export const villages = [
  {
    id: '1101010001',
    districtId: '1101010',
    name: 'Latiung',
  },
  {
    id: '1101010002',
    districtId: '1101010',
    name: 'Labuhan Bajau',
  },
  {
    id: '1101010003',
    districtId: '1101010',
    name: 'Suak Lamatan',
  },
  {
    id: '1101010004',
    districtId: '1101010',
    name: 'Ana Ao',
  },
  {
    id: '1101010005',
    districtId: '1101010',
    name: 'Lataling',
  },
  {
    id: '1101010006',
    districtId: '1101010',
    name: 'Pulau Bengkalak',
  },
  {
    id: '1101010007',
    districtId: '1101010',
    name: 'Badegong',
  },
  {
    id: '1101010008',
    districtId: '1101010',
    name: 'Kebun Baru',
  },
  {
    id: '1101010009',
    districtId: '1101010',
    name: 'Ulul Mayang',
  },
  {
    id: '1101010010',
    districtId: '1101010',
    name: 'Pasir Tinggi',
  },
  {
    id: '1101010011',
    districtId: '1101010',
    name: 'Labuhan Jaya',
  },
  {
    id: '1101010012',
    districtId: '1101010',
    name: 'Labuhan Bakti',
  },
  {
    id: '1101010013',
    districtId: '1101010',
    name: 'Batu Ralang',
  },
  {
    id: '1101010014',
    districtId: '1101010',
    name: 'Alus Alus',
  },
  {
    id: '1101010015',
    districtId: '1101010',
    name: 'Seuneubok',
  },
  {
    id: '1101010016',
    districtId: '1101010',
    name: 'Blang Sebel',
  },
  {
    id: '1101010017',
    districtId: '1101010',
    name: 'Trans Baru',
  },
  {
    id: '1101010018',
    districtId: '1101010',
    name: 'Trans Meranti',
  },
  {
    id: '1101010019',
    districtId: '1101010',
    name: 'Trans Jernge',
  },
  {
    id: '1101020022',
    districtId: '1101020',
    name: 'Air Pinang',
  },
  {
    id: '1101020023',
    districtId: '1101020',
    name: 'Kuala Makmur',
  },
  {
    id: '1101020024',
    districtId: '1101020',
    name: 'Ganting',
  },
  {
    id: '1101020025',
    districtId: '1101020',
    name: 'Linggi',
  },
  {
    id: '1101020026',
    districtId: '1101020',
    name: 'Lugu',
  },
  {
    id: '1101020027',
    districtId: '1101020',
    name: 'Sinabang',
  },
  {
    id: '1101020028',
    districtId: '1101020',
    name: 'Suka Maju',
  },
  {
    id: '1101020029',
    districtId: '1101020',
    name: 'Suka Karya',
  },
  {
    id: '1101020030',
    districtId: '1101020',
    name: 'Suka Jaya',
  },
  {
    id: '1101020031',
    districtId: '1101020',
    name: 'Air Dingin',
  },
  {
    id: '1101020032',
    districtId: '1101020',
    name: 'Kota Batu',
  },
  {
    id: '1101020035',
    districtId: '1101020',
    name: 'Suak Buluh',
  },
  {
    id: '1101020036',
    districtId: '1101020',
    name: 'Ujung Tinggi',
  },
  {
    id: '1101020037',
    districtId: '1101020',
    name: 'Pulau Siumat',
  },
  {
    id: '1101020038',
    districtId: '1101020',
    name: 'Sefoyan',
  },
  {
    id: '1101020039',
    districtId: '1101020',
    name: 'Amaiteng Mulia',
  },
  {
    id: '1101020040',
    districtId: '1101020',
    name: 'Ameria Bahagia',
  },
  {
    id: '1101021001',
    districtId: '1101021',
    name: 'Sital',
  },
  {
    id: '1101021002',
    districtId: '1101021',
    name: 'Leubang',
  },
  {
    id: '1101021003',
    districtId: '1101021',
    name: 'Leubang Hulu',
  },
  {
    id: '1101021004',
    districtId: '1101021',
    name: 'Awe Seubal',
  },
  {
    id: '1101021005',
    districtId: '1101021',
    name: 'Lantik',
  },
  {
    id: '1101021006',
    districtId: '1101021',
    name: 'Awe Kecil',
  },
  {
    id: '1101021007',
    districtId: '1101021',
    name: 'Salur',
  },
  {
    id: '1101021008',
    districtId: '1101021',
    name: 'Salur Latun',
  },
  {
    id: '1101021009',
    districtId: '1101021',
    name: 'Salur Lasengalu',
  },
  {
    id: '1101021010',
    districtId: '1101021',
    name: 'Nancala',
  },
  {
    id: '1101021011',
    districtId: '1101021',
    name: 'Maudil',
  },
  {
    id: '1101021012',
    districtId: '1101021',
    name: 'Inor',
  },
  {
    id: '1101021013',
    districtId: '1101021',
    name: 'Naibos',
  },
  {
    id: '1101021014',
    districtId: '1101021',
    name: 'Laayon',
  },
  {
    id: '1101021015',
    districtId: '1101021',
    name: 'Angkeo',
  },
  {
    id: '1101021016',
    districtId: '1101021',
    name: 'Bunon',
  },
  {
    id: '1101021017',
    districtId: '1101021',
    name: 'Silengas',
  },
  {
    id: '1101021018',
    districtId: '1101021',
    name: 'Pulau Teupah',
  },
  {
    id: '1101022001',
    districtId: '1101022',
    name: 'Kahat',
  },
  {
    id: '1101022002',
    districtId: '1101022',
    name: 'Busung Indah',
  },
  {
    id: '1101022003',
    districtId: '1101022',
    name: 'Nancawa',
  },
  {
    id: '1101022004',
    districtId: '1101022',
    name: 'Labuah',
  },
  {
    id: '1101022005',
    districtId: '1101022',
    name: 'Abail',
  },
  {
    id: '1101022006',
    districtId: '1101022',
    name: 'Simpang Abail',
  },
  {
    id: '1101022007',
    districtId: '1101022',
    name: 'Lanting',
  },
  {
    id: '1101022008',
    districtId: '1101022',
    name: 'Lasikin',
  },
  {
    id: '1101022009',
    districtId: '1101022',
    name: 'Matanurung',
  },
  {
    id: '1101022010',
    districtId: '1101022',
    name: 'Sua Sua',
  },
  {
    id: '1101022011',
    districtId: '1101022',
    name: 'Batu Batu',
  },
  {
    id: '1101022012',
    districtId: '1101022',
    name: 'Situbuk',
  },
  {
    id: '1101030001',
    districtId: '1101030',
    name: 'Dihit',
  },
  {
    id: '1101030002',
    districtId: '1101030',
    name: 'Lauke',
  },
  {
    id: '1101030003',
    districtId: '1101030',
    name: 'Lambaya',
  },
  {
    id: '1101030004',
    districtId: '1101030',
    name: 'Lakubang',
  },
  {
    id: '1101030005',
    districtId: '1101030',
    name: 'Kampung Aie',
  },
  {
    id: '1101030006',
    districtId: '1101030',
    name: 'Lauree',
  },
  {
    id: '1101030007',
    districtId: '1101030',
    name: 'Latitik',
  },
  {
    id: '1101030008',
    districtId: '1101030',
    name: 'Lamayang',
  },
  {
    id: '1101030009',
    districtId: '1101030',
    name: 'Wel Wel',
  },
  {
    id: '1101030020',
    districtId: '1101030',
    name: 'Situfa Jaya',
  },
  {
    id: '1101030021',
    districtId: '1101030',
    name: 'Putra Jaya',
  },
  {
    id: '1101030022',
    districtId: '1101030',
    name: 'Luan Sorip',
  },
  {
    id: '1101030023',
    districtId: '1101030',
    name: 'Suak Baru',
  },
  {
    id: '1101030024',
    districtId: '1101030',
    name: 'Sebbe',
  },
  {
    id: '1101030025',
    districtId: '1101030',
    name: 'Kuta Baru',
  },
  {
    id: '1101030026',
    districtId: '1101030',
    name: 'Wel Langkom',
  },
  {
    id: '1101031001',
    districtId: '1101031',
    name: 'Kuala Bakti',
  },
  {
    id: '1101031002',
    districtId: '1101031',
    name: 'Lugu Sebahak',
  },
  {
    id: '1101031003',
    districtId: '1101031',
    name: 'Gunung Putih',
  },
  {
    id: '1101031004',
    districtId: '1101031',
    name: 'Babussalam',
  },
  {
    id: '1101031005',
    districtId: '1101031',
    name: 'Muara Aman',
  },
  {
    id: '1101031006',
    districtId: '1101031',
    name: 'Luan Balu',
  },
  {
    id: '1101031007',
    districtId: '1101031',
    name: 'Sambai',
  },
  {
    id: '1101031008',
    districtId: '1101031',
    name: 'Kuala Baru',
  },
  {
    id: '1101031009',
    districtId: '1101031',
    name: 'Tanjung Raya',
  },
  {
    id: '1101031010',
    districtId: '1101031',
    name: 'Bulu Hadik',
  },
  {
    id: '1101032001',
    districtId: '1101032',
    name: 'Bubuhan',
  },
  {
    id: '1101032002',
    districtId: '1101032',
    name: 'Amarabu',
  },
  {
    id: '1101032003',
    districtId: '1101032',
    name: 'Kuta Inang',
  },
  {
    id: '1101032004',
    districtId: '1101032',
    name: 'Kuta Padang',
  },
  {
    id: '1101032005',
    districtId: '1101032',
    name: 'Latak Ayah',
  },
  {
    id: '1101032006',
    districtId: '1101032',
    name: 'Sibuluh',
  },
  {
    id: '1101032007',
    districtId: '1101032',
    name: 'Borengan',
  },
  {
    id: '1101032008',
    districtId: '1101032',
    name: 'Ujung Padang',
  },
  {
    id: '1101040001',
    districtId: '1101040',
    name: 'Ujung Salang',
  },
  {
    id: '1101040002',
    districtId: '1101040',
    name: 'Padang Unoi',
  },
  {
    id: '1101040003',
    districtId: '1101040',
    name: 'Meunafa',
  },
  {
    id: '1101040004',
    districtId: '1101040',
    name: 'Nasreuhe',
  },
  {
    id: '1101040005',
    districtId: '1101040',
    name: 'Along',
  },
  {
    id: '1101040006',
    districtId: '1101040',
    name: 'Panton Lawe',
  },
  {
    id: '1101040007',
    districtId: '1101040',
    name: 'Mutiara',
  },
  {
    id: '1101040008',
    districtId: '1101040',
    name: 'Karya Bakti',
  },
  {
    id: '1101040009',
    districtId: '1101040',
    name: 'Tamon Jaya',
  },
  {
    id: '1101040010',
    districtId: '1101040',
    name: 'Jaya Baru',
  },
  {
    id: '1101040011',
    districtId: '1101040',
    name: 'Tameng',
  },
  {
    id: '1101040012',
    districtId: '1101040',
    name: 'Lalla Bahagia',
  },
  {
    id: '1101040013',
    districtId: '1101040',
    name: 'Suak Manang',
  },
  {
    id: '1101040014',
    districtId: '1101040',
    name: 'Bunga',
  },
  {
    id: '1101040015',
    districtId: '1101040',
    name: 'Ganang Pusako',
  },
  {
    id: '1101040016',
    districtId: '1101040',
    name: 'Kenangan Jaya',
  },
  {
    id: '1101050007',
    districtId: '1101050',
    name: 'Sanggiran',
  },
  {
    id: '1101050008',
    districtId: '1101050',
    name: 'Amabaan',
  },
  {
    id: '1101050009',
    districtId: '1101050',
    name: 'Miteum',
  },
  {
    id: '1101050010',
    districtId: '1101050',
    name: 'Malasin',
  },
  {
    id: '1101050011',
    districtId: '1101050',
    name: 'Lamamek',
  },
  {
    id: '1101050012',
    districtId: '1101050',
    name: 'Sigulai',
  },
  {
    id: '1101050013',
    districtId: '1101050',
    name: 'Sembilan',
  },
  {
    id: '1101050014',
    districtId: '1101050',
    name: 'Layabaung',
  },
  {
    id: '1101050015',
    districtId: '1101050',
    name: 'Lhok Makmur',
  },
  {
    id: '1101050016',
    districtId: '1101050',
    name: 'Ujung Harapan',
  },
  {
    id: '1101050017',
    districtId: '1101050',
    name: 'Lhok Bikhao',
  },
  {
    id: '1101050018',
    districtId: '1101050',
    name: 'Babul Makmur',
  },
  {
    id: '1101050019',
    districtId: '1101050',
    name: 'Batu Ragi',
  },
  {
    id: '1101050020',
    districtId: '1101050',
    name: 'Sinar Bahagia',
  },
  {
    id: '1101051001',
    districtId: '1101051',
    name: 'Lafakha',
  },
  {
    id: '1101051002',
    districtId: '1101051',
    name: 'Lhok Dalam',
  },
  {
    id: '1101051003',
    districtId: '1101051',
    name: 'Lubuk Baik',
  },
  {
    id: '1101051004',
    districtId: '1101051',
    name: 'Langi',
  },
  {
    id: '1101051005',
    districtId: '1101051',
    name: 'Serafon',
  },
  {
    id: '1101051006',
    districtId: '1101051',
    name: 'Lhok Pauh',
  },
  {
    id: '1101051007',
    districtId: '1101051',
    name: 'Lamerem',
  },
  {
    id: '1101051008',
    districtId: '1101051',
    name: 'Lewak',
  },
  {
    id: '1102010003',
    districtId: '1102010',
    name: 'Pulau Baguk',
  },
  {
    id: '1102010004',
    districtId: '1102010',
    name: 'Pulau Balai',
  },
  {
    id: '1102010005',
    districtId: '1102010',
    name: 'Teluk Nibung',
  },
  {
    id: '1102011001',
    districtId: '1102011',
    name: 'Asantola',
  },
  {
    id: '1102011002',
    districtId: '1102011',
    name: 'Ujung Sialit',
  },
  {
    id: '1102011003',
    districtId: '1102011',
    name: 'Haloban',
  },
  {
    id: '1102011004',
    districtId: '1102011',
    name: 'Suka Makmur',
  },
  {
    id: '1102020003',
    districtId: '1102020',
    name: 'Pulo Sarok',
  },
  {
    id: '1102020004',
    districtId: '1102020',
    name: 'Pasar Singkil',
  },
  {
    id: '1102020005',
    districtId: '1102020',
    name: 'Ujung',
  },
  {
    id: '1102020006',
    districtId: '1102020',
    name: 'Kota Simboling',
  },
  {
    id: '1102020007',
    districtId: '1102020',
    name: 'Kilangan',
  },
  {
    id: '1102020009',
    districtId: '1102020',
    name: 'Teluk Ambun',
  },
  {
    id: '1102020010',
    districtId: '1102020',
    name: 'Rantau Gedang',
  },
  {
    id: '1102020011',
    districtId: '1102020',
    name: 'Teluk Rumbia',
  },
  {
    id: '1102020012',
    districtId: '1102020',
    name: 'Takal Pasir',
  },
  {
    id: '1102020013',
    districtId: '1102020',
    name: 'Selok Aceh',
  },
  {
    id: '1102020014',
    districtId: '1102020',
    name: 'Pea Bumbung',
  },
  {
    id: '1102020015',
    districtId: '1102020',
    name: 'Pemuka',
  },
  {
    id: '1102020019',
    districtId: '1102020',
    name: 'Suka Damai',
  },
  {
    id: '1102020020',
    districtId: '1102020',
    name: 'Ujung Bawang',
  },
  {
    id: '1102020021',
    districtId: '1102020',
    name: 'Siti Ambia',
  },
  {
    id: '1102020022',
    districtId: '1102020',
    name: 'Suka Makmur',
  },
  {
    id: '1102021001',
    districtId: '1102021',
    name: 'Gosong Telaga Utara',
  },
  {
    id: '1102021002',
    districtId: '1102021',
    name: 'Gosong Telaga Selatan',
  },
  {
    id: '1102021003',
    districtId: '1102021',
    name: 'Gosong Telaga Timur',
  },
  {
    id: '1102021004',
    districtId: '1102021',
    name: 'Telaga Bakti',
  },
  {
    id: '1102021005',
    districtId: '1102021',
    name: 'Kampung Baru',
  },
  {
    id: '1102021006',
    districtId: '1102021',
    name: 'Ketapang Indah',
  },
  {
    id: '1102021007',
    districtId: '1102021',
    name: 'Gosong Telaga Barat',
  },
  {
    id: '1102022001',
    districtId: '1102022',
    name: 'Kayu Menang',
  },
  {
    id: '1102022002',
    districtId: '1102022',
    name: 'Kuala Baru Sungai',
  },
  {
    id: '1102022003',
    districtId: '1102022',
    name: 'Kuala Baru Laut',
  },
  {
    id: '1102022004',
    districtId: '1102022',
    name: 'Suka Jaya',
  },
  {
    id: '1102030017',
    districtId: '1102030',
    name: 'Pangi',
  },
  {
    id: '1102030026',
    districtId: '1102030',
    name: 'Tugan',
  },
  {
    id: '1102030027',
    districtId: '1102030',
    name: 'Cibubukan',
  },
  {
    id: '1102030028',
    districtId: '1102030',
    name: 'Kain Golong',
  },
  {
    id: '1102030029',
    districtId: '1102030',
    name: 'Sukarejo',
  },
  {
    id: '1102030030',
    districtId: '1102030',
    name: 'Tuh Tuhan',
  },
  {
    id: '1102030031',
    districtId: '1102030',
    name: 'Lae Gecih',
  },
  {
    id: '1102030032',
    districtId: '1102030',
    name: 'Siatas',
  },
  {
    id: '1102030033',
    districtId: '1102030',
    name: 'Kuta Kerangan',
  },
  {
    id: '1102030034',
    districtId: '1102030',
    name: 'Lipat Kajang',
  },
  {
    id: '1102030035',
    districtId: '1102030',
    name: 'Tanjung Mas',
  },
  {
    id: '1102030036',
    districtId: '1102030',
    name: 'Serasah',
  },
  {
    id: '1102030038',
    districtId: '1102030',
    name: 'Ujung Limus',
  },
  {
    id: '1102030039',
    districtId: '1102030',
    name: 'Silatong',
  },
  {
    id: '1102030040',
    districtId: '1102030',
    name: 'Lae Riman',
  },
  {
    id: '1102030041',
    districtId: '1102030',
    name: 'Pertabas',
  },
  {
    id: '1102030042',
    districtId: '1102030',
    name: 'Kuta Tinggi',
  },
  {
    id: '1102030043',
    districtId: '1102030',
    name: 'Lae Nipe',
  },
  {
    id: '1102030044',
    districtId: '1102030',
    name: 'Pakiraman',
  },
  {
    id: '1102030048',
    districtId: '1102030',
    name: 'Lae Gambir',
  },
  {
    id: '1102030049',
    districtId: '1102030',
    name: 'Kuta Batu',
  },
  {
    id: '1102030050',
    districtId: '1102030',
    name: 'Guha',
  },
  {
    id: '1102030051',
    districtId: '1102030',
    name: 'Lipat Kajang Atas',
  },
  {
    id: '1102030052',
    districtId: '1102030',
    name: 'Sidodadi',
  },
  {
    id: '1102030053',
    districtId: '1102030',
    name: 'Pandan Sari',
  },
  {
    id: '1102031001',
    districtId: '1102031',
    name: 'Pertampakan',
  },
  {
    id: '1102031002',
    districtId: '1102031',
    name: 'Tanah Merah',
  },
  {
    id: '1102031003',
    districtId: '1102031',
    name: 'Sebatang',
  },
  {
    id: '1102031004',
    districtId: '1102031',
    name: 'Seping Baru',
  },
  {
    id: '1102031005',
    districtId: '1102031',
    name: 'Perangusan',
  },
  {
    id: '1102031006',
    districtId: '1102031',
    name: 'Gunung Lagan',
  },
  {
    id: '1102031007',
    districtId: '1102031',
    name: 'Tanah Bara',
  },
  {
    id: '1102031008',
    districtId: '1102031',
    name: 'Suka Makmur',
  },
  {
    id: '1102031009',
    districtId: '1102031',
    name: 'Sidorejo',
  },
  {
    id: '1102031010',
    districtId: '1102031',
    name: 'Pandan Sari',
  },
  {
    id: '1102031011',
    districtId: '1102031',
    name: 'Blok 31',
  },
  {
    id: '1102031012',
    districtId: '1102031',
    name: 'Blok 18',
  },
  {
    id: '1102031013',
    districtId: '1102031',
    name: 'Sanggaberu Silulusan',
  },
  {
    id: '1102031014',
    districtId: '1102031',
    name: 'Blok 15',
  },
  {
    id: '1102031015',
    districtId: '1102031',
    name: 'Tulaan',
  },
  {
    id: '1102031016',
    districtId: '1102031',
    name: 'Blok VI Baru',
  },
  {
    id: '1102031017',
    districtId: '1102031',
    name: 'Tunas Harapan',
  },
  {
    id: '1102031018',
    districtId: '1102031',
    name: 'Lae Butar',
  },
  {
    id: '1102031019',
    districtId: '1102031',
    name: 'Rimo',
  },
  {
    id: '1102031020',
    districtId: '1102031',
    name: 'Sianjo Anjo Meriah',
  },
  {
    id: '1102031021',
    districtId: '1102031',
    name: 'Cingkam',
  },
  {
    id: '1102031022',
    districtId: '1102031',
    name: 'Bukit Harapan',
  },
  {
    id: '1102031023',
    districtId: '1102031',
    name: 'Penjahitan',
  },
  {
    id: '1102031024',
    districtId: '1102031',
    name: 'Tanjung Betik',
  },
  {
    id: '1102031025',
    districtId: '1102031',
    name: 'Labuhan Kera',
  },
  {
    id: '1102032001',
    districtId: '1102032',
    name: 'Situban Makmur',
  },
  {
    id: '1102032002',
    districtId: '1102032',
    name: 'Lae Balno',
  },
  {
    id: '1102032003',
    districtId: '1102032',
    name: 'Sikoran',
  },
  {
    id: '1102032004',
    districtId: '1102032',
    name: 'Napa Galuh',
  },
  {
    id: '1102032005',
    districtId: '1102032',
    name: 'Biskang',
  },
  {
    id: '1102032006',
    districtId: '1102032',
    name: 'Situbuh-Tubuh',
  },
  {
    id: '1102033001',
    districtId: '1102033',
    name: 'Mandumpang',
  },
  {
    id: '1102033002',
    districtId: '1102033',
    name: 'Alur Linci',
  },
  {
    id: '1102033003',
    districtId: '1102033',
    name: 'Sirimo Mungkur',
  },
  {
    id: '1102033004',
    districtId: '1102033',
    name: 'Keras',
  },
  {
    id: '1102033005',
    districtId: '1102033',
    name: 'Ketangkuhan',
  },
  {
    id: '1102033006',
    districtId: '1102033',
    name: 'Siompin',
  },
  {
    id: '1102033007',
    districtId: '1102033',
    name: 'Bulu Ara',
  },
  {
    id: '1102033008',
    districtId: '1102033',
    name: 'Lae Bangun',
  },
  {
    id: '1102033009',
    districtId: '1102033',
    name: 'Bulu Sema',
  },
  {
    id: '1102033010',
    districtId: '1102033',
    name: 'Pangkalan Sulampi',
  },
  {
    id: '1102033011',
    districtId: '1102033',
    name: 'Suro Baru',
  },
  {
    id: '1102042001',
    districtId: '1102042',
    name: 'Sri Kayu',
  },
  {
    id: '1102042002',
    districtId: '1102042',
    name: 'Pea Jambu',
  },
  {
    id: '1102042003',
    districtId: '1102042',
    name: 'Lae Pinang',
  },
  {
    id: '1102042004',
    districtId: '1102042',
    name: 'Singkohor',
  },
  {
    id: '1102042006',
    districtId: '1102042',
    name: 'Mukti Jaya',
  },
  {
    id: '1102042007',
    districtId: '1102042',
    name: 'Lae Sipola',
  },
  {
    id: '1102043001',
    districtId: '1102043',
    name: 'Muara Pea',
  },
  {
    id: '1102043002',
    districtId: '1102043',
    name: 'Sumber Mukti',
  },
  {
    id: '1102043003',
    districtId: '1102043',
    name: 'Ladang Bisik',
  },
  {
    id: '1102043004',
    districtId: '1102043',
    name: 'Samar Dua',
  },
  {
    id: '1102043005',
    districtId: '1102043',
    name: 'Butar',
  },
  {
    id: '1102043006',
    districtId: '1102043',
    name: 'Mukti Lincir',
  },
  {
    id: '1102043007',
    districtId: '1102043',
    name: 'Lapahan Buaya',
  },
  {
    id: '1102043008',
    districtId: '1102043',
    name: 'Lentong',
  },
  {
    id: '1102043009',
    districtId: '1102043',
    name: 'Danau Bungara',
  },
  {
    id: '1103010001',
    districtId: '1103010',
    name: 'Kuta Padang',
  },
  {
    id: '1103010002',
    districtId: '1103010',
    name: 'Raket',
  },
  {
    id: '1103010003',
    districtId: '1103010',
    name: 'Gampong Tengah',
  },
  {
    id: '1103010004',
    districtId: '1103010',
    name: 'Tepin Tinggi',
  },
  {
    id: '1103010005',
    districtId: '1103010',
    name: 'Ie Meudama',
  },
  {
    id: '1103010009',
    districtId: '1103010',
    name: 'Ujong Tan0h',
  },
  {
    id: '1103010010',
    districtId: '1103010',
    name: 'Keude Trumon',
  },
  {
    id: '1103010011',
    districtId: '1103010',
    name: 'Kuta Baru',
  },
  {
    id: '1103010012',
    districtId: '1103010',
    name: 'Singleng',
  },
  {
    id: '1103010013',
    districtId: '1103010',
    name: 'Panton Bili',
  },
  {
    id: '1103010027',
    districtId: '1103010',
    name: 'UPT II Pd Harapan',
  },
  {
    id: '1103010030',
    districtId: '1103010',
    name: 'Seunabok Jaya (Ex UPT V)',
  },
  {
    id: '1103011001',
    districtId: '1103011',
    name: 'Titi Poben',
  },
  {
    id: '1103011002',
    districtId: '1103011',
    name: 'Alur Bujok',
  },
  {
    id: '1103011003',
    districtId: '1103011',
    name: 'Seuneubok Puntho',
  },
  {
    id: '1103011008',
    districtId: '1103011',
    name: 'Pinto Rimba',
  },
  {
    id: '1103011009',
    districtId: '1103011',
    name: 'Krung Luas',
  },
  {
    id: '1103011010',
    districtId: '1103011',
    name: 'Jambo Dalem',
  },
  {
    id: '1103011011',
    districtId: '1103011',
    name: 'Kapai Seusak',
  },
  {
    id: '1103011012',
    districtId: '1103011',
    name: 'UPT I Snb Pusaka',
  },
  {
    id: '1103012001',
    districtId: '1103012',
    name: 'Lhok Raya',
  },
  {
    id: '1103012002',
    districtId: '1103012',
    name: 'Ie Jeureuneh',
  },
  {
    id: '1103012003',
    districtId: '1103012',
    name: 'Naca',
  },
  {
    id: '1103012004',
    districtId: '1103012',
    name: 'Cot Bayu',
  },
  {
    id: '1103012005',
    districtId: '1103012',
    name: 'Jambo Papeun',
  },
  {
    id: '1103012006',
    districtId: '1103012',
    name: 'Ladang Rimba',
  },
  {
    id: '1103012007',
    districtId: '1103012',
    name: 'Pulo Paya',
  },
  {
    id: '1103012008',
    districtId: '1103012',
    name: 'Krueng Batee',
  },
  {
    id: '1103012009',
    districtId: '1103012',
    name: 'Kampong Teungoh',
  },
  {
    id: '1103012010',
    districtId: '1103012',
    name: 'Gunong Kapho',
  },
  {
    id: '1103020001',
    districtId: '1103020',
    name: 'Ujung Mangki',
  },
  {
    id: '1103020002',
    districtId: '1103020',
    name: 'Keude Bakongan',
  },
  {
    id: '1103020003',
    districtId: '1103020',
    name: 'Kampung Baru',
  },
  {
    id: '1103020014',
    districtId: '1103020',
    name: 'Ujung Padang',
  },
  {
    id: '1103020015',
    districtId: '1103020',
    name: 'Kmp Drien',
  },
  {
    id: '1103020023',
    districtId: '1103020',
    name: 'Dahrul Ihsan',
  },
  {
    id: '1103020024',
    districtId: '1103020',
    name: 'Padang Beurahan',
  },
  {
    id: '1103021002',
    districtId: '1103021',
    name: 'Ujung Pulo Cut',
  },
  {
    id: '1103021003',
    districtId: '1103021',
    name: 'Ujung Pulo Rayeuk',
  },
  {
    id: '1103021004',
    districtId: '1103021',
    name: 'Pasi Seubadeh',
  },
  {
    id: '1103021005',
    districtId: '1103021',
    name: 'Ladang Rimba',
  },
  {
    id: '1103021006',
    districtId: '1103021',
    name: 'Simpang',
  },
  {
    id: '1103021007',
    districtId: '1103021',
    name: 'Sawah Tingkeum',
  },
  {
    id: '1103021008',
    districtId: '1103021',
    name: 'Seuleukat',
  },
  {
    id: '1103022001',
    districtId: '1103022',
    name: 'Seneubok Alur Bulah',
  },
  {
    id: '1103022002',
    districtId: '1103022',
    name: 'Alurduamas',
  },
  {
    id: '1103022003',
    districtId: '1103022',
    name: 'Jambo Keupok',
  },
  {
    id: '1103022004',
    districtId: '1103022',
    name: 'Ujung Tanoh',
  },
  {
    id: '1103022005',
    districtId: '1103022',
    name: 'Beutong',
  },
  {
    id: '1103022006',
    districtId: '1103022',
    name: 'Ujung Gunong Rayek',
  },
  {
    id: '1103022007',
    districtId: '1103022',
    name: 'Ujung Gunung Cut',
  },
  {
    id: '1103022008',
    districtId: '1103022',
    name: 'Rambong',
  },
  {
    id: '1103022009',
    districtId: '1103022',
    name: 'Seuneubok Keuranji',
  },
  {
    id: '1103022010',
    districtId: '1103022',
    name: 'Bukit Gading',
  },
  {
    id: '1103030001',
    districtId: '1103030',
    name: 'Pasi Lembang',
  },
  {
    id: '1103030002',
    districtId: '1103030',
    name: 'Ujung Padang',
  },
  {
    id: '1103030003',
    districtId: '1103030',
    name: 'Indra Damai',
  },
  {
    id: '1103030004',
    districtId: '1103030',
    name: 'Suaq Bakong',
  },
  {
    id: '1103030005',
    districtId: '1103030',
    name: 'Barat Daya',
  },
  {
    id: '1103030006',
    districtId: '1103030',
    name: 'Sialang',
  },
  {
    id: '1103030007',
    districtId: '1103030',
    name: 'Kapeh',
  },
  {
    id: '1103030008',
    districtId: '1103030',
    name: 'Pulo Ie',
  },
  {
    id: '1103030009',
    districtId: '1103030',
    name: 'Jua',
  },
  {
    id: '1103030010',
    districtId: '1103030',
    name: 'Pasi Merapat',
  },
  {
    id: '1103030011',
    districtId: '1103030',
    name: 'Ujung',
  },
  {
    id: '1103030012',
    districtId: '1103030',
    name: 'Luar',
  },
  {
    id: '1103030013',
    districtId: '1103030',
    name: 'Kedai Kandang',
  },
  {
    id: '1103030014',
    districtId: '1103030',
    name: 'Rantau Binuang',
  },
  {
    id: '1103030015',
    districtId: '1103030',
    name: 'Ujung Pasir',
  },
  {
    id: '1103030016',
    districtId: '1103030',
    name: 'Gelumbuk',
  },
  {
    id: '1103030017',
    districtId: '1103030',
    name: 'Kedai Runding',
  },
  {
    id: '1103031001',
    districtId: '1103031',
    name: 'Sapik',
  },
  {
    id: '1103031002',
    districtId: '1103031',
    name: 'Durian Kawan',
  },
  {
    id: '1103031003',
    districtId: '1103031',
    name: 'Alai',
  },
  {
    id: '1103031004',
    districtId: '1103031',
    name: 'Paya Dapur',
  },
  {
    id: '1103031005',
    districtId: '1103031',
    name: 'Pucuk Lembang',
  },
  {
    id: '1103031006',
    districtId: '1103031',
    name: 'Lawe Buluh Didi',
  },
  {
    id: '1103031007',
    districtId: '1103031',
    name: 'Lawe Sawah',
  },
  {
    id: '1103031008',
    districtId: '1103031',
    name: 'Paya Laba',
  },
  {
    id: '1103031009',
    districtId: '1103031',
    name: 'Lawe Cimanok',
  },
  {
    id: '1103040001',
    districtId: '1103040',
    name: 'Kedai Padang',
  },
  {
    id: '1103040002',
    districtId: '1103040',
    name: 'Pasi Kuala Bau',
  },
  {
    id: '1103040003',
    districtId: '1103040',
    name: 'Suaq Geringgeng',
  },
  {
    id: '1103040004',
    districtId: '1103040',
    name: 'Simpang Lhee',
  },
  {
    id: '1103040005',
    districtId: '1103040',
    name: 'Simpang Empat',
  },
  {
    id: '1103040006',
    districtId: '1103040',
    name: 'Jambo Manyang',
  },
  {
    id: '1103040007',
    districtId: '1103040',
    name: 'Limau Purut',
  },
  {
    id: '1103040008',
    districtId: '1103040',
    name: 'Pulo Kambing',
  },
  {
    id: '1103040009',
    districtId: '1103040',
    name: 'Kampung Paya',
  },
  {
    id: '1103040010',
    districtId: '1103040',
    name: 'Krueng Batu',
  },
  {
    id: '1103040011',
    districtId: '1103040',
    name: 'Gunong Pulo',
  },
  {
    id: '1103040012',
    districtId: '1103040',
    name: 'Pulo Ie I',
  },
  {
    id: '1103040013',
    districtId: '1103040',
    name: 'Krueng Batee',
  },
  {
    id: '1103040014',
    districtId: '1103040',
    name: 'Pasi Kuala Asahan',
  },
  {
    id: '1103040015',
    districtId: '1103040',
    name: 'Fajar Harapan',
  },
  {
    id: '1103040036',
    districtId: '1103040',
    name: 'Krueng Kluet',
  },
  {
    id: '1103040039',
    districtId: '1103040',
    name: 'Alur Mas',
  },
  {
    id: '1103040050',
    districtId: '1103040',
    name: 'Kampung Tinggi',
  },
  {
    id: '1103040051',
    districtId: '1103040',
    name: 'Kampung Ruak',
  },
  {
    id: '1103040052',
    districtId: '1103040',
    name: 'Kota Fajar',
  },
  {
    id: '1103040053',
    districtId: '1103040',
    name: 'Gunung Pudung',
  },
  {
    id: '1103041001',
    districtId: '1103041',
    name: 'Ujung Padang Asahan',
  },
  {
    id: '1103041002',
    districtId: '1103041',
    name: 'Pulo Ie II',
  },
  {
    id: '1103041003',
    districtId: '1103041',
    name: 'Ie Mirah',
  },
  {
    id: '1103041004',
    districtId: '1103041',
    name: 'Ujung Padang Rasian',
  },
  {
    id: '1103041005',
    districtId: '1103041',
    name: 'Pasi Rasian',
  },
  {
    id: '1103041006',
    districtId: '1103041',
    name: 'Teupin Gajah',
  },
  {
    id: '1103041007',
    districtId: '1103041',
    name: 'Kampung Baro',
  },
  {
    id: '1103041008',
    districtId: '1103041',
    name: 'Krueng Kelee',
  },
  {
    id: '1103041009',
    districtId: '1103041',
    name: 'Lhok Sialang Rayeuk',
  },
  {
    id: '1103041010',
    districtId: '1103041',
    name: 'Lhok Sialang Cut',
  },
  {
    id: '1103041011',
    districtId: '1103041',
    name: 'Payateuk',
  },
  {
    id: '1103041012',
    districtId: '1103041',
    name: 'Silolo',
  },
  {
    id: '1103041013',
    districtId: '1103041',
    name: 'Kampung Baru',
  },
  {
    id: '1103041014',
    districtId: '1103041',
    name: 'Si Neubok',
  },
  {
    id: '1103041015',
    districtId: '1103041',
    name: 'Ladang Tuha',
  },
  {
    id: '1103041016',
    districtId: '1103041',
    name: 'Panton Bili',
  },
  {
    id: '1103041017',
    districtId: '1103041',
    name: 'Ladang Teungoh',
  },
  {
    id: '1103041018',
    districtId: '1103041',
    name: 'Pucuk Krueng',
  },
  {
    id: '1103041019',
    districtId: '1103041',
    name: 'Mata Ie',
  },
  {
    id: '1103041020',
    districtId: '1103041',
    name: 'Ujung Batu',
  },
  {
    id: '1103041021',
    districtId: '1103041',
    name: 'Pante Raja',
  },
  {
    id: '1103042001',
    districtId: '1103042',
    name: 'Jambo Papan',
  },
  {
    id: '1103042002',
    districtId: '1103042',
    name: 'Koto Indarung',
  },
  {
    id: '1103042003',
    districtId: '1103042',
    name: 'Siurai Urai',
  },
  {
    id: '1103042004',
    districtId: '1103042',
    name: 'Malaka',
  },
  {
    id: '1103042005',
    districtId: '1103042',
    name: 'Lawe Melang',
  },
  {
    id: '1103042006',
    districtId: '1103042',
    name: 'Koto',
  },
  {
    id: '1103042007',
    districtId: '1103042',
    name: 'Kampung Sawah',
  },
  {
    id: '1103042008',
    districtId: '1103042',
    name: 'Kampung Padang',
  },
  {
    id: '1103042009',
    districtId: '1103042',
    name: 'Pulo Air',
  },
  {
    id: '1103042010',
    districtId: '1103042',
    name: 'Mersak',
  },
  {
    id: '1103042011',
    districtId: '1103042',
    name: 'Simpang Dua',
  },
  {
    id: '1103042012',
    districtId: '1103042',
    name: 'Simpang Tiga',
  },
  {
    id: '1103042013',
    districtId: '1103042',
    name: 'Alur Kejrun',
  },
  {
    id: '1103050001',
    districtId: '1103050',
    name: 'Gunung Kerambil',
  },
  {
    id: '1103050002',
    districtId: '1103050',
    name: 'Air Berudang',
  },
  {
    id: '1103050003',
    districtId: '1103050',
    name: 'Lhok Ketapang',
  },
  {
    id: '1103050004',
    districtId: '1103050',
    name: 'Hilir',
  },
  {
    id: '1103050005',
    districtId: '1103050',
    name: 'Pasar',
  },
  {
    id: '1103050006',
    districtId: '1103050',
    name: 'Padang',
  },
  {
    id: '1103050007',
    districtId: '1103050',
    name: 'Tepi Air',
  },
  {
    id: '1103050008',
    districtId: '1103050',
    name: 'Hulu',
  },
  {
    id: '1103050009',
    districtId: '1103050',
    name: 'Jambo Apha',
  },
  {
    id: '1103050010',
    districtId: '1103050',
    name: 'Lhok Bengkuang',
  },
  {
    id: '1103050011',
    districtId: '1103050',
    name: 'Batu Itam',
  },
  {
    id: '1103050012',
    districtId: '1103050',
    name: 'Panjupian',
  },
  {
    id: '1103050013',
    districtId: '1103050',
    name: 'Lhok Rukam',
  },
  {
    id: '1103050014',
    districtId: '1103050',
    name: 'Air Pinang',
  },
  {
    id: '1103050015',
    districtId: '1103050',
    name: 'Panton Luas',
  },
  {
    id: '1103050016',
    districtId: '1103050',
    name: 'Lhok Bengkuang Timur',
  },
  {
    id: '1103060001',
    districtId: '1103060',
    name: 'Ujung Tanah',
  },
  {
    id: '1103060002',
    districtId: '1103060',
    name: 'Payonan Gadang',
  },
  {
    id: '1103060003',
    districtId: '1103060',
    name: 'Lubuk Layu',
  },
  {
    id: '1103060004',
    districtId: '1103060',
    name: 'Suaq Hulu',
  },
  {
    id: '1103060005',
    districtId: '1103060',
    name: 'Luar',
  },
  {
    id: '1103060006',
    districtId: '1103060',
    name: 'Ujung Kampung',
  },
  {
    id: '1103060007',
    districtId: '1103060',
    name: 'Tampang',
  },
  {
    id: '1103060008',
    districtId: '1103060',
    name: 'Jilatang',
  },
  {
    id: '1103060009',
    districtId: '1103060',
    name: 'Air Sialang Hulu',
  },
  {
    id: '1103060010',
    districtId: '1103060',
    name: 'Air Sialang Tengah',
  },
  {
    id: '1103060011',
    districtId: '1103060',
    name: 'Air Sialang Hilir',
  },
  {
    id: '1103060012',
    districtId: '1103060',
    name: 'Subarang',
  },
  {
    id: '1103060013',
    districtId: '1103060',
    name: 'Gunung Ketek',
  },
  {
    id: '1103060014',
    districtId: '1103060',
    name: 'Kota Baru',
  },
  {
    id: '1103060015',
    districtId: '1103060',
    name: 'Madat',
  },
  {
    id: '1103060016',
    districtId: '1103060',
    name: 'Dalam',
  },
  {
    id: '1103060017',
    districtId: '1103060',
    name: 'Tengah',
  },
  {
    id: '1103060018',
    districtId: '1103060',
    name: 'Balai',
  },
  {
    id: '1103060019',
    districtId: '1103060',
    name: 'Baru',
  },
  {
    id: '1103060020',
    districtId: '1103060',
    name: 'Gadang',
  },
  {
    id: '1103060021',
    districtId: '1103060',
    name: 'Ladang Kasik Putih',
  },
  {
    id: '1103060022',
    districtId: '1103060',
    name: 'Ladang Panton Luas',
  },
  {
    id: '1103060023',
    districtId: '1103060',
    name: 'Alur Simerah',
  },
  {
    id: '1103060024',
    districtId: '1103060',
    name: 'Alur Pinang',
  },
  {
    id: '1103060025',
    districtId: '1103060',
    name: 'Gunung Cut',
  },
  {
    id: '1103060026',
    districtId: '1103060',
    name: 'Kuta Blang',
  },
  {
    id: '1103060027',
    districtId: '1103060',
    name: 'Batee Tunggai',
  },
  {
    id: '1103060028',
    districtId: '1103060',
    name: 'Arafah',
  },
  {
    id: '1103070001',
    districtId: '1103070',
    name: 'Sawang Bau',
  },
  {
    id: '1103070002',
    districtId: '1103070',
    name: 'Ujung Padang',
  },
  {
    id: '1103070003',
    districtId: '1103070',
    name: 'Kuta Baro',
  },
  {
    id: '1103070004',
    districtId: '1103070',
    name: 'Simpang III',
  },
  {
    id: '1103070005',
    districtId: '1103070',
    name: 'Blang Gelinggang',
  },
  {
    id: '1103070006',
    districtId: '1103070',
    name: 'Meuligo',
  },
  {
    id: '1103070007',
    districtId: '1103070',
    name: 'Sawang I',
  },
  {
    id: '1103070008',
    districtId: '1103070',
    name: 'Sawang II',
  },
  {
    id: '1103070009',
    districtId: '1103070',
    name: 'Ujung Karang',
  },
  {
    id: '1103070010',
    districtId: '1103070',
    name: 'Lhok Pawoh',
  },
  {
    id: '1103070011',
    districtId: '1103070',
    name: 'Panton Luas',
  },
  {
    id: '1103070012',
    districtId: '1103070',
    name: 'Trieng Meuduro Tunong',
  },
  {
    id: '1103070013',
    districtId: '1103070',
    name: 'Trieng Meuduro Baroh',
  },
  {
    id: '1103070014',
    districtId: '1103070',
    name: 'Sikulat',
  },
  {
    id: '1103070015',
    districtId: '1103070',
    name: 'Mutiara',
  },
  {
    id: '1103080001',
    districtId: '1103080',
    name: 'Alue Meutuah',
  },
  {
    id: '1103080002',
    districtId: '1103080',
    name: 'Lhok Aman',
  },
  {
    id: '1103080003',
    districtId: '1103080',
    name: 'Ladang Baro',
  },
  {
    id: '1103080004',
    districtId: '1103080',
    name: 'Labuhan Tarok',
  },
  {
    id: '1103080005',
    districtId: '1103080',
    name: 'Tanjung Harapan',
  },
  {
    id: '1103080006',
    districtId: '1103080',
    name: 'Kuta Baro',
  },
  {
    id: '1103080007',
    districtId: '1103080',
    name: 'Keude Meukek',
  },
  {
    id: '1103080008',
    districtId: '1103080',
    name: 'Aron Tunggai',
  },
  {
    id: '1103080009',
    districtId: '1103080',
    name: 'Blang Bladeh',
  },
  {
    id: '1103080010',
    districtId: '1103080',
    name: 'Blang Teungoh',
  },
  {
    id: '1103080011',
    districtId: '1103080',
    name: 'Ie Buboh',
  },
  {
    id: '1103080012',
    districtId: '1103080',
    name: 'Kuta Buloh II',
  },
  {
    id: '1103080013',
    districtId: '1103080',
    name: 'Kuta Buloh I',
  },
  {
    id: '1103080014',
    districtId: '1103080',
    name: 'Ie Dingen',
  },
  {
    id: '1103080015',
    districtId: '1103080',
    name: 'Drien Jalo',
  },
  {
    id: '1103080016',
    districtId: '1103080',
    name: 'Jambo Papeun',
  },
  {
    id: '1103080017',
    districtId: '1103080',
    name: 'Buket Meuh',
  },
  {
    id: '1103080018',
    districtId: '1103080',
    name: 'Alue Baro',
  },
  {
    id: '1103080019',
    districtId: '1103080',
    name: 'Rot Teungoh',
  },
  {
    id: '1103080020',
    districtId: '1103080',
    name: 'Blang Kuala',
  },
  {
    id: '1103080021',
    districtId: '1103080',
    name: 'Ladang Tuha',
  },
  {
    id: '1103080022',
    districtId: '1103080',
    name: 'Lhok Mamplam',
  },
  {
    id: '1103080023',
    districtId: '1103080',
    name: 'Labuhan Tarok II',
  },
  {
    id: '1103090010',
    districtId: '1103090',
    name: 'Padang Baru',
  },
  {
    id: '1103090011',
    districtId: '1103090',
    name: 'Lembah Baru',
  },
  {
    id: '1103090012',
    districtId: '1103090',
    name: 'Tengah Baru',
  },
  {
    id: '1103090013',
    districtId: '1103090',
    name: 'Pawoh',
  },
  {
    id: '1103090014',
    districtId: '1103090',
    name: 'Apha',
  },
  {
    id: '1103090015',
    districtId: '1103090',
    name: 'Pasar Lama',
  },
  {
    id: '1103090016',
    districtId: '1103090',
    name: 'Padang Bakau',
  },
  {
    id: '1103090028',
    districtId: '1103090',
    name: 'Bakau Hulu',
  },
  {
    id: '1103090029',
    districtId: '1103090',
    name: 'Manggis Harapan',
  },
  {
    id: '1103090030',
    districtId: '1103090',
    name: 'Ujung Batu',
  },
  {
    id: '1103090031',
    districtId: '1103090',
    name: 'Dalam',
  },
  {
    id: '1103090032',
    districtId: '1103090',
    name: 'Kota Palak',
  },
  {
    id: '1103090033',
    districtId: '1103090',
    name: 'Cacang',
  },
  {
    id: '1103090034',
    districtId: '1103090',
    name: 'Tengah Pisang',
  },
  {
    id: '1103090035',
    districtId: '1103090',
    name: 'Pisang',
  },
  {
    id: '1103090036',
    districtId: '1103090',
    name: 'Hulu Pisang',
  },
  {
    id: '1103091001',
    districtId: '1103091',
    name: 'Keumumu Hilir',
  },
  {
    id: '1103091002',
    districtId: '1103091',
    name: 'Paya Peulumat',
  },
  {
    id: '1103091003',
    districtId: '1103091',
    name: 'Tengah Peulumat',
  },
  {
    id: '1103091004',
    districtId: '1103091',
    name: 'Padang Peulumat',
  },
  {
    id: '1103091005',
    districtId: '1103091',
    name: 'Limau Saring',
  },
  {
    id: '1103091006',
    districtId: '1103091',
    name: 'Aur Peulumat',
  },
  {
    id: '1103091007',
    districtId: '1103091',
    name: 'Keumumu Hulu',
  },
  {
    id: '1103091008',
    districtId: '1103091',
    name: 'Beutong',
  },
  {
    id: '1103091009',
    districtId: '1103091',
    name: 'Peunalop',
  },
  {
    id: '1103091010',
    districtId: '1103091',
    name: 'Gunung Rotan',
  },
  {
    id: '1103091011',
    districtId: '1103091',
    name: 'Keumumu Seberang',
  },
  {
    id: '1103091012',
    districtId: '1103091',
    name: 'Sawang Indah',
  },
  {
    id: '1103092001',
    districtId: '1103092',
    name: 'Pulo Ie',
  },
  {
    id: '1103092002',
    districtId: '1103092',
    name: 'Suak Lokan',
  },
  {
    id: '1103092003',
    districtId: '1103092',
    name: 'Iku Lhung',
  },
  {
    id: '1103092004',
    districtId: '1103092',
    name: 'Pante Geulima',
  },
  {
    id: '1103092005',
    districtId: '1103092',
    name: 'Blang Baru',
  },
  {
    id: '1103092006',
    districtId: '1103092',
    name: 'Blang Poroh',
  },
  {
    id: '1103092007',
    districtId: '1103092',
    name: 'Kuta Iboh',
  },
  {
    id: '1103092008',
    districtId: '1103092',
    name: 'Tutong',
  },
  {
    id: '1103092009',
    districtId: '1103092',
    name: 'Ujung Padang',
  },
  {
    id: '1103092010',
    districtId: '1103092',
    name: 'Tengah Iboh',
  },
  {
    id: '1103092011',
    districtId: '1103092',
    name: 'Peulokan',
  },
  {
    id: '1103092012',
    districtId: '1103092',
    name: 'Kuta Trieng',
  },
  {
    id: '1103092013',
    districtId: '1103092',
    name: 'Panton Pawoh',
  },
  {
    id: '1103092014',
    districtId: '1103092',
    name: 'Batee Meucanang',
  },
  {
    id: '1103092015',
    districtId: '1103092',
    name: 'Panton Rubek',
  },
  {
    id: '1104010021',
    districtId: '1104010',
    name: 'Muara Baru',
  },
  {
    id: '1104010022',
    districtId: '1104010',
    name: 'Pasir Bangun',
  },
  {
    id: '1104010023',
    districtId: '1104010',
    name: 'Ngkeran',
  },
  {
    id: '1104010024',
    districtId: '1104010',
    name: 'Lawe Kongkir',
  },
  {
    id: '1104010025',
    districtId: '1104010',
    name: 'Kubu',
  },
  {
    id: '1104010026',
    districtId: '1104010',
    name: 'Kuta Cingkam II',
  },
  {
    id: '1104010027',
    districtId: '1104010',
    name: 'Kuta Cingkam I',
  },
  {
    id: '1104010028',
    districtId: '1104010',
    name: 'Lawe Sempilang',
  },
  {
    id: '1104010029',
    districtId: '1104010',
    name: 'Kuta Batu II',
  },
  {
    id: '1104010030',
    districtId: '1104010',
    name: 'Kuta Batu I',
  },
  {
    id: '1104010031',
    districtId: '1104010',
    name: 'Prapat Batu Nunggul',
  },
  {
    id: '1104010032',
    districtId: '1104010',
    name: 'Pulo Sepang',
  },
  {
    id: '1104010034',
    districtId: '1104010',
    name: 'Paya Munje',
  },
  {
    id: '1104010035',
    districtId: '1104010',
    name: 'Darul Amin',
  },
  {
    id: '1104010036',
    districtId: '1104010',
    name: 'Lawe Lubang Indah',
  },
  {
    id: '1104010037',
    districtId: '1104010',
    name: 'Batu Hamparan',
  },
  {
    id: '1104010038',
    districtId: '1104010',
    name: 'Rih Mbelang',
  },
  {
    id: '1104010039',
    districtId: '1104010',
    name: 'Kute Batu Baru',
  },
  {
    id: '1104010040',
    districtId: '1104010',
    name: 'Rumah Kampung',
  },
  {
    id: '1104010041',
    districtId: '1104010',
    name: 'Pasekh Pekhmate',
  },
  {
    id: '1104010042',
    districtId: '1104010',
    name: 'Pasir Nunggul',
  },
  {
    id: '1104010043',
    districtId: '1104010',
    name: 'Lawe Kongkir Hilir',
  },
  {
    id: '1104010044',
    districtId: '1104010',
    name: 'Pulo Ndadap',
  },
  {
    id: '1104010045',
    districtId: '1104010',
    name: 'Pintu Khimbe',
  },
  {
    id: '1104010046',
    districtId: '1104010',
    name: 'Pulo Gadung',
  },
  {
    id: '1104010047',
    districtId: '1104010',
    name: 'Cingkam Meranggun',
  },
  {
    id: '1104010048',
    districtId: '1104010',
    name: 'Pasir Nunang',
  },
  {
    id: '1104010049',
    districtId: '1104010',
    name: 'Deleng Kukusen',
  },
  {
    id: '1104011001',
    districtId: '1104011',
    name: 'Penguhapan',
  },
  {
    id: '1104011002',
    districtId: '1104011',
    name: 'Salim Pipit',
  },
  {
    id: '1104011003',
    districtId: '1104011',
    name: 'Lawe Sumur',
  },
  {
    id: '1104011004',
    districtId: '1104011',
    name: 'Uning Sigugur',
  },
  {
    id: '1104011005',
    districtId: '1104011',
    name: 'Kuta Lang Lang',
  },
  {
    id: '1104011006',
    districtId: '1104011',
    name: 'Lumban Sitio Tio',
  },
  {
    id: '1104011007',
    districtId: '1104011',
    name: 'Meranti',
  },
  {
    id: '1104011008',
    districtId: '1104011',
    name: 'Perdamean',
  },
  {
    id: '1104011009',
    districtId: '1104011',
    name: 'Mutiara Damai',
  },
  {
    id: '1104011010',
    districtId: '1104011',
    name: 'Lumban Tua',
  },
  {
    id: '1104011011',
    districtId: '1104011',
    name: 'Dolok Nauli',
  },
  {
    id: '1104011012',
    districtId: '1104011',
    name: 'Tuhi Jongkat',
  },
  {
    id: '1104011013',
    districtId: '1104011',
    name: 'Titi Mas',
  },
  {
    id: '1104011017',
    districtId: '1104011',
    name: 'Lawe Malun',
  },
  {
    id: '1104011018',
    districtId: '1104011',
    name: 'Alur Baning',
  },
  {
    id: '1104011019',
    districtId: '1104011',
    name: 'Sigai Indah',
  },
  {
    id: '1104011020',
    districtId: '1104011',
    name: 'Sumur Alas',
  },
  {
    id: '1104011021',
    districtId: '1104011',
    name: 'Tuah Mesade',
  },
  {
    id: '1104011022',
    districtId: '1104011',
    name: 'Lingga Alas',
  },
  {
    id: '1104011023',
    districtId: '1104011',
    name: 'Rambung Tubung',
  },
  {
    id: '1104011024',
    districtId: '1104011',
    name: 'Sperinding',
  },
  {
    id: '1104011025',
    districtId: '1104011',
    name: 'Tanah Subur',
  },
  {
    id: '1104011026',
    districtId: '1104011',
    name: 'Pinggan Mblang',
  },
  {
    id: '1104011027',
    districtId: '1104011',
    name: 'Ukir Deleng',
  },
  {
    id: '1104011028',
    districtId: '1104011',
    name: 'Alas Mesikhat',
  },
  {
    id: '1104011029',
    districtId: '1104011',
    name: 'Titi Harapan',
  },
  {
    id: '1104011030',
    districtId: '1104011',
    name: 'Alur Baru',
  },
  {
    id: '1104012001',
    districtId: '1104012',
    name: 'Alur Langsat',
  },
  {
    id: '1104012002',
    districtId: '1104012',
    name: 'Lawe Tungkal',
  },
  {
    id: '1104012003',
    districtId: '1104012',
    name: 'Rumah Luar',
  },
  {
    id: '1104012005',
    districtId: '1104012',
    name: 'Rambah Sayang',
  },
  {
    id: '1104012006',
    districtId: '1104012',
    name: 'Jambur Damar',
  },
  {
    id: '1104012007',
    districtId: '1104012',
    name: 'Tenembak Alas',
  },
  {
    id: '1104012008',
    districtId: '1104012',
    name: 'Salim Pinim',
  },
  {
    id: '1104012009',
    districtId: '1104012',
    name: 'Rutung Mbelang',
  },
  {
    id: '1104012010',
    districtId: '1104012',
    name: 'Setambul Jaya',
  },
  {
    id: '1104012011',
    districtId: '1104012',
    name: 'Alur Nangka',
  },
  {
    id: '1104012012',
    districtId: '1104012',
    name: 'Timang Rasa',
  },
  {
    id: '1104012013',
    districtId: '1104012',
    name: 'Jambur Permata',
  },
  {
    id: '1104012014',
    districtId: '1104012',
    name: 'Kute Mejile',
  },
  {
    id: '1104012015',
    districtId: '1104012',
    name: 'Salim Pinim II',
  },
  {
    id: '1104020011',
    districtId: '1104020',
    name: 'Lawe Loning Gab',
  },
  {
    id: '1104020012',
    districtId: '1104020',
    name: 'Lawe Loning Aman',
  },
  {
    id: '1104020013',
    districtId: '1104020',
    name: 'Gabungan Parsaoran',
  },
  {
    id: '1104020014',
    districtId: '1104020',
    name: 'Kedataran Gab',
  },
  {
    id: '1104020016',
    districtId: '1104020',
    name: 'Kuta Tengah',
  },
  {
    id: '1104020017',
    districtId: '1104020',
    name: 'Tanah Baru',
  },
  {
    id: '1104020018',
    districtId: '1104020',
    name: 'Lawe Sigala Timur',
  },
  {
    id: '1104020019',
    districtId: '1104020',
    name: 'Lawe Sigala Barat',
  },
  {
    id: '1104020020',
    districtId: '1104020',
    name: 'Suka Damai',
  },
  {
    id: '1104020021',
    districtId: '1104020',
    name: 'Lawe Sigala II',
  },
  {
    id: '1104020022',
    districtId: '1104020',
    name: 'Lawe Tua Gab',
  },
  {
    id: '1104020023',
    districtId: '1104020',
    name: 'Bukit Merdeka',
  },
  {
    id: '1104020024',
    districtId: '1104020',
    name: 'Lawe Kesumpat',
  },
  {
    id: '1104020027',
    districtId: '1104020',
    name: 'Darul Aman',
  },
  {
    id: '1104020035',
    districtId: '1104020',
    name: 'Lawe Loning Sepakat',
  },
  {
    id: '1104020036',
    districtId: '1104020',
    name: 'Gaya Jaya',
  },
  {
    id: '1104020037',
    districtId: '1104020',
    name: 'Lawe Loning I',
  },
  {
    id: '1104020038',
    districtId: '1104020',
    name: 'Lawe Rakat',
  },
  {
    id: '1104020039',
    districtId: '1104020',
    name: 'Suka Maju',
  },
  {
    id: '1104020040',
    districtId: '1104020',
    name: 'Suka Jaya',
  },
  {
    id: '1104020041',
    districtId: '1104020',
    name: 'Lawe Serke',
  },
  {
    id: '1104020042',
    districtId: '1104020',
    name: 'Lawe Tua Persatuan',
  },
  {
    id: '1104020043',
    districtId: '1104020',
    name: 'Lawe Tua Makmur',
  },
  {
    id: '1104020044',
    districtId: '1104020',
    name: 'Bukit Sepakat',
  },
  {
    id: '1104020045',
    districtId: '1104020',
    name: 'Enmya Batu Dua Ratus',
  },
  {
    id: '1104020046',
    districtId: '1104020',
    name: 'Sebungke',
  },
  {
    id: '1104020047',
    districtId: '1104020',
    name: 'Lawe Loning Hakhapen',
  },
  {
    id: '1104020048',
    districtId: '1104020',
    name: 'Ndauh Ni Tenggau',
  },
  {
    id: '1104020049',
    districtId: '1104020',
    name: 'Kertimbang',
  },
  {
    id: '1104020050',
    districtId: '1104020',
    name: 'Lawe Sigala Barat Jaya',
  },
  {
    id: '1104020051',
    districtId: '1104020',
    name: 'Lawe Pekhidinan',
  },
  {
    id: '1104020052',
    districtId: '1104020',
    name: 'Gelah Musara',
  },
  {
    id: '1104020053',
    districtId: '1104020',
    name: 'Mulie Dame',
  },
  {
    id: '1104020054',
    districtId: '1104020',
    name: 'Karya Indah',
  },
  {
    id: '1104020055',
    districtId: '1104020',
    name: 'Kayu Mbelin',
  },
  {
    id: '1104021002',
    districtId: '1104021',
    name: 'Muara Situlen',
  },
  {
    id: '1104021003',
    districtId: '1104021',
    name: 'Pardamean',
  },
  {
    id: '1104021004',
    districtId: '1104021',
    name: 'Sejahtera',
  },
  {
    id: '1104021005',
    districtId: '1104021',
    name: 'Kampung Bhakti',
  },
  {
    id: '1104021006',
    districtId: '1104021',
    name: 'Lawe Perbunga',
  },
  {
    id: '1104021007',
    districtId: '1104021',
    name: 'Cinta Damai',
  },
  {
    id: '1104021008',
    districtId: '1104021',
    name: 'Pardomuan II',
  },
  {
    id: '1104021009',
    districtId: '1104021',
    name: 'Lawe Deski Sabas',
  },
  {
    id: '1104021010',
    districtId: '1104021',
    name: 'Pardomuan I',
  },
  {
    id: '1104021011',
    districtId: '1104021',
    name: 'Lawe Deski I',
  },
  {
    id: '1104021017',
    districtId: '1104021',
    name: 'Musara Setia',
  },
  {
    id: '1104021018',
    districtId: '1104021',
    name: 'Sejahtera Baru',
  },
  {
    id: '1104021019',
    districtId: '1104021',
    name: 'Tanoh Alas',
  },
  {
    id: '1104021020',
    districtId: '1104021',
    name: 'Cinta Makmur',
  },
  {
    id: '1104021021',
    districtId: '1104021',
    name: 'Lawe Mantik',
  },
  {
    id: '1104021022',
    districtId: '1104021',
    name: 'Kute Makmur',
  },
  {
    id: '1104021023',
    districtId: '1104021',
    name: 'Lawe Desky Tongah',
  },
  {
    id: '1104021024',
    districtId: '1104021',
    name: 'Lawe Tawakh',
  },
  {
    id: '1104021025',
    districtId: '1104021',
    name: 'Sabilussalam',
  },
  {
    id: '1104021026',
    districtId: '1104021',
    name: 'Deski Jaya',
  },
  {
    id: '1104021027',
    districtId: '1104021',
    name: 'Pintu Alas',
  },
  {
    id: '1104022001',
    districtId: '1104022',
    name: 'Lawe Kinga T Tinggi',
  },
  {
    id: '1104022002',
    districtId: '1104022',
    name: 'Lawe Beringin Horas',
  },
  {
    id: '1104022003',
    districtId: '1104022',
    name: 'Lawe Beringin Gayo',
  },
  {
    id: '1104022004',
    districtId: '1104022',
    name: 'Suka Makmur',
  },
  {
    id: '1104022005',
    districtId: '1104022',
    name: 'Ngk Alur Buluh',
  },
  {
    id: '1104022006',
    districtId: '1104022',
    name: 'Simpang Semadam',
  },
  {
    id: '1104022007',
    districtId: '1104022',
    name: 'Semadam Awal',
  },
  {
    id: '1104022008',
    districtId: '1104022',
    name: 'Kebun Sere',
  },
  {
    id: '1104022009',
    districtId: '1104022',
    name: 'Semadam Asal',
  },
  {
    id: '1104022010',
    districtId: '1104022',
    name: 'Lawe Kinga Gab',
  },
  {
    id: '1104022011',
    districtId: '1104022',
    name: 'Titi Pasir',
  },
  {
    id: '1104022012',
    districtId: '1104022',
    name: 'Pasar Puntung',
  },
  {
    id: '1104022013',
    districtId: '1104022',
    name: 'Lawe Petanduk',
  },
  {
    id: '1104022014',
    districtId: '1104022',
    name: 'Sepakat Segenep',
  },
  {
    id: '1104022015',
    districtId: '1104022',
    name: 'Kampung Baru',
  },
  {
    id: '1104022016',
    districtId: '1104022',
    name: 'Selamat Indah',
  },
  {
    id: '1104022017',
    districtId: '1104022',
    name: 'Lawe Mejile',
  },
  {
    id: '1104022018',
    districtId: '1104022',
    name: 'Lawe Kinga Lapter',
  },
  {
    id: '1104022019',
    districtId: '1104022',
    name: 'Lawe Petanduk I',
  },
  {
    id: '1104023001',
    districtId: '1104023',
    name: 'Naga Timbul',
  },
  {
    id: '1104023002',
    districtId: '1104023',
    name: 'Gunung Pak-Pak',
  },
  {
    id: '1104023003',
    districtId: '1104023',
    name: 'Bunbun Alas',
  },
  {
    id: '1104023004',
    districtId: '1104023',
    name: 'Tanjung Sari',
  },
  {
    id: '1104023005',
    districtId: '1104023',
    name: 'Bintang Alga Musara',
  },
  {
    id: '1104023006',
    districtId: '1104023',
    name: 'Bukit Bintang Indah',
  },
  {
    id: '1104023007',
    districtId: '1104023',
    name: 'Suka Damai',
  },
  {
    id: '1104023008',
    districtId: '1104023',
    name: 'Sepakat',
  },
  {
    id: '1104023009',
    districtId: '1104023',
    name: 'Punce Nali',
  },
  {
    id: '1104023010',
    districtId: '1104023',
    name: 'Sade Ate',
  },
  {
    id: '1104023011',
    districtId: '1104023',
    name: 'Arih Mejilai',
  },
  {
    id: '1104023012',
    districtId: '1104023',
    name: 'Ukhat Peseluk',
  },
  {
    id: '1104023013',
    districtId: '1104023',
    name: 'Tunas Mude',
  },
  {
    id: '1104023014',
    districtId: '1104023',
    name: 'Gaye Sendah',
  },
  {
    id: '1104023015',
    districtId: '1104023',
    name: 'Kute Hakhapen',
  },
  {
    id: '1104023016',
    districtId: '1104023',
    name: 'Tuah Kerine',
  },
  {
    id: '1104023017',
    districtId: '1104023',
    name: 'Lawe Sekhakut',
  },
  {
    id: '1104023018',
    districtId: '1104023',
    name: 'Bun Bun Indah',
  },
  {
    id: '1104023019',
    districtId: '1104023',
    name: 'Laut Tawar',
  },
  {
    id: '1104023020',
    districtId: '1104023',
    name: 'Kane Mende',
  },
  {
    id: '1104023021',
    districtId: '1104023',
    name: 'Kompas',
  },
  {
    id: '1104023022',
    districtId: '1104023',
    name: 'Bukit Meriah',
  },
  {
    id: '1104023023',
    districtId: '1104023',
    name: 'Permata Musara',
  },
  {
    id: '1104030016',
    districtId: '1104030',
    name: 'Tualang Sembilar',
  },
  {
    id: '1104030017',
    districtId: '1104030',
    name: 'Terutung Payung Hilir',
  },
  {
    id: '1104030018',
    districtId: '1104030',
    name: 'Terutung Payung Hulu',
  },
  {
    id: '1104030019',
    districtId: '1104030',
    name: 'Likat',
  },
  {
    id: '1104030020',
    districtId: '1104030',
    name: 'Rikit',
  },
  {
    id: '1104030021',
    districtId: '1104030',
    name: 'Kuning I',
  },
  {
    id: '1104030022',
    districtId: '1104030',
    name: 'Cinta Damai',
  },
  {
    id: '1104030023',
    districtId: '1104030',
    name: 'Kuning II',
  },
  {
    id: '1104030024',
    districtId: '1104030',
    name: 'Kuta Lang Lang',
  },
  {
    id: '1104030025',
    districtId: '1104030',
    name: 'Pedesi',
  },
  {
    id: '1104030026',
    districtId: '1104030',
    name: 'Biak Muli',
  },
  {
    id: '1104030027',
    districtId: '1104030',
    name: 'Terutung Megara Asli',
  },
  {
    id: '1104030028',
    districtId: '1104030',
    name: 'Pinding',
  },
  {
    id: '1104030029',
    districtId: '1104030',
    name: 'Lawe Hijo',
  },
  {
    id: '1104030034',
    districtId: '1104030',
    name: 'Bambel Gabungan',
  },
  {
    id: '1104030040',
    districtId: '1104030',
    name: 'Pulo Kedondong',
  },
  {
    id: '1104030041',
    districtId: '1104030',
    name: 'Pulo Perengge',
  },
  {
    id: '1104030042',
    districtId: '1104030',
    name: 'Kute Antara',
  },
  {
    id: '1104030046',
    districtId: '1104030',
    name: 'Terutung Seperai',
  },
  {
    id: '1104030047',
    districtId: '1104030',
    name: 'Lawe Kihing',
  },
  {
    id: '1104030048',
    districtId: '1104030',
    name: 'Bambel',
  },
  {
    id: '1104030049',
    districtId: '1104030',
    name: 'Kute Seri',
  },
  {
    id: '1104030050',
    districtId: '1104030',
    name: 'Kuta Buluh',
  },
  {
    id: '1104030051',
    districtId: '1104030',
    name: 'Tualang Sembilar Baru',
  },
  {
    id: '1104030052',
    districtId: '1104030',
    name: 'Terutung Payung Gabungan',
  },
  {
    id: '1104030053',
    districtId: '1104030',
    name: 'Biak Muli Baru',
  },
  {
    id: '1104030054',
    districtId: '1104030',
    name: 'Biak Muli Pante Raja',
  },
  {
    id: '1104030055',
    districtId: '1104030',
    name: 'Biak Muli Sejahtera',
  },
  {
    id: '1104030056',
    districtId: '1104030',
    name: 'Lawe Hijo Metuah',
  },
  {
    id: '1104030057',
    districtId: '1104030',
    name: 'Lawe Hijo Ampera',
  },
  {
    id: '1104030058',
    districtId: '1104030',
    name: 'Lembah Haji',
  },
  {
    id: '1104030059',
    districtId: '1104030',
    name: 'Kuta Lang Lang Baru',
  },
  {
    id: '1104030060',
    districtId: '1104030',
    name: 'Pancar Iman',
  },
  {
    id: '1104031001',
    districtId: '1104031',
    name: 'Maha Singkil',
  },
  {
    id: '1104031002',
    districtId: '1104031',
    name: 'Tenembak Bintang',
  },
  {
    id: '1104031003',
    districtId: '1104031',
    name: 'Alur Buluh',
  },
  {
    id: '1104031004',
    districtId: '1104031',
    name: 'Tualang Baru',
  },
  {
    id: '1104031005',
    districtId: '1104031',
    name: 'Kuta Lengat Pagan',
  },
  {
    id: '1104031006',
    districtId: '1104031',
    name: 'Kuta Lengat Selian',
  },
  {
    id: '1104031007',
    districtId: '1104031',
    name: 'Kuta Lingga',
  },
  {
    id: '1104031008',
    districtId: '1104031',
    name: 'Rema',
  },
  {
    id: '1104031009',
    districtId: '1104031',
    name: 'Lawe Dua Gab',
  },
  {
    id: '1104031010',
    districtId: '1104031',
    name: 'Kerukunan',
  },
  {
    id: '1104031012',
    districtId: '1104031',
    name: 'Rikit Bur',
  },
  {
    id: '1104031013',
    districtId: '1104031',
    name: 'Amaliah',
  },
  {
    id: '1104031014',
    districtId: '1104031',
    name: 'Gumpang',
  },
  {
    id: '1104031015',
    districtId: '1104031',
    name: 'Pejuang',
  },
  {
    id: '1104031016',
    districtId: '1104031',
    name: 'Sebudi Jaya',
  },
  {
    id: '1104031017',
    districtId: '1104031',
    name: 'Bambel Baru',
  },
  {
    id: '1104031018',
    districtId: '1104031',
    name: 'Darussalam',
  },
  {
    id: '1104031019',
    districtId: '1104031',
    name: 'Kute Gekhat',
  },
  {
    id: '1104031020',
    districtId: '1104031',
    name: 'Mbak Sako',
  },
  {
    id: '1104031021',
    districtId: '1104031',
    name: 'Paye Rambung',
  },
  {
    id: '1104031022',
    districtId: '1104031',
    name: 'Darul Imami',
  },
  {
    id: '1104031023',
    districtId: '1104031',
    name: 'Rikit Bur II',
  },
  {
    id: '1104031024',
    districtId: '1104031',
    name: 'Empat Lima',
  },
  {
    id: '1104032001',
    districtId: '1104032',
    name: 'Kuta Lesung',
  },
  {
    id: '1104032002',
    districtId: '1104032',
    name: 'Berandang',
  },
  {
    id: '1104032003',
    districtId: '1104032',
    name: 'Lawe Sumur',
  },
  {
    id: '1104032004',
    districtId: '1104032',
    name: 'Terutung Megare Lawe Pasaran',
  },
  {
    id: '1104032005',
    districtId: '1104032',
    name: 'Kisam Gabungan',
  },
  {
    id: '1104032006',
    districtId: '1104032',
    name: 'Penosan',
  },
  {
    id: '1104032007',
    districtId: '1104032',
    name: 'Kisam Kute Pasir',
  },
  {
    id: '1104032008',
    districtId: '1104032',
    name: 'Buah Pala',
  },
  {
    id: '1104032009',
    districtId: '1104032',
    name: 'Kute Bunin',
  },
  {
    id: '1104032010',
    districtId: '1104032',
    name: 'Lawe Sumur Baru',
  },
  {
    id: '1104032011',
    districtId: '1104032',
    name: 'Setia Baru',
  },
  {
    id: '1104032012',
    districtId: '1104032',
    name: 'Lawe Perlak',
  },
  {
    id: '1104032013',
    districtId: '1104032',
    name: 'Lawe Sumur Sepakat',
  },
  {
    id: '1104032014',
    districtId: '1104032',
    name: 'Terutung Megara Baru',
  },
  {
    id: '1104032015',
    districtId: '1104032',
    name: 'Lawe Pasaran Tengku Mbelin',
  },
  {
    id: '1104032016',
    districtId: '1104032',
    name: 'Kisam Lestari',
  },
  {
    id: '1104032017',
    districtId: '1104032',
    name: 'Kisam Kuta Rambe',
  },
  {
    id: '1104032018',
    districtId: '1104032',
    name: 'Tiger Miko',
  },
  {
    id: '1104040001',
    districtId: '1104040',
    name: 'Kuta Rih',
  },
  {
    id: '1104040002',
    districtId: '1104040',
    name: 'Kutacane Lama',
  },
  {
    id: '1104040003',
    districtId: '1104040',
    name: 'Perapat Hilir',
  },
  {
    id: '1104040004',
    districtId: '1104040',
    name: 'Perapat Hulu',
  },
  {
    id: '1104040005',
    districtId: '1104040',
    name: 'Pulo Latong',
  },
  {
    id: '1104040010',
    districtId: '1104040',
    name: 'Kota Kutacane',
  },
  {
    id: '1104040011',
    districtId: '1104040',
    name: 'Muara Lawe Bulan',
  },
  {
    id: '1104040012',
    districtId: '1104040',
    name: 'Mbarung',
  },
  {
    id: '1104040013',
    districtId: '1104040',
    name: 'Pulonas',
  },
  {
    id: '1104040021',
    districtId: '1104040',
    name: 'Batu Bulan I',
  },
  {
    id: '1104040022',
    districtId: '1104040',
    name: 'Batu Bulan II',
  },
  {
    id: '1104040023',
    districtId: '1104040',
    name: 'Batu Bulan Asli',
  },
  {
    id: '1104040024',
    districtId: '1104040',
    name: 'Kampung Raja',
  },
  {
    id: '1104040026',
    districtId: '1104040',
    name: 'Kampung Melayu Gabungan',
  },
  {
    id: '1104040027',
    districtId: '1104040',
    name: 'Terutung Pedi',
  },
  {
    id: '1104040029',
    districtId: '1104040',
    name: 'Gumpang Jaya',
  },
  {
    id: '1104040030',
    districtId: '1104040',
    name: 'Batumbulan Baru',
  },
  {
    id: '1104040031',
    districtId: '1104040',
    name: 'Ujung Barat',
  },
  {
    id: '1104040032',
    districtId: '1104040',
    name: 'Pulo Peding',
  },
  {
    id: '1104040033',
    districtId: '1104040',
    name: 'Medabe',
  },
  {
    id: '1104040034',
    districtId: '1104040',
    name: 'Perapat Sepakat',
  },
  {
    id: '1104040035',
    districtId: '1104040',
    name: 'Perapat Titi Panjang',
  },
  {
    id: '1104040036',
    districtId: '1104040',
    name: 'Pulo Sanggar',
  },
  {
    id: '1104040037',
    districtId: '1104040',
    name: 'Mbarung Datuk Saudane',
  },
  {
    id: '1104040038',
    districtId: '1104040',
    name: 'Batu Bulan Sepakat',
  },
  {
    id: '1104040039',
    districtId: '1104040',
    name: 'Kampung Melayu I',
  },
  {
    id: '1104040040',
    districtId: '1104040',
    name: 'Alas Merancar',
  },
  {
    id: '1104041001',
    districtId: '1104041',
    name: 'Pasir Penjengakan',
  },
  {
    id: '1104041002',
    districtId: '1104041',
    name: 'Kutambaru',
  },
  {
    id: '1104041003',
    districtId: '1104041',
    name: 'Pasir Gala',
  },
  {
    id: '1104041004',
    districtId: '1104041',
    name: 'Lawe Rutung',
  },
  {
    id: '1104041005',
    districtId: '1104041',
    name: 'Kuta Bantil',
  },
  {
    id: '1104041006',
    districtId: '1104041',
    name: 'Lawe Kulok',
  },
  {
    id: '1104041007',
    districtId: '1104041',
    name: 'Lawe Sagu Hulu',
  },
  {
    id: '1104041012',
    districtId: '1104041',
    name: 'Tenembak Juhar',
  },
  {
    id: '1104041013',
    districtId: '1104041',
    name: 'Lawe Sagu Hilir',
  },
  {
    id: '1104041014',
    districtId: '1104041',
    name: 'Kp Nangka Gab',
  },
  {
    id: '1104041016',
    districtId: '1104041',
    name: 'Telaga Mekar',
  },
  {
    id: '1104041018',
    districtId: '1104041',
    name: 'Kute Buluh Botong',
  },
  {
    id: '1104041019',
    districtId: '1104041',
    name: 'Kute Mbaru Bencawan',
  },
  {
    id: '1104041020',
    districtId: '1104041',
    name: 'Pulonas Baru',
  },
  {
    id: '1104041021',
    districtId: '1104041',
    name: 'Simpang Empat',
  },
  {
    id: '1104041022',
    districtId: '1104041',
    name: 'Kandang Belang Mandiri',
  },
  {
    id: '1104041023',
    districtId: '1104041',
    name: 'Mbacang Racun',
  },
  {
    id: '1104041024',
    districtId: '1104041',
    name: 'Lawe Kinge',
  },
  {
    id: '1104041025',
    districtId: '1104041',
    name: 'Perapat Timur',
  },
  {
    id: '1104041026',
    districtId: '1104041',
    name: 'Bahagia',
  },
  {
    id: '1104041027',
    districtId: '1104041',
    name: 'Kuta Galuh',
  },
  {
    id: '1104041028',
    districtId: '1104041',
    name: 'Kute Genting',
  },
  {
    id: '1104041029',
    districtId: '1104041',
    name: 'Lawe Sagu',
  },
  {
    id: '1104041030',
    districtId: '1104041',
    name: 'Kute Pangguh',
  },
  {
    id: '1104050002',
    districtId: '1104050',
    name: 'Kampung Baru',
  },
  {
    id: '1104050003',
    districtId: '1104050',
    name: 'Purwodadi',
  },
  {
    id: '1104050004',
    districtId: '1104050',
    name: 'Lawe Bekung',
  },
  {
    id: '1104050005',
    districtId: '1104050',
    name: 'Salang Alas',
  },
  {
    id: '1104050006',
    districtId: '1104050',
    name: 'Kuta Tinggi',
  },
  {
    id: '1104050014',
    districtId: '1104050',
    name: 'Peranginan',
  },
  {
    id: '1104050015',
    districtId: '1104050',
    name: 'Kuta Pasir',
  },
  {
    id: '1104050022',
    districtId: '1104050',
    name: 'Natam',
  },
  {
    id: '1104050034',
    districtId: '1104050',
    name: 'Kumbang Jaya',
  },
  {
    id: '1104050035',
    districtId: '1104050',
    name: 'Kumbang Indah',
  },
  {
    id: '1104050036',
    districtId: '1104050',
    name: 'Deleng Megakhe',
  },
  {
    id: '1104050037',
    districtId: '1104050',
    name: 'Lawe Bekung Tempahan',
  },
  {
    id: '1104050038',
    districtId: '1104050',
    name: 'Badar Indah',
  },
  {
    id: '1104050040',
    districtId: '1104050',
    name: 'Natam Baru',
  },
  {
    id: '1104050041',
    districtId: '1104050',
    name: 'Tanah Merah',
  },
  {
    id: '1104050042',
    districtId: '1104050',
    name: 'Batu Mberong',
  },
  {
    id: '1104050043',
    districtId: '1104050',
    name: 'Lawe Sekerah',
  },
  {
    id: '1104050044',
    districtId: '1104050',
    name: 'Tanoh Megakhe',
  },
  {
    id: '1104051001',
    districtId: '1104051',
    name: 'Gulo',
  },
  {
    id: '1104051002',
    districtId: '1104051',
    name: 'Lawe Stul',
  },
  {
    id: '1104051003',
    districtId: '1104051',
    name: 'Kite Meranggun',
  },
  {
    id: '1104051004',
    districtId: '1104051',
    name: 'Pulo Piku',
  },
  {
    id: '1104051005',
    districtId: '1104051',
    name: 'Terutung Kute',
  },
  {
    id: '1104051006',
    districtId: '1104051',
    name: 'Kuta Ujung',
  },
  {
    id: '1104051007',
    districtId: '1104051',
    name: 'Mamas',
  },
  {
    id: '1104051008',
    districtId: '1104051',
    name: 'Tanjung Lama',
  },
  {
    id: '1104051009',
    districtId: '1104051',
    name: 'Tanjung Muda',
  },
  {
    id: '1104051010',
    districtId: '1104051',
    name: 'Tanjung Aman',
  },
  {
    id: '1104051011',
    districtId: '1104051',
    name: 'Rambung Teldak',
  },
  {
    id: '1104051012',
    districtId: '1104051',
    name: 'Serimuda',
  },
  {
    id: '1104051013',
    districtId: '1104051',
    name: 'Darul Makmur',
  },
  {
    id: '1104051014',
    districtId: '1104051',
    name: 'Kute Rambe',
  },
  {
    id: '1104051015',
    districtId: '1104051',
    name: 'Ujung Baru',
  },
  {
    id: '1104051016',
    districtId: '1104051',
    name: 'Mamas Baru',
  },
  {
    id: '1104051017',
    districtId: '1104051',
    name: 'Rambung Jaya',
  },
  {
    id: '1104051018',
    districtId: '1104051',
    name: 'Makmur Jaya',
  },
  {
    id: '1104051019',
    districtId: '1104051',
    name: 'Pulo Gadung',
  },
  {
    id: '1104051020',
    districtId: '1104051',
    name: 'Istiqomah',
  },
  {
    id: '1104051021',
    districtId: '1104051',
    name: 'Khotan Jaya',
  },
  {
    id: '1104051022',
    districtId: '1104051',
    name: 'Lawe Mamas Indah',
  },
  {
    id: '1104051023',
    districtId: '1104051',
    name: 'Tanjung Baru',
  },
  {
    id: '1104051024',
    districtId: '1104051',
    name: 'Simpang IV Tanjung',
  },
  {
    id: '1104051025',
    districtId: '1104051',
    name: 'Tanjung Leuser',
  },
  {
    id: '1104051026',
    districtId: '1104051',
    name: 'Lawe Pinis',
  },
  {
    id: '1104051027',
    districtId: '1104051',
    name: 'Kuning Abadi',
  },
  {
    id: '1104051028',
    districtId: '1104051',
    name: 'Buntul Kendawi',
  },
  {
    id: '1104052001',
    districtId: '1104052',
    name: 'Deleng Damar',
  },
  {
    id: '1104052002',
    districtId: '1104052',
    name: 'Simpang III Jongar',
  },
  {
    id: '1104052003',
    districtId: '1104052',
    name: 'Penyebrangan Cingkam',
  },
  {
    id: '1104052004',
    districtId: '1104052',
    name: 'Jongar',
  },
  {
    id: '1104052005',
    districtId: '1104052',
    name: 'Lawe Penanggalan',
  },
  {
    id: '1104052006',
    districtId: '1104052',
    name: 'Jambur Lak Lak',
  },
  {
    id: '1104052007',
    districtId: '1104052',
    name: 'Lawe Mengkudu',
  },
  {
    id: '1104052008',
    districtId: '1104052',
    name: 'Aunan Sepakat',
  },
  {
    id: '1104052009',
    districtId: '1104052',
    name: 'Ketambe',
  },
  {
    id: '1104052010',
    districtId: '1104052',
    name: 'Rumah Bundar',
  },
  {
    id: '1104052011',
    districtId: '1104052',
    name: 'Kayu Mentangur',
  },
  {
    id: '1104052012',
    districtId: '1104052',
    name: 'Lawe Sembekan',
  },
  {
    id: '1104052013',
    districtId: '1104052',
    name: 'Lawe Gekh Gekh',
  },
  {
    id: '1104052014',
    districtId: '1104052',
    name: 'Lawe Beringin',
  },
  {
    id: '1104052015',
    districtId: '1104052',
    name: 'Bener Berpapah',
  },
  {
    id: '1104052016',
    districtId: '1104052',
    name: 'Datuk Pinding',
  },
  {
    id: '1104052017',
    districtId: '1104052',
    name: 'Penungkunen',
  },
  {
    id: '1104052018',
    districtId: '1104052',
    name: 'Jati Sara',
  },
  {
    id: '1104052019',
    districtId: '1104052',
    name: 'Leuser',
  },
  {
    id: '1104052020',
    districtId: '1104052',
    name: 'Bukit Baru',
  },
  {
    id: '1104052021',
    districtId: '1104052',
    name: 'Kati Maju',
  },
  {
    id: '1104052022',
    districtId: '1104052',
    name: 'Lawe Aunan',
  },
  {
    id: '1104052023',
    districtId: '1104052',
    name: 'Bintang Bener',
  },
  {
    id: '1104052024',
    districtId: '1104052',
    name: 'Suka Rimbun',
  },
  {
    id: '1104052025',
    districtId: '1104052',
    name: 'Simpur Jaya',
  },
  {
    id: '1104053001',
    districtId: '1104053',
    name: 'Bunga Melur',
  },
  {
    id: '1104053002',
    districtId: '1104053',
    name: 'Terutung Mbelang',
  },
  {
    id: '1104053003',
    districtId: '1104053',
    name: 'Tenembak Lang Lang',
  },
  {
    id: '1104053004',
    districtId: '1104053',
    name: 'Penampaan',
  },
  {
    id: '1104053005',
    districtId: '1104053',
    name: 'Tualang Lama',
  },
  {
    id: '1104053006',
    districtId: '1104053',
    name: 'Lawe Pangkat',
  },
  {
    id: '1104053007',
    districtId: '1104053',
    name: 'Gusung Batu',
  },
  {
    id: '1104053008',
    districtId: '1104053',
    name: 'Kaya Pangur',
  },
  {
    id: '1104053009',
    districtId: '1104053',
    name: 'Ranto Diur',
  },
  {
    id: '1104053010',
    districtId: '1104053',
    name: 'Lembah Alas',
  },
  {
    id: '1104053011',
    districtId: '1104053',
    name: 'Kampung Sepakat',
  },
  {
    id: '1104053012',
    districtId: '1104053',
    name: 'Salang Sigotom',
  },
  {
    id: '1104053013',
    districtId: '1104053',
    name: 'Salang Baru',
  },
  {
    id: '1104053014',
    districtId: '1104053',
    name: 'Salang Muara',
  },
  {
    id: '1104053015',
    districtId: '1104053',
    name: 'Muhajirin',
  },
  {
    id: '1104053016',
    districtId: '1104053',
    name: 'Beringin Naru',
  },
  {
    id: '1104053017',
    districtId: '1104053',
    name: 'Tanoh Khukahen',
  },
  {
    id: '1104053018',
    districtId: '1104053',
    name: 'Tading Niulihi',
  },
  {
    id: '1104053019',
    districtId: '1104053',
    name: 'Peseluk Pesimbe',
  },
  {
    id: '1104053020',
    districtId: '1104053',
    name: 'Kati Jeroh',
  },
  {
    id: '1104053021',
    districtId: '1104053',
    name: 'Kane Lot',
  },
  {
    id: '1104053022',
    districtId: '1104053',
    name: 'Lawe Hakhum',
  },
  {
    id: '1105080001',
    districtId: '1105080',
    name: 'Lokop',
  },
  {
    id: '1105080002',
    districtId: '1105080',
    name: 'Tualang',
  },
  {
    id: '1105080003',
    districtId: '1105080',
    name: 'Gampong Terujak',
  },
  {
    id: '1105080004',
    districtId: '1105080',
    name: 'Leles',
  },
  {
    id: '1105080013',
    districtId: '1105080',
    name: 'Ujung Karang',
  },
  {
    id: '1105080014',
    districtId: '1105080',
    name: 'Ujung Taring',
  },
  {
    id: '1105080015',
    districtId: '1105080',
    name: 'Sunti',
  },
  {
    id: '1105080016',
    districtId: '1105080',
    name: 'Sekualan',
  },
  {
    id: '1105080017',
    districtId: '1105080',
    name: 'Loot',
  },
  {
    id: '1105080018',
    districtId: '1105080',
    name: 'Nalon',
  },
  {
    id: '1105080019',
    districtId: '1105080',
    name: 'Jering',
  },
  {
    id: '1105080020',
    districtId: '1105080',
    name: 'Rampah',
  },
  {
    id: '1105080021',
    districtId: '1105080',
    name: 'Mesir',
  },
  {
    id: '1105080022',
    districtId: '1105080',
    name: 'Selemak',
  },
  {
    id: '1105080023',
    districtId: '1105080',
    name: 'Sembuang',
  },
  {
    id: '1105080028',
    districtId: '1105080',
    name: 'Bunin',
  },
  {
    id: '1105080029',
    districtId: '1105080',
    name: 'Alur Drien',
  },
  {
    id: '1105080030',
    districtId: '1105080',
    name: 'UPT I Kuala Pangoh',
  },
  {
    id: '1105081001',
    districtId: '1105081',
    name: 'Hti Ranto Naro',
  },
  {
    id: '1105081002',
    districtId: '1105081',
    name: 'Tampur Boor',
  },
  {
    id: '1105081003',
    districtId: '1105081',
    name: 'Tampor Paloh',
  },
  {
    id: '1105081004',
    districtId: '1105081',
    name: 'Melidi',
  },
  {
    id: '1105081005',
    districtId: '1105081',
    name: 'Batu Sumbang',
  },
  {
    id: '1105081006',
    districtId: '1105081',
    name: 'Simpang Jernih',
  },
  {
    id: '1105081007',
    districtId: '1105081',
    name: 'Pante Kera',
  },
  {
    id: '1105081008',
    districtId: '1105081',
    name: 'Rantau Panjang',
  },
  {
    id: '1105082001',
    districtId: '1105082',
    name: 'Arul Pinang',
  },
  {
    id: '1105082002',
    districtId: '1105082',
    name: 'Peunaron Baru',
  },
  {
    id: '1105082003',
    districtId: '1105082',
    name: 'Peunaron Lama',
  },
  {
    id: '1105082004',
    districtId: '1105082',
    name: 'Bukit Tiga',
  },
  {
    id: '1105082006',
    districtId: '1105082',
    name: 'Sri Mulya',
  },
  {
    id: '1105090001',
    districtId: '1105090',
    name: 'Buket Tiga',
  },
  {
    id: '1105090002',
    districtId: '1105090',
    name: 'Benteng',
  },
  {
    id: '1105090003',
    districtId: '1105090',
    name: 'Afd.II Buket',
  },
  {
    id: '1105090004',
    districtId: '1105090',
    name: 'Alue Drien',
  },
  {
    id: '1105090005',
    districtId: '1105090',
    name: 'Alue Canang',
  },
  {
    id: '1105090006',
    districtId: '1105090',
    name: 'Jambur Labu',
  },
  {
    id: '1105090007',
    districtId: '1105090',
    name: 'Alue Buloh',
  },
  {
    id: '1105090008',
    districtId: '1105090',
    name: 'Peutow',
  },
  {
    id: '1105090009',
    districtId: '1105090',
    name: 'Kemuning Hulu',
  },
  {
    id: '1105090010',
    districtId: '1105090',
    name: 'Alue Teh',
  },
  {
    id: '1105090011',
    districtId: '1105090',
    name: 'Paya Tampah',
  },
  {
    id: '1105090012',
    districtId: '1105090',
    name: 'Paya Bili II',
  },
  {
    id: '1105090013',
    districtId: '1105090',
    name: 'Paya Rambong',
  },
  {
    id: '1105090014',
    districtId: '1105090',
    name: 'Alue Gadeng Satu',
  },
  {
    id: '1105090015',
    districtId: '1105090',
    name: 'Birem Rayeuk',
  },
  {
    id: '1105090016',
    districtId: '1105090',
    name: 'Keude Birem',
  },
  {
    id: '1105090017',
    districtId: '1105090',
    name: 'Aramiyah',
  },
  {
    id: '1105090018',
    districtId: '1105090',
    name: 'Paya Bili I',
  },
  {
    id: '1105090019',
    districtId: '1105090',
    name: 'Merbau II',
  },
  {
    id: '1105090020',
    districtId: '1105090',
    name: 'Paya Peulawi',
  },
  {
    id: '1105090021',
    districtId: '1105090',
    name: 'Bayeun',
  },
  {
    id: '1105090022',
    districtId: '1105090',
    name: 'Alue Gadeng',
  },
  {
    id: '1105090023',
    districtId: '1105090',
    name: 'Perk. Alue Gadeng Dua',
  },
  {
    id: '1105090024',
    districtId: '1105090',
    name: 'Bukit Seulemak',
  },
  {
    id: '1105090025',
    districtId: '1105090',
    name: 'Blang Tualang',
  },
  {
    id: '1105090026',
    districtId: '1105090',
    name: 'Alue Sentang',
  },
  {
    id: '1105090027',
    districtId: '1105090',
    name: 'Alue Nyamuk',
  },
  {
    id: '1105100001',
    districtId: '1105100',
    name: 'Alue Tuwi',
  },
  {
    id: '1105100002',
    districtId: '1105100',
    name: 'Alue Kaol',
  },
  {
    id: '1105100003',
    districtId: '1105100',
    name: 'Alue Punti',
  },
  {
    id: '1105100004',
    districtId: '1105100',
    name: 'Damar Siput',
  },
  {
    id: '1105100005',
    districtId: '1105100',
    name: 'Simpang Peut',
  },
  {
    id: '1105100006',
    districtId: '1105100',
    name: 'Sarah Kayee',
  },
  {
    id: '1105100007',
    districtId: '1105100',
    name: 'Alur Seuleumak',
  },
  {
    id: '1105100008',
    districtId: '1105100',
    name: 'Simpang Aneuh',
  },
  {
    id: '1105100009',
    districtId: '1105100',
    name: 'Gampong Bayeun',
  },
  {
    id: '1105100010',
    districtId: '1105100',
    name: 'Sarah Teubee',
  },
  {
    id: '1105100011',
    districtId: '1105100',
    name: 'Rantau Panjang',
  },
  {
    id: '1105100012',
    districtId: '1105100',
    name: 'Alue Raya',
  },
  {
    id: '1105100013',
    districtId: '1105100',
    name: 'Seuneubok Dalam',
  },
  {
    id: '1105100014',
    districtId: '1105100',
    name: 'Alue Kumba',
  },
  {
    id: '1105101001',
    districtId: '1105101',
    name: 'Gajah Mentah',
  },
  {
    id: '1105101002',
    districtId: '1105101',
    name: 'Seuneubok Aceh',
  },
  {
    id: '1105101003',
    districtId: '1105101',
    name: 'Seuneubok Pase',
  },
  {
    id: '1105101004',
    districtId: '1105101',
    name: 'Sungai Simpang',
  },
  {
    id: '1105101005',
    districtId: '1105101',
    name: 'Paya Keutapang',
  },
  {
    id: '1105101006',
    districtId: '1105101',
    name: 'Alue Itam',
  },
  {
    id: '1105101007',
    districtId: '1105101',
    name: 'Bukit Drien',
  },
  {
    id: '1105101008',
    districtId: '1105101',
    name: 'Bukit Selamat',
  },
  {
    id: '1105101009',
    districtId: '1105101',
    name: 'Kuala Parek',
  },
  {
    id: '1105101010',
    districtId: '1105101',
    name: 'Labuhan Keude',
  },
  {
    id: '1105101011',
    districtId: '1105101',
    name: 'Krueng Lingka',
  },
  {
    id: '1105101012',
    districtId: '1105101',
    name: 'Geulumpang Payong',
  },
  {
    id: '1105101013',
    districtId: '1105101',
    name: 'Alue Rangan',
  },
  {
    id: '1105110008',
    districtId: '1105110',
    name: 'Cek Mbon',
  },
  {
    id: '1105110018',
    districtId: '1105110',
    name: 'Seuneubok Pidie',
  },
  {
    id: '1105110019',
    districtId: '1105110',
    name: 'Kuala Leuge',
  },
  {
    id: '1105110020',
    districtId: '1105110',
    name: 'Seuneubok Peusangan',
  },
  {
    id: '1105110023',
    districtId: '1105110',
    name: 'Leubuk Pempeng',
  },
  {
    id: '1105110024',
    districtId: '1105110',
    name: 'Dama Tutong',
  },
  {
    id: '1105110025',
    districtId: '1105110',
    name: 'Bale Buya',
  },
  {
    id: '1105110026',
    districtId: '1105110',
    name: 'Matang Gleum',
  },
  {
    id: '1105110027',
    districtId: '1105110',
    name: 'Alue Nibong',
  },
  {
    id: '1105110028',
    districtId: '1105110',
    name: 'Buket Pala',
  },
  {
    id: '1105110029',
    districtId: '1105110',
    name: 'Blang Simpo',
  },
  {
    id: '1105110030',
    districtId: '1105110',
    name: 'Paya Kalut',
  },
  {
    id: '1105110031',
    districtId: '1105110',
    name: 'Alue Dua Paya Gajah',
  },
  {
    id: '1105110032',
    districtId: '1105110',
    name: 'Seuneubok Aceh',
  },
  {
    id: '1105110033',
    districtId: '1105110',
    name: 'Uteun Dama',
  },
  {
    id: '1105110034',
    districtId: '1105110',
    name: 'Paya Meuligo',
  },
  {
    id: '1105110035',
    districtId: '1105110',
    name: 'Punti',
  },
  {
    id: '1105110036',
    districtId: '1105110',
    name: 'Keumuneng',
  },
  {
    id: '1105110037',
    districtId: '1105110',
    name: 'Bangka Rimueng',
  },
  {
    id: '1105110038',
    districtId: '1105110',
    name: 'Leuge',
  },
  {
    id: '1105110039',
    districtId: '1105110',
    name: 'Lhok Dalam',
  },
  {
    id: '1105110040',
    districtId: '1105110',
    name: 'Bandrong',
  },
  {
    id: '1105110042',
    districtId: '1105110',
    name: 'Tanah Rata',
  },
  {
    id: '1105110043',
    districtId: '1105110',
    name: 'Tualang',
  },
  {
    id: '1105110044',
    districtId: '1105110',
    name: 'Keude Peureulak',
  },
  {
    id: '1105110045',
    districtId: '1105110',
    name: 'Cot Muda Itam',
  },
  {
    id: '1105110046',
    districtId: '1105110',
    name: 'Pasir Putih',
  },
  {
    id: '1105110047',
    districtId: '1105110',
    name: 'Blang Betra',
  },
  {
    id: '1105110055',
    districtId: '1105110',
    name: 'Beusa Meuranou',
  },
  {
    id: '1105110056',
    districtId: '1105110',
    name: 'Seumatang Muda Itam',
  },
  {
    id: '1105110057',
    districtId: '1105110',
    name: 'Blang Balok',
  },
  {
    id: '1105110058',
    districtId: '1105110',
    name: 'Kuala Bugak',
  },
  {
    id: '1105110059',
    districtId: '1105110',
    name: 'Paya Lipah',
  },
  {
    id: '1105110060',
    districtId: '1105110',
    name: 'Cot Geulumpang',
  },
  {
    id: '1105110062',
    districtId: '1105110',
    name: 'Cot Keh',
  },
  {
    id: '1105110063',
    districtId: '1105110',
    name: 'Blang Batee',
  },
  {
    id: '1105110064',
    districtId: '1105110',
    name: 'Alue Rambong',
  },
  {
    id: '1105110065',
    districtId: '1105110',
    name: 'Matang Peulawi',
  },
  {
    id: '1105111001',
    districtId: '1105111',
    name: 'Bukit Meuriam',
  },
  {
    id: '1105111002',
    districtId: '1105111',
    name: 'Seuneubok Punti',
  },
  {
    id: '1105111003',
    districtId: '1105111',
    name: 'Alue Bugeng',
  },
  {
    id: '1105111004',
    districtId: '1105111',
    name: 'Seuneubok Teungoh',
  },
  {
    id: '1105111005',
    districtId: '1105111',
    name: 'Seuneubok Teupin',
  },
  {
    id: '1105111006',
    districtId: '1105111',
    name: 'Alue Bu/Alue Lhok',
  },
  {
    id: '1105111007',
    districtId: '1105111',
    name: 'Alue Gurep',
  },
  {
    id: '1105111008',
    districtId: '1105111',
    name: 'Alue Bu Alue Nireh',
  },
  {
    id: '1105111009',
    districtId: '1105111',
    name: 'Seuneubok Paya',
  },
  {
    id: '1105111010',
    districtId: '1105111',
    name: 'Seuneubok Rawang',
  },
  {
    id: '1105111011',
    districtId: '1105111',
    name: 'Alue Tho',
  },
  {
    id: '1105111012',
    districtId: '1105111',
    name: 'Seuneubok Lapang',
  },
  {
    id: '1105111013',
    districtId: '1105111',
    name: 'Seuneubok Jalan',
  },
  {
    id: '1105111014',
    districtId: '1105111',
    name: 'Geulanggang Merak',
  },
  {
    id: '1105111015',
    districtId: '1105111',
    name: 'Seumatang Keude',
  },
  {
    id: '1105111016',
    districtId: '1105111',
    name: 'Babah Krueng',
  },
  {
    id: '1105111017',
    districtId: '1105111',
    name: 'Krut Lintang',
  },
  {
    id: '1105111018',
    districtId: '1105111',
    name: 'Jeungki',
  },
  {
    id: '1105111019',
    districtId: '1105111',
    name: 'Seuneubok Dalam',
  },
  {
    id: '1105111020',
    districtId: '1105111',
    name: 'Tualang Pateng',
  },
  {
    id: '1105112001',
    districtId: '1105112',
    name: 'Kabu',
  },
  {
    id: '1105112002',
    districtId: '1105112',
    name: 'Beuringin',
  },
  {
    id: '1105112003',
    districtId: '1105112',
    name: 'Teumpeun',
  },
  {
    id: '1105112004',
    districtId: '1105112',
    name: 'Kebun Teumpeun',
  },
  {
    id: '1105112005',
    districtId: '1105112',
    name: 'Paya Seungat',
  },
  {
    id: '1105112006',
    districtId: '1105112',
    name: 'Tanjung Tualang',
  },
  {
    id: '1105112007',
    districtId: '1105112',
    name: 'Beusa Seberang',
  },
  {
    id: '1105112008',
    districtId: '1105112',
    name: 'Paya Gajah',
  },
  {
    id: '1105112009',
    districtId: '1105112',
    name: 'Mon Geudong',
  },
  {
    id: '1105112010',
    districtId: '1105112',
    name: 'Alue Bu Tuha',
  },
  {
    id: '1105112011',
    districtId: '1105112',
    name: 'Alue Bu Jalan',
  },
  {
    id: '1105112012',
    districtId: '1105112',
    name: 'Paya Biek',
  },
  {
    id: '1105112013',
    districtId: '1105112',
    name: 'Beusa Baroh',
  },
  {
    id: '1105112014',
    districtId: '1105112',
    name: 'Alue Bu Tunong',
  },
  {
    id: '1105112015',
    districtId: '1105112',
    name: 'Alue Bu Jalan Baroh',
  },
  {
    id: '1105120001',
    districtId: '1105120',
    name: 'Beurandang',
  },
  {
    id: '1105120002',
    districtId: '1105120',
    name: 'Alue Geunteng',
  },
  {
    id: '1105120003',
    districtId: '1105120',
    name: 'Kliet',
  },
  {
    id: '1105120004',
    districtId: '1105120',
    name: 'Gampong Tampak',
  },
  {
    id: '1105120005',
    districtId: '1105120',
    name: 'Paya Palas',
  },
  {
    id: '1105120006',
    districtId: '1105120',
    name: 'Alue Batee',
  },
  {
    id: '1105120007',
    districtId: '1105120',
    name: 'Bhom Lama',
  },
  {
    id: '1105120008',
    districtId: '1105120',
    name: 'Pasir Putih',
  },
  {
    id: '1105120009',
    districtId: '1105120',
    name: 'Alue Dua',
  },
  {
    id: '1105120010',
    districtId: '1105120',
    name: 'Buket Pala Bsp',
  },
  {
    id: '1105120011',
    districtId: '1105120',
    name: 'Punti Payong',
  },
  {
    id: '1105120012',
    districtId: '1105120',
    name: 'Seumaly',
  },
  {
    id: '1105120013',
    districtId: '1105120',
    name: 'Kp. Pertamina',
  },
  {
    id: '1105120014',
    districtId: '1105120',
    name: 'Blang Barom',
  },
  {
    id: '1105120015',
    districtId: '1105120',
    name: 'Pulo Blang',
  },
  {
    id: '1105120016',
    districtId: '1105120',
    name: 'Snb Johan',
  },
  {
    id: '1105120017',
    districtId: '1105120',
    name: 'Paya Unou',
  },
  {
    id: '1105120018',
    districtId: '1105120',
    name: 'Snb Baro',
  },
  {
    id: '1105120019',
    districtId: '1105120',
    name: 'Snb Dalam',
  },
  {
    id: '1105120020',
    districtId: '1105120',
    name: 'Seulemak Muda',
  },
  {
    id: '1105120021',
    districtId: '1105120',
    name: 'Mata Ie',
  },
  {
    id: '1105120022',
    districtId: '1105120',
    name: 'Alue Udep',
  },
  {
    id: '1105120023',
    districtId: '1105120',
    name: 'Seumanah Jaya',
  },
  {
    id: '1105130042',
    districtId: '1105130',
    name: 'Dama Pulo',
  },
  {
    id: '1105130043',
    districtId: '1105130',
    name: 'Gureb Blang',
  },
  {
    id: '1105130044',
    districtId: '1105130',
    name: 'Seuneubok Tutong',
  },
  {
    id: '1105130045',
    districtId: '1105130',
    name: 'Sam Pai Mah',
  },
  {
    id: '1105130046',
    districtId: '1105130',
    name: 'Seuneubok Tuha',
  },
  {
    id: '1105130047',
    districtId: '1105130',
    name: 'Buket Langa',
  },
  {
    id: '1105130048',
    districtId: '1105130',
    name: 'Buket Juara',
  },
  {
    id: '1105130049',
    districtId: '1105130',
    name: 'Buket Pala',
  },
  {
    id: '1105130050',
    districtId: '1105130',
    name: 'Meunasah Puuk',
  },
  {
    id: '1105130051',
    districtId: '1105130',
    name: 'Keude Blang',
  },
  {
    id: '1105130078',
    districtId: '1105130',
    name: 'Bantayan Timur',
  },
  {
    id: '1105130079',
    districtId: '1105130',
    name: 'Gampong Aceh',
  },
  {
    id: '1105130080',
    districtId: '1105130',
    name: 'Keude Aceh',
  },
  {
    id: '1105130081',
    districtId: '1105130',
    name: 'Kuta Blang',
  },
  {
    id: '1105130083',
    districtId: '1105130',
    name: 'Seuneubok Bacee',
  },
  {
    id: '1105130084',
    districtId: '1105130',
    name: 'Titi Baro',
  },
  {
    id: '1105130103',
    districtId: '1105130',
    name: 'Seuneubok Teungoh (Pr)',
  },
  {
    id: '1105130104',
    districtId: '1105130',
    name: 'Seuneubok Rambong',
  },
  {
    id: '1105130105',
    districtId: '1105130',
    name: 'Tanoh Anou',
  },
  {
    id: '1105130106',
    districtId: '1105130',
    name: 'Kampung Tanjong',
  },
  {
    id: '1105130107',
    districtId: '1105130',
    name: 'Kuala Pd Puntong',
  },
  {
    id: '1105130108',
    districtId: '1105130',
    name: 'Kampung Jawa',
  },
  {
    id: '1105130109',
    districtId: '1105130',
    name: 'Blang Geulumpang',
  },
  {
    id: '1105130111',
    districtId: '1105130',
    name: 'Gampong Jalan',
  },
  {
    id: '1105130112',
    districtId: '1105130',
    name: 'Buket Meulinteung',
  },
  {
    id: '1105130113',
    districtId: '1105130',
    name: 'Buket Jok',
  },
  {
    id: '1105130114',
    districtId: '1105130',
    name: 'Teupin Batee',
  },
  {
    id: '1105130115',
    districtId: '1105130',
    name: 'Alue Dua Muka S',
  },
  {
    id: '1105130116',
    districtId: '1105130',
    name: 'Tanjong Kapai',
  },
  {
    id: '1105130117',
    districtId: '1105130',
    name: 'Gampong Baro',
  },
  {
    id: '1105130118',
    districtId: '1105130',
    name: 'Kuala Idi',
  },
  {
    id: '1105130119',
    districtId: '1105130',
    name: 'Keutapang Mameh',
  },
  {
    id: '1105130120',
    districtId: '1105130',
    name: 'Ulee Blang',
  },
  {
    id: '1105130121',
    districtId: '1105130',
    name: 'Alue Dua Muka 0',
  },
  {
    id: '1105130122',
    districtId: '1105130',
    name: 'Kuta Lawah',
  },
  {
    id: '1105131001',
    districtId: '1105131',
    name: 'Asan Rampak',
  },
  {
    id: '1105131002',
    districtId: '1105131',
    name: 'Buket Kuta',
  },
  {
    id: '1105131003',
    districtId: '1105131',
    name: 'Blang Kuta',
  },
  {
    id: '1105131004',
    districtId: '1105131',
    name: 'Alue Batee',
  },
  {
    id: '1105131005',
    districtId: '1105131',
    name: 'Paya Bili I',
  },
  {
    id: '1105131006',
    districtId: '1105131',
    name: 'Blang Buket',
  },
  {
    id: '1105131007',
    districtId: '1105131',
    name: 'Kuta Baro',
  },
  {
    id: '1105131008',
    districtId: '1105131',
    name: 'Seuneubok Teungoh',
  },
  {
    id: '1105131009',
    districtId: '1105131',
    name: 'Seuneubok Punteut',
  },
  {
    id: '1105131010',
    districtId: '1105131',
    name: 'Sama Dua',
  },
  {
    id: '1105131011',
    districtId: '1105131',
    name: 'Kampung Keude',
  },
  {
    id: '1105131012',
    districtId: '1105131',
    name: 'Meunasah Krueng',
  },
  {
    id: '1105131013',
    districtId: '1105131',
    name: 'Paya Bili Dua',
  },
  {
    id: '1105131014',
    districtId: '1105131',
    name: 'Paya Dua',
  },
  {
    id: '1105131015',
    districtId: '1105131',
    name: 'Kampung Kuala',
  },
  {
    id: '1105131016',
    districtId: '1105131',
    name: 'Alue Ie Itam',
  },
  {
    id: '1105131017',
    districtId: '1105131',
    name: 'Matang Rayeuk',
  },
  {
    id: '1105132001',
    districtId: '1105132',
    name: 'Seuneubok Bayu',
  },
  {
    id: '1105132002',
    districtId: '1105132',
    name: 'Jambo Reuhat',
  },
  {
    id: '1105132003',
    districtId: '1105132',
    name: 'Blang Rambong',
  },
  {
    id: '1105132004',
    districtId: '1105132',
    name: 'Ulee Jalan',
  },
  {
    id: '1105132005',
    districtId: '1105132',
    name: 'Seuneubok Kandang',
  },
  {
    id: '1105132006',
    districtId: '1105132',
    name: 'Seuneubok Benteng',
  },
  {
    id: '1105132007',
    districtId: '1105132',
    name: 'Seuneubok Pangou',
  },
  {
    id: '1105132008',
    districtId: '1105132',
    name: 'Uram Jalan',
  },
  {
    id: '1105132009',
    districtId: '1105132',
    name: 'Jalan Dua',
  },
  {
    id: '1105132010',
    districtId: '1105132',
    name: 'Panton Rayeuk T',
  },
  {
    id: '1105132011',
    districtId: '1105132',
    name: 'Panton Rayeuk A',
  },
  {
    id: '1105132012',
    districtId: '1105132',
    name: 'Panton Rayeuk B',
  },
  {
    id: '1105132013',
    districtId: '1105132',
    name: 'Panton Rayeuk M',
  },
  {
    id: '1105132014',
    districtId: '1105132',
    name: 'Buket Drien',
  },
  {
    id: '1105132015',
    districtId: '1105132',
    name: 'Paya Laman',
  },
  {
    id: '1105132016',
    districtId: '1105132',
    name: 'Seuneubok Simpang',
  },
  {
    id: '1105133001',
    districtId: '1105133',
    name: 'Alue Lhok',
  },
  {
    id: '1105133002',
    districtId: '1105133',
    name: 'Padang Kasah',
  },
  {
    id: '1105133003',
    districtId: '1105133',
    name: 'Seuneubok Buya',
  },
  {
    id: '1105133004',
    districtId: '1105133',
    name: 'Paya Awe',
  },
  {
    id: '1105133005',
    districtId: '1105133',
    name: 'Paya Gaboh',
  },
  {
    id: '1105133006',
    districtId: '1105133',
    name: 'Seuneubok Drien',
  },
  {
    id: '1105133007',
    districtId: '1105133',
    name: 'Keude Keumuneng',
  },
  {
    id: '1105133008',
    districtId: '1105133',
    name: 'Gampong Keumuning',
  },
  {
    id: '1105133009',
    districtId: '1105133',
    name: 'Seuneubok Meurudu',
  },
  {
    id: '1105133010',
    districtId: '1105133',
    name: 'Seuneubok Punti',
  },
  {
    id: '1105133011',
    districtId: '1105133',
    name: 'Seuneubok Dalam',
  },
  {
    id: '1105133012',
    districtId: '1105133',
    name: 'Seuneubok Jalan',
  },
  {
    id: '1105133013',
    districtId: '1105133',
    name: 'Buket Teukuh',
  },
  {
    id: '1105133014',
    districtId: '1105133',
    name: 'Keumuning Lhok',
  },
  {
    id: '1105133015',
    districtId: '1105133',
    name: 'Buket Rumiya',
  },
  {
    id: '1105133016',
    districtId: '1105133',
    name: 'Alue Kumbang M',
  },
  {
    id: '1105133017',
    districtId: '1105133',
    name: 'Alue Kumbang A',
  },
  {
    id: '1105133018',
    districtId: '1105133',
    name: 'Seuneubok Baro',
  },
  {
    id: '1105133019',
    districtId: '1105133',
    name: 'Buket Puuk',
  },
  {
    id: '1105133020',
    districtId: '1105133',
    name: 'Seuneubok Buloh',
  },
  {
    id: '1105133021',
    districtId: '1105133',
    name: 'Blang Minjei',
  },
  {
    id: '1105133022',
    districtId: '1105133',
    name: 'Blang Seguci',
  },
  {
    id: '1105133023',
    districtId: '1105133',
    name: 'Bantayan Barat',
  },
  {
    id: '1105133024',
    districtId: '1105133',
    name: 'Seuneubok Teupin Panah',
  },
  {
    id: '1105133025',
    districtId: '1105133',
    name: 'Teupin Panah',
  },
  {
    id: '1105134001',
    districtId: '1105134',
    name: 'Seuneubok Aceh Baro',
  },
  {
    id: '1105134002',
    districtId: '1105134',
    name: 'Lhok Leumak',
  },
  {
    id: '1105134003',
    districtId: '1105134',
    name: 'Seuneubok Teungoh (Kd II)',
  },
  {
    id: '1105134004',
    districtId: '1105134',
    name: 'Meunasah Aron',
  },
  {
    id: '1105134005',
    districtId: '1105134',
    name: 'Lhok Dalam',
  },
  {
    id: '1105134006',
    districtId: '1105134',
    name: 'Lhok Meureu',
  },
  {
    id: '1105134007',
    districtId: '1105134',
    name: 'Pt. Meureubo',
  },
  {
    id: '1105134008',
    districtId: '1105134',
    name: 'Khok Panjou',
  },
  {
    id: '1105134009',
    districtId: '1105134',
    name: 'Alue Jangat',
  },
  {
    id: '1105134010',
    districtId: '1105134',
    name: 'Medang Ara',
  },
  {
    id: '1105134011',
    districtId: '1105134',
    name: 'Seuneubok Kulam',
  },
  {
    id: '1105134012',
    districtId: '1105134',
    name: 'Gunong Putoh',
  },
  {
    id: '1105134013',
    districtId: '1105134',
    name: 'Seuneubok Lapang',
  },
  {
    id: '1105134014',
    districtId: '1105134',
    name: 'Keude Dua',
  },
  {
    id: '1105134015',
    districtId: '1105134',
    name: 'Buket Peulawi',
  },
  {
    id: '1105134016',
    districtId: '1105134',
    name: 'Pulo Blang',
  },
  {
    id: '1105135001',
    districtId: '1105135',
    name: 'Ketapang Dua',
  },
  {
    id: '1105135002',
    districtId: '1105135',
    name: 'Matang Rayeuk (Smk)',
  },
  {
    id: '1105135003',
    districtId: '1105135',
    name: 'Menunasah Jeumpa',
  },
  {
    id: '1105135004',
    districtId: '1105135',
    name: 'Lhok Asahan',
  },
  {
    id: '1105135005',
    districtId: '1105135',
    name: 'Tualang Dalam',
  },
  {
    id: '1105135006',
    districtId: '1105135',
    name: 'Seuneubok Kuyun',
  },
  {
    id: '1105135007',
    districtId: '1105135',
    name: 'Ulee Gle',
  },
  {
    id: '1105135008',
    districtId: '1105135',
    name: 'Seuneubok Barat',
  },
  {
    id: '1105135009',
    districtId: '1105135',
    name: 'Seuneubok Teungoh (Smk)',
  },
  {
    id: '1105135010',
    districtId: '1105135',
    name: 'Seuneubok Timur',
  },
  {
    id: '1105135011',
    districtId: '1105135',
    name: 'Matang Bungong',
  },
  {
    id: '1105135012',
    districtId: '1105135',
    name: 'Matang Rayeuk (Pr)',
  },
  {
    id: '1105135013',
    districtId: '1105135',
    name: 'Seuneubok Dalam (Smk)',
  },
  {
    id: '1105140001',
    districtId: '1105140',
    name: 'Seuneubok Simpang',
  },
  {
    id: '1105140002',
    districtId: '1105140',
    name: 'Alur Lhok',
  },
  {
    id: '1105140003',
    districtId: '1105140',
    name: 'Alur Merbo',
  },
  {
    id: '1105140004',
    districtId: '1105140',
    name: 'Meunasah Keutapang',
  },
  {
    id: '1105140005',
    districtId: '1105140',
    name: 'Alue Dalam',
  },
  {
    id: '1105140006',
    districtId: '1105140',
    name: 'Dama Polo II',
  },
  {
    id: '1105140007',
    districtId: '1105140',
    name: 'Alur Ludin II',
  },
  {
    id: '1105140008',
    districtId: '1105140',
    name: 'Jungka Gajah',
  },
  {
    id: '1105140009',
    districtId: '1105140',
    name: 'Buket Rumiya',
  },
  {
    id: '1105140010',
    districtId: '1105140',
    name: 'Buket Raya',
  },
  {
    id: '1105140011',
    districtId: '1105140',
    name: 'Gaseh Sayang',
  },
  {
    id: '1105140012',
    districtId: '1105140',
    name: 'Seuneubok Buloh',
  },
  {
    id: '1105140013',
    districtId: '1105140',
    name: 'Kapai Baro',
  },
  {
    id: '1105140014',
    districtId: '1105140',
    name: 'Kemuning I',
  },
  {
    id: '1105140015',
    districtId: '1105140',
    name: 'Seuneubok Tuha I',
  },
  {
    id: '1105140016',
    districtId: '1105140',
    name: 'Alue Gadeng',
  },
  {
    id: '1105140017',
    districtId: '1105140',
    name: 'Trieng Gadeng',
  },
  {
    id: '1105140018',
    districtId: '1105140',
    name: 'Buket Kulam',
  },
  {
    id: '1105140019',
    districtId: '1105140',
    name: 'Seuneubok Teungoh',
  },
  {
    id: '1105140020',
    districtId: '1105140',
    name: 'Dama Pulo I',
  },
  {
    id: '1105140021',
    districtId: '1105140',
    name: 'Kampung Beunot',
  },
  {
    id: '1105140022',
    districtId: '1105140',
    name: 'Teupin Drum',
  },
  {
    id: '1105140023',
    districtId: '1105140',
    name: 'Kuala Idi Cut',
  },
  {
    id: '1105140024',
    districtId: '1105140',
    name: 'Kampung Baro',
  },
  {
    id: '1105140025',
    districtId: '1105140',
    name: 'Alur Ludin I',
  },
  {
    id: '1105140026',
    districtId: '1105140',
    name: 'Lhok Geulumpang',
  },
  {
    id: '1105140027',
    districtId: '1105140',
    name: 'Blang Buket',
  },
  {
    id: '1105140028',
    districtId: '1105140',
    name: 'Seuneubok Tuha II',
  },
  {
    id: '1105140029',
    districtId: '1105140',
    name: 'Kemuning II',
  },
  {
    id: '1105140030',
    districtId: '1105140',
    name: 'Buket Tualang',
  },
  {
    id: '1105140031',
    districtId: '1105140',
    name: 'Bagok Panah IV',
  },
  {
    id: '1105140032',
    districtId: '1105140',
    name: 'Bagok Panah III',
  },
  {
    id: '1105140033',
    districtId: '1105140',
    name: 'Kemuning  V',
  },
  {
    id: '1105140034',
    districtId: '1105140',
    name: 'Kemuning III',
  },
  {
    id: '1105140035',
    districtId: '1105140',
    name: 'Kemuning IV',
  },
  {
    id: '1105140036',
    districtId: '1105140',
    name: 'Grong-Grong',
  },
  {
    id: '1105140037',
    districtId: '1105140',
    name: 'Kampung Keude',
  },
  {
    id: '1105140038',
    districtId: '1105140',
    name: 'Keude Idi Cut',
  },
  {
    id: '1105140039',
    districtId: '1105140',
    name: 'Seuneubok Baroh',
  },
  {
    id: '1105140040',
    districtId: '1105140',
    name: 'Meunasah Blang',
  },
  {
    id: '1105140041',
    districtId: '1105140',
    name: 'Seuneubok Aceh',
  },
  {
    id: '1105140042',
    districtId: '1105140',
    name: 'Matang Geutou',
  },
  {
    id: '1105140043',
    districtId: '1105140',
    name: 'Matang Pineung',
  },
  {
    id: '1105140044',
    districtId: '1105140',
    name: 'Bagok Panah I',
  },
  {
    id: '1105140045',
    districtId: '1105140',
    name: 'Bagok Panah II',
  },
  {
    id: '1105150001',
    districtId: '1105150',
    name: 'Alue Siwah Serdang',
  },
  {
    id: '1105150002',
    districtId: '1105150',
    name: 'Gampong Lhee',
  },
  {
    id: '1105150003',
    districtId: '1105150',
    name: 'Beurandang',
  },
  {
    id: '1105150005',
    districtId: '1105150',
    name: 'Seuneubok Rambong',
  },
  {
    id: '1105150006',
    districtId: '1105150',
    name: 'Gampung Jalan',
  },
  {
    id: '1105150008',
    districtId: '1105150',
    name: 'Buket Meurak',
  },
  {
    id: '1105150009',
    districtId: '1105150',
    name: 'Seuneubok Dalam',
  },
  {
    id: '1105150010',
    districtId: '1105150',
    name: 'Kampung Mesjid',
  },
  {
    id: '1105150011',
    districtId: '1105150',
    name: 'Paya Enjee',
  },
  {
    id: '1105150012',
    districtId: '1105150',
    name: 'Seuleumak Muda',
  },
  {
    id: '1105150013',
    districtId: '1105150',
    name: 'Cot Asan',
  },
  {
    id: '1105150014',
    districtId: '1105150',
    name: 'Buket Panyang',
  },
  {
    id: '1105150023',
    districtId: '1105150',
    name: 'Buket Panjou',
  },
  {
    id: '1105150024',
    districtId: '1105150',
    name: 'Matang Panyang',
  },
  {
    id: '1105150025',
    districtId: '1105150',
    name: 'Meunasah Hagu',
  },
  {
    id: '1105150026',
    districtId: '1105150',
    name: 'Matang Kunyet',
  },
  {
    id: '1105150027',
    districtId: '1105150',
    name: 'Matang Neuheun',
  },
  {
    id: '1105150028',
    districtId: '1105150',
    name: 'Teupin Pukat',
  },
  {
    id: '1105150029',
    districtId: '1105150',
    name: 'Pulo-U',
  },
  {
    id: '1105150030',
    districtId: '1105150',
    name: 'Matang Seuleumak',
  },
  {
    id: '1105150031',
    districtId: '1105150',
    name: 'Bantayan',
  },
  {
    id: '1105150032',
    districtId: '1105150',
    name: 'Blang Panjou',
  },
  {
    id: '1105150034',
    districtId: '1105150',
    name: 'Seumatang Aron',
  },
  {
    id: '1105150035',
    districtId: '1105150',
    name: 'Meudang Ara',
  },
  {
    id: '1105150036',
    districtId: '1105150',
    name: 'Meunasah Teungoh',
  },
  {
    id: '1105150037',
    districtId: '1105150',
    name: 'Kampung Keude Bagok Dua',
  },
  {
    id: '1105150038',
    districtId: '1105150',
    name: 'Kampung Keude Bagok Sa',
  },
  {
    id: '1105150039',
    districtId: '1105150',
    name: 'Kuala Bagok',
  },
  {
    id: '1105150040',
    districtId: '1105150',
    name: 'Asan Tanjung',
  },
  {
    id: '1105150041',
    districtId: '1105150',
    name: 'Baroh Bugeng',
  },
  {
    id: '1105150042',
    districtId: '1105150',
    name: 'Peulawi',
  },
  {
    id: '1105151001',
    districtId: '1105151',
    name: 'Tunong Bugeng',
  },
  {
    id: '1105151002',
    districtId: '1105151',
    name: 'Gampong Cempeudak',
  },
  {
    id: '1105151003',
    districtId: '1105151',
    name: 'Buket Tufah',
  },
  {
    id: '1105151004',
    districtId: '1105151',
    name: 'Tunong Ulee Gajah',
  },
  {
    id: '1105151005',
    districtId: '1105151',
    name: 'Keudondong',
  },
  {
    id: '1105151006',
    districtId: '1105151',
    name: 'Seuneubok Panton',
  },
  {
    id: '1105151007',
    districtId: '1105151',
    name: 'Buket Teumpen',
  },
  {
    id: '1105151008',
    districtId: '1105151',
    name: 'Keude Blang',
  },
  {
    id: '1105151009',
    districtId: '1105151',
    name: 'Paya Kreub',
  },
  {
    id: '1105151010',
    districtId: '1105151',
    name: 'Tunong Paya Kreub',
  },
  {
    id: '1105151011',
    districtId: '1105151',
    name: 'Alue Siwah Dua',
  },
  {
    id: '1105160006',
    districtId: '1105160',
    name: 'Keumuneng',
  },
  {
    id: '1105160007',
    districtId: '1105160',
    name: 'Ladang Baro',
  },
  {
    id: '1105160008',
    districtId: '1105160',
    name: 'Seuneubok Baro',
  },
  {
    id: '1105160009',
    districtId: '1105160',
    name: 'Seuneubok Rambong',
  },
  {
    id: '1105160010',
    districtId: '1105160',
    name: 'Teupin Raya',
  },
  {
    id: '1105160011',
    districtId: '1105160',
    name: 'Buket Panyang',
  },
  {
    id: '1105160012',
    districtId: '1105160',
    name: 'Blang Keumuhang',
  },
  {
    id: '1105160013',
    districtId: '1105160',
    name: 'Bukit Makmur',
  },
  {
    id: '1105160014',
    districtId: '1105160',
    name: 'Buket Dindeng',
  },
  {
    id: '1105160015',
    districtId: '1105160',
    name: 'Lhok Rambong',
  },
  {
    id: '1105160016',
    districtId: '1105160',
    name: 'Blang Mideun',
  },
  {
    id: '1105160017',
    districtId: '1105160',
    name: 'Blang Jambee',
  },
  {
    id: '1105160018',
    districtId: '1105160',
    name: 'Paya Bakong',
  },
  {
    id: '1105160019',
    districtId: '1105160',
    name: 'Buket Seraja',
  },
  {
    id: '1105160020',
    districtId: '1105160',
    name: 'Blang Paoh Satu',
  },
  {
    id: '1105160021',
    districtId: '1105160',
    name: 'Ulee Ateung',
  },
  {
    id: '1105160022',
    districtId: '1105160',
    name: 'Mane Rampak',
  },
  {
    id: '1105160023',
    districtId: '1105160',
    name: 'Ujong Tunong',
  },
  {
    id: '1105160024',
    districtId: '1105160',
    name: 'Paya Pasi',
  },
  {
    id: '1105160025',
    districtId: '1105160',
    name: 'Blang Gleum',
  },
  {
    id: '1105160026',
    districtId: '1105160',
    name: 'Alue Cek Doy',
  },
  {
    id: '1105160027',
    districtId: '1105160',
    name: 'Tumpok Teungoh',
  },
  {
    id: '1105160028',
    districtId: '1105160',
    name: 'Matang',
  },
  {
    id: '1105160029',
    districtId: '1105160',
    name: 'Julok Tunong',
  },
  {
    id: '1105160030',
    districtId: '1105160',
    name: 'Blang Paoh Dua',
  },
  {
    id: '1105160031',
    districtId: '1105160',
    name: 'Keude Kuta Binjai',
  },
  {
    id: '1105160032',
    districtId: '1105160',
    name: 'Ulee Tanoh',
  },
  {
    id: '1105160033',
    districtId: '1105160',
    name: 'Kuala Geulumpang',
  },
  {
    id: '1105160034',
    districtId: '1105160',
    name: 'Blang Uyok',
  },
  {
    id: '1105160035',
    districtId: '1105160',
    name: 'Ulee Blang',
  },
  {
    id: '1105160036',
    districtId: '1105160',
    name: 'Naleung',
  },
  {
    id: '1105160037',
    districtId: '1105160',
    name: 'Labohan',
  },
  {
    id: '1105160038',
    districtId: '1105160',
    name: 'Gampong Baro',
  },
  {
    id: '1105160039',
    districtId: '1105160',
    name: 'Seumatang',
  },
  {
    id: '1105160040',
    districtId: '1105160',
    name: 'Tanjong Tok Blang',
  },
  {
    id: '1105160041',
    districtId: '1105160',
    name: 'Simpang Lhee',
  },
  {
    id: '1105160042',
    districtId: '1105160',
    name: 'Lhok Seuntang',
  },
  {
    id: '1105161001',
    districtId: '1105161',
    name: 'Alue Ie Itam',
  },
  {
    id: '1105161002',
    districtId: '1105161',
    name: 'Seuneubok Bayu',
  },
  {
    id: '1105161003',
    districtId: '1105161',
    name: 'Blang Nisam',
  },
  {
    id: '1105161004',
    districtId: '1105161',
    name: 'Bandar Baro',
  },
  {
    id: '1105161005',
    districtId: '1105161',
    name: 'Alue Patong',
  },
  {
    id: '1105161006',
    districtId: '1105161',
    name: 'Seuneubok Cina',
  },
  {
    id: '1105161007',
    districtId: '1105161',
    name: 'Pelita Sagup Jaya',
  },
  {
    id: '1105161008',
    districtId: '1105161',
    name: 'Perk Julok Rayeuk Utara',
  },
  {
    id: '1105161009',
    districtId: '1105161',
    name: 'Perk Julok Rayeuk Selatan',
  },
  {
    id: '1105161010',
    districtId: '1105161',
    name: 'Jambo Balee',
  },
  {
    id: '1105161011',
    districtId: '1105161',
    name: 'Alue Ie Mirah',
  },
  {
    id: '1105161012',
    districtId: '1105161',
    name: 'Jambo Lubok',
  },
  {
    id: '1105161013',
    districtId: '1105161',
    name: 'Suka Makmur',
  },
  {
    id: '1105170001',
    districtId: '1105170',
    name: 'Blang Seunong',
  },
  {
    id: '1105170002',
    districtId: '1105170',
    name: 'Pante Labu',
  },
  {
    id: '1105170003',
    districtId: '1105170',
    name: 'Pante Rambong',
  },
  {
    id: '1105170004',
    districtId: '1105170',
    name: 'Alue Ie Mirah',
  },
  {
    id: '1105170005',
    districtId: '1105170',
    name: 'Seuneubok Tuha',
  },
  {
    id: '1105170006',
    districtId: '1105170',
    name: 'Seuneubok Saboh',
  },
  {
    id: '1105170007',
    districtId: '1105170',
    name: 'Buket Kareng',
  },
  {
    id: '1105170008',
    districtId: '1105170',
    name: 'Buket Bata',
  },
  {
    id: '1105170009',
    districtId: '1105170',
    name: 'Grong Grong',
  },
  {
    id: '1105170010',
    districtId: '1105170',
    name: 'Meunasah Tunong',
  },
  {
    id: '1105170011',
    districtId: '1105170',
    name: 'Matang Peureulak',
  },
  {
    id: '1105170012',
    districtId: '1105170',
    name: 'Meunasah Leubok',
  },
  {
    id: '1105170013',
    districtId: '1105170',
    name: 'Meunasah Teungoh',
  },
  {
    id: '1105170014',
    districtId: '1105170',
    name: 'Keude Baro',
  },
  {
    id: '1105170015',
    districtId: '1105170',
    name: 'Pante Panah',
  },
  {
    id: '1105170016',
    districtId: '1105170',
    name: 'Matang Pudeng',
  },
  {
    id: '1105170017',
    districtId: '1105170',
    name: 'Gampong Putoh Dua',
  },
  {
    id: '1105170018',
    districtId: '1105170',
    name: 'Matang Kruet',
  },
  {
    id: '1105170019',
    districtId: '1105170',
    name: 'Paya Deumam Satu',
  },
  {
    id: '1105170020',
    districtId: '1105170',
    name: 'Paya Deumam Lhee',
  },
  {
    id: '1105170021',
    districtId: '1105170',
    name: 'Paya Deumam Dua',
  },
  {
    id: '1105170022',
    districtId: '1105170',
    name: 'Putoh Satu',
  },
  {
    id: '1105170023',
    districtId: '1105170',
    name: 'Suka Damai',
  },
  {
    id: '1105170024',
    districtId: '1105170',
    name: 'Sah Raja',
  },
  {
    id: '1105170025',
    districtId: '1105170',
    name: 'Sijudo',
  },
  {
    id: '1105180003',
    districtId: '1105180',
    name: 'Matang Weng',
  },
  {
    id: '1105180005',
    districtId: '1105180',
    name: 'Alue Mulieng',
  },
  {
    id: '1105180009',
    districtId: '1105180',
    name: 'Pucok Alue Barat',
  },
  {
    id: '1105180010',
    districtId: '1105180',
    name: 'Pucok Alue Satu',
  },
  {
    id: '1105180011',
    districtId: '1105180',
    name: 'Matang Kumbang',
  },
  {
    id: '1105180012',
    districtId: '1105180',
    name: 'Titi Baroeh',
  },
  {
    id: '1105180013',
    districtId: '1105180',
    name: 'Ara Kundo',
  },
  {
    id: '1105180014',
    districtId: '1105180',
    name: 'Alue Buloh Dua',
  },
  {
    id: '1105180015',
    districtId: '1105180',
    name: 'Matang Rayeuk',
  },
  {
    id: '1105180016',
    districtId: '1105180',
    name: 'Teupin Breuh',
  },
  {
    id: '1105180017',
    districtId: '1105180',
    name: 'Blang Me',
  },
  {
    id: '1105180018',
    districtId: '1105180',
    name: 'Pucok Alue Dua',
  },
  {
    id: '1105180019',
    districtId: '1105180',
    name: 'Peulalu',
  },
  {
    id: '1105180023',
    districtId: '1105180',
    name: 'Alue Buloh Satu',
  },
  {
    id: '1105180024',
    districtId: '1105180',
    name: 'Kuala Simpang Ulim',
  },
  {
    id: '1105180025',
    districtId: '1105180',
    name: 'Kampong Baro',
  },
  {
    id: '1105180026',
    districtId: '1105180',
    name: 'Nicah Awe',
  },
  {
    id: '1105180027',
    districtId: '1105180',
    name: 'Bantayan',
  },
  {
    id: '1105180028',
    districtId: '1105180',
    name: 'Keude Tuha',
  },
  {
    id: '1105180030',
    districtId: '1105180',
    name: 'Gampong Blang',
  },
  {
    id: '1105180031',
    districtId: '1105180',
    name: 'Lampuh Rayeuk',
  },
  {
    id: '1105180033',
    districtId: '1105180',
    name: 'Teupin Mamplam',
  },
  {
    id: '1105180034',
    districtId: '1105180',
    name: 'Matang Seupeng',
  },
  {
    id: '1105181001',
    districtId: '1105181',
    name: 'Paya Deumam Peut',
  },
  {
    id: '1105181002',
    districtId: '1105181',
    name: 'Paya Naden',
  },
  {
    id: '1105181003',
    districtId: '1105181',
    name: 'Tanjung Ara',
  },
  {
    id: '1105181004',
    districtId: '1105181',
    name: 'Tanjung Minjei',
  },
  {
    id: '1105181005',
    districtId: '1105181',
    name: 'Seuneubok Pidie',
  },
  {
    id: '1105181006',
    districtId: '1105181',
    name: 'Rambong Lop',
  },
  {
    id: '1105181007',
    districtId: '1105181',
    name: 'Matang Jrok',
  },
  {
    id: '1105181008',
    districtId: '1105181',
    name: 'Matang Nibong',
  },
  {
    id: '1105181009',
    districtId: '1105181',
    name: 'Madat',
  },
  {
    id: '1105181010',
    districtId: '1105181',
    name: 'Abeuk Geulanteu',
  },
  {
    id: '1105181011',
    districtId: '1105181',
    name: 'Matang Keupula Satu',
  },
  {
    id: '1105181012',
    districtId: '1105181',
    name: 'Ulee Ateung',
  },
  {
    id: '1105181013',
    districtId: '1105181',
    name: 'Blang Andam',
  },
  {
    id: '1105181014',
    districtId: '1105181',
    name: 'Bintah',
  },
  {
    id: '1105181015',
    districtId: '1105181',
    name: 'Blang Awe',
  },
  {
    id: '1105181016',
    districtId: '1105181',
    name: 'Pante Meureubo',
  },
  {
    id: '1105181017',
    districtId: '1105181',
    name: 'Lueng Satu',
  },
  {
    id: '1105181018',
    districtId: '1105181',
    name: 'Matang Keupula Lhee',
  },
  {
    id: '1105181019',
    districtId: '1105181',
    name: 'Matang Keupula Dua',
  },
  {
    id: '1105181020',
    districtId: '1105181',
    name: 'Blang Ubit',
  },
  {
    id: '1105181021',
    districtId: '1105181',
    name: 'Lueng Peut',
  },
  {
    id: '1105181022',
    districtId: '1105181',
    name: 'Lueng Dua',
  },
  {
    id: '1105181023',
    districtId: '1105181',
    name: 'Matang Guru',
  },
  {
    id: '1105181024',
    districtId: '1105181',
    name: 'Pante Bayam',
  },
  {
    id: '1105181025',
    districtId: '1105181',
    name: 'Meunasah Tingkeum',
  },
  {
    id: '1105181026',
    districtId: '1105181',
    name: 'Meunasah Asan',
  },
  {
    id: '1106010007',
    districtId: '1106010',
    name: 'Lumut',
  },
  {
    id: '1106010008',
    districtId: '1106010',
    name: 'Delung Sekinel',
  },
  {
    id: '1106010009',
    districtId: '1106010',
    name: 'Jamat',
  },
  {
    id: '1106010010',
    districtId: '1106010',
    name: 'Linge',
  },
  {
    id: '1106010011',
    districtId: '1106010',
    name: 'Owaq',
  },
  {
    id: '1106010012',
    districtId: '1106010',
    name: 'Penarun',
  },
  {
    id: '1106010013',
    districtId: '1106010',
    name: 'Umang',
  },
  {
    id: '1106010014',
    districtId: '1106010',
    name: 'Simpang Tiga Uning',
  },
  {
    id: '1106010015',
    districtId: '1106010',
    name: 'Pantan Nangka',
  },
  {
    id: '1106010016',
    districtId: '1106010',
    name: 'Mungkur',
  },
  {
    id: '1106010017',
    districtId: '1106010',
    name: 'Gewat',
  },
  {
    id: '1106010018',
    districtId: '1106010',
    name: 'Kemerleng',
  },
  {
    id: '1106010019',
    districtId: '1106010',
    name: 'Kute Rayang',
  },
  {
    id: '1106010020',
    districtId: '1106010',
    name: 'Kute Keramil',
  },
  {
    id: '1106010021',
    districtId: '1106010',
    name: 'Kute Riyem',
  },
  {
    id: '1106010022',
    districtId: '1106010',
    name: 'Kute Baru',
  },
  {
    id: '1106010023',
    districtId: '1106010',
    name: 'Kute Robel',
  },
  {
    id: '1106010024',
    districtId: '1106010',
    name: 'Gelampang Gading',
  },
  {
    id: '1106010030',
    districtId: '1106010',
    name: 'Gemboyah',
  },
  {
    id: '1106010031',
    districtId: '1106010',
    name: 'Dispot Linge',
  },
  {
    id: '1106010036',
    districtId: '1106010',
    name: 'Ise-Ise',
  },
  {
    id: '1106010037',
    districtId: '1106010',
    name: 'Kute Reje',
  },
  {
    id: '1106010038',
    districtId: '1106010',
    name: 'Reje Payung',
  },
  {
    id: '1106010039',
    districtId: '1106010',
    name: 'Arul Item',
  },
  {
    id: '1106010040',
    districtId: '1106010',
    name: 'Antara',
  },
  {
    id: '1106010041',
    districtId: '1106010',
    name: 'Pantan Reduk',
  },
  {
    id: '1106011001',
    districtId: '1106011',
    name: 'Atu Lintang',
  },
  {
    id: '1106011002',
    districtId: '1106011',
    name: 'Merah Mege',
  },
  {
    id: '1106011003',
    districtId: '1106011',
    name: 'Tanoh Abu',
  },
  {
    id: '1106011004',
    districtId: '1106011',
    name: 'Merah Muyang',
  },
  {
    id: '1106011005',
    districtId: '1106011',
    name: 'Merah Pupuk',
  },
  {
    id: '1106011006',
    districtId: '1106011',
    name: 'Bintang Kekelip',
  },
  {
    id: '1106011007',
    districtId: '1106011',
    name: 'Merah Jernang',
  },
  {
    id: '1106011008',
    districtId: '1106011',
    name: 'Kepala Akal',
  },
  {
    id: '1106011009',
    districtId: '1106011',
    name: 'Gayo Murni',
  },
  {
    id: '1106011010',
    districtId: '1106011',
    name: 'Pantan Damar',
  },
  {
    id: '1106011011',
    districtId: '1106011',
    name: 'Damar Mulyo',
  },
  {
    id: '1106012001',
    districtId: '1106012',
    name: 'Gegarang',
  },
  {
    id: '1106012002',
    districtId: '1106012',
    name: 'Berawang Dewal',
  },
  {
    id: '1106012003',
    districtId: '1106012',
    name: 'Jagong',
  },
  {
    id: '1106012004',
    districtId: '1106012',
    name: 'Merah Said',
  },
  {
    id: '1106012005',
    districtId: '1106012',
    name: 'Jeget Ayu',
  },
  {
    id: '1106012006',
    districtId: '1106012',
    name: 'Paya Tungel',
  },
  {
    id: '1106012007',
    districtId: '1106012',
    name: 'Telege Sari',
  },
  {
    id: '1106012008',
    districtId: '1106012',
    name: 'Paya Dedep',
  },
  {
    id: '1106012009',
    districtId: '1106012',
    name: 'Bukit Kemuning',
  },
  {
    id: '1106012010',
    districtId: '1106012',
    name: 'Bukit Sari',
  },
  {
    id: '1106020001',
    districtId: '1106020',
    name: 'Bamil Nosar',
  },
  {
    id: '1106020002',
    districtId: '1106020',
    name: 'Mude Nosar',
  },
  {
    id: '1106020003',
    districtId: '1106020',
    name: 'Bale Nosar',
  },
  {
    id: '1106020004',
    districtId: '1106020',
    name: 'Mengaya',
  },
  {
    id: '1106020005',
    districtId: '1106020',
    name: 'Bewang',
  },
  {
    id: '1106020006',
    districtId: '1106020',
    name: 'Linung Bulen I',
  },
  {
    id: '1106020007',
    districtId: '1106020',
    name: 'Linung Bulen II',
  },
  {
    id: '1106020008',
    districtId: '1106020',
    name: 'Dedamar',
  },
  {
    id: '1106020009',
    districtId: '1106020',
    name: 'Serule',
  },
  {
    id: '1106020010',
    districtId: '1106020',
    name: 'Kuala II',
  },
  {
    id: '1106020011',
    districtId: '1106020',
    name: 'Kuala I',
  },
  {
    id: '1106020012',
    districtId: '1106020',
    name: 'Kala Segi',
  },
  {
    id: '1106020013',
    districtId: '1106020',
    name: 'Kelitu',
  },
  {
    id: '1106020014',
    districtId: '1106020',
    name: 'Kejurun Syiah Utama',
  },
  {
    id: '1106020015',
    districtId: '1106020',
    name: 'Wihlah Setie',
  },
  {
    id: '1106020016',
    districtId: '1106020',
    name: 'Atu Payung',
  },
  {
    id: '1106020017',
    districtId: '1106020',
    name: 'Wakil Jalil',
  },
  {
    id: '1106020018',
    districtId: '1106020',
    name: 'Genuren',
  },
  {
    id: '1106020019',
    districtId: '1106020',
    name: 'Kala Bintang',
  },
  {
    id: '1106020020',
    districtId: '1106020',
    name: 'Jamur Konyel',
  },
  {
    id: '1106020021',
    districtId: '1106020',
    name: 'Merodot',
  },
  {
    id: '1106020022',
    districtId: '1106020',
    name: 'Gegarang',
  },
  {
    id: '1106020023',
    districtId: '1106020',
    name: 'Sintep',
  },
  {
    id: '1106020024',
    districtId: '1106020',
    name: 'Gelepulo',
  },
  {
    id: '1106031001',
    districtId: '1106031',
    name: 'Asir Asir',
  },
  {
    id: '1106031002',
    districtId: '1106031',
    name: 'Asir Asir Asia',
  },
  {
    id: '1106031003',
    districtId: '1106031',
    name: 'Bujang',
  },
  {
    id: '1106031004',
    districtId: '1106031',
    name: 'Hakim Bale Bujang',
  },
  {
    id: '1106031005',
    districtId: '1106031',
    name: 'Kenawat',
  },
  {
    id: '1106031006',
    districtId: '1106031',
    name: 'Pedemun One One',
  },
  {
    id: '1106031007',
    districtId: '1106031',
    name: 'Toweren Toa',
  },
  {
    id: '1106031008',
    districtId: '1106031',
    name: 'Toweren Antara',
  },
  {
    id: '1106031009',
    districtId: '1106031',
    name: 'Toweren Uken',
  },
  {
    id: '1106031010',
    districtId: '1106031',
    name: 'Gunung Suku',
  },
  {
    id: '1106031011',
    districtId: '1106031',
    name: 'Rawe',
  },
  {
    id: '1106031012',
    districtId: '1106031',
    name: 'Takengon Timur',
  },
  {
    id: '1106031013',
    districtId: '1106031',
    name: 'Bale Atu',
  },
  {
    id: '1106031014',
    districtId: '1106031',
    name: 'Takengon Barat',
  },
  {
    id: '1106031015',
    districtId: '1106031',
    name: 'Kuteni Reje',
  },
  {
    id: '1106031016',
    districtId: '1106031',
    name: 'Merah Mersa',
  },
  {
    id: '1106031017',
    districtId: '1106031',
    name: 'One-One',
  },
  {
    id: '1106031018',
    districtId: '1106031',
    name: 'Toweren Musara',
  },
  {
    id: '1106032001',
    districtId: '1106032',
    name: 'Gunung Bukit',
  },
  {
    id: '1106032002',
    districtId: '1106032',
    name: 'Lot Kala',
  },
  {
    id: '1106032003',
    districtId: '1106032',
    name: 'Mendale',
  },
  {
    id: '1106032004',
    districtId: '1106032',
    name: 'Jongok Meluem',
  },
  {
    id: '1106032005',
    districtId: '1106032',
    name: 'Paya Reje Tami Delem',
  },
  {
    id: '1106032006',
    districtId: '1106032',
    name: 'Pinangan',
  },
  {
    id: '1106032007',
    districtId: '1106032',
    name: 'Paya Tumpi',
  },
  {
    id: '1106032008',
    districtId: '1106032',
    name: 'Bukit Sama',
  },
  {
    id: '1106032009',
    districtId: '1106032',
    name: 'Kelupak Mata',
  },
  {
    id: '1106032010',
    districtId: '1106032',
    name: 'Gunung Balohen',
  },
  {
    id: '1106032011',
    districtId: '1106032',
    name: 'Bukit',
  },
  {
    id: '1106032013',
    districtId: '1106032',
    name: 'Kala Lengkio',
  },
  {
    id: '1106032014',
    districtId: '1106032',
    name: 'Jongok Bathin',
  },
  {
    id: '1106032015',
    districtId: '1106032',
    name: 'Bukit Ewih Tami Delem',
  },
  {
    id: '1106032016',
    districtId: '1106032',
    name: 'Gunung Bahgie',
  },
  {
    id: '1106032017',
    districtId: '1106032',
    name: 'Timangan Gading',
  },
  {
    id: '1106032018',
    districtId: '1106032',
    name: 'Paya Tumpi I',
  },
  {
    id: '1106032019',
    districtId: '1106032',
    name: 'Paya Tumpi Baru',
  },
  {
    id: '1106032030',
    districtId: '1106032',
    name: 'Kute Lot',
  },
  {
    id: '1106032031',
    districtId: '1106032',
    name: 'Telege Atu',
  },
  {
    id: '1106040001',
    districtId: '1106040',
    name: 'Wih Ilang',
  },
  {
    id: '1106040002',
    districtId: '1106040',
    name: 'Wih Lah',
  },
  {
    id: '1106040003',
    districtId: '1106040',
    name: 'Pedekok',
  },
  {
    id: '1106040004',
    districtId: '1106040',
    name: 'Uring',
  },
  {
    id: '1106040005',
    districtId: '1106040',
    name: 'Ierelop',
  },
  {
    id: '1106040006',
    districtId: '1106040',
    name: 'Terang Ulen',
  },
  {
    id: '1106040007',
    districtId: '1106040',
    name: 'Gele Lungi',
  },
  {
    id: '1106040008',
    districtId: '1106040',
    name: 'Kedelah',
  },
  {
    id: '1106040009',
    districtId: '1106040',
    name: 'Wih Nareh',
  },
  {
    id: '1106040010',
    districtId: '1106040',
    name: 'Kung',
  },
  {
    id: '1106040011',
    districtId: '1106040',
    name: 'Simpang Kelaping',
  },
  {
    id: '1106040012',
    districtId: '1106040',
    name: 'Kute Lintang',
  },
  {
    id: '1106040013',
    districtId: '1106040',
    name: 'Kayu Kul',
  },
  {
    id: '1106040019',
    districtId: '1106040',
    name: 'Uning',
  },
  {
    id: '1106040022',
    districtId: '1106040',
    name: 'Arul Badak',
  },
  {
    id: '1106040023',
    districtId: '1106040',
    name: 'Berawang Baro',
  },
  {
    id: '1106040024',
    districtId: '1106040',
    name: 'Lelumu',
  },
  {
    id: '1106040025',
    districtId: '1106040',
    name: 'Tebuk',
  },
  {
    id: '1106040026',
    districtId: '1106040',
    name: 'Paya Jeget',
  },
  {
    id: '1106040027',
    districtId: '1106040',
    name: 'Ujung Gele',
  },
  {
    id: '1106040028',
    districtId: '1106040',
    name: 'Pepalang',
  },
  {
    id: '1106040029',
    districtId: '1106040',
    name: 'Pegasing',
  },
  {
    id: '1106040032',
    districtId: '1106040',
    name: 'Wih Terjun',
  },
  {
    id: '1106040033',
    districtId: '1106040',
    name: 'Pantan Musara',
  },
  {
    id: '1106040034',
    districtId: '1106040',
    name: 'Panangen Mata',
  },
  {
    id: '1106040035',
    districtId: '1106040',
    name: 'Linung Ayu',
  },
  {
    id: '1106040036',
    districtId: '1106040',
    name: 'Kala Pegasing',
  },
  {
    id: '1106040038',
    districtId: '1106040',
    name: 'Belang Bebangka',
  },
  {
    id: '1106040039',
    districtId: '1106040',
    name: 'Jurusen',
  },
  {
    id: '1106040041',
    districtId: '1106040',
    name: 'Jejem',
  },
  {
    id: '1106040042',
    districtId: '1106040',
    name: 'Suka Damai',
  },
  {
    id: '1106041001',
    districtId: '1106041',
    name: 'Atang Jungket',
  },
  {
    id: '1106041002',
    districtId: '1106041',
    name: 'Lenga',
  },
  {
    id: '1106041003',
    districtId: '1106041',
    name: 'Pucuk Deku',
  },
  {
    id: '1106041004',
    districtId: '1106041',
    name: 'Arul Latong',
  },
  {
    id: '1106041005',
    districtId: '1106041',
    name: 'Tebes Lues',
  },
  {
    id: '1106041006',
    districtId: '1106041',
    name: 'Bies Baru',
  },
  {
    id: '1106041007',
    districtId: '1106041',
    name: 'Bies Penentanan',
  },
  {
    id: '1106041008',
    districtId: '1106041',
    name: 'Sp Uning Niken',
  },
  {
    id: '1106041009',
    districtId: '1106041',
    name: 'Bies Mulie',
  },
  {
    id: '1106041010',
    districtId: '1106041',
    name: 'Simpang Lukup Badak',
  },
  {
    id: '1106041011',
    districtId: '1106041',
    name: 'Uning Pegantungen',
  },
  {
    id: '1106041012',
    districtId: '1106041',
    name: 'Karang Bayur',
  },
  {
    id: '1106050001',
    districtId: '1106050',
    name: 'Blang Gele',
  },
  {
    id: '1106050002',
    districtId: '1106050',
    name: 'Tansaril',
  },
  {
    id: '1106050003',
    districtId: '1106050',
    name: 'Blang Kolak II',
  },
  {
    id: '1106050004',
    districtId: '1106050',
    name: 'Blang Kolak I',
  },
  {
    id: '1106050005',
    districtId: '1106050',
    name: 'Kemili',
  },
  {
    id: '1106050006',
    districtId: '1106050',
    name: 'Simpang Empat',
  },
  {
    id: '1106050007',
    districtId: '1106050',
    name: 'Bebesen',
  },
  {
    id: '1106050008',
    districtId: '1106050',
    name: 'Mongal',
  },
  {
    id: '1106050009',
    districtId: '1106050',
    name: 'Daling',
  },
  {
    id: '1106050010',
    districtId: '1106050',
    name: 'Tensaren',
  },
  {
    id: '1106050011',
    districtId: '1106050',
    name: 'Lelabu',
  },
  {
    id: '1106050012',
    districtId: '1106050',
    name: 'Umang',
  },
  {
    id: '1106050019',
    districtId: '1106050',
    name: 'Atu Tulu',
  },
  {
    id: '1106050020',
    districtId: '1106050',
    name: 'Gele Lah',
  },
  {
    id: '1106050021',
    districtId: '1106050',
    name: 'Atu Gajah Reje Guru',
  },
  {
    id: '1106050022',
    districtId: '1106050',
    name: 'Pendere Saril',
  },
  {
    id: '1106050023',
    districtId: '1106050',
    name: 'Sadong Juru Mudi',
  },
  {
    id: '1106050024',
    districtId: '1106050',
    name: 'Keramat Mupakat',
  },
  {
    id: '1106050025',
    districtId: '1106050',
    name: 'Nunang Antara',
  },
  {
    id: '1106050026',
    districtId: '1106050',
    name: 'Kebet',
  },
  {
    id: '1106050027',
    districtId: '1106050',
    name: 'Empus Talu',
  },
  {
    id: '1106050028',
    districtId: '1106050',
    name: 'Lemah Burbana',
  },
  {
    id: '1106050029',
    districtId: '1106050',
    name: 'Bahgie',
  },
  {
    id: '1106050030',
    districtId: '1106050',
    name: 'Bur Biah',
  },
  {
    id: '1106050031',
    districtId: '1106050',
    name: 'Ulu Nuih',
  },
  {
    id: '1106050032',
    districtId: '1106050',
    name: 'Mah Bengi',
  },
  {
    id: '1106050033',
    districtId: '1106050',
    name: 'Calo Blang Gele',
  },
  {
    id: '1106050034',
    districtId: '1106050',
    name: 'Kala Kemili',
  },
  {
    id: '1106051001',
    districtId: '1106051',
    name: 'Tapak Moge',
  },
  {
    id: '1106051002',
    districtId: '1106051',
    name: 'Kute Panang',
  },
  {
    id: '1106051003',
    districtId: '1106051',
    name: 'Pantan Sile',
  },
  {
    id: '1106051004',
    districtId: '1106051',
    name: 'Ratawali',
  },
  {
    id: '1106051005',
    districtId: '1106051',
    name: 'Timang Rasa',
  },
  {
    id: '1106051006',
    districtId: '1106051',
    name: 'Tawar Miko',
  },
  {
    id: '1106051007',
    districtId: '1106051',
    name: 'Tawardi',
  },
  {
    id: '1106051008',
    districtId: '1106051',
    name: 'Wih Nongkal',
  },
  {
    id: '1106051009',
    districtId: '1106051',
    name: 'Dedingin',
  },
  {
    id: '1106051010',
    districtId: '1106051',
    name: 'Segene Balik',
  },
  {
    id: '1106051011',
    districtId: '1106051',
    name: 'Buter Balik',
  },
  {
    id: '1106051012',
    districtId: '1106051',
    name: 'Balik',
  },
  {
    id: '1106051013',
    districtId: '1106051',
    name: 'Atu Gogop',
  },
  {
    id: '1106051014',
    districtId: '1106051',
    name: 'Lukup Sabun',
  },
  {
    id: '1106051015',
    districtId: '1106051',
    name: 'Lukup Sabun Tengah',
  },
  {
    id: '1106051016',
    districtId: '1106051',
    name: 'Lukup Sabun Timur',
  },
  {
    id: '1106051017',
    districtId: '1106051',
    name: 'Lukup Sabun Barat',
  },
  {
    id: '1106051018',
    districtId: '1106051',
    name: 'Bukit  Rata',
  },
  {
    id: '1106051019',
    districtId: '1106051',
    name: 'Kala Nongkal',
  },
  {
    id: '1106051020',
    districtId: '1106051',
    name: 'Empu Balik',
  },
  {
    id: '1106051021',
    districtId: '1106051',
    name: 'Blang Balik',
  },
  {
    id: '1106051022',
    districtId: '1106051',
    name: 'Wih Nongkal Toa',
  },
  {
    id: '1106051023',
    districtId: '1106051',
    name: 'Tapak Moge Timur',
  },
  {
    id: '1106051024',
    districtId: '1106051',
    name: 'Pantan Jerik',
  },
  {
    id: '1106060009',
    districtId: '1106060',
    name: 'Rutih',
  },
  {
    id: '1106060011',
    districtId: '1106060',
    name: 'Genting Gerbang',
  },
  {
    id: '1106060012',
    districtId: '1106060',
    name: 'Pepayungen Angkup',
  },
  {
    id: '1106060013',
    districtId: '1106060',
    name: 'Remesen',
  },
  {
    id: '1106060014',
    districtId: '1106060',
    name: 'Burni Bius',
  },
  {
    id: '1106060015',
    districtId: '1106060',
    name: 'Wihni  Bakong',
  },
  {
    id: '1106060016',
    districtId: '1106060',
    name: 'Wih Porak',
  },
  {
    id: '1106060017',
    districtId: '1106060',
    name: 'Arulgele',
  },
  {
    id: '1106060018',
    districtId: '1106060',
    name: 'Gunung Singit',
  },
  {
    id: '1106060019',
    districtId: '1106060',
    name: 'Semelit Mutiara',
  },
  {
    id: '1106060020',
    districtId: '1106060',
    name: 'Arul Kumer',
  },
  {
    id: '1106060021',
    districtId: '1106060',
    name: 'Wihni Durin',
  },
  {
    id: '1106060049',
    districtId: '1106060',
    name: 'Paya Beke',
  },
  {
    id: '1106060051',
    districtId: '1106060',
    name: 'Jerata',
  },
  {
    id: '1106060052',
    districtId: '1106060',
    name: 'Terang Engon',
  },
  {
    id: '1106060053',
    districtId: '1106060',
    name: 'Simpang Kemili',
  },
  {
    id: '1106060054',
    districtId: '1106060',
    name: 'Burni Bius Baru',
  },
  {
    id: '1106060055',
    districtId: '1106060',
    name: 'Rebegedung',
  },
  {
    id: '1106060056',
    districtId: '1106060',
    name: 'Sanehen',
  },
  {
    id: '1106060057',
    districtId: '1106060',
    name: 'Wih Pesam',
  },
  {
    id: '1106060058',
    districtId: '1106060',
    name: 'Paya Pelu',
  },
  {
    id: '1106060059',
    districtId: '1106060',
    name: 'Arul Putih',
  },
  {
    id: '1106060060',
    districtId: '1106060',
    name: 'Arul Relem',
  },
  {
    id: '1106060061',
    districtId: '1106060',
    name: 'Tenebuk Kp. Baru',
  },
  {
    id: '1106060062',
    districtId: '1106060',
    name: 'Reremal',
  },
  {
    id: '1106060065',
    districtId: '1106060',
    name: 'Mulie Jadi',
  },
  {
    id: '1106060066',
    districtId: '1106060',
    name: 'Bius Utama',
  },
  {
    id: '1106060067',
    districtId: '1106060',
    name: 'Wih Sagi Indah',
  },
  {
    id: '1106060068',
    districtId: '1106060',
    name: 'Mekar Indah',
  },
  {
    id: '1106060069',
    districtId: '1106060',
    name: 'Wih Bersih',
  },
  {
    id: '1106060070',
    districtId: '1106060',
    name: 'Arul Kumer Timur',
  },
  {
    id: '1106060071',
    districtId: '1106060',
    name: 'Arul Kumer Barat',
  },
  {
    id: '1106060072',
    districtId: '1106060',
    name: 'Arul Kumer Selatan',
  },
  {
    id: '1106061001',
    districtId: '1106061',
    name: 'Pantan Penyo',
  },
  {
    id: '1106061002',
    districtId: '1106061',
    name: 'Bah',
  },
  {
    id: '1106061003',
    districtId: '1106061',
    name: 'Cang Duri',
  },
  {
    id: '1106061004',
    districtId: '1106061',
    name: 'Jaluk',
  },
  {
    id: '1106061005',
    districtId: '1106061',
    name: 'Gelumpang Payung',
  },
  {
    id: '1106061006',
    districtId: '1106061',
    name: 'Blang Mancung',
  },
  {
    id: '1106061007',
    districtId: '1106061',
    name: 'Kute Gelime',
  },
  {
    id: '1106061008',
    districtId: '1106061',
    name: 'Kalaketol',
  },
  {
    id: '1106061009',
    districtId: '1106061',
    name: 'Serempah',
  },
  {
    id: '1106061010',
    districtId: '1106061',
    name: 'Burlah',
  },
  {
    id: '1106061011',
    districtId: '1106061',
    name: 'Rejewali',
  },
  {
    id: '1106061012',
    districtId: '1106061',
    name: 'Pondok Balik',
  },
  {
    id: '1106061013',
    districtId: '1106061',
    name: 'Buter',
  },
  {
    id: '1106061014',
    districtId: '1106061',
    name: 'Kekuyang',
  },
  {
    id: '1106061015',
    districtId: '1106061',
    name: 'Bintang Pepara',
  },
  {
    id: '1106061016',
    districtId: '1106061',
    name: 'Karang Ampar',
  },
  {
    id: '1106061017',
    districtId: '1106061',
    name: 'Pantan Reduk',
  },
  {
    id: '1106061018',
    districtId: '1106061',
    name: 'Jerata',
  },
  {
    id: '1106061019',
    districtId: '1106061',
    name: 'Simpang Juli',
  },
  {
    id: '1106061020',
    districtId: '1106061',
    name: 'Jalan Tengah',
  },
  {
    id: '1106061021',
    districtId: '1106061',
    name: 'Blang Mancung Bawah',
  },
  {
    id: '1106061022',
    districtId: '1106061',
    name: 'Genting Bulen',
  },
  {
    id: '1106061023',
    districtId: '1106061',
    name: 'Selon',
  },
  {
    id: '1106061024',
    districtId: '1106061',
    name: 'Buge Ara',
  },
  {
    id: '1106061025',
    districtId: '1106061',
    name: 'Bergang',
  },
  {
    id: '1106062001',
    districtId: '1106062',
    name: 'Paya Kolak',
  },
  {
    id: '1106062002',
    districtId: '1106062',
    name: 'Arul Gading',
  },
  {
    id: '1106062003',
    districtId: '1106062',
    name: 'Tanoh Depet',
  },
  {
    id: '1106062004',
    districtId: '1106062',
    name: 'Kuyun Uken',
  },
  {
    id: '1106062005',
    districtId: '1106062',
    name: 'Kuyun Toa',
  },
  {
    id: '1106062006',
    districtId: '1106062',
    name: 'Uning Berawang Ramung',
  },
  {
    id: '1106062007',
    districtId: '1106062',
    name: 'Cibro',
  },
  {
    id: '1106062008',
    districtId: '1106062',
    name: 'Berawang Gading',
  },
  {
    id: '1106062009',
    districtId: '1106062',
    name: 'Melala',
  },
  {
    id: '1106062010',
    districtId: '1106062',
    name: 'Blang Kekumur',
  },
  {
    id: '1106062011',
    districtId: '1106062',
    name: 'Makmur',
  },
  {
    id: '1106062012',
    districtId: '1106062',
    name: 'Celala',
  },
  {
    id: '1106062013',
    districtId: '1106062',
    name: 'Ramung Ara',
  },
  {
    id: '1106062014',
    districtId: '1106062',
    name: 'Sepakat',
  },
  {
    id: '1106062015',
    districtId: '1106062',
    name: 'Kuyun',
  },
  {
    id: '1106062016',
    districtId: '1106062',
    name: 'Blang Delem',
  },
  {
    id: '1106062017',
    districtId: '1106062',
    name: 'Depet Indah',
  },
  {
    id: '1106063001',
    districtId: '1106063',
    name: 'Merandeh Paya',
  },
  {
    id: '1106063002',
    districtId: '1106063',
    name: 'Tanjung',
  },
  {
    id: '1106063003',
    districtId: '1106063',
    name: 'Rusip',
  },
  {
    id: '1106063004',
    districtId: '1106063',
    name: 'Paya Tampu',
  },
  {
    id: '1106063005',
    districtId: '1106063',
    name: 'Kuala Rawa',
  },
  {
    id: '1106063006',
    districtId: '1106063',
    name: 'Pantan Tengah',
  },
  {
    id: '1106063007',
    districtId: '1106063',
    name: 'Pilar',
  },
  {
    id: '1106063008',
    districtId: '1106063',
    name: 'Arul Pertik',
  },
  {
    id: '1106063009',
    districtId: '1106063',
    name: 'Atu Singkih',
  },
  {
    id: '1106063010',
    districtId: '1106063',
    name: 'Pantan Bener',
  },
  {
    id: '1106063011',
    districtId: '1106063',
    name: 'Kerawang',
  },
  {
    id: '1106063012',
    districtId: '1106063',
    name: 'Pilar Jaya',
  },
  {
    id: '1106063013',
    districtId: '1106063',
    name: 'Tirmi Ara',
  },
  {
    id: '1106063014',
    districtId: '1106063',
    name: 'Mekar Maju',
  },
  {
    id: '1106063015',
    districtId: '1106063',
    name: 'Pilar Wih Kiri',
  },
  {
    id: '1106063016',
    districtId: '1106063',
    name: 'Laut Jaya',
  },
  {
    id: '1107050001',
    districtId: '1107050',
    name: 'Suwak Indrapuri',
  },
  {
    id: '1107050002',
    districtId: '1107050',
    name: 'Pasar Aceh',
  },
  {
    id: '1107050003',
    districtId: '1107050',
    name: 'Padang Seurahet',
  },
  {
    id: '1107050004',
    districtId: '1107050',
    name: 'Panggong',
  },
  {
    id: '1107050005',
    districtId: '1107050',
    name: 'Kampung Belakang',
  },
  {
    id: '1107050006',
    districtId: '1107050',
    name: 'Kampung Pasir',
  },
  {
    id: '1107050007',
    districtId: '1107050',
    name: 'Ujung Kalak',
  },
  {
    id: '1107050008',
    districtId: '1107050',
    name: 'Ujong Baroh',
  },
  {
    id: '1107050009',
    districtId: '1107050',
    name: 'Rundeng',
  },
  {
    id: '1107050010',
    districtId: '1107050',
    name: 'Kuta Padang',
  },
  {
    id: '1107050011',
    districtId: '1107050',
    name: 'Drien Rampak',
  },
  {
    id: '1107050012',
    districtId: '1107050',
    name: 'Kampung Darat',
  },
  {
    id: '1107050013',
    districtId: '1107050',
    name: 'Gampa',
  },
  {
    id: '1107050014',
    districtId: '1107050',
    name: 'Seuneubok',
  },
  {
    id: '1107050015',
    districtId: '1107050',
    name: 'Suak Ribee',
  },
  {
    id: '1107050016',
    districtId: '1107050',
    name: 'Suak Raya',
  },
  {
    id: '1107050017',
    districtId: '1107050',
    name: 'Suak Nie',
  },
  {
    id: '1107050018',
    districtId: '1107050',
    name: 'Lapang',
  },
  {
    id: '1107050019',
    districtId: '1107050',
    name: 'Leuhan',
  },
  {
    id: '1107050020',
    districtId: '1107050',
    name: 'Blang Berandang',
  },
  {
    id: '1107050021',
    districtId: '1107050',
    name: 'Suak Sigadeng',
  },
  {
    id: '1107060007',
    districtId: '1107060',
    name: 'Suak Seumaseh',
  },
  {
    id: '1107060008',
    districtId: '1107060',
    name: 'Suak Geudubang',
  },
  {
    id: '1107060009',
    districtId: '1107060',
    name: 'Suak Pante Breuh',
  },
  {
    id: '1107060010',
    districtId: '1107060',
    name: 'Suak Seukee',
  },
  {
    id: '1107060011',
    districtId: '1107060',
    name: 'Suak Pandan',
  },
  {
    id: '1107060012',
    districtId: '1107060',
    name: 'Lhok Bubon',
  },
  {
    id: '1107060013',
    districtId: '1107060',
    name: 'Gampong Cot',
  },
  {
    id: '1107060014',
    districtId: '1107060',
    name: 'Gampong Teungoh',
  },
  {
    id: '1107060015',
    districtId: '1107060',
    name: 'Kuala Bubon',
  },
  {
    id: '1107060016',
    districtId: '1107060',
    name: 'Suak Timah',
  },
  {
    id: '1107060017',
    districtId: '1107060',
    name: 'Cot Darat',
  },
  {
    id: '1107060018',
    districtId: '1107060',
    name: 'Pucok Lueng',
  },
  {
    id: '1107060019',
    districtId: '1107060',
    name: 'Alue Raya',
  },
  {
    id: '1107060020',
    districtId: '1107060',
    name: 'Cot Pluh',
  },
  {
    id: '1107060021',
    districtId: '1107060',
    name: 'Cot Mesjid',
  },
  {
    id: '1107060022',
    districtId: '1107060',
    name: 'Cot Seulamat',
  },
  {
    id: '1107060023',
    districtId: '1107060',
    name: 'Cot Seumeureng',
  },
  {
    id: '1107060024',
    districtId: '1107060',
    name: 'Paya Lumpat',
  },
  {
    id: '1107060025',
    districtId: '1107060',
    name: 'Ujong Nga',
  },
  {
    id: '1107060026',
    districtId: '1107060',
    name: 'Gampong Ladang',
  },
  {
    id: '1107060027',
    districtId: '1107060',
    name: 'Cot Lampise',
  },
  {
    id: '1107060028',
    districtId: '1107060',
    name: 'Pinem',
  },
  {
    id: '1107060029',
    districtId: '1107060',
    name: 'Rangkileh',
  },
  {
    id: '1107060030',
    districtId: '1107060',
    name: 'Cot Amun',
  },
  {
    id: '1107060031',
    districtId: '1107060',
    name: 'Reusak',
  },
  {
    id: '1107060032',
    districtId: '1107060',
    name: 'Deuah',
  },
  {
    id: '1107060033',
    districtId: '1107060',
    name: 'Mesjid Baro',
  },
  {
    id: '1107060034',
    districtId: '1107060',
    name: 'Leukeun',
  },
  {
    id: '1107060035',
    districtId: '1107060',
    name: 'Lubok',
  },
  {
    id: '1107060036',
    districtId: '1107060',
    name: 'Krueng Tinggai',
  },
  {
    id: '1107060037',
    districtId: '1107060',
    name: 'Pange',
  },
  {
    id: '1107060038',
    districtId: '1107060',
    name: 'Keureuseng',
  },
  {
    id: '1107061001',
    districtId: '1107061',
    name: 'Rambong',
  },
  {
    id: '1107061002',
    districtId: '1107061',
    name: 'Beurawang',
  },
  {
    id: '1107061003',
    districtId: '1107061',
    name: 'Kuta Padang',
  },
  {
    id: '1107061004',
    districtId: '1107061',
    name: 'Layung',
  },
  {
    id: '1107061005',
    districtId: '1107061',
    name: 'Alue Bakong',
  },
  {
    id: '1107061006',
    districtId: '1107061',
    name: 'Alue Lhok',
  },
  {
    id: '1107061007',
    districtId: '1107061',
    name: 'Gunong Panah',
  },
  {
    id: '1107061008',
    districtId: '1107061',
    name: 'Seumuleng',
  },
  {
    id: '1107061009',
    districtId: '1107061',
    name: 'Kuala Pling',
  },
  {
    id: '1107061010',
    districtId: '1107061',
    name: 'Ulee Blang',
  },
  {
    id: '1107061011',
    districtId: '1107061',
    name: 'Seuneubok Trap',
  },
  {
    id: '1107061012',
    districtId: '1107061',
    name: 'Liceh',
  },
  {
    id: '1107061013',
    districtId: '1107061',
    name: 'Cot Keumuneng',
  },
  {
    id: '1107061014',
    districtId: '1107061',
    name: 'Suak Pangkat',
  },
  {
    id: '1107061015',
    districtId: '1107061',
    name: 'Peulanteu Sp',
  },
  {
    id: '1107061016',
    districtId: '1107061',
    name: 'Cot Lada',
  },
  {
    id: '1107061017',
    districtId: '1107061',
    name: 'Blang Sibeutong',
  },
  {
    id: '1107062001',
    districtId: '1107062',
    name: 'Pante Meutia',
  },
  {
    id: '1107062002',
    districtId: '1107062',
    name: 'Suak Bidok',
  },
  {
    id: '1107062003',
    districtId: '1107062',
    name: 'Suak Ie Beusou',
  },
  {
    id: '1107062004',
    districtId: '1107062',
    name: 'Suak Keumudee',
  },
  {
    id: '1107062005',
    districtId: '1107062',
    name: 'Arongan',
  },
  {
    id: '1107062006',
    districtId: '1107062',
    name: 'Cot Kumbang',
  },
  {
    id: '1107062007',
    districtId: '1107062',
    name: 'Keub',
  },
  {
    id: '1107062008',
    districtId: '1107062',
    name: 'Peuribu',
  },
  {
    id: '1107062009',
    districtId: '1107062',
    name: 'Teupin Peuraho',
  },
  {
    id: '1107062010',
    districtId: '1107062',
    name: 'Ujong Beusa',
  },
  {
    id: '1107062011',
    districtId: '1107062',
    name: 'Kubu',
  },
  {
    id: '1107062012',
    districtId: '1107062',
    name: 'Seuneubok Lueng',
  },
  {
    id: '1107062013',
    districtId: '1107062',
    name: 'Drien Rampak',
  },
  {
    id: '1107062014',
    districtId: '1107062',
    name: 'Cot Buloh',
  },
  {
    id: '1107062015',
    districtId: '1107062',
    name: 'Simpang Peut',
  },
  {
    id: '1107062016',
    districtId: '1107062',
    name: 'Rimba Langgeh',
  },
  {
    id: '1107062017',
    districtId: '1107062',
    name: 'Seuneubok Teungoh',
  },
  {
    id: '1107062018',
    districtId: '1107062',
    name: 'Gunong Pulo',
  },
  {
    id: '1107062019',
    districtId: '1107062',
    name: 'Karang Hampa',
  },
  {
    id: '1107062020',
    districtId: '1107062',
    name: 'Peulanteu Lb',
  },
  {
    id: '1107062021',
    districtId: '1107062',
    name: 'Ujong Simpang',
  },
  {
    id: '1107062022',
    districtId: '1107062',
    name: 'Panton Makmur',
  },
  {
    id: '1107062023',
    districtId: '1107062',
    name: 'Panton Bahagia',
  },
  {
    id: '1107062024',
    districtId: '1107062',
    name: 'Cot Jurumudi',
  },
  {
    id: '1107062025',
    districtId: '1107062',
    name: 'Alue Sundak',
  },
  {
    id: '1107062026',
    districtId: '1107062',
    name: 'Alue Bagok',
  },
  {
    id: '1107062027',
    districtId: '1107062',
    name: 'Alue Batee',
  },
  {
    id: '1107070015',
    districtId: '1107070',
    name: 'Ie Itam Baroh',
  },
  {
    id: '1107070016',
    districtId: '1107070',
    name: 'Ie Itam Tunong',
  },
  {
    id: '1107070017',
    districtId: '1107070',
    name: 'Cot Murong',
  },
  {
    id: '1107070018',
    districtId: '1107070',
    name: 'Padang Jawa',
  },
  {
    id: '1107070023',
    districtId: '1107070',
    name: 'Ranto Panyang',
  },
  {
    id: '1107070024',
    districtId: '1107070',
    name: 'Gempa Raya',
  },
  {
    id: '1107070025',
    districtId: '1107070',
    name: 'Cot Lagan Cm',
  },
  {
    id: '1107070026',
    districtId: '1107070',
    name: 'Aron Baroh',
  },
  {
    id: '1107070027',
    districtId: '1107070',
    name: 'Pasi Pandan',
  },
  {
    id: '1107070033',
    districtId: '1107070',
    name: 'Aron Tunong',
  },
  {
    id: '1107070034',
    districtId: '1107070',
    name: 'Pasi Aceh',
  },
  {
    id: '1107070035',
    districtId: '1107070',
    name: 'Lhung Tgk Yah',
  },
  {
    id: '1107070036',
    districtId: '1107070',
    name: 'Paya Dua',
  },
  {
    id: '1107070037',
    districtId: '1107070',
    name: 'Suak Tring',
  },
  {
    id: '1107070038',
    districtId: '1107070',
    name: 'Glee Siblah',
  },
  {
    id: '1107070039',
    districtId: '1107070',
    name: 'Darul Huda',
  },
  {
    id: '1107070040',
    districtId: '1107070',
    name: 'Paya Luah',
  },
  {
    id: '1107070041',
    districtId: '1107070',
    name: 'Gunong Rambong',
  },
  {
    id: '1107070042',
    districtId: '1107070',
    name: 'Lueng Buloh',
  },
  {
    id: '1107070043',
    districtId: '1107070',
    name: 'Lueng Tanoh Tho',
  },
  {
    id: '1107070044',
    districtId: '1107070',
    name: 'Lueng Jawa',
  },
  {
    id: '1107070045',
    districtId: '1107070',
    name: 'Tingkeum Panyang',
  },
  {
    id: '1107070046',
    districtId: '1107070',
    name: 'Kuala Bhee',
  },
  {
    id: '1107070047',
    districtId: '1107070',
    name: 'Pasi Lunak',
  },
  {
    id: '1107070048',
    districtId: '1107070',
    name: 'Bakat',
  },
  {
    id: '1107070049',
    districtId: '1107070',
    name: 'Cot Keumudee',
  },
  {
    id: '1107070050',
    districtId: '1107070',
    name: 'Alue Blang',
  },
  {
    id: '1107070051',
    districtId: '1107070',
    name: 'Blang Mee',
  },
  {
    id: '1107070052',
    districtId: '1107070',
    name: 'Keuleumbah',
  },
  {
    id: '1107070053',
    districtId: '1107070',
    name: 'Jawa',
  },
  {
    id: '1107070054',
    districtId: '1107070',
    name: 'Alue Panyang',
  },
  {
    id: '1107070055',
    districtId: '1107070',
    name: 'Pulo Ie',
  },
  {
    id: '1107070056',
    districtId: '1107070',
    name: 'Pasi Ara Kb',
  },
  {
    id: '1107070057',
    districtId: '1107070',
    name: 'Gunung Hampa',
  },
  {
    id: '1107070058',
    districtId: '1107070',
    name: 'Alue Sikaya',
  },
  {
    id: '1107070059',
    districtId: '1107070',
    name: 'Drin Mangko',
  },
  {
    id: '1107070060',
    districtId: '1107070',
    name: 'Seumantok',
  },
  {
    id: '1107070062',
    districtId: '1107070',
    name: 'Cot Situah',
  },
  {
    id: '1107070063',
    districtId: '1107070',
    name: 'Pasi Birah',
  },
  {
    id: '1107070070',
    districtId: '1107070',
    name: 'Panton',
  },
  {
    id: '1107070071',
    districtId: '1107070',
    name: 'Alue Sundak',
  },
  {
    id: '1107070079',
    districtId: '1107070',
    name: 'Teumarom',
  },
  {
    id: '1107070080',
    districtId: '1107070',
    name: 'Jawi',
  },
  {
    id: '1107071001',
    districtId: '1107071',
    name: 'Alue Leuhob',
  },
  {
    id: '1107071002',
    districtId: '1107071',
    name: 'Blang Luah Lm',
  },
  {
    id: '1107071003',
    districtId: '1107071',
    name: 'Pasi Male',
  },
  {
    id: '1107071004',
    districtId: '1107071',
    name: 'Napai',
  },
  {
    id: '1107071005',
    districtId: '1107071',
    name: 'Blang Cot Mameh',
  },
  {
    id: '1107071006',
    districtId: '1107071',
    name: 'Kulam Kaju',
  },
  {
    id: '1107071007',
    districtId: '1107071',
    name: 'Lhok Male',
  },
  {
    id: '1107071008',
    districtId: '1107071',
    name: 'Cot Rambong',
  },
  {
    id: '1107071009',
    districtId: '1107071',
    name: 'Lubuk Pasi Ara',
  },
  {
    id: '1107071010',
    districtId: '1107071',
    name: 'Ulee Pasi Ara',
  },
  {
    id: '1107071011',
    districtId: '1107071',
    name: 'Cot Lagan Lm',
  },
  {
    id: '1107071012',
    districtId: '1107071',
    name: 'Lueng Baro',
  },
  {
    id: '1107071013',
    districtId: '1107071',
    name: 'Alue Perman',
  },
  {
    id: '1107071014',
    districtId: '1107071',
    name: 'Blang Cot Rubek',
  },
  {
    id: '1107071015',
    districtId: '1107071',
    name: 'Peuluekung',
  },
  {
    id: '1107071016',
    districtId: '1107071',
    name: 'Pasi Jeut',
  },
  {
    id: '1107071017',
    districtId: '1107071',
    name: 'Mon Pasong',
  },
  {
    id: '1107071018',
    districtId: '1107071',
    name: 'Pasi Mali',
  },
  {
    id: '1107071019',
    districtId: '1107071',
    name: 'Karak',
  },
  {
    id: '1107071020',
    districtId: '1107071',
    name: 'Alue Keumuneng',
  },
  {
    id: '1107071021',
    districtId: '1107071',
    name: 'Ie Sayang',
  },
  {
    id: '1107071022',
    districtId: '1107071',
    name: 'Ulee Pulo',
  },
  {
    id: '1107071023',
    districtId: '1107071',
    name: 'Pasi Panyang',
  },
  {
    id: '1107071024',
    districtId: '1107071',
    name: 'Simpang Teumarom',
  },
  {
    id: '1107072001',
    districtId: '1107072',
    name: 'Cot Punti',
  },
  {
    id: '1107072002',
    districtId: '1107072',
    name: 'Pasi Janeng',
  },
  {
    id: '1107072003',
    districtId: '1107072',
    name: 'Tangkeh',
  },
  {
    id: '1107072004',
    districtId: '1107072',
    name: 'Paya Meugeundrang',
  },
  {
    id: '1107072005',
    districtId: '1107072',
    name: 'Gunong Panyang',
  },
  {
    id: '1107072006',
    districtId: '1107072',
    name: 'Seuneubok Dalam',
  },
  {
    id: '1107072007',
    districtId: '1107072',
    name: 'Blang Luah Kb',
  },
  {
    id: '1107072008',
    districtId: '1107072',
    name: 'Rambong Pinto',
  },
  {
    id: '1107072009',
    districtId: '1107072',
    name: 'Alue Seuralen',
  },
  {
    id: '1107072010',
    districtId: '1107072',
    name: 'Alue Empeuk',
  },
  {
    id: '1107072011',
    districtId: '1107072',
    name: 'Rambong',
  },
  {
    id: '1107072012',
    districtId: '1107072',
    name: 'Gampong Baro Wt',
  },
  {
    id: '1107072013',
    districtId: '1107072',
    name: 'Pasi Ara Wt',
  },
  {
    id: '1107072014',
    districtId: '1107072',
    name: 'Keubeu Capang',
  },
  {
    id: '1107072015',
    districtId: '1107072',
    name: 'Paya Baro',
  },
  {
    id: '1107072016',
    districtId: '1107072',
    name: 'Alue Bilie',
  },
  {
    id: '1107072017',
    districtId: '1107072',
    name: 'Tuwi Empeuk',
  },
  {
    id: '1107072018',
    districtId: '1107072',
    name: 'Alue Meuganda',
  },
  {
    id: '1107072019',
    districtId: '1107072',
    name: 'Gampong Baro Kb',
  },
  {
    id: '1107072020',
    districtId: '1107072',
    name: 'Lubok Panyang',
  },
  {
    id: '1107072021',
    districtId: '1107072',
    name: 'Seuradeuk',
  },
  {
    id: '1107072022',
    districtId: '1107072',
    name: 'Blang Makmur',
  },
  {
    id: '1107072023',
    districtId: '1107072',
    name: 'Bukit Megajah',
  },
  {
    id: '1107072024',
    districtId: '1107072',
    name: 'Blang Dalam',
  },
  {
    id: '1107072025',
    districtId: '1107072',
    name: 'Teumiket Ranom',
  },
  {
    id: '1107072026',
    districtId: '1107072',
    name: 'Alue Kuyuen',
  },
  {
    id: '1107080023',
    districtId: '1107080',
    name: 'Marek',
  },
  {
    id: '1107080025',
    districtId: '1107080',
    name: 'Pasi Teungoh',
  },
  {
    id: '1107080026',
    districtId: '1107080',
    name: 'Pasi Jambu',
  },
  {
    id: '1107080027',
    districtId: '1107080',
    name: 'Alue Tampak',
  },
  {
    id: '1107080028',
    districtId: '1107080',
    name: 'Tumpok Ladang',
  },
  {
    id: '1107080032',
    districtId: '1107080',
    name: 'Meunasah Ara',
  },
  {
    id: '1107080033',
    districtId: '1107080',
    name: 'Meunasah Rayeuk',
  },
  {
    id: '1107080034',
    districtId: '1107080',
    name: 'Meunasah Buloh',
  },
  {
    id: '1107080035',
    districtId: '1107080',
    name: 'Padang Mancang',
  },
  {
    id: '1107080036',
    districtId: '1107080',
    name: 'Mesjid',
  },
  {
    id: '1107080037',
    districtId: '1107080',
    name: 'Keude Aron',
  },
  {
    id: '1107080038',
    districtId: '1107080',
    name: 'Peunia',
  },
  {
    id: '1107080039',
    districtId: '1107080',
    name: 'Simpang',
  },
  {
    id: '1107080040',
    districtId: '1107080',
    name: 'Beureugang',
  },
  {
    id: '1107080041',
    districtId: '1107080',
    name: 'Batu Jaya',
  },
  {
    id: '1107080042',
    districtId: '1107080',
    name: 'Blang Geunang',
  },
  {
    id: '1107080043',
    districtId: '1107080',
    name: 'Muko',
  },
  {
    id: '1107080044',
    districtId: '1107080',
    name: 'Tanjong Bunga',
  },
  {
    id: '1107080045',
    districtId: '1107080',
    name: 'Putim',
  },
  {
    id: '1107080046',
    districtId: '1107080',
    name: 'Meunasah Rambot',
  },
  {
    id: '1107080047',
    districtId: '1107080',
    name: 'Alue On',
  },
  {
    id: '1107080048',
    districtId: '1107080',
    name: 'Pasi Jeumpa',
  },
  {
    id: '1107080049',
    districtId: '1107080',
    name: 'Palimbungan',
  },
  {
    id: '1107080050',
    districtId: '1107080',
    name: 'Pasi Meugat',
  },
  {
    id: '1107080051',
    districtId: '1107080',
    name: 'Puuk',
  },
  {
    id: '1107080052',
    districtId: '1107080',
    name: 'Meunasah Gantung',
  },
  {
    id: '1107080053',
    districtId: '1107080',
    name: 'Pungkie',
  },
  {
    id: '1107080054',
    districtId: '1107080',
    name: 'Babah Meulaboh',
  },
  {
    id: '1107080055',
    districtId: '1107080',
    name: 'Menuang Tanjong',
  },
  {
    id: '1107080056',
    districtId: '1107080',
    name: 'Tanjong Meulaboh',
  },
  {
    id: '1107080057',
    districtId: '1107080',
    name: 'Blang Dalam',
  },
  {
    id: '1107080058',
    districtId: '1107080',
    name: 'Alue Peudeung',
  },
  {
    id: '1107080059',
    districtId: '1107080',
    name: 'Pasi Ara',
  },
  {
    id: '1107080060',
    districtId: '1107080',
    name: 'Keude Tanjong',
  },
  {
    id: '1107080061',
    districtId: '1107080',
    name: 'Pucok Pungkie',
  },
  {
    id: '1107080062',
    districtId: '1107080',
    name: 'Pasi Kumbang',
  },
  {
    id: '1107080063',
    districtId: '1107080',
    name: 'Teupin Panah',
  },
  {
    id: '1107080064',
    districtId: '1107080',
    name: 'Drien Calee',
  },
  {
    id: '1107080065',
    districtId: '1107080',
    name: 'Alue Lhee',
  },
  {
    id: '1107080067',
    districtId: '1107080',
    name: 'Teuladan',
  },
  {
    id: '1107080068',
    districtId: '1107080',
    name: 'Sawang Teubee',
  },
  {
    id: '1107080069',
    districtId: '1107080',
    name: 'Alue Lhok',
  },
  {
    id: '1107080070',
    districtId: '1107080',
    name: 'Padang Sikabu',
  },
  {
    id: '1107080071',
    districtId: '1107080',
    name: 'Keuramat',
  },
  {
    id: '1107081001',
    districtId: '1107081',
    name: 'Peunaga Cut Ujong',
  },
  {
    id: '1107081002',
    districtId: '1107081',
    name: 'Gunong Kleng',
  },
  {
    id: '1107081003',
    districtId: '1107081',
    name: 'Peunaga Pasi',
  },
  {
    id: '1107081004',
    districtId: '1107081',
    name: 'Peunaga Rayeuk',
  },
  {
    id: '1107081005',
    districtId: '1107081',
    name: 'Paya Peunaga',
  },
  {
    id: '1107081006',
    districtId: '1107081',
    name: 'Langung',
  },
  {
    id: '1107081007',
    districtId: '1107081',
    name: 'Meureubo',
  },
  {
    id: '1107081008',
    districtId: '1107081',
    name: 'Ujong Drien',
  },
  {
    id: '1107081009',
    districtId: '1107081',
    name: 'Pasi Pinang',
  },
  {
    id: '1107081010',
    districtId: '1107081',
    name: 'Ujong Tanjong',
  },
  {
    id: '1107081011',
    districtId: '1107081',
    name: 'Bukit Jaya',
  },
  {
    id: '1107081012',
    districtId: '1107081',
    name: 'Buloh',
  },
  {
    id: '1107081013',
    districtId: '1107081',
    name: 'Ranto Panyang Timur',
  },
  {
    id: '1107081014',
    districtId: '1107081',
    name: 'Ranto Panyang Barat',
  },
  {
    id: '1107081015',
    districtId: '1107081',
    name: 'Mesjid Tuha',
  },
  {
    id: '1107081016',
    districtId: '1107081',
    name: 'Ujong Tanoh Darat',
  },
  {
    id: '1107081017',
    districtId: '1107081',
    name: 'Ranub Dong',
  },
  {
    id: '1107081018',
    districtId: '1107081',
    name: 'Pasi Mesjid',
  },
  {
    id: '1107081019',
    districtId: '1107081',
    name: 'Pulo Teungoh Ranto',
  },
  {
    id: '1107081020',
    districtId: '1107081',
    name: 'Balee',
  },
  {
    id: '1107081021',
    districtId: '1107081',
    name: 'Sumber Batu',
  },
  {
    id: '1107081022',
    districtId: '1107081',
    name: 'Pasi Aceh Baroh',
  },
  {
    id: '1107081023',
    districtId: '1107081',
    name: 'Pasi Aceh Tunong',
  },
  {
    id: '1107081024',
    districtId: '1107081',
    name: 'Reudeup',
  },
  {
    id: '1107081025',
    districtId: '1107081',
    name: 'Pucok Reudeup',
  },
  {
    id: '1107081026',
    districtId: '1107081',
    name: 'Paya Baro Ranto Panjang',
  },
  {
    id: '1107082001',
    districtId: '1107082',
    name: 'Tegal Sari',
  },
  {
    id: '1107082002',
    districtId: '1107082',
    name: 'Krueng Beukah',
  },
  {
    id: '1107082003',
    districtId: '1107082',
    name: 'Berdikari',
  },
  {
    id: '1107082004',
    districtId: '1107082',
    name: 'Suwak Awe',
  },
  {
    id: '1107082005',
    districtId: '1107082',
    name: 'Gunong Tarok',
  },
  {
    id: '1107082006',
    districtId: '1107082',
    name: 'Babah Krueng Teklep',
  },
  {
    id: '1107082007',
    districtId: '1107082',
    name: 'Lhok Sari',
  },
  {
    id: '1107082008',
    districtId: '1107082',
    name: 'Lhok Guci',
  },
  {
    id: '1107082009',
    districtId: '1107082',
    name: 'Keude Suwak Awe',
  },
  {
    id: '1107082010',
    districtId: '1107082',
    name: 'Sawang Rambot',
  },
  {
    id: '1107082011',
    districtId: '1107082',
    name: 'Menuang Kinco',
  },
  {
    id: '1107082012',
    districtId: '1107082',
    name: 'Seumara',
  },
  {
    id: '1107082013',
    districtId: '1107082',
    name: 'Seumantok',
  },
  {
    id: '1107082014',
    districtId: '1107082',
    name: 'Manjeng',
  },
  {
    id: '1107082015',
    districtId: '1107082',
    name: 'Pante Ceureumen',
  },
  {
    id: '1107082016',
    districtId: '1107082',
    name: 'Pulo Teungoh Manyeng',
  },
  {
    id: '1107082017',
    districtId: '1107082',
    name: 'Keutambang',
  },
  {
    id: '1107082018',
    districtId: '1107082',
    name: 'Canggai',
  },
  {
    id: '1107082019',
    districtId: '1107082',
    name: 'Lawet',
  },
  {
    id: '1107082020',
    districtId: '1107082',
    name: 'Lango',
  },
  {
    id: '1107082021',
    districtId: '1107082',
    name: 'Babah Lueng',
  },
  {
    id: '1107082022',
    districtId: '1107082',
    name: 'Babah Iseung',
  },
  {
    id: '1107082023',
    districtId: '1107082',
    name: 'Alue Keumang',
  },
  {
    id: '1107082024',
    districtId: '1107082',
    name: 'Jambak',
  },
  {
    id: '1107082025',
    districtId: '1107082',
    name: 'Sikundo',
  },
  {
    id: '1107083001',
    districtId: '1107083',
    name: 'Paya Baro Meuko',
  },
  {
    id: '1107083002',
    districtId: '1107083',
    name: 'Gunung Mata Ie',
  },
  {
    id: '1107083003',
    districtId: '1107083',
    name: 'Babah Krueng Manggie',
  },
  {
    id: '1107083004',
    districtId: '1107083',
    name: 'Blang Balee',
  },
  {
    id: '1107083005',
    districtId: '1107083',
    name: 'Lek Lek',
  },
  {
    id: '1107083006',
    districtId: '1107083',
    name: 'Gampong Baro',
  },
  {
    id: '1107083007',
    districtId: '1107083',
    name: 'Meutulang',
  },
  {
    id: '1107083008',
    districtId: '1107083',
    name: 'Manggie',
  },
  {
    id: '1107083009',
    districtId: '1107083',
    name: 'Tamping',
  },
  {
    id: '1107083010',
    districtId: '1107083',
    name: 'Cot Manggie',
  },
  {
    id: '1107083011',
    districtId: '1107083',
    name: 'Kuala Manye',
  },
  {
    id: '1107083012',
    districtId: '1107083',
    name: 'Tuwi Buya',
  },
  {
    id: '1107083013',
    districtId: '1107083',
    name: 'Ujong Raja',
  },
  {
    id: '1107083014',
    districtId: '1107083',
    name: 'Mugo Cut',
  },
  {
    id: '1107083015',
    districtId: '1107083',
    name: 'Mugo Rayeuk',
  },
  {
    id: '1107083016',
    districtId: '1107083',
    name: 'Baro Paya',
  },
  {
    id: '1107083017',
    districtId: '1107083',
    name: 'Sibintang',
  },
  {
    id: '1107083018',
    districtId: '1107083',
    name: 'Blang Teungoh',
  },
  {
    id: '1107083019',
    districtId: '1107083',
    name: 'Antong',
  },
  {
    id: '1107090001',
    districtId: '1107090',
    name: 'Tuwi Saya',
  },
  {
    id: '1107090002',
    districtId: '1107090',
    name: 'Lueng Baro',
  },
  {
    id: '1107090003',
    districtId: '1107090',
    name: 'Sipot',
  },
  {
    id: '1107090004',
    districtId: '1107090',
    name: 'Gaseu',
  },
  {
    id: '1107090005',
    districtId: '1107090',
    name: 'Leubok Beutong',
  },
  {
    id: '1107090006',
    districtId: '1107090',
    name: 'Pungkie',
  },
  {
    id: '1107090007',
    districtId: '1107090',
    name: 'Gunong Buloh',
  },
  {
    id: '1107090008',
    districtId: '1107090',
    name: 'Ramitie',
  },
  {
    id: '1107090009',
    districtId: '1107090',
    name: 'Gleung',
  },
  {
    id: '1107090010',
    districtId: '1107090',
    name: 'Tanoh Mirah',
  },
  {
    id: '1107090011',
    districtId: '1107090',
    name: 'Drien Sibak',
  },
  {
    id: '1107090012',
    districtId: '1107090',
    name: 'Sakuy',
  },
  {
    id: '1107090013',
    districtId: '1107090',
    name: 'Kajeung',
  },
  {
    id: '1107090014',
    districtId: '1107090',
    name: 'Geudong',
  },
  {
    id: '1107090015',
    districtId: '1107090',
    name: 'Tungkop',
  },
  {
    id: '1107090016',
    districtId: '1107090',
    name: 'Sarah Perlak',
  },
  {
    id: '1107090017',
    districtId: '1107090',
    name: 'Lancong',
  },
  {
    id: '1107090018',
    districtId: '1107090',
    name: 'Tutut',
  },
  {
    id: '1108010001',
    districtId: '1108010',
    name: 'Meunasah Lhok',
  },
  {
    id: '1108010002',
    districtId: '1108010',
    name: 'Pudeng',
  },
  {
    id: '1108010003',
    districtId: '1108010',
    name: 'Pasi',
  },
  {
    id: '1108010004',
    districtId: '1108010',
    name: 'Glee Bruek',
  },
  {
    id: '1108010005',
    districtId: '1108010',
    name: 'Meunasah Cot',
  },
  {
    id: '1108010006',
    districtId: '1108010',
    name: 'Cundien',
  },
  {
    id: '1108010007',
    districtId: '1108010',
    name: 'Gapuy',
  },
  {
    id: '1108010008',
    districtId: '1108010',
    name: 'Mon Mata',
  },
  {
    id: '1108010009',
    districtId: '1108010',
    name: 'Keutapang',
  },
  {
    id: '1108010010',
    districtId: '1108010',
    name: 'Lamsujen',
  },
  {
    id: '1108010011',
    districtId: '1108010',
    name: 'Lamjuhang',
  },
  {
    id: '1108010012',
    districtId: '1108010',
    name: 'Utamong',
  },
  {
    id: '1108010013',
    districtId: '1108010',
    name: 'Saney',
  },
  {
    id: '1108010014',
    districtId: '1108010',
    name: 'Lamgeuriheu',
  },
  {
    id: '1108010015',
    districtId: '1108010',
    name: 'Umong Seuribee',
  },
  {
    id: '1108010016',
    districtId: '1108010',
    name: 'Lamkuta Blang Mee',
  },
  {
    id: '1108010017',
    districtId: '1108010',
    name: 'Teungoh Blang Mee',
  },
  {
    id: '1108010018',
    districtId: '1108010',
    name: 'Teungoh Geunteut',
  },
  {
    id: '1108010019',
    districtId: '1108010',
    name: 'Baroh Geunteut',
  },
  {
    id: '1108010020',
    districtId: '1108010',
    name: 'Baroh Blang Mee',
  },
  {
    id: '1108010021',
    districtId: '1108010',
    name: 'Jantang',
  },
  {
    id: '1108010022',
    districtId: '1108010',
    name: 'Meunasah Krueng Kala',
  },
  {
    id: '1108010023',
    districtId: '1108010',
    name: 'Kareung',
  },
  {
    id: '1108010024',
    districtId: '1108010',
    name: 'Birek',
  },
  {
    id: '1108010025',
    districtId: '1108010',
    name: 'Seungko Mulat',
  },
  {
    id: '1108010026',
    districtId: '1108010',
    name: 'Baroh Krueng Kala',
  },
  {
    id: '1108010027',
    districtId: '1108010',
    name: 'Tunong Krueng Kala',
  },
  {
    id: '1108010028',
    districtId: '1108010',
    name: 'Paroy',
  },
  {
    id: '1108020007',
    districtId: '1108020',
    name: 'Mon Ikeun',
  },
  {
    id: '1108020008',
    districtId: '1108020',
    name: 'Naga Umbang',
  },
  {
    id: '1108020009',
    districtId: '1108020',
    name: 'Lambaro Kueh',
  },
  {
    id: '1108020010',
    districtId: '1108020',
    name: 'Lam Ateuk',
  },
  {
    id: '1108020011',
    districtId: '1108020',
    name: 'Aneuk Paya',
  },
  {
    id: '1108020012',
    districtId: '1108020',
    name: 'Lampaya',
  },
  {
    id: '1108020013',
    districtId: '1108020',
    name: 'Lamkruet',
  },
  {
    id: '1108020014',
    districtId: '1108020',
    name: 'Weuraya',
  },
  {
    id: '1108020015',
    districtId: '1108020',
    name: 'Meunasah Lambaro',
  },
  {
    id: '1108020016',
    districtId: '1108020',
    name: 'Mon Cut',
  },
  {
    id: '1108020017',
    districtId: '1108020',
    name: 'Meunasah Manyang',
  },
  {
    id: '1108020018',
    districtId: '1108020',
    name: 'Meunasah Karieng',
  },
  {
    id: '1108020019',
    districtId: '1108020',
    name: 'Lamgaboh',
  },
  {
    id: '1108020020',
    districtId: '1108020',
    name: 'Tanjong',
  },
  {
    id: '1108020021',
    districtId: '1108020',
    name: 'Kueh',
  },
  {
    id: '1108020022',
    districtId: '1108020',
    name: 'Nusa',
  },
  {
    id: '1108020023',
    districtId: '1108020',
    name: 'Seubun Keutapang',
  },
  {
    id: '1108020024',
    districtId: '1108020',
    name: 'Seubun Ayon',
  },
  {
    id: '1108020025',
    districtId: '1108020',
    name: 'Lambaro Seubun',
  },
  {
    id: '1108020026',
    districtId: '1108020',
    name: 'Meunasah Mesjid Lamlhom',
  },
  {
    id: '1108020027',
    districtId: '1108020',
    name: 'Meunasah Baro',
  },
  {
    id: '1108020028',
    districtId: '1108020',
    name: 'Meunasah Mesjid Lampuuk',
  },
  {
    id: '1108020029',
    districtId: '1108020',
    name: 'Meunasah Balee',
  },
  {
    id: '1108020030',
    districtId: '1108020',
    name: 'Lamgirek',
  },
  {
    id: '1108020031',
    districtId: '1108020',
    name: 'Meunasah Beutong',
  },
  {
    id: '1108020032',
    districtId: '1108020',
    name: 'Lamcok',
  },
  {
    id: '1108020033',
    districtId: '1108020',
    name: 'Meunasah Blang',
  },
  {
    id: '1108020034',
    districtId: '1108020',
    name: 'Meunasah Cut',
  },
  {
    id: '1108021001',
    districtId: '1108021',
    name: 'Layeun',
  },
  {
    id: '1108021002',
    districtId: '1108021',
    name: 'Pulot',
  },
  {
    id: '1108021003',
    districtId: '1108021',
    name: 'Lamseunia',
  },
  {
    id: '1108021004',
    districtId: '1108021',
    name: 'Meunasah Mesjid',
  },
  {
    id: '1108021005',
    districtId: '1108021',
    name: 'Meunasah Bak U',
  },
  {
    id: '1108021006',
    districtId: '1108021',
    name: 'Dayah Mamplam',
  },
  {
    id: '1108030001',
    districtId: '1108030',
    name: 'Aneuk Glee',
  },
  {
    id: '1108030002',
    districtId: '1108030',
    name: 'Lam Ilie Ganto',
  },
  {
    id: '1108030003',
    districtId: '1108030',
    name: 'Lam Ilie Teungoh',
  },
  {
    id: '1108030004',
    districtId: '1108030',
    name: 'Reukih Dayah',
  },
  {
    id: '1108030005',
    districtId: '1108030',
    name: 'Krueng Lamkareung',
  },
  {
    id: '1108030006',
    districtId: '1108030',
    name: 'Riting',
  },
  {
    id: '1108030028',
    districtId: '1108030',
    name: 'Lampanah Tunong',
  },
  {
    id: '1108030029',
    districtId: '1108030',
    name: 'Lampanah Baro',
  },
  {
    id: '1108030030',
    districtId: '1108030',
    name: 'Lampanah Teungoh',
  },
  {
    id: '1108030031',
    districtId: '1108030',
    name: 'Lampanah Dayah',
  },
  {
    id: '1108030032',
    districtId: '1108030',
    name: 'Lampanah Ranjo',
  },
  {
    id: '1108030033',
    districtId: '1108030',
    name: 'Seuot Tunong',
  },
  {
    id: '1108030034',
    districtId: '1108030',
    name: 'Sihom Cot',
  },
  {
    id: '1108030035',
    districtId: '1108030',
    name: 'Sihom Lhok',
  },
  {
    id: '1108030036',
    districtId: '1108030',
    name: 'Sinyeu',
  },
  {
    id: '1108030037',
    districtId: '1108030',
    name: 'Seuot Baroh',
  },
  {
    id: '1108030038',
    districtId: '1108030',
    name: 'Pasar Indrapuri',
  },
  {
    id: '1108030039',
    districtId: '1108030',
    name: 'Indra Puri',
  },
  {
    id: '1108030040',
    districtId: '1108030',
    name: 'Reukih Keupula',
  },
  {
    id: '1108030041',
    districtId: '1108030',
    name: 'Lamleubok',
  },
  {
    id: '1108030042',
    districtId: '1108030',
    name: 'Lam Ilie Mesjid',
  },
  {
    id: '1108030043',
    districtId: '1108030',
    name: 'Empe Ara',
  },
  {
    id: '1108030044',
    districtId: '1108030',
    name: 'Ulee Kareung',
  },
  {
    id: '1108030045',
    districtId: '1108030',
    name: 'Seuremo',
  },
  {
    id: '1108030046',
    districtId: '1108030',
    name: 'Meunara',
  },
  {
    id: '1108030047',
    districtId: '1108030',
    name: 'Lingom',
  },
  {
    id: '1108030048',
    districtId: '1108030',
    name: 'Lambunot',
  },
  {
    id: '1108030049',
    districtId: '1108030',
    name: 'Lamsiot',
  },
  {
    id: '1108030050',
    districtId: '1108030',
    name: 'Ulee Ue',
  },
  {
    id: '1108030051',
    districtId: '1108030',
    name: 'Jruek Bak Kreh',
  },
  {
    id: '1108030052',
    districtId: '1108030',
    name: 'Jruek Balee',
  },
  {
    id: '1108030053',
    districtId: '1108030',
    name: 'Grot Manyang',
  },
  {
    id: '1108030054',
    districtId: '1108030',
    name: 'Grot Baro',
  },
  {
    id: '1108030055',
    districtId: '1108030',
    name: 'Mon Alue',
  },
  {
    id: '1108030056',
    districtId: '1108030',
    name: 'Grot Blang',
  },
  {
    id: '1108030057',
    districtId: '1108030',
    name: 'Seulangai',
  },
  {
    id: '1108030058',
    districtId: '1108030',
    name: 'Lampupok Baro',
  },
  {
    id: '1108030059',
    districtId: '1108030',
    name: 'Lampupok Raya',
  },
  {
    id: '1108030060',
    districtId: '1108030',
    name: 'Lambeutong',
  },
  {
    id: '1108030061',
    districtId: '1108030',
    name: 'Limo Lamluweung',
  },
  {
    id: '1108030062',
    districtId: '1108030',
    name: 'Limo Mesjid',
  },
  {
    id: '1108030063',
    districtId: '1108030',
    name: 'Limo Blang',
  },
  {
    id: '1108030064',
    districtId: '1108030',
    name: 'Cot Kareung',
  },
  {
    id: '1108030065',
    districtId: '1108030',
    name: 'Cureh',
  },
  {
    id: '1108030066',
    districtId: '1108030',
    name: 'Lheue',
  },
  {
    id: '1108030067',
    districtId: '1108030',
    name: 'Mesalee',
  },
  {
    id: '1108030068',
    districtId: '1108030',
    name: 'Lamlung',
  },
  {
    id: '1108030069',
    districtId: '1108030',
    name: 'Mureu Ule Titie',
  },
  {
    id: '1108030070',
    districtId: '1108030',
    name: 'Mureu Bung U',
  },
  {
    id: '1108030071',
    districtId: '1108030',
    name: 'Mureu Baro',
  },
  {
    id: '1108030072',
    districtId: '1108030',
    name: 'Mureu Lamglumpang',
  },
  {
    id: '1108030073',
    districtId: '1108030',
    name: 'Manggra',
  },
  {
    id: '1108031001',
    districtId: '1108031',
    name: 'Bak Sukon',
  },
  {
    id: '1108031002',
    districtId: '1108031',
    name: 'Siron Krueng',
  },
  {
    id: '1108031003',
    districtId: '1108031',
    name: 'Siron Blang',
  },
  {
    id: '1108031004',
    districtId: '1108031',
    name: 'Bueng Simek',
  },
  {
    id: '1108031005',
    districtId: '1108031',
    name: 'Bithak',
  },
  {
    id: '1108031006',
    districtId: '1108031',
    name: 'Tutui',
  },
  {
    id: '1108031007',
    districtId: '1108031',
    name: 'Pakuk',
  },
  {
    id: '1108031008',
    districtId: '1108031',
    name: 'Pasar Lampaku',
  },
  {
    id: '1108031009',
    districtId: '1108031',
    name: 'Sigapang',
  },
  {
    id: '1108031010',
    districtId: '1108031',
    name: 'Keureuweung Krueng',
  },
  {
    id: '1108031011',
    districtId: '1108031',
    name: 'Keureuweung Blang',
  },
  {
    id: '1108031012',
    districtId: '1108031',
    name: 'Glee Jai',
  },
  {
    id: '1108031013',
    districtId: '1108031',
    name: 'Lampakuk',
  },
  {
    id: '1108031014',
    districtId: '1108031',
    name: 'Banda Safa',
  },
  {
    id: '1108031015',
    districtId: '1108031',
    name: 'Lamtui',
  },
  {
    id: '1108031016',
    districtId: '1108031',
    name: 'Lambeugak',
  },
  {
    id: '1108031017',
    districtId: '1108031',
    name: 'Lamleupung',
  },
  {
    id: '1108031018',
    districtId: '1108031',
    name: 'Cot Bayu',
  },
  {
    id: '1108031019',
    districtId: '1108031',
    name: 'Keumireu',
  },
  {
    id: '1108031020',
    districtId: '1108031',
    name: 'Lamleuot',
  },
  {
    id: '1108031021',
    districtId: '1108031',
    name: 'Leupung Baleu',
  },
  {
    id: '1108031022',
    districtId: '1108031',
    name: 'Ie Alang Lamkeureumeuh',
  },
  {
    id: '1108031023',
    districtId: '1108031',
    name: 'Ie Alang Mesjid',
  },
  {
    id: '1108031024',
    districtId: '1108031',
    name: 'Ie Alang Dayah',
  },
  {
    id: '1108031025',
    districtId: '1108031',
    name: 'Ie Alang Lamghui',
  },
  {
    id: '1108031026',
    districtId: '1108031',
    name: 'Maheng',
  },
  {
    id: '1108031027',
    districtId: '1108031',
    name: 'Leupung Bruek',
  },
  {
    id: '1108031028',
    districtId: '1108031',
    name: 'Lam Aling',
  },
  {
    id: '1108031029',
    districtId: '1108031',
    name: 'Lamsie',
  },
  {
    id: '1108031030',
    districtId: '1108031',
    name: 'Lampoh Raja',
  },
  {
    id: '1108031031',
    districtId: '1108031',
    name: 'Barih Lhok',
  },
  {
    id: '1108031032',
    districtId: '1108031',
    name: 'Lamkleng',
  },
  {
    id: '1108040016',
    districtId: '1108040',
    name: 'Alue Gintong',
  },
  {
    id: '1108040017',
    districtId: '1108040',
    name: 'Lhieb',
  },
  {
    id: '1108040019',
    districtId: '1108040',
    name: 'Data Gaseu',
  },
  {
    id: '1108040020',
    districtId: '1108040',
    name: 'Keunaloi',
  },
  {
    id: '1108040021',
    districtId: '1108040',
    name: 'Jawie',
  },
  {
    id: '1108040022',
    districtId: '1108040',
    name: 'Buga',
  },
  {
    id: '1108040023',
    districtId: '1108040',
    name: 'Pasar Seulimeum',
  },
  {
    id: '1108040024',
    districtId: '1108040',
    name: 'Rabo',
  },
  {
    id: '1108040025',
    districtId: '1108040',
    name: 'Lampisang Tunong',
  },
  {
    id: '1108040026',
    districtId: '1108040',
    name: 'Lampisang Teungoh',
  },
  {
    id: '1108040027',
    districtId: '1108040',
    name: 'Lampisang Dayah',
  },
  {
    id: '1108040028',
    districtId: '1108040',
    name: 'Capeung Baroh',
  },
  {
    id: '1108040029',
    districtId: '1108040',
    name: 'Capeung Dayah',
  },
  {
    id: '1108040030',
    districtId: '1108040',
    name: 'Bak Aghu',
  },
  {
    id: '1108040031',
    districtId: '1108040',
    name: 'Meunasah Jeumpa',
  },
  {
    id: '1108040032',
    districtId: '1108040',
    name: 'Pinto Khop',
  },
  {
    id: '1108040033',
    districtId: '1108040',
    name: 'Kayee Adang',
  },
  {
    id: '1108040034',
    districtId: '1108040',
    name: 'Seuneubok',
  },
  {
    id: '1108040035',
    districtId: '1108040',
    name: 'Seulimeum',
  },
  {
    id: '1108040036',
    districtId: '1108040',
    name: 'Gampong Raya',
  },
  {
    id: '1108040037',
    districtId: '1108040',
    name: 'Lamjruen',
  },
  {
    id: '1108040038',
    districtId: '1108040',
    name: 'Iboh Tanjong',
  },
  {
    id: '1108040039',
    districtId: '1108040',
    name: 'Iboh Tunong',
  },
  {
    id: '1108040040',
    districtId: '1108040',
    name: 'Alue Rindang',
  },
  {
    id: '1108040041',
    districtId: '1108040',
    name: 'Meunasah Baro',
  },
  {
    id: '1108040047',
    districtId: '1108040',
    name: 'Ayon',
  },
  {
    id: '1108040048',
    districtId: '1108040',
    name: 'Bayu',
  },
  {
    id: '1108040049',
    districtId: '1108040',
    name: 'Batee Lhee',
  },
  {
    id: '1108040050',
    districtId: '1108040',
    name: 'Meunasah Tunong',
  },
  {
    id: '1108040051',
    districtId: '1108040',
    name: 'Mangeu',
  },
  {
    id: '1108040052',
    districtId: '1108040',
    name: 'Bak Seutui',
  },
  {
    id: '1108040053',
    districtId: '1108040',
    name: 'Ujong Mesjid Tanoh Abee',
  },
  {
    id: '1108040054',
    districtId: '1108040',
    name: 'Lamkuk',
  },
  {
    id: '1108040055',
    districtId: '1108040',
    name: 'Lamcarak',
  },
  {
    id: '1108040056',
    districtId: '1108040',
    name: 'Lampantee',
  },
  {
    id: '1108040057',
    districtId: '1108040',
    name: 'Lamteuba Droe',
  },
  {
    id: '1108040058',
    districtId: '1108040',
    name: 'Pulo',
  },
  {
    id: '1108040059',
    districtId: '1108040',
    name: 'Meurah',
  },
  {
    id: '1108040060',
    districtId: '1108040',
    name: 'Lambada',
  },
  {
    id: '1108040061',
    districtId: '1108040',
    name: 'Blang Tingkeum',
  },
  {
    id: '1108040062',
    districtId: '1108040',
    name: 'Lam Apeng',
  },
  {
    id: '1108040063',
    districtId: '1108040',
    name: 'Ateuk',
  },
  {
    id: '1108040064',
    districtId: '1108040',
    name: 'Beureunut',
  },
  {
    id: '1108040065',
    districtId: '1108040',
    name: 'Ujong Keupula',
  },
  {
    id: '1108040066',
    districtId: '1108040',
    name: 'Lampanah',
  },
  {
    id: '1108040067',
    districtId: '1108040',
    name: 'Ujong Mesjid Lampanah',
  },
  {
    id: '1108040068',
    districtId: '1108040',
    name: 'Leungah',
  },
  {
    id: '1108041001',
    districtId: '1108041',
    name: 'Jantho Baru',
  },
  {
    id: '1108041002',
    districtId: '1108041',
    name: 'Weu',
  },
  {
    id: '1108041003',
    districtId: '1108041',
    name: 'Aweek',
  },
  {
    id: '1108041004',
    districtId: '1108041',
    name: 'Bueng',
  },
  {
    id: '1108041005',
    districtId: '1108041',
    name: 'Jalin',
  },
  {
    id: '1108041006',
    districtId: '1108041',
    name: 'Suka Tani',
  },
  {
    id: '1108041007',
    districtId: '1108041',
    name: 'Data Cut',
  },
  {
    id: '1108041008',
    districtId: '1108041',
    name: 'Jantho',
  },
  {
    id: '1108041009',
    districtId: '1108041',
    name: 'Barueh',
  },
  {
    id: '1108041010',
    districtId: '1108041',
    name: 'Jantho Makmur',
  },
  {
    id: '1108041011',
    districtId: '1108041',
    name: 'Bukit Meusara',
  },
  {
    id: '1108041012',
    districtId: '1108041',
    name: 'Teureubeh',
  },
  {
    id: '1108041013',
    districtId: '1108041',
    name: 'Cucum',
  },
  {
    id: '1108042001',
    districtId: '1108042',
    name: 'Panca',
  },
  {
    id: '1108042002',
    districtId: '1108042',
    name: 'Panca Kubu',
  },
  {
    id: '1108042003',
    districtId: '1108042',
    name: 'Lam Kubu',
  },
  {
    id: '1108042004',
    districtId: '1108042',
    name: 'Lon Asan',
  },
  {
    id: '1108042005',
    districtId: '1108042',
    name: 'Lon Baroh',
  },
  {
    id: '1108042006',
    districtId: '1108042',
    name: 'Paya Keureuleh',
  },
  {
    id: '1108042007',
    districtId: '1108042',
    name: 'Lambaro Tunong',
  },
  {
    id: '1108042008',
    districtId: '1108042',
    name: 'Teuladan',
  },
  {
    id: '1108042009',
    districtId: '1108042',
    name: 'Lamtamot',
  },
  {
    id: '1108042010',
    districtId: '1108042',
    name: 'Suka Damai',
  },
  {
    id: '1108042011',
    districtId: '1108042',
    name: 'Suka Mulia',
  },
  {
    id: '1108042012',
    districtId: '1108042',
    name: 'Saree Aceh',
  },
  {
    id: '1108050001',
    districtId: '1108050',
    name: 'Lamnga',
  },
  {
    id: '1108050002',
    districtId: '1108050',
    name: 'Baro',
  },
  {
    id: '1108050003',
    districtId: '1108050',
    name: 'Neuheun',
  },
  {
    id: '1108050004',
    districtId: '1108050',
    name: 'Durung',
  },
  {
    id: '1108050005',
    districtId: '1108050',
    name: 'Ladong',
  },
  {
    id: '1108050006',
    districtId: '1108050',
    name: 'Ruyung',
  },
  {
    id: '1108050007',
    districtId: '1108050',
    name: 'Paya Kameng',
  },
  {
    id: '1108050008',
    districtId: '1108050',
    name: 'Beurandeh',
  },
  {
    id: '1108050009',
    districtId: '1108050',
    name: 'Meunasah Kulam',
  },
  {
    id: '1108050010',
    districtId: '1108050',
    name: 'Meunasah Keudee',
  },
  {
    id: '1108050011',
    districtId: '1108050',
    name: 'Meunasah Mon',
  },
  {
    id: '1108050012',
    districtId: '1108050',
    name: 'Ie Seum',
  },
  {
    id: '1108050013',
    districtId: '1108050',
    name: 'Lamreh',
  },
  {
    id: '1108060001',
    districtId: '1108060',
    name: 'Lampuja',
  },
  {
    id: '1108060002',
    districtId: '1108060',
    name: 'Lam Ujong',
  },
  {
    id: '1108060003',
    districtId: '1108060',
    name: 'Lam Gawee',
  },
  {
    id: '1108060004',
    districtId: '1108060',
    name: 'Lam Asan',
  },
  {
    id: '1108060005',
    districtId: '1108060',
    name: 'Lam Reh',
  },
  {
    id: '1108060006',
    districtId: '1108060',
    name: 'Siem',
  },
  {
    id: '1108060007',
    districtId: '1108060',
    name: 'Krueng Kalee',
  },
  {
    id: '1108060008',
    districtId: '1108060',
    name: 'Lambaro Sukon',
  },
  {
    id: '1108060009',
    districtId: '1108060',
    name: 'Lambiheu Lambaro Angan',
  },
  {
    id: '1108060010',
    districtId: '1108060',
    name: 'Lambiheu Siem',
  },
  {
    id: '1108060011',
    districtId: '1108060',
    name: 'Lam Klat',
  },
  {
    id: '1108060012',
    districtId: '1108060',
    name: 'Lamkeuneung',
  },
  {
    id: '1108060013',
    districtId: '1108060',
    name: 'Lampuuk',
  },
  {
    id: '1108060014',
    districtId: '1108060',
    name: 'Lamtimpeung',
  },
  {
    id: '1108060015',
    districtId: '1108060',
    name: 'Limpok',
  },
  {
    id: '1108060016',
    districtId: '1108060',
    name: 'Barabung',
  },
  {
    id: '1108060017',
    districtId: '1108060',
    name: 'Tungkob',
  },
  {
    id: '1108060018',
    districtId: '1108060',
    name: 'Lam Duro',
  },
  {
    id: '1108060019',
    districtId: '1108060',
    name: 'Lambitra',
  },
  {
    id: '1108060020',
    districtId: '1108060',
    name: 'Lieue',
  },
  {
    id: '1108060021',
    districtId: '1108060',
    name: 'Lambada Peukan',
  },
  {
    id: '1108060022',
    districtId: '1108060',
    name: 'Blang',
  },
  {
    id: '1108060023',
    districtId: '1108060',
    name: 'Cot',
  },
  {
    id: '1108060024',
    districtId: '1108060',
    name: 'Angan',
  },
  {
    id: '1108060026',
    districtId: '1108060',
    name: 'Miruek Taman',
  },
  {
    id: '1108060027',
    districtId: '1108060',
    name: 'Lampeudaya',
  },
  {
    id: '1108060028',
    districtId: '1108060',
    name: 'Suleue',
  },
  {
    id: '1108060029',
    districtId: '1108060',
    name: 'Tanjong Deah',
  },
  {
    id: '1108060030',
    districtId: '1108060',
    name: 'Tanjung Selamat',
  },
  {
    id: '1108061001',
    districtId: '1108061',
    name: 'Blang Krueng',
  },
  {
    id: '1108061002',
    districtId: '1108061',
    name: 'Baet',
  },
  {
    id: '1108061003',
    districtId: '1108061',
    name: 'Cadek',
  },
  {
    id: '1108061004',
    districtId: '1108061',
    name: 'Kajhu',
  },
  {
    id: '1108061005',
    districtId: '1108061',
    name: 'Cot Paya',
  },
  {
    id: '1108061006',
    districtId: '1108061',
    name: 'Lambada Lhok',
  },
  {
    id: '1108061007',
    districtId: '1108061',
    name: 'Klieng Cot Aron',
  },
  {
    id: '1108061008',
    districtId: '1108061',
    name: 'Miruek Lamreudeup',
  },
  {
    id: '1108061009',
    districtId: '1108061',
    name: 'Klieng Meuria',
  },
  {
    id: '1108061010',
    districtId: '1108061',
    name: 'Lampineung',
  },
  {
    id: '1108061011',
    districtId: '1108061',
    name: 'Lam Asan',
  },
  {
    id: '1108061012',
    districtId: '1108061',
    name: 'Labuy',
  },
  {
    id: '1108061013',
    districtId: '1108061',
    name: 'Lam Ujong',
  },
  {
    id: '1108070005',
    districtId: '1108070',
    name: 'Gue',
  },
  {
    id: '1108070009',
    districtId: '1108070',
    name: 'Babah Jurong',
  },
  {
    id: '1108070010',
    districtId: '1108070',
    name: 'Lambro Deyah',
  },
  {
    id: '1108070011',
    districtId: '1108070',
    name: 'Lam Baed',
  },
  {
    id: '1108070012',
    districtId: '1108070',
    name: 'Krueng Anoi',
  },
  {
    id: '1108070013',
    districtId: '1108070',
    name: 'Cot Masam',
  },
  {
    id: '1108070014',
    districtId: '1108070',
    name: 'Cot Mancang',
  },
  {
    id: '1108070015',
    districtId: '1108070',
    name: 'Bueng Bakjok',
  },
  {
    id: '1108070016',
    districtId: '1108070',
    name: 'Cot Beut',
  },
  {
    id: '1108070017',
    districtId: '1108070',
    name: 'Ujong Blang',
  },
  {
    id: '1108070018',
    districtId: '1108070',
    name: 'Seupeu',
  },
  {
    id: '1108070019',
    districtId: '1108070',
    name: 'Lam Neuheun',
  },
  {
    id: '1108070020',
    districtId: '1108070',
    name: 'Lam Puuk',
  },
  {
    id: '1108070021',
    districtId: '1108070',
    name: 'Lambro Bileu',
  },
  {
    id: '1108070022',
    districtId: '1108070',
    name: 'Lampoh Keude',
  },
  {
    id: '1108070023',
    districtId: '1108070',
    name: 'Cot Peutano',
  },
  {
    id: '1108070024',
    districtId: '1108070',
    name: 'Cot Cut',
  },
  {
    id: '1108070025',
    districtId: '1108070',
    name: 'Lam Glumpang',
  },
  {
    id: '1108070026',
    districtId: '1108070',
    name: 'Meunasah Bak Trieng',
  },
  {
    id: '1108070027',
    districtId: '1108070',
    name: 'Lam Asan',
  },
  {
    id: '1108070028',
    districtId: '1108070',
    name: 'Lamceu',
  },
  {
    id: '1108070029',
    districtId: '1108070',
    name: 'Cot Preh',
  },
  {
    id: '1108070030',
    districtId: '1108070',
    name: 'Puuk',
  },
  {
    id: '1108070031',
    districtId: '1108070',
    name: 'Lam Seunong',
  },
  {
    id: '1108070032',
    districtId: '1108070',
    name: 'Lam Trieng',
  },
  {
    id: '1108070033',
    districtId: '1108070',
    name: 'Beurangong',
  },
  {
    id: '1108070034',
    districtId: '1108070',
    name: 'Rabeu',
  },
  {
    id: '1108070035',
    districtId: '1108070',
    name: 'Deyah',
  },
  {
    id: '1108070036',
    districtId: '1108070',
    name: 'Cucum',
  },
  {
    id: '1108070037',
    districtId: '1108070',
    name: 'Cot Yang',
  },
  {
    id: '1108070038',
    districtId: '1108070',
    name: 'Cot Raya',
  },
  {
    id: '1108070039',
    districtId: '1108070',
    name: 'Lampoh Tarom',
  },
  {
    id: '1108070040',
    districtId: '1108070',
    name: 'Aron',
  },
  {
    id: '1108070041',
    districtId: '1108070',
    name: 'Lam Roh',
  },
  {
    id: '1108070042',
    districtId: '1108070',
    name: 'Bak Buloh',
  },
  {
    id: '1108070043',
    districtId: '1108070',
    name: 'Lam Raya',
  },
  {
    id: '1108070044',
    districtId: '1108070',
    name: 'Tumpok Lampoh',
  },
  {
    id: '1108070045',
    districtId: '1108070',
    name: 'Lambunot Tanoh',
  },
  {
    id: '1108070046',
    districtId: '1108070',
    name: 'Lambunot Paya',
  },
  {
    id: '1108070047',
    districtId: '1108070',
    name: 'Lamteube Mon Ara',
  },
  {
    id: '1108070048',
    districtId: '1108070',
    name: 'Lamteubee Geupula',
  },
  {
    id: '1108070049',
    districtId: '1108070',
    name: 'Lam Alu Cut',
  },
  {
    id: '1108070050',
    districtId: '1108070',
    name: 'Lam Sabang',
  },
  {
    id: '1108070051',
    districtId: '1108070',
    name: 'Lam Alu Raya',
  },
  {
    id: '1108070052',
    districtId: '1108070',
    name: 'Leupung Ulee Alue',
  },
  {
    id: '1108070053',
    districtId: '1108070',
    name: 'Leupung Mesjid',
  },
  {
    id: '1108070054',
    districtId: '1108070',
    name: 'Cot Lamme',
  },
  {
    id: '1108080001',
    districtId: '1108080',
    name: 'Weu Bada',
  },
  {
    id: '1108080002',
    districtId: '1108080',
    name: 'Piyeung Lhang',
  },
  {
    id: '1108080003',
    districtId: '1108080',
    name: 'Piyeung Datu',
  },
  {
    id: '1108080004',
    districtId: '1108080',
    name: 'Piyeung Mane',
  },
  {
    id: '1108080005',
    districtId: '1108080',
    name: 'Kuweu',
  },
  {
    id: '1108080006',
    districtId: '1108080',
    name: 'Bueng Daroh',
  },
  {
    id: '1108080007',
    districtId: '1108080',
    name: 'Cot Lampoh Soh',
  },
  {
    id: '1108080008',
    districtId: '1108080',
    name: 'Mon Ara',
  },
  {
    id: '1108080009',
    districtId: '1108080',
    name: 'Cot Lhok',
  },
  {
    id: '1108080010',
    districtId: '1108080',
    name: 'Bueng Raya',
  },
  {
    id: '1108080011',
    districtId: '1108080',
    name: 'Atong',
  },
  {
    id: '1108080012',
    districtId: '1108080',
    name: 'Teubang Phui Mesjid',
  },
  {
    id: '1108080013',
    districtId: '1108080',
    name: 'Lamme Garot',
  },
  {
    id: '1108080014',
    districtId: '1108080',
    name: 'Reudeup',
  },
  {
    id: '1108080015',
    districtId: '1108080',
    name: 'Bakcirih',
  },
  {
    id: '1108080016',
    districtId: '1108080',
    name: 'Meunasah Tutong',
  },
  {
    id: '1108080017',
    districtId: '1108080',
    name: 'Empee Tanong',
  },
  {
    id: '1108080018',
    districtId: '1108080',
    name: 'Dayah Daboh',
  },
  {
    id: '1108080019',
    districtId: '1108080',
    name: 'Lampaseh Krueng',
  },
  {
    id: '1108080020',
    districtId: '1108080',
    name: 'Lamnga',
  },
  {
    id: '1108080021',
    districtId: '1108080',
    name: 'Lampaseh Lhok',
  },
  {
    id: '1108080022',
    districtId: '1108080',
    name: 'Baroh',
  },
  {
    id: '1108080023',
    districtId: '1108080',
    name: 'Mata Ie',
  },
  {
    id: '1108080024',
    districtId: '1108080',
    name: 'Weu Krueng',
  },
  {
    id: '1108080025',
    districtId: '1108080',
    name: 'Alue',
  },
  {
    id: '1108080026',
    districtId: '1108080',
    name: 'Weu Lhok',
  },
  {
    id: '1108080027',
    districtId: '1108080',
    name: 'Warabo',
  },
  {
    id: '1108080028',
    districtId: '1108080',
    name: 'Teubang Phui Baro',
  },
  {
    id: '1108080029',
    districtId: '1108080',
    name: 'Bueng Tujoh',
  },
  {
    id: '1108080030',
    districtId: '1108080',
    name: 'Bira Lhok',
  },
  {
    id: '1108080031',
    districtId: '1108080',
    name: 'Bira Cot',
  },
  {
    id: '1108080032',
    districtId: '1108080',
    name: 'Peurumping',
  },
  {
    id: '1108080035',
    districtId: '1108080',
    name: 'Bak Dilip',
  },
  {
    id: '1108080036',
    districtId: '1108080',
    name: 'Ulee Lhat',
  },
  {
    id: '1108080037',
    districtId: '1108080',
    name: 'Seubam Lhok',
  },
  {
    id: '1108080038',
    districtId: '1108080',
    name: 'Lam Raya',
  },
  {
    id: '1108080039',
    districtId: '1108080',
    name: 'Cot Seunong',
  },
  {
    id: '1108080042',
    districtId: '1108080',
    name: 'Seubam Cot',
  },
  {
    id: '1108080043',
    districtId: '1108080',
    name: 'Seumet',
  },
  {
    id: '1108081001',
    districtId: '1108081',
    name: 'Cot Mon Raya',
  },
  {
    id: '1108081002',
    districtId: '1108081',
    name: 'Cot Geundreut',
  },
  {
    id: '1108081003',
    districtId: '1108081',
    name: 'Paya-Ue',
  },
  {
    id: '1108081004',
    districtId: '1108081',
    name: 'Lamme',
  },
  {
    id: '1108081005',
    districtId: '1108081',
    name: 'Meulayo',
  },
  {
    id: '1108081006',
    districtId: '1108081',
    name: 'Lam Siem',
  },
  {
    id: '1108081007',
    districtId: '1108081',
    name: 'Cot Puklat',
  },
  {
    id: '1108081008',
    districtId: '1108081',
    name: 'Data Makmur',
  },
  {
    id: '1108081009',
    districtId: '1108081',
    name: 'Kayee Kunyet',
  },
  {
    id: '1108081010',
    districtId: '1108081',
    name: 'Cot Meulangen',
  },
  {
    id: '1108081011',
    districtId: '1108081',
    name: 'Cot Nambak',
  },
  {
    id: '1108081012',
    districtId: '1108081',
    name: 'Cot Mancang',
  },
  {
    id: '1108081013',
    districtId: '1108081',
    name: 'Empee Bata',
  },
  {
    id: '1108081014',
    districtId: '1108081',
    name: 'Cot Bagi',
  },
  {
    id: '1108081015',
    districtId: '1108081',
    name: 'Teupin Batee',
  },
  {
    id: '1108081016',
    districtId: '1108081',
    name: 'Cot Leuot',
  },
  {
    id: '1108081017',
    districtId: '1108081',
    name: 'Cot Hoho',
  },
  {
    id: '1108081018',
    districtId: '1108081',
    name: 'Cot Jambo',
  },
  {
    id: '1108081019',
    districtId: '1108081',
    name: 'Cot Rumpun',
  },
  {
    id: '1108081020',
    districtId: '1108081',
    name: 'Bung Pageu',
  },
  {
    id: '1108081021',
    districtId: '1108081',
    name: 'Cot Sayun',
  },
  {
    id: '1108081022',
    districtId: '1108081',
    name: 'Cot Karieng',
  },
  {
    id: '1108081023',
    districtId: '1108081',
    name: 'Cot Malem',
  },
  {
    id: '1108081024',
    districtId: '1108081',
    name: 'Kampung Blang',
  },
  {
    id: '1108081025',
    districtId: '1108081',
    name: 'Bung Sidom',
  },
  {
    id: '1108081026',
    districtId: '1108081',
    name: 'Cot Madhi',
  },
  {
    id: '1108090001',
    districtId: '1108090',
    name: 'Kayee Lee',
  },
  {
    id: '1108090002',
    districtId: '1108090',
    name: 'Lam Teungoh',
  },
  {
    id: '1108090003',
    districtId: '1108090',
    name: 'Lubok Sukon',
  },
  {
    id: '1108090004',
    districtId: '1108090',
    name: 'Lubok Gapuy',
  },
  {
    id: '1108090005',
    districtId: '1108090',
    name: 'Lamdaya',
  },
  {
    id: '1108090006',
    districtId: '1108090',
    name: 'Lam Ue',
  },
  {
    id: '1108090007',
    districtId: '1108090',
    name: 'Paleuh Blang',
  },
  {
    id: '1108090008',
    districtId: '1108090',
    name: 'Paleuh Pulo',
  },
  {
    id: '1108090009',
    districtId: '1108090',
    name: 'Lambada',
  },
  {
    id: '1108090010',
    districtId: '1108090',
    name: 'Lamcot',
  },
  {
    id: '1108090011',
    districtId: '1108090',
    name: 'Lampreh Lamjampok',
  },
  {
    id: '1108090012',
    districtId: '1108090',
    name: 'Lam Sinyeu',
  },
  {
    id: '1108090013',
    districtId: '1108090',
    name: 'Cot Mentiwan',
  },
  {
    id: '1108090014',
    districtId: '1108090',
    name: 'Cot Alue',
  },
  {
    id: '1108090015',
    districtId: '1108090',
    name: 'Cot Gud',
  },
  {
    id: '1108090016',
    districtId: '1108090',
    name: 'Cot Bada',
  },
  {
    id: '1108090017',
    districtId: '1108090',
    name: 'Cot Suruy',
  },
  {
    id: '1108090018',
    districtId: '1108090',
    name: 'Ajee Cut',
  },
  {
    id: '1108090019',
    districtId: '1108090',
    name: 'Ajee Rayeuk',
  },
  {
    id: '1108090020',
    districtId: '1108090',
    name: 'Dham Pulo',
  },
  {
    id: '1108090021',
    districtId: '1108090',
    name: 'Pasie Lubuk',
  },
  {
    id: '1108090022',
    districtId: '1108090',
    name: 'Ujong XII',
  },
  {
    id: '1108090023',
    districtId: '1108090',
    name: 'Lampreh Lamteungoh',
  },
  {
    id: '1108090024',
    districtId: '1108090',
    name: 'Bada',
  },
  {
    id: '1108090025',
    districtId: '1108090',
    name: 'Lambaro',
  },
  {
    id: '1108090026',
    districtId: '1108090',
    name: 'Kalut',
  },
  {
    id: '1108090027',
    districtId: '1108090',
    name: 'Meunasah Manyet',
  },
  {
    id: '1108090028',
    districtId: '1108090',
    name: 'Ajee Pagar Air',
  },
  {
    id: '1108090029',
    districtId: '1108090',
    name: 'Lubok Batee',
  },
  {
    id: '1108090030',
    districtId: '1108090',
    name: 'Siron',
  },
  {
    id: '1108090031',
    districtId: '1108090',
    name: 'Meunasah Baro',
  },
  {
    id: '1108090032',
    districtId: '1108090',
    name: 'Pasie Lamgarot',
  },
  {
    id: '1108090033',
    districtId: '1108090',
    name: 'Dham Ceukok',
  },
  {
    id: '1108090034',
    districtId: '1108090',
    name: 'Gani',
  },
  {
    id: '1108090035',
    districtId: '1108090',
    name: 'Bueng Ceukok',
  },
  {
    id: '1108090036',
    districtId: '1108090',
    name: 'Teubang Phui',
  },
  {
    id: '1108090037',
    districtId: '1108090',
    name: 'Ateuk Lueng Ie',
  },
  {
    id: '1108090038',
    districtId: '1108090',
    name: 'Ateuk Anggok',
  },
  {
    id: '1108090039',
    districtId: '1108090',
    name: 'Bakoy',
  },
  {
    id: '1108090040',
    districtId: '1108090',
    name: 'Meunasah Manyang Lamgarot',
  },
  {
    id: '1108090041',
    districtId: '1108090',
    name: 'Meunasah Tutong',
  },
  {
    id: '1108090042',
    districtId: '1108090',
    name: 'Meunasah Deyah',
  },
  {
    id: '1108090043',
    districtId: '1108090',
    name: 'Jurong Peujeura',
  },
  {
    id: '1108090044',
    districtId: '1108090',
    name: 'Pantee',
  },
  {
    id: '1108090045',
    districtId: '1108090',
    name: 'Bineh Blang',
  },
  {
    id: '1108090046',
    districtId: '1108090',
    name: 'Reuloh',
  },
  {
    id: '1108090047',
    districtId: '1108090',
    name: 'Tanjong',
  },
  {
    id: '1108090048',
    districtId: '1108090',
    name: 'Meunasah Manyang Pagar Air',
  },
  {
    id: '1108090049',
    districtId: '1108090',
    name: 'Santan',
  },
  {
    id: '1108090050',
    districtId: '1108090',
    name: 'Mns Krueng',
  },
  {
    id: '1108091001',
    districtId: '1108091',
    name: 'Lampermai',
  },
  {
    id: '1108091002',
    districtId: '1108091',
    name: 'Miruk',
  },
  {
    id: '1108091003',
    districtId: '1108091',
    name: 'Gla Deyah',
  },
  {
    id: '1108091004',
    districtId: '1108091',
    name: 'Gla Meunasah Baro',
  },
  {
    id: '1108091005',
    districtId: '1108091',
    name: 'Meunasah Intan',
  },
  {
    id: '1108091006',
    districtId: '1108091',
    name: 'Meunasah Baet',
  },
  {
    id: '1108091007',
    districtId: '1108091',
    name: 'Meunasah Manyang',
  },
  {
    id: '1108091008',
    districtId: '1108091',
    name: 'Lamgapang',
  },
  {
    id: '1108091009',
    districtId: '1108091',
    name: 'Rumpet',
  },
  {
    id: '1108091010',
    districtId: '1108091',
    name: 'Bak Trieng',
  },
  {
    id: '1108091011',
    districtId: '1108091',
    name: 'Lueng Ie',
  },
  {
    id: '1108091012',
    districtId: '1108091',
    name: 'Meunasah Papeun',
  },
  {
    id: '1108100001',
    districtId: '1108100',
    name: 'Luthu Lamweu',
  },
  {
    id: '1108100002',
    districtId: '1108100',
    name: 'Baet Masjid',
  },
  {
    id: '1108100003',
    districtId: '1108100',
    name: 'Baet Lamphuot',
  },
  {
    id: '1108100004',
    districtId: '1108100',
    name: 'Baet Meesago',
  },
  {
    id: '1108100005',
    districtId: '1108100',
    name: 'Pantee Rawa',
  },
  {
    id: '1108100021',
    districtId: '1108100',
    name: 'Sibreh Keumudee',
  },
  {
    id: '1108100022',
    districtId: '1108100',
    name: 'Dilip Lamteungoh',
  },
  {
    id: '1108100023',
    districtId: '1108100',
    name: 'Dilip Bukti',
  },
  {
    id: '1108100024',
    districtId: '1108100',
    name: 'Reuhat Tuha',
  },
  {
    id: '1108100025',
    districtId: '1108100',
    name: 'Seumeureung',
  },
  {
    id: '1108100026',
    districtId: '1108100',
    name: 'Luthu Dayah Krueng',
  },
  {
    id: '1108100027',
    districtId: '1108100',
    name: 'Lamtanjong',
  },
  {
    id: '1108100028',
    districtId: '1108100',
    name: 'Lambirah',
  },
  {
    id: '1108100029',
    districtId: '1108100',
    name: 'Kayee Adang',
  },
  {
    id: '1108100031',
    districtId: '1108100',
    name: 'Tampok Blang',
  },
  {
    id: '1108100049',
    districtId: '1108100',
    name: 'Lamgeu Baro',
  },
  {
    id: '1108100050',
    districtId: '1108100',
    name: 'Lamgeu Tuha',
  },
  {
    id: '1108100051',
    districtId: '1108100',
    name: 'Lamlheu',
  },
  {
    id: '1108100052',
    districtId: '1108100',
    name: 'Lamteh Dayah',
  },
  {
    id: '1108100053',
    districtId: '1108100',
    name: 'Tampok Jeurat Raya',
  },
  {
    id: '1108100054',
    districtId: '1108100',
    name: 'Lampanah Ineu',
  },
  {
    id: '1108100055',
    districtId: '1108100',
    name: 'Kling Manyang',
  },
  {
    id: '1108100056',
    districtId: '1108100',
    name: 'Lampisang',
  },
  {
    id: '1108100057',
    districtId: '1108100',
    name: 'Lambaro Sibreh',
  },
  {
    id: '1108100058',
    districtId: '1108100',
    name: 'Weusiteh',
  },
  {
    id: '1108100059',
    districtId: '1108100',
    name: 'Aneuk Galong Titi',
  },
  {
    id: '1108100060',
    districtId: '1108100',
    name: 'Aneuk Galong Baro',
  },
  {
    id: '1108100061',
    districtId: '1108100',
    name: 'Meunasah Bakthu',
  },
  {
    id: '1108100062',
    districtId: '1108100',
    name: 'Blang Cut',
  },
  {
    id: '1108100063',
    districtId: '1108100',
    name: 'Meunasah Tuha',
  },
  {
    id: '1108100064',
    districtId: '1108100',
    name: 'Aneuk Batee',
  },
  {
    id: '1108100065',
    districtId: '1108100',
    name: 'Niron',
  },
  {
    id: '1108100066',
    districtId: '1108100',
    name: 'Bukloh',
  },
  {
    id: '1108100067',
    districtId: '1108100',
    name: 'Lambarih Jurong Raya',
  },
  {
    id: '1108100068',
    districtId: '1108100',
    name: 'Lambarih Bakmee',
  },
  {
    id: '1108101001',
    districtId: '1108101',
    name: 'Leubok Batee',
  },
  {
    id: '1108101002',
    districtId: '1108101',
    name: 'Leubok Buni',
  },
  {
    id: '1108101003',
    districtId: '1108101',
    name: 'Bughu',
  },
  {
    id: '1108101004',
    districtId: '1108101',
    name: 'Teu Dayah',
  },
  {
    id: '1108101005',
    districtId: '1108101',
    name: 'Lam Ara Tunong',
  },
  {
    id: '1108101006',
    districtId: '1108101',
    name: 'Lam Ara Eungkit',
  },
  {
    id: '1108101007',
    districtId: '1108101',
    name: 'Lam Ara Cut',
  },
  {
    id: '1108101008',
    districtId: '1108101',
    name: 'Leupung Cut',
  },
  {
    id: '1108101009',
    districtId: '1108101',
    name: 'Tumbo Baro',
  },
  {
    id: '1108101010',
    districtId: '1108101',
    name: 'Lambaro Samahani',
  },
  {
    id: '1108101011',
    districtId: '1108101',
    name: 'Leupung Riwat',
  },
  {
    id: '1108101012',
    districtId: '1108101',
    name: 'Leupung Rayeuk',
  },
  {
    id: '1108101013',
    districtId: '1108101',
    name: 'Reuleung Glumpang',
  },
  {
    id: '1108101014',
    districtId: '1108101',
    name: 'Reuleung Karieng',
  },
  {
    id: '1108101015',
    districtId: '1108101',
    name: 'Lamsiteh Cot',
  },
  {
    id: '1108102001',
    districtId: '1108102',
    name: 'Tan Tuha',
  },
  {
    id: '1108102002',
    districtId: '1108102',
    name: 'Blang Preh',
  },
  {
    id: '1108102003',
    districtId: '1108102',
    name: 'Blang Miro',
  },
  {
    id: '1108102004',
    districtId: '1108102',
    name: 'Bha Ulee Tutu',
  },
  {
    id: '1108102005',
    districtId: '1108102',
    name: 'Lambunot',
  },
  {
    id: '1108102006',
    districtId: '1108102',
    name: 'Lambatee',
  },
  {
    id: '1108102007',
    districtId: '1108102',
    name: 'Nya',
  },
  {
    id: '1108102008',
    districtId: '1108102',
    name: 'Krueng Mak',
  },
  {
    id: '1108102009',
    districtId: '1108102',
    name: 'Batee Linteung',
  },
  {
    id: '1108102010',
    districtId: '1108102',
    name: 'Ateuk Lamphang',
  },
  {
    id: '1108102011',
    districtId: '1108102',
    name: 'Ateuk Cut',
  },
  {
    id: '1108102012',
    districtId: '1108102',
    name: 'Ateuk Blang Asan',
  },
  {
    id: '1108102013',
    districtId: '1108102',
    name: 'Ateuk Mon Panah',
  },
  {
    id: '1108102014',
    districtId: '1108102',
    name: 'Ateuk Lam Ura',
  },
  {
    id: '1108102015',
    districtId: '1108102',
    name: 'Ateuk Lampeuot',
  },
  {
    id: '1108102016',
    districtId: '1108102',
    name: 'Lamjamee Dayah',
  },
  {
    id: '1108102017',
    districtId: '1108102',
    name: 'Lamjamee Lamkrak',
  },
  {
    id: '1108102018',
    districtId: '1108102',
    name: 'Lam Urit',
  },
  {
    id: '1108110014',
    districtId: '1108110',
    name: 'Deunong',
  },
  {
    id: '1108110015',
    districtId: '1108110',
    name: 'Leu Geu',
  },
  {
    id: '1108110017',
    districtId: '1108110',
    name: 'Lamsiteh',
  },
  {
    id: '1108110018',
    districtId: '1108110',
    name: 'Lampeuneuen',
  },
  {
    id: '1108110019',
    districtId: '1108110',
    name: 'Ulee Tuy',
  },
  {
    id: '1108110020',
    districtId: '1108110',
    name: 'Punie',
  },
  {
    id: '1108110021',
    districtId: '1108110',
    name: 'Leu Ue',
  },
  {
    id: '1108110022',
    districtId: '1108110',
    name: 'Geundring',
  },
  {
    id: '1108110023',
    districtId: '1108110',
    name: 'Pasheu Beutong',
  },
  {
    id: '1108110024',
    districtId: '1108110',
    name: 'Lampasi Engking',
  },
  {
    id: '1108110025',
    districtId: '1108110',
    name: 'Jeumpet Ajun',
  },
  {
    id: '1108110026',
    districtId: '1108110',
    name: 'Garot',
  },
  {
    id: '1108110027',
    districtId: '1108110',
    name: 'Gue Gajah',
  },
  {
    id: '1108110028',
    districtId: '1108110',
    name: 'Ulee Lueng',
  },
  {
    id: '1108110029',
    districtId: '1108110',
    name: 'Lam Bheu',
  },
  {
    id: '1108110030',
    districtId: '1108110',
    name: 'Kandang',
  },
  {
    id: '1108110031',
    districtId: '1108110',
    name: 'Daroy Kameu',
  },
  {
    id: '1108110032',
    districtId: '1108110',
    name: 'Tingkeum',
  },
  {
    id: '1108110033',
    districtId: '1108110',
    name: 'Lamtheun',
  },
  {
    id: '1108110034',
    districtId: '1108110',
    name: 'Lamsidaya',
  },
  {
    id: '1108110035',
    districtId: '1108110',
    name: 'Kuta Karang',
  },
  {
    id: '1108110036',
    districtId: '1108110',
    name: 'Lamkawee',
  },
  {
    id: '1108110037',
    districtId: '1108110',
    name: 'Lheu Blang',
  },
  {
    id: '1108110038',
    districtId: '1108110',
    name: 'Lagang',
  },
  {
    id: '1108110039',
    districtId: '1108110',
    name: 'Lamblang Manyang',
  },
  {
    id: '1108110040',
    districtId: '1108110',
    name: 'Lamblang Trieng',
  },
  {
    id: '1108110041',
    districtId: '1108110',
    name: 'Payaroh',
  },
  {
    id: '1108110042',
    districtId: '1108110',
    name: 'Lampeuneurut Ujong Blang',
  },
  {
    id: '1108110043',
    districtId: '1108110',
    name: 'Lampeuneurut Gampong',
  },
  {
    id: '1108110044',
    districtId: '1108110',
    name: 'Lamcot',
  },
  {
    id: '1108110045',
    districtId: '1108110',
    name: 'Lamreung',
  },
  {
    id: '1108110046',
    districtId: '1108110',
    name: 'Bayu',
  },
  {
    id: '1108111001',
    districtId: '1108111',
    name: 'Lambaro Biluy',
  },
  {
    id: '1108111002',
    districtId: '1108111',
    name: 'Empetring',
  },
  {
    id: '1108111003',
    districtId: '1108111',
    name: 'Biluy',
  },
  {
    id: '1108111004',
    districtId: '1108111',
    name: 'Lamsod',
  },
  {
    id: '1108111005',
    districtId: '1108111',
    name: 'Manee Dayah',
  },
  {
    id: '1108111006',
    districtId: '1108111',
    name: 'Lamtadok',
  },
  {
    id: '1108111007',
    districtId: '1108111',
    name: 'Lamkunyet',
  },
  {
    id: '1108111008',
    districtId: '1108111',
    name: 'Lhang',
  },
  {
    id: '1108111009',
    districtId: '1108111',
    name: 'Lambatee',
  },
  {
    id: '1108111010',
    districtId: '1108111',
    name: 'Turam',
  },
  {
    id: '1108111011',
    districtId: '1108111',
    name: 'Blang Kiree',
  },
  {
    id: '1108111012',
    districtId: '1108111',
    name: 'Teubalui',
  },
  {
    id: '1108111013',
    districtId: '1108111',
    name: 'Neusok',
  },
  {
    id: '1108111014',
    districtId: '1108111',
    name: 'Lam Bleut',
  },
  {
    id: '1108120001',
    districtId: '1108120',
    name: 'Beradeun',
  },
  {
    id: '1108120002',
    districtId: '1108120',
    name: 'Keuneueu',
  },
  {
    id: '1108120003',
    districtId: '1108120',
    name: 'Lampisang',
  },
  {
    id: '1108120004',
    districtId: '1108120',
    name: 'Rima Jeune',
  },
  {
    id: '1108120005',
    districtId: '1108120',
    name: 'Rima Keunerum',
  },
  {
    id: '1108120006',
    districtId: '1108120',
    name: 'Ajuen',
  },
  {
    id: '1108120007',
    districtId: '1108120',
    name: 'Lam Hasan',
  },
  {
    id: '1108120008',
    districtId: '1108120',
    name: 'Payatieng',
  },
  {
    id: '1108120009',
    districtId: '1108120',
    name: 'Lamgeu-Eu',
  },
  {
    id: '1108120010',
    districtId: '1108120',
    name: 'Lam Rukam',
  },
  {
    id: '1108120011',
    districtId: '1108120',
    name: 'Gurah',
  },
  {
    id: '1108120012',
    districtId: '1108120',
    name: 'Lam Isek',
  },
  {
    id: '1108120013',
    districtId: '1108120',
    name: 'Lam Keumok',
  },
  {
    id: '1108120014',
    districtId: '1108120',
    name: 'Lamlumpu',
  },
  {
    id: '1108120015',
    districtId: '1108120',
    name: 'Lam Teeh',
  },
  {
    id: '1108120016',
    districtId: '1108120',
    name: 'Baro',
  },
  {
    id: '1108120017',
    districtId: '1108120',
    name: 'Lam Manyang',
  },
  {
    id: '1108120018',
    districtId: '1108120',
    name: 'Lam Awee',
  },
  {
    id: '1108120019',
    districtId: '1108120',
    name: 'Meunasah Tuha',
  },
  {
    id: '1108120020',
    districtId: '1108120',
    name: 'Lam Teungoh',
  },
  {
    id: '1108120021',
    districtId: '1108120',
    name: 'Lam Tutui',
  },
  {
    id: '1108120022',
    districtId: '1108120',
    name: 'Lam Guron',
  },
  {
    id: '1108120023',
    districtId: '1108120',
    name: 'Lam Badeuk',
  },
  {
    id: '1108120024',
    districtId: '1108120',
    name: 'Lambaro Neujid',
  },
  {
    id: '1108120025',
    districtId: '1108120',
    name: 'Lam Pageu',
  },
  {
    id: '1108120026',
    districtId: '1108120',
    name: 'Pulo Bunta',
  },
  {
    id: '1108130001',
    districtId: '1108130',
    name: 'Teunom',
  },
  {
    id: '1108130002',
    districtId: '1108130',
    name: 'Pasi Janeng',
  },
  {
    id: '1108130003',
    districtId: '1108130',
    name: 'Alue Riyeung',
  },
  {
    id: '1108130004',
    districtId: '1108130',
    name: 'Deudap',
  },
  {
    id: '1108130005',
    districtId: '1108130',
    name: 'Rabo',
  },
  {
    id: '1108130006',
    districtId: '1108130',
    name: 'Lamteng',
  },
  {
    id: '1108130007',
    districtId: '1108130',
    name: 'Lhoh',
  },
  {
    id: '1108130008',
    districtId: '1108130',
    name: 'Lampuyang',
  },
  {
    id: '1108130009',
    districtId: '1108130',
    name: 'Lapeng',
  },
  {
    id: '1108130010',
    districtId: '1108130',
    name: 'Paloh',
  },
  {
    id: '1108130011',
    districtId: '1108130',
    name: 'Blang Situngkoh',
  },
  {
    id: '1108130012',
    districtId: '1108130',
    name: 'Ulee Paya',
  },
  {
    id: '1108130013',
    districtId: '1108130',
    name: 'Seurapong',
  },
  {
    id: '1108130014',
    districtId: '1108130',
    name: 'Gugob',
  },
  {
    id: '1108130015',
    districtId: '1108130',
    name: 'Alue Raya',
  },
  {
    id: '1108130016',
    districtId: '1108130',
    name: 'Rinon',
  },
  {
    id: '1108130017',
    districtId: '1108130',
    name: 'Melingge',
  },
  {
    id: '1109010003',
    districtId: '1109010',
    name: 'Keune',
  },
  {
    id: '1109010004',
    districtId: '1109010',
    name: 'Bangkeh',
  },
  {
    id: '1109010005',
    districtId: '1109010',
    name: 'Pulo Loih',
  },
  {
    id: '1109010006',
    districtId: '1109010',
    name: 'Pucok',
  },
  {
    id: '1109010007',
    districtId: '1109010',
    name: 'Leupu',
  },
  {
    id: '1109010008',
    districtId: '1109010',
    name: 'UPT V Geumpang',
  },
  {
    id: '1109011001',
    districtId: '1109011',
    name: 'Mane',
  },
  {
    id: '1109011002',
    districtId: '1109011',
    name: 'Turue Cut',
  },
  {
    id: '1109011003',
    districtId: '1109011',
    name: 'Lutueng',
  },
  {
    id: '1109011004',
    districtId: '1109011',
    name: 'Blang Dalam',
  },
  {
    id: '1109070001',
    districtId: '1109070',
    name: 'Kumbang Keupula',
  },
  {
    id: '1109070002',
    districtId: '1109070',
    name: 'Tufah Jeulatang',
  },
  {
    id: '1109070003',
    districtId: '1109070',
    name: 'Keutapang Mesjid',
  },
  {
    id: '1109070004',
    districtId: '1109070',
    name: 'Amud Mesjid',
  },
  {
    id: '1109070005',
    districtId: '1109070',
    name: 'Cot Tunong',
  },
  {
    id: '1109070006',
    districtId: '1109070',
    name: 'Cot Baroh',
  },
  {
    id: '1109070007',
    districtId: '1109070',
    name: 'Krueng Nyong',
  },
  {
    id: '1109070008',
    districtId: '1109070',
    name: 'Krueng Jangko',
  },
  {
    id: '1109070009',
    districtId: '1109070',
    name: 'Reudeup Meulayu',
  },
  {
    id: '1109070010',
    districtId: '1109070',
    name: 'Panjoe',
  },
  {
    id: '1109070011',
    districtId: '1109070',
    name: 'Pulo Gajah Matee',
  },
  {
    id: '1109070012',
    districtId: '1109070',
    name: 'Menje',
  },
  {
    id: '1109070013',
    districtId: '1109070',
    name: 'Jurong Pandee',
  },
  {
    id: '1109070014',
    districtId: '1109070',
    name: 'Pulo Lon/P.Dayah',
  },
  {
    id: '1109070015',
    districtId: '1109070',
    name: 'Kampung Jumpa',
  },
  {
    id: '1109070016',
    districtId: '1109070',
    name: 'Bili',
  },
  {
    id: '1109070017',
    districtId: '1109070',
    name: 'Dayah Tanoh',
  },
  {
    id: '1109070018',
    districtId: '1109070',
    name: 'Simpang',
  },
  {
    id: '1109070019',
    districtId: '1109070',
    name: 'Kayee Jatoe',
  },
  {
    id: '1109070020',
    districtId: '1109070',
    name: 'Kruet Teumpeun',
  },
  {
    id: '1109070021',
    districtId: '1109070',
    name: 'Sukon Baroh',
  },
  {
    id: '1109070022',
    districtId: '1109070',
    name: 'Blang Drang',
  },
  {
    id: '1109070023',
    districtId: '1109070',
    name: 'Mamplam',
  },
  {
    id: '1109070024',
    districtId: '1109070',
    name: 'Sukon Mesjid',
  },
  {
    id: '1109070025',
    districtId: '1109070',
    name: 'Pulo Batee',
  },
  {
    id: '1109070026',
    districtId: '1109070',
    name: 'Neurok',
  },
  {
    id: '1109070027',
    districtId: '1109070',
    name: 'Lambaro',
  },
  {
    id: '1109070028',
    districtId: '1109070',
    name: 'Blang Pueb',
  },
  {
    id: '1109070029',
    districtId: '1109070',
    name: 'Blang Tunong',
  },
  {
    id: '1109070030',
    districtId: '1109070',
    name: 'Dayah Kp. Pisang',
  },
  {
    id: '1109070031',
    districtId: '1109070',
    name: 'Balee',
  },
  {
    id: '1109070032',
    districtId: '1109070',
    name: 'Ude Gampong',
  },
  {
    id: '1109070033',
    districtId: '1109070',
    name: 'Kupula',
  },
  {
    id: '1109070039',
    districtId: '1109070',
    name: 'Pulo Leung Teuga',
  },
  {
    id: '1109071001',
    districtId: '1109071',
    name: 'Manyang',
  },
  {
    id: '1109071002',
    districtId: '1109071',
    name: 'Meunasah Sagoe',
  },
  {
    id: '1109071003',
    districtId: '1109071',
    name: 'Pulo Iboih',
  },
  {
    id: '1109071004',
    districtId: '1109071',
    name: 'Jurong Baro',
  },
  {
    id: '1109071005',
    districtId: '1109071',
    name: 'Geunteng',
  },
  {
    id: '1109071006',
    districtId: '1109071',
    name: 'Sukon Paku',
  },
  {
    id: '1109071007',
    districtId: '1109071',
    name: 'Blang Baroh',
  },
  {
    id: '1109071008',
    districtId: '1109071',
    name: 'Meunasah Sangget',
  },
  {
    id: '1109071009',
    districtId: '1109071',
    name: 'Meunasah Bungong',
  },
  {
    id: '1109071010',
    districtId: '1109071',
    name: 'Meunasah Seukee',
  },
  {
    id: '1109071011',
    districtId: '1109071',
    name: 'Pulo Panjou',
  },
  {
    id: '1109071012',
    districtId: '1109071',
    name: 'Seureukui/Cebrek',
  },
  {
    id: '1109071013',
    districtId: '1109071',
    name: 'Meunasah Daboih',
  },
  {
    id: '1109071014',
    districtId: '1109071',
    name: 'Bale Gantung',
  },
  {
    id: '1109071015',
    districtId: '1109071',
    name: 'Me Teumpeun',
  },
  {
    id: '1109071016',
    districtId: '1109071',
    name: 'U Bungkok',
  },
  {
    id: '1109071017',
    districtId: '1109071',
    name: 'Kumbang Unoe',
  },
  {
    id: '1109071018',
    districtId: '1109071',
    name: 'Glumpang Bungkok',
  },
  {
    id: '1109071019',
    districtId: '1109071',
    name: 'Meunasah Kumpang',
  },
  {
    id: '1109071020',
    districtId: '1109071',
    name: 'Meunasah Ukee',
  },
  {
    id: '1109071021',
    districtId: '1109071',
    name: 'Palong',
  },
  {
    id: '1109080032',
    districtId: '1109080',
    name: 'Paya Tiba',
  },
  {
    id: '1109080033',
    districtId: '1109080',
    name: 'Rapana',
  },
  {
    id: '1109080034',
    districtId: '1109080',
    name: 'Baro Yaman',
  },
  {
    id: '1109080044',
    districtId: '1109080',
    name: 'Sentosa',
  },
  {
    id: '1109080045',
    districtId: '1109080',
    name: 'Mesjid Yaman',
  },
  {
    id: '1109080046',
    districtId: '1109080',
    name: 'Baroh Barat Yaman',
  },
  {
    id: '1109080047',
    districtId: '1109080',
    name: 'Mee Teungoh',
  },
  {
    id: '1109080048',
    districtId: '1109080',
    name: 'Bale',
  },
  {
    id: '1109080049',
    districtId: '1109080',
    name: 'Lingkok',
  },
  {
    id: '1109080050',
    districtId: '1109080',
    name: 'Reului',
  },
  {
    id: '1109080051',
    districtId: '1109080',
    name: 'Dayah Syarif',
  },
  {
    id: '1109080052',
    districtId: '1109080',
    name: 'Ribeun',
  },
  {
    id: '1109080053',
    districtId: '1109080',
    name: 'Peureulak',
  },
  {
    id: '1109080054',
    districtId: '1109080',
    name: 'Kumbang',
  },
  {
    id: '1109080055',
    districtId: '1109080',
    name: 'Mee Panyang',
  },
  {
    id: '1109080056',
    districtId: '1109080',
    name: 'Blang Lileue',
  },
  {
    id: '1109080057',
    districtId: '1109080',
    name: 'Bale Baro Keumangan',
  },
  {
    id: '1109080058',
    districtId: '1109080',
    name: 'Mesjid Keumangan',
  },
  {
    id: '1109080059',
    districtId: '1109080',
    name: 'Lueng Sagoe',
  },
  {
    id: '1109080060',
    districtId: '1109080',
    name: 'Blang Beureueh',
  },
  {
    id: '1109080069',
    districtId: '1109080',
    name: 'Lampoh Sirong',
  },
  {
    id: '1109080070',
    districtId: '1109080',
    name: 'Pante Beureueh',
  },
  {
    id: '1109080071',
    districtId: '1109080',
    name: 'Paloh Kambuek',
  },
  {
    id: '1109080072',
    districtId: '1109080',
    name: 'Dayah Beureueh',
  },
  {
    id: '1109080073',
    districtId: '1109080',
    name: 'Blang Tidiek',
  },
  {
    id: '1109080074',
    districtId: '1109080',
    name: 'Jadan',
  },
  {
    id: '1109080075',
    districtId: '1109080',
    name: 'Tuha Gampong Gajah',
  },
  {
    id: '1109080076',
    districtId: '1109080',
    name: 'Dayah Tidiek',
  },
  {
    id: '1109080077',
    districtId: '1109080',
    name: 'Keumangan Cut',
  },
  {
    id: '1109081001',
    districtId: '1109081',
    name: 'Tong Peria',
  },
  {
    id: '1109081002',
    districtId: '1109081',
    name: 'Tong Weng',
  },
  {
    id: '1109081003',
    districtId: '1109081',
    name: 'Barieh',
  },
  {
    id: '1109081004',
    districtId: '1109081',
    name: 'Blangong Basah',
  },
  {
    id: '1109081005',
    districtId: '1109081',
    name: 'Kulam Ara',
  },
  {
    id: '1109081006',
    districtId: '1109081',
    name: 'Didoh',
  },
  {
    id: '1109081007',
    districtId: '1109081',
    name: 'Rinti',
  },
  {
    id: '1109081008',
    districtId: '1109081',
    name: 'Balee Ujong Rimba',
  },
  {
    id: '1109081009',
    districtId: '1109081',
    name: 'Meugit',
  },
  {
    id: '1109081010',
    districtId: '1109081',
    name: 'Empeh',
  },
  {
    id: '1109081011',
    districtId: '1109081',
    name: 'Mesjid Gumpueng',
  },
  {
    id: '1109081012',
    districtId: '1109081',
    name: 'Pulo Drien',
  },
  {
    id: '1109081013',
    districtId: '1109081',
    name: 'Simbe',
  },
  {
    id: '1109081014',
    districtId: '1109081',
    name: 'Ulee Gampong',
  },
  {
    id: '1109081015',
    districtId: '1109081',
    name: 'Mon Ara',
  },
  {
    id: '1109081016',
    districtId: '1109081',
    name: 'Baroh',
  },
  {
    id: '1109081017',
    districtId: '1109081',
    name: 'Baro Ujong Rimba',
  },
  {
    id: '1109081018',
    districtId: '1109081',
    name: 'Blang Riek',
  },
  {
    id: '1109081019',
    districtId: '1109081',
    name: 'Paloh Raya',
  },
  {
    id: '1109081020',
    districtId: '1109081',
    name: 'Nibong',
  },
  {
    id: '1109081021',
    districtId: '1109081',
    name: 'Paloh Lhok Usi',
  },
  {
    id: '1109081022',
    districtId: '1109081',
    name: 'Campli Usi',
  },
  {
    id: '1109081023',
    districtId: '1109081',
    name: 'Dayah Usi',
  },
  {
    id: '1109081024',
    districtId: '1109081',
    name: 'Paloh Tinggi',
  },
  {
    id: '1109081025',
    districtId: '1109081',
    name: 'Rambong',
  },
  {
    id: '1109081026',
    districtId: '1109081',
    name: 'Mee Tanjong Usi',
  },
  {
    id: '1109081027',
    districtId: '1109081',
    name: 'Mesjid Usi',
  },
  {
    id: '1109081028',
    districtId: '1109081',
    name: 'Gampong Cot Usi',
  },
  {
    id: '1109081029',
    districtId: '1109081',
    name: 'Reubat',
  },
  {
    id: '1109081030',
    districtId: '1109081',
    name: 'Tiba Raya',
  },
  {
    id: '1109081031',
    districtId: '1109081',
    name: 'Mesjid Tiba',
  },
  {
    id: '1109081032',
    districtId: '1109081',
    name: 'Jojo',
  },
  {
    id: '1109081033',
    districtId: '1109081',
    name: 'Gampong Lada',
  },
  {
    id: '1109081034',
    districtId: '1109081',
    name: 'Dayah Kumba',
  },
  {
    id: '1109081035',
    districtId: '1109081',
    name: 'Cot Kuthang',
  },
  {
    id: '1109081036',
    districtId: '1109081',
    name: 'Mesjid Jeurat Manyang',
  },
  {
    id: '1109081037',
    districtId: '1109081',
    name: 'Sagoe Teumpeun',
  },
  {
    id: '1109081038',
    districtId: '1109081',
    name: 'Dayah Tanoh',
  },
  {
    id: '1109081039',
    districtId: '1109081',
    name: 'Beureu Eh II',
  },
  {
    id: '1109081040',
    districtId: '1109081',
    name: 'Jiem',
  },
  {
    id: '1109081041',
    districtId: '1109081',
    name: 'Ulee Tutue',
  },
  {
    id: '1109081042',
    districtId: '1109081',
    name: 'Mecat Adan',
  },
  {
    id: '1109081043',
    districtId: '1109081',
    name: 'Karieng',
  },
  {
    id: '1109081044',
    districtId: '1109081',
    name: 'Rambot Adan',
  },
  {
    id: '1109081045',
    districtId: '1109081',
    name: 'Alue Adan',
  },
  {
    id: '1109081046',
    districtId: '1109081',
    name: 'Dayah Adan',
  },
  {
    id: '1109081047',
    districtId: '1109081',
    name: 'Mee Adan',
  },
  {
    id: '1109081048',
    districtId: '1109081',
    name: 'Jumphoih Adan',
  },
  {
    id: '1109090001',
    districtId: '1109090',
    name: 'Blang Rikui',
  },
  {
    id: '1109090002',
    districtId: '1109090',
    name: 'Panton Beunot',
  },
  {
    id: '1109090003',
    districtId: '1109090',
    name: 'Daya Cot',
  },
  {
    id: '1109090004',
    districtId: '1109090',
    name: 'Daya Kampong Baro',
  },
  {
    id: '1109090005',
    districtId: '1109090',
    name: 'Daya Baroh',
  },
  {
    id: '1109090006',
    districtId: '1109090',
    name: 'Daya Teungoh',
  },
  {
    id: '1109090007',
    districtId: '1109090',
    name: 'Pulo Keunari',
  },
  {
    id: '1109090008',
    districtId: '1109090',
    name: 'Pulo Glumpang',
  },
  {
    id: '1109090009',
    districtId: '1109090',
    name: 'Peunadok',
  },
  {
    id: '1109090010',
    districtId: '1109090',
    name: 'Pulo Tambo',
  },
  {
    id: '1109090011',
    districtId: '1109090',
    name: 'Mns. Mancang',
  },
  {
    id: '1109090012',
    districtId: '1109090',
    name: 'Mns. Panah',
  },
  {
    id: '1109090013',
    districtId: '1109090',
    name: 'Pulo Mesjid',
  },
  {
    id: '1109090014',
    districtId: '1109090',
    name: 'Trieng Cudo Tunong',
  },
  {
    id: '1109090015',
    districtId: '1109090',
    name: 'Mampree',
  },
  {
    id: '1109090016',
    districtId: '1109090',
    name: 'Trieng Cudo Baroh',
  },
  {
    id: '1109090017',
    districtId: '1109090',
    name: 'Rabo',
  },
  {
    id: '1109090018',
    districtId: '1109090',
    name: 'Pulo Siblah',
  },
  {
    id: '1109090019',
    districtId: '1109090',
    name: 'Lhok Igeuh',
  },
  {
    id: '1109100001',
    districtId: '1109100',
    name: 'Pulo Sejahtra',
  },
  {
    id: '1109100002',
    districtId: '1109100',
    name: 'Krueng Meuriam',
  },
  {
    id: '1109100003',
    districtId: '1109100',
    name: 'Peunalom II',
  },
  {
    id: '1109100004',
    districtId: '1109100',
    name: 'Peunalom I',
  },
  {
    id: '1109100005',
    districtId: '1109100',
    name: 'Pulo Baro',
  },
  {
    id: '1109100006',
    districtId: '1109100',
    name: 'Keude Tangse',
  },
  {
    id: '1109100007',
    districtId: '1109100',
    name: 'Pulo Mesjid I',
  },
  {
    id: '1109100008',
    districtId: '1109100',
    name: 'Pulo Mesjid II',
  },
  {
    id: '1109100009',
    districtId: '1109100',
    name: 'Blang Jeurat',
  },
  {
    id: '1109100010',
    districtId: '1109100',
    name: 'Layan',
  },
  {
    id: '1109100011',
    districtId: '1109100',
    name: 'Blang Dalam',
  },
  {
    id: '1109100012',
    districtId: '1109100',
    name: 'Ranto Panyang',
  },
  {
    id: '1109100013',
    districtId: '1109100',
    name: 'Blang Teungoh',
  },
  {
    id: '1109100014',
    districtId: '1109100',
    name: 'Blang Bungong',
  },
  {
    id: '1109100015',
    districtId: '1109100',
    name: 'Blang Dhod',
  },
  {
    id: '1109100016',
    districtId: '1109100',
    name: 'Paya Guci',
  },
  {
    id: '1109100017',
    districtId: '1109100',
    name: 'Ulee Gunong',
  },
  {
    id: '1109100018',
    districtId: '1109100',
    name: 'Keubon Nilam',
  },
  {
    id: '1109100019',
    districtId: '1109100',
    name: 'Pulo Seunong',
  },
  {
    id: '1109100020',
    districtId: '1109100',
    name: 'Pulo Kawa',
  },
  {
    id: '1109100021',
    districtId: '1109100',
    name: 'Neubok Badeuk',
  },
  {
    id: '1109100022',
    districtId: '1109100',
    name: 'Blang Malo',
  },
  {
    id: '1109100023',
    districtId: '1109100',
    name: 'Krueng Seukeuk',
  },
  {
    id: '1109100024',
    districtId: '1109100',
    name: 'Beungga',
  },
  {
    id: '1109100025',
    districtId: '1109100',
    name: 'Pulo Iee',
  },
  {
    id: '1109100026',
    districtId: '1109100',
    name: 'Alue Calong',
  },
  {
    id: '1109100027',
    districtId: '1109100',
    name: 'Lhok Keutapang',
  },
  {
    id: '1109100029',
    districtId: '1109100',
    name: 'Blang Pandak',
  },
  {
    id: '1109111001',
    districtId: '1109111',
    name: 'Pako',
  },
  {
    id: '1109111002',
    districtId: '1109111',
    name: 'Tunong',
  },
  {
    id: '1109111003',
    districtId: '1109111',
    name: 'Pulo Cahi',
  },
  {
    id: '1109111004',
    districtId: '1109111',
    name: 'Pulo Seupeng',
  },
  {
    id: '1109111005',
    districtId: '1109111',
    name: 'Papeuen Nicah',
  },
  {
    id: '1109111006',
    districtId: '1109111',
    name: 'Ugadeng',
  },
  {
    id: '1109111007',
    districtId: '1109111',
    name: 'Kumbang',
  },
  {
    id: '1109111008',
    districtId: '1109111',
    name: 'Sagoe',
  },
  {
    id: '1109111009',
    districtId: '1109111',
    name: 'Dayah Keumala',
  },
  {
    id: '1109111010',
    districtId: '1109111',
    name: 'Rheng',
  },
  {
    id: '1109111011',
    districtId: '1109111',
    name: 'Mesjid Nicah',
  },
  {
    id: '1109111012',
    districtId: '1109111',
    name: 'Asan Nicah',
  },
  {
    id: '1109111013',
    districtId: '1109111',
    name: 'Paloh Teungoh',
  },
  {
    id: '1109111014',
    districtId: '1109111',
    name: 'Jijiem',
  },
  {
    id: '1109111015',
    districtId: '1109111',
    name: 'Cot Kreh',
  },
  {
    id: '1109111016',
    districtId: '1109111',
    name: 'Pulo Baro',
  },
  {
    id: '1109111017',
    districtId: '1109111',
    name: 'Cot Nuran',
  },
  {
    id: '1109111018',
    districtId: '1109111',
    name: 'Pulo Pante',
  },
  {
    id: '1109112001',
    districtId: '1109112',
    name: 'Alue',
  },
  {
    id: '1109112002',
    districtId: '1109112',
    name: 'Blang Tho',
  },
  {
    id: '1109112003',
    districtId: '1109112',
    name: 'Asan Tongpeudeng',
  },
  {
    id: '1109112004',
    districtId: '1109112',
    name: 'Mesjid Tongpeudeng',
  },
  {
    id: '1109112005',
    districtId: '1109112',
    name: 'Pulo Loih',
  },
  {
    id: '1109112006',
    districtId: '1109112',
    name: 'Pulo Raya',
  },
  {
    id: '1109112007',
    districtId: '1109112',
    name: 'Paloh Naleung',
  },
  {
    id: '1109112008',
    districtId: '1109112',
    name: 'Dayah Menara',
  },
  {
    id: '1109112009',
    districtId: '1109112',
    name: 'Pante Siren',
  },
  {
    id: '1109112010',
    districtId: '1109112',
    name: 'Uke',
  },
  {
    id: '1109112011',
    districtId: '1109112',
    name: 'Pante Kulu',
  },
  {
    id: '1109112012',
    districtId: '1109112',
    name: 'Cut',
  },
  {
    id: '1109112013',
    districtId: '1109112',
    name: 'Lingkok',
  },
  {
    id: '1109120001',
    districtId: '1109120',
    name: 'Barieh',
  },
  {
    id: '1109120002',
    districtId: '1109120',
    name: 'Kandang',
  },
  {
    id: '1109120003',
    districtId: '1109120',
    name: 'Paloh Jeureula',
  },
  {
    id: '1109120004',
    districtId: '1109120',
    name: 'Cot Cantek',
  },
  {
    id: '1109120005',
    districtId: '1109120',
    name: 'Lhok Panah',
  },
  {
    id: '1109120006',
    districtId: '1109120',
    name: 'Blang Cot',
  },
  {
    id: '1109120007',
    districtId: '1109120',
    name: 'Blang Kumot Tunong',
  },
  {
    id: '1109120008',
    districtId: '1109120',
    name: 'Murong Cot',
  },
  {
    id: '1109120009',
    districtId: '1109120',
    name: 'Murong Lhok',
  },
  {
    id: '1109120010',
    districtId: '1109120',
    name: 'Gampong Cot',
  },
  {
    id: '1109120011',
    districtId: '1109120',
    name: 'Riweuk',
  },
  {
    id: '1109120012',
    districtId: '1109120',
    name: 'Mancang',
  },
  {
    id: '1109120013',
    districtId: '1109120',
    name: 'Kp Pisang Bucue',
  },
  {
    id: '1109120014',
    districtId: '1109120',
    name: 'Lingkok',
  },
  {
    id: '1109120015',
    districtId: '1109120',
    name: 'Cumbok Lie',
  },
  {
    id: '1109120016',
    districtId: '1109120',
    name: 'Blang Kumot Baroh',
  },
  {
    id: '1109120017',
    districtId: '1109120',
    name: 'Lam Ujong',
  },
  {
    id: '1109120018',
    districtId: '1109120',
    name: 'Cumbok Niwa',
  },
  {
    id: '1109120019',
    districtId: '1109120',
    name: 'Dayah Kp Pisang',
  },
  {
    id: '1109120020',
    districtId: '1109120',
    name: 'Leupuem Mesjid',
  },
  {
    id: '1109120021',
    districtId: '1109120',
    name: 'Jurong Pante',
  },
  {
    id: '1109120022',
    districtId: '1109120',
    name: 'Beutong Perlak',
  },
  {
    id: '1109120023',
    districtId: '1109120',
    name: 'Bucue',
  },
  {
    id: '1109120024',
    districtId: '1109120',
    name: 'Balue Tanoh',
  },
  {
    id: '1109120025',
    districtId: '1109120',
    name: 'Cot Sukon',
  },
  {
    id: '1109120026',
    districtId: '1109120',
    name: 'Balue Kulu',
  },
  {
    id: '1109120027',
    districtId: '1109120',
    name: 'Lhok Me',
  },
  {
    id: '1109120028',
    districtId: '1109120',
    name: 'Beutong Pocut',
  },
  {
    id: '1109120029',
    districtId: '1109120',
    name: 'Pasar Kota Bakti',
  },
  {
    id: '1109120030',
    districtId: '1109120',
    name: 'Gampong Baro',
  },
  {
    id: '1109120031',
    districtId: '1109120',
    name: 'Mns Blang',
  },
  {
    id: '1109120032',
    districtId: '1109120',
    name: 'Mns Bale',
  },
  {
    id: '1109120033',
    districtId: '1109120',
    name: 'Gampong Jumpa',
  },
  {
    id: '1109120034',
    districtId: '1109120',
    name: 'Pante Krueng',
  },
  {
    id: '1109120035',
    districtId: '1109120',
    name: 'Lameue Mns Raya',
  },
  {
    id: '1109120036',
    districtId: '1109120',
    name: 'Dayah Tuha',
  },
  {
    id: '1109120037',
    districtId: '1109120',
    name: 'Lameue Mns Baro',
  },
  {
    id: '1109120038',
    districtId: '1109120',
    name: 'Pulo Jumpa',
  },
  {
    id: '1109120039',
    districtId: '1109120',
    name: 'Pulo Keurembok',
  },
  {
    id: '1109120040',
    districtId: '1109120',
    name: 'Perlak Asan',
  },
  {
    id: '1109120041',
    districtId: '1109120',
    name: 'Perlak Baroh',
  },
  {
    id: '1109120042',
    districtId: '1109120',
    name: 'Mali Lamkuta',
  },
  {
    id: '1109120043',
    districtId: '1109120',
    name: 'Mali Uke',
  },
  {
    id: '1109120044',
    districtId: '1109120',
    name: 'Mali Guyui',
  },
  {
    id: '1109120045',
    districtId: '1109120',
    name: 'Tang Kueng',
  },
  {
    id: '1109120046',
    districtId: '1109120',
    name: 'Lameu Mns Leung',
  },
  {
    id: '1109120047',
    districtId: '1109120',
    name: 'Lhok Empeh',
  },
  {
    id: '1109120048',
    districtId: '1109120',
    name: 'Mali Mesjid',
  },
  {
    id: '1109120049',
    districtId: '1109120',
    name: 'Mali Cot',
  },
  {
    id: '1109130001',
    districtId: '1109130',
    name: 'Tuha Lala',
  },
  {
    id: '1109130002',
    districtId: '1109130',
    name: 'Meuyub Lala',
  },
  {
    id: '1109130003',
    districtId: '1109130',
    name: 'Kulu',
  },
  {
    id: '1109130004',
    districtId: '1109130',
    name: 'Lhok Lubu',
  },
  {
    id: '1109130005',
    districtId: '1109130',
    name: 'Krueng Lala',
  },
  {
    id: '1109130006',
    districtId: '1109130',
    name: 'Babah Jurong',
  },
  {
    id: '1109130007',
    districtId: '1109130',
    name: 'Mesjid Andeue',
  },
  {
    id: '1109130008',
    districtId: '1109130',
    name: 'Dayah Andeue',
  },
  {
    id: '1109130009',
    districtId: '1109130',
    name: 'Dayah Sinthop',
  },
  {
    id: '1109130010',
    districtId: '1109130',
    name: 'Pulo Tanjong',
  },
  {
    id: '1109130011',
    districtId: '1109130',
    name: 'Teumeucet',
  },
  {
    id: '1109130012',
    districtId: '1109130',
    name: 'Blang Cut',
  },
  {
    id: '1109130013',
    districtId: '1109130',
    name: 'Kumbang',
  },
  {
    id: '1109130014',
    districtId: '1109130',
    name: 'Blang',
  },
  {
    id: '1109130015',
    districtId: '1109130',
    name: 'Lagang',
  },
  {
    id: '1109130016',
    districtId: '1109130',
    name: 'Tunong Ilot',
  },
  {
    id: '1109130017',
    districtId: '1109130',
    name: 'Baroh Ilot',
  },
  {
    id: '1109130018',
    districtId: '1109130',
    name: 'Teungoh Ilot',
  },
  {
    id: '1109130019',
    districtId: '1109130',
    name: 'Mesjid Ilot',
  },
  {
    id: '1109130020',
    districtId: '1109130',
    name: 'Ara Bungkok',
  },
  {
    id: '1109140001',
    districtId: '1109140',
    name: 'Seunadeu Kunyet',
  },
  {
    id: '1109140002',
    districtId: '1109140',
    name: 'Blang Gunci Kunyet',
  },
  {
    id: '1109140003',
    districtId: '1109140',
    name: 'Kambuek Nicah',
  },
  {
    id: '1109140004',
    districtId: '1109140',
    name: 'Kambuek Payapi Kunyet',
  },
  {
    id: '1109140005',
    districtId: '1109140',
    name: 'Baro Kunyet',
  },
  {
    id: '1109140006',
    districtId: '1109140',
    name: 'Hagu Kunyet',
  },
  {
    id: '1109140007',
    districtId: '1109140',
    name: 'Piala Kunyet',
  },
  {
    id: '1109140008',
    districtId: '1109140',
    name: 'Mesjid Kunyet',
  },
  {
    id: '1109140009',
    districtId: '1109140',
    name: 'Dayah Tanoh Kunyet',
  },
  {
    id: '1109140010',
    districtId: '1109140',
    name: 'Cot Kunyet',
  },
  {
    id: '1109140011',
    districtId: '1109140',
    name: 'Blang Geuleudieng',
  },
  {
    id: '1109140012',
    districtId: '1109140',
    name: 'Mesjid Geuleudieng',
  },
  {
    id: '1109140013',
    districtId: '1109140',
    name: 'Perlak Peudaya',
  },
  {
    id: '1109140014',
    districtId: '1109140',
    name: 'Dayah Baroh Kunyet',
  },
  {
    id: '1109140015',
    districtId: '1109140',
    name: 'Buni Reuling Peudaya',
  },
  {
    id: '1109140016',
    districtId: '1109140',
    name: 'Buloh Peudaya',
  },
  {
    id: '1109140017',
    districtId: '1109140',
    name: 'Mesjid Peudaya',
  },
  {
    id: '1109140018',
    districtId: '1109140',
    name: 'Cut Peudaya',
  },
  {
    id: '1109140019',
    districtId: '1109140',
    name: 'Tunong Peudaya',
  },
  {
    id: '1109140020',
    districtId: '1109140',
    name: 'Seukeun Peudaya',
  },
  {
    id: '1109140021',
    districtId: '1109140',
    name: 'Tuha Peudaya',
  },
  {
    id: '1109140022',
    districtId: '1109140',
    name: 'Geulumpang Gld',
  },
  {
    id: '1109140023',
    districtId: '1109140',
    name: 'Kreet Paloh',
  },
  {
    id: '1109140024',
    districtId: '1109140',
    name: 'Capa Paloh',
  },
  {
    id: '1109140025',
    districtId: '1109140',
    name: 'Jurong Anoe',
  },
  {
    id: '1109140026',
    districtId: '1109140',
    name: 'Teugoh Peudaya',
  },
  {
    id: '1109140027',
    districtId: '1109140',
    name: 'Dayah Peudaya',
  },
  {
    id: '1109140028',
    districtId: '1109140',
    name: 'Cut Paloh',
  },
  {
    id: '1109140029',
    districtId: '1109140',
    name: 'Pante Cermen',
  },
  {
    id: '1109140030',
    districtId: '1109140',
    name: 'Meuke Gogo',
  },
  {
    id: '1109140031',
    districtId: '1109140',
    name: 'Raya Gogo',
  },
  {
    id: '1109140032',
    districtId: '1109140',
    name: 'Buloh Gogo',
  },
  {
    id: '1109140033',
    districtId: '1109140',
    name: 'Kumbang Gogo',
  },
  {
    id: '1109140034',
    districtId: '1109140',
    name: 'Tuha Gogo',
  },
  {
    id: '1109140035',
    districtId: '1109140',
    name: 'Glee Gogo',
  },
  {
    id: '1109140036',
    districtId: '1109140',
    name: 'Paloh Jeurat Beurabo',
  },
  {
    id: '1109140037',
    districtId: '1109140',
    name: 'Adang Beurabo',
  },
  {
    id: '1109140038',
    districtId: '1109140',
    name: 'Seuleungging Beurabo',
  },
  {
    id: '1109140039',
    districtId: '1109140',
    name: 'Meuke Beurabo',
  },
  {
    id: '1109140040',
    districtId: '1109140',
    name: 'Mesjid Beurabo',
  },
  {
    id: '1109140041',
    districtId: '1109140',
    name: 'Mesjid Gogo',
  },
  {
    id: '1109140042',
    districtId: '1109140',
    name: 'Aron Bunot Gogo',
  },
  {
    id: '1109140043',
    districtId: '1109140',
    name: 'Teungoh Drien Gogo',
  },
  {
    id: '1109140044',
    districtId: '1109140',
    name: 'Pasar Paloh',
  },
  {
    id: '1109140045',
    districtId: '1109140',
    name: 'Siron Paloh',
  },
  {
    id: '1109140046',
    districtId: '1109140',
    name: 'Balee  Paloh',
  },
  {
    id: '1109140047',
    districtId: '1109140',
    name: 'Suyo Paloh',
  },
  {
    id: '1109140048',
    districtId: '1109140',
    name: 'Gampong Cot Paloh',
  },
  {
    id: '1109140049',
    districtId: '1109140',
    name: 'Pulo Hagu Tanjung',
  },
  {
    id: '1109140050',
    districtId: '1109140',
    name: 'Trieng Paloh',
  },
  {
    id: '1109140051',
    districtId: '1109140',
    name: 'Leuhob Paloh',
  },
  {
    id: '1109140052',
    districtId: '1109140',
    name: 'Pante Crung Tanjong',
  },
  {
    id: '1109140053',
    districtId: '1109140',
    name: 'Grong Grong Gogo',
  },
  {
    id: '1109140054',
    districtId: '1109140',
    name: 'Seukeum Brok  Beurabo',
  },
  {
    id: '1109140055',
    districtId: '1109140',
    name: 'Baro Beurabo',
  },
  {
    id: '1109140056',
    districtId: '1109140',
    name: 'Meuriya Tanjong',
  },
  {
    id: '1109140057',
    districtId: '1109140',
    name: 'Khang Tanjong',
  },
  {
    id: '1109140058',
    districtId: '1109140',
    name: 'Leun Tanjong',
  },
  {
    id: '1109140059',
    districtId: '1109140',
    name: 'Cot Ketapang Tanjong',
  },
  {
    id: '1109140060',
    districtId: '1109140',
    name: 'Siron Tanjong',
  },
  {
    id: '1109140061',
    districtId: '1109140',
    name: 'Mesjid Tanjong',
  },
  {
    id: '1109140062',
    districtId: '1109140',
    name: 'Keupula Tanjong',
  },
  {
    id: '1109140063',
    districtId: '1109140',
    name: 'Jok Tanjong',
  },
  {
    id: '1109140064',
    districtId: '1109140',
    name: 'Tunong Tanjong',
  },
  {
    id: '1109150001',
    districtId: '1109150',
    name: 'Krueng Cot',
  },
  {
    id: '1109150002',
    districtId: '1109150',
    name: 'Dayah Baro',
  },
  {
    id: '1109150003',
    districtId: '1109150',
    name: 'Dayah Beuah',
  },
  {
    id: '1109150004',
    districtId: '1109150',
    name: 'Mesjid Beuah',
  },
  {
    id: '1109150005',
    districtId: '1109150',
    name: 'Sukon Lhong',
  },
  {
    id: '1109150006',
    districtId: '1109150',
    name: 'Seupeung',
  },
  {
    id: '1109150007',
    districtId: '1109150',
    name: 'Lhee Meunasah',
  },
  {
    id: '1109150008',
    districtId: '1109150',
    name: 'Puuk',
  },
  {
    id: '1109150009',
    districtId: '1109150',
    name: 'Ulee Tutue Raya',
  },
  {
    id: '1109150010',
    districtId: '1109150',
    name: 'Mesjid Aree',
  },
  {
    id: '1109150011',
    districtId: '1109150',
    name: 'Keurumbok',
  },
  {
    id: '1109150012',
    districtId: '1109150',
    name: 'Pulo Tunong',
  },
  {
    id: '1109150013',
    districtId: '1109150',
    name: 'Tunong',
  },
  {
    id: '1109150014',
    districtId: '1109150',
    name: 'Raya',
  },
  {
    id: '1109150015',
    districtId: '1109150',
    name: 'Daboh',
  },
  {
    id: '1109150016',
    districtId: '1109150',
    name: 'Cut',
  },
  {
    id: '1109150017',
    districtId: '1109150',
    name: 'Tanjung',
  },
  {
    id: '1109150018',
    districtId: '1109150',
    name: 'Buloh',
  },
  {
    id: '1109150019',
    districtId: '1109150',
    name: 'Dayah Reubee',
  },
  {
    id: '1109150020',
    districtId: '1109150',
    name: 'Bungo',
  },
  {
    id: '1109150021',
    districtId: '1109150',
    name: 'Kumbang',
  },
  {
    id: '1109150022',
    districtId: '1109150',
    name: 'Reuba',
  },
  {
    id: '1109150023',
    districtId: '1109150',
    name: 'Krueng',
  },
  {
    id: '1109150024',
    districtId: '1109150',
    name: 'Neulop',
  },
  {
    id: '1109150025',
    districtId: '1109150',
    name: 'Geudong',
  },
  {
    id: '1109150026',
    districtId: '1109150',
    name: 'Mesjid Reubee',
  },
  {
    id: '1109150027',
    districtId: '1109150',
    name: 'Ceurih Keupula',
  },
  {
    id: '1109150028',
    districtId: '1109150',
    name: 'Pulo Baroh',
  },
  {
    id: '1109150029',
    districtId: '1109150',
    name: 'Keutapang Aree',
  },
  {
    id: '1109150030',
    districtId: '1109150',
    name: 'Pantee',
  },
  {
    id: '1109150031',
    districtId: '1109150',
    name: 'Ceurih Blang Mee',
  },
  {
    id: '1109150032',
    districtId: '1109150',
    name: 'Ceurih Cot',
  },
  {
    id: '1109150033',
    districtId: '1109150',
    name: 'Ceurih Alue',
  },
  {
    id: '1109150034',
    districtId: '1109150',
    name: 'Reuntoh',
  },
  {
    id: '1109150035',
    districtId: '1109150',
    name: 'Jambee',
  },
  {
    id: '1109150036',
    districtId: '1109150',
    name: 'Glee',
  },
  {
    id: '1109150039',
    districtId: '1109150',
    name: 'Keutapang Bambong',
  },
  {
    id: '1109150040',
    districtId: '1109150',
    name: 'Pangoe',
  },
  {
    id: '1109150041',
    districtId: '1109150',
    name: 'Metareum',
  },
  {
    id: '1109150042',
    districtId: '1109150',
    name: 'Lueng Dama',
  },
  {
    id: '1109150043',
    districtId: '1109150',
    name: 'Rusep',
  },
  {
    id: '1109150044',
    districtId: '1109150',
    name: 'Mesjid Bambong',
  },
  {
    id: '1109150045',
    districtId: '1109150',
    name: 'Sagoe',
  },
  {
    id: '1109150046',
    districtId: '1109150',
    name: 'Seukeum',
  },
  {
    id: '1109151001',
    districtId: '1109151',
    name: 'Beureuleung',
  },
  {
    id: '1109151002',
    districtId: '1109151',
    name: 'Pangge/Pilok',
  },
  {
    id: '1109151003',
    districtId: '1109151',
    name: 'Nicah',
  },
  {
    id: '1109151004',
    districtId: '1109151',
    name: 'Mesjid Memeuaneuk',
  },
  {
    id: '1109151005',
    districtId: '1109151',
    name: 'Sentosa',
  },
  {
    id: '1109151006',
    districtId: '1109151',
    name: 'Sukon',
  },
  {
    id: '1109151007',
    districtId: '1109151',
    name: 'Daka',
  },
  {
    id: '1109151008',
    districtId: '1109151',
    name: 'Baroh Beureuleung',
  },
  {
    id: '1109151009',
    districtId: '1109151',
    name: 'Teungoh Beureuleung',
  },
  {
    id: '1109151010',
    districtId: '1109151',
    name: 'Mesjid Beureuleung',
  },
  {
    id: '1109151011',
    districtId: '1109151',
    name: 'Mee Beureuleung',
  },
  {
    id: '1109151012',
    districtId: '1109151',
    name: 'Paya',
  },
  {
    id: '1109151013',
    districtId: '1109151',
    name: 'Gintong',
  },
  {
    id: '1109151014',
    districtId: '1109151',
    name: 'Karieng',
  },
  {
    id: '1109151015',
    districtId: '1109151',
    name: 'Grong Grong',
  },
  {
    id: '1109160001',
    districtId: '1109160',
    name: 'Tuha Suwiek',
  },
  {
    id: '1109160002',
    districtId: '1109160',
    name: 'Mesjid Suwiek',
  },
  {
    id: '1109160003',
    districtId: '1109160',
    name: 'Teungoh Suwiek',
  },
  {
    id: '1109160004',
    districtId: '1109160',
    name: 'Beureudeup',
  },
  {
    id: '1109160005',
    districtId: '1109160',
    name: 'Sukon Ulga',
  },
  {
    id: '1109160006',
    districtId: '1109160',
    name: 'Peutoe',
  },
  {
    id: '1109160007',
    districtId: '1109160',
    name: 'Glee Gapui',
  },
  {
    id: '1109160008',
    districtId: '1109160',
    name: 'Mesjid Ulga',
  },
  {
    id: '1109160009',
    districtId: '1109160',
    name: 'Blang Rapai',
  },
  {
    id: '1109160010',
    districtId: '1109160',
    name: 'Balee Baroh Gapui',
  },
  {
    id: '1109160011',
    districtId: '1109160',
    name: 'Neulop II',
  },
  {
    id: '1109160012',
    districtId: '1109160',
    name: 'Baro Gapui',
  },
  {
    id: '1109160013',
    districtId: '1109160',
    name: 'Mesjid Dijiem',
  },
  {
    id: '1109160014',
    districtId: '1109160',
    name: 'Guci',
  },
  {
    id: '1109160015',
    districtId: '1109160',
    name: 'Wakeueh',
  },
  {
    id: '1109160016',
    districtId: '1109160',
    name: 'Dayah Bie',
  },
  {
    id: '1109160017',
    districtId: '1109160',
    name: 'Jurong',
  },
  {
    id: '1109160018',
    districtId: '1109160',
    name: 'Baro Bluek',
  },
  {
    id: '1109160019',
    districtId: '1109160',
    name: 'Rumia',
  },
  {
    id: '1109160020',
    districtId: '1109160',
    name: 'Keutapang',
  },
  {
    id: '1109160021',
    districtId: '1109160',
    name: 'Cot Seukee',
  },
  {
    id: '1109160022',
    districtId: '1109160',
    name: 'Drien',
  },
  {
    id: '1109160023',
    districtId: '1109160',
    name: 'Bale Baroh Bluek',
  },
  {
    id: '1109160024',
    districtId: '1109160',
    name: 'Teungoh Blang',
  },
  {
    id: '1109160025',
    districtId: '1109160',
    name: 'Meulayu',
  },
  {
    id: '1109160026',
    districtId: '1109160',
    name: 'Sukon Tungkop',
  },
  {
    id: '1109160027',
    districtId: '1109160',
    name: 'Keubang',
  },
  {
    id: '1109160028',
    districtId: '1109160',
    name: 'Garot Cut',
  },
  {
    id: '1109160029',
    districtId: '1109160',
    name: 'Rawa Tungkop',
  },
  {
    id: '1109160030',
    districtId: '1109160',
    name: 'Mesjid Tungkop',
  },
  {
    id: '1109160031',
    districtId: '1109160',
    name: 'Lamreuneung',
  },
  {
    id: '1109160032',
    districtId: '1109160',
    name: 'Lamkabu',
  },
  {
    id: '1109160033',
    districtId: '1109160',
    name: 'Mesjid Baro',
  },
  {
    id: '1109160034',
    districtId: '1109160',
    name: 'Tampieng Baroh',
  },
  {
    id: '1109160035',
    districtId: '1109160',
    name: 'Dayah Caleue',
  },
  {
    id: '1109160036',
    districtId: '1109160',
    name: 'Tampieng Tunong',
  },
  {
    id: '1109160037',
    districtId: '1109160',
    name: 'Ulee Birah',
  },
  {
    id: '1109160038',
    districtId: '1109160',
    name: 'Blang Lhok Kaju',
  },
  {
    id: '1109160039',
    districtId: '1109160',
    name: 'Baro Jruek',
  },
  {
    id: '1109160040',
    districtId: '1109160',
    name: 'Mesjid Lam Ujong',
  },
  {
    id: '1109160041',
    districtId: '1109160',
    name: 'Tungkop Cut',
  },
  {
    id: '1109160042',
    districtId: '1109160',
    name: 'Dayah Muara Garot',
  },
  {
    id: '1109160043',
    districtId: '1109160',
    name: 'Blang Garot',
  },
  {
    id: '1109160044',
    districtId: '1109160',
    name: 'Pulo Gampong U',
  },
  {
    id: '1109160045',
    districtId: '1109160',
    name: 'Dayah Keurako',
  },
  {
    id: '1109160046',
    districtId: '1109160',
    name: 'Yub Mee',
  },
  {
    id: '1109160047',
    districtId: '1109160',
    name: 'Raya Lhok Kaju',
  },
  {
    id: '1109160048',
    districtId: '1109160',
    name: 'Pante Garot',
  },
  {
    id: '1109160049',
    districtId: '1109160',
    name: 'Pante Lhok Kaju',
  },
  {
    id: '1109170001',
    districtId: '1109170',
    name: 'Bluek Arab',
  },
  {
    id: '1109170002',
    districtId: '1109170',
    name: 'Sialet Alet',
  },
  {
    id: '1109170003',
    districtId: '1109170',
    name: 'Mee Tanoh',
  },
  {
    id: '1109170004',
    districtId: '1109170',
    name: 'Puuk',
  },
  {
    id: '1109170005',
    districtId: '1109170',
    name: 'Balee',
  },
  {
    id: '1109170006',
    districtId: '1109170',
    name: 'Meunjee Mesjid',
  },
  {
    id: '1109170007',
    districtId: '1109170',
    name: 'Sumboe Buga',
  },
  {
    id: '1109170008',
    districtId: '1109170',
    name: 'Rambayan Kupula',
  },
  {
    id: '1109170009',
    districtId: '1109170',
    name: 'Rambayan Lueng',
  },
  {
    id: '1109170010',
    districtId: '1109170',
    name: 'Dayah Bubue',
  },
  {
    id: '1109170011',
    districtId: '1109170',
    name: 'Tanjong Hagu',
  },
  {
    id: '1109170012',
    districtId: '1109170',
    name: 'Dua Paya',
  },
  {
    id: '1109170013',
    districtId: '1109170',
    name: 'Mee Lampoih Saka',
  },
  {
    id: '1109170014',
    districtId: '1109170',
    name: 'Lueng Guci Rumpong',
  },
  {
    id: '1109170015',
    districtId: '1109170',
    name: 'Cot Mulu',
  },
  {
    id: '1109170016',
    districtId: '1109170',
    name: 'Kumbang Waido',
  },
  {
    id: '1109170017',
    districtId: '1109170',
    name: 'Waido',
  },
  {
    id: '1109170018',
    districtId: '1109170',
    name: 'Dayah Seumiden',
  },
  {
    id: '1109170019',
    districtId: '1109170',
    name: 'Blang Seupeng',
  },
  {
    id: '1109170020',
    districtId: '1109170',
    name: 'Dayah Muara',
  },
  {
    id: '1109170021',
    districtId: '1109170',
    name: 'Meuleuweuk',
  },
  {
    id: '1109170022',
    districtId: '1109170',
    name: 'Jim',
  },
  {
    id: '1109170023',
    districtId: '1109170',
    name: 'Kabat',
  },
  {
    id: '1109170024',
    districtId: '1109170',
    name: 'Leuhob',
  },
  {
    id: '1109170025',
    districtId: '1109170',
    name: 'Peunayong',
  },
  {
    id: '1109170026',
    districtId: '1109170',
    name: 'Mesjid Guci Rumpong',
  },
  {
    id: '1109170027',
    districtId: '1109170',
    name: 'Mee Krukon',
  },
  {
    id: '1109170028',
    districtId: '1109170',
    name: 'Reuba Waido',
  },
  {
    id: '1109170029',
    districtId: '1109170',
    name: 'Cempala Kuneng',
  },
  {
    id: '1109170030',
    districtId: '1109170',
    name: 'Ulee Cot Seupeng',
  },
  {
    id: '1109170031',
    districtId: '1109170',
    name: 'Sawiet',
  },
  {
    id: '1109170032',
    districtId: '1109170',
    name: 'Ulee Tutue',
  },
  {
    id: '1109170033',
    districtId: '1109170',
    name: 'Keutapang',
  },
  {
    id: '1109170034',
    districtId: '1109170',
    name: 'Jurong',
  },
  {
    id: '1109170035',
    districtId: '1109170',
    name: 'Raya Krueng Seumiden',
  },
  {
    id: '1109170036',
    districtId: '1109170',
    name: 'Krueng Seumiden',
  },
  {
    id: '1109170037',
    districtId: '1109170',
    name: 'Sukon Krueng Seumiden',
  },
  {
    id: '1109170038',
    districtId: '1109170',
    name: 'Blang Krueng Seumiden',
  },
  {
    id: '1109170039',
    districtId: '1109170',
    name: 'Keureumbok',
  },
  {
    id: '1109170040',
    districtId: '1109170',
    name: 'Mee Krueng Seumiden',
  },
  {
    id: '1109170041',
    districtId: '1109170',
    name: 'Blang Raya',
  },
  {
    id: '1109170042',
    districtId: '1109170',
    name: 'Dayah Teungku',
  },
  {
    id: '1109170043',
    districtId: '1109170',
    name: 'Jurong Raya',
  },
  {
    id: '1109170044',
    districtId: '1109170',
    name: 'Balee Rastong',
  },
  {
    id: '1109170045',
    districtId: '1109170',
    name: 'Lueng Mesjid',
  },
  {
    id: '1109170046',
    districtId: '1109170',
    name: 'Teungoh Baroh',
  },
  {
    id: '1109170047',
    districtId: '1109170',
    name: 'Mee Hagu',
  },
  {
    id: '1109170048',
    districtId: '1109170',
    name: 'Dayah Sukon',
  },
  {
    id: '1109180001',
    districtId: '1109180',
    name: 'Bentayan',
  },
  {
    id: '1109180002',
    districtId: '1109180',
    name: 'Meunasah Kandang',
  },
  {
    id: '1109180003',
    districtId: '1109180',
    name: 'Puuk',
  },
  {
    id: '1109180004',
    districtId: '1109180',
    name: 'Jurong Bale',
  },
  {
    id: '1109180005',
    districtId: '1109180',
    name: 'Aron Asan Kumbang',
  },
  {
    id: '1109180006',
    districtId: '1109180',
    name: 'Meunasah Mesjid',
  },
  {
    id: '1109180007',
    districtId: '1109180',
    name: 'Meunasah Mee',
  },
  {
    id: '1109180008',
    districtId: '1109180',
    name: 'Meunasah Teungoh',
  },
  {
    id: '1109180009',
    districtId: '1109180',
    name: 'Asan',
  },
  {
    id: '1109180010',
    districtId: '1109180',
    name: 'Panjou',
  },
  {
    id: '1109180011',
    districtId: '1109180',
    name: 'Jeumeurang',
  },
  {
    id: '1109180012',
    districtId: '1109180',
    name: 'Pusong',
  },
  {
    id: '1109180013',
    districtId: '1109180',
    name: 'Pasi Lhok',
  },
  {
    id: '1109180014',
    districtId: '1109180',
    name: 'Kayee Panyang',
  },
  {
    id: '1109180015',
    districtId: '1109180',
    name: 'Tanjong',
  },
  {
    id: '1109180016',
    districtId: '1109180',
    name: 'Lamkawe',
  },
  {
    id: '1109180017',
    districtId: '1109180',
    name: 'Blang Cut',
  },
  {
    id: '1109180018',
    districtId: '1109180',
    name: 'Geulumpang',
  },
  {
    id: '1109180019',
    districtId: '1109180',
    name: 'Aron Kuta Baro',
  },
  {
    id: '1109180020',
    districtId: '1109180',
    name: 'Araih',
  },
  {
    id: '1109180021',
    districtId: '1109180',
    name: 'Barat',
  },
  {
    id: '1109180022',
    districtId: '1109180',
    name: 'Teumpeun',
  },
  {
    id: '1109180023',
    districtId: '1109180',
    name: 'Reung Reung',
  },
  {
    id: '1109180024',
    districtId: '1109180',
    name: 'Dayah Blang',
  },
  {
    id: '1109180025',
    districtId: '1109180',
    name: 'Cebrek',
  },
  {
    id: '1109180026',
    districtId: '1109180',
    name: 'Dayah Mon Ara',
  },
  {
    id: '1109180027',
    districtId: '1109180',
    name: 'Jurong Mesjid',
  },
  {
    id: '1109180028',
    districtId: '1109180',
    name: 'Meunasah Gantung',
  },
  {
    id: '1109180029',
    districtId: '1109180',
    name: 'Babah Jurong',
  },
  {
    id: '1109180030',
    districtId: '1109180',
    name: 'Meuraksa',
  },
  {
    id: '1109180031',
    districtId: '1109180',
    name: 'Arusan',
  },
  {
    id: '1109180032',
    districtId: '1109180',
    name: 'Jareng',
  },
  {
    id: '1109180033',
    districtId: '1109180',
    name: 'Keupula',
  },
  {
    id: '1109180034',
    districtId: '1109180',
    name: 'Keureumbok',
  },
  {
    id: '1109180035',
    districtId: '1109180',
    name: 'Matang Kuli',
  },
  {
    id: '1109180036',
    districtId: '1109180',
    name: 'Meunasah Manyang',
  },
  {
    id: '1109180037',
    districtId: '1109180',
    name: 'Meunasah Krueng',
  },
  {
    id: '1109180038',
    districtId: '1109180',
    name: 'Meunasah Baro',
  },
  {
    id: '1109180039',
    districtId: '1109180',
    name: 'Sukon',
  },
  {
    id: '1109180040',
    districtId: '1109180',
    name: 'Ara',
  },
  {
    id: '1109180041',
    districtId: '1109180',
    name: 'Krueng Dhou',
  },
  {
    id: '1109180042',
    districtId: '1109180',
    name: 'Tanjong Krueng',
  },
  {
    id: '1109180043',
    districtId: '1109180',
    name: 'Lancang',
  },
  {
    id: '1109180044',
    districtId: '1109180',
    name: 'Keude Ie Leubeue',
  },
  {
    id: '1109180045',
    districtId: '1109180',
    name: 'Pasi Ie Leubeue',
  },
  {
    id: '1109190001',
    districtId: '1109190',
    name: 'Raya Paya',
  },
  {
    id: '1109190002',
    districtId: '1109190',
    name: 'Mesjid Bungie',
  },
  {
    id: '1109190003',
    districtId: '1109190',
    name: 'Liliep',
  },
  {
    id: '1109190004',
    districtId: '1109190',
    name: 'Ujong Baroh',
  },
  {
    id: '1109190005',
    districtId: '1109190',
    name: 'Seuk Cukok',
  },
  {
    id: '1109190006',
    districtId: '1109190',
    name: 'Pulo Tu',
  },
  {
    id: '1109190007',
    districtId: '1109190',
    name: 'Paloh Tok Due',
  },
  {
    id: '1109190008',
    districtId: '1109190',
    name: 'Meunasah Juerong',
  },
  {
    id: '1109190009',
    districtId: '1109190',
    name: 'Kampung Blang',
  },
  {
    id: '1109190010',
    districtId: '1109190',
    name: 'Kulam Baro',
  },
  {
    id: '1109190011',
    districtId: '1109190',
    name: 'Linggong Sagoe',
  },
  {
    id: '1109190012',
    districtId: '1109190',
    name: 'Blang Leuen',
  },
  {
    id: '1109190013',
    districtId: '1109190',
    name: 'Mesjid Tungue',
  },
  {
    id: '1109190014',
    districtId: '1109190',
    name: 'Ulee Barat',
  },
  {
    id: '1109190015',
    districtId: '1109190',
    name: 'Empeh',
  },
  {
    id: '1109190016',
    districtId: '1109190',
    name: 'Padang',
  },
  {
    id: '1109190017',
    districtId: '1109190',
    name: 'Dayah Blang',
  },
  {
    id: '1109190018',
    districtId: '1109190',
    name: 'Teungoh Mangki',
  },
  {
    id: '1109190019',
    districtId: '1109190',
    name: 'Dayah Blang Cut',
  },
  {
    id: '1109190020',
    districtId: '1109190',
    name: 'Nien',
  },
  {
    id: '1109190021',
    districtId: '1109190',
    name: 'Curucok Timur',
  },
  {
    id: '1109190022',
    districtId: '1109190',
    name: 'Jaja Tunong',
  },
  {
    id: '1109190023',
    districtId: '1109190',
    name: 'Ujong Gampong',
  },
  {
    id: '1109190024',
    districtId: '1109190',
    name: 'Lheue',
  },
  {
    id: '1109190025',
    districtId: '1109190',
    name: 'Jaja Baroh',
  },
  {
    id: '1109190026',
    districtId: '1109190',
    name: 'Pulo Raya',
  },
  {
    id: '1109190027',
    districtId: '1109190',
    name: 'Curucok Barat',
  },
  {
    id: '1109190028',
    districtId: '1109190',
    name: 'Curucok Sagoe',
  },
  {
    id: '1109190029',
    districtId: '1109190',
    name: 'Cot Ara',
  },
  {
    id: '1109190030',
    districtId: '1109190',
    name: 'Madika',
  },
  {
    id: '1109190031',
    districtId: '1109190',
    name: 'Sagoe',
  },
  {
    id: '1109190032',
    districtId: '1109190',
    name: 'Bunien',
  },
  {
    id: '1109190033',
    districtId: '1109190',
    name: 'Cot Paleue',
  },
  {
    id: '1109190034',
    districtId: '1109190',
    name: 'Raya Paleue',
  },
  {
    id: '1109190035',
    districtId: '1109190',
    name: 'Pante',
  },
  {
    id: '1109190036',
    districtId: '1109190',
    name: 'Pulo Blang',
  },
  {
    id: '1109190037',
    districtId: '1109190',
    name: 'Gong',
  },
  {
    id: '1109190038',
    districtId: '1109190',
    name: 'Mesjid Gigieng',
  },
  {
    id: '1109190039',
    districtId: '1109190',
    name: 'Cot Jaja',
  },
  {
    id: '1109190040',
    districtId: '1109190',
    name: 'Peukan Tuha',
  },
  {
    id: '1109190041',
    districtId: '1109190',
    name: 'Pulo Gajah Mate',
  },
  {
    id: '1109190042',
    districtId: '1109190',
    name: 'Meunasah Blang',
  },
  {
    id: '1109190043',
    districtId: '1109190',
    name: 'Mamplam',
  },
  {
    id: '1109190044',
    districtId: '1109190',
    name: 'Lambideng',
  },
  {
    id: '1109190045',
    districtId: '1109190',
    name: 'Seukee',
  },
  {
    id: '1109190046',
    districtId: '1109190',
    name: 'Meunasah Lhee',
  },
  {
    id: '1109190047',
    districtId: '1109190',
    name: 'Mantak Raya',
  },
  {
    id: '1109190048',
    districtId: '1109190',
    name: 'Dayah Lampoh Awe',
  },
  {
    id: '1109190049',
    districtId: '1109190',
    name: 'Kupula',
  },
  {
    id: '1109190050',
    districtId: '1109190',
    name: 'Sukon',
  },
  {
    id: '1109190051',
    districtId: '1109190',
    name: 'Cebrek',
  },
  {
    id: '1109190052',
    districtId: '1109190',
    name: 'Peukan Soet',
  },
  {
    id: '1109200001',
    districtId: '1109200',
    name: 'Tanjong Krueng',
  },
  {
    id: '1109200002',
    districtId: '1109200',
    name: 'Mns Peukan',
  },
  {
    id: '1109200003',
    districtId: '1109200',
    name: 'Gampong Asan',
  },
  {
    id: '1109200004',
    districtId: '1109200',
    name: 'Blang Asan',
  },
  {
    id: '1109200005',
    districtId: '1109200',
    name: 'Blok Sawah',
  },
  {
    id: '1109200006',
    districtId: '1109200',
    name: 'Pante Teungoh',
  },
  {
    id: '1109200007',
    districtId: '1109200',
    name: 'Kramat Dalam',
  },
  {
    id: '1109200008',
    districtId: '1109200',
    name: 'Kramat Luar',
  },
  {
    id: '1109200009',
    districtId: '1109200',
    name: 'Lampoh Krueng',
  },
  {
    id: '1109200010',
    districtId: '1109200',
    name: 'Pasi Peukan Baro',
  },
  {
    id: '1109200011',
    districtId: '1109200',
    name: 'Pasi Rawa',
  },
  {
    id: '1109200012',
    districtId: '1109200',
    name: 'Kuala Pidie',
  },
  {
    id: '1109200013',
    districtId: '1109200',
    name: 'Blok Bengkel',
  },
  {
    id: '1109200014',
    districtId: '1109200',
    name: 'Benteng',
  },
  {
    id: '1109200015',
    districtId: '1109200',
    name: 'Blang Paseh',
  },
  {
    id: '1109210001',
    districtId: '1109210',
    name: 'Tumpok Laweung',
  },
  {
    id: '1109210002',
    districtId: '1109210',
    name: 'Ulee Ceue Keulibeut',
  },
  {
    id: '1109210003',
    districtId: '1109210',
    name: 'Keudee',
  },
  {
    id: '1109210004',
    districtId: '1109210',
    name: 'Ulee Tutue',
  },
  {
    id: '1109210005',
    districtId: '1109210',
    name: 'Dalueng',
  },
  {
    id: '1109210006',
    districtId: '1109210',
    name: 'Jawa',
  },
  {
    id: '1109210007',
    districtId: '1109210',
    name: 'Abo',
  },
  {
    id: '1109210008',
    districtId: '1109210',
    name: 'Meucat',
  },
  {
    id: '1109210009',
    districtId: '1109210',
    name: 'Bayu',
  },
  {
    id: '1109210010',
    districtId: '1109210',
    name: 'Dayah Teubeng',
  },
  {
    id: '1109210011',
    districtId: '1109210',
    name: 'Gampong',
  },
  {
    id: '1109210012',
    districtId: '1109210',
    name: 'Cot Geunduek',
  },
  {
    id: '1109210013',
    districtId: '1109210',
    name: 'Dayah Tanoh',
  },
  {
    id: '1109210014',
    districtId: '1109210',
    name: 'Dayah Tutong',
  },
  {
    id: '1109210015',
    districtId: '1109210',
    name: 'Raya Sanggeue',
  },
  {
    id: '1109210016',
    districtId: '1109210',
    name: 'Sirong',
  },
  {
    id: '1109210017',
    districtId: '1109210',
    name: 'Keutumbu',
  },
  {
    id: '1109210018',
    districtId: '1109210',
    name: 'Jeuleupe',
  },
  {
    id: '1109210019',
    districtId: '1109210',
    name: 'Krueng Dhoe',
  },
  {
    id: '1109210020',
    districtId: '1109210',
    name: 'Keutapang',
  },
  {
    id: '1109210021',
    districtId: '1109210',
    name: 'Kampung Barat',
  },
  {
    id: '1109210022',
    districtId: '1109210',
    name: 'Kampong Pukat',
  },
  {
    id: '1109210023',
    districtId: '1109210',
    name: 'Labui',
  },
  {
    id: '1109210024',
    districtId: '1109210',
    name: 'Tanjong',
  },
  {
    id: '1109210025',
    districtId: '1109210',
    name: 'Tijue',
  },
  {
    id: '1109210026',
    districtId: '1109210',
    name: 'Paya',
  },
  {
    id: '1109210027',
    districtId: '1109210',
    name: 'Ulee Ceue Teubeng',
  },
  {
    id: '1109210028',
    districtId: '1109210',
    name: 'Dayah Teungoh',
  },
  {
    id: '1109210029',
    districtId: '1109210',
    name: 'Mesjid Runtoh',
  },
  {
    id: '1109210030',
    districtId: '1109210',
    name: 'Baroh',
  },
  {
    id: '1109210031',
    districtId: '1109210',
    name: 'Puuk',
  },
  {
    id: '1109210032',
    districtId: '1109210',
    name: 'Lampeudeu Tunong',
  },
  {
    id: '1109210033',
    districtId: '1109210',
    name: 'Lampeudeu Baroh',
  },
  {
    id: '1109210034',
    districtId: '1109210',
    name: 'Lampoh Lada',
  },
  {
    id: '1109210035',
    districtId: '1109210',
    name: 'Keuniree',
  },
  {
    id: '1109210036',
    districtId: '1109210',
    name: 'Cot Teungoh',
  },
  {
    id: '1109210037',
    districtId: '1109210',
    name: 'Cot Rheng',
  },
  {
    id: '1109210038',
    districtId: '1109210',
    name: 'Tumpok 40',
  },
  {
    id: '1109210039',
    districtId: '1109210',
    name: 'Pulo Pisang',
  },
  {
    id: '1109210040',
    districtId: '1109210',
    name: 'Paloh',
  },
  {
    id: '1109210041',
    districtId: '1109210',
    name: 'Lamkuta',
  },
  {
    id: '1109210042',
    districtId: '1109210',
    name: 'Lhok Keutapang',
  },
  {
    id: '1109210043',
    districtId: '1109210',
    name: 'Tibang',
  },
  {
    id: '1109210044',
    districtId: '1109210',
    name: 'Jeumpa',
  },
  {
    id: '1109210045',
    districtId: '1109210',
    name: 'Ujong Langgo',
  },
  {
    id: '1109210046',
    districtId: '1109210',
    name: 'Batee',
  },
  {
    id: '1109210047',
    districtId: '1109210',
    name: 'Bie',
  },
  {
    id: '1109210048',
    districtId: '1109210',
    name: 'Blangkula',
  },
  {
    id: '1109210049',
    districtId: '1109210',
    name: 'Alue',
  },
  {
    id: '1109210050',
    districtId: '1109210',
    name: 'Paya Linteung',
  },
  {
    id: '1109210051',
    districtId: '1109210',
    name: 'Seukee',
  },
  {
    id: '1109210052',
    districtId: '1109210',
    name: 'Seuri Weuk',
  },
  {
    id: '1109210053',
    districtId: '1109210',
    name: 'Puli',
  },
  {
    id: '1109210054',
    districtId: '1109210',
    name: 'Mesjid Utue',
  },
  {
    id: '1109210055',
    districtId: '1109210',
    name: 'Seukeumbrok',
  },
  {
    id: '1109210056',
    districtId: '1109210',
    name: 'Leubue',
  },
  {
    id: '1109210057',
    districtId: '1109210',
    name: 'Cot Geulumpang',
  },
  {
    id: '1109210058',
    districtId: '1109210',
    name: 'Gampong Baro',
  },
  {
    id: '1109210059',
    districtId: '1109210',
    name: 'Gajah Ayee',
  },
  {
    id: '1109210060',
    districtId: '1109210',
    name: 'Rawa',
  },
  {
    id: '1109210061',
    districtId: '1109210',
    name: 'Peukan Baro',
  },
  {
    id: '1109210062',
    districtId: '1109210',
    name: 'Pulo Bubee',
  },
  {
    id: '1109210063',
    districtId: '1109210',
    name: 'Mancang',
  },
  {
    id: '1109210064',
    districtId: '1109210',
    name: 'Raya Utue',
  },
  {
    id: '1109220001',
    districtId: '1109220',
    name: 'Kareung',
  },
  {
    id: '1109220002',
    districtId: '1109220',
    name: 'Awe',
  },
  {
    id: '1109220003',
    districtId: '1109220',
    name: 'Rungkom',
  },
  {
    id: '1109220004',
    districtId: '1109220',
    name: 'Pulo Pande',
  },
  {
    id: '1109220005',
    districtId: '1109220',
    name: 'Mee',
  },
  {
    id: '1109220006',
    districtId: '1109220',
    name: 'Alue Lada',
  },
  {
    id: '1109220007',
    districtId: '1109220',
    name: 'Seulatan',
  },
  {
    id: '1109220008',
    districtId: '1109220',
    name: 'Tuha',
  },
  {
    id: '1109220009',
    districtId: '1109220',
    name: 'Teupin Raya',
  },
  {
    id: '1109220010',
    districtId: '1109220',
    name: 'Calong Cut',
  },
  {
    id: '1109220011',
    districtId: '1109220',
    name: 'Dayah',
  },
  {
    id: '1109220012',
    districtId: '1109220',
    name: 'Meucat',
  },
  {
    id: '1109220013',
    districtId: '1109220',
    name: 'Aron',
  },
  {
    id: '1109220014',
    districtId: '1109220',
    name: 'Mesjid',
  },
  {
    id: '1109220015',
    districtId: '1109220',
    name: 'Bintang Hu',
  },
  {
    id: '1109220016',
    districtId: '1109220',
    name: 'Dayah Tuha',
  },
  {
    id: '1109220017',
    districtId: '1109220',
    name: 'Dayah Baroh',
  },
  {
    id: '1109220018',
    districtId: '1109220',
    name: 'Pulo Tukok',
  },
  {
    id: '1109220019',
    districtId: '1109220',
    name: 'Glumpang Lhee',
  },
  {
    id: '1109220020',
    districtId: '1109220',
    name: 'Geunteng Timur',
  },
  {
    id: '1109220021',
    districtId: '1109220',
    name: 'Geunteng Barat',
  },
  {
    id: '1109220022',
    districtId: '1109220',
    name: 'Pulo Bungong',
  },
  {
    id: '1109220023',
    districtId: '1109220',
    name: 'Teupin Jeue',
  },
  {
    id: '1109220024',
    districtId: '1109220',
    name: 'Neuheun',
  },
  {
    id: '1109220025',
    districtId: '1109220',
    name: 'Crueng',
  },
  {
    id: '1109220026',
    districtId: '1109220',
    name: 'Kulam',
  },
  {
    id: '1109220027',
    districtId: '1109220',
    name: 'Kulee',
  },
  {
    id: '1109220028',
    districtId: '1109220',
    name: 'Pasi Beurandeh',
  },
  {
    id: '1109230001',
    districtId: '1109230',
    name: 'Papeun',
  },
  {
    id: '1109230002',
    districtId: '1109230',
    name: 'Tuha Biheue',
  },
  {
    id: '1109230003',
    districtId: '1109230',
    name: 'Batee',
  },
  {
    id: '1109230004',
    districtId: '1109230',
    name: 'Ingin Jaya',
  },
  {
    id: '1109230005',
    districtId: '1109230',
    name: 'Blang Raya',
  },
  {
    id: '1109230006',
    districtId: '1109230',
    name: 'Ujong Pie',
  },
  {
    id: '1109230007',
    districtId: '1109230',
    name: 'Sagoe',
  },
  {
    id: '1109230008',
    districtId: '1109230',
    name: 'Ie Masen',
  },
  {
    id: '1109230009',
    districtId: '1109230',
    name: 'Krueng',
  },
  {
    id: '1109230010',
    districtId: '1109230',
    name: 'Gle Cut',
  },
  {
    id: '1109230011',
    districtId: '1109230',
    name: 'Deyah',
  },
  {
    id: '1109230012',
    districtId: '1109230',
    name: 'Pawod',
  },
  {
    id: '1109230013',
    districtId: '1109230',
    name: 'Sukajaya',
  },
  {
    id: '1109230014',
    districtId: '1109230',
    name: 'Keupula',
  },
  {
    id: '1109230015',
    districtId: '1109230',
    name: 'Mesjid',
  },
  {
    id: '1109230016',
    districtId: '1109230',
    name: 'Tgk. DI Laweung',
  },
  {
    id: '1109230017',
    districtId: '1109230',
    name: 'Cot',
  },
  {
    id: '1109230018',
    districtId: '1109230',
    name: 'Simpang Beutuong',
  },
  {
    id: '1110010001',
    districtId: '1110010',
    name: 'Meurah',
  },
  {
    id: '1110010002',
    districtId: '1110010',
    name: 'Cot Meurak Blang',
  },
  {
    id: '1110010003',
    districtId: '1110010',
    name: 'Batee Iliek',
  },
  {
    id: '1110010005',
    districtId: '1110010',
    name: 'Cot Meurak Baroh',
  },
  {
    id: '1110010006',
    districtId: '1110010',
    name: 'Mesjid Baro',
  },
  {
    id: '1110010007',
    districtId: '1110010',
    name: 'Darussalam',
  },
  {
    id: '1110010009',
    districtId: '1110010',
    name: 'Matang Wakeuh',
  },
  {
    id: '1110010010',
    districtId: '1110010',
    name: 'Matang Jareung',
  },
  {
    id: '1110010011',
    districtId: '1110010',
    name: 'Alue Barat',
  },
  {
    id: '1110010012',
    districtId: '1110010',
    name: 'Ulee Alue',
  },
  {
    id: '1110010013',
    districtId: '1110010',
    name: 'Cot Mane',
  },
  {
    id: '1110010034',
    districtId: '1110010',
    name: 'Paloh',
  },
  {
    id: '1110010035',
    districtId: '1110010',
    name: 'Gampong Meulum',
  },
  {
    id: '1110010036',
    districtId: '1110010',
    name: 'Geulumpang Bungkok',
  },
  {
    id: '1110010037',
    districtId: '1110010',
    name: 'Lancok',
  },
  {
    id: '1110010038',
    districtId: '1110010',
    name: 'Ulee Jeumatan',
  },
  {
    id: '1110010039',
    districtId: '1110010',
    name: 'Lhok Seumira',
  },
  {
    id: '1110010040',
    districtId: '1110010',
    name: 'Lueng Keubeu',
  },
  {
    id: '1110010041',
    districtId: '1110010',
    name: 'Mideun Geudong',
  },
  {
    id: '1110010042',
    districtId: '1110010',
    name: 'Meunasah Lueng',
  },
  {
    id: '1110010043',
    districtId: '1110010',
    name: 'Namploh Papeuen',
  },
  {
    id: '1110010044',
    districtId: '1110010',
    name: 'Meuliek',
  },
  {
    id: '1110010048',
    districtId: '1110010',
    name: 'Namploh Krueng',
  },
  {
    id: '1110010049',
    districtId: '1110010',
    name: 'Mideun Jok',
  },
  {
    id: '1110010050',
    districtId: '1110010',
    name: 'Gampong Putoh',
  },
  {
    id: '1110010051',
    districtId: '1110010',
    name: 'Namploh Baro',
  },
  {
    id: '1110010052',
    districtId: '1110010',
    name: 'Namploh Blang Garang',
  },
  {
    id: '1110010053',
    districtId: '1110010',
    name: 'Kandang',
  },
  {
    id: '1110010054',
    districtId: '1110010',
    name: 'Namploh Manyang',
  },
  {
    id: '1110010070',
    districtId: '1110010',
    name: 'Sangso',
  },
  {
    id: '1110010071',
    districtId: '1110010',
    name: 'Keude Aceh',
  },
  {
    id: '1110010072',
    districtId: '1110010',
    name: 'Gampong Baro',
  },
  {
    id: '1110010073',
    districtId: '1110010',
    name: 'Pineung Siri Bee',
  },
  {
    id: '1110010074',
    districtId: '1110010',
    name: 'Matang Teungoh',
  },
  {
    id: '1110010075',
    districtId: '1110010',
    name: 'Ulee Ue',
  },
  {
    id: '1110010076',
    districtId: '1110010',
    name: 'Tanjongan Idem',
  },
  {
    id: '1110010077',
    districtId: '1110010',
    name: 'Tanjong Baro',
  },
  {
    id: '1110010078',
    districtId: '1110010',
    name: 'Meunasah Lincah',
  },
  {
    id: '1110010079',
    districtId: '1110010',
    name: 'Ankieng Barat',
  },
  {
    id: '1110010080',
    districtId: '1110010',
    name: 'Meunasah Puuk',
  },
  {
    id: '1110010081',
    districtId: '1110010',
    name: 'Meunasah Lancok',
  },
  {
    id: '1110010082',
    districtId: '1110010',
    name: 'Cot Siren',
  },
  {
    id: '1110010084',
    districtId: '1110010',
    name: 'Pante Rheeng',
  },
  {
    id: '1110010085',
    districtId: '1110010',
    name: 'Pulo Baroh',
  },
  {
    id: '1110010086',
    districtId: '1110010',
    name: 'Matang',
  },
  {
    id: '1110010087',
    districtId: '1110010',
    name: 'Geulumpang Payong',
  },
  {
    id: '1110011001',
    districtId: '1110011',
    name: 'Gle Meundong',
  },
  {
    id: '1110011002',
    districtId: '1110011',
    name: 'Ie Rhob Babah Lueng',
  },
  {
    id: '1110011003',
    districtId: '1110011',
    name: 'Lhok Tanoh',
  },
  {
    id: '1110011004',
    districtId: '1110011',
    name: 'Krueng Meuseugob',
  },
  {
    id: '1110011005',
    districtId: '1110011',
    name: 'Paku',
  },
  {
    id: '1110011006',
    districtId: '1110011',
    name: 'Blang Tambue',
  },
  {
    id: '1110011007',
    districtId: '1110011',
    name: 'Meunasah Mamplam',
  },
  {
    id: '1110011008',
    districtId: '1110011',
    name: 'Pulo Dapong',
  },
  {
    id: '1110011009',
    districtId: '1110011',
    name: 'Cot Trieng',
  },
  {
    id: '1110011010',
    districtId: '1110011',
    name: 'Ie Rhob Timur',
  },
  {
    id: '1110011011',
    districtId: '1110011',
    name: 'Ie Rhob Barat',
  },
  {
    id: '1110011012',
    districtId: '1110011',
    name: 'Meunasah Dayah',
  },
  {
    id: '1110011013',
    districtId: '1110011',
    name: 'Pulo Drien',
  },
  {
    id: '1110011014',
    districtId: '1110011',
    name: 'Ie Rhob Geulumpang',
  },
  {
    id: '1110011015',
    districtId: '1110011',
    name: 'Ceureucok',
  },
  {
    id: '1110011016',
    districtId: '1110011',
    name: 'Arongan',
  },
  {
    id: '1110011017',
    districtId: '1110011',
    name: 'Balee',
  },
  {
    id: '1110011018',
    districtId: '1110011',
    name: 'Blang Mane Barat',
  },
  {
    id: '1110011019',
    districtId: '1110011',
    name: 'Blang Mane Dua Meunasah',
  },
  {
    id: '1110011020',
    districtId: '1110011',
    name: 'Jurong Binje',
  },
  {
    id: '1110011021',
    districtId: '1110011',
    name: 'Meunasah Mesjid',
  },
  {
    id: '1110011022',
    districtId: '1110011',
    name: 'Blang Teumulek',
  },
  {
    id: '1110011023',
    districtId: '1110011',
    name: 'Blang Kuta Dua Meunasah',
  },
  {
    id: '1110011024',
    districtId: '1110011',
    name: 'Blang Kuta Coh',
  },
  {
    id: '1110011025',
    districtId: '1110011',
    name: 'Rheum Timur',
  },
  {
    id: '1110011026',
    districtId: '1110011',
    name: 'Rheum Barat',
  },
  {
    id: '1110011027',
    districtId: '1110011',
    name: 'Rheum Barouh',
  },
  {
    id: '1110011028',
    districtId: '1110011',
    name: 'Lancang',
  },
  {
    id: '1110011029',
    districtId: '1110011',
    name: 'Keude Tambue',
  },
  {
    id: '1110011030',
    districtId: '1110011',
    name: 'Meunasah Asan',
  },
  {
    id: '1110011031',
    districtId: '1110011',
    name: 'Peuneulet Tunong',
  },
  {
    id: '1110011032',
    districtId: '1110011',
    name: 'Cure Tunong',
  },
  {
    id: '1110011033',
    districtId: '1110011',
    name: 'Cure Baroh',
  },
  {
    id: '1110011034',
    districtId: '1110011',
    name: 'Peunelet Baroh',
  },
  {
    id: '1110011035',
    districtId: '1110011',
    name: 'Ulee Kareung',
  },
  {
    id: '1110011036',
    districtId: '1110011',
    name: 'Alue Leuhob',
  },
  {
    id: '1110011037',
    districtId: '1110011',
    name: 'Blang Panyang',
  },
  {
    id: '1110011038',
    districtId: '1110011',
    name: 'Calok',
  },
  {
    id: '1110011039',
    districtId: '1110011',
    name: 'Meunasah Barat',
  },
  {
    id: '1110011040',
    districtId: '1110011',
    name: 'Tambue Barat',
  },
  {
    id: '1110011041',
    districtId: '1110011',
    name: 'Lhok Mane',
  },
  {
    id: '1110020001',
    districtId: '1110020',
    name: 'Seuneubok Baro',
  },
  {
    id: '1110020002',
    districtId: '1110020',
    name: 'Panton Bili',
  },
  {
    id: '1110020003',
    districtId: '1110020',
    name: 'Blang Sama Gadeng',
  },
  {
    id: '1110020004',
    districtId: '1110020',
    name: 'Cot Leubeng',
  },
  {
    id: '1110020005',
    districtId: '1110020',
    name: 'Bantayan',
  },
  {
    id: '1110020006',
    districtId: '1110020',
    name: 'Kuta Reusep',
  },
  {
    id: '1110020007',
    districtId: '1110020',
    name: 'G A R O T',
  },
  {
    id: '1110020008',
    districtId: '1110020',
    name: 'Gampong Blang',
  },
  {
    id: '1110020009',
    districtId: '1110020',
    name: 'Mns Teungoh',
  },
  {
    id: '1110020010',
    districtId: '1110020',
    name: 'Pandrah Janeng',
  },
  {
    id: '1110020011',
    districtId: '1110020',
    name: 'Pandrah Kandeh',
  },
  {
    id: '1110020012',
    districtId: '1110020',
    name: 'Mns. Reudeup',
  },
  {
    id: '1110020013',
    districtId: '1110020',
    name: 'Alue Igeueh',
  },
  {
    id: '1110020014',
    districtId: '1110020',
    name: 'Lhok Dagang',
  },
  {
    id: '1110020015',
    districtId: '1110020',
    name: 'Lancok Ulim',
  },
  {
    id: '1110020016',
    districtId: '1110020',
    name: 'Nase Me',
  },
  {
    id: '1110020017',
    districtId: '1110020',
    name: 'Panton',
  },
  {
    id: '1110020018',
    districtId: '1110020',
    name: 'Uteun Kruet',
  },
  {
    id: '1110020019',
    districtId: '1110020',
    name: 'Nase Barat',
  },
  {
    id: '1110030001',
    districtId: '1110030',
    name: 'Jeumpa Sikureung',
  },
  {
    id: '1110030002',
    districtId: '1110030',
    name: 'Blang Poroh',
  },
  {
    id: '1110030003',
    districtId: '1110030',
    name: 'Lhok Kulam',
  },
  {
    id: '1110030010',
    districtId: '1110030',
    name: 'Sampoi Ajad',
  },
  {
    id: '1110030011',
    districtId: '1110030',
    name: 'Ulee Blang',
  },
  {
    id: '1110030012',
    districtId: '1110030',
    name: 'Alue Seutui',
  },
  {
    id: '1110030013',
    districtId: '1110030',
    name: 'Blang Neubok',
  },
  {
    id: '1110030014',
    districtId: '1110030',
    name: 'Meunasah Alue',
  },
  {
    id: '1110030015',
    districtId: '1110030',
    name: 'Meunasah Tunong Lueng',
  },
  {
    id: '1110030016',
    districtId: '1110030',
    name: 'Lheue Simpang',
  },
  {
    id: '1110030017',
    districtId: '1110030',
    name: 'Lheue Barat',
  },
  {
    id: '1110030018',
    districtId: '1110030',
    name: 'Meunasah Dayah',
  },
  {
    id: '1110030019',
    districtId: '1110030',
    name: 'Meunasah Keupula',
  },
  {
    id: '1110030020',
    districtId: '1110030',
    name: 'Ulee Gajah',
  },
  {
    id: '1110030021',
    districtId: '1110030',
    name: 'Uteun Pupaleh',
  },
  {
    id: '1110030022',
    districtId: '1110030',
    name: 'Darul Aman',
  },
  {
    id: '1110030023',
    districtId: '1110030',
    name: 'Lampoh Oe',
  },
  {
    id: '1110030024',
    districtId: '1110030',
    name: 'Pulo Rangkileh',
  },
  {
    id: '1110030025',
    districtId: '1110030',
    name: 'Tufah',
  },
  {
    id: '1110030030',
    districtId: '1110030',
    name: 'Tanjong Bungong',
  },
  {
    id: '1110030031',
    districtId: '1110030',
    name: 'Dayah Baro',
  },
  {
    id: '1110030032',
    districtId: '1110030',
    name: 'Ulee Rabo',
  },
  {
    id: '1110030033',
    districtId: '1110030',
    name: 'Lhueng Tengoh',
  },
  {
    id: '1110030034',
    districtId: '1110030',
    name: 'Meunasah Tambo',
  },
  {
    id: '1110030035',
    districtId: '1110030',
    name: 'Meunasah Keutapang',
  },
  {
    id: '1110030036',
    districtId: '1110030',
    name: 'Cot Geulumpang Tunong',
  },
  {
    id: '1110030037',
    districtId: '1110030',
    name: 'Cot Geulumpang Baroh',
  },
  {
    id: '1110030038',
    districtId: '1110030',
    name: 'Keude Jeunieb',
  },
  {
    id: '1110030039',
    districtId: '1110030',
    name: 'Janggot Seungko',
  },
  {
    id: '1110030040',
    districtId: '1110030',
    name: 'Blang Mee Timu',
  },
  {
    id: '1110030041',
    districtId: '1110030',
    name: 'Matang Nibong',
  },
  {
    id: '1110030042',
    districtId: '1110030',
    name: 'Blang Mee Barat',
  },
  {
    id: '1110030043',
    districtId: '1110030',
    name: 'Matang Teungoh',
  },
  {
    id: '1110030044',
    districtId: '1110030',
    name: 'Matang Bangka',
  },
  {
    id: '1110030045',
    districtId: '1110030',
    name: 'Blang Lancang',
  },
  {
    id: '1110030046',
    districtId: '1110030',
    name: 'Lancang',
  },
  {
    id: '1110030047',
    districtId: '1110030',
    name: 'Teupin Keupula',
  },
  {
    id: '1110030057',
    districtId: '1110030',
    name: 'Meunasah Lueng',
  },
  {
    id: '1110030058',
    districtId: '1110030',
    name: 'Alue Lam Saba',
  },
  {
    id: '1110030059',
    districtId: '1110030',
    name: 'Dayah Blang Raleu',
  },
  {
    id: '1110030060',
    districtId: '1110030',
    name: 'Meunasah Blang',
  },
  {
    id: '1110030061',
    districtId: '1110030',
    name: 'Paya Bili',
  },
  {
    id: '1110030062',
    districtId: '1110030',
    name: 'Meunasah Kota',
  },
  {
    id: '1110031001',
    districtId: '1110031',
    name: 'Balee Daka',
  },
  {
    id: '1110031002',
    districtId: '1110031',
    name: 'Matang Kule',
  },
  {
    id: '1110031003',
    districtId: '1110031',
    name: 'Lancok Bungo',
  },
  {
    id: '1110031004',
    districtId: '1110031',
    name: 'Teupin Panah',
  },
  {
    id: '1110031005',
    districtId: '1110031',
    name: 'Seuneubok Punti',
  },
  {
    id: '1110031006',
    districtId: '1110031',
    name: 'Uteun Rungkom',
  },
  {
    id: '1110031007',
    districtId: '1110031',
    name: 'Uteun Sikumbong',
  },
  {
    id: '1110031008',
    districtId: '1110031',
    name: 'Jambo Dalam',
  },
  {
    id: '1110031009',
    districtId: '1110031',
    name: 'Paloh Pupu',
  },
  {
    id: '1110031010',
    districtId: '1110031',
    name: 'Rambong Payong',
  },
  {
    id: '1110031011',
    districtId: '1110031',
    name: 'Cot Geulumpang',
  },
  {
    id: '1110031012',
    districtId: '1110031',
    name: 'Seuneubok Aceh',
  },
  {
    id: '1110031013',
    districtId: '1110031',
    name: 'Seuneubok Nalan',
  },
  {
    id: '1110031014',
    districtId: '1110031',
    name: 'Krueng Baro',
  },
  {
    id: '1110031015',
    districtId: '1110031',
    name: 'Keude Plimbang',
  },
  {
    id: '1110031016',
    districtId: '1110031',
    name: 'Puuek',
  },
  {
    id: '1110031017',
    districtId: '1110031',
    name: 'Padang Kasab',
  },
  {
    id: '1110031018',
    districtId: '1110031',
    name: 'Seuneubok Seumawe',
  },
  {
    id: '1110031019',
    districtId: '1110031',
    name: 'Seuneubok Plimbang',
  },
  {
    id: '1110031020',
    districtId: '1110031',
    name: 'Seuneubok Teungoh',
  },
  {
    id: '1110031021',
    districtId: '1110031',
    name: 'Garab',
  },
  {
    id: '1110031022',
    districtId: '1110031',
    name: 'Kuta Trieng',
  },
  {
    id: '1110040001',
    districtId: '1110040',
    name: 'Blang Rangkuluh',
  },
  {
    id: '1110040002',
    districtId: '1110040',
    name: 'Alue Sijuek',
  },
  {
    id: '1110040003',
    districtId: '1110040',
    name: 'Buket Paya',
  },
  {
    id: '1110040004',
    districtId: '1110040',
    name: 'Dayah Mon Ara',
  },
  {
    id: '1110040005',
    districtId: '1110040',
    name: 'Pulo Ara',
  },
  {
    id: '1110040006',
    districtId: '1110040',
    name: 'Cot Laot',
  },
  {
    id: '1110040007',
    districtId: '1110040',
    name: 'Meunasah Bungo',
  },
  {
    id: '1110040008',
    districtId: '1110040',
    name: 'Paya Bunot',
  },
  {
    id: '1110040009',
    districtId: '1110040',
    name: 'Cot Keutapang',
  },
  {
    id: '1110040010',
    districtId: '1110040',
    name: 'Lawang',
  },
  {
    id: '1110040011',
    districtId: '1110040',
    name: 'Hagu',
  },
  {
    id: '1110040012',
    districtId: '1110040',
    name: 'Meunasah Krueng',
  },
  {
    id: '1110040013',
    districtId: '1110040',
    name: 'Meunasah Rabo',
  },
  {
    id: '1110040014',
    districtId: '1110040',
    name: 'Meunasah Tambo',
  },
  {
    id: '1110040015',
    districtId: '1110040',
    name: 'Meunasah Baroh',
  },
  {
    id: '1110040016',
    districtId: '1110040',
    name: 'Blang Matang',
  },
  {
    id: '1110040017',
    districtId: '1110040',
    name: 'Meunasah Tunong',
  },
  {
    id: '1110040018',
    districtId: '1110040',
    name: 'Meunasah Alue',
  },
  {
    id: '1110040019',
    districtId: '1110040',
    name: 'Blang Bati',
  },
  {
    id: '1110040020',
    districtId: '1110040',
    name: 'Keude Alue Rheing',
  },
  {
    id: '1110040021',
    districtId: '1110040',
    name: 'Pulo Lawang',
  },
  {
    id: '1110040022',
    districtId: '1110040',
    name: 'Karieng',
  },
  {
    id: '1110040023',
    districtId: '1110040',
    name: 'Blang Glumpang',
  },
  {
    id: '1110040024',
    districtId: '1110040',
    name: 'Meunasah Mesjid',
  },
  {
    id: '1110040025',
    districtId: '1110040',
    name: 'Meunasah Cut',
  },
  {
    id: '1110040026',
    districtId: '1110040',
    name: 'Matang Reuleut',
  },
  {
    id: '1110040027',
    districtId: '1110040',
    name: 'Meunasah Pulo',
  },
  {
    id: '1110040028',
    districtId: '1110040',
    name: 'Ara Bungong',
  },
  {
    id: '1110040029',
    districtId: '1110040',
    name: 'Garot',
  },
  {
    id: '1110040030',
    districtId: '1110040',
    name: 'Blang Beururu',
  },
  {
    id: '1110040031',
    districtId: '1110040',
    name: 'Jabet',
  },
  {
    id: '1110040032',
    districtId: '1110040',
    name: 'Sawang',
  },
  {
    id: '1110040033',
    districtId: '1110040',
    name: 'Blang Kubu',
  },
  {
    id: '1110040034',
    districtId: '1110040',
    name: 'Matang Pasi',
  },
  {
    id: '1110040035',
    districtId: '1110040',
    name: 'Kukue',
  },
  {
    id: '1110040036',
    districtId: '1110040',
    name: 'Meunasah Blang',
  },
  {
    id: '1110040037',
    districtId: '1110040',
    name: 'Gampong Baro',
  },
  {
    id: '1110040038',
    districtId: '1110040',
    name: 'Gampong Paya',
  },
  {
    id: '1110040039',
    districtId: '1110040',
    name: 'Seuneubok Paya',
  },
  {
    id: '1110040040',
    districtId: '1110040',
    name: 'Meunasah Teungoh',
  },
  {
    id: '1110040041',
    districtId: '1110040',
    name: 'Calok',
  },
  {
    id: '1110040042',
    districtId: '1110040',
    name: 'Tanjong Seulamat',
  },
  {
    id: '1110040043',
    districtId: '1110040',
    name: 'Jaba',
  },
  {
    id: '1110040044',
    districtId: '1110040',
    name: 'Cot Kruet',
  },
  {
    id: '1110040045',
    districtId: '1110040',
    name: 'Alue Keutapang',
  },
  {
    id: '1110040046',
    districtId: '1110040',
    name: 'Alue Gandai',
  },
  {
    id: '1110040047',
    districtId: '1110040',
    name: 'Tgk.DI Bathon',
  },
  {
    id: '1110040048',
    districtId: '1110040',
    name: 'Paya Barat',
  },
  {
    id: '1110040049',
    districtId: '1110040',
    name: 'Gampong Mulia',
  },
  {
    id: '1110040050',
    districtId: '1110040',
    name: 'Neubok Naleung',
  },
  {
    id: '1110040051',
    districtId: '1110040',
    name: 'Paya Timu',
  },
  {
    id: '1110040052',
    districtId: '1110040',
    name: 'Pinto Rimba',
  },
  {
    id: '1110050001',
    districtId: '1110050',
    name: 'Krueng Simpo',
  },
  {
    id: '1110050002',
    districtId: '1110050',
    name: 'Teupin Manee',
  },
  {
    id: '1110050003',
    districtId: '1110050',
    name: 'Bunyot',
  },
  {
    id: '1110050004',
    districtId: '1110050',
    name: 'Pante Baro',
  },
  {
    id: '1110050005',
    districtId: '1110050',
    name: 'Mane Meujingki',
  },
  {
    id: '1110050006',
    districtId: '1110050',
    name: 'Abeuk Budi',
  },
  {
    id: '1110050007',
    districtId: '1110050',
    name: 'Blang Keutumba',
  },
  {
    id: '1110050008',
    districtId: '1110050',
    name: 'Seuneubok Peuraden',
  },
  {
    id: '1110050009',
    districtId: '1110050',
    name: 'Paya Cut',
  },
  {
    id: '1110050010',
    districtId: '1110050',
    name: 'Alue Unou',
  },
  {
    id: '1110050011',
    districtId: '1110050',
    name: 'Batee Raya',
  },
  {
    id: '1110050012',
    districtId: '1110050',
    name: 'Juli Mee Teungoh',
  },
  {
    id: '1110050013',
    districtId: '1110050',
    name: 'Seuneubok Gunci',
  },
  {
    id: '1110050014',
    districtId: '1110050',
    name: 'Geulumpang Meu Jimjim',
  },
  {
    id: '1110050016',
    districtId: '1110050',
    name: 'Juli Tamboi Tanjong',
  },
  {
    id: '1110050017',
    districtId: '1110050',
    name: 'Juli Seutuy',
  },
  {
    id: '1110050018',
    districtId: '1110050',
    name: 'Juli Cot Mesjid',
  },
  {
    id: '1110050019',
    districtId: '1110050',
    name: 'Suka Tani',
  },
  {
    id: '1110050020',
    districtId: '1110050',
    name: 'Juli Keudee Dua',
  },
  {
    id: '1110050021',
    districtId: '1110050',
    name: 'Simpang Jaya',
  },
  {
    id: '1110050022',
    districtId: '1110050',
    name: 'Alue Rambong',
  },
  {
    id: '1110050023',
    districtId: '1110050',
    name: 'Buket Mulia',
  },
  {
    id: '1110050024',
    districtId: '1110050',
    name: 'Juli Meunasah Teungoh',
  },
  {
    id: '1110050025',
    districtId: '1110050',
    name: 'Juli Tgk Dilampoh',
  },
  {
    id: '1110050026',
    districtId: '1110050',
    name: 'Juli Seupeng',
  },
  {
    id: '1110050027',
    districtId: '1110050',
    name: 'Juli Meunasah Tambo',
  },
  {
    id: '1110050028',
    districtId: '1110050',
    name: 'Paseh',
  },
  {
    id: '1110050029',
    districtId: '1110050',
    name: 'Juli Paya Ru',
  },
  {
    id: '1110050030',
    districtId: '1110050',
    name: 'Juli Cot Meurak',
  },
  {
    id: '1110050031',
    districtId: '1110050',
    name: 'Ranto Panyang',
  },
  {
    id: '1110050032',
    districtId: '1110050',
    name: 'Seuneubok Dalam',
  },
  {
    id: '1110050033',
    districtId: '1110050',
    name: 'Balee Panah',
  },
  {
    id: '1110050034',
    districtId: '1110050',
    name: 'Simpang Mulia',
  },
  {
    id: '1110050035',
    districtId: '1110050',
    name: 'Juli Meunasah Jok',
  },
  {
    id: '1110050036',
    districtId: '1110050',
    name: 'Juli Uroek Anoe',
  },
  {
    id: '1110050037',
    districtId: '1110050',
    name: 'Pante Peusangan',
  },
  {
    id: '1110060001',
    districtId: '1110060',
    name: 'Abeuk Usong',
  },
  {
    id: '1110060002',
    districtId: '1110060',
    name: 'Blang Seupeng',
  },
  {
    id: '1110060003',
    districtId: '1110060',
    name: 'Cot Iboih',
  },
  {
    id: '1110060004',
    districtId: '1110060',
    name: 'Seuneubok Lhong',
  },
  {
    id: '1110060005',
    districtId: '1110060',
    name: 'Paloh Panyang',
  },
  {
    id: '1110060006',
    districtId: '1110060',
    name: 'Blang Rheum',
  },
  {
    id: '1110060007',
    districtId: '1110060',
    name: 'Cot Ulim',
  },
  {
    id: '1110060008',
    districtId: '1110060',
    name: 'Cot Leusong',
  },
  {
    id: '1110060009',
    districtId: '1110060',
    name: 'Blang Seunong',
  },
  {
    id: '1110060010',
    districtId: '1110060',
    name: 'Cot Keutapang',
  },
  {
    id: '1110060027',
    districtId: '1110060',
    name: 'Cot Tarom Tunong',
  },
  {
    id: '1110060028',
    districtId: '1110060',
    name: 'Blang Cot Tunong',
  },
  {
    id: '1110060029',
    districtId: '1110060',
    name: 'Seuleumbah',
  },
  {
    id: '1110060030',
    districtId: '1110060',
    name: 'Abeuk Tingkeum',
  },
  {
    id: '1110060031',
    districtId: '1110060',
    name: 'Blang Me',
  },
  {
    id: '1110060032',
    districtId: '1110060',
    name: 'Pulo Lawang',
  },
  {
    id: '1110060033',
    districtId: '1110060',
    name: 'Paloh Seulimeng',
  },
  {
    id: '1110060034',
    districtId: '1110060',
    name: 'Teupok Tunong',
  },
  {
    id: '1110060035',
    districtId: '1110060',
    name: 'Teupok Baroh',
  },
  {
    id: '1110060036',
    districtId: '1110060',
    name: 'Cot Bada',
  },
  {
    id: '1110060037',
    districtId: '1110060',
    name: 'Cot Gadong',
  },
  {
    id: '1110060038',
    districtId: '1110060',
    name: 'Kuala Jeumpa',
  },
  {
    id: '1110060039',
    districtId: '1110060',
    name: 'Blang Dalam',
  },
  {
    id: '1110060040',
    districtId: '1110060',
    name: 'Blang Bladeh',
  },
  {
    id: '1110060041',
    districtId: '1110060',
    name: 'Geulumpang Payong',
  },
  {
    id: '1110060042',
    districtId: '1110060',
    name: 'Blang Cot Baroh',
  },
  {
    id: '1110060043',
    districtId: '1110060',
    name: 'Cot Tarom Baroh',
  },
  {
    id: '1110060044',
    districtId: '1110060',
    name: 'Geudong Tampu',
  },
  {
    id: '1110060061',
    districtId: '1110060',
    name: 'Lipah Cut',
  },
  {
    id: '1110060062',
    districtId: '1110060',
    name: 'Lipah Rayeuk',
  },
  {
    id: '1110060063',
    districtId: '1110060',
    name: 'Mon Jambee',
  },
  {
    id: '1110060064',
    districtId: '1110060',
    name: 'Batee Timoh',
  },
  {
    id: '1110060065',
    districtId: '1110060',
    name: 'Cot Geurundong',
  },
  {
    id: '1110060066',
    districtId: '1110060',
    name: 'Beurawang',
  },
  {
    id: '1110060073',
    districtId: '1110060',
    name: 'Blang Gandai',
  },
  {
    id: '1110060075',
    districtId: '1110060',
    name: 'Salah Sirong Jaya',
  },
  {
    id: '1110060076',
    districtId: '1110060',
    name: 'Mon Mane',
  },
  {
    id: '1110060077',
    districtId: '1110060',
    name: 'Alue Limeng',
  },
  {
    id: '1110060078',
    districtId: '1110060',
    name: 'Cot Meugoe',
  },
  {
    id: '1110060079',
    districtId: '1110060',
    name: 'Cot Iboih Timu',
  },
  {
    id: '1110060080',
    districtId: '1110060',
    name: 'Kuta Meuligoe',
  },
  {
    id: '1110060081',
    districtId: '1110060',
    name: 'Lhaksmana',
  },
  {
    id: '1110061001',
    districtId: '1110061',
    name: 'Cot Peutek',
  },
  {
    id: '1110061002',
    districtId: '1110061',
    name: 'Cot Jrat',
  },
  {
    id: '1110061003',
    districtId: '1110061',
    name: 'Uteun Reutoh',
  },
  {
    id: '1110061004',
    districtId: '1110061',
    name: 'Buket Teukueh',
  },
  {
    id: '1110061005',
    districtId: '1110061',
    name: 'Blang Reulieng',
  },
  {
    id: '1110061006',
    districtId: '1110061',
    name: 'Blang Tingkeum',
  },
  {
    id: '1110061007',
    districtId: '1110061',
    name: 'Geulanggang Gampong',
  },
  {
    id: '1110061008',
    districtId: '1110061',
    name: 'Pulo Ara Geudong Teungoh',
  },
  {
    id: '1110061009',
    districtId: '1110061',
    name: 'Bireun Meunasah Capa',
  },
  {
    id: '1110061010',
    districtId: '1110061',
    name: 'Bireun Meunsah Tgk Digadong',
  },
  {
    id: '1110061011',
    districtId: '1110061',
    name: 'Bireun Meunasah Dayah',
  },
  {
    id: '1110061012',
    districtId: '1110061',
    name: 'Bireun Meunasah Blang',
  },
  {
    id: '1110061013',
    districtId: '1110061',
    name: 'Bireun Mns Reuleut',
  },
  {
    id: '1110061014',
    districtId: '1110061',
    name: 'Kota Bireun',
  },
  {
    id: '1110061015',
    districtId: '1110061',
    name: 'Pulo Kiton',
  },
  {
    id: '1110061016',
    districtId: '1110061',
    name: 'Lhok Awe Teungoh',
  },
  {
    id: '1110061017',
    districtId: '1110061',
    name: 'Geudong Alue',
  },
  {
    id: '1110061018',
    districtId: '1110061',
    name: 'Geudong Geudong',
  },
  {
    id: '1110061019',
    districtId: '1110061',
    name: 'Geulanggang Teungoh',
  },
  {
    id: '1110061020',
    districtId: '1110061',
    name: 'Geulanggang Baro',
  },
  {
    id: '1110061021',
    districtId: '1110061',
    name: 'Geulanggang Kulam',
  },
  {
    id: '1110061022',
    districtId: '1110061',
    name: 'Cot Gapu',
  },
  {
    id: '1110061023',
    districtId: '1110061',
    name: 'Gampong Baro',
  },
  {
    id: '1110062001',
    districtId: '1110062',
    name: 'Cot Trieng',
  },
  {
    id: '1110062002',
    districtId: '1110062',
    name: 'Lhok Awe Awe',
  },
  {
    id: '1110062003',
    districtId: '1110062',
    name: 'Cot Unoe',
  },
  {
    id: '1110062004',
    districtId: '1110062',
    name: 'Cot Batee',
  },
  {
    id: '1110062005',
    districtId: '1110062',
    name: 'Cot Kuta',
  },
  {
    id: '1110062006',
    districtId: '1110062',
    name: 'Cot Glumpang',
  },
  {
    id: '1110062007',
    districtId: '1110062',
    name: 'Glumpang Baroh',
  },
  {
    id: '1110062008',
    districtId: '1110062',
    name: 'Lancok Pante Ara',
  },
  {
    id: '1110062009',
    districtId: '1110062',
    name: 'Balee Kuyun',
  },
  {
    id: '1110062010',
    districtId: '1110062',
    name: 'Kareung',
  },
  {
    id: '1110062011',
    districtId: '1110062',
    name: 'Lancok Lancok',
  },
  {
    id: '1110062012',
    districtId: '1110062',
    name: 'Cot Usibak',
  },
  {
    id: '1110062013',
    districtId: '1110062',
    name: 'Kuala Raja',
  },
  {
    id: '1110062014',
    districtId: '1110062',
    name: 'Ujong Blang Mesjid',
  },
  {
    id: '1110062015',
    districtId: '1110062',
    name: 'Weu Jangka',
  },
  {
    id: '1110062016',
    districtId: '1110062',
    name: 'Cot Lagasawa',
  },
  {
    id: '1110062017',
    districtId: '1110062',
    name: 'Ujong Blang',
  },
  {
    id: '1110062018',
    districtId: '1110062',
    name: 'Kuta Baro',
  },
  {
    id: '1110062019',
    districtId: '1110062',
    name: 'Krueng Juli Timur',
  },
  {
    id: '1110062020',
    districtId: '1110062',
    name: 'Krueng Juli Barat',
  },
  {
    id: '1110070001',
    districtId: '1110070',
    name: 'Pulo U',
  },
  {
    id: '1110070002',
    districtId: '1110070',
    name: 'Abeuk Jaloh',
  },
  {
    id: '1110070003',
    districtId: '1110070',
    name: 'Pulo Seuna',
  },
  {
    id: '1110070004',
    districtId: '1110070',
    name: 'Pulo Blang',
  },
  {
    id: '1110070005',
    districtId: '1110070',
    name: 'Pulo Iboih',
  },
  {
    id: '1110070006',
    districtId: '1110070',
    name: 'Pulo Reudeup',
  },
  {
    id: '1110070007',
    districtId: '1110070',
    name: 'Gampong Meulinteung',
  },
  {
    id: '1110070008',
    districtId: '1110070',
    name: 'Lamkuta',
  },
  {
    id: '1110070009',
    districtId: '1110070',
    name: 'Ruseb Ara',
  },
  {
    id: '1110070010',
    districtId: '1110070',
    name: 'Lueng',
  },
  {
    id: '1110070011',
    districtId: '1110070',
    name: 'Ruseb Dayah',
  },
  {
    id: '1110070012',
    districtId: '1110070',
    name: 'Kambuek',
  },
  {
    id: '1110070013',
    districtId: '1110070',
    name: 'Bada Timu',
  },
  {
    id: '1110070014',
    districtId: '1110070',
    name: 'Bada Barat',
  },
  {
    id: '1110070015',
    districtId: '1110070',
    name: 'Barat Lanyan',
  },
  {
    id: '1110070016',
    districtId: '1110070',
    name: 'Geundot',
  },
  {
    id: '1110070017',
    districtId: '1110070',
    name: 'Meunasah Krueng',
  },
  {
    id: '1110070018',
    districtId: '1110070',
    name: 'Paya Bieng',
  },
  {
    id: '1110070019',
    districtId: '1110070',
    name: 'Jangka Alue',
  },
  {
    id: '1110070020',
    districtId: '1110070',
    name: 'Jangka Keutapang',
  },
  {
    id: '1110070021',
    districtId: '1110070',
    name: 'Lampoh Rayeuk',
  },
  {
    id: '1110070022',
    districtId: '1110070',
    name: 'Lhok Bugeng',
  },
  {
    id: '1110070023',
    districtId: '1110070',
    name: 'Linggong',
  },
  {
    id: '1110070024',
    districtId: '1110070',
    name: 'Alue Buya',
  },
  {
    id: '1110070025',
    districtId: '1110070',
    name: 'Tanoh Anoe',
  },
  {
    id: '1110070026',
    districtId: '1110070',
    name: 'Tanjongan',
  },
  {
    id: '1110070027',
    districtId: '1110070',
    name: 'Jangka Alue Bie',
  },
  {
    id: '1110070028',
    districtId: '1110070',
    name: 'Jangka Mesjid',
  },
  {
    id: '1110070029',
    districtId: '1110070',
    name: 'Jangka Alue U',
  },
  {
    id: '1110070030',
    districtId: '1110070',
    name: 'Pante Peusangan',
  },
  {
    id: '1110070031',
    districtId: '1110070',
    name: 'Bugak Krueng',
  },
  {
    id: '1110070032',
    districtId: '1110070',
    name: 'Bugak Mesjid',
  },
  {
    id: '1110070033',
    districtId: '1110070',
    name: 'Bugak Krueng Mate',
  },
  {
    id: '1110070034',
    districtId: '1110070',
    name: 'Bugeng',
  },
  {
    id: '1110070035',
    districtId: '1110070',
    name: 'Kuala Ceurape',
  },
  {
    id: '1110070036',
    districtId: '1110070',
    name: 'Alue Bayeu Utang',
  },
  {
    id: '1110070037',
    districtId: '1110070',
    name: 'Ulee Ceue',
  },
  {
    id: '1110070038',
    districtId: '1110070',
    name: 'Alue Kuta',
  },
  {
    id: '1110070039',
    districtId: '1110070',
    name: 'Punjot',
  },
  {
    id: '1110070040',
    districtId: '1110070',
    name: 'Pulo Pineung Mns II',
  },
  {
    id: '1110070041',
    districtId: '1110070',
    name: 'Bugak Blang',
  },
  {
    id: '1110070042',
    districtId: '1110070',
    name: 'Pante Sukon',
  },
  {
    id: '1110070043',
    districtId: '1110070',
    name: 'Pante Paku',
  },
  {
    id: '1110070044',
    districtId: '1110070',
    name: 'Pante Ranub',
  },
  {
    id: '1110070045',
    districtId: '1110070',
    name: 'Alue Buya Pasi',
  },
  {
    id: '1110070046',
    districtId: '1110070',
    name: 'Alue Bie Pusong',
  },
  {
    id: '1110080023',
    districtId: '1110080',
    name: 'Alue Udeung',
  },
  {
    id: '1110080024',
    districtId: '1110080',
    name: 'Alue Peuno',
  },
  {
    id: '1110080038',
    districtId: '1110080',
    name: 'Kapa',
  },
  {
    id: '1110080039',
    districtId: '1110080',
    name: 'Blang Panjoe',
  },
  {
    id: '1110080040',
    districtId: '1110080',
    name: 'Pante Lhong',
  },
  {
    id: '1110080041',
    districtId: '1110080',
    name: 'Paya Cut',
  },
  {
    id: '1110080042',
    districtId: '1110080',
    name: 'Seuneubok Aceh',
  },
  {
    id: '1110080043',
    districtId: '1110080',
    name: 'Paya Lipah',
  },
  {
    id: '1110080044',
    districtId: '1110080',
    name: 'Seuneubok Rawa',
  },
  {
    id: '1110080045',
    districtId: '1110080',
    name: 'Blang Geulanggang',
  },
  {
    id: '1110080046',
    districtId: '1110080',
    name: 'Uteun Bunta',
  },
  {
    id: '1110080047',
    districtId: '1110080',
    name: 'Paya Reuhat',
  },
  {
    id: '1110080048',
    districtId: '1110080',
    name: 'Paya Abo',
  },
  {
    id: '1110080049',
    districtId: '1110080',
    name: 'Paloh',
  },
  {
    id: '1110080050',
    districtId: '1110080',
    name: 'Paya Meuneng',
  },
  {
    id: '1110080051',
    districtId: '1110080',
    name: 'Matang Sagoe',
  },
  {
    id: '1110080052',
    districtId: '1110080',
    name: 'Panton Geulima',
  },
  {
    id: '1110080053',
    districtId: '1110080',
    name: 'Neuheuen',
  },
  {
    id: '1110080054',
    districtId: '1110080',
    name: 'Keude Matang Glp Dua',
  },
  {
    id: '1110080055',
    districtId: '1110080',
    name: 'Pante Gajah',
  },
  {
    id: '1110080056',
    districtId: '1110080',
    name: 'Blang Asan',
  },
  {
    id: '1110080057',
    districtId: '1110080',
    name: 'Gampong Raya Dagang',
  },
  {
    id: '1110080058',
    districtId: '1110080',
    name: 'Gampong Raya Tambo',
  },
  {
    id: '1110080059',
    districtId: '1110080',
    name: 'Keude Tanjong',
  },
  {
    id: '1110080060',
    districtId: '1110080',
    name: 'Pante Pisang',
  },
  {
    id: '1110080061',
    districtId: '1110080',
    name: 'Blang Cut Sp IV',
  },
  {
    id: '1110080062',
    districtId: '1110080',
    name: 'Pante Cut',
  },
  {
    id: '1110080063',
    districtId: '1110080',
    name: 'Matang Glp Dua Meunasah Timu',
  },
  {
    id: '1110080064',
    districtId: '1110080',
    name: 'Matang Glp Dua Meunasah Dayah',
  },
  {
    id: '1110080065',
    districtId: '1110080',
    name: 'Matang Mesjid',
  },
  {
    id: '1110080066',
    districtId: '1110080',
    name: 'Cot Panjoe',
  },
  {
    id: '1110080067',
    districtId: '1110080',
    name: 'Cot Keuranji',
  },
  {
    id: '1110080068',
    districtId: '1110080',
    name: 'Gampong Baroh',
  },
  {
    id: '1110080069',
    districtId: '1110080',
    name: 'Blang Rambong',
  },
  {
    id: '1110080070',
    districtId: '1110080',
    name: 'Tanoh Mirah',
  },
  {
    id: '1110080071',
    districtId: '1110080',
    name: 'Cot Girek',
  },
  {
    id: '1110080072',
    districtId: '1110080',
    name: 'Sagoe',
  },
  {
    id: '1110080073',
    districtId: '1110080',
    name: 'Cot Bada Barat',
  },
  {
    id: '1110080074',
    districtId: '1110080',
    name: 'Cot Bada Tunong',
  },
  {
    id: '1110080075',
    districtId: '1110080',
    name: 'Cot Buket',
  },
  {
    id: '1110080076',
    districtId: '1110080',
    name: 'Cot Ieju',
  },
  {
    id: '1110080077',
    districtId: '1110080',
    name: 'Nicah',
  },
  {
    id: '1110080078',
    districtId: '1110080',
    name: 'Cot Bada Baroh',
  },
  {
    id: '1110080079',
    districtId: '1110080',
    name: 'Cot Keumudee',
  },
  {
    id: '1110080081',
    districtId: '1110080',
    name: 'Pulo Naleung',
  },
  {
    id: '1110080082',
    districtId: '1110080',
    name: 'Cot Nga',
  },
  {
    id: '1110080083',
    districtId: '1110080',
    name: 'Karieng',
  },
  {
    id: '1110080084',
    districtId: '1110080',
    name: 'Mata Mamplam',
  },
  {
    id: '1110080085',
    districtId: '1110080',
    name: 'Alue Glumpang',
  },
  {
    id: '1110080086',
    districtId: '1110080',
    name: 'Cot Rabo Baroh',
  },
  {
    id: '1110080087',
    districtId: '1110080',
    name: 'Cot Rabo Tunong',
  },
  {
    id: '1110080088',
    districtId: '1110080',
    name: 'Krueng Dheue',
  },
  {
    id: '1110080089',
    districtId: '1110080',
    name: 'Matang Cot Paseh',
  },
  {
    id: '1110080090',
    districtId: '1110080',
    name: 'Krueng Baro Mesjid',
  },
  {
    id: '1110080091',
    districtId: '1110080',
    name: 'Gampong Putoh',
  },
  {
    id: '1110080092',
    districtId: '1110080',
    name: 'Pante Piyeu',
  },
  {
    id: '1110080093',
    districtId: '1110080',
    name: 'Tanjong Mesjid',
  },
  {
    id: '1110080094',
    districtId: '1110080',
    name: 'Tanjong Paya',
  },
  {
    id: '1110080095',
    districtId: '1110080',
    name: 'Tanjong Nie',
  },
  {
    id: '1110080096',
    districtId: '1110080',
    name: 'Bayu',
  },
  {
    id: '1110080097',
    districtId: '1110080',
    name: 'Krueng Baro Bb Krueng',
  },
  {
    id: '1110080098',
    districtId: '1110080',
    name: 'Meunasah Nibong',
  },
  {
    id: '1110080099',
    districtId: '1110080',
    name: 'Pante Ara',
  },
  {
    id: '1110080100',
    districtId: '1110080',
    name: 'Meunasah Meucap',
  },
  {
    id: '1110080101',
    districtId: '1110080',
    name: 'Asan Bideun',
  },
  {
    id: '1110080102',
    districtId: '1110080',
    name: 'Pulo Pisang',
  },
  {
    id: '1110080104',
    districtId: '1110080',
    name: 'Cot Puuk',
  },
  {
    id: '1110080105',
    districtId: '1110080',
    name: 'Blang Dalam',
  },
  {
    id: '1110080106',
    districtId: '1110080',
    name: 'Pulo Ue Baro',
  },
  {
    id: '1110081001',
    districtId: '1110081',
    name: 'Blang Mane',
  },
  {
    id: '1110081002',
    districtId: '1110081',
    name: 'Darussalam',
  },
  {
    id: '1110081003',
    districtId: '1110081',
    name: 'Tanjong Beuridi',
  },
  {
    id: '1110081004',
    districtId: '1110081',
    name: 'Darul Aman',
  },
  {
    id: '1110081005',
    districtId: '1110081',
    name: 'Paya Crot',
  },
  {
    id: '1110081006',
    districtId: '1110081',
    name: 'Pulo Panyang',
  },
  {
    id: '1110081007',
    districtId: '1110081',
    name: 'Ulee Jalan',
  },
  {
    id: '1110081008',
    districtId: '1110081',
    name: 'Geulanggang Labu',
  },
  {
    id: '1110081009',
    districtId: '1110081',
    name: 'Teupin Reudeup',
  },
  {
    id: '1110081010',
    districtId: '1110081',
    name: 'Krueng Beukah',
  },
  {
    id: '1110081011',
    districtId: '1110081',
    name: 'Blang Pala',
  },
  {
    id: '1110081012',
    districtId: '1110081',
    name: 'Ceubrek',
  },
  {
    id: '1110081013',
    districtId: '1110081',
    name: 'Uteun Ghatom',
  },
  {
    id: '1110081014',
    districtId: '1110081',
    name: 'Me Rayeuk',
  },
  {
    id: '1110081015',
    districtId: '1110081',
    name: 'Uteun Raya',
  },
  {
    id: '1110081016',
    districtId: '1110081',
    name: 'Mata Ie',
  },
  {
    id: '1110081017',
    districtId: '1110081',
    name: 'Blang Cut',
  },
  {
    id: '1110081018',
    districtId: '1110081',
    name: 'Lueng Baro',
  },
  {
    id: '1110081019',
    districtId: '1110081',
    name: 'Lueng Kuli',
  },
  {
    id: '1110081020',
    districtId: '1110081',
    name: 'Pulo Harapan',
  },
  {
    id: '1110081021',
    districtId: '1110081',
    name: 'Suwak',
  },
  {
    id: '1110082001',
    districtId: '1110082',
    name: 'Pante Karya',
  },
  {
    id: '1110082002',
    districtId: '1110082',
    name: 'Alue Glumpang',
  },
  {
    id: '1110082003',
    districtId: '1110082',
    name: 'Buket Sudan',
  },
  {
    id: '1110082004',
    districtId: '1110082',
    name: 'Cot Saleut',
  },
  {
    id: '1110082005',
    districtId: '1110082',
    name: 'Paloh Mampree',
  },
  {
    id: '1110082006',
    districtId: '1110082',
    name: 'Alue Iet',
  },
  {
    id: '1110082007',
    districtId: '1110082',
    name: 'Awe Geutah',
  },
  {
    id: '1110082008',
    districtId: '1110082',
    name: 'Blang Cirih',
  },
  {
    id: '1110082009',
    districtId: '1110082',
    name: 'Alue Keupula',
  },
  {
    id: '1110082010',
    districtId: '1110082',
    name: 'Alue Krueb',
  },
  {
    id: '1110082011',
    districtId: '1110082',
    name: 'Rambong Payong',
  },
  {
    id: '1110082012',
    districtId: '1110082',
    name: 'Lueng Daneun',
  },
  {
    id: '1110082013',
    districtId: '1110082',
    name: 'Cot Aneuk Batee',
  },
  {
    id: '1110082014',
    districtId: '1110082',
    name: 'Kubu Raya',
  },
  {
    id: '1110082015',
    districtId: '1110082',
    name: 'Pante Baro Gle Sibla',
  },
  {
    id: '1110082016',
    districtId: '1110082',
    name: 'Pante Baro Kumbang',
  },
  {
    id: '1110082017',
    districtId: '1110082',
    name: 'Pante Baro Bukit Panyang',
  },
  {
    id: '1110082018',
    districtId: '1110082',
    name: 'Kubu',
  },
  {
    id: '1110082019',
    districtId: '1110082',
    name: 'Teupin Raya',
  },
  {
    id: '1110082020',
    districtId: '1110082',
    name: 'Awe Geutah Paya',
  },
  {
    id: '1110082021',
    districtId: '1110082',
    name: 'Dayah Baro',
  },
  {
    id: '1110090001',
    districtId: '1110090',
    name: 'Sukarame',
  },
  {
    id: '1110090002',
    districtId: '1110090',
    name: 'Panton Mesjid',
  },
  {
    id: '1110090003',
    districtId: '1110090',
    name: 'Alue Dua',
  },
  {
    id: '1110090004',
    districtId: '1110090',
    name: 'Blang Perlak',
  },
  {
    id: '1110090005',
    districtId: '1110090',
    name: 'Tanjong Mulia',
  },
  {
    id: '1110090006',
    districtId: '1110090',
    name: 'Matang Kumbang',
  },
  {
    id: '1110090007',
    districtId: '1110090',
    name: 'Meureubo',
  },
  {
    id: '1110090008',
    districtId: '1110090',
    name: 'Seuneubok Baro',
  },
  {
    id: '1110090009',
    districtId: '1110090',
    name: 'Blang Dalam',
  },
  {
    id: '1110090010',
    districtId: '1110090',
    name: 'Pandak',
  },
  {
    id: '1110090011',
    districtId: '1110090',
    name: 'Blang Mane',
  },
  {
    id: '1110090012',
    districtId: '1110090',
    name: 'Pante Breuh',
  },
  {
    id: '1110090013',
    districtId: '1110090',
    name: 'Ulee Gle',
  },
  {
    id: '1110090014',
    districtId: '1110090',
    name: 'Mon Ara',
  },
  {
    id: '1110090015',
    districtId: '1110090',
    name: 'Lapehan Mesjid',
  },
  {
    id: '1110090016',
    districtId: '1110090',
    name: 'Buket Selamat',
  },
  {
    id: '1110090017',
    districtId: '1110090',
    name: 'Blang Kutang',
  },
  {
    id: '1110090018',
    districtId: '1110090',
    name: 'Cot Kruet',
  },
  {
    id: '1110090019',
    districtId: '1110090',
    name: 'Trienggadeng',
  },
  {
    id: '1110090020',
    districtId: '1110090',
    name: 'Leubu Mesjid',
  },
  {
    id: '1110090021',
    districtId: '1110090',
    name: 'Kuta Barat',
  },
  {
    id: '1110090022',
    districtId: '1110090',
    name: 'Leubu Cot',
  },
  {
    id: '1110090023',
    districtId: '1110090',
    name: 'Paya Dua',
  },
  {
    id: '1110090024',
    districtId: '1110090',
    name: 'Leubu Me',
  },
  {
    id: '1110090025',
    districtId: '1110090',
    name: 'Batee Dabai',
  },
  {
    id: '1110090026',
    districtId: '1110090',
    name: 'Pulo Teungoh',
  },
  {
    id: '1110090027',
    districtId: '1110090',
    name: 'Ara Lipeh',
  },
  {
    id: '1110100005',
    districtId: '1110100',
    name: 'Paloh Kayee Kunyet',
  },
  {
    id: '1110100006',
    districtId: '1110100',
    name: 'Tanjong Raya',
  },
  {
    id: '1110100007',
    districtId: '1110100',
    name: 'Paya Seupat',
  },
  {
    id: '1110100008',
    districtId: '1110100',
    name: 'Paya Kareung',
  },
  {
    id: '1110100009',
    districtId: '1110100',
    name: 'Blang Kubu',
  },
  {
    id: '1110100014',
    districtId: '1110100',
    name: 'Paya Baro',
  },
  {
    id: '1110100015',
    districtId: '1110100',
    name: 'Tanjong Mesjid',
  },
  {
    id: '1110100016',
    districtId: '1110100',
    name: 'Mon Jeureujak',
  },
  {
    id: '1110100017',
    districtId: '1110100',
    name: 'Dama Kawan',
  },
  {
    id: '1110100018',
    districtId: '1110100',
    name: 'Cot Rambat',
  },
  {
    id: '1110100019',
    districtId: '1110100',
    name: 'Blang Guron',
  },
  {
    id: '1110100020',
    districtId: '1110100',
    name: 'Cot Teubee',
  },
  {
    id: '1110100021',
    districtId: '1110100',
    name: 'Tanjong Bungong',
  },
  {
    id: '1110100022',
    districtId: '1110100',
    name: 'Pulo Gisa',
  },
  {
    id: '1110100023',
    districtId: '1110100',
    name: 'Ujong Bayu',
  },
  {
    id: '1110100024',
    districtId: '1110100',
    name: 'Cot Tupah',
  },
  {
    id: '1110100025',
    districtId: '1110100',
    name: 'Cot Tunong',
  },
  {
    id: '1110100039',
    districtId: '1110100',
    name: 'Cot Puuk',
  },
  {
    id: '1110100040',
    districtId: '1110100',
    name: 'Paloh Me',
  },
  {
    id: '1110100041',
    districtId: '1110100',
    name: 'Geurugok',
  },
  {
    id: '1110100042',
    districtId: '1110100',
    name: 'Cot Jabet',
  },
  {
    id: '1110100043',
    districtId: '1110100',
    name: 'Pante Sikeumbong',
  },
  {
    id: '1110100044',
    districtId: '1110100',
    name: 'Ceubo',
  },
  {
    id: '1110100045',
    districtId: '1110100',
    name: 'Keude Lapang',
  },
  {
    id: '1110100046',
    districtId: '1110100',
    name: 'Blang Keude',
  },
  {
    id: '1110100047',
    districtId: '1110100',
    name: 'Cot Mane',
  },
  {
    id: '1110100057',
    districtId: '1110100',
    name: 'Lhok Mambang',
  },
  {
    id: '1110100058',
    districtId: '1110100',
    name: 'Lapang Timur',
  },
  {
    id: '1110100059',
    districtId: '1110100',
    name: 'Teupin Siron',
  },
  {
    id: '1110100060',
    districtId: '1110100',
    name: 'Ie Rhob',
  },
  {
    id: '1110100061',
    districtId: '1110100',
    name: 'Alue Mangki',
  },
  {
    id: '1110100062',
    districtId: '1110100',
    name: 'Lingka Kuta',
  },
  {
    id: '1110100063',
    districtId: '1110100',
    name: 'Lapang Barat',
  },
  {
    id: '1110100064',
    districtId: '1110100',
    name: 'Samuti Krueng',
  },
  {
    id: '1110100065',
    districtId: '1110100',
    name: 'Samuti Makmur',
  },
  {
    id: '1110100066',
    districtId: '1110100',
    name: 'Samuti Rayeuk',
  },
  {
    id: '1110100076',
    districtId: '1110100',
    name: 'Samuti Aman',
  },
  {
    id: '1110100077',
    districtId: '1110100',
    name: 'Mon Keulayu',
  },
  {
    id: '1110100078',
    districtId: '1110100',
    name: 'Mon Jambe',
  },
  {
    id: '1110100079',
    districtId: '1110100',
    name: 'Blang Rheu',
  },
  {
    id: '1110101001',
    districtId: '1110101',
    name: 'Parang Sikureung',
  },
  {
    id: '1110101002',
    districtId: '1110101',
    name: 'Tanjong Siron',
  },
  {
    id: '1110101003',
    districtId: '1110101',
    name: 'Paloh Raya',
  },
  {
    id: '1110101004',
    districtId: '1110101',
    name: 'Paloh Peuradi',
  },
  {
    id: '1110101005',
    districtId: '1110101',
    name: 'Crung Kumbang',
  },
  {
    id: '1110101006',
    districtId: '1110101',
    name: 'Paloh Dama',
  },
  {
    id: '1110101007',
    districtId: '1110101',
    name: 'Bukit Dalam',
  },
  {
    id: '1110101008',
    districtId: '1110101',
    name: 'Gle Putoh',
  },
  {
    id: '1110101009',
    districtId: '1110101',
    name: 'Bale Me',
  },
  {
    id: '1110101010',
    districtId: '1110101',
    name: 'Kulu',
  },
  {
    id: '1110101011',
    districtId: '1110101',
    name: 'Blang Me',
  },
  {
    id: '1110101012',
    districtId: '1110101',
    name: 'Blang Panjoe',
  },
  {
    id: '1110101013',
    districtId: '1110101',
    name: 'Lhok Nga',
  },
  {
    id: '1110101014',
    districtId: '1110101',
    name: 'Meuse',
  },
  {
    id: '1110101015',
    districtId: '1110101',
    name: 'Babah Jurong',
  },
  {
    id: '1110101016',
    districtId: '1110101',
    name: 'Dayah Panjoe',
  },
  {
    id: '1110101017',
    districtId: '1110101',
    name: 'Iembudee',
  },
  {
    id: '1110101018',
    districtId: '1110101',
    name: 'Tingkeum Baro',
  },
  {
    id: '1110101019',
    districtId: '1110101',
    name: 'Pulo Reudeup',
  },
  {
    id: '1110101020',
    districtId: '1110101',
    name: 'Tingkeum Manyang',
  },
  {
    id: '1110101021',
    districtId: '1110101',
    name: 'Ulee Pusong',
  },
  {
    id: '1110101022',
    districtId: '1110101',
    name: 'Paya Rangkuluh',
  },
  {
    id: '1110101023',
    districtId: '1110101',
    name: 'Cot Baroh',
  },
  {
    id: '1110101024',
    districtId: '1110101',
    name: 'Babah Suak',
  },
  {
    id: '1110101025',
    districtId: '1110101',
    name: 'Geulanggang Rayeuk',
  },
  {
    id: '1110101026',
    districtId: '1110101',
    name: 'Geulanggang Meunje',
  },
  {
    id: '1110101027',
    districtId: '1110101',
    name: 'Geulanggang Panah',
  },
  {
    id: '1110101028',
    districtId: '1110101',
    name: 'Pulo Blang',
  },
  {
    id: '1110101029',
    districtId: '1110101',
    name: 'Pulo Siron',
  },
  {
    id: '1110101030',
    districtId: '1110101',
    name: 'Jarum Mahme',
  },
  {
    id: '1110101031',
    districtId: '1110101',
    name: 'Dayah Mesjid',
  },
  {
    id: '1110101032',
    districtId: '1110101',
    name: 'Ujong Blang',
  },
  {
    id: '1110101033',
    districtId: '1110101',
    name: 'Keurumbok',
  },
  {
    id: '1110101034',
    districtId: '1110101',
    name: 'Jarummah Baroh',
  },
  {
    id: '1110101035',
    districtId: '1110101',
    name: 'Cot Ara',
  },
  {
    id: '1110101036',
    districtId: '1110101',
    name: 'Rancong',
  },
  {
    id: '1110101037',
    districtId: '1110101',
    name: 'Pulo Nga',
  },
  {
    id: '1110101038',
    districtId: '1110101',
    name: 'Cot Me',
  },
  {
    id: '1110101039',
    districtId: '1110101',
    name: 'Jambo Kajeung',
  },
  {
    id: '1110101040',
    districtId: '1110101',
    name: 'Kulu Kuta',
  },
  {
    id: '1110101041',
    districtId: '1110101',
    name: 'Pulo Awe',
  },
  {
    id: '1111010001',
    districtId: '1111010',
    name: 'Riseh Tunong',
  },
  {
    id: '1111010002',
    districtId: '1111010',
    name: 'Gunci',
  },
  {
    id: '1111010003',
    districtId: '1111010',
    name: 'Kubu',
  },
  {
    id: '1111010004',
    districtId: '1111010',
    name: 'Blang Cut',
  },
  {
    id: '1111010005',
    districtId: '1111010',
    name: 'Riseh Teungoh',
  },
  {
    id: '1111010006',
    districtId: '1111010',
    name: 'Riseh Baroh',
  },
  {
    id: '1111010007',
    districtId: '1111010',
    name: 'Lhok Cut',
  },
  {
    id: '1111010008',
    districtId: '1111010',
    name: 'Sawang',
  },
  {
    id: '1111010009',
    districtId: '1111010',
    name: 'Blang Teurakan',
  },
  {
    id: '1111010010',
    districtId: '1111010',
    name: 'Jurong',
  },
  {
    id: '1111010011',
    districtId: '1111010',
    name: 'Blang Manyak',
  },
  {
    id: '1111010012',
    districtId: '1111010',
    name: 'Lhok Jok',
  },
  {
    id: '1111010013',
    districtId: '1111010',
    name: 'Babah Krueng',
  },
  {
    id: '1111010014',
    districtId: '1111010',
    name: 'Rambong Payong',
  },
  {
    id: '1111010015',
    districtId: '1111010',
    name: 'Teupin Rusep',
  },
  {
    id: '1111010016',
    districtId: '1111010',
    name: 'Lancok',
  },
  {
    id: '1111010017',
    districtId: '1111010',
    name: 'Lhok Bayu',
  },
  {
    id: '1111010018',
    districtId: '1111010',
    name: 'Paya Rabo Timu',
  },
  {
    id: '1111010019',
    districtId: '1111010',
    name: 'Paya Rabo Lhok',
  },
  {
    id: '1111010020',
    districtId: '1111010',
    name: 'Krueng Baro',
  },
  {
    id: '1111010021',
    districtId: '1111010',
    name: 'Blang Reuling',
  },
  {
    id: '1111010022',
    districtId: '1111010',
    name: 'Punteuet',
  },
  {
    id: '1111010023',
    districtId: '1111010',
    name: 'Meunasah Pulo',
  },
  {
    id: '1111010024',
    districtId: '1111010',
    name: 'Lhok Kuyuen',
  },
  {
    id: '1111010025',
    districtId: '1111010',
    name: 'Lhok Gajah',
  },
  {
    id: '1111010026',
    districtId: '1111010',
    name: 'Pante Jaloh',
  },
  {
    id: '1111010027',
    districtId: '1111010',
    name: 'Babah Buloh',
  },
  {
    id: '1111010028',
    districtId: '1111010',
    name: 'Cot Lambideng',
  },
  {
    id: '1111010029',
    districtId: '1111010',
    name: 'Gampong Teungoh',
  },
  {
    id: '1111010030',
    districtId: '1111010',
    name: 'Paya Gaboh',
  },
  {
    id: '1111010031',
    districtId: '1111010',
    name: 'Kuta Meuligoe',
  },
  {
    id: '1111010032',
    districtId: '1111010',
    name: 'Abeuk Reuling',
  },
  {
    id: '1111010033',
    districtId: '1111010',
    name: 'Cot Keumuneng',
  },
  {
    id: '1111010034',
    districtId: '1111010',
    name: 'Ulee Geudong',
  },
  {
    id: '1111010035',
    districtId: '1111010',
    name: 'Tanjong Keumala',
  },
  {
    id: '1111010036',
    districtId: '1111010',
    name: 'Lhok Krek',
  },
  {
    id: '1111010037',
    districtId: '1111010',
    name: 'Glee Dagang',
  },
  {
    id: '1111010038',
    districtId: '1111010',
    name: 'Lagang',
  },
  {
    id: '1111010039',
    districtId: '1111010',
    name: 'Lhok Merbo',
  },
  {
    id: '1111020007',
    districtId: '1111020',
    name: 'Jeulikat',
  },
  {
    id: '1111020008',
    districtId: '1111020',
    name: 'Meunasah Cut',
  },
  {
    id: '1111020009',
    districtId: '1111020',
    name: 'Alue Bili',
  },
  {
    id: '1111020010',
    districtId: '1111020',
    name: 'Cot Mambong',
  },
  {
    id: '1111020011',
    districtId: '1111020',
    name: 'Blang Dalam Tunong',
  },
  {
    id: '1111020012',
    districtId: '1111020',
    name: 'Blang Dalam Baroh',
  },
  {
    id: '1111020013',
    districtId: '1111020',
    name: 'Blang Dalam Geunteng',
  },
  {
    id: '1111020014',
    districtId: '1111020',
    name: 'Tingkeum',
  },
  {
    id: '1111020015',
    districtId: '1111020',
    name: 'Meunasah Rayeuk',
  },
  {
    id: '1111020016',
    districtId: '1111020',
    name: 'Peunayan',
  },
  {
    id: '1111020017',
    districtId: '1111020',
    name: 'Paloh Mampree',
  },
  {
    id: '1111020018',
    districtId: '1111020',
    name: 'Panton',
  },
  {
    id: '1111020019',
    districtId: '1111020',
    name: 'Meunasah Alue',
  },
  {
    id: '1111020022',
    districtId: '1111020',
    name: 'Paloh Mambu',
  },
  {
    id: '1111020023',
    districtId: '1111020',
    name: 'Gampong Barat',
  },
  {
    id: '1111020024',
    districtId: '1111020',
    name: 'Meunasah Beunot',
  },
  {
    id: '1111020025',
    districtId: '1111020',
    name: 'Mns Meucat',
  },
  {
    id: '1111020026',
    districtId: '1111020',
    name: 'Gampong Teungoh',
  },
  {
    id: '1111020027',
    districtId: '1111020',
    name: 'Cot Me',
  },
  {
    id: '1111020028',
    districtId: '1111020',
    name: 'Cot Euntung',
  },
  {
    id: '1111020029',
    districtId: '1111020',
    name: 'Keutapang',
  },
  {
    id: '1111020030',
    districtId: '1111020',
    name: 'Blang Crok',
  },
  {
    id: '1111020031',
    districtId: '1111020',
    name: 'Binjee',
  },
  {
    id: '1111020032',
    districtId: '1111020',
    name: 'Cot Leupee',
  },
  {
    id: '1111020033',
    districtId: '1111020',
    name: 'Meunasah Krueng',
  },
  {
    id: '1111020034',
    districtId: '1111020',
    name: 'Ulee Blang',
  },
  {
    id: '1111020035',
    districtId: '1111020',
    name: 'Seuneubok',
  },
  {
    id: '1111020036',
    districtId: '1111020',
    name: 'Blang Karieng',
  },
  {
    id: '1111020037',
    districtId: '1111020',
    name: 'Paloh Kayee Kunyet',
  },
  {
    id: '1111021001',
    districtId: '1111021',
    name: 'Alue Dua',
  },
  {
    id: '1111021002',
    districtId: '1111021',
    name: 'Alue Papeun',
  },
  {
    id: '1111021003',
    districtId: '1111021',
    name: 'Blang Jrat',
  },
  {
    id: '1111021004',
    districtId: '1111021',
    name: 'Blang Pohroh',
  },
  {
    id: '1111021005',
    districtId: '1111021',
    name: 'Darussalam',
  },
  {
    id: '1111021006',
    districtId: '1111021',
    name: 'Seumirah',
  },
  {
    id: '1111022001',
    districtId: '1111022',
    name: 'Jamuan',
  },
  {
    id: '1111022002',
    districtId: '1111022',
    name: 'Alue Keureunyai',
  },
  {
    id: '1111022003',
    districtId: '1111022',
    name: 'Blang Pala',
  },
  {
    id: '1111022004',
    districtId: '1111022',
    name: 'Sangkelan',
  },
  {
    id: '1111022005',
    districtId: '1111022',
    name: 'Ulee Nyeue',
  },
  {
    id: '1111022006',
    districtId: '1111022',
    name: 'Paya Uleue',
  },
  {
    id: '1111022007',
    districtId: '1111022',
    name: 'Cot Jabet',
  },
  {
    id: '1111022008',
    districtId: '1111022',
    name: 'Paya Dua',
  },
  {
    id: '1111022009',
    districtId: '1111022',
    name: 'Paya Beunyot',
  },
  {
    id: '1111030001',
    districtId: '1111030',
    name: 'Sido Muliyo',
  },
  {
    id: '1111030012',
    districtId: '1111030',
    name: 'Alue Rambee',
  },
  {
    id: '1111030013',
    districtId: '1111030',
    name: 'Meunye Cut Bahagia',
  },
  {
    id: '1111030014',
    districtId: '1111030',
    name: 'Cot Merbo',
  },
  {
    id: '1111030015',
    districtId: '1111030',
    name: 'Panton Rayeuk I',
  },
  {
    id: '1111030016',
    districtId: '1111030',
    name: 'Blang Talon',
  },
  {
    id: '1111030017',
    districtId: '1111030',
    name: 'Buket',
  },
  {
    id: '1111030018',
    districtId: '1111030',
    name: 'Lhok Jok',
  },
  {
    id: '1111030019',
    districtId: '1111030',
    name: 'Seuneubok Drien',
  },
  {
    id: '1111030026',
    districtId: '1111030',
    name: 'Cempeudak',
  },
  {
    id: '1111030027',
    districtId: '1111030',
    name: 'Blang Riek',
  },
  {
    id: '1111030028',
    districtId: '1111030',
    name: 'Meunasah Blang Ara',
  },
  {
    id: '1111030029',
    districtId: '1111030',
    name: 'Keude Blang Ara',
  },
  {
    id: '1111030030',
    districtId: '1111030',
    name: 'Krueng Manyang',
  },
  {
    id: '1111030031',
    districtId: '1111030',
    name: 'Bayu',
  },
  {
    id: '1111030032',
    districtId: '1111030',
    name: 'Blang Ado',
  },
  {
    id: '1111030033',
    districtId: '1111030',
    name: 'Dayah Meunara',
  },
  {
    id: '1111030034',
    districtId: '1111030',
    name: 'Cot Rheue',
  },
  {
    id: '1111030035',
    districtId: '1111030',
    name: 'Babah Lueng',
  },
  {
    id: '1111030036',
    districtId: '1111030',
    name: 'Panton Rayeuk II',
  },
  {
    id: '1111030037',
    districtId: '1111030',
    name: 'Saweuk',
  },
  {
    id: '1111030038',
    districtId: '1111030',
    name: 'Langkuta',
  },
  {
    id: '1111030039',
    districtId: '1111030',
    name: 'Cot Seumiyong',
  },
  {
    id: '1111030040',
    districtId: '1111030',
    name: 'Meuriya',
  },
  {
    id: '1111030041',
    districtId: '1111030',
    name: 'Cot Seutuy',
  },
  {
    id: '1111030042',
    districtId: '1111030',
    name: 'Mulieng Manyang',
  },
  {
    id: '1111030043',
    districtId: '1111030',
    name: 'Mulieng Meucat',
  },
  {
    id: '1111030044',
    districtId: '1111030',
    name: 'Pulo Barat',
  },
  {
    id: '1111030045',
    districtId: '1111030',
    name: 'Pulo Rayeuk',
  },
  {
    id: '1111030046',
    districtId: '1111030',
    name: 'Meunasah Kumbang',
  },
  {
    id: '1111030047',
    districtId: '1111030',
    name: 'Ceumeucet',
  },
  {
    id: '1111030048',
    districtId: '1111030',
    name: 'Guha Uleue',
  },
  {
    id: '1111030049',
    districtId: '1111030',
    name: 'Blang Gurah',
  },
  {
    id: '1111030050',
    districtId: '1111030',
    name: 'Krueng Seunong',
  },
  {
    id: '1111030051',
    districtId: '1111030',
    name: 'Keude Krueng',
  },
  {
    id: '1111030052',
    districtId: '1111030',
    name: 'Pulo Iboih',
  },
  {
    id: '1111030053',
    districtId: '1111030',
    name: 'Keureusek',
  },
  {
    id: '1111030054',
    districtId: '1111030',
    name: 'Meunasah Kulam',
  },
  {
    id: '1111030055',
    districtId: '1111030',
    name: 'Krueng Seupeng',
  },
  {
    id: '1111031001',
    districtId: '1111031',
    name: 'Pase Sentausa',
  },
  {
    id: '1111031002',
    districtId: '1111031',
    name: 'Kilo Meter VIII',
  },
  {
    id: '1111031003',
    districtId: '1111031',
    name: 'Kilo Meter VI',
  },
  {
    id: '1111031004',
    districtId: '1111031',
    name: 'Meunasah Dayah',
  },
  {
    id: '1111031005',
    districtId: '1111031',
    name: 'Kebon Baru',
  },
  {
    id: '1111031006',
    districtId: '1111031',
    name: 'Ie Tarek I',
  },
  {
    id: '1111031007',
    districtId: '1111031',
    name: 'Ie Tarek II',
  },
  {
    id: '1111031008',
    districtId: '1111031',
    name: 'Seunebok Punti',
  },
  {
    id: '1111031009',
    districtId: '1111031',
    name: 'Keude Simpang IV',
  },
  {
    id: '1111031010',
    districtId: '1111031',
    name: 'Blang Raleu',
  },
  {
    id: '1111031011',
    districtId: '1111031',
    name: 'Meunasah Baroh',
  },
  {
    id: '1111031012',
    districtId: '1111031',
    name: 'Meunasah Teungoh',
  },
  {
    id: '1111031013',
    districtId: '1111031',
    name: 'Mancang',
  },
  {
    id: '1111031014',
    districtId: '1111031',
    name: 'Alue Bade',
  },
  {
    id: '1111031015',
    districtId: '1111031',
    name: 'Paya Teungoh',
  },
  {
    id: '1111031016',
    districtId: '1111031',
    name: 'Paya Leupah',
  },
  {
    id: '1111040010',
    districtId: '1111040',
    name: 'Meudang Ara',
  },
  {
    id: '1111040012',
    districtId: '1111040',
    name: 'Siren Tujoh',
  },
  {
    id: '1111040013',
    districtId: '1111040',
    name: 'Cut Neuheun',
  },
  {
    id: '1111040014',
    districtId: '1111040',
    name: 'Tumpeun',
  },
  {
    id: '1111040015',
    districtId: '1111040',
    name: 'A L E N',
  },
  {
    id: '1111040016',
    districtId: '1111040',
    name: 'Dayah Blang Seureukuy',
  },
  {
    id: '1111040017',
    districtId: '1111040',
    name: 'Blang Patra',
  },
  {
    id: '1111040019',
    districtId: '1111040',
    name: 'Buket Glumpang',
  },
  {
    id: '1111040020',
    districtId: '1111040',
    name: 'Seunebok Baro',
  },
  {
    id: '1111040021',
    districtId: '1111040',
    name: 'Alue Majron',
  },
  {
    id: '1111040022',
    districtId: '1111040',
    name: 'Blang Majron',
  },
  {
    id: '1111040023',
    districtId: '1111040',
    name: 'Blang Seureukuy',
  },
  {
    id: '1111040024',
    districtId: '1111040',
    name: 'Kayee Panyang',
  },
  {
    id: '1111040025',
    districtId: '1111040',
    name: 'Ulee Meuria',
  },
  {
    id: '1111040026',
    districtId: '1111040',
    name: 'Pulo Blang Trieng',
  },
  {
    id: '1111040027',
    districtId: '1111040',
    name: 'Rheng',
  },
  {
    id: '1111040028',
    districtId: '1111040',
    name: 'Trieng Meudurou',
  },
  {
    id: '1111040029',
    districtId: '1111040',
    name: 'Garot',
  },
  {
    id: '1111040030',
    districtId: '1111040',
    name: 'Cibrek',
  },
  {
    id: '1111040031',
    districtId: '1111040',
    name: 'Blang Awe',
  },
  {
    id: '1111040032',
    districtId: '1111040',
    name: 'Pulo Blang Mangat',
  },
  {
    id: '1111040033',
    districtId: '1111040',
    name: 'Ulee Gampong',
  },
  {
    id: '1111040034',
    districtId: '1111040',
    name: 'Bale',
  },
  {
    id: '1111040035',
    districtId: '1111040',
    name: 'Bie',
  },
  {
    id: '1111040036',
    districtId: '1111040',
    name: 'Nibong',
  },
  {
    id: '1111040037',
    districtId: '1111040',
    name: 'Baro Kulam Gajah',
  },
  {
    id: '1111040038',
    districtId: '1111040',
    name: 'Beurandang',
  },
  {
    id: '1111040039',
    districtId: '1111040',
    name: 'Mns Glong',
  },
  {
    id: '1111040040',
    districtId: '1111040',
    name: 'Mns Langa',
  },
  {
    id: '1111040041',
    districtId: '1111040',
    name: 'Mns Beunot',
  },
  {
    id: '1111040042',
    districtId: '1111040',
    name: 'Keude Bayu',
  },
  {
    id: '1111040043',
    districtId: '1111040',
    name: 'Blang Bayu',
  },
  {
    id: '1111040044',
    districtId: '1111040',
    name: 'Dayah Baro',
  },
  {
    id: '1111040045',
    districtId: '1111040',
    name: 'Dayah Tuha',
  },
  {
    id: '1111040046',
    districtId: '1111040',
    name: 'Bungong',
  },
  {
    id: '1111040047',
    districtId: '1111040',
    name: 'Punti',
  },
  {
    id: '1111040048',
    districtId: '1111040',
    name: 'Baroh Blang Rimueng',
  },
  {
    id: '1111040049',
    districtId: '1111040',
    name: 'Lancok',
  },
  {
    id: '1111041001',
    districtId: '1111041',
    name: 'Suka Damai',
  },
  {
    id: '1111041002',
    districtId: '1111041',
    name: 'Pulo Meuria',
  },
  {
    id: '1111041003',
    districtId: '1111041',
    name: 'Krueng Mbang',
  },
  {
    id: '1111041004',
    districtId: '1111041',
    name: 'Dayah Seupeng',
  },
  {
    id: '1111041005',
    districtId: '1111041',
    name: 'Uram Jalan',
  },
  {
    id: '1111041006',
    districtId: '1111041',
    name: 'Peudari',
  },
  {
    id: '1111041007',
    districtId: '1111041',
    name: 'Rayeuk Jawa',
  },
  {
    id: '1111041008',
    districtId: '1111041',
    name: 'Darussalam',
  },
  {
    id: '1111041009',
    districtId: '1111041',
    name: 'Alue Awe',
  },
  {
    id: '1111041010',
    districtId: '1111041',
    name: 'Lhok Asan',
  },
  {
    id: '1111041011',
    districtId: '1111041',
    name: 'Darul Aman',
  },
  {
    id: '1111050001',
    districtId: '1111050',
    name: 'Mns Baree Blang',
  },
  {
    id: '1111050002',
    districtId: '1111050',
    name: 'Paya Sutra',
  },
  {
    id: '1111050003',
    districtId: '1111050',
    name: 'Tualang',
  },
  {
    id: '1111050004',
    districtId: '1111050',
    name: 'Pulo Blang',
  },
  {
    id: '1111050005',
    districtId: '1111050',
    name: 'Leubok Tuwe',
  },
  {
    id: '1111050006',
    districtId: '1111050',
    name: 'Saramaba',
  },
  {
    id: '1111050007',
    districtId: '1111050',
    name: 'Blang Reuma',
  },
  {
    id: '1111050008',
    districtId: '1111050',
    name: 'Ranto',
  },
  {
    id: '1111050009',
    districtId: '1111050',
    name: 'Meunye Peut',
  },
  {
    id: '1111050010',
    districtId: '1111050',
    name: 'Meunye Payong',
  },
  {
    id: '1111050011',
    districtId: '1111050',
    name: 'Beuringen',
  },
  {
    id: '1111050012',
    districtId: '1111050',
    name: 'Ujong Kuta Batee',
  },
  {
    id: '1111050013',
    districtId: '1111050',
    name: 'Teungoh Kuta Batee',
  },
  {
    id: '1111050014',
    districtId: '1111050',
    name: 'Baroh Kuta Batee',
  },
  {
    id: '1111050015',
    districtId: '1111050',
    name: 'Ceubrek',
  },
  {
    id: '1111050016',
    districtId: '1111050',
    name: 'Gampong Teungoh',
  },
  {
    id: '1111050017',
    districtId: '1111050',
    name: 'Keude Jungka Gajah',
  },
  {
    id: '1111050018',
    districtId: '1111050',
    name: 'Nibong',
  },
  {
    id: '1111050019',
    districtId: '1111050',
    name: 'Drien Beukah',
  },
  {
    id: '1111050020',
    districtId: '1111050',
    name: 'Paya Kambuek',
  },
  {
    id: '1111050021',
    districtId: '1111050',
    name: 'Paya Bili',
  },
  {
    id: '1111050022',
    districtId: '1111050',
    name: 'Drien Puntong',
  },
  {
    id: '1111050023',
    districtId: '1111050',
    name: 'Pulo Kitou',
  },
  {
    id: '1111050024',
    districtId: '1111050',
    name: 'Teungoh Reuba',
  },
  {
    id: '1111050025',
    districtId: '1111050',
    name: 'Meunasah Nga',
  },
  {
    id: '1111050026',
    districtId: '1111050',
    name: 'Ujong Reuba',
  },
  {
    id: '1111050027',
    districtId: '1111050',
    name: 'Mns Mesjid',
  },
  {
    id: '1111050028',
    districtId: '1111050',
    name: 'Mns Me',
  },
  {
    id: '1111050029',
    districtId: '1111050',
    name: 'Barat Paya Itik',
  },
  {
    id: '1111050030',
    districtId: '1111050',
    name: 'Pri Keutapang',
  },
  {
    id: '1111050031',
    districtId: '1111050',
    name: 'Kumbang',
  },
  {
    id: '1111050032',
    districtId: '1111050',
    name: 'Mns Keh',
  },
  {
    id: '1111050033',
    districtId: '1111050',
    name: 'Blang Cut',
  },
  {
    id: '1111050034',
    districtId: '1111050',
    name: 'Rayeuk Paya Itik',
  },
  {
    id: '1111050035',
    districtId: '1111050',
    name: 'Ubit Paya Itik',
  },
  {
    id: '1111050036',
    districtId: '1111050',
    name: 'Mns Rangkileh',
  },
  {
    id: '1111050037',
    districtId: '1111050',
    name: 'Tumpok Tungku',
  },
  {
    id: '1111050038',
    districtId: '1111050',
    name: 'Manyang',
  },
  {
    id: '1111050039',
    districtId: '1111050',
    name: 'Ulee Meuria',
  },
  {
    id: '1111050040',
    districtId: '1111050',
    name: 'Geulumpang',
  },
  {
    id: '1111050041',
    districtId: '1111050',
    name: 'Mns Tanjong',
  },
  {
    id: '1111050042',
    districtId: '1111050',
    name: 'Rayeuk Matang',
  },
  {
    id: '1111050043',
    districtId: '1111050',
    name: 'Keude Karieng',
  },
  {
    id: '1111050044',
    districtId: '1111050',
    name: 'Reudeup',
  },
  {
    id: '1111050045',
    districtId: '1111050',
    name: 'Pulo Bluek',
  },
  {
    id: '1111050046',
    districtId: '1111050',
    name: 'Dayah Bluek',
  },
  {
    id: '1111050047',
    districtId: '1111050',
    name: 'Meuria Bluek',
  },
  {
    id: '1111050048',
    districtId: '1111050',
    name: 'Ulee Ceubrek',
  },
  {
    id: '1111050049',
    districtId: '1111050',
    name: 'Mesjid Bluek',
  },
  {
    id: '1111050050',
    districtId: '1111050',
    name: 'Rheng Bluk',
  },
  {
    id: '1111060038',
    districtId: '1111060',
    name: 'Blang Seupeng',
  },
  {
    id: '1111060039',
    districtId: '1111060',
    name: 'Blang Kuta',
  },
  {
    id: '1111060047',
    districtId: '1111060',
    name: 'Leubok Pirak',
  },
  {
    id: '1111060048',
    districtId: '1111060',
    name: 'Beuracan Pirak',
  },
  {
    id: '1111060049',
    districtId: '1111060',
    name: 'Matang Peusangan',
  },
  {
    id: '1111060057',
    districtId: '1111060',
    name: 'Kunyet Mule',
  },
  {
    id: '1111060058',
    districtId: '1111060',
    name: 'Aron Pirak',
  },
  {
    id: '1111060059',
    districtId: '1111060',
    name: 'Mesjid Pirak',
  },
  {
    id: '1111060060',
    districtId: '1111060',
    name: 'Pante Pirak',
  },
  {
    id: '1111060066',
    districtId: '1111060',
    name: 'Beuringen',
  },
  {
    id: '1111060067',
    districtId: '1111060',
    name: 'Teungoh Pirak',
  },
  {
    id: '1111060068',
    districtId: '1111060',
    name: 'Rayeuk Pirak',
  },
  {
    id: '1111060069',
    districtId: '1111060',
    name: 'Tutong',
  },
  {
    id: '1111060071',
    districtId: '1111060',
    name: 'Teungoh Seuleumak',
  },
  {
    id: '1111060072',
    districtId: '1111060',
    name: 'Tanjong Tgk Kari',
  },
  {
    id: '1111060073',
    districtId: '1111060',
    name: 'Seuriweuk',
  },
  {
    id: '1111060074',
    districtId: '1111060',
    name: 'Dayah Baro',
  },
  {
    id: '1111060075',
    districtId: '1111060',
    name: 'Alue Tho',
  },
  {
    id: '1111060076',
    districtId: '1111060',
    name: 'Ceubrek Pirak',
  },
  {
    id: '1111060077',
    districtId: '1111060',
    name: 'Meunye Pirak',
  },
  {
    id: '1111060078',
    districtId: '1111060',
    name: 'Siren',
  },
  {
    id: '1111060079',
    districtId: '1111060',
    name: 'Tanjong Haji Muda',
  },
  {
    id: '1111060085',
    districtId: '1111060',
    name: 'Trieng Teupin Keubeu',
  },
  {
    id: '1111060086',
    districtId: '1111060',
    name: 'Teupin Keubeu',
  },
  {
    id: '1111060087',
    districtId: '1111060',
    name: 'Tanjong Babah Krueng',
  },
  {
    id: '1111060088',
    districtId: '1111060',
    name: 'Lawang',
  },
  {
    id: '1111060089',
    districtId: '1111060',
    name: 'Tanjong Tgk Ali',
  },
  {
    id: '1111060090',
    districtId: '1111060',
    name: 'Hagu',
  },
  {
    id: '1111060091',
    districtId: '1111060',
    name: 'Meuria Matang Kuli',
  },
  {
    id: '1111060092',
    districtId: '1111060',
    name: 'Alue Entok',
  },
  {
    id: '1111060093',
    districtId: '1111060',
    name: 'Tumpok Barat',
  },
  {
    id: '1111060094',
    districtId: '1111060',
    name: 'Parang IX',
  },
  {
    id: '1111060095',
    districtId: '1111060',
    name: 'Baro',
  },
  {
    id: '1111060096',
    districtId: '1111060',
    name: 'Mee',
  },
  {
    id: '1111060097',
    districtId: '1111060',
    name: 'Blang',
  },
  {
    id: '1111060098',
    districtId: '1111060',
    name: 'Keude Matang Kuli',
  },
  {
    id: '1111060099',
    districtId: '1111060',
    name: 'Punti Matang Kuli',
  },
  {
    id: '1111060100',
    districtId: '1111060',
    name: 'Matang Mee',
  },
  {
    id: '1111060101',
    districtId: '1111060',
    name: 'Rayeuk Glangglong',
  },
  {
    id: '1111060102',
    districtId: '1111060',
    name: 'Tumpok Peureulak',
  },
  {
    id: '1111060103',
    districtId: '1111060',
    name: 'Rayeuk Matang Kuli',
  },
  {
    id: '1111060104',
    districtId: '1111060',
    name: 'Ude',
  },
  {
    id: '1111060105',
    districtId: '1111060',
    name: 'Ujong Kulam',
  },
  {
    id: '1111060106',
    districtId: '1111060',
    name: 'Jeumpa Glumpang VII',
  },
  {
    id: '1111060107',
    districtId: '1111060',
    name: 'Punti Glumpang VII',
  },
  {
    id: '1111060108',
    districtId: '1111060',
    name: 'Glumpang VII',
  },
  {
    id: '1111060109',
    districtId: '1111060',
    name: 'Teungoh Glp VII',
  },
  {
    id: '1111060110',
    districtId: '1111060',
    name: 'Aron Glp VII',
  },
  {
    id: '1111060111',
    districtId: '1111060',
    name: 'Matang Munye',
  },
  {
    id: '1111061001',
    districtId: '1111061',
    name: 'Blang Mane',
  },
  {
    id: '1111061002',
    districtId: '1111061',
    name: 'Matang Panyang',
  },
  {
    id: '1111061003',
    districtId: '1111061',
    name: 'Alue Lhok',
  },
  {
    id: '1111061004',
    districtId: '1111061',
    name: 'Seuneubok Aceh',
  },
  {
    id: '1111061005',
    districtId: '1111061',
    name: 'Buket Pidie',
  },
  {
    id: '1111061006',
    districtId: '1111061',
    name: 'Buket Guru',
  },
  {
    id: '1111061007',
    districtId: '1111061',
    name: 'Alue Bieng',
  },
  {
    id: '1111061008',
    districtId: '1111061',
    name: 'Peureupok',
  },
  {
    id: '1111061009',
    districtId: '1111061',
    name: 'Blang Gunci',
  },
  {
    id: '1111061010',
    districtId: '1111061',
    name: 'Pante Seuleumak',
  },
  {
    id: '1111061011',
    districtId: '1111061',
    name: 'Nga',
  },
  {
    id: '1111061012',
    districtId: '1111061',
    name: 'Mampree',
  },
  {
    id: '1111061013',
    districtId: '1111061',
    name: 'Tanjong Drien',
  },
  {
    id: '1111061014',
    districtId: '1111061',
    name: 'Cot Tufah',
  },
  {
    id: '1111061015',
    districtId: '1111061',
    name: 'Asan Seuleumak',
  },
  {
    id: '1111061016',
    districtId: '1111061',
    name: 'Tgk Dibanda Tek-Tek',
  },
  {
    id: '1111061017',
    districtId: '1111061',
    name: 'Simpang',
  },
  {
    id: '1111061018',
    districtId: '1111061',
    name: 'Keubon Pirak',
  },
  {
    id: '1111061019',
    districtId: '1111061',
    name: 'Blang Ara',
  },
  {
    id: '1111061020',
    districtId: '1111061',
    name: 'Geureughek',
  },
  {
    id: '1111061021',
    districtId: '1111061',
    name: 'Blang Pante',
  },
  {
    id: '1111061022',
    districtId: '1111061',
    name: 'Lueng',
  },
  {
    id: '1111061023',
    districtId: '1111061',
    name: 'Tgk Dibanda Pirak',
  },
  {
    id: '1111061024',
    districtId: '1111061',
    name: 'Geulumpang Pirak',
  },
  {
    id: '1111061025',
    districtId: '1111061',
    name: 'Blang Sialet',
  },
  {
    id: '1111061026',
    districtId: '1111061',
    name: 'Blang Paku',
  },
  {
    id: '1111061027',
    districtId: '1111061',
    name: 'Blang Dalam',
  },
  {
    id: '1111061028',
    districtId: '1111061',
    name: 'Meuria Seuleumak',
  },
  {
    id: '1111061029',
    districtId: '1111061',
    name: 'Leuhong',
  },
  {
    id: '1111061030',
    districtId: '1111061',
    name: 'Tanjong Beurunyong',
  },
  {
    id: '1111061031',
    districtId: '1111061',
    name: 'Keude Paya Bakong',
  },
  {
    id: '1111061032',
    districtId: '1111061',
    name: 'Ceumpeudak',
  },
  {
    id: '1111061033',
    districtId: '1111061',
    name: 'Paya Meudru',
  },
  {
    id: '1111061034',
    districtId: '1111061',
    name: 'Meunye Seuleumak',
  },
  {
    id: '1111061035',
    districtId: '1111061',
    name: 'Alue Leukot',
  },
  {
    id: '1111061036',
    districtId: '1111061',
    name: 'Pucok Alue Seuleumak',
  },
  {
    id: '1111061037',
    districtId: '1111061',
    name: 'Jok',
  },
  {
    id: '1111061038',
    districtId: '1111061',
    name: 'Tunong Krueng',
  },
  {
    id: '1111061039',
    districtId: '1111061',
    name: 'Tumpok Mesjid',
  },
  {
    id: '1111062001',
    districtId: '1111062',
    name: 'Tanjong Seuruekuy',
  },
  {
    id: '1111062002',
    districtId: '1111062',
    name: 'Alue Rimee',
  },
  {
    id: '1111062003',
    districtId: '1111062',
    name: 'Paya Lueng Jalo',
  },
  {
    id: '1111062004',
    districtId: '1111062',
    name: 'Serdang',
  },
  {
    id: '1111062005',
    districtId: '1111062',
    name: 'Ulee Blang',
  },
  {
    id: '1111062006',
    districtId: '1111062',
    name: 'Meunye VII',
  },
  {
    id: '1111062007',
    districtId: '1111062',
    name: 'Pucok Alue Pirak',
  },
  {
    id: '1111062008',
    districtId: '1111062',
    name: 'Ara Tonton Moncrang',
  },
  {
    id: '1111062009',
    districtId: '1111062',
    name: 'Bili Baro',
  },
  {
    id: '1111062010',
    districtId: '1111062',
    name: 'Keutapang',
  },
  {
    id: '1111062011',
    districtId: '1111062',
    name: 'Rengkam',
  },
  {
    id: '1111062012',
    districtId: '1111062',
    name: 'Teupin U',
  },
  {
    id: '1111062013',
    districtId: '1111062',
    name: 'Alue Bungkoh',
  },
  {
    id: '1111062014',
    districtId: '1111062',
    name: 'Ceumeucet',
  },
  {
    id: '1111062015',
    districtId: '1111062',
    name: 'Leupe',
  },
  {
    id: '1111062016',
    districtId: '1111062',
    name: 'Trieng Krueng Kreh',
  },
  {
    id: '1111062017',
    districtId: '1111062',
    name: 'Matang Keh',
  },
  {
    id: '1111062018',
    districtId: '1111062',
    name: 'Krueng Pirak',
  },
  {
    id: '1111062019',
    districtId: '1111062',
    name: 'Rayeuk Pange',
  },
  {
    id: '1111062020',
    districtId: '1111062',
    name: 'Bungong',
  },
  {
    id: '1111062021',
    districtId: '1111062',
    name: 'Geulumpang',
  },
  {
    id: '1111062022',
    districtId: '1111062',
    name: 'Asan Krueng Kreh',
  },
  {
    id: '1111062023',
    districtId: '1111062',
    name: 'Beuracan Rata',
  },
  {
    id: '1111070001',
    districtId: '1111070',
    name: 'Cot Girek',
  },
  {
    id: '1111070002',
    districtId: '1111070',
    name: 'Alue Leuhob',
  },
  {
    id: '1111070003',
    districtId: '1111070',
    name: 'Lhok Merbo',
  },
  {
    id: '1111070004',
    districtId: '1111070',
    name: 'Kampung Bantan',
  },
  {
    id: '1111070005',
    districtId: '1111070',
    name: 'Alue Seumambu',
  },
  {
    id: '1111070006',
    districtId: '1111070',
    name: 'Batu XII',
  },
  {
    id: '1111070007',
    districtId: '1111070',
    name: 'Kampung Tempel',
  },
  {
    id: '1111070008',
    districtId: '1111070',
    name: 'Seupeng',
  },
  {
    id: '1111070009',
    districtId: '1111070',
    name: 'Beurandang Dayah',
  },
  {
    id: '1111070010',
    districtId: '1111070',
    name: 'Beurandang Asan',
  },
  {
    id: '1111070011',
    districtId: '1111070',
    name: 'Drien II',
  },
  {
    id: '1111070012',
    districtId: '1111070',
    name: 'Beurandang Krueng',
  },
  {
    id: '1111070013',
    districtId: '1111070',
    name: 'Jeulikat',
  },
  {
    id: '1111070014',
    districtId: '1111070',
    name: 'Ara',
  },
  {
    id: '1111070015',
    districtId: '1111070',
    name: 'Lueng Baro',
  },
  {
    id: '1111070016',
    districtId: '1111070',
    name: 'Lhok Reuhat',
  },
  {
    id: '1111070017',
    districtId: '1111070',
    name: 'Trieng',
  },
  {
    id: '1111070018',
    districtId: '1111070',
    name: 'U Baro',
  },
  {
    id: '1111070019',
    districtId: '1111070',
    name: 'Ceumpeudak',
  },
  {
    id: '1111070020',
    districtId: '1111070',
    name: 'Alue Drien',
  },
  {
    id: '1111070021',
    districtId: '1111070',
    name: 'Seuneubok Baro',
  },
  {
    id: '1111070022',
    districtId: '1111070',
    name: 'Ulee Gampong',
  },
  {
    id: '1111070023',
    districtId: '1111070',
    name: 'Pucok Alue',
  },
  {
    id: '1111070024',
    districtId: '1111070',
    name: 'Matang Teungoh',
  },
  {
    id: '1111080024',
    districtId: '1111080',
    name: 'Buket Jeurat Manyang',
  },
  {
    id: '1111080025',
    districtId: '1111080',
    name: 'Matang Raya',
  },
  {
    id: '1111080026',
    districtId: '1111080',
    name: 'Matang Seuke Pulot',
  },
  {
    id: '1111080027',
    districtId: '1111080',
    name: 'Lueng Tuha',
  },
  {
    id: '1111080028',
    districtId: '1111080',
    name: 'Pucok Alue',
  },
  {
    id: '1111080029',
    districtId: '1111080',
    name: 'Matang Serdang',
  },
  {
    id: '1111080030',
    districtId: '1111080',
    name: 'Matang Teungoh T',
  },
  {
    id: '1111080031',
    districtId: '1111080',
    name: 'Buket Padang',
  },
  {
    id: '1111080032',
    districtId: '1111080',
    name: 'Lhok Beuringen',
  },
  {
    id: '1111080033',
    districtId: '1111080',
    name: 'Lhok Merbo',
  },
  {
    id: '1111080034',
    districtId: '1111080',
    name: 'Buket Alue Puteh',
  },
  {
    id: '1111080035',
    districtId: '1111080',
    name: 'Lhok Reudeup',
  },
  {
    id: '1111080036',
    districtId: '1111080',
    name: 'Matang Maneh',
  },
  {
    id: '1111080037',
    districtId: '1111080',
    name: 'Alue Ie Mirah',
  },
  {
    id: '1111080038',
    districtId: '1111080',
    name: 'Tanjung Punti',
  },
  {
    id: '1111080039',
    districtId: '1111080',
    name: 'Tanjung Ara',
  },
  {
    id: '1111080040',
    districtId: '1111080',
    name: 'Matang Santot',
  },
  {
    id: '1111080041',
    districtId: '1111080',
    name: 'Ulee Gle',
  },
  {
    id: '1111080042',
    districtId: '1111080',
    name: 'Buket Batee Badan',
  },
  {
    id: '1111080043',
    districtId: '1111080',
    name: 'Biram Cut',
  },
  {
    id: '1111080044',
    districtId: '1111080',
    name: 'Biram Rayeuk',
  },
  {
    id: '1111080045',
    districtId: '1111080',
    name: 'Cot Biek',
  },
  {
    id: '1111080046',
    districtId: '1111080',
    name: 'Matang Arongan',
  },
  {
    id: '1111080047',
    districtId: '1111080',
    name: 'Lhok Bintang Hu',
  },
  {
    id: '1111080048',
    districtId: '1111080',
    name: 'Biara Barat',
  },
  {
    id: '1111080049',
    districtId: '1111080',
    name: 'Biara Timur',
  },
  {
    id: '1111080050',
    districtId: '1111080',
    name: 'Matang Drien',
  },
  {
    id: '1111080051',
    districtId: '1111080',
    name: 'Ceumpeudak',
  },
  {
    id: '1111080052',
    districtId: '1111080',
    name: 'Alue Papeun',
  },
  {
    id: '1111080053',
    districtId: '1111080',
    name: 'Samakurok',
  },
  {
    id: '1111080054',
    districtId: '1111080',
    name: 'Rawang Itik',
  },
  {
    id: '1111080055',
    districtId: '1111080',
    name: 'Kota Panton Labu',
  },
  {
    id: '1111080056',
    districtId: '1111080',
    name: 'Mns Panton Labu',
  },
  {
    id: '1111080057',
    districtId: '1111080',
    name: 'Tanjong Ceungai',
  },
  {
    id: '1111080058',
    districtId: '1111080',
    name: 'Teupin Bayu',
  },
  {
    id: '1111080059',
    districtId: '1111080',
    name: 'Teupin Gajah',
  },
  {
    id: '1111080060',
    districtId: '1111080',
    name: 'Tanjong Meunye',
  },
  {
    id: '1111080061',
    districtId: '1111080',
    name: 'Matang Jurong',
  },
  {
    id: '1111080062',
    districtId: '1111080',
    name: 'Tanjong Dalam Utara',
  },
  {
    id: '1111080063',
    districtId: '1111080',
    name: 'Tanjong Menuang',
  },
  {
    id: '1111080064',
    districtId: '1111080',
    name: 'Seuneubok Pidie',
  },
  {
    id: '1111080065',
    districtId: '1111080',
    name: 'Meunasah Dayah',
  },
  {
    id: '1111080066',
    districtId: '1111080',
    name: 'Meunasah Geudong',
  },
  {
    id: '1111080067',
    districtId: '1111080',
    name: 'Meunasah Merbo',
  },
  {
    id: '1111080068',
    districtId: '1111080',
    name: 'Seuneubok Dhou',
  },
  {
    id: '1111080069',
    districtId: '1111080',
    name: 'Rantau Panyang',
  },
  {
    id: '1111080070',
    districtId: '1111080',
    name: 'Geulumpang Umpung Unou',
  },
  {
    id: '1111081001',
    districtId: '1111081',
    name: 'Leubok Pusaka',
  },
  {
    id: '1111081002',
    districtId: '1111081',
    name: 'Seureuke',
  },
  {
    id: '1111081003',
    districtId: '1111081',
    name: 'Buket Linteung',
  },
  {
    id: '1111081004',
    districtId: '1111081',
    name: 'Rumoh Rayeuk',
  },
  {
    id: '1111081005',
    districtId: '1111081',
    name: 'Langkahan',
  },
  {
    id: '1111081006',
    districtId: '1111081',
    name: 'Geudumbak',
  },
  {
    id: '1111081007',
    districtId: '1111081',
    name: 'Tanjong Dalam Selatan',
  },
  {
    id: '1111081008',
    districtId: '1111081',
    name: 'Meunasah Blang',
  },
  {
    id: '1111081009',
    districtId: '1111081',
    name: 'Alue Krak Kayee',
  },
  {
    id: '1111081010',
    districtId: '1111081',
    name: 'Tanjong Jawa',
  },
  {
    id: '1111081011',
    districtId: '1111081',
    name: 'Matang Teungoh S',
  },
  {
    id: '1111081012',
    districtId: '1111081',
    name: 'Padang Meuria',
  },
  {
    id: '1111081013',
    districtId: '1111081',
    name: 'Leubok Mane',
  },
  {
    id: '1111081014',
    districtId: '1111081',
    name: 'Matang Rubek',
  },
  {
    id: '1111081015',
    districtId: '1111081',
    name: 'Simpang Tiga',
  },
  {
    id: '1111081016',
    districtId: '1111081',
    name: 'Paya Tukai',
  },
  {
    id: '1111081017',
    districtId: '1111081',
    name: 'Kampong Blang',
  },
  {
    id: '1111081018',
    districtId: '1111081',
    name: 'Matang  Keutapang',
  },
  {
    id: '1111081019',
    districtId: '1111081',
    name: 'Pante Gaki Bale',
  },
  {
    id: '1111081020',
    districtId: '1111081',
    name: 'Krueng Lingka',
  },
  {
    id: '1111081021',
    districtId: '1111081',
    name: 'Bantayan',
  },
  {
    id: '1111081022',
    districtId: '1111081',
    name: 'Alue Dua',
  },
  {
    id: '1111081023',
    districtId: '1111081',
    name: 'Cot Bada',
  },
  {
    id: '1111090001',
    districtId: '1111090',
    name: 'Blang Tue',
  },
  {
    id: '1111090002',
    districtId: '1111090',
    name: 'Merbo Puntong',
  },
  {
    id: '1111090003',
    districtId: '1111090',
    name: 'Mane Kawan',
  },
  {
    id: '1111090004',
    districtId: '1111090',
    name: 'Tanjong Pineung',
  },
  {
    id: '1111090005',
    districtId: '1111090',
    name: 'Alue Kiran',
  },
  {
    id: '1111090006',
    districtId: '1111090',
    name: 'Alue Barueh',
  },
  {
    id: '1111090007',
    districtId: '1111090',
    name: 'Keude Simpang Jalan',
  },
  {
    id: '1111090008',
    districtId: '1111090',
    name: 'Cot Kafiraton',
  },
  {
    id: '1111090009',
    districtId: '1111090',
    name: 'Paya Dua Ujong',
  },
  {
    id: '1111090010',
    districtId: '1111090',
    name: 'Tanjong Dama',
  },
  {
    id: '1111090011',
    districtId: '1111090',
    name: 'Paya Dua Uram',
  },
  {
    id: '1111090012',
    districtId: '1111090',
    name: 'Lhok Geulituet',
  },
  {
    id: '1111090013',
    districtId: '1111090',
    name: 'Matang Anoe',
  },
  {
    id: '1111090014',
    districtId: '1111090',
    name: 'Lhok Rambideng',
  },
  {
    id: '1111090015',
    districtId: '1111090',
    name: 'Blang Pha',
  },
  {
    id: '1111090016',
    districtId: '1111090',
    name: 'Matang Jeulikat',
  },
  {
    id: '1111090017',
    districtId: '1111090',
    name: 'Darul Aman',
  },
  {
    id: '1111090018',
    districtId: '1111090',
    name: 'Cot Trueng',
  },
  {
    id: '1111090019',
    districtId: '1111090',
    name: 'Meunasah Sagoe',
  },
  {
    id: '1111090020',
    districtId: '1111090',
    name: 'Matang Puntong',
  },
  {
    id: '1111090021',
    districtId: '1111090',
    name: 'Matang Panyang',
  },
  {
    id: '1111090022',
    districtId: '1111090',
    name: 'Cot Patisah',
  },
  {
    id: '1111090023',
    districtId: '1111090',
    name: 'Alue Capli',
  },
  {
    id: '1111090024',
    districtId: '1111090',
    name: 'Simpang Peut',
  },
  {
    id: '1111090025',
    districtId: '1111090',
    name: 'Ulee Titi',
  },
  {
    id: '1111090026',
    districtId: '1111090',
    name: 'Lhok Puuk',
  },
  {
    id: '1111090027',
    districtId: '1111090',
    name: 'Ulee Rubek Barat',
  },
  {
    id: '1111090028',
    districtId: '1111090',
    name: 'Matang Lada',
  },
  {
    id: '1111090029',
    districtId: '1111090',
    name: 'Matang Karieng',
  },
  {
    id: '1111090030',
    districtId: '1111090',
    name: 'Ulee Matang',
  },
  {
    id: '1111090031',
    districtId: '1111090',
    name: 'Ulee Rube Timu',
  },
  {
    id: '1111090032',
    districtId: '1111090',
    name: 'Bantayan',
  },
  {
    id: '1111090033',
    districtId: '1111090',
    name: 'Teupin Kuyuen',
  },
  {
    id: '1111100001',
    districtId: '1111100',
    name: 'Cinta Makmur',
  },
  {
    id: '1111100002',
    districtId: '1111100',
    name: 'Babussalam',
  },
  {
    id: '1111100003',
    districtId: '1111100',
    name: 'Buket Dara Baro',
  },
  {
    id: '1111100004',
    districtId: '1111100',
    name: 'Matang Baro',
  },
  {
    id: '1111100005',
    districtId: '1111100',
    name: 'Ujong Dama',
  },
  {
    id: '1111100006',
    districtId: '1111100',
    name: 'Buket Mon Sukon',
  },
  {
    id: '1111100007',
    districtId: '1111100',
    name: 'Matang Beuringen',
  },
  {
    id: '1111100009',
    districtId: '1111100',
    name: 'Matang Pineung',
  },
  {
    id: '1111100010',
    districtId: '1111100',
    name: 'Ceumpedak',
  },
  {
    id: '1111100011',
    districtId: '1111100',
    name: 'Matang Reudeup',
  },
  {
    id: '1111100012',
    districtId: '1111100',
    name: 'Buket Lueng Bata',
  },
  {
    id: '1111100013',
    districtId: '1111100',
    name: 'Matang Manyam',
  },
  {
    id: '1111100014',
    districtId: '1111100',
    name: 'Cot Manyang',
  },
  {
    id: '1111100015',
    districtId: '1111100',
    name: 'Keude Meunye IV',
  },
  {
    id: '1111100016',
    districtId: '1111100',
    name: 'Matang Ulim',
  },
  {
    id: '1111100017',
    districtId: '1111100',
    name: 'Matang Linya',
  },
  {
    id: '1111100023',
    districtId: '1111100',
    name: 'Alue Ie Tarek',
  },
  {
    id: '1111100024',
    districtId: '1111100',
    name: 'Geulumpang Bungkok',
  },
  {
    id: '1111100025',
    districtId: '1111100',
    name: 'Arongan Lise',
  },
  {
    id: '1111100026',
    districtId: '1111100',
    name: 'Glumpang Payong',
  },
  {
    id: '1111100027',
    districtId: '1111100',
    name: 'Alue Rambong',
  },
  {
    id: '1111100028',
    districtId: '1111100',
    name: 'Geulumpang Samlakoe',
  },
  {
    id: '1111100029',
    districtId: '1111100',
    name: 'Matang Rawa',
  },
  {
    id: '1111100030',
    districtId: '1111100',
    name: 'Matang Lawang',
  },
  {
    id: '1111100032',
    districtId: '1111100',
    name: 'Cot Ara',
  },
  {
    id: '1111100033',
    districtId: '1111100',
    name: 'Alue Dama',
  },
  {
    id: '1111100034',
    districtId: '1111100',
    name: 'Alue Bili Geulumpang',
  },
  {
    id: '1111100035',
    districtId: '1111100',
    name: 'Pucok Alue',
  },
  {
    id: '1111100036',
    districtId: '1111100',
    name: 'Matang Kareung',
  },
  {
    id: '1111100037',
    districtId: '1111100',
    name: 'Cot Ulaya',
  },
  {
    id: '1111100040',
    districtId: '1111100',
    name: 'Keude Panteu Breuh',
  },
  {
    id: '1111100041',
    districtId: '1111100',
    name: 'Rambong Dalam',
  },
  {
    id: '1111100042',
    districtId: '1111100',
    name: 'Alue Bili Rayeuk',
  },
  {
    id: '1111100043',
    districtId: '1111100',
    name: 'Meunasah Alue Ie Puteh',
  },
  {
    id: '1111100044',
    districtId: '1111100',
    name: 'Keude Alue Ie Puteh',
  },
  {
    id: '1111100045',
    districtId: '1111100',
    name: 'Matang Kumbang',
  },
  {
    id: '1111100057',
    districtId: '1111100',
    name: 'Cot Mane',
  },
  {
    id: '1111100058',
    districtId: '1111100',
    name: 'Cot Kumbang',
  },
  {
    id: '1111100059',
    districtId: '1111100',
    name: 'Lhok Seutuy',
  },
  {
    id: '1111100060',
    districtId: '1111100',
    name: 'Meunasah Bujok',
  },
  {
    id: '1111100061',
    districtId: '1111100',
    name: 'Alue Jamok',
  },
  {
    id: '1111100062',
    districtId: '1111100',
    name: 'Meudang Ara',
  },
  {
    id: '1111100063',
    districtId: '1111100',
    name: 'Alue Keutapang',
  },
  {
    id: '1111100064',
    districtId: '1111100',
    name: 'Meunasah Geudong',
  },
  {
    id: '1111100065',
    districtId: '1111100',
    name: 'Krueng Lingka Timu',
  },
  {
    id: '1111100066',
    districtId: '1111100',
    name: 'Krueng Lingka Barat',
  },
  {
    id: '1111100067',
    districtId: '1111100',
    name: 'Alue Anou Timu',
  },
  {
    id: '1111100068',
    districtId: '1111100',
    name: 'Alue Anou Barat',
  },
  {
    id: '1111100069',
    districtId: '1111100',
    name: 'Alue Serdang',
  },
  {
    id: '1111100070',
    districtId: '1111100',
    name: 'Matang Raya Barat',
  },
  {
    id: '1111100074',
    districtId: '1111100',
    name: 'Pulo Seuke',
  },
  {
    id: '1111100075',
    districtId: '1111100',
    name: 'Alue Geudong',
  },
  {
    id: '1111100076',
    districtId: '1111100',
    name: 'Matang Keulayu',
  },
  {
    id: '1111100077',
    districtId: '1111100',
    name: 'Matang Raya Timu',
  },
  {
    id: '1111100078',
    districtId: '1111100',
    name: 'Alue Buya',
  },
  {
    id: '1111100079',
    districtId: '1111100',
    name: 'Matang Cut',
  },
  {
    id: '1111100080',
    districtId: '1111100',
    name: 'Tanjong Glumpang',
  },
  {
    id: '1111101001',
    districtId: '1111101',
    name: 'Cot Kupok',
  },
  {
    id: '1111101002',
    districtId: '1111101',
    name: 'Matang Raya Blang Sialet',
  },
  {
    id: '1111101003',
    districtId: '1111101',
    name: 'Pucok Alue Buket',
  },
  {
    id: '1111101004',
    districtId: '1111101',
    name: 'Cot Paya',
  },
  {
    id: '1111101005',
    districtId: '1111101',
    name: 'Matang Teungoh',
  },
  {
    id: '1111101006',
    districtId: '1111101',
    name: 'Matang Panyang',
  },
  {
    id: '1111101007',
    districtId: '1111101',
    name: 'Matang Bayu',
  },
  {
    id: '1111101008',
    districtId: '1111101',
    name: 'Lang Nibong',
  },
  {
    id: '1111101009',
    districtId: '1111101',
    name: 'Singgah Mata',
  },
  {
    id: '1111101010',
    districtId: '1111101',
    name: 'Matang Ceubrek',
  },
  {
    id: '1111101011',
    districtId: '1111101',
    name: 'Cot Usen',
  },
  {
    id: '1111101012',
    districtId: '1111101',
    name: 'Matang Sijuek Barat',
  },
  {
    id: '1111101013',
    districtId: '1111101',
    name: 'Matang Sijuek Teungoh',
  },
  {
    id: '1111101014',
    districtId: '1111101',
    name: 'Matang Sijuek Timu',
  },
  {
    id: '1111101015',
    districtId: '1111101',
    name: 'Keude Sampoyniet',
  },
  {
    id: '1111101016',
    districtId: '1111101',
    name: 'Blang Seunong',
  },
  {
    id: '1111101017',
    districtId: '1111101',
    name: 'Matang Paya',
  },
  {
    id: '1111101018',
    districtId: '1111101',
    name: 'Lhok Iboh',
  },
  {
    id: '1111101019',
    districtId: '1111101',
    name: 'Cot Laba',
  },
  {
    id: '1111101020',
    districtId: '1111101',
    name: 'Meunasah Pante',
  },
  {
    id: '1111101021',
    districtId: '1111101',
    name: 'Cot Murong',
  },
  {
    id: '1111101022',
    districtId: '1111101',
    name: 'Meurandeh Paya',
  },
  {
    id: '1111101023',
    districtId: '1111101',
    name: 'Meunasah Hagu',
  },
  {
    id: '1111101024',
    districtId: '1111101',
    name: 'Blang Rheu',
  },
  {
    id: '1111101025',
    districtId: '1111101',
    name: 'Lhok Euncien',
  },
  {
    id: '1111101026',
    districtId: '1111101',
    name: 'Paya Bateung',
  },
  {
    id: '1111110001',
    districtId: '1111110',
    name: 'Geulumpang',
  },
  {
    id: '1111110002',
    districtId: '1111110',
    name: 'Buloh Lt',
  },
  {
    id: '1111110003',
    districtId: '1111110',
    name: 'Alue Abee',
  },
  {
    id: '1111110004',
    districtId: '1111110',
    name: 'Alue Eumpok',
  },
  {
    id: '1111110005',
    districtId: '1111110',
    name: 'Alue Itam Reudeup',
  },
  {
    id: '1111110006',
    districtId: '1111110',
    name: 'Buket Krueng',
  },
  {
    id: '1111110007',
    districtId: '1111110',
    name: 'Meunasah Teungoh Lb',
  },
  {
    id: '1111110008',
    districtId: '1111110',
    name: 'Kumbang Lt',
  },
  {
    id: '1111110009',
    districtId: '1111110',
    name: 'Alue Itam Baroh',
  },
  {
    id: '1111110010',
    districtId: '1111110',
    name: 'Meuria',
  },
  {
    id: '1111110011',
    districtId: '1111110',
    name: 'Arongan Lt',
  },
  {
    id: '1111110012',
    districtId: '1111110',
    name: 'Buket Me Lt',
  },
  {
    id: '1111110013',
    districtId: '1111110',
    name: 'Dayah Lt',
  },
  {
    id: '1111110014',
    districtId: '1111110',
    name: 'Krueng Lt',
  },
  {
    id: '1111110015',
    districtId: '1111110',
    name: 'Meunasah Tuha',
  },
  {
    id: '1111110016',
    districtId: '1111110',
    name: 'Meunasah Rayeuk Lb',
  },
  {
    id: '1111110017',
    districtId: '1111110',
    name: 'Meucat',
  },
  {
    id: '1111110018',
    districtId: '1111110',
    name: 'Asan Lb',
  },
  {
    id: '1111110019',
    districtId: '1111110',
    name: 'Rawa',
  },
  {
    id: '1111110020',
    districtId: '1111110',
    name: 'Babah Geudubang',
  },
  {
    id: '1111110021',
    districtId: '1111110',
    name: 'Meunasah Meurebo',
  },
  {
    id: '1111110022',
    districtId: '1111110',
    name: 'Ulee Gunong',
  },
  {
    id: '1111110023',
    districtId: '1111110',
    name: 'Teupin Keubeu',
  },
  {
    id: '1111110024',
    districtId: '1111110',
    name: 'Seuneubok Dalam',
  },
  {
    id: '1111110025',
    districtId: '1111110',
    name: 'Grong Grong',
  },
  {
    id: '1111110026',
    districtId: '1111110',
    name: 'Lhok Kareung',
  },
  {
    id: '1111110027',
    districtId: '1111110',
    name: 'Cot Asan',
  },
  {
    id: '1111110028',
    districtId: '1111110',
    name: 'Buket Hagu',
  },
  {
    id: '1111110030',
    districtId: '1111110',
    name: 'Mata Ie',
  },
  {
    id: '1111110031',
    districtId: '1111110',
    name: 'Mata U',
  },
  {
    id: '1111110032',
    districtId: '1111110',
    name: 'Lhok Sentang',
  },
  {
    id: '1111110033',
    districtId: '1111110',
    name: 'Ulee Tanoh',
  },
  {
    id: '1111110034',
    districtId: '1111110',
    name: 'Nga Lt',
  },
  {
    id: '1111110035',
    districtId: '1111110',
    name: 'Meunasah Jok',
  },
  {
    id: '1111110036',
    districtId: '1111110',
    name: 'Meunasah Nga Lb',
  },
  {
    id: '1111110037',
    districtId: '1111110',
    name: 'Matang Meunye',
  },
  {
    id: '1111110038',
    districtId: '1111110',
    name: 'Beringin Lb',
  },
  {
    id: '1111110039',
    districtId: '1111110',
    name: 'Manyang',
  },
  {
    id: '1111110040',
    districtId: '1111110',
    name: 'Blang',
  },
  {
    id: '1111110041',
    districtId: '1111110',
    name: 'Ceubrek',
  },
  {
    id: '1111110042',
    districtId: '1111110',
    name: 'Kuta Lhoksukon',
  },
  {
    id: '1111110043',
    districtId: '1111110',
    name: 'Dayah Lb',
  },
  {
    id: '1111110044',
    districtId: '1111110',
    name: 'Meunasah Matang Teungoh Lt',
  },
  {
    id: '1111110045',
    districtId: '1111110',
    name: 'Meunasah Geulinggang',
  },
  {
    id: '1111110046',
    districtId: '1111110',
    name: 'Ulee Barat',
  },
  {
    id: '1111110047',
    districtId: '1111110',
    name: 'Pulo Dulang',
  },
  {
    id: '1111110048',
    districtId: '1111110',
    name: 'Meunasah Tutong',
  },
  {
    id: '1111110049',
    districtId: '1111110',
    name: 'Meunasah Geumata',
  },
  {
    id: '1111110050',
    districtId: '1111110',
    name: 'Meunasah Pante',
  },
  {
    id: '1111110051',
    districtId: '1111110',
    name: 'Trieng Matang Ubi',
  },
  {
    id: '1111110052',
    districtId: '1111110',
    name: 'Meunye Matang Ubi',
  },
  {
    id: '1111110053',
    districtId: '1111110',
    name: 'Blang Rubek',
  },
  {
    id: '1111110054',
    districtId: '1111110',
    name: 'Alue Buket',
  },
  {
    id: '1111110055',
    districtId: '1111110',
    name: 'Meunasah Reudeup',
  },
  {
    id: '1111110056',
    districtId: '1111110',
    name: 'Nga Matang Ubi',
  },
  {
    id: '1111110057',
    districtId: '1111110',
    name: 'Buket Sentang',
  },
  {
    id: '1111110058',
    districtId: '1111110',
    name: 'Blang Aman',
  },
  {
    id: '1111110059',
    districtId: '1111110',
    name: 'Cot U Sibak',
  },
  {
    id: '1111110060',
    districtId: '1111110',
    name: 'Bintang Hu',
  },
  {
    id: '1111110061',
    districtId: '1111110',
    name: 'Cot Ara',
  },
  {
    id: '1111110062',
    districtId: '1111110',
    name: 'Cot Geulumpang Ab',
  },
  {
    id: '1111110063',
    districtId: '1111110',
    name: 'Abeuk Leupen',
  },
  {
    id: '1111110064',
    districtId: '1111110',
    name: 'Matang Pupanji Ab',
  },
  {
    id: '1111110065',
    districtId: '1111110',
    name: 'Matang Teungoh Ab',
  },
  {
    id: '1111110066',
    districtId: '1111110',
    name: 'Meunasah Asan Ab',
  },
  {
    id: '1111110067',
    districtId: '1111110',
    name: 'Ranto',
  },
  {
    id: '1111110068',
    districtId: '1111110',
    name: 'Keutapang',
  },
  {
    id: '1111110069',
    districtId: '1111110',
    name: 'Alue Mudem',
  },
  {
    id: '1111110070',
    districtId: '1111110',
    name: 'R A M B O T',
  },
  {
    id: '1111110071',
    districtId: '1111110',
    name: 'Ara Ab',
  },
  {
    id: '1111110072',
    districtId: '1111110',
    name: 'Meunasah Alue Drien Lb',
  },
  {
    id: '1111110073',
    districtId: '1111110',
    name: 'Mancang',
  },
  {
    id: '1111110074',
    districtId: '1111110',
    name: 'Leubok Ab',
  },
  {
    id: '1111110075',
    districtId: '1111110',
    name: 'Trieng Pantang',
  },
  {
    id: '1111110076',
    districtId: '1111110',
    name: 'Meunasah Arongan Ab',
  },
  {
    id: '1111120001',
    districtId: '1111120',
    name: 'Leupon Siren',
  },
  {
    id: '1111120002',
    districtId: '1111120',
    name: 'Ulee Buket',
  },
  {
    id: '1111120003',
    districtId: '1111120',
    name: 'Blang Pie',
  },
  {
    id: '1111120004',
    districtId: '1111120',
    name: 'Blang Trieng',
  },
  {
    id: '1111120008',
    districtId: '1111120',
    name: 'Cot Barat',
  },
  {
    id: '1111120009',
    districtId: '1111120',
    name: 'Plu Pakam',
  },
  {
    id: '1111120010',
    districtId: '1111120',
    name: 'Tumpok Aceh',
  },
  {
    id: '1111120011',
    districtId: '1111120',
    name: 'Cot Dah',
  },
  {
    id: '1111120012',
    districtId: '1111120',
    name: 'Alue Sijuek',
  },
  {
    id: '1111120015',
    districtId: '1111120',
    name: 'Hagu',
  },
  {
    id: '1111120016',
    districtId: '1111120',
    name: 'Bayi',
  },
  {
    id: '1111120017',
    districtId: '1111120',
    name: 'Leu Hong',
  },
  {
    id: '1111120018',
    districtId: '1111120',
    name: 'Punti Seuleumak Barat',
  },
  {
    id: '1111120019',
    districtId: '1111120',
    name: 'Serba Jaman Tunong',
  },
  {
    id: '1111120020',
    districtId: '1111120',
    name: 'Alue Gampong',
  },
  {
    id: '1111120023',
    districtId: '1111120',
    name: 'Matang Baloy',
  },
  {
    id: '1111120024',
    districtId: '1111120',
    name: 'Teupin Me',
  },
  {
    id: '1111120025',
    districtId: '1111120',
    name: 'Blang',
  },
  {
    id: '1111120026',
    districtId: '1111120',
    name: 'Matang Mane',
  },
  {
    id: '1111120030',
    districtId: '1111120',
    name: 'Tanjong Mesjid',
  },
  {
    id: '1111120031',
    districtId: '1111120',
    name: 'Keutapang',
  },
  {
    id: '1111120032',
    districtId: '1111120',
    name: 'Ceubrek',
  },
  {
    id: '1111120033',
    districtId: '1111120',
    name: 'Manyang Seuleumak Barat',
  },
  {
    id: '1111120034',
    districtId: '1111120',
    name: 'Trieng',
  },
  {
    id: '1111120035',
    districtId: '1111120',
    name: 'Serba Jaman Baroh',
  },
  {
    id: '1111120036',
    districtId: '1111120',
    name: 'Ujong Baroh Sb',
  },
  {
    id: '1111120044',
    districtId: '1111120',
    name: 'Blang Jruen',
  },
  {
    id: '1111120045',
    districtId: '1111120',
    name: 'Rayeuk Kuta',
  },
  {
    id: '1111120046',
    districtId: '1111120',
    name: 'Paya',
  },
  {
    id: '1111120047',
    districtId: '1111120',
    name: 'Rangkaya',
  },
  {
    id: '1111120048',
    districtId: '1111120',
    name: 'Rayeuk Meunye',
  },
  {
    id: '1111120049',
    districtId: '1111120',
    name: 'Keude Blang Jruen',
  },
  {
    id: '1111120050',
    districtId: '1111120',
    name: 'Ampeh',
  },
  {
    id: '1111120054',
    districtId: '1111120',
    name: 'Tutong',
  },
  {
    id: '1111120055',
    districtId: '1111120',
    name: 'Alue',
  },
  {
    id: '1111120056',
    districtId: '1111120',
    name: 'Teungoh Beureghang',
  },
  {
    id: '1111120057',
    districtId: '1111120',
    name: 'Jeumpa Beureghang',
  },
  {
    id: '1111120058',
    districtId: '1111120',
    name: 'Pante',
  },
  {
    id: '1111120059',
    districtId: '1111120',
    name: 'Tgk Dibale',
  },
  {
    id: '1111120060',
    districtId: '1111120',
    name: 'Serba Jaman',
  },
  {
    id: '1111120061',
    districtId: '1111120',
    name: 'Rayeuk Naleung',
  },
  {
    id: '1111120062',
    districtId: '1111120',
    name: 'Blang Bidok',
  },
  {
    id: '1111120063',
    districtId: '1111120',
    name: 'Punti Pulo Agam',
  },
  {
    id: '1111120064',
    districtId: '1111120',
    name: 'Teungoh Pulo Agam',
  },
  {
    id: '1111120065',
    districtId: '1111120',
    name: 'Rawa',
  },
  {
    id: '1111120066',
    districtId: '1111120',
    name: 'Matang Ben',
  },
  {
    id: '1111120067',
    districtId: '1111120',
    name: 'Ujong Baroh Beureghang',
  },
  {
    id: '1111120068',
    districtId: '1111120',
    name: 'Manyang Tunong',
  },
  {
    id: '1111120069',
    districtId: '1111120',
    name: 'Alue Pangkat',
  },
  {
    id: '1111120070',
    districtId: '1111120',
    name: 'Pulo Blang',
  },
  {
    id: '1111120071',
    districtId: '1111120',
    name: 'Matang Ceubrek',
  },
  {
    id: '1111120072',
    districtId: '1111120',
    name: 'Hueng',
  },
  {
    id: '1111120073',
    districtId: '1111120',
    name: 'Deng',
  },
  {
    id: '1111120074',
    districtId: '1111120',
    name: 'Paya Beurandang',
  },
  {
    id: '1111120075',
    districtId: '1111120',
    name: 'Pulo U',
  },
  {
    id: '1111120076',
    districtId: '1111120',
    name: 'Alue Keujruen',
  },
  {
    id: '1111120077',
    districtId: '1111120',
    name: 'Buket Makarti',
  },
  {
    id: '1111121001',
    districtId: '1111121',
    name: 'Bumban',
  },
  {
    id: '1111121002',
    districtId: '1111121',
    name: 'Alue Ngom',
  },
  {
    id: '1111121003',
    districtId: '1111121',
    name: 'Alue Panah',
  },
  {
    id: '1111121004',
    districtId: '1111121',
    name: 'Alue Ie Mirah',
  },
  {
    id: '1111121005',
    districtId: '1111121',
    name: 'Maddi',
  },
  {
    id: '1111121006',
    districtId: '1111121',
    name: 'Tanjong Putoh',
  },
  {
    id: '1111121007',
    districtId: '1111121',
    name: 'Seulunyok',
  },
  {
    id: '1111121008',
    districtId: '1111121',
    name: 'Ranto',
  },
  {
    id: '1111121009',
    districtId: '1111121',
    name: 'Menye Lhee',
  },
  {
    id: '1111121010',
    districtId: '1111121',
    name: 'Keulilee',
  },
  {
    id: '1111121011',
    districtId: '1111121',
    name: 'Paya Teureubang',
  },
  {
    id: '1111121012',
    districtId: '1111121',
    name: 'Sumbok Rayek',
  },
  {
    id: '1111121013',
    districtId: '1111121',
    name: 'Mamplam',
  },
  {
    id: '1111121014',
    districtId: '1111121',
    name: 'Keh',
  },
  {
    id: '1111121015',
    districtId: '1111121',
    name: 'Dayah Nibong',
  },
  {
    id: '1111121016',
    districtId: '1111121',
    name: 'Teupin Jok',
  },
  {
    id: '1111121017',
    districtId: '1111121',
    name: 'Keupok Nibong',
  },
  {
    id: '1111121018',
    districtId: '1111121',
    name: 'Keude Nibong',
  },
  {
    id: '1111121019',
    districtId: '1111121',
    name: 'Nibong Wakeuh',
  },
  {
    id: '1111121020',
    districtId: '1111121',
    name: 'Nibong Baroh',
  },
  {
    id: '1111130001',
    districtId: '1111130',
    name: 'Kitou',
  },
  {
    id: '1111130002',
    districtId: '1111130',
    name: 'Paya Terbang',
  },
  {
    id: '1111130003',
    districtId: '1111130',
    name: 'Tanjong Mesjid',
  },
  {
    id: '1111130004',
    districtId: '1111130',
    name: 'Tanjong Awe',
  },
  {
    id: '1111130005',
    districtId: '1111130',
    name: 'Tanjong Rengkam',
  },
  {
    id: '1111130006',
    districtId: '1111130',
    name: 'Tanjong Hagu',
  },
  {
    id: '1111130007',
    districtId: '1111130',
    name: 'Madan',
  },
  {
    id: '1111130008',
    districtId: '1111130',
    name: 'Tanjong Baroh',
  },
  {
    id: '1111130009',
    districtId: '1111130',
    name: 'Gampong Baro',
  },
  {
    id: '1111130010',
    districtId: '1111130',
    name: 'Tanjong Kleng',
  },
  {
    id: '1111130011',
    districtId: '1111130',
    name: 'Krueng Baro Lgh',
  },
  {
    id: '1111130012',
    districtId: '1111130',
    name: 'Teupin Beulangan',
  },
  {
    id: '1111130013',
    districtId: '1111130',
    name: 'Teupin Ara',
  },
  {
    id: '1111130014',
    districtId: '1111130',
    name: 'Pusong',
  },
  {
    id: '1111130015',
    districtId: '1111130',
    name: 'Mancang',
  },
  {
    id: '1111130016',
    districtId: '1111130',
    name: 'Blang Kabu',
  },
  {
    id: '1111130017',
    districtId: '1111130',
    name: 'Keude Geudong',
  },
  {
    id: '1111130018',
    districtId: '1111130',
    name: 'Blang Peuria',
  },
  {
    id: '1111130019',
    districtId: '1111130',
    name: 'Meunasah Asan',
  },
  {
    id: '1111130020',
    districtId: '1111130',
    name: 'Murong',
  },
  {
    id: '1111130021',
    districtId: '1111130',
    name: 'Pie',
  },
  {
    id: '1111130022',
    districtId: '1111130',
    name: 'Krueng Mate',
  },
  {
    id: '1111130023',
    districtId: '1111130',
    name: 'Beuringen',
  },
  {
    id: '1111130024',
    districtId: '1111130',
    name: 'Kuta Krueng',
  },
  {
    id: '1111130025',
    districtId: '1111130',
    name: 'Kuta Glumpang',
  },
  {
    id: '1111130026',
    districtId: '1111130',
    name: 'Meucat',
  },
  {
    id: '1111130027',
    districtId: '1111130',
    name: 'Krueng Baro Blang Me',
  },
  {
    id: '1111130028',
    districtId: '1111130',
    name: 'Ujong',
  },
  {
    id: '1111130029',
    districtId: '1111130',
    name: 'Mesjid',
  },
  {
    id: '1111130030',
    districtId: '1111130',
    name: 'Teungoh',
  },
  {
    id: '1111130031',
    districtId: '1111130',
    name: 'Puuk',
  },
  {
    id: '1111130032',
    districtId: '1111130',
    name: 'Pulo',
  },
  {
    id: '1111130033',
    districtId: '1111130',
    name: 'Laga Baro',
  },
  {
    id: '1111130034',
    districtId: '1111130',
    name: 'Matang Tunong',
  },
  {
    id: '1111130035',
    districtId: '1111130',
    name: 'Keude Blang Me',
  },
  {
    id: '1111130036',
    districtId: '1111130',
    name: 'Matang Puntong',
  },
  {
    id: '1111130037',
    districtId: '1111130',
    name: 'Lancang',
  },
  {
    id: '1111130038',
    districtId: '1111130',
    name: 'Matang Ulim',
  },
  {
    id: '1111130039',
    districtId: '1111130',
    name: 'Sawang',
  },
  {
    id: '1111130040',
    districtId: '1111130',
    name: 'Blang Nibong',
  },
  {
    id: '1111140001',
    districtId: '1111140',
    name: 'Tanjong Krueng Pase',
  },
  {
    id: '1111140002',
    districtId: '1111140',
    name: 'Matang Munye',
  },
  {
    id: '1111140003',
    districtId: '1111140',
    name: 'Blang',
  },
  {
    id: '1111140004',
    districtId: '1111140',
    name: 'Glok Aron',
  },
  {
    id: '1111140005',
    districtId: '1111140',
    name: 'Mee Aron',
  },
  {
    id: '1111140006',
    districtId: '1111140',
    name: 'Meuria Aron',
  },
  {
    id: '1111140007',
    districtId: '1111140',
    name: 'U Blang Asan',
  },
  {
    id: '1111140008',
    districtId: '1111140',
    name: 'Kanot',
  },
  {
    id: '1111140009',
    districtId: '1111140',
    name: 'Dayah Aron',
  },
  {
    id: '1111140010',
    districtId: '1111140',
    name: 'Moncrang',
  },
  {
    id: '1111140011',
    districtId: '1111140',
    name: 'Keude Aron',
  },
  {
    id: '1111140012',
    districtId: '1111140',
    name: 'Teungoh',
  },
  {
    id: '1111140013',
    districtId: '1111140',
    name: 'Kumbang',
  },
  {
    id: '1111140014',
    districtId: '1111140',
    name: 'Cibrek Tunong',
  },
  {
    id: '1111140015',
    districtId: '1111140',
    name: 'Meucat',
  },
  {
    id: '1111140016',
    districtId: '1111140',
    name: 'Dayah Teungku',
  },
  {
    id: '1111140017',
    districtId: '1111140',
    name: 'Calong',
  },
  {
    id: '1111140018',
    districtId: '1111140',
    name: 'Manyang Baroh',
  },
  {
    id: '1111140019',
    districtId: '1111140',
    name: 'Alue Gunto',
  },
  {
    id: '1111140020',
    districtId: '1111140',
    name: 'Peurupok',
  },
  {
    id: '1111140021',
    districtId: '1111140',
    name: 'Pulo',
  },
  {
    id: '1111140022',
    districtId: '1111140',
    name: 'Tanjong Mulieng',
  },
  {
    id: '1111140023',
    districtId: '1111140',
    name: 'Cibrek Baroh',
  },
  {
    id: '1111140024',
    districtId: '1111140',
    name: 'Mesjid',
  },
  {
    id: '1111140025',
    districtId: '1111140',
    name: 'Pante',
  },
  {
    id: '1111140026',
    districtId: '1111140',
    name: 'Keutapang',
  },
  {
    id: '1111140027',
    districtId: '1111140',
    name: 'Keude Teupin Punti',
  },
  {
    id: '1111140028',
    districtId: '1111140',
    name: 'Awe',
  },
  {
    id: '1111140029',
    districtId: '1111140',
    name: 'Hagu',
  },
  {
    id: '1111140030',
    districtId: '1111140',
    name: 'Ara',
  },
  {
    id: '1111140031',
    districtId: '1111140',
    name: 'Mampree',
  },
  {
    id: '1111140032',
    districtId: '1111140',
    name: 'Ampeh',
  },
  {
    id: '1111140033',
    districtId: '1111140',
    name: 'Dayah Meuria',
  },
  {
    id: '1111140034',
    districtId: '1111140',
    name: 'Kulam',
  },
  {
    id: '1111150001',
    districtId: '1111150',
    name: 'Alue',
  },
  {
    id: '1111150002',
    districtId: '1111150',
    name: 'Keude Matang Panyang',
  },
  {
    id: '1111150003',
    districtId: '1111150',
    name: 'Blang',
  },
  {
    id: '1111150004',
    districtId: '1111150',
    name: 'Gampong Pande',
  },
  {
    id: '1111150005',
    districtId: '1111150',
    name: 'Paloh',
  },
  {
    id: '1111150006',
    districtId: '1111150',
    name: 'Prie',
  },
  {
    id: '1111150007',
    districtId: '1111150',
    name: 'Me Merbo',
  },
  {
    id: '1111150008',
    districtId: '1111150',
    name: 'Ulee Tanoh',
  },
  {
    id: '1111150009',
    districtId: '1111150',
    name: 'Matang Ranub Laseh',
  },
  {
    id: '1111150015',
    districtId: '1111150',
    name: 'Keutapang',
  },
  {
    id: '1111150016',
    districtId: '1111150',
    name: 'Kumbang',
  },
  {
    id: '1111150017',
    districtId: '1111150',
    name: 'Me Matang Panyang',
  },
  {
    id: '1111150018',
    districtId: '1111150',
    name: 'Cangguek',
  },
  {
    id: '1111150019',
    districtId: '1111150',
    name: 'Keude Jrat Manyang',
  },
  {
    id: '1111150020',
    districtId: '1111150',
    name: 'Teupin Gapeuh',
  },
  {
    id: '1111150021',
    districtId: '1111150',
    name: 'Cibrek',
  },
  {
    id: '1111150024',
    districtId: '1111150',
    name: 'Matang Janeng',
  },
  {
    id: '1111150029',
    districtId: '1111150',
    name: 'Kuala Keureutoe Barat',
  },
  {
    id: '1111151001',
    districtId: '1111151',
    name: 'Keureutoau',
  },
  {
    id: '1111151002',
    districtId: '1111151',
    name: 'Lueng Baro',
  },
  {
    id: '1111151003',
    districtId: '1111151',
    name: 'Merbo Lama',
  },
  {
    id: '1111151004',
    districtId: '1111151',
    name: 'Merbo Jurong',
  },
  {
    id: '1111151005',
    districtId: '1111151',
    name: 'Tanjung Dama',
  },
  {
    id: '1111151006',
    districtId: '1111151',
    name: 'Geulanggang Baro',
  },
  {
    id: '1111151007',
    districtId: '1111151',
    name: 'Matang Tunong',
  },
  {
    id: '1111151008',
    districtId: '1111151',
    name: 'Matang Baroh',
  },
  {
    id: '1111151009',
    districtId: '1111151',
    name: 'Keude Lapang',
  },
  {
    id: '1111151010',
    districtId: '1111151',
    name: 'Kuala Cangkoi',
  },
  {
    id: '1111151011',
    districtId: '1111151',
    name: 'Kuala Kereutou',
  },
  {
    id: '1111160001',
    districtId: '1111160',
    name: 'Teupin Banja',
  },
  {
    id: '1111160002',
    districtId: '1111160',
    name: 'Panigah',
  },
  {
    id: '1111160003',
    districtId: '1111160',
    name: 'Paloh Awe',
  },
  {
    id: '1111160004',
    districtId: '1111160',
    name: 'Reuleut Timur',
  },
  {
    id: '1111160005',
    districtId: '1111160',
    name: 'Reuleut Barat',
  },
  {
    id: '1111160006',
    districtId: '1111160',
    name: 'Pinto Makmur',
  },
  {
    id: '1111160007',
    districtId: '1111160',
    name: 'Tumpok Beurandang',
  },
  {
    id: '1111160008',
    districtId: '1111160',
    name: 'Paloh Raya',
  },
  {
    id: '1111160009',
    districtId: '1111160',
    name: 'Meunasah Pinto',
  },
  {
    id: '1111160010',
    districtId: '1111160',
    name: 'Kuala Dua',
  },
  {
    id: '1111160011',
    districtId: '1111160',
    name: 'Keude Mane',
  },
  {
    id: '1111160012',
    districtId: '1111160',
    name: 'Mane Tunong',
  },
  {
    id: '1111160013',
    districtId: '1111160',
    name: 'Pante Gurah',
  },
  {
    id: '1111160014',
    districtId: '1111160',
    name: 'Kambam',
  },
  {
    id: '1111160015',
    districtId: '1111160',
    name: 'Keude Bungkaih',
  },
  {
    id: '1111160016',
    districtId: '1111160',
    name: 'Ulee Madon',
  },
  {
    id: '1111160017',
    districtId: '1111160',
    name: 'Meunasah Aron',
  },
  {
    id: '1111160018',
    districtId: '1111160',
    name: 'Cot Trueng',
  },
  {
    id: '1111160019',
    districtId: '1111160',
    name: 'Dakuta',
  },
  {
    id: '1111160020',
    districtId: '1111160',
    name: 'Meunasah Drang',
  },
  {
    id: '1111160021',
    districtId: '1111160',
    name: 'Meunasah Baro',
  },
  {
    id: '1111160022',
    districtId: '1111160',
    name: 'Meunasah Lhok',
  },
  {
    id: '1111160023',
    districtId: '1111160',
    name: 'Cot Seurani',
  },
  {
    id: '1111160024',
    districtId: '1111160',
    name: 'Tanoh Anoue',
  },
  {
    id: '1111170001',
    districtId: '1111170',
    name: 'Paloh Igeuh',
  },
  {
    id: '1111170002',
    districtId: '1111170',
    name: 'Paloh Gadeng',
  },
  {
    id: '1111170003',
    districtId: '1111170',
    name: 'Tambon Tunong',
  },
  {
    id: '1111170004',
    districtId: '1111170',
    name: 'Tambon Baroh',
  },
  {
    id: '1111170005',
    districtId: '1111170',
    name: 'Paloh Lada',
  },
  {
    id: '1111170006',
    districtId: '1111170',
    name: 'Pulo Rungkom',
  },
  {
    id: '1111170007',
    districtId: '1111170',
    name: 'Ulee Pulo',
  },
  {
    id: '1111170008',
    districtId: '1111170',
    name: 'Ulee Reuleung',
  },
  {
    id: '1111170009',
    districtId: '1111170',
    name: 'Lancang Barat',
  },
  {
    id: '1111170010',
    districtId: '1111170',
    name: 'Geulumpang Sulu Barat',
  },
  {
    id: '1111170011',
    districtId: '1111170',
    name: 'Geulumpang Sulu Timur',
  },
  {
    id: '1111170012',
    districtId: '1111170',
    name: 'Uteun Geulinggang',
  },
  {
    id: '1111170013',
    districtId: '1111170',
    name: 'Keude Krueng Geukueh',
  },
  {
    id: '1111170014',
    districtId: '1111170',
    name: 'Bangka Jaya',
  },
  {
    id: '1111170015',
    districtId: '1111170',
    name: 'Bluka Teubai',
  },
  {
    id: '1112010015',
    districtId: '1112010',
    name: 'Tengah',
  },
  {
    id: '1112010016',
    districtId: '1112010',
    name: 'Padang',
  },
  {
    id: '1112010017',
    districtId: '1112010',
    name: 'Kedai',
  },
  {
    id: '1112010018',
    districtId: '1112010',
    name: 'Paya',
  },
  {
    id: '1112010019',
    districtId: '1112010',
    name: 'Seunalop',
  },
  {
    id: '1112010022',
    districtId: '1112010',
    name: 'Ladang Panah',
  },
  {
    id: '1112010023',
    districtId: '1112010',
    name: 'Pusu',
  },
  {
    id: '1112010024',
    districtId: '1112010',
    name: 'Ujung Padang',
  },
  {
    id: '1112010025',
    districtId: '1112010',
    name: 'Lhung Baro',
  },
  {
    id: '1112010026',
    districtId: '1112010',
    name: 'Panton Makmur',
  },
  {
    id: '1112010027',
    districtId: '1112010',
    name: 'Pante Raja',
  },
  {
    id: '1112010028',
    districtId: '1112010',
    name: 'Lhok Pawoh',
  },
  {
    id: '1112010029',
    districtId: '1112010',
    name: 'Pante Pirak',
  },
  {
    id: '1112010030',
    districtId: '1112010',
    name: 'Sejahtera',
  },
  {
    id: '1112010031',
    districtId: '1112010',
    name: 'Blang Manggeng',
  },
  {
    id: '1112010032',
    districtId: '1112010',
    name: 'Tokoh',
  },
  {
    id: '1112010033',
    districtId: '1112010',
    name: 'Lhok Puntoy',
  },
  {
    id: '1112010034',
    districtId: '1112010',
    name: 'Pante Cermin',
  },
  {
    id: '1112011001',
    districtId: '1112011',
    name: 'Ujung Tanah',
  },
  {
    id: '1112011002',
    districtId: '1112011',
    name: 'Kuta Paya',
  },
  {
    id: '1112011003',
    districtId: '1112011',
    name: 'Geulanggang Batee',
  },
  {
    id: '1112011004',
    districtId: '1112011',
    name: 'Meunasah Tengah',
  },
  {
    id: '1112011005',
    districtId: '1112011',
    name: 'Meunasah Sukon',
  },
  {
    id: '1112011006',
    districtId: '1112011',
    name: 'Cot Bak-U',
  },
  {
    id: '1112011007',
    districtId: '1112011',
    name: 'Meurandeh',
  },
  {
    id: '1112011008',
    districtId: '1112011',
    name: 'Padang Kelele',
  },
  {
    id: '1112011009',
    districtId: '1112011',
    name: 'Ladang Tuha I',
  },
  {
    id: '1112011010',
    districtId: '1112011',
    name: 'Ladang Tuha II',
  },
  {
    id: '1112011011',
    districtId: '1112011',
    name: 'Alue Rambot',
  },
  {
    id: '1112011016',
    districtId: '1112011',
    name: 'Suka Damai',
  },
  {
    id: '1112011017',
    districtId: '1112011',
    name: 'Tokoh II',
  },
  {
    id: '1112011018',
    districtId: '1112011',
    name: 'Kaye Aceh',
  },
  {
    id: '1112020001',
    districtId: '1112020',
    name: 'Padang Bakjok',
  },
  {
    id: '1112020002',
    districtId: '1112020',
    name: 'Suak Nibong',
  },
  {
    id: '1112020003',
    districtId: '1112020',
    name: 'Drien Kipah',
  },
  {
    id: '1112020004',
    districtId: '1112020',
    name: 'Bineh Krueng',
  },
  {
    id: '1112020005',
    districtId: '1112020',
    name: 'Drien Jalo',
  },
  {
    id: '1112020006',
    districtId: '1112020',
    name: 'Padang Kawa',
  },
  {
    id: '1112020007',
    districtId: '1112020',
    name: 'Mesjid',
  },
  {
    id: '1112020008',
    districtId: '1112020',
    name: 'Adan',
  },
  {
    id: '1112020009',
    districtId: '1112020',
    name: 'Pante Geulumpang',
  },
  {
    id: '1112020010',
    districtId: '1112020',
    name: 'Gunung Cut',
  },
  {
    id: '1112020011',
    districtId: '1112020',
    name: 'Padang Bak Jeumpa',
  },
  {
    id: '1112020012',
    districtId: '1112020',
    name: 'Blang Padang',
  },
  {
    id: '1112020013',
    districtId: '1112020',
    name: 'Suak Labu',
  },
  {
    id: '1112020014',
    districtId: '1112020',
    name: 'Kuta Bak Drin',
  },
  {
    id: '1112020015',
    districtId: '1112020',
    name: 'Ie Lhop',
  },
  {
    id: '1112021002',
    districtId: '1112021',
    name: 'Tangan Tangan Cut',
  },
  {
    id: '1112021003',
    districtId: '1112021',
    name: 'Lhang',
  },
  {
    id: '1112021004',
    districtId: '1112021',
    name: 'Ujung Tanah',
  },
  {
    id: '1112021005',
    districtId: '1112021',
    name: 'Rambong',
  },
  {
    id: '1112021006',
    districtId: '1112021',
    name: 'Pisang',
  },
  {
    id: '1112021007',
    districtId: '1112021',
    name: 'Alue Dama',
  },
  {
    id: '1112021008',
    districtId: '1112021',
    name: 'Mon Mameh',
  },
  {
    id: '1112021009',
    districtId: '1112021',
    name: 'Cinta Makmur',
  },
  {
    id: '1112021010',
    districtId: '1112021',
    name: 'Kuta Murni',
  },
  {
    id: '1112030002',
    districtId: '1112030',
    name: 'Cot Jeurat',
  },
  {
    id: '1112030003',
    districtId: '1112030',
    name: 'Kuta Bahagia',
  },
  {
    id: '1112030004',
    districtId: '1112030',
    name: 'Kedai Siblah',
  },
  {
    id: '1112030005',
    districtId: '1112030',
    name: 'Pasar Blang Pidie',
  },
  {
    id: '1112030006',
    districtId: '1112030',
    name: 'Meudang Ara',
  },
  {
    id: '1112030007',
    districtId: '1112030',
    name: 'Geulumpang Payong',
  },
  {
    id: '1112030008',
    districtId: '1112030',
    name: 'Kuta Tinggi',
  },
  {
    id: '1112030009',
    districtId: '1112030',
    name: 'Kedai Paya',
  },
  {
    id: '1112030010',
    districtId: '1112030',
    name: 'Baharu',
  },
  {
    id: '1112030011',
    districtId: '1112030',
    name: 'Lamkuta',
  },
  {
    id: '1112030012',
    districtId: '1112030',
    name: 'Alum Anggota',
  },
  {
    id: '1112030013',
    districtId: '1112030',
    name: 'Mata Ie',
  },
  {
    id: '1112030014',
    districtId: '1112030',
    name: 'Panton Raya',
  },
  {
    id: '1112030015',
    districtId: '1112030',
    name: 'Seunaloh',
  },
  {
    id: '1112030016',
    districtId: '1112030',
    name: 'Lhung Tarok',
  },
  {
    id: '1112030018',
    districtId: '1112030',
    name: 'Lhung Asan',
  },
  {
    id: '1112030019',
    districtId: '1112030',
    name: 'Guhang',
  },
  {
    id: '1112030027',
    districtId: '1112030',
    name: 'Kuta Tuha',
  },
  {
    id: '1112030029',
    districtId: '1112030',
    name: 'Gudang',
  },
  {
    id: '1112030030',
    districtId: '1112030',
    name: 'Babah Lhung',
  },
  {
    id: '1112031001',
    districtId: '1112031',
    name: 'Padang Geulumpang',
  },
  {
    id: '1112031002',
    districtId: '1112031',
    name: 'Aso Nanggro',
  },
  {
    id: '1112031003',
    districtId: '1112031',
    name: 'Ladang Neubok',
  },
  {
    id: '1112031004',
    districtId: '1112031',
    name: 'Iku Lhung',
  },
  {
    id: '1112031005',
    districtId: '1112031',
    name: 'Cot Mane',
  },
  {
    id: '1112031006',
    districtId: '1112031',
    name: 'Kuta Jeumpa',
  },
  {
    id: '1112031007',
    districtId: '1112031',
    name: 'Alue Sungai Pinang',
  },
  {
    id: '1112031008',
    districtId: '1112031',
    name: 'Alue Rambot',
  },
  {
    id: '1112031009',
    districtId: '1112031',
    name: 'Baru',
  },
  {
    id: '1112031010',
    districtId: '1112031',
    name: 'Kuta Makmur',
  },
  {
    id: '1112031011',
    districtId: '1112031',
    name: 'Alue Selaseh',
  },
  {
    id: '1112031012',
    districtId: '1112031',
    name: 'Jeumpa Barat',
  },
  {
    id: '1112040001',
    districtId: '1112040',
    name: 'Kedai Susoh',
  },
  {
    id: '1112040002',
    districtId: '1112040',
    name: 'Panjang Baru',
  },
  {
    id: '1112040003',
    districtId: '1112040',
    name: 'Kedai Palak Kerambil',
  },
  {
    id: '1112040004',
    districtId: '1112040',
    name: 'Ladang',
  },
  {
    id: '1112040005',
    districtId: '1112040',
    name: 'Padang Panjang',
  },
  {
    id: '1112040006',
    districtId: '1112040',
    name: 'Rubek Meupayong',
  },
  {
    id: '1112040007',
    districtId: '1112040',
    name: 'Cot Mancang',
  },
  {
    id: '1112040008',
    districtId: '1112040',
    name: 'Lampoh Drien',
  },
  {
    id: '1112040009',
    districtId: '1112040',
    name: 'Meunasah',
  },
  {
    id: '1112040010',
    districtId: '1112040',
    name: 'Blang Dalam',
  },
  {
    id: '1112040011',
    districtId: '1112040',
    name: 'Palak Hulu',
  },
  {
    id: '1112040012',
    districtId: '1112040',
    name: 'Palak Hilir',
  },
  {
    id: '1112040013',
    districtId: '1112040',
    name: 'Rumah Dua Lapis',
  },
  {
    id: '1112040014',
    districtId: '1112040',
    name: 'Durian Jangek',
  },
  {
    id: '1112040015',
    districtId: '1112040',
    name: 'Baharu',
  },
  {
    id: '1112040016',
    districtId: '1112040',
    name: 'Pinang',
  },
  {
    id: '1112040017',
    districtId: '1112040',
    name: 'Rumah Panjang',
  },
  {
    id: '1112040018',
    districtId: '1112040',
    name: 'Padang Baru',
  },
  {
    id: '1112040019',
    districtId: '1112040',
    name: 'Pulau Kayu',
  },
  {
    id: '1112040020',
    districtId: '1112040',
    name: 'Ujung Padang',
  },
  {
    id: '1112040021',
    districtId: '1112040',
    name: 'Pawoh',
  },
  {
    id: '1112040022',
    districtId: '1112040',
    name: 'Barat',
  },
  {
    id: '1112040023',
    districtId: '1112040',
    name: 'Durian Rampak',
  },
  {
    id: '1112040024',
    districtId: '1112040',
    name: 'Pantai Perak',
  },
  {
    id: '1112040025',
    districtId: '1112040',
    name: 'Padang Hilir',
  },
  {
    id: '1112040026',
    districtId: '1112040',
    name: 'Gadang',
  },
  {
    id: '1112040027',
    districtId: '1112040',
    name: 'Tangah',
  },
  {
    id: '1112040028',
    districtId: '1112040',
    name: 'Kepala Bandar',
  },
  {
    id: '1112040029',
    districtId: '1112040',
    name: 'Geulima Jaya',
  },
  {
    id: '1112050001',
    districtId: '1112050',
    name: 'Lama Tuha',
  },
  {
    id: '1112050002',
    districtId: '1112050',
    name: 'Keudee Baro',
  },
  {
    id: '1112050003',
    districtId: '1112050',
    name: 'Ie Mameh',
  },
  {
    id: '1112050004',
    districtId: '1112050',
    name: 'Alue Pisang',
  },
  {
    id: '1112050005',
    districtId: '1112050',
    name: 'Krueng Batee',
  },
  {
    id: '1112050006',
    districtId: '1112050',
    name: 'Lhok Gajah',
  },
  {
    id: '1112050007',
    districtId: '1112050',
    name: 'Muka Blang',
  },
  {
    id: '1112050008',
    districtId: '1112050',
    name: 'Padang Sikabu',
  },
  {
    id: '1112050009',
    districtId: '1112050',
    name: 'Lhung Gelumpang',
  },
  {
    id: '1112050010',
    districtId: '1112050',
    name: 'Alue Padee',
  },
  {
    id: '1112050011',
    districtId: '1112050',
    name: 'Blang Panyang',
  },
  {
    id: '1112050012',
    districtId: '1112050',
    name: 'Kampung Tengah',
  },
  {
    id: '1112050013',
    districtId: '1112050',
    name: 'Blang Makmur',
  },
  {
    id: '1112050014',
    districtId: '1112050',
    name: 'Kuala Terubu',
  },
  {
    id: '1112050015',
    districtId: '1112050',
    name: 'Pasar Kuta Bahagia',
  },
  {
    id: '1112050016',
    districtId: '1112050',
    name: 'Panto Cut',
  },
  {
    id: '1112050017',
    districtId: '1112050',
    name: 'Kota Bahagia',
  },
  {
    id: '1112050018',
    districtId: '1112050',
    name: 'Gelanggang Gajah',
  },
  {
    id: '1112050019',
    districtId: '1112050',
    name: 'Krueng Panto',
  },
  {
    id: '1112050020',
    districtId: '1112050',
    name: 'Drien Beurumbang',
  },
  {
    id: '1112050021',
    districtId: '1112050',
    name: 'Rumoh Panyang',
  },
  {
    id: '1112060001',
    districtId: '1112060',
    name: 'Gunung Samarinda',
  },
  {
    id: '1112060002',
    districtId: '1112060',
    name: 'Ie Merah',
  },
  {
    id: '1112060003',
    districtId: '1112060',
    name: 'Pantee Rakyat',
  },
  {
    id: '1112060004',
    districtId: '1112060',
    name: 'Pantee Cermin',
  },
  {
    id: '1112060005',
    districtId: '1112060',
    name: 'Alue Jerjak',
  },
  {
    id: '1112060006',
    districtId: '1112060',
    name: 'Blang Dalam',
  },
  {
    id: '1112060007',
    districtId: '1112060',
    name: 'Alue Peunawa',
  },
  {
    id: '1112060008',
    districtId: '1112060',
    name: 'Simpang Gadeng',
  },
  {
    id: '1112060009',
    districtId: '1112060',
    name: 'Teladan Jaya',
  },
  {
    id: '1112060010',
    districtId: '1112060',
    name: 'Blang Raja',
  },
  {
    id: '1112060011',
    districtId: '1112060',
    name: 'Rukoen Damee',
  },
  {
    id: '1112060012',
    districtId: '1112060',
    name: 'Lhok Gayo',
  },
  {
    id: '1112060013',
    districtId: '1112060',
    name: 'Alue Dawah',
  },
  {
    id: '1112060014',
    districtId: '1112060',
    name: 'Cot Seumantok',
  },
  {
    id: '1113010001',
    districtId: '1113010',
    name: 'Bener',
  },
  {
    id: '1113010003',
    districtId: '1113010',
    name: 'Rikit Dekat',
  },
  {
    id: '1113010004',
    districtId: '1113010',
    name: 'Ulon Tanoh',
  },
  {
    id: '1113010005',
    districtId: '1113010',
    name: 'Rema',
  },
  {
    id: '1113010006',
    districtId: '1113010',
    name: 'Tampeng',
  },
  {
    id: '1113010007',
    districtId: '1113010',
    name: 'Beranang',
  },
  {
    id: '1113010008',
    districtId: '1113010',
    name: 'Kuta Ujung',
  },
  {
    id: '1113010014',
    districtId: '1113010',
    name: 'Cike',
  },
  {
    id: '1113010015',
    districtId: '1113010',
    name: 'Rema Baru',
  },
  {
    id: '1113010016',
    districtId: '1113010',
    name: 'Kerukunan Kuta Panjang',
  },
  {
    id: '1113010017',
    districtId: '1113010',
    name: 'Tampeng Musara',
  },
  {
    id: '1113010018',
    districtId: '1113010',
    name: 'Kong Paluh',
  },
  {
    id: '1113011001',
    districtId: '1113011',
    name: 'Penosan',
  },
  {
    id: '1113011002',
    districtId: '1113011',
    name: 'Penosan Sepakat',
  },
  {
    id: '1113011003',
    districtId: '1113011',
    name: 'Gegarang',
  },
  {
    id: '1113011004',
    districtId: '1113011',
    name: 'Peparik Gaib',
  },
  {
    id: '1113011005',
    districtId: '1113011',
    name: 'Tingkem',
  },
  {
    id: '1113011006',
    districtId: '1113011',
    name: 'Sekuelen',
  },
  {
    id: '1113011007',
    districtId: '1113011',
    name: 'Akul',
  },
  {
    id: '1113011008',
    districtId: '1113011',
    name: 'Ketukah',
  },
  {
    id: '1113011009',
    districtId: '1113011',
    name: 'Blang Jerango',
  },
  {
    id: '1113011010',
    districtId: '1113011',
    name: 'Peparik Dekat',
  },
  {
    id: '1113020002',
    districtId: '1113020',
    name: 'Palok',
  },
  {
    id: '1113020003',
    districtId: '1113020',
    name: 'Penggalangan',
  },
  {
    id: '1113020004',
    districtId: '1113020',
    name: 'Lempuh',
  },
  {
    id: '1113020007',
    districtId: '1113020',
    name: 'Kute Sere',
  },
  {
    id: '1113020008',
    districtId: '1113020',
    name: 'Cempa',
  },
  {
    id: '1113020009',
    districtId: '1113020',
    name: 'Gele',
  },
  {
    id: '1113020010',
    districtId: '1113020',
    name: 'Penampaan',
  },
  {
    id: '1113020011',
    districtId: '1113020',
    name: 'Porang',
  },
  {
    id: '1113020013',
    districtId: '1113020',
    name: 'Kota Blangkejeren',
  },
  {
    id: '1113020014',
    districtId: '1113020',
    name: 'Kampung Jawa',
  },
  {
    id: '1113020015',
    districtId: '1113020',
    name: 'Kuta Lintang',
  },
  {
    id: '1113020016',
    districtId: '1113020',
    name: 'Leme',
  },
  {
    id: '1113020017',
    districtId: '1113020',
    name: 'Bukit',
  },
  {
    id: '1113020018',
    districtId: '1113020',
    name: 'Durin',
  },
  {
    id: '1113020019',
    districtId: '1113020',
    name: 'Bacang',
  },
  {
    id: '1113020025',
    districtId: '1113020',
    name: 'Agusen',
  },
  {
    id: '1113020026',
    districtId: '1113020',
    name: 'Penampaan Uken',
  },
  {
    id: '1113020028',
    districtId: '1113020',
    name: 'Bustanussalam',
  },
  {
    id: '1113020029',
    districtId: '1113020',
    name: 'Sepang',
  },
  {
    id: '1113020030',
    districtId: '1113020',
    name: 'Rak Lunung',
  },
  {
    id: '1113020031',
    districtId: '1113020',
    name: 'Sentang',
  },
  {
    id: '1113021001',
    districtId: '1113021',
    name: 'Marpunge',
  },
  {
    id: '1113021002',
    districtId: '1113021',
    name: 'Ramung Musara',
  },
  {
    id: '1113021003',
    districtId: '1113021',
    name: 'Meloak Sepakat',
  },
  {
    id: '1113021004',
    districtId: '1113021',
    name: 'Gumpang Pekan',
  },
  {
    id: '1113021005',
    districtId: '1113021',
    name: 'Pintu Gayo',
  },
  {
    id: '1113021006',
    districtId: '1113021',
    name: 'Jeret Onom',
  },
  {
    id: '1113021007',
    districtId: '1113021',
    name: 'Kute Lengat Sepakat',
  },
  {
    id: '1113021008',
    districtId: '1113021',
    name: 'Pungke Jaya',
  },
  {
    id: '1113021009',
    districtId: '1113021',
    name: 'Singah Mule',
  },
  {
    id: '1113021010',
    districtId: '1113021',
    name: 'Meloak Aih Ilang',
  },
  {
    id: '1113021011',
    districtId: '1113021',
    name: 'Uning Pune',
  },
  {
    id: '1113021012',
    districtId: '1113021',
    name: 'Putri Betung',
  },
  {
    id: '1113021013',
    districtId: '1113021',
    name: 'Gumpang Lempuh',
  },
  {
    id: '1113022001',
    districtId: '1113022',
    name: 'Sangir',
  },
  {
    id: '1113022002',
    districtId: '1113022',
    name: 'Panglima Linting',
  },
  {
    id: '1113022003',
    districtId: '1113022',
    name: 'Pangur',
  },
  {
    id: '1113022004',
    districtId: '1113022',
    name: 'Badak',
  },
  {
    id: '1113022005',
    districtId: '1113022',
    name: 'Blangtemung',
  },
  {
    id: '1113022006',
    districtId: '1113022',
    name: 'Kendawi',
  },
  {
    id: '1113022007',
    districtId: '1113022',
    name: 'Pepalan',
  },
  {
    id: '1113022008',
    districtId: '1113022',
    name: 'Uning Sepakat',
  },
  {
    id: '1113022009',
    districtId: '1113022',
    name: 'Uning Gelung',
  },
  {
    id: '1113022010',
    districtId: '1113022',
    name: 'Rerebe',
  },
  {
    id: '1113022011',
    districtId: '1113022',
    name: 'Rigeb',
  },
  {
    id: '1113023001',
    districtId: '1113023',
    name: 'Bener Baru',
  },
  {
    id: '1113023002',
    districtId: '1113023',
    name: 'Kute Bukit',
  },
  {
    id: '1113023003',
    districtId: '1113023',
    name: 'Blang Bengkik',
  },
  {
    id: '1113023004',
    districtId: '1113023',
    name: 'Gantung Geluni',
  },
  {
    id: '1113023005',
    districtId: '1113023',
    name: 'Kong Bur',
  },
  {
    id: '1113023006',
    districtId: '1113023',
    name: 'Ume Lah',
  },
  {
    id: '1113023007',
    districtId: '1113023',
    name: 'Akang Siwah',
  },
  {
    id: '1113023008',
    districtId: '1113023',
    name: 'Tetingi',
  },
  {
    id: '1113023009',
    districtId: '1113023',
    name: 'Cinta Maju',
  },
  {
    id: '1113023011',
    districtId: '1113023',
    name: 'Porang Ayu',
  },
  {
    id: '1113023012',
    districtId: '1113023',
    name: 'Anak Reje',
  },
  {
    id: '1113023013',
    districtId: '1113023',
    name: 'Rak Lintang',
  },
  {
    id: '1113030001',
    districtId: '1113030',
    name: 'Gajah',
  },
  {
    id: '1113030002',
    districtId: '1113030',
    name: 'Uring',
  },
  {
    id: '1113030003',
    districtId: '1113030',
    name: 'Pintu Rime',
  },
  {
    id: '1113030004',
    districtId: '1113030',
    name: 'Ekan',
  },
  {
    id: '1113030005',
    districtId: '1113030',
    name: 'Pertik',
  },
  {
    id: '1113030006',
    districtId: '1113030',
    name: 'Pining',
  },
  {
    id: '1113030007',
    districtId: '1113030',
    name: 'Pepalah',
  },
  {
    id: '1113030008',
    districtId: '1113030',
    name: 'Pasir Putih',
  },
  {
    id: '1113030009',
    districtId: '1113030',
    name: 'Lesten',
  },
  {
    id: '1113040004',
    districtId: '1113040',
    name: 'Kuning',
  },
  {
    id: '1113040005',
    districtId: '1113040',
    name: 'Padang Pasir',
  },
  {
    id: '1113040006',
    districtId: '1113040',
    name: 'Mangang',
  },
  {
    id: '1113040007',
    districtId: '1113040',
    name: 'Rikit Gaib',
  },
  {
    id: '1113040008',
    districtId: '1113040',
    name: 'Ampa Kolak',
  },
  {
    id: '1113040009',
    districtId: '1113040',
    name: 'Cane Uken',
  },
  {
    id: '1113040010',
    districtId: '1113040',
    name: 'Tungel',
  },
  {
    id: '1113040011',
    districtId: '1113040',
    name: 'Pinang Rugup',
  },
  {
    id: '1113040012',
    districtId: '1113040',
    name: 'Rempelam',
  },
  {
    id: '1113040013',
    districtId: '1113040',
    name: 'Cane Toa',
  },
  {
    id: '1113040014',
    districtId: '1113040',
    name: 'Tungel Baru',
  },
  {
    id: '1113040015',
    districtId: '1113040',
    name: 'Lukup Baru',
  },
  {
    id: '1113040016',
    districtId: '1113040',
    name: 'Penomon Jaya',
  },
  {
    id: '1113041001',
    districtId: '1113041',
    name: 'Tetingi',
  },
  {
    id: '1113041002',
    districtId: '1113041',
    name: 'Remukut',
  },
  {
    id: '1113041003',
    districtId: '1113041',
    name: 'Seneren',
  },
  {
    id: '1113041004',
    districtId: '1113041',
    name: 'Kenyaran',
  },
  {
    id: '1113041005',
    districtId: '1113041',
    name: 'Atu Kapur',
  },
  {
    id: '1113041006',
    districtId: '1113041',
    name: 'Uning Kurnia',
  },
  {
    id: '1113041007',
    districtId: '1113041',
    name: 'Suri Musara',
  },
  {
    id: '1113041008',
    districtId: '1113041',
    name: 'Cane Baru',
  },
  {
    id: '1113041009',
    districtId: '1113041',
    name: 'Aih Selah',
  },
  {
    id: '1113050001',
    districtId: '1113050',
    name: 'Bukut',
  },
  {
    id: '1113050002',
    districtId: '1113050',
    name: 'Soyo',
  },
  {
    id: '1113050003',
    districtId: '1113050',
    name: 'Kuta Sange',
  },
  {
    id: '1113050004',
    districtId: '1113050',
    name: 'Rumpi',
  },
  {
    id: '1113050005',
    districtId: '1113050',
    name: 'Rempelam Jabo',
  },
  {
    id: '1113050006',
    districtId: '1113050',
    name: 'Padang',
  },
  {
    id: '1113050007',
    districtId: '1113050',
    name: 'Terangun',
  },
  {
    id: '1113050008',
    districtId: '1113050',
    name: 'Rempelam Pinang',
  },
  {
    id: '1113050012',
    districtId: '1113050',
    name: 'Terlis',
  },
  {
    id: '1113050013',
    districtId: '1113050',
    name: 'Berhut',
  },
  {
    id: '1113050015',
    districtId: '1113050',
    name: 'Kute Reje',
  },
  {
    id: '1113050016',
    districtId: '1113050',
    name: 'Gewat',
  },
  {
    id: '1113050017',
    districtId: '1113050',
    name: 'Pantan Lues',
  },
  {
    id: '1113050018',
    districtId: '1113050',
    name: 'Makmur Jaya',
  },
  {
    id: '1113050019',
    districtId: '1113050',
    name: 'Persada Tongra',
  },
  {
    id: '1113050020',
    districtId: '1113050',
    name: 'Blang Kuncir',
  },
  {
    id: '1113050021',
    districtId: '1113050',
    name: 'Telege Jernih',
  },
  {
    id: '1113050022',
    districtId: '1113050',
    name: 'Reje Pudung',
  },
  {
    id: '1113050023',
    districtId: '1113050',
    name: 'Melelang',
  },
  {
    id: '1113050024',
    districtId: '1113050',
    name: 'Lestari',
  },
  {
    id: '1113050025',
    districtId: '1113050',
    name: 'Blang Kala',
  },
  {
    id: '1113050026',
    districtId: '1113050',
    name: 'Garut',
  },
  {
    id: '1113050027',
    districtId: '1113050',
    name: 'Gawar Belangi',
  },
  {
    id: '1113050028',
    districtId: '1113050',
    name: 'Rime Raya',
  },
  {
    id: '1113050029',
    districtId: '1113050',
    name: 'Blang Kede',
  },
  {
    id: '1113051001',
    districtId: '1113051',
    name: 'Pasir',
  },
  {
    id: '1113051002',
    districtId: '1113051',
    name: 'Rerebe',
  },
  {
    id: '1113051003',
    districtId: '1113051',
    name: 'Setul',
  },
  {
    id: '1113051004',
    districtId: '1113051',
    name: 'Perlak',
  },
  {
    id: '1113051005',
    districtId: '1113051',
    name: 'Pantan Kela',
  },
  {
    id: '1113051006',
    districtId: '1113051',
    name: 'Paya Kumer',
  },
  {
    id: '1113051007',
    districtId: '1113051',
    name: 'Uyem Beriring',
  },
  {
    id: '1113051008',
    districtId: '1113051',
    name: 'Pulo Gelime',
  },
  {
    id: '1113051009',
    districtId: '1113051',
    name: 'Buntul Musara',
  },
  {
    id: '1113051010',
    districtId: '1113051',
    name: 'Kuala Jernih',
  },
  {
    id: '1114010001',
    districtId: '1114010',
    name: 'Kaloy',
  },
  {
    id: '1114010002',
    districtId: '1114010',
    name: 'Rongoh',
  },
  {
    id: '1114010003',
    districtId: '1114010',
    name: 'Alur Tani I',
  },
  {
    id: '1114010004',
    districtId: '1114010',
    name: 'Alur Tani II',
  },
  {
    id: '1114010005',
    districtId: '1114010',
    name: 'Bandar Khalifah',
  },
  {
    id: '1114010006',
    districtId: '1114010',
    name: 'Perk Pulau Tiga',
  },
  {
    id: '1114010007',
    districtId: '1114010',
    name: 'Bandar Setia',
  },
  {
    id: '1114010008',
    districtId: '1114010',
    name: 'Harum Sari',
  },
  {
    id: '1114010009',
    districtId: '1114010',
    name: 'Wono Sari',
  },
  {
    id: '1114011001',
    districtId: '1114011',
    name: 'Jambo Rambong',
  },
  {
    id: '1114011002',
    districtId: '1114011',
    name: 'Blang Kandis',
  },
  {
    id: '1114011003',
    districtId: '1114011',
    name: 'Perk Alur Jambu',
  },
  {
    id: '1114011004',
    districtId: '1114011',
    name: 'Aras Sembilan',
  },
  {
    id: '1114011005',
    districtId: '1114011',
    name: 'Alur Jambu',
  },
  {
    id: '1114011006',
    districtId: '1114011',
    name: 'Batang Ara',
  },
  {
    id: '1114011007',
    districtId: '1114011',
    name: 'Perupuk',
  },
  {
    id: '1114011008',
    districtId: '1114011',
    name: 'Serba',
  },
  {
    id: '1114011009',
    districtId: '1114011',
    name: 'Sunting',
  },
  {
    id: '1114011010',
    districtId: '1114011',
    name: 'Rantau Bintang',
  },
  {
    id: '1114011011',
    districtId: '1114011',
    name: 'Babo',
  },
  {
    id: '1114011012',
    districtId: '1114011',
    name: 'Pantai Cempa',
  },
  {
    id: '1114011013',
    districtId: '1114011',
    name: 'Pengidam',
  },
  {
    id: '1114011014',
    districtId: '1114011',
    name: 'Bengkelang',
  },
  {
    id: '1114011015',
    districtId: '1114011',
    name: 'Batu Bedulang',
  },
  {
    id: '1114020005',
    districtId: '1114020',
    name: 'Kebun Sungai Liput',
  },
  {
    id: '1114020007',
    districtId: '1114020',
    name: 'Alur Selebu',
  },
  {
    id: '1114020008',
    districtId: '1114020',
    name: 'Suka Makmur',
  },
  {
    id: '1114020009',
    districtId: '1114020',
    name: 'Seumadam',
  },
  {
    id: '1114020010',
    districtId: '1114020',
    name: 'Karangjadi',
  },
  {
    id: '1114020011',
    districtId: '1114020',
    name: 'Kampung Jawa',
  },
  {
    id: '1114020012',
    districtId: '1114020',
    name: 'Sidodadi',
  },
  {
    id: '1114020013',
    districtId: '1114020',
    name: 'Purwodadi',
  },
  {
    id: '1114020014',
    districtId: '1114020',
    name: 'Tanjung Genteng',
  },
  {
    id: '1114020015',
    districtId: '1114020',
    name: 'Gerenggam',
  },
  {
    id: '1114020016',
    districtId: '1114020',
    name: 'Simpang Kanan',
  },
  {
    id: '1114020017',
    districtId: '1114020',
    name: 'Tanjung Mancang',
  },
  {
    id: '1114020018',
    districtId: '1114020',
    name: 'Pangkalan',
  },
  {
    id: '1114020019',
    districtId: '1114020',
    name: 'Sungai Liput',
  },
  {
    id: '1114020020',
    districtId: '1114020',
    name: 'Bukit Rata',
  },
  {
    id: '1114021001',
    districtId: '1114021',
    name: 'Selamat',
  },
  {
    id: '1114021002',
    districtId: '1114021',
    name: 'Tenggulun',
  },
  {
    id: '1114021003',
    districtId: '1114021',
    name: 'Rimba Sawang',
  },
  {
    id: '1114021004',
    districtId: '1114021',
    name: 'Tebing Tinggi',
  },
  {
    id: '1114021006',
    districtId: '1114021',
    name: 'Simpang Kiri',
  },
  {
    id: '1114030001',
    districtId: '1114030',
    name: 'Ingin Jaya',
  },
  {
    id: '1114030002',
    districtId: '1114030',
    name: 'Paya Bedi',
  },
  {
    id: '1114030003',
    districtId: '1114030',
    name: 'Landuh',
  },
  {
    id: '1114030004',
    districtId: '1114030',
    name: 'Benua Raja',
  },
  {
    id: '1114030005',
    districtId: '1114030',
    name: 'Kampung Durian',
  },
  {
    id: '1114030006',
    districtId: '1114030',
    name: 'Sukajadi',
  },
  {
    id: '1114030007',
    districtId: '1114030',
    name: 'Suka Rahmat',
  },
  {
    id: '1114030008',
    districtId: '1114030',
    name: 'Suka Mulia',
  },
  {
    id: '1114030009',
    districtId: '1114030',
    name: 'Suka Rakyat',
  },
  {
    id: '1114030010',
    districtId: '1114030',
    name: 'Jamur Labu',
  },
  {
    id: '1114030011',
    districtId: '1114030',
    name: 'Jamur Jelatang',
  },
  {
    id: '1114030012',
    districtId: '1114030',
    name: 'Kamp Pertamina',
  },
  {
    id: '1114030013',
    districtId: '1114030',
    name: 'Rantau Pauh',
  },
  {
    id: '1114030014',
    districtId: '1114030',
    name: 'Alur Cucur',
  },
  {
    id: '1114030015',
    districtId: '1114030',
    name: 'Kebun Rantau',
  },
  {
    id: '1114030016',
    districtId: '1114030',
    name: 'Alur Manis',
  },
  {
    id: '1114040001',
    districtId: '1114040',
    name: 'Sriwijaya',
  },
  {
    id: '1114040002',
    districtId: '1114040',
    name: 'Kota Kuala Simpang',
  },
  {
    id: '1114040003',
    districtId: '1114040',
    name: 'Perdamaian',
  },
  {
    id: '1114040004',
    districtId: '1114040',
    name: 'Bukit Tempurung',
  },
  {
    id: '1114040005',
    districtId: '1114040',
    name: 'Kota Lintang',
  },
  {
    id: '1114050001',
    districtId: '1114050',
    name: 'Sukaramai II',
  },
  {
    id: '1114050002',
    districtId: '1114050',
    name: 'Sukaramai I',
  },
  {
    id: '1114050003',
    districtId: '1114050',
    name: 'Perk Gedung Biara',
  },
  {
    id: '1114050004',
    districtId: '1114050',
    name: 'Air Masin',
  },
  {
    id: '1114050005',
    districtId: '1114050',
    name: 'Sidodadi',
  },
  {
    id: '1114050006',
    districtId: '1114050',
    name: 'Tualang',
  },
  {
    id: '1114050007',
    districtId: '1114050',
    name: 'Matang Sentang',
  },
  {
    id: '1114050008',
    districtId: '1114050',
    name: 'Alur Alim',
  },
  {
    id: '1114050009',
    districtId: '1114050',
    name: 'Lubuk Damar',
  },
  {
    id: '1114050010',
    districtId: '1114050',
    name: 'Sei Kuruk III',
  },
  {
    id: '1114050011',
    districtId: '1114050',
    name: 'Sei Kuruk II',
  },
  {
    id: '1114050012',
    districtId: '1114050',
    name: 'Gedung Biara',
  },
  {
    id: '1114050013',
    districtId: '1114050',
    name: 'Perk Seuruway',
  },
  {
    id: '1114050014',
    districtId: '1114050',
    name: 'Padang Langgis',
  },
  {
    id: '1114050015',
    districtId: '1114050',
    name: 'Pantai Balai',
  },
  {
    id: '1114050016',
    districtId: '1114050',
    name: 'Binjai',
  },
  {
    id: '1114050017',
    districtId: '1114050',
    name: 'Tangsi Lama',
  },
  {
    id: '1114050018',
    districtId: '1114050',
    name: 'Peukan Seuruway',
  },
  {
    id: '1114050019',
    districtId: '1114050',
    name: 'Muka Sungai Kuruk',
  },
  {
    id: '1114050020',
    districtId: '1114050',
    name: 'Sungai Kuruk I',
  },
  {
    id: '1114050021',
    districtId: '1114050',
    name: 'Paya Udang',
  },
  {
    id: '1114050022',
    districtId: '1114050',
    name: 'Gelung',
  },
  {
    id: '1114050023',
    districtId: '1114050',
    name: 'Kampung Baru',
  },
  {
    id: '1114050024',
    districtId: '1114050',
    name: 'Kw Pusung Kapal',
  },
  {
    id: '1114060001',
    districtId: '1114060',
    name: 'Upah',
  },
  {
    id: '1114060002',
    districtId: '1114060',
    name: 'Perkebunan Upah',
  },
  {
    id: '1114060003',
    districtId: '1114060',
    name: 'Matang Teupah',
  },
  {
    id: '1114060004',
    districtId: '1114060',
    name: 'Seuneubok Dalam Upah',
  },
  {
    id: '1114060006',
    districtId: '1114060',
    name: 'Sukamulia Bd /S.Iyu',
  },
  {
    id: '1114060009',
    districtId: '1114060',
    name: 'Kebon Sungai Iyu',
  },
  {
    id: '1114060010',
    districtId: '1114060',
    name: 'Marlempang',
  },
  {
    id: '1114060011',
    districtId: '1114060',
    name: 'Balai',
  },
  {
    id: '1114060012',
    districtId: '1114060',
    name: 'Lambung Blang',
  },
  {
    id: '1114060013',
    districtId: '1114060',
    name: 'Lubuk Batil',
  },
  {
    id: '1114060014',
    districtId: '1114060',
    name: 'Tanjung Paret',
  },
  {
    id: '1114060015',
    districtId: '1114060',
    name: 'Seuneubok Dalam Mesjid',
  },
  {
    id: '1114060016',
    districtId: '1114060',
    name: 'Rantau Pakam',
  },
  {
    id: '1114060017',
    districtId: '1114060',
    name: 'Tumpok Teungah',
  },
  {
    id: '1114060018',
    districtId: '1114060',
    name: 'Tanjung',
  },
  {
    id: '1114060019',
    districtId: '1114060',
    name: 'Tanjung Mulia',
  },
  {
    id: '1114060020',
    districtId: '1114060',
    name: 'Teluk Kemiri',
  },
  {
    id: '1114060021',
    districtId: '1114060',
    name: 'Mesjid Bdh',
  },
  {
    id: '1114060022',
    districtId: '1114060',
    name: 'Teluk Kepayang',
  },
  {
    id: '1114060023',
    districtId: '1114060',
    name: 'Teluk Halban',
  },
  {
    id: '1114060024',
    districtId: '1114060',
    name: 'Raja',
  },
  {
    id: '1114060025',
    districtId: '1114060',
    name: 'Cinta Raja',
  },
  {
    id: '1114060026',
    districtId: '1114060',
    name: 'Tanjung Binjai',
  },
  {
    id: '1114060027',
    districtId: '1114060',
    name: 'Kuala Peunaga',
  },
  {
    id: '1114060028',
    districtId: '1114060',
    name: 'Kuala Geunting',
  },
  {
    id: '1114060029',
    districtId: '1114060',
    name: 'Bandar Baru',
  },
  {
    id: '1114060030',
    districtId: '1114060',
    name: 'Mesjid S.Iyu',
  },
  {
    id: '1114060031',
    districtId: '1114060',
    name: 'Alur Cantik',
  },
  {
    id: '1114060032',
    districtId: '1114060',
    name: 'Tanjung Lipat I',
  },
  {
    id: '1114060034',
    districtId: '1114060',
    name: 'Bandar Khalifah',
  },
  {
    id: '1114060035',
    districtId: '1114060',
    name: 'Seuneubok Aceh',
  },
  {
    id: '1114060036',
    districtId: '1114060',
    name: 'Tanjung Lipat II',
  },
  {
    id: '1114060037',
    districtId: '1114060',
    name: 'Tengku Tinggi',
  },
  {
    id: '1114061001',
    districtId: '1114061',
    name: 'Sukajadi',
  },
  {
    id: '1114061002',
    districtId: '1114061',
    name: 'Suka Damai',
  },
  {
    id: '1114061003',
    districtId: '1114061',
    name: 'Paya Rahat',
  },
  {
    id: '1114061004',
    districtId: '1114061',
    name: 'Suka Mulia/Upah Hulu',
  },
  {
    id: '1114061005',
    districtId: '1114061',
    name: 'Matang Seuping',
  },
  {
    id: '1114061006',
    districtId: '1114061',
    name: 'Gampong Besar',
  },
  {
    id: '1114061007',
    districtId: '1114061',
    name: 'Telaga Meuku II',
  },
  {
    id: '1114061008',
    districtId: '1114061',
    name: 'Telaga Meuku I',
  },
  {
    id: '1114061009',
    districtId: '1114061',
    name: 'Tanjung Keramat',
  },
  {
    id: '1114061010',
    districtId: '1114061',
    name: 'Alur Nunang',
  },
  {
    id: '1114070013',
    districtId: '1114070',
    name: 'Tanjung Karang',
  },
  {
    id: '1114070015',
    districtId: '1114070',
    name: 'Menang Gini',
  },
  {
    id: '1114070016',
    districtId: '1114070',
    name: 'Kesehatan',
  },
  {
    id: '1114070017',
    districtId: '1114070',
    name: 'Gampong Sukajadi',
  },
  {
    id: '1114070018',
    districtId: '1114070',
    name: 'Dalam',
  },
  {
    id: '1114070019',
    districtId: '1114070',
    name: 'Gampong Bundar',
  },
  {
    id: '1114070021',
    districtId: '1114070',
    name: 'Kebun Tanah Terban',
  },
  {
    id: '1114070022',
    districtId: '1114070',
    name: 'Tanah Terban',
  },
  {
    id: '1114070023',
    districtId: '1114070',
    name: 'Gampong Air Tenang',
  },
  {
    id: '1114070024',
    districtId: '1114070',
    name: 'Gampong Johar',
  },
  {
    id: '1114070025',
    districtId: '1114070',
    name: 'Gampong Tupah',
  },
  {
    id: '1114070026',
    districtId: '1114070',
    name: 'Banai',
  },
  {
    id: '1114070027',
    districtId: '1114070',
    name: 'Rantau Panjang',
  },
  {
    id: '1114070028',
    districtId: '1114070',
    name: 'Pahlawan',
  },
  {
    id: '1114070029',
    districtId: '1114070',
    name: 'Medang Ara',
  },
  {
    id: '1114070030',
    districtId: '1114070',
    name: 'Kebun Medang Ara',
  },
  {
    id: '1114070031',
    districtId: '1114070',
    name: 'Kebun Seleleh',
  },
  {
    id: '1114070032',
    districtId: '1114070',
    name: 'Alur Selalas',
  },
  {
    id: '1114070033',
    districtId: '1114070',
    name: 'Alur Baung',
  },
  {
    id: '1114070034',
    districtId: '1114070',
    name: 'Payameta',
  },
  {
    id: '1114070035',
    districtId: '1114070',
    name: 'Alur Bemban',
  },
  {
    id: '1114070036',
    districtId: '1114070',
    name: 'Tanjung Seumantoh',
  },
  {
    id: '1114070037',
    districtId: '1114070',
    name: 'Kebun Tanjung Seumantoh',
  },
  {
    id: '1114070038',
    districtId: '1114070',
    name: 'Paya Tampah',
  },
  {
    id: '1114070039',
    districtId: '1114070',
    name: 'Alur Lhok',
  },
  {
    id: '1114070040',
    districtId: '1114070',
    name: 'Buket Panjang',
  },
  {
    id: '1114070041',
    districtId: '1114070',
    name: 'Sukajadi Paya Bujuk',
  },
  {
    id: '1114070042',
    districtId: '1114070',
    name: 'Simpang Empat',
  },
  {
    id: '1114070043',
    districtId: '1114070',
    name: 'Paya Awe',
  },
  {
    id: '1114070044',
    districtId: '1114070',
    name: 'Paya Kulbi',
  },
  {
    id: '1114070045',
    districtId: '1114070',
    name: 'Buket Keranji',
  },
  {
    id: '1114071001',
    districtId: '1114071',
    name: 'Baling Karang',
  },
  {
    id: '1114071002',
    districtId: '1114071',
    name: 'Suka Makmur',
  },
  {
    id: '1114071003',
    districtId: '1114071',
    name: 'Sulum',
  },
  {
    id: '1114071004',
    districtId: '1114071',
    name: 'Juar',
  },
  {
    id: '1114071005',
    districtId: '1114071',
    name: 'Pematang Durian',
  },
  {
    id: '1114071006',
    districtId: '1114071',
    name: 'Sekumur',
  },
  {
    id: '1114071007',
    districtId: '1114071',
    name: 'Tanjung Gelumpang',
  },
  {
    id: '1114071008',
    districtId: '1114071',
    name: 'Lubuk Sidup',
  },
  {
    id: '1114071009',
    districtId: '1114071',
    name: 'Sekerak Kanan',
  },
  {
    id: '1114071010',
    districtId: '1114071',
    name: 'Bandar Mahligai',
  },
  {
    id: '1114071011',
    districtId: '1114071',
    name: 'Sekerak Kiri',
  },
  {
    id: '1114071012',
    districtId: '1114071',
    name: 'Pantai Perlak',
  },
  {
    id: '1114071013',
    districtId: '1114071',
    name: 'Pantai Tinjau',
  },
  {
    id: '1114071014',
    districtId: '1114071',
    name: 'Kebun Batang Ara',
  },
  {
    id: '1114080001',
    districtId: '1114080',
    name: 'Krueng Sikajang',
  },
  {
    id: '1114080002',
    districtId: '1114080',
    name: 'Seuneubok Punti',
  },
  {
    id: '1114080003',
    districtId: '1114080',
    name: 'Paya Ketenggar',
  },
  {
    id: '1114080004',
    districtId: '1114080',
    name: 'Buket Panjang II',
  },
  {
    id: '1114080005',
    districtId: '1114080',
    name: 'Buket Paya',
  },
  {
    id: '1114080006',
    districtId: '1114080',
    name: 'Bukit Panjang I',
  },
  {
    id: '1114080007',
    districtId: '1114080',
    name: 'Seuneubok Baru',
  },
  {
    id: '1114080008',
    districtId: '1114080',
    name: 'Benteng Anyer',
  },
  {
    id: '1114080009',
    districtId: '1114080',
    name: 'Matang Ara Jawa',
  },
  {
    id: '1114080010',
    districtId: '1114080',
    name: 'Matang Ara Aceh',
  },
  {
    id: '1114080011',
    districtId: '1114080',
    name: 'Lhok Medang Ara',
  },
  {
    id: '1114080012',
    districtId: '1114080',
    name: 'Ie Bintah',
  },
  {
    id: '1114080013',
    districtId: '1114080',
    name: 'Tualang Baru',
  },
  {
    id: '1114080014',
    districtId: '1114080',
    name: 'Pahlawan',
  },
  {
    id: '1114080015',
    districtId: '1114080',
    name: 'Gaseh Sayang',
  },
  {
    id: '1114080016',
    districtId: '1114080',
    name: 'Sampaimah',
  },
  {
    id: '1114080017',
    districtId: '1114080',
    name: 'Gelanggang Merak',
  },
  {
    id: '1114080018',
    districtId: '1114080',
    name: 'Matang Cincin',
  },
  {
    id: '1114080019',
    districtId: '1114080',
    name: 'Alue Ie Puteh',
  },
  {
    id: '1114080020',
    districtId: '1114080',
    name: 'Lueng Manyo',
  },
  {
    id: '1114080021',
    districtId: '1114080',
    name: 'Raja Tuha',
  },
  {
    id: '1114080022',
    districtId: '1114080',
    name: 'Seuneubok Pidie',
  },
  {
    id: '1114080023',
    districtId: '1114080',
    name: 'Geudham',
  },
  {
    id: '1114080024',
    districtId: '1114080',
    name: 'Alue Sentang',
  },
  {
    id: '1114080025',
    districtId: '1114080',
    name: 'Ujong Tanjong',
  },
  {
    id: '1114080026',
    districtId: '1114080',
    name: 'Tanjung Neraca',
  },
  {
    id: '1114080027',
    districtId: '1114080',
    name: 'Dagang Setia',
  },
  {
    id: '1114080028',
    districtId: '1114080',
    name: 'Simpang Lhee',
  },
  {
    id: '1114080029',
    districtId: '1114080',
    name: 'Seuneubok Cantek',
  },
  {
    id: '1114080030',
    districtId: '1114080',
    name: 'Mesjid',
  },
  {
    id: '1114080031',
    districtId: '1114080',
    name: 'Meunasah Paya',
  },
  {
    id: '1114080032',
    districtId: '1114080',
    name: 'Meurandeh',
  },
  {
    id: '1114080033',
    districtId: '1114080',
    name: 'Bandung Jaya',
  },
  {
    id: '1114080034',
    districtId: '1114080',
    name: 'Pandan Sari',
  },
  {
    id: '1114080035',
    districtId: '1114080',
    name: 'Paya Baru',
  },
  {
    id: '1114080036',
    districtId: '1114080',
    name: 'Sapta Marga',
  },
  {
    id: '1115010003',
    districtId: '1115010',
    name: 'Kuala Semanyam',
  },
  {
    id: '1115010005',
    districtId: '1115010',
    name: 'Blang Luah',
  },
  {
    id: '1115010007',
    districtId: '1115010',
    name: 'Pulo Kruet',
  },
  {
    id: '1115010009',
    districtId: '1115010',
    name: 'Alue Bateung Brook',
  },
  {
    id: '1115010010',
    districtId: '1115010',
    name: 'Ladang Baro',
  },
  {
    id: '1115010011',
    districtId: '1115010',
    name: 'Alue Kuyun',
  },
  {
    id: '1115010013',
    districtId: '1115010',
    name: 'Alue Raya',
  },
  {
    id: '1115010014',
    districtId: '1115010',
    name: 'Sukaramai',
  },
  {
    id: '1115010015',
    districtId: '1115010',
    name: 'Ujong Tanjong',
  },
  {
    id: '1115010016',
    districtId: '1115010',
    name: 'Alue Jampak',
  },
  {
    id: '1115010017',
    districtId: '1115010',
    name: 'Serba Jadi',
  },
  {
    id: '1115010018',
    districtId: '1115010',
    name: 'Serba Guna',
  },
  {
    id: '1115010022',
    districtId: '1115010',
    name: 'Kayee Unou',
  },
  {
    id: '1115010023',
    districtId: '1115010',
    name: 'Geulanggang Gajah',
  },
  {
    id: '1115010024',
    districtId: '1115010',
    name: 'Sidojadi',
  },
  {
    id: '1115010025',
    districtId: '1115010',
    name: 'Sukamulia',
  },
  {
    id: '1115010026',
    districtId: '1115010',
    name: 'Simpang Dua',
  },
  {
    id: '1115010027',
    districtId: '1115010',
    name: 'Panton Bayu',
  },
  {
    id: '1115010028',
    districtId: '1115010',
    name: 'Simpang Deli Kilang',
  },
  {
    id: '1115010029',
    districtId: '1115010',
    name: 'Simpang Deli Kampong',
  },
  {
    id: '1115010030',
    districtId: '1115010',
    name: 'Pulo Ie',
  },
  {
    id: '1115010031',
    districtId: '1115010',
    name: 'Pulo Tengah',
  },
  {
    id: '1115010032',
    districtId: '1115010',
    name: 'Karang Anyar',
  },
  {
    id: '1115010033',
    districtId: '1115010',
    name: 'Sukajadi',
  },
  {
    id: '1115010034',
    districtId: '1115010',
    name: 'Alue Bilie',
  },
  {
    id: '1115010035',
    districtId: '1115010',
    name: 'Blang Baro',
  },
  {
    id: '1115010036',
    districtId: '1115010',
    name: 'Kuta Trieng',
  },
  {
    id: '1115010037',
    districtId: '1115010',
    name: 'Lamie',
  },
  {
    id: '1115010040',
    districtId: '1115010',
    name: 'Ujong Lamie',
  },
  {
    id: '1115010041',
    districtId: '1115010',
    name: 'Tuwi Buya',
  },
  {
    id: '1115010042',
    districtId: '1115010',
    name: 'Sukaraja',
  },
  {
    id: '1115010043',
    districtId: '1115010',
    name: 'Gunung Cut',
  },
  {
    id: '1115010044',
    districtId: '1115010',
    name: 'Suak Palembang',
  },
  {
    id: '1115010045',
    districtId: '1115010',
    name: 'Alue Geutah',
  },
  {
    id: '1115010046',
    districtId: '1115010',
    name: 'Alue Wakie',
  },
  {
    id: '1115010047',
    districtId: '1115010',
    name: 'Krueng Alem',
  },
  {
    id: '1115010048',
    districtId: '1115010',
    name: 'Alue Rambot',
  },
  {
    id: '1115010049',
    districtId: '1115010',
    name: 'Krueng Seumayam',
  },
  {
    id: '1115010050',
    districtId: '1115010',
    name: 'Makarti Jaya',
  },
  {
    id: '1115010051',
    districtId: '1115010',
    name: 'Sumber Makmur',
  },
  {
    id: '1115011001',
    districtId: '1115011',
    name: 'Kuala Teripa',
  },
  {
    id: '1115011002',
    districtId: '1115011',
    name: 'Drien Tujoh',
  },
  {
    id: '1115011003',
    districtId: '1115011',
    name: 'Lueng Keubeu Jagat',
  },
  {
    id: '1115011004',
    districtId: '1115011',
    name: 'Kabu',
  },
  {
    id: '1115011005',
    districtId: '1115011',
    name: 'Babah Lueng',
  },
  {
    id: '1115011006',
    districtId: '1115011',
    name: 'Pasi Keubeu Dom',
  },
  {
    id: '1115011007',
    districtId: '1115011',
    name: 'Neubok Yee Pk',
  },
  {
    id: '1115011008',
    districtId: '1115011',
    name: 'Neubok Yee Pp',
  },
  {
    id: '1115011009',
    districtId: '1115011',
    name: 'Mon Dua',
  },
  {
    id: '1115011010',
    districtId: '1115011',
    name: 'Panton Pange',
  },
  {
    id: '1115011011',
    districtId: '1115011',
    name: 'Ujong Krueng',
  },
  {
    id: '1115020017',
    districtId: '1115020',
    name: 'Ujong Fatihah',
  },
  {
    id: '1115020018',
    districtId: '1115020',
    name: 'Blang Teungoh',
  },
  {
    id: '1115020019',
    districtId: '1115020',
    name: 'Cot Kumbang',
  },
  {
    id: '1115020020',
    districtId: '1115020',
    name: 'Blang Bintang',
  },
  {
    id: '1115020021',
    districtId: '1115020',
    name: 'Ujong Padang',
  },
  {
    id: '1115020022',
    districtId: '1115020',
    name: 'Jokja',
  },
  {
    id: '1115020023',
    districtId: '1115020',
    name: 'Lawa Batu',
  },
  {
    id: '1115020026',
    districtId: '1115020',
    name: 'Purworejo',
  },
  {
    id: '1115020038',
    districtId: '1115020',
    name: 'Pulo Ie',
  },
  {
    id: '1115020039',
    districtId: '1115020',
    name: 'Ujong Sikuneng',
  },
  {
    id: '1115020040',
    districtId: '1115020',
    name: 'Blang Baro',
  },
  {
    id: '1115020041',
    districtId: '1115020',
    name: 'Blang Muko',
  },
  {
    id: '1115020042',
    districtId: '1115020',
    name: 'Simpang Peut',
  },
  {
    id: '1115020043',
    districtId: '1115020',
    name: 'Kuta Makmur',
  },
  {
    id: '1115020044',
    districtId: '1115020',
    name: 'Gunong Reubo',
  },
  {
    id: '1115020045',
    districtId: '1115020',
    name: 'Ujong Pasi',
  },
  {
    id: '1115020046',
    districtId: '1115020',
    name: 'Alue Ie Mameh',
  },
  {
    id: '1115021001',
    districtId: '1115021',
    name: 'Suak Puntong',
  },
  {
    id: '1115021002',
    districtId: '1115021',
    name: 'Gampong Lhok',
  },
  {
    id: '1115021003',
    districtId: '1115021',
    name: 'Kuala Baro',
  },
  {
    id: '1115021004',
    districtId: '1115021',
    name: 'Padang Rubek',
  },
  {
    id: '1115021005',
    districtId: '1115021',
    name: 'Pulo',
  },
  {
    id: '1115021006',
    districtId: '1115021',
    name: 'Langkak',
  },
  {
    id: '1115021007',
    districtId: '1115021',
    name: 'Kuala Tuha',
  },
  {
    id: '1115021008',
    districtId: '1115021',
    name: 'Kubang Gajah',
  },
  {
    id: '1115021009',
    districtId: '1115021',
    name: 'Kuala Trang',
  },
  {
    id: '1115021010',
    districtId: '1115021',
    name: 'Cot Rambong',
  },
  {
    id: '1115021011',
    districtId: '1115021',
    name: 'Padang Panyang',
  },
  {
    id: '1115021012',
    districtId: '1115021',
    name: 'Arongan',
  },
  {
    id: '1115021013',
    districtId: '1115021',
    name: 'Jatirejo',
  },
  {
    id: '1115021014',
    districtId: '1115021',
    name: 'Purwodadi',
  },
  {
    id: '1115021015',
    districtId: '1115021',
    name: 'Lueng T Ben',
  },
  {
    id: '1115021016',
    districtId: '1115021',
    name: 'Purwosari',
  },
  {
    id: '1115022001',
    districtId: '1115022',
    name: 'Alue Bata',
  },
  {
    id: '1115022002',
    districtId: '1115022',
    name: 'Gunong Sapek',
  },
  {
    id: '1115022003',
    districtId: '1115022',
    name: 'Sarah Mantok',
  },
  {
    id: '1115022004',
    districtId: '1115022',
    name: 'Pasi Luah',
  },
  {
    id: '1115022005',
    districtId: '1115022',
    name: 'Gunong Geulugo',
  },
  {
    id: '1115022006',
    districtId: '1115022',
    name: 'Gunong Kupok',
  },
  {
    id: '1115022007',
    districtId: '1115022',
    name: 'Gunong Pungkie',
  },
  {
    id: '1115022008',
    districtId: '1115022',
    name: 'Alue Siron',
  },
  {
    id: '1115022009',
    districtId: '1115022',
    name: 'Cot Mu',
  },
  {
    id: '1115022010',
    districtId: '1115022',
    name: 'Babah Rot',
  },
  {
    id: '1115022011',
    districtId: '1115022',
    name: 'Babah Dua',
  },
  {
    id: '1115022012',
    districtId: '1115022',
    name: 'Batu Raja',
  },
  {
    id: '1115022013',
    districtId: '1115022',
    name: 'Simpang Jaya',
  },
  {
    id: '1115022014',
    districtId: '1115022',
    name: 'Sumber Daya',
  },
  {
    id: '1115022015',
    districtId: '1115022',
    name: 'Rantau Selamat',
  },
  {
    id: '1115022016',
    districtId: '1115022',
    name: 'Alue Sepeng',
  },
  {
    id: '1115022017',
    districtId: '1115022',
    name: 'Krueng Itam',
  },
  {
    id: '1115022018',
    districtId: '1115022',
    name: 'Alue Gajah',
  },
  {
    id: '1115022019',
    districtId: '1115022',
    name: 'Alue Labu',
  },
  {
    id: '1115022020',
    districtId: '1115022',
    name: 'Gapa Garu',
  },
  {
    id: '1115022021',
    districtId: '1115022',
    name: 'Kuala Tadu',
  },
  {
    id: '1115022022',
    districtId: '1115022',
    name: 'Cot Me',
  },
  {
    id: '1115030001',
    districtId: '1115030',
    name: 'Kuta Jeumpa',
  },
  {
    id: '1115030002',
    districtId: '1115030',
    name: 'Blang Dalam',
  },
  {
    id: '1115030003',
    districtId: '1115030',
    name: 'Lhok Seumot',
  },
  {
    id: '1115030004',
    districtId: '1115030',
    name: 'Bumi Sari',
  },
  {
    id: '1115030005',
    districtId: '1115030',
    name: 'Blang Baro Rambong',
  },
  {
    id: '1115030006',
    districtId: '1115030',
    name: 'Meunasah Krueng',
  },
  {
    id: '1115030007',
    districtId: '1115030',
    name: 'Keude Seumot',
  },
  {
    id: '1115030008',
    districtId: '1115030',
    name: 'Blang Seumot',
  },
  {
    id: '1115030009',
    districtId: '1115030',
    name: 'Babah Krueng',
  },
  {
    id: '1115030010',
    districtId: '1115030',
    name: 'Meunasah Pante',
  },
  {
    id: '1115030011',
    districtId: '1115030',
    name: 'Blang Baro Pr',
  },
  {
    id: '1115030012',
    districtId: '1115030',
    name: 'Gunung Nagan',
  },
  {
    id: '1115030013',
    districtId: '1115030',
    name: 'Blang Mesjid',
  },
  {
    id: '1115030014',
    districtId: '1115030',
    name: 'Kulam Jeurneh',
  },
  {
    id: '1115030015',
    districtId: '1115030',
    name: 'Meunasah Teungoh',
  },
  {
    id: '1115030016',
    districtId: '1115030',
    name: 'Meunasah Dayah',
  },
  {
    id: '1115030017',
    districtId: '1115030',
    name: 'Ujong Blang',
  },
  {
    id: '1115030018',
    districtId: '1115030',
    name: 'Krueng Cut',
  },
  {
    id: '1115030019',
    districtId: '1115030',
    name: 'Blang Neuang',
  },
  {
    id: '1115030020',
    districtId: '1115030',
    name: 'Blang Seunong',
  },
  {
    id: '1115030021',
    districtId: '1115030',
    name: 'Tuwi Bunta',
  },
  {
    id: '1115030022',
    districtId: '1115030',
    name: 'Blang Leumak',
  },
  {
    id: '1115030023',
    districtId: '1115030',
    name: 'Panton Bayam',
  },
  {
    id: '1115030028',
    districtId: '1115030',
    name: 'Pante Ara',
  },
  {
    id: '1115031001',
    districtId: '1115031',
    name: 'Blang Meurandeh',
  },
  {
    id: '1115031002',
    districtId: '1115031',
    name: 'Blang Puuk',
  },
  {
    id: '1115031003',
    districtId: '1115031',
    name: 'Kuta Teungoh',
  },
  {
    id: '1115031004',
    districtId: '1115031',
    name: 'Babah Suak',
  },
  {
    id: '1115040014',
    districtId: '1115040',
    name: 'Blang Murong',
  },
  {
    id: '1115040015',
    districtId: '1115040',
    name: 'Lhok Padang',
  },
  {
    id: '1115040016',
    districtId: '1115040',
    name: 'Paya Undan',
  },
  {
    id: '1115040021',
    districtId: '1115040',
    name: 'Blang Puuk Kulu',
  },
  {
    id: '1115040022',
    districtId: '1115040',
    name: 'Kulu',
  },
  {
    id: '1115040023',
    districtId: '1115040',
    name: 'Kuta Aceh',
  },
  {
    id: '1115040024',
    districtId: '1115040',
    name: 'Krueng Ceukou',
  },
  {
    id: '1115040025',
    districtId: '1115040',
    name: 'Paya Udeung',
  },
  {
    id: '1115040026',
    districtId: '1115040',
    name: 'Kuta Paya',
  },
  {
    id: '1115040027',
    districtId: '1115040',
    name: 'Rambong Cut',
  },
  {
    id: '1115040028',
    districtId: '1115040',
    name: 'Rambong Rayeuk',
  },
  {
    id: '1115040031',
    districtId: '1115040',
    name: 'Bantan',
  },
  {
    id: '1115040032',
    districtId: '1115040',
    name: 'Blang Puuk Nigan',
  },
  {
    id: '1115040033',
    districtId: '1115040',
    name: 'Krueng Ceh',
  },
  {
    id: '1115040034',
    districtId: '1115040',
    name: 'Nigan',
  },
  {
    id: '1115040035',
    districtId: '1115040',
    name: 'Gampong Cot',
  },
  {
    id: '1115040036',
    districtId: '1115040',
    name: 'Cot Lhe Lhe',
  },
  {
    id: '1115040037',
    districtId: '1115040',
    name: 'Kuta Baro Jeuram',
  },
  {
    id: '1115040038',
    districtId: '1115040',
    name: 'Jeuram',
  },
  {
    id: '1115040039',
    districtId: '1115040',
    name: 'Latong',
  },
  {
    id: '1115040040',
    districtId: '1115040',
    name: 'Alue Buloh',
  },
  {
    id: '1115040041',
    districtId: '1115040',
    name: 'Krueng Mangkom',
  },
  {
    id: '1115040042',
    districtId: '1115040',
    name: 'Pante Cermin',
  },
  {
    id: '1115040043',
    districtId: '1115040',
    name: 'Padang',
  },
  {
    id: '1115040044',
    districtId: '1115040',
    name: 'Lhok Parom',
  },
  {
    id: '1115040045',
    districtId: '1115040',
    name: 'Blang Pateuk',
  },
  {
    id: '1115040046',
    districtId: '1115040',
    name: 'Cot Kumbang',
  },
  {
    id: '1115040047',
    districtId: '1115040',
    name: 'Kuta Kumbang',
  },
  {
    id: '1115040048',
    districtId: '1115040',
    name: 'Sapek',
  },
  {
    id: '1115040049',
    districtId: '1115040',
    name: 'Kuta Sayeh',
  },
  {
    id: '1115040050',
    districtId: '1115040',
    name: 'Parom',
  },
  {
    id: '1115040051',
    districtId: '1115040',
    name: 'Blang Baro',
  },
  {
    id: '1115040052',
    districtId: '1115040',
    name: 'Peureulak',
  },
  {
    id: '1115040059',
    districtId: '1115040',
    name: 'Alue Tho',
  },
  {
    id: '1115040060',
    districtId: '1115040',
    name: 'Alue Dodok',
  },
  {
    id: '1115041001',
    districtId: '1115041',
    name: 'Lueng Baro',
  },
  {
    id: '1115041002',
    districtId: '1115041',
    name: 'Alue Kambuek',
  },
  {
    id: '1115041003',
    districtId: '1115041',
    name: 'Kuta Padang',
  },
  {
    id: '1115041004',
    districtId: '1115041',
    name: 'Suak Bili',
  },
  {
    id: '1115041005',
    districtId: '1115041',
    name: 'Macah',
  },
  {
    id: '1115041006',
    districtId: '1115041',
    name: 'Seumambek',
  },
  {
    id: '1115041007',
    districtId: '1115041',
    name: 'Cot Kuta',
  },
  {
    id: '1115041008',
    districtId: '1115041',
    name: 'Kabu Blang Sapek',
  },
  {
    id: '1115041009',
    districtId: '1115041',
    name: 'Cot Peradi',
  },
  {
    id: '1115041010',
    districtId: '1115041',
    name: 'Blang Sapek',
  },
  {
    id: '1115041011',
    districtId: '1115041',
    name: 'Lhok Beutong',
  },
  {
    id: '1115041012',
    districtId: '1115041',
    name: 'Kampong Teungoh',
  },
  {
    id: '1115041013',
    districtId: '1115041',
    name: 'Lhok Rameun',
  },
  {
    id: '1115041014',
    districtId: '1115041',
    name: 'Blang Mulieng',
  },
  {
    id: '1115041015',
    districtId: '1115041',
    name: 'Krak Tampai',
  },
  {
    id: '1115041016',
    districtId: '1115041',
    name: 'Meureubo',
  },
  {
    id: '1115041017',
    districtId: '1115041',
    name: 'Kuta Baro Bm',
  },
  {
    id: '1115041018',
    districtId: '1115041',
    name: 'Alue Peusaja',
  },
  {
    id: '1115041019',
    districtId: '1115041',
    name: 'Alue Gajah',
  },
  {
    id: '1115050001',
    districtId: '1115050',
    name: 'Blang Lango',
  },
  {
    id: '1115050002',
    districtId: '1115050',
    name: 'Tuwi Meuleusong',
  },
  {
    id: '1115050003',
    districtId: '1115050',
    name: 'Blang Geudong',
  },
  {
    id: '1115050004',
    districtId: '1115050',
    name: 'Sawang Mane',
  },
  {
    id: '1115050005',
    districtId: '1115050',
    name: 'Lhok Pange',
  },
  {
    id: '1115050006',
    districtId: '1115050',
    name: 'Keude Neulop',
  },
  {
    id: '1115050007',
    districtId: '1115050',
    name: 'Mon Bateung',
  },
  {
    id: '1115050008',
    districtId: '1115050',
    name: 'Ie Beudoh',
  },
  {
    id: '1115050009',
    districtId: '1115050',
    name: 'Suak Perbong',
  },
  {
    id: '1115050010',
    districtId: '1115050',
    name: 'Blang Ara Kmp.',
  },
  {
    id: '1115050011',
    districtId: '1115050',
    name: 'Krueng Kulu',
  },
  {
    id: '1115050012',
    districtId: '1115050',
    name: 'Cot Punti',
  },
  {
    id: '1115050013',
    districtId: '1115050',
    name: 'Keude Blang Ara',
  },
  {
    id: '1115050014',
    districtId: '1115050',
    name: 'Peuleukung',
  },
  {
    id: '1115050015',
    districtId: '1115050',
    name: 'Sapeng',
  },
  {
    id: '1115050016',
    districtId: '1115050',
    name: 'Meugat Meuh',
  },
  {
    id: '1115050017',
    districtId: '1115050',
    name: 'Blang Panyang',
  },
  {
    id: '1115050018',
    districtId: '1115050',
    name: 'Uteun Pulo',
  },
  {
    id: '1115050019',
    districtId: '1115050',
    name: 'Keude Linteung',
  },
  {
    id: '1115050020',
    districtId: '1115050',
    name: 'Paya',
  },
  {
    id: '1115050021',
    districtId: '1115050',
    name: 'Cot Teuku Dek',
  },
  {
    id: '1115050022',
    districtId: '1115050',
    name: 'Lhok Mesjid',
  },
  {
    id: '1115050023',
    districtId: '1115050',
    name: 'Blang Preh',
  },
  {
    id: '1115050024',
    districtId: '1115050',
    name: 'Blang Bayu',
  },
  {
    id: '1115050025',
    districtId: '1115050',
    name: 'Meurandeh Suak',
  },
  {
    id: '1115050026',
    districtId: '1115050',
    name: 'Cot Dirui',
  },
  {
    id: '1115050027',
    districtId: '1115050',
    name: 'Cot Manyang',
  },
  {
    id: '1115050028',
    districtId: '1115050',
    name: 'Kabu Baroh',
  },
  {
    id: '1115050029',
    districtId: '1115050',
    name: 'Kabu Tunong',
  },
  {
    id: '1115050030',
    districtId: '1115050',
    name: 'Cot Gud',
  },
  {
    id: '1115050031',
    districtId: '1115050',
    name: 'Pulo Teungoh',
  },
  {
    id: '1115050032',
    districtId: '1115050',
    name: 'Kila',
  },
  {
    id: '1115050033',
    districtId: '1115050',
    name: 'Kandeh',
  },
  {
    id: '1115050034',
    districtId: '1115050',
    name: 'Blang Tengku',
  },
  {
    id: '1116010001',
    districtId: '1116010',
    name: 'Lueng Gayo',
  },
  {
    id: '1116010002',
    districtId: '1116010',
    name: 'Cot Trap',
  },
  {
    id: '1116010003',
    districtId: '1116010',
    name: 'Pasi Geulima',
  },
  {
    id: '1116010004',
    districtId: '1116010',
    name: 'Teupin Ara',
  },
  {
    id: '1116010005',
    districtId: '1116010',
    name: 'Paya Baro',
  },
  {
    id: '1116010006',
    districtId: '1116010',
    name: 'Pasi Tulak Bala',
  },
  {
    id: '1116010007',
    districtId: '1116010',
    name: 'Panton',
  },
  {
    id: '1116010008',
    districtId: '1116010',
    name: 'Gampong Baro',
  },
  {
    id: '1116010009',
    districtId: '1116010',
    name: 'Pasi Pawang',
  },
  {
    id: '1116010010',
    districtId: '1116010',
    name: 'Rambong Payong',
  },
  {
    id: '1116010011',
    districtId: '1116010',
    name: 'Padang Kleng',
  },
  {
    id: '1116010012',
    districtId: '1116010',
    name: 'Keude Teunom',
  },
  {
    id: '1116010013',
    districtId: '1116010',
    name: 'Alue Ambang',
  },
  {
    id: '1116010014',
    districtId: '1116010',
    name: 'Batee-Roo',
  },
  {
    id: '1116010015',
    districtId: '1116010',
    name: 'Tanoh Manyang',
  },
  {
    id: '1116010016',
    districtId: '1116010',
    name: 'Tanoh Anou',
  },
  {
    id: '1116010017',
    districtId: '1116010',
    name: 'Blang Baro',
  },
  {
    id: '1116010019',
    districtId: '1116010',
    name: 'Pasi Timon',
  },
  {
    id: '1116010025',
    districtId: '1116010',
    name: 'Seumira',
  },
  {
    id: '1116010026',
    districtId: '1116010',
    name: 'Seuneubok Padang',
  },
  {
    id: '1116010046',
    districtId: '1116010',
    name: 'Kubu',
  },
  {
    id: '1116010051',
    districtId: '1116010',
    name: 'Alue Meuraksa',
  },
  {
    id: '1116011001',
    districtId: '1116011',
    name: 'Pulo Tinggi',
  },
  {
    id: '1116011002',
    districtId: '1116011',
    name: 'Alue Krueng',
  },
  {
    id: '1116011003',
    districtId: '1116011',
    name: 'Pasi Teubee',
  },
  {
    id: '1116011004',
    districtId: '1116011',
    name: 'Tim Pleung',
  },
  {
    id: '1116011005',
    districtId: '1116011',
    name: 'Krueng Beukah',
  },
  {
    id: '1116011006',
    districtId: '1116011',
    name: 'Tuwi Kareung I',
  },
  {
    id: '1116011007',
    districtId: '1116011',
    name: 'Lhok Guci',
  },
  {
    id: '1116011008',
    districtId: '1116011',
    name: 'Bintah',
  },
  {
    id: '1116011009',
    districtId: '1116011',
    name: 'Tuwi Perya',
  },
  {
    id: '1116011010',
    districtId: '1116011',
    name: 'Alue Punti',
  },
  {
    id: '1116011011',
    districtId: '1116011',
    name: 'Ceuraceu',
  },
  {
    id: '1116011012',
    districtId: '1116011',
    name: 'Alue Jang',
  },
  {
    id: '1116011013',
    districtId: '1116011',
    name: 'Sarah Raya',
  },
  {
    id: '1116011014',
    districtId: '1116011',
    name: 'Buket Kemuneng',
  },
  {
    id: '1116020001',
    districtId: '1116020',
    name: 'Keude Panga',
  },
  {
    id: '1116020002',
    districtId: '1116020',
    name: 'Tuwi Kareung Panga',
  },
  {
    id: '1116020003',
    districtId: '1116020',
    name: 'Kuta Tuha',
  },
  {
    id: '1116020004',
    districtId: '1116020',
    name: 'Ladang Baro',
  },
  {
    id: '1116020005',
    districtId: '1116020',
    name: 'Babah Ceupan',
  },
  {
    id: '1116020006',
    districtId: '1116020',
    name: 'Gampong Harapan',
  },
  {
    id: '1116020007',
    districtId: '1116020',
    name: 'Tuwi Kayee',
  },
  {
    id: '1116020008',
    districtId: '1116020',
    name: 'Panton Kabu',
  },
  {
    id: '1116020009',
    districtId: '1116020',
    name: 'Alue Teungoh',
  },
  {
    id: '1116020010',
    districtId: '1116020',
    name: 'Panton Krueng',
  },
  {
    id: '1116020011',
    districtId: '1116020',
    name: 'Alue Pande',
  },
  {
    id: '1116020012',
    districtId: '1116020',
    name: 'Batee Meutudong',
  },
  {
    id: '1116020013',
    districtId: '1116020',
    name: 'Gleputoh',
  },
  {
    id: '1116020014',
    districtId: '1116020',
    name: 'Alue Raya',
  },
  {
    id: '1116020015',
    districtId: '1116020',
    name: 'Alue Abet',
  },
  {
    id: '1116020016',
    districtId: '1116020',
    name: 'Gunong Mantok',
  },
  {
    id: '1116020017',
    districtId: '1116020',
    name: 'Tuwi Empeuk',
  },
  {
    id: '1116020018',
    districtId: '1116020',
    name: 'Gunong Meulinteung',
  },
  {
    id: '1116020019',
    districtId: '1116020',
    name: 'Gunong Buloh',
  },
  {
    id: '1116020020',
    districtId: '1116020',
    name: 'Alue Piet',
  },
  {
    id: '1116030001',
    districtId: '1116030',
    name: 'Bahagia',
  },
  {
    id: '1116030002',
    districtId: '1116030',
    name: 'Sentosa',
  },
  {
    id: '1116030003',
    districtId: '1116030',
    name: 'Dayah Baro',
  },
  {
    id: '1116030004',
    districtId: '1116030',
    name: 'Kampung Blang',
  },
  {
    id: '1116030005',
    districtId: '1116030',
    name: 'Panton Makmur',
  },
  {
    id: '1116030006',
    districtId: '1116030',
    name: 'Keutapang',
  },
  {
    id: '1116030007',
    districtId: '1116030',
    name: 'Padang Datar',
  },
  {
    id: '1116030008',
    districtId: '1116030',
    name: 'Mon Mata',
  },
  {
    id: '1116030009',
    districtId: '1116030',
    name: 'Keude Krueng Sabee',
  },
  {
    id: '1116030010',
    districtId: '1116030',
    name: 'Kabong',
  },
  {
    id: '1116030011',
    districtId: '1116030',
    name: 'Datar Luas',
  },
  {
    id: '1116030012',
    districtId: '1116030',
    name: 'Paya Seumantok',
  },
  {
    id: '1116030013',
    districtId: '1116030',
    name: 'Ranto Panyang',
  },
  {
    id: '1116030014',
    districtId: '1116030',
    name: 'Curek',
  },
  {
    id: '1116030015',
    districtId: '1116030',
    name: 'Alue Tho',
  },
  {
    id: '1116030016',
    districtId: '1116030',
    name: 'Buntha',
  },
  {
    id: '1116030017',
    districtId: '1116030',
    name: 'Panggong',
  },
  {
    id: '1116040001',
    districtId: '1116040',
    name: 'Sawang',
  },
  {
    id: '1116040002',
    districtId: '1116040',
    name: 'Lhok Geulumpang',
  },
  {
    id: '1116040003',
    districtId: '1116040',
    name: 'Lhok Timon',
  },
  {
    id: '1116040004',
    districtId: '1116040',
    name: 'Gampong Baro',
  },
  {
    id: '1116040005',
    districtId: '1116040',
    name: 'Lhok Buya',
  },
  {
    id: '1116040006',
    districtId: '1116040',
    name: 'Lhok Bot',
  },
  {
    id: '1116040007',
    districtId: '1116040',
    name: 'Padang',
  },
  {
    id: '1116040008',
    districtId: '1116040',
    name: 'Gunong Meunasah',
  },
  {
    id: '1116040009',
    districtId: '1116040',
    name: 'Paya Laut',
  },
  {
    id: '1116040010',
    districtId: '1116040',
    name: 'Sapek',
  },
  {
    id: '1116040011',
    districtId: '1116040',
    name: 'Gampong Baroh',
  },
  {
    id: '1116040012',
    districtId: '1116040',
    name: 'Gle Subak',
  },
  {
    id: '1116040013',
    districtId: '1116040',
    name: 'Pante Kuyun',
  },
  {
    id: '1116050004',
    districtId: '1116050',
    name: 'Kuala Bakong',
  },
  {
    id: '1116050009',
    districtId: '1116050',
    name: 'Cot Langsat',
  },
  {
    id: '1116050010',
    districtId: '1116050',
    name: 'Mataie',
  },
  {
    id: '1116050011',
    districtId: '1116050',
    name: 'Jeumpheuk',
  },
  {
    id: '1116050012',
    districtId: '1116050',
    name: 'Babah Nipah',
  },
  {
    id: '1116050013',
    districtId: '1116050',
    name: 'Kuala Ligan',
  },
  {
    id: '1116050014',
    districtId: '1116050',
    name: 'Seumantok',
  },
  {
    id: '1116050027',
    districtId: '1116050',
    name: 'Krueng Ayon',
  },
  {
    id: '1116050028',
    districtId: '1116050',
    name: 'Cot Punti',
  },
  {
    id: '1116050029',
    districtId: '1116050',
    name: 'Ligan',
  },
  {
    id: '1116050030',
    districtId: '1116050',
    name: 'Lhok Kruet',
  },
  {
    id: '1116050031',
    districtId: '1116050',
    name: 'Pulo Raya',
  },
  {
    id: '1116050032',
    districtId: '1116050',
    name: 'Krueng No',
  },
  {
    id: '1116050033',
    districtId: '1116050',
    name: 'Crak Mong',
  },
  {
    id: '1116050034',
    districtId: '1116050',
    name: 'Meunasah Kulam',
  },
  {
    id: '1116050035',
    districtId: '1116050',
    name: 'Blang Monlung',
  },
  {
    id: '1116050036',
    districtId: '1116050',
    name: 'Alue Gro',
  },
  {
    id: '1116050037',
    districtId: '1116050',
    name: 'Ie Jeureungeh',
  },
  {
    id: '1116050038',
    districtId: '1116050',
    name: 'Ranto Sabon',
  },
  {
    id: '1116051001',
    districtId: '1116051',
    name: 'Patek',
  },
  {
    id: '1116051002',
    districtId: '1116051',
    name: 'Blang Dalam',
  },
  {
    id: '1116051003',
    districtId: '1116051',
    name: 'Gampong Baro P',
  },
  {
    id: '1116051004',
    districtId: '1116051',
    name: 'Pajar',
  },
  {
    id: '1116051005',
    districtId: '1116051',
    name: 'Reuntang',
  },
  {
    id: '1116051006',
    districtId: '1116051',
    name: 'Cot Pange',
  },
  {
    id: '1116051007',
    districtId: '1116051',
    name: 'Arongan',
  },
  {
    id: '1116051008',
    districtId: '1116051',
    name: 'Krueng Tho',
  },
  {
    id: '1116051009',
    districtId: '1116051',
    name: 'Panton Krueng',
  },
  {
    id: '1116051010',
    districtId: '1116051',
    name: 'Paya Santeut',
  },
  {
    id: '1116051011',
    districtId: '1116051',
    name: 'Lam Teungoh',
  },
  {
    id: '1116051012',
    districtId: '1116051',
    name: 'Ujong Rimba',
  },
  {
    id: '1116051013',
    districtId: '1116051',
    name: 'Gunung Cut',
  },
  {
    id: '1116051014',
    districtId: '1116051',
    name: 'Sayeung',
  },
  {
    id: '1116051015',
    districtId: '1116051',
    name: 'Babah Dua',
  },
  {
    id: '1116051016',
    districtId: '1116051',
    name: 'Gampong Baro L',
  },
  {
    id: '1116051017',
    districtId: '1116051',
    name: 'Alue Gajah',
  },
  {
    id: '1116051018',
    districtId: '1116051',
    name: 'Masen',
  },
  {
    id: '1116051019',
    districtId: '1116051',
    name: 'Teupin Asan',
  },
  {
    id: '1116060011',
    districtId: '1116060',
    name: 'Meutara',
  },
  {
    id: '1116060015',
    districtId: '1116060',
    name: 'Lhuet',
  },
  {
    id: '1116060016',
    districtId: '1116060',
    name: 'Lamme',
  },
  {
    id: '1116060017',
    districtId: '1116060',
    name: 'Seureuba',
  },
  {
    id: '1116060018',
    districtId: '1116060',
    name: 'Leupe',
  },
  {
    id: '1116060020',
    districtId: '1116060',
    name: 'Nusa',
  },
  {
    id: '1116060021',
    districtId: '1116060',
    name: 'Rumpet',
  },
  {
    id: '1116060022',
    districtId: '1116060',
    name: 'Darat',
  },
  {
    id: '1116060023',
    districtId: '1116060',
    name: 'Gle Jong',
  },
  {
    id: '1116060024',
    districtId: '1116060',
    name: 'Gampong Baro',
  },
  {
    id: '1116060025',
    districtId: '1116060',
    name: 'Meunasah Weh',
  },
  {
    id: '1116060026',
    districtId: '1116060',
    name: 'Cot Dulang',
  },
  {
    id: '1116060027',
    districtId: '1116060',
    name: 'Putue',
  },
  {
    id: '1116060028',
    districtId: '1116060',
    name: 'Lam Durian',
  },
  {
    id: '1116060029',
    districtId: '1116060',
    name: 'Babah Krueng',
  },
  {
    id: '1116060030',
    districtId: '1116060',
    name: 'Bak Paoh',
  },
  {
    id: '1116060031',
    districtId: '1116060',
    name: 'Pasar Lamno',
  },
  {
    id: '1116060032',
    districtId: '1116060',
    name: 'Pante Keutapang',
  },
  {
    id: '1116060033',
    districtId: '1116060',
    name: 'Panton Makmur',
  },
  {
    id: '1116060034',
    districtId: '1116060',
    name: 'Krueng Tunong',
  },
  {
    id: '1116060035',
    districtId: '1116060',
    name: 'Lamtui',
  },
  {
    id: '1116060036',
    districtId: '1116060',
    name: 'Jambo Masi',
  },
  {
    id: '1116060037',
    districtId: '1116060',
    name: 'Lambaroh',
  },
  {
    id: '1116060038',
    districtId: '1116060',
    name: 'Gle Putoh',
  },
  {
    id: '1116060039',
    districtId: '1116060',
    name: 'Alue Rayeuk',
  },
  {
    id: '1116060040',
    districtId: '1116060',
    name: 'Mareu',
  },
  {
    id: '1116060041',
    districtId: '1116060',
    name: 'Sabet',
  },
  {
    id: '1116060042',
    districtId: '1116060',
    name: 'Pante Cermin',
  },
  {
    id: '1116060043',
    districtId: '1116060',
    name: 'Sango',
  },
  {
    id: '1116060044',
    districtId: '1116060',
    name: 'Lamasan',
  },
  {
    id: '1116060045',
    districtId: '1116060',
    name: 'Ujong Sudeun',
  },
  {
    id: '1116060046',
    districtId: '1116060',
    name: 'Babah Ie',
  },
  {
    id: '1116060047',
    districtId: '1116060',
    name: 'Meudheun',
  },
  {
    id: '1116060048',
    districtId: '1116060',
    name: 'Sapek',
  },
  {
    id: '1116061001',
    districtId: '1116061',
    name: 'Ceunamprong',
  },
  {
    id: '1116061002',
    districtId: '1116061',
    name: 'Keude Unga',
  },
  {
    id: '1116061003',
    districtId: '1116061',
    name: 'Kareng Ateuh',
  },
  {
    id: '1116061004',
    districtId: '1116061',
    name: 'Meudang Ghon',
  },
  {
    id: '1116061005',
    districtId: '1116061',
    name: 'Ujong Muloh',
  },
  {
    id: '1116061006',
    districtId: '1116061',
    name: 'Kuala',
  },
  {
    id: '1116061007',
    districtId: '1116061',
    name: 'Teumareum',
  },
  {
    id: '1116061008',
    districtId: '1116061',
    name: 'Jangeut',
  },
  {
    id: '1116061009',
    districtId: '1116061',
    name: 'Alue Mie',
  },
  {
    id: '1116061010',
    districtId: '1116061',
    name: 'Babah Dua',
  },
  {
    id: '1116061011',
    districtId: '1116061',
    name: 'Meunasah Tutong',
  },
  {
    id: '1116061012',
    districtId: '1116061',
    name: 'Meunasah Teungoh',
  },
  {
    id: '1116061013',
    districtId: '1116061',
    name: 'Meunasah Rayeuk',
  },
  {
    id: '1116061014',
    districtId: '1116061',
    name: 'Mukhan',
  },
  {
    id: '1117010003',
    districtId: '1117010',
    name: 'Bandar Lampahan',
  },
  {
    id: '1117010004',
    districtId: '1117010',
    name: 'Karang Jadi',
  },
  {
    id: '1117010005',
    districtId: '1117010',
    name: 'Lampahan',
  },
  {
    id: '1117010006',
    districtId: '1117010',
    name: 'Suka Damai',
  },
  {
    id: '1117010007',
    districtId: '1117010',
    name: 'Blang Rongka',
  },
  {
    id: '1117010008',
    districtId: '1117010',
    name: 'Tunyang',
  },
  {
    id: '1117010012',
    districtId: '1117010',
    name: 'Setie',
  },
  {
    id: '1117010014',
    districtId: '1117010',
    name: 'Simpang Layang',
  },
  {
    id: '1117010015',
    districtId: '1117010',
    name: 'Gegur Sepakat',
  },
  {
    id: '1117010016',
    districtId: '1117010',
    name: 'Cekal Baru',
  },
  {
    id: '1117010019',
    districtId: '1117010',
    name: 'Damaran Baru',
  },
  {
    id: '1117010020',
    districtId: '1117010',
    name: 'Pajar Harapan',
  },
  {
    id: '1117010021',
    districtId: '1117010',
    name: 'Kenine',
  },
  {
    id: '1117010022',
    districtId: '1117010',
    name: 'Rembune',
  },
  {
    id: '1117010023',
    districtId: '1117010',
    name: 'Bumi Ayu',
  },
  {
    id: '1117010024',
    districtId: '1117010',
    name: 'Kampung Baru',
  },
  {
    id: '1117010025',
    districtId: '1117010',
    name: 'Mude Benara',
  },
  {
    id: '1117010026',
    districtId: '1117010',
    name: 'Pantan Pediangan',
  },
  {
    id: '1117010027',
    districtId: '1117010',
    name: 'Lampahan Barat',
  },
  {
    id: '1117010028',
    districtId: '1117010',
    name: 'Mekar Ayu',
  },
  {
    id: '1117010029',
    districtId: '1117010',
    name: 'Lampahan Timur',
  },
  {
    id: '1117010030',
    districtId: '1117010',
    name: 'Kolam Para Kanis',
  },
  {
    id: '1117010031',
    districtId: '1117010',
    name: 'Timang Rasa',
  },
  {
    id: '1117010032',
    districtId: '1117010',
    name: 'Bukit Mulie',
  },
  {
    id: '1117010033',
    districtId: '1117010',
    name: 'Sumber Jaya',
  },
  {
    id: '1117010034',
    districtId: '1117010',
    name: 'Gunung Tunyang',
  },
  {
    id: '1117010035',
    districtId: '1117010',
    name: 'Datu Beru Tunyang',
  },
  {
    id: '1117010036',
    districtId: '1117010',
    name: 'Pantan Kemuning',
  },
  {
    id: '1117010037',
    districtId: '1117010',
    name: 'Bukit Tunyang',
  },
  {
    id: '1117010038',
    districtId: '1117010',
    name: 'Linung Bale',
  },
  {
    id: '1117011001',
    districtId: '1117011',
    name: 'Timang Gajah',
  },
  {
    id: '1117011002',
    districtId: '1117011',
    name: 'Reronga',
  },
  {
    id: '1117011003',
    districtId: '1117011',
    name: 'Pantan Lues',
  },
  {
    id: '1117011004',
    districtId: '1117011',
    name: 'Meriah Jaya',
  },
  {
    id: '1117011005',
    districtId: '1117011',
    name: 'Umah Besi',
  },
  {
    id: '1117011006',
    districtId: '1117011',
    name: 'Pante Karya',
  },
  {
    id: '1117011007',
    districtId: '1117011',
    name: 'Simpang Rahmat',
  },
  {
    id: '1117011008',
    districtId: '1117011',
    name: 'Gajah Putih',
  },
  {
    id: '1117011009',
    districtId: '1117011',
    name: 'Gayo Setie',
  },
  {
    id: '1117011010',
    districtId: '1117011',
    name: 'Alam Jaya',
  },
  {
    id: '1117020001',
    districtId: '1117020',
    name: 'Rime Raya',
  },
  {
    id: '1117020002',
    districtId: '1117020',
    name: 'Singah Mulo',
  },
  {
    id: '1117020003',
    districtId: '1117020',
    name: 'Alur Gading',
  },
  {
    id: '1117020004',
    districtId: '1117020',
    name: 'Blang Rakal',
  },
  {
    id: '1117020005',
    districtId: '1117020',
    name: 'Negeri Antara',
  },
  {
    id: '1117020006',
    districtId: '1117020',
    name: 'Blang Ara',
  },
  {
    id: '1117020007',
    districtId: '1117020',
    name: 'Gemasih',
  },
  {
    id: '1117020008',
    districtId: '1117020',
    name: 'Pulo Intan',
  },
  {
    id: '1117020009',
    districtId: '1117020',
    name: 'Rata Ara',
  },
  {
    id: '1117020010',
    districtId: '1117020',
    name: 'Musara 58',
  },
  {
    id: '1117020011',
    districtId: '1117020',
    name: 'Musara Pakat',
  },
  {
    id: '1117020012',
    districtId: '1117020',
    name: 'Weh Porak',
  },
  {
    id: '1117020013',
    districtId: '1117020',
    name: 'Simpang Lancang',
  },
  {
    id: '1117020014',
    districtId: '1117020',
    name: 'Bener Meriah',
  },
  {
    id: '1117020015',
    districtId: '1117020',
    name: 'Perdamaian',
  },
  {
    id: '1117020016',
    districtId: '1117020',
    name: 'Ulu Naron',
  },
  {
    id: '1117020017',
    districtId: '1117020',
    name: 'Taman Firdaus',
  },
  {
    id: '1117020018',
    districtId: '1117020',
    name: 'Bintang Berangun',
  },
  {
    id: '1117020019',
    districtId: '1117020',
    name: 'Uning Emas',
  },
  {
    id: '1117020020',
    districtId: '1117020',
    name: 'Pancar Jelobok',
  },
  {
    id: '1117020021',
    districtId: '1117020',
    name: 'Alur Cincin',
  },
  {
    id: '1117020022',
    districtId: '1117020',
    name: 'Pantan Sinaku',
  },
  {
    id: '1117020023',
    districtId: '1117020',
    name: 'Pantan Lah',
  },
  {
    id: '1117030002',
    districtId: '1117030',
    name: 'Blang Tampu',
  },
  {
    id: '1117030003',
    districtId: '1117030',
    name: 'Uning Bersah',
  },
  {
    id: '1117030004',
    districtId: '1117030',
    name: 'Uning Teritit',
  },
  {
    id: '1117030005',
    districtId: '1117030',
    name: 'Kute Lintang',
  },
  {
    id: '1117030006',
    districtId: '1117030',
    name: 'Tingkem Bersatu',
  },
  {
    id: '1117030007',
    districtId: '1117030',
    name: 'Tingkem Asli',
  },
  {
    id: '1117030008',
    districtId: '1117030',
    name: 'Reje Guru',
  },
  {
    id: '1117030009',
    districtId: '1117030',
    name: 'Blang Sentang',
  },
  {
    id: '1117030010',
    districtId: '1117030',
    name: 'Pasar Simpang Tiga',
  },
  {
    id: '1117030011',
    districtId: '1117030',
    name: 'Bale Redelong',
  },
  {
    id: '1117030012',
    districtId: '1117030',
    name: 'Ujung Gele',
  },
  {
    id: '1117030013',
    districtId: '1117030',
    name: 'Delung Tue',
  },
  {
    id: '1117030014',
    districtId: '1117030',
    name: 'Kenawat Redelong',
  },
  {
    id: '1117030015',
    districtId: '1117030',
    name: 'Blang Ara',
  },
  {
    id: '1117030016',
    districtId: '1117030',
    name: 'Waq Pondok Sayur',
  },
  {
    id: '1117030017',
    districtId: '1117030',
    name: 'Panji Mulia II',
  },
  {
    id: '1117030018',
    districtId: '1117030',
    name: 'Panji Mulia  I',
  },
  {
    id: '1117030019',
    districtId: '1117030',
    name: 'Isaq Busur',
  },
  {
    id: '1117030020',
    districtId: '1117030',
    name: 'Bujang',
  },
  {
    id: '1117030021',
    districtId: '1117030',
    name: 'Hakim Tunggul Naru',
  },
  {
    id: '1117030022',
    districtId: '1117030',
    name: 'Bale Atu',
  },
  {
    id: '1117030033',
    districtId: '1117030',
    name: 'Tingkem Benyer',
  },
  {
    id: '1117030034',
    districtId: '1117030',
    name: 'Bantin Wih Pongas',
  },
  {
    id: '1117030035',
    districtId: '1117030',
    name: 'Sedia Jadi',
  },
  {
    id: '1117030036',
    districtId: '1117030',
    name: 'Rembele',
  },
  {
    id: '1117030037',
    districtId: '1117030',
    name: 'Mutiara Baru',
  },
  {
    id: '1117030038',
    districtId: '1117030',
    name: 'Blang Panas',
  },
  {
    id: '1117030039',
    districtId: '1117030',
    name: 'Bukit Bersatu',
  },
  {
    id: '1117030040',
    districtId: '1117030',
    name: 'Serule Kayu',
  },
  {
    id: '1117030041',
    districtId: '1117030',
    name: 'Kute Kering',
  },
  {
    id: '1117030042',
    districtId: '1117030',
    name: 'Kute Tanyung',
  },
  {
    id: '1117030043',
    districtId: '1117030',
    name: 'Babussalam',
  },
  {
    id: '1117030044',
    districtId: '1117030',
    name: 'Paya Gajah',
  },
  {
    id: '1117030045',
    districtId: '1117030',
    name: 'Delung Asli',
  },
  {
    id: '1117030046',
    districtId: '1117030',
    name: 'Pilar Jaya',
  },
  {
    id: '1117030047',
    districtId: '1117030',
    name: 'Meluem',
  },
  {
    id: '1117030048',
    districtId: '1117030',
    name: 'Mupakat Jadi',
  },
  {
    id: '1117030049',
    districtId: '1117030',
    name: 'Godang',
  },
  {
    id: '1117030050',
    districtId: '1117030',
    name: 'Uring',
  },
  {
    id: '1117030051',
    districtId: '1117030',
    name: 'Karang Rejo',
  },
  {
    id: '1117040001',
    districtId: '1117040',
    name: 'Simpang Teritit',
  },
  {
    id: '1117040003',
    districtId: '1117040',
    name: 'Sukarame Atas',
  },
  {
    id: '1117040004',
    districtId: '1117040',
    name: 'Sukarame Bawah',
  },
  {
    id: '1117040005',
    districtId: '1117040',
    name: 'Syura Jadi',
  },
  {
    id: '1117040006',
    districtId: '1117040',
    name: 'Pante Raya',
  },
  {
    id: '1117040007',
    districtId: '1117040',
    name: 'Simpang Balek',
  },
  {
    id: '1117040008',
    districtId: '1117040',
    name: 'Suka Jadi',
  },
  {
    id: '1117040009',
    districtId: '1117040',
    name: 'Bener Ayu',
  },
  {
    id: '1117040010',
    districtId: '1117040',
    name: 'Blang Paku',
  },
  {
    id: '1117040011',
    districtId: '1117040',
    name: 'Suka Makmur',
  },
  {
    id: '1117040012',
    districtId: '1117040',
    name: 'Merie I',
  },
  {
    id: '1117040013',
    districtId: '1117040',
    name: 'Jamur Uluh',
  },
  {
    id: '1117040014',
    districtId: '1117040',
    name: 'Gegerung',
  },
  {
    id: '1117040015',
    districtId: '1117040',
    name: 'Bukit Pepanyi',
  },
  {
    id: '1117040016',
    districtId: '1117040',
    name: 'Jamur Ujung',
  },
  {
    id: '1117040017',
    districtId: '1117040',
    name: 'Wonosobo',
  },
  {
    id: '1117040018',
    districtId: '1117040',
    name: 'Lut Kucak',
  },
  {
    id: '1117040019',
    districtId: '1117040',
    name: 'Wih Pesam',
  },
  {
    id: '1117040020',
    districtId: '1117040',
    name: 'Cinta Damai',
  },
  {
    id: '1117040021',
    districtId: '1117040',
    name: 'Bener Mulie',
  },
  {
    id: '1117040022',
    districtId: '1117040',
    name: 'Kebun Baru',
  },
  {
    id: '1117040023',
    districtId: '1117040',
    name: 'Blang Kucak',
  },
  {
    id: '1117040024',
    districtId: '1117040',
    name: 'Simpang Antara',
  },
  {
    id: '1117040025',
    districtId: '1117040',
    name: 'Blang Benara',
  },
  {
    id: '1117040026',
    districtId: '1117040',
    name: 'Suka Makmur Timur',
  },
  {
    id: '1117040027',
    districtId: '1117040',
    name: 'Burni Telong',
  },
  {
    id: '1117040028',
    districtId: '1117040',
    name: 'Mekar Jadi Ayu',
  },
  {
    id: '1117050001',
    districtId: '1117050',
    name: 'Wonosari',
  },
  {
    id: '1117050002',
    districtId: '1117050',
    name: 'Paya Baning',
  },
  {
    id: '1117050003',
    districtId: '1117050',
    name: 'Blang Pulo',
  },
  {
    id: '1117050011',
    districtId: '1117050',
    name: 'Petukel Blang Jorong',
  },
  {
    id: '1117050012',
    districtId: '1117050',
    name: 'Tanjung Pura',
  },
  {
    id: '1117050013',
    districtId: '1117050',
    name: 'Hakim Wih Ilang',
  },
  {
    id: '1117050014',
    districtId: '1117050',
    name: 'Lewa Jadi',
  },
  {
    id: '1117050015',
    districtId: '1117050',
    name: 'Bukit Wih Ilang',
  },
  {
    id: '1117050016',
    districtId: '1117050',
    name: 'Suku Wih Ilang',
  },
  {
    id: '1117050017',
    districtId: '1117050',
    name: 'Pondok Gajah',
  },
  {
    id: '1117050018',
    districtId: '1117050',
    name: 'Purwosari',
  },
  {
    id: '1117050019',
    districtId: '1117050',
    name: 'Sidodadi',
  },
  {
    id: '1117050020',
    districtId: '1117050',
    name: 'Selamat Rejo',
  },
  {
    id: '1117050021',
    districtId: '1117050',
    name: 'Pondok Ulung',
  },
  {
    id: '1117050022',
    districtId: '1117050',
    name: 'Janarata',
  },
  {
    id: '1117050023',
    districtId: '1117050',
    name: 'Batin Baru',
  },
  {
    id: '1117050033',
    districtId: '1117050',
    name: 'Muyang Kute Mangku',
  },
  {
    id: '1117050034',
    districtId: '1117050',
    name: 'Keramat Jaya',
  },
  {
    id: '1117050035',
    districtId: '1117050',
    name: 'Simpang Utama',
  },
  {
    id: '1117050038',
    districtId: '1117050',
    name: 'Pakat Jeroh',
  },
  {
    id: '1117050039',
    districtId: '1117050',
    name: 'Puja Mulia',
  },
  {
    id: '1117050040',
    districtId: '1117050',
    name: 'Pondok Baru',
  },
  {
    id: '1117050041',
    districtId: '1117050',
    name: 'Bahgie Bertona',
  },
  {
    id: '1117050044',
    districtId: '1117050',
    name: 'Tansaran Bidin',
  },
  {
    id: '1117050045',
    districtId: '1117050',
    name: 'Sinar Jaya Paya Ringkel',
  },
  {
    id: '1117050046',
    districtId: '1117050',
    name: 'Remang Ketike Jaya',
  },
  {
    id: '1117050047',
    districtId: '1117050',
    name: 'Gunung Antara',
  },
  {
    id: '1117050048',
    districtId: '1117050',
    name: 'Gele Semayang',
  },
  {
    id: '1117050049',
    districtId: '1117050',
    name: 'Makmur Sentosa',
  },
  {
    id: '1117050050',
    districtId: '1117050',
    name: 'Tawar Sedenge',
  },
  {
    id: '1117050051',
    districtId: '1117050',
    name: 'Jadi Sepakat',
  },
  {
    id: '1117050052',
    districtId: '1117050',
    name: 'Selisih Mara',
  },
  {
    id: '1117050053',
    districtId: '1117050',
    name: 'Kala Nempan',
  },
  {
    id: '1117050054',
    districtId: '1117050',
    name: 'Mutiara',
  },
  {
    id: '1117050060',
    districtId: '1117050',
    name: 'Beranun Teleden',
  },
  {
    id: '1117051001',
    districtId: '1117051',
    name: 'Bener Lukup II',
  },
  {
    id: '1117051002',
    districtId: '1117051',
    name: 'Bener Kelipah Utara',
  },
  {
    id: '1117051003',
    districtId: '1117051',
    name: 'Bener Kelipah Selatan',
  },
  {
    id: '1117051004',
    districtId: '1117051',
    name: 'Bintang Musara',
  },
  {
    id: '1117051005',
    districtId: '1117051',
    name: 'Bandar Jaya',
  },
  {
    id: '1117051006',
    districtId: '1117051',
    name: 'Nosar Tawar Jaya',
  },
  {
    id: '1117051007',
    districtId: '1117051',
    name: 'Jongok Meluem',
  },
  {
    id: '1117051008',
    districtId: '1117051',
    name: 'Suku Bener',
  },
  {
    id: '1117051009',
    districtId: '1117051',
    name: 'Lot Bener Kelipah',
  },
  {
    id: '1117051010',
    districtId: '1117051',
    name: 'Kala Tenang',
  },
  {
    id: '1117051011',
    districtId: '1117051',
    name: 'Gunung Musara',
  },
  {
    id: '1117051012',
    districtId: '1117051',
    name: 'Nosar Baru',
  },
  {
    id: '1117060001',
    districtId: '1117060',
    name: 'Tembolon',
  },
  {
    id: '1117060002',
    districtId: '1117060',
    name: 'Wih Nidurin',
  },
  {
    id: '1117060003',
    districtId: '1117060',
    name: 'Kute Lah Lane',
  },
  {
    id: '1117060004',
    districtId: '1117060',
    name: 'Payung',
  },
  {
    id: '1117060007',
    districtId: '1117060',
    name: 'Kerlang',
  },
  {
    id: '1117060008',
    districtId: '1117060',
    name: 'Gerpa',
  },
  {
    id: '1117060009',
    districtId: '1117060',
    name: 'Goneng',
  },
  {
    id: '1117060010',
    districtId: '1117060',
    name: 'Blang Panu',
  },
  {
    id: '1117060011',
    districtId: '1117060',
    name: 'Rusip',
  },
  {
    id: '1117060015',
    districtId: '1117060',
    name: 'Uning',
  },
  {
    id: '1117060016',
    districtId: '1117060',
    name: 'Pasir Putih',
  },
  {
    id: '1117060027',
    districtId: '1117060',
    name: 'Rata Mulie',
  },
  {
    id: '1117060028',
    districtId: '1117060',
    name: 'Tempen Baru',
  },
  {
    id: '1117060029',
    districtId: '1117060',
    name: 'Geruti Jaya',
  },
  {
    id: '1117061001',
    districtId: '1117061',
    name: 'Cemparam Jaya',
  },
  {
    id: '1117061002',
    districtId: '1117061',
    name: 'Jamur Atu',
  },
  {
    id: '1117061003',
    districtId: '1117061',
    name: 'Gunung Sayang',
  },
  {
    id: '1117061004',
    districtId: '1117061',
    name: 'Wih Resap',
  },
  {
    id: '1117061005',
    districtId: '1117061',
    name: 'Simpur',
  },
  {
    id: '1117061006',
    districtId: '1117061',
    name: 'Amor',
  },
  {
    id: '1117061007',
    districtId: '1117061',
    name: 'Buntul Gayo',
  },
  {
    id: '1117061008',
    districtId: '1117061',
    name: 'Wer Tingkem',
  },
  {
    id: '1117061009',
    districtId: '1117061',
    name: 'Hakim Peteri Pintu',
  },
  {
    id: '1117061010',
    districtId: '1117061',
    name: 'Perumpakan Benjadi',
  },
  {
    id: '1117061011',
    districtId: '1117061',
    name: 'Cemparam Lama',
  },
  {
    id: '1117061012',
    districtId: '1117061',
    name: 'Cemparam Pakat Jeroh',
  },
  {
    id: '1117061013',
    districtId: '1117061',
    name: 'Simpang Renggali',
  },
  {
    id: '1117061014',
    districtId: '1117061',
    name: 'Sosial',
  },
  {
    id: '1117061015',
    districtId: '1117061',
    name: 'Pantan Kuli',
  },
  {
    id: '1117070001',
    districtId: '1117070',
    name: 'Pantan Tengah Jaya',
  },
  {
    id: '1117070002',
    districtId: '1117070',
    name: 'Bener Pepanyi',
  },
  {
    id: '1117070003',
    districtId: '1117070',
    name: 'Bintang Bener',
  },
  {
    id: '1117070004',
    districtId: '1117070',
    name: 'Bintang Permata',
  },
  {
    id: '1117070005',
    districtId: '1117070',
    name: 'Buntul Peteri',
  },
  {
    id: '1117070006',
    districtId: '1117070',
    name: 'Gelampang',
  },
  {
    id: '1117070007',
    districtId: '1117070',
    name: 'Seni Antara',
  },
  {
    id: '1117070008',
    districtId: '1117070',
    name: 'Weh Tenang Uken',
  },
  {
    id: '1117070009',
    districtId: '1117070',
    name: 'Darul Aman',
  },
  {
    id: '1117070010',
    districtId: '1117070',
    name: 'Penosan Jaya',
  },
  {
    id: '1117070011',
    districtId: '1117070',
    name: 'Ramung Jaya',
  },
  {
    id: '1117070012',
    districtId: '1117070',
    name: 'Temas Mumanang',
  },
  {
    id: '1117070013',
    districtId: '1117070',
    name: 'Weh Tenang Tua',
  },
  {
    id: '1117070014',
    districtId: '1117070',
    name: 'Ayu Ara',
  },
  {
    id: '1117070015',
    districtId: '1117070',
    name: 'Bale Musara',
  },
  {
    id: '1117070016',
    districtId: '1117070',
    name: 'Bale Purnama',
  },
  {
    id: '1117070017',
    districtId: '1117070',
    name: 'Burni Pase',
  },
  {
    id: '1117070018',
    districtId: '1117070',
    name: 'Kepies',
  },
  {
    id: '1117070019',
    districtId: '1117070',
    name: 'Rikit Musara',
  },
  {
    id: '1117070020',
    districtId: '1117070',
    name: 'Ceding Ayu',
  },
  {
    id: '1117070021',
    districtId: '1117070',
    name: 'Jungke Gajah',
  },
  {
    id: '1117070022',
    districtId: '1117070',
    name: 'Jelobok',
  },
  {
    id: '1117070023',
    districtId: '1117070',
    name: 'Pemango',
  },
  {
    id: '1117070024',
    districtId: '1117070',
    name: 'Suku Sara Tangke',
  },
  {
    id: '1117070025',
    districtId: '1117070',
    name: 'Tawar Bengi',
  },
  {
    id: '1117070026',
    districtId: '1117070',
    name: 'Uning Sejuk',
  },
  {
    id: '1117070027',
    districtId: '1117070',
    name: 'Timur Jaya',
  },
  {
    id: '1118010001',
    districtId: '1118010',
    name: 'Mns Mulieng',
  },
  {
    id: '1118010002',
    districtId: '1118010',
    name: 'Lampoih Lada',
  },
  {
    id: '1118010003',
    districtId: '1118010',
    name: 'Glumpang Tutong',
  },
  {
    id: '1118010004',
    districtId: '1118010',
    name: 'Rungkom',
  },
  {
    id: '1118010005',
    districtId: '1118010',
    name: 'Blang Awe',
  },
  {
    id: '1118010006',
    districtId: '1118010',
    name: 'Manyang Lancok',
  },
  {
    id: '1118010007',
    districtId: '1118010',
    name: 'Pohroh',
  },
  {
    id: '1118010008',
    districtId: '1118010',
    name: 'Kudrang',
  },
  {
    id: '1118010009',
    districtId: '1118010',
    name: 'Meunasah Hagu',
  },
  {
    id: '1118010010',
    districtId: '1118010',
    name: 'Dayah Tuha',
  },
  {
    id: '1118010011',
    districtId: '1118010',
    name: 'Rumpuen',
  },
  {
    id: '1118010012',
    districtId: '1118010',
    name: 'Meunasah Kulam',
  },
  {
    id: '1118010013',
    districtId: '1118010',
    name: 'Rambong',
  },
  {
    id: '1118010014',
    districtId: '1118010',
    name: 'Grong Grong',
  },
  {
    id: '1118010015',
    districtId: '1118010',
    name: 'Kuta Trieng',
  },
  {
    id: '1118010016',
    districtId: '1118010',
    name: 'Pulo U',
  },
  {
    id: '1118010017',
    districtId: '1118010',
    name: 'Manyang Cut',
  },
  {
    id: '1118010018',
    districtId: '1118010',
    name: 'Beurawang',
  },
  {
    id: '1118010019',
    districtId: '1118010',
    name: 'Dayah Timu',
  },
  {
    id: '1118010020',
    districtId: '1118010',
    name: 'Bunot',
  },
  {
    id: '1118010021',
    districtId: '1118010',
    name: 'Teupin Peuraho',
  },
  {
    id: '1118010022',
    districtId: '1118010',
    name: 'Geuleudah',
  },
  {
    id: '1118010023',
    districtId: '1118010',
    name: 'Meunasah Lhok',
  },
  {
    id: '1118010024',
    districtId: '1118010',
    name: 'Mesjid Tuha',
  },
  {
    id: '1118010025',
    districtId: '1118010',
    name: 'Rhieng Mancang',
  },
  {
    id: '1118010026',
    districtId: '1118010',
    name: 'Rhieng Krueng',
  },
  {
    id: '1118010027',
    districtId: '1118010',
    name: 'Rhieng Blang',
  },
  {
    id: '1118010028',
    districtId: '1118010',
    name: 'Meuraksa',
  },
  {
    id: '1118010029',
    districtId: '1118010',
    name: 'Meunasah Balek',
  },
  {
    id: '1118010030',
    districtId: '1118010',
    name: 'Kota Meureudu',
  },
  {
    id: '1118020001',
    districtId: '1118020',
    name: 'Seunong',
  },
  {
    id: '1118020002',
    districtId: '1118020',
    name: 'Lhok Sandeng',
  },
  {
    id: '1118020003',
    districtId: '1118020',
    name: 'Sarah Mane',
  },
  {
    id: '1118020004',
    districtId: '1118020',
    name: 'Lancok',
  },
  {
    id: '1118020005',
    districtId: '1118020',
    name: 'Meunasah Kulam',
  },
  {
    id: '1118020006',
    districtId: '1118020',
    name: 'Meunasah Teungoh',
  },
  {
    id: '1118020007',
    districtId: '1118020',
    name: 'Geunteng',
  },
  {
    id: '1118020008',
    districtId: '1118020',
    name: 'Meunasah Bie',
  },
  {
    id: '1118020009',
    districtId: '1118020',
    name: 'Meunasah Raya',
  },
  {
    id: '1118020010',
    districtId: '1118020',
    name: 'Gampong Blang',
  },
  {
    id: '1118020011',
    districtId: '1118020',
    name: 'Blang Cut',
  },
  {
    id: '1118020012',
    districtId: '1118020',
    name: 'Meunasah Dayah Usen',
  },
  {
    id: '1118020013',
    districtId: '1118020',
    name: 'Meunasah Mancang',
  },
  {
    id: '1118020014',
    districtId: '1118020',
    name: 'Dayah Kruet',
  },
  {
    id: '1118020015',
    districtId: '1118020',
    name: 'Beuringen',
  },
  {
    id: '1118020016',
    districtId: '1118020',
    name: 'Pante Beureune',
  },
  {
    id: '1118020017',
    districtId: '1118020',
    name: 'Meunasah Jurong',
  },
  {
    id: '1118020018',
    districtId: '1118020',
    name: 'Buangan',
  },
  {
    id: '1118020019',
    districtId: '1118020',
    name: 'Lueng Bimba',
  },
  {
    id: '1118030001',
    districtId: '1118030',
    name: 'Gahru',
  },
  {
    id: '1118030002',
    districtId: '1118030',
    name: 'Kumba',
  },
  {
    id: '1118030003',
    districtId: '1118030',
    name: 'Blang Miroe',
  },
  {
    id: '1118030004',
    districtId: '1118030',
    name: 'Beurasan',
  },
  {
    id: '1118030005',
    districtId: '1118030',
    name: 'Cot Keng',
  },
  {
    id: '1118030006',
    districtId: '1118030',
    name: 'Krueng Kiran',
  },
  {
    id: '1118030007',
    districtId: '1118030',
    name: 'Asan Kumbang',
  },
  {
    id: '1118030008',
    districtId: '1118030',
    name: 'Pulo Gapu',
  },
  {
    id: '1118030009',
    districtId: '1118030',
    name: 'Cot Gurufai',
  },
  {
    id: '1118030010',
    districtId: '1118030',
    name: 'Alue Sane',
  },
  {
    id: '1118030011',
    districtId: '1118030',
    name: 'Lhok Pusong',
  },
  {
    id: '1118030012',
    districtId: '1118030',
    name: 'Alue Keutapang',
  },
  {
    id: '1118030013',
    districtId: '1118030',
    name: 'Jeulanga Barat',
  },
  {
    id: '1118030014',
    districtId: '1118030',
    name: 'Jeulanga Mata Ie',
  },
  {
    id: '1118030015',
    districtId: '1118030',
    name: 'Jeulanga Mesjid',
  },
  {
    id: '1118030016',
    districtId: '1118030',
    name: 'Meunasah Paku',
  },
  {
    id: '1118030017',
    districtId: '1118030',
    name: 'Meurandeh Alue',
  },
  {
    id: '1118030018',
    districtId: '1118030',
    name: 'Reudeup Melayu',
  },
  {
    id: '1118030019',
    districtId: '1118030',
    name: 'Paya Pisang Klat',
  },
  {
    id: '1118030020',
    districtId: '1118030',
    name: 'Alue Mee',
  },
  {
    id: '1118030021',
    districtId: '1118030',
    name: 'Drien Tujoh',
  },
  {
    id: '1118030022',
    districtId: '1118030',
    name: 'Blang Kuta',
  },
  {
    id: '1118030023',
    districtId: '1118030',
    name: 'Seunong',
  },
  {
    id: '1118030024',
    districtId: '1118030',
    name: 'Pohroh',
  },
  {
    id: '1118030025',
    districtId: '1118030',
    name: 'Babah Krueng',
  },
  {
    id: '1118030026',
    districtId: '1118030',
    name: 'Uteun Bayu',
  },
  {
    id: '1118030027',
    districtId: '1118030',
    name: 'Muko Buloh',
  },
  {
    id: '1118030028',
    districtId: '1118030',
    name: 'Drien Bungong',
  },
  {
    id: '1118030029',
    districtId: '1118030',
    name: 'Meugit Sagoe',
  },
  {
    id: '1118030030',
    districtId: '1118030',
    name: 'Meugit Kayee Panyang',
  },
  {
    id: '1118030031',
    districtId: '1118030',
    name: 'Adan',
  },
  {
    id: '1118030032',
    districtId: '1118030',
    name: 'Muko Dayah',
  },
  {
    id: '1118030033',
    districtId: '1118030',
    name: 'Keude Ulee Gle',
  },
  {
    id: '1118030034',
    districtId: '1118030',
    name: 'Pulo',
  },
  {
    id: '1118030035',
    districtId: '1118030',
    name: 'Gampong Baro',
  },
  {
    id: '1118030036',
    districtId: '1118030',
    name: 'Gampong Ulee Gle',
  },
  {
    id: '1118030037',
    districtId: '1118030',
    name: 'Muko Kuthang',
  },
  {
    id: '1118030038',
    districtId: '1118030',
    name: 'Peulakan Tunong',
  },
  {
    id: '1118030039',
    districtId: '1118030',
    name: 'Peulakan Tambo',
  },
  {
    id: '1118030040',
    districtId: '1118030',
    name: 'Kuta Krueng',
  },
  {
    id: '1118030041',
    districtId: '1118030',
    name: 'Paya Tunong',
  },
  {
    id: '1118030042',
    districtId: '1118030',
    name: 'Paya Baroh',
  },
  {
    id: '1118030043',
    districtId: '1118030',
    name: 'Blang Dalam',
  },
  {
    id: '1118030044',
    districtId: '1118030',
    name: 'Mukoe Baroh',
  },
  {
    id: '1118030045',
    districtId: '1118030',
    name: 'Peulakan Cibrek',
  },
  {
    id: '1118040001',
    districtId: '1118040',
    name: 'Meuko Jurong',
  },
  {
    id: '1118040002',
    districtId: '1118040',
    name: 'Buket Teungoh',
  },
  {
    id: '1118040003',
    districtId: '1118040',
    name: 'Jurong Ara',
  },
  {
    id: '1118040004',
    districtId: '1118040',
    name: 'Jurong Teungoh',
  },
  {
    id: '1118040005',
    districtId: '1118040',
    name: 'Jurong Binje',
  },
  {
    id: '1118040006',
    districtId: '1118040',
    name: 'Reului Mangat',
  },
  {
    id: '1118040007',
    districtId: '1118040',
    name: 'Meunasah Mee',
  },
  {
    id: '1118040008',
    districtId: '1118040',
    name: 'Meunasah Kumbang',
  },
  {
    id: '1118040009',
    districtId: '1118040',
    name: 'Kuta Baroh',
  },
  {
    id: '1118040010',
    districtId: '1118040',
    name: 'Meuko Meugit',
  },
  {
    id: '1118040011',
    districtId: '1118040',
    name: 'Keurisi Meunasah Raya',
  },
  {
    id: '1118040012',
    districtId: '1118040',
    name: 'Kiran Dayah',
  },
  {
    id: '1118040013',
    districtId: '1118040',
    name: 'Kiran Baroh',
  },
  {
    id: '1118040014',
    districtId: '1118040',
    name: 'Kiran Krueng',
  },
  {
    id: '1118040015',
    districtId: '1118040',
    name: 'Keurisi Meunasah Lueng',
  },
  {
    id: '1118040016',
    districtId: '1118040',
    name: 'Keude Jangka Buya',
  },
  {
    id: '1118040017',
    districtId: '1118040',
    name: 'Gampong Cot',
  },
  {
    id: '1118040018',
    districtId: '1118040',
    name: 'Keurisi Meunasah Beurembang',
  },
  {
    id: '1118050001',
    districtId: '1118050',
    name: 'Alue Keumiki',
  },
  {
    id: '1118050002',
    districtId: '1118050',
    name: 'Lhok Gajah',
  },
  {
    id: '1118050003',
    districtId: '1118050',
    name: 'Blang Rheue',
  },
  {
    id: '1118050004',
    districtId: '1118050',
    name: 'Cot Seutui',
  },
  {
    id: '1118050005',
    districtId: '1118050',
    name: 'Meunasah Mesjid',
  },
  {
    id: '1118050006',
    districtId: '1118050',
    name: 'Blang Cari',
  },
  {
    id: '1118050007',
    districtId: '1118050',
    name: 'Bidok',
  },
  {
    id: '1118050008',
    districtId: '1118050',
    name: 'Balee Ulim',
  },
  {
    id: '1118050009',
    districtId: '1118050',
    name: 'Pantang Cot Baloi',
  },
  {
    id: '1118050010',
    districtId: '1118050',
    name: 'Nangrhoe Barat',
  },
  {
    id: '1118050011',
    districtId: '1118050',
    name: 'Reuleut',
  },
  {
    id: '1118050012',
    districtId: '1118050',
    name: 'Sambongan Baro',
  },
  {
    id: '1118050013',
    districtId: '1118050',
    name: 'Dayah Baroh',
  },
  {
    id: '1118050014',
    districtId: '1118050',
    name: 'Meunasah Pupu',
  },
  {
    id: '1118050015',
    districtId: '1118050',
    name: 'Nangrhoe Timu',
  },
  {
    id: '1118050016',
    districtId: '1118050',
    name: 'Meunasah Kumbang',
  },
  {
    id: '1118050017',
    districtId: '1118050',
    name: 'Mesjid Ulim Tunong',
  },
  {
    id: '1118050018',
    districtId: '1118050',
    name: 'Siblah Coh',
  },
  {
    id: '1118050019',
    districtId: '1118050',
    name: 'Pulo Ulim',
  },
  {
    id: '1118050020',
    districtId: '1118050',
    name: 'Grong Grong Capa',
  },
  {
    id: '1118050021',
    districtId: '1118050',
    name: 'Tanjong Ulim',
  },
  {
    id: '1118050022',
    districtId: '1118050',
    name: 'Meunasah Krueng',
  },
  {
    id: '1118050023',
    districtId: '1118050',
    name: 'Keude Ulim',
  },
  {
    id: '1118050024',
    districtId: '1118050',
    name: 'Dayah Lubue',
  },
  {
    id: '1118050025',
    districtId: '1118050',
    name: 'Mesjid Ulim Baroh',
  },
  {
    id: '1118050026',
    districtId: '1118050',
    name: 'Meunasah Bueng',
  },
  {
    id: '1118050027',
    districtId: '1118050',
    name: 'Geulanggang',
  },
  {
    id: '1118050028',
    districtId: '1118050',
    name: 'Tijien Husen',
  },
  {
    id: '1118050029',
    districtId: '1118050',
    name: 'Pulo Lhok',
  },
  {
    id: '1118050030',
    districtId: '1118050',
    name: 'Tijien Daboh',
  },
  {
    id: '1118060001',
    districtId: '1118060',
    name: 'Panton Raya',
  },
  {
    id: '1118060002',
    districtId: '1118060',
    name: 'Peulandok Tunong',
  },
  {
    id: '1118060003',
    districtId: '1118060',
    name: 'Peulandok Teungoh',
  },
  {
    id: '1118060004',
    districtId: '1118060',
    name: 'Buloh',
  },
  {
    id: '1118060005',
    districtId: '1118060',
    name: 'Dayah Ujong Baroh',
  },
  {
    id: '1118060006',
    districtId: '1118060',
    name: 'Matang',
  },
  {
    id: '1118060007',
    districtId: '1118060',
    name: 'Dee',
  },
  {
    id: '1118060008',
    districtId: '1118060',
    name: 'Deah Teumanah',
  },
  {
    id: '1118060009',
    districtId: '1118060',
    name: 'Tampui',
  },
  {
    id: '1118060010',
    districtId: '1118060',
    name: 'Reuseb',
  },
  {
    id: '1118060011',
    districtId: '1118060',
    name: 'Mesjid Peudeuek Baroh',
  },
  {
    id: '1118060012',
    districtId: '1118060',
    name: 'Tuha',
  },
  {
    id: '1118060013',
    districtId: '1118060',
    name: 'Paya',
  },
  {
    id: '1118060014',
    districtId: '1118060',
    name: 'Mesjid Trienggadeng',
  },
  {
    id: '1118060015',
    districtId: '1118060',
    name: 'Tueng Kluet',
  },
  {
    id: '1118060016',
    districtId: '1118060',
    name: 'Mee Pangwa',
  },
  {
    id: '1118060017',
    districtId: '1118060',
    name: 'Rawasari',
  },
  {
    id: '1118060018',
    districtId: '1118060',
    name: 'Cot Makaso',
  },
  {
    id: '1118060019',
    districtId: '1118060',
    name: 'Kuta',
  },
  {
    id: '1118060020',
    districtId: '1118060',
    name: 'Meucat',
  },
  {
    id: '1118060021',
    districtId: '1118060',
    name: 'Deah Pangwa',
  },
  {
    id: '1118060022',
    districtId: '1118060',
    name: 'Cot Lheue Rheung',
  },
  {
    id: '1118060023',
    districtId: '1118060',
    name: 'Meue',
  },
  {
    id: '1118060024',
    districtId: '1118060',
    name: 'Keude',
  },
  {
    id: '1118060025',
    districtId: '1118060',
    name: 'Raya',
  },
  {
    id: '1118060026',
    districtId: '1118060',
    name: 'Mee Peuduek',
  },
  {
    id: '1118060027',
    districtId: '1118060',
    name: 'Sagoe',
  },
  {
    id: '1118070001',
    districtId: '1118070',
    name: "Lhok Pu'Uk",
  },
  {
    id: '1118070002',
    districtId: '1118070',
    name: 'Tunong',
  },
  {
    id: '1118070003',
    districtId: '1118070',
    name: 'Teungoh',
  },
  {
    id: '1118070004',
    districtId: '1118070',
    name: 'Peurade',
  },
  {
    id: '1118070005',
    districtId: '1118070',
    name: 'Reudeup',
  },
  {
    id: '1118070006',
    districtId: '1118070',
    name: 'Mesjid',
  },
  {
    id: '1118070007',
    districtId: '1118070',
    name: 'Muka Blang',
  },
  {
    id: '1118070008',
    districtId: '1118070',
    name: 'Hagu',
  },
  {
    id: '1118070009',
    districtId: '1118070',
    name: 'Tu Pantee Raja',
  },
  {
    id: '1118070010',
    districtId: '1118070',
    name: 'Keude',
  },
  {
    id: '1118080001',
    districtId: '1118080',
    name: 'Mns Aki Neungoh',
  },
  {
    id: '1118080002',
    districtId: '1118080',
    name: 'Mns Abah Lueng',
  },
  {
    id: '1118080003',
    districtId: '1118080',
    name: 'Meunasah Jijiem',
  },
  {
    id: '1118080004',
    districtId: '1118080',
    name: 'Mns Sarah Panyang',
  },
  {
    id: '1118080005',
    districtId: '1118080',
    name: 'Mns Blang Sukon',
  },
  {
    id: '1118080006',
    districtId: '1118080',
    name: 'Mns Kayee Jatoe',
  },
  {
    id: '1118080007',
    districtId: '1118080',
    name: 'Mns Blang Baro',
  },
  {
    id: '1118080008',
    districtId: '1118080',
    name: 'Mns Blang Iboih',
  },
  {
    id: '1118080009',
    districtId: '1118080',
    name: 'Mns Dayah Langien',
  },
  {
    id: '1118080010',
    districtId: '1118080',
    name: 'Mns Blang Krueng',
  },
  {
    id: '1118080011',
    districtId: '1118080',
    name: 'Meunasah Alue',
  },
  {
    id: '1118080012',
    districtId: '1118080',
    name: 'Mns Tanoh Mirah',
  },
  {
    id: '1118080013',
    districtId: '1118080',
    name: 'Mns Ujong Leubat',
  },
  {
    id: '1118080014',
    districtId: '1118080',
    name: 'Mns Tualada',
  },
  {
    id: '1118080015',
    districtId: '1118080',
    name: 'Mns Cut Langien',
  },
  {
    id: '1118080016',
    districtId: '1118080',
    name: 'Meunasah Sagoe',
  },
  {
    id: '1118080017',
    districtId: '1118080',
    name: 'Mns Baroh Cot',
  },
  {
    id: '1118080018',
    districtId: '1118080',
    name: 'Meunasah Balee',
  },
  {
    id: '1118080019',
    districtId: '1118080',
    name: 'Mns Teungoh',
  },
  {
    id: '1118080020',
    districtId: '1118080',
    name: 'Mns Baroh Musa',
  },
  {
    id: '1118080021',
    districtId: '1118080',
    name: 'Mns Paru Keude',
  },
  {
    id: '1118080022',
    districtId: '1118080',
    name: 'Mns Lancang',
  },
  {
    id: '1118080023',
    districtId: '1118080',
    name: 'Mns Udeung',
  },
  {
    id: '1118080024',
    districtId: '1118080',
    name: 'Meunasah Ara',
  },
  {
    id: '1118080025',
    districtId: '1118080',
    name: 'Mns Blang Glong',
  },
  {
    id: '1118080026',
    districtId: '1118080',
    name: 'Meunasah Keude',
  },
  {
    id: '1118080027',
    districtId: '1118080',
    name: 'Mns Pueb Lueng Nibong',
  },
  {
    id: '1118080028',
    districtId: '1118080',
    name: 'Mns Daboih',
  },
  {
    id: '1118080029',
    districtId: '1118080',
    name: 'Mns Pulo Rheng',
  },
  {
    id: '1118080030',
    districtId: '1118080',
    name: 'Mns Gampong',
  },
  {
    id: '1118080031',
    districtId: '1118080',
    name: 'Mns Dayah Nyong',
  },
  {
    id: '1118080032',
    districtId: '1118080',
    name: 'Mns Beurandeh',
  },
  {
    id: '1118080033',
    districtId: '1118080',
    name: 'Mns Kayee Raya',
  },
  {
    id: '1118080034',
    districtId: '1118080',
    name: 'Meunasah Siren',
  },
  {
    id: '1118080035',
    districtId: '1118080',
    name: 'Meunasah Tutong',
  },
  {
    id: '1118080036',
    districtId: '1118080',
    name: 'Mns Manyang',
  },
  {
    id: '1118080037',
    districtId: '1118080',
    name: 'Mns Baroh Lancok',
  },
  {
    id: '1118080038',
    districtId: '1118080',
    name: 'Meunasah Mesjid',
  },
  {
    id: '1118080039',
    districtId: '1118080',
    name: 'Mns Pulo Pueb',
  },
  {
    id: '1118080040',
    districtId: '1118080',
    name: 'Meunasah Sawang',
  },
  {
    id: '1118080041',
    districtId: '1118080',
    name: 'Meunasah Baro',
  },
  {
    id: '1118080042',
    districtId: '1118080',
    name: 'Mns Cut Nyong',
  },
  {
    id: '1118080043',
    districtId: '1118080',
    name: 'Mns Paru Cot',
  },
  {
    id: '1171010019',
    districtId: '1171010',
    name: 'Surien',
  },
  {
    id: '1171010020',
    districtId: '1171010',
    name: 'Aso Nanggroe',
  },
  {
    id: '1171010021',
    districtId: '1171010',
    name: 'Gampong Blang',
  },
  {
    id: '1171010022',
    districtId: '1171010',
    name: 'Lamjabat',
  },
  {
    id: '1171010023',
    districtId: '1171010',
    name: 'Gampong Baro',
  },
  {
    id: '1171010025',
    districtId: '1171010',
    name: 'Punge Jurong',
  },
  {
    id: '1171010027',
    districtId: '1171010',
    name: 'Lampaseh Aceh',
  },
  {
    id: '1171010028',
    districtId: '1171010',
    name: 'Punge Ujong',
  },
  {
    id: '1171010029',
    districtId: '1171010',
    name: 'Cot Lamkuweueh',
  },
  {
    id: '1171010030',
    districtId: '1171010',
    name: 'Gampong Pie',
  },
  {
    id: '1171010031',
    districtId: '1171010',
    name: 'Ulee Lheue',
  },
  {
    id: '1171010032',
    districtId: '1171010',
    name: 'Deah Glumpang',
  },
  {
    id: '1171010033',
    districtId: '1171010',
    name: 'Lambung',
  },
  {
    id: '1171010034',
    districtId: '1171010',
    name: 'Blang Oi',
  },
  {
    id: '1171010035',
    districtId: '1171010',
    name: 'Alue Deah Teungoh',
  },
  {
    id: '1171010036',
    districtId: '1171010',
    name: 'Deah Baro',
  },
  {
    id: '1171011001',
    districtId: '1171011',
    name: 'Ulee Pata',
  },
  {
    id: '1171011002',
    districtId: '1171011',
    name: 'Lamjamee',
  },
  {
    id: '1171011003',
    districtId: '1171011',
    name: 'Lampoh Daya',
  },
  {
    id: '1171011004',
    districtId: '1171011',
    name: 'Emperom',
  },
  {
    id: '1171011005',
    districtId: '1171011',
    name: 'Geuceu Meunara',
  },
  {
    id: '1171011006',
    districtId: '1171011',
    name: 'Lamtemen Barat',
  },
  {
    id: '1171011007',
    districtId: '1171011',
    name: 'Bitai',
  },
  {
    id: '1171011008',
    districtId: '1171011',
    name: 'Lamtemen Timur',
  },
  {
    id: '1171011009',
    districtId: '1171011',
    name: 'Punge Blang Cut',
  },
  {
    id: '1171012001',
    districtId: '1171012',
    name: 'Lam Ara',
  },
  {
    id: '1171012002',
    districtId: '1171012',
    name: 'Lampuot',
  },
  {
    id: '1171012003',
    districtId: '1171012',
    name: 'Mibo',
  },
  {
    id: '1171012004',
    districtId: '1171012',
    name: 'Lhong Cut',
  },
  {
    id: '1171012005',
    districtId: '1171012',
    name: 'Lhong Raya',
  },
  {
    id: '1171012006',
    districtId: '1171012',
    name: 'Peunyeurat',
  },
  {
    id: '1171012007',
    districtId: '1171012',
    name: 'Lam Lagang',
  },
  {
    id: '1171012008',
    districtId: '1171012',
    name: 'Geuceu Komplek',
  },
  {
    id: '1171012009',
    districtId: '1171012',
    name: 'Geuceu Iniem',
  },
  {
    id: '1171012010',
    districtId: '1171012',
    name: 'Geuceu Kayee Jato',
  },
  {
    id: '1171020001',
    districtId: '1171020',
    name: 'Ateuk Jawo',
  },
  {
    id: '1171020007',
    districtId: '1171020',
    name: 'Ateuk Deah Tanoh',
  },
  {
    id: '1171020008',
    districtId: '1171020',
    name: 'Ateuk Pahlawan',
  },
  {
    id: '1171020009',
    districtId: '1171020',
    name: 'Ateuk Munjeng',
  },
  {
    id: '1171020010',
    districtId: '1171020',
    name: 'Neusu Aceh',
  },
  {
    id: '1171020011',
    districtId: '1171020',
    name: 'Seutui',
  },
  {
    id: '1171020012',
    districtId: '1171020',
    name: 'Sukaramai',
  },
  {
    id: '1171020013',
    districtId: '1171020',
    name: 'Neusu Jaya',
  },
  {
    id: '1171020014',
    districtId: '1171020',
    name: 'Peuniti',
  },
  {
    id: '1171020019',
    districtId: '1171020',
    name: 'Kampung Baru',
  },
  {
    id: '1171021001',
    districtId: '1171021',
    name: 'Lamdom',
  },
  {
    id: '1171021002',
    districtId: '1171021',
    name: 'Cot Mesjid',
  },
  {
    id: '1171021003',
    districtId: '1171021',
    name: 'Batoh',
  },
  {
    id: '1171021004',
    districtId: '1171021',
    name: 'Lueng Bata',
  },
  {
    id: '1171021005',
    districtId: '1171021',
    name: 'Blang Cut',
  },
  {
    id: '1171021006',
    districtId: '1171021',
    name: 'Lampaloh',
  },
  {
    id: '1171021007',
    districtId: '1171021',
    name: 'Sukadamai',
  },
  {
    id: '1171021008',
    districtId: '1171021',
    name: 'Panteriek',
  },
  {
    id: '1171021009',
    districtId: '1171021',
    name: 'Lamseupeung',
  },
  {
    id: '1171030001',
    districtId: '1171030',
    name: 'Peunayong',
  },
  {
    id: '1171030002',
    districtId: '1171030',
    name: 'Laksana',
  },
  {
    id: '1171030003',
    districtId: '1171030',
    name: 'Keuramat',
  },
  {
    id: '1171030004',
    districtId: '1171030',
    name: 'Kuta Alam',
  },
  {
    id: '1171030005',
    districtId: '1171030',
    name: 'Beurawe',
  },
  {
    id: '1171030006',
    districtId: '1171030',
    name: 'Kota Baru',
  },
  {
    id: '1171030007',
    districtId: '1171030',
    name: 'Bandar Baru',
  },
  {
    id: '1171030008',
    districtId: '1171030',
    name: 'Mulia',
  },
  {
    id: '1171030013',
    districtId: '1171030',
    name: 'Lampulo',
  },
  {
    id: '1171030014',
    districtId: '1171030',
    name: 'Lamdingin',
  },
  {
    id: '1171030015',
    districtId: '1171030',
    name: 'Lambaro Skep',
  },
  {
    id: '1171031001',
    districtId: '1171031',
    name: 'Lampaseh Kota',
  },
  {
    id: '1171031002',
    districtId: '1171031',
    name: 'Merduati',
  },
  {
    id: '1171031003',
    districtId: '1171031',
    name: 'Keudah',
  },
  {
    id: '1171031004',
    districtId: '1171031',
    name: 'Peulanggahan',
  },
  {
    id: '1171031005',
    districtId: '1171031',
    name: 'Gampong Jawa',
  },
  {
    id: '1171031006',
    districtId: '1171031',
    name: 'Gampong Pande',
  },
  {
    id: '1171040010',
    districtId: '1171040',
    name: 'Iemasen Kaye Adang',
  },
  {
    id: '1171040011',
    districtId: '1171040',
    name: 'Pineung',
  },
  {
    id: '1171040012',
    districtId: '1171040',
    name: 'Lamgugob',
  },
  {
    id: '1171040013',
    districtId: '1171040',
    name: 'Kopelma Darussalam',
  },
  {
    id: '1171040014',
    districtId: '1171040',
    name: 'Rukoh',
  },
  {
    id: '1171040015',
    districtId: '1171040',
    name: 'Jeulingke',
  },
  {
    id: '1171040016',
    districtId: '1171040',
    name: 'Tibang',
  },
  {
    id: '1171040017',
    districtId: '1171040',
    name: 'Deah Raya',
  },
  {
    id: '1171040018',
    districtId: '1171040',
    name: 'Alue Naga',
  },
  {
    id: '1171040019',
    districtId: '1171040',
    name: 'Peurada',
  },
  {
    id: '1171041001',
    districtId: '1171041',
    name: 'Pango Raya',
  },
  {
    id: '1171041002',
    districtId: '1171041',
    name: 'Pango Deah',
  },
  {
    id: '1171041003',
    districtId: '1171041',
    name: 'Ilie',
  },
  {
    id: '1171041004',
    districtId: '1171041',
    name: 'Lamteh',
  },
  {
    id: '1171041005',
    districtId: '1171041',
    name: 'Lamglumpang',
  },
  {
    id: '1171041006',
    districtId: '1171041',
    name: 'Ceurih',
  },
  {
    id: '1171041007',
    districtId: '1171041',
    name: 'Iemasen Ulee Kareng',
  },
  {
    id: '1171041008',
    districtId: '1171041',
    name: 'Doy',
  },
  {
    id: '1171041009',
    districtId: '1171041',
    name: 'Lambhuk',
  },
  {
    id: '1172010001',
    districtId: '1172010',
    name: 'Paya',
  },
  {
    id: '1172010002',
    districtId: '1172010',
    name: 'Keuneukai',
  },
  {
    id: '1172010003',
    districtId: '1172010',
    name: 'Beurawang',
  },
  {
    id: '1172010004',
    districtId: '1172010',
    name: 'Jaboi',
  },
  {
    id: '1172010005',
    districtId: '1172010',
    name: 'Balohan',
  },
  {
    id: '1172010006',
    districtId: '1172010',
    name: 'Cot Abeuk',
  },
  {
    id: '1172010007',
    districtId: '1172010',
    name: "Cot Ba'U",
  },
  {
    id: '1172010008',
    districtId: '1172010',
    name: 'Anoe Itam',
  },
  {
    id: '1172010009',
    districtId: '1172010',
    name: 'Ujong Kareung',
  },
  {
    id: '1172010010',
    districtId: '1172010',
    name: 'Ie Meulee',
  },
  {
    id: '1172020001',
    districtId: '1172020',
    name: 'Iboih',
  },
  {
    id: '1172020002',
    districtId: '1172020',
    name: 'Batee Shoek',
  },
  {
    id: '1172020003',
    districtId: '1172020',
    name: 'Paya Seunara',
  },
  {
    id: '1172020004',
    districtId: '1172020',
    name: 'Krueng Raya',
  },
  {
    id: '1172020005',
    districtId: '1172020',
    name: 'Aneuk Laot',
  },
  {
    id: '1172020006',
    districtId: '1172020',
    name: 'Kuta Timu',
  },
  {
    id: '1172020007',
    districtId: '1172020',
    name: 'Kuta Barat',
  },
  {
    id: '1172020008',
    districtId: '1172020',
    name: 'Kuta Ateuh',
  },
  {
    id: '1173010007',
    districtId: '1173010',
    name: 'Buket Meudang Ara',
  },
  {
    id: '1173010009',
    districtId: '1173010',
    name: 'Matang Seutui',
  },
  {
    id: '1173010010',
    districtId: '1173010',
    name: 'Buket Pulo',
  },
  {
    id: '1173010011',
    districtId: '1173010',
    name: 'Matang Panyang',
  },
  {
    id: '1173010012',
    districtId: '1173010',
    name: 'Simpang Wie',
  },
  {
    id: '1173010013',
    districtId: '1173010',
    name: 'Buket Rata',
  },
  {
    id: '1173010014',
    districtId: '1173010',
    name: 'Buket Meutuah',
  },
  {
    id: '1173010015',
    districtId: '1173010',
    name: 'Alue Merbau',
  },
  {
    id: '1173010016',
    districtId: '1173010',
    name: 'Matang Ceungai',
  },
  {
    id: '1173010017',
    districtId: '1173010',
    name: 'Seuneubok Antara',
  },
  {
    id: '1173010018',
    districtId: '1173010',
    name: 'Alue Pineung',
  },
  {
    id: '1173010019',
    districtId: '1173010',
    name: 'Sukarejo',
  },
  {
    id: '1173010020',
    districtId: '1173010',
    name: 'Cinta Raja',
  },
  {
    id: '1173010021',
    districtId: '1173010',
    name: 'Sungai Lueng',
  },
  {
    id: '1173010022',
    districtId: '1173010',
    name: 'Alue Pineung Timue',
  },
  {
    id: '1173010023',
    districtId: '1173010',
    name: 'Kapa',
  },
  {
    id: '1173011001',
    districtId: '1173011',
    name: 'Pondok Keumuning',
  },
  {
    id: '1173011002',
    districtId: '1173011',
    name: 'Seulalah',
  },
  {
    id: '1173011003',
    districtId: '1173011',
    name: 'Pondok Pabrik',
  },
  {
    id: '1173011004',
    districtId: '1173011',
    name: 'Sidodadi',
  },
  {
    id: '1173011005',
    districtId: '1173011',
    name: 'Sidorejo',
  },
  {
    id: '1173011006',
    districtId: '1173011',
    name: 'Gampong Baro',
  },
  {
    id: '1173011007',
    districtId: '1173011',
    name: 'Meurandeh',
  },
  {
    id: '1173011008',
    districtId: '1173011',
    name: 'Asam Peutek',
  },
  {
    id: '1173011009',
    districtId: '1173011',
    name: 'Baroh Langsa Lama',
  },
  {
    id: '1173011010',
    districtId: '1173011',
    name: 'Seulalah Baru',
  },
  {
    id: '1173011011',
    districtId: '1173011',
    name: 'Suka Jadi Kebun Ireng',
  },
  {
    id: '1173011012',
    districtId: '1173011',
    name: 'Meurandeh Tengah',
  },
  {
    id: '1173011013',
    districtId: '1173011',
    name: 'Meurandeh Dayah',
  },
  {
    id: '1173011014',
    districtId: '1173011',
    name: 'Meurandeh Aceh',
  },
  {
    id: '1173011015',
    districtId: '1173011',
    name: 'Bate Puteh',
  },
  {
    id: '1173020008',
    districtId: '1173020',
    name: 'Lhok Banie',
  },
  {
    id: '1173020009',
    districtId: '1173020',
    name: 'Paya Bujok Teungoh',
  },
  {
    id: '1173020010',
    districtId: '1173020',
    name: 'Paya Bujok. Beuramoe',
  },
  {
    id: '1173020011',
    districtId: '1173020',
    name: 'Simpang Lhee',
  },
  {
    id: '1173020012',
    districtId: '1173020',
    name: 'Seuriget',
  },
  {
    id: '1173020019',
    districtId: '1173020',
    name: 'Matang Seulimeng',
  },
  {
    id: '1173020020',
    districtId: '1173020',
    name: 'Sungai Pauh',
  },
  {
    id: '1173020021',
    districtId: '1173020',
    name: 'Kuala Langsa',
  },
  {
    id: '1173020022',
    districtId: '1173020',
    name: 'Telaga Tujuh',
  },
  {
    id: '1173020023',
    districtId: '1173020',
    name: 'Serambi Indah',
  },
  {
    id: '1173020024',
    districtId: '1173020',
    name: 'Sungai Pauh Pusaka',
  },
  {
    id: '1173020025',
    districtId: '1173020',
    name: 'Sungai Pauh Tanjong',
  },
  {
    id: '1173020026',
    districtId: '1173020',
    name: 'Sungai Pauh Firdaus',
  },
  {
    id: '1173021001',
    districtId: '1173021',
    name: 'Timbang Langsa',
  },
  {
    id: '1173021002',
    districtId: '1173021',
    name: 'Alue Dua',
  },
  {
    id: '1173021003',
    districtId: '1173021',
    name: 'Birem Puntong',
  },
  {
    id: '1173021004',
    districtId: '1173021',
    name: 'Paya Bujok Seuleumak',
  },
  {
    id: '1173021005',
    districtId: '1173021',
    name: 'Pondok Kelapa',
  },
  {
    id: '1173021006',
    districtId: '1173021',
    name: 'Karang Anyar',
  },
  {
    id: '1173021007',
    districtId: '1173021',
    name: 'Paya Bujok Tunong',
  },
  {
    id: '1173021008',
    districtId: '1173021',
    name: 'Geudubang Jawa',
  },
  {
    id: '1173021009',
    districtId: '1173021',
    name: 'Geudubang Aceh',
  },
  {
    id: '1173021010',
    districtId: '1173021',
    name: 'Alue Dua Bakaran Batee',
  },
  {
    id: '1173021011',
    districtId: '1173021',
    name: 'Lengkong',
  },
  {
    id: '1173021012',
    districtId: '1173021',
    name: 'Sukajadi Makmur',
  },
  {
    id: '1173030001',
    districtId: '1173030',
    name: 'Gampong Teungoh',
  },
  {
    id: '1173030002',
    districtId: '1173030',
    name: 'Peukan Langsa',
  },
  {
    id: '1173030004',
    districtId: '1173030',
    name: 'Gampong Jawa',
  },
  {
    id: '1173030005',
    districtId: '1173030',
    name: 'Paya Bujok Blang Pase',
  },
  {
    id: '1173030006',
    districtId: '1173030',
    name: 'Gampong Blang',
  },
  {
    id: '1173030007',
    districtId: '1173030',
    name: 'Alue Berawe',
  },
  {
    id: '1173030009',
    districtId: '1173030',
    name: 'Gampong Daulat',
  },
  {
    id: '1173030010',
    districtId: '1173030',
    name: 'Gampong Mutia',
  },
  {
    id: '1173030011',
    districtId: '1173030',
    name: 'Blang Sinibong',
  },
  {
    id: '1173030013',
    districtId: '1173030',
    name: 'Tualang Teungoh',
  },
  {
    id: '1174010001',
    districtId: '1174010',
    name: 'Alue Lim',
  },
  {
    id: '1174010002',
    districtId: '1174010',
    name: 'Blang Buloh',
  },
  {
    id: '1174010003',
    districtId: '1174010',
    name: 'Mane Kareung',
  },
  {
    id: '1174010004',
    districtId: '1174010',
    name: 'Asan Kareung',
  },
  {
    id: '1174010005',
    districtId: '1174010',
    name: 'Rayeuk Kareung',
  },
  {
    id: '1174010006',
    districtId: '1174010',
    name: 'Kumbang Punteut',
  },
  {
    id: '1174010007',
    districtId: '1174010',
    name: 'Blang Punteut',
  },
  {
    id: '1174010008',
    districtId: '1174010',
    name: 'Ulee Blang Mane',
  },
  {
    id: '1174010009',
    districtId: '1174010',
    name: 'Keude Punteut',
  },
  {
    id: '1174010010',
    districtId: '1174010',
    name: 'Mesjid Punteut',
  },
  {
    id: '1174010011',
    districtId: '1174010',
    name: 'Tunong',
  },
  {
    id: '1174010012',
    districtId: '1174010',
    name: 'Baloy',
  },
  {
    id: '1174010013',
    districtId: '1174010',
    name: 'Teungoh',
  },
  {
    id: '1174010014',
    districtId: '1174010',
    name: 'Blang Teue',
  },
  {
    id: '1174010015',
    districtId: '1174010',
    name: 'Jambo Timu',
  },
  {
    id: '1174010016',
    districtId: '1174010',
    name: 'Mesjid Meuraksa',
  },
  {
    id: '1174010017',
    districtId: '1174010',
    name: 'Blang Cut',
  },
  {
    id: '1174010018',
    districtId: '1174010',
    name: 'Kuala Meuraksa',
  },
  {
    id: '1174010019',
    districtId: '1174010',
    name: 'Jeuleukat',
  },
  {
    id: '1174010020',
    districtId: '1174010',
    name: 'Blang Weu Panjou',
  },
  {
    id: '1174010021',
    districtId: '1174010',
    name: 'Blang Weu Baroh',
  },
  {
    id: '1174010022',
    districtId: '1174010',
    name: 'Seuneubok',
  },
  {
    id: '1174020002',
    districtId: '1174020',
    name: 'Paloh Batee',
  },
  {
    id: '1174020003',
    districtId: '1174020',
    name: 'Lhok Mon Puteh',
  },
  {
    id: '1174020004',
    districtId: '1174020',
    name: 'Cot Girek',
  },
  {
    id: '1174020005',
    districtId: '1174020',
    name: 'Manyang',
  },
  {
    id: '1174020006',
    districtId: '1174020',
    name: 'Blang Crum',
  },
  {
    id: '1174020007',
    districtId: '1174020',
    name: 'Alue Awe',
  },
  {
    id: '1174020008',
    districtId: '1174020',
    name: 'Cut Mamplam',
  },
  {
    id: '1174020009',
    districtId: '1174020',
    name: 'Mns Mee',
  },
  {
    id: '1174020010',
    districtId: '1174020',
    name: 'Mns Blang',
  },
  {
    id: '1174020011',
    districtId: '1174020',
    name: 'Uteunkot',
  },
  {
    id: '1174020012',
    districtId: '1174020',
    name: 'Blang Pohroh',
  },
  {
    id: '1174020013',
    districtId: '1174020',
    name: 'Paya Punteut',
  },
  {
    id: '1174020014',
    districtId: '1174020',
    name: 'Keude Cunda',
  },
  {
    id: '1174020015',
    districtId: '1174020',
    name: 'Mns Mesjid',
  },
  {
    id: '1174020016',
    districtId: '1174020',
    name: 'Panggoi',
  },
  {
    id: '1174020017',
    districtId: '1174020',
    name: 'Paya Bili',
  },
  {
    id: '1174020018',
    districtId: '1174020',
    name: 'Mns Alue',
  },
  {
    id: '1174021001',
    districtId: '1174021',
    name: 'Cot Trieng',
  },
  {
    id: '1174021002',
    districtId: '1174021',
    name: 'Paloh Punti',
  },
  {
    id: '1174021003',
    districtId: '1174021',
    name: 'Mns Dayah',
  },
  {
    id: '1174021004',
    districtId: '1174021',
    name: 'Blang Panyang',
  },
  {
    id: '1174021005',
    districtId: '1174021',
    name: 'Meuria',
  },
  {
    id: '1174021006',
    districtId: '1174021',
    name: 'Blang Pulo',
  },
  {
    id: '1174021007',
    districtId: '1174021',
    name: 'Batuphat Timur',
  },
  {
    id: '1174021008',
    districtId: '1174021',
    name: 'Padang Sakti',
  },
  {
    id: '1174021009',
    districtId: '1174021',
    name: 'Ujong Pacu',
  },
  {
    id: '1174021010',
    districtId: '1174021',
    name: 'Blang Naleung Mameh',
  },
  {
    id: '1174021011',
    districtId: '1174021',
    name: 'Batuphat Barat',
  },
  {
    id: '1174030001',
    districtId: '1174030',
    name: 'Mon Geudong',
  },
  {
    id: '1174030002',
    districtId: '1174030',
    name: 'Keude Aceh',
  },
  {
    id: '1174030003',
    districtId: '1174030',
    name: 'Pusong Lama',
  },
  {
    id: '1174030004',
    districtId: '1174030',
    name: 'Pusong Baru',
  },
  {
    id: '1174030005',
    districtId: '1174030',
    name: 'Lhokseumawe',
  },
  {
    id: '1174030006',
    districtId: '1174030',
    name: 'Simpang Empat',
  },
  {
    id: '1174030007',
    districtId: '1174030',
    name: 'Lancang Garam',
  },
  {
    id: '1174030008',
    districtId: '1174030',
    name: 'Kampung Jawa Baru',
  },
  {
    id: '1174030009',
    districtId: '1174030',
    name: 'Tumpok Teungoh',
  },
  {
    id: '1174030010',
    districtId: '1174030',
    name: 'Kuta Blang',
  },
  {
    id: '1174030011',
    districtId: '1174030',
    name: 'Uteun Bayi',
  },
  {
    id: '1174030012',
    districtId: '1174030',
    name: 'Banda Masen',
  },
  {
    id: '1174030013',
    districtId: '1174030',
    name: 'Ujong Blang',
  },
  {
    id: '1174030014',
    districtId: '1174030',
    name: 'Ulee Jalan',
  },
  {
    id: '1174030015',
    districtId: '1174030',
    name: 'Hagu Barat Laut',
  },
  {
    id: '1174030016',
    districtId: '1174030',
    name: 'Hagu Teungoh',
  },
  {
    id: '1174030017',
    districtId: '1174030',
    name: 'Hagu Selatan',
  },
  {
    id: '1174030018',
    districtId: '1174030',
    name: 'Kampung Jawa Lama',
  },
  {
    id: '1175010001',
    districtId: '1175010',
    name: 'Buluh Dori',
  },
  {
    id: '1175010002',
    districtId: '1175010',
    name: 'Pegayo',
  },
  {
    id: '1175010003',
    districtId: '1175010',
    name: 'Subulussalam',
  },
  {
    id: '1175010004',
    districtId: '1175010',
    name: 'Pasar Panjang',
  },
  {
    id: '1175010005',
    districtId: '1175010',
    name: 'Tangga Besi',
  },
  {
    id: '1175010006',
    districtId: '1175010',
    name: 'Kuta Cepu',
  },
  {
    id: '1175010007',
    districtId: '1175010',
    name: 'Suka Makmur',
  },
  {
    id: '1175010008',
    districtId: '1175010',
    name: 'Sikelondang',
  },
  {
    id: '1175010009',
    districtId: '1175010',
    name: 'Mukti Makmur',
  },
  {
    id: '1175010010',
    districtId: '1175010',
    name: 'Subulussalam Barat',
  },
  {
    id: '1175010011',
    districtId: '1175010',
    name: 'Subulussalam Selatan',
  },
  {
    id: '1175010012',
    districtId: '1175010',
    name: 'Subulussalam Utara',
  },
  {
    id: '1175010013',
    districtId: '1175010',
    name: 'Lae Oram',
  },
  {
    id: '1175010014',
    districtId: '1175010',
    name: 'Makmur Jaya',
  },
  {
    id: '1175010015',
    districtId: '1175010',
    name: 'Belegen Mulia',
  },
  {
    id: '1175010016',
    districtId: '1175010',
    name: 'Danau Tras',
  },
  {
    id: '1175010017',
    districtId: '1175010',
    name: 'Subulussalam Timur',
  },
  {
    id: '1175020001',
    districtId: '1175020',
    name: 'Lae Motong',
  },
  {
    id: '1175020002',
    districtId: '1175020',
    name: 'Kampung Baru',
  },
  {
    id: '1175020003',
    districtId: '1175020',
    name: 'Penanggalan',
  },
  {
    id: '1175020004',
    districtId: '1175020',
    name: 'Lae Bersih',
  },
  {
    id: '1175020005',
    districtId: '1175020',
    name: 'Cepu',
  },
  {
    id: '1175020006',
    districtId: '1175020',
    name: 'Kuta Tengah',
  },
  {
    id: '1175020007',
    districtId: '1175020',
    name: 'Sikelang',
  },
  {
    id: '1175020008',
    districtId: '1175020',
    name: 'Jontor',
  },
  {
    id: '1175020009',
    districtId: '1175020',
    name: 'Lae Ikan',
  },
  {
    id: '1175020010',
    districtId: '1175020',
    name: 'Penuntungan',
  },
  {
    id: '1175020011',
    districtId: '1175020',
    name: 'Dasan Raja',
  },
  {
    id: '1175020012',
    districtId: '1175020',
    name: 'Penanggalan Barat',
  },
  {
    id: '1175020013',
    districtId: '1175020',
    name: 'Penanggalan Timur',
  },
  {
    id: '1175030001',
    districtId: '1175030',
    name: 'Siperkas',
  },
  {
    id: '1175030002',
    districtId: '1175030',
    name: 'Kuta Beringin',
  },
  {
    id: '1175030003',
    districtId: '1175030',
    name: 'Kampong Badar',
  },
  {
    id: '1175030004',
    districtId: '1175030',
    name: 'Harapan Baru',
  },
  {
    id: '1175030005',
    districtId: '1175030',
    name: 'Teladan Baru',
  },
  {
    id: '1175030006',
    districtId: '1175030',
    name: 'Oboh',
  },
  {
    id: '1175030007',
    districtId: '1175030',
    name: 'Binanga',
  },
  {
    id: '1175030008',
    districtId: '1175030',
    name: 'Belukur Makmur',
  },
  {
    id: '1175030009',
    districtId: '1175030',
    name: 'Pasar Rundeng',
  },
  {
    id: '1175030010',
    districtId: '1175030',
    name: 'Lae Pamualan',
  },
  {
    id: '1175030011',
    districtId: '1175030',
    name: 'Muara Batu-Batu',
  },
  {
    id: '1175030012',
    districtId: '1175030',
    name: 'Sibungke',
  },
  {
    id: '1175030013',
    districtId: '1175030',
    name: 'Panglima Sahman',
  },
  {
    id: '1175030014',
    districtId: '1175030',
    name: 'Sibuasan',
  },
  {
    id: '1175030015',
    districtId: '1175030',
    name: 'Dah',
  },
  {
    id: '1175030016',
    districtId: '1175030',
    name: 'Sepadan',
  },
  {
    id: '1175030017',
    districtId: '1175030',
    name: 'Geruguh',
  },
  {
    id: '1175030018',
    districtId: '1175030',
    name: 'Lae Mate',
  },
  {
    id: '1175030019',
    districtId: '1175030',
    name: 'Mandilam',
  },
  {
    id: '1175030020',
    districtId: '1175030',
    name: 'Tualang',
  },
  {
    id: '1175030021',
    districtId: '1175030',
    name: 'Tanah Tumbuh',
  },
  {
    id: '1175030022',
    districtId: '1175030',
    name: 'Kuala Keupeng',
  },
  {
    id: '1175030023',
    districtId: '1175030',
    name: 'Suak Jampak',
  },
  {
    id: '1175040001',
    districtId: '1175040',
    name: 'Pulo Belen',
  },
  {
    id: '1175040002',
    districtId: '1175040',
    name: 'Pulo Kedep',
  },
  {
    id: '1175040003',
    districtId: '1175040',
    name: 'Suka Maju',
  },
  {
    id: '1175040004',
    districtId: '1175040',
    name: 'Gunung Bakti',
  },
  {
    id: '1175040005',
    districtId: '1175040',
    name: 'Jambi',
  },
  {
    id: '1175040006',
    districtId: '1175040',
    name: 'Singgersing',
  },
  {
    id: '1175040007',
    districtId: '1175040',
    name: 'Cipar Pari',
  },
  {
    id: '1175040008',
    districtId: '1175040',
    name: 'Namo Buaya',
  },
  {
    id: '1175040009',
    districtId: '1175040',
    name: 'Cipar Pari Timur',
  },
  {
    id: '1175040010',
    districtId: '1175040',
    name: 'Lae Simolap',
  },
  {
    id: '1175040011',
    districtId: '1175040',
    name: 'Darul Makmur',
  },
  {
    id: '1175040012',
    districtId: '1175040',
    name: 'Pasir Belo',
  },
  {
    id: '1175040013',
    districtId: '1175040',
    name: 'Bawan',
  },
  {
    id: '1175040014',
    districtId: '1175040',
    name: 'Sigrun',
  },
  {
    id: '1175040015',
    districtId: '1175040',
    name: 'Lae Langge',
  },
  {
    id: '1175040016',
    districtId: '1175040',
    name: 'Jabi-Jabi',
  },
  {
    id: '1175040017',
    districtId: '1175040',
    name: 'Bunga Tanjung',
  },
  {
    id: '1175040018',
    districtId: '1175040',
    name: 'Jabi-Jabi Barat',
  },
  {
    id: '1175040019',
    districtId: '1175040',
    name: 'Batu Napal',
  },
  {
    id: '1175050001',
    districtId: '1175050',
    name: 'Sepang',
  },
  {
    id: '1175050002',
    districtId: '1175050',
    name: 'Longkib',
  },
  {
    id: '1175050003',
    districtId: '1175050',
    name: 'Panji',
  },
  {
    id: '1175050004',
    districtId: '1175050',
    name: 'Darul Aman',
  },
  {
    id: '1175050005',
    districtId: '1175050',
    name: 'Bukit Alim',
  },
  {
    id: '1175050006',
    districtId: '1175050',
    name: 'Rantau Panjang',
  },
  {
    id: '1175050007',
    districtId: '1175050',
    name: 'Sikerabang',
  },
  {
    id: '1175050008',
    districtId: '1175050',
    name: 'Bangun Sari',
  },
  {
    id: '1175050009',
    districtId: '1175050',
    name: 'Lae Saga',
  },
  {
    id: '1175050010',
    districtId: '1175050',
    name: 'Darussalam',
  },
  {
    id: '1201060015',
    districtId: '1201060',
    name: 'Tete Goenaai',
  },
  {
    id: '1201060016',
    districtId: '1201060',
    name: 'Laowo Hilimbaruzo',
  },
  {
    id: '1201060017',
    districtId: '1201060',
    name: 'Hililawae',
  },
  {
    id: '1201060018',
    districtId: '1201060',
    name: 'Tuhewaebu',
  },
  {
    id: '1201060023',
    districtId: '1201060',
    name: 'Sisobahili Iraonohura',
  },
  {
    id: '1201060024',
    districtId: '1201060',
    name: 'Hilimoasio',
  },
  {
    id: '1201060025',
    districtId: '1201060',
    name: 'Oladano',
  },
  {
    id: '1201060026',
    districtId: '1201060',
    name: 'Ahedano',
  },
  {
    id: '1201060027',
    districtId: '1201060',
    name: 'Hilinaa Tafuo',
  },
  {
    id: '1201060028',
    districtId: '1201060',
    name: 'Hilionozega',
  },
  {
    id: '1201060029',
    districtId: '1201060',
    name: 'Mondrali',
  },
  {
    id: '1201060036',
    districtId: '1201060',
    name: 'Awoni Lauso',
  },
  {
    id: '1201060037',
    districtId: '1201060',
    name: 'Bobozioli Loloanaa',
  },
  {
    id: '1201060038',
    districtId: '1201060',
    name: 'Tetehosi',
  },
  {
    id: '1201060039',
    districtId: '1201060',
    name: 'Saiwahili Hiliadulo',
  },
  {
    id: '1201060040',
    districtId: '1201060',
    name: 'Maliwaa',
  },
  {
    id: '1201060041',
    districtId: '1201060',
    name: 'Biouti',
  },
  {
    id: '1201060042',
    districtId: '1201060',
    name: 'Bozihona',
  },
  {
    id: '1201060043',
    districtId: '1201060',
    name: 'Hilimoasio Dua',
  },
  {
    id: '1201060044',
    districtId: '1201060',
    name: 'Hiliadulo',
  },
  {
    id: '1201060045',
    districtId: '1201060',
    name: 'Orahili Zuzundrao',
  },
  {
    id: '1201060046',
    districtId: '1201060',
    name: 'Tiga Serangkai Maliwaa',
  },
  {
    id: '1201060047',
    districtId: '1201060',
    name: 'Hiligogowaya Maliwaa',
  },
  {
    id: '1201060048',
    districtId: '1201060',
    name: 'Laira',
  },
  {
    id: '1201060049',
    districtId: '1201060',
    name: 'Otalua',
  },
  {
    id: '1201060050',
    districtId: '1201060',
    name: 'Baruzo',
  },
  {
    id: '1201060051',
    districtId: '1201060',
    name: 'Sandruta',
  },
  {
    id: '1201060052',
    districtId: '1201060',
    name: 'Biouti Timur',
  },
  {
    id: '1201061001',
    districtId: '1201061',
    name: 'Siofa Banua',
  },
  {
    id: '1201061002',
    districtId: '1201061',
    name: 'Sifaoroasi Uluhou',
  },
  {
    id: '1201061003',
    districtId: '1201061',
    name: 'Gazamanu',
  },
  {
    id: '1201061004',
    districtId: '1201061',
    name: 'Hiliganoita',
  },
  {
    id: '1201061005',
    districtId: '1201061',
    name: 'Sisarahili Bawolato',
  },
  {
    id: '1201061006',
    districtId: '1201061',
    name: 'Dahana',
  },
  {
    id: '1201061007',
    districtId: '1201061',
    name: 'Hilihoru',
  },
  {
    id: '1201061008',
    districtId: '1201061',
    name: 'Hilialawa',
  },
  {
    id: '1201061009',
    districtId: '1201061',
    name: 'Hiliwarokha',
  },
  {
    id: '1201061010',
    districtId: '1201061',
    name: 'Hilifaosi',
  },
  {
    id: '1201061011',
    districtId: '1201061',
    name: 'Sitolubanua',
  },
  {
    id: '1201061012',
    districtId: '1201061',
    name: 'Orahili',
  },
  {
    id: '1201061013',
    districtId: '1201061',
    name: 'Siofaewali',
  },
  {
    id: '1201061014',
    districtId: '1201061',
    name: 'Sohoya',
  },
  {
    id: '1201061015',
    districtId: '1201061',
    name: 'Tagaule',
  },
  {
    id: '1201061016',
    districtId: '1201061',
    name: 'Botohaenga',
  },
  {
    id: '1201061017',
    districtId: '1201061',
    name: 'Sindrondro',
  },
  {
    id: '1201061018',
    districtId: '1201061',
    name: 'Hilihao Cugala',
  },
  {
    id: '1201061019',
    districtId: '1201061',
    name: 'Siofaewali Selatan',
  },
  {
    id: '1201061020',
    districtId: '1201061',
    name: 'Lagasimahe',
  },
  {
    id: '1201061021',
    districtId: '1201061',
    name: 'Orahua',
  },
  {
    id: '1201061022',
    districtId: '1201061',
    name: 'Hou',
  },
  {
    id: '1201061023',
    districtId: '1201061',
    name: 'Banua Sibohou Silima Ewali',
  },
  {
    id: '1201061024',
    districtId: '1201061',
    name: 'Balale Tobaa',
  },
  {
    id: '1201061025',
    districtId: '1201061',
    name: 'Orahua Faondrato',
  },
  {
    id: '1201062001',
    districtId: '1201062',
    name: 'Orahili',
  },
  {
    id: '1201062002',
    districtId: '1201062',
    name: 'Hilimbowo',
  },
  {
    id: '1201062003',
    districtId: '1201062',
    name: 'Fatodano',
  },
  {
    id: '1201062004',
    districtId: '1201062',
    name: 'Fahandrona',
  },
  {
    id: '1201062005',
    districtId: '1201062',
    name: 'Hilibadalu',
  },
  {
    id: '1201062006',
    districtId: '1201062',
    name: 'Holi',
  },
  {
    id: '1201062007',
    districtId: '1201062',
    name: 'Sisobahili Ulugawo',
  },
  {
    id: '1201062008',
    districtId: '1201062',
    name: 'Hiliwetogela',
  },
  {
    id: '1201062009',
    districtId: '1201062',
    name: 'Lawa-Lawa Luo',
  },
  {
    id: '1201062010',
    districtId: '1201062',
    name: 'Sifaoroasi Ulugawo',
  },
  {
    id: '1201062011',
    districtId: '1201062',
    name: 'Onodalinga',
  },
  {
    id: '1201062012',
    districtId: '1201062',
    name: 'Mohili',
  },
  {
    id: '1201062013',
    districtId: '1201062',
    name: 'Hiligafoa',
  },
  {
    id: '1201062014',
    districtId: '1201062',
    name: 'Sisarahili Soromaasi',
  },
  {
    id: '1201070006',
    districtId: '1201070',
    name: 'Hiliotalua',
  },
  {
    id: '1201070008',
    districtId: '1201070',
    name: 'Akhelaume',
  },
  {
    id: '1201070012',
    districtId: '1201070',
    name: 'Tulombaho Saloo',
  },
  {
    id: '1201070013',
    districtId: '1201070',
    name: 'Olindrawa Sisarahili',
  },
  {
    id: '1201070014',
    districtId: '1201070',
    name: 'Lasela',
  },
  {
    id: '1201070016',
    districtId: '1201070',
    name: 'Hilisebua',
  },
  {
    id: '1201070017',
    districtId: '1201070',
    name: 'Somi',
  },
  {
    id: '1201070018',
    districtId: '1201070',
    name: 'Sirete',
  },
  {
    id: '1201070019',
    districtId: '1201070',
    name: 'Hiliweto Gido',
  },
  {
    id: '1201070020',
    districtId: '1201070',
    name: 'Loloanaa Gido',
  },
  {
    id: '1201070022',
    districtId: '1201070',
    name: 'Sisobahili',
  },
  {
    id: '1201070023',
    districtId: '1201070',
    name: 'Lahemo',
  },
  {
    id: '1201070024',
    districtId: '1201070',
    name: 'Ladea',
  },
  {
    id: '1201070027',
    districtId: '1201070',
    name: 'Umbu',
  },
  {
    id: '1201070028',
    districtId: '1201070',
    name: 'Saewe',
  },
  {
    id: '1201070029',
    districtId: '1201070',
    name: 'Lolozasai',
  },
  {
    id: '1201070030',
    districtId: '1201070',
    name: 'Lasara Idanoi',
  },
  {
    id: '1201070031',
    districtId: '1201070',
    name: 'Ladea Orahua',
  },
  {
    id: '1201070032',
    districtId: '1201070',
    name: 'Nifoloo Lauru',
  },
  {
    id: '1201070033',
    districtId: '1201070',
    name: 'Somi Botogoo',
  },
  {
    id: '1201070034',
    districtId: '1201070',
    name: 'Hilizoi',
  },
  {
    id: '1201071001',
    districtId: '1201071',
    name: 'Tuhembuasi',
  },
  {
    id: '1201071002',
    districtId: '1201071',
    name: 'Hilibadalu',
  },
  {
    id: '1201071003',
    districtId: '1201071',
    name: 'Lauri',
  },
  {
    id: '1201071004',
    districtId: '1201071',
    name: 'Hilimbana',
  },
  {
    id: '1201071005',
    districtId: '1201071',
    name: 'Saetagaramba',
  },
  {
    id: '1201071006',
    districtId: '1201071',
    name: 'Sogaeadu',
  },
  {
    id: '1201071007',
    districtId: '1201071',
    name: 'Baruzo',
  },
  {
    id: '1201071008',
    districtId: '1201071',
    name: 'Tulumbaho',
  },
  {
    id: '1201071009',
    districtId: '1201071',
    name: 'Sihareo Sogaeadu',
  },
  {
    id: '1201071010',
    districtId: '1201071',
    name: 'Wea-Wea',
  },
  {
    id: '1201071011',
    districtId: '1201071',
    name: 'Sisarahili Sogeadu',
  },
  {
    id: '1201081001',
    districtId: '1201081',
    name: 'Balodano',
  },
  {
    id: '1201081002',
    districtId: '1201081',
    name: 'Lewuoguru II',
  },
  {
    id: '1201081003',
    districtId: '1201081',
    name: 'Sisarahili Ma U',
  },
  {
    id: '1201081004',
    districtId: '1201081',
    name: 'Sihareo III',
  },
  {
    id: '1201081005',
    districtId: '1201081',
    name: 'Dekha',
  },
  {
    id: '1201081006',
    districtId: '1201081',
    name: 'Lasara Siwalubanua',
  },
  {
    id: '1201081007',
    districtId: '1201081',
    name: 'Tuhemberua',
  },
  {
    id: '1201081008',
    districtId: '1201081',
    name: 'Atualuo',
  },
  {
    id: '1201081009',
    districtId: '1201081',
    name: 'Lewa - Lewa',
  },
  {
    id: '1201081010',
    districtId: '1201081',
    name: 'Sihareo III Bawosaloo Berua',
  },
  {
    id: '1201081011',
    districtId: '1201081',
    name: 'Sihareo III Hilibadalu',
  },
  {
    id: '1201082001',
    districtId: '1201082',
    name: 'Sisobawino I',
  },
  {
    id: '1201082002',
    districtId: '1201082',
    name: 'Lewuombanua',
  },
  {
    id: '1201082003',
    districtId: '1201082',
    name: 'Iodano',
  },
  {
    id: '1201082004',
    districtId: '1201082',
    name: 'H U N O',
  },
  {
    id: '1201082005',
    districtId: '1201082',
    name: 'Lewuoguru I',
  },
  {
    id: '1201082006',
    districtId: '1201082',
    name: 'Sisaratandrawa',
  },
  {
    id: '1201082007',
    districtId: '1201082',
    name: 'Somolo-Molo',
  },
  {
    id: '1201082008',
    districtId: '1201082',
    name: 'Sifaoroasi',
  },
  {
    id: '1201082009',
    districtId: '1201082',
    name: 'Hiligodu Somolo-Molo',
  },
  {
    id: '1201082010',
    districtId: '1201082',
    name: 'Hilimborodano',
  },
  {
    id: '1201082011',
    districtId: '1201082',
    name: 'Soewali',
  },
  {
    id: '1201130020',
    districtId: '1201130',
    name: 'Onozitoli Dulu',
  },
  {
    id: '1201130021',
    districtId: '1201130',
    name: 'Sinarikhi',
  },
  {
    id: '1201130022',
    districtId: '1201130',
    name: 'Ombolata Saloo',
  },
  {
    id: '1201130023',
    districtId: '1201130',
    name: 'Sisobalauru',
  },
  {
    id: '1201130024',
    districtId: '1201130',
    name: 'Tuhegafoa II',
  },
  {
    id: '1201130025',
    districtId: '1201130',
    name: 'Ononamolo I Botomuzoi',
  },
  {
    id: '1201130026',
    districtId: '1201130',
    name: 'Fadoro Lauru',
  },
  {
    id: '1201130027',
    districtId: '1201130',
    name: 'D I M A',
  },
  {
    id: '1201130028',
    districtId: '1201130',
    name: 'Mazingo Tanoseo',
  },
  {
    id: '1201130029',
    districtId: '1201130',
    name: 'Sisobahili I Tanoseo',
  },
  {
    id: '1201130030',
    districtId: '1201130',
    name: 'Hiligodu Tanoseo',
  },
  {
    id: '1201130031',
    districtId: '1201130',
    name: 'Hiliduho',
  },
  {
    id: '1201130032',
    districtId: '1201130',
    name: 'Lasara Tanoseo',
  },
  {
    id: '1201130033',
    districtId: '1201130',
    name: 'Onowaembo Hiligara',
  },
  {
    id: '1201130034',
    districtId: '1201130',
    name: 'Silimabanua',
  },
  {
    id: '1201130035',
    districtId: '1201130',
    name: 'Ombolata Sarahili',
  },
  {
    id: '1201131001',
    districtId: '1201131',
    name: 'Fadoro Hunogoa',
  },
  {
    id: '1201131002',
    districtId: '1201131',
    name: 'Lolofaoso Lalai',
  },
  {
    id: '1201131003',
    districtId: '1201131',
    name: 'Fulolo Lalai',
  },
  {
    id: '1201131004',
    districtId: '1201131',
    name: 'Lalai I / II',
  },
  {
    id: '1201131005',
    districtId: '1201131',
    name: 'Lawa Lawa',
  },
  {
    id: '1201131006',
    districtId: '1201131',
    name: 'Lolowua',
  },
  {
    id: '1201131007',
    districtId: '1201131',
    name: 'Dahadano Botombawo',
  },
  {
    id: '1201131008',
    districtId: '1201131',
    name: 'Fadoro Lalai',
  },
  {
    id: '1201131009',
    districtId: '1201131',
    name: 'Lolowua Hiliwarasi',
  },
  {
    id: '1201131010',
    districtId: '1201131',
    name: 'Hilizia Lauru',
  },
  {
    id: '1201131011',
    districtId: '1201131',
    name: 'Lolo Faoso',
  },
  {
    id: '1201131012',
    districtId: '1201131',
    name: 'Onombongi',
  },
  {
    id: '1201131013',
    districtId: '1201131',
    name: 'Orahili Idanoi',
  },
  {
    id: '1201131014',
    districtId: '1201131',
    name: 'Awela',
  },
  {
    id: '1201131015',
    districtId: '1201131',
    name: 'Ehosakhozi',
  },
  {
    id: '1201132001',
    districtId: '1201132',
    name: 'Ononamolo Talafu',
  },
  {
    id: '1201132002',
    districtId: '1201132',
    name: 'Hiligodu Botomuzoi',
  },
  {
    id: '1201132003',
    districtId: '1201132',
    name: 'Lasara Botomuzoi',
  },
  {
    id: '1201132004',
    districtId: '1201132',
    name: 'Simanaere Botomuzoi',
  },
  {
    id: '1201132005',
    districtId: '1201132',
    name: 'Hiliwaele II',
  },
  {
    id: '1201132006',
    districtId: '1201132',
    name: 'Hilihambawa Botomuzoi',
  },
  {
    id: '1201132007',
    districtId: '1201132',
    name: 'Hiliwaele I',
  },
  {
    id: '1201132008',
    districtId: '1201132',
    name: 'Hilimbowo Botomuzoi',
  },
  {
    id: '1201132009',
    districtId: '1201132',
    name: 'Tuhegafoa I',
  },
  {
    id: '1201132010',
    districtId: '1201132',
    name: 'Balohili Botomuzoi',
  },
  {
    id: '1201132011',
    districtId: '1201132',
    name: 'Loloanaa',
  },
  {
    id: '1201132012',
    districtId: '1201132',
    name: 'Fulolo Botomuzoi',
  },
  {
    id: '1201132013',
    districtId: '1201132',
    name: 'Tetehosi Botomuzoi',
  },
  {
    id: '1201132014',
    districtId: '1201132',
    name: 'Mohili Berua Botomuzoi',
  },
  {
    id: '1201132015',
    districtId: '1201132',
    name: 'Sisobahili Dola',
  },
  {
    id: '1201132016',
    districtId: '1201132',
    name: 'Talafu',
  },
  {
    id: '1201132017',
    districtId: '1201132',
    name: 'Banua Sibohou Botomuzoi',
  },
  {
    id: '1201132018',
    districtId: '1201132',
    name: 'Olanori',
  },
  {
    id: '1202010001',
    districtId: '1202010',
    name: 'Pulau Tamang',
  },
  {
    id: '1202010002',
    districtId: '1202010',
    name: 'Pasar Batahan',
  },
  {
    id: '1202010003',
    districtId: '1202010',
    name: 'Batahan I',
  },
  {
    id: '1202010004',
    districtId: '1202010',
    name: 'Banjar Aur',
  },
  {
    id: '1202010005',
    districtId: '1202010',
    name: 'Kampung Kapas',
  },
  {
    id: '1202010006',
    districtId: '1202010',
    name: 'Batusondat',
  },
  {
    id: '1202010007',
    districtId: '1202010',
    name: 'Bintungan Bejangkar',
  },
  {
    id: '1202010010',
    districtId: '1202010',
    name: 'Kubangan Tompek',
  },
  {
    id: '1202010013',
    districtId: '1202010',
    name: 'Pasar Baru Batahan',
  },
  {
    id: '1202010014',
    districtId: '1202010',
    name: 'Kuala Batahan',
  },
  {
    id: '1202010015',
    districtId: '1202010',
    name: 'Sari Kenanga',
  },
  {
    id: '1202010016',
    districtId: '1202010',
    name: 'Muara Pertemuan',
  },
  {
    id: '1202010019',
    districtId: '1202010',
    name: 'Batahan II',
  },
  {
    id: '1202010020',
    districtId: '1202010',
    name: 'Batahan III',
  },
  {
    id: '1202010021',
    districtId: '1202010',
    name: 'Batahan IV',
  },
  {
    id: '1202010022',
    districtId: '1202010',
    name: 'Kampung Kapas I',
  },
  {
    id: '1202010024',
    districtId: '1202010',
    name: 'Sinunukan VI',
  },
  {
    id: '1202010027',
    districtId: '1202010',
    name: 'Kubangan Pandan Sari',
  },
  {
    id: '1202011001',
    districtId: '1202011',
    name: 'Sinunukan IV',
  },
  {
    id: '1202011002',
    districtId: '1202011',
    name: 'Sinunukan II',
  },
  {
    id: '1202011003',
    districtId: '1202011',
    name: 'Sinunukan I Central',
  },
  {
    id: '1202011004',
    districtId: '1202011',
    name: 'Sinunukan III',
  },
  {
    id: '1202011005',
    districtId: '1202011',
    name: 'Banjar Aur Utara',
  },
  {
    id: '1202011006',
    districtId: '1202011',
    name: 'Bintungan Bejangkar Baru',
  },
  {
    id: '1202011007',
    districtId: '1202011',
    name: 'Kampung Kapas II',
  },
  {
    id: '1202011008',
    districtId: '1202011',
    name: 'Pasir Putih',
  },
  {
    id: '1202011009',
    districtId: '1202011',
    name: 'Suka Damai',
  },
  {
    id: '1202011010',
    districtId: '1202011',
    name: 'Wido Daren',
  },
  {
    id: '1202011011',
    districtId: '1202011',
    name: 'Wono Sari',
  },
  {
    id: '1202011012',
    districtId: '1202011',
    name: 'Sinunukan I',
  },
  {
    id: '1202011013',
    districtId: '1202011',
    name: 'Sidomakmur',
  },
  {
    id: '1202011014',
    districtId: '1202011',
    name: 'Airapa',
  },
  {
    id: '1202020010',
    districtId: '1202020',
    name: 'Aek Nabara',
  },
  {
    id: '1202020027',
    districtId: '1202020',
    name: 'Ampung Siala',
  },
  {
    id: '1202020028',
    districtId: '1202020',
    name: 'Muara Parlampungan',
  },
  {
    id: '1202020029',
    districtId: '1202020',
    name: 'Banjar Malayu',
  },
  {
    id: '1202020030',
    districtId: '1202020',
    name: 'Muara Soma',
  },
  {
    id: '1202020031',
    districtId: '1202020',
    name: 'Ampung Padang',
  },
  {
    id: '1202020032',
    districtId: '1202020',
    name: 'Sipogu',
  },
  {
    id: '1202020033',
    districtId: '1202020',
    name: 'Tombang Kaluang',
  },
  {
    id: '1202020034',
    districtId: '1202020',
    name: 'Bangkelang',
  },
  {
    id: '1202020035',
    districtId: '1202020',
    name: 'Aek Nangali',
  },
  {
    id: '1202020036',
    districtId: '1202020',
    name: 'Rao-Rao',
  },
  {
    id: '1202020037',
    districtId: '1202020',
    name: 'Aek Guo',
  },
  {
    id: '1202020038',
    districtId: '1202020',
    name: 'Tarlola',
  },
  {
    id: '1202020039',
    districtId: '1202020',
    name: 'Ampung Julu',
  },
  {
    id: '1202020040',
    districtId: '1202020',
    name: 'Sopo Tinjak',
  },
  {
    id: '1202020041',
    districtId: '1202020',
    name: 'Batu Madinding',
  },
  {
    id: '1202020042',
    districtId: '1202020',
    name: 'Rantobi',
  },
  {
    id: '1202020043',
    districtId: '1202020',
    name: 'Hadangkahan',
  },
  {
    id: '1202020044',
    districtId: '1202020',
    name: 'Aek Manggis',
  },
  {
    id: '1202020045',
    districtId: '1202020',
    name: 'Guo Batu',
  },
  {
    id: '1202020046',
    districtId: '1202020',
    name: 'Simanguntong',
  },
  {
    id: '1202020047',
    districtId: '1202020',
    name: 'Aek Holbung',
  },
  {
    id: '1202020048',
    districtId: '1202020',
    name: 'Hatupangan',
  },
  {
    id: '1202020049',
    districtId: '1202020',
    name: 'Bulu Soma',
  },
  {
    id: '1202020050',
    districtId: '1202020',
    name: 'Jambur Baru',
  },
  {
    id: '1202020051',
    districtId: '1202020',
    name: 'Lubuk Bondar Panjang',
  },
  {
    id: '1202020052',
    districtId: '1202020',
    name: 'Tor Naincat',
  },
  {
    id: '1202020053',
    districtId: '1202020',
    name: 'Aek Baru Jae',
  },
  {
    id: '1202020054',
    districtId: '1202020',
    name: 'Aek Baru Julu',
  },
  {
    id: '1202020055',
    districtId: '1202020',
    name: 'Huta Lobu',
  },
  {
    id: '1202020056',
    districtId: '1202020',
    name: 'Lubuk Samboa',
  },
  {
    id: '1202021001',
    districtId: '1202021',
    name: 'Tapus',
  },
  {
    id: '1202021002',
    districtId: '1202021',
    name: 'Simpang Durian',
  },
  {
    id: '1202021014',
    districtId: '1202021',
    name: 'Simpang Bajole',
  },
  {
    id: '1202021015',
    districtId: '1202021',
    name: 'Bandar Limabung',
  },
  {
    id: '1202021016',
    districtId: '1202021',
    name: 'Aek Manyuruk',
  },
  {
    id: '1202021017',
    districtId: '1202021',
    name: 'Simpang Duku',
  },
  {
    id: '1202021018',
    districtId: '1202021',
    name: 'Simpang Koje',
  },
  {
    id: '1202021019',
    districtId: '1202021',
    name: 'Pangkalan',
  },
  {
    id: '1202021020',
    districtId: '1202021',
    name: 'Lancat',
  },
  {
    id: '1202021021',
    districtId: '1202021',
    name: 'Sikumbu',
  },
  {
    id: '1202021022',
    districtId: '1202021',
    name: 'Aek Garingging',
  },
  {
    id: '1202021023',
    districtId: '1202021',
    name: 'Perk. Simpang Gambir',
  },
  {
    id: '1202021024',
    districtId: '1202021',
    name: 'Simpang Gambir',
  },
  {
    id: '1202021025',
    districtId: '1202021',
    name: 'Lobung',
  },
  {
    id: '1202021027',
    districtId: '1202021',
    name: 'Kampung Baru',
  },
  {
    id: '1202021029',
    districtId: '1202021',
    name: 'Bonca Bayuon',
  },
  {
    id: '1202021030',
    districtId: '1202021',
    name: 'Dalan Lidang',
  },
  {
    id: '1202021031',
    districtId: '1202021',
    name: 'Parbatasan',
  },
  {
    id: '1202021032',
    districtId: '1202021',
    name: 'Tangsi Atas',
  },
  {
    id: '1202022001',
    districtId: '1202022',
    name: 'Sampuran',
  },
  {
    id: '1202022002',
    districtId: '1202022',
    name: 'Tandikek',
  },
  {
    id: '1202022003',
    districtId: '1202022',
    name: 'Gonting',
  },
  {
    id: '1202022004',
    districtId: '1202022',
    name: 'Bangun Saroha',
  },
  {
    id: '1202022005',
    districtId: '1202022',
    name: 'Simaninggir',
  },
  {
    id: '1202022006',
    districtId: '1202022',
    name: 'Banjar Maga',
  },
  {
    id: '1202022007',
    districtId: '1202022',
    name: 'Ranto Nalinjang',
  },
  {
    id: '1202022008',
    districtId: '1202022',
    name: 'Simpang Talap',
  },
  {
    id: '1202022009',
    districtId: '1202022',
    name: 'Manisak',
  },
  {
    id: '1202022010',
    districtId: '1202022',
    name: 'Huta Raja',
  },
  {
    id: '1202022011',
    districtId: '1202022',
    name: 'Muara Bangko',
  },
  {
    id: '1202022012',
    districtId: '1202022',
    name: 'Huta Baringin',
  },
  {
    id: '1202022013',
    districtId: '1202022',
    name: 'Ranto Panjang',
  },
  {
    id: '1202022014',
    districtId: '1202022',
    name: 'Dua Sepakat',
  },
  {
    id: '1202022015',
    districtId: '1202022',
    name: 'Huta Nauli',
  },
  {
    id: '1202022016',
    districtId: '1202022',
    name: 'Padangsilojongan',
  },
  {
    id: '1202022017',
    districtId: '1202022',
    name: 'Lubuk Kancah',
  },
  {
    id: '1202022018',
    districtId: '1202022',
    name: 'Gunung Godang',
  },
  {
    id: '1202030004',
    districtId: '1202030',
    name: 'Tobang',
  },
  {
    id: '1202030005',
    districtId: '1202030',
    name: 'Botung',
  },
  {
    id: '1202030010',
    districtId: '1202030',
    name: 'Muara Botung',
  },
  {
    id: '1202030014',
    districtId: '1202030',
    name: 'Hutarimbaru Sm',
  },
  {
    id: '1202030015',
    districtId: '1202030',
    name: 'Huta Pungkut Julu',
  },
  {
    id: '1202030016',
    districtId: '1202030',
    name: 'Huta Pungkut Tonga',
  },
  {
    id: '1202030017',
    districtId: '1202030',
    name: 'Usor Tolang',
  },
  {
    id: '1202030018',
    districtId: '1202030',
    name: 'Huta Pungkut Jae',
  },
  {
    id: '1202030019',
    districtId: '1202030',
    name: 'Tamiang',
  },
  {
    id: '1202030020',
    districtId: '1202030',
    name: 'Patialo',
  },
  {
    id: '1202030021',
    districtId: '1202030',
    name: 'Huta Dangka',
  },
  {
    id: '1202030022',
    districtId: '1202030',
    name: 'Muara Pungkut',
  },
  {
    id: '1202030023',
    districtId: '1202030',
    name: 'Manambin',
  },
  {
    id: '1202030025',
    districtId: '1202030',
    name: 'Pagar Gunung',
  },
  {
    id: '1202030026',
    districtId: '1202030',
    name: 'Batahan',
  },
  {
    id: '1202030027',
    districtId: '1202030',
    name: 'Sibio-Bio',
  },
  {
    id: '1202030028',
    districtId: '1202030',
    name: 'Ujung Marisi',
  },
  {
    id: '1202030029',
    districtId: '1202030',
    name: 'Gunung Tua Ms',
  },
  {
    id: '1202030030',
    districtId: '1202030',
    name: 'Padang Bulan',
  },
  {
    id: '1202030031',
    districtId: '1202030',
    name: 'Muara Siambak',
  },
  {
    id: '1202030032',
    districtId: '1202030',
    name: 'Simandolam',
  },
  {
    id: '1202030033',
    districtId: '1202030',
    name: 'Muarapotan',
  },
  {
    id: '1202030035',
    districtId: '1202030',
    name: 'Tombang Bustak',
  },
  {
    id: '1202030036',
    districtId: '1202030',
    name: 'Huta Baringin Tb',
  },
  {
    id: '1202030037',
    districtId: '1202030',
    name: 'Gading Bain',
  },
  {
    id: '1202030038',
    districtId: '1202030',
    name: 'Simpang Tolang Julu',
  },
  {
    id: '1202030039',
    districtId: '1202030',
    name: 'Huta Puli',
  },
  {
    id: '1202030040',
    districtId: '1202030',
    name: 'Sopo Sorik',
  },
  {
    id: '1202030045',
    districtId: '1202030',
    name: 'Simpang Tolang Jae',
  },
  {
    id: '1202030046',
    districtId: '1202030',
    name: 'Sayur Maincat',
  },
  {
    id: '1202030047',
    districtId: '1202030',
    name: 'Pasar Kotanopan',
  },
  {
    id: '1202030048',
    districtId: '1202030',
    name: 'Singengu Julu',
  },
  {
    id: '1202030049',
    districtId: '1202030',
    name: 'Singengu Jae',
  },
  {
    id: '1202030050',
    districtId: '1202030',
    name: 'Huta Padang Sm',
  },
  {
    id: '1202030051',
    districtId: '1202030',
    name: 'Gunung Tua Sm',
  },
  {
    id: '1202030052',
    districtId: '1202030',
    name: 'Saba Dolok',
  },
  {
    id: '1202031001',
    districtId: '1202031',
    name: 'Simpang Banyak Julu',
  },
  {
    id: '1202031002',
    districtId: '1202031',
    name: 'Simpang Banyak Jae',
  },
  {
    id: '1202031003',
    districtId: '1202031',
    name: 'Habincaran',
  },
  {
    id: '1202031004',
    districtId: '1202031',
    name: 'Huta Padang Up',
  },
  {
    id: '1202031005',
    districtId: '1202031',
    name: 'Huta Godang',
  },
  {
    id: '1202031006',
    districtId: '1202031',
    name: 'Alahan Kae',
  },
  {
    id: '1202031007',
    districtId: '1202031',
    name: 'Patahajang',
  },
  {
    id: '1202031008',
    districtId: '1202031',
    name: 'Tolang',
  },
  {
    id: '1202031009',
    districtId: '1202031',
    name: 'Hutarimbaru Up',
  },
  {
    id: '1202031010',
    districtId: '1202031',
    name: 'Simpang Duhu Lombang',
  },
  {
    id: '1202031011',
    districtId: '1202031',
    name: 'Simpang Duhu Dolok',
  },
  {
    id: '1202031012',
    districtId: '1202031',
    name: 'Simpang Pining',
  },
  {
    id: '1202031013',
    districtId: '1202031',
    name: 'Muara Saladi',
  },
  {
    id: '1202032001',
    districtId: '1202032',
    name: 'Pastap Julu',
  },
  {
    id: '1202032002',
    districtId: '1202032',
    name: 'Pastap',
  },
  {
    id: '1202032011',
    districtId: '1202032',
    name: 'Laru Dolok',
  },
  {
    id: '1202032012',
    districtId: '1202032',
    name: 'Huta Tonga Ab',
  },
  {
    id: '1202032013',
    districtId: '1202032',
    name: 'Muara Mais',
  },
  {
    id: '1202032014',
    districtId: '1202032',
    name: 'Padang Sanggar',
  },
  {
    id: '1202032015',
    districtId: '1202032',
    name: 'Angin Barat',
  },
  {
    id: '1202032016',
    districtId: '1202032',
    name: 'Muara Mais Jambur',
  },
  {
    id: '1202032017',
    districtId: '1202032',
    name: 'Laru Baringin',
  },
  {
    id: '1202032018',
    districtId: '1202032',
    name: 'Laru Bolak',
  },
  {
    id: '1202032019',
    districtId: '1202032',
    name: 'Pasar Laru',
  },
  {
    id: '1202032020',
    districtId: '1202032',
    name: 'Laru Lombang',
  },
  {
    id: '1202032021',
    districtId: '1202032',
    name: 'Tambangan Jae',
  },
  {
    id: '1202032022',
    districtId: '1202032',
    name: 'Lumban Pasir',
  },
  {
    id: '1202032023',
    districtId: '1202032',
    name: 'Tambangan Tonga',
  },
  {
    id: '1202032024',
    districtId: '1202032',
    name: 'Tambangan Pasoman',
  },
  {
    id: '1202032025',
    districtId: '1202032',
    name: 'Rao-Rao Dolok',
  },
  {
    id: '1202032026',
    districtId: '1202032',
    name: 'Rao-Rao Lombang',
  },
  {
    id: '1202032027',
    districtId: '1202032',
    name: 'Panjaringan',
  },
  {
    id: '1202032028',
    districtId: '1202032',
    name: 'Simangambat Tb',
  },
  {
    id: '1202033001',
    districtId: '1202033',
    name: 'Purba Baru',
  },
  {
    id: '1202033002',
    districtId: '1202033',
    name: 'Siantona',
  },
  {
    id: '1202033003',
    districtId: '1202033',
    name: 'Purba Lamo',
  },
  {
    id: '1202033004',
    districtId: '1202033',
    name: 'Bangun Purba',
  },
  {
    id: '1202033005',
    districtId: '1202033',
    name: 'Aek Marian Mg',
  },
  {
    id: '1202033006',
    districtId: '1202033',
    name: 'Pasar Maga',
  },
  {
    id: '1202033007',
    districtId: '1202033',
    name: 'Maga Dolok',
  },
  {
    id: '1202033008',
    districtId: '1202033',
    name: 'Maga Lombang',
  },
  {
    id: '1202033009',
    districtId: '1202033',
    name: 'Pangkat',
  },
  {
    id: '1202034001',
    districtId: '1202034',
    name: 'Huta Tinggi',
  },
  {
    id: '1202034002',
    districtId: '1202034',
    name: 'Hutanamale',
  },
  {
    id: '1202034003',
    districtId: '1202034',
    name: 'Huta Baringin',
  },
  {
    id: '1202034004',
    districtId: '1202034',
    name: 'Sibanggor Julu',
  },
  {
    id: '1202034005',
    districtId: '1202034',
    name: 'Sibanggor Jae',
  },
  {
    id: '1202034006',
    districtId: '1202034',
    name: 'Purba Julu',
  },
  {
    id: '1202034007',
    districtId: '1202034',
    name: 'Sibanggor Tonga',
  },
  {
    id: '1202034008',
    districtId: '1202034',
    name: 'Huta Lombang',
  },
  {
    id: '1202034009',
    districtId: '1202034',
    name: 'Huta Baru',
  },
  {
    id: '1202034010',
    districtId: '1202034',
    name: 'Handel',
  },
  {
    id: '1202034011',
    districtId: '1202034',
    name: 'Huta Baringin Julu',
  },
  {
    id: '1202040008',
    districtId: '1202040',
    name: 'Ranjo Batu',
  },
  {
    id: '1202040009',
    districtId: '1202040',
    name: 'Kampung Pinang',
  },
  {
    id: '1202040011',
    districtId: '1202040',
    name: 'Simpang Mandepo',
  },
  {
    id: '1202040012',
    districtId: '1202040',
    name: 'Bandar Panjang',
  },
  {
    id: '1202040013',
    districtId: '1202040',
    name: 'Pasar Muara Sipongi',
  },
  {
    id: '1202040014',
    districtId: '1202040',
    name: 'Sibinail',
  },
  {
    id: '1202040015',
    districtId: '1202040',
    name: 'Koto Baringin',
  },
  {
    id: '1202040016',
    districtId: '1202040',
    name: 'Tanjung Alai',
  },
  {
    id: '1202040017',
    districtId: '1202040',
    name: 'Limau Manis',
  },
  {
    id: '1202040018',
    districtId: '1202040',
    name: 'Bandar Panjang Tuo',
  },
  {
    id: '1202040019',
    districtId: '1202040',
    name: 'Tamiang Mudo',
  },
  {
    id: '1202040020',
    districtId: '1202040',
    name: 'Tanjung Medan',
  },
  {
    id: '1202040021',
    districtId: '1202040',
    name: 'Aek Botung',
  },
  {
    id: '1202040022',
    districtId: '1202040',
    name: 'Koto Boru',
  },
  {
    id: '1202040023',
    districtId: '1202040',
    name: 'Muara Kumpulan',
  },
  {
    id: '1202040024',
    districtId: '1202040',
    name: 'Tanjung Larangan',
  },
  {
    id: '1202041001',
    districtId: '1202041',
    name: 'Huta Julu',
  },
  {
    id: '1202041002',
    districtId: '1202041',
    name: 'Huta Padang',
  },
  {
    id: '1202041003',
    districtId: '1202041',
    name: 'Huta Toras',
  },
  {
    id: '1202041004',
    districtId: '1202041',
    name: 'Pakantan Lombang',
  },
  {
    id: '1202041005',
    districtId: '1202041',
    name: 'Huta Lancat',
  },
  {
    id: '1202041006',
    districtId: '1202041',
    name: 'Pakantan Dolok',
  },
  {
    id: '1202041007',
    districtId: '1202041',
    name: 'Silogun',
  },
  {
    id: '1202041008',
    districtId: '1202041',
    name: 'Huta Gambir',
  },
  {
    id: '1202050007',
    districtId: '1202050',
    name: 'Aek Banir',
  },
  {
    id: '1202050018',
    districtId: '1202050',
    name: 'Sipaga - Paga',
  },
  {
    id: '1202050019',
    districtId: '1202050',
    name: 'Parbangunan',
  },
  {
    id: '1202050028',
    districtId: '1202050',
    name: 'Pidoli Lombang',
  },
  {
    id: '1202050029',
    districtId: '1202050',
    name: 'Pidoli Dolok',
  },
  {
    id: '1202050030',
    districtId: '1202050',
    name: 'Darussalam',
  },
  {
    id: '1202050031',
    districtId: '1202050',
    name: 'Siobon Julu',
  },
  {
    id: '1202050032',
    districtId: '1202050',
    name: 'Kota Siantar',
  },
  {
    id: '1202050033',
    districtId: '1202050',
    name: 'Panyabungan II',
  },
  {
    id: '1202050034',
    districtId: '1202050',
    name: 'Panyabungan III',
  },
  {
    id: '1202050035',
    districtId: '1202050',
    name: 'Panyabungan I',
  },
  {
    id: '1202050036',
    districtId: '1202050',
    name: 'Pasar Hilir',
  },
  {
    id: '1202050037',
    districtId: '1202050',
    name: 'Panyabungan Julu',
  },
  {
    id: '1202050038',
    districtId: '1202050',
    name: 'Panyabungan Tonga',
  },
  {
    id: '1202050039',
    districtId: '1202050',
    name: 'Panyabungan Jae',
  },
  {
    id: '1202050040',
    districtId: '1202050',
    name: 'Adian Jior',
  },
  {
    id: '1202050044',
    districtId: '1202050',
    name: 'Gunung Manaon',
  },
  {
    id: '1202050045',
    districtId: '1202050',
    name: 'Kayu Jati',
  },
  {
    id: '1202050046',
    districtId: '1202050',
    name: 'Sigalapang Julu',
  },
  {
    id: '1202050047',
    districtId: '1202050',
    name: 'Kampung Padang',
  },
  {
    id: '1202050048',
    districtId: '1202050',
    name: 'Ipar Bondar',
  },
  {
    id: '1202050049',
    districtId: '1202050',
    name: 'Gunung Tua Jae',
  },
  {
    id: '1202050050',
    districtId: '1202050',
    name: 'Manyabar',
  },
  {
    id: '1202050051',
    districtId: '1202050',
    name: 'Sarak Matua',
  },
  {
    id: '1202050052',
    districtId: '1202050',
    name: 'Gunung Barani',
  },
  {
    id: '1202050062',
    districtId: '1202050',
    name: 'Salambue',
  },
  {
    id: '1202050063',
    districtId: '1202050',
    name: 'Aek Mata',
  },
  {
    id: '1202050064',
    districtId: '1202050',
    name: 'Huta Lombang Lubis',
  },
  {
    id: '1202050065',
    districtId: '1202050',
    name: 'Pagaran Tonga',
  },
  {
    id: '1202050066',
    districtId: '1202050',
    name: 'Sopo Batu',
  },
  {
    id: '1202050067',
    districtId: '1202050',
    name: 'Gunung Tua Julu',
  },
  {
    id: '1202050068',
    districtId: '1202050',
    name: 'Gunung Tua Tonga',
  },
  {
    id: '1202050069',
    districtId: '1202050',
    name: 'Lumban Pasir',
  },
  {
    id: '1202050070',
    districtId: '1202050',
    name: 'Dalan Lidang',
  },
  {
    id: '1202050071',
    districtId: '1202050',
    name: 'Siobon Jae',
  },
  {
    id: '1202050072',
    districtId: '1202050',
    name: 'Sipolu Polu',
  },
  {
    id: '1202050073',
    districtId: '1202050',
    name: 'Saba Jambu',
  },
  {
    id: '1202050074',
    districtId: '1202050',
    name: 'Panggorengan',
  },
  {
    id: '1202050075',
    districtId: '1202050',
    name: 'Manyabar Jae',
  },
  {
    id: '1202051001',
    districtId: '1202051',
    name: 'Hayu Raja',
  },
  {
    id: '1202051002',
    districtId: '1202051',
    name: 'Kayu Laut',
  },
  {
    id: '1202051003',
    districtId: '1202051',
    name: 'Tano Bato',
  },
  {
    id: '1202051004',
    districtId: '1202051',
    name: 'Roburan Lombang',
  },
  {
    id: '1202051005',
    districtId: '1202051',
    name: 'Roburan Dolok',
  },
  {
    id: '1202051006',
    districtId: '1202051',
    name: 'Lumban Dolok',
  },
  {
    id: '1202051007',
    districtId: '1202051',
    name: 'Huta Raja',
  },
  {
    id: '1202051008',
    districtId: '1202051',
    name: 'Hutaimbaru',
  },
  {
    id: '1202051009',
    districtId: '1202051',
    name: 'Aek Ngali',
  },
  {
    id: '1202051010',
    districtId: '1202051',
    name: 'Huta Julu',
  },
  {
    id: '1202051011',
    districtId: '1202051',
    name: 'Pagaran Gala-Gala',
  },
  {
    id: '1202052001',
    districtId: '1202052',
    name: 'Longat',
  },
  {
    id: '1202052002',
    districtId: '1202052',
    name: 'Sirambas',
  },
  {
    id: '1202052003',
    districtId: '1202052',
    name: 'Sabajior',
  },
  {
    id: '1202052004',
    districtId: '1202052',
    name: 'Hutabaringin',
  },
  {
    id: '1202052005',
    districtId: '1202052',
    name: 'Batang Gadis',
  },
  {
    id: '1202052006',
    districtId: '1202052',
    name: 'Barbaran',
  },
  {
    id: '1202052007',
    districtId: '1202052',
    name: 'Huta Tonga Barbaran',
  },
  {
    id: '1202052008',
    districtId: '1202052',
    name: 'Runding',
  },
  {
    id: '1202052009',
    districtId: '1202052',
    name: 'Barbaran Jae',
  },
  {
    id: '1202052010',
    districtId: '1202052',
    name: 'Batang Gadis Jae',
  },
  {
    id: '1202053005',
    districtId: '1202053',
    name: 'Baringin Jaya',
  },
  {
    id: '1202053006',
    districtId: '1202053',
    name: 'Simanondong',
  },
  {
    id: '1202053007',
    districtId: '1202053',
    name: 'Rumbio',
  },
  {
    id: '1202053008',
    districtId: '1202053',
    name: 'Mompang Julu',
  },
  {
    id: '1202053009',
    districtId: '1202053',
    name: 'Mompang Jae',
  },
  {
    id: '1202053010',
    districtId: '1202053',
    name: 'Huta Damai',
  },
  {
    id: '1202053011',
    districtId: '1202053',
    name: 'Suka Ramai',
  },
  {
    id: '1202053012',
    districtId: '1202053',
    name: 'Jambur Padang Matinggi',
  },
  {
    id: '1202053017',
    districtId: '1202053',
    name: 'Sopo Sorik',
  },
  {
    id: '1202053018',
    districtId: '1202053',
    name: 'Tanjung Mompang',
  },
  {
    id: '1202053019',
    districtId: '1202053',
    name: 'Tor Banua Raja',
  },
  {
    id: '1202053020',
    districtId: '1202053',
    name: 'Kampung Baru',
  },
  {
    id: '1202054001',
    districtId: '1202054',
    name: 'Tebing Tinggi',
  },
  {
    id: '1202054002',
    districtId: '1202054',
    name: 'Huta Rimbaru',
  },
  {
    id: '1202054003',
    districtId: '1202054',
    name: 'Gunung Baringin',
  },
  {
    id: '1202054004',
    districtId: '1202054',
    name: 'Tanjung',
  },
  {
    id: '1202054005',
    districtId: '1202054',
    name: 'Aek Nabara',
  },
  {
    id: '1202054006',
    districtId: '1202054',
    name: 'Pagur',
  },
  {
    id: '1202054007',
    districtId: '1202054',
    name: 'Ranto Natas',
  },
  {
    id: '1202054008',
    districtId: '1202054',
    name: 'Pardomuan',
  },
  {
    id: '1202054009',
    districtId: '1202054',
    name: 'Sirangkap',
  },
  {
    id: '1202054010',
    districtId: '1202054',
    name: 'Huta Tinggi',
  },
  {
    id: '1202054011',
    districtId: '1202054',
    name: 'Huta Bangun',
  },
  {
    id: '1202054012',
    districtId: '1202054',
    name: 'Parmompang',
  },
  {
    id: '1202054013',
    districtId: '1202054',
    name: 'Tanjung Julu',
  },
  {
    id: '1202054014',
    districtId: '1202054',
    name: 'Banjar Lancat',
  },
  {
    id: '1202054015',
    districtId: '1202054',
    name: 'Padang Laru',
  },
  {
    id: '1202055001',
    districtId: '1202055',
    name: 'Huta Bargot Dolok',
  },
  {
    id: '1202055002',
    districtId: '1202055',
    name: 'Huta Bargot Nauli',
  },
  {
    id: '1202055003',
    districtId: '1202055',
    name: 'Pasar Huta Bargot',
  },
  {
    id: '1202055004',
    districtId: '1202055',
    name: 'Bangun Sejati',
  },
  {
    id: '1202055005',
    districtId: '1202055',
    name: 'Huta Bargot Lombang',
  },
  {
    id: '1202055006',
    districtId: '1202055',
    name: 'Huta Bargot Setia',
  },
  {
    id: '1202055007',
    districtId: '1202055',
    name: 'Mondan',
  },
  {
    id: '1202055008',
    districtId: '1202055',
    name: 'Sayur Maincat',
  },
  {
    id: '1202055009',
    districtId: '1202055',
    name: 'Simalagi',
  },
  {
    id: '1202055010',
    districtId: '1202055',
    name: 'Hutarimbaru',
  },
  {
    id: '1202055011',
    districtId: '1202055',
    name: 'Kumpulan Setia',
  },
  {
    id: '1202055012',
    districtId: '1202055',
    name: 'Hutanaingkan',
  },
  {
    id: '1202055013',
    districtId: '1202055',
    name: 'Binanga',
  },
  {
    id: '1202055014',
    districtId: '1202055',
    name: 'Saba Padang',
  },
  {
    id: '1202060001',
    districtId: '1202060',
    name: 'Pardamean Baru',
  },
  {
    id: '1202060002',
    districtId: '1202060',
    name: 'Patiluban Mudik',
  },
  {
    id: '1202060003',
    districtId: '1202060',
    name: 'Kampung Sawah',
  },
  {
    id: '1202060004',
    districtId: '1202060',
    name: 'Pasar V Natal',
  },
  {
    id: '1202060005',
    districtId: '1202060',
    name: 'Pasar II Natal',
  },
  {
    id: '1202060006',
    districtId: '1202060',
    name: 'Pasar I Natal',
  },
  {
    id: '1202060007',
    districtId: '1202060',
    name: 'Setia Karya',
  },
  {
    id: '1202060008',
    districtId: '1202060',
    name: 'Patiluban Hilir',
  },
  {
    id: '1202060009',
    districtId: '1202060',
    name: 'Tegal Sari',
  },
  {
    id: '1202060010',
    districtId: '1202060',
    name: 'Perkebunan Patiluban',
  },
  {
    id: '1202060011',
    districtId: '1202060',
    name: 'Sikara Kara I',
  },
  {
    id: '1202060012',
    districtId: '1202060',
    name: 'Sikara Kara II',
  },
  {
    id: '1202060013',
    districtId: '1202060',
    name: 'Panggautan',
  },
  {
    id: '1202060014',
    districtId: '1202060',
    name: 'Taluk',
  },
  {
    id: '1202060015',
    districtId: '1202060',
    name: 'Sikara Kara',
  },
  {
    id: '1202060016',
    districtId: '1202060',
    name: 'Buburan',
  },
  {
    id: '1202060017',
    districtId: '1202060',
    name: 'Sikara Kara III',
  },
  {
    id: '1202060018',
    districtId: '1202060',
    name: 'Bintuas',
  },
  {
    id: '1202060019',
    districtId: '1202060',
    name: 'Sundutan Tigo',
  },
  {
    id: '1202060020',
    districtId: '1202060',
    name: 'Sikara Kara IV',
  },
  {
    id: '1202060021',
    districtId: '1202060',
    name: 'Balimbing',
  },
  {
    id: '1202060022',
    districtId: '1202060',
    name: 'Pasar III Natal',
  },
  {
    id: '1202060023',
    districtId: '1202060',
    name: 'Bondakase',
  },
  {
    id: '1202060024',
    districtId: '1202060',
    name: 'Tunas Karya',
  },
  {
    id: '1202060025',
    districtId: '1202060',
    name: 'Rukun Jaya',
  },
  {
    id: '1202060026',
    districtId: '1202060',
    name: 'Sinunukan V',
  },
  {
    id: '1202060027',
    districtId: '1202060',
    name: 'Suka Maju',
  },
  {
    id: '1202060028',
    districtId: '1202060',
    name: 'Sasaran',
  },
  {
    id: '1202060029',
    districtId: '1202060',
    name: 'Pasar VI Natal',
  },
  {
    id: '1202060030',
    districtId: '1202060',
    name: 'Kun-Kun',
  },
  {
    id: '1202070001',
    districtId: '1202070',
    name: 'Rantau Panjang',
  },
  {
    id: '1202070002',
    districtId: '1202070',
    name: 'Manuncang',
  },
  {
    id: '1202070003',
    districtId: '1202070',
    name: 'Lubuk Kapundung',
  },
  {
    id: '1202070004',
    districtId: '1202070',
    name: 'Hutaimbaru',
  },
  {
    id: '1202070005',
    districtId: '1202070',
    name: 'Panunggulan',
  },
  {
    id: '1202070006',
    districtId: '1202070',
    name: 'Tabuyung',
  },
  {
    id: '1202070007',
    districtId: '1202070',
    name: 'Pasar II Singkuang',
  },
  {
    id: '1202070008',
    districtId: '1202070',
    name: 'Pasar I Singkuang',
  },
  {
    id: '1202070009',
    districtId: '1202070',
    name: 'Sikapas',
  },
  {
    id: '1202070010',
    districtId: '1202070',
    name: 'Batu Mundom',
  },
  {
    id: '1202070011',
    districtId: '1202070',
    name: 'Tagilang Julu',
  },
  {
    id: '1202070012',
    districtId: '1202070',
    name: 'Sali Baru',
  },
  {
    id: '1202070013',
    districtId: '1202070',
    name: 'Suka Maju',
  },
  {
    id: '1202070014',
    districtId: '1202070',
    name: 'Lubuk Kapundung II',
  },
  {
    id: '1202070015',
    districtId: '1202070',
    name: 'UPT Tabuyung',
  },
  {
    id: '1202070016',
    districtId: '1202070',
    name: 'UPT Singkuang II',
  },
  {
    id: '1202070017',
    districtId: '1202070',
    name: 'UPT Singkuang I',
  },
  {
    id: '1202080010',
    districtId: '1202080',
    name: 'Pintu Padang Julu',
  },
  {
    id: '1202080011',
    districtId: '1202080',
    name: 'Huta Baringin',
  },
  {
    id: '1202080012',
    districtId: '1202080',
    name: 'Pintu Padang Jae',
  },
  {
    id: '1202080013',
    districtId: '1202080',
    name: 'Sinonoan',
  },
  {
    id: '1202080014',
    districtId: '1202080',
    name: 'Aek Mual',
  },
  {
    id: '1202080015',
    districtId: '1202080',
    name: 'Lumban Dolok',
  },
  {
    id: '1202080016',
    districtId: '1202080',
    name: 'Tangga Bosi I',
  },
  {
    id: '1202080017',
    districtId: '1202080',
    name: 'Huta Godang Muda',
  },
  {
    id: '1202080020',
    districtId: '1202080',
    name: 'Muara Batang Angkola',
  },
  {
    id: '1202080021',
    districtId: '1202080',
    name: 'Huraba I',
  },
  {
    id: '1202080022',
    districtId: '1202080',
    name: 'Simaninggir',
  },
  {
    id: '1202080023',
    districtId: '1202080',
    name: 'Siabu',
  },
  {
    id: '1202080024',
    districtId: '1202080',
    name: 'Bonan Dolok',
  },
  {
    id: '1202080025',
    districtId: '1202080',
    name: 'Lumban Pinasa',
  },
  {
    id: '1202080026',
    districtId: '1202080',
    name: 'Simangambat',
  },
  {
    id: '1202080027',
    districtId: '1202080',
    name: 'Huta Puli',
  },
  {
    id: '1202080028',
    districtId: '1202080',
    name: 'Huta Raja',
  },
  {
    id: '1202080029',
    districtId: '1202080',
    name: 'Sibaruang',
  },
  {
    id: '1202080030',
    districtId: '1202080',
    name: 'Sihepeng',
  },
  {
    id: '1202080031',
    districtId: '1202080',
    name: 'Tanjung Sialang',
  },
  {
    id: '1202080032',
    districtId: '1202080',
    name: 'Tangga Bosi II',
  },
  {
    id: '1202080033',
    districtId: '1202080',
    name: 'Tangga Bosi III',
  },
  {
    id: '1202080034',
    districtId: '1202080',
    name: 'Huraba II',
  },
  {
    id: '1202080036',
    districtId: '1202080',
    name: 'Sihepeng Sada',
  },
  {
    id: '1202080037',
    districtId: '1202080',
    name: 'Sihepeng Dua',
  },
  {
    id: '1202080038',
    districtId: '1202080',
    name: 'Sihepeng Tolu',
  },
  {
    id: '1202080039',
    districtId: '1202080',
    name: 'Sihepeng Opat',
  },
  {
    id: '1202080040',
    districtId: '1202080',
    name: 'Sihepeng Lima',
  },
  {
    id: '1202081006',
    districtId: '1202081',
    name: 'Janji Matogu',
  },
  {
    id: '1202081007',
    districtId: '1202081',
    name: 'Malintang Julu',
  },
  {
    id: '1202081008',
    districtId: '1202081',
    name: 'Malintang Jae',
  },
  {
    id: '1202081009',
    districtId: '1202081',
    name: 'Sidojadi',
  },
  {
    id: '1202081010',
    districtId: '1202081',
    name: 'Bange',
  },
  {
    id: '1202081011',
    districtId: '1202081',
    name: 'Huta Bangun',
  },
  {
    id: '1202081012',
    districtId: '1202081',
    name: 'Pasar Baru Malintang',
  },
  {
    id: '1202081013',
    districtId: '1202081',
    name: 'Malintang',
  },
  {
    id: '1202081014',
    districtId: '1202081',
    name: 'Lambou Darul Ihsan',
  },
  {
    id: '1202081015',
    districtId: '1202081',
    name: 'Bange Nauli',
  },
  {
    id: '1202081016',
    districtId: '1202081',
    name: 'Huta Bangun Jae',
  },
  {
    id: '1202082001',
    districtId: '1202082',
    name: 'Banua Rakyat',
  },
  {
    id: '1202082002',
    districtId: '1202082',
    name: 'Humbang I',
  },
  {
    id: '1202082003',
    districtId: '1202082',
    name: 'Sayur Matua',
  },
  {
    id: '1202082004',
    districtId: '1202082',
    name: 'Tarutung Panjang',
  },
  {
    id: '1202082005',
    districtId: '1202082',
    name: 'Tambiski',
  },
  {
    id: '1202082006',
    districtId: '1202082',
    name: 'Simanosor',
  },
  {
    id: '1202082007',
    districtId: '1202082',
    name: 'Tambiski Nauli',
  },
  {
    id: '1203010056',
    districtId: '1203010',
    name: 'Sorik',
  },
  {
    id: '1203010057',
    districtId: '1203010',
    name: 'Padang Kahombu',
  },
  {
    id: '1203010058',
    districtId: '1203010',
    name: 'Huta Padang',
  },
  {
    id: '1203010059',
    districtId: '1203010',
    name: 'Sori Madingin Pp',
  },
  {
    id: '1203010061',
    districtId: '1203010',
    name: 'Hurase',
  },
  {
    id: '1203010069',
    districtId: '1203010',
    name: 'Sigulang Losung',
  },
  {
    id: '1203010075',
    districtId: '1203010',
    name: 'Pasar Lama',
  },
  {
    id: '1203010076',
    districtId: '1203010',
    name: 'Sigalangan',
  },
  {
    id: '1203010079',
    districtId: '1203010',
    name: 'Janji Manaon',
  },
  {
    id: '1203010081',
    districtId: '1203010',
    name: 'Bargot Topong',
  },
  {
    id: '1203010083',
    districtId: '1203010',
    name: 'Sidadi II',
  },
  {
    id: '1203010084',
    districtId: '1203010',
    name: 'Sidadi I',
  },
  {
    id: '1203010087',
    districtId: '1203010',
    name: 'Janji Mauli Mt',
  },
  {
    id: '1203010088',
    districtId: '1203010',
    name: 'Muara Tais III',
  },
  {
    id: '1203010090',
    districtId: '1203010',
    name: 'Pargumbangan',
  },
  {
    id: '1203010094',
    districtId: '1203010',
    name: 'Pangaribuan',
  },
  {
    id: '1203010099',
    districtId: '1203010',
    name: 'Aek Nauli',
  },
  {
    id: '1203010106',
    districtId: '1203010',
    name: 'Muara Tais I',
  },
  {
    id: '1203010107',
    districtId: '1203010',
    name: 'Bintuju',
  },
  {
    id: '1203010108',
    districtId: '1203010',
    name: 'Huta Holbung',
  },
  {
    id: '1203010109',
    districtId: '1203010',
    name: 'Muara Tais II',
  },
  {
    id: '1203010110',
    districtId: '1203010',
    name: 'Basilam Baru',
  },
  {
    id: '1203010111',
    districtId: '1203010',
    name: 'Sipangko',
  },
  {
    id: '1203010114',
    districtId: '1203010',
    name: 'Benteng Huraba',
  },
  {
    id: '1203010115',
    districtId: '1203010',
    name: 'Kelurahan Pintu Padang I',
  },
  {
    id: '1203010116',
    districtId: '1203010',
    name: 'Kelurahan Pintu Padang II',
  },
  {
    id: '1203010117',
    districtId: '1203010',
    name: 'Bangun Purba',
  },
  {
    id: '1203010118',
    districtId: '1203010',
    name: 'Sitampa',
  },
  {
    id: '1203010119',
    districtId: '1203010',
    name: 'Pasir Matogu',
  },
  {
    id: '1203010120',
    districtId: '1203010',
    name: 'Sibulele Muara',
  },
  {
    id: '1203010121',
    districtId: '1203010',
    name: 'Aek Gunung',
  },
  {
    id: '1203010122',
    districtId: '1203010',
    name: 'Sorimanaon',
  },
  {
    id: '1203010123',
    districtId: '1203010',
    name: 'Tatengger',
  },
  {
    id: '1203010124',
    districtId: '1203010',
    name: 'Muara Purba Nauli',
  },
  {
    id: '1203010125',
    districtId: '1203010',
    name: 'Huta Tonga',
  },
  {
    id: '1203010126',
    districtId: '1203010',
    name: 'Tahalak Ujung Gading',
  },
  {
    id: '1203011031',
    districtId: '1203011',
    name: 'Huta Pardomuan',
  },
  {
    id: '1203011032',
    districtId: '1203011',
    name: 'Aek Badak Julu',
  },
  {
    id: '1203011033',
    districtId: '1203011',
    name: 'Aek Badak Jae',
  },
  {
    id: '1203011038',
    districtId: '1203011',
    name: 'Aek Libung',
  },
  {
    id: '1203011043',
    districtId: '1203011',
    name: 'Bulu Gading',
  },
  {
    id: '1203011044',
    districtId: '1203011',
    name: 'Bange',
  },
  {
    id: '1203011047',
    districtId: '1203011',
    name: 'Tolang Jae',
  },
  {
    id: '1203011048',
    districtId: '1203011',
    name: 'Mondang',
  },
  {
    id: '1203011049',
    districtId: '1203011',
    name: 'Janji Mauli Baringin',
  },
  {
    id: '1203011050',
    districtId: '1203011',
    name: 'Tolang Julu',
  },
  {
    id: '1203011051',
    districtId: '1203011',
    name: 'Sipange Godang',
  },
  {
    id: '1203011052',
    districtId: '1203011',
    name: 'Sipange Julu',
  },
  {
    id: '1203011053',
    districtId: '1203011',
    name: 'Sialang',
  },
  {
    id: '1203011058',
    districtId: '1203011',
    name: 'Somanggal Parmonangan',
  },
  {
    id: '1203011059',
    districtId: '1203011',
    name: 'Lumban Huayan',
  },
  {
    id: '1203011060',
    districtId: '1203011',
    name: 'Sayur Matinggi',
  },
  {
    id: '1203011061',
    districtId: '1203011',
    name: 'Silaiya',
  },
  {
    id: '1203011062',
    districtId: '1203011',
    name: 'Silaiya Tanjung Leuk',
  },
  {
    id: '1203011063',
    districtId: '1203011',
    name: 'Sipange Siunjam',
  },
  {
    id: '1203012001',
    districtId: '1203012',
    name: 'Simaninggir',
  },
  {
    id: '1203012002',
    districtId: '1203012',
    name: 'Kota Tua',
  },
  {
    id: '1203012003',
    districtId: '1203012',
    name: 'Harean',
  },
  {
    id: '1203012004',
    districtId: '1203012',
    name: 'Lumban Ratus',
  },
  {
    id: '1203012005',
    districtId: '1203012',
    name: 'Sisoma',
  },
  {
    id: '1203012006',
    districtId: '1203012',
    name: 'Ingul Jae',
  },
  {
    id: '1203012007',
    districtId: '1203012',
    name: 'Lumban Jabi-Jabi',
  },
  {
    id: '1203012008',
    districtId: '1203012',
    name: 'Purbatua',
  },
  {
    id: '1203012009',
    districtId: '1203012',
    name: 'Hutaraja',
  },
  {
    id: '1203012010',
    districtId: '1203012',
    name: 'Panabari Huta Tonga',
  },
  {
    id: '1203012011',
    districtId: '1203012',
    name: 'Situmba',
  },
  {
    id: '1203012012',
    districtId: '1203012',
    name: 'Batu Horpak',
  },
  {
    id: '1203012013',
    districtId: '1203012',
    name: 'Aek Kahombu',
  },
  {
    id: '1203012014',
    districtId: '1203012',
    name: 'Tanjung Medan',
  },
  {
    id: '1203012015',
    districtId: '1203012',
    name: 'Aek Parupuk',
  },
  {
    id: '1203012016',
    districtId: '1203012',
    name: 'Panindoan',
  },
  {
    id: '1203012017',
    districtId: '1203012',
    name: 'Aek Uncim',
  },
  {
    id: '1203070051',
    districtId: '1203070',
    name: 'Pargarutan Jae',
  },
  {
    id: '1203070054',
    districtId: '1203070',
    name: 'Sijungkang',
  },
  {
    id: '1203070058',
    districtId: '1203070',
    name: 'Huraba',
  },
  {
    id: '1203070060',
    districtId: '1203070',
    name: 'Huta Ginjang',
  },
  {
    id: '1203070067',
    districtId: '1203070',
    name: 'Pargarutan Julu',
  },
  {
    id: '1203070070',
    districtId: '1203070',
    name: 'Pargarutan Tonga',
  },
  {
    id: '1203070076',
    districtId: '1203070',
    name: 'Panompuan Jae',
  },
  {
    id: '1203070080',
    districtId: '1203070',
    name: 'Lantosan Rogas',
  },
  {
    id: '1203070094',
    districtId: '1203070',
    name: 'Pasar Pargarutan',
  },
  {
    id: '1203070095',
    districtId: '1203070',
    name: 'Pargarutan Dolok',
  },
  {
    id: '1203070096',
    districtId: '1203070',
    name: 'Pal XI',
  },
  {
    id: '1203070097',
    districtId: '1203070',
    name: 'Marisi',
  },
  {
    id: '1203070098',
    districtId: '1203070',
    name: 'Panompuan',
  },
  {
    id: '1203070099',
    districtId: '1203070',
    name: 'Batang Tura Sirumambe',
  },
  {
    id: '1203070100',
    districtId: '1203070',
    name: 'Sanggapati',
  },
  {
    id: '1203080001',
    districtId: '1203080',
    name: 'Kelurahan Pardomuan',
  },
  {
    id: '1203080002',
    districtId: '1203080',
    name: 'Sihuik Kuik',
  },
  {
    id: '1203080003',
    districtId: '1203080',
    name: 'Aek Natas',
  },
  {
    id: '1203080004',
    districtId: '1203080',
    name: 'Gunung Baringin',
  },
  {
    id: '1203080005',
    districtId: '1203080',
    name: 'Dolok Godang',
  },
  {
    id: '1203080006',
    districtId: '1203080',
    name: 'Kelurahan Simarpinggan',
  },
  {
    id: '1203080007',
    districtId: '1203080',
    name: 'Kelurahan Tapian Nauli',
  },
  {
    id: '1203080008',
    districtId: '1203080',
    name: 'Tandihat',
  },
  {
    id: '1203080009',
    districtId: '1203080',
    name: 'Sihopur',
  },
  {
    id: '1203080010',
    districtId: '1203080',
    name: 'Perk. Simarpinggan',
  },
  {
    id: '1203080011',
    districtId: '1203080',
    name: 'Siamporik Dolok',
  },
  {
    id: '1203080012',
    districtId: '1203080',
    name: 'Sibong Bong',
  },
  {
    id: '1203080013',
    districtId: '1203080',
    name: 'Siamporik Lombang',
  },
  {
    id: '1203080014',
    districtId: '1203080',
    name: 'Kelurahan Napa',
  },
  {
    id: '1203080015',
    districtId: '1203080',
    name: 'Pintu Padang',
  },
  {
    id: '1203080016',
    districtId: '1203080',
    name: 'Sinyior',
  },
  {
    id: '1203080017',
    districtId: '1203080',
    name: 'Situmbaga',
  },
  {
    id: '1203090004',
    districtId: '1203090',
    name: 'Siuhom',
  },
  {
    id: '1203090005',
    districtId: '1203090',
    name: 'Sisundung',
  },
  {
    id: '1203090006',
    districtId: '1203090',
    name: 'Parsalakan',
  },
  {
    id: '1203090012',
    districtId: '1203090',
    name: 'Sialogo',
  },
  {
    id: '1203090018',
    districtId: '1203090',
    name: 'Lembah Lubuk Raya',
  },
  {
    id: '1203090019',
    districtId: '1203090',
    name: 'Sitara Toit',
  },
  {
    id: '1203090020',
    districtId: '1203090',
    name: 'Lobu Layan Sigordang',
  },
  {
    id: '1203090021',
    districtId: '1203090',
    name: 'Aek Nabara',
  },
  {
    id: '1203090022',
    districtId: '1203090',
    name: 'Sibangkua',
  },
  {
    id: '1203090023',
    districtId: '1203090',
    name: 'Sigumuru',
  },
  {
    id: '1203090024',
    districtId: '1203090',
    name: 'Sitinjak',
  },
  {
    id: '1203090025',
    districtId: '1203090',
    name: 'Simatorkis Sisoma',
  },
  {
    id: '1203090026',
    districtId: '1203090',
    name: 'Panobasan',
  },
  {
    id: '1203090027',
    districtId: '1203090',
    name: 'Panobasan Lombang',
  },
  {
    id: '1203091001',
    districtId: '1203091',
    name: 'Malombu',
  },
  {
    id: '1203091002',
    districtId: '1203091',
    name: 'Rianiate',
  },
  {
    id: '1203091003',
    districtId: '1203091',
    name: 'Sangkunur',
  },
  {
    id: '1203091004',
    districtId: '1203091',
    name: 'Tindoan Laut',
  },
  {
    id: '1203091005',
    districtId: '1203091',
    name: 'Simataniari',
  },
  {
    id: '1203091006',
    districtId: '1203091',
    name: 'Batu Godang',
  },
  {
    id: '1203091007',
    districtId: '1203091',
    name: 'Aek Pardomuan',
  },
  {
    id: '1203091008',
    districtId: '1203091',
    name: 'Bandar Tarutung',
  },
  {
    id: '1203091009',
    districtId: '1203091',
    name: 'Perkebunan',
  },
  {
    id: '1203091010',
    districtId: '1203091',
    name: 'Simatohir',
  },
  {
    id: '1203100001',
    districtId: '1203100',
    name: 'Hapesong Lama',
  },
  {
    id: '1203100002',
    districtId: '1203100',
    name: 'Perk Hapesong',
  },
  {
    id: '1203100003',
    districtId: '1203100',
    name: 'Padang Lancat',
  },
  {
    id: '1203100009',
    districtId: '1203100',
    name: 'Sianggunan',
  },
  {
    id: '1203100010',
    districtId: '1203100',
    name: 'Hutabaru',
  },
  {
    id: '1203100017',
    districtId: '1203100',
    name: 'Sipenggeng',
  },
  {
    id: '1203100018',
    districtId: '1203100',
    name: 'Hapesong Baru',
  },
  {
    id: '1203100019',
    districtId: '1203100',
    name: 'Perkebunan Sigala-Gala',
  },
  {
    id: '1203100025',
    districtId: '1203100',
    name: 'Perk Batang Toru',
  },
  {
    id: '1203100026',
    districtId: '1203100',
    name: 'Telo',
  },
  {
    id: '1203100027',
    districtId: '1203100',
    name: 'Wek III Batang Toru',
  },
  {
    id: '1203100028',
    districtId: '1203100',
    name: 'Wek II',
  },
  {
    id: '1203100029',
    districtId: '1203100',
    name: 'Wek I',
  },
  {
    id: '1203100035',
    districtId: '1203100',
    name: 'Wek IV Batang Toru',
  },
  {
    id: '1203100036',
    districtId: '1203100',
    name: 'Napa',
  },
  {
    id: '1203100037',
    districtId: '1203100',
    name: 'Aek Pining',
  },
  {
    id: '1203100038',
    districtId: '1203100',
    name: 'Sumuran',
  },
  {
    id: '1203100058',
    districtId: '1203100',
    name: 'Batu Hula',
  },
  {
    id: '1203100061',
    districtId: '1203100',
    name: 'Huta Godang',
  },
  {
    id: '1203100062',
    districtId: '1203100',
    name: 'Garoga',
  },
  {
    id: '1203100063',
    districtId: '1203100',
    name: 'Batu Horing',
  },
  {
    id: '1203100064',
    districtId: '1203100',
    name: 'Aek Ngadol Nauli',
  },
  {
    id: '1203100065',
    districtId: '1203100',
    name: 'Sisipa',
  },
  {
    id: '1203101031',
    districtId: '1203101',
    name: 'Huraba',
  },
  {
    id: '1203101041',
    districtId: '1203101',
    name: 'Gunung Binanga',
  },
  {
    id: '1203101043',
    districtId: '1203101',
    name: 'Marancar Godang',
  },
  {
    id: '1203101050',
    districtId: '1203101',
    name: 'Simaninggir',
  },
  {
    id: '1203101051',
    districtId: '1203101',
    name: 'Marancar Julu',
  },
  {
    id: '1203101057',
    districtId: '1203101',
    name: 'Hau Natas',
  },
  {
    id: '1203101066',
    districtId: '1203101',
    name: 'Aek Nabara',
  },
  {
    id: '1203101067',
    districtId: '1203101',
    name: 'Gapuk Tua',
  },
  {
    id: '1203101068',
    districtId: '1203101',
    name: 'Pasar Sempurna',
  },
  {
    id: '1203101069',
    districtId: '1203101',
    name: 'Aek Sabaon',
  },
  {
    id: '1203101070',
    districtId: '1203101',
    name: 'Sugi',
  },
  {
    id: '1203101071',
    districtId: '1203101',
    name: 'Tanjung Dolok',
  },
  {
    id: '1203102001',
    districtId: '1203102',
    name: 'Muara Upu',
  },
  {
    id: '1203102002',
    districtId: '1203102',
    name: 'Bandar Hapinis',
  },
  {
    id: '1203102003',
    districtId: '1203102',
    name: 'Huta Raja',
  },
  {
    id: '1203102004',
    districtId: '1203102',
    name: 'Muara Manompas',
  },
  {
    id: '1203102006',
    districtId: '1203102',
    name: 'Pardamean',
  },
  {
    id: '1203102007',
    districtId: '1203102',
    name: 'Terapung Raya',
  },
  {
    id: '1203102008',
    districtId: '1203102',
    name: 'Muara Huta Raja',
  },
  {
    id: '1203102009',
    districtId: '1203102',
    name: 'Muara Ampolu',
  },
  {
    id: '1203102010',
    districtId: '1203102',
    name: 'Simarlelan',
  },
  {
    id: '1203110005',
    districtId: '1203110',
    name: 'Tolang',
  },
  {
    id: '1203110008',
    districtId: '1203110',
    name: 'Janji Mauli',
  },
  {
    id: '1203110028',
    districtId: '1203110',
    name: 'Baringin',
  },
  {
    id: '1203110032',
    districtId: '1203110',
    name: 'Parau Sorat',
  },
  {
    id: '1203110034',
    districtId: '1203110',
    name: 'Siala Gundi',
  },
  {
    id: '1203110036',
    districtId: '1203110',
    name: 'Barnang Koling',
  },
  {
    id: '1203110039',
    districtId: '1203110',
    name: 'Pargarutan',
  },
  {
    id: '1203110040',
    districtId: '1203110',
    name: 'Panaungan',
  },
  {
    id: '1203110046',
    districtId: '1203110',
    name: 'Pangaribuan',
  },
  {
    id: '1203110055',
    districtId: '1203110',
    name: 'Padang Bujur',
  },
  {
    id: '1203110056',
    districtId: '1203110',
    name: 'Simaninggir',
  },
  {
    id: '1203110057',
    districtId: '1203110',
    name: 'Paran Padang',
  },
  {
    id: '1203110059',
    districtId: '1203110',
    name: 'Pasar Sipirok',
  },
  {
    id: '1203110062',
    districtId: '1203110',
    name: 'Pangurabaan',
  },
  {
    id: '1203110066',
    districtId: '1203110',
    name: 'Bagas Lombang',
  },
  {
    id: '1203110070',
    districtId: '1203110',
    name: 'Paran Julu',
  },
  {
    id: '1203110071',
    districtId: '1203110',
    name: 'Bulu Mario',
  },
  {
    id: '1203110072',
    districtId: '1203110',
    name: 'Batu Satail',
  },
  {
    id: '1203110086',
    districtId: '1203110',
    name: 'Ramba Sihasur',
  },
  {
    id: '1203110093',
    districtId: '1203110',
    name: 'Sibadoar',
  },
  {
    id: '1203110095',
    districtId: '1203110',
    name: 'Hasang Marsada',
  },
  {
    id: '1203110097',
    districtId: '1203110',
    name: 'Bunga Bondar',
  },
  {
    id: '1203110099',
    districtId: '1203110',
    name: 'Sampean',
  },
  {
    id: '1203110101',
    districtId: '1203110',
    name: 'Sialaman',
  },
  {
    id: '1203110102',
    districtId: '1203110',
    name: 'Kilang Papan',
  },
  {
    id: '1203110103',
    districtId: '1203110',
    name: 'Saba Batang Miha',
  },
  {
    id: '1203110104',
    districtId: '1203110',
    name: 'Situmba',
  },
  {
    id: '1203110105',
    districtId: '1203110',
    name: 'Situmba Julu',
  },
  {
    id: '1203110106',
    districtId: '1203110',
    name: 'Batang Tura Julu',
  },
  {
    id: '1203110107',
    districtId: '1203110',
    name: 'Batang Tura',
  },
  {
    id: '1203110108',
    districtId: '1203110',
    name: 'Paran Dolok Mardomu',
  },
  {
    id: '1203110109',
    districtId: '1203110',
    name: 'Sarogodung',
  },
  {
    id: '1203110110',
    districtId: '1203110',
    name: 'Dolok Sordang',
  },
  {
    id: '1203110111',
    districtId: '1203110',
    name: 'Dolok Sordang Julu',
  },
  {
    id: '1203110112',
    districtId: '1203110',
    name: 'Huta Suhut',
  },
  {
    id: '1203110113',
    districtId: '1203110',
    name: 'Sipirok Godang',
  },
  {
    id: '1203110114',
    districtId: '1203110',
    name: 'Aek Batang Paya',
  },
  {
    id: '1203110115',
    districtId: '1203110',
    name: 'Marsada',
  },
  {
    id: '1203110116',
    districtId: '1203110',
    name: 'Luat Lombang',
  },
  {
    id: '1203110117',
    districtId: '1203110',
    name: 'Pahae Aek Sagala',
  },
  {
    id: '1203120031',
    districtId: '1203120',
    name: 'Sipogu',
  },
  {
    id: '1203120032',
    districtId: '1203120',
    name: 'Dalihan Natolu',
  },
  {
    id: '1203120033',
    districtId: '1203120',
    name: 'Pardomuan',
  },
  {
    id: '1203120034',
    districtId: '1203120',
    name: 'Arse Nauli',
  },
  {
    id: '1203120035',
    districtId: '1203120',
    name: 'Pinagar',
  },
  {
    id: '1203120036',
    districtId: '1203120',
    name: 'Nanggar Jati',
  },
  {
    id: '1203120037',
    districtId: '1203120',
    name: 'Aek Haminjon',
  },
  {
    id: '1203120038',
    districtId: '1203120',
    name: 'Nanggar Jati Huta Padang',
  },
  {
    id: '1203120039',
    districtId: '1203120',
    name: 'Natambang Roncitan',
  },
  {
    id: '1203120040',
    districtId: '1203120',
    name: 'Lancat',
  },
  {
    id: '1203160115',
    districtId: '1203160',
    name: 'Pintu Padang Mandalasena',
  },
  {
    id: '1203160116',
    districtId: '1203160',
    name: 'Silangkitang Tambiski',
  },
  {
    id: '1203160117',
    districtId: '1203160',
    name: 'Parau Sorat Sitabo Tabo',
  },
  {
    id: '1203160118',
    districtId: '1203160',
    name: 'Sunge Sigiring Giring',
  },
  {
    id: '1203160119',
    districtId: '1203160',
    name: 'Ulu Mamis Situnggaling',
  },
  {
    id: '1203160120',
    districtId: '1203160',
    name: 'Sipagimbar',
  },
  {
    id: '1203160121',
    districtId: '1203160',
    name: 'Sidapdap Simanosor',
  },
  {
    id: '1203160122',
    districtId: '1203160',
    name: 'Aek Simotung',
  },
  {
    id: '1203160123',
    districtId: '1203160',
    name: 'Saut Banua Simanosor',
  },
  {
    id: '1203160124',
    districtId: '1203160',
    name: 'Batang Parsuluman',
  },
  {
    id: '1203160125',
    districtId: '1203160',
    name: 'Damparan Haunatas',
  },
  {
    id: '1203160126',
    districtId: '1203160',
    name: 'Simangambat',
  },
  {
    id: '1203160127',
    districtId: '1203160',
    name: 'Somba Debata Purba',
  },
  {
    id: '1203160128',
    districtId: '1203160',
    name: 'Padang Mandailing Garugur',
  },
  {
    id: '1203161037',
    districtId: '1203161',
    name: 'Tapus Godang',
  },
  {
    id: '1203161045',
    districtId: '1203161',
    name: 'Lobutayas',
  },
  {
    id: '1203161070',
    districtId: '1203161',
    name: 'Sigolang',
  },
  {
    id: '1203161071',
    districtId: '1203161',
    name: 'Biru',
  },
  {
    id: '1203161080',
    districtId: '1203161',
    name: 'Sihulambu',
  },
  {
    id: '1203161091',
    districtId: '1203161',
    name: 'Aek Urat',
  },
  {
    id: '1203161092',
    districtId: '1203161',
    name: 'Huta Baru',
  },
  {
    id: '1203161093',
    districtId: '1203161',
    name: 'Aek Latong',
  },
  {
    id: '1203161094',
    districtId: '1203161',
    name: 'Tapus Sipagabu',
  },
  {
    id: '1203161095',
    districtId: '1203161',
    name: 'Tolang',
  },
  {
    id: '1203161096',
    districtId: '1203161',
    name: 'Silangkitang',
  },
  {
    id: '1203161097',
    districtId: '1203161',
    name: 'Gorahut',
  },
  {
    id: '1204010002',
    districtId: '1204010',
    name: 'Pinang Sori',
  },
  {
    id: '1204010003',
    districtId: '1204010',
    name: 'Gunung Marijo',
  },
  {
    id: '1204010004',
    districtId: '1204010',
    name: 'Sihaporas',
  },
  {
    id: '1204010005',
    districtId: '1204010',
    name: 'Sitonong Bangun',
  },
  {
    id: '1204010006',
    districtId: '1204010',
    name: 'Toga Basir',
  },
  {
    id: '1204010007',
    districtId: '1204010',
    name: 'Pinang Baru',
  },
  {
    id: '1204010008',
    districtId: '1204010',
    name: 'Parjalihotan Baru',
  },
  {
    id: '1204010009',
    districtId: '1204010',
    name: 'Danau Pandan',
  },
  {
    id: '1204010010',
    districtId: '1204010',
    name: 'Sori Nauli',
  },
  {
    id: '1204010011',
    districtId: '1204010',
    name: 'Albion Prancis',
  },
  {
    id: '1204011001',
    districtId: '1204011',
    name: 'Sitardas',
  },
  {
    id: '1204011002',
    districtId: '1204011',
    name: 'Jago-Jago',
  },
  {
    id: '1204011003',
    districtId: '1204011',
    name: 'Hutabalang',
  },
  {
    id: '1204011004',
    districtId: '1204011',
    name: 'Lopian',
  },
  {
    id: '1204011005',
    districtId: '1204011',
    name: 'Aek Horsik',
  },
  {
    id: '1204011006',
    districtId: '1204011',
    name: 'Kebun Pisang',
  },
  {
    id: '1204011007',
    districtId: '1204011',
    name: 'Gunung Kelambu',
  },
  {
    id: '1204011008',
    districtId: '1204011',
    name: 'Lubuk Ampolu',
  },
  {
    id: '1204011009',
    districtId: '1204011',
    name: 'Pagaran Honas',
  },
  {
    id: '1204020004',
    districtId: '1204020',
    name: 'Mombang Boru',
  },
  {
    id: '1204020005',
    districtId: '1204020',
    name: 'Anggoli',
  },
  {
    id: '1204020006',
    districtId: '1204020',
    name: 'Sibabangun',
  },
  {
    id: '1204020009',
    districtId: '1204020',
    name: 'Simanosor',
  },
  {
    id: '1204020010',
    districtId: '1204020',
    name: 'Muara Sibuntuon',
  },
  {
    id: '1204020011',
    districtId: '1204020',
    name: 'Sibio Bio',
  },
  {
    id: '1204020012',
    districtId: '1204020',
    name: 'Hutagurgur',
  },
  {
    id: '1204021001',
    districtId: '1204021',
    name: 'Lumut',
  },
  {
    id: '1204021002',
    districtId: '1204021',
    name: 'Lumut Nauli',
  },
  {
    id: '1204021003',
    districtId: '1204021',
    name: 'Lumut Maju',
  },
  {
    id: '1204021004',
    districtId: '1204021',
    name: 'Aek Gambir',
  },
  {
    id: '1204021005',
    districtId: '1204021',
    name: 'Masundung',
  },
  {
    id: '1204021006',
    districtId: '1204021',
    name: 'Sialogo',
  },
  {
    id: '1204022001',
    districtId: '1204022',
    name: 'Tebing Tinggi',
  },
  {
    id: '1204022002',
    districtId: '1204022',
    name: 'Pulo Pakat II',
  },
  {
    id: '1204022003',
    districtId: '1204022',
    name: 'Sihapas',
  },
  {
    id: '1204022004',
    districtId: '1204022',
    name: 'Pulo Pakat',
  },
  {
    id: '1204022005',
    districtId: '1204022',
    name: 'Janji Maria',
  },
  {
    id: '1204022006',
    districtId: '1204022',
    name: 'Sihadatuon',
  },
  {
    id: '1204030001',
    districtId: '1204030',
    name: 'Hajoran',
  },
  {
    id: '1204030010',
    districtId: '1204030',
    name: 'Aek Tolang',
  },
  {
    id: '1204030011',
    districtId: '1204030',
    name: 'Pandan',
  },
  {
    id: '1204030012',
    districtId: '1204030',
    name: 'Sibuluan Indah',
  },
  {
    id: '1204030013',
    districtId: '1204030',
    name: 'Lubuk Tukko',
  },
  {
    id: '1204030015',
    districtId: '1204030',
    name: 'Sibuluan Nauli',
  },
  {
    id: '1204030016',
    districtId: '1204030',
    name: 'Aek Sitio-Tio',
  },
  {
    id: '1204030017',
    districtId: '1204030',
    name: 'Sibuluan Raya',
  },
  {
    id: '1204030018',
    districtId: '1204030',
    name: 'Kalangan',
  },
  {
    id: '1204030019',
    districtId: '1204030',
    name: 'Pandan Wangi',
  },
  {
    id: '1204030020',
    districtId: '1204030',
    name: 'Sibuluan Terpadu',
  },
  {
    id: '1204030021',
    districtId: '1204030',
    name: 'Sitio-Tio Hilir',
  },
  {
    id: '1204030022',
    districtId: '1204030',
    name: 'Sibuluan Baru',
  },
  {
    id: '1204030023',
    districtId: '1204030',
    name: 'Lubuk Tukko Baru',
  },
  {
    id: '1204030024',
    districtId: '1204030',
    name: 'Sihaporas Nauli',
  },
  {
    id: '1204030025',
    districtId: '1204030',
    name: 'Pasar Baru',
  },
  {
    id: '1204030026',
    districtId: '1204030',
    name: 'Hajoran Indah',
  },
  {
    id: '1204030027',
    districtId: '1204030',
    name: 'Muara Nibung',
  },
  {
    id: '1204030028',
    districtId: '1204030',
    name: 'Aek Garut',
  },
  {
    id: '1204030029',
    districtId: '1204030',
    name: 'Budi Luhur',
  },
  {
    id: '1204030030',
    districtId: '1204030',
    name: 'Kalangan Indah',
  },
  {
    id: '1204030031',
    districtId: '1204030',
    name: 'Mangga Dua',
  },
  {
    id: '1204031001',
    districtId: '1204031',
    name: 'Sipange',
  },
  {
    id: '1204031002',
    districtId: '1204031',
    name: 'Hutanabolon',
  },
  {
    id: '1204031003',
    districtId: '1204031',
    name: 'Sigiring Giring',
  },
  {
    id: '1204031004',
    districtId: '1204031',
    name: 'Sait Kalangan II',
  },
  {
    id: '1204031005',
    districtId: '1204031',
    name: 'Aek Bontar',
  },
  {
    id: '1204031006',
    districtId: '1204031',
    name: 'Tapian Nauli/Saurmanggita',
  },
  {
    id: '1204031007',
    districtId: '1204031',
    name: 'Bonalumban',
  },
  {
    id: '1204031008',
    districtId: '1204031',
    name: 'Tukka',
  },
  {
    id: '1204031009',
    districtId: '1204031',
    name: 'Aek Tolang Induk',
  },
  {
    id: '1204032001',
    districtId: '1204032',
    name: 'Sibuluan Nalambok',
  },
  {
    id: '1204032002',
    districtId: '1204032',
    name: 'Sipan',
  },
  {
    id: '1204032003',
    districtId: '1204032',
    name: 'Sarudik',
  },
  {
    id: '1204032004',
    districtId: '1204032',
    name: 'Pondok Batu',
  },
  {
    id: '1204032005',
    districtId: '1204032',
    name: 'Pasir Bidang',
  },
  {
    id: '1204040001',
    districtId: '1204040',
    name: 'Tapian Nauli I',
  },
  {
    id: '1204040005',
    districtId: '1204040',
    name: 'Mela Dolok',
  },
  {
    id: '1204040006',
    districtId: '1204040',
    name: 'Aloban',
  },
  {
    id: '1204040007',
    districtId: '1204040',
    name: 'Tapian Nauli III',
  },
  {
    id: '1204040008',
    districtId: '1204040',
    name: 'Tapian Nauli II',
  },
  {
    id: '1204040009',
    districtId: '1204040',
    name: 'Tapian Nauli IV',
  },
  {
    id: '1204040011',
    districtId: '1204040',
    name: 'Mela I',
  },
  {
    id: '1204040012',
    districtId: '1204040',
    name: 'Mela II',
  },
  {
    id: '1204040013',
    districtId: '1204040',
    name: 'Bair',
  },
  {
    id: '1204041001',
    districtId: '1204041',
    name: 'Bonan Dolok',
  },
  {
    id: '1204041002',
    districtId: '1204041',
    name: 'Rampa',
  },
  {
    id: '1204041003',
    districtId: '1204041',
    name: 'Mardame',
  },
  {
    id: '1204041004',
    districtId: '1204041',
    name: 'Nauli',
  },
  {
    id: '1204041005',
    districtId: '1204041',
    name: 'Naga Timbul',
  },
  {
    id: '1204041006',
    districtId: '1204041',
    name: 'Simaninggir',
  },
  {
    id: '1204050001',
    districtId: '1204050',
    name: 'Unte Mungkur IV',
  },
  {
    id: '1204050003',
    districtId: '1204050',
    name: 'Unte Mungkur III',
  },
  {
    id: '1204050004',
    districtId: '1204050',
    name: 'Unte Mungkur II',
  },
  {
    id: '1204050006',
    districtId: '1204050',
    name: 'Unte Mungkur I',
  },
  {
    id: '1204050007',
    districtId: '1204050',
    name: 'Satahi Nauli',
  },
  {
    id: '1204050008',
    districtId: '1204050',
    name: 'Hurlang Muara Nauli',
  },
  {
    id: '1204050009',
    districtId: '1204050',
    name: 'Kolang Nauli',
  },
  {
    id: '1204050010',
    districtId: '1204050',
    name: 'Pasar Onan Hurlang',
  },
  {
    id: '1204050011',
    districtId: '1204050',
    name: 'Sipakpahi Aek Lobu',
  },
  {
    id: '1204050012',
    districtId: '1204050',
    name: 'Hudopa Nauli',
  },
  {
    id: '1204050013',
    districtId: '1204050',
    name: 'Rawa Makmur',
  },
  {
    id: '1204050014',
    districtId: '1204050',
    name: 'Makarti Nauli',
  },
  {
    id: '1204050015',
    districtId: '1204050',
    name: 'Pargaringan',
  },
  {
    id: '1204050016',
    districtId: '1204050',
    name: 'Simarpinggan',
  },
  {
    id: '1204060002',
    districtId: '1204060',
    name: 'Botot',
  },
  {
    id: '1204060003',
    districtId: '1204060',
    name: 'Sorkam',
  },
  {
    id: '1204060004',
    districtId: '1204060',
    name: 'Pargarutan',
  },
  {
    id: '1204060005',
    districtId: '1204060',
    name: 'Tarutung Bolak',
  },
  {
    id: '1204060006',
    districtId: '1204060',
    name: 'Gonting Mahe',
  },
  {
    id: '1204060009',
    districtId: '1204060',
    name: 'Pardamean',
  },
  {
    id: '1204060010',
    districtId: '1204060',
    name: 'Pelita',
  },
  {
    id: '1204060011',
    districtId: '1204060',
    name: 'Fajar',
  },
  {
    id: '1204060012',
    districtId: '1204060',
    name: 'Pearaja',
  },
  {
    id: '1204060013',
    districtId: '1204060',
    name: 'Nai Pos Pos Barat',
  },
  {
    id: '1204060021',
    districtId: '1204060',
    name: 'Rianiate',
  },
  {
    id: '1204060023',
    districtId: '1204060',
    name: 'Dolok Pantis',
  },
  {
    id: '1204060024',
    districtId: '1204060',
    name: 'Teluk Roban',
  },
  {
    id: '1204060025',
    districtId: '1204060',
    name: 'Sorkam Kiri',
  },
  {
    id: '1204060026',
    districtId: '1204060',
    name: 'Sorkam Tengah',
  },
  {
    id: '1204060027',
    districtId: '1204060',
    name: 'Hite Urat',
  },
  {
    id: '1204060028',
    districtId: '1204060',
    name: 'Pagaran Julu',
  },
  {
    id: '1204060029',
    districtId: '1204060',
    name: 'Pananggahan',
  },
  {
    id: '1204060030',
    districtId: '1204060',
    name: 'Sihapas',
  },
  {
    id: '1204060031',
    districtId: '1204060',
    name: 'Nauli',
  },
  {
    id: '1204060032',
    districtId: '1204060',
    name: 'Muara Nauli',
  },
  {
    id: '1204061001',
    districtId: '1204061',
    name: 'Maduma',
  },
  {
    id: '1204061002',
    districtId: '1204061',
    name: 'Pahieme',
  },
  {
    id: '1204061003',
    districtId: '1204061',
    name: 'Pasar Sorkam',
  },
  {
    id: '1204061004',
    districtId: '1204061',
    name: 'Sorkam Kanan',
  },
  {
    id: '1204061005',
    districtId: '1204061',
    name: 'Sipea Pea',
  },
  {
    id: '1204061006',
    districtId: '1204061',
    name: 'Aek Raso',
  },
  {
    id: '1204061007',
    districtId: '1204061',
    name: 'Pasaribu Tobing Jae',
  },
  {
    id: '1204061008',
    districtId: '1204061',
    name: 'Pahieme II',
  },
  {
    id: '1204061009',
    districtId: '1204061',
    name: 'Binasi',
  },
  {
    id: '1204061010',
    districtId: '1204061',
    name: 'Sidikalang',
  },
  {
    id: '1204061011',
    districtId: '1204061',
    name: 'Sorkam Kanan',
  },
  {
    id: '1204061012',
    districtId: '1204061',
    name: 'Madani',
  },
  {
    id: '1204062001',
    districtId: '1204062',
    name: 'Suga-Suga',
  },
  {
    id: '1204062002',
    districtId: '1204062',
    name: 'Suka Maju',
  },
  {
    id: '1204062003',
    districtId: '1204062',
    name: 'Aek Nadua',
  },
  {
    id: '1204062004',
    districtId: '1204062',
    name: 'Pasaribu Tobing',
  },
  {
    id: '1204062005',
    districtId: '1204062',
    name: 'Makmur',
  },
  {
    id: '1204062006',
    districtId: '1204062',
    name: 'Simargarap',
  },
  {
    id: '1204062007',
    districtId: '1204062',
    name: 'Sidaling',
  },
  {
    id: '1204062008',
    districtId: '1204062',
    name: 'Sipakpahi',
  },
  {
    id: '1204062009',
    districtId: '1204062',
    name: 'Po Simargarap',
  },
  {
    id: '1204070010',
    districtId: '1204070',
    name: 'Bukit Patupangan',
  },
  {
    id: '1204070011',
    districtId: '1204070',
    name: 'Kedai Gedang',
  },
  {
    id: '1204070012',
    districtId: '1204070',
    name: 'Sigambo Gambo',
  },
  {
    id: '1204070013',
    districtId: '1204070',
    name: 'Padang Masiang',
  },
  {
    id: '1204070014',
    districtId: '1204070',
    name: 'Kampung Solok',
  },
  {
    id: '1204070015',
    districtId: '1204070',
    name: 'Pasar Batu Gerigis',
  },
  {
    id: '1204070016',
    districtId: '1204070',
    name: 'Pasar Terandam',
  },
  {
    id: '1204070017',
    districtId: '1204070',
    name: 'Kinali',
  },
  {
    id: '1204070018',
    districtId: '1204070',
    name: 'Ujung Batu',
  },
  {
    id: '1204070019',
    districtId: '1204070',
    name: 'Kampung Mudik',
  },
  {
    id: '1204070020',
    districtId: '1204070',
    name: 'Gabungan Hasang',
  },
  {
    id: '1204070024',
    districtId: '1204070',
    name: 'Aek Dakka',
  },
  {
    id: '1204070036',
    districtId: '1204070',
    name: 'Bungo Tanjung',
  },
  {
    id: '1204071001',
    districtId: '1204071',
    name: 'Barambang',
  },
  {
    id: '1204071002',
    districtId: '1204071',
    name: 'Sosor Gadong',
  },
  {
    id: '1204071003',
    districtId: '1204071',
    name: 'Siantar Ca',
  },
  {
    id: '1204071004',
    districtId: '1204071',
    name: 'Muara Bolak',
  },
  {
    id: '1204071005',
    districtId: '1204071',
    name: 'Siantar Dolok',
  },
  {
    id: '1204071006',
    districtId: '1204071',
    name: 'Baringin',
  },
  {
    id: '1204071007',
    districtId: '1204071',
    name: 'Huta Tombak',
  },
  {
    id: '1204071008',
    districtId: '1204071',
    name: 'Sibintang',
  },
  {
    id: '1204071009',
    districtId: '1204071',
    name: 'Unte Boang',
  },
  {
    id: '1204072001',
    districtId: '1204072',
    name: 'Ladang Tengah',
  },
  {
    id: '1204072002',
    districtId: '1204072',
    name: 'Uratan',
  },
  {
    id: '1204072003',
    districtId: '1204072',
    name: 'Lobu Tua',
  },
  {
    id: '1204072004',
    districtId: '1204072',
    name: 'Bondar Sihudon II',
  },
  {
    id: '1204072005',
    districtId: '1204072',
    name: 'Bondar Sihudon I',
  },
  {
    id: '1204072006',
    districtId: '1204072',
    name: 'Rina Bolak',
  },
  {
    id: '1204072007',
    districtId: '1204072',
    name: 'Sosor Gonting',
  },
  {
    id: '1204072008',
    districtId: '1204072',
    name: 'Sirami Ramian',
  },
  {
    id: '1204072009',
    districtId: '1204072',
    name: 'Pangaribuan',
  },
  {
    id: '1204072010',
    districtId: '1204072',
    name: 'Sijungkang',
  },
  {
    id: '1204072011',
    districtId: '1204072',
    name: 'Sogar',
  },
  {
    id: '1204072012',
    districtId: '1204072',
    name: 'Sigolang',
  },
  {
    id: '1204072013',
    districtId: '1204072',
    name: 'Sitiris Tiris',
  },
  {
    id: '1204072014',
    districtId: '1204072',
    name: 'Sawah Lamo',
  },
  {
    id: '1204073001',
    districtId: '1204073',
    name: 'Pananggahan',
  },
  {
    id: '1204073002',
    districtId: '1204073',
    name: 'Purba Tua',
  },
  {
    id: '1204073003',
    districtId: '1204073',
    name: 'Hutaginjang',
  },
  {
    id: '1204073004',
    districtId: '1204073',
    name: 'Sihorbo',
  },
  {
    id: '1204073005',
    districtId: '1204073',
    name: 'Parik Sinomba',
  },
  {
    id: '1204073008',
    districtId: '1204073',
    name: 'Siharbangan',
  },
  {
    id: '1204080008',
    districtId: '1204080',
    name: 'Manduamas Lama',
  },
  {
    id: '1204080009',
    districtId: '1204080',
    name: 'Pasar Onan Manduamas',
  },
  {
    id: '1204080011',
    districtId: '1204080',
    name: 'Binjohara',
  },
  {
    id: '1204080012',
    districtId: '1204080',
    name: 'Pagaran Nauli',
  },
  {
    id: '1204080013',
    districtId: '1204080',
    name: 'Sarma Nauli',
  },
  {
    id: '1204080014',
    districtId: '1204080',
    name: 'Saragih',
  },
  {
    id: '1204080015',
    districtId: '1204080',
    name: 'Tumba',
  },
  {
    id: '1204080016',
    districtId: '1204080',
    name: 'Tumba Jae',
  },
  {
    id: '1204080017',
    districtId: '1204080',
    name: 'Lae Monong',
  },
  {
    id: '1204080018',
    districtId: '1204080',
    name: 'Manduamas Baru',
  },
  {
    id: '1204080019',
    districtId: '1204080',
    name: 'Saragih Timur',
  },
  {
    id: '1204080020',
    districtId: '1204080',
    name: 'Saragih Barat',
  },
  {
    id: '1204080021',
    districtId: '1204080',
    name: 'Binjohara Uruk',
  },
  {
    id: '1204080022',
    districtId: '1204080',
    name: 'Binjohara Baru',
  },
  {
    id: '1204080023',
    districtId: '1204080',
    name: 'Tambahan Nanjur',
  },
  {
    id: '1204080024',
    districtId: '1204080',
    name: 'Parsihotangan',
  },
  {
    id: '1204080025',
    districtId: '1204080',
    name: 'Tumba Nauli',
  },
  {
    id: '1204080026',
    districtId: '1204080',
    name: 'Perluasan',
  },
  {
    id: '1204080027',
    districtId: '1204080',
    name: 'Muara Tapus',
  },
  {
    id: '1204080028',
    districtId: '1204080',
    name: 'Pagaran Baru',
  },
  {
    id: '1204081001',
    districtId: '1204081',
    name: 'Sampang Maruhur',
  },
  {
    id: '1204081002',
    districtId: '1204081',
    name: 'Siordang',
  },
  {
    id: '1204081003',
    districtId: '1204081',
    name: 'Pardomuan',
  },
  {
    id: '1204081004',
    districtId: '1204081',
    name: 'Simpang III Lae Bingke',
  },
  {
    id: '1204081005',
    districtId: '1204081',
    name: 'Bajamas',
  },
  {
    id: '1204081006',
    districtId: '1204081',
    name: 'Masnauli',
  },
  {
    id: '1204081007',
    districtId: '1204081',
    name: 'Sigodung',
  },
  {
    id: '1204081008',
    districtId: '1204081',
    name: 'Muara Ore',
  },
  {
    id: '1205030001',
    districtId: '1205030',
    name: 'Manalu Purba',
  },
  {
    id: '1205030002',
    districtId: '1205030',
    name: 'Manalu Dolok',
  },
  {
    id: '1205030003',
    districtId: '1205030',
    name: 'Manalu',
  },
  {
    id: '1205030004',
    districtId: '1205030',
    name: 'Huta Julu',
  },
  {
    id: '1205030005',
    districtId: '1205030',
    name: 'Aek Raja',
  },
  {
    id: '1205030006',
    districtId: '1205030',
    name: 'Huta Tinggi',
  },
  {
    id: '1205030007',
    districtId: '1205030',
    name: 'Lobu Sunut',
  },
  {
    id: '1205030008',
    districtId: '1205030',
    name: 'Sisordak',
  },
  {
    id: '1205030009',
    districtId: '1205030',
    name: 'Hutatua',
  },
  {
    id: '1205030010',
    districtId: '1205030',
    name: 'Pertengahan',
  },
  {
    id: '1205030011',
    districtId: '1205030',
    name: 'Hutajulu Parbalik',
  },
  {
    id: '1205030012',
    districtId: '1205030',
    name: 'Horisan Ranggitgit',
  },
  {
    id: '1205030013',
    districtId: '1205030',
    name: 'Purba Dolok',
  },
  {
    id: '1205030014',
    districtId: '1205030',
    name: 'Batuarimo',
  },
  {
    id: '1205040001',
    districtId: '1205040',
    name: 'Pagaran Lambung I',
  },
  {
    id: '1205040002',
    districtId: '1205040',
    name: 'Sibalanga',
  },
  {
    id: '1205040003',
    districtId: '1205040',
    name: 'Pagaran Lambung II',
  },
  {
    id: '1205040004',
    districtId: '1205040',
    name: 'Pagaran Lambung III',
  },
  {
    id: '1205040005',
    districtId: '1205040',
    name: 'Pagaran Pisang',
  },
  {
    id: '1205040006',
    districtId: '1205040',
    name: 'Adiankoting',
  },
  {
    id: '1205040007',
    districtId: '1205040',
    name: 'Dolok Nauli',
  },
  {
    id: '1205040008',
    districtId: '1205040',
    name: 'Banuaji IV',
  },
  {
    id: '1205040009',
    districtId: '1205040',
    name: 'Banuaji I',
  },
  {
    id: '1205040010',
    districtId: '1205040',
    name: 'Banuaji II',
  },
  {
    id: '1205040011',
    districtId: '1205040',
    name: 'Pansur Batu',
  },
  {
    id: '1205040012',
    districtId: '1205040',
    name: 'Pardomuan Nauli',
  },
  {
    id: '1205040013',
    districtId: '1205040',
    name: 'Siantar Nai Pospos',
  },
  {
    id: '1205040014',
    districtId: '1205040',
    name: 'Pagaran Lambung IV',
  },
  {
    id: '1205040015',
    districtId: '1205040',
    name: 'Pansur Batu II',
  },
  {
    id: '1205040016',
    districtId: '1205040',
    name: 'Pansur Batu I',
  },
  {
    id: '1205050001',
    districtId: '1205050',
    name: 'Rura Julu Toruan',
  },
  {
    id: '1205050002',
    districtId: '1205050',
    name: 'Rura Julu Dolok',
  },
  {
    id: '1205050003',
    districtId: '1205050',
    name: 'Simanungkalit',
  },
  {
    id: '1205050004',
    districtId: '1205050',
    name: 'Hutauruk',
  },
  {
    id: '1205050005',
    districtId: '1205050',
    name: 'Situmeang Habinsaran',
  },
  {
    id: '1205050006',
    districtId: '1205050',
    name: 'Situmeang Hasundutan',
  },
  {
    id: '1205050007',
    districtId: '1205050',
    name: 'Lobusingkam',
  },
  {
    id: '1205050008',
    districtId: '1205050',
    name: 'Pagar Batu',
  },
  {
    id: '1205050009',
    districtId: '1205050',
    name: 'Sipahutar',
  },
  {
    id: '1205050010',
    districtId: '1205050',
    name: 'Huta Raja',
  },
  {
    id: '1205050011',
    districtId: '1205050',
    name: 'Tapian Nauli',
  },
  {
    id: '1205050012',
    districtId: '1205050',
    name: 'Huta Raja Hasundutan',
  },
  {
    id: '1205050013',
    districtId: '1205050',
    name: 'Huta Raja Simanungkalit',
  },
  {
    id: '1205050014',
    districtId: '1205050',
    name: 'Hutauruk Hasundutan',
  },
  {
    id: '1205060001',
    districtId: '1205060',
    name: 'Siandor Andor',
  },
  {
    id: '1205060002',
    districtId: '1205060',
    name: 'Hutapea Banuarea',
  },
  {
    id: '1205060008',
    districtId: '1205060',
    name: 'Parbubu Pea',
  },
  {
    id: '1205060009',
    districtId: '1205060',
    name: 'Parbubu II',
  },
  {
    id: '1205060010',
    districtId: '1205060',
    name: 'Parbubu Dolok',
  },
  {
    id: '1205060011',
    districtId: '1205060',
    name: 'Huta Toruan VIII',
  },
  {
    id: '1205060012',
    districtId: '1205060',
    name: 'Parbubu I',
  },
  {
    id: '1205060013',
    districtId: '1205060',
    name: 'Hutatoruan I',
  },
  {
    id: '1205060019',
    districtId: '1205060',
    name: 'Sosunggulon',
  },
  {
    id: '1205060020',
    districtId: '1205060',
    name: 'Parbaju Toruan',
  },
  {
    id: '1205060021',
    districtId: '1205060',
    name: 'Hapoltahan',
  },
  {
    id: '1205060022',
    districtId: '1205060',
    name: 'Huta Toruan IV',
  },
  {
    id: '1205060023',
    districtId: '1205060',
    name: 'Aek Sian Simun',
  },
  {
    id: '1205060024',
    districtId: '1205060',
    name: 'Huta Toruan V',
  },
  {
    id: '1205060025',
    districtId: '1205060',
    name: 'Huta Toruan VI',
  },
  {
    id: '1205060026',
    districtId: '1205060',
    name: 'Huta Toruan XI',
  },
  {
    id: '1205060027',
    districtId: '1205060',
    name: 'Huta Toruan IX',
  },
  {
    id: '1205060028',
    districtId: '1205060',
    name: 'Huta Toruan X',
  },
  {
    id: '1205060029',
    districtId: '1205060',
    name: 'Huta Toruan VII',
  },
  {
    id: '1205060030',
    districtId: '1205060',
    name: 'Partali Toruan',
  },
  {
    id: '1205060033',
    districtId: '1205060',
    name: 'Parbaju Tonga',
  },
  {
    id: '1205060034',
    districtId: '1205060',
    name: 'Simamora',
  },
  {
    id: '1205060035',
    districtId: '1205060',
    name: 'Hutagalung Siwaluompu',
  },
  {
    id: '1205060036',
    districtId: '1205060',
    name: 'Siraja Oloan',
  },
  {
    id: '1205060037',
    districtId: '1205060',
    name: 'Hutauruk',
  },
  {
    id: '1205060038',
    districtId: '1205060',
    name: 'Parbaju Julu',
  },
  {
    id: '1205060039',
    districtId: '1205060',
    name: 'Partali Julu',
  },
  {
    id: '1205060040',
    districtId: '1205060',
    name: 'Sitampurung',
  },
  {
    id: '1205060041',
    districtId: '1205060',
    name: 'Jambur Nauli',
  },
  {
    id: '1205060042',
    districtId: '1205060',
    name: 'Sihujur',
  },
  {
    id: '1205060043',
    districtId: '1205060',
    name: 'Hutatoruan III',
  },
  {
    id: '1205061001',
    districtId: '1205061',
    name: 'Pansur Napitu',
  },
  {
    id: '1205061002',
    districtId: '1205061',
    name: 'Lobuhole',
  },
  {
    id: '1205061003',
    districtId: '1205061',
    name: 'Sitompul',
  },
  {
    id: '1205061004',
    districtId: '1205061',
    name: 'Sangkaran',
  },
  {
    id: '1205061005',
    districtId: '1205061',
    name: 'Enda Portibi',
  },
  {
    id: '1205061006',
    districtId: '1205061',
    name: 'Si Raja Hutagalung',
  },
  {
    id: '1205061007',
    districtId: '1205061',
    name: 'Lumban Siagian Jae',
  },
  {
    id: '1205061008',
    districtId: '1205061',
    name: 'Lumban Siagian Julu',
  },
  {
    id: '1205061009',
    districtId: '1205061',
    name: 'Simorangkir Habinsaran',
  },
  {
    id: '1205061010',
    districtId: '1205061',
    name: 'Simorangkir Julu',
  },
  {
    id: '1205061011',
    districtId: '1205061',
    name: 'Simanampang',
  },
  {
    id: '1205061012',
    districtId: '1205061',
    name: 'Sidagal',
  },
  {
    id: '1205070001',
    districtId: '1205070',
    name: 'Pangurdotan',
  },
  {
    id: '1205070002',
    districtId: '1205070',
    name: 'Lumban Gaol',
  },
  {
    id: '1205070003',
    districtId: '1205070',
    name: 'Lumban Tonga',
  },
  {
    id: '1205070004',
    districtId: '1205070',
    name: 'Sitolu Ama',
  },
  {
    id: '1205070005',
    districtId: '1205070',
    name: 'Simanampang',
  },
  {
    id: '1205070006',
    districtId: '1205070',
    name: 'Lobu Pining',
  },
  {
    id: '1205070007',
    districtId: '1205070',
    name: 'Huta Barat',
  },
  {
    id: '1205070008',
    districtId: '1205070',
    name: 'Lumban Dolok',
  },
  {
    id: '1205070009',
    districtId: '1205070',
    name: 'Simardangiang',
  },
  {
    id: '1205070010',
    districtId: '1205070',
    name: 'Sibaganding',
  },
  {
    id: '1205070011',
    districtId: '1205070',
    name: 'Lumban Garaga',
  },
  {
    id: '1205070012',
    districtId: '1205070',
    name: 'Janji Matogu',
  },
  {
    id: '1205070013',
    districtId: '1205070',
    name: 'Lumban Jaean',
  },
  {
    id: '1205070014',
    districtId: '1205070',
    name: 'Onan Hasang',
  },
  {
    id: '1205070015',
    districtId: '1205070',
    name: 'Pantis',
  },
  {
    id: '1205070016',
    districtId: '1205070',
    name: 'Lontung Dolok',
  },
  {
    id: '1205070017',
    districtId: '1205070',
    name: 'Simataniari',
  },
  {
    id: '1205070018',
    districtId: '1205070',
    name: 'Simasom Toruan',
  },
  {
    id: '1205070019',
    districtId: '1205070',
    name: 'Simasom',
  },
  {
    id: '1205080013',
    districtId: '1205080',
    name: 'Sukamaju',
  },
  {
    id: '1205080019',
    districtId: '1205080',
    name: 'Sitolu Ompu',
  },
  {
    id: '1205080020',
    districtId: '1205080',
    name: 'Siopat Bahal',
  },
  {
    id: '1205080021',
    districtId: '1205080',
    name: 'Pasar Sarulla',
  },
  {
    id: '1205080022',
    districtId: '1205080',
    name: 'Nahornop Marsada',
  },
  {
    id: '1205080023',
    districtId: '1205080',
    name: 'Setia',
  },
  {
    id: '1205080025',
    districtId: '1205080',
    name: 'Parsaoran Samosir',
  },
  {
    id: '1205080026',
    districtId: '1205080',
    name: 'Pardomuan Nainggolan',
  },
  {
    id: '1205080027',
    districtId: '1205080',
    name: 'Parsaoran Nainggolan',
  },
  {
    id: '1205080028',
    districtId: '1205080',
    name: 'Pardamean Nainggolan',
  },
  {
    id: '1205080029',
    districtId: '1205080',
    name: 'Sigurung Gurung',
  },
  {
    id: '1205080030',
    districtId: '1205080',
    name: 'Silangkitang',
  },
  {
    id: '1205080031',
    districtId: '1205080',
    name: 'Tordolok Nauli',
  },
  {
    id: '1205081001',
    districtId: '1205081',
    name: 'Bonani Dolok',
  },
  {
    id: '1205081002',
    districtId: '1205081',
    name: 'Selamat',
  },
  {
    id: '1205081003',
    districtId: '1205081',
    name: 'Purbatua',
  },
  {
    id: '1205081004',
    districtId: '1205081',
    name: 'Pardomuan Janji Angkola',
  },
  {
    id: '1205081005',
    districtId: '1205081',
    name: 'Parsaoran Janji Angkola',
  },
  {
    id: '1205081006',
    districtId: '1205081',
    name: 'Janji Nauli',
  },
  {
    id: '1205081007',
    districtId: '1205081',
    name: 'Sitolu Bahal',
  },
  {
    id: '1205081008',
    districtId: '1205081',
    name: 'Robean',
  },
  {
    id: '1205081009',
    districtId: '1205081',
    name: 'Huta Nagodang',
  },
  {
    id: '1205081010',
    districtId: '1205081',
    name: 'Sidua Bahal',
  },
  {
    id: '1205081011',
    districtId: '1205081',
    name: 'Sibulan Bulan',
  },
  {
    id: '1205082001',
    districtId: '1205082',
    name: 'Silosung',
  },
  {
    id: '1205082002',
    districtId: '1205082',
    name: 'Simangumban Jae',
  },
  {
    id: '1205082003',
    districtId: '1205082',
    name: 'Dolok Sanggul',
  },
  {
    id: '1205082004',
    districtId: '1205082',
    name: 'Aek Nabara',
  },
  {
    id: '1205082005',
    districtId: '1205082',
    name: 'Simangumban Julu',
  },
  {
    id: '1205082006',
    districtId: '1205082',
    name: 'Lobu Sihim',
  },
  {
    id: '1205082007',
    districtId: '1205082',
    name: 'Dolok Saut',
  },
  {
    id: '1205082008',
    districtId: '1205082',
    name: 'Pardomuan',
  },
  {
    id: '1205090001',
    districtId: '1205090',
    name: 'Parlombuan',
  },
  {
    id: '1205090002',
    districtId: '1205090',
    name: 'Lumban Sinaga',
  },
  {
    id: '1205090003',
    districtId: '1205090',
    name: 'Pansur Natolu',
  },
  {
    id: '1205090004',
    districtId: '1205090',
    name: 'Silantom Julu',
  },
  {
    id: '1205090005',
    districtId: '1205090',
    name: 'Silantom Tonga',
  },
  {
    id: '1205090006',
    districtId: '1205090',
    name: 'Rahut Bosi',
  },
  {
    id: '1205090007',
    districtId: '1205090',
    name: 'Batuna Dua',
  },
  {
    id: '1205090008',
    districtId: '1205090',
    name: 'Sampagul',
  },
  {
    id: '1205090009',
    districtId: '1205090',
    name: 'Harianja',
  },
  {
    id: '1205090010',
    districtId: '1205090',
    name: 'Batu Manumpak',
  },
  {
    id: '1205090011',
    districtId: '1205090',
    name: 'Parsi Barungan',
  },
  {
    id: '1205090012',
    districtId: '1205090',
    name: 'Pakpahan',
  },
  {
    id: '1205090013',
    districtId: '1205090',
    name: 'Najumambe',
  },
  {
    id: '1205090014',
    districtId: '1205090',
    name: 'Purbatua',
  },
  {
    id: '1205090015',
    districtId: '1205090',
    name: 'Lumban Sormin',
  },
  {
    id: '1205090016',
    districtId: '1205090',
    name: 'Sibingke',
  },
  {
    id: '1205090017',
    districtId: '1205090',
    name: 'Godung Borotan',
  },
  {
    id: '1205090018',
    districtId: '1205090',
    name: 'Parratusan',
  },
  {
    id: '1205090019',
    districtId: '1205090',
    name: 'Sigotom Julu',
  },
  {
    id: '1205090020',
    districtId: '1205090',
    name: 'Parsorminan I',
  },
  {
    id: '1205090021',
    districtId: '1205090',
    name: 'Silantom Jae',
  },
  {
    id: '1205090022',
    districtId: '1205090',
    name: 'Padang Parsadaan',
  },
  {
    id: '1205090023',
    districtId: '1205090',
    name: 'Rahut Bosi Onan',
  },
  {
    id: '1205090024',
    districtId: '1205090',
    name: 'Hutaraja',
  },
  {
    id: '1205090025',
    districtId: '1205090',
    name: 'Sigotom Timur',
  },
  {
    id: '1205090026',
    districtId: '1205090',
    name: 'Sigotom Dolok Nauli',
  },
  {
    id: '1205100001',
    districtId: '1205100',
    name: 'Sibaganding',
  },
  {
    id: '1205100002',
    districtId: '1205100',
    name: 'Padang Siandomang',
  },
  {
    id: '1205100003',
    districtId: '1205100',
    name: 'Parinsoran Pangorian',
  },
  {
    id: '1205100004',
    districtId: '1205100',
    name: 'Aek Tangga',
  },
  {
    id: '1205100005',
    districtId: '1205100',
    name: 'Simpang Bolon',
  },
  {
    id: '1205100006',
    districtId: '1205100',
    name: 'Garoga Sibargot',
  },
  {
    id: '1205100007',
    districtId: '1205100',
    name: 'Gonting Garoga',
  },
  {
    id: '1205100008',
    districtId: '1205100',
    name: 'Sibalanga',
  },
  {
    id: '1205100009',
    districtId: '1205100',
    name: 'Parsosoran',
  },
  {
    id: '1205100010',
    districtId: '1205100',
    name: 'Lontung Jae I',
  },
  {
    id: '1205100011',
    districtId: '1205100',
    name: 'Lontung Jae II',
  },
  {
    id: '1205100012',
    districtId: '1205100',
    name: 'Gonting Salak',
  },
  {
    id: '1205100013',
    districtId: '1205100',
    name: 'Parmanuhan',
  },
  {
    id: '1205110001',
    districtId: '1205110',
    name: 'Onan Runggu I',
  },
  {
    id: '1205110002',
    districtId: '1205110',
    name: 'Sipahutar III',
  },
  {
    id: '1205110003',
    districtId: '1205110',
    name: 'Siabal Abal I',
  },
  {
    id: '1205110004',
    districtId: '1205110',
    name: 'Siabal Abal II',
  },
  {
    id: '1205110005',
    districtId: '1205110',
    name: 'Aek Nauli II',
  },
  {
    id: '1205110006',
    districtId: '1205110',
    name: 'Aek Nauli III',
  },
  {
    id: '1205110007',
    districtId: '1205110',
    name: 'Aek Nauli I',
  },
  {
    id: '1205110008',
    districtId: '1205110',
    name: 'Sabungan Nihuta V',
  },
  {
    id: '1205110009',
    districtId: '1205110',
    name: 'Siabal Abal III',
  },
  {
    id: '1205110010',
    districtId: '1205110',
    name: 'Sipahutar II',
  },
  {
    id: '1205110011',
    districtId: '1205110',
    name: 'Sipahutar I',
  },
  {
    id: '1205110012',
    districtId: '1205110',
    name: 'Onan Runggu III',
  },
  {
    id: '1205110013',
    districtId: '1205110',
    name: 'Onan Runggu II',
  },
  {
    id: '1205110014',
    districtId: '1205110',
    name: 'Onan Runggu IV',
  },
  {
    id: '1205110015',
    districtId: '1205110',
    name: 'Sabungan Nihuta I',
  },
  {
    id: '1205110016',
    districtId: '1205110',
    name: 'Sabungan Nihuta II',
  },
  {
    id: '1205110017',
    districtId: '1205110',
    name: 'Sabungan Nihuta III',
  },
  {
    id: '1205110018',
    districtId: '1205110',
    name: 'Sabungan Nihuta IV',
  },
  {
    id: '1205110019',
    districtId: '1205110',
    name: 'Tapian Nauli II',
  },
  {
    id: '1205110020',
    districtId: '1205110',
    name: 'Tapian Nauli III',
  },
  {
    id: '1205110021',
    districtId: '1205110',
    name: 'Tapian Nauli I',
  },
  {
    id: '1205110022',
    districtId: '1205110',
    name: 'Siabal Abal IV',
  },
  {
    id: '1205110023',
    districtId: '1205110',
    name: 'Aek Nauli IV',
  },
  {
    id: '1205110024',
    districtId: '1205110',
    name: 'Siabal-Abal VI',
  },
  {
    id: '1205110025',
    districtId: '1205110',
    name: 'Siabal-Abal V',
  },
  {
    id: '1205120001',
    districtId: '1205120',
    name: 'Lumban Tonga Tonga',
  },
  {
    id: '1205120002',
    districtId: '1205120',
    name: 'Paniaran',
  },
  {
    id: '1205120003',
    districtId: '1205120',
    name: 'Bahal Batu III',
  },
  {
    id: '1205120004',
    districtId: '1205120',
    name: 'Bahal Batu II',
  },
  {
    id: '1205120005',
    districtId: '1205120',
    name: 'Bahal Batu I',
  },
  {
    id: '1205120006',
    districtId: '1205120',
    name: 'Sitabo-Tabo',
  },
  {
    id: '1205120007',
    districtId: '1205120',
    name: 'Siborong-Borong I',
  },
  {
    id: '1205120008',
    districtId: '1205120',
    name: 'Siaro',
  },
  {
    id: '1205120009',
    districtId: '1205120',
    name: 'Sitampurung',
  },
  {
    id: '1205120010',
    districtId: '1205120',
    name: 'Pasar Siborong-Borong',
  },
  {
    id: '1205120011',
    districtId: '1205120',
    name: 'Pohan Tonga',
  },
  {
    id: '1205120012',
    districtId: '1205120',
    name: 'Lobu Siregar II',
  },
  {
    id: '1205120013',
    districtId: '1205120',
    name: 'Hutabulu',
  },
  {
    id: '1205120014',
    districtId: '1205120',
    name: 'Lobu Siregar I',
  },
  {
    id: '1205120015',
    districtId: '1205120',
    name: 'Pohan Jae',
  },
  {
    id: '1205120016',
    districtId: '1205120',
    name: 'Pohan Julu',
  },
  {
    id: '1205120017',
    districtId: '1205120',
    name: 'Parik Sabungan',
  },
  {
    id: '1205120018',
    districtId: '1205120',
    name: 'Siborong-Borong II',
  },
  {
    id: '1205120019',
    districtId: '1205120',
    name: 'Sigumbang',
  },
  {
    id: '1205120020',
    districtId: '1205120',
    name: 'Sitabotabo Toruan',
  },
  {
    id: '1205120021',
    districtId: '1205120',
    name: 'Silait-Lait',
  },
  {
    id: '1205130001',
    districtId: '1205130',
    name: 'Sibaragas',
  },
  {
    id: '1205130002',
    districtId: '1205130',
    name: 'Lumban Motung',
  },
  {
    id: '1205130003',
    districtId: '1205130',
    name: 'Banua Luhu',
  },
  {
    id: '1205130004',
    districtId: '1205130',
    name: 'Lumban Julu',
  },
  {
    id: '1205130005',
    districtId: '1205130',
    name: 'Lubis',
  },
  {
    id: '1205130006',
    districtId: '1205130',
    name: 'Lumban Ina Ina',
  },
  {
    id: '1205130007',
    districtId: '1205130',
    name: 'Pagaran',
  },
  {
    id: '1205130008',
    districtId: '1205130',
    name: 'Parhorboan',
  },
  {
    id: '1205130009',
    districtId: '1205130',
    name: 'Sipultak',
  },
  {
    id: '1205130010',
    districtId: '1205130',
    name: 'Dolok Saribu',
  },
  {
    id: '1205130011',
    districtId: '1205130',
    name: 'Lumban Silintong',
  },
  {
    id: '1205130012',
    districtId: '1205130',
    name: 'Simamora Hasibuan',
  },
  {
    id: '1205130013',
    districtId: '1205130',
    name: 'Sipultak  Dolok',
  },
  {
    id: '1205130014',
    districtId: '1205130',
    name: 'Hasibuan',
  },
  {
    id: '1205180007',
    districtId: '1205180',
    name: 'Huta Lontung',
  },
  {
    id: '1205180008',
    districtId: '1205180',
    name: 'Bariba Niaek',
  },
  {
    id: '1205180009',
    districtId: '1205180',
    name: 'Silali Toruan',
  },
  {
    id: '1205180010',
    districtId: '1205180',
    name: 'Hutana Godang',
  },
  {
    id: '1205180011',
    districtId: '1205180',
    name: 'Unte Mungkur',
  },
  {
    id: '1205180012',
    districtId: '1205180',
    name: 'Batu Binumbun',
  },
  {
    id: '1205180013',
    districtId: '1205180',
    name: 'Simatupang',
  },
  {
    id: '1205180014',
    districtId: '1205180',
    name: 'Aritonang',
  },
  {
    id: '1205180015',
    districtId: '1205180',
    name: 'Dolok Martumbur',
  },
  {
    id: '1205180016',
    districtId: '1205180',
    name: 'Sitanggor',
  },
  {
    id: '1205180017',
    districtId: '1205180',
    name: 'Huta Ginjang',
  },
  {
    id: '1205180018',
    districtId: '1205180',
    name: 'Silando',
  },
  {
    id: '1205180019',
    districtId: '1205180',
    name: 'Papande',
  },
  {
    id: '1205180020',
    districtId: '1205180',
    name: 'Sibandang',
  },
  {
    id: '1205180021',
    districtId: '1205180',
    name: 'Sampuran',
  },
  {
    id: '1206030004',
    districtId: '1206030',
    name: 'Aek Bolon Julu',
  },
  {
    id: '1206030005',
    districtId: '1206030',
    name: 'Aek Bolon Jae',
  },
  {
    id: '1206030006',
    districtId: '1206030',
    name: 'Siboruon',
  },
  {
    id: '1206030007',
    districtId: '1206030',
    name: 'Hutagaol Peatalum',
  },
  {
    id: '1206030008',
    districtId: '1206030',
    name: 'Bonan Dolok II',
  },
  {
    id: '1206030009',
    districtId: '1206030',
    name: 'Huta Namora',
  },
  {
    id: '1206030010',
    districtId: '1206030',
    name: 'Huta Dame',
  },
  {
    id: '1206030011',
    districtId: '1206030',
    name: 'Bonan Dolok I',
  },
  {
    id: '1206030012',
    districtId: '1206030',
    name: 'Bonan Dolok III',
  },
  {
    id: '1206030013',
    districtId: '1206030',
    name: 'Sibuntuon',
  },
  {
    id: '1206030014',
    districtId: '1206030',
    name: 'Lumban Gorat',
  },
  {
    id: '1206030015',
    districtId: '1206030',
    name: 'Sianipar Sihail Hail',
  },
  {
    id: '1206030016',
    districtId: '1206030',
    name: 'Silalahi Pagar Batu',
  },
  {
    id: '1206030017',
    districtId: '1206030',
    name: 'Hinalang Bagasan',
  },
  {
    id: '1206030018',
    districtId: '1206030',
    name: 'Sangkar Nihuta',
  },
  {
    id: '1206030019',
    districtId: '1206030',
    name: 'Pardede Onan',
  },
  {
    id: '1206030020',
    districtId: '1206030',
    name: 'Napitupulu Bagasan',
  },
  {
    id: '1206030021',
    districtId: '1206030',
    name: 'Balige III',
  },
  {
    id: '1206030022',
    districtId: '1206030',
    name: 'Balige II',
  },
  {
    id: '1206030023',
    districtId: '1206030',
    name: 'Paindoan',
  },
  {
    id: '1206030024',
    districtId: '1206030',
    name: 'Parsuratan',
  },
  {
    id: '1206030025',
    districtId: '1206030',
    name: 'Huta Bulu Mejan',
  },
  {
    id: '1206030026',
    districtId: '1206030',
    name: 'Sariburaja Janji Maria',
  },
  {
    id: '1206030027',
    districtId: '1206030',
    name: 'Baru Ara',
  },
  {
    id: '1206030028',
    districtId: '1206030',
    name: 'Matio',
  },
  {
    id: '1206030029',
    districtId: '1206030',
    name: 'Lumban Pea',
  },
  {
    id: '1206030030',
    districtId: '1206030',
    name: 'Lumban Gaol',
  },
  {
    id: '1206030031',
    districtId: '1206030',
    name: 'Sibola Hotangsas',
  },
  {
    id: '1206030032',
    districtId: '1206030',
    name: 'Lumban Bul Bul',
  },
  {
    id: '1206030033',
    districtId: '1206030',
    name: 'Balige I',
  },
  {
    id: '1206030034',
    districtId: '1206030',
    name: 'Lumban Dolok',
  },
  {
    id: '1206030035',
    districtId: '1206030',
    name: 'Longat',
  },
  {
    id: '1206030037',
    districtId: '1206030',
    name: 'Lumban Silintong',
  },
  {
    id: '1206030038',
    districtId: '1206030',
    name: 'Lumban Pea Timur',
  },
  {
    id: '1206030039',
    districtId: '1206030',
    name: 'Tambunan Sunge',
  },
  {
    id: '1206031001',
    districtId: '1206031',
    name: 'Tangga Batu Barat',
  },
  {
    id: '1206031002',
    districtId: '1206031',
    name: 'Tangga Batu Timur',
  },
  {
    id: '1206031003',
    districtId: '1206031',
    name: 'Gurgur  Aek Raja',
  },
  {
    id: '1206031004',
    districtId: '1206031',
    name: 'Lintong Nihuta',
  },
  {
    id: '1206031005',
    districtId: '1206031',
    name: 'Tara Bunga',
  },
  {
    id: '1206031006',
    districtId: '1206031',
    name: 'M E A T',
  },
  {
    id: '1206040001',
    districtId: '1206040',
    name: 'Haunatas I',
  },
  {
    id: '1206040002',
    districtId: '1206040',
    name: 'Sintong Marnipi',
  },
  {
    id: '1206040003',
    districtId: '1206040',
    name: 'Sidulang',
  },
  {
    id: '1206040004',
    districtId: '1206040',
    name: 'Haunatas II',
  },
  {
    id: '1206040005',
    districtId: '1206040',
    name: 'Sibarani Nasampulu',
  },
  {
    id: '1206040006',
    districtId: '1206040',
    name: 'Sitangkola',
  },
  {
    id: '1206040007',
    districtId: '1206040',
    name: 'Sibuea',
  },
  {
    id: '1206040008',
    districtId: '1206040',
    name: 'Simatibung',
  },
  {
    id: '1206040009',
    districtId: '1206040',
    name: 'Pardomuan Nauli',
  },
  {
    id: '1206040010',
    districtId: '1206040',
    name: 'Ujung Tanduk',
  },
  {
    id: '1206040011',
    districtId: '1206040',
    name: 'Pintu Bosi',
  },
  {
    id: '1206040012',
    districtId: '1206040',
    name: 'Gasa Ribu',
  },
  {
    id: '1206040013',
    districtId: '1206040',
    name: 'Pasar Lagu Boti',
  },
  {
    id: '1206040014',
    districtId: '1206040',
    name: 'Aruan',
  },
  {
    id: '1206040015',
    districtId: '1206040',
    name: 'Lumban Bagasan',
  },
  {
    id: '1206040016',
    districtId: '1206040',
    name: 'Tinggir Nipasir',
  },
  {
    id: '1206040017',
    districtId: '1206040',
    name: 'Ompu Raja Hutapea',
  },
  {
    id: '1206040018',
    districtId: '1206040',
    name: 'Sitoluama',
  },
  {
    id: '1206040019',
    districtId: '1206040',
    name: 'Pardinggaran',
  },
  {
    id: '1206040020',
    districtId: '1206040',
    name: 'Lumban Binanga',
  },
  {
    id: '1206040021',
    districtId: '1206040',
    name: 'Siraja Gorat',
  },
  {
    id: '1206040022',
    districtId: '1206040',
    name: 'Ompu Raja Hutapea Timur',
  },
  {
    id: '1206040023',
    districtId: '1206040',
    name: 'Ompu Raja Hatulian',
  },
  {
    id: '1206050004',
    districtId: '1206050',
    name: 'Lumban Rau Barat',
  },
  {
    id: '1206050005',
    districtId: '1206050',
    name: 'Lumban Rau Selatan',
  },
  {
    id: '1206050009',
    districtId: '1206050',
    name: 'Parsoburan Tengah',
  },
  {
    id: '1206050010',
    districtId: '1206050',
    name: 'Parsoburan Barat',
  },
  {
    id: '1206050011',
    districtId: '1206050',
    name: 'Lumban Balik',
  },
  {
    id: '1206050012',
    districtId: '1206050',
    name: 'Lumban Pinasa',
  },
  {
    id: '1206050013',
    districtId: '1206050',
    name: 'Panamparan',
  },
  {
    id: '1206050014',
    districtId: '1206050',
    name: 'Lumban Ruhap',
  },
  {
    id: '1206050015',
    districtId: '1206050',
    name: 'Lumban Pea',
  },
  {
    id: '1206050016',
    districtId: '1206050',
    name: 'Hitetano',
  },
  {
    id: '1206050018',
    districtId: '1206050',
    name: 'Lobu Hole',
  },
  {
    id: '1206050019',
    districtId: '1206050',
    name: 'Batu Nabolon',
  },
  {
    id: '1206050020',
    districtId: '1206050',
    name: 'Lumban Gaol',
  },
  {
    id: '1206050021',
    districtId: '1206050',
    name: 'Tornagodang',
  },
  {
    id: '1206050022',
    districtId: '1206050',
    name: 'Taonmarisi',
  },
  {
    id: '1206050023',
    districtId: '1206050',
    name: 'Pagar Batu',
  },
  {
    id: '1206050024',
    districtId: '1206050',
    name: 'Sibuntuon',
  },
  {
    id: '1206050025',
    districtId: '1206050',
    name: 'Aek Ulok',
  },
  {
    id: '1206050026',
    districtId: '1206050',
    name: 'Pangujungan',
  },
  {
    id: '1206050027',
    districtId: '1206050',
    name: 'Lumban Pinasa Saroha',
  },
  {
    id: '1206050028',
    districtId: '1206050',
    name: 'Lumban Lintong',
  },
  {
    id: '1206050029',
    districtId: '1206050',
    name: 'Pararungan',
  },
  {
    id: '1206051001',
    districtId: '1206051',
    name: 'Pangururan',
  },
  {
    id: '1206051002',
    districtId: '1206051',
    name: 'Pardomuan Nauli',
  },
  {
    id: '1206051003',
    districtId: '1206051',
    name: 'Lintong',
  },
  {
    id: '1206051004',
    districtId: '1206051',
    name: 'Natumingka',
  },
  {
    id: '1206051005',
    districtId: '1206051',
    name: 'Rianiate',
  },
  {
    id: '1206051006',
    districtId: '1206051',
    name: 'Aek Unsin',
  },
  {
    id: '1206051007',
    districtId: '1206051',
    name: 'Purba Tua',
  },
  {
    id: '1206051008',
    districtId: '1206051',
    name: 'Janji Maria',
  },
  {
    id: '1206051009',
    districtId: '1206051',
    name: 'Pangururan II',
  },
  {
    id: '1206051010',
    districtId: '1206051',
    name: 'Pangururan III',
  },
  {
    id: '1206051011',
    districtId: '1206051',
    name: 'Riganjang',
  },
  {
    id: '1206051012',
    districtId: '1206051',
    name: 'Pasar Borbor',
  },
  {
    id: '1206051013',
    districtId: '1206051',
    name: 'Lumban Sewa',
  },
  {
    id: '1206051014',
    districtId: '1206051',
    name: 'Huta Gurgur',
  },
  {
    id: '1206051015',
    districtId: '1206051',
    name: 'Simare',
  },
  {
    id: '1206052001',
    districtId: '1206052',
    name: 'Lumban Rau Tengah',
  },
  {
    id: '1206052002',
    districtId: '1206052',
    name: 'Lumban Rau Timur',
  },
  {
    id: '1206052003',
    districtId: '1206052',
    name: 'Lumban Rau Utara',
  },
  {
    id: '1206052004',
    districtId: '1206052',
    name: 'Napajoring',
  },
  {
    id: '1206052005',
    districtId: '1206052',
    name: 'Sipagabu',
  },
  {
    id: '1206052006',
    districtId: '1206052',
    name: 'Liat Tondung',
  },
  {
    id: '1206052007',
    districtId: '1206052',
    name: 'Batu Manumpak',
  },
  {
    id: '1206052008',
    districtId: '1206052',
    name: 'Lumban Rau Tenggara',
  },
  {
    id: '1206052009',
    districtId: '1206052',
    name: 'Cinta Damai',
  },
  {
    id: '1206052010',
    districtId: '1206052',
    name: 'Siantarasa',
  },
  {
    id: '1206060001',
    districtId: '1206060',
    name: 'Pintu Batu',
  },
  {
    id: '1206060002',
    districtId: '1206060',
    name: 'Pardomuan',
  },
  {
    id: '1206060003',
    districtId: '1206060',
    name: 'Ombur',
  },
  {
    id: '1206060004',
    districtId: '1206060',
    name: 'Parsambilan',
  },
  {
    id: '1206060005',
    districtId: '1206060',
    name: 'Sigodang Tua',
  },
  {
    id: '1206060006',
    districtId: '1206060',
    name: 'Sinta Dame',
  },
  {
    id: '1206060007',
    districtId: '1206060',
    name: 'Natolutali',
  },
  {
    id: '1206060008',
    districtId: '1206060',
    name: 'Dalihan Natolu',
  },
  {
    id: '1206060009',
    districtId: '1206060',
    name: 'Huta Gurgur II',
  },
  {
    id: '1206060010',
    districtId: '1206060',
    name: 'Huta Gurgur I',
  },
  {
    id: '1206060011',
    districtId: '1206060',
    name: 'Sitorang I',
  },
  {
    id: '1206060012',
    districtId: '1206060',
    name: 'Huta Namora',
  },
  {
    id: '1206060021',
    districtId: '1206060',
    name: 'Silaen',
  },
  {
    id: '1206060022',
    districtId: '1206060',
    name: 'Lumban Dolok',
  },
  {
    id: '1206060023',
    districtId: '1206060',
    name: 'Napitupulu',
  },
  {
    id: '1206060024',
    districtId: '1206060',
    name: 'Hutagaol Sihujur',
  },
  {
    id: '1206060025',
    districtId: '1206060',
    name: 'Sibide Barat',
  },
  {
    id: '1206060026',
    districtId: '1206060',
    name: 'Sibide',
  },
  {
    id: '1206060027',
    districtId: '1206060',
    name: 'Meranti Barat',
  },
  {
    id: '1206060028',
    districtId: '1206060',
    name: 'Simanobak',
  },
  {
    id: '1206060029',
    districtId: '1206060',
    name: 'Marbulang',
  },
  {
    id: '1206060030',
    districtId: '1206060',
    name: 'Siringkiron',
  },
  {
    id: '1206060031',
    districtId: '1206060',
    name: 'Panindii',
  },
  {
    id: '1206061001',
    districtId: '1206061',
    name: 'Sigumpar Dangsina',
  },
  {
    id: '1206061002',
    districtId: '1206061',
    name: 'Dolok Jior',
  },
  {
    id: '1206061003',
    districtId: '1206061',
    name: 'Sigumpar',
  },
  {
    id: '1206061004',
    districtId: '1206061',
    name: 'Sigumpar Julu',
  },
  {
    id: '1206061005',
    districtId: '1206061',
    name: 'Maju',
  },
  {
    id: '1206061006',
    districtId: '1206061',
    name: 'Marsangap',
  },
  {
    id: '1206061007',
    districtId: '1206061',
    name: 'Nauli',
  },
  {
    id: '1206061008',
    districtId: '1206061',
    name: 'Situa-Tua',
  },
  {
    id: '1206061009',
    districtId: '1206061',
    name: 'Sigumpar Barat',
  },
  {
    id: '1206061010',
    districtId: '1206061',
    name: 'Banua Huta',
  },
  {
    id: '1206070010',
    districtId: '1206070',
    name: 'Parparean I',
  },
  {
    id: '1206070011',
    districtId: '1206070',
    name: 'Parparean II',
  },
  {
    id: '1206070012',
    districtId: '1206070',
    name: 'Parparean III',
  },
  {
    id: '1206070013',
    districtId: '1206070',
    name: 'Parparean IV',
  },
  {
    id: '1206070014',
    districtId: '1206070',
    name: 'Gala Gala Pangkailan',
  },
  {
    id: '1206070026',
    districtId: '1206070',
    name: 'Pasar Porsea',
  },
  {
    id: '1206070027',
    districtId: '1206070',
    name: 'Patane III',
  },
  {
    id: '1206070028',
    districtId: '1206070',
    name: 'Patane IV',
  },
  {
    id: '1206070029',
    districtId: '1206070',
    name: 'Patane II',
  },
  {
    id: '1206070030',
    districtId: '1206070',
    name: 'Patane I',
  },
  {
    id: '1206070032',
    districtId: '1206070',
    name: 'Amborgang',
  },
  {
    id: '1206070033',
    districtId: '1206070',
    name: 'Nalela',
  },
  {
    id: '1206070034',
    districtId: '1206070',
    name: 'Silamosik I',
  },
  {
    id: '1206070037',
    districtId: '1206070',
    name: 'Lumban Gurning',
  },
  {
    id: '1206070038',
    districtId: '1206070',
    name: 'Patane V',
  },
  {
    id: '1206070039',
    districtId: '1206070',
    name: 'Raut Bosi',
  },
  {
    id: '1206070040',
    districtId: '1206070',
    name: 'Simpang Siguragura',
  },
  {
    id: '1206071001',
    districtId: '1206071',
    name: 'Ambar Halim',
  },
  {
    id: '1206071002',
    districtId: '1206071',
    name: 'Pintu Pohan Dolok',
  },
  {
    id: '1206071003',
    districtId: '1206071',
    name: 'Pintu Pohan Pasar',
  },
  {
    id: '1206071004',
    districtId: '1206071',
    name: 'Halado',
  },
  {
    id: '1206071008',
    districtId: '1206071',
    name: 'Meranti Timur',
  },
  {
    id: '1206071009',
    districtId: '1206071',
    name: 'Meranti Tengah',
  },
  {
    id: '1206071010',
    districtId: '1206071',
    name: 'Meranti Utara',
  },
  {
    id: '1206072001',
    districtId: '1206072',
    name: 'Narumonda V',
  },
  {
    id: '1206072002',
    districtId: '1206072',
    name: 'Narumonda VI',
  },
  {
    id: '1206072003',
    districtId: '1206072',
    name: 'Narumonda VII',
  },
  {
    id: '1206072004',
    districtId: '1206072',
    name: 'Narumonda VIII',
  },
  {
    id: '1206072005',
    districtId: '1206072',
    name: 'Siantar Sitiotio',
  },
  {
    id: '1206072006',
    districtId: '1206072',
    name: 'Narumonda I',
  },
  {
    id: '1206072007',
    districtId: '1206072',
    name: 'Narumonda II',
  },
  {
    id: '1206072008',
    districtId: '1206072',
    name: 'Narumonda III',
  },
  {
    id: '1206072009',
    districtId: '1206072',
    name: 'Narumonda IV',
  },
  {
    id: '1206072010',
    districtId: '1206072',
    name: 'Siantar Tonga Tonga II',
  },
  {
    id: '1206072011',
    districtId: '1206072',
    name: 'Siantar Dangsina',
  },
  {
    id: '1206072012',
    districtId: '1206072',
    name: 'Siantar Tonga Tonga I',
  },
  {
    id: '1206072013',
    districtId: '1206072',
    name: 'Siantar Sigordang',
  },
  {
    id: '1206072014',
    districtId: '1206072',
    name: 'Siantar Tonga Tonga III',
  },
  {
    id: '1206073001',
    districtId: '1206073',
    name: 'Siantar Utara',
  },
  {
    id: '1206073002',
    districtId: '1206073',
    name: 'Dolok Nauli',
  },
  {
    id: '1206073003',
    districtId: '1206073',
    name: 'Jonggi Manulus',
  },
  {
    id: '1206073004',
    districtId: '1206073',
    name: 'Banjar Ganjang',
  },
  {
    id: '1206073005',
    districtId: '1206073',
    name: 'Pangombusan',
  },
  {
    id: '1206073006',
    districtId: '1206073',
    name: 'Lumban Sitorus',
  },
  {
    id: '1206073007',
    districtId: '1206073',
    name: 'Bius Gu Barat',
  },
  {
    id: '1206073008',
    districtId: '1206073',
    name: 'Lumban Huala',
  },
  {
    id: '1206073009',
    districtId: '1206073',
    name: 'Tangga Batu II',
  },
  {
    id: '1206073010',
    districtId: '1206073',
    name: 'Tangga Batu I',
  },
  {
    id: '1206073011',
    districtId: '1206073',
    name: 'Lumban Manurung',
  },
  {
    id: '1206080018',
    districtId: '1206080',
    name: 'Sibaruang',
  },
  {
    id: '1206080025',
    districtId: '1206080',
    name: 'Jangga Toruan',
  },
  {
    id: '1206080026',
    districtId: '1206080',
    name: 'Jangga Dolok',
  },
  {
    id: '1206080027',
    districtId: '1206080',
    name: 'Hatinggian',
  },
  {
    id: '1206080028',
    districtId: '1206080',
    name: 'Lintong Julu',
  },
  {
    id: '1206080029',
    districtId: '1206080',
    name: 'Pasar Lumban Julu',
  },
  {
    id: '1206080030',
    districtId: '1206080',
    name: 'Sionggang Utara',
  },
  {
    id: '1206080031',
    districtId: '1206080',
    name: 'Sionggang Tengah',
  },
  {
    id: '1206080032',
    districtId: '1206080',
    name: 'Sionggang Selatan',
  },
  {
    id: '1206080033',
    districtId: '1206080',
    name: 'Hutanamora',
  },
  {
    id: '1206080034',
    districtId: '1206080',
    name: 'Jonggi Nihuta',
  },
  {
    id: '1206080035',
    districtId: '1206080',
    name: 'Aek Natolu Jaya',
  },
  {
    id: '1206081001',
    districtId: '1206081',
    name: 'Siregar Aek Nalas',
  },
  {
    id: '1206081002',
    districtId: '1206081',
    name: 'Sigaol Barat',
  },
  {
    id: '1206081003',
    districtId: '1206081',
    name: 'Sigaol Timur',
  },
  {
    id: '1206081004',
    districtId: '1206081',
    name: 'Marom',
  },
  {
    id: '1206081005',
    districtId: '1206081',
    name: 'Sibuntuon',
  },
  {
    id: '1206081006',
    districtId: '1206081',
    name: 'Dolok Saribu Janji Matogu',
  },
  {
    id: '1206081007',
    districtId: '1206081',
    name: 'Partor Janji Matogu',
  },
  {
    id: '1206081008',
    districtId: '1206081',
    name: 'Parbagasan Janji Matogu',
  },
  {
    id: '1206081009',
    districtId: '1206081',
    name: 'Partoruan Janji Matogu',
  },
  {
    id: '1206081010',
    districtId: '1206081',
    name: 'Parhabinsaran Janji Matogu',
  },
  {
    id: '1206081011',
    districtId: '1206081',
    name: 'Lumban Binanga',
  },
  {
    id: '1206081012',
    districtId: '1206081',
    name: 'Lumban Holbung Lumban Nabolon',
  },
  {
    id: '1206081013',
    districtId: '1206081',
    name: 'Lumban Nabolon',
  },
  {
    id: '1206081015',
    districtId: '1206081',
    name: 'Dolok Nagodang',
  },
  {
    id: '1206081016',
    districtId: '1206081',
    name: 'Parik',
  },
  {
    id: '1206081017',
    districtId: '1206081',
    name: 'Dolok Saribu Lumban Nabolon',
  },
  {
    id: '1206081018',
    districtId: '1206081',
    name: 'Sampuara',
  },
  {
    id: '1206082001',
    districtId: '1206082',
    name: 'Sirungkungon',
  },
  {
    id: '1206082002',
    districtId: '1206082',
    name: 'Parsaoran Sibisa',
  },
  {
    id: '1206082003',
    districtId: '1206082',
    name: 'Pardamean Sibisa',
  },
  {
    id: '1206082004',
    districtId: '1206082',
    name: 'Sigapiton',
  },
  {
    id: '1206082005',
    districtId: '1206082',
    name: 'Horsik',
  },
  {
    id: '1206082006',
    districtId: '1206082',
    name: 'Motung',
  },
  {
    id: '1206082007',
    districtId: '1206082',
    name: 'Parsaoran Ajibata',
  },
  {
    id: '1206082008',
    districtId: '1206082',
    name: 'Pardomuan Ajibata',
  },
  {
    id: '1206082009',
    districtId: '1206082',
    name: 'Pardamean Ajibata',
  },
  {
    id: '1206082010',
    districtId: '1206082',
    name: 'Pardomuan Motung',
  },
  {
    id: '1206083001',
    districtId: '1206083',
    name: 'Sibadihon',
  },
  {
    id: '1206083002',
    districtId: '1206083',
    name: 'Naga Timbul',
  },
  {
    id: '1206083003',
    districtId: '1206083',
    name: 'Harungguan',
  },
  {
    id: '1206083004',
    districtId: '1206083',
    name: 'Lumban Lobu',
  },
  {
    id: '1206083005',
    districtId: '1206083',
    name: 'Sinar Sabungan',
  },
  {
    id: '1206083006',
    districtId: '1206083',
    name: 'Sihiong',
  },
  {
    id: '1206083008',
    districtId: '1206083',
    name: 'Silamosik II',
  },
  {
    id: '1206083011',
    districtId: '1206083',
    name: 'Naga Timbul Timur',
  },
  {
    id: '1206083012',
    districtId: '1206083',
    name: 'Lumban Sangkalan',
  },
  {
    id: '1206083013',
    districtId: '1206083',
    name: 'Partoruan Lumban Lobu',
  },
  {
    id: '1206083014',
    districtId: '1206083',
    name: 'Pardolok Lumban Lobu',
  },
  {
    id: '1206083015',
    districtId: '1206083',
    name: 'Silombu',
  },
  {
    id: '1207050001',
    districtId: '1207050',
    name: 'Tanjung Siram',
  },
  {
    id: '1207050002',
    districtId: '1207050',
    name: 'S Satu Aek Nabara',
  },
  {
    id: '1207050003',
    districtId: '1207050',
    name: 'Kampung Dalam',
  },
  {
    id: '1207050004',
    districtId: '1207050',
    name: 'Lingga Tiga',
  },
  {
    id: '1207050005',
    districtId: '1207050',
    name: 'Bandar Tinggi',
  },
  {
    id: '1207050006',
    districtId: '1207050',
    name: 'S Tiga Aek Nabara',
  },
  {
    id: '1207050007',
    districtId: '1207050',
    name: 'S Empat Aek Nabara',
  },
  {
    id: '1207050008',
    districtId: '1207050',
    name: 'S Lima Aek Nabara',
  },
  {
    id: '1207050009',
    districtId: '1207050',
    name: 'S Enam Aek Nabara',
  },
  {
    id: '1207050010',
    districtId: '1207050',
    name: 'N Delapan Aek Nabara',
  },
  {
    id: '1207050011',
    districtId: '1207050',
    name: 'N Lima Aek Nabara',
  },
  {
    id: '1207050012',
    districtId: '1207050',
    name: 'S Dua Aek Nabara',
  },
  {
    id: '1207050013',
    districtId: '1207050',
    name: 'N Tiga Aek Nabara',
  },
  {
    id: '1207050014',
    districtId: '1207050',
    name: 'N Dua Aek Nabara',
  },
  {
    id: '1207050015',
    districtId: '1207050',
    name: 'N Empat Aek Nabara',
  },
  {
    id: '1207050016',
    districtId: '1207050',
    name: 'Perbaungan',
  },
  {
    id: '1207050017',
    districtId: '1207050',
    name: 'N Tujuh Aek Nabara',
  },
  {
    id: '1207050018',
    districtId: '1207050',
    name: 'Meranti',
  },
  {
    id: '1207050019',
    districtId: '1207050',
    name: 'Gunung Selamat',
  },
  {
    id: '1207050020',
    districtId: '1207050',
    name: 'N Enam Aek Nabara',
  },
  {
    id: '1207050021',
    districtId: '1207050',
    name: 'Pematang Seleng',
  },
  {
    id: '1207050022',
    districtId: '1207050',
    name: 'Pondok Batu',
  },
  {
    id: '1207050023',
    districtId: '1207050',
    name: 'Emplasmen Aek Nabara',
  },
  {
    id: '1207050024',
    districtId: '1207050',
    name: 'N Satu Aek Nabara',
  },
  {
    id: '1207070001',
    districtId: '1207070',
    name: 'Sidorukun',
  },
  {
    id: '1207070002',
    districtId: '1207070',
    name: 'Perkebunan Pangkatan',
  },
  {
    id: '1207070003',
    districtId: '1207070',
    name: 'Tebing Tinggi Pangkatan',
  },
  {
    id: '1207070004',
    districtId: '1207070',
    name: 'Kampung Padang',
  },
  {
    id: '1207070005',
    districtId: '1207070',
    name: 'Tanjung Harapan',
  },
  {
    id: '1207070006',
    districtId: '1207070',
    name: 'Pangkatan',
  },
  {
    id: '1207070007',
    districtId: '1207070',
    name: 'Sennah',
  },
  {
    id: '1207080001',
    districtId: '1207080',
    name: 'Sibargot',
  },
  {
    id: '1207080002',
    districtId: '1207080',
    name: 'Bandar Kumbul',
  },
  {
    id: '1207080003',
    districtId: '1207080',
    name: 'Tanjung Medan',
  },
  {
    id: '1207080004',
    districtId: '1207080',
    name: 'Janji',
  },
  {
    id: '1207080005',
    districtId: '1207080',
    name: 'Afdeling I Rantauprapat',
  },
  {
    id: '1207080006',
    districtId: '1207080',
    name: 'Aek Buru Selatan',
  },
  {
    id: '1207080007',
    districtId: '1207080',
    name: 'Afdeling II Rantauprapat',
  },
  {
    id: '1207080008',
    districtId: '1207080',
    name: 'Kampung Baru',
  },
  {
    id: '1207080009',
    districtId: '1207080',
    name: 'Tebing Linggahara',
  },
  {
    id: '1207080010',
    districtId: '1207080',
    name: 'Tebing Linggahara Baru',
  },
  {
    id: '1207130001',
    districtId: '1207130',
    name: 'Perkebunan Sennah',
  },
  {
    id: '1207130002',
    districtId: '1207130',
    name: 'Kampung Bilah',
  },
  {
    id: '1207130003',
    districtId: '1207130',
    name: 'Perkebunan Bilah',
  },
  {
    id: '1207130004',
    districtId: '1207130',
    name: 'Negeri Lama',
  },
  {
    id: '1207130005',
    districtId: '1207130',
    name: 'Negeri Lama Seberang',
  },
  {
    id: '1207130006',
    districtId: '1207130',
    name: 'Perkebunan Negeri Lama',
  },
  {
    id: '1207130007',
    districtId: '1207130',
    name: 'Sidomulyo',
  },
  {
    id: '1207130008',
    districtId: '1207130',
    name: 'Negeri Baru',
  },
  {
    id: '1207130009',
    districtId: '1207130',
    name: 'Sei Tampang',
  },
  {
    id: '1207130010',
    districtId: '1207130',
    name: 'Sei Tarolat',
  },
  {
    id: '1207130011',
    districtId: '1207130',
    name: 'Sei Kasih',
  },
  {
    id: '1207130012',
    districtId: '1207130',
    name: 'Tanjung Haloban',
  },
  {
    id: '1207130013',
    districtId: '1207130',
    name: 'Selat Besar',
  },
  {
    id: '1207140001',
    districtId: '1207140',
    name: 'Sei Sentosa',
  },
  {
    id: '1207140002',
    districtId: '1207140',
    name: 'Ajamu',
  },
  {
    id: '1207140003',
    districtId: '1207140',
    name: 'Meranti Paham',
  },
  {
    id: '1207140004',
    districtId: '1207140',
    name: 'Teluk Sentosa',
  },
  {
    id: '1207140005',
    districtId: '1207140',
    name: 'Cinta Makmur',
  },
  {
    id: '1207140006',
    districtId: '1207140',
    name: 'Tanjung Sarang Elang',
  },
  {
    id: '1207140007',
    districtId: '1207140',
    name: 'Sei Jawi Jawi',
  },
  {
    id: '1207150001',
    districtId: '1207150',
    name: 'Sei Siarti',
  },
  {
    id: '1207150002',
    districtId: '1207150',
    name: 'Selat Beting',
  },
  {
    id: '1207150003',
    districtId: '1207150',
    name: 'Sei Pelancang',
  },
  {
    id: '1207150004',
    districtId: '1207150',
    name: 'Bagan Bilah',
  },
  {
    id: '1207150005',
    districtId: '1207150',
    name: 'Sei Rakyat',
  },
  {
    id: '1207150006',
    districtId: '1207150',
    name: 'Sei Nahodaris',
  },
  {
    id: '1207150007',
    districtId: '1207150',
    name: 'Telaga Suka',
  },
  {
    id: '1207150008',
    districtId: '1207150',
    name: 'Labuhan Bilik',
  },
  {
    id: '1207150009',
    districtId: '1207150',
    name: 'Sei Merdeka',
  },
  {
    id: '1207150010',
    districtId: '1207150',
    name: 'Pasar Tiga',
  },
  {
    id: '1207160001',
    districtId: '1207160',
    name: 'Sei Penggantungan',
  },
  {
    id: '1207160002',
    districtId: '1207160',
    name: 'Sei Lumut',
  },
  {
    id: '1207160003',
    districtId: '1207160',
    name: 'Sei Tawar',
  },
  {
    id: '1207160004',
    districtId: '1207160',
    name: 'Sei Sanggul',
  },
  {
    id: '1207160005',
    districtId: '1207160',
    name: 'Sei Berombang',
  },
  {
    id: '1207160006',
    districtId: '1207160',
    name: 'Sei Sakat',
  },
  {
    id: '1207160007',
    districtId: '1207160',
    name: 'Sei Baru',
  },
  {
    id: '1207160008',
    districtId: '1207160',
    name: 'Wonosari',
  },
  {
    id: '1207210001',
    districtId: '1207210',
    name: 'Lobusona',
  },
  {
    id: '1207210002',
    districtId: '1207210',
    name: 'Sidorejo',
  },
  {
    id: '1207210003',
    districtId: '1207210',
    name: 'Sigambal',
  },
  {
    id: '1207210004',
    districtId: '1207210',
    name: 'Danobale',
  },
  {
    id: '1207210005',
    districtId: '1207210',
    name: 'Perdamean',
  },
  {
    id: '1207210006',
    districtId: '1207210',
    name: 'Ujung Bandar',
  },
  {
    id: '1207210007',
    districtId: '1207210',
    name: 'Bakaran Batu',
  },
  {
    id: '1207210008',
    districtId: '1207210',
    name: 'Urung Kompas',
  },
  {
    id: '1207210009',
    districtId: '1207210',
    name: 'Sioldengan',
  },
  {
    id: '1207220001',
    districtId: '1207220',
    name: 'Sirandorung',
  },
  {
    id: '1207220002',
    districtId: '1207220',
    name: 'Padang Bulan',
  },
  {
    id: '1207220003',
    districtId: '1207220',
    name: 'Kartini',
  },
  {
    id: '1207220004',
    districtId: '1207220',
    name: 'Rantauprapat',
  },
  {
    id: '1207220005',
    districtId: '1207220',
    name: 'Cendana',
  },
  {
    id: '1207220006',
    districtId: '1207220',
    name: 'Bina Raga',
  },
  {
    id: '1207220007',
    districtId: '1207220',
    name: 'Siringo-Ringo',
  },
  {
    id: '1207220008',
    districtId: '1207220',
    name: 'Aek Paing',
  },
  {
    id: '1207220009',
    districtId: '1207220',
    name: 'Padang Matinggi',
  },
  {
    id: '1207220010',
    districtId: '1207220',
    name: 'Pulo Padang',
  },
  {
    id: '1208010001',
    districtId: '1208010',
    name: 'Huta Padang',
  },
  {
    id: '1208010002',
    districtId: '1208010',
    name: 'Huta Bagasan',
  },
  {
    id: '1208010003',
    districtId: '1208010',
    name: 'Bandar Pasir Mandoge',
  },
  {
    id: '1208010004',
    districtId: '1208010',
    name: 'Suka Makmur',
  },
  {
    id: '1208010005',
    districtId: '1208010',
    name: 'Sei Kopas',
  },
  {
    id: '1208010006',
    districtId: '1208010',
    name: 'Silau Jawa',
  },
  {
    id: '1208010007',
    districtId: '1208010',
    name: 'Sei Nadoras',
  },
  {
    id: '1208010008',
    districtId: '1208010',
    name: 'Tomuan Holbung',
  },
  {
    id: '1208010009',
    districtId: '1208010',
    name: 'Gotting Sidodadi',
  },
  {
    id: '1208020013',
    districtId: '1208020',
    name: 'Bandar Pulau Pekan',
  },
  {
    id: '1208020014',
    districtId: '1208020',
    name: 'Padang Pulau',
  },
  {
    id: '1208020015',
    districtId: '1208020',
    name: 'Perkebunan Padang Pulau',
  },
  {
    id: '1208020016',
    districtId: '1208020',
    name: 'Buntu Maraja',
  },
  {
    id: '1208020017',
    districtId: '1208020',
    name: 'Gonting Malaha',
  },
  {
    id: '1208020018',
    districtId: '1208020',
    name: 'Perkebunan Aek Tarum',
  },
  {
    id: '1208020019',
    districtId: '1208020',
    name: 'Gajah Sakti',
  },
  {
    id: '1208020020',
    districtId: '1208020',
    name: 'Gunung Berkat',
  },
  {
    id: '1208020021',
    districtId: '1208020',
    name: 'Huta Rao',
  },
  {
    id: '1208020022',
    districtId: '1208020',
    name: 'Aek Nagali',
  },
  {
    id: '1208021001',
    districtId: '1208021',
    name: 'Tangga',
  },
  {
    id: '1208021002',
    districtId: '1208021',
    name: 'Lobu Rappa',
  },
  {
    id: '1208021003',
    districtId: '1208021',
    name: 'Marjanji Aceh',
  },
  {
    id: '1208021004',
    districtId: '1208021',
    name: 'Aek Bamban',
  },
  {
    id: '1208021005',
    districtId: '1208021',
    name: 'Perkebunan Bandar Pulau',
  },
  {
    id: '1208021006',
    districtId: '1208021',
    name: 'Aek Songsongan',
  },
  {
    id: '1208021007',
    districtId: '1208021',
    name: 'Perkebunan Bandar Selamat',
  },
  {
    id: '1208021008',
    districtId: '1208021',
    name: 'Mekar Marjanji',
  },
  {
    id: '1208021009',
    districtId: '1208021',
    name: 'Situnjak',
  },
  {
    id: '1208022001',
    districtId: '1208022',
    name: 'Perkebunan Aek Nagaga',
  },
  {
    id: '1208022002',
    districtId: '1208022',
    name: 'Rahuning',
  },
  {
    id: '1208022003',
    districtId: '1208022',
    name: 'Perkebunan Gunung Melayu',
  },
  {
    id: '1208022004',
    districtId: '1208022',
    name: 'Gunung Melayu',
  },
  {
    id: '1208022005',
    districtId: '1208022',
    name: 'Batu Anam',
  },
  {
    id: '1208022006',
    districtId: '1208022',
    name: 'Rahuning I',
  },
  {
    id: '1208022007',
    districtId: '1208022',
    name: 'Rahuning II',
  },
  {
    id: '1208030013',
    districtId: '1208030',
    name: 'Bangun',
  },
  {
    id: '1208030014',
    districtId: '1208030',
    name: 'Persatuan',
  },
  {
    id: '1208030015',
    districtId: '1208030',
    name: 'Perkebunan Tunggul 45',
  },
  {
    id: '1208030016',
    districtId: '1208030',
    name: 'Orika',
  },
  {
    id: '1208030017',
    districtId: '1208030',
    name: 'Baru',
  },
  {
    id: '1208030018',
    districtId: '1208030',
    name: 'Manis',
  },
  {
    id: '1208030019',
    districtId: '1208030',
    name: 'Pulau Rakyat Pekan',
  },
  {
    id: '1208030020',
    districtId: '1208030',
    name: 'Pulau Rakyat Tua',
  },
  {
    id: '1208030021',
    districtId: '1208030',
    name: 'Sei Piring',
  },
  {
    id: '1208030022',
    districtId: '1208030',
    name: 'Ofa/Padang Mahondang',
  },
  {
    id: '1208030023',
    districtId: '1208030',
    name: 'Padang Mahondang',
  },
  {
    id: '1208030024',
    districtId: '1208030',
    name: 'Mekar Sari',
  },
  {
    id: '1208031007',
    districtId: '1208031',
    name: 'Sengon Sari',
  },
  {
    id: '1208031008',
    districtId: '1208031',
    name: 'Lobu Jiur',
  },
  {
    id: '1208031009',
    districtId: '1208031',
    name: 'Aek Loba Pekan',
  },
  {
    id: '1208031010',
    districtId: '1208031',
    name: 'Aek Loba Afdeling I',
  },
  {
    id: '1208031011',
    districtId: '1208031',
    name: 'Alang Bonbon',
  },
  {
    id: '1208031012',
    districtId: '1208031',
    name: 'Rawa Sari',
  },
  {
    id: '1208031013',
    districtId: '1208031',
    name: 'Aek Loba',
  },
  {
    id: '1208032001',
    districtId: '1208032',
    name: 'Aek Bange',
  },
  {
    id: '1208032002',
    districtId: '1208032',
    name: 'Ledong Barat',
  },
  {
    id: '1208032003',
    districtId: '1208032',
    name: 'Ledong Timur',
  },
  {
    id: '1208032004',
    districtId: '1208032',
    name: 'Aek Korsik',
  },
  {
    id: '1208032005',
    districtId: '1208032',
    name: 'Aek Ledong',
  },
  {
    id: '1208032006',
    districtId: '1208032',
    name: 'Aek Nabuntu',
  },
  {
    id: '1208032007',
    districtId: '1208032',
    name: 'Padang Sipirok',
  },
  {
    id: '1208040001',
    districtId: '1208040',
    name: 'Perbangunan',
  },
  {
    id: '1208040002',
    districtId: '1208040',
    name: 'Pertahanan',
  },
  {
    id: '1208040003',
    districtId: '1208040',
    name: 'Bangun Baru',
  },
  {
    id: '1208040005',
    districtId: '1208040',
    name: 'Sei Paham',
  },
  {
    id: '1208040006',
    districtId: '1208040',
    name: 'Sei Kepayang Kanan',
  },
  {
    id: '1208040007',
    districtId: '1208040',
    name: 'Sei Kepayang Tengah',
  },
  {
    id: '1208041001',
    districtId: '1208041',
    name: 'Sei Kepayang Kiri',
  },
  {
    id: '1208041002',
    districtId: '1208041',
    name: 'Sei Lendir',
  },
  {
    id: '1208041003',
    districtId: '1208041',
    name: 'Sei Tualang Pandau',
  },
  {
    id: '1208041004',
    districtId: '1208041',
    name: 'Sei Serindan',
  },
  {
    id: '1208041005',
    districtId: '1208041',
    name: 'Sei Jawi Jawi',
  },
  {
    id: '1208041006',
    districtId: '1208041',
    name: 'Sei Nangka',
  },
  {
    id: '1208042001',
    districtId: '1208042',
    name: 'Sei Lunang',
  },
  {
    id: '1208042002',
    districtId: '1208042',
    name: 'Sei Pasir',
  },
  {
    id: '1208042003',
    districtId: '1208042',
    name: 'Sei Tempurung',
  },
  {
    id: '1208042004',
    districtId: '1208042',
    name: 'Sarang Helang',
  },
  {
    id: '1208042005',
    districtId: '1208042',
    name: 'Sei Sembilang',
  },
  {
    id: '1208050001',
    districtId: '1208050',
    name: 'Kapias Batu VIII',
  },
  {
    id: '1208050002',
    districtId: '1208050',
    name: 'Pematang Sungai Baru',
  },
  {
    id: '1208050003',
    districtId: '1208050',
    name: 'Sei Apung Jaya',
  },
  {
    id: '1208050004',
    districtId: '1208050',
    name: 'Sungai Apung',
  },
  {
    id: '1208050005',
    districtId: '1208050',
    name: 'Asahan Mati',
  },
  {
    id: '1208050006',
    districtId: '1208050',
    name: 'Bagan Asahan Baru',
  },
  {
    id: '1208050007',
    districtId: '1208050',
    name: 'Bagan Asahan Pekan',
  },
  {
    id: '1208050008',
    districtId: '1208050',
    name: 'Bagan Asahan',
  },
  {
    id: '1208060006',
    districtId: '1208060',
    name: 'Silomlom',
  },
  {
    id: '1208060007',
    districtId: '1208060',
    name: 'Perkebunan Sukaraja',
  },
  {
    id: '1208060008',
    districtId: '1208060',
    name: 'Simpang Empat',
  },
  {
    id: '1208060009',
    districtId: '1208060',
    name: 'Sei Dua Hulu',
  },
  {
    id: '1208060010',
    districtId: '1208060',
    name: 'Perkebunan Hessa',
  },
  {
    id: '1208060011',
    districtId: '1208060',
    name: 'Sungai Lama',
  },
  {
    id: '1208060012',
    districtId: '1208060',
    name: 'Sipaku Area',
  },
  {
    id: '1208060013',
    districtId: '1208060',
    name: 'Anjung Ganjang',
  },
  {
    id: '1208061001',
    districtId: '1208061',
    name: 'Pulau Maria',
  },
  {
    id: '1208061002',
    districtId: '1208061',
    name: 'Pulau Tanjung',
  },
  {
    id: '1208061003',
    districtId: '1208061',
    name: 'Teluk Dalam',
  },
  {
    id: '1208061004',
    districtId: '1208061',
    name: 'Perkebunan Teluk Dalam',
  },
  {
    id: '1208061005',
    districtId: '1208061',
    name: 'Aek Teluk Kiri',
  },
  {
    id: '1208061006',
    districtId: '1208061',
    name: 'Mekar Tanjung',
  },
  {
    id: '1208070001',
    districtId: '1208070',
    name: 'Perkebunan Pulahan',
  },
  {
    id: '1208070002',
    districtId: '1208070',
    name: 'Perkebunan Air Batu III/IX',
  },
  {
    id: '1208070003',
    districtId: '1208070',
    name: 'Sungai Alim Ulu',
  },
  {
    id: '1208070004',
    districtId: '1208070',
    name: 'Air Teluk Hessa',
  },
  {
    id: '1208070005',
    districtId: '1208070',
    name: 'Perkebunan Air Batu I/II',
  },
  {
    id: '1208070006',
    districtId: '1208070',
    name: 'Pinanggiripan',
  },
  {
    id: '1208070007',
    districtId: '1208070',
    name: 'Danau Sijabut',
  },
  {
    id: '1208070008',
    districtId: '1208070',
    name: 'Hessa Perlompongan',
  },
  {
    id: '1208070009',
    districtId: '1208070',
    name: 'Air Genting',
  },
  {
    id: '1208070010',
    districtId: '1208070',
    name: 'Hessa Air Genting',
  },
  {
    id: '1208070011',
    districtId: '1208070',
    name: 'Sijabut Teratai',
  },
  {
    id: '1208070012',
    districtId: '1208070',
    name: 'Pulau Pale',
  },
  {
    id: '1208071001',
    districtId: '1208071',
    name: 'Tanjung Alam',
  },
  {
    id: '1208071002',
    districtId: '1208071',
    name: 'Perkebunan Sei Dadap III/IV',
  },
  {
    id: '1208071003',
    districtId: '1208071',
    name: 'Bahung Sibatu-Batu',
  },
  {
    id: '1208071004',
    districtId: '1208071',
    name: 'Sei Alim Hasak',
  },
  {
    id: '1208071005',
    districtId: '1208071',
    name: 'Perkebunan Sei Dadap I/II',
  },
  {
    id: '1208071006',
    districtId: '1208071',
    name: 'Sei Kamah II',
  },
  {
    id: '1208071007',
    districtId: '1208071',
    name: 'Sei Kamah I',
  },
  {
    id: '1208071008',
    districtId: '1208071',
    name: 'Tanjung Asri',
  },
  {
    id: '1208071009',
    districtId: '1208071',
    name: 'Sei Kamah Baru',
  },
  {
    id: '1208071010',
    districtId: '1208071',
    name: 'Pasiran',
  },
  {
    id: '1208080001',
    districtId: '1208080',
    name: 'Lestari',
  },
  {
    id: '1208080005',
    districtId: '1208080',
    name: 'Buntu Pane',
  },
  {
    id: '1208080006',
    districtId: '1208080',
    name: 'Ambalutu',
  },
  {
    id: '1208080008',
    districtId: '1208080',
    name: 'Prapat Janji',
  },
  {
    id: '1208080012',
    districtId: '1208080',
    name: 'Sei Silau Timur',
  },
  {
    id: '1208080013',
    districtId: '1208080',
    name: 'Sionggang',
  },
  {
    id: '1208080014',
    districtId: '1208080',
    name: 'Mekar Sari',
  },
  {
    id: '1208080015',
    districtId: '1208080',
    name: 'Perkebunan Sei Silau',
  },
  {
    id: '1208080016',
    districtId: '1208080',
    name: 'Karya Ambalutu',
  },
  {
    id: '1208081001',
    districtId: '1208081',
    name: 'Teladan',
  },
  {
    id: '1208081002',
    districtId: '1208081',
    name: 'Sidomulyo',
  },
  {
    id: '1208081003',
    districtId: '1208081',
    name: 'Butrea/Piasa Ulu',
  },
  {
    id: '1208081004',
    districtId: '1208081',
    name: 'Terusan Tengah',
  },
  {
    id: '1208081005',
    districtId: '1208081',
    name: 'Sumber Harapan',
  },
  {
    id: '1208081006',
    districtId: '1208081',
    name: 'Tinggi Raja',
  },
  {
    id: '1208081007',
    districtId: '1208081',
    name: 'Padang Sari',
  },
  {
    id: '1208082001',
    districtId: '1208082',
    name: 'Sei Silau Tua',
  },
  {
    id: '1208082002',
    districtId: '1208082',
    name: 'Sei Silau Barat',
  },
  {
    id: '1208082003',
    districtId: '1208082',
    name: 'Silau Maraja',
  },
  {
    id: '1208082004',
    districtId: '1208082',
    name: 'Urung Pane',
  },
  {
    id: '1208082005',
    districtId: '1208082',
    name: 'Bangun Sari',
  },
  {
    id: '1208090013',
    districtId: '1208090',
    name: 'Serdang',
  },
  {
    id: '1208090014',
    districtId: '1208090',
    name: 'Meranti',
  },
  {
    id: '1208090015',
    districtId: '1208090',
    name: 'Sei Beluru',
  },
  {
    id: '1208090016',
    districtId: '1208090',
    name: 'Perkebunan Sei Balai',
  },
  {
    id: '1208090020',
    districtId: '1208090',
    name: 'Gajah',
  },
  {
    id: '1208090021',
    districtId: '1208090',
    name: 'Air Putih',
  },
  {
    id: '1208090022',
    districtId: '1208090',
    name: 'Sukajadi',
  },
  {
    id: '1208091001',
    districtId: '1208091',
    name: 'Taman Sari',
  },
  {
    id: '1208091002',
    districtId: '1208091',
    name: 'Perhutaan Silau',
  },
  {
    id: '1208091003',
    districtId: '1208091',
    name: 'Sukadamai',
  },
  {
    id: '1208091004',
    districtId: '1208091',
    name: 'Tanah Rakyat',
  },
  {
    id: '1208091005',
    districtId: '1208091',
    name: 'Gedangan',
  },
  {
    id: '1208091006',
    districtId: '1208091',
    name: 'Sidomulyo',
  },
  {
    id: '1208091007',
    districtId: '1208091',
    name: 'Pulo Bandring',
  },
  {
    id: '1208091008',
    districtId: '1208091',
    name: 'Suka Makmur',
  },
  {
    id: '1208091009',
    districtId: '1208091',
    name: 'Sukadamai Barat',
  },
  {
    id: '1208091010',
    districtId: '1208091',
    name: 'Bunut Seberang',
  },
  {
    id: '1208092001',
    districtId: '1208092',
    name: 'Pondok Bungur',
  },
  {
    id: '1208092002',
    districtId: '1208092',
    name: 'Rawang Baru',
  },
  {
    id: '1208092003',
    districtId: '1208092',
    name: 'Rawang Pasar V',
  },
  {
    id: '1208092004',
    districtId: '1208092',
    name: 'Rawang Pasar IV',
  },
  {
    id: '1208092005',
    districtId: '1208092',
    name: 'Rawang Lama',
  },
  {
    id: '1208092006',
    districtId: '1208092',
    name: 'Panca Arga',
  },
  {
    id: '1208092007',
    districtId: '1208092',
    name: 'Rawang Pasar VI',
  },
  {
    id: '1208100001',
    districtId: '1208100',
    name: 'Binjai Serbangan',
  },
  {
    id: '1208100002',
    districtId: '1208100',
    name: 'Air Joman',
  },
  {
    id: '1208100003',
    districtId: '1208100',
    name: 'Air Joman Baru',
  },
  {
    id: '1208100004',
    districtId: '1208100',
    name: 'Punggulan',
  },
  {
    id: '1208100005',
    districtId: '1208100',
    name: 'Pasar Lembu',
  },
  {
    id: '1208100007',
    districtId: '1208100',
    name: 'Banjar',
  },
  {
    id: '1208100008',
    districtId: '1208100',
    name: 'Subur',
  },
  {
    id: '1208101001',
    districtId: '1208101',
    name: 'Lubuk Palas',
  },
  {
    id: '1208101002',
    districtId: '1208101',
    name: 'Silo Baru',
  },
  {
    id: '1208101003',
    districtId: '1208101',
    name: 'Silo Bonto',
  },
  {
    id: '1208101004',
    districtId: '1208101',
    name: 'Silo Lama',
  },
  {
    id: '1208101005',
    districtId: '1208101',
    name: 'Bangun Sari',
  },
  {
    id: '1208160001',
    districtId: '1208160',
    name: 'Sei Renggas',
  },
  {
    id: '1208160002',
    districtId: '1208160',
    name: 'Sendang Sari',
  },
  {
    id: '1208160003',
    districtId: '1208160',
    name: 'Kisaran Barat',
  },
  {
    id: '1208160004',
    districtId: '1208160',
    name: 'Tegal Sari',
  },
  {
    id: '1208160005',
    districtId: '1208160',
    name: 'Tebing Kisaran',
  },
  {
    id: '1208160006',
    districtId: '1208160',
    name: 'Kisaran Kota',
  },
  {
    id: '1208160007',
    districtId: '1208160',
    name: 'Kisaran Baru',
  },
  {
    id: '1208160008',
    districtId: '1208160',
    name: 'Mekar Baru',
  },
  {
    id: '1208160009',
    districtId: '1208160',
    name: 'Sidodadi',
  },
  {
    id: '1208160010',
    districtId: '1208160',
    name: 'Dadi Mulyo',
  },
  {
    id: '1208160011',
    districtId: '1208160',
    name: 'Sidomukti',
  },
  {
    id: '1208160012',
    districtId: '1208160',
    name: 'Bunut',
  },
  {
    id: '1208160013',
    districtId: '1208160',
    name: 'Bunut Barat',
  },
  {
    id: '1208170001',
    districtId: '1208170',
    name: 'Sentang',
  },
  {
    id: '1208170002',
    districtId: '1208170',
    name: 'Kedai Ledang',
  },
  {
    id: '1208170003',
    districtId: '1208170',
    name: 'Kisaran Naga',
  },
  {
    id: '1208170004',
    districtId: '1208170',
    name: 'Teladan',
  },
  {
    id: '1208170005',
    districtId: '1208170',
    name: 'Kisaran Timur',
  },
  {
    id: '1208170006',
    districtId: '1208170',
    name: 'Selawan',
  },
  {
    id: '1208170007',
    districtId: '1208170',
    name: 'Mutiara',
  },
  {
    id: '1208170008',
    districtId: '1208170',
    name: 'Si Umbut Baru',
  },
  {
    id: '1208170009',
    districtId: '1208170',
    name: 'Siumbut - Umbut',
  },
  {
    id: '1208170010',
    districtId: '1208170',
    name: 'Karang Anyer',
  },
  {
    id: '1208170011',
    districtId: '1208170',
    name: 'Gambir Baru',
  },
  {
    id: '1208170012',
    districtId: '1208170',
    name: 'Lestari',
  },
  {
    id: '1209010002',
    districtId: '1209010',
    name: 'Sibangun Meriah',
  },
  {
    id: '1209010004',
    districtId: '1209010',
    name: 'Saribu Dolok',
  },
  {
    id: '1209010005',
    districtId: '1209010',
    name: 'Purba Sinombah',
  },
  {
    id: '1209010006',
    districtId: '1209010',
    name: 'Purba Tua',
  },
  {
    id: '1209010011',
    districtId: '1209010',
    name: 'Purba Tua Baru',
  },
  {
    id: '1209010014',
    districtId: '1209010',
    name: 'Sinar Baru',
  },
  {
    id: '1209010015',
    districtId: '1209010',
    name: 'Purba Tua Etek',
  },
  {
    id: '1209011001',
    districtId: '1209011',
    name: 'Ujung Saribu',
  },
  {
    id: '1209011002',
    districtId: '1209011',
    name: 'Silimakuta Barat',
  },
  {
    id: '1209011003',
    districtId: '1209011',
    name: 'Siboras',
  },
  {
    id: '1209011004',
    districtId: '1209011',
    name: 'Ujung Mariah',
  },
  {
    id: '1209011005',
    districtId: '1209011',
    name: 'Mardinding',
  },
  {
    id: '1209011006',
    districtId: '1209011',
    name: 'Naga Saribu',
  },
  {
    id: '1209011007',
    districtId: '1209011',
    name: 'Saribujandi',
  },
  {
    id: '1209011008',
    districtId: '1209011',
    name: 'Naga Mariah',
  },
  {
    id: '1209011009',
    districtId: '1209011',
    name: 'Bandar Saribu',
  },
  {
    id: '1209011010',
    districtId: '1209011',
    name: 'Naga Bosar',
  },
  {
    id: '1209020002',
    districtId: '1209020',
    name: 'Kinalang',
  },
  {
    id: '1209020006',
    districtId: '1209020',
    name: 'Tiga Runggu',
  },
  {
    id: '1209020007',
    districtId: '1209020',
    name: 'Purba Tengah',
  },
  {
    id: '1209020008',
    districtId: '1209020',
    name: 'Pematang Purba',
  },
  {
    id: '1209020009',
    districtId: '1209020',
    name: 'Purba Sipinggan',
  },
  {
    id: '1209020010',
    districtId: '1209020',
    name: 'Urung Purba',
  },
  {
    id: '1209020011',
    districtId: '1209020',
    name: 'Tanoh Tinggir',
  },
  {
    id: '1209020012',
    districtId: '1209020',
    name: 'Purba Dolok',
  },
  {
    id: '1209020013',
    districtId: '1209020',
    name: 'Saribu Jandi',
  },
  {
    id: '1209020014',
    districtId: '1209020',
    name: 'Hutaraja',
  },
  {
    id: '1209020015',
    districtId: '1209020',
    name: 'Nagori Tongah',
  },
  {
    id: '1209020016',
    districtId: '1209020',
    name: 'Urung Pane',
  },
  {
    id: '1209020017',
    districtId: '1209020',
    name: 'Bunga Sampang',
  },
  {
    id: '1209020018',
    districtId: '1209020',
    name: 'Bandar Sauhur',
  },
  {
    id: '1209021001',
    districtId: '1209021',
    name: 'Nagori Sihalpe',
  },
  {
    id: '1209021002',
    districtId: '1209021',
    name: 'Purba Horison',
  },
  {
    id: '1209021003',
    districtId: '1209021',
    name: 'Purba Pasir',
  },
  {
    id: '1209021004',
    districtId: '1209021',
    name: 'Haranggaol',
  },
  {
    id: '1209021005',
    districtId: '1209021',
    name: 'Nagori Purba',
  },
  {
    id: '1209040007',
    districtId: '1209040',
    name: 'Sidamanik',
  },
  {
    id: '1209040008',
    districtId: '1209040',
    name: 'Ambarisan',
  },
  {
    id: '1209040009',
    districtId: '1209040',
    name: 'Sarimatondang',
  },
  {
    id: '1209040010',
    districtId: '1209040',
    name: 'Bah Butong Satu',
  },
  {
    id: '1209040011',
    districtId: '1209040',
    name: 'Bah Butong Dua',
  },
  {
    id: '1209040012',
    districtId: '1209040',
    name: 'Bahal Gajah',
  },
  {
    id: '1209040013',
    districtId: '1209040',
    name: 'Tiga Bolon',
  },
  {
    id: '1209040014',
    districtId: '1209040',
    name: 'Manik Hataran',
  },
  {
    id: '1209040015',
    districtId: '1209040',
    name: 'Mekar Sidamanik',
  },
  {
    id: '1209040016',
    districtId: '1209040',
    name: 'Manik Maraja',
  },
  {
    id: '1209040017',
    districtId: '1209040',
    name: 'Bah Biak',
  },
  {
    id: '1209040018',
    districtId: '1209040',
    name: 'Kebun Sayur Bah Butong',
  },
  {
    id: '1209040019',
    districtId: '1209040',
    name: 'Birong Ulu Manriah',
  },
  {
    id: '1209040020',
    districtId: '1209040',
    name: 'Manik Rambung',
  },
  {
    id: '1209040021',
    districtId: '1209040',
    name: 'Bukit Rejo',
  },
  {
    id: '1209041001',
    districtId: '1209041',
    name: 'Sipolha Horisan',
  },
  {
    id: '1209041002',
    districtId: '1209041',
    name: 'Pematang Tambun Raya',
  },
  {
    id: '1209041003',
    districtId: '1209041',
    name: 'Sihaporas',
  },
  {
    id: '1209041004',
    districtId: '1209041',
    name: 'Jorlang Huluan',
  },
  {
    id: '1209041005',
    districtId: '1209041',
    name: 'Bandar Manik',
  },
  {
    id: '1209041006',
    districtId: '1209041',
    name: 'Sait Buttu Saribu',
  },
  {
    id: '1209041007',
    districtId: '1209041',
    name: 'Pematang Sidamanik',
  },
  {
    id: '1209041008',
    districtId: '1209041',
    name: 'Sarimattin',
  },
  {
    id: '1209041009',
    districtId: '1209041',
    name: 'Simantin',
  },
  {
    id: '1209041010',
    districtId: '1209041',
    name: 'Gorak',
  },
  {
    id: '1209050001',
    districtId: '1209050',
    name: 'Sipangan Bolon',
  },
  {
    id: '1209050002',
    districtId: '1209050',
    name: 'Girsang',
  },
  {
    id: '1209050003',
    districtId: '1209050',
    name: 'Parapat',
  },
  {
    id: '1209050004',
    districtId: '1209050',
    name: 'Tiga Raja',
  },
  {
    id: '1209050005',
    districtId: '1209050',
    name: 'Sibaganding',
  },
  {
    id: '1209050006',
    districtId: '1209050',
    name: 'Sipangan Bolon Mekar',
  },
  {
    id: '1209060006',
    districtId: '1209060',
    name: 'Mekar Mulia',
  },
  {
    id: '1209060007',
    districtId: '1209060',
    name: 'Pardamean Asih',
  },
  {
    id: '1209060008',
    districtId: '1209060',
    name: 'Marubun Jaya',
  },
  {
    id: '1209060009',
    districtId: '1209060',
    name: 'Totap Majawa',
  },
  {
    id: '1209060010',
    districtId: '1209060',
    name: 'Balimbingan',
  },
  {
    id: '1209060011',
    districtId: '1209060',
    name: 'Bah Kisat',
  },
  {
    id: '1209060012',
    districtId: '1209060',
    name: 'Maligas Tongah',
  },
  {
    id: '1209060015',
    districtId: '1209060',
    name: 'Panambean Marjanji',
  },
  {
    id: '1209060016',
    districtId: '1209060',
    name: 'Tanjung Pasir',
  },
  {
    id: '1209060017',
    districtId: '1209060',
    name: 'Muara Mulia',
  },
  {
    id: '1209060018',
    districtId: '1209060',
    name: 'Bosar Galugur',
  },
  {
    id: '1209060019',
    districtId: '1209060',
    name: 'Pematang Tanah Jawa',
  },
  {
    id: '1209060020',
    districtId: '1209060',
    name: 'Baja Dolok',
  },
  {
    id: '1209060021',
    districtId: '1209060',
    name: 'Bah Jambi II',
  },
  {
    id: '1209060022',
    districtId: '1209060',
    name: 'Pagar Jambi',
  },
  {
    id: '1209060023',
    districtId: '1209060',
    name: 'Bayu Bagasan',
  },
  {
    id: '1209060024',
    districtId: '1209060',
    name: 'Baliju',
  },
  {
    id: '1209060025',
    districtId: '1209060',
    name: 'Bah Jambi III',
  },
  {
    id: '1209060026',
    districtId: '1209060',
    name: 'Marubun Bayu',
  },
  {
    id: '1209060027',
    districtId: '1209060',
    name: 'Parbalogan',
  },
  {
    id: '1209061001',
    districtId: '1209061',
    name: 'Bosar Nauli',
  },
  {
    id: '1209061002',
    districtId: '1209061',
    name: 'Tangga Batu',
  },
  {
    id: '1209061003',
    districtId: '1209061',
    name: 'Buntu Turunan',
  },
  {
    id: '1209061004',
    districtId: '1209061',
    name: 'Buntu Bayu',
  },
  {
    id: '1209061005',
    districtId: '1209061',
    name: 'Saribu Asih',
  },
  {
    id: '1209061006',
    districtId: '1209061',
    name: 'Jawa Tongah',
  },
  {
    id: '1209061007',
    districtId: '1209061',
    name: 'Tonduhan',
  },
  {
    id: '1209061008',
    districtId: '1209061',
    name: 'Parhundalian Jawadipar',
  },
  {
    id: '1209061009',
    districtId: '1209061',
    name: 'Jawa Tongah II',
  },
  {
    id: '1209070001',
    districtId: '1209070',
    name: 'Dolok Parmonangan',
  },
  {
    id: '1209070002',
    districtId: '1209070',
    name: 'Negeri Dolok',
  },
  {
    id: '1209070003',
    districtId: '1209070',
    name: 'Gunung Mariah',
  },
  {
    id: '1209070004',
    districtId: '1209070',
    name: 'Marihat Dolok',
  },
  {
    id: '1209070005',
    districtId: '1209070',
    name: 'Marihat Raja',
  },
  {
    id: '1209070006',
    districtId: '1209070',
    name: 'Tiga Dolok',
  },
  {
    id: '1209070007',
    districtId: '1209070',
    name: 'Bandar Dolok',
  },
  {
    id: '1209070008',
    districtId: '1209070',
    name: 'Dolok Tomuan',
  },
  {
    id: '1209070009',
    districtId: '1209070',
    name: 'Ujung Bondar',
  },
  {
    id: '1209070010',
    districtId: '1209070',
    name: 'Siatasan',
  },
  {
    id: '1209070011',
    districtId: '1209070',
    name: 'Pondok Buluh',
  },
  {
    id: '1209070012',
    districtId: '1209070',
    name: 'Marihat Pondok',
  },
  {
    id: '1209070013',
    districtId: '1209070',
    name: 'Marihat Marsada',
  },
  {
    id: '1209070014',
    districtId: '1209070',
    name: 'Lumban Gorat',
  },
  {
    id: '1209070015',
    districtId: '1209070',
    name: 'Palianaopat',
  },
  {
    id: '1209080001',
    districtId: '1209080',
    name: 'Jorlang Hataran',
  },
  {
    id: '1209080002',
    districtId: '1209080',
    name: 'Sibunga Bunga',
  },
  {
    id: '1209080003',
    districtId: '1209080',
    name: 'Dolok Marlawan',
  },
  {
    id: '1209080004',
    districtId: '1209080',
    name: 'Kasindir',
  },
  {
    id: '1209080005',
    districtId: '1209080',
    name: 'Tiga Balata',
  },
  {
    id: '1209080006',
    districtId: '1209080',
    name: 'Pinang Ratus',
  },
  {
    id: '1209080007',
    districtId: '1209080',
    name: 'Bah Birong Ulu',
  },
  {
    id: '1209080008',
    districtId: '1209080',
    name: 'Bah Sampuran',
  },
  {
    id: '1209080009',
    districtId: '1209080',
    name: 'Panombean Huta Urung',
  },
  {
    id: '1209080010',
    districtId: '1209080',
    name: 'Dipar Hataran',
  },
  {
    id: '1209080011',
    districtId: '1209080',
    name: 'Parmonangan',
  },
  {
    id: '1209080012',
    districtId: '1209080',
    name: 'Dolok Parriasan',
  },
  {
    id: '1209080013',
    districtId: '1209080',
    name: 'Pagar Pinang',
  },
  {
    id: '1209090001',
    districtId: '1209090',
    name: 'Simantin Pane Dame',
  },
  {
    id: '1209090002',
    districtId: '1209090',
    name: 'Bangun Rakyat',
  },
  {
    id: '1209090003',
    districtId: '1209090',
    name: 'Simpang Raya',
  },
  {
    id: '1209090004',
    districtId: '1209090',
    name: 'Siborna',
  },
  {
    id: '1209090006',
    districtId: '1209090',
    name: 'Janggir Leto',
  },
  {
    id: '1209090007',
    districtId: '1209090',
    name: 'Pane Tongah',
  },
  {
    id: '1209090008',
    districtId: '1209090',
    name: 'Sipoldas',
  },
  {
    id: '1209090009',
    districtId: '1209090',
    name: 'Sigodang',
  },
  {
    id: '1209090014',
    districtId: '1209090',
    name: 'Mekar Sari Raya',
  },
  {
    id: '1209090015',
    districtId: '1209090',
    name: 'Bah Balon Tongah',
  },
  {
    id: '1209090016',
    districtId: '1209090',
    name: 'Sigodang Barat',
  },
  {
    id: '1209090017',
    districtId: '1209090',
    name: 'Simpang Raya Dasma',
  },
  {
    id: '1209090018',
    districtId: '1209090',
    name: 'Bangun Das Mariah',
  },
  {
    id: '1209090019',
    districtId: '1209090',
    name: 'Bangun Sitoluh Bah',
  },
  {
    id: '1209090020',
    districtId: '1209090',
    name: 'Nauli Baru',
  },
  {
    id: '1209090021',
    districtId: '1209090',
    name: 'Bahliran Siborna',
  },
  {
    id: '1209090022',
    districtId: '1209090',
    name: 'Rawang Pardomuan Nauli',
  },
  {
    id: '1209091001',
    districtId: '1209091',
    name: 'Simpang Pane',
  },
  {
    id: '1209091002',
    districtId: '1209091',
    name: 'Marjandi',
  },
  {
    id: '1209091003',
    districtId: '1209091',
    name: 'Panombean',
  },
  {
    id: '1209091004',
    districtId: '1209091',
    name: 'Nagori Bosar',
  },
  {
    id: '1209091005',
    districtId: '1209091',
    name: 'Talun Kondot',
  },
  {
    id: '1209091006',
    districtId: '1209091',
    name: 'Pematang Panombean',
  },
  {
    id: '1209091007',
    districtId: '1209091',
    name: 'Simbolon Tengkoh',
  },
  {
    id: '1209091008',
    districtId: '1209091',
    name: 'Pematang Pane',
  },
  {
    id: '1209091009',
    districtId: '1209091',
    name: 'Marjandi Pisang',
  },
  {
    id: '1209091010',
    districtId: '1209091',
    name: 'Banuh Raya',
  },
  {
    id: '1209091011',
    districtId: '1209091',
    name: 'Rukun Mulyo',
  },
  {
    id: '1209100003',
    districtId: '1209100',
    name: 'Raya Bayu',
  },
  {
    id: '1209100004',
    districtId: '1209100',
    name: 'Dalig Raya',
  },
  {
    id: '1209100005',
    districtId: '1209100',
    name: 'Pematang Raya',
  },
  {
    id: '1209100006',
    districtId: '1209100',
    name: 'Merek Raya',
  },
  {
    id: '1209100007',
    districtId: '1209100',
    name: 'Bahapal Raya',
  },
  {
    id: '1209100008',
    districtId: '1209100',
    name: 'Sondi Raya',
  },
  {
    id: '1209100011',
    districtId: '1209100',
    name: 'Siporkas',
  },
  {
    id: '1209100012',
    districtId: '1209100',
    name: 'Silou Huluan',
  },
  {
    id: '1209100013',
    districtId: '1209100',
    name: 'Silou Buttu',
  },
  {
    id: '1209100014',
    districtId: '1209100',
    name: 'Bonguron Kariahan',
  },
  {
    id: '1209100015',
    districtId: '1209100',
    name: 'Sihubu Raya',
  },
  {
    id: '1209100016',
    districtId: '1209100',
    name: 'Raya Bosi',
  },
  {
    id: '1209100017',
    districtId: '1209100',
    name: 'Simbou Baru',
  },
  {
    id: '1209100019',
    districtId: '1209100',
    name: 'Lokkung Raya',
  },
  {
    id: '1209100020',
    districtId: '1209100',
    name: 'Baringin Raya',
  },
  {
    id: '1209100021',
    districtId: '1209100',
    name: 'Limag Raya',
  },
  {
    id: '1209100022',
    districtId: '1209100',
    name: 'Dame Raya',
  },
  {
    id: '1209101001',
    districtId: '1209101',
    name: 'Parjalangan',
  },
  {
    id: '1209101002',
    districtId: '1209101',
    name: 'Raya Huluan',
  },
  {
    id: '1209101003',
    districtId: '1209101',
    name: 'Dolog Huluan',
  },
  {
    id: '1209101004',
    districtId: '1209101',
    name: 'Raya Usang',
  },
  {
    id: '1209101005',
    districtId: '1209101',
    name: 'Bintang Meriah',
  },
  {
    id: '1209101006',
    districtId: '1209101',
    name: 'Bangun Pane',
  },
  {
    id: '1209101007',
    districtId: '1209101',
    name: 'Partuahan',
  },
  {
    id: '1209101008',
    districtId: '1209101',
    name: 'Bah Bolon',
  },
  {
    id: '1209101009',
    districtId: '1209101',
    name: 'Sinaman Labah',
  },
  {
    id: '1209101010',
    districtId: '1209101',
    name: 'Pamatang Sinaman',
  },
  {
    id: '1209110001',
    districtId: '1209110',
    name: 'Cingkes',
  },
  {
    id: '1209110002',
    districtId: '1209110',
    name: 'Paribuan',
  },
  {
    id: '1209110003',
    districtId: '1209110',
    name: 'Saran Padang',
  },
  {
    id: '1209110004',
    districtId: '1209110',
    name: 'Mariah Dolok',
  },
  {
    id: '1209110005',
    districtId: '1209110',
    name: 'Dolok Mariah',
  },
  {
    id: '1209110006',
    districtId: '1209110',
    name: 'Marubun Lokkung',
  },
  {
    id: '1209110007',
    districtId: '1209110',
    name: 'Bawang',
  },
  {
    id: '1209110008',
    districtId: '1209110',
    name: 'Huta Saing',
  },
  {
    id: '1209110009',
    districtId: '1209110',
    name: 'Togur',
  },
  {
    id: '1209110010',
    districtId: '1209110',
    name: 'Perasmian',
  },
  {
    id: '1209110011',
    districtId: '1209110',
    name: 'Tanjung Purba',
  },
  {
    id: '1209110012',
    districtId: '1209110',
    name: 'Ujung Bawang',
  },
  {
    id: '1209110013',
    districtId: '1209110',
    name: 'Silau Marawan',
  },
  {
    id: '1209110014',
    districtId: '1209110',
    name: 'Bosi Sinombah',
  },
  {
    id: '1209120001',
    districtId: '1209120',
    name: 'Dolok Saribu Bangun',
  },
  {
    id: '1209120002',
    districtId: '1209120',
    name: 'Simanabun',
  },
  {
    id: '1209120003',
    districtId: '1209120',
    name: 'Mariah Buttu',
  },
  {
    id: '1209120004',
    districtId: '1209120',
    name: 'Pardomuan Tongah',
  },
  {
    id: '1209120005',
    districtId: '1209120',
    name: 'Dolok Marawa',
  },
  {
    id: '1209120006',
    districtId: '1209120',
    name: 'Negeri Dolok',
  },
  {
    id: '1209120007',
    districtId: '1209120',
    name: 'Bandar Nagori',
  },
  {
    id: '1209120008',
    districtId: '1209120',
    name: 'Bandar Maruhur',
  },
  {
    id: '1209120009',
    districtId: '1209120',
    name: 'Silau Paribuan',
  },
  {
    id: '1209120010',
    districtId: '1209120',
    name: 'Silau Dunia',
  },
  {
    id: '1209120011',
    districtId: '1209120',
    name: 'Buttu Bayu',
  },
  {
    id: '1209120012',
    districtId: '1209120',
    name: 'Nagori Tani',
  },
  {
    id: '1209120013',
    districtId: '1209120',
    name: 'Bah Sarimah',
  },
  {
    id: '1209120014',
    districtId: '1209120',
    name: 'Sinasih',
  },
  {
    id: '1209120015',
    districtId: '1209120',
    name: 'Damakitang',
  },
  {
    id: '1209120016',
    districtId: '1209120',
    name: 'Pardomuan Bandar',
  },
  {
    id: '1209130001',
    districtId: '1209130',
    name: 'Bah Tonang',
  },
  {
    id: '1209130002',
    districtId: '1209130',
    name: 'Sambosar Raya',
  },
  {
    id: '1209130003',
    districtId: '1209130',
    name: 'Bangun Raya',
  },
  {
    id: '1209130004',
    districtId: '1209130',
    name: 'Sindar Raya',
  },
  {
    id: '1209130005',
    districtId: '1209130',
    name: 'Amborokan Pane Raya',
  },
  {
    id: '1209130006',
    districtId: '1209130',
    name: 'Panduman',
  },
  {
    id: '1209130007',
    districtId: '1209130',
    name: 'Bah Bulian',
  },
  {
    id: '1209130008',
    districtId: '1209130',
    name: 'Durian Baggal',
  },
  {
    id: '1209130009',
    districtId: '1209130',
    name: 'Sorba Dolog',
  },
  {
    id: '1209130010',
    districtId: '1209130',
    name: 'Puli Buah',
  },
  {
    id: '1209130011',
    districtId: '1209130',
    name: 'Gunung Datas',
  },
  {
    id: '1209130012',
    districtId: '1209130',
    name: 'Banjaran',
  },
  {
    id: '1209130013',
    districtId: '1209130',
    name: 'Marubun Siboras',
  },
  {
    id: '1209130014',
    districtId: '1209130',
    name: 'Banu Raya',
  },
  {
    id: '1209140001',
    districtId: '1209140',
    name: 'Dolok Maraja',
  },
  {
    id: '1209140002',
    districtId: '1209140',
    name: 'Sinaksak',
  },
  {
    id: '1209140003',
    districtId: '1209140',
    name: 'Batu Silangit',
  },
  {
    id: '1209140004',
    districtId: '1209140',
    name: 'Dolok Ulu',
  },
  {
    id: '1209140005',
    districtId: '1209140',
    name: 'Nagur Usang',
  },
  {
    id: '1209140006',
    districtId: '1209140',
    name: 'Naga Dolok',
  },
  {
    id: '1209140007',
    districtId: '1209140',
    name: 'Dolok Kahean',
  },
  {
    id: '1209140008',
    districtId: '1209140',
    name: 'Purbasari',
  },
  {
    id: '1209140009',
    districtId: '1209140',
    name: 'Pematang Dolok Kahean',
  },
  {
    id: '1209140010',
    districtId: '1209140',
    name: 'Negeri Bayu Muslimin',
  },
  {
    id: '1209140011',
    districtId: '1209140',
    name: 'Dolok Simbolon',
  },
  {
    id: '1209150001',
    districtId: '1209150',
    name: 'Silenduk',
  },
  {
    id: '1209150002',
    districtId: '1209150',
    name: 'Bah Tobu',
  },
  {
    id: '1209150003',
    districtId: '1209150',
    name: 'Bandar Selamat',
  },
  {
    id: '1209150004',
    districtId: '1209150',
    name: 'Dolok Merangir Satu',
  },
  {
    id: '1209150005',
    districtId: '1209150',
    name: 'Dolok Merangir Dua',
  },
  {
    id: '1209150006',
    districtId: '1209150',
    name: 'Serbelawan',
  },
  {
    id: '1209150007',
    districtId: '1209150',
    name: 'Dolok Ilir Satu',
  },
  {
    id: '1209150008',
    districtId: '1209150',
    name: 'Dolok Mainu',
  },
  {
    id: '1209150009',
    districtId: '1209150',
    name: 'Bahung Kahean',
  },
  {
    id: '1209150010',
    districtId: '1209150',
    name: 'Dolok Ilir Dua',
  },
  {
    id: '1209150011',
    districtId: '1209150',
    name: 'Kahean',
  },
  {
    id: '1209150012',
    districtId: '1209150',
    name: 'Dolog Tenera',
  },
  {
    id: '1209150013',
    districtId: '1209150',
    name: 'Dolok Kataran',
  },
  {
    id: '1209150014',
    districtId: '1209150',
    name: 'Padang Mainu',
  },
  {
    id: '1209150015',
    districtId: '1209150',
    name: 'Bahung Huluan',
  },
  {
    id: '1209150016',
    districtId: '1209150',
    name: 'Aman Sari',
  },
  {
    id: '1209160001',
    districtId: '1209160',
    name: 'Silampuyang',
  },
  {
    id: '1209160002',
    districtId: '1209160',
    name: 'Silau Manik',
  },
  {
    id: '1209160003',
    districtId: '1209160',
    name: 'Silau Malaha',
  },
  {
    id: '1209160004',
    districtId: '1209160',
    name: 'Marihat Baris',
  },
  {
    id: '1209160005',
    districtId: '1209160',
    name: 'Siantar Estate',
  },
  {
    id: '1209160006',
    districtId: '1209160',
    name: 'Rambung Merah',
  },
  {
    id: '1209160007',
    districtId: '1209160',
    name: 'Karang Bangun',
  },
  {
    id: '1209160008',
    districtId: '1209160',
    name: 'Pematang Simalungun',
  },
  {
    id: '1209160009',
    districtId: '1209160',
    name: 'Dolok Marlawan',
  },
  {
    id: '1209160010',
    districtId: '1209160',
    name: 'Pantoan Maju',
  },
  {
    id: '1209160011',
    districtId: '1209160',
    name: 'Sejahtera',
  },
  {
    id: '1209160012',
    districtId: '1209160',
    name: 'Sitalasari',
  },
  {
    id: '1209160013',
    districtId: '1209160',
    name: 'Laras Dua',
  },
  {
    id: '1209160014',
    districtId: '1209160',
    name: 'Nusa Harapan',
  },
  {
    id: '1209160015',
    districtId: '1209160',
    name: 'Lestari Indah',
  },
  {
    id: '1209160016',
    districtId: '1209160',
    name: 'Dolok Hataran',
  },
  {
    id: '1209160036',
    districtId: '1209160',
    name: 'Pematang Silampuyang',
  },
  {
    id: '1209161001',
    districtId: '1209161',
    name: 'Senio',
  },
  {
    id: '1209161002',
    districtId: '1209161',
    name: 'Bangun',
  },
  {
    id: '1209161003',
    districtId: '1209161',
    name: 'Pematang Asilum',
  },
  {
    id: '1209161004',
    districtId: '1209161',
    name: 'Pematang Sah Kuda',
  },
  {
    id: '1209161005',
    districtId: '1209161',
    name: 'Marihat Bukit',
  },
  {
    id: '1209161006',
    districtId: '1209161',
    name: 'Sah Kuda Bayu',
  },
  {
    id: '1209161007',
    districtId: '1209161',
    name: 'Bukit Maraja',
  },
  {
    id: '1209161008',
    districtId: '1209161',
    name: 'Pematang Gajing',
  },
  {
    id: '1209161009',
    districtId: '1209161',
    name: 'Dolok Malela',
  },
  {
    id: '1209161010',
    districtId: '1209161',
    name: 'Bandar Siantar',
  },
  {
    id: '1209161011',
    districtId: '1209161',
    name: 'Serapuh',
  },
  {
    id: '1209161012',
    districtId: '1209161',
    name: 'Silau Malela',
  },
  {
    id: '1209161013',
    districtId: '1209161',
    name: 'Silulu',
  },
  {
    id: '1209161014',
    districtId: '1209161',
    name: 'Margomulyo',
  },
  {
    id: '1209161015',
    districtId: '1209161',
    name: 'Nagori Malela',
  },
  {
    id: '1209161016',
    districtId: '1209161',
    name: 'Lingga',
  },
  {
    id: '1209162001',
    districtId: '1209162',
    name: 'Karang Sari',
  },
  {
    id: '1209162002',
    districtId: '1209162',
    name: 'Karang Rejo',
  },
  {
    id: '1209162003',
    districtId: '1209162',
    name: 'Karang Anyer',
  },
  {
    id: '1209162004',
    districtId: '1209162',
    name: 'Silau Bayu',
  },
  {
    id: '1209162005',
    districtId: '1209162',
    name: 'Huta Dipar',
  },
  {
    id: '1209162006',
    districtId: '1209162',
    name: 'Tumorang',
  },
  {
    id: '1209162007',
    districtId: '1209162',
    name: 'Rabuhit',
  },
  {
    id: '1209162008',
    districtId: '1209162',
    name: 'Bandar Malela',
  },
  {
    id: '1209162009',
    districtId: '1209162',
    name: 'Gajing',
  },
  {
    id: '1209170005',
    districtId: '1209170',
    name: 'Mariah Hombang',
  },
  {
    id: '1209170006',
    districtId: '1209170',
    name: 'Marihat Mayang',
  },
  {
    id: '1209170007',
    districtId: '1209170',
    name: 'Jawa Baru',
  },
  {
    id: '1209170008',
    districtId: '1209170',
    name: 'Pulo Bayu',
  },
  {
    id: '1209170009',
    districtId: '1209170',
    name: 'Huta Bayu',
  },
  {
    id: '1209170010',
    districtId: '1209170',
    name: 'Silak Kidir',
  },
  {
    id: '1209170011',
    districtId: '1209170',
    name: 'Bosar Bayu',
  },
  {
    id: '1209170012',
    districtId: '1209170',
    name: 'Mancuk',
  },
  {
    id: '1209170015',
    districtId: '1209170',
    name: 'Maligas Bayu',
  },
  {
    id: '1209170016',
    districtId: '1209170',
    name: 'Raja Maligas',
  },
  {
    id: '1209170017',
    districtId: '1209170',
    name: 'Dolok Sinumbah',
  },
  {
    id: '1209170018',
    districtId: '1209170',
    name: 'Raja Maligas I',
  },
  {
    id: '1209170019',
    districtId: '1209170',
    name: 'Bahal Batu',
  },
  {
    id: '1209170020',
    districtId: '1209170',
    name: 'Pokan Baru',
  },
  {
    id: '1209170021',
    districtId: '1209170',
    name: 'Manrayap Baru',
  },
  {
    id: '1209170022',
    districtId: '1209170',
    name: 'Talang Bayu',
  },
  {
    id: '1209171001',
    districtId: '1209171',
    name: 'Mariah Jambi',
  },
  {
    id: '1209171002',
    districtId: '1209171',
    name: 'Moho',
  },
  {
    id: '1209171003',
    districtId: '1209171',
    name: 'Bahalat Bayu',
  },
  {
    id: '1209171004',
    districtId: '1209171',
    name: 'Mekar Bahalat',
  },
  {
    id: '1209171005',
    districtId: '1209171',
    name: 'Tanjung Maraja',
  },
  {
    id: '1209171006',
    districtId: '1209171',
    name: 'Jawa Maraja',
  },
  {
    id: '1209171007',
    districtId: '1209171',
    name: 'Bah Joga',
  },
  {
    id: '1209171008',
    districtId: '1209171',
    name: 'Bah Jambi I',
  },
  {
    id: '1209180004',
    districtId: '1209180',
    name: 'Purba Ganda',
  },
  {
    id: '1209180005',
    districtId: '1209180',
    name: 'Kerasaan II',
  },
  {
    id: '1209180006',
    districtId: '1209180',
    name: 'Kerasaan I',
  },
  {
    id: '1209180007',
    districtId: '1209180',
    name: 'Pardomuan Nauli',
  },
  {
    id: '1209180008',
    districtId: '1209180',
    name: 'Mariah Bandar',
  },
  {
    id: '1209180009',
    districtId: '1209180',
    name: 'Talun Madear',
  },
  {
    id: '1209180010',
    districtId: '1209180',
    name: 'Kandangan',
  },
  {
    id: '1209180011',
    districtId: '1209180',
    name: 'Purwosari',
  },
  {
    id: '1209180012',
    districtId: '1209180',
    name: 'Pematang Bandar',
  },
  {
    id: '1209180013',
    districtId: '1209180',
    name: 'Bandar Manis',
  },
  {
    id: '1209180014',
    districtId: '1209180',
    name: 'Wonorejo',
  },
  {
    id: '1209180015',
    districtId: '1209180',
    name: 'Talun Rejo',
  },
  {
    id: '1209180016',
    districtId: '1209180',
    name: 'Purwodadi',
  },
  {
    id: '1209181001',
    districtId: '1209181',
    name: 'L A R A S',
  },
  {
    id: '1209181002',
    districtId: '1209181',
    name: 'Bah Gunung',
  },
  {
    id: '1209181003',
    districtId: '1209181',
    name: 'Bandar Tongah',
  },
  {
    id: '1209181004',
    districtId: '1209181',
    name: 'Dolok Parmonangan',
  },
  {
    id: '1209181005',
    districtId: '1209181',
    name: 'Naga Jaya I',
  },
  {
    id: '1209181006',
    districtId: '1209181',
    name: 'Naga Jaya II',
  },
  {
    id: '1209181007',
    districtId: '1209181',
    name: 'Tanjung Hataran',
  },
  {
    id: '1209181008',
    districtId: '1209181',
    name: 'Bandar Betsy I',
  },
  {
    id: '1209181009',
    districtId: '1209181',
    name: 'Bandar Betsy II',
  },
  {
    id: '1209181010',
    districtId: '1209181',
    name: 'Naga Sopa',
  },
  {
    id: '1209190001',
    districtId: '1209190',
    name: 'Pematang Kerasaan',
  },
  {
    id: '1209190002',
    districtId: '1209190',
    name: 'Pematang Kerasaan Rejo',
  },
  {
    id: '1209190003',
    districtId: '1209190',
    name: 'Marihat Bandar',
  },
  {
    id: '1209190004',
    districtId: '1209190',
    name: 'Timbaan',
  },
  {
    id: '1209190005',
    districtId: '1209190',
    name: 'Nagori Bandar',
  },
  {
    id: '1209190006',
    districtId: '1209190',
    name: 'Bandar Rakyat',
  },
  {
    id: '1209190007',
    districtId: '1209190',
    name: 'Bandar Pulo',
  },
  {
    id: '1209190008',
    districtId: '1209190',
    name: 'Bandar Jawa',
  },
  {
    id: '1209190009',
    districtId: '1209190',
    name: 'Perdagangan I',
  },
  {
    id: '1209190010',
    districtId: '1209190',
    name: 'Bah Lias',
  },
  {
    id: '1209190011',
    districtId: '1209190',
    name: 'Perdagangan II',
  },
  {
    id: '1209190012',
    districtId: '1209190',
    name: 'Perlanaan',
  },
  {
    id: '1209190013',
    districtId: '1209190',
    name: 'Sido Tani',
  },
  {
    id: '1209190014',
    districtId: '1209190',
    name: 'Sugarang Bayu',
  },
  {
    id: '1209190015',
    districtId: '1209190',
    name: 'Perdagangan III',
  },
  {
    id: '1209190016',
    districtId: '1209190',
    name: 'Landbouw',
  },
  {
    id: '1209191001',
    districtId: '1209191',
    name: 'Panombean Baru',
  },
  {
    id: '1209191002',
    districtId: '1209191',
    name: 'Lias Baru',
  },
  {
    id: '1209191003',
    districtId: '1209191',
    name: 'Bandar Silou',
  },
  {
    id: '1209191004',
    districtId: '1209191',
    name: 'Bandar Masilam',
  },
  {
    id: '1209191005',
    districtId: '1209191',
    name: 'Gunung Serawan',
  },
  {
    id: '1209191006',
    districtId: '1209191',
    name: 'Bandar Masilam II',
  },
  {
    id: '1209191007',
    districtId: '1209191',
    name: 'Partimbalan',
  },
  {
    id: '1209191008',
    districtId: '1209191',
    name: 'Bandar Tinggi',
  },
  {
    id: '1209191009',
    districtId: '1209191',
    name: 'Bandar Rejo',
  },
  {
    id: '1209191010',
    districtId: '1209191',
    name: 'Bandar Gunung',
  },
  {
    id: '1209200001',
    districtId: '1209200',
    name: 'Parbutaran',
  },
  {
    id: '1209200002',
    districtId: '1209200',
    name: 'Mayang',
  },
  {
    id: '1209200003',
    districtId: '1209200',
    name: 'Dusun Pengkolan',
  },
  {
    id: '1209200004',
    districtId: '1209200',
    name: 'Bosar Maligas',
  },
  {
    id: '1209200005',
    districtId: '1209200',
    name: 'Boluk',
  },
  {
    id: '1209200006',
    districtId: '1209200',
    name: 'Sei Mangkei',
  },
  {
    id: '1209200007',
    districtId: '1209200',
    name: 'Gunung Bayu',
  },
  {
    id: '1209200008',
    districtId: '1209200',
    name: 'Talun Saragih',
  },
  {
    id: '1209200009',
    districtId: '1209200',
    name: 'Marihat Tanjung',
  },
  {
    id: '1209200010',
    districtId: '1209200',
    name: 'Marihat Butar',
  },
  {
    id: '1209200011',
    districtId: '1209200',
    name: 'Sei Torop',
  },
  {
    id: '1209200012',
    districtId: '1209200',
    name: 'Adil Makmur',
  },
  {
    id: '1209200013',
    districtId: '1209200',
    name: 'Teladan',
  },
  {
    id: '1209200014',
    districtId: '1209200',
    name: 'Tempel Jaya',
  },
  {
    id: '1209200015',
    districtId: '1209200',
    name: 'Sidomulyo',
  },
  {
    id: '1209200016',
    districtId: '1209200',
    name: 'Nanggar Bayu',
  },
  {
    id: '1209200017',
    districtId: '1209200',
    name: 'Mekar Rejo',
  },
  {
    id: '1209210001',
    districtId: '1209210',
    name: 'Sordang Bolon',
  },
  {
    id: '1209210002',
    districtId: '1209210',
    name: 'Sayur Matinggi',
  },
  {
    id: '1209210003',
    districtId: '1209210',
    name: 'Taratak Nagodang',
  },
  {
    id: '1209210004',
    districtId: '1209210',
    name: 'Huta Parik',
  },
  {
    id: '1209210005',
    districtId: '1209210',
    name: 'Ujung Padang',
  },
  {
    id: '1209210006',
    districtId: '1209210',
    name: 'Tinjowan',
  },
  {
    id: '1209210007',
    districtId: '1209210',
    name: 'Dusun Ulu',
  },
  {
    id: '1209210008',
    districtId: '1209210',
    name: 'Teluk Lapian',
  },
  {
    id: '1209210009',
    districtId: '1209210',
    name: 'Tanjung Rapuan',
  },
  {
    id: '1209210010',
    districtId: '1209210',
    name: 'Pagar Bosi',
  },
  {
    id: '1209210011',
    districtId: '1209210',
    name: 'Bangun Sordang',
  },
  {
    id: '1209210012',
    districtId: '1209210',
    name: 'Aek Ger Ger',
  },
  {
    id: '1209210013',
    districtId: '1209210',
    name: 'Pulo Pitu Marihat',
  },
  {
    id: '1209210014',
    districtId: '1209210',
    name: 'Siringan Ringan',
  },
  {
    id: '1209210015',
    districtId: '1209210',
    name: 'Riah Naposo',
  },
  {
    id: '1209210016',
    districtId: '1209210',
    name: 'Sei Merbau',
  },
  {
    id: '1209210017',
    districtId: '1209210',
    name: 'Kampung Lalang',
  },
  {
    id: '1209210018',
    districtId: '1209210',
    name: 'Sordang Baru',
  },
  {
    id: '1209210019',
    districtId: '1209210',
    name: 'Banjar Hulu',
  },
  {
    id: '1209210020',
    districtId: '1209210',
    name: 'Rawa Masin',
  },
  {
    id: '1210030002',
    districtId: '1210030',
    name: 'Sidiangkat',
  },
  {
    id: '1210030003',
    districtId: '1210030',
    name: 'Batang Beruh',
  },
  {
    id: '1210030004',
    districtId: '1210030',
    name: 'Bintang Hulu',
  },
  {
    id: '1210030005',
    districtId: '1210030',
    name: 'Kalang Simbara',
  },
  {
    id: '1210030006',
    districtId: '1210030',
    name: 'Bintang',
  },
  {
    id: '1210030007',
    districtId: '1210030',
    name: 'Kalang',
  },
  {
    id: '1210030008',
    districtId: '1210030',
    name: 'Kota Sidikalang',
  },
  {
    id: '1210030009',
    districtId: '1210030',
    name: 'Belang Malum',
  },
  {
    id: '1210030010',
    districtId: '1210030',
    name: 'Kuta Gambir',
  },
  {
    id: '1210030011',
    districtId: '1210030',
    name: 'Huta Rakjat',
  },
  {
    id: '1210030012',
    districtId: '1210030',
    name: 'Bintang Mersada',
  },
  {
    id: '1210031001',
    districtId: '1210031',
    name: 'Berampu',
  },
  {
    id: '1210031002',
    districtId: '1210031',
    name: 'Karing',
  },
  {
    id: '1210031003',
    districtId: '1210031',
    name: 'Banjar Toba',
  },
  {
    id: '1210031004',
    districtId: '1210031',
    name: 'Pasi',
  },
  {
    id: '1210031005',
    districtId: '1210031',
    name: 'Sambaliang',
  },
  {
    id: '1210032001',
    districtId: '1210032',
    name: 'Sitinjo',
  },
  {
    id: '1210032003',
    districtId: '1210032',
    name: 'Panji Dabutar',
  },
  {
    id: '1210032012',
    districtId: '1210032',
    name: 'Sitinjo I',
  },
  {
    id: '1210032013',
    districtId: '1210032',
    name: 'Sitinjo II',
  },
  {
    id: '1210040001',
    districtId: '1210040',
    name: 'Parbuluan II',
  },
  {
    id: '1210040002',
    districtId: '1210040',
    name: 'Parbuluan I',
  },
  {
    id: '1210040003',
    districtId: '1210040',
    name: 'Parbuluan V',
  },
  {
    id: '1210040004',
    districtId: '1210040',
    name: 'Parbuluan III',
  },
  {
    id: '1210040005',
    districtId: '1210040',
    name: 'Parbuluan IV',
  },
  {
    id: '1210040006',
    districtId: '1210040',
    name: 'Parbuluan VI',
  },
  {
    id: '1210040007',
    districtId: '1210040',
    name: 'Lae Hole',
  },
  {
    id: '1210040008',
    districtId: '1210040',
    name: 'B A N G U N',
  },
  {
    id: '1210040009',
    districtId: '1210040',
    name: 'Lae Hole I',
  },
  {
    id: '1210040010',
    districtId: '1210040',
    name: 'Lae Hole II',
  },
  {
    id: '1210040011',
    districtId: '1210040',
    name: 'Bangun I',
  },
  {
    id: '1210050001',
    districtId: '1210050',
    name: 'Pegagan Julu V',
  },
  {
    id: '1210050002',
    districtId: '1210050',
    name: 'Pegagan Julu IV',
  },
  {
    id: '1210050003',
    districtId: '1210050',
    name: 'Pegagan Julu II',
  },
  {
    id: '1210050004',
    districtId: '1210050',
    name: 'Pegagan Julu I',
  },
  {
    id: '1210050005',
    districtId: '1210050',
    name: 'Pegagan Julu III',
  },
  {
    id: '1210050006',
    districtId: '1210050',
    name: 'Pegagan Julu VI',
  },
  {
    id: '1210050007',
    districtId: '1210050',
    name: 'Pegagan Julu VII',
  },
  {
    id: '1210050008',
    districtId: '1210050',
    name: 'Pegagan Julu VIII',
  },
  {
    id: '1210050009',
    districtId: '1210050',
    name: 'Pegagan Julu IX',
  },
  {
    id: '1210050010',
    districtId: '1210050',
    name: 'Pegagan Julu X',
  },
  {
    id: '1210050011',
    districtId: '1210050',
    name: 'Tanjung Beringin',
  },
  {
    id: '1210050012',
    districtId: '1210050',
    name: 'Dolok Tolong',
  },
  {
    id: '1210050013',
    districtId: '1210050',
    name: 'Kuta Gugung',
  },
  {
    id: '1210050014',
    districtId: '1210050',
    name: 'Pargambiran',
  },
  {
    id: '1210050015',
    districtId: '1210050',
    name: 'Perjuangan',
  },
  {
    id: '1210050016',
    districtId: '1210050',
    name: 'Sileuh-Leuh Parsaoran',
  },
  {
    id: '1210050017',
    districtId: '1210050',
    name: 'Pangguruan',
  },
  {
    id: '1210050018',
    districtId: '1210050',
    name: 'Tanjung Beringin I',
  },
  {
    id: '1210050019',
    districtId: '1210050',
    name: 'Barisan Nauli',
  },
  {
    id: '1210051001',
    districtId: '1210051',
    name: 'Silalahi II',
  },
  {
    id: '1210051002',
    districtId: '1210051',
    name: 'Silalahi I',
  },
  {
    id: '1210051003',
    districtId: '1210051',
    name: 'Paropo',
  },
  {
    id: '1210051004',
    districtId: '1210051',
    name: 'Silalahi III',
  },
  {
    id: '1210051005',
    districtId: '1210051',
    name: 'Paropo I',
  },
  {
    id: '1210060001',
    districtId: '1210060',
    name: 'Lae Rambong',
  },
  {
    id: '1210060002',
    districtId: '1210060',
    name: 'Lae Ambat',
  },
  {
    id: '1210060003',
    districtId: '1210060',
    name: 'Lae Panginuman',
  },
  {
    id: '1210060004',
    districtId: '1210060',
    name: 'Sumbari',
  },
  {
    id: '1210060005',
    districtId: '1210060',
    name: 'Bakal Gajah',
  },
  {
    id: '1210060006',
    districtId: '1210060',
    name: 'Uruk Belin',
  },
  {
    id: '1210060007',
    districtId: '1210060',
    name: 'Siboras',
  },
  {
    id: '1210060008',
    districtId: '1210060',
    name: 'Bonian',
  },
  {
    id: '1210060009',
    districtId: '1210060',
    name: 'Bongkaras',
  },
  {
    id: '1210060010',
    districtId: '1210060',
    name: 'Tungtung Batu',
  },
  {
    id: '1210060011',
    districtId: '1210060',
    name: 'Longkotan',
  },
  {
    id: '1210060012',
    districtId: '1210060',
    name: 'Parongil',
  },
  {
    id: '1210060013',
    districtId: '1210060',
    name: 'Siratah',
  },
  {
    id: '1210060014',
    districtId: '1210060',
    name: 'Polling Anak-Anak',
  },
  {
    id: '1210060015',
    districtId: '1210060',
    name: 'Palipi',
  },
  {
    id: '1210060016',
    districtId: '1210060',
    name: 'Lae Pangaroan',
  },
  {
    id: '1210061001',
    districtId: '1210061',
    name: 'Sumbul',
  },
  {
    id: '1210061002',
    districtId: '1210061',
    name: 'Kentara',
  },
  {
    id: '1210061003',
    districtId: '1210061',
    name: 'Lae Parira',
  },
  {
    id: '1210061004',
    districtId: '1210061',
    name: 'Bulu Duri',
  },
  {
    id: '1210061005',
    districtId: '1210061',
    name: 'Sempung Polling',
  },
  {
    id: '1210061006',
    districtId: '1210061',
    name: 'Pandiangan',
  },
  {
    id: '1210061007',
    districtId: '1210061',
    name: 'Lumban Sihite',
  },
  {
    id: '1210061008',
    districtId: '1210061',
    name: 'Lumban Toruan',
  },
  {
    id: '1210061009',
    districtId: '1210061',
    name: 'Kaban Julu',
  },
  {
    id: '1210070001',
    districtId: '1210070',
    name: 'Sinampang',
  },
  {
    id: '1210070002',
    districtId: '1210070',
    name: 'Sihorbo',
  },
  {
    id: '1210070003',
    districtId: '1210070',
    name: 'Soban',
  },
  {
    id: '1210070004',
    districtId: '1210070',
    name: 'Adian Nangka',
  },
  {
    id: '1210070005',
    districtId: '1210070',
    name: 'Buntu Raja',
  },
  {
    id: '1210070006',
    districtId: '1210070',
    name: 'Gomit',
  },
  {
    id: '1210070007',
    districtId: '1210070',
    name: 'Jumantuang',
  },
  {
    id: '1210070008',
    districtId: '1210070',
    name: 'Jumasiulok',
  },
  {
    id: '1210070009',
    districtId: '1210070',
    name: 'Jumateguh',
  },
  {
    id: '1210070010',
    districtId: '1210070',
    name: 'Sosorlontung',
  },
  {
    id: '1210070011',
    districtId: '1210070',
    name: 'Huta Imbaru',
  },
  {
    id: '1210070012',
    districtId: '1210070',
    name: 'Maju',
  },
  {
    id: '1210070013',
    districtId: '1210070',
    name: 'Adian Gupa',
  },
  {
    id: '1210080001',
    districtId: '1210080',
    name: 'Tambahan',
  },
  {
    id: '1210080002',
    districtId: '1210080',
    name: 'Kuta Tengah',
  },
  {
    id: '1210080003',
    districtId: '1210080',
    name: 'Lae Nuaha',
  },
  {
    id: '1210080004',
    districtId: '1210080',
    name: 'Sungai Raya',
  },
  {
    id: '1210080005',
    districtId: '1210080',
    name: 'Gunung Meriah',
  },
  {
    id: '1210080006',
    districtId: '1210080',
    name: 'Sigambir Gambir',
  },
  {
    id: '1210080007',
    districtId: '1210080',
    name: 'Silumboyah',
  },
  {
    id: '1210080008',
    districtId: '1210080',
    name: 'Pangaribuan',
  },
  {
    id: '1210080009',
    districtId: '1210080',
    name: 'Tualang',
  },
  {
    id: '1210080010',
    districtId: '1210080',
    name: 'Bakal Julu',
  },
  {
    id: '1210080011',
    districtId: '1210080',
    name: 'Sipoltong',
  },
  {
    id: '1210080012',
    districtId: '1210080',
    name: 'P A N D A N',
  },
  {
    id: '1210090001',
    districtId: '1210090',
    name: 'Lae Itam',
  },
  {
    id: '1210090002',
    districtId: '1210090',
    name: 'Pardomuan',
  },
  {
    id: '1210090003',
    districtId: '1210090',
    name: 'Jambur Indonesia',
  },
  {
    id: '1210090004',
    districtId: '1210090',
    name: 'Simungun',
  },
  {
    id: '1210090005',
    districtId: '1210090',
    name: 'J A N J I',
  },
  {
    id: '1210090006',
    districtId: '1210090',
    name: 'Lae Markelang',
  },
  {
    id: '1210090007',
    districtId: '1210090',
    name: 'Lae Luhung',
  },
  {
    id: '1210090008',
    districtId: '1210090',
    name: 'Sopo Butar',
  },
  {
    id: '1210090009',
    districtId: '1210090',
    name: 'Lae Sering',
  },
  {
    id: '1210090010',
    districtId: '1210090',
    name: 'Lae Haporas',
  },
  {
    id: '1210100001',
    districtId: '1210100',
    name: 'Sumbul Tengah',
  },
  {
    id: '1210100002',
    districtId: '1210100',
    name: 'Ujung Teran',
  },
  {
    id: '1210100003',
    districtId: '1210100',
    name: 'Juma Gerat',
  },
  {
    id: '1210100004',
    districtId: '1210100',
    name: 'Sarintonu',
  },
  {
    id: '1210100005',
    districtId: '1210100',
    name: 'Palding',
  },
  {
    id: '1210100006',
    districtId: '1210100',
    name: 'Bertungen Julu',
  },
  {
    id: '1210100007',
    districtId: '1210100',
    name: 'Sukandebi',
  },
  {
    id: '1210100008',
    districtId: '1210100',
    name: 'Lau Molgap',
  },
  {
    id: '1210100009',
    districtId: '1210100',
    name: 'Lau Pakpak',
  },
  {
    id: '1210100011',
    districtId: '1210100',
    name: 'Lau Mil',
  },
  {
    id: '1210100012',
    districtId: '1210100',
    name: 'Lau Bagot',
  },
  {
    id: '1210100013',
    districtId: '1210100',
    name: 'Tigalingga',
  },
  {
    id: '1210100014',
    districtId: '1210100',
    name: 'Lau Sireme',
  },
  {
    id: '1210100019',
    districtId: '1210100',
    name: 'Palding Jaya',
  },
  {
    id: '1210101001',
    districtId: '1210101',
    name: 'Bukit Lau Kersik',
  },
  {
    id: '1210101002',
    districtId: '1210101',
    name: 'Gunung Sitember',
  },
  {
    id: '1210101003',
    districtId: '1210101',
    name: 'Batu Gungun',
  },
  {
    id: '1210101004',
    districtId: '1210101',
    name: 'Gundaling',
  },
  {
    id: '1210101005',
    districtId: '1210101',
    name: 'Rante Besi',
  },
  {
    id: '1210101006',
    districtId: '1210101',
    name: 'Kendit Liang',
  },
  {
    id: '1210101007',
    districtId: '1210101',
    name: 'Lau Lebah',
  },
  {
    id: '1210101008',
    districtId: '1210101',
    name: 'Tupak Raja',
  },
  {
    id: '1210110001',
    districtId: '1210110',
    name: 'Tanjung Saluksuk',
  },
  {
    id: '1210110002',
    districtId: '1210110',
    name: 'Simanduma',
  },
  {
    id: '1210110003',
    districtId: '1210110',
    name: 'Bandar Huta Usang',
  },
  {
    id: '1210110004',
    districtId: '1210110',
    name: 'Lingga Raja',
  },
  {
    id: '1210110005',
    districtId: '1210110',
    name: 'Onan Lama',
  },
  {
    id: '1210110006',
    districtId: '1210110',
    name: 'Bukit Tinggi',
  },
  {
    id: '1210110007',
    districtId: '1210110',
    name: 'Laksa',
  },
  {
    id: '1210110008',
    districtId: '1210110',
    name: 'Simartugan',
  },
  {
    id: '1210110009',
    districtId: '1210110',
    name: 'Perik Mbue',
  },
  {
    id: '1210110010',
    districtId: '1210110',
    name: 'Lingga Raja II',
  },
  {
    id: '1210110011',
    districtId: '1210110',
    name: 'Bukit Baru',
  },
  {
    id: '1210110012',
    districtId: '1210110',
    name: 'Mbinanga',
  },
  {
    id: '1210110013',
    districtId: '1210110',
    name: 'Kuta Usang',
  },
  {
    id: '1210120001',
    districtId: '1210120',
    name: 'Renun',
  },
  {
    id: '1210120002',
    districtId: '1210120',
    name: 'Pasir Tengah',
  },
  {
    id: '1210120003',
    districtId: '1210120',
    name: 'Pamah',
  },
  {
    id: '1210120004',
    districtId: '1210120',
    name: 'Kuta Buluh',
  },
  {
    id: '1210120005',
    districtId: '1210120',
    name: 'Tanah Pinem',
  },
  {
    id: '1210120006',
    districtId: '1210120',
    name: 'Kempawa',
  },
  {
    id: '1210120007',
    districtId: '1210120',
    name: 'Kuta Gamber',
  },
  {
    id: '1210120008',
    districtId: '1210120',
    name: 'Lau Perimbon',
  },
  {
    id: '1210120009',
    districtId: '1210120',
    name: 'Harapan',
  },
  {
    id: '1210120010',
    districtId: '1210120',
    name: 'Gunung Tua',
  },
  {
    id: '1210120011',
    districtId: '1210120',
    name: 'Suka Dame',
  },
  {
    id: '1210120012',
    districtId: '1210120',
    name: 'Lau Tawar',
  },
  {
    id: '1210120013',
    districtId: '1210120',
    name: 'Mangan Molih',
  },
  {
    id: '1210120014',
    districtId: '1210120',
    name: 'Lau Njuhar',
  },
  {
    id: '1210120015',
    districtId: '1210120',
    name: 'Liang Jering',
  },
  {
    id: '1210120016',
    districtId: '1210120',
    name: 'Alur Subur',
  },
  {
    id: '1210120017',
    districtId: '1210120',
    name: 'Balandua',
  },
  {
    id: '1210120018',
    districtId: '1210120',
    name: 'Pasir Mbelang',
  },
  {
    id: '1210120019',
    districtId: '1210120',
    name: 'Sinar Pagi',
  },
  {
    id: '1211010001',
    districtId: '1211010',
    name: 'Lau Solu',
  },
  {
    id: '1211010002',
    districtId: '1211010',
    name: 'Kuta Pengkih',
  },
  {
    id: '1211010003',
    districtId: '1211010',
    name: 'Rimo Bunga',
  },
  {
    id: '1211010004',
    districtId: '1211010',
    name: 'Lau Mulgap',
  },
  {
    id: '1211010005',
    districtId: '1211010',
    name: 'Tanjung Pamah',
  },
  {
    id: '1211010006',
    districtId: '1211010',
    name: 'Mardingding',
  },
  {
    id: '1211010007',
    districtId: '1211010',
    name: 'Lau Kasumpat',
  },
  {
    id: '1211010008',
    districtId: '1211010',
    name: 'Bandar Purba',
  },
  {
    id: '1211010009',
    districtId: '1211010',
    name: 'Lau Pengulu',
  },
  {
    id: '1211010010',
    districtId: '1211010',
    name: 'Lau Pakam',
  },
  {
    id: '1211010011',
    districtId: '1211010',
    name: 'Lau Garut',
  },
  {
    id: '1211010012',
    districtId: '1211010',
    name: 'Bukit Makmur',
  },
  {
    id: '1211020001',
    districtId: '1211020',
    name: 'Lau Peranggunan',
  },
  {
    id: '1211020002',
    districtId: '1211020',
    name: 'Durin Rugun',
  },
  {
    id: '1211020003',
    districtId: '1211020',
    name: 'Kinangkong',
  },
  {
    id: '1211020004',
    districtId: '1211020',
    name: 'Lau Peradep',
  },
  {
    id: '1211020005',
    districtId: '1211020',
    name: 'Laubaleng',
  },
  {
    id: '1211020006',
    districtId: '1211020',
    name: 'Tanjung Gunung',
  },
  {
    id: '1211020007',
    districtId: '1211020',
    name: 'Kutambelin',
  },
  {
    id: '1211020008',
    districtId: '1211020',
    name: 'Martelu',
  },
  {
    id: '1211020009',
    districtId: '1211020',
    name: 'Lingga Muda',
  },
  {
    id: '1211020010',
    districtId: '1211020',
    name: 'Mbal-Mbal Petarum',
  },
  {
    id: '1211020011',
    districtId: '1211020',
    name: 'Perbulan',
  },
  {
    id: '1211020012',
    districtId: '1211020',
    name: 'Buluh Pancur',
  },
  {
    id: '1211020013',
    districtId: '1211020',
    name: 'Rambah Tampu',
  },
  {
    id: '1211020014',
    districtId: '1211020',
    name: 'Batu Rongkam',
  },
  {
    id: '1211020015',
    districtId: '1211020',
    name: 'Pintu Angin',
  },
  {
    id: '1211030001',
    districtId: '1211030',
    name: 'Lau Kapur',
  },
  {
    id: '1211030002',
    districtId: '1211030',
    name: 'Kem Kem',
  },
  {
    id: '1211030003',
    districtId: '1211030',
    name: 'Gunung',
  },
  {
    id: '1211030004',
    districtId: '1211030',
    name: 'Simpang Pergendangen',
  },
  {
    id: '1211030005',
    districtId: '1211030',
    name: 'Pergendangen',
  },
  {
    id: '1211030006',
    districtId: '1211030',
    name: 'Tigabinanga',
  },
  {
    id: '1211030007',
    districtId: '1211030',
    name: 'Kuta Galoh',
  },
  {
    id: '1211030008',
    districtId: '1211030',
    name: 'Kuta Raya',
  },
  {
    id: '1211030009',
    districtId: '1211030',
    name: 'Bunga Baru',
  },
  {
    id: '1211030010',
    districtId: '1211030',
    name: 'Pertumbuken',
  },
  {
    id: '1211030011',
    districtId: '1211030',
    name: 'Kuala',
  },
  {
    id: '1211030012',
    districtId: '1211030',
    name: 'Kuta Buara',
  },
  {
    id: '1211030013',
    districtId: '1211030',
    name: 'Simolap',
  },
  {
    id: '1211030014',
    districtId: '1211030',
    name: 'Kuta Bangun',
  },
  {
    id: '1211030015',
    districtId: '1211030',
    name: 'Sukajulu',
  },
  {
    id: '1211030016',
    districtId: '1211030',
    name: 'Kutambaru Punti',
  },
  {
    id: '1211030017',
    districtId: '1211030',
    name: 'Kuta Gerat',
  },
  {
    id: '1211030018',
    districtId: '1211030',
    name: 'Limang',
  },
  {
    id: '1211030019',
    districtId: '1211030',
    name: 'Perbesi',
  },
  {
    id: '1211030020',
    districtId: '1211030',
    name: 'Batumamak',
  },
  {
    id: '1211040001',
    districtId: '1211040',
    name: 'Namosuro',
  },
  {
    id: '1211040002',
    districtId: '1211040',
    name: 'Jandi',
  },
  {
    id: '1211040003',
    districtId: '1211040',
    name: 'Naga',
  },
  {
    id: '1211040004',
    districtId: '1211040',
    name: 'Ketawaren',
  },
  {
    id: '1211040005',
    districtId: '1211040',
    name: 'Lau Kidupen',
  },
  {
    id: '1211040006',
    districtId: '1211040',
    name: 'Lau Lingga',
  },
  {
    id: '1211040007',
    districtId: '1211040',
    name: 'Pernantin',
  },
  {
    id: '1211040008',
    districtId: '1211040',
    name: 'Bekilang',
  },
  {
    id: '1211040009',
    districtId: '1211040',
    name: 'Buluh Pancur',
  },
  {
    id: '1211040010',
    districtId: '1211040',
    name: 'Juhar Tarigan',
  },
  {
    id: '1211040011',
    districtId: '1211040',
    name: 'Juhar Perangin-Angin',
  },
  {
    id: '1211040012',
    districtId: '1211040',
    name: 'Kidupen',
  },
  {
    id: '1211040013',
    districtId: '1211040',
    name: 'Pasar Baru',
  },
  {
    id: '1211040014',
    districtId: '1211040',
    name: 'Mbetung',
  },
  {
    id: '1211040015',
    districtId: '1211040',
    name: 'Gunung Juhar',
  },
  {
    id: '1211040016',
    districtId: '1211040',
    name: 'Juhar Ginting',
  },
  {
    id: '1211040017',
    districtId: '1211040',
    name: 'Sigenderang',
  },
  {
    id: '1211040018',
    districtId: '1211040',
    name: 'Batumamak',
  },
  {
    id: '1211040019',
    districtId: '1211040',
    name: 'Nageri',
  },
  {
    id: '1211040020',
    districtId: '1211040',
    name: 'Sugihen',
  },
  {
    id: '1211040021',
    districtId: '1211040',
    name: 'Sukababo',
  },
  {
    id: '1211040022',
    districtId: '1211040',
    name: 'Kutagugung',
  },
  {
    id: '1211040023',
    districtId: '1211040',
    name: 'Keriahen',
  },
  {
    id: '1211040024',
    districtId: '1211040',
    name: 'Kutambelin',
  },
  {
    id: '1211040025',
    districtId: '1211040',
    name: 'Juhar Ginting Sadanioga',
  },
  {
    id: '1211050001',
    districtId: '1211050',
    name: 'Sarimunte',
  },
  {
    id: '1211050002',
    districtId: '1211050',
    name: 'Kutambaru',
  },
  {
    id: '1211050003',
    districtId: '1211050',
    name: 'Gunung Saribu',
  },
  {
    id: '1211050004',
    districtId: '1211050',
    name: 'Kabantua',
  },
  {
    id: '1211050005',
    districtId: '1211050',
    name: 'Gurubenua',
  },
  {
    id: '1211050006',
    districtId: '1211050',
    name: 'Barung Kersap',
  },
  {
    id: '1211050007',
    districtId: '1211050',
    name: 'Biak Nampe',
  },
  {
    id: '1211050008',
    districtId: '1211050',
    name: 'Tanjung Beringin',
  },
  {
    id: '1211050009',
    districtId: '1211050',
    name: 'Pertumbungen',
  },
  {
    id: '1211050010',
    districtId: '1211050',
    name: 'Parimbalang',
  },
  {
    id: '1211050011',
    districtId: '1211050',
    name: 'Munte',
  },
  {
    id: '1211050012',
    districtId: '1211050',
    name: 'Gunung Manumpak',
  },
  {
    id: '1211050013',
    districtId: '1211050',
    name: 'Selakkar',
  },
  {
    id: '1211050014',
    districtId: '1211050',
    name: 'Sarinembah',
  },
  {
    id: '1211050015',
    districtId: '1211050',
    name: 'Singgamanik',
  },
  {
    id: '1211050016',
    districtId: '1211050',
    name: 'Nageri',
  },
  {
    id: '1211050017',
    districtId: '1211050',
    name: 'Kutasuah',
  },
  {
    id: '1211050018',
    districtId: '1211050',
    name: 'Kineppen',
  },
  {
    id: '1211050019',
    districtId: '1211050',
    name: 'Buluh Naman',
  },
  {
    id: '1211050020',
    districtId: '1211050',
    name: 'Bandar Meriah',
  },
  {
    id: '1211050021',
    districtId: '1211050',
    name: 'Sukarame',
  },
  {
    id: '1211050022',
    districtId: '1211050',
    name: 'Kutagerat',
  },
  {
    id: '1211060001',
    districtId: '1211060',
    name: 'Pola Tebu',
  },
  {
    id: '1211060002',
    districtId: '1211060',
    name: 'Gunung Meriah',
  },
  {
    id: '1211060003',
    districtId: '1211060',
    name: 'Negeri Jahe',
  },
  {
    id: '1211060004',
    districtId: '1211060',
    name: 'Buah Raya',
  },
  {
    id: '1211060005',
    districtId: '1211060',
    name: 'Bintang Meriah',
  },
  {
    id: '1211060006',
    districtId: '1211060',
    name: 'Siabang Abang',
  },
  {
    id: '1211060007',
    districtId: '1211060',
    name: 'Jinabun',
  },
  {
    id: '1211060008',
    districtId: '1211060',
    name: 'Kuta Buluh',
  },
  {
    id: '1211060009',
    districtId: '1211060',
    name: 'Lau Buluh',
  },
  {
    id: '1211060010',
    districtId: '1211060',
    name: 'Kuta Male',
  },
  {
    id: '1211060011',
    districtId: '1211060',
    name: 'Ujung Deleng',
  },
  {
    id: '1211060012',
    districtId: '1211060',
    name: 'Tanjung Merahe',
  },
  {
    id: '1211060013',
    districtId: '1211060',
    name: 'Liang Merdeka',
  },
  {
    id: '1211060014',
    districtId: '1211060',
    name: 'Rih Tengah',
  },
  {
    id: '1211060015',
    districtId: '1211060',
    name: 'Mburidi',
  },
  {
    id: '1211060016',
    districtId: '1211060',
    name: 'Kuta Buluh Gugung',
  },
  {
    id: '1211070002',
    districtId: '1211070',
    name: 'Batukarang',
  },
  {
    id: '1211070003',
    districtId: '1211070',
    name: 'Rimokayu',
  },
  {
    id: '1211070004',
    districtId: '1211070',
    name: 'Cimbang',
  },
  {
    id: '1211070005',
    districtId: '1211070',
    name: 'Ujung Payung',
  },
  {
    id: '1211070006',
    districtId: '1211070',
    name: 'Payung',
  },
  {
    id: '1211070007',
    districtId: '1211070',
    name: 'Suka Meriah',
  },
  {
    id: '1211070008',
    districtId: '1211070',
    name: 'Guru Kinayan',
  },
  {
    id: '1211070009',
    districtId: '1211070',
    name: 'Selandi',
  },
  {
    id: '1211071001',
    districtId: '1211071',
    name: 'Tanjung Pulo',
  },
  {
    id: '1211071002',
    districtId: '1211071',
    name: 'Tanjung Mbelang',
  },
  {
    id: '1211071003',
    districtId: '1211071',
    name: 'Nari Gunung Dua',
  },
  {
    id: '1211071004',
    districtId: '1211071',
    name: 'Jandi Meriah',
  },
  {
    id: '1211071005',
    districtId: '1211071',
    name: 'Suka Tendel',
  },
  {
    id: '1211071006',
    districtId: '1211071',
    name: 'Tanjung Merawa',
  },
  {
    id: '1211071007',
    districtId: '1211071',
    name: 'Tiganderket',
  },
  {
    id: '1211071008',
    districtId: '1211071',
    name: 'Perbaji',
  },
  {
    id: '1211071009',
    districtId: '1211071',
    name: 'Temburun',
  },
  {
    id: '1211071010',
    districtId: '1211071',
    name: 'Mardingding',
  },
  {
    id: '1211071011',
    districtId: '1211071',
    name: 'Kuta Mbaru',
  },
  {
    id: '1211071012',
    districtId: '1211071',
    name: 'Susuk',
  },
  {
    id: '1211071013',
    districtId: '1211071',
    name: 'Gunung Merlawan',
  },
  {
    id: '1211071014',
    districtId: '1211071',
    name: 'Nari Gunung Satu',
  },
  {
    id: '1211071015',
    districtId: '1211071',
    name: 'Kuta Galuh',
  },
  {
    id: '1211071016',
    districtId: '1211071',
    name: 'Penampen',
  },
  {
    id: '1211071017',
    districtId: '1211071',
    name: 'Kuta Kepar',
  },
  {
    id: '1211080001',
    districtId: '1211080',
    name: 'Beganding',
  },
  {
    id: '1211080002',
    districtId: '1211080',
    name: 'Serumbia',
  },
  {
    id: '1211080003',
    districtId: '1211080',
    name: 'Nang Belawan',
  },
  {
    id: '1211080004',
    districtId: '1211080',
    name: 'Lingga',
  },
  {
    id: '1211080005',
    districtId: '1211080',
    name: 'Lingga Julu',
  },
  {
    id: '1211080006',
    districtId: '1211080',
    name: 'Ndokum Siroga',
  },
  {
    id: '1211080007',
    districtId: '1211080',
    name: 'Surbakti',
  },
  {
    id: '1211080008',
    districtId: '1211080',
    name: 'Tiga Pancur',
  },
  {
    id: '1211080009',
    districtId: '1211080',
    name: 'Berastepu',
  },
  {
    id: '1211080010',
    districtId: '1211080',
    name: 'Pintu Besi',
  },
  {
    id: '1211080011',
    districtId: '1211080',
    name: 'Jeraya',
  },
  {
    id: '1211080012',
    districtId: '1211080',
    name: 'Perteguhen',
  },
  {
    id: '1211080013',
    districtId: '1211080',
    name: 'Kuta Tengah',
  },
  {
    id: '1211080014',
    districtId: '1211080',
    name: 'Torong',
  },
  {
    id: '1211080015',
    districtId: '1211080',
    name: 'Gajah',
  },
  {
    id: '1211080016',
    districtId: '1211080',
    name: 'Bulan Baru',
  },
  {
    id: '1211080021',
    districtId: '1211080',
    name: 'Gamber',
  },
  {
    id: '1211081001',
    districtId: '1211081',
    name: 'Kuta Gugung',
  },
  {
    id: '1211081002',
    districtId: '1211081',
    name: 'Sigarang Garang',
  },
  {
    id: '1211081003',
    districtId: '1211081',
    name: 'Bekerah',
  },
  {
    id: '1211081004',
    districtId: '1211081',
    name: 'Simacem',
  },
  {
    id: '1211081005',
    districtId: '1211081',
    name: 'Sukanalu',
  },
  {
    id: '1211081006',
    districtId: '1211081',
    name: 'Kuta Tonggal',
  },
  {
    id: '1211081007',
    districtId: '1211081',
    name: 'Suka Ndebi',
  },
  {
    id: '1211081008',
    districtId: '1211081',
    name: 'Naman',
  },
  {
    id: '1211081009',
    districtId: '1211081',
    name: 'Sukatepu',
  },
  {
    id: '1211081010',
    districtId: '1211081',
    name: 'Ndeskati',
  },
  {
    id: '1211081011',
    districtId: '1211081',
    name: 'Kuta Mbelin',
  },
  {
    id: '1211081012',
    districtId: '1211081',
    name: 'Gung Pinto',
  },
  {
    id: '1211081013',
    districtId: '1211081',
    name: 'Kebayaken',
  },
  {
    id: '1211081014',
    districtId: '1211081',
    name: 'Kuta Rayat',
  },
  {
    id: '1211082001',
    districtId: '1211082',
    name: 'Deram',
  },
  {
    id: '1211082002',
    districtId: '1211082',
    name: 'Ujung Teran',
  },
  {
    id: '1211082003',
    districtId: '1211082',
    name: 'Cinta Rayat',
  },
  {
    id: '1211082004',
    districtId: '1211082',
    name: 'Sada Perarih',
  },
  {
    id: '1211082005',
    districtId: '1211082',
    name: 'Semangat',
  },
  {
    id: '1211082006',
    districtId: '1211082',
    name: 'Merdeka',
  },
  {
    id: '1211082007',
    districtId: '1211082',
    name: 'Gongsol',
  },
  {
    id: '1211082008',
    districtId: '1211082',
    name: 'Jaranguda',
  },
  {
    id: '1211082009',
    districtId: '1211082',
    name: 'Semangat Gunung',
  },
  {
    id: '1211090001',
    districtId: '1211090',
    name: 'Lausimomo',
  },
  {
    id: '1211090002',
    districtId: '1211090',
    name: 'Kandibata',
  },
  {
    id: '1211090003',
    districtId: '1211090',
    name: 'Kacaribu',
  },
  {
    id: '1211090004',
    districtId: '1211090',
    name: 'Lau Cimba',
  },
  {
    id: '1211090005',
    districtId: '1211090',
    name: 'Padang Mas',
  },
  {
    id: '1211090006',
    districtId: '1211090',
    name: 'Gung Leto',
  },
  {
    id: '1211090007',
    districtId: '1211090',
    name: 'Gung Negeri',
  },
  {
    id: '1211090008',
    districtId: '1211090',
    name: 'Samura',
  },
  {
    id: '1211090009',
    districtId: '1211090',
    name: 'Ketaren',
  },
  {
    id: '1211090010',
    districtId: '1211090',
    name: 'Kampung Dalam',
  },
  {
    id: '1211090011',
    districtId: '1211090',
    name: 'Rumah Kabanjahe',
  },
  {
    id: '1211090012',
    districtId: '1211090',
    name: 'Kaban',
  },
  {
    id: '1211090013',
    districtId: '1211090',
    name: 'Sumber Mufakat',
  },
  {
    id: '1211100001',
    districtId: '1211100',
    name: 'Gurusinga',
  },
  {
    id: '1211100002',
    districtId: '1211100',
    name: 'R A Y A',
  },
  {
    id: '1211100003',
    districtId: '1211100',
    name: 'Rumah Berastagi',
  },
  {
    id: '1211100004',
    districtId: '1211100',
    name: 'Tambak Lau Mulgap II',
  },
  {
    id: '1211100005',
    districtId: '1211100',
    name: 'Gundaling II',
  },
  {
    id: '1211100006',
    districtId: '1211100',
    name: 'Gundaling I',
  },
  {
    id: '1211100007',
    districtId: '1211100',
    name: 'Tambak Lau Mulgap I',
  },
  {
    id: '1211100008',
    districtId: '1211100',
    name: 'Sempajaya',
  },
  {
    id: '1211100009',
    districtId: '1211100',
    name: 'D A U L U',
  },
  {
    id: '1211100010',
    districtId: '1211100',
    name: 'Lau Gumba',
  },
  {
    id: '1211110001',
    districtId: '1211110',
    name: 'Sukamaju',
  },
  {
    id: '1211110002',
    districtId: '1211110',
    name: 'Kuta Mbelin',
  },
  {
    id: '1211110003',
    districtId: '1211110',
    name: 'Singa',
  },
  {
    id: '1211110004',
    districtId: '1211110',
    name: 'Kubu Simbelang',
  },
  {
    id: '1211110005',
    districtId: '1211110',
    name: 'Kacinambun',
  },
  {
    id: '1211110006',
    districtId: '1211110',
    name: 'Lau Riman',
  },
  {
    id: '1211110007',
    districtId: '1211110',
    name: 'Manuk Mulia',
  },
  {
    id: '1211110008',
    districtId: '1211110',
    name: 'Kuta Kepar',
  },
  {
    id: '1211110009',
    districtId: '1211110',
    name: 'Bunuraya',
  },
  {
    id: '1211110010',
    districtId: '1211110',
    name: 'Mulawari',
  },
  {
    id: '1211110011',
    districtId: '1211110',
    name: 'Suka',
  },
  {
    id: '1211110012',
    districtId: '1211110',
    name: 'Sukadame',
  },
  {
    id: '1211110013',
    districtId: '1211110',
    name: 'Tigapanah',
  },
  {
    id: '1211110014',
    districtId: '1211110',
    name: 'Kuta Bale',
  },
  {
    id: '1211110015',
    districtId: '1211110',
    name: 'Seberaya',
  },
  {
    id: '1211110016',
    districtId: '1211110',
    name: 'Lepar Samura',
  },
  {
    id: '1211110017',
    districtId: '1211110',
    name: 'Ajimbelang',
  },
  {
    id: '1211110018',
    districtId: '1211110',
    name: 'Kutajulu',
  },
  {
    id: '1211110021',
    districtId: '1211110',
    name: 'Bertah',
  },
  {
    id: '1211110023',
    districtId: '1211110',
    name: 'Ajibuhara',
  },
  {
    id: '1211110024',
    districtId: '1211110',
    name: 'Ajijahe',
  },
  {
    id: '1211110025',
    districtId: '1211110',
    name: 'Ajijulu',
  },
  {
    id: '1211110026',
    districtId: '1211110',
    name: 'Salit',
  },
  {
    id: '1211110027',
    districtId: '1211110',
    name: 'Suka Mbayak',
  },
  {
    id: '1211110028',
    districtId: '1211110',
    name: 'Suka Sipilihen',
  },
  {
    id: '1211110029',
    districtId: '1211110',
    name: 'Lambar',
  },
  {
    id: '1211111001',
    districtId: '1211111',
    name: 'Kubucolia',
  },
  {
    id: '1211111002',
    districtId: '1211111',
    name: 'Sampun',
  },
  {
    id: '1211111003',
    districtId: '1211111',
    name: 'Bukit',
  },
  {
    id: '1211111004',
    districtId: '1211111',
    name: 'Sugihen',
  },
  {
    id: '1211111005',
    districtId: '1211111',
    name: 'Melas',
  },
  {
    id: '1211111006',
    districtId: '1211111',
    name: 'Ujung Sampun',
  },
  {
    id: '1211111007',
    districtId: '1211111',
    name: 'Dolat Rayat',
  },
  {
    id: '1211120001',
    districtId: '1211120',
    name: 'Kodon-Kodon',
  },
  {
    id: '1211120002',
    districtId: '1211120',
    name: 'Sibolangit',
  },
  {
    id: '1211120003',
    districtId: '1211120',
    name: 'Tongging',
  },
  {
    id: '1211120004',
    districtId: '1211120',
    name: 'Pengambaten',
  },
  {
    id: '1211120005',
    districtId: '1211120',
    name: 'Nagalingga',
  },
  {
    id: '1211120006',
    districtId: '1211120',
    name: 'Pancur Batu',
  },
  {
    id: '1211120007',
    districtId: '1211120',
    name: 'Pertibi Tembe',
  },
  {
    id: '1211120008',
    districtId: '1211120',
    name: 'Pertibi Lama',
  },
  {
    id: '1211120009',
    districtId: '1211120',
    name: 'Merek',
  },
  {
    id: '1211120010',
    districtId: '1211120',
    name: 'Situnggaling',
  },
  {
    id: '1211120011',
    districtId: '1211120',
    name: 'Negeri Tongging',
  },
  {
    id: '1211120012',
    districtId: '1211120',
    name: 'Garingging',
  },
  {
    id: '1211120013',
    districtId: '1211120',
    name: 'Bandar Tongging',
  },
  {
    id: '1211120014',
    districtId: '1211120',
    name: 'Mulia Rakyat',
  },
  {
    id: '1211120015',
    districtId: '1211120',
    name: 'D O K A N',
  },
  {
    id: '1211120016',
    districtId: '1211120',
    name: 'Regaji',
  },
  {
    id: '1211120017',
    districtId: '1211120',
    name: 'Sukamandi',
  },
  {
    id: '1211120018',
    districtId: '1211120',
    name: 'Nagara',
  },
  {
    id: '1211120019',
    districtId: '1211120',
    name: 'Ajinembah',
  },
  {
    id: '1211130001',
    districtId: '1211130',
    name: 'Rumamis',
  },
  {
    id: '1211130002',
    districtId: '1211130',
    name: 'Semangat',
  },
  {
    id: '1211130003',
    districtId: '1211130',
    name: 'Sinaman',
  },
  {
    id: '1211130004',
    districtId: '1211130',
    name: 'Talimbaru',
  },
  {
    id: '1211130005',
    districtId: '1211130',
    name: 'Pertumbuken',
  },
  {
    id: '1211130006',
    districtId: '1211130',
    name: 'Bulan Julu',
  },
  {
    id: '1211130007',
    districtId: '1211130',
    name: 'Bulan Jahe',
  },
  {
    id: '1211130008',
    districtId: '1211130',
    name: 'Sukanalu',
  },
  {
    id: '1211130009',
    districtId: '1211130',
    name: 'Sukajulu',
  },
  {
    id: '1211130010',
    districtId: '1211130',
    name: 'Barusjahe',
  },
  {
    id: '1211130011',
    districtId: '1211130',
    name: 'Serdang',
  },
  {
    id: '1211130012',
    districtId: '1211130',
    name: 'Penampen',
  },
  {
    id: '1211130013',
    districtId: '1211130',
    name: 'Sarimanis',
  },
  {
    id: '1211130014',
    districtId: '1211130',
    name: 'Tengkidik',
  },
  {
    id: '1211130015',
    districtId: '1211130',
    name: 'Paribun',
  },
  {
    id: '1211130016',
    districtId: '1211130',
    name: 'Persadanta',
  },
  {
    id: '1211130017',
    districtId: '1211130',
    name: 'Sikap',
  },
  {
    id: '1211130018',
    districtId: '1211130',
    name: 'Tanjung Barus',
  },
  {
    id: '1211130019',
    districtId: '1211130',
    name: 'Barusjulu',
  },
  {
    id: '1212010001',
    districtId: '1212010',
    name: 'Kuta Bayu',
  },
  {
    id: '1212010002',
    districtId: '1212010',
    name: 'Gunung Sinembah',
  },
  {
    id: '1212010003',
    districtId: '1212010',
    name: 'Gunung Paribuan',
  },
  {
    id: '1212010004',
    districtId: '1212010',
    name: 'Simempar',
  },
  {
    id: '1212010005',
    districtId: '1212010',
    name: 'Gunung Seribu',
  },
  {
    id: '1212010006',
    districtId: '1212010',
    name: 'Kuta Tengah',
  },
  {
    id: '1212010007',
    districtId: '1212010',
    name: 'Pekan Gunung Meriah',
  },
  {
    id: '1212010008',
    districtId: '1212010',
    name: 'Gunung Meriah',
  },
  {
    id: '1212010009',
    districtId: '1212010',
    name: 'Bintang Meriah',
  },
  {
    id: '1212010010',
    districtId: '1212010',
    name: 'Ujung Meriah',
  },
  {
    id: '1212010011',
    districtId: '1212010',
    name: 'Marjanji Pematang',
  },
  {
    id: '1212010012',
    districtId: '1212010',
    name: 'Marjanji Tongah',
  },
  {
    id: '1212020001',
    districtId: '1212020',
    name: 'Liang Pematang',
  },
  {
    id: '1212020002',
    districtId: '1212020',
    name: 'Liang Muda',
  },
  {
    id: '1212020003',
    districtId: '1212020',
    name: 'Tanjung Raja',
  },
  {
    id: '1212020004',
    districtId: '1212020',
    name: 'Gunung Manumpak B',
  },
  {
    id: '1212020005',
    districtId: '1212020',
    name: 'Sipinggan',
  },
  {
    id: '1212020006',
    districtId: '1212020',
    name: 'Tanjung Muda',
  },
  {
    id: '1212020007',
    districtId: '1212020',
    name: 'Bah Bah Buntu',
  },
  {
    id: '1212020008',
    districtId: '1212020',
    name: 'Kuta Mbelin',
  },
  {
    id: '1212020009',
    districtId: '1212020',
    name: 'Tanjung Bampu',
  },
  {
    id: '1212020010',
    districtId: '1212020',
    name: 'Tanjung Timur',
  },
  {
    id: '1212020011',
    districtId: '1212020',
    name: 'Durin Tinggung',
  },
  {
    id: '1212020012',
    districtId: '1212020',
    name: 'Rumah Rih',
  },
  {
    id: '1212020013',
    districtId: '1212020',
    name: 'Sibunga Bunga Hilir',
  },
  {
    id: '1212020014',
    districtId: '1212020',
    name: 'Gunung Manumpak A',
  },
  {
    id: '1212020015',
    districtId: '1212020',
    name: 'Durian Empat Mbelang',
  },
  {
    id: '1212020016',
    districtId: '1212020',
    name: 'Tiga Juhar',
  },
  {
    id: '1212020017',
    districtId: '1212020',
    name: 'Ranggitgit',
  },
  {
    id: '1212020018',
    districtId: '1212020',
    name: 'Rumah Lengo',
  },
  {
    id: '1212020019',
    districtId: '1212020',
    name: 'Rumah Sumbul',
  },
  {
    id: '1212020020',
    districtId: '1212020',
    name: 'Tanah Gara Hulu',
  },
  {
    id: '1212030001',
    districtId: '1212030',
    name: 'Bandar Baru',
  },
  {
    id: '1212030002',
    districtId: '1212030',
    name: 'Sikeben',
  },
  {
    id: '1212030003',
    districtId: '1212030',
    name: 'Martelu',
  },
  {
    id: '1212030004',
    districtId: '1212030',
    name: 'Bukum',
  },
  {
    id: '1212030005',
    districtId: '1212030',
    name: 'Negri Gugung',
  },
  {
    id: '1212030006',
    districtId: '1212030',
    name: 'Cinta Rakyat',
  },
  {
    id: '1212030007',
    districtId: '1212030',
    name: 'Ketangkuhen',
  },
  {
    id: '1212030008',
    districtId: '1212030',
    name: 'Suka Maju',
  },
  {
    id: '1212030009',
    districtId: '1212030',
    name: 'Buluh Awar',
  },
  {
    id: '1212030010',
    districtId: '1212030',
    name: 'Batu Layang',
  },
  {
    id: '1212030011',
    districtId: '1212030',
    name: 'Rumah Pil-Pil',
  },
  {
    id: '1212030012',
    districtId: '1212030',
    name: 'Suka Makmur',
  },
  {
    id: '1212030013',
    districtId: '1212030',
    name: 'Durin Serugun',
  },
  {
    id: '1212030014',
    districtId: '1212030',
    name: 'Ujung Deleng',
  },
  {
    id: '1212030015',
    districtId: '1212030',
    name: 'Tanjung Beringin',
  },
  {
    id: '1212030016',
    districtId: '1212030',
    name: 'Tambunen',
  },
  {
    id: '1212030017',
    districtId: '1212030',
    name: 'Puang Aja',
  },
  {
    id: '1212030018',
    districtId: '1212030',
    name: 'Betimus Baru',
  },
  {
    id: '1212030019',
    districtId: '1212030',
    name: 'Rumah Sumbul',
  },
  {
    id: '1212030020',
    districtId: '1212030',
    name: 'Rumah Kinangkung Suka Piring',
  },
  {
    id: '1212030021',
    districtId: '1212030',
    name: 'Sala Bulan',
  },
  {
    id: '1212030022',
    districtId: '1212030',
    name: 'Bengkurung',
  },
  {
    id: '1212030023',
    districtId: '1212030',
    name: 'Kuala',
  },
  {
    id: '1212030024',
    districtId: '1212030',
    name: 'Batu Mbelin',
  },
  {
    id: '1212030025',
    districtId: '1212030',
    name: 'Sibolangit',
  },
  {
    id: '1212030026',
    districtId: '1212030',
    name: 'Sembahe',
  },
  {
    id: '1212030027',
    districtId: '1212030',
    name: 'Buah Nabar',
  },
  {
    id: '1212030028',
    districtId: '1212030',
    name: 'Bingkawan',
  },
  {
    id: '1212030029',
    districtId: '1212030',
    name: 'Sayum Sabah',
  },
  {
    id: '1212030030',
    districtId: '1212030',
    name: 'Rambung Baru',
  },
  {
    id: '1212040001',
    districtId: '1212040',
    name: 'Suka Makmur',
  },
  {
    id: '1212040002',
    districtId: '1212040',
    name: 'Perpanden',
  },
  {
    id: '1212040003',
    districtId: '1212040',
    name: 'Namo Mirik',
  },
  {
    id: '1212040004',
    districtId: '1212040',
    name: 'Suka Dame',
  },
  {
    id: '1212040005',
    districtId: '1212040',
    name: 'Kwala Lau Bicik',
  },
  {
    id: '1212040006',
    districtId: '1212040',
    name: 'Pasar X',
  },
  {
    id: '1212040007',
    districtId: '1212040',
    name: 'Sampe Cita',
  },
  {
    id: '1212040008',
    districtId: '1212040',
    name: 'Kutalimbaru',
  },
  {
    id: '1212040009',
    districtId: '1212040',
    name: 'Suka Rende',
  },
  {
    id: '1212040010',
    districtId: '1212040',
    name: 'Lau Bakeri',
  },
  {
    id: '1212040011',
    districtId: '1212040',
    name: 'Silebo Lebo',
  },
  {
    id: '1212040012',
    districtId: '1212040',
    name: 'Sawit Rejo',
  },
  {
    id: '1212040013',
    districtId: '1212040',
    name: 'Sei Mencirim',
  },
  {
    id: '1212040014',
    districtId: '1212040',
    name: 'Namo Rube Julu',
  },
  {
    id: '1212050001',
    districtId: '1212050',
    name: 'Bintang Meriah',
  },
  {
    id: '1212050002',
    districtId: '1212050',
    name: 'Sugau',
  },
  {
    id: '1212050003',
    districtId: '1212050',
    name: 'Tiang Layar',
  },
  {
    id: '1212050004',
    districtId: '1212050',
    name: 'Salam Tani',
  },
  {
    id: '1212050005',
    districtId: '1212050',
    name: 'Namo Riam',
  },
  {
    id: '1212050006',
    districtId: '1212050',
    name: 'Durin Simbelang A',
  },
  {
    id: '1212050007',
    districtId: '1212050',
    name: 'Durin Tunggal',
  },
  {
    id: '1212050008',
    districtId: '1212050',
    name: 'Pertampilen',
  },
  {
    id: '1212050009',
    districtId: '1212050',
    name: 'Hulu',
  },
  {
    id: '1212050010',
    districtId: '1212050',
    name: 'Namo Simpur',
  },
  {
    id: '1212050011',
    districtId: '1212050',
    name: 'Namo Bintang',
  },
  {
    id: '1212050012',
    districtId: '1212050',
    name: 'Simalingkar A',
  },
  {
    id: '1212050013',
    districtId: '1212050',
    name: 'Perumnas Simalingkar',
  },
  {
    id: '1212050014',
    districtId: '1212050',
    name: 'B A R U',
  },
  {
    id: '1212050015',
    districtId: '1212050',
    name: 'L A M A',
  },
  {
    id: '1212050016',
    districtId: '1212050',
    name: 'Kampung Tengah',
  },
  {
    id: '1212050017',
    districtId: '1212050',
    name: 'Namorih',
  },
  {
    id: '1212050018',
    districtId: '1212050',
    name: 'Durian Jangak',
  },
  {
    id: '1212050019',
    districtId: '1212050',
    name: 'Tuntungan II',
  },
  {
    id: '1212050020',
    districtId: '1212050',
    name: 'Tuntungan I',
  },
  {
    id: '1212050021',
    districtId: '1212050',
    name: 'Gunung Tinggi',
  },
  {
    id: '1212050022',
    districtId: '1212050',
    name: 'Sei Gelugur',
  },
  {
    id: '1212050023',
    districtId: '1212050',
    name: 'Suka Raya',
  },
  {
    id: '1212050024',
    districtId: '1212050',
    name: 'Tanjung Anom',
  },
  {
    id: '1212050025',
    districtId: '1212050',
    name: 'Sembahe Baru',
  },
  {
    id: '1212060001',
    districtId: '1212060',
    name: 'Rimo Mungkur',
  },
  {
    id: '1212060002',
    districtId: '1212060',
    name: 'Namo Batang',
  },
  {
    id: '1212060003',
    districtId: '1212060',
    name: 'Bekukul',
  },
  {
    id: '1212060004',
    districtId: '1212060',
    name: 'Namo Pinang',
  },
  {
    id: '1212060005',
    districtId: '1212060',
    name: 'Tanjung Selamat',
  },
  {
    id: '1212060006',
    districtId: '1212060',
    name: 'Namo Pakam',
  },
  {
    id: '1212060007',
    districtId: '1212060',
    name: 'Suka Mulia Hulu',
  },
  {
    id: '1212060008',
    districtId: '1212060',
    name: 'Uruk Gedang',
  },
  {
    id: '1212060009',
    districtId: '1212060',
    name: 'Suka Mulia Hilir',
  },
  {
    id: '1212060010',
    districtId: '1212060',
    name: 'Silue Lue',
  },
  {
    id: '1212060011',
    districtId: '1212060',
    name: 'Lubang Ido',
  },
  {
    id: '1212060012',
    districtId: '1212060',
    name: 'Rumah Mbacang',
  },
  {
    id: '1212060013',
    districtId: '1212060',
    name: 'Rumah Keben',
  },
  {
    id: '1212060014',
    districtId: '1212060',
    name: 'Tangkahan',
  },
  {
    id: '1212060015',
    districtId: '1212060',
    name: 'Cinta Rakyat',
  },
  {
    id: '1212060016',
    districtId: '1212060',
    name: 'Gunung Berita',
  },
  {
    id: '1212060017',
    districtId: '1212060',
    name: 'Namo Rambe',
  },
  {
    id: '1212060018',
    districtId: '1212060',
    name: 'Namo Landur',
  },
  {
    id: '1212060019',
    districtId: '1212060',
    name: 'Namo Mbaru',
  },
  {
    id: '1212060020',
    districtId: '1212060',
    name: 'Salang Tungir',
  },
  {
    id: '1212060021',
    districtId: '1212060',
    name: 'Gunung Kelawas',
  },
  {
    id: '1212060022',
    districtId: '1212060',
    name: 'Batu Rejo',
  },
  {
    id: '1212060023',
    districtId: '1212060',
    name: 'Batu Mbelin',
  },
  {
    id: '1212060024',
    districtId: '1212060',
    name: 'Kuta Tengah',
  },
  {
    id: '1212060025',
    districtId: '1212060',
    name: 'Jati Kesuma',
  },
  {
    id: '1212060026',
    districtId: '1212060',
    name: 'Jaba',
  },
  {
    id: '1212060027',
    districtId: '1212060',
    name: 'Timbang Lawan',
  },
  {
    id: '1212060028',
    districtId: '1212060',
    name: 'Batu Gemuk',
  },
  {
    id: '1212060029',
    districtId: '1212060',
    name: 'Lau Mulgap',
  },
  {
    id: '1212060030',
    districtId: '1212060',
    name: 'Kuala Simeme',
  },
  {
    id: '1212060031',
    districtId: '1212060',
    name: 'Kuta Tualah',
  },
  {
    id: '1212060032',
    districtId: '1212060',
    name: 'Namo Mbelin',
  },
  {
    id: '1212060033',
    districtId: '1212060',
    name: 'Sudi Rejo',
  },
  {
    id: '1212060034',
    districtId: '1212060',
    name: 'Batu Penjemuran',
  },
  {
    id: '1212060035',
    districtId: '1212060',
    name: 'Ujung Labuhen',
  },
  {
    id: '1212060036',
    districtId: '1212060',
    name: 'Deli Tua',
  },
  {
    id: '1212070001',
    districtId: '1212070',
    name: 'Mardinding Julu',
  },
  {
    id: '1212070002',
    districtId: '1212070',
    name: 'Penen',
  },
  {
    id: '1212070003',
    districtId: '1212070',
    name: 'Per Ria Ria',
  },
  {
    id: '1212070004',
    districtId: '1212070',
    name: 'Sari Laba Jahe',
  },
  {
    id: '1212070005',
    districtId: '1212070',
    name: 'Biru Biru',
  },
  {
    id: '1212070006',
    districtId: '1212070',
    name: 'Kuala Dekah',
  },
  {
    id: '1212070007',
    districtId: '1212070',
    name: 'Rumah Gerat',
  },
  {
    id: '1212070008',
    districtId: '1212070',
    name: 'Tanjung Sena',
  },
  {
    id: '1212070009',
    districtId: '1212070',
    name: 'Kuta Mulyo',
  },
  {
    id: '1212070010',
    districtId: '1212070',
    name: 'Mbaruai',
  },
  {
    id: '1212070011',
    districtId: '1212070',
    name: 'Namo Tualang',
  },
  {
    id: '1212070012',
    districtId: '1212070',
    name: 'Kampung Selamat',
  },
  {
    id: '1212070013',
    districtId: '1212070',
    name: 'Sidodadi',
  },
  {
    id: '1212070014',
    districtId: '1212070',
    name: 'Namo Suro Baru',
  },
  {
    id: '1212070015',
    districtId: '1212070',
    name: 'Aji Baho',
  },
  {
    id: '1212070016',
    districtId: '1212070',
    name: 'Candi Rejo',
  },
  {
    id: '1212070017',
    districtId: '1212070',
    name: 'Sidomulyo',
  },
  {
    id: '1212080001',
    districtId: '1212080',
    name: 'Rambai',
  },
  {
    id: '1212080002',
    districtId: '1212080',
    name: 'Kuta Jurung',
  },
  {
    id: '1212080003',
    districtId: '1212080',
    name: 'Penungkiren',
  },
  {
    id: '1212080004',
    districtId: '1212080',
    name: 'Lau Rakit',
  },
  {
    id: '1212080005',
    districtId: '1212080',
    name: 'Tala Peta',
  },
  {
    id: '1212080006',
    districtId: '1212080',
    name: 'Siguci',
  },
  {
    id: '1212080007',
    districtId: '1212080',
    name: 'Gunung Rintis',
  },
  {
    id: '1212080008',
    districtId: '1212080',
    name: 'Lau Rempah',
  },
  {
    id: '1212080009',
    districtId: '1212080',
    name: 'Juma Tombak',
  },
  {
    id: '1212080010',
    districtId: '1212080',
    name: 'Negara/Beringin',
  },
  {
    id: '1212080011',
    districtId: '1212080',
    name: 'Talun Kenas',
  },
  {
    id: '1212080012',
    districtId: '1212080',
    name: 'Sumbul',
  },
  {
    id: '1212080013',
    districtId: '1212080',
    name: 'Limau Mungkur',
  },
  {
    id: '1212080014',
    districtId: '1212080',
    name: 'Tadukan Raga',
  },
  {
    id: '1212080015',
    districtId: '1212080',
    name: 'Lau Barus Baru',
  },
  {
    id: '1212090010',
    districtId: '1212090',
    name: 'Mabar',
  },
  {
    id: '1212090011',
    districtId: '1212090',
    name: 'Sibaganding',
  },
  {
    id: '1212090012',
    districtId: '1212090',
    name: 'Bah Balua',
  },
  {
    id: '1212090013',
    districtId: '1212090',
    name: 'Rumah Deleng',
  },
  {
    id: '1212090014',
    districtId: '1212090',
    name: 'Bandar Gugung',
  },
  {
    id: '1212090015',
    districtId: '1212090',
    name: 'Bandar Meriah',
  },
  {
    id: '1212090016',
    districtId: '1212090',
    name: 'Perguruan',
  },
  {
    id: '1212090017',
    districtId: '1212090',
    name: 'Bangun Purba Tengah',
  },
  {
    id: '1212090018',
    districtId: '1212090',
    name: 'Damak Maliho',
  },
  {
    id: '1212090019',
    districtId: '1212090',
    name: 'Suka Luwe',
  },
  {
    id: '1212090020',
    districtId: '1212090',
    name: 'Urung Ganjang',
  },
  {
    id: '1212090021',
    districtId: '1212090',
    name: 'Bandar Kwala',
  },
  {
    id: '1212090022',
    districtId: '1212090',
    name: 'Marombun Barat',
  },
  {
    id: '1212090023',
    districtId: '1212090',
    name: 'Marombun Ujung Jawi',
  },
  {
    id: '1212090024',
    districtId: '1212090',
    name: 'Bah Perak',
  },
  {
    id: '1212090025',
    districtId: '1212090',
    name: 'Bangun Purba',
  },
  {
    id: '1212090026',
    districtId: '1212090',
    name: 'Greahan',
  },
  {
    id: '1212090027',
    districtId: '1212090',
    name: 'Cimahe',
  },
  {
    id: '1212090028',
    districtId: '1212090',
    name: 'Batu Gingging',
  },
  {
    id: '1212090029',
    districtId: '1212090',
    name: 'Tanjung Purba',
  },
  {
    id: '1212090030',
    districtId: '1212090',
    name: 'Sialang',
  },
  {
    id: '1212090031',
    districtId: '1212090',
    name: 'Bagerpang',
  },
  {
    id: '1212090032',
    districtId: '1212090',
    name: 'Batu Rata',
  },
  {
    id: '1212090033',
    districtId: '1212090',
    name: 'Ujung Rambe',
  },
  {
    id: '1212190001',
    districtId: '1212190',
    name: 'Kampung Paku',
  },
  {
    id: '1212190007',
    districtId: '1212190',
    name: 'Bandar Kwala',
  },
  {
    id: '1212190008',
    districtId: '1212190',
    name: 'Baru Titi Besi',
  },
  {
    id: '1212190012',
    districtId: '1212190',
    name: 'Pulau Tagor Baru',
  },
  {
    id: '1212190013',
    districtId: '1212190',
    name: 'Galang Barat',
  },
  {
    id: '1212190014',
    districtId: '1212190',
    name: 'Kotangan',
  },
  {
    id: '1212190015',
    districtId: '1212190',
    name: 'Sungei Putih',
  },
  {
    id: '1212190016',
    districtId: '1212190',
    name: 'Paya Kuda',
  },
  {
    id: '1212190017',
    districtId: '1212190',
    name: 'Kampung Kelapa Satu',
  },
  {
    id: '1212190018',
    districtId: '1212190',
    name: 'Pisang Pala',
  },
  {
    id: '1212190019',
    districtId: '1212190',
    name: 'Petumbukan',
  },
  {
    id: '1212190020',
    districtId: '1212190',
    name: 'Tanjung Gusti',
  },
  {
    id: '1212190021',
    districtId: '1212190',
    name: 'Sungai Karang',
  },
  {
    id: '1212190022',
    districtId: '1212190',
    name: 'Kampung Galang Suka',
  },
  {
    id: '1212190023',
    districtId: '1212190',
    name: 'Galang Kota',
  },
  {
    id: '1212190024',
    districtId: '1212190',
    name: 'Timbang Deli',
  },
  {
    id: '1212190025',
    districtId: '1212190',
    name: 'Jaharum A',
  },
  {
    id: '1212190026',
    districtId: '1212190',
    name: 'Tanah Merah',
  },
  {
    id: '1212190027',
    districtId: '1212190',
    name: 'Pertangguhan',
  },
  {
    id: '1212190028',
    districtId: '1212190',
    name: 'Tanjung Siporkis',
  },
  {
    id: '1212190029',
    districtId: '1212190',
    name: 'Batu Lokong',
  },
  {
    id: '1212190030',
    districtId: '1212190',
    name: 'Naga Rejo',
  },
  {
    id: '1212190031',
    districtId: '1212190',
    name: 'Paya Itik',
  },
  {
    id: '1212190032',
    districtId: '1212190',
    name: 'Paya Sampir',
  },
  {
    id: '1212190033',
    districtId: '1212190',
    name: 'Kampung Johar Baru',
  },
  {
    id: '1212190034',
    districtId: '1212190',
    name: 'Kotasan',
  },
  {
    id: '1212190035',
    districtId: '1212190',
    name: 'Jaharum B',
  },
  {
    id: '1212190036',
    districtId: '1212190',
    name: 'Tanah Abang',
  },
  {
    id: '1212190037',
    districtId: '1212190',
    name: 'Kramat Gajah',
  },
  {
    id: '1212200001',
    districtId: '1212200',
    name: 'Medan Sinembah',
  },
  {
    id: '1212200002',
    districtId: '1212200',
    name: 'Bandar Labuhan',
  },
  {
    id: '1212200003',
    districtId: '1212200',
    name: 'Bangun Rejo',
  },
  {
    id: '1212200004',
    districtId: '1212200',
    name: 'Aek Pancur',
  },
  {
    id: '1212200005',
    districtId: '1212200',
    name: 'Naga Timbul',
  },
  {
    id: '1212200006',
    districtId: '1212200',
    name: 'Lengau Serpang',
  },
  {
    id: '1212200007',
    districtId: '1212200',
    name: 'Sei Merah',
  },
  {
    id: '1212200008',
    districtId: '1212200',
    name: 'Dagang Kerawan',
  },
  {
    id: '1212200009',
    districtId: '1212200',
    name: 'Tanjung Morawa Pekan',
  },
  {
    id: '1212200010',
    districtId: '1212200',
    name: 'Tanjung Morawa A',
  },
  {
    id: '1212200011',
    districtId: '1212200',
    name: 'Limau Manis',
  },
  {
    id: '1212200012',
    districtId: '1212200',
    name: 'Ujung Serdang',
  },
  {
    id: '1212200013',
    districtId: '1212200',
    name: 'Bangun Sari',
  },
  {
    id: '1212200014',
    districtId: '1212200',
    name: 'Bangun Sari Baru',
  },
  {
    id: '1212200015',
    districtId: '1212200',
    name: 'Buntu Bedimbar',
  },
  {
    id: '1212200016',
    districtId: '1212200',
    name: 'Telaga Sari',
  },
  {
    id: '1212200017',
    districtId: '1212200',
    name: 'Dagang Kelambir',
  },
  {
    id: '1212200018',
    districtId: '1212200',
    name: 'Tanjung Morawa B',
  },
  {
    id: '1212200019',
    districtId: '1212200',
    name: 'Tanjung Baru',
  },
  {
    id: '1212200020',
    districtId: '1212200',
    name: 'Punden Rejo',
  },
  {
    id: '1212200021',
    districtId: '1212200',
    name: 'Tanjung Mulia',
  },
  {
    id: '1212200022',
    districtId: '1212200',
    name: 'Perdamaian',
  },
  {
    id: '1212200023',
    districtId: '1212200',
    name: 'Wono Sari',
  },
  {
    id: '1212200024',
    districtId: '1212200',
    name: 'Dalu 10 A',
  },
  {
    id: '1212200025',
    districtId: '1212200',
    name: 'Dalu 10 B',
  },
  {
    id: '1212200026',
    districtId: '1212200',
    name: 'Penara Kebun',
  },
  {
    id: '1212210001',
    districtId: '1212210',
    name: 'Patumbak Satu',
  },
  {
    id: '1212210002',
    districtId: '1212210',
    name: 'Lantasan Baru',
  },
  {
    id: '1212210003',
    districtId: '1212210',
    name: 'Lantasan Lama',
  },
  {
    id: '1212210004',
    districtId: '1212210',
    name: 'Patumbak Dua',
  },
  {
    id: '1212210005',
    districtId: '1212210',
    name: 'Sigara Gara',
  },
  {
    id: '1212210006',
    districtId: '1212210',
    name: 'Marindal Satu',
  },
  {
    id: '1212210007',
    districtId: '1212210',
    name: 'Patumbak Kampung',
  },
  {
    id: '1212210008',
    districtId: '1212210',
    name: 'Marindal Dua',
  },
  {
    id: '1212220001',
    districtId: '1212220',
    name: 'Deli Tua Barat',
  },
  {
    id: '1212220002',
    districtId: '1212220',
    name: 'Deli Tua Timur',
  },
  {
    id: '1212220003',
    districtId: '1212220',
    name: 'Deli Tua',
  },
  {
    id: '1212220004',
    districtId: '1212220',
    name: 'Mekar Sari',
  },
  {
    id: '1212220005',
    districtId: '1212220',
    name: 'Kedai Durian',
  },
  {
    id: '1212220006',
    districtId: '1212220',
    name: 'Suka Makmur',
  },
  {
    id: '1212230001',
    districtId: '1212230',
    name: 'Telaga Sari',
  },
  {
    id: '1212230002',
    districtId: '1212230',
    name: 'Sei Mencirim',
  },
  {
    id: '1212230003',
    districtId: '1212230',
    name: 'Suka Maju',
  },
  {
    id: '1212230004',
    districtId: '1212230',
    name: 'Sei Beras Sekata',
  },
  {
    id: '1212230005',
    districtId: '1212230',
    name: 'Tanjung Selamat',
  },
  {
    id: '1212230006',
    districtId: '1212230',
    name: 'Sunggal Kanan',
  },
  {
    id: '1212230007',
    districtId: '1212230',
    name: 'Medan Krio',
  },
  {
    id: '1212230008',
    districtId: '1212230',
    name: 'Paya Geli',
  },
  {
    id: '1212230009',
    districtId: '1212230',
    name: 'Puji Mulyo',
  },
  {
    id: '1212230010',
    districtId: '1212230',
    name: 'Sei Semayang',
  },
  {
    id: '1212230011',
    districtId: '1212230',
    name: 'Sumber Melati Diski',
  },
  {
    id: '1212230012',
    districtId: '1212230',
    name: 'Serba Jadi',
  },
  {
    id: '1212230013',
    districtId: '1212230',
    name: 'Mulyorejo',
  },
  {
    id: '1212230014',
    districtId: '1212230',
    name: 'Kampung Lalang',
  },
  {
    id: '1212230015',
    districtId: '1212230',
    name: 'Purwodadi',
  },
  {
    id: '1212230016',
    districtId: '1212230',
    name: 'Tanjung Gusta',
  },
  {
    id: '1212230017',
    districtId: '1212230',
    name: 'Helvetia',
  },
  {
    id: '1212240001',
    districtId: '1212240',
    name: 'Tandam Hulu Dua',
  },
  {
    id: '1212240002',
    districtId: '1212240',
    name: 'Kampung Tandam Hulu Satu',
  },
  {
    id: '1212240003',
    districtId: '1212240',
    name: 'Paya Bakung',
  },
  {
    id: '1212240004',
    districtId: '1212240',
    name: 'Klambir Lima Kampung',
  },
  {
    id: '1212240005',
    districtId: '1212240',
    name: 'Klambir Lima Kebon',
  },
  {
    id: '1212240006',
    districtId: '1212240',
    name: 'Klumpang Kebon',
  },
  {
    id: '1212240007',
    districtId: '1212240',
    name: 'Klumpang Kampung',
  },
  {
    id: '1212240008',
    districtId: '1212240',
    name: 'Sialang Muda',
  },
  {
    id: '1212240009',
    districtId: '1212240',
    name: 'Bulu Cina',
  },
  {
    id: '1212240010',
    districtId: '1212240',
    name: 'Tandam Hilir Satu',
  },
  {
    id: '1212240011',
    districtId: '1212240',
    name: 'Tandam Hilir Dua',
  },
  {
    id: '1212240012',
    districtId: '1212240',
    name: 'Kota Datar',
  },
  {
    id: '1212240013',
    districtId: '1212240',
    name: 'Kota Rantang',
  },
  {
    id: '1212240014',
    districtId: '1212240',
    name: 'Kampung Lama',
  },
  {
    id: '1212240015',
    districtId: '1212240',
    name: 'Klambir',
  },
  {
    id: '1212240016',
    districtId: '1212240',
    name: 'Kampung Selemak',
  },
  {
    id: '1212240017',
    districtId: '1212240',
    name: 'Hamparan Perak',
  },
  {
    id: '1212240018',
    districtId: '1212240',
    name: 'Sungai Baharu',
  },
  {
    id: '1212240019',
    districtId: '1212240',
    name: 'Paluh Manan',
  },
  {
    id: '1212240020',
    districtId: '1212240',
    name: 'Paluh Kurau',
  },
  {
    id: '1212250001',
    districtId: '1212250',
    name: 'Helvetia',
  },
  {
    id: '1212250002',
    districtId: '1212250',
    name: 'Manunggal',
  },
  {
    id: '1212250003',
    districtId: '1212250',
    name: 'Pematang Johar',
  },
  {
    id: '1212250004',
    districtId: '1212250',
    name: 'Telaga Tujuh',
  },
  {
    id: '1212250005',
    districtId: '1212250',
    name: 'Karang Gading',
  },
  {
    id: '1212260001',
    districtId: '1212260',
    name: 'Amplas',
  },
  {
    id: '1212260002',
    districtId: '1212260',
    name: 'Kenangan',
  },
  {
    id: '1212260003',
    districtId: '1212260',
    name: 'Tembung',
  },
  {
    id: '1212260004',
    districtId: '1212260',
    name: 'Sumber Rejo Timur',
  },
  {
    id: '1212260005',
    districtId: '1212260',
    name: 'Sei Rotan',
  },
  {
    id: '1212260006',
    districtId: '1212260',
    name: 'Bandar Klippa',
  },
  {
    id: '1212260007',
    districtId: '1212260',
    name: 'Bandar Khalipah',
  },
  {
    id: '1212260008',
    districtId: '1212260',
    name: 'Medan Estate',
  },
  {
    id: '1212260009',
    districtId: '1212260',
    name: 'Laut Dendang',
  },
  {
    id: '1212260010',
    districtId: '1212260',
    name: 'Sampali',
  },
  {
    id: '1212260011',
    districtId: '1212260',
    name: 'Bandar Setia',
  },
  {
    id: '1212260012',
    districtId: '1212260',
    name: 'Kolam',
  },
  {
    id: '1212260013',
    districtId: '1212260',
    name: 'Saentis',
  },
  {
    id: '1212260014',
    districtId: '1212260',
    name: 'Cinta Rakyat',
  },
  {
    id: '1212260015',
    districtId: '1212260',
    name: 'Cinta Damai',
  },
  {
    id: '1212260016',
    districtId: '1212260',
    name: 'Pematang Lalang',
  },
  {
    id: '1212260017',
    districtId: '1212260',
    name: 'Percut',
  },
  {
    id: '1212260018',
    districtId: '1212260',
    name: 'Tanjung Rejo',
  },
  {
    id: '1212260019',
    districtId: '1212260',
    name: 'Tanjung Selamat',
  },
  {
    id: '1212260020',
    districtId: '1212260',
    name: 'Kenangan Baru',
  },
  {
    id: '1212270001',
    districtId: '1212270',
    name: 'Sena',
  },
  {
    id: '1212270002',
    districtId: '1212270',
    name: 'Tumpatan Nibung',
  },
  {
    id: '1212270003',
    districtId: '1212270',
    name: 'Baru',
  },
  {
    id: '1212270004',
    districtId: '1212270',
    name: 'Tanjung Sari',
  },
  {
    id: '1212270005',
    districtId: '1212270',
    name: 'Bakaran Batu',
  },
  {
    id: '1212270006',
    districtId: '1212270',
    name: 'Bintang Meriah',
  },
  {
    id: '1212270007',
    districtId: '1212270',
    name: 'Batang Kuis Pekan',
  },
  {
    id: '1212270008',
    districtId: '1212270',
    name: 'Paya Gambar',
  },
  {
    id: '1212270009',
    districtId: '1212270',
    name: 'Sidodadi',
  },
  {
    id: '1212270010',
    districtId: '1212270',
    name: 'Sugiharjo',
  },
  {
    id: '1212270011',
    districtId: '1212270',
    name: 'Mesjid',
  },
  {
    id: '1212280001',
    districtId: '1212280',
    name: 'Sei Tuan',
  },
  {
    id: '1212280002',
    districtId: '1212280',
    name: 'Tengah',
  },
  {
    id: '1212280003',
    districtId: '1212280',
    name: 'Kelambir',
  },
  {
    id: '1212280004',
    districtId: '1212280',
    name: 'Durian',
  },
  {
    id: '1212280005',
    districtId: '1212280',
    name: 'Kubah Sentang',
  },
  {
    id: '1212280006',
    districtId: '1212280',
    name: 'Perkbunan Ramunia',
  },
  {
    id: '1212280007',
    districtId: '1212280',
    name: 'Ramunia Dua',
  },
  {
    id: '1212280008',
    districtId: '1212280',
    name: 'Ramunia Satu',
  },
  {
    id: '1212280009',
    districtId: '1212280',
    name: 'Denai Sarang Burung',
  },
  {
    id: '1212280010',
    districtId: '1212280',
    name: 'Denai Lama',
  },
  {
    id: '1212280011',
    districtId: '1212280',
    name: 'Binjai Bakung',
  },
  {
    id: '1212280012',
    districtId: '1212280',
    name: 'Denai Kuala',
  },
  {
    id: '1212280013',
    districtId: '1212280',
    name: 'Paluh Sibaji',
  },
  {
    id: '1212280014',
    districtId: '1212280',
    name: 'Pantai Labu Baru',
  },
  {
    id: '1212280015',
    districtId: '1212280',
    name: 'Pantai Labu Pekan',
  },
  {
    id: '1212280016',
    districtId: '1212280',
    name: 'Rugemuk',
  },
  {
    id: '1212280017',
    districtId: '1212280',
    name: 'Pematang Biara',
  },
  {
    id: '1212280018',
    districtId: '1212280',
    name: 'Rantau Panjang',
  },
  {
    id: '1212280019',
    districtId: '1212280',
    name: 'Bagan Serdang',
  },
  {
    id: '1212290001',
    districtId: '1212290',
    name: 'Tumpatan',
  },
  {
    id: '1212290002',
    districtId: '1212290',
    name: 'Emplasmen Kuala Namu',
  },
  {
    id: '1212290003',
    districtId: '1212290',
    name: 'Sidodadi Ramunia',
  },
  {
    id: '1212290004',
    districtId: '1212290',
    name: 'Pasar Lima Kebun Kelapa',
  },
  {
    id: '1212290005',
    districtId: '1212290',
    name: 'Aras Kabu',
  },
  {
    id: '1212290006',
    districtId: '1212290',
    name: 'Serdang',
  },
  {
    id: '1212290007',
    districtId: '1212290',
    name: 'Sidourip',
  },
  {
    id: '1212290008',
    districtId: '1212290',
    name: 'Pasar Enam Kuala Namu',
  },
  {
    id: '1212290009',
    districtId: '1212290',
    name: 'Karang Anyar',
  },
  {
    id: '1212290010',
    districtId: '1212290',
    name: 'Beringin',
  },
  {
    id: '1212290011',
    districtId: '1212290',
    name: 'Sidoarjo Dua Ramunia',
  },
  {
    id: '1212300001',
    districtId: '1212300',
    name: 'Paluh Kemiri',
  },
  {
    id: '1212300002',
    districtId: '1212300',
    name: 'Petapahan',
  },
  {
    id: '1212300003',
    districtId: '1212300',
    name: 'Tanjung Garbus Satu',
  },
  {
    id: '1212300004',
    districtId: '1212300',
    name: 'Pagar Merbau Tiga',
  },
  {
    id: '1212300005',
    districtId: '1212300',
    name: 'Cemara',
  },
  {
    id: '1212300006',
    districtId: '1212300',
    name: 'Pasar Melintang',
  },
  {
    id: '1212300007',
    districtId: '1212300',
    name: 'Pagar Jati',
  },
  {
    id: '1212300008',
    districtId: '1212300',
    name: 'Syahmad',
  },
  {
    id: '1212300009',
    districtId: '1212300',
    name: 'Lubuk Pakam Tiga',
  },
  {
    id: '1212300010',
    districtId: '1212300',
    name: 'Lubuk Pakam I/II',
  },
  {
    id: '1212300011',
    districtId: '1212300',
    name: 'Lubuk Pakam Pekan',
  },
  {
    id: '1212300012',
    districtId: '1212300',
    name: 'Bakaran Batu',
  },
  {
    id: '1212300013',
    districtId: '1212300',
    name: 'Sekip',
  },
  {
    id: '1212310001',
    districtId: '1212310',
    name: 'Bandar Dolok',
  },
  {
    id: '1212310002',
    districtId: '1212310',
    name: 'Tanjung Garbus II',
  },
  {
    id: '1212310003',
    districtId: '1212310',
    name: 'Perbarakan',
  },
  {
    id: '1212310004',
    districtId: '1212310',
    name: 'Tanjung Garbus Kampung',
  },
  {
    id: '1212310005',
    districtId: '1212310',
    name: 'Tanjung Mulia',
  },
  {
    id: '1212310006',
    districtId: '1212310',
    name: 'Purwodadi',
  },
  {
    id: '1212310007',
    districtId: '1212310',
    name: 'Sukamulia',
  },
  {
    id: '1212310008',
    districtId: '1212310',
    name: 'Sidodadi Batu Delapan',
  },
  {
    id: '1212310009',
    districtId: '1212310',
    name: 'Jati Rejo',
  },
  {
    id: '1212310010',
    districtId: '1212310',
    name: 'Sidoarjo Satu Jatibaru',
  },
  {
    id: '1212310011',
    districtId: '1212310',
    name: 'Sidoarjo Satu Pasar Miring',
  },
  {
    id: '1212310012',
    districtId: '1212310',
    name: 'Pagar Merbau I',
  },
  {
    id: '1212310013',
    districtId: '1212310',
    name: 'Pagar Merbau II',
  },
  {
    id: '1212310014',
    districtId: '1212310',
    name: 'Sumberejo',
  },
  {
    id: '1212310015',
    districtId: '1212310',
    name: 'Sukamandi Hulu',
  },
  {
    id: '1212310016',
    districtId: '1212310',
    name: 'Sukamandi Hilir',
  },
  {
    id: '1213010001',
    districtId: '1213010',
    name: 'Batu Jong Jong',
  },
  {
    id: '1213010002',
    districtId: '1213010',
    name: 'Lau Damak',
  },
  {
    id: '1213010003',
    districtId: '1213010',
    name: 'Timbang Lawan',
  },
  {
    id: '1213010004',
    districtId: '1213010',
    name: 'Sampe Raya',
  },
  {
    id: '1213010005',
    districtId: '1213010',
    name: 'Bukit Lawang',
  },
  {
    id: '1213010006',
    districtId: '1213010',
    name: 'Perkebunan Bungara',
  },
  {
    id: '1213010007',
    districtId: '1213010',
    name: 'Pekan Bahorok',
  },
  {
    id: '1213010008',
    districtId: '1213010',
    name: 'Empus',
  },
  {
    id: '1213010009',
    districtId: '1213010',
    name: 'Perkebunan Turangi',
  },
  {
    id: '1213010010',
    districtId: '1213010',
    name: 'Simpang Pulau Rambung',
  },
  {
    id: '1213010011',
    districtId: '1213010',
    name: 'Sematar',
  },
  {
    id: '1213010012',
    districtId: '1213010',
    name: 'Perkebunan Pulau Rambung',
  },
  {
    id: '1213010013',
    districtId: '1213010',
    name: 'Suka Rakyat',
  },
  {
    id: '1213010014',
    districtId: '1213010',
    name: 'Tanjung Lenggang',
  },
  {
    id: '1213010017',
    districtId: '1213010',
    name: 'Perkebunan Sei Musam',
  },
  {
    id: '1213010018',
    districtId: '1213010',
    name: 'Sei Musam Kendit',
  },
  {
    id: '1213010020',
    districtId: '1213010',
    name: 'Timbang Jaya',
  },
  {
    id: '1213010021',
    districtId: '1213010',
    name: 'Musam Pembangunan',
  },
  {
    id: '1213010023',
    districtId: '1213010',
    name: 'Ujung Bandar',
  },
  {
    id: '1213011001',
    districtId: '1213011',
    name: 'Sumber Jaya',
  },
  {
    id: '1213011002',
    districtId: '1213011',
    name: 'Pulau Semikat',
  },
  {
    id: '1213011003',
    districtId: '1213011',
    name: 'Sebertung',
  },
  {
    id: '1213011004',
    districtId: '1213011',
    name: 'Perkebunan Amal Tani',
  },
  {
    id: '1213011005',
    districtId: '1213011',
    name: 'Sidorejo',
  },
  {
    id: '1213011006',
    districtId: '1213011',
    name: 'Gunung Tinggi',
  },
  {
    id: '1213011007',
    districtId: '1213011',
    name: 'Serapit',
  },
  {
    id: '1213011008',
    districtId: '1213011',
    name: 'Sukapulung',
  },
  {
    id: '1213011009',
    districtId: '1213011',
    name: 'Tanjung Keriahan',
  },
  {
    id: '1213011010',
    districtId: '1213011',
    name: 'Aman Damai',
  },
  {
    id: '1213020005',
    districtId: '1213020',
    name: 'Ujung Bandar',
  },
  {
    id: '1213020006',
    districtId: '1213020',
    name: 'Parangguam',
  },
  {
    id: '1213020007',
    districtId: '1213020',
    name: 'Perkebunan Tambunan',
  },
  {
    id: '1213020008',
    districtId: '1213020',
    name: 'Lau Tepu',
  },
  {
    id: '1213020009',
    districtId: '1213020',
    name: 'Pama Tambunan',
  },
  {
    id: '1213020010',
    districtId: '1213020',
    name: 'Perkebunan Glugur Langkat',
  },
  {
    id: '1213020015',
    districtId: '1213020',
    name: 'Bandar Telu',
  },
  {
    id: '1213020016',
    districtId: '1213020',
    name: 'Turangi',
  },
  {
    id: '1213020017',
    districtId: '1213020',
    name: 'Ujung Teran',
  },
  {
    id: '1213020018',
    districtId: '1213020',
    name: 'Minta Kasih',
  },
  {
    id: '1213020019',
    districtId: '1213020',
    name: 'Tanjung Langkat',
  },
  {
    id: '1213020020',
    districtId: '1213020',
    name: 'Naman Jahe',
  },
  {
    id: '1213020021',
    districtId: '1213020',
    name: 'Perkebunan Tanjung Keliling',
  },
  {
    id: '1213020025',
    districtId: '1213020',
    name: 'Ponco Warno',
  },
  {
    id: '1213020026',
    districtId: '1213020',
    name: 'Adin Tengah',
  },
  {
    id: '1213020027',
    districtId: '1213020',
    name: 'Lau Lugur',
  },
  {
    id: '1213020028',
    districtId: '1213020',
    name: 'Pancur Ido',
  },
  {
    id: '1213021001',
    districtId: '1213021',
    name: 'Kaperas',
  },
  {
    id: '1213021002',
    districtId: '1213021',
    name: 'Sulkam',
  },
  {
    id: '1213021003',
    districtId: '1213021',
    name: 'Rampah',
  },
  {
    id: '1213021004',
    districtId: '1213021',
    name: 'Namo Teras',
  },
  {
    id: '1213021005',
    districtId: '1213021',
    name: 'Kutambaru',
  },
  {
    id: '1213021006',
    districtId: '1213021',
    name: 'Perkebunan Marike',
  },
  {
    id: '1213021007',
    districtId: '1213021',
    name: 'Kuta Gajah',
  },
  {
    id: '1213021008',
    districtId: '1213021',
    name: 'Perkebunan Namo Tongan',
  },
  {
    id: '1213030001',
    districtId: '1213030',
    name: 'Telagah',
  },
  {
    id: '1213030002',
    districtId: '1213030',
    name: 'Tanjung Gunung',
  },
  {
    id: '1213030003',
    districtId: '1213030',
    name: 'Pekan Sawah',
  },
  {
    id: '1213030004',
    districtId: '1213030',
    name: 'Belinteng',
  },
  {
    id: '1213030005',
    districtId: '1213030',
    name: 'Rumah Galuh',
  },
  {
    id: '1213030006',
    districtId: '1213030',
    name: 'Simpang Kuta Buluh',
  },
  {
    id: '1213030007',
    districtId: '1213030',
    name: 'Gunung Ambat',
  },
  {
    id: '1213030008',
    districtId: '1213030',
    name: 'Namu Ukur Selatan',
  },
  {
    id: '1213030009',
    districtId: '1213030',
    name: 'Namu Ukur Utara',
  },
  {
    id: '1213030010',
    districtId: '1213030',
    name: 'Durian Lingga',
  },
  {
    id: '1213030011',
    districtId: '1213030',
    name: 'Pasar VIII Namo Terasi',
  },
  {
    id: '1213030012',
    districtId: '1213030',
    name: 'Pasar IV Namo Terasi',
  },
  {
    id: '1213030013',
    districtId: '1213030',
    name: 'Pasar VI Kwala Mencirim',
  },
  {
    id: '1213030014',
    districtId: '1213030',
    name: 'Purwobinangun',
  },
  {
    id: '1213030015',
    districtId: '1213030',
    name: 'Emplasmen Kwala Mencirim',
  },
  {
    id: '1213030016',
    districtId: '1213030',
    name: 'Mekar Jaya',
  },
  {
    id: '1213040001',
    districtId: '1213040',
    name: 'Garunggang',
  },
  {
    id: '1213040002',
    districtId: '1213040',
    name: 'Parit Bindu',
  },
  {
    id: '1213040003',
    districtId: '1213040',
    name: 'Beruam',
  },
  {
    id: '1213040004',
    districtId: '1213040',
    name: 'Besadi',
  },
  {
    id: '1213040005',
    districtId: '1213040',
    name: 'Perkebunan Blangkahan',
  },
  {
    id: '1213040006',
    districtId: '1213040',
    name: 'Sei Penjara',
  },
  {
    id: '1213040007',
    districtId: '1213040',
    name: 'Raja Tengah',
  },
  {
    id: '1213040008',
    districtId: '1213040',
    name: 'Namo Mbelin',
  },
  {
    id: '1213040009',
    districtId: '1213040',
    name: 'Bekiung',
  },
  {
    id: '1213040010',
    districtId: '1213040',
    name: 'Balai Kasih',
  },
  {
    id: '1213040011',
    districtId: '1213040',
    name: 'Dalan Naman',
  },
  {
    id: '1213040012',
    districtId: '1213040',
    name: 'Pekan Kuala',
  },
  {
    id: '1213040013',
    districtId: '1213040',
    name: 'Perkebunan Bekiun',
  },
  {
    id: '1213040017',
    districtId: '1213040',
    name: 'Suka Damai',
  },
  {
    id: '1213040018',
    districtId: '1213040',
    name: 'Sido Makmur',
  },
  {
    id: '1213040019',
    districtId: '1213040',
    name: 'Bela Rakyat',
  },
  {
    id: '1213050001',
    districtId: '1213050',
    name: 'Nambiki',
  },
  {
    id: '1213050002',
    districtId: '1213050',
    name: 'Tanjung Merahe',
  },
  {
    id: '1213050003',
    districtId: '1213050',
    name: 'Padang Brahrang',
  },
  {
    id: '1213050004',
    districtId: '1213050',
    name: 'Lau Mulgap',
  },
  {
    id: '1213050005',
    districtId: '1213050',
    name: 'Kuta Parit',
  },
  {
    id: '1213050006',
    districtId: '1213050',
    name: 'Pekan Selesai',
  },
  {
    id: '1213050007',
    districtId: '1213050',
    name: 'Bekulap',
  },
  {
    id: '1213050008',
    districtId: '1213050',
    name: 'Perhiasan',
  },
  {
    id: '1213050009',
    districtId: '1213050',
    name: 'Selayang',
  },
  {
    id: '1213050010',
    districtId: '1213050',
    name: 'Sei Limbat',
  },
  {
    id: '1213050011',
    districtId: '1213050',
    name: 'Mancang',
  },
  {
    id: '1213050012',
    districtId: '1213050',
    name: 'Kuala Air Hitam',
  },
  {
    id: '1213050013',
    districtId: '1213050',
    name: 'Padang Cermin',
  },
  {
    id: '1213050014',
    districtId: '1213050',
    name: 'Selayang Baru',
  },
  {
    id: '1213060001',
    districtId: '1213060',
    name: 'Tanjung Jati',
  },
  {
    id: '1213060002',
    districtId: '1213060',
    name: 'Sidomulyo',
  },
  {
    id: '1213060003',
    districtId: '1213060',
    name: 'Sendang Rejo',
  },
  {
    id: '1213060004',
    districtId: '1213060',
    name: 'Sambirejo',
  },
  {
    id: '1213060005',
    districtId: '1213060',
    name: 'Kwala Begumit',
  },
  {
    id: '1213060006',
    districtId: '1213060',
    name: 'Perdamean',
  },
  {
    id: '1213060007',
    districtId: '1213060',
    name: 'Sukamakmur',
  },
  {
    id: '1213070001',
    districtId: '1213070',
    name: 'Banyumas',
  },
  {
    id: '1213070002',
    districtId: '1213070',
    name: 'Kwala Bingai',
  },
  {
    id: '1213070003',
    districtId: '1213070',
    name: 'Sidomulyo',
  },
  {
    id: '1213070004',
    districtId: '1213070',
    name: 'Pantai Gemi',
  },
  {
    id: '1213070005',
    districtId: '1213070',
    name: 'Perdamaian',
  },
  {
    id: '1213070006',
    districtId: '1213070',
    name: 'Stabat Baru',
  },
  {
    id: '1213070007',
    districtId: '1213070',
    name: 'Ara Condong',
  },
  {
    id: '1213070008',
    districtId: '1213070',
    name: 'Kwala Begumit',
  },
  {
    id: '1213070009',
    districtId: '1213070',
    name: 'Mangga',
  },
  {
    id: '1213070010',
    districtId: '1213070',
    name: 'Karangrejo',
  },
  {
    id: '1213070011',
    districtId: '1213070',
    name: 'Dendang',
  },
  {
    id: '1213070012',
    districtId: '1213070',
    name: 'Paya Mabar',
  },
  {
    id: '1213080001',
    districtId: '1213080',
    name: 'Besilam Bukit Lembasa',
  },
  {
    id: '1213080002',
    districtId: '1213080',
    name: 'Gergas',
  },
  {
    id: '1213080003',
    districtId: '1213080',
    name: 'Bingai',
  },
  {
    id: '1213080004',
    districtId: '1213080',
    name: 'Bukit Melintang',
  },
  {
    id: '1213080005',
    districtId: '1213080',
    name: 'Kebun Balok',
  },
  {
    id: '1213080006',
    districtId: '1213080',
    name: 'Sumber Mulyo',
  },
  {
    id: '1213080007',
    districtId: '1213080',
    name: 'Gohor Lama',
  },
  {
    id: '1213080008',
    districtId: '1213080',
    name: 'Stabat Lama',
  },
  {
    id: '1213080009',
    districtId: '1213080',
    name: 'Stabat Lama Barat',
  },
  {
    id: '1213080010',
    districtId: '1213080',
    name: 'Pertumbukan',
  },
  {
    id: '1213080011',
    districtId: '1213080',
    name: 'Paya Tusan',
  },
  {
    id: '1213080012',
    districtId: '1213080',
    name: 'Mekar Jaya',
  },
  {
    id: '1213080013',
    districtId: '1213080',
    name: 'Jentera Stabat',
  },
  {
    id: '1213080014',
    districtId: '1213080',
    name: 'Stungkit',
  },
  {
    id: '1213090001',
    districtId: '1213090',
    name: 'Sei Musam',
  },
  {
    id: '1213090002',
    districtId: '1213090',
    name: 'Namu Sialang',
  },
  {
    id: '1213090003',
    districtId: '1213090',
    name: 'Sei Serdang',
  },
  {
    id: '1213090004',
    districtId: '1213090',
    name: 'Sei Bamban',
  },
  {
    id: '1213090005',
    districtId: '1213090',
    name: 'Batang Serangan',
  },
  {
    id: '1213090006',
    districtId: '1213090',
    name: 'Kuala Musam',
  },
  {
    id: '1213090007',
    districtId: '1213090',
    name: 'Karya Jadi',
  },
  {
    id: '1213090008',
    districtId: '1213090',
    name: 'Paluh Pakeh Babusalam',
  },
  {
    id: '1213100001',
    districtId: '1213100',
    name: 'Sei Litur Tasik',
  },
  {
    id: '1213100002',
    districtId: '1213100',
    name: 'Sawit Seberang',
  },
  {
    id: '1213100003',
    districtId: '1213100',
    name: 'Alur Gadung',
  },
  {
    id: '1213100004',
    districtId: '1213100',
    name: 'Simpang 3 Sawit Seberang',
  },
  {
    id: '1213100005',
    districtId: '1213100',
    name: 'Sawit Hulu',
  },
  {
    id: '1213100006',
    districtId: '1213100',
    name: 'Mekar Sawit',
  },
  {
    id: '1213100007',
    districtId: '1213100',
    name: 'Alur Melati',
  },
  {
    id: '1213110001',
    districtId: '1213110',
    name: 'Sukaramai',
  },
  {
    id: '1213110002',
    districtId: '1213110',
    name: 'Tebing Tanjung Selamat',
  },
  {
    id: '1213110003',
    districtId: '1213110',
    name: 'Tanjung Putus',
  },
  {
    id: '1213110004',
    districtId: '1213110',
    name: 'Tanjung Selamat',
  },
  {
    id: '1213110005',
    districtId: '1213110',
    name: 'Besilam',
  },
  {
    id: '1213110006',
    districtId: '1213110',
    name: 'Padang Tualang',
  },
  {
    id: '1213110007',
    districtId: '1213110',
    name: 'Serapuh Abc',
  },
  {
    id: '1213110008',
    districtId: '1213110',
    name: 'Kwala Pesilam',
  },
  {
    id: '1213110009',
    districtId: '1213110',
    name: 'Buluh Telang',
  },
  {
    id: '1213110010',
    districtId: '1213110',
    name: 'Jati Sari',
  },
  {
    id: '1213110011',
    districtId: '1213110',
    name: 'Banjar Raya',
  },
  {
    id: '1213110012',
    districtId: '1213110',
    name: 'Bukit Sari',
  },
  {
    id: '1213120001',
    districtId: '1213120',
    name: 'Perkebunan Tanjung Beringin',
  },
  {
    id: '1213120002',
    districtId: '1213120',
    name: 'Sukajadi',
  },
  {
    id: '1213120003',
    districtId: '1213120',
    name: 'Baru Pasar 8',
  },
  {
    id: '1213120004',
    districtId: '1213120',
    name: 'Paya Rengas',
  },
  {
    id: '1213120005',
    districtId: '1213120',
    name: 'Hinai Kanan',
  },
  {
    id: '1213120006',
    districtId: '1213120',
    name: 'Sukadamai',
  },
  {
    id: '1213120007',
    districtId: '1213120',
    name: 'Kebun Lada',
  },
  {
    id: '1213120008',
    districtId: '1213120',
    name: 'Tanjung Mulia',
  },
  {
    id: '1213120009',
    districtId: '1213120',
    name: 'Muka Paya',
  },
  {
    id: '1213120010',
    districtId: '1213120',
    name: 'Cempa',
  },
  {
    id: '1213120011',
    districtId: '1213120',
    name: 'Batu Malenggang',
  },
  {
    id: '1213120012',
    districtId: '1213120',
    name: 'Tamaran',
  },
  {
    id: '1213120013',
    districtId: '1213120',
    name: 'Suka Damai Timur',
  },
  {
    id: '1213130001',
    districtId: '1213130',
    name: 'Kepala Sungai',
  },
  {
    id: '1213130002',
    districtId: '1213130',
    name: 'Perkotaan',
  },
  {
    id: '1213130003',
    districtId: '1213130',
    name: 'Teluk',
  },
  {
    id: '1213130004',
    districtId: '1213130',
    name: 'Cinta Raja',
  },
  {
    id: '1213130005',
    districtId: '1213130',
    name: 'Telaga Jernih',
  },
  {
    id: '1213130006',
    districtId: '1213130',
    name: 'Karang Gading',
  },
  {
    id: '1213130007',
    districtId: '1213130',
    name: 'Kwala Besar',
  },
  {
    id: '1213130008',
    districtId: '1213130',
    name: 'Selotong',
  },
  {
    id: '1213130009',
    districtId: '1213130',
    name: 'Secanggang',
  },
  {
    id: '1213130010',
    districtId: '1213130',
    name: 'Tanjung Ibus',
  },
  {
    id: '1213130011',
    districtId: '1213130',
    name: 'Hinai Kiri',
  },
  {
    id: '1213130012',
    districtId: '1213130',
    name: 'Kebun Kelapa',
  },
  {
    id: '1213130013',
    districtId: '1213130',
    name: 'Sungai Ular',
  },
  {
    id: '1213130014',
    districtId: '1213130',
    name: 'Jaring Halus',
  },
  {
    id: '1213130015',
    districtId: '1213130',
    name: 'Karang Anyar',
  },
  {
    id: '1213130016',
    districtId: '1213130',
    name: 'Pantai Gading',
  },
  {
    id: '1213130017',
    districtId: '1213130',
    name: 'Suka Mulia',
  },
  {
    id: '1213140001',
    districtId: '1213140',
    name: 'Serapuh Asli',
  },
  {
    id: '1213140002',
    districtId: '1213140',
    name: 'Pematang Tengah',
  },
  {
    id: '1213140003',
    districtId: '1213140',
    name: 'Paya Perupuk',
  },
  {
    id: '1213140004',
    districtId: '1213140',
    name: 'Pekan Tanjung Pura',
  },
  {
    id: '1213140005',
    districtId: '1213140',
    name: 'Lalang',
  },
  {
    id: '1213140006',
    districtId: '1213140',
    name: 'Pantai Cermin',
  },
  {
    id: '1213140007',
    districtId: '1213140',
    name: 'Pekubuan',
  },
  {
    id: '1213140008',
    districtId: '1213140',
    name: 'Teluk Bakung',
  },
  {
    id: '1213140009',
    districtId: '1213140',
    name: 'Pematang Serai',
  },
  {
    id: '1213140010',
    districtId: '1213140',
    name: 'Baja Kuning',
  },
  {
    id: '1213140011',
    districtId: '1213140',
    name: 'Pulau Banyak',
  },
  {
    id: '1213140012',
    districtId: '1213140',
    name: 'Pematang Cengal',
  },
  {
    id: '1213140013',
    districtId: '1213140',
    name: 'Kwala Serapuh',
  },
  {
    id: '1213140014',
    districtId: '1213140',
    name: 'Kwala Langkat',
  },
  {
    id: '1213140015',
    districtId: '1213140',
    name: 'Bubun',
  },
  {
    id: '1213140016',
    districtId: '1213140',
    name: 'Tapak Kuda',
  },
  {
    id: '1213140017',
    districtId: '1213140',
    name: 'Sukamaju',
  },
  {
    id: '1213140018',
    districtId: '1213140',
    name: 'Karya Maju',
  },
  {
    id: '1213140019',
    districtId: '1213140',
    name: 'Pematang Cengal Barat',
  },
  {
    id: '1213150001',
    districtId: '1213150',
    name: 'Paya Bengkuang',
  },
  {
    id: '1213150002',
    districtId: '1213150',
    name: 'Air Hitam',
  },
  {
    id: '1213150003',
    districtId: '1213150',
    name: 'Padang Langkat',
  },
  {
    id: '1213150004',
    districtId: '1213150',
    name: 'Paluh Manis',
  },
  {
    id: '1213150005',
    districtId: '1213150',
    name: 'Pekan Gebang',
  },
  {
    id: '1213150006',
    districtId: '1213150',
    name: 'Dogang',
  },
  {
    id: '1213150007',
    districtId: '1213150',
    name: 'Sangga Lima Perkebunan Serapuh',
  },
  {
    id: '1213150008',
    districtId: '1213150',
    name: 'Pasar Rawa',
  },
  {
    id: '1213150009',
    districtId: '1213150',
    name: 'Kwala Gebang',
  },
  {
    id: '1213150010',
    districtId: '1213150',
    name: 'Bukit Mengkirai',
  },
  {
    id: '1213150011',
    districtId: '1213150',
    name: 'Pasiran',
  },
  {
    id: '1213160001',
    districtId: '1213160',
    name: 'Pelawi Utara',
  },
  {
    id: '1213160002',
    districtId: '1213160',
    name: 'Securai Utara',
  },
  {
    id: '1213160003',
    districtId: '1213160',
    name: 'Securai Selatan',
  },
  {
    id: '1213160004',
    districtId: '1213160',
    name: 'Pelawi Selatan',
  },
  {
    id: '1213160005',
    districtId: '1213160',
    name: 'Brandan Timur Baru',
  },
  {
    id: '1213160006',
    districtId: '1213160',
    name: 'Brandan Barat',
  },
  {
    id: '1213160007',
    districtId: '1213160',
    name: 'Brandan Timur',
  },
  {
    id: '1213160008',
    districtId: '1213160',
    name: 'Teluk Meku',
  },
  {
    id: '1213170001',
    districtId: '1213170',
    name: 'Harapan Jaya',
  },
  {
    id: '1213170002',
    districtId: '1213170',
    name: 'Telaga Said',
  },
  {
    id: '1213170003',
    districtId: '1213170',
    name: 'Lama Baru',
  },
  {
    id: '1213170004',
    districtId: '1213170',
    name: 'Lama',
  },
  {
    id: '1213170005',
    districtId: '1213170',
    name: 'Alur Dua',
  },
  {
    id: '1213170006',
    districtId: '1213170',
    name: 'Puraka II',
  },
  {
    id: '1213170007',
    districtId: '1213170',
    name: 'Alur Dua Baru',
  },
  {
    id: '1213170008',
    districtId: '1213170',
    name: 'Puraka I Pertamina',
  },
  {
    id: '1213170009',
    districtId: '1213170',
    name: 'Sei Bilah',
  },
  {
    id: '1213170010',
    districtId: '1213170',
    name: 'Sei Bilah Timur',
  },
  {
    id: '1213170011',
    districtId: '1213170',
    name: 'Mekar Makmur',
  },
  {
    id: '1213170012',
    districtId: '1213170',
    name: 'Harapan Baru',
  },
  {
    id: '1213170013',
    districtId: '1213170',
    name: 'Harapan Maju',
  },
  {
    id: '1213170014',
    districtId: '1213170',
    name: 'Harapan Makmur',
  },
  {
    id: '1213180001',
    districtId: '1213180',
    name: 'Tangkahan Durian',
  },
  {
    id: '1213180002',
    districtId: '1213180',
    name: 'Sei Tualang',
  },
  {
    id: '1213180003',
    districtId: '1213180',
    name: 'Lubuk Kasih',
  },
  {
    id: '1213180004',
    districtId: '1213180',
    name: 'Pangkalan Batu',
  },
  {
    id: '1213180005',
    districtId: '1213180',
    name: 'Perlis',
  },
  {
    id: '1213180006',
    districtId: '1213180',
    name: 'Lubuk Kertang',
  },
  {
    id: '1213180007',
    districtId: '1213180',
    name: 'Kelantan',
  },
  {
    id: '1213190001',
    districtId: '1213190',
    name: 'Pir Adb Besitang',
  },
  {
    id: '1213190002',
    districtId: '1213190',
    name: 'Sekoci',
  },
  {
    id: '1213190003',
    districtId: '1213190',
    name: 'Bukit Mas',
  },
  {
    id: '1213190004',
    districtId: '1213190',
    name: 'Halaban',
  },
  {
    id: '1213190005',
    districtId: '1213190',
    name: 'Bukit Selamat',
  },
  {
    id: '1213190006',
    districtId: '1213190',
    name: 'Pekan Besitang',
  },
  {
    id: '1213190007',
    districtId: '1213190',
    name: 'Kampung Lama',
  },
  {
    id: '1213190008',
    districtId: '1213190',
    name: 'Bukit Kubu',
  },
  {
    id: '1213190009',
    districtId: '1213190',
    name: 'Suka Jaya',
  },
  {
    id: '1213200001',
    districtId: '1213200',
    name: 'Pangkalan Siata',
  },
  {
    id: '1213200002',
    districtId: '1213200',
    name: 'Sei Meran',
  },
  {
    id: '1213200003',
    districtId: '1213200',
    name: 'Alur Cempedak',
  },
  {
    id: '1213200004',
    districtId: '1213200',
    name: 'Paya Tampak',
  },
  {
    id: '1213200005',
    districtId: '1213200',
    name: 'Sei Siur',
  },
  {
    id: '1213200006',
    districtId: '1213200',
    name: 'Tanjung Pasir',
  },
  {
    id: '1213200007',
    districtId: '1213200',
    name: 'Pintu Air',
  },
  {
    id: '1213200008',
    districtId: '1213200',
    name: 'Beras Basah',
  },
  {
    id: '1213200009',
    districtId: '1213200',
    name: 'Bukit Jengkol',
  },
  {
    id: '1213200010',
    districtId: '1213200',
    name: 'Pulau Sembilan',
  },
  {
    id: '1213200011',
    districtId: '1213200',
    name: 'Pulau Kampai',
  },
  {
    id: '1213201001',
    districtId: '1213201',
    name: 'Salahaji',
  },
  {
    id: '1213201002',
    districtId: '1213201',
    name: 'Serang Jaya',
  },
  {
    id: '1213201003',
    districtId: '1213201',
    name: 'Pematang Tengah',
  },
  {
    id: '1213201004',
    districtId: '1213201',
    name: 'Perkebunan Perapen',
  },
  {
    id: '1213201005',
    districtId: '1213201',
    name: 'Limau Mungkur',
  },
  {
    id: '1213201006',
    districtId: '1213201',
    name: 'Perkebunan Damar Condong',
  },
  {
    id: '1213201007',
    districtId: '1213201',
    name: 'Damar Condong',
  },
  {
    id: '1213201008',
    districtId: '1213201',
    name: 'Serang Jaya Hilir',
  },
  {
    id: '1214010001',
    districtId: '1214010',
    name: 'Duru',
  },
  {
    id: '1214010002',
    districtId: '1214010',
    name: 'Tuwaso',
  },
  {
    id: '1214010003',
    districtId: '1214010',
    name: 'Hilioromao',
  },
  {
    id: '1214010004',
    districtId: '1214010',
    name: 'Eho',
  },
  {
    id: '1214010005',
    districtId: '1214010',
    name: 'Sialema',
  },
  {
    id: '1214010006',
    districtId: '1214010',
    name: 'Bawonifaoso',
  },
  {
    id: '1214010007',
    districtId: '1214010',
    name: 'Hilianombasela',
  },
  {
    id: '1214010008',
    districtId: '1214010',
    name: 'Lumbui Melayu',
  },
  {
    id: '1214010009',
    districtId: '1214010',
    name: 'Hiliorudua Tebolo',
  },
  {
    id: '1214010010',
    districtId: '1214010',
    name: 'Tebolo Melayu',
  },
  {
    id: '1214010016',
    districtId: '1214010',
    name: 'Baruyu Sibohou',
  },
  {
    id: '1214010017',
    districtId: '1214010',
    name: 'Lumbui Nias',
  },
  {
    id: '1214010018',
    districtId: '1214010',
    name: 'Tanomokino',
  },
  {
    id: '1214010019',
    districtId: '1214010',
    name: 'Sepakat',
  },
  {
    id: '1214010020',
    districtId: '1214010',
    name: 'Hilikana',
  },
  {
    id: '1214010021',
    districtId: '1214010',
    name: 'Bawootanio Omega',
  },
  {
    id: '1214010022',
    districtId: '1214010',
    name: 'Hilinifaese',
  },
  {
    id: '1214011001',
    districtId: '1214011',
    name: 'Makole',
  },
  {
    id: '1214011002',
    districtId: '1214011',
    name: 'Jeke',
  },
  {
    id: '1214011003',
    districtId: '1214011',
    name: 'Sifauruasi',
  },
  {
    id: '1214011004',
    districtId: '1214011',
    name: 'Saeru Melayu',
  },
  {
    id: '1214011005',
    districtId: '1214011',
    name: 'Bawoanalita Saeru',
  },
  {
    id: '1214011006',
    districtId: '1214011',
    name: 'Bawo Orudua',
  },
  {
    id: '1214011007',
    districtId: '1214011',
    name: 'Hale Baluta',
  },
  {
    id: '1214011008',
    districtId: '1214011',
    name: 'Bawo Ofuloa',
  },
  {
    id: '1214011009',
    districtId: '1214011',
    name: 'Baluta',
  },
  {
    id: '1214011010',
    districtId: '1214011',
    name: 'Eho Baluta',
  },
  {
    id: '1214011011',
    districtId: '1214011',
    name: 'Hiligeho Sogawu',
  },
  {
    id: '1214011012',
    districtId: '1214011',
    name: 'Hiliomasio',
  },
  {
    id: '1214020028',
    districtId: '1214020',
    name: 'Sifitu Ewali',
  },
  {
    id: '1214020029',
    districtId: '1214020',
    name: 'Rapa Rapa',
  },
  {
    id: '1214020030',
    districtId: '1214020',
    name: 'Sinauru',
  },
  {
    id: '1214020031',
    districtId: '1214020',
    name: 'Siofa Ewali',
  },
  {
    id: '1214020032',
    districtId: '1214020',
    name: 'Simaluaya',
  },
  {
    id: '1214020033',
    districtId: '1214020',
    name: 'Silimaewali',
  },
  {
    id: '1214020034',
    districtId: '1214020',
    name: 'Siduaewali',
  },
  {
    id: '1214020035',
    districtId: '1214020',
    name: 'Pasar Pulau Tello',
  },
  {
    id: '1214020036',
    districtId: '1214020',
    name: 'Baruyu Lasara',
  },
  {
    id: '1214020037',
    districtId: '1214020',
    name: 'Hiliotalua',
  },
  {
    id: '1214020038',
    districtId: '1214020',
    name: 'Hiliamodula',
  },
  {
    id: '1214020039',
    districtId: '1214020',
    name: 'Bawodobara',
  },
  {
    id: '1214020040',
    districtId: '1214020',
    name: 'Bawoamahelato',
  },
  {
    id: '1214020041',
    districtId: '1214020',
    name: 'Loboi',
  },
  {
    id: '1214020042',
    districtId: '1214020',
    name: 'Bawoomasio',
  },
  {
    id: '1214020043',
    districtId: '1214020',
    name: 'Balogia',
  },
  {
    id: '1214020045',
    districtId: '1214020',
    name: 'Lasonde',
  },
  {
    id: '1214020051',
    districtId: '1214020',
    name: 'Koto',
  },
  {
    id: '1214020062',
    districtId: '1214020',
    name: 'Sebuasi',
  },
  {
    id: '1214020063',
    districtId: '1214020',
    name: 'Sisarahili',
  },
  {
    id: '1214020064',
    districtId: '1214020',
    name: 'Onaya',
  },
  {
    id: '1214020065',
    districtId: '1214020',
    name: 'Orahili',
  },
  {
    id: '1214021001',
    districtId: '1214021',
    name: 'Mahang Labara',
  },
  {
    id: '1214021002',
    districtId: '1214021',
    name: 'Adam',
  },
  {
    id: '1214021003',
    districtId: '1214021',
    name: 'Bais',
  },
  {
    id: '1214021004',
    districtId: '1214021',
    name: 'Lambak',
  },
  {
    id: '1214021005',
    districtId: '1214021',
    name: 'Labuan Rima',
  },
  {
    id: '1214021006',
    districtId: '1214021',
    name: 'Labuan Hiu',
  },
  {
    id: '1214021007',
    districtId: '1214021',
    name: 'Labuan Bajau',
  },
  {
    id: '1214021008',
    districtId: '1214021',
    name: 'Labara',
  },
  {
    id: '1214021009',
    districtId: '1214021',
    name: 'Bais Baru',
  },
  {
    id: '1214021010',
    districtId: '1214021',
    name: 'Labuan Rima Baru',
  },
  {
    id: '1214022001',
    districtId: '1214022',
    name: 'Gondia',
  },
  {
    id: '1214022002',
    districtId: '1214022',
    name: 'Maufa',
  },
  {
    id: '1214022003',
    districtId: '1214022',
    name: 'Gobo Baru',
  },
  {
    id: '1214022004',
    districtId: '1214022',
    name: 'Gobo',
  },
  {
    id: '1214022005',
    districtId: '1214022',
    name: 'Silina',
  },
  {
    id: '1214022006',
    districtId: '1214022',
    name: 'Silina Baru',
  },
  {
    id: '1214023001',
    districtId: '1214023',
    name: 'Fuge',
  },
  {
    id: '1214023003',
    districtId: '1214023',
    name: 'Bawositora',
  },
  {
    id: '1214023004',
    districtId: '1214023',
    name: 'Sigese',
  },
  {
    id: '1214023005',
    districtId: '1214023',
    name: 'Bintuang',
  },
  {
    id: '1214023006',
    districtId: '1214023',
    name: 'Hayo',
  },
  {
    id: '1214023007',
    districtId: '1214023',
    name: 'Sibaranun',
  },
  {
    id: '1214023008',
    districtId: '1214023',
    name: 'Luaha Idano Pono',
  },
  {
    id: '1214023009',
    districtId: '1214023',
    name: 'Bawolawinda',
  },
  {
    id: '1214023010',
    districtId: '1214023',
    name: 'Hili Jamorogotano',
  },
  {
    id: '1214024001',
    districtId: '1214024',
    name: 'Wawa',
  },
  {
    id: '1214024002',
    districtId: '1214024',
    name: 'Teluk Limo',
  },
  {
    id: '1214024003',
    districtId: '1214024',
    name: 'Bale Bale',
  },
  {
    id: '1214024005',
    districtId: '1214024',
    name: 'Marit Baru',
  },
  {
    id: '1214024006',
    districtId: '1214024',
    name: 'Silima Banua Marit',
  },
  {
    id: '1214024009',
    districtId: '1214024',
    name: 'Majino Lorang',
  },
  {
    id: '1214024010',
    districtId: '1214024',
    name: 'Siofa Banua Lorang',
  },
  {
    id: '1214024011',
    districtId: '1214024',
    name: 'Limo Biang',
  },
  {
    id: '1214024012',
    districtId: '1214024',
    name: 'Ziabiang',
  },
  {
    id: '1214024013',
    districtId: '1214024',
    name: 'Memong',
  },
  {
    id: '1214024014',
    districtId: '1214024',
    name: 'Afore',
  },
  {
    id: '1214024015',
    districtId: '1214024',
    name: 'Bale-Bale Sibohou',
  },
  {
    id: '1214030006',
    districtId: '1214030',
    name: 'Hiligeho',
  },
  {
    id: '1214030007',
    districtId: '1214030',
    name: 'Hilitobara',
  },
  {
    id: '1214030008',
    districtId: '1214030',
    name: 'Pasar Teluk Dalam',
  },
  {
    id: '1214030009',
    districtId: '1214030',
    name: 'Bawonifaoso',
  },
  {
    id: '1214030010',
    districtId: '1214030',
    name: 'Bawozaua',
  },
  {
    id: '1214030011',
    districtId: '1214030',
    name: 'Hiliganowo',
  },
  {
    id: '1214030022',
    districtId: '1214030',
    name: 'Bawodobara',
  },
  {
    id: '1214030023',
    districtId: '1214030',
    name: 'Bawolowalani',
  },
  {
    id: '1214030024',
    districtId: '1214030',
    name: 'Hilisondrekha',
  },
  {
    id: '1214030025',
    districtId: '1214030',
    name: 'Hilisaootoniha',
  },
  {
    id: '1214030040',
    districtId: '1214030',
    name: 'Hilianaa',
  },
  {
    id: '1214030041',
    districtId: '1214030',
    name: 'Hiliganowo Saloo',
  },
  {
    id: '1214030042',
    districtId: '1214030',
    name: "Hiliganowosa'Ua",
  },
  {
    id: '1214030043',
    districtId: '1214030',
    name: 'Hililaza',
  },
  {
    id: '1214030044',
    districtId: '1214030',
    name: 'Nanowa',
  },
  {
    id: '1214031004',
    districtId: '1214031',
    name: 'Bawonahono',
  },
  {
    id: '1214031005',
    districtId: '1214031',
    name: 'Hilizihono',
  },
  {
    id: '1214031006',
    districtId: '1214031',
    name: 'Bawomataluo',
  },
  {
    id: '1214031007',
    districtId: '1214031',
    name: 'Orahili Fau',
  },
  {
    id: '1214031008',
    districtId: '1214031',
    name: 'Lahusa Fau',
  },
  {
    id: '1214031009',
    districtId: '1214031',
    name: 'Onohondro',
  },
  {
    id: '1214031010',
    districtId: '1214031',
    name: 'Siwalawa',
  },
  {
    id: '1214031011',
    districtId: '1214031',
    name: 'Hilinawalo Fau',
  },
  {
    id: '1214031013',
    districtId: '1214031',
    name: 'Hiliofonaluo',
  },
  {
    id: '1214031016',
    districtId: '1214031',
    name: 'Bawofanayama',
  },
  {
    id: '1214031017',
    districtId: '1214031',
    name: 'Orahili Geto',
  },
  {
    id: '1214031018',
    districtId: '1214031',
    name: 'Orahili Eho',
  },
  {
    id: '1214031019',
    districtId: '1214031',
    name: 'Hilisalawa',
  },
  {
    id: '1214031020',
    districtId: '1214031',
    name: 'Hilikaramaha',
  },
  {
    id: '1214031021',
    districtId: '1214031',
    name: 'Siliwulawa',
  },
  {
    id: '1214031022',
    districtId: '1214031',
    name: 'Hilifarokhalawa',
  },
  {
    id: '1214031023',
    districtId: '1214031',
    name: 'Ete Batu',
  },
  {
    id: '1214032001',
    districtId: '1214032',
    name: 'Hiliamaetaluo',
  },
  {
    id: '1214032002',
    districtId: '1214032',
    name: 'Hilisataro',
  },
  {
    id: '1214032003',
    districtId: '1214032',
    name: 'Hilinamoniha',
  },
  {
    id: '1214032004',
    districtId: '1214032',
    name: 'Bawoganowo',
  },
  {
    id: '1214032005',
    districtId: '1214032',
    name: 'Hilialawa',
  },
  {
    id: '1214032006',
    districtId: '1214032',
    name: 'Hilindrasoniha',
  },
  {
    id: '1214032007',
    districtId: '1214032',
    name: 'Hilisataro Raya',
  },
  {
    id: '1214032008',
    districtId: '1214032',
    name: 'Hilisataro Gewa',
  },
  {
    id: '1214032009',
    districtId: '1214032',
    name: 'Hiliasi',
  },
  {
    id: '1214032010',
    districtId: '1214032',
    name: 'Hilimagari',
  },
  {
    id: '1214032011',
    districtId: '1214032',
    name: 'Hilisoromi',
  },
  {
    id: '1214032012',
    districtId: '1214032',
    name: 'Hilisataro Nandisa',
  },
  {
    id: '1214032013',
    districtId: '1214032',
    name: 'Hilisataro Ehosofayo',
  },
  {
    id: '1214032014',
    districtId: '1214032',
    name: 'Hilindraso Raya',
  },
  {
    id: '1214033001',
    districtId: '1214033',
    name: 'Hilisimaetano',
  },
  {
    id: '1214033003',
    districtId: '1214033',
    name: 'Bawogosali',
  },
  {
    id: '1214033004',
    districtId: '1214033',
    name: 'Hilifalawu',
  },
  {
    id: '1214033006',
    districtId: '1214033',
    name: 'Sotoo Hilisimaetano',
  },
  {
    id: '1214033007',
    districtId: '1214033',
    name: 'Eho Hilisimaetano',
  },
  {
    id: '1214033008',
    districtId: '1214033',
    name: 'Samadaya Hilisimaetano',
  },
  {
    id: '1214033009',
    districtId: '1214033',
    name: 'Idala Jaya Hilisimaetano',
  },
  {
    id: '1214033010',
    districtId: '1214033',
    name: 'Faomasi Hilisimaetano',
  },
  {
    id: '1214033011',
    districtId: '1214033',
    name: 'Hiliaurifa Hilisimaetano',
  },
  {
    id: '1214033012',
    districtId: '1214033',
    name: 'Ndraso Hilisimaetano',
  },
  {
    id: '1214033013',
    districtId: '1214033',
    name: 'Pekan Hilisimaetano',
  },
  {
    id: '1214033014',
    districtId: '1214033',
    name: 'Bonia Hilisimaetano',
  },
  {
    id: '1214033015',
    districtId: '1214033',
    name: 'Bawosaodano',
  },
  {
    id: '1214033016',
    districtId: '1214033',
    name: 'Bowohosi',
  },
  {
    id: '1214034001',
    districtId: '1214034',
    name: 'Hilizalootano',
  },
  {
    id: '1214034002',
    districtId: '1214034',
    name: 'Bawolahusa',
  },
  {
    id: '1214034003',
    districtId: '1214034',
    name: 'Hilinawalo Mazino',
  },
  {
    id: '1214034004',
    districtId: '1214034',
    name: 'Hilizoroilawa',
  },
  {
    id: '1214034005',
    districtId: '1214034',
    name: 'Lawindra',
  },
  {
    id: '1214034006',
    districtId: '1214034',
    name: 'Bawolahusa Doli-Doli',
  },
  {
    id: '1214034007',
    districtId: '1214034',
    name: 'Hilizalotano Larono',
  },
  {
    id: '1214034008',
    districtId: '1214034',
    name: 'Hilizalotano Laowo',
  },
  {
    id: '1214034009',
    districtId: '1214034',
    name: 'Lolomboli',
  },
  {
    id: '1214034010',
    districtId: '1214034',
    name: 'Hililaza Hilinawalo Mazino',
  },
  {
    id: '1214034011',
    districtId: '1214034',
    name: 'Hilifondege Hilizoroilawa',
  },
  {
    id: '1214035001',
    districtId: '1214035',
    name: 'Botohilisaloo',
  },
  {
    id: '1214035002',
    districtId: '1214035',
    name: 'Botohilitano',
  },
  {
    id: '1214035005',
    districtId: '1214035',
    name: 'Lagundri',
  },
  {
    id: '1214035006',
    districtId: '1214035',
    name: 'Hiliametaniha',
  },
  {
    id: '1214035007',
    districtId: '1214035',
    name: 'Orahili Faomasi',
  },
  {
    id: '1214035008',
    districtId: '1214035',
    name: 'Hilimaenamolo',
  },
  {
    id: '1214035010',
    districtId: '1214035',
    name: 'Bawomaenamolo',
  },
  {
    id: '1214035011',
    districtId: '1214035',
    name: 'Botohili Sorake',
  },
  {
    id: '1214035012',
    districtId: '1214035',
    name: 'Botohili Silambo',
  },
  {
    id: '1214035013',
    districtId: '1214035',
    name: 'Sondregeasi',
  },
  {
    id: '1214036001',
    districtId: '1214036',
    name: 'Hiliamuri',
  },
  {
    id: '1214036002',
    districtId: '1214036',
    name: 'Hilionaha',
  },
  {
    id: '1214036003',
    districtId: '1214036',
    name: 'Hilimondregeraya',
  },
  {
    id: '1214036005',
    districtId: '1214036',
    name: 'Hilinamozaua',
  },
  {
    id: '1214036008',
    districtId: '1214036',
    name: 'Hilifalago',
  },
  {
    id: '1214036009',
    districtId: '1214036',
    name: 'Hilialitosaua',
  },
  {
    id: '1214036010',
    districtId: '1214036',
    name: 'Hilinamozaua Raya',
  },
  {
    id: '1214036011',
    districtId: '1214036',
    name: 'Hilisanekhehosi',
  },
  {
    id: '1214036012',
    districtId: '1214036',
    name: 'Hilifarono',
  },
  {
    id: '1214036013',
    districtId: '1214036',
    name: 'Hilifalago Raya',
  },
  {
    id: '1214036014',
    districtId: '1214036',
    name: 'Hilikara',
  },
  {
    id: '1214040001',
    districtId: '1214040',
    name: 'Hilihoru',
  },
  {
    id: '1214040002',
    districtId: '1214040',
    name: 'Hilimbulawa',
  },
  {
    id: '1214040003',
    districtId: '1214040',
    name: 'Sifaoroasi',
  },
  {
    id: '1214040008',
    districtId: '1214040',
    name: 'Sisobahili',
  },
  {
    id: '1214040009',
    districtId: '1214040',
    name: 'Tuindrao',
  },
  {
    id: '1214040011',
    districtId: '1214040',
    name: 'Hilimbowo',
  },
  {
    id: '1214040012',
    districtId: '1214040',
    name: 'Lolozaria',
  },
  {
    id: '1214040013',
    districtId: '1214040',
    name: 'Lolomoyo',
  },
  {
    id: '1214040014',
    districtId: '1214040',
    name: 'Hilifadolo',
  },
  {
    id: '1214040015',
    districtId: '1214040',
    name: 'Orahili Eho',
  },
  {
    id: '1214040019',
    districtId: '1214040',
    name: 'Sirofi',
  },
  {
    id: '1214040020',
    districtId: '1214040',
    name: 'Hilisaloo',
  },
  {
    id: '1214040021',
    districtId: '1214040',
    name: 'Loloabolo',
  },
  {
    id: '1214040022',
    districtId: '1214040',
    name: 'Mohili',
  },
  {
    id: '1214040023',
    districtId: '1214040',
    name: 'Hilindraso',
  },
  {
    id: '1214040024',
    districtId: '1214040',
    name: 'Hilimaera',
  },
  {
    id: '1214040025',
    districtId: '1214040',
    name: 'Amandraya',
  },
  {
    id: '1214040026',
    districtId: '1214040',
    name: 'Sinar Inoo',
  },
  {
    id: '1214040027',
    districtId: '1214040',
    name: 'Tuindrao 1',
  },
  {
    id: '1214040028',
    districtId: '1214040',
    name: 'Tuhemberua',
  },
  {
    id: '1214040029',
    districtId: '1214040',
    name: 'Boholu',
  },
  {
    id: '1214041001',
    districtId: '1214041',
    name: 'Hilitotao',
  },
  {
    id: '1214041002',
    districtId: '1214041',
    name: 'Hiliorodua',
  },
  {
    id: '1214041003',
    districtId: '1214041',
    name: 'Hiliamauzula',
  },
  {
    id: '1214041004',
    districtId: '1214041',
    name: 'Sisobambowo',
  },
  {
    id: '1214041005',
    districtId: '1214041',
    name: 'Hilifadolo',
  },
  {
    id: '1214041006',
    districtId: '1214041',
    name: 'Aramo',
  },
  {
    id: '1214041007',
    districtId: '1214041',
    name: 'Hilimagiao',
  },
  {
    id: '1214041008',
    districtId: '1214041',
    name: 'Hume',
  },
  {
    id: '1214041009',
    districtId: '1214041',
    name: 'Hilimejaya',
  },
  {
    id: '1214041010',
    districtId: '1214041',
    name: 'Dao-Dao',
  },
  {
    id: '1214041011',
    districtId: '1214041',
    name: 'Sikhorilafau',
  },
  {
    id: '1214041012',
    districtId: '1214041',
    name: 'Hilimbowo',
  },
  {
    id: '1214041013',
    districtId: '1214041',
    name: 'Hilisawato',
  },
  {
    id: '1214041014',
    districtId: '1214041',
    name: 'Hiligafoa',
  },
  {
    id: '1214041015',
    districtId: '1214041',
    name: 'Balohao',
  },
  {
    id: '1214041016',
    districtId: '1214041',
    name: 'Hiliadolowa',
  },
  {
    id: '1214041017',
    districtId: '1214041',
    name: 'Hiligumbu',
  },
  {
    id: '1214041018',
    districtId: '1214041',
    name: 'Bagoa',
  },
  {
    id: '1214042001',
    districtId: '1214042',
    name: 'Foikhu Fondrako',
  },
  {
    id: '1214042002',
    districtId: '1214042',
    name: 'Sisarahili Susua',
  },
  {
    id: '1214042003',
    districtId: '1214042',
    name: 'Hilinifaoso',
  },
  {
    id: '1214042004',
    districtId: '1214042',
    name: 'Ramba-Ramba',
  },
  {
    id: '1214042005',
    districtId: '1214042',
    name: 'Fondrakoraya',
  },
  {
    id: '1214042006',
    districtId: '1214042',
    name: 'Lahusa Susua',
  },
  {
    id: '1214042009',
    districtId: '1214042',
    name: 'Susua',
  },
  {
    id: '1214042010',
    districtId: '1214042',
    name: 'Orudua Sibohou',
  },
  {
    id: '1214042011',
    districtId: '1214042',
    name: 'Amandraya',
  },
  {
    id: '1214042012',
    districtId: '1214042',
    name: 'Sifaoroasi',
  },
  {
    id: '1214042013',
    districtId: '1214042',
    name: 'Hiliwosi',
  },
  {
    id: '1214042014',
    districtId: '1214042',
    name: 'Orahili Fondrako',
  },
  {
    id: '1214050001',
    districtId: '1214050',
    name: 'Golambanua I',
  },
  {
    id: '1214050002',
    districtId: '1214050',
    name: 'Hilisimaetano',
  },
  {
    id: '1214050003',
    districtId: '1214050',
    name: 'Bawozihono',
  },
  {
    id: '1214050004',
    districtId: '1214050',
    name: 'Bawootalua',
  },
  {
    id: '1214050005',
    districtId: '1214050',
    name: 'Tetezou',
  },
  {
    id: '1214050006',
    districtId: '1214050',
    name: 'Bawolato',
  },
  {
    id: '1214050009',
    districtId: '1214050',
    name: 'Lahusa',
  },
  {
    id: '1214050016',
    districtId: '1214050',
    name: 'Orahili Balaekha',
  },
  {
    id: '1214050017',
    districtId: '1214050',
    name: 'Hiliorudua',
  },
  {
    id: '1214050018',
    districtId: '1214050',
    name: 'Sinar Baru Daro-Daro',
  },
  {
    id: '1214050019',
    districtId: '1214050',
    name: 'Hiliabolata',
  },
  {
    id: '1214050020',
    districtId: '1214050',
    name: 'Sisarahililaza',
  },
  {
    id: '1214050021',
    districtId: '1214050',
    name: 'Harenoro',
  },
  {
    id: '1214050022',
    districtId: '1214050',
    name: 'Hilizomboi',
  },
  {
    id: '1214050023',
    districtId: '1214050',
    name: 'Hiligambukha',
  },
  {
    id: '1214050024',
    districtId: '1214050',
    name: 'Hiliwatema',
  },
  {
    id: '1214050025',
    districtId: '1214050',
    name: 'Sobawagoli',
  },
  {
    id: '1214050026',
    districtId: '1214050',
    name: 'Sinar Baho',
  },
  {
    id: '1214050027',
    districtId: '1214050',
    name: 'Lahusa 1',
  },
  {
    id: '1214050028',
    districtId: '1214050',
    name: 'Hilinawalo Balaekha',
  },
  {
    id: '1214050029',
    districtId: '1214050',
    name: 'Oikhodabalaekha',
  },
  {
    id: '1214050030',
    districtId: '1214050',
    name: 'Angorudua Balaekha',
  },
  {
    id: '1214050031',
    districtId: '1214050',
    name: 'Mogae',
  },
  {
    id: '1214051001',
    districtId: '1214051',
    name: 'Hilizanuwo',
  },
  {
    id: '1214051002',
    districtId: '1214051',
    name: 'Mondrowe',
  },
  {
    id: '1214051003',
    districtId: '1214051',
    name: 'Hilidohona',
  },
  {
    id: '1214051004',
    districtId: '1214051',
    name: 'Hililaora',
  },
  {
    id: '1214051005',
    districtId: '1214051',
    name: 'Ulu Idanoduo',
  },
  {
    id: '1214051006',
    districtId: '1214051',
    name: 'Naai',
  },
  {
    id: '1214051007',
    districtId: '1214051',
    name: 'Taluzusua',
  },
  {
    id: '1214051008',
    districtId: '1214051',
    name: 'Hilisaooto',
  },
  {
    id: '1214051010',
    districtId: '1214051',
    name: 'Umbusohahau',
  },
  {
    id: '1214051011',
    districtId: '1214051',
    name: 'Olanori',
  },
  {
    id: '1214051012',
    districtId: '1214051',
    name: 'Hoya',
  },
  {
    id: '1214052001',
    districtId: '1214052',
    name: 'Siwalubanua',
  },
  {
    id: '1214052003',
    districtId: '1214052',
    name: 'Sitolu Banua',
  },
  {
    id: '1214052004',
    districtId: '1214052',
    name: 'Silimabanua',
  },
  {
    id: '1214052005',
    districtId: '1214052',
    name: 'Mehaga',
  },
  {
    id: '1214052006',
    districtId: '1214052',
    name: 'Fanedanu',
  },
  {
    id: '1214052007',
    districtId: '1214052',
    name: 'Hiliorahua Tasua',
  },
  {
    id: '1214052008',
    districtId: '1214052',
    name: 'Sihareo',
  },
  {
    id: '1214052009',
    districtId: '1214052',
    name: 'Sifitubanua',
  },
  {
    id: '1214052011',
    districtId: '1214052',
    name: 'Golambanua II',
  },
  {
    id: '1214052013',
    districtId: '1214052',
    name: 'Oladano',
  },
  {
    id: '1214052014',
    districtId: '1214052',
    name: 'Sinar Susua',
  },
  {
    id: '1214052015',
    districtId: '1214052',
    name: 'Hilialawa',
  },
  {
    id: '1214052016',
    districtId: '1214052',
    name: 'Gabungan Tasua',
  },
  {
    id: '1214052017',
    districtId: '1214052',
    name: 'Somambawa',
  },
  {
    id: '1214060013',
    districtId: '1214060',
    name: 'Lawa Lawa Luo Gomo',
  },
  {
    id: '1214060014',
    districtId: '1214060',
    name: 'Siforoasi Gomo',
  },
  {
    id: '1214060015',
    districtId: '1214060',
    name: 'Orahili Gomo',
  },
  {
    id: '1214060018',
    districtId: '1214060',
    name: 'Lolosoni',
  },
  {
    id: '1214060019',
    districtId: '1214060',
    name: 'Hilianaa Gomo',
  },
  {
    id: '1214060021',
    districtId: '1214060',
    name: 'Doli Doli',
  },
  {
    id: '1214060032',
    districtId: '1214060',
    name: 'Suka Maju Mohili',
  },
  {
    id: '1214060036',
    districtId: '1214060',
    name: 'Tanonikoo',
  },
  {
    id: '1214060037',
    districtId: '1214060',
    name: 'Orahili Sibohou',
  },
  {
    id: '1214060038',
    districtId: '1214060',
    name: 'Umbu Orahua',
  },
  {
    id: '1214060039',
    districtId: '1214060',
    name: 'Gunung Gabungan',
  },
  {
    id: '1214061001',
    districtId: '1214061',
    name: 'Hilimboe',
  },
  {
    id: '1214061002',
    districtId: '1214061',
    name: 'Hiliorahua',
  },
  {
    id: '1214061003',
    districtId: '1214061',
    name: 'Sifalago Susua',
  },
  {
    id: '1214061004',
    districtId: '1214061',
    name: 'Hilimboho',
  },
  {
    id: '1214061005',
    districtId: '1214061',
    name: 'Orahili Susua',
  },
  {
    id: '1214061006',
    districtId: '1214061',
    name: 'Hilianaa Susua',
  },
  {
    id: '1214061007',
    districtId: '1214061',
    name: 'Hiliwaebu',
  },
  {
    id: '1214061008',
    districtId: '1214061',
    name: 'Hilidanayao',
  },
  {
    id: '1214061009',
    districtId: '1214061',
    name: 'Hilizamurugo',
  },
  {
    id: '1214061010',
    districtId: '1214061',
    name: 'Sisobahili',
  },
  {
    id: '1214061011',
    districtId: '1214061',
    name: 'Dao-Dao Zanuwo',
  },
  {
    id: '1214061012',
    districtId: '1214061',
    name: 'Hiliorudua',
  },
  {
    id: '1214061013',
    districtId: '1214061',
    name: 'Bintang Baru Susua',
  },
  {
    id: '1214061014',
    districtId: '1214061',
    name: 'Hiliadulo Soi',
  },
  {
    id: '1214061015',
    districtId: '1214061',
    name: 'Orahili Boe',
  },
  {
    id: '1214061016',
    districtId: '1214061',
    name: 'Orahua Uluzoi',
  },
  {
    id: '1214061017',
    districtId: '1214061',
    name: 'Hilitobara',
  },
  {
    id: '1214061018',
    districtId: '1214061',
    name: 'Hilisibohou',
  },
  {
    id: '1214062001',
    districtId: '1214062',
    name: 'Luahandroito',
  },
  {
    id: '1214062002',
    districtId: '1214062',
    name: 'Tetegawaai',
  },
  {
    id: '1214062003',
    districtId: '1214062',
    name: 'Hilimbaruzo',
  },
  {
    id: '1214062005',
    districtId: '1214062',
    name: 'Siofabanua',
  },
  {
    id: '1214062006',
    districtId: '1214062',
    name: 'Tafulu',
  },
  {
    id: '1214062007',
    districtId: '1214062',
    name: 'Hilimaufa',
  },
  {
    id: '1214062009',
    districtId: '1214062',
    name: 'Ulu Mazo',
  },
  {
    id: '1214062010',
    districtId: '1214062',
    name: 'Tetegawai Ehomo',
  },
  {
    id: '1214062011',
    districtId: '1214062',
    name: 'Orahuahili',
  },
  {
    id: '1214062012',
    districtId: '1214062',
    name: 'Guigui',
  },
  {
    id: '1214063001',
    districtId: '1214063',
    name: 'Lawindra',
  },
  {
    id: '1214063003',
    districtId: '1214063',
    name: 'Hiliuso',
  },
  {
    id: '1214063004',
    districtId: '1214063',
    name: 'Balohili Mola',
  },
  {
    id: '1214063005',
    districtId: '1214063',
    name: 'Sifaoroasi Mola',
  },
  {
    id: '1214063006',
    districtId: '1214063',
    name: 'Tobualo',
  },
  {
    id: '1214063007',
    districtId: '1214063',
    name: 'Ambukha',
  },
  {
    id: '1214063008',
    districtId: '1214063',
    name: 'Foikhugaga',
  },
  {
    id: '1214063009',
    districtId: '1214063',
    name: 'Hilibadalu',
  },
  {
    id: '1214063010',
    districtId: '1214063',
    name: 'Orlin',
  },
  {
    id: '1214063011',
    districtId: '1214063',
    name: 'Orahili Mola',
  },
  {
    id: '1214063012',
    districtId: '1214063',
    name: 'Umbunasi',
  },
  {
    id: '1214064001',
    districtId: '1214064',
    name: 'Hiliserangkai',
  },
  {
    id: '1214064002',
    districtId: '1214064',
    name: 'Lahusa Idanotae',
  },
  {
    id: '1214064003',
    districtId: '1214064',
    name: 'Orahua',
  },
  {
    id: '1214064004',
    districtId: '1214064',
    name: 'Hilimbowo Idanotae',
  },
  {
    id: '1214064005',
    districtId: '1214064',
    name: 'Sirahia',
  },
  {
    id: '1214064006',
    districtId: '1214064',
    name: 'Umbu Idanotae',
  },
  {
    id: '1214064007',
    districtId: '1214064',
    name: 'Awoni',
  },
  {
    id: '1214064008',
    districtId: '1214064',
    name: 'Hilisaloo',
  },
  {
    id: '1214064009',
    districtId: '1214064',
    name: 'Balumbaruzo Orahua',
  },
  {
    id: '1214064010',
    districtId: '1214064',
    name: 'Harefa Orahua',
  },
  {
    id: '1214064011',
    districtId: '1214064',
    name: 'Hiligabungan',
  },
  {
    id: '1214064012',
    districtId: '1214064',
    name: 'Buhawa',
  },
  {
    id: '1214065001',
    districtId: '1214065',
    name: 'Lawa Lawa Luo Idanotae',
  },
  {
    id: '1214065002',
    districtId: '1214065',
    name: 'Dao-Dao Zanuwo Idanotae',
  },
  {
    id: '1214065003',
    districtId: '1214065',
    name: 'Fanedanu',
  },
  {
    id: '1214065004',
    districtId: '1214065',
    name: 'Fanedanu Sibohou',
  },
  {
    id: '1214065005',
    districtId: '1214065',
    name: 'Lolozukhu',
  },
  {
    id: '1214065006',
    districtId: '1214065',
    name: 'Damai',
  },
  {
    id: '1214065007',
    districtId: '1214065',
    name: 'Sisiwa Ewali',
  },
  {
    id: '1214065008',
    districtId: '1214065',
    name: 'Silima Banua',
  },
  {
    id: '1214065009',
    districtId: '1214065',
    name: 'Sindrolo',
  },
  {
    id: '1214065010',
    districtId: '1214065',
    name: 'Sisarahili Ewo',
  },
  {
    id: '1214065011',
    districtId: '1214065',
    name: "Hilialo'Oa",
  },
  {
    id: '1214066001',
    districtId: '1214066',
    name: 'Tuhegafoa',
  },
  {
    id: '1214066002',
    districtId: '1214066',
    name: 'Siholi',
  },
  {
    id: '1214066003',
    districtId: '1214066',
    name: 'Sifalago Gomo',
  },
  {
    id: '1214066004',
    districtId: '1214066',
    name: 'Balohili Gomo',
  },
  {
    id: '1214066007',
    districtId: '1214066',
    name: 'Orsedes',
  },
  {
    id: '1214066008',
    districtId: '1214066',
    name: 'Bohalu',
  },
  {
    id: '1214066009',
    districtId: '1214066',
    name: 'Sinar Helaowo',
  },
  {
    id: '1214066010',
    districtId: '1214066',
    name: 'Perjuangan',
  },
  {
    id: '1214066011',
    districtId: '1214066',
    name: 'Lewa-Lewa',
  },
  {
    id: '1214066012',
    districtId: '1214066',
    name: 'Siraha',
  },
  {
    id: '1214070006',
    districtId: '1214070',
    name: 'Tuhemberua',
  },
  {
    id: '1214070009',
    districtId: '1214070',
    name: 'Hiliotalua',
  },
  {
    id: '1214070010',
    districtId: '1214070',
    name: 'Hilisangowola',
  },
  {
    id: '1214070011',
    districtId: '1214070',
    name: 'Lawa-Lawa Luo',
  },
  {
    id: '1214070012',
    districtId: '1214070',
    name: 'Tesikhori',
  },
  {
    id: '1214070013',
    districtId: '1214070',
    name: 'Koendrafo',
  },
  {
    id: '1214070021',
    districtId: '1214070',
    name: 'Ewo',
  },
  {
    id: '1214070023',
    districtId: '1214070',
    name: 'Koolotano',
  },
  {
    id: '1214070024',
    districtId: '1214070',
    name: 'Tumari',
  },
  {
    id: '1214070026',
    districtId: '1214070',
    name: 'Botohili Ndruria',
  },
  {
    id: '1214070027',
    districtId: '1214070',
    name: 'Caritas Sagawunasi',
  },
  {
    id: '1214070028',
    districtId: '1214070',
    name: 'Orudua Lawa-Lawa Luo',
  },
  {
    id: '1214070029',
    districtId: '1214070',
    name: 'Hilifaondrato',
  },
  {
    id: '1214071001',
    districtId: '1214071',
    name: 'Hiliwaebu',
  },
  {
    id: '1214071002',
    districtId: '1214071',
    name: 'Borowosi',
  },
  {
    id: '1214071003',
    districtId: '1214071',
    name: 'Sambulu',
  },
  {
    id: '1214071004',
    districtId: '1214071',
    name: 'Hilimaera',
  },
  {
    id: '1214071005',
    districtId: '1214071',
    name: 'Orahili Ulunoyo',
  },
  {
    id: '1214071006',
    districtId: '1214071',
    name: 'Marao',
  },
  {
    id: '1214071007',
    districtId: '1214071',
    name: 'Amorosa',
  },
  {
    id: '1214071008',
    districtId: '1214071',
    name: 'Suka Maju',
  },
  {
    id: '1214071009',
    districtId: '1214071',
    name: 'Loloanaa',
  },
  {
    id: '1214071010',
    districtId: '1214071',
    name: 'Hilifakhe',
  },
  {
    id: '1214071011',
    districtId: '1214071',
    name: 'Bawololomatua',
  },
  {
    id: '1214071012',
    districtId: '1214071',
    name: 'Puncak Lolomatua',
  },
  {
    id: '1214071013',
    districtId: '1214071',
    name: 'Ambukha I',
  },
  {
    id: '1214072001',
    districtId: '1214072',
    name: 'Hiliuso',
  },
  {
    id: '1214072002',
    districtId: '1214072',
    name: 'Tarewe',
  },
  {
    id: '1214072003',
    districtId: '1214072',
    name: 'Sisarahili Huruna',
  },
  {
    id: '1214072004',
    districtId: '1214072',
    name: 'Sifalago',
  },
  {
    id: '1214072005',
    districtId: '1214072',
    name: 'Tundumbaho',
  },
  {
    id: '1214072006',
    districtId: '1214072',
    name: 'Lalimanawa',
  },
  {
    id: '1214072007',
    districtId: '1214072',
    name: 'Siforoasi',
  },
  {
    id: '1214072009',
    districtId: '1214072',
    name: 'Ehosakhozi',
  },
  {
    id: '1214072010',
    districtId: '1214072',
    name: 'Hilizoliga',
  },
  {
    id: '1214072011',
    districtId: '1214072',
    name: 'Olayama',
  },
  {
    id: '1214072012',
    districtId: '1214072',
    name: 'Bawohosi',
  },
  {
    id: '1214072013',
    districtId: '1214072',
    name: 'Fadoro Tuhemberua',
  },
  {
    id: '1214072014',
    districtId: '1214072',
    name: 'Hilifalawu',
  },
  {
    id: '1214072015',
    districtId: '1214072',
    name: 'Luahamofakhe',
  },
  {
    id: '1214072016',
    districtId: '1214072',
    name: "Sifaoro'Asi Huruna",
  },
  {
    id: '1214072017',
    districtId: '1214072',
    name: 'Hilimanawa',
  },
  {
    id: '1214072018',
    districtId: '1214072',
    name: 'Mombawa Oladano',
  },
  {
    id: '1214080001',
    districtId: '1214080',
    name: 'Tuhegafoa',
  },
  {
    id: '1214080002',
    districtId: '1214080',
    name: 'Sisarahili Ekholo',
  },
  {
    id: '1214080003',
    districtId: '1214080',
    name: 'Amuri',
  },
  {
    id: '1214080010',
    districtId: '1214080',
    name: 'Lolohowa',
  },
  {
    id: '1214080011',
    districtId: '1214080',
    name: 'Lolowau',
  },
  {
    id: '1214080012',
    districtId: '1214080',
    name: 'Hilifadolo',
  },
  {
    id: '1214080015',
    districtId: '1214080',
    name: 'Lolomoyo',
  },
  {
    id: '1214080016',
    districtId: '1214080',
    name: 'Lolofaoso',
  },
  {
    id: '1214080017',
    districtId: '1214080',
    name: 'Bawosaloo Siwalawa',
  },
  {
    id: '1214080038',
    districtId: '1214080',
    name: 'Botohili',
  },
  {
    id: '1214080039',
    districtId: '1214080',
    name: 'Samiri',
  },
  {
    id: '1214080040',
    districtId: '1214080',
    name: 'Hilimbowo Siwalawa',
  },
  {
    id: '1214080041',
    districtId: '1214080',
    name: 'Nituwuboho',
  },
  {
    id: '1214080042',
    districtId: '1214080',
    name: 'Hilikara',
  },
  {
    id: '1214081001',
    districtId: '1214081',
    name: 'Bawosaloo Dao Dao',
  },
  {
    id: '1214081002',
    districtId: '1214081',
    name: 'Togizita',
  },
  {
    id: '1214081003',
    districtId: '1214081',
    name: 'Tuhoowo',
  },
  {
    id: '1214081004',
    districtId: '1214081',
    name: 'Soledua',
  },
  {
    id: '1214081005',
    districtId: '1214081',
    name: 'Dao-Dao Sowo',
  },
  {
    id: '1214081007',
    districtId: '1214081',
    name: 'Hilitoese',
  },
  {
    id: '1214081008',
    districtId: '1214081',
    name: 'Hiliadulo',
  },
  {
    id: '1214081009',
    districtId: '1214081',
    name: 'Togizita I',
  },
  {
    id: '1214081010',
    districtId: '1214081',
    name: 'Soledua I',
  },
  {
    id: '1214081011',
    districtId: '1214081',
    name: 'Soledua II',
  },
  {
    id: '1214082001',
    districtId: '1214082',
    name: 'Suka Maju',
  },
  {
    id: '1214082002',
    districtId: '1214082',
    name: 'Hilimbowo',
  },
  {
    id: '1214082003',
    districtId: '1214082',
    name: 'Lolomaya',
  },
  {
    id: '1214082004',
    districtId: '1214082',
    name: 'Simandaolo',
  },
  {
    id: '1214082005',
    districtId: '1214082',
    name: 'Simandraolo Oou',
  },
  {
    id: '1214082006',
    districtId: '1214082',
    name: 'Hilinamazihono',
  },
  {
    id: '1214082009',
    districtId: '1214082',
    name: 'Bawosaloo Bawoluo',
  },
  {
    id: '1214082010',
    districtId: '1214082',
    name: 'Hilimbuasi',
  },
  {
    id: '1214082011',
    districtId: '1214082',
    name: 'Hiliorudua',
  },
  {
    id: '1214082012',
    districtId: '1214082',
    name: 'Hilinamazihono Moale',
  },
  {
    id: '1214082013',
    districtId: '1214082',
    name: 'Balohili Oou',
  },
  {
    id: '1214083001',
    districtId: '1214083',
    name: 'Sisarahili Oyo',
  },
  {
    id: '1214083002',
    districtId: '1214083',
    name: 'Tetehosi',
  },
  {
    id: '1214083003',
    districtId: '1214083',
    name: 'Lauso',
  },
  {
    id: '1214083004',
    districtId: '1214083',
    name: 'Orahili Huruna',
  },
  {
    id: '1214083005',
    districtId: '1214083',
    name: 'Sisobahili Huruna',
  },
  {
    id: '1214083006',
    districtId: '1214083',
    name: 'Hiliweto',
  },
  {
    id: '1214083007',
    districtId: '1214083',
    name: 'Soromaasi',
  },
  {
    id: '1214083008',
    districtId: '1214083',
    name: 'Fadoro Ewo',
  },
  {
    id: '1214083009',
    districtId: '1214083',
    name: 'Onohazumba',
  },
  {
    id: '1214083010',
    districtId: '1214083',
    name: 'Helefanikha',
  },
  {
    id: '1214084001',
    districtId: '1214084',
    name: 'Manawadano',
  },
  {
    id: '1214084002',
    districtId: '1214084',
    name: 'Sisobahili Siwalawa',
  },
  {
    id: '1214084003',
    districtId: '1214084',
    name: 'Talio',
  },
  {
    id: '1214084004',
    districtId: '1214084',
    name: 'Hiliadulo',
  },
  {
    id: '1214084005',
    districtId: '1214084',
    name: 'Maluo',
  },
  {
    id: '1214084008',
    districtId: '1214084',
    name: 'Umbuasi',
  },
  {
    id: '1214084010',
    districtId: '1214084',
    name: 'Anaoma',
  },
  {
    id: '1214084011',
    districtId: '1214084',
    name: 'Berua Siwalawa',
  },
  {
    id: '1214084012',
    districtId: '1214084',
    name: 'Hiligodu',
  },
  {
    id: '1214084013',
    districtId: '1214084',
    name: 'Bukit Burasi',
  },
  {
    id: '1214084014',
    districtId: '1214084',
    name: 'Umbuasi Barat',
  },
  {
    id: '1215010001',
    districtId: '1215010',
    name: 'Tukka Dolok',
  },
  {
    id: '1215010002',
    districtId: '1215010',
    name: 'Pakkat Hauagong',
  },
  {
    id: '1215010003',
    districtId: '1215010',
    name: 'Purba Bersatu',
  },
  {
    id: '1215010004',
    districtId: '1215010',
    name: 'Purba Baringin',
  },
  {
    id: '1215010005',
    districtId: '1215010',
    name: 'Karya',
  },
  {
    id: '1215010006',
    districtId: '1215010',
    name: 'Manalu',
  },
  {
    id: '1215010007',
    districtId: '1215010',
    name: 'Pulo Godang',
  },
  {
    id: '1215010008',
    districtId: '1215010',
    name: 'Sipagabu',
  },
  {
    id: '1215010009',
    districtId: '1215010',
    name: 'Banuarea',
  },
  {
    id: '1215010010',
    districtId: '1215010',
    name: 'Sijarango',
  },
  {
    id: '1215010011',
    districtId: '1215010',
    name: 'Lumban Tonga Tonga',
  },
  {
    id: '1215010012',
    districtId: '1215010',
    name: 'Rura Tanjung',
  },
  {
    id: '1215010013',
    districtId: '1215010',
    name: 'Rura Aek Sopang',
  },
  {
    id: '1215010014',
    districtId: '1215010',
    name: 'Siambaton',
  },
  {
    id: '1215010015',
    districtId: '1215010',
    name: 'Parmonangan',
  },
  {
    id: '1215010016',
    districtId: '1215010',
    name: 'Ambobi Paranginan',
  },
  {
    id: '1215010017',
    districtId: '1215010',
    name: 'Purba Sianjur',
  },
  {
    id: '1215010018',
    districtId: '1215010',
    name: 'Peadungdung',
  },
  {
    id: '1215010019',
    districtId: '1215010',
    name: 'Sijarango I',
  },
  {
    id: '1215010020',
    districtId: '1215010',
    name: 'Hauagong',
  },
  {
    id: '1215010021',
    districtId: '1215010',
    name: 'Panggugunan',
  },
  {
    id: '1215010022',
    districtId: '1215010',
    name: 'Siambaton Pahae',
  },
  {
    id: '1215020001',
    districtId: '1215020',
    name: 'Aek Godang',
  },
  {
    id: '1215020002',
    districtId: '1215020',
    name: 'Sanggaran II',
  },
  {
    id: '1215020003',
    districtId: '1215020',
    name: 'Janji Nagodang',
  },
  {
    id: '1215020011',
    districtId: '1215020',
    name: 'Huta Julu',
  },
  {
    id: '1215020012',
    districtId: '1215020',
    name: 'Sihikkit',
  },
  {
    id: '1215020013',
    districtId: '1215020',
    name: 'Onan Ganjang',
  },
  {
    id: '1215020014',
    districtId: '1215020',
    name: 'Parbotihan',
  },
  {
    id: '1215020015',
    districtId: '1215020',
    name: 'Batu Nagodang Siatas',
  },
  {
    id: '1215020016',
    districtId: '1215020',
    name: 'Sampetua',
  },
  {
    id: '1215020017',
    districtId: '1215020',
    name: 'Parnapa',
  },
  {
    id: '1215020020',
    districtId: '1215020',
    name: 'Sibuluan',
  },
  {
    id: '1215020021',
    districtId: '1215020',
    name: 'Sigalogo',
  },
  {
    id: '1215030001',
    districtId: '1215030',
    name: 'Sanggaran I',
  },
  {
    id: '1215030002',
    districtId: '1215030',
    name: 'Sitapongan',
  },
  {
    id: '1215030003',
    districtId: '1215030',
    name: 'Sibuntuon',
  },
  {
    id: '1215030004',
    districtId: '1215030',
    name: 'Sigulok',
  },
  {
    id: '1215030005',
    districtId: '1215030',
    name: 'Batunajagar',
  },
  {
    id: '1215030006',
    districtId: '1215030',
    name: 'Bonan Dolok II',
  },
  {
    id: '1215030007',
    districtId: '1215030',
    name: 'Bonan Dolok I',
  },
  {
    id: '1215030008',
    districtId: '1215030',
    name: 'Hutaginjang',
  },
  {
    id: '1215030009',
    districtId: '1215030',
    name: 'Siborboron',
  },
  {
    id: '1215030010',
    districtId: '1215030',
    name: 'Nagurguran',
  },
  {
    id: '1215040001',
    districtId: '1215040',
    name: 'Sosor Tambok',
  },
  {
    id: '1215040002',
    districtId: '1215040',
    name: 'Sihite II',
  },
  {
    id: '1215040003',
    districtId: '1215040',
    name: 'Purba Dolok',
  },
  {
    id: '1215040004',
    districtId: '1215040',
    name: 'Lumban Purba',
  },
  {
    id: '1215040005',
    districtId: '1215040',
    name: 'Simarigung',
  },
  {
    id: '1215040006',
    districtId: '1215040',
    name: 'Saitnihuta',
  },
  {
    id: '1215040007',
    districtId: '1215040',
    name: 'Aek Lung',
  },
  {
    id: '1215040008',
    districtId: '1215040',
    name: 'Purba Manalu',
  },
  {
    id: '1215040009',
    districtId: '1215040',
    name: 'Pakkat',
  },
  {
    id: '1215040010',
    districtId: '1215040',
    name: 'Pasaribu',
  },
  {
    id: '1215040011',
    districtId: '1215040',
    name: 'Lumban Tobing',
  },
  {
    id: '1215040012',
    districtId: '1215040',
    name: 'Pasar Dolok Sanggul',
  },
  {
    id: '1215040013',
    districtId: '1215040',
    name: 'Janji',
  },
  {
    id: '1215040014',
    districtId: '1215040',
    name: 'Sihite I',
  },
  {
    id: '1215040015',
    districtId: '1215040',
    name: 'Huta Bagasan',
  },
  {
    id: '1215040016',
    districtId: '1215040',
    name: 'Matiti II',
  },
  {
    id: '1215040017',
    districtId: '1215040',
    name: 'Matiti I',
  },
  {
    id: '1215040018',
    districtId: '1215040',
    name: 'Huta Gurgur',
  },
  {
    id: '1215040019',
    districtId: '1215040',
    name: 'Sampean',
  },
  {
    id: '1215040020',
    districtId: '1215040',
    name: 'Silaga Laga',
  },
  {
    id: '1215040021',
    districtId: '1215040',
    name: 'Sirisirisi',
  },
  {
    id: '1215040022',
    districtId: '1215040',
    name: 'Bonani Onan',
  },
  {
    id: '1215040023',
    districtId: '1215040',
    name: 'Sileang',
  },
  {
    id: '1215040024',
    districtId: '1215040',
    name: 'Sosor Gonting',
  },
  {
    id: '1215040025',
    districtId: '1215040',
    name: 'Hutaraja',
  },
  {
    id: '1215040026',
    districtId: '1215040',
    name: 'Parik Sinomba',
  },
  {
    id: '1215040027',
    districtId: '1215040',
    name: 'Simangaronsang',
  },
  {
    id: '1215040028',
    districtId: '1215040',
    name: 'Sosortolong Sihite III',
  },
  {
    id: '1215050001',
    districtId: '1215050',
    name: 'Hutasoit I',
  },
  {
    id: '1215050002',
    districtId: '1215050',
    name: 'Lobutua',
  },
  {
    id: '1215050003',
    districtId: '1215050',
    name: 'Pargaulan',
  },
  {
    id: '1215050004',
    districtId: '1215050',
    name: 'Naga Saribu I',
  },
  {
    id: '1215050005',
    districtId: '1215050',
    name: 'Naga Saribu II',
  },
  {
    id: '1215050012',
    districtId: '1215050',
    name: 'Siharjulu',
  },
  {
    id: '1215050013',
    districtId: '1215050',
    name: 'Sibuntuon Parpea',
  },
  {
    id: '1215050015',
    districtId: '1215050',
    name: 'Sibuntuon Partur',
  },
  {
    id: '1215050016',
    districtId: '1215050',
    name: 'Sitolu Bahal',
  },
  {
    id: '1215050017',
    districtId: '1215050',
    name: 'Tapian Nauli',
  },
  {
    id: '1215050018',
    districtId: '1215050',
    name: 'Siponjot',
  },
  {
    id: '1215050019',
    districtId: '1215050',
    name: 'Dolok Margu',
  },
  {
    id: '1215050020',
    districtId: '1215050',
    name: 'Sitio II',
  },
  {
    id: '1215050021',
    districtId: '1215050',
    name: 'Hutasoit II',
  },
  {
    id: '1215050022',
    districtId: '1215050',
    name: 'Bonan Dolok',
  },
  {
    id: '1215050023',
    districtId: '1215050',
    name: 'Sigompul',
  },
  {
    id: '1215050024',
    districtId: '1215050',
    name: 'Nagasaribu IV',
  },
  {
    id: '1215050025',
    districtId: '1215050',
    name: 'Nagasaribu V',
  },
  {
    id: '1215050026',
    districtId: '1215050',
    name: 'Nagasaribu III',
  },
  {
    id: '1215050027',
    districtId: '1215050',
    name: 'Sigumpar',
  },
  {
    id: '1215050028',
    districtId: '1215050',
    name: 'Parulohan',
  },
  {
    id: '1215050029',
    districtId: '1215050',
    name: 'Habeahan',
  },
  {
    id: '1215060001',
    districtId: '1215060',
    name: 'Lumban Sialaman',
  },
  {
    id: '1215060002',
    districtId: '1215060',
    name: 'Paranginan Selatan',
  },
  {
    id: '1215060003',
    districtId: '1215060',
    name: 'Lumban Barat',
  },
  {
    id: '1215060004',
    districtId: '1215060',
    name: 'Lobu Tolong',
  },
  {
    id: '1215060005',
    districtId: '1215060',
    name: 'Sihonongan',
  },
  {
    id: '1215060006',
    districtId: '1215060',
    name: 'Paranginan Utara',
  },
  {
    id: '1215060007',
    districtId: '1215060',
    name: 'Pearung',
  },
  {
    id: '1215060008',
    districtId: '1215060',
    name: 'Siborutorup',
  },
  {
    id: '1215060009',
    districtId: '1215060',
    name: 'Lumban Sianturi',
  },
  {
    id: '1215060010',
    districtId: '1215060',
    name: 'Lobutolong Habinsaran',
  },
  {
    id: '1215060011',
    districtId: '1215060',
    name: 'Pearung Silali',
  },
  {
    id: '1215070001',
    districtId: '1215070',
    name: 'Tipang',
  },
  {
    id: '1215070002',
    districtId: '1215070',
    name: 'Marbun Toruan',
  },
  {
    id: '1215070003',
    districtId: '1215070',
    name: 'Siunong Unong Julu',
  },
  {
    id: '1215070004',
    districtId: '1215070',
    name: 'Simamora',
  },
  {
    id: '1215070005',
    districtId: '1215070',
    name: 'Sinambela',
  },
  {
    id: '1215070006',
    districtId: '1215070',
    name: 'Simangulampe',
  },
  {
    id: '1215070007',
    districtId: '1215070',
    name: 'Marbun Tonga Marbun Dolok',
  },
  {
    id: '1215080001',
    districtId: '1215080',
    name: 'Aek Nauli II',
  },
  {
    id: '1215080003',
    districtId: '1215080',
    name: 'Aek Nauli I',
  },
  {
    id: '1215080004',
    districtId: '1215080',
    name: 'Pandumaan',
  },
  {
    id: '1215080005',
    districtId: '1215080',
    name: 'Sipitu Huta',
  },
  {
    id: '1215080006',
    districtId: '1215080',
    name: 'Parsingguran II',
  },
  {
    id: '1215080007',
    districtId: '1215080',
    name: 'Pollung',
  },
  {
    id: '1215080008',
    districtId: '1215080',
    name: 'Parsingguran I',
  },
  {
    id: '1215080009',
    districtId: '1215080',
    name: 'Ria Ria',
  },
  {
    id: '1215080010',
    districtId: '1215080',
    name: 'Huta Paung',
  },
  {
    id: '1215080011',
    districtId: '1215080',
    name: 'Pansur Batu',
  },
  {
    id: '1215080012',
    districtId: '1215080',
    name: 'Huta Julu',
  },
  {
    id: '1215080013',
    districtId: '1215080',
    name: 'Pardomuan',
  },
  {
    id: '1215080014',
    districtId: '1215080',
    name: 'Hutapaung Utara',
  },
  {
    id: '1215090006',
    districtId: '1215090',
    name: 'Pusuk II Simaninggir',
  },
  {
    id: '1215090007',
    districtId: '1215090',
    name: 'Pusuk I',
  },
  {
    id: '1215090008',
    districtId: '1215090',
    name: 'Baringin',
  },
  {
    id: '1215090009',
    districtId: '1215090',
    name: 'Sihotang Hasugian Tonga',
  },
  {
    id: '1215090010',
    districtId: '1215090',
    name: 'Sionom Hudon Selatan',
  },
  {
    id: '1215090011',
    districtId: '1215090',
    name: 'Sihotang Hasugian Dolok I',
  },
  {
    id: '1215090012',
    districtId: '1215090',
    name: 'Sionom Hudon Timur I',
  },
  {
    id: '1215090013',
    districtId: '1215090',
    name: 'Sionom Hudon Utara',
  },
  {
    id: '1215090014',
    districtId: '1215090',
    name: 'Sionom Hudon Julu',
  },
  {
    id: '1215090015',
    districtId: '1215090',
    name: 'Sionom Hudon Tonga',
  },
  {
    id: '1215090016',
    districtId: '1215090',
    name: 'Sionom Hudon Toruan',
  },
  {
    id: '1215090017',
    districtId: '1215090',
    name: 'Sionom Hudon VII',
  },
  {
    id: '1215090018',
    districtId: '1215090',
    name: 'Simataniari',
  },
  {
    id: '1215090019',
    districtId: '1215090',
    name: 'Sihotang Hasugian Habinsaran',
  },
  {
    id: '1215090020',
    districtId: '1215090',
    name: 'Sihotang Hasugian Dolok II',
  },
  {
    id: '1215090021',
    districtId: '1215090',
    name: 'Sionom Hudon Timur II',
  },
  {
    id: '1215090022',
    districtId: '1215090',
    name: 'Sionom Hudon Sibulbulon',
  },
  {
    id: '1215090023',
    districtId: '1215090',
    name: 'Janji Hutanapa',
  },
  {
    id: '1215090024',
    districtId: '1215090',
    name: 'Baringin Natam',
  },
  {
    id: '1215090025',
    districtId: '1215090',
    name: 'Sionom Hudon Runggu',
  },
  {
    id: '1215100001',
    districtId: '1215100',
    name: 'Sitanduk',
  },
  {
    id: '1215100002',
    districtId: '1215100',
    name: 'Tara Bintang',
  },
  {
    id: '1215100003',
    districtId: '1215100',
    name: 'Sibongkare',
  },
  {
    id: '1215100004',
    districtId: '1215100',
    name: 'Sihombu',
  },
  {
    id: '1215100005',
    districtId: '1215100',
    name: 'Sihotang Hasugian Toruan',
  },
  {
    id: '1215100006',
    districtId: '1215100',
    name: 'Simbara',
  },
  {
    id: '1215100007',
    districtId: '1215100',
    name: 'Mungkur',
  },
  {
    id: '1215100008',
    districtId: '1215100',
    name: 'Sianju',
  },
  {
    id: '1215100009',
    districtId: '1215100',
    name: 'Marpadan',
  },
  {
    id: '1216010001',
    districtId: '1216010',
    name: 'Sibongkaras',
  },
  {
    id: '1216010002',
    districtId: '1216010',
    name: 'Kuta Tinggi',
  },
  {
    id: '1216010003',
    districtId: '1216010',
    name: 'Penanggalen Binanga Boang',
  },
  {
    id: '1216010004',
    districtId: '1216010',
    name: 'Salak I',
  },
  {
    id: '1216010005',
    districtId: '1216010',
    name: 'Salak II',
  },
  {
    id: '1216010006',
    districtId: '1216010',
    name: 'Boang Manalu',
  },
  {
    id: '1216011001',
    districtId: '1216011',
    name: 'Kaban Tengah',
  },
  {
    id: '1216011002',
    districtId: '1216011',
    name: 'Bandar Baru',
  },
  {
    id: '1216011003',
    districtId: '1216011',
    name: 'Tanjung Meriah',
  },
  {
    id: '1216011004',
    districtId: '1216011',
    name: 'Tanjung Mulia',
  },
  {
    id: '1216011005',
    districtId: '1216011',
    name: 'Simberuna',
  },
  {
    id: '1216011006',
    districtId: '1216011',
    name: 'Perolihen',
  },
  {
    id: '1216011007',
    districtId: '1216011',
    name: 'Maholida',
  },
  {
    id: '1216011008',
    districtId: '1216011',
    name: 'Perjaga',
  },
  {
    id: '1216011009',
    districtId: '1216011',
    name: 'Malum',
  },
  {
    id: '1216011010',
    districtId: '1216011',
    name: 'Mbinalun',
  },
  {
    id: '1216012001',
    districtId: '1216012',
    name: 'Sibagindar',
  },
  {
    id: '1216012002',
    districtId: '1216012',
    name: 'Pagindar',
  },
  {
    id: '1216012003',
    districtId: '1216012',
    name: 'Lae Mbentar',
  },
  {
    id: '1216012004',
    districtId: '1216012',
    name: 'Napatalun Perlambukan',
  },
  {
    id: '1216013001',
    districtId: '1216013',
    name: 'Silimakuta',
  },
  {
    id: '1216013002',
    districtId: '1216013',
    name: 'Ulu Merah',
  },
  {
    id: '1216013003',
    districtId: '1216013',
    name: 'Pardomuan',
  },
  {
    id: '1216013004',
    districtId: '1216013',
    name: 'Lae Langge Namuseng',
  },
  {
    id: '1216013005',
    districtId: '1216013',
    name: 'Cikaok',
  },
  {
    id: '1216014001',
    districtId: '1216014',
    name: 'Aornakan I',
  },
  {
    id: '1216014002',
    districtId: '1216014',
    name: 'Aornakan II',
  },
  {
    id: '1216014003',
    districtId: '1216014',
    name: 'Simerpara',
  },
  {
    id: '1216014004',
    districtId: '1216014',
    name: 'Kecupak I',
  },
  {
    id: '1216014005',
    districtId: '1216014',
    name: 'Kecupak II',
  },
  {
    id: '1216020001',
    districtId: '1216020',
    name: 'Majanggut II',
  },
  {
    id: '1216020002',
    districtId: '1216020',
    name: 'Majanggut I',
  },
  {
    id: '1216020003',
    districtId: '1216020',
    name: 'Pardomuan',
  },
  {
    id: '1216020004',
    districtId: '1216020',
    name: 'Parpulungan',
  },
  {
    id: '1216020005',
    districtId: '1216020',
    name: 'Kutasaga',
  },
  {
    id: '1216020006',
    districtId: '1216020',
    name: 'Kutadame',
  },
  {
    id: '1216020007',
    districtId: '1216020',
    name: 'Kuta Meriah',
  },
  {
    id: '1216020008',
    districtId: '1216020',
    name: 'Sukaramai',
  },
  {
    id: '1216020009',
    districtId: '1216020',
    name: 'Surung Mersada',
  },
  {
    id: '1216020010',
    districtId: '1216020',
    name: 'Perduhapen',
  },
  {
    id: '1216021001',
    districtId: '1216021',
    name: 'Mahala',
  },
  {
    id: '1216021002',
    districtId: '1216021',
    name: 'Tinada',
  },
  {
    id: '1216021003',
    districtId: '1216021',
    name: 'Silimakuta',
  },
  {
    id: '1216021004',
    districtId: '1216021',
    name: 'Kuta Babo',
  },
  {
    id: '1216021005',
    districtId: '1216021',
    name: 'Prongil',
  },
  {
    id: '1216021006',
    districtId: '1216021',
    name: 'Buluh Tellang',
  },
  {
    id: '1216022001',
    districtId: '1216022',
    name: 'Siempat Rube I',
  },
  {
    id: '1216022002',
    districtId: '1216022',
    name: 'Siempat Rube II',
  },
  {
    id: '1216022003',
    districtId: '1216022',
    name: 'Mungkur',
  },
  {
    id: '1216022004',
    districtId: '1216022',
    name: 'Siempat Rube IV',
  },
  {
    id: '1216022005',
    districtId: '1216022',
    name: 'Kuta Jungak',
  },
  {
    id: '1216022006',
    districtId: '1216022',
    name: 'Traju',
  },
  {
    id: '1217010001',
    districtId: '1217010',
    name: 'Boho',
  },
  {
    id: '1217010002',
    districtId: '1217010',
    name: 'Aek Sipitudai',
  },
  {
    id: '1217010003',
    districtId: '1217010',
    name: 'Singkam',
  },
  {
    id: '1217010004',
    districtId: '1217010',
    name: 'Sari Marihit',
  },
  {
    id: '1217010005',
    districtId: '1217010',
    name: 'Sianjur Mulamula',
  },
  {
    id: '1217010006',
    districtId: '1217010',
    name: 'Ginolat',
  },
  {
    id: '1217010007',
    districtId: '1217010',
    name: 'Huta Ginjang',
  },
  {
    id: '1217010008',
    districtId: '1217010',
    name: 'Siboro',
  },
  {
    id: '1217010009',
    districtId: '1217010',
    name: 'Huta Gurgur',
  },
  {
    id: '1217010010',
    districtId: '1217010',
    name: 'Bonan Dolok',
  },
  {
    id: '1217010011',
    districtId: '1217010',
    name: 'Hasinggaan',
  },
  {
    id: '1217010012',
    districtId: '1217010',
    name: 'Habeahan Naburahan',
  },
  {
    id: '1217020001',
    districtId: '1217020',
    name: 'Partungko Naginjang',
  },
  {
    id: '1217020004',
    districtId: '1217020',
    name: 'Siparmahan',
  },
  {
    id: '1217020005',
    districtId: '1217020',
    name: 'Dolok Raja',
  },
  {
    id: '1217020006',
    districtId: '1217020',
    name: 'Sampur Toba',
  },
  {
    id: '1217020007',
    districtId: '1217020',
    name: 'Hariara Pohan',
  },
  {
    id: '1217020008',
    districtId: '1217020',
    name: 'Janji Martahan',
  },
  {
    id: '1217020009',
    districtId: '1217020',
    name: 'Turpuk Sihotang',
  },
  {
    id: '1217020010',
    districtId: '1217020',
    name: 'Sosor Dolok',
  },
  {
    id: '1217020011',
    districtId: '1217020',
    name: 'Turpuk Sagala',
  },
  {
    id: '1217020012',
    districtId: '1217020',
    name: 'Turpuk Malau',
  },
  {
    id: '1217020013',
    districtId: '1217020',
    name: 'Turpuk Limbong',
  },
  {
    id: '1217020014',
    districtId: '1217020',
    name: 'Hutagalung',
  },
  {
    id: '1217020015',
    districtId: '1217020',
    name: 'Hariarapintu',
  },
  {
    id: '1217030001',
    districtId: '1217030',
    name: 'Tamba Dolok',
  },
  {
    id: '1217030002',
    districtId: '1217030',
    name: 'Cinta Maju',
  },
  {
    id: '1217030003',
    districtId: '1217030',
    name: 'Buntu Mauli',
  },
  {
    id: '1217030004',
    districtId: '1217030',
    name: 'Sabulan',
  },
  {
    id: '1217030005',
    districtId: '1217030',
    name: 'Holbung',
  },
  {
    id: '1217030006',
    districtId: '1217030',
    name: 'Janji Raja',
  },
  {
    id: '1217030007',
    districtId: '1217030',
    name: 'Janji Maria',
  },
  {
    id: '1217030008',
    districtId: '1217030',
    name: 'Parsaoran',
  },
  {
    id: '1217040001',
    districtId: '1217040',
    name: 'Harian',
  },
  {
    id: '1217040002',
    districtId: '1217040',
    name: 'Sitinjak',
  },
  {
    id: '1217040003',
    districtId: '1217040',
    name: 'Pakpahan',
  },
  {
    id: '1217040004',
    districtId: '1217040',
    name: 'Onan Runggu',
  },
  {
    id: '1217040005',
    districtId: '1217040',
    name: 'Tambun Sungkean',
  },
  {
    id: '1217040006',
    districtId: '1217040',
    name: 'Sitamiang',
  },
  {
    id: '1217040007',
    districtId: '1217040',
    name: 'Pardomuan',
  },
  {
    id: '1217040008',
    districtId: '1217040',
    name: 'Huta Hotang',
  },
  {
    id: '1217040009',
    districtId: '1217040',
    name: 'Rina Bolak',
  },
  {
    id: '1217040010',
    districtId: '1217040',
    name: 'Sipira',
  },
  {
    id: '1217040011',
    districtId: '1217040',
    name: 'Janji Matogu',
  },
  {
    id: '1217040012',
    districtId: '1217040',
    name: 'Silima Lombu',
  },
  {
    id: '1217050001',
    districtId: '1217050',
    name: 'Pasaran Parsaoran',
  },
  {
    id: '1217050002',
    districtId: '1217050',
    name: 'Pasaran I',
  },
  {
    id: '1217050003',
    districtId: '1217050',
    name: 'Sibonor Ompuratus',
  },
  {
    id: '1217050004',
    districtId: '1217050',
    name: 'Sinaga Uruk Pandiangan',
  },
  {
    id: '1217050005',
    districtId: '1217050',
    name: 'Nainggolan',
  },
  {
    id: '1217050006',
    districtId: '1217050',
    name: 'Siruma Hombar',
  },
  {
    id: '1217050007',
    districtId: '1217050',
    name: 'Sipinggan Lumban Siantar',
  },
  {
    id: '1217050008',
    districtId: '1217050',
    name: 'Pangaloan',
  },
  {
    id: '1217050009',
    districtId: '1217050',
    name: 'Toguan Galung',
  },
  {
    id: '1217050010',
    districtId: '1217050',
    name: 'Huta Rihit',
  },
  {
    id: '1217050011',
    districtId: '1217050',
    name: 'Parhusip III',
  },
  {
    id: '1217050012',
    districtId: '1217050',
    name: 'Pananggangan',
  },
  {
    id: '1217050013',
    districtId: '1217050',
    name: 'Janji Marapot',
  },
  {
    id: '1217050014',
    districtId: '1217050',
    name: 'Sipinggan',
  },
  {
    id: '1217050015',
    districtId: '1217050',
    name: 'Pananggangan II',
  },
  {
    id: '1217060005',
    districtId: '1217060',
    name: 'Urat Timur',
  },
  {
    id: '1217060006',
    districtId: '1217060',
    name: 'Suhut Nihuta Pardomuan',
  },
  {
    id: '1217060007',
    districtId: '1217060',
    name: 'Parsaoran Urat',
  },
  {
    id: '1217060008',
    districtId: '1217060',
    name: 'Urat II',
  },
  {
    id: '1217060009',
    districtId: '1217060',
    name: 'Gorat Pallombuan',
  },
  {
    id: '1217060010',
    districtId: '1217060',
    name: 'Palipi',
  },
  {
    id: '1217060011',
    districtId: '1217060',
    name: 'Pardomuan Nauli',
  },
  {
    id: '1217060012',
    districtId: '1217060',
    name: 'Hatoguan',
  },
  {
    id: '1217060013',
    districtId: '1217060',
    name: 'Saor Nauli Hatoguan',
  },
  {
    id: '1217060014',
    districtId: '1217060',
    name: 'Simbolon Purba',
  },
  {
    id: '1217060015',
    districtId: '1217060',
    name: 'Huta Ginjang',
  },
  {
    id: '1217060016',
    districtId: '1217060',
    name: 'Sigaol Marbun',
  },
  {
    id: '1217060017',
    districtId: '1217060',
    name: 'Sigaol Simbolon',
  },
  {
    id: '1217060018',
    districtId: '1217060',
    name: 'Pamutaran',
  },
  {
    id: '1217060019',
    districtId: '1217060',
    name: 'Sideak',
  },
  {
    id: '1217060020',
    districtId: '1217060',
    name: 'Pallombuan',
  },
  {
    id: '1217060021',
    districtId: '1217060',
    name: 'Hutadame',
  },
  {
    id: '1217070001',
    districtId: '1217070',
    name: 'Paraduan',
  },
  {
    id: '1217070002',
    districtId: '1217070',
    name: 'Lintongnihuta',
  },
  {
    id: '1217070003',
    districtId: '1217070',
    name: 'Ronggur Nihuta',
  },
  {
    id: '1217070004',
    districtId: '1217070',
    name: 'Sijambur',
  },
  {
    id: '1217070005',
    districtId: '1217070',
    name: 'Sabungan Nihuta',
  },
  {
    id: '1217070006',
    districtId: '1217070',
    name: 'Salaon Toba',
  },
  {
    id: '1217070007',
    districtId: '1217070',
    name: 'Salaon Tonga Tonga',
  },
  {
    id: '1217070008',
    districtId: '1217070',
    name: 'Salaon Dolok',
  },
  {
    id: '1217080001',
    districtId: '1217080',
    name: 'Rianiate',
  },
  {
    id: '1217080002',
    districtId: '1217080',
    name: 'Parmonangan',
  },
  {
    id: '1217080003',
    districtId: '1217080',
    name: 'Huta Namora',
  },
  {
    id: '1217080009',
    districtId: '1217080',
    name: 'Pintu Sona',
  },
  {
    id: '1217080010',
    districtId: '1217080',
    name: 'Huta Tinggi',
  },
  {
    id: '1217080011',
    districtId: '1217080',
    name: 'Pardomuan I',
  },
  {
    id: '1217080012',
    districtId: '1217080',
    name: 'Pasar Pangururan',
  },
  {
    id: '1217080013',
    districtId: '1217080',
    name: 'Tanjung Bunga',
  },
  {
    id: '1217080014',
    districtId: '1217080',
    name: 'Siogung Ogung',
  },
  {
    id: '1217080015',
    districtId: '1217080',
    name: 'Parsaoran I',
  },
  {
    id: '1217080016',
    districtId: '1217080',
    name: 'Saitnihuta',
  },
  {
    id: '1217080017',
    districtId: '1217080',
    name: 'Lumban Pinggol',
  },
  {
    id: '1217080018',
    districtId: '1217080',
    name: 'Sianting Anting',
  },
  {
    id: '1217080019',
    districtId: '1217080',
    name: 'Parlondut',
  },
  {
    id: '1217080023',
    districtId: '1217080',
    name: 'Aek Nauli',
  },
  {
    id: '1217080024',
    districtId: '1217080',
    name: 'Pardugul',
  },
  {
    id: '1217080025',
    districtId: '1217080',
    name: 'Panampangan',
  },
  {
    id: '1217080026',
    districtId: '1217080',
    name: 'Sitoluhuta',
  },
  {
    id: '1217080027',
    districtId: '1217080',
    name: 'Sinabulan',
  },
  {
    id: '1217080028',
    districtId: '1217080',
    name: 'Siopat Sosor',
  },
  {
    id: '1217080029',
    districtId: '1217080',
    name: 'Huta Bolon',
  },
  {
    id: '1217080030',
    districtId: '1217080',
    name: 'Situngkir',
  },
  {
    id: '1217080031',
    districtId: '1217080',
    name: 'Sialanguan',
  },
  {
    id: '1217080032',
    districtId: '1217080',
    name: 'Parhorasan',
  },
  {
    id: '1217080033',
    districtId: '1217080',
    name: 'Pardomuan Nauli',
  },
  {
    id: '1217080034',
    districtId: '1217080',
    name: 'Lumban Suhi Suhi Dolok',
  },
  {
    id: '1217080035',
    districtId: '1217080',
    name: 'Lumban Suhi Suhi Toruan',
  },
  {
    id: '1217080036',
    districtId: '1217080',
    name: 'Parbaba Dolok',
  },
  {
    id: '1217090001',
    districtId: '1217090',
    name: 'Tanjungan',
  },
  {
    id: '1217090002',
    districtId: '1217090',
    name: 'Parbalohan',
  },
  {
    id: '1217090003',
    districtId: '1217090',
    name: 'Pardomuan',
  },
  {
    id: '1217090004',
    districtId: '1217090',
    name: 'Parmonangan',
  },
  {
    id: '1217090005',
    districtId: '1217090',
    name: 'Huta Ginjang',
  },
  {
    id: '1217090006',
    districtId: '1217090',
    name: 'Tomok',
  },
  {
    id: '1217090007',
    districtId: '1217090',
    name: 'Garoga',
  },
  {
    id: '1217090008',
    districtId: '1217090',
    name: 'Tuktuk Siadong',
  },
  {
    id: '1217090009',
    districtId: '1217090',
    name: 'Ambarita',
  },
  {
    id: '1217090010',
    districtId: '1217090',
    name: 'Martoba',
  },
  {
    id: '1217090011',
    districtId: '1217090',
    name: 'Sihusapi',
  },
  {
    id: '1217090012',
    districtId: '1217090',
    name: 'Maduma',
  },
  {
    id: '1217090013',
    districtId: '1217090',
    name: 'Simanindo Sangkal',
  },
  {
    id: '1217090014',
    districtId: '1217090',
    name: 'Cinta Dame',
  },
  {
    id: '1217090015',
    districtId: '1217090',
    name: 'Simarmata',
  },
  {
    id: '1217090016',
    districtId: '1217090',
    name: 'Dosroha',
  },
  {
    id: '1217090017',
    districtId: '1217090',
    name: 'Tomok Parsaoran',
  },
  {
    id: '1217090018',
    districtId: '1217090',
    name: 'Unjur',
  },
  {
    id: '1217090019',
    districtId: '1217090',
    name: 'Siallagan-Pindaraya',
  },
  {
    id: '1217090020',
    districtId: '1217090',
    name: 'Marlumba',
  },
  {
    id: '1217090021',
    districtId: '1217090',
    name: 'Simanindo',
  },
  {
    id: '1218010001',
    districtId: '1218010',
    name: 'Huta Galuh',
  },
  {
    id: '1218010002',
    districtId: '1218010',
    name: 'Rubun Dunia',
  },
  {
    id: '1218010003',
    districtId: '1218010',
    name: 'Sialtong',
  },
  {
    id: '1218010004',
    districtId: '1218010',
    name: 'Bandar Bayu',
  },
  {
    id: '1218010005',
    districtId: '1218010',
    name: 'Kotarih Baru',
  },
  {
    id: '1218010006',
    districtId: '1218010',
    name: 'Durian Kondot',
  },
  {
    id: '1218010007',
    districtId: '1218010',
    name: 'Kotarih Pekan',
  },
  {
    id: '1218010008',
    districtId: '1218010',
    name: 'Perbahingan',
  },
  {
    id: '1218010009',
    districtId: '1218010',
    name: 'Sei Karih',
  },
  {
    id: '1218010010',
    districtId: '1218010',
    name: 'Banjaran Godang',
  },
  {
    id: '1218010011',
    districtId: '1218010',
    name: 'Sei Ujan-Ujan',
  },
  {
    id: '1218011001',
    districtId: '1218011',
    name: 'Pamah',
  },
  {
    id: '1218011002',
    districtId: '1218011',
    name: 'Tarean',
  },
  {
    id: '1218011003',
    districtId: '1218011',
    name: 'Tapak Meriah',
  },
  {
    id: '1218011004',
    districtId: '1218011',
    name: 'Pagar Manik',
  },
  {
    id: '1218011005',
    districtId: '1218011',
    name: 'Silinda',
  },
  {
    id: '1218011006',
    districtId: '1218011',
    name: 'Damak Gelugur',
  },
  {
    id: '1218011007',
    districtId: '1218011',
    name: 'Kulasar',
  },
  {
    id: '1218011008',
    districtId: '1218011',
    name: 'Sungai Buaya',
  },
  {
    id: '1218011009',
    districtId: '1218011',
    name: 'Batu Masagi',
  },
  {
    id: '1218012001',
    districtId: '1218012',
    name: 'Damak Tolong Buho',
  },
  {
    id: '1218012002',
    districtId: '1218012',
    name: 'Gudang Garam',
  },
  {
    id: '1218012003',
    districtId: '1218012',
    name: 'Dolok Masango',
  },
  {
    id: '1218012004',
    districtId: '1218012',
    name: 'Sarang Giting Hulu',
  },
  {
    id: '1218012005',
    districtId: '1218012',
    name: 'Pegajahan Hulu',
  },
  {
    id: '1218012006',
    districtId: '1218012',
    name: 'Bintang Bayu',
  },
  {
    id: '1218012007',
    districtId: '1218012',
    name: 'Pegajahan Kahan',
  },
  {
    id: '1218012008',
    districtId: '1218012',
    name: 'Siahap',
  },
  {
    id: '1218012009',
    districtId: '1218012',
    name: 'Bandar Magodang',
  },
  {
    id: '1218012010',
    districtId: '1218012',
    name: 'Sarang Giting Kahan',
  },
  {
    id: '1218012011',
    districtId: '1218012',
    name: 'Kampung Kristen',
  },
  {
    id: '1218012012',
    districtId: '1218012',
    name: 'Ujung Negeri Hulu',
  },
  {
    id: '1218012013',
    districtId: '1218012',
    name: 'Ujung Negeri Kahan',
  },
  {
    id: '1218012014',
    districtId: '1218012',
    name: 'Bandar Negeri',
  },
  {
    id: '1218012015',
    districtId: '1218012',
    name: 'Marihat Dolok',
  },
  {
    id: '1218012016',
    districtId: '1218012',
    name: 'Huta Durian',
  },
  {
    id: '1218012017',
    districtId: '1218012',
    name: 'Bandar Pinang Kebun',
  },
  {
    id: '1218012018',
    districtId: '1218012',
    name: 'Bandar Pinang Rambe',
  },
  {
    id: '1218012019',
    districtId: '1218012',
    name: 'Panombean',
  },
  {
    id: '1218020001',
    districtId: '1218020',
    name: 'Pertambatan',
  },
  {
    id: '1218020002',
    districtId: '1218020',
    name: 'Bah Kerapuh',
  },
  {
    id: '1218020003',
    districtId: '1218020',
    name: 'Dolok Sagala',
  },
  {
    id: '1218020004',
    districtId: '1218020',
    name: 'Bukit Cermin Hilir',
  },
  {
    id: '1218020005',
    districtId: '1218020',
    name: 'Tanjung Maria',
  },
  {
    id: '1218020006',
    districtId: '1218020',
    name: 'Ujung Silau',
  },
  {
    id: '1218020007',
    districtId: '1218020',
    name: 'Kerapuh',
  },
  {
    id: '1218020008',
    districtId: '1218020',
    name: 'Sarang Torop',
  },
  {
    id: '1218020009',
    districtId: '1218020',
    name: 'Sarang Ginting',
  },
  {
    id: '1218020010',
    districtId: '1218020',
    name: 'Dolok Manampang',
  },
  {
    id: '1218020011',
    districtId: '1218020',
    name: 'Pekan Dolok Masihul',
  },
  {
    id: '1218020012',
    districtId: '1218020',
    name: 'Aras Panjang',
  },
  {
    id: '1218020013',
    districtId: '1218020',
    name: 'Martebing',
  },
  {
    id: '1218020014',
    districtId: '1218020',
    name: 'Bantan',
  },
  {
    id: '1218020015',
    districtId: '1218020',
    name: 'Batu (12)',
  },
  {
    id: '1218020016',
    districtId: '1218020',
    name: 'Silau Merawan',
  },
  {
    id: '1218020017',
    districtId: '1218020',
    name: 'Batu (13)',
  },
  {
    id: '1218020018',
    districtId: '1218020',
    name: 'Pekan Kemis',
  },
  {
    id: '1218020019',
    districtId: '1218020',
    name: 'Pardomuan',
  },
  {
    id: '1218020020',
    districtId: '1218020',
    name: 'Dame',
  },
  {
    id: '1218020021',
    districtId: '1218020',
    name: 'Tegal Sari',
  },
  {
    id: '1218020022',
    districtId: '1218020',
    name: 'Hevea',
  },
  {
    id: '1218020023',
    districtId: '1218020',
    name: 'Baja Ronggi',
  },
  {
    id: '1218020024',
    districtId: '1218020',
    name: 'Durian Puloan',
  },
  {
    id: '1218020026',
    districtId: '1218020',
    name: 'Kota Tengah',
  },
  {
    id: '1218020027',
    districtId: '1218020',
    name: 'Blok Sepuluh',
  },
  {
    id: '1218020028',
    districtId: '1218020',
    name: 'Huta Nauli',
  },
  {
    id: '1218020029',
    districtId: '1218020',
    name: 'Mala Sori',
  },
  {
    id: '1218021001',
    districtId: '1218021',
    name: 'Kelapa Bajohom',
  },
  {
    id: '1218021002',
    districtId: '1218021',
    name: 'Kuala Bali',
  },
  {
    id: '1218021003',
    districtId: '1218021',
    name: 'Karang Tengah',
  },
  {
    id: '1218021004',
    districtId: '1218021',
    name: 'Tanjung Harap',
  },
  {
    id: '1218021005',
    districtId: '1218021',
    name: 'Manggis',
  },
  {
    id: '1218021006',
    districtId: '1218021',
    name: 'Serbajadi',
  },
  {
    id: '1218021007',
    districtId: '1218021',
    name: 'Bah Sidua Dua',
  },
  {
    id: '1218021008',
    districtId: '1218021',
    name: 'Tambak Cekur',
  },
  {
    id: '1218021009',
    districtId: '1218021',
    name: 'Pulau Tagor',
  },
  {
    id: '1218021010',
    districtId: '1218021',
    name: 'Pulau Gambar',
  },
  {
    id: '1218030001',
    districtId: '1218030',
    name: 'Rimbun',
  },
  {
    id: '1218030002',
    districtId: '1218030',
    name: 'Mariah Nagur',
  },
  {
    id: '1218030003',
    districtId: '1218030',
    name: 'Parlambean',
  },
  {
    id: '1218030004',
    districtId: '1218030',
    name: 'Naga Raja',
  },
  {
    id: '1218030005',
    districtId: '1218030',
    name: 'Tinokkah',
  },
  {
    id: '1218030006',
    districtId: '1218030',
    name: 'Bartong',
  },
  {
    id: '1218030007',
    districtId: '1218030',
    name: 'Nagur Pane',
  },
  {
    id: '1218030008',
    districtId: '1218030',
    name: 'Baja Dolok',
  },
  {
    id: '1218030009',
    districtId: '1218030',
    name: 'Pispis',
  },
  {
    id: '1218030010',
    districtId: '1218030',
    name: 'Marubun',
  },
  {
    id: '1218030011',
    districtId: '1218030',
    name: 'Serbananti',
  },
  {
    id: '1218030012',
    districtId: '1218030',
    name: 'Sipispis',
  },
  {
    id: '1218030013',
    districtId: '1218030',
    name: 'Silau Padang',
  },
  {
    id: '1218030014',
    districtId: '1218030',
    name: 'Marjanji',
  },
  {
    id: '1218030015',
    districtId: '1218030',
    name: 'Buluh Duri',
  },
  {
    id: '1218030016',
    districtId: '1218030',
    name: 'Gunung Manako',
  },
  {
    id: '1218030017',
    districtId: '1218030',
    name: 'Damak Urat',
  },
  {
    id: '1218030018',
    districtId: '1218030',
    name: 'Simalas',
  },
  {
    id: '1218030019',
    districtId: '1218030',
    name: 'Sibarau',
  },
  {
    id: '1218030020',
    districtId: '1218030',
    name: 'Gunung Pane',
  },
  {
    id: '1218040001',
    districtId: '1218040',
    name: 'Nagaraja I',
  },
  {
    id: '1218040002',
    districtId: '1218040',
    name: 'Limbong',
  },
  {
    id: '1218040003',
    districtId: '1218040',
    name: 'Panglong',
  },
  {
    id: '1218040004',
    districtId: '1218040',
    name: 'Gunung Para',
  },
  {
    id: '1218040005',
    districtId: '1218040',
    name: 'Dolok Merawan',
  },
  {
    id: '1218040006',
    districtId: '1218040',
    name: 'Paritokan',
  },
  {
    id: '1218040007',
    districtId: '1218040',
    name: 'Kalembak',
  },
  {
    id: '1218040008',
    districtId: '1218040',
    name: 'Bandarawan',
  },
  {
    id: '1218040009',
    districtId: '1218040',
    name: 'Pabatu VI',
  },
  {
    id: '1218040010',
    districtId: '1218040',
    name: 'Pabatu I',
  },
  {
    id: '1218040011',
    districtId: '1218040',
    name: 'Pabatu II',
  },
  {
    id: '1218040012',
    districtId: '1218040',
    name: 'Mainu Tongah',
  },
  {
    id: '1218040013',
    districtId: '1218040',
    name: 'Afdeling VI Dolok Ilir',
  },
  {
    id: '1218040014',
    districtId: '1218040',
    name: 'Afdeling VII Dolok Ilir',
  },
  {
    id: '1218040015',
    districtId: '1218040',
    name: 'Bah Damar',
  },
  {
    id: '1218040016',
    districtId: '1218040',
    name: 'Pabatu III',
  },
  {
    id: '1218040017',
    districtId: '1218040',
    name: 'Korajim',
  },
  {
    id: '1218050001',
    districtId: '1218050',
    name: 'Naga Kesiangan',
  },
  {
    id: '1218050002',
    districtId: '1218050',
    name: 'Gunung Kataran',
  },
  {
    id: '1218050009',
    districtId: '1218050',
    name: 'Penonggol',
  },
  {
    id: '1218050010',
    districtId: '1218050',
    name: 'Kedai Damar',
  },
  {
    id: '1218050011',
    districtId: '1218050',
    name: 'Bah Sumbu',
  },
  {
    id: '1218050012',
    districtId: '1218050',
    name: 'Jambu',
  },
  {
    id: '1218050013',
    districtId: '1218050',
    name: 'Mariah Padang',
  },
  {
    id: '1218050014',
    districtId: '1218050',
    name: 'Pertapaan',
  },
  {
    id: '1218050015',
    districtId: '1218050',
    name: 'Sei Serimah',
  },
  {
    id: '1218050016',
    districtId: '1218050',
    name: 'Paya Bagas',
  },
  {
    id: '1218050021',
    districtId: '1218050',
    name: 'Kuta Baru',
  },
  {
    id: '1218050022',
    districtId: '1218050',
    name: 'Paya Lombang',
  },
  {
    id: '1218050023',
    districtId: '1218050',
    name: 'Paya Mabar',
  },
  {
    id: '1218050024',
    districtId: '1218050',
    name: 'Sei Periok',
  },
  {
    id: '1218051001',
    districtId: '1218051',
    name: 'Sibulan',
  },
  {
    id: '1218051002',
    districtId: '1218051',
    name: 'Bahilang',
  },
  {
    id: '1218051003',
    districtId: '1218051',
    name: 'Penggalian',
  },
  {
    id: '1218051004',
    districtId: '1218051',
    name: 'Paya Pinang',
  },
  {
    id: '1218051005',
    districtId: '1218051',
    name: 'Laut Tador',
  },
  {
    id: '1218051006',
    districtId: '1218051',
    name: 'Kuta Pinang',
  },
  {
    id: '1218051007',
    districtId: '1218051',
    name: 'Tanah Besih',
  },
  {
    id: '1218051008',
    districtId: '1218051',
    name: 'Paya Pasir',
  },
  {
    id: '1218051009',
    districtId: '1218051',
    name: 'Binjai',
  },
  {
    id: '1218051010',
    districtId: '1218051',
    name: 'Penggalangan',
  },
  {
    id: '1218060001',
    districtId: '1218060',
    name: 'Bandar Tengah',
  },
  {
    id: '1218060002',
    districtId: '1218060',
    name: 'Juhar',
  },
  {
    id: '1218060003',
    districtId: '1218060',
    name: 'Kayu Besar',
  },
  {
    id: '1218060004',
    districtId: '1218060',
    name: 'Pekan Bandar Khalipah',
  },
  {
    id: '1218060005',
    districtId: '1218060',
    name: 'Gelam Sei Serimah',
  },
  {
    id: '1218070001',
    districtId: '1218070',
    name: 'Pematang Terang',
  },
  {
    id: '1218070002',
    districtId: '1218070',
    name: 'Pematang Cermai',
  },
  {
    id: '1218070003',
    districtId: '1218070',
    name: 'Tebing Tinggi',
  },
  {
    id: '1218070004',
    districtId: '1218070',
    name: 'Bagan Kuala',
  },
  {
    id: '1218070005',
    districtId: '1218070',
    name: 'Pekan Tanjung Beringin',
  },
  {
    id: '1218070006',
    districtId: '1218070',
    name: 'Mangga Dua',
  },
  {
    id: '1218070007',
    districtId: '1218070',
    name: 'Nagur',
  },
  {
    id: '1218070008',
    districtId: '1218070',
    name: 'Sukajadi',
  },
  {
    id: '1218080001',
    districtId: '1218080',
    name: 'Rambung Sialang Tengah',
  },
  {
    id: '1218080002',
    districtId: '1218080',
    name: 'Rambung Sialang Hulu',
  },
  {
    id: '1218080003',
    districtId: '1218080',
    name: 'Pergulaan',
  },
  {
    id: '1218080004',
    districtId: '1218080',
    name: 'Sinah Kasih',
  },
  {
    id: '1218080012',
    districtId: '1218080',
    name: 'Sei Parit',
  },
  {
    id: '1218080013',
    districtId: '1218080',
    name: 'Rambung Estate',
  },
  {
    id: '1218080014',
    districtId: '1218080',
    name: 'Rambung Sialang Hilir',
  },
  {
    id: '1218080015',
    districtId: '1218080',
    name: 'Tanah Raja',
  },
  {
    id: '1218080016',
    districtId: '1218080',
    name: 'Simpang Empat',
  },
  {
    id: '1218080017',
    districtId: '1218080',
    name: 'Cempedak Lobang',
  },
  {
    id: '1218080018',
    districtId: '1218080',
    name: 'Silau Rakyat',
  },
  {
    id: '1218080019',
    districtId: '1218080',
    name: 'Pematang Ganjang',
  },
  {
    id: '1218080021',
    districtId: '1218080',
    name: 'Sei Rampah',
  },
  {
    id: '1218080024',
    districtId: '1218080',
    name: 'Sei Rejo',
  },
  {
    id: '1218080025',
    districtId: '1218080',
    name: 'Pematang Pelintahan',
  },
  {
    id: '1218080026',
    districtId: '1218080',
    name: 'Firdaus',
  },
  {
    id: '1218080027',
    districtId: '1218080',
    name: 'Firdaus Estate',
  },
  {
    id: '1218081001',
    districtId: '1218081',
    name: 'Sei Belutu',
  },
  {
    id: '1218081002',
    districtId: '1218081',
    name: 'Gempolan',
  },
  {
    id: '1218081003',
    districtId: '1218081',
    name: 'Bakaran Batu',
  },
  {
    id: '1218081004',
    districtId: '1218081',
    name: 'Suka Damai',
  },
  {
    id: '1218081005',
    districtId: '1218081',
    name: 'Sei Bamban Estate',
  },
  {
    id: '1218081006',
    districtId: '1218081',
    name: 'Sei Buluh',
  },
  {
    id: '1218081007',
    districtId: '1218081',
    name: 'Sei Bamban',
  },
  {
    id: '1218081008',
    districtId: '1218081',
    name: 'Penggalangan',
  },
  {
    id: '1218081009',
    districtId: '1218081',
    name: 'Pon',
  },
  {
    id: '1218081010',
    districtId: '1218081',
    name: 'Rampah Estate',
  },
  {
    id: '1218090001',
    districtId: '1218090',
    name: 'Sei Buluh',
  },
  {
    id: '1218090002',
    districtId: '1218090',
    name: 'Liberia',
  },
  {
    id: '1218090003',
    districtId: '1218090',
    name: 'Pematang Seterak',
  },
  {
    id: '1218090004',
    districtId: '1218090',
    name: 'Matapao',
  },
  {
    id: '1218090005',
    districtId: '1218090',
    name: 'Makmur',
  },
  {
    id: '1218090006',
    districtId: '1218090',
    name: 'Pasar Baru',
  },
  {
    id: '1218090007',
    districtId: '1218090',
    name: 'Pekan Sialang Buah',
  },
  {
    id: '1218090008',
    districtId: '1218090',
    name: 'Sialang Buah',
  },
  {
    id: '1218090009',
    districtId: '1218090',
    name: 'Pematang Guntung',
  },
  {
    id: '1218090010',
    districtId: '1218090',
    name: 'Sentang',
  },
  {
    id: '1218090011',
    districtId: '1218090',
    name: 'Bogak Besar',
  },
  {
    id: '1218090012',
    districtId: '1218090',
    name: 'Pematang Kuala',
  },
  {
    id: '1218100010',
    districtId: '1218100',
    name: 'Adolina',
  },
  {
    id: '1218100011',
    districtId: '1218100',
    name: 'Melati Dua',
  },
  {
    id: '1218100013',
    districtId: '1218100',
    name: 'Tanjung Buluh',
  },
  {
    id: '1218100014',
    districtId: '1218100',
    name: 'Sei Buluh',
  },
  {
    id: '1218100015',
    districtId: '1218100',
    name: 'Sei Sijenggi',
  },
  {
    id: '1218100016',
    districtId: '1218100',
    name: 'Deli Muda Hulu',
  },
  {
    id: '1218100020',
    districtId: '1218100',
    name: 'Melati Satu',
  },
  {
    id: '1218100021',
    districtId: '1218100',
    name: 'Citaman Jernih',
  },
  {
    id: '1218100022',
    districtId: '1218100',
    name: 'Batang Terab',
  },
  {
    id: '1218100023',
    districtId: '1218100',
    name: 'Simpang Tiga Pekan',
  },
  {
    id: '1218100024',
    districtId: '1218100',
    name: 'Kota Galuh',
  },
  {
    id: '1218100025',
    districtId: '1218100',
    name: 'Tualang',
  },
  {
    id: '1218100026',
    districtId: '1218100',
    name: 'Bengkel',
  },
  {
    id: '1218100027',
    districtId: '1218100',
    name: 'Deli Muda Hilir',
  },
  {
    id: '1218100028',
    districtId: '1218100',
    name: 'Tanah Merah',
  },
  {
    id: '1218100029',
    districtId: '1218100',
    name: 'Lubuk Bayas',
  },
  {
    id: '1218100030',
    districtId: '1218100',
    name: 'Sei Naga Lawan',
  },
  {
    id: '1218100031',
    districtId: '1218100',
    name: 'Lubuk Rotan',
  },
  {
    id: '1218100032',
    districtId: '1218100',
    name: 'Kesatuan',
  },
  {
    id: '1218100033',
    districtId: '1218100',
    name: 'Lidah Tanah',
  },
  {
    id: '1218100034',
    districtId: '1218100',
    name: 'Pematang Tatal',
  },
  {
    id: '1218100035',
    districtId: '1218100',
    name: 'Lubuk Dendang',
  },
  {
    id: '1218100036',
    districtId: '1218100',
    name: 'Suka Beras',
  },
  {
    id: '1218100037',
    districtId: '1218100',
    name: 'Cinta Air',
  },
  {
    id: '1218100038',
    districtId: '1218100',
    name: 'Pematang Sijonam',
  },
  {
    id: '1218100039',
    districtId: '1218100',
    name: 'Lubuk Cemara',
  },
  {
    id: '1218100040',
    districtId: '1218100',
    name: 'Jambur Pulau',
  },
  {
    id: '1218100041',
    districtId: '1218100',
    name: 'Suka Jadi',
  },
  {
    id: '1218101001',
    districtId: '1218101',
    name: 'Tanjung Putus',
  },
  {
    id: '1218101002',
    districtId: '1218101',
    name: 'Sennah',
  },
  {
    id: '1218101003',
    districtId: '1218101',
    name: 'Pondok Tengah',
  },
  {
    id: '1218101004',
    districtId: '1218101',
    name: 'Sukasari',
  },
  {
    id: '1218101005',
    districtId: '1218101',
    name: 'Bingkat',
  },
  {
    id: '1218101006',
    districtId: '1218101',
    name: 'Pegajahan',
  },
  {
    id: '1218101007',
    districtId: '1218101',
    name: 'Melati Kebun',
  },
  {
    id: '1218101008',
    districtId: '1218101',
    name: 'Petuaran Hulu',
  },
  {
    id: '1218101009',
    districtId: '1218101',
    name: 'Petuaran Hilir',
  },
  {
    id: '1218101010',
    districtId: '1218101',
    name: 'Lestari Dadi',
  },
  {
    id: '1218101011',
    districtId: '1218101',
    name: 'Bengabing',
  },
  {
    id: '1218101012',
    districtId: '1218101',
    name: 'Jati Mulyo',
  },
  {
    id: '1218101013',
    districtId: '1218101',
    name: 'Karang Anyar',
  },
  {
    id: '1218110001',
    districtId: '1218110',
    name: 'Ujung Rambung',
  },
  {
    id: '1218110002',
    districtId: '1218110',
    name: 'Celawan',
  },
  {
    id: '1218110003',
    districtId: '1218110',
    name: 'Besar 2 Terjun',
  },
  {
    id: '1218110004',
    districtId: '1218110',
    name: 'Sementara',
  },
  {
    id: '1218110005',
    districtId: '1218110',
    name: 'Ara Payung',
  },
  {
    id: '1218110006',
    districtId: '1218110',
    name: 'Pematang Kasih',
  },
  {
    id: '1218110007',
    districtId: '1218110',
    name: 'Naga Kisar',
  },
  {
    id: '1218110008',
    districtId: '1218110',
    name: 'Lubuk Saban',
  },
  {
    id: '1218110009',
    districtId: '1218110',
    name: 'Kuala Lama',
  },
  {
    id: '1218110010',
    districtId: '1218110',
    name: 'Pantai Cermin Kiri',
  },
  {
    id: '1218110011',
    districtId: '1218110',
    name: 'Pantai Cermin Kanan',
  },
  {
    id: '1218110012',
    districtId: '1218110',
    name: 'Kota Pari',
  },
  {
    id: '1219010002',
    districtId: '1219010',
    name: 'Perkebunan Sei Balai',
  },
  {
    id: '1219010003',
    districtId: '1219010',
    name: 'Suka Ramai',
  },
  {
    id: '1219010004',
    districtId: '1219010',
    name: 'Sei Bejangkar',
  },
  {
    id: '1219010005',
    districtId: '1219010',
    name: 'Perkebunan Sei Bejangkar',
  },
  {
    id: '1219010006',
    districtId: '1219010',
    name: 'Sei Balai',
  },
  {
    id: '1219010007',
    districtId: '1219010',
    name: 'Mekar Mulio',
  },
  {
    id: '1219010008',
    districtId: '1219010',
    name: 'Kwala Sikasim',
  },
  {
    id: '1219010010',
    districtId: '1219010',
    name: 'Durian',
  },
  {
    id: '1219010011',
    districtId: '1219010',
    name: 'Perjuangan',
  },
  {
    id: '1219010012',
    districtId: '1219010',
    name: 'Suko Rejo',
  },
  {
    id: '1219010013',
    districtId: '1219010',
    name: 'Benteng Jaya',
  },
  {
    id: '1219010014',
    districtId: '1219010',
    name: 'Tanah Timbul',
  },
  {
    id: '1219010015',
    districtId: '1219010',
    name: 'Sidomulio',
  },
  {
    id: '1219010016',
    districtId: '1219010',
    name: 'Mekar Baru',
  },
  {
    id: '1219020018',
    districtId: '1219020',
    name: 'Guntung',
  },
  {
    id: '1219020019',
    districtId: '1219020',
    name: 'Bagan Dalam',
  },
  {
    id: '1219020020',
    districtId: '1219020',
    name: 'Suka Maju',
  },
  {
    id: '1219020021',
    districtId: '1219020',
    name: 'Tanjung Tiram',
  },
  {
    id: '1219020022',
    districtId: '1219020',
    name: 'Bogak',
  },
  {
    id: '1219020029',
    districtId: '1219020',
    name: 'Suka Jaya',
  },
  {
    id: '1219020030',
    districtId: '1219020',
    name: 'Kampung Lalang',
  },
  {
    id: '1219020031',
    districtId: '1219020',
    name: 'Bagan Arya',
  },
  {
    id: '1219020032',
    districtId: '1219020',
    name: 'Pahlawan',
  },
  {
    id: '1219020033',
    districtId: '1219020',
    name: 'Bandar Rahmad',
  },
  {
    id: '1219021001',
    districtId: '1219021',
    name: 'Tanjung Mulia',
  },
  {
    id: '1219021002',
    districtId: '1219021',
    name: 'Sungai Mentaram',
  },
  {
    id: '1219021003',
    districtId: '1219021',
    name: 'Pematang Rambai',
  },
  {
    id: '1219021004',
    districtId: '1219021',
    name: 'Bagan Baru',
  },
  {
    id: '1219021005',
    districtId: '1219021',
    name: 'Ujung Kubu',
  },
  {
    id: '1219021006',
    districtId: '1219021',
    name: 'Lima Laras',
  },
  {
    id: '1219021007',
    districtId: '1219021',
    name: 'Sentang',
  },
  {
    id: '1219021008',
    districtId: '1219021',
    name: 'Jati Mulia',
  },
  {
    id: '1219021009',
    districtId: '1219021',
    name: 'Tali Air Permai',
  },
  {
    id: '1219021010',
    districtId: '1219021',
    name: 'Kapal Merah',
  },
  {
    id: '1219021011',
    districtId: '1219021',
    name: 'Bandar Sono',
  },
  {
    id: '1219021012',
    districtId: '1219021',
    name: 'Mekar Laras',
  },
  {
    id: '1219030008',
    districtId: '1219030',
    name: 'Panjang',
  },
  {
    id: '1219030009',
    districtId: '1219030',
    name: 'Pahang',
  },
  {
    id: '1219030010',
    districtId: '1219030',
    name: 'Padang Genting',
  },
  {
    id: '1219030011',
    districtId: '1219030',
    name: 'Labuhan Ruku',
  },
  {
    id: '1219030012',
    districtId: '1219030',
    name: 'Mesjid Lama',
  },
  {
    id: '1219030013',
    districtId: '1219030',
    name: 'Dahari Selebar',
  },
  {
    id: '1219030017',
    districtId: '1219030',
    name: 'Gunung Rante',
  },
  {
    id: '1219030018',
    districtId: '1219030',
    name: 'Benteng',
  },
  {
    id: '1219030019',
    districtId: '1219030',
    name: 'Indra Yaman',
  },
  {
    id: '1219030020',
    districtId: '1219030',
    name: 'Dahari Indah',
  },
  {
    id: '1219031001',
    districtId: '1219031',
    name: 'Petatal',
  },
  {
    id: '1219031002',
    districtId: '1219031',
    name: 'Perkebunan Tanah Datar',
  },
  {
    id: '1219031003',
    districtId: '1219031',
    name: 'Karang Baru',
  },
  {
    id: '1219031004',
    districtId: '1219031',
    name: 'Bangun Sari',
  },
  {
    id: '1219031005',
    districtId: '1219031',
    name: 'Binjei Baru',
  },
  {
    id: '1219031006',
    districtId: '1219031',
    name: 'Sei Muka',
  },
  {
    id: '1219031007',
    districtId: '1219031',
    name: 'Perkebunan Petatal',
  },
  {
    id: '1219031008',
    districtId: '1219031',
    name: 'Glugur Makmur',
  },
  {
    id: '1219031009',
    districtId: '1219031',
    name: 'Mekar Baru',
  },
  {
    id: '1219031010',
    districtId: '1219031',
    name: 'Sumber Tani',
  },
  {
    id: '1219040001',
    districtId: '1219040',
    name: 'Mangkai Baru',
  },
  {
    id: '1219040002',
    districtId: '1219040',
    name: 'Mangkai Lama',
  },
  {
    id: '1219040003',
    districtId: '1219040',
    name: 'Lima Puluh Kota',
  },
  {
    id: '1219040004',
    districtId: '1219040',
    name: 'Perkebunan Dolok',
  },
  {
    id: '1219040005',
    districtId: '1219040',
    name: 'Sumber Padi',
  },
  {
    id: '1219040006',
    districtId: '1219040',
    name: 'Perkebunan Limau Manis',
  },
  {
    id: '1219040007',
    districtId: '1219040',
    name: 'Antara',
  },
  {
    id: '1219040008',
    districtId: '1219040',
    name: 'Perkebunan Kwala Gunung',
  },
  {
    id: '1219040013',
    districtId: '1219040',
    name: 'Perkebunan  Lima Puluh',
  },
  {
    id: '1219040014',
    districtId: '1219040',
    name: 'Sumber Makmur',
  },
  {
    id: '1219040015',
    districtId: '1219040',
    name: 'Perkebunan Tanah Gambus',
  },
  {
    id: '1219040027',
    districtId: '1219040',
    name: 'Simpang Gambus',
  },
  {
    id: '1219041001',
    districtId: '1219041',
    name: 'Guntung',
  },
  {
    id: '1219041002',
    districtId: '1219041',
    name: 'Pematang Panjang',
  },
  {
    id: '1219041003',
    districtId: '1219041',
    name: 'Bulan-Bulan',
  },
  {
    id: '1219041004',
    districtId: '1219041',
    name: 'Perupuk',
  },
  {
    id: '1219041005',
    districtId: '1219041',
    name: 'Gambus Laut',
  },
  {
    id: '1219041006',
    districtId: '1219041',
    name: 'Lubuk Cuik',
  },
  {
    id: '1219041007',
    districtId: '1219041',
    name: 'Tanah Itam Hilir',
  },
  {
    id: '1219041008',
    districtId: '1219041',
    name: 'Barung-Barung',
  },
  {
    id: '1219041009',
    districtId: '1219041',
    name: 'Pasir Permit',
  },
  {
    id: '1219041010',
    districtId: '1219041',
    name: 'Titi Putih',
  },
  {
    id: '1219041011',
    districtId: '1219041',
    name: 'Gunung Bandung',
  },
  {
    id: '1219041012',
    districtId: '1219041',
    name: 'Titi Merah',
  },
  {
    id: '1219041013',
    districtId: '1219041',
    name: 'Pematang Tengah',
  },
  {
    id: '1219042001',
    districtId: '1219042',
    name: 'Kwala Gunung',
  },
  {
    id: '1219042002',
    districtId: '1219042',
    name: 'Cahaya Pardomuan',
  },
  {
    id: '1219042003',
    districtId: '1219042',
    name: 'Simpang Dolok',
  },
  {
    id: '1219042004',
    districtId: '1219042',
    name: 'Empat Negeri',
  },
  {
    id: '1219042005',
    districtId: '1219042',
    name: 'Perkebunan Tanah Itam Ulu',
  },
  {
    id: '1219042006',
    districtId: '1219042',
    name: 'Lubuk Besar',
  },
  {
    id: '1219042007',
    districtId: '1219042',
    name: 'Pulau Sejuk',
  },
  {
    id: '1219042008',
    districtId: '1219042',
    name: 'Air Hitam',
  },
  {
    id: '1219042009',
    districtId: '1219042',
    name: 'Sumber Rejo',
  },
  {
    id: '1219042010',
    districtId: '1219042',
    name: 'Lubuk Hulu',
  },
  {
    id: '1219050008',
    districtId: '1219050',
    name: 'Sipare-Pare',
  },
  {
    id: '1219050009',
    districtId: '1219050',
    name: 'Pasar Lapan',
  },
  {
    id: '1219050010',
    districtId: '1219050',
    name: 'Indrapura',
  },
  {
    id: '1219050011',
    districtId: '1219050',
    name: 'Tanah Merah',
  },
  {
    id: '1219050012',
    districtId: '1219050',
    name: 'Tanjung Muda',
  },
  {
    id: '1219050013',
    districtId: '1219050',
    name: 'Tanah Tinggi',
  },
  {
    id: '1219050014',
    districtId: '1219050',
    name: 'Sukaraja',
  },
  {
    id: '1219050015',
    districtId: '1219050',
    name: 'Pematang Panjang',
  },
  {
    id: '1219050016',
    districtId: '1219050',
    name: 'Aras',
  },
  {
    id: '1219050017',
    districtId: '1219050',
    name: 'Limau Sundai',
  },
  {
    id: '1219050021',
    districtId: '1219050',
    name: 'Tanjung Harapan',
  },
  {
    id: '1219050022',
    districtId: '1219050',
    name: 'Tanjung Kubah',
  },
  {
    id: '1219050023',
    districtId: '1219050',
    name: 'Suka Ramai',
  },
  {
    id: '1219050024',
    districtId: '1219050',
    name: 'Titi Payung',
  },
  {
    id: '1219050025',
    districtId: '1219050',
    name: 'Perkotaan',
  },
  {
    id: '1219050026',
    districtId: '1219050',
    name: 'Indrasakti',
  },
  {
    id: '1219050027',
    districtId: '1219050',
    name: 'Tanah Rendah',
  },
  {
    id: '1219050028',
    districtId: '1219050',
    name: 'Kampung Kelapa',
  },
  {
    id: '1219050029',
    districtId: '1219050',
    name: 'Tanjung Mulia',
  },
  {
    id: '1219060007',
    districtId: '1219060',
    name: 'Sei Suka/Deras',
  },
  {
    id: '1219060008',
    districtId: '1219060',
    name: 'Perkebunan Sipare-Pare',
  },
  {
    id: '1219060009',
    districtId: '1219060',
    name: 'Simodong',
  },
  {
    id: '1219060010',
    districtId: '1219060',
    name: 'Pematang Jering',
  },
  {
    id: '1219060011',
    districtId: '1219060',
    name: 'Pematang Kuing',
  },
  {
    id: '1219060012',
    districtId: '1219060',
    name: 'Kwala Tanjung',
  },
  {
    id: '1219060013',
    districtId: '1219060',
    name: 'Kwala Indah',
  },
  {
    id: '1219060018',
    districtId: '1219060',
    name: 'Tanjung Gading',
  },
  {
    id: '1219060019',
    districtId: '1219060',
    name: 'Simpang Kopi',
  },
  {
    id: '1219060020',
    districtId: '1219060',
    name: 'Brohol',
  },
  {
    id: '1219061001',
    districtId: '1219061',
    name: 'Tanjung Prapat',
  },
  {
    id: '1219061002',
    districtId: '1219061',
    name: 'Laut Tador',
  },
  {
    id: '1219061003',
    districtId: '1219061',
    name: 'Perkebunan Tanjung Kasau',
  },
  {
    id: '1219061004',
    districtId: '1219061',
    name: 'Tanjung Kasau',
  },
  {
    id: '1219061005',
    districtId: '1219061',
    name: 'Tanjung Seri',
  },
  {
    id: '1219061006',
    districtId: '1219061',
    name: 'Sei Simujur',
  },
  {
    id: '1219061007',
    districtId: '1219061',
    name: 'Pelanggiran Laut Tador',
  },
  {
    id: '1219061008',
    districtId: '1219061',
    name: 'Dwi Sri',
  },
  {
    id: '1219061009',
    districtId: '1219061',
    name: 'Mekar Sari',
  },
  {
    id: '1219061010',
    districtId: '1219061',
    name: 'Kandangan',
  },
  {
    id: '1219070001',
    districtId: '1219070',
    name: 'Sido Mulyo',
  },
  {
    id: '1219070002',
    districtId: '1219070',
    name: 'Aek Nauli',
  },
  {
    id: '1219070003',
    districtId: '1219070',
    name: 'Sei Buah Keras',
  },
  {
    id: '1219070004',
    districtId: '1219070',
    name: 'Sei Rakyat',
  },
  {
    id: '1219070005',
    districtId: '1219070',
    name: 'Tanjung Sigoni',
  },
  {
    id: '1219070006',
    districtId: '1219070',
    name: 'Pematang Cengkring',
  },
  {
    id: '1219070007',
    districtId: '1219070',
    name: 'Pakam Raya',
  },
  {
    id: '1219070008',
    districtId: '1219070',
    name: 'Pakam',
  },
  {
    id: '1219070009',
    districtId: '1219070',
    name: 'Lalang',
  },
  {
    id: '1219070010',
    districtId: '1219070',
    name: 'Medang',
  },
  {
    id: '1219070011',
    districtId: '1219070',
    name: 'Durian',
  },
  {
    id: '1219070012',
    districtId: '1219070',
    name: 'Nenas Siam',
  },
  {
    id: '1219070013',
    districtId: '1219070',
    name: 'Pangkalan Dodek Baru',
  },
  {
    id: '1219070014',
    districtId: '1219070',
    name: 'Pangkalan Dodek',
  },
  {
    id: '1219070015',
    districtId: '1219070',
    name: 'Sei Raja',
  },
  {
    id: '1219070016',
    districtId: '1219070',
    name: 'Cengkering Pekan',
  },
  {
    id: '1219070017',
    districtId: '1219070',
    name: 'Pakam Raya Selatan',
  },
  {
    id: '1219070018',
    districtId: '1219070',
    name: 'Mandarsah',
  },
  {
    id: '1219070019',
    districtId: '1219070',
    name: 'Medang Baru',
  },
  {
    id: '1219070020',
    districtId: '1219070',
    name: 'Pematang Nibung',
  },
  {
    id: '1219070021',
    districtId: '1219070',
    name: 'Pagurawan',
  },
  {
    id: '1220010001',
    districtId: '1220010',
    name: 'Pangkal Dolok Lama',
  },
  {
    id: '1220010002',
    districtId: '1220010',
    name: 'Pangkalan Dolok Julu',
  },
  {
    id: '1220010003',
    districtId: '1220010',
    name: 'Batang Onang Baru',
  },
  {
    id: '1220010004',
    districtId: '1220010',
    name: 'Bonan Dolok',
  },
  {
    id: '1220010005',
    districtId: '1220010',
    name: 'Batang Onang Lama',
  },
  {
    id: '1220010006',
    districtId: '1220010',
    name: 'Pintu Padang',
  },
  {
    id: '1220010007',
    districtId: '1220010',
    name: 'Galanggang',
  },
  {
    id: '1220010008',
    districtId: '1220010',
    name: 'Huta Lambung',
  },
  {
    id: '1220010009',
    districtId: '1220010',
    name: 'Gunung Tua Batang Onang',
  },
  {
    id: '1220010010',
    districtId: '1220010',
    name: 'Simanapang',
  },
  {
    id: '1220010011',
    districtId: '1220010',
    name: 'Simaninggir Psm',
  },
  {
    id: '1220010012',
    districtId: '1220010',
    name: 'Batu Mamak',
  },
  {
    id: '1220010013',
    districtId: '1220010',
    name: 'Padang Garugur',
  },
  {
    id: '1220010014',
    districtId: '1220010',
    name: 'Gunung Tua Tumbu Jati',
  },
  {
    id: '1220010015',
    districtId: '1220010',
    name: 'Batu Pulut',
  },
  {
    id: '1220010016',
    districtId: '1220010',
    name: 'Gunung Tua Julu',
  },
  {
    id: '1220010017',
    districtId: '1220010',
    name: 'Pasar Matanggor',
  },
  {
    id: '1220010018',
    districtId: '1220010',
    name: 'Padang Matinggi',
  },
  {
    id: '1220010019',
    districtId: '1220010',
    name: 'Sayur Matinggi',
  },
  {
    id: '1220010020',
    districtId: '1220010',
    name: 'Janji Mauli',
  },
  {
    id: '1220010021',
    districtId: '1220010',
    name: 'Simardona',
  },
  {
    id: '1220010022',
    districtId: '1220010',
    name: 'Sayur Matinggi Julu',
  },
  {
    id: '1220010023',
    districtId: '1220010',
    name: 'Purba Tua',
  },
  {
    id: '1220010024',
    districtId: '1220010',
    name: 'Parau Sorat',
  },
  {
    id: '1220010025',
    districtId: '1220010',
    name: 'Pasir Ampulo Hopong',
  },
  {
    id: '1220010026',
    districtId: '1220010',
    name: 'Tamosu',
  },
  {
    id: '1220010027',
    districtId: '1220010',
    name: 'Pagaran Batu',
  },
  {
    id: '1220010028',
    districtId: '1220010',
    name: 'Simangambat Dolok',
  },
  {
    id: '1220010029',
    districtId: '1220010',
    name: 'Padang Bujur Baru',
  },
  {
    id: '1220010030',
    districtId: '1220010',
    name: 'Janji Manahan',
  },
  {
    id: '1220010031',
    districtId: '1220010',
    name: 'Batu Nanggar',
  },
  {
    id: '1220010032',
    districtId: '1220010',
    name: 'Morang',
  },
  {
    id: '1220020001',
    districtId: '1220020',
    name: 'Aek Bargot',
  },
  {
    id: '1220020002',
    districtId: '1220020',
    name: 'Pamuntaran',
  },
  {
    id: '1220020003',
    districtId: '1220020',
    name: 'Balimbing Julu',
  },
  {
    id: '1220020004',
    districtId: '1220020',
    name: 'Balimbing Jae',
  },
  {
    id: '1220020005',
    districtId: '1220020',
    name: 'Sobar',
  },
  {
    id: '1220020006',
    districtId: '1220020',
    name: 'Sipupus Lombang',
  },
  {
    id: '1220020007',
    districtId: '1220020',
    name: 'Padang Bujur',
  },
  {
    id: '1220020008',
    districtId: '1220020',
    name: 'Paran Gadung',
  },
  {
    id: '1220020009',
    districtId: '1220020',
    name: 'Padang Baruas',
  },
  {
    id: '1220020010',
    districtId: '1220020',
    name: 'Ubar',
  },
  {
    id: '1220020011',
    districtId: '1220020',
    name: 'Balakka',
  },
  {
    id: '1220020012',
    districtId: '1220020',
    name: 'Gariang',
  },
  {
    id: '1220020013',
    districtId: '1220020',
    name: 'Lantosan II',
  },
  {
    id: '1220020014',
    districtId: '1220020',
    name: 'Batu Gana',
  },
  {
    id: '1220020015',
    districtId: '1220020',
    name: 'Parupuk Jae',
  },
  {
    id: '1220020016',
    districtId: '1220020',
    name: 'Parupuk Julu',
  },
  {
    id: '1220020017',
    districtId: '1220020',
    name: 'Pancur Pangko',
  },
  {
    id: '1220020018',
    districtId: '1220020',
    name: 'Paran Nangka',
  },
  {
    id: '1220020019',
    districtId: '1220020',
    name: 'Hasambi',
  },
  {
    id: '1220020020',
    districtId: '1220020',
    name: 'Sialang',
  },
  {
    id: '1220020021',
    districtId: '1220020',
    name: 'Batu Rancang',
  },
  {
    id: '1220020022',
    districtId: '1220020',
    name: 'Siunggam Dolok',
  },
  {
    id: '1220020023',
    districtId: '1220020',
    name: 'Sitanggoru',
  },
  {
    id: '1220030004',
    districtId: '1220030',
    name: 'Gumarupu Lama',
  },
  {
    id: '1220030005',
    districtId: '1220030',
    name: 'Aek Siala',
  },
  {
    id: '1220030006',
    districtId: '1220030',
    name: 'Padang Manjoir',
  },
  {
    id: '1220030007',
    districtId: '1220030',
    name: 'Gunung Martua',
  },
  {
    id: '1220030008',
    districtId: '1220030',
    name: 'Sihambeng',
  },
  {
    id: '1220030009',
    districtId: '1220030',
    name: 'Aek Torop',
  },
  {
    id: '1220030016',
    districtId: '1220030',
    name: 'Torluk Muara Dolok',
  },
  {
    id: '1220030019',
    districtId: '1220030',
    name: 'Napalombang',
  },
  {
    id: '1220030020',
    districtId: '1220030',
    name: 'Hotang Sasa',
  },
  {
    id: '1220030021',
    districtId: '1220030',
    name: 'Bara',
  },
  {
    id: '1220030022',
    districtId: '1220030',
    name: 'Simandiangin',
  },
  {
    id: '1220030023',
    districtId: '1220030',
    name: 'Bahal',
  },
  {
    id: '1220030024',
    districtId: '1220030',
    name: 'Pasir Pinang',
  },
  {
    id: '1220030025',
    districtId: '1220030',
    name: 'Portibi Jae',
  },
  {
    id: '1220030026',
    districtId: '1220030',
    name: 'Portibi Julu',
  },
  {
    id: '1220030027',
    districtId: '1220030',
    name: 'Gumarupu Baru',
  },
  {
    id: '1220030028',
    districtId: '1220030',
    name: 'Balakka Torop',
  },
  {
    id: '1220030029',
    districtId: '1220030',
    name: 'Napahalas',
  },
  {
    id: '1220030030',
    districtId: '1220030',
    name: 'Sigama Napahalas',
  },
  {
    id: '1220030032',
    districtId: '1220030',
    name: 'Mangaledang Lama',
  },
  {
    id: '1220030033',
    districtId: '1220030',
    name: 'Janji Matogu',
  },
  {
    id: '1220030045',
    districtId: '1220030',
    name: 'Mangaledang',
  },
  {
    id: '1220030046',
    districtId: '1220030',
    name: 'Bakkudu',
  },
  {
    id: '1220030047',
    districtId: '1220030',
    name: 'Muara Sigama',
  },
  {
    id: '1220030048',
    districtId: '1220030',
    name: 'Rondaman Dolok',
  },
  {
    id: '1220030049',
    districtId: '1220030',
    name: 'Tanjung Selamat',
  },
  {
    id: '1220030050',
    districtId: '1220030',
    name: 'Aloban',
  },
  {
    id: '1220030051',
    districtId: '1220030',
    name: 'Rondaman Lombang',
  },
  {
    id: '1220030052',
    districtId: '1220030',
    name: 'Sipirok',
  },
  {
    id: '1220030053',
    districtId: '1220030',
    name: 'Parsarmaan',
  },
  {
    id: '1220030054',
    districtId: '1220030',
    name: 'Hadungdung',
  },
  {
    id: '1220030055',
    districtId: '1220030',
    name: 'Gunung Manaon I',
  },
  {
    id: '1220030056',
    districtId: '1220030',
    name: 'Gunung Baringin',
  },
  {
    id: '1220030057',
    districtId: '1220030',
    name: 'Aek Haruaya',
  },
  {
    id: '1220030058',
    districtId: '1220030',
    name: 'Lantosan I',
  },
  {
    id: '1220030059',
    districtId: '1220030',
    name: 'Sitopayan',
  },
  {
    id: '1220040015',
    districtId: '1220040',
    name: 'Sibatang Kayu',
  },
  {
    id: '1220040031',
    districtId: '1220040',
    name: 'Bukit Raya Serdang',
  },
  {
    id: '1220040035',
    districtId: '1220040',
    name: 'Sigama Ujung Gading',
  },
  {
    id: '1220040036',
    districtId: '1220040',
    name: 'Aek Suhat',
  },
  {
    id: '1220040040',
    districtId: '1220040',
    name: 'Padang Garugur',
  },
  {
    id: '1220040041',
    districtId: '1220040',
    name: 'Sigama',
  },
  {
    id: '1220040042',
    districtId: '1220040',
    name: 'Simanosor',
  },
  {
    id: '1220040043',
    districtId: '1220040',
    name: 'Parlimbatan',
  },
  {
    id: '1220040044',
    districtId: '1220040',
    name: 'Gunung Manaon II',
  },
  {
    id: '1220040060',
    districtId: '1220040',
    name: 'Saba Sitahul Tahul',
  },
  {
    id: '1220040061',
    districtId: '1220040',
    name: 'Saba Bangunan',
  },
  {
    id: '1220040062',
    districtId: '1220040',
    name: 'Gunung Tua Jae',
  },
  {
    id: '1220040063',
    districtId: '1220040',
    name: 'Gunung Tua Tonga',
  },
  {
    id: '1220040064',
    districtId: '1220040',
    name: 'Pasar Gunung Tua',
  },
  {
    id: '1220040065',
    districtId: '1220040',
    name: 'Sosopan',
  },
  {
    id: '1220040066',
    districtId: '1220040',
    name: 'Hambiri',
  },
  {
    id: '1220040067',
    districtId: '1220040',
    name: 'Sidingkat',
  },
  {
    id: '1220040068',
    districtId: '1220040',
    name: 'Batu Tambun',
  },
  {
    id: '1220040069',
    districtId: '1220040',
    name: 'Batu Sundung',
  },
  {
    id: '1220040070',
    districtId: '1220040',
    name: 'Garonggang',
  },
  {
    id: '1220040071',
    districtId: '1220040',
    name: 'Nabonggal',
  },
  {
    id: '1220040072',
    districtId: '1220040',
    name: 'Sampuran',
  },
  {
    id: '1220040073',
    districtId: '1220040',
    name: 'Hajoran',
  },
  {
    id: '1220040074',
    districtId: '1220040',
    name: 'Tanjung Siram',
  },
  {
    id: '1220040075',
    districtId: '1220040',
    name: 'Garoga',
  },
  {
    id: '1220040076',
    districtId: '1220040',
    name: 'Pagaran Sikkam',
  },
  {
    id: '1220040077',
    districtId: '1220040',
    name: 'Pagaran Tonga',
  },
  {
    id: '1220040078',
    districtId: '1220040',
    name: 'Gunung Tua Julu',
  },
  {
    id: '1220040079',
    districtId: '1220040',
    name: 'Gunung Tua Baru',
  },
  {
    id: '1220040080',
    districtId: '1220040',
    name: 'Batang Baruhar Julu',
  },
  {
    id: '1220040081',
    districtId: '1220040',
    name: 'Batang Baruhar Jae',
  },
  {
    id: '1220040082',
    districtId: '1220040',
    name: 'Huta Lombang',
  },
  {
    id: '1220040083',
    districtId: '1220040',
    name: 'Purba Sinomba',
  },
  {
    id: '1220040084',
    districtId: '1220040',
    name: 'Sibagasi',
  },
  {
    id: '1220040085',
    districtId: '1220040',
    name: 'Sunge Durian',
  },
  {
    id: '1220040086',
    districtId: '1220040',
    name: 'Sunge Orosan',
  },
  {
    id: '1220040087',
    districtId: '1220040',
    name: 'Lubuk Torop',
  },
  {
    id: '1220040088',
    districtId: '1220040',
    name: 'Liang Asona',
  },
  {
    id: '1220040089',
    districtId: '1220040',
    name: 'Simandiangin Dolok',
  },
  {
    id: '1220040090',
    districtId: '1220040',
    name: 'Simandiangin Lombang',
  },
  {
    id: '1220040091',
    districtId: '1220040',
    name: 'Hutaimbaru II',
  },
  {
    id: '1220040092',
    districtId: '1220040',
    name: 'Purba Tua',
  },
  {
    id: '1220040093',
    districtId: '1220040',
    name: 'Tanjung Marulak',
  },
  {
    id: '1220040094',
    districtId: '1220040',
    name: 'Siombob',
  },
  {
    id: '1220040095',
    districtId: '1220040',
    name: 'Ambasang Natigor',
  },
  {
    id: '1220040096',
    districtId: '1220040',
    name: 'Aek Gambir',
  },
  {
    id: '1220040097',
    districtId: '1220040',
    name: 'Napa Gadung Laut',
  },
  {
    id: '1220040098',
    districtId: '1220040',
    name: 'Rampa Julu',
  },
  {
    id: '1220040099',
    districtId: '1220040',
    name: 'Rampa Jae',
  },
  {
    id: '1220040100',
    districtId: '1220040',
    name: 'Sigimbal',
  },
  {
    id: '1220040101',
    districtId: '1220040',
    name: 'Mananti (Marenti)',
  },
  {
    id: '1220040102',
    districtId: '1220040',
    name: 'Paran Padang',
  },
  {
    id: '1220040103',
    districtId: '1220040',
    name: 'Rahuning Jae',
  },
  {
    id: '1220040104',
    districtId: '1220040',
    name: 'Botung',
  },
  {
    id: '1220040105',
    districtId: '1220040',
    name: 'Dolok Sae',
  },
  {
    id: '1220040106',
    districtId: '1220040',
    name: 'Sihapas Hapas',
  },
  {
    id: '1220040107',
    districtId: '1220040',
    name: 'Batu Mamak',
  },
  {
    id: '1220040108',
    districtId: '1220040',
    name: 'Losung Batu',
  },
  {
    id: '1220040109',
    districtId: '1220040',
    name: 'Sunge Tolang',
  },
  {
    id: '1220040110',
    districtId: '1220040',
    name: 'Simasi',
  },
  {
    id: '1220040114',
    districtId: '1220040',
    name: 'Aek Jangkang',
  },
  {
    id: '1220040115',
    districtId: '1220040',
    name: 'Simbolon',
  },
  {
    id: '1220041001',
    districtId: '1220041',
    name: 'Mompang II',
  },
  {
    id: '1220041002',
    districtId: '1220041',
    name: 'Gulangan',
  },
  {
    id: '1220041003',
    districtId: '1220041',
    name: 'Simaninggir',
  },
  {
    id: '1220041004',
    districtId: '1220041',
    name: 'Siunggam Jae',
  },
  {
    id: '1220041005',
    districtId: '1220041',
    name: 'Siunggam Julu',
  },
  {
    id: '1220041006',
    districtId: '1220041',
    name: 'Siunggam Tonga',
  },
  {
    id: '1220041007',
    districtId: '1220041',
    name: 'Naga Saribu',
  },
  {
    id: '1220041008',
    districtId: '1220041',
    name: 'Sihoda-Hoda',
  },
  {
    id: '1220041009',
    districtId: '1220041',
    name: 'Bangun Purba',
  },
  {
    id: '1220041010',
    districtId: '1220041',
    name: 'Tangga-Tangga  Hambeng',
  },
  {
    id: '1220041011',
    districtId: '1220041',
    name: 'Aek Bayur',
  },
  {
    id: '1220041012',
    districtId: '1220041',
    name: 'Aek Tolong',
  },
  {
    id: '1220041013',
    districtId: '1220041',
    name: 'Pijor Koling',
  },
  {
    id: '1220041014',
    districtId: '1220041',
    name: 'Purba Tua Dolok',
  },
  {
    id: '1220050104',
    districtId: '1220050',
    name: 'Huta Pasir',
  },
  {
    id: '1220050105',
    districtId: '1220050',
    name: 'Mandasip',
  },
  {
    id: '1220050107',
    districtId: '1220050',
    name: 'Langkimat',
  },
  {
    id: '1220050108',
    districtId: '1220050',
    name: 'Huta Baru',
  },
  {
    id: '1220050109',
    districtId: '1220050',
    name: 'Janji Matogu Sim',
  },
  {
    id: '1220050110',
    districtId: '1220050',
    name: 'Paran Padang',
  },
  {
    id: '1220050111',
    districtId: '1220050',
    name: 'Jabi-Jabi',
  },
  {
    id: '1220050112',
    districtId: '1220050',
    name: 'Gunung Manaon Sim',
  },
  {
    id: '1220050113',
    districtId: '1220050',
    name: 'Sionggoton',
  },
  {
    id: '1220050114',
    districtId: '1220050',
    name: 'Tanjung Botung',
  },
  {
    id: '1220050115',
    districtId: '1220050',
    name: 'Aek Raru',
  },
  {
    id: '1220050116',
    districtId: '1220050',
    name: 'Simangambat Julu',
  },
  {
    id: '1220050117',
    districtId: '1220050',
    name: 'Sigagan',
  },
  {
    id: '1220050118',
    districtId: '1220050',
    name: 'Simangambat Jae',
  },
  {
    id: '1220050119',
    districtId: '1220050',
    name: 'Pagaran Tonga ( Paran )',
  },
  {
    id: '1220050120',
    districtId: '1220050',
    name: 'Ujung Gading Julu',
  },
  {
    id: '1220050121',
    districtId: '1220050',
    name: 'Ulak Tano',
  },
  {
    id: '1220050122',
    districtId: '1220050',
    name: 'Tanjung Maria',
  },
  {
    id: '1220050123',
    districtId: '1220050',
    name: 'Ujung Gading Jae',
  },
  {
    id: '1220050124',
    districtId: '1220050',
    name: 'Huta Baringin',
  },
  {
    id: '1220050138',
    districtId: '1220050',
    name: 'Kosik Putih',
  },
  {
    id: '1220051001',
    districtId: '1220051',
    name: 'Labuhan Jurung',
  },
  {
    id: '1220051002',
    districtId: '1220051',
    name: 'Gunung Manaon Ub',
  },
  {
    id: '1220051003',
    districtId: '1220051',
    name: 'Ujung Batu Julu',
  },
  {
    id: '1220051004',
    districtId: '1220051',
    name: 'Martujuan',
  },
  {
    id: '1220051005',
    districtId: '1220051',
    name: 'Paya Bahung  Ub',
  },
  {
    id: '1220051006',
    districtId: '1220051',
    name: 'Ujung Batu Jae',
  },
  {
    id: '1220051007',
    districtId: '1220051',
    name: 'Tobing Tinggi Ub',
  },
  {
    id: '1220051008',
    districtId: '1220051',
    name: 'Marlaung',
  },
  {
    id: '1220051009',
    districtId: '1220051',
    name: 'Mananti',
  },
  {
    id: '1220051010',
    districtId: '1220051',
    name: 'Jambu Tonang',
  },
  {
    id: '1220051011',
    districtId: '1220051',
    name: 'Manare Tua',
  },
  {
    id: '1220051012',
    districtId: '1220051',
    name: 'Pasir Lancat Ub',
  },
  {
    id: '1220051013',
    districtId: '1220051',
    name: 'Huta Raja',
  },
  {
    id: '1220060001',
    districtId: '1220060',
    name: 'Hutaimbaru I',
  },
  {
    id: '1220060002',
    districtId: '1220060',
    name: 'Huta Nopan',
  },
  {
    id: '1220060003',
    districtId: '1220060',
    name: 'Hambulo',
  },
  {
    id: '1220060004',
    districtId: '1220060',
    name: 'Paolan',
  },
  {
    id: '1220060005',
    districtId: '1220060',
    name: 'Sipenggeng',
  },
  {
    id: '1220060006',
    districtId: '1220060',
    name: 'Balimbing',
  },
  {
    id: '1220060011',
    districtId: '1220060',
    name: 'Sipaho',
  },
  {
    id: '1220060014',
    districtId: '1220060',
    name: 'Sigala-Gala',
  },
  {
    id: '1220060015',
    districtId: '1220060',
    name: 'Ujung Padang',
  },
  {
    id: '1220060016',
    districtId: '1220060',
    name: 'Rondaman Siburegar',
  },
  {
    id: '1220060017',
    districtId: '1220060',
    name: 'Pangirkiran',
  },
  {
    id: '1220060018',
    districtId: '1220060',
    name: 'Sitabola',
  },
  {
    id: '1220060019',
    districtId: '1220060',
    name: 'Japinulik',
  },
  {
    id: '1220060020',
    districtId: '1220060',
    name: 'Sitenun',
  },
  {
    id: '1220060021',
    districtId: '1220060',
    name: 'Sandean Tonga',
  },
  {
    id: '1220060022',
    districtId: '1220060',
    name: 'Sandean Jae',
  },
  {
    id: '1220060023',
    districtId: '1220060',
    name: 'Silantoyung',
  },
  {
    id: '1220060024',
    districtId: '1220060',
    name: 'Hiteurat',
  },
  {
    id: '1220060025',
    districtId: '1220060',
    name: 'Halongonan',
  },
  {
    id: '1220060026',
    districtId: '1220060',
    name: 'Bargot Topong Julu',
  },
  {
    id: '1220060027',
    districtId: '1220060',
    name: 'Bargot Topong Jae',
  },
  {
    id: '1220060028',
    districtId: '1220060',
    name: 'Siringkit Julu',
  },
  {
    id: '1220060029',
    districtId: '1220060',
    name: 'Siringkit Jae',
  },
  {
    id: '1220060035',
    districtId: '1220060',
    name: 'Napa Lancat',
  },
  {
    id: '1220060036',
    districtId: '1220060',
    name: 'Pangarambangan',
  },
  {
    id: '1220060037',
    districtId: '1220060',
    name: 'Pagar Gunung',
  },
  {
    id: '1220060038',
    districtId: '1220060',
    name: 'Siboru Angin',
  },
  {
    id: '1220060039',
    districtId: '1220060',
    name: 'Hasatan',
  },
  {
    id: '1220060040',
    districtId: '1220060',
    name: 'Paran Honas',
  },
  {
    id: '1220060041',
    districtId: '1220060',
    name: 'Tapus Jae',
  },
  {
    id: '1220060042',
    districtId: '1220060',
    name: 'Saba',
  },
  {
    id: '1220060043',
    districtId: '1220060',
    name: 'Sandean Julu',
  },
  {
    id: '1220060044',
    districtId: '1220060',
    name: 'Batu Tunggal',
  },
  {
    id: '1220061001',
    districtId: '1220061',
    name: 'Pasir Bara',
  },
  {
    id: '1220061002',
    districtId: '1220061',
    name: 'Gunung Intan',
  },
  {
    id: '1220061003',
    districtId: '1220061',
    name: 'Mompang I',
  },
  {
    id: '1220061004',
    districtId: '1220061',
    name: 'Gunung Manaon III',
  },
  {
    id: '1220061005',
    districtId: '1220061',
    name: 'Siancimun',
  },
  {
    id: '1220061006',
    districtId: '1220061',
    name: 'Rondaman',
  },
  {
    id: '1220061007',
    districtId: '1220061',
    name: 'Sihopuk Baru',
  },
  {
    id: '1220061008',
    districtId: '1220061',
    name: 'Sihopuk Lama',
  },
  {
    id: '1220061009',
    districtId: '1220061',
    name: 'Huta Baru Nangka',
  },
  {
    id: '1220061010',
    districtId: '1220061',
    name: 'Situmbaga',
  },
  {
    id: '1220061011',
    districtId: '1220061',
    name: 'Bolatan',
  },
  {
    id: '1220061012',
    districtId: '1220061',
    name: 'UPT Batang Pane I',
  },
  {
    id: '1220061013',
    districtId: '1220061',
    name: 'Batang Pane II',
  },
  {
    id: '1220061014',
    districtId: '1220061',
    name: 'UPT Batang Pane III',
  },
  {
    id: '1220070001',
    districtId: '1220070',
    name: 'Huta Imbaru Gul',
  },
  {
    id: '1220070002',
    districtId: '1220070',
    name: 'Gumaruntar',
  },
  {
    id: '1220070003',
    districtId: '1220070',
    name: 'Aek Rao Tapian Nadenggan',
  },
  {
    id: '1220070004',
    districtId: '1220070',
    name: 'Situmbaga',
  },
  {
    id: '1220070005',
    districtId: '1220070',
    name: 'Sungai Datar',
  },
  {
    id: '1220070006',
    districtId: '1220070',
    name: 'Sijantung Julu',
  },
  {
    id: '1220070007',
    districtId: '1220070',
    name: 'Parigi',
  },
  {
    id: '1220070008',
    districtId: '1220070',
    name: 'Sijantung Jae',
  },
  {
    id: '1220070009',
    districtId: '1220070',
    name: 'Tanjung Longat',
  },
  {
    id: '1220070010',
    districtId: '1220070',
    name: 'Pp Merdeka',
  },
  {
    id: '1220070011',
    districtId: '1220070',
    name: 'Dalihan Natolu',
  },
  {
    id: '1220070012',
    districtId: '1220070',
    name: 'Sinabongan',
  },
  {
    id: '1220070013',
    districtId: '1220070',
    name: 'Binanga Panosahan',
  },
  {
    id: '1220070014',
    districtId: '1220070',
    name: 'Singanyal',
  },
  {
    id: '1220070015',
    districtId: '1220070',
    name: 'Simatorkis',
  },
  {
    id: '1220070016',
    districtId: '1220070',
    name: 'Bahap',
  },
  {
    id: '1220070017',
    districtId: '1220070',
    name: 'Janji Manahan Sil',
  },
  {
    id: '1220070018',
    districtId: '1220070',
    name: 'Sijara-Jara',
  },
  {
    id: '1220070019',
    districtId: '1220070',
    name: 'Silangge',
  },
  {
    id: '1220070020',
    districtId: '1220070',
    name: 'Baringin Sil',
  },
  {
    id: '1220070021',
    districtId: '1220070',
    name: 'Pijor Koling',
  },
  {
    id: '1220070022',
    districtId: '1220070',
    name: 'Aek Ilung',
  },
  {
    id: '1220070023',
    districtId: '1220070',
    name: 'Sibayo Jae',
  },
  {
    id: '1220070024',
    districtId: '1220070',
    name: 'Bukit Tinggi',
  },
  {
    id: '1220070025',
    districtId: '1220070',
    name: 'Pasar Sipiongot',
  },
  {
    id: '1220070026',
    districtId: '1220070',
    name: 'Batu Runding',
  },
  {
    id: '1220070027',
    districtId: '1220070',
    name: 'Parmeraan',
  },
  {
    id: '1220070028',
    districtId: '1220070',
    name: 'Bintais Julu',
  },
  {
    id: '1220070029',
    districtId: '1220070',
    name: 'Huta Baru Sil',
  },
  {
    id: '1220070030',
    districtId: '1220070',
    name: 'Nabonggal',
  },
  {
    id: '1220070031',
    districtId: '1220070',
    name: 'Gumbot',
  },
  {
    id: '1220070032',
    districtId: '1220070',
    name: 'Sipiongot',
  },
  {
    id: '1220070033',
    districtId: '1220070',
    name: 'Bunut',
  },
  {
    id: '1220070034',
    districtId: '1220070',
    name: 'Huta Baru (Sip)',
  },
  {
    id: '1220070035',
    districtId: '1220070',
    name: 'Purbatua (Purbabatu)',
  },
  {
    id: '1220070036',
    districtId: '1220070',
    name: 'Lubuk Godang',
  },
  {
    id: '1220070037',
    districtId: '1220070',
    name: 'Tarutung Bolak',
  },
  {
    id: '1220070038',
    districtId: '1220070',
    name: 'Tanjung Baru B',
  },
  {
    id: '1220070039',
    districtId: '1220070',
    name: 'Sibur Bur',
  },
  {
    id: '1220070040',
    districtId: '1220070',
    name: 'Siraga Huta Padang',
  },
  {
    id: '1220070041',
    districtId: '1220070',
    name: 'Gunung Salamat',
  },
  {
    id: '1220070042',
    districtId: '1220070',
    name: 'Janji Manahan Gul',
  },
  {
    id: '1220070043',
    districtId: '1220070',
    name: 'Sibayo',
  },
  {
    id: '1220070044',
    districtId: '1220070',
    name: 'Rancaran',
  },
  {
    id: '1220070045',
    districtId: '1220070',
    name: 'Rongkare',
  },
  {
    id: '1220070046',
    districtId: '1220070',
    name: 'Arse',
  },
  {
    id: '1220070047',
    districtId: '1220070',
    name: 'Simangambat Tua',
  },
  {
    id: '1220070048',
    districtId: '1220070',
    name: 'Simataniari',
  },
  {
    id: '1220070049',
    districtId: '1220070',
    name: 'Simanosor',
  },
  {
    id: '1220070050',
    districtId: '1220070',
    name: 'Simataniari Jae',
  },
  {
    id: '1220070051',
    districtId: '1220070',
    name: 'Lubuk Kundur',
  },
  {
    id: '1220070052',
    districtId: '1220070',
    name: 'Lubuk Lanjang',
  },
  {
    id: '1220070053',
    districtId: '1220070',
    name: 'Sigala Gala',
  },
  {
    id: '1220070054',
    districtId: '1220070',
    name: 'Aek Sundur',
  },
  {
    id: '1220070055',
    districtId: '1220070',
    name: 'Janji Matogu',
  },
  {
    id: '1220070056',
    districtId: '1220070',
    name: 'Binanga Gumbot',
  },
  {
    id: '1220070057',
    districtId: '1220070',
    name: 'Aek Haruaya',
  },
  {
    id: '1220070058',
    districtId: '1220070',
    name: 'Aek Suhat Tr',
  },
  {
    id: '1220070059',
    districtId: '1220070',
    name: 'Sialang Dolok',
  },
  {
    id: '1220070060',
    districtId: '1220070',
    name: 'Siranap',
  },
  {
    id: '1220070061',
    districtId: '1220070',
    name: 'Jambur Batu',
  },
  {
    id: '1220070062',
    districtId: '1220070',
    name: 'Mompang Dolok',
  },
  {
    id: '1220070063',
    districtId: '1220070',
    name: 'Mompang Lombang',
  },
  {
    id: '1220070064',
    districtId: '1220070',
    name: 'Aek Tangga',
  },
  {
    id: '1220070065',
    districtId: '1220070',
    name: 'Simaninggir Sip',
  },
  {
    id: '1220070066',
    districtId: '1220070',
    name: 'Pagaran Julu I',
  },
  {
    id: '1220070067',
    districtId: '1220070',
    name: 'Silogo-Logo',
  },
  {
    id: '1220070068',
    districtId: '1220070',
    name: 'Pagaran Siregar',
  },
  {
    id: '1220070069',
    districtId: '1220070',
    name: 'Siala Gundi',
  },
  {
    id: '1220070070',
    districtId: '1220070',
    name: 'Simambal',
  },
  {
    id: '1220070071',
    districtId: '1220070',
    name: 'Baringin Sip',
  },
  {
    id: '1220070072',
    districtId: '1220070',
    name: 'Siloung',
  },
  {
    id: '1220070073',
    districtId: '1220070',
    name: 'Napa Sundali',
  },
  {
    id: '1220070074',
    districtId: '1220070',
    name: 'Sijorang',
  },
  {
    id: '1220070075',
    districtId: '1220070',
    name: 'Sibio-Bio',
  },
  {
    id: '1220070076',
    districtId: '1220070',
    name: 'Sunge Pining',
  },
  {
    id: '1220070077',
    districtId: '1220070',
    name: 'Paya Ombik',
  },
  {
    id: '1220070078',
    districtId: '1220070',
    name: 'Panca',
  },
  {
    id: '1220070079',
    districtId: '1220070',
    name: 'Siguga',
  },
  {
    id: '1220070080',
    districtId: '1220070',
    name: 'Bandar Nauli',
  },
  {
    id: '1220070081',
    districtId: '1220070',
    name: 'Gunung Maria',
  },
  {
    id: '1220070082',
    districtId: '1220070',
    name: 'Pagaran Julu II',
  },
  {
    id: '1220070083',
    districtId: '1220070',
    name: 'Aek Suhat Jae',
  },
  {
    id: '1220070084',
    districtId: '1220070',
    name: 'Naga Saribu',
  },
  {
    id: '1220070085',
    districtId: '1220070',
    name: 'Huala Baringin',
  },
  {
    id: '1220070086',
    districtId: '1220070',
    name: 'Dolok Sanggul',
  },
  {
    id: '1220080001',
    districtId: '1220080',
    name: 'Kuala Simpang',
  },
  {
    id: '1220080002',
    districtId: '1220080',
    name: 'Simundol',
  },
  {
    id: '1220080003',
    districtId: '1220080',
    name: 'Sitonun',
  },
  {
    id: '1220080004',
    districtId: '1220080',
    name: 'Simaninggir Sim',
  },
  {
    id: '1220080005',
    districtId: '1220080',
    name: 'Aek Jabut',
  },
  {
    id: '1220080006',
    districtId: '1220080',
    name: 'Nabundong',
  },
  {
    id: '1220080007',
    districtId: '1220080',
    name: 'Pasar Simundol',
  },
  {
    id: '1220080008',
    districtId: '1220080',
    name: 'Pasang Lela',
  },
  {
    id: '1220080009',
    districtId: '1220080',
    name: 'Gunung Sormin',
  },
  {
    id: '1220080010',
    districtId: '1220080',
    name: 'Nahula Jae',
  },
  {
    id: '1220080011',
    districtId: '1220080',
    name: 'Gonting Bange',
  },
  {
    id: '1220080012',
    districtId: '1220080',
    name: 'Simangambat',
  },
  {
    id: '1220080013',
    districtId: '1220080',
    name: 'Tanjung Baru Silaiya',
  },
  {
    id: '1220080014',
    districtId: '1220080',
    name: 'Padang Malakka',
  },
  {
    id: '1220080015',
    districtId: '1220080',
    name: 'Saba Bangunan',
  },
  {
    id: '1220080016',
    districtId: '1220080',
    name: 'Malino',
  },
  {
    id: '1220080017',
    districtId: '1220080',
    name: 'Salusuhan',
  },
  {
    id: '1220080018',
    districtId: '1220080',
    name: 'Sihalo-Halo/Sihatubang',
  },
  {
    id: '1220080019',
    districtId: '1220080',
    name: 'Janji Manahan Gnt',
  },
  {
    id: '1220080020',
    districtId: '1220080',
    name: 'Sipogas B',
  },
  {
    id: '1220080021',
    districtId: '1220080',
    name: 'Sunut',
  },
  {
    id: '1220080022',
    districtId: '1220080',
    name: 'Pamarai (Paramai)',
  },
  {
    id: '1220080023',
    districtId: '1220080',
    name: 'Psr Sayur Matinggi',
  },
  {
    id: '1220080024',
    districtId: '1220080',
    name: 'Sayur Matinggi',
  },
  {
    id: '1220080025',
    districtId: '1220080',
    name: 'Panyabungan',
  },
  {
    id: '1220080026',
    districtId: '1220080',
    name: 'Aek Simanat',
  },
  {
    id: '1220080027',
    districtId: '1220080',
    name: 'Pulo Liman (Limo)',
  },
  {
    id: '1220080028',
    districtId: '1220080',
    name: 'Pd Matinggi Gnt',
  },
  {
    id: '1220080029',
    districtId: '1220080',
    name: 'Hasahatan',
  },
  {
    id: '1220080030',
    districtId: '1220080',
    name: 'Pinarik',
  },
  {
    id: '1220080031',
    districtId: '1220080',
    name: 'Unte Manis',
  },
  {
    id: '1220080032',
    districtId: '1220080',
    name: 'Pamonoran',
  },
  {
    id: '1220080033',
    districtId: '1220080',
    name: 'Huta Imbaru Sim',
  },
  {
    id: '1220080034',
    districtId: '1220080',
    name: 'Aek Kundur',
  },
  {
    id: '1220080035',
    districtId: '1220080',
    name: 'Hatiran',
  },
  {
    id: '1220080036',
    districtId: '1220080',
    name: 'Pd Matinggi Sim',
  },
  {
    id: '1220080037',
    districtId: '1220080',
    name: 'Aek Kanan',
  },
  {
    id: '1220080038',
    districtId: '1220080',
    name: 'Karang Anyar',
  },
  {
    id: '1220080039',
    districtId: '1220080',
    name: 'Nahula Julu',
  },
  {
    id: '1220080040',
    districtId: '1220080',
    name: 'Gadung Holbung',
  },
  {
    id: '1220080041',
    districtId: '1220080',
    name: 'Sigordang',
  },
  {
    id: '1220080042',
    districtId: '1220080',
    name: 'Batu Hibul',
  },
  {
    id: '1220080043',
    districtId: '1220080',
    name: 'Simadihon',
  },
  {
    id: '1220080044',
    districtId: '1220080',
    name: 'Sipogas A',
  },
  {
    id: '1220090001',
    districtId: '1220090',
    name: 'Aek Godang',
  },
  {
    id: '1220090002',
    districtId: '1220090',
    name: 'Aek Nauli',
  },
  {
    id: '1220090003',
    districtId: '1220090',
    name: 'Sampuran Simarloting',
  },
  {
    id: '1220090004',
    districtId: '1220090',
    name: 'Pangirkiran',
  },
  {
    id: '1220090005',
    districtId: '1220090',
    name: 'Pintu Bosi',
  },
  {
    id: '1220090006',
    districtId: '1220090',
    name: 'Simaninggir Pb',
  },
  {
    id: '1220090007',
    districtId: '1220090',
    name: 'Sidong-Dong',
  },
  {
    id: '1220090008',
    districtId: '1220090',
    name: 'Sitabar',
  },
  {
    id: '1220090009',
    districtId: '1220090',
    name: 'Parmeraan',
  },
  {
    id: '1220090010',
    districtId: '1220090',
    name: 'Sukadame',
  },
  {
    id: '1221010001',
    districtId: '1221010',
    name: 'Pagaran Bira Jae',
  },
  {
    id: '1221010002',
    districtId: '1221010',
    name: 'Pagaran Bira Julu',
  },
  {
    id: '1221010003',
    districtId: '1221010',
    name: 'Huta Bargot',
  },
  {
    id: '1221010004',
    districtId: '1221010',
    name: 'Siundol Jae',
  },
  {
    id: '1221010005',
    districtId: '1221010',
    name: 'Siundol Julu',
  },
  {
    id: '1221010006',
    districtId: '1221010',
    name: 'Siundol Dolok',
  },
  {
    id: '1221010007',
    districtId: '1221010',
    name: 'Huta Baru Siundol',
  },
  {
    id: '1221010008',
    districtId: '1221010',
    name: 'Binanga Tolu',
  },
  {
    id: '1221010009',
    districtId: '1221010',
    name: 'Aek Bargot',
  },
  {
    id: '1221010010',
    districtId: '1221010',
    name: 'Ulu Aer',
  },
  {
    id: '1221010011',
    districtId: '1221010',
    name: 'Hulim',
  },
  {
    id: '1221010012',
    districtId: '1221010',
    name: 'Sianggunan',
  },
  {
    id: '1221010013',
    districtId: '1221010',
    name: 'Simaninggir II (Sosopan)',
  },
  {
    id: '1221010014',
    districtId: '1221010',
    name: 'Sibual-Buali',
  },
  {
    id: '1221010015',
    districtId: '1221010',
    name: 'Sosopan',
  },
  {
    id: '1221010016',
    districtId: '1221010',
    name: 'Sihaporas',
  },
  {
    id: '1221010017',
    districtId: '1221010',
    name: 'Sigala Gala',
  },
  {
    id: '1221010018',
    districtId: '1221010',
    name: 'Banua Tonga',
  },
  {
    id: '1221010019',
    districtId: '1221010',
    name: 'Sosopan Julu',
  },
  {
    id: '1221010020',
    districtId: '1221010',
    name: 'Huta Bara',
  },
  {
    id: '1221010021',
    districtId: '1221010',
    name: 'Huta Baru Sosopan',
  },
  {
    id: '1221010022',
    districtId: '1221010',
    name: 'Simartolu',
  },
  {
    id: '1221020001',
    districtId: '1221020',
    name: 'Sibulus Salam',
  },
  {
    id: '1221020002',
    districtId: '1221020',
    name: 'Pintu Padang',
  },
  {
    id: '1221020021',
    districtId: '1221020',
    name: 'Handang Kopo',
  },
  {
    id: '1221020022',
    districtId: '1221020',
    name: 'Simanuldang Jae',
  },
  {
    id: '1221020023',
    districtId: '1221020',
    name: 'Simanuldang Julu',
  },
  {
    id: '1221020024',
    districtId: '1221020',
    name: 'Tapian Nauli',
  },
  {
    id: '1221020025',
    districtId: '1221020',
    name: 'Matondang',
  },
  {
    id: '1221020026',
    districtId: '1221020',
    name: 'Pasar Ipuh',
  },
  {
    id: '1221020027',
    districtId: '1221020',
    name: 'Paringgonan',
  },
  {
    id: '1221020028',
    districtId: '1221020',
    name: 'Paringgonan Julu',
  },
  {
    id: '1221020029',
    districtId: '1221020',
    name: 'Paran Batu (Pagaran Batu)',
  },
  {
    id: '1221020030',
    districtId: '1221020',
    name: 'Tanjung',
  },
  {
    id: '1221020031',
    districtId: '1221020',
    name: 'Siraisan',
  },
  {
    id: '1221020032',
    districtId: '1221020',
    name: 'Aekharuaya)',
  },
  {
    id: '1221020033',
    districtId: '1221020',
    name: 'Sibual Buali',
  },
  {
    id: '1221030003',
    districtId: '1221030',
    name: 'Janji Lobi',
  },
  {
    id: '1221030004',
    districtId: '1221030',
    name: 'Sayur Matua',
  },
  {
    id: '1221030005',
    districtId: '1221030',
    name: 'Hutarimbaru',
  },
  {
    id: '1221030016',
    districtId: '1221030',
    name: 'Tano Bato',
  },
  {
    id: '1221030017',
    districtId: '1221030',
    name: 'Tanjung Botung',
  },
  {
    id: '1221030018',
    districtId: '1221030',
    name: 'Tanjung Durian',
  },
  {
    id: '1221030019',
    districtId: '1221030',
    name: 'Sitarolo Julu',
  },
  {
    id: '1221030020',
    districtId: '1221030',
    name: 'Mompang',
  },
  {
    id: '1221030034',
    districtId: '1221030',
    name: 'Sabahotang',
  },
  {
    id: '1221030035',
    districtId: '1221030',
    name: 'Sigorbus Julu',
  },
  {
    id: '1221030036',
    districtId: '1221030',
    name: 'Sigurbus Jae',
  },
  {
    id: '1221030037',
    districtId: '1221030',
    name: 'Hasahatan Julu',
  },
  {
    id: '1221030038',
    districtId: '1221030',
    name: 'Hasahatan Jae',
  },
  {
    id: '1221030039',
    districtId: '1221030',
    name: 'Psr Sibuhuan',
  },
  {
    id: '1221030041',
    districtId: '1221030',
    name: 'Pancaukan',
  },
  {
    id: '1221030042',
    districtId: '1221030',
    name: 'Bulu Sonik',
  },
  {
    id: '1221030043',
    districtId: '1221030',
    name: 'Pgr Baringin',
  },
  {
    id: '1221030044',
    districtId: '1221030',
    name: 'Arse Simatorkis',
  },
  {
    id: '1221030046',
    districtId: '1221030',
    name: 'Sibuhuan Julu',
  },
  {
    id: '1221030047',
    districtId: '1221030',
    name: 'Bangun Raya',
  },
  {
    id: '1221030048',
    districtId: '1221030',
    name: 'Purbatua',
  },
  {
    id: '1221030049',
    districtId: '1221030',
    name: 'Sialam Bue',
  },
  {
    id: '1221030050',
    districtId: '1221030',
    name: 'Sibuhuan Jae',
  },
  {
    id: '1221030052',
    districtId: '1221030',
    name: 'Handis Julu',
  },
  {
    id: '1221030054',
    districtId: '1221030',
    name: 'Siolip',
  },
  {
    id: '1221030055',
    districtId: '1221030',
    name: 'Saba Riba',
  },
  {
    id: '1221030056',
    districtId: '1221030',
    name: 'Limbong',
  },
  {
    id: '1221030057',
    districtId: '1221030',
    name: 'Simaninggir',
  },
  {
    id: '1221030058',
    districtId: '1221030',
    name: 'Binabo Jae',
  },
  {
    id: '1221030059',
    districtId: '1221030',
    name: 'Binabo Julu',
  },
  {
    id: '1221031001',
    districtId: '1221031',
    name: 'Panarian',
  },
  {
    id: '1221031002',
    districtId: '1221031',
    name: 'Sayur Maincat',
  },
  {
    id: '1221031003',
    districtId: '1221031',
    name: 'Gunung Barani',
  },
  {
    id: '1221031004',
    districtId: '1221031',
    name: 'Gunung Intan',
  },
  {
    id: '1221031005',
    districtId: '1221031',
    name: 'Banua Tonga',
  },
  {
    id: '1221031006',
    districtId: '1221031',
    name: 'Bt Bulu Lama',
  },
  {
    id: '1221031007',
    districtId: '1221031',
    name: 'Bt Bulu Baru',
  },
  {
    id: '1221031008',
    districtId: '1221031',
    name: 'Tanjung Baringin Simarula',
  },
  {
    id: '1221031009',
    districtId: '1221031',
    name: 'Pagur Satio',
  },
  {
    id: '1221031010',
    districtId: '1221031',
    name: 'Sidomulio',
  },
  {
    id: '1221031011',
    districtId: '1221031',
    name: 'Tj Purbatua',
  },
  {
    id: '1221040045',
    districtId: '1221040',
    name: 'Batang Bulu Tanggal',
  },
  {
    id: '1221040051',
    districtId: '1221040',
    name: 'Janji Matogu',
  },
  {
    id: '1221040053',
    districtId: '1221040',
    name: 'Pagaran Silindung',
  },
  {
    id: '1221040060',
    districtId: '1221040',
    name: 'Tangga Bosi',
  },
  {
    id: '1221040061',
    districtId: '1221040',
    name: 'Huta Ibus',
  },
  {
    id: '1221040062',
    districtId: '1221040',
    name: 'Pgr Jalu Jalu',
  },
  {
    id: '1221040063',
    districtId: '1221040',
    name: 'Huta Nopan',
  },
  {
    id: '1221040064',
    districtId: '1221040',
    name: 'Pagaran Jae Batu',
  },
  {
    id: '1221040065',
    districtId: '1221040',
    name: 'Bonal',
  },
  {
    id: '1221040066',
    districtId: '1221040',
    name: 'Pasar Latong',
  },
  {
    id: '1221040067',
    districtId: '1221040',
    name: 'Aek Lancat',
  },
  {
    id: '1221040068',
    districtId: '1221040',
    name: 'Gunung Manobot',
  },
  {
    id: '1221040069',
    districtId: '1221040',
    name: 'Huta Dolok',
  },
  {
    id: '1221040070',
    districtId: '1221040',
    name: 'Pagaran Malaka',
  },
  {
    id: '1221040071',
    districtId: '1221040',
    name: 'Batang Tanggal Baru',
  },
  {
    id: '1221040072',
    districtId: '1221040',
    name: 'Bt Bulu Jae',
  },
  {
    id: '1221040073',
    districtId: '1221040',
    name: 'Janji Lobi Lima',
  },
  {
    id: '1221040074',
    districtId: '1221040',
    name: 'Surodingin',
  },
  {
    id: '1221040075',
    districtId: '1221040',
    name: 'Sangkilon',
  },
  {
    id: '1221040076',
    districtId: '1221040',
    name: 'Siali Ali',
  },
  {
    id: '1221040077',
    districtId: '1221040',
    name: 'Huta Lombang',
  },
  {
    id: '1221040078',
    districtId: '1221040',
    name: 'Parsombaan',
  },
  {
    id: '1221040079',
    districtId: '1221040',
    name: 'Pagaran Mompang',
  },
  {
    id: '1221040080',
    districtId: '1221040',
    name: 'Sihiuk',
  },
  {
    id: '1221050001',
    districtId: '1221050',
    name: 'Batu Gajah',
  },
  {
    id: '1221050002',
    districtId: '1221050',
    name: 'Hapung',
  },
  {
    id: '1221050003',
    districtId: '1221050',
    name: 'Hapung Torop',
  },
  {
    id: '1221050004',
    districtId: '1221050',
    name: 'Bonan Dolok',
  },
  {
    id: '1221050038',
    districtId: '1221050',
    name: 'Mandian',
  },
  {
    id: '1221050039',
    districtId: '1221050',
    name: 'Parapat',
  },
  {
    id: '1221050040',
    districtId: '1221050',
    name: 'Handio',
  },
  {
    id: '1221050041',
    districtId: '1221050',
    name: 'Horuan',
  },
  {
    id: '1221050042',
    districtId: '1221050',
    name: 'Harang Jae',
  },
  {
    id: '1221050043',
    districtId: '1221050',
    name: 'Harang Julu',
  },
  {
    id: '1221050044',
    districtId: '1221050',
    name: 'Gunung Tua',
  },
  {
    id: '1221050045',
    districtId: '1221050',
    name: 'Pasir Julu',
  },
  {
    id: '1221050046',
    districtId: '1221050',
    name: 'Lumban Huayan',
  },
  {
    id: '1221050047',
    districtId: '1221050',
    name: 'Siborna (Siboris Bunut)',
  },
  {
    id: '1221050048',
    districtId: '1221050',
    name: 'Mananti Sosa Julu',
  },
  {
    id: '1221050049',
    districtId: '1221050',
    name: 'Huta Imbaru',
  },
  {
    id: '1221050050',
    districtId: '1221050',
    name: 'Sisoma',
  },
  {
    id: '1221050051',
    districtId: '1221050',
    name: 'Mondang',
  },
  {
    id: '1221050052',
    districtId: '1221050',
    name: 'Simarancar',
  },
  {
    id: '1221050053',
    districtId: '1221050',
    name: 'Huta Raja Lama',
  },
  {
    id: '1221050057',
    districtId: '1221050',
    name: 'Tj Botung Sosa Jae',
  },
  {
    id: '1221050079',
    districtId: '1221050',
    name: 'Aek Tinga',
  },
  {
    id: '1221050080',
    districtId: '1221050',
    name: 'Gunung Baringin',
  },
  {
    id: '1221050082',
    districtId: '1221050',
    name: 'Pasar Ujung Batu',
  },
  {
    id: '1221050083',
    districtId: '1221050',
    name: 'Ujung Batu',
  },
  {
    id: '1221050084',
    districtId: '1221050',
    name: 'Janji Raja',
  },
  {
    id: '1221050085',
    districtId: '1221050',
    name: 'Rao Rao Dolok',
  },
  {
    id: '1221050086',
    districtId: '1221050',
    name: 'Parau Sorat',
  },
  {
    id: '1221050087',
    districtId: '1221050',
    name: 'Aer Bale',
  },
  {
    id: '1221050088',
    districtId: '1221050',
    name: 'Tanjung Bale',
  },
  {
    id: '1221050089',
    districtId: '1221050',
    name: 'Ampolu',
  },
  {
    id: '1221050090',
    districtId: '1221050',
    name: 'Siginduang',
  },
  {
    id: '1221050091',
    districtId: '1221050',
    name: 'Ramba',
  },
  {
    id: '1221050092',
    districtId: '1221050',
    name: 'Roburan',
  },
  {
    id: '1221050093',
    districtId: '1221050',
    name: 'Tanjung',
  },
  {
    id: '1221050094',
    districtId: '1221050',
    name: 'Hurung Jilok',
  },
  {
    id: '1221050095',
    districtId: '1221050',
    name: 'Pasir Jae',
  },
  {
    id: '1221050096',
    districtId: '1221050',
    name: 'Sungai Jior',
  },
  {
    id: '1221050097',
    districtId: '1221050',
    name: 'Pir Sosa Plasma Mond',
  },
  {
    id: '1221060005',
    districtId: '1221060',
    name: 'Manggis',
  },
  {
    id: '1221060006',
    districtId: '1221060',
    name: 'Pagaran Tayas',
  },
  {
    id: '1221060007',
    districtId: '1221060',
    name: 'Hatongga',
  },
  {
    id: '1221060008',
    districtId: '1221060',
    name: 'Botung',
  },
  {
    id: '1221060009',
    districtId: '1221060',
    name: 'Siadam',
  },
  {
    id: '1221060010',
    districtId: '1221060',
    name: 'Siojo',
  },
  {
    id: '1221060011',
    districtId: '1221060',
    name: 'Pagaran Manggis',
  },
  {
    id: '1221060012',
    districtId: '1221060',
    name: 'Muara Malinto Baru',
  },
  {
    id: '1221060013',
    districtId: '1221060',
    name: 'Hutanopan',
  },
  {
    id: '1221060014',
    districtId: '1221060',
    name: 'Huta Baru',
  },
  {
    id: '1221060015',
    districtId: '1221060',
    name: 'Tandalon',
  },
  {
    id: '1221060016',
    districtId: '1221060',
    name: 'Tangga Batu',
  },
  {
    id: '1221060017',
    districtId: '1221060',
    name: 'Pagaran Dolok',
  },
  {
    id: '1221060018',
    districtId: '1221060',
    name: 'Muara M Lama',
  },
  {
    id: '1221060019',
    districtId: '1221060',
    name: 'Aek Sorik',
  },
  {
    id: '1221060020',
    districtId: '1221060',
    name: 'Tanjung Botung',
  },
  {
    id: '1221060021',
    districtId: '1221060',
    name: 'Pinarik',
  },
  {
    id: '1221060022',
    districtId: '1221060',
    name: 'Gunung Manaon',
  },
  {
    id: '1221060023',
    districtId: '1221060',
    name: 'Muara Tige',
  },
  {
    id: '1221060024',
    districtId: '1221060',
    name: 'Sibodak Papaso',
  },
  {
    id: '1221060025',
    districtId: '1221060',
    name: 'Gunung Intan',
  },
  {
    id: '1221060026',
    districtId: '1221060',
    name: 'Pgr Beringin',
  },
  {
    id: '1221060027',
    districtId: '1221060',
    name: 'Salambue',
  },
  {
    id: '1221060028',
    districtId: '1221060',
    name: 'Papaso',
  },
  {
    id: '1221060029',
    districtId: '1221060',
    name: 'Rombayan',
  },
  {
    id: '1221060035',
    districtId: '1221060',
    name: 'Tanjung Baru',
  },
  {
    id: '1221060036',
    districtId: '1221060',
    name: 'Tamiang',
  },
  {
    id: '1221060037',
    districtId: '1221060',
    name: 'Tanjung Barani',
  },
  {
    id: '1221070030',
    districtId: '1221070',
    name: 'Tanjung Ale',
  },
  {
    id: '1221070031',
    districtId: '1221070',
    name: 'Sigala Gala',
  },
  {
    id: '1221070032',
    districtId: '1221070',
    name: 'Simangambat',
  },
  {
    id: '1221070033',
    districtId: '1221070',
    name: 'Pir Trans Sosa III B',
  },
  {
    id: '1221070034',
    districtId: '1221070',
    name: 'Tanjung Sari Ib',
  },
  {
    id: '1221070054',
    districtId: '1221070',
    name: 'Sibodak Sosa Jae',
  },
  {
    id: '1221070055',
    districtId: '1221070',
    name: 'Parmainan',
  },
  {
    id: '1221070056',
    districtId: '1221070',
    name: 'Pagaran Dolok Sosa Jae',
  },
  {
    id: '1221070058',
    districtId: '1221070',
    name: 'Sido Mulyo III A',
  },
  {
    id: '1221070059',
    districtId: '1221070',
    name: 'Ali Aga',
  },
  {
    id: '1221070060',
    districtId: '1221070',
    name: 'Mananti Sosa Jae',
  },
  {
    id: '1221070061',
    districtId: '1221070',
    name: 'Pir Tran Sosa II',
  },
  {
    id: '1221070062',
    districtId: '1221070',
    name: 'Mulya Sari',
  },
  {
    id: '1221070063',
    districtId: '1221070',
    name: 'Panyabungan',
  },
  {
    id: '1221070064',
    districtId: '1221070',
    name: 'Tanjung Baringin',
  },
  {
    id: '1221070065',
    districtId: '1221070',
    name: 'Pasar Panyabungan',
  },
  {
    id: '1221070066',
    districtId: '1221070',
    name: 'Sosa Mulia',
  },
  {
    id: '1221070067',
    districtId: '1221070',
    name: 'Ujung Padang',
  },
  {
    id: '1221070068',
    districtId: '1221070',
    name: 'Huta Raja Tinggi',
  },
  {
    id: '1221070069',
    districtId: '1221070',
    name: 'Payaombor',
  },
  {
    id: '1221070070',
    districtId: '1221070',
    name: 'Siabu',
  },
  {
    id: '1221070071',
    districtId: '1221070',
    name: 'Sungai Korang',
  },
  {
    id: '1221070072',
    districtId: '1221070',
    name: 'Sigalapung',
  },
  {
    id: '1221070073',
    districtId: '1221070',
    name: 'Ujung Batu III',
  },
  {
    id: '1221070074',
    districtId: '1221070',
    name: 'Ujung Batu II',
  },
  {
    id: '1221070075',
    districtId: '1221070',
    name: 'Ujung Batu I',
  },
  {
    id: '1221070076',
    districtId: '1221070',
    name: 'Ujung Batu IV',
  },
  {
    id: '1221070077',
    districtId: '1221070',
    name: 'UPT Ujung Batu V',
  },
  {
    id: '1221070078',
    districtId: '1221070',
    name: 'Lubuk Bunut',
  },
  {
    id: '1221070081',
    districtId: '1221070',
    name: 'Gunung Mulia',
  },
  {
    id: '1221070098',
    districtId: '1221070',
    name: 'Margo Mulia Sosa IV',
  },
  {
    id: '1221080074',
    districtId: '1221080',
    name: 'Ganal',
  },
  {
    id: '1221080076',
    districtId: '1221080',
    name: 'Gunung Matinggi',
  },
  {
    id: '1221080077',
    districtId: '1221080',
    name: 'Gunung Manaon Hr',
  },
  {
    id: '1221080078',
    districtId: '1221080',
    name: 'Paya Bujing',
  },
  {
    id: '1221080079',
    districtId: '1221080',
    name: 'Bulu Cina',
  },
  {
    id: '1221080080',
    districtId: '1221080',
    name: 'Gonting Julu',
  },
  {
    id: '1221080084',
    districtId: '1221080',
    name: 'Gonting Jae',
  },
  {
    id: '1221080085',
    districtId: '1221080',
    name: 'Binanga Tolu',
  },
  {
    id: '1221080086',
    districtId: '1221080',
    name: 'Pasir Lancat Lama',
  },
  {
    id: '1221080087',
    districtId: '1221080',
    name: 'Pasir Lancat Baru',
  },
  {
    id: '1221080088',
    districtId: '1221080',
    name: 'Ramba',
  },
  {
    id: '1221080089',
    districtId: '1221080',
    name: 'Tarutung Sihoda-Hoda',
  },
  {
    id: '1221080090',
    districtId: '1221080',
    name: 'Pasir Pinang',
  },
  {
    id: '1221080091',
    districtId: '1221080',
    name: 'Pulo Bariang',
  },
  {
    id: '1221080092',
    districtId: '1221080',
    name: 'Pasar Huristak',
  },
  {
    id: '1221080093',
    districtId: '1221080',
    name: 'Huristak',
  },
  {
    id: '1221080094',
    districtId: '1221080',
    name: 'Sipirok Baru',
  },
  {
    id: '1221080095',
    districtId: '1221080',
    name: 'Paran Tonga Hr (An)',
  },
  {
    id: '1221080096',
    districtId: '1221080',
    name: 'Tobing Tinggi Hr',
  },
  {
    id: '1221080097',
    districtId: '1221080',
    name: 'Tobing Julu',
  },
  {
    id: '1221080098',
    districtId: '1221080',
    name: 'Huta Pasir Ulak Tano',
  },
  {
    id: '1221080099',
    districtId: '1221080',
    name: 'Gala Bonang',
  },
  {
    id: '1221080100',
    districtId: '1221080',
    name: 'Tobing Jae',
  },
  {
    id: '1221080101',
    districtId: '1221080',
    name: 'Siala Gundi',
  },
  {
    id: '1221080102',
    districtId: '1221080',
    name: 'Tanjung Morang Hr',
  },
  {
    id: '1221080103',
    districtId: '1221080',
    name: 'Tanjung Baringin',
  },
  {
    id: '1221080106',
    districtId: '1221080',
    name: 'Sigading',
  },
  {
    id: '1221090034',
    districtId: '1221090',
    name: 'Huta Ruhom',
  },
  {
    id: '1221090035',
    districtId: '1221090',
    name: 'Gading',
  },
  {
    id: '1221090036',
    districtId: '1221090',
    name: 'Paran Napa Jae',
  },
  {
    id: '1221090037',
    districtId: '1221090',
    name: 'Batu Sundung',
  },
  {
    id: '1221090039',
    districtId: '1221090',
    name: 'Sidong-Dong',
  },
  {
    id: '1221090044',
    districtId: '1221090',
    name: 'Bara Batu',
  },
  {
    id: '1221090045',
    districtId: '1221090',
    name: 'Gunung Manaon Ur',
  },
  {
    id: '1221090046',
    districtId: '1221090',
    name: 'Ginduang Batu',
  },
  {
    id: '1221090047',
    districtId: '1221090',
    name: 'Bahal Batu',
  },
  {
    id: '1221090048',
    districtId: '1221090',
    name: 'Padang Matinggi',
  },
  {
    id: '1221090049',
    districtId: '1221090',
    name: 'Pangirkiran Dolok',
  },
  {
    id: '1221090050',
    districtId: '1221090',
    name: 'Janji Raja',
  },
  {
    id: '1221090051',
    districtId: '1221090',
    name: 'Siboris Dolok',
  },
  {
    id: '1221090052',
    districtId: '1221090',
    name: 'Siboris Lombang',
  },
  {
    id: '1221090053',
    districtId: '1221090',
    name: 'Unte Rudang',
  },
  {
    id: '1221090054',
    districtId: '1221090',
    name: 'Tandihat',
  },
  {
    id: '1221090055',
    districtId: '1221090',
    name: 'Padang Garugur',
  },
  {
    id: '1221090056',
    districtId: '1221090',
    name: 'Siparau',
  },
  {
    id: '1221090057',
    districtId: '1221090',
    name: 'Sihaborgoan Barumun',
  },
  {
    id: '1221090058',
    districtId: '1221090',
    name: 'Sisalean',
  },
  {
    id: '1221090059',
    districtId: '1221090',
    name: 'Sibontar',
  },
  {
    id: '1221090060',
    districtId: '1221090',
    name: 'Bire',
  },
  {
    id: '1221090061',
    districtId: '1221090',
    name: 'Paran Napa Dolok',
  },
  {
    id: '1221090062',
    districtId: '1221090',
    name: 'Aek Siala',
  },
  {
    id: '1221090063',
    districtId: '1221090',
    name: 'Sibatu Loting',
  },
  {
    id: '1221090064',
    districtId: '1221090',
    name: 'Sihaborgoan Dalan',
  },
  {
    id: '1221090065',
    districtId: '1221090',
    name: 'Janji Manahan',
  },
  {
    id: '1221090066',
    districtId: '1221090',
    name: 'Binanga',
  },
  {
    id: '1221090067',
    districtId: '1221090',
    name: 'Siboris Bahal',
  },
  {
    id: '1221090068',
    districtId: '1221090',
    name: 'Pasar Binanga',
  },
  {
    id: '1221090069',
    districtId: '1221090',
    name: 'Siolip',
  },
  {
    id: '1221090070',
    districtId: '1221090',
    name: 'Aek Tunjang',
  },
  {
    id: '1221090071',
    districtId: '1221090',
    name: 'Manombo',
  },
  {
    id: '1221090072',
    districtId: '1221090',
    name: 'Bangkudu',
  },
  {
    id: '1221090073',
    districtId: '1221090',
    name: 'Aek Tanduk',
  },
  {
    id: '1221090075',
    districtId: '1221090',
    name: 'Pp Makmur',
  },
  {
    id: '1221090081',
    districtId: '1221090',
    name: 'Gunung Malintang',
  },
  {
    id: '1221090082',
    districtId: '1221090',
    name: 'Janji Matogu Ur',
  },
  {
    id: '1221090083',
    districtId: '1221090',
    name: 'Gunung Baringin',
  },
  {
    id: '1221091001',
    districtId: '1221091',
    name: 'Tobing Tinggi An',
  },
  {
    id: '1221091002',
    districtId: '1221091',
    name: 'Sipagabu',
  },
  {
    id: '1221091003',
    districtId: '1221091',
    name: 'Paran Tonga An',
  },
  {
    id: '1221091004',
    districtId: '1221091',
    name: 'Tanjung',
  },
  {
    id: '1221091005',
    districtId: '1221091',
    name: 'Paran Julu',
  },
  {
    id: '1221091006',
    districtId: '1221091',
    name: 'Hadungdung Aek Rampah',
  },
  {
    id: '1221091007',
    districtId: '1221091',
    name: 'Tobing',
  },
  {
    id: '1221091008',
    districtId: '1221091',
    name: 'Hadung-Dung Pintu Padang',
  },
  {
    id: '1221091009',
    districtId: '1221091',
    name: 'Padang Garugur Julu',
  },
  {
    id: '1221091010',
    districtId: '1221091',
    name: 'Sidokan',
  },
  {
    id: '1221091011',
    districtId: '1221091',
    name: 'Aek Nabara Julu',
  },
  {
    id: '1221091012',
    districtId: '1221091',
    name: 'Aek Nabara Tonga',
  },
  {
    id: '1221091013',
    districtId: '1221091',
    name: 'Aek Nabara Jae',
  },
  {
    id: '1221091014',
    districtId: '1221091',
    name: 'Padang Garugur Jae',
  },
  {
    id: '1221091015',
    districtId: '1221091',
    name: 'Janji Maria',
  },
  {
    id: '1221091016',
    districtId: '1221091',
    name: 'Bangkuang',
  },
  {
    id: '1221091017',
    districtId: '1221091',
    name: 'Tanjung Rokan',
  },
  {
    id: '1221091018',
    districtId: '1221091',
    name: 'Paya Bahung',
  },
  {
    id: '1221091019',
    districtId: '1221091',
    name: 'Aek Bonban',
  },
  {
    id: '1221091020',
    districtId: '1221091',
    name: 'Marenu',
  },
  {
    id: '1221091021',
    districtId: '1221091',
    name: 'Padang Garugur Tonga',
  },
  {
    id: '1221091022',
    districtId: '1221091',
    name: 'Huta Bargot',
  },
  {
    id: '1221091023',
    districtId: '1221091',
    name: 'Sayur Mahincat',
  },
  {
    id: '1221091024',
    districtId: '1221091',
    name: 'Sayur Matua',
  },
  {
    id: '1221091025',
    districtId: '1221091',
    name: 'Aek Buaton',
  },
  {
    id: '1221092001',
    districtId: '1221092',
    name: 'Gulangan',
  },
  {
    id: '1221092002',
    districtId: '1221092',
    name: 'Aek Goti',
  },
  {
    id: '1221092003',
    districtId: '1221092',
    name: 'Sitada Tada',
  },
  {
    id: '1221092004',
    districtId: '1221092',
    name: 'Lubuk Gonting',
  },
  {
    id: '1221092005',
    districtId: '1221092',
    name: 'Padang Hasior Dolok',
  },
  {
    id: '1221092006',
    districtId: '1221092',
    name: 'Padang Hasior Lombang',
  },
  {
    id: '1221092007',
    districtId: '1221092',
    name: 'Paran Dolok',
  },
  {
    id: '1221092008',
    districtId: '1221092',
    name: 'Ujung Gading',
  },
  {
    id: '1221092009',
    districtId: '1221092',
    name: 'Simaninggir',
  },
  {
    id: '1221092010',
    districtId: '1221092',
    name: 'Tanjung Morang Sh',
  },
  {
    id: '1221092011',
    districtId: '1221092',
    name: 'Silenjeng',
  },
  {
    id: '1221092012',
    districtId: '1221092',
    name: 'Balangka',
  },
  {
    id: '1221092013',
    districtId: '1221092',
    name: 'Ujung Padang',
  },
  {
    id: '1222010001',
    districtId: '1222010',
    name: 'Batang Nadenggan',
  },
  {
    id: '1222010002',
    districtId: '1222010',
    name: 'Langga Payung',
  },
  {
    id: '1222010003',
    districtId: '1222010',
    name: 'Sabungan',
  },
  {
    id: '1222010004',
    districtId: '1222010',
    name: 'Hajoran',
  },
  {
    id: '1222010005',
    districtId: '1222010',
    name: 'Ujung Gading',
  },
  {
    id: '1222010006',
    districtId: '1222010',
    name: 'Huta Godang',
  },
  {
    id: '1222010007',
    districtId: '1222010',
    name: 'Parimburan',
  },
  {
    id: '1222010008',
    districtId: '1222010',
    name: 'Sampean',
  },
  {
    id: '1222010009',
    districtId: '1222010',
    name: 'Marsonja',
  },
  {
    id: '1222020001',
    districtId: '1222020',
    name: 'Bukit Tujuh',
  },
  {
    id: '1222020002',
    districtId: '1222020',
    name: 'Sungai Meranti',
  },
  {
    id: '1222020003',
    districtId: '1222020',
    name: 'Torganda',
  },
  {
    id: '1222020004',
    districtId: '1222020',
    name: 'Torgamba',
  },
  {
    id: '1222020005',
    districtId: '1222020',
    name: 'Aek Raso',
  },
  {
    id: '1222020006',
    districtId: '1222020',
    name: 'Rasau',
  },
  {
    id: '1222020007',
    districtId: '1222020',
    name: 'Bangai',
  },
  {
    id: '1222020008',
    districtId: '1222020',
    name: 'Teluk Rampah',
  },
  {
    id: '1222020009',
    districtId: '1222020',
    name: 'Aek Batu',
  },
  {
    id: '1222020010',
    districtId: '1222020',
    name: 'Beringin Jaya',
  },
  {
    id: '1222020011',
    districtId: '1222020',
    name: 'Pinang Dame',
  },
  {
    id: '1222020012',
    districtId: '1222020',
    name: 'Asam Jawa',
  },
  {
    id: '1222020013',
    districtId: '1222020',
    name: 'Pangarungan',
  },
  {
    id: '1222020014',
    districtId: '1222020',
    name: 'Bunut',
  },
  {
    id: '1222030001',
    districtId: '1222030',
    name: 'Simatahari',
  },
  {
    id: '1222030002',
    districtId: '1222030',
    name: 'Pasir Tuntung',
  },
  {
    id: '1222030003',
    districtId: '1222030',
    name: 'Mampang',
  },
  {
    id: '1222030004',
    districtId: '1222030',
    name: 'Hadundung',
  },
  {
    id: '1222030005',
    districtId: '1222030',
    name: 'Perkebunan Normark',
  },
  {
    id: '1222030006',
    districtId: '1222030',
    name: 'Sosopan',
  },
  {
    id: '1222030007',
    districtId: '1222030',
    name: 'Perkebunan Nagodang',
  },
  {
    id: '1222030008',
    districtId: '1222030',
    name: 'Kota Pinang',
  },
  {
    id: '1222030009',
    districtId: '1222030',
    name: 'Perkebunan Sei Rumbia',
  },
  {
    id: '1222030010',
    districtId: '1222030',
    name: 'Sisumut',
  },
  {
    id: '1222040001',
    districtId: '1222040',
    name: 'Binanga Dua',
  },
  {
    id: '1222040002',
    districtId: '1222040',
    name: 'Mandala Sena',
  },
  {
    id: '1222040003',
    districtId: '1222040',
    name: 'Ulu Mahuam',
  },
  {
    id: '1222040004',
    districtId: '1222040',
    name: 'Aek Goti',
  },
  {
    id: '1222040005',
    districtId: '1222040',
    name: 'Rintis',
  },
  {
    id: '1222040006',
    districtId: '1222040',
    name: 'Sukadame',
  },
  {
    id: '1222050001',
    districtId: '1222050',
    name: 'Perlabian',
  },
  {
    id: '1222050002',
    districtId: '1222050',
    name: 'Perkebunan Perlabian',
  },
  {
    id: '1222050003',
    districtId: '1222050',
    name: 'Pekan Tolan',
  },
  {
    id: '1222050004',
    districtId: '1222050',
    name: 'Perkebunan Tolan I/II',
  },
  {
    id: '1222050005',
    districtId: '1222050',
    name: 'Air Merah',
  },
  {
    id: '1222050006',
    districtId: '1222050',
    name: 'Perkebunan Batang Seponggol',
  },
  {
    id: '1222050007',
    districtId: '1222050',
    name: 'Kebun Teluk Panji',
  },
  {
    id: '1222050008',
    districtId: '1222050',
    name: 'Teluk Panji I',
  },
  {
    id: '1222050009',
    districtId: '1222050',
    name: 'Teluk Panji II',
  },
  {
    id: '1222050010',
    districtId: '1222050',
    name: 'Teluk Panji III',
  },
  {
    id: '1222050011',
    districtId: '1222050',
    name: 'Teluk Panji IV',
  },
  {
    id: '1222050012',
    districtId: '1222050',
    name: 'Kampung Teluk Panji',
  },
  {
    id: '1222050013',
    districtId: '1222050',
    name: 'Tanjung Medan',
  },
  {
    id: '1222050014',
    districtId: '1222050',
    name: 'Tanjung Selamat',
  },
  {
    id: '1222050015',
    districtId: '1222050',
    name: 'Tanjung Mulia',
  },
  {
    id: '1223010001',
    districtId: '1223010',
    name: 'Pematang',
  },
  {
    id: '1223010002',
    districtId: '1223010',
    name: 'Batu Tunggal',
  },
  {
    id: '1223010003',
    districtId: '1223010',
    name: 'Sungai Raja',
  },
  {
    id: '1223010004',
    districtId: '1223010',
    name: 'Perkebunan Berangir',
  },
  {
    id: '1223010005',
    districtId: '1223010',
    name: 'Pasang Lela',
  },
  {
    id: '1223010006',
    districtId: '1223010',
    name: 'Silumajang',
  },
  {
    id: '1223010007',
    districtId: '1223010',
    name: 'Hatapang',
  },
  {
    id: '1223010008',
    districtId: '1223010',
    name: 'Meranti Omas',
  },
  {
    id: '1223010009',
    districtId: '1223010',
    name: 'Bangun Rejo',
  },
  {
    id: '1223010010',
    districtId: '1223010',
    name: 'Kampung Pajak',
  },
  {
    id: '1223010011',
    districtId: '1223010',
    name: 'Aek Kota Batu',
  },
  {
    id: '1223010012',
    districtId: '1223010',
    name: 'Simpang Marbau',
  },
  {
    id: '1223010013',
    districtId: '1223010',
    name: 'Pulo Jantan',
  },
  {
    id: '1223020001',
    districtId: '1223020',
    name: 'Perkebunan Pernantian',
  },
  {
    id: '1223020002',
    districtId: '1223020',
    name: 'Perkebunan Marbau Selatan',
  },
  {
    id: '1223020003',
    districtId: '1223020',
    name: 'Perkebunan Milano',
  },
  {
    id: '1223020004',
    districtId: '1223020',
    name: 'Pulo Bargot',
  },
  {
    id: '1223020005',
    districtId: '1223020',
    name: 'Sumber Mulyo',
  },
  {
    id: '1223020006',
    districtId: '1223020',
    name: 'Sipare Pare Hilir',
  },
  {
    id: '1223020007',
    districtId: '1223020',
    name: 'Sipare Pare Tengah',
  },
  {
    id: '1223020008',
    districtId: '1223020',
    name: 'Tubiran',
  },
  {
    id: '1223020009',
    districtId: '1223020',
    name: 'Belongkut',
  },
  {
    id: '1223020010',
    districtId: '1223020',
    name: 'Simpang Empat',
  },
  {
    id: '1223020011',
    districtId: '1223020',
    name: 'Marbau',
  },
  {
    id: '1223020012',
    districtId: '1223020',
    name: 'Babussalam',
  },
  {
    id: '1223020013',
    districtId: '1223020',
    name: 'Marbau Selatan',
  },
  {
    id: '1223020014',
    districtId: '1223020',
    name: 'Aek Tapa',
  },
  {
    id: '1223020015',
    districtId: '1223020',
    name: 'Lobu Rampah',
  },
  {
    id: '1223020016',
    districtId: '1223020',
    name: 'Perkebunan Brussel',
  },
  {
    id: '1223020017',
    districtId: '1223020',
    name: 'Bulungihit',
  },
  {
    id: '1223020018',
    districtId: '1223020',
    name: 'Aek Hitetoras',
  },
  {
    id: '1223030001',
    districtId: '1223030',
    name: 'Padang Maninjau',
  },
  {
    id: '1223030002',
    districtId: '1223030',
    name: 'Panigoran',
  },
  {
    id: '1223030003',
    districtId: '1223030',
    name: 'Sidomulyo',
  },
  {
    id: '1223030004',
    districtId: '1223030',
    name: 'Karang Anyar',
  },
  {
    id: '1223030005',
    districtId: '1223030',
    name: 'Perkebunan Padang Halaban',
  },
  {
    id: '1223030006',
    districtId: '1223030',
    name: 'Aek Korsik',
  },
  {
    id: '1223030007',
    districtId: '1223030',
    name: 'Purworejo',
  },
  {
    id: '1223030008',
    districtId: '1223030',
    name: 'Bandar Selamat',
  },
  {
    id: '1223040001',
    districtId: '1223040',
    name: 'Poldung',
  },
  {
    id: '1223040002',
    districtId: '1223040',
    name: 'Rombisan',
  },
  {
    id: '1223040003',
    districtId: '1223040',
    name: 'Sibito',
  },
  {
    id: '1223040004',
    districtId: '1223040',
    name: 'Simonis',
  },
  {
    id: '1223040005',
    districtId: '1223040',
    name: 'Kampung Yaman',
  },
  {
    id: '1223040006',
    districtId: '1223040',
    name: 'Perkebunan Aek Pamingke',
  },
  {
    id: '1223040007',
    districtId: '1223040',
    name: 'Bandar Durian',
  },
  {
    id: '1223040008',
    districtId: '1223040',
    name: 'Perkebunan Halimbe',
  },
  {
    id: '1223040009',
    districtId: '1223040',
    name: 'Terang Bulan',
  },
  {
    id: '1223040010',
    districtId: '1223040',
    name: 'Adian Torop',
  },
  {
    id: '1223040011',
    districtId: '1223040',
    name: 'Pangkalan',
  },
  {
    id: '1223040012',
    districtId: '1223040',
    name: 'Ujung Padang',
  },
  {
    id: '1223050001',
    districtId: '1223050',
    name: 'Lobu Huala',
  },
  {
    id: '1223050002',
    districtId: '1223050',
    name: 'Siamporik',
  },
  {
    id: '1223050003',
    districtId: '1223050',
    name: 'Simangalam',
  },
  {
    id: '1223050004',
    districtId: '1223050',
    name: 'Gunung Melayu',
  },
  {
    id: '1223050005',
    districtId: '1223050',
    name: 'Damuli Pekan',
  },
  {
    id: '1223050006',
    districtId: '1223050',
    name: 'Perkebunan Damuli',
  },
  {
    id: '1223050007',
    districtId: '1223050',
    name: 'Hasang',
  },
  {
    id: '1223050008',
    districtId: '1223050',
    name: 'Bandar Lama',
  },
  {
    id: '1223050009',
    districtId: '1223050',
    name: 'Sidua Dua',
  },
  {
    id: '1223050010',
    districtId: '1223050',
    name: 'Gunting Saga',
  },
  {
    id: '1223050011',
    districtId: '1223050',
    name: 'Tanjung Pasir',
  },
  {
    id: '1223050012',
    districtId: '1223050',
    name: 'Sialang Taji',
  },
  {
    id: '1223060001',
    districtId: '1223060',
    name: 'Kuala Bangka',
  },
  {
    id: '1223060002',
    districtId: '1223060',
    name: 'Teluk Binjai',
  },
  {
    id: '1223060003',
    districtId: '1223060',
    name: 'Sungai Sentang',
  },
  {
    id: '1223060004',
    districtId: '1223060',
    name: 'Sungai Apung',
  },
  {
    id: '1223060005',
    districtId: '1223060',
    name: 'Kampung Mesjid',
  },
  {
    id: '1223060006',
    districtId: '1223060',
    name: 'Teluk Piai',
  },
  {
    id: '1223060007',
    districtId: '1223060',
    name: 'Tanjung Mangedar',
  },
  {
    id: '1223070001',
    districtId: '1223070',
    name: 'Kuala Beringin',
  },
  {
    id: '1223070002',
    districtId: '1223070',
    name: 'Pulo Dogom',
  },
  {
    id: '1223070003',
    districtId: '1223070',
    name: 'Perkebunan Londut',
  },
  {
    id: '1223070004',
    districtId: '1223070',
    name: 'Perkebunan Kanopan Ulu',
  },
  {
    id: '1223070005',
    districtId: '1223070',
    name: 'Parpaudangan',
  },
  {
    id: '1223070006',
    districtId: '1223070',
    name: 'Aek Kanopan',
  },
  {
    id: '1223070007',
    districtId: '1223070',
    name: 'Perkebunan Membang Muda',
  },
  {
    id: '1223070008',
    districtId: '1223070',
    name: 'Perkebunan Labuhan Haji',
  },
  {
    id: '1223070009',
    districtId: '1223070',
    name: 'Perkebunan Hanna',
  },
  {
    id: '1223070010',
    districtId: '1223070',
    name: 'Aek Kanopan Timur',
  },
  {
    id: '1223070011',
    districtId: '1223070',
    name: 'Sukarame',
  },
  {
    id: '1223070012',
    districtId: '1223070',
    name: 'Sukarame Baru',
  },
  {
    id: '1223070013',
    districtId: '1223070',
    name: 'Sono Martani',
  },
  {
    id: '1223080001',
    districtId: '1223080',
    name: 'Air Hitam',
  },
  {
    id: '1223080002',
    districtId: '1223080',
    name: 'Teluk Pulai Dalam',
  },
  {
    id: '1223080003',
    districtId: '1223080',
    name: 'Teluk Pulai Luar',
  },
  {
    id: '1223080004',
    districtId: '1223080',
    name: 'Kelapa Sebatang',
  },
  {
    id: '1223080005',
    districtId: '1223080',
    name: 'Pangkalan Lunang',
  },
  {
    id: '1223080006',
    districtId: '1223080',
    name: 'Tanjung Leidong',
  },
  {
    id: '1223080007',
    districtId: '1223080',
    name: 'Simandulang',
  },
  {
    id: '1224010001',
    districtId: '1224010',
    name: 'Humene Siheneasi',
  },
  {
    id: '1224010002',
    districtId: '1224010',
    name: 'Fabaliwa Oyo',
  },
  {
    id: '1224010003',
    districtId: '1224010',
    name: 'Siwawo',
  },
  {
    id: '1224010004',
    districtId: '1224010',
    name: 'Gunung Tua',
  },
  {
    id: '1224010005',
    districtId: '1224010',
    name: 'Ononazara',
  },
  {
    id: '1224010006',
    districtId: '1224010',
    name: 'Teolo',
  },
  {
    id: '1224010007',
    districtId: '1224010',
    name: 'Botona Ai',
  },
  {
    id: '1224010008',
    districtId: '1224010',
    name: 'Harefa',
  },
  {
    id: '1224020001',
    districtId: '1224020',
    name: 'Bitaya',
  },
  {
    id: '1224020002',
    districtId: '1224020',
    name: 'Lahemboho',
  },
  {
    id: '1224020003',
    districtId: '1224020',
    name: 'Hilisebua Siwalubanua',
  },
  {
    id: '1224020004',
    districtId: '1224020',
    name: 'Anaoma',
  },
  {
    id: '1224020005',
    districtId: '1224020',
    name: 'Dahana Tugalaoyo',
  },
  {
    id: '1224020006',
    districtId: '1224020',
    name: 'Loloana A',
  },
  {
    id: '1224020007',
    districtId: '1224020',
    name: 'Fulolo',
  },
  {
    id: '1224020008',
    districtId: '1224020',
    name: 'Ombolata',
  },
  {
    id: '1224020009',
    districtId: '1224020',
    name: 'Banua Sibohou I',
  },
  {
    id: '1224020010',
    districtId: '1224020',
    name: 'Banua Sibohou II',
  },
  {
    id: '1224020011',
    districtId: '1224020',
    name: 'Dahana Alasa',
  },
  {
    id: '1224020012',
    districtId: '1224020',
    name: 'Ononamolo Alasa',
  },
  {
    id: '1224020013',
    districtId: '1224020',
    name: 'Hiligawoni',
  },
  {
    id: '1224020014',
    districtId: '1224020',
    name: 'Ononamolo Tumula',
  },
  {
    id: '1224030001',
    districtId: '1224030',
    name: 'Harefanaese',
  },
  {
    id: '1224030002',
    districtId: '1224030',
    name: 'Banua Sibohou III',
  },
  {
    id: '1224030003',
    districtId: '1224030',
    name: 'Laehuwa',
  },
  {
    id: '1224030004',
    districtId: '1224030',
    name: 'Hilimbowo Kare',
  },
  {
    id: '1224030005',
    districtId: '1224030',
    name: 'Hilina A',
  },
  {
    id: '1224030006',
    districtId: '1224030',
    name: 'Mazingo',
  },
  {
    id: '1224040001',
    districtId: '1224040',
    name: 'Orahili',
  },
  {
    id: '1224040002',
    districtId: '1224040',
    name: 'Hilibanua',
  },
  {
    id: '1224040003',
    districtId: '1224040',
    name: 'Sisobahili',
  },
  {
    id: '1224040004',
    districtId: '1224040',
    name: 'Sisarahili',
  },
  {
    id: '1224040005',
    districtId: '1224040',
    name: 'Banua Sibohou',
  },
  {
    id: '1224040006',
    districtId: '1224040',
    name: 'Esiwa',
  },
  {
    id: '1224040007',
    districtId: '1224040',
    name: 'Tuhenakhe I',
  },
  {
    id: '1224040008',
    districtId: '1224040',
    name: 'Namohalu',
  },
  {
    id: '1224040009',
    districtId: '1224040',
    name: 'Lasara',
  },
  {
    id: '1224040010',
    districtId: '1224040',
    name: 'Berua',
  },
  {
    id: '1224040011',
    districtId: '1224040',
    name: 'Dahana Hiligodu',
  },
  {
    id: '1224050001',
    districtId: '1224050',
    name: 'Tetehosi Maziaya',
  },
  {
    id: '1224050002',
    districtId: '1224050',
    name: 'Umbubalodano',
  },
  {
    id: '1224050003',
    districtId: '1224050',
    name: 'Hilimbosi',
  },
  {
    id: '1224050004',
    districtId: '1224050',
    name: 'Hilisaloo',
  },
  {
    id: '1224050005',
    districtId: '1224050',
    name: 'Botombawo',
  },
  {
    id: '1224050006',
    districtId: '1224050',
    name: 'Fulolosaloo',
  },
  {
    id: '1224060001',
    districtId: '1224060',
    name: 'Botolakha',
  },
  {
    id: '1224060002',
    districtId: '1224060',
    name: 'Siofa Banua',
  },
  {
    id: '1224060003',
    districtId: '1224060',
    name: 'Laaya',
  },
  {
    id: '1224060004',
    districtId: '1224060',
    name: 'Alooa',
  },
  {
    id: '1224060005',
    districtId: '1224060',
    name: 'Ladara',
  },
  {
    id: '1224060006',
    districtId: '1224060',
    name: 'Banuagea',
  },
  {
    id: '1224060007',
    districtId: '1224060',
    name: 'Silima Banua',
  },
  {
    id: '1224060008',
    districtId: '1224060',
    name: 'Fino',
  },
  {
    id: '1224070001',
    districtId: '1224070',
    name: 'Ombolata Sawo',
  },
  {
    id: '1224070002',
    districtId: '1224070',
    name: 'Sanawuyu',
  },
  {
    id: '1224070003',
    districtId: '1224070',
    name: 'Onozitoli Sawo',
  },
  {
    id: '1224070004',
    districtId: '1224070',
    name: 'Hiliduruwa',
  },
  {
    id: '1224070005',
    districtId: '1224070',
    name: 'Teluk Bengkuang',
  },
  {
    id: '1224070006',
    districtId: '1224070',
    name: 'Seriwau',
  },
  {
    id: '1224070007',
    districtId: '1224070',
    name: 'Sawo',
  },
  {
    id: '1224070008',
    districtId: '1224070',
    name: 'Lasara Sawo',
  },
  {
    id: '1224070009',
    districtId: '1224070',
    name: 'Sisarahili Teluk Siabang',
  },
  {
    id: '1224070010',
    districtId: '1224070',
    name: 'Sifahandro',
  },
  {
    id: '1224080001',
    districtId: '1224080',
    name: 'Baho',
  },
  {
    id: '1224080002',
    districtId: '1224080',
    name: 'Maziaya',
  },
  {
    id: '1224080003',
    districtId: '1224080',
    name: 'Fadoro Fulolo',
  },
  {
    id: '1224080004',
    districtId: '1224080',
    name: 'Hilidundra',
  },
  {
    id: '1224080005',
    districtId: '1224080',
    name: 'Lawira Satua',
  },
  {
    id: '1224080006',
    districtId: '1224080',
    name: 'Hiligodu',
  },
  {
    id: '1224080007',
    districtId: '1224080',
    name: 'Lombuzaua',
  },
  {
    id: '1224080008',
    districtId: '1224080',
    name: 'Lawira II',
  },
  {
    id: '1224080009',
    districtId: '1224080',
    name: 'Lawira I',
  },
  {
    id: '1224080010',
    districtId: '1224080',
    name: 'Lolofaoso',
  },
  {
    id: '1224080011',
    districtId: '1224080',
    name: 'Lolomboli',
  },
  {
    id: '1224080012',
    districtId: '1224080',
    name: 'Dahadano',
  },
  {
    id: '1224080013',
    districtId: '1224080',
    name: 'Hiligeo Afia',
  },
  {
    id: '1224090001',
    districtId: '1224090',
    name: 'Lukhulase',
  },
  {
    id: '1224090002',
    districtId: '1224090',
    name: 'Laowowaga',
  },
  {
    id: '1224090003',
    districtId: '1224090',
    name: 'Meafu',
  },
  {
    id: '1224090004',
    districtId: '1224090',
    name: 'Tetehosisorowi',
  },
  {
    id: '1224090005',
    districtId: '1224090',
    name: 'Tugala Lauru',
  },
  {
    id: '1224090006',
    districtId: '1224090',
    name: 'Muzoi',
  },
  {
    id: '1224090007',
    districtId: '1224090',
    name: 'Tefao',
  },
  {
    id: '1224100001',
    districtId: '1224100',
    name: 'Faekhunaa',
  },
  {
    id: '1224100002',
    districtId: '1224100',
    name: 'Sifaoroasi',
  },
  {
    id: '1224100003',
    districtId: '1224100',
    name: 'Lauru Fadoro',
  },
  {
    id: '1224100004',
    districtId: '1224100',
    name: 'Afulu',
  },
  {
    id: '1224100005',
    districtId: '1224100',
    name: 'Sisobahili',
  },
  {
    id: '1224100006',
    districtId: '1224100',
    name: 'Lauru Lahewa',
  },
  {
    id: '1224100007',
    districtId: '1224100',
    name: 'Harewakhe',
  },
  {
    id: '1224100008',
    districtId: '1224100',
    name: 'Ombolata Afulu',
  },
  {
    id: '1224100009',
    districtId: '1224100',
    name: 'Lauru I Afulu',
  },
  {
    id: '1224110001',
    districtId: '1224110',
    name: 'Holi',
  },
  {
    id: '1224110002',
    districtId: '1224110',
    name: 'Hilizukhu',
  },
  {
    id: '1224110003',
    districtId: '1224110',
    name: 'Sifaoroasi',
  },
  {
    id: '1224110004',
    districtId: '1224110',
    name: 'Onozalukhu',
  },
  {
    id: '1224110005',
    districtId: '1224110',
    name: 'Hilina A',
  },
  {
    id: '1224110006',
    districtId: '1224110',
    name: 'Iraono Lase',
  },
  {
    id: '1224110007',
    districtId: '1224110',
    name: 'Sitolu Banua',
  },
  {
    id: '1224110008',
    districtId: '1224110',
    name: 'Hili Goduhoya',
  },
  {
    id: '1224110009',
    districtId: '1224110',
    name: 'Lasara',
  },
  {
    id: '1224110010',
    districtId: '1224110',
    name: 'Fadoro Hilihambawa',
  },
  {
    id: '1224110011',
    districtId: '1224110',
    name: 'Fadoro Hilimbowo',
  },
  {
    id: '1224110012',
    districtId: '1224110',
    name: 'Siheneasi',
  },
  {
    id: '1224110013',
    districtId: '1224110',
    name: 'Moawo',
  },
  {
    id: '1224110014',
    districtId: '1224110',
    name: 'Afia',
  },
  {
    id: '1224110015',
    districtId: '1224110',
    name: 'Hili Hati',
  },
  {
    id: '1224110016',
    districtId: '1224110',
    name: 'Fadoro Sitolu Hili',
  },
  {
    id: '1224110017',
    districtId: '1224110',
    name: 'Lahewa',
  },
  {
    id: '1224110018',
    districtId: '1224110',
    name: 'Ombolata',
  },
  {
    id: '1224110019',
    districtId: '1224110',
    name: 'Marafala',
  },
  {
    id: '1224110020',
    districtId: '1224110',
    name: 'Balefadoro Tuho',
  },
  {
    id: '1224110021',
    districtId: '1224110',
    name: 'Hili Gawolo',
  },
  {
    id: '1225010001',
    districtId: '1225010',
    name: 'Bawosaloo',
  },
  {
    id: '1225010002',
    districtId: '1225010',
    name: 'Imana',
  },
  {
    id: '1225010003',
    districtId: '1225010',
    name: 'Tuwa Tuwa',
  },
  {
    id: '1225010004',
    districtId: '1225010',
    name: 'Kafo Kafo',
  },
  {
    id: '1225010005',
    districtId: '1225010',
    name: 'Bawasawa',
  },
  {
    id: '1225010006',
    districtId: '1225010',
    name: 'Pulau Bogi',
  },
  {
    id: '1225010007',
    districtId: '1225010',
    name: 'Halamona',
  },
  {
    id: '1225010008',
    districtId: '1225010',
    name: 'Hanofa',
  },
  {
    id: '1225010009',
    districtId: '1225010',
    name: 'Lahawa',
  },
  {
    id: '1225010010',
    districtId: '1225010',
    name: 'Hinako',
  },
  {
    id: '1225010011',
    districtId: '1225010',
    name: 'Sinene Eto',
  },
  {
    id: '1225010012',
    districtId: '1225010',
    name: 'Balowondrate',
  },
  {
    id: '1225010013',
    districtId: '1225010',
    name: 'Sirombu',
  },
  {
    id: '1225010014',
    districtId: '1225010',
    name: 'Togideu',
  },
  {
    id: '1225010015',
    districtId: '1225010',
    name: 'Tugala',
  },
  {
    id: '1225010016',
    districtId: '1225010',
    name: 'Tugalagawu',
  },
  {
    id: '1225010017',
    districtId: '1225010',
    name: 'Fadoro',
  },
  {
    id: '1225010018',
    districtId: '1225010',
    name: 'Orahili',
  },
  {
    id: '1225010019',
    districtId: '1225010',
    name: 'Gunung Cahaya',
  },
  {
    id: '1225010020',
    districtId: '1225010',
    name: 'Sisobandrao',
  },
  {
    id: '1225010021',
    districtId: '1225010',
    name: 'Togim Bogi',
  },
  {
    id: '1225010022',
    districtId: '1225010',
    name: 'Tetehosi',
  },
  {
    id: '1225010023',
    districtId: '1225010',
    name: 'Ombolata',
  },
  {
    id: '1225010024',
    districtId: '1225010',
    name: 'Lahusa',
  },
  {
    id: '1225010025',
    districtId: '1225010',
    name: 'Hilimberua',
  },
  {
    id: '1225020001',
    districtId: '1225020',
    name: 'Sisobaoho',
  },
  {
    id: '1225020002',
    districtId: '1225020',
    name: 'Bawazamaiwo',
  },
  {
    id: '1225020003',
    districtId: '1225020',
    name: 'Sitolubanua',
  },
  {
    id: '1225020004',
    districtId: '1225020',
    name: 'Iraonogaila',
  },
  {
    id: '1225020005',
    districtId: '1225020',
    name: 'Lologundre',
  },
  {
    id: '1225020006',
    districtId: '1225020',
    name: 'Lolowau',
  },
  {
    id: '1225020007',
    districtId: '1225020',
    name: 'Sisobambowo',
  },
  {
    id: '1225020008',
    districtId: '1225020',
    name: 'Hiliadulo',
  },
  {
    id: '1225020009',
    districtId: '1225020',
    name: 'Onolimbu',
  },
  {
    id: '1225020010',
    districtId: '1225020',
    name: 'Onowaembo',
  },
  {
    id: '1225020011',
    districtId: '1225020',
    name: 'Tiga Serangkai',
  },
  {
    id: '1225030001',
    districtId: '1225030',
    name: 'Hilibadalu',
  },
  {
    id: '1225030002',
    districtId: '1225030',
    name: 'Hilisangawola',
  },
  {
    id: '1225030003',
    districtId: '1225030',
    name: 'Saloo',
  },
  {
    id: '1225030004',
    districtId: '1225030',
    name: 'Bukit Tinggi',
  },
  {
    id: '1225030007',
    districtId: '1225030',
    name: 'Lawelu',
  },
  {
    id: '1225040001',
    districtId: '1225040',
    name: 'Sisobawino II',
  },
  {
    id: '1225040002',
    districtId: '1225040',
    name: 'Duria',
  },
  {
    id: '1225040003',
    districtId: '1225040',
    name: 'Hilimbowo Mau',
  },
  {
    id: '1225040004',
    districtId: '1225040',
    name: 'Ambukha',
  },
  {
    id: '1225040005',
    districtId: '1225040',
    name: 'Hilimbuasi',
  },
  {
    id: '1225040006',
    districtId: '1225040',
    name: 'Lolofitu',
  },
  {
    id: '1225040007',
    districtId: '1225040',
    name: 'Hiliuso',
  },
  {
    id: '1225040008',
    districtId: '1225040',
    name: 'W A N G O',
  },
  {
    id: '1225050001',
    districtId: '1225050',
    name: 'Hilimayo',
  },
  {
    id: '1225050002',
    districtId: '1225050',
    name: 'Hiambanua',
  },
  {
    id: '1225050003',
    districtId: '1225050',
    name: 'Balodano',
  },
  {
    id: '1225050004',
    districtId: '1225050',
    name: 'Tarahoso',
  },
  {
    id: '1225050005',
    districtId: '1225050',
    name: 'Ononamolo II',
  },
  {
    id: '1225050006',
    districtId: '1225050',
    name: 'Hilimbaruzo',
  },
  {
    id: '1225050007',
    districtId: '1225050',
    name: 'Ononamolo I',
  },
  {
    id: '1225050008',
    districtId: '1225050',
    name: 'Sihareo',
  },
  {
    id: '1225050009',
    districtId: '1225050',
    name: 'Lolomboli',
  },
  {
    id: '1225050010',
    districtId: '1225050',
    name: 'Lahagu',
  },
  {
    id: '1225050011',
    districtId: '1225050',
    name: 'Taraha',
  },
  {
    id: '1225050012',
    districtId: '1225050',
    name: 'Hilimbowo',
  },
  {
    id: '1225060001',
    districtId: '1225060',
    name: 'Sisobambowo',
  },
  {
    id: '1225060002',
    districtId: '1225060',
    name: 'Fadorobahili',
  },
  {
    id: '1225060003',
    districtId: '1225060',
    name: 'Tuho Owo',
  },
  {
    id: '1225060004',
    districtId: '1225060',
    name: 'Iraono Gambo',
  },
  {
    id: '1225060005',
    districtId: '1225060',
    name: 'Simaeasi',
  },
  {
    id: '1225060006',
    districtId: '1225060',
    name: 'Hiliwalo O I',
  },
  {
    id: '1225060007',
    districtId: '1225060',
    name: 'Sianaa',
  },
  {
    id: '1225060008',
    districtId: '1225060',
    name: 'Fadoro',
  },
  {
    id: '1225060009',
    districtId: '1225060',
    name: 'Lasara Baene',
  },
  {
    id: '1225060010',
    districtId: '1225060',
    name: 'Tumori',
  },
  {
    id: '1225060011',
    districtId: '1225060',
    name: 'Tetehosi',
  },
  {
    id: '1225060012',
    districtId: '1225060',
    name: 'Zuzundrao',
  },
  {
    id: '1225060013',
    districtId: '1225060',
    name: 'Sisarahili I',
  },
  {
    id: '1225060014',
    districtId: '1225060',
    name: 'Hayo',
  },
  {
    id: '1225060015',
    districtId: '1225060',
    name: 'Doli Doli',
  },
  {
    id: '1225060016',
    districtId: '1225060',
    name: 'Lakhene',
  },
  {
    id: '1225060017',
    districtId: '1225060',
    name: 'Lolozirugi',
  },
  {
    id: '1225060018',
    districtId: '1225060',
    name: 'Tuhemberua',
  },
  {
    id: '1225060019',
    districtId: '1225060',
    name: 'Lologolu',
  },
  {
    id: '1225060020',
    districtId: '1225060',
    name: 'Tuwuna',
  },
  {
    id: '1225070001',
    districtId: '1225070',
    name: 'Onolimbu Raya',
  },
  {
    id: '1225070002',
    districtId: '1225070',
    name: 'Ononamolo III',
  },
  {
    id: '1225070003',
    districtId: '1225070',
    name: 'Sisobaoho',
  },
  {
    id: '1225070004',
    districtId: '1225070',
    name: 'Iraonogeba',
  },
  {
    id: '1225070005',
    districtId: '1225070',
    name: 'Lolohia',
  },
  {
    id: '1225070006',
    districtId: '1225070',
    name: 'Onolimbu You',
  },
  {
    id: '1225070007',
    districtId: '1225070',
    name: 'Fadoro Sifulubanua',
  },
  {
    id: '1225070008',
    districtId: '1225070',
    name: 'Hilidaura',
  },
  {
    id: '1225070009',
    districtId: '1225070',
    name: 'Sisarahili II',
  },
  {
    id: '1225070010',
    districtId: '1225070',
    name: 'Lasarabagawu',
  },
  {
    id: '1225070011',
    districtId: '1225070',
    name: 'Sisobandrao',
  },
  {
    id: '1225070012',
    districtId: '1225070',
    name: 'Mazingo',
  },
  {
    id: '1225070013',
    districtId: '1225070',
    name: 'Lasarafaga',
  },
  {
    id: '1225070014',
    districtId: '1225070',
    name: 'Orahilibadalu',
  },
  {
    id: '1225080001',
    districtId: '1225080',
    name: 'Onozalukhu You',
  },
  {
    id: '1225080002',
    districtId: '1225080',
    name: 'Siduahili',
  },
  {
    id: '1225080003',
    districtId: '1225080',
    name: 'Hilisoromi',
  },
  {
    id: '1225080004',
    districtId: '1225080',
    name: 'Gunung Baru',
  },
  {
    id: '1225080005',
    districtId: '1225080',
    name: 'Hiliwaloo II',
  },
  {
    id: '1225080006',
    districtId: '1225080',
    name: 'Hilifadolo',
  },
  {
    id: '1225080007',
    districtId: '1225080',
    name: 'Sitolu Ewali',
  },
  {
    id: '1225080008',
    districtId: '1225080',
    name: 'Hili Waele',
  },
  {
    id: '1225080009',
    districtId: '1225080',
    name: 'Lasara Bahili',
  },
  {
    id: '1225080010',
    districtId: '1225080',
    name: 'Sitolubanua Fadoro',
  },
  {
    id: '1271010001',
    districtId: '1271010',
    name: 'Sibolga Ilir',
  },
  {
    id: '1271010002',
    districtId: '1271010',
    name: 'Angin Nauli',
  },
  {
    id: '1271010003',
    districtId: '1271010',
    name: 'Huta Tonga Tonga',
  },
  {
    id: '1271010004',
    districtId: '1271010',
    name: 'Huta Barangan',
  },
  {
    id: '1271010005',
    districtId: '1271010',
    name: 'Simare-Mare',
  },
  {
    id: '1271020001',
    districtId: '1271020',
    name: 'Kota Beringin',
  },
  {
    id: '1271020002',
    districtId: '1271020',
    name: 'Pasar Baru',
  },
  {
    id: '1271020003',
    districtId: '1271020',
    name: 'Pasar Belakang',
  },
  {
    id: '1271020004',
    districtId: '1271020',
    name: 'Pancuran Gerobak',
  },
  {
    id: '1271030003',
    districtId: '1271030',
    name: 'Aek Habil',
  },
  {
    id: '1271030006',
    districtId: '1271030',
    name: 'Aek Manis',
  },
  {
    id: '1271030007',
    districtId: '1271030',
    name: 'Aek Parombunan',
  },
  {
    id: '1271030008',
    districtId: '1271030',
    name: 'Aek Muara Pinang',
  },
  {
    id: '1271031001',
    districtId: '1271031',
    name: 'Pancuran Pinang',
  },
  {
    id: '1271031002',
    districtId: '1271031',
    name: 'Pancuran Kerambil',
  },
  {
    id: '1271031003',
    districtId: '1271031',
    name: 'Pancuran Dewa',
  },
  {
    id: '1271031004',
    districtId: '1271031',
    name: 'Pancuran Bambu',
  },
  {
    id: '1272010001',
    districtId: '1272010',
    name: 'Sijambi',
  },
  {
    id: '1272010002',
    districtId: '1272010',
    name: 'Pahang',
  },
  {
    id: '1272010003',
    districtId: '1272010',
    name: 'Gading',
  },
  {
    id: '1272010009',
    districtId: '1272010',
    name: 'Sirantau',
  },
  {
    id: '1272010010',
    districtId: '1272010',
    name: 'Pantai Johor',
  },
  {
    id: '1272011001',
    districtId: '1272011',
    name: 'Bunga Tanjung',
  },
  {
    id: '1272011002',
    districtId: '1272011',
    name: 'Selat Lancang',
  },
  {
    id: '1272011003',
    districtId: '1272011',
    name: 'Selat Tanjung Medan',
  },
  {
    id: '1272011004',
    districtId: '1272011',
    name: 'Semula Jadi',
  },
  {
    id: '1272011005',
    districtId: '1272011',
    name: 'Pulau Simardan',
  },
  {
    id: '1272020001',
    districtId: '1272020',
    name: 'Tanjung Balai Kota II',
  },
  {
    id: '1272020002',
    districtId: '1272020',
    name: 'Tanjung Balai Kota I',
  },
  {
    id: '1272020003',
    districtId: '1272020',
    name: 'Karya',
  },
  {
    id: '1272020004',
    districtId: '1272020',
    name: 'Perwira',
  },
  {
    id: '1272020005',
    districtId: '1272020',
    name: 'Indra Sakti',
  },
  {
    id: '1272020006',
    districtId: '1272020',
    name: 'Pantai Burung',
  },
  {
    id: '1272030001',
    districtId: '1272030',
    name: 'Tanjung Balai Kota  III',
  },
  {
    id: '1272030002',
    districtId: '1272030',
    name: 'Mata Halasan',
  },
  {
    id: '1272030003',
    districtId: '1272030',
    name: 'Kwala Silau Bestari',
  },
  {
    id: '1272030004',
    districtId: '1272030',
    name: 'Tanjung Balai Kota IV',
  },
  {
    id: '1272030005',
    districtId: '1272030',
    name: 'Sejahtera',
  },
  {
    id: '1272040001',
    districtId: '1272040',
    name: 'Pasar Baru',
  },
  {
    id: '1272040002',
    districtId: '1272040',
    name: 'Keramat Kubah',
  },
  {
    id: '1272040003',
    districtId: '1272040',
    name: 'Sumber Sari',
  },
  {
    id: '1272040004',
    districtId: '1272040',
    name: 'Muara Sentosa',
  },
  {
    id: '1272040005',
    districtId: '1272040',
    name: 'Sei Raja',
  },
  {
    id: '1272050001',
    districtId: '1272050',
    name: 'Beting Kwala Kapias',
  },
  {
    id: '1272050002',
    districtId: '1272050',
    name: 'Kapias Pulau Buaya',
  },
  {
    id: '1272050003',
    districtId: '1272050',
    name: 'Sei Merbau',
  },
  {
    id: '1272050004',
    districtId: '1272050',
    name: 'Pematang Pasir',
  },
  {
    id: '1272050005',
    districtId: '1272050',
    name: 'Perjuangan',
  },
  {
    id: '1273010004',
    districtId: '1273010',
    name: 'Sukamaju',
  },
  {
    id: '1273010005',
    districtId: '1273010',
    name: 'Pardamean',
  },
  {
    id: '1273010006',
    districtId: '1273010',
    name: 'Sukaraja',
  },
  {
    id: '1273010007',
    districtId: '1273010',
    name: 'Bp Nauli',
  },
  {
    id: '1273010008',
    districtId: '1273010',
    name: 'Sukamakmur',
  },
  {
    id: '1273010009',
    districtId: '1273010',
    name: 'Parhorasan Nauli',
  },
  {
    id: '1273010010',
    districtId: '1273010',
    name: 'Mekar Nauli',
  },
  {
    id: '1273011001',
    districtId: '1273011',
    name: 'Simarimbun',
  },
  {
    id: '1273011002',
    districtId: '1273011',
    name: 'Naga Huta',
  },
  {
    id: '1273011003',
    districtId: '1273011',
    name: 'Pematang Marihat',
  },
  {
    id: '1273011004',
    districtId: '1273011',
    name: 'Tong Marimbun',
  },
  {
    id: '1273011005',
    districtId: '1273011',
    name: 'Nagahuta Timur',
  },
  {
    id: '1273011006',
    districtId: '1273011',
    name: 'Marihat Jaya',
  },
  {
    id: '1273020001',
    districtId: '1273020',
    name: 'Aek Nauli',
  },
  {
    id: '1273020002',
    districtId: '1273020',
    name: 'Martimbang',
  },
  {
    id: '1273020003',
    districtId: '1273020',
    name: 'Kristen',
  },
  {
    id: '1273020004',
    districtId: '1273020',
    name: 'Toba',
  },
  {
    id: '1273020005',
    districtId: '1273020',
    name: 'Karo',
  },
  {
    id: '1273020006',
    districtId: '1273020',
    name: 'Simalungun',
  },
  {
    id: '1273030001',
    districtId: '1273030',
    name: 'Sipinggol Pinggol',
  },
  {
    id: '1273030002',
    districtId: '1273030',
    name: 'Teladan',
  },
  {
    id: '1273030003',
    districtId: '1273030',
    name: 'Dwikora',
  },
  {
    id: '1273030004',
    districtId: '1273030',
    name: 'Proklamasi',
  },
  {
    id: '1273030005',
    districtId: '1273030',
    name: 'Timbang Galung',
  },
  {
    id: '1273030006',
    districtId: '1273030',
    name: 'Simarito',
  },
  {
    id: '1273030007',
    districtId: '1273030',
    name: 'Banjar',
  },
  {
    id: '1273030008',
    districtId: '1273030',
    name: 'Bantan',
  },
  {
    id: '1273040001',
    districtId: '1273040',
    name: 'Martoba',
  },
  {
    id: '1273040002',
    districtId: '1273040',
    name: 'Melayu',
  },
  {
    id: '1273040003',
    districtId: '1273040',
    name: 'Baru',
  },
  {
    id: '1273040004',
    districtId: '1273040',
    name: 'Suka Dame',
  },
  {
    id: '1273040005',
    districtId: '1273040',
    name: 'Bane',
  },
  {
    id: '1273040006',
    districtId: '1273040',
    name: 'Sigulang Gulang',
  },
  {
    id: '1273040007',
    districtId: '1273040',
    name: 'Kahean',
  },
  {
    id: '1273050001',
    districtId: '1273050',
    name: 'Kebun Sayur',
  },
  {
    id: '1273050002',
    districtId: '1273050',
    name: 'Tomuan',
  },
  {
    id: '1273050003',
    districtId: '1273050',
    name: 'Pahlawan',
  },
  {
    id: '1273050004',
    districtId: '1273050',
    name: 'Siopat Suhu',
  },
  {
    id: '1273050005',
    districtId: '1273050',
    name: 'Merdeka',
  },
  {
    id: '1273050006',
    districtId: '1273050',
    name: 'Pardomuan',
  },
  {
    id: '1273050007',
    districtId: '1273050',
    name: 'Asuhan',
  },
  {
    id: '1273060005',
    districtId: '1273060',
    name: 'Sumber Jaya',
  },
  {
    id: '1273060006',
    districtId: '1273060',
    name: 'Naga Pita.',
  },
  {
    id: '1273060007',
    districtId: '1273060',
    name: 'Pondok Sayur',
  },
  {
    id: '1273060008',
    districtId: '1273060',
    name: 'Tambun Nabolon',
  },
  {
    id: '1273060009',
    districtId: '1273060',
    name: 'Nagapitu',
  },
  {
    id: '1273060010',
    districtId: '1273060',
    name: 'Tanjung Pinggir',
  },
  {
    id: '1273060011',
    districtId: '1273060',
    name: 'Tanjung Tongah',
  },
  {
    id: '1273061001',
    districtId: '1273061',
    name: 'Bah Kapul',
  },
  {
    id: '1273061002',
    districtId: '1273061',
    name: 'Gurilla',
  },
  {
    id: '1273061003',
    districtId: '1273061',
    name: 'Bukit Shofa',
  },
  {
    id: '1273061004',
    districtId: '1273061',
    name: 'Setia Negara',
  },
  {
    id: '1273061005',
    districtId: '1273061',
    name: 'Bah Sorma',
  },
  {
    id: '1274010001',
    districtId: '1274010',
    name: 'Pabatu',
  },
  {
    id: '1274010002',
    districtId: '1274010',
    name: 'Lubuk Baru',
  },
  {
    id: '1274010003',
    districtId: '1274010',
    name: 'Persiakan',
  },
  {
    id: '1274010004',
    districtId: '1274010',
    name: 'Bandarsono',
  },
  {
    id: '1274010008',
    districtId: '1274010',
    name: 'Tualang',
  },
  {
    id: '1274010011',
    districtId: '1274010',
    name: 'Lubuk Raya',
  },
  {
    id: '1274010012',
    districtId: '1274010',
    name: 'Padang Merbau',
  },
  {
    id: '1274011001',
    districtId: '1274011',
    name: 'Mandailing',
  },
  {
    id: '1274011002',
    districtId: '1274011',
    name: 'Pasar Gambir',
  },
  {
    id: '1274011003',
    districtId: '1274011',
    name: 'Rambung',
  },
  {
    id: '1274011004',
    districtId: '1274011',
    name: 'Tebing Tinggi Lama',
  },
  {
    id: '1274011005',
    districtId: '1274011',
    name: 'Pasar Baru',
  },
  {
    id: '1274011006',
    districtId: '1274011',
    name: 'Badak Bejuang',
  },
  {
    id: '1274011007',
    districtId: '1274011',
    name: 'Bandar Utama',
  },
  {
    id: '1274020005',
    districtId: '1274020',
    name: 'Rantau Laban',
  },
  {
    id: '1274020008',
    districtId: '1274020',
    name: 'Sri Padang',
  },
  {
    id: '1274020009',
    districtId: '1274020',
    name: 'Karya Jaya',
  },
  {
    id: '1274020010',
    districtId: '1274020',
    name: 'Lalang',
  },
  {
    id: '1274020011',
    districtId: '1274020',
    name: 'Tanjung Marulak',
  },
  {
    id: '1274020012',
    districtId: '1274020',
    name: 'Tanjung Marulak Hilir',
  },
  {
    id: '1274020013',
    districtId: '1274020',
    name: 'Mekar Sentosa',
  },
  {
    id: '1274021001',
    districtId: '1274021',
    name: 'Bulian',
  },
  {
    id: '1274021002',
    districtId: '1274021',
    name: 'Pelita',
  },
  {
    id: '1274021003',
    districtId: '1274021',
    name: 'Durian',
  },
  {
    id: '1274021004',
    districtId: '1274021',
    name: 'Bandar Sakti',
  },
  {
    id: '1274021005',
    districtId: '1274021',
    name: 'Teluk Karang',
  },
  {
    id: '1274021006',
    districtId: '1274021',
    name: 'Pinang Mancung',
  },
  {
    id: '1274021007',
    districtId: '1274021',
    name: 'Berohol',
  },
  {
    id: '1274030001',
    districtId: '1274030',
    name: 'Bagelen',
  },
  {
    id: '1274030002',
    districtId: '1274030',
    name: 'Tebing Tinggi',
  },
  {
    id: '1274030005',
    districtId: '1274030',
    name: 'Tambangan',
  },
  {
    id: '1274030006',
    districtId: '1274030',
    name: 'Satria',
  },
  {
    id: '1274030007',
    districtId: '1274030',
    name: 'Deblod Sundoro',
  },
  {
    id: '1274030008',
    districtId: '1274030',
    name: 'Damar Sari',
  },
  {
    id: '1274030009',
    districtId: '1274030',
    name: 'Tambangan Hulu',
  },
  {
    id: '1275010001',
    districtId: '1275010',
    name: 'Baru Ladang Bambu',
  },
  {
    id: '1275010002',
    districtId: '1275010',
    name: 'Sidomulyo',
  },
  {
    id: '1275010003',
    districtId: '1275010',
    name: 'Lau Cih',
  },
  {
    id: '1275010004',
    districtId: '1275010',
    name: 'Namu Gajah',
  },
  {
    id: '1275010005',
    districtId: '1275010',
    name: 'Kemenangan Tani',
  },
  {
    id: '1275010006',
    districtId: '1275010',
    name: 'Simalingkar B',
  },
  {
    id: '1275010007',
    districtId: '1275010',
    name: 'Simpang Selayang',
  },
  {
    id: '1275010008',
    districtId: '1275010',
    name: 'Tanjung Selamat',
  },
  {
    id: '1275010009',
    districtId: '1275010',
    name: 'M A N G G A',
  },
  {
    id: '1275020001',
    districtId: '1275020',
    name: 'Kwala Bekala',
  },
  {
    id: '1275020002',
    districtId: '1275020',
    name: 'Gedung Johor',
  },
  {
    id: '1275020003',
    districtId: '1275020',
    name: 'Kedai Durian',
  },
  {
    id: '1275020004',
    districtId: '1275020',
    name: 'Suka Maju',
  },
  {
    id: '1275020005',
    districtId: '1275020',
    name: 'Titi Kuning',
  },
  {
    id: '1275020006',
    districtId: '1275020',
    name: 'Pangkalan Masyhur',
  },
  {
    id: '1275030001',
    districtId: '1275030',
    name: 'Harjosari II',
  },
  {
    id: '1275030002',
    districtId: '1275030',
    name: 'Sitirejo II',
  },
  {
    id: '1275030003',
    districtId: '1275030',
    name: 'Sitirejo III',
  },
  {
    id: '1275030004',
    districtId: '1275030',
    name: 'Harjosari I',
  },
  {
    id: '1275030005',
    districtId: '1275030',
    name: 'A M P L A S',
  },
  {
    id: '1275030006',
    districtId: '1275030',
    name: 'Timbang Deli',
  },
  {
    id: '1275030007',
    districtId: '1275030',
    name: 'Bangun Mulia',
  },
  {
    id: '1275040001',
    districtId: '1275040',
    name: 'B I N J A I',
  },
  {
    id: '1275040002',
    districtId: '1275040',
    name: 'Medan Tenggara',
  },
  {
    id: '1275040003',
    districtId: '1275040',
    name: 'D E N A I',
  },
  {
    id: '1275040004',
    districtId: '1275040',
    name: 'Tegal Sari Mandala III',
  },
  {
    id: '1275040005',
    districtId: '1275040',
    name: 'Tegal Sari Mandala II',
  },
  {
    id: '1275040006',
    districtId: '1275040',
    name: 'Tegal Sari Mandala I',
  },
  {
    id: '1275050001',
    districtId: '1275050',
    name: 'Pasar Merah Timur',
  },
  {
    id: '1275050002',
    districtId: '1275050',
    name: 'Tegal Sari II',
  },
  {
    id: '1275050003',
    districtId: '1275050',
    name: 'Tegal Sari III',
  },
  {
    id: '1275050004',
    districtId: '1275050',
    name: 'Tegal Sari I',
  },
  {
    id: '1275050005',
    districtId: '1275050',
    name: 'Sukaramai I',
  },
  {
    id: '1275050006',
    districtId: '1275050',
    name: 'Kota Matsum II',
  },
  {
    id: '1275050007',
    districtId: '1275050',
    name: 'Kota Matsum IV',
  },
  {
    id: '1275050008',
    districtId: '1275050',
    name: 'Kota Matsum I',
  },
  {
    id: '1275050009',
    districtId: '1275050',
    name: 'Sei Rengas Permata',
  },
  {
    id: '1275050010',
    districtId: '1275050',
    name: 'Sukaramai II',
  },
  {
    id: '1275050011',
    districtId: '1275050',
    name: 'Sei Rengas II',
  },
  {
    id: '1275050012',
    districtId: '1275050',
    name: 'Pandau Hulu II',
  },
  {
    id: '1275060001',
    districtId: '1275060',
    name: 'Siti Rejo I',
  },
  {
    id: '1275060002',
    districtId: '1275060',
    name: 'Sudi Rejo II',
  },
  {
    id: '1275060003',
    districtId: '1275060',
    name: 'Sudi Rejo I',
  },
  {
    id: '1275060004',
    districtId: '1275060',
    name: 'Teladan Timur',
  },
  {
    id: '1275060005',
    districtId: '1275060',
    name: 'Teladan Barat',
  },
  {
    id: '1275060006',
    districtId: '1275060',
    name: 'Pasar Merah Barat',
  },
  {
    id: '1275060007',
    districtId: '1275060',
    name: 'M E S J I D',
  },
  {
    id: '1275060008',
    districtId: '1275060',
    name: 'Kota Matsum III',
  },
  {
    id: '1275060009',
    districtId: '1275060',
    name: 'Sei Rengas I',
  },
  {
    id: '1275060010',
    districtId: '1275060',
    name: 'Pasar Baru',
  },
  {
    id: '1275060011',
    districtId: '1275060',
    name: 'Pusat Pasar',
  },
  {
    id: '1275060012',
    districtId: '1275060',
    name: 'Pandau Hulu I',
  },
  {
    id: '1275070001',
    districtId: '1275070',
    name: 'Kampung Baru',
  },
  {
    id: '1275070002',
    districtId: '1275070',
    name: 'Sei Mati',
  },
  {
    id: '1275070003',
    districtId: '1275070',
    name: 'Suka Raja',
  },
  {
    id: '1275070004',
    districtId: '1275070',
    name: 'J A T I',
  },
  {
    id: '1275070005',
    districtId: '1275070',
    name: 'H A M D A N',
  },
  {
    id: '1275070006',
    districtId: '1275070',
    name: 'A U R',
  },
  {
    id: '1275080001',
    districtId: '1275080',
    name: 'Sari Rejo',
  },
  {
    id: '1275080002',
    districtId: '1275080',
    name: 'Suka Damai',
  },
  {
    id: '1275080003',
    districtId: '1275080',
    name: 'Polonia',
  },
  {
    id: '1275080004',
    districtId: '1275080',
    name: 'Anggrung',
  },
  {
    id: '1275080005',
    districtId: '1275080',
    name: 'Madras Hulu',
  },
  {
    id: '1275090001',
    districtId: '1275090',
    name: 'Titi Rantai',
  },
  {
    id: '1275090002',
    districtId: '1275090',
    name: 'Padang Bulan',
  },
  {
    id: '1275090003',
    districtId: '1275090',
    name: 'Merdeka',
  },
  {
    id: '1275090004',
    districtId: '1275090',
    name: 'D A R A T',
  },
  {
    id: '1275090005',
    districtId: '1275090',
    name: 'Babura',
  },
  {
    id: '1275090006',
    districtId: '1275090',
    name: 'Petisah Hulu',
  },
  {
    id: '1275100001',
    districtId: '1275100',
    name: 'Sempakata',
  },
  {
    id: '1275100002',
    districtId: '1275100',
    name: 'Beringin',
  },
  {
    id: '1275100003',
    districtId: '1275100',
    name: 'Padang Bulan Selayang II',
  },
  {
    id: '1275100004',
    districtId: '1275100',
    name: 'Padang Bulan Selayang I',
  },
  {
    id: '1275100005',
    districtId: '1275100',
    name: 'Tanjung Sari',
  },
  {
    id: '1275100006',
    districtId: '1275100',
    name: 'Asam Kumbang',
  },
  {
    id: '1275110001',
    districtId: '1275110',
    name: 'Sunggal',
  },
  {
    id: '1275110002',
    districtId: '1275110',
    name: 'Tanjung Rejo',
  },
  {
    id: '1275110003',
    districtId: '1275110',
    name: 'Babura',
  },
  {
    id: '1275110004',
    districtId: '1275110',
    name: 'Simpang Tanjung',
  },
  {
    id: '1275110005',
    districtId: '1275110',
    name: 'Sei Sikambing B',
  },
  {
    id: '1275110006',
    districtId: '1275110',
    name: 'Lalang',
  },
  {
    id: '1275120001',
    districtId: '1275120',
    name: 'Cinta Damai',
  },
  {
    id: '1275120002',
    districtId: '1275120',
    name: 'Sei Sikambing C II',
  },
  {
    id: '1275120003',
    districtId: '1275120',
    name: 'Dwi Kora',
  },
  {
    id: '1275120004',
    districtId: '1275120',
    name: 'Helvetia Timur',
  },
  {
    id: '1275120005',
    districtId: '1275120',
    name: 'Helvetia Tengah',
  },
  {
    id: '1275120006',
    districtId: '1275120',
    name: 'Helvetia',
  },
  {
    id: '1275120007',
    districtId: '1275120',
    name: 'Tanjung Gusta',
  },
  {
    id: '1275130001',
    districtId: '1275130',
    name: 'Sei Sikambing D',
  },
  {
    id: '1275130002',
    districtId: '1275130',
    name: 'Petisah Tengah',
  },
  {
    id: '1275130003',
    districtId: '1275130',
    name: 'S E K I P',
  },
  {
    id: '1275130004',
    districtId: '1275130',
    name: 'Sei Putih Timur II',
  },
  {
    id: '1275130005',
    districtId: '1275130',
    name: 'Sei Putih Timur I',
  },
  {
    id: '1275130006',
    districtId: '1275130',
    name: 'Sei Putih Tengah',
  },
  {
    id: '1275130007',
    districtId: '1275130',
    name: 'Sei Putih Barat',
  },
  {
    id: '1275140001',
    districtId: '1275140',
    name: 'Kesawan',
  },
  {
    id: '1275140002',
    districtId: '1275140',
    name: 'Silalas',
  },
  {
    id: '1275140003',
    districtId: '1275140',
    name: 'Sei Agul',
  },
  {
    id: '1275140004',
    districtId: '1275140',
    name: 'Karang Berombak',
  },
  {
    id: '1275140005',
    districtId: '1275140',
    name: 'Glugur Kota',
  },
  {
    id: '1275140006',
    districtId: '1275140',
    name: 'Pulo Brayan Kota',
  },
  {
    id: '1275150001',
    districtId: '1275150',
    name: 'Gang Buntu',
  },
  {
    id: '1275150002',
    districtId: '1275150',
    name: 'Sidodadi',
  },
  {
    id: '1275150003',
    districtId: '1275150',
    name: 'Perintis',
  },
  {
    id: '1275150004',
    districtId: '1275150',
    name: 'Gaharu',
  },
  {
    id: '1275150005',
    districtId: '1275150',
    name: 'Durian',
  },
  {
    id: '1275150006',
    districtId: '1275150',
    name: 'Glugur Darat II',
  },
  {
    id: '1275150007',
    districtId: '1275150',
    name: 'Glugur Darat I',
  },
  {
    id: '1275150008',
    districtId: '1275150',
    name: 'Pulo Brayan Darat I',
  },
  {
    id: '1275150009',
    districtId: '1275150',
    name: 'Pulo Brayan Darat II',
  },
  {
    id: '1275150010',
    districtId: '1275150',
    name: 'Pulo Brayan Bengkel Baru',
  },
  {
    id: '1275150011',
    districtId: '1275150',
    name: 'Pulo Brayan Bengkel',
  },
  {
    id: '1275160001',
    districtId: '1275160',
    name: 'Pandau Hilir',
  },
  {
    id: '1275160002',
    districtId: '1275160',
    name: 'Sei Kera Hulu',
  },
  {
    id: '1275160003',
    districtId: '1275160',
    name: 'Pahlawan',
  },
  {
    id: '1275160004',
    districtId: '1275160',
    name: 'Sei Kera Hilir I',
  },
  {
    id: '1275160005',
    districtId: '1275160',
    name: 'Sei Kera Hilir II',
  },
  {
    id: '1275160006',
    districtId: '1275160',
    name: 'Sidorame Timur',
  },
  {
    id: '1275160007',
    districtId: '1275160',
    name: 'Sidorame Barat II',
  },
  {
    id: '1275160008',
    districtId: '1275160',
    name: 'Sidorame Barat I',
  },
  {
    id: '1275160009',
    districtId: '1275160',
    name: 'Tegal Rejo',
  },
  {
    id: '1275170001',
    districtId: '1275170',
    name: 'Indra Kasih',
  },
  {
    id: '1275170002',
    districtId: '1275170',
    name: 'Sidorejo Hilir',
  },
  {
    id: '1275170003',
    districtId: '1275170',
    name: 'Sidorejo',
  },
  {
    id: '1275170004',
    districtId: '1275170',
    name: 'Bantan Timur',
  },
  {
    id: '1275170005',
    districtId: '1275170',
    name: 'Bandar Selamat',
  },
  {
    id: '1275170006',
    districtId: '1275170',
    name: 'B A N T A N',
  },
  {
    id: '1275170007',
    districtId: '1275170',
    name: 'T E M B U N G',
  },
  {
    id: '1275180001',
    districtId: '1275180',
    name: 'Tanjung Mulia',
  },
  {
    id: '1275180002',
    districtId: '1275180',
    name: 'Tanjung Mulia Hilir',
  },
  {
    id: '1275180003',
    districtId: '1275180',
    name: 'Mabar Hilir',
  },
  {
    id: '1275180004',
    districtId: '1275180',
    name: 'M A B A R',
  },
  {
    id: '1275180005',
    districtId: '1275180',
    name: 'Kota Bangun',
  },
  {
    id: '1275180006',
    districtId: '1275180',
    name: 'Titi Papan',
  },
  {
    id: '1275190001',
    districtId: '1275190',
    name: 'B E S A R',
  },
  {
    id: '1275190002',
    districtId: '1275190',
    name: 'Tangkahan',
  },
  {
    id: '1275190003',
    districtId: '1275190',
    name: 'Martubung',
  },
  {
    id: '1275190004',
    districtId: '1275190',
    name: 'Sei Mati',
  },
  {
    id: '1275190005',
    districtId: '1275190',
    name: 'Pekan Labuhan',
  },
  {
    id: '1275190006',
    districtId: '1275190',
    name: 'Nelayan Indah',
  },
  {
    id: '1275200001',
    districtId: '1275200',
    name: 'Tanah Enam Ratus',
  },
  {
    id: '1275200002',
    districtId: '1275200',
    name: 'Rengas Pulau',
  },
  {
    id: '1275200003',
    districtId: '1275200',
    name: 'T E R J U N',
  },
  {
    id: '1275200004',
    districtId: '1275200',
    name: 'Paya Pasir',
  },
  {
    id: '1275200005',
    districtId: '1275200',
    name: 'Labuhan Deli',
  },
  {
    id: '1275210001',
    districtId: '1275210',
    name: 'Belawan Pulau Sicanang',
  },
  {
    id: '1275210002',
    districtId: '1275210',
    name: 'Belawan Bahagia',
  },
  {
    id: '1275210003',
    districtId: '1275210',
    name: 'Belawan Bahari',
  },
  {
    id: '1275210004',
    districtId: '1275210',
    name: 'Belawan II',
  },
  {
    id: '1275210005',
    districtId: '1275210',
    name: 'Bagan Deli',
  },
  {
    id: '1275210006',
    districtId: '1275210',
    name: 'Belawan I',
  },
  {
    id: '1276010001',
    districtId: '1276010',
    name: 'Tanah Merah',
  },
  {
    id: '1276010002',
    districtId: '1276010',
    name: 'Bhakti Karya',
  },
  {
    id: '1276010003',
    districtId: '1276010',
    name: 'Tanah Seribu',
  },
  {
    id: '1276010004',
    districtId: '1276010',
    name: 'Puji Dadi',
  },
  {
    id: '1276010005',
    districtId: '1276010',
    name: 'Binjai Estate',
  },
  {
    id: '1276010006',
    districtId: '1276010',
    name: 'Rambung Barat',
  },
  {
    id: '1276010007',
    districtId: '1276010',
    name: 'Rambung Dalam',
  },
  {
    id: '1276010008',
    districtId: '1276010',
    name: 'Rambung Timur',
  },
  {
    id: '1276020001',
    districtId: '1276020',
    name: 'Berngam',
  },
  {
    id: '1276020002',
    districtId: '1276020',
    name: 'Satria',
  },
  {
    id: '1276020003',
    districtId: '1276020',
    name: 'Setia',
  },
  {
    id: '1276020004',
    districtId: '1276020',
    name: 'Kartini',
  },
  {
    id: '1276020005',
    districtId: '1276020',
    name: 'Tangsi',
  },
  {
    id: '1276020006',
    districtId: '1276020',
    name: 'Binjai',
  },
  {
    id: '1276020007',
    districtId: '1276020',
    name: 'Pekan Binjai',
  },
  {
    id: '1276030001',
    districtId: '1276030',
    name: 'Mencirim',
  },
  {
    id: '1276030002',
    districtId: '1276030',
    name: 'Tunggurono',
  },
  {
    id: '1276030003',
    districtId: '1276030',
    name: 'Dataran Tinggi',
  },
  {
    id: '1276030004',
    districtId: '1276030',
    name: 'Timbang Langkat',
  },
  {
    id: '1276030005',
    districtId: '1276030',
    name: 'Tanah Tinggi',
  },
  {
    id: '1276030006',
    districtId: '1276030',
    name: 'Sumber Mulyorejo',
  },
  {
    id: '1276030007',
    districtId: '1276030',
    name: 'Sumber Karya',
  },
  {
    id: '1276040001',
    districtId: '1276040',
    name: 'Pahlawan',
  },
  {
    id: '1276040002',
    districtId: '1276040',
    name: 'Jatinegara',
  },
  {
    id: '1276040003',
    districtId: '1276040',
    name: 'Nangka',
  },
  {
    id: '1276040004',
    districtId: '1276040',
    name: 'Jati Makmur',
  },
  {
    id: '1276040005',
    districtId: '1276040',
    name: 'Damai',
  },
  {
    id: '1276040006',
    districtId: '1276040',
    name: 'Kebun Lada',
  },
  {
    id: '1276040007',
    districtId: '1276040',
    name: 'Cengkeh Turi',
  },
  {
    id: '1276040008',
    districtId: '1276040',
    name: 'Jati Karya',
  },
  {
    id: '1276040009',
    districtId: '1276040',
    name: 'Jati Utomo',
  },
  {
    id: '1276050001',
    districtId: '1276050',
    name: 'Bandar Senembah',
  },
  {
    id: '1276050002',
    districtId: '1276050',
    name: 'Limau Mungkur',
  },
  {
    id: '1276050003',
    districtId: '1276050',
    name: 'Limau Sundai',
  },
  {
    id: '1276050004',
    districtId: '1276050',
    name: 'Paya Roba',
  },
  {
    id: '1276050005',
    districtId: '1276050',
    name: 'Suka Maju',
  },
  {
    id: '1276050006',
    districtId: '1276050',
    name: 'Suka Ramai',
  },
  {
    id: '1277010001',
    districtId: '1277010',
    name: 'Sihitang',
  },
  {
    id: '1277010002',
    districtId: '1277010',
    name: 'Pal IV P Koling',
  },
  {
    id: '1277010003',
    districtId: '1277010',
    name: 'Salambue',
  },
  {
    id: '1277010004',
    districtId: '1277010',
    name: 'Sigulang',
  },
  {
    id: '1277010005',
    districtId: '1277010',
    name: 'Huta Koje',
  },
  {
    id: '1277010006',
    districtId: '1277010',
    name: 'Huta Limbong',
  },
  {
    id: '1277010007',
    districtId: '1277010',
    name: 'Huta Padang Pk',
  },
  {
    id: '1277010008',
    districtId: '1277010',
    name: 'Pijor Koling',
  },
  {
    id: '1277010009',
    districtId: '1277010',
    name: 'Goti',
  },
  {
    id: '1277010010',
    districtId: '1277010',
    name: 'Manegen',
  },
  {
    id: '1277010011',
    districtId: '1277010',
    name: 'Manunggang Jae',
  },
  {
    id: '1277010012',
    districtId: '1277010',
    name: 'Labuhan Rasoki',
  },
  {
    id: '1277010013',
    districtId: '1277010',
    name: 'Purbatua P Koling',
  },
  {
    id: '1277010014',
    districtId: '1277010',
    name: 'Manunggang Julu',
  },
  {
    id: '1277010015',
    districtId: '1277010',
    name: 'Tarutung Baru',
  },
  {
    id: '1277010016',
    districtId: '1277010',
    name: 'Huta Lombang',
  },
  {
    id: '1277010017',
    districtId: '1277010',
    name: 'Perkebunan P Koling',
  },
  {
    id: '1277010018',
    districtId: '1277010',
    name: 'Labuhan Labo',
  },
  {
    id: '1277020001',
    districtId: '1277020',
    name: 'Hanopan',
  },
  {
    id: '1277020002',
    districtId: '1277020',
    name: 'Sidangkal',
  },
  {
    id: '1277020003',
    districtId: '1277020',
    name: 'Wek VI',
  },
  {
    id: '1277020004',
    districtId: '1277020',
    name: 'Ujung Padang',
  },
  {
    id: '1277020005',
    districtId: '1277020',
    name: 'Aek Tampang',
  },
  {
    id: '1277020006',
    districtId: '1277020',
    name: 'Padang Matinggi',
  },
  {
    id: '1277020007',
    districtId: '1277020',
    name: 'Silandit',
  },
  {
    id: '1277020008',
    districtId: '1277020',
    name: 'Wek V',
  },
  {
    id: '1277020009',
    districtId: '1277020',
    name: 'Sitamiang',
  },
  {
    id: '1277020010',
    districtId: '1277020',
    name: 'Losung',
  },
  {
    id: '1277020011',
    districtId: '1277020',
    name: 'Padang Matinggi Lestari',
  },
  {
    id: '1277020012',
    districtId: '1277020',
    name: 'Sitamiang Baru',
  },
  {
    id: '1277030005',
    districtId: '1277030',
    name: 'Purwodadi',
  },
  {
    id: '1277030006',
    districtId: '1277030',
    name: 'Gunung Hasahatan',
  },
  {
    id: '1277030007',
    districtId: '1277030',
    name: 'Ujung Gurap',
  },
  {
    id: '1277030008',
    districtId: '1277030',
    name: 'Baruas',
  },
  {
    id: '1277030009',
    districtId: '1277030',
    name: 'Aek Bayur',
  },
  {
    id: '1277030010',
    districtId: '1277030',
    name: 'Aek Tuhul',
  },
  {
    id: '1277030011',
    districtId: '1277030',
    name: 'Pudun Jae',
  },
  {
    id: '1277030012',
    districtId: '1277030',
    name: 'Pudun Julu',
  },
  {
    id: '1277030013',
    districtId: '1277030',
    name: 'Siloting',
  },
  {
    id: '1277030014',
    districtId: '1277030',
    name: 'Batang Bahal',
  },
  {
    id: '1277030015',
    districtId: '1277030',
    name: 'Aek Najaji',
  },
  {
    id: '1277030016',
    districtId: '1277030',
    name: 'Bargot Topong',
  },
  {
    id: '1277030017',
    districtId: '1277030',
    name: 'Simirik',
  },
  {
    id: '1277030018',
    districtId: '1277030',
    name: 'Batunadua Jae',
  },
  {
    id: '1277030019',
    districtId: '1277030',
    name: 'Batunadua Julu',
  },
  {
    id: '1277040001',
    districtId: '1277040',
    name: 'Wek IV',
  },
  {
    id: '1277040002',
    districtId: '1277040',
    name: 'Wek III',
  },
  {
    id: '1277040003',
    districtId: '1277040',
    name: 'Wek II',
  },
  {
    id: '1277040004',
    districtId: '1277040',
    name: 'Wek I',
  },
  {
    id: '1277040005',
    districtId: '1277040',
    name: 'Batang Ayumi Julu',
  },
  {
    id: '1277040006',
    districtId: '1277040',
    name: 'Batang Ayumi Jae',
  },
  {
    id: '1277040007',
    districtId: '1277040',
    name: 'Tobat',
  },
  {
    id: '1277040008',
    districtId: '1277040',
    name: 'Tano Bato',
  },
  {
    id: '1277040009',
    districtId: '1277040',
    name: 'Bonan Dolok',
  },
  {
    id: '1277040010',
    districtId: '1277040',
    name: 'Sadabuan',
  },
  {
    id: '1277040011',
    districtId: '1277040',
    name: 'Panyanggar',
  },
  {
    id: '1277040012',
    districtId: '1277040',
    name: 'Losung Batu',
  },
  {
    id: '1277040013',
    districtId: '1277040',
    name: 'Kantin',
  },
  {
    id: '1277040014',
    districtId: '1277040',
    name: 'Bincar',
  },
  {
    id: '1277040015',
    districtId: '1277040',
    name: 'Timbangan',
  },
  {
    id: '1277040016',
    districtId: '1277040',
    name: 'Kayu Ombun',
  },
  {
    id: '1277050001',
    districtId: '1277050',
    name: 'Partihaman Saroha',
  },
  {
    id: '1277050002',
    districtId: '1277050',
    name: 'Hutaimbaru',
  },
  {
    id: '1277050003',
    districtId: '1277050',
    name: 'Palopat Maria',
  },
  {
    id: '1277050004',
    districtId: '1277050',
    name: 'Sabungan Jae',
  },
  {
    id: '1277050005',
    districtId: '1277050',
    name: 'Lembah Lubuk Manik',
  },
  {
    id: '1277050006',
    districtId: '1277050',
    name: 'Sabungan Sipabangun',
  },
  {
    id: '1277050007',
    districtId: '1277050',
    name: 'Singali',
  },
  {
    id: '1277050008',
    districtId: '1277050',
    name: 'Huta Padang',
  },
  {
    id: '1277050009',
    districtId: '1277050',
    name: 'Lubuk Raya',
  },
  {
    id: '1277050010',
    districtId: '1277050',
    name: 'Tinjoman',
  },
  {
    id: '1277051001',
    districtId: '1277051',
    name: 'Simatohir',
  },
  {
    id: '1277051002',
    districtId: '1277051',
    name: 'Rimba Soping',
  },
  {
    id: '1277051003',
    districtId: '1277051',
    name: 'Mompang',
  },
  {
    id: '1277051004',
    districtId: '1277051',
    name: 'Batu Layan',
  },
  {
    id: '1277051005',
    districtId: '1277051',
    name: 'Joring Lombang',
  },
  {
    id: '1277051006',
    districtId: '1277051',
    name: 'Joring Natobang',
  },
  {
    id: '1277051007',
    districtId: '1277051',
    name: 'Simasom',
  },
  {
    id: '1277051008',
    districtId: '1277051',
    name: 'Pintu Langit Jae',
  },
  {
    id: '1278010001',
    districtId: '1278010',
    name: 'Hilimbowo Idanoi',
  },
  {
    id: '1278010002',
    districtId: '1278010',
    name: 'Hiliweto Idanoi',
  },
  {
    id: '1278010003',
    districtId: '1278010',
    name: 'Tuhegeo II',
  },
  {
    id: '1278010004',
    districtId: '1278010',
    name: 'Samasi',
  },
  {
    id: '1278010005',
    districtId: '1278010',
    name: 'Loloanaa Idanoi',
  },
  {
    id: '1278010006',
    districtId: '1278010',
    name: 'Ombolata',
  },
  {
    id: '1278010007',
    districtId: '1278010',
    name: 'Onowaembo',
  },
  {
    id: '1278010008',
    districtId: '1278010',
    name: 'Siwalubanua I',
  },
  {
    id: '1278010009',
    districtId: '1278010',
    name: 'Awaai',
  },
  {
    id: '1278010010',
    districtId: '1278010',
    name: 'Lewuoguru Idanoi',
  },
  {
    id: '1278010011',
    districtId: '1278010',
    name: 'Fadoro',
  },
  {
    id: '1278010012',
    districtId: '1278010',
    name: 'Sifalaete',
  },
  {
    id: '1278010013',
    districtId: '1278010',
    name: 'Hilihambawa',
  },
  {
    id: '1278010014',
    districtId: '1278010',
    name: 'Tetehosi I',
  },
  {
    id: '1278010015',
    districtId: '1278010',
    name: 'Tetehosi II',
  },
  {
    id: '1278010016',
    districtId: '1278010',
    name: 'Binaka',
  },
  {
    id: '1278010017',
    districtId: '1278010',
    name: 'Idanotae',
  },
  {
    id: '1278010018',
    districtId: '1278010',
    name: 'Fowa',
  },
  {
    id: '1278010019',
    districtId: '1278010',
    name: 'Siwalubanua II',
  },
  {
    id: '1278010020',
    districtId: '1278010',
    name: 'Humene',
  },
  {
    id: '1278010021',
    districtId: '1278010',
    name: 'Simanaere',
  },
  {
    id: '1278010022',
    districtId: '1278010',
    name: 'Helefanikha',
  },
  {
    id: '1278010023',
    districtId: '1278010',
    name: 'Tuhegeo I',
  },
  {
    id: '1278010024',
    districtId: '1278010',
    name: 'Dahana',
  },
  {
    id: '1278010025',
    districtId: '1278010',
    name: 'Hilimbawadesolo',
  },
  {
    id: '1278010026',
    districtId: '1278010',
    name: 'Bawodesolo',
  },
  {
    id: '1278020001',
    districtId: '1278020',
    name: 'Lololakha',
  },
  {
    id: '1278020002',
    districtId: '1278020',
    name: 'Onozitoli Tabaloho',
  },
  {
    id: '1278020003',
    districtId: '1278020',
    name: 'Sihareo I Tabaloho',
  },
  {
    id: '1278020004',
    districtId: '1278020',
    name: 'Ombolata Simenari',
  },
  {
    id: '1278020005',
    districtId: '1278020',
    name: 'Mazingo Tabaloho',
  },
  {
    id: '1278020006',
    districtId: '1278020',
    name: 'Ononamolo I Lot',
  },
  {
    id: '1278020007',
    districtId: '1278020',
    name: 'Luaha Laraga',
  },
  {
    id: '1278020008',
    districtId: '1278020',
    name: 'Lolomboli',
  },
  {
    id: '1278020009',
    districtId: '1278020',
    name: 'Fodo',
  },
  {
    id: '1278020010',
    districtId: '1278020',
    name: 'Faekhu',
  },
  {
    id: '1278020011',
    districtId: '1278020',
    name: 'Lolofaoso Tabaloho',
  },
  {
    id: '1278020012',
    districtId: '1278020',
    name: 'Hiligara',
  },
  {
    id: '1278020013',
    districtId: '1278020',
    name: 'Hiligodu Ombolata',
  },
  {
    id: '1278020014',
    districtId: '1278020',
    name: 'Tetehosi Ombalata',
  },
  {
    id: '1278020016',
    districtId: '1278020',
    name: 'Sisobahili II Tanoseo',
  },
  {
    id: '1278030001',
    districtId: '1278030',
    name: 'Onozikho',
  },
  {
    id: '1278030002',
    districtId: '1278030',
    name: 'Gada',
  },
  {
    id: '1278030003',
    districtId: '1278030',
    name: 'Hilinakhe',
  },
  {
    id: '1278030004',
    districtId: '1278030',
    name: 'Lolomoyo Tuhemberua',
  },
  {
    id: '1278030005',
    districtId: '1278030',
    name: 'Sihareo Siwahili',
  },
  {
    id: '1278030006',
    districtId: '1278030',
    name: 'Tumori Balohili',
  },
  {
    id: '1278030007',
    districtId: '1278030',
    name: 'Tumori',
  },
  {
    id: '1278030008',
    districtId: '1278030',
    name: 'Orahili Tumori',
  },
  {
    id: '1278030010',
    districtId: '1278030',
    name: 'Ononamolo II Lot',
  },
  {
    id: '1278040001',
    districtId: '1278040',
    name: 'Miga',
  },
  {
    id: '1278040002',
    districtId: '1278040',
    name: 'Sihareo II',
  },
  {
    id: '1278040003',
    districtId: '1278040',
    name: 'Ilir',
  },
  {
    id: '1278040004',
    districtId: '1278040',
    name: 'Sifalaete Tabaloho',
  },
  {
    id: '1278040005',
    districtId: '1278040',
    name: 'Dahana',
  },
  {
    id: '1278040006',
    districtId: '1278040',
    name: 'Sisobahili Tabaloho',
  },
  {
    id: '1278040007',
    districtId: '1278040',
    name: 'Dahadano Gawu Gawu',
  },
  {
    id: '1278040008',
    districtId: '1278040',
    name: 'Lasara Bahili',
  },
  {
    id: '1278040009',
    districtId: '1278040',
    name: 'Mudik',
  },
  {
    id: '1278040010',
    districtId: '1278040',
    name: 'Boyo',
  },
  {
    id: '1278040011',
    districtId: '1278040',
    name: 'Hilina A',
  },
  {
    id: '1278040012',
    districtId: '1278040',
    name: 'Lelewonu Nikootano',
  },
  {
    id: '1278040013',
    districtId: '1278040',
    name: 'Simandraolo',
  },
  {
    id: '1278040014',
    districtId: '1278040',
    name: 'Madolaoli',
  },
  {
    id: '1278040015',
    districtId: '1278040',
    name: 'Sisarahili Sisambalahe',
  },
  {
    id: '1278040016',
    districtId: '1278040',
    name: 'Onowaembo',
  },
  {
    id: '1278040017',
    districtId: '1278040',
    name: 'Fadoro Lasara',
  },
  {
    id: '1278040018',
    districtId: '1278040',
    name: 'Tuhemberua Ulu',
  },
  {
    id: '1278040019',
    districtId: '1278040',
    name: 'Onozitoli Siforoasi',
  },
  {
    id: '1278040020',
    districtId: '1278040',
    name: 'Pasar Gunung Sitoli',
  },
  {
    id: '1278040021',
    districtId: '1278040',
    name: 'Saombo',
  },
  {
    id: '1278040022',
    districtId: '1278040',
    name: 'Iraonogeba',
  },
  {
    id: '1278040023',
    districtId: '1278040',
    name: 'Ombolata Ulu',
  },
  {
    id: '1278040024',
    districtId: '1278040',
    name: 'Moawo',
  },
  {
    id: '1278040025',
    districtId: '1278040',
    name: 'Saewe',
  },
  {
    id: '1278040026',
    districtId: '1278040',
    name: 'Sifalaete Ulu',
  },
  {
    id: '1278040027',
    districtId: '1278040',
    name: 'Hilimbaruzo',
  },
  {
    id: '1278040028',
    districtId: '1278040',
    name: 'Hili Hao',
  },
  {
    id: '1278040029',
    districtId: '1278040',
    name: 'Sisarahili Gamo',
  },
  {
    id: '1278040030',
    districtId: '1278040',
    name: 'Bawadesolo',
  },
  {
    id: '1278040031',
    districtId: '1278040',
    name: 'Onozitoli Olora',
  },
  {
    id: '1278040032',
    districtId: '1278040',
    name: 'Madula',
  },
  {
    id: '1278050001',
    districtId: '1278050',
    name: 'Fadoro You',
  },
  {
    id: '1278050002',
    districtId: '1278050',
    name: 'Nazalou Alooa',
  },
  {
    id: '1278050003',
    districtId: '1278050',
    name: 'Nikootano Dao',
  },
  {
    id: '1278050004',
    districtId: '1278050',
    name: 'Nazalou Lolowua',
  },
  {
    id: '1278050005',
    districtId: '1278050',
    name: 'Lololawa',
  },
  {
    id: '1278050006',
    districtId: '1278050',
    name: 'Orahili Tanoseo',
  },
  {
    id: '1278050007',
    districtId: '1278050',
    name: 'Tarakhaini',
  },
  {
    id: '1278050008',
    districtId: '1278050',
    name: 'Fadoro Hilimbowo',
  },
  {
    id: '1278050009',
    districtId: '1278050',
    name: 'Iraono Lase',
  },
  {
    id: '1278060001',
    districtId: '1278060',
    name: 'Hiligodu Ulu',
  },
  {
    id: '1278060002',
    districtId: '1278060',
    name: 'Hilimbowo Olora',
  },
  {
    id: '1278060003',
    districtId: '1278060',
    name: 'Olora',
  },
  {
    id: '1278060004',
    districtId: '1278060',
    name: 'Gawu Gawu Bouso',
  },
  {
    id: '1278060005',
    districtId: '1278060',
    name: 'Loloanaa / Lolomoyo',
  },
  {
    id: '1278060006',
    districtId: '1278060',
    name: 'Lasara Sowu',
  },
  {
    id: '1278060007',
    districtId: '1278060',
    name: 'Hambawa',
  },
  {
    id: '1278060008',
    districtId: '1278060',
    name: 'Tetehosi Afia',
  },
  {
    id: '1278060009',
    districtId: '1278060',
    name: 'Afia',
  },
  {
    id: '1278060010',
    districtId: '1278060',
    name: 'Teluk Belukar',
  },
  {
    id: '1301011001',
    districtId: '1301011',
    name: 'Bulasat',
  },
  {
    id: '1301011002',
    districtId: '1301011',
    name: 'Sinaka',
  },
  {
    id: '1301011003',
    districtId: '1301011',
    name: 'Makalo',
  },
  {
    id: '1301011004',
    districtId: '1301011',
    name: 'Malakopa',
  },
  {
    id: '1301012001',
    districtId: '1301012',
    name: 'Taikako',
  },
  {
    id: '1301012002',
    districtId: '1301012',
    name: 'Sikakap',
  },
  {
    id: '1301012003',
    districtId: '1301012',
    name: 'Matobe',
  },
  {
    id: '1301013001',
    districtId: '1301013',
    name: 'Saumanganya',
  },
  {
    id: '1301013002',
    districtId: '1301013',
    name: 'Silabu',
  },
  {
    id: '1301013003',
    districtId: '1301013',
    name: 'Betumonga',
  },
  {
    id: '1301021001',
    districtId: '1301021',
    name: 'Bosua',
  },
  {
    id: '1301021002',
    districtId: '1301021',
    name: 'Nemnemleleu',
  },
  {
    id: '1301021003',
    districtId: '1301021',
    name: 'Beriulou',
  },
  {
    id: '1301021004',
    districtId: '1301021',
    name: 'Mara',
  },
  {
    id: '1301021005',
    districtId: '1301021',
    name: 'Sioban',
  },
  {
    id: '1301021006',
    districtId: '1301021',
    name: 'Saureinu',
  },
  {
    id: '1301021007',
    districtId: '1301021',
    name: 'Matobe',
  },
  {
    id: '1301022001',
    districtId: '1301022',
    name: 'Betumonga',
  },
  {
    id: '1301022002',
    districtId: '1301022',
    name: 'Goisooinan',
  },
  {
    id: '1301022003',
    districtId: '1301022',
    name: 'Bukit Pamewa',
  },
  {
    id: '1301022004',
    districtId: '1301022',
    name: 'Sipora Jaya',
  },
  {
    id: '1301022005',
    districtId: '1301022',
    name: 'Sido Makmur',
  },
  {
    id: '1301022006',
    districtId: '1301022',
    name: 'Tuapejat',
  },
  {
    id: '1301030002',
    districtId: '1301030',
    name: 'Madobag',
  },
  {
    id: '1301030004',
    districtId: '1301030',
    name: 'Muara Siberut',
  },
  {
    id: '1301030005',
    districtId: '1301030',
    name: 'Maileppet',
  },
  {
    id: '1301030006',
    districtId: '1301030',
    name: 'Muntei',
  },
  {
    id: '1301030008',
    districtId: '1301030',
    name: 'Matotonan',
  },
  {
    id: '1301031001',
    districtId: '1301031',
    name: 'Pasakiat Teileleu',
  },
  {
    id: '1301031002',
    districtId: '1301031',
    name: 'Katurei',
  },
  {
    id: '1301031003',
    districtId: '1301031',
    name: 'Sagulubbeg',
  },
  {
    id: '1301032001',
    districtId: '1301032',
    name: 'Saliguma',
  },
  {
    id: '1301032002',
    districtId: '1301032',
    name: 'Saibi Samukop',
  },
  {
    id: '1301032003',
    districtId: '1301032',
    name: 'Cimpungan',
  },
  {
    id: '1301040003',
    districtId: '1301040',
    name: 'Sirilogui',
  },
  {
    id: '1301040004',
    districtId: '1301040',
    name: 'Muara Sikabaluan',
  },
  {
    id: '1301040005',
    districtId: '1301040',
    name: 'Mongan Poula',
  },
  {
    id: '1301040006',
    districtId: '1301040',
    name: 'Sotboyak',
  },
  {
    id: '1301040007',
    districtId: '1301040',
    name: 'Bojakan',
  },
  {
    id: '1301040009',
    districtId: '1301040',
    name: 'Malancan',
  },
  {
    id: '1301041001',
    districtId: '1301041',
    name: 'Simatalu',
  },
  {
    id: '1301041002',
    districtId: '1301041',
    name: 'Simalegi',
  },
  {
    id: '1301041003',
    districtId: '1301041',
    name: 'Sigapokna',
  },
  {
    id: '1302011001',
    districtId: '1302011',
    name: 'Silaut',
  },
  {
    id: '1302011002',
    districtId: '1302011',
    name: 'Sambungo',
  },
  {
    id: '1302011003',
    districtId: '1302011',
    name: 'Air Hitam',
  },
  {
    id: '1302011004',
    districtId: '1302011',
    name: 'Lubuk Bunta',
  },
  {
    id: '1302011005',
    districtId: '1302011',
    name: 'Durian Seribu',
  },
  {
    id: '1302011006',
    districtId: '1302011',
    name: 'Pasir Binjai',
  },
  {
    id: '1302011007',
    districtId: '1302011',
    name: 'Talang Binjai',
  },
  {
    id: '1302011008',
    districtId: '1302011',
    name: 'Sungai Sarik',
  },
  {
    id: '1302011009',
    districtId: '1302011',
    name: 'Sungai Pulai',
  },
  {
    id: '1302011010',
    districtId: '1302011',
    name: 'Sungai Sirah',
  },
  {
    id: '1302012001',
    districtId: '1302012',
    name: 'Lunang',
  },
  {
    id: '1302012002',
    districtId: '1302012',
    name: 'Lunang Selatan',
  },
  {
    id: '1302012003',
    districtId: '1302012',
    name: 'Lunang Utara',
  },
  {
    id: '1302012004',
    districtId: '1302012',
    name: 'Lunang Barat',
  },
  {
    id: '1302012005',
    districtId: '1302012',
    name: 'Sindang Lunang',
  },
  {
    id: '1302012006',
    districtId: '1302012',
    name: 'Lunang Satu',
  },
  {
    id: '1302012007',
    districtId: '1302012',
    name: 'Lunang Tengah',
  },
  {
    id: '1302012008',
    districtId: '1302012',
    name: 'Pondok Parian Lunang',
  },
  {
    id: '1302012009',
    districtId: '1302012',
    name: 'Lunang Dua',
  },
  {
    id: '1302012010',
    districtId: '1302012',
    name: 'Lunang Tiga',
  },
  {
    id: '1302020001',
    districtId: '1302020',
    name: 'Tapan',
  },
  {
    id: '1302020003',
    districtId: '1302020',
    name: 'Batang Arah Tapan',
  },
  {
    id: '1302020005',
    districtId: '1302020',
    name: 'Pasar Tapan',
  },
  {
    id: '1302020006',
    districtId: '1302020',
    name: 'Ampang Tulak Tapan',
  },
  {
    id: '1302020009',
    districtId: '1302020',
    name: 'Koto Anau Tapan',
  },
  {
    id: '1302020010',
    districtId: '1302020',
    name: 'Dusun Baru Tapan',
  },
  {
    id: '1302020011',
    districtId: '1302020',
    name: 'Tanjung Pondok Tapan',
  },
  {
    id: '1302020015',
    districtId: '1302020',
    name: 'Batang Betung Tapan',
  },
  {
    id: '1302020016',
    districtId: '1302020',
    name: 'Riak Danau Tapan',
  },
  {
    id: '1302020017',
    districtId: '1302020',
    name: 'Bukit Buai Tapan',
  },
  {
    id: '1302021001',
    districtId: '1302021',
    name: 'Kubu Tapan',
  },
  {
    id: '1302021002',
    districtId: '1302021',
    name: 'Talang Koto Pulai Tapan',
  },
  {
    id: '1302021003',
    districtId: '1302021',
    name: 'Binjai Tapan',
  },
  {
    id: '1302021004',
    districtId: '1302021',
    name: 'Sungai Gambir Sako Tapan',
  },
  {
    id: '1302021005',
    districtId: '1302021',
    name: 'Simpang Gunung Tapan',
  },
  {
    id: '1302021006',
    districtId: '1302021',
    name: 'Kampung Tengah Tapan',
  },
  {
    id: '1302021007',
    districtId: '1302021',
    name: 'Sungai Pinang Tapan',
  },
  {
    id: '1302021008',
    districtId: '1302021',
    name: 'Tebing Tinggi Tapan',
  },
  {
    id: '1302021009',
    districtId: '1302021',
    name: 'Talang Balarik Tapan',
  },
  {
    id: '1302021010',
    districtId: '1302021',
    name: 'Limau Purut Tapan',
  },
  {
    id: '1302030001',
    districtId: '1302030',
    name: 'Inderapura',
  },
  {
    id: '1302030002',
    districtId: '1302030',
    name: 'Muaro Sakai Inderapura',
  },
  {
    id: '1302030003',
    districtId: '1302030',
    name: 'Inderapura Barat',
  },
  {
    id: '1302030004',
    districtId: '1302030',
    name: 'Tigo Sepakat Inderapura',
  },
  {
    id: '1302030005',
    districtId: '1302030',
    name: 'Inderapura Selatan',
  },
  {
    id: '1302030006',
    districtId: '1302030',
    name: 'Kudo-Kudo Inderapura',
  },
  {
    id: '1302030009',
    districtId: '1302030',
    name: 'Simpang Lama Inderapura',
  },
  {
    id: '1302030010',
    districtId: '1302030',
    name: 'Tluk Amplu Indrapura',
  },
  {
    id: '1302030012',
    districtId: '1302030',
    name: 'Inderapura Tengah',
  },
  {
    id: '1302030014',
    districtId: '1302030',
    name: 'Tigo Sungai Inderapura',
  },
  {
    id: '1302031001',
    districtId: '1302031',
    name: 'Inderapura Timur',
  },
  {
    id: '1302031002',
    districtId: '1302031',
    name: 'Inderapura Utara',
  },
  {
    id: '1302031003',
    districtId: '1302031',
    name: 'Pulau Rajo Inderapura',
  },
  {
    id: '1302031004',
    districtId: '1302031',
    name: 'Tluk Kualo Inderapura',
  },
  {
    id: '1302031005',
    districtId: '1302031',
    name: 'Palokan Inderapura',
  },
  {
    id: '1302031006',
    districtId: '1302031',
    name: 'Tanah Bakali Inderapura',
  },
  {
    id: '1302031007',
    districtId: '1302031',
    name: 'Lubuk Betung Inderapura',
  },
  {
    id: '1302031008',
    districtId: '1302031',
    name: 'Damar Lapan Batang Inderapura',
  },
  {
    id: '1302031009',
    districtId: '1302031',
    name: 'Muara Inderapura',
  },
  {
    id: '1302031010',
    districtId: '1302031',
    name: 'Lalang Panjang Inderapura',
  },
  {
    id: '1302040001',
    districtId: '1302040',
    name: 'Aie Haji',
  },
  {
    id: '1302040002',
    districtId: '1302040',
    name: 'Punggasan',
  },
  {
    id: '1302040003',
    districtId: '1302040',
    name: 'Punggasan Timur',
  },
  {
    id: '1302040004',
    districtId: '1302040',
    name: 'Padang XI Punggasan',
  },
  {
    id: '1302040005',
    districtId: '1302040',
    name: 'Lagan Mudik Punggasan',
  },
  {
    id: '1302040006',
    districtId: '1302040',
    name: 'Lagan Hilir Punggasan',
  },
  {
    id: '1302040007',
    districtId: '1302040',
    name: 'Punggasan Utara',
  },
  {
    id: '1302040008',
    districtId: '1302040',
    name: 'Muara Gadang Air Haji',
  },
  {
    id: '1302040009',
    districtId: '1302040',
    name: 'Air Haji Barat',
  },
  {
    id: '1302040010',
    districtId: '1302040',
    name: 'Pasar Bukit Air Haji',
  },
  {
    id: '1302040011',
    districtId: '1302040',
    name: 'Sungai Sirah Air Haji',
  },
  {
    id: '1302040012',
    districtId: '1302040',
    name: 'Rantau Simalenang Air Haji',
  },
  {
    id: '1302040013',
    districtId: '1302040',
    name: 'Air Haji Tengah',
  },
  {
    id: '1302040014',
    districtId: '1302040',
    name: 'Pasar Lama Muara Air Haji',
  },
  {
    id: '1302040015',
    districtId: '1302040',
    name: 'Air Haji Tenggara',
  },
  {
    id: '1302040016',
    districtId: '1302040',
    name: 'Muara Kandis Punggasan',
  },
  {
    id: '1302050001',
    districtId: '1302050',
    name: 'Sungai Tunu',
  },
  {
    id: '1302050002',
    districtId: '1302050',
    name: 'Palangai',
  },
  {
    id: '1302050003',
    districtId: '1302050',
    name: 'Sungai Tunu Barat',
  },
  {
    id: '1302050004',
    districtId: '1302050',
    name: 'Sungai Tunu Utara',
  },
  {
    id: '1302050005',
    districtId: '1302050',
    name: 'Nyiur Melambai Pelangai',
  },
  {
    id: '1302050006',
    districtId: '1302050',
    name: 'Pelangai Kaciak',
  },
  {
    id: '1302050007',
    districtId: '1302050',
    name: 'Pelangai Gadang',
  },
  {
    id: '1302050008',
    districtId: '1302050',
    name: 'Koto VIII Pelangai',
  },
  {
    id: '1302050009',
    districtId: '1302050',
    name: 'Pasia Pelangai',
  },
  {
    id: '1302050010',
    districtId: '1302050',
    name: 'Sungai Liku Pelangai',
  },
  {
    id: '1302060001',
    districtId: '1302060',
    name: 'Lakitan',
  },
  {
    id: '1302060002',
    districtId: '1302060',
    name: 'Kambang',
  },
  {
    id: '1302060003',
    districtId: '1302060',
    name: 'Lakitan Selatan',
  },
  {
    id: '1302060004',
    districtId: '1302060',
    name: 'Lakitan Tengah',
  },
  {
    id: '1302060005',
    districtId: '1302060',
    name: 'Lakitan Timur',
  },
  {
    id: '1302060006',
    districtId: '1302060',
    name: 'Lakitan Utara',
  },
  {
    id: '1302060007',
    districtId: '1302060',
    name: 'Kambang Barat',
  },
  {
    id: '1302060008',
    districtId: '1302060',
    name: 'Kambang Utara',
  },
  {
    id: '1302060009',
    districtId: '1302060',
    name: 'Kambang Timur',
  },
  {
    id: '1302070001',
    districtId: '1302070',
    name: 'Amping Parak',
  },
  {
    id: '1302070002',
    districtId: '1302070',
    name: 'Surantih',
  },
  {
    id: '1302070003',
    districtId: '1302070',
    name: 'Taratak',
  },
  {
    id: '1302070004',
    districtId: '1302070',
    name: 'Amping Parak Timur',
  },
  {
    id: '1302070005',
    districtId: '1302070',
    name: 'Aur Duri Surantih',
  },
  {
    id: '1302070006',
    districtId: '1302070',
    name: 'Rawang Gunung Malelo Surantih',
  },
  {
    id: '1302070007',
    districtId: '1302070',
    name: 'Koto Nan Tigo Selatan Surantih',
  },
  {
    id: '1302070008',
    districtId: '1302070',
    name: 'Koto Nan Tigo Utara Surantih',
  },
  {
    id: '1302070009',
    districtId: '1302070',
    name: 'Gantiang Mudiak Selatan Surantih',
  },
  {
    id: '1302070010',
    districtId: '1302070',
    name: 'Gantiang Mudiak Utara Surantih',
  },
  {
    id: '1302070011',
    districtId: '1302070',
    name: 'Lansano Taratak',
  },
  {
    id: '1302070012',
    districtId: '1302070',
    name: 'Koto Taratak',
  },
  {
    id: '1302080001',
    districtId: '1302080',
    name: 'IV Koto Hilie',
  },
  {
    id: '1302080002',
    districtId: '1302080',
    name: 'IV Koto Mudiek',
  },
  {
    id: '1302080003',
    districtId: '1302080',
    name: 'Taluk',
  },
  {
    id: '1302080004',
    districtId: '1302080',
    name: 'Koto Nan Tigo IV Koto Hilie',
  },
  {
    id: '1302080005',
    districtId: '1302080',
    name: 'Koto Nan Duo IV Koto Hilie',
  },
  {
    id: '1302080006',
    districtId: '1302080',
    name: 'Sungai Nyalo IV Koto Mudiek',
  },
  {
    id: '1302080007',
    districtId: '1302080',
    name: 'Tuik IV Koto Mudiek',
  },
  {
    id: '1302080008',
    districtId: '1302080',
    name: 'Taratak Tempatih IV Koto Mudiek',
  },
  {
    id: '1302080009',
    districtId: '1302080',
    name: 'Taluk Tigo Sakato',
  },
  {
    id: '1302090001',
    districtId: '1302090',
    name: 'Salido',
  },
  {
    id: '1302090002',
    districtId: '1302090',
    name: 'Painan',
  },
  {
    id: '1302090003',
    districtId: '1302090',
    name: 'Lumpo',
  },
  {
    id: '1302090004',
    districtId: '1302090',
    name: 'Tambang',
  },
  {
    id: '1302090005',
    districtId: '1302090',
    name: 'Bungo Pasang Salido',
  },
  {
    id: '1302090006',
    districtId: '1302090',
    name: 'Sago Salido',
  },
  {
    id: '1302090007',
    districtId: '1302090',
    name: 'Painan Selatan Painan',
  },
  {
    id: '1302090008',
    districtId: '1302090',
    name: 'Painan Timur Painan',
  },
  {
    id: '1302090009',
    districtId: '1302090',
    name: 'Bukik Kaciak Lumpo',
  },
  {
    id: '1302090010',
    districtId: '1302090',
    name: 'Sungai Sariak Lumpo',
  },
  {
    id: '1302090011',
    districtId: '1302090',
    name: 'Sungai Gayo Lumpo',
  },
  {
    id: '1302090012',
    districtId: '1302090',
    name: 'Gunung Bungkuak Lumpo',
  },
  {
    id: '1302090013',
    districtId: '1302090',
    name: 'Ampang Tareh Lumpo',
  },
  {
    id: '1302090014',
    districtId: '1302090',
    name: 'Ampuan Lumpo',
  },
  {
    id: '1302090015',
    districtId: '1302090',
    name: 'Balai Sinayan Lumpo',
  },
  {
    id: '1302090016',
    districtId: '1302090',
    name: 'Taratak Tangah Lumpo',
  },
  {
    id: '1302090017',
    districtId: '1302090',
    name: 'Batu Kunik Lumpo',
  },
  {
    id: '1302090018',
    districtId: '1302090',
    name: 'Limau Gadang Lumpo',
  },
  {
    id: '1302090019',
    districtId: '1302090',
    name: 'Koto Rawang',
  },
  {
    id: '1302090020',
    districtId: '1302090',
    name: 'Salido Sari Bulan',
  },
  {
    id: '1302100001',
    districtId: '1302100',
    name: 'Pasar Baru',
  },
  {
    id: '1302100002',
    districtId: '1302100',
    name: 'Talaok',
  },
  {
    id: '1302100003',
    districtId: '1302100',
    name: 'Koto Barapak',
  },
  {
    id: '1302100004',
    districtId: '1302100',
    name: 'Gurun Panjang',
  },
  {
    id: '1302100005',
    districtId: '1302100',
    name: 'Api-Api Pasar Baru',
  },
  {
    id: '1302100006',
    districtId: '1302100',
    name: 'Tanjung Durian Pasar Baru',
  },
  {
    id: '1302100007',
    districtId: '1302100',
    name: 'Asam Kamba Pasar Baru',
  },
  {
    id: '1302100008',
    districtId: '1302100',
    name: 'Sawah Laweh Pasar Baru',
  },
  {
    id: '1302100009',
    districtId: '1302100',
    name: 'Kapeh Panji Jaya Talaok',
  },
  {
    id: '1302100010',
    districtId: '1302100',
    name: 'Aur Begalung Talaok',
  },
  {
    id: '1302100011',
    districtId: '1302100',
    name: 'Kapelgam Koto Barapak',
  },
  {
    id: '1302100012',
    districtId: '1302100',
    name: 'Kapujan Koto Barapak',
  },
  {
    id: '1302100013',
    districtId: '1302100',
    name: 'Koto Baru Koto Barapak',
  },
  {
    id: '1302100014',
    districtId: '1302100',
    name: 'Kubang Koto Barapak',
  },
  {
    id: '1302100015',
    districtId: '1302100',
    name: 'Gurun Panjang Selatan',
  },
  {
    id: '1302100016',
    districtId: '1302100',
    name: 'Gurun Panjang Utara',
  },
  {
    id: '1302100017',
    districtId: '1302100',
    name: 'Gurun Panjang Barat',
  },
  {
    id: '1302101001',
    districtId: '1302101',
    name: 'Puluik Puluik',
  },
  {
    id: '1302101002',
    districtId: '1302101',
    name: 'Koto Ranah',
  },
  {
    id: '1302101003',
    districtId: '1302101',
    name: 'Muaro Aie',
  },
  {
    id: '1302101004',
    districtId: '1302101',
    name: 'Pancuang Taba',
  },
  {
    id: '1302101005',
    districtId: '1302101',
    name: 'Puluik Puluik Selatan',
  },
  {
    id: '1302101006',
    districtId: '1302101',
    name: 'Limau Gadang Pancung Taba',
  },
  {
    id: '1302110001',
    districtId: '1302110',
    name: 'Kapuh',
  },
  {
    id: '1302110002',
    districtId: '1302110',
    name: 'Ampang Pulai',
  },
  {
    id: '1302110003',
    districtId: '1302110',
    name: 'Nanggalo',
  },
  {
    id: '1302110004',
    districtId: '1302110',
    name: 'Batu Hampar',
  },
  {
    id: '1302110005',
    districtId: '1302110',
    name: 'Duku',
  },
  {
    id: '1302110006',
    districtId: '1302110',
    name: 'Barung Barung Balantai',
  },
  {
    id: '1302110007',
    districtId: '1302110',
    name: 'Sungai Pinang',
  },
  {
    id: '1302110008',
    districtId: '1302110',
    name: 'Siguntur',
  },
  {
    id: '1302110009',
    districtId: '1302110',
    name: 'Taratak Sungai Lundang',
  },
  {
    id: '1302110010',
    districtId: '1302110',
    name: 'Kapuh Utara',
  },
  {
    id: '1302110011',
    districtId: '1302110',
    name: 'Mandeh',
  },
  {
    id: '1302110012',
    districtId: '1302110',
    name: 'Barung Barung Balantai Selatan',
  },
  {
    id: '1302110013',
    districtId: '1302110',
    name: 'Jinang Kampung Pansur Ampang Pulai',
  },
  {
    id: '1302110014',
    districtId: '1302110',
    name: 'Pulau Karam Ampang Pulai',
  },
  {
    id: '1302110015',
    districtId: '1302110',
    name: 'Cerocok Anau Ampang Pulai',
  },
  {
    id: '1302110016',
    districtId: '1302110',
    name: 'Sungai Nyalo Mudiak Aie',
  },
  {
    id: '1302110017',
    districtId: '1302110',
    name: 'Setara Nanggalo',
  },
  {
    id: '1302110018',
    districtId: '1302110',
    name: 'Batu Hampar Selatan',
  },
  {
    id: '1302110019',
    districtId: '1302110',
    name: 'Duku Utara',
  },
  {
    id: '1302110020',
    districtId: '1302110',
    name: 'Barung-Barung Balantai Timur',
  },
  {
    id: '1302110021',
    districtId: '1302110',
    name: 'Siguntur Tua',
  },
  {
    id: '1302110022',
    districtId: '1302110',
    name: 'Kampung Baru Korong Nan Ampek',
  },
  {
    id: '1302110023',
    districtId: '1302110',
    name: 'Barung-Barung Balantai Tengah',
  },
  {
    id: '1303040001',
    districtId: '1303040',
    name: 'Surian',
  },
  {
    id: '1303040002',
    districtId: '1303040',
    name: 'Lolo',
  },
  {
    id: '1303050001',
    districtId: '1303050',
    name: 'Alahan Panjang',
  },
  {
    id: '1303050002',
    districtId: '1303050',
    name: 'Sungai Nanam',
  },
  {
    id: '1303050003',
    districtId: '1303050',
    name: 'Salimpek',
  },
  {
    id: '1303050004',
    districtId: '1303050',
    name: 'Aie Dingin',
  },
  {
    id: '1303051001',
    districtId: '1303051',
    name: 'Sungai Abu',
  },
  {
    id: '1303051002',
    districtId: '1303051',
    name: 'Sariak Alahan Tigo',
  },
  {
    id: '1303051003',
    districtId: '1303051',
    name: 'Talang Babungo',
  },
  {
    id: '1303060001',
    districtId: '1303060',
    name: 'Sirukam',
  },
  {
    id: '1303060002',
    districtId: '1303060',
    name: 'Supayang',
  },
  {
    id: '1303060003',
    districtId: '1303060',
    name: 'Aia Luo',
  },
  {
    id: '1303061001',
    districtId: '1303061',
    name: 'Rangkiang Luluih',
  },
  {
    id: '1303061002',
    districtId: '1303061',
    name: 'Batu Bajanjang',
  },
  {
    id: '1303061003',
    districtId: '1303061',
    name: 'Simanau',
  },
  {
    id: '1303061004',
    districtId: '1303061',
    name: 'Tanjuang Balik Sumiso',
  },
  {
    id: '1303061005',
    districtId: '1303061',
    name: 'Garabak Data',
  },
  {
    id: '1303070001',
    districtId: '1303070',
    name: 'Koto Anau',
  },
  {
    id: '1303070002',
    districtId: '1303070',
    name: 'Batu Banyak',
  },
  {
    id: '1303070003',
    districtId: '1303070',
    name: 'Limau Lunggo',
  },
  {
    id: '1303070004',
    districtId: '1303070',
    name: 'Koto Laweh',
  },
  {
    id: '1303070005',
    districtId: '1303070',
    name: 'Salayo Tanang Bukik Sileh',
  },
  {
    id: '1303070006',
    districtId: '1303070',
    name: 'Batu Bajanjang',
  },
  {
    id: '1303071001',
    districtId: '1303071',
    name: 'Kampuang Batu Dalam',
  },
  {
    id: '1303071002',
    districtId: '1303071',
    name: 'Simpang Tanjuang Nan IV',
  },
  {
    id: '1303080001',
    districtId: '1303080',
    name: 'Cupak',
  },
  {
    id: '1303080002',
    districtId: '1303080',
    name: 'Talang',
  },
  {
    id: '1303080003',
    districtId: '1303080',
    name: 'Sungai Janiah',
  },
  {
    id: '1303080004',
    districtId: '1303080',
    name: 'Koto Gadang Guguak',
  },
  {
    id: '1303080005',
    districtId: '1303080',
    name: 'Koto Gaek Guguak',
  },
  {
    id: '1303080006',
    districtId: '1303080',
    name: 'Jawi-Jawi Guguak',
  },
  {
    id: '1303080007',
    districtId: '1303080',
    name: 'Batang Barus',
  },
  {
    id: '1303080008',
    districtId: '1303080',
    name: 'Aia Batumbuak',
  },
  {
    id: '1303090001',
    districtId: '1303090',
    name: 'Muaro Paneh',
  },
  {
    id: '1303090002',
    districtId: '1303090',
    name: 'Kinari',
  },
  {
    id: '1303090003',
    districtId: '1303090',
    name: 'Parambahan',
  },
  {
    id: '1303090004',
    districtId: '1303090',
    name: 'Dilam',
  },
  {
    id: '1303090005',
    districtId: '1303090',
    name: 'Bukik Tandang',
  },
  {
    id: '1303100001',
    districtId: '1303100',
    name: 'Pianggu',
  },
  {
    id: '1303100002',
    districtId: '1303100',
    name: 'Taruang-Taruang',
  },
  {
    id: '1303100003',
    districtId: '1303100',
    name: 'Siaro-Aro',
  },
  {
    id: '1303100004',
    districtId: '1303100',
    name: 'Indudua',
  },
  {
    id: '1303100005',
    districtId: '1303100',
    name: 'Guguak Sarai',
  },
  {
    id: '1303100006',
    districtId: '1303100',
    name: 'Sungai Durian',
  },
  {
    id: '1303100007',
    districtId: '1303100',
    name: 'Bukit Bais',
  },
  {
    id: '1303100008',
    districtId: '1303100',
    name: 'Koto Laweh',
  },
  {
    id: '1303100009',
    districtId: '1303100',
    name: 'Sungai Jambua',
  },
  {
    id: '1303110001',
    districtId: '1303110',
    name: 'Gauang',
  },
  {
    id: '1303110002',
    districtId: '1303110',
    name: 'Panyakalan',
  },
  {
    id: '1303110003',
    districtId: '1303110',
    name: 'Saok Laweh',
  },
  {
    id: '1303110004',
    districtId: '1303110',
    name: 'Tanjuang Bingkuang',
  },
  {
    id: '1303110005',
    districtId: '1303110',
    name: 'Gantuang Ciri',
  },
  {
    id: '1303110006',
    districtId: '1303110',
    name: 'Koto Hilalang',
  },
  {
    id: '1303110007',
    districtId: '1303110',
    name: 'Selayo',
  },
  {
    id: '1303110008',
    districtId: '1303110',
    name: 'Koto Baru',
  },
  {
    id: '1303120001',
    districtId: '1303120',
    name: 'Katialo',
  },
  {
    id: '1303120002',
    districtId: '1303120',
    name: 'Tanjuang Balik',
  },
  {
    id: '1303120003',
    districtId: '1303120',
    name: 'Paninjauan',
  },
  {
    id: '1303120004',
    districtId: '1303120',
    name: 'Labuah Panjang',
  },
  {
    id: '1303120005',
    districtId: '1303120',
    name: 'Sulik Aia',
  },
  {
    id: '1303120006',
    districtId: '1303120',
    name: 'Pasilihan',
  },
  {
    id: '1303120007',
    districtId: '1303120',
    name: 'Bukik Kanduang',
  },
  {
    id: '1303120008',
    districtId: '1303120',
    name: 'Kuncia',
  },
  {
    id: '1303120009',
    districtId: '1303120',
    name: 'Siberambang',
  },
  {
    id: '1303130001',
    districtId: '1303130',
    name: 'Kacang',
  },
  {
    id: '1303130002',
    districtId: '1303130',
    name: 'Tikalak',
  },
  {
    id: '1303130003',
    districtId: '1303130',
    name: 'Singkarak',
  },
  {
    id: '1303130004',
    districtId: '1303130',
    name: 'Sumani',
  },
  {
    id: '1303130005',
    districtId: '1303130',
    name: 'Saniang Baka',
  },
  {
    id: '1303130006',
    districtId: '1303130',
    name: 'Koto Sani',
  },
  {
    id: '1303130007',
    districtId: '1303130',
    name: 'Tanjuang Alai',
  },
  {
    id: '1303130008',
    districtId: '1303130',
    name: 'Aripan',
  },
  {
    id: '1303140001',
    districtId: '1303140',
    name: 'Muaro Pingai',
  },
  {
    id: '1303140002',
    districtId: '1303140',
    name: 'Paninggahan',
  },
  {
    id: '1304050001',
    districtId: '1304050',
    name: 'Sungai Lansek',
  },
  {
    id: '1304050002',
    districtId: '1304050',
    name: 'Muaro Takung',
  },
  {
    id: '1304050003',
    districtId: '1304050',
    name: 'Kunangan Parit Rantang',
  },
  {
    id: '1304050004',
    districtId: '1304050',
    name: 'Kamang',
  },
  {
    id: '1304050005',
    districtId: '1304050',
    name: 'Air Amo',
  },
  {
    id: '1304050006',
    districtId: '1304050',
    name: 'Sungai Batuang',
  },
  {
    id: '1304050007',
    districtId: '1304050',
    name: 'Siaur',
  },
  {
    id: '1304050008',
    districtId: '1304050',
    name: 'Lubuk Tarantang',
  },
  {
    id: '1304050009',
    districtId: '1304050',
    name: 'Maloro',
  },
  {
    id: '1304050010',
    districtId: '1304050',
    name: 'Tanjung Kaliang',
  },
  {
    id: '1304050011',
    districtId: '1304050',
    name: 'Padang Tarok',
  },
  {
    id: '1304060001',
    districtId: '1304060',
    name: 'Langki',
  },
  {
    id: '1304060002',
    districtId: '1304060',
    name: 'Sibakur',
  },
  {
    id: '1304060003',
    districtId: '1304060',
    name: 'Pulasan',
  },
  {
    id: '1304060004',
    districtId: '1304060',
    name: 'Tanjung Lolo',
  },
  {
    id: '1304060005',
    districtId: '1304060',
    name: 'Tanjung Gadang',
  },
  {
    id: '1304060006',
    districtId: '1304060',
    name: 'Taratak Baru',
  },
  {
    id: '1304060007',
    districtId: '1304060',
    name: 'Timbulun',
  },
  {
    id: '1304060008',
    districtId: '1304060',
    name: 'Sinyamu',
  },
  {
    id: '1304060009',
    districtId: '1304060',
    name: 'Taratak Baru Utara',
  },
  {
    id: '1304070001',
    districtId: '1304070',
    name: 'Muaro',
  },
  {
    id: '1304070002',
    districtId: '1304070',
    name: 'Kandang Baru',
  },
  {
    id: '1304070003',
    districtId: '1304070',
    name: 'Pematang Panjang',
  },
  {
    id: '1304070004',
    districtId: '1304070',
    name: 'Sijunjung',
  },
  {
    id: '1304070005',
    districtId: '1304070',
    name: 'Aia Angek',
  },
  {
    id: '1304070006',
    districtId: '1304070',
    name: 'Solok Ambah',
  },
  {
    id: '1304070007',
    districtId: '1304070',
    name: 'Paruh',
  },
  {
    id: '1304070008',
    districtId: '1304070',
    name: 'Muaro Silokek',
  },
  {
    id: '1304070009',
    districtId: '1304070',
    name: 'Durian Gadang',
  },
  {
    id: '1304071001',
    districtId: '1304071',
    name: 'Buluh Kasok',
  },
  {
    id: '1304071002',
    districtId: '1304071',
    name: 'Lubuk Tarok',
  },
  {
    id: '1304071003',
    districtId: '1304071',
    name: 'Lalan',
  },
  {
    id: '1304071004',
    districtId: '1304071',
    name: 'Silongo',
  },
  {
    id: '1304071005',
    districtId: '1304071',
    name: 'Kampung Dalam',
  },
  {
    id: '1304071006',
    districtId: '1304071',
    name: 'Latang',
  },
  {
    id: '1304080001',
    districtId: '1304080',
    name: 'Mundam Sakti',
  },
  {
    id: '1304080002',
    districtId: '1304080',
    name: 'Koto Baru',
  },
  {
    id: '1304080003',
    districtId: '1304080',
    name: 'Muaro Bodi',
  },
  {
    id: '1304080004',
    districtId: '1304080',
    name: 'Palangki',
  },
  {
    id: '1304080005',
    districtId: '1304080',
    name: 'Koto Tuo',
  },
  {
    id: '1304090001',
    districtId: '1304090',
    name: 'Batu Manjulua',
  },
  {
    id: '1304090002',
    districtId: '1304090',
    name: 'Padang Sibusuak',
  },
  {
    id: '1304090003',
    districtId: '1304090',
    name: 'Pamuatan',
  },
  {
    id: '1304090004',
    districtId: '1304090',
    name: 'Kampung Baru',
  },
  {
    id: '1304100001',
    districtId: '1304100',
    name: 'Limo Koto',
  },
  {
    id: '1304100002',
    districtId: '1304100',
    name: 'Padang Laweh',
  },
  {
    id: '1304100003',
    districtId: '1304100',
    name: 'Tanjung',
  },
  {
    id: '1304100004',
    districtId: '1304100',
    name: 'Palaluar',
  },
  {
    id: '1304100005',
    districtId: '1304100',
    name: 'Guguk',
  },
  {
    id: '1304100006',
    districtId: '1304100',
    name: 'Bukit Bual',
  },
  {
    id: '1304100007',
    districtId: '1304100',
    name: 'Padang Laweh Selatan',
  },
  {
    id: '1304110001',
    districtId: '1304110',
    name: 'Kumanis',
  },
  {
    id: '1304110002',
    districtId: '1304110',
    name: 'Tanjung Bonai Aur',
  },
  {
    id: '1304110003',
    districtId: '1304110',
    name: 'Sisawah',
  },
  {
    id: '1304110004',
    districtId: '1304110',
    name: 'Tamparungo',
  },
  {
    id: '1304110005',
    districtId: '1304110',
    name: 'Sumpur Kudus',
  },
  {
    id: '1304110006',
    districtId: '1304110',
    name: 'Mengganti',
  },
  {
    id: '1304110007',
    districtId: '1304110',
    name: 'Sepakat Silantai',
  },
  {
    id: '1304110008',
    districtId: '1304110',
    name: 'Unggan',
  },
  {
    id: '1304110009',
    districtId: '1304110',
    name: 'Tanjung Bonai Aur Selatan',
  },
  {
    id: '1304110010',
    districtId: '1304110',
    name: 'Tanjuang Labuah',
  },
  {
    id: '1304110011',
    districtId: '1304110',
    name: 'Sumpur Kudus Selatan',
  },
  {
    id: '1305010001',
    districtId: '1305010',
    name: 'Tambangan',
  },
  {
    id: '1305010002',
    districtId: '1305010',
    name: 'Jaho',
  },
  {
    id: '1305010003',
    districtId: '1305010',
    name: 'Paninjauan',
  },
  {
    id: '1305010004',
    districtId: '1305010',
    name: 'Panyalaian',
  },
  {
    id: '1305010005',
    districtId: '1305010',
    name: 'Aie Angek',
  },
  {
    id: '1305010006',
    districtId: '1305010',
    name: 'Koto Baru',
  },
  {
    id: '1305010007',
    districtId: '1305010',
    name: 'Pandai Sikek',
  },
  {
    id: '1305010008',
    districtId: '1305010',
    name: 'Singgalang',
  },
  {
    id: '1305010009',
    districtId: '1305010',
    name: 'Koto Laweh',
  },
  {
    id: '1305020001',
    districtId: '1305020',
    name: 'Tanjung Barulak',
  },
  {
    id: '1305020002',
    districtId: '1305020',
    name: 'Bungo Tanjung',
  },
  {
    id: '1305020003',
    districtId: '1305020',
    name: 'Pitalah',
  },
  {
    id: '1305020004',
    districtId: '1305020',
    name: 'Gunung Rajo',
  },
  {
    id: '1305020005',
    districtId: '1305020',
    name: 'Batipuh Baruah',
  },
  {
    id: '1305020006',
    districtId: '1305020',
    name: 'Batipuah Ateh',
  },
  {
    id: '1305020007',
    districtId: '1305020',
    name: 'Sabu',
  },
  {
    id: '1305020008',
    districtId: '1305020',
    name: 'Andaleh',
  },
  {
    id: '1305021001',
    districtId: '1305021',
    name: 'Guguak Malalo',
  },
  {
    id: '1305021002',
    districtId: '1305021',
    name: 'Padang Laweh Malalo',
  },
  {
    id: '1305021003',
    districtId: '1305021',
    name: 'Sumpur',
  },
  {
    id: '1305021004',
    districtId: '1305021',
    name: 'Batu Taba',
  },
  {
    id: '1305030001',
    districtId: '1305030',
    name: 'Batu Basa',
  },
  {
    id: '1305030002',
    districtId: '1305030',
    name: 'Tabek',
  },
  {
    id: '1305030003',
    districtId: '1305030',
    name: 'Sawah Tangah',
  },
  {
    id: '1305030004',
    districtId: '1305030',
    name: 'Simabur',
  },
  {
    id: '1305030005',
    districtId: '1305030',
    name: 'Pariangan',
  },
  {
    id: '1305030006',
    districtId: '1305030',
    name: 'Sungai Jambu',
  },
  {
    id: '1305040001',
    districtId: '1305040',
    name: 'Simawang',
  },
  {
    id: '1305040002',
    districtId: '1305040',
    name: 'Balimbiang',
  },
  {
    id: '1305040003',
    districtId: '1305040',
    name: 'III Koto',
  },
  {
    id: '1305040004',
    districtId: '1305040',
    name: 'Padang Magek',
  },
  {
    id: '1305040005',
    districtId: '1305040',
    name: 'Rambatan',
  },
  {
    id: '1305050001',
    districtId: '1305050',
    name: 'Cubadak',
  },
  {
    id: '1305050002',
    districtId: '1305050',
    name: 'Parambahan',
  },
  {
    id: '1305050003',
    districtId: '1305050',
    name: 'Labuh',
  },
  {
    id: '1305050004',
    districtId: '1305050',
    name: 'Lima Kaum',
  },
  {
    id: '1305050005',
    districtId: '1305050',
    name: 'Baringin',
  },
  {
    id: '1305060001',
    districtId: '1305060',
    name: 'Pagaruyung',
  },
  {
    id: '1305060002',
    districtId: '1305060',
    name: 'Saruaso',
  },
  {
    id: '1305060003',
    districtId: '1305060',
    name: 'Koto Tangah',
  },
  {
    id: '1305060004',
    districtId: '1305060',
    name: 'Tanjung Barulak',
  },
  {
    id: '1305070001',
    districtId: '1305070',
    name: 'Padang Ganting',
  },
  {
    id: '1305070002',
    districtId: '1305070',
    name: 'Atar',
  },
  {
    id: '1305080001',
    districtId: '1305080',
    name: 'Taluak',
  },
  {
    id: '1305080002',
    districtId: '1305080',
    name: 'Tigo Jangko',
  },
  {
    id: '1305080003',
    districtId: '1305080',
    name: 'Pangian',
  },
  {
    id: '1305080004',
    districtId: '1305080',
    name: 'Buo',
  },
  {
    id: '1305081001',
    districtId: '1305081',
    name: 'Tepi Selo',
  },
  {
    id: '1305081002',
    districtId: '1305081',
    name: 'Lubuak Jantan',
  },
  {
    id: '1305081003',
    districtId: '1305081',
    name: 'Balai Tangah',
  },
  {
    id: '1305081004',
    districtId: '1305081',
    name: 'Batu Bulek',
  },
  {
    id: '1305081005',
    districtId: '1305081',
    name: 'Tanjuang Bonai',
  },
  {
    id: '1305090001',
    districtId: '1305090',
    name: 'Minangkabau',
  },
  {
    id: '1305090002',
    districtId: '1305090',
    name: 'Andaleh Baruh Bukik',
  },
  {
    id: '1305090003',
    districtId: '1305090',
    name: 'Sungayang',
  },
  {
    id: '1305090004',
    districtId: '1305090',
    name: 'Tanjuang',
  },
  {
    id: '1305090005',
    districtId: '1305090',
    name: 'Sungai Patai',
  },
  {
    id: '1305100001',
    districtId: '1305100',
    name: 'Talang Tangah',
  },
  {
    id: '1305100002',
    districtId: '1305100',
    name: 'Gurun',
  },
  {
    id: '1305100003',
    districtId: '1305100',
    name: 'Simpuruik',
  },
  {
    id: '1305100004',
    districtId: '1305100',
    name: 'Sungai Tarab',
  },
  {
    id: '1305100005',
    districtId: '1305100',
    name: 'Padang Laweh',
  },
  {
    id: '1305100006',
    districtId: '1305100',
    name: 'Koto Tuo',
  },
  {
    id: '1305100007',
    districtId: '1305100',
    name: 'Pasie Laweh',
  },
  {
    id: '1305100008',
    districtId: '1305100',
    name: 'Kumango',
  },
  {
    id: '1305100009',
    districtId: '1305100',
    name: 'Rao Rao',
  },
  {
    id: '1305100010',
    districtId: '1305100',
    name: 'Koto Baru',
  },
  {
    id: '1305110001',
    districtId: '1305110',
    name: 'Tabek Patah',
  },
  {
    id: '1305110002',
    districtId: '1305110',
    name: 'Lawang Mandahiliang',
  },
  {
    id: '1305110003',
    districtId: '1305110',
    name: 'Salimpaung',
  },
  {
    id: '1305110004',
    districtId: '1305110',
    name: 'Supayang',
  },
  {
    id: '1305110005',
    districtId: '1305110',
    name: 'Situmbuk',
  },
  {
    id: '1305110006',
    districtId: '1305110',
    name: 'Sumaniak',
  },
  {
    id: '1305111001',
    districtId: '1305111',
    name: 'Tanjuang Alam',
  },
  {
    id: '1305111002',
    districtId: '1305111',
    name: 'Barulak',
  },
  {
    id: '1306010001',
    districtId: '1306010',
    name: 'Katapiang',
  },
  {
    id: '1306010002',
    districtId: '1306010',
    name: 'Kasang',
  },
  {
    id: '1306010003',
    districtId: '1306010',
    name: 'Sungai Buluh',
  },
  {
    id: '1306010004',
    districtId: '1306010',
    name: 'Buayan Lubuk Alung',
  },
  {
    id: '1306010005',
    districtId: '1306010',
    name: 'Sungai Buluh Selatan',
  },
  {
    id: '1306010006',
    districtId: '1306010',
    name: 'Sungai Buluh Barat',
  },
  {
    id: '1306010007',
    districtId: '1306010',
    name: 'Sungai Buluh Timur',
  },
  {
    id: '1306010008',
    districtId: '1306010',
    name: 'Sungai Buluh Utara',
  },
  {
    id: '1306020001',
    districtId: '1306020',
    name: 'Lubuk Alung',
  },
  {
    id: '1306020002',
    districtId: '1306020',
    name: 'Aie Tajun Lubuk Alung',
  },
  {
    id: '1306020003',
    districtId: '1306020',
    name: 'Sikabu Lubuk Alung',
  },
  {
    id: '1306020004',
    districtId: '1306020',
    name: 'Pasie Laweh Lubuk Alung',
  },
  {
    id: '1306020005',
    districtId: '1306020',
    name: 'Punggung Kasiak Lubuk Alung',
  },
  {
    id: '1306020006',
    districtId: '1306020',
    name: 'Balah Hilia Lubuk Alung',
  },
  {
    id: '1306020007',
    districtId: '1306020',
    name: 'Sungai Abang Lubuk Alung',
  },
  {
    id: '1306020008',
    districtId: '1306020',
    name: 'Singguling Lubuk Alung',
  },
  {
    id: '1306020009',
    districtId: '1306020',
    name: 'Salibutan Lubuk Alung',
  },
  {
    id: '1306021001',
    districtId: '1306021',
    name: 'Toboh Gadang',
  },
  {
    id: '1306021002',
    districtId: '1306021',
    name: 'Sintuk',
  },
  {
    id: '1306021003',
    districtId: '1306021',
    name: 'Toboh Gadang Barat',
  },
  {
    id: '1306021004',
    districtId: '1306021',
    name: 'Toboh Gadang Selatan',
  },
  {
    id: '1306021005',
    districtId: '1306021',
    name: 'Toboh Gadang Timur',
  },
  {
    id: '1306030001',
    districtId: '1306030',
    name: 'Tapakis',
  },
  {
    id: '1306030002',
    districtId: '1306030',
    name: 'Ulakan',
  },
  {
    id: '1306030003',
    districtId: '1306030',
    name: 'Seulayat Ulakan',
  },
  {
    id: '1306030004',
    districtId: '1306030',
    name: 'Sungai Gimba Ulakan',
  },
  {
    id: '1306030005',
    districtId: '1306030',
    name: 'Manggopoh Palak Gadang Ulakan',
  },
  {
    id: '1306030006',
    districtId: '1306030',
    name: 'Sandi Ulakan',
  },
  {
    id: '1306030007',
    districtId: '1306030',
    name: 'Kampuang Galapuang Ulakan',
  },
  {
    id: '1306030008',
    districtId: '1306030',
    name: 'Padang Toboh Ulakan',
  },
  {
    id: '1306040001',
    districtId: '1306040',
    name: 'Sunua',
  },
  {
    id: '1306040002',
    districtId: '1306040',
    name: 'Padang Bintungan',
  },
  {
    id: '1306040003',
    districtId: '1306040',
    name: 'Pauah Kamba',
  },
  {
    id: '1306040004',
    districtId: '1306040',
    name: 'Kapalo Koto',
  },
  {
    id: '1306040005',
    districtId: '1306040',
    name: 'Kurai Taji',
  },
  {
    id: '1306040006',
    districtId: '1306040',
    name: 'Sunur Barat',
  },
  {
    id: '1306040007',
    districtId: '1306040',
    name: 'Sunur Tengah',
  },
  {
    id: '1306040008',
    districtId: '1306040',
    name: 'Padang Kandang Pulau Air Padang Bintungan',
  },
  {
    id: '1306040009',
    districtId: '1306040',
    name: 'Kurai Taji Timur',
  },
  {
    id: '1306050001',
    districtId: '1306050',
    name: 'Lubuk Pandan',
  },
  {
    id: '1306050002',
    districtId: '1306050',
    name: 'Sicincin',
  },
  {
    id: '1306050003',
    districtId: '1306050',
    name: 'Sungai Asam',
  },
  {
    id: '1306051001',
    districtId: '1306051',
    name: 'Koto Tinggi',
  },
  {
    id: '1306051002',
    districtId: '1306051',
    name: 'Gadua',
  },
  {
    id: '1306051003',
    districtId: '1306051',
    name: 'Toboh Ketek',
  },
  {
    id: '1306051004',
    districtId: '1306051',
    name: 'Pakandangan',
  },
  {
    id: '1306051005',
    districtId: '1306051',
    name: 'Parik Malintang',
  },
  {
    id: '1306052001',
    districtId: '1306052',
    name: 'Kapalo Hilalang',
  },
  {
    id: '1306052002',
    districtId: '1306052',
    name: 'Kayu Tanam',
  },
  {
    id: '1306052003',
    districtId: '1306052',
    name: 'Guguak',
  },
  {
    id: '1306052004',
    districtId: '1306052',
    name: 'Anduring',
  },
  {
    id: '1306060001',
    districtId: '1306060',
    name: 'Balah Aia',
  },
  {
    id: '1306060002',
    districtId: '1306060',
    name: 'Lareh Nan Panjang',
  },
  {
    id: '1306060003',
    districtId: '1306060',
    name: 'Lurah Ampalu',
  },
  {
    id: '1306060004',
    districtId: '1306060',
    name: 'Sungai Sariak',
  },
  {
    id: '1306060005',
    districtId: '1306060',
    name: 'Balah Aie Timur',
  },
  {
    id: '1306060006',
    districtId: '1306060',
    name: 'Balah Aie Utara',
  },
  {
    id: '1306060007',
    districtId: '1306060',
    name: 'Lareh Nan Panjang Selatan',
  },
  {
    id: '1306060008',
    districtId: '1306060',
    name: 'Lareh Nan Panjang Barat',
  },
  {
    id: '1306060009',
    districtId: '1306060',
    name: 'Limpato Sungai Sariak',
  },
  {
    id: '1306060010',
    districtId: '1306060',
    name: 'Bisati Sungai Sariak',
  },
  {
    id: '1306060011',
    districtId: '1306060',
    name: 'Lareh Nan Panjang Sungai Sariak',
  },
  {
    id: '1306060012',
    districtId: '1306060',
    name: 'Ambuang Kapua Sungai Sariak',
  },
  {
    id: '1306061001',
    districtId: '1306061',
    name: 'Sungai Durian',
  },
  {
    id: '1306061002',
    districtId: '1306061',
    name: 'Tandikat',
  },
  {
    id: '1306061003',
    districtId: '1306061',
    name: 'Tandikat Utara',
  },
  {
    id: '1306061004',
    districtId: '1306061',
    name: 'Kampuang Tanjuang Koto Mambang Sungai Durian',
  },
  {
    id: '1306061005',
    districtId: '1306061',
    name: 'Tandikat Selatan',
  },
  {
    id: '1306061006',
    districtId: '1306061',
    name: 'Tandikat Barat',
  },
  {
    id: '1306062001',
    districtId: '1306062',
    name: 'Koto Dalam',
  },
  {
    id: '1306062002',
    districtId: '1306062',
    name: 'Batu Kalang',
  },
  {
    id: '1306062003',
    districtId: '1306062',
    name: 'Koto Baru',
  },
  {
    id: '1306062004',
    districtId: '1306062',
    name: 'Koto Dalam Barat',
  },
  {
    id: '1306062005',
    districtId: '1306062',
    name: 'Koto Dalam Selatan',
  },
  {
    id: '1306062006',
    districtId: '1306062',
    name: 'Batu Kalang Utara',
  },
  {
    id: '1306070001',
    districtId: '1306070',
    name: 'Campago',
  },
  {
    id: '1306070002',
    districtId: '1306070',
    name: 'Sikucur',
  },
  {
    id: '1306070003',
    districtId: '1306070',
    name: 'Campago Selatan',
  },
  {
    id: '1306070004',
    districtId: '1306070',
    name: 'Campago Barat',
  },
  {
    id: '1306070005',
    districtId: '1306070',
    name: 'Sikucur Tengah',
  },
  {
    id: '1306070006',
    districtId: '1306070',
    name: 'Sikucur Barat',
  },
  {
    id: '1306070007',
    districtId: '1306070',
    name: 'Sikucur Utara',
  },
  {
    id: '1306070008',
    districtId: '1306070',
    name: 'Sikucur Timur',
  },
  {
    id: '1306071001',
    districtId: '1306071',
    name: 'Limau Puruik',
  },
  {
    id: '1306071002',
    districtId: '1306071',
    name: 'Kudu Gantiang',
  },
  {
    id: '1306071003',
    districtId: '1306071',
    name: 'Gunung Padang Alai',
  },
  {
    id: '1306071004',
    districtId: '1306071',
    name: 'Kudu Gantiang Barat',
  },
  {
    id: '1306080001',
    districtId: '1306080',
    name: 'Pilubang',
  },
  {
    id: '1306080002',
    districtId: '1306080',
    name: 'Kuranji Hilir',
  },
  {
    id: '1306080003',
    districtId: '1306080',
    name: 'Koto Tinggi Kuranji Hilir',
  },
  {
    id: '1306080004',
    districtId: '1306080',
    name: 'Guguak Kuranji Hilir',
  },
  {
    id: '1306081001',
    districtId: '1306081',
    name: 'Gasan Gadang',
  },
  {
    id: '1306081002',
    districtId: '1306081',
    name: 'Malai V Suku',
  },
  {
    id: '1306081003',
    districtId: '1306081',
    name: 'Malai V Suku Timur',
  },
  {
    id: '1306090001',
    districtId: '1306090',
    name: 'Kuranji Hulu',
  },
  {
    id: '1306090002',
    districtId: '1306090',
    name: 'Malai III Koto',
  },
  {
    id: '1306090003',
    districtId: '1306090',
    name: 'Batu Gadang Kuranji Hulu',
  },
  {
    id: '1306090004',
    districtId: '1306090',
    name: 'Sungai Sirah Kuranji Hulu',
  },
  {
    id: '1306100001',
    districtId: '1306100',
    name: 'III Koto Aur Malintang',
  },
  {
    id: '1306100002',
    districtId: '1306100',
    name: 'III Koto Aur Malintang Selatan',
  },
  {
    id: '1306100003',
    districtId: '1306100',
    name: 'III Koto Aur Malintang Timur',
  },
  {
    id: '1306100004',
    districtId: '1306100',
    name: 'III Koto Aur Malintang Utara',
  },
  {
    id: '1306100005',
    districtId: '1306100',
    name: 'Balai Baik Malai III Koto',
  },
  {
    id: '1307010001',
    districtId: '1307010',
    name: 'Tiku Selatan',
  },
  {
    id: '1307010002',
    districtId: '1307010',
    name: 'Tiku Utara',
  },
  {
    id: '1307010003',
    districtId: '1307010',
    name: 'Tiku Limo Jorong',
  },
  {
    id: '1307020001',
    districtId: '1307020',
    name: 'Manggopoh',
  },
  {
    id: '1307020002',
    districtId: '1307020',
    name: 'Garagahan',
  },
  {
    id: '1307020003',
    districtId: '1307020',
    name: 'Kampuang Tangah',
  },
  {
    id: '1307020004',
    districtId: '1307020',
    name: 'Kampung Pinang',
  },
  {
    id: '1307020005',
    districtId: '1307020',
    name: 'Lubuk Basung',
  },
  {
    id: '1307021001',
    districtId: '1307021',
    name: 'Bawan',
  },
  {
    id: '1307021002',
    districtId: '1307021',
    name: 'Sitanang',
  },
  {
    id: '1307021003',
    districtId: '1307021',
    name: 'Batu Kambing',
  },
  {
    id: '1307021004',
    districtId: '1307021',
    name: 'Sitalang',
  },
  {
    id: '1307030001',
    districtId: '1307030',
    name: 'Tanjung Sani',
  },
  {
    id: '1307030002',
    districtId: '1307030',
    name: 'Sungai Batang',
  },
  {
    id: '1307030003',
    districtId: '1307030',
    name: 'Maninjau',
  },
  {
    id: '1307030004',
    districtId: '1307030',
    name: 'Bayua',
  },
  {
    id: '1307030005',
    districtId: '1307030',
    name: 'Duo Koto',
  },
  {
    id: '1307030006',
    districtId: '1307030',
    name: 'Paninjauan',
  },
  {
    id: '1307030007',
    districtId: '1307030',
    name: 'Koto Kaciak',
  },
  {
    id: '1307030008',
    districtId: '1307030',
    name: 'Koto Gadang Anam Koto',
  },
  {
    id: '1307030009',
    districtId: '1307030',
    name: 'Koto Malintang',
  },
  {
    id: '1307040001',
    districtId: '1307040',
    name: 'Matua Mudiak',
  },
  {
    id: '1307040002',
    districtId: '1307040',
    name: 'Parik Panjang',
  },
  {
    id: '1307040003',
    districtId: '1307040',
    name: 'Panta Pauah',
  },
  {
    id: '1307040004',
    districtId: '1307040',
    name: 'Matua Hilia',
  },
  {
    id: '1307040005',
    districtId: '1307040',
    name: 'Tigo Balai',
  },
  {
    id: '1307040006',
    districtId: '1307040',
    name: 'Lawang',
  },
  {
    id: '1307050001',
    districtId: '1307050',
    name: 'Koto Tuo',
  },
  {
    id: '1307050002',
    districtId: '1307050',
    name: 'Balingka',
  },
  {
    id: '1307050003',
    districtId: '1307050',
    name: 'Sungai Landia',
  },
  {
    id: '1307050004',
    districtId: '1307050',
    name: 'Koto Panjang',
  },
  {
    id: '1307050005',
    districtId: '1307050',
    name: 'Sianok Anam Suku',
  },
  {
    id: '1307050006',
    districtId: '1307050',
    name: 'Koto Gadang',
  },
  {
    id: '1307050007',
    districtId: '1307050',
    name: 'Guguak Tabek Sarojo',
  },
  {
    id: '1307051001',
    districtId: '1307051',
    name: 'Malalak Selatan',
  },
  {
    id: '1307051002',
    districtId: '1307051',
    name: 'Malalak Barat',
  },
  {
    id: '1307051003',
    districtId: '1307051',
    name: 'Malalak Timur',
  },
  {
    id: '1307051004',
    districtId: '1307051',
    name: 'Malalak Utara',
  },
  {
    id: '1307061001',
    districtId: '1307061',
    name: 'Pakan Sinayan',
  },
  {
    id: '1307061002',
    districtId: '1307061',
    name: 'Sungai Tanang',
  },
  {
    id: '1307061003',
    districtId: '1307061',
    name: 'Padang Lua',
  },
  {
    id: '1307061004',
    districtId: '1307061',
    name: 'Cingkariang',
  },
  {
    id: '1307061005',
    districtId: '1307061',
    name: 'Ladang Laweh',
  },
  {
    id: '1307061006',
    districtId: '1307061',
    name: 'Taluak Ampek Suku',
  },
  {
    id: '1307061007',
    districtId: '1307061',
    name: 'Kubang Putiah',
  },
  {
    id: '1307062001',
    districtId: '1307062',
    name: 'Batu Palano',
  },
  {
    id: '1307062002',
    districtId: '1307062',
    name: 'Padang Laweh',
  },
  {
    id: '1307062003',
    districtId: '1307062',
    name: 'Batagak',
  },
  {
    id: '1307062004',
    districtId: '1307062',
    name: 'Sariak',
  },
  {
    id: '1307062005',
    districtId: '1307062',
    name: 'Sungai Pua',
  },
  {
    id: '1307070001',
    districtId: '1307070',
    name: 'Batu Taba',
  },
  {
    id: '1307070002',
    districtId: '1307070',
    name: 'Pasia',
  },
  {
    id: '1307070003',
    districtId: '1307070',
    name: 'Balai Gurah',
  },
  {
    id: '1307070004',
    districtId: '1307070',
    name: 'Ampang Gadang',
  },
  {
    id: '1307070005',
    districtId: '1307070',
    name: 'Biaro Gadang',
  },
  {
    id: '1307070006',
    districtId: '1307070',
    name: 'Lambah',
  },
  {
    id: '1307070007',
    districtId: '1307070',
    name: 'Panampuang',
  },
  {
    id: '1307071001',
    districtId: '1307071',
    name: 'Bukik Batabuah',
  },
  {
    id: '1307071002',
    districtId: '1307071',
    name: 'Lasi',
  },
  {
    id: '1307071003',
    districtId: '1307071',
    name: 'Canduang Koto Laweh',
  },
  {
    id: '1307080001',
    districtId: '1307080',
    name: 'Koto Tinggi',
  },
  {
    id: '1307080002',
    districtId: '1307080',
    name: 'Padang Tarok',
  },
  {
    id: '1307080003',
    districtId: '1307080',
    name: 'Simarasok',
  },
  {
    id: '1307080004',
    districtId: '1307080',
    name: 'Tabek Panjang',
  },
  {
    id: '1307080005',
    districtId: '1307080',
    name: 'Salo',
  },
  {
    id: '1307080006',
    districtId: '1307080',
    name: 'Koto Baru',
  },
  {
    id: '1307090001',
    districtId: '1307090',
    name: 'Gadut',
  },
  {
    id: '1307090002',
    districtId: '1307090',
    name: 'Kapau',
  },
  {
    id: '1307090003',
    districtId: '1307090',
    name: 'Koto Tangah',
  },
  {
    id: '1307091001',
    districtId: '1307091',
    name: 'Magek',
  },
  {
    id: '1307091002',
    districtId: '1307091',
    name: 'Kamang Hilia',
  },
  {
    id: '1307091003',
    districtId: '1307091',
    name: 'Kamang Mudiak',
  },
  {
    id: '1307100001',
    districtId: '1307100',
    name: 'Baringin',
  },
  {
    id: '1307100002',
    districtId: '1307100',
    name: 'Sungai Puar',
  },
  {
    id: '1307100003',
    districtId: '1307100',
    name: 'Sipinang',
  },
  {
    id: '1307100004',
    districtId: '1307100',
    name: 'Ampek Koto Palembayan',
  },
  {
    id: '1307100005',
    districtId: '1307100',
    name: 'Tigo Koto Silungkang',
  },
  {
    id: '1307100006',
    districtId: '1307100',
    name: 'Salareh Aia',
  },
  {
    id: '1307110001',
    districtId: '1307110',
    name: 'Koto Rantang',
  },
  {
    id: '1307110002',
    districtId: '1307110',
    name: 'Pasia Laweh',
  },
  {
    id: '1307110003',
    districtId: '1307110',
    name: 'Pagadih',
  },
  {
    id: '1307110004',
    districtId: '1307110',
    name: 'Nan Tujuah',
  },
  {
    id: '1308010001',
    districtId: '1308010',
    name: 'Sungai Baringin',
  },
  {
    id: '1308010002',
    districtId: '1308010',
    name: 'Koto Baru Simalanggang',
  },
  {
    id: '1308010003',
    districtId: '1308010',
    name: 'Simalanggang',
  },
  {
    id: '1308010004',
    districtId: '1308010',
    name: 'Koto Tangah Simalanggang',
  },
  {
    id: '1308010005',
    districtId: '1308010',
    name: 'Taeh Baruah',
  },
  {
    id: '1308010006',
    districtId: '1308010',
    name: 'Piobang',
  },
  {
    id: '1308010007',
    districtId: '1308010',
    name: 'Taeh Bukik',
  },
  {
    id: '1308011001',
    districtId: '1308011',
    name: 'Koto Tangah Batu Hampa',
  },
  {
    id: '1308011002',
    districtId: '1308011',
    name: 'Batu Hampa',
  },
  {
    id: '1308011003',
    districtId: '1308011',
    name: 'Sariak Laweh',
  },
  {
    id: '1308011004',
    districtId: '1308011',
    name: 'Sungai Balantiak',
  },
  {
    id: '1308011005',
    districtId: '1308011',
    name: 'Suayan',
  },
  {
    id: '1308011006',
    districtId: '1308011',
    name: 'Pauah Sangik',
  },
  {
    id: '1308011007',
    districtId: '1308011',
    name: 'Durian Gadang',
  },
  {
    id: '1308020001',
    districtId: '1308020',
    name: 'Mungo',
  },
  {
    id: '1308020002',
    districtId: '1308020',
    name: 'Andaleh',
  },
  {
    id: '1308020003',
    districtId: '1308020',
    name: 'Sungai Kamuyang',
  },
  {
    id: '1308020004',
    districtId: '1308020',
    name: 'Tanjuang Aro Sikabu-Kabu Pd. Panjang',
  },
  {
    id: '1308021001',
    districtId: '1308021',
    name: 'Halaban',
  },
  {
    id: '1308021002',
    districtId: '1308021',
    name: 'Ampalu',
  },
  {
    id: '1308021003',
    districtId: '1308021',
    name: 'Tanjuang Gadang',
  },
  {
    id: '1308021004',
    districtId: '1308021',
    name: 'Sitanang',
  },
  {
    id: '1308021005',
    districtId: '1308021',
    name: 'Batu Payuang',
  },
  {
    id: '1308021006',
    districtId: '1308021',
    name: 'Labuah Gunuang',
  },
  {
    id: '1308021007',
    districtId: '1308021',
    name: 'Balai Panjang',
  },
  {
    id: '1308021008',
    districtId: '1308021',
    name: 'Bukik Sikumpa',
  },
  {
    id: '1308022001',
    districtId: '1308022',
    name: 'Situjuah Gadang',
  },
  {
    id: '1308022002',
    districtId: '1308022',
    name: 'Situjuah Banda Dalam',
  },
  {
    id: '1308022003',
    districtId: '1308022',
    name: 'Situjuah Batua',
  },
  {
    id: '1308022004',
    districtId: '1308022',
    name: 'Tungka',
  },
  {
    id: '1308022005',
    districtId: '1308022',
    name: 'Situjuah Ladang Laweh',
  },
  {
    id: '1308030001',
    districtId: '1308030',
    name: 'Taram',
  },
  {
    id: '1308030002',
    districtId: '1308030',
    name: 'Bukik Limbuku',
  },
  {
    id: '1308030003',
    districtId: '1308030',
    name: 'Pilubang',
  },
  {
    id: '1308030004',
    districtId: '1308030',
    name: 'Batu Balang',
  },
  {
    id: '1308030005',
    districtId: '1308030',
    name: 'Koto Tuo',
  },
  {
    id: '1308030006',
    districtId: '1308030',
    name: 'Lubuak Batingkok',
  },
  {
    id: '1308030007',
    districtId: '1308030',
    name: 'Gurun',
  },
  {
    id: '1308030008',
    districtId: '1308030',
    name: 'Sarilamak',
  },
  {
    id: '1308030009',
    districtId: '1308030',
    name: 'Tarantang',
  },
  {
    id: '1308030010',
    districtId: '1308030',
    name: 'Solok Bio-Bio',
  },
  {
    id: '1308030011',
    districtId: '1308030',
    name: 'Harau',
  },
  {
    id: '1308040001',
    districtId: '1308040',
    name: 'Kubang',
  },
  {
    id: '1308040002',
    districtId: '1308040',
    name: 'Simpang Sugiran',
  },
  {
    id: '1308040003',
    districtId: '1308040',
    name: 'Sungai Talang',
  },
  {
    id: '1308040004',
    districtId: '1308040',
    name: 'Guguak VIII Koto',
  },
  {
    id: '1308040005',
    districtId: '1308040',
    name: 'VII Koto Talago',
  },
  {
    id: '1308041001',
    districtId: '1308041',
    name: 'Jopang Manganti',
  },
  {
    id: '1308041002',
    districtId: '1308041',
    name: 'Mungka',
  },
  {
    id: '1308041003',
    districtId: '1308041',
    name: 'Talang Maua',
  },
  {
    id: '1308041004',
    districtId: '1308041',
    name: 'Simpang Kapuak',
  },
  {
    id: '1308041005',
    districtId: '1308041',
    name: 'Sungai Antuan',
  },
  {
    id: '1308050001',
    districtId: '1308050',
    name: 'Kurai',
  },
  {
    id: '1308050002',
    districtId: '1308050',
    name: 'Suliki',
  },
  {
    id: '1308050003',
    districtId: '1308050',
    name: 'Limbanang',
  },
  {
    id: '1308050004',
    districtId: '1308050',
    name: 'Sungai Rimbang',
  },
  {
    id: '1308050005',
    districtId: '1308050',
    name: 'Tanjuang Bungo',
  },
  {
    id: '1308050006',
    districtId: '1308050',
    name: 'Andiang',
  },
  {
    id: '1308051001',
    districtId: '1308051',
    name: 'Koto Tangah',
  },
  {
    id: '1308051002',
    districtId: '1308051',
    name: 'Banja Laweh',
  },
  {
    id: '1308051003',
    districtId: '1308051',
    name: 'Maek',
  },
  {
    id: '1308051004',
    districtId: '1308051',
    name: 'Sungai Naniang',
  },
  {
    id: '1308051005',
    districtId: '1308051',
    name: 'Baruah Gunuang',
  },
  {
    id: '1308060001',
    districtId: '1308060',
    name: 'Pandam Gadang',
  },
  {
    id: '1308060002',
    districtId: '1308060',
    name: 'Talang Anau',
  },
  {
    id: '1308060003',
    districtId: '1308060',
    name: 'Koto Tinggi',
  },
  {
    id: '1308070001',
    districtId: '1308070',
    name: 'Koto Lamo',
  },
  {
    id: '1308070002',
    districtId: '1308070',
    name: 'Lubuak Alai',
  },
  {
    id: '1308070003',
    districtId: '1308070',
    name: 'Muaro Paiti',
  },
  {
    id: '1308070004',
    districtId: '1308070',
    name: 'Koto Bangun',
  },
  {
    id: '1308070005',
    districtId: '1308070',
    name: 'Durian Tinggi',
  },
  {
    id: '1308070006',
    districtId: '1308070',
    name: 'Sialang',
  },
  {
    id: '1308070007',
    districtId: '1308070',
    name: 'Galugua',
  },
  {
    id: '1308080001',
    districtId: '1308080',
    name: 'Koto Alam',
  },
  {
    id: '1308080002',
    districtId: '1308080',
    name: 'Manggilang',
  },
  {
    id: '1308080003',
    districtId: '1308080',
    name: 'Pangkalan',
  },
  {
    id: '1308080004',
    districtId: '1308080',
    name: 'Gunuang Malintang',
  },
  {
    id: '1308080005',
    districtId: '1308080',
    name: 'Tanjuang Balik',
  },
  {
    id: '1308080006',
    districtId: '1308080',
    name: 'Tanjuang Pauah',
  },
  {
    id: '1309070001',
    districtId: '1309070',
    name: 'Koto Kaciak',
  },
  {
    id: '1309070002',
    districtId: '1309070',
    name: 'Limo Koto',
  },
  {
    id: '1309070003',
    districtId: '1309070',
    name: 'Ganggo Hilia',
  },
  {
    id: '1309070004',
    districtId: '1309070',
    name: 'Ganggo Mudiak',
  },
  {
    id: '1309071001',
    districtId: '1309071',
    name: 'Binjai',
  },
  {
    id: '1309071002',
    districtId: '1309071',
    name: 'Ladang Panjang',
  },
  {
    id: '1309071003',
    districtId: '1309071',
    name: 'Malampah',
  },
  {
    id: '1309072001',
    districtId: '1309072',
    name: 'Alahan Mati',
  },
  {
    id: '1309072002',
    districtId: '1309072',
    name: 'Simpang',
  },
  {
    id: '1309080001',
    districtId: '1309080',
    name: 'Tanjung Beringin',
  },
  {
    id: '1309080002',
    districtId: '1309080',
    name: 'Jambak',
  },
  {
    id: '1309080003',
    districtId: '1309080',
    name: 'Durian Tinggi',
  },
  {
    id: '1309080004',
    districtId: '1309080',
    name: 'Pauah',
  },
  {
    id: '1309080005',
    districtId: '1309080',
    name: 'Aia Manggih',
  },
  {
    id: '1309080006',
    districtId: '1309080',
    name: 'Sundata',
  },
  {
    id: '1309100001',
    districtId: '1309100',
    name: 'Cubadak',
  },
  {
    id: '1309100002',
    districtId: '1309100',
    name: 'Simpang Tonang',
  },
  {
    id: '1309110001',
    districtId: '1309110',
    name: 'Panti',
  },
  {
    id: '1309110002',
    districtId: '1309110',
    name: 'Panti Selatan',
  },
  {
    id: '1309110003',
    districtId: '1309110',
    name: 'Panti Timur',
  },
  {
    id: '1309111001',
    districtId: '1309111',
    name: 'Padang Galugua',
  },
  {
    id: '1309111002',
    districtId: '1309111',
    name: 'Persiapan Bahagia Padang Galugua',
  },
  {
    id: '1309111003',
    districtId: '1309111',
    name: 'Persiapan Sitombol Padang Galugua',
  },
  {
    id: '1309111004',
    districtId: '1309111',
    name: 'Persiapan Sontang Cubadak',
  },
  {
    id: '1309121001',
    districtId: '1309121',
    name: 'Taruang-Taruang',
  },
  {
    id: '1309121002',
    districtId: '1309121',
    name: 'Padang Mantinggi',
  },
  {
    id: '1309122001',
    districtId: '1309122',
    name: 'Lubuak Gadang',
  },
  {
    id: '1309122002',
    districtId: '1309122',
    name: 'Pintu Padang',
  },
  {
    id: '1309122003',
    districtId: '1309122',
    name: 'Muaro Tais',
  },
  {
    id: '1309123001',
    districtId: '1309123',
    name: 'Muaro Sei Lolo',
  },
  {
    id: '1309123002',
    districtId: '1309123',
    name: 'Silayang',
  },
  {
    id: '1309124001',
    districtId: '1309124',
    name: 'Lansek Kadok',
  },
  {
    id: '1309124002',
    districtId: '1309124',
    name: 'Tanjung Betung',
  },
  {
    id: '1309124003',
    districtId: '1309124',
    name: 'Lubuak Layang',
  },
  {
    id: '1309125001',
    districtId: '1309125',
    name: 'Koto Nopan',
  },
  {
    id: '1309125002',
    districtId: '1309125',
    name: 'Koto Rajo',
  },
  {
    id: '1309125003',
    districtId: '1309125',
    name: 'Languang',
  },
  {
    id: '1310010001',
    districtId: '1310010',
    name: 'Lubuk Gadang',
  },
  {
    id: '1310010002',
    districtId: '1310010',
    name: 'Lubuk Gadang Timur',
  },
  {
    id: '1310010003',
    districtId: '1310010',
    name: 'Lubuk Gadang Selatan',
  },
  {
    id: '1310010004',
    districtId: '1310010',
    name: 'Lubuk Gadang Utara',
  },
  {
    id: '1310020001',
    districtId: '1310020',
    name: 'Lubuk Malako',
  },
  {
    id: '1310020002',
    districtId: '1310020',
    name: 'Padang Air Dingin',
  },
  {
    id: '1310020003',
    districtId: '1310020',
    name: 'Bidar Alam',
  },
  {
    id: '1310020004',
    districtId: '1310020',
    name: 'Padang Limau Sundai',
  },
  {
    id: '1310020005',
    districtId: '1310020',
    name: 'Padang Gantiang',
  },
  {
    id: '1310021001',
    districtId: '1310021',
    name: 'Sungai Kunyit',
  },
  {
    id: '1310021002',
    districtId: '1310021',
    name: 'Talunan Maju',
  },
  {
    id: '1310021003',
    districtId: '1310021',
    name: 'Talao Sungai Kunyit',
  },
  {
    id: '1310021004',
    districtId: '1310021',
    name: 'Sungai Kunyit Barat',
  },
  {
    id: '1310030001',
    districtId: '1310030',
    name: 'Abai',
  },
  {
    id: '1310030002',
    districtId: '1310030',
    name: 'Ranah Pantai Cermin',
  },
  {
    id: '1310030003',
    districtId: '1310030',
    name: 'Dusun Tangah',
  },
  {
    id: '1310030004',
    districtId: '1310030',
    name: 'Sitapus',
  },
  {
    id: '1310030005',
    districtId: '1310030',
    name: 'Lubuk Ulang Aling',
  },
  {
    id: '1310030006',
    districtId: '1310030',
    name: 'Lubuk Ulang Aling Selatan',
  },
  {
    id: '1310030007',
    districtId: '1310030',
    name: 'Lubuk Ulang Aling Tengah',
  },
  {
    id: '1310040001',
    districtId: '1310040',
    name: 'Koto Baru',
  },
  {
    id: '1310040002',
    districtId: '1310040',
    name: 'Pasar Muara Labuh',
  },
  {
    id: '1310040003',
    districtId: '1310040',
    name: 'Pulakek Koto Baru',
  },
  {
    id: '1310040004',
    districtId: '1310040',
    name: 'Sako Pasia Talang',
  },
  {
    id: '1310040005',
    districtId: '1310040',
    name: 'Pasir Talang',
  },
  {
    id: '1310040006',
    districtId: '1310040',
    name: 'Bomas',
  },
  {
    id: '1310040007',
    districtId: '1310040',
    name: 'Sako Selatan Pasia Talang',
  },
  {
    id: '1310040008',
    districtId: '1310040',
    name: 'Sako Utara Pasia Talang',
  },
  {
    id: '1310040009',
    districtId: '1310040',
    name: 'Pasir Talang Selatan',
  },
  {
    id: '1310040010',
    districtId: '1310040',
    name: 'Pasir Talang Barat',
  },
  {
    id: '1310040011',
    districtId: '1310040',
    name: 'Pasir Talang Timur',
  },
  {
    id: '1310041001',
    districtId: '1310041',
    name: 'Alam Pauh Duo',
  },
  {
    id: '1310041002',
    districtId: '1310041',
    name: 'Kapau Alam Pauh Duo',
  },
  {
    id: '1310041003',
    districtId: '1310041',
    name: 'Luak Kapau Alam Pauh Duo',
  },
  {
    id: '1310041004',
    districtId: '1310041',
    name: 'Pauh Duo Nan Batigo',
  },
  {
    id: '1310050001',
    districtId: '1310050',
    name: 'Pakan Rabaa',
  },
  {
    id: '1310050002',
    districtId: '1310050',
    name: 'Pakan Rabaa Timur',
  },
  {
    id: '1310050003',
    districtId: '1310050',
    name: 'Pakan Rabaa Utara',
  },
  {
    id: '1310050004',
    districtId: '1310050',
    name: 'Pakan Rabaa Tengah',
  },
  {
    id: '1311010005',
    districtId: '1311010',
    name: 'Sungai Rumbai',
  },
  {
    id: '1311010006',
    districtId: '1311010',
    name: 'Kurnia Koto Salak',
  },
  {
    id: '1311010007',
    districtId: '1311010',
    name: 'Sungai Rumbai Timur',
  },
  {
    id: '1311010008',
    districtId: '1311010',
    name: 'Kurnia Selatan',
  },
  {
    id: '1311011001',
    districtId: '1311011',
    name: 'Koto Gadang',
  },
  {
    id: '1311011002',
    districtId: '1311011',
    name: 'Koto Tinggi',
  },
  {
    id: '1311011003',
    districtId: '1311011',
    name: 'Bonjol',
  },
  {
    id: '1311011004',
    districtId: '1311011',
    name: 'Abai Siat',
  },
  {
    id: '1311011005',
    districtId: '1311011',
    name: 'Koto Besar',
  },
  {
    id: '1311011006',
    districtId: '1311011',
    name: 'Koto Laweh',
  },
  {
    id: '1311011007',
    districtId: '1311011',
    name: 'Koto Ranah',
  },
  {
    id: '1311012001',
    districtId: '1311012',
    name: 'Lubuk Besar',
  },
  {
    id: '1311012002',
    districtId: '1311012',
    name: 'Alahan Nan Tigo',
  },
  {
    id: '1311012003',
    districtId: '1311012',
    name: 'Sungai Limau',
  },
  {
    id: '1311012004',
    districtId: '1311012',
    name: 'Sinamar',
  },
  {
    id: '1311012005',
    districtId: '1311012',
    name: 'Tanjung Alam',
  },
  {
    id: '1311020001',
    districtId: '1311020',
    name: 'Ampang Kuranji',
  },
  {
    id: '1311020003',
    districtId: '1311020',
    name: 'Koto Baru',
  },
  {
    id: '1311020005',
    districtId: '1311020',
    name: 'Sialang Gaung',
  },
  {
    id: '1311020008',
    districtId: '1311020',
    name: 'Koto Padang',
  },
  {
    id: '1311021001',
    districtId: '1311021',
    name: 'Padukuan',
  },
  {
    id: '1311021002',
    districtId: '1311021',
    name: 'Pulau Mainan',
  },
  {
    id: '1311021003',
    districtId: '1311021',
    name: 'Simalidu',
  },
  {
    id: '1311021004',
    districtId: '1311021',
    name: 'Koto Salak',
  },
  {
    id: '1311021005',
    districtId: '1311021',
    name: 'Ampalu',
  },
  {
    id: '1311022001',
    districtId: '1311022',
    name: 'Koto Beringin',
  },
  {
    id: '1311022002',
    districtId: '1311022',
    name: 'Sipangkur',
  },
  {
    id: '1311022003',
    districtId: '1311022',
    name: 'Sungai Langkok',
  },
  {
    id: '1311022004',
    districtId: '1311022',
    name: 'Tiumang',
  },
  {
    id: '1311023001',
    districtId: '1311023',
    name: 'Batu Rijal',
  },
  {
    id: '1311023002',
    districtId: '1311023',
    name: 'Muaro Sopan',
  },
  {
    id: '1311023003',
    districtId: '1311023',
    name: 'Padang Laweh',
  },
  {
    id: '1311023004',
    districtId: '1311023',
    name: 'Sopan Jaya',
  },
  {
    id: '1311030001',
    districtId: '1311030',
    name: 'Sitiung',
  },
  {
    id: '1311030002',
    districtId: '1311030',
    name: 'Siguntur',
  },
  {
    id: '1311030004',
    districtId: '1311030',
    name: 'Gunung Medan',
  },
  {
    id: '1311030005',
    districtId: '1311030',
    name: 'Sungai Duo',
  },
  {
    id: '1311031001',
    districtId: '1311031',
    name: 'Panyubarangan',
  },
  {
    id: '1311031002',
    districtId: '1311031',
    name: 'Tabek',
  },
  {
    id: '1311031003',
    districtId: '1311031',
    name: 'Timpeh',
  },
  {
    id: '1311031004',
    districtId: '1311031',
    name: 'Taratak Tinggi',
  },
  {
    id: '1311031005',
    districtId: '1311031',
    name: 'Ranah Palabi',
  },
  {
    id: '1311040003',
    districtId: '1311040',
    name: 'IV Koto Pulau Punjung',
  },
  {
    id: '1311040004',
    districtId: '1311040',
    name: 'Sungai Dareh',
  },
  {
    id: '1311040005',
    districtId: '1311040',
    name: 'Tebing Tinggi',
  },
  {
    id: '1311040006',
    districtId: '1311040',
    name: 'Sungai Kambut',
  },
  {
    id: '1311040007',
    districtId: '1311040',
    name: 'Gunung Selasih',
  },
  {
    id: '1311040008',
    districtId: '1311040',
    name: 'Sikabau',
  },
  {
    id: '1311041001',
    districtId: '1311041',
    name: 'Banai',
  },
  {
    id: '1311041002',
    districtId: '1311041',
    name: 'Lubuk Karak',
  },
  {
    id: '1311041003',
    districtId: '1311041',
    name: 'Silago',
  },
  {
    id: '1311041004',
    districtId: '1311041',
    name: 'Koto Nan IV Dibawuah',
  },
  {
    id: '1312010001',
    districtId: '1312010',
    name: 'Aia Bangih',
  },
  {
    id: '1312020001',
    districtId: '1312020',
    name: 'Desa Baru',
  },
  {
    id: '1312020002',
    districtId: '1312020',
    name: 'Batahan',
  },
  {
    id: '1312030001',
    districtId: '1312030',
    name: 'Parik',
  },
  {
    id: '1312040001',
    districtId: '1312040',
    name: 'Sungai Aua',
  },
  {
    id: '1312050001',
    districtId: '1312050',
    name: 'Ujuang Gadiang',
  },
  {
    id: '1312060001',
    districtId: '1312060',
    name: 'Muaro Kiawai',
  },
  {
    id: '1312060002',
    districtId: '1312060',
    name: 'Rabi Jongor',
  },
  {
    id: '1312070001',
    districtId: '1312070',
    name: 'Kajai',
  },
  {
    id: '1312070002',
    districtId: '1312070',
    name: 'Talu',
  },
  {
    id: '1312070003',
    districtId: '1312070',
    name: 'Sinuruik',
  },
  {
    id: '1312080001',
    districtId: '1312080',
    name: 'Lingkuang Aua',
  },
  {
    id: '1312080002',
    districtId: '1312080',
    name: 'Aua Kuniang',
  },
  {
    id: '1312080003',
    districtId: '1312080',
    name: 'Aia Gadang',
  },
  {
    id: '1312090001',
    districtId: '1312090',
    name: 'Koto Baru',
  },
  {
    id: '1312090002',
    districtId: '1312090',
    name: 'Kapa',
  },
  {
    id: '1312100001',
    districtId: '1312100',
    name: 'Sasak',
  },
  {
    id: '1312110001',
    districtId: '1312110',
    name: 'Katiagan',
  },
  {
    id: '1312110002',
    districtId: '1312110',
    name: 'Kinali',
  },
  {
    id: '1371010001',
    districtId: '1371010',
    name: 'Teluk Kabung Selatan',
  },
  {
    id: '1371010007',
    districtId: '1371010',
    name: 'Bungus Selatan',
  },
  {
    id: '1371010014',
    districtId: '1371010',
    name: 'Teluk Kabung Tengah',
  },
  {
    id: '1371010015',
    districtId: '1371010',
    name: 'Teluk Kabung Utara',
  },
  {
    id: '1371010016',
    districtId: '1371010',
    name: 'Bungus Timur',
  },
  {
    id: '1371010017',
    districtId: '1371010',
    name: 'Bungus Barat',
  },
  {
    id: '1371020001',
    districtId: '1371020',
    name: 'Tarantang',
  },
  {
    id: '1371020002',
    districtId: '1371020',
    name: 'Beringin',
  },
  {
    id: '1371020003',
    districtId: '1371020',
    name: 'Batu Gadang',
  },
  {
    id: '1371020004',
    districtId: '1371020',
    name: 'Indarung',
  },
  {
    id: '1371020005',
    districtId: '1371020',
    name: 'Padang Besi',
  },
  {
    id: '1371020006',
    districtId: '1371020',
    name: 'Koto Lalang',
  },
  {
    id: '1371020007',
    districtId: '1371020',
    name: 'Bandar Buat',
  },
  {
    id: '1371030007',
    districtId: '1371030',
    name: 'Kampung Baru Nan Xx',
  },
  {
    id: '1371030010',
    districtId: '1371030',
    name: 'Pampangan Nan Xx',
  },
  {
    id: '1371030011',
    districtId: '1371030',
    name: 'Koto Baru Nan Xx',
  },
  {
    id: '1371030012',
    districtId: '1371030',
    name: 'Tanjuang Aur Nan Xx',
  },
  {
    id: '1371030013',
    districtId: '1371030',
    name: 'Gurun Laweh Nan Xx',
  },
  {
    id: '1371030014',
    districtId: '1371030',
    name: 'Banuaran Nan Xx',
  },
  {
    id: '1371030016',
    districtId: '1371030',
    name: 'Lubuk Begalung Nan Xx',
  },
  {
    id: '1371030020',
    districtId: '1371030',
    name: 'Cengkeh Nan Xx',
  },
  {
    id: '1371030022',
    districtId: '1371030',
    name: 'Gates Nan Xx',
  },
  {
    id: '1371030023',
    districtId: '1371030',
    name: 'Pagambiran Ampulu Nan Xx',
  },
  {
    id: '1371030025',
    districtId: '1371030',
    name: 'Parak Laweh Pulau Air Nan Xx',
  },
  {
    id: '1371030026',
    districtId: '1371030',
    name: 'Tanjung Saba Pitameh Nan Xx',
  },
  {
    id: '1371030027',
    districtId: '1371030',
    name: 'Tanah Sirah Piai Nan Xx',
  },
  {
    id: '1371030028',
    districtId: '1371030',
    name: 'Kampung Jua Nan Xx',
  },
  {
    id: '1371030029',
    districtId: '1371030',
    name: 'Batuang Taba Nan Xx',
  },
  {
    id: '1371040003',
    districtId: '1371040',
    name: 'Air Manis',
  },
  {
    id: '1371040008',
    districtId: '1371040',
    name: 'Bukik Gado Gado',
  },
  {
    id: '1371040010',
    districtId: '1371040',
    name: 'Batang Arau',
  },
  {
    id: '1371040011',
    districtId: '1371040',
    name: 'Seberang Palinggam',
  },
  {
    id: '1371040016',
    districtId: '1371040',
    name: 'Pasa Gadang',
  },
  {
    id: '1371040021',
    districtId: '1371040',
    name: 'Belakang Pondok',
  },
  {
    id: '1371040024',
    districtId: '1371040',
    name: 'Alang Laweh',
  },
  {
    id: '1371040025',
    districtId: '1371040',
    name: 'Taluak Bayua',
  },
  {
    id: '1371040026',
    districtId: '1371040',
    name: 'Rawang',
  },
  {
    id: '1371040027',
    districtId: '1371040',
    name: 'Mato Aie',
  },
  {
    id: '1371040028',
    districtId: '1371040',
    name: 'Seberang Padang',
  },
  {
    id: '1371040029',
    districtId: '1371040',
    name: 'Ranah Parak Rumbio',
  },
  {
    id: '1371050020',
    districtId: '1371050',
    name: 'Sawahan',
  },
  {
    id: '1371050028',
    districtId: '1371050',
    name: 'Ganting Parak Gadang',
  },
  {
    id: '1371050029',
    districtId: '1371050',
    name: 'Parak Gadang Timur',
  },
  {
    id: '1371050030',
    districtId: '1371050',
    name: 'Kubu Marapalam',
  },
  {
    id: '1371050031',
    districtId: '1371050',
    name: 'Kubu Parak Karakah',
  },
  {
    id: '1371050032',
    districtId: '1371050',
    name: 'Andalas',
  },
  {
    id: '1371050033',
    districtId: '1371050',
    name: 'Simpang Haru',
  },
  {
    id: '1371050034',
    districtId: '1371050',
    name: 'Sawahan Timur',
  },
  {
    id: '1371050035',
    districtId: '1371050',
    name: 'Jati Baru',
  },
  {
    id: '1371050036',
    districtId: '1371050',
    name: 'Jati',
  },
  {
    id: '1371060010',
    districtId: '1371060',
    name: 'Belakang Tangsi',
  },
  {
    id: '1371060013',
    districtId: '1371060',
    name: 'Olo',
  },
  {
    id: '1371060023',
    districtId: '1371060',
    name: 'Ujung Gurun',
  },
  {
    id: '1371060031',
    districtId: '1371060',
    name: 'Berok Nipah',
  },
  {
    id: '1371060032',
    districtId: '1371060',
    name: 'Kampung Pondok',
  },
  {
    id: '1371060033',
    districtId: '1371060',
    name: 'Kampung Jao',
  },
  {
    id: '1371060034',
    districtId: '1371060',
    name: 'Purus',
  },
  {
    id: '1371060035',
    districtId: '1371060',
    name: 'Padang Pasir',
  },
  {
    id: '1371060036',
    districtId: '1371060',
    name: 'Rimbo Kaluang',
  },
  {
    id: '1371060037',
    districtId: '1371060',
    name: 'Flamboyan Baru',
  },
  {
    id: '1371070005',
    districtId: '1371070',
    name: 'Gunung Pangilun',
  },
  {
    id: '1371070010',
    districtId: '1371070',
    name: 'Ulak Karang Selatan',
  },
  {
    id: '1371070012',
    districtId: '1371070',
    name: 'Ulak Karang Utara',
  },
  {
    id: '1371070017',
    districtId: '1371070',
    name: 'Air Tawar Timur',
  },
  {
    id: '1371070018',
    districtId: '1371070',
    name: 'Air Tawar Barat',
  },
  {
    id: '1371070019',
    districtId: '1371070',
    name: 'Alai Parak Kopi',
  },
  {
    id: '1371070020',
    districtId: '1371070',
    name: 'Lolong Belanti',
  },
  {
    id: '1371080001',
    districtId: '1371080',
    name: 'Tabiang Banda Gadang',
  },
  {
    id: '1371080002',
    districtId: '1371080',
    name: 'Gurun Laweh',
  },
  {
    id: '1371080003',
    districtId: '1371080',
    name: 'Kampung Olo',
  },
  {
    id: '1371080005',
    districtId: '1371080',
    name: 'Kampung Lapai Baru',
  },
  {
    id: '1371080006',
    districtId: '1371080',
    name: 'Surau Gadang',
  },
  {
    id: '1371080007',
    districtId: '1371080',
    name: 'Kurao Pagang',
  },
  {
    id: '1371090001',
    districtId: '1371090',
    name: 'Anduring',
  },
  {
    id: '1371090002',
    districtId: '1371090',
    name: 'Pasar Ambacang',
  },
  {
    id: '1371090003',
    districtId: '1371090',
    name: 'Lubuk Lintah',
  },
  {
    id: '1371090004',
    districtId: '1371090',
    name: 'Ampang',
  },
  {
    id: '1371090005',
    districtId: '1371090',
    name: 'Kalumbuk',
  },
  {
    id: '1371090006',
    districtId: '1371090',
    name: 'Korong Gadang',
  },
  {
    id: '1371090007',
    districtId: '1371090',
    name: 'Kuranji',
  },
  {
    id: '1371090008',
    districtId: '1371090',
    name: 'Gunung Sarik',
  },
  {
    id: '1371090009',
    districtId: '1371090',
    name: 'Sungai Sapih',
  },
  {
    id: '1371100001',
    districtId: '1371100',
    name: 'Pisang',
  },
  {
    id: '1371100002',
    districtId: '1371100',
    name: 'Binuang Kampung Dalam',
  },
  {
    id: '1371100003',
    districtId: '1371100',
    name: 'Piai Tangah',
  },
  {
    id: '1371100004',
    districtId: '1371100',
    name: 'Cupak Tangah',
  },
  {
    id: '1371100005',
    districtId: '1371100',
    name: 'Kapala Koto',
  },
  {
    id: '1371100008',
    districtId: '1371100',
    name: 'Koto Luar',
  },
  {
    id: '1371100013',
    districtId: '1371100',
    name: 'Lambung Bukit',
  },
  {
    id: '1371100014',
    districtId: '1371100',
    name: 'Limau Manis Selatan',
  },
  {
    id: '1371100015',
    districtId: '1371100',
    name: 'Limau Manis',
  },
  {
    id: '1371110001',
    districtId: '1371110',
    name: 'Dadok Tunggul Hitam',
  },
  {
    id: '1371110002',
    districtId: '1371110',
    name: 'Air Pacah',
  },
  {
    id: '1371110004',
    districtId: '1371110',
    name: 'Lubuk Minturun',
  },
  {
    id: '1371110007',
    districtId: '1371110',
    name: 'Bungo Pasang',
  },
  {
    id: '1371110008',
    districtId: '1371110',
    name: 'Parupuk Tabing',
  },
  {
    id: '1371110012',
    districtId: '1371110',
    name: 'Batang Kabung',
  },
  {
    id: '1371110021',
    districtId: '1371110',
    name: 'Lubuk Buaya',
  },
  {
    id: '1371110023',
    districtId: '1371110',
    name: 'Padang Sarai',
  },
  {
    id: '1371110025',
    districtId: '1371110',
    name: 'Koto Panjang Ikua Koto',
  },
  {
    id: '1371110026',
    districtId: '1371110',
    name: 'Pasir Nan Tigo',
  },
  {
    id: '1371110027',
    districtId: '1371110',
    name: 'Koto Pulai',
  },
  {
    id: '1371110028',
    districtId: '1371110',
    name: 'Balai Gadang',
  },
  {
    id: '1371110029',
    districtId: '1371110',
    name: 'Batipuh Panjang',
  },
  {
    id: '1372010001',
    districtId: '1372010',
    name: 'Tanah Garam',
  },
  {
    id: '1372010002',
    districtId: '1372010',
    name: 'VI Suku',
  },
  {
    id: '1372010003',
    districtId: '1372010',
    name: 'Sinapa Piliang',
  },
  {
    id: '1372010004',
    districtId: '1372010',
    name: 'IX Korong',
  },
  {
    id: '1372010005',
    districtId: '1372010',
    name: 'Kampai Tabu Kerambil',
  },
  {
    id: '1372010006',
    districtId: '1372010',
    name: 'Aro IV Korong',
  },
  {
    id: '1372010007',
    districtId: '1372010',
    name: 'Simpang Rumbio',
  },
  {
    id: '1372020001',
    districtId: '1372020',
    name: 'Koto Panjang',
  },
  {
    id: '1372020002',
    districtId: '1372020',
    name: 'Pasar Pandan Air Mati',
  },
  {
    id: '1372020003',
    districtId: '1372020',
    name: 'Tanjung Paku',
  },
  {
    id: '1372020004',
    districtId: '1372020',
    name: 'Nan Balimo',
  },
  {
    id: '1372020005',
    districtId: '1372020',
    name: 'Kampung Jawa',
  },
  {
    id: '1372020006',
    districtId: '1372020',
    name: 'Laing',
  },
  {
    id: '1373010001',
    districtId: '1373010',
    name: 'Silungkang Oso',
  },
  {
    id: '1373010002',
    districtId: '1373010',
    name: 'Taratak Bancah',
  },
  {
    id: '1373010003',
    districtId: '1373010',
    name: 'Muaro Kalaban',
  },
  {
    id: '1373010004',
    districtId: '1373010',
    name: 'Silungkang Tigo',
  },
  {
    id: '1373010005',
    districtId: '1373010',
    name: 'Silungkang Duo',
  },
  {
    id: '1373020001',
    districtId: '1373020',
    name: 'Lunto Barat',
  },
  {
    id: '1373020002',
    districtId: '1373020',
    name: 'Lunto Timur',
  },
  {
    id: '1373020003',
    districtId: '1373020',
    name: 'Pasar Kubang',
  },
  {
    id: '1373020004',
    districtId: '1373020',
    name: 'Kubang Tangah',
  },
  {
    id: '1373020005',
    districtId: '1373020',
    name: 'Kubang Utara Sikabu',
  },
  {
    id: '1373020006',
    districtId: '1373020',
    name: 'Pasar',
  },
  {
    id: '1373020007',
    districtId: '1373020',
    name: 'Kubang Sirakuk Utara',
  },
  {
    id: '1373020008',
    districtId: '1373020',
    name: 'Kubang Sirakuk Selatan',
  },
  {
    id: '1373020009',
    districtId: '1373020',
    name: 'Aur Mulyo',
  },
  {
    id: '1373020010',
    districtId: '1373020',
    name: 'Tanah Lapang',
  },
  {
    id: '1373020011',
    districtId: '1373020',
    name: 'Air Dingin',
  },
  {
    id: '1373030001',
    districtId: '1373030',
    name: 'Lumindai',
  },
  {
    id: '1373030002',
    districtId: '1373030',
    name: 'Balai Batu Sandaran',
  },
  {
    id: '1373030003',
    districtId: '1373030',
    name: 'Saringan',
  },
  {
    id: '1373030004',
    districtId: '1373030',
    name: 'Lubang Panjang',
  },
  {
    id: '1373030005',
    districtId: '1373030',
    name: 'Durian I',
  },
  {
    id: '1373030006',
    districtId: '1373030',
    name: 'Durian II',
  },
  {
    id: '1373030007',
    districtId: '1373030',
    name: 'Talago Gunung',
  },
  {
    id: '1373030008',
    districtId: '1373030',
    name: 'Santur',
  },
  {
    id: '1373030009',
    districtId: '1373030',
    name: 'Kolok Mudik',
  },
  {
    id: '1373030010',
    districtId: '1373030',
    name: 'Kolok Nan Tuo',
  },
  {
    id: '1373040001',
    districtId: '1373040',
    name: 'Sikalang',
  },
  {
    id: '1373040002',
    districtId: '1373040',
    name: 'Rantih',
  },
  {
    id: '1373040003',
    districtId: '1373040',
    name: 'Salak',
  },
  {
    id: '1373040004',
    districtId: '1373040',
    name: 'Sijantang Koto',
  },
  {
    id: '1373040005',
    districtId: '1373040',
    name: 'Talawi Hilir',
  },
  {
    id: '1373040006',
    districtId: '1373040',
    name: 'Talawi Mudik',
  },
  {
    id: '1373040007',
    districtId: '1373040',
    name: 'Bukik Gadang',
  },
  {
    id: '1373040008',
    districtId: '1373040',
    name: 'Batu Tanjung',
  },
  {
    id: '1373040009',
    districtId: '1373040',
    name: 'Kumbayau',
  },
  {
    id: '1373040010',
    districtId: '1373040',
    name: 'Datar Mansiang',
  },
  {
    id: '1373040011',
    districtId: '1373040',
    name: 'Tumpuk Tangah',
  },
  {
    id: '1374010001',
    districtId: '1374010',
    name: 'Silaing Bawah',
  },
  {
    id: '1374010002',
    districtId: '1374010',
    name: 'Silaing Atas',
  },
  {
    id: '1374010003',
    districtId: '1374010',
    name: 'Pasar Usang',
  },
  {
    id: '1374010004',
    districtId: '1374010',
    name: 'Kampung  Manggis',
  },
  {
    id: '1374010005',
    districtId: '1374010',
    name: 'Tanah Hitam',
  },
  {
    id: '1374010006',
    districtId: '1374010',
    name: 'Pasar Baru',
  },
  {
    id: '1374010007',
    districtId: '1374010',
    name: 'Bukit Surungan',
  },
  {
    id: '1374010008',
    districtId: '1374010',
    name: 'Balai-Balai',
  },
  {
    id: '1374020001',
    districtId: '1374020',
    name: 'Koto Panjang',
  },
  {
    id: '1374020002',
    districtId: '1374020',
    name: 'Koto Katik',
  },
  {
    id: '1374020003',
    districtId: '1374020',
    name: 'Ngalau',
  },
  {
    id: '1374020004',
    districtId: '1374020',
    name: 'Ekor Lubuk',
  },
  {
    id: '1374020005',
    districtId: '1374020',
    name: 'Sigando',
  },
  {
    id: '1374020006',
    districtId: '1374020',
    name: 'Ganting',
  },
  {
    id: '1374020007',
    districtId: '1374020',
    name: 'Guguk  Malintang',
  },
  {
    id: '1374020008',
    districtId: '1374020',
    name: 'Tanah  Pak Lambik',
  },
  {
    id: '1375010001',
    districtId: '1375010',
    name: 'Bukit Cangang Kayu Ramang',
  },
  {
    id: '1375010002',
    districtId: '1375010',
    name: 'Tarok Dipo',
  },
  {
    id: '1375010003',
    districtId: '1375010',
    name: 'Pakan Kurai',
  },
  {
    id: '1375010004',
    districtId: '1375010',
    name: 'Aur Tajungkang Tengah Sawah',
  },
  {
    id: '1375010005',
    districtId: '1375010',
    name: 'Benteng Pasar Atas',
  },
  {
    id: '1375010006',
    districtId: '1375010',
    name: 'Kayu Kubu',
  },
  {
    id: '1375010007',
    districtId: '1375010',
    name: 'Bukit Apit Puhun',
  },
  {
    id: '1375020001',
    districtId: '1375020',
    name: 'Pulai Anak Air',
  },
  {
    id: '1375020002',
    districtId: '1375020',
    name: 'Koto Selayan',
  },
  {
    id: '1375020003',
    districtId: '1375020',
    name: 'Garegeh',
  },
  {
    id: '1375020004',
    districtId: '1375020',
    name: 'Manggis Ganting',
  },
  {
    id: '1375020005',
    districtId: '1375020',
    name: 'Campago Ipuh',
  },
  {
    id: '1375020006',
    districtId: '1375020',
    name: 'Puhun Tembok',
  },
  {
    id: '1375020007',
    districtId: '1375020',
    name: 'Puhun Pintu Kabun',
  },
  {
    id: '1375020008',
    districtId: '1375020',
    name: 'Kubu Gulai Bancah',
  },
  {
    id: '1375020009',
    districtId: '1375020',
    name: 'Campago Guguk Bulek',
  },
  {
    id: '1375030001',
    districtId: '1375030',
    name: 'Belakang Balok',
  },
  {
    id: '1375030002',
    districtId: '1375030',
    name: 'Sapiran',
  },
  {
    id: '1375030003',
    districtId: '1375030',
    name: 'Birugo',
  },
  {
    id: '1375030004',
    districtId: '1375030',
    name: 'Aur Kuning',
  },
  {
    id: '1375030005',
    districtId: '1375030',
    name: 'Pakan Labuh',
  },
  {
    id: '1375030006',
    districtId: '1375030',
    name: 'Kubu Tanjung',
  },
  {
    id: '1375030007',
    districtId: '1375030',
    name: 'Ladang Cakiah',
  },
  {
    id: '1375030008',
    districtId: '1375030',
    name: 'Parit Antang',
  },
  {
    id: '1376010010',
    districtId: '1376010',
    name: 'Pakan Sinayan',
  },
  {
    id: '1376010011',
    districtId: '1376010',
    name: 'Kubu Gadang',
  },
  {
    id: '1376010012',
    districtId: '1376010',
    name: 'Bulakan Balai Kandi',
  },
  {
    id: '1376010013',
    districtId: '1376010',
    name: 'Tanjuang Pauah',
  },
  {
    id: '1376010014',
    districtId: '1376010',
    name: 'Ibuah',
  },
  {
    id: '1376010015',
    districtId: '1376010',
    name: 'Labuah Basilang',
  },
  {
    id: '1376010018',
    districtId: '1376010',
    name: 'Parak Batuang',
  },
  {
    id: '1376010019',
    districtId: '1376010',
    name: 'Parik Rantang',
  },
  {
    id: '1376010025',
    districtId: '1376010',
    name: 'Payolansek',
  },
  {
    id: '1376010027',
    districtId: '1376010',
    name: 'Tanah Mati',
  },
  {
    id: '1376010028',
    districtId: '1376010',
    name: 'Padang Data',
  },
  {
    id: '1376010029',
    districtId: '1376010',
    name: 'Subarang Batuang',
  },
  {
    id: '1376010030',
    districtId: '1376010',
    name: 'Koto Tangah',
  },
  {
    id: '1376010031',
    districtId: '1376010',
    name: 'Talang',
  },
  {
    id: '1376010032',
    districtId: '1376010',
    name: 'Nunang Daya Bangun',
  },
  {
    id: '1376010033',
    districtId: '1376010',
    name: 'Padang Tinggi Piliang',
  },
  {
    id: '1376010034',
    districtId: '1376010',
    name: 'Padangtongah Balainanduo',
  },
  {
    id: '1376010035',
    districtId: '1376010',
    name: 'Tanjuanggodang Sungaipinago',
  },
  {
    id: '1376011001',
    districtId: '1376011',
    name: 'Balai Panjang',
  },
  {
    id: '1376011002',
    districtId: '1376011',
    name: 'Limbukan',
  },
  {
    id: '1376011004',
    districtId: '1376011',
    name: 'Padang Karambia',
  },
  {
    id: '1376011010',
    districtId: '1376011',
    name: 'Kototuo Limokampuang',
  },
  {
    id: '1376011011',
    districtId: '1376011',
    name: 'Kapalo Koto Ampangan',
  },
  {
    id: '1376011012',
    districtId: '1376011',
    name: 'Sawahpadang Aua Kuniang',
  },
  {
    id: '1376020005',
    districtId: '1376020',
    name: 'Padang Tangah Payobada',
  },
  {
    id: '1376020006',
    districtId: '1376020',
    name: 'Balai Jaring',
  },
  {
    id: '1376020012',
    districtId: '1376020',
    name: 'Payobasung',
  },
  {
    id: '1376020013',
    districtId: '1376020',
    name: 'Koto Panjang',
  },
  {
    id: '1376020014',
    districtId: '1376020',
    name: 'Koto Baru',
  },
  {
    id: '1376020015',
    districtId: '1376020',
    name: 'Padang Alai Bodi',
  },
  {
    id: '1376020016',
    districtId: '1376020',
    name: 'Padang Tiakar',
  },
  {
    id: '1376020017',
    districtId: '1376020',
    name: 'Sicincin',
  },
  {
    id: '1376020018',
    districtId: '1376020',
    name: 'Tiakar',
  },
  {
    id: '1376030005',
    districtId: '1376030',
    name: 'Napar',
  },
  {
    id: '1376030029',
    districtId: '1376030',
    name: 'Ompang Tanah Sirah',
  },
  {
    id: '1376030030',
    districtId: '1376030',
    name: 'Taratak Padang Kampuang',
  },
  {
    id: '1376030031',
    districtId: '1376030',
    name: 'Tigo Koto Dibaruah',
  },
  {
    id: '1376030032',
    districtId: '1376030',
    name: 'Tigo Koto Diate',
  },
  {
    id: '1376030033',
    districtId: '1376030',
    name: 'Kapalo Koto Dibalai',
  },
  {
    id: '1376030034',
    districtId: '1376030',
    name: 'Kotokociak Kubu Tapakrajo',
  },
  {
    id: '1376030035',
    districtId: '1376030',
    name: 'Balai Tongah Koto',
  },
  {
    id: '1376030036',
    districtId: '1376030',
    name: 'Ikua Koto Dibalai',
  },
  {
    id: '1376031001',
    districtId: '1376031',
    name: 'Koto Panjang Padang',
  },
  {
    id: '1376031002',
    districtId: '1376031',
    name: 'Koto Panjang Dalam',
  },
  {
    id: '1376031003',
    districtId: '1376031',
    name: 'Parambahan',
  },
  {
    id: '1376031004',
    districtId: '1376031',
    name: 'Padang Sikabu',
  },
  {
    id: '1376031005',
    districtId: '1376031',
    name: 'Parit Muko Aie',
  },
  {
    id: '1376031006',
    districtId: '1376031',
    name: 'Sungai Durian',
  },
  {
    id: '1377010001',
    districtId: '1377010',
    name: 'Pasir Sunur',
  },
  {
    id: '1377010002',
    districtId: '1377010',
    name: 'Marunggi',
  },
  {
    id: '1377010003',
    districtId: '1377010',
    name: 'Kampung Apar',
  },
  {
    id: '1377010004',
    districtId: '1377010',
    name: 'Sikabu',
  },
  {
    id: '1377010005',
    districtId: '1377010',
    name: 'Palak Aneh',
  },
  {
    id: '1377010006',
    districtId: '1377010',
    name: 'Padang Cakur',
  },
  {
    id: '1377010007',
    districtId: '1377010',
    name: 'Taluk',
  },
  {
    id: '1377010008',
    districtId: '1377010',
    name: 'Marabau',
  },
  {
    id: '1377010009',
    districtId: '1377010',
    name: 'Sungai Kasai',
  },
  {
    id: '1377010010',
    districtId: '1377010',
    name: 'Batang Tajongkek',
  },
  {
    id: '1377010011',
    districtId: '1377010',
    name: 'Balai Kurai Taji',
  },
  {
    id: '1377010012',
    districtId: '1377010',
    name: 'Pauh Kurai Taji',
  },
  {
    id: '1377010013',
    districtId: '1377010',
    name: 'Simpang',
  },
  {
    id: '1377010014',
    districtId: '1377010',
    name: 'Toboh Palabah',
  },
  {
    id: '1377010018',
    districtId: '1377010',
    name: 'Rambai',
  },
  {
    id: '1377010019',
    districtId: '1377010',
    name: 'Punggung Lading',
  },
  {
    id: '1377020001',
    districtId: '1377020',
    name: 'Karan Aur',
  },
  {
    id: '1377020002',
    districtId: '1377020',
    name: 'Jalan Baru',
  },
  {
    id: '1377020003',
    districtId: '1377020',
    name: 'Ujung Batung',
  },
  {
    id: '1377020004',
    districtId: '1377020',
    name: 'Jalan Kereta Api',
  },
  {
    id: '1377020005',
    districtId: '1377020',
    name: 'Cimparuh',
  },
  {
    id: '1377020006',
    districtId: '1377020',
    name: 'Alai Gelombang',
  },
  {
    id: '1377020007',
    districtId: '1377020',
    name: 'Taratak',
  },
  {
    id: '1377020008',
    districtId: '1377020',
    name: 'Kampung Baru',
  },
  {
    id: '1377020009',
    districtId: '1377020',
    name: 'Lohong',
  },
  {
    id: '1377020010',
    districtId: '1377020',
    name: 'Pasir',
  },
  {
    id: '1377020011',
    districtId: '1377020',
    name: 'Kampung Perak',
  },
  {
    id: '1377020012',
    districtId: '1377020',
    name: 'Pondok II',
  },
  {
    id: '1377020013',
    districtId: '1377020',
    name: 'Jawi-Jawi I',
  },
  {
    id: '1377020014',
    districtId: '1377020',
    name: 'Jawi-Jawi II',
  },
  {
    id: '1377020015',
    districtId: '1377020',
    name: 'Kampung Jawa II',
  },
  {
    id: '1377020016',
    districtId: '1377020',
    name: 'Kampung Jawa I',
  },
  {
    id: '1377020017',
    districtId: '1377020',
    name: 'Kampung Pondok',
  },
  {
    id: '1377020018',
    districtId: '1377020',
    name: 'Pauh Barat',
  },
  {
    id: '1377020019',
    districtId: '1377020',
    name: 'Pauh Timur',
  },
  {
    id: '1377020020',
    districtId: '1377020',
    name: 'Rawang',
  },
  {
    id: '1377020021',
    districtId: '1377020',
    name: 'Jati Hilir',
  },
  {
    id: '1377020022',
    districtId: '1377020',
    name: 'Jati Mudik',
  },
  {
    id: '1377021001',
    districtId: '1377021',
    name: 'Kampung Gadang',
  },
  {
    id: '1377021002',
    districtId: '1377021',
    name: 'Talago Sarik',
  },
  {
    id: '1377021003',
    districtId: '1377021',
    name: 'Bato',
  },
  {
    id: '1377021004',
    districtId: '1377021',
    name: 'Batang Kabung',
  },
  {
    id: '1377021005',
    districtId: '1377021',
    name: 'Sungai Sirah',
  },
  {
    id: '1377021006',
    districtId: '1377021',
    name: 'Bungo Tanjung',
  },
  {
    id: '1377021007',
    districtId: '1377021',
    name: 'Kampung Kandang',
  },
  {
    id: '1377021008',
    districtId: '1377021',
    name: 'Kaluat',
  },
  {
    id: '1377021009',
    districtId: '1377021',
    name: 'Kajai',
  },
  {
    id: '1377021010',
    districtId: '1377021',
    name: 'Kampung Tangah',
  },
  {
    id: '1377021011',
    districtId: '1377021',
    name: 'Sungai Pasak',
  },
  {
    id: '1377021012',
    districtId: '1377021',
    name: 'Air Santok',
  },
  {
    id: '1377021013',
    districtId: '1377021',
    name: 'Cubadak Mentawai',
  },
  {
    id: '1377021014',
    districtId: '1377021',
    name: 'Koto Marapak',
  },
  {
    id: '1377021015',
    districtId: '1377021',
    name: 'Pakasai',
  },
  {
    id: '1377021016',
    districtId: '1377021',
    name: 'Kampung Baru Padusunan',
  },
  {
    id: '1377030001',
    districtId: '1377030',
    name: 'Ampalu',
  },
  {
    id: '1377030006',
    districtId: '1377030',
    name: 'Tanjung Sabar',
  },
  {
    id: '1377030007',
    districtId: '1377030',
    name: 'Apar',
  },
  {
    id: '1377030008',
    districtId: '1377030',
    name: 'Manggung',
  },
  {
    id: '1377030009',
    districtId: '1377030',
    name: 'Cubadak Air',
  },
  {
    id: '1377030010',
    districtId: '1377030',
    name: 'Cubadak Air Selatan',
  },
  {
    id: '1377030011',
    districtId: '1377030',
    name: 'Sikapak Timur',
  },
  {
    id: '1377030012',
    districtId: '1377030',
    name: 'Sikapak Barat',
  },
  {
    id: '1377030013',
    districtId: '1377030',
    name: 'Tungkal Selatan',
  },
  {
    id: '1377030014',
    districtId: '1377030',
    name: 'Tungkal Utara',
  },
  {
    id: '1377030015',
    districtId: '1377030',
    name: 'Cubadak Air Utara',
  },
  {
    id: '1377030016',
    districtId: '1377030',
    name: 'Naras Hilir',
  },
  {
    id: '1377030017',
    districtId: '1377030',
    name: 'Naras I',
  },
  {
    id: '1377030018',
    districtId: '1377030',
    name: 'Balai Naras',
  },
  {
    id: '1377030019',
    districtId: '1377030',
    name: 'Padang Birik-Birik',
  },
  {
    id: '1377030020',
    districtId: '1377030',
    name: 'Sintuk',
  },
  {
    id: '1377030021',
    districtId: '1377030',
    name: 'Sungai Rambai',
  },
  {
    id: '1401010005',
    districtId: '1401010',
    name: 'Pantai',
  },
  {
    id: '1401010006',
    districtId: '1401010',
    name: 'Air Buluh',
  },
  {
    id: '1401010007',
    districtId: '1401010',
    name: 'Lubuk Ramo',
  },
  {
    id: '1401010008',
    districtId: '1401010',
    name: 'Koto Cengar',
  },
  {
    id: '1401010009',
    districtId: '1401010',
    name: 'Seberang Cengar',
  },
  {
    id: '1401010010',
    districtId: '1401010',
    name: 'Sangau',
  },
  {
    id: '1401010011',
    districtId: '1401010',
    name: 'Banjar Padang',
  },
  {
    id: '1401010012',
    districtId: '1401010',
    name: 'Lubuk Jambi',
  },
  {
    id: '1401010013',
    districtId: '1401010',
    name: 'Koto Lubuk Jambi',
  },
  {
    id: '1401010014',
    districtId: '1401010',
    name: 'Kasang',
  },
  {
    id: '1401010016',
    districtId: '1401010',
    name: 'Aur Duri',
  },
  {
    id: '1401010017',
    districtId: '1401010',
    name: 'Bukit Kauman',
  },
  {
    id: '1401010018',
    districtId: '1401010',
    name: 'Sungai Manau',
  },
  {
    id: '1401010028',
    districtId: '1401010',
    name: 'Saik',
  },
  {
    id: '1401010029',
    districtId: '1401010',
    name: 'Pebaun Hulu',
  },
  {
    id: '1401010030',
    districtId: '1401010',
    name: 'Pebaun Hilir',
  },
  {
    id: '1401010031',
    districtId: '1401010',
    name: 'Kinali',
  },
  {
    id: '1401010032',
    districtId: '1401010',
    name: 'Pulau Binjai',
  },
  {
    id: '1401010033',
    districtId: '1401010',
    name: 'Seberang Pantai',
  },
  {
    id: '1401010034',
    districtId: '1401010',
    name: 'Luai',
  },
  {
    id: '1401010035',
    districtId: '1401010',
    name: 'Rantau Sialang',
  },
  {
    id: '1401010036',
    districtId: '1401010',
    name: 'Banjar Guntung',
  },
  {
    id: '1401010038',
    districtId: '1401010',
    name: 'Bukit Pedusunan',
  },
  {
    id: '1401010041',
    districtId: '1401010',
    name: 'Muaro Tombang',
  },
  {
    id: '1401011001',
    districtId: '1401011',
    name: 'Sungai Kelelawar',
  },
  {
    id: '1401011002',
    districtId: '1401011',
    name: 'Sungai Alah',
  },
  {
    id: '1401011003',
    districtId: '1401011',
    name: 'Lubuk Ambacang',
  },
  {
    id: '1401011004',
    districtId: '1401011',
    name: 'Koto Kombu',
  },
  {
    id: '1401011005',
    districtId: '1401011',
    name: 'Sumpu',
  },
  {
    id: '1401011006',
    districtId: '1401011',
    name: 'Inuman',
  },
  {
    id: '1401011007',
    districtId: '1401011',
    name: 'Tanjung Medang',
  },
  {
    id: '1401011008',
    districtId: '1401011',
    name: 'Mudik Ulo',
  },
  {
    id: '1401011009',
    districtId: '1401011',
    name: 'Sungai Pinang',
  },
  {
    id: '1401011010',
    districtId: '1401011',
    name: 'Tanjung',
  },
  {
    id: '1401011011',
    districtId: '1401011',
    name: 'Serosah',
  },
  {
    id: '1401011012',
    districtId: '1401011',
    name: 'Sampurago',
  },
  {
    id: '1401012001',
    districtId: '1401012',
    name: 'Pulau Rumput',
  },
  {
    id: '1401012002',
    districtId: '1401012',
    name: 'Koto Gunung',
  },
  {
    id: '1401012003',
    districtId: '1401012',
    name: 'Teluk Beringin',
  },
  {
    id: '1401012004',
    districtId: '1401012',
    name: 'Pulau Mungkur',
  },
  {
    id: '1401012005',
    districtId: '1401012',
    name: 'Seberang Gunung',
  },
  {
    id: '1401012006',
    districtId: '1401012',
    name: 'Teberau Panjang',
  },
  {
    id: '1401012007',
    districtId: '1401012',
    name: 'Gunung',
  },
  {
    id: '1401012008',
    districtId: '1401012',
    name: 'Toar',
  },
  {
    id: '1401012009',
    districtId: '1401012',
    name: 'Kampung Baru',
  },
  {
    id: '1401012010',
    districtId: '1401012',
    name: 'Petapahan',
  },
  {
    id: '1401012011',
    districtId: '1401012',
    name: 'Lubuk Terantang',
  },
  {
    id: '1401012012',
    districtId: '1401012',
    name: 'Siberobah',
  },
  {
    id: '1401012013',
    districtId: '1401012',
    name: 'Pisang Berebus',
  },
  {
    id: '1401012014',
    districtId: '1401012',
    name: 'Seberang Sungai',
  },
  {
    id: '1401013001',
    districtId: '1401013',
    name: 'Perhentian Sungkai',
  },
  {
    id: '1401013002',
    districtId: '1401013',
    name: 'Sungai Besar',
  },
  {
    id: '1401013003',
    districtId: '1401013',
    name: 'Sungai Besar Hilir',
  },
  {
    id: '1401013004',
    districtId: '1401013',
    name: 'Ibul',
  },
  {
    id: '1401013005',
    districtId: '1401013',
    name: 'Kampung Baru Ibul',
  },
  {
    id: '1401013006',
    districtId: '1401013',
    name: 'Pangkalan',
  },
  {
    id: '1401013007',
    districtId: '1401013',
    name: 'Muaro Tobek',
  },
  {
    id: '1401013008',
    districtId: '1401013',
    name: 'Muaro Tiu Makmur',
  },
  {
    id: '1401013009',
    districtId: '1401013',
    name: 'Muara Petai',
  },
  {
    id: '1401013010',
    districtId: '1401013',
    name: 'Setiang',
  },
  {
    id: '1401020001',
    districtId: '1401020',
    name: 'Pangkalan Indarung',
  },
  {
    id: '1401020002',
    districtId: '1401020',
    name: 'Pulau Padang',
  },
  {
    id: '1401020003',
    districtId: '1401020',
    name: 'Muara Lembu',
  },
  {
    id: '1401020004',
    districtId: '1401020',
    name: 'Logas',
  },
  {
    id: '1401020005',
    districtId: '1401020',
    name: 'Sungai Bawang',
  },
  {
    id: '1401020006',
    districtId: '1401020',
    name: 'Air Mas',
  },
  {
    id: '1401020007',
    districtId: '1401020',
    name: 'Sumber Datar',
  },
  {
    id: '1401020008',
    districtId: '1401020',
    name: 'Sungai Keranji',
  },
  {
    id: '1401020009',
    districtId: '1401020',
    name: 'Pasir Emas',
  },
  {
    id: '1401020010',
    districtId: '1401020',
    name: 'Sungai Sirih',
  },
  {
    id: '1401020011',
    districtId: '1401020',
    name: 'Kebun Lado',
  },
  {
    id: '1401020013',
    districtId: '1401020',
    name: 'Sungai Kuning',
  },
  {
    id: '1401020014',
    districtId: '1401020',
    name: 'Petai Baru',
  },
  {
    id: '1401020015',
    districtId: '1401020',
    name: 'Logas Hilir',
  },
  {
    id: '1401021001',
    districtId: '1401021',
    name: 'Petai',
  },
  {
    id: '1401021002',
    districtId: '1401021',
    name: 'Sungai Buluh',
  },
  {
    id: '1401021003',
    districtId: '1401021',
    name: 'Simpang Raya',
  },
  {
    id: '1401021004',
    districtId: '1401021',
    name: 'Koto Baru',
  },
  {
    id: '1401021005',
    districtId: '1401021',
    name: 'Sumber Jaya',
  },
  {
    id: '1401021006',
    districtId: '1401021',
    name: 'Suka Damai',
  },
  {
    id: '1401021007',
    districtId: '1401021',
    name: 'Muara Bahan',
  },
  {
    id: '1401021008',
    districtId: '1401021',
    name: 'Bukit Raya',
  },
  {
    id: '1401021009',
    districtId: '1401021',
    name: 'Beringin Jaya',
  },
  {
    id: '1401021010',
    districtId: '1401021',
    name: 'Sukamaju',
  },
  {
    id: '1401021011',
    districtId: '1401021',
    name: 'Sungai Paku',
  },
  {
    id: '1401021012',
    districtId: '1401021',
    name: 'Tanjung Pauh',
  },
  {
    id: '1401030001',
    districtId: '1401030',
    name: 'Bandar Alai',
  },
  {
    id: '1401030002',
    districtId: '1401030',
    name: 'Pulau Kedundung',
  },
  {
    id: '1401030003',
    districtId: '1401030',
    name: 'Pulau Aro',
  },
  {
    id: '1401030004',
    districtId: '1401030',
    name: 'Seberang Taluk',
  },
  {
    id: '1401030005',
    districtId: '1401030',
    name: 'Pulau Baru',
  },
  {
    id: '1401030006',
    districtId: '1401030',
    name: 'Koto Tuo',
  },
  {
    id: '1401030007',
    districtId: '1401030',
    name: 'Kopah',
  },
  {
    id: '1401030008',
    districtId: '1401030',
    name: 'Jaya',
  },
  {
    id: '1401030009',
    districtId: '1401030',
    name: 'Munsalo',
  },
  {
    id: '1401030015',
    districtId: '1401030',
    name: 'Beringin Taluk',
  },
  {
    id: '1401030016',
    districtId: '1401030',
    name: 'Sawah',
  },
  {
    id: '1401030017',
    districtId: '1401030',
    name: 'Pasar Taluk',
  },
  {
    id: '1401030018',
    districtId: '1401030',
    name: 'Koto Taluk',
  },
  {
    id: '1401030019',
    districtId: '1401030',
    name: 'Simpang Tiga',
  },
  {
    id: '1401030020',
    districtId: '1401030',
    name: 'Pulau Godang',
  },
  {
    id: '1401030021',
    districtId: '1401030',
    name: 'Koto Kari',
  },
  {
    id: '1401030022',
    districtId: '1401030',
    name: 'Pintu Gobang',
  },
  {
    id: '1401030023',
    districtId: '1401030',
    name: 'Jake',
  },
  {
    id: '1401030024',
    districtId: '1401030',
    name: 'Sitorajo',
  },
  {
    id: '1401030025',
    districtId: '1401030',
    name: 'Seberang Teluk Hilir',
  },
  {
    id: '1401030026',
    districtId: '1401030',
    name: 'Sungai Jering',
  },
  {
    id: '1401030027',
    districtId: '1401030',
    name: 'Titian Modang Kopah',
  },
  {
    id: '1401030028',
    districtId: '1401030',
    name: 'Pulau Banjar Kari',
  },
  {
    id: '1401031001',
    districtId: '1401031',
    name: 'Pulau Kopung',
  },
  {
    id: '1401031002',
    districtId: '1401031',
    name: 'Kampung Baru Sentajo',
  },
  {
    id: '1401031003',
    districtId: '1401031',
    name: 'Koto Sentajo',
  },
  {
    id: '1401031004',
    districtId: '1401031',
    name: 'Muaro Sentajo',
  },
  {
    id: '1401031005',
    districtId: '1401031',
    name: 'Pulau Komang',
  },
  {
    id: '1401031006',
    districtId: '1401031',
    name: 'Beringin Jaya',
  },
  {
    id: '1401031007',
    districtId: '1401031',
    name: 'Jalur Patah',
  },
  {
    id: '1401031008',
    districtId: '1401031',
    name: 'Teratak Air Hitam',
  },
  {
    id: '1401031009',
    districtId: '1401031',
    name: 'Parit Teratak Air Hitam',
  },
  {
    id: '1401031010',
    districtId: '1401031',
    name: 'Seberang Teratak Air Hitam',
  },
  {
    id: '1401031011',
    districtId: '1401031',
    name: 'Geringging Baru',
  },
  {
    id: '1401031012',
    districtId: '1401031',
    name: 'Marsawa',
  },
  {
    id: '1401031013',
    districtId: '1401031',
    name: 'Langsat Hulu',
  },
  {
    id: '1401031014',
    districtId: '1401031',
    name: 'Muara Langsat',
  },
  {
    id: '1401031015',
    districtId: '1401031',
    name: 'Geringging Jaya',
  },
  {
    id: '1401040001',
    districtId: '1401040',
    name: 'Koto Benai',
  },
  {
    id: '1401040002',
    districtId: '1401040',
    name: 'Talontam',
  },
  {
    id: '1401040003',
    districtId: '1401040',
    name: 'Banjar Benai',
  },
  {
    id: '1401040004',
    districtId: '1401040',
    name: 'Gunung Kesiangan',
  },
  {
    id: '1401040005',
    districtId: '1401040',
    name: 'Banjar Lopak',
  },
  {
    id: '1401040006',
    districtId: '1401040',
    name: 'Pulau Kalimanting',
  },
  {
    id: '1401040007',
    districtId: '1401040',
    name: 'Tanjung',
  },
  {
    id: '1401040008',
    districtId: '1401040',
    name: 'Pulau Ingu',
  },
  {
    id: '1401040009',
    districtId: '1401040',
    name: 'Simandolak',
  },
  {
    id: '1401040012',
    districtId: '1401040',
    name: 'Tebing Tinggi',
  },
  {
    id: '1401040013',
    districtId: '1401040',
    name: 'Pulau Lancang',
  },
  {
    id: '1401040014',
    districtId: '1401040',
    name: 'Pulau Tongah',
  },
  {
    id: '1401040015',
    districtId: '1401040',
    name: 'Ujung Tanjung',
  },
  {
    id: '1401040016',
    districtId: '1401040',
    name: 'Siberakun',
  },
  {
    id: '1401040017',
    districtId: '1401040',
    name: 'Benai',
  },
  {
    id: '1401040018',
    districtId: '1401040',
    name: 'Benai Kecil',
  },
  {
    id: '1401050020',
    districtId: '1401050',
    name: 'Pulau Kijang',
  },
  {
    id: '1401050021',
    districtId: '1401050',
    name: 'Banuaran',
  },
  {
    id: '1401050022',
    districtId: '1401050',
    name: 'Koto Tuo',
  },
  {
    id: '1401050023',
    districtId: '1401050',
    name: 'Pasar Usang Baserah',
  },
  {
    id: '1401050024',
    districtId: '1401050',
    name: 'Pulau Madinah',
  },
  {
    id: '1401050025',
    districtId: '1401050',
    name: 'Kampung Tengah',
  },
  {
    id: '1401050026',
    districtId: '1401050',
    name: 'Kepala Pulau',
  },
  {
    id: '1401050035',
    districtId: '1401050',
    name: 'Kampung Medan',
  },
  {
    id: '1401050036',
    districtId: '1401050',
    name: 'Pasar Baru Baserah',
  },
  {
    id: '1401050037',
    districtId: '1401050',
    name: 'Simpang Tanah Lapang',
  },
  {
    id: '1401050038',
    districtId: '1401050',
    name: 'Kampung Madura',
  },
  {
    id: '1401050039',
    districtId: '1401050',
    name: 'Rawang Bonto',
  },
  {
    id: '1401050040',
    districtId: '1401050',
    name: 'Dusun Tuo',
  },
  {
    id: '1401050041',
    districtId: '1401050',
    name: 'Gunung Melintang',
  },
  {
    id: '1401050042',
    districtId: '1401050',
    name: 'Teratak Baru',
  },
  {
    id: '1401050043',
    districtId: '1401050',
    name: 'Simpang Pulau Beralo',
  },
  {
    id: '1401051001',
    districtId: '1401051',
    name: 'Pembatang',
  },
  {
    id: '1401051002',
    districtId: '1401051',
    name: 'Padang Kunik',
  },
  {
    id: '1401051003',
    districtId: '1401051',
    name: 'Padang Tanggung',
  },
  {
    id: '1401051004',
    districtId: '1401051',
    name: 'Teluk Pauh',
  },
  {
    id: '1401051005',
    districtId: '1401051',
    name: 'Tanah Bekali',
  },
  {
    id: '1401051006',
    districtId: '1401051',
    name: 'Pulau Deras',
  },
  {
    id: '1401051007',
    districtId: '1401051',
    name: 'Pulau Kumpai',
  },
  {
    id: '1401051008',
    districtId: '1401051',
    name: 'Pulau Tengah',
  },
  {
    id: '1401051009',
    districtId: '1401051',
    name: 'Koto Pangean',
  },
  {
    id: '1401051010',
    districtId: '1401051',
    name: 'Sukaping',
  },
  {
    id: '1401051011',
    districtId: '1401051',
    name: 'Pulau Rengas',
  },
  {
    id: '1401051012',
    districtId: '1401051',
    name: 'Pauh Angit',
  },
  {
    id: '1401051013',
    districtId: '1401051',
    name: 'Rawang Binjai',
  },
  {
    id: '1401051014',
    districtId: '1401051',
    name: 'Pasar Baru Pangean',
  },
  {
    id: '1401051015',
    districtId: '1401051',
    name: 'Pauh Angit Hulu',
  },
  {
    id: '1401051016',
    districtId: '1401051',
    name: 'Sako',
  },
  {
    id: '1401051017',
    districtId: '1401051',
    name: 'Sungai Langsat',
  },
  {
    id: '1401052001',
    districtId: '1401052',
    name: 'Sikijang',
  },
  {
    id: '1401052002',
    districtId: '1401052',
    name: 'Teratak Rendah',
  },
  {
    id: '1401052003',
    districtId: '1401052',
    name: 'Perhentian Luas',
  },
  {
    id: '1401052004',
    districtId: '1401052',
    name: 'Logas',
  },
  {
    id: '1401052005',
    districtId: '1401052',
    name: 'Sungai Rambai',
  },
  {
    id: '1401052006',
    districtId: '1401052',
    name: 'Rambahan',
  },
  {
    id: '1401052007',
    districtId: '1401052',
    name: 'Lubuk Kebun',
  },
  {
    id: '1401052008',
    districtId: '1401052',
    name: 'Situgal',
  },
  {
    id: '1401052009',
    districtId: '1401052',
    name: 'Hulu Teso',
  },
  {
    id: '1401052010',
    districtId: '1401052',
    name: 'Sukaraja',
  },
  {
    id: '1401052011',
    districtId: '1401052',
    name: 'Sako Margasari',
  },
  {
    id: '1401052012',
    districtId: '1401052',
    name: 'Giri Sako',
  },
  {
    id: '1401052013',
    districtId: '1401052',
    name: 'Kuantan Sako',
  },
  {
    id: '1401052014',
    districtId: '1401052',
    name: 'Sidodadi',
  },
  {
    id: '1401052015',
    districtId: '1401052',
    name: 'Bumi Mulya',
  },
  {
    id: '1401053001',
    districtId: '1401053',
    name: 'Tanjung Pisang',
  },
  {
    id: '1401053002',
    districtId: '1401053',
    name: 'Pengalian',
  },
  {
    id: '1401053003',
    districtId: '1401053',
    name: 'Kasang Limau Sundai',
  },
  {
    id: '1401053004',
    districtId: '1401053',
    name: 'Teratak Jering',
  },
  {
    id: '1401053005',
    districtId: '1401053',
    name: 'Koto Rajo',
  },
  {
    id: '1401053006',
    districtId: '1401053',
    name: 'Danau',
  },
  {
    id: '1401053007',
    districtId: '1401053',
    name: 'Lumbok',
  },
  {
    id: '1401053008',
    districtId: '1401053',
    name: 'Pelukahan',
  },
  {
    id: '1401053009',
    districtId: '1401053',
    name: 'Pulau Baru',
  },
  {
    id: '1401053010',
    districtId: '1401053',
    name: 'Tanjung',
  },
  {
    id: '1401053011',
    districtId: '1401053',
    name: 'Sungai Serik',
  },
  {
    id: '1401053012',
    districtId: '1401053',
    name: 'Rawang Oguang',
  },
  {
    id: '1401053013',
    districtId: '1401053',
    name: 'Pulau Kulur',
  },
  {
    id: '1401053014',
    districtId: '1401053',
    name: 'Pulau Beralo',
  },
  {
    id: '1401060003',
    districtId: '1401060',
    name: 'Sikakak',
  },
  {
    id: '1401060004',
    districtId: '1401060',
    name: 'Pulau Jambu',
  },
  {
    id: '1401060005',
    districtId: '1401060',
    name: 'Pulau Bayur',
  },
  {
    id: '1401060006',
    districtId: '1401060',
    name: 'Pulau Panjang Cerenti',
  },
  {
    id: '1401060007',
    districtId: '1401060',
    name: 'Teluk Pauh',
  },
  {
    id: '1401060008',
    districtId: '1401060',
    name: 'Pesikaian',
  },
  {
    id: '1401060009',
    districtId: '1401060',
    name: 'Koto Cerenti',
  },
  {
    id: '1401060010',
    districtId: '1401060',
    name: 'Koto Peraku',
  },
  {
    id: '1401060011',
    districtId: '1401060',
    name: 'Pasar Cerenti',
  },
  {
    id: '1401060012',
    districtId: '1401060',
    name: 'Kampung Baru',
  },
  {
    id: '1401060013',
    districtId: '1401060',
    name: 'Kompe Berangin',
  },
  {
    id: '1401060014',
    districtId: '1401060',
    name: 'Tanjung Medan',
  },
  {
    id: '1401060015',
    districtId: '1401060',
    name: 'Kampung Baru Timur',
  },
  {
    id: '1401061001',
    districtId: '1401061',
    name: 'Pulau Panjang Hulu',
  },
  {
    id: '1401061002',
    districtId: '1401061',
    name: 'Pulau  Panjang Hilir',
  },
  {
    id: '1401061003',
    districtId: '1401061',
    name: 'Bedeng Sikuran',
  },
  {
    id: '1401061004',
    districtId: '1401061',
    name: 'Banjar Nantigo',
  },
  {
    id: '1401061005',
    districtId: '1401061',
    name: 'Pasar Inuman',
  },
  {
    id: '1401061006',
    districtId: '1401061',
    name: 'Pulau Sipan',
  },
  {
    id: '1401061007',
    districtId: '1401061',
    name: 'Pulau Busuk',
  },
  {
    id: '1401061008',
    districtId: '1401061',
    name: 'Koto Inuman',
  },
  {
    id: '1401061009',
    districtId: '1401061',
    name: 'Sigaruntang',
  },
  {
    id: '1401061010',
    districtId: '1401061',
    name: 'Pulau Busuk Jaya',
  },
  {
    id: '1401061011',
    districtId: '1401061',
    name: 'Seberang Pulau Busuk',
  },
  {
    id: '1401061012',
    districtId: '1401061',
    name: 'Ketaping Jaya',
  },
  {
    id: '1401061013',
    districtId: '1401061',
    name: 'Lebuh Lurus',
  },
  {
    id: '1401061014',
    districtId: '1401061',
    name: 'Kampung Baru Koto',
  },
  {
    id: '1402010006',
    districtId: '1402010',
    name: 'Semelinang Tebing',
  },
  {
    id: '1402010007',
    districtId: '1402010',
    name: 'Pauh Ranap',
  },
  {
    id: '1402010010',
    districtId: '1402010',
    name: 'Baturijal Hulu',
  },
  {
    id: '1402010011',
    districtId: '1402010',
    name: 'Baturijal Hilir',
  },
  {
    id: '1402010012',
    districtId: '1402010',
    name: 'Peranap',
  },
  {
    id: '1402010013',
    districtId: '1402010',
    name: 'Gumanti',
  },
  {
    id: '1402010014',
    districtId: '1402010',
    name: 'Semelinang Darat',
  },
  {
    id: '1402010015',
    districtId: '1402010',
    name: 'Pandan Wangi',
  },
  {
    id: '1402010016',
    districtId: '1402010',
    name: 'Serai Wangi',
  },
  {
    id: '1402010017',
    districtId: '1402010',
    name: 'Katipo Pura',
  },
  {
    id: '1402010018',
    districtId: '1402010',
    name: 'Setako Raya',
  },
  {
    id: '1402010019',
    districtId: '1402010',
    name: 'Baturijal Barat',
  },
  {
    id: '1402011001',
    districtId: '1402011',
    name: 'Punti Kayu',
  },
  {
    id: '1402011002',
    districtId: '1402011',
    name: 'Pematang',
  },
  {
    id: '1402011003',
    districtId: '1402011',
    name: 'Pesajian',
  },
  {
    id: '1402011004',
    districtId: '1402011',
    name: 'Selunak',
  },
  {
    id: '1402011005',
    districtId: '1402011',
    name: 'Pematang Benteng',
  },
  {
    id: '1402011006',
    districtId: '1402011',
    name: 'Suka Maju',
  },
  {
    id: '1402011007',
    districtId: '1402011',
    name: 'Sencano Jaya',
  },
  {
    id: '1402011008',
    districtId: '1402011',
    name: 'Sungai Aur',
  },
  {
    id: '1402011009',
    districtId: '1402011',
    name: 'Peladangan',
  },
  {
    id: '1402011010',
    districtId: '1402011',
    name: 'Koto Tuo',
  },
  {
    id: '1402020026',
    districtId: '1402020',
    name: 'Bukit Meranti',
  },
  {
    id: '1402020027',
    districtId: '1402020',
    name: 'Paya Rumbai',
  },
  {
    id: '1402020028',
    districtId: '1402020',
    name: 'Kelesa',
  },
  {
    id: '1402020030',
    districtId: '1402020',
    name: 'Beligan',
  },
  {
    id: '1402020031',
    districtId: '1402020',
    name: 'Seresam',
  },
  {
    id: '1402020032',
    districtId: '1402020',
    name: 'Petala Bumi',
  },
  {
    id: '1402020033',
    districtId: '1402020',
    name: 'Titian Resak',
  },
  {
    id: '1402020034',
    districtId: '1402020',
    name: 'Sibabat',
  },
  {
    id: '1402020035',
    districtId: '1402020',
    name: 'Pangkalan Kasai',
  },
  {
    id: '1402020036',
    districtId: '1402020',
    name: 'Buluh Rampai',
  },
  {
    id: '1402020037',
    districtId: '1402020',
    name: 'Bandar Padang',
  },
  {
    id: '1402021001',
    districtId: '1402021',
    name: 'Talang Bersemi',
  },
  {
    id: '1402021002',
    districtId: '1402021',
    name: 'Talang Mulya',
  },
  {
    id: '1402021003',
    districtId: '1402021',
    name: 'Anak Talang',
  },
  {
    id: '1402021004',
    districtId: '1402021',
    name: 'Cenaku Kecil',
  },
  {
    id: '1402021005',
    districtId: '1402021',
    name: 'Alim',
  },
  {
    id: '1402021006',
    districtId: '1402021',
    name: 'Puntianai',
  },
  {
    id: '1402021007',
    districtId: '1402021',
    name: 'Pematang Manggis',
  },
  {
    id: '1402021008',
    districtId: '1402021',
    name: 'Kerubung Jaya',
  },
  {
    id: '1402021009',
    districtId: '1402021',
    name: 'Petaling Jaya',
  },
  {
    id: '1402021010',
    districtId: '1402021',
    name: 'Aur Cina',
  },
  {
    id: '1402021011',
    districtId: '1402021',
    name: 'Bukit Lingkar',
  },
  {
    id: '1402021012',
    districtId: '1402021',
    name: 'Bukit Lipai',
  },
  {
    id: '1402021014',
    districtId: '1402021',
    name: 'Kuala Gading',
  },
  {
    id: '1402021015',
    districtId: '1402021',
    name: 'Kuala Kilan',
  },
  {
    id: '1402021016',
    districtId: '1402021',
    name: 'Sipang',
  },
  {
    id: '1402021017',
    districtId: '1402021',
    name: 'Pejangki',
  },
  {
    id: '1402021018',
    districtId: '1402021',
    name: 'Lahai Kemuning',
  },
  {
    id: '1402021019',
    districtId: '1402021',
    name: 'Kepayang Sari',
  },
  {
    id: '1402021020',
    districtId: '1402021',
    name: 'Batu Papan',
  },
  {
    id: '1402021021',
    districtId: '1402021',
    name: 'Sanglap',
  },
  {
    id: '1402022001',
    districtId: '1402022',
    name: 'Siambul',
  },
  {
    id: '1402022002',
    districtId: '1402022',
    name: 'Rantau Langsat',
  },
  {
    id: '1402022003',
    districtId: '1402022',
    name: 'Sungai Akar',
  },
  {
    id: '1402022004',
    districtId: '1402022',
    name: 'Usul',
  },
  {
    id: '1402022005',
    districtId: '1402022',
    name: 'Seberida',
  },
  {
    id: '1402022006',
    districtId: '1402022',
    name: 'Talang Lakat',
  },
  {
    id: '1402022007',
    districtId: '1402022',
    name: 'Belimbing',
  },
  {
    id: '1402022008',
    districtId: '1402022',
    name: 'Ringin',
  },
  {
    id: '1402022009',
    districtId: '1402022',
    name: 'Panyaguan',
  },
  {
    id: '1402022010',
    districtId: '1402022',
    name: 'Danau Rambai',
  },
  {
    id: '1402030015',
    districtId: '1402030',
    name: 'Pulau Sengkilo',
  },
  {
    id: '1402030016',
    districtId: '1402030',
    name: 'Kota Medan',
  },
  {
    id: '1402030017',
    districtId: '1402030',
    name: 'Polak Pisang',
  },
  {
    id: '1402030018',
    districtId: '1402030',
    name: 'Simpang Kota Medan',
  },
  {
    id: '1402030019',
    districtId: '1402030',
    name: 'Tanjung Beludu',
  },
  {
    id: '1402030020',
    districtId: '1402030',
    name: 'Pelangko',
  },
  {
    id: '1402030021',
    districtId: '1402030',
    name: 'Simpang Kelayang',
  },
  {
    id: '1402030022',
    districtId: '1402030',
    name: 'Teluk Sejuah',
  },
  {
    id: '1402030023',
    districtId: '1402030',
    name: 'Dusun Tua',
  },
  {
    id: '1402030024',
    districtId: '1402030',
    name: 'Bongkal Malang',
  },
  {
    id: '1402030025',
    districtId: '1402030',
    name: 'Sungai Banyak Ikan',
  },
  {
    id: '1402030026',
    districtId: '1402030',
    name: 'Sungai Pasir Putih',
  },
  {
    id: '1402030027',
    districtId: '1402030',
    name: 'Sungai Golang',
  },
  {
    id: '1402030028',
    districtId: '1402030',
    name: 'Sungai Kuning Benio',
  },
  {
    id: '1402030029',
    districtId: '1402030',
    name: 'Pasir Beringin',
  },
  {
    id: '1402030030',
    districtId: '1402030',
    name: 'Bukit Selanjut',
  },
  {
    id: '1402030031',
    districtId: '1402030',
    name: 'Dusun Tua Pelang',
  },
  {
    id: '1402031001',
    districtId: '1402031',
    name: 'Kota Baru',
  },
  {
    id: '1402031002',
    districtId: '1402031',
    name: 'Rimba Seminai',
  },
  {
    id: '1402031003',
    districtId: '1402031',
    name: 'Kuantan Tenang',
  },
  {
    id: '1402031004',
    districtId: '1402031',
    name: 'Kelayang',
  },
  {
    id: '1402031005',
    districtId: '1402031',
    name: 'Lubuk Sitarak',
  },
  {
    id: '1402031006',
    districtId: '1402031',
    name: 'Petonggan',
  },
  {
    id: '1402031007',
    districtId: '1402031',
    name: 'Batu Sawar',
  },
  {
    id: '1402031008',
    districtId: '1402031',
    name: 'Talang Sungai Parit',
  },
  {
    id: '1402031009',
    districtId: '1402031',
    name: 'Talang Selantai',
  },
  {
    id: '1402031010',
    districtId: '1402031',
    name: 'Talang Perigi',
  },
  {
    id: '1402031011',
    districtId: '1402031',
    name: 'Talang Gedabu',
  },
  {
    id: '1402031012',
    districtId: '1402031',
    name: 'Talang Sungai Limau',
  },
  {
    id: '1402031013',
    districtId: '1402031',
    name: 'Talang Durian Cacar',
  },
  {
    id: '1402031014',
    districtId: '1402031',
    name: 'Talang Tujuh Buah Tangga',
  },
  {
    id: '1402031015',
    districtId: '1402031',
    name: 'Bukit Indah',
  },
  {
    id: '1402031016',
    districtId: '1402031',
    name: 'Kampung Bunga',
  },
  {
    id: '1402031017',
    districtId: '1402031',
    name: 'Talang Pring Jaya',
  },
  {
    id: '1402031018',
    districtId: '1402031',
    name: 'Talang Sungai Ekok',
  },
  {
    id: '1402031019',
    districtId: '1402031',
    name: 'Talang Suka Maju',
  },
  {
    id: '1402040008',
    districtId: '1402040',
    name: 'Pasir Keranji',
  },
  {
    id: '1402040009',
    districtId: '1402040',
    name: 'Air Molek I',
  },
  {
    id: '1402040010',
    districtId: '1402040',
    name: 'Candirejo',
  },
  {
    id: '1402040011',
    districtId: '1402040',
    name: 'Air Molek II',
  },
  {
    id: '1402040012',
    districtId: '1402040',
    name: 'Lembah Dusun Gading',
  },
  {
    id: '1402040013',
    districtId: '1402040',
    name: 'Petalongan',
  },
  {
    id: '1402040018',
    districtId: '1402040',
    name: 'Kembang Harum',
  },
  {
    id: '1402040019',
    districtId: '1402040',
    name: 'Batu Gajah',
  },
  {
    id: '1402040020',
    districtId: '1402040',
    name: 'Jatirejo',
  },
  {
    id: '1402040021',
    districtId: '1402040',
    name: 'Serumpun Jaya',
  },
  {
    id: '1402040022',
    districtId: '1402040',
    name: 'Tanjung Gading',
  },
  {
    id: '1402040023',
    districtId: '1402040',
    name: 'Sekar Mawar',
  },
  {
    id: '1402040024',
    districtId: '1402040',
    name: 'Tanah Merah',
  },
  {
    id: '1402041001',
    districtId: '1402041',
    name: 'Japura',
  },
  {
    id: '1402041002',
    districtId: '1402041',
    name: 'Sidomulyo',
  },
  {
    id: '1402041003',
    districtId: '1402041',
    name: 'Pasir Ringgit',
  },
  {
    id: '1402041004',
    districtId: '1402041',
    name: 'Gudang Batu',
  },
  {
    id: '1402041005',
    districtId: '1402041',
    name: 'Sungai Sagu',
  },
  {
    id: '1402041006',
    districtId: '1402041',
    name: 'Lirik Area',
  },
  {
    id: '1402041007',
    districtId: '1402041',
    name: 'Rejosari',
  },
  {
    id: '1402041008',
    districtId: '1402041',
    name: 'Lambang Sari V',
  },
  {
    id: '1402041009',
    districtId: '1402041',
    name: 'Lambang Sari IV',
  },
  {
    id: '1402041010',
    districtId: '1402041',
    name: 'Lambang Sari I, II, III',
  },
  {
    id: '1402041011',
    districtId: '1402041',
    name: 'Wonosari',
  },
  {
    id: '1402041012',
    districtId: '1402041',
    name: 'Seko Lubuk Tigo',
  },
  {
    id: '1402041013',
    districtId: '1402041',
    name: 'Banjar Balam',
  },
  {
    id: '1402041014',
    districtId: '1402041',
    name: 'Redang Seko',
  },
  {
    id: '1402041015',
    districtId: '1402041',
    name: 'Sukajadi',
  },
  {
    id: '1402041016',
    districtId: '1402041',
    name: 'Mekar Sari',
  },
  {
    id: '1402041017',
    districtId: '1402041',
    name: 'Pasir Sialang Jaya',
  },
  {
    id: '1402042001',
    districtId: '1402042',
    name: 'Kelawat',
  },
  {
    id: '1402042002',
    districtId: '1402042',
    name: 'Perkebunan  Sungai Lala',
  },
  {
    id: '1402042003',
    districtId: '1402042',
    name: 'Kuala Lala',
  },
  {
    id: '1402042004',
    districtId: '1402042',
    name: 'Pasir Batu Mandi',
  },
  {
    id: '1402042005',
    districtId: '1402042',
    name: 'Pasir Selabau',
  },
  {
    id: '1402042006',
    districtId: '1402042',
    name: 'Pasir Bongkal',
  },
  {
    id: '1402042007',
    districtId: '1402042',
    name: 'Perkebunan Sungai Parit',
  },
  {
    id: '1402042008',
    districtId: '1402042',
    name: 'Morong',
  },
  {
    id: '1402042009',
    districtId: '1402042',
    name: 'Sungai Lala',
  },
  {
    id: '1402042010',
    districtId: '1402042',
    name: 'Pasir Kelampaian',
  },
  {
    id: '1402042011',
    districtId: '1402042',
    name: 'Tanjung Danau',
  },
  {
    id: '1402042012',
    districtId: '1402042',
    name: 'Sungai Air Putih',
  },
  {
    id: '1402043001',
    districtId: '1402043',
    name: 'Sei Beras-Beras',
  },
  {
    id: '1402043002',
    districtId: '1402043',
    name: 'Sei Beberas Hilir',
  },
  {
    id: '1402043003',
    districtId: '1402043',
    name: 'Pondok Gelugur',
  },
  {
    id: '1402043004',
    districtId: '1402043',
    name: 'Rimpian',
  },
  {
    id: '1402043005',
    districtId: '1402043',
    name: 'Lubuk Batu Tinggal',
  },
  {
    id: '1402043027',
    districtId: '1402043',
    name: 'Kulim Jaya',
  },
  {
    id: '1402043029',
    districtId: '1402043',
    name: 'Tasik Juang',
  },
  {
    id: '1402043030',
    districtId: '1402043',
    name: 'Pontian Mekar',
  },
  {
    id: '1402043031',
    districtId: '1402043',
    name: 'Air Putih',
  },
  {
    id: '1402050001',
    districtId: '1402050',
    name: 'Barangan',
  },
  {
    id: '1402050002',
    districtId: '1402050',
    name: 'Alang Kepayang',
  },
  {
    id: '1402050003',
    districtId: '1402050',
    name: 'Danau Baru',
  },
  {
    id: '1402050004',
    districtId: '1402050',
    name: 'Redang',
  },
  {
    id: '1402050005',
    districtId: '1402050',
    name: 'Kota Lama',
  },
  {
    id: '1402050006',
    districtId: '1402050',
    name: 'Sungai Dawu',
  },
  {
    id: '1402050007',
    districtId: '1402050',
    name: 'Pematang Jaya',
  },
  {
    id: '1402050008',
    districtId: '1402050',
    name: 'Bukit Petaling',
  },
  {
    id: '1402050009',
    districtId: '1402050',
    name: 'Tanah Datar',
  },
  {
    id: '1402050010',
    districtId: '1402050',
    name: 'Talang Jerinjing',
  },
  {
    id: '1402050011',
    districtId: '1402050',
    name: 'Pematang Reba',
  },
  {
    id: '1402050012',
    districtId: '1402050',
    name: 'Pekan Heran',
  },
  {
    id: '1402050013',
    districtId: '1402050',
    name: 'Rantau Bakung',
  },
  {
    id: '1402050014',
    districtId: '1402050',
    name: 'Sialang Dua Dahan',
  },
  {
    id: '1402050015',
    districtId: '1402050',
    name: 'Tani Makmur',
  },
  {
    id: '1402050016',
    districtId: '1402050',
    name: 'Sungai Baung',
  },
  {
    id: '1402050017',
    districtId: '1402050',
    name: 'Air Jernih',
  },
  {
    id: '1402050018',
    districtId: '1402050',
    name: 'Danau Tiga',
  },
  {
    id: '1402060001',
    districtId: '1402060',
    name: 'Sungai Guntung Tengah',
  },
  {
    id: '1402060002',
    districtId: '1402060',
    name: 'Sungai Guntung Hilir',
  },
  {
    id: '1402060003',
    districtId: '1402060',
    name: 'Kuantan Babu',
  },
  {
    id: '1402060004',
    districtId: '1402060',
    name: 'Kampung Dagang',
  },
  {
    id: '1402060005',
    districtId: '1402060',
    name: 'Kampung Pulau',
  },
  {
    id: '1402060006',
    districtId: '1402060',
    name: 'Kampung Besar Kota',
  },
  {
    id: '1402060007',
    districtId: '1402060',
    name: 'Pasar Kota',
  },
  {
    id: '1402060008',
    districtId: '1402060',
    name: 'Sekip Hulu',
  },
  {
    id: '1402060009',
    districtId: '1402060',
    name: 'Sekip Hilir',
  },
  {
    id: '1402060010',
    districtId: '1402060',
    name: 'Kampung Besar Seberang',
  },
  {
    id: '1402060011',
    districtId: '1402060',
    name: 'Rantau Mapesai',
  },
  {
    id: '1402060012',
    districtId: '1402060',
    name: 'Pasir Kemilu',
  },
  {
    id: '1402060013',
    districtId: '1402060',
    name: 'Sungai Beringin',
  },
  {
    id: '1402060014',
    districtId: '1402060',
    name: 'Pulau Gajah',
  },
  {
    id: '1402060015',
    districtId: '1402060',
    name: 'Sungai Raya',
  },
  {
    id: '1402060016',
    districtId: '1402060',
    name: 'Rawa Bangun',
  },
  {
    id: '1402061001',
    districtId: '1402061',
    name: 'Kuala Cenaku',
  },
  {
    id: '1402061002',
    districtId: '1402061',
    name: 'Tambak',
  },
  {
    id: '1402061003',
    districtId: '1402061',
    name: 'Pulau Gelang',
  },
  {
    id: '1402061004',
    districtId: '1402061',
    name: 'Kuala Mulya',
  },
  {
    id: '1402061005',
    districtId: '1402061',
    name: 'Tanjung Sari',
  },
  {
    id: '1402061006',
    districtId: '1402061',
    name: 'Rawa Sekip',
  },
  {
    id: '1402061007',
    districtId: '1402061',
    name: 'Rawa Asri',
  },
  {
    id: '1402061008',
    districtId: '1402061',
    name: "Pulau Jum'At",
  },
  {
    id: '1402061009',
    districtId: '1402061',
    name: 'Suka Jadi',
  },
  {
    id: '1402061010',
    districtId: '1402061',
    name: 'Teluk Sungkai',
  },
  {
    id: '1403010001',
    districtId: '1403010',
    name: 'Kotabaru Reteh',
  },
  {
    id: '1403010002',
    districtId: '1403010',
    name: 'Seberang Pebenaan',
  },
  {
    id: '1403010003',
    districtId: '1403010',
    name: 'Pebenaan',
  },
  {
    id: '1403010004',
    districtId: '1403010',
    name: 'Nusantara Jaya',
  },
  {
    id: '1403010005',
    districtId: '1403010',
    name: 'Kembang Mekar Sari',
  },
  {
    id: '1403010006',
    districtId: '1403010',
    name: 'Kotabaru Seberida',
  },
  {
    id: '1403010007',
    districtId: '1403010',
    name: 'Pasar Kembang',
  },
  {
    id: '1403010008',
    districtId: '1403010',
    name: 'Kuala Keritang',
  },
  {
    id: '1403010009',
    districtId: '1403010',
    name: 'Kuala Lemang',
  },
  {
    id: '1403010010',
    districtId: '1403010',
    name: 'Teluk Kelasa',
  },
  {
    id: '1403010011',
    districtId: '1403010',
    name: 'Pengalihan',
  },
  {
    id: '1403010012',
    districtId: '1403010',
    name: 'Pancur',
  },
  {
    id: '1403010013',
    districtId: '1403010',
    name: 'Sencalang',
  },
  {
    id: '1403010014',
    districtId: '1403010',
    name: 'Kayu Raja',
  },
  {
    id: '1403010015',
    districtId: '1403010',
    name: 'Lintas Utara',
  },
  {
    id: '1403010016',
    districtId: '1403010',
    name: 'Nyiur Permai',
  },
  {
    id: '1403010017',
    districtId: '1403010',
    name: 'Petalongan',
  },
  {
    id: '1403011001',
    districtId: '1403011',
    name: 'Selensen',
  },
  {
    id: '1403011002',
    districtId: '1403011',
    name: 'Batu Ampar',
  },
  {
    id: '1403011003',
    districtId: '1403011',
    name: 'Keritang',
  },
  {
    id: '1403011004',
    districtId: '1403011',
    name: 'Air Balui',
  },
  {
    id: '1403011005',
    districtId: '1403011',
    name: 'Tuk Jimun',
  },
  {
    id: '1403011006',
    districtId: '1403011',
    name: 'Kemuning Muda',
  },
  {
    id: '1403011007',
    districtId: '1403011',
    name: 'Kemuning Tua',
  },
  {
    id: '1403011008',
    districtId: '1403011',
    name: 'Sekara',
  },
  {
    id: '1403011009',
    districtId: '1403011',
    name: 'Limau Manis',
  },
  {
    id: '1403011010',
    districtId: '1403011',
    name: 'Talang Jangkang',
  },
  {
    id: '1403011011',
    districtId: '1403011',
    name: 'Lubuk Besar',
  },
  {
    id: '1403011012',
    districtId: '1403011',
    name: 'Sekayan',
  },
  {
    id: '1403020001',
    districtId: '1403020',
    name: 'Sanglar',
  },
  {
    id: '1403020002',
    districtId: '1403020',
    name: 'Pulau Kecil',
  },
  {
    id: '1403020003',
    districtId: '1403020',
    name: 'Pulau Kijang',
  },
  {
    id: '1403020004',
    districtId: '1403020',
    name: 'Sungai Undan',
  },
  {
    id: '1403020005',
    districtId: '1403020',
    name: 'Sungai Terab',
  },
  {
    id: '1403020010',
    districtId: '1403020',
    name: 'Seberang Sanglar',
  },
  {
    id: '1403020011',
    districtId: '1403020',
    name: 'Mekar Sari',
  },
  {
    id: '1403020012',
    districtId: '1403020',
    name: 'Seberang Pulau Kijang',
  },
  {
    id: '1403020013',
    districtId: '1403020',
    name: 'Sungai Asam',
  },
  {
    id: '1403020014',
    districtId: '1403020',
    name: 'Pulau Ruku',
  },
  {
    id: '1403020015',
    districtId: '1403020',
    name: 'Metro',
  },
  {
    id: '1403020016',
    districtId: '1403020',
    name: 'Madani',
  },
  {
    id: '1403020017',
    districtId: '1403020',
    name: 'Tanjung Labuh',
  },
  {
    id: '1403020018',
    districtId: '1403020',
    name: 'Sungai Mahang',
  },
  {
    id: '1403021001',
    districtId: '1403021',
    name: 'Kuala Patah Parang',
  },
  {
    id: '1403021002',
    districtId: '1403021',
    name: 'Kuala Sungai Batang',
  },
  {
    id: '1403021003',
    districtId: '1403021',
    name: 'Pasenggerahan',
  },
  {
    id: '1403021004',
    districtId: '1403021',
    name: 'Benteng',
  },
  {
    id: '1403021005',
    districtId: '1403021',
    name: 'Benteng Barat',
  },
  {
    id: '1403021006',
    districtId: '1403021',
    name: 'Benteng Utara',
  },
  {
    id: '1403021007',
    districtId: '1403021',
    name: 'Pandan Sari',
  },
  {
    id: '1403021008',
    districtId: '1403021',
    name: 'Mugo Mulyo',
  },
  {
    id: '1403030001',
    districtId: '1403030',
    name: 'Bagan Jaya',
  },
  {
    id: '1403030002',
    districtId: '1403030',
    name: 'Suhada',
  },
  {
    id: '1403030003',
    districtId: '1403030',
    name: 'Sungai Rukam',
  },
  {
    id: '1403030004',
    districtId: '1403030',
    name: 'Pengalihan',
  },
  {
    id: '1403030005',
    districtId: '1403030',
    name: 'Sungai Ambat',
  },
  {
    id: '1403030006',
    districtId: '1403030',
    name: 'Pusaran',
  },
  {
    id: '1403030007',
    districtId: '1403030',
    name: 'Enok',
  },
  {
    id: '1403030008',
    districtId: '1403030',
    name: 'Teluk Medan',
  },
  {
    id: '1403030009',
    districtId: '1403030',
    name: 'Rantau Panjang',
  },
  {
    id: '1403030010',
    districtId: '1403030',
    name: 'Simpang Tiga',
  },
  {
    id: '1403030011',
    districtId: '1403030',
    name: 'Jaya Bhakti',
  },
  {
    id: '1403030012',
    districtId: '1403030',
    name: 'Sungai Lokan',
  },
  {
    id: '1403030013',
    districtId: '1403030',
    name: 'Pantai Seberang Makmur',
  },
  {
    id: '1403030014',
    districtId: '1403030',
    name: 'Simpang Tiga Daratan',
  },
  {
    id: '1403040001',
    districtId: '1403040',
    name: 'Sungai Nyiur',
  },
  {
    id: '1403040002',
    districtId: '1403040',
    name: 'Selat Nama',
  },
  {
    id: '1403040003',
    districtId: '1403040',
    name: 'Kuala Enok',
  },
  {
    id: '1403040004',
    districtId: '1403040',
    name: 'Sungai Laut',
  },
  {
    id: '1403040005',
    districtId: '1403040',
    name: 'Tanjung Pasir',
  },
  {
    id: '1403040006',
    districtId: '1403040',
    name: 'Tanah Merah',
  },
  {
    id: '1403040007',
    districtId: '1403040',
    name: 'Tanjung Baru',
  },
  {
    id: '1403040008',
    districtId: '1403040',
    name: 'Tekulai Hulu',
  },
  {
    id: '1403040009',
    districtId: '1403040',
    name: 'Tekulai Hilir',
  },
  {
    id: '1403040010',
    districtId: '1403040',
    name: 'Tekulai Bugis',
  },
  {
    id: '1403050001',
    districtId: '1403050',
    name: 'Tanjung Lajau',
  },
  {
    id: '1403050002',
    districtId: '1403050',
    name: 'Sungai Buluh',
  },
  {
    id: '1403050003',
    districtId: '1403050',
    name: 'Sungai Bela',
  },
  {
    id: '1403050008',
    districtId: '1403050',
    name: 'Perigi Raja',
  },
  {
    id: '1403050009',
    districtId: '1403050',
    name: 'Sapat',
  },
  {
    id: '1403050010',
    districtId: '1403050',
    name: 'Teluk Dalam',
  },
  {
    id: '1403050011',
    districtId: '1403050',
    name: 'Sungai Piyai',
  },
  {
    id: '1403050012',
    districtId: '1403050',
    name: 'Tanjung Melayu',
  },
  {
    id: '1403051001',
    districtId: '1403051',
    name: 'Concong Luar',
  },
  {
    id: '1403051002',
    districtId: '1403051',
    name: 'Kampung Baru',
  },
  {
    id: '1403051003',
    districtId: '1403051',
    name: 'Concong Tengah',
  },
  {
    id: '1403051004',
    districtId: '1403051',
    name: 'Concong Dalam',
  },
  {
    id: '1403051005',
    districtId: '1403051',
    name: 'Sungai Berapit',
  },
  {
    id: '1403051006',
    districtId: '1403051',
    name: 'Panglima Raja',
  },
  {
    id: '1403060001',
    districtId: '1403060',
    name: 'Seberang Tembilahan',
  },
  {
    id: '1403060002',
    districtId: '1403060',
    name: 'Sungai Perak',
  },
  {
    id: '1403060003',
    districtId: '1403060',
    name: 'Tembilahan Hilir',
  },
  {
    id: '1403060004',
    districtId: '1403060',
    name: 'Tembilahan Kota',
  },
  {
    id: '1403060005',
    districtId: '1403060',
    name: 'Pekan Arba',
  },
  {
    id: '1403060006',
    districtId: '1403060',
    name: 'Sungai Beringin',
  },
  {
    id: '1403060007',
    districtId: '1403060',
    name: 'Seberang Tembilahan Barat',
  },
  {
    id: '1403060008',
    districtId: '1403060',
    name: 'Seberang Tembilahan Selatan',
  },
  {
    id: '1403061001',
    districtId: '1403061',
    name: 'Pulau Palas',
  },
  {
    id: '1403061002',
    districtId: '1403061',
    name: 'Tembilahan Hulu',
  },
  {
    id: '1403061003',
    districtId: '1403061',
    name: 'Sialang Panjang',
  },
  {
    id: '1403061004',
    districtId: '1403061',
    name: 'Pekan Kamis',
  },
  {
    id: '1403061005',
    districtId: '1403061',
    name: 'Sungai Intan',
  },
  {
    id: '1403061006',
    districtId: '1403061',
    name: 'Tembilahan Barat',
  },
  {
    id: '1403070009',
    districtId: '1403070',
    name: 'Tempuling',
  },
  {
    id: '1403070010',
    districtId: '1403070',
    name: 'Sungai Salak',
  },
  {
    id: '1403070011',
    districtId: '1403070',
    name: 'Teluk Jira',
  },
  {
    id: '1403070012',
    districtId: '1403070',
    name: 'Mumpa',
  },
  {
    id: '1403070013',
    districtId: '1403070',
    name: 'Teluk Kiambang',
  },
  {
    id: '1403070014',
    districtId: '1403070',
    name: 'Karya Tunas Jaya',
  },
  {
    id: '1403070015',
    districtId: '1403070',
    name: 'Harapan Jaya',
  },
  {
    id: '1403070016',
    districtId: '1403070',
    name: 'Tanjung Pidada',
  },
  {
    id: '1403070017',
    districtId: '1403070',
    name: 'Pangkalan Tujuh',
  },
  {
    id: '1403071001',
    districtId: '1403071',
    name: 'Bayas Jaya',
  },
  {
    id: '1403071002',
    districtId: '1403071',
    name: 'Pekan Tua',
  },
  {
    id: '1403071003',
    districtId: '1403071',
    name: 'Kempas Jaya',
  },
  {
    id: '1403071004',
    districtId: '1403071',
    name: 'Sungai Ara',
  },
  {
    id: '1403071005',
    districtId: '1403071',
    name: 'Harapan Tani',
  },
  {
    id: '1403071006',
    districtId: '1403071',
    name: 'Karya Tani',
  },
  {
    id: '1403071007',
    districtId: '1403071',
    name: 'Rumbai Jaya',
  },
  {
    id: '1403071008',
    districtId: '1403071',
    name: 'Sungai Gantang',
  },
  {
    id: '1403071009',
    districtId: '1403071',
    name: 'Sungai Rabit',
  },
  {
    id: '1403071010',
    districtId: '1403071',
    name: 'Kerta Jaya',
  },
  {
    id: '1403071011',
    districtId: '1403071',
    name: 'Kulim Jaya',
  },
  {
    id: '1403071012',
    districtId: '1403071',
    name: 'Danau Pulai Indah',
  },
  {
    id: '1403080001',
    districtId: '1403080',
    name: 'Kuala Sebatu',
  },
  {
    id: '1403080002',
    districtId: '1403080',
    name: 'Sungai Raya',
  },
  {
    id: '1403080003',
    districtId: '1403080',
    name: 'Sungai Junjangan',
  },
  {
    id: '1403080004',
    districtId: '1403080',
    name: 'Sungai Luar',
  },
  {
    id: '1403080005',
    districtId: '1403080',
    name: 'Sungai Dusun',
  },
  {
    id: '1403080006',
    districtId: '1403080',
    name: 'Sungai Piring',
  },
  {
    id: '1403080007',
    districtId: '1403080',
    name: 'Tanjung Siantar',
  },
  {
    id: '1403080008',
    districtId: '1403080',
    name: 'Sungai Rawa',
  },
  {
    id: '1403080009',
    districtId: '1403080',
    name: 'Sialang Jaya',
  },
  {
    id: '1403080010',
    districtId: '1403080',
    name: 'Gemilang Jaya',
  },
  {
    id: '1403080011',
    districtId: '1403080',
    name: 'Tasik Raya',
  },
  {
    id: '1403080012',
    districtId: '1403080',
    name: 'Pasir Emas',
  },
  {
    id: '1403080013',
    districtId: '1403080',
    name: 'Simpang Jaya',
  },
  {
    id: '1403090001',
    districtId: '1403090',
    name: 'Rambaian',
  },
  {
    id: '1403090002',
    districtId: '1403090',
    name: 'Sungai Empat',
  },
  {
    id: '1403090003',
    districtId: '1403090',
    name: 'Teluk Tuasan',
  },
  {
    id: '1403090004',
    districtId: '1403090',
    name: 'Sungai Iliran',
  },
  {
    id: '1403090005',
    districtId: '1403090',
    name: 'Teluk Sungka',
  },
  {
    id: '1403090006',
    districtId: '1403090',
    name: 'Teluk Pantaian',
  },
  {
    id: '1403090007',
    districtId: '1403090',
    name: 'Teluk Pinang',
  },
  {
    id: '1403090008',
    districtId: '1403090',
    name: 'Kuala Gaung',
  },
  {
    id: '1403090009',
    districtId: '1403090',
    name: 'Kelumpang',
  },
  {
    id: '1403090010',
    districtId: '1403090',
    name: 'Idaman',
  },
  {
    id: '1403090011',
    districtId: '1403090',
    name: 'Harapan Makmur',
  },
  {
    id: '1403090012',
    districtId: '1403090',
    name: 'Tanjung Harapan',
  },
  {
    id: '1403100001',
    districtId: '1403100',
    name: 'Teluk Kabung',
  },
  {
    id: '1403100002',
    districtId: '1403100',
    name: 'Simpang Gaung',
  },
  {
    id: '1403100003',
    districtId: '1403100',
    name: 'Pungkat',
  },
  {
    id: '1403100004',
    districtId: '1403100',
    name: 'Belantaraya',
  },
  {
    id: '1403100005',
    districtId: '1403100',
    name: 'Jerambang',
  },
  {
    id: '1403100006',
    districtId: '1403100',
    name: 'Sungai Baru',
  },
  {
    id: '1403100007',
    districtId: '1403100',
    name: 'Lahang Baru',
  },
  {
    id: '1403100008',
    districtId: '1403100',
    name: 'Kuala Lahang',
  },
  {
    id: '1403100009',
    districtId: '1403100',
    name: 'Lahang Tengah',
  },
  {
    id: '1403100010',
    districtId: '1403100',
    name: 'Lahang Hulu',
  },
  {
    id: '1403100011',
    districtId: '1403100',
    name: 'Terusan Kempas',
  },
  {
    id: '1403100012',
    districtId: '1403100',
    name: 'Gembira',
  },
  {
    id: '1403100013',
    districtId: '1403100',
    name: 'Semambu Kuning',
  },
  {
    id: '1403100014',
    districtId: '1403100',
    name: 'Pintasan',
  },
  {
    id: '1403100015',
    districtId: '1403100',
    name: 'Soren',
  },
  {
    id: '1403100016',
    districtId: '1403100',
    name: 'Teluk Merbau',
  },
  {
    id: '1403110001',
    districtId: '1403110',
    name: 'Pulau Cawan',
  },
  {
    id: '1403110002',
    districtId: '1403110',
    name: 'Batang Tumu',
  },
  {
    id: '1403110003',
    districtId: '1403110',
    name: 'Bakau Aceh',
  },
  {
    id: '1403110004',
    districtId: '1403110',
    name: 'Pelanduk',
  },
  {
    id: '1403110005',
    districtId: '1403110',
    name: 'Igal',
  },
  {
    id: '1403110006',
    districtId: '1403110',
    name: 'Khairiah Mandah',
  },
  {
    id: '1403110007',
    districtId: '1403110',
    name: 'Bente',
  },
  {
    id: '1403110008',
    districtId: '1403110',
    name: 'Belaras',
  },
  {
    id: '1403110009',
    districtId: '1403110',
    name: 'Bekawan',
  },
  {
    id: '1403110010',
    districtId: '1403110',
    name: 'Bantayan',
  },
  {
    id: '1403110011',
    districtId: '1403110',
    name: 'Bolak Raya',
  },
  {
    id: '1403110012',
    districtId: '1403110',
    name: 'Batang Sari',
  },
  {
    id: '1403110013',
    districtId: '1403110',
    name: 'Sepakat Jaya',
  },
  {
    id: '1403110014',
    districtId: '1403110',
    name: 'Surayya Mandiri',
  },
  {
    id: '1403110015',
    districtId: '1403110',
    name: 'Cahaya Baru',
  },
  {
    id: '1403110016',
    districtId: '1403110',
    name: 'Belaras Barat',
  },
  {
    id: '1403110017',
    districtId: '1403110',
    name: 'Bidari Tanjung Datuk',
  },
  {
    id: '1403120001',
    districtId: '1403120',
    name: 'Sungai Simbar',
  },
  {
    id: '1403120002',
    districtId: '1403120',
    name: 'Kuala Selat',
  },
  {
    id: '1403120003',
    districtId: '1403120',
    name: 'Penjuru',
  },
  {
    id: '1403120004',
    districtId: '1403120',
    name: 'Tagaraja',
  },
  {
    id: '1403120005',
    districtId: '1403120',
    name: 'Sari Mulya',
  },
  {
    id: '1403120006',
    districtId: '1403120',
    name: 'Air Tawar',
  },
  {
    id: '1403120007',
    districtId: '1403120',
    name: 'Tanjung Raja',
  },
  {
    id: '1403120008',
    districtId: '1403120',
    name: 'Sungai Teritip',
  },
  {
    id: '1403120009',
    districtId: '1403120',
    name: 'Makmur Jaya',
  },
  {
    id: '1403120010',
    districtId: '1403120',
    name: 'Amal Bakti',
  },
  {
    id: '1403120011',
    districtId: '1403120',
    name: 'Bandar Sri Gemilang',
  },
  {
    id: '1403121001',
    districtId: '1403121',
    name: 'Tanjung Simpang',
  },
  {
    id: '1403121002',
    districtId: '1403121',
    name: 'Simpang Kateman',
  },
  {
    id: '1403121003',
    districtId: '1403121',
    name: 'Pelangiran',
  },
  {
    id: '1403121004',
    districtId: '1403121',
    name: 'Rotan Semelur',
  },
  {
    id: '1403121005',
    districtId: '1403121',
    name: 'Baung Rejo Jaya',
  },
  {
    id: '1403121006',
    districtId: '1403121',
    name: 'Tagagiri Tama Jaya',
  },
  {
    id: '1403121007',
    districtId: '1403121',
    name: 'Pinang Jaya',
  },
  {
    id: '1403121008',
    districtId: '1403121',
    name: 'Wonosari',
  },
  {
    id: '1403121009',
    districtId: '1403121',
    name: 'Tegal Rejo Jaya',
  },
  {
    id: '1403121010',
    districtId: '1403121',
    name: 'Intan Mulya Jaya',
  },
  {
    id: '1403121011',
    districtId: '1403121',
    name: 'Saka Palas Jaya',
  },
  {
    id: '1403121012',
    districtId: '1403121',
    name: 'Catur Karya',
  },
  {
    id: '1403121013',
    districtId: '1403121',
    name: 'Bagan Jaya',
  },
  {
    id: '1403121014',
    districtId: '1403121',
    name: 'Teluk Bunian',
  },
  {
    id: '1403121015',
    districtId: '1403121',
    name: 'Hidayah',
  },
  {
    id: '1403121016',
    districtId: '1403121',
    name: 'Terusan Beringin Jaya',
  },
  {
    id: '1403122001',
    districtId: '1403122',
    name: 'Griya Mukti Jaya',
  },
  {
    id: '1403122002',
    districtId: '1403122',
    name: 'Tunggal Rahayu Jaya',
  },
  {
    id: '1403122003',
    districtId: '1403122',
    name: 'Hibrida Mulya',
  },
  {
    id: '1403122004',
    districtId: '1403122',
    name: 'Beringin Mulya',
  },
  {
    id: '1403122005',
    districtId: '1403122',
    name: 'Indra Sari Jaya',
  },
  {
    id: '1403122006',
    districtId: '1403122',
    name: 'Sumber Makmur Jaya',
  },
  {
    id: '1403122007',
    districtId: '1403122',
    name: 'Sumber Jaya',
  },
  {
    id: '1403122008',
    districtId: '1403122',
    name: 'Hibrida Jaya',
  },
  {
    id: '1403122009',
    districtId: '1403122',
    name: 'Sumber Sari Jaya',
  },
  {
    id: '1403122010',
    districtId: '1403122',
    name: 'Kelapa Patih Jaya',
  },
  {
    id: '1403122011',
    districtId: '1403122',
    name: 'Sapta Mulya Jaya',
  },
  {
    id: '1403122012',
    districtId: '1403122',
    name: 'Gembaran',
  },
  {
    id: '1403122013',
    districtId: '1403122',
    name: 'Saka Rotan',
  },
  {
    id: '1403123001',
    districtId: '1403123',
    name: 'Pulau Burung',
  },
  {
    id: '1403123002',
    districtId: '1403123',
    name: 'Bangun Harjo Jaya',
  },
  {
    id: '1403123003',
    districtId: '1403123',
    name: 'Ringin Jaya',
  },
  {
    id: '1403123004',
    districtId: '1403123',
    name: 'Mayang Sari Jaya',
  },
  {
    id: '1403123005',
    districtId: '1403123',
    name: 'Bukit Sari Intan Jaya',
  },
  {
    id: '1403123006',
    districtId: '1403123',
    name: 'Manunggal Jaya',
  },
  {
    id: '1403123007',
    districtId: '1403123',
    name: 'Teluk Nibung',
  },
  {
    id: '1403123008',
    districtId: '1403123',
    name: 'Sungai Danai',
  },
  {
    id: '1403123009',
    districtId: '1403123',
    name: 'Sri Danai',
  },
  {
    id: '1403123010',
    districtId: '1403123',
    name: 'Sapta Jaya',
  },
  {
    id: '1403123011',
    districtId: '1403123',
    name: 'Keramat Jaya',
  },
  {
    id: '1403123012',
    districtId: '1403123',
    name: 'Suka Jaya',
  },
  {
    id: '1403123014',
    districtId: '1403123',
    name: 'Binangun Jaya',
  },
  {
    id: '1403123015',
    districtId: '1403123',
    name: 'Sukoharjo Jaya',
  },
  {
    id: '1404010001',
    districtId: '1404010',
    name: 'Segati',
  },
  {
    id: '1404010002',
    districtId: '1404010',
    name: 'Sotol',
  },
  {
    id: '1404010003',
    districtId: '1404010',
    name: 'Tambak',
  },
  {
    id: '1404010004',
    districtId: '1404010',
    name: 'Langkan',
  },
  {
    id: '1404010005',
    districtId: '1404010',
    name: 'Pangkalan Gondai',
  },
  {
    id: '1404010006',
    districtId: '1404010',
    name: 'Penarikan',
  },
  {
    id: '1404010007',
    districtId: '1404010',
    name: 'Langgam',
  },
  {
    id: '1404010008',
    districtId: '1404010',
    name: 'Padang Luas',
  },
  {
    id: '1404011001',
    districtId: '1404011',
    name: 'Rantau Baru',
  },
  {
    id: '1404011002',
    districtId: '1404011',
    name: 'Kuala Terusan',
  },
  {
    id: '1404011003',
    districtId: '1404011',
    name: 'Pangkalan Kerinci Kota',
  },
  {
    id: '1404011005',
    districtId: '1404011',
    name: 'Mekar Jaya',
  },
  {
    id: '1404011006',
    districtId: '1404011',
    name: 'Makmur',
  },
  {
    id: '1404011007',
    districtId: '1404011',
    name: 'Pangkalan Kerinci Barat',
  },
  {
    id: '1404011008',
    districtId: '1404011',
    name: 'Pangkalan Kerinci Timur',
  },
  {
    id: '1404012001',
    districtId: '1404012',
    name: 'Simpang Beringin',
  },
  {
    id: '1404012002',
    districtId: '1404012',
    name: 'Sekijang',
  },
  {
    id: '1404012003',
    districtId: '1404012',
    name: 'Lubuk Ogung',
  },
  {
    id: '1404012004',
    districtId: '1404012',
    name: 'Muda Setia',
  },
  {
    id: '1404012005',
    districtId: '1404012',
    name: 'Kiyap Jaya',
  },
  {
    id: '1404020019',
    districtId: '1404020',
    name: 'Tanjung Beringin',
  },
  {
    id: '1404020020',
    districtId: '1404020',
    name: 'Talau',
  },
  {
    id: '1404020021',
    districtId: '1404020',
    name: 'Kesuma',
  },
  {
    id: '1404020022',
    districtId: '1404020',
    name: 'Betung',
  },
  {
    id: '1404020023',
    districtId: '1404020',
    name: 'Sorek Satu',
  },
  {
    id: '1404020024',
    districtId: '1404020',
    name: 'Sorek Dua',
  },
  {
    id: '1404020025',
    districtId: '1404020',
    name: 'Dundangan',
  },
  {
    id: '1404020026',
    districtId: '1404020',
    name: 'Surya Indah',
  },
  {
    id: '1404020027',
    districtId: '1404020',
    name: 'Beringin Indah',
  },
  {
    id: '1404020028',
    districtId: '1404020',
    name: 'Sialang Indah',
  },
  {
    id: '1404020029',
    districtId: '1404020',
    name: 'Terantang Manuk',
  },
  {
    id: '1404020030',
    districtId: '1404020',
    name: 'Palas',
  },
  {
    id: '1404020031',
    districtId: '1404020',
    name: 'Harapan Jaya',
  },
  {
    id: '1404020032',
    districtId: '1404020',
    name: 'Meranti',
  },
  {
    id: '1404020033',
    districtId: '1404020',
    name: 'Kemang',
  },
  {
    id: '1404020034',
    districtId: '1404020',
    name: 'Batang Kulim',
  },
  {
    id: '1404020035',
    districtId: '1404020',
    name: 'Sido Mukti',
  },
  {
    id: '1404021001',
    districtId: '1404021',
    name: 'Silikuan Hulu',
  },
  {
    id: '1404021002',
    districtId: '1404021',
    name: 'Lubuk Kembang Sari',
  },
  {
    id: '1404021003',
    districtId: '1404021',
    name: 'Lubuk Kembang Bunga',
  },
  {
    id: '1404021004',
    districtId: '1404021',
    name: 'Air Hitam',
  },
  {
    id: '1404021005',
    districtId: '1404021',
    name: 'Kampung Baru',
  },
  {
    id: '1404021006',
    districtId: '1404021',
    name: 'Ukui Satu',
  },
  {
    id: '1404021007',
    districtId: '1404021',
    name: 'Ukui Dua',
  },
  {
    id: '1404021008',
    districtId: '1404021',
    name: 'Bukit Gajah',
  },
  {
    id: '1404021009',
    districtId: '1404021',
    name: 'Bukit Jaya',
  },
  {
    id: '1404021010',
    districtId: '1404021',
    name: 'Air Emas',
  },
  {
    id: '1404021011',
    districtId: '1404021',
    name: 'Tri Mulya Jaya',
  },
  {
    id: '1404021012',
    districtId: '1404021',
    name: 'Bagan Limau',
  },
  {
    id: '1404022001',
    districtId: '1404022',
    name: 'Genduang',
  },
  {
    id: '1404022002',
    districtId: '1404022',
    name: 'Rawang Sari',
  },
  {
    id: '1404022003',
    districtId: '1404022',
    name: 'Sari Makmur',
  },
  {
    id: '1404022004',
    districtId: '1404022',
    name: 'Mulia Subur',
  },
  {
    id: '1404022005',
    districtId: '1404022',
    name: 'Mayang Sari',
  },
  {
    id: '1404022006',
    districtId: '1404022',
    name: 'Sari Mulya',
  },
  {
    id: '1404022007',
    districtId: '1404022',
    name: 'Dusun Tua',
  },
  {
    id: '1404022008',
    districtId: '1404022',
    name: 'Pangkalan Lesung',
  },
  {
    id: '1404022009',
    districtId: '1404022',
    name: 'Tanjung Kuyo',
  },
  {
    id: '1404022010',
    districtId: '1404022',
    name: 'Pesaguan',
  },
  {
    id: '1404030005',
    districtId: '1404030',
    name: 'Merbau',
  },
  {
    id: '1404030009',
    districtId: '1404030',
    name: 'Petani',
  },
  {
    id: '1404030010',
    districtId: '1404030',
    name: 'Pangkalan Bunut',
  },
  {
    id: '1404030011',
    districtId: '1404030',
    name: 'Lubuk Mas',
  },
  {
    id: '1404030012',
    districtId: '1404030',
    name: 'Balam Merah',
  },
  {
    id: '1404030013',
    districtId: '1404030',
    name: 'Bagan Laguh',
  },
  {
    id: '1404030014',
    districtId: '1404030',
    name: 'Sungai Buluh',
  },
  {
    id: '1404030017',
    districtId: '1404030',
    name: 'Lubuk Mandian Gajah',
  },
  {
    id: '1404030018',
    districtId: '1404030',
    name: 'Keriung',
  },
  {
    id: '1404030019',
    districtId: '1404030',
    name: 'Sialang Kayu Batu',
  },
  {
    id: '1404031001',
    districtId: '1404031',
    name: 'Sungai Ara',
  },
  {
    id: '1404031002',
    districtId: '1404031',
    name: 'Ransang',
  },
  {
    id: '1404031003',
    districtId: '1404031',
    name: 'Kuala Tolam',
  },
  {
    id: '1404031004',
    districtId: '1404031',
    name: 'Pelalawan',
  },
  {
    id: '1404031005',
    districtId: '1404031',
    name: 'Telayap',
  },
  {
    id: '1404031006',
    districtId: '1404031',
    name: 'Batang Nilo Kecil',
  },
  {
    id: '1404031007',
    districtId: '1404031',
    name: 'Sering',
  },
  {
    id: '1404031008',
    districtId: '1404031',
    name: 'Delik',
  },
  {
    id: '1404031010',
    districtId: '1404031',
    name: 'Lalang Kabung',
  },
  {
    id: '1404032001',
    districtId: '1404032',
    name: 'Kuala Semundam',
  },
  {
    id: '1404032002',
    districtId: '1404032',
    name: 'Rawang Empat',
  },
  {
    id: '1404032003',
    districtId: '1404032',
    name: 'Tambun',
  },
  {
    id: '1404032004',
    districtId: '1404032',
    name: 'Terbangiang',
  },
  {
    id: '1404032005',
    districtId: '1404032',
    name: 'Lubuk Terap',
  },
  {
    id: '1404032006',
    districtId: '1404032',
    name: 'Angkasa',
  },
  {
    id: '1404032007',
    districtId: '1404032',
    name: 'Sialang Godang',
  },
  {
    id: '1404032008',
    districtId: '1404032',
    name: 'Lubuk Raja',
  },
  {
    id: '1404032009',
    districtId: '1404032',
    name: 'Lubuk Keranji Timur',
  },
  {
    id: '1404032010',
    districtId: '1404032',
    name: 'Sialang Bungkuk',
  },
  {
    id: '1404032011',
    districtId: '1404032',
    name: 'Air Terjun',
  },
  {
    id: '1404040012',
    districtId: '1404040',
    name: 'Serapung',
  },
  {
    id: '1404040013',
    districtId: '1404040',
    name: 'Teluk',
  },
  {
    id: '1404040014',
    districtId: '1404040',
    name: 'Teluk Dalam',
  },
  {
    id: '1404040015',
    districtId: '1404040',
    name: 'Sokoi',
  },
  {
    id: '1404040016',
    districtId: '1404040',
    name: 'Tanjung Sum',
  },
  {
    id: '1404040017',
    districtId: '1404040',
    name: 'Sungai Solok',
  },
  {
    id: '1404040018',
    districtId: '1404040',
    name: 'Sungai Upih',
  },
  {
    id: '1404040019',
    districtId: '1404040',
    name: 'Teluk Beringin',
  },
  {
    id: '1404040020',
    districtId: '1404040',
    name: 'Sungai Emas',
  },
  {
    id: '1404040021',
    districtId: '1404040',
    name: 'Teluk Bakau',
  },
  {
    id: '1404041001',
    districtId: '1404041',
    name: 'Bukit Lembah Subur',
  },
  {
    id: '1404041002',
    districtId: '1404041',
    name: 'Banjar Panjang',
  },
  {
    id: '1404041003',
    districtId: '1404041',
    name: 'Kerumutan',
  },
  {
    id: '1404041004',
    districtId: '1404041',
    name: 'Beringin Makmur',
  },
  {
    id: '1404041005',
    districtId: '1404041',
    name: 'Pematang Tinggi',
  },
  {
    id: '1404041006',
    districtId: '1404041',
    name: 'Pangkalan Tampoi',
  },
  {
    id: '1404041007',
    districtId: '1404041',
    name: 'Pangkalan Panduk',
  },
  {
    id: '1404041008',
    districtId: '1404041',
    name: 'Tanjung Air Hitam',
  },
  {
    id: '1404041009',
    districtId: '1404041',
    name: 'Mak Teduh',
  },
  {
    id: '1404041010',
    districtId: '1404041',
    name: 'Lipai Bulan',
  },
  {
    id: '1404042001',
    districtId: '1404042',
    name: 'Kuala Panduk',
  },
  {
    id: '1404042002',
    districtId: '1404042',
    name: 'Petodaan',
  },
  {
    id: '1404042003',
    districtId: '1404042',
    name: 'Teluk Meranti',
  },
  {
    id: '1404042004',
    districtId: '1404042',
    name: 'Pulau Muda',
  },
  {
    id: '1404042005',
    districtId: '1404042',
    name: 'Pangkalan Terap',
  },
  {
    id: '1404042006',
    districtId: '1404042',
    name: 'Teluk Binjai',
  },
  {
    id: '1404042007',
    districtId: '1404042',
    name: 'Gambut Mutiara',
  },
  {
    id: '1404042008',
    districtId: '1404042',
    name: 'Labuhan Bilik',
  },
  {
    id: '1404042009',
    districtId: '1404042',
    name: 'Segamai',
  },
  {
    id: '1405010005',
    districtId: '1405010',
    name: 'Mandi Angin',
  },
  {
    id: '1405010006',
    districtId: '1405010',
    name: 'Minas Barat',
  },
  {
    id: '1405010007',
    districtId: '1405010',
    name: 'Rantau Bertuah',
  },
  {
    id: '1405010008',
    districtId: '1405010',
    name: 'Minas Timur',
  },
  {
    id: '1405010009',
    districtId: '1405010',
    name: 'Minas Jaya',
  },
  {
    id: '1405011001',
    districtId: '1405011',
    name: 'Lubuk Umbut',
  },
  {
    id: '1405011002',
    districtId: '1405011',
    name: 'Sungai Selodang',
  },
  {
    id: '1405011003',
    districtId: '1405011',
    name: 'Teluk Lancang',
  },
  {
    id: '1405011004',
    districtId: '1405011',
    name: 'Olak',
  },
  {
    id: '1405011005',
    districtId: '1405011',
    name: 'Muara Kelantan',
  },
  {
    id: '1405011006',
    districtId: '1405011',
    name: 'Lubuk Jering',
  },
  {
    id: '1405011007',
    districtId: '1405011',
    name: 'Muara Bungkal',
  },
  {
    id: '1405011008',
    districtId: '1405011',
    name: 'Bencah Umbai',
  },
  {
    id: '1405011009',
    districtId: '1405011',
    name: 'Tasik Betung',
  },
  {
    id: '1405012001',
    districtId: '1405012',
    name: 'Telaga Sam Sam',
  },
  {
    id: '1405012002',
    districtId: '1405012',
    name: 'Sam Sam',
  },
  {
    id: '1405012003',
    districtId: '1405012',
    name: 'Kandis Kota',
  },
  {
    id: '1405012004',
    districtId: '1405012',
    name: 'Kandis',
  },
  {
    id: '1405012005',
    districtId: '1405012',
    name: 'Simpang Belutu',
  },
  {
    id: '1405012006',
    districtId: '1405012',
    name: 'Belutu',
  },
  {
    id: '1405012007',
    districtId: '1405012',
    name: 'Bekalar',
  },
  {
    id: '1405012008',
    districtId: '1405012',
    name: 'Jambai Makmur',
  },
  {
    id: '1405012009',
    districtId: '1405012',
    name: 'Pencing Bekulo',
  },
  {
    id: '1405012010',
    districtId: '1405012',
    name: 'Sungai Gondang',
  },
  {
    id: '1405012011',
    districtId: '1405012',
    name: 'Libo Jaya',
  },
  {
    id: '1405020042',
    districtId: '1405020',
    name: 'Langkai',
  },
  {
    id: '1405020043',
    districtId: '1405020',
    name: 'Kampung Dalam',
  },
  {
    id: '1405020046',
    districtId: '1405020',
    name: 'Kampung Rempak',
  },
  {
    id: '1405020047',
    districtId: '1405020',
    name: 'Tumang',
  },
  {
    id: '1405020049',
    districtId: '1405020',
    name: 'Merempan Hulu',
  },
  {
    id: '1405020050',
    districtId: '1405020',
    name: 'Rawang Air Putih',
  },
  {
    id: '1405020051',
    districtId: '1405020',
    name: 'Suak Lanjut',
  },
  {
    id: '1405020052',
    districtId: '1405020',
    name: 'Buantan Besar',
  },
  {
    id: '1405021001',
    districtId: '1405021',
    name: 'Kerinci Kiri',
  },
  {
    id: '1405021003',
    districtId: '1405021',
    name: 'Bukit Agung',
  },
  {
    id: '1405021004',
    districtId: '1405021',
    name: 'Kumbara Utama',
  },
  {
    id: '1405021005',
    districtId: '1405021',
    name: 'Bukit Harapan',
  },
  {
    id: '1405021006',
    districtId: '1405021',
    name: 'Buana Bhakti',
  },
  {
    id: '1405021007',
    districtId: '1405021',
    name: 'Kerinci Kanan',
  },
  {
    id: '1405021008',
    districtId: '1405021',
    name: 'Simpang Perak Jaya',
  },
  {
    id: '1405021009',
    districtId: '1405021',
    name: 'Gabung Makmur',
  },
  {
    id: '1405021010',
    districtId: '1405021',
    name: 'Jati Mulia',
  },
  {
    id: '1405021011',
    districtId: '1405021',
    name: 'Buatan Baru',
  },
  {
    id: '1405021012',
    districtId: '1405021',
    name: 'Seminai',
  },
  {
    id: '1405021013',
    districtId: '1405021',
    name: 'Delima Jaya',
  },
  {
    id: '1405022001',
    districtId: '1405022',
    name: 'Meredan',
  },
  {
    id: '1405022002',
    districtId: '1405022',
    name: 'Tualang',
  },
  {
    id: '1405022003',
    districtId: '1405022',
    name: 'Pinang Sebatang',
  },
  {
    id: '1405022013',
    districtId: '1405022',
    name: 'Meredan Barat',
  },
  {
    id: '1405022014',
    districtId: '1405022',
    name: 'Pinang Sebatang Barat',
  },
  {
    id: '1405022015',
    districtId: '1405022',
    name: 'Pinang Sebatang Timur',
  },
  {
    id: '1405022016',
    districtId: '1405022',
    name: 'Perawang Barat',
  },
  {
    id: '1405022017',
    districtId: '1405022',
    name: 'Perawang',
  },
  {
    id: '1405022018',
    districtId: '1405022',
    name: 'Tualang Timur',
  },
  {
    id: '1405023001',
    districtId: '1405023',
    name: 'Suka Mulia',
  },
  {
    id: '1405023002',
    districtId: '1405023',
    name: 'Buana Makmur',
  },
  {
    id: '1405023003',
    districtId: '1405023',
    name: 'Pangkalan Makmur',
  },
  {
    id: '1405023004',
    districtId: '1405023',
    name: 'Banjar Seminai',
  },
  {
    id: '1405023005',
    districtId: '1405023',
    name: 'Teluk Merbau',
  },
  {
    id: '1405023006',
    districtId: '1405023',
    name: 'Sawit Permai',
  },
  {
    id: '1405023007',
    districtId: '1405023',
    name: 'Sialang Sakti',
  },
  {
    id: '1405023008',
    districtId: '1405023',
    name: 'Merangkai',
  },
  {
    id: '1405023009',
    districtId: '1405023',
    name: 'Berumbung Baru',
  },
  {
    id: '1405023010',
    districtId: '1405023',
    name: 'Lubuk Tilan',
  },
  {
    id: '1405023011',
    districtId: '1405023',
    name: 'Dayun',
  },
  {
    id: '1405024001',
    districtId: '1405024',
    name: 'Empang Baru',
  },
  {
    id: '1405024002',
    districtId: '1405024',
    name: 'Sialang Palas',
  },
  {
    id: '1405024003',
    districtId: '1405024',
    name: 'Sialang Baru',
  },
  {
    id: '1405024004',
    districtId: '1405024',
    name: 'Lubuk Dalam',
  },
  {
    id: '1405024005',
    districtId: '1405024',
    name: 'Rawang Kao',
  },
  {
    id: '1405024006',
    districtId: '1405024',
    name: 'Sri Gading',
  },
  {
    id: '1405024007',
    districtId: '1405024',
    name: 'Rawang Kao Barat',
  },
  {
    id: '1405025001',
    districtId: '1405025',
    name: 'Kuala Gasib',
  },
  {
    id: '1405025002',
    districtId: '1405025',
    name: 'Teluk Rimba',
  },
  {
    id: '1405025003',
    districtId: '1405025',
    name: 'Pangkalan Pisang',
  },
  {
    id: '1405025004',
    districtId: '1405025',
    name: 'Keranji Guguh',
  },
  {
    id: '1405025005',
    districtId: '1405025',
    name: 'Empang Pandan',
  },
  {
    id: '1405025006',
    districtId: '1405025',
    name: 'Sengkemang',
  },
  {
    id: '1405025007',
    districtId: '1405025',
    name: 'Rantau Panjang',
  },
  {
    id: '1405025008',
    districtId: '1405025',
    name: 'Buatan II',
  },
  {
    id: '1405025009',
    districtId: '1405025',
    name: 'Buatan I',
  },
  {
    id: '1405025010',
    districtId: '1405025',
    name: 'Sri Gemilang',
  },
  {
    id: '1405025011',
    districtId: '1405025',
    name: 'Tasik Seminai',
  },
  {
    id: '1405026001',
    districtId: '1405026',
    name: 'Merempan Hilir',
  },
  {
    id: '1405026002',
    districtId: '1405026',
    name: 'Sungai Mempura',
  },
  {
    id: '1405026003',
    districtId: '1405026',
    name: 'Kampung Tengah',
  },
  {
    id: '1405026004',
    districtId: '1405026',
    name: 'Benteng Hulu',
  },
  {
    id: '1405026005',
    districtId: '1405026',
    name: 'Benteng Hilir',
  },
  {
    id: '1405026006',
    districtId: '1405026',
    name: 'Paluh',
  },
  {
    id: '1405026007',
    districtId: '1405026',
    name: 'Kota Ringin',
  },
  {
    id: '1405026008',
    districtId: '1405026',
    name: 'Teluk Merempan',
  },
  {
    id: '1405030011',
    districtId: '1405030',
    name: 'Teluk Mesjid',
  },
  {
    id: '1405030012',
    districtId: '1405030',
    name: 'Pariti/II',
  },
  {
    id: '1405030013',
    districtId: '1405030',
    name: 'Sungai Apit',
  },
  {
    id: '1405030016',
    districtId: '1405030',
    name: 'Tanjung Kuras',
  },
  {
    id: '1405030017',
    districtId: '1405030',
    name: 'Sungai Kayu Ara',
  },
  {
    id: '1405030018',
    districtId: '1405030',
    name: 'Lalang',
  },
  {
    id: '1405030019',
    districtId: '1405030',
    name: 'Mengkapan',
  },
  {
    id: '1405030020',
    districtId: '1405030',
    name: 'Sungai Rawa',
  },
  {
    id: '1405030021',
    districtId: '1405030',
    name: 'Penyengat',
  },
  {
    id: '1405030022',
    districtId: '1405030',
    name: 'Teluk Lanus',
  },
  {
    id: '1405030023',
    districtId: '1405030',
    name: 'Harapan',
  },
  {
    id: '1405030027',
    districtId: '1405030',
    name: 'Teluk Batil',
  },
  {
    id: '1405030028',
    districtId: '1405030',
    name: 'Bunsur',
  },
  {
    id: '1405030029',
    districtId: '1405030',
    name: 'Kayu Ara Permai',
  },
  {
    id: '1405030030',
    districtId: '1405030',
    name: 'Rawa Mekar Jaya',
  },
  {
    id: '1405031001',
    districtId: '1405031',
    name: 'Jaya Pura',
  },
  {
    id: '1405031007',
    districtId: '1405031',
    name: 'Bunga Raya',
  },
  {
    id: '1405031008',
    districtId: '1405031',
    name: 'Jati Baru',
  },
  {
    id: '1405031011',
    districtId: '1405031',
    name: 'Buantan Lestari',
  },
  {
    id: '1405031012',
    districtId: '1405031',
    name: 'Tuah Indrapura',
  },
  {
    id: '1405031013',
    districtId: '1405031',
    name: 'Kemuning Muda',
  },
  {
    id: '1405031014',
    districtId: '1405031',
    name: 'Langsat Permai',
  },
  {
    id: '1405031015',
    districtId: '1405031',
    name: 'Suak Merambai',
  },
  {
    id: '1405031016',
    districtId: '1405031',
    name: 'Dayang Suri',
  },
  {
    id: '1405031017',
    districtId: '1405031',
    name: 'Temusai',
  },
  {
    id: '1405032001',
    districtId: '1405032',
    name: 'Sungai Tengah',
  },
  {
    id: '1405032002',
    districtId: '1405032',
    name: 'Bandar Sungai',
  },
  {
    id: '1405032003',
    districtId: '1405032',
    name: 'Belading',
  },
  {
    id: '1405032004',
    districtId: '1405032',
    name: 'Laksamana',
  },
  {
    id: '1405032005',
    districtId: '1405032',
    name: 'Rempak',
  },
  {
    id: '1405032006',
    districtId: '1405032',
    name: 'Sabak Permai',
  },
  {
    id: '1405032007',
    districtId: '1405032',
    name: 'Bandar Pedada',
  },
  {
    id: '1405032008',
    districtId: '1405032',
    name: 'Selat Guntung',
  },
  {
    id: '1405033001',
    districtId: '1405033',
    name: 'Sungai Berbari',
  },
  {
    id: '1405033002',
    districtId: '1405033',
    name: 'Sungai Limau',
  },
  {
    id: '1405033003',
    districtId: '1405033',
    name: 'Dosan',
  },
  {
    id: '1405033004',
    districtId: '1405033',
    name: 'Benayah',
  },
  {
    id: '1405033005',
    districtId: '1405033',
    name: 'Pebadaran',
  },
  {
    id: '1405033006',
    districtId: '1405033',
    name: 'Dusun Pusaka',
  },
  {
    id: '1405033007',
    districtId: '1405033',
    name: 'Perincit',
  },
  {
    id: '1406010006',
    districtId: '1406010',
    name: 'Domo',
  },
  {
    id: '1406010014',
    districtId: '1406010',
    name: 'Muara Selaya',
  },
  {
    id: '1406010015',
    districtId: '1406010',
    name: 'IV Koto Setingkai',
  },
  {
    id: '1406010016',
    districtId: '1406010',
    name: 'Padang Sawah',
  },
  {
    id: '1406010017',
    districtId: '1406010',
    name: 'Kuntu',
  },
  {
    id: '1406010018',
    districtId: '1406010',
    name: 'Teluk Paman',
  },
  {
    id: '1406010019',
    districtId: '1406010',
    name: 'Lipat Kain',
  },
  {
    id: '1406010020',
    districtId: '1406010',
    name: 'Sungai Geringging',
  },
  {
    id: '1406010021',
    districtId: '1406010',
    name: 'Sungai Paku',
  },
  {
    id: '1406010034',
    districtId: '1406010',
    name: 'Sungai Rambai',
  },
  {
    id: '1406010035',
    districtId: '1406010',
    name: 'Sungai Raja',
  },
  {
    id: '1406010036',
    districtId: '1406010',
    name: 'Tanjung Harapan',
  },
  {
    id: '1406010037',
    districtId: '1406010',
    name: 'Sungai Sarik',
  },
  {
    id: '1406010040',
    districtId: '1406010',
    name: 'Lipat Kain Utara',
  },
  {
    id: '1406010041',
    districtId: '1406010',
    name: 'Lipat Kain Selatan',
  },
  {
    id: '1406010042',
    districtId: '1406010',
    name: 'Kuntu Darussalam',
  },
  {
    id: '1406010043',
    districtId: '1406010',
    name: 'Tanjung Mas',
  },
  {
    id: '1406010044',
    districtId: '1406010',
    name: 'Sungai Liti',
  },
  {
    id: '1406010045',
    districtId: '1406010',
    name: 'Teluk Paman Timur',
  },
  {
    id: '1406010046',
    districtId: '1406010',
    name: 'Sungai Harapan',
  },
  {
    id: '1406011001',
    districtId: '1406011',
    name: 'Aur Kuning',
  },
  {
    id: '1406011002',
    districtId: '1406011',
    name: 'Tanjung Beringin',
  },
  {
    id: '1406011003',
    districtId: '1406011',
    name: 'Batu Sanggan',
  },
  {
    id: '1406011004',
    districtId: '1406011',
    name: 'Tanjung Belit',
  },
  {
    id: '1406011005',
    districtId: '1406011',
    name: 'Gema',
  },
  {
    id: '1406011006',
    districtId: '1406011',
    name: 'Tanjung Belit Selatan',
  },
  {
    id: '1406011007',
    districtId: '1406011',
    name: 'Kota Lama',
  },
  {
    id: '1406011008',
    districtId: '1406011',
    name: 'Ludai',
  },
  {
    id: '1406011009',
    districtId: '1406011',
    name: 'Pangkalan Kapas',
  },
  {
    id: '1406011010',
    districtId: '1406011',
    name: 'Kebun Tinggi',
  },
  {
    id: '1406011011',
    districtId: '1406011',
    name: 'Batu Sasak',
  },
  {
    id: '1406011012',
    districtId: '1406011',
    name: 'Tanjung Karang',
  },
  {
    id: '1406011013',
    districtId: '1406011',
    name: 'Gajah Bertalut',
  },
  {
    id: '1406011014',
    districtId: '1406011',
    name: 'Pangkalan Serai',
  },
  {
    id: '1406011015',
    districtId: '1406011',
    name: 'Danau Sontul',
  },
  {
    id: '1406011016',
    districtId: '1406011',
    name: 'Deras Tajak',
  },
  {
    id: '1406011017',
    districtId: '1406011',
    name: 'Terusan',
  },
  {
    id: '1406011018',
    districtId: '1406011',
    name: 'Sungai Santi',
  },
  {
    id: '1406011019',
    districtId: '1406011',
    name: 'Tanjung Permai',
  },
  {
    id: '1406011020',
    districtId: '1406011',
    name: 'Dua Sepakat',
  },
  {
    id: '1406011021',
    districtId: '1406011',
    name: 'Subayang Jaya',
  },
  {
    id: '1406011022',
    districtId: '1406011',
    name: 'Bukit Betung',
  },
  {
    id: '1406011023',
    districtId: '1406011',
    name: 'Lubuk Bigau',
  },
  {
    id: '1406011024',
    districtId: '1406011',
    name: 'Muara Bio',
  },
  {
    id: '1406012001',
    districtId: '1406012',
    name: 'Sungai Simpang Dua',
  },
  {
    id: '1406012002',
    districtId: '1406012',
    name: 'Sungai Pagar',
  },
  {
    id: '1406012003',
    districtId: '1406012',
    name: 'Mentulik',
  },
  {
    id: '1406012004',
    districtId: '1406012',
    name: 'Bangun Sari',
  },
  {
    id: '1406012005',
    districtId: '1406012',
    name: 'Sungai Petai',
  },
  {
    id: '1406012006',
    districtId: '1406012',
    name: 'Rantau Kasih',
  },
  {
    id: '1406012007',
    districtId: '1406012',
    name: 'Sungai Bunga',
  },
  {
    id: '1406012008',
    districtId: '1406012',
    name: 'Gading Permai',
  },
  {
    id: '1406013001',
    districtId: '1406013',
    name: 'Kebun Durian',
  },
  {
    id: '1406013002',
    districtId: '1406013',
    name: 'Subarak',
  },
  {
    id: '1406013003',
    districtId: '1406013',
    name: 'Gunung Sahilan',
  },
  {
    id: '1406013004',
    districtId: '1406013',
    name: 'Suka Makmur',
  },
  {
    id: '1406013005',
    districtId: '1406013',
    name: 'Gunung Sari',
  },
  {
    id: '1406013006',
    districtId: '1406013',
    name: 'Makmur Sejahtera',
  },
  {
    id: '1406013007',
    districtId: '1406013',
    name: 'Sungai Lipai',
  },
  {
    id: '1406013008',
    districtId: '1406013',
    name: 'Sahilan Darussalam',
  },
  {
    id: '1406013009',
    districtId: '1406013',
    name: 'Gunung Mulya',
  },
  {
    id: '1406014001',
    districtId: '1406014',
    name: 'Penghidupan',
  },
  {
    id: '1406014002',
    districtId: '1406014',
    name: 'Simalinyang',
  },
  {
    id: '1406014003',
    districtId: '1406014',
    name: 'Mayang Pongkai',
  },
  {
    id: '1406014004',
    districtId: '1406014',
    name: 'Lubuk Sakai',
  },
  {
    id: '1406014005',
    districtId: '1406014',
    name: 'Bina Baru',
  },
  {
    id: '1406014006',
    districtId: '1406014',
    name: 'Hidup Baru',
  },
  {
    id: '1406014007',
    districtId: '1406014',
    name: 'Karya Bakti',
  },
  {
    id: '1406014008',
    districtId: '1406014',
    name: 'Koto Damai',
  },
  {
    id: '1406014009',
    districtId: '1406014',
    name: 'Utama Karya',
  },
  {
    id: '1406014010',
    districtId: '1406014',
    name: 'Bukit Sakai',
  },
  {
    id: '1406014011',
    districtId: '1406014',
    name: 'Mekar Jaya',
  },
  {
    id: '1406020001',
    districtId: '1406020',
    name: 'Balung',
  },
  {
    id: '1406020002',
    districtId: '1406020',
    name: 'Pulau Gadang',
  },
  {
    id: '1406020003',
    districtId: '1406020',
    name: 'Tanjung Alai',
  },
  {
    id: '1406020004',
    districtId: '1406020',
    name: 'Batu Bersurat',
  },
  {
    id: '1406020005',
    districtId: '1406020',
    name: 'Koto Tuo',
  },
  {
    id: '1406020006',
    districtId: '1406020',
    name: 'Muara Takus',
  },
  {
    id: '1406020007',
    districtId: '1406020',
    name: 'Gunung Bungsu',
  },
  {
    id: '1406020013',
    districtId: '1406020',
    name: 'Koto Mesjid',
  },
  {
    id: '1406020014',
    districtId: '1406020',
    name: 'Lubuk Agung',
  },
  {
    id: '1406020015',
    districtId: '1406020',
    name: 'Ranah Sungkai',
  },
  {
    id: '1406020016',
    districtId: '1406020',
    name: 'Binamang',
  },
  {
    id: '1406020017',
    districtId: '1406020',
    name: 'Pongkai Istiqamah',
  },
  {
    id: '1406020024',
    districtId: '1406020',
    name: 'Koto Tuo Barat',
  },
  {
    id: '1406021001',
    districtId: '1406021',
    name: 'Tanjung',
  },
  {
    id: '1406021002',
    districtId: '1406021',
    name: 'Tabing',
  },
  {
    id: '1406021003',
    districtId: '1406021',
    name: 'Pongkai',
  },
  {
    id: '1406021004',
    districtId: '1406021',
    name: 'Gunung Malelo',
  },
  {
    id: '1406021005',
    districtId: '1406021',
    name: 'Sibiruang',
  },
  {
    id: '1406021006',
    districtId: '1406021',
    name: 'Bandur Picak',
  },
  {
    id: '1406030002',
    districtId: '1406030',
    name: 'Kuok',
  },
  {
    id: '1406030003',
    districtId: '1406030',
    name: 'Merangin',
  },
  {
    id: '1406030004',
    districtId: '1406030',
    name: 'Empat Balai',
  },
  {
    id: '1406030005',
    districtId: '1406030',
    name: 'Pulau Jambu',
  },
  {
    id: '1406030008',
    districtId: '1406030',
    name: 'Silam',
  },
  {
    id: '1406030009',
    districtId: '1406030',
    name: 'Bukit Melintang',
  },
  {
    id: '1406030010',
    districtId: '1406030',
    name: 'Lereng',
  },
  {
    id: '1406030011',
    districtId: '1406030',
    name: 'Pulau Terap',
  },
  {
    id: '1406030012',
    districtId: '1406030',
    name: 'Batu Langka Kecil',
  },
  {
    id: '1406031001',
    districtId: '1406031',
    name: 'Siabu',
  },
  {
    id: '1406031002',
    districtId: '1406031',
    name: 'Ganting',
  },
  {
    id: '1406031003',
    districtId: '1406031',
    name: 'Sipungguk',
  },
  {
    id: '1406031004',
    districtId: '1406031',
    name: 'Ganting Damai',
  },
  {
    id: '1406031005',
    districtId: '1406031',
    name: 'Salo',
  },
  {
    id: '1406031006',
    districtId: '1406031',
    name: 'Salo Timur',
  },
  {
    id: '1406040002',
    districtId: '1406040',
    name: 'Petapahan',
  },
  {
    id: '1406040003',
    districtId: '1406040',
    name: 'Sei Lembu Makmur',
  },
  {
    id: '1406040004',
    districtId: '1406040',
    name: 'Muara Mahat Baru',
  },
  {
    id: '1406040005',
    districtId: '1406040',
    name: 'Kinantan',
  },
  {
    id: '1406040006',
    districtId: '1406040',
    name: 'Sibuak',
  },
  {
    id: '1406040007',
    districtId: '1406040',
    name: 'Pantai Cermin',
  },
  {
    id: '1406040008',
    districtId: '1406040',
    name: 'Sei Putih',
  },
  {
    id: '1406040009',
    districtId: '1406040',
    name: 'Pagaruyung',
  },
  {
    id: '1406040010',
    districtId: '1406040',
    name: 'Air Terbit',
  },
  {
    id: '1406040011',
    districtId: '1406040',
    name: 'Pancuran Gading',
  },
  {
    id: '1406040012',
    districtId: '1406040',
    name: 'Sari Galuh',
  },
  {
    id: '1406040013',
    districtId: '1406040',
    name: 'Tri Manunggal',
  },
  {
    id: '1406040014',
    districtId: '1406040',
    name: 'Mukti Sari',
  },
  {
    id: '1406040015',
    districtId: '1406040',
    name: 'Indrapuri',
  },
  {
    id: '1406040016',
    districtId: '1406040',
    name: 'Gading Sari',
  },
  {
    id: '1406040017',
    districtId: '1406040',
    name: 'Tanjung Sawit',
  },
  {
    id: '1406040018',
    districtId: '1406040',
    name: 'Sumber Makmur',
  },
  {
    id: '1406040019',
    districtId: '1406040',
    name: 'Petapahan Jaya',
  },
  {
    id: '1406040030',
    districtId: '1406040',
    name: 'Pelambaian',
  },
  {
    id: '1406040031',
    districtId: '1406040',
    name: 'Indra Sakti',
  },
  {
    id: '1406040032',
    districtId: '1406040',
    name: 'Sungai Agung',
  },
  {
    id: '1406040033',
    districtId: '1406040',
    name: 'Karya Indah',
  },
  {
    id: '1406040034',
    districtId: '1406040',
    name: 'Kijang Rejo',
  },
  {
    id: '1406040035',
    districtId: '1406040',
    name: 'Bencah Kelubi',
  },
  {
    id: '1406040036',
    districtId: '1406040',
    name: 'Batu Gajah',
  },
  {
    id: '1406041001',
    districtId: '1406041',
    name: 'Kasikan',
  },
  {
    id: '1406041002',
    districtId: '1406041',
    name: 'Rimba Beringin',
  },
  {
    id: '1406041003',
    districtId: '1406041',
    name: 'Senama Nenek',
  },
  {
    id: '1406041004',
    districtId: '1406041',
    name: 'Bukit Kemuning',
  },
  {
    id: '1406041005',
    districtId: '1406041',
    name: 'Danau Lancang',
  },
  {
    id: '1406041006',
    districtId: '1406041',
    name: 'Suka Ramai',
  },
  {
    id: '1406041007',
    districtId: '1406041',
    name: 'Kusau Makmur',
  },
  {
    id: '1406041008',
    districtId: '1406041',
    name: 'Sumber Sari',
  },
  {
    id: '1406041014',
    districtId: '1406041',
    name: 'Talang Danto',
  },
  {
    id: '1406041015',
    districtId: '1406041',
    name: 'Muara Intan',
  },
  {
    id: '1406041016',
    districtId: '1406041',
    name: 'Intan Jaya',
  },
  {
    id: '1406041017',
    districtId: '1406041',
    name: 'Tanah Datar',
  },
  {
    id: '1406041018',
    districtId: '1406041',
    name: 'Rimba Makmur',
  },
  {
    id: '1406041019',
    districtId: '1406041',
    name: 'Rimba Jaya',
  },
  {
    id: '1406042001',
    districtId: '1406042',
    name: 'Sekijang',
  },
  {
    id: '1406042002',
    districtId: '1406042',
    name: 'Tebing Lestari',
  },
  {
    id: '1406042003',
    districtId: '1406042',
    name: 'Kijang Jaya',
  },
  {
    id: '1406042004',
    districtId: '1406042',
    name: 'Tanah Tinggi',
  },
  {
    id: '1406042005',
    districtId: '1406042',
    name: 'Tapung Makmur',
  },
  {
    id: '1406042006',
    districtId: '1406042',
    name: 'Tapung Lestari',
  },
  {
    id: '1406042007',
    districtId: '1406042',
    name: 'Kota Garo',
  },
  {
    id: '1406042008',
    districtId: '1406042',
    name: 'Suka Maju',
  },
  {
    id: '1406042009',
    districtId: '1406042',
    name: 'Kota Baru',
  },
  {
    id: '1406042010',
    districtId: '1406042',
    name: 'Koto Bangun',
  },
  {
    id: '1406042011',
    districtId: '1406042',
    name: 'Cinta Damai',
  },
  {
    id: '1406042012',
    districtId: '1406042',
    name: 'Beringin Lestari',
  },
  {
    id: '1406042013',
    districtId: '1406042',
    name: 'Tandan Sari',
  },
  {
    id: '1406042015',
    districtId: '1406042',
    name: 'Kijang Makmur',
  },
  {
    id: '1406042016',
    districtId: '1406042',
    name: 'Koto Aman',
  },
  {
    id: '1406042017',
    districtId: '1406042',
    name: 'Gerbang Sari',
  },
  {
    id: '1406050002',
    districtId: '1406050',
    name: 'Langgini',
  },
  {
    id: '1406050003',
    districtId: '1406050',
    name: 'Bangkinang',
  },
  {
    id: '1406050013',
    districtId: '1406050',
    name: 'Kumantan',
  },
  {
    id: '1406050014',
    districtId: '1406050',
    name: 'Ridan Permai',
  },
  {
    id: '1406051001',
    districtId: '1406051',
    name: 'Pulau Lawas',
  },
  {
    id: '1406051002',
    districtId: '1406051',
    name: 'Muara Uwai',
  },
  {
    id: '1406051003',
    districtId: '1406051',
    name: 'Pulau',
  },
  {
    id: '1406051004',
    districtId: '1406051',
    name: 'Pasir Sialang',
  },
  {
    id: '1406051005',
    districtId: '1406051',
    name: 'Bukit Sembilan',
  },
  {
    id: '1406051006',
    districtId: '1406051',
    name: 'Laboi Jaya',
  },
  {
    id: '1406051007',
    districtId: '1406051',
    name: 'Suka Mulya',
  },
  {
    id: '1406051008',
    districtId: '1406051',
    name: 'Bukit Payung',
  },
  {
    id: '1406051009',
    districtId: '1406051',
    name: 'Binuang',
  },
  {
    id: '1406060001',
    districtId: '1406060',
    name: 'Batu Belah',
  },
  {
    id: '1406060002',
    districtId: '1406060',
    name: 'Tanjung Berulak',
  },
  {
    id: '1406060003',
    districtId: '1406060',
    name: 'Air Tiris',
  },
  {
    id: '1406060004',
    districtId: '1406060',
    name: 'Ranah',
  },
  {
    id: '1406060005',
    districtId: '1406060',
    name: 'Penyasawan',
  },
  {
    id: '1406060006',
    districtId: '1406060',
    name: 'Rumbio',
  },
  {
    id: '1406060007',
    districtId: '1406060',
    name: 'Padang Mutung',
  },
  {
    id: '1406060025',
    districtId: '1406060',
    name: 'Simpang Kubu',
  },
  {
    id: '1406060026',
    districtId: '1406060',
    name: 'Tanjung Rambutan',
  },
  {
    id: '1406060028',
    districtId: '1406060',
    name: 'Pulau Jambu',
  },
  {
    id: '1406060029',
    districtId: '1406060',
    name: 'Limau Manis',
  },
  {
    id: '1406060030',
    districtId: '1406060',
    name: 'Naumbai',
  },
  {
    id: '1406060031',
    districtId: '1406060',
    name: 'Ranah Singkuang',
  },
  {
    id: '1406060032',
    districtId: '1406060',
    name: 'Pulau Tinggi',
  },
  {
    id: '1406060033',
    districtId: '1406060',
    name: 'Koto Tibun',
  },
  {
    id: '1406060034',
    districtId: '1406060',
    name: 'Bukit Ranah',
  },
  {
    id: '1406060035',
    districtId: '1406060',
    name: 'Ranah Baru',
  },
  {
    id: '1406060036',
    districtId: '1406060',
    name: 'Pulau Sarak',
  },
  {
    id: '1406061001',
    districtId: '1406061',
    name: 'Pulau Rambai',
  },
  {
    id: '1406061002',
    districtId: '1406061',
    name: 'Kampar',
  },
  {
    id: '1406061003',
    districtId: '1406061',
    name: 'Koto Perambahan',
  },
  {
    id: '1406061004',
    districtId: '1406061',
    name: 'Pulau Birandang',
  },
  {
    id: '1406061005',
    districtId: '1406061',
    name: 'Sungai Putih',
  },
  {
    id: '1406061006',
    districtId: '1406061',
    name: 'Deli Makmur',
  },
  {
    id: '1406061007',
    districtId: '1406061',
    name: 'Sungai Tarap',
  },
  {
    id: '1406061008',
    districtId: '1406061',
    name: 'Tanjung Bungo',
  },
  {
    id: '1406061009',
    districtId: '1406061',
    name: 'Sawah Baru',
  },
  {
    id: '1406062001',
    districtId: '1406062',
    name: 'Alam Panjang',
  },
  {
    id: '1406062002',
    districtId: '1406062',
    name: 'Pulau Payung',
  },
  {
    id: '1406062003',
    districtId: '1406062',
    name: 'Teratak',
  },
  {
    id: '1406062004',
    districtId: '1406062',
    name: 'Bukit Kratai',
  },
  {
    id: '1406062005',
    districtId: '1406062',
    name: 'Batang Batindih',
  },
  {
    id: '1406062006',
    districtId: '1406062',
    name: 'Tambusai',
  },
  {
    id: '1406062007',
    districtId: '1406062',
    name: 'Simpang Petai',
  },
  {
    id: '1406063001',
    districtId: '1406063',
    name: 'Kampung Panjang',
  },
  {
    id: '1406063002',
    districtId: '1406063',
    name: 'Sawah',
  },
  {
    id: '1406063003',
    districtId: '1406063',
    name: 'Kayu Aro',
  },
  {
    id: '1406063004',
    districtId: '1406063',
    name: 'Muara Jalai',
  },
  {
    id: '1406063005',
    districtId: '1406063',
    name: 'Sungai Tonang',
  },
  {
    id: '1406063006',
    districtId: '1406063',
    name: 'Sungai Jalau',
  },
  {
    id: '1406063007',
    districtId: '1406063',
    name: 'Sendayan',
  },
  {
    id: '1406063008',
    districtId: '1406063',
    name: 'Naga Beralih',
  },
  {
    id: '1406070001',
    districtId: '1406070',
    name: 'Kuapan',
  },
  {
    id: '1406070002',
    districtId: '1406070',
    name: 'Aur Sati',
  },
  {
    id: '1406070003',
    districtId: '1406070',
    name: 'Tambang',
  },
  {
    id: '1406070004',
    districtId: '1406070',
    name: 'Padang Luas',
  },
  {
    id: '1406070005',
    districtId: '1406070',
    name: 'Gobah',
  },
  {
    id: '1406070006',
    districtId: '1406070',
    name: 'Terantang',
  },
  {
    id: '1406070007',
    districtId: '1406070',
    name: 'Rimba Panjang',
  },
  {
    id: '1406070008',
    districtId: '1406070',
    name: 'Kualu',
  },
  {
    id: '1406070009',
    districtId: '1406070',
    name: 'Teluk Kenidai',
  },
  {
    id: '1406070010',
    districtId: '1406070',
    name: 'Parit Baru',
  },
  {
    id: '1406070011',
    districtId: '1406070',
    name: 'Kemang Indah',
  },
  {
    id: '1406070012',
    districtId: '1406070',
    name: 'Sungai Pinang',
  },
  {
    id: '1406070013',
    districtId: '1406070',
    name: 'Kualu Nenas',
  },
  {
    id: '1406070014',
    districtId: '1406070',
    name: 'Tarai Bangun',
  },
  {
    id: '1406070015',
    districtId: '1406070',
    name: 'Palung Raya',
  },
  {
    id: '1406070016',
    districtId: '1406070',
    name: 'Pulau Permai',
  },
  {
    id: '1406070017',
    districtId: '1406070',
    name: 'Balam Jaya',
  },
  {
    id: '1406080004',
    districtId: '1406080',
    name: 'Buluh Nipis',
  },
  {
    id: '1406080005',
    districtId: '1406080',
    name: 'Pangkalan Baru',
  },
  {
    id: '1406080006',
    districtId: '1406080',
    name: 'Buluh Cina',
  },
  {
    id: '1406080007',
    districtId: '1406080',
    name: 'Lubuk Siam',
  },
  {
    id: '1406080009',
    districtId: '1406080',
    name: 'Teratak Buluh',
  },
  {
    id: '1406080010',
    districtId: '1406080',
    name: 'Desa Baru',
  },
  {
    id: '1406080011',
    districtId: '1406080',
    name: 'Tanah Merah',
  },
  {
    id: '1406080012',
    districtId: '1406080',
    name: 'Pandau Jaya',
  },
  {
    id: '1406080013',
    districtId: '1406080',
    name: 'Pangkalan Serik',
  },
  {
    id: '1406080014',
    districtId: '1406080',
    name: 'Kepau Jaya',
  },
  {
    id: '1406080015',
    districtId: '1406080',
    name: 'Tanjung Balam',
  },
  {
    id: '1406080016',
    districtId: '1406080',
    name: 'Kubang Jaya',
  },
  {
    id: '1406081001',
    districtId: '1406081',
    name: 'Pantai Raja',
  },
  {
    id: '1406081002',
    districtId: '1406081',
    name: 'Sialang Kubang',
  },
  {
    id: '1406081003',
    districtId: '1406081',
    name: 'Hang Tuah',
  },
  {
    id: '1406081008',
    districtId: '1406081',
    name: 'Kampung Pinang',
  },
  {
    id: '1406081009',
    districtId: '1406081',
    name: 'Lubuk Sakat',
  },
  {
    id: '1407010001',
    districtId: '1407010',
    name: 'Cipang Kiri Hulu',
  },
  {
    id: '1407010002',
    districtId: '1407010',
    name: 'Cipang Kiri Hilir',
  },
  {
    id: '1407010007',
    districtId: '1407010',
    name: 'Sikebau Jaya',
  },
  {
    id: '1407010008',
    districtId: '1407010',
    name: 'Lubuk Bendahara',
  },
  {
    id: '1407010009',
    districtId: '1407010',
    name: 'Lubuk Bendahara Timur',
  },
  {
    id: '1407010010',
    districtId: '1407010',
    name: 'Tanjung Medan',
  },
  {
    id: '1407010011',
    districtId: '1407010',
    name: 'Rokan',
  },
  {
    id: '1407010012',
    districtId: '1407010',
    name: 'Cipang Kanan',
  },
  {
    id: '1407010013',
    districtId: '1407010',
    name: 'Rokan Koto Ruang',
  },
  {
    id: '1407010014',
    districtId: '1407010',
    name: 'Rokan Timur',
  },
  {
    id: '1407010015',
    districtId: '1407010',
    name: 'Tibawan',
  },
  {
    id: '1407010016',
    districtId: '1407010',
    name: 'Lubuk Betung',
  },
  {
    id: '1407010017',
    districtId: '1407010',
    name: 'Alahan',
  },
  {
    id: '1407010018',
    districtId: '1407010',
    name: 'Pemandang',
  },
  {
    id: '1407011001',
    districtId: '1407011',
    name: 'Pendalian',
  },
  {
    id: '1407011002',
    districtId: '1407011',
    name: 'Bengkolan Salak',
  },
  {
    id: '1407011003',
    districtId: '1407011',
    name: 'Suligi',
  },
  {
    id: '1407011004',
    districtId: '1407011',
    name: 'Air Panas',
  },
  {
    id: '1407011005',
    districtId: '1407011',
    name: 'Sungai Kandis',
  },
  {
    id: '1407020003',
    districtId: '1407020',
    name: 'Kumain',
  },
  {
    id: '1407020004',
    districtId: '1407020',
    name: 'Bono Tapung',
  },
  {
    id: '1407020005',
    districtId: '1407020',
    name: 'Dayo',
  },
  {
    id: '1407020006',
    districtId: '1407020',
    name: 'Tapung Jaya',
  },
  {
    id: '1407020012',
    districtId: '1407020',
    name: 'Tandun',
  },
  {
    id: '1407020013',
    districtId: '1407020',
    name: 'Puo Raya',
  },
  {
    id: '1407020014',
    districtId: '1407020',
    name: 'Sungai Kuning',
  },
  {
    id: '1407020015',
    districtId: '1407020',
    name: 'Koto Tandun',
  },
  {
    id: '1407020016',
    districtId: '1407020',
    name: 'Tandun Barat',
  },
  {
    id: '1407021001',
    districtId: '1407021',
    name: 'Kabun',
  },
  {
    id: '1407021002',
    districtId: '1407021',
    name: 'Aliantan',
  },
  {
    id: '1407021003',
    districtId: '1407021',
    name: 'Koto Ranah',
  },
  {
    id: '1407021004',
    districtId: '1407021',
    name: 'Bencah Kesuma',
  },
  {
    id: '1407021005',
    districtId: '1407021',
    name: 'Batu Langkah Besar',
  },
  {
    id: '1407021006',
    districtId: '1407021',
    name: 'Giti',
  },
  {
    id: '1407022001',
    districtId: '1407022',
    name: 'Ujung Batu',
  },
  {
    id: '1407022002',
    districtId: '1407022',
    name: 'Ujung Batu Timur',
  },
  {
    id: '1407022003',
    districtId: '1407022',
    name: 'Ngaso',
  },
  {
    id: '1407022004',
    districtId: '1407022',
    name: 'Suka Damai',
  },
  {
    id: '1407022005',
    districtId: '1407022',
    name: 'Pematang Tebih',
  },
  {
    id: '1407030001',
    districtId: '1407030',
    name: 'Rambah Samo Barat',
  },
  {
    id: '1407030002',
    districtId: '1407030',
    name: 'Marga Mulya',
  },
  {
    id: '1407030003',
    districtId: '1407030',
    name: 'Rambah Samo',
  },
  {
    id: '1407030004',
    districtId: '1407030',
    name: 'Karya Mulya',
  },
  {
    id: '1407030005',
    districtId: '1407030',
    name: 'Rambah Baru',
  },
  {
    id: '1407030006',
    districtId: '1407030',
    name: 'Rambah Utama',
  },
  {
    id: '1407030007',
    districtId: '1407030',
    name: 'Pasir Makmur',
  },
  {
    id: '1407030008',
    districtId: '1407030',
    name: 'Masda Makmur',
  },
  {
    id: '1407030009',
    districtId: '1407030',
    name: 'Langkitin',
  },
  {
    id: '1407030010',
    districtId: '1407030',
    name: 'Lubuk Napal',
  },
  {
    id: '1407030011',
    districtId: '1407030',
    name: 'Sungai Salak',
  },
  {
    id: '1407030012',
    districtId: '1407030',
    name: 'Teluk Aur',
  },
  {
    id: '1407030013',
    districtId: '1407030',
    name: 'Lubuk Bilang',
  },
  {
    id: '1407030014',
    districtId: '1407030',
    name: 'Sungai Kuning',
  },
  {
    id: '1407040002',
    districtId: '1407040',
    name: 'Menaming',
  },
  {
    id: '1407040003',
    districtId: '1407040',
    name: 'Rambah Tengah Hulu',
  },
  {
    id: '1407040004',
    districtId: '1407040',
    name: 'Rambah Tengah Barat',
  },
  {
    id: '1407040005',
    districtId: '1407040',
    name: 'Pasir Pengaraian',
  },
  {
    id: '1407040006',
    districtId: '1407040',
    name: 'Rambah Tengah Utara',
  },
  {
    id: '1407040012',
    districtId: '1407040',
    name: 'Rambah Tengah Hilir',
  },
  {
    id: '1407040013',
    districtId: '1407040',
    name: 'Pasir Baru',
  },
  {
    id: '1407040014',
    districtId: '1407040',
    name: 'Tanjung Belit',
  },
  {
    id: '1407040015',
    districtId: '1407040',
    name: 'Sialang Jaya',
  },
  {
    id: '1407040016',
    districtId: '1407040',
    name: 'Koto Tinggi',
  },
  {
    id: '1407040017',
    districtId: '1407040',
    name: 'Suka Maju',
  },
  {
    id: '1407040018',
    districtId: '1407040',
    name: 'Pematang Berangan',
  },
  {
    id: '1407040019',
    districtId: '1407040',
    name: 'Babussalam',
  },
  {
    id: '1407040020',
    districtId: '1407040',
    name: 'Pasir Maju',
  },
  {
    id: '1407041004',
    districtId: '1407041',
    name: 'Pasir Jaya',
  },
  {
    id: '1407041005',
    districtId: '1407041',
    name: 'Pasir Utama',
  },
  {
    id: '1407041006',
    districtId: '1407041',
    name: 'Rambah Hilir',
  },
  {
    id: '1407041007',
    districtId: '1407041',
    name: 'Rambah Muda',
  },
  {
    id: '1407041008',
    districtId: '1407041',
    name: 'Sungai Sitolang',
  },
  {
    id: '1407041009',
    districtId: '1407041',
    name: 'Lubuk Krapat',
  },
  {
    id: '1407041010',
    districtId: '1407041',
    name: 'Rambah Hilir Tengah',
  },
  {
    id: '1407041011',
    districtId: '1407041',
    name: 'Rambah Hilir Timur',
  },
  {
    id: '1407041012',
    districtId: '1407041',
    name: 'Rambah',
  },
  {
    id: '1407041013',
    districtId: '1407041',
    name: 'Serombau Indah',
  },
  {
    id: '1407041014',
    districtId: '1407041',
    name: 'Sungai Dua Indah',
  },
  {
    id: '1407041015',
    districtId: '1407041',
    name: 'Muara Musu',
  },
  {
    id: '1407041016',
    districtId: '1407041',
    name: 'Sejati',
  },
  {
    id: '1407042001',
    districtId: '1407042',
    name: 'Bangun Purba',
  },
  {
    id: '1407042002',
    districtId: '1407042',
    name: 'Pasir Agung',
  },
  {
    id: '1407042003',
    districtId: '1407042',
    name: 'Pasir Intan',
  },
  {
    id: '1407042004',
    districtId: '1407042',
    name: 'Rambah Jaya',
  },
  {
    id: '1407042005',
    districtId: '1407042',
    name: 'Bangun Purba Timur Jaya',
  },
  {
    id: '1407042006',
    districtId: '1407042',
    name: 'Bangun Purba Barat',
  },
  {
    id: '1407042007',
    districtId: '1407042',
    name: 'Tangun',
  },
  {
    id: '1407050001',
    districtId: '1407050',
    name: 'Tambusai Barat',
  },
  {
    id: '1407050002',
    districtId: '1407050',
    name: 'Sungai Kumango',
  },
  {
    id: '1407050003',
    districtId: '1407050',
    name: 'Batas',
  },
  {
    id: '1407050004',
    districtId: '1407050',
    name: 'Tali Kumain',
  },
  {
    id: '1407050005',
    districtId: '1407050',
    name: 'Tambusai Tengah',
  },
  {
    id: '1407050006',
    districtId: '1407050',
    name: 'Rantau Panjang',
  },
  {
    id: '1407050007',
    districtId: '1407050',
    name: 'Sialang Rindang',
  },
  {
    id: '1407050008',
    districtId: '1407050',
    name: 'Tambusai Timur',
  },
  {
    id: '1407050009',
    districtId: '1407050',
    name: 'Sukamaju',
  },
  {
    id: '1407050015',
    districtId: '1407050',
    name: 'Batang Kumu',
  },
  {
    id: '1407050016',
    districtId: '1407050',
    name: 'Tingkok',
  },
  {
    id: '1407050017',
    districtId: '1407050',
    name: 'Lubuk Soting',
  },
  {
    id: '1407051001',
    districtId: '1407051',
    name: 'Suka Damai',
  },
  {
    id: '1407051002',
    districtId: '1407051',
    name: 'Mahato Sakti',
  },
  {
    id: '1407051003',
    districtId: '1407051',
    name: 'Rantau Sakti',
  },
  {
    id: '1407051004',
    districtId: '1407051',
    name: 'Payung Sekaki',
  },
  {
    id: '1407051005',
    districtId: '1407051',
    name: 'Pagar Mayang',
  },
  {
    id: '1407051006',
    districtId: '1407051',
    name: 'Simpang Harapan',
  },
  {
    id: '1407051007',
    districtId: '1407051',
    name: 'Mekar Jaya',
  },
  {
    id: '1407051008',
    districtId: '1407051',
    name: 'Bangun Jaya',
  },
  {
    id: '1407051009',
    districtId: '1407051',
    name: 'Tambusai Utara',
  },
  {
    id: '1407051010',
    districtId: '1407051',
    name: 'Tanjung Medan',
  },
  {
    id: '1407051011',
    districtId: '1407051',
    name: 'Mahato',
  },
  {
    id: '1407060004',
    districtId: '1407060',
    name: 'Kepenuhan Tengah',
  },
  {
    id: '1407060005',
    districtId: '1407060',
    name: 'Kepenuhan Barat',
  },
  {
    id: '1407060006',
    districtId: '1407060',
    name: 'Kepenuhan Raya',
  },
  {
    id: '1407060007',
    districtId: '1407060',
    name: 'Kepenuhan Baru',
  },
  {
    id: '1407060008',
    districtId: '1407060',
    name: 'UPT Sp III Koto Tengah/Kepenuhan Makmur',
  },
  {
    id: '1407060009',
    districtId: '1407060',
    name: 'Kepenuhan Timur',
  },
  {
    id: '1407060010',
    districtId: '1407060',
    name: 'Kepenuhan Hilir',
  },
  {
    id: '1407060011',
    districtId: '1407060',
    name: 'UPT Sp IV Koto Tengah/Kepenuhan Sejati',
  },
  {
    id: '1407060012',
    districtId: '1407060',
    name: 'Kepenuhan Sei Mandian',
  },
  {
    id: '1407060013',
    districtId: '1407060',
    name: 'Ulak Patian',
  },
  {
    id: '1407060016',
    districtId: '1407060',
    name: 'Rantau Binuang Sakti',
  },
  {
    id: '1407060017',
    districtId: '1407060',
    name: 'Kepenuhan Barat Mulya',
  },
  {
    id: '1407060018',
    districtId: '1407060',
    name: 'Kepenuhan Barat Sungai Rokan Jaya',
  },
  {
    id: '1407061001',
    districtId: '1407061',
    name: 'Kepenuhan Jaya',
  },
  {
    id: '1407061002',
    districtId: '1407061',
    name: 'Kepenuhan Hulu',
  },
  {
    id: '1407061003',
    districtId: '1407061',
    name: 'Muara Jaya',
  },
  {
    id: '1407061004',
    districtId: '1407061',
    name: 'Pekan Tebih',
  },
  {
    id: '1407061005',
    districtId: '1407061',
    name: 'Kepayang',
  },
  {
    id: '1407070002',
    districtId: '1407070',
    name: 'Kota Intan',
  },
  {
    id: '1407070003',
    districtId: '1407070',
    name: 'Kota Lama',
  },
  {
    id: '1407070006',
    districtId: '1407070',
    name: 'Bukit Intan Makmur',
  },
  {
    id: '1407070008',
    districtId: '1407070',
    name: 'Bagan Tujuh',
  },
  {
    id: '1407070011',
    districtId: '1407070',
    name: 'Kota Raya',
  },
  {
    id: '1407070012',
    districtId: '1407070',
    name: 'Kota Baru',
  },
  {
    id: '1407070013',
    districtId: '1407070',
    name: 'Sungai Kuti',
  },
  {
    id: '1407070014',
    districtId: '1407070',
    name: 'Pasir Indah',
  },
  {
    id: '1407070015',
    districtId: '1407070',
    name: 'Muara Dilam',
  },
  {
    id: '1407070016',
    districtId: '1407070',
    name: 'Pasir Luhur',
  },
  {
    id: '1407071001',
    districtId: '1407071',
    name: 'Pagaran Tapah',
  },
  {
    id: '1407071002',
    districtId: '1407071',
    name: 'Kembang Damai',
  },
  {
    id: '1407071005',
    districtId: '1407071',
    name: 'Sangkir Indah',
  },
  {
    id: '1407072001',
    districtId: '1407072',
    name: 'Teluk Sono',
  },
  {
    id: '1407072002',
    districtId: '1407072',
    name: 'Rawa Makmur',
  },
  {
    id: '1407072003',
    districtId: '1407072',
    name: 'Sontang',
  },
  {
    id: '1407072004',
    districtId: '1407072',
    name: 'Bonai',
  },
  {
    id: '1407072005',
    districtId: '1407072',
    name: 'Pauh',
  },
  {
    id: '1407072006',
    districtId: '1407072',
    name: 'Kasang Padang',
  },
  {
    id: '1407072007',
    districtId: '1407072',
    name: 'Kasang Mungkal',
  },
  {
    id: '1408010013',
    districtId: '1408010',
    name: 'Talang Mandi',
  },
  {
    id: '1408010014',
    districtId: '1408010',
    name: 'Harapan Baru',
  },
  {
    id: '1408010015',
    districtId: '1408010',
    name: 'Gajah Sakti',
  },
  {
    id: '1408010016',
    districtId: '1408010',
    name: 'Batang Serosa',
  },
  {
    id: '1408010017',
    districtId: '1408010',
    name: 'Balik Alam',
  },
  {
    id: '1408010018',
    districtId: '1408010',
    name: 'Duri Barat',
  },
  {
    id: '1408010019',
    districtId: '1408010',
    name: 'Duri Timur',
  },
  {
    id: '1408010020',
    districtId: '1408010',
    name: 'Babussalam',
  },
  {
    id: '1408010021',
    districtId: '1408010',
    name: 'Air Jamban',
  },
  {
    id: '1408010025',
    districtId: '1408010',
    name: 'Pematang Pudu',
  },
  {
    id: '1408010028',
    districtId: '1408010',
    name: 'Bathin Betuah',
  },
  {
    id: '1408011001',
    districtId: '1408011',
    name: 'Pinggir',
  },
  {
    id: '1408011002',
    districtId: '1408011',
    name: 'Semunai',
  },
  {
    id: '1408011003',
    districtId: '1408011',
    name: 'Tengganau',
  },
  {
    id: '1408011004',
    districtId: '1408011',
    name: 'Balai Pungut',
  },
  {
    id: '1408011005',
    districtId: '1408011',
    name: 'Muara Basung',
  },
  {
    id: '1408011011',
    districtId: '1408011',
    name: 'Titian Antui',
  },
  {
    id: '1408011012',
    districtId: '1408011',
    name: 'Balai Raja',
  },
  {
    id: '1408011014',
    districtId: '1408011',
    name: 'Sungai Meranti',
  },
  {
    id: '1408011015',
    districtId: '1408011',
    name: 'Pangkalan Libut',
  },
  {
    id: '1408011016',
    districtId: '1408011',
    name: 'Buluh Apo',
  },
  {
    id: '1408012001',
    districtId: '1408012',
    name: 'Buluh Manis',
  },
  {
    id: '1408012002',
    districtId: '1408012',
    name: 'Petani',
  },
  {
    id: '1408012003',
    districtId: '1408012',
    name: 'Tambusai Batang Dui',
  },
  {
    id: '1408012004',
    districtId: '1408012',
    name: 'Simpang Padang',
  },
  {
    id: '1408012005',
    districtId: '1408012',
    name: 'Pematang Obo',
  },
  {
    id: '1408012006',
    districtId: '1408012',
    name: 'Balai Makam',
  },
  {
    id: '1408012007',
    districtId: '1408012',
    name: 'Air Kulim',
  },
  {
    id: '1408012008',
    districtId: '1408012',
    name: 'Boncah Mahang',
  },
  {
    id: '1408012009',
    districtId: '1408012',
    name: 'Sebangar',
  },
  {
    id: '1408012010',
    districtId: '1408012',
    name: 'Pamesi',
  },
  {
    id: '1408012011',
    districtId: '1408012',
    name: 'Bumbung',
  },
  {
    id: '1408012012',
    districtId: '1408012',
    name: 'Kesumbo Ampai',
  },
  {
    id: '1408012013',
    districtId: '1408012',
    name: 'Bathin Sobanga',
  },
  {
    id: '1408013001',
    districtId: '1408013',
    name: 'Melibur',
  },
  {
    id: '1408013002',
    districtId: '1408013',
    name: 'Beringin',
  },
  {
    id: '1408013003',
    districtId: '1408013',
    name: 'Kuala Penaso',
  },
  {
    id: '1408013004',
    districtId: '1408013',
    name: 'Koto Pait Beringin',
  },
  {
    id: '1408013005',
    districtId: '1408013',
    name: 'Serai Wangi',
  },
  {
    id: '1408013006',
    districtId: '1408013',
    name: 'Tasik Tebing Serai',
  },
  {
    id: '1408013007',
    districtId: '1408013',
    name: 'Tasik Serai Timur',
  },
  {
    id: '1408013008',
    districtId: '1408013',
    name: 'Tasik Serai',
  },
  {
    id: '1408013009',
    districtId: '1408013',
    name: 'Tasik Serai Barat',
  },
  {
    id: '1408020005',
    districtId: '1408020',
    name: 'Pangkalan Jambi',
  },
  {
    id: '1408020014',
    districtId: '1408020',
    name: 'Dompas',
  },
  {
    id: '1408020015',
    districtId: '1408020',
    name: 'Sejangat',
  },
  {
    id: '1408020016',
    districtId: '1408020',
    name: 'Sungai Pakning',
  },
  {
    id: '1408020017',
    districtId: '1408020',
    name: 'Sungai Selari',
  },
  {
    id: '1408020018',
    districtId: '1408020',
    name: 'Buruk Bakul',
  },
  {
    id: '1408020019',
    districtId: '1408020',
    name: 'Bukit Batu',
  },
  {
    id: '1408020020',
    districtId: '1408020',
    name: 'Sukajadi',
  },
  {
    id: '1408020029',
    districtId: '1408020',
    name: 'Pakning Asal',
  },
  {
    id: '1408020030',
    districtId: '1408020',
    name: 'Batang Duku',
  },
  {
    id: '1408021001',
    districtId: '1408021',
    name: 'Langkat',
  },
  {
    id: '1408021002',
    districtId: '1408021',
    name: 'Sepotong',
  },
  {
    id: '1408021003',
    districtId: '1408021',
    name: 'Sungai Siput',
  },
  {
    id: '1408021004',
    districtId: '1408021',
    name: 'Lubuk Muda',
  },
  {
    id: '1408021005',
    districtId: '1408021',
    name: 'Lubuk Garam',
  },
  {
    id: '1408021006',
    districtId: '1408021',
    name: 'Tanjung Belit',
  },
  {
    id: '1408021007',
    districtId: '1408021',
    name: 'Lubuk Gaung',
  },
  {
    id: '1408021008',
    districtId: '1408021',
    name: 'Sadar Jaya',
  },
  {
    id: '1408021009',
    districtId: '1408021',
    name: 'Muara Dua',
  },
  {
    id: '1408021010',
    districtId: '1408021',
    name: 'Bandar Jaya',
  },
  {
    id: '1408021011',
    districtId: '1408021',
    name: 'Sungai Linau',
  },
  {
    id: '1408021012',
    districtId: '1408021',
    name: 'Tanjung Damai',
  },
  {
    id: '1408021013',
    districtId: '1408021',
    name: 'Sumber Jaya',
  },
  {
    id: '1408021014',
    districtId: '1408021',
    name: 'Sungai Nibung',
  },
  {
    id: '1408021015',
    districtId: '1408021',
    name: 'Koto Raja',
  },
  {
    id: '1408021016',
    districtId: '1408021',
    name: 'Liang Banir',
  },
  {
    id: '1408021017',
    districtId: '1408021',
    name: 'Tanjung Datuk',
  },
  {
    id: '1408022001',
    districtId: '1408022',
    name: 'Parit I Api Api',
  },
  {
    id: '1408022002',
    districtId: '1408022',
    name: 'Temiang',
  },
  {
    id: '1408022003',
    districtId: '1408022',
    name: 'Api Api',
  },
  {
    id: '1408022004',
    districtId: '1408022',
    name: 'Tenggayun',
  },
  {
    id: '1408022005',
    districtId: '1408022',
    name: 'Sepahat',
  },
  {
    id: '1408022006',
    districtId: '1408022',
    name: 'Bukit Kerikil',
  },
  {
    id: '1408022007',
    districtId: '1408022',
    name: 'Tanjung Leban',
  },
  {
    id: '1408030001',
    districtId: '1408030',
    name: 'Tanjung Kapal',
  },
  {
    id: '1408030002',
    districtId: '1408030',
    name: 'Batu Panjang',
  },
  {
    id: '1408030003',
    districtId: '1408030',
    name: 'Terkul',
  },
  {
    id: '1408030004',
    districtId: '1408030',
    name: 'Pergam',
  },
  {
    id: '1408030005',
    districtId: '1408030',
    name: 'Teluk Lecah',
  },
  {
    id: '1408030006',
    districtId: '1408030',
    name: 'Sei Cingam',
  },
  {
    id: '1408030007',
    districtId: '1408030',
    name: 'Pangkalan Nyirih',
  },
  {
    id: '1408030008',
    districtId: '1408030',
    name: 'Hutan Panjang',
  },
  {
    id: '1408030014',
    districtId: '1408030',
    name: 'Makeruh',
  },
  {
    id: '1408030015',
    districtId: '1408030',
    name: 'Sukarjo Mesim',
  },
  {
    id: '1408030016',
    districtId: '1408030',
    name: 'Parit Kebumen',
  },
  {
    id: '1408030017',
    districtId: '1408030',
    name: 'Darul Aman',
  },
  {
    id: '1408030018',
    districtId: '1408030',
    name: 'Sri Tanjung',
  },
  {
    id: '1408030019',
    districtId: '1408030',
    name: 'Pancur Jaya',
  },
  {
    id: '1408030020',
    districtId: '1408030',
    name: 'Pangkalan Pinang',
  },
  {
    id: '1408030021',
    districtId: '1408030',
    name: 'Dungun Baru',
  },
  {
    id: '1408031001',
    districtId: '1408031',
    name: 'Titi Akar',
  },
  {
    id: '1408031002',
    districtId: '1408031',
    name: 'Tanjung Medang',
  },
  {
    id: '1408031003',
    districtId: '1408031',
    name: 'Teluk Rhu',
  },
  {
    id: '1408031004',
    districtId: '1408031',
    name: 'Tanjung Punak',
  },
  {
    id: '1408031005',
    districtId: '1408031',
    name: 'Kadur',
  },
  {
    id: '1408031006',
    districtId: '1408031',
    name: 'Hutan Ayu',
  },
  {
    id: '1408031007',
    districtId: '1408031',
    name: 'Sukadamai',
  },
  {
    id: '1408031008',
    districtId: '1408031',
    name: 'Putri Sembilan',
  },
  {
    id: '1408040001',
    districtId: '1408040',
    name: 'Sekodi',
  },
  {
    id: '1408040002',
    districtId: '1408040',
    name: 'Kelemantan',
  },
  {
    id: '1408040003',
    districtId: '1408040',
    name: 'Ketam Putih',
  },
  {
    id: '1408040004',
    districtId: '1408040',
    name: 'Pematang Duku',
  },
  {
    id: '1408040005',
    districtId: '1408040',
    name: 'Penebal',
  },
  {
    id: '1408040006',
    districtId: '1408040',
    name: 'Temeran',
  },
  {
    id: '1408040007',
    districtId: '1408040',
    name: 'Penampi',
  },
  {
    id: '1408040008',
    districtId: '1408040',
    name: 'Sungai Alam',
  },
  {
    id: '1408040009',
    districtId: '1408040',
    name: 'Air Putih',
  },
  {
    id: '1408040010',
    districtId: '1408040',
    name: 'Senggoro',
  },
  {
    id: '1408040011',
    districtId: '1408040',
    name: 'Rimba Sekampung',
  },
  {
    id: '1408040012',
    districtId: '1408040',
    name: 'Bengkalis Kota',
  },
  {
    id: '1408040013',
    districtId: '1408040',
    name: 'Wonosari',
  },
  {
    id: '1408040014',
    districtId: '1408040',
    name: 'Damon',
  },
  {
    id: '1408040015',
    districtId: '1408040',
    name: 'Kelapa Pati',
  },
  {
    id: '1408040016',
    districtId: '1408040',
    name: 'Pedekik',
  },
  {
    id: '1408040017',
    districtId: '1408040',
    name: 'Pangkalan Batang',
  },
  {
    id: '1408040018',
    districtId: '1408040',
    name: 'Sebauk',
  },
  {
    id: '1408040019',
    districtId: '1408040',
    name: 'Teluk Latak',
  },
  {
    id: '1408040020',
    districtId: '1408040',
    name: 'Meskom',
  },
  {
    id: '1408040021',
    districtId: '1408040',
    name: 'Palkun',
  },
  {
    id: '1408040022',
    districtId: '1408040',
    name: 'Kelemantan Barat',
  },
  {
    id: '1408040023',
    districtId: '1408040',
    name: 'Sungai Batang',
  },
  {
    id: '1408040024',
    districtId: '1408040',
    name: 'Pematang Duku Timur',
  },
  {
    id: '1408040025',
    districtId: '1408040',
    name: 'Damai',
  },
  {
    id: '1408040026',
    districtId: '1408040',
    name: 'Kelebuk',
  },
  {
    id: '1408040027',
    districtId: '1408040',
    name: 'Kuala Alam',
  },
  {
    id: '1408040028',
    districtId: '1408040',
    name: 'Pangkalan Batang Barat',
  },
  {
    id: '1408040029',
    districtId: '1408040',
    name: 'Senderak',
  },
  {
    id: '1408040030',
    districtId: '1408040',
    name: 'Prapat Tunggal',
  },
  {
    id: '1408040031',
    districtId: '1408040',
    name: 'Simpang Ayam',
  },
  {
    id: '1408050001',
    districtId: '1408050',
    name: 'Teluk Lancar',
  },
  {
    id: '1408050002',
    districtId: '1408050',
    name: 'Kembung Luar',
  },
  {
    id: '1408050003',
    districtId: '1408050',
    name: 'Teluk Pambang',
  },
  {
    id: '1408050004',
    districtId: '1408050',
    name: 'Muntai',
  },
  {
    id: '1408050005',
    districtId: '1408050',
    name: 'Bantan Air',
  },
  {
    id: '1408050006',
    districtId: '1408050',
    name: 'Bantan Tengah',
  },
  {
    id: '1408050007',
    districtId: '1408050',
    name: 'Selat Baru',
  },
  {
    id: '1408050008',
    districtId: '1408050',
    name: 'Bantan Tua',
  },
  {
    id: '1408050009',
    districtId: '1408050',
    name: 'Jangkang',
  },
  {
    id: '1408050010',
    districtId: '1408050',
    name: 'Kembung Baru',
  },
  {
    id: '1408050011',
    districtId: '1408050',
    name: 'Pambang Pesisir',
  },
  {
    id: '1408050012',
    districtId: '1408050',
    name: 'Pambang Baru',
  },
  {
    id: '1408050013',
    districtId: '1408050',
    name: 'Suka Maju',
  },
  {
    id: '1408050014',
    districtId: '1408050',
    name: 'Muntai Barat',
  },
  {
    id: '1408050015',
    districtId: '1408050',
    name: 'Bantan Sari',
  },
  {
    id: '1408050016',
    districtId: '1408050',
    name: 'Bantan Timur',
  },
  {
    id: '1408050017',
    districtId: '1408050',
    name: 'Teluk Papal',
  },
  {
    id: '1408050018',
    districtId: '1408050',
    name: 'Ulu Pulau',
  },
  {
    id: '1408050019',
    districtId: '1408050',
    name: 'Mentayan',
  },
  {
    id: '1408050020',
    districtId: '1408050',
    name: 'Resam Lapis',
  },
  {
    id: '1408050021',
    districtId: '1408050',
    name: 'Berancah',
  },
  {
    id: '1408050022',
    districtId: '1408050',
    name: 'Pasiran',
  },
  {
    id: '1408050023',
    districtId: '1408050',
    name: 'Deluk',
  },
  {
    id: '1409010006',
    districtId: '1409010',
    name: 'Putat',
  },
  {
    id: '1409010009',
    districtId: '1409010',
    name: 'Sekeladi',
  },
  {
    id: '1409010010',
    districtId: '1409010',
    name: 'Sintong',
  },
  {
    id: '1409010011',
    districtId: '1409010',
    name: 'Teluk Mega',
  },
  {
    id: '1409010012',
    districtId: '1409010',
    name: 'Sedinginan',
  },
  {
    id: '1409010013',
    districtId: '1409010',
    name: 'Banjar XII',
  },
  {
    id: '1409010014',
    districtId: '1409010',
    name: 'Rantau Bais',
  },
  {
    id: '1409010015',
    districtId: '1409010',
    name: 'Ujung Tanjung',
  },
  {
    id: '1409010016',
    districtId: '1409010',
    name: 'Mumugo',
  },
  {
    id: '1409010017',
    districtId: '1409010',
    name: 'Teluk Berembun',
  },
  {
    id: '1409010018',
    districtId: '1409010',
    name: 'Menggala Sakti',
  },
  {
    id: '1409010019',
    districtId: '1409010',
    name: 'Menggala Sempurna',
  },
  {
    id: '1409010020',
    districtId: '1409010',
    name: 'Sekeladi Hilir',
  },
  {
    id: '1409010021',
    districtId: '1409010',
    name: 'Sintong Makmur',
  },
  {
    id: '1409010022',
    districtId: '1409010',
    name: 'Sintong Bakti',
  },
  {
    id: '1409010023',
    districtId: '1409010',
    name: 'Sintong Pusaka',
  },
  {
    id: '1409010024',
    districtId: '1409010',
    name: 'Menggala Teladan',
  },
  {
    id: '1409010025',
    districtId: '1409010',
    name: 'Cempedak Rahuk',
  },
  {
    id: '1409011002',
    districtId: '1409011',
    name: 'Pujud',
  },
  {
    id: '1409011003',
    districtId: '1409011',
    name: 'Teluk Nayang',
  },
  {
    id: '1409011004',
    districtId: '1409011',
    name: 'Air Hitam',
  },
  {
    id: '1409011005',
    districtId: '1409011',
    name: 'Siarang Arang',
  },
  {
    id: '1409011020',
    districtId: '1409011',
    name: 'Kasang Bangsawan',
  },
  {
    id: '1409011021',
    districtId: '1409011',
    name: 'Sungai Pinang',
  },
  {
    id: '1409011024',
    districtId: '1409011',
    name: 'Suka Jadi',
  },
  {
    id: '1409011034',
    districtId: '1409011',
    name: 'Perkebunan Siarangarang',
  },
  {
    id: '1409011035',
    districtId: '1409011',
    name: 'Babussalam Rokan',
  },
  {
    id: '1409011036',
    districtId: '1409011',
    name: 'Pujud Selatan',
  },
  {
    id: '1409011037',
    districtId: '1409011',
    name: 'Pujud Utara',
  },
  {
    id: '1409011038',
    districtId: '1409011',
    name: 'Pematang Genting',
  },
  {
    id: '1409011039',
    districtId: '1409011',
    name: 'Suka Mulya',
  },
  {
    id: '1409011040',
    districtId: '1409011',
    name: 'Siarang Arang Rokan',
  },
  {
    id: '1409011041',
    districtId: '1409011',
    name: 'Kasang Bangsawan Muda',
  },
  {
    id: '1409011042',
    districtId: '1409011',
    name: 'Ulak Kembahang',
  },
  {
    id: '1409012001',
    districtId: '1409012',
    name: 'Melayu Besar',
  },
  {
    id: '1409012002',
    districtId: '1409012',
    name: 'Melayu Tengah',
  },
  {
    id: '1409012003',
    districtId: '1409012',
    name: 'Batu Hampar',
  },
  {
    id: '1409012004',
    districtId: '1409012',
    name: 'Mesah',
  },
  {
    id: '1409012005',
    districtId: '1409012',
    name: 'Labuhan Papan',
  },
  {
    id: '1409012006',
    districtId: '1409012',
    name: 'Melayu Besar Kota',
  },
  {
    id: '1409013001',
    districtId: '1409013',
    name: 'Sekapas',
  },
  {
    id: '1409013002',
    districtId: '1409013',
    name: 'Bagan Cempedak',
  },
  {
    id: '1409013003',
    districtId: '1409013',
    name: 'Rantau Kopar',
  },
  {
    id: '1409013004',
    districtId: '1409013',
    name: 'Sungai Rangau',
  },
  {
    id: '1409014001',
    districtId: '1409014',
    name: 'Sei Meranti Darussalam',
  },
  {
    id: '1409014002',
    districtId: '1409014',
    name: 'Akar Belingkar',
  },
  {
    id: '1409014003',
    districtId: '1409014',
    name: 'Sei Meranti',
  },
  {
    id: '1409014004',
    districtId: '1409014',
    name: 'Sei Tapah',
  },
  {
    id: '1409014005',
    districtId: '1409014',
    name: 'Tanjung Medan',
  },
  {
    id: '1409014006',
    districtId: '1409014',
    name: 'Tangga Batu',
  },
  {
    id: '1409014007',
    districtId: '1409014',
    name: 'Tanjung Medan Barat',
  },
  {
    id: '1409014008',
    districtId: '1409014',
    name: 'Tanjung Sari',
  },
  {
    id: '1409014009',
    districtId: '1409014',
    name: 'Pondok Kresek',
  },
  {
    id: '1409014010',
    districtId: '1409014',
    name: 'Perkebunan Tanjung Medan',
  },
  {
    id: '1409014011',
    districtId: '1409014',
    name: 'Sri Kayangan',
  },
  {
    id: '1409014012',
    districtId: '1409014',
    name: 'Tanjung Medan Utara',
  },
  {
    id: '1409014013',
    districtId: '1409014',
    name: 'Bagan Nenas',
  },
  {
    id: '1409020001',
    districtId: '1409020',
    name: 'Bahtera Makmur',
  },
  {
    id: '1409020002',
    districtId: '1409020',
    name: 'Gelora',
  },
  {
    id: '1409020003',
    districtId: '1409020',
    name: 'Pelita',
  },
  {
    id: '1409020014',
    districtId: '1409020',
    name: 'Bagan Batu',
  },
  {
    id: '1409020015',
    districtId: '1409020',
    name: 'Suka Maju',
  },
  {
    id: '1409020016',
    districtId: '1409020',
    name: 'Bagan Manunggal',
  },
  {
    id: '1409020017',
    districtId: '1409020',
    name: 'Bagan Sapta Permai',
  },
  {
    id: '1409020018',
    districtId: '1409020',
    name: 'Bakti Makmur',
  },
  {
    id: '1409020021',
    districtId: '1409020',
    name: 'Jaya Agung',
  },
  {
    id: '1409020022',
    districtId: '1409020',
    name: 'Meranti Makmur',
  },
  {
    id: '1409020025',
    districtId: '1409020',
    name: 'Bayangkara Jaya',
  },
  {
    id: '1409020031',
    districtId: '1409020',
    name: 'Bahtera Makmur Kota',
  },
  {
    id: '1409020032',
    districtId: '1409020',
    name: 'Bagan Batu Kota',
  },
  {
    id: '1409020035',
    districtId: '1409020',
    name: 'Bagan Batu Barat',
  },
  {
    id: '1409020036',
    districtId: '1409020',
    name: 'Jadi Makmur',
  },
  {
    id: '1409020037',
    districtId: '1409020',
    name: 'Murini Makmur',
  },
  {
    id: '1409020038',
    districtId: '1409020',
    name: 'Bakti Jaya',
  },
  {
    id: '1409021001',
    districtId: '1409021',
    name: 'Simpang Kanan',
  },
  {
    id: '1409021002',
    districtId: '1409021',
    name: 'Kota Parit',
  },
  {
    id: '1409021003',
    districtId: '1409021',
    name: 'Bagan Nibung',
  },
  {
    id: '1409021004',
    districtId: '1409021',
    name: 'Bukit Damar',
  },
  {
    id: '1409021005',
    districtId: '1409021',
    name: 'Bukit Mas',
  },
  {
    id: '1409021006',
    districtId: '1409021',
    name: 'Bukit Selamat',
  },
  {
    id: '1409022001',
    districtId: '1409022',
    name: 'Bagan Sinembah Kota',
  },
  {
    id: '1409022002',
    districtId: '1409022',
    name: 'Harapan Makmur Selatan',
  },
  {
    id: '1409022003',
    districtId: '1409022',
    name: 'Harapan Makmur',
  },
  {
    id: '1409022004',
    districtId: '1409022',
    name: 'Bagan Sinembah',
  },
  {
    id: '1409022005',
    districtId: '1409022',
    name: 'Salak',
  },
  {
    id: '1409022006',
    districtId: '1409022',
    name: 'Panca Mukti',
  },
  {
    id: '1409022007',
    districtId: '1409022',
    name: 'Makmur Jaya',
  },
  {
    id: '1409022008',
    districtId: '1409022',
    name: 'Bagan Sinembah Barat',
  },
  {
    id: '1409022009',
    districtId: '1409022',
    name: 'Bagan Sinembah Timur',
  },
  {
    id: '1409022010',
    districtId: '1409022',
    name: 'Bagan Sinembah Utara',
  },
  {
    id: '1409022011',
    districtId: '1409022',
    name: 'Ampaian Rotan Makmur',
  },
  {
    id: '1409022012',
    districtId: '1409022',
    name: 'Suka Jadi Jaya',
  },
  {
    id: '1409022013',
    districtId: '1409022',
    name: 'Bagan Sinembah Jaya',
  },
  {
    id: '1409023001',
    districtId: '1409023',
    name: 'Pasir Putih',
  },
  {
    id: '1409023002',
    districtId: '1409023',
    name: 'Balai Jaya',
  },
  {
    id: '1409023003',
    districtId: '1409023',
    name: 'Balam Sempurna',
  },
  {
    id: '1409023004',
    districtId: '1409023',
    name: 'Balam Sempurna Kota',
  },
  {
    id: '1409023005',
    districtId: '1409023',
    name: 'Balam Jaya',
  },
  {
    id: '1409023006',
    districtId: '1409023',
    name: 'Balai Jaya Kota',
  },
  {
    id: '1409023007',
    districtId: '1409023',
    name: 'Pasir Putih Utara',
  },
  {
    id: '1409023008',
    districtId: '1409023',
    name: 'Kencana',
  },
  {
    id: '1409023009',
    districtId: '1409023',
    name: 'Bagan Bhakti',
  },
  {
    id: '1409023010',
    districtId: '1409023',
    name: 'Pasir Putih Barat',
  },
  {
    id: '1409023011',
    districtId: '1409023',
    name: 'Lubuk Jawi',
  },
  {
    id: '1409030007',
    districtId: '1409030',
    name: 'Teluk Merbau',
  },
  {
    id: '1409030008',
    districtId: '1409030',
    name: 'Rantau Panjang Kanan',
  },
  {
    id: '1409030009',
    districtId: '1409030',
    name: 'Sungai Kubu',
  },
  {
    id: '1409030010',
    districtId: '1409030',
    name: 'Tanjung Leban',
  },
  {
    id: '1409030011',
    districtId: '1409030',
    name: 'Sungai Sigajah',
  },
  {
    id: '1409030012',
    districtId: '1409030',
    name: 'Teluk Piyai',
  },
  {
    id: '1409030015',
    districtId: '1409030',
    name: 'Sei Segajah Makmur',
  },
  {
    id: '1409030016',
    districtId: '1409030',
    name: 'Sungai Kubu Hulu',
  },
  {
    id: '1409030017',
    districtId: '1409030',
    name: 'Teluk Piyai Pesisir',
  },
  {
    id: '1409030018',
    districtId: '1409030',
    name: 'Sungai Sigajah Jaya',
  },
  {
    id: '1409031001',
    districtId: '1409031',
    name: 'Sungai Daun',
  },
  {
    id: '1409031002',
    districtId: '1409031',
    name: 'Pasir Limau Kapas',
  },
  {
    id: '1409031003',
    districtId: '1409031',
    name: 'Panipahan',
  },
  {
    id: '1409031004',
    districtId: '1409031',
    name: 'Teluk Pulai',
  },
  {
    id: '1409031005',
    districtId: '1409031',
    name: 'Panipahan Laut',
  },
  {
    id: '1409031006',
    districtId: '1409031',
    name: 'Panipahan Darat',
  },
  {
    id: '1409031007',
    districtId: '1409031',
    name: 'Pulau Jemur',
  },
  {
    id: '1409031008',
    districtId: '1409031',
    name: 'Panipahan',
  },
  {
    id: '1409032001',
    districtId: '1409032',
    name: 'Teluk Nilap',
  },
  {
    id: '1409032002',
    districtId: '1409032',
    name: 'Sungai Majo',
  },
  {
    id: '1409032003',
    districtId: '1409032',
    name: 'Sungai Pinang',
  },
  {
    id: '1409032004',
    districtId: '1409032',
    name: 'Rantau Panjang Kiri',
  },
  {
    id: '1409032005',
    districtId: '1409032',
    name: 'Rantau Panjang Kiri Hilir',
  },
  {
    id: '1409032006',
    districtId: '1409032',
    name: 'Jojol',
  },
  {
    id: '1409032007',
    districtId: '1409032',
    name: 'Sungai Panji Panji',
  },
  {
    id: '1409032008',
    districtId: '1409032',
    name: 'Pulau Halang Belakang',
  },
  {
    id: '1409032009',
    districtId: '1409032',
    name: 'Pulau Halang Muka',
  },
  {
    id: '1409032010',
    districtId: '1409032',
    name: 'Sungai Majo Pusako',
  },
  {
    id: '1409032011',
    districtId: '1409032',
    name: 'Pulau Halang Hulu',
  },
  {
    id: '1409032012',
    districtId: '1409032',
    name: 'Teluk Nilap Jaya',
  },
  {
    id: '1409040008',
    districtId: '1409040',
    name: 'Labuhan Tangga Kecil',
  },
  {
    id: '1409040009',
    districtId: '1409040',
    name: 'Labuhan Tangga Besar',
  },
  {
    id: '1409040010',
    districtId: '1409040',
    name: 'Bagan Punak',
  },
  {
    id: '1409040013',
    districtId: '1409040',
    name: 'Bagan Hulu',
  },
  {
    id: '1409040014',
    districtId: '1409040',
    name: 'Bagan Timur',
  },
  {
    id: '1409040015',
    districtId: '1409040',
    name: 'Bagan Kota',
  },
  {
    id: '1409040016',
    districtId: '1409040',
    name: 'Bagan Barat',
  },
  {
    id: '1409040017',
    districtId: '1409040',
    name: 'Bagan Jawa',
  },
  {
    id: '1409040018',
    districtId: '1409040',
    name: 'Parit Aman',
  },
  {
    id: '1409040019',
    districtId: '1409040',
    name: 'Labuhan Tangga Baru',
  },
  {
    id: '1409040020',
    districtId: '1409040',
    name: 'Bagan Punak Pesisir',
  },
  {
    id: '1409040021',
    districtId: '1409040',
    name: 'Bagan Jawa Pesisir',
  },
  {
    id: '1409040022',
    districtId: '1409040',
    name: 'Bagan Punak Meranti',
  },
  {
    id: '1409040023',
    districtId: '1409040',
    name: 'Serusa',
  },
  {
    id: '1409040024',
    districtId: '1409040',
    name: 'Labuhan Tangga Hilir',
  },
  {
    id: '1409041001',
    districtId: '1409041',
    name: 'Raja Bejamu',
  },
  {
    id: '1409041002',
    districtId: '1409041',
    name: 'Sungai Bakau',
  },
  {
    id: '1409041003',
    districtId: '1409041',
    name: 'Sinaboi',
  },
  {
    id: '1409041004',
    districtId: '1409041',
    name: 'Sei Nyamuk',
  },
  {
    id: '1409041005',
    districtId: '1409041',
    name: 'Darussalam',
  },
  {
    id: '1409041006',
    districtId: '1409041',
    name: 'Sinaboi Kota',
  },
  {
    id: '1409042001',
    districtId: '1409042',
    name: 'Bantayan',
  },
  {
    id: '1409042002',
    districtId: '1409042',
    name: 'Bantayan Baru',
  },
  {
    id: '1409042003',
    districtId: '1409042',
    name: 'Bantayan Hilir',
  },
  {
    id: '1409042004',
    districtId: '1409042',
    name: 'Sungai Sialang Hulu',
  },
  {
    id: '1409042005',
    districtId: '1409042',
    name: 'Sungai Sialang',
  },
  {
    id: '1409043001',
    districtId: '1409043',
    name: 'Rokan Baru',
  },
  {
    id: '1409043002',
    districtId: '1409043',
    name: 'Teluk Bano II',
  },
  {
    id: '1409043003',
    districtId: '1409043',
    name: 'Suak Temenggung',
  },
  {
    id: '1409043006',
    districtId: '1409043',
    name: 'Pedamaran',
  },
  {
    id: '1409043007',
    districtId: '1409043',
    name: 'Suak Air Hitam',
  },
  {
    id: '1409043011',
    districtId: '1409043',
    name: 'Sungai Besar',
  },
  {
    id: '1409043012',
    districtId: '1409043',
    name: 'Pekaitan',
  },
  {
    id: '1409043025',
    districtId: '1409043',
    name: 'Kubu I',
  },
  {
    id: '1409043026',
    districtId: '1409043',
    name: 'Karya Mulyo Sari',
  },
  {
    id: '1409043027',
    districtId: '1409043',
    name: 'Rokan Baru Pesisir',
  },
  {
    id: '1409050005',
    districtId: '1409050',
    name: 'Karya Mukti',
  },
  {
    id: '1409050008',
    districtId: '1409050',
    name: 'Rimba Melintang',
  },
  {
    id: '1409050009',
    districtId: '1409050',
    name: 'Jumrah',
  },
  {
    id: '1409050010',
    districtId: '1409050',
    name: 'Teluk Pulau Hulu',
  },
  {
    id: '1409050011',
    districtId: '1409050',
    name: 'Teluk Pulau Hilir',
  },
  {
    id: '1409050012',
    districtId: '1409050',
    name: 'Lenggadai Hulu',
  },
  {
    id: '1409050013',
    districtId: '1409050',
    name: 'Mukti Jaya',
  },
  {
    id: '1409050017',
    districtId: '1409050',
    name: 'Lenggadai Hilir',
  },
  {
    id: '1409050018',
    districtId: '1409050',
    name: 'Pematang Botam',
  },
  {
    id: '1409050019',
    districtId: '1409050',
    name: 'Harapan Jaya',
  },
  {
    id: '1409050020',
    districtId: '1409050',
    name: 'Seremban Jaya',
  },
  {
    id: '1409050021',
    districtId: '1409050',
    name: 'Pematang Sikek',
  },
  {
    id: '1409051001',
    districtId: '1409051',
    name: 'Bangko Sempurna',
  },
  {
    id: '1409051002',
    districtId: '1409051',
    name: 'Bangko Bakti',
  },
  {
    id: '1409051003',
    districtId: '1409051',
    name: 'Bangko Jaya',
  },
  {
    id: '1409051004',
    districtId: '1409051',
    name: 'Bangko Pusaka',
  },
  {
    id: '1409051005',
    districtId: '1409051',
    name: 'Bangko Makmur',
  },
  {
    id: '1409051006',
    districtId: '1409051',
    name: 'Bangko Kiri',
  },
  {
    id: '1409051007',
    districtId: '1409051',
    name: 'Bangko Kanan',
  },
  {
    id: '1409051008',
    districtId: '1409051',
    name: 'Sungai Manasib',
  },
  {
    id: '1409051009',
    districtId: '1409051',
    name: 'Teluk Bano I',
  },
  {
    id: '1409051010',
    districtId: '1409051',
    name: 'Pematang Ibul',
  },
  {
    id: '1409051011',
    districtId: '1409051',
    name: 'Pematang Damar',
  },
  {
    id: '1409051012',
    districtId: '1409051',
    name: 'Bangko Permata',
  },
  {
    id: '1409051013',
    districtId: '1409051',
    name: 'Bangko Mukti',
  },
  {
    id: '1409051014',
    districtId: '1409051',
    name: 'Bangko Lestari',
  },
  {
    id: '1409051015',
    districtId: '1409051',
    name: 'Bangko Balam',
  },
  {
    id: '1409051016',
    districtId: '1409051',
    name: 'Bangko Masraya',
  },
  {
    id: '1410010001',
    districtId: '1410010',
    name: 'Tanjung Peranap',
  },
  {
    id: '1410010002',
    districtId: '1410010',
    name: 'Tanjung',
  },
  {
    id: '1410010003',
    districtId: '1410010',
    name: 'Insit',
  },
  {
    id: '1410010004',
    districtId: '1410010',
    name: 'Tenan',
  },
  {
    id: '1410010005',
    districtId: '1410010',
    name: 'Kundur',
  },
  {
    id: '1410010006',
    districtId: '1410010',
    name: 'Batang Malas',
  },
  {
    id: '1410010007',
    districtId: '1410010',
    name: 'Alai',
  },
  {
    id: '1410010008',
    districtId: '1410010',
    name: 'Mekong',
  },
  {
    id: '1410010009',
    districtId: '1410010',
    name: 'Mantiasa',
  },
  {
    id: '1410010010',
    districtId: '1410010',
    name: 'Gogok Darussalam',
  },
  {
    id: '1410010011',
    districtId: '1410010',
    name: 'Maini Darul Aman',
  },
  {
    id: '1410010012',
    districtId: '1410010',
    name: 'Mengkikip',
  },
  {
    id: '1410010013',
    districtId: '1410010',
    name: 'Alai Selatan',
  },
  {
    id: '1410010014',
    districtId: '1410010',
    name: 'Tanjung Darul Takzim',
  },
  {
    id: '1410020008',
    districtId: '1410020',
    name: 'Sesap',
  },
  {
    id: '1410020009',
    districtId: '1410020',
    name: 'Banglas Barat',
  },
  {
    id: '1410020010',
    districtId: '1410020',
    name: 'Banglas',
  },
  {
    id: '1410020011',
    districtId: '1410020',
    name: 'Selat Panjang Timur',
  },
  {
    id: '1410020012',
    districtId: '1410020',
    name: 'Selat Panjang Selatan',
  },
  {
    id: '1410020013',
    districtId: '1410020',
    name: 'Alah Air',
  },
  {
    id: '1410020014',
    districtId: '1410020',
    name: 'Alah Air Timur',
  },
  {
    id: '1410020015',
    districtId: '1410020',
    name: 'Selat Panjang Barat',
  },
  {
    id: '1410020016',
    districtId: '1410020',
    name: 'Selat Panjang Kota',
  },
  {
    id: '1410021001',
    districtId: '1410021',
    name: 'Kepau Baru',
  },
  {
    id: '1410021002',
    districtId: '1410021',
    name: 'Teluk Buntal',
  },
  {
    id: '1410021003',
    districtId: '1410021',
    name: 'Tanjung Gadai',
  },
  {
    id: '1410021004',
    districtId: '1410021',
    name: 'Tanjung Sari',
  },
  {
    id: '1410021005',
    districtId: '1410021',
    name: 'Nipah Sendanu',
  },
  {
    id: '1410021006',
    districtId: '1410021',
    name: 'Sungai Tohor',
  },
  {
    id: '1410021007',
    districtId: '1410021',
    name: 'Lukun',
  },
  {
    id: '1410021008',
    districtId: '1410021',
    name: 'Sungai Tohor Barat',
  },
  {
    id: '1410021009',
    districtId: '1410021',
    name: 'Sendanu Darul Ihsan',
  },
  {
    id: '1410021010',
    districtId: '1410021',
    name: 'Batin Suir',
  },
  {
    id: '1410030005',
    districtId: '1410030',
    name: 'Repan',
  },
  {
    id: '1410030006',
    districtId: '1410030',
    name: 'Penyagun',
  },
  {
    id: '1410030007',
    districtId: '1410030',
    name: 'Gemala Sari',
  },
  {
    id: '1410030008',
    districtId: '1410030',
    name: 'Sungai Gayung Kiri',
  },
  {
    id: '1410030009',
    districtId: '1410030',
    name: 'Tanjung Medang',
  },
  {
    id: '1410030010',
    districtId: '1410030',
    name: 'Teluk Samak',
  },
  {
    id: '1410030011',
    districtId: '1410030',
    name: 'Tanjung Samak',
  },
  {
    id: '1410030012',
    districtId: '1410030',
    name: 'Tanjung Bakau',
  },
  {
    id: '1410030013',
    districtId: '1410030',
    name: 'Topang',
  },
  {
    id: '1410030014',
    districtId: '1410030',
    name: 'Citra Damai',
  },
  {
    id: '1410030016',
    districtId: '1410030',
    name: 'Dwi Tunggal',
  },
  {
    id: '1410030017',
    districtId: '1410030',
    name: 'Wonosari',
  },
  {
    id: '1410030018',
    districtId: '1410030',
    name: 'Tebun',
  },
  {
    id: '1410030020',
    districtId: '1410030',
    name: 'Tanjung Gemuk',
  },
  {
    id: '1410031001',
    districtId: '1410031',
    name: 'Beting',
  },
  {
    id: '1410031002',
    districtId: '1410031',
    name: 'Sokop',
  },
  {
    id: '1410031003',
    districtId: '1410031',
    name: 'Bungur',
  },
  {
    id: '1410031004',
    districtId: '1410031',
    name: 'Tanjung Kedabu',
  },
  {
    id: '1410031005',
    districtId: '1410031',
    name: 'Telesung',
  },
  {
    id: '1410031006',
    districtId: '1410031',
    name: 'Tenggayun Raya',
  },
  {
    id: '1410031007',
    districtId: '1410031',
    name: 'Sonde',
  },
  {
    id: '1410031008',
    districtId: '1410031',
    name: 'Kayu Ara',
  },
  {
    id: '1410031009',
    districtId: '1410031',
    name: 'Tanah Merah',
  },
  {
    id: '1410031010',
    districtId: '1410031',
    name: 'Kedabu Rapat',
  },
  {
    id: '1410031011',
    districtId: '1410031',
    name: 'Sendaur',
  },
  {
    id: '1410040001',
    districtId: '1410040',
    name: 'Bantar',
  },
  {
    id: '1410040002',
    districtId: '1410040',
    name: 'Anak Setatah',
  },
  {
    id: '1410040003',
    districtId: '1410040',
    name: 'Segomeng',
  },
  {
    id: '1410040004',
    districtId: '1410040',
    name: 'Sialang Pasung',
  },
  {
    id: '1410040005',
    districtId: '1410040',
    name: 'Lemang',
  },
  {
    id: '1410040006',
    districtId: '1410040',
    name: 'Sungai Cina',
  },
  {
    id: '1410040007',
    districtId: '1410040',
    name: 'Bina Maju',
  },
  {
    id: '1410040008',
    districtId: '1410040',
    name: 'Telaga Baru',
  },
  {
    id: '1410040009',
    districtId: '1410040',
    name: 'Bokor',
  },
  {
    id: '1410040015',
    districtId: '1410040',
    name: 'Melai',
  },
  {
    id: '1410040016',
    districtId: '1410040',
    name: 'Permai',
  },
  {
    id: '1410040017',
    districtId: '1410040',
    name: 'Mekar Baru',
  },
  {
    id: '1410050001',
    districtId: '1410050',
    name: 'Lukit',
  },
  {
    id: '1410050002',
    districtId: '1410050',
    name: 'Meranti Bunting',
  },
  {
    id: '1410050003',
    districtId: '1410050',
    name: 'Tanjung Kulim',
  },
  {
    id: '1410050004',
    districtId: '1410050',
    name: 'Pelantai',
  },
  {
    id: '1410050005',
    districtId: '1410050',
    name: 'Mekar Sari',
  },
  {
    id: '1410050006',
    districtId: '1410050',
    name: 'Teluk Belitung',
  },
  {
    id: '1410050007',
    districtId: '1410050',
    name: 'Bagan Melibur',
  },
  {
    id: '1410050016',
    districtId: '1410050',
    name: 'Mayang Sari',
  },
  {
    id: '1410050019',
    districtId: '1410050',
    name: 'Sungai Anak Kamal',
  },
  {
    id: '1410050020',
    districtId: '1410050',
    name: 'Sungai Tengah',
  },
  {
    id: '1410051001',
    districtId: '1410051',
    name: 'Teluk Ketapang',
  },
  {
    id: '1410051002',
    districtId: '1410051',
    name: 'Semukut',
  },
  {
    id: '1410051003',
    districtId: '1410051',
    name: 'Centai',
  },
  {
    id: '1410051004',
    districtId: '1410051',
    name: 'Tanjung Bunga',
  },
  {
    id: '1410051005',
    districtId: '1410051',
    name: 'Renak Dungun',
  },
  {
    id: '1410051006',
    districtId: '1410051',
    name: 'Baran Melintang',
  },
  {
    id: '1410051007',
    districtId: '1410051',
    name: 'Kuala Merbau',
  },
  {
    id: '1410051008',
    districtId: '1410051',
    name: 'Batang Meranti',
  },
  {
    id: '1410051009',
    districtId: '1410051',
    name: 'Pangkalan Balai',
  },
  {
    id: '1410051010',
    districtId: '1410051',
    name: 'Padang Kamal',
  },
  {
    id: '1410051011',
    districtId: '1410051',
    name: 'Ketapang Permai',
  },
  {
    id: '1410052001',
    districtId: '1410052',
    name: 'Mengkirau',
  },
  {
    id: '1410052002',
    districtId: '1410052',
    name: 'Mengkopot',
  },
  {
    id: '1410052003',
    districtId: '1410052',
    name: 'Tanjung Pisang',
  },
  {
    id: '1410052004',
    districtId: '1410052',
    name: 'Selat Akar',
  },
  {
    id: '1410052005',
    districtId: '1410052',
    name: 'Bandul',
  },
  {
    id: '1410052006',
    districtId: '1410052',
    name: 'Kudap',
  },
  {
    id: '1410052007',
    districtId: '1410052',
    name: 'Dedap',
  },
  {
    id: '1410052008',
    districtId: '1410052',
    name: 'Mekar Delima',
  },
  {
    id: '1410052009',
    districtId: '1410052',
    name: 'Putri Puyu',
  },
  {
    id: '1410052010',
    districtId: '1410052',
    name: 'Tanjung Padang',
  },
  {
    id: '1471010001',
    districtId: '1471010',
    name: 'Simpang Baru',
  },
  {
    id: '1471010005',
    districtId: '1471010',
    name: 'Sidomulyo Barat',
  },
  {
    id: '1471010007',
    districtId: '1471010',
    name: 'Tuah Karya',
  },
  {
    id: '1471010008',
    districtId: '1471010',
    name: 'Delima',
  },
  {
    id: '1471010009',
    districtId: '1471010',
    name: 'Tuah Madani',
  },
  {
    id: '1471010010',
    districtId: '1471010',
    name: 'Sialang Munggu',
  },
  {
    id: '1471010011',
    districtId: '1471010',
    name: 'Tobek Godang',
  },
  {
    id: '1471010012',
    districtId: '1471010',
    name: 'Bina Widya',
  },
  {
    id: '1471010013',
    districtId: '1471010',
    name: 'Air Putih',
  },
  {
    id: '1471011001',
    districtId: '1471011',
    name: 'Labuh Baru Timur',
  },
  {
    id: '1471011002',
    districtId: '1471011',
    name: 'Tampan',
  },
  {
    id: '1471011003',
    districtId: '1471011',
    name: 'Air Hitam',
  },
  {
    id: '1471011004',
    districtId: '1471011',
    name: 'Labuh Baru Barat',
  },
  {
    id: '1471011005',
    districtId: '1471011',
    name: 'Bandar Raya',
  },
  {
    id: '1471011006',
    districtId: '1471011',
    name: 'Sungai Sibam',
  },
  {
    id: '1471011007',
    districtId: '1471011',
    name: 'Tirta Siak',
  },
  {
    id: '1471020001',
    districtId: '1471020',
    name: 'Simpang Tiga',
  },
  {
    id: '1471020004',
    districtId: '1471020',
    name: 'Tengkerang Selatan',
  },
  {
    id: '1471020007',
    districtId: '1471020',
    name: 'Tengkerang Utara',
  },
  {
    id: '1471020011',
    districtId: '1471020',
    name: 'Tengkerang Labuai',
  },
  {
    id: '1471020012',
    districtId: '1471020',
    name: 'Air Dingin',
  },
  {
    id: '1471021001',
    districtId: '1471021',
    name: 'Tengkerang Tengah',
  },
  {
    id: '1471021002',
    districtId: '1471021',
    name: 'Tengkerang Barat',
  },
  {
    id: '1471021003',
    districtId: '1471021',
    name: 'Maharatu',
  },
  {
    id: '1471021004',
    districtId: '1471021',
    name: 'Sidomulyo Timur',
  },
  {
    id: '1471021005',
    districtId: '1471021',
    name: 'Wonorejo',
  },
  {
    id: '1471021006',
    districtId: '1471021',
    name: 'Perhentian Marpoyan',
  },
  {
    id: '1471022001',
    districtId: '1471022',
    name: 'Kulim',
  },
  {
    id: '1471022002',
    districtId: '1471022',
    name: 'Tengkerang Timur',
  },
  {
    id: '1471022003',
    districtId: '1471022',
    name: 'Rejosari',
  },
  {
    id: '1471022004',
    districtId: '1471022',
    name: 'Sail',
  },
  {
    id: '1471022005',
    districtId: '1471022',
    name: 'Sialang Rampai',
  },
  {
    id: '1471022006',
    districtId: '1471022',
    name: 'Pebatuan',
  },
  {
    id: '1471022007',
    districtId: '1471022',
    name: 'Mentangor',
  },
  {
    id: '1471022008',
    districtId: '1471022',
    name: 'Pematang Kapau',
  },
  {
    id: '1471022009',
    districtId: '1471022',
    name: 'Sialang Sakti',
  },
  {
    id: '1471022010',
    districtId: '1471022',
    name: 'Tuah Negeri',
  },
  {
    id: '1471022011',
    districtId: '1471022',
    name: 'Melebung',
  },
  {
    id: '1471022012',
    districtId: '1471022',
    name: 'Industri Tenayan',
  },
  {
    id: '1471022013',
    districtId: '1471022',
    name: 'Bambu Kuning',
  },
  {
    id: '1471030001',
    districtId: '1471030',
    name: 'Rintis',
  },
  {
    id: '1471030002',
    districtId: '1471030',
    name: 'Sekip',
  },
  {
    id: '1471030003',
    districtId: '1471030',
    name: 'Tanjung Rhu',
  },
  {
    id: '1471030004',
    districtId: '1471030',
    name: 'Pesisir',
  },
  {
    id: '1471040001',
    districtId: '1471040',
    name: 'Cinta Raja',
  },
  {
    id: '1471040002',
    districtId: '1471040',
    name: 'Suka Maju',
  },
  {
    id: '1471040003',
    districtId: '1471040',
    name: 'Suka Mulia',
  },
  {
    id: '1471050001',
    districtId: '1471050',
    name: 'Simpang Empat',
  },
  {
    id: '1471050002',
    districtId: '1471050',
    name: 'Sumahilang',
  },
  {
    id: '1471050003',
    districtId: '1471050',
    name: 'Tanah Datar',
  },
  {
    id: '1471050004',
    districtId: '1471050',
    name: 'Kota Baru',
  },
  {
    id: '1471050005',
    districtId: '1471050',
    name: 'Sukaramai',
  },
  {
    id: '1471050006',
    districtId: '1471050',
    name: 'Kota Tinggi',
  },
  {
    id: '1471060002',
    districtId: '1471060',
    name: 'Jadirejo',
  },
  {
    id: '1471060003',
    districtId: '1471060',
    name: 'Kampung Tengah',
  },
  {
    id: '1471060004',
    districtId: '1471060',
    name: 'Kampung Melayu',
  },
  {
    id: '1471060005',
    districtId: '1471060',
    name: 'Kedungsari',
  },
  {
    id: '1471060006',
    districtId: '1471060',
    name: 'Harjosari',
  },
  {
    id: '1471060007',
    districtId: '1471060',
    name: 'Sukajadi',
  },
  {
    id: '1471060008',
    districtId: '1471060',
    name: 'Pulau Karam',
  },
  {
    id: '1471070001',
    districtId: '1471070',
    name: 'Padang Bulan',
  },
  {
    id: '1471070002',
    districtId: '1471070',
    name: 'Padang Terubuk',
  },
  {
    id: '1471070003',
    districtId: '1471070',
    name: 'Sago',
  },
  {
    id: '1471070004',
    districtId: '1471070',
    name: 'Kampung Dalam',
  },
  {
    id: '1471070005',
    districtId: '1471070',
    name: 'Kampung Bandar',
  },
  {
    id: '1471070006',
    districtId: '1471070',
    name: 'Kampung Baru',
  },
  {
    id: '1471080001',
    districtId: '1471080',
    name: 'Umban Sari',
  },
  {
    id: '1471080006',
    districtId: '1471080',
    name: 'Rumbai Bukit',
  },
  {
    id: '1471080007',
    districtId: '1471080',
    name: 'Muara Fajar',
  },
  {
    id: '1471080008',
    districtId: '1471080',
    name: 'Palas',
  },
  {
    id: '1471080009',
    districtId: '1471080',
    name: 'Sri Meranti',
  },
  {
    id: '1471080010',
    districtId: '1471080',
    name: 'Agrowisata',
  },
  {
    id: '1471080011',
    districtId: '1471080',
    name: 'Maharani',
  },
  {
    id: '1471080012',
    districtId: '1471080',
    name: 'Rantau Panjang',
  },
  {
    id: '1471080013',
    districtId: '1471080',
    name: 'Muara Fajar Barat',
  },
  {
    id: '1471081001',
    districtId: '1471081',
    name: 'Meranti Pandak',
  },
  {
    id: '1471081002',
    districtId: '1471081',
    name: 'Limbungan',
  },
  {
    id: '1471081003',
    districtId: '1471081',
    name: 'Lembah Sari',
  },
  {
    id: '1471081004',
    districtId: '1471081',
    name: 'Lembah Damai',
  },
  {
    id: '1471081005',
    districtId: '1471081',
    name: 'Limbungan Baru',
  },
  {
    id: '1471081006',
    districtId: '1471081',
    name: 'Tebing Tinggi Okura',
  },
  {
    id: '1471081007',
    districtId: '1471081',
    name: 'Sungai Ambang',
  },
  {
    id: '1471081008',
    districtId: '1471081',
    name: 'Sungai Ukai',
  },
  {
    id: '1473010001',
    districtId: '1473010',
    name: 'Bukit Nenas',
  },
  {
    id: '1473010006',
    districtId: '1473010',
    name: 'Bagan Besar',
  },
  {
    id: '1473010007',
    districtId: '1473010',
    name: 'Bukit Kayu Kapur',
  },
  {
    id: '1473010008',
    districtId: '1473010',
    name: 'Gurun Panjang',
  },
  {
    id: '1473010009',
    districtId: '1473010',
    name: 'Kampung Baru',
  },
  {
    id: '1473011001',
    districtId: '1473011',
    name: 'Pelintung',
  },
  {
    id: '1473011002',
    districtId: '1473011',
    name: 'Guntung',
  },
  {
    id: '1473011003',
    districtId: '1473011',
    name: 'Teluk Makmur',
  },
  {
    id: '1473011004',
    districtId: '1473011',
    name: 'Mundam',
  },
  {
    id: '1473012001',
    districtId: '1473012',
    name: 'Bangsal Aceh',
  },
  {
    id: '1473012002',
    districtId: '1473012',
    name: 'Lubuk Gaung',
  },
  {
    id: '1473012003',
    districtId: '1473012',
    name: 'Basilam Baru',
  },
  {
    id: '1473012004',
    districtId: '1473012',
    name: 'Batu Teritip',
  },
  {
    id: '1473012005',
    districtId: '1473012',
    name: 'Tanjung Penyembal',
  },
  {
    id: '1473020005',
    districtId: '1473020',
    name: 'Pangkalan Sesai',
  },
  {
    id: '1473020006',
    districtId: '1473020',
    name: 'Purnama',
  },
  {
    id: '1473020009',
    districtId: '1473020',
    name: 'Simpang Tetap Darul Ihsan',
  },
  {
    id: '1473020010',
    districtId: '1473020',
    name: 'Bagan Keladi',
  },
  {
    id: '1473021001',
    districtId: '1473021',
    name: 'Mekar Sari',
  },
  {
    id: '1473021002',
    districtId: '1473021',
    name: 'Bukit Timah',
  },
  {
    id: '1473021003',
    districtId: '1473021',
    name: 'Bumi Ayu',
  },
  {
    id: '1473021004',
    districtId: '1473021',
    name: 'Bukit Datuk',
  },
  {
    id: '1473021005',
    districtId: '1473021',
    name: 'Ratu Sima',
  },
  {
    id: '1473030001',
    districtId: '1473030',
    name: 'Tanjung Palas',
  },
  {
    id: '1473030002',
    districtId: '1473030',
    name: 'Jaya Mukti',
  },
  {
    id: '1473030003',
    districtId: '1473030',
    name: 'Teluk Binjai',
  },
  {
    id: '1473030006',
    districtId: '1473030',
    name: 'Buluh Kasap',
  },
  {
    id: '1473030007',
    districtId: '1473030',
    name: 'Bukit Batrem',
  },
  {
    id: '1473031001',
    districtId: '1473031',
    name: 'Rimba Sekampung',
  },
  {
    id: '1473031002',
    districtId: '1473031',
    name: 'Sukajadi',
  },
  {
    id: '1473031003',
    districtId: '1473031',
    name: 'Bintan',
  },
  {
    id: '1473031004',
    districtId: '1473031',
    name: 'Dumai Kota',
  },
  {
    id: '1473031005',
    districtId: '1473031',
    name: 'Laksamana',
  },
  {
    id: '1501010001',
    districtId: '1501010',
    name: 'Lempur Mudik',
  },
  {
    id: '1501010002',
    districtId: '1501010',
    name: 'Dusun Baru Lempur',
  },
  {
    id: '1501010003',
    districtId: '1501010',
    name: 'Lempur Tengah',
  },
  {
    id: '1501010004',
    districtId: '1501010',
    name: 'Lempur Hilir',
  },
  {
    id: '1501010005',
    districtId: '1501010',
    name: 'Perikan Tengah',
  },
  {
    id: '1501010006',
    districtId: '1501010',
    name: 'Selampaung',
  },
  {
    id: '1501010007',
    districtId: '1501010',
    name: 'Masgo',
  },
  {
    id: '1501010008',
    districtId: '1501010',
    name: 'Air Mumu',
  },
  {
    id: '1501010009',
    districtId: '1501010',
    name: 'Kebun Baru',
  },
  {
    id: '1501010010',
    districtId: '1501010',
    name: 'Sungai Hangat',
  },
  {
    id: '1501010017',
    districtId: '1501010',
    name: 'Manjunto Lempur',
  },
  {
    id: '1501010018',
    districtId: '1501010',
    name: 'Kebun Lima',
  },
  {
    id: '1501011001',
    districtId: '1501011',
    name: 'Pasar Kerman',
  },
  {
    id: '1501011002',
    districtId: '1501011',
    name: 'Lolo Hilir',
  },
  {
    id: '1501011003',
    districtId: '1501011',
    name: 'Lolo Gedang',
  },
  {
    id: '1501011004',
    districtId: '1501011',
    name: 'Lolo Kecil',
  },
  {
    id: '1501011005',
    districtId: '1501011',
    name: 'Talang Kemuning',
  },
  {
    id: '1501011006',
    districtId: '1501011',
    name: 'Tanjung Syam',
  },
  {
    id: '1501011007',
    districtId: '1501011',
    name: 'Bintang Marak',
  },
  {
    id: '1501011008',
    districtId: '1501011',
    name: 'Pulau Sangkar',
  },
  {
    id: '1501011009',
    districtId: '1501011',
    name: 'Pondok',
  },
  {
    id: '1501011010',
    districtId: '1501011',
    name: 'Muak',
  },
  {
    id: '1501011011',
    districtId: '1501011',
    name: 'Pulau Pandan',
  },
  {
    id: '1501011012',
    districtId: '1501011',
    name: 'Pengasi Lama',
  },
  {
    id: '1501011013',
    districtId: '1501011',
    name: 'Karang Pandan',
  },
  {
    id: '1501011014',
    districtId: '1501011',
    name: 'Pengasi Baru',
  },
  {
    id: '1501011015',
    districtId: '1501011',
    name: 'Muaro Lulo',
  },
  {
    id: '1501020001',
    districtId: '1501020',
    name: 'Muara Hemat',
  },
  {
    id: '1501020002',
    districtId: '1501020',
    name: 'Batang Merangin',
  },
  {
    id: '1501020003',
    districtId: '1501020',
    name: 'Pematang Lingkung',
  },
  {
    id: '1501020004',
    districtId: '1501020',
    name: 'Tamiai',
  },
  {
    id: '1501020005',
    districtId: '1501020',
    name: 'Pasar Tamiai',
  },
  {
    id: '1501020006',
    districtId: '1501020',
    name: 'Lubuk Paku',
  },
  {
    id: '1501020007',
    districtId: '1501020',
    name: 'Seberang Merangin',
  },
  {
    id: '1501020009',
    districtId: '1501020',
    name: 'Dusun Baru Pulau Sangkar',
  },
  {
    id: '1501020010',
    districtId: '1501020',
    name: 'Tarutung',
  },
  {
    id: '1501030001',
    districtId: '1501030',
    name: 'Tanjung Batu',
  },
  {
    id: '1501030002',
    districtId: '1501030',
    name: 'Pidung',
  },
  {
    id: '1501030003',
    districtId: '1501030',
    name: 'Keluru',
  },
  {
    id: '1501030004',
    districtId: '1501030',
    name: 'Talang Lindung',
  },
  {
    id: '1501030005',
    districtId: '1501030',
    name: 'Koto Agung',
  },
  {
    id: '1501030006',
    districtId: '1501030',
    name: 'Jujun',
  },
  {
    id: '1501030007',
    districtId: '1501030',
    name: 'Benik',
  },
  {
    id: '1501030008',
    districtId: '1501030',
    name: 'Koto Dian',
  },
  {
    id: '1501030009',
    districtId: '1501030',
    name: 'Telago',
  },
  {
    id: '1501030010',
    districtId: '1501030',
    name: 'Koto Tuo Pulo Tengah',
  },
  {
    id: '1501030011',
    districtId: '1501030',
    name: 'Dusun Baru Pulau Tengah',
  },
  {
    id: '1501030012',
    districtId: '1501030',
    name: 'Lempur Danau',
  },
  {
    id: '1501030013',
    districtId: '1501030',
    name: 'Koto Patah',
  },
  {
    id: '1501030014',
    districtId: '1501030',
    name: 'Semerap',
  },
  {
    id: '1501030015',
    districtId: '1501030',
    name: 'Koto Baru Semerap',
  },
  {
    id: '1501030016',
    districtId: '1501030',
    name: 'Pondok Siguang',
  },
  {
    id: '1501030017',
    districtId: '1501030',
    name: 'Tanjung Pauh Hilir',
  },
  {
    id: '1501030018',
    districtId: '1501030',
    name: 'Punai Merindu',
  },
  {
    id: '1501030019',
    districtId: '1501030',
    name: 'Tanjung Pauh Mudik',
  },
  {
    id: '1501030020',
    districtId: '1501030',
    name: 'Pancuran Tiga',
  },
  {
    id: '1501030021',
    districtId: '1501030',
    name: 'Koto Baru',
  },
  {
    id: '1501030022',
    districtId: '1501030',
    name: 'Pulau Tengah',
  },
  {
    id: '1501030023',
    districtId: '1501030',
    name: 'Pasar Semerap',
  },
  {
    id: '1501030024',
    districtId: '1501030',
    name: 'Permai Baru',
  },
  {
    id: '1501030025',
    districtId: '1501030',
    name: 'Pasar Jujun',
  },
  {
    id: '1501030026',
    districtId: '1501030',
    name: 'Limok Manaih Pulau Tengah',
  },
  {
    id: '1501030027',
    districtId: '1501030',
    name: 'Jembatan Merah Pulau Tengah',
  },
  {
    id: '1501030028',
    districtId: '1501030',
    name: 'Pancuran Bangko',
  },
  {
    id: '1501030029',
    districtId: '1501030',
    name: 'Koto Tengah',
  },
  {
    id: '1501030030',
    districtId: '1501030',
    name: 'Serumpun Pauh',
  },
  {
    id: '1501030031',
    districtId: '1501030',
    name: 'Sumur Jauh',
  },
  {
    id: '1501030032',
    districtId: '1501030',
    name: 'Bukit Pulai',
  },
  {
    id: '1501040001',
    districtId: '1501040',
    name: 'Sanggaran Agung',
  },
  {
    id: '1501040002',
    districtId: '1501040',
    name: 'Talang Kemulun',
  },
  {
    id: '1501040003',
    districtId: '1501040',
    name: 'Kotobaru Sanggaran Agung',
  },
  {
    id: '1501040004',
    districtId: '1501040',
    name: 'Pendung Talang Genting',
  },
  {
    id: '1501040005',
    districtId: '1501040',
    name: 'Koto Tengah',
  },
  {
    id: '1501040006',
    districtId: '1501040',
    name: 'Seleman',
  },
  {
    id: '1501040007',
    districtId: '1501040',
    name: 'Tebing Tinggi',
  },
  {
    id: '1501040008',
    districtId: '1501040',
    name: 'Tanjung Tanah',
  },
  {
    id: '1501040009',
    districtId: '1501040',
    name: 'Koto Petai',
  },
  {
    id: '1501040010',
    districtId: '1501040',
    name: 'Koto Salak',
  },
  {
    id: '1501040011',
    districtId: '1501040',
    name: 'Simpang Empat',
  },
  {
    id: '1501040012',
    districtId: '1501040',
    name: 'Cupak',
  },
  {
    id: '1501040013',
    districtId: '1501040',
    name: 'Koto Iman',
  },
  {
    id: '1501040014',
    districtId: '1501040',
    name: 'Ujung Pasir',
  },
  {
    id: '1501040015',
    districtId: '1501040',
    name: 'Pasar Sore Seleman',
  },
  {
    id: '1501040016',
    districtId: '1501040',
    name: 'Dusun Baru Tanjung Tanah',
  },
  {
    id: '1501040017',
    districtId: '1501040',
    name: 'Tanjung Harapan',
  },
  {
    id: '1501040018',
    districtId: '1501040',
    name: 'Agung Koto Iman',
  },
  {
    id: '1501040019',
    districtId: '1501040',
    name: 'Koto Tuo Ujung Pasir',
  },
  {
    id: '1501050001',
    districtId: '1501050',
    name: 'Kayuaro Ambai',
  },
  {
    id: '1501050002',
    districtId: '1501050',
    name: 'Bunga Tanjung',
  },
  {
    id: '1501050003',
    districtId: '1501050',
    name: 'Pondok Beringin',
  },
  {
    id: '1501050005',
    districtId: '1501050',
    name: 'Semerah',
  },
  {
    id: '1501050006',
    districtId: '1501050',
    name: 'Sebukar',
  },
  {
    id: '1501050018',
    districtId: '1501050',
    name: 'Pendung Hilir',
  },
  {
    id: '1501050019',
    districtId: '1501050',
    name: 'Tanjung Mudo',
  },
  {
    id: '1501050020',
    districtId: '1501050',
    name: 'Pendung Tengah',
  },
  {
    id: '1501050021',
    districtId: '1501050',
    name: 'Koto Baru Hiang',
  },
  {
    id: '1501050022',
    districtId: '1501050',
    name: 'Ambai Atas',
  },
  {
    id: '1501050023',
    districtId: '1501050',
    name: 'Ambai Bawah',
  },
  {
    id: '1501050024',
    districtId: '1501050',
    name: 'Betung Kuning',
  },
  {
    id: '1501050025',
    districtId: '1501050',
    name: 'Hiang Tinggi',
  },
  {
    id: '1501050029',
    districtId: '1501050',
    name: 'Hiang Karya',
  },
  {
    id: '1501050030',
    districtId: '1501050',
    name: 'Baru Semerah',
  },
  {
    id: '1501050031',
    districtId: '1501050',
    name: 'Hiang Lestari',
  },
  {
    id: '1501050032',
    districtId: '1501050',
    name: 'Angkasa Pura',
  },
  {
    id: '1501050033',
    districtId: '1501050',
    name: 'Hiang Sakti',
  },
  {
    id: '1501050034',
    districtId: '1501050',
    name: 'Penawar Tinggi',
  },
  {
    id: '1501050035',
    districtId: '1501050',
    name: 'Koto Sekilan Ambai',
  },
  {
    id: '1501070022',
    districtId: '1501070',
    name: 'Koto Majidin Mudik',
  },
  {
    id: '1501070027',
    districtId: '1501070',
    name: 'Koto Majidin Hilir',
  },
  {
    id: '1501070028',
    districtId: '1501070',
    name: 'Air Tenang',
  },
  {
    id: '1501070029',
    districtId: '1501070',
    name: 'Koto Baru Semurup',
  },
  {
    id: '1501070030',
    districtId: '1501070',
    name: 'Koto Diair',
  },
  {
    id: '1501070031',
    districtId: '1501070',
    name: 'Pasar Semurup',
  },
  {
    id: '1501070033',
    districtId: '1501070',
    name: 'Muara Semerah',
  },
  {
    id: '1501070034',
    districtId: '1501070',
    name: 'Balai',
  },
  {
    id: '1501070039',
    districtId: '1501070',
    name: 'Koto Dua Lama',
  },
  {
    id: '1501070040',
    districtId: '1501070',
    name: 'Pendung Hilir',
  },
  {
    id: '1501070041',
    districtId: '1501070',
    name: 'Pendung Mudik',
  },
  {
    id: '1501070050',
    districtId: '1501070',
    name: 'Sawahan Koto Majidin',
  },
  {
    id: '1501070051',
    districtId: '1501070',
    name: 'Muara Semerah Mudik',
  },
  {
    id: '1501070052',
    districtId: '1501070',
    name: 'Pendung Tengah',
  },
  {
    id: '1501070053',
    districtId: '1501070',
    name: 'Koto Majidin DI Air',
  },
  {
    id: '1501070054',
    districtId: '1501070',
    name: 'Sawahan Jaya',
  },
  {
    id: '1501071001',
    districtId: '1501071',
    name: 'Kemantan Hilir',
  },
  {
    id: '1501071002',
    districtId: '1501071',
    name: 'Koto Tebat',
  },
  {
    id: '1501071003',
    districtId: '1501071',
    name: 'Pondok Sungai Abu',
  },
  {
    id: '1501071004',
    districtId: '1501071',
    name: 'Sungai Abu',
  },
  {
    id: '1501071005',
    districtId: '1501071',
    name: 'Pungut Hilir',
  },
  {
    id: '1501071006',
    districtId: '1501071',
    name: 'Pungut Tengah',
  },
  {
    id: '1501071007',
    districtId: '1501071',
    name: 'Pungut Mudik',
  },
  {
    id: '1501071008',
    districtId: '1501071',
    name: 'Desa Baru Sei Tutung',
  },
  {
    id: '1501071009',
    districtId: '1501071',
    name: 'Sungai Tutung',
  },
  {
    id: '1501071010',
    districtId: '1501071',
    name: 'Sungai Medang',
  },
  {
    id: '1501071013',
    districtId: '1501071',
    name: 'Air Hangat',
  },
  {
    id: '1501071014',
    districtId: '1501071',
    name: 'Kemantan Tinggi',
  },
  {
    id: '1501071015',
    districtId: '1501071',
    name: 'Kemantan Agung',
  },
  {
    id: '1501071016',
    districtId: '1501071',
    name: 'Kemantan Kebalai',
  },
  {
    id: '1501071017',
    districtId: '1501071',
    name: 'Kemantan Darat',
  },
  {
    id: '1501071018',
    districtId: '1501071',
    name: 'Sungai Deras',
  },
  {
    id: '1501071019',
    districtId: '1501071',
    name: 'Simpang Empat Sungai Tutung',
  },
  {
    id: '1501071020',
    districtId: '1501071',
    name: 'Kemantan Mudik',
  },
  {
    id: '1501071021',
    districtId: '1501071',
    name: 'Baru Sungai Deras',
  },
  {
    id: '1501071022',
    districtId: '1501071',
    name: 'Air Panas Sungai Abu',
  },
  {
    id: '1501071023',
    districtId: '1501071',
    name: 'Baru Sungai Abu',
  },
  {
    id: '1501071024',
    districtId: '1501071',
    name: 'Taman Jernih Sungai Tutung',
  },
  {
    id: '1501071025',
    districtId: '1501071',
    name: 'Baru Sungai Medang',
  },
  {
    id: '1501071026',
    districtId: '1501071',
    name: 'Baru Air Hangat',
  },
  {
    id: '1501071027',
    districtId: '1501071',
    name: 'Kemantan Raya',
  },
  {
    id: '1501072001',
    districtId: '1501072',
    name: 'Koto Lanang',
  },
  {
    id: '1501072002',
    districtId: '1501072',
    name: 'Ladeh',
  },
  {
    id: '1501072003',
    districtId: '1501072',
    name: 'Lubuk Suli',
  },
  {
    id: '1501072004',
    districtId: '1501072',
    name: 'Dusun Baru Kubang',
  },
  {
    id: '1501072005',
    districtId: '1501072',
    name: 'Kubang Gedang',
  },
  {
    id: '1501072006',
    districtId: '1501072',
    name: 'Koto Panjang',
  },
  {
    id: '1501072007',
    districtId: '1501072',
    name: 'Koto Payang',
  },
  {
    id: '1501072008',
    districtId: '1501072',
    name: 'Koto Tuo',
  },
  {
    id: '1501072009',
    districtId: '1501072',
    name: 'Semumu',
  },
  {
    id: '1501072010',
    districtId: '1501072',
    name: 'Sekungkung',
  },
  {
    id: '1501072011',
    districtId: '1501072',
    name: 'Tebat Ijuk',
  },
  {
    id: '1501072012',
    districtId: '1501072',
    name: 'Belui',
  },
  {
    id: '1501072013',
    districtId: '1501072',
    name: 'Simpang Belui',
  },
  {
    id: '1501072014',
    districtId: '1501072',
    name: 'Belui Tinggi',
  },
  {
    id: '1501072015',
    districtId: '1501072',
    name: 'Kayu Aho Mangkak Koto Lanang',
  },
  {
    id: '1501072016',
    districtId: '1501072',
    name: 'Kubang Agung',
  },
  {
    id: '1501072017',
    districtId: '1501072',
    name: 'Tambak Tinggi',
  },
  {
    id: '1501072018',
    districtId: '1501072',
    name: 'Koto Simpai Kubang',
  },
  {
    id: '1501072019',
    districtId: '1501072',
    name: 'Tebat Ijuk Dili',
  },
  {
    id: '1501072020',
    districtId: '1501072',
    name: 'Pahlawan Belui',
  },
  {
    id: '1501073001',
    districtId: '1501073',
    name: 'Koto Cayo',
  },
  {
    id: '1501073002',
    districtId: '1501073',
    name: 'Kecil',
  },
  {
    id: '1501073003',
    districtId: '1501073',
    name: 'Koto Tengah',
  },
  {
    id: '1501073004',
    districtId: '1501073',
    name: 'Koto Datuk',
  },
  {
    id: '1501073005',
    districtId: '1501073',
    name: 'Koto Dua Baru',
  },
  {
    id: '1501073006',
    districtId: '1501073',
    name: 'Koto Mudik',
  },
  {
    id: '1501073007',
    districtId: '1501073',
    name: 'Pugu',
  },
  {
    id: '1501073008',
    districtId: '1501073',
    name: 'Air Panas Baru',
  },
  {
    id: '1501073009',
    districtId: '1501073',
    name: 'Baru',
  },
  {
    id: '1501073010',
    districtId: '1501073',
    name: 'Koto Mebai',
  },
  {
    id: '1501073011',
    districtId: '1501073',
    name: 'Hamparan Pugu',
  },
  {
    id: '1501073012',
    districtId: '1501073',
    name: 'Air Bersih',
  },
  {
    id: '1501080018',
    districtId: '1501080',
    name: 'Sungai Gelampeh',
  },
  {
    id: '1501080023',
    districtId: '1501080',
    name: 'Tanjung Genting',
  },
  {
    id: '1501080024',
    districtId: '1501080',
    name: 'Simpang Tutup',
  },
  {
    id: '1501080025',
    districtId: '1501080',
    name: 'Siulak Tenang',
  },
  {
    id: '1501080026',
    districtId: '1501080',
    name: 'Kel. Siulak Deras',
  },
  {
    id: '1501080027',
    districtId: '1501080',
    name: 'Danau Tinggi',
  },
  {
    id: '1501080028',
    districtId: '1501080',
    name: 'Siulak Deras Mudik',
  },
  {
    id: '1501080029',
    districtId: '1501080',
    name: 'Sungai Batu Gantih',
  },
  {
    id: '1501080030',
    districtId: '1501080',
    name: 'Suko Pangkat',
  },
  {
    id: '1501080031',
    districtId: '1501080',
    name: 'Sungai Betung Hilir',
  },
  {
    id: '1501080032',
    districtId: '1501080',
    name: 'Sungai Betung Mudik',
  },
  {
    id: '1501080033',
    districtId: '1501080',
    name: 'Sungai Batu Gantih Hilir',
  },
  {
    id: '1501080034',
    districtId: '1501080',
    name: 'Baru Sungai Betung Mudik',
  },
  {
    id: '1501080035',
    districtId: '1501080',
    name: 'Tanjung Genting Mudik',
  },
  {
    id: '1501080036',
    districtId: '1501080',
    name: 'Ujung Ladang',
  },
  {
    id: '1501080037',
    districtId: '1501080',
    name: 'Air Betung',
  },
  {
    id: '1501081001',
    districtId: '1501081',
    name: 'Air Terjun',
  },
  {
    id: '1501081002',
    districtId: '1501081',
    name: 'Siulak Kecil Mudik',
  },
  {
    id: '1501081003',
    districtId: '1501081',
    name: 'Siulak Kecil Hilir',
  },
  {
    id: '1501081004',
    districtId: '1501081',
    name: 'Siulak Gedang',
  },
  {
    id: '1501081014',
    districtId: '1501081',
    name: 'Pasar Siulak Gedang',
  },
  {
    id: '1501081015',
    districtId: '1501081',
    name: 'Dusun Dalam',
  },
  {
    id: '1501081016',
    districtId: '1501081',
    name: 'Koto Beringin',
  },
  {
    id: '1501081017',
    districtId: '1501081',
    name: 'Siulak Panjang',
  },
  {
    id: '1501081018',
    districtId: '1501081',
    name: 'Koto Tengah',
  },
  {
    id: '1501081019',
    districtId: '1501081',
    name: 'Koto Aro',
  },
  {
    id: '1501081020',
    districtId: '1501081',
    name: 'Koto Rendah',
  },
  {
    id: '1501081021',
    districtId: '1501081',
    name: 'Dusun Baru',
  },
  {
    id: '1501081023',
    districtId: '1501081',
    name: 'Koto Kapeh',
  },
  {
    id: '1501081024',
    districtId: '1501081',
    name: 'Sungai Pegeh',
  },
  {
    id: '1501081025',
    districtId: '1501081',
    name: 'Sungai Lebuh',
  },
  {
    id: '1501081026',
    districtId: '1501081',
    name: 'Koto Lebuh Tinggi',
  },
  {
    id: '1501081027',
    districtId: '1501081',
    name: 'Lubuk Nagodang',
  },
  {
    id: '1501081028',
    districtId: '1501081',
    name: 'Telago Biru',
  },
  {
    id: '1501081031',
    districtId: '1501081',
    name: 'Tutung Bungkuk',
  },
  {
    id: '1501081033',
    districtId: '1501081',
    name: 'Padang Jantung',
  },
  {
    id: '1501081034',
    districtId: '1501081',
    name: 'Pelak Gedang',
  },
  {
    id: '1501081035',
    districtId: '1501081',
    name: 'Bendar Sedap',
  },
  {
    id: '1501081036',
    districtId: '1501081',
    name: 'Pelak Naneh',
  },
  {
    id: '1501081037',
    districtId: '1501081',
    name: 'Demong Sakti',
  },
  {
    id: '1501081038',
    districtId: '1501081',
    name: 'Pasar Senen',
  },
  {
    id: '1501081039',
    districtId: '1501081',
    name: 'Baru Sungai Pegeh',
  },
  {
    id: '1501082001',
    districtId: '1501082',
    name: 'Mukai Hilir',
  },
  {
    id: '1501082002',
    districtId: '1501082',
    name: 'Sungai Langkap',
  },
  {
    id: '1501082003',
    districtId: '1501082',
    name: 'Sungai Kuning',
  },
  {
    id: '1501082004',
    districtId: '1501082',
    name: 'Pasir Jaya',
  },
  {
    id: '1501082005',
    districtId: '1501082',
    name: 'Mukai Pintu',
  },
  {
    id: '1501082006',
    districtId: '1501082',
    name: 'Mukai Tengah',
  },
  {
    id: '1501082007',
    districtId: '1501082',
    name: 'Mukai Mudik',
  },
  {
    id: '1501082008',
    districtId: '1501082',
    name: 'Tebing Tinggi',
  },
  {
    id: '1501082009',
    districtId: '1501082',
    name: 'Senimpik',
  },
  {
    id: '1501082010',
    districtId: '1501082',
    name: 'Mukai Tinggi',
  },
  {
    id: '1501082011',
    districtId: '1501082',
    name: 'Lubuk Tabun',
  },
  {
    id: '1501082012',
    districtId: '1501082',
    name: 'Mukai Seberang',
  },
  {
    id: '1501082013',
    districtId: '1501082',
    name: 'Talang Tinggi',
  },
  {
    id: '1501082014',
    districtId: '1501082',
    name: 'Koto Lua',
  },
  {
    id: '1501090003',
    districtId: '1501090',
    name: 'Sungai Dalam',
  },
  {
    id: '1501090004',
    districtId: '1501090',
    name: 'Koto Tuo',
  },
  {
    id: '1501090005',
    districtId: '1501090',
    name: 'Koto Baru',
  },
  {
    id: '1501090014',
    districtId: '1501090',
    name: 'Bedeng Baru',
  },
  {
    id: '1501090015',
    districtId: '1501090',
    name: 'Sungai Tanduk',
  },
  {
    id: '1501090016',
    districtId: '1501090',
    name: 'Koto Panjang',
  },
  {
    id: '1501090017',
    districtId: '1501090',
    name: 'Sungai Sampun',
  },
  {
    id: '1501090018',
    districtId: '1501090',
    name: 'Koto Tengah',
  },
  {
    id: '1501090019',
    districtId: '1501090',
    name: 'Sungai Bendung Air',
  },
  {
    id: '1501090023',
    districtId: '1501090',
    name: 'Sangir',
  },
  {
    id: '1501090024',
    districtId: '1501090',
    name: 'Batang Sangir',
  },
  {
    id: '1501090025',
    districtId: '1501090',
    name: 'Kersik Tuo',
  },
  {
    id: '1501090036',
    districtId: '1501090',
    name: 'Koto Periang',
  },
  {
    id: '1501090037',
    districtId: '1501090',
    name: 'Lindung Jaya',
  },
  {
    id: '1501090039',
    districtId: '1501090',
    name: 'Pasar Sungai Tanduk',
  },
  {
    id: '1501090040',
    districtId: '1501090',
    name: 'Mekar Sari',
  },
  {
    id: '1501090041',
    districtId: '1501090',
    name: 'Renah Kasah',
  },
  {
    id: '1501090043',
    districtId: '1501090',
    name: 'Mekar Jaya',
  },
  {
    id: '1501090044',
    districtId: '1501090',
    name: 'Sangir Tengah',
  },
  {
    id: '1501090045',
    districtId: '1501090',
    name: 'Bendung Air Timur',
  },
  {
    id: '1501090046',
    districtId: '1501090',
    name: 'Tanjung Bungo',
  },
  {
    id: '1501091001',
    districtId: '1501091',
    name: 'Sungai Rumpun',
  },
  {
    id: '1501091002',
    districtId: '1501091',
    name: 'Bengkolan Dua',
  },
  {
    id: '1501091003',
    districtId: '1501091',
    name: 'Sungai Sikai',
  },
  {
    id: '1501091004',
    districtId: '1501091',
    name: 'Tangkil',
  },
  {
    id: '1501091005',
    districtId: '1501091',
    name: 'Bumbun Duri',
  },
  {
    id: '1501091006',
    districtId: '1501091',
    name: 'Jernih Jaya',
  },
  {
    id: '1501091007',
    districtId: '1501091',
    name: 'Lubuk Pauh',
  },
  {
    id: '1501091008',
    districtId: '1501091',
    name: 'Pelompek',
  },
  {
    id: '1501091009',
    districtId: '1501091',
    name: 'Telun Berasap',
  },
  {
    id: '1501091010',
    districtId: '1501091',
    name: 'Pesisir Bukit',
  },
  {
    id: '1501091011',
    districtId: '1501091',
    name: 'Pauh Tinggi',
  },
  {
    id: '1501091012',
    districtId: '1501091',
    name: 'Pelompek Pasar Baru',
  },
  {
    id: '1501091013',
    districtId: '1501091',
    name: 'Sungai Jernih',
  },
  {
    id: '1501092001',
    districtId: '1501092',
    name: 'Batu Hampar',
  },
  {
    id: '1501092002',
    districtId: '1501092',
    name: 'Sungai Asam',
  },
  {
    id: '1501092003',
    districtId: '1501092',
    name: 'Bento',
  },
  {
    id: '1501092004',
    districtId: '1501092',
    name: 'Bedeng Delapan',
  },
  {
    id: '1501092005',
    districtId: '1501092',
    name: 'Sako Dua',
  },
  {
    id: '1501092006',
    districtId: '1501092',
    name: 'Bedeng Dua',
  },
  {
    id: '1501092007',
    districtId: '1501092',
    name: 'Kampung Baru',
  },
  {
    id: '1501092008',
    districtId: '1501092',
    name: 'Patok Empat',
  },
  {
    id: '1501092009',
    districtId: '1501092',
    name: 'Sungai Lintang',
  },
  {
    id: '1501092010',
    districtId: '1501092',
    name: 'Sungai Jambu',
  },
  {
    id: '1501092011',
    districtId: '1501092',
    name: 'Giri Mulyo',
  },
  {
    id: '1501092012',
    districtId: '1501092',
    name: 'Sungai Kering',
  },
  {
    id: '1501092013',
    districtId: '1501092',
    name: 'Gunung Labu',
  },
  {
    id: '1501092014',
    districtId: '1501092',
    name: 'Kebun Baru',
  },
  {
    id: '1501092015',
    districtId: '1501092',
    name: 'Sungai Renah',
  },
  {
    id: '1501092016',
    districtId: '1501092',
    name: 'Pasar Minggu',
  },
  {
    id: '1501092017',
    districtId: '1501092',
    name: 'Ensatu',
  },
  {
    id: '1502010015',
    districtId: '1502010',
    name: 'Muara Madras',
  },
  {
    id: '1502010016',
    districtId: '1502010',
    name: 'Lubuk Pungguk',
  },
  {
    id: '1502010017',
    districtId: '1502010',
    name: 'Pulau Tengah',
  },
  {
    id: '1502010018',
    districtId: '1502010',
    name: 'Renah Alai',
  },
  {
    id: '1502010019',
    districtId: '1502010',
    name: 'Lubuk Mentilin',
  },
  {
    id: '1502010020',
    districtId: '1502010',
    name: 'Rantau Kermas',
  },
  {
    id: '1502010021',
    districtId: '1502010',
    name: 'Tanjung Kasri',
  },
  {
    id: '1502010022',
    districtId: '1502010',
    name: 'Renah Kemumu',
  },
  {
    id: '1502010023',
    districtId: '1502010',
    name: 'Koto Renah',
  },
  {
    id: '1502010024',
    districtId: '1502010',
    name: 'Renah Pelaan',
  },
  {
    id: '1502010025',
    districtId: '1502010',
    name: 'Koto Rawang',
  },
  {
    id: '1502011001',
    districtId: '1502011',
    name: 'Pematang Pauh',
  },
  {
    id: '1502011002',
    districtId: '1502011',
    name: 'Beringin Tinggi',
  },
  {
    id: '1502011003',
    districtId: '1502011',
    name: 'Tanjung Benuang',
  },
  {
    id: '1502011004',
    districtId: '1502011',
    name: 'Gedang',
  },
  {
    id: '1502011005',
    districtId: '1502011',
    name: 'Rantau Suli',
  },
  {
    id: '1502011006',
    districtId: '1502011',
    name: 'Talang Tembago',
  },
  {
    id: '1502011007',
    districtId: '1502011',
    name: 'Baru',
  },
  {
    id: '1502011008',
    districtId: '1502011',
    name: 'Tanjung Mudo',
  },
  {
    id: '1502011009',
    districtId: '1502011',
    name: 'Koto Teguh',
  },
  {
    id: '1502011010',
    districtId: '1502011',
    name: 'Jangkat',
  },
  {
    id: '1502011011',
    districtId: '1502011',
    name: 'Koto Baru',
  },
  {
    id: '1502011012',
    districtId: '1502011',
    name: 'Tanjung Alam',
  },
  {
    id: '1502011013',
    districtId: '1502011',
    name: 'Kabu',
  },
  {
    id: '1502011014',
    districtId: '1502011',
    name: 'Simpang Talang Tembago',
  },
  {
    id: '1502020004',
    districtId: '1502020',
    name: 'Durian Rambun',
  },
  {
    id: '1502020008',
    districtId: '1502020',
    name: 'Lubuk Birah',
  },
  {
    id: '1502020009',
    districtId: '1502020',
    name: 'Peradun Temeras',
  },
  {
    id: '1502020010',
    districtId: '1502020',
    name: 'Teluk Sikumbang',
  },
  {
    id: '1502020011',
    districtId: '1502020',
    name: 'Tiaro',
  },
  {
    id: '1502020012',
    districtId: '1502020',
    name: 'Lubuk Beringin',
  },
  {
    id: '1502020013',
    districtId: '1502020',
    name: 'Rantau Macang',
  },
  {
    id: '1502020014',
    districtId: '1502020',
    name: 'Pasar Muara Siau',
  },
  {
    id: '1502020015',
    districtId: '1502020',
    name: 'Muara Siau',
  },
  {
    id: '1502020016',
    districtId: '1502020',
    name: 'Rantau Bidaro',
  },
  {
    id: '1502020017',
    districtId: '1502020',
    name: 'Air Lago',
  },
  {
    id: '1502020018',
    districtId: '1502020',
    name: 'Badak Tekurung',
  },
  {
    id: '1502020019',
    districtId: '1502020',
    name: 'Rantau Panjang',
  },
  {
    id: '1502020020',
    districtId: '1502020',
    name: 'Pulau Raman',
  },
  {
    id: '1502020021',
    districtId: '1502020',
    name: 'Sepantai Renah',
  },
  {
    id: '1502020022',
    districtId: '1502020',
    name: 'Rantau Bayur',
  },
  {
    id: '1502020023',
    districtId: '1502020',
    name: 'Sungai Ulas',
  },
  {
    id: '1502021001',
    districtId: '1502021',
    name: 'Tanjung Dalam',
  },
  {
    id: '1502021002',
    districtId: '1502021',
    name: 'Muara Pangi',
  },
  {
    id: '1502021003',
    districtId: '1502021',
    name: 'Rantau Jering',
  },
  {
    id: '1502021004',
    districtId: '1502021',
    name: 'Nilo Dingin',
  },
  {
    id: '1502021005',
    districtId: '1502021',
    name: 'Tanjung Berugo',
  },
  {
    id: '1502021006',
    districtId: '1502021',
    name: 'Dusun Tuo',
  },
  {
    id: '1502021007',
    districtId: '1502021',
    name: 'Koto Rami',
  },
  {
    id: '1502021008',
    districtId: '1502021',
    name: 'Pasar Masurai',
  },
  {
    id: '1502021009',
    districtId: '1502021',
    name: 'Rancan',
  },
  {
    id: '1502021010',
    districtId: '1502021',
    name: 'Muara Lengayo',
  },
  {
    id: '1502021011',
    districtId: '1502021',
    name: 'Sungai Lalang',
  },
  {
    id: '1502021012',
    districtId: '1502021',
    name: 'Talang Asal',
  },
  {
    id: '1502021013',
    districtId: '1502021',
    name: 'Muara Kelukup',
  },
  {
    id: '1502021014',
    districtId: '1502021',
    name: 'Talang Paruh',
  },
  {
    id: '1502021015',
    districtId: '1502021',
    name: 'Durian Mukut',
  },
  {
    id: '1502022001',
    districtId: '1502022',
    name: 'Sekancing',
  },
  {
    id: '1502022002',
    districtId: '1502022',
    name: 'Beringin Sanggul',
  },
  {
    id: '1502022003',
    districtId: '1502022',
    name: 'Rantau Limau Kapas',
  },
  {
    id: '1502022004',
    districtId: '1502022',
    name: 'Sekancing Ilir',
  },
  {
    id: '1502022005',
    districtId: '1502022',
    name: 'Baru Bukit Punjung',
  },
  {
    id: '1502022006',
    districtId: '1502022',
    name: 'Baru Sungai Sakai',
  },
  {
    id: '1502030004',
    districtId: '1502030',
    name: 'Rejosari',
  },
  {
    id: '1502030005',
    districtId: '1502030',
    name: 'Pematang Kancil',
  },
  {
    id: '1502030006',
    districtId: '1502030',
    name: 'Tanah Abang',
  },
  {
    id: '1502030007',
    districtId: '1502030',
    name: 'Empang Benao',
  },
  {
    id: '1502030008',
    districtId: '1502030',
    name: 'Tanjung Gedang',
  },
  {
    id: '1502030009',
    districtId: '1502030',
    name: 'K E R O Y A',
  },
  {
    id: '1502030010',
    districtId: '1502030',
    name: 'Pauh Menang',
  },
  {
    id: '1502030011',
    districtId: '1502030',
    name: 'Kelurahan Pamenang',
  },
  {
    id: '1502030017',
    districtId: '1502030',
    name: 'Sialang',
  },
  {
    id: '1502030018',
    districtId: '1502030',
    name: 'Muara Belengo',
  },
  {
    id: '1502030019',
    districtId: '1502030',
    name: 'Jelatang',
  },
  {
    id: '1502030020',
    districtId: '1502030',
    name: 'Karang Berahi',
  },
  {
    id: '1502030026',
    districtId: '1502030',
    name: 'Sungai Udang',
  },
  {
    id: '1502030027',
    districtId: '1502030',
    name: 'Pelakar Jaya',
  },
  {
    id: '1502031001',
    districtId: '1502031',
    name: 'Mampun Baru',
  },
  {
    id: '1502031002',
    districtId: '1502031',
    name: 'Pinang Merah',
  },
  {
    id: '1502031003',
    districtId: '1502031',
    name: 'Karang Anyar',
  },
  {
    id: '1502031004',
    districtId: '1502031',
    name: 'Simpang Limbur Merangin',
  },
  {
    id: '1502031005',
    districtId: '1502031',
    name: 'Limbur Merangin',
  },
  {
    id: '1502031006',
    districtId: '1502031',
    name: 'Tanjung Lamin',
  },
  {
    id: '1502031007',
    districtId: '1502031',
    name: 'Papit',
  },
  {
    id: '1502031008',
    districtId: '1502031',
    name: 'Pulau Tujuh',
  },
  {
    id: '1502032001',
    districtId: '1502032',
    name: 'Lantak Seribu',
  },
  {
    id: '1502032002',
    districtId: '1502032',
    name: 'Rasau',
  },
  {
    id: '1502032003',
    districtId: '1502032',
    name: 'Meranti',
  },
  {
    id: '1502032004',
    districtId: '1502032',
    name: 'Bukit Bungkul',
  },
  {
    id: '1502033001',
    districtId: '1502033',
    name: 'Tanjung Benuang',
  },
  {
    id: '1502033002',
    districtId: '1502033',
    name: 'Tambang Emas',
  },
  {
    id: '1502033003',
    districtId: '1502033',
    name: 'Pulau Bayur',
  },
  {
    id: '1502033004',
    districtId: '1502033',
    name: 'Selango',
  },
  {
    id: '1502040004',
    districtId: '1502040',
    name: 'Sungai Kapas',
  },
  {
    id: '1502040005',
    districtId: '1502040',
    name: 'Langling',
  },
  {
    id: '1502040006',
    districtId: '1502040',
    name: 'Kungkai',
  },
  {
    id: '1502040014',
    districtId: '1502040',
    name: 'Kelurahan Pasar Atas Bangko',
  },
  {
    id: '1502040016',
    districtId: '1502040',
    name: 'Kelurahan Pasar Bangko',
  },
  {
    id: '1502040017',
    districtId: '1502040',
    name: 'Kelurahan Pematang Kandis',
  },
  {
    id: '1502040018',
    districtId: '1502040',
    name: 'Kelurahan Dusun Bangko',
  },
  {
    id: '1502040019',
    districtId: '1502040',
    name: 'Dusun Mudo',
  },
  {
    id: '1502041001',
    districtId: '1502041',
    name: 'Bedeng Rejo',
  },
  {
    id: '1502041002',
    districtId: '1502041',
    name: 'Bukit Beringin',
  },
  {
    id: '1502041003',
    districtId: '1502041',
    name: 'Sungai Putih',
  },
  {
    id: '1502041004',
    districtId: '1502041',
    name: 'Pulau Rengas',
  },
  {
    id: '1502041005',
    districtId: '1502041',
    name: 'Biuku Tanjung',
  },
  {
    id: '1502041006',
    districtId: '1502041',
    name: 'Pulau Rengas Ulu',
  },
  {
    id: '1502042001',
    districtId: '1502042',
    name: 'Mentawak',
  },
  {
    id: '1502042002',
    districtId: '1502042',
    name: 'Sungai Ulak',
  },
  {
    id: '1502042003',
    districtId: '1502042',
    name: 'Aur Berduri',
  },
  {
    id: '1502042004',
    districtId: '1502042',
    name: 'Danau',
  },
  {
    id: '1502042005',
    districtId: '1502042',
    name: 'Telun',
  },
  {
    id: '1502042006',
    districtId: '1502042',
    name: 'Nalo Gedang',
  },
  {
    id: '1502042007',
    districtId: '1502042',
    name: 'Baru Nalo',
  },
  {
    id: '1502043001',
    districtId: '1502043',
    name: 'Pulau Baru',
  },
  {
    id: '1502043002',
    districtId: '1502043',
    name: 'Rantau Alai',
  },
  {
    id: '1502043003',
    districtId: '1502043',
    name: 'Lubuk Gaung',
  },
  {
    id: '1502043004',
    districtId: '1502043',
    name: 'Titian Teras',
  },
  {
    id: '1502043005',
    districtId: '1502043',
    name: 'Salam Buku',
  },
  {
    id: '1502043006',
    districtId: '1502043',
    name: 'Kederasan Panjang',
  },
  {
    id: '1502043007',
    districtId: '1502043',
    name: 'Pulau Layang',
  },
  {
    id: '1502043008',
    districtId: '1502043',
    name: 'Pelangki',
  },
  {
    id: '1502043009',
    districtId: '1502043',
    name: 'Nibung',
  },
  {
    id: '1502043010',
    districtId: '1502043',
    name: 'Tambang Besi',
  },
  {
    id: '1502050009',
    districtId: '1502050',
    name: 'Bukit Batu',
  },
  {
    id: '1502050010',
    districtId: '1502050',
    name: 'Sungai Nilau',
  },
  {
    id: '1502050011',
    districtId: '1502050',
    name: 'Sungai Pinang',
  },
  {
    id: '1502050012',
    districtId: '1502050',
    name: 'Palipan',
  },
  {
    id: '1502050013',
    districtId: '1502050',
    name: 'Seringat',
  },
  {
    id: '1502050014',
    districtId: '1502050',
    name: 'Tiangko',
  },
  {
    id: '1502050015',
    districtId: '1502050',
    name: 'Sungai Manau',
  },
  {
    id: '1502050016',
    districtId: '1502050',
    name: 'Durian Lecah',
  },
  {
    id: '1502050017',
    districtId: '1502050',
    name: 'Benteng',
  },
  {
    id: '1502050018',
    districtId: '1502050',
    name: 'Gelanggang',
  },
  {
    id: '1502051001',
    districtId: '1502051',
    name: 'Talang Segegah',
  },
  {
    id: '1502051002',
    districtId: '1502051',
    name: 'Durian Batakuk',
  },
  {
    id: '1502051003',
    districtId: '1502051',
    name: 'Muaro Panco Barat',
  },
  {
    id: '1502051004',
    districtId: '1502051',
    name: 'Parit Ujung Tanjung',
  },
  {
    id: '1502051005',
    districtId: '1502051',
    name: 'Guguk',
  },
  {
    id: '1502051006',
    districtId: '1502051',
    name: 'Muara Bantan',
  },
  {
    id: '1502051007',
    districtId: '1502051',
    name: 'Markeh',
  },
  {
    id: '1502051008',
    districtId: '1502051',
    name: 'Air Batu',
  },
  {
    id: '1502051009',
    districtId: '1502051',
    name: 'Muaro Panco Timur',
  },
  {
    id: '1502051010',
    districtId: '1502051',
    name: 'Simpang Parit',
  },
  {
    id: '1502051011',
    districtId: '1502051',
    name: 'Marus Jaya',
  },
  {
    id: '1502051012',
    districtId: '1502051',
    name: 'Renah Medan',
  },
  {
    id: '1502052001',
    districtId: '1502052',
    name: 'Bukit Perentak',
  },
  {
    id: '1502052002',
    districtId: '1502052',
    name: 'Baru Pangkalan Jambu',
  },
  {
    id: '1502052003',
    districtId: '1502052',
    name: 'Tigo Alur Pangkalan Jambu',
  },
  {
    id: '1502052004',
    districtId: '1502052',
    name: 'Birun',
  },
  {
    id: '1502052005',
    districtId: '1502052',
    name: 'Bunga Tanjung',
  },
  {
    id: '1502052006',
    districtId: '1502052',
    name: 'Sungai Jering',
  },
  {
    id: '1502052007',
    districtId: '1502052',
    name: 'Kampung Limo',
  },
  {
    id: '1502052008',
    districtId: '1502052',
    name: 'Tanjung Mudo',
  },
  {
    id: '1502060026',
    districtId: '1502060',
    name: 'Kelurahan Mampun',
  },
  {
    id: '1502060027',
    districtId: '1502060',
    name: 'Kelurahan Kampung Baruh',
  },
  {
    id: '1502060028',
    districtId: '1502060',
    name: 'Kelurahan Pasar Rantau Panjang',
  },
  {
    id: '1502060029',
    districtId: '1502060',
    name: 'Seling',
  },
  {
    id: '1502060030',
    districtId: '1502060',
    name: 'Kandang',
  },
  {
    id: '1502060031',
    districtId: '1502060',
    name: 'Koto Rayo',
  },
  {
    id: '1502060032',
    districtId: '1502060',
    name: 'Kelurahan Dusun Baru',
  },
  {
    id: '1502060033',
    districtId: '1502060',
    name: 'Beluran Panjang',
  },
  {
    id: '1502060035',
    districtId: '1502060',
    name: 'Tanjung Ilir',
  },
  {
    id: '1502060046',
    districtId: '1502060',
    name: 'Lubuk Napal',
  },
  {
    id: '1502060047',
    districtId: '1502060',
    name: 'Kelurahan Pasar Baru Rantau Panjang',
  },
  {
    id: '1502061009',
    districtId: '1502061',
    name: 'Muara Jernih',
  },
  {
    id: '1502061010',
    districtId: '1502061',
    name: 'Pulau Aro',
  },
  {
    id: '1502061011',
    districtId: '1502061',
    name: 'Kapuk',
  },
  {
    id: '1502061012',
    districtId: '1502061',
    name: 'Rantau Ngarau',
  },
  {
    id: '1502061013',
    districtId: '1502061',
    name: 'Muaro Seketuk',
  },
  {
    id: '1502061014',
    districtId: '1502061',
    name: 'Medan Baru',
  },
  {
    id: '1502062001',
    districtId: '1502062',
    name: 'Sinar Gading',
  },
  {
    id: '1502062002',
    districtId: '1502062',
    name: 'Muara Delang',
  },
  {
    id: '1502062003',
    districtId: '1502062',
    name: 'Sungai Sahut',
  },
  {
    id: '1502062004',
    districtId: '1502062',
    name: 'Bunga Antoi',
  },
  {
    id: '1502062005',
    districtId: '1502062',
    name: 'Rawa Jaya',
  },
  {
    id: '1502062006',
    districtId: '1502062',
    name: 'Bunga Tanjung',
  },
  {
    id: '1502062007',
    districtId: '1502062',
    name: 'Gading Jaya',
  },
  {
    id: '1502062008',
    districtId: '1502062',
    name: 'Mekar Jaya',
  },
  {
    id: '1502063001',
    districtId: '1502063',
    name: 'Ulak Makam',
  },
  {
    id: '1502063002',
    districtId: '1502063',
    name: 'Air Batu',
  },
  {
    id: '1502063003',
    districtId: '1502063',
    name: 'Rejo Sari',
  },
  {
    id: '1502063004',
    districtId: '1502063',
    name: 'Kota Raja',
  },
  {
    id: '1502063005',
    districtId: '1502063',
    name: 'Rantau Limau Manis',
  },
  {
    id: '1502063006',
    districtId: '1502063',
    name: 'Tunggul Bulin',
  },
  {
    id: '1502063007',
    districtId: '1502063',
    name: 'Mekar Limau Manis',
  },
  {
    id: '1502064001',
    districtId: '1502064',
    name: 'Bukit Subur',
  },
  {
    id: '1502064002',
    districtId: '1502064',
    name: 'Sungai Bulian',
  },
  {
    id: '1502064003',
    districtId: '1502064',
    name: 'Sungai Limau',
  },
  {
    id: '1502064004',
    districtId: '1502064',
    name: 'Sri Sembilan',
  },
  {
    id: '1502065001',
    districtId: '1502065',
    name: 'Koto Baru',
  },
  {
    id: '1502065002',
    districtId: '1502065',
    name: 'Sido Lego',
  },
  {
    id: '1502065003',
    districtId: '1502065',
    name: 'Tambang Baru',
  },
  {
    id: '1502065004',
    districtId: '1502065',
    name: 'Mensango',
  },
  {
    id: '1502065005',
    districtId: '1502065',
    name: 'Sido Harjo',
  },
  {
    id: '1502066001',
    districtId: '1502066',
    name: 'Tanjung Rejo',
  },
  {
    id: '1502066002',
    districtId: '1502066',
    name: 'Sumber Agung',
  },
  {
    id: '1502066003',
    districtId: '1502066',
    name: 'Suko Rejo',
  },
  {
    id: '1502066004',
    districtId: '1502066',
    name: 'Sido Rukun',
  },
  {
    id: '1502066005',
    districtId: '1502066',
    name: 'Lubuk Bumbun',
  },
  {
    id: '1502066006',
    districtId: '1502066',
    name: 'Tegal Rejo',
  },
  {
    id: '1502067001',
    districtId: '1502067',
    name: 'Air Liki',
  },
  {
    id: '1502067002',
    districtId: '1502067',
    name: 'Ngaol',
  },
  {
    id: '1502067003',
    districtId: '1502067',
    name: 'Telentam',
  },
  {
    id: '1502067004',
    districtId: '1502067',
    name: 'Sungai Tabir',
  },
  {
    id: '1502067005',
    districtId: '1502067',
    name: 'Batang Kibul',
  },
  {
    id: '1502067006',
    districtId: '1502067',
    name: 'Muara Kibul',
  },
  {
    id: '1502067007',
    districtId: '1502067',
    name: 'Pulau Terbakar',
  },
  {
    id: '1502067008',
    districtId: '1502067',
    name: 'Tanjung Putus',
  },
  {
    id: '1502067009',
    districtId: '1502067',
    name: 'Pulau Lebar',
  },
  {
    id: '1502067010',
    districtId: '1502067',
    name: 'Air Liki Baru',
  },
  {
    id: '1502067011',
    districtId: '1502067',
    name: 'Ngaol Ilir',
  },
  {
    id: '1502067012',
    districtId: '1502067',
    name: 'Baru Kibul',
  },
  {
    id: '1502067013',
    districtId: '1502067',
    name: 'Tanjung Beringin',
  },
  {
    id: '1502067014',
    districtId: '1502067',
    name: 'Muaro Langeh',
  },
  {
    id: '1503010001',
    districtId: '1503010',
    name: 'Simpang Narso',
  },
  {
    id: '1503010002',
    districtId: '1503010',
    name: 'Batu Empang',
  },
  {
    id: '1503010003',
    districtId: '1503010',
    name: 'Batin Pengambang',
  },
  {
    id: '1503010004',
    districtId: '1503010',
    name: 'Muara Air Dua',
  },
  {
    id: '1503010005',
    districtId: '1503010',
    name: 'Sungai Keradak',
  },
  {
    id: '1503010006',
    districtId: '1503010',
    name: 'Tambak Ratu',
  },
  {
    id: '1503010007',
    districtId: '1503010',
    name: 'Rantau Panjang',
  },
  {
    id: '1503010008',
    districtId: '1503010',
    name: 'Pekan Gedang',
  },
  {
    id: '1503010009',
    districtId: '1503010',
    name: 'Pulau Salak Baru',
  },
  {
    id: '1503010010',
    districtId: '1503010',
    name: 'Bukit Kalimau Ulu',
  },
  {
    id: '1503010011',
    districtId: '1503010',
    name: 'Raden Anom',
  },
  {
    id: '1503010012',
    districtId: '1503010',
    name: 'Datuk Nan Duo',
  },
  {
    id: '1503010013',
    districtId: '1503010',
    name: 'Padang Jering',
  },
  {
    id: '1503010014',
    districtId: '1503010',
    name: 'Kasiro',
  },
  {
    id: '1503010015',
    districtId: '1503010',
    name: 'Kasiro Ilir',
  },
  {
    id: '1503010016',
    districtId: '1503010',
    name: 'Sungai Bemban',
  },
  {
    id: '1503010017',
    districtId: '1503010',
    name: 'Sungai Baung',
  },
  {
    id: '1503010018',
    districtId: '1503010',
    name: 'Muara Cuban',
  },
  {
    id: '1503010019',
    districtId: '1503010',
    name: 'Lubuk Bangkar',
  },
  {
    id: '1503010020',
    districtId: '1503010',
    name: 'Muara Pemuat',
  },
  {
    id: '1503010021',
    districtId: '1503010',
    name: 'Bukitsulah',
  },
  {
    id: '1503010022',
    districtId: '1503010',
    name: 'Paniban Baru',
  },
  {
    id: '1503010023',
    districtId: '1503010',
    name: 'Bukit Berantai',
  },
  {
    id: '1503020001',
    districtId: '1503020',
    name: 'Mersip',
  },
  {
    id: '1503020002',
    districtId: '1503020',
    name: 'Desa Berkun',
  },
  {
    id: '1503020003',
    districtId: '1503020',
    name: 'Lubuk Bedorong',
  },
  {
    id: '1503020004',
    districtId: '1503020',
    name: 'Meribung',
  },
  {
    id: '1503020005',
    districtId: '1503020',
    name: 'Napal Melintang',
  },
  {
    id: '1503020007',
    districtId: '1503020',
    name: 'Panca Karya',
  },
  {
    id: '1503020008',
    districtId: '1503020',
    name: 'Ranggo',
  },
  {
    id: '1503020009',
    districtId: '1503020',
    name: 'Tanjung Raden',
  },
  {
    id: '1503020010',
    districtId: '1503020',
    name: 'Temenggung',
  },
  {
    id: '1503020011',
    districtId: '1503020',
    name: 'Pulau Pandan',
  },
  {
    id: '1503020015',
    districtId: '1503020',
    name: 'Demang',
  },
  {
    id: '1503020016',
    districtId: '1503020',
    name: 'Muara Mansao',
  },
  {
    id: '1503020017',
    districtId: '1503020',
    name: 'Moenti',
  },
  {
    id: '1503020018',
    districtId: '1503020',
    name: 'Muara Limun',
  },
  {
    id: '1503020019',
    districtId: '1503020',
    name: 'Suka Damai',
  },
  {
    id: '1503020020',
    districtId: '1503020',
    name: 'Temalang',
  },
  {
    id: '1503021001',
    districtId: '1503021',
    name: 'Kampung Tujuh',
  },
  {
    id: '1503021002',
    districtId: '1503021',
    name: 'Lubuk Resam',
  },
  {
    id: '1503021003',
    districtId: '1503021',
    name: 'Teluk Rendah',
  },
  {
    id: '1503021004',
    districtId: '1503021',
    name: 'Teluk Tigo',
  },
  {
    id: '1503021005',
    districtId: '1503021',
    name: 'Pemuncak',
  },
  {
    id: '1503021006',
    districtId: '1503021',
    name: 'Tambang Tinggi',
  },
  {
    id: '1503021007',
    districtId: '1503021',
    name: 'Lubuk Resam Ilir',
  },
  {
    id: '1503021008',
    districtId: '1503021',
    name: 'Tendah',
  },
  {
    id: '1503021009',
    districtId: '1503021',
    name: 'Sekamis',
  },
  {
    id: '1503021010',
    districtId: '1503021',
    name: 'Sungai Keramat',
  },
  {
    id: '1503030008',
    districtId: '1503030',
    name: 'Pematang Kulim',
  },
  {
    id: '1503030009',
    districtId: '1503030',
    name: 'Batu Putih',
  },
  {
    id: '1503030010',
    districtId: '1503030',
    name: 'Pelawan',
  },
  {
    id: '1503030011',
    districtId: '1503030',
    name: 'Sungai Merah',
  },
  {
    id: '1503030012',
    districtId: '1503030',
    name: 'Penegah',
  },
  {
    id: '1503030013',
    districtId: '1503030',
    name: 'Pulau Aro',
  },
  {
    id: '1503030014',
    districtId: '1503030',
    name: 'Bukit',
  },
  {
    id: '1503030015',
    districtId: '1503030',
    name: 'Lubuk Sepuh',
  },
  {
    id: '1503030016',
    districtId: '1503030',
    name: 'Muara Danau',
  },
  {
    id: '1503030017',
    districtId: '1503030',
    name: 'Rantau Tenang',
  },
  {
    id: '1503030018',
    districtId: '1503030',
    name: 'Mekarsari',
  },
  {
    id: '1503030019',
    districtId: '1503030',
    name: 'Pasarpelawan',
  },
  {
    id: '1503030020',
    districtId: '1503030',
    name: 'Pelawan Jaya',
  },
  {
    id: '1503030021',
    districtId: '1503030',
    name: 'Lubuksayak',
  },
  {
    id: '1503031001',
    districtId: '1503031',
    name: 'Perdamaian',
  },
  {
    id: '1503031002',
    districtId: '1503031',
    name: 'Sungai Gedang',
  },
  {
    id: '1503031003',
    districtId: '1503031',
    name: 'Sungai Benteng',
  },
  {
    id: '1503031004',
    districtId: '1503031',
    name: 'Bukit Murau',
  },
  {
    id: '1503031005',
    districtId: '1503031',
    name: 'Pasar Singkut',
  },
  {
    id: '1503031006',
    districtId: '1503031',
    name: 'Bukit Tigo',
  },
  {
    id: '1503031007',
    districtId: '1503031',
    name: 'Payo Lebar',
  },
  {
    id: '1503031019',
    districtId: '1503031',
    name: 'Simpang Nibung',
  },
  {
    id: '1503031020',
    districtId: '1503031',
    name: 'Siliwangi',
  },
  {
    id: '1503031021',
    districtId: '1503031',
    name: 'Sendang Sari',
  },
  {
    id: '1503031022',
    districtId: '1503031',
    name: 'Argo Sari',
  },
  {
    id: '1503031023',
    districtId: '1503031',
    name: 'Bukit Bumi Raya',
  },
  {
    id: '1503031024',
    districtId: '1503031',
    name: 'Bukit Talang Mas',
  },
  {
    id: '1503040009',
    districtId: '1503040',
    name: 'T I N T I N G',
  },
  {
    id: '1503040010',
    districtId: '1503040',
    name: 'Sei Baung',
  },
  {
    id: '1503040011',
    districtId: '1503040',
    name: 'Panti',
  },
  {
    id: '1503040012',
    districtId: '1503040',
    name: 'Sungai Abang',
  },
  {
    id: '1503040013',
    districtId: '1503040',
    name: 'B E R N A I',
  },
  {
    id: '1503040014',
    districtId: '1503040',
    name: 'Dusun Sarolangun',
  },
  {
    id: '1503040015',
    districtId: '1503040',
    name: 'Pasar Sarolangun',
  },
  {
    id: '1503040016',
    districtId: '1503040',
    name: 'Sukasari',
  },
  {
    id: '1503040017',
    districtId: '1503040',
    name: 'Sarolangun Kembang',
  },
  {
    id: '1503040018',
    districtId: '1503040',
    name: 'Ladang Panjang',
  },
  {
    id: '1503040019',
    districtId: '1503040',
    name: 'L I D U N G',
  },
  {
    id: '1503040020',
    districtId: '1503040',
    name: 'Baru',
  },
  {
    id: '1503040021',
    districtId: '1503040',
    name: 'Aur Gading',
  },
  {
    id: '1503040022',
    districtId: '1503040',
    name: 'Gunung Kembang',
  },
  {
    id: '1503040023',
    districtId: '1503040',
    name: 'Ujung Tanjung',
  },
  {
    id: '1503040024',
    districtId: '1503040',
    name: 'Bernai Dalam',
  },
  {
    id: '1503041001',
    districtId: '1503041',
    name: 'Tanjung Gagak',
  },
  {
    id: '1503041002',
    districtId: '1503041',
    name: 'Rantau Gedang',
  },
  {
    id: '1503041003',
    districtId: '1503041',
    name: 'Pulau Buayo',
  },
  {
    id: '1503041004',
    districtId: '1503041',
    name: 'Batu Penyabung',
  },
  {
    id: '1503041005',
    districtId: '1503041',
    name: 'Teluk Kecimbung',
  },
  {
    id: '1503041006',
    districtId: '1503041',
    name: 'Dusun Dalam',
  },
  {
    id: '1503041007',
    districtId: '1503041',
    name: 'Pulau Lintang',
  },
  {
    id: '1503041008',
    districtId: '1503041',
    name: 'Penarun',
  },
  {
    id: '1503041009',
    districtId: '1503041',
    name: 'Pulau Malako',
  },
  {
    id: '1503041010',
    districtId: '1503041',
    name: 'Tanjung',
  },
  {
    id: '1503041011',
    districtId: '1503041',
    name: 'Limbur Tembesi',
  },
  {
    id: '1503041012',
    districtId: '1503041',
    name: 'Bangun Jayo',
  },
  {
    id: '1503041023',
    districtId: '1503041',
    name: 'Muaralati',
  },
  {
    id: '1503041024',
    districtId: '1503041',
    name: 'Teluk Mancur',
  },
  {
    id: '1503041025',
    districtId: '1503041',
    name: 'Sukajadi',
  },
  {
    id: '1503050001',
    districtId: '1503050',
    name: 'Seko Besar',
  },
  {
    id: '1503050002',
    districtId: '1503050',
    name: 'Taman Bandung',
  },
  {
    id: '1503050003',
    districtId: '1503050',
    name: 'Sepintun',
  },
  {
    id: '1503050004',
    districtId: '1503050',
    name: 'Lamban Sigatal',
  },
  {
    id: '1503050005',
    districtId: '1503050',
    name: 'Lubuk Napal',
  },
  {
    id: '1503050006',
    districtId: '1503050',
    name: 'Pangidaran',
  },
  {
    id: '1503050007',
    districtId: '1503050',
    name: 'Karang Mendapo',
  },
  {
    id: '1503050008',
    districtId: '1503050',
    name: 'Batu Ampar',
  },
  {
    id: '1503050009',
    districtId: '1503050',
    name: 'Batu Kucing',
  },
  {
    id: '1503050010',
    districtId: '1503050',
    name: 'Pauh',
  },
  {
    id: '1503050011',
    districtId: '1503050',
    name: 'Semaran',
  },
  {
    id: '1503050013',
    districtId: '1503050',
    name: 'Kasang Melintang',
  },
  {
    id: '1503050014',
    districtId: '1503050',
    name: 'Pangkal Bulian',
  },
  {
    id: '1503050015',
    districtId: '1503050',
    name: 'Danauserdang',
  },
  {
    id: '1503051001',
    districtId: '1503051',
    name: 'Lubuk Kepayang',
  },
  {
    id: '1503051002',
    districtId: '1503051',
    name: 'Dusun Baru',
  },
  {
    id: '1503051003',
    districtId: '1503051',
    name: 'Semurung',
  },
  {
    id: '1503051004',
    districtId: '1503051',
    name: 'Jernih',
  },
  {
    id: '1503051005',
    districtId: '1503051',
    name: 'Lubuk Jering',
  },
  {
    id: '1503051006',
    districtId: '1503051',
    name: 'Mentawak Baru',
  },
  {
    id: '1503051007',
    districtId: '1503051',
    name: 'Pematang Kabau',
  },
  {
    id: '1503051008',
    districtId: '1503051',
    name: 'Bukit Suban',
  },
  {
    id: '1503051015',
    districtId: '1503051',
    name: 'Mentawak Ulu',
  },
  {
    id: '1503060001',
    districtId: '1503060',
    name: 'Gurun Mudo',
  },
  {
    id: '1503060002',
    districtId: '1503060',
    name: 'Gurun Tuo',
  },
  {
    id: '1503060003',
    districtId: '1503060',
    name: 'Simpang Gurun Tuo',
  },
  {
    id: '1503060004',
    districtId: '1503060',
    name: 'Pemusiran',
  },
  {
    id: '1503060005',
    districtId: '1503060',
    name: 'Rangkiling Simpang',
  },
  {
    id: '1503060006',
    districtId: '1503060',
    name: 'Rangkiling',
  },
  {
    id: '1503060007',
    districtId: '1503060',
    name: 'Mandiangin Tuo',
  },
  {
    id: '1503060008',
    districtId: '1503060',
    name: 'Mandiangin',
  },
  {
    id: '1503060009',
    districtId: '1503060',
    name: 'Desa Taman Dewa',
  },
  {
    id: '1503060010',
    districtId: '1503060',
    name: 'Simpang Kertopati',
  },
  {
    id: '1503060011',
    districtId: '1503060',
    name: 'Kerto Pati',
  },
  {
    id: '1503060012',
    districtId: '1503060',
    name: 'Muara Ketalo',
  },
  {
    id: '1503060013',
    districtId: '1503060',
    name: 'Bukit Peranginan',
  },
  {
    id: '1503060014',
    districtId: '1503060',
    name: 'Petiduran Baru',
  },
  {
    id: '1503060015',
    districtId: '1503060',
    name: 'Guruh Baru',
  },
  {
    id: '1503060016',
    districtId: '1503060',
    name: 'Sungai Butang',
  },
  {
    id: '1503060017',
    districtId: '1503060',
    name: 'Butang Baru',
  },
  {
    id: '1503060018',
    districtId: '1503060',
    name: 'Merantih Baru',
  },
  {
    id: '1503060019',
    districtId: '1503060',
    name: 'Jati Baru',
  },
  {
    id: '1503060020',
    districtId: '1503060',
    name: 'Talang Serdang',
  },
  {
    id: '1503060021',
    districtId: '1503060',
    name: 'Gurun Baru',
  },
  {
    id: '1503060022',
    districtId: '1503060',
    name: 'Mandiangin Pasar',
  },
  {
    id: '1503060023',
    districtId: '1503060',
    name: 'Kute Jaye',
  },
  {
    id: '1503060024',
    districtId: '1503060',
    name: 'Sungai Rotan',
  },
  {
    id: '1503060025',
    districtId: '1503060',
    name: 'Suka Maju',
  },
  {
    id: '1503060026',
    districtId: '1503060',
    name: 'Meranti Jaya',
  },
  {
    id: '1503060027',
    districtId: '1503060',
    name: 'Jernang Baru',
  },
  {
    id: '1503060028',
    districtId: '1503060',
    name: 'Jati Baru Mudo',
  },
  {
    id: '1504010009',
    districtId: '1504010',
    name: 'Sengkati Kecil',
  },
  {
    id: '1504010010',
    districtId: '1504010',
    name: 'Mersam',
  },
  {
    id: '1504010011',
    districtId: '1504010',
    name: 'Benteng Rendah',
  },
  {
    id: '1504010012',
    districtId: '1504010',
    name: 'Kembang Paseban',
  },
  {
    id: '1504010013',
    districtId: '1504010',
    name: 'Kembang Tanjung',
  },
  {
    id: '1504010014',
    districtId: '1504010',
    name: 'Pematang Gadung',
  },
  {
    id: '1504010015',
    districtId: '1504010',
    name: 'Teluk Melintang',
  },
  {
    id: '1504010016',
    districtId: '1504010',
    name: 'Sengkati Gedang',
  },
  {
    id: '1504010017',
    districtId: '1504010',
    name: 'Sengkati Baru',
  },
  {
    id: '1504010018',
    districtId: '1504010',
    name: 'Sungai Puar',
  },
  {
    id: '1504010025',
    districtId: '1504010',
    name: 'Rantau Gedang',
  },
  {
    id: '1504010026',
    districtId: '1504010',
    name: 'Tapah Sari',
  },
  {
    id: '1504010027',
    districtId: '1504010',
    name: 'Bukit Harapan',
  },
  {
    id: '1504010028',
    districtId: '1504010',
    name: 'Bukit Kemuning',
  },
  {
    id: '1504010029',
    districtId: '1504010',
    name: 'Belanti Jaya',
  },
  {
    id: '1504010030',
    districtId: '1504010',
    name: 'Simpang Rantau Gedang',
  },
  {
    id: '1504010031',
    districtId: '1504010',
    name: 'Sengkati Mudo',
  },
  {
    id: '1504010032',
    districtId: '1504010',
    name: 'Tanjung Putra',
  },
  {
    id: '1504011001',
    districtId: '1504011',
    name: 'Batu Sawar',
  },
  {
    id: '1504011002',
    districtId: '1504011',
    name: 'Peninjauan',
  },
  {
    id: '1504011003',
    districtId: '1504011',
    name: 'Teluk Leban',
  },
  {
    id: '1504011004',
    districtId: '1504011',
    name: 'Kampung Baru',
  },
  {
    id: '1504011005',
    districtId: '1504011',
    name: 'Padang Kelapo',
  },
  {
    id: '1504011006',
    districtId: '1504011',
    name: 'Sungai Lingkar',
  },
  {
    id: '1504011007',
    districtId: '1504011',
    name: 'Sungai Ruan Ilir',
  },
  {
    id: '1504011008',
    districtId: '1504011',
    name: 'Sungai Ruan Ulu',
  },
  {
    id: '1504011009',
    districtId: '1504011',
    name: 'Olak Kemang',
  },
  {
    id: '1504011010',
    districtId: '1504011',
    name: 'Tebing Tinggi',
  },
  {
    id: '1504011011',
    districtId: '1504011',
    name: 'Rengas IX',
  },
  {
    id: '1504011012',
    districtId: '1504011',
    name: 'Kembang Seri',
  },
  {
    id: '1504011013',
    districtId: '1504011',
    name: 'Buluh Kasab',
  },
  {
    id: '1504011014',
    districtId: '1504011',
    name: 'Simpang Sungai Rengas',
  },
  {
    id: '1504011015',
    districtId: '1504011',
    name: 'Rawa Mekar',
  },
  {
    id: '1504011016',
    districtId: '1504011',
    name: 'Mekar Sari',
  },
  {
    id: '1504011017',
    districtId: '1504011',
    name: 'Kembang Seri Baru',
  },
  {
    id: '1504020001',
    districtId: '1504020',
    name: 'Jelutih',
  },
  {
    id: '1504020002',
    districtId: '1504020',
    name: 'Olak Besar',
  },
  {
    id: '1504020003',
    districtId: '1504020',
    name: 'Durian Luncuk',
  },
  {
    id: '1504020004',
    districtId: '1504020',
    name: 'Aur Gading',
  },
  {
    id: '1504020005',
    districtId: '1504020',
    name: 'Hajran',
  },
  {
    id: '1504020006',
    districtId: '1504020',
    name: 'Paku Aji',
  },
  {
    id: '1504020007',
    districtId: '1504020',
    name: 'Muara Jangga',
  },
  {
    id: '1504020008',
    districtId: '1504020',
    name: 'Mata Gual',
  },
  {
    id: '1504020009',
    districtId: '1504020',
    name: 'Koto Buayo',
  },
  {
    id: '1504020010',
    districtId: '1504020',
    name: 'Karmeo',
  },
  {
    id: '1504020011',
    districtId: '1504020',
    name: 'Simpang Karmeo',
  },
  {
    id: '1504020012',
    districtId: '1504020',
    name: 'Jangga',
  },
  {
    id: '1504020013',
    districtId: '1504020',
    name: 'Terentang Baru',
  },
  {
    id: '1504020014',
    districtId: '1504020',
    name: 'Jangga Baru',
  },
  {
    id: '1504020015',
    districtId: '1504020',
    name: 'Bulian Baru',
  },
  {
    id: '1504020016',
    districtId: '1504020',
    name: 'Simpang Jelutih',
  },
  {
    id: '1504020017',
    districtId: '1504020',
    name: 'Simpang Aur Gading',
  },
  {
    id: '1504030001',
    districtId: '1504030',
    name: 'Jebak',
  },
  {
    id: '1504030002',
    districtId: '1504030',
    name: 'Ampelu',
  },
  {
    id: '1504030003',
    districtId: '1504030',
    name: 'Tanjung Marwo',
  },
  {
    id: '1504030004',
    districtId: '1504030',
    name: 'Kampung Baru Km 5',
  },
  {
    id: '1504030005',
    districtId: '1504030',
    name: 'Sukaramai',
  },
  {
    id: '1504030006',
    districtId: '1504030',
    name: 'Pasar Muara Tembesi',
  },
  {
    id: '1504030007',
    districtId: '1504030',
    name: 'Rambutan Masam',
  },
  {
    id: '1504030008',
    districtId: '1504030',
    name: 'Pulau',
  },
  {
    id: '1504030009',
    districtId: '1504030',
    name: 'Sungai Pulai',
  },
  {
    id: '1504030010',
    districtId: '1504030',
    name: 'Rantau Kapas Mudo',
  },
  {
    id: '1504030011',
    districtId: '1504030',
    name: 'Rantau Kapas Tuo',
  },
  {
    id: '1504030012',
    districtId: '1504030',
    name: 'Ampelu Mudo',
  },
  {
    id: '1504030013',
    districtId: '1504030',
    name: 'Pelayangan',
  },
  {
    id: '1504030014',
    districtId: '1504030',
    name: 'Pematang Lima Suku',
  },
  {
    id: '1504040007',
    districtId: '1504040',
    name: 'Singkawang',
  },
  {
    id: '1504040008',
    districtId: '1504040',
    name: 'Kilangan',
  },
  {
    id: '1504040012',
    districtId: '1504040',
    name: 'Rantau Puri',
  },
  {
    id: '1504040013',
    districtId: '1504040',
    name: 'Sungai Buluh',
  },
  {
    id: '1504040014',
    districtId: '1504040',
    name: 'Muara Bulian',
  },
  {
    id: '1504040015',
    districtId: '1504040',
    name: 'Sri Dadi',
  },
  {
    id: '1504040016',
    districtId: '1504040',
    name: 'Tenam',
  },
  {
    id: '1504040017',
    districtId: '1504040',
    name: 'Simpang Terusan',
  },
  {
    id: '1504040018',
    districtId: '1504040',
    name: 'Pasar Terusan',
  },
  {
    id: '1504040020',
    districtId: '1504040',
    name: 'Napal Sisik',
  },
  {
    id: '1504040021',
    districtId: '1504040',
    name: 'Malapari',
  },
  {
    id: '1504040023',
    districtId: '1504040',
    name: 'Olak',
  },
  {
    id: '1504040024',
    districtId: '1504040',
    name: 'Teratai',
  },
  {
    id: '1504040025',
    districtId: '1504040',
    name: 'Bajubang Laut',
  },
  {
    id: '1504040026',
    districtId: '1504040',
    name: 'Sungai Baung',
  },
  {
    id: '1504040027',
    districtId: '1504040',
    name: 'Aro',
  },
  {
    id: '1504040028',
    districtId: '1504040',
    name: 'Muara Singoan',
  },
  {
    id: '1504040033',
    districtId: '1504040',
    name: 'Rengas Condong',
  },
  {
    id: '1504040034',
    districtId: '1504040',
    name: 'Pasar Baru',
  },
  {
    id: '1504040035',
    districtId: '1504040',
    name: 'Rambahan',
  },
  {
    id: '1504040036',
    districtId: '1504040',
    name: 'Pelayangan',
  },
  {
    id: '1504041001',
    districtId: '1504041',
    name: 'Sungkai',
  },
  {
    id: '1504041002',
    districtId: '1504041',
    name: 'Bungku',
  },
  {
    id: '1504041003',
    districtId: '1504041',
    name: 'Mekar Jaya',
  },
  {
    id: '1504041004',
    districtId: '1504041',
    name: 'Pompa Air',
  },
  {
    id: '1504041005',
    districtId: '1504041',
    name: 'Ladang Peris',
  },
  {
    id: '1504041006',
    districtId: '1504041',
    name: 'Penerokan',
  },
  {
    id: '1504041007',
    districtId: '1504041',
    name: 'Bajubang',
  },
  {
    id: '1504041008',
    districtId: '1504041',
    name: 'Batin',
  },
  {
    id: '1504041009',
    districtId: '1504041',
    name: 'Petajin',
  },
  {
    id: '1504041010',
    districtId: '1504041',
    name: 'Mekar Sari Nes',
  },
  {
    id: '1504042001',
    districtId: '1504042',
    name: 'Terusan',
  },
  {
    id: '1504042002',
    districtId: '1504042',
    name: 'Danau Embat',
  },
  {
    id: '1504042003',
    districtId: '1504042',
    name: 'Bulian Jaya',
  },
  {
    id: '1504042004',
    districtId: '1504042',
    name: 'Tidar Kuranji',
  },
  {
    id: '1504042005',
    districtId: '1504042',
    name: 'Kehidupan Baru',
  },
  {
    id: '1504042006',
    districtId: '1504042',
    name: 'Karya Mukti',
  },
  {
    id: '1504042007',
    districtId: '1504042',
    name: 'Bukit Sari',
  },
  {
    id: '1504042008',
    districtId: '1504042',
    name: 'Terusan',
  },
  {
    id: '1504050003',
    districtId: '1504050',
    name: 'Tebing Tinggi',
  },
  {
    id: '1504050004',
    districtId: '1504050',
    name: 'Simpang Kubu Kandang',
  },
  {
    id: '1504050005',
    districtId: '1504050',
    name: 'Kubu Kandang',
  },
  {
    id: '1504050006',
    districtId: '1504050',
    name: 'Kuap',
  },
  {
    id: '1504050007',
    districtId: '1504050',
    name: 'Senaning',
  },
  {
    id: '1504050008',
    districtId: '1504050',
    name: 'Jembatan Mas',
  },
  {
    id: '1504050009',
    districtId: '1504050',
    name: 'Awin',
  },
  {
    id: '1504050010',
    districtId: '1504050',
    name: 'Serasah',
  },
  {
    id: '1504050011',
    districtId: '1504050',
    name: 'Pulau Betung',
  },
  {
    id: '1504050012',
    districtId: '1504050',
    name: 'Ture',
  },
  {
    id: '1504050013',
    districtId: '1504050',
    name: 'Lubuk Ruso',
  },
  {
    id: '1504050014',
    districtId: '1504050',
    name: 'Olak Rambahan',
  },
  {
    id: '1504050015',
    districtId: '1504050',
    name: 'Lopak Aur',
  },
  {
    id: '1504050016',
    districtId: '1504050',
    name: 'Selat',
  },
  {
    id: '1504050017',
    districtId: '1504050',
    name: 'Teluk',
  },
  {
    id: '1504050018',
    districtId: '1504050',
    name: 'Pulau Raman',
  },
  {
    id: '1504050019',
    districtId: '1504050',
    name: 'Kaos',
  },
  {
    id: '1504050020',
    districtId: '1504050',
    name: 'Teluk Ketapang',
  },
  {
    id: '1504050021',
    districtId: '1504050',
    name: 'Kampung Pulau',
  },
  {
    id: '1505010024',
    districtId: '1505010',
    name: 'Suka Damai',
  },
  {
    id: '1505010025',
    districtId: '1505010',
    name: 'Ibru',
  },
  {
    id: '1505010026',
    districtId: '1505010',
    name: 'Nyogan',
  },
  {
    id: '1505010027',
    districtId: '1505010',
    name: 'Pelempang',
  },
  {
    id: '1505010029',
    districtId: '1505010',
    name: 'Km.39 Tanjung Pauh',
  },
  {
    id: '1505010030',
    districtId: '1505010',
    name: 'Baru',
  },
  {
    id: '1505010031',
    districtId: '1505010',
    name: 'Tanjung Pauh 32',
  },
  {
    id: '1505010032',
    districtId: '1505010',
    name: 'Kelurahan Tempino',
  },
  {
    id: '1505010033',
    districtId: '1505010',
    name: 'Naga Sari',
  },
  {
    id: '1505010034',
    districtId: '1505010',
    name: 'Sebapo',
  },
  {
    id: '1505010035',
    districtId: '1505010',
    name: 'Sungai Landai',
  },
  {
    id: '1505010040',
    districtId: '1505010',
    name: 'Suka Maju',
  },
  {
    id: '1505010041',
    districtId: '1505010',
    name: 'Pondok Meja',
  },
  {
    id: '1505010042',
    districtId: '1505010',
    name: 'Muaro Sebapo',
  },
  {
    id: '1505010043',
    districtId: '1505010',
    name: 'Tanjung Pauh Talang Pelita',
  },
  {
    id: '1505011009',
    districtId: '1505011',
    name: 'Tanjung Harapan',
  },
  {
    id: '1505011010',
    districtId: '1505011',
    name: 'Marga',
  },
  {
    id: '1505011011',
    districtId: '1505011',
    name: 'Bukit Mas',
  },
  {
    id: '1505011012',
    districtId: '1505011',
    name: 'Panca Bakti',
  },
  {
    id: '1505011013',
    districtId: '1505011',
    name: 'Bukit Makmur',
  },
  {
    id: '1505011020',
    districtId: '1505011',
    name: 'Suka Makmur',
  },
  {
    id: '1505011021',
    districtId: '1505011',
    name: 'Marga Mulya',
  },
  {
    id: '1505011022',
    districtId: '1505011',
    name: 'Berkah',
  },
  {
    id: '1505011023',
    districtId: '1505011',
    name: 'Panca Mulya',
  },
  {
    id: '1505011025',
    districtId: '1505011',
    name: 'Mekar Sari Makmur',
  },
  {
    id: '1505011032',
    districtId: '1505011',
    name: 'Bhakti Mulia',
  },
  {
    id: '1505012001',
    districtId: '1505012',
    name: 'Tanjung Sari',
  },
  {
    id: '1505012002',
    districtId: '1505012',
    name: 'Mekar Jaya',
  },
  {
    id: '1505012003',
    districtId: '1505012',
    name: 'Trijaya',
  },
  {
    id: '1505012004',
    districtId: '1505012',
    name: 'Bukit Subur',
  },
  {
    id: '1505012005',
    districtId: '1505012',
    name: 'Adipura Kencana',
  },
  {
    id: '1505012006',
    districtId: '1505012',
    name: 'Bukit Jaya',
  },
  {
    id: '1505012007',
    districtId: '1505012',
    name: 'Tanjung Mulya',
  },
  {
    id: '1505012008',
    districtId: '1505012',
    name: 'Ujung Tanjung',
  },
  {
    id: '1505012009',
    districtId: '1505012',
    name: 'Tanjung Baru',
  },
  {
    id: '1505012010',
    districtId: '1505012',
    name: 'Tanjung Lebar',
  },
  {
    id: '1505013001',
    districtId: '1505013',
    name: 'Sungai Dayo',
  },
  {
    id: '1505013002',
    districtId: '1505013',
    name: 'Bukit Mulya',
  },
  {
    id: '1505013003',
    districtId: '1505013',
    name: 'Matra Manunggal',
  },
  {
    id: '1505013004',
    districtId: '1505013',
    name: 'Pinang Tinggi',
  },
  {
    id: '1505013005',
    districtId: '1505013',
    name: 'Bahar Mulya',
  },
  {
    id: '1505013006',
    districtId: '1505013',
    name: 'Sumber Jaya',
  },
  {
    id: '1505013007',
    districtId: '1505013',
    name: 'Mulya Jaya',
  },
  {
    id: '1505013008',
    districtId: '1505013',
    name: 'Sumber Mulya',
  },
  {
    id: '1505013009',
    districtId: '1505013',
    name: 'Talang Bukit',
  },
  {
    id: '1505013010',
    districtId: '1505013',
    name: 'Talang Datar',
  },
  {
    id: '1505013011',
    districtId: '1505013',
    name: 'Markanding',
  },
  {
    id: '1505020005',
    districtId: '1505020',
    name: 'Sungai Terap',
  },
  {
    id: '1505020008',
    districtId: '1505020',
    name: 'Kasang Pudak',
  },
  {
    id: '1505020009',
    districtId: '1505020',
    name: 'Kasang Lopak Alai',
  },
  {
    id: '1505020010',
    districtId: '1505020',
    name: 'Solok',
  },
  {
    id: '1505020011',
    districtId: '1505020',
    name: 'Sumber Jaya',
  },
  {
    id: '1505020012',
    districtId: '1505020',
    name: 'Arang Arang',
  },
  {
    id: '1505020013',
    districtId: '1505020',
    name: 'Sipin Teluk Duren',
  },
  {
    id: '1505020014',
    districtId: '1505020',
    name: 'Pemunduran',
  },
  {
    id: '1505020015',
    districtId: '1505020',
    name: 'Teluk Raya',
  },
  {
    id: '1505020016',
    districtId: '1505020',
    name: 'Ramin',
  },
  {
    id: '1505020017',
    districtId: '1505020',
    name: 'Tarikan',
  },
  {
    id: '1505020018',
    districtId: '1505020',
    name: 'Lopak Alai',
  },
  {
    id: '1505020019',
    districtId: '1505020',
    name: 'Sakean',
  },
  {
    id: '1505020020',
    districtId: '1505020',
    name: 'Kota Karang',
  },
  {
    id: '1505020021',
    districtId: '1505020',
    name: 'Pudak',
  },
  {
    id: '1505020022',
    districtId: '1505020',
    name: 'Muara Kumpeh',
  },
  {
    id: '1505020023',
    districtId: '1505020',
    name: 'Kasang Kumpeh',
  },
  {
    id: '1505020024',
    districtId: '1505020',
    name: 'Kasang Kota Karang',
  },
  {
    id: '1505021001',
    districtId: '1505021',
    name: 'Petaling Jaya',
  },
  {
    id: '1505021002',
    districtId: '1505021',
    name: 'Sumber Agung',
  },
  {
    id: '1505021003',
    districtId: '1505021',
    name: 'Ladang Panjang',
  },
  {
    id: '1505021004',
    districtId: '1505021',
    name: 'Talang Belido',
  },
  {
    id: '1505021005',
    districtId: '1505021',
    name: 'Talang Kerinci',
  },
  {
    id: '1505021006',
    districtId: '1505021',
    name: 'Kebon Sembilan',
  },
  {
    id: '1505021007',
    districtId: '1505021',
    name: 'Sungai Gelam',
  },
  {
    id: '1505021008',
    districtId: '1505021',
    name: 'Parit',
  },
  {
    id: '1505021009',
    districtId: '1505021',
    name: 'Tangkit Baru',
  },
  {
    id: '1505021010',
    districtId: '1505021',
    name: 'Tangkit',
  },
  {
    id: '1505021011',
    districtId: '1505021',
    name: 'Mingkung Jaya',
  },
  {
    id: '1505021012',
    districtId: '1505021',
    name: 'Trimulya',
  },
  {
    id: '1505021013',
    districtId: '1505021',
    name: 'Mekar Jaya',
  },
  {
    id: '1505021014',
    districtId: '1505021',
    name: 'Gambut Jaya',
  },
  {
    id: '1505021015',
    districtId: '1505021',
    name: 'Sido Mukti',
  },
  {
    id: '1505030001',
    districtId: '1505030',
    name: 'Puding',
  },
  {
    id: '1505030002',
    districtId: '1505030',
    name: 'Pulau Mentaro',
  },
  {
    id: '1505030003',
    districtId: '1505030',
    name: 'Mekar Sari',
  },
  {
    id: '1505030006',
    districtId: '1505030',
    name: 'Betung',
  },
  {
    id: '1505030007',
    districtId: '1505030',
    name: 'Pematang Raman',
  },
  {
    id: '1505030008',
    districtId: '1505030',
    name: 'Petanang',
  },
  {
    id: '1505030009',
    districtId: '1505030',
    name: 'Sungai Bungur',
  },
  {
    id: '1505030010',
    districtId: '1505030',
    name: 'Seponjen',
  },
  {
    id: '1505030011',
    districtId: '1505030',
    name: 'Londerang',
  },
  {
    id: '1505030012',
    districtId: '1505030',
    name: 'Sogo',
  },
  {
    id: '1505030013',
    districtId: '1505030',
    name: 'Rantau Panjang',
  },
  {
    id: '1505030014',
    districtId: '1505030',
    name: 'Kelurahan Tanjung',
  },
  {
    id: '1505030015',
    districtId: '1505030',
    name: 'Gedong Karya',
  },
  {
    id: '1505030016',
    districtId: '1505030',
    name: 'Jebus',
  },
  {
    id: '1505030017',
    districtId: '1505030',
    name: 'Sungai Aur',
  },
  {
    id: '1505030018',
    districtId: '1505030',
    name: 'Maju Jaya',
  },
  {
    id: '1505030019',
    districtId: '1505030',
    name: 'Rondang',
  },
  {
    id: '1505040001',
    districtId: '1505040',
    name: 'Setiris',
  },
  {
    id: '1505040002',
    districtId: '1505040',
    name: 'Mudung Darat',
  },
  {
    id: '1505040003',
    districtId: '1505040',
    name: 'Danau Kedap',
  },
  {
    id: '1505040004',
    districtId: '1505040',
    name: 'Bakung',
  },
  {
    id: '1505040005',
    districtId: '1505040',
    name: 'Niaso',
  },
  {
    id: '1505040014',
    districtId: '1505040',
    name: 'Muaro Jambi',
  },
  {
    id: '1505040015',
    districtId: '1505040',
    name: 'Danau Lamo',
  },
  {
    id: '1505040016',
    districtId: '1505040',
    name: 'Baru',
  },
  {
    id: '1505040017',
    districtId: '1505040',
    name: 'Jambi Tulo',
  },
  {
    id: '1505040018',
    districtId: '1505040',
    name: 'Kelurahan Jambi Kecil',
  },
  {
    id: '1505040019',
    districtId: '1505040',
    name: 'Tanjung Katung',
  },
  {
    id: '1505040020',
    districtId: '1505040',
    name: 'Lubuk Raman',
  },
  {
    id: '1505041001',
    districtId: '1505041',
    name: 'Kunangan',
  },
  {
    id: '1505041002',
    districtId: '1505041',
    name: 'Talang Duku',
  },
  {
    id: '1505041003',
    districtId: '1505041',
    name: 'Tebat Patah',
  },
  {
    id: '1505041004',
    districtId: '1505041',
    name: 'Kemingking Dalam',
  },
  {
    id: '1505041005',
    districtId: '1505041',
    name: 'Teluk Jambu',
  },
  {
    id: '1505041006',
    districtId: '1505041',
    name: 'Kemingking Luar',
  },
  {
    id: '1505041007',
    districtId: '1505041',
    name: 'Dusun Mudo',
  },
  {
    id: '1505041008',
    districtId: '1505041',
    name: 'Sekumbung',
  },
  {
    id: '1505041009',
    districtId: '1505041',
    name: 'Rukam',
  },
  {
    id: '1505041010',
    districtId: '1505041',
    name: 'Manis Mato',
  },
  {
    id: '1505050003',
    districtId: '1505050',
    name: 'Sungai Bertam',
  },
  {
    id: '1505050004',
    districtId: '1505050',
    name: 'Muhajirin',
  },
  {
    id: '1505050005',
    districtId: '1505050',
    name: 'Maro Sebo',
  },
  {
    id: '1505050006',
    districtId: '1505050',
    name: 'Kelurahan Pijoan',
  },
  {
    id: '1505050007',
    districtId: '1505050',
    name: 'Muara Pijoan',
  },
  {
    id: '1505050008',
    districtId: '1505050',
    name: 'Simpang Sungai Duren',
  },
  {
    id: '1505050009',
    districtId: '1505050',
    name: 'Mendalo Darat',
  },
  {
    id: '1505050010',
    districtId: '1505050',
    name: 'Sungai Duren',
  },
  {
    id: '1505050011',
    districtId: '1505050',
    name: 'Mendalo Laut',
  },
  {
    id: '1505050012',
    districtId: '1505050',
    name: 'Penyengat Olak',
  },
  {
    id: '1505050013',
    districtId: '1505050',
    name: 'Sembubuk',
  },
  {
    id: '1505050014',
    districtId: '1505050',
    name: 'Sarang Burung',
  },
  {
    id: '1505050015',
    districtId: '1505050',
    name: 'Pematang Jering',
  },
  {
    id: '1505050016',
    districtId: '1505050',
    name: 'Rengas Bandung',
  },
  {
    id: '1505050017',
    districtId: '1505050',
    name: 'Senaung',
  },
  {
    id: '1505050018',
    districtId: '1505050',
    name: 'Kedemangan',
  },
  {
    id: '1505050019',
    districtId: '1505050',
    name: 'Danau Sarang Elang',
  },
  {
    id: '1505050020',
    districtId: '1505050',
    name: 'Simpang Limo',
  },
  {
    id: '1505050021',
    districtId: '1505050',
    name: 'Pematang Gajah',
  },
  {
    id: '1505050022',
    districtId: '1505050',
    name: 'Mendalo Indah',
  },
  {
    id: '1505060001',
    districtId: '1505060',
    name: 'Tantan',
  },
  {
    id: '1505060002',
    districtId: '1505060',
    name: 'Kedotan',
  },
  {
    id: '1505060003',
    districtId: '1505060',
    name: 'Keranggan',
  },
  {
    id: '1505060004',
    districtId: '1505060',
    name: 'Sekernan',
  },
  {
    id: '1505060005',
    districtId: '1505060',
    name: 'Tunas Baru',
  },
  {
    id: '1505060006',
    districtId: '1505060',
    name: 'Berembang',
  },
  {
    id: '1505060007',
    districtId: '1505060',
    name: 'Pematang Pulai',
  },
  {
    id: '1505060008',
    districtId: '1505060',
    name: 'Pulau Kayu Aro',
  },
  {
    id: '1505060009',
    districtId: '1505060',
    name: 'Rantau Majo',
  },
  {
    id: '1505060010',
    districtId: '1505060',
    name: 'Kelurahan Sengeti',
  },
  {
    id: '1505060011',
    districtId: '1505060',
    name: 'Bukit Baling',
  },
  {
    id: '1505060012',
    districtId: '1505060',
    name: 'Gerunggung',
  },
  {
    id: '1505060013',
    districtId: '1505060',
    name: 'Suak Putat',
  },
  {
    id: '1505060014',
    districtId: '1505060',
    name: 'Tanjung Lanjut',
  },
  {
    id: '1505060015',
    districtId: '1505060',
    name: 'Suko Awin Jaya',
  },
  {
    id: '1505060016',
    districtId: '1505060',
    name: 'Tunas Mudo',
  },
  {
    id: '1506010010',
    districtId: '1506010',
    name: 'Mendahara Tengah',
  },
  {
    id: '1506010011',
    districtId: '1506010',
    name: 'Pangkal Duri',
  },
  {
    id: '1506010012',
    districtId: '1506010',
    name: 'Mendahara Ilir',
  },
  {
    id: '1506010013',
    districtId: '1506010',
    name: 'Lagan Ilir',
  },
  {
    id: '1506010014',
    districtId: '1506010',
    name: 'Bhakti Idaman',
  },
  {
    id: '1506010015',
    districtId: '1506010',
    name: 'Merbau',
  },
  {
    id: '1506010016',
    districtId: '1506010',
    name: 'Sungai Tawar',
  },
  {
    id: '1506010017',
    districtId: '1506010',
    name: 'Sinar Kalimantan',
  },
  {
    id: '1506010018',
    districtId: '1506010',
    name: 'Pangkal Duri Ilir',
  },
  {
    id: '1506011001',
    districtId: '1506011',
    name: 'Bukit Tempurung',
  },
  {
    id: '1506011002',
    districtId: '1506011',
    name: 'Sungai Toman',
  },
  {
    id: '1506011003',
    districtId: '1506011',
    name: 'Simpang Tuan',
  },
  {
    id: '1506011004',
    districtId: '1506011',
    name: 'Pematang Rahim',
  },
  {
    id: '1506011005',
    districtId: '1506011',
    name: 'Sinar Wajo',
  },
  {
    id: '1506011006',
    districtId: '1506011',
    name: 'Sungai Beras',
  },
  {
    id: '1506011007',
    districtId: '1506011',
    name: 'Mencolok',
  },
  {
    id: '1506012001',
    districtId: '1506012',
    name: 'Rantau Karya',
  },
  {
    id: '1506012002',
    districtId: '1506012',
    name: 'Kota Baru',
  },
  {
    id: '1506012003',
    districtId: '1506012',
    name: 'Pandan Lagan',
  },
  {
    id: '1506012004',
    districtId: '1506012',
    name: 'Suka Maju',
  },
  {
    id: '1506012005',
    districtId: '1506012',
    name: 'Pandan Makmur',
  },
  {
    id: '1506012006',
    districtId: '1506012',
    name: 'Pandan Sejahtera',
  },
  {
    id: '1506012007',
    districtId: '1506012',
    name: 'Pandan Jaya',
  },
  {
    id: '1506012008',
    districtId: '1506012',
    name: 'Lagan Ulu',
  },
  {
    id: '1506012009',
    districtId: '1506012',
    name: 'Lagan Tengah',
  },
  {
    id: '1506020003',
    districtId: '1506020',
    name: 'Catur Rahayu',
  },
  {
    id: '1506020004',
    districtId: '1506020',
    name: 'Jati Mulyo',
  },
  {
    id: '1506020005',
    districtId: '1506020',
    name: 'Sido Mukti',
  },
  {
    id: '1506020006',
    districtId: '1506020',
    name: 'Kuala Dendang',
  },
  {
    id: '1506020007',
    districtId: '1506020',
    name: 'Rantau Indah',
  },
  {
    id: '1506020008',
    districtId: '1506020',
    name: 'Kuta Kandis Dendang',
  },
  {
    id: '1506020009',
    districtId: '1506020',
    name: 'Koto Kandis',
  },
  {
    id: '1506031001',
    districtId: '1506031',
    name: 'Parit Culum II',
  },
  {
    id: '1506031002',
    districtId: '1506031',
    name: 'Parit Culum I',
  },
  {
    id: '1506031003',
    districtId: '1506031',
    name: 'Teluk Dawan',
  },
  {
    id: '1506031004',
    districtId: '1506031',
    name: 'Talang Babat',
  },
  {
    id: '1506031005',
    districtId: '1506031',
    name: 'Rano',
  },
  {
    id: '1506031006',
    districtId: '1506031',
    name: 'Nibung Putih',
  },
  {
    id: '1506031007',
    districtId: '1506031',
    name: 'Kampung Singkep',
  },
  {
    id: '1506032001',
    districtId: '1506032',
    name: 'Lambur II',
  },
  {
    id: '1506032002',
    districtId: '1506032',
    name: 'Lambur I',
  },
  {
    id: '1506032003',
    districtId: '1506032',
    name: 'Muara Sabak Ulu',
  },
  {
    id: '1506032004',
    districtId: '1506032',
    name: 'Muara Sabak Ilir',
  },
  {
    id: '1506032005',
    districtId: '1506032',
    name: 'Siau Dalam',
  },
  {
    id: '1506032006',
    districtId: '1506032',
    name: 'Kota Raja',
  },
  {
    id: '1506032007',
    districtId: '1506032',
    name: 'Alang Alang',
  },
  {
    id: '1506032008',
    districtId: '1506032',
    name: 'Sungai Ular',
  },
  {
    id: '1506032009',
    districtId: '1506032',
    name: 'Lambur',
  },
  {
    id: '1506032010',
    districtId: '1506032',
    name: 'Kota Harapan',
  },
  {
    id: '1506032011',
    districtId: '1506032',
    name: 'Simbur Naik',
  },
  {
    id: '1506032012',
    districtId: '1506032',
    name: 'Kuala Simbur',
  },
  {
    id: '1506033001',
    districtId: '1506033',
    name: 'Kuala Lagan',
  },
  {
    id: '1506033002',
    districtId: '1506033',
    name: 'Teluk Majelis',
  },
  {
    id: '1506033003',
    districtId: '1506033',
    name: 'Kampung Laut',
  },
  {
    id: '1506033004',
    districtId: '1506033',
    name: 'Tanjung Solok',
  },
  {
    id: '1506033005',
    districtId: '1506033',
    name: 'Manunggal Makmur',
  },
  {
    id: '1506033006',
    districtId: '1506033',
    name: 'Majelis Hidayah',
  },
  {
    id: '1506040006',
    districtId: '1506040',
    name: 'Rantau Rasau I',
  },
  {
    id: '1506040007',
    districtId: '1506040',
    name: 'Rantau Rasau II',
  },
  {
    id: '1506040008',
    districtId: '1506040',
    name: 'Rantau Jaya',
  },
  {
    id: '1506040009',
    districtId: '1506040',
    name: 'Bangun Karya',
  },
  {
    id: '1506040010',
    districtId: '1506040',
    name: 'Bandar Jaya',
  },
  {
    id: '1506040011',
    districtId: '1506040',
    name: 'Sungai Dusun',
  },
  {
    id: '1506040012',
    districtId: '1506040',
    name: 'Harapan Makmur',
  },
  {
    id: '1506040013',
    districtId: '1506040',
    name: 'Marga Mulya',
  },
  {
    id: '1506040014',
    districtId: '1506040',
    name: 'Karya Bhakti',
  },
  {
    id: '1506040015',
    districtId: '1506040',
    name: 'Pematang Mayan',
  },
  {
    id: '1506040016',
    districtId: '1506040',
    name: 'Tri Mulya',
  },
  {
    id: '1506041001',
    districtId: '1506041',
    name: 'Simpang',
  },
  {
    id: '1506041002',
    districtId: '1506041',
    name: 'Rawasari',
  },
  {
    id: '1506041003',
    districtId: '1506041',
    name: 'Rantau Makmur',
  },
  {
    id: '1506041004',
    districtId: '1506041',
    name: 'Telaga Limo',
  },
  {
    id: '1506041005',
    districtId: '1506041',
    name: 'Sungai Rambut',
  },
  {
    id: '1506041006',
    districtId: '1506041',
    name: 'Rantau Rasau Desa',
  },
  {
    id: '1506050001',
    districtId: '1506050',
    name: 'Sungai Raya',
  },
  {
    id: '1506050002',
    districtId: '1506050',
    name: 'Teluk Kijing',
  },
  {
    id: '1506050003',
    districtId: '1506050',
    name: 'Pemusiran',
  },
  {
    id: '1506050004',
    districtId: '1506050',
    name: 'Nipah Panjang I',
  },
  {
    id: '1506050005',
    districtId: '1506050',
    name: 'Nipah Panjang II',
  },
  {
    id: '1506050006',
    districtId: '1506050',
    name: 'Simpang Datuk',
  },
  {
    id: '1506050007',
    districtId: '1506050',
    name: 'Simpang Jelita',
  },
  {
    id: '1506050008',
    districtId: '1506050',
    name: 'Bunga Tanjung',
  },
  {
    id: '1506050009',
    districtId: '1506050',
    name: 'Sungai Tering',
  },
  {
    id: '1506050010',
    districtId: '1506050',
    name: 'Sungai Jeruk',
  },
  {
    id: '1506060001',
    districtId: '1506060',
    name: 'Sungai Benuh',
  },
  {
    id: '1506060002',
    districtId: '1506060',
    name: 'Labuhan Pering',
  },
  {
    id: '1506060003',
    districtId: '1506060',
    name: 'Sungai Cemara',
  },
  {
    id: '1506060004',
    districtId: '1506060',
    name: 'Air Hitam Laut',
  },
  {
    id: '1506060005',
    districtId: '1506060',
    name: 'Remau Baku Tuo',
  },
  {
    id: '1506060006',
    districtId: '1506060',
    name: 'Sungai Sayang',
  },
  {
    id: '1506060007',
    districtId: '1506060',
    name: 'Sungai Jambat',
  },
  {
    id: '1506060008',
    districtId: '1506060',
    name: 'Sungai Lokan',
  },
  {
    id: '1506060009',
    districtId: '1506060',
    name: 'Sungai Itik',
  },
  {
    id: '1507010016',
    districtId: '1507010',
    name: 'Badang',
  },
  {
    id: '1507010017',
    districtId: '1507010',
    name: 'Tanjung Tayas',
  },
  {
    id: '1507010018',
    districtId: '1507010',
    name: 'Kuala Dasal',
  },
  {
    id: '1507010019',
    districtId: '1507010',
    name: 'Pematang Pauh',
  },
  {
    id: '1507010025',
    districtId: '1507010',
    name: 'Pelabuhan Dagang',
  },
  {
    id: '1507010026',
    districtId: '1507010',
    name: 'Taman Raja',
  },
  {
    id: '1507010036',
    districtId: '1507010',
    name: 'Brasau',
  },
  {
    id: '1507010037',
    districtId: '1507010',
    name: 'Badang Sepakat',
  },
  {
    id: '1507010038',
    districtId: '1507010',
    name: 'Gemuruh',
  },
  {
    id: '1507010039',
    districtId: '1507010',
    name: 'Pematang Tembesu',
  },
  {
    id: '1507011005',
    districtId: '1507011',
    name: 'Tanjung Benanak',
  },
  {
    id: '1507011006',
    districtId: '1507011',
    name: 'Bukit Harapan',
  },
  {
    id: '1507011007',
    districtId: '1507011',
    name: 'Adi Purwa',
  },
  {
    id: '1507011010',
    districtId: '1507011',
    name: 'Pinang Gading',
  },
  {
    id: '1507011014',
    districtId: '1507011',
    name: 'Merlung',
  },
  {
    id: '1507011015',
    districtId: '1507011',
    name: 'Tanjung Paku',
  },
  {
    id: '1507011016',
    districtId: '1507011',
    name: 'Lubuk Terap',
  },
  {
    id: '1507011017',
    districtId: '1507011',
    name: 'Penyabungan',
  },
  {
    id: '1507011020',
    districtId: '1507011',
    name: 'Tanjung Makmur',
  },
  {
    id: '1507011021',
    districtId: '1507011',
    name: 'Merlung',
  },
  {
    id: '1507012001',
    districtId: '1507012',
    name: 'Lubuk Bernai',
  },
  {
    id: '1507012002',
    districtId: '1507012',
    name: 'Kampung Baru',
  },
  {
    id: '1507012003',
    districtId: '1507012',
    name: 'Tanjung Bojo',
  },
  {
    id: '1507012004',
    districtId: '1507012',
    name: 'Dusun Kebon',
  },
  {
    id: '1507012005',
    districtId: '1507012',
    name: 'Suban',
  },
  {
    id: '1507012006',
    districtId: '1507012',
    name: 'Sri Agung',
  },
  {
    id: '1507012007',
    districtId: '1507012',
    name: 'Lubuk Lawas',
  },
  {
    id: '1507012008',
    districtId: '1507012',
    name: 'Sungai Badar',
  },
  {
    id: '1507012009',
    districtId: '1507012',
    name: 'Sungai Penoban',
  },
  {
    id: '1507012010',
    districtId: '1507012',
    name: 'Rawang Kempas',
  },
  {
    id: '1507012011',
    districtId: '1507012',
    name: 'Rawa Medang',
  },
  {
    id: '1507013001',
    districtId: '1507013',
    name: 'Purwodadi',
  },
  {
    id: '1507013002',
    districtId: '1507013',
    name: 'Sukadamai',
  },
  {
    id: '1507013003',
    districtId: '1507013',
    name: 'Adi Jaya',
  },
  {
    id: '1507013004',
    districtId: '1507013',
    name: 'Tebing Tinggi',
  },
  {
    id: '1507013005',
    districtId: '1507013',
    name: 'Kelagian',
  },
  {
    id: '1507013006',
    districtId: '1507013',
    name: 'Sungai Keruh',
  },
  {
    id: '1507013007',
    districtId: '1507013',
    name: 'Dataran Kempas',
  },
  {
    id: '1507013008',
    districtId: '1507013',
    name: 'Delima',
  },
  {
    id: '1507013009',
    districtId: '1507013',
    name: 'Talang Makmur',
  },
  {
    id: '1507013010',
    districtId: '1507013',
    name: 'Teluk Pengkah',
  },
  {
    id: '1507014001',
    districtId: '1507014',
    name: 'Lubuk Kambing',
  },
  {
    id: '1507014002',
    districtId: '1507014',
    name: 'Sungai Rotan',
  },
  {
    id: '1507014003',
    districtId: '1507014',
    name: 'Cinta Damai',
  },
  {
    id: '1507014004',
    districtId: '1507014',
    name: 'Lampisi',
  },
  {
    id: '1507014005',
    districtId: '1507014',
    name: 'Pulau Pauh',
  },
  {
    id: '1507014006',
    districtId: '1507014',
    name: 'Rantau Benar',
  },
  {
    id: '1507014007',
    districtId: '1507014',
    name: 'Muara Danau',
  },
  {
    id: '1507014008',
    districtId: '1507014',
    name: 'Tanah Tumbuh',
  },
  {
    id: '1507014009',
    districtId: '1507014',
    name: 'Sungai Paur',
  },
  {
    id: '1507014010',
    districtId: '1507014',
    name: 'Bukit Bakar',
  },
  {
    id: '1507015001',
    districtId: '1507015',
    name: 'Intan Jaya',
  },
  {
    id: '1507015002',
    districtId: '1507015',
    name: 'Bukit Indah',
  },
  {
    id: '1507015003',
    districtId: '1507015',
    name: 'Kemang Manis',
  },
  {
    id: '1507015004',
    districtId: '1507015',
    name: 'Dusun Mudo',
  },
  {
    id: '1507015005',
    districtId: '1507015',
    name: 'Rantau Badak',
  },
  {
    id: '1507015006',
    districtId: '1507015',
    name: 'Sungai Papauh',
  },
  {
    id: '1507015007',
    districtId: '1507015',
    name: 'Sungai Muluk',
  },
  {
    id: '1507015008',
    districtId: '1507015',
    name: 'Pematang Balam',
  },
  {
    id: '1507015009',
    districtId: '1507015',
    name: 'Lubuk Sebontan',
  },
  {
    id: '1507015010',
    districtId: '1507015',
    name: 'Rantau Badak Lamo',
  },
  {
    id: '1507020005',
    districtId: '1507020',
    name: 'Teluk Nilau',
  },
  {
    id: '1507020006',
    districtId: '1507020',
    name: 'Sungai Serindit',
  },
  {
    id: '1507020007',
    districtId: '1507020',
    name: 'Parit Pudin',
  },
  {
    id: '1507020008',
    districtId: '1507020',
    name: 'Mekar Jati',
  },
  {
    id: '1507020010',
    districtId: '1507020',
    name: 'Parit Bilal',
  },
  {
    id: '1507020011',
    districtId: '1507020',
    name: 'Suak Samin',
  },
  {
    id: '1507020012',
    districtId: '1507020',
    name: 'Parit Sidang',
  },
  {
    id: '1507020013',
    districtId: '1507020',
    name: 'Sungai Pampang',
  },
  {
    id: '1507020014',
    districtId: '1507020',
    name: 'Sungai Jering',
  },
  {
    id: '1507020015',
    districtId: '1507020',
    name: 'Sungai Raya',
  },
  {
    id: '1507020016',
    districtId: '1507020',
    name: 'Sungai Baung',
  },
  {
    id: '1507020017',
    districtId: '1507020',
    name: 'Karya Maju',
  },
  {
    id: '1507020018',
    districtId: '1507020',
    name: 'Pasar Senin',
  },
  {
    id: '1507021001',
    districtId: '1507021',
    name: 'Margo Rukun',
  },
  {
    id: '1507021002',
    districtId: '1507021',
    name: 'Sungai Rambai',
  },
  {
    id: '1507021003',
    districtId: '1507021',
    name: 'Teluk Ketapang',
  },
  {
    id: '1507021004',
    districtId: '1507021',
    name: 'Sungai Kayu Aro',
  },
  {
    id: '1507021005',
    districtId: '1507021',
    name: 'Senyerang',
  },
  {
    id: '1507021006',
    districtId: '1507021',
    name: 'Lumahan',
  },
  {
    id: '1507021007',
    districtId: '1507021',
    name: 'Kempas Jaya',
  },
  {
    id: '1507021008',
    districtId: '1507021',
    name: 'Sungsang',
  },
  {
    id: '1507021009',
    districtId: '1507021',
    name: 'Sungai Kepayang',
  },
  {
    id: '1507021010',
    districtId: '1507021',
    name: 'Sungai Landak',
  },
  {
    id: '1507030007',
    districtId: '1507030',
    name: 'Tungkal Harapan',
  },
  {
    id: '1507030008',
    districtId: '1507030',
    name: 'Tungkal IV Kota',
  },
  {
    id: '1507030009',
    districtId: '1507030',
    name: 'Tungkal III',
  },
  {
    id: '1507030010',
    districtId: '1507030',
    name: 'Tungkal II',
  },
  {
    id: '1507030011',
    districtId: '1507030',
    name: 'Tungkal I',
  },
  {
    id: '1507030014',
    districtId: '1507030',
    name: 'Teluk Sialang',
  },
  {
    id: '1507030015',
    districtId: '1507030',
    name: 'Sungai Nibung',
  },
  {
    id: '1507030016',
    districtId: '1507030',
    name: 'Sriwijaya',
  },
  {
    id: '1507030017',
    districtId: '1507030',
    name: 'Patunas',
  },
  {
    id: '1507030018',
    districtId: '1507030',
    name: 'Kampung Nelayan',
  },
  {
    id: '1507031001',
    districtId: '1507031',
    name: 'Beram Itam Kanan',
  },
  {
    id: '1507031002',
    districtId: '1507031',
    name: 'Beram Itam Kiri',
  },
  {
    id: '1507031003',
    districtId: '1507031',
    name: 'Pembengis',
  },
  {
    id: '1507031004',
    districtId: '1507031',
    name: 'Tanjung Senjulang',
  },
  {
    id: '1507031005',
    districtId: '1507031',
    name: 'Jati Emas',
  },
  {
    id: '1507031006',
    districtId: '1507031',
    name: 'Kemuning',
  },
  {
    id: '1507031007',
    districtId: '1507031',
    name: 'Pantai Gading',
  },
  {
    id: '1507031008',
    districtId: '1507031',
    name: 'Bram Itam Raya',
  },
  {
    id: '1507031009',
    districtId: '1507031',
    name: 'Mekar Tanjung',
  },
  {
    id: '1507031010',
    districtId: '1507031',
    name: 'Semau',
  },
  {
    id: '1507032001',
    districtId: '1507032',
    name: 'Teluk Pulai Raya',
  },
  {
    id: '1507032002',
    districtId: '1507032',
    name: 'Tungkal V',
  },
  {
    id: '1507032003',
    districtId: '1507032',
    name: 'Tungkal IV Desa',
  },
  {
    id: '1507032004',
    districtId: '1507032',
    name: 'Kuala Baru',
  },
  {
    id: '1507032005',
    districtId: '1507032',
    name: 'Kuala Kahar',
  },
  {
    id: '1507032006',
    districtId: '1507032',
    name: 'Harapan Jaya',
  },
  {
    id: '1507032007',
    districtId: '1507032',
    name: 'Mekar Alam',
  },
  {
    id: '1507032008',
    districtId: '1507032',
    name: 'Muara Seberang',
  },
  {
    id: '1507040001',
    districtId: '1507040',
    name: 'Pematang Lumut',
  },
  {
    id: '1507040007',
    districtId: '1507040',
    name: 'Serdang Jaya',
  },
  {
    id: '1507040008',
    districtId: '1507040',
    name: 'Makmur Jaya',
  },
  {
    id: '1507040009',
    districtId: '1507040',
    name: 'Mekar Jaya',
  },
  {
    id: '1507040010',
    districtId: '1507040',
    name: 'Terjun Gajah',
  },
  {
    id: '1507040011',
    districtId: '1507040',
    name: 'Lubuk Terentang',
  },
  {
    id: '1507040012',
    districtId: '1507040',
    name: 'Pematang Buluh',
  },
  {
    id: '1507040013',
    districtId: '1507040',
    name: 'Muntialo',
  },
  {
    id: '1507040014',
    districtId: '1507040',
    name: 'Teluk Kulbi',
  },
  {
    id: '1507040015',
    districtId: '1507040',
    name: 'Mandala Jaya',
  },
  {
    id: '1507040016',
    districtId: '1507040',
    name: 'Sungai Terap',
  },
  {
    id: '1507040017',
    districtId: '1507040',
    name: 'Bunga Tanjung',
  },
  {
    id: '1507041001',
    districtId: '1507041',
    name: 'Sungai Gebar',
  },
  {
    id: '1507041002',
    districtId: '1507041',
    name: 'Sungai Dualap',
  },
  {
    id: '1507041003',
    districtId: '1507041',
    name: 'Betara Kiri',
  },
  {
    id: '1507041004',
    districtId: '1507041',
    name: 'Betara Kanan',
  },
  {
    id: '1507041005',
    districtId: '1507041',
    name: 'Sungai Gebar Barat',
  },
  {
    id: '1507041006',
    districtId: '1507041',
    name: 'Sungai Dungun',
  },
  {
    id: '1507041007',
    districtId: '1507041',
    name: 'Tanjung Pasir',
  },
  {
    id: '1507041008',
    districtId: '1507041',
    name: 'Dataran Pinang',
  },
  {
    id: '1507041009',
    districtId: '1507041',
    name: 'Kuala Indah',
  },
  {
    id: '1507041010',
    districtId: '1507041',
    name: 'Suak Labu',
  },
  {
    id: '1508010007',
    districtId: '1508010',
    name: 'Tuo Ilir',
  },
  {
    id: '1508010008',
    districtId: '1508010',
    name: 'Teluk Rendah Pasar',
  },
  {
    id: '1508010009',
    districtId: '1508010',
    name: 'Teluk Rendah Ilir',
  },
  {
    id: '1508010010',
    districtId: '1508010',
    name: 'Teluk Rendah Ulu',
  },
  {
    id: '1508010011',
    districtId: '1508010',
    name: 'Muara Ketalo',
  },
  {
    id: '1508010012',
    districtId: '1508010',
    name: 'Kelurahan Sungai Bengkal',
  },
  {
    id: '1508010013',
    districtId: '1508010',
    name: 'Betung Bedarah Timur',
  },
  {
    id: '1508010014',
    districtId: '1508010',
    name: 'Betung Bedarah Barat',
  },
  {
    id: '1508010015',
    districtId: '1508010',
    name: 'Sungai Aro',
  },
  {
    id: '1508010016',
    districtId: '1508010',
    name: 'Kunangan',
  },
  {
    id: '1508010018',
    districtId: '1508010',
    name: 'Sungai Bengkal Barat',
  },
  {
    id: '1508011001',
    districtId: '1508011',
    name: 'Embacang Gedang',
  },
  {
    id: '1508011002',
    districtId: '1508011',
    name: 'Pintas Tuo',
  },
  {
    id: '1508011003',
    districtId: '1508011',
    name: 'Tambun Arang',
  },
  {
    id: '1508011004',
    districtId: '1508011',
    name: 'Bangun Seranten',
  },
  {
    id: '1508011005',
    districtId: '1508011',
    name: 'Sungai Jernih',
  },
  {
    id: '1508011006',
    districtId: '1508011',
    name: 'Tanah Garo',
  },
  {
    id: '1508011007',
    districtId: '1508011',
    name: 'Bangko Pintas',
  },
  {
    id: '1508011008',
    districtId: '1508011',
    name: 'Olak Kemang',
  },
  {
    id: '1508020001',
    districtId: '1508020',
    name: 'Aburan Batang Tebo',
  },
  {
    id: '1508020002',
    districtId: '1508020',
    name: 'Kelurahan Muara Tebo',
  },
  {
    id: '1508020003',
    districtId: '1508020',
    name: 'Mangun Jayo',
  },
  {
    id: '1508020004',
    districtId: '1508020',
    name: 'Tengah Ulu',
  },
  {
    id: '1508020005',
    districtId: '1508020',
    name: 'Teluk Pandak',
  },
  {
    id: '1508020006',
    districtId: '1508020',
    name: 'Semabu',
  },
  {
    id: '1508020007',
    districtId: '1508020',
    name: 'Kandang',
  },
  {
    id: '1508020010',
    districtId: '1508020',
    name: 'Bedaro Rampak',
  },
  {
    id: '1508020011',
    districtId: '1508020',
    name: 'Kelurahan Tebing Tinggi',
  },
  {
    id: '1508020012',
    districtId: '1508020',
    name: 'Sungai Alai',
  },
  {
    id: '1508020019',
    districtId: '1508020',
    name: 'Pelayang',
  },
  {
    id: '1508020020',
    districtId: '1508020',
    name: 'Sungai Keruh',
  },
  {
    id: '1508021001',
    districtId: '1508021',
    name: 'Tambun Arang',
  },
  {
    id: '1508021002',
    districtId: '1508021',
    name: 'Jati Belarik',
  },
  {
    id: '1508021003',
    districtId: '1508021',
    name: 'Puntikalo',
  },
  {
    id: '1508021004',
    districtId: '1508021',
    name: 'Lembak Bungur',
  },
  {
    id: '1508021005',
    districtId: '1508021',
    name: 'Teluk Singkawang',
  },
  {
    id: '1508021006',
    districtId: '1508021',
    name: 'Teriti',
  },
  {
    id: '1508021007',
    districtId: '1508021',
    name: 'Dusun Tuo Sumay',
  },
  {
    id: '1508021008',
    districtId: '1508021',
    name: 'Teluk Langkap',
  },
  {
    id: '1508021009',
    districtId: '1508021',
    name: 'Suo Suo',
  },
  {
    id: '1508021010',
    districtId: '1508021',
    name: 'Muara Sekalo',
  },
  {
    id: '1508021011',
    districtId: '1508021',
    name: 'Semambu',
  },
  {
    id: '1508021012',
    districtId: '1508021',
    name: 'Pemayongan',
  },
  {
    id: '1508022001',
    districtId: '1508022',
    name: 'Penapalan',
  },
  {
    id: '1508022002',
    districtId: '1508022',
    name: 'Muara Kilis',
  },
  {
    id: '1508022003',
    districtId: '1508022',
    name: 'Mengupeh',
  },
  {
    id: '1508022004',
    districtId: '1508022',
    name: 'Rantau Api',
  },
  {
    id: '1508022005',
    districtId: '1508022',
    name: 'Lubuk Mandarsah',
  },
  {
    id: '1508030003',
    districtId: '1508030',
    name: 'Rimbo Mulyo',
  },
  {
    id: '1508030004',
    districtId: '1508030',
    name: 'Sapta Mulia',
  },
  {
    id: '1508030005',
    districtId: '1508030',
    name: 'Pematang Sapat',
  },
  {
    id: '1508030013',
    districtId: '1508030',
    name: 'Tegal Arum',
  },
  {
    id: '1508030014',
    districtId: '1508030',
    name: 'Tirtakencana',
  },
  {
    id: '1508030015',
    districtId: '1508030',
    name: 'Purwo Harjo',
  },
  {
    id: '1508030016',
    districtId: '1508030',
    name: 'Perintis',
  },
  {
    id: '1508030017',
    districtId: '1508030',
    name: 'Kelurahan Wirotho Agung',
  },
  {
    id: '1508031001',
    districtId: '1508031',
    name: 'Sungai Pandan',
  },
  {
    id: '1508031002',
    districtId: '1508031',
    name: 'Suka Maju',
  },
  {
    id: '1508031003',
    districtId: '1508031',
    name: 'Suka Damai',
  },
  {
    id: '1508031004',
    districtId: '1508031',
    name: 'Wanareja',
  },
  {
    id: '1508031005',
    districtId: '1508031',
    name: 'Sido Rukun',
  },
  {
    id: '1508031006',
    districtId: '1508031',
    name: 'Sumber Sari',
  },
  {
    id: '1508032001',
    districtId: '1508032',
    name: 'Pulung Rejo',
  },
  {
    id: '1508032002',
    districtId: '1508032',
    name: 'Karang Dadi',
  },
  {
    id: '1508032003',
    districtId: '1508032',
    name: 'Sido Rejo',
  },
  {
    id: '1508032004',
    districtId: '1508032',
    name: 'Sari Mulya',
  },
  {
    id: '1508032005',
    districtId: '1508032',
    name: 'Sumber Agung',
  },
  {
    id: '1508032006',
    districtId: '1508032',
    name: 'Giri Purno',
  },
  {
    id: '1508032007',
    districtId: '1508032',
    name: 'Giriwinangun',
  },
  {
    id: '1508032008',
    districtId: '1508032',
    name: 'Sepakat Bersatu',
  },
  {
    id: '1508032009',
    districtId: '1508032',
    name: 'Rantau Kembang',
  },
  {
    id: '1508040012',
    districtId: '1508040',
    name: 'Teluk Kuali',
  },
  {
    id: '1508040013',
    districtId: '1508040',
    name: 'Lubuk Benteng',
  },
  {
    id: '1508040014',
    districtId: '1508040',
    name: 'Kelurahan Pulau Temiang',
  },
  {
    id: '1508040015',
    districtId: '1508040',
    name: 'Pulau Panjang',
  },
  {
    id: '1508040016',
    districtId: '1508040',
    name: 'Bungo Tanjung',
  },
  {
    id: '1508040017',
    districtId: '1508040',
    name: 'Tanjung Aur',
  },
  {
    id: '1508040018',
    districtId: '1508040',
    name: 'Rantau Langkap',
  },
  {
    id: '1508040020',
    districtId: '1508040',
    name: 'Teluk Kembang Jambu',
  },
  {
    id: '1508040021',
    districtId: '1508040',
    name: 'Pagar Puding',
  },
  {
    id: '1508040022',
    districtId: '1508040',
    name: 'Sungai Rambai',
  },
  {
    id: '1508040027',
    districtId: '1508040',
    name: 'Malako Intan',
  },
  {
    id: '1508040028',
    districtId: '1508040',
    name: 'Pulau Jelmu',
  },
  {
    id: '1508040029',
    districtId: '1508040',
    name: 'Medan Seri Rambahan',
  },
  {
    id: '1508040030',
    districtId: '1508040',
    name: 'Teluk Kasai Rambahan',
  },
  {
    id: '1508040031',
    districtId: '1508040',
    name: 'Ulak Banjir Rambahan',
  },
  {
    id: '1508040032',
    districtId: '1508040',
    name: 'Teluk Pandan Rambahan',
  },
  {
    id: '1508040033',
    districtId: '1508040',
    name: 'Jambu',
  },
  {
    id: '1508041001',
    districtId: '1508041',
    name: 'Tanjung',
  },
  {
    id: '1508041002',
    districtId: '1508041',
    name: 'Kuamang',
  },
  {
    id: '1508041003',
    districtId: '1508041',
    name: 'Teluk Kayu Putih',
  },
  {
    id: '1508041006',
    districtId: '1508041',
    name: 'Dusun Baru',
  },
  {
    id: '1508041011',
    districtId: '1508041',
    name: 'Muara Niro',
  },
  {
    id: '1508041012',
    districtId: '1508041',
    name: 'Aur Cino',
  },
  {
    id: '1508041013',
    districtId: '1508041',
    name: 'Sungai Abang',
  },
  {
    id: '1508041014',
    districtId: '1508041',
    name: 'Teluk Lancang',
  },
  {
    id: '1508041015',
    districtId: '1508041',
    name: 'Muara Tabun',
  },
  {
    id: '1508041016',
    districtId: '1508041',
    name: 'Tabun',
  },
  {
    id: '1508042001',
    districtId: '1508042',
    name: 'Pinang Belai',
  },
  {
    id: '1508042002',
    districtId: '1508042',
    name: 'Sekutur Jaya',
  },
  {
    id: '1508042003',
    districtId: '1508042',
    name: 'Bukit Pemuatan',
  },
  {
    id: '1508042004',
    districtId: '1508042',
    name: 'Napal Putih',
  },
  {
    id: '1508042005',
    districtId: '1508042',
    name: 'Sako Makmur',
  },
  {
    id: '1508042006',
    districtId: '1508042',
    name: 'Pagar Puding Lamo',
  },
  {
    id: '1508042007',
    districtId: '1508042',
    name: 'Tanjung Aur Seberang',
  },
  {
    id: '1508042008',
    districtId: '1508042',
    name: 'Teluk Melintang',
  },
  {
    id: '1508043001',
    districtId: '1508043',
    name: 'Teluk Kepayang Pulau Indah',
  },
  {
    id: '1508043002',
    districtId: '1508043',
    name: 'Sungai Karang',
  },
  {
    id: '1508043003',
    districtId: '1508043',
    name: 'Balai Rajo',
  },
  {
    id: '1508043004',
    districtId: '1508043',
    name: 'Paseban',
  },
  {
    id: '1508043005',
    districtId: '1508043',
    name: 'Cermin Alam',
  },
  {
    id: '1508043006',
    districtId: '1508043',
    name: 'Pasir Mayang',
  },
  {
    id: '1509010001',
    districtId: '1509010',
    name: 'Batu Kerbau',
  },
  {
    id: '1509010003',
    districtId: '1509010',
    name: 'Baru Pelepat',
  },
  {
    id: '1509010004',
    districtId: '1509010',
    name: 'Rantel',
  },
  {
    id: '1509010005',
    districtId: '1509010',
    name: 'Balai Jaya',
  },
  {
    id: '1509010006',
    districtId: '1509010',
    name: 'Sungai Beringin',
  },
  {
    id: '1509010007',
    districtId: '1509010',
    name: 'Rantau Keloyang',
  },
  {
    id: '1509010008',
    districtId: '1509010',
    name: 'Dwi Karya Bakti',
  },
  {
    id: '1509010009',
    districtId: '1509010',
    name: 'Mulia Jaya',
  },
  {
    id: '1509010010',
    districtId: '1509010',
    name: 'Gapura Suci',
  },
  {
    id: '1509010011',
    districtId: '1509010',
    name: 'Mulia Bakti',
  },
  {
    id: '1509010012',
    districtId: '1509010',
    name: 'Cilodang',
  },
  {
    id: '1509010029',
    districtId: '1509010',
    name: 'Sungai Gurun',
  },
  {
    id: '1509010030',
    districtId: '1509010',
    name: 'Senamat',
  },
  {
    id: '1509010031',
    districtId: '1509010',
    name: 'Sekampil',
  },
  {
    id: '1509010032',
    districtId: '1509010',
    name: 'Bukit Telago',
  },
  {
    id: '1509011001',
    districtId: '1509011',
    name: 'Purwosari',
  },
  {
    id: '1509011002',
    districtId: '1509011',
    name: 'Lembah Kuamang',
  },
  {
    id: '1509011003',
    districtId: '1509011',
    name: 'Sumber Mulia',
  },
  {
    id: '1509011004',
    districtId: '1509011',
    name: 'Daya Murni',
  },
  {
    id: '1509011005',
    districtId: '1509011',
    name: 'Maju Jaya',
  },
  {
    id: '1509011006',
    districtId: '1509011',
    name: 'Tirta Mulia',
  },
  {
    id: '1509011007',
    districtId: '1509011',
    name: 'Lingga Kuamang',
  },
  {
    id: '1509011008',
    districtId: '1509011',
    name: 'Sumber Harapan',
  },
  {
    id: '1509011009',
    districtId: '1509011',
    name: 'Bangun Harjo',
  },
  {
    id: '1509011010',
    districtId: '1509011',
    name: 'Kuning Gading',
  },
  {
    id: '1509011011',
    districtId: '1509011',
    name: 'Karya Harapan Mukti',
  },
  {
    id: '1509011012',
    districtId: '1509011',
    name: 'Kuamang Jaya',
  },
  {
    id: '1509011013',
    districtId: '1509011',
    name: 'Muara Kuamang',
  },
  {
    id: '1509011014',
    districtId: '1509011',
    name: 'Lubuk',
  },
  {
    id: '1509011015',
    districtId: '1509011',
    name: 'Danau',
  },
  {
    id: '1509011016',
    districtId: '1509011',
    name: 'Koto Jayo',
  },
  {
    id: '1509011017',
    districtId: '1509011',
    name: 'Padang Palangeh',
  },
  {
    id: '1509021001',
    districtId: '1509021',
    name: 'Sepunggur',
  },
  {
    id: '1509021002',
    districtId: '1509021',
    name: 'Babeko',
  },
  {
    id: '1509021003',
    districtId: '1509021',
    name: 'Simpang Babeko',
  },
  {
    id: '1509021004',
    districtId: '1509021',
    name: 'Tanjung Menanti',
  },
  {
    id: '1509021005',
    districtId: '1509021',
    name: 'Suka Makmur',
  },
  {
    id: '1509021006',
    districtId: '1509021',
    name: 'Tuo Sepunggur',
  },
  {
    id: '1509022001',
    districtId: '1509022',
    name: 'Sungai Mengkuang',
  },
  {
    id: '1509022002',
    districtId: '1509022',
    name: 'Sungai Buluh',
  },
  {
    id: '1509022003',
    districtId: '1509022',
    name: 'Kelurahan Pasir Putih',
  },
  {
    id: '1509022004',
    districtId: '1509022',
    name: 'Kelurahan Cadika',
  },
  {
    id: '1509023001',
    districtId: '1509023',
    name: 'Kelurahan Sungai Kerjan',
  },
  {
    id: '1509023002',
    districtId: '1509023',
    name: 'Sungai Arang',
  },
  {
    id: '1509023003',
    districtId: '1509023',
    name: 'Talang Pantai',
  },
  {
    id: '1509023004',
    districtId: '1509023',
    name: 'Kelurahan Sungai  Pinang',
  },
  {
    id: '1509023005',
    districtId: '1509023',
    name: 'Pulau Pekan',
  },
  {
    id: '1509024001',
    districtId: '1509024',
    name: 'Kelurahan Bungo Barat',
  },
  {
    id: '1509024002',
    districtId: '1509024',
    name: 'Kelurahan Batang Bungo',
  },
  {
    id: '1509024003',
    districtId: '1509024',
    name: 'Kelurahan Bungo Timur',
  },
  {
    id: '1509024004',
    districtId: '1509024',
    name: 'Kelurahan Jaya Setia',
  },
  {
    id: '1509024005',
    districtId: '1509024',
    name: 'Kelurahan Tanjung Gedang',
  },
  {
    id: '1509025001',
    districtId: '1509025',
    name: 'Kelurahan Manggis',
  },
  {
    id: '1509025002',
    districtId: '1509025',
    name: 'Kelurahan Sungai Binjai',
  },
  {
    id: '1509025003',
    districtId: '1509025',
    name: 'Kelurahan Bungo Taman Agung',
  },
  {
    id: '1509025004',
    districtId: '1509025',
    name: 'Purwo Bakti',
  },
  {
    id: '1509025005',
    districtId: '1509025',
    name: 'Air Gemuruh',
  },
  {
    id: '1509025006',
    districtId: '1509025',
    name: 'Teluk Panjang',
  },
  {
    id: '1509025007',
    districtId: '1509025',
    name: 'Lubuk Benteng',
  },
  {
    id: '1509025008',
    districtId: '1509025',
    name: 'Sarana Jaya',
  },
  {
    id: '1509030004',
    districtId: '1509030',
    name: 'Leban',
  },
  {
    id: '1509030005',
    districtId: '1509030',
    name: 'Lubuk Kayu Aro',
  },
  {
    id: '1509030012',
    districtId: '1509030',
    name: 'Talang Sungai Bungo',
  },
  {
    id: '1509030013',
    districtId: '1509030',
    name: 'Rantau Pandan',
  },
  {
    id: '1509030014',
    districtId: '1509030',
    name: 'Rantau Duku',
  },
  {
    id: '1509030015',
    districtId: '1509030',
    name: 'Lubuk Mayan',
  },
  {
    id: '1509031001',
    districtId: '1509031',
    name: 'Tebing Tinggi',
  },
  {
    id: '1509031002',
    districtId: '1509031',
    name: 'Datar',
  },
  {
    id: '1509031003',
    districtId: '1509031',
    name: 'Bedaro',
  },
  {
    id: '1509031004',
    districtId: '1509031',
    name: 'Baru Pusat Jalo',
  },
  {
    id: '1509031005',
    districtId: '1509031',
    name: 'Tebat',
  },
  {
    id: '1509031006',
    districtId: '1509031',
    name: 'Tanjung Agung',
  },
  {
    id: '1509031007',
    districtId: '1509031',
    name: 'Mangun Jayo',
  },
  {
    id: '1509031008',
    districtId: '1509031',
    name: 'Suka Jaya',
  },
  {
    id: '1509031009',
    districtId: '1509031',
    name: 'Pekan Jumat',
  },
  {
    id: '1509032001',
    districtId: '1509032',
    name: 'Sungai Telang',
  },
  {
    id: '1509032002',
    districtId: '1509032',
    name: 'Timbolasi',
  },
  {
    id: '1509032003',
    districtId: '1509032',
    name: 'Karak Apung',
  },
  {
    id: '1509032004',
    districtId: '1509032',
    name: 'Muara Buat',
  },
  {
    id: '1509032005',
    districtId: '1509032',
    name: 'Buat',
  },
  {
    id: '1509032006',
    districtId: '1509032',
    name: 'Lubuk Beringin',
  },
  {
    id: '1509032007',
    districtId: '1509032',
    name: 'Laman Panjang',
  },
  {
    id: '1509032008',
    districtId: '1509032',
    name: 'Senamat Ulu',
  },
  {
    id: '1509032009',
    districtId: '1509032',
    name: 'Aur Cino',
  },
  {
    id: '1509040001',
    districtId: '1509040',
    name: 'Tanjung',
  },
  {
    id: '1509040002',
    districtId: '1509040',
    name: 'Candi',
  },
  {
    id: '1509040003',
    districtId: '1509040',
    name: 'Telentam',
  },
  {
    id: '1509040004',
    districtId: '1509040',
    name: 'Pasar Rantau Embacang',
  },
  {
    id: '1509040005',
    districtId: '1509040',
    name: 'Sungai Gambir',
  },
  {
    id: '1509040006',
    districtId: '1509040',
    name: 'Pasar Lubuk Landai',
  },
  {
    id: '1509040007',
    districtId: '1509040',
    name: 'Tanah Bekali',
  },
  {
    id: '1509040008',
    districtId: '1509040',
    name: 'Empelu',
  },
  {
    id: '1509040009',
    districtId: '1509040',
    name: 'Teluk Pandak',
  },
  {
    id: '1509040010',
    districtId: '1509040',
    name: 'Tenam',
  },
  {
    id: '1509041001',
    districtId: '1509041',
    name: 'Embacang Gedang',
  },
  {
    id: '1509041002',
    districtId: '1509041',
    name: 'Sungai Mancur',
  },
  {
    id: '1509041003',
    districtId: '1509041',
    name: 'Tanah Periuk',
  },
  {
    id: '1509041004',
    districtId: '1509041',
    name: 'Lubuk Landai',
  },
  {
    id: '1509041005',
    districtId: '1509041',
    name: 'Pematang Panjang',
  },
  {
    id: '1509041006',
    districtId: '1509041',
    name: 'Tebing Tinggi',
  },
  {
    id: '1509041007',
    districtId: '1509041',
    name: 'Rantau Embacang',
  },
  {
    id: '1509041008',
    districtId: '1509041',
    name: 'Paku Aji',
  },
  {
    id: '1509041009',
    districtId: '1509041',
    name: 'Sungai Puri',
  },
  {
    id: '1509041010',
    districtId: '1509041',
    name: 'Sungai Lilin',
  },
  {
    id: '1509041011',
    districtId: '1509041',
    name: 'Sungai Tembang',
  },
  {
    id: '1509041012',
    districtId: '1509041',
    name: 'Rantau Makmur',
  },
  {
    id: '1509050017',
    districtId: '1509050',
    name: 'Tebing Tinggi Uleh',
  },
  {
    id: '1509050018',
    districtId: '1509050',
    name: 'Bukit Kemang',
  },
  {
    id: '1509050019',
    districtId: '1509050',
    name: 'Rambah',
  },
  {
    id: '1509050020',
    districtId: '1509050',
    name: 'Pedukun',
  },
  {
    id: '1509050021',
    districtId: '1509050',
    name: 'Lubuk Niur',
  },
  {
    id: '1509050022',
    districtId: '1509050',
    name: 'Tanah Tumbuh',
  },
  {
    id: '1509050023',
    districtId: '1509050',
    name: 'Teluk Kecimbung',
  },
  {
    id: '1509050024',
    districtId: '1509050',
    name: 'Panjang',
  },
  {
    id: '1509050025',
    districtId: '1509050',
    name: 'Perenti Luweh',
  },
  {
    id: '1509050027',
    districtId: '1509050',
    name: 'Koto Jayo',
  },
  {
    id: '1509050028',
    districtId: '1509050',
    name: 'Renah Jelmu',
  },
  {
    id: '1509051001',
    districtId: '1509051',
    name: 'Rantau Tipu',
  },
  {
    id: '1509051002',
    districtId: '1509051',
    name: 'Renah Sungai Ipuh',
  },
  {
    id: '1509051003',
    districtId: '1509051',
    name: 'Pemunyian',
  },
  {
    id: '1509051004',
    districtId: '1509051',
    name: 'Lubuk Tanah Terban',
  },
  {
    id: '1509051005',
    districtId: '1509051',
    name: 'Renah Sungai Besar',
  },
  {
    id: '1509051006',
    districtId: '1509051',
    name: 'Tanjung Bungo',
  },
  {
    id: '1509051007',
    districtId: '1509051',
    name: 'Tuo Limbur',
  },
  {
    id: '1509051008',
    districtId: '1509051',
    name: 'Muara Tebo Pandak',
  },
  {
    id: '1509051009',
    districtId: '1509051',
    name: 'Tebo Jaya',
  },
  {
    id: '1509051010',
    districtId: '1509051',
    name: 'Sekar Mengkuang',
  },
  {
    id: '1509051011',
    districtId: '1509051',
    name: 'Pauh Agung',
  },
  {
    id: '1509051012',
    districtId: '1509051',
    name: 'Baru Lubuk Mengkuang',
  },
  {
    id: '1509051013',
    districtId: '1509051',
    name: 'Tuo Lubuk Mengkuang',
  },
  {
    id: '1509051018',
    districtId: '1509051',
    name: 'Limbur Baru',
  },
  {
    id: '1509052001',
    districtId: '1509052',
    name: 'Pulau Kerakap',
  },
  {
    id: '1509052002',
    districtId: '1509052',
    name: 'Peninjau',
  },
  {
    id: '1509052003',
    districtId: '1509052',
    name: 'Pelayang',
  },
  {
    id: '1509052004',
    districtId: '1509052',
    name: 'Talang Silungko',
  },
  {
    id: '1509052005',
    districtId: '1509052',
    name: 'Seberang Jaya',
  },
  {
    id: '1509060001',
    districtId: '1509060',
    name: 'Tanjung Belit',
  },
  {
    id: '1509060002',
    districtId: '1509060',
    name: 'Pulau Jelmu',
  },
  {
    id: '1509060003',
    districtId: '1509060',
    name: 'Rantau Ikil',
  },
  {
    id: '1509060004',
    districtId: '1509060',
    name: 'Ujung Tanjung',
  },
  {
    id: '1509060005',
    districtId: '1509060',
    name: 'Sirih Sekapur',
  },
  {
    id: '1509060006',
    districtId: '1509060',
    name: 'Talang Pemesun',
  },
  {
    id: '1509060007',
    districtId: '1509060',
    name: 'Rantau Panjang',
  },
  {
    id: '1509060008',
    districtId: '1509060',
    name: 'Jumbak',
  },
  {
    id: '1509060009',
    districtId: '1509060',
    name: 'Baru Balai Panjang',
  },
  {
    id: '1509060010',
    districtId: '1509060',
    name: 'Sirih Sekapur Perkembangan',
  },
  {
    id: '1509061001',
    districtId: '1509061',
    name: 'Tepian Danto',
  },
  {
    id: '1509061002',
    districtId: '1509061',
    name: 'Aur Gading',
  },
  {
    id: '1509061003',
    districtId: '1509061',
    name: 'Pulau Batu',
  },
  {
    id: '1509061004',
    districtId: '1509061',
    name: 'Sari Mulya',
  },
  {
    id: '1509061005',
    districtId: '1509061',
    name: 'Bukit Sari',
  },
  {
    id: '1509061006',
    districtId: '1509061',
    name: 'Lubuk Tenam',
  },
  {
    id: '1509061007',
    districtId: '1509061',
    name: 'Kuamang',
  },
  {
    id: '1571010003',
    districtId: '1571010',
    name: 'Simpang III Sipin',
  },
  {
    id: '1571010004',
    districtId: '1571010',
    name: 'Suka Karya',
  },
  {
    id: '1571010005',
    districtId: '1571010',
    name: 'Kenali Asam Bawah',
  },
  {
    id: '1571010006',
    districtId: '1571010',
    name: 'Kenali Asam Atas',
  },
  {
    id: '1571010007',
    districtId: '1571010',
    name: 'Paal Lima',
  },
  {
    id: '1571011001',
    districtId: '1571011',
    name: 'Kenali Besar',
  },
  {
    id: '1571011002',
    districtId: '1571011',
    name: 'Rawa Sari',
  },
  {
    id: '1571011003',
    districtId: '1571011',
    name: 'Bagan Pete',
  },
  {
    id: '1571011004',
    districtId: '1571011',
    name: 'Beliung',
  },
  {
    id: '1571011005',
    districtId: '1571011',
    name: 'Mayang Mangurai',
  },
  {
    id: '1571020003',
    districtId: '1571020',
    name: 'Pasir Putih',
  },
  {
    id: '1571020004',
    districtId: '1571020',
    name: 'Wijaya Pura',
  },
  {
    id: '1571020005',
    districtId: '1571020',
    name: 'Pakuan Baru',
  },
  {
    id: '1571020006',
    districtId: '1571020',
    name: 'Tambak Sari',
  },
  {
    id: '1571020007',
    districtId: '1571020',
    name: 'The Hok',
  },
  {
    id: '1571021001',
    districtId: '1571021',
    name: 'Paal Merah',
  },
  {
    id: '1571021002',
    districtId: '1571021',
    name: 'Talang Bakung',
  },
  {
    id: '1571021003',
    districtId: '1571021',
    name: 'Lingkar Selatan',
  },
  {
    id: '1571021004',
    districtId: '1571021',
    name: 'Eka Jaya',
  },
  {
    id: '1571021005',
    districtId: '1571021',
    name: 'Payo Silincah',
  },
  {
    id: '1571030001',
    districtId: '1571030',
    name: 'Kebun Handil',
  },
  {
    id: '1571030002',
    districtId: '1571030',
    name: 'Jelutung',
  },
  {
    id: '1571030003',
    districtId: '1571030',
    name: 'Payo Lebar',
  },
  {
    id: '1571030004',
    districtId: '1571030',
    name: 'Lebak Bandung',
  },
  {
    id: '1571030005',
    districtId: '1571030',
    name: 'Cempaka Putih',
  },
  {
    id: '1571030006',
    districtId: '1571030',
    name: 'Talang Jauh',
  },
  {
    id: '1571030007',
    districtId: '1571030',
    name: 'Handil Jaya',
  },
  {
    id: '1571040001',
    districtId: '1571040',
    name: 'Beringin',
  },
  {
    id: '1571040002',
    districtId: '1571040',
    name: 'Sungai Asam',
  },
  {
    id: '1571040003',
    districtId: '1571040',
    name: 'Orang Kayo Hitam',
  },
  {
    id: '1571040004',
    districtId: '1571040',
    name: 'Pasar Jambi',
  },
  {
    id: '1571050001',
    districtId: '1571050',
    name: 'Penyengat Rendah',
  },
  {
    id: '1571050002',
    districtId: '1571050',
    name: 'Simpang IV Sipin',
  },
  {
    id: '1571050003',
    districtId: '1571050',
    name: 'Telanaipura',
  },
  {
    id: '1571050009',
    districtId: '1571050',
    name: 'Buluran Kenali',
  },
  {
    id: '1571050010',
    districtId: '1571050',
    name: 'Teluk Kenali',
  },
  {
    id: '1571050011',
    districtId: '1571050',
    name: 'Pematang Sulur',
  },
  {
    id: '1571051001',
    districtId: '1571051',
    name: 'Selamat',
  },
  {
    id: '1571051002',
    districtId: '1571051',
    name: 'Sungai Putri',
  },
  {
    id: '1571051003',
    districtId: '1571051',
    name: 'Solok Sipin',
  },
  {
    id: '1571051004',
    districtId: '1571051',
    name: 'Murni',
  },
  {
    id: '1571051005',
    districtId: '1571051',
    name: 'Legok',
  },
  {
    id: '1571060001',
    districtId: '1571060',
    name: 'Pasir Panjang',
  },
  {
    id: '1571060002',
    districtId: '1571060',
    name: 'Tanjung Raden',
  },
  {
    id: '1571060003',
    districtId: '1571060',
    name: 'Tanjung Pasir',
  },
  {
    id: '1571060004',
    districtId: '1571060',
    name: 'Olak Kemang',
  },
  {
    id: '1571060005',
    districtId: '1571060',
    name: 'Ulu Gedong',
  },
  {
    id: '1571070001',
    districtId: '1571070',
    name: 'Tengah',
  },
  {
    id: '1571070002',
    districtId: '1571070',
    name: 'Jelmu',
  },
  {
    id: '1571070003',
    districtId: '1571070',
    name: 'Mudung Laut',
  },
  {
    id: '1571070004',
    districtId: '1571070',
    name: 'Arab Melayu',
  },
  {
    id: '1571070005',
    districtId: '1571070',
    name: 'Tahtul Yaman',
  },
  {
    id: '1571070006',
    districtId: '1571070',
    name: 'Tanjung Johor',
  },
  {
    id: '1571080001',
    districtId: '1571080',
    name: 'Sulan Jana',
  },
  {
    id: '1571080002',
    districtId: '1571080',
    name: 'Budiman',
  },
  {
    id: '1571080003',
    districtId: '1571080',
    name: 'Talang Banjar',
  },
  {
    id: '1571080005',
    districtId: '1571080',
    name: 'Tanjung Sari',
  },
  {
    id: '1571080006',
    districtId: '1571080',
    name: 'Tanjung Pinang',
  },
  {
    id: '1571080007',
    districtId: '1571080',
    name: 'Rajawali',
  },
  {
    id: '1571080008',
    districtId: '1571080',
    name: 'Kasang',
  },
  {
    id: '1571080009',
    districtId: '1571080',
    name: 'Kasang Jaya',
  },
  {
    id: '1571080010',
    districtId: '1571080',
    name: 'Sijinjang',
  },
  {
    id: '1572010001',
    districtId: '1572010',
    name: 'Dusun Baru Debai',
  },
  {
    id: '1572010002',
    districtId: '1572010',
    name: 'Pendung Hiang',
  },
  {
    id: '1572010003',
    districtId: '1572010',
    name: 'Koto Padang',
  },
  {
    id: '1572010004',
    districtId: '1572010',
    name: 'Mekar Jaya',
  },
  {
    id: '1572010005',
    districtId: '1572010',
    name: 'Koto Dumo',
  },
  {
    id: '1572010006',
    districtId: '1572010',
    name: 'Sembilan',
  },
  {
    id: '1572010007',
    districtId: '1572010',
    name: 'Tanjung Karang',
  },
  {
    id: '1572010008',
    districtId: '1572010',
    name: 'Koto Panap',
  },
  {
    id: '1572010009',
    districtId: '1572010',
    name: 'Koto Baru Tanah Kampung',
  },
  {
    id: '1572010010',
    districtId: '1572010',
    name: 'Koto Pudung',
  },
  {
    id: '1572010011',
    districtId: '1572010',
    name: 'Koto Tengah',
  },
  {
    id: '1572010012',
    districtId: '1572010',
    name: 'Koto Tuo',
  },
  {
    id: '1572010013',
    districtId: '1572010',
    name: 'Tanjung Bunga',
  },
  {
    id: '1572020001',
    districtId: '1572020',
    name: 'Renah Kayu Embun',
  },
  {
    id: '1572020002',
    districtId: '1572020',
    name: 'Air Teluh',
  },
  {
    id: '1572020003',
    districtId: '1572020',
    name: 'Kumun Mudik',
  },
  {
    id: '1572020004',
    districtId: '1572020',
    name: 'Muara Jaya',
  },
  {
    id: '1572020005',
    districtId: '1572020',
    name: 'Kumun Hilir',
  },
  {
    id: '1572020006',
    districtId: '1572020',
    name: 'Ulu Air',
  },
  {
    id: '1572020007',
    districtId: '1572020',
    name: 'Sandaran Galeh',
  },
  {
    id: '1572020008',
    districtId: '1572020',
    name: 'Pinggir Air',
  },
  {
    id: '1572020009',
    districtId: '1572020',
    name: 'Debai',
  },
  {
    id: '1572030006',
    districtId: '1572030',
    name: 'Gedang',
  },
  {
    id: '1572030007',
    districtId: '1572030',
    name: 'Pasar Baru',
  },
  {
    id: '1572030008',
    districtId: '1572030',
    name: 'Kelurahan Sungai Penuh',
  },
  {
    id: '1572030010',
    districtId: '1572030',
    name: 'Kelurahan Pasar Sungai Penuh',
  },
  {
    id: '1572030013',
    districtId: '1572030',
    name: 'Amar Sakti',
  },
  {
    id: '1572031001',
    districtId: '1572031',
    name: 'Sungai Jernih',
  },
  {
    id: '1572031002',
    districtId: '1572031',
    name: 'Koto Lebu',
  },
  {
    id: '1572031003',
    districtId: '1572031',
    name: 'Karya Bakti',
  },
  {
    id: '1572031004',
    districtId: '1572031',
    name: 'Lawang Agung',
  },
  {
    id: '1572031005',
    districtId: '1572031',
    name: 'Kelurahan Pondok Tinggi',
  },
  {
    id: '1572031006',
    districtId: '1572031',
    name: 'Permanti',
  },
  {
    id: '1572031007',
    districtId: '1572031',
    name: 'Pondok Agung',
  },
  {
    id: '1572031008',
    districtId: '1572031',
    name: 'Aur Duri',
  },
  {
    id: '1572032001',
    districtId: '1572032',
    name: 'Sumur Anyir',
  },
  {
    id: '1572032002',
    districtId: '1572032',
    name: 'Pelayang Raya',
  },
  {
    id: '1572032003',
    districtId: '1572032',
    name: 'Talang Lindung',
  },
  {
    id: '1572032004',
    districtId: '1572032',
    name: 'Sungai Ning',
  },
  {
    id: '1572032005',
    districtId: '1572032',
    name: 'Koto Tinggi',
  },
  {
    id: '1572032006',
    districtId: '1572032',
    name: 'Kelurahan Dusun Baru',
  },
  {
    id: '1572040001',
    districtId: '1572040',
    name: 'Tanjung Muda',
  },
  {
    id: '1572040002',
    districtId: '1572040',
    name: 'Tanjung',
  },
  {
    id: '1572040003',
    districtId: '1572040',
    name: 'Paling Serumpun',
  },
  {
    id: '1572040004',
    districtId: '1572040',
    name: 'Simpang Tiga Rawang',
  },
  {
    id: '1572040005',
    districtId: '1572040',
    name: 'Dusun Diilir',
  },
  {
    id: '1572040006',
    districtId: '1572040',
    name: 'Kampung Diilir',
  },
  {
    id: '1572040007',
    districtId: '1572040',
    name: 'Koto Teluk',
  },
  {
    id: '1572040008',
    districtId: '1572040',
    name: 'Cempaka',
  },
  {
    id: '1572040009',
    districtId: '1572040',
    name: 'Koto Beringin',
  },
  {
    id: '1572040010',
    districtId: '1572040',
    name: 'Maliki Air',
  },
  {
    id: '1572040011',
    districtId: '1572040',
    name: 'Kampung Dalam',
  },
  {
    id: '1572040012',
    districtId: '1572040',
    name: 'Larik Kemahan',
  },
  {
    id: '1572040013',
    districtId: '1572040',
    name: 'Koto Dian',
  },
  {
    id: '1572050001',
    districtId: '1572050',
    name: 'Koto Renah',
  },
  {
    id: '1572050002',
    districtId: '1572050',
    name: 'Koto Keras',
  },
  {
    id: '1572050007',
    districtId: '1572050',
    name: 'Koto Bento',
  },
  {
    id: '1572050008',
    districtId: '1572050',
    name: 'Koto Tengah',
  },
  {
    id: '1572050009',
    districtId: '1572050',
    name: 'Koto Lolo',
  },
  {
    id: '1572050010',
    districtId: '1572050',
    name: 'Koto Dua',
  },
  {
    id: '1572050011',
    districtId: '1572050',
    name: 'Seberang',
  },
  {
    id: '1572050012',
    districtId: '1572050',
    name: 'Sumur Gedang',
  },
  {
    id: '1572050013',
    districtId: '1572050',
    name: 'Sungai Liuk',
  },
  {
    id: '1572051001',
    districtId: '1572051',
    name: 'Baru Sri Menanti',
  },
  {
    id: '1572051002',
    districtId: '1572051',
    name: 'Koto Limau Manis',
  },
  {
    id: '1572051003',
    districtId: '1572051',
    name: 'Koto Baru',
  },
  {
    id: '1572051004',
    districtId: '1572051',
    name: 'Permai Indah',
  },
  {
    id: '1572051005',
    districtId: '1572051',
    name: 'Kampung Tengah',
  },
  {
    id: '1572051006',
    districtId: '1572051',
    name: 'Dujung Sakti',
  },
  {
    id: '1601052001',
    districtId: '1601052',
    name: 'Bandar Jaya',
  },
  {
    id: '1601052002',
    districtId: '1601052',
    name: 'Karang Endah',
  },
  {
    id: '1601052003',
    districtId: '1601052',
    name: 'Pajar Bulan',
  },
  {
    id: '1601052004',
    districtId: '1601052',
    name: 'Pagar Dewa',
  },
  {
    id: '1601052005',
    districtId: '1601052',
    name: 'Tanjung Lengkayap',
  },
  {
    id: '1601052006',
    districtId: '1601052',
    name: 'Bumi Kawa',
  },
  {
    id: '1601052007',
    districtId: '1601052',
    name: 'Negeri Ratu',
  },
  {
    id: '1601052008',
    districtId: '1601052',
    name: 'Lubuk Dalam',
  },
  {
    id: '1601052009',
    districtId: '1601052',
    name: 'Segara Kembang',
  },
  {
    id: '1601052010',
    districtId: '1601052',
    name: 'Sukaraja',
  },
  {
    id: '1601052011',
    districtId: '1601052',
    name: 'Gedung Pakuan',
  },
  {
    id: '1601052012',
    districtId: '1601052',
    name: 'Tualang',
  },
  {
    id: '1601052013',
    districtId: '1601052',
    name: 'Sundan',
  },
  {
    id: '1601052014',
    districtId: '1601052',
    name: 'Tihang',
  },
  {
    id: '1601052015',
    districtId: '1601052',
    name: 'Lubuk Hara',
  },
  {
    id: '1601052016',
    districtId: '1601052',
    name: 'Negeri Agung',
  },
  {
    id: '1601052017',
    districtId: '1601052',
    name: 'Way Heling',
  },
  {
    id: '1601052018',
    districtId: '1601052',
    name: 'Bunga Tanjung',
  },
  {
    id: '1601052019',
    districtId: '1601052',
    name: 'Umpam',
  },
  {
    id: '1601052020',
    districtId: '1601052',
    name: 'Tanjung Agung',
  },
  {
    id: '1601052021',
    districtId: '1601052',
    name: 'Simpang Empat',
  },
  {
    id: '1601052022',
    districtId: '1601052',
    name: 'Fajar Jaya',
  },
  {
    id: '1601070001',
    districtId: '1601070',
    name: 'Negeri Sindang',
  },
  {
    id: '1601070002',
    districtId: '1601070',
    name: 'Rantau Kumpai',
  },
  {
    id: '1601070003',
    districtId: '1601070',
    name: 'Tungku Jaya',
  },
  {
    id: '1601070004',
    districtId: '1601070',
    name: 'Lubuk Baru',
  },
  {
    id: '1601070005',
    districtId: '1601070',
    name: 'Bandar',
  },
  {
    id: '1601070006',
    districtId: '1601070',
    name: 'Lubuk Leban',
  },
  {
    id: '1601070007',
    districtId: '1601070',
    name: 'Penyandingan',
  },
  {
    id: '1601070008',
    districtId: '1601070',
    name: 'Kungkilan',
  },
  {
    id: '1601070009',
    districtId: '1601070',
    name: 'Mekar Jaya',
  },
  {
    id: '1601070010',
    districtId: '1601070',
    name: 'Penantian',
  },
  {
    id: '1601070011',
    districtId: '1601070',
    name: 'Mekar Sari',
  },
  {
    id: '1601080008',
    districtId: '1601080',
    name: 'Gunung Meraksa',
  },
  {
    id: '1601080010',
    districtId: '1601080',
    name: 'Tanjung Pura',
  },
  {
    id: '1601080011',
    districtId: '1601080',
    name: 'Tanjung Sari',
  },
  {
    id: '1601080012',
    districtId: '1601080',
    name: 'Tangsi Lontar',
  },
  {
    id: '1601080017',
    districtId: '1601080',
    name: 'Belambangan',
  },
  {
    id: '1601080018',
    districtId: '1601080',
    name: 'Kesambi Rata',
  },
  {
    id: '1601080021',
    districtId: '1601080',
    name: 'Gunung Liwat',
  },
  {
    id: '1601080022',
    districtId: '1601080',
    name: 'Semanding',
  },
  {
    id: '1601080023',
    districtId: '1601080',
    name: 'Pengandonan',
  },
  {
    id: '1601080024',
    districtId: '1601080',
    name: 'Tanjungan',
  },
  {
    id: '1601080025',
    districtId: '1601080',
    name: 'Ujan Mas',
  },
  {
    id: '1601080026',
    districtId: '1601080',
    name: 'Gunung Kuripan',
  },
  {
    id: '1601081001',
    districtId: '1601081',
    name: 'Tanjung Kurung',
  },
  {
    id: '1601081002',
    districtId: '1601081',
    name: 'Sukarami',
  },
  {
    id: '1601081003',
    districtId: '1601081',
    name: 'Batang Hari',
  },
  {
    id: '1601081004',
    districtId: '1601081',
    name: 'Nyiur Sayak',
  },
  {
    id: '1601081005',
    districtId: '1601081',
    name: 'Suka Merindu',
  },
  {
    id: '1601081006',
    districtId: '1601081',
    name: 'Padang Bindu',
  },
  {
    id: '1601081007',
    districtId: '1601081',
    name: 'Panggal Panggal',
  },
  {
    id: '1601081008',
    districtId: '1601081',
    name: 'Bedegung',
  },
  {
    id: '1601081009',
    districtId: '1601081',
    name: 'Ulak Pandan',
  },
  {
    id: '1601081010',
    districtId: '1601081',
    name: 'Kebon Agung',
  },
  {
    id: '1601081011',
    districtId: '1601081',
    name: 'Tubohan',
  },
  {
    id: '1601081012',
    districtId: '1601081',
    name: 'Raksa Jiwa',
  },
  {
    id: '1601081013',
    districtId: '1601081',
    name: 'Guna Makmur',
  },
  {
    id: '1601081014',
    districtId: '1601081',
    name: 'Seleman',
  },
  {
    id: '1601081015',
    districtId: '1601081',
    name: 'Kebun Jati',
  },
  {
    id: '1601081016',
    districtId: '1601081',
    name: 'Singapura',
  },
  {
    id: '1601081017',
    districtId: '1601081',
    name: 'Pengaringan',
  },
  {
    id: '1601081018',
    districtId: '1601081',
    name: 'Panai Makmur',
  },
  {
    id: '1601081019',
    districtId: '1601081',
    name: 'Banjar Sari',
  },
  {
    id: '1601081020',
    districtId: '1601081',
    name: 'Pandan Dulang',
  },
  {
    id: '1601081021',
    districtId: '1601081',
    name: 'Tebing Kampung',
  },
  {
    id: '1601082001',
    districtId: '1601082',
    name: 'Kelumpang',
  },
  {
    id: '1601082002',
    districtId: '1601082',
    name: 'Mendingin',
  },
  {
    id: '1601082003',
    districtId: '1601082',
    name: 'Sukajadi',
  },
  {
    id: '1601082004',
    districtId: '1601082',
    name: 'Gunung Tiga',
  },
  {
    id: '1601082005',
    districtId: '1601082',
    name: 'Ulak Lebar',
  },
  {
    id: '1601082006',
    districtId: '1601082',
    name: 'Pedataran',
  },
  {
    id: '1601082007',
    districtId: '1601082',
    name: 'Belandang',
  },
  {
    id: '1601083001',
    districtId: '1601083',
    name: 'Kemala Jaya',
  },
  {
    id: '1601083002',
    districtId: '1601083',
    name: 'Lontar',
  },
  {
    id: '1601083003',
    districtId: '1601083',
    name: 'Lubuk Tupak',
  },
  {
    id: '1601083004',
    districtId: '1601083',
    name: 'Beringin',
  },
  {
    id: '1601083005',
    districtId: '1601083',
    name: 'Muara Saeh',
  },
  {
    id: '1601083006',
    districtId: '1601083',
    name: 'Surau',
  },
  {
    id: '1601083007',
    districtId: '1601083',
    name: 'Karang Lantang',
  },
  {
    id: '1601090015',
    districtId: '1601090',
    name: 'Kepayang',
  },
  {
    id: '1601090017',
    districtId: '1601090',
    name: 'Kedondong',
  },
  {
    id: '1601090018',
    districtId: '1601090',
    name: 'Belimbing',
  },
  {
    id: '1601090021',
    districtId: '1601090',
    name: 'Durian',
  },
  {
    id: '1601090022',
    districtId: '1601090',
    name: 'Espe Tiga',
  },
  {
    id: '1601090023',
    districtId: '1601090',
    name: 'Lubuk Rukam',
  },
  {
    id: '1601090024',
    districtId: '1601090',
    name: 'Bindu',
  },
  {
    id: '1601090028',
    districtId: '1601090',
    name: 'Mendala',
  },
  {
    id: '1601090029',
    districtId: '1601090',
    name: 'Panji Jaya',
  },
  {
    id: '1601090030',
    districtId: '1601090',
    name: 'Makarti Jaya',
  },
  {
    id: '1601090031',
    districtId: '1601090',
    name: 'Makarti Tama',
  },
  {
    id: '1601090032',
    districtId: '1601090',
    name: 'Penilikan/Mitra Ogan',
  },
  {
    id: '1601090033',
    districtId: '1601090',
    name: 'Peninjauan',
  },
  {
    id: '1601090034',
    districtId: '1601090',
    name: 'Saung Naga',
  },
  {
    id: '1601090035',
    districtId: '1601090',
    name: 'Mitra Kencana',
  },
  {
    id: '1601090044',
    districtId: '1601090',
    name: 'Karang Dapo',
  },
  {
    id: '1601091001',
    districtId: '1601091',
    name: 'Merbau',
  },
  {
    id: '1601091002',
    districtId: '1601091',
    name: 'Gunung Meraksa',
  },
  {
    id: '1601091003',
    districtId: '1601091',
    name: 'Kurup',
  },
  {
    id: '1601091004',
    districtId: '1601091',
    name: 'Banu Ayu',
  },
  {
    id: '1601091006',
    districtId: '1601091',
    name: 'Tanjung Dalam',
  },
  {
    id: '1601091007',
    districtId: '1601091',
    name: 'Lubuk Batang Baru',
  },
  {
    id: '1601091008',
    districtId: '1601091',
    name: 'Lubuk Batang Lama',
  },
  {
    id: '1601091010',
    districtId: '1601091',
    name: 'Belatung',
  },
  {
    id: '1601091011',
    districtId: '1601091',
    name: 'Karta Mulia',
  },
  {
    id: '1601091012',
    districtId: '1601091',
    name: 'Markisa',
  },
  {
    id: '1601091013',
    districtId: '1601091',
    name: 'Lunggaian Baru/Air Wal',
  },
  {
    id: '1601091014',
    districtId: '1601091',
    name: 'Lunggaian',
  },
  {
    id: '1601091015',
    districtId: '1601091',
    name: 'Tanjung Manggus',
  },
  {
    id: '1601091016',
    districtId: '1601091',
    name: 'Bandar Agung',
  },
  {
    id: '1601091017',
    districtId: '1601091',
    name: 'Sumber Bahagia',
  },
  {
    id: '1601092001',
    districtId: '1601092',
    name: 'Marga Bakti',
  },
  {
    id: '1601092002',
    districtId: '1601092',
    name: 'Karya Mukti',
  },
  {
    id: '1601092003',
    districtId: '1601092',
    name: 'Karya Jaya',
  },
  {
    id: '1601092004',
    districtId: '1601092',
    name: 'Sri Mulya',
  },
  {
    id: '1601092005',
    districtId: '1601092',
    name: 'Marga Mulya',
  },
  {
    id: '1601092006',
    districtId: '1601092',
    name: 'Tanjung Makmur',
  },
  {
    id: '1601093001',
    districtId: '1601093',
    name: 'Bunglai',
  },
  {
    id: '1601093002',
    districtId: '1601093',
    name: 'Kedaton',
  },
  {
    id: '1601093003',
    districtId: '1601093',
    name: 'Kampai',
  },
  {
    id: '1601093004',
    districtId: '1601093',
    name: 'Rantau Panjang',
  },
  {
    id: '1601093005',
    districtId: '1601093',
    name: 'Suka Pindah',
  },
  {
    id: '1601093006',
    districtId: '1601093',
    name: 'Lubuk Kemiling',
  },
  {
    id: '1601093007',
    districtId: '1601093',
    name: 'Sinar Kedaton',
  },
  {
    id: '1601093008',
    districtId: '1601093',
    name: 'Kedaton Timur',
  },
  {
    id: '1601130004',
    districtId: '1601130',
    name: 'Tanjung Baru',
  },
  {
    id: '1601130005',
    districtId: '1601130',
    name: 'Pasar Baru',
  },
  {
    id: '1601130007',
    districtId: '1601130',
    name: 'Kemala Raja',
  },
  {
    id: '1601130008',
    districtId: '1601130',
    name: 'Sukaraya',
  },
  {
    id: '1601130009',
    districtId: '1601130',
    name: 'Tanjung Kemala',
  },
  {
    id: '1601130010',
    districtId: '1601130',
    name: 'Sukajadi',
  },
  {
    id: '1601130011',
    districtId: '1601130',
    name: 'Air Pauh',
  },
  {
    id: '1601130012',
    districtId: '1601130',
    name: 'Baturaja Permai',
  },
  {
    id: '1601130013',
    districtId: '1601130',
    name: 'Terusan',
  },
  {
    id: '1601130014',
    districtId: '1601130',
    name: 'Sekar Jaya',
  },
  {
    id: '1601130015',
    districtId: '1601130',
    name: 'Sepancar Lawang Kulon',
  },
  {
    id: '1601130016',
    districtId: '1601130',
    name: 'Kemelak Bindung Langit',
  },
  {
    id: '1601130017',
    districtId: '1601130',
    name: 'Baturaja Lama',
  },
  {
    id: '1601131001',
    districtId: '1601131',
    name: 'Batumarta I',
  },
  {
    id: '1601131002',
    districtId: '1601131',
    name: 'Batumarta II',
  },
  {
    id: '1601131003',
    districtId: '1601131',
    name: 'Battu Winangun',
  },
  {
    id: '1601131004',
    districtId: '1601131',
    name: 'Lekis Rejo',
  },
  {
    id: '1601131005',
    districtId: '1601131',
    name: 'Lubuk Banjar',
  },
  {
    id: '1601131006',
    districtId: '1601131',
    name: 'Batu Raden',
  },
  {
    id: '1601131007',
    districtId: '1601131',
    name: 'Marta Jaya',
  },
  {
    id: '1601140001',
    districtId: '1601140',
    name: 'Batu Putih',
  },
  {
    id: '1601140002',
    districtId: '1601140',
    name: 'Laya',
  },
  {
    id: '1601140003',
    districtId: '1601140',
    name: 'Saung Naga',
  },
  {
    id: '1601140004',
    districtId: '1601140',
    name: 'Tanjung Agung',
  },
  {
    id: '1601140005',
    districtId: '1601140',
    name: 'Talang Jawa',
  },
  {
    id: '1601140006',
    districtId: '1601140',
    name: 'Air Gading',
  },
  {
    id: '1601140007',
    districtId: '1601140',
    name: 'Pusar',
  },
  {
    id: '1601140008',
    districtId: '1601140',
    name: 'Batu Kuning',
  },
  {
    id: '1601140009',
    districtId: '1601140',
    name: 'Karang Agung',
  },
  {
    id: '1601140010',
    districtId: '1601140',
    name: 'Karang Endah',
  },
  {
    id: '1601140011',
    districtId: '1601140',
    name: 'Tanjung Karang',
  },
  {
    id: '1601140012',
    districtId: '1601140',
    name: 'Suka Maju',
  },
  {
    id: '1602010001',
    districtId: '1602010',
    name: 'Cahya Bumi',
  },
  {
    id: '1602010002',
    districtId: '1602010',
    name: 'Bumi Arjo',
  },
  {
    id: '1602010003',
    districtId: '1602010',
    name: 'Cahya Tani',
  },
  {
    id: '1602010004',
    districtId: '1602010',
    name: 'Dabuk Rejo',
  },
  {
    id: '1602010005',
    districtId: '1602010',
    name: 'Sukamulya',
  },
  {
    id: '1602010007',
    districtId: '1602010',
    name: 'Tebing Suluh',
  },
  {
    id: '1602010008',
    districtId: '1602010',
    name: 'Cahya Maju',
  },
  {
    id: '1602010009',
    districtId: '1602010',
    name: 'Tulung Harapan',
  },
  {
    id: '1602010010',
    districtId: '1602010',
    name: 'Bumi Agung',
  },
  {
    id: '1602010011',
    districtId: '1602010',
    name: 'Sindang Sari',
  },
  {
    id: '1602010012',
    districtId: '1602010',
    name: 'Sumber Agung',
  },
  {
    id: '1602010014',
    districtId: '1602010',
    name: 'Kepahyang',
  },
  {
    id: '1602010015',
    districtId: '1602010',
    name: 'Tugumulyo',
  },
  {
    id: '1602010016',
    districtId: '1602010',
    name: 'Tugu Agung',
  },
  {
    id: '1602010017',
    districtId: '1602010',
    name: 'Tugu Jaya',
  },
  {
    id: '1602010018',
    districtId: '1602010',
    name: 'Mekar Jaya',
  },
  {
    id: '1602010019',
    districtId: '1602010',
    name: 'Sumber Makmur',
  },
  {
    id: '1602010020',
    districtId: '1602010',
    name: 'Bumi Arjo Makmur',
  },
  {
    id: '1602010021',
    districtId: '1602010',
    name: 'Cahya Makmur',
  },
  {
    id: '1602011001',
    districtId: '1602011',
    name: 'Lempuing Indah',
  },
  {
    id: '1602011002',
    districtId: '1602011',
    name: 'Mukti Sari',
  },
  {
    id: '1602011003',
    districtId: '1602011',
    name: 'Sungai Belida',
  },
  {
    id: '1602011004',
    districtId: '1602011',
    name: 'Lubuk Seberuk',
  },
  {
    id: '1602011005',
    districtId: '1602011',
    name: 'Muara Burnai II',
  },
  {
    id: '1602011006',
    districtId: '1602011',
    name: 'Tania Makmur',
  },
  {
    id: '1602011007',
    districtId: '1602011',
    name: 'Muara Burnai',
  },
  {
    id: '1602011008',
    districtId: '1602011',
    name: 'Rantau Durian II',
  },
  {
    id: '1602011009',
    districtId: '1602011',
    name: 'Rantau Durian',
  },
  {
    id: '1602011010',
    districtId: '1602011',
    name: 'Sukamaju',
  },
  {
    id: '1602011011',
    districtId: '1602011',
    name: 'Suka Jaya',
  },
  {
    id: '1602011012',
    districtId: '1602011',
    name: 'Tanjung Sari II',
  },
  {
    id: '1602011013',
    districtId: '1602011',
    name: 'Tanjung Sari',
  },
  {
    id: '1602011014',
    districtId: '1602011',
    name: 'Purwo Asri',
  },
  {
    id: '1602011015',
    districtId: '1602011',
    name: 'Lubuk Makmur',
  },
  {
    id: '1602011016',
    districtId: '1602011',
    name: 'Rantau Durian Asli',
  },
  {
    id: '1602020015',
    districtId: '1602020',
    name: 'Kali Deras',
  },
  {
    id: '1602020016',
    districtId: '1602020',
    name: 'Sumber Deras',
  },
  {
    id: '1602020017',
    districtId: '1602020',
    name: 'Pematang Panggang',
  },
  {
    id: '1602020018',
    districtId: '1602020',
    name: 'Kembang Jajar Sp7 At',
  },
  {
    id: '1602020025',
    districtId: '1602020',
    name: 'Suryaadi',
  },
  {
    id: '1602020026',
    districtId: '1602020',
    name: 'Jaya Bhakti',
  },
  {
    id: '1602020027',
    districtId: '1602020',
    name: 'Margo Bhakti',
  },
  {
    id: '1602020028',
    districtId: '1602020',
    name: 'Makarti Mulya',
  },
  {
    id: '1602020029',
    districtId: '1602020',
    name: 'Suka Mukti',
  },
  {
    id: '1602020031',
    districtId: '1602020',
    name: 'Sungai Sodong',
  },
  {
    id: '1602020032',
    districtId: '1602020',
    name: 'Mekar Wangi',
  },
  {
    id: '1602020033',
    districtId: '1602020',
    name: 'Karya Mukti',
  },
  {
    id: '1602020049',
    districtId: '1602020',
    name: 'Pagar Dewa',
  },
  {
    id: '1602020050',
    districtId: '1602020',
    name: 'Kota Baru',
  },
  {
    id: '1602020051',
    districtId: '1602020',
    name: 'Sido Basuki',
  },
  {
    id: '1602020052',
    districtId: '1602020',
    name: 'Pematang Kasih',
  },
  {
    id: '1602020053',
    districtId: '1602020',
    name: 'Labuhan Jaya',
  },
  {
    id: '1602021001',
    districtId: '1602021',
    name: 'Sungai Tepuk',
  },
  {
    id: '1602021002',
    districtId: '1602021',
    name: 'Sido Mulyo',
  },
  {
    id: '1602021003',
    districtId: '1602021',
    name: 'Talang Jaya',
  },
  {
    id: '1602021004',
    districtId: '1602021',
    name: 'Sungai Menang',
  },
  {
    id: '1602021005',
    districtId: '1602021',
    name: 'Karangsia',
  },
  {
    id: '1602021006',
    districtId: '1602021',
    name: 'Talang Makmur',
  },
  {
    id: '1602021007',
    districtId: '1602021',
    name: 'Harapan Jaya',
  },
  {
    id: '1602021008',
    districtId: '1602021',
    name: 'Sungai Ceper',
  },
  {
    id: '1602021009',
    districtId: '1602021',
    name: 'Gajah Mati',
  },
  {
    id: '1602021010',
    districtId: '1602021',
    name: 'Bumi Pratama Mandira',
  },
  {
    id: '1602021011',
    districtId: '1602021',
    name: 'Sungai Pinang Indah',
  },
  {
    id: '1602021012',
    districtId: '1602021',
    name: 'Sungai Sibur',
  },
  {
    id: '1602021013',
    districtId: '1602021',
    name: 'Gajah Mukti',
  },
  {
    id: '1602021014',
    districtId: '1602021',
    name: 'Gajah Mulya',
  },
  {
    id: '1602021015',
    districtId: '1602021',
    name: 'Gajah Makmur',
  },
  {
    id: '1602021016',
    districtId: '1602021',
    name: 'Sari Gading',
  },
  {
    id: '1602021017',
    districtId: '1602021',
    name: 'Gading Mas',
  },
  {
    id: '1602021018',
    districtId: '1602021',
    name: 'Gading Jaya',
  },
  {
    id: '1602022001',
    districtId: '1602022',
    name: 'Kampung Baru',
  },
  {
    id: '1602022002',
    districtId: '1602022',
    name: 'Mesuji Jaya',
  },
  {
    id: '1602022003',
    districtId: '1602022',
    name: 'Beringin Jaya',
  },
  {
    id: '1602022004',
    districtId: '1602022',
    name: 'Pematang Bhina Tani',
  },
  {
    id: '1602022005',
    districtId: '1602022',
    name: 'Bhina Karsa',
  },
  {
    id: '1602022006',
    districtId: '1602022',
    name: 'Cahaya Mas',
  },
  {
    id: '1602022007',
    districtId: '1602022',
    name: 'Pematang Sari',
  },
  {
    id: '1602022008',
    districtId: '1602022',
    name: 'Pematang Jaya',
  },
  {
    id: '1602022009',
    districtId: '1602022',
    name: 'Gading Sari',
  },
  {
    id: '1602022010',
    districtId: '1602022',
    name: 'Karya Usaha',
  },
  {
    id: '1602022011',
    districtId: '1602022',
    name: 'Pematang Sukatani',
  },
  {
    id: '1602022012',
    districtId: '1602022',
    name: 'Karya Jaya',
  },
  {
    id: '1602022013',
    districtId: '1602022',
    name: 'Mukti Karya',
  },
  {
    id: '1602022015',
    districtId: '1602022',
    name: 'Surya Karta',
  },
  {
    id: '1602022016',
    districtId: '1602022',
    name: 'Catur Tunggal',
  },
  {
    id: '1602022017',
    districtId: '1602022',
    name: 'Pematang Sukaramah',
  },
  {
    id: '1602022018',
    districtId: '1602022',
    name: 'Sumber Mulya',
  },
  {
    id: '1602022019',
    districtId: '1602022',
    name: 'Cahaya Mulya',
  },
  {
    id: '1602022020',
    districtId: '1602022',
    name: 'Tegal Sari',
  },
  {
    id: '1602023001',
    districtId: '1602023',
    name: 'Balian Makmur',
  },
  {
    id: '1602023002',
    districtId: '1602023',
    name: 'Mulya Jaya',
  },
  {
    id: '1602023003',
    districtId: '1602023',
    name: 'Sumber Baru',
  },
  {
    id: '1602023004',
    districtId: '1602023',
    name: 'Cipta Sari',
  },
  {
    id: '1602023005',
    districtId: '1602023',
    name: 'Sumbu Sari',
  },
  {
    id: '1602023006',
    districtId: '1602023',
    name: 'Suka Sari',
  },
  {
    id: '1602023007',
    districtId: '1602023',
    name: 'Kemang Indah',
  },
  {
    id: '1602023008',
    districtId: '1602023',
    name: 'Mataram Jaya',
  },
  {
    id: '1602023009',
    districtId: '1602023',
    name: 'Rotan Mulya',
  },
  {
    id: '1602023010',
    districtId: '1602023',
    name: 'Gedung Rejo',
  },
  {
    id: '1602023011',
    districtId: '1602023',
    name: 'Sedyo Mulyo',
  },
  {
    id: '1602023012',
    districtId: '1602023',
    name: 'Kerta Mukti',
  },
  {
    id: '1602023013',
    districtId: '1602023',
    name: 'Embacang Permai',
  },
  {
    id: '1602023014',
    districtId: '1602023',
    name: 'Bumi Makmur',
  },
  {
    id: '1602023015',
    districtId: '1602023',
    name: 'Embacang',
  },
  {
    id: '1602023016',
    districtId: '1602023',
    name: 'Balian',
  },
  {
    id: '1602023017',
    districtId: '1602023',
    name: 'Dabuk Makmur',
  },
  {
    id: '1602030010',
    districtId: '1602030',
    name: 'Pulu Beruang',
  },
  {
    id: '1602030011',
    districtId: '1602030',
    name: 'Tulung Selapan Ilir',
  },
  {
    id: '1602030012',
    districtId: '1602030',
    name: 'Tulung Selapan Ulu',
  },
  {
    id: '1602030013',
    districtId: '1602030',
    name: 'Petaling',
  },
  {
    id: '1602030014',
    districtId: '1602030',
    name: 'Kayu Ara',
  },
  {
    id: '1602030015',
    districtId: '1602030',
    name: 'Penyandingan',
  },
  {
    id: '1602030016',
    districtId: '1602030',
    name: 'Tanjung Batu',
  },
  {
    id: '1602030017',
    districtId: '1602030',
    name: 'Cambai',
  },
  {
    id: '1602030018',
    districtId: '1602030',
    name: 'Toman',
  },
  {
    id: '1602030019',
    districtId: '1602030',
    name: 'Jerambah Rengas',
  },
  {
    id: '1602030020',
    districtId: '1602030',
    name: 'Penanggoan Duren',
  },
  {
    id: '1602030021',
    districtId: '1602030',
    name: 'Lebung Itam',
  },
  {
    id: '1602030022',
    districtId: '1602030',
    name: 'Lebung Gajah',
  },
  {
    id: '1602030023',
    districtId: '1602030',
    name: 'Ujung Tanjung',
  },
  {
    id: '1602030024',
    districtId: '1602030',
    name: 'Simpang Tiga',
  },
  {
    id: '1602030025',
    districtId: '1602030',
    name: 'Simpang Tiga Sakti',
  },
  {
    id: '1602030026',
    districtId: '1602030',
    name: 'Simpang Tiga Makmur',
  },
  {
    id: '1602030027',
    districtId: '1602030',
    name: 'Simpang Tiga Jaya',
  },
  {
    id: '1602030028',
    districtId: '1602030',
    name: 'Rantau Lurus',
  },
  {
    id: '1602030029',
    districtId: '1602030',
    name: 'Tulung Seluang',
  },
  {
    id: '1602030030',
    districtId: '1602030',
    name: 'Simpang Tiga Abadi',
  },
  {
    id: '1602030031',
    districtId: '1602030',
    name: 'Kuala Dua Belas',
  },
  {
    id: '1602030032',
    districtId: '1602030',
    name: 'Tulung Selapan Timur',
  },
  {
    id: '1602031001',
    districtId: '1602031',
    name: 'Sungai Somor',
  },
  {
    id: '1602031002',
    districtId: '1602031',
    name: 'Sungai Pasir',
  },
  {
    id: '1602031003',
    districtId: '1602031',
    name: 'Sungai Jeruju',
  },
  {
    id: '1602031004',
    districtId: '1602031',
    name: 'Sungai Lumpur',
  },
  {
    id: '1602031005',
    districtId: '1602031',
    name: 'Ulak Kedondong',
  },
  {
    id: '1602031006',
    districtId: '1602031',
    name: 'Sungai Ketupak',
  },
  {
    id: '1602031007',
    districtId: '1602031',
    name: 'Pelimbangan',
  },
  {
    id: '1602031008',
    districtId: '1602031',
    name: 'Cengal',
  },
  {
    id: '1602031009',
    districtId: '1602031',
    name: 'Talang Rimba',
  },
  {
    id: '1602031010',
    districtId: '1602031',
    name: 'Kuala Sungai Pasir',
  },
  {
    id: '1602031011',
    districtId: '1602031',
    name: 'Kuala Sungai Jeruju',
  },
  {
    id: '1602031012',
    districtId: '1602031',
    name: 'Parit Raya',
  },
  {
    id: '1602031013',
    districtId: '1602031',
    name: 'Lebak Beriang',
  },
  {
    id: '1602031014',
    districtId: '1602031',
    name: 'Balam Jeruju',
  },
  {
    id: '1602031015',
    districtId: '1602031',
    name: 'Pantai Harapan',
  },
  {
    id: '1602031016',
    districtId: '1602031',
    name: 'Adil Makmur',
  },
  {
    id: '1602031017',
    districtId: '1602031',
    name: 'Kebon Cabe',
  },
  {
    id: '1602040001',
    districtId: '1602040',
    name: 'Burnai Timur',
  },
  {
    id: '1602040002',
    districtId: '1602040',
    name: 'Suka Pulih',
  },
  {
    id: '1602040003',
    districtId: '1602040',
    name: 'Menang Raya',
  },
  {
    id: '1602040004',
    districtId: '1602040',
    name: 'Pedamaran VI',
  },
  {
    id: '1602040005',
    districtId: '1602040',
    name: 'Pedamaran V',
  },
  {
    id: '1602040006',
    districtId: '1602040',
    name: 'Pedamaran IV',
  },
  {
    id: '1602040007',
    districtId: '1602040',
    name: 'Pedamaran III',
  },
  {
    id: '1602040008',
    districtId: '1602040',
    name: 'Pedamaran II',
  },
  {
    id: '1602040009',
    districtId: '1602040',
    name: 'Pedamaran I',
  },
  {
    id: '1602040010',
    districtId: '1602040',
    name: 'Sukaraja',
  },
  {
    id: '1602040011',
    districtId: '1602040',
    name: 'Serinanti',
  },
  {
    id: '1602040012',
    districtId: '1602040',
    name: 'Suka Damai',
  },
  {
    id: '1602040013',
    districtId: '1602040',
    name: 'Cinta Jaya',
  },
  {
    id: '1602040014',
    districtId: '1602040',
    name: 'Lebuh Rarak',
  },
  {
    id: '1602041001',
    districtId: '1602041',
    name: 'Mari Baya',
  },
  {
    id: '1602041002',
    districtId: '1602041',
    name: 'Pulau Geronggang',
  },
  {
    id: '1602041003',
    districtId: '1602041',
    name: 'Gading Raja',
  },
  {
    id: '1602041004',
    districtId: '1602041',
    name: 'Sumber Hidup',
  },
  {
    id: '1602041005',
    districtId: '1602041',
    name: 'Pancawarna',
  },
  {
    id: '1602041006',
    districtId: '1602041',
    name: 'Tanjung Makmur',
  },
  {
    id: '1602041007',
    districtId: '1602041',
    name: 'Kayu Labu',
  },
  {
    id: '1602050001',
    districtId: '1602050',
    name: 'Ulak Kapal',
  },
  {
    id: '1602050002',
    districtId: '1602050',
    name: 'Tanjung Merindu',
  },
  {
    id: '1602050003',
    districtId: '1602050',
    name: 'Tanjung Baru',
  },
  {
    id: '1602050004',
    districtId: '1602050',
    name: 'Seri Tanjung',
  },
  {
    id: '1602050005',
    districtId: '1602050',
    name: 'Pengarayan',
  },
  {
    id: '1602050006',
    districtId: '1602050',
    name: 'Sukarami',
  },
  {
    id: '1602050012',
    districtId: '1602050',
    name: 'Sukamulia',
  },
  {
    id: '1602050014',
    districtId: '1602050',
    name: 'Pulau Gemantung',
  },
  {
    id: '1602050015',
    districtId: '1602050',
    name: 'Bumi Agung',
  },
  {
    id: '1602050016',
    districtId: '1602050',
    name: 'Kotabumi',
  },
  {
    id: '1602050017',
    districtId: '1602050',
    name: 'Tanjung Beringin',
  },
  {
    id: '1602050018',
    districtId: '1602050',
    name: 'Juk Dadak',
  },
  {
    id: '1602050019',
    districtId: '1602050',
    name: 'Ulak Balam',
  },
  {
    id: '1602050020',
    districtId: '1602050',
    name: 'Tanjung Laut',
  },
  {
    id: '1602050021',
    districtId: '1602050',
    name: 'Tanjung Laga',
  },
  {
    id: '1602050022',
    districtId: '1602050',
    name: 'Tanjung Lubuk',
  },
  {
    id: '1602050026',
    districtId: '1602050',
    name: 'Jambu Ilir',
  },
  {
    id: '1602050027',
    districtId: '1602050',
    name: 'Atar Balam',
  },
  {
    id: '1602050028',
    districtId: '1602050',
    name: 'Tanjung Harapan',
  },
  {
    id: '1602050029',
    districtId: '1602050',
    name: 'Pulau Gemantung Darat',
  },
  {
    id: '1602050030',
    districtId: '1602050',
    name: 'Pulau Gemantung Ulu',
  },
  {
    id: '1602050031',
    districtId: '1602050',
    name: 'Pulau Gemantung Ilir',
  },
  {
    id: '1602051001',
    districtId: '1602051',
    name: 'Benawa',
  },
  {
    id: '1602051002',
    districtId: '1602051',
    name: 'Panca Tunggal Benawa',
  },
  {
    id: '1602051003',
    districtId: '1602051',
    name: 'Sinar Harapan Mulya',
  },
  {
    id: '1602051004',
    districtId: '1602051',
    name: 'Bumi Harapan',
  },
  {
    id: '1602051005',
    districtId: '1602051',
    name: 'Mulya Guna',
  },
  {
    id: '1602051006',
    districtId: '1602051',
    name: 'Serapek',
  },
  {
    id: '1602051007',
    districtId: '1602051',
    name: 'Sugih Waras',
  },
  {
    id: '1602051008',
    districtId: '1602051',
    name: 'Seriguna',
  },
  {
    id: '1602051009',
    districtId: '1602051',
    name: 'Muara Telang',
  },
  {
    id: '1602051010',
    districtId: '1602051',
    name: 'Kuripan',
  },
  {
    id: '1602051011',
    districtId: '1602051',
    name: 'Penyandingan',
  },
  {
    id: '1602051012',
    districtId: '1602051',
    name: 'Talang Pangeran',
  },
  {
    id: '1602051013',
    districtId: '1602051',
    name: 'Cintamarga',
  },
  {
    id: '1602051014',
    districtId: '1602051',
    name: 'Ulak Ketapang',
  },
  {
    id: '1602060001',
    districtId: '1602060',
    name: 'Buluh Cawang',
  },
  {
    id: '1602060002',
    districtId: '1602060',
    name: 'Banding Anyar',
  },
  {
    id: '1602060003',
    districtId: '1602060',
    name: 'Muara Baru',
  },
  {
    id: '1602060004',
    districtId: '1602060',
    name: 'Anyar',
  },
  {
    id: '1602060005',
    districtId: '1602060',
    name: 'Lubuk Dalam',
  },
  {
    id: '1602060006',
    districtId: '1602060',
    name: 'Kedaton',
  },
  {
    id: '1602060007',
    districtId: '1602060',
    name: 'Jua Jua',
  },
  {
    id: '1602060008',
    districtId: '1602060',
    name: 'Sidakersa',
  },
  {
    id: '1602060009',
    districtId: '1602060',
    name: 'Kota Raya',
  },
  {
    id: '1602060010',
    districtId: '1602060',
    name: 'Perigi',
  },
  {
    id: '1602060011',
    districtId: '1602060',
    name: 'Mangun Jaya',
  },
  {
    id: '1602060012',
    districtId: '1602060',
    name: 'Cinta Raja',
  },
  {
    id: '1602060013',
    districtId: '1602060',
    name: 'Celikah',
  },
  {
    id: '1602060014',
    districtId: '1602060',
    name: 'Paku',
  },
  {
    id: '1602060015',
    districtId: '1602060',
    name: 'Kayu Agung',
  },
  {
    id: '1602060016',
    districtId: '1602060',
    name: 'Tanjung Serang',
  },
  {
    id: '1602060017',
    districtId: '1602060',
    name: 'Tanjung Lubuk',
  },
  {
    id: '1602060018',
    districtId: '1602060',
    name: 'Arisan Buntal',
  },
  {
    id: '1602060019',
    districtId: '1602060',
    name: 'Sukadana',
  },
  {
    id: '1602060020',
    districtId: '1602060',
    name: 'Serigeni Lama',
  },
  {
    id: '1602060021',
    districtId: '1602060',
    name: 'Serigeni Baru',
  },
  {
    id: '1602060022',
    districtId: '1602060',
    name: 'Teloko',
  },
  {
    id: '1602060023',
    districtId: '1602060',
    name: 'Kijang Ulu',
  },
  {
    id: '1602060024',
    districtId: '1602060',
    name: 'Tanjung Menang',
  },
  {
    id: '1602060025',
    districtId: '1602060',
    name: 'Tanjung Rancing',
  },
  {
    id: '1602120001',
    districtId: '1602120',
    name: 'Tanjung Alai',
  },
  {
    id: '1602120002',
    districtId: '1602120',
    name: 'Ulak Jermun',
  },
  {
    id: '1602120003',
    districtId: '1602120',
    name: 'Mangun Jaya',
  },
  {
    id: '1602120004',
    districtId: '1602120',
    name: 'Batu Ampar',
  },
  {
    id: '1602120005',
    districtId: '1602120',
    name: 'Awal Terusan',
  },
  {
    id: '1602120006',
    districtId: '1602120',
    name: 'Terusan Menang',
  },
  {
    id: '1602120007',
    districtId: '1602120',
    name: 'Belanti',
  },
  {
    id: '1602120008',
    districtId: '1602120',
    name: 'Rengas Pitu',
  },
  {
    id: '1602120009',
    districtId: '1602120',
    name: 'Terate',
  },
  {
    id: '1602120010',
    districtId: '1602120',
    name: 'Sp Padang',
  },
  {
    id: '1602120011',
    districtId: '1602120',
    name: 'Rawang Besar',
  },
  {
    id: '1602120012',
    districtId: '1602120',
    name: 'Pematang Buluran',
  },
  {
    id: '1602120015',
    districtId: '1602120',
    name: 'Serdang Menang',
  },
  {
    id: '1602120016',
    districtId: '1602120',
    name: 'Pantai',
  },
  {
    id: '1602120017',
    districtId: '1602120',
    name: 'Bungin Tinggi',
  },
  {
    id: '1602120020',
    districtId: '1602120',
    name: 'Penyandingan',
  },
  {
    id: '1602120021',
    districtId: '1602120',
    name: 'Berkat',
  },
  {
    id: '1602120022',
    districtId: '1602120',
    name: 'Sukaraja',
  },
  {
    id: '1602120023',
    districtId: '1602120',
    name: 'Batu Ampar Baru',
  },
  {
    id: '1602120024',
    districtId: '1602120',
    name: 'Terusan Laut',
  },
  {
    id: '1602121001',
    districtId: '1602121',
    name: 'Pematang Kijang',
  },
  {
    id: '1602121002',
    districtId: '1602121',
    name: 'Bubusan',
  },
  {
    id: '1602121003',
    districtId: '1602121',
    name: 'Air Hitam',
  },
  {
    id: '1602121004',
    districtId: '1602121',
    name: 'Jejawi',
  },
  {
    id: '1602121005',
    districtId: '1602121',
    name: 'Karang Agung',
  },
  {
    id: '1602121006',
    districtId: '1602121',
    name: 'Talang Cempedak',
  },
  {
    id: '1602121007',
    districtId: '1602121',
    name: 'Lubuk Ketepeng',
  },
  {
    id: '1602121008',
    districtId: '1602121',
    name: 'Tanjung Aur',
  },
  {
    id: '1602121009',
    districtId: '1602121',
    name: 'Lingkis',
  },
  {
    id: '1602121010',
    districtId: '1602121',
    name: 'Muara Batun',
  },
  {
    id: '1602121011',
    districtId: '1602121',
    name: 'Terusan Jawa',
  },
  {
    id: '1602121012',
    districtId: '1602121',
    name: 'Simpang Empat',
  },
  {
    id: '1602121013',
    districtId: '1602121',
    name: 'Pedu',
  },
  {
    id: '1602121014',
    districtId: '1602121',
    name: 'Ulak Tembaga',
  },
  {
    id: '1602121015',
    districtId: '1602121',
    name: 'Sukadarma',
  },
  {
    id: '1602121016',
    districtId: '1602121',
    name: 'Tanjung Ali',
  },
  {
    id: '1602121017',
    districtId: '1602121',
    name: 'Padang Bulan',
  },
  {
    id: '1602121018',
    districtId: '1602121',
    name: 'Batun Baru',
  },
  {
    id: '1602121019',
    districtId: '1602121',
    name: 'Danau Ceper',
  },
  {
    id: '1602130001',
    districtId: '1602130',
    name: 'Ulak Kemang',
  },
  {
    id: '1602130002',
    districtId: '1602130',
    name: 'Sepang',
  },
  {
    id: '1602130003',
    districtId: '1602130',
    name: 'Keman',
  },
  {
    id: '1602130004',
    districtId: '1602130',
    name: 'Kandis',
  },
  {
    id: '1602130005',
    districtId: '1602130',
    name: 'Ulak Depati',
  },
  {
    id: '1602130006',
    districtId: '1602130',
    name: 'Jungkal',
  },
  {
    id: '1602130015',
    districtId: '1602130',
    name: 'Serdang',
  },
  {
    id: '1602130016',
    districtId: '1602130',
    name: 'Serimenang',
  },
  {
    id: '1602130017',
    districtId: '1602130',
    name: 'Pampangan',
  },
  {
    id: '1602130018',
    districtId: '1602130',
    name: 'Pulau Betung',
  },
  {
    id: '1602130019',
    districtId: '1602130',
    name: 'Tapus',
  },
  {
    id: '1602130020',
    districtId: '1602130',
    name: 'Pulau Layang',
  },
  {
    id: '1602130021',
    districtId: '1602130',
    name: 'Kuro',
  },
  {
    id: '1602130022',
    districtId: '1602130',
    name: 'Bangsal',
  },
  {
    id: '1602130023',
    districtId: '1602130',
    name: 'Menggeris',
  },
  {
    id: '1602130024',
    districtId: '1602130',
    name: 'Secondong',
  },
  {
    id: '1602130025',
    districtId: '1602130',
    name: 'Jermun',
  },
  {
    id: '1602130035',
    districtId: '1602130',
    name: 'Tanjung Kemang',
  },
  {
    id: '1602130036',
    districtId: '1602130',
    name: 'Ulak Pianggu',
  },
  {
    id: '1602130037',
    districtId: '1602130',
    name: 'Ulak Kemang Baru',
  },
  {
    id: '1602130038',
    districtId: '1602130',
    name: 'Keman Baru',
  },
  {
    id: '1602130039',
    districtId: '1602130',
    name: 'Sri Mulya',
  },
  {
    id: '1602131001',
    districtId: '1602131',
    name: 'Sungai Bungin',
  },
  {
    id: '1602131002',
    districtId: '1602131',
    name: 'Suka Raja',
  },
  {
    id: '1602131003',
    districtId: '1602131',
    name: 'Darat',
  },
  {
    id: '1602131004',
    districtId: '1602131',
    name: 'Sukadamai',
  },
  {
    id: '1602131005',
    districtId: '1602131',
    name: 'Lebung Batang',
  },
  {
    id: '1602131006',
    districtId: '1602131',
    name: 'Pangkalan Lampam',
  },
  {
    id: '1602131007',
    districtId: '1602131',
    name: 'Lirik',
  },
  {
    id: '1602131008',
    districtId: '1602131',
    name: 'Deling',
  },
  {
    id: '1602131009',
    districtId: '1602131',
    name: 'Talang Daya',
  },
  {
    id: '1602131010',
    districtId: '1602131',
    name: 'Air Pedara',
  },
  {
    id: '1602131011',
    districtId: '1602131',
    name: 'Rimba Samak',
  },
  {
    id: '1602131012',
    districtId: '1602131',
    name: 'Pulawan',
  },
  {
    id: '1602131013',
    districtId: '1602131',
    name: 'Riding',
  },
  {
    id: '1602131014',
    districtId: '1602131',
    name: 'Sunggutan',
  },
  {
    id: '1602131015',
    districtId: '1602131',
    name: 'Air Rumbai',
  },
  {
    id: '1602131016',
    districtId: '1602131',
    name: 'Rambai',
  },
  {
    id: '1602131017',
    districtId: '1602131',
    name: 'Perigi',
  },
  {
    id: '1602131018',
    districtId: '1602131',
    name: 'Bukit Batu',
  },
  {
    id: '1602131019',
    districtId: '1602131',
    name: 'Rawa Tenam',
  },
  {
    id: '1602140001',
    districtId: '1602140',
    name: 'Sungai Batang',
  },
  {
    id: '1602140002',
    districtId: '1602140',
    name: 'Bukit Batu',
  },
  {
    id: '1602140003',
    districtId: '1602140',
    name: 'Rengas Abang',
  },
  {
    id: '1602140004',
    districtId: '1602140',
    name: 'Simpang Heran',
  },
  {
    id: '1602140005',
    districtId: '1602140',
    name: 'Banyu Biru',
  },
  {
    id: '1602140006',
    districtId: '1602140',
    name: 'Pangkalan Sakti',
  },
  {
    id: '1602140007',
    districtId: '1602140',
    name: 'Rantau Karya',
  },
  {
    id: '1602140008',
    districtId: '1602140',
    name: 'Nusa Karta',
  },
  {
    id: '1602140009',
    districtId: '1602140',
    name: 'Sri Jaya Baru',
  },
  {
    id: '1602140010',
    districtId: '1602140',
    name: 'Jadi Mulya',
  },
  {
    id: '1602140011',
    districtId: '1602140',
    name: 'Suka Mulya',
  },
  {
    id: '1602140012',
    districtId: '1602140',
    name: 'Mukti Jaya',
  },
  {
    id: '1602140013',
    districtId: '1602140',
    name: 'Kerta Mukti',
  },
  {
    id: '1602140014',
    districtId: '1602140',
    name: 'Negeri Sakti',
  },
  {
    id: '1602140015',
    districtId: '1602140',
    name: 'Pangkalan Damai',
  },
  {
    id: '1602140016',
    districtId: '1602140',
    name: 'Nusantara',
  },
  {
    id: '1602140017',
    districtId: '1602140',
    name: 'Bandar Jaya',
  },
  {
    id: '1602140018',
    districtId: '1602140',
    name: 'Tirta Mulya',
  },
  {
    id: '1602140019',
    districtId: '1602140',
    name: 'Marga Tani',
  },
  {
    id: '1603010001',
    districtId: '1603010',
    name: 'Penindaian',
  },
  {
    id: '1603010002',
    districtId: '1603010',
    name: 'Babatan',
  },
  {
    id: '1603010003',
    districtId: '1603010',
    name: 'Muara Dua',
  },
  {
    id: '1603010004',
    districtId: '1603010',
    name: 'Pulau Panggung',
  },
  {
    id: '1603010005',
    districtId: '1603010',
    name: 'Muara Danau',
  },
  {
    id: '1603010006',
    districtId: '1603010',
    name: 'Penyandingan',
  },
  {
    id: '1603010007',
    districtId: '1603010',
    name: 'Tanah Abang',
  },
  {
    id: '1603010008',
    districtId: '1603010',
    name: 'Karya Nyata',
  },
  {
    id: '1603010009',
    districtId: '1603010',
    name: 'Pagar Agung',
  },
  {
    id: '1603010010',
    districtId: '1603010',
    name: 'Perapau',
  },
  {
    id: '1603011001',
    districtId: '1603011',
    name: 'Segamit',
  },
  {
    id: '1603011002',
    districtId: '1603011',
    name: 'Cahaya Alam',
  },
  {
    id: '1603011003',
    districtId: '1603011',
    name: 'Tanjung Tiga',
  },
  {
    id: '1603011004',
    districtId: '1603011',
    name: 'Tanjung Agung',
  },
  {
    id: '1603011005',
    districtId: '1603011',
    name: 'Datar Lebar',
  },
  {
    id: '1603011006',
    districtId: '1603011',
    name: 'Siring Agung',
  },
  {
    id: '1603011007',
    districtId: '1603011',
    name: 'Aremantai',
  },
  {
    id: '1603011008',
    districtId: '1603011',
    name: 'Pajar Bulan',
  },
  {
    id: '1603011009',
    districtId: '1603011',
    name: 'Pelakat',
  },
  {
    id: '1603011010',
    districtId: '1603011',
    name: 'Danau Gerak',
  },
  {
    id: '1603012001',
    districtId: '1603012',
    name: 'Gunung Agung',
  },
  {
    id: '1603012002',
    districtId: '1603012',
    name: 'Kota Padang',
  },
  {
    id: '1603012003',
    districtId: '1603012',
    name: 'Tenam Bungkuk',
  },
  {
    id: '1603012004',
    districtId: '1603012',
    name: 'Tanjung Raya',
  },
  {
    id: '1603012005',
    districtId: '1603012',
    name: 'Muara Tenang',
  },
  {
    id: '1603012006',
    districtId: '1603012',
    name: 'Seri Tanjung',
  },
  {
    id: '1603012007',
    districtId: '1603012',
    name: 'Tebing Abang',
  },
  {
    id: '1603012008',
    districtId: '1603012',
    name: 'Batu Surau',
  },
  {
    id: '1603012009',
    districtId: '1603012',
    name: 'Rekimai Jaya',
  },
  {
    id: '1603012010',
    districtId: '1603012',
    name: 'Palak Tanah',
  },
  {
    id: '1603012011',
    districtId: '1603012',
    name: 'Kota Agung',
  },
  {
    id: '1603012012',
    districtId: '1603012',
    name: 'Swarna Dwipa',
  },
  {
    id: '1603020001',
    districtId: '1603020',
    name: 'Lubuk Nipis',
  },
  {
    id: '1603020002',
    districtId: '1603020',
    name: 'Padang Bindu',
  },
  {
    id: '1603020003',
    districtId: '1603020',
    name: 'Bedegung',
  },
  {
    id: '1603020004',
    districtId: '1603020',
    name: 'Indramayu',
  },
  {
    id: '1603020005',
    districtId: '1603020',
    name: 'Muara Meo',
  },
  {
    id: '1603020006',
    districtId: '1603020',
    name: 'Pandan Dulang',
  },
  {
    id: '1603020007',
    districtId: '1603020',
    name: 'Suka Raja',
  },
  {
    id: '1603020008',
    districtId: '1603020',
    name: 'Tanjung Baru',
  },
  {
    id: '1603020009',
    districtId: '1603020',
    name: 'Lambur',
  },
  {
    id: '1603020010',
    districtId: '1603020',
    name: 'Lebak Budi',
  },
  {
    id: '1603020011',
    districtId: '1603020',
    name: 'Pandan Enim',
  },
  {
    id: '1603020012',
    districtId: '1603020',
    name: 'Paduraksa',
  },
  {
    id: '1603020013',
    districtId: '1603020',
    name: 'Embawang',
  },
  {
    id: '1603020014',
    districtId: '1603020',
    name: 'Pagar Dewa',
  },
  {
    id: '1603020015',
    districtId: '1603020',
    name: 'Tanjung Bulan',
  },
  {
    id: '1603020016',
    districtId: '1603020',
    name: 'Lesung Batu',
  },
  {
    id: '1603020017',
    districtId: '1603020',
    name: 'Matas',
  },
  {
    id: '1603020018',
    districtId: '1603020',
    name: 'Tanjung Agung',
  },
  {
    id: '1603020019',
    districtId: '1603020',
    name: 'Tanjung Karangan',
  },
  {
    id: '1603020020',
    districtId: '1603020',
    name: 'Seleman',
  },
  {
    id: '1603020021',
    districtId: '1603020',
    name: 'Penyandingan',
  },
  {
    id: '1603020022',
    districtId: '1603020',
    name: 'Tanjung Lalang',
  },
  {
    id: '1603020023',
    districtId: '1603020',
    name: 'Pulau Panggung',
  },
  {
    id: '1603020024',
    districtId: '1603020',
    name: 'Muara Emil',
  },
  {
    id: '1603020025',
    districtId: '1603020',
    name: 'Sugih Waras',
  },
  {
    id: '1603020026',
    districtId: '1603020',
    name: 'Pagar Jati',
  },
  {
    id: '1603031001',
    districtId: '1603031',
    name: 'Marga Mulia',
  },
  {
    id: '1603031002',
    districtId: '1603031',
    name: 'Sumber Rahayu',
  },
  {
    id: '1603031003',
    districtId: '1603031',
    name: 'Kencana Mulia',
  },
  {
    id: '1603031004',
    districtId: '1603031',
    name: 'Sugih Waras',
  },
  {
    id: '1603031005',
    districtId: '1603031',
    name: 'Pagar Agung',
  },
  {
    id: '1603031006',
    districtId: '1603031',
    name: 'Tanjung Raya',
  },
  {
    id: '1603031007',
    districtId: '1603031',
    name: 'Tanjung Dalam',
  },
  {
    id: '1603031008',
    districtId: '1603031',
    name: 'Sukarami',
  },
  {
    id: '1603031009',
    districtId: '1603031',
    name: 'Sugihan',
  },
  {
    id: '1603031010',
    districtId: '1603031',
    name: 'Negeri Agung',
  },
  {
    id: '1603031011',
    districtId: '1603031',
    name: 'Baru Rambang',
  },
  {
    id: '1603031012',
    districtId: '1603031',
    name: 'Air Keruh',
  },
  {
    id: '1603031013',
    districtId: '1603031',
    name: 'Sugih Waras Barat',
  },
  {
    id: '1603032010',
    districtId: '1603032',
    name: 'Aur',
  },
  {
    id: '1603032011',
    districtId: '1603032',
    name: 'Beringin',
  },
  {
    id: '1603032012',
    districtId: '1603032',
    name: 'Suka Merindu',
  },
  {
    id: '1603032013',
    districtId: '1603032',
    name: 'Kota Baru',
  },
  {
    id: '1603032014',
    districtId: '1603032',
    name: 'Pagar Gunung',
  },
  {
    id: '1603032015',
    districtId: '1603032',
    name: 'Jiwa Baru',
  },
  {
    id: '1603032016',
    districtId: '1603032',
    name: 'Gunung Raja',
  },
  {
    id: '1603032017',
    districtId: '1603032',
    name: 'Tanjung Kemala',
  },
  {
    id: '1603032020',
    districtId: '1603032',
    name: 'Menanti',
  },
  {
    id: '1603032021',
    districtId: '1603032',
    name: 'Air Asam',
  },
  {
    id: '1603033001',
    districtId: '1603033',
    name: 'Lubai Persada',
  },
  {
    id: '1603033002',
    districtId: '1603033',
    name: 'Lubai Makmur',
  },
  {
    id: '1603033003',
    districtId: '1603033',
    name: 'Mekar Jaya',
  },
  {
    id: '1603033004',
    districtId: '1603033',
    name: 'Lecah',
  },
  {
    id: '1603033005',
    districtId: '1603033',
    name: 'Prabu Menang',
  },
  {
    id: '1603033006',
    districtId: '1603033',
    name: 'Pagar Dewa',
  },
  {
    id: '1603033007',
    districtId: '1603033',
    name: 'Sumber Mulya',
  },
  {
    id: '1603033008',
    districtId: '1603033',
    name: 'Karang Mulya',
  },
  {
    id: '1603033009',
    districtId: '1603033',
    name: 'Karang Agung',
  },
  {
    id: '1603033010',
    districtId: '1603033',
    name: 'Sumber Asri',
  },
  {
    id: '1603033011',
    districtId: '1603033',
    name: 'Karang Sari',
  },
  {
    id: '1603040001',
    districtId: '1603040',
    name: 'Darmo',
  },
  {
    id: '1603040002',
    districtId: '1603040',
    name: 'Keban Agung',
  },
  {
    id: '1603040003',
    districtId: '1603040',
    name: 'Tanjung Enim Selatan',
  },
  {
    id: '1603040004',
    districtId: '1603040',
    name: 'Tanjung Enim',
  },
  {
    id: '1603040005',
    districtId: '1603040',
    name: 'Pasar Tanjung Enim',
  },
  {
    id: '1603040006',
    districtId: '1603040',
    name: 'Tegal Rejo',
  },
  {
    id: '1603040007',
    districtId: '1603040',
    name: 'Lingga',
  },
  {
    id: '1603050001',
    districtId: '1603050',
    name: 'Tanjung Raja',
  },
  {
    id: '1603050002',
    districtId: '1603050',
    name: 'Karang Raja',
  },
  {
    id: '1603050003',
    districtId: '1603050',
    name: 'Saka Jaya',
  },
  {
    id: '1603050004',
    districtId: '1603050',
    name: 'Pasar I',
  },
  {
    id: '1603050005',
    districtId: '1603050',
    name: 'Pasar II',
  },
  {
    id: '1603050006',
    districtId: '1603050',
    name: 'Pasar III',
  },
  {
    id: '1603050007',
    districtId: '1603050',
    name: 'Tungkal',
  },
  {
    id: '1603050008',
    districtId: '1603050',
    name: 'Lubuk Empelas',
  },
  {
    id: '1603050009',
    districtId: '1603050',
    name: 'Tanjung Jati',
  },
  {
    id: '1603050010',
    districtId: '1603050',
    name: 'Muara Lawai',
  },
  {
    id: '1603050011',
    districtId: '1603050',
    name: 'Muara Enim',
  },
  {
    id: '1603050012',
    districtId: '1603050',
    name: 'Harapan Jaya',
  },
  {
    id: '1603050013',
    districtId: '1603050',
    name: 'Muara Harapan',
  },
  {
    id: '1603050014',
    districtId: '1603050',
    name: 'Kepur',
  },
  {
    id: '1603050015',
    districtId: '1603050',
    name: 'Tanjung Serian',
  },
  {
    id: '1603050016',
    districtId: '1603050',
    name: 'Air Lintang',
  },
  {
    id: '1603051001',
    districtId: '1603051',
    name: 'Tanjung Raman',
  },
  {
    id: '1603051002',
    districtId: '1603051',
    name: 'Muara Gula Baru',
  },
  {
    id: '1603051003',
    districtId: '1603051',
    name: 'Muara Gula Lama',
  },
  {
    id: '1603051004',
    districtId: '1603051',
    name: 'Pinang Belarik',
  },
  {
    id: '1603051005',
    districtId: '1603051',
    name: 'Ujan Mas Lama',
  },
  {
    id: '1603051006',
    districtId: '1603051',
    name: 'Ujan Mas Baru',
  },
  {
    id: '1603051007',
    districtId: '1603051',
    name: 'Guci',
  },
  {
    id: '1603051008',
    districtId: '1603051',
    name: 'Ulak Bandung',
  },
  {
    id: '1603060001',
    districtId: '1603060',
    name: 'Bangun Sari',
  },
  {
    id: '1603060002',
    districtId: '1603060',
    name: 'Sumaja Makmur',
  },
  {
    id: '1603060003',
    districtId: '1603060',
    name: 'Fajar Indah',
  },
  {
    id: '1603060004',
    districtId: '1603060',
    name: 'Kayu Ara Sakti',
  },
  {
    id: '1603060005',
    districtId: '1603060',
    name: 'Penanggiran',
  },
  {
    id: '1603060006',
    districtId: '1603060',
    name: 'Sidomulyo',
  },
  {
    id: '1603060007',
    districtId: '1603060',
    name: 'Gunung Megang Dalam',
  },
  {
    id: '1603060008',
    districtId: '1603060',
    name: 'Gunung Megang Luar',
  },
  {
    id: '1603060009',
    districtId: '1603060',
    name: 'Lubuk Mumpo',
  },
  {
    id: '1603060010',
    districtId: '1603060',
    name: 'Perjito',
  },
  {
    id: '1603060011',
    districtId: '1603060',
    name: 'Tanjung Terang',
  },
  {
    id: '1603060012',
    districtId: '1603060',
    name: 'Tanjung Muning',
  },
  {
    id: '1603060021',
    districtId: '1603060',
    name: 'Panang Jaya',
  },
  {
    id: '1603061001',
    districtId: '1603061',
    name: 'Padang Bindu',
  },
  {
    id: '1603061002',
    districtId: '1603061',
    name: 'Pagar Dewa',
  },
  {
    id: '1603061003',
    districtId: '1603061',
    name: 'Pagar Jati',
  },
  {
    id: '1603061004',
    districtId: '1603061',
    name: 'Betung',
  },
  {
    id: '1603061005',
    districtId: '1603061',
    name: 'Hidup Baru',
  },
  {
    id: '1603061006',
    districtId: '1603061',
    name: 'Rami Pasai',
  },
  {
    id: '1603062013',
    districtId: '1603062',
    name: 'Berugo',
  },
  {
    id: '1603062014',
    districtId: '1603062',
    name: 'Tanjung',
  },
  {
    id: '1603062015',
    districtId: '1603062',
    name: 'Cinta Kasih',
  },
  {
    id: '1603062016',
    districtId: '1603062',
    name: 'Darmo Kasih',
  },
  {
    id: '1603062017',
    districtId: '1603062',
    name: 'Teluk Lubuk',
  },
  {
    id: '1603062018',
    districtId: '1603062',
    name: 'Belimbing',
  },
  {
    id: '1603062019',
    districtId: '1603062',
    name: 'Bulang',
  },
  {
    id: '1603062020',
    districtId: '1603062',
    name: 'Dalam',
  },
  {
    id: '1603062022',
    districtId: '1603062',
    name: 'Belimbing Jaya',
  },
  {
    id: '1603062023',
    districtId: '1603062',
    name: 'Simpang Tanjung',
  },
  {
    id: '1603070001',
    districtId: '1603070',
    name: 'Suban Jeriji',
  },
  {
    id: '1603070002',
    districtId: '1603070',
    name: 'Gemawang',
  },
  {
    id: '1603070003',
    districtId: '1603070',
    name: 'Aur Duri',
  },
  {
    id: '1603070004',
    districtId: '1603070',
    name: 'Manunggal Jaya',
  },
  {
    id: '1603070005',
    districtId: '1603070',
    name: 'Manunggal Makmur',
  },
  {
    id: '1603070006',
    districtId: '1603070',
    name: 'Air Enau UPT XI',
  },
  {
    id: '1603070007',
    districtId: '1603070',
    name: 'Air Talas',
  },
  {
    id: '1603070008',
    districtId: '1603070',
    name: 'Jemenang',
  },
  {
    id: '1603070009',
    districtId: '1603070',
    name: 'Muara Emburung',
  },
  {
    id: '1603070010',
    districtId: '1603070',
    name: 'Tanjung Menang',
  },
  {
    id: '1603070011',
    districtId: '1603070',
    name: 'Tebat Agung',
  },
  {
    id: '1603070012',
    districtId: '1603070',
    name: 'Lubuk Raman',
  },
  {
    id: '1603070013',
    districtId: '1603070',
    name: 'Air Limau',
  },
  {
    id: '1603070014',
    districtId: '1603070',
    name: 'Gerinam',
  },
  {
    id: '1603070015',
    districtId: '1603070',
    name: 'Muara Niru',
  },
  {
    id: '1603070016',
    districtId: '1603070',
    name: 'Banuayu',
  },
  {
    id: '1603070017',
    districtId: '1603070',
    name: 'Kuripan',
  },
  {
    id: '1603070018',
    districtId: '1603070',
    name: 'Gunung Raja',
  },
  {
    id: '1603070019',
    districtId: '1603070',
    name: 'Pangkalan Babat',
  },
  {
    id: '1603070020',
    districtId: '1603070',
    name: 'Batu Raja',
  },
  {
    id: '1603070021',
    districtId: '1603070',
    name: 'Dangku',
  },
  {
    id: '1603070022',
    districtId: '1603070',
    name: 'Siku',
  },
  {
    id: '1603070023',
    districtId: '1603070',
    name: 'Kasih Dewa',
  },
  {
    id: '1603070024',
    districtId: '1603070',
    name: 'Air Cekdam',
  },
  {
    id: '1603070025',
    districtId: '1603070',
    name: 'Kuripan Baru',
  },
  {
    id: '1603070026',
    districtId: '1603070',
    name: 'Kuripan Selatan',
  },
  {
    id: '1603090001',
    districtId: '1603090',
    name: 'Karang Endah Selatan',
  },
  {
    id: '1603090002',
    districtId: '1603090',
    name: 'Karang Endah',
  },
  {
    id: '1603090003',
    districtId: '1603090',
    name: 'Tambangan Kelekar',
  },
  {
    id: '1603090004',
    districtId: '1603090',
    name: 'Sigam',
  },
  {
    id: '1603090005',
    districtId: '1603090',
    name: 'Midar',
  },
  {
    id: '1603090006',
    districtId: '1603090',
    name: 'Jambu',
  },
  {
    id: '1603090007',
    districtId: '1603090',
    name: 'Gaung Telang',
  },
  {
    id: '1603090008',
    districtId: '1603090',
    name: 'Melilian',
  },
  {
    id: '1603090009',
    districtId: '1603090',
    name: 'Pedataran',
  },
  {
    id: '1603090010',
    districtId: '1603090',
    name: 'Sebau',
  },
  {
    id: '1603090011',
    districtId: '1603090',
    name: 'Paya Bakal',
  },
  {
    id: '1603090012',
    districtId: '1603090',
    name: 'Gelumbang',
  },
  {
    id: '1603090013',
    districtId: '1603090',
    name: 'Talang Taling',
  },
  {
    id: '1603090014',
    districtId: '1603090',
    name: 'Pinang Banjar',
  },
  {
    id: '1603090015',
    districtId: '1603090',
    name: 'Segayam',
  },
  {
    id: '1603090016',
    districtId: '1603090',
    name: 'Putak',
  },
  {
    id: '1603090017',
    districtId: '1603090',
    name: 'Suka Menang',
  },
  {
    id: '1603090018',
    districtId: '1603090',
    name: 'Bitis',
  },
  {
    id: '1603090019',
    districtId: '1603090',
    name: 'Gumai',
  },
  {
    id: '1603090020',
    districtId: '1603090',
    name: 'Suka Jaya',
  },
  {
    id: '1603090021',
    districtId: '1603090',
    name: 'Kartamulia',
  },
  {
    id: '1603090022',
    districtId: '1603090',
    name: 'Teluk Limau',
  },
  {
    id: '1603090023',
    districtId: '1603090',
    name: 'Betung',
  },
  {
    id: '1603091007',
    districtId: '1603091',
    name: 'Kemang',
  },
  {
    id: '1603091008',
    districtId: '1603091',
    name: 'Lembak',
  },
  {
    id: '1603091009',
    districtId: '1603091',
    name: 'Sungai Duren',
  },
  {
    id: '1603091010',
    districtId: '1603091',
    name: 'Tapus',
  },
  {
    id: '1603091011',
    districtId: '1603091',
    name: 'Petanang',
  },
  {
    id: '1603091012',
    districtId: '1603091',
    name: 'Talang Nangka',
  },
  {
    id: '1603091013',
    districtId: '1603091',
    name: 'Alai',
  },
  {
    id: '1603091017',
    districtId: '1603091',
    name: 'Tanjung Baru',
  },
  {
    id: '1603091020',
    districtId: '1603091',
    name: 'Lubuk Enau',
  },
  {
    id: '1603091021',
    districtId: '1603091',
    name: 'Alai Selatan',
  },
  {
    id: '1603092001',
    districtId: '1603092',
    name: 'Modong',
  },
  {
    id: '1603092002',
    districtId: '1603092',
    name: 'Tanjung Miring',
  },
  {
    id: '1603092003',
    districtId: '1603092',
    name: 'Suka Cinta',
  },
  {
    id: '1603092004',
    districtId: '1603092',
    name: 'Penandingan',
  },
  {
    id: '1603092005',
    districtId: '1603092',
    name: 'Danau Rata',
  },
  {
    id: '1603092006',
    districtId: '1603092',
    name: 'Suka Maju',
  },
  {
    id: '1603092007',
    districtId: '1603092',
    name: 'Sukarami',
  },
  {
    id: '1603092008',
    districtId: '1603092',
    name: 'Suka Jadi',
  },
  {
    id: '1603092009',
    districtId: '1603092',
    name: 'Suka Dana',
  },
  {
    id: '1603092010',
    districtId: '1603092',
    name: 'Petar Dalam',
  },
  {
    id: '1603092011',
    districtId: '1603092',
    name: 'Paya Angus',
  },
  {
    id: '1603092012',
    districtId: '1603092',
    name: 'Danau Tampang',
  },
  {
    id: '1603092013',
    districtId: '1603092',
    name: 'Kasai',
  },
  {
    id: '1603092014',
    districtId: '1603092',
    name: 'Sungai Rotan',
  },
  {
    id: '1603092015',
    districtId: '1603092',
    name: 'Suka Merindu',
  },
  {
    id: '1603092016',
    districtId: '1603092',
    name: 'Tanding Marga',
  },
  {
    id: '1603092017',
    districtId: '1603092',
    name: 'Muara Lematang',
  },
  {
    id: '1603092018',
    districtId: '1603092',
    name: 'Danau Baru',
  },
  {
    id: '1603092019',
    districtId: '1603092',
    name: 'Petar Luar',
  },
  {
    id: '1603093001',
    districtId: '1603093',
    name: 'Harapan Mulia',
  },
  {
    id: '1603093002',
    districtId: '1603093',
    name: 'Arisan Musi',
  },
  {
    id: '1603093003',
    districtId: '1603093',
    name: 'Gedung Buruk',
  },
  {
    id: '1603093004',
    districtId: '1603093',
    name: 'Kayu Ara Batu',
  },
  {
    id: '1603093005',
    districtId: '1603093',
    name: 'Arisan Musi Timur',
  },
  {
    id: '1603093006',
    districtId: '1603093',
    name: 'Patra Tani',
  },
  {
    id: '1603093007',
    districtId: '1603093',
    name: 'Tanjung Baru',
  },
  {
    id: '1603093008',
    districtId: '1603093',
    name: 'Mulia Abadi',
  },
  {
    id: '1603094001',
    districtId: '1603094',
    name: 'Embacang Kelekar',
  },
  {
    id: '1603094002',
    districtId: '1603094',
    name: 'Teluk Jaya',
  },
  {
    id: '1603094003',
    districtId: '1603094',
    name: 'Menanti',
  },
  {
    id: '1603094004',
    districtId: '1603094',
    name: 'Suban Baru',
  },
  {
    id: '1603094005',
    districtId: '1603094',
    name: 'Pelempang',
  },
  {
    id: '1603094006',
    districtId: '1603094',
    name: 'Tanjung Medang',
  },
  {
    id: '1603094007',
    districtId: '1603094',
    name: 'Menanti Selatan',
  },
  {
    id: '1603095001',
    districtId: '1603095',
    name: 'Babat',
  },
  {
    id: '1603095002',
    districtId: '1603095',
    name: 'Talang Balai',
  },
  {
    id: '1603095003',
    districtId: '1603095',
    name: 'Sialingan',
  },
  {
    id: '1603095004',
    districtId: '1603095',
    name: 'Tanjung Bunut',
  },
  {
    id: '1603095005',
    districtId: '1603095',
    name: 'Ibul',
  },
  {
    id: '1603095006',
    districtId: '1603095',
    name: 'Gaung Asam',
  },
  {
    id: '1603095014',
    districtId: '1603095',
    name: 'Lubuk Semantung',
  },
  {
    id: '1603095016',
    districtId: '1603095',
    name: 'Lubuk Getam',
  },
  {
    id: '1603095018',
    districtId: '1603095',
    name: 'Tanjung Tiga',
  },
  {
    id: '1603095019',
    districtId: '1603095',
    name: 'Talang Beliung',
  },
  {
    id: '1604011001',
    districtId: '1604011',
    name: 'Tanjung Sakti',
  },
  {
    id: '1604011002',
    districtId: '1604011',
    name: 'Penandingan',
  },
  {
    id: '1604011003',
    districtId: '1604011',
    name: 'Tanjung Bulan',
  },
  {
    id: '1604011004',
    districtId: '1604011',
    name: 'Pajar Bulan',
  },
  {
    id: '1604011005',
    districtId: '1604011',
    name: 'Negeri Kaya',
  },
  {
    id: '1604011006',
    districtId: '1604011',
    name: 'Gunung Kerto',
  },
  {
    id: '1604011007',
    districtId: '1604011',
    name: 'Pulau Panggung',
  },
  {
    id: '1604011008',
    districtId: '1604011',
    name: 'Masam Bulau',
  },
  {
    id: '1604011009',
    districtId: '1604011',
    name: 'Gunung Agung',
  },
  {
    id: '1604011010',
    districtId: '1604011',
    name: 'Ulak Lebar',
  },
  {
    id: '1604011011',
    districtId: '1604011',
    name: 'Pagar Agung',
  },
  {
    id: '1604011012',
    districtId: '1604011',
    name: 'Benteng',
  },
  {
    id: '1604011013',
    districtId: '1604011',
    name: 'Pagar Jati',
  },
  {
    id: '1604011014',
    districtId: '1604011',
    name: 'Lubuk Tabun',
  },
  {
    id: '1604011015',
    districtId: '1604011',
    name: 'Lubuk Dalam',
  },
  {
    id: '1604011016',
    districtId: '1604011',
    name: 'Gunung Kembang',
  },
  {
    id: '1604011017',
    districtId: '1604011',
    name: 'Pulau Panas',
  },
  {
    id: '1604011018',
    districtId: '1604011',
    name: 'Sindang Panjang',
  },
  {
    id: '1604012001',
    districtId: '1604012',
    name: 'Karang Agung',
  },
  {
    id: '1604012002',
    districtId: '1604012',
    name: 'Gunung Raya',
  },
  {
    id: '1604012003',
    districtId: '1604012',
    name: 'Talang Tinggi',
  },
  {
    id: '1604012004',
    districtId: '1604012',
    name: 'Simpang III Pumu',
  },
  {
    id: '1604012005',
    districtId: '1604012',
    name: 'Kepala Siring',
  },
  {
    id: '1604012006',
    districtId: '1604012',
    name: 'Genting',
  },
  {
    id: '1604012007',
    districtId: '1604012',
    name: 'Suban',
  },
  {
    id: '1604012008',
    districtId: '1604012',
    name: 'Muara Cawang',
  },
  {
    id: '1604012009',
    districtId: '1604012',
    name: 'Gunung Ayu',
  },
  {
    id: '1604012010',
    districtId: '1604012',
    name: 'Ujung Pulau',
  },
  {
    id: '1604012011',
    districtId: '1604012',
    name: 'Tanjung Alam',
  },
  {
    id: '1604012012',
    districtId: '1604012',
    name: 'Batu Rancing',
  },
  {
    id: '1604012013',
    districtId: '1604012',
    name: 'Gunung Meraksa',
  },
  {
    id: '1604012014',
    districtId: '1604012',
    name: 'Kembang Ayun',
  },
  {
    id: '1604040001',
    districtId: '1604040',
    name: 'Bangke',
  },
  {
    id: '1604040002',
    districtId: '1604040',
    name: 'Tebat Langsat',
  },
  {
    id: '1604040003',
    districtId: '1604040',
    name: 'Tunggul Bute',
  },
  {
    id: '1604040004',
    districtId: '1604040',
    name: 'Tanjung Raman',
  },
  {
    id: '1604040005',
    districtId: '1604040',
    name: 'Gunung Lewat',
  },
  {
    id: '1604040006',
    districtId: '1604040',
    name: 'Singapura',
  },
  {
    id: '1604040007',
    districtId: '1604040',
    name: 'Kebon Jati',
  },
  {
    id: '1604040008',
    districtId: '1604040',
    name: 'Bintuhan',
  },
  {
    id: '1604040009',
    districtId: '1604040',
    name: 'Muntar Alam Baru',
  },
  {
    id: '1604040010',
    districtId: '1604040',
    name: 'Muntar Alam Lama',
  },
  {
    id: '1604040011',
    districtId: '1604040',
    name: 'Pandan Arang Ulu',
  },
  {
    id: '1604040012',
    districtId: '1604040',
    name: 'Karang Endah',
  },
  {
    id: '1604040013',
    districtId: '1604040',
    name: 'Lawang Agung',
  },
  {
    id: '1604040014',
    districtId: '1604040',
    name: 'Kota Agung',
  },
  {
    id: '1604040015',
    districtId: '1604040',
    name: 'Sukarame',
  },
  {
    id: '1604040016',
    districtId: '1604040',
    name: 'Karang Agung',
  },
  {
    id: '1604040017',
    districtId: '1604040',
    name: 'Sukaraja',
  },
  {
    id: '1604040018',
    districtId: '1604040',
    name: 'Gedung Agung',
  },
  {
    id: '1604040019',
    districtId: '1604040',
    name: 'Muara Gula',
  },
  {
    id: '1604040020',
    districtId: '1604040',
    name: 'Tanjung Bulan',
  },
  {
    id: '1604040037',
    districtId: '1604040',
    name: 'Tanjung Beringin',
  },
  {
    id: '1604040039',
    districtId: '1604040',
    name: 'Pagar Ruyung',
  },
  {
    id: '1604041001',
    districtId: '1604041',
    name: 'Karang Lebak',
  },
  {
    id: '1604041002',
    districtId: '1604041',
    name: 'Sukananti',
  },
  {
    id: '1604041003',
    districtId: '1604041',
    name: 'Babatan',
  },
  {
    id: '1604041004',
    districtId: '1604041',
    name: 'Sengkuang',
  },
  {
    id: '1604041005',
    districtId: '1604041',
    name: 'Padang Masat',
  },
  {
    id: '1604041006',
    districtId: '1604041',
    name: 'Penindaian',
  },
  {
    id: '1604041007',
    districtId: '1604041',
    name: 'Muara Tiga',
  },
  {
    id: '1604041008',
    districtId: '1604041',
    name: 'Tebing Tinggi',
  },
  {
    id: '1604041009',
    districtId: '1604041',
    name: 'Datar Balam',
  },
  {
    id: '1604041010',
    districtId: '1604041',
    name: 'Pengentaan',
  },
  {
    id: '1604041011',
    districtId: '1604041',
    name: 'Lesung Batu',
  },
  {
    id: '1604041012',
    districtId: '1604041',
    name: 'Air Puar',
  },
  {
    id: '1604041013',
    districtId: '1604041',
    name: 'Pajar Bulan',
  },
  {
    id: '1604041014',
    districtId: '1604041',
    name: 'Mengkenang',
  },
  {
    id: '1604041015',
    districtId: '1604041',
    name: 'Lawang Agung Mulak',
  },
  {
    id: '1604041020',
    districtId: '1604041',
    name: 'Geramat',
  },
  {
    id: '1604042001',
    districtId: '1604042',
    name: 'Tanjung Nibung',
  },
  {
    id: '1604042002',
    districtId: '1604042',
    name: 'Tanjung Bay',
  },
  {
    id: '1604042003',
    districtId: '1604042',
    name: 'Tanjung Baru',
  },
  {
    id: '1604042004',
    districtId: '1604042',
    name: 'Tanjung Kurung Ulu',
  },
  {
    id: '1604042005',
    districtId: '1604042',
    name: 'Tanjung Kurung Ilir',
  },
  {
    id: '1604042006',
    districtId: '1604042',
    name: 'Padang Perigi',
  },
  {
    id: '1604042007',
    districtId: '1604042',
    name: 'Air Dingin Lama',
  },
  {
    id: '1604042008',
    districtId: '1604042',
    name: 'Air Dingin Baru',
  },
  {
    id: '1604042009',
    districtId: '1604042',
    name: 'Tanjung Tebat',
  },
  {
    id: '1604042010',
    districtId: '1604042',
    name: 'Pandan Arang Ilir',
  },
  {
    id: '1604042011',
    districtId: '1604042',
    name: 'Muara Danau',
  },
  {
    id: '1604042012',
    districtId: '1604042',
    name: 'Talang Jawa',
  },
  {
    id: '1604042013',
    districtId: '1604042',
    name: 'Tanjung Raya',
  },
  {
    id: '1604042014',
    districtId: '1604042',
    name: 'Tanjung Menang',
  },
  {
    id: '1604043001',
    districtId: '1604043',
    name: 'Durian Dangkal',
  },
  {
    id: '1604043002',
    districtId: '1604043',
    name: 'Penandingan',
  },
  {
    id: '1604043003',
    districtId: '1604043',
    name: 'Talang Padang',
  },
  {
    id: '1604043004',
    districtId: '1604043',
    name: 'Lubuk Dendan',
  },
  {
    id: '1604043005',
    districtId: '1604043',
    name: 'Jadian Baru',
  },
  {
    id: '1604043006',
    districtId: '1604043',
    name: 'Jadian Lama',
  },
  {
    id: '1604043007',
    districtId: '1604043',
    name: 'Talang Berangin',
  },
  {
    id: '1604043008',
    districtId: '1604043',
    name: 'Padang Bindu',
  },
  {
    id: '1604043009',
    districtId: '1604043',
    name: 'Keban Agung',
  },
  {
    id: '1604043010',
    districtId: '1604043',
    name: 'Danau Belidang',
  },
  {
    id: '1604050031',
    districtId: '1604050',
    name: 'Tanjung Mulak',
  },
  {
    id: '1604050032',
    districtId: '1604050',
    name: 'Pulau Pinang',
  },
  {
    id: '1604050033',
    districtId: '1604050',
    name: 'Lubuk Sepang',
  },
  {
    id: '1604050034',
    districtId: '1604050',
    name: 'Tanjung Sirih',
  },
  {
    id: '1604050039',
    districtId: '1604050',
    name: 'Perigi',
  },
  {
    id: '1604050040',
    districtId: '1604050',
    name: 'Karang Dalam',
  },
  {
    id: '1604050041',
    districtId: '1604050',
    name: 'Pagar Batu',
  },
  {
    id: '1604050042',
    districtId: '1604050',
    name: 'Kuba',
  },
  {
    id: '1604050043',
    districtId: '1604050',
    name: 'Jati',
  },
  {
    id: '1604050044',
    districtId: '1604050',
    name: 'Muara Siban',
  },
  {
    id: '1604051001',
    districtId: '1604051',
    name: 'Kedaton',
  },
  {
    id: '1604051002',
    districtId: '1604051',
    name: 'Tanjung Agung',
  },
  {
    id: '1604051003',
    districtId: '1604051',
    name: 'Pagar Agung',
  },
  {
    id: '1604051004',
    districtId: '1604051',
    name: 'Muara Dua',
  },
  {
    id: '1604051005',
    districtId: '1604051',
    name: 'Penantian',
  },
  {
    id: '1604051006',
    districtId: '1604051',
    name: 'Merindu',
  },
  {
    id: '1604051007',
    districtId: '1604051',
    name: 'Gemidar Ulu',
  },
  {
    id: '1604051008',
    districtId: '1604051',
    name: 'Gemidar Ilir',
  },
  {
    id: '1604051009',
    districtId: '1604051',
    name: 'Rimba Sujud',
  },
  {
    id: '1604051010',
    districtId: '1604051',
    name: 'Pagar Alam',
  },
  {
    id: '1604051011',
    districtId: '1604051',
    name: 'Padang Pagun',
  },
  {
    id: '1604051012',
    districtId: '1604051',
    name: 'Kupang',
  },
  {
    id: '1604051013',
    districtId: '1604051',
    name: 'Danau',
  },
  {
    id: '1604051014',
    districtId: '1604051',
    name: 'Siring Agung',
  },
  {
    id: '1604051015',
    districtId: '1604051',
    name: 'Batu Rusa',
  },
  {
    id: '1604051016',
    districtId: '1604051',
    name: 'Karang Agung',
  },
  {
    id: '1604051017',
    districtId: '1604051',
    name: 'Sawah Darat',
  },
  {
    id: '1604051018',
    districtId: '1604051',
    name: 'Air Lingkar',
  },
  {
    id: '1604051019',
    districtId: '1604051',
    name: 'Lesung Batu',
  },
  {
    id: '1604051020',
    districtId: '1604051',
    name: 'Bandung Agung',
  },
  {
    id: '1604052001',
    districtId: '1604052',
    name: 'Sp.II UPT Padang Muaradua',
  },
  {
    id: '1604052002',
    districtId: '1604052',
    name: 'Rindu Hati',
  },
  {
    id: '1604052003',
    districtId: '1604052',
    name: 'Lubuk Selo',
  },
  {
    id: '1604052004',
    districtId: '1604052',
    name: 'Sumber Karya',
  },
  {
    id: '1604052005',
    districtId: '1604052',
    name: 'Sinjar Bulan',
  },
  {
    id: '1604052006',
    districtId: '1604052',
    name: 'Padang Gumay',
  },
  {
    id: '1604052007',
    districtId: '1604052',
    name: 'Tanjung Aur',
  },
  {
    id: '1604052008',
    districtId: '1604052',
    name: 'Tanjung Raja',
  },
  {
    id: '1604052009',
    districtId: '1604052',
    name: 'Tinggi Hari',
  },
  {
    id: '1604052010',
    districtId: '1604052',
    name: 'Simpur',
  },
  {
    id: '1604060001',
    districtId: '1604060',
    name: 'Mangun Sari',
  },
  {
    id: '1604060002',
    districtId: '1604060',
    name: 'Pagar Dewa',
  },
  {
    id: '1604060003',
    districtId: '1604060',
    name: 'Serambi',
  },
  {
    id: '1604060004',
    districtId: '1604060',
    name: 'Sukananti',
  },
  {
    id: '1604060005',
    districtId: '1604060',
    name: 'Tanjung Menang',
  },
  {
    id: '1604060006',
    districtId: '1604060',
    name: 'Lubuk Sawung',
  },
  {
    id: '1604060007',
    districtId: '1604060',
    name: 'Gunung Kaya',
  },
  {
    id: '1604060038',
    districtId: '1604060',
    name: 'Gunung Megang',
  },
  {
    id: '1604060039',
    districtId: '1604060',
    name: 'Karang Tanding',
  },
  {
    id: '1604060040',
    districtId: '1604060',
    name: 'Jarai',
  },
  {
    id: '1604060041',
    districtId: '1604060',
    name: 'Muaratawi',
  },
  {
    id: '1604060042',
    districtId: '1604060',
    name: 'Aromantai',
  },
  {
    id: '1604060043',
    districtId: '1604060',
    name: 'Jemaring',
  },
  {
    id: '1604060044',
    districtId: '1604060',
    name: 'Pamah Salak',
  },
  {
    id: '1604060045',
    districtId: '1604060',
    name: 'Pelajaran',
  },
  {
    id: '1604060046',
    districtId: '1604060',
    name: 'Nantigiri',
  },
  {
    id: '1604060047',
    districtId: '1604060',
    name: 'Kedaton',
  },
  {
    id: '1604060048',
    districtId: '1604060',
    name: 'Bandaraji',
  },
  {
    id: '1604060049',
    districtId: '1604060',
    name: 'Tertap',
  },
  {
    id: '1604060050',
    districtId: '1604060',
    name: 'Penantian',
  },
  {
    id: '1604060051',
    districtId: '1604060',
    name: 'Sadan',
  },
  {
    id: '1604061007',
    districtId: '1604061',
    name: 'Aceh',
  },
  {
    id: '1604061008',
    districtId: '1604061',
    name: 'Kota Raya Darat',
  },
  {
    id: '1604061009',
    districtId: '1604061',
    name: 'Pajar Tinggi',
  },
  {
    id: '1604061010',
    districtId: '1604061',
    name: 'Talang Padang Tinggi',
  },
  {
    id: '1604061011',
    districtId: '1604061',
    name: 'Talang Pagar Agung',
  },
  {
    id: '1604061012',
    districtId: '1604061',
    name: 'Talang Baru',
  },
  {
    id: '1604061013',
    districtId: '1604061',
    name: 'Talang Tangsi',
  },
  {
    id: '1604061014',
    districtId: '1604061',
    name: 'Talang Mengkenang',
  },
  {
    id: '1604061015',
    districtId: '1604061',
    name: 'Kota Raya Lembak',
  },
  {
    id: '1604061016',
    districtId: '1604061',
    name: 'Sumur',
  },
  {
    id: '1604061017',
    districtId: '1604061',
    name: 'Pajar Bulan',
  },
  {
    id: '1604061018',
    districtId: '1604061',
    name: 'Pulau Panggung',
  },
  {
    id: '1604061019',
    districtId: '1604061',
    name: 'Bantunan',
  },
  {
    id: '1604061020',
    districtId: '1604061',
    name: 'Sukabumi',
  },
  {
    id: '1604061021',
    districtId: '1604061',
    name: 'Ulak Bandung',
  },
  {
    id: '1604061022',
    districtId: '1604061',
    name: 'Pulau',
  },
  {
    id: '1604061023',
    districtId: '1604061',
    name: 'Benua Raja',
  },
  {
    id: '1604061024',
    districtId: '1604061',
    name: 'Tongkok',
  },
  {
    id: '1604061025',
    districtId: '1604061',
    name: 'Gelung Sakti',
  },
  {
    id: '1604061026',
    districtId: '1604061',
    name: 'Jentian',
  },
  {
    id: '1604062001',
    districtId: '1604062',
    name: 'Muara Payang',
  },
  {
    id: '1604062002',
    districtId: '1604062',
    name: 'Muara Gelumpai',
  },
  {
    id: '1604062003',
    districtId: '1604062',
    name: 'Talang Tinggi',
  },
  {
    id: '1604062004',
    districtId: '1604062',
    name: 'Lawang Agung Lama',
  },
  {
    id: '1604062005',
    districtId: '1604062',
    name: 'Lawang Agung Baru',
  },
  {
    id: '1604062006',
    districtId: '1604062',
    name: 'Muara Jauh',
  },
  {
    id: '1604062007',
    districtId: '1604062',
    name: 'Bandu Agung',
  },
  {
    id: '1604063001',
    districtId: '1604063',
    name: 'Rambai Kaca',
  },
  {
    id: '1604063002',
    districtId: '1604063',
    name: 'Kapitan',
  },
  {
    id: '1604063003',
    districtId: '1604063',
    name: 'Sukamerindu',
  },
  {
    id: '1604063004',
    districtId: '1604063',
    name: 'Gunung Liwat',
  },
  {
    id: '1604063005',
    districtId: '1604063',
    name: 'Karang Caya',
  },
  {
    id: '1604063006',
    districtId: '1604063',
    name: 'Guru Agung',
  },
  {
    id: '1604063007',
    districtId: '1604063',
    name: 'Tanjung Agung',
  },
  {
    id: '1604063008',
    districtId: '1604063',
    name: 'Sukaraja',
  },
  {
    id: '1604063009',
    districtId: '1604063',
    name: 'Tanjung Raya',
  },
  {
    id: '1604063010',
    districtId: '1604063',
    name: 'Pagar Kaya',
  },
  {
    id: '1604111001',
    districtId: '1604111',
    name: 'Darma Raharja',
  },
  {
    id: '1604111002',
    districtId: '1604111',
    name: 'Suka Bakti',
  },
  {
    id: '1604111003',
    districtId: '1604111',
    name: 'Sidomakmur',
  },
  {
    id: '1604111004',
    districtId: '1604111',
    name: 'Saung Naga',
  },
  {
    id: '1604111005',
    districtId: '1604111',
    name: 'Penantian',
  },
  {
    id: '1604111006',
    districtId: '1604111',
    name: 'Singapura',
  },
  {
    id: '1604111007',
    districtId: '1604111',
    name: 'Babat Baru',
  },
  {
    id: '1604111008',
    districtId: '1604111',
    name: 'Ulak Bandung',
  },
  {
    id: '1604111009',
    districtId: '1604111',
    name: 'Jajaran Baru',
  },
  {
    id: '1604111010',
    districtId: '1604111',
    name: 'Wonorejo',
  },
  {
    id: '1604111011',
    districtId: '1604111',
    name: 'Suka Merindu',
  },
  {
    id: '1604111012',
    districtId: '1604111',
    name: 'Jajaran Lama',
  },
  {
    id: '1604111013',
    districtId: '1604111',
    name: 'Lubuk Seketi',
  },
  {
    id: '1604111014',
    districtId: '1604111',
    name: 'Sukarami',
  },
  {
    id: '1604111015',
    districtId: '1604111',
    name: 'Purwo Rejo',
  },
  {
    id: '1604111016',
    districtId: '1604111',
    name: 'Bandarjaya',
  },
  {
    id: '1604111017',
    districtId: '1604111',
    name: 'Wanaraya',
  },
  {
    id: '1604111018',
    districtId: '1604111',
    name: 'Purnamasari',
  },
  {
    id: '1604111019',
    districtId: '1604111',
    name: 'Mekar Jaya',
  },
  {
    id: '1604112001',
    districtId: '1604112',
    name: 'Lubuk Nambulan',
  },
  {
    id: '1604112002',
    districtId: '1604112',
    name: 'Gelumbang',
  },
  {
    id: '1604112003',
    districtId: '1604112',
    name: 'Gunung Aji',
  },
  {
    id: '1604112004',
    districtId: '1604112',
    name: 'Binjai',
  },
  {
    id: '1604112005',
    districtId: '1604112',
    name: 'Sendawar',
  },
  {
    id: '1604112006',
    districtId: '1604112',
    name: 'Gunung Kembang',
  },
  {
    id: '1604112007',
    districtId: '1604112',
    name: 'Bunga Mas',
  },
  {
    id: '1604112008',
    districtId: '1604112',
    name: 'Lubuk Layang Ilir',
  },
  {
    id: '1604112009',
    districtId: '1604112',
    name: 'Lubuk Layang Ulu',
  },
  {
    id: '1604112010',
    districtId: '1604112',
    name: 'Muara Danau',
  },
  {
    id: '1604112011',
    districtId: '1604112',
    name: 'Paduraksa',
  },
  {
    id: '1604112012',
    districtId: '1604112',
    name: 'Gunung Karto',
  },
  {
    id: '1604112013',
    districtId: '1604112',
    name: 'Karang Endah',
  },
  {
    id: '1604112014',
    districtId: '1604112',
    name: 'Petikal Baru',
  },
  {
    id: '1604112015',
    districtId: '1604112',
    name: 'Tanda Raja',
  },
  {
    id: '1604112016',
    districtId: '1604112',
    name: 'Petikal Lama',
  },
  {
    id: '1604112017',
    districtId: '1604112',
    name: 'Muara Empayang',
  },
  {
    id: '1604112018',
    districtId: '1604112',
    name: 'Lubuk Kuta',
  },
  {
    id: '1604112019',
    districtId: '1604112',
    name: 'Seronggo',
  },
  {
    id: '1604112020',
    districtId: '1604112',
    name: 'Gedung Agung',
  },
  {
    id: '1604112021',
    districtId: '1604112',
    name: 'Lubuk Tampang',
  },
  {
    id: '1604112022',
    districtId: '1604112',
    name: 'Cecar',
  },
  {
    id: '1604112023',
    districtId: '1604112',
    name: 'Datar Serdang',
  },
  {
    id: '1604112024',
    districtId: '1604112',
    name: 'Batu Urip',
  },
  {
    id: '1604112025',
    districtId: '1604112',
    name: 'Tanjung Bindu',
  },
  {
    id: '1604112026',
    districtId: '1604112',
    name: 'Babat Lama',
  },
  {
    id: '1604112027',
    districtId: '1604112',
    name: 'Linggar Jaya',
  },
  {
    id: '1604112028',
    districtId: '1604112',
    name: 'Marga Mulia',
  },
  {
    id: '1604112029',
    districtId: '1604112',
    name: 'Kencana Sari',
  },
  {
    id: '1604112030',
    districtId: '1604112',
    name: 'Purwa Raja',
  },
  {
    id: '1604112031',
    districtId: '1604112',
    name: 'Cempaka Sakti',
  },
  {
    id: '1604112032',
    districtId: '1604112',
    name: 'Sukoharjo',
  },
  {
    id: '1604113001',
    districtId: '1604113',
    name: 'Keban Agung Sp I',
  },
  {
    id: '1604113002',
    districtId: '1604113',
    name: 'Pandan Arang',
  },
  {
    id: '1604113003',
    districtId: '1604113',
    name: 'Keban Agung',
  },
  {
    id: '1604113004',
    districtId: '1604113',
    name: 'Tanjung Kurung',
  },
  {
    id: '1604113005',
    districtId: '1604113',
    name: 'Nanjungan',
  },
  {
    id: '1604113006',
    districtId: '1604113',
    name: 'Pulau Beringin',
  },
  {
    id: '1604113007',
    districtId: '1604113',
    name: 'Tanjung Beringin',
  },
  {
    id: '1604113008',
    districtId: '1604113',
    name: 'Pagar Jati',
  },
  {
    id: '1604113009',
    districtId: '1604113',
    name: 'Jagabaya',
  },
  {
    id: '1604113010',
    districtId: '1604113',
    name: 'Sirah Pulau',
  },
  {
    id: '1604113011',
    districtId: '1604113',
    name: 'Tanjung Alam',
  },
  {
    id: '1604113012',
    districtId: '1604113',
    name: 'Karang Cahaya',
  },
  {
    id: '1604113013',
    districtId: '1604113',
    name: 'Pagardin',
  },
  {
    id: '1604113014',
    districtId: '1604113',
    name: 'Banuayu',
  },
  {
    id: '1604113015',
    districtId: '1604113',
    name: 'Beringin Jaya',
  },
  {
    id: '1604113016',
    districtId: '1604113',
    name: 'Padang Bindu',
  },
  {
    id: '1604113017',
    districtId: '1604113',
    name: 'Lubuk Lungkang',
  },
  {
    id: '1604113018',
    districtId: '1604113',
    name: 'Beringin Janggut',
  },
  {
    id: '1604114001',
    districtId: '1604114',
    name: 'Tanjung Aur',
  },
  {
    id: '1604114002',
    districtId: '1604114',
    name: 'Sukaraja',
  },
  {
    id: '1604114003',
    districtId: '1604114',
    name: 'Maspura',
  },
  {
    id: '1604114004',
    districtId: '1604114',
    name: 'Sungai Laru',
  },
  {
    id: '1604114005',
    districtId: '1604114',
    name: 'Tanjung Baru',
  },
  {
    id: '1604114006',
    districtId: '1604114',
    name: 'Muara Lingsing',
  },
  {
    id: '1604114007',
    districtId: '1604114',
    name: 'Kepala Siring',
  },
  {
    id: '1604114008',
    districtId: '1604114',
    name: 'Banyumas',
  },
  {
    id: '1604114009',
    districtId: '1604114',
    name: 'Purbamas',
  },
  {
    id: '1604120026',
    districtId: '1604120',
    name: 'Pagar Agung',
  },
  {
    id: '1604120027',
    districtId: '1604120',
    name: 'Pagar Sari',
  },
  {
    id: '1604120028',
    districtId: '1604120',
    name: 'Pagar Negara',
  },
  {
    id: '1604120029',
    districtId: '1604120',
    name: 'Kota Baru',
  },
  {
    id: '1604120030',
    districtId: '1604120',
    name: 'Bandar Agung',
  },
  {
    id: '1604120031',
    districtId: '1604120',
    name: 'Pasar Lama',
  },
  {
    id: '1604120033',
    districtId: '1604120',
    name: 'Rd. Pjka Lahat',
  },
  {
    id: '1604120034',
    districtId: '1604120',
    name: 'Gunung Gajah',
  },
  {
    id: '1604120035',
    districtId: '1604120',
    name: 'Lahat Tengah',
  },
  {
    id: '1604120036',
    districtId: '1604120',
    name: 'Sukanegara',
  },
  {
    id: '1604120037',
    districtId: '1604120',
    name: 'Selawi',
  },
  {
    id: '1604120039',
    districtId: '1604120',
    name: 'Pasar Baru',
  },
  {
    id: '1604120040',
    districtId: '1604120',
    name: 'Pasar Bawah',
  },
  {
    id: '1604120043',
    districtId: '1604120',
    name: 'Kota Jaya',
  },
  {
    id: '1604120044',
    districtId: '1604120',
    name: 'Kota Negara',
  },
  {
    id: '1604120045',
    districtId: '1604120',
    name: 'Rd. Pjka Bandar Agung',
  },
  {
    id: '1604120049',
    districtId: '1604120',
    name: 'Manggul',
  },
  {
    id: '1604120050',
    districtId: '1604120',
    name: 'Ulak Lebar',
  },
  {
    id: '1604120051',
    districtId: '1604120',
    name: 'Padang Lengkuas',
  },
  {
    id: '1604120052',
    districtId: '1604120',
    name: 'Kota Raya',
  },
  {
    id: '1604120053',
    districtId: '1604120',
    name: 'Keban',
  },
  {
    id: '1604120054',
    districtId: '1604120',
    name: 'Senabing',
  },
  {
    id: '1604120055',
    districtId: '1604120',
    name: 'Makartitama',
  },
  {
    id: '1604120056',
    districtId: '1604120',
    name: 'Ulak Mas',
  },
  {
    id: '1604120057',
    districtId: '1604120',
    name: 'Sari Bunga Mas',
  },
  {
    id: '1604120058',
    districtId: '1604120',
    name: 'Girimuliya',
  },
  {
    id: '1604120059',
    districtId: '1604120',
    name: 'Bandar Jaya',
  },
  {
    id: '1604120060',
    districtId: '1604120',
    name: 'Talang Jawa Selatan',
  },
  {
    id: '1604120061',
    districtId: '1604120',
    name: 'Talang Jawa Utara',
  },
  {
    id: '1604121001',
    districtId: '1604121',
    name: 'Sugi Waras',
  },
  {
    id: '1604121002',
    districtId: '1604121',
    name: 'Tanjung Periuk',
  },
  {
    id: '1604121003',
    districtId: '1604121',
    name: 'Tanjung Karangan',
  },
  {
    id: '1604121004',
    districtId: '1604121',
    name: 'Muara Tandi',
  },
  {
    id: '1604121005',
    districtId: '1604121',
    name: 'Darmo',
  },
  {
    id: '1604121006',
    districtId: '1604121',
    name: 'Endikat Ilir',
  },
  {
    id: '1604121007',
    districtId: '1604121',
    name: 'Tanjung Baru',
  },
  {
    id: '1604121008',
    districtId: '1604121',
    name: 'Ngalam Baru',
  },
  {
    id: '1604121009',
    districtId: '1604121',
    name: 'Mandi Angin',
  },
  {
    id: '1604121010',
    districtId: '1604121',
    name: 'Tanjung Dalam',
  },
  {
    id: '1604121011',
    districtId: '1604121',
    name: 'Tanah Pilih',
  },
  {
    id: '1604121012',
    districtId: '1604121',
    name: 'Tanjung Beringin',
  },
  {
    id: '1604121013',
    districtId: '1604121',
    name: 'Batay',
  },
  {
    id: '1604121014',
    districtId: '1604121',
    name: 'Sukarami',
  },
  {
    id: '1604121015',
    districtId: '1604121',
    name: 'Suka Makmur',
  },
  {
    id: '1604122001',
    districtId: '1604122',
    name: 'Sukajadi',
  },
  {
    id: '1604122002',
    districtId: '1604122',
    name: 'Penandingan',
  },
  {
    id: '1604122003',
    districtId: '1604122',
    name: 'Tanjung Agung',
  },
  {
    id: '1604122004',
    districtId: '1604122',
    name: 'Talang Tinggi',
  },
  {
    id: '1604122005',
    districtId: '1604122',
    name: 'Batu Niding',
  },
  {
    id: '1604122006',
    districtId: '1604122',
    name: 'Tanjung Raya',
  },
  {
    id: '1604122007',
    districtId: '1604122',
    name: 'Lubuk Mabar',
  },
  {
    id: '1604122008',
    districtId: '1604122',
    name: 'Pagar Agung',
  },
  {
    id: '1604122009',
    districtId: '1604122',
    name: 'Lubuk Tuba',
  },
  {
    id: '1604122010',
    districtId: '1604122',
    name: 'Lubuk Atung',
  },
  {
    id: '1604122011',
    districtId: '1604122',
    name: 'Muara Cawang',
  },
  {
    id: '1604123001',
    districtId: '1604123',
    name: 'Tanjung Payang',
  },
  {
    id: '1604123002',
    districtId: '1604123',
    name: 'Banjar Negara',
  },
  {
    id: '1604123003',
    districtId: '1604123',
    name: 'Tanjung Tebat',
  },
  {
    id: '1604123004',
    districtId: '1604123',
    name: 'Karang Anyar',
  },
  {
    id: '1604123005',
    districtId: '1604123',
    name: 'Nantal',
  },
  {
    id: '1604123006',
    districtId: '1604123',
    name: 'Karang Baru',
  },
  {
    id: '1604123007',
    districtId: '1604123',
    name: 'Talang Sejemput',
  },
  {
    id: '1604123008',
    districtId: '1604123',
    name: 'Muara Cawang',
  },
  {
    id: '1604123009',
    districtId: '1604123',
    name: 'Talang Sawah',
  },
  {
    id: '1604123010',
    districtId: '1604123',
    name: 'Kerung',
  },
  {
    id: '1604131010',
    districtId: '1604131',
    name: 'Ulak Pandan',
  },
  {
    id: '1604131011',
    districtId: '1604131',
    name: 'Negeri Agung',
  },
  {
    id: '1604131012',
    districtId: '1604131',
    name: 'Lebak Budi',
  },
  {
    id: '1604131013',
    districtId: '1604131',
    name: 'Suka Cinta',
  },
  {
    id: '1604131014',
    districtId: '1604131',
    name: 'Gunung Agung',
  },
  {
    id: '1604131015',
    districtId: '1604131',
    name: 'Tanjung Pinang',
  },
  {
    id: '1604131016',
    districtId: '1604131',
    name: 'Suka Marga',
  },
  {
    id: '1604131017',
    districtId: '1604131',
    name: 'Payo',
  },
  {
    id: '1604131018',
    districtId: '1604131',
    name: 'Karang Endah',
  },
  {
    id: '1604131019',
    districtId: '1604131',
    name: 'Muara Temiang',
  },
  {
    id: '1604131020',
    districtId: '1604131',
    name: 'Lubuk Kepayang',
  },
  {
    id: '1604131021',
    districtId: '1604131',
    name: 'Tanjung Telang',
  },
  {
    id: '1604131022',
    districtId: '1604131',
    name: 'Kebur',
  },
  {
    id: '1604131023',
    districtId: '1604131',
    name: 'Tanjung Baru',
  },
  {
    id: '1604131024',
    districtId: '1604131',
    name: 'Muara Maung',
  },
  {
    id: '1604131025',
    districtId: '1604131',
    name: 'Telatang',
  },
  {
    id: '1604131026',
    districtId: '1604131',
    name: 'Merapi',
  },
  {
    id: '1604131027',
    districtId: '1604131',
    name: 'Purwosari',
  },
  {
    id: '1604131028',
    districtId: '1604131',
    name: 'Karang Rejo',
  },
  {
    id: '1604132001',
    districtId: '1604132',
    name: 'Sirah Pulau',
  },
  {
    id: '1604132002',
    districtId: '1604132',
    name: 'Prabu Menang',
  },
  {
    id: '1604132003',
    districtId: '1604132',
    name: 'Gunung Kembang',
  },
  {
    id: '1604132004',
    districtId: '1604132',
    name: 'Arahan',
  },
  {
    id: '1604132005',
    districtId: '1604132',
    name: 'Banjar Sari',
  },
  {
    id: '1604132006',
    districtId: '1604132',
    name: 'Tanjung Jambu',
  },
  {
    id: '1604132007',
    districtId: '1604132',
    name: 'Muara Lawai',
  },
  {
    id: '1604132008',
    districtId: '1604132',
    name: 'Lebuay Bandung',
  },
  {
    id: '1604132009',
    districtId: '1604132',
    name: 'Nanjungan',
  },
  {
    id: '1604132010',
    districtId: '1604132',
    name: 'Gedung Agung',
  },
  {
    id: '1604132011',
    districtId: '1604132',
    name: 'Tanjung Lontar',
  },
  {
    id: '1604132012',
    districtId: '1604132',
    name: 'Sengkuang',
  },
  {
    id: '1604132013',
    districtId: '1604132',
    name: 'Cempaka Wangi',
  },
  {
    id: '1604132014',
    districtId: '1604132',
    name: 'Lematang Jaya',
  },
  {
    id: '1604133001',
    districtId: '1604133',
    name: 'Geramat',
  },
  {
    id: '1604133002',
    districtId: '1604133',
    name: 'Lubuk Betung',
  },
  {
    id: '1604133003',
    districtId: '1604133',
    name: 'Perangai',
  },
  {
    id: '1604133004',
    districtId: '1604133',
    name: 'Tanjung Beringin',
  },
  {
    id: '1604133005',
    districtId: '1604133',
    name: 'Suka Merindu',
  },
  {
    id: '1604133006',
    districtId: '1604133',
    name: 'Talang Akar',
  },
  {
    id: '1604133007',
    districtId: '1604133',
    name: 'Lubuk Pedara',
  },
  {
    id: '1604133008',
    districtId: '1604133',
    name: 'Tanjung Menang',
  },
  {
    id: '1604133009',
    districtId: '1604133',
    name: 'Padang',
  },
  {
    id: '1605030003',
    districtId: '1605030',
    name: 'Pasenan',
  },
  {
    id: '1605030015',
    districtId: '1605030',
    name: 'Sukaraya',
  },
  {
    id: '1605030016',
    districtId: '1605030',
    name: 'Terawas',
  },
  {
    id: '1605030018',
    districtId: '1605030',
    name: 'Babat',
  },
  {
    id: '1605030019',
    districtId: '1605030',
    name: 'Suka Mana',
  },
  {
    id: '1605030020',
    districtId: '1605030',
    name: 'Padu Raksa',
  },
  {
    id: '1605030021',
    districtId: '1605030',
    name: 'Sumber Karya',
  },
  {
    id: '1605030022',
    districtId: '1605030',
    name: 'Sri Mulyo',
  },
  {
    id: '1605030023',
    districtId: '1605030',
    name: 'Sukakarya',
  },
  {
    id: '1605030024',
    districtId: '1605030',
    name: 'Sukarejo',
  },
  {
    id: '1605030027',
    districtId: '1605030',
    name: 'Sukamerindu',
  },
  {
    id: '1605030035',
    districtId: '1605030',
    name: 'Kosgoro',
  },
  {
    id: '1605030036',
    districtId: '1605030',
    name: 'Sukaraya Baru',
  },
  {
    id: '1605031001',
    districtId: '1605031',
    name: 'Selangit',
  },
  {
    id: '1605031002',
    districtId: '1605031',
    name: 'Taba Remanik',
  },
  {
    id: '1605031003',
    districtId: '1605031',
    name: 'Taba Tengah',
  },
  {
    id: '1605031004',
    districtId: '1605031',
    name: 'Taba Renah',
  },
  {
    id: '1605031005',
    districtId: '1605031',
    name: 'Prabu Menang',
  },
  {
    id: '1605031006',
    districtId: '1605031',
    name: 'Taba Gindo',
  },
  {
    id: '1605031007',
    districtId: '1605031',
    name: 'Muara Nilau',
  },
  {
    id: '1605031008',
    districtId: '1605031',
    name: 'Karang Panggung',
  },
  {
    id: '1605031009',
    districtId: '1605031',
    name: 'Batu Gane',
  },
  {
    id: '1605031010',
    districtId: '1605031',
    name: 'Napal Melintang',
  },
  {
    id: '1605031011',
    districtId: '1605031',
    name: 'Lubuk Ngin',
  },
  {
    id: '1605031012',
    districtId: '1605031',
    name: 'Lubuk Ngin Baru',
  },
  {
    id: '1605032001',
    districtId: '1605032',
    name: 'Sumber Jaya',
  },
  {
    id: '1605032002',
    districtId: '1605032',
    name: 'Sumber Harta',
  },
  {
    id: '1605032003',
    districtId: '1605032',
    name: 'Jambu Rejo',
  },
  {
    id: '1605032004',
    districtId: '1605032',
    name: 'Suka Maju',
  },
  {
    id: '1605032005',
    districtId: '1605032',
    name: 'Sumber Sari',
  },
  {
    id: '1605032006',
    districtId: '1605032',
    name: 'Suka Mulya',
  },
  {
    id: '1605032007',
    districtId: '1605032',
    name: 'Suka Jaya',
  },
  {
    id: '1605032008',
    districtId: '1605032',
    name: 'Sukarami',
  },
  {
    id: '1605032009',
    districtId: '1605032',
    name: 'Madang',
  },
  {
    id: '1605032010',
    districtId: '1605032',
    name: 'Sumber Asri',
  },
  {
    id: '1605040001',
    districtId: '1605040',
    name: 'Tegal Rejo',
  },
  {
    id: '1605040002',
    districtId: '1605040',
    name: 'Widodo',
  },
  {
    id: '1605040003',
    districtId: '1605040',
    name: 'Surodadi',
  },
  {
    id: '1605040004',
    districtId: '1605040',
    name: 'Srikaton',
  },
  {
    id: '1605040005',
    districtId: '1605040',
    name: 'Kali Bening',
  },
  {
    id: '1605040006',
    districtId: '1605040',
    name: 'Trikoyo',
  },
  {
    id: '1605040007',
    districtId: '1605040',
    name: 'Nawangsasi',
  },
  {
    id: '1605040008',
    districtId: '1605040',
    name: 'Sukomulio',
  },
  {
    id: '1605040009',
    districtId: '1605040',
    name: 'Wonokerto',
  },
  {
    id: '1605040010',
    districtId: '1605040',
    name: 'Wukir Sari',
  },
  {
    id: '1605040011',
    districtId: '1605040',
    name: 'Mataram',
  },
  {
    id: '1605040012',
    districtId: '1605040',
    name: 'Ngadirejo',
  },
  {
    id: '1605040013',
    districtId: '1605040',
    name: 'Sidoharjo',
  },
  {
    id: '1605040014',
    districtId: '1605040',
    name: 'Tambah Asri',
  },
  {
    id: '1605040015',
    districtId: '1605040',
    name: 'Wonorejo',
  },
  {
    id: '1605040016',
    districtId: '1605040',
    name: 'Dwijaya',
  },
  {
    id: '1605040017',
    districtId: '1605040',
    name: 'Siti Harjo',
  },
  {
    id: '1605040018',
    districtId: '1605040',
    name: 'Triwikaton',
  },
  {
    id: '1605041001',
    districtId: '1605041',
    name: 'Mangun Harjo',
  },
  {
    id: '1605041002',
    districtId: '1605041',
    name: 'Mardiharjo',
  },
  {
    id: '1605041003',
    districtId: '1605041',
    name: 'Rejosari',
  },
  {
    id: '1605041004',
    districtId: '1605041',
    name: 'Kertosari',
  },
  {
    id: '1605041005',
    districtId: '1605041',
    name: 'Bangun Sari',
  },
  {
    id: '1605041006',
    districtId: '1605041',
    name: 'Pagarsari',
  },
  {
    id: '1605041007',
    districtId: '1605041',
    name: 'Purwodadi',
  },
  {
    id: '1605041008',
    districtId: '1605041',
    name: 'Purwa Karya',
  },
  {
    id: '1605041009',
    districtId: '1605041',
    name: 'Karyadadi',
  },
  {
    id: '1605041010',
    districtId: '1605041',
    name: 'Sadar Karya',
  },
  {
    id: '1605041011',
    districtId: '1605041',
    name: 'Trikarya',
  },
  {
    id: '1605050014',
    districtId: '1605050',
    name: 'Pedang',
  },
  {
    id: '1605050015',
    districtId: '1605050',
    name: 'Muara Beliti Baru',
  },
  {
    id: '1605050017',
    districtId: '1605050',
    name: 'Pasar Muara Beliti',
  },
  {
    id: '1605050018',
    districtId: '1605050',
    name: 'Suro',
  },
  {
    id: '1605050019',
    districtId: '1605050',
    name: 'Bumi Agung',
  },
  {
    id: '1605050020',
    districtId: '1605050',
    name: 'Mana Resmi',
  },
  {
    id: '1605050025',
    districtId: '1605050',
    name: 'Tanah Periuk I',
  },
  {
    id: '1605050026',
    districtId: '1605050',
    name: 'Ketuan Jaya',
  },
  {
    id: '1605050027',
    districtId: '1605050',
    name: 'Air Satan',
  },
  {
    id: '1605050028',
    districtId: '1605050',
    name: 'Durian Remuk',
  },
  {
    id: '1605050029',
    districtId: '1605050',
    name: 'Satan Indah Jaya',
  },
  {
    id: '1605050030',
    districtId: '1605050',
    name: 'Air Lesing',
  },
  {
    id: '1605051001',
    districtId: '1605051',
    name: 'Rantau Serik',
  },
  {
    id: '1605051002',
    districtId: '1605051',
    name: 'Kebur',
  },
  {
    id: '1605051003',
    districtId: '1605051',
    name: 'Lubuk Besar',
  },
  {
    id: '1605051004',
    districtId: '1605051',
    name: 'Batu Bandung',
  },
  {
    id: '1605051005',
    districtId: '1605051',
    name: 'Muara Kati Baru I',
  },
  {
    id: '1605051006',
    districtId: '1605051',
    name: 'Muara Kati Baru II',
  },
  {
    id: '1605051007',
    districtId: '1605051',
    name: 'Muara Kati Lama',
  },
  {
    id: '1605051008',
    districtId: '1605051',
    name: 'Rantau Bingin',
  },
  {
    id: '1605051009',
    districtId: '1605051',
    name: 'Simpang Gegas Temuan',
  },
  {
    id: '1605051010',
    districtId: '1605051',
    name: 'Kebur Jaya',
  },
  {
    id: '1605060001',
    districtId: '1605060',
    name: 'Margatunggal',
  },
  {
    id: '1605060002',
    districtId: '1605060',
    name: 'Sidodadi',
  },
  {
    id: '1605060003',
    districtId: '1605060',
    name: 'Sukowono',
  },
  {
    id: '1605060004',
    districtId: '1605060',
    name: 'Bumi Rejo',
  },
  {
    id: '1605060005',
    districtId: '1605060',
    name: 'Margoyoso',
  },
  {
    id: '1605060006',
    districtId: '1605060',
    name: 'Giriyoso',
  },
  {
    id: '1605060007',
    districtId: '1605060',
    name: 'Ngestiboga II',
  },
  {
    id: '1605060008',
    districtId: '1605060',
    name: 'Kertosono',
  },
  {
    id: '1605060009',
    districtId: '1605060',
    name: 'Purwodadi',
  },
  {
    id: '1605060010',
    districtId: '1605060',
    name: 'Donorojo',
  },
  {
    id: '1605060011',
    districtId: '1605060',
    name: 'Ngestiboga I',
  },
  {
    id: '1605060012',
    districtId: '1605060',
    name: 'Margatani',
  },
  {
    id: '1605060013',
    districtId: '1605060',
    name: 'Ngestikarya',
  },
  {
    id: '1605061001',
    districtId: '1605061',
    name: 'Rantau Alih',
  },
  {
    id: '1605061002',
    districtId: '1605061',
    name: 'Ciptodadi',
  },
  {
    id: '1605061003',
    districtId: '1605061',
    name: 'Sugi Waras',
  },
  {
    id: '1605061004',
    districtId: '1605061',
    name: 'Sukowarno',
  },
  {
    id: '1605061005',
    districtId: '1605061',
    name: 'Bangun Rejo',
  },
  {
    id: '1605061006',
    districtId: '1605061',
    name: 'Yudha Karya',
  },
  {
    id: '1605061007',
    districtId: '1605061',
    name: 'Sukarena',
  },
  {
    id: '1605061008',
    districtId: '1605061',
    name: 'Ciptodadi II',
  },
  {
    id: '1605070019',
    districtId: '1605070',
    name: 'Binjai',
  },
  {
    id: '1605070020',
    districtId: '1605070',
    name: 'Pulau Panggung',
  },
  {
    id: '1605070031',
    districtId: '1605070',
    name: 'Mandi Aur',
  },
  {
    id: '1605070032',
    districtId: '1605070',
    name: 'Tanjung Lama',
  },
  {
    id: '1605070033',
    districtId: '1605070',
    name: 'Muara Kelingi',
  },
  {
    id: '1605070034',
    districtId: '1605070',
    name: 'Lubuk Tua',
  },
  {
    id: '1605070035',
    districtId: '1605070',
    name: 'Mambang',
  },
  {
    id: '1605070036',
    districtId: '1605070',
    name: 'Bingin',
  },
  {
    id: '1605070037',
    districtId: '1605070',
    name: 'Marga Sakti',
  },
  {
    id: '1605070038',
    districtId: '1605070',
    name: 'Tugu Sempurna',
  },
  {
    id: '1605070039',
    districtId: '1605070',
    name: 'Beliti Jaya',
  },
  {
    id: '1605070040',
    districtId: '1605070',
    name: 'Karya Sakti',
  },
  {
    id: '1605070041',
    districtId: '1605070',
    name: 'Petrans Jaya',
  },
  {
    id: '1605070042',
    districtId: '1605070',
    name: 'Karya Mukti',
  },
  {
    id: '1605070044',
    districtId: '1605070',
    name: 'Karya Teladan',
  },
  {
    id: '1605070045',
    districtId: '1605070',
    name: 'Temuan Sari',
  },
  {
    id: '1605070046',
    districtId: '1605070',
    name: 'Temuan Jaya',
  },
  {
    id: '1605070047',
    districtId: '1605070',
    name: 'Mekarsari',
  },
  {
    id: '1605070048',
    districtId: '1605070',
    name: 'Mangan Jaya',
  },
  {
    id: '1605070049',
    districtId: '1605070',
    name: 'Lubuk Muda',
  },
  {
    id: '1605070050',
    districtId: '1605070',
    name: 'Sukamenang',
  },
  {
    id: '1605071001',
    districtId: '1605071',
    name: 'Kembang Tanjung',
  },
  {
    id: '1605071002',
    districtId: '1605071',
    name: 'G Kembang Baru',
  },
  {
    id: '1605071003',
    districtId: '1605071',
    name: 'G Kembang Lama',
  },
  {
    id: '1605071004',
    districtId: '1605071',
    name: 'Sungai Bunut',
  },
  {
    id: '1605071005',
    districtId: '1605071',
    name: 'Mekar Jaya',
  },
  {
    id: '1605071006',
    districtId: '1605071',
    name: 'Sungai Naik',
  },
  {
    id: '1605071007',
    districtId: '1605071',
    name: 'Mulyo Harjo',
  },
  {
    id: '1605071008',
    districtId: '1605071',
    name: 'Trimukti',
  },
  {
    id: '1605071009',
    districtId: '1605071',
    name: 'Suka Makmur',
  },
  {
    id: '1605071010',
    districtId: '1605071',
    name: 'Raksa Budi',
  },
  {
    id: '1605071011',
    districtId: '1605071',
    name: 'Kota Baru',
  },
  {
    id: '1605071012',
    districtId: '1605071',
    name: 'Pangkalan Tarum Lama',
  },
  {
    id: '1605071013',
    districtId: '1605071',
    name: 'Trijaya',
  },
  {
    id: '1605071014',
    districtId: '1605071',
    name: 'Sadu',
  },
  {
    id: '1605071015',
    districtId: '1605071',
    name: 'Bangun Jaya',
  },
  {
    id: '1605071016',
    districtId: '1605071',
    name: 'Tambangan',
  },
  {
    id: '1605071017',
    districtId: '1605071',
    name: 'Pelawe',
  },
  {
    id: '1605071018',
    districtId: '1605071',
    name: 'Lubuk Pauh',
  },
  {
    id: '1605071019',
    districtId: '1605071',
    name: 'Sembatu Jaya Spi',
  },
  {
    id: '1605072001',
    districtId: '1605072',
    name: 'Air Beliti',
  },
  {
    id: '1605072002',
    districtId: '1605072',
    name: 'Suka Mulya',
  },
  {
    id: '1605072003',
    districtId: '1605072',
    name: 'Jaya Tunggal',
  },
  {
    id: '1605072004',
    districtId: '1605072',
    name: 'Remayu',
  },
  {
    id: '1605072005',
    districtId: '1605072',
    name: 'Petunang',
  },
  {
    id: '1605072006',
    districtId: '1605072',
    name: 'Jaya Bakti',
  },
  {
    id: '1605072007',
    districtId: '1605072',
    name: 'Dharma Sakti',
  },
  {
    id: '1605072008',
    districtId: '1605072',
    name: 'Banpres',
  },
  {
    id: '1605072009',
    districtId: '1605072',
    name: 'Bamasko',
  },
  {
    id: '1605072010',
    districtId: '1605072',
    name: 'Lubuk Rumbai',
  },
  {
    id: '1605072011',
    districtId: '1605072',
    name: 'Leban Jaya',
  },
  {
    id: '1605080001',
    districtId: '1605080',
    name: 'Pian Raya',
  },
  {
    id: '1605080002',
    districtId: '1605080',
    name: 'Bumi Makmur',
  },
  {
    id: '1605080003',
    districtId: '1605080',
    name: 'Sp V Tri Anggunjaya',
  },
  {
    id: '1605080004',
    districtId: '1605080',
    name: 'Harapan Makmur',
  },
  {
    id: '1605080005',
    districtId: '1605080',
    name: 'Mukti Karya',
  },
  {
    id: '1605080006',
    districtId: '1605080',
    name: 'Sindang Laya',
  },
  {
    id: '1605080007',
    districtId: '1605080',
    name: 'Semangus',
  },
  {
    id: '1605080008',
    districtId: '1605080',
    name: 'Pendingan',
  },
  {
    id: '1605080009',
    districtId: '1605080',
    name: 'Anyar',
  },
  {
    id: '1605080010',
    districtId: '1605080',
    name: 'Muara Rengas',
  },
  {
    id: '1605080011',
    districtId: '1605080',
    name: 'Sungai Pinang',
  },
  {
    id: '1605080012',
    districtId: '1605080',
    name: 'Semeteh',
  },
  {
    id: '1605080013',
    districtId: '1605080',
    name: 'Lubuk Pandan',
  },
  {
    id: '1605080014',
    districtId: '1605080',
    name: 'Muara Lakitan',
  },
  {
    id: '1605080015',
    districtId: '1605080',
    name: 'Prabumulih I',
  },
  {
    id: '1605080016',
    districtId: '1605080',
    name: 'Prabumulih II',
  },
  {
    id: '1605080017',
    districtId: '1605080',
    name: 'Pelita Jaya',
  },
  {
    id: '1605080018',
    districtId: '1605080',
    name: 'Sido Mulyo',
  },
  {
    id: '1605080019',
    districtId: '1605080',
    name: 'Marga Baru',
  },
  {
    id: '1605080020',
    districtId: '1605080',
    name: 'Semangus Baru',
  },
  {
    id: '1605090001',
    districtId: '1605090',
    name: 'Wonosari',
  },
  {
    id: '1605090002',
    districtId: '1605090',
    name: 'Megang Sakti II',
  },
  {
    id: '1605090003',
    districtId: '1605090',
    name: 'Megang Sakti IV',
  },
  {
    id: '1605090004',
    districtId: '1605090',
    name: 'Megang Sakti III',
  },
  {
    id: '1605090005',
    districtId: '1605090',
    name: 'Pagar Ayu',
  },
  {
    id: '1605090006',
    districtId: '1605090',
    name: 'Megang Sakti I',
  },
  {
    id: '1605090007',
    districtId: '1605090',
    name: 'Sumber Rejo',
  },
  {
    id: '1605090008',
    districtId: '1605090',
    name: 'Megang Sakti V',
  },
  {
    id: '1605090009',
    districtId: '1605090',
    name: 'Jajaran Baru II',
  },
  {
    id: '1605090010',
    districtId: '1605090',
    name: 'Muara Megang',
  },
  {
    id: '1605090011',
    districtId: '1605090',
    name: 'Marga Puspita',
  },
  {
    id: '1605090012',
    districtId: '1605090',
    name: 'Tegal Sari',
  },
  {
    id: '1605090013',
    districtId: '1605090',
    name: 'Campur Sari',
  },
  {
    id: '1605090014',
    districtId: '1605090',
    name: 'Mekarsari',
  },
  {
    id: '1605090015',
    districtId: '1605090',
    name: 'Karya Mulya',
  },
  {
    id: '1605090016',
    districtId: '1605090',
    name: 'Rejosari',
  },
  {
    id: '1605090017',
    districtId: '1605090',
    name: 'Trisakti',
  },
  {
    id: '1605090018',
    districtId: '1605090',
    name: 'Jajaran Baru I',
  },
  {
    id: '1605090020',
    districtId: '1605090',
    name: 'Mulyo Sari',
  },
  {
    id: '1605090021',
    districtId: '1605090',
    name: 'Muara Megang I',
  },
  {
    id: '1605090022',
    districtId: '1605090',
    name: 'Talang Ubi',
  },
  {
    id: '1606010001',
    districtId: '1606010',
    name: 'Air Balui',
  },
  {
    id: '1606010002',
    districtId: '1606010',
    name: 'Nganti',
  },
  {
    id: '1606010003',
    districtId: '1606010',
    name: 'Jud II',
  },
  {
    id: '1606010004',
    districtId: '1606010',
    name: 'Jud I',
  },
  {
    id: '1606010005',
    districtId: '1606010',
    name: 'Penggage',
  },
  {
    id: '1606010006',
    districtId: '1606010',
    name: 'Ngulak III',
  },
  {
    id: '1606010007',
    districtId: '1606010',
    name: 'Ngunang',
  },
  {
    id: '1606010008',
    districtId: '1606010',
    name: 'Ulak  Embacang',
  },
  {
    id: '1606010009',
    districtId: '1606010',
    name: 'Ngulak I',
  },
  {
    id: '1606010010',
    districtId: '1606010',
    name: 'Ngulak II',
  },
  {
    id: '1606010011',
    districtId: '1606010',
    name: 'Terusan',
  },
  {
    id: '1606010012',
    districtId: '1606010',
    name: 'Kemang',
  },
  {
    id: '1606010013',
    districtId: '1606010',
    name: 'Tanjung Raya',
  },
  {
    id: '1606010014',
    districtId: '1606010',
    name: 'Air Itam',
  },
  {
    id: '1606010015',
    districtId: '1606010',
    name: 'Keban II',
  },
  {
    id: '1606010016',
    districtId: '1606010',
    name: 'Keban I',
  },
  {
    id: '1606010017',
    districtId: '1606010',
    name: 'Panai',
  },
  {
    id: '1606010018',
    districtId: '1606010',
    name: 'Macang Sakti',
  },
  {
    id: '1606010019',
    districtId: '1606010',
    name: 'Ngulak',
  },
  {
    id: '1606020026',
    districtId: '1606020',
    name: 'Kasmaran',
  },
  {
    id: '1606020027',
    districtId: '1606020',
    name: 'Toman',
  },
  {
    id: '1606020028',
    districtId: '1606020',
    name: 'Babat',
  },
  {
    id: '1606020029',
    districtId: '1606020',
    name: 'Mangun Jaya',
  },
  {
    id: '1606020030',
    districtId: '1606020',
    name: 'Muara Punjung',
  },
  {
    id: '1606020031',
    districtId: '1606020',
    name: 'Beruga',
  },
  {
    id: '1606020032',
    districtId: '1606020',
    name: 'Sugiwaras',
  },
  {
    id: '1606020033',
    districtId: '1606020',
    name: 'Sugi Raya',
  },
  {
    id: '1606020034',
    districtId: '1606020',
    name: 'Sereka',
  },
  {
    id: '1606020035',
    districtId: '1606020',
    name: 'Sri Mulyo',
  },
  {
    id: '1606020036',
    districtId: '1606020',
    name: 'Sungai Angit',
  },
  {
    id: '1606020037',
    districtId: '1606020',
    name: 'Bangun Sari',
  },
  {
    id: '1606020038',
    districtId: '1606020',
    name: 'Pangkalan Jaya',
  },
  {
    id: '1606021001',
    districtId: '1606021',
    name: 'Pengaturan',
  },
  {
    id: '1606021002',
    districtId: '1606021',
    name: 'Pinggap',
  },
  {
    id: '1606021003',
    districtId: '1606021',
    name: 'Tanah Abang',
  },
  {
    id: '1606021004',
    districtId: '1606021',
    name: 'Talang Leban',
  },
  {
    id: '1606021005',
    districtId: '1606021',
    name: 'Saud',
  },
  {
    id: '1606021006',
    districtId: '1606021',
    name: 'Bukit Sejahtera',
  },
  {
    id: '1606021007',
    districtId: '1606021',
    name: 'Bukit Selabu UPT II',
  },
  {
    id: '1606021008',
    districtId: '1606021',
    name: 'Tanjung Bali',
  },
  {
    id: '1606021009',
    districtId: '1606021',
    name: 'Lubuk Buah',
  },
  {
    id: '1606021010',
    districtId: '1606021',
    name: 'Bukit Pangkuasan UPT IV',
  },
  {
    id: '1606021011',
    districtId: '1606021',
    name: 'Talang Buluh',
  },
  {
    id: '1606021012',
    districtId: '1606021',
    name: 'Sungai Napal',
  },
  {
    id: '1606021013',
    districtId: '1606021',
    name: 'Pangkalan Bulian',
  },
  {
    id: '1606021014',
    districtId: '1606021',
    name: 'Lubuk Bintialo',
  },
  {
    id: '1606021015',
    districtId: '1606021',
    name: 'Sako Suban',
  },
  {
    id: '1606021016',
    districtId: '1606021',
    name: 'Ulak Kembang',
  },
  {
    id: '1606022001',
    districtId: '1606022',
    name: 'Bangun Harjo (Sp6,8)',
  },
  {
    id: '1606022002',
    districtId: '1606022',
    name: 'Sukamaju (Sp5,7)',
  },
  {
    id: '1606022003',
    districtId: '1606022',
    name: 'Suka Makmur',
  },
  {
    id: '1606022004',
    districtId: '1606022',
    name: 'Suka Damai (Sp2,4)',
  },
  {
    id: '1606022005',
    districtId: '1606022',
    name: 'Sido Mukti (Sp1,3)',
  },
  {
    id: '1606022006',
    districtId: '1606022',
    name: 'Sukajaya (Sp.3)',
  },
  {
    id: '1606022007',
    districtId: '1606022',
    name: 'Sidorahayu (B1,2)',
  },
  {
    id: '1606022008',
    districtId: '1606022',
    name: 'Bukit Indah (B3)',
  },
  {
    id: '1606022009',
    districtId: '1606022',
    name: 'Air Putih Ulu (C1,2)',
  },
  {
    id: '1606022010',
    districtId: '1606022',
    name: 'Cinta Karya (C3)',
  },
  {
    id: '1606022011',
    districtId: '1606022',
    name: 'Sialang Agung (Cii)',
  },
  {
    id: '1606022012',
    districtId: '1606022',
    name: 'Warga Mulya (B4)',
  },
  {
    id: '1606022013',
    districtId: '1606022',
    name: 'Tanjung Kaputran (B5)',
  },
  {
    id: '1606022014',
    districtId: '1606022',
    name: 'Air Putih Ilir',
  },
  {
    id: '1606022015',
    districtId: '1606022',
    name: 'Sumber Rezeki',
  },
  {
    id: '1606023001',
    districtId: '1606023',
    name: 'Rantau Panjang',
  },
  {
    id: '1606023002',
    districtId: '1606023',
    name: 'Karang Anyar',
  },
  {
    id: '1606023003',
    districtId: '1606023',
    name: 'Karang Waru',
  },
  {
    id: '1606023004',
    districtId: '1606023',
    name: 'Bumi Ayu',
  },
  {
    id: '1606023005',
    districtId: '1606023',
    name: 'Ulak Paceh',
  },
  {
    id: '1606023006',
    districtId: '1606023',
    name: 'Tanjung Durian',
  },
  {
    id: '1606023007',
    districtId: '1606023',
    name: 'Napal',
  },
  {
    id: '1606023008',
    districtId: '1606023',
    name: 'Rantau Kasih',
  },
  {
    id: '1606023009',
    districtId: '1606023',
    name: 'Karang Ringin II',
  },
  {
    id: '1606023010',
    districtId: '1606023',
    name: 'Karang Ringin I',
  },
  {
    id: '1606023011',
    districtId: '1606023',
    name: 'Ulak Teberau',
  },
  {
    id: '1606023012',
    districtId: '1606023',
    name: 'Simpang Sari',
  },
  {
    id: '1606023013',
    districtId: '1606023',
    name: 'Ulak Paceh Jaya',
  },
  {
    id: '1606023014',
    districtId: '1606023',
    name: 'Talang Piase',
  },
  {
    id: '1606023015',
    districtId: '1606023',
    name: 'Pandan Dulang',
  },
  {
    id: '1606030001',
    districtId: '1606030',
    name: 'Jirak',
  },
  {
    id: '1606030002',
    districtId: '1606030',
    name: 'Talang Mandung',
  },
  {
    id: '1606030003',
    districtId: '1606030',
    name: 'Sungai Dua',
  },
  {
    id: '1606030004',
    districtId: '1606030',
    name: 'Setia Jaya',
  },
  {
    id: '1606030005',
    districtId: '1606030',
    name: 'Pagar Kaya',
  },
  {
    id: '1606030006',
    districtId: '1606030',
    name: 'Suka Lali',
  },
  {
    id: '1606030007',
    districtId: '1606030',
    name: 'Kertayu',
  },
  {
    id: '1606030008',
    districtId: '1606030',
    name: 'Sindang Marga',
  },
  {
    id: '1606030009',
    districtId: '1606030',
    name: 'Tebing Bulang',
  },
  {
    id: '1606030010',
    districtId: '1606030',
    name: 'Gajah Mati',
  },
  {
    id: '1606030011',
    districtId: '1606030',
    name: 'Rantau Sialang',
  },
  {
    id: '1606030012',
    districtId: '1606030',
    name: 'Kerta Jaya',
  },
  {
    id: '1606030013',
    districtId: '1606030',
    name: 'Rukun Rahayu',
  },
  {
    id: '1606030014',
    districtId: '1606030',
    name: 'Mekarjaya D.1',
  },
  {
    id: '1606030015',
    districtId: '1606030',
    name: 'Rejo Sari',
  },
  {
    id: '1606030016',
    districtId: '1606030',
    name: 'Jembatan Gantung',
  },
  {
    id: '1606030017',
    districtId: '1606030',
    name: 'Baru Jaya',
  },
  {
    id: '1606030018',
    districtId: '1606030',
    name: 'Layan',
  },
  {
    id: '1606030019',
    districtId: '1606030',
    name: 'Keramat Jaya',
  },
  {
    id: '1606030020',
    districtId: '1606030',
    name: 'Sinar Jaya',
  },
  {
    id: '1606030021',
    districtId: '1606030',
    name: 'Talang Simpang',
  },
  {
    id: '1606030022',
    districtId: '1606030',
    name: 'Bangkit Jaya',
  },
  {
    id: '1606040001',
    districtId: '1606040',
    name: 'Rimbah Ukur',
  },
  {
    id: '1606040002',
    districtId: '1606040',
    name: 'Sungai Medak',
  },
  {
    id: '1606040003',
    districtId: '1606040',
    name: 'Sungai Batang/ C.6',
  },
  {
    id: '1606040004',
    districtId: '1606040',
    name: 'Sukarami',
  },
  {
    id: '1606040005',
    districtId: '1606040',
    name: 'Soak Baru',
  },
  {
    id: '1606040006',
    districtId: '1606040',
    name: 'Balai Agung',
  },
  {
    id: '1606040007',
    districtId: '1606040',
    name: 'Serasan Jaya',
  },
  {
    id: '1606040008',
    districtId: '1606040',
    name: 'Kayuara',
  },
  {
    id: '1606040009',
    districtId: '1606040',
    name: 'Lumpatan',
  },
  {
    id: '1606040010',
    districtId: '1606040',
    name: 'Bailangu',
  },
  {
    id: '1606040022',
    districtId: '1606040',
    name: 'Muara Teladan',
  },
  {
    id: '1606040023',
    districtId: '1606040',
    name: 'Bandar Jaya',
  },
  {
    id: '1606040024',
    districtId: '1606040',
    name: 'Lumpatan II',
  },
  {
    id: '1606040025',
    districtId: '1606040',
    name: 'Bailangu Timur',
  },
  {
    id: '1606041001',
    districtId: '1606041',
    name: 'Danau Cala',
  },
  {
    id: '1606041002',
    districtId: '1606041',
    name: 'Rantau Keroya',
  },
  {
    id: '1606041003',
    districtId: '1606041',
    name: 'Teluk Kijing I',
  },
  {
    id: '1606041004',
    districtId: '1606041',
    name: 'Tanjung Agung Barat',
  },
  {
    id: '1606041005',
    districtId: '1606041',
    name: 'Tanjung Agung Timur',
  },
  {
    id: '1606041006',
    districtId: '1606041',
    name: 'Tanjung Agung Utara',
  },
  {
    id: '1606041007',
    districtId: '1606041',
    name: 'Purwosari',
  },
  {
    id: '1606041008',
    districtId: '1606041',
    name: 'Teluk Kijing III',
  },
  {
    id: '1606041009',
    districtId: '1606041',
    name: 'Teluk Kijing II',
  },
  {
    id: '1606041010',
    districtId: '1606041',
    name: 'Petaling',
  },
  {
    id: '1606041011',
    districtId: '1606041',
    name: 'Lais',
  },
  {
    id: '1606041012',
    districtId: '1606041',
    name: 'Teluk',
  },
  {
    id: '1606041013',
    districtId: '1606041',
    name: 'Epil',
  },
  {
    id: '1606041014',
    districtId: '1606041',
    name: 'Tanjung Agung Selatan',
  },
  {
    id: '1606041015',
    districtId: '1606041',
    name: 'Lais Utara',
  },
  {
    id: '1606090007',
    districtId: '1606090',
    name: 'Sungai Lilin',
  },
  {
    id: '1606090018',
    districtId: '1606090',
    name: 'Sumber Rejeki',
  },
  {
    id: '1606090019',
    districtId: '1606090',
    name: 'Sukadamai Baru',
  },
  {
    id: '1606090020',
    districtId: '1606090',
    name: 'Cinta Damai',
  },
  {
    id: '1606090021',
    districtId: '1606090',
    name: 'Berlian Makmur',
  },
  {
    id: '1606090022',
    districtId: '1606090',
    name: 'Srigunung',
  },
  {
    id: '1606090023',
    districtId: '1606090',
    name: 'Bumi Kencana',
  },
  {
    id: '1606090024',
    districtId: '1606090',
    name: 'Panca Tunggal',
  },
  {
    id: '1606090025',
    districtId: '1606090',
    name: 'Mulyorejo',
  },
  {
    id: '1606090026',
    districtId: '1606090',
    name: 'Linggo Sari',
  },
  {
    id: '1606090027',
    districtId: '1606090',
    name: 'Nusa Serasan',
  },
  {
    id: '1606090028',
    districtId: '1606090',
    name: 'Pinang Banjar',
  },
  {
    id: '1606090029',
    districtId: '1606090',
    name: 'Mekar Jadi',
  },
  {
    id: '1606090035',
    districtId: '1606090',
    name: 'Bukit Jaya',
  },
  {
    id: '1606090036',
    districtId: '1606090',
    name: 'Sungai Lilin Jaya',
  },
  {
    id: '1606091001',
    districtId: '1606091',
    name: 'Tenggaro',
  },
  {
    id: '1606091002',
    districtId: '1606091',
    name: 'Keluang',
  },
  {
    id: '1606091003',
    districtId: '1606091',
    name: 'Sumber Agung',
  },
  {
    id: '1606091004',
    districtId: '1606091',
    name: 'Karya Maju',
  },
  {
    id: '1606091005',
    districtId: '1606091',
    name: 'Tegal Mulya',
  },
  {
    id: '1606091006',
    districtId: '1606091',
    name: 'Mekar Jaya',
  },
  {
    id: '1606091007',
    districtId: '1606091',
    name: 'Loka Jaya',
  },
  {
    id: '1606091008',
    districtId: '1606091',
    name: 'Dawas',
  },
  {
    id: '1606091009',
    districtId: '1606091',
    name: 'Tanjung Dalam',
  },
  {
    id: '1606091010',
    districtId: '1606091',
    name: 'Cipta Praja',
  },
  {
    id: '1606091011',
    districtId: '1606091',
    name: 'Mekarsari',
  },
  {
    id: '1606091012',
    districtId: '1606091',
    name: 'Mulyo Asih',
  },
  {
    id: '1606091013',
    districtId: '1606091',
    name: 'Sido Rejo',
  },
  {
    id: '1606091014',
    districtId: '1606091',
    name: 'Sridamai',
  },
  {
    id: '1606092001',
    districtId: '1606092',
    name: 'Gajah Mati',
  },
  {
    id: '1606092002',
    districtId: '1606092',
    name: 'Tanjung Kerang',
  },
  {
    id: '1606092003',
    districtId: '1606092',
    name: 'Babat Banyuasin',
  },
  {
    id: '1606092004',
    districtId: '1606092',
    name: 'Supat',
  },
  {
    id: '1606092005',
    districtId: '1606092',
    name: 'Letang',
  },
  {
    id: '1606092006',
    districtId: '1606092',
    name: 'Suka Maju',
  },
  {
    id: '1606092007',
    districtId: '1606092',
    name: 'Langkap',
  },
  {
    id: '1606092008',
    districtId: '1606092',
    name: 'Tenggulang Jaya',
  },
  {
    id: '1606092009',
    districtId: '1606092',
    name: 'Bandar Tenggulang',
  },
  {
    id: '1606092010',
    districtId: '1606092',
    name: 'Sumber Jaya',
  },
  {
    id: '1606092011',
    districtId: '1606092',
    name: 'Tenggulang Baru',
  },
  {
    id: '1606092012',
    districtId: '1606092',
    name: 'Seratus Lapan',
  },
  {
    id: '1606092013',
    districtId: '1606092',
    name: 'Babat Ramba Jaya',
  },
  {
    id: '1606092014',
    districtId: '1606092',
    name: 'Supat Barat',
  },
  {
    id: '1606092015',
    districtId: '1606092',
    name: 'Supat Timur',
  },
  {
    id: '1606092016',
    districtId: '1606092',
    name: 'Gajah Muda',
  },
  {
    id: '1606100027',
    districtId: '1606100',
    name: 'Muara Merang',
  },
  {
    id: '1606100028',
    districtId: '1606100',
    name: 'Mangsang',
  },
  {
    id: '1606100040',
    districtId: '1606100',
    name: 'Tampang Baru',
  },
  {
    id: '1606100041',
    districtId: '1606100',
    name: 'Pulai Gading',
  },
  {
    id: '1606100042',
    districtId: '1606100',
    name: 'Muara Medak',
  },
  {
    id: '1606100043',
    districtId: '1606100',
    name: 'Kali Berau',
  },
  {
    id: '1606100047',
    districtId: '1606100',
    name: 'Sindang Marga',
  },
  {
    id: '1606100048',
    districtId: '1606100',
    name: 'Telang',
  },
  {
    id: '1606100049',
    districtId: '1606100',
    name: 'Mendis',
  },
  {
    id: '1606100050',
    districtId: '1606100',
    name: 'Simpang Bayat',
  },
  {
    id: '1606100051',
    districtId: '1606100',
    name: 'Pangkalan Bayat',
  },
  {
    id: '1606100052',
    districtId: '1606100',
    name: 'Pagar Desa',
  },
  {
    id: '1606100053',
    districtId: '1606100',
    name: 'Bayat Ilir',
  },
  {
    id: '1606100054',
    districtId: '1606100',
    name: 'Bayung Lencir',
  },
  {
    id: '1606100055',
    districtId: '1606100',
    name: 'Senawar Jaya',
  },
  {
    id: '1606100056',
    districtId: '1606100',
    name: 'Sukajaya',
  },
  {
    id: '1606100057',
    districtId: '1606100',
    name: 'Muara Bahar',
  },
  {
    id: '1606100058',
    districtId: '1606100',
    name: 'Mekar Jaya',
  },
  {
    id: '1606100059',
    districtId: '1606100',
    name: 'Kepayang',
  },
  {
    id: '1606100060',
    districtId: '1606100',
    name: 'Mendis Jaya',
  },
  {
    id: '1606100061',
    districtId: '1606100',
    name: 'Lubuk Harjo',
  },
  {
    id: '1606100062',
    districtId: '1606100',
    name: 'Bayung Lencir Indah',
  },
  {
    id: '1606100063',
    districtId: '1606100',
    name: 'Wonorejo',
  },
  {
    id: '1606101001',
    districtId: '1606101',
    name: 'Karang Agung',
  },
  {
    id: '1606101002',
    districtId: '1606101',
    name: 'Gali Sari',
  },
  {
    id: '1606101003',
    districtId: '1606101',
    name: 'Perumpung Raya',
  },
  {
    id: '1606101004',
    districtId: '1606101',
    name: 'Karang Makmur',
  },
  {
    id: '1606101005',
    districtId: '1606101',
    name: 'Karang Rejo',
  },
  {
    id: '1606101006',
    districtId: '1606101',
    name: 'Karya Mukti',
  },
  {
    id: '1606101007',
    districtId: '1606101',
    name: 'Mulya Agung',
  },
  {
    id: '1606101008',
    districtId: '1606101',
    name: 'Madya Mulya',
  },
  {
    id: '1606101009',
    districtId: '1606101',
    name: 'Karang Tirta',
  },
  {
    id: '1606101010',
    districtId: '1606101',
    name: 'Purwa Agung',
  },
  {
    id: '1606101011',
    districtId: '1606101',
    name: 'Tri Mulya Agung',
  },
  {
    id: '1606101012',
    districtId: '1606101',
    name: 'Ringin Agung',
  },
  {
    id: '1606101013',
    districtId: '1606101',
    name: 'Mekar Sari',
  },
  {
    id: '1606101014',
    districtId: '1606101',
    name: 'Sri Karang Rejo',
  },
  {
    id: '1606101015',
    districtId: '1606101',
    name: 'Karang Mukti',
  },
  {
    id: '1606101016',
    districtId: '1606101',
    name: 'Karang Sari',
  },
  {
    id: '1606101017',
    districtId: '1606101',
    name: 'Mulya Jaya',
  },
  {
    id: '1606101018',
    districtId: '1606101',
    name: 'Sari Agung',
  },
  {
    id: '1606101019',
    districtId: '1606101',
    name: 'Sukajadi',
  },
  {
    id: '1606101020',
    districtId: '1606101',
    name: 'Bandar Agung',
  },
  {
    id: '1606101021',
    districtId: '1606101',
    name: 'Mandala Sari',
  },
  {
    id: '1606101022',
    districtId: '1606101',
    name: 'Sri Gading',
  },
  {
    id: '1606101023',
    districtId: '1606101',
    name: 'Bumi Agung',
  },
  {
    id: '1606101024',
    districtId: '1606101',
    name: 'Agung Jaya',
  },
  {
    id: '1606101025',
    districtId: '1606101',
    name: 'Jaya Agung',
  },
  {
    id: '1606101026',
    districtId: '1606101',
    name: 'Suka Makmur',
  },
  {
    id: '1606101027',
    districtId: '1606101',
    name: 'Mekar Jaya',
  },
  {
    id: '1606102001',
    districtId: '1606102',
    name: 'Berojaya Timur',
  },
  {
    id: '1606102002',
    districtId: '1606102',
    name: 'Beji Mulyo',
  },
  {
    id: '1606102003',
    districtId: '1606102',
    name: 'Margo Mulyo',
  },
  {
    id: '1606102004',
    districtId: '1606102',
    name: 'Pandan Sari',
  },
  {
    id: '1606102005',
    districtId: '1606102',
    name: 'Simpang Tungkal',
  },
  {
    id: '1606102006',
    districtId: '1606102',
    name: 'Suka Damai',
  },
  {
    id: '1606102007',
    districtId: '1606102',
    name: 'Peninggalan',
  },
  {
    id: '1606102008',
    districtId: '1606102',
    name: 'Pangkalan Tungkal',
  },
  {
    id: '1606102009',
    districtId: '1606102',
    name: 'Berlian Jaya',
  },
  {
    id: '1606102010',
    districtId: '1606102',
    name: 'Sumber Harum',
  },
  {
    id: '1606102011',
    districtId: '1606102',
    name: 'Sumber Sari',
  },
  {
    id: '1606102012',
    districtId: '1606102',
    name: 'Srimulyo',
  },
  {
    id: '1606102013',
    districtId: '1606102',
    name: 'Banjar Jaya',
  },
  {
    id: '1606102014',
    districtId: '1606102',
    name: 'Sinar Harapan',
  },
  {
    id: '1606102015',
    districtId: '1606102',
    name: 'Sinar Tungkal',
  },
  {
    id: '1606102016',
    districtId: '1606102',
    name: 'Sido Mulyo',
  },
  {
    id: '1607010001',
    districtId: '1607010',
    name: 'Muara Abab',
  },
  {
    id: '1607010002',
    districtId: '1607010',
    name: 'Peldas',
  },
  {
    id: '1607010003',
    districtId: '1607010',
    name: 'Tanjung Pasir',
  },
  {
    id: '1607010004',
    districtId: '1607010',
    name: 'Tanjung Tiga',
  },
  {
    id: '1607010005',
    districtId: '1607010',
    name: 'Rantau Bayur',
  },
  {
    id: '1607010006',
    districtId: '1607010',
    name: 'Tebing Abang',
  },
  {
    id: '1607010007',
    districtId: '1607010',
    name: 'Pagar Bulan',
  },
  {
    id: '1607010008',
    districtId: '1607010',
    name: 'Lubuk Rengas',
  },
  {
    id: '1607010009',
    districtId: '1607010',
    name: 'Lebung',
  },
  {
    id: '1607010010',
    districtId: '1607010',
    name: 'Kemang Bejalu',
  },
  {
    id: '1607010011',
    districtId: '1607010',
    name: 'Tanjung Menang Musi',
  },
  {
    id: '1607010012',
    districtId: '1607010',
    name: 'Sri Jaya',
  },
  {
    id: '1607010013',
    districtId: '1607010',
    name: 'Sejagung',
  },
  {
    id: '1607010014',
    districtId: '1607010',
    name: 'Sungai Pinang',
  },
  {
    id: '1607010015',
    districtId: '1607010',
    name: 'Semuntul',
  },
  {
    id: '1607010016',
    districtId: '1607010',
    name: 'Talang Kemang',
  },
  {
    id: '1607010017',
    districtId: '1607010',
    name: 'Rantau Harapan',
  },
  {
    id: '1607010018',
    districtId: '1607010',
    name: 'Sungai Lilin',
  },
  {
    id: '1607010019',
    districtId: '1607010',
    name: 'Suka Rela',
  },
  {
    id: '1607010020',
    districtId: '1607010',
    name: 'Penandingan',
  },
  {
    id: '1607010021',
    districtId: '1607010',
    name: 'Sungai Naik',
  },
  {
    id: '1607020001',
    districtId: '1607020',
    name: 'Talang Jaya Indah',
  },
  {
    id: '1607020002',
    districtId: '1607020',
    name: 'Talang Jaya Mulya',
  },
  {
    id: '1607020003',
    districtId: '1607020',
    name: 'Talang Jaya Raya',
  },
  {
    id: '1607020004',
    districtId: '1607020',
    name: 'Pulau Rajak',
  },
  {
    id: '1607020014',
    districtId: '1607020',
    name: 'Lubuk Karet',
  },
  {
    id: '1607020015',
    districtId: '1607020',
    name: 'Betung',
  },
  {
    id: '1607020016',
    districtId: '1607020',
    name: 'Bukit',
  },
  {
    id: '1607020017',
    districtId: '1607020',
    name: 'Sri Kembang',
  },
  {
    id: '1607020018',
    districtId: '1607020',
    name: 'Talang Jaya Raya II',
  },
  {
    id: '1607020020',
    districtId: '1607020',
    name: 'Suka Mulya',
  },
  {
    id: '1607020021',
    districtId: '1607020',
    name: 'Rimba Asam',
  },
  {
    id: '1607021001',
    districtId: '1607021',
    name: 'Talang Ipuh',
  },
  {
    id: '1607021002',
    districtId: '1607021',
    name: 'Air Senggeris',
  },
  {
    id: '1607021003',
    districtId: '1607021',
    name: 'Lubuk Lancang',
  },
  {
    id: '1607021004',
    districtId: '1607021',
    name: 'Biyuku',
  },
  {
    id: '1607021005',
    districtId: '1607021',
    name: 'Rimba Terab',
  },
  {
    id: '1607021006',
    districtId: '1607021',
    name: 'Sedang',
  },
  {
    id: '1607021007',
    districtId: '1607021',
    name: 'Tanjung Laut',
  },
  {
    id: '1607021008',
    districtId: '1607021',
    name: 'Bengkuang',
  },
  {
    id: '1607021009',
    districtId: '1607021',
    name: 'Durian Daun',
  },
  {
    id: '1607021010',
    districtId: '1607021',
    name: 'Meranti',
  },
  {
    id: '1607021011',
    districtId: '1607021',
    name: 'Suka Raja',
  },
  {
    id: '1607030001',
    districtId: '1607030',
    name: 'Tabuan Asri (Sp VI)',
  },
  {
    id: '1607030002',
    districtId: '1607030',
    name: 'Teluk Betung',
  },
  {
    id: '1607030003',
    districtId: '1607030',
    name: 'Banjarsari (Air Senda IV)',
  },
  {
    id: '1607030004',
    districtId: '1607030',
    name: 'Buana Murti (Air Senda III)',
  },
  {
    id: '1607030005',
    districtId: '1607030',
    name: 'Tirta Mulya (Air Senda I)',
  },
  {
    id: '1607030006',
    districtId: '1607030',
    name: 'Senda Mukti (Air Senda II)',
  },
  {
    id: '1607030007',
    districtId: '1607030',
    name: 'Budi Asih',
  },
  {
    id: '1607030008',
    districtId: '1607030',
    name: 'Wonosari UPT VII Pr I',
  },
  {
    id: '1607030009',
    districtId: '1607030',
    name: 'Majatra UPT VI Pr I',
  },
  {
    id: '1607030010',
    districtId: '1607030',
    name: 'Bumi Rejo',
  },
  {
    id: '1607030011',
    districtId: '1607030',
    name: 'Songo Makmur',
  },
  {
    id: '1607030012',
    districtId: '1607030',
    name: 'Mekar Sari UPT XI Pr II',
  },
  {
    id: '1607030013',
    districtId: '1607030',
    name: 'Sumber Mukti',
  },
  {
    id: '1607030014',
    districtId: '1607030',
    name: 'Wonodadi',
  },
  {
    id: '1607030015',
    districtId: '1607030',
    name: 'Rukun Makmur',
  },
  {
    id: '1607030016',
    districtId: '1607030',
    name: 'Wana Mukti',
  },
  {
    id: '1607030017',
    districtId: '1607030',
    name: 'Sumber Mulya',
  },
  {
    id: '1607030018',
    districtId: '1607030',
    name: 'Rawa Banda',
  },
  {
    id: '1607030019',
    districtId: '1607030',
    name: 'Sumber Agung',
  },
  {
    id: '1607030020',
    districtId: '1607030',
    name: 'Kelapa Dua',
  },
  {
    id: '1607030021',
    districtId: '1607030',
    name: 'Sumber Rejo',
  },
  {
    id: '1607030022',
    districtId: '1607030',
    name: 'Nunggal Sari',
  },
  {
    id: '1607030023',
    districtId: '1607030',
    name: 'Dana Mulya',
  },
  {
    id: '1607030024',
    districtId: '1607030',
    name: 'Sumber Rejeki',
  },
  {
    id: '1607030025',
    districtId: '1607030',
    name: 'Purwodadi',
  },
  {
    id: '1607030026',
    districtId: '1607030',
    name: 'Karang Manunggal',
  },
  {
    id: '1607030027',
    districtId: '1607030',
    name: 'Ringin Harjo',
  },
  {
    id: '1607030028',
    districtId: '1607030',
    name: 'Penuguan',
  },
  {
    id: '1607030029',
    districtId: '1607030',
    name: 'Mukut',
  },
  {
    id: '1607031001',
    districtId: '1607031',
    name: 'Teluk Tenggulang',
  },
  {
    id: '1607031002',
    districtId: '1607031',
    name: 'Sukamulya UPT I K A Ulu',
  },
  {
    id: '1607031003',
    districtId: '1607031',
    name: 'Sukaraja P.Rimau',
  },
  {
    id: '1607031004',
    districtId: '1607031',
    name: 'Karang Anyar',
  },
  {
    id: '1607031005',
    districtId: '1607031',
    name: 'Karang Mulya/Sumber Jaya',
  },
  {
    id: '1607031006',
    districtId: '1607031',
    name: 'Karang Asem',
  },
  {
    id: '1607031007',
    districtId: '1607031',
    name: 'Marga Rahayu',
  },
  {
    id: '1607031008',
    districtId: '1607031',
    name: 'Bumi Serdang',
  },
  {
    id: '1607031009',
    districtId: '1607031',
    name: 'Sidomulyo',
  },
  {
    id: '1607031010',
    districtId: '1607031',
    name: 'Keluang',
  },
  {
    id: '1607031011',
    districtId: '1607031',
    name: 'Bentayan',
  },
  {
    id: '1607031012',
    districtId: '1607031',
    name: 'Pancamulya Pertak II Sp 2',
  },
  {
    id: '1607031013',
    districtId: '1607031',
    name: 'Suka Jaya Pertak III',
  },
  {
    id: '1607031014',
    districtId: '1607031',
    name: 'Suka Karya',
  },
  {
    id: '1607040001',
    districtId: '1607040',
    name: 'Galang Tinggi',
  },
  {
    id: '1607040002',
    districtId: '1607040',
    name: 'Petaling',
  },
  {
    id: '1607040003',
    districtId: '1607040',
    name: 'Sidang Mas',
  },
  {
    id: '1607040004',
    districtId: '1607040',
    name: 'Ujung Tanjung',
  },
  {
    id: '1607040005',
    districtId: '1607040',
    name: 'Rimba Alai',
  },
  {
    id: '1607040006',
    districtId: '1607040',
    name: 'Terentang',
  },
  {
    id: '1607040007',
    districtId: '1607040',
    name: 'Tanjung Beringin',
  },
  {
    id: '1607040008',
    districtId: '1607040',
    name: 'Pelajau',
  },
  {
    id: '1607040010',
    districtId: '1607040',
    name: 'Regan Agung',
  },
  {
    id: '1607040011',
    districtId: '1607040',
    name: 'Pelajau Ilir',
  },
  {
    id: '1607040012',
    districtId: '1607040',
    name: 'Lubuk Saung',
  },
  {
    id: '1607040013',
    districtId: '1607040',
    name: 'Mulya Agung',
  },
  {
    id: '1607040014',
    districtId: '1607040',
    name: 'Pangkalan Balai',
  },
  {
    id: '1607040015',
    districtId: '1607040',
    name: 'Seterio',
  },
  {
    id: '1607040016',
    districtId: '1607040',
    name: 'Sri Bandung',
  },
  {
    id: '1607040017',
    districtId: '1607040',
    name: 'Tanjung Menang Darat',
  },
  {
    id: '1607040018',
    districtId: '1607040',
    name: 'Suka Mulya',
  },
  {
    id: '1607040019',
    districtId: '1607040',
    name: 'Kayuara Kuning',
  },
  {
    id: '1607040020',
    districtId: '1607040',
    name: 'Tanjung Agung',
  },
  {
    id: '1607040021',
    districtId: '1607040',
    name: 'Pangkalan Panji',
  },
  {
    id: '1607040022',
    districtId: '1607040',
    name: 'Langkan',
  },
  {
    id: '1607040029',
    districtId: '1607040',
    name: 'Tanjung Kepayang',
  },
  {
    id: '1607040033',
    districtId: '1607040',
    name: 'Kedondong Raye',
  },
  {
    id: '1607040034',
    districtId: '1607040',
    name: 'Suka Raja Baru',
  },
  {
    id: '1607040037',
    districtId: '1607040',
    name: 'Terlangu',
  },
  {
    id: '1607040038',
    districtId: '1607040',
    name: 'Rimba Balai',
  },
  {
    id: '1607041001',
    districtId: '1607041',
    name: 'Pulau',
  },
  {
    id: '1607041002',
    districtId: '1607041',
    name: 'Lalang Sembawa',
  },
  {
    id: '1607041003',
    districtId: '1607041',
    name: 'Rejodadi',
  },
  {
    id: '1607041004',
    districtId: '1607041',
    name: 'Mainan',
  },
  {
    id: '1607041005',
    districtId: '1607041',
    name: 'Limau',
  },
  {
    id: '1607041006',
    districtId: '1607041',
    name: 'Purwosari',
  },
  {
    id: '1607041007',
    districtId: '1607041',
    name: 'Limbang Mulya',
  },
  {
    id: '1607041008',
    districtId: '1607041',
    name: 'Sakomakmur',
  },
  {
    id: '1607041009',
    districtId: '1607041',
    name: 'Air Rengit / Pulau Muning',
  },
  {
    id: '1607041010',
    districtId: '1607041',
    name: 'Muara Damai',
  },
  {
    id: '1607041011',
    districtId: '1607041',
    name: 'Santan Sari',
  },
  {
    id: '1607050001',
    districtId: '1607050',
    name: 'Air Batu',
  },
  {
    id: '1607050002',
    districtId: '1607050',
    name: 'Sukamoro',
  },
  {
    id: '1607050003',
    districtId: '1607050',
    name: 'Sukajadi',
  },
  {
    id: '1607050004',
    districtId: '1607050',
    name: 'Pangkalan Benteng',
  },
  {
    id: '1607050005',
    districtId: '1607050',
    name: 'Gasing',
  },
  {
    id: '1607050006',
    districtId: '1607050',
    name: 'Kenten',
  },
  {
    id: '1607050009',
    districtId: '1607050',
    name: 'Sungai Rengit',
  },
  {
    id: '1607050019',
    districtId: '1607050',
    name: 'Talang Buluh',
  },
  {
    id: '1607050020',
    districtId: '1607050',
    name: 'Tanah Mas',
  },
  {
    id: '1607050021',
    districtId: '1607050',
    name: 'Kenten Laut',
  },
  {
    id: '1607050022',
    districtId: '1607050',
    name: 'Talang Keramat',
  },
  {
    id: '1607050023',
    districtId: '1607050',
    name: 'Sungai Rengit Murni',
  },
  {
    id: '1607051001',
    districtId: '1607051',
    name: 'Sebalik',
  },
  {
    id: '1607051002',
    districtId: '1607051',
    name: 'Tanjung Lago',
  },
  {
    id: '1607051003',
    districtId: '1607051',
    name: 'Manggar Raya',
  },
  {
    id: '1607051004',
    districtId: '1607051',
    name: 'Banyu Urip',
  },
  {
    id: '1607051005',
    districtId: '1607051',
    name: 'Suka Damai',
  },
  {
    id: '1607051006',
    districtId: '1607051',
    name: 'Muara Sugih',
  },
  {
    id: '1607051007',
    districtId: '1607051',
    name: 'Suka Tani',
  },
  {
    id: '1607051008',
    districtId: '1607051',
    name: 'Sri Menanti',
  },
  {
    id: '1607051009',
    districtId: '1607051',
    name: 'Bangun Sari',
  },
  {
    id: '1607051010',
    districtId: '1607051',
    name: 'Sumber Mekar Mukti',
  },
  {
    id: '1607051011',
    districtId: '1607051',
    name: 'Kuala Puntian',
  },
  {
    id: '1607051012',
    districtId: '1607051',
    name: 'Telang Sari',
  },
  {
    id: '1607051013',
    districtId: '1607051',
    name: 'Mulya Sari',
  },
  {
    id: '1607051014',
    districtId: '1607051',
    name: 'Purwosari',
  },
  {
    id: '1607051015',
    districtId: '1607051',
    name: 'Bunga Karang',
  },
  {
    id: '1607060017',
    districtId: '1607060',
    name: 'Sungai Rebo',
  },
  {
    id: '1607060018',
    districtId: '1607060',
    name: 'Sungai Gerong',
  },
  {
    id: '1607060019',
    districtId: '1607060',
    name: 'Mariana',
  },
  {
    id: '1607060026',
    districtId: '1607060',
    name: 'Tirto Sari',
  },
  {
    id: '1607060027',
    districtId: '1607060',
    name: 'Pematang Palas',
  },
  {
    id: '1607060028',
    districtId: '1607060',
    name: 'Perajen',
  },
  {
    id: '1607060029',
    districtId: '1607060',
    name: 'Pulau Borang',
  },
  {
    id: '1607060030',
    districtId: '1607060',
    name: 'Merah Mata',
  },
  {
    id: '1607060031',
    districtId: '1607060',
    name: 'Cinta Manis',
  },
  {
    id: '1607060032',
    districtId: '1607060',
    name: 'Perambahan',
  },
  {
    id: '1607060044',
    districtId: '1607060',
    name: 'Mariana Ilir',
  },
  {
    id: '1607060045',
    districtId: '1607060',
    name: 'Duren Ijo',
  },
  {
    id: '1607060051',
    districtId: '1607060',
    name: 'Perambahan Baru',
  },
  {
    id: '1607061001',
    districtId: '1607061',
    name: 'Sidomulyo',
  },
  {
    id: '1607061002',
    districtId: '1607061',
    name: 'Cinta Manis Baru',
  },
  {
    id: '1607061003',
    districtId: '1607061',
    name: 'Nusa Makmur',
  },
  {
    id: '1607061004',
    districtId: '1607061',
    name: 'Sebokor',
  },
  {
    id: '1607061005',
    districtId: '1607061',
    name: 'Rimba Jaya',
  },
  {
    id: '1607061006',
    districtId: '1607061',
    name: 'Panca Desa',
  },
  {
    id: '1607061007',
    districtId: '1607061',
    name: 'Teluk Tenggirik',
  },
  {
    id: '1607061008',
    districtId: '1607061',
    name: 'Padang Rejo',
  },
  {
    id: '1607061009',
    districtId: '1607061',
    name: 'Budi Mulyo',
  },
  {
    id: '1607061010',
    districtId: '1607061',
    name: 'Sido Makmur',
  },
  {
    id: '1607061011',
    districtId: '1607061',
    name: 'Kumbang Padang Permata',
  },
  {
    id: '1607061012',
    districtId: '1607061',
    name: 'Tirta Makmur',
  },
  {
    id: '1607061013',
    districtId: '1607061',
    name: 'Panca Mulya',
  },
  {
    id: '1607061014',
    districtId: '1607061',
    name: 'Muara Baru',
  },
  {
    id: '1607061015',
    districtId: '1607061',
    name: 'Air Kumdang Bhakti',
  },
  {
    id: '1607061016',
    districtId: '1607061',
    name: 'Sebubus',
  },
  {
    id: '1607070001',
    districtId: '1607070',
    name: 'Rambutan',
  },
  {
    id: '1607070002',
    districtId: '1607070',
    name: 'Kebon Sahang',
  },
  {
    id: '1607070003',
    districtId: '1607070',
    name: 'Pulau Parang',
  },
  {
    id: '1607070004',
    districtId: '1607070',
    name: 'Siju',
  },
  {
    id: '1607070005',
    districtId: '1607070',
    name: 'Tanah Lembak',
  },
  {
    id: '1607070006',
    districtId: '1607070',
    name: 'Parit',
  },
  {
    id: '1607070007',
    districtId: '1607070',
    name: 'Pelaju',
  },
  {
    id: '1607070008',
    districtId: '1607070',
    name: 'Suka Pindah',
  },
  {
    id: '1607070009',
    districtId: '1607070',
    name: 'Durian Gadis',
  },
  {
    id: '1607070010',
    districtId: '1607070',
    name: 'Tanjung Kerang',
  },
  {
    id: '1607070011',
    districtId: '1607070',
    name: 'Tanjung Merbu',
  },
  {
    id: '1607070012',
    districtId: '1607070',
    name: 'Gelebak Dalam',
  },
  {
    id: '1607070013',
    districtId: '1607070',
    name: 'Sako',
  },
  {
    id: '1607070014',
    districtId: '1607070',
    name: 'Pangkalan Gelebak',
  },
  {
    id: '1607070015',
    districtId: '1607070',
    name: 'Sungai Pinang',
  },
  {
    id: '1607070016',
    districtId: '1607070',
    name: 'Sungai Kedukan',
  },
  {
    id: '1607070017',
    districtId: '1607070',
    name: 'Sungai Dua',
  },
  {
    id: '1607070018',
    districtId: '1607070',
    name: 'Menten',
  },
  {
    id: '1607070019',
    districtId: '1607070',
    name: 'Desa Baru',
  },
  {
    id: '1607070020',
    districtId: '1607070',
    name: 'Jakabaring Selatan',
  },
  {
    id: '1607080003',
    districtId: '1607080',
    name: 'Muara Padang',
  },
  {
    id: '1607080009',
    districtId: '1607080',
    name: 'Karang Anyar',
  },
  {
    id: '1607080010',
    districtId: '1607080',
    name: 'Tanjung Baru',
  },
  {
    id: '1607080011',
    districtId: '1607080',
    name: 'Sumber Sari/Margo Mulyo',
  },
  {
    id: '1607080012',
    districtId: '1607080',
    name: 'Purwodadi',
  },
  {
    id: '1607080013',
    districtId: '1607080',
    name: 'Sumber Makmur',
  },
  {
    id: '1607080014',
    districtId: '1607080',
    name: 'UPT V Jalur 18/ Sidomulyo',
  },
  {
    id: '1607080015',
    districtId: '1607080',
    name: 'Air Gading',
  },
  {
    id: '1607080016',
    districtId: '1607080',
    name: 'Tirto Raharjo',
  },
  {
    id: '1607080017',
    districtId: '1607080',
    name: 'Marga Sugihan',
  },
  {
    id: '1607080018',
    districtId: '1607080',
    name: 'Sidorejo',
  },
  {
    id: '1607080019',
    districtId: '1607080',
    name: 'Sidomulyo',
  },
  {
    id: '1607080020',
    districtId: '1607080',
    name: 'Daya Makmur',
  },
  {
    id: '1607080021',
    districtId: '1607080',
    name: 'Daya Utama',
  },
  {
    id: '1607080022',
    districtId: '1607080',
    name: 'Tirta Jaya',
  },
  {
    id: '1607081001',
    districtId: '1607081',
    name: 'Daya Murni',
  },
  {
    id: '1607081002',
    districtId: '1607081',
    name: 'Daya Bangun Harjo',
  },
  {
    id: '1607081003',
    districtId: '1607081',
    name: 'Sumber Mulyo',
  },
  {
    id: '1607081004',
    districtId: '1607081',
    name: 'Margomulyo I Jalur 16',
  },
  {
    id: '1607081005',
    districtId: '1607081',
    name: 'Sugih Waras',
  },
  {
    id: '1607081006',
    districtId: '1607081',
    name: 'Indrapura',
  },
  {
    id: '1607081007',
    districtId: '1607081',
    name: 'Cendana',
  },
  {
    id: '1607081008',
    districtId: '1607081',
    name: 'Argo Mulyo',
  },
  {
    id: '1607081009',
    districtId: '1607081',
    name: 'Rejosari',
  },
  {
    id: '1607081010',
    districtId: '1607081',
    name: 'Tirto Harjo',
  },
  {
    id: '1607081011',
    districtId: '1607081',
    name: 'Daya Kusuma',
  },
  {
    id: '1607081012',
    districtId: '1607081',
    name: 'Margo Rukun',
  },
  {
    id: '1607081013',
    districtId: '1607081',
    name: 'Ganesha Mukti',
  },
  {
    id: '1607081014',
    districtId: '1607081',
    name: 'Gilirang',
  },
  {
    id: '1607081015',
    districtId: '1607081',
    name: 'Tirta Mulyo',
  },
  {
    id: '1607081016',
    districtId: '1607081',
    name: 'Beringin Agung',
  },
  {
    id: '1607081017',
    districtId: '1607081',
    name: 'Jalur Mulya',
  },
  {
    id: '1607081018',
    districtId: '1607081',
    name: 'Timbul Jaya',
  },
  {
    id: '1607081019',
    districtId: '1607081',
    name: 'Juru Taroh',
  },
  {
    id: '1607081020',
    districtId: '1607081',
    name: 'Kuala Sugihan',
  },
  {
    id: '1607081021',
    districtId: '1607081',
    name: 'Sido Makmur',
  },
  {
    id: '1607081022',
    districtId: '1607081',
    name: 'Mekar Jaya',
  },
  {
    id: '1607090007',
    districtId: '1607090',
    name: 'Upang Makmur',
  },
  {
    id: '1607090008',
    districtId: '1607090',
    name: 'Pangestu',
  },
  {
    id: '1607090009',
    districtId: '1607090',
    name: 'Makarti Jaya',
  },
  {
    id: '1607090010',
    districtId: '1607090',
    name: 'Tirta Kencana',
  },
  {
    id: '1607090011',
    districtId: '1607090',
    name: 'Tirta Mulya',
  },
  {
    id: '1607090012',
    districtId: '1607090',
    name: 'Pendowo Harjo',
  },
  {
    id: '1607090013',
    districtId: '1607090',
    name: 'Upang Mulya',
  },
  {
    id: '1607090017',
    districtId: '1607090',
    name: 'Purwosari',
  },
  {
    id: '1607090019',
    districtId: '1607090',
    name: 'Muara Baru',
  },
  {
    id: '1607090020',
    districtId: '1607090',
    name: 'Sungai Semut',
  },
  {
    id: '1607090021',
    districtId: '1607090',
    name: 'Tanjung Baru',
  },
  {
    id: '1607090022',
    districtId: '1607090',
    name: 'Tanjung Mas',
  },
  {
    id: '1607091001',
    districtId: '1607091',
    name: 'Srimulyo',
  },
  {
    id: '1607091002',
    districtId: '1607091',
    name: 'Srikaton',
  },
  {
    id: '1607091003',
    districtId: '1607091',
    name: 'Sidoharjo',
  },
  {
    id: '1607091004',
    districtId: '1607091',
    name: 'Bintaran',
  },
  {
    id: '1607091005',
    districtId: '1607091',
    name: 'Damarwulan',
  },
  {
    id: '1607091006',
    districtId: '1607091',
    name: 'Enggalrejo',
  },
  {
    id: '1607091007',
    districtId: '1607091',
    name: 'Air Solok Batu',
  },
  {
    id: '1607091008',
    districtId: '1607091',
    name: 'Salek Agung',
  },
  {
    id: '1607091009',
    districtId: '1607091',
    name: 'Salek Mukti',
  },
  {
    id: '1607091010',
    districtId: '1607091',
    name: 'Salek Jaya',
  },
  {
    id: '1607091011',
    districtId: '1607091',
    name: 'Salek Mulya',
  },
  {
    id: '1607091012',
    districtId: '1607091',
    name: 'Salek Makmur',
  },
  {
    id: '1607091013',
    districtId: '1607091',
    name: 'Upang',
  },
  {
    id: '1607091014',
    districtId: '1607091',
    name: 'Upang Marga',
  },
  {
    id: '1607100016',
    districtId: '1607100',
    name: 'Teluk Payo',
  },
  {
    id: '1607100022',
    districtId: '1607100',
    name: 'Sungsang III',
  },
  {
    id: '1607100023',
    districtId: '1607100',
    name: 'Sungsang I',
  },
  {
    id: '1607100024',
    districtId: '1607100',
    name: 'Sungsang II',
  },
  {
    id: '1607100025',
    districtId: '1607100',
    name: 'Sumber Rejeki',
  },
  {
    id: '1607100026',
    districtId: '1607100',
    name: 'Sri Agung',
  },
  {
    id: '1607100027',
    districtId: '1607100',
    name: 'Karang Sari',
  },
  {
    id: '1607100028',
    districtId: '1607100',
    name: 'Majuria',
  },
  {
    id: '1607100029',
    districtId: '1607100',
    name: 'Tabala Jaya',
  },
  {
    id: '1607100030',
    districtId: '1607100',
    name: 'Sungsang IV',
  },
  {
    id: '1607100031',
    districtId: '1607100',
    name: 'Tanah Pilih',
  },
  {
    id: '1607100032',
    districtId: '1607100',
    name: 'Jati Sari',
  },
  {
    id: '1607100033',
    districtId: '1607100',
    name: 'Perajen Jaya',
  },
  {
    id: '1607100034',
    districtId: '1607100',
    name: 'Rimau Sungsang',
  },
  {
    id: '1607100037',
    districtId: '1607100',
    name: 'Muara Sungsang',
  },
  {
    id: '1607100038',
    districtId: '1607100',
    name: 'Marga Sungsang',
  },
  {
    id: '1607100039',
    districtId: '1607100',
    name: 'Mekar Sari',
  },
  {
    id: '1607110001',
    districtId: '1607110',
    name: 'Mukti Jaya',
  },
  {
    id: '1607110002',
    districtId: '1607110',
    name: 'Mekar Sari (UPT XII)',
  },
  {
    id: '1607110003',
    districtId: '1607110',
    name: 'Telang Jaya',
  },
  {
    id: '1607110004',
    districtId: '1607110',
    name: 'Telang Makmur',
  },
  {
    id: '1607110005',
    districtId: '1607110',
    name: 'Sumber Hidup',
  },
  {
    id: '1607110006',
    districtId: '1607110',
    name: 'Telang Rejo',
  },
  {
    id: '1607110007',
    districtId: '1607110',
    name: 'Telang Karya',
  },
  {
    id: '1607110012',
    districtId: '1607110',
    name: 'Sumber Mulya',
  },
  {
    id: '1607110013',
    districtId: '1607110',
    name: 'Marga Rahayu',
  },
  {
    id: '1607110018',
    districtId: '1607110',
    name: 'Panca Mukti',
  },
  {
    id: '1607110023',
    districtId: '1607110',
    name: 'Mekar Mukti',
  },
  {
    id: '1607110024',
    districtId: '1607110',
    name: 'Talang Indah',
  },
  {
    id: '1607110025',
    districtId: '1607110',
    name: 'Upang Jaya',
  },
  {
    id: '1607110026',
    districtId: '1607110',
    name: 'Upang Ceria',
  },
  {
    id: '1607110027',
    districtId: '1607110',
    name: 'Upang Cemara',
  },
  {
    id: '1607110028',
    districtId: '1607110',
    name: 'Upang Karya',
  },
  {
    id: '1607111001',
    districtId: '1607111',
    name: 'Karang Baru',
  },
  {
    id: '1607111002',
    districtId: '1607111',
    name: 'Karang Anyar',
  },
  {
    id: '1607111003',
    districtId: '1607111',
    name: 'Muara Telang Marga',
  },
  {
    id: '1607111004',
    districtId: '1607111',
    name: 'Sri Tiga',
  },
  {
    id: '1607111005',
    districtId: '1607111',
    name: 'Muara Telang',
  },
  {
    id: '1607111006',
    districtId: '1607111',
    name: 'Sumber Jaya',
  },
  {
    id: '1607111007',
    districtId: '1607111',
    name: 'Terusan Muara',
  },
  {
    id: '1607111008',
    districtId: '1607111',
    name: 'Terusan Tengah',
  },
  {
    id: '1607111009',
    districtId: '1607111',
    name: 'Terusan Dalam',
  },
  {
    id: '1607111010',
    districtId: '1607111',
    name: 'Talang Lubuk',
  },
  {
    id: '1608010001',
    districtId: '1608010',
    name: 'Kota Dalam',
  },
  {
    id: '1608010002',
    districtId: '1608010',
    name: 'Teluk Agung',
  },
  {
    id: '1608010003',
    districtId: '1608010',
    name: 'Tanjung Besar',
  },
  {
    id: '1608010004',
    districtId: '1608010',
    name: 'Pulau Duku',
  },
  {
    id: '1608010005',
    districtId: '1608010',
    name: 'Sinar Marga',
  },
  {
    id: '1608010006',
    districtId: '1608010',
    name: 'Kota Baru',
  },
  {
    id: '1608010007',
    districtId: '1608010',
    name: 'Galang Tinggi',
  },
  {
    id: '1608010008',
    districtId: '1608010',
    name: 'Sukaraja',
  },
  {
    id: '1608010009',
    districtId: '1608010',
    name: 'Srimenanti',
  },
  {
    id: '1608010010',
    districtId: '1608010',
    name: 'Kepayang',
  },
  {
    id: '1608010011',
    districtId: '1608010',
    name: 'Kemang Bandung',
  },
  {
    id: '1608010012',
    districtId: '1608010',
    name: 'Selabung Belimbing Jaya',
  },
  {
    id: '1608010013',
    districtId: '1608010',
    name: 'Air Baru',
  },
  {
    id: '1608010014',
    districtId: '1608010',
    name: 'Bunut',
  },
  {
    id: '1608010015',
    districtId: '1608010',
    name: 'Perean',
  },
  {
    id: '1608020020',
    districtId: '1608020',
    name: 'Way Timah',
  },
  {
    id: '1608020021',
    districtId: '1608020',
    name: 'Sipatuhu',
  },
  {
    id: '1608020022',
    districtId: '1608020',
    name: 'Air Rupik',
  },
  {
    id: '1608020023',
    districtId: '1608020',
    name: 'Banding Agung',
  },
  {
    id: '1608020024',
    districtId: '1608020',
    name: 'Surabaya',
  },
  {
    id: '1608020025',
    districtId: '1608020',
    name: 'Bandar Agung Ranau',
  },
  {
    id: '1608020026',
    districtId: '1608020',
    name: 'Sugih Waras',
  },
  {
    id: '1608020027',
    districtId: '1608020',
    name: 'Suka Negeri',
  },
  {
    id: '1608020028',
    districtId: '1608020',
    name: 'Rantau Nipis',
  },
  {
    id: '1608020033',
    districtId: '1608020',
    name: 'Merbau',
  },
  {
    id: '1608020034',
    districtId: '1608020',
    name: 'Tanjung Agung',
  },
  {
    id: '1608020035',
    districtId: '1608020',
    name: 'Telanai',
  },
  {
    id: '1608020036',
    districtId: '1608020',
    name: 'Tanjung Harapan',
  },
  {
    id: '1608020037',
    districtId: '1608020',
    name: 'Sidodadi',
  },
  {
    id: '1608020038',
    districtId: '1608020',
    name: 'Sipatuhu Dua',
  },
  {
    id: '1608020039',
    districtId: '1608020',
    name: 'Penantian',
  },
  {
    id: '1608020040',
    districtId: '1608020',
    name: 'Sukamaju',
  },
  {
    id: '1608020041',
    districtId: '1608020',
    name: 'Tangsi Agung',
  },
  {
    id: '1608020042',
    districtId: '1608020',
    name: 'Sumber Makmur',
  },
  {
    id: '1608020043',
    districtId: '1608020',
    name: 'Karang Indah',
  },
  {
    id: '1608020044',
    districtId: '1608020',
    name: 'Terap Mulia',
  },
  {
    id: '1608020045',
    districtId: '1608020',
    name: 'Surabaya Timur',
  },
  {
    id: '1608021001',
    districtId: '1608021',
    name: 'Sukajaya',
  },
  {
    id: '1608021002',
    districtId: '1608021',
    name: 'Kota Batu',
  },
  {
    id: '1608021003',
    districtId: '1608021',
    name: 'Pagar Dewa',
  },
  {
    id: '1608021004',
    districtId: '1608021',
    name: 'Tanjung Jati',
  },
  {
    id: '1608021005',
    districtId: '1608021',
    name: 'Gunung Aji',
  },
  {
    id: '1608021006',
    districtId: '1608021',
    name: 'Pilla',
  },
  {
    id: '1608021007',
    districtId: '1608021',
    name: 'Gunung Raya',
  },
  {
    id: '1608021008',
    districtId: '1608021',
    name: 'Remanam Jaya',
  },
  {
    id: '1608021009',
    districtId: '1608021',
    name: 'Way Wangi Seminung',
  },
  {
    id: '1608021010',
    districtId: '1608021',
    name: 'Tanjung Baru',
  },
  {
    id: '1608021011',
    districtId: '1608021',
    name: 'Mekar Sari',
  },
  {
    id: '1608021012',
    districtId: '1608021',
    name: 'Bumi Agung',
  },
  {
    id: '1608021013',
    districtId: '1608021',
    name: 'Kiwis Raya',
  },
  {
    id: '1608021014',
    districtId: '1608021',
    name: 'Sigigok Raya',
  },
  {
    id: '1608021015',
    districtId: '1608021',
    name: 'Gedung Ranau',
  },
  {
    id: '1608021016',
    districtId: '1608021',
    name: 'Bedeng Tiga',
  },
  {
    id: '1608022001',
    districtId: '1608022',
    name: 'Tanjung Kemala',
  },
  {
    id: '1608022002',
    districtId: '1608022',
    name: 'Sukamarga',
  },
  {
    id: '1608022003',
    districtId: '1608022',
    name: 'Subik',
  },
  {
    id: '1608022004',
    districtId: '1608022',
    name: 'Jepara',
  },
  {
    id: '1608022005',
    districtId: '1608022',
    name: 'Hangkusa',
  },
  {
    id: '1608022006',
    districtId: '1608022',
    name: 'Sukarami',
  },
  {
    id: '1608022007',
    districtId: '1608022',
    name: 'Simpang Sender',
  },
  {
    id: '1608022008',
    districtId: '1608022',
    name: 'Sumber Mulia',
  },
  {
    id: '1608022009',
    districtId: '1608022',
    name: 'Tanjung Setia',
  },
  {
    id: '1608022010',
    districtId: '1608022',
    name: 'Gedung Baru',
  },
  {
    id: '1608022011',
    districtId: '1608022',
    name: 'Padang Ratu',
  },
  {
    id: '1608022012',
    districtId: '1608022',
    name: 'Tanjung Sari',
  },
  {
    id: '1608022013',
    districtId: '1608022',
    name: 'Sukabumi',
  },
  {
    id: '1608022014',
    districtId: '1608022',
    name: 'Way Relai',
  },
  {
    id: '1608022015',
    districtId: '1608022',
    name: 'Tanjung Baru Ranau',
  },
  {
    id: '1608022016',
    districtId: '1608022',
    name: 'Simpang Sender Utara',
  },
  {
    id: '1608022017',
    districtId: '1608022',
    name: 'Simpang Sender Selatan',
  },
  {
    id: '1608022018',
    districtId: '1608022',
    name: 'Simpang Sender Timur',
  },
  {
    id: '1608022019',
    districtId: '1608022',
    name: 'Simpang Sender Tengah',
  },
  {
    id: '1608022020',
    districtId: '1608022',
    name: 'Sumber Jaya',
  },
  {
    id: '1608022021',
    districtId: '1608022',
    name: 'Pakhda Suka',
  },
  {
    id: '1608022022',
    districtId: '1608022',
    name: 'Serumpun Jaya',
  },
  {
    id: '1608030001',
    districtId: '1608030',
    name: 'Sipin',
  },
  {
    id: '1608030002',
    districtId: '1608030',
    name: 'Tanjung Durian',
  },
  {
    id: '1608030003',
    districtId: '1608030',
    name: 'Kota Way',
  },
  {
    id: '1608030004',
    districtId: '1608030',
    name: 'Karet Jaya',
  },
  {
    id: '1608030005',
    districtId: '1608030',
    name: 'Sri Menanti',
  },
  {
    id: '1608030006',
    districtId: '1608030',
    name: 'Talang Padang',
  },
  {
    id: '1608030007',
    districtId: '1608030',
    name: 'Serakat Jaya',
  },
  {
    id: '1608030008',
    districtId: '1608030',
    name: 'Durian Sembilan',
  },
  {
    id: '1608030010',
    districtId: '1608030',
    name: 'Sumber Ringin',
  },
  {
    id: '1608030011',
    districtId: '1608030',
    name: 'Kembang Tinggi',
  },
  {
    id: '1608030012',
    districtId: '1608030',
    name: 'Danau Jaya',
  },
  {
    id: '1608030013',
    districtId: '1608030',
    name: 'Sido Rahayu',
  },
  {
    id: '1608030014',
    districtId: '1608030',
    name: 'Sidodadi',
  },
  {
    id: '1608030020',
    districtId: '1608030',
    name: 'Sumber Raya',
  },
  {
    id: '1608030021',
    districtId: '1608030',
    name: 'Sinar Napalan',
  },
  {
    id: '1608030022',
    districtId: '1608030',
    name: 'Tanjung Jaya',
  },
  {
    id: '1608030023',
    districtId: '1608030',
    name: 'Sinar Baru',
  },
  {
    id: '1608030024',
    districtId: '1608030',
    name: 'Mekar Jaya',
  },
  {
    id: '1608030025',
    districtId: '1608030',
    name: 'Air Kelian',
  },
  {
    id: '1608030026',
    districtId: '1608030',
    name: 'Tanjung Sari',
  },
  {
    id: '1608030027',
    districtId: '1608030',
    name: 'Tanjung Baru',
  },
  {
    id: '1608030028',
    districtId: '1608030',
    name: 'Tanjung Menang',
  },
  {
    id: '1608040012',
    districtId: '1608040',
    name: 'Tanjung Sari',
  },
  {
    id: '1608040014',
    districtId: '1608040',
    name: 'Lubar',
  },
  {
    id: '1608040015',
    districtId: '1608040',
    name: 'Karang Agung',
  },
  {
    id: '1608040016',
    districtId: '1608040',
    name: 'Simpangan',
  },
  {
    id: '1608040017',
    districtId: '1608040',
    name: 'Bungin Campang',
  },
  {
    id: '1608040020',
    districtId: '1608040',
    name: 'Simpang Agung',
  },
  {
    id: '1608040021',
    districtId: '1608040',
    name: 'Sinar Mulyo',
  },
  {
    id: '1608041001',
    districtId: '1608041',
    name: 'Tanjung Beringin',
  },
  {
    id: '1608041002',
    districtId: '1608041',
    name: 'Bandar',
  },
  {
    id: '1608041003',
    districtId: '1608041',
    name: 'Jagaraga',
  },
  {
    id: '1608041004',
    districtId: '1608041',
    name: 'Damarpura',
  },
  {
    id: '1608041005',
    districtId: '1608041',
    name: 'Tekana',
  },
  {
    id: '1608041006',
    districtId: '1608041',
    name: 'Sinar Danau',
  },
  {
    id: '1608041007',
    districtId: '1608041',
    name: 'Tunas Jaya',
  },
  {
    id: '1608041008',
    districtId: '1608041',
    name: 'Gemiung',
  },
  {
    id: '1608050013',
    districtId: '1608050',
    name: 'Sukabanjar',
  },
  {
    id: '1608050014',
    districtId: '1608050',
    name: 'Sukaraja II',
  },
  {
    id: '1608050017',
    districtId: '1608050',
    name: 'Bumi Agung',
  },
  {
    id: '1608050018',
    districtId: '1608050',
    name: 'Batu Belang Jaya',
  },
  {
    id: '1608050019',
    districtId: '1608050',
    name: 'Kisau',
  },
  {
    id: '1608050020',
    districtId: '1608050',
    name: 'Pancur Pungah',
  },
  {
    id: '1608050021',
    districtId: '1608050',
    name: 'Pasar Muaradua',
  },
  {
    id: '1608050022',
    districtId: '1608050',
    name: 'Gunung Tiga',
  },
  {
    id: '1608050023',
    districtId: '1608050',
    name: 'Gedung Lepihan',
  },
  {
    id: '1608050058',
    districtId: '1608050',
    name: 'Pendagan',
  },
  {
    id: '1608050059',
    districtId: '1608050',
    name: 'Mehanggin',
  },
  {
    id: '1608050064',
    districtId: '1608050',
    name: 'Batu Belang 2',
  },
  {
    id: '1608050065',
    districtId: '1608050',
    name: 'Pelangki',
  },
  {
    id: '1608050066',
    districtId: '1608050',
    name: 'Datar',
  },
  {
    id: '1608051002',
    districtId: '1608051',
    name: 'Pelawi',
  },
  {
    id: '1608051003',
    districtId: '1608051',
    name: 'Bendi',
  },
  {
    id: '1608051004',
    districtId: '1608051',
    name: 'Gunung Cahya',
  },
  {
    id: '1608051005',
    districtId: '1608051',
    name: 'Ruos',
  },
  {
    id: '1608051006',
    districtId: '1608051',
    name: 'Bumi Jaya',
  },
  {
    id: '1608051007',
    districtId: '1608051',
    name: 'Banjar Agung',
  },
  {
    id: '1608051008',
    districtId: '1608051',
    name: 'Sukajaya',
  },
  {
    id: '1608051009',
    districtId: '1608051',
    name: 'Rantau Panjang',
  },
  {
    id: '1608051010',
    districtId: '1608051',
    name: 'Pekuwolan',
  },
  {
    id: '1608051011',
    districtId: '1608051',
    name: 'Majar',
  },
  {
    id: '1608051012',
    districtId: '1608051',
    name: 'Bumi Agung Jaya',
  },
  {
    id: '1608060008',
    districtId: '1608060',
    name: 'Tanjung Raya',
  },
  {
    id: '1608060009',
    districtId: '1608060',
    name: 'Sukarami',
  },
  {
    id: '1608060010',
    districtId: '1608060',
    name: 'Gunung Terang',
  },
  {
    id: '1608060011',
    districtId: '1608060',
    name: 'Negeri Agung',
  },
  {
    id: '1608060012',
    districtId: '1608060',
    name: 'Madura',
  },
  {
    id: '1608060013',
    districtId: '1608060',
    name: 'Negeri Batin',
  },
  {
    id: '1608060014',
    districtId: '1608060',
    name: 'Kota Karang',
  },
  {
    id: '1608060015',
    districtId: '1608060',
    name: 'Tanjung Menang Ilir',
  },
  {
    id: '1608060016',
    districtId: '1608060',
    name: 'Tanjung Menang Ulu',
  },
  {
    id: '1608060017',
    districtId: '1608060',
    name: 'Kenali',
  },
  {
    id: '1608060018',
    districtId: '1608060',
    name: 'Negeri Cahya',
  },
  {
    id: '1608060019',
    districtId: '1608060',
    name: 'Sukaraja I',
  },
  {
    id: '1608060020',
    districtId: '1608060',
    name: 'Tanjung Iman',
  },
  {
    id: '1608060021',
    districtId: '1608060',
    name: 'Talang Baru',
  },
  {
    id: '1608060022',
    districtId: '1608060',
    name: 'Bunga Mas',
  },
  {
    id: '1608060023',
    districtId: '1608060',
    name: 'Lubuk Liku',
  },
  {
    id: '1608061001',
    districtId: '1608061',
    name: 'Sukabumi',
  },
  {
    id: '1608061002',
    districtId: '1608061',
    name: 'Kota Agung',
  },
  {
    id: '1608061003',
    districtId: '1608061',
    name: 'Karang Pendeta',
  },
  {
    id: '1608061004',
    districtId: '1608061',
    name: 'Sukarena',
  },
  {
    id: '1608061005',
    districtId: '1608061',
    name: 'Surabaya',
  },
  {
    id: '1608061006',
    districtId: '1608061',
    name: 'Kuripan',
  },
  {
    id: '1608061007',
    districtId: '1608061',
    name: 'Peninggiran',
  },
  {
    id: '1608061008',
    districtId: '1608061',
    name: 'Kuripan 2',
  },
  {
    id: '1608070001',
    districtId: '1608070',
    name: 'Sugih Waras',
  },
  {
    id: '1608070002',
    districtId: '1608070',
    name: 'Padang Sari',
  },
  {
    id: '1608070003',
    districtId: '1608070',
    name: 'Padang Bindu',
  },
  {
    id: '1608070004',
    districtId: '1608070',
    name: 'Nagar Agung',
  },
  {
    id: '1608070005',
    districtId: '1608070',
    name: 'Saung Naga',
  },
  {
    id: '1608070006',
    districtId: '1608070',
    name: 'Negeri Batin Baru',
  },
  {
    id: '1608070007',
    districtId: '1608070',
    name: 'Kota Aman',
  },
  {
    id: '1608070008',
    districtId: '1608070',
    name: 'Peninjauan',
  },
  {
    id: '1608070013',
    districtId: '1608070',
    name: 'Blambangan',
  },
  {
    id: '1608070014',
    districtId: '1608070',
    name: 'Simpang Saga',
  },
  {
    id: '1608070015',
    districtId: '1608070',
    name: 'Perupus Blambangan',
  },
  {
    id: '1608070016',
    districtId: '1608070',
    name: 'Kagelang Blambangan',
  },
  {
    id: '1608070017',
    districtId: '1608070',
    name: 'Sukajadi Blambangan',
  },
  {
    id: '1608070018',
    districtId: '1608070',
    name: 'Bedeng Blambangan',
  },
  {
    id: '1608071001',
    districtId: '1608071',
    name: 'Penanggungan',
  },
  {
    id: '1608071002',
    districtId: '1608071',
    name: 'Tanjung Kurung',
  },
  {
    id: '1608071003',
    districtId: '1608071',
    name: 'Bumi Genap',
  },
  {
    id: '1608071004',
    districtId: '1608071',
    name: 'Gedung Nyawa',
  },
  {
    id: '1608071005',
    districtId: '1608071',
    name: 'Gedung Wani',
  },
  {
    id: '1608071006',
    districtId: '1608071',
    name: 'Sura',
  },
  {
    id: '1608071007',
    districtId: '1608071',
    name: 'Merpang',
  },
  {
    id: '1608071008',
    districtId: '1608071',
    name: 'Karang Endah',
  },
  {
    id: '1608071009',
    districtId: '1608071',
    name: 'Air Baru',
  },
  {
    id: '1608080001',
    districtId: '1608080',
    name: 'Balaian',
  },
  {
    id: '1608080002',
    districtId: '1608080',
    name: 'Berasang',
  },
  {
    id: '1608080003',
    districtId: '1608080',
    name: 'Tebat Gabus',
  },
  {
    id: '1608080004',
    districtId: '1608080',
    name: 'Padang Lay',
  },
  {
    id: '1608080005',
    districtId: '1608080',
    name: 'Danau Rata',
  },
  {
    id: '1608080006',
    districtId: '1608080',
    name: 'Pulau Panggung',
  },
  {
    id: '1608080007',
    districtId: '1608080',
    name: 'Ulak Pandan',
  },
  {
    id: '1608080008',
    districtId: '1608080',
    name: 'Gunung Megang',
  },
  {
    id: '1608080009',
    districtId: '1608080',
    name: 'Tenang',
  },
  {
    id: '1608080010',
    districtId: '1608080',
    name: 'Padang Bindu',
  },
  {
    id: '1608080011',
    districtId: '1608080',
    name: 'Kota Padang',
  },
  {
    id: '1608080012',
    districtId: '1608080',
    name: 'Muara Payang',
  },
  {
    id: '1608080013',
    districtId: '1608080',
    name: 'Siring Agung',
  },
  {
    id: '1608080014',
    districtId: '1608080',
    name: 'Pajar Bulan',
  },
  {
    id: '1608080015',
    districtId: '1608080',
    name: 'Bandar Alam Lama',
  },
  {
    id: '1608080016',
    districtId: '1608080',
    name: 'Simpang Empat',
  },
  {
    id: '1608080017',
    districtId: '1608080',
    name: 'Simpang Tiga',
  },
  {
    id: '1608080018',
    districtId: '1608080',
    name: 'Singa Laga',
  },
  {
    id: '1608080019',
    districtId: '1608080',
    name: 'Air Alun',
  },
  {
    id: '1608090001',
    districtId: '1608090',
    name: 'Gunung Gare',
  },
  {
    id: '1608090009',
    districtId: '1608090',
    name: 'Tanjung Beringin',
  },
  {
    id: '1608090010',
    districtId: '1608090',
    name: 'Simpang Lubuk Dalam',
  },
  {
    id: '1608090011',
    districtId: '1608090',
    name: 'Ulak Agung Ulu',
  },
  {
    id: '1608090012',
    districtId: '1608090',
    name: 'Bandar Alam Baru',
  },
  {
    id: '1608090013',
    districtId: '1608090',
    name: 'Ulak Agung Ilir',
  },
  {
    id: '1608090014',
    districtId: '1608090',
    name: 'Alundua',
  },
  {
    id: '1608090015',
    districtId: '1608090',
    name: 'Penyandingan',
  },
  {
    id: '1608090016',
    districtId: '1608090',
    name: 'Dusun Tengah',
  },
  {
    id: '1608090017',
    districtId: '1608090',
    name: 'Penantian',
  },
  {
    id: '1608090021',
    districtId: '1608090',
    name: 'Sukaraja',
  },
  {
    id: '1608090022',
    districtId: '1608090',
    name: 'Muaradua Kisam',
  },
  {
    id: '1608090023',
    districtId: '1608090',
    name: 'Pagar Dewa',
  },
  {
    id: '1608090024',
    districtId: '1608090',
    name: 'Sukananti',
  },
  {
    id: '1608090037',
    districtId: '1608090',
    name: 'Tanjung Tebat',
  },
  {
    id: '1608090038',
    districtId: '1608090',
    name: 'Lawang Agung',
  },
  {
    id: '1608090039',
    districtId: '1608090',
    name: 'Bayur Tengah',
  },
  {
    id: '1608090040',
    districtId: '1608090',
    name: 'Sugihan',
  },
  {
    id: '1608091001',
    districtId: '1608091',
    name: 'Pulau Kemiling',
  },
  {
    id: '1608091002',
    districtId: '1608091',
    name: 'Siring Alam',
  },
  {
    id: '1608091003',
    districtId: '1608091',
    name: 'Simpang Campang',
  },
  {
    id: '1608091004',
    districtId: '1608091',
    name: 'Pangandonan',
  },
  {
    id: '1608091005',
    districtId: '1608091',
    name: 'Keban Agung',
  },
  {
    id: '1608091006',
    districtId: '1608091',
    name: 'Pius',
  },
  {
    id: '1608091007',
    districtId: '1608091',
    name: 'Muara Sindang',
  },
  {
    id: '1608091008',
    districtId: '1608091',
    name: 'Tanjung Jati',
  },
  {
    id: '1608091009',
    districtId: '1608091',
    name: 'Campang Jaya',
  },
  {
    id: '1608100001',
    districtId: '1608100',
    name: 'Gunung Batu',
  },
  {
    id: '1608100002',
    districtId: '1608100',
    name: 'Kemu',
  },
  {
    id: '1608100003',
    districtId: '1608100',
    name: 'Simpang Pancur',
  },
  {
    id: '1608100004',
    districtId: '1608100',
    name: 'Pagar Agung',
  },
  {
    id: '1608100005',
    districtId: '1608100',
    name: 'Tanjung Kari',
  },
  {
    id: '1608100006',
    districtId: '1608100',
    name: 'Aromantai',
  },
  {
    id: '1608100007',
    districtId: '1608100',
    name: 'Pulau Beringin',
  },
  {
    id: '1608100008',
    districtId: '1608100',
    name: 'Tanjung Bulan',
  },
  {
    id: '1608100026',
    districtId: '1608100',
    name: 'Pematang Obar',
  },
  {
    id: '1608100027',
    districtId: '1608100',
    name: 'Anugerah Kemu',
  },
  {
    id: '1608100028',
    districtId: '1608100',
    name: 'Kemu Ulu',
  },
  {
    id: '1608100029',
    districtId: '1608100',
    name: 'Pulau Beringin Utara',
  },
  {
    id: '1608100030',
    districtId: '1608100',
    name: 'Tanjung Bulan Ulu',
  },
  {
    id: '1608101001',
    districtId: '1608101',
    name: 'Tanjung Harapan',
  },
  {
    id: '1608101002',
    districtId: '1608101',
    name: 'Muara Sindang Ilir',
  },
  {
    id: '1608101003',
    districtId: '1608101',
    name: 'Muara Sindang Tengah',
  },
  {
    id: '1608101004',
    districtId: '1608101',
    name: 'Pematang Danau',
  },
  {
    id: '1608101005',
    districtId: '1608101',
    name: 'Ulu Danau',
  },
  {
    id: '1608101006',
    districtId: '1608101',
    name: 'Watas',
  },
  {
    id: '1608101007',
    districtId: '1608101',
    name: 'Tebat Layang',
  },
  {
    id: '1608102001',
    districtId: '1608102',
    name: 'Cukoh Nau',
  },
  {
    id: '1608102002',
    districtId: '1608102',
    name: 'Pecah Pinggan',
  },
  {
    id: '1608102003',
    districtId: '1608102',
    name: 'Ujan Mas',
  },
  {
    id: '1608102004',
    districtId: '1608102',
    name: 'Pulau Kemuning',
  },
  {
    id: '1608102005',
    districtId: '1608102',
    name: 'Tanah Pilih',
  },
  {
    id: '1608102006',
    districtId: '1608102',
    name: 'Guntung Jaya',
  },
  {
    id: '1608102007',
    districtId: '1608102',
    name: 'Simpang Luas',
  },
  {
    id: '1608102008',
    districtId: '1608102',
    name: 'Sebaja',
  },
  {
    id: '1608102009',
    districtId: '1608102',
    name: 'Sadau Jaya',
  },
  {
    id: '1609010008',
    districtId: '1609010',
    name: 'Tanjung Kemala',
  },
  {
    id: '1609010009',
    districtId: '1609010',
    name: 'Kota Baru',
  },
  {
    id: '1609010010',
    districtId: '1609010',
    name: 'Pasar Martapura',
  },
  {
    id: '1609010011',
    districtId: '1609010',
    name: 'Paku Sengkunyit',
  },
  {
    id: '1609010012',
    districtId: '1609010',
    name: 'Dusun Martapura',
  },
  {
    id: '1609010013',
    districtId: '1609010',
    name: 'Keromongan',
  },
  {
    id: '1609010014',
    districtId: '1609010',
    name: 'Perjaya',
  },
  {
    id: '1609010021',
    districtId: '1609010',
    name: 'Kota Baru Barat',
  },
  {
    id: '1609010022',
    districtId: '1609010',
    name: 'Sukomulyo',
  },
  {
    id: '1609010023',
    districtId: '1609010',
    name: 'Kota Baru Selatan',
  },
  {
    id: '1609010024',
    districtId: '1609010',
    name: 'Sungai Tuha Jaya',
  },
  {
    id: '1609010025',
    districtId: '1609010',
    name: 'Terukis Rahayu',
  },
  {
    id: '1609010026',
    districtId: '1609010',
    name: 'Bukit Sari',
  },
  {
    id: '1609010027',
    districtId: '1609010',
    name: 'Veteran Jaya',
  },
  {
    id: '1609010028',
    districtId: '1609010',
    name: 'Perjaya Barat',
  },
  {
    id: '1609010029',
    districtId: '1609010',
    name: 'Tanjung Kemala Barat',
  },
  {
    id: '1609011001',
    districtId: '1609011',
    name: 'Baturaja Bungin',
  },
  {
    id: '1609011002',
    districtId: '1609011',
    name: 'Tulang Bawang',
  },
  {
    id: '1609011003',
    districtId: '1609011',
    name: 'Sabah Lioh',
  },
  {
    id: '1609011004',
    districtId: '1609011',
    name: 'Negeri Ratu',
  },
  {
    id: '1609011005',
    districtId: '1609011',
    name: 'Negeri Ratu Baru',
  },
  {
    id: '1609011006',
    districtId: '1609011',
    name: 'Peracak',
  },
  {
    id: '1609011007',
    districtId: '1609011',
    name: 'Tunas Peracak',
  },
  {
    id: '1609011008',
    districtId: '1609011',
    name: 'Suka Baru',
  },
  {
    id: '1609012001',
    districtId: '1609012',
    name: 'Mendah',
  },
  {
    id: '1609012002',
    districtId: '1609012',
    name: 'Bunga Mayang',
  },
  {
    id: '1609012003',
    districtId: '1609012',
    name: 'Tumi Jaya',
  },
  {
    id: '1609012004',
    districtId: '1609012',
    name: 'Condong',
  },
  {
    id: '1609012005',
    districtId: '1609012',
    name: 'Way Salak',
  },
  {
    id: '1609012006',
    districtId: '1609012',
    name: 'Jayapura',
  },
  {
    id: '1609012007',
    districtId: '1609012',
    name: 'Peracak Jaya',
  },
  {
    id: '1609012008',
    districtId: '1609012',
    name: 'Kambang',
  },
  {
    id: '1609020001',
    districtId: '1609020',
    name: 'Negeri Agung',
  },
  {
    id: '1609020002',
    districtId: '1609020',
    name: 'Banumas',
  },
  {
    id: '1609020003',
    districtId: '1609020',
    name: 'Banuayu',
  },
  {
    id: '1609020004',
    districtId: '1609020',
    name: 'Pulau Negara',
  },
  {
    id: '1609020005',
    districtId: '1609020',
    name: 'Bantan',
  },
  {
    id: '1609020006',
    districtId: '1609020',
    name: 'Negeri Pakuan',
  },
  {
    id: '1609020007',
    districtId: '1609020',
    name: 'Bandar Jaya',
  },
  {
    id: '1609020008',
    districtId: '1609020',
    name: 'Pahang Asri',
  },
  {
    id: '1609020009',
    districtId: '1609020',
    name: 'Pemetung Basuki',
  },
  {
    id: '1609020010',
    districtId: '1609020',
    name: 'Saung Dadi',
  },
  {
    id: '1609020011',
    districtId: '1609020',
    name: 'Terantang Sakti',
  },
  {
    id: '1609020012',
    districtId: '1609020',
    name: 'Negeri Agung Jaya',
  },
  {
    id: '1609020013',
    districtId: '1609020',
    name: 'Bantan Pelita',
  },
  {
    id: '1609030001',
    districtId: '1609030',
    name: 'Sukaraja',
  },
  {
    id: '1609030002',
    districtId: '1609030',
    name: 'Pisang Jaya',
  },
  {
    id: '1609030003',
    districtId: '1609030',
    name: 'Kurungan Nyawa',
  },
  {
    id: '1609030004',
    districtId: '1609030',
    name: 'Way Halom',
  },
  {
    id: '1609030005',
    districtId: '1609030',
    name: 'Tebat Jaya',
  },
  {
    id: '1609030006',
    districtId: '1609030',
    name: 'Sumber Agung',
  },
  {
    id: '1609030007',
    districtId: '1609030',
    name: 'Sri Dadi / Saridati',
  },
  {
    id: '1609030016',
    districtId: '1609030',
    name: 'Tanjung Bulan',
  },
  {
    id: '1609030041',
    districtId: '1609030',
    name: 'Kurungan Nyawa I',
  },
  {
    id: '1609030042',
    districtId: '1609030',
    name: 'Kurungan Nyawa II',
  },
  {
    id: '1609030043',
    districtId: '1609030',
    name: 'Kurungan Nyawa III',
  },
  {
    id: '1609030044',
    districtId: '1609030',
    name: 'Cipta Muda',
  },
  {
    id: '1609030045',
    districtId: '1609030',
    name: 'Aman Jaya',
  },
  {
    id: '1609030046',
    districtId: '1609030',
    name: 'Sukaraja Tuha',
  },
  {
    id: '1609030047',
    districtId: '1609030',
    name: 'Mulyo Agung',
  },
  {
    id: '1609030048',
    districtId: '1609030',
    name: 'Ganjar Agung',
  },
  {
    id: '1609030049',
    districtId: '1609030',
    name: 'Mudasentosa',
  },
  {
    id: '1609031001',
    districtId: '1609031',
    name: 'Tanjung Mas',
  },
  {
    id: '1609031002',
    districtId: '1609031',
    name: 'Limansari',
  },
  {
    id: '1609031003',
    districtId: '1609031',
    name: 'Sumber Harjo',
  },
  {
    id: '1609031004',
    districtId: '1609031',
    name: 'Sumber Mulyo',
  },
  {
    id: '1609031005',
    districtId: '1609031',
    name: 'Bangun Harjo',
  },
  {
    id: '1609031006',
    districtId: '1609031',
    name: 'Karang Tengah',
  },
  {
    id: '1609031007',
    districtId: '1609031',
    name: 'Sri Katon',
  },
  {
    id: '1609031008',
    districtId: '1609031',
    name: 'Tanjung Sari',
  },
  {
    id: '1609031009',
    districtId: '1609031',
    name: 'Sumber Asri',
  },
  {
    id: '1609031010',
    districtId: '1609031',
    name: 'Suka Maju',
  },
  {
    id: '1609031011',
    districtId: '1609031',
    name: 'Sukoharjo',
  },
  {
    id: '1609031012',
    districtId: '1609031',
    name: 'Tekorejo',
  },
  {
    id: '1609031013',
    districtId: '1609031',
    name: 'Pengandonan',
  },
  {
    id: '1609031014',
    districtId: '1609031',
    name: 'Tambak Boyo',
  },
  {
    id: '1609031015',
    districtId: '1609031',
    name: 'Rejodadi',
  },
  {
    id: '1609031017',
    districtId: '1609031',
    name: 'Rowodadi',
  },
  {
    id: '1609031018',
    districtId: '1609031',
    name: 'Sukodadi',
  },
  {
    id: '1609031019',
    districtId: '1609031',
    name: 'Sumedang Sari',
  },
  {
    id: '1609031020',
    districtId: '1609031',
    name: 'Kumpul Rejo',
  },
  {
    id: '1609031021',
    districtId: '1609031',
    name: 'Metro Rejo',
  },
  {
    id: '1609031022',
    districtId: '1609031',
    name: 'Kedu',
  },
  {
    id: '1609031023',
    districtId: '1609031',
    name: 'Kedung Rejo',
  },
  {
    id: '1609031024',
    districtId: '1609031',
    name: 'Banyumas Asri',
  },
  {
    id: '1609031025',
    districtId: '1609031',
    name: 'Tanjung Agung',
  },
  {
    id: '1609031026',
    districtId: '1609031',
    name: 'Tanjung Mulya',
  },
  {
    id: '1609031027',
    districtId: '1609031',
    name: 'Raman Agung',
  },
  {
    id: '1609031028',
    districtId: '1609031',
    name: 'Bukit Mas',
  },
  {
    id: '1609031029',
    districtId: '1609031',
    name: 'Berasan Mulya',
  },
  {
    id: '1609031030',
    districtId: '1609031',
    name: 'Gumuk Rejo',
  },
  {
    id: '1609031031',
    districtId: '1609031',
    name: 'Sumber Tani',
  },
  {
    id: '1609031032',
    districtId: '1609031',
    name: 'Wonodadi Asri',
  },
  {
    id: '1609031033',
    districtId: '1609031',
    name: 'Suka Jaya',
  },
  {
    id: '1609031034',
    districtId: '1609031',
    name: 'Bumi Rahayu Mukti',
  },
  {
    id: '1609032001',
    districtId: '1609032',
    name: 'Sri Bunga',
  },
  {
    id: '1609032002',
    districtId: '1609032',
    name: 'Anyar',
  },
  {
    id: '1609032003',
    districtId: '1609032',
    name: 'Pandan Sari II',
  },
  {
    id: '1609032004',
    districtId: '1609032',
    name: 'Rawa Sari',
  },
  {
    id: '1609032005',
    districtId: '1609032',
    name: 'Surya Menang',
  },
  {
    id: '1609032006',
    districtId: '1609032',
    name: 'Muncak Kabau',
  },
  {
    id: '1609032007',
    districtId: '1609032',
    name: 'Sri Bulan',
  },
  {
    id: '1609040001',
    districtId: '1609040',
    name: 'Pandan Jaya',
  },
  {
    id: '1609040002',
    districtId: '1609040',
    name: 'Riang Bandung',
  },
  {
    id: '1609040003',
    districtId: '1609040',
    name: 'Karang Negara',
  },
  {
    id: '1609040012',
    districtId: '1609040',
    name: 'Sukanegara',
  },
  {
    id: '1609040013',
    districtId: '1609040',
    name: 'Jati Mulyo II',
  },
  {
    id: '1609040014',
    districtId: '1609040',
    name: 'Sri Mulyo',
  },
  {
    id: '1609040015',
    districtId: '1609040',
    name: 'Rasuan Baru',
  },
  {
    id: '1609040016',
    districtId: '1609040',
    name: 'Kertanegara',
  },
  {
    id: '1609040018',
    districtId: '1609040',
    name: 'Kota Negara',
  },
  {
    id: '1609040019',
    districtId: '1609040',
    name: 'Pandan Agung',
  },
  {
    id: '1609040020',
    districtId: '1609040',
    name: 'Margo Tani',
  },
  {
    id: '1609040021',
    districtId: '1609040',
    name: 'Banban Rejo',
  },
  {
    id: '1609040022',
    districtId: '1609040',
    name: 'Riang Bandung Ilir',
  },
  {
    id: '1609040023',
    districtId: '1609040',
    name: 'Dadi Mulyo',
  },
  {
    id: '1609040024',
    districtId: '1609040',
    name: 'Sri Kencana',
  },
  {
    id: '1609040025',
    districtId: '1609040',
    name: 'Margotani II',
  },
  {
    id: '1609040026',
    districtId: '1609040',
    name: 'Kotanegara Timur',
  },
  {
    id: '1609040027',
    districtId: '1609040',
    name: 'Talang Giring',
  },
  {
    id: '1609040028',
    districtId: '1609040',
    name: 'Kalirejo',
  },
  {
    id: '1609041001',
    districtId: '1609041',
    name: 'Batu Marta X',
  },
  {
    id: '1609041002',
    districtId: '1609041',
    name: 'Bina Amarta',
  },
  {
    id: '1609041003',
    districtId: '1609041',
    name: 'Batu Marta VI',
  },
  {
    id: '1609041004',
    districtId: '1609041',
    name: 'Banding Agung',
  },
  {
    id: '1609041005',
    districtId: '1609041',
    name: 'Nikan',
  },
  {
    id: '1609041006',
    districtId: '1609041',
    name: 'Karya Makmur VIII',
  },
  {
    id: '1609041007',
    districtId: '1609041',
    name: 'Wana Bakti',
  },
  {
    id: '1609041008',
    districtId: '1609041',
    name: 'Suka Damai',
  },
  {
    id: '1609041009',
    districtId: '1609041',
    name: 'Surabaya',
  },
  {
    id: '1609041010',
    districtId: '1609041',
    name: 'Marta V Jaya',
  },
  {
    id: '1609041011',
    districtId: '1609041',
    name: 'Marta Mulya',
  },
  {
    id: '1609041012',
    districtId: '1609041',
    name: 'Tri Marta Jaya',
  },
  {
    id: '1609041013',
    districtId: '1609041',
    name: 'Suka Damai Timur',
  },
  {
    id: '1609041014',
    districtId: '1609041',
    name: 'Sido Mulyo',
  },
  {
    id: '1609041015',
    districtId: '1609041',
    name: 'Banjar Agung',
  },
  {
    id: '1609050011',
    districtId: '1609050',
    name: 'Jaya Bakti',
  },
  {
    id: '1609050012',
    districtId: '1609050',
    name: 'Harjo Mulyo',
  },
  {
    id: '1609050013',
    districtId: '1609050',
    name: 'Jatisari',
  },
  {
    id: '1609050014',
    districtId: '1609050',
    name: 'Mendayun',
  },
  {
    id: '1609050015',
    districtId: '1609050',
    name: 'Gunung Terang',
  },
  {
    id: '1609050016',
    districtId: '1609050',
    name: 'Rasuan',
  },
  {
    id: '1609050017',
    districtId: '1609050',
    name: 'Mengulak',
  },
  {
    id: '1609050018',
    districtId: '1609050',
    name: 'Sp Karta Mulya',
  },
  {
    id: '1609050019',
    districtId: '1609050',
    name: 'Karta Mulya',
  },
  {
    id: '1609050021',
    districtId: '1609050',
    name: 'Agung Jati',
  },
  {
    id: '1609050022',
    districtId: '1609050',
    name: 'Tridadi',
  },
  {
    id: '1609050023',
    districtId: '1609050',
    name: 'Rasuan Darat',
  },
  {
    id: '1609050024',
    districtId: '1609050',
    name: 'Harjomulyo Jaya',
  },
  {
    id: '1609051001',
    districtId: '1609051',
    name: 'Tugumulyo',
  },
  {
    id: '1609051002',
    districtId: '1609051',
    name: 'Bangsa Negara',
  },
  {
    id: '1609051003',
    districtId: '1609051',
    name: 'Tugu Harum',
  },
  {
    id: '1609051004',
    districtId: '1609051',
    name: 'Tulus Ayu',
  },
  {
    id: '1609051005',
    districtId: '1609051',
    name: 'Karang Binangun',
  },
  {
    id: '1609051006',
    districtId: '1609051',
    name: 'Jati Mulyo 1',
  },
  {
    id: '1609051007',
    districtId: '1609051',
    name: 'Pandan Sari 1',
  },
  {
    id: '1609051008',
    districtId: '1609051',
    name: 'Pelita Jaya',
  },
  {
    id: '1609051009',
    districtId: '1609051',
    name: 'Mekar Jaya',
  },
  {
    id: '1609051010',
    districtId: '1609051',
    name: 'Lubuk Harjo',
  },
  {
    id: '1609051011',
    districtId: '1609051',
    name: 'Tanah Merah',
  },
  {
    id: '1609051012',
    districtId: '1609051',
    name: 'Joso Winangun',
  },
  {
    id: '1609051013',
    districtId: '1609051',
    name: 'Rantau Jaya',
  },
  {
    id: '1609051014',
    districtId: '1609051',
    name: 'Tebing Sari Mulya',
  },
  {
    id: '1609051015',
    districtId: '1609051',
    name: 'Marga Cinta',
  },
  {
    id: '1609051016',
    districtId: '1609051',
    name: 'Karang Binangun II',
  },
  {
    id: '1609051017',
    districtId: '1609051',
    name: 'Burnai Sari Mulya',
  },
  {
    id: '1609060001',
    districtId: '1609060',
    name: 'Sido Rahayu',
  },
  {
    id: '1609060002',
    districtId: '1609060',
    name: 'Sukarami',
  },
  {
    id: '1609060003',
    districtId: '1609060',
    name: 'Tawang Rejo',
  },
  {
    id: '1609060012',
    districtId: '1609060',
    name: 'Triyoso',
  },
  {
    id: '1609060013',
    districtId: '1609060',
    name: 'Serbaguna',
  },
  {
    id: '1609060014',
    districtId: '1609060',
    name: 'Sumber Suko',
  },
  {
    id: '1609060015',
    districtId: '1609060',
    name: 'Sukajadi',
  },
  {
    id: '1609060016',
    districtId: '1609060',
    name: 'Sukosari',
  },
  {
    id: '1609060017',
    districtId: '1609060',
    name: 'Pujorahayu',
  },
  {
    id: '1609060018',
    districtId: '1609060',
    name: 'Sidomulyo',
  },
  {
    id: '1609060022',
    districtId: '1609060',
    name: 'Tanjung Raya',
  },
  {
    id: '1609060023',
    districtId: '1609060',
    name: 'Harjo Winangun',
  },
  {
    id: '1609060024',
    districtId: '1609060',
    name: 'Tegal Rejo',
  },
  {
    id: '1609060025',
    districtId: '1609060',
    name: 'Gumawang',
  },
  {
    id: '1609060026',
    districtId: '1609060',
    name: 'Bedilan',
  },
  {
    id: '1609060027',
    districtId: '1609060',
    name: 'Sidogede',
  },
  {
    id: '1609060028',
    districtId: '1609060',
    name: 'Sido Makmur',
  },
  {
    id: '1609060029',
    districtId: '1609060',
    name: 'Gunung Mas',
  },
  {
    id: '1609060030',
    districtId: '1609060',
    name: 'Karang Kemiri',
  },
  {
    id: '1609060031',
    districtId: '1609060',
    name: 'Sidodadi',
  },
  {
    id: '1609060032',
    districtId: '1609060',
    name: 'Sumber Suko Jaya',
  },
  {
    id: '1609060033',
    districtId: '1609060',
    name: 'Gedung Rejo',
  },
  {
    id: '1609060034',
    districtId: '1609060',
    name: 'Mojosari',
  },
  {
    id: '1609060035',
    districtId: '1609060',
    name: 'Ketapang',
  },
  {
    id: '1609061001',
    districtId: '1609061',
    name: 'Rejosari',
  },
  {
    id: '1609061002',
    districtId: '1609061',
    name: 'Rejosari Jaya',
  },
  {
    id: '1609061003',
    districtId: '1609061',
    name: 'Sumber Agung',
  },
  {
    id: '1609061004',
    districtId: '1609061',
    name: 'Banjar Rejo',
  },
  {
    id: '1609061005',
    districtId: '1609061',
    name: 'Panca Tunggal',
  },
  {
    id: '1609061006',
    districtId: '1609061',
    name: 'Sidorejo',
  },
  {
    id: '1609061007',
    districtId: '1609061',
    name: 'Margo Koyo',
  },
  {
    id: '1609061008',
    districtId: '1609061',
    name: 'Karsa Jaya',
  },
  {
    id: '1609061009',
    districtId: '1609061',
    name: 'Windu Sari',
  },
  {
    id: '1609061010',
    districtId: '1609061',
    name: 'Karya Makmur',
  },
  {
    id: '1609061011',
    districtId: '1609061',
    name: 'Giri Mulyo',
  },
  {
    id: '1609061012',
    districtId: '1609061',
    name: 'Madugondo',
  },
  {
    id: '1609061013',
    districtId: '1609061',
    name: 'Argo Mulyo',
  },
  {
    id: '1609061014',
    districtId: '1609061',
    name: 'Tunggal Jaya',
  },
  {
    id: '1609061015',
    districtId: '1609061',
    name: 'Panca Jaya',
  },
  {
    id: '1609061016',
    districtId: '1609061',
    name: 'Sumber Makmur',
  },
  {
    id: '1609061017',
    districtId: '1609061',
    name: 'Sumber Jaya',
  },
  {
    id: '1609070004',
    districtId: '1609070',
    name: 'Tri Karya',
  },
  {
    id: '1609070005',
    districtId: '1609070',
    name: 'Nusa Tunggal',
  },
  {
    id: '1609070006',
    districtId: '1609070',
    name: 'Kutosari',
  },
  {
    id: '1609070007',
    districtId: '1609070',
    name: 'Nusaraya',
  },
  {
    id: '1609070008',
    districtId: '1609070',
    name: 'Nusa Bali',
  },
  {
    id: '1609070009',
    districtId: '1609070',
    name: 'Nusa Bakti',
  },
  {
    id: '1609070010',
    districtId: '1609070',
    name: 'Senu Marga',
  },
  {
    id: '1609070011',
    districtId: '1609070',
    name: 'Karang Sari',
  },
  {
    id: '1609070012',
    districtId: '1609070',
    name: 'Sukanegara',
  },
  {
    id: '1609070013',
    districtId: '1609070',
    name: 'Nusa Maju',
  },
  {
    id: '1609070014',
    districtId: '1609070',
    name: 'Nusa Agung',
  },
  {
    id: '1609070015',
    districtId: '1609070',
    name: 'Nusa Jaya',
  },
  {
    id: '1609070016',
    districtId: '1609070',
    name: 'Nusa Tenggara',
  },
  {
    id: '1609070017',
    districtId: '1609070',
    name: 'Sumber Rejo',
  },
  {
    id: '1609070018',
    districtId: '1609070',
    name: 'Sinar Bali',
  },
  {
    id: '1609070019',
    districtId: '1609070',
    name: 'Karang Jadi',
  },
  {
    id: '1609070020',
    districtId: '1609070',
    name: 'Ringin Sari',
  },
  {
    id: '1609070021',
    districtId: '1609070',
    name: 'Ganti Warno',
  },
  {
    id: '1609070022',
    districtId: '1609070',
    name: 'Dadi Rejo',
  },
  {
    id: '1609070023',
    districtId: '1609070',
    name: 'Karya Maju',
  },
  {
    id: '1609080001',
    districtId: '1609080',
    name: 'Sumber Rahayu',
  },
  {
    id: '1609080002',
    districtId: '1609080',
    name: 'Sri Bantolo',
  },
  {
    id: '1609080003',
    districtId: '1609080',
    name: 'Purwosari',
  },
  {
    id: '1609080008',
    districtId: '1609080',
    name: 'Tanjung Kemuning',
  },
  {
    id: '1609080010',
    districtId: '1609080',
    name: 'Margo Mulyo',
  },
  {
    id: '1609080011',
    districtId: '1609080',
    name: 'Karang Manik',
  },
  {
    id: '1609080012',
    districtId: '1609080',
    name: 'Raman Jaya',
  },
  {
    id: '1609080013',
    districtId: '1609080',
    name: 'Tegal Sari',
  },
  {
    id: '1609080014',
    districtId: '1609080',
    name: 'Sumber Jaya',
  },
  {
    id: '1609080015',
    districtId: '1609080',
    name: 'Sumber Sari',
  },
  {
    id: '1609080016',
    districtId: '1609080',
    name: 'Sumber Harapan',
  },
  {
    id: '1609080017',
    districtId: '1609080',
    name: 'Keli Rejo',
  },
  {
    id: '1609080018',
    districtId: '1609080',
    name: 'Sumber Rejo',
  },
  {
    id: '1609080019',
    districtId: '1609080',
    name: 'Toto Rejo',
  },
  {
    id: '1609080020',
    districtId: '1609080',
    name: 'Kemuning Jaya',
  },
  {
    id: '1609080021',
    districtId: '1609080',
    name: 'Bangun Rejo',
  },
  {
    id: '1609080022',
    districtId: '1609080',
    name: 'Srijaya',
  },
  {
    id: '1609080023',
    districtId: '1609080',
    name: 'Batu Mas',
  },
  {
    id: '1609080024',
    districtId: '1609080',
    name: 'Suka Jaya',
  },
  {
    id: '1609080025',
    districtId: '1609080',
    name: 'Karang Jaya',
  },
  {
    id: '1609080026',
    districtId: '1609080',
    name: 'Darma Buana',
  },
  {
    id: '1609080027',
    districtId: '1609080',
    name: 'Tegal Besar',
  },
  {
    id: '1609080028',
    districtId: '1609080',
    name: 'Rejo Mulyo',
  },
  {
    id: '1609080029',
    districtId: '1609080',
    name: 'Purworejo',
  },
  {
    id: '1609080030',
    districtId: '1609080',
    name: 'Sumber Makmur',
  },
  {
    id: '1609080031',
    districtId: '1609080',
    name: 'Budi Luhur',
  },
  {
    id: '1609080032',
    districtId: '1609080',
    name: 'Margo Mulyo Makmur',
  },
  {
    id: '1609081001',
    districtId: '1609081',
    name: 'Sukoharjo',
  },
  {
    id: '1609081002',
    districtId: '1609081',
    name: 'Sribudaya',
  },
  {
    id: '1609081003',
    districtId: '1609081',
    name: 'Sri Mulyo',
  },
  {
    id: '1609081004',
    districtId: '1609081',
    name: 'Purwodadi',
  },
  {
    id: '1609081005',
    districtId: '1609081',
    name: 'Ulak Buntar',
  },
  {
    id: '1609081006',
    districtId: '1609081',
    name: 'Sari Guna',
  },
  {
    id: '1609081007',
    districtId: '1609081',
    name: 'Sido Waluyo',
  },
  {
    id: '1609081008',
    districtId: '1609081',
    name: 'Sugih Waras',
  },
  {
    id: '1609081009',
    districtId: '1609081',
    name: 'Rejosari',
  },
  {
    id: '1609081010',
    districtId: '1609081',
    name: 'Tulung Sari',
  },
  {
    id: '1609081011',
    districtId: '1609081',
    name: 'Petanggan',
  },
  {
    id: '1609081012',
    districtId: '1609081',
    name: 'Mulya Sari',
  },
  {
    id: '1609090002',
    districtId: '1609090',
    name: 'Jaya Mulia',
  },
  {
    id: '1609090007',
    districtId: '1609090',
    name: 'Gunung Sugih',
  },
  {
    id: '1609090008',
    districtId: '1609090',
    name: 'Taman Agung',
  },
  {
    id: '1609090009',
    districtId: '1609090',
    name: 'Trimo Harjo',
  },
  {
    id: '1609090011',
    districtId: '1609090',
    name: 'Suka Mulya',
  },
  {
    id: '1609090018',
    districtId: '1609090',
    name: 'Taraman',
  },
  {
    id: '1609090019',
    districtId: '1609090',
    name: 'Karang Endah',
  },
  {
    id: '1609090020',
    districtId: '1609090',
    name: 'Sri Wangi',
  },
  {
    id: '1609090021',
    districtId: '1609090',
    name: 'Krujon',
  },
  {
    id: '1609090022',
    districtId: '1609090',
    name: 'Margorejo',
  },
  {
    id: '1609090023',
    districtId: '1609090',
    name: 'Cahaya Negeri',
  },
  {
    id: '1609090024',
    districtId: '1609090',
    name: 'Taman Mulyo',
  },
  {
    id: '1609090025',
    districtId: '1609090',
    name: 'Mujo Rahayu',
  },
  {
    id: '1609090026',
    districtId: '1609090',
    name: 'Taman Harjo',
  },
  {
    id: '1609090027',
    districtId: '1609090',
    name: 'Trimo Rejo',
  },
  {
    id: '1609090028',
    districtId: '1609090',
    name: 'Karang Marga',
  },
  {
    id: '1609090029',
    districtId: '1609090',
    name: 'Taraman Jaya',
  },
  {
    id: '1609090030',
    districtId: '1609090',
    name: 'Sri Wangi Ulu',
  },
  {
    id: '1609090031',
    districtId: '1609090',
    name: 'Margo Dadi',
  },
  {
    id: '1609091001',
    districtId: '1609091',
    name: 'Karang Menjangan',
  },
  {
    id: '1609091002',
    districtId: '1609091',
    name: 'Karang Melati',
  },
  {
    id: '1609091003',
    districtId: '1609091',
    name: 'Karang Anyar',
  },
  {
    id: '1609091004',
    districtId: '1609091',
    name: 'Tulung Harapan',
  },
  {
    id: '1609091005',
    districtId: '1609091',
    name: 'Nirwana',
  },
  {
    id: '1609091006',
    districtId: '1609091',
    name: 'Burnai Mulya',
  },
  {
    id: '1609091007',
    districtId: '1609091',
    name: 'Kota Tanah',
  },
  {
    id: '1609091008',
    districtId: '1609091',
    name: 'Melati Jaya',
  },
  {
    id: '1609091009',
    districtId: '1609091',
    name: 'Karang Mulya',
  },
  {
    id: '1609091010',
    districtId: '1609091',
    name: 'Harapan Jaya',
  },
  {
    id: '1609091011',
    districtId: '1609091',
    name: 'Wana Sari',
  },
  {
    id: '1609091012',
    districtId: '1609091',
    name: 'Burnai Jaya',
  },
  {
    id: '1609091013',
    districtId: '1609091',
    name: 'Mulya Jaya',
  },
  {
    id: '1609091014',
    districtId: '1609091',
    name: 'Kota Mulya',
  },
  {
    id: '1609091015',
    districtId: '1609091',
    name: 'Bungin Jaya',
  },
  {
    id: '1609091016',
    districtId: '1609091',
    name: 'Melati Agung',
  },
  {
    id: '1609091017',
    districtId: '1609091',
    name: 'Wana Makmur',
  },
  {
    id: '1609091018',
    districtId: '1609091',
    name: 'Bawang Tikar',
  },
  {
    id: '1609091019',
    districtId: '1609091',
    name: 'Karya Bakti',
  },
  {
    id: '1609091020',
    districtId: '1609091',
    name: 'Harapan Makmur',
  },
  {
    id: '1609091021',
    districtId: '1609091',
    name: 'Wana Jaya',
  },
  {
    id: '1609100033',
    districtId: '1609100',
    name: 'Ulak Baru',
  },
  {
    id: '1609100034',
    districtId: '1609100',
    name: 'Kuripan',
  },
  {
    id: '1609100035',
    districtId: '1609100',
    name: 'Gunung Jati',
  },
  {
    id: '1609100036',
    districtId: '1609100',
    name: 'Negeri Sakti',
  },
  {
    id: '1609100037',
    districtId: '1609100',
    name: 'Campang Tiga Ulu',
  },
  {
    id: '1609100038',
    districtId: '1609100',
    name: 'Campang Tiga Ilir',
  },
  {
    id: '1609100039',
    districtId: '1609100',
    name: 'Sukaraja',
  },
  {
    id: '1609100040',
    districtId: '1609100',
    name: 'Cempaka',
  },
  {
    id: '1609100041',
    districtId: '1609100',
    name: 'Sukabumi',
  },
  {
    id: '1609100042',
    districtId: '1609100',
    name: 'Gunung Batu',
  },
  {
    id: '1609100043',
    districtId: '1609100',
    name: 'Maluai Indah',
  },
  {
    id: '1609100044',
    districtId: '1609100',
    name: 'Harisan Jaya',
  },
  {
    id: '1609100045',
    districtId: '1609100',
    name: 'Campang Tiga Jaya',
  },
  {
    id: '1609101001',
    districtId: '1609101',
    name: 'Tanjung Kukuh',
  },
  {
    id: '1609101002',
    districtId: '1609101',
    name: 'Betung',
  },
  {
    id: '1609101003',
    districtId: '1609101',
    name: 'Tanjung Mas',
  },
  {
    id: '1609101004',
    districtId: '1609101',
    name: 'Menanga Besar',
  },
  {
    id: '1609101005',
    districtId: '1609101',
    name: 'Menanga Tengah',
  },
  {
    id: '1609101006',
    districtId: '1609101',
    name: 'Kangkung',
  },
  {
    id: '1609101007',
    districtId: '1609101',
    name: 'Adu Manis',
  },
  {
    id: '1609101008',
    districtId: '1609101',
    name: 'Suka Negeri',
  },
  {
    id: '1609101009',
    districtId: '1609101',
    name: 'Sri Tanjung',
  },
  {
    id: '1609101010',
    districtId: '1609101',
    name: 'Kangkung Ilir',
  },
  {
    id: '1609101011',
    districtId: '1609101',
    name: 'Betung Timur',
  },
  {
    id: '1609101012',
    districtId: '1609101',
    name: 'Menanga Sari',
  },
  {
    id: '1609101013',
    districtId: '1609101',
    name: 'Tanjung Jaya',
  },
  {
    id: '1610010004',
    districtId: '1610010',
    name: 'Munggu',
  },
  {
    id: '1610010005',
    districtId: '1610010',
    name: 'Seri Menanti',
  },
  {
    id: '1610010006',
    districtId: '1610010',
    name: 'Rantau Sialang',
  },
  {
    id: '1610010007',
    districtId: '1610010',
    name: 'Kuang Anyar',
  },
  {
    id: '1610010009',
    districtId: '1610010',
    name: 'Kasah',
  },
  {
    id: '1610010011',
    districtId: '1610010',
    name: 'Muara Kuang',
  },
  {
    id: '1610010012',
    districtId: '1610010',
    name: 'Tanabang Ilir',
  },
  {
    id: '1610010013',
    districtId: '1610010',
    name: 'Seri Kembang',
  },
  {
    id: '1610010014',
    districtId: '1610010',
    name: 'Naga Sari',
  },
  {
    id: '1610010015',
    districtId: '1610010',
    name: 'Suka Cinta',
  },
  {
    id: '1610010016',
    districtId: '1610010',
    name: 'Kelampadu',
  },
  {
    id: '1610010017',
    districtId: '1610010',
    name: 'Sukajadi',
  },
  {
    id: '1610010018',
    districtId: '1610010',
    name: 'Rama Kasih',
  },
  {
    id: '1610010019',
    districtId: '1610010',
    name: 'Tanabang Ulu',
  },
  {
    id: '1610011001',
    districtId: '1610011',
    name: 'Ibul Dalam',
  },
  {
    id: '1610011002',
    districtId: '1610011',
    name: 'Beringin Dalam',
  },
  {
    id: '1610011003',
    districtId: '1610011',
    name: 'Kuang Dalam Barat',
  },
  {
    id: '1610011004',
    districtId: '1610011',
    name: 'Lubuk Tunggal',
  },
  {
    id: '1610011005',
    districtId: '1610011',
    name: 'Ulak Segara',
  },
  {
    id: '1610011006',
    districtId: '1610011',
    name: 'Tambang Rambang',
  },
  {
    id: '1610011007',
    districtId: '1610011',
    name: 'Tangai',
  },
  {
    id: '1610011008',
    districtId: '1610011',
    name: 'Tanjung Miring',
  },
  {
    id: '1610011009',
    districtId: '1610011',
    name: 'Kayu Ara',
  },
  {
    id: '1610011010',
    districtId: '1610011',
    name: 'Tanjung Bulan',
  },
  {
    id: '1610011011',
    districtId: '1610011',
    name: 'Sunur',
  },
  {
    id: '1610011012',
    districtId: '1610011',
    name: 'Kuang Dalam Timur',
  },
  {
    id: '1610011013',
    districtId: '1610011',
    name: 'Sukananti',
  },
  {
    id: '1610012001',
    districtId: '1610012',
    name: 'Ulak Kembahang',
  },
  {
    id: '1610012002',
    districtId: '1610012',
    name: 'Lubuk Keliat',
  },
  {
    id: '1610012003',
    districtId: '1610012',
    name: 'Embacang',
  },
  {
    id: '1610012004',
    districtId: '1610012',
    name: 'Betung I',
  },
  {
    id: '1610012005',
    districtId: '1610012',
    name: 'Kasih Raja',
  },
  {
    id: '1610012006',
    districtId: '1610012',
    name: 'Talang Tengah',
  },
  {
    id: '1610012007',
    districtId: '1610012',
    name: 'Ketiau',
  },
  {
    id: '1610012008',
    districtId: '1610012',
    name: 'Betung II',
  },
  {
    id: '1610012009',
    districtId: '1610012',
    name: 'Payalingkung',
  },
  {
    id: '1610012010',
    districtId: '1610012',
    name: 'Talang Tengah Laut',
  },
  {
    id: '1610020008',
    districtId: '1610020',
    name: 'Seri Bandung',
  },
  {
    id: '1610020012',
    districtId: '1610020',
    name: 'Seri Tanjung',
  },
  {
    id: '1610020013',
    districtId: '1610020',
    name: 'Bangun Jaya',
  },
  {
    id: '1610020014',
    districtId: '1610020',
    name: 'Tanjung Tambak',
  },
  {
    id: '1610020015',
    districtId: '1610020',
    name: 'Tanjung Baru Petai',
  },
  {
    id: '1610020016',
    districtId: '1610020',
    name: 'Tanjung Batu Seberang',
  },
  {
    id: '1610020017',
    districtId: '1610020',
    name: 'Tanjung Atap',
  },
  {
    id: '1610020018',
    districtId: '1610020',
    name: 'Limbang Jaya I',
  },
  {
    id: '1610020024',
    districtId: '1610020',
    name: 'Tanjung Laut',
  },
  {
    id: '1610020025',
    districtId: '1610020',
    name: 'Tanjung Pinang I',
  },
  {
    id: '1610020026',
    districtId: '1610020',
    name: 'Tanjung Batu',
  },
  {
    id: '1610020027',
    districtId: '1610020',
    name: 'Pajar Bulan',
  },
  {
    id: '1610020028',
    districtId: '1610020',
    name: 'Senuro Timur',
  },
  {
    id: '1610020029',
    districtId: '1610020',
    name: 'Sentul',
  },
  {
    id: '1610020030',
    districtId: '1610020',
    name: 'Burai',
  },
  {
    id: '1610020031',
    districtId: '1610020',
    name: 'Tanjung Batu Timur',
  },
  {
    id: '1610020032',
    districtId: '1610020',
    name: 'Tanjung Tambak Baru',
  },
  {
    id: '1610020033',
    districtId: '1610020',
    name: 'Limbang Jaya II',
  },
  {
    id: '1610020034',
    districtId: '1610020',
    name: 'Senuro Barat',
  },
  {
    id: '1610020035',
    districtId: '1610020',
    name: 'Tanjung Pinang II',
  },
  {
    id: '1610020036',
    districtId: '1610020',
    name: 'Tanjung Atap Barat',
  },
  {
    id: '1610021001',
    districtId: '1610021',
    name: 'Tebedak I',
  },
  {
    id: '1610021002',
    districtId: '1610021',
    name: 'Lubuk Bandung',
  },
  {
    id: '1610021003',
    districtId: '1610021',
    name: 'Rengas I',
  },
  {
    id: '1610021004',
    districtId: '1610021',
    name: 'Paya Besar',
  },
  {
    id: '1610021005',
    districtId: '1610021',
    name: 'Talang Seleman',
  },
  {
    id: '1610021006',
    districtId: '1610021',
    name: 'Payaraman Timur',
  },
  {
    id: '1610021007',
    districtId: '1610021',
    name: 'Seri Kembang I',
  },
  {
    id: '1610021008',
    districtId: '1610021',
    name: 'Tanjung Lalang',
  },
  {
    id: '1610021009',
    districtId: '1610021',
    name: 'Seri Kembang II',
  },
  {
    id: '1610021010',
    districtId: '1610021',
    name: 'Seri Kembang III',
  },
  {
    id: '1610021011',
    districtId: '1610021',
    name: 'Tebedak II',
  },
  {
    id: '1610021012',
    districtId: '1610021',
    name: 'Rengas II',
  },
  {
    id: '1610021013',
    districtId: '1610021',
    name: 'Payaraman Barat',
  },
  {
    id: '1610030001',
    districtId: '1610030',
    name: 'Kelampaian',
  },
  {
    id: '1610030002',
    districtId: '1610030',
    name: 'Suka Nanti',
  },
  {
    id: '1610030003',
    districtId: '1610030',
    name: 'Rantau Alai',
  },
  {
    id: '1610030004',
    districtId: '1610030',
    name: 'Kertabayang',
  },
  {
    id: '1610030005',
    districtId: '1610030',
    name: 'Suka Maju',
  },
  {
    id: '1610030006',
    districtId: '1610030',
    name: 'Sukamarga',
  },
  {
    id: '1610030007',
    districtId: '1610030',
    name: 'Sanding Marga',
  },
  {
    id: '1610030011',
    districtId: '1610030',
    name: 'Tanjung Mas',
  },
  {
    id: '1610030012',
    districtId: '1610030',
    name: 'Lebung Bandung',
  },
  {
    id: '1610030013',
    districtId: '1610030',
    name: 'Talang Sari',
  },
  {
    id: '1610030019',
    districtId: '1610030',
    name: 'Sirah Pulau Kilip',
  },
  {
    id: '1610030020',
    districtId: '1610030',
    name: 'Mekar Sari',
  },
  {
    id: '1610030021',
    districtId: '1610030',
    name: 'Sukananti  Baru',
  },
  {
    id: '1610031001',
    districtId: '1610031',
    name: 'Kumbang Ulu',
  },
  {
    id: '1610031002',
    districtId: '1610031',
    name: 'Kumbang Ilir',
  },
  {
    id: '1610031003',
    districtId: '1610031',
    name: 'Tanjung Alai',
  },
  {
    id: '1610031004',
    districtId: '1610031',
    name: 'Muara Kumbang',
  },
  {
    id: '1610031005',
    districtId: '1610031',
    name: 'Lubuk Rukam',
  },
  {
    id: '1610031006',
    districtId: '1610031',
    name: 'Pandan Arang',
  },
  {
    id: '1610031007',
    districtId: '1610031',
    name: 'Kandis I',
  },
  {
    id: '1610031008',
    districtId: '1610031',
    name: 'Santapan Barat',
  },
  {
    id: '1610031009',
    districtId: '1610031',
    name: 'Miji',
  },
  {
    id: '1610031010',
    districtId: '1610031',
    name: 'Santapan Timur',
  },
  {
    id: '1610031011',
    districtId: '1610031',
    name: 'Kandis II',
  },
  {
    id: '1610031012',
    districtId: '1610031',
    name: 'Lubuk Segonang',
  },
  {
    id: '1610040024',
    districtId: '1610040',
    name: 'Tanjung Temiang',
  },
  {
    id: '1610040028',
    districtId: '1610040',
    name: 'Seridalam',
  },
  {
    id: '1610040030',
    districtId: '1610040',
    name: 'Tanjung Raja',
  },
  {
    id: '1610040031',
    districtId: '1610040',
    name: 'Tanjung Raja Barat',
  },
  {
    id: '1610040032',
    districtId: '1610040',
    name: 'Tanjung Raja Utara',
  },
  {
    id: '1610040035',
    districtId: '1610040',
    name: 'Talang Balai Baru I',
  },
  {
    id: '1610040036',
    districtId: '1610040',
    name: 'Siring Alam',
  },
  {
    id: '1610040037',
    districtId: '1610040',
    name: 'Tanjung Agas',
  },
  {
    id: '1610040038',
    districtId: '1610040',
    name: 'Talang Balai Lama',
  },
  {
    id: '1610040045',
    districtId: '1610040',
    name: 'Suka Pindah',
  },
  {
    id: '1610040046',
    districtId: '1610040',
    name: 'Ulak Kerbau Lama',
  },
  {
    id: '1610040047',
    districtId: '1610040',
    name: 'Ulak Kerbau Baru',
  },
  {
    id: '1610040048',
    districtId: '1610040',
    name: 'Kerinjing',
  },
  {
    id: '1610040049',
    districtId: '1610040',
    name: 'Tanjung Raja Timur',
  },
  {
    id: '1610040050',
    districtId: '1610040',
    name: 'Belanti',
  },
  {
    id: '1610040051',
    districtId: '1610040',
    name: 'Tanjung Raja Selatan',
  },
  {
    id: '1610040052',
    districtId: '1610040',
    name: 'Talang Balai Baru II',
  },
  {
    id: '1610040053',
    districtId: '1610040',
    name: 'Skonjing',
  },
  {
    id: '1610040054',
    districtId: '1610040',
    name: 'Tanjung Harapan',
  },
  {
    id: '1610041001',
    districtId: '1610041',
    name: 'Ketapang I',
  },
  {
    id: '1610041002',
    districtId: '1610041',
    name: 'Jagalana',
  },
  {
    id: '1610041003',
    districtId: '1610041',
    name: 'Kota Daro I',
  },
  {
    id: '1610041004',
    districtId: '1610041',
    name: 'Kota Daro II',
  },
  {
    id: '1610041005',
    districtId: '1610041',
    name: 'Rantau Panjang Ilir',
  },
  {
    id: '1610041006',
    districtId: '1610041',
    name: 'Jagaraja',
  },
  {
    id: '1610041007',
    districtId: '1610041',
    name: 'Sejangko I',
  },
  {
    id: '1610041008',
    districtId: '1610041',
    name: 'Sungai Rotan',
  },
  {
    id: '1610041009',
    districtId: '1610041',
    name: 'Sejangko II',
  },
  {
    id: '1610041010',
    districtId: '1610041',
    name: 'Rantau Panjang Ulu',
  },
  {
    id: '1610041011',
    districtId: '1610041',
    name: 'Ketapang II',
  },
  {
    id: '1610041012',
    districtId: '1610041',
    name: 'Arisan Deras',
  },
  {
    id: '1610042001',
    districtId: '1610042',
    name: 'Tanjung Serian',
  },
  {
    id: '1610042002',
    districtId: '1610042',
    name: 'Talang Dukun',
  },
  {
    id: '1610042003',
    districtId: '1610042',
    name: 'Sungai Pinang III',
  },
  {
    id: '1610042004',
    districtId: '1610042',
    name: 'Sungai Pinang',
  },
  {
    id: '1610042005',
    districtId: '1610042',
    name: 'Sungai Pinang II',
  },
  {
    id: '1610042006',
    districtId: '1610042',
    name: 'Serijabo',
  },
  {
    id: '1610042007',
    districtId: '1610042',
    name: 'Penyandingan',
  },
  {
    id: '1610042008',
    districtId: '1610042',
    name: 'Pinang Jaya',
  },
  {
    id: '1610042009',
    districtId: '1610042',
    name: 'Sungai Pinang I',
  },
  {
    id: '1610042010',
    districtId: '1610042',
    name: 'Pinang Mas',
  },
  {
    id: '1610042011',
    districtId: '1610042',
    name: 'Sungai Pinang Lagati',
  },
  {
    id: '1610042012',
    districtId: '1610042',
    name: 'Sungai Pinang Nibung',
  },
  {
    id: '1610042013',
    districtId: '1610042',
    name: 'Serijabo Baru',
  },
  {
    id: '1610050016',
    districtId: '1610050',
    name: 'Aur Standing',
  },
  {
    id: '1610050019',
    districtId: '1610050',
    name: 'Suka Rami',
  },
  {
    id: '1610050020',
    districtId: '1610050',
    name: 'Palu',
  },
  {
    id: '1610050021',
    districtId: '1610050',
    name: 'Muara Dua',
  },
  {
    id: '1610050022',
    districtId: '1610050',
    name: 'Teluk Kecapi',
  },
  {
    id: '1610050023',
    districtId: '1610050',
    name: 'Pelabuhan Dalam',
  },
  {
    id: '1610050024',
    districtId: '1610050',
    name: 'Pemulutan Ulu',
  },
  {
    id: '1610050025',
    districtId: '1610050',
    name: 'Pemulutan Ilir',
  },
  {
    id: '1610050026',
    districtId: '1610050',
    name: 'Sungai Rasau',
  },
  {
    id: '1610050027',
    districtId: '1610050',
    name: 'Pegayut',
  },
  {
    id: '1610050028',
    districtId: '1610050',
    name: 'Ibul Besar I',
  },
  {
    id: '1610050029',
    districtId: '1610050',
    name: 'Ibul Besar II',
  },
  {
    id: '1610050030',
    districtId: '1610050',
    name: 'Ibul Besar III',
  },
  {
    id: '1610050031',
    districtId: '1610050',
    name: 'Mekar Jaya',
  },
  {
    id: '1610050032',
    districtId: '1610050',
    name: 'Lebung Jangkar',
  },
  {
    id: '1610050033',
    districtId: '1610050',
    name: 'Kedukan Bujang',
  },
  {
    id: '1610050034',
    districtId: '1610050',
    name: 'Rawa Jaya',
  },
  {
    id: '1610050035',
    districtId: '1610050',
    name: 'Babatan Saudagar',
  },
  {
    id: '1610050036',
    districtId: '1610050',
    name: 'Tanjung Pasir',
  },
  {
    id: '1610050037',
    districtId: '1610050',
    name: 'Harapan',
  },
  {
    id: '1610050038',
    districtId: '1610050',
    name: 'Pipa Putih',
  },
  {
    id: '1610050039',
    districtId: '1610050',
    name: 'Sungai Buaya',
  },
  {
    id: '1610050040',
    districtId: '1610050',
    name: 'Muara Baru',
  },
  {
    id: '1610050041',
    districtId: '1610050',
    name: 'Sembadak',
  },
  {
    id: '1610050042',
    districtId: '1610050',
    name: 'Simpang Pelabuhan Dalam',
  },
  {
    id: '1610051001',
    districtId: '1610051',
    name: 'Maju Jaya',
  },
  {
    id: '1610051002',
    districtId: '1610051',
    name: 'Naikan Tembakang',
  },
  {
    id: '1610051003',
    districtId: '1610051',
    name: 'Pematang Bangsal',
  },
  {
    id: '1610051004',
    districtId: '1610051',
    name: 'Sungai Lebung',
  },
  {
    id: '1610051005',
    districtId: '1610051',
    name: 'Cahaya Marga',
  },
  {
    id: '1610051006',
    districtId: '1610051',
    name: 'Mayapati',
  },
  {
    id: '1610051007',
    districtId: '1610051',
    name: 'Kapuk',
  },
  {
    id: '1610051008',
    districtId: '1610051',
    name: 'Segayam',
  },
  {
    id: '1610051009',
    districtId: '1610051',
    name: 'Ulak Aur Standing',
  },
  {
    id: '1610051010',
    districtId: '1610051',
    name: 'Harimau Tandang',
  },
  {
    id: '1610051011',
    districtId: '1610051',
    name: 'Sungai Keli',
  },
  {
    id: '1610051012',
    districtId: '1610051',
    name: 'Sungai Lebung Ulu',
  },
  {
    id: '1610051013',
    districtId: '1610051',
    name: 'Lebak Pering',
  },
  {
    id: '1610051014',
    districtId: '1610051',
    name: 'Sungai Ondok',
  },
  {
    id: '1610051015',
    districtId: '1610051',
    name: 'Pematang Bungur',
  },
  {
    id: '1610052001',
    districtId: '1610052',
    name: 'Suka Merindu',
  },
  {
    id: '1610052002',
    districtId: '1610052',
    name: 'Saranglang',
  },
  {
    id: '1610052003',
    districtId: '1610052',
    name: 'Kamal',
  },
  {
    id: '1610052004',
    districtId: '1610052',
    name: 'Pulau Negara',
  },
  {
    id: '1610052005',
    districtId: '1610052',
    name: 'Seribanding',
  },
  {
    id: '1610052006',
    districtId: '1610052',
    name: 'Talang Pangeran Ulu',
  },
  {
    id: '1610052007',
    districtId: '1610052',
    name: 'Ulak Kembahang I',
  },
  {
    id: '1610052008',
    districtId: '1610052',
    name: 'Ulak Petangisan',
  },
  {
    id: '1610052009',
    districtId: '1610052',
    name: 'Talang Pangeran Ilir',
  },
  {
    id: '1610052010',
    districtId: '1610052',
    name: 'Ulak Kembahang II',
  },
  {
    id: '1610052011',
    districtId: '1610052',
    name: 'Arisan Jaya',
  },
  {
    id: '1610060005',
    districtId: '1610060',
    name: 'Lubuk Sakti',
  },
  {
    id: '1610060006',
    districtId: '1610060',
    name: 'Tanjung Gelam',
  },
  {
    id: '1610060007',
    districtId: '1610060',
    name: 'Tanjung Agung',
  },
  {
    id: '1610060008',
    districtId: '1610060',
    name: 'Ulak Bedil',
  },
  {
    id: '1610060010',
    districtId: '1610060',
    name: 'Sudi Mampir',
  },
  {
    id: '1610060011',
    districtId: '1610060',
    name: 'Penyandingan',
  },
  {
    id: '1610060012',
    districtId: '1610060',
    name: 'Talang Aur',
  },
  {
    id: '1610060013',
    districtId: '1610060',
    name: 'Ulak Banding',
  },
  {
    id: '1610060014',
    districtId: '1610060',
    name: 'Muara Penimbung Ulu',
  },
  {
    id: '1610060015',
    districtId: '1610060',
    name: 'Sakatiga',
  },
  {
    id: '1610060016',
    districtId: '1610060',
    name: 'Tanjung Sejaro',
  },
  {
    id: '1610060017',
    districtId: '1610060',
    name: 'Sakatiga Seberang',
  },
  {
    id: '1610060019',
    districtId: '1610060',
    name: 'Tanjung Seteko',
  },
  {
    id: '1610060027',
    districtId: '1610060',
    name: 'Ulak Segelung',
  },
  {
    id: '1610060028',
    districtId: '1610060',
    name: 'Indralaya Mulya',
  },
  {
    id: '1610060029',
    districtId: '1610060',
    name: 'Indralaya Raya',
  },
  {
    id: '1610060030',
    districtId: '1610060',
    name: 'Indralaya Indah',
  },
  {
    id: '1610060031',
    districtId: '1610060',
    name: 'Muara Penimbung Ilir',
  },
  {
    id: '1610060032',
    districtId: '1610060',
    name: 'Tunas Aur',
  },
  {
    id: '1610060033',
    districtId: '1610060',
    name: 'Sejaro Sakti',
  },
  {
    id: '1610061001',
    districtId: '1610061',
    name: 'Bakung',
  },
  {
    id: '1610061002',
    districtId: '1610061',
    name: 'Lorok',
  },
  {
    id: '1610061003',
    districtId: '1610061',
    name: 'Parit',
  },
  {
    id: '1610061004',
    districtId: '1610061',
    name: 'Purnajaya',
  },
  {
    id: '1610061005',
    districtId: '1610061',
    name: 'Payakabung',
  },
  {
    id: '1610061006',
    districtId: '1610061',
    name: 'Tanjung Baru',
  },
  {
    id: '1610061007',
    districtId: '1610061',
    name: 'Tanjung Pering',
  },
  {
    id: '1610061008',
    districtId: '1610061',
    name: 'Sungai Rambutan',
  },
  {
    id: '1610061009',
    districtId: '1610061',
    name: 'Suak Batok',
  },
  {
    id: '1610061010',
    districtId: '1610061',
    name: 'Timbangan',
  },
  {
    id: '1610061011',
    districtId: '1610061',
    name: 'Suka Mulia',
  },
  {
    id: '1610061012',
    districtId: '1610061',
    name: 'Pulau Kabal',
  },
  {
    id: '1610061013',
    districtId: '1610061',
    name: 'Tanjung Pule',
  },
  {
    id: '1610061014',
    districtId: '1610061',
    name: 'Permata Baru',
  },
  {
    id: '1610061015',
    districtId: '1610061',
    name: 'Palem Raya',
  },
  {
    id: '1610061016',
    districtId: '1610061',
    name: 'Pulau Semambu',
  },
  {
    id: '1610062001',
    districtId: '1610062',
    name: 'Tanjung Dayang Selatan',
  },
  {
    id: '1610062002',
    districtId: '1610062',
    name: 'Mandi  Angin',
  },
  {
    id: '1610062003',
    districtId: '1610062',
    name: 'Sukaraja Baru',
  },
  {
    id: '1610062004',
    districtId: '1610062',
    name: 'Sukaraja Lama',
  },
  {
    id: '1610062005',
    districtId: '1610062',
    name: 'Tanjung Lubuk',
  },
  {
    id: '1610062006',
    districtId: '1610062',
    name: 'Beti',
  },
  {
    id: '1610062007',
    districtId: '1610062',
    name: 'Meranjat Ilir',
  },
  {
    id: '1610062008',
    districtId: '1610062',
    name: 'Meranjat II',
  },
  {
    id: '1610062009',
    districtId: '1610062',
    name: 'Meranjat I',
  },
  {
    id: '1610062010',
    districtId: '1610062',
    name: 'Tebing Gerinting Selatan',
  },
  {
    id: '1610062011',
    districtId: '1610062',
    name: 'Arisan Gading',
  },
  {
    id: '1610062012',
    districtId: '1610062',
    name: 'Meranjat III',
  },
  {
    id: '1610062013',
    districtId: '1610062',
    name: 'Tebing Gerinting Utara',
  },
  {
    id: '1610062014',
    districtId: '1610062',
    name: 'Tanjung Dayang Utara',
  },
  {
    id: '1611010006',
    districtId: '1611010',
    name: 'Sawah',
  },
  {
    id: '1611010007',
    districtId: '1611010',
    name: 'Seleman Ulu',
  },
  {
    id: '1611010008',
    districtId: '1611010',
    name: 'Seleman Ilir',
  },
  {
    id: '1611010009',
    districtId: '1611010',
    name: 'Muara Timbuk',
  },
  {
    id: '1611010010',
    districtId: '1611010',
    name: 'Batu Galang',
  },
  {
    id: '1611010011',
    districtId: '1611010',
    name: 'Lubuk Ulak',
  },
  {
    id: '1611010012',
    districtId: '1611010',
    name: 'Talang Benteng',
  },
  {
    id: '1611010013',
    districtId: '1611010',
    name: 'Muara Semah',
  },
  {
    id: '1611010014',
    districtId: '1611010',
    name: 'Niur',
  },
  {
    id: '1611010015',
    districtId: '1611010',
    name: 'Fajar Menang',
  },
  {
    id: '1611010016',
    districtId: '1611010',
    name: 'Gedung Agung',
  },
  {
    id: '1611010017',
    districtId: '1611010',
    name: 'Tanjung Tawang',
  },
  {
    id: '1611010018',
    districtId: '1611010',
    name: 'Muara Pinang Lama',
  },
  {
    id: '1611010019',
    districtId: '1611010',
    name: 'Sapapanjang',
  },
  {
    id: '1611010020',
    districtId: '1611010',
    name: 'Talang Baru',
  },
  {
    id: '1611010021',
    districtId: '1611010',
    name: 'Muara Pinang Baru',
  },
  {
    id: '1611010022',
    districtId: '1611010',
    name: 'Lubuk Tanjung',
  },
  {
    id: '1611010034',
    districtId: '1611010',
    name: 'Padang Burnai',
  },
  {
    id: '1611010035',
    districtId: '1611010',
    name: 'Tanjung Kurung',
  },
  {
    id: '1611010036',
    districtId: '1611010',
    name: 'Belimbing',
  },
  {
    id: '1611010037',
    districtId: '1611010',
    name: 'Suka Dana',
  },
  {
    id: '1611010038',
    districtId: '1611010',
    name: 'Batu Jungul',
  },
  {
    id: '1611020001',
    districtId: '1611020',
    name: 'Tanjung Alam',
  },
  {
    id: '1611020002',
    districtId: '1611020',
    name: 'Lesung Batu',
  },
  {
    id: '1611020003',
    districtId: '1611020',
    name: 'Babatan',
  },
  {
    id: '1611020004',
    districtId: '1611020',
    name: 'Rantaualih',
  },
  {
    id: '1611020005',
    districtId: '1611020',
    name: 'Sukarami',
  },
  {
    id: '1611020006',
    districtId: '1611020',
    name: 'Rantau Kasai',
  },
  {
    id: '1611020007',
    districtId: '1611020',
    name: 'Lubuk Cik',
  },
  {
    id: '1611020008',
    districtId: '1611020',
    name: 'Karang Tanding',
  },
  {
    id: '1611020009',
    districtId: '1611020',
    name: 'Batu Ampar',
  },
  {
    id: '1611020010',
    districtId: '1611020',
    name: 'Nibung',
  },
  {
    id: '1611020011',
    districtId: '1611020',
    name: 'Pagar Jati',
  },
  {
    id: '1611020012',
    districtId: '1611020',
    name: 'Tanjung Jati',
  },
  {
    id: '1611020013',
    districtId: '1611020',
    name: 'Umojati',
  },
  {
    id: '1611020014',
    districtId: '1611020',
    name: 'Muara Danau',
  },
  {
    id: '1611020015',
    districtId: '1611020',
    name: 'Lubuk Tapang',
  },
  {
    id: '1611020016',
    districtId: '1611020',
    name: 'Endalo',
  },
  {
    id: '1611030001',
    districtId: '1611030',
    name: 'Lubuk Layang',
  },
  {
    id: '1611030002',
    districtId: '1611030',
    name: 'Bandar Agung',
  },
  {
    id: '1611030003',
    districtId: '1611030',
    name: 'Jarakan',
  },
  {
    id: '1611030004',
    districtId: '1611030',
    name: 'Lubuk Sepang',
  },
  {
    id: '1611030005',
    districtId: '1611030',
    name: 'Nanjungan',
  },
  {
    id: '1611030006',
    districtId: '1611030',
    name: 'Tanjung Eran',
  },
  {
    id: '1611030007',
    districtId: '1611030',
    name: 'Tanjung Raman',
  },
  {
    id: '1611030008',
    districtId: '1611030',
    name: 'Pendopo',
  },
  {
    id: '1611030010',
    districtId: '1611030',
    name: 'Gunung Meraksabaru',
  },
  {
    id: '1611030011',
    districtId: '1611030',
    name: 'Sarang Bulan',
  },
  {
    id: '1611030012',
    districtId: '1611030',
    name: 'Bayau',
  },
  {
    id: '1611030013',
    districtId: '1611030',
    name: 'Tanjung Baru',
  },
  {
    id: '1611030014',
    districtId: '1611030',
    name: 'Muara Karang',
  },
  {
    id: '1611030015',
    districtId: '1611030',
    name: 'Landur',
  },
  {
    id: '1611030016',
    districtId: '1611030',
    name: 'Gunung Meraksa Lama',
  },
  {
    id: '1611030017',
    districtId: '1611030',
    name: 'Manggilan',
  },
  {
    id: '1611030018',
    districtId: '1611030',
    name: 'Batu Cawang',
  },
  {
    id: '1611030021',
    districtId: '1611030',
    name: 'Beruge Ilir',
  },
  {
    id: '1611030031',
    districtId: '1611030',
    name: 'Pagar Tengah',
  },
  {
    id: '1611031001',
    districtId: '1611031',
    name: 'Muara Lintang Lama',
  },
  {
    id: '1611031002',
    districtId: '1611031',
    name: 'Muara Lintang Baru',
  },
  {
    id: '1611031003',
    districtId: '1611031',
    name: 'Tebat Payang',
  },
  {
    id: '1611031004',
    districtId: '1611031',
    name: 'Karang Caya',
  },
  {
    id: '1611031005',
    districtId: '1611031',
    name: 'Tanjung Raya',
  },
  {
    id: '1611031006',
    districtId: '1611031',
    name: 'Padang Bindu',
  },
  {
    id: '1611031007',
    districtId: '1611031',
    name: 'Lingge',
  },
  {
    id: '1611031008',
    districtId: '1611031',
    name: 'Rantau Dodor',
  },
  {
    id: '1611031009',
    districtId: '1611031',
    name: 'Kungkilan',
  },
  {
    id: '1611031010',
    districtId: '1611031',
    name: 'Air Kandis',
  },
  {
    id: '1611040001',
    districtId: '1611040',
    name: 'Penantian',
  },
  {
    id: '1611040002',
    districtId: '1611040',
    name: 'Talang Padang',
  },
  {
    id: '1611040003',
    districtId: '1611040',
    name: 'Tanjung Beringin',
  },
  {
    id: '1611040004',
    districtId: '1611040',
    name: 'Lawang Agung',
  },
  {
    id: '1611040005',
    districtId: '1611040',
    name: 'Pagar Jati',
  },
  {
    id: '1611040006',
    districtId: '1611040',
    name: 'Bandar Agung',
  },
  {
    id: '1611040007',
    districtId: '1611040',
    name: 'Keban Jati',
  },
  {
    id: '1611040008',
    districtId: '1611040',
    name: 'Nanjungan',
  },
  {
    id: '1611040009',
    districtId: '1611040',
    name: 'Talang Randai',
  },
  {
    id: '1611040010',
    districtId: '1611040',
    name: 'Air Mayan',
  },
  {
    id: '1611040011',
    districtId: '1611040',
    name: 'Padang Gelai',
  },
  {
    id: '1611040012',
    districtId: '1611040',
    name: 'Muara Rungga',
  },
  {
    id: '1611040013',
    districtId: '1611040',
    name: 'Padang Bindu',
  },
  {
    id: '1611040014',
    districtId: '1611040',
    name: 'Muara Sindang',
  },
  {
    id: '1611040015',
    districtId: '1611040',
    name: 'Muara Aman',
  },
  {
    id: '1611050016',
    districtId: '1611050',
    name: 'Air Kelinsar',
  },
  {
    id: '1611050017',
    districtId: '1611050',
    name: 'Talang Bengkulu',
  },
  {
    id: '1611050018',
    districtId: '1611050',
    name: 'Kunduran',
  },
  {
    id: '1611050019',
    districtId: '1611050',
    name: 'Simpang Perigi',
  },
  {
    id: '1611050020',
    districtId: '1611050',
    name: 'Muara Kalangan',
  },
  {
    id: '1611050021',
    districtId: '1611050',
    name: 'Batu Lintang',
  },
  {
    id: '1611050022',
    districtId: '1611050',
    name: 'Galang',
  },
  {
    id: '1611050023',
    districtId: '1611050',
    name: 'Tanjung Agung',
  },
  {
    id: '1611050024',
    districtId: '1611050',
    name: 'Padang Tepong',
  },
  {
    id: '1611050025',
    districtId: '1611050',
    name: 'Muara Betung',
  },
  {
    id: '1611050026',
    districtId: '1611050',
    name: 'Pulau Kemang',
  },
  {
    id: '1611050027',
    districtId: '1611050',
    name: 'Lubuk Puding Baru',
  },
  {
    id: '1611050028',
    districtId: '1611050',
    name: 'Lubuk Puding Lama',
  },
  {
    id: '1611050029',
    districtId: '1611050',
    name: 'Batu Bidung',
  },
  {
    id: '1611051001',
    districtId: '1611051',
    name: 'Puntang',
  },
  {
    id: '1611051002',
    districtId: '1611051',
    name: 'Bandar Aji',
  },
  {
    id: '1611051003',
    districtId: '1611051',
    name: 'Paduraksa',
  },
  {
    id: '1611051004',
    districtId: '1611051',
    name: 'Karang Gede',
  },
  {
    id: '1611051005',
    districtId: '1611051',
    name: 'Karang Dapo Baru',
  },
  {
    id: '1611051006',
    districtId: '1611051',
    name: 'Karang Dapo Lama',
  },
  {
    id: '1611051007',
    districtId: '1611051',
    name: 'Tangga Rasa',
  },
  {
    id: '1611051008',
    districtId: '1611051',
    name: 'Tapa Lama',
  },
  {
    id: '1611051009',
    districtId: '1611051',
    name: 'Tapa Baru',
  },
  {
    id: '1611051010',
    districtId: '1611051',
    name: 'Marta Pura',
  },
  {
    id: '1611051011',
    districtId: '1611051',
    name: 'Karang Anyar',
  },
  {
    id: '1611060001',
    districtId: '1611060',
    name: 'Karang Are',
  },
  {
    id: '1611060002',
    districtId: '1611060',
    name: 'Kembahang Lama',
  },
  {
    id: '1611060003',
    districtId: '1611060',
    name: 'Padang Titiran',
  },
  {
    id: '1611060004',
    districtId: '1611060',
    name: 'Ps Talang Padang',
  },
  {
    id: '1611060005',
    districtId: '1611060',
    name: 'Macang Manis',
  },
  {
    id: '1611060006',
    districtId: '1611060',
    name: 'Talang Padang',
  },
  {
    id: '1611060007',
    districtId: '1611060',
    name: 'Lampar Baru',
  },
  {
    id: '1611060008',
    districtId: '1611060',
    name: 'Kembahang Baru',
  },
  {
    id: '1611060009',
    districtId: '1611060',
    name: 'Canggu',
  },
  {
    id: '1611060010',
    districtId: '1611060',
    name: 'Remantai',
  },
  {
    id: '1611060011',
    districtId: '1611060',
    name: 'Talang Durian',
  },
  {
    id: '1611060012',
    districtId: '1611060',
    name: 'Lubuk Buntak',
  },
  {
    id: '1611060013',
    districtId: '1611060',
    name: 'Ulak Dabuk',
  },
  {
    id: '1611070014',
    districtId: '1611070',
    name: 'Ujung Alih',
  },
  {
    id: '1611070015',
    districtId: '1611070',
    name: 'Lubuk Gelanggang',
  },
  {
    id: '1611070016',
    districtId: '1611070',
    name: 'Ulak Mengkudu',
  },
  {
    id: '1611070017',
    districtId: '1611070',
    name: 'Batu Pance',
  },
  {
    id: '1611070018',
    districtId: '1611070',
    name: 'Aur Gading',
  },
  {
    id: '1611070019',
    districtId: '1611070',
    name: 'Terusan Lama',
  },
  {
    id: '1611070020',
    districtId: '1611070',
    name: 'Terusan Baru',
  },
  {
    id: '1611070021',
    districtId: '1611070',
    name: 'Seguring Kecil',
  },
  {
    id: '1611070022',
    districtId: '1611070',
    name: 'Rantau Tenang',
  },
  {
    id: '1611070023',
    districtId: '1611070',
    name: 'Lampar Baru',
  },
  {
    id: '1611070024',
    districtId: '1611070',
    name: 'Kemang Manis',
  },
  {
    id: '1611070025',
    districtId: '1611070',
    name: 'Kupang',
  },
  {
    id: '1611070026',
    districtId: '1611070',
    name: 'Mekar Jaya',
  },
  {
    id: '1611070027',
    districtId: '1611070',
    name: 'Makarti Jaya',
  },
  {
    id: '1611070028',
    districtId: '1611070',
    name: 'Pancurmas Unit Jaya',
  },
  {
    id: '1611070029',
    districtId: '1611070',
    name: 'Tanjung Kupang',
  },
  {
    id: '1611070030',
    districtId: '1611070',
    name: 'Pasar Tebing Tinggi',
  },
  {
    id: '1611070031',
    districtId: '1611070',
    name: 'Tanjung Makmur',
  },
  {
    id: '1611070032',
    districtId: '1611070',
    name: 'Kelumpang Jaya',
  },
  {
    id: '1611070033',
    districtId: '1611070',
    name: 'Pajar Bakti',
  },
  {
    id: '1611070034',
    districtId: '1611070',
    name: 'Sugi Waras',
  },
  {
    id: '1611070035',
    districtId: '1611070',
    name: 'Batu Raja Baru',
  },
  {
    id: '1611070036',
    districtId: '1611070',
    name: 'Batu Raja Lama',
  },
  {
    id: '1611070037',
    districtId: '1611070',
    name: 'Kota Gading',
  },
  {
    id: '1611070047',
    districtId: '1611070',
    name: 'Jaya Loka',
  },
  {
    id: '1611070048',
    districtId: '1611070',
    name: 'Tanjung Kupang Baru',
  },
  {
    id: '1611071001',
    districtId: '1611071',
    name: 'Lubuk Kelumpang',
  },
  {
    id: '1611071002',
    districtId: '1611071',
    name: 'Sawah',
  },
  {
    id: '1611071003',
    districtId: '1611071',
    name: 'Tanjung Ning Simpang',
  },
  {
    id: '1611071004',
    districtId: '1611071',
    name: 'Tanjung Ning Jaya',
  },
  {
    id: '1611071005',
    districtId: '1611071',
    name: 'Tanjung Ning Lama',
  },
  {
    id: '1611071006',
    districtId: '1611071',
    name: 'Tanjung Ning Tengah',
  },
  {
    id: '1611071007',
    districtId: '1611071',
    name: 'Kebon',
  },
  {
    id: '1611071008',
    districtId: '1611071',
    name: 'Suka Kaya',
  },
  {
    id: '1611071009',
    districtId: '1611071',
    name: 'Taba',
  },
  {
    id: '1611071010',
    districtId: '1611071',
    name: 'Muara Saling',
  },
  {
    id: '1612010001',
    districtId: '1612010',
    name: 'Semangus',
  },
  {
    id: '1612010002',
    districtId: '1612010',
    name: 'Benakat Minyak',
  },
  {
    id: '1612010003',
    districtId: '1612010',
    name: 'Sungai Baung',
  },
  {
    id: '1612010004',
    districtId: '1612010',
    name: 'Talang Ubi Barat',
  },
  {
    id: '1612010005',
    districtId: '1612010',
    name: 'Pasar Bhayangkara',
  },
  {
    id: '1612010006',
    districtId: '1612010',
    name: 'Talang Ubi Selatan',
  },
  {
    id: '1612010007',
    districtId: '1612010',
    name: 'Talang Ubi Timur',
  },
  {
    id: '1612010008',
    districtId: '1612010',
    name: 'Handayani Mulia',
  },
  {
    id: '1612010009',
    districtId: '1612010',
    name: 'Simpang Tais',
  },
  {
    id: '1612010010',
    districtId: '1612010',
    name: 'Talang Bulang',
  },
  {
    id: '1612010011',
    districtId: '1612010',
    name: 'Benuang',
  },
  {
    id: '1612010012',
    districtId: '1612010',
    name: 'Beruge Darat',
  },
  {
    id: '1612010013',
    districtId: '1612010',
    name: 'Kertadewa',
  },
  {
    id: '1612010014',
    districtId: '1612010',
    name: 'Sinar Dewa',
  },
  {
    id: '1612010015',
    districtId: '1612010',
    name: 'Panta Dewa',
  },
  {
    id: '1612010016',
    districtId: '1612010',
    name: 'Sungai Ibul',
  },
  {
    id: '1612010017',
    districtId: '1612010',
    name: 'Sukamaju',
  },
  {
    id: '1612010018',
    districtId: '1612010',
    name: 'Talang Ubi Utara',
  },
  {
    id: '1612010019',
    districtId: '1612010',
    name: 'Suka Damai',
  },
  {
    id: '1612010020',
    districtId: '1612010',
    name: 'Talang Akar',
  },
  {
    id: '1612020001',
    districtId: '1612020',
    name: 'Bumiayu',
  },
  {
    id: '1612020002',
    districtId: '1612020',
    name: 'Tanah Abang Selatan',
  },
  {
    id: '1612020003',
    districtId: '1612020',
    name: 'Suka Manis',
  },
  {
    id: '1612020004',
    districtId: '1612020',
    name: 'Muara Dua',
  },
  {
    id: '1612020005',
    districtId: '1612020',
    name: 'Petulai',
  },
  {
    id: '1612020006',
    districtId: '1612020',
    name: 'Tanah Abang Utara',
  },
  {
    id: '1612020007',
    districtId: '1612020',
    name: 'Muara Sungai',
  },
  {
    id: '1612020008',
    districtId: '1612020',
    name: 'Curup',
  },
  {
    id: '1612020009',
    districtId: '1612020',
    name: 'Raja',
  },
  {
    id: '1612020010',
    districtId: '1612020',
    name: 'Raja Barat',
  },
  {
    id: '1612020011',
    districtId: '1612020',
    name: 'Harapan Jaya',
  },
  {
    id: '1612020012',
    districtId: '1612020',
    name: 'Lunas Jaya',
  },
  {
    id: '1612020013',
    districtId: '1612020',
    name: 'Sukaraja',
  },
  {
    id: '1612020014',
    districtId: '1612020',
    name: 'Sedupi',
  },
  {
    id: '1612020015',
    districtId: '1612020',
    name: 'Tanjung Dalam',
  },
  {
    id: '1612020016',
    districtId: '1612020',
    name: 'Pandan',
  },
  {
    id: '1612020017',
    districtId: '1612020',
    name: 'Modong',
  },
  {
    id: '1612030001',
    districtId: '1612030',
    name: 'Pengabuan',
  },
  {
    id: '1612030002',
    districtId: '1612030',
    name: 'Pengabuan Timur',
  },
  {
    id: '1612030003',
    districtId: '1612030',
    name: 'Perambatan',
  },
  {
    id: '1612030004',
    districtId: '1612030',
    name: 'Betung',
  },
  {
    id: '1612030005',
    districtId: '1612030',
    name: 'Betung Selatan',
  },
  {
    id: '1612030006',
    districtId: '1612030',
    name: 'Betung Barat',
  },
  {
    id: '1612030007',
    districtId: '1612030',
    name: 'Karang Agung',
  },
  {
    id: '1612030008',
    districtId: '1612030',
    name: 'Tanjung Kurung',
  },
  {
    id: '1612040001',
    districtId: '1612040',
    name: 'Purun Timur',
  },
  {
    id: '1612040002',
    districtId: '1612040',
    name: 'Purun',
  },
  {
    id: '1612040003',
    districtId: '1612040',
    name: 'Babat',
  },
  {
    id: '1612040004',
    districtId: '1612040',
    name: 'Sungai Langan',
  },
  {
    id: '1612040005',
    districtId: '1612040',
    name: 'Sepantan Jaya',
  },
  {
    id: '1612040006',
    districtId: '1612040',
    name: 'Gunung Raja',
  },
  {
    id: '1612040007',
    districtId: '1612040',
    name: 'Suka Raja',
  },
  {
    id: '1612040008',
    districtId: '1612040',
    name: 'Gunung Menang',
  },
  {
    id: '1612040009',
    districtId: '1612040',
    name: 'Mangkunegara',
  },
  {
    id: '1612040010',
    districtId: '1612040',
    name: 'Raja Jaya',
  },
  {
    id: '1612040011',
    districtId: '1612040',
    name: 'Mangkunegara Timur',
  },
  {
    id: '1612040012',
    districtId: '1612040',
    name: 'Air Itam',
  },
  {
    id: '1612040013',
    districtId: '1612040',
    name: 'Air Itam Timur',
  },
  {
    id: '1612040014',
    districtId: '1612040',
    name: 'Simpang Tiga Babat',
  },
  {
    id: '1612040015',
    districtId: '1612040',
    name: 'Simpang Babat',
  },
  {
    id: '1612050001',
    districtId: '1612050',
    name: 'Tambak',
  },
  {
    id: '1612050002',
    districtId: '1612050',
    name: 'Suka Rami',
  },
  {
    id: '1612050003',
    districtId: '1612050',
    name: 'Tanjung Baru',
  },
  {
    id: '1612050004',
    districtId: '1612050',
    name: 'Muara Ikan',
  },
  {
    id: '1612050005',
    districtId: '1612050',
    name: 'Kota Baru',
  },
  {
    id: '1612050006',
    districtId: '1612050',
    name: 'Tanding Marga',
  },
  {
    id: '1612050007',
    districtId: '1612050',
    name: 'Karang Tanding',
  },
  {
    id: '1612050008',
    districtId: '1612050',
    name: 'Lubuk Tampui',
  },
  {
    id: '1612050009',
    districtId: '1612050',
    name: 'Prabumenang',
  },
  {
    id: '1612050010',
    districtId: '1612050',
    name: 'Tempirai Selatan',
  },
  {
    id: '1612050011',
    districtId: '1612050',
    name: 'Tempirai Utara',
  },
  {
    id: '1612050012',
    districtId: '1612050',
    name: 'Tempirai Timur',
  },
  {
    id: '1612050013',
    districtId: '1612050',
    name: 'Tempirai',
  },
  {
    id: '1612050014',
    districtId: '1612050',
    name: 'Madu Kincing',
  },
  {
    id: '1612050015',
    districtId: '1612050',
    name: 'Tanding Jaya',
  },
  {
    id: '1613010001',
    districtId: '1613010',
    name: 'Kuto Tanjung',
  },
  {
    id: '1613010002',
    districtId: '1613010',
    name: 'Napal Licin',
  },
  {
    id: '1613010003',
    districtId: '1613010',
    name: 'Sosokan',
  },
  {
    id: '1613010004',
    districtId: '1613010',
    name: 'Muara Kulam',
  },
  {
    id: '1613010005',
    districtId: '1613010',
    name: 'Muara Kuis',
  },
  {
    id: '1613010006',
    districtId: '1613010',
    name: 'Pulau Kidak',
  },
  {
    id: '1613010007',
    districtId: '1613010',
    name: 'Jangkat',
  },
  {
    id: '1613020001',
    districtId: '1613020',
    name: 'Lubuk Kumbung',
  },
  {
    id: '1613020002',
    districtId: '1613020',
    name: 'Bukit Ulu',
  },
  {
    id: '1613020003',
    districtId: '1613020',
    name: 'Bukit Langkap',
  },
  {
    id: '1613020004',
    districtId: '1613020',
    name: 'Rantau Jaya',
  },
  {
    id: '1613020005',
    districtId: '1613020',
    name: 'Sukaraja',
  },
  {
    id: '1613020006',
    districtId: '1613020',
    name: 'Muara Batang Empu',
  },
  {
    id: '1613020007',
    districtId: '1613020',
    name: 'Rantau Telang',
  },
  {
    id: '1613020008',
    districtId: '1613020',
    name: 'Tanjung Agung',
  },
  {
    id: '1613020009',
    districtId: '1613020',
    name: 'Sukamenang',
  },
  {
    id: '1613020010',
    districtId: '1613020',
    name: 'Terusan',
  },
  {
    id: '1613020011',
    districtId: '1613020',
    name: 'Karang Jaya',
  },
  {
    id: '1613020012',
    districtId: '1613020',
    name: 'Embacang Baru',
  },
  {
    id: '1613020013',
    districtId: '1613020',
    name: 'Embacang Baru Ilir',
  },
  {
    id: '1613020014',
    districtId: '1613020',
    name: 'Embacang Lama',
  },
  {
    id: '1613020015',
    districtId: '1613020',
    name: 'Muara Tiku',
  },
  {
    id: '1613030001',
    districtId: '1613030',
    name: 'Lubuk Mas',
  },
  {
    id: '1613030002',
    districtId: '1613030',
    name: 'Pangkalan',
  },
  {
    id: '1613030003',
    districtId: '1613030',
    name: 'Teladas',
  },
  {
    id: '1613030004',
    districtId: '1613030',
    name: 'Kerta Dewa',
  },
  {
    id: '1613030005',
    districtId: '1613030',
    name: 'Pulau Lebar',
  },
  {
    id: '1613030006',
    districtId: '1613030',
    name: 'Sungai Baung',
  },
  {
    id: '1613030007',
    districtId: '1613030',
    name: 'Surulangun',
  },
  {
    id: '1613030008',
    districtId: '1613030',
    name: 'Sukomoro',
  },
  {
    id: '1613030009',
    districtId: '1613030',
    name: 'Pasar Surulangun',
  },
  {
    id: '1613030010',
    districtId: '1613030',
    name: 'Lesung Batu Muda',
  },
  {
    id: '1613030011',
    districtId: '1613030',
    name: 'Lesung Batu',
  },
  {
    id: '1613030012',
    districtId: '1613030',
    name: 'Lubuk Kemang',
  },
  {
    id: '1613030013',
    districtId: '1613030',
    name: 'Remban',
  },
  {
    id: '1613030014',
    districtId: '1613030',
    name: 'Sungai Kijang',
  },
  {
    id: '1613030015',
    districtId: '1613030',
    name: 'Sungai Jauh',
  },
  {
    id: '1613030016',
    districtId: '1613030',
    name: 'Simpang Nibung Rawas',
  },
  {
    id: '1613030017',
    districtId: '1613030',
    name: 'Sungai Lanang',
  },
  {
    id: '1613040001',
    districtId: '1613040',
    name: 'Batu Gajah',
  },
  {
    id: '1613040002',
    districtId: '1613040',
    name: 'Tanjung Beringin',
  },
  {
    id: '1613040003',
    districtId: '1613040',
    name: 'Noman',
  },
  {
    id: '1613040004',
    districtId: '1613040',
    name: 'Noman Baru',
  },
  {
    id: '1613040005',
    districtId: '1613040',
    name: 'Batu Gajah Baru',
  },
  {
    id: '1613040006',
    districtId: '1613040',
    name: 'Maur Baru',
  },
  {
    id: '1613040007',
    districtId: '1613040',
    name: 'Maur Lama',
  },
  {
    id: '1613040008',
    districtId: '1613040',
    name: 'Bingin Rupit',
  },
  {
    id: '1613040009',
    districtId: '1613040',
    name: 'Beringin Jaya',
  },
  {
    id: '1613040010',
    districtId: '1613040',
    name: 'Muara Rupit',
  },
  {
    id: '1613040011',
    districtId: '1613040',
    name: 'Karang Anyar',
  },
  {
    id: '1613040012',
    districtId: '1613040',
    name: 'Karang Waru',
  },
  {
    id: '1613040013',
    districtId: '1613040',
    name: 'Lawang Agung',
  },
  {
    id: '1613040014',
    districtId: '1613040',
    name: 'Lubuk Rumbai',
  },
  {
    id: '1613040015',
    districtId: '1613040',
    name: 'Lubuk Rumbai Baru',
  },
  {
    id: '1613040016',
    districtId: '1613040',
    name: 'Sungai Jernih',
  },
  {
    id: '1613040017',
    districtId: '1613040',
    name: 'Pantai',
  },
  {
    id: '1613050001',
    districtId: '1613050',
    name: 'Kertasari',
  },
  {
    id: '1613050002',
    districtId: '1613050',
    name: 'Rantau Kadam',
  },
  {
    id: '1613050003',
    districtId: '1613050',
    name: 'Karang Dapo I',
  },
  {
    id: '1613050004',
    districtId: '1613050',
    name: 'Karang Dapo',
  },
  {
    id: '1613050005',
    districtId: '1613050',
    name: 'Setia Marga',
  },
  {
    id: '1613050006',
    districtId: '1613050',
    name: 'Biaro Baru',
  },
  {
    id: '1613050007',
    districtId: '1613050',
    name: 'Biaro Lama',
  },
  {
    id: '1613050008',
    districtId: '1613050',
    name: 'Aringin',
  },
  {
    id: '1613050009',
    districtId: '1613050',
    name: 'Bina Karya',
  },
  {
    id: '1613060001',
    districtId: '1613060',
    name: 'Mandi Angin',
  },
  {
    id: '1613060002',
    districtId: '1613060',
    name: 'Beringin Makmur I',
  },
  {
    id: '1613060003',
    districtId: '1613060',
    name: 'Batu Kucing',
  },
  {
    id: '1613060004',
    districtId: '1613060',
    name: 'Pauh',
  },
  {
    id: '1613060005',
    districtId: '1613060',
    name: 'Mekarsari',
  },
  {
    id: '1613060006',
    districtId: '1613060',
    name: 'Ketapat Bening',
  },
  {
    id: '1613060007',
    districtId: '1613060',
    name: 'Air Bening',
  },
  {
    id: '1613060008',
    districtId: '1613060',
    name: 'Pauh I',
  },
  {
    id: '1613060009',
    districtId: '1613060',
    name: 'Belani',
  },
  {
    id: '1613060010',
    districtId: '1613060',
    name: 'Tanjung Raja',
  },
  {
    id: '1613060011',
    districtId: '1613060',
    name: 'Beringin Makmur II',
  },
  {
    id: '1613060012',
    districtId: '1613060',
    name: 'Bingin Teluk',
  },
  {
    id: '1613060013',
    districtId: '1613060',
    name: 'Beringin Sakti',
  },
  {
    id: '1613070001',
    districtId: '1613070',
    name: 'Jadi Mulya I',
  },
  {
    id: '1613070002',
    districtId: '1613070',
    name: 'Kerani Jaya',
  },
  {
    id: '1613070003',
    districtId: '1613070',
    name: 'Jadi Mulya',
  },
  {
    id: '1613070004',
    districtId: '1613070',
    name: 'Sumber Makmur',
  },
  {
    id: '1613070005',
    districtId: '1613070',
    name: 'Mulya Jaya',
  },
  {
    id: '1613070006',
    districtId: '1613070',
    name: 'Kelumpang Jaya',
  },
  {
    id: '1613070007',
    districtId: '1613070',
    name: 'Srijaya Makmur',
  },
  {
    id: '1613070008',
    districtId: '1613070',
    name: 'Karya Makmur',
  },
  {
    id: '1613070009',
    districtId: '1613070',
    name: 'Bumi Makmur',
  },
  {
    id: '1613070010',
    districtId: '1613070',
    name: 'Sumber Sari',
  },
  {
    id: '1613070011',
    districtId: '1613070',
    name: 'Tebing Tinggi',
  },
  {
    id: '1671010006',
    districtId: '1671010',
    name: '35 Ilir',
  },
  {
    id: '1671010007',
    districtId: '1671010',
    name: '32 Ilir',
  },
  {
    id: '1671010008',
    districtId: '1671010',
    name: '30 Ilir',
  },
  {
    id: '1671010009',
    districtId: '1671010',
    name: 'Kemang Manis',
  },
  {
    id: '1671010010',
    districtId: '1671010',
    name: '29 Ilir',
  },
  {
    id: '1671010011',
    districtId: '1671010',
    name: '28 Ilir',
  },
  {
    id: '1671010012',
    districtId: '1671010',
    name: '27 Ilir',
  },
  {
    id: '1671011001',
    districtId: '1671011',
    name: 'Pulo Kerto',
  },
  {
    id: '1671011002',
    districtId: '1671011',
    name: 'Gandus',
  },
  {
    id: '1671011003',
    districtId: '1671011',
    name: 'Karang Jaya',
  },
  {
    id: '1671011004',
    districtId: '1671011',
    name: 'Karang Anyar',
  },
  {
    id: '1671011005',
    districtId: '1671011',
    name: '36 Ilir',
  },
  {
    id: '1671020008',
    districtId: '1671020',
    name: '1 Ulu',
  },
  {
    id: '1671020010',
    districtId: '1671020',
    name: '2 Ulu',
  },
  {
    id: '1671020011',
    districtId: '1671020',
    name: '3-4 Ulu',
  },
  {
    id: '1671020012',
    districtId: '1671020',
    name: '5 Ulu',
  },
  {
    id: '1671020013',
    districtId: '1671020',
    name: '7 Ulu',
  },
  {
    id: '1671021001',
    districtId: '1671021',
    name: 'Karya Jaya',
  },
  {
    id: '1671021002',
    districtId: '1671021',
    name: 'Keramasan',
  },
  {
    id: '1671021003',
    districtId: '1671021',
    name: 'Kemang Agung',
  },
  {
    id: '1671021004',
    districtId: '1671021',
    name: 'Kemas Rindo',
  },
  {
    id: '1671021005',
    districtId: '1671021',
    name: 'Ogan Baru',
  },
  {
    id: '1671021006',
    districtId: '1671021',
    name: 'Kertapati',
  },
  {
    id: '1671022001',
    districtId: '1671022',
    name: '15 Ulu',
  },
  {
    id: '1671022002',
    districtId: '1671022',
    name: 'Tuan Kentang',
  },
  {
    id: '1671022003',
    districtId: '1671022',
    name: '8 Ulu',
  },
  {
    id: '1671022004',
    districtId: '1671022',
    name: 'Silaberanti',
  },
  {
    id: '1671022005',
    districtId: '1671022',
    name: '9/10 Ulu',
  },
  {
    id: '1671030007',
    districtId: '1671030',
    name: 'Sentosa',
  },
  {
    id: '1671030008',
    districtId: '1671030',
    name: '16 Ulu',
  },
  {
    id: '1671030010',
    districtId: '1671030',
    name: 'Tangga Takat',
  },
  {
    id: '1671030011',
    districtId: '1671030',
    name: '14 Ulu',
  },
  {
    id: '1671030012',
    districtId: '1671030',
    name: '13 Ulu',
  },
  {
    id: '1671030013',
    districtId: '1671030',
    name: '12 Ulu',
  },
  {
    id: '1671030014',
    districtId: '1671030',
    name: '11 Ulu',
  },
  {
    id: '1671031001',
    districtId: '1671031',
    name: 'Plaju Darat',
  },
  {
    id: '1671031002',
    districtId: '1671031',
    name: 'Talang Putri',
  },
  {
    id: '1671031003',
    districtId: '1671031',
    name: 'Komperta',
  },
  {
    id: '1671031004',
    districtId: '1671031',
    name: 'Plaju Ilir',
  },
  {
    id: '1671031005',
    districtId: '1671031',
    name: 'Talang Bubuk',
  },
  {
    id: '1671031006',
    districtId: '1671031',
    name: 'Plaju Ulu',
  },
  {
    id: '1671031007',
    districtId: '1671031',
    name: 'Bagus Kuning',
  },
  {
    id: '1671040001',
    districtId: '1671040',
    name: 'Bukit Lama',
  },
  {
    id: '1671040002',
    districtId: '1671040',
    name: '26 Ilir I',
  },
  {
    id: '1671040009',
    districtId: '1671040',
    name: 'Lorok Pakjo',
  },
  {
    id: '1671040010',
    districtId: '1671040',
    name: 'Demang Lebar Daun',
  },
  {
    id: '1671040011',
    districtId: '1671040',
    name: 'Bukit Baru',
  },
  {
    id: '1671040012',
    districtId: '1671040',
    name: 'Siring Agung',
  },
  {
    id: '1671041001',
    districtId: '1671041',
    name: 'Talang Semut',
  },
  {
    id: '1671041002',
    districtId: '1671041',
    name: '22 Ilir',
  },
  {
    id: '1671041003',
    districtId: '1671041',
    name: '19 Ilir',
  },
  {
    id: '1671041004',
    districtId: '1671041',
    name: '23 Ilir',
  },
  {
    id: '1671041005',
    districtId: '1671041',
    name: '26 Ilir',
  },
  {
    id: '1671041006',
    districtId: '1671041',
    name: '24 Ilir',
  },
  {
    id: '1671050001',
    districtId: '1671050',
    name: '18 Ilir',
  },
  {
    id: '1671050002',
    districtId: '1671050',
    name: '16 Ilir',
  },
  {
    id: '1671050003',
    districtId: '1671050',
    name: '13 Ilir',
  },
  {
    id: '1671050004',
    districtId: '1671050',
    name: '14 Ilir',
  },
  {
    id: '1671050005',
    districtId: '1671050',
    name: '15 Ilir',
  },
  {
    id: '1671050006',
    districtId: '1671050',
    name: '17 Ilir',
  },
  {
    id: '1671050007',
    districtId: '1671050',
    name: 'Kepandean Baru',
  },
  {
    id: '1671050008',
    districtId: '1671050',
    name: '20 Ilir I',
  },
  {
    id: '1671050009',
    districtId: '1671050',
    name: 'Sei Pangeran',
  },
  {
    id: '1671050011',
    districtId: '1671050',
    name: '20 Ilir III',
  },
  {
    id: '1671050017',
    districtId: '1671050',
    name: '20 Ilir IV',
  },
  {
    id: '1671051001',
    districtId: '1671051',
    name: 'Sekip Jaya',
  },
  {
    id: '1671051002',
    districtId: '1671051',
    name: 'Pahlawan',
  },
  {
    id: '1671051003',
    districtId: '1671051',
    name: '20 Ilir II',
  },
  {
    id: '1671051004',
    districtId: '1671051',
    name: 'Pipa Reja',
  },
  {
    id: '1671051005',
    districtId: '1671051',
    name: 'Talang Aman',
  },
  {
    id: '1671051006',
    districtId: '1671051',
    name: 'Ario Kemuning',
  },
  {
    id: '1671060004',
    districtId: '1671060',
    name: 'Lawang Kidul',
  },
  {
    id: '1671060005',
    districtId: '1671060',
    name: '3 Ilir',
  },
  {
    id: '1671060006',
    districtId: '1671060',
    name: '1 Ilir',
  },
  {
    id: '1671060007',
    districtId: '1671060',
    name: 'Sungai Buah',
  },
  {
    id: '1671060008',
    districtId: '1671060',
    name: '2 Ilir',
  },
  {
    id: '1671060009',
    districtId: '1671060',
    name: '5 Ilir',
  },
  {
    id: '1671061001',
    districtId: '1671061',
    name: 'Sei Lais',
  },
  {
    id: '1671061002',
    districtId: '1671061',
    name: 'Sei Selincah',
  },
  {
    id: '1671061003',
    districtId: '1671061',
    name: 'Sei Selayur',
  },
  {
    id: '1671061004',
    districtId: '1671061',
    name: 'Kalidoni',
  },
  {
    id: '1671061005',
    districtId: '1671061',
    name: 'Bukit Sangkal',
  },
  {
    id: '1671062001',
    districtId: '1671062',
    name: '10 Ilir',
  },
  {
    id: '1671062002',
    districtId: '1671062',
    name: '11 Ilir',
  },
  {
    id: '1671062003',
    districtId: '1671062',
    name: 'Kuto Batu',
  },
  {
    id: '1671062004',
    districtId: '1671062',
    name: 'Duku',
  },
  {
    id: '1671062005',
    districtId: '1671062',
    name: '9 Ilir',
  },
  {
    id: '1671062006',
    districtId: '1671062',
    name: '8 Ilir',
  },
  {
    id: '1671070001',
    districtId: '1671070',
    name: 'Sukamaju',
  },
  {
    id: '1671070002',
    districtId: '1671070',
    name: 'Sialang',
  },
  {
    id: '1671070003',
    districtId: '1671070',
    name: 'Sako',
  },
  {
    id: '1671070007',
    districtId: '1671070',
    name: 'Sako Baru',
  },
  {
    id: '1671071001',
    districtId: '1671071',
    name: 'Lebong Gajah',
  },
  {
    id: '1671071002',
    districtId: '1671071',
    name: 'Srimulyo',
  },
  {
    id: '1671071003',
    districtId: '1671071',
    name: 'Suka Mulya',
  },
  {
    id: '1671071004',
    districtId: '1671071',
    name: 'Karya Mulya',
  },
  {
    id: '1671080002',
    districtId: '1671080',
    name: 'Suka Bangun',
  },
  {
    id: '1671080003',
    districtId: '1671080',
    name: 'Sukajaya',
  },
  {
    id: '1671080004',
    districtId: '1671080',
    name: 'Sukarami',
  },
  {
    id: '1671080008',
    districtId: '1671080',
    name: 'Kebun Bunga',
  },
  {
    id: '1671080009',
    districtId: '1671080',
    name: 'Talang Betutu',
  },
  {
    id: '1671080010',
    districtId: '1671080',
    name: 'Sukodadi',
  },
  {
    id: '1671080011',
    districtId: '1671080',
    name: 'Talang Jambe',
  },
  {
    id: '1671081001',
    districtId: '1671081',
    name: 'Srijaya',
  },
  {
    id: '1671081002',
    districtId: '1671081',
    name: 'Karya Baru',
  },
  {
    id: '1671081003',
    districtId: '1671081',
    name: 'Talang Kelapa',
  },
  {
    id: '1671081004',
    districtId: '1671081',
    name: 'Alang Alang Lebar',
  },
  {
    id: '1672010001',
    districtId: '1672010',
    name: 'Rambang Senuling',
  },
  {
    id: '1672010002',
    districtId: '1672010',
    name: 'Tanjung Rambang',
  },
  {
    id: '1672010003',
    districtId: '1672010',
    name: 'Karang Bindu',
  },
  {
    id: '1672010005',
    districtId: '1672010',
    name: 'Karya Mulya',
  },
  {
    id: '1672010006',
    districtId: '1672010',
    name: 'Sinar Rambang',
  },
  {
    id: '1672010007',
    districtId: '1672010',
    name: 'Jungai',
  },
  {
    id: '1672010008',
    districtId: '1672010',
    name: 'Talang Batu',
  },
  {
    id: '1672010009',
    districtId: '1672010',
    name: 'Karangan',
  },
  {
    id: '1672010010',
    districtId: '1672010',
    name: 'Kemang Tanduk',
  },
  {
    id: '1672020003',
    districtId: '1672020',
    name: 'Karang Raja',
  },
  {
    id: '1672020004',
    districtId: '1672020',
    name: 'Muara Dua',
  },
  {
    id: '1672020005',
    districtId: '1672020',
    name: 'Gunung Ibul Barat',
  },
  {
    id: '1672020006',
    districtId: '1672020',
    name: 'Gunung Ibul',
  },
  {
    id: '1672020007',
    districtId: '1672020',
    name: 'Karang Jaya',
  },
  {
    id: '1672020008',
    districtId: '1672020',
    name: 'Tugu Kecil',
  },
  {
    id: '1672020009',
    districtId: '1672020',
    name: 'Prabu Jaya',
  },
  {
    id: '1672020010',
    districtId: '1672020',
    name: 'Sukajadi',
  },
  {
    id: '1672021001',
    districtId: '1672021',
    name: 'Tanjung Menang',
  },
  {
    id: '1672021002',
    districtId: '1672021',
    name: 'Tanjung Raman',
  },
  {
    id: '1672021003',
    districtId: '1672021',
    name: 'Suka Raja',
  },
  {
    id: '1672021004',
    districtId: '1672021',
    name: 'Majasari',
  },
  {
    id: '1672030001',
    districtId: '1672030',
    name: 'Gunung Kemala',
  },
  {
    id: '1672030002',
    districtId: '1672030',
    name: 'Patih Galung',
  },
  {
    id: '1672030003',
    districtId: '1672030',
    name: 'Prabumulih',
  },
  {
    id: '1672030008',
    districtId: '1672030',
    name: 'Muntang Tapus',
  },
  {
    id: '1672030011',
    districtId: '1672030',
    name: 'Payu Putat',
  },
  {
    id: '1672030012',
    districtId: '1672030',
    name: 'Tanjung Telang',
  },
  {
    id: '1672031001',
    districtId: '1672031',
    name: 'Wonosari',
  },
  {
    id: '1672031002',
    districtId: '1672031',
    name: 'Pasar Prabumulih',
  },
  {
    id: '1672031003',
    districtId: '1672031',
    name: 'Mangga Besar',
  },
  {
    id: '1672031004',
    districtId: '1672031',
    name: 'Anak Petai',
  },
  {
    id: '1672031005',
    districtId: '1672031',
    name: 'Pasar II Prabumulih',
  },
  {
    id: '1672040003',
    districtId: '1672040',
    name: 'Sungai Medang',
  },
  {
    id: '1672040004',
    districtId: '1672040',
    name: 'Muara Sungai',
  },
  {
    id: '1672040005',
    districtId: '1672040',
    name: 'Cambai',
  },
  {
    id: '1672040006',
    districtId: '1672040',
    name: 'Sindur',
  },
  {
    id: '1672040007',
    districtId: '1672040',
    name: 'Pangkul',
  },
  {
    id: '1673010001',
    districtId: '1673010',
    name: 'Penjalang',
  },
  {
    id: '1673010002',
    districtId: '1673010',
    name: 'Lubuk Buntak',
  },
  {
    id: '1673010003',
    districtId: '1673010',
    name: 'Perahu Dipo',
  },
  {
    id: '1673010004',
    districtId: '1673010',
    name: 'Kance Diwe',
  },
  {
    id: '1673010005',
    districtId: '1673010',
    name: 'Atung Bungsu',
  },
  {
    id: '1673011001',
    districtId: '1673011',
    name: 'Candi Jaya',
  },
  {
    id: '1673011002',
    districtId: '1673011',
    name: 'Jokoh',
  },
  {
    id: '1673011003',
    districtId: '1673011',
    name: 'Pelang Kenidai',
  },
  {
    id: '1673011004',
    districtId: '1673011',
    name: 'Padang Temu',
  },
  {
    id: '1673011005',
    districtId: '1673011',
    name: 'Karang Dalo',
  },
  {
    id: '1673020001',
    districtId: '1673020',
    name: 'Burung Dinang',
  },
  {
    id: '1673020002',
    districtId: '1673020',
    name: 'Muara Siban',
  },
  {
    id: '1673020003',
    districtId: '1673020',
    name: 'Reba Tinggi',
  },
  {
    id: '1673020004',
    districtId: '1673020',
    name: 'Jangkar Mas',
  },
  {
    id: '1673020005',
    districtId: '1673020',
    name: 'Pagar Wangi',
  },
  {
    id: '1673020006',
    districtId: '1673020',
    name: 'Bumi Agung',
  },
  {
    id: '1673020007',
    districtId: '1673020',
    name: 'Agung Lawangan',
  },
  {
    id: '1673030001',
    districtId: '1673030',
    name: 'Tanjung Agung',
  },
  {
    id: '1673030002',
    districtId: '1673030',
    name: 'Ulu Rurah',
  },
  {
    id: '1673030003',
    districtId: '1673030',
    name: 'Tumbak Ulas',
  },
  {
    id: '1673030004',
    districtId: '1673030',
    name: 'Basemah Serasan',
  },
  {
    id: '1673030005',
    districtId: '1673030',
    name: 'Tebat Giri Indah',
  },
  {
    id: '1673030006',
    districtId: '1673030',
    name: 'Sidorejo',
  },
  {
    id: '1673030007',
    districtId: '1673030',
    name: 'Nendagung',
  },
  {
    id: '1673030008',
    districtId: '1673030',
    name: 'Gunung Dempo',
  },
  {
    id: '1673040001',
    districtId: '1673040',
    name: 'Dempo Makmur',
  },
  {
    id: '1673040002',
    districtId: '1673040',
    name: 'Bangun Rejo',
  },
  {
    id: '1673040003',
    districtId: '1673040',
    name: 'Curup Jare',
  },
  {
    id: '1673040004',
    districtId: '1673040',
    name: 'Pagar Alam',
  },
  {
    id: '1673040005',
    districtId: '1673040',
    name: 'Sukorejo',
  },
  {
    id: '1673040006',
    districtId: '1673040',
    name: 'Bangun Jaya',
  },
  {
    id: '1673040007',
    districtId: '1673040',
    name: 'Beringin Jaya',
  },
  {
    id: '1673040008',
    districtId: '1673040',
    name: 'Alun Dua',
  },
  {
    id: '1673040009',
    districtId: '1673040',
    name: 'Kuripan Babas',
  },
  {
    id: '1673040010',
    districtId: '1673040',
    name: 'Selibar',
  },
  {
    id: '1674011001',
    districtId: '1674011',
    name: 'Kayu Ara',
  },
  {
    id: '1674011002',
    districtId: '1674011',
    name: 'Watas Lubuk Durian',
  },
  {
    id: '1674011003',
    districtId: '1674011',
    name: 'Lubuk Tanjung',
  },
  {
    id: '1674011004',
    districtId: '1674011',
    name: 'Tanjung Indah',
  },
  {
    id: '1674011005',
    districtId: '1674011',
    name: 'Tanjung Aman',
  },
  {
    id: '1674011006',
    districtId: '1674011',
    name: 'Lubuk Aman',
  },
  {
    id: '1674011007',
    districtId: '1674011',
    name: 'Pelita Jaya',
  },
  {
    id: '1674011008',
    districtId: '1674011',
    name: 'Bandung Ujung',
  },
  {
    id: '1674011009',
    districtId: '1674011',
    name: 'Bandung Kiri',
  },
  {
    id: '1674011010',
    districtId: '1674011',
    name: 'Sukajadi',
  },
  {
    id: '1674011011',
    districtId: '1674011',
    name: 'Muara Enim',
  },
  {
    id: '1674012001',
    districtId: '1674012',
    name: 'Sidorejo',
  },
  {
    id: '1674012002',
    districtId: '1674012',
    name: 'Tapak Lebar',
  },
  {
    id: '1674012003',
    districtId: '1674012',
    name: 'Ulak Lebar',
  },
  {
    id: '1674012004',
    districtId: '1674012',
    name: 'Bandung Kanan',
  },
  {
    id: '1674012005',
    districtId: '1674012',
    name: 'Keputeraan',
  },
  {
    id: '1674012006',
    districtId: '1674012',
    name: 'Lubuk Linggau Ulu',
  },
  {
    id: '1674012007',
    districtId: '1674012',
    name: 'Lubuk Linggau Ilir',
  },
  {
    id: '1674012008',
    districtId: '1674012',
    name: 'Pasar Permiri',
  },
  {
    id: '1674021001',
    districtId: '1674021',
    name: 'Rahma',
  },
  {
    id: '1674021002',
    districtId: '1674021',
    name: 'Perumnas Rahma',
  },
  {
    id: '1674021003',
    districtId: '1674021',
    name: 'Jukung',
  },
  {
    id: '1674021004',
    districtId: '1674021',
    name: 'Air Kati',
  },
  {
    id: '1674021005',
    districtId: '1674021',
    name: 'Lubuk Binjai',
  },
  {
    id: '1674021006',
    districtId: '1674021',
    name: 'Lubuk Kupang',
  },
  {
    id: '1674021007',
    districtId: '1674021',
    name: 'Air Temam',
  },
  {
    id: '1674022001',
    districtId: '1674022',
    name: 'Taba Pingin',
  },
  {
    id: '1674022002',
    districtId: '1674022',
    name: 'Moneng Sepati',
  },
  {
    id: '1674022003',
    districtId: '1674022',
    name: 'Marga Mulya',
  },
  {
    id: '1674022004',
    districtId: '1674022',
    name: 'Marga Rahayu',
  },
  {
    id: '1674022005',
    districtId: '1674022',
    name: 'Tanah Periuk',
  },
  {
    id: '1674022006',
    districtId: '1674022',
    name: 'Simpang Periuk',
  },
  {
    id: '1674022007',
    districtId: '1674022',
    name: 'Karang Ketuan',
  },
  {
    id: '1674022008',
    districtId: '1674022',
    name: 'Eka Marga',
  },
  {
    id: '1674022009',
    districtId: '1674022',
    name: 'Siring Agung',
  },
  {
    id: '1674031001',
    districtId: '1674031',
    name: 'Taba Jemekeh',
  },
  {
    id: '1674031002',
    districtId: '1674031',
    name: 'Taba Koji',
  },
  {
    id: '1674031003',
    districtId: '1674031',
    name: 'Batu Urip Taba',
  },
  {
    id: '1674031004',
    districtId: '1674031',
    name: 'Watervang',
  },
  {
    id: '1674031005',
    districtId: '1674031',
    name: 'Majapahit',
  },
  {
    id: '1674031006',
    districtId: '1674031',
    name: 'Air Kuti',
  },
  {
    id: '1674031007',
    districtId: '1674031',
    name: 'Nikan Jaya',
  },
  {
    id: '1674031008',
    districtId: '1674031',
    name: 'Taba Lestari',
  },
  {
    id: '1674032001',
    districtId: '1674032',
    name: 'Mesat Jaya',
  },
  {
    id: '1674032002',
    districtId: '1674032',
    name: 'Mesat Seni',
  },
  {
    id: '1674032003',
    districtId: '1674032',
    name: 'Jawa Kanan',
  },
  {
    id: '1674032004',
    districtId: '1674032',
    name: 'Jawa Kanan Ss',
  },
  {
    id: '1674032005',
    districtId: '1674032',
    name: 'Jawa Kiri',
  },
  {
    id: '1674032006',
    districtId: '1674032',
    name: 'Wira Karya',
  },
  {
    id: '1674032007',
    districtId: '1674032',
    name: 'Dempo',
  },
  {
    id: '1674032008',
    districtId: '1674032',
    name: 'Karya Bhakti',
  },
  {
    id: '1674032009',
    districtId: '1674032',
    name: 'Cereme Taba',
  },
  {
    id: '1674041001',
    districtId: '1674041',
    name: 'Sumber Agung',
  },
  {
    id: '1674041002',
    districtId: '1674041',
    name: 'Petanang Ulu',
  },
  {
    id: '1674041003',
    districtId: '1674041',
    name: 'Petanang Ilir',
  },
  {
    id: '1674041004',
    districtId: '1674041',
    name: 'Belalau I',
  },
  {
    id: '1674041005',
    districtId: '1674041',
    name: 'Belalau II',
  },
  {
    id: '1674041006',
    districtId: '1674041',
    name: 'Taba Baru',
  },
  {
    id: '1674041007',
    districtId: '1674041',
    name: 'Margo Rejo',
  },
  {
    id: '1674041008',
    districtId: '1674041',
    name: 'Marga Bakti',
  },
  {
    id: '1674041009',
    districtId: '1674041',
    name: 'Durian Rampak',
  },
  {
    id: '1674041010',
    districtId: '1674041',
    name: 'Tanjung Raya',
  },
  {
    id: '1674042001',
    districtId: '1674042',
    name: 'Ulak Surung',
  },
  {
    id: '1674042002',
    districtId: '1674042',
    name: 'Pasar Satelit',
  },
  {
    id: '1674042003',
    districtId: '1674042',
    name: 'Kenanga',
  },
  {
    id: '1674042004',
    districtId: '1674042',
    name: 'Senalang',
  },
  {
    id: '1674042005',
    districtId: '1674042',
    name: 'Batu Urip',
  },
  {
    id: '1674042006',
    districtId: '1674042',
    name: 'Megang',
  },
  {
    id: '1674042007',
    districtId: '1674042',
    name: 'Ponorogo',
  },
  {
    id: '1674042008',
    districtId: '1674042',
    name: 'Jogoboyo',
  },
  {
    id: '1674042009',
    districtId: '1674042',
    name: 'Puncak Kemuning',
  },
  {
    id: '1674042010',
    districtId: '1674042',
    name: 'Kali Serayu',
  },
  {
    id: '1701040002',
    districtId: '1701040',
    name: 'Ketaping',
  },
  {
    id: '1701040003',
    districtId: '1701040',
    name: 'Terulung',
  },
  {
    id: '1701040004',
    districtId: '1701040',
    name: 'Manggul',
  },
  {
    id: '1701040005',
    districtId: '1701040',
    name: 'Tanjung Besar',
  },
  {
    id: '1701040030',
    districtId: '1701040',
    name: 'Lubuk Sirih Ulu',
  },
  {
    id: '1701040031',
    districtId: '1701040',
    name: 'Lubuk Sirih Ilir',
  },
  {
    id: '1701040032',
    districtId: '1701040',
    name: 'Tanjung Raman',
  },
  {
    id: '1701040033',
    districtId: '1701040',
    name: 'Kayu Kunyit',
  },
  {
    id: '1701040050',
    districtId: '1701040',
    name: 'Kota Padang',
  },
  {
    id: '1701040051',
    districtId: '1701040',
    name: 'Melao',
  },
  {
    id: '1701040052',
    districtId: '1701040',
    name: 'Gunung Sakti',
  },
  {
    id: '1701040053',
    districtId: '1701040',
    name: 'Jeranglah Rendah',
  },
  {
    id: '1701040054',
    districtId: '1701040',
    name: 'Jeranglah Tinggi',
  },
  {
    id: '1701040055',
    districtId: '1701040',
    name: 'Kembang Ayun',
  },
  {
    id: '1701040056',
    districtId: '1701040',
    name: 'Tambangan',
  },
  {
    id: '1701040057',
    districtId: '1701040',
    name: 'Gunung Kembang',
  },
  {
    id: '1701040058',
    districtId: '1701040',
    name: 'Padang Manis',
  },
  {
    id: '1701040059',
    districtId: '1701040',
    name: 'Padang Pandan',
  },
  {
    id: '1701041006',
    districtId: '1701041',
    name: 'Kampung Baru',
  },
  {
    id: '1701041007',
    districtId: '1701041',
    name: 'Pagar Dewa',
  },
  {
    id: '1701041008',
    districtId: '1701041',
    name: 'Pasar Baru',
  },
  {
    id: '1701041013',
    districtId: '1701041',
    name: 'Kota Medan',
  },
  {
    id: '1701041014',
    districtId: '1701041',
    name: 'Gunung Ayu',
  },
  {
    id: '1701041015',
    districtId: '1701041',
    name: 'Padang Niur',
  },
  {
    id: '1701041016',
    districtId: '1701041',
    name: 'Tebat Kubu',
  },
  {
    id: '1701041017',
    districtId: '1701041',
    name: 'Gelumbang',
  },
  {
    id: '1701041018',
    districtId: '1701041',
    name: 'Padang Kapuk',
  },
  {
    id: '1701041019',
    districtId: '1701041',
    name: 'Ibul',
  },
  {
    id: '1701041020',
    districtId: '1701041',
    name: 'Padang Berangin',
  },
  {
    id: '1701042012',
    districtId: '1701042',
    name: 'Lawang Agung',
  },
  {
    id: '1701042013',
    districtId: '1701042',
    name: 'Durian Sebatang',
  },
  {
    id: '1701042014',
    districtId: '1701042',
    name: 'Pajar Bulan',
  },
  {
    id: '1701042015',
    districtId: '1701042',
    name: 'Tanjung Besar',
  },
  {
    id: '1701042016',
    districtId: '1701042',
    name: 'Muara Tiga',
  },
  {
    id: '1701042017',
    districtId: '1701042',
    name: 'Sukananti',
  },
  {
    id: '1701042018',
    districtId: '1701042',
    name: 'Tanjung Negara',
  },
  {
    id: '1701042019',
    districtId: '1701042',
    name: 'Tanjung Alam',
  },
  {
    id: '1701042020',
    districtId: '1701042',
    name: 'Keban Agung III',
  },
  {
    id: '1701042021',
    districtId: '1701042',
    name: 'Keban Agung II',
  },
  {
    id: '1701042022',
    districtId: '1701042',
    name: 'Keban Agung I',
  },
  {
    id: '1701042023',
    districtId: '1701042',
    name: 'Palak Siring',
  },
  {
    id: '1701042024',
    districtId: '1701042',
    name: 'Bumi Agung',
  },
  {
    id: '1701042025',
    districtId: '1701042',
    name: 'Rantau Sialang',
  },
  {
    id: '1701042026',
    districtId: '1701042',
    name: 'Batu Ampar',
  },
  {
    id: '1701042027',
    districtId: '1701042',
    name: 'Muara Tiga Ilir',
  },
  {
    id: '1701042028',
    districtId: '1701042',
    name: 'Nanti Agung',
  },
  {
    id: '1701042029',
    districtId: '1701042',
    name: 'Karang Agung',
  },
  {
    id: '1701042030',
    districtId: '1701042',
    name: 'Lubuk Resam',
  },
  {
    id: '1701043001',
    districtId: '1701043',
    name: 'Tumbuk Tebing',
  },
  {
    id: '1701043002',
    districtId: '1701043',
    name: 'Padang Burnai',
  },
  {
    id: '1701043003',
    districtId: '1701043',
    name: 'Gunung Kayo',
  },
  {
    id: '1701043004',
    districtId: '1701043',
    name: 'Gindosuli',
  },
  {
    id: '1701043005',
    districtId: '1701043',
    name: 'Talang Indah',
  },
  {
    id: '1701043006',
    districtId: '1701043',
    name: 'Tanjung Tebat',
  },
  {
    id: '1701043007',
    districtId: '1701043',
    name: 'Padang Jawi',
  },
  {
    id: '1701043008',
    districtId: '1701043',
    name: 'Tanjung Aur',
  },
  {
    id: '1701043009',
    districtId: '1701043',
    name: 'Padang Nibung',
  },
  {
    id: '1701043010',
    districtId: '1701043',
    name: 'Kuripan',
  },
  {
    id: '1701044001',
    districtId: '1701044',
    name: 'Pasar Bawah',
  },
  {
    id: '1701044002',
    districtId: '1701044',
    name: 'Gunung Mesir',
  },
  {
    id: '1701044003',
    districtId: '1701044',
    name: 'Ketapang Besar',
  },
  {
    id: '1701044004',
    districtId: '1701044',
    name: 'Padang Sialang',
  },
  {
    id: '1701044005',
    districtId: '1701044',
    name: 'Belakang Gedung',
  },
  {
    id: '1701044006',
    districtId: '1701044',
    name: 'Pasar Mulia',
  },
  {
    id: '1701044007',
    districtId: '1701044',
    name: 'Batu Lambang',
  },
  {
    id: '1701044008',
    districtId: '1701044',
    name: 'Batu Kuning',
  },
  {
    id: '1701044009',
    districtId: '1701044',
    name: 'Tanjung Mulia',
  },
  {
    id: '1701045001',
    districtId: '1701045',
    name: 'Lubuk Ladung',
  },
  {
    id: '1701045002',
    districtId: '1701045',
    name: 'Air Sulau',
  },
  {
    id: '1701045003',
    districtId: '1701045',
    name: 'Sukajaya',
  },
  {
    id: '1701045004',
    districtId: '1701045',
    name: 'Sukaraja',
  },
  {
    id: '1701045005',
    districtId: '1701045',
    name: 'Limus',
  },
  {
    id: '1701045006',
    districtId: '1701045',
    name: 'Penindaian',
  },
  {
    id: '1701045007',
    districtId: '1701045',
    name: 'Padang Bindu',
  },
  {
    id: '1701045008',
    districtId: '1701045',
    name: 'Nanjungan',
  },
  {
    id: '1701045009',
    districtId: '1701045',
    name: 'Pagar Banyu',
  },
  {
    id: '1701045010',
    districtId: '1701045',
    name: 'Sukarami',
  },
  {
    id: '1701045011',
    districtId: '1701045',
    name: 'Betungan',
  },
  {
    id: '1701045012',
    districtId: '1701045',
    name: 'Karang Caya',
  },
  {
    id: '1701050001',
    districtId: '1701050',
    name: 'Muara Pulutan',
  },
  {
    id: '1701050002',
    districtId: '1701050',
    name: 'Muara Payang',
  },
  {
    id: '1701050003',
    districtId: '1701050',
    name: 'Durian Seginim',
  },
  {
    id: '1701050004',
    districtId: '1701050',
    name: 'Banding Agung',
  },
  {
    id: '1701050005',
    districtId: '1701050',
    name: 'Pajar Bulan',
  },
  {
    id: '1701050006',
    districtId: '1701050',
    name: 'Padang Lebar',
  },
  {
    id: '1701050007',
    districtId: '1701050',
    name: 'Dusun Tengah',
  },
  {
    id: '1701050008',
    districtId: '1701050',
    name: 'Padang Siring',
  },
  {
    id: '1701050009',
    districtId: '1701050',
    name: 'Tanjung Menang',
  },
  {
    id: '1701050010',
    districtId: '1701050',
    name: 'Gunung Ayu',
  },
  {
    id: '1701050011',
    districtId: '1701050',
    name: 'Kota Bumi Baru',
  },
  {
    id: '1701050012',
    districtId: '1701050',
    name: 'Sindang Bulan',
  },
  {
    id: '1701050013',
    districtId: '1701050',
    name: 'Sukaraja',
  },
  {
    id: '1701050014',
    districtId: '1701050',
    name: 'Pasar Baru',
  },
  {
    id: '1701050015',
    districtId: '1701050',
    name: 'Darat Sawah',
  },
  {
    id: '1701050016',
    districtId: '1701050',
    name: 'Kota Agung',
  },
  {
    id: '1701050017',
    districtId: '1701050',
    name: 'Muara Danau',
  },
  {
    id: '1701050018',
    districtId: '1701050',
    name: 'Babatan Ilir',
  },
  {
    id: '1701050019',
    districtId: '1701050',
    name: 'Babatan Ulu',
  },
  {
    id: '1701050020',
    districtId: '1701050',
    name: 'Tanjung Agung',
  },
  {
    id: '1701050021',
    districtId: '1701050',
    name: 'Dusun Baru',
  },
  {
    id: '1701050022',
    districtId: '1701050',
    name: 'Darat Sawah Ulu',
  },
  {
    id: '1701051001',
    districtId: '1701051',
    name: 'Suka Bandung',
  },
  {
    id: '1701051002',
    districtId: '1701051',
    name: 'Penandingan',
  },
  {
    id: '1701051003',
    districtId: '1701051',
    name: 'Maras',
  },
  {
    id: '1701051004',
    districtId: '1701051',
    name: 'Keban Jati',
  },
  {
    id: '1701051005',
    districtId: '1701051',
    name: 'Tanjung Beringin',
  },
  {
    id: '1701051006',
    districtId: '1701051',
    name: 'Palak Bengkerung',
  },
  {
    id: '1701051007',
    districtId: '1701051',
    name: 'Suka Negeri',
  },
  {
    id: '1701051008',
    districtId: '1701051',
    name: 'Pino Baru',
  },
  {
    id: '1701051009',
    districtId: '1701051',
    name: 'Suka Maju',
  },
  {
    id: '1701051010',
    districtId: '1701051',
    name: 'Sukarami',
  },
  {
    id: '1701060013',
    districtId: '1701060',
    name: 'Padang Lebar',
  },
  {
    id: '1701060014',
    districtId: '1701060',
    name: 'Anggut',
  },
  {
    id: '1701060015',
    districtId: '1701060',
    name: 'Gedung Agung',
  },
  {
    id: '1701060016',
    districtId: '1701060',
    name: 'Tanjung Eran',
  },
  {
    id: '1701060017',
    districtId: '1701060',
    name: 'Tanjung Aur I',
  },
  {
    id: '1701060018',
    districtId: '1701060',
    name: 'Puding',
  },
  {
    id: '1701060019',
    districtId: '1701060',
    name: 'Air Umban',
  },
  {
    id: '1701060020',
    districtId: '1701060',
    name: 'Masat',
  },
  {
    id: '1701060024',
    districtId: '1701060',
    name: 'Ulak Lebar',
  },
  {
    id: '1701060025',
    districtId: '1701060',
    name: 'Sebilo',
  },
  {
    id: '1701060026',
    districtId: '1701060',
    name: 'Ganjuh',
  },
  {
    id: '1701060027',
    districtId: '1701060',
    name: 'Kota Bumi',
  },
  {
    id: '1701060028',
    districtId: '1701060',
    name: 'Batu Bandung',
  },
  {
    id: '1701060029',
    districtId: '1701060',
    name: 'Beringin Datar',
  },
  {
    id: '1701060030',
    districtId: '1701060',
    name: 'Padang Mumpo',
  },
  {
    id: '1701060031',
    districtId: '1701060',
    name: 'Padang Tambak',
  },
  {
    id: '1701061001',
    districtId: '1701061',
    name: 'Tanggo Raso',
  },
  {
    id: '1701061002',
    districtId: '1701061',
    name: 'Air Kemang',
  },
  {
    id: '1701061003',
    districtId: '1701061',
    name: 'Bandung Ayu',
  },
  {
    id: '1701061004',
    districtId: '1701061',
    name: 'Tungkal I',
  },
  {
    id: '1701061005',
    districtId: '1701061',
    name: 'Talang Padang',
  },
  {
    id: '1701061006',
    districtId: '1701061',
    name: 'Pasar Pino',
  },
  {
    id: '1701061007',
    districtId: '1701061',
    name: 'Selali',
  },
  {
    id: '1701061008',
    districtId: '1701061',
    name: 'Nanjungan',
  },
  {
    id: '1701061009',
    districtId: '1701061',
    name: 'Tungkal II',
  },
  {
    id: '1701061010',
    districtId: '1701061',
    name: 'Napal Melintang',
  },
  {
    id: '1701061011',
    districtId: '1701061',
    name: 'Serang Bulan',
  },
  {
    id: '1701061012',
    districtId: '1701061',
    name: 'Kemang Manis',
  },
  {
    id: '1701061013',
    districtId: '1701061',
    name: 'Suka Bandung',
  },
  {
    id: '1701061014',
    districtId: '1701061',
    name: 'Cinto Mandi',
  },
  {
    id: '1701061015',
    districtId: '1701061',
    name: 'Pagar Gading',
  },
  {
    id: '1701061016',
    districtId: '1701061',
    name: 'Kembang Seri',
  },
  {
    id: '1701061017',
    districtId: '1701061',
    name: 'Karang Cayo',
  },
  {
    id: '1701061018',
    districtId: '1701061',
    name: 'Tanjung Aur II',
  },
  {
    id: '1701061019',
    districtId: '1701061',
    name: 'Padang Beriang',
  },
  {
    id: '1701061020',
    districtId: '1701061',
    name: 'Padang Serasan',
  },
  {
    id: '1701061022',
    districtId: '1701061',
    name: 'Telaga Dalam',
  },
  {
    id: '1701061023',
    districtId: '1701061',
    name: 'UPT Tanjung Aur II',
  },
  {
    id: '1701062001',
    districtId: '1701062',
    name: 'Batu Panco',
  },
  {
    id: '1701062002',
    districtId: '1701062',
    name: 'Batu Kuning',
  },
  {
    id: '1701062003',
    districtId: '1701062',
    name: 'Bandar Agung',
  },
  {
    id: '1701062004',
    districtId: '1701062',
    name: 'Merambung',
  },
  {
    id: '1701062005',
    districtId: '1701062',
    name: 'Simpang Pino',
  },
  {
    id: '1701062006',
    districtId: '1701062',
    name: 'Talang Tinggi',
  },
  {
    id: '1701062007',
    districtId: '1701062',
    name: 'Keban Jati',
  },
  {
    id: '1701062008',
    districtId: '1701062',
    name: 'Lubuk Tapi',
  },
  {
    id: '1701062009',
    districtId: '1701062',
    name: 'Kayu Ajaran',
  },
  {
    id: '1701062010',
    districtId: '1701062',
    name: 'Air Tenam',
  },
  {
    id: '1702020007',
    districtId: '1702020',
    name: 'Durian Mas',
  },
  {
    id: '1702020008',
    districtId: '1702020',
    name: 'Lubuk Mumpo',
  },
  {
    id: '1702020009',
    districtId: '1702020',
    name: 'Dusun Baru',
  },
  {
    id: '1702020010',
    districtId: '1702020',
    name: 'Bedeng Ss',
  },
  {
    id: '1702020011',
    districtId: '1702020',
    name: 'Kota Padang',
  },
  {
    id: '1702020012',
    districtId: '1702020',
    name: 'Suka Rami',
  },
  {
    id: '1702020013',
    districtId: '1702020',
    name: 'Taba Anyar',
  },
  {
    id: '1702020014',
    districtId: '1702020',
    name: 'Derati',
  },
  {
    id: '1702020015',
    districtId: '1702020',
    name: 'Kota Padang Baru',
  },
  {
    id: '1702020016',
    districtId: '1702020',
    name: 'Tanjung Gelang',
  },
  {
    id: '1702021001',
    districtId: '1702021',
    name: 'Merantau',
  },
  {
    id: '1702021002',
    districtId: '1702021',
    name: 'Periang',
  },
  {
    id: '1702021003',
    districtId: '1702021',
    name: 'Balai Butar',
  },
  {
    id: '1702021004',
    districtId: '1702021',
    name: 'Lubuk Belimbing I',
  },
  {
    id: '1702021005',
    districtId: '1702021',
    name: 'Sari Pulau',
  },
  {
    id: '1702021006',
    districtId: '1702021',
    name: 'Suka Merindu',
  },
  {
    id: '1702021007',
    districtId: '1702021',
    name: 'Lubuk Belimbing II',
  },
  {
    id: '1702021008',
    districtId: '1702021',
    name: 'Lubuk Bingin Baru',
  },
  {
    id: '1702021009',
    districtId: '1702021',
    name: 'Lubuk Tunjung',
  },
  {
    id: '1702021010',
    districtId: '1702021',
    name: 'Suka Karya',
  },
  {
    id: '1702030028',
    districtId: '1702030',
    name: 'Karang Baru',
  },
  {
    id: '1702030029',
    districtId: '1702030',
    name: 'Guru Agung',
  },
  {
    id: '1702030031',
    districtId: '1702030',
    name: 'Tanjung Sanai I',
  },
  {
    id: '1702030032',
    districtId: '1702030',
    name: 'Tanjung Sanai II',
  },
  {
    id: '1702030033',
    districtId: '1702030',
    name: 'Ulak Tanding',
  },
  {
    id: '1702030034',
    districtId: '1702030',
    name: 'Pasar Padang Ulak Tanding',
  },
  {
    id: '1702030035',
    districtId: '1702030',
    name: 'Taba Tinggi',
  },
  {
    id: '1702030036',
    districtId: '1702030',
    name: 'Muara Telita',
  },
  {
    id: '1702030037',
    districtId: '1702030',
    name: 'T A K T O I',
  },
  {
    id: '1702030040',
    districtId: '1702030',
    name: 'Ujan Panas',
  },
  {
    id: '1702030041',
    districtId: '1702030',
    name: 'Kasie Kasubun',
  },
  {
    id: '1702030042',
    districtId: '1702030',
    name: 'Belumai II',
  },
  {
    id: '1702030043',
    districtId: '1702030',
    name: 'Belumai I',
  },
  {
    id: '1702030044',
    districtId: '1702030',
    name: 'Bukit Batu',
  },
  {
    id: '1702030045',
    districtId: '1702030',
    name: 'Air Kati',
  },
  {
    id: '1702031001',
    districtId: '1702031',
    name: 'Sindang Jaya',
  },
  {
    id: '1702031006',
    districtId: '1702031',
    name: 'Sindang Jati',
  },
  {
    id: '1702031007',
    districtId: '1702031',
    name: 'Air Dingin',
  },
  {
    id: '1702031008',
    districtId: '1702031',
    name: 'Kayu Manis',
  },
  {
    id: '1702031011',
    districtId: '1702031',
    name: 'Beringin Tiga',
  },
  {
    id: '1702031012',
    districtId: '1702031',
    name: 'Pelalo',
  },
  {
    id: '1702031013',
    districtId: '1702031',
    name: 'Belitar Muka',
  },
  {
    id: '1702031014',
    districtId: '1702031',
    name: 'Belitar Seberang',
  },
  {
    id: '1702031015',
    districtId: '1702031',
    name: 'Tanjung Aur',
  },
  {
    id: '1702031016',
    districtId: '1702031',
    name: 'Cahaya Negeri',
  },
  {
    id: '1702032001',
    districtId: '1702032',
    name: 'Kepala Curup',
  },
  {
    id: '1702032002',
    districtId: '1702032',
    name: 'Simpang Beliti',
  },
  {
    id: '1702032003',
    districtId: '1702032',
    name: 'Kampung Jeruk',
  },
  {
    id: '1702032004',
    districtId: '1702032',
    name: 'Air Apo',
  },
  {
    id: '1702032005',
    districtId: '1702032',
    name: 'Taba Padang',
  },
  {
    id: '1702033001',
    districtId: '1702033',
    name: 'A P U R',
  },
  {
    id: '1702033002',
    districtId: '1702033',
    name: 'Lawang Agung',
  },
  {
    id: '1702033003',
    districtId: '1702033',
    name: 'Lubuk Alai',
  },
  {
    id: '1702033004',
    districtId: '1702033',
    name: 'Karang Pinang',
  },
  {
    id: '1702033005',
    districtId: '1702033',
    name: 'Tanjung Agung',
  },
  {
    id: '1702033006',
    districtId: '1702033',
    name: 'Pengambang',
  },
  {
    id: '1702033007',
    districtId: '1702033',
    name: 'J A B I',
  },
  {
    id: '1702033008',
    districtId: '1702033',
    name: 'Tanjung Heran',
  },
  {
    id: '1702033009',
    districtId: '1702033',
    name: 'Air Nau',
  },
  {
    id: '1702034001',
    districtId: '1702034',
    name: 'IV Suku Menanti',
  },
  {
    id: '1702034002',
    districtId: '1702034',
    name: 'Bengko',
  },
  {
    id: '1702034003',
    districtId: '1702034',
    name: 'Sinar Gunung',
  },
  {
    id: '1702034004',
    districtId: '1702034',
    name: 'Air Rusa',
  },
  {
    id: '1702034005',
    districtId: '1702034',
    name: 'Talang Belitar',
  },
  {
    id: '1702034006',
    districtId: '1702034',
    name: 'Warung Pojok',
  },
  {
    id: '1702040012',
    districtId: '1702040',
    name: 'Air Putih Lama',
  },
  {
    id: '1702040013',
    districtId: '1702040',
    name: 'Air Rambai',
  },
  {
    id: '1702040014',
    districtId: '1702040',
    name: 'Dwi Tunggal',
  },
  {
    id: '1702040015',
    districtId: '1702040',
    name: 'Adirejo',
  },
  {
    id: '1702040016',
    districtId: '1702040',
    name: 'Talang Benih',
  },
  {
    id: '1702040017',
    districtId: '1702040',
    name: 'Jalan Baru',
  },
  {
    id: '1702040018',
    districtId: '1702040',
    name: 'Pasar Baru',
  },
  {
    id: '1702040019',
    districtId: '1702040',
    name: 'Pasar Tengah',
  },
  {
    id: '1702040061',
    districtId: '1702040',
    name: 'Timbul Rejo',
  },
  {
    id: '1702041001',
    districtId: '1702041',
    name: 'Baru Manis',
  },
  {
    id: '1702041002',
    districtId: '1702041',
    name: 'Air Pikat',
  },
  {
    id: '1702041003',
    districtId: '1702041',
    name: 'Tebat Tenong Dalam',
  },
  {
    id: '1702041004',
    districtId: '1702041',
    name: 'Suka Rami',
  },
  {
    id: '1702041007',
    districtId: '1702041',
    name: 'Pagar Gunung',
  },
  {
    id: '1702041008',
    districtId: '1702041',
    name: 'Air Mundu',
  },
  {
    id: '1702041009',
    districtId: '1702041',
    name: 'Kampung Sajad',
  },
  {
    id: '1702041010',
    districtId: '1702041',
    name: 'Sentral Baru',
  },
  {
    id: '1702041011',
    districtId: '1702041',
    name: 'Kampung Melayu',
  },
  {
    id: '1702041013',
    districtId: '1702041',
    name: 'Selamat Sudiarjo',
  },
  {
    id: '1702041014',
    districtId: '1702041',
    name: 'Purwodadi',
  },
  {
    id: '1702041015',
    districtId: '1702041',
    name: 'Tebat Pulau',
  },
  {
    id: '1702042001',
    districtId: '1702042',
    name: 'Air Meles Atas',
  },
  {
    id: '1702042002',
    districtId: '1702042',
    name: 'Cawang Baru',
  },
  {
    id: '1702042003',
    districtId: '1702042',
    name: 'Cawang Lama',
  },
  {
    id: '1702042004',
    districtId: '1702042',
    name: 'Kayu Manis',
  },
  {
    id: '1702042005',
    districtId: '1702042',
    name: 'Simpang Nangka',
  },
  {
    id: '1702042006',
    districtId: '1702042',
    name: 'Kampung Baru',
  },
  {
    id: '1702042007',
    districtId: '1702042',
    name: 'Suban Ayam',
  },
  {
    id: '1702042008',
    districtId: '1702042',
    name: 'Air Putih Kali Bandung',
  },
  {
    id: '1702042009',
    districtId: '1702042',
    name: 'Air Duku',
  },
  {
    id: '1702042010',
    districtId: '1702042',
    name: 'Sambirejo',
  },
  {
    id: '1702042011',
    districtId: '1702042',
    name: 'Sumber Bening',
  },
  {
    id: '1702042012',
    districtId: '1702042',
    name: 'Sumber Urip',
  },
  {
    id: '1702042013',
    districtId: '1702042',
    name: 'Karang Jaya',
  },
  {
    id: '1702042014',
    districtId: '1702042',
    name: 'Kali Padang',
  },
  {
    id: '1702042015',
    districtId: '1702042',
    name: 'Talang Lahat',
  },
  {
    id: '1702042016',
    districtId: '1702042',
    name: 'Mojorejo',
  },
  {
    id: '1702043001',
    districtId: '1702043',
    name: 'Air Lanang',
  },
  {
    id: '1702043002',
    districtId: '1702043',
    name: 'Tanjung Dalam',
  },
  {
    id: '1702043003',
    districtId: '1702043',
    name: 'Turan Baru',
  },
  {
    id: '1702043004',
    districtId: '1702043',
    name: 'Pungguk Lalang',
  },
  {
    id: '1702043005',
    districtId: '1702043',
    name: 'Watas Marga',
  },
  {
    id: '1702043006',
    districtId: '1702043',
    name: 'Lubuk Ubar',
  },
  {
    id: '1702043007',
    districtId: '1702043',
    name: 'Rimbo Recap',
  },
  {
    id: '1702043008',
    districtId: '1702043',
    name: 'Suka Marga',
  },
  {
    id: '1702043009',
    districtId: '1702043',
    name: 'Tempel Rejo',
  },
  {
    id: '1702043010',
    districtId: '1702043',
    name: 'Air Putih Baru',
  },
  {
    id: '1702043011',
    districtId: '1702043',
    name: 'Desa Teladan',
  },
  {
    id: '1702044001',
    districtId: '1702044',
    name: 'Kepala Siring',
  },
  {
    id: '1702044002',
    districtId: '1702044',
    name: 'Talang Rimbo Baru',
  },
  {
    id: '1702044003',
    districtId: '1702044',
    name: 'Talang Rimbo Lama',
  },
  {
    id: '1702044004',
    districtId: '1702044',
    name: 'Banyumas',
  },
  {
    id: '1702044005',
    districtId: '1702044',
    name: 'Pelabuhan Baru',
  },
  {
    id: '1702044006',
    districtId: '1702044',
    name: 'Kampung Jawa',
  },
  {
    id: '1702044007',
    districtId: '1702044',
    name: 'Sidorejo',
  },
  {
    id: '1702044008',
    districtId: '1702044',
    name: 'Air Bang',
  },
  {
    id: '1702044009',
    districtId: '1702044',
    name: 'Air Merah',
  },
  {
    id: '1702044010',
    districtId: '1702044',
    name: 'Batu Galing',
  },
  {
    id: '1702045001',
    districtId: '1702045',
    name: 'Bandung Marga',
  },
  {
    id: '1702045002',
    districtId: '1702045',
    name: 'Pal VII',
  },
  {
    id: '1702045003',
    districtId: '1702045',
    name: 'Sumber Rejo Transad',
  },
  {
    id: '1702045004',
    districtId: '1702045',
    name: 'Pal 100',
  },
  {
    id: '1702045005',
    districtId: '1702045',
    name: 'Karang Anyar Pal VIII',
  },
  {
    id: '1702045006',
    districtId: '1702045',
    name: 'Tebat Tenong Luar',
  },
  {
    id: '1702045007',
    districtId: '1702045',
    name: 'Bangun Jaya',
  },
  {
    id: '1702045008',
    districtId: '1702045',
    name: 'Air Bening',
  },
  {
    id: '1702045009',
    districtId: '1702045',
    name: 'Babakan Baru',
  },
  {
    id: '1702045010',
    districtId: '1702045',
    name: 'Dataran Tapus',
  },
  {
    id: '1702046001',
    districtId: '1702046',
    name: 'Dusun Curup',
  },
  {
    id: '1702046002',
    districtId: '1702046',
    name: 'Batu Dewa',
  },
  {
    id: '1702046003',
    districtId: '1702046',
    name: 'Tunas Harapan',
  },
  {
    id: '1702046004',
    districtId: '1702046',
    name: 'Perbo',
  },
  {
    id: '1702046005',
    districtId: '1702046',
    name: 'Batu Panco',
  },
  {
    id: '1702046006',
    districtId: '1702046',
    name: 'Suka Datang',
  },
  {
    id: '1702046007',
    districtId: '1702046',
    name: 'Lubuk Kembang',
  },
  {
    id: '1702046008',
    districtId: '1702046',
    name: 'Dusun Sawah',
  },
  {
    id: '1702046009',
    districtId: '1702046',
    name: 'Tabarenah',
  },
  {
    id: '1702046010',
    districtId: '1702046',
    name: 'Desa Pahlawan',
  },
  {
    id: '1702046011',
    districtId: '1702046',
    name: 'Tasik Malaya',
  },
  {
    id: '1702046012',
    districtId: '1702046',
    name: 'Tanjung Beringin',
  },
  {
    id: '1702046013',
    districtId: '1702046',
    name: 'Kota Pagu',
  },
  {
    id: '1702046014',
    districtId: '1702046',
    name: 'Seguring',
  },
  {
    id: '1702047001',
    districtId: '1702047',
    name: 'Duku Ulu',
  },
  {
    id: '1702047002',
    districtId: '1702047',
    name: 'Duku Ilir',
  },
  {
    id: '1702047003',
    districtId: '1702047',
    name: 'Kampung Delima',
  },
  {
    id: '1702047004',
    districtId: '1702047',
    name: 'Kesambe Lama',
  },
  {
    id: '1702047005',
    districtId: '1702047',
    name: 'Karang Anyar',
  },
  {
    id: '1702047006',
    districtId: '1702047',
    name: 'Air Meles Bawah',
  },
  {
    id: '1702047007',
    districtId: '1702047',
    name: 'Sukaraja',
  },
  {
    id: '1702047008',
    districtId: '1702047',
    name: 'Kesambe Baru',
  },
  {
    id: '1702047009',
    districtId: '1702047',
    name: 'Talang Ulu',
  },
  {
    id: '1703010001',
    districtId: '1703010',
    name: 'Banjar Sari',
  },
  {
    id: '1703010002',
    districtId: '1703010',
    name: 'Meok',
  },
  {
    id: '1703010003',
    districtId: '1703010',
    name: 'Apoho',
  },
  {
    id: '1703010004',
    districtId: '1703010',
    name: 'Malakoni',
  },
  {
    id: '1703010005',
    districtId: '1703010',
    name: 'Kaana',
  },
  {
    id: '1703010006',
    districtId: '1703010',
    name: 'Kahyapu',
  },
  {
    id: '1703050033',
    districtId: '1703050',
    name: 'Tanjung Putus',
  },
  {
    id: '1703050036',
    districtId: '1703050',
    name: 'Talang Jambu',
  },
  {
    id: '1703050037',
    districtId: '1703050',
    name: 'Tebat Pacur',
  },
  {
    id: '1703050039',
    districtId: '1703050',
    name: 'Penyangkak',
  },
  {
    id: '1703050040',
    districtId: '1703050',
    name: 'Magelang',
  },
  {
    id: '1703050041',
    districtId: '1703050',
    name: 'Talang Curup',
  },
  {
    id: '1703050042',
    districtId: '1703050',
    name: 'Banyumas Baru',
  },
  {
    id: '1703050043',
    districtId: '1703050',
    name: 'Serumbung',
  },
  {
    id: '1703050044',
    districtId: '1703050',
    name: 'Lubuk Durian',
  },
  {
    id: '1703050045',
    districtId: '1703050',
    name: 'Salam Harjo',
  },
  {
    id: '1703050046',
    districtId: '1703050',
    name: 'Banyumas Lama',
  },
  {
    id: '1703050047',
    districtId: '1703050',
    name: 'Talang Pasak',
  },
  {
    id: '1703050048',
    districtId: '1703050',
    name: 'Jogya Baru',
  },
  {
    id: '1703050049',
    districtId: '1703050',
    name: 'Perbo',
  },
  {
    id: '1703050050',
    districtId: '1703050',
    name: 'Simpang Ketenong',
  },
  {
    id: '1703050051',
    districtId: '1703050',
    name: 'Aur Gading',
  },
  {
    id: '1703050052',
    districtId: '1703050',
    name: 'Lubuk Jale',
  },
  {
    id: '1703050053',
    districtId: '1703050',
    name: 'Kedu Baru',
  },
  {
    id: '1703051001',
    districtId: '1703051',
    name: 'Tepi Laut',
  },
  {
    id: '1703051002',
    districtId: '1703051',
    name: 'Pasar Bembah',
  },
  {
    id: '1703051003',
    districtId: '1703051',
    name: 'Pasar Kerkap',
  },
  {
    id: '1703051004',
    districtId: '1703051',
    name: 'Air Napal',
  },
  {
    id: '1703051005',
    districtId: '1703051',
    name: 'Talang Jarang',
  },
  {
    id: '1703051006',
    districtId: '1703051',
    name: 'Talang Kering',
  },
  {
    id: '1703051007',
    districtId: '1703051',
    name: 'Selubuk',
  },
  {
    id: '1703051008',
    districtId: '1703051',
    name: 'Pasar Tebat',
  },
  {
    id: '1703051009',
    districtId: '1703051',
    name: 'Lubuk Tanjung',
  },
  {
    id: '1703051010',
    districtId: '1703051',
    name: 'Pasar Palik',
  },
  {
    id: '1703051011',
    districtId: '1703051',
    name: 'Tebing Kandang',
  },
  {
    id: '1703051012',
    districtId: '1703051',
    name: 'Dusun Pukur',
  },
  {
    id: '1703052001',
    districtId: '1703052',
    name: 'Kota Agung',
  },
  {
    id: '1703052002',
    districtId: '1703052',
    name: 'Talang Lembak',
  },
  {
    id: '1703052003',
    districtId: '1703052',
    name: 'Talang Renah',
  },
  {
    id: '1703052004',
    districtId: '1703052',
    name: 'Sungai Pura',
  },
  {
    id: '1703052005',
    districtId: '1703052',
    name: 'Tanjung Genting',
  },
  {
    id: '1703052006',
    districtId: '1703052',
    name: 'Lubuk Balam',
  },
  {
    id: '1703052007',
    districtId: '1703052',
    name: 'Datar Macang',
  },
  {
    id: '1703052010',
    districtId: '1703052',
    name: 'Genting Perangkap',
  },
  {
    id: '1703052011',
    districtId: '1703052',
    name: 'Talang Baru Ginting',
  },
  {
    id: '1703052012',
    districtId: '1703052',
    name: 'Talang Pungguk',
  },
  {
    id: '1703052013',
    districtId: '1703052',
    name: 'Kertapati',
  },
  {
    id: '1703052014',
    districtId: '1703052',
    name: 'Talang Ginting',
  },
  {
    id: '1703052015',
    districtId: '1703052',
    name: 'Tanjung Karet',
  },
  {
    id: '1703052016',
    districtId: '1703052',
    name: 'Dusun Curup',
  },
  {
    id: '1703052017',
    districtId: '1703052',
    name: 'Penyangkak',
  },
  {
    id: '1703053001',
    districtId: '1703053',
    name: 'Kota Lekat Ilir',
  },
  {
    id: '1703053002',
    districtId: '1703053',
    name: 'Air Banai',
  },
  {
    id: '1703053003',
    districtId: '1703053',
    name: 'Air Baus II',
  },
  {
    id: '1703053004',
    districtId: '1703053',
    name: 'Air Baus I',
  },
  {
    id: '1703053005',
    districtId: '1703053',
    name: 'Taba Padang Kol',
  },
  {
    id: '1703053006',
    districtId: '1703053',
    name: 'Taba Padang Rejang',
  },
  {
    id: '1703053007',
    districtId: '1703053',
    name: 'Padang Bendar',
  },
  {
    id: '1703053008',
    districtId: '1703053',
    name: 'Batu Layang',
  },
  {
    id: '1703053009',
    districtId: '1703053',
    name: 'Batu Raja Kol',
  },
  {
    id: '1703053010',
    districtId: '1703053',
    name: 'Batu Raja Rejang',
  },
  {
    id: '1703053011',
    districtId: '1703053',
    name: 'Batu Roto',
  },
  {
    id: '1703053012',
    districtId: '1703053',
    name: 'Pematang Balam',
  },
  {
    id: '1703053013',
    districtId: '1703053',
    name: 'Talang Rendah',
  },
  {
    id: '1703053014',
    districtId: '1703053',
    name: 'Sumberejo',
  },
  {
    id: '1703053015',
    districtId: '1703053',
    name: 'Kota Lekat Mudik',
  },
  {
    id: '1703054001',
    districtId: '1703054',
    name: 'Lubuk Sematung',
  },
  {
    id: '1703054002',
    districtId: '1703054',
    name: 'Ketapi',
  },
  {
    id: '1703054003',
    districtId: '1703054',
    name: 'Sawang Lebar',
  },
  {
    id: '1703054004',
    districtId: '1703054',
    name: 'Lubuk Gading',
  },
  {
    id: '1703054005',
    districtId: '1703054',
    name: 'Sawang Lebar Ilir',
  },
  {
    id: '1703054006',
    districtId: '1703054',
    name: 'Lubuk Pendam',
  },
  {
    id: '1703054007',
    districtId: '1703054',
    name: 'Alunddua',
  },
  {
    id: '1703054008',
    districtId: '1703054',
    name: 'Sengkuang',
  },
  {
    id: '1703054009',
    districtId: '1703054',
    name: 'Tanjung Agung',
  },
  {
    id: '1703054010',
    districtId: '1703054',
    name: 'Padang Sepan',
  },
  {
    id: '1703060010',
    districtId: '1703060',
    name: 'Talang Denau',
  },
  {
    id: '1703060011',
    districtId: '1703060',
    name: 'Gunung Selan',
  },
  {
    id: '1703060012',
    districtId: '1703060',
    name: 'Gunung Agung',
  },
  {
    id: '1703060013',
    districtId: '1703060',
    name: 'Rama Agung',
  },
  {
    id: '1703060014',
    districtId: '1703060',
    name: 'Gunung Alam',
  },
  {
    id: '1703060015',
    districtId: '1703060',
    name: 'Sido Urip',
  },
  {
    id: '1703060016',
    districtId: '1703060',
    name: 'Datar Ruyung',
  },
  {
    id: '1703060017',
    districtId: '1703060',
    name: 'Tanjung Raman',
  },
  {
    id: '1703060020',
    districtId: '1703060',
    name: 'Lubuk Saung',
  },
  {
    id: '1703060021',
    districtId: '1703060',
    name: 'Karang Suci',
  },
  {
    id: '1703060022',
    districtId: '1703060',
    name: 'Purwodadi',
  },
  {
    id: '1703060023',
    districtId: '1703060',
    name: 'Karang Anyar II',
  },
  {
    id: '1703060024',
    districtId: '1703060',
    name: 'Karang Anyar',
  },
  {
    id: '1703060025',
    districtId: '1703060',
    name: 'Taba Tembilang',
  },
  {
    id: '1703060026',
    districtId: '1703060',
    name: 'Senali',
  },
  {
    id: '1703060027',
    districtId: '1703060',
    name: 'Kuro Tidur',
  },
  {
    id: '1703061001',
    districtId: '1703061',
    name: 'Gardu',
  },
  {
    id: '1703061002',
    districtId: '1703061',
    name: 'Pagar Banyu',
  },
  {
    id: '1703061003',
    districtId: '1703061',
    name: 'Pematang Sapang',
  },
  {
    id: '1703061004',
    districtId: '1703061',
    name: 'Sumber Agung',
  },
  {
    id: '1703061005',
    districtId: '1703061',
    name: 'Sidodadi',
  },
  {
    id: '1703061006',
    districtId: '1703061',
    name: 'Gunung Besar',
  },
  {
    id: '1703061007',
    districtId: '1703061',
    name: 'Kali',
  },
  {
    id: '1703061008',
    districtId: '1703061',
    name: 'Pagar Ruyung',
  },
  {
    id: '1703061009',
    districtId: '1703061',
    name: 'Air Merah',
  },
  {
    id: '1703061010',
    districtId: '1703061',
    name: 'Tebing Kaning',
  },
  {
    id: '1703061011',
    districtId: '1703061',
    name: 'Kemumu',
  },
  {
    id: '1703061012',
    districtId: '1703061',
    name: 'Kalai Duai',
  },
  {
    id: '1703070001',
    districtId: '1703070',
    name: 'Pasar Lais',
  },
  {
    id: '1703070002',
    districtId: '1703070',
    name: 'Pal Tiga Puluh',
  },
  {
    id: '1703070003',
    districtId: '1703070',
    name: 'Jago Bayo',
  },
  {
    id: '1703070004',
    districtId: '1703070',
    name: 'Lubuk Lesung',
  },
  {
    id: '1703070005',
    districtId: '1703070',
    name: 'Dusun Raja',
  },
  {
    id: '1703070006',
    districtId: '1703070',
    name: 'Durian Daun',
  },
  {
    id: '1703070007',
    districtId: '1703070',
    name: 'Air Padang',
  },
  {
    id: '1703070008',
    districtId: '1703070',
    name: 'Datar Lebar',
  },
  {
    id: '1703070010',
    districtId: '1703070',
    name: 'Talang Rasau',
  },
  {
    id: '1703070011',
    districtId: '1703070',
    name: 'Lubuk Gedang',
  },
  {
    id: '1703070012',
    districtId: '1703070',
    name: 'Suka Langu',
  },
  {
    id: '1703070026',
    districtId: '1703070',
    name: 'Taba Baru',
  },
  {
    id: '1703070027',
    districtId: '1703070',
    name: 'Kalbang',
  },
  {
    id: '1703071001',
    districtId: '1703071',
    name: 'Serangai',
  },
  {
    id: '1703071002',
    districtId: '1703071',
    name: 'Selolong',
  },
  {
    id: '1703071003',
    districtId: '1703071',
    name: 'Airlakok',
  },
  {
    id: '1703071004',
    districtId: '1703071',
    name: 'Bintunan',
  },
  {
    id: '1703071005',
    districtId: '1703071',
    name: 'Sukamarga',
  },
  {
    id: '1703071006',
    districtId: '1703071',
    name: 'Batik Nau',
  },
  {
    id: '1703071007',
    districtId: '1703071',
    name: 'Pagar Ruyung',
  },
  {
    id: '1703071008',
    districtId: '1703071',
    name: 'Durian Amparan',
  },
  {
    id: '1703071009',
    districtId: '1703071',
    name: 'Samban Jaya',
  },
  {
    id: '1703071010',
    districtId: '1703071',
    name: 'Maninjau',
  },
  {
    id: '1703071011',
    districtId: '1703071',
    name: 'Air Menganyau',
  },
  {
    id: '1703071012',
    districtId: '1703071',
    name: 'Taba Kelintang',
  },
  {
    id: '1703071013',
    districtId: '1703071',
    name: 'Ulak Tanding',
  },
  {
    id: '1703071014',
    districtId: '1703071',
    name: 'Sekiau',
  },
  {
    id: '1703071015',
    districtId: '1703071',
    name: 'Seberang Tunggal',
  },
  {
    id: '1703072001',
    districtId: '1703072',
    name: 'Sukamakmur',
  },
  {
    id: '1703072002',
    districtId: '1703072',
    name: 'Tanjung Anom',
  },
  {
    id: '1703072003',
    districtId: '1703072',
    name: 'Giri Mulya',
  },
  {
    id: '1703072004',
    districtId: '1703072',
    name: 'Wonoharjo',
  },
  {
    id: '1703072005',
    districtId: '1703072',
    name: 'Rena Jaya',
  },
  {
    id: '1703072006',
    districtId: '1703072',
    name: 'Suka Mulya',
  },
  {
    id: '1703073001',
    districtId: '1703073',
    name: 'Tanjung Aur',
  },
  {
    id: '1703073002',
    districtId: '1703073',
    name: 'Mesigit',
  },
  {
    id: '1703073003',
    districtId: '1703073',
    name: 'Retes',
  },
  {
    id: '1703073004',
    districtId: '1703073',
    name: 'Lubuk Mumpo',
  },
  {
    id: '1703073005',
    districtId: '1703073',
    name: 'Talang Ulu',
  },
  {
    id: '1703073006',
    districtId: '1703073',
    name: 'Kembang Manis',
  },
  {
    id: '1703073007',
    districtId: '1703073',
    name: 'Sukarami',
  },
  {
    id: '1703073008',
    districtId: '1703073',
    name: 'Teluk Ajang',
  },
  {
    id: '1703073009',
    districtId: '1703073',
    name: 'Dusun Balam',
  },
  {
    id: '1703073010',
    districtId: '1703073',
    name: 'Padang Kala',
  },
  {
    id: '1703080001',
    districtId: '1703080',
    name: 'Lubuk Banyau',
  },
  {
    id: '1703080002',
    districtId: '1703080',
    name: 'Sido Mukti',
  },
  {
    id: '1703080003',
    districtId: '1703080',
    name: 'Arga Mulya',
  },
  {
    id: '1703080004',
    districtId: '1703080',
    name: 'Talang Tua',
  },
  {
    id: '1703080005',
    districtId: '1703080',
    name: 'Padang Jaya',
  },
  {
    id: '1703080006',
    districtId: '1703080',
    name: 'Tanjung Harapan',
  },
  {
    id: '1703080007',
    districtId: '1703080',
    name: 'Marga Sakti',
  },
  {
    id: '1703080008',
    districtId: '1703080',
    name: 'Marga Jaya',
  },
  {
    id: '1703080009',
    districtId: '1703080',
    name: 'Tanah Hitam',
  },
  {
    id: '1703080010',
    districtId: '1703080',
    name: 'Tambak Rejo',
  },
  {
    id: '1703080011',
    districtId: '1703080',
    name: 'Tanah Tinggi',
  },
  {
    id: '1703080012',
    districtId: '1703080',
    name: 'Sido Luhur',
  },
  {
    id: '1703090001',
    districtId: '1703090',
    name: 'Urai',
  },
  {
    id: '1703090007',
    districtId: '1703090',
    name: 'Pasar Ketahun',
  },
  {
    id: '1703090008',
    districtId: '1703090',
    name: 'Giri Kencana',
  },
  {
    id: '1703090011',
    districtId: '1703090',
    name: 'Kuala Lelangi',
  },
  {
    id: '1703090012',
    districtId: '1703090',
    name: 'Talang Baru',
  },
  {
    id: '1703090013',
    districtId: '1703090',
    name: 'Dusun Raja',
  },
  {
    id: '1703090014',
    districtId: '1703090',
    name: 'Fajar Baru',
  },
  {
    id: '1703090015',
    districtId: '1703090',
    name: 'Lubuk Mindai',
  },
  {
    id: '1703090024',
    districtId: '1703090',
    name: 'Melati Harjo',
  },
  {
    id: '1703090025',
    districtId: '1703090',
    name: 'Bukit Indah',
  },
  {
    id: '1703090026',
    districtId: '1703090',
    name: 'Bukit Tinggi',
  },
  {
    id: '1703091006',
    districtId: '1703091',
    name: 'Tanjung Alai',
  },
  {
    id: '1703091007',
    districtId: '1703091',
    name: 'Dusun Jabi',
  },
  {
    id: '1703091008',
    districtId: '1703091',
    name: 'Napal Putih',
  },
  {
    id: '1703091013',
    districtId: '1703091',
    name: 'Lebong Tandai',
  },
  {
    id: '1703091014',
    districtId: '1703091',
    name: 'Air Tenang',
  },
  {
    id: '1703091015',
    districtId: '1703091',
    name: 'Teluk Anggung',
  },
  {
    id: '1703091016',
    districtId: '1703091',
    name: 'Tanjung Kemenyan',
  },
  {
    id: '1703091017',
    districtId: '1703091',
    name: 'Muara Santan',
  },
  {
    id: '1703091019',
    districtId: '1703091',
    name: 'Gembung Raya',
  },
  {
    id: '1703091020',
    districtId: '1703091',
    name: 'Kinal Jaya',
  },
  {
    id: '1703092001',
    districtId: '1703092',
    name: 'Pagar Din',
  },
  {
    id: '1703092002',
    districtId: '1703092',
    name: 'Tanjung Dalam',
  },
  {
    id: '1703092003',
    districtId: '1703092',
    name: 'Air Lelangi',
  },
  {
    id: '1703092004',
    districtId: '1703092',
    name: 'Pondok Bakil',
  },
  {
    id: '1703092005',
    districtId: '1703092',
    name: 'Talang Berantai',
  },
  {
    id: '1703092006',
    districtId: '1703092',
    name: 'Bukit Berlian',
  },
  {
    id: '1703092007',
    districtId: '1703092',
    name: 'Tanjung Harapan',
  },
  {
    id: '1703092008',
    districtId: '1703092',
    name: 'Tanjung Sari',
  },
  {
    id: '1703092009',
    districtId: '1703092',
    name: 'Sp 7 Bangun Karya',
  },
  {
    id: '1703092010',
    districtId: '1703092',
    name: 'Bukit  Sari',
  },
  {
    id: '1703093001',
    districtId: '1703093',
    name: 'Air Simpang',
  },
  {
    id: '1703093002',
    districtId: '1703093',
    name: 'Air Sebayur',
  },
  {
    id: '1703093003',
    districtId: '1703093',
    name: 'Air Sekamanak',
  },
  {
    id: '1703093004',
    districtId: '1703093',
    name: 'Marga Bakti',
  },
  {
    id: '1703093005',
    districtId: '1703093',
    name: 'Bukit Makmur',
  },
  {
    id: '1703093006',
    districtId: '1703093',
    name: 'Bukit Harapan',
  },
  {
    id: '1703093007',
    districtId: '1703093',
    name: 'Gunung Payung',
  },
  {
    id: '1703093008',
    districtId: '1703093',
    name: 'Tanjung Muara',
  },
  {
    id: '1703093010',
    districtId: '1703093',
    name: 'Sumber Mulya',
  },
  {
    id: '1703093011',
    districtId: '1703093',
    name: 'Bumi Harjo',
  },
  {
    id: '1703100001',
    districtId: '1703100',
    name: 'Air Petai',
  },
  {
    id: '1703100002',
    districtId: '1703100',
    name: 'Karang Pulau',
  },
  {
    id: '1703100003',
    districtId: '1703100',
    name: 'Karang Tengah',
  },
  {
    id: '1703100004',
    districtId: '1703100',
    name: 'Air Muring',
  },
  {
    id: '1703100005',
    districtId: '1703100',
    name: 'Pasar Baru Kota Bani',
  },
  {
    id: '1703100006',
    districtId: '1703100',
    name: 'Pasar Sebelat',
  },
  {
    id: '1703100007',
    districtId: '1703100',
    name: 'Talang Arah',
  },
  {
    id: '1703100008',
    districtId: '1703100',
    name: 'Cipta Mulya',
  },
  {
    id: '1703100009',
    districtId: '1703100',
    name: 'Air Pandan',
  },
  {
    id: '1703101001',
    districtId: '1703101',
    name: 'Suka Negara',
  },
  {
    id: '1703101002',
    districtId: '1703101',
    name: 'Karya Jaya',
  },
  {
    id: '1703101003',
    districtId: '1703101',
    name: 'Karya Bakti',
  },
  {
    id: '1703101004',
    districtId: '1703101',
    name: 'Suka Medan',
  },
  {
    id: '1703101005',
    districtId: '1703101',
    name: 'Suka Merindu',
  },
  {
    id: '1703101006',
    districtId: '1703101',
    name: 'Suka Maju',
  },
  {
    id: '1703101007',
    districtId: '1703101',
    name: 'Suka Baru',
  },
  {
    id: '1703101008',
    districtId: '1703101',
    name: 'Karya Pelita',
  },
  {
    id: '1703101009',
    districtId: '1703101',
    name: 'Suka Makmur',
  },
  {
    id: '1703101010',
    districtId: '1703101',
    name: 'Air Putih',
  },
  {
    id: '1704010001',
    districtId: '1704010',
    name: 'Tanjung Betuah',
  },
  {
    id: '1704010003',
    districtId: '1704010',
    name: 'Gedung Menung',
  },
  {
    id: '1704010004',
    districtId: '1704010',
    name: 'Ulak Pandan',
  },
  {
    id: '1704010005',
    districtId: '1704010',
    name: 'Merpas',
  },
  {
    id: '1704010006',
    districtId: '1704010',
    name: 'Air Palawan',
  },
  {
    id: '1704010007',
    districtId: '1704010',
    name: 'Muara Dua',
  },
  {
    id: '1704010008',
    districtId: '1704010',
    name: 'Bukit Indah',
  },
  {
    id: '1704010009',
    districtId: '1704010',
    name: 'Suku Tiga',
  },
  {
    id: '1704010010',
    districtId: '1704010',
    name: 'Tebing Rambutan',
  },
  {
    id: '1704010011',
    districtId: '1704010',
    name: 'Batu Lungun',
  },
  {
    id: '1704010012',
    districtId: '1704010',
    name: 'Sumber Harapan',
  },
  {
    id: '1704010013',
    districtId: '1704010',
    name: 'Suka Jaya',
  },
  {
    id: '1704010014',
    districtId: '1704010',
    name: 'Pasar Baru',
  },
  {
    id: '1704010015',
    districtId: '1704010',
    name: 'Tri Jaya',
  },
  {
    id: '1704010016',
    districtId: '1704010',
    name: 'Air Batang',
  },
  {
    id: '1704010017',
    districtId: '1704010',
    name: 'Sinar Banten',
  },
  {
    id: '1704010018',
    districtId: '1704010',
    name: 'Pasar Jumat',
  },
  {
    id: '1704020001',
    districtId: '1704020',
    name: 'Parda Suka',
  },
  {
    id: '1704020002',
    districtId: '1704020',
    name: 'Air Long',
  },
  {
    id: '1704020003',
    districtId: '1704020',
    name: 'Linau',
  },
  {
    id: '1704020004',
    districtId: '1704020',
    name: 'Way Hawang',
  },
  {
    id: '1704020005',
    districtId: '1704020',
    name: 'Tanjung Baru',
  },
  {
    id: '1704020006',
    districtId: '1704020',
    name: 'Penyandingan',
  },
  {
    id: '1704020007',
    districtId: '1704020',
    name: 'Tanjung Aur',
  },
  {
    id: '1704020008',
    districtId: '1704020',
    name: 'Kedataran',
  },
  {
    id: '1704020009',
    districtId: '1704020',
    name: 'Tanjung Ganti',
  },
  {
    id: '1704020011',
    districtId: '1704020',
    name: 'Benteng Harapan',
  },
  {
    id: '1704020012',
    districtId: '1704020',
    name: 'Suka Menanti',
  },
  {
    id: '1704020013',
    districtId: '1704020',
    name: 'Sinar Mulya',
  },
  {
    id: '1704020014',
    districtId: '1704020',
    name: 'Bakal Makmur',
  },
  {
    id: '1704020015',
    districtId: '1704020',
    name: 'Muara Jaya',
  },
  {
    id: '1704020016',
    districtId: '1704020',
    name: 'Tanjung Agung',
  },
  {
    id: '1704020017',
    districtId: '1704020',
    name: 'Arga Mulia',
  },
  {
    id: '1704020018',
    districtId: '1704020',
    name: 'Air Jelatang',
  },
  {
    id: '1704020020',
    districtId: '1704020',
    name: 'Sumber Harapan',
  },
  {
    id: '1704020021',
    districtId: '1704020',
    name: 'Tanjung Beringin',
  },
  {
    id: '1704030012',
    districtId: '1704030',
    name: 'Sekunyit',
  },
  {
    id: '1704030013',
    districtId: '1704030',
    name: 'Suka Bandung',
  },
  {
    id: '1704030014',
    districtId: '1704030',
    name: 'Air Dingin',
  },
  {
    id: '1704030015',
    districtId: '1704030',
    name: 'Pasar Baru',
  },
  {
    id: '1704030016',
    districtId: '1704030',
    name: 'Jembatan Dua',
  },
  {
    id: '1704030017',
    districtId: '1704030',
    name: 'Gedung Sako',
  },
  {
    id: '1704030018',
    districtId: '1704030',
    name: 'Bandar',
  },
  {
    id: '1704030019',
    districtId: '1704030',
    name: 'Pasar Lama',
  },
  {
    id: '1704030020',
    districtId: '1704030',
    name: 'Tanjung Besar',
  },
  {
    id: '1704030035',
    districtId: '1704030',
    name: 'Pengubaian',
  },
  {
    id: '1704030036',
    districtId: '1704030',
    name: 'Pahlawan Ratu',
  },
  {
    id: '1704030037',
    districtId: '1704030',
    name: 'Pasar Sauh',
  },
  {
    id: '1704030038',
    districtId: '1704030',
    name: 'Padang Petron',
  },
  {
    id: '1704030039',
    districtId: '1704030',
    name: 'Kepala Pasar',
  },
  {
    id: '1704030040',
    districtId: '1704030',
    name: 'Sawah Jangkung',
  },
  {
    id: '1704030041',
    districtId: '1704030',
    name: 'Selasih',
  },
  {
    id: '1704030042',
    districtId: '1704030',
    name: 'Padang Genteng',
  },
  {
    id: '1704030043',
    districtId: '1704030',
    name: 'Gedung Sako II',
  },
  {
    id: '1704030044',
    districtId: '1704030',
    name: 'Sinar Pagi',
  },
  {
    id: '1704031001',
    districtId: '1704031',
    name: 'Suka Banjar',
  },
  {
    id: '1704031002',
    districtId: '1704031',
    name: 'Tanjung Bunga',
  },
  {
    id: '1704031003',
    districtId: '1704031',
    name: 'Tanjung Agung',
  },
  {
    id: '1704031004',
    districtId: '1704031',
    name: 'Babat',
  },
  {
    id: '1704031005',
    districtId: '1704031',
    name: 'Cucupan',
  },
  {
    id: '1704031006',
    districtId: '1704031',
    name: 'Kepahyang',
  },
  {
    id: '1704031007',
    districtId: '1704031',
    name: 'Tanjung Dalam',
  },
  {
    id: '1704031008',
    districtId: '1704031',
    name: 'Pagar Dewa',
  },
  {
    id: '1704031009',
    districtId: '1704031',
    name: 'Muara Tetap',
  },
  {
    id: '1704031010',
    districtId: '1704031',
    name: 'Kasuk Baru',
  },
  {
    id: '1704031011',
    districtId: '1704031',
    name: 'Suka Raja',
  },
  {
    id: '1704031012',
    districtId: '1704031',
    name: 'Padang Binjai',
  },
  {
    id: '1704040007',
    districtId: '1704040',
    name: 'Padang Baru',
  },
  {
    id: '1704040008',
    districtId: '1704040',
    name: 'Tanjung Pandan',
  },
  {
    id: '1704040009',
    districtId: '1704040',
    name: 'Tanjung Iman',
  },
  {
    id: '1704040010',
    districtId: '1704040',
    name: 'Penyandingan',
  },
  {
    id: '1704040011',
    districtId: '1704040',
    name: 'Kemang Manis',
  },
  {
    id: '1704040012',
    districtId: '1704040',
    name: 'Padang Hangat',
  },
  {
    id: '1704040013',
    districtId: '1704040',
    name: 'Pajar Bulan',
  },
  {
    id: '1704040014',
    districtId: '1704040',
    name: 'Suka Rami',
  },
  {
    id: '1704040015',
    districtId: '1704040',
    name: 'Sinar Jaya',
  },
  {
    id: '1704041001',
    districtId: '1704041',
    name: 'Benua Ratu',
  },
  {
    id: '1704041002',
    districtId: '1704041',
    name: 'Tuguk',
  },
  {
    id: '1704041003',
    districtId: '1704041',
    name: 'Umbul',
  },
  {
    id: '1704041004',
    districtId: '1704041',
    name: 'Tanjung Beringin',
  },
  {
    id: '1704041005',
    districtId: '1704041',
    name: 'Durian Besar',
  },
  {
    id: '1704041006',
    districtId: '1704041',
    name: 'Ganda Suli',
  },
  {
    id: '1704041007',
    districtId: '1704041',
    name: 'Padang Jati',
  },
  {
    id: '1704041008',
    districtId: '1704041',
    name: 'Cahaya Negeri',
  },
  {
    id: '1704041009',
    districtId: '1704041',
    name: 'Bangun Jiwa',
  },
  {
    id: '1704041010',
    districtId: '1704041',
    name: 'Kepahyang',
  },
  {
    id: '1704041011',
    districtId: '1704041',
    name: 'Pulau Panggung',
  },
  {
    id: '1704041012',
    districtId: '1704041',
    name: 'Serdang Indah',
  },
  {
    id: '1704042001',
    districtId: '1704042',
    name: 'Bukit Makmur',
  },
  {
    id: '1704042002',
    districtId: '1704042',
    name: 'Ulak Bandung',
  },
  {
    id: '1704042003',
    districtId: '1704042',
    name: 'Sumber Makmur',
  },
  {
    id: '1704042004',
    districtId: '1704042',
    name: 'Tri Tunggal Bhakti',
  },
  {
    id: '1704042005',
    districtId: '1704042',
    name: 'Muara Sahung',
  },
  {
    id: '1704042006',
    districtId: '1704042',
    name: 'Ulak Lebar',
  },
  {
    id: '1704042007',
    districtId: '1704042',
    name: 'Cinta Makmur',
  },
  {
    id: '1704050010',
    districtId: '1704050',
    name: 'Gedung Wani',
  },
  {
    id: '1704050011',
    districtId: '1704050',
    name: 'Geramat',
  },
  {
    id: '1704050012',
    districtId: '1704050',
    name: 'Penandingan',
  },
  {
    id: '1704050013',
    districtId: '1704050',
    name: 'Tanjung Alam',
  },
  {
    id: '1704050014',
    districtId: '1704050',
    name: 'Tanjung Baru',
  },
  {
    id: '1704050015',
    districtId: '1704050',
    name: 'Pengurung',
  },
  {
    id: '1704050016',
    districtId: '1704050',
    name: 'Pinang Jawa I',
  },
  {
    id: '1704050017',
    districtId: '1704050',
    name: 'Gunung Terang',
  },
  {
    id: '1704050018',
    districtId: '1704050',
    name: 'Talang Padang',
  },
  {
    id: '1704050019',
    districtId: '1704050',
    name: 'Gunung Megang',
  },
  {
    id: '1704050020',
    districtId: '1704050',
    name: 'Jawi',
  },
  {
    id: '1704050021',
    districtId: '1704050',
    name: 'Talang Berangin',
  },
  {
    id: '1704050023',
    districtId: '1704050',
    name: 'Pinang Jawa II',
  },
  {
    id: '1704050024',
    districtId: '1704050',
    name: 'Papahan',
  },
  {
    id: '1704051001',
    districtId: '1704051',
    name: 'Nusuk',
  },
  {
    id: '1704051002',
    districtId: '1704051',
    name: 'Tanjung Harapan',
  },
  {
    id: '1704051003',
    districtId: '1704051',
    name: 'Awat Mata',
  },
  {
    id: '1704051004',
    districtId: '1704051',
    name: 'Suka Merindu',
  },
  {
    id: '1704051005',
    districtId: '1704051',
    name: 'Mentiring I',
  },
  {
    id: '1704051006',
    districtId: '1704051',
    name: 'Lubuk Gung',
  },
  {
    id: '1704051007',
    districtId: '1704051',
    name: 'Cahaya Bathin',
  },
  {
    id: '1704051008',
    districtId: '1704051',
    name: 'Gunung Tiga I',
  },
  {
    id: '1704051009',
    districtId: '1704051',
    name: 'Karang Dapo',
  },
  {
    id: '1704051010',
    districtId: '1704051',
    name: 'Bunga Melur',
  },
  {
    id: '1704051012',
    districtId: '1704051',
    name: 'Gunung Tiga II',
  },
  {
    id: '1704051013',
    districtId: '1704051',
    name: 'Padang Panjang',
  },
  {
    id: '1704051015',
    districtId: '1704051',
    name: 'Masria Baru',
  },
  {
    id: '1704060001',
    districtId: '1704060',
    name: 'Beriang Tinggi',
  },
  {
    id: '1704060002',
    districtId: '1704060',
    name: 'Tanjung Bulan',
  },
  {
    id: '1704060003',
    districtId: '1704060',
    name: 'Padang Leban',
  },
  {
    id: '1704060004',
    districtId: '1704060',
    name: 'Tinggi Ari',
  },
  {
    id: '1704060005',
    districtId: '1704060',
    name: 'Tanjung Aur I',
  },
  {
    id: '1704060006',
    districtId: '1704060',
    name: 'Aur Ringit',
  },
  {
    id: '1704060007',
    districtId: '1704060',
    name: 'Tanjung Kemuning I',
  },
  {
    id: '1704060008',
    districtId: '1704060',
    name: 'Selika I',
  },
  {
    id: '1704060009',
    districtId: '1704060',
    name: 'Tanjung Iman I',
  },
  {
    id: '1704060010',
    districtId: '1704060',
    name: 'Pelajaran I',
  },
  {
    id: '1704060011',
    districtId: '1704060',
    name: 'Sulauwangi',
  },
  {
    id: '1704060012',
    districtId: '1704060',
    name: 'Padang Kedondong',
  },
  {
    id: '1704060013',
    districtId: '1704060',
    name: 'Selika II',
  },
  {
    id: '1704060014',
    districtId: '1704060',
    name: 'Pelajaran II',
  },
  {
    id: '1704060015',
    districtId: '1704060',
    name: 'Padang Tinggi',
  },
  {
    id: '1704060017',
    districtId: '1704060',
    name: 'Tanjung Kemuning II',
  },
  {
    id: '1704060018',
    districtId: '1704060',
    name: 'Tanjung Kemuning III',
  },
  {
    id: '1704060020',
    districtId: '1704060',
    name: 'Tanjung Aur II',
  },
  {
    id: '1704060022',
    districtId: '1704060',
    name: 'Tanjung Iman II',
  },
  {
    id: '1704060023',
    districtId: '1704060',
    name: 'Selika III',
  },
  {
    id: '1704061001',
    districtId: '1704061',
    name: 'Pagar Dewa',
  },
  {
    id: '1704061002',
    districtId: '1704061',
    name: 'Talang Tais',
  },
  {
    id: '1704061003',
    districtId: '1704061',
    name: 'Penantian',
  },
  {
    id: '1704061004',
    districtId: '1704061',
    name: 'Siring Agung',
  },
  {
    id: '1704061005',
    districtId: '1704061',
    name: 'Darat Sawah',
  },
  {
    id: '1704061006',
    districtId: '1704061',
    name: 'Sukarami I',
  },
  {
    id: '1704061007',
    districtId: '1704061',
    name: 'Rigangan I',
  },
  {
    id: '1704061008',
    districtId: '1704061',
    name: 'Rigangan II',
  },
  {
    id: '1704061009',
    districtId: '1704061',
    name: 'Rigangan III',
  },
  {
    id: '1704061010',
    districtId: '1704061',
    name: 'Tanjung Ganti I',
  },
  {
    id: '1704061011',
    districtId: '1704061',
    name: 'Tanjung Ganti II',
  },
  {
    id: '1704061012',
    districtId: '1704061',
    name: 'Talang Marap',
  },
  {
    id: '1704061014',
    districtId: '1704061',
    name: 'Sukarami II',
  },
  {
    id: '1704070027',
    districtId: '1704070',
    name: 'Padang Manis',
  },
  {
    id: '1704070028',
    districtId: '1704070',
    name: 'Gunung Agung',
  },
  {
    id: '1704070029',
    districtId: '1704070',
    name: 'Bandu Agung',
  },
  {
    id: '1704070031',
    districtId: '1704070',
    name: 'Simpang Tiga',
  },
  {
    id: '1704070032',
    districtId: '1704070',
    name: 'Guru Agung I',
  },
  {
    id: '1704070034',
    districtId: '1704070',
    name: 'Tanjung Betung I',
  },
  {
    id: '1704070040',
    districtId: '1704070',
    name: 'Pancur Negara',
  },
  {
    id: '1704070041',
    districtId: '1704070',
    name: 'Perugaian',
  },
  {
    id: '1704070042',
    districtId: '1704070',
    name: 'Coko Enau',
  },
  {
    id: '1704070043',
    districtId: '1704070',
    name: 'Tanjung Betung II',
  },
  {
    id: '1704070045',
    districtId: '1704070',
    name: 'Guru Agung II',
  },
  {
    id: '1704071001',
    districtId: '1704071',
    name: 'Gunung Kaya',
  },
  {
    id: '1704071002',
    districtId: '1704071',
    name: 'Ulak Agung',
  },
  {
    id: '1704071003',
    districtId: '1704071',
    name: 'Air Kering I',
  },
  {
    id: '1704071004',
    districtId: '1704071',
    name: 'Talang Padang',
  },
  {
    id: '1704071005',
    districtId: '1704071',
    name: 'Talang Jawi I',
  },
  {
    id: '1704071006',
    districtId: '1704071',
    name: 'Talang Jawi II',
  },
  {
    id: '1704071007',
    districtId: '1704071',
    name: 'Talang Besar',
  },
  {
    id: '1704071008',
    districtId: '1704071',
    name: 'Pulau Panggung',
  },
  {
    id: '1704071010',
    districtId: '1704071',
    name: 'Air Kering II',
  },
  {
    id: '1704072001',
    districtId: '1704072',
    name: 'Datar Lebar I',
  },
  {
    id: '1704072002',
    districtId: '1704072',
    name: 'Tanjung Bunian',
  },
  {
    id: '1704072003',
    districtId: '1704072',
    name: 'Sinar Bulan',
  },
  {
    id: '1704072004',
    districtId: '1704072',
    name: 'Suka Nanti',
  },
  {
    id: '1704072005',
    districtId: '1704072',
    name: 'Lawang Agung',
  },
  {
    id: '1704072006',
    districtId: '1704072',
    name: 'Tanjung Kurung',
  },
  {
    id: '1704072007',
    districtId: '1704072',
    name: 'Senak',
  },
  {
    id: '1704072009',
    districtId: '1704072',
    name: 'Datar Lebar II',
  },
  {
    id: '1704072010',
    districtId: '1704072',
    name: 'Aur Gading',
  },
  {
    id: '1704073001',
    districtId: '1704073',
    name: 'Pagar Gunung',
  },
  {
    id: '1704073002',
    districtId: '1704073',
    name: 'Cokoh Betung',
  },
  {
    id: '1704073003',
    districtId: '1704073',
    name: 'Pagar Alam',
  },
  {
    id: '1704073004',
    districtId: '1704073',
    name: 'Manau Sembilan I',
  },
  {
    id: '1704073005',
    districtId: '1704073',
    name: 'Manau Sembilan II',
  },
  {
    id: '1704073006',
    districtId: '1704073',
    name: 'Bungin Tambun I',
  },
  {
    id: '1704073007',
    districtId: '1704073',
    name: 'Bungin Tambun II',
  },
  {
    id: '1704073008',
    districtId: '1704073',
    name: 'Bungin Tambun III',
  },
  {
    id: '1704073009',
    districtId: '1704073',
    name: 'Naga Rantai',
  },
  {
    id: '1704073010',
    districtId: '1704073',
    name: 'Margo Mulyo',
  },
  {
    id: '1704073011',
    districtId: '1704073',
    name: 'Jati Mulyo',
  },
  {
    id: '1705010001',
    districtId: '1705010',
    name: 'Tedunan',
  },
  {
    id: '1705010002',
    districtId: '1705010',
    name: 'Kembang Mumpo',
  },
  {
    id: '1705010003',
    districtId: '1705010',
    name: 'Ketapang Baru',
  },
  {
    id: '1705010004',
    districtId: '1705010',
    name: 'Padang Bakung',
  },
  {
    id: '1705010005',
    districtId: '1705010',
    name: 'Talang Alai',
  },
  {
    id: '1705010006',
    districtId: '1705010',
    name: 'Jambat Akar',
  },
  {
    id: '1705010007',
    districtId: '1705010',
    name: 'Karang Anyar',
  },
  {
    id: '1705010008',
    districtId: '1705010',
    name: 'Ujung Padang',
  },
  {
    id: '1705010009',
    districtId: '1705010',
    name: 'Sendawar',
  },
  {
    id: '1705010010',
    districtId: '1705010',
    name: 'Gelombang',
  },
  {
    id: '1705010011',
    districtId: '1705010',
    name: 'Lubuk Betung',
  },
  {
    id: '1705010012',
    districtId: '1705010',
    name: 'Padang Peri',
  },
  {
    id: '1705010013',
    districtId: '1705010',
    name: 'Maras Tengah',
  },
  {
    id: '1705010014',
    districtId: '1705010',
    name: 'Gunung Kembang',
  },
  {
    id: '1705010015',
    districtId: '1705010',
    name: 'Gunung Bantan',
  },
  {
    id: '1705010016',
    districtId: '1705010',
    name: 'Genting Juar',
  },
  {
    id: '1705010017',
    districtId: '1705010',
    name: 'Padang Kelapo',
  },
  {
    id: '1705010018',
    districtId: '1705010',
    name: 'Talang Beringin',
  },
  {
    id: '1705010019',
    districtId: '1705010',
    name: 'Muara Maras',
  },
  {
    id: '1705010020',
    districtId: '1705010',
    name: 'Pematang Riding',
  },
  {
    id: '1705010021',
    districtId: '1705010',
    name: 'Muara Timput',
  },
  {
    id: '1705010022',
    districtId: '1705010',
    name: 'Serian Bandung',
  },
  {
    id: '1705010023',
    districtId: '1705010',
    name: 'Talang Kemang',
  },
  {
    id: '1705010024',
    districtId: '1705010',
    name: 'Rimbo Besar',
  },
  {
    id: '1705010025',
    districtId: '1705010',
    name: 'Karang Dapo',
  },
  {
    id: '1705010026',
    districtId: '1705010',
    name: 'Maras Bantan',
  },
  {
    id: '1705020001',
    districtId: '1705020',
    name: 'Maras Jauh',
  },
  {
    id: '1705020002',
    districtId: '1705020',
    name: 'Tebat Gunung',
  },
  {
    id: '1705020003',
    districtId: '1705020',
    name: 'Padang Serunaian',
  },
  {
    id: '1705020004',
    districtId: '1705020',
    name: 'Gunung Mesir',
  },
  {
    id: '1705020005',
    districtId: '1705020',
    name: 'Petai Kayu',
  },
  {
    id: '1705020006',
    districtId: '1705020',
    name: 'Nanjungan',
  },
  {
    id: '1705020007',
    districtId: '1705020',
    name: 'Bandung Agung',
  },
  {
    id: '1705020008',
    districtId: '1705020',
    name: 'Pinju Layang',
  },
  {
    id: '1705020009',
    districtId: '1705020',
    name: 'Nanti Agung',
  },
  {
    id: '1705020010',
    districtId: '1705020',
    name: 'Pajar Bulan',
  },
  {
    id: '1705020011',
    districtId: '1705020',
    name: 'Rantau Panjang',
  },
  {
    id: '1705020012',
    districtId: '1705020',
    name: 'Talang Durian',
  },
  {
    id: '1705020013',
    districtId: '1705020',
    name: 'Air Melancar',
  },
  {
    id: '1705020014',
    districtId: '1705020',
    name: 'Cugung Langu',
  },
  {
    id: '1705020015',
    districtId: '1705020',
    name: 'Renah Gajah Mati 1',
  },
  {
    id: '1705020016',
    districtId: '1705020',
    name: 'Muara Dua',
  },
  {
    id: '1705020017',
    districtId: '1705020',
    name: 'Renah Gajah Mati II',
  },
  {
    id: '1705020018',
    districtId: '1705020',
    name: 'Kayu Elang',
  },
  {
    id: '1705020019',
    districtId: '1705020',
    name: 'Napalan',
  },
  {
    id: '1705020020',
    districtId: '1705020',
    name: 'Mekar Sari Mukti',
  },
  {
    id: '1705020021',
    districtId: '1705020',
    name: 'Suban',
  },
  {
    id: '1705020022',
    districtId: '1705020',
    name: 'Telatan',
  },
  {
    id: '1705020023',
    districtId: '1705020',
    name: 'Kemang Manis',
  },
  {
    id: '1705020024',
    districtId: '1705020',
    name: 'Gunung Megang',
  },
  {
    id: '1705030043',
    districtId: '1705030',
    name: 'Kembang Seri',
  },
  {
    id: '1705030044',
    districtId: '1705030',
    name: 'Lubuk Gio',
  },
  {
    id: '1705030045',
    districtId: '1705030',
    name: 'Muara Danau',
  },
  {
    id: '1705030048',
    districtId: '1705030',
    name: 'Durian Bubur',
  },
  {
    id: '1705030049',
    districtId: '1705030',
    name: 'Masmambang',
  },
  {
    id: '1705030050',
    districtId: '1705030',
    name: 'Serambi Gunung',
  },
  {
    id: '1705030051',
    districtId: '1705030',
    name: 'Air Payangan',
  },
  {
    id: '1705030052',
    districtId: '1705030',
    name: 'Batu Tugu',
  },
  {
    id: '1705030053',
    districtId: '1705030',
    name: 'Air Teras',
  },
  {
    id: '1705030054',
    districtId: '1705030',
    name: 'Bunut Tinggi',
  },
  {
    id: '1705030055',
    districtId: '1705030',
    name: 'Lubuk Gadis',
  },
  {
    id: '1705030056',
    districtId: '1705030',
    name: 'Kampai',
  },
  {
    id: '1705030057',
    districtId: '1705030',
    name: 'Lubuk Ngantungan',
  },
  {
    id: '1705030058',
    districtId: '1705030',
    name: 'Napal Melintang',
  },
  {
    id: '1705030059',
    districtId: '1705030',
    name: 'Simpang Tiga Pagar Gasing',
  },
  {
    id: '1705030060',
    districtId: '1705030',
    name: 'Harapan Mulya',
  },
  {
    id: '1705031001',
    districtId: '1705031',
    name: 'Dusun Baru',
  },
  {
    id: '1705031002',
    districtId: '1705031',
    name: 'Padang Batu',
  },
  {
    id: '1705031003',
    districtId: '1705031',
    name: 'Penago I',
  },
  {
    id: '1705031004',
    districtId: '1705031',
    name: 'Penago Baru',
  },
  {
    id: '1705031005',
    districtId: '1705031',
    name: 'Rawa Indah',
  },
  {
    id: '1705031006',
    districtId: '1705031',
    name: 'Tanah Abang',
  },
  {
    id: '1705031007',
    districtId: '1705031',
    name: 'Penago II',
  },
  {
    id: '1705031008',
    districtId: '1705031',
    name: 'Talang Kabu',
  },
  {
    id: '1705031009',
    districtId: '1705031',
    name: 'Talang Panjang',
  },
  {
    id: '1705031010',
    districtId: '1705031',
    name: 'Padang Cekur',
  },
  {
    id: '1705031011',
    districtId: '1705031',
    name: 'Nanti Agung',
  },
  {
    id: '1705031012',
    districtId: '1705031',
    name: 'Pasar Talo',
  },
  {
    id: '1705031013',
    districtId: '1705031',
    name: 'Margo Sari',
  },
  {
    id: '1705031014',
    districtId: '1705031',
    name: 'Paluh Terap',
  },
  {
    id: '1705031015',
    districtId: '1705031',
    name: 'Mekar Sari',
  },
  {
    id: '1705032001',
    districtId: '1705032',
    name: 'Pering Baru',
  },
  {
    id: '1705032002',
    districtId: '1705032',
    name: 'Suka Merindu',
  },
  {
    id: '1705032003',
    districtId: '1705032',
    name: 'Suka Bulan',
  },
  {
    id: '1705032004',
    districtId: '1705032',
    name: 'Talang Padang',
  },
  {
    id: '1705032005',
    districtId: '1705032',
    name: 'Taba',
  },
  {
    id: '1705032006',
    districtId: '1705032',
    name: 'Bakal Dalam',
  },
  {
    id: '1705032007',
    districtId: '1705032',
    name: 'Sungai Petai',
  },
  {
    id: '1705032008',
    districtId: '1705032',
    name: 'Lubuk Lagan',
  },
  {
    id: '1705032009',
    districtId: '1705032',
    name: 'Napalan',
  },
  {
    id: '1705032010',
    districtId: '1705032',
    name: 'Tebat Sibun',
  },
  {
    id: '1705032011',
    districtId: '1705032',
    name: 'Batu Balai',
  },
  {
    id: '1705033001',
    districtId: '1705033',
    name: 'Pagar',
  },
  {
    id: '1705033002',
    districtId: '1705033',
    name: 'Banyu Kencana',
  },
  {
    id: '1705033003',
    districtId: '1705033',
    name: 'Pagar Agung',
  },
  {
    id: '1705033004',
    districtId: '1705033',
    name: 'Air Keruh',
  },
  {
    id: '1705033005',
    districtId: '1705033',
    name: 'Muara Simpur',
  },
  {
    id: '1705033006',
    districtId: '1705033',
    name: 'Hargo Binangun',
  },
  {
    id: '1705033007',
    districtId: '1705033',
    name: 'Simpur Ijang',
  },
  {
    id: '1705033008',
    districtId: '1705033',
    name: 'Mekar Jaya',
  },
  {
    id: '1705033009',
    districtId: '1705033',
    name: 'Giri Nanto',
  },
  {
    id: '1705033010',
    districtId: '1705033',
    name: 'Giri Mulya',
  },
  {
    id: '1705033011',
    districtId: '1705033',
    name: 'Pagar Banyu',
  },
  {
    id: '1705033012',
    districtId: '1705033',
    name: 'Tanjung Agung',
  },
  {
    id: '1705033013',
    districtId: '1705033',
    name: 'Muara Nibung',
  },
  {
    id: '1705040020',
    districtId: '1705040',
    name: 'Napal',
  },
  {
    id: '1705040021',
    districtId: '1705040',
    name: 'Talang Dantuk',
  },
  {
    id: '1705040027',
    districtId: '1705040',
    name: 'Dusun Baru',
  },
  {
    id: '1705040028',
    districtId: '1705040',
    name: 'Talang Saling',
  },
  {
    id: '1705040029',
    districtId: '1705040',
    name: 'Lubuk Lintang',
  },
  {
    id: '1705040030',
    districtId: '1705040',
    name: 'Pasar Tais',
  },
  {
    id: '1705040031',
    districtId: '1705040',
    name: 'Lubuk Kebur',
  },
  {
    id: '1705041001',
    districtId: '1705041',
    name: 'Tanjung Seluai',
  },
  {
    id: '1705041002',
    districtId: '1705041',
    name: 'Rimbo Kedui',
  },
  {
    id: '1705041003',
    districtId: '1705041',
    name: 'Sido Mulyo',
  },
  {
    id: '1705041004',
    districtId: '1705041',
    name: 'Padang Rambun',
  },
  {
    id: '1705041005',
    districtId: '1705041',
    name: 'Pasar Seluma',
  },
  {
    id: '1705041006',
    districtId: '1705041',
    name: 'Suka Rami',
  },
  {
    id: '1705041007',
    districtId: '1705041',
    name: 'Tangga Batu',
  },
  {
    id: '1705041008',
    districtId: '1705041',
    name: 'Padang Genting',
  },
  {
    id: '1705041009',
    districtId: '1705041',
    name: 'Sengkuang',
  },
  {
    id: '1705041010',
    districtId: '1705041',
    name: 'Tanjung Seru',
  },
  {
    id: '1705041011',
    districtId: '1705041',
    name: 'Tanjungan',
  },
  {
    id: '1705041012',
    districtId: '1705041',
    name: 'Padang Merbau',
  },
  {
    id: '1705042001',
    districtId: '1705042',
    name: 'Purbosari',
  },
  {
    id: '1705042002',
    districtId: '1705042',
    name: 'Talang Perapat',
  },
  {
    id: '1705042003',
    districtId: '1705042',
    name: 'Air Latak',
  },
  {
    id: '1705042004',
    districtId: '1705042',
    name: 'Pagar Agung',
  },
  {
    id: '1705042005',
    districtId: '1705042',
    name: 'Talang Tinggi',
  },
  {
    id: '1705042006',
    districtId: '1705042',
    name: 'Lunjuk',
  },
  {
    id: '1705042007',
    districtId: '1705042',
    name: 'Lubuk Lagan',
  },
  {
    id: '1705042008',
    districtId: '1705042',
    name: 'Tanjung Agung',
  },
  {
    id: '1705042009',
    districtId: '1705042',
    name: 'Sengkuang Jaya',
  },
  {
    id: '1705043001',
    districtId: '1705043',
    name: 'Tenangan',
  },
  {
    id: '1705043002',
    districtId: '1705043',
    name: 'Rawasari',
  },
  {
    id: '1705043003',
    districtId: '1705043',
    name: 'Talang Sali',
  },
  {
    id: '1705043004',
    districtId: '1705043',
    name: 'Kunduran',
  },
  {
    id: '1705043005',
    districtId: '1705043',
    name: 'Kota Agung',
  },
  {
    id: '1705043006',
    districtId: '1705043',
    name: 'Selebar',
  },
  {
    id: '1705043007',
    districtId: '1705043',
    name: 'Sembayat',
  },
  {
    id: '1705043008',
    districtId: '1705043',
    name: 'Bunga Mas',
  },
  {
    id: '1705044001',
    districtId: '1705044',
    name: 'Simpang',
  },
  {
    id: '1705044002',
    districtId: '1705044',
    name: 'Selingsingan',
  },
  {
    id: '1705044003',
    districtId: '1705044',
    name: 'Puguk',
  },
  {
    id: '1705044004',
    districtId: '1705044',
    name: 'Pandan',
  },
  {
    id: '1705044005',
    districtId: '1705044',
    name: 'Talang Beringin',
  },
  {
    id: '1705044006',
    districtId: '1705044',
    name: 'Talang Rami',
  },
  {
    id: '1705044007',
    districtId: '1705044',
    name: 'Lubuk Resam',
  },
  {
    id: '1705044008',
    districtId: '1705044',
    name: 'Sekalak',
  },
  {
    id: '1705044009',
    districtId: '1705044',
    name: 'Sinar Pagi',
  },
  {
    id: '1705044010',
    districtId: '1705044',
    name: 'Talang Empat',
  },
  {
    id: '1705050011',
    districtId: '1705050',
    name: 'Sukaraja',
  },
  {
    id: '1705050012',
    districtId: '1705050',
    name: 'Lubuk Sahung',
  },
  {
    id: '1705050014',
    districtId: '1705050',
    name: 'Bukit Peninjauan II',
  },
  {
    id: '1705050015',
    districtId: '1705050',
    name: 'Padang Pelawi',
  },
  {
    id: '1705050016',
    districtId: '1705050',
    name: 'Kayu Arang',
  },
  {
    id: '1705050017',
    districtId: '1705050',
    name: 'N I U R',
  },
  {
    id: '1705050018',
    districtId: '1705050',
    name: 'Cahaya Negeri',
  },
  {
    id: '1705050019',
    districtId: '1705050',
    name: 'Bukit Peninjauan I',
  },
  {
    id: '1705050020',
    districtId: '1705050',
    name: 'Riak Siabun',
  },
  {
    id: '1705050021',
    districtId: '1705050',
    name: 'Jenggalu',
  },
  {
    id: '1705050022',
    districtId: '1705050',
    name: 'Babatan',
  },
  {
    id: '1705050033',
    districtId: '1705050',
    name: 'Sido Sari',
  },
  {
    id: '1705050034',
    districtId: '1705050',
    name: 'Sari Mulyo',
  },
  {
    id: '1705050035',
    districtId: '1705050',
    name: 'Sido Luhur',
  },
  {
    id: '1705050036',
    districtId: '1705050',
    name: 'Sumber Arum',
  },
  {
    id: '1705050037',
    districtId: '1705050',
    name: 'Riak Siabun I',
  },
  {
    id: '1705050038',
    districtId: '1705050',
    name: 'Padang Kuas',
  },
  {
    id: '1705050039',
    districtId: '1705050',
    name: 'Kuti Agung',
  },
  {
    id: '1705050040',
    districtId: '1705050',
    name: 'Air Kemuning',
  },
  {
    id: '1705050041',
    districtId: '1705050',
    name: 'Air Petai',
  },
  {
    id: '1705050042',
    districtId: '1705050',
    name: 'Sumber Makmur',
  },
  {
    id: '1705051001',
    districtId: '1705051',
    name: 'Pasar Ngalam',
  },
  {
    id: '1705051002',
    districtId: '1705051',
    name: 'Sukasari',
  },
  {
    id: '1705051003',
    districtId: '1705051',
    name: 'Tawang Rejo',
  },
  {
    id: '1705051004',
    districtId: '1705051',
    name: 'Kungkai Baru',
  },
  {
    id: '1705051005',
    districtId: '1705051',
    name: 'Keban Agung',
  },
  {
    id: '1705051006',
    districtId: '1705051',
    name: 'Lawang Agung',
  },
  {
    id: '1705051007',
    districtId: '1705051',
    name: 'Padang Pelasan',
  },
  {
    id: '1705051008',
    districtId: '1705051',
    name: 'Air Periukan',
  },
  {
    id: '1705051009',
    districtId: '1705051',
    name: 'Dermayu',
  },
  {
    id: '1705051010',
    districtId: '1705051',
    name: 'Suka Maju',
  },
  {
    id: '1705051011',
    districtId: '1705051',
    name: 'Talang Benuang',
  },
  {
    id: '1705051012',
    districtId: '1705051',
    name: 'Talang Alai',
  },
  {
    id: '1705051013',
    districtId: '1705051',
    name: 'Lubuk Gilang',
  },
  {
    id: '1705051014',
    districtId: '1705051',
    name: 'Talang Sebaris',
  },
  {
    id: '1705051015',
    districtId: '1705051',
    name: 'Lokasi Baru',
  },
  {
    id: '1705051016',
    districtId: '1705051',
    name: 'Taba Lubuk Puding',
  },
  {
    id: '1705052001',
    districtId: '1705052',
    name: 'Tumbuan',
  },
  {
    id: '1705052002',
    districtId: '1705052',
    name: 'Renah Panjang',
  },
  {
    id: '1705052003',
    districtId: '1705052',
    name: 'Gunung Agung',
  },
  {
    id: '1705052004',
    districtId: '1705052',
    name: 'Padang Capo Ulu',
  },
  {
    id: '1705052005',
    districtId: '1705052',
    name: 'Talang Giring',
  },
  {
    id: '1705052006',
    districtId: '1705052',
    name: 'Tanjung Kuaw',
  },
  {
    id: '1705052007',
    districtId: '1705052',
    name: 'Dusun Tengah',
  },
  {
    id: '1705052008',
    districtId: '1705052',
    name: 'Talang Kebun',
  },
  {
    id: '1705052009',
    districtId: '1705052',
    name: 'Arang Sapat',
  },
  {
    id: '1705052010',
    districtId: '1705052',
    name: 'Napal Jungur',
  },
  {
    id: '1705052011',
    districtId: '1705052',
    name: 'Cawang',
  },
  {
    id: '1705052012',
    districtId: '1705052',
    name: 'Padang Capo Ilir',
  },
  {
    id: '1705052013',
    districtId: '1705052',
    name: 'Sakaian',
  },
  {
    id: '1705052014',
    districtId: '1705052',
    name: 'Lubuk Terentang',
  },
  {
    id: '1706010016',
    districtId: '1706010',
    name: 'Air Buluh',
  },
  {
    id: '1706010017',
    districtId: '1706010',
    name: 'Pulau Baru',
  },
  {
    id: '1706010018',
    districtId: '1706010',
    name: 'Semundam',
  },
  {
    id: '1706010019',
    districtId: '1706010',
    name: 'Tanjung Jaya',
  },
  {
    id: '1706010020',
    districtId: '1706010',
    name: 'Dusun Sibak',
  },
  {
    id: '1706010021',
    districtId: '1706010',
    name: 'Medan Jaya',
  },
  {
    id: '1706010022',
    districtId: '1706010',
    name: 'Tanjung Harapan',
  },
  {
    id: '1706010023',
    districtId: '1706010',
    name: 'Pasar Ipuh',
  },
  {
    id: '1706010024',
    districtId: '1706010',
    name: 'Manunggal Jaya',
  },
  {
    id: '1706010025',
    districtId: '1706010',
    name: 'Retak Hilir',
  },
  {
    id: '1706010028',
    districtId: '1706010',
    name: 'Pulai Payung',
  },
  {
    id: '1706010029',
    districtId: '1706010',
    name: 'Tanjung Medan',
  },
  {
    id: '1706010030',
    districtId: '1706010',
    name: 'Tirta Mulya',
  },
  {
    id: '1706010031',
    districtId: '1706010',
    name: 'Pasar Baru',
  },
  {
    id: '1706010032',
    districtId: '1706010',
    name: 'Pulau Makmur',
  },
  {
    id: '1706010033',
    districtId: '1706010',
    name: 'Mundam Marap',
  },
  {
    id: '1706011001',
    districtId: '1706011',
    name: 'Air Rami',
  },
  {
    id: '1706011002',
    districtId: '1706011',
    name: 'Rami Mulia',
  },
  {
    id: '1706011003',
    districtId: '1706011',
    name: 'Mekar Jaya',
  },
  {
    id: '1706011004',
    districtId: '1706011',
    name: 'Dusun Pulau',
  },
  {
    id: '1706011005',
    districtId: '1706011',
    name: 'Talang Rio',
  },
  {
    id: '1706011006',
    districtId: '1706011',
    name: 'Arga Jaya',
  },
  {
    id: '1706011007',
    districtId: '1706011',
    name: 'Ipuh II/Ce Sp IV /Makmur Jaya',
  },
  {
    id: '1706011008',
    districtId: '1706011',
    name: 'Marga Mulia',
  },
  {
    id: '1706011009',
    districtId: '1706011',
    name: 'Bukit Harapan',
  },
  {
    id: '1706011010',
    districtId: '1706011',
    name: 'Tirta Kencana',
  },
  {
    id: '1706011011',
    districtId: '1706011',
    name: 'Bukit Mulya',
  },
  {
    id: '1706011012',
    districtId: '1706011',
    name: 'Cinta Asih',
  },
  {
    id: '1706012001',
    districtId: '1706012',
    name: 'Semambang Makmur',
  },
  {
    id: '1706012002',
    districtId: '1706012',
    name: 'Gajah Makmur',
  },
  {
    id: '1706012003',
    districtId: '1706012',
    name: 'Lubuk Talang',
  },
  {
    id: '1706012004',
    districtId: '1706012',
    name: 'Serami Baru',
  },
  {
    id: '1706012005',
    districtId: '1706012',
    name: 'Talang Arah',
  },
  {
    id: '1706012006',
    districtId: '1706012',
    name: 'Talang Baru',
  },
  {
    id: '1706012007',
    districtId: '1706012',
    name: 'Air Merah',
  },
  {
    id: '1706012008',
    districtId: '1706012',
    name: 'UPT Lubuk Talang',
  },
  {
    id: '1706020005',
    districtId: '1706020',
    name: 'Air Hitam',
  },
  {
    id: '1706020006',
    districtId: '1706020',
    name: 'Dusun Tunggang',
  },
  {
    id: '1706020007',
    districtId: '1706020',
    name: 'Air Berau',
  },
  {
    id: '1706020008',
    districtId: '1706020',
    name: 'Pondok Suguh',
  },
  {
    id: '1706020010',
    districtId: '1706020',
    name: 'Air Bikuk',
  },
  {
    id: '1706020011',
    districtId: '1706020',
    name: 'Sinar Laut',
  },
  {
    id: '1706020013',
    districtId: '1706020',
    name: 'Lubuk Bento',
  },
  {
    id: '1706020014',
    districtId: '1706020',
    name: 'Pondok Kandang',
  },
  {
    id: '1706020022',
    districtId: '1706020',
    name: 'Bumi Mekar Jaya',
  },
  {
    id: '1706020023',
    districtId: '1706020',
    name: 'Karya Mulya',
  },
  {
    id: '1706020024',
    districtId: '1706020',
    name: 'Teluk Bakung',
  },
  {
    id: '1706021001',
    districtId: '1706021',
    name: 'Padang Gading',
  },
  {
    id: '1706021002',
    districtId: '1706021',
    name: 'Retak Mudik',
  },
  {
    id: '1706021003',
    districtId: '1706021',
    name: 'Mekar Sari',
  },
  {
    id: '1706021004',
    districtId: '1706021',
    name: 'Gajah Mati',
  },
  {
    id: '1706021005',
    districtId: '1706021',
    name: 'Sumber Makmur',
  },
  {
    id: '1706021006',
    districtId: '1706021',
    name: 'Talang Gading',
  },
  {
    id: '1706021007',
    districtId: '1706021',
    name: 'Sidodadi',
  },
  {
    id: '1706021008',
    districtId: '1706021',
    name: 'Gading Jaya',
  },
  {
    id: '1706021009',
    districtId: '1706021',
    name: 'Banjar Sari',
  },
  {
    id: '1706022001',
    districtId: '1706022',
    name: 'Pasar Bantal',
  },
  {
    id: '1706022002',
    districtId: '1706022',
    name: 'Teramang Jaya',
  },
  {
    id: '1706022003',
    districtId: '1706022',
    name: 'Nenggalo',
  },
  {
    id: '1706022004',
    districtId: '1706022',
    name: 'Pondok Baru',
  },
  {
    id: '1706022005',
    districtId: '1706022',
    name: 'Bunga Tanjung',
  },
  {
    id: '1706022006',
    districtId: '1706022',
    name: 'Sido Makmur',
  },
  {
    id: '1706022007',
    districtId: '1706022',
    name: 'Lubuk Selandak',
  },
  {
    id: '1706022008',
    districtId: '1706022',
    name: 'Bandar Jaya',
  },
  {
    id: '1706022009',
    districtId: '1706022',
    name: 'Mandi Angin Jaya',
  },
  {
    id: '1706022010',
    districtId: '1706022',
    name: 'Nelan Indah',
  },
  {
    id: '1706022011',
    districtId: '1706022',
    name: 'Pernyah',
  },
  {
    id: '1706022012',
    districtId: '1706022',
    name: 'Batu Ejung',
  },
  {
    id: '1706022013',
    districtId: '1706022',
    name: 'Brangan Mulya',
  },
  {
    id: '1706030012',
    districtId: '1706030',
    name: 'Teras Terunjam',
  },
  {
    id: '1706030013',
    districtId: '1706030',
    name: 'Setia Budi',
  },
  {
    id: '1706030014',
    districtId: '1706030',
    name: 'Pondok Kopi',
  },
  {
    id: '1706030015',
    districtId: '1706030',
    name: 'Tunggal Jaya',
  },
  {
    id: '1706030022',
    districtId: '1706030',
    name: 'Mekar Jaya',
  },
  {
    id: '1706030023',
    districtId: '1706030',
    name: 'Karang Jaya',
  },
  {
    id: '1706030024',
    districtId: '1706030',
    name: 'Teruntung',
  },
  {
    id: '1706030025',
    districtId: '1706030',
    name: 'Telang Kuning',
  },
  {
    id: '1706031001',
    districtId: '1706031',
    name: 'Bumi Mulya',
  },
  {
    id: '1706031002',
    districtId: '1706031',
    name: 'Penarik',
  },
  {
    id: '1706031003',
    districtId: '1706031',
    name: 'Lubuk Mukti',
  },
  {
    id: '1706031004',
    districtId: '1706031',
    name: 'Suka Maju',
  },
  {
    id: '1706031005',
    districtId: '1706031',
    name: 'Bukit Makmur',
  },
  {
    id: '1706031006',
    districtId: '1706031',
    name: 'Sumber Mulya',
  },
  {
    id: '1706031007',
    districtId: '1706031',
    name: 'Wonosobo',
  },
  {
    id: '1706031008',
    districtId: '1706031',
    name: 'Mekar Mulya',
  },
  {
    id: '1706031009',
    districtId: '1706031',
    name: 'Sido Mulyo',
  },
  {
    id: '1706031010',
    districtId: '1706031',
    name: 'Marga Mukti',
  },
  {
    id: '1706031011',
    districtId: '1706031',
    name: 'Sidodadi',
  },
  {
    id: '1706031012',
    districtId: '1706031',
    name: 'Maju Makmur',
  },
  {
    id: '1706031013',
    districtId: '1706031',
    name: 'Sendang Mulyo',
  },
  {
    id: '1706031014',
    districtId: '1706031',
    name: 'Marga Mulya',
  },
  {
    id: '1706032001',
    districtId: '1706032',
    name: 'Sungai Jerinjing',
  },
  {
    id: '1706032002',
    districtId: '1706032',
    name: 'Pondok Baru',
  },
  {
    id: '1706032003',
    districtId: '1706032',
    name: 'Sungai Ipuh',
  },
  {
    id: '1706032004',
    districtId: '1706032',
    name: 'Sungai Gading',
  },
  {
    id: '1706032005',
    districtId: '1706032',
    name: 'Surian Bungkal',
  },
  {
    id: '1706032006',
    districtId: '1706032',
    name: 'Lubuk Sahung',
  },
  {
    id: '1706032007',
    districtId: '1706032',
    name: 'Lubuk Bangko',
  },
  {
    id: '1706032008',
    districtId: '1706032',
    name: 'Talang Buai',
  },
  {
    id: '1706032009',
    districtId: '1706032',
    name: 'Aur Cina',
  },
  {
    id: '1706032010',
    districtId: '1706032',
    name: 'Sungai Ipuh Satu',
  },
  {
    id: '1706032011',
    districtId: '1706032',
    name: 'Sungai Ipuh Dua',
  },
  {
    id: '1706032012',
    districtId: '1706032',
    name: 'Talang Medan',
  },
  {
    id: '1706040005',
    districtId: '1706040',
    name: 'Tanah Rekah',
  },
  {
    id: '1706040006',
    districtId: '1706040',
    name: 'Pasar Mukomuko',
  },
  {
    id: '1706040007',
    districtId: '1706040',
    name: 'Ujung Padang',
  },
  {
    id: '1706040008',
    districtId: '1706040',
    name: 'Pondok Batu',
  },
  {
    id: '1706040009',
    districtId: '1706040',
    name: 'Selagan Jaya',
  },
  {
    id: '1706040014',
    districtId: '1706040',
    name: 'Pasar Sebelah',
  },
  {
    id: '1706040033',
    districtId: '1706040',
    name: 'Koto Jaya',
  },
  {
    id: '1706040034',
    districtId: '1706040',
    name: 'Bandar Ratu',
  },
  {
    id: '1706040035',
    districtId: '1706040',
    name: 'Tanah Harapan',
  },
  {
    id: '1706041001',
    districtId: '1706041',
    name: 'Air Dikit',
  },
  {
    id: '1706041002',
    districtId: '1706041',
    name: 'Pondok Lunang',
  },
  {
    id: '1706041003',
    districtId: '1706041',
    name: 'Dusun Baru V Koto',
  },
  {
    id: '1706041004',
    districtId: '1706041',
    name: 'Sari Bulan',
  },
  {
    id: '1706041005',
    districtId: '1706041',
    name: 'Sari Makmur',
  },
  {
    id: '1706041006',
    districtId: '1706041',
    name: 'Sumber Sari',
  },
  {
    id: '1706041007',
    districtId: '1706041',
    name: 'Air Kasai',
  },
  {
    id: '1706042001',
    districtId: '1706042',
    name: 'Rawa Mulya',
  },
  {
    id: '1706042002',
    districtId: '1706042',
    name: 'Dusun Baru Pelokan',
  },
  {
    id: '1706042003',
    districtId: '1706042',
    name: 'Lubuk Sanai',
  },
  {
    id: '1706042004',
    districtId: '1706042',
    name: 'Pauh Terenjah',
  },
  {
    id: '1706042005',
    districtId: '1706042',
    name: 'Tanjung Mulya',
  },
  {
    id: '1706042006',
    districtId: '1706042',
    name: 'Rawa Bangun',
  },
  {
    id: '1706042007',
    districtId: '1706042',
    name: 'Lubuk Sanai II',
  },
  {
    id: '1706042008',
    districtId: '1706042',
    name: 'Lubuk Sanai III',
  },
  {
    id: '1706050001',
    districtId: '1706050',
    name: 'Sumber Makmur',
  },
  {
    id: '1706050002',
    districtId: '1706050',
    name: 'Tanjung Alai',
  },
  {
    id: '1706050003',
    districtId: '1706050',
    name: 'Lubuk Gedang',
  },
  {
    id: '1706050010',
    districtId: '1706050',
    name: 'Arah Tiga',
  },
  {
    id: '1706050011',
    districtId: '1706050',
    name: 'Lubuk Pinang',
  },
  {
    id: '1706050012',
    districtId: '1706050',
    name: 'Suka Pindah',
  },
  {
    id: '1706050018',
    districtId: '1706050',
    name: 'Ranah Karya',
  },
  {
    id: '1706051001',
    districtId: '1706051',
    name: 'Agung Jaya',
  },
  {
    id: '1706051002',
    districtId: '1706051',
    name: 'Pondok Makmur',
  },
  {
    id: '1706051003',
    districtId: '1706051',
    name: 'Manjunto Jaya',
  },
  {
    id: '1706051004',
    districtId: '1706051',
    name: 'Tirta Makmur',
  },
  {
    id: '1706051005',
    districtId: '1706051',
    name: 'Tirta Mulya',
  },
  {
    id: '1706051006',
    districtId: '1706051',
    name: 'Kota Praja',
  },
  {
    id: '1706051007',
    districtId: '1706051',
    name: 'Sinar Jaya',
  },
  {
    id: '1706051008',
    districtId: '1706051',
    name: 'Sido Makmur',
  },
  {
    id: '1706052001',
    districtId: '1706052',
    name: 'Pondok Tengah',
  },
  {
    id: '1706052002',
    districtId: '1706052',
    name: 'Sungai Lintang',
  },
  {
    id: '1706052003',
    districtId: '1706052',
    name: 'Talang Petai',
  },
  {
    id: '1706052004',
    districtId: '1706052',
    name: 'Lalang Luas',
  },
  {
    id: '1706052005',
    districtId: '1706052',
    name: 'Rasno',
  },
  {
    id: '1706052006',
    districtId: '1706052',
    name: 'Pondok Panjang',
  },
  {
    id: '1706052007',
    districtId: '1706052',
    name: 'Talang Sakti',
  },
  {
    id: '1706052008',
    districtId: '1706052',
    name: 'Talang Sepakat',
  },
  {
    id: '1706052009',
    districtId: '1706052',
    name: 'Lubuk Cabau',
  },
  {
    id: '1706052010',
    districtId: '1706052',
    name: 'Sungai Rengas',
  },
  {
    id: '1707010001',
    districtId: '1707010',
    name: 'Bioa Sengok',
  },
  {
    id: '1707010002',
    districtId: '1707010',
    name: 'Rimbo Pengadang',
  },
  {
    id: '1707010003',
    districtId: '1707010',
    name: 'Teluk Dien',
  },
  {
    id: '1707010009',
    districtId: '1707010',
    name: 'Talang Ratu',
  },
  {
    id: '1707010011',
    districtId: '1707010',
    name: 'Tik Kuto',
  },
  {
    id: '1707010012',
    districtId: '1707010',
    name: 'Bajok',
  },
  {
    id: '1707011001',
    districtId: '1707011',
    name: 'Topos',
  },
  {
    id: '1707011002',
    districtId: '1707011',
    name: 'Tik Sirong',
  },
  {
    id: '1707011003',
    districtId: '1707011',
    name: 'Suka Negeri',
  },
  {
    id: '1707011004',
    districtId: '1707011',
    name: 'Ajai Siang',
  },
  {
    id: '1707011005',
    districtId: '1707011',
    name: 'Talang Donok',
  },
  {
    id: '1707011006',
    districtId: '1707011',
    name: 'Talang Donok I',
  },
  {
    id: '1707011007',
    districtId: '1707011',
    name: 'Talang Baru I',
  },
  {
    id: '1707011008',
    districtId: '1707011',
    name: 'Talang Baru II',
  },
  {
    id: '1707020010',
    districtId: '1707020',
    name: 'Suka Sari',
  },
  {
    id: '1707020011',
    districtId: '1707020',
    name: 'Kutai Donok',
  },
  {
    id: '1707020012',
    districtId: '1707020',
    name: 'Mangkurajo',
  },
  {
    id: '1707020013',
    districtId: '1707020',
    name: 'T E S',
  },
  {
    id: '1707020014',
    districtId: '1707020',
    name: 'Taba Anyar',
  },
  {
    id: '1707020015',
    districtId: '1707020',
    name: 'Turan Tiging',
  },
  {
    id: '1707020016',
    districtId: '1707020',
    name: 'Mubai',
  },
  {
    id: '1707020017',
    districtId: '1707020',
    name: 'Turan Lalang',
  },
  {
    id: '1707020026',
    districtId: '1707020',
    name: 'Tik Jeniak',
  },
  {
    id: '1707020027',
    districtId: '1707020',
    name: 'Manai Blau',
  },
  {
    id: '1707021001',
    districtId: '1707021',
    name: 'Karang Dapo Atas',
  },
  {
    id: '1707021002',
    districtId: '1707021',
    name: 'Bukit Nibung',
  },
  {
    id: '1707021003',
    districtId: '1707021',
    name: 'Karang Dapo Bawah',
  },
  {
    id: '1707021004',
    districtId: '1707021',
    name: 'Pungguk Pedaro',
  },
  {
    id: '1707021005',
    districtId: '1707021',
    name: 'Talang Kerinci',
  },
  {
    id: '1707021006',
    districtId: '1707021',
    name: 'Pelabuhan Talang Liak',
  },
  {
    id: '1707021007',
    districtId: '1707021',
    name: 'Talang Liak I',
  },
  {
    id: '1707021008',
    districtId: '1707021',
    name: 'Talang Liak II',
  },
  {
    id: '1707021009',
    districtId: '1707021',
    name: 'Bungin',
  },
  {
    id: '1707030001',
    districtId: '1707030',
    name: 'Semelako Atas',
  },
  {
    id: '1707030002',
    districtId: '1707030',
    name: 'Semelako I',
  },
  {
    id: '1707030003',
    districtId: '1707030',
    name: 'Karang Anyar',
  },
  {
    id: '1707030004',
    districtId: '1707030',
    name: 'Tanjung Bungai I',
  },
  {
    id: '1707030005',
    districtId: '1707030',
    name: 'Pagar Agung',
  },
  {
    id: '1707030006',
    districtId: '1707030',
    name: 'Embong Panjang',
  },
  {
    id: '1707030013',
    districtId: '1707030',
    name: 'Tanjung Bungai II',
  },
  {
    id: '1707030014',
    districtId: '1707030',
    name: 'Semelako II',
  },
  {
    id: '1707030015',
    districtId: '1707030',
    name: 'Semelako III',
  },
  {
    id: '1707030016',
    districtId: '1707030',
    name: 'Danau Liang',
  },
  {
    id: '1707030017',
    districtId: '1707030',
    name: 'Suka Damai',
  },
  {
    id: '1707031001',
    districtId: '1707031',
    name: 'Ujung Tanjung I',
  },
  {
    id: '1707031002',
    districtId: '1707031',
    name: 'Muning Agung',
  },
  {
    id: '1707031003',
    districtId: '1707031',
    name: 'Ujung Tanjung II',
  },
  {
    id: '1707031004',
    districtId: '1707031',
    name: 'Ujung Tanjung III',
  },
  {
    id: '1707031005',
    districtId: '1707031',
    name: 'Magelang Baru',
  },
  {
    id: '1707031006',
    districtId: '1707031',
    name: 'Lemeu Pit',
  },
  {
    id: '1707031007',
    districtId: '1707031',
    name: 'Tabeak Kauk',
  },
  {
    id: '1707031008',
    districtId: '1707031',
    name: 'Tabeak Dipoa',
  },
  {
    id: '1707031009',
    districtId: '1707031',
    name: 'Suka Bumi',
  },
  {
    id: '1707040001',
    districtId: '1707040',
    name: 'Tik Tebing',
  },
  {
    id: '1707040002',
    districtId: '1707040',
    name: 'Tabeak Blau',
  },
  {
    id: '1707040005',
    districtId: '1707040',
    name: 'Blau',
  },
  {
    id: '1707040006',
    districtId: '1707040',
    name: 'Sukau Kayo',
  },
  {
    id: '1707040007',
    districtId: '1707040',
    name: 'Tabeak Blau I',
  },
  {
    id: '1707040008',
    districtId: '1707040',
    name: 'Daneu',
  },
  {
    id: '1707042001',
    districtId: '1707042',
    name: 'Tanjung Agung',
  },
  {
    id: '1707042002',
    districtId: '1707042',
    name: 'Sukau Datang',
  },
  {
    id: '1707042003',
    districtId: '1707042',
    name: 'Sukau Datang I',
  },
  {
    id: '1707042004',
    districtId: '1707042',
    name: 'Gunung Alam',
  },
  {
    id: '1707042005',
    districtId: '1707042',
    name: 'Tabeak Blau II',
  },
  {
    id: '1707042006',
    districtId: '1707042',
    name: 'Kota Baru Santan',
  },
  {
    id: '1707042007',
    districtId: '1707042',
    name: 'Tik Teleu',
  },
  {
    id: '1707042008',
    districtId: '1707042',
    name: 'Pelabai',
  },
  {
    id: '1707050013',
    districtId: '1707050',
    name: 'Talang Ulu',
  },
  {
    id: '1707050014',
    districtId: '1707050',
    name: 'Kampung Muara Aman',
  },
  {
    id: '1707050028',
    districtId: '1707050',
    name: 'Nangai Amen',
  },
  {
    id: '1707050029',
    districtId: '1707050',
    name: 'Pasar Muara Aman',
  },
  {
    id: '1707050030',
    districtId: '1707050',
    name: 'Kampung Dalam',
  },
  {
    id: '1707050031',
    districtId: '1707050',
    name: 'Gandung',
  },
  {
    id: '1707050032',
    districtId: '1707050',
    name: 'Lokasari',
  },
  {
    id: '1707050033',
    districtId: '1707050',
    name: 'Lebong Tambang',
  },
  {
    id: '1707050034',
    districtId: '1707050',
    name: 'Kampung Jawa',
  },
  {
    id: '1707050035',
    districtId: '1707050',
    name: 'Ladang Palembang',
  },
  {
    id: '1707050036',
    districtId: '1707050',
    name: 'Tunggang',
  },
  {
    id: '1707050043',
    districtId: '1707050',
    name: 'Gandung Baru',
  },
  {
    id: '1707051001',
    districtId: '1707051',
    name: 'Nangai Tayau',
  },
  {
    id: '1707051002',
    districtId: '1707051',
    name: 'Nangai Tayau I',
  },
  {
    id: '1707051003',
    districtId: '1707051',
    name: 'Pyang Mbik',
  },
  {
    id: '1707051004',
    districtId: '1707051',
    name: 'Sukau Mergo',
  },
  {
    id: '1707051005',
    districtId: '1707051',
    name: 'Sukau Rajo',
  },
  {
    id: '1707051006',
    districtId: '1707051',
    name: 'Talang Bunut',
  },
  {
    id: '1707051007',
    districtId: '1707051',
    name: 'Selebar Jaya',
  },
  {
    id: '1707051008',
    districtId: '1707051',
    name: 'Garut',
  },
  {
    id: '1707051009',
    districtId: '1707051',
    name: 'Amen',
  },
  {
    id: '1707051010',
    districtId: '1707051',
    name: 'Sungai Gerong',
  },
  {
    id: '1707052001',
    districtId: '1707052',
    name: 'Embong',
  },
  {
    id: '1707052002',
    districtId: '1707052',
    name: 'Embong Satu',
  },
  {
    id: '1707052003',
    districtId: '1707052',
    name: 'Kota Baru',
  },
  {
    id: '1707052004',
    districtId: '1707052',
    name: 'Kota Agung',
  },
  {
    id: '1707052005',
    districtId: '1707052',
    name: 'Lemeu',
  },
  {
    id: '1707052006',
    districtId: '1707052',
    name: 'Pangkalan',
  },
  {
    id: '1707052007',
    districtId: '1707052',
    name: 'Tangua',
  },
  {
    id: '1707053001',
    districtId: '1707053',
    name: 'Ketenong Satu',
  },
  {
    id: '1707053002',
    districtId: '1707053',
    name: 'Ketenong Dua',
  },
  {
    id: '1707053003',
    districtId: '1707053',
    name: 'Ketenong Jaya',
  },
  {
    id: '1707053004',
    districtId: '1707053',
    name: 'Tambang Saweak',
  },
  {
    id: '1707053005',
    districtId: '1707053',
    name: 'Air Kopras',
  },
  {
    id: '1707053006',
    districtId: '1707053',
    name: 'Bioa Putiak',
  },
  {
    id: '1707053007',
    districtId: '1707053',
    name: 'Sebelet',
  },
  {
    id: '1707053008',
    districtId: '1707053',
    name: 'Sungai Lisai',
  },
  {
    id: '1708010001',
    districtId: '1708010',
    name: 'Limbur Baru',
  },
  {
    id: '1708010002',
    districtId: '1708010',
    name: 'Batu Kalung',
  },
  {
    id: '1708010003',
    districtId: '1708010',
    name: 'Sosokan Baru',
  },
  {
    id: '1708010004',
    districtId: '1708010',
    name: 'Sosokan Taba',
  },
  {
    id: '1708010005',
    districtId: '1708010',
    name: 'Batu Bandung',
  },
  {
    id: '1708010006',
    districtId: '1708010',
    name: 'Talang Tige',
  },
  {
    id: '1708010007',
    districtId: '1708010',
    name: 'Renah Kurung',
  },
  {
    id: '1708010008',
    districtId: '1708010',
    name: 'Warung Pojok',
  },
  {
    id: '1708020001',
    districtId: '1708020',
    name: 'Kembang Seri',
  },
  {
    id: '1708020002',
    districtId: '1708020',
    name: 'Pagar Agung',
  },
  {
    id: '1708020003',
    districtId: '1708020',
    name: 'Talang Pito',
  },
  {
    id: '1708020004',
    districtId: '1708020',
    name: 'Talang Sawah',
  },
  {
    id: '1708020005',
    districtId: '1708020',
    name: 'Kota Agung',
  },
  {
    id: '1708020006',
    districtId: '1708020',
    name: 'Embong Ijuk',
  },
  {
    id: '1708020007',
    districtId: '1708020',
    name: 'Limbur Lama',
  },
  {
    id: '1708020008',
    districtId: '1708020',
    name: 'Cinto Mandi',
  },
  {
    id: '1708020009',
    districtId: '1708020',
    name: 'Keban Agung',
  },
  {
    id: '1708020010',
    districtId: '1708020',
    name: 'Gunung Agung',
  },
  {
    id: '1708020011',
    districtId: '1708020',
    name: 'Embong Sido',
  },
  {
    id: '1708020012',
    districtId: '1708020',
    name: 'Taba Baru',
  },
  {
    id: '1708020013',
    districtId: '1708020',
    name: 'Batu Belarik',
  },
  {
    id: '1708020014',
    districtId: '1708020',
    name: 'Bukit Menyan',
  },
  {
    id: '1708020015',
    districtId: '1708020',
    name: 'Sosokan Cinto Mandi',
  },
  {
    id: '1708020016',
    districtId: '1708020',
    name: 'Muara Langkap',
  },
  {
    id: '1708020017',
    districtId: '1708020',
    name: 'Air Raman',
  },
  {
    id: '1708020018',
    districtId: '1708020',
    name: 'Langgar Jaya',
  },
  {
    id: '1708020019',
    districtId: '1708020',
    name: 'Cinta Mandi Baru',
  },
  {
    id: '1708030001',
    districtId: '1708030',
    name: 'Benuang Galing',
  },
  {
    id: '1708030002',
    districtId: '1708030',
    name: 'Air Selimang',
  },
  {
    id: '1708030003',
    districtId: '1708030',
    name: 'Tebat Laut',
  },
  {
    id: '1708030004',
    districtId: '1708030',
    name: 'Taba Padang',
  },
  {
    id: '1708030005',
    districtId: '1708030',
    name: 'Lubuk Sahung',
  },
  {
    id: '1708030006',
    districtId: '1708030',
    name: 'Temdak',
  },
  {
    id: '1708030007',
    districtId: '1708030',
    name: 'Kandang',
  },
  {
    id: '1708030008',
    districtId: '1708030',
    name: 'Cirebon Baru',
  },
  {
    id: '1708030009',
    districtId: '1708030',
    name: 'Talang Gelompok',
  },
  {
    id: '1708030010',
    districtId: '1708030',
    name: 'Air Pesi',
  },
  {
    id: '1708030011',
    districtId: '1708030',
    name: 'Talang Babatan',
  },
  {
    id: '1708030012',
    districtId: '1708030',
    name: 'Bayung',
  },
  {
    id: '1708030013',
    districtId: '1708030',
    name: 'Sungai Jernih',
  },
  {
    id: '1708040001',
    districtId: '1708040',
    name: 'Tertik',
  },
  {
    id: '1708040002',
    districtId: '1708040',
    name: 'Taba Air Pauh',
  },
  {
    id: '1708040003',
    districtId: '1708040',
    name: 'Penanjung Panjang',
  },
  {
    id: '1708040004',
    districtId: '1708040',
    name: 'Peraduan Binjai',
  },
  {
    id: '1708040005',
    districtId: '1708040',
    name: 'Talang Karet',
  },
  {
    id: '1708040006',
    districtId: '1708040',
    name: 'Tebat Karai',
  },
  {
    id: '1708040007',
    districtId: '1708040',
    name: 'Taba Sating',
  },
  {
    id: '1708040008',
    districtId: '1708040',
    name: 'Nanti Agung',
  },
  {
    id: '1708040009',
    districtId: '1708040',
    name: 'Karang Tengah',
  },
  {
    id: '1708040010',
    districtId: '1708040',
    name: 'Tapak Gedung',
  },
  {
    id: '1708040011',
    districtId: '1708040',
    name: 'Tebing Penyamun',
  },
  {
    id: '1708040012',
    districtId: '1708040',
    name: 'Sinar Gunung',
  },
  {
    id: '1708040013',
    districtId: '1708040',
    name: 'Taba Saling',
  },
  {
    id: '1708040014',
    districtId: '1708040',
    name: 'Penanjung Panjang Atas',
  },
  {
    id: '1708050001',
    districtId: '1708050',
    name: 'Tebat Monok',
  },
  {
    id: '1708050002',
    districtId: '1708050',
    name: 'Kelilik',
  },
  {
    id: '1708050003',
    districtId: '1708050',
    name: 'Imigrasi Permu',
  },
  {
    id: '1708050004',
    districtId: '1708050',
    name: 'Permu',
  },
  {
    id: '1708050005',
    districtId: '1708050',
    name: 'Pasar Ujung',
  },
  {
    id: '1708050006',
    districtId: '1708050',
    name: 'Karang Endah',
  },
  {
    id: '1708050007',
    districtId: '1708050',
    name: 'Weskust',
  },
  {
    id: '1708050008',
    districtId: '1708050',
    name: 'Kampung Bogor',
  },
  {
    id: '1708050009',
    districtId: '1708050',
    name: 'Pensiunan',
  },
  {
    id: '1708050010',
    districtId: '1708050',
    name: 'Pasar Kepahiang',
  },
  {
    id: '1708050011',
    districtId: '1708050',
    name: 'Dusun Kepahiang',
  },
  {
    id: '1708050012',
    districtId: '1708050',
    name: 'Kuto Rejo',
  },
  {
    id: '1708050013',
    districtId: '1708050',
    name: 'Karang Anyar',
  },
  {
    id: '1708050014',
    districtId: '1708050',
    name: 'Taba Tebelet',
  },
  {
    id: '1708050015',
    districtId: '1708050',
    name: 'Pelangkian',
  },
  {
    id: '1708050016',
    districtId: '1708050',
    name: 'Kelobak',
  },
  {
    id: '1708050017',
    districtId: '1708050',
    name: 'Pagar Gunung',
  },
  {
    id: '1708050018',
    districtId: '1708050',
    name: 'Suka Merindu',
  },
  {
    id: '1708050019',
    districtId: '1708050',
    name: 'Kampung Pensiunan',
  },
  {
    id: '1708050020',
    districtId: '1708050',
    name: 'Pasar Sejantung',
  },
  {
    id: '1708050021',
    districtId: '1708050',
    name: 'Padang Lekat',
  },
  {
    id: '1708050022',
    districtId: '1708050',
    name: 'Bogor Baru',
  },
  {
    id: '1708050023',
    districtId: '1708050',
    name: 'Permu Bawah',
  },
  {
    id: '1708060001',
    districtId: '1708060',
    name: 'Suka Sari',
  },
  {
    id: '1708060002',
    districtId: '1708060',
    name: 'Bukit Sari',
  },
  {
    id: '1708060003',
    districtId: '1708060',
    name: 'Tangsi Duren',
  },
  {
    id: '1708060004',
    districtId: '1708060',
    name: 'Tangsi Baru',
  },
  {
    id: '1708060005',
    districtId: '1708060',
    name: 'Pematang Donok',
  },
  {
    id: '1708060006',
    districtId: '1708060',
    name: 'Babakan Bogor',
  },
  {
    id: '1708060007',
    districtId: '1708060',
    name: 'Barat Wetan',
  },
  {
    id: '1708060008',
    districtId: '1708060',
    name: 'Air Sempiang',
  },
  {
    id: '1708060009',
    districtId: '1708060',
    name: 'Tugu Rejo',
  },
  {
    id: '1708060010',
    districtId: '1708060',
    name: 'Bandung Baru',
  },
  {
    id: '1708060011',
    districtId: '1708060',
    name: 'Sido Makmur',
  },
  {
    id: '1708060012',
    districtId: '1708060',
    name: 'Sumber Sari',
  },
  {
    id: '1708060013',
    districtId: '1708060',
    name: 'Mekar Sari',
  },
  {
    id: '1708060015',
    districtId: '1708060',
    name: 'Sido Rejo',
  },
  {
    id: '1708060016',
    districtId: '1708060',
    name: 'Bandung Jaya',
  },
  {
    id: '1708070001',
    districtId: '1708070',
    name: 'Daspetah',
  },
  {
    id: '1708070002',
    districtId: '1708070',
    name: 'Ujan Mas Bawah',
  },
  {
    id: '1708070003',
    districtId: '1708070',
    name: 'Ujan Mas Atas',
  },
  {
    id: '1708070004',
    districtId: '1708070',
    name: 'Suro Lembak',
  },
  {
    id: '1708070005',
    districtId: '1708070',
    name: 'Suro Ilir',
  },
  {
    id: '1708070006',
    districtId: '1708070',
    name: 'Suro Muncar',
  },
  {
    id: '1708070007',
    districtId: '1708070',
    name: 'Suro Baru',
  },
  {
    id: '1708070008',
    districtId: '1708070',
    name: 'Pekalongan',
  },
  {
    id: '1708070009',
    districtId: '1708070',
    name: 'Pungguk Meranti',
  },
  {
    id: '1708070010',
    districtId: '1708070',
    name: 'Bumi Sari',
  },
  {
    id: '1708070011',
    districtId: '1708070',
    name: 'Cugung Lalang',
  },
  {
    id: '1708070012',
    districtId: '1708070',
    name: 'Suro Bali',
  },
  {
    id: '1708070013',
    districtId: '1708070',
    name: 'Tanjung Alam',
  },
  {
    id: '1708070014',
    districtId: '1708070',
    name: 'Pungguk Beringang',
  },
  {
    id: '1708070015',
    districtId: '1708070',
    name: 'Meranti Jaya',
  },
  {
    id: '1708070016',
    districtId: '1708070',
    name: 'Air Hitam',
  },
  {
    id: '1708070017',
    districtId: '1708070',
    name: 'Daspetah II',
  },
  {
    id: '1708080001',
    districtId: '1708080',
    name: 'Lubuk Penyamun',
  },
  {
    id: '1708080002',
    districtId: '1708080',
    name: 'Bukit Barisan',
  },
  {
    id: '1708080003',
    districtId: '1708080',
    name: 'Durian Depun',
  },
  {
    id: '1708080004',
    districtId: '1708080',
    name: 'Pulo Geto',
  },
  {
    id: '1708080005',
    districtId: '1708080',
    name: 'Taba Mulan',
  },
  {
    id: '1708080006',
    districtId: '1708080',
    name: 'Simpang Kota Bingin',
  },
  {
    id: '1708080007',
    districtId: '1708080',
    name: 'Batu Ampar',
  },
  {
    id: '1708080008',
    districtId: '1708080',
    name: 'Pulo Geto Baru',
  },
  {
    id: '1709010001',
    districtId: '1709010',
    name: 'Air Sebakul',
  },
  {
    id: '1709010002',
    districtId: '1709010',
    name: 'Bukit',
  },
  {
    id: '1709010003',
    districtId: '1709010',
    name: 'Lagan Bungin',
  },
  {
    id: '1709010004',
    districtId: '1709010',
    name: 'Tabalagan',
  },
  {
    id: '1709010005',
    districtId: '1709010',
    name: 'Lagan',
  },
  {
    id: '1709010006',
    districtId: '1709010',
    name: 'Pulau Panggung',
  },
  {
    id: '1709010007',
    districtId: '1709010',
    name: 'Jayakarta',
  },
  {
    id: '1709010008',
    districtId: '1709010',
    name: 'Tengah Padang',
  },
  {
    id: '1709010009',
    districtId: '1709010',
    name: 'Kembang Seri',
  },
  {
    id: '1709010010',
    districtId: '1709010',
    name: 'Taba Pasmah',
  },
  {
    id: '1709010011',
    districtId: '1709010',
    name: 'Nakau',
  },
  {
    id: '1709010012',
    districtId: '1709010',
    name: 'Padang Ulak Tanjung',
  },
  {
    id: '1709010013',
    districtId: '1709010',
    name: 'Pagar Jati',
  },
  {
    id: '1709010014',
    districtId: '1709010',
    name: 'Jumat',
  },
  {
    id: '1709010015',
    districtId: '1709010',
    name: 'Air Putih',
  },
  {
    id: '1709020001',
    districtId: '1709020',
    name: 'Karang Nanding',
  },
  {
    id: '1709020002',
    districtId: '1709020',
    name: 'Penanding',
  },
  {
    id: '1709020003',
    districtId: '1709020',
    name: 'Durian Demang',
  },
  {
    id: '1709020004',
    districtId: '1709020',
    name: 'Dusun Baru II',
  },
  {
    id: '1709020005',
    districtId: '1709020',
    name: 'Karang Tinggi',
  },
  {
    id: '1709020006',
    districtId: '1709020',
    name: 'Taba Mutung',
  },
  {
    id: '1709020007',
    districtId: '1709020',
    name: 'Kancing',
  },
  {
    id: '1709020008',
    districtId: '1709020',
    name: 'Ujung Karang',
  },
  {
    id: '1709020009',
    districtId: '1709020',
    name: 'Talang Empat',
  },
  {
    id: '1709020010',
    districtId: '1709020',
    name: 'Taba Terunjam',
  },
  {
    id: '1709020011',
    districtId: '1709020',
    name: 'Padang Tambak',
  },
  {
    id: '1709020012',
    districtId: '1709020',
    name: 'Rena Lebar',
  },
  {
    id: '1709020013',
    districtId: '1709020',
    name: 'Pelajau',
  },
  {
    id: '1709020014',
    districtId: '1709020',
    name: 'Rena Semanek',
  },
  {
    id: '1709020015',
    districtId: '1709020',
    name: 'Gajah Mati',
  },
  {
    id: '1709020016',
    districtId: '1709020',
    name: 'Semidang',
  },
  {
    id: '1709020017',
    districtId: '1709020',
    name: 'Pagar Gunung',
  },
  {
    id: '1709020018',
    districtId: '1709020',
    name: 'Padang Siring',
  },
  {
    id: '1709030001',
    districtId: '1709030',
    name: 'Kota Niur',
  },
  {
    id: '1709030002',
    districtId: '1709030',
    name: 'Tanjung Raman',
  },
  {
    id: '1709030003',
    districtId: '1709030',
    name: 'Sukarami',
  },
  {
    id: '1709030004',
    districtId: '1709030',
    name: 'Karang Tengah',
  },
  {
    id: '1709030005',
    districtId: '1709030',
    name: 'Lubuk Sini',
  },
  {
    id: '1709030006',
    districtId: '1709030',
    name: 'Bajak I',
  },
  {
    id: '1709030007',
    districtId: '1709030',
    name: 'Surau',
  },
  {
    id: '1709030008',
    districtId: '1709030',
    name: 'Rindu Hati',
  },
  {
    id: '1709030009',
    districtId: '1709030',
    name: 'Tanjung Heran',
  },
  {
    id: '1709030010',
    districtId: '1709030',
    name: 'Taba Teret',
  },
  {
    id: '1709030011',
    districtId: '1709030',
    name: 'Taba Penanjung',
  },
  {
    id: '1709030012',
    districtId: '1709030',
    name: 'Datar Lebar',
  },
  {
    id: '1709030019',
    districtId: '1709030',
    name: 'Penum',
  },
  {
    id: '1709030020',
    districtId: '1709030',
    name: 'Taba Baru',
  },
  {
    id: '1709031001',
    districtId: '1709031',
    name: 'Bajak II',
  },
  {
    id: '1709031002',
    districtId: '1709031',
    name: 'Jambu',
  },
  {
    id: '1709031003',
    districtId: '1709031',
    name: 'Penembang',
  },
  {
    id: '1709031004',
    districtId: '1709031',
    name: 'Lubuk Unen',
  },
  {
    id: '1709031005',
    districtId: '1709031',
    name: 'Pungguk Ketupak',
  },
  {
    id: '1709031006',
    districtId: '1709031',
    name: 'Pungguk Beringin',
  },
  {
    id: '1709031007',
    districtId: '1709031',
    name: 'Kelindang',
  },
  {
    id: '1709031008',
    districtId: '1709031',
    name: 'Ulak Lebar',
  },
  {
    id: '1709031009',
    districtId: '1709031',
    name: 'Taba Durian Sebakul',
  },
  {
    id: '1709031010',
    districtId: '1709031',
    name: 'Talang Ambung',
  },
  {
    id: '1709031011',
    districtId: '1709031',
    name: 'Lubuk Unen Baru',
  },
  {
    id: '1709031012',
    districtId: '1709031',
    name: 'Padang Kedeper',
  },
  {
    id: '1709031013',
    districtId: '1709031',
    name: 'Kelindang Atas',
  },
  {
    id: '1709040008',
    districtId: '1709040',
    name: 'Taba Renah',
  },
  {
    id: '1709040009',
    districtId: '1709040',
    name: 'Temiang',
  },
  {
    id: '1709040011',
    districtId: '1709040',
    name: 'Kertapati',
  },
  {
    id: '1709040012',
    districtId: '1709040',
    name: 'Pagar Jati',
  },
  {
    id: '1709040014',
    districtId: '1709040',
    name: 'Arga Indah I',
  },
  {
    id: '1709040015',
    districtId: '1709040',
    name: 'Datar Penokot',
  },
  {
    id: '1709040016',
    districtId: '1709040',
    name: 'Layang Lekat',
  },
  {
    id: '1709040017',
    districtId: '1709040',
    name: 'Talang Curup',
  },
  {
    id: '1709040018',
    districtId: '1709040',
    name: 'Tumbuk',
  },
  {
    id: '1709040019',
    districtId: '1709040',
    name: 'Rena Kandis',
  },
  {
    id: '1709040020',
    districtId: '1709040',
    name: 'Karang Are',
  },
  {
    id: '1709040021',
    districtId: '1709040',
    name: 'Kertapati Mudik',
  },
  {
    id: '1709040022',
    districtId: '1709040',
    name: 'Keroya',
  },
  {
    id: '1709040023',
    districtId: '1709040',
    name: 'Rena Jaya',
  },
  {
    id: '1709041001',
    districtId: '1709041',
    name: 'Lubuk Puar',
  },
  {
    id: '1709041002',
    districtId: '1709041',
    name: 'Punjung',
  },
  {
    id: '1709041003',
    districtId: '1709041',
    name: 'Bajak III',
  },
  {
    id: '1709041004',
    districtId: '1709041',
    name: 'Komering',
  },
  {
    id: '1709041005',
    districtId: '1709041',
    name: 'Arga Indah II',
  },
  {
    id: '1709041006',
    districtId: '1709041',
    name: 'Curup',
  },
  {
    id: '1709041007',
    districtId: '1709041',
    name: 'Karang Panggung',
  },
  {
    id: '1709041008',
    districtId: '1709041',
    name: 'Lubuk Pendam',
  },
  {
    id: '1709041009',
    districtId: '1709041',
    name: 'Rajak Besi',
  },
  {
    id: '1709041010',
    districtId: '1709041',
    name: 'Susup',
  },
  {
    id: '1709041011',
    districtId: '1709041',
    name: 'Pagar Agung',
  },
  {
    id: '1709041012',
    districtId: '1709041',
    name: 'Durian Lebar',
  },
  {
    id: '1709041013',
    districtId: '1709041',
    name: 'Taba Gemantung',
  },
  {
    id: '1709041014',
    districtId: '1709041',
    name: 'Pungguk Jaya',
  },
  {
    id: '1709041015',
    districtId: '1709041',
    name: 'Pagar Besi',
  },
  {
    id: '1709050001',
    districtId: '1709050',
    name: 'Pekik Nyaring',
  },
  {
    id: '1709050002',
    districtId: '1709050',
    name: 'Srikuncoro',
  },
  {
    id: '1709050010',
    districtId: '1709050',
    name: 'Panca Mukti',
  },
  {
    id: '1709050011',
    districtId: '1709050',
    name: 'Srikaton',
  },
  {
    id: '1709050012',
    districtId: '1709050',
    name: 'Pasar Pedati',
  },
  {
    id: '1709050013',
    districtId: '1709050',
    name: 'Talang Pauh',
  },
  {
    id: '1709050014',
    districtId: '1709050',
    name: 'Sidodadi',
  },
  {
    id: '1709050015',
    districtId: '1709050',
    name: 'Talang Buseng',
  },
  {
    id: '1709050017',
    districtId: '1709050',
    name: 'Kembang Ayun',
  },
  {
    id: '1709050018',
    districtId: '1709050',
    name: 'Pagardewa',
  },
  {
    id: '1709050019',
    districtId: '1709050',
    name: 'Sidorejo',
  },
  {
    id: '1709050020',
    districtId: '1709050',
    name: 'Sunda Kelapa',
  },
  {
    id: '1709050021',
    districtId: '1709050',
    name: 'Pondok Kelapa',
  },
  {
    id: '1709050022',
    districtId: '1709050',
    name: 'Padang Betuah',
  },
  {
    id: '1709050023',
    districtId: '1709050',
    name: 'Bintang Selatan',
  },
  {
    id: '1709050024',
    districtId: '1709050',
    name: 'Abu Sakim',
  },
  {
    id: '1709050025',
    districtId: '1709050',
    name: 'Harapan',
  },
  {
    id: '1709051001',
    districtId: '1709051',
    name: 'Tanjung Terdana',
  },
  {
    id: '1709051002',
    districtId: '1709051',
    name: 'Pondok Kubang',
  },
  {
    id: '1709051003',
    districtId: '1709051',
    name: 'Anyar',
  },
  {
    id: '1709051004',
    districtId: '1709051',
    name: 'Batu Raja',
  },
  {
    id: '1709051005',
    districtId: '1709051',
    name: 'Tanjung Dalam',
  },
  {
    id: '1709051006',
    districtId: '1709051',
    name: 'Talang Tengah I',
  },
  {
    id: '1709051007',
    districtId: '1709051',
    name: 'Linggar Galing',
  },
  {
    id: '1709051008',
    districtId: '1709051',
    name: 'Paku Haji',
  },
  {
    id: '1709051009',
    districtId: '1709051',
    name: 'Dusun Baru I',
  },
  {
    id: '1709051010',
    districtId: '1709051',
    name: 'Harapan Makmur',
  },
  {
    id: '1709051011',
    districtId: '1709051',
    name: 'Taba Jambu',
  },
  {
    id: '1709051012',
    districtId: '1709051',
    name: 'Margo Mulyo',
  },
  {
    id: '1709060011',
    districtId: '1709060',
    name: 'Kota Titik',
  },
  {
    id: '1709060012',
    districtId: '1709060',
    name: 'Aturan Mumpo',
  },
  {
    id: '1709060013',
    districtId: '1709060',
    name: 'Senabah',
  },
  {
    id: '1709060014',
    districtId: '1709060',
    name: 'Talang Tengah II',
  },
  {
    id: '1709060015',
    districtId: '1709060',
    name: 'Tanjung Kepayang',
  },
  {
    id: '1709060016',
    districtId: '1709060',
    name: 'Kebun Lebar',
  },
  {
    id: '1709060017',
    districtId: '1709060',
    name: 'Tiambang',
  },
  {
    id: '1709060018',
    districtId: '1709060',
    name: 'Pematang Tiga',
  },
  {
    id: '1709060019',
    districtId: '1709060',
    name: 'Batu Bariang',
  },
  {
    id: '1709060020',
    districtId: '1709060',
    name: 'Air Kotok',
  },
  {
    id: '1709060021',
    districtId: '1709060',
    name: 'Aturan Mumpo II',
  },
  {
    id: '1709060022',
    districtId: '1709060',
    name: 'Genting Dabuk',
  },
  {
    id: '1709060023',
    districtId: '1709060',
    name: 'Pematang Tiga Lama',
  },
  {
    id: '1709061001',
    districtId: '1709061',
    name: 'Sekayun',
  },
  {
    id: '1709061002',
    districtId: '1709061',
    name: 'Sekayun Mudik',
  },
  {
    id: '1709061003',
    districtId: '1709061',
    name: 'Sekayun Ilir',
  },
  {
    id: '1709061004',
    districtId: '1709061',
    name: 'Talang Donok',
  },
  {
    id: '1709061005',
    districtId: '1709061',
    name: 'Taba Tengah',
  },
  {
    id: '1709061006',
    districtId: '1709061',
    name: 'Padang Burnai',
  },
  {
    id: '1709061007',
    districtId: '1709061',
    name: 'Lubuk Langkap',
  },
  {
    id: '1709061008',
    districtId: '1709061',
    name: 'Air Napal',
  },
  {
    id: '1709061009',
    districtId: '1709061',
    name: 'Genting',
  },
  {
    id: '1709061010',
    districtId: '1709061',
    name: 'Talang Panjang',
  },
  {
    id: '1709061011',
    districtId: '1709061',
    name: 'Bang Haji',
  },
  {
    id: '1709061012',
    districtId: '1709061',
    name: 'Sungkai Berayun',
  },
  {
    id: '1771010003',
    districtId: '1771010',
    name: 'Betungan',
  },
  {
    id: '1771010004',
    districtId: '1771010',
    name: 'Pekan Sabtu',
  },
  {
    id: '1771010005',
    districtId: '1771010',
    name: 'Suka Rami',
  },
  {
    id: '1771010006',
    districtId: '1771010',
    name: 'Pagar Dewa',
  },
  {
    id: '1771010007',
    districtId: '1771010',
    name: 'Bumiayu',
  },
  {
    id: '1771010008',
    districtId: '1771010',
    name: 'Sumur Dewa',
  },
  {
    id: '1771011001',
    districtId: '1771011',
    name: 'Teluk Sepang',
  },
  {
    id: '1771011002',
    districtId: '1771011',
    name: 'Sumber Jaya',
  },
  {
    id: '1771011003',
    districtId: '1771011',
    name: 'Kandang',
  },
  {
    id: '1771011004',
    districtId: '1771011',
    name: 'Kandang Mas',
  },
  {
    id: '1771011005',
    districtId: '1771011',
    name: 'Padang Serai',
  },
  {
    id: '1771011006',
    districtId: '1771011',
    name: 'Muara Dua',
  },
  {
    id: '1771020001',
    districtId: '1771020',
    name: 'Sido Mulyo',
  },
  {
    id: '1771020005',
    districtId: '1771020',
    name: 'Jalan Gedang',
  },
  {
    id: '1771020006',
    districtId: '1771020',
    name: 'Padang Harapan',
  },
  {
    id: '1771020024',
    districtId: '1771020',
    name: 'Cempaka Permai',
  },
  {
    id: '1771020027',
    districtId: '1771020',
    name: 'Linkar Barat',
  },
  {
    id: '1771021001',
    districtId: '1771021',
    name: 'Tanah Patah',
  },
  {
    id: '1771021002',
    districtId: '1771021',
    name: 'Kebun Tebeng',
  },
  {
    id: '1771021003',
    districtId: '1771021',
    name: 'Sawah Lebar Baru',
  },
  {
    id: '1771021004',
    districtId: '1771021',
    name: 'Sawah Lebar',
  },
  {
    id: '1771021005',
    districtId: '1771021',
    name: 'Nusa Indah',
  },
  {
    id: '1771021006',
    districtId: '1771021',
    name: 'Kebun Kenanga',
  },
  {
    id: '1771021007',
    districtId: '1771021',
    name: 'Kebun Beler',
  },
  {
    id: '1771021008',
    districtId: '1771021',
    name: 'Lempuing',
  },
  {
    id: '1771022001',
    districtId: '1771022',
    name: 'Anggut Bawah',
  },
  {
    id: '1771022002',
    districtId: '1771022',
    name: 'Penurunan',
  },
  {
    id: '1771022003',
    districtId: '1771022',
    name: 'Padang Jati',
  },
  {
    id: '1771022004',
    districtId: '1771022',
    name: 'Belakang Pondok',
  },
  {
    id: '1771022005',
    districtId: '1771022',
    name: 'Pengantungan',
  },
  {
    id: '1771022006',
    districtId: '1771022',
    name: 'Kebun Dahri',
  },
  {
    id: '1771022007',
    districtId: '1771022',
    name: 'Kebun Gerand',
  },
  {
    id: '1771022008',
    districtId: '1771022',
    name: 'Anggut Atas',
  },
  {
    id: '1771022009',
    districtId: '1771022',
    name: 'Anggut Dalam',
  },
  {
    id: '1771023001',
    districtId: '1771023',
    name: 'Jembatan Kecil',
  },
  {
    id: '1771023002',
    districtId: '1771023',
    name: 'Panorama',
  },
  {
    id: '1771023003',
    districtId: '1771023',
    name: 'Lingkar Timur',
  },
  {
    id: '1771023004',
    districtId: '1771023',
    name: 'Timur Indah',
  },
  {
    id: '1771023005',
    districtId: '1771023',
    name: 'Padang Nangka',
  },
  {
    id: '1771023006',
    districtId: '1771023',
    name: 'Dusun Besar',
  },
  {
    id: '1771030001',
    districtId: '1771030',
    name: 'Kebun Keling',
  },
  {
    id: '1771030004',
    districtId: '1771030',
    name: 'Malabero',
  },
  {
    id: '1771030005',
    districtId: '1771030',
    name: 'Sumur Melele',
  },
  {
    id: '1771030006',
    districtId: '1771030',
    name: 'Pasar Berkas',
  },
  {
    id: '1771030007',
    districtId: '1771030',
    name: 'Pasar Baru',
  },
  {
    id: '1771030008',
    districtId: '1771030',
    name: 'Pasar Jitra',
  },
  {
    id: '1771030009',
    districtId: '1771030',
    name: 'Pasar Melintang',
  },
  {
    id: '1771030011',
    districtId: '1771030',
    name: 'Pondok Besi',
  },
  {
    id: '1771030012',
    districtId: '1771030',
    name: 'Kebun Ros',
  },
  {
    id: '1771030013',
    districtId: '1771030',
    name: 'Pintu Batu',
  },
  {
    id: '1771030014',
    districtId: '1771030',
    name: 'Tengah Padang',
  },
  {
    id: '1771030015',
    districtId: '1771030',
    name: 'Bajak',
  },
  {
    id: '1771030016',
    districtId: '1771030',
    name: 'Kampung Bali',
  },
  {
    id: '1771031001',
    districtId: '1771031',
    name: 'Surabaya',
  },
  {
    id: '1771031002',
    districtId: '1771031',
    name: 'Semarang',
  },
  {
    id: '1771031003',
    districtId: '1771031',
    name: 'Tanjung Jaya',
  },
  {
    id: '1771031004',
    districtId: '1771031',
    name: 'Tanjung Agung',
  },
  {
    id: '1771031005',
    districtId: '1771031',
    name: 'Suka Merindu',
  },
  {
    id: '1771031006',
    districtId: '1771031',
    name: 'Kampung Kelawi',
  },
  {
    id: '1771031007',
    districtId: '1771031',
    name: 'Pasar Bengkulu',
  },
  {
    id: '1771040001',
    districtId: '1771040',
    name: 'Beringin Raya',
  },
  {
    id: '1771040002',
    districtId: '1771040',
    name: 'Rawa Makmur',
  },
  {
    id: '1771040003',
    districtId: '1771040',
    name: 'Kandang Limun',
  },
  {
    id: '1771040004',
    districtId: '1771040',
    name: 'Pematang Gubernur',
  },
  {
    id: '1771040005',
    districtId: '1771040',
    name: 'Bentiring',
  },
  {
    id: '1771040006',
    districtId: '1771040',
    name: 'Rawa Makmur Permai',
  },
  {
    id: '1771040007',
    districtId: '1771040',
    name: 'Bentiring Permai',
  },
  {
    id: '1801040001',
    districtId: '1801040',
    name: 'Kubu Perahu',
  },
  {
    id: '1801040002',
    districtId: '1801040',
    name: 'Way Empulau Ulu',
  },
  {
    id: '1801040003',
    districtId: '1801040',
    name: 'Watas',
  },
  {
    id: '1801040004',
    districtId: '1801040',
    name: 'Padang Dalom',
  },
  {
    id: '1801040005',
    districtId: '1801040',
    name: 'Gunung Sugih',
  },
  {
    id: '1801040006',
    districtId: '1801040',
    name: 'Sebarus',
  },
  {
    id: '1801040007',
    districtId: '1801040',
    name: 'Pasar Liwa',
  },
  {
    id: '1801040008',
    districtId: '1801040',
    name: 'Way Mengaku',
  },
  {
    id: '1801040009',
    districtId: '1801040',
    name: 'Padang Cahya',
  },
  {
    id: '1801040012',
    districtId: '1801040',
    name: 'Sukarame',
  },
  {
    id: '1801040013',
    districtId: '1801040',
    name: 'Bahway',
  },
  {
    id: '1801040014',
    districtId: '1801040',
    name: 'Sedampah Indah',
  },
  {
    id: '1801041001',
    districtId: '1801041',
    name: 'Tanjung Raya',
  },
  {
    id: '1801041002',
    districtId: '1801041',
    name: 'Hanakau',
  },
  {
    id: '1801041003',
    districtId: '1801041',
    name: 'Buay Nyerupa',
  },
  {
    id: '1801041004',
    districtId: '1801041',
    name: 'Tapak Siring',
  },
  {
    id: '1801041005',
    districtId: '1801041',
    name: 'Pagar Dewa',
  },
  {
    id: '1801041006',
    districtId: '1801041',
    name: 'Jaga Raga',
  },
  {
    id: '1801041012',
    districtId: '1801041',
    name: 'Suka Mulya',
  },
  {
    id: '1801041018',
    districtId: '1801041',
    name: 'Bandar Baru',
  },
  {
    id: '1801041019',
    districtId: '1801041',
    name: 'Bumi Jaya',
  },
  {
    id: '1801041020',
    districtId: '1801041',
    name: 'Teba Pering Raya',
  },
  {
    id: '1801042001',
    districtId: '1801042',
    name: 'Lombok',
  },
  {
    id: '1801042002',
    districtId: '1801042',
    name: 'Heni Arong',
  },
  {
    id: '1801042003',
    districtId: '1801042',
    name: 'Suka Banjar',
  },
  {
    id: '1801042004',
    districtId: '1801042',
    name: 'Lombok Timur',
  },
  {
    id: '1801042005',
    districtId: '1801042',
    name: 'Suka Banjar II Ujung Rembun',
  },
  {
    id: '1801042006',
    districtId: '1801042',
    name: 'Suka Maju',
  },
  {
    id: '1801042007',
    districtId: '1801042',
    name: 'Ujung',
  },
  {
    id: '1801042008',
    districtId: '1801042',
    name: 'Keagungan',
  },
  {
    id: '1801042009',
    districtId: '1801042',
    name: 'Tawan Suka Mulya',
  },
  {
    id: '1801042010',
    districtId: '1801042',
    name: 'Pancur Mas',
  },
  {
    id: '1801042011',
    districtId: '1801042',
    name: 'Lombok Selatan',
  },
  {
    id: '1801050025',
    districtId: '1801050',
    name: 'Hujung',
  },
  {
    id: '1801050026',
    districtId: '1801050',
    name: 'Kenali',
  },
  {
    id: '1801050027',
    districtId: '1801050',
    name: 'Bedudu',
  },
  {
    id: '1801050028',
    districtId: '1801050',
    name: 'Sukarami',
  },
  {
    id: '1801050031',
    districtId: '1801050',
    name: 'Kejadian',
  },
  {
    id: '1801050032',
    districtId: '1801050',
    name: 'Bumi Agung',
  },
  {
    id: '1801050033',
    districtId: '1801050',
    name: 'Turgak',
  },
  {
    id: '1801050034',
    districtId: '1801050',
    name: 'Serungkuk',
  },
  {
    id: '1801050039',
    districtId: '1801050',
    name: 'Suka Makmur',
  },
  {
    id: '1801050041',
    districtId: '1801050',
    name: 'Pajar Agung',
  },
  {
    id: '1801051001',
    districtId: '1801051',
    name: 'Tiga Jaya',
  },
  {
    id: '1801051002',
    districtId: '1801051',
    name: 'Waspada',
  },
  {
    id: '1801051003',
    districtId: '1801051',
    name: 'Giham Sukamaju',
  },
  {
    id: '1801051004',
    districtId: '1801051',
    name: 'Sekincau',
  },
  {
    id: '1801051005',
    districtId: '1801051',
    name: 'Pampangan',
  },
  {
    id: '1801052001',
    districtId: '1801052',
    name: 'Tugu Ratu',
  },
  {
    id: '1801052002',
    districtId: '1801052',
    name: 'Banding Agung',
  },
  {
    id: '1801052003',
    districtId: '1801052',
    name: 'Roworejo',
  },
  {
    id: '1801052006',
    districtId: '1801052',
    name: 'Sumber Agung',
  },
  {
    id: '1801052007',
    districtId: '1801052',
    name: 'Suka Marga',
  },
  {
    id: '1801052013',
    districtId: '1801052',
    name: 'Sido Rejo',
  },
  {
    id: '1801052017',
    districtId: '1801052',
    name: 'Ringin Sari',
  },
  {
    id: '1801053001',
    districtId: '1801053',
    name: 'Kota Besi',
  },
  {
    id: '1801053002',
    districtId: '1801053',
    name: 'Canggu',
  },
  {
    id: '1801053003',
    districtId: '1801053',
    name: 'Gunung Sugih',
  },
  {
    id: '1801053004',
    districtId: '1801053',
    name: 'Pekon Balak',
  },
  {
    id: '1801053005',
    districtId: '1801053',
    name: 'Sukabumi',
  },
  {
    id: '1801053006',
    districtId: '1801053',
    name: 'Kegeringan',
  },
  {
    id: '1801053007',
    districtId: '1801053',
    name: 'Negeri Ratu',
  },
  {
    id: '1801053008',
    districtId: '1801053',
    name: 'Kembahang',
  },
  {
    id: '1801053009',
    districtId: '1801053',
    name: 'Sukaraja',
  },
  {
    id: '1801053010',
    districtId: '1801053',
    name: 'Kerang',
  },
  {
    id: '1801053011',
    districtId: '1801053',
    name: 'Teba Liyokh',
  },
  {
    id: '1801054001',
    districtId: '1801054',
    name: 'Pahayu Jaya',
  },
  {
    id: '1801054002',
    districtId: '1801054',
    name: 'Basungan',
  },
  {
    id: '1801054003',
    districtId: '1801054',
    name: 'Mekar Sari',
  },
  {
    id: '1801054004',
    districtId: '1801054',
    name: 'Sidomulyo',
  },
  {
    id: '1801054005',
    districtId: '1801054',
    name: 'Sidodadi',
  },
  {
    id: '1801054006',
    districtId: '1801054',
    name: 'Marga Jaya',
  },
  {
    id: '1801054007',
    districtId: '1801054',
    name: 'Suka Jaya',
  },
  {
    id: '1801054008',
    districtId: '1801054',
    name: 'Batu Api',
  },
  {
    id: '1801054009',
    districtId: '1801054',
    name: 'Pagar Dewa',
  },
  {
    id: '1801054010',
    districtId: '1801054',
    name: 'Suka Mulya',
  },
  {
    id: '1801055001',
    districtId: '1801055',
    name: 'Argomulyo',
  },
  {
    id: '1801055002',
    districtId: '1801055',
    name: 'Batu Kebayan',
  },
  {
    id: '1801055003',
    districtId: '1801055',
    name: 'Atar Bawang',
  },
  {
    id: '1801055004',
    districtId: '1801055',
    name: 'Campang Tiga',
  },
  {
    id: '1801055005',
    districtId: '1801055',
    name: 'Luas',
  },
  {
    id: '1801055006',
    districtId: '1801055',
    name: 'Bakhu',
  },
  {
    id: '1801055007',
    districtId: '1801055',
    name: 'Way Ngison',
  },
  {
    id: '1801055008',
    districtId: '1801055',
    name: 'Kubu Liku Jaya',
  },
  {
    id: '1801055009',
    districtId: '1801055',
    name: 'Sumber Rejo',
  },
  {
    id: '1801055010',
    districtId: '1801055',
    name: 'Atar Kuwau',
  },
  {
    id: '1801056001',
    districtId: '1801056',
    name: 'Suoh',
  },
  {
    id: '1801056002',
    districtId: '1801056',
    name: 'Srimulyo',
  },
  {
    id: '1801056003',
    districtId: '1801056',
    name: 'Bandar Agung',
  },
  {
    id: '1801056004',
    districtId: '1801056',
    name: 'Ringin Jaya',
  },
  {
    id: '1801056005',
    districtId: '1801056',
    name: 'Bumi Hantatai',
  },
  {
    id: '1801056006',
    districtId: '1801056',
    name: 'Gunung Ratu',
  },
  {
    id: '1801056007',
    districtId: '1801056',
    name: 'Tanjung Sari',
  },
  {
    id: '1801056008',
    districtId: '1801056',
    name: 'Negeri Jaya',
  },
  {
    id: '1801056009',
    districtId: '1801056',
    name: 'Tembelang',
  },
  {
    id: '1801056010',
    districtId: '1801056',
    name: 'Tri Mekar Jaya',
  },
  {
    id: '1801060014',
    districtId: '1801060',
    name: 'Sindang Pagar',
  },
  {
    id: '1801060015',
    districtId: '1801060',
    name: 'Suka Jaya',
  },
  {
    id: '1801060026',
    districtId: '1801060',
    name: 'Simpang Sari',
  },
  {
    id: '1801060027',
    districtId: '1801060',
    name: 'Way Petay',
  },
  {
    id: '1801060028',
    districtId: '1801060',
    name: 'Sukapura',
  },
  {
    id: '1801060030',
    districtId: '1801060',
    name: 'Tugusari',
  },
  {
    id: '1801061001',
    districtId: '1801061',
    name: 'Tambak Jaya',
  },
  {
    id: '1801061002',
    districtId: '1801061',
    name: 'Padang Tambak',
  },
  {
    id: '1801061003',
    districtId: '1801061',
    name: 'Sukaraja',
  },
  {
    id: '1801061004',
    districtId: '1801061',
    name: 'Sukananti',
  },
  {
    id: '1801061007',
    districtId: '1801061',
    name: 'Tanjung Raya',
  },
  {
    id: '1801061011',
    districtId: '1801061',
    name: 'Mutar Alam',
  },
  {
    id: '1801061012',
    districtId: '1801061',
    name: 'Karang Agung',
  },
  {
    id: '1801061013',
    districtId: '1801061',
    name: 'Pura Laksana',
  },
  {
    id: '1801061014',
    districtId: '1801061',
    name: 'Fajar Bulan',
  },
  {
    id: '1801062001',
    districtId: '1801062',
    name: 'Mekar Jaya',
  },
  {
    id: '1801062002',
    districtId: '1801062',
    name: 'Pura Mekar',
  },
  {
    id: '1801062003',
    districtId: '1801062',
    name: 'Cipta Waras',
  },
  {
    id: '1801062004',
    districtId: '1801062',
    name: 'Tri Mulyo',
  },
  {
    id: '1801062005',
    districtId: '1801062',
    name: 'Gedung Surian',
  },
  {
    id: '1801063001',
    districtId: '1801063',
    name: 'Pura Jaya',
  },
  {
    id: '1801063002',
    districtId: '1801063',
    name: 'Pura Wiwitan',
  },
  {
    id: '1801063003',
    districtId: '1801063',
    name: 'Tribudi Syukur',
  },
  {
    id: '1801063004',
    districtId: '1801063',
    name: 'Muara Jaya I',
  },
  {
    id: '1801063005',
    districtId: '1801063',
    name: 'Muara Jaya II',
  },
  {
    id: '1801063006',
    districtId: '1801063',
    name: 'Tribudi Makmur',
  },
  {
    id: '1801063007',
    districtId: '1801063',
    name: 'Tugu Mulya',
  },
  {
    id: '1801063008',
    districtId: '1801063',
    name: 'Cipta Mulya',
  },
  {
    id: '1801063009',
    districtId: '1801063',
    name: 'Muara Baru',
  },
  {
    id: '1801063010',
    districtId: '1801063',
    name: 'Sinar Luas',
  },
  {
    id: '1801064001',
    districtId: '1801064',
    name: 'Sidodadi',
  },
  {
    id: '1801064002',
    districtId: '1801064',
    name: 'Semarang Jaya',
  },
  {
    id: '1801064003',
    districtId: '1801064',
    name: 'Sumber Alam',
  },
  {
    id: '1801064004',
    districtId: '1801064',
    name: 'Gunung Terang',
  },
  {
    id: '1801064005',
    districtId: '1801064',
    name: 'Suka Jadi',
  },
  {
    id: '1801064006',
    districtId: '1801064',
    name: 'Sri Menanti',
  },
  {
    id: '1801064007',
    districtId: '1801064',
    name: 'Sinar Jaya',
  },
  {
    id: '1801064008',
    districtId: '1801064',
    name: 'Rigis Jaya',
  },
  {
    id: '1801064009',
    districtId: '1801064',
    name: 'Suka Damai',
  },
  {
    id: '1801064010',
    districtId: '1801064',
    name: 'Manggarai',
  },
  {
    id: '1802010003',
    districtId: '1802010',
    name: 'Karang Anyar',
  },
  {
    id: '1802010008',
    districtId: '1802010',
    name: 'Kalirejo',
  },
  {
    id: '1802010009',
    districtId: '1802010',
    name: 'Dadirejo',
  },
  {
    id: '1802010010',
    districtId: '1802010',
    name: 'Banyu Urip',
  },
  {
    id: '1802010011',
    districtId: '1802010',
    name: 'Wonosobo',
  },
  {
    id: '1802010012',
    districtId: '1802010',
    name: 'Soponyono',
  },
  {
    id: '1802010013',
    districtId: '1802010',
    name: 'Bandar Kejadian',
  },
  {
    id: '1802010014',
    districtId: '1802010',
    name: 'Way Panas',
  },
  {
    id: '1802010015',
    districtId: '1802010',
    name: 'Sinar Saudara',
  },
  {
    id: '1802010016',
    districtId: '1802010',
    name: 'Sridadi',
  },
  {
    id: '1802010017',
    districtId: '1802010',
    name: 'Lakaran',
  },
  {
    id: '1802010018',
    districtId: '1802010',
    name: 'Padang Ratu',
  },
  {
    id: '1802010019',
    districtId: '1802010',
    name: 'Parda Suka',
  },
  {
    id: '1802010020',
    districtId: '1802010',
    name: 'Tanjung Kurung',
  },
  {
    id: '1802010021',
    districtId: '1802010',
    name: 'Padang Manis',
  },
  {
    id: '1802010022',
    districtId: '1802010',
    name: 'Kejadian',
  },
  {
    id: '1802010023',
    districtId: '1802010',
    name: 'Dadisari',
  },
  {
    id: '1802010024',
    districtId: '1802010',
    name: 'Kalisari',
  },
  {
    id: '1802010029',
    districtId: '1802010',
    name: 'Banjar Negoro',
  },
  {
    id: '1802010030',
    districtId: '1802010',
    name: 'Pekon Balak',
  },
  {
    id: '1802010031',
    districtId: '1802010',
    name: 'Kunyayan',
  },
  {
    id: '1802010032',
    districtId: '1802010',
    name: 'Banjarsari',
  },
  {
    id: '1802010037',
    districtId: '1802010',
    name: 'Negeri Ngarip',
  },
  {
    id: '1802010038',
    districtId: '1802010',
    name: 'Sampang Turus',
  },
  {
    id: '1802010039',
    districtId: '1802010',
    name: 'Way Liwok',
  },
  {
    id: '1802010040',
    districtId: '1802010',
    name: 'Sumur Tujuh',
  },
  {
    id: '1802010041',
    districtId: '1802010',
    name: 'Dadi Mulyo',
  },
  {
    id: '1802010042',
    districtId: '1802010',
    name: 'Sri Melati',
  },
  {
    id: '1802011001',
    districtId: '1802011',
    name: 'Tugu Papak',
  },
  {
    id: '1802011002',
    districtId: '1802011',
    name: 'Karang Rejo',
  },
  {
    id: '1802011003',
    districtId: '1802011',
    name: 'Garut',
  },
  {
    id: '1802011004',
    districtId: '1802011',
    name: 'Sido Dadi',
  },
  {
    id: '1802011005',
    districtId: '1802011',
    name: 'Kaca Pura',
  },
  {
    id: '1802011006',
    districtId: '1802011',
    name: 'Tugu Rejo',
  },
  {
    id: '1802011007',
    districtId: '1802011',
    name: 'Bangun Rejo',
  },
  {
    id: '1802011008',
    districtId: '1802011',
    name: 'Sukaraja',
  },
  {
    id: '1802011009',
    districtId: '1802011',
    name: 'Sedayu',
  },
  {
    id: '1802011010',
    districtId: '1802011',
    name: 'Kanoman',
  },
  {
    id: '1802011011',
    districtId: '1802011',
    name: 'Sudimoro',
  },
  {
    id: '1802011012',
    districtId: '1802011',
    name: 'Sudimoro Bangun',
  },
  {
    id: '1802011013',
    districtId: '1802011',
    name: 'Way Kerap',
  },
  {
    id: '1802011014',
    districtId: '1802011',
    name: 'Sri Purnomo',
  },
  {
    id: '1802011015',
    districtId: '1802011',
    name: 'Sri Kuncoro',
  },
  {
    id: '1802011016',
    districtId: '1802011',
    name: 'Sri Katon',
  },
  {
    id: '1802011017',
    districtId: '1802011',
    name: 'Parda Waras',
  },
  {
    id: '1802011018',
    districtId: '1802011',
    name: 'Karang Agung',
  },
  {
    id: '1802011019',
    districtId: '1802011',
    name: 'Sido Mulyo',
  },
  {
    id: '1802011020',
    districtId: '1802011',
    name: 'Tulung Asahan',
  },
  {
    id: '1802011021',
    districtId: '1802011',
    name: 'Margo Mulyo',
  },
  {
    id: '1802011022',
    districtId: '1802011',
    name: 'Suka Jaya',
  },
  {
    id: '1802012001',
    districtId: '1802012',
    name: 'Negeri Agung',
  },
  {
    id: '1802012002',
    districtId: '1802012',
    name: 'Bandar Sukabumi',
  },
  {
    id: '1802012003',
    districtId: '1802012',
    name: 'Sanggi',
  },
  {
    id: '1802012004',
    districtId: '1802012',
    name: 'Raja Basa',
  },
  {
    id: '1802012005',
    districtId: '1802012',
    name: 'Gunung Doh',
  },
  {
    id: '1802012006',
    districtId: '1802012',
    name: 'Banding',
  },
  {
    id: '1802012007',
    districtId: '1802012',
    name: 'Atar Lebar',
  },
  {
    id: '1802012008',
    districtId: '1802012',
    name: 'Simpang Bayur',
  },
  {
    id: '1802012009',
    districtId: '1802012',
    name: 'Sanggi Unggak',
  },
  {
    id: '1802012010',
    districtId: '1802012',
    name: 'Sinar Bangun',
  },
  {
    id: '1802012011',
    districtId: '1802012',
    name: 'Tulung Sari',
  },
  {
    id: '1802020021',
    districtId: '1802020',
    name: 'Negeri Ratu',
  },
  {
    id: '1802020024',
    districtId: '1802020',
    name: 'Penanggungan',
  },
  {
    id: '1802020025',
    districtId: '1802020',
    name: 'Terdana',
  },
  {
    id: '1802020026',
    districtId: '1802020',
    name: 'Baros',
  },
  {
    id: '1802020027',
    districtId: '1802020',
    name: 'Pasar Madang',
  },
  {
    id: '1802020028',
    districtId: '1802020',
    name: 'Kuripan',
  },
  {
    id: '1802020029',
    districtId: '1802020',
    name: 'Kelungu',
  },
  {
    id: '1802020030',
    districtId: '1802020',
    name: 'Pardasuka',
  },
  {
    id: '1802020031',
    districtId: '1802020',
    name: 'Teratas',
  },
  {
    id: '1802020032',
    districtId: '1802020',
    name: 'Kusa',
  },
  {
    id: '1802020033',
    districtId: '1802020',
    name: 'Terbaya',
  },
  {
    id: '1802020034',
    districtId: '1802020',
    name: 'Kedamaian',
  },
  {
    id: '1802020035',
    districtId: '1802020',
    name: 'Kota Agung',
  },
  {
    id: '1802020036',
    districtId: '1802020',
    name: 'Kota Batu',
  },
  {
    id: '1802020037',
    districtId: '1802020',
    name: 'Campang Tiga',
  },
  {
    id: '1802020038',
    districtId: '1802020',
    name: 'Bentengan Jaya',
  },
  {
    id: '1802021001',
    districtId: '1802021',
    name: 'Tampang',
  },
  {
    id: '1802021002',
    districtId: '1802021',
    name: 'Kaur Gading',
  },
  {
    id: '1802021003',
    districtId: '1802021',
    name: 'Tirom',
  },
  {
    id: '1802021004',
    districtId: '1802021',
    name: 'Way Nipah',
  },
  {
    id: '1802021005',
    districtId: '1802021',
    name: 'Guring',
  },
  {
    id: '1802021006',
    districtId: '1802021',
    name: 'Betung',
  },
  {
    id: '1802021007',
    districtId: '1802021',
    name: 'Tanjungan',
  },
  {
    id: '1802021011',
    districtId: '1802021',
    name: 'Teluk Brak',
  },
  {
    id: '1802021012',
    districtId: '1802021',
    name: 'Karang Brak',
  },
  {
    id: '1802021013',
    districtId: '1802021',
    name: 'Pesanguan',
  },
  {
    id: '1802021014',
    districtId: '1802021',
    name: 'Way Asahan',
  },
  {
    id: '1802021015',
    districtId: '1802021',
    name: 'Tampang Muda',
  },
  {
    id: '1802021016',
    districtId: '1802021',
    name: 'Kampung Baru',
  },
  {
    id: '1802021017',
    districtId: '1802021',
    name: 'Matanda',
  },
  {
    id: '1802022001',
    districtId: '1802022',
    name: 'Teba',
  },
  {
    id: '1802022002',
    districtId: '1802022',
    name: 'Karta',
  },
  {
    id: '1802022003',
    districtId: '1802022',
    name: 'Tanjung Anom',
  },
  {
    id: '1802022004',
    districtId: '1802022',
    name: 'Umbul Buah',
  },
  {
    id: '1802022005',
    districtId: '1802022',
    name: 'Kagungan',
  },
  {
    id: '1802022006',
    districtId: '1802022',
    name: 'Suka Banjar',
  },
  {
    id: '1802022007',
    districtId: '1802022',
    name: 'Menggala',
  },
  {
    id: '1802022008',
    districtId: '1802022',
    name: 'Mulang Maya',
  },
  {
    id: '1802022009',
    districtId: '1802022',
    name: 'Kampung Baru',
  },
  {
    id: '1802022010',
    districtId: '1802022',
    name: 'Batu Keramat',
  },
  {
    id: '1802022011',
    districtId: '1802022',
    name: 'Talang Rejo',
  },
  {
    id: '1802022012',
    districtId: '1802022',
    name: 'Tanjung Jati',
  },
  {
    id: '1802023001',
    districtId: '1802023',
    name: 'Belu',
  },
  {
    id: '1802023002',
    districtId: '1802023',
    name: 'Negara Batin',
  },
  {
    id: '1802023003',
    districtId: '1802023',
    name: 'Banjar Masin',
  },
  {
    id: '1802023004',
    districtId: '1802023',
    name: 'Kanyangan',
  },
  {
    id: '1802023005',
    districtId: '1802023',
    name: 'Kali Miring',
  },
  {
    id: '1802023006',
    districtId: '1802023',
    name: 'Payung',
  },
  {
    id: '1802023007',
    districtId: '1802023',
    name: 'Maja',
  },
  {
    id: '1802023008',
    districtId: '1802023',
    name: 'Pulau Benawang',
  },
  {
    id: '1802023009',
    districtId: '1802023',
    name: 'Gedung Jambu',
  },
  {
    id: '1802023010',
    districtId: '1802023',
    name: 'Kandang Besi',
  },
  {
    id: '1802023011',
    districtId: '1802023',
    name: 'Teba Bunuk',
  },
  {
    id: '1802023012',
    districtId: '1802023',
    name: 'Way Gelang',
  },
  {
    id: '1802023013',
    districtId: '1802023',
    name: 'Tela Gening',
  },
  {
    id: '1802023014',
    districtId: '1802023',
    name: 'Kesugihan',
  },
  {
    id: '1802023015',
    districtId: '1802023',
    name: 'Pajajaran',
  },
  {
    id: '1802023016',
    districtId: '1802023',
    name: 'Tanjung Agung',
  },
  {
    id: '1802030001',
    districtId: '1802030',
    name: 'Talang Beringin',
  },
  {
    id: '1802030002',
    districtId: '1802030',
    name: 'Gunung Megang',
  },
  {
    id: '1802030003',
    districtId: '1802030',
    name: 'Tanjung Rejo',
  },
  {
    id: '1802030004',
    districtId: '1802030',
    name: 'Tanjung Begelung',
  },
  {
    id: '1802030005',
    districtId: '1802030',
    name: 'Sinar Mulyo',
  },
  {
    id: '1802030006',
    districtId: '1802030',
    name: 'Kemuning',
  },
  {
    id: '1802030007',
    districtId: '1802030',
    name: 'Gedung Agung',
  },
  {
    id: '1802030008',
    districtId: '1802030',
    name: 'Penantian',
  },
  {
    id: '1802030009',
    districtId: '1802030',
    name: 'Muara Dua',
  },
  {
    id: '1802030010',
    districtId: '1802030',
    name: 'Tekad',
  },
  {
    id: '1802030014',
    districtId: '1802030',
    name: 'Pulau Panggung',
  },
  {
    id: '1802030016',
    districtId: '1802030',
    name: 'Way Ilahan',
  },
  {
    id: '1802030017',
    districtId: '1802030',
    name: 'Gunung Meraksa',
  },
  {
    id: '1802030018',
    districtId: '1802030',
    name: 'Batu Bedil',
  },
  {
    id: '1802030019',
    districtId: '1802030',
    name: 'Air Bakoman',
  },
  {
    id: '1802030020',
    districtId: '1802030',
    name: 'Sumber Mulya',
  },
  {
    id: '1802030021',
    districtId: '1802030',
    name: 'Sindang Marga',
  },
  {
    id: '1802030022',
    districtId: '1802030',
    name: 'Talang Jawa',
  },
  {
    id: '1802030023',
    districtId: '1802030',
    name: 'Tanjung Gunung',
  },
  {
    id: '1802030024',
    districtId: '1802030',
    name: 'Sinar Mancak',
  },
  {
    id: '1802030025',
    districtId: '1802030',
    name: 'Sri Menganten',
  },
  {
    id: '1802031001',
    districtId: '1802031',
    name: 'Datarajan',
  },
  {
    id: '1802031002',
    districtId: '1802031',
    name: 'Gunungtiga',
  },
  {
    id: '1802031003',
    districtId: '1802031',
    name: 'Karangrejo',
  },
  {
    id: '1802031004',
    districtId: '1802031',
    name: 'Pagaralam Ulubelu',
  },
  {
    id: '1802031005',
    districtId: '1802031',
    name: 'Muaradua Ulubelu',
  },
  {
    id: '1802031006',
    districtId: '1802031',
    name: 'Ngarip',
  },
  {
    id: '1802031007',
    districtId: '1802031',
    name: 'Penantian Ulubelu',
  },
  {
    id: '1802031008',
    districtId: '1802031',
    name: 'Gunungsari',
  },
  {
    id: '1802031009',
    districtId: '1802031',
    name: 'Sirnagalih',
  },
  {
    id: '1802031010',
    districtId: '1802031',
    name: 'Ulu Semong',
  },
  {
    id: '1802031011',
    districtId: '1802031',
    name: 'Rejosari',
  },
  {
    id: '1802031012',
    districtId: '1802031',
    name: 'Sukamaju',
  },
  {
    id: '1802031013',
    districtId: '1802031',
    name: 'Tanjung Baru',
  },
  {
    id: '1802031014',
    districtId: '1802031',
    name: 'Sinar Banten',
  },
  {
    id: '1802031015',
    districtId: '1802031',
    name: 'Air Abang',
  },
  {
    id: '1802031016',
    districtId: '1802031',
    name: 'Petay Kayu',
  },
  {
    id: '1802032001',
    districtId: '1802032',
    name: 'Way Harong',
  },
  {
    id: '1802032002',
    districtId: '1802032',
    name: 'Air Kubang',
  },
  {
    id: '1802032003',
    districtId: '1802032',
    name: 'Karang Sari',
  },
  {
    id: '1802032004',
    districtId: '1802032',
    name: 'Sidomulyo',
  },
  {
    id: '1802032005',
    districtId: '1802032',
    name: 'Air Naningan',
  },
  {
    id: '1802032006',
    districtId: '1802032',
    name: 'Sinar Jawa',
  },
  {
    id: '1802032007',
    districtId: '1802032',
    name: 'Datar Lebuay',
  },
  {
    id: '1802032008',
    districtId: '1802032',
    name: 'Batu Tegi',
  },
  {
    id: '1802032009',
    districtId: '1802032',
    name: 'Sinar Sekampung',
  },
  {
    id: '1802032010',
    districtId: '1802032',
    name: 'Margo Mulyo',
  },
  {
    id: '1802040019',
    districtId: '1802040',
    name: 'Kalibening',
  },
  {
    id: '1802040022',
    districtId: '1802040',
    name: 'Kejayaan',
  },
  {
    id: '1802040023',
    districtId: '1802040',
    name: 'Sukabumi',
  },
  {
    id: '1802040024',
    districtId: '1802040',
    name: 'Sukanegeri Jaya',
  },
  {
    id: '1802040025',
    districtId: '1802040',
    name: 'Banjarsari',
  },
  {
    id: '1802040026',
    districtId: '1802040',
    name: 'Singosari',
  },
  {
    id: '1802040031',
    districtId: '1802040',
    name: 'Sinar Banten',
  },
  {
    id: '1802040032',
    districtId: '1802040',
    name: 'Sukarame',
  },
  {
    id: '1802040033',
    districtId: '1802040',
    name: 'Banding Agung',
  },
  {
    id: '1802040034',
    districtId: '1802040',
    name: 'Talang Padang',
  },
  {
    id: '1802040035',
    districtId: '1802040',
    name: 'Suka Negeri',
  },
  {
    id: '1802040036',
    districtId: '1802040',
    name: 'Suka Bandung',
  },
  {
    id: '1802040037',
    districtId: '1802040',
    name: 'Suka Merindu',
  },
  {
    id: '1802040038',
    districtId: '1802040',
    name: 'Sinar Semendo',
  },
  {
    id: '1802040039',
    districtId: '1802040',
    name: 'Negeri Agung',
  },
  {
    id: '1802040040',
    districtId: '1802040',
    name: 'Sinar Petir',
  },
  {
    id: '1802040041',
    districtId: '1802040',
    name: 'Way Halom',
  },
  {
    id: '1802040042',
    districtId: '1802040',
    name: 'Talang Sepuh',
  },
  {
    id: '1802040043',
    districtId: '1802040',
    name: 'Sinar Harapan',
  },
  {
    id: '1802040044',
    districtId: '1802040',
    name: 'Sinar Betung',
  },
  {
    id: '1802041001',
    districtId: '1802041',
    name: 'Margoyoso',
  },
  {
    id: '1802041002',
    districtId: '1802041',
    name: 'Dadapan',
  },
  {
    id: '1802041003',
    districtId: '1802041',
    name: 'Simpang Kanan',
  },
  {
    id: '1802041004',
    districtId: '1802041',
    name: 'Margodadi',
  },
  {
    id: '1802041005',
    districtId: '1802041',
    name: 'Argopeni',
  },
  {
    id: '1802041006',
    districtId: '1802041',
    name: 'Sumber Mulyo',
  },
  {
    id: '1802041007',
    districtId: '1802041',
    name: 'Wonoharjo',
  },
  {
    id: '1802041008',
    districtId: '1802041',
    name: 'Tegal Binangun',
  },
  {
    id: '1802041009',
    districtId: '1802041',
    name: 'Sumberrejo',
  },
  {
    id: '1802041010',
    districtId: '1802041',
    name: 'Sidomulyo',
  },
  {
    id: '1802041011',
    districtId: '1802041',
    name: 'Kebumen',
  },
  {
    id: '1802041012',
    districtId: '1802041',
    name: 'Argomulyo',
  },
  {
    id: '1802041013',
    districtId: '1802041',
    name: 'Sidorejo',
  },
  {
    id: '1802042001',
    districtId: '1802042',
    name: 'Gisting Atas',
  },
  {
    id: '1802042002',
    districtId: '1802042',
    name: 'Gisting Bawah',
  },
  {
    id: '1802042003',
    districtId: '1802042',
    name: 'Purwodadi',
  },
  {
    id: '1802042004',
    districtId: '1802042',
    name: 'Kuta Dalom',
  },
  {
    id: '1802042005',
    districtId: '1802042',
    name: 'Banjarmanis',
  },
  {
    id: '1802042006',
    districtId: '1802042',
    name: 'Campang',
  },
  {
    id: '1802042007',
    districtId: '1802042',
    name: 'Sidokaton',
  },
  {
    id: '1802042008',
    districtId: '1802042',
    name: 'Lanbauw',
  },
  {
    id: '1802042009',
    districtId: '1802042',
    name: 'Gisting Permai',
  },
  {
    id: '1802043001',
    districtId: '1802043',
    name: 'Banjar Negeri',
  },
  {
    id: '1802043002',
    districtId: '1802043',
    name: 'Ciherang',
  },
  {
    id: '1802043003',
    districtId: '1802043',
    name: 'Sukaraja',
  },
  {
    id: '1802043004',
    districtId: '1802043',
    name: 'Banjar Agung',
  },
  {
    id: '1802043005',
    districtId: '1802043',
    name: 'Kedaloman',
  },
  {
    id: '1802043006',
    districtId: '1802043',
    name: 'Sukabanjar',
  },
  {
    id: '1802043007',
    districtId: '1802043',
    name: 'Sukamernah',
  },
  {
    id: '1802043008',
    districtId: '1802043',
    name: 'Pariaman',
  },
  {
    id: '1802043009',
    districtId: '1802043',
    name: 'Sukadamai',
  },
  {
    id: '1802043010',
    districtId: '1802043',
    name: 'Way Halom',
  },
  {
    id: '1802043011',
    districtId: '1802043',
    name: 'Penanggungan',
  },
  {
    id: '1802043012',
    districtId: '1802043',
    name: 'Darus Salam',
  },
  {
    id: '1802050001',
    districtId: '1802050',
    name: 'Tamansari',
  },
  {
    id: '1802050002',
    districtId: '1802050',
    name: 'Campang Way Handak',
  },
  {
    id: '1802050003',
    districtId: '1802050',
    name: 'Gading',
  },
  {
    id: '1802050004',
    districtId: '1802050',
    name: 'Sumanda',
  },
  {
    id: '1802050005',
    districtId: '1802050',
    name: 'Tanjung Agung',
  },
  {
    id: '1802050006',
    districtId: '1802050',
    name: 'Babakan',
  },
  {
    id: '1802050007',
    districtId: '1802050',
    name: 'Gunung Kasih',
  },
  {
    id: '1802050008',
    districtId: '1802050',
    name: 'Tanjung Kemala',
  },
  {
    id: '1802050009',
    districtId: '1802050',
    name: 'Binjai Wangi',
  },
  {
    id: '1802050010',
    districtId: '1802050',
    name: 'Sukajadi',
  },
  {
    id: '1802050011',
    districtId: '1802050',
    name: 'Rantau Tijang',
  },
  {
    id: '1802050012',
    districtId: '1802050',
    name: 'Sinar Agung',
  },
  {
    id: '1802050013',
    districtId: '1802050',
    name: 'Negeri Ratu',
  },
  {
    id: '1802050014',
    districtId: '1802050',
    name: 'Way Jaha',
  },
  {
    id: '1802050015',
    districtId: '1802050',
    name: 'Tiuh Memon',
  },
  {
    id: '1802050016',
    districtId: '1802050',
    name: 'Banjar Agung Ilir',
  },
  {
    id: '1802050017',
    districtId: '1802050',
    name: 'Banjar Agung Udik',
  },
  {
    id: '1802050018',
    districtId: '1802050',
    name: 'Tanjung Heran',
  },
  {
    id: '1802050019',
    districtId: '1802050',
    name: 'Tangkit Serdang',
  },
  {
    id: '1802050020',
    districtId: '1802050',
    name: 'Way Pring',
  },
  {
    id: '1802050021',
    districtId: '1802050',
    name: 'Pungkut',
  },
  {
    id: '1802050022',
    districtId: '1802050',
    name: 'Sukamaju',
  },
  {
    id: '1802050023',
    districtId: '1802050',
    name: 'Sukamulya',
  },
  {
    id: '1802050024',
    districtId: '1802050',
    name: 'Kayu Hubi',
  },
  {
    id: '1802050025',
    districtId: '1802050',
    name: 'Gunung Tiga',
  },
  {
    id: '1802050026',
    districtId: '1802050',
    name: 'Way Manak',
  },
  {
    id: '1802050027',
    districtId: '1802050',
    name: 'Talang Lebar',
  },
  {
    id: '1802101001',
    districtId: '1802101',
    name: 'Sinarpetir',
  },
  {
    id: '1802101002',
    districtId: '1802101',
    name: 'Napal',
  },
  {
    id: '1802101003',
    districtId: '1802101',
    name: 'Gunung Terang',
  },
  {
    id: '1802101004',
    districtId: '1802101',
    name: 'Banjar Masin',
  },
  {
    id: '1802101005',
    districtId: '1802101',
    name: 'Sukamara',
  },
  {
    id: '1802101006',
    districtId: '1802101',
    name: 'Sukanegara',
  },
  {
    id: '1802101007',
    districtId: '1802101',
    name: 'Suka Agung Timur',
  },
  {
    id: '1802101008',
    districtId: '1802101',
    name: 'Suka Agung Barat',
  },
  {
    id: '1802101009',
    districtId: '1802101',
    name: 'Pematang Nebak',
  },
  {
    id: '1802101010',
    districtId: '1802101',
    name: 'Tanjung Sari',
  },
  {
    id: '1802110001',
    districtId: '1802110',
    name: 'Karang Buah',
  },
  {
    id: '1802110002',
    districtId: '1802110',
    name: 'Sawang Balak',
  },
  {
    id: '1802110012',
    districtId: '1802110',
    name: 'Sukaraja',
  },
  {
    id: '1802110013',
    districtId: '1802110',
    name: 'Banjar Negeri',
  },
  {
    id: '1802110014',
    districtId: '1802110',
    name: 'Gedung',
  },
  {
    id: '1802110015',
    districtId: '1802110',
    name: 'Kejadianlom',
  },
  {
    id: '1802110016',
    districtId: '1802110',
    name: 'Sukapadang',
  },
  {
    id: '1802110017',
    districtId: '1802110',
    name: 'Kacamarga',
  },
  {
    id: '1802110018',
    districtId: '1802110',
    name: 'Pampangan',
  },
  {
    id: '1802110019',
    districtId: '1802110',
    name: 'Tanjung Jati',
  },
  {
    id: '1802110021',
    districtId: '1802110',
    name: 'Tanjung Raja',
  },
  {
    id: '1802110022',
    districtId: '1802110',
    name: 'Way Rilau',
  },
  {
    id: '1802110023',
    districtId: '1802110',
    name: 'Tengor',
  },
  {
    id: '1802110024',
    districtId: '1802110',
    name: 'Banjar Manis',
  },
  {
    id: '1802110025',
    districtId: '1802110',
    name: 'Tanjung Betuah',
  },
  {
    id: '1802110026',
    districtId: '1802110',
    name: 'Putih Doh',
  },
  {
    id: '1802110027',
    districtId: '1802110',
    name: 'Pekon Doh',
  },
  {
    id: '1802110038',
    districtId: '1802110',
    name: 'Kubu Langka',
  },
  {
    id: '1802110039',
    districtId: '1802110',
    name: 'Kuta Kakhang',
  },
  {
    id: '1802110040',
    districtId: '1802110',
    name: 'Suka Banjar',
  },
  {
    id: '1802111001',
    districtId: '1802111',
    name: 'Umbar',
  },
  {
    id: '1802111002',
    districtId: '1802111',
    name: 'Paku',
  },
  {
    id: '1802111003',
    districtId: '1802111',
    name: 'Napal',
  },
  {
    id: '1802111004',
    districtId: '1802111',
    name: 'Negeri Kelumbayan',
  },
  {
    id: '1802111005',
    districtId: '1802111',
    name: 'Pekon Susuk',
  },
  {
    id: '1802111006',
    districtId: '1802111',
    name: 'Penyandingan',
  },
  {
    id: '1802111007',
    districtId: '1802111',
    name: 'Pekon Unggak',
  },
  {
    id: '1802111008',
    districtId: '1802111',
    name: 'Kiluan Negeri',
  },
  {
    id: '1802112001',
    districtId: '1802112',
    name: 'Badak',
  },
  {
    id: '1802112002',
    districtId: '1802112',
    name: 'Kuripan',
  },
  {
    id: '1802112003',
    districtId: '1802112',
    name: 'Tegineneng',
  },
  {
    id: '1802112004',
    districtId: '1802112',
    name: 'Ketapang',
  },
  {
    id: '1802112005',
    districtId: '1802112',
    name: 'Padang Ratu',
  },
  {
    id: '1802112006',
    districtId: '1802112',
    name: 'Banjar Agung',
  },
  {
    id: '1802112007',
    districtId: '1802112',
    name: 'Pekon Ampai',
  },
  {
    id: '1802112008',
    districtId: '1802112',
    name: 'Pariaman',
  },
  {
    id: '1802112009',
    districtId: '1802112',
    name: 'Antarbrak',
  },
  {
    id: '1802112010',
    districtId: '1802112',
    name: 'Tanjung Siom',
  },
  {
    id: '1802112011',
    districtId: '1802112',
    name: 'Tanjung Jaya',
  },
  {
    id: '1802113001',
    districtId: '1802113',
    name: 'Sidoharjo',
  },
  {
    id: '1802113002',
    districtId: '1802113',
    name: 'Lengkukai',
  },
  {
    id: '1802113003',
    districtId: '1802113',
    name: 'Merbau',
  },
  {
    id: '1802113004',
    districtId: '1802113',
    name: 'Batu Patah',
  },
  {
    id: '1802113005',
    districtId: '1802113',
    name: 'Purwosari',
  },
  {
    id: '1802113006',
    districtId: '1802113',
    name: 'Margamulya',
  },
  {
    id: '1803060001',
    districtId: '1803060',
    name: 'Hajimena',
  },
  {
    id: '1803060002',
    districtId: '1803060',
    name: 'Sidosari',
  },
  {
    id: '1803060003',
    districtId: '1803060',
    name: 'Pemanggilan',
  },
  {
    id: '1803060004',
    districtId: '1803060',
    name: 'Natar',
  },
  {
    id: '1803060005',
    districtId: '1803060',
    name: 'Merak Batin',
  },
  {
    id: '1803060006',
    districtId: '1803060',
    name: 'Krawang Sari',
  },
  {
    id: '1803060007',
    districtId: '1803060',
    name: 'Muara Putih',
  },
  {
    id: '1803060008',
    districtId: '1803060',
    name: 'Tanjungsari',
  },
  {
    id: '1803060009',
    districtId: '1803060',
    name: 'Negara Ratu',
  },
  {
    id: '1803060010',
    districtId: '1803060',
    name: 'Rejosari',
  },
  {
    id: '1803060011',
    districtId: '1803060',
    name: 'Bumisari',
  },
  {
    id: '1803060012',
    districtId: '1803060',
    name: 'Candi Mas',
  },
  {
    id: '1803060013',
    districtId: '1803060',
    name: 'Pancasila',
  },
  {
    id: '1803060014',
    districtId: '1803060',
    name: 'Sukadamai',
  },
  {
    id: '1803060015',
    districtId: '1803060',
    name: 'Bandarejo',
  },
  {
    id: '1803060016',
    districtId: '1803060',
    name: 'Purwosari',
  },
  {
    id: '1803060017',
    districtId: '1803060',
    name: 'Rulung Raya',
  },
  {
    id: '1803060018',
    districtId: '1803060',
    name: 'Brantiraya',
  },
  {
    id: '1803060019',
    districtId: '1803060',
    name: 'Haduyang',
  },
  {
    id: '1803060020',
    districtId: '1803060',
    name: 'Banjarnegeri',
  },
  {
    id: '1803060021',
    districtId: '1803060',
    name: 'Mandah',
  },
  {
    id: '1803060022',
    districtId: '1803060',
    name: 'Rulunghelok',
  },
  {
    id: '1803060023',
    districtId: '1803060',
    name: 'Kali Sari',
  },
  {
    id: '1803060024',
    districtId: '1803060',
    name: 'Wai Sari',
  },
  {
    id: '1803060025',
    districtId: '1803060',
    name: 'Rulung Mulya',
  },
  {
    id: '1803060026',
    districtId: '1803060',
    name: 'Rulung Sari',
  },
  {
    id: '1803070001',
    districtId: '1803070',
    name: 'Way Huwi',
  },
  {
    id: '1803070002',
    districtId: '1803070',
    name: 'Jatimulyo',
  },
  {
    id: '1803070003',
    districtId: '1803070',
    name: 'Banjar Agung',
  },
  {
    id: '1803070004',
    districtId: '1803070',
    name: 'Gedung Harapan',
  },
  {
    id: '1803070005',
    districtId: '1803070',
    name: 'Gedung Agung',
  },
  {
    id: '1803070006',
    districtId: '1803070',
    name: 'Margomulyo',
  },
  {
    id: '1803070007',
    districtId: '1803070',
    name: 'Sidodadi Asri',
  },
  {
    id: '1803070008',
    districtId: '1803070',
    name: 'Purwotani',
  },
  {
    id: '1803070009',
    districtId: '1803070',
    name: 'Sumber Jaya',
  },
  {
    id: '1803070010',
    districtId: '1803070',
    name: 'Margodadi',
  },
  {
    id: '1803070011',
    districtId: '1803070',
    name: 'Margo Lestari',
  },
  {
    id: '1803070012',
    districtId: '1803070',
    name: 'Marga Agung',
  },
  {
    id: '1803070013',
    districtId: '1803070',
    name: 'Marga Kaya',
  },
  {
    id: '1803070014',
    districtId: '1803070',
    name: 'Sinar Rejeki',
  },
  {
    id: '1803070015',
    districtId: '1803070',
    name: 'Sidoharjo',
  },
  {
    id: '1803070016',
    districtId: '1803070',
    name: 'Rejomulyo',
  },
  {
    id: '1803070017',
    districtId: '1803070',
    name: 'Karang Anyar',
  },
  {
    id: '1803070018',
    districtId: '1803070',
    name: 'Fajar Baru',
  },
  {
    id: '1803070019',
    districtId: '1803070',
    name: 'Karang Sari',
  },
  {
    id: '1803070020',
    districtId: '1803070',
    name: 'Karang Rejo',
  },
  {
    id: '1803070021',
    districtId: '1803070',
    name: 'Margorejo',
  },
  {
    id: '1803080001',
    districtId: '1803080',
    name: 'Kali Asin',
  },
  {
    id: '1803080002',
    districtId: '1803080',
    name: 'Lematang',
  },
  {
    id: '1803080003',
    districtId: '1803080',
    name: 'Sabah Balau',
  },
  {
    id: '1803080004',
    districtId: '1803080',
    name: 'Sukanegara',
  },
  {
    id: '1803080005',
    districtId: '1803080',
    name: 'Galih Lunik',
  },
  {
    id: '1803080006',
    districtId: '1803080',
    name: 'Serdang',
  },
  {
    id: '1803080007',
    districtId: '1803080',
    name: 'Sinar Ogan',
  },
  {
    id: '1803080008',
    districtId: '1803080',
    name: 'Budi Lestari',
  },
  {
    id: '1803080009',
    districtId: '1803080',
    name: 'Jatibaru',
  },
  {
    id: '1803080010',
    districtId: '1803080',
    name: 'Jati Indah',
  },
  {
    id: '1803080011',
    districtId: '1803080',
    name: 'Trimulyo',
  },
  {
    id: '1803080019',
    districtId: '1803080',
    name: 'Sindang Sari',
  },
  {
    id: '1803080020',
    districtId: '1803080',
    name: 'Purwodadi Simpang',
  },
  {
    id: '1803080021',
    districtId: '1803080',
    name: 'Way Galih',
  },
  {
    id: '1803080023',
    districtId: '1803080',
    name: 'Rejomulyo',
  },
  {
    id: '1803080024',
    districtId: '1803080',
    name: 'Srikaton',
  },
  {
    id: '1803081001',
    districtId: '1803081',
    name: 'Sidomukti',
  },
  {
    id: '1803081002',
    districtId: '1803081',
    name: 'Wawasan',
  },
  {
    id: '1803081003',
    districtId: '1803081',
    name: 'Bangunsari',
  },
  {
    id: '1803081004',
    districtId: '1803081',
    name: 'Mulyo Sari',
  },
  {
    id: '1803081005',
    districtId: '1803081',
    name: 'Kertosari',
  },
  {
    id: '1803081006',
    districtId: '1803081',
    name: 'Wonodadi',
  },
  {
    id: '1803081007',
    districtId: '1803081',
    name: 'Purwodadi Dalam',
  },
  {
    id: '1803081008',
    districtId: '1803081',
    name: 'Malang Sari',
  },
  {
    id: '1803090001',
    districtId: '1803090',
    name: 'Tarahan',
  },
  {
    id: '1803090002',
    districtId: '1803090',
    name: 'Karya Tunggal',
  },
  {
    id: '1803090003',
    districtId: '1803090',
    name: 'Babatan',
  },
  {
    id: '1803090004',
    districtId: '1803090',
    name: 'Pardasuka',
  },
  {
    id: '1803090005',
    districtId: '1803090',
    name: 'Sukajaya',
  },
  {
    id: '1803090006',
    districtId: '1803090',
    name: 'Tanjungratu',
  },
  {
    id: '1803090007',
    districtId: '1803090',
    name: 'Tanjungagung',
  },
  {
    id: '1803090008',
    districtId: '1803090',
    name: 'Tanjungan',
  },
  {
    id: '1803090009',
    districtId: '1803090',
    name: 'Trans Tanjungan',
  },
  {
    id: '1803090024',
    districtId: '1803090',
    name: 'Neglasari',
  },
  {
    id: '1803090032',
    districtId: '1803090',
    name: 'Rangai Tri Tunggal',
  },
  {
    id: '1803090033',
    districtId: '1803090',
    name: 'Sido Mekar',
  },
  {
    id: '1803091001',
    districtId: '1803091',
    name: 'Tanjung Baru',
  },
  {
    id: '1803091002',
    districtId: '1803091',
    name: 'Baru Ranji',
  },
  {
    id: '1803091003',
    districtId: '1803091',
    name: 'Karang Raja',
  },
  {
    id: '1803091004',
    districtId: '1803091',
    name: 'Mekar Jaya',
  },
  {
    id: '1803091005',
    districtId: '1803091',
    name: 'Suban',
  },
  {
    id: '1803091006',
    districtId: '1803091',
    name: 'Merbau Mataram',
  },
  {
    id: '1803091007',
    districtId: '1803091',
    name: 'Triharjo',
  },
  {
    id: '1803091008',
    districtId: '1803091',
    name: 'Panca Tunggal',
  },
  {
    id: '1803091009',
    districtId: '1803091',
    name: 'Talang Jawa',
  },
  {
    id: '1803091010',
    districtId: '1803091',
    name: 'Lebungsari',
  },
  {
    id: '1803091011',
    districtId: '1803091',
    name: 'Pujirahayu',
  },
  {
    id: '1803091012',
    districtId: '1803091',
    name: 'Batuagung',
  },
  {
    id: '1803091013',
    districtId: '1803091',
    name: 'Sinar Karya',
  },
  {
    id: '1803091014',
    districtId: '1803091',
    name: 'Tanjung Harapan',
  },
  {
    id: '1803091015',
    districtId: '1803091',
    name: 'Karang Jaya',
  },
  {
    id: '1803092001',
    districtId: '1803092',
    name: 'Pemulihan',
  },
  {
    id: '1803092002',
    districtId: '1803092',
    name: 'Purwodadi',
  },
  {
    id: '1803092003',
    districtId: '1803092',
    name: 'Sukamaju',
  },
  {
    id: '1803092004',
    districtId: '1803092',
    name: 'Banjarsari',
  },
  {
    id: '1803092005',
    districtId: '1803092',
    name: 'Karang Pucung',
  },
  {
    id: '1803092006',
    districtId: '1803092',
    name: 'Talang Way Sulan',
  },
  {
    id: '1803092007',
    districtId: '1803092',
    name: 'Sumberagung',
  },
  {
    id: '1803092008',
    districtId: '1803092',
    name: 'Mekarsari',
  },
  {
    id: '1803100001',
    districtId: '1803100',
    name: 'Suak',
  },
  {
    id: '1803100002',
    districtId: '1803100',
    name: 'Siring Jaha',
  },
  {
    id: '1803100003',
    districtId: '1803100',
    name: 'Budi Daya',
  },
  {
    id: '1803100004',
    districtId: '1803100',
    name: 'Sukamaju',
  },
  {
    id: '1803100005',
    districtId: '1803100',
    name: 'Sukamarga',
  },
  {
    id: '1803100006',
    districtId: '1803100',
    name: 'Sidowaluyo',
  },
  {
    id: '1803100012',
    districtId: '1803100',
    name: 'Sidorejo',
  },
  {
    id: '1803100013',
    districtId: '1803100',
    name: 'Sidodadi',
  },
  {
    id: '1803100014',
    districtId: '1803100',
    name: 'Seloretno',
  },
  {
    id: '1803100015',
    districtId: '1803100',
    name: 'Kota Dalam',
  },
  {
    id: '1803100016',
    districtId: '1803100',
    name: 'Sukabanjar',
  },
  {
    id: '1803100017',
    districtId: '1803100',
    name: 'Talang Baru',
  },
  {
    id: '1803100018',
    districtId: '1803100',
    name: 'Bandar Dalam',
  },
  {
    id: '1803100019',
    districtId: '1803100',
    name: 'Campang Tiga',
  },
  {
    id: '1803100020',
    districtId: '1803100',
    name: 'Sidomulyo',
  },
  {
    id: '1803100021',
    districtId: '1803100',
    name: 'Banjar Suri',
  },
  {
    id: '1803101001',
    districtId: '1803101',
    name: 'Rantau Minyak',
  },
  {
    id: '1803101002',
    districtId: '1803101',
    name: 'Sidoasri',
  },
  {
    id: '1803101003',
    districtId: '1803101',
    name: 'Way Gelam',
  },
  {
    id: '1803101004',
    districtId: '1803101',
    name: 'Candipuro/Titiwangi',
  },
  {
    id: '1803101005',
    districtId: '1803101',
    name: 'Trimomukti',
  },
  {
    id: '1803101006',
    districtId: '1803101',
    name: 'Bumi Jaya',
  },
  {
    id: '1803101007',
    districtId: '1803101',
    name: 'Rawa Selapan',
  },
  {
    id: '1803101008',
    districtId: '1803101',
    name: 'Sinar Pasemah',
  },
  {
    id: '1803101009',
    districtId: '1803101',
    name: 'Beringin Kencana',
  },
  {
    id: '1803101010',
    districtId: '1803101',
    name: 'Banyumas',
  },
  {
    id: '1803101011',
    districtId: '1803101',
    name: 'Cintamulya',
  },
  {
    id: '1803101012',
    districtId: '1803101',
    name: 'Sinar Palembang',
  },
  {
    id: '1803101013',
    districtId: '1803101',
    name: 'Karya Mulya Sari',
  },
  {
    id: '1803101014',
    districtId: '1803101',
    name: 'Batuliman Indah',
  },
  {
    id: '1803102001',
    districtId: '1803102',
    name: 'Sidoharjo',
  },
  {
    id: '1803102002',
    districtId: '1803102',
    name: 'Sidomakmur',
  },
  {
    id: '1803102003',
    districtId: '1803102',
    name: 'Sidoreno',
  },
  {
    id: '1803102004',
    districtId: '1803102',
    name: 'Balinuraga',
  },
  {
    id: '1803110016',
    districtId: '1803110',
    name: 'Jondong',
  },
  {
    id: '1803110017',
    districtId: '1803110',
    name: 'Tengkujuh',
  },
  {
    id: '1803110018',
    districtId: '1803110',
    name: 'Pauh Tanjung Iman',
  },
  {
    id: '1803110019',
    districtId: '1803110',
    name: 'Maja',
  },
  {
    id: '1803110020',
    districtId: '1803110',
    name: 'Bumi Agung',
  },
  {
    id: '1803110021',
    districtId: '1803110',
    name: 'Kalianda',
  },
  {
    id: '1803110022',
    districtId: '1803110',
    name: 'Sumur Kumbang',
  },
  {
    id: '1803110023',
    districtId: '1803110',
    name: 'Buah Berak',
  },
  {
    id: '1803110024',
    districtId: '1803110',
    name: 'Kesugihan',
  },
  {
    id: '1803110025',
    districtId: '1803110',
    name: 'Pematang',
  },
  {
    id: '1803110026',
    districtId: '1803110',
    name: 'Kecapi',
  },
  {
    id: '1803110027',
    districtId: '1803110',
    name: 'Babulang',
  },
  {
    id: '1803110028',
    districtId: '1803110',
    name: 'Sukaratu',
  },
  {
    id: '1803110029',
    districtId: '1803110',
    name: 'Palembapang',
  },
  {
    id: '1803110030',
    districtId: '1803110',
    name: 'Tajimalela',
  },
  {
    id: '1803110031',
    districtId: '1803110',
    name: 'Marga Catur',
  },
  {
    id: '1803110032',
    districtId: '1803110',
    name: 'Suka Tani',
  },
  {
    id: '1803110033',
    districtId: '1803110',
    name: 'Canggu',
  },
  {
    id: '1803110034',
    districtId: '1803110',
    name: 'Kedaton',
  },
  {
    id: '1803110035',
    districtId: '1803110',
    name: 'Way Urang',
  },
  {
    id: '1803110036',
    districtId: '1803110',
    name: 'Merak Belantung',
  },
  {
    id: '1803110037',
    districtId: '1803110',
    name: 'Gunung Terang',
  },
  {
    id: '1803110038',
    districtId: '1803110',
    name: 'Munjuk Sempurna',
  },
  {
    id: '1803110039',
    districtId: '1803110',
    name: 'Bulok',
  },
  {
    id: '1803110040',
    districtId: '1803110',
    name: 'Agom',
  },
  {
    id: '1803110041',
    districtId: '1803110',
    name: 'Negeri Pandan',
  },
  {
    id: '1803110042',
    districtId: '1803110',
    name: 'Taman Agung',
  },
  {
    id: '1803110043',
    districtId: '1803110',
    name: 'Wai Lubuk',
  },
  {
    id: '1803110044',
    districtId: '1803110',
    name: 'Hara Banjar Manis',
  },
  {
    id: '1803111001',
    districtId: '1803111',
    name: 'Tejang Pulau Sebesi',
  },
  {
    id: '1803111002',
    districtId: '1803111',
    name: 'Hargo Pancoran',
  },
  {
    id: '1803111003',
    districtId: '1803111',
    name: 'Kerinjing',
  },
  {
    id: '1803111004',
    districtId: '1803111',
    name: 'Cugung',
  },
  {
    id: '1803111005',
    districtId: '1803111',
    name: 'Batu Balak',
  },
  {
    id: '1803111006',
    districtId: '1803111',
    name: 'Kunjir',
  },
  {
    id: '1803111007',
    districtId: '1803111',
    name: 'Waymuli',
  },
  {
    id: '1803111008',
    districtId: '1803111',
    name: 'Sukaraja',
  },
  {
    id: '1803111009',
    districtId: '1803111',
    name: 'Rajabasa',
  },
  {
    id: '1803111010',
    districtId: '1803111',
    name: 'Banding',
  },
  {
    id: '1803111011',
    districtId: '1803111',
    name: 'Canti',
  },
  {
    id: '1803111012',
    districtId: '1803111',
    name: 'Canggung',
  },
  {
    id: '1803111013',
    districtId: '1803111',
    name: 'Betung',
  },
  {
    id: '1803111014',
    districtId: '1803111',
    name: 'Tanjung Gading',
  },
  {
    id: '1803111015',
    districtId: '1803111',
    name: 'Kota Guring',
  },
  {
    id: '1803111016',
    districtId: '1803111',
    name: 'Wai Muli Timur',
  },
  {
    id: '1803120001',
    districtId: '1803120',
    name: 'Tanjung Sari',
  },
  {
    id: '1803120002',
    districtId: '1803120',
    name: 'Bangunan',
  },
  {
    id: '1803120003',
    districtId: '1803120',
    name: 'Sukaraja',
  },
  {
    id: '1803120004',
    districtId: '1803120',
    name: 'Suka Mulya',
  },
  {
    id: '1803120005',
    districtId: '1803120',
    name: 'Sukabakti',
  },
  {
    id: '1803120015',
    districtId: '1803120',
    name: 'Palas Pasemah',
  },
  {
    id: '1803120016',
    districtId: '1803120',
    name: 'Palas Jaya',
  },
  {
    id: '1803120017',
    districtId: '1803120',
    name: 'Pulau Tengah',
  },
  {
    id: '1803120018',
    districtId: '1803120',
    name: 'Bandan Hurip',
  },
  {
    id: '1803120019',
    districtId: '1803120',
    name: 'Palas Aji',
  },
  {
    id: '1803120020',
    districtId: '1803120',
    name: 'Rejo Mulyo',
  },
  {
    id: '1803120021',
    districtId: '1803120',
    name: 'Bali Agung',
  },
  {
    id: '1803120022',
    districtId: '1803120',
    name: 'Bumi Daya',
  },
  {
    id: '1803120023',
    districtId: '1803120',
    name: 'Bumi Restu',
  },
  {
    id: '1803120024',
    districtId: '1803120',
    name: 'Tanjung Jaya',
  },
  {
    id: '1803120025',
    districtId: '1803120',
    name: 'Bumi Asih',
  },
  {
    id: '1803120026',
    districtId: '1803120',
    name: 'Mekar Mulya',
  },
  {
    id: '1803120027',
    districtId: '1803120',
    name: 'Pematang Baru',
  },
  {
    id: '1803120028',
    districtId: '1803120',
    name: 'Kali Rejo',
  },
  {
    id: '1803120029',
    districtId: '1803120',
    name: 'Bumi Asri',
  },
  {
    id: '1803120030',
    districtId: '1803120',
    name: 'Pulau Jaya',
  },
  {
    id: '1803121001',
    districtId: '1803121',
    name: 'Bakti Rasa',
  },
  {
    id: '1803121002',
    districtId: '1803121',
    name: 'Sukapura',
  },
  {
    id: '1803121003',
    districtId: '1803121',
    name: 'Mandalasari',
  },
  {
    id: '1803121004',
    districtId: '1803121',
    name: 'Sumber Sari',
  },
  {
    id: '1803121005',
    districtId: '1803121',
    name: 'Margajasa',
  },
  {
    id: '1803121006',
    districtId: '1803121',
    name: 'Kedaung',
  },
  {
    id: '1803121007',
    districtId: '1803121',
    name: 'Sumber Agung',
  },
  {
    id: '1803121008',
    districtId: '1803121',
    name: 'Kuala Sekampung',
  },
  {
    id: '1803121009',
    districtId: '1803121',
    name: 'Bandar Agung',
  },
  {
    id: '1803121010',
    districtId: '1803121',
    name: 'Margasari',
  },
  {
    id: '1803130008',
    districtId: '1803130',
    name: 'Tanjung Heran',
  },
  {
    id: '1803130009',
    districtId: '1803130',
    name: 'Pisang',
  },
  {
    id: '1803130010',
    districtId: '1803130',
    name: 'Sukabaru',
  },
  {
    id: '1803130016',
    districtId: '1803130',
    name: 'Tetaan',
  },
  {
    id: '1803130017',
    districtId: '1803130',
    name: 'Sukajaya',
  },
  {
    id: '1803130018',
    districtId: '1803130',
    name: 'Penengahan',
  },
  {
    id: '1803130019',
    districtId: '1803130',
    name: 'Gayam',
  },
  {
    id: '1803130020',
    districtId: '1803130',
    name: 'Gedungharta',
  },
  {
    id: '1803130021',
    districtId: '1803130',
    name: 'Way Kalam',
  },
  {
    id: '1803130022',
    districtId: '1803130',
    name: 'Padan',
  },
  {
    id: '1803130023',
    districtId: '1803130',
    name: 'Kampungbaru',
  },
  {
    id: '1803130024',
    districtId: '1803130',
    name: 'Banjarmasin',
  },
  {
    id: '1803130031',
    districtId: '1803130',
    name: 'Klaten',
  },
  {
    id: '1803130032',
    districtId: '1803130',
    name: 'Pasuruan',
  },
  {
    id: '1803130033',
    districtId: '1803130',
    name: 'Ruang Tengah',
  },
  {
    id: '1803130034',
    districtId: '1803130',
    name: 'Kelau',
  },
  {
    id: '1803130035',
    districtId: '1803130',
    name: 'Taman Baru',
  },
  {
    id: '1803130036',
    districtId: '1803130',
    name: 'Kuripan',
  },
  {
    id: '1803130037',
    districtId: '1803130',
    name: 'Rawi',
  },
  {
    id: '1803130038',
    districtId: '1803130',
    name: 'Belambangan',
  },
  {
    id: '1803130039',
    districtId: '1803130',
    name: 'Kekiling',
  },
  {
    id: '1803130041',
    districtId: '1803130',
    name: 'Gandri',
  },
  {
    id: '1803131001',
    districtId: '1803131',
    name: 'Sumur',
  },
  {
    id: '1803131002',
    districtId: '1803131',
    name: 'Ruguk',
  },
  {
    id: '1803131003',
    districtId: '1803131',
    name: 'Tridarmayoga',
  },
  {
    id: '1803131004',
    districtId: '1803131',
    name: 'Legundi',
  },
  {
    id: '1803131005',
    districtId: '1803131',
    name: 'Ketapang',
  },
  {
    id: '1803131006',
    districtId: '1803131',
    name: 'Bangun Rejo',
  },
  {
    id: '1803131007',
    districtId: '1803131',
    name: 'Karang Sari',
  },
  {
    id: '1803131008',
    districtId: '1803131',
    name: 'Sri Pendowo',
  },
  {
    id: '1803131009',
    districtId: '1803131',
    name: 'Sumbernadi',
  },
  {
    id: '1803131010',
    districtId: '1803131',
    name: 'Taman Sari',
  },
  {
    id: '1803131011',
    districtId: '1803131',
    name: 'Kemukus',
  },
  {
    id: '1803131012',
    districtId: '1803131',
    name: 'Lebung Nala',
  },
  {
    id: '1803131013',
    districtId: '1803131',
    name: 'Sidoasih',
  },
  {
    id: '1803131014',
    districtId: '1803131',
    name: 'Pematang Pasir',
  },
  {
    id: '1803131015',
    districtId: '1803131',
    name: 'Berundung',
  },
  {
    id: '1803131016',
    districtId: '1803131',
    name: 'Sidoluhur',
  },
  {
    id: '1803131017',
    districtId: '1803131',
    name: 'Wai Sidomukti',
  },
  {
    id: '1803132001',
    districtId: '1803132',
    name: 'Totoharjo',
  },
  {
    id: '1803132002',
    districtId: '1803132',
    name: 'Kelawi',
  },
  {
    id: '1803132003',
    districtId: '1803132',
    name: 'Bakauheni',
  },
  {
    id: '1803132004',
    districtId: '1803132',
    name: 'Hata',
  },
  {
    id: '1803132005',
    districtId: '1803132',
    name: 'Semanak',
  },
  {
    id: '1804010001',
    districtId: '1804010',
    name: 'Sumber Agung',
  },
  {
    id: '1804010002',
    districtId: '1804010',
    name: 'Purbo Sembodo',
  },
  {
    id: '1804010003',
    districtId: '1804010',
    name: 'Kibang',
  },
  {
    id: '1804010004',
    districtId: '1804010',
    name: 'Margo Jaya',
  },
  {
    id: '1804010005',
    districtId: '1804010',
    name: 'Margo Toto',
  },
  {
    id: '1804010006',
    districtId: '1804010',
    name: 'Margo Sari',
  },
  {
    id: '1804010007',
    districtId: '1804010',
    name: 'Jaya Asri',
  },
  {
    id: '1804020001',
    districtId: '1804020',
    name: 'Buana Sakti',
  },
  {
    id: '1804020002',
    districtId: '1804020',
    name: 'Balai Kencono',
  },
  {
    id: '1804020003',
    districtId: '1804020',
    name: 'Rejo Agung',
  },
  {
    id: '1804020004',
    districtId: '1804020',
    name: 'Adi Warno',
  },
  {
    id: '1804020005',
    districtId: '1804020',
    name: 'Nampi Rejo',
  },
  {
    id: '1804020006',
    districtId: '1804020',
    name: 'Banar Joyo',
  },
  {
    id: '1804020007',
    districtId: '1804020',
    name: 'Telogo Rejo',
  },
  {
    id: '1804020008',
    districtId: '1804020',
    name: 'Sumber Rejo',
  },
  {
    id: '1804020009',
    districtId: '1804020',
    name: 'Banjar Rejo',
  },
  {
    id: '1804020010',
    districtId: '1804020',
    name: 'Bumi Harjo',
  },
  {
    id: '1804020011',
    districtId: '1804020',
    name: 'Bale Rejo',
  },
  {
    id: '1804020012',
    districtId: '1804020',
    name: 'Batang Harjo',
  },
  {
    id: '1804020013',
    districtId: '1804020',
    name: 'Bumi Mas',
  },
  {
    id: '1804020014',
    districtId: '1804020',
    name: 'Selo Rejo',
  },
  {
    id: '1804020015',
    districtId: '1804020',
    name: 'Sri Basuki',
  },
  {
    id: '1804020016',
    districtId: '1804020',
    name: 'Sumber Agung',
  },
  {
    id: '1804020017',
    districtId: '1804020',
    name: 'Purwodadi Mekar',
  },
  {
    id: '1804030001',
    districtId: '1804030',
    name: 'Sidomukti',
  },
  {
    id: '1804030002',
    districtId: '1804030',
    name: 'Karya Mukti',
  },
  {
    id: '1804030003',
    districtId: '1804030',
    name: 'Sidomulyo',
  },
  {
    id: '1804030004',
    districtId: '1804030',
    name: 'Sidodadi',
  },
  {
    id: '1804030005',
    districtId: '1804030',
    name: 'Trimulyo',
  },
  {
    id: '1804030006',
    districtId: '1804030',
    name: 'Girikarto',
  },
  {
    id: '1804030007',
    districtId: '1804030',
    name: 'Hargomulyo',
  },
  {
    id: '1804030008',
    districtId: '1804030',
    name: 'Wonokarto',
  },
  {
    id: '1804030009',
    districtId: '1804030',
    name: 'Suko Harjo',
  },
  {
    id: '1804030010',
    districtId: '1804030',
    name: 'Giri Kelopo Mulyo',
  },
  {
    id: '1804030011',
    districtId: '1804030',
    name: 'Sumber Gede',
  },
  {
    id: '1804030012',
    districtId: '1804030',
    name: 'Sambikarto',
  },
  {
    id: '1804030013',
    districtId: '1804030',
    name: 'Sumbersari',
  },
  {
    id: '1804030014',
    districtId: '1804030',
    name: 'Mekar Mulya',
  },
  {
    id: '1804030015',
    districtId: '1804030',
    name: 'Mekar Mukti',
  },
  {
    id: '1804030016',
    districtId: '1804030',
    name: 'Jadi Mulyo',
  },
  {
    id: '1804030017',
    districtId: '1804030',
    name: 'Mekar Sari',
  },
  {
    id: '1804040001',
    districtId: '1804040',
    name: 'Jaya Guna',
  },
  {
    id: '1804040002',
    districtId: '1804040',
    name: 'Sukaraja Tiga',
  },
  {
    id: '1804040003',
    districtId: '1804040',
    name: 'Gedung Wani',
  },
  {
    id: '1804040004',
    districtId: '1804040',
    name: 'Gedung Wani Timur',
  },
  {
    id: '1804040005',
    districtId: '1804040',
    name: 'Surya Mataram',
  },
  {
    id: '1804040006',
    districtId: '1804040',
    name: 'Nabang Baru',
  },
  {
    id: '1804040007',
    districtId: '1804040',
    name: 'Negeri Jemanten',
  },
  {
    id: '1804040008',
    districtId: '1804040',
    name: 'Negeri Agung',
  },
  {
    id: '1804040009',
    districtId: '1804040',
    name: 'Negeri Katon',
  },
  {
    id: '1804040010',
    districtId: '1804040',
    name: 'Sukadana Baru',
  },
  {
    id: '1804040011',
    districtId: '1804040',
    name: 'Tanjung Harapan',
  },
  {
    id: '1804040012',
    districtId: '1804040',
    name: 'Negeri Tua',
  },
  {
    id: '1804040013',
    districtId: '1804040',
    name: 'Tri Sinar',
  },
  {
    id: '1804050001',
    districtId: '1804050',
    name: 'Gunung Agung',
  },
  {
    id: '1804050002',
    districtId: '1804050',
    name: 'Gunung Pasir Jaya',
  },
  {
    id: '1804050003',
    districtId: '1804050',
    name: 'Gunung Sugih Besar',
  },
  {
    id: '1804050004',
    districtId: '1804050',
    name: 'Bauh Gunung Sari',
  },
  {
    id: '1804050005',
    districtId: '1804050',
    name: 'Brawijaya',
  },
  {
    id: '1804050006',
    districtId: '1804050',
    name: 'Sidorejo',
  },
  {
    id: '1804050007',
    districtId: '1804050',
    name: 'Pugung Raharjo',
  },
  {
    id: '1804050008',
    districtId: '1804050',
    name: 'Bojong',
  },
  {
    id: '1804050009',
    districtId: '1804050',
    name: 'Banjar Agung',
  },
  {
    id: '1804050010',
    districtId: '1804050',
    name: 'Tuba',
  },
  {
    id: '1804050011',
    districtId: '1804050',
    name: 'Mengandung Sari',
  },
  {
    id: '1804050012',
    districtId: '1804050',
    name: 'Sindang Anom',
  },
  {
    id: '1804050013',
    districtId: '1804050',
    name: 'Bumi Mulyo',
  },
  {
    id: '1804050014',
    districtId: '1804050',
    name: 'Gunung Mulyo',
  },
  {
    id: '1804050015',
    districtId: '1804050',
    name: 'Purwo Kencono',
  },
  {
    id: '1804060001',
    districtId: '1804060',
    name: 'Mekar Jaya',
  },
  {
    id: '1804060010',
    districtId: '1804060',
    name: 'Adirejo',
  },
  {
    id: '1804060011',
    districtId: '1804060',
    name: 'Asahan',
  },
  {
    id: '1804060012',
    districtId: '1804060',
    name: 'Belimbing Sari',
  },
  {
    id: '1804060013',
    districtId: '1804060',
    name: 'Gunung Mekar',
  },
  {
    id: '1804060014',
    districtId: '1804060',
    name: 'Benteng Sari',
  },
  {
    id: '1804060015',
    districtId: '1804060',
    name: 'Mumbang Jaya',
  },
  {
    id: '1804060016',
    districtId: '1804060',
    name: 'Gunung Sugih Kecil',
  },
  {
    id: '1804060017',
    districtId: '1804060',
    name: 'Pematang Tahalo',
  },
  {
    id: '1804060018',
    districtId: '1804060',
    name: 'Negara Batin',
  },
  {
    id: '1804060019',
    districtId: '1804060',
    name: 'Negara Saka',
  },
  {
    id: '1804060020',
    districtId: '1804060',
    name: 'Jabung',
  },
  {
    id: '1804060021',
    districtId: '1804060',
    name: 'Adi Luhur',
  },
  {
    id: '1804060022',
    districtId: '1804060',
    name: 'Tanjung Sari',
  },
  {
    id: '1804060023',
    districtId: '1804060',
    name: 'Sambi Rejo',
  },
  {
    id: '1804061001',
    districtId: '1804061',
    name: 'Sumur Kucing',
  },
  {
    id: '1804061002',
    districtId: '1804061',
    name: 'Labuhan Ratu',
  },
  {
    id: '1804061003',
    districtId: '1804061',
    name: 'Kedung Ringin',
  },
  {
    id: '1804061004',
    districtId: '1804061',
    name: 'Rejo Mulyo',
  },
  {
    id: '1804061005',
    districtId: '1804061',
    name: 'Purworejo',
  },
  {
    id: '1804061006',
    districtId: '1804061',
    name: 'Mulyo Sari',
  },
  {
    id: '1804061007',
    districtId: '1804061',
    name: 'Pasir Sakti',
  },
  {
    id: '1804061008',
    districtId: '1804061',
    name: 'Mekar Sari',
  },
  {
    id: '1804062001',
    districtId: '1804062',
    name: 'Marga Batin',
  },
  {
    id: '1804062002',
    districtId: '1804062',
    name: 'Sido Rahayu',
  },
  {
    id: '1804062003',
    districtId: '1804062',
    name: 'Ngesti Karya',
  },
  {
    id: '1804062004',
    districtId: '1804062',
    name: 'Sumber Jaya',
  },
  {
    id: '1804062005',
    districtId: '1804062',
    name: 'Sumber Rejo',
  },
  {
    id: '1804062006',
    districtId: '1804062',
    name: 'Mekar Karya',
  },
  {
    id: '1804062007',
    districtId: '1804062',
    name: 'Tanjung Wangi',
  },
  {
    id: '1804062008',
    districtId: '1804062',
    name: 'Tri Tunggal',
  },
  {
    id: '1804062009',
    districtId: '1804062',
    name: 'Jembrana',
  },
  {
    id: '1804062010',
    districtId: '1804062',
    name: 'Karang Anom',
  },
  {
    id: '1804062011',
    districtId: '1804062',
    name: 'Karya Basuki',
  },
  {
    id: '1804063001',
    districtId: '1804063',
    name: 'Bungkuk',
  },
  {
    id: '1804063002',
    districtId: '1804063',
    name: 'Giri Mulyo',
  },
  {
    id: '1804063003',
    districtId: '1804063',
    name: 'Gunung Mas',
  },
  {
    id: '1804063004',
    districtId: '1804063',
    name: 'Batu Badak',
  },
  {
    id: '1804063005',
    districtId: '1804063',
    name: 'Peniangan',
  },
  {
    id: '1804063006',
    districtId: '1804063',
    name: 'Purwosari',
  },
  {
    id: '1804063007',
    districtId: '1804063',
    name: 'Gunung Raya',
  },
  {
    id: '1804063008',
    districtId: '1804063',
    name: 'Bukit Raya',
  },
  {
    id: '1804070005',
    districtId: '1804070',
    name: 'Karyatani',
  },
  {
    id: '1804070006',
    districtId: '1804070',
    name: 'Karya Makmur',
  },
  {
    id: '1804070007',
    districtId: '1804070',
    name: 'Bandar Negeri',
  },
  {
    id: '1804070015',
    districtId: '1804070',
    name: 'Maringgai',
  },
  {
    id: '1804070016',
    districtId: '1804070',
    name: 'Muara Gading Mas',
  },
  {
    id: '1804070017',
    districtId: '1804070',
    name: 'Labuhan Maringai',
  },
  {
    id: '1804070031',
    districtId: '1804070',
    name: 'Sri Gading',
  },
  {
    id: '1804070032',
    districtId: '1804070',
    name: 'Sri Minosari',
  },
  {
    id: '1804070033',
    districtId: '1804070',
    name: 'Margasari',
  },
  {
    id: '1804070034',
    districtId: '1804070',
    name: 'Sukorahayu',
  },
  {
    id: '1804070035',
    districtId: '1804070',
    name: 'Karang Anyar',
  },
  {
    id: '1804071001',
    districtId: '1804071',
    name: 'Tulungpasik',
  },
  {
    id: '1804071002',
    districtId: '1804071',
    name: 'Mandala Sari',
  },
  {
    id: '1804071003',
    districtId: '1804071',
    name: 'Kebon Damar',
  },
  {
    id: '1804071004',
    districtId: '1804071',
    name: 'Mataram Baru',
  },
  {
    id: '1804071005',
    districtId: '1804071',
    name: 'Rajabasa Baru',
  },
  {
    id: '1804071006',
    districtId: '1804071',
    name: 'Teluk Dalem',
  },
  {
    id: '1804071007',
    districtId: '1804071',
    name: 'Wai Arang',
  },
  {
    id: '1804072001',
    districtId: '1804072',
    name: 'Waringin Jaya',
  },
  {
    id: '1804072002',
    districtId: '1804072',
    name: 'Sri Bawono',
  },
  {
    id: '1804072003',
    districtId: '1804072',
    name: 'Sri Menanti',
  },
  {
    id: '1804072004',
    districtId: '1804072',
    name: 'Sri Pendowo',
  },
  {
    id: '1804072005',
    districtId: '1804072',
    name: 'Bandar Agung',
  },
  {
    id: '1804072006',
    districtId: '1804072',
    name: 'Sadar Sriwijaya',
  },
  {
    id: '1804072007',
    districtId: '1804072',
    name: 'Mekar Jaya',
  },
  {
    id: '1804073001',
    districtId: '1804073',
    name: 'Sidomakmur',
  },
  {
    id: '1804073002',
    districtId: '1804073',
    name: 'Tanjung Aji',
  },
  {
    id: '1804073003',
    districtId: '1804073',
    name: 'Tebing',
  },
  {
    id: '1804073004',
    districtId: '1804073',
    name: 'Wana',
  },
  {
    id: '1804073005',
    districtId: '1804073',
    name: 'Sumberhadi',
  },
  {
    id: '1804073006',
    districtId: '1804073',
    name: 'Itik Rendai',
  },
  {
    id: '1804074001',
    districtId: '1804074',
    name: 'Negeri Agung',
  },
  {
    id: '1804074002',
    districtId: '1804074',
    name: 'Pempen',
  },
  {
    id: '1804074003',
    districtId: '1804074',
    name: 'Pelindung Jaya',
  },
  {
    id: '1804074004',
    districtId: '1804074',
    name: 'Wai Mili',
  },
  {
    id: '1804074005',
    districtId: '1804074',
    name: 'Nibung',
  },
  {
    id: '1804080001',
    districtId: '1804080',
    name: 'Braja Fajar',
  },
  {
    id: '1804080002',
    districtId: '1804080',
    name: 'Braja Emas',
  },
  {
    id: '1804080007',
    districtId: '1804080',
    name: 'Braja Caka',
  },
  {
    id: '1804080008',
    districtId: '1804080',
    name: 'Braja Dewa',
  },
  {
    id: '1804080009',
    districtId: '1804080',
    name: 'Sri Wangi',
  },
  {
    id: '1804080010',
    districtId: '1804080',
    name: 'Jepara',
  },
  {
    id: '1804080011',
    districtId: '1804080',
    name: 'Sumberjo',
  },
  {
    id: '1804080012',
    districtId: '1804080',
    name: 'Sri Rejosari',
  },
  {
    id: '1804080013',
    districtId: '1804080',
    name: 'Labuhan Ratu Dua',
  },
  {
    id: '1804080014',
    districtId: '1804080',
    name: 'Sumur Bandung',
  },
  {
    id: '1804080018',
    districtId: '1804080',
    name: 'Labuhan Ratu Satu',
  },
  {
    id: '1804080019',
    districtId: '1804080',
    name: 'Braja Sakti',
  },
  {
    id: '1804080022',
    districtId: '1804080',
    name: 'Braja Asri',
  },
  {
    id: '1804080023',
    districtId: '1804080',
    name: 'Sumber Marga',
  },
  {
    id: '1804080024',
    districtId: '1804080',
    name: 'Labuhan Ratu Danau',
  },
  {
    id: '1804080025',
    districtId: '1804080',
    name: 'Labuhan Ratu Baru',
  },
  {
    id: '1804081001',
    districtId: '1804081',
    name: 'Braja Gemilang',
  },
  {
    id: '1804081002',
    districtId: '1804081',
    name: 'Braja Luhur',
  },
  {
    id: '1804081003',
    districtId: '1804081',
    name: 'Braja Kencana',
  },
  {
    id: '1804081004',
    districtId: '1804081',
    name: 'Braja Harjosari',
  },
  {
    id: '1804081005',
    districtId: '1804081',
    name: 'Braja Indah',
  },
  {
    id: '1804081006',
    districtId: '1804081',
    name: 'Braja Yekti',
  },
  {
    id: '1804081007',
    districtId: '1804081',
    name: 'Braja Mulya',
  },
  {
    id: '1804082001',
    districtId: '1804082',
    name: 'Labuhan Ratu Empat',
  },
  {
    id: '1804082002',
    districtId: '1804082',
    name: 'Labuhan Ratu Lima',
  },
  {
    id: '1804082003',
    districtId: '1804082',
    name: 'Labuhan Ratu Tiga',
  },
  {
    id: '1804082004',
    districtId: '1804082',
    name: 'Labuhan Ratu VII',
  },
  {
    id: '1804082005',
    districtId: '1804082',
    name: 'Labuhan Ratu',
  },
  {
    id: '1804082006',
    districtId: '1804082',
    name: 'Labuhan Ratu Enam',
  },
  {
    id: '1804082007',
    districtId: '1804082',
    name: 'Raja Basa Lama',
  },
  {
    id: '1804082008',
    districtId: '1804082',
    name: 'Raja Basa Lama Satu',
  },
  {
    id: '1804082009',
    districtId: '1804082',
    name: 'Raja Basa Lama Dua',
  },
  {
    id: '1804082010',
    districtId: '1804082',
    name: 'Labuhan Ratu VIII',
  },
  {
    id: '1804082011',
    districtId: '1804082',
    name: 'Labuhan Ratu IX',
  },
  {
    id: '1804090005',
    districtId: '1804090',
    name: 'Raja Basa Batanghari',
  },
  {
    id: '1804090011',
    districtId: '1804090',
    name: 'Sukadana',
  },
  {
    id: '1804090012',
    districtId: '1804090',
    name: 'Putra Aji Dua',
  },
  {
    id: '1804090013',
    districtId: '1804090',
    name: 'Pakuan Aji',
  },
  {
    id: '1804090014',
    districtId: '1804090',
    name: 'Bumi Nabung Udik',
  },
  {
    id: '1804090015',
    districtId: '1804090',
    name: 'Sukadana Timur',
  },
  {
    id: '1804090016',
    districtId: '1804090',
    name: 'Surabaya Udik',
  },
  {
    id: '1804090017',
    districtId: '1804090',
    name: 'Rantau Jaya Udik II',
  },
  {
    id: '1804090018',
    districtId: '1804090',
    name: 'Muara Jaya',
  },
  {
    id: '1804090019',
    districtId: '1804090',
    name: 'Rantau Jaya Udik',
  },
  {
    id: '1804090020',
    districtId: '1804090',
    name: 'Pasar Sukadana',
  },
  {
    id: '1804090021',
    districtId: '1804090',
    name: 'Mataram Marga',
  },
  {
    id: '1804090022',
    districtId: '1804090',
    name: 'Terbanggi Marga',
  },
  {
    id: '1804090023',
    districtId: '1804090',
    name: 'Sukadana Ilir',
  },
  {
    id: '1804090024',
    districtId: '1804090',
    name: 'Negara Nabung',
  },
  {
    id: '1804090025',
    districtId: '1804090',
    name: 'Bumi Ayu',
  },
  {
    id: '1804090026',
    districtId: '1804090',
    name: 'Putra Aji I',
  },
  {
    id: '1804090027',
    districtId: '1804090',
    name: 'Sukadana Selatan',
  },
  {
    id: '1804090028',
    districtId: '1804090',
    name: 'Sukadana Tengah',
  },
  {
    id: '1804090029',
    districtId: '1804090',
    name: 'Sukadana Jaya',
  },
  {
    id: '1804091001',
    districtId: '1804091',
    name: 'Marga Mulya',
  },
  {
    id: '1804091002',
    districtId: '1804091',
    name: 'Donomulyo',
  },
  {
    id: '1804091003',
    districtId: '1804091',
    name: 'Nyampir',
  },
  {
    id: '1804091004',
    districtId: '1804091',
    name: 'Bumi Tinggi',
  },
  {
    id: '1804091005',
    districtId: '1804091',
    name: 'Lehan',
  },
  {
    id: '1804091006',
    districtId: '1804091',
    name: 'Catur Swako',
  },
  {
    id: '1804091007',
    districtId: '1804091',
    name: 'Mulyo Asri',
  },
  {
    id: '1804092001',
    districtId: '1804092',
    name: 'Gunung Tiga',
  },
  {
    id: '1804092002',
    districtId: '1804092',
    name: 'Sukacari',
  },
  {
    id: '1804092003',
    districtId: '1804092',
    name: 'Negara Ratu',
  },
  {
    id: '1804092004',
    districtId: '1804092',
    name: 'Bumi Jawa',
  },
  {
    id: '1804092005',
    districtId: '1804092',
    name: 'Gedung Dalam',
  },
  {
    id: '1804092006',
    districtId: '1804092',
    name: 'Sukaraja Nuban',
  },
  {
    id: '1804092007',
    districtId: '1804092',
    name: 'Trisno Mulyo',
  },
  {
    id: '1804092008',
    districtId: '1804092',
    name: 'Cempaka Nuban',
  },
  {
    id: '1804092009',
    districtId: '1804092',
    name: 'Kedaton II (Dua)',
  },
  {
    id: '1804092010',
    districtId: '1804092',
    name: 'Kedaton Induk',
  },
  {
    id: '1804092011',
    districtId: '1804092',
    name: 'Kedaton I (Satu)',
  },
  {
    id: '1804092012',
    districtId: '1804092',
    name: 'Tulung Balak',
  },
  {
    id: '1804092013',
    districtId: '1804092',
    name: 'Purwosari',
  },
  {
    id: '1804100001',
    districtId: '1804100',
    name: 'Adirejo',
  },
  {
    id: '1804100002',
    districtId: '1804100',
    name: 'Sidodadi',
  },
  {
    id: '1804100003',
    districtId: '1804100',
    name: 'Gondang Rejo',
  },
  {
    id: '1804100004',
    districtId: '1804100',
    name: 'Siraman',
  },
  {
    id: '1804100005',
    districtId: '1804100',
    name: 'Pekalongan',
  },
  {
    id: '1804100006',
    districtId: '1804100',
    name: 'Tulus Rejo',
  },
  {
    id: '1804100007',
    districtId: '1804100',
    name: 'Jojog',
  },
  {
    id: '1804100008',
    districtId: '1804100',
    name: 'Ganti Warno',
  },
  {
    id: '1804100009',
    districtId: '1804100',
    name: 'Kali Bening',
  },
  {
    id: '1804100010',
    districtId: '1804100',
    name: 'Wono Sari',
  },
  {
    id: '1804100011',
    districtId: '1804100',
    name: 'Adijaya',
  },
  {
    id: '1804100012',
    districtId: '1804100',
    name: 'Gantimulyo',
  },
  {
    id: '1804110001',
    districtId: '1804110',
    name: 'Raman Aji',
  },
  {
    id: '1804110002',
    districtId: '1804110',
    name: 'Rukti Sediyo',
  },
  {
    id: '1804110003',
    districtId: '1804110',
    name: 'Ratna Daya',
  },
  {
    id: '1804110004',
    districtId: '1804110',
    name: 'Kota Raman',
  },
  {
    id: '1804110005',
    districtId: '1804110',
    name: 'Rejo Binangun',
  },
  {
    id: '1804110006',
    districtId: '1804110',
    name: 'Rantau Fajar',
  },
  {
    id: '1804110007',
    districtId: '1804110',
    name: 'Raman Endra',
  },
  {
    id: '1804110008',
    districtId: '1804110',
    name: 'Raman Fajar',
  },
  {
    id: '1804110009',
    districtId: '1804110',
    name: 'Restu Rahayu',
  },
  {
    id: '1804110010',
    districtId: '1804110',
    name: 'Rejo Katon',
  },
  {
    id: '1804110011',
    districtId: '1804110',
    name: 'Rama Puja',
  },
  {
    id: '1804120001',
    districtId: '1804120',
    name: 'Taman Asri',
  },
  {
    id: '1804120002',
    districtId: '1804120',
    name: 'Taman Bogo',
  },
  {
    id: '1804120003',
    districtId: '1804120',
    name: 'Tambah Dadi',
  },
  {
    id: '1804120004',
    districtId: '1804120',
    name: 'Taman Cari',
  },
  {
    id: '1804120005',
    districtId: '1804120',
    name: 'Taman Endah',
  },
  {
    id: '1804120006',
    districtId: '1804120',
    name: 'Taman Fajar',
  },
  {
    id: '1804120007',
    districtId: '1804120',
    name: 'Tegal Gondo',
  },
  {
    id: '1804120008',
    districtId: '1804120',
    name: 'Toto Harjo',
  },
  {
    id: '1804120009',
    districtId: '1804120',
    name: 'Tambah Luhur',
  },
  {
    id: '1804120010',
    districtId: '1804120',
    name: 'Tanjung Inten',
  },
  {
    id: '1804120011',
    districtId: '1804120',
    name: 'Tegal Yoso',
  },
  {
    id: '1804120012',
    districtId: '1804120',
    name: 'Tanjung Kesuma',
  },
  {
    id: '1804121001',
    districtId: '1804121',
    name: 'Toto Mulyo',
  },
  {
    id: '1804121002',
    districtId: '1804121',
    name: 'Tegal Ombo',
  },
  {
    id: '1804121003',
    districtId: '1804121',
    name: 'Toto Projo',
  },
  {
    id: '1804121004',
    districtId: '1804121',
    name: 'Taman Negeri',
  },
  {
    id: '1804121005',
    districtId: '1804121',
    name: 'Tanjung Kencono',
  },
  {
    id: '1804121006',
    districtId: '1804121',
    name: 'Tambah Subur',
  },
  {
    id: '1804121007',
    districtId: '1804121',
    name: 'Tanjung Tirto',
  },
  {
    id: '1804121008',
    districtId: '1804121',
    name: 'Kali Pasir',
  },
  {
    id: '1805010006',
    districtId: '1805010',
    name: 'Purwosari',
  },
  {
    id: '1805010008',
    districtId: '1805010',
    name: 'Mojokerto',
  },
  {
    id: '1805010009',
    districtId: '1805010',
    name: 'Sendang Ayu',
  },
  {
    id: '1805010010',
    districtId: '1805010',
    name: 'Surabaya',
  },
  {
    id: '1805010011',
    districtId: '1805010',
    name: 'Bandarsari',
  },
  {
    id: '1805010012',
    districtId: '1805010',
    name: 'Sri Agung',
  },
  {
    id: '1805010013',
    districtId: '1805010',
    name: 'Kota Baru',
  },
  {
    id: '1805010014',
    districtId: '1805010',
    name: 'Margorejo',
  },
  {
    id: '1805010015',
    districtId: '1805010',
    name: 'Karang Tanjung',
  },
  {
    id: '1805010028',
    districtId: '1805010',
    name: 'Kuripan',
  },
  {
    id: '1805010029',
    districtId: '1805010',
    name: 'Haduyang Ratu',
  },
  {
    id: '1805010030',
    districtId: '1805010',
    name: 'Padang Ratu',
  },
  {
    id: '1805010051',
    districtId: '1805010',
    name: 'Karang Sari',
  },
  {
    id: '1805010061',
    districtId: '1805010',
    name: 'Sumbersari',
  },
  {
    id: '1805010062',
    districtId: '1805010',
    name: 'Purworejo',
  },
  {
    id: '1805011001',
    districtId: '1805011',
    name: 'Marga Jaya',
  },
  {
    id: '1805011002',
    districtId: '1805011',
    name: 'Lingga Pura',
  },
  {
    id: '1805011003',
    districtId: '1805011',
    name: 'Nyukang Harjo',
  },
  {
    id: '1805011004',
    districtId: '1805011',
    name: 'Sidoharjo',
  },
  {
    id: '1805011005',
    districtId: '1805011',
    name: 'Taman Sari',
  },
  {
    id: '1805011006',
    districtId: '1805011',
    name: 'Negeri Katon',
  },
  {
    id: '1805011007',
    districtId: '1805011',
    name: 'Karang Anyar',
  },
  {
    id: '1805011008',
    districtId: '1805011',
    name: 'Galih Karangjati',
  },
  {
    id: '1805011009',
    districtId: '1805011',
    name: 'Gedung Harta',
  },
  {
    id: '1805011010',
    districtId: '1805011',
    name: 'Negeri Agung',
  },
  {
    id: '1805011011',
    districtId: '1805011',
    name: 'Tanjung Ratu',
  },
  {
    id: '1805011012',
    districtId: '1805011',
    name: 'Gedung Haji',
  },
  {
    id: '1805011013',
    districtId: '1805011',
    name: 'Negeri Jaya',
  },
  {
    id: '1805011014',
    districtId: '1805011',
    name: 'Mekar Harjo',
  },
  {
    id: '1805012001',
    districtId: '1805012',
    name: 'Kota Batu',
  },
  {
    id: '1805012002',
    districtId: '1805012',
    name: 'Tawang Negeri',
  },
  {
    id: '1805012003',
    districtId: '1805012',
    name: 'Payung Makmur',
  },
  {
    id: '1805012004',
    districtId: '1805012',
    name: 'Payung Dadi',
  },
  {
    id: '1805012005',
    districtId: '1805012',
    name: 'Payung Rejo',
  },
  {
    id: '1805012006',
    districtId: '1805012',
    name: 'Tanjung Rejo',
  },
  {
    id: '1805012007',
    districtId: '1805012',
    name: 'Sangun Ratu',
  },
  {
    id: '1805012008',
    districtId: '1805012',
    name: 'Gunung Raya',
  },
  {
    id: '1805012009',
    districtId: '1805012',
    name: 'Gunung Haji',
  },
  {
    id: '1805012010',
    districtId: '1805012',
    name: 'Negeri Ratu',
  },
  {
    id: '1805012011',
    districtId: '1805012',
    name: 'Tanjung Kemala',
  },
  {
    id: '1805012012',
    districtId: '1805012',
    name: 'Negeri Kepayungan',
  },
  {
    id: '1805012013',
    districtId: '1805012',
    name: 'Payung Batu',
  },
  {
    id: '1805012014',
    districtId: '1805012',
    name: 'Segala Mider',
  },
  {
    id: '1805012015',
    districtId: '1805012',
    name: 'Tias Bangun',
  },
  {
    id: '1805012016',
    districtId: '1805012',
    name: 'Sinar Negeri',
  },
  {
    id: '1805012017',
    districtId: '1805012',
    name: 'Riau Periangan',
  },
  {
    id: '1805012018',
    districtId: '1805012',
    name: 'Pekandangan',
  },
  {
    id: '1805012019',
    districtId: '1805012',
    name: 'Payung Mulya',
  },
  {
    id: '1805012020',
    districtId: '1805012',
    name: 'Padang Rejo',
  },
  {
    id: '1805013001',
    districtId: '1805013',
    name: 'Sri Katon',
  },
  {
    id: '1805013002',
    districtId: '1805013',
    name: 'Jaya Sakti',
  },
  {
    id: '1805013003',
    districtId: '1805013',
    name: 'Bumi Jaya',
  },
  {
    id: '1805013004',
    districtId: '1805013',
    name: 'Mulyo Haji',
  },
  {
    id: '1805013005',
    districtId: '1805013',
    name: 'Haji Pemanggilan',
  },
  {
    id: '1805013006',
    districtId: '1805013',
    name: 'Negara Bumi Ilir',
  },
  {
    id: '1805013007',
    districtId: '1805013',
    name: 'Bumi Aji',
  },
  {
    id: '1805013008',
    districtId: '1805013',
    name: 'Negara Aji Tua',
  },
  {
    id: '1805013009',
    districtId: '1805013',
    name: 'Negara Bumi Udik',
  },
  {
    id: '1805013010',
    districtId: '1805013',
    name: 'Negara Aji Baru',
  },
  {
    id: '1805013011',
    districtId: '1805013',
    name: 'Gunung Agung',
  },
  {
    id: '1805013012',
    districtId: '1805013',
    name: 'Tanjung Harapan',
  },
  {
    id: '1805014001',
    districtId: '1805014',
    name: 'Gedung Ratu',
  },
  {
    id: '1805014002',
    districtId: '1805014',
    name: 'Sri Mulyo',
  },
  {
    id: '1805014003',
    districtId: '1805014',
    name: 'Gedung Sari',
  },
  {
    id: '1805014004',
    districtId: '1805014',
    name: 'Bandar Putih Tua',
  },
  {
    id: '1805014005',
    districtId: '1805014',
    name: 'Sukajaya',
  },
  {
    id: '1805014006',
    districtId: '1805014',
    name: 'Karang Jawa',
  },
  {
    id: '1805020002',
    districtId: '1805020',
    name: 'Sri Way Langsep',
  },
  {
    id: '1805020003',
    districtId: '1805020',
    name: 'Wayakroy',
  },
  {
    id: '1805020004',
    districtId: '1805020',
    name: 'Kali Rejo',
  },
  {
    id: '1805020005',
    districtId: '1805020',
    name: 'Balai Rejo',
  },
  {
    id: '1805020006',
    districtId: '1805020',
    name: 'Sri Basuki',
  },
  {
    id: '1805020007',
    districtId: '1805020',
    name: 'Kali Wungu',
  },
  {
    id: '1805020008',
    districtId: '1805020',
    name: 'Kali Dadi',
  },
  {
    id: '1805020017',
    districtId: '1805020',
    name: 'Sri Mulyo',
  },
  {
    id: '1805020018',
    districtId: '1805020',
    name: 'Sri Dadi',
  },
  {
    id: '1805020019',
    districtId: '1805020',
    name: 'Sukosari',
  },
  {
    id: '1805020020',
    districtId: '1805020',
    name: 'Watu Agung',
  },
  {
    id: '1805020021',
    districtId: '1805020',
    name: 'Sinar Sari',
  },
  {
    id: '1805020022',
    districtId: '1805020',
    name: 'Ponco Warno',
  },
  {
    id: '1805020023',
    districtId: '1805020',
    name: 'Sri Purnomo',
  },
  {
    id: '1805020024',
    districtId: '1805020',
    name: 'Agung Timur',
  },
  {
    id: '1805020025',
    districtId: '1805020',
    name: 'Sinar Rejo',
  },
  {
    id: '1805020026',
    districtId: '1805020',
    name: 'Kali Sari',
  },
  {
    id: '1805021001',
    districtId: '1805021',
    name: 'Sendang Mulyo',
  },
  {
    id: '1805021002',
    districtId: '1805021',
    name: 'Sendang Rejo',
  },
  {
    id: '1805021003',
    districtId: '1805021',
    name: 'Sendang Agung',
  },
  {
    id: '1805021004',
    districtId: '1805021',
    name: 'Sendang Retno',
  },
  {
    id: '1805021005',
    districtId: '1805021',
    name: 'Sendang Baru',
  },
  {
    id: '1805021006',
    districtId: '1805021',
    name: 'Sendang Asih',
  },
  {
    id: '1805021007',
    districtId: '1805021',
    name: 'Sendang Asri',
  },
  {
    id: '1805021008',
    districtId: '1805021',
    name: 'Sendang Mukti',
  },
  {
    id: '1805021009',
    districtId: '1805021',
    name: 'Kutowinangun',
  },
  {
    id: '1805030001',
    districtId: '1805030',
    name: 'Purwodadi',
  },
  {
    id: '1805030002',
    districtId: '1805030',
    name: 'Sidodadi',
  },
  {
    id: '1805030003',
    districtId: '1805030',
    name: 'Sidorejo',
  },
  {
    id: '1805030004',
    districtId: '1805030',
    name: 'Cimarias',
  },
  {
    id: '1805030005',
    districtId: '1805030',
    name: 'Bangun Rejo',
  },
  {
    id: '1805030006',
    districtId: '1805030',
    name: 'Sidoluhur',
  },
  {
    id: '1805030007',
    districtId: '1805030',
    name: 'Sidomulyo',
  },
  {
    id: '1805030008',
    districtId: '1805030',
    name: 'Timbul Rejo',
  },
  {
    id: '1805030009',
    districtId: '1805030',
    name: 'Suka Waringin',
  },
  {
    id: '1805030010',
    districtId: '1805030',
    name: 'Suka Negara',
  },
  {
    id: '1805030011',
    districtId: '1805030',
    name: 'Sri Pendowo',
  },
  {
    id: '1805030012',
    districtId: '1805030',
    name: 'Sinar Seputih',
  },
  {
    id: '1805030013',
    districtId: '1805030',
    name: 'Sinar Luas',
  },
  {
    id: '1805030014',
    districtId: '1805030',
    name: 'Tanjung Jaya',
  },
  {
    id: '1805030015',
    districtId: '1805030',
    name: 'Tanjung Pandan',
  },
  {
    id: '1805030016',
    districtId: '1805030',
    name: 'Mekar Jaya',
  },
  {
    id: '1805030017',
    districtId: '1805030',
    name: 'Suka Negeri',
  },
  {
    id: '1805040017',
    districtId: '1805040',
    name: 'Terbanggi Subing',
  },
  {
    id: '1805040018',
    districtId: '1805040',
    name: 'Wono Sari',
  },
  {
    id: '1805040019',
    districtId: '1805040',
    name: 'Terbanggi Agung',
  },
  {
    id: '1805040020',
    districtId: '1805040',
    name: 'Gunung Sugih Raya',
  },
  {
    id: '1805040021',
    districtId: '1805040',
    name: 'Komering Agung',
  },
  {
    id: '1805040022',
    districtId: '1805040',
    name: 'Komering Putih',
  },
  {
    id: '1805040023',
    districtId: '1805040',
    name: 'Pajar Bulan',
  },
  {
    id: '1805040024',
    districtId: '1805040',
    name: 'Seputih Jaya',
  },
  {
    id: '1805040025',
    districtId: '1805040',
    name: 'Gunung Sari',
  },
  {
    id: '1805040026',
    districtId: '1805040',
    name: 'Gunung Sugih',
  },
  {
    id: '1805040027',
    districtId: '1805040',
    name: 'Buyut Udik',
  },
  {
    id: '1805040028',
    districtId: '1805040',
    name: 'Putra Buyut',
  },
  {
    id: '1805040029',
    districtId: '1805040',
    name: 'Buyut Ilir',
  },
  {
    id: '1805040030',
    districtId: '1805040',
    name: 'Buyut Utara',
  },
  {
    id: '1805040031',
    districtId: '1805040',
    name: 'Bangun Rejo',
  },
  {
    id: '1805041001',
    districtId: '1805041',
    name: 'Kedatuan',
  },
  {
    id: '1805041002',
    districtId: '1805041',
    name: 'Binjai Agung',
  },
  {
    id: '1805041003',
    districtId: '1805041',
    name: 'Rengas',
  },
  {
    id: '1805041004',
    districtId: '1805041',
    name: 'Kesumadadi',
  },
  {
    id: '1805041005',
    districtId: '1805041',
    name: 'Goras Jaya',
  },
  {
    id: '1805041006',
    districtId: '1805041',
    name: 'Sinar Banten/Bekri',
  },
  {
    id: '1805041007',
    districtId: '1805041',
    name: 'Kesuma Jaya',
  },
  {
    id: '1805041008',
    districtId: '1805041',
    name: 'Bangunsari',
  },
  {
    id: '1805042001',
    districtId: '1805042',
    name: 'Sukajawa',
  },
  {
    id: '1805042002',
    districtId: '1805042',
    name: 'Sidokerto',
  },
  {
    id: '1805042003',
    districtId: '1805042',
    name: 'Sukajadi',
  },
  {
    id: '1805042004',
    districtId: '1805042',
    name: 'Wates',
  },
  {
    id: '1805042005',
    districtId: '1805042',
    name: 'Bumiratu',
  },
  {
    id: '1805042006',
    districtId: '1805042',
    name: 'Bumiraharjo',
  },
  {
    id: '1805042007',
    districtId: '1805042',
    name: 'Bumirahayu',
  },
  {
    id: '1805042008',
    districtId: '1805042',
    name: 'Sidowaras',
  },
  {
    id: '1805042009',
    districtId: '1805042',
    name: 'Bulusari',
  },
  {
    id: '1805042010',
    districtId: '1805042',
    name: 'Tulung Kakan',
  },
  {
    id: '1805050001',
    districtId: '1805050',
    name: 'Adipuro',
  },
  {
    id: '1805050002',
    districtId: '1805050',
    name: 'Leman Benawi',
  },
  {
    id: '1805050003',
    districtId: '1805050',
    name: 'Depok Rejo',
  },
  {
    id: '1805050004',
    districtId: '1805050',
    name: 'Tempuran',
  },
  {
    id: '1805050005',
    districtId: '1805050',
    name: 'Simbar Waringin',
  },
  {
    id: '1805050006',
    districtId: '1805050',
    name: 'Trimurjo',
  },
  {
    id: '1805050007',
    districtId: '1805050',
    name: 'Notoharjo',
  },
  {
    id: '1805050008',
    districtId: '1805050',
    name: 'Untoro',
  },
  {
    id: '1805050009',
    districtId: '1805050',
    name: 'Purwoadi',
  },
  {
    id: '1805050010',
    districtId: '1805050',
    name: 'Purwodadi',
  },
  {
    id: '1805050011',
    districtId: '1805050',
    name: 'Pujodadi',
  },
  {
    id: '1805050012',
    districtId: '1805050',
    name: 'Pujokerto',
  },
  {
    id: '1805050013',
    districtId: '1805050',
    name: 'Pujo Basuki',
  },
  {
    id: '1805050014',
    districtId: '1805050',
    name: 'Pujoasri',
  },
  {
    id: '1805060001',
    districtId: '1805060',
    name: 'Nunggal Rejo',
  },
  {
    id: '1805060002',
    districtId: '1805060',
    name: 'Badran Sari',
  },
  {
    id: '1805060003',
    districtId: '1805060',
    name: 'Sri Sawahan',
  },
  {
    id: '1805060007',
    districtId: '1805060',
    name: 'Toto Katon',
  },
  {
    id: '1805060008',
    districtId: '1805060',
    name: 'Tanggul Angin',
  },
  {
    id: '1805060009',
    districtId: '1805060',
    name: 'Ngesti Rahayu',
  },
  {
    id: '1805060010',
    districtId: '1805060',
    name: 'Mojo Pahit',
  },
  {
    id: '1805060011',
    districtId: '1805060',
    name: 'Asto Mulyo',
  },
  {
    id: '1805060012',
    districtId: '1805060',
    name: 'Sido Mulyo',
  },
  {
    id: '1805061001',
    districtId: '1805061',
    name: 'Sri Tejo Kencono',
  },
  {
    id: '1805061002',
    districtId: '1805061',
    name: 'Sapto Mulyo',
  },
  {
    id: '1805061003',
    districtId: '1805061',
    name: 'Nambah Rejo',
  },
  {
    id: '1805061004',
    districtId: '1805061',
    name: 'Sumber Rejo',
  },
  {
    id: '1805061005',
    districtId: '1805061',
    name: 'Purworejo',
  },
  {
    id: '1805061006',
    districtId: '1805061',
    name: 'Kota Gajah',
  },
  {
    id: '1805061007',
    districtId: '1805061',
    name: 'Kota Gajah Timur',
  },
  {
    id: '1805070001',
    districtId: '1805070',
    name: 'Rejo Basuki',
  },
  {
    id: '1805070002',
    districtId: '1805070',
    name: 'Rejo Asri',
  },
  {
    id: '1805070003',
    districtId: '1805070',
    name: 'Rukti Endah',
  },
  {
    id: '1805070004',
    districtId: '1805070',
    name: 'Rama Gunawan',
  },
  {
    id: '1805070005',
    districtId: '1805070',
    name: 'Rama Dewa',
  },
  {
    id: '1805070006',
    districtId: '1805070',
    name: 'Ratna Khaton',
  },
  {
    id: '1805070007',
    districtId: '1805070',
    name: 'Ramayana',
  },
  {
    id: '1805070008',
    districtId: '1805070',
    name: 'Rama Indera',
  },
  {
    id: '1805070009',
    districtId: '1805070',
    name: 'Rukti Harjo',
  },
  {
    id: '1805070010',
    districtId: '1805070',
    name: 'Rama Murti',
  },
  {
    id: '1805070011',
    districtId: '1805070',
    name: 'Rama Utama',
  },
  {
    id: '1805070012',
    districtId: '1805070',
    name: 'Rama Nirwana',
  },
  {
    id: '1805070013',
    districtId: '1805070',
    name: 'Buyut Baru',
  },
  {
    id: '1805070014',
    districtId: '1805070',
    name: 'Rama Kelandungan',
  },
  {
    id: '1805080006',
    districtId: '1805080',
    name: 'Adi Jaya',
  },
  {
    id: '1805080008',
    districtId: '1805080',
    name: 'Yukum Jaya',
  },
  {
    id: '1805080009',
    districtId: '1805080',
    name: 'Indra Putra Subing',
  },
  {
    id: '1805080010',
    districtId: '1805080',
    name: 'Karang Endah',
  },
  {
    id: '1805080011',
    districtId: '1805080',
    name: 'Nambah Dadi',
  },
  {
    id: '1805080012',
    districtId: '1805080',
    name: 'Ono Harjo',
  },
  {
    id: '1805080013',
    districtId: '1805080',
    name: 'Terbanggi Besar',
  },
  {
    id: '1805080014',
    districtId: '1805080',
    name: 'Poncowati',
  },
  {
    id: '1805080015',
    districtId: '1805080',
    name: 'Bandar Jaya Timur',
  },
  {
    id: '1805080016',
    districtId: '1805080',
    name: 'Bandar Jaya Barat',
  },
  {
    id: '1805081001',
    districtId: '1805081',
    name: 'Harapan Rejo',
  },
  {
    id: '1805081002',
    districtId: '1805081',
    name: 'Endang Rejo',
  },
  {
    id: '1805081003',
    districtId: '1805081',
    name: 'Dono Arum',
  },
  {
    id: '1805081004',
    districtId: '1805081',
    name: 'Simpang Agung',
  },
  {
    id: '1805081005',
    districtId: '1805081',
    name: 'Bumi Kencana',
  },
  {
    id: '1805081006',
    districtId: '1805081',
    name: 'Gayau Sakti',
  },
  {
    id: '1805081007',
    districtId: '1805081',
    name: 'Fajar Asri',
  },
  {
    id: '1805081008',
    districtId: '1805081',
    name: 'Selusuban',
  },
  {
    id: '1805081009',
    districtId: '1805081',
    name: 'Muji Rahayu',
  },
  {
    id: '1805081010',
    districtId: '1805081',
    name: 'Bumi Mas',
  },
  {
    id: '1805082001',
    districtId: '1805082',
    name: 'Banjar Ratu',
  },
  {
    id: '1805082002',
    districtId: '1805082',
    name: 'Candi Rejo',
  },
  {
    id: '1805082003',
    districtId: '1805082',
    name: 'Purnama Tunggal',
  },
  {
    id: '1805082004',
    districtId: '1805082',
    name: 'Tanjung Ratu Ilir',
  },
  {
    id: '1805082005',
    districtId: '1805082',
    name: 'Banjar Kertarahayu',
  },
  {
    id: '1805082006',
    districtId: '1805082',
    name: 'Lempuyang Bandar',
  },
  {
    id: '1805082007',
    districtId: '1805082',
    name: 'Banjar Rejo',
  },
  {
    id: '1805082008',
    districtId: '1805082',
    name: 'Putra Lempuyang',
  },
  {
    id: '1805090001',
    districtId: '1805090',
    name: 'Gunung Agung',
  },
  {
    id: '1805090002',
    districtId: '1805090',
    name: 'Bandar Agung',
  },
  {
    id: '1805090003',
    districtId: '1805090',
    name: 'Bandar Sakti',
  },
  {
    id: '1805090004',
    districtId: '1805090',
    name: 'Tanjung Anom',
  },
  {
    id: '1805090005',
    districtId: '1805090',
    name: 'Gunung Batin Baru',
  },
  {
    id: '1805090006',
    districtId: '1805090',
    name: 'Gunung Batin Udik',
  },
  {
    id: '1805090007',
    districtId: '1805090',
    name: 'Gunung Batin Ilir',
  },
  {
    id: '1805100001',
    districtId: '1805100',
    name: 'Fajar Mataram',
  },
  {
    id: '1805100002',
    districtId: '1805100',
    name: 'Qurnia Mataram',
  },
  {
    id: '1805100003',
    districtId: '1805100',
    name: 'Rejosari Mataram',
  },
  {
    id: '1805100004',
    districtId: '1805100',
    name: 'Sumber Agung Mataram',
  },
  {
    id: '1805100005',
    districtId: '1805100',
    name: 'Utama Jaya Mataram',
  },
  {
    id: '1805100006',
    districtId: '1805100',
    name: 'Trimulyo Mataram',
  },
  {
    id: '1805100007',
    districtId: '1805100',
    name: 'Wirata Agung Mataram',
  },
  {
    id: '1805100008',
    districtId: '1805100',
    name: 'Varia Agung',
  },
  {
    id: '1805100009',
    districtId: '1805100',
    name: 'Subing Karya',
  },
  {
    id: '1805100010',
    districtId: '1805100',
    name: 'Bumi Setia Mataram',
  },
  {
    id: '1805100011',
    districtId: '1805100',
    name: 'Dharma Agung Mataram',
  },
  {
    id: '1805100013',
    districtId: '1805100',
    name: 'Banjar Agung Mataram',
  },
  {
    id: '1805101001',
    districtId: '1805101',
    name: 'Uman Agung',
  },
  {
    id: '1805101002',
    districtId: '1805101',
    name: 'Sri Wijaya',
  },
  {
    id: '1805101003',
    districtId: '1805101',
    name: 'Sendang Agung Mataram',
  },
  {
    id: '1805101004',
    districtId: '1805101',
    name: 'Jati Datar Mataram',
  },
  {
    id: '1805101005',
    districtId: '1805101',
    name: 'Terbanggi Mulya',
  },
  {
    id: '1805101006',
    districtId: '1805101',
    name: 'Terbanggi Ilir',
  },
  {
    id: '1805101007',
    districtId: '1805101',
    name: 'Mataram Udik',
  },
  {
    id: '1805101008',
    districtId: '1805101',
    name: 'Mataram Jaya',
  },
  {
    id: '1805101009',
    districtId: '1805101',
    name: 'UPT Way Terusan Sp 1',
  },
  {
    id: '1805101010',
    districtId: '1805101',
    name: 'UPT Way Terusan Sp. 2',
  },
  {
    id: '1805101011',
    districtId: '1805101',
    name: 'UPT Way Terusan Sp.3',
  },
  {
    id: '1805101012',
    districtId: '1805101',
    name: 'Sumber Rejeki',
  },
  {
    id: '1805110001',
    districtId: '1805110',
    name: 'Sumber Bahagia',
  },
  {
    id: '1805110002',
    districtId: '1805110',
    name: 'Setia Bumi',
  },
  {
    id: '1805110003',
    districtId: '1805110',
    name: 'Siswa Bangun',
  },
  {
    id: '1805110004',
    districtId: '1805110',
    name: 'Sanggar Buana',
  },
  {
    id: '1805110005',
    districtId: '1805110',
    name: 'Sakti Buana',
  },
  {
    id: '1805110006',
    districtId: '1805110',
    name: 'Setia Bakti',
  },
  {
    id: '1805110007',
    districtId: '1805110',
    name: 'Sumber Baru',
  },
  {
    id: '1805110008',
    districtId: '1805110',
    name: 'Tanjung Harapan',
  },
  {
    id: '1805110009',
    districtId: '1805110',
    name: 'Sari Bakti',
  },
  {
    id: '1805110011',
    districtId: '1805110',
    name: 'Sri Basuki',
  },
  {
    id: '1805110013',
    districtId: '1805110',
    name: 'Swastika Buana',
  },
  {
    id: '1805110014',
    districtId: '1805110',
    name: 'Sumber Fajar',
  },
  {
    id: '1805110015',
    districtId: '1805110',
    name: 'Tanjung Kerajan',
  },
  {
    id: '1805111001',
    districtId: '1805111',
    name: 'Sri Bawono',
  },
  {
    id: '1805111002',
    districtId: '1805111',
    name: 'Sri Budaya',
  },
  {
    id: '1805111003',
    districtId: '1805111',
    name: 'Suko Binangun',
  },
  {
    id: '1805111004',
    districtId: '1805111',
    name: 'Sri Busono',
  },
  {
    id: '1805111005',
    districtId: '1805111',
    name: 'Sido Binangun',
  },
  {
    id: '1805111006',
    districtId: '1805111',
    name: 'Sangga Buana',
  },
  {
    id: '1805120006',
    districtId: '1805120',
    name: 'Bina Karya Buana',
  },
  {
    id: '1805120007',
    districtId: '1805120',
    name: 'Binakarya Putra',
  },
  {
    id: '1805120009',
    districtId: '1805120',
    name: 'Rukti Basuki',
  },
  {
    id: '1805120010',
    districtId: '1805120',
    name: 'Restu Baru',
  },
  {
    id: '1805120011',
    districtId: '1805120',
    name: 'Restu Buana',
  },
  {
    id: '1805120013',
    districtId: '1805120',
    name: 'Reno Basuki',
  },
  {
    id: '1805120014',
    districtId: '1805120',
    name: 'Rekso Binangun',
  },
  {
    id: '1805120015',
    districtId: '1805120',
    name: 'Teluk Dalem Ilir',
  },
  {
    id: '1805120016',
    districtId: '1805120',
    name: 'Bina Karya Mandiri',
  },
  {
    id: '1805121001',
    districtId: '1805121',
    name: 'Bumi Nabung Selatan',
  },
  {
    id: '1805121002',
    districtId: '1805121',
    name: 'Bumi Nabung Baru',
  },
  {
    id: '1805121003',
    districtId: '1805121',
    name: 'Sri Kencono',
  },
  {
    id: '1805121004',
    districtId: '1805121',
    name: 'Bumi Nabung Timur',
  },
  {
    id: '1805121005',
    districtId: '1805121',
    name: 'Bumi Nabung Ilir',
  },
  {
    id: '1805121006',
    districtId: '1805121',
    name: 'Bumi Nabung Utara',
  },
  {
    id: '1805121007',
    districtId: '1805121',
    name: 'Sri Kencono Baru',
  },
  {
    id: '1805122001',
    districtId: '1805122',
    name: 'Joharan',
  },
  {
    id: '1805122002',
    districtId: '1805122',
    name: 'Rantau Jaya Ilir',
  },
  {
    id: '1805122003',
    districtId: '1805122',
    name: 'Bina Karya Sakti',
  },
  {
    id: '1805122004',
    districtId: '1805122',
    name: 'Bina Karya Jaya',
  },
  {
    id: '1805122005',
    districtId: '1805122',
    name: 'Bina Karya Utama',
  },
  {
    id: '1805122006',
    districtId: '1805122',
    name: 'Rantau Jaya Baru',
  },
  {
    id: '1805122007',
    districtId: '1805122',
    name: 'Meranggi Jaya',
  },
  {
    id: '1805122008',
    districtId: '1805122',
    name: 'Mekar Jaya',
  },
  {
    id: '1805122009',
    districtId: '1805122',
    name: 'Bina Karya Baru',
  },
  {
    id: '1805122010',
    districtId: '1805122',
    name: 'Rantau Jaya Makmur',
  },
  {
    id: '1805130001',
    districtId: '1805130',
    name: 'Gaya Baru Enam',
  },
  {
    id: '1805130002',
    districtId: '1805130',
    name: 'Rawa Betik',
  },
  {
    id: '1805130011',
    districtId: '1805130',
    name: 'Gaya Baru Empat',
  },
  {
    id: '1805130012',
    districtId: '1805130',
    name: 'Gaya Baru Tujuh',
  },
  {
    id: '1805130013',
    districtId: '1805130',
    name: 'Sumber Katon',
  },
  {
    id: '1805130014',
    districtId: '1805130',
    name: 'Sri Katon',
  },
  {
    id: '1805130015',
    districtId: '1805130',
    name: 'Gaya Baru Dua',
  },
  {
    id: '1805130016',
    districtId: '1805130',
    name: 'Gaya Baru Tiga',
  },
  {
    id: '1805130018',
    districtId: '1805130',
    name: 'Kenanga Sari',
  },
  {
    id: '1805130019',
    districtId: '1805130',
    name: 'Sri Mulya Jaya',
  },
  {
    id: '1805130020',
    districtId: '1805130',
    name: 'Gaya Baru Satu',
  },
  {
    id: '1805130021',
    districtId: '1805130',
    name: 'Gaya Baru Delapan',
  },
  {
    id: '1805130022',
    districtId: '1805130',
    name: 'Mataram Ilir',
  },
  {
    id: '1805131001',
    districtId: '1805131',
    name: 'Raja Wali',
  },
  {
    id: '1805131002',
    districtId: '1805131',
    name: 'Surabaya Ilir',
  },
  {
    id: '1805131003',
    districtId: '1805131',
    name: 'Beringin Jaya',
  },
  {
    id: '1805131004',
    districtId: '1805131',
    name: 'Cempaka Putih',
  },
  {
    id: '1805131005',
    districtId: '1805131',
    name: 'Sido Dadi',
  },
  {
    id: '1805131006',
    districtId: '1805131',
    name: 'Cabang',
  },
  {
    id: '1805131007',
    districtId: '1805131',
    name: 'Sumber Agung',
  },
  {
    id: '1805131008',
    districtId: '1805131',
    name: 'Gaya Baru Lima',
  },
  {
    id: '1805131009',
    districtId: '1805131',
    name: 'Subang Jaya',
  },
  {
    id: '1805131010',
    districtId: '1805131',
    name: 'Surabaya Baru',
  },
  {
    id: '1806010001',
    districtId: '1806010',
    name: 'Tanjung Baru',
  },
  {
    id: '1806010002',
    districtId: '1806010',
    name: 'Tanjung Baru Timur',
  },
  {
    id: '1806010005',
    districtId: '1806010',
    name: 'Bukit Kemuning',
  },
  {
    id: '1806010006',
    districtId: '1806010',
    name: 'Muara Aman',
  },
  {
    id: '1806010007',
    districtId: '1806010',
    name: 'Suka Menanti',
  },
  {
    id: '1806010008',
    districtId: '1806010',
    name: 'Tanjung Waras',
  },
  {
    id: '1806010015',
    districtId: '1806010',
    name: 'Dwikora',
  },
  {
    id: '1806010016',
    districtId: '1806010',
    name: 'Sidomulyo',
  },
  {
    id: '1806011001',
    districtId: '1806011',
    name: 'Sidokayo',
  },
  {
    id: '1806011002',
    districtId: '1806011',
    name: 'Sekipi',
  },
  {
    id: '1806011003',
    districtId: '1806011',
    name: 'Muara Dua',
  },
  {
    id: '1806011004',
    districtId: '1806011',
    name: 'Ulak Rengas',
  },
  {
    id: '1806011005',
    districtId: '1806011',
    name: 'Pulau Panggung',
  },
  {
    id: '1806011006',
    districtId: '1806011',
    name: 'Kebon Dalam',
  },
  {
    id: '1806011007',
    districtId: '1806011',
    name: 'Sukamaju',
  },
  {
    id: '1806011008',
    districtId: '1806011',
    name: 'Sukamarga',
  },
  {
    id: '1806020001',
    districtId: '1806020',
    name: 'Tulung Balak',
  },
  {
    id: '1806020002',
    districtId: '1806020',
    name: 'Suka Mulya',
  },
  {
    id: '1806020003',
    districtId: '1806020',
    name: 'Gunung Katon',
  },
  {
    id: '1806020004',
    districtId: '1806020',
    name: 'Karang Waringin',
  },
  {
    id: '1806020005',
    districtId: '1806020',
    name: 'Sukasari',
  },
  {
    id: '1806020006',
    districtId: '1806020',
    name: 'Sido Mulyo',
  },
  {
    id: '1806020007',
    districtId: '1806020',
    name: 'Tanjung Beringin',
  },
  {
    id: '1806020008',
    districtId: '1806020',
    name: 'Merambung',
  },
  {
    id: '1806020009',
    districtId: '1806020',
    name: 'Sinar Jaya',
  },
  {
    id: '1806020010',
    districtId: '1806020',
    name: 'Sindang Agung',
  },
  {
    id: '1806020011',
    districtId: '1806020',
    name: 'Mekar Jaya',
  },
  {
    id: '1806020012',
    districtId: '1806020',
    name: 'Sri Menanti',
  },
  {
    id: '1806020013',
    districtId: '1806020',
    name: 'Tanjung Raja',
  },
  {
    id: '1806020014',
    districtId: '1806020',
    name: 'Tanjung Riang',
  },
  {
    id: '1806020015',
    districtId: '1806020',
    name: 'Kemala Raja',
  },
  {
    id: '1806020016',
    districtId: '1806020',
    name: 'Ulak Ata',
  },
  {
    id: '1806020017',
    districtId: '1806020',
    name: 'Sindang Marga',
  },
  {
    id: '1806020018',
    districtId: '1806020',
    name: 'Sinar Mulya',
  },
  {
    id: '1806020019',
    districtId: '1806020',
    name: 'Priangan Baru',
  },
  {
    id: '1806030017',
    districtId: '1806030',
    name: 'Hujan Mas',
  },
  {
    id: '1806030024',
    districtId: '1806030',
    name: 'Bumi Nabung',
  },
  {
    id: '1806030025',
    districtId: '1806030',
    name: 'Pengaringan',
  },
  {
    id: '1806030026',
    districtId: '1806030',
    name: 'Simpang Abung',
  },
  {
    id: '1806030027',
    districtId: '1806030',
    name: 'Way Wakak',
  },
  {
    id: '1806030028',
    districtId: '1806030',
    name: 'Tanjung Harta',
  },
  {
    id: '1806030029',
    districtId: '1806030',
    name: 'Cahaya Negeri',
  },
  {
    id: '1806030030',
    districtId: '1806030',
    name: 'Ogan Lima',
  },
  {
    id: '1806030031',
    districtId: '1806030',
    name: 'Kistang',
  },
  {
    id: '1806030032',
    districtId: '1806030',
    name: 'Kemplas',
  },
  {
    id: '1806030033',
    districtId: '1806030',
    name: 'Pematang Kasih',
  },
  {
    id: '1806030034',
    districtId: '1806030',
    name: 'Lepang Besar',
  },
  {
    id: '1806030036',
    districtId: '1806030',
    name: 'Gunung Betuah',
  },
  {
    id: '1806030037',
    districtId: '1806030',
    name: 'Bumi Mandiri',
  },
  {
    id: '1806031006',
    districtId: '1806031',
    name: 'Gunung Gijul',
  },
  {
    id: '1806031008',
    districtId: '1806031',
    name: 'Gunung Sadar',
  },
  {
    id: '1806031009',
    districtId: '1806031',
    name: 'Subik',
  },
  {
    id: '1806031013',
    districtId: '1806031',
    name: 'Pekurun Selatan',
  },
  {
    id: '1806031014',
    districtId: '1806031',
    name: 'Pekurun Barat',
  },
  {
    id: '1806031015',
    districtId: '1806031',
    name: 'Pekurun Utara',
  },
  {
    id: '1806031016',
    districtId: '1806031',
    name: 'Kedaton',
  },
  {
    id: '1806031017',
    districtId: '1806031',
    name: 'Sri Bandung',
  },
  {
    id: '1806031018',
    districtId: '1806031',
    name: 'Negla Sari',
  },
  {
    id: '1806031019',
    districtId: '1806031',
    name: 'Kinciran',
  },
  {
    id: '1806031020',
    districtId: '1806031',
    name: 'Gunung Besar',
  },
  {
    id: '1806032001',
    districtId: '1806032',
    name: 'Beringin',
  },
  {
    id: '1806032002',
    districtId: '1806032',
    name: 'Sabuk Empat',
  },
  {
    id: '1806032003',
    districtId: '1806032',
    name: 'Sabuk Indah',
  },
  {
    id: '1806032004',
    districtId: '1806032',
    name: 'Talang Jembatan',
  },
  {
    id: '1806032005',
    districtId: '1806032',
    name: 'Aji Kagungan',
  },
  {
    id: '1806032006',
    districtId: '1806032',
    name: 'Bindu',
  },
  {
    id: '1806032007',
    districtId: '1806032',
    name: 'Way Perancang',
  },
  {
    id: '1806033001',
    districtId: '1806033',
    name: 'Campang Gijul',
  },
  {
    id: '1806033002',
    districtId: '1806033',
    name: 'Nyapah Banyu',
  },
  {
    id: '1806033003',
    districtId: '1806033',
    name: 'Sinar Gunung',
  },
  {
    id: '1806033004',
    districtId: '1806033',
    name: 'Ogan Campang',
  },
  {
    id: '1806033005',
    districtId: '1806033',
    name: 'Sumber Tani',
  },
  {
    id: '1806033006',
    districtId: '1806033',
    name: 'Ogan Jaya',
  },
  {
    id: '1806033007',
    districtId: '1806033',
    name: 'Pekurun Udik',
  },
  {
    id: '1806033008',
    districtId: '1806033',
    name: 'Pekurun Tengah',
  },
  {
    id: '1806033009',
    districtId: '1806033',
    name: 'Pekurun',
  },
  {
    id: '1806040006',
    districtId: '1806040',
    name: 'Talang Bojong',
  },
  {
    id: '1806040011',
    districtId: '1806040',
    name: 'Kota Gapura',
  },
  {
    id: '1806040013',
    districtId: '1806040',
    name: 'Cempedak',
  },
  {
    id: '1806040014',
    districtId: '1806040',
    name: 'Sribasuki',
  },
  {
    id: '1806040015',
    districtId: '1806040',
    name: 'Rejosari',
  },
  {
    id: '1806040016',
    districtId: '1806040',
    name: 'Kotabumi Tengah',
  },
  {
    id: '1806040017',
    districtId: '1806040',
    name: 'Kotabumi Ilir',
  },
  {
    id: '1806040018',
    districtId: '1806040',
    name: 'Kotabumi Pasar',
  },
  {
    id: '1806040019',
    districtId: '1806040',
    name: 'Kotabumi Udik',
  },
  {
    id: '1806040020',
    districtId: '1806040',
    name: 'Sindang Sari',
  },
  {
    id: '1806040027',
    districtId: '1806040',
    name: 'Kotabumi Tengah Barat',
  },
  {
    id: '1806040028',
    districtId: '1806040',
    name: 'Bojong Barat',
  },
  {
    id: '1806040029',
    districtId: '1806040',
    name: 'Sumber Arum',
  },
  {
    id: '1806041001',
    districtId: '1806041',
    name: 'Kali Cinta',
  },
  {
    id: '1806041002',
    districtId: '1806041',
    name: 'Madukoro Baru',
  },
  {
    id: '1806041003',
    districtId: '1806041',
    name: 'Madukoro',
  },
  {
    id: '1806041004',
    districtId: '1806041',
    name: 'Talang Jali',
  },
  {
    id: '1806041005',
    districtId: '1806041',
    name: 'Margorejo',
  },
  {
    id: '1806041006',
    districtId: '1806041',
    name: 'Banjar Wangi',
  },
  {
    id: '1806041007',
    districtId: '1806041',
    name: 'Wonomarto',
  },
  {
    id: '1806041008',
    districtId: '1806041',
    name: 'Sawo Jajar',
  },
  {
    id: '1806042001',
    districtId: '1806042',
    name: 'Taman Jaya',
  },
  {
    id: '1806042002',
    districtId: '1806042',
    name: 'Jerangkang',
  },
  {
    id: '1806042003',
    districtId: '1806042',
    name: 'Way Melan',
  },
  {
    id: '1806042004',
    districtId: '1806042',
    name: 'Bandar Putih',
  },
  {
    id: '1806042005',
    districtId: '1806042',
    name: 'Karang Agung',
  },
  {
    id: '1806042006',
    districtId: '1806042',
    name: 'Mulang Maya',
  },
  {
    id: '1806042007',
    districtId: '1806042',
    name: 'Curup Guruh Kagungan',
  },
  {
    id: '1806042008',
    districtId: '1806042',
    name: 'Kota Alam',
  },
  {
    id: '1806042009',
    districtId: '1806042',
    name: 'Kelapa Tujuh',
  },
  {
    id: '1806042010',
    districtId: '1806042',
    name: 'Tanjung Aman',
  },
  {
    id: '1806042011',
    districtId: '1806042',
    name: 'Tanjung Senang',
  },
  {
    id: '1806042012',
    districtId: '1806042',
    name: 'Tanjung Harapan',
  },
  {
    id: '1806042013',
    districtId: '1806042',
    name: 'Alam Jaya',
  },
  {
    id: '1806042014',
    districtId: '1806042',
    name: 'Sinar Mas Alam',
  },
  {
    id: '1806050001',
    districtId: '1806050',
    name: 'Gilih Sukanegeri',
  },
  {
    id: '1806050002',
    districtId: '1806050',
    name: 'Cabang Empat',
  },
  {
    id: '1806050003',
    districtId: '1806050',
    name: 'Sinar Ogan',
  },
  {
    id: '1806050004',
    districtId: '1806050',
    name: 'Candi Mas',
  },
  {
    id: '1806050005',
    districtId: '1806050',
    name: 'Trimodadi',
  },
  {
    id: '1806050011',
    districtId: '1806050',
    name: 'Kali Balangan',
  },
  {
    id: '1806050012',
    districtId: '1806050',
    name: 'Kembang Tanjung',
  },
  {
    id: '1806050013',
    districtId: '1806050',
    name: 'Kembang Gading',
  },
  {
    id: '1806050014',
    districtId: '1806050',
    name: 'Abung Jayo',
  },
  {
    id: '1806050015',
    districtId: '1806050',
    name: 'Cabang Abung Raya',
  },
  {
    id: '1806050016',
    districtId: '1806050',
    name: 'Kalibening Raya',
  },
  {
    id: '1806050017',
    districtId: '1806050',
    name: 'Ratu Abung',
  },
  {
    id: '1806050018',
    districtId: '1806050',
    name: 'Kemalo Abung',
  },
  {
    id: '1806050019',
    districtId: '1806050',
    name: 'Bandar Kagungan Raya',
  },
  {
    id: '1806050020',
    districtId: '1806050',
    name: 'Way Lunik',
  },
  {
    id: '1806050021',
    districtId: '1806050',
    name: 'Bumi Raya',
  },
  {
    id: '1806051001',
    districtId: '1806051',
    name: 'Sukamaju',
  },
  {
    id: '1806051002',
    districtId: '1806051',
    name: 'Semuli Jaya',
  },
  {
    id: '1806051003',
    districtId: '1806051',
    name: 'Semuli Raya',
  },
  {
    id: '1806051004',
    districtId: '1806051',
    name: 'Papan Asri',
  },
  {
    id: '1806051005',
    districtId: '1806051',
    name: 'Sido Rahayu',
  },
  {
    id: '1806051006',
    districtId: '1806051',
    name: 'Gunung Kramat',
  },
  {
    id: '1806051007',
    districtId: '1806051',
    name: 'Gunung Sari',
  },
  {
    id: '1806052001',
    districtId: '1806052',
    name: 'Jagang',
  },
  {
    id: '1806052002',
    districtId: '1806052',
    name: 'Tanjung Iman',
  },
  {
    id: '1806052003',
    districtId: '1806052',
    name: 'Blambangan',
  },
  {
    id: '1806052004',
    districtId: '1806052',
    name: 'Pagar Gading',
  },
  {
    id: '1806052005',
    districtId: '1806052',
    name: 'Tulung Singkip',
  },
  {
    id: '1806052006',
    districtId: '1806052',
    name: 'Pagar',
  },
  {
    id: '1806052007',
    districtId: '1806052',
    name: 'Buring Kencana',
  },
  {
    id: '1806060001',
    districtId: '1806060',
    name: 'Banjar Agung',
  },
  {
    id: '1806060002',
    districtId: '1806060',
    name: 'Bumi Agung Marga',
  },
  {
    id: '1806060003',
    districtId: '1806060',
    name: 'Peraduan Waras',
  },
  {
    id: '1806060004',
    districtId: '1806060',
    name: 'Penagan Ratu',
  },
  {
    id: '1806060005',
    districtId: '1806060',
    name: 'Gedung Nyapah',
  },
  {
    id: '1806060006',
    districtId: '1806060',
    name: 'Pungguk Lama',
  },
  {
    id: '1806060007',
    districtId: '1806060',
    name: 'Surakarta',
  },
  {
    id: '1806060008',
    districtId: '1806060',
    name: 'Sumber Agung',
  },
  {
    id: '1806060009',
    districtId: '1806060',
    name: 'Sidomukti',
  },
  {
    id: '1806060010',
    districtId: '1806060',
    name: 'Bumi Jaya',
  },
  {
    id: '1806060011',
    districtId: '1806060',
    name: 'Rejo Mulyo',
  },
  {
    id: '1806060021',
    districtId: '1806060',
    name: 'Papan Rejo',
  },
  {
    id: '1806061001',
    districtId: '1806061',
    name: 'Bandar Abung',
  },
  {
    id: '1806061002',
    districtId: '1806061',
    name: 'Bangun Sari',
  },
  {
    id: '1806061003',
    districtId: '1806061',
    name: 'Tata Karya',
  },
  {
    id: '1806061004',
    districtId: '1806061',
    name: 'Sukoharjo',
  },
  {
    id: '1806061005',
    districtId: '1806061',
    name: 'Bumi Restu',
  },
  {
    id: '1806061006',
    districtId: '1806061',
    name: 'Bumi Raharja',
  },
  {
    id: '1806061007',
    districtId: '1806061',
    name: 'Purba Sakti',
  },
  {
    id: '1806061008',
    districtId: '1806061',
    name: 'Bandar Sakti',
  },
  {
    id: '1806061009',
    districtId: '1806061',
    name: 'Karya Sakti',
  },
  {
    id: '1806070011',
    districtId: '1806070',
    name: 'Bumi Ratu',
  },
  {
    id: '1806070014',
    districtId: '1806070',
    name: 'Sirna Galih',
  },
  {
    id: '1806070015',
    districtId: '1806070',
    name: 'Labuhan Ratu Pasar',
  },
  {
    id: '1806070016',
    districtId: '1806070',
    name: 'Labuhan Ratu Kampung',
  },
  {
    id: '1806070017',
    districtId: '1806070',
    name: 'Gedung Ketapang',
  },
  {
    id: '1806070018',
    districtId: '1806070',
    name: 'Banjar Ketapang',
  },
  {
    id: '1806070019',
    districtId: '1806070',
    name: 'Kota Agung',
  },
  {
    id: '1806070020',
    districtId: '1806070',
    name: 'Ketapang',
  },
  {
    id: '1806070021',
    districtId: '1806070',
    name: 'Karang Rejo',
  },
  {
    id: '1806070022',
    districtId: '1806070',
    name: 'Sidodadi',
  },
  {
    id: '1806070023',
    districtId: '1806070',
    name: 'Gunung Labuhan',
  },
  {
    id: '1806071001',
    districtId: '1806071',
    name: 'Negeri Ratu',
  },
  {
    id: '1806071002',
    districtId: '1806071',
    name: 'Pakuan Agung',
  },
  {
    id: '1806071003',
    districtId: '1806071',
    name: 'Banjar Ratu',
  },
  {
    id: '1806071004',
    districtId: '1806071',
    name: 'Banjar Negeri',
  },
  {
    id: '1806071005',
    districtId: '1806071',
    name: 'Negeri Ujung Karang',
  },
  {
    id: '1806071006',
    districtId: '1806071',
    name: 'Bandar Agung',
  },
  {
    id: '1806071007',
    districtId: '1806071',
    name: 'Karang Sari',
  },
  {
    id: '1806071008',
    districtId: '1806071',
    name: 'Karang Sakti',
  },
  {
    id: '1806071009',
    districtId: '1806071',
    name: 'Karang Rejo II',
  },
  {
    id: '1806071010',
    districtId: '1806071',
    name: 'Karang Mulyo',
  },
  {
    id: '1806071011',
    districtId: '1806071',
    name: 'Sumber Agung',
  },
  {
    id: '1806072001',
    districtId: '1806072',
    name: 'Kota Napal',
  },
  {
    id: '1806072002',
    districtId: '1806072',
    name: 'Tanah Abang',
  },
  {
    id: '1806072003',
    districtId: '1806072',
    name: 'Negara Tulang Bawang',
  },
  {
    id: '1806072004',
    districtId: '1806072',
    name: 'Tulang Bawang Baru',
  },
  {
    id: '1806072005',
    districtId: '1806072',
    name: 'Sukadana Ilir',
  },
  {
    id: '1806072006',
    districtId: '1806072',
    name: 'Sukadana Udik',
  },
  {
    id: '1806072007',
    districtId: '1806072',
    name: 'Haduyang Ratu',
  },
  {
    id: '1806072008',
    districtId: '1806072',
    name: 'Isorejo',
  },
  {
    id: '1806072009',
    districtId: '1806072',
    name: 'Mulyo Rejo II',
  },
  {
    id: '1806072010',
    districtId: '1806072',
    name: 'Mulyo Rejo I',
  },
  {
    id: '1806072011',
    districtId: '1806072',
    name: 'Sukamaju',
  },
  {
    id: '1806073001',
    districtId: '1806073',
    name: 'Comok Sinar Jaya',
  },
  {
    id: '1806073002',
    districtId: '1806073',
    name: 'Way Isem',
  },
  {
    id: '1806073003',
    districtId: '1806073',
    name: 'Sinar Harapan',
  },
  {
    id: '1806073004',
    districtId: '1806073',
    name: 'Cahaya Mas',
  },
  {
    id: '1806073005',
    districtId: '1806073',
    name: 'Gunung Maknibai',
  },
  {
    id: '1806073006',
    districtId: '1806073',
    name: 'Negeri Sakti',
  },
  {
    id: '1806073007',
    districtId: '1806073',
    name: 'Gunung Raja',
  },
  {
    id: '1806073008',
    districtId: '1806073',
    name: 'Kubuhitu',
  },
  {
    id: '1806073009',
    districtId: '1806073',
    name: 'Tanjung Jaya',
  },
  {
    id: '1806073010',
    districtId: '1806073',
    name: 'Negeri Batin Jaya',
  },
  {
    id: '1806074001',
    districtId: '1806074',
    name: 'Lepang Tengah',
  },
  {
    id: '1806074002',
    districtId: '1806074',
    name: 'Sukajaya',
  },
  {
    id: '1806074003',
    districtId: '1806074',
    name: 'Negara Agung',
  },
  {
    id: '1806074004',
    districtId: '1806074',
    name: 'Sri Agung',
  },
  {
    id: '1806074005',
    districtId: '1806074',
    name: 'Cahaya Makmur',
  },
  {
    id: '1806074006',
    districtId: '1806074',
    name: 'Sri Jaya',
  },
  {
    id: '1806074007',
    districtId: '1806074',
    name: 'Cempaka Barat',
  },
  {
    id: '1806074008',
    districtId: '1806074',
    name: 'Cempaka',
  },
  {
    id: '1806074009',
    districtId: '1806074',
    name: 'Cempaka Timur',
  },
  {
    id: '1806080010',
    districtId: '1806080',
    name: 'Baru Raharja',
  },
  {
    id: '1806080012',
    districtId: '1806080',
    name: 'Ogan Jaya',
  },
  {
    id: '1806080013',
    districtId: '1806080',
    name: 'Bangun Jaya',
  },
  {
    id: '1806080019',
    districtId: '1806080',
    name: 'Negeri Ratu',
  },
  {
    id: '1806080020',
    districtId: '1806080',
    name: 'Padang Ratu',
  },
  {
    id: '1806080021',
    districtId: '1806080',
    name: 'Negeri Sakti',
  },
  {
    id: '1806080022',
    districtId: '1806080',
    name: 'Ciamis',
  },
  {
    id: '1806080024',
    districtId: '1806080',
    name: 'Gedung Batin',
  },
  {
    id: '1806080025',
    districtId: '1806080',
    name: 'Negara Batin',
  },
  {
    id: '1806080026',
    districtId: '1806080',
    name: 'Batu Raja',
  },
  {
    id: '1806080027',
    districtId: '1806080',
    name: 'Negara Ratu',
  },
  {
    id: '1806080029',
    districtId: '1806080',
    name: 'Kota Negara',
  },
  {
    id: '1806080030',
    districtId: '1806080',
    name: 'Hanakau Jaya',
  },
  {
    id: '1806080031',
    districtId: '1806080',
    name: 'Negara Batin II',
  },
  {
    id: '1806080032',
    districtId: '1806080',
    name: 'Kota Negara Ilir',
  },
  {
    id: '1806081001',
    districtId: '1806081',
    name: 'Bunglai Tengah',
  },
  {
    id: '1806081002',
    districtId: '1806081',
    name: 'Negara Kemakmuran',
  },
  {
    id: '1806081003',
    districtId: '1806081',
    name: 'Tanjung Harapan',
  },
  {
    id: '1806081004',
    districtId: '1806081',
    name: 'Lubuk Rukam',
  },
  {
    id: '1806081005',
    districtId: '1806081',
    name: 'Gedung Makripat',
  },
  {
    id: '1806081006',
    districtId: '1806081',
    name: 'Beringin Jaya',
  },
  {
    id: '1806081007',
    districtId: '1806081',
    name: 'Ibul Jaya',
  },
  {
    id: '1806081008',
    districtId: '1806081',
    name: 'Tulung Buyut',
  },
  {
    id: '1806081009',
    districtId: '1806081',
    name: 'Gedung Raja',
  },
  {
    id: '1806081010',
    districtId: '1806081',
    name: 'Gedung Negara',
  },
  {
    id: '1806082001',
    districtId: '1806082',
    name: 'Negeri Campang Jaya',
  },
  {
    id: '1806082002',
    districtId: '1806082',
    name: 'Pampang Tangguk Jaya',
  },
  {
    id: '1806082003',
    districtId: '1806082',
    name: 'Ratu Jaya',
  },
  {
    id: '1806082004',
    districtId: '1806082',
    name: 'Negeri Galih Rejo',
  },
  {
    id: '1806082005',
    districtId: '1806082',
    name: 'Batu Nangkop',
  },
  {
    id: '1806082006',
    districtId: '1806082',
    name: 'Mekar Asri',
  },
  {
    id: '1806082007',
    districtId: '1806082',
    name: 'Negara Bumi',
  },
  {
    id: '1806082008',
    districtId: '1806082',
    name: 'Melungun Ratu',
  },
  {
    id: '1807010001',
    districtId: '1807010',
    name: 'Juku Batu',
  },
  {
    id: '1807010002',
    districtId: '1807010',
    name: 'Bandar Agung',
  },
  {
    id: '1807010003',
    districtId: '1807010',
    name: 'Sumber Sari',
  },
  {
    id: '1807010004',
    districtId: '1807010',
    name: 'Bonglai',
  },
  {
    id: '1807010005',
    districtId: '1807010',
    name: 'Campang Delapan',
  },
  {
    id: '1807010006',
    districtId: '1807010',
    name: 'Kemu',
  },
  {
    id: '1807010007',
    districtId: '1807010',
    name: 'Sumber Baru',
  },
  {
    id: '1807010008',
    districtId: '1807010',
    name: 'Neki',
  },
  {
    id: '1807010009',
    districtId: '1807010',
    name: 'Rantau Temiang',
  },
  {
    id: '1807010010',
    districtId: '1807010',
    name: 'Menanga Siamang',
  },
  {
    id: '1807010011',
    districtId: '1807010',
    name: 'Menanga Jaya',
  },
  {
    id: '1807010012',
    districtId: '1807010',
    name: 'Rebang Tinggi',
  },
  {
    id: '1807010013',
    districtId: '1807010',
    name: 'Argomulyo',
  },
  {
    id: '1807010014',
    districtId: '1807010',
    name: 'Rantau Jaya',
  },
  {
    id: '1807010015',
    districtId: '1807010',
    name: 'Simpang Asam',
  },
  {
    id: '1807010016',
    districtId: '1807010',
    name: 'Pasar Banjit',
  },
  {
    id: '1807010017',
    districtId: '1807010',
    name: 'Bali Sadar Selatan',
  },
  {
    id: '1807010018',
    districtId: '1807010',
    name: 'Bali Sadar Tengah',
  },
  {
    id: '1807010019',
    districtId: '1807010',
    name: 'Bali Sadar Utara',
  },
  {
    id: '1807010020',
    districtId: '1807010',
    name: 'Dono Mulyo',
  },
  {
    id: '1807020014',
    districtId: '1807020',
    name: 'Banjar Masin',
  },
  {
    id: '1807020015',
    districtId: '1807020',
    name: 'Banjar Agung',
  },
  {
    id: '1807020016',
    districtId: '1807020',
    name: 'Banjar Mulia',
  },
  {
    id: '1807020017',
    districtId: '1807020',
    name: 'Banjar Baru',
  },
  {
    id: '1807020018',
    districtId: '1807020',
    name: 'Banjar Negara',
  },
  {
    id: '1807020019',
    districtId: '1807020',
    name: 'Banjar Setia',
  },
  {
    id: '1807020020',
    districtId: '1807020',
    name: 'Mekar Asri',
  },
  {
    id: '1807020021',
    districtId: '1807020',
    name: 'Tiuh Balak',
  },
  {
    id: '1807020022',
    districtId: '1807020',
    name: 'Campur Asri',
  },
  {
    id: '1807020023',
    districtId: '1807020',
    name: 'Gedung Rejo',
  },
  {
    id: '1807020024',
    districtId: '1807020',
    name: 'Taman Asri',
  },
  {
    id: '1807020025',
    districtId: '1807020',
    name: 'Tiuh Balak Pasar',
  },
  {
    id: '1807020026',
    districtId: '1807020',
    name: 'Setia Negara',
  },
  {
    id: '1807020027',
    districtId: '1807020',
    name: 'Bhakti Negara',
  },
  {
    id: '1807020028',
    districtId: '1807020',
    name: 'Tiuh Balak I',
  },
  {
    id: '1807020029',
    districtId: '1807020',
    name: 'Gedung Pakuon',
  },
  {
    id: '1807020030',
    districtId: '1807020',
    name: 'Cugah',
  },
  {
    id: '1807020031',
    districtId: '1807020',
    name: 'Bumi Merapi',
  },
  {
    id: '1807020032',
    districtId: '1807020',
    name: 'Bumi Rejo',
  },
  {
    id: '1807020033',
    districtId: '1807020',
    name: 'Banjar Sari',
  },
  {
    id: '1807020034',
    districtId: '1807020',
    name: 'Sukosari',
  },
  {
    id: '1807020038',
    districtId: '1807020',
    name: 'Gunung Katun',
  },
  {
    id: '1807021001',
    districtId: '1807021',
    name: 'Banjar Ratu',
  },
  {
    id: '1807021002',
    districtId: '1807021',
    name: 'Banjar Sakti',
  },
  {
    id: '1807021003',
    districtId: '1807021',
    name: 'Gunung Baru',
  },
  {
    id: '1807021004',
    districtId: '1807021',
    name: 'Suka Negeri',
  },
  {
    id: '1807021005',
    districtId: '1807021',
    name: 'Negeri Mulyo',
  },
  {
    id: '1807021006',
    districtId: '1807021',
    name: 'Negeri Sungkai',
  },
  {
    id: '1807021007',
    districtId: '1807021',
    name: 'Gunung Sari',
  },
  {
    id: '1807021008',
    districtId: '1807021',
    name: 'Gunung Labuhan',
  },
  {
    id: '1807021009',
    districtId: '1807021',
    name: 'Bengkulu Rejo',
  },
  {
    id: '1807021010',
    districtId: '1807021',
    name: 'Bengkulu',
  },
  {
    id: '1807021011',
    districtId: '1807021',
    name: 'Way Tuba',
  },
  {
    id: '1807021012',
    districtId: '1807021',
    name: 'Bengkulu Raman',
  },
  {
    id: '1807021013',
    districtId: '1807021',
    name: 'Kayu Batu',
  },
  {
    id: '1807021014',
    districtId: '1807021',
    name: 'Bengkulu Jaya',
  },
  {
    id: '1807021015',
    districtId: '1807021',
    name: 'Curup Patah',
  },
  {
    id: '1807021016',
    districtId: '1807021',
    name: 'Tiuh Balak II',
  },
  {
    id: '1807021017',
    districtId: '1807021',
    name: 'Sukarame',
  },
  {
    id: '1807021018',
    districtId: '1807021',
    name: 'Negeri Ujan Mas',
  },
  {
    id: '1807021019',
    districtId: '1807021',
    name: 'Bengkulu Tengah',
  },
  {
    id: '1807021020',
    districtId: '1807021',
    name: 'Gunung Pekuwon',
  },
  {
    id: '1807021021',
    districtId: '1807021',
    name: 'Labuhan Jaya',
  },
  {
    id: '1807030001',
    districtId: '1807030',
    name: 'Sinar Gading',
  },
  {
    id: '1807030002',
    districtId: '1807030',
    name: 'Sukajadi',
  },
  {
    id: '1807030003',
    districtId: '1807030',
    name: 'Karang Lantang',
  },
  {
    id: '1807030004',
    districtId: '1807030',
    name: 'Kedaton',
  },
  {
    id: '1807030005',
    districtId: '1807030',
    name: 'Datar Bancong',
  },
  {
    id: '1807030006',
    districtId: '1807030',
    name: 'Kasui Pasar',
  },
  {
    id: '1807030007',
    districtId: '1807030',
    name: 'Kasui Lama',
  },
  {
    id: '1807030008',
    districtId: '1807030',
    name: 'Talang Mangga',
  },
  {
    id: '1807030009',
    districtId: '1807030',
    name: 'Jaya Tinggi',
  },
  {
    id: '1807030010',
    districtId: '1807030',
    name: 'Gelombang Panjang',
  },
  {
    id: '1807030011',
    districtId: '1807030',
    name: 'Kampung Baru',
  },
  {
    id: '1807030012',
    districtId: '1807030',
    name: 'Tangkas',
  },
  {
    id: '1807030013',
    districtId: '1807030',
    name: 'Jukuh Kemuning',
  },
  {
    id: '1807030015',
    districtId: '1807030',
    name: 'Kota Way',
  },
  {
    id: '1807030016',
    districtId: '1807030',
    name: 'Tanjung Bulan',
  },
  {
    id: '1807030017',
    districtId: '1807030',
    name: 'Tanjung Harapan',
  },
  {
    id: '1807030018',
    districtId: '1807030',
    name: 'Tanjung Kurung',
  },
  {
    id: '1807030019',
    districtId: '1807030',
    name: 'Tanjung Kurung Lama',
  },
  {
    id: '1807030020',
    districtId: '1807030',
    name: 'Bukit Batu',
  },
  {
    id: '1807031001',
    districtId: '1807031',
    name: 'Gunung Sari',
  },
  {
    id: '1807031002',
    districtId: '1807031',
    name: 'Lebak Peniangan',
  },
  {
    id: '1807031003',
    districtId: '1807031',
    name: 'Madang Jaya',
  },
  {
    id: '1807031004',
    districtId: '1807031',
    name: 'Tanjung Tiga',
  },
  {
    id: '1807031005',
    districtId: '1807031',
    name: 'Air Ringkih',
  },
  {
    id: '1807031006',
    districtId: '1807031',
    name: 'Simpang Tiga',
  },
  {
    id: '1807031007',
    districtId: '1807031',
    name: 'Tanjung Raya',
  },
  {
    id: '1807031008',
    districtId: '1807031',
    name: 'Beringin Jaya',
  },
  {
    id: '1807031009',
    districtId: '1807031',
    name: 'Karya Maju',
  },
  {
    id: '1807031010',
    districtId: '1807031',
    name: 'Mulya Jaya',
  },
  {
    id: '1807040001',
    districtId: '1807040',
    name: 'Rambang Jaya',
  },
  {
    id: '1807040002',
    districtId: '1807040',
    name: 'Gistang',
  },
  {
    id: '1807040003',
    districtId: '1807040',
    name: 'Negeri Batin',
  },
  {
    id: '1807040004',
    districtId: '1807040',
    name: 'Negeri Baru',
  },
  {
    id: '1807040005',
    districtId: '1807040',
    name: 'Bumi Ratu',
  },
  {
    id: '1807040006',
    districtId: '1807040',
    name: 'Sriwijaya',
  },
  {
    id: '1807040007',
    districtId: '1807040',
    name: 'Sidoarjo',
  },
  {
    id: '1807040008',
    districtId: '1807040',
    name: 'Brata Yuda',
  },
  {
    id: '1807040009',
    districtId: '1807040',
    name: 'Gedung Batin',
  },
  {
    id: '1807040025',
    districtId: '1807040',
    name: 'Sri Rejeki',
  },
  {
    id: '1807040026',
    districtId: '1807040',
    name: 'Blambangan Umpu',
  },
  {
    id: '1807040027',
    districtId: '1807040',
    name: 'Lembasung',
  },
  {
    id: '1807040028',
    districtId: '1807040',
    name: 'Umpu Bakti',
  },
  {
    id: '1807040029',
    districtId: '1807040',
    name: 'Umpu Kencana',
  },
  {
    id: '1807040030',
    districtId: '1807040',
    name: 'Karang Umpu',
  },
  {
    id: '1807040031',
    districtId: '1807040',
    name: 'Gunung Sangkaran',
  },
  {
    id: '1807040032',
    districtId: '1807040',
    name: 'Sangkaran Bhakti',
  },
  {
    id: '1807040033',
    districtId: '1807040',
    name: 'Bumi Baru',
  },
  {
    id: '1807040034',
    districtId: '1807040',
    name: 'Tanjung Sari',
  },
  {
    id: '1807040035',
    districtId: '1807040',
    name: 'Tanjung Raja Giham',
  },
  {
    id: '1807040046',
    districtId: '1807040',
    name: 'Segara Midar',
  },
  {
    id: '1807040047',
    districtId: '1807040',
    name: 'Tanjung Raja Sakti',
  },
  {
    id: '1807040048',
    districtId: '1807040',
    name: 'Negeri Bumi Putra',
  },
  {
    id: '1807040049',
    districtId: '1807040',
    name: 'Panca Negeri',
  },
  {
    id: '1807040050',
    districtId: '1807040',
    name: 'Gedung Riang',
  },
  {
    id: '1807040051',
    districtId: '1807040',
    name: 'Ojolali',
  },
  {
    id: '1807041001',
    districtId: '1807041',
    name: 'Bukit Gemuruh',
  },
  {
    id: '1807041002',
    districtId: '1807041',
    name: 'Bumi Dana',
  },
  {
    id: '1807041003',
    districtId: '1807041',
    name: 'Way Mencar',
  },
  {
    id: '1807041004',
    districtId: '1807041',
    name: 'Bandar Sari',
  },
  {
    id: '1807041005',
    districtId: '1807041',
    name: 'Suma Mukti',
  },
  {
    id: '1807041006',
    districtId: '1807041',
    name: 'Ramsai',
  },
  {
    id: '1807041007',
    districtId: '1807041',
    name: 'Way Tuba',
  },
  {
    id: '1807041008',
    districtId: '1807041',
    name: 'Karya Jaya',
  },
  {
    id: '1807041009',
    districtId: '1807041',
    name: 'Say Umpu',
  },
  {
    id: '1807041010',
    districtId: '1807041',
    name: 'Beringin Jaya',
  },
  {
    id: '1807041011',
    districtId: '1807041',
    name: 'Bukit Harapan',
  },
  {
    id: '1807041012',
    districtId: '1807041',
    name: 'Way Pisang',
  },
  {
    id: '1807041013',
    districtId: '1807041',
    name: 'Way Tuba Asri',
  },
  {
    id: '1807042001',
    districtId: '1807042',
    name: 'Gedung Jaya',
  },
  {
    id: '1807042002',
    districtId: '1807042',
    name: 'Way Limau',
  },
  {
    id: '1807042003',
    districtId: '1807042',
    name: 'Kali Papan',
  },
  {
    id: '1807042004',
    districtId: '1807042',
    name: 'Bandar Dalam',
  },
  {
    id: '1807042005',
    districtId: '1807042',
    name: 'Negeri Agung',
  },
  {
    id: '1807042006',
    districtId: '1807042',
    name: 'Pulau Batu',
  },
  {
    id: '1807042007',
    districtId: '1807042',
    name: 'Karya Agung',
  },
  {
    id: '1807042008',
    districtId: '1807042',
    name: 'Penengahan',
  },
  {
    id: '1807042009',
    districtId: '1807042',
    name: 'Mulya Sari',
  },
  {
    id: '1807042010',
    districtId: '1807042',
    name: 'Tanjung Rejo',
  },
  {
    id: '1807042011',
    districtId: '1807042',
    name: 'Sungsang',
  },
  {
    id: '1807042012',
    districtId: '1807042',
    name: 'Kota Baru',
  },
  {
    id: '1807042013',
    districtId: '1807042',
    name: 'Kotabumi Way Kanan',
  },
  {
    id: '1807042014',
    districtId: '1807042',
    name: 'Gedung Menang',
  },
  {
    id: '1807042015',
    districtId: '1807042',
    name: 'Gedung Harapan',
  },
  {
    id: '1807042016',
    districtId: '1807042',
    name: 'Rejo Sari',
  },
  {
    id: '1807042017',
    districtId: '1807042',
    name: 'Bandar Kasih',
  },
  {
    id: '1807042018',
    districtId: '1807042',
    name: 'Sumber Rejeki',
  },
  {
    id: '1807042019',
    districtId: '1807042',
    name: 'Mulya Agung',
  },
  {
    id: '1807050002',
    districtId: '1807050',
    name: 'Giri Harjo',
  },
  {
    id: '1807050003',
    districtId: '1807050',
    name: 'Tulang Bawang',
  },
  {
    id: '1807050004',
    districtId: '1807050',
    name: 'Mesir Udik',
  },
  {
    id: '1807050005',
    districtId: '1807050',
    name: 'Mesir Ilir',
  },
  {
    id: '1807050020',
    districtId: '1807050',
    name: 'Bumi Agung Watas',
  },
  {
    id: '1807050021',
    districtId: '1807050',
    name: 'Serdang Kuring',
  },
  {
    id: '1807050022',
    districtId: '1807050',
    name: 'Sapto Renggo',
  },
  {
    id: '1807050023',
    districtId: '1807050',
    name: 'Bumi Agung',
  },
  {
    id: '1807050024',
    districtId: '1807050',
    name: 'Mekar Jaya',
  },
  {
    id: '1807050025',
    districtId: '1807050',
    name: 'Kota Dewa',
  },
  {
    id: '1807050026',
    districtId: '1807050',
    name: 'Dewa Agung',
  },
  {
    id: '1807051001',
    districtId: '1807051',
    name: 'Punjul Agung',
  },
  {
    id: '1807051002',
    districtId: '1807051',
    name: 'Suka Agung',
  },
  {
    id: '1807051003',
    districtId: '1807051',
    name: 'Suka Dana',
  },
  {
    id: '1807051004',
    districtId: '1807051',
    name: 'Sukabumi',
  },
  {
    id: '1807051005',
    districtId: '1807051',
    name: 'Bumi Harjo',
  },
  {
    id: '1807051006',
    districtId: '1807051',
    name: 'Sri Tunggal',
  },
  {
    id: '1807051007',
    districtId: '1807051',
    name: 'Nuar Maju',
  },
  {
    id: '1807051008',
    districtId: '1807051',
    name: 'Lebung Lawe',
  },
  {
    id: '1807051009',
    districtId: '1807051',
    name: 'Way Agung',
  },
  {
    id: '1807052001',
    districtId: '1807052',
    name: 'Tanjung Dalom',
  },
  {
    id: '1807052002',
    districtId: '1807052',
    name: 'Karangan',
  },
  {
    id: '1807052003',
    districtId: '1807052',
    name: 'Bumi Agung',
  },
  {
    id: '1807052004',
    districtId: '1807052',
    name: 'Mulyo Harjo',
  },
  {
    id: '1807052005',
    districtId: '1807052',
    name: 'Wonoharjo',
  },
  {
    id: '1807052006',
    districtId: '1807052',
    name: 'Pisang Baru',
  },
  {
    id: '1807052007',
    districtId: '1807052',
    name: 'Srinumpi',
  },
  {
    id: '1807052008',
    districtId: '1807052',
    name: 'Pisang Indah',
  },
  {
    id: '1807052009',
    districtId: '1807052',
    name: 'Suka Maju',
  },
  {
    id: '1807052010',
    districtId: '1807052',
    name: 'Bumi Say Agung',
  },
  {
    id: '1807060002',
    districtId: '1807060',
    name: 'Bhakti Negara',
  },
  {
    id: '1807060003',
    districtId: '1807060',
    name: 'Tanjung Serupa',
  },
  {
    id: '1807060004',
    districtId: '1807060',
    name: 'Sukabumi',
  },
  {
    id: '1807060005',
    districtId: '1807060',
    name: 'Tanjung Agung',
  },
  {
    id: '1807060006',
    districtId: '1807060',
    name: 'Serupa Indah',
  },
  {
    id: '1807060007',
    districtId: '1807060',
    name: 'Pakuan Baru',
  },
  {
    id: '1807060008',
    districtId: '1807060',
    name: 'Tanjung Ratu',
  },
  {
    id: '1807060009',
    districtId: '1807060',
    name: 'Way Tawar',
  },
  {
    id: '1807060010',
    districtId: '1807060',
    name: 'Pakuan Sakti',
  },
  {
    id: '1807060011',
    districtId: '1807060',
    name: 'Negara Harja',
  },
  {
    id: '1807060012',
    districtId: '1807060',
    name: 'Negara Tama',
  },
  {
    id: '1807060032',
    districtId: '1807060',
    name: 'Bumi Mulya',
  },
  {
    id: '1807060035',
    districtId: '1807060',
    name: 'Negara Sakti',
  },
  {
    id: '1807060036',
    districtId: '1807060',
    name: 'Negara Ratu',
  },
  {
    id: '1807060037',
    districtId: '1807060',
    name: 'Rumbih',
  },
  {
    id: '1807060038',
    districtId: '1807060',
    name: 'Gunung Waras',
  },
  {
    id: '1807060039',
    districtId: '1807060',
    name: 'Gunung Cahya',
  },
  {
    id: '1807060040',
    districtId: '1807060',
    name: 'Pakuan Ratu',
  },
  {
    id: '1807060041',
    districtId: '1807060',
    name: 'Karang Agung',
  },
  {
    id: '1807061001',
    districtId: '1807061',
    name: 'Setia Negara',
  },
  {
    id: '1807061002',
    districtId: '1807061',
    name: 'Purwa Agung',
  },
  {
    id: '1807061003',
    districtId: '1807061',
    name: 'Sri Mulyo',
  },
  {
    id: '1807061004',
    districtId: '1807061',
    name: 'Sri Menanti',
  },
  {
    id: '1807061005',
    districtId: '1807061',
    name: 'Negara Batin',
  },
  {
    id: '1807061006',
    districtId: '1807061',
    name: 'Purwa Negara',
  },
  {
    id: '1807061007',
    districtId: '1807061',
    name: 'Marga Jaya',
  },
  {
    id: '1807061008',
    districtId: '1807061',
    name: 'Karta Jaya',
  },
  {
    id: '1807061009',
    districtId: '1807061',
    name: 'Gedong Jaya',
  },
  {
    id: '1807061010',
    districtId: '1807061',
    name: 'Adi Jaya',
  },
  {
    id: '1807061011',
    districtId: '1807061',
    name: 'Sari Jaya',
  },
  {
    id: '1807061012',
    districtId: '1807061',
    name: 'Gisting Jaya',
  },
  {
    id: '1807061013',
    districtId: '1807061',
    name: 'Bumi Jaya',
  },
  {
    id: '1807061014',
    districtId: '1807061',
    name: 'Negara Mulya',
  },
  {
    id: '1807061015',
    districtId: '1807061',
    name: 'Kota Jawa',
  },
  {
    id: '1807062001',
    districtId: '1807062',
    name: 'Sri Basuki',
  },
  {
    id: '1807062002',
    districtId: '1807062',
    name: 'Negara Jaya',
  },
  {
    id: '1807062003',
    districtId: '1807062',
    name: 'Bima Sakti',
  },
  {
    id: '1807062004',
    districtId: '1807062',
    name: 'Tegal Mukti',
  },
  {
    id: '1807062005',
    districtId: '1807062',
    name: 'Pagar Iman',
  },
  {
    id: '1807062006',
    districtId: '1807062',
    name: 'Kaliawi',
  },
  {
    id: '1807062007',
    districtId: '1807062',
    name: 'Negeri Besar',
  },
  {
    id: '1807062008',
    districtId: '1807062',
    name: 'Tiuh Baru',
  },
  {
    id: '1807062009',
    districtId: '1807062',
    name: 'Kiling Kiling',
  },
  {
    id: '1807062010',
    districtId: '1807062',
    name: 'Kaliawi Indah',
  },
  {
    id: '1807062011',
    districtId: '1807062',
    name: 'Negeri Jaya',
  },
  {
    id: '1807062012',
    districtId: '1807062',
    name: 'Tanjung Mas',
  },
  {
    id: '1807062013',
    districtId: '1807062',
    name: 'Negeri Kasih',
  },
  {
    id: '1808030007',
    districtId: '1808030',
    name: 'Banjar Agung',
  },
  {
    id: '1808030008',
    districtId: '1808030',
    name: 'Tunggal Warga',
  },
  {
    id: '1808030009',
    districtId: '1808030',
    name: 'Dwi Warga Tunggal Jaya',
  },
  {
    id: '1808030010',
    districtId: '1808030',
    name: 'Moris Jaya',
  },
  {
    id: '1808030011',
    districtId: '1808030',
    name: 'Tri Dharma Wirajaya',
  },
  {
    id: '1808030012',
    districtId: '1808030',
    name: 'Tri Mulya Jaya',
  },
  {
    id: '1808030013',
    districtId: '1808030',
    name: 'Tri Mukti Jaya',
  },
  {
    id: '1808030014',
    districtId: '1808030',
    name: 'Tri Tunggal Jaya',
  },
  {
    id: '1808030015',
    districtId: '1808030',
    name: 'Warga Makmur Jaya',
  },
  {
    id: '1808030016',
    districtId: '1808030',
    name: 'Warga Indah Jaya',
  },
  {
    id: '1808030017',
    districtId: '1808030',
    name: 'Banjar Dewa',
  },
  {
    id: '1808031001',
    districtId: '1808031',
    name: 'Ringin Sari',
  },
  {
    id: '1808031002',
    districtId: '1808031',
    name: 'Catur Karya Buana Jaya',
  },
  {
    id: '1808031003',
    districtId: '1808031',
    name: 'Bujuk Agung',
  },
  {
    id: '1808031004',
    districtId: '1808031',
    name: 'Sukamaju',
  },
  {
    id: '1808031005',
    districtId: '1808031',
    name: 'Penawar Jaya',
  },
  {
    id: '1808031006',
    districtId: '1808031',
    name: 'Purwa Jaya',
  },
  {
    id: '1808031007',
    districtId: '1808031',
    name: 'Agung Dalem',
  },
  {
    id: '1808031008',
    districtId: '1808031',
    name: 'Sumber Makmur',
  },
  {
    id: '1808031009',
    districtId: '1808031',
    name: 'Tri Tunggal Jaya',
  },
  {
    id: '1808031010',
    districtId: '1808031',
    name: 'Agung Jaya',
  },
  {
    id: '1808031011',
    districtId: '1808031',
    name: 'Penawar Rejo',
  },
  {
    id: '1808031012',
    districtId: '1808031',
    name: 'Mekar Jaya',
  },
  {
    id: '1808032001',
    districtId: '1808032',
    name: 'Jaya Makmur',
  },
  {
    id: '1808032002',
    districtId: '1808032',
    name: 'Kahuripan Jaya',
  },
  {
    id: '1808032003',
    districtId: '1808032',
    name: 'Bawang Sakti Jaya',
  },
  {
    id: '1808032004',
    districtId: '1808032',
    name: 'Bawang Tirto Mulyo',
  },
  {
    id: '1808032005',
    districtId: '1808032',
    name: 'Mekar Indah Jaya',
  },
  {
    id: '1808032006',
    districtId: '1808032',
    name: 'Mekar Jaya',
  },
  {
    id: '1808032007',
    districtId: '1808032',
    name: 'Balai Murni Jaya',
  },
  {
    id: '1808032008',
    districtId: '1808032',
    name: 'Karya Murni Jaya',
  },
  {
    id: '1808032009',
    districtId: '1808032',
    name: 'Panca Karsa Purna Jaya',
  },
  {
    id: '1808032010',
    districtId: '1808032',
    name: 'Panca Mulia',
  },
  {
    id: '1808040001',
    districtId: '1808040',
    name: 'Penawar Baru',
  },
  {
    id: '1808040002',
    districtId: '1808040',
    name: 'Gedung Aji',
  },
  {
    id: '1808040003',
    districtId: '1808040',
    name: 'Penawar',
  },
  {
    id: '1808040004',
    districtId: '1808040',
    name: 'Aji Jaya Knpi',
  },
  {
    id: '1808040005',
    districtId: '1808040',
    name: 'Kecubung Jaya',
  },
  {
    id: '1808040014',
    districtId: '1808040',
    name: 'Kecubung Mulya',
  },
  {
    id: '1808040015',
    districtId: '1808040',
    name: 'Aji Murni Jaya',
  },
  {
    id: '1808040016',
    districtId: '1808040',
    name: 'Aji Mesir',
  },
  {
    id: '1808040017',
    districtId: '1808040',
    name: 'Aji Permai Talang Buah',
  },
  {
    id: '1808040018',
    districtId: '1808040',
    name: 'Bandar Aji Jaya',
  },
  {
    id: '1808041001',
    districtId: '1808041',
    name: 'Sumber Sari',
  },
  {
    id: '1808041002',
    districtId: '1808041',
    name: 'Karya Makmur',
  },
  {
    id: '1808041003',
    districtId: '1808041',
    name: 'Panca Tunggal Jaya',
  },
  {
    id: '1808041004',
    districtId: '1808041',
    name: 'Gedung Harapan',
  },
  {
    id: '1808041005',
    districtId: '1808041',
    name: 'Gedung Rejo Sakti',
  },
  {
    id: '1808041006',
    districtId: '1808041',
    name: 'Wono Rejo',
  },
  {
    id: '1808041007',
    districtId: '1808041',
    name: 'Gedung Asri',
  },
  {
    id: '1808041008',
    districtId: '1808041',
    name: 'Pasar Batang',
  },
  {
    id: '1808041009',
    districtId: '1808041',
    name: 'Suka Makmur',
  },
  {
    id: '1808042001',
    districtId: '1808042',
    name: 'Paduan Rajawali',
  },
  {
    id: '1808042002',
    districtId: '1808042',
    name: 'Bangun Rejo',
  },
  {
    id: '1808042003',
    districtId: '1808042',
    name: 'Sukarame',
  },
  {
    id: '1808042004',
    districtId: '1808042',
    name: 'Bina Bumi',
  },
  {
    id: '1808042005',
    districtId: '1808042',
    name: 'Karya Bhakti',
  },
  {
    id: '1808042006',
    districtId: '1808042',
    name: 'Kecubung Raya',
  },
  {
    id: '1808042007',
    districtId: '1808042',
    name: 'Marga Jaya',
  },
  {
    id: '1808042008',
    districtId: '1808042',
    name: 'Mulyo Aji',
  },
  {
    id: '1808050001',
    districtId: '1808050',
    name: 'Bujung Tenuk',
  },
  {
    id: '1808050002',
    districtId: '1808050',
    name: 'Astra Ksetra',
  },
  {
    id: '1808050005',
    districtId: '1808050',
    name: 'Ujung Gunung Ilir',
  },
  {
    id: '1808050012',
    districtId: '1808050',
    name: 'Menggala Selatan',
  },
  {
    id: '1808050013',
    districtId: '1808050',
    name: 'Ujung Gunung',
  },
  {
    id: '1808050014',
    districtId: '1808050',
    name: 'Menggala Tengah',
  },
  {
    id: '1808050015',
    districtId: '1808050',
    name: 'Menggala Kota',
  },
  {
    id: '1808050016',
    districtId: '1808050',
    name: 'Kagungan Rahayu',
  },
  {
    id: '1808050017',
    districtId: '1808050',
    name: 'Tiuh Tohou',
  },
  {
    id: '1808051011',
    districtId: '1808051',
    name: 'Boga Tama',
  },
  {
    id: '1808051012',
    districtId: '1808051',
    name: 'Tri Rejo Mulyo',
  },
  {
    id: '1808051013',
    districtId: '1808051',
    name: 'Sidoharjo',
  },
  {
    id: '1808051014',
    districtId: '1808051',
    name: 'Sidomulyo',
  },
  {
    id: '1808051015',
    districtId: '1808051',
    name: 'Tri Jaya',
  },
  {
    id: '1808051016',
    districtId: '1808051',
    name: 'Tri Tunggal Jaya',
  },
  {
    id: '1808051017',
    districtId: '1808051',
    name: 'Wiratama',
  },
  {
    id: '1808051018',
    districtId: '1808051',
    name: 'Pulo Gadung',
  },
  {
    id: '1808051019',
    districtId: '1808051',
    name: 'Sidodadi',
  },
  {
    id: '1808051020',
    districtId: '1808051',
    name: 'Dwimulyo',
  },
  {
    id: '1808051021',
    districtId: '1808051',
    name: 'Rejo Sari',
  },
  {
    id: '1808051022',
    districtId: '1808051',
    name: 'Wira Agung Sari',
  },
  {
    id: '1808051023',
    districtId: '1808051',
    name: 'Sidomakmur',
  },
  {
    id: '1808051024',
    districtId: '1808051',
    name: 'Trikarya',
  },
  {
    id: '1808052003',
    districtId: '1808052',
    name: 'Bumi Ratu',
  },
  {
    id: '1808052004',
    districtId: '1808052',
    name: 'Hargo Rejo',
  },
  {
    id: '1808052005',
    districtId: '1808052',
    name: 'Yudha Karya Jitu',
  },
  {
    id: '1808052010',
    districtId: '1808052',
    name: 'Karya Jitu Mukti',
  },
  {
    id: '1808052011',
    districtId: '1808052',
    name: 'Hargo Mulyo',
  },
  {
    id: '1808052012',
    districtId: '1808052',
    name: 'Wono Agung',
  },
  {
    id: '1808052013',
    districtId: '1808052',
    name: 'Medasari',
  },
  {
    id: '1808052014',
    districtId: '1808052',
    name: 'Gedung Karya Jitu',
  },
  {
    id: '1808052015',
    districtId: '1808052',
    name: 'Karya Cipta Abadi',
  },
  {
    id: '1808053001',
    districtId: '1808053',
    name: 'Bakung Udik',
  },
  {
    id: '1808053002',
    districtId: '1808053',
    name: 'Bakung Ilir',
  },
  {
    id: '1808053003',
    districtId: '1808053',
    name: 'Gunung Tapa',
  },
  {
    id: '1808053004',
    districtId: '1808053',
    name: 'Gedung Meneng',
  },
  {
    id: '1808053008',
    districtId: '1808053',
    name: 'Gedung Bandar Rahayu',
  },
  {
    id: '1808053009',
    districtId: '1808053',
    name: 'Gunung Tapa Ilir',
  },
  {
    id: '1808053010',
    districtId: '1808053',
    name: 'Gunung Tapa Tengah',
  },
  {
    id: '1808053011',
    districtId: '1808053',
    name: 'Gunung Tapa Udik',
  },
  {
    id: '1808053012',
    districtId: '1808053',
    name: 'Gedung Bandar Rejo',
  },
  {
    id: '1808053013',
    districtId: '1808053',
    name: 'Bakung Rahayu',
  },
  {
    id: '1808053014',
    districtId: '1808053',
    name: 'Gedung Meneng Baru',
  },
  {
    id: '1808054001',
    districtId: '1808054',
    name: 'Bumi Dipasena Sentosa',
  },
  {
    id: '1808054002',
    districtId: '1808054',
    name: 'Bumi Dipasena Utama',
  },
  {
    id: '1808054003',
    districtId: '1808054',
    name: 'Bumi Dipasena Agung',
  },
  {
    id: '1808054004',
    districtId: '1808054',
    name: 'Bumi Dipasena Jaya',
  },
  {
    id: '1808054005',
    districtId: '1808054',
    name: 'Bumi Dipasena Mulya',
  },
  {
    id: '1808054006',
    districtId: '1808054',
    name: 'Bumi Dipasena Makmur',
  },
  {
    id: '1808054007',
    districtId: '1808054',
    name: 'Bumi Dipasena Sejahtera',
  },
  {
    id: '1808054008',
    districtId: '1808054',
    name: 'Bumi Dipasena Abadi',
  },
  {
    id: '1808055001',
    districtId: '1808055',
    name: 'Rawa Ragil',
  },
  {
    id: '1808055002',
    districtId: '1808055',
    name: 'Gedung Jaya',
  },
  {
    id: '1808055003',
    districtId: '1808055',
    name: 'Duto Yoso Mulyo',
  },
  {
    id: '1808055004',
    districtId: '1808055',
    name: 'Andalas Cermin',
  },
  {
    id: '1808055005',
    districtId: '1808055',
    name: 'Panggung Mulyo',
  },
  {
    id: '1808055006',
    districtId: '1808055',
    name: 'Batang Hari',
  },
  {
    id: '1808055007',
    districtId: '1808055',
    name: 'Sumber Agung',
  },
  {
    id: '1808055008',
    districtId: '1808055',
    name: 'Bumi Sari',
  },
  {
    id: '1808055009',
    districtId: '1808055',
    name: 'Mulyo Dadi',
  },
  {
    id: '1808056001',
    districtId: '1808056',
    name: 'Batu Ampar',
  },
  {
    id: '1808056002',
    districtId: '1808056',
    name: 'Suka Bhakti',
  },
  {
    id: '1808056003',
    districtId: '1808056',
    name: 'Sido Mukti',
  },
  {
    id: '1808056004',
    districtId: '1808056',
    name: 'Makarti Tama',
  },
  {
    id: '1808056005',
    districtId: '1808056',
    name: 'Setia Tama',
  },
  {
    id: '1808056006',
    districtId: '1808056',
    name: 'Mesir Dwi Jaya',
  },
  {
    id: '1808056007',
    districtId: '1808056',
    name: 'Sumber Jaya',
  },
  {
    id: '1808056008',
    districtId: '1808056',
    name: 'Mekar Asri',
  },
  {
    id: '1808056009',
    districtId: '1808056',
    name: 'Sidomekar',
  },
  {
    id: '1808057001',
    districtId: '1808057',
    name: 'Pasiran Jaya',
  },
  {
    id: '1808057002',
    districtId: '1808057',
    name: 'Bratasena Mandiri',
  },
  {
    id: '1808057003',
    districtId: '1808057',
    name: 'Bratasena Adiwarna',
  },
  {
    id: '1808057004',
    districtId: '1808057',
    name: 'Sungai Nibung',
  },
  {
    id: '1808057005',
    districtId: '1808057',
    name: 'Mahabang',
  },
  {
    id: '1808057006',
    districtId: '1808057',
    name: 'Kuala Teladas',
  },
  {
    id: '1808057007',
    districtId: '1808057',
    name: 'Kekatung',
  },
  {
    id: '1808057008',
    districtId: '1808057',
    name: 'Teladas',
  },
  {
    id: '1808057009',
    districtId: '1808057',
    name: 'Way Dente',
  },
  {
    id: '1808057010',
    districtId: '1808057',
    name: 'Dente Makmur',
  },
  {
    id: '1808057011',
    districtId: '1808057',
    name: 'Pendowo Asri',
  },
  {
    id: '1808057012',
    districtId: '1808057',
    name: 'Sungai Burung',
  },
  {
    id: '1808058001',
    districtId: '1808058',
    name: 'Menggala',
  },
  {
    id: '1808058002',
    districtId: '1808058',
    name: 'Sungai Luar',
  },
  {
    id: '1808058003',
    districtId: '1808058',
    name: 'Bedarou Indah',
  },
  {
    id: '1808058004',
    districtId: '1808058',
    name: 'Kibang',
  },
  {
    id: '1808058005',
    districtId: '1808058',
    name: 'Cempaka Jaya',
  },
  {
    id: '1808058006',
    districtId: '1808058',
    name: 'Tri Makmur Jaya',
  },
  {
    id: '1808058007',
    districtId: '1808058',
    name: 'Kahuripan Dalam',
  },
  {
    id: '1808058008',
    districtId: '1808058',
    name: 'Lebuh Dalem',
  },
  {
    id: '1808058009',
    districtId: '1808058',
    name: 'Cempaka Dalam',
  },
  {
    id: '1808058010',
    districtId: '1808058',
    name: 'Lingai',
  },
  {
    id: '1809010001',
    districtId: '1809010',
    name: 'Sukamaju',
  },
  {
    id: '1809010002',
    districtId: '1809010',
    name: 'Bawang',
  },
  {
    id: '1809010003',
    districtId: '1809010',
    name: 'Pagar Jaya',
  },
  {
    id: '1809010004',
    districtId: '1809010',
    name: 'Pulau Legundi',
  },
  {
    id: '1809010005',
    districtId: '1809010',
    name: 'Sukarame',
  },
  {
    id: '1809010006',
    districtId: '1809010',
    name: 'Kota Jawa',
  },
  {
    id: '1809010007',
    districtId: '1809010',
    name: 'Rusaba',
  },
  {
    id: '1809010008',
    districtId: '1809010',
    name: 'Sukajaya Pidada',
  },
  {
    id: '1809010009',
    districtId: '1809010',
    name: 'Batu Raja',
  },
  {
    id: '1809010010',
    districtId: '1809010',
    name: 'Banding Agung',
  },
  {
    id: '1809010021',
    districtId: '1809010',
    name: 'Bangun Rejo',
  },
  {
    id: '1809011001',
    districtId: '1809011',
    name: 'Kampungbaru',
  },
  {
    id: '1809011002',
    districtId: '1809011',
    name: 'Kekatang',
  },
  {
    id: '1809011003',
    districtId: '1809011',
    name: 'Pekon Ampai',
  },
  {
    id: '1809011004',
    districtId: '1809011',
    name: 'Kunyaian',
  },
  {
    id: '1809011005',
    districtId: '1809011',
    name: 'Umbul Limus',
  },
  {
    id: '1809011006',
    districtId: '1809011',
    name: 'Tajur',
  },
  {
    id: '1809011007',
    districtId: '1809011',
    name: 'Penyandingan',
  },
  {
    id: '1809011008',
    districtId: '1809011',
    name: 'Maja',
  },
  {
    id: '1809011009',
    districtId: '1809011',
    name: 'Suka Jaya Punduh',
  },
  {
    id: '1809011010',
    districtId: '1809011',
    name: 'Pulau Pahawang',
  },
  {
    id: '1809020021',
    districtId: '1809020',
    name: 'Sanggi',
  },
  {
    id: '1809020022',
    districtId: '1809020',
    name: 'Durian',
  },
  {
    id: '1809020023',
    districtId: '1809020',
    name: 'Banjaran',
  },
  {
    id: '1809020030',
    districtId: '1809020',
    name: 'Way Urang',
  },
  {
    id: '1809020031',
    districtId: '1809020',
    name: 'Paya',
  },
  {
    id: '1809020032',
    districtId: '1809020',
    name: 'Tambangan',
  },
  {
    id: '1809020033',
    districtId: '1809020',
    name: 'Hanau Berak',
  },
  {
    id: '1809020034',
    districtId: '1809020',
    name: 'Padang Cermin',
  },
  {
    id: '1809020042',
    districtId: '1809020',
    name: 'Gayau',
  },
  {
    id: '1809020043',
    districtId: '1809020',
    name: 'Trimulyo',
  },
  {
    id: '1809020047',
    districtId: '1809020',
    name: 'Khepong Jaya',
  },
  {
    id: '1809021001',
    districtId: '1809021',
    name: 'Batu Menyan',
  },
  {
    id: '1809021002',
    districtId: '1809021',
    name: 'Gebang',
  },
  {
    id: '1809021003',
    districtId: '1809021',
    name: 'Sidodadi',
  },
  {
    id: '1809021004',
    districtId: '1809021',
    name: 'Hanura',
  },
  {
    id: '1809021005',
    districtId: '1809021',
    name: 'Cilimus',
  },
  {
    id: '1809021006',
    districtId: '1809021',
    name: 'Hurun',
  },
  {
    id: '1809021007',
    districtId: '1809021',
    name: 'Sukajaya Lempasing',
  },
  {
    id: '1809021008',
    districtId: '1809021',
    name: 'Munca',
  },
  {
    id: '1809021009',
    districtId: '1809021',
    name: 'Tanjung Agung',
  },
  {
    id: '1809021010',
    districtId: '1809021',
    name: 'Talang Mulyo',
  },
  {
    id: '1809022001',
    districtId: '1809022',
    name: 'Sumber Jaya',
  },
  {
    id: '1809022002',
    districtId: '1809022',
    name: 'Bunut Seberang',
  },
  {
    id: '1809022003',
    districtId: '1809022',
    name: 'Ceringin Asri',
  },
  {
    id: '1809022004',
    districtId: '1809022',
    name: 'Poncorejo',
  },
  {
    id: '1809022005',
    districtId: '1809022',
    name: 'Gunung Rejo',
  },
  {
    id: '1809022006',
    districtId: '1809022',
    name: 'Mulyosari',
  },
  {
    id: '1809022007',
    districtId: '1809022',
    name: 'Wates Way Ratai',
  },
  {
    id: '1809022008',
    districtId: '1809022',
    name: 'Bunut',
  },
  {
    id: '1809022009',
    districtId: '1809022',
    name: 'Pesawaran Indah',
  },
  {
    id: '1809022010',
    districtId: '1809022',
    name: 'Harapan Jaya',
  },
  {
    id: '1809030010',
    districtId: '1809030',
    name: 'Sukamaju',
  },
  {
    id: '1809030011',
    districtId: '1809030',
    name: 'Waykepayang',
  },
  {
    id: '1809030012',
    districtId: '1809030',
    name: 'Kedondong',
  },
  {
    id: '1809030013',
    districtId: '1809030',
    name: 'Sinar Harapan',
  },
  {
    id: '1809030014',
    districtId: '1809030',
    name: 'Tempel Rejo',
  },
  {
    id: '1809030015',
    districtId: '1809030',
    name: 'Pasar Baru',
  },
  {
    id: '1809030016',
    districtId: '1809030',
    name: 'Kerta Sana',
  },
  {
    id: '1809030017',
    districtId: '1809030',
    name: 'Gunung Sugih',
  },
  {
    id: '1809030032',
    districtId: '1809030',
    name: 'Babakan Loa',
  },
  {
    id: '1809030033',
    districtId: '1809030',
    name: 'Pesawaran',
  },
  {
    id: '1809030034',
    districtId: '1809030',
    name: 'Tebajawa',
  },
  {
    id: '1809030035',
    districtId: '1809030',
    name: 'Harapan Jaya',
  },
  {
    id: '1809031001',
    districtId: '1809031',
    name: 'Bayas Jaya',
  },
  {
    id: '1809031002',
    districtId: '1809031',
    name: 'Padang Cermin',
  },
  {
    id: '1809031003',
    districtId: '1809031',
    name: 'Sukajaya',
  },
  {
    id: '1809031004',
    districtId: '1809031',
    name: 'Penengahan',
  },
  {
    id: '1809031005',
    districtId: '1809031',
    name: 'Tanjung Kerta',
  },
  {
    id: '1809031006',
    districtId: '1809031',
    name: 'Kotajawa',
  },
  {
    id: '1809031007',
    districtId: '1809031',
    name: 'Mada Jaya',
  },
  {
    id: '1809031008',
    districtId: '1809031',
    name: 'Gunungsari',
  },
  {
    id: '1809031009',
    districtId: '1809031',
    name: 'Kubu Batu',
  },
  {
    id: '1809031010',
    districtId: '1809031',
    name: 'Tanjung Rejo',
  },
  {
    id: '1809040001',
    districtId: '1809040',
    name: 'Gunungrejo',
  },
  {
    id: '1809040002',
    districtId: '1809040',
    name: 'Cimanuk',
  },
  {
    id: '1809040003',
    districtId: '1809040',
    name: 'Sukamandi',
  },
  {
    id: '1809040004',
    districtId: '1809040',
    name: 'Way Harong',
  },
  {
    id: '1809040005',
    districtId: '1809040',
    name: 'Margodadi',
  },
  {
    id: '1809040006',
    districtId: '1809040',
    name: 'Tanjung Agung',
  },
  {
    id: '1809040007',
    districtId: '1809040',
    name: 'Kotadalam',
  },
  {
    id: '1809040008',
    districtId: '1809040',
    name: 'Baturaja',
  },
  {
    id: '1809040009',
    districtId: '1809040',
    name: 'Sindang Garut',
  },
  {
    id: '1809040010',
    districtId: '1809040',
    name: 'Sidodadi',
  },
  {
    id: '1809040011',
    districtId: '1809040',
    name: 'Gedung Dalam',
  },
  {
    id: '1809040012',
    districtId: '1809040',
    name: 'Pekondoh',
  },
  {
    id: '1809040013',
    districtId: '1809040',
    name: 'Pekondoh Gedung',
  },
  {
    id: '1809040014',
    districtId: '1809040',
    name: 'Banjar Negeri',
  },
  {
    id: '1809040015',
    districtId: '1809040',
    name: 'Padang Manis',
  },
  {
    id: '1809040016',
    districtId: '1809040',
    name: 'Paguyuban',
  },
  {
    id: '1809050001',
    districtId: '1809050',
    name: 'Padang Ratu',
  },
  {
    id: '1809050002',
    districtId: '1809050',
    name: 'Cipadang',
  },
  {
    id: '1809050003',
    districtId: '1809050',
    name: 'Pampangan',
  },
  {
    id: '1809050004',
    districtId: '1809050',
    name: 'Waylayap',
  },
  {
    id: '1809050005',
    districtId: '1809050',
    name: 'Sukadadi',
  },
  {
    id: '1809050006',
    districtId: '1809050',
    name: 'Bogorejo',
  },
  {
    id: '1809050007',
    districtId: '1809050',
    name: 'Sukaraja',
  },
  {
    id: '1809050008',
    districtId: '1809050',
    name: 'Gedung Tataan',
  },
  {
    id: '1809050009',
    districtId: '1809050',
    name: 'Kutoarjo',
  },
  {
    id: '1809050010',
    districtId: '1809050',
    name: 'Karang Anyar',
  },
  {
    id: '1809050011',
    districtId: '1809050',
    name: 'Bagelen',
  },
  {
    id: '1809050012',
    districtId: '1809050',
    name: 'Kebagusan',
  },
  {
    id: '1809050013',
    districtId: '1809050',
    name: 'Wiyono',
  },
  {
    id: '1809050014',
    districtId: '1809050',
    name: 'Tamansari',
  },
  {
    id: '1809050015',
    districtId: '1809050',
    name: 'Bernung',
  },
  {
    id: '1809050016',
    districtId: '1809050',
    name: 'Sungai Langka',
  },
  {
    id: '1809050017',
    districtId: '1809050',
    name: 'Negeri Sakti',
  },
  {
    id: '1809050018',
    districtId: '1809050',
    name: 'Kurungannyawa',
  },
  {
    id: '1809050019',
    districtId: '1809050',
    name: 'Sukabanjar',
  },
  {
    id: '1809060001',
    districtId: '1809060',
    name: 'Purworejo',
  },
  {
    id: '1809060002',
    districtId: '1809060',
    name: 'Kagunganratu',
  },
  {
    id: '1809060003',
    districtId: '1809060',
    name: 'Pujorahayu',
  },
  {
    id: '1809060004',
    districtId: '1809060',
    name: 'Kalirejo',
  },
  {
    id: '1809060005',
    districtId: '1809060',
    name: 'Tanjung Rejo',
  },
  {
    id: '1809060006',
    districtId: '1809060',
    name: 'Negerikatun',
  },
  {
    id: '1809060007',
    districtId: '1809060',
    name: 'Negarasaka',
  },
  {
    id: '1809060008',
    districtId: '1809060',
    name: 'Pejambon',
  },
  {
    id: '1809060009',
    districtId: '1809060',
    name: 'Halangan Ratu',
  },
  {
    id: '1809060010',
    districtId: '1809060',
    name: 'Trisno Maju',
  },
  {
    id: '1809060011',
    districtId: '1809060',
    name: 'Lumbi Rejo',
  },
  {
    id: '1809060012',
    districtId: '1809060',
    name: 'Roworejo',
  },
  {
    id: '1809060013',
    districtId: '1809060',
    name: 'Sidomulyo',
  },
  {
    id: '1809060014',
    districtId: '1809060',
    name: 'Poncokresno',
  },
  {
    id: '1809060015',
    districtId: '1809060',
    name: 'Tri Rahayu',
  },
  {
    id: '1809060016',
    districtId: '1809060',
    name: 'Sinarbandung',
  },
  {
    id: '1809060017',
    districtId: '1809060',
    name: 'Bangun Sari',
  },
  {
    id: '1809060018',
    districtId: '1809060',
    name: 'Karangrejo',
  },
  {
    id: '1809060019',
    districtId: '1809060',
    name: 'Negeri Ulangan Jaya',
  },
  {
    id: '1809070001',
    districtId: '1809070',
    name: 'Kresno Widodo',
  },
  {
    id: '1809070002',
    districtId: '1809070',
    name: 'Gedung Gumanti',
  },
  {
    id: '1809070003',
    districtId: '1809070',
    name: 'Kejadian',
  },
  {
    id: '1809070004',
    districtId: '1809070',
    name: 'Bumiagung',
  },
  {
    id: '1809070005',
    districtId: '1809070',
    name: 'Batang Hari Ogan',
  },
  {
    id: '1809070006',
    districtId: '1809070',
    name: 'Rejoagung',
  },
  {
    id: '1809070007',
    districtId: '1809070',
    name: 'Kota Agung',
  },
  {
    id: '1809070008',
    districtId: '1809070',
    name: 'Negara Ratuwates',
  },
  {
    id: '1809070009',
    districtId: '1809070',
    name: 'Gunung Sugih Baru',
  },
  {
    id: '1809070010',
    districtId: '1809070',
    name: 'Margo Mulyo',
  },
  {
    id: '1809070011',
    districtId: '1809070',
    name: 'Trimulyo',
  },
  {
    id: '1809070012',
    districtId: '1809070',
    name: 'Sinar Jati',
  },
  {
    id: '1809070013',
    districtId: '1809070',
    name: 'Margo Rejo',
  },
  {
    id: '1809070014',
    districtId: '1809070',
    name: 'Gerning',
  },
  {
    id: '1809070015',
    districtId: '1809070',
    name: 'Panca Bakti',
  },
  {
    id: '1809070016',
    districtId: '1809070',
    name: 'Sriwedari',
  },
  {
    id: '1810010004',
    districtId: '1810010',
    name: 'Selapan',
  },
  {
    id: '1810010005',
    districtId: '1810010',
    name: 'Kedaung',
  },
  {
    id: '1810010006',
    districtId: '1810010',
    name: 'Suka Negeri',
  },
  {
    id: '1810010007',
    districtId: '1810010',
    name: 'Rantau Tijang',
  },
  {
    id: '1810010008',
    districtId: '1810010',
    name: 'Pardasuka',
  },
  {
    id: '1810010009',
    districtId: '1810010',
    name: 'Tanjung Rusia',
  },
  {
    id: '1810010013',
    districtId: '1810010',
    name: 'Wargo Mulyo',
  },
  {
    id: '1810010014',
    districtId: '1810010',
    name: 'Pujodadi',
  },
  {
    id: '1810010015',
    districtId: '1810010',
    name: 'Sukorejo',
  },
  {
    id: '1810010018',
    districtId: '1810010',
    name: 'Sidodadi',
  },
  {
    id: '1810010019',
    districtId: '1810010',
    name: 'Pardasuka Timur',
  },
  {
    id: '1810010020',
    districtId: '1810010',
    name: 'Tanjung Rusia Timur',
  },
  {
    id: '1810010021',
    districtId: '1810010',
    name: 'Pardasuka Selatan',
  },
  {
    id: '1810020001',
    districtId: '1810020',
    name: 'Kresnomulyo',
  },
  {
    id: '1810020002',
    districtId: '1810020',
    name: 'Sumber Agung',
  },
  {
    id: '1810020003',
    districtId: '1810020',
    name: 'Ambarawa',
  },
  {
    id: '1810020004',
    districtId: '1810020',
    name: 'Ambarawa Barat',
  },
  {
    id: '1810020005',
    districtId: '1810020',
    name: 'Tanjung Anom',
  },
  {
    id: '1810020006',
    districtId: '1810020',
    name: 'Jati Agung',
  },
  {
    id: '1810020007',
    districtId: '1810020',
    name: 'Margodadi',
  },
  {
    id: '1810020008',
    districtId: '1810020',
    name: 'Ambarawa Timur',
  },
  {
    id: '1810030001',
    districtId: '1810030',
    name: 'Candi Retno',
  },
  {
    id: '1810030002',
    districtId: '1810030',
    name: 'Tanjung Dalam',
  },
  {
    id: '1810030003',
    districtId: '1810030',
    name: 'Way Ngisom',
  },
  {
    id: '1810030004',
    districtId: '1810030',
    name: 'Karangsari',
  },
  {
    id: '1810030005',
    districtId: '1810030',
    name: 'Gumuk Mas',
  },
  {
    id: '1810030006',
    districtId: '1810030',
    name: 'Patoman',
  },
  {
    id: '1810030007',
    districtId: '1810030',
    name: 'Pagelaran',
  },
  {
    id: '1810030008',
    districtId: '1810030',
    name: 'Sukaratu',
  },
  {
    id: '1810030009',
    districtId: '1810030',
    name: 'Sukawangi',
  },
  {
    id: '1810030010',
    districtId: '1810030',
    name: 'Lugusari',
  },
  {
    id: '1810030011',
    districtId: '1810030',
    name: 'Panutan',
  },
  {
    id: '1810030012',
    districtId: '1810030',
    name: 'Bumi Ratu',
  },
  {
    id: '1810030019',
    districtId: '1810030',
    name: 'Gemah Ripah',
  },
  {
    id: '1810030020',
    districtId: '1810030',
    name: 'Pamenang',
  },
  {
    id: '1810030023',
    districtId: '1810030',
    name: 'Pasir Ukir',
  },
  {
    id: '1810030024',
    districtId: '1810030',
    name: 'Gumuk Rejo',
  },
  {
    id: '1810030027',
    districtId: '1810030',
    name: 'Puji Harjo',
  },
  {
    id: '1810030028',
    districtId: '1810030',
    name: 'Padang Rejo',
  },
  {
    id: '1810030029',
    districtId: '1810030',
    name: 'Sidodadi',
  },
  {
    id: '1810030030',
    districtId: '1810030',
    name: 'Sumber Rejo',
  },
  {
    id: '1810030031',
    districtId: '1810030',
    name: 'Ganjaran',
  },
  {
    id: '1810030032',
    districtId: '1810030',
    name: 'Bumi Rejo',
  },
  {
    id: '1810031013',
    districtId: '1810031',
    name: 'Fajar Baru',
  },
  {
    id: '1810031014',
    districtId: '1810031',
    name: 'Kemilin',
  },
  {
    id: '1810031015',
    districtId: '1810031',
    name: 'Neglasari',
  },
  {
    id: '1810031016',
    districtId: '1810031',
    name: 'Sumber Bandung',
  },
  {
    id: '1810031017',
    districtId: '1810031',
    name: 'Giri Tunggal',
  },
  {
    id: '1810031018',
    districtId: '1810031',
    name: 'Margosari',
  },
  {
    id: '1810031021',
    districtId: '1810031',
    name: 'Fajar Mulia',
  },
  {
    id: '1810031022',
    districtId: '1810031',
    name: 'Madaraya',
  },
  {
    id: '1810031025',
    districtId: '1810031',
    name: 'Gunung Raya',
  },
  {
    id: '1810031026',
    districtId: '1810031',
    name: 'Way Kunir',
  },
  {
    id: '1810040007',
    districtId: '1810040',
    name: 'Margakaya',
  },
  {
    id: '1810040008',
    districtId: '1810040',
    name: 'Waluyojati',
  },
  {
    id: '1810040009',
    districtId: '1810040',
    name: 'Pajar Esuk',
  },
  {
    id: '1810040011',
    districtId: '1810040',
    name: 'Sidoharjo',
  },
  {
    id: '1810040012',
    districtId: '1810040',
    name: 'Podomoro',
  },
  {
    id: '1810040013',
    districtId: '1810040',
    name: 'Bumi Arum',
  },
  {
    id: '1810040015',
    districtId: '1810040',
    name: 'Pajar Agung',
  },
  {
    id: '1810040016',
    districtId: '1810040',
    name: 'Pringsewu Utara',
  },
  {
    id: '1810040017',
    districtId: '1810040',
    name: 'Pringsewu Selatan',
  },
  {
    id: '1810040018',
    districtId: '1810040',
    name: 'Pringsewu Barat',
  },
  {
    id: '1810040019',
    districtId: '1810040',
    name: 'Pringsewu Timur',
  },
  {
    id: '1810040020',
    districtId: '1810040',
    name: 'Rejosari',
  },
  {
    id: '1810040021',
    districtId: '1810040',
    name: 'Bumi Ayu',
  },
  {
    id: '1810040022',
    districtId: '1810040',
    name: 'Podosari',
  },
  {
    id: '1810040023',
    districtId: '1810040',
    name: 'Fajar Agung Barat',
  },
  {
    id: '1810050001',
    districtId: '1810050',
    name: 'Parerejo',
  },
  {
    id: '1810050002',
    districtId: '1810050',
    name: 'Blitarejo',
  },
  {
    id: '1810050003',
    districtId: '1810050',
    name: 'Panjerejo',
  },
  {
    id: '1810050004',
    districtId: '1810050',
    name: 'Bulukarto',
  },
  {
    id: '1810050005',
    districtId: '1810050',
    name: 'Wates',
  },
  {
    id: '1810050006',
    districtId: '1810050',
    name: 'Bulurejo',
  },
  {
    id: '1810050007',
    districtId: '1810050',
    name: 'Tambak Rejo',
  },
  {
    id: '1810050008',
    districtId: '1810050',
    name: 'Wonodadi',
  },
  {
    id: '1810050009',
    districtId: '1810050',
    name: 'Gading Rejo',
  },
  {
    id: '1810050010',
    districtId: '1810050',
    name: 'Tegalsari',
  },
  {
    id: '1810050011',
    districtId: '1810050',
    name: 'Tulung Agung',
  },
  {
    id: '1810050012',
    districtId: '1810050',
    name: 'Jogyakarta',
  },
  {
    id: '1810050013',
    districtId: '1810050',
    name: 'Kediri',
  },
  {
    id: '1810050014',
    districtId: '1810050',
    name: 'Mataram',
  },
  {
    id: '1810050015',
    districtId: '1810050',
    name: 'Wonosari',
  },
  {
    id: '1810050016',
    districtId: '1810050',
    name: 'Klaten',
  },
  {
    id: '1810050017',
    districtId: '1810050',
    name: 'Wates Timur',
  },
  {
    id: '1810050018',
    districtId: '1810050',
    name: 'Wates Selatan',
  },
  {
    id: '1810050019',
    districtId: '1810050',
    name: 'Gading Rejo Timur',
  },
  {
    id: '1810050020',
    districtId: '1810050',
    name: 'Gading Rejo Utara',
  },
  {
    id: '1810050021',
    districtId: '1810050',
    name: 'Tambah Rejo Barat',
  },
  {
    id: '1810050022',
    districtId: '1810050',
    name: 'Yogyakarta Selatan',
  },
  {
    id: '1810050023',
    districtId: '1810050',
    name: 'Wonodadi Utara',
  },
  {
    id: '1810060002',
    districtId: '1810060',
    name: 'Sinar Baru',
  },
  {
    id: '1810060003',
    districtId: '1810060',
    name: 'Sukoharjo I',
  },
  {
    id: '1810060004',
    districtId: '1810060',
    name: 'Sukoharjo II',
  },
  {
    id: '1810060005',
    districtId: '1810060',
    name: 'Sukoharjo IV',
  },
  {
    id: '1810060006',
    districtId: '1810060',
    name: 'Panggung Rejo',
  },
  {
    id: '1810060007',
    districtId: '1810060',
    name: 'Pandansari',
  },
  {
    id: '1810060008',
    districtId: '1810060',
    name: 'Pandan Surat',
  },
  {
    id: '1810060009',
    districtId: '1810060',
    name: 'Sukoharjo III',
  },
  {
    id: '1810060010',
    districtId: '1810060',
    name: 'Keputran',
  },
  {
    id: '1810060011',
    districtId: '1810060',
    name: 'Sukoyoso',
  },
  {
    id: '1810060012',
    districtId: '1810060',
    name: 'Siliwangi',
  },
  {
    id: '1810060022',
    districtId: '1810060',
    name: 'Waringinsari Barat',
  },
  {
    id: '1810060023',
    districtId: '1810060',
    name: 'Pandansari Selatan',
  },
  {
    id: '1810060024',
    districtId: '1810060',
    name: 'Sinar Baru Timur',
  },
  {
    id: '1810060025',
    districtId: '1810060',
    name: 'Panggung Rejo Utara',
  },
  {
    id: '1810060026',
    districtId: '1810060',
    name: 'Sukoharjo III Barat',
  },
  {
    id: '1810070001',
    districtId: '1810070',
    name: 'Waya Krui',
  },
  {
    id: '1810070002',
    districtId: '1810070',
    name: 'Sri Rahayu',
  },
  {
    id: '1810070003',
    districtId: '1810070',
    name: 'Nusa Wungu',
  },
  {
    id: '1810070004',
    districtId: '1810070',
    name: 'Sukamulya',
  },
  {
    id: '1810070005',
    districtId: '1810070',
    name: 'Banjarejo',
  },
  {
    id: '1810070006',
    districtId: '1810070',
    name: 'Sriwungu',
  },
  {
    id: '1810070007',
    districtId: '1810070',
    name: 'Banyuwangi',
  },
  {
    id: '1810070008',
    districtId: '1810070',
    name: 'Banyumas',
  },
  {
    id: '1810070009',
    districtId: '1810070',
    name: 'Sinar Mulia',
  },
  {
    id: '1810070010',
    districtId: '1810070',
    name: 'Mulyorejo',
  },
  {
    id: '1810070011',
    districtId: '1810070',
    name: 'Banyu Urip',
  },
  {
    id: '1810080004',
    districtId: '1810080',
    name: 'Sinar Waya',
  },
  {
    id: '1810080005',
    districtId: '1810080',
    name: 'Bandung Baru',
  },
  {
    id: '1810080006',
    districtId: '1810080',
    name: 'Waringinsari Timur',
  },
  {
    id: '1810080007',
    districtId: '1810080',
    name: 'Tritunggal Mulya',
  },
  {
    id: '1810080008',
    districtId: '1810080',
    name: 'Enggal Rejo',
  },
  {
    id: '1810080009',
    districtId: '1810080',
    name: 'Sukoharum',
  },
  {
    id: '1810080010',
    districtId: '1810080',
    name: 'Adi Luwih',
  },
  {
    id: '1810080011',
    districtId: '1810080',
    name: 'Purwodadi',
  },
  {
    id: '1810080012',
    districtId: '1810080',
    name: 'Srikaton',
  },
  {
    id: '1810080013',
    districtId: '1810080',
    name: 'Tunggul Pawenang',
  },
  {
    id: '1810080014',
    districtId: '1810080',
    name: 'Bandung Baru Barat',
  },
  {
    id: '1810080015',
    districtId: '1810080',
    name: 'Toto Karto',
  },
  {
    id: '1810080016',
    districtId: '1810080',
    name: 'Kuta Waringin',
  },
  {
    id: '1811010001',
    districtId: '1811010',
    name: 'Bumi Harapan',
  },
  {
    id: '1811010002',
    districtId: '1811010',
    name: 'Buko Poso',
  },
  {
    id: '1811010003',
    districtId: '1811010',
    name: 'Hadi Mulyo',
  },
  {
    id: '1811010004',
    districtId: '1811010',
    name: 'Gedung Boga/Raja',
  },
  {
    id: '1811010005',
    districtId: '1811010',
    name: 'Suka Agung',
  },
  {
    id: '1811010006',
    districtId: '1811010',
    name: 'Rejo Mulyo',
  },
  {
    id: '1811010007',
    districtId: '1811010',
    name: 'Labuhan Baru',
  },
  {
    id: '1811010008',
    districtId: '1811010',
    name: 'Panca Warna',
  },
  {
    id: '1811010009',
    districtId: '1811010',
    name: 'Kebun Dalam',
  },
  {
    id: '1811010010',
    districtId: '1811010',
    name: 'Kejadian',
  },
  {
    id: '1811010011',
    districtId: '1811010',
    name: 'Labuhan Batin',
  },
  {
    id: '1811010012',
    districtId: '1811010',
    name: 'Labuhan Makmur',
  },
  {
    id: '1811010013',
    districtId: '1811010',
    name: 'Gedung Sri Mulyo',
  },
  {
    id: '1811010014',
    districtId: '1811010',
    name: 'Labuhan Permai',
  },
  {
    id: '1811010015',
    districtId: '1811010',
    name: 'Sumber Rejo',
  },
  {
    id: '1811010016',
    districtId: '1811010',
    name: 'Margo Bhakti',
  },
  {
    id: '1811010017',
    districtId: '1811010',
    name: 'Labuhan Mulya',
  },
  {
    id: '1811010018',
    districtId: '1811010',
    name: 'Karang Mulya',
  },
  {
    id: '1811010019',
    districtId: '1811010',
    name: 'Tri Tunggal Jaya',
  },
  {
    id: '1811010020',
    districtId: '1811010',
    name: 'Suka Mandiri',
  },
  {
    id: '1811020005',
    districtId: '1811020',
    name: 'Budi Aji',
  },
  {
    id: '1811020006',
    districtId: '1811020',
    name: 'Simpang Pematang',
  },
  {
    id: '1811020007',
    districtId: '1811020',
    name: 'Harapan Jaya',
  },
  {
    id: '1811020008',
    districtId: '1811020',
    name: 'Margo Rahayu',
  },
  {
    id: '1811020009',
    districtId: '1811020',
    name: 'Wira Bangun',
  },
  {
    id: '1811020021',
    districtId: '1811020',
    name: 'Agung Batin',
  },
  {
    id: '1811020022',
    districtId: '1811020',
    name: 'Bangun Mulyo',
  },
  {
    id: '1811020023',
    districtId: '1811020',
    name: 'Jaya Sakti',
  },
  {
    id: '1811020024',
    districtId: '1811020',
    name: 'Rejo Binangun',
  },
  {
    id: '1811020025',
    districtId: '1811020',
    name: 'Simpang Mesuji',
  },
  {
    id: '1811020026',
    districtId: '1811020',
    name: 'Margo Makmur',
  },
  {
    id: '1811020027',
    districtId: '1811020',
    name: 'Aji Jaya',
  },
  {
    id: '1811020028',
    districtId: '1811020',
    name: 'Mulya Agung',
  },
  {
    id: '1811030001',
    districtId: '1811030',
    name: 'Mukti Karya',
  },
  {
    id: '1811030002',
    districtId: '1811030',
    name: 'Adi Luhur',
  },
  {
    id: '1811030003',
    districtId: '1811030',
    name: 'Fajar Baru',
  },
  {
    id: '1811030004',
    districtId: '1811030',
    name: 'Adi Mulyo',
  },
  {
    id: '1811030005',
    districtId: '1811030',
    name: 'Fajar Asri',
  },
  {
    id: '1811030006',
    districtId: '1811030',
    name: 'Fajar Indah',
  },
  {
    id: '1811030007',
    districtId: '1811030',
    name: 'Adi Karya Mulya',
  },
  {
    id: '1811040001',
    districtId: '1811040',
    name: 'Muara Tenang',
  },
  {
    id: '1811040002',
    districtId: '1811040',
    name: 'Brabasan',
  },
  {
    id: '1811040003',
    districtId: '1811040',
    name: 'Gedung Ram',
  },
  {
    id: '1811040004',
    districtId: '1811040',
    name: 'Mekar Sari',
  },
  {
    id: '1811040005',
    districtId: '1811040',
    name: 'Sinar Laga',
  },
  {
    id: '1811040006',
    districtId: '1811040',
    name: 'Wira Jaya',
  },
  {
    id: '1811040007',
    districtId: '1811040',
    name: 'Bangun Jaya',
  },
  {
    id: '1811040008',
    districtId: '1811040',
    name: 'Bujung Buring',
  },
  {
    id: '1811040009',
    districtId: '1811040',
    name: 'Harapan Mukti',
  },
  {
    id: '1811040010',
    districtId: '1811040',
    name: 'Tri Karya Mulya',
  },
  {
    id: '1811040011',
    districtId: '1811040',
    name: 'Tanjung Sari',
  },
  {
    id: '1811040012',
    districtId: '1811040',
    name: 'Kagungan Dalam',
  },
  {
    id: '1811040013',
    districtId: '1811040',
    name: 'Sri Tanjung',
  },
  {
    id: '1811040014',
    districtId: '1811040',
    name: 'Berasan Makmur',
  },
  {
    id: '1811040015',
    districtId: '1811040',
    name: 'Mekar Jaya',
  },
  {
    id: '1811040016',
    districtId: '1811040',
    name: 'Gedung Mulya',
  },
  {
    id: '1811040017',
    districtId: '1811040',
    name: 'Tanjung Harapan',
  },
  {
    id: '1811040018',
    districtId: '1811040',
    name: 'Muara Tenang Timur',
  },
  {
    id: '1811040019',
    districtId: '1811040',
    name: 'Sriwijaya',
  },
  {
    id: '1811040020',
    districtId: '1811040',
    name: 'Mukti Jaya',
  },
  {
    id: '1811040021',
    districtId: '1811040',
    name: 'Bujung Buring Baru',
  },
  {
    id: '1811050003',
    districtId: '1811050',
    name: 'Tirta Laga',
  },
  {
    id: '1811050020',
    districtId: '1811050',
    name: 'Wiralaga I',
  },
  {
    id: '1811050021',
    districtId: '1811050',
    name: 'Wiralaga II',
  },
  {
    id: '1811050022',
    districtId: '1811050',
    name: 'Tanjung Serayan',
  },
  {
    id: '1811050040',
    districtId: '1811050',
    name: 'Nipah Kuning',
  },
  {
    id: '1811050043',
    districtId: '1811050',
    name: 'Sungai Badak',
  },
  {
    id: '1811050044',
    districtId: '1811050',
    name: 'Sidomulyo',
  },
  {
    id: '1811050047',
    districtId: '1811050',
    name: 'Sumber Makmur',
  },
  {
    id: '1811050048',
    districtId: '1811050',
    name: 'Mulya Sari',
  },
  {
    id: '1811050049',
    districtId: '1811050',
    name: 'Wiralaga Mulya',
  },
  {
    id: '1811050050',
    districtId: '1811050',
    name: 'Suka Maju',
  },
  {
    id: '1811060001',
    districtId: '1811060',
    name: 'Pangkal Mas Mulya',
  },
  {
    id: '1811060002',
    districtId: '1811060',
    name: 'Pangkal Mas Jaya',
  },
  {
    id: '1811060003',
    districtId: '1811060',
    name: 'Tanjung Mas Makmur',
  },
  {
    id: '1811060004',
    districtId: '1811060',
    name: 'Muara Mas',
  },
  {
    id: '1811060005',
    districtId: '1811060',
    name: 'Tanjung Mas Mulya',
  },
  {
    id: '1811060006',
    districtId: '1811060',
    name: 'Tanjung Mas Jaya',
  },
  {
    id: '1811060007',
    districtId: '1811060',
    name: 'Wonosari',
  },
  {
    id: '1811060008',
    districtId: '1811060',
    name: 'Dwi Karya Mustika',
  },
  {
    id: '1811060009',
    districtId: '1811060',
    name: 'Eka Mulya',
  },
  {
    id: '1811060010',
    districtId: '1811060',
    name: 'Marga Jadi',
  },
  {
    id: '1811060011',
    districtId: '1811060',
    name: 'Tanjung Menang',
  },
  {
    id: '1811060012',
    districtId: '1811060',
    name: 'Talang Batu',
  },
  {
    id: '1811060013',
    districtId: '1811060',
    name: 'Sungai Cambai',
  },
  {
    id: '1811060014',
    districtId: '1811060',
    name: 'Margo Jaya',
  },
  {
    id: '1811060015',
    districtId: '1811060',
    name: 'Pangkal Mas',
  },
  {
    id: '1811060016',
    districtId: '1811060',
    name: 'Tanjung Menang Raya',
  },
  {
    id: '1811060017',
    districtId: '1811060',
    name: 'Tebing Karya Mandiri',
  },
  {
    id: '1811060018',
    districtId: '1811060',
    name: 'Tanjung Mas Rejo',
  },
  {
    id: '1811060019',
    districtId: '1811060',
    name: 'Margo Mulyo',
  },
  {
    id: '1811060020',
    districtId: '1811060',
    name: 'Muara Asri',
  },
  {
    id: '1811070001',
    districtId: '1811070',
    name: 'Sidang Gunung Tiga',
  },
  {
    id: '1811070002',
    districtId: '1811070',
    name: 'Sidang Bandar Anom',
  },
  {
    id: '1811070003',
    districtId: '1811070',
    name: 'Sidang Kurnia Agung',
  },
  {
    id: '1811070004',
    districtId: '1811070',
    name: 'Sidang Iso Mukti',
  },
  {
    id: '1811070005',
    districtId: '1811070',
    name: 'Sidang Sido Rahayu',
  },
  {
    id: '1811070006',
    districtId: '1811070',
    name: 'Sidang Way Puji',
  },
  {
    id: '1811070007',
    districtId: '1811070',
    name: 'Panggung Jaya',
  },
  {
    id: '1811070008',
    districtId: '1811070',
    name: 'Tlogo Rejo',
  },
  {
    id: '1811070009',
    districtId: '1811070',
    name: 'Panggung Rejo',
  },
  {
    id: '1811070010',
    districtId: '1811070',
    name: 'Sungai Buaya',
  },
  {
    id: '1811070011',
    districtId: '1811070',
    name: 'Sungai Sidang',
  },
  {
    id: '1811070012',
    districtId: '1811070',
    name: 'Sidang Muara Jaya',
  },
  {
    id: '1811070013',
    districtId: '1811070',
    name: 'Sidang Makmur',
  },
  {
    id: '1812010010',
    districtId: '1812010',
    name: 'Marga Kencana',
  },
  {
    id: '1812010011',
    districtId: '1812010',
    name: 'Kagungan Ratu',
  },
  {
    id: '1812010012',
    districtId: '1812010',
    name: 'Karta Raharja',
  },
  {
    id: '1812010013',
    districtId: '1812010',
    name: 'Way Sido',
  },
  {
    id: '1812010014',
    districtId: '1812010',
    name: 'Karta Sari',
  },
  {
    id: '1812010015',
    districtId: '1812010',
    name: 'Karta',
  },
  {
    id: '1812010016',
    districtId: '1812010',
    name: 'Gunung Katun Malay',
  },
  {
    id: '1812010017',
    districtId: '1812010',
    name: 'Gunung Katun Tanjungan',
  },
  {
    id: '1812010018',
    districtId: '1812010',
    name: 'Gedung Ratu',
  },
  {
    id: '1812020001',
    districtId: '1812020',
    name: 'Gunung Menanti',
  },
  {
    id: '1812020002',
    districtId: '1812020',
    name: 'Margo Dadi',
  },
  {
    id: '1812020003',
    districtId: '1812020',
    name: 'Murni Jaya',
  },
  {
    id: '1812020004',
    districtId: '1812020',
    name: 'Margo Mulyo',
  },
  {
    id: '1812020005',
    districtId: '1812020',
    name: 'Daya Asri',
  },
  {
    id: '1812020006',
    districtId: '1812020',
    name: 'Daya Murni',
  },
  {
    id: '1812020007',
    districtId: '1812020',
    name: 'Daya Sakti',
  },
  {
    id: '1812020008',
    districtId: '1812020',
    name: 'Makarti',
  },
  {
    id: '1812020009',
    districtId: '1812020',
    name: 'Sumber Rejo',
  },
  {
    id: '1812020010',
    districtId: '1812020',
    name: 'Gunung Timbul',
  },
  {
    id: '1812030001',
    districtId: '1812030',
    name: 'Mulya Asri',
  },
  {
    id: '1812030002',
    districtId: '1812030',
    name: 'Candra Kencana',
  },
  {
    id: '1812030003',
    districtId: '1812030',
    name: 'Mulya Kencana',
  },
  {
    id: '1812030004',
    districtId: '1812030',
    name: 'Pulung Kencana',
  },
  {
    id: '1812030005',
    districtId: '1812030',
    name: 'Tirta Kencana',
  },
  {
    id: '1812030006',
    districtId: '1812030',
    name: 'Panaragan Jaya',
  },
  {
    id: '1812030007',
    districtId: '1812030',
    name: 'Penumangan',
  },
  {
    id: '1812030008',
    districtId: '1812030',
    name: 'Penumangan Baru',
  },
  {
    id: '1812030009',
    districtId: '1812030',
    name: 'Panaragan',
  },
  {
    id: '1812030010',
    districtId: '1812030',
    name: 'Bandar Dewa',
  },
  {
    id: '1812030011',
    districtId: '1812030',
    name: 'Menggala Mas',
  },
  {
    id: '1812030013',
    districtId: '1812030',
    name: 'Tunas Asri',
  },
  {
    id: '1812030014',
    districtId: '1812030',
    name: 'Wonokerto',
  },
  {
    id: '1812030015',
    districtId: '1812030',
    name: 'Panaragan Jaya Utama',
  },
  {
    id: '1812030016',
    districtId: '1812030',
    name: 'Panaragan Jaya Indah',
  },
  {
    id: '1812030017',
    districtId: '1812030',
    name: 'Mulya Jaya',
  },
  {
    id: '1812030018',
    districtId: '1812030',
    name: 'Tirta Makmur',
  },
  {
    id: '1812030019',
    districtId: '1812030',
    name: 'Candra Mukti',
  },
  {
    id: '1812030020',
    districtId: '1812030',
    name: 'Candra Jaya',
  },
  {
    id: '1812040001',
    districtId: '1812040',
    name: 'Pagar Dewa',
  },
  {
    id: '1812040002',
    districtId: '1812040',
    name: 'Bujung Dewa',
  },
  {
    id: '1812040003',
    districtId: '1812040',
    name: 'Bujung Sari Marga',
  },
  {
    id: '1812040004',
    districtId: '1812040',
    name: 'Pagar Dewa Suka Mulya',
  },
  {
    id: '1812040005',
    districtId: '1812040',
    name: 'Cahyou Randu',
  },
  {
    id: '1812040006',
    districtId: '1812040',
    name: 'Marga Jaya Indah',
  },
  {
    id: '1812050001',
    districtId: '1812050',
    name: 'Lesung Bakti Jaya',
  },
  {
    id: '1812050002',
    districtId: '1812050',
    name: 'Mekar Sari Jaya',
  },
  {
    id: '1812050003',
    districtId: '1812050',
    name: 'Pagar Jaya',
  },
  {
    id: '1812050004',
    districtId: '1812050',
    name: 'Sumber Rejo',
  },
  {
    id: '1812050005',
    districtId: '1812050',
    name: 'Gunung Sari',
  },
  {
    id: '1812050006',
    districtId: '1812050',
    name: 'Kibang Budi Jaya',
  },
  {
    id: '1812050007',
    districtId: '1812050',
    name: 'Kibang Yekti Jaya',
  },
  {
    id: '1812050008',
    districtId: '1812050',
    name: 'Kibang Tri Jaya',
  },
  {
    id: '1812050009',
    districtId: '1812050',
    name: 'Gilang Tunggal Makarta',
  },
  {
    id: '1812050010',
    districtId: '1812050',
    name: 'Kibang Mulya Jaya',
  },
  {
    id: '1812060002',
    districtId: '1812060',
    name: 'Gunung Terang',
  },
  {
    id: '1812060003',
    districtId: '1812060',
    name: 'Gunung Agung',
  },
  {
    id: '1812060008',
    districtId: '1812060',
    name: 'Toto Mulyo',
  },
  {
    id: '1812060009',
    districtId: '1812060',
    name: 'Setia Bumi',
  },
  {
    id: '1812060012',
    districtId: '1812060',
    name: 'Kagungan Jaya',
  },
  {
    id: '1812060013',
    districtId: '1812060',
    name: 'Terang Mulya',
  },
  {
    id: '1812060014',
    districtId: '1812060',
    name: 'Terang Bumi Agung',
  },
  {
    id: '1812060016',
    districtId: '1812060',
    name: 'Setia Agung',
  },
  {
    id: '1812060018',
    districtId: '1812060',
    name: 'Mulyo Jadi',
  },
  {
    id: '1812060021',
    districtId: '1812060',
    name: 'Terang Makmur',
  },
  {
    id: '1812061001',
    districtId: '1812061',
    name: 'Mulyo Sari',
  },
  {
    id: '1812061002',
    districtId: '1812061',
    name: 'Marga Sari',
  },
  {
    id: '1812061003',
    districtId: '1812061',
    name: 'Toto Wonodadi',
  },
  {
    id: '1812061004',
    districtId: '1812061',
    name: 'Sido Makmur',
  },
  {
    id: '1812061005',
    districtId: '1812061',
    name: 'Panca Marga',
  },
  {
    id: '1812061006',
    districtId: '1812061',
    name: 'Toto Katon',
  },
  {
    id: '1812061007',
    districtId: '1812061',
    name: 'Toto Makmur',
  },
  {
    id: '1812061008',
    districtId: '1812061',
    name: 'Margo Dadi',
  },
  {
    id: '1812061009',
    districtId: '1812061',
    name: 'Marga Mulyo',
  },
  {
    id: '1812061010',
    districtId: '1812061',
    name: 'Sakti Jaya',
  },
  {
    id: '1812070001',
    districtId: '1812070',
    name: 'Marga Jaya',
  },
  {
    id: '1812070002',
    districtId: '1812070',
    name: 'Mekar Jaya',
  },
  {
    id: '1812070003',
    districtId: '1812070',
    name: 'Suka Jaya',
  },
  {
    id: '1812070004',
    districtId: '1812070',
    name: 'Mulya Jaya',
  },
  {
    id: '1812070005',
    districtId: '1812070',
    name: 'Wono Rejo',
  },
  {
    id: '1812070006',
    districtId: '1812070',
    name: 'Sumber Jaya',
  },
  {
    id: '1812070007',
    districtId: '1812070',
    name: 'Bangun Jaya',
  },
  {
    id: '1812070008',
    districtId: '1812070',
    name: 'Tunas Jaya',
  },
  {
    id: '1812070009',
    districtId: '1812070',
    name: 'Jaya Murni',
  },
  {
    id: '1812070010',
    districtId: '1812070',
    name: 'Tri Tunggal Jaya',
  },
  {
    id: '1812070011',
    districtId: '1812070',
    name: 'Mulya Sari',
  },
  {
    id: '1812070012',
    districtId: '1812070',
    name: 'Dwikora Jaya',
  },
  {
    id: '1812070013',
    districtId: '1812070',
    name: 'Sumber Rejeki',
  },
  {
    id: '1812080001',
    districtId: '1812080',
    name: 'Agung Jaya',
  },
  {
    id: '1812080002',
    districtId: '1812080',
    name: 'Mercu Buana',
  },
  {
    id: '1812080003',
    districtId: '1812080',
    name: 'Balam Jaya',
  },
  {
    id: '1812080004',
    districtId: '1812080',
    name: 'Indraloka II',
  },
  {
    id: '1812080005',
    districtId: '1812080',
    name: 'Pagar Buana',
  },
  {
    id: '1812080006',
    districtId: '1812080',
    name: 'Indraloka I',
  },
  {
    id: '1812080007',
    districtId: '1812080',
    name: 'Balam Asri',
  },
  {
    id: '1812080008',
    districtId: '1812080',
    name: 'Indraloka Mukti',
  },
  {
    id: '1812080009',
    districtId: '1812080',
    name: 'Indraloka Jaya',
  },
  {
    id: '1813010001',
    districtId: '1813010',
    name: 'Way Batang',
  },
  {
    id: '1813010002',
    districtId: '1813010',
    name: 'Parda Haga',
  },
  {
    id: '1813010003',
    districtId: '1813010',
    name: 'Tanjung Sakti',
  },
  {
    id: '1813010004',
    districtId: '1813010',
    name: 'Tanjung Jati',
  },
  {
    id: '1813010005',
    districtId: '1813010',
    name: 'Rata Agung',
  },
  {
    id: '1813010006',
    districtId: '1813010',
    name: 'Lemong',
  },
  {
    id: '1813010007',
    districtId: '1813010',
    name: 'Cahaya Negeri',
  },
  {
    id: '1813010008',
    districtId: '1813010',
    name: 'Suka Mulya',
  },
  {
    id: '1813010009',
    districtId: '1813010',
    name: 'Malaya',
  },
  {
    id: '1813010010',
    districtId: '1813010',
    name: 'Bambang',
  },
  {
    id: '1813010011',
    districtId: '1813010',
    name: 'Pagar Dalam',
  },
  {
    id: '1813010012',
    districtId: '1813010',
    name: 'Bandar Pugung',
  },
  {
    id: '1813010013',
    districtId: '1813010',
    name: 'Penengahan',
  },
  {
    id: '1813020001',
    districtId: '1813020',
    name: 'Walur',
  },
  {
    id: '1813020002',
    districtId: '1813020',
    name: 'Padang Rindu',
  },
  {
    id: '1813020003',
    districtId: '1813020',
    name: 'Kuripan',
  },
  {
    id: '1813020004',
    districtId: '1813020',
    name: 'Negeri Ratu',
  },
  {
    id: '1813020005',
    districtId: '1813020',
    name: 'Kerbang Langgar',
  },
  {
    id: '1813020006',
    districtId: '1813020',
    name: 'Kerbang Dalam',
  },
  {
    id: '1813020007',
    districtId: '1813020',
    name: 'Balam',
  },
  {
    id: '1813020008',
    districtId: '1813020',
    name: 'Way Narta',
  },
  {
    id: '1813020009',
    districtId: '1813020',
    name: 'Kota Karang',
  },
  {
    id: '1813020010',
    districtId: '1813020',
    name: 'Baturaja',
  },
  {
    id: '1813020011',
    districtId: '1813020',
    name: 'Gedau',
  },
  {
    id: '1813020012',
    districtId: '1813020',
    name: 'Pemancar',
  },
  {
    id: '1813030001',
    districtId: '1813030',
    name: 'Sukamarga',
  },
  {
    id: '1813030002',
    districtId: '1813030',
    name: 'Pekon Lok',
  },
  {
    id: '1813030003',
    districtId: '1813030',
    name: 'Bandar Dalam',
  },
  {
    id: '1813030004',
    districtId: '1813030',
    name: 'Pasar Pulau Pisang',
  },
  {
    id: '1813030005',
    districtId: '1813030',
    name: 'Sukadana',
  },
  {
    id: '1813030006',
    districtId: '1813030',
    name: 'Labuhan',
  },
  {
    id: '1813040001',
    districtId: '1813040',
    name: 'Tembakak Way Sindi',
  },
  {
    id: '1813040002',
    districtId: '1813040',
    name: 'Way Sindi Utara',
  },
  {
    id: '1813040003',
    districtId: '1813040',
    name: 'Asahan Way Sindi',
  },
  {
    id: '1813040004',
    districtId: '1813040',
    name: 'Way Sindi Hanuan',
  },
  {
    id: '1813040005',
    districtId: '1813040',
    name: 'Way Sindi',
  },
  {
    id: '1813040006',
    districtId: '1813040',
    name: 'Kebuayan',
  },
  {
    id: '1813040007',
    districtId: '1813040',
    name: 'Way Nukak',
  },
  {
    id: '1813040008',
    districtId: '1813040',
    name: 'Laay',
  },
  {
    id: '1813040009',
    districtId: '1813040',
    name: 'Penggawa Lima Ulu',
  },
  {
    id: '1813040010',
    districtId: '1813040',
    name: 'Penengahan',
  },
  {
    id: '1813040011',
    districtId: '1813040',
    name: 'Penggawa Lima Tengah',
  },
  {
    id: '1813040012',
    districtId: '1813040',
    name: 'Menyancang',
  },
  {
    id: '1813050001',
    districtId: '1813050',
    name: 'Bumiwaras',
  },
  {
    id: '1813050002',
    districtId: '1813050',
    name: 'Pajar Bulan',
  },
  {
    id: '1813050003',
    districtId: '1813050',
    name: 'Penggawa Lima',
  },
  {
    id: '1813050004',
    districtId: '1813050',
    name: 'Penggawa Lima Ilir',
  },
  {
    id: '1813050005',
    districtId: '1813050',
    name: 'Banjar Agung',
  },
  {
    id: '1813050006',
    districtId: '1813050',
    name: 'Suka Baru',
  },
  {
    id: '1813050007',
    districtId: '1813050',
    name: 'Ulu Krui',
  },
  {
    id: '1813050008',
    districtId: '1813050',
    name: 'Gunung Kemala',
  },
  {
    id: '1813050009',
    districtId: '1813050',
    name: 'Labuhan Mandi',
  },
  {
    id: '1813050010',
    districtId: '1813050',
    name: 'Gunung Kemala Timur',
  },
  {
    id: '1813060001',
    districtId: '1813060',
    name: 'Way Redak',
  },
  {
    id: '1813060002',
    districtId: '1813060',
    name: 'Seray',
  },
  {
    id: '1813060003',
    districtId: '1813060',
    name: 'Rawas',
  },
  {
    id: '1813060004',
    districtId: '1813060',
    name: 'Kampung Jawa',
  },
  {
    id: '1813060005',
    districtId: '1813060',
    name: 'Pasar Krui',
  },
  {
    id: '1813060006',
    districtId: '1813060',
    name: 'Pasar Kota Krui',
  },
  {
    id: '1813060007',
    districtId: '1813060',
    name: 'Sukanegara',
  },
  {
    id: '1813060008',
    districtId: '1813060',
    name: 'Pahmungan',
  },
  {
    id: '1813070001',
    districtId: '1813070',
    name: 'Walur',
  },
  {
    id: '1813070002',
    districtId: '1813070',
    name: 'Pemerihan',
  },
  {
    id: '1813070003',
    districtId: '1813070',
    name: 'Lintik',
  },
  {
    id: '1813070004',
    districtId: '1813070',
    name: 'Suka Jadi',
  },
  {
    id: '1813070005',
    districtId: '1813070',
    name: 'Padang Haluan',
  },
  {
    id: '1813070006',
    districtId: '1813070',
    name: 'Way Napal',
  },
  {
    id: '1813070007',
    districtId: '1813070',
    name: 'Way Suluh',
  },
  {
    id: '1813070008',
    districtId: '1813070',
    name: 'Padang Raya',
  },
  {
    id: '1813070009',
    districtId: '1813070',
    name: 'Balai Kencana',
  },
  {
    id: '1813070010',
    districtId: '1813070',
    name: 'Mandiri Sejati',
  },
  {
    id: '1813080001',
    districtId: '1813080',
    name: 'Marang',
  },
  {
    id: '1813080002',
    districtId: '1813080',
    name: 'Tanjung Raya',
  },
  {
    id: '1813080003',
    districtId: '1813080',
    name: 'Bangun Negara',
  },
  {
    id: '1813080004',
    districtId: '1813080',
    name: 'Way Jambu',
  },
  {
    id: '1813080005',
    districtId: '1813080',
    name: 'Paku Negara',
  },
  {
    id: '1813080006',
    districtId: '1813080',
    name: 'Ulok Manik',
  },
  {
    id: '1813080007',
    districtId: '1813080',
    name: 'Biha',
  },
  {
    id: '1813080008',
    districtId: '1813080',
    name: 'Tanjung Setia',
  },
  {
    id: '1813080009',
    districtId: '1813080',
    name: 'Sumur Jaya',
  },
  {
    id: '1813080010',
    districtId: '1813080',
    name: 'Pagar Dalam',
  },
  {
    id: '1813080011',
    districtId: '1813080',
    name: 'Tanjung Jati',
  },
  {
    id: '1813080012',
    districtId: '1813080',
    name: 'Pelita Jaya',
  },
  {
    id: '1813080013',
    districtId: '1813080',
    name: 'Sukarame',
  },
  {
    id: '1813080014',
    districtId: '1813080',
    name: 'Negeri Ratu Tenumbang',
  },
  {
    id: '1813080015',
    districtId: '1813080',
    name: 'Tulung Bamban',
  },
  {
    id: '1813090001',
    districtId: '1813090',
    name: 'Gedung Cahya Kuningan',
  },
  {
    id: '1813090002',
    districtId: '1813090',
    name: 'Suka Banjar',
  },
  {
    id: '1813090003',
    districtId: '1813090',
    name: 'Suka Negara',
  },
  {
    id: '1813090004',
    districtId: '1813090',
    name: 'Pekon Mon',
  },
  {
    id: '1813090005',
    districtId: '1813090',
    name: 'Muara Tembulih',
  },
  {
    id: '1813090006',
    districtId: '1813090',
    name: 'Negeri Ratu Ngambur',
  },
  {
    id: '1813090007',
    districtId: '1813090',
    name: 'Bumi Ratu',
  },
  {
    id: '1813090008',
    districtId: '1813090',
    name: 'Ulok Mukti',
  },
  {
    id: '1813090009',
    districtId: '1813090',
    name: 'Sumber Agung',
  },
  {
    id: '1813100001',
    districtId: '1813100',
    name: 'Parda Suka',
  },
  {
    id: '1813100002',
    districtId: '1813100',
    name: 'Sukarame',
  },
  {
    id: '1813100003',
    districtId: '1813100',
    name: 'Sukamaju',
  },
  {
    id: '1813100004',
    districtId: '1813100',
    name: 'Raja Basa',
  },
  {
    id: '1813100005',
    districtId: '1813100',
    name: 'Mulang Maya',
  },
  {
    id: '1813100006',
    districtId: '1813100',
    name: 'Padang Dalam',
  },
  {
    id: '1813100007',
    districtId: '1813100',
    name: 'Bandar Jaya',
  },
  {
    id: '1813100008',
    districtId: '1813100',
    name: 'Negeri Ratu Ngaras',
  },
  {
    id: '1813100009',
    districtId: '1813100',
    name: 'Kota Batu',
  },
  {
    id: '1813110001',
    districtId: '1813110',
    name: 'Way Haru',
  },
  {
    id: '1813110002',
    districtId: '1813110',
    name: 'Siring Gading',
  },
  {
    id: '1813110003',
    districtId: '1813110',
    name: 'Way Tias',
  },
  {
    id: '1813110004',
    districtId: '1813110',
    name: 'Bandar Dalam',
  },
  {
    id: '1813110005',
    districtId: '1813110',
    name: 'Sumber Rejo',
  },
  {
    id: '1813110006',
    districtId: '1813110',
    name: 'Suka Negeri',
  },
  {
    id: '1813110007',
    districtId: '1813110',
    name: 'Kota Jawa',
  },
  {
    id: '1813110008',
    districtId: '1813110',
    name: 'Pagar Bukit Induk',
  },
  {
    id: '1813110009',
    districtId: '1813110',
    name: 'Penyandingan',
  },
  {
    id: '1813110010',
    districtId: '1813110',
    name: 'Pemerihan',
  },
  {
    id: '1813110011',
    districtId: '1813110',
    name: 'Tanjung Kemala',
  },
  {
    id: '1813110012',
    districtId: '1813110',
    name: 'Suka Marga',
  },
  {
    id: '1813110013',
    districtId: '1813110',
    name: 'Tanjung Rejo',
  },
  {
    id: '1813110014',
    districtId: '1813110',
    name: 'Pagar Bukit',
  },
  {
    id: '1871010005',
    districtId: '1871010',
    name: 'Bakung',
  },
  {
    id: '1871010006',
    districtId: '1871010',
    name: 'Kuripan',
  },
  {
    id: '1871010007',
    districtId: '1871010',
    name: 'Negeri Olok Gading',
  },
  {
    id: '1871010008',
    districtId: '1871010',
    name: 'Sukarame II',
  },
  {
    id: '1871010011',
    districtId: '1871010',
    name: 'Batu Putuk',
  },
  {
    id: '1871011001',
    districtId: '1871011',
    name: 'Sukamaju',
  },
  {
    id: '1871011002',
    districtId: '1871011',
    name: 'Keteguhan',
  },
  {
    id: '1871011003',
    districtId: '1871011',
    name: 'Kota Karang',
  },
  {
    id: '1871011004',
    districtId: '1871011',
    name: 'Perwata',
  },
  {
    id: '1871011009',
    districtId: '1871011',
    name: 'Way Tataan',
  },
  {
    id: '1871011010',
    districtId: '1871011',
    name: 'Kota Karang Raya',
  },
  {
    id: '1871020001',
    districtId: '1871020',
    name: 'Gedong Pakuon',
  },
  {
    id: '1871020002',
    districtId: '1871020',
    name: 'Talang',
  },
  {
    id: '1871020003',
    districtId: '1871020',
    name: 'Pesawahan',
  },
  {
    id: '1871020004',
    districtId: '1871020',
    name: 'Teluk Betung',
  },
  {
    id: '1871020013',
    districtId: '1871020',
    name: 'Sumur Putri',
  },
  {
    id: '1871020014',
    districtId: '1871020',
    name: 'Gunung Mas',
  },
  {
    id: '1871021001',
    districtId: '1871021',
    name: 'Kangkung',
  },
  {
    id: '1871021002',
    districtId: '1871021',
    name: 'Bumi Waras',
  },
  {
    id: '1871021003',
    districtId: '1871021',
    name: 'Bumi Raya',
  },
  {
    id: '1871021004',
    districtId: '1871021',
    name: 'Sukaraja',
  },
  {
    id: '1871021005',
    districtId: '1871021',
    name: 'Garuntang',
  },
  {
    id: '1871030002',
    districtId: '1871030',
    name: 'Panjang Selatan',
  },
  {
    id: '1871030003',
    districtId: '1871030',
    name: 'Panjang Utara',
  },
  {
    id: '1871030004',
    districtId: '1871030',
    name: 'Pidada',
  },
  {
    id: '1871030009',
    districtId: '1871030',
    name: 'Karang Maritim',
  },
  {
    id: '1871030010',
    districtId: '1871030',
    name: 'Way Lunik',
  },
  {
    id: '1871030011',
    districtId: '1871030',
    name: 'Ketapang',
  },
  {
    id: '1871030012',
    districtId: '1871030',
    name: 'Ketapang Kuala',
  },
  {
    id: '1871040002',
    districtId: '1871040',
    name: 'Kota Baru',
  },
  {
    id: '1871040003',
    districtId: '1871040',
    name: 'Tanjung Agung',
  },
  {
    id: '1871040004',
    districtId: '1871040',
    name: 'Kebon Jeruk',
  },
  {
    id: '1871040005',
    districtId: '1871040',
    name: 'Sawah Lama',
  },
  {
    id: '1871040006',
    districtId: '1871040',
    name: 'Sawah Brebes',
  },
  {
    id: '1871041001',
    districtId: '1871041',
    name: 'Tanjung Gading',
  },
  {
    id: '1871041002',
    districtId: '1871041',
    name: 'Tanjung Raya',
  },
  {
    id: '1871041003',
    districtId: '1871041',
    name: 'Kedamaian',
  },
  {
    id: '1871041004',
    districtId: '1871041',
    name: 'Kalibalau Kencana',
  },
  {
    id: '1871041005',
    districtId: '1871041',
    name: 'Tanjung Baru',
  },
  {
    id: '1871041006',
    districtId: '1871041',
    name: 'Bumi Kedamaian',
  },
  {
    id: '1871041007',
    districtId: '1871041',
    name: 'Tanjung Agung Raya',
  },
  {
    id: '1871050001',
    districtId: '1871050',
    name: 'Kupang Kota',
  },
  {
    id: '1871050003',
    districtId: '1871050',
    name: 'Kupang Teba',
  },
  {
    id: '1871050004',
    districtId: '1871050',
    name: 'Kupang Raya',
  },
  {
    id: '1871050006',
    districtId: '1871050',
    name: 'Sumur Batu',
  },
  {
    id: '1871050007',
    districtId: '1871050',
    name: 'Gulak Galik',
  },
  {
    id: '1871050008',
    districtId: '1871050',
    name: 'Pengajaran',
  },
  {
    id: '1871060001',
    districtId: '1871060',
    name: 'Durian Payung',
  },
  {
    id: '1871060002',
    districtId: '1871060',
    name: 'Gotong Royong',
  },
  {
    id: '1871060005',
    districtId: '1871060',
    name: 'Palapa',
  },
  {
    id: '1871060006',
    districtId: '1871060',
    name: 'Kaliawi',
  },
  {
    id: '1871060007',
    districtId: '1871060',
    name: 'Kelapa Tiga',
  },
  {
    id: '1871060010',
    districtId: '1871060',
    name: 'Pasir Gintung',
  },
  {
    id: '1871060013',
    districtId: '1871060',
    name: 'Kaliawi Persada',
  },
  {
    id: '1871061001',
    districtId: '1871061',
    name: 'Gunung Sari',
  },
  {
    id: '1871061002',
    districtId: '1871061',
    name: 'Tanjung Karang',
  },
  {
    id: '1871061003',
    districtId: '1871061',
    name: 'Pelita',
  },
  {
    id: '1871061004',
    districtId: '1871061',
    name: 'Enggal',
  },
  {
    id: '1871061005',
    districtId: '1871061',
    name: 'Rawa Laut',
  },
  {
    id: '1871061006',
    districtId: '1871061',
    name: 'Pahoman',
  },
  {
    id: '1871070002',
    districtId: '1871070',
    name: 'Susunan Baru',
  },
  {
    id: '1871070003',
    districtId: '1871070',
    name: 'Sukadana Ham',
  },
  {
    id: '1871070004',
    districtId: '1871070',
    name: 'Sukajawa',
  },
  {
    id: '1871070005',
    districtId: '1871070',
    name: 'Gedong Air',
  },
  {
    id: '1871070006',
    districtId: '1871070',
    name: 'Segala Mider',
  },
  {
    id: '1871070010',
    districtId: '1871070',
    name: 'Sukajawa Baru',
  },
  {
    id: '1871070013',
    districtId: '1871070',
    name: 'Kelapa Tiga Permai',
  },
  {
    id: '1871071001',
    districtId: '1871071',
    name: 'Sumber Agung',
  },
  {
    id: '1871071002',
    districtId: '1871071',
    name: 'Kedaung',
  },
  {
    id: '1871071003',
    districtId: '1871071',
    name: 'Pinang Jaya',
  },
  {
    id: '1871071004',
    districtId: '1871071',
    name: 'Beringin Raya',
  },
  {
    id: '1871071005',
    districtId: '1871071',
    name: 'Sumber Rejo',
  },
  {
    id: '1871071006',
    districtId: '1871071',
    name: 'Kemiling Permai',
  },
  {
    id: '1871071008',
    districtId: '1871071',
    name: 'Sumberrejo Sejahtera',
  },
  {
    id: '1871071009',
    districtId: '1871071',
    name: 'Beringin Jaya',
  },
  {
    id: '1871071010',
    districtId: '1871071',
    name: 'Kemiling Raya',
  },
  {
    id: '1871072001',
    districtId: '1871072',
    name: 'Bilabong Jaya',
  },
  {
    id: '1871072002',
    districtId: '1871072',
    name: 'Langkapura',
  },
  {
    id: '1871072003',
    districtId: '1871072',
    name: 'Langkapura Baru',
  },
  {
    id: '1871072004',
    districtId: '1871072',
    name: 'Gunung Terang',
  },
  {
    id: '1871072005',
    districtId: '1871072',
    name: 'Gunung Agung',
  },
  {
    id: '1871080001',
    districtId: '1871080',
    name: 'Sukamenanti',
  },
  {
    id: '1871080002',
    districtId: '1871080',
    name: 'Sidodadi',
  },
  {
    id: '1871080003',
    districtId: '1871080',
    name: 'Surabaya',
  },
  {
    id: '1871080005',
    districtId: '1871080',
    name: 'Kedaton',
  },
  {
    id: '1871080016',
    districtId: '1871080',
    name: 'Sukamenanti Baru',
  },
  {
    id: '1871080018',
    districtId: '1871080',
    name: 'Penengahan',
  },
  {
    id: '1871080019',
    districtId: '1871080',
    name: 'Penengahan Raya',
  },
  {
    id: '1871081001',
    districtId: '1871081',
    name: 'Gedong Meneng',
  },
  {
    id: '1871081002',
    districtId: '1871081',
    name: 'Rajabasa',
  },
  {
    id: '1871081003',
    districtId: '1871081',
    name: 'Rajabasa Raya',
  },
  {
    id: '1871081004',
    districtId: '1871081',
    name: 'Rajabasa Jaya',
  },
  {
    id: '1871081005',
    districtId: '1871081',
    name: 'Gedong Meneng Baru',
  },
  {
    id: '1871081006',
    districtId: '1871081',
    name: 'Rajabasa Pemuka',
  },
  {
    id: '1871081007',
    districtId: '1871081',
    name: 'Rajabasa Nunyai',
  },
  {
    id: '1871082001',
    districtId: '1871082',
    name: 'Labuhan Dalam',
  },
  {
    id: '1871082002',
    districtId: '1871082',
    name: 'Tanjung Senang',
  },
  {
    id: '1871082003',
    districtId: '1871082',
    name: 'Way Kandis',
  },
  {
    id: '1871082004',
    districtId: '1871082',
    name: 'Perumnas Way Kandis',
  },
  {
    id: '1871082005',
    districtId: '1871082',
    name: 'Pematang Wangi',
  },
  {
    id: '1871083006',
    districtId: '1871083',
    name: 'Labuhan Ratu',
  },
  {
    id: '1871083009',
    districtId: '1871083',
    name: 'Kampung Baru',
  },
  {
    id: '1871083013',
    districtId: '1871083',
    name: 'Sepang Jaya',
  },
  {
    id: '1871083014',
    districtId: '1871083',
    name: 'Labuhan Ratu Raya',
  },
  {
    id: '1871083015',
    districtId: '1871083',
    name: 'Kota Sepang',
  },
  {
    id: '1871083017',
    districtId: '1871083',
    name: 'Kampung Baru Raya',
  },
  {
    id: '1871090005',
    districtId: '1871090',
    name: 'Sukarame',
  },
  {
    id: '1871090009',
    districtId: '1871090',
    name: 'Way Dadi',
  },
  {
    id: '1871090011',
    districtId: '1871090',
    name: 'Korpri Jaya',
  },
  {
    id: '1871090012',
    districtId: '1871090',
    name: 'Way Dadi Baru',
  },
  {
    id: '1871090013',
    districtId: '1871090',
    name: 'Korpri Raya',
  },
  {
    id: '1871090014',
    districtId: '1871090',
    name: 'Sukarame Baru',
  },
  {
    id: '1871091005',
    districtId: '1871091',
    name: 'Sukabumi Indah',
  },
  {
    id: '1871091006',
    districtId: '1871091',
    name: 'Sukabumi',
  },
  {
    id: '1871091007',
    districtId: '1871091',
    name: 'Nusantara Permai',
  },
  {
    id: '1871091008',
    districtId: '1871091',
    name: 'Campang Raya',
  },
  {
    id: '1871091009',
    districtId: '1871091',
    name: 'Campang Jaya',
  },
  {
    id: '1871091010',
    districtId: '1871091',
    name: 'Way Gubak',
  },
  {
    id: '1871091011',
    districtId: '1871091',
    name: 'Way Laga',
  },
  {
    id: '1871092001',
    districtId: '1871092',
    name: 'Jagabaya I',
  },
  {
    id: '1871092002',
    districtId: '1871092',
    name: 'Jagabaya II',
  },
  {
    id: '1871092003',
    districtId: '1871092',
    name: 'Jagabaya III',
  },
  {
    id: '1871092004',
    districtId: '1871092',
    name: 'Gunung Sulah',
  },
  {
    id: '1871092005',
    districtId: '1871092',
    name: 'Way Halim Permai',
  },
  {
    id: '1871092006',
    districtId: '1871092',
    name: 'Perumnas Way Halim',
  },
  {
    id: '1872011001',
    districtId: '1872011',
    name: 'Sumbersari',
  },
  {
    id: '1872011002',
    districtId: '1872011',
    name: 'Rejomulyo',
  },
  {
    id: '1872011003',
    districtId: '1872011',
    name: 'Margodadi',
  },
  {
    id: '1872011004',
    districtId: '1872011',
    name: 'Margorejo',
  },
  {
    id: '1872012001',
    districtId: '1872012',
    name: 'Mulyojati',
  },
  {
    id: '1872012002',
    districtId: '1872012',
    name: 'Mulyosari',
  },
  {
    id: '1872012003',
    districtId: '1872012',
    name: 'Ganjaragung',
  },
  {
    id: '1872012004',
    districtId: '1872012',
    name: 'Ganjarasri',
  },
  {
    id: '1872021001',
    districtId: '1872021',
    name: 'Tejosari',
  },
  {
    id: '1872021002',
    districtId: '1872021',
    name: 'Tejoagung',
  },
  {
    id: '1872021003',
    districtId: '1872021',
    name: 'Iringmulyo',
  },
  {
    id: '1872021004',
    districtId: '1872021',
    name: 'Yosorejo',
  },
  {
    id: '1872021005',
    districtId: '1872021',
    name: 'Yosodadi',
  },
  {
    id: '1872022001',
    districtId: '1872022',
    name: 'Metro',
  },
  {
    id: '1872022002',
    districtId: '1872022',
    name: 'Imopuro',
  },
  {
    id: '1872022003',
    districtId: '1872022',
    name: 'Hadimulyo Barat',
  },
  {
    id: '1872022004',
    districtId: '1872022',
    name: 'Hadimulyo Timur',
  },
  {
    id: '1872022005',
    districtId: '1872022',
    name: 'Yosomulyo',
  },
  {
    id: '1872023001',
    districtId: '1872023',
    name: 'Banjarsari',
  },
  {
    id: '1872023002',
    districtId: '1872023',
    name: 'Purwosari',
  },
  {
    id: '1872023003',
    districtId: '1872023',
    name: 'Purwoasri',
  },
  {
    id: '1872023004',
    districtId: '1872023',
    name: 'Karangrejo',
  },
  {
    id: '1901070001',
    districtId: '1901070',
    name: 'Kota Kapur',
  },
  {
    id: '1901070002',
    districtId: '1901070',
    name: 'Penagan',
  },
  {
    id: '1901070003',
    districtId: '1901070',
    name: 'Rukam',
  },
  {
    id: '1901070004',
    districtId: '1901070',
    name: 'Air Buluh',
  },
  {
    id: '1901070005',
    districtId: '1901070',
    name: 'Kace',
  },
  {
    id: '1901070006',
    districtId: '1901070',
    name: 'Cengkongabang',
  },
  {
    id: '1901070007',
    districtId: '1901070',
    name: 'Airduren',
  },
  {
    id: '1901070008',
    districtId: '1901070',
    name: 'Petaling',
  },
  {
    id: '1901070009',
    districtId: '1901070',
    name: 'Menduk',
  },
  {
    id: '1901070010',
    districtId: '1901070',
    name: 'Payabenua',
  },
  {
    id: '1901070011',
    districtId: '1901070',
    name: 'Kemuja',
  },
  {
    id: '1901070013',
    districtId: '1901070',
    name: 'Labuh Air Pandan',
  },
  {
    id: '1901070014',
    districtId: '1901070',
    name: 'Kace Timur',
  },
  {
    id: '1901070015',
    districtId: '1901070',
    name: 'Petaling Banjar',
  },
  {
    id: '1901080010',
    districtId: '1901080',
    name: 'Kimak',
  },
  {
    id: '1901080011',
    districtId: '1901080',
    name: 'Jada Bahrin',
  },
  {
    id: '1901080012',
    districtId: '1901080',
    name: 'Balunijuk',
  },
  {
    id: '1901080013',
    districtId: '1901080',
    name: 'Pagarawan',
  },
  {
    id: '1901080014',
    districtId: '1901080',
    name: 'Baturusa',
  },
  {
    id: '1901080015',
    districtId: '1901080',
    name: 'Air Anyir',
  },
  {
    id: '1901080016',
    districtId: '1901080',
    name: 'Riding Panjang',
  },
  {
    id: '1901080017',
    districtId: '1901080',
    name: 'Dwi Makmur',
  },
  {
    id: '1901080018',
    districtId: '1901080',
    name: 'Jurung',
  },
  {
    id: '1901080019',
    districtId: '1901080',
    name: 'Merawang',
  },
  {
    id: '1901081001',
    districtId: '1901081',
    name: 'Kotawaringin',
  },
  {
    id: '1901081002',
    districtId: '1901081',
    name: 'Saing',
  },
  {
    id: '1901081003',
    districtId: '1901081',
    name: 'Tanah Bawah',
  },
  {
    id: '1901081004',
    districtId: '1901081',
    name: 'Nibung',
  },
  {
    id: '1901081005',
    districtId: '1901081',
    name: 'Labu',
  },
  {
    id: '1901081006',
    districtId: '1901081',
    name: 'Pudingbesar',
  },
  {
    id: '1901081007',
    districtId: '1901081',
    name: 'Kayu Besi',
  },
  {
    id: '1901090014',
    districtId: '1901090',
    name: 'Kenanga',
  },
  {
    id: '1901090015',
    districtId: '1901090',
    name: 'Rebo',
  },
  {
    id: '1901090016',
    districtId: '1901090',
    name: 'Parit Padang',
  },
  {
    id: '1901090017',
    districtId: '1901090',
    name: 'Srimenanti',
  },
  {
    id: '1901090018',
    districtId: '1901090',
    name: 'Sungailiat',
  },
  {
    id: '1901090019',
    districtId: '1901090',
    name: 'Kuday',
  },
  {
    id: '1901090020',
    districtId: '1901090',
    name: 'Sinar Baru',
  },
  {
    id: '1901090021',
    districtId: '1901090',
    name: 'Lubuk Kelik',
  },
  {
    id: '1901090022',
    districtId: '1901090',
    name: 'Surya Timur',
  },
  {
    id: '1901090023',
    districtId: '1901090',
    name: 'Jelitik',
  },
  {
    id: '1901090024',
    districtId: '1901090',
    name: 'Bukit Betung',
  },
  {
    id: '1901090025',
    districtId: '1901090',
    name: 'Sinar Jaya Jelutung',
  },
  {
    id: '1901090026',
    districtId: '1901090',
    name: 'Matras',
  },
  {
    id: '1901091001',
    districtId: '1901091',
    name: 'Penyamun',
  },
  {
    id: '1901091002',
    districtId: '1901091',
    name: 'Pemali',
  },
  {
    id: '1901091003',
    districtId: '1901091',
    name: 'Air Duren',
  },
  {
    id: '1901091004',
    districtId: '1901091',
    name: 'Air Ruai',
  },
  {
    id: '1901091005',
    districtId: '1901091',
    name: 'Karya Makmur',
  },
  {
    id: '1901091006',
    districtId: '1901091',
    name: 'Sempan',
  },
  {
    id: '1901092001',
    districtId: '1901092',
    name: 'Maras Senang',
  },
  {
    id: '1901092002',
    districtId: '1901092',
    name: 'Kapuk',
  },
  {
    id: '1901092003',
    districtId: '1901092',
    name: 'Neknang',
  },
  {
    id: '1901092004',
    districtId: '1901092',
    name: 'Tiang Tara',
  },
  {
    id: '1901092005',
    districtId: '1901092',
    name: 'Dalil',
  },
  {
    id: '1901092006',
    districtId: '1901092',
    name: 'Bakam',
  },
  {
    id: '1901092007',
    districtId: '1901092',
    name: 'Mangka',
  },
  {
    id: '1901092008',
    districtId: '1901092',
    name: 'Mabat',
  },
  {
    id: '1901092009',
    districtId: '1901092',
    name: 'Bukitlayang',
  },
  {
    id: '1901130010',
    districtId: '1901130',
    name: 'Riding Panjang',
  },
  {
    id: '1901130011',
    districtId: '1901130',
    name: 'Gunung Muda',
  },
  {
    id: '1901130012',
    districtId: '1901130',
    name: 'Kuto Panji',
  },
  {
    id: '1901130013',
    districtId: '1901130',
    name: 'Air Jukung',
  },
  {
    id: '1901130014',
    districtId: '1901130',
    name: 'Bukit Ketok',
  },
  {
    id: '1901130015',
    districtId: '1901130',
    name: 'Bintet',
  },
  {
    id: '1901130016',
    districtId: '1901130',
    name: 'Gunung Pelawan',
  },
  {
    id: '1901130017',
    districtId: '1901130',
    name: 'Belinyu',
  },
  {
    id: '1901130018',
    districtId: '1901130',
    name: 'Mantung',
  },
  {
    id: '1901130019',
    districtId: '1901130',
    name: 'Air Asam',
  },
  {
    id: '1901130020',
    districtId: '1901130',
    name: 'Remodong Indah',
  },
  {
    id: '1901131001',
    districtId: '1901131',
    name: 'Banyu Asin',
  },
  {
    id: '1901131002',
    districtId: '1901131',
    name: 'Pangkal Niur',
  },
  {
    id: '1901131004',
    districtId: '1901131',
    name: 'Cit',
  },
  {
    id: '1901131005',
    districtId: '1901131',
    name: 'Deniang',
  },
  {
    id: '1901131006',
    districtId: '1901131',
    name: 'Mapur',
  },
  {
    id: '1901131007',
    districtId: '1901131',
    name: 'Silip',
  },
  {
    id: '1901131008',
    districtId: '1901131',
    name: 'Riau',
  },
  {
    id: '1901131009',
    districtId: '1901131',
    name: 'Berbura',
  },
  {
    id: '1902010001',
    districtId: '1902010',
    name: 'Pulau Seliu',
  },
  {
    id: '1902010002',
    districtId: '1902010',
    name: 'Membalong',
  },
  {
    id: '1902010003',
    districtId: '1902010',
    name: 'Mentigi',
  },
  {
    id: '1902010004',
    districtId: '1902010',
    name: 'Tanjung Rusa',
  },
  {
    id: '1902010005',
    districtId: '1902010',
    name: 'Kembiri',
  },
  {
    id: '1902010006',
    districtId: '1902010',
    name: 'Perpat',
  },
  {
    id: '1902010007',
    districtId: '1902010',
    name: 'Lassar',
  },
  {
    id: '1902010008',
    districtId: '1902010',
    name: 'Simpang Rusa',
  },
  {
    id: '1902010009',
    districtId: '1902010',
    name: 'Bantan',
  },
  {
    id: '1902010010',
    districtId: '1902010',
    name: 'Pulau Sumedang',
  },
  {
    id: '1902010011',
    districtId: '1902010',
    name: 'Gunung Riting',
  },
  {
    id: '1902010012',
    districtId: '1902010',
    name: 'Padang Kandis',
  },
  {
    id: '1902060007',
    districtId: '1902060',
    name: 'Buluh Tumbang',
  },
  {
    id: '1902060008',
    districtId: '1902060',
    name: 'Perawas',
  },
  {
    id: '1902060009',
    districtId: '1902060',
    name: 'Lesung Batang',
  },
  {
    id: '1902060010',
    districtId: '1902060',
    name: 'Pangkallalang',
  },
  {
    id: '1902060011',
    districtId: '1902060',
    name: 'Dukong',
  },
  {
    id: '1902060012',
    districtId: '1902060',
    name: 'Juru Seberang',
  },
  {
    id: '1902060013',
    districtId: '1902060',
    name: 'Kota',
  },
  {
    id: '1902060014',
    districtId: '1902060',
    name: 'Parit',
  },
  {
    id: '1902060015',
    districtId: '1902060',
    name: 'Tanjung Pendam',
  },
  {
    id: '1902060016',
    districtId: '1902060',
    name: 'Air Saga',
  },
  {
    id: '1902060017',
    districtId: '1902060',
    name: 'Paal Satu',
  },
  {
    id: '1902060018',
    districtId: '1902060',
    name: 'Air Merbau',
  },
  {
    id: '1902060019',
    districtId: '1902060',
    name: 'Aik Ketekok',
  },
  {
    id: '1902060020',
    districtId: '1902060',
    name: 'Aik Rayak',
  },
  {
    id: '1902060021',
    districtId: '1902060',
    name: 'Aik Pelempang Jaya',
  },
  {
    id: '1902060022',
    districtId: '1902060',
    name: 'Kampong Damai',
  },
  {
    id: '1902061001',
    districtId: '1902061',
    name: 'Pegantungan',
  },
  {
    id: '1902061002',
    districtId: '1902061',
    name: 'Sungai Samak',
  },
  {
    id: '1902061004',
    districtId: '1902061',
    name: 'Badau',
  },
  {
    id: '1902061005',
    districtId: '1902061',
    name: 'Kacang Botor',
  },
  {
    id: '1902061006',
    districtId: '1902061',
    name: 'Air Batu Buding',
  },
  {
    id: '1902061007',
    districtId: '1902061',
    name: 'Ibul',
  },
  {
    id: '1902062001',
    districtId: '1902062',
    name: 'Batu Itam',
  },
  {
    id: '1902062002',
    districtId: '1902062',
    name: 'Terong',
  },
  {
    id: '1902062003',
    districtId: '1902062',
    name: 'Air Seru',
  },
  {
    id: '1902062004',
    districtId: '1902062',
    name: 'Air Selumar',
  },
  {
    id: '1902062005',
    districtId: '1902062',
    name: 'Tanjung Binga',
  },
  {
    id: '1902062006',
    districtId: '1902062',
    name: 'Keciput',
  },
  {
    id: '1902062007',
    districtId: '1902062',
    name: 'Sijuk',
  },
  {
    id: '1902062008',
    districtId: '1902062',
    name: 'Sungai Padang',
  },
  {
    id: '1902062009',
    districtId: '1902062',
    name: 'Tanjong Tinggi',
  },
  {
    id: '1902062010',
    districtId: '1902062',
    name: 'Pelepak  Pute',
  },
  {
    id: '1902063001',
    districtId: '1902063',
    name: 'Suak Gual',
  },
  {
    id: '1902063002',
    districtId: '1902063',
    name: 'Petaling',
  },
  {
    id: '1902063003',
    districtId: '1902063',
    name: 'Selat Nasik',
  },
  {
    id: '1902063004',
    districtId: '1902063',
    name: 'Pulau Gersik',
  },
  {
    id: '1903010010',
    districtId: '1903010',
    name: 'Kayuarang',
  },
  {
    id: '1903010011',
    districtId: '1903010',
    name: 'Mancung',
  },
  {
    id: '1903010012',
    districtId: '1903010',
    name: 'Sinar Sari',
  },
  {
    id: '1903010013',
    districtId: '1903010',
    name: 'Kelapa',
  },
  {
    id: '1903010014',
    districtId: '1903010',
    name: 'Beruas',
  },
  {
    id: '1903010016',
    districtId: '1903010',
    name: 'Tebing',
  },
  {
    id: '1903010017',
    districtId: '1903010',
    name: 'Air Bulin',
  },
  {
    id: '1903010018',
    districtId: '1903010',
    name: 'Dendang',
  },
  {
    id: '1903010019',
    districtId: '1903010',
    name: 'Kacung',
  },
  {
    id: '1903010020',
    districtId: '1903010',
    name: 'Terentang',
  },
  {
    id: '1903010021',
    districtId: '1903010',
    name: 'Tugang',
  },
  {
    id: '1903010022',
    districtId: '1903010',
    name: 'Tuik',
  },
  {
    id: '1903010023',
    districtId: '1903010',
    name: 'Pangkal Beras',
  },
  {
    id: '1903020001',
    districtId: '1903020',
    name: 'Tanjungniur',
  },
  {
    id: '1903020002',
    districtId: '1903020',
    name: 'Benteng Kuta',
  },
  {
    id: '1903020003',
    districtId: '1903020',
    name: 'Air Lintang',
  },
  {
    id: '1903020004',
    districtId: '1903020',
    name: 'Sinar Surya',
  },
  {
    id: '1903020005',
    districtId: '1903020',
    name: 'Tempilang',
  },
  {
    id: '1903020006',
    districtId: '1903020',
    name: 'Buyan Kelumbi',
  },
  {
    id: '1903020007',
    districtId: '1903020',
    name: 'Sangku',
  },
  {
    id: '1903020008',
    districtId: '1903020',
    name: 'Penyampak',
  },
  {
    id: '1903020009',
    districtId: '1903020',
    name: 'Simpang Yul',
  },
  {
    id: '1903030001',
    districtId: '1903030',
    name: 'Belolaut',
  },
  {
    id: '1903030004',
    districtId: '1903030',
    name: 'Air Belo',
  },
  {
    id: '1903030005',
    districtId: '1903030',
    name: 'Sungai Baru',
  },
  {
    id: '1903030006',
    districtId: '1903030',
    name: 'Sungai Daeng',
  },
  {
    id: '1903030007',
    districtId: '1903030',
    name: 'Tanjung',
  },
  {
    id: '1903030008',
    districtId: '1903030',
    name: 'Air Putih',
  },
  {
    id: '1903030009',
    districtId: '1903030',
    name: 'Airlimau',
  },
  {
    id: '1903040001',
    districtId: '1903040',
    name: 'Kundi',
  },
  {
    id: '1903040002',
    districtId: '1903040',
    name: 'Simpang Tiga',
  },
  {
    id: '1903040003',
    districtId: '1903040',
    name: 'Mayang',
  },
  {
    id: '1903040004',
    districtId: '1903040',
    name: 'Rambat',
  },
  {
    id: '1903040005',
    districtId: '1903040',
    name: 'Simpang Gong',
  },
  {
    id: '1903040006',
    districtId: '1903040',
    name: 'Pelangas',
  },
  {
    id: '1903040007',
    districtId: '1903040',
    name: 'Berang',
  },
  {
    id: '1903040008',
    districtId: '1903040',
    name: 'Ibul',
  },
  {
    id: '1903040009',
    districtId: '1903040',
    name: 'Peradong',
  },
  {
    id: '1903040010',
    districtId: '1903040',
    name: 'Air Nyatoh',
  },
  {
    id: '1903040011',
    districtId: '1903040',
    name: 'Pangek',
  },
  {
    id: '1903040012',
    districtId: '1903040',
    name: 'Air Menduyung',
  },
  {
    id: '1903040013',
    districtId: '1903040',
    name: 'Bukit Terak',
  },
  {
    id: '1903050002',
    districtId: '1903050',
    name: 'Tumbak Petar',
  },
  {
    id: '1903050003',
    districtId: '1903050',
    name: 'Limbung',
  },
  {
    id: '1903050004',
    districtId: '1903050',
    name: 'Rukam',
  },
  {
    id: '1903050009',
    districtId: '1903050',
    name: 'Ranggi/Asam',
  },
  {
    id: '1903050010',
    districtId: '1903050',
    name: 'Sungai Buluh',
  },
  {
    id: '1903050011',
    districtId: '1903050',
    name: 'Ketap',
  },
  {
    id: '1903050018',
    districtId: '1903050',
    name: 'Mislak',
  },
  {
    id: '1903050019',
    districtId: '1903050',
    name: 'Air Kuang',
  },
  {
    id: '1903050020',
    districtId: '1903050',
    name: 'Pebuar',
  },
  {
    id: '1903050021',
    districtId: '1903050',
    name: 'Sinar Manik',
  },
  {
    id: '1903051001',
    districtId: '1903051',
    name: 'Bakit',
  },
  {
    id: '1903051003',
    districtId: '1903051',
    name: 'Kapit',
  },
  {
    id: '1903051004',
    districtId: '1903051',
    name: 'Telak',
  },
  {
    id: '1903051005',
    districtId: '1903051',
    name: 'Sekar Biru',
  },
  {
    id: '1903051007',
    districtId: '1903051',
    name: 'Air Gantang',
  },
  {
    id: '1903051008',
    districtId: '1903051',
    name: 'Kelabat',
  },
  {
    id: '1903051009',
    districtId: '1903051',
    name: 'Cupat',
  },
  {
    id: '1903051010',
    districtId: '1903051',
    name: 'Teluk Limau',
  },
  {
    id: '1904010001',
    districtId: '1904010',
    name: 'Nibung',
  },
  {
    id: '1904010006',
    districtId: '1904010',
    name: 'Koba',
  },
  {
    id: '1904010007',
    districtId: '1904010',
    name: 'Arung Dalam',
  },
  {
    id: '1904010009',
    districtId: '1904010',
    name: 'Terentang Tiga',
  },
  {
    id: '1904010010',
    districtId: '1904010',
    name: 'Penyak',
  },
  {
    id: '1904010011',
    districtId: '1904010',
    name: 'Kurau',
  },
  {
    id: '1904010012',
    districtId: '1904010',
    name: 'Kurau Barat',
  },
  {
    id: '1904010013',
    districtId: '1904010',
    name: 'Simpang Perlang',
  },
  {
    id: '1904010014',
    districtId: '1904010',
    name: 'Padang Mulia',
  },
  {
    id: '1904010015',
    districtId: '1904010',
    name: 'Berok',
  },
  {
    id: '1904011002',
    districtId: '1904011',
    name: 'Kulur Ilir',
  },
  {
    id: '1904011004',
    districtId: '1904011',
    name: 'Perlang',
  },
  {
    id: '1904011005',
    districtId: '1904011',
    name: 'Lubuk Besar',
  },
  {
    id: '1904011006',
    districtId: '1904011',
    name: 'Lubuk Pabrik',
  },
  {
    id: '1904011007',
    districtId: '1904011',
    name: 'Lubuk Lingkuk',
  },
  {
    id: '1904011008',
    districtId: '1904011',
    name: 'Batu Beriga',
  },
  {
    id: '1904011009',
    districtId: '1904011',
    name: 'Belimbing',
  },
  {
    id: '1904020006',
    districtId: '1904020',
    name: 'Tanjung Gunung',
  },
  {
    id: '1904020008',
    districtId: '1904020',
    name: 'Airmesu',
  },
  {
    id: '1904020010',
    districtId: '1904020',
    name: 'Mangkol',
  },
  {
    id: '1904020012',
    districtId: '1904020',
    name: 'Padang Baru',
  },
  {
    id: '1904020015',
    districtId: '1904020',
    name: 'Batu Belubang',
  },
  {
    id: '1904020016',
    districtId: '1904020',
    name: 'Pedindang',
  },
  {
    id: '1904020017',
    districtId: '1904020',
    name: 'Airmesu Timur',
  },
  {
    id: '1904020018',
    districtId: '1904020',
    name: 'Kebintik',
  },
  {
    id: '1904021001',
    districtId: '1904021',
    name: 'Belilik',
  },
  {
    id: '1904021002',
    districtId: '1904021',
    name: 'Namang',
  },
  {
    id: '1904021004',
    districtId: '1904021',
    name: 'Cambai',
  },
  {
    id: '1904021005',
    districtId: '1904021',
    name: 'Kayu Besi',
  },
  {
    id: '1904021006',
    districtId: '1904021',
    name: 'Bukit Kijang',
  },
  {
    id: '1904021007',
    districtId: '1904021',
    name: 'Baskara Bakti',
  },
  {
    id: '1904021008',
    districtId: '1904021',
    name: 'Cambai Selatan',
  },
  {
    id: '1904030001',
    districtId: '1904030',
    name: 'Sungai Selan',
  },
  {
    id: '1904030002',
    districtId: '1904030',
    name: 'Lampur',
  },
  {
    id: '1904030003',
    districtId: '1904030',
    name: 'Kerantai',
  },
  {
    id: '1904030008',
    districtId: '1904030',
    name: 'Keretak',
  },
  {
    id: '1904030009',
    districtId: '1904030',
    name: 'Sarangmandi',
  },
  {
    id: '1904030011',
    districtId: '1904030',
    name: 'Kemingking',
  },
  {
    id: '1904030012',
    districtId: '1904030',
    name: 'Sungai Selan Atas',
  },
  {
    id: '1904030013',
    districtId: '1904030',
    name: 'Ramadhon',
  },
  {
    id: '1904030014',
    districtId: '1904030',
    name: 'Kerakas',
  },
  {
    id: '1904030015',
    districtId: '1904030',
    name: 'Tanjungpura',
  },
  {
    id: '1904030016',
    districtId: '1904030',
    name: 'Keretak Atas',
  },
  {
    id: '1904030017',
    districtId: '1904030',
    name: 'Melabun',
  },
  {
    id: '1904040001',
    districtId: '1904040',
    name: 'Sungkap',
  },
  {
    id: '1904040002',
    districtId: '1904040',
    name: 'Celuak',
  },
  {
    id: '1904040004',
    districtId: '1904040',
    name: 'Simpang Katis',
  },
  {
    id: '1904040006',
    districtId: '1904040',
    name: 'Beruas',
  },
  {
    id: '1904040007',
    districtId: '1904040',
    name: 'Terak',
  },
  {
    id: '1904040008',
    districtId: '1904040',
    name: 'Pasir Garam',
  },
  {
    id: '1904040009',
    districtId: '1904040',
    name: 'Pinang Sebatang',
  },
  {
    id: '1904040010',
    districtId: '1904040',
    name: 'Katis',
  },
  {
    id: '1905010006',
    districtId: '1905010',
    name: 'Irat',
  },
  {
    id: '1905010007',
    districtId: '1905010',
    name: 'Sengir',
  },
  {
    id: '1905010008',
    districtId: '1905010',
    name: 'Payung',
  },
  {
    id: '1905010009',
    districtId: '1905010',
    name: 'Nadung',
  },
  {
    id: '1905010010',
    districtId: '1905010',
    name: 'Ranggung',
  },
  {
    id: '1905010017',
    districtId: '1905010',
    name: 'Pangkalbuluh',
  },
  {
    id: '1905010018',
    districtId: '1905010',
    name: 'Malik',
  },
  {
    id: '1905010020',
    districtId: '1905010',
    name: 'Paku',
  },
  {
    id: '1905011001',
    districtId: '1905011',
    name: 'Batu Betumpang',
  },
  {
    id: '1905011002',
    districtId: '1905011',
    name: 'Panca Tunggal',
  },
  {
    id: '1905011003',
    districtId: '1905011',
    name: 'Fajar Indah',
  },
  {
    id: '1905011004',
    districtId: '1905011',
    name: 'Sukajaya',
  },
  {
    id: '1905011005',
    districtId: '1905011',
    name: 'Sumber Jaya Permai',
  },
  {
    id: '1905020001',
    districtId: '1905020',
    name: 'Jelutung II',
  },
  {
    id: '1905020002',
    districtId: '1905020',
    name: 'Gudang',
  },
  {
    id: '1905020003',
    districtId: '1905020',
    name: 'Sebagin',
  },
  {
    id: '1905020004',
    districtId: '1905020',
    name: 'Rajik',
  },
  {
    id: '1905020005',
    districtId: '1905020',
    name: 'Simpang Rimba',
  },
  {
    id: '1905020006',
    districtId: '1905020',
    name: 'Bangka Kota',
  },
  {
    id: '1905020007',
    districtId: '1905020',
    name: 'Permis',
  },
  {
    id: '1905030001',
    districtId: '1905030',
    name: 'Rias',
  },
  {
    id: '1905030002',
    districtId: '1905030',
    name: 'Teladan',
  },
  {
    id: '1905030003',
    districtId: '1905030',
    name: 'Tanjung Ketapang',
  },
  {
    id: '1905030004',
    districtId: '1905030',
    name: 'Toboali',
  },
  {
    id: '1905030008',
    districtId: '1905030',
    name: 'Kaposang',
  },
  {
    id: '1905030009',
    districtId: '1905030',
    name: 'Gadung',
  },
  {
    id: '1905030010',
    districtId: '1905030',
    name: 'Bikang',
  },
  {
    id: '1905030011',
    districtId: '1905030',
    name: 'Jeriji',
  },
  {
    id: '1905030012',
    districtId: '1905030',
    name: 'Serdang',
  },
  {
    id: '1905030013',
    districtId: '1905030',
    name: 'Rindik',
  },
  {
    id: '1905030014',
    districtId: '1905030',
    name: 'Kepoh',
  },
  {
    id: '1905031001',
    districtId: '1905031',
    name: 'Sadai',
  },
  {
    id: '1905031002',
    districtId: '1905031',
    name: 'Pasir Putih',
  },
  {
    id: '1905031003',
    districtId: '1905031',
    name: 'Tukak',
  },
  {
    id: '1905031004',
    districtId: '1905031',
    name: 'Tiram',
  },
  {
    id: '1905031005',
    districtId: '1905031',
    name: 'Bukit Terap',
  },
  {
    id: '1905040001',
    districtId: '1905040',
    name: 'Pergam',
  },
  {
    id: '1905040002',
    districtId: '1905040',
    name: 'Bencah',
  },
  {
    id: '1905040004',
    districtId: '1905040',
    name: 'Airgegas',
  },
  {
    id: '1905040005',
    districtId: '1905040',
    name: 'Delas',
  },
  {
    id: '1905040006',
    districtId: '1905040',
    name: 'Sidoharjo',
  },
  {
    id: '1905040007',
    districtId: '1905040',
    name: 'Nyelanding',
  },
  {
    id: '1905040008',
    districtId: '1905040',
    name: 'Nangka',
  },
  {
    id: '1905040009',
    districtId: '1905040',
    name: 'Ranggas',
  },
  {
    id: '1905040010',
    districtId: '1905040',
    name: 'Air Bara',
  },
  {
    id: '1905050002',
    districtId: '1905050',
    name: 'Tanjunglabu',
  },
  {
    id: '1905050004',
    districtId: '1905050',
    name: 'Tanjung Sangkar',
  },
  {
    id: '1905051001',
    districtId: '1905051',
    name: 'Celagen',
  },
  {
    id: '1905051002',
    districtId: '1905051',
    name: 'Pongok',
  },
  {
    id: '1906010004',
    districtId: '1906010',
    name: 'Dendang',
  },
  {
    id: '1906010005',
    districtId: '1906010',
    name: 'Jangkang',
  },
  {
    id: '1906010008',
    districtId: '1906010',
    name: 'Balok',
  },
  {
    id: '1906011001',
    districtId: '1906011',
    name: 'Tanjung Kelumpang',
  },
  {
    id: '1906011002',
    districtId: '1906011',
    name: 'Tanjung Batu Itam',
  },
  {
    id: '1906011003',
    districtId: '1906011',
    name: 'Dukong',
  },
  {
    id: '1906011004',
    districtId: '1906011',
    name: 'Simpang Pesak',
  },
  {
    id: '1906020001',
    districtId: '1906020',
    name: 'Lilangan',
  },
  {
    id: '1906020002',
    districtId: '1906020',
    name: 'Jangkar Asam',
  },
  {
    id: '1906020003',
    districtId: '1906020',
    name: 'Gantung',
  },
  {
    id: '1906020004',
    districtId: '1906020',
    name: 'Selingsing',
  },
  {
    id: '1906020008',
    districtId: '1906020',
    name: 'Limbongan',
  },
  {
    id: '1906020009',
    districtId: '1906020',
    name: 'Batu Penyu',
  },
  {
    id: '1906020010',
    districtId: '1906020',
    name: 'Lenggang',
  },
  {
    id: '1906021001',
    districtId: '1906021',
    name: 'Lintang',
  },
  {
    id: '1906021002',
    districtId: '1906021',
    name: 'Aik Madu',
  },
  {
    id: '1906021003',
    districtId: '1906021',
    name: 'Renggiang',
  },
  {
    id: '1906021004',
    districtId: '1906021',
    name: 'Simpang Tiga',
  },
  {
    id: '1906030001',
    districtId: '1906030',
    name: 'Kelubi',
  },
  {
    id: '1906030002',
    districtId: '1906030',
    name: 'Padang',
  },
  {
    id: '1906030003',
    districtId: '1906030',
    name: 'Lalang',
  },
  {
    id: '1906030004',
    districtId: '1906030',
    name: 'Lalang Jaya',
  },
  {
    id: '1906030005',
    districtId: '1906030',
    name: 'Kurnia Jaya',
  },
  {
    id: '1906030006',
    districtId: '1906030',
    name: 'Baru',
  },
  {
    id: '1906030010',
    districtId: '1906030',
    name: 'Buku Limau',
  },
  {
    id: '1906030011',
    districtId: '1906030',
    name: 'Bentaian Jaya',
  },
  {
    id: '1906030012',
    districtId: '1906030',
    name: 'Mekar Jaya',
  },
  {
    id: '1906031001',
    districtId: '1906031',
    name: 'Sukamandi',
  },
  {
    id: '1906031002',
    districtId: '1906031',
    name: 'Mengkubang',
  },
  {
    id: '1906031003',
    districtId: '1906031',
    name: 'Burung Mandi',
  },
  {
    id: '1906031004',
    districtId: '1906031',
    name: 'Mempaya',
  },
  {
    id: '1906031005',
    districtId: '1906031',
    name: 'Air Kelik',
  },
  {
    id: '1906040001',
    districtId: '1906040',
    name: 'Cendil',
  },
  {
    id: '1906040002',
    districtId: '1906040',
    name: 'Buding',
  },
  {
    id: '1906040003',
    districtId: '1906040',
    name: 'Mentawak',
  },
  {
    id: '1906040005',
    districtId: '1906040',
    name: 'Mayang',
  },
  {
    id: '1906040007',
    districtId: '1906040',
    name: 'Pembaharuan',
  },
  {
    id: '1971010001',
    districtId: '1971010',
    name: 'Asam',
  },
  {
    id: '1971010002',
    districtId: '1971010',
    name: 'Parit Lalang',
  },
  {
    id: '1971010004',
    districtId: '1971010',
    name: 'Bintang',
  },
  {
    id: '1971010009',
    districtId: '1971010',
    name: 'Melintang',
  },
  {
    id: '1971010010',
    districtId: '1971010',
    name: 'Keramat',
  },
  {
    id: '1971010013',
    districtId: '1971010',
    name: 'Masjid Jamik',
  },
  {
    id: '1971010015',
    districtId: '1971010',
    name: 'Pintu Air',
  },
  {
    id: '1971010016',
    districtId: '1971010',
    name: 'Gajah Mada',
  },
  {
    id: '1971020008',
    districtId: '1971020',
    name: 'Semabung Lama',
  },
  {
    id: '1971020009',
    districtId: '1971020',
    name: 'Bacang',
  },
  {
    id: '1971020010',
    districtId: '1971020',
    name: 'Air Itam',
  },
  {
    id: '1971020011',
    districtId: '1971020',
    name: 'Sinar Bulan',
  },
  {
    id: '1971020012',
    districtId: '1971020',
    name: 'Temberan',
  },
  {
    id: '1971020013',
    districtId: '1971020',
    name: 'Air Mawar',
  },
  {
    id: '1971020014',
    districtId: '1971020',
    name: 'Pasir Putih',
  },
  {
    id: '1971021001',
    districtId: '1971021',
    name: 'Sriwijaya',
  },
  {
    id: '1971021002',
    districtId: '1971021',
    name: 'Bukit Besar',
  },
  {
    id: '1971021003',
    districtId: '1971021',
    name: 'Batu Intan',
  },
  {
    id: '1971021004',
    districtId: '1971021',
    name: 'Semabung Baru',
  },
  {
    id: '1971021005',
    districtId: '1971021',
    name: 'Pasar Padi',
  },
  {
    id: '1971030006',
    districtId: '1971030',
    name: 'Ampui',
  },
  {
    id: '1971030009',
    districtId: '1971030',
    name: 'Lontong Pancur',
  },
  {
    id: '1971030010',
    districtId: '1971030',
    name: 'Pasir Garam',
  },
  {
    id: '1971030015',
    districtId: '1971030',
    name: 'Rejosari',
  },
  {
    id: '1971030016',
    districtId: '1971030',
    name: 'Ketapang',
  },
  {
    id: '1971031001',
    districtId: '1971031',
    name: 'Air Salemba',
  },
  {
    id: '1971031002',
    districtId: '1971031',
    name: 'Gabek Satu',
  },
  {
    id: '1971031003',
    districtId: '1971031',
    name: 'Gabek Dua',
  },
  {
    id: '1971031004',
    districtId: '1971031',
    name: 'Selindung Baru',
  },
  {
    id: '1971031005',
    districtId: '1971031',
    name: 'Selindung',
  },
  {
    id: '1971031006',
    districtId: '1971031',
    name: 'Jerambah Gantung',
  },
  {
    id: '1971040019',
    districtId: '1971040',
    name: 'Batin Tikal',
  },
  {
    id: '1971040020',
    districtId: '1971040',
    name: 'Rawa Bangun',
  },
  {
    id: '1971040021',
    districtId: '1971040',
    name: 'Gedung Nasional',
  },
  {
    id: '1971040022',
    districtId: '1971040',
    name: 'Opas Indah',
  },
  {
    id: '1971040023',
    districtId: '1971040',
    name: 'Kejaksaan',
  },
  {
    id: '1971041002',
    districtId: '1971041',
    name: 'Kacang Pedang',
  },
  {
    id: '1971041003',
    districtId: '1971041',
    name: 'Tuatunu Indah',
  },
  {
    id: '1971041004',
    districtId: '1971041',
    name: 'Bukit Merapin',
  },
  {
    id: '1971041005',
    districtId: '1971041',
    name: 'Bukit Sari',
  },
  {
    id: '1971041006',
    districtId: '1971041',
    name: 'Taman Bunga',
  },
  {
    id: '1971041007',
    districtId: '1971041',
    name: 'Air Kepala Tujuh',
  },
  {
    id: '2101010003',
    districtId: '2101010',
    name: 'Moro',
  },
  {
    id: '2101010004',
    districtId: '2101010',
    name: 'Pauh',
  },
  {
    id: '2101010005',
    districtId: '2101010',
    name: 'Sugie',
  },
  {
    id: '2101010006',
    districtId: '2101010',
    name: 'Keban',
  },
  {
    id: '2101010007',
    districtId: '2101010',
    name: 'Selat Mie',
  },
  {
    id: '2101010008',
    districtId: '2101010',
    name: 'Tanjung Pelanduk',
  },
  {
    id: '2101010009',
    districtId: '2101010',
    name: 'Jang',
  },
  {
    id: '2101010010',
    districtId: '2101010',
    name: 'Moro Timur',
  },
  {
    id: '2101010011',
    districtId: '2101010',
    name: 'Pulau Moro',
  },
  {
    id: '2101010012',
    districtId: '2101010',
    name: 'Niur Permai',
  },
  {
    id: '2101010013',
    districtId: '2101010',
    name: 'Rawa Jaya',
  },
  {
    id: '2101010014',
    districtId: '2101010',
    name: 'Buluh Patah',
  },
  {
    id: '2101011001',
    districtId: '2101011',
    name: 'Telaga Tujuh',
  },
  {
    id: '2101011002',
    districtId: '2101011',
    name: 'Sanglar',
  },
  {
    id: '2101011003',
    districtId: '2101011',
    name: 'Semembang',
  },
  {
    id: '2101011004',
    districtId: '2101011',
    name: 'Tanjung Kilang',
  },
  {
    id: '2101020001',
    districtId: '2101020',
    name: 'Tanjung Batu Barat',
  },
  {
    id: '2101020002',
    districtId: '2101020',
    name: 'Tanjung Batu Kota',
  },
  {
    id: '2101020004',
    districtId: '2101020',
    name: 'Sungai Sebesi',
  },
  {
    id: '2101020005',
    districtId: '2101020',
    name: 'Sungai Ungar',
  },
  {
    id: '2101020009',
    districtId: '2101020',
    name: 'Gading Sari',
  },
  {
    id: '2101021001',
    districtId: '2101021',
    name: 'Sungai Ungar Utara',
  },
  {
    id: '2101021005',
    districtId: '2101021',
    name: 'Tanjung Berlian Kota',
  },
  {
    id: '2101021006',
    districtId: '2101021',
    name: 'Teluk Radang',
  },
  {
    id: '2101021007',
    districtId: '2101021',
    name: 'Tanjung Berlian Barat',
  },
  {
    id: '2101021008',
    districtId: '2101021',
    name: 'Perayun',
  },
  {
    id: '2101022001',
    districtId: '2101022',
    name: 'Sawang',
  },
  {
    id: '2101022002',
    districtId: '2101022',
    name: 'Sawang Laut',
  },
  {
    id: '2101022004',
    districtId: '2101022',
    name: 'Sawang Selatan',
  },
  {
    id: '2101023003',
    districtId: '2101023',
    name: 'Alai',
  },
  {
    id: '2101023007',
    districtId: '2101023',
    name: 'Batu Limau',
  },
  {
    id: '2101023008',
    districtId: '2101023',
    name: 'Ngal',
  },
  {
    id: '2101023010',
    districtId: '2101023',
    name: 'Sungai Buluh',
  },
  {
    id: '2101024003',
    districtId: '2101024',
    name: 'Penarah',
  },
  {
    id: '2101024008',
    districtId: '2101024',
    name: 'Sungai Asam',
  },
  {
    id: '2101024009',
    districtId: '2101024',
    name: 'Degong',
  },
  {
    id: '2101024010',
    districtId: '2101024',
    name: 'Tebias',
  },
  {
    id: '2101030004',
    districtId: '2101030',
    name: 'Parit',
  },
  {
    id: '2101030005',
    districtId: '2101030',
    name: 'Tulang',
  },
  {
    id: '2101030006',
    districtId: '2101030',
    name: 'Tanjung Balai',
  },
  {
    id: '2101030007',
    districtId: '2101030',
    name: 'Teluk Air',
  },
  {
    id: '2101030008',
    districtId: '2101030',
    name: 'Sungai Lakam Timur',
  },
  {
    id: '2101030010',
    districtId: '2101030',
    name: 'Selat Mendaun',
  },
  {
    id: '2101030011',
    districtId: '2101030',
    name: 'Tanjung Balai Kota',
  },
  {
    id: '2101030012',
    districtId: '2101030',
    name: 'Sungai Lakam Barat',
  },
  {
    id: '2101031001',
    districtId: '2101031',
    name: 'Tanjung Hutan',
  },
  {
    id: '2101031003',
    districtId: '2101031',
    name: 'Lubuk Puding',
  },
  {
    id: '2101031004',
    districtId: '2101031',
    name: 'Tanjung Batu Kecil',
  },
  {
    id: '2101032001',
    districtId: '2101032',
    name: 'Meral Kota',
  },
  {
    id: '2101032002',
    districtId: '2101032',
    name: 'Baran Barat',
  },
  {
    id: '2101032003',
    districtId: '2101032',
    name: 'Sungai Raya',
  },
  {
    id: '2101032006',
    districtId: '2101032',
    name: 'Sungai Pasir',
  },
  {
    id: '2101032007',
    districtId: '2101032',
    name: 'Baran Timur',
  },
  {
    id: '2101032008',
    districtId: '2101032',
    name: 'Parit Benut',
  },
  {
    id: '2101033001',
    districtId: '2101033',
    name: 'Tebing',
  },
  {
    id: '2101033002',
    districtId: '2101033',
    name: 'Teluk Uma',
  },
  {
    id: '2101033004',
    districtId: '2101033',
    name: 'Kapling',
  },
  {
    id: '2101033005',
    districtId: '2101033',
    name: 'Pamak',
  },
  {
    id: '2101033006',
    districtId: '2101033',
    name: 'Harjosari',
  },
  {
    id: '2101033008',
    districtId: '2101033',
    name: 'Pongkar',
  },
  {
    id: '2101034004',
    districtId: '2101034',
    name: 'Pasir Panjang',
  },
  {
    id: '2101034005',
    districtId: '2101034',
    name: 'Pangke',
  },
  {
    id: '2101034007',
    districtId: '2101034',
    name: 'Darusalam',
  },
  {
    id: '2101034009',
    districtId: '2101034',
    name: 'Pangke Barat',
  },
  {
    id: '2102040001',
    districtId: '2102040',
    name: 'Pangkil',
  },
  {
    id: '2102040002',
    districtId: '2102040',
    name: 'Pengujan',
  },
  {
    id: '2102040003',
    districtId: '2102040',
    name: 'Penaga',
  },
  {
    id: '2102040004',
    districtId: '2102040',
    name: 'Tembeling',
  },
  {
    id: '2102040005',
    districtId: '2102040',
    name: 'Bintan Buyu',
  },
  {
    id: '2102040006',
    districtId: '2102040',
    name: 'Tembeling Tanjung',
  },
  {
    id: '2102050003',
    districtId: '2102050',
    name: 'Lancang Kuning',
  },
  {
    id: '2102050004',
    districtId: '2102050',
    name: 'Tanjung Uban Selatan',
  },
  {
    id: '2102050005',
    districtId: '2102050',
    name: 'Tanjung Uban Kota',
  },
  {
    id: '2102050006',
    districtId: '2102050',
    name: 'Tanjung Uban Utara',
  },
  {
    id: '2102050009',
    districtId: '2102050',
    name: 'Tanjung Uban Timur',
  },
  {
    id: '2102051001',
    districtId: '2102051',
    name: 'Sebong Pereh',
  },
  {
    id: '2102051002',
    districtId: '2102051',
    name: 'Sebong Lagoi',
  },
  {
    id: '2102051003',
    districtId: '2102051',
    name: 'Ekang Anculai',
  },
  {
    id: '2102051004',
    districtId: '2102051',
    name: 'Sri Bintan',
  },
  {
    id: '2102051005',
    districtId: '2102051',
    name: 'Pengudang',
  },
  {
    id: '2102051006',
    districtId: '2102051',
    name: 'Berakit',
  },
  {
    id: '2102051007',
    districtId: '2102051',
    name: 'Kota Baru',
  },
  {
    id: '2102052001',
    districtId: '2102052',
    name: 'Kuala Sempang',
  },
  {
    id: '2102052003',
    districtId: '2102052',
    name: 'Teluk Sasah',
  },
  {
    id: '2102052004',
    districtId: '2102052',
    name: 'Teluk Lobam',
  },
  {
    id: '2102052005',
    districtId: '2102052',
    name: 'Tanjung Permai',
  },
  {
    id: '2102060005',
    districtId: '2102060',
    name: 'Kijang Kota',
  },
  {
    id: '2102060006',
    districtId: '2102060',
    name: 'Sungai Enam',
  },
  {
    id: '2102060007',
    districtId: '2102060',
    name: 'Gunung Lengkuas',
  },
  {
    id: '2102060008',
    districtId: '2102060',
    name: 'Sungai Lekop',
  },
  {
    id: '2102061001',
    districtId: '2102061',
    name: 'Gunung Kijang',
  },
  {
    id: '2102061003',
    districtId: '2102061',
    name: 'Kawal',
  },
  {
    id: '2102061004',
    districtId: '2102061',
    name: 'Teluk Bakau',
  },
  {
    id: '2102061005',
    districtId: '2102061',
    name: 'Malang Rapat',
  },
  {
    id: '2102062001',
    districtId: '2102062',
    name: 'Mantang Lama',
  },
  {
    id: '2102062002',
    districtId: '2102062',
    name: 'Mantang Besar',
  },
  {
    id: '2102062003',
    districtId: '2102062',
    name: 'Mantang Baru',
  },
  {
    id: '2102063001',
    districtId: '2102063',
    name: 'Mapur',
  },
  {
    id: '2102063002',
    districtId: '2102063',
    name: 'Numbing',
  },
  {
    id: '2102063003',
    districtId: '2102063',
    name: 'Kelong',
  },
  {
    id: '2102063004',
    districtId: '2102063',
    name: 'Air Glubi',
  },
  {
    id: '2102064001',
    districtId: '2102064',
    name: 'Toapaya Utara',
  },
  {
    id: '2102064002',
    districtId: '2102064',
    name: 'Toapaya',
  },
  {
    id: '2102064003',
    districtId: '2102064',
    name: 'Toapaya Asri',
  },
  {
    id: '2102064004',
    districtId: '2102064',
    name: 'Toapaya Selatan',
  },
  {
    id: '2102070001',
    districtId: '2102070',
    name: 'Pulau Pinang',
  },
  {
    id: '2102070002',
    districtId: '2102070',
    name: 'Pulau Mentebung',
  },
  {
    id: '2102070003',
    districtId: '2102070',
    name: 'Kampung Melayu',
  },
  {
    id: '2102070004',
    districtId: '2102070',
    name: 'Kampung Hilir',
  },
  {
    id: '2102070005',
    districtId: '2102070',
    name: 'Teluk Sekuni',
  },
  {
    id: '2102070006',
    districtId: '2102070',
    name: 'Batu Lepuk',
  },
  {
    id: '2102070008',
    districtId: '2102070',
    name: 'Pengikik',
  },
  {
    id: '2103030001',
    districtId: '2103030',
    name: 'Sebelat',
  },
  {
    id: '2103030003',
    districtId: '2103030',
    name: 'Sabang Barat',
  },
  {
    id: '2103030005',
    districtId: '2103030',
    name: 'Air Putih',
  },
  {
    id: '2103031001',
    districtId: '2103031',
    name: 'Batu Belanak',
  },
  {
    id: '2103031002',
    districtId: '2103031',
    name: 'Gunung Jambat',
  },
  {
    id: '2103031003',
    districtId: '2103031',
    name: 'Air Kumpai',
  },
  {
    id: '2103040008',
    districtId: '2103040',
    name: 'Sedanau',
  },
  {
    id: '2103040014',
    districtId: '2103040',
    name: 'Mekar Jaya',
  },
  {
    id: '2103040015',
    districtId: '2103040',
    name: 'Binjai',
  },
  {
    id: '2103040016',
    districtId: '2103040',
    name: 'Pian Tengah',
  },
  {
    id: '2103040018',
    districtId: '2103040',
    name: 'Selaut',
  },
  {
    id: '2103041001',
    districtId: '2103041',
    name: 'Kelarik Barat',
  },
  {
    id: '2103041002',
    districtId: '2103041',
    name: 'Kelarik',
  },
  {
    id: '2103041003',
    districtId: '2103041',
    name: 'Kelarik Utara',
  },
  {
    id: '2103041004',
    districtId: '2103041',
    name: 'Kelarik Air Mali',
  },
  {
    id: '2103041005',
    districtId: '2103041',
    name: 'Teluk Buton',
  },
  {
    id: '2103041006',
    districtId: '2103041',
    name: 'Belakang Gunung',
  },
  {
    id: '2103041007',
    districtId: '2103041',
    name: 'Seluan Barat',
  },
  {
    id: '2103041008',
    districtId: '2103041',
    name: 'Gunung Durian',
  },
  {
    id: '2103042001',
    districtId: '2103042',
    name: 'Air Payang',
  },
  {
    id: '2103042002',
    districtId: '2103042',
    name: 'Tanjung Pala',
  },
  {
    id: '2103042003',
    districtId: '2103042',
    name: 'Kadur',
  },
  {
    id: '2103043001',
    districtId: '2103043',
    name: 'Sededap',
  },
  {
    id: '2103043002',
    districtId: '2103043',
    name: 'Sabang Mawang',
  },
  {
    id: '2103043004',
    districtId: '2103043',
    name: 'Tanjung Batang',
  },
  {
    id: '2103043005',
    districtId: '2103043',
    name: 'Serantas',
  },
  {
    id: '2103043006',
    districtId: '2103043',
    name: 'Sabang Mawang Barat',
  },
  {
    id: '2103043010',
    districtId: '2103043',
    name: 'Teluk Labuh',
  },
  {
    id: '2103044001',
    districtId: '2103044',
    name: 'Sedanau Timur',
  },
  {
    id: '2103044002',
    districtId: '2103044',
    name: 'Sedarat Baru',
  },
  {
    id: '2103044003',
    districtId: '2103044',
    name: 'Batubi Jaya',
  },
  {
    id: '2103044004',
    districtId: '2103044',
    name: 'Gunung Putri',
  },
  {
    id: '2103044005',
    districtId: '2103044',
    name: 'Semedang',
  },
  {
    id: '2103045001',
    districtId: '2103045',
    name: 'Pulau Tiga',
  },
  {
    id: '2103045002',
    districtId: '2103045',
    name: 'Tanjung Kumbik Utara',
  },
  {
    id: '2103045004',
    districtId: '2103045',
    name: 'Selading',
  },
  {
    id: '2103050002',
    districtId: '2103050',
    name: 'Sungai Ulu',
  },
  {
    id: '2103050003',
    districtId: '2103050',
    name: 'Ranai',
  },
  {
    id: '2103050008',
    districtId: '2103050',
    name: 'Sepempang',
  },
  {
    id: '2103050014',
    districtId: '2103050',
    name: 'Batu Gajah',
  },
  {
    id: '2103050015',
    districtId: '2103050',
    name: 'Ranai Darat',
  },
  {
    id: '2103050016',
    districtId: '2103050',
    name: 'Bandarsyah',
  },
  {
    id: '2103051002',
    districtId: '2103051',
    name: 'Tanjung',
  },
  {
    id: '2103051003',
    districtId: '2103051',
    name: 'Kelanga',
  },
  {
    id: '2103051004',
    districtId: '2103051',
    name: 'Pengadah',
  },
  {
    id: '2103051005',
    districtId: '2103051',
    name: 'Sebadai Hulu',
  },
  {
    id: '2103051006',
    districtId: '2103051',
    name: 'Limau Manis',
  },
  {
    id: '2103051007',
    districtId: '2103051',
    name: 'Selemam',
  },
  {
    id: '2103052001',
    districtId: '2103052',
    name: 'Harapan Jaya',
  },
  {
    id: '2103052002',
    districtId: '2103052',
    name: 'Tapau',
  },
  {
    id: '2103052003',
    districtId: '2103052',
    name: 'Air Lengit',
  },
  {
    id: '2103053001',
    districtId: '2103053',
    name: 'Cemaga',
  },
  {
    id: '2103053002',
    districtId: '2103053',
    name: 'Cemaga Utara',
  },
  {
    id: '2103053003',
    districtId: '2103053',
    name: 'Cemaga Selatan',
  },
  {
    id: '2103053004',
    districtId: '2103053',
    name: 'Cemaga Tengah',
  },
  {
    id: '2103060001',
    districtId: '2103060',
    name: 'Kampung Hilir',
  },
  {
    id: '2103060002',
    districtId: '2103060',
    name: 'Serasan',
  },
  {
    id: '2103060005',
    districtId: '2103060',
    name: 'Batu Berian',
  },
  {
    id: '2103060006',
    districtId: '2103060',
    name: 'Tanjung Setelung',
  },
  {
    id: '2103060007',
    districtId: '2103060',
    name: 'Tanjung Balau',
  },
  {
    id: '2103060008',
    districtId: '2103060',
    name: 'Pangkalan',
  },
  {
    id: '2103060009',
    districtId: '2103060',
    name: 'Jermalik',
  },
  {
    id: '2103061001',
    districtId: '2103061',
    name: 'Pulau Panjang',
  },
  {
    id: '2103061002',
    districtId: '2103061',
    name: 'Subi Besar',
  },
  {
    id: '2103061003',
    districtId: '2103061',
    name: 'Subi',
  },
  {
    id: '2103061004',
    districtId: '2103061',
    name: 'Meliah',
  },
  {
    id: '2103061005',
    districtId: '2103061',
    name: 'Terayak',
  },
  {
    id: '2103061006',
    districtId: '2103061',
    name: 'Kerdau',
  },
  {
    id: '2103061007',
    districtId: '2103061',
    name: 'Subi Besar Timur',
  },
  {
    id: '2103061008',
    districtId: '2103061',
    name: 'Meliah Selatan',
  },
  {
    id: '2103062001',
    districtId: '2103062',
    name: 'Arung Ayam',
  },
  {
    id: '2103062002',
    districtId: '2103062',
    name: 'Air Nusa',
  },
  {
    id: '2103062003',
    districtId: '2103062',
    name: 'Air Ringau',
  },
  {
    id: '2103062004',
    districtId: '2103062',
    name: 'Payak',
  },
  {
    id: '2104010001',
    districtId: '2104010',
    name: 'Marok Tua',
  },
  {
    id: '2104010002',
    districtId: '2104010',
    name: 'Sungai Buluh',
  },
  {
    id: '2104010003',
    districtId: '2104010',
    name: 'Kuala Raya',
  },
  {
    id: '2104010004',
    districtId: '2104010',
    name: 'Bakong',
  },
  {
    id: '2104010006',
    districtId: '2104010',
    name: 'Sungai Harapan',
  },
  {
    id: '2104010007',
    districtId: '2104010',
    name: 'Jagoh',
  },
  {
    id: '2104010008',
    districtId: '2104010',
    name: 'Sungai Raya',
  },
  {
    id: '2104010009',
    districtId: '2104010',
    name: 'Raya',
  },
  {
    id: '2104010010',
    districtId: '2104010',
    name: 'Bukit Belah',
  },
  {
    id: '2104010011',
    districtId: '2104010',
    name: 'Tanjung Irat',
  },
  {
    id: '2104010012',
    districtId: '2104010',
    name: 'Langkap',
  },
  {
    id: '2104010013',
    districtId: '2104010',
    name: 'Tinjul',
  },
  {
    id: '2104011001',
    districtId: '2104011',
    name: 'Posek',
  },
  {
    id: '2104011002',
    districtId: '2104011',
    name: 'Suak Buaya',
  },
  {
    id: '2104011003',
    districtId: '2104011',
    name: 'Busung Panjang',
  },
  {
    id: '2104020003',
    districtId: '2104020',
    name: 'Dabo',
  },
  {
    id: '2104020008',
    districtId: '2104020',
    name: 'Batu Berdaun',
  },
  {
    id: '2104020009',
    districtId: '2104020',
    name: 'Dabo Lama',
  },
  {
    id: '2104020010',
    districtId: '2104020',
    name: 'Batu Kacang',
  },
  {
    id: '2104020011',
    districtId: '2104020',
    name: 'Tanjung Harapan',
  },
  {
    id: '2104020012',
    districtId: '2104020',
    name: 'Sungai Lumpur',
  },
  {
    id: '2104021001',
    districtId: '2104021',
    name: 'Berhala',
  },
  {
    id: '2104021002',
    districtId: '2104021',
    name: 'Marok Kecil',
  },
  {
    id: '2104021003',
    districtId: '2104021',
    name: 'Resang',
  },
  {
    id: '2104022001',
    districtId: '2104022',
    name: 'Berindat',
  },
  {
    id: '2104022002',
    districtId: '2104022',
    name: 'Persing',
  },
  {
    id: '2104022003',
    districtId: '2104022',
    name: 'Sedamai',
  },
  {
    id: '2104022004',
    districtId: '2104022',
    name: 'Lanjut',
  },
  {
    id: '2104022005',
    districtId: '2104022',
    name: 'Kote',
  },
  {
    id: '2104022006',
    districtId: '2104022',
    name: 'Pelakak',
  },
  {
    id: '2104030001',
    districtId: '2104030',
    name: 'Pekajang',
  },
  {
    id: '2104030005',
    districtId: '2104030',
    name: 'Mepar',
  },
  {
    id: '2104030006',
    districtId: '2104030',
    name: 'Kelombok',
  },
  {
    id: '2104030007',
    districtId: '2104030',
    name: 'Merawang',
  },
  {
    id: '2104030008',
    districtId: '2104030',
    name: 'Daik',
  },
  {
    id: '2104030009',
    districtId: '2104030',
    name: 'Panggak Darat',
  },
  {
    id: '2104030010',
    districtId: '2104030',
    name: 'Panggak Laut',
  },
  {
    id: '2104030011',
    districtId: '2104030',
    name: 'Musai',
  },
  {
    id: '2104030016',
    districtId: '2104030',
    name: 'Mentuda',
  },
  {
    id: '2104031001',
    districtId: '2104031',
    name: 'Selayar',
  },
  {
    id: '2104031002',
    districtId: '2104031',
    name: 'Penuba',
  },
  {
    id: '2104031003',
    districtId: '2104031',
    name: 'Pantai Harapan',
  },
  {
    id: '2104031004',
    districtId: '2104031',
    name: 'Penuba Timur',
  },
  {
    id: '2104032001',
    districtId: '2104032',
    name: 'Bukit Langkap',
  },
  {
    id: '2104032002',
    districtId: '2104032',
    name: 'Kerandin',
  },
  {
    id: '2104032003',
    districtId: '2104032',
    name: 'Pekaka',
  },
  {
    id: '2104032004',
    districtId: '2104032',
    name: 'Keton',
  },
  {
    id: '2104032005',
    districtId: '2104032',
    name: 'Sungai Pinang',
  },
  {
    id: '2104040001',
    districtId: '2104040',
    name: 'Sekanah',
  },
  {
    id: '2104040002',
    districtId: '2104040',
    name: 'Duara',
  },
  {
    id: '2104040004',
    districtId: '2104040',
    name: 'Limbung',
  },
  {
    id: '2104040005',
    districtId: '2104040',
    name: 'Bukit Harapan',
  },
  {
    id: '2104040007',
    districtId: '2104040',
    name: 'Linau',
  },
  {
    id: '2104040008',
    districtId: '2104040',
    name: 'Pancur',
  },
  {
    id: '2104040009',
    districtId: '2104040',
    name: 'Rantau Panjang',
  },
  {
    id: '2104040010',
    districtId: '2104040',
    name: 'Sungai Besar',
  },
  {
    id: '2104040011',
    districtId: '2104040',
    name: 'Resun Pesisir',
  },
  {
    id: '2104050001',
    districtId: '2104050',
    name: 'Mamut',
  },
  {
    id: '2104050002',
    districtId: '2104050',
    name: 'Senayang',
  },
  {
    id: '2104050003',
    districtId: '2104050',
    name: 'Rejai',
  },
  {
    id: '2104050004',
    districtId: '2104050',
    name: 'Pasir Panjang',
  },
  {
    id: '2104050005',
    districtId: '2104050',
    name: 'Temiang',
  },
  {
    id: '2104050006',
    districtId: '2104050',
    name: 'Pulau Medang',
  },
  {
    id: '2104050007',
    districtId: '2104050',
    name: 'Tanjung Kelit',
  },
  {
    id: '2104050008',
    districtId: '2104050',
    name: 'Batu Belubang',
  },
  {
    id: '2104050009',
    districtId: '2104050',
    name: 'Pulau Batang',
  },
  {
    id: '2104050010',
    districtId: '2104050',
    name: 'Mensanak',
  },
  {
    id: '2104050011',
    districtId: '2104050',
    name: 'Benan',
  },
  {
    id: '2104050012',
    districtId: '2104050',
    name: 'Tanjung Lipat',
  },
  {
    id: '2104050013',
    districtId: '2104050',
    name: 'Penaah',
  },
  {
    id: '2104050014',
    districtId: '2104050',
    name: 'Laboh',
  },
  {
    id: '2104050015',
    districtId: '2104050',
    name: 'Baran',
  },
  {
    id: '2104050016',
    districtId: '2104050',
    name: 'Cempa',
  },
  {
    id: '2104050017',
    districtId: '2104050',
    name: 'Tajur Biru',
  },
  {
    id: '2104050018',
    districtId: '2104050',
    name: 'Pulau Duyung',
  },
  {
    id: '2104050019',
    districtId: '2104050',
    name: 'Pulau Bukit',
  },
  {
    id: '2105010004',
    districtId: '2105010',
    name: 'Mampok',
  },
  {
    id: '2105010006',
    districtId: '2105010',
    name: 'Rewak',
  },
  {
    id: '2105010007',
    districtId: '2105010',
    name: 'Keramut',
  },
  {
    id: '2105010008',
    districtId: '2105010',
    name: 'Impol',
  },
  {
    id: '2105010009',
    districtId: '2105010',
    name: 'Air Biru',
  },
  {
    id: '2105010010',
    districtId: '2105010',
    name: 'Sunggak',
  },
  {
    id: '2105010011',
    districtId: '2105010',
    name: 'Batu Berapit',
  },
  {
    id: '2105010012',
    districtId: '2105010',
    name: 'Landak',
  },
  {
    id: '2105020001',
    districtId: '2105020',
    name: 'Ulu Maras',
  },
  {
    id: '2105020002',
    districtId: '2105020',
    name: 'Kuala Maras',
  },
  {
    id: '2105020003',
    districtId: '2105020',
    name: 'Bukit Padi',
  },
  {
    id: '2105020004',
    districtId: '2105020',
    name: 'Genting Pulur',
  },
  {
    id: '2105030001',
    districtId: '2105030',
    name: 'Kiabu',
  },
  {
    id: '2105030002',
    districtId: '2105030',
    name: 'Telaga',
  },
  {
    id: '2105030003',
    districtId: '2105030',
    name: 'Mengkait',
  },
  {
    id: '2105030004',
    districtId: '2105030',
    name: 'Tiangau',
  },
  {
    id: '2105030005',
    districtId: '2105030',
    name: 'Telaga Kecil',
  },
  {
    id: '2105030006',
    districtId: '2105030',
    name: 'Lingai',
  },
  {
    id: '2105030007',
    districtId: '2105030',
    name: 'Air Bini',
  },
  {
    id: '2105040003',
    districtId: '2105040',
    name: 'Tarempa Barat',
  },
  {
    id: '2105040004',
    districtId: '2105040',
    name: 'Tarempa',
  },
  {
    id: '2105040005',
    districtId: '2105040',
    name: 'Tarempa Selatan',
  },
  {
    id: '2105040006',
    districtId: '2105040',
    name: 'Tarempa Timur',
  },
  {
    id: '2105040007',
    districtId: '2105040',
    name: 'Sri Tanjung',
  },
  {
    id: '2105040008',
    districtId: '2105040',
    name: 'Tarempa Barat Daya',
  },
  {
    id: '2105040009',
    districtId: '2105040',
    name: 'Pesisir Timur',
  },
  {
    id: '2105050001',
    districtId: '2105050',
    name: 'Nyamuk',
  },
  {
    id: '2105050002',
    districtId: '2105050',
    name: 'Batu Belah',
  },
  {
    id: '2105050003',
    districtId: '2105050',
    name: 'Munjan',
  },
  {
    id: '2105050004',
    districtId: '2105050',
    name: 'Serat',
  },
  {
    id: '2105050005',
    districtId: '2105050',
    name: 'Air Putih',
  },
  {
    id: '2105060001',
    districtId: '2105060',
    name: 'Air Asuk',
  },
  {
    id: '2105060002',
    districtId: '2105060',
    name: 'Air Sena',
  },
  {
    id: '2105060003',
    districtId: '2105060',
    name: 'Teluk Siantan',
  },
  {
    id: '2105060004',
    districtId: '2105060',
    name: 'Liuk',
  },
  {
    id: '2105060005',
    districtId: '2105060',
    name: 'Lidi',
  },
  {
    id: '2105060006',
    districtId: '2105060',
    name: 'Teluk Sunting',
  },
  {
    id: '2105070002',
    districtId: '2105070',
    name: 'Tebang',
  },
  {
    id: '2105070003',
    districtId: '2105070',
    name: 'Ladan',
  },
  {
    id: '2105070005',
    districtId: '2105070',
    name: 'Payalaman',
  },
  {
    id: '2105070008',
    districtId: '2105070',
    name: 'Putik',
  },
  {
    id: '2105070009',
    districtId: '2105070',
    name: 'Bayat',
  },
  {
    id: '2105070010',
    districtId: '2105070',
    name: 'Piabung',
  },
  {
    id: '2105070011',
    districtId: '2105070',
    name: 'Langir',
  },
  {
    id: '2105070012',
    districtId: '2105070',
    name: 'Candi',
  },
  {
    id: '2105070013',
    districtId: '2105070',
    name: 'Piasan',
  },
  {
    id: '2105070014',
    districtId: '2105070',
    name: 'Belibak',
  },
  {
    id: '2105070015',
    districtId: '2105070',
    name: 'Teluk Bayur',
  },
  {
    id: '2105070016',
    districtId: '2105070',
    name: 'Matak',
  },
  {
    id: '2105070017',
    districtId: '2105070',
    name: 'Payamaram',
  },
  {
    id: '2105070018',
    districtId: '2105070',
    name: 'Batu Ampar',
  },
  {
    id: '2171010001',
    districtId: '2171010',
    name: 'Pulau Terong',
  },
  {
    id: '2171010002',
    districtId: '2171010',
    name: 'Pecong',
  },
  {
    id: '2171010003',
    districtId: '2171010',
    name: 'Kasu',
  },
  {
    id: '2171010004',
    districtId: '2171010',
    name: 'Pemping',
  },
  {
    id: '2171010006',
    districtId: '2171010',
    name: 'Tanjung Sari',
  },
  {
    id: '2171010007',
    districtId: '2171010',
    name: 'Sekanak Raya',
  },
  {
    id: '2171020001',
    districtId: '2171020',
    name: 'Pantai Gelam',
  },
  {
    id: '2171020002',
    districtId: '2171020',
    name: 'Temoyong',
  },
  {
    id: '2171020003',
    districtId: '2171020',
    name: 'Pulau Setokok',
  },
  {
    id: '2171020004',
    districtId: '2171020',
    name: 'Batu Legong',
  },
  {
    id: '2171020005',
    districtId: '2171020',
    name: 'Bulang Lintang',
  },
  {
    id: '2171020006',
    districtId: '2171020',
    name: 'Pulau Buluh',
  },
  {
    id: '2171030001',
    districtId: '2171030',
    name: 'Pulau Abang',
  },
  {
    id: '2171030002',
    districtId: '2171030',
    name: 'Karas',
  },
  {
    id: '2171030003',
    districtId: '2171030',
    name: 'Sijantung',
  },
  {
    id: '2171030004',
    districtId: '2171030',
    name: 'Sembulang',
  },
  {
    id: '2171030005',
    districtId: '2171030',
    name: 'Rempang Cate',
  },
  {
    id: '2171030006',
    districtId: '2171030',
    name: 'Subang Mas',
  },
  {
    id: '2171030007',
    districtId: '2171030',
    name: 'Galang Baru',
  },
  {
    id: '2171030008',
    districtId: '2171030',
    name: 'Air Raja',
  },
  {
    id: '2171040003',
    districtId: '2171040',
    name: 'Tanjung Piayu',
  },
  {
    id: '2171040004',
    districtId: '2171040',
    name: 'Muka Kuning',
  },
  {
    id: '2171040005',
    districtId: '2171040',
    name: 'Duriangkang',
  },
  {
    id: '2171040006',
    districtId: '2171040',
    name: 'Mangsang',
  },
  {
    id: '2171041001',
    districtId: '2171041',
    name: 'Tembesi',
  },
  {
    id: '2171041002',
    districtId: '2171041',
    name: 'Sungai Binti',
  },
  {
    id: '2171041003',
    districtId: '2171041',
    name: 'Sungai Lekop',
  },
  {
    id: '2171041004',
    districtId: '2171041',
    name: 'Sagulung Kota',
  },
  {
    id: '2171041005',
    districtId: '2171041',
    name: 'Sungai Langkai',
  },
  {
    id: '2171041006',
    districtId: '2171041',
    name: 'Sungai Pelunggut',
  },
  {
    id: '2171050001',
    districtId: '2171050',
    name: 'Ngenang',
  },
  {
    id: '2171050002',
    districtId: '2171050',
    name: 'Kabil',
  },
  {
    id: '2171050003',
    districtId: '2171050',
    name: 'Batu Besar',
  },
  {
    id: '2171050008',
    districtId: '2171050',
    name: 'Sambau',
  },
  {
    id: '2171051001',
    districtId: '2171051',
    name: 'Taman Baloi',
  },
  {
    id: '2171051002',
    districtId: '2171051',
    name: 'Baloi Permai',
  },
  {
    id: '2171051003',
    districtId: '2171051',
    name: 'Belian',
  },
  {
    id: '2171051004',
    districtId: '2171051',
    name: 'Teluk Tering',
  },
  {
    id: '2171051005',
    districtId: '2171051',
    name: 'Sungai Panas',
  },
  {
    id: '2171051006',
    districtId: '2171051',
    name: 'Sukajadi',
  },
  {
    id: '2171060002',
    districtId: '2171060',
    name: 'Tanjung Riau',
  },
  {
    id: '2171060003',
    districtId: '2171060',
    name: 'Tiban Baru',
  },
  {
    id: '2171060004',
    districtId: '2171060',
    name: 'Tiban Lama',
  },
  {
    id: '2171060005',
    districtId: '2171060',
    name: 'Tiban Indah',
  },
  {
    id: '2171060006',
    districtId: '2171060',
    name: 'Patam Lestari',
  },
  {
    id: '2171060007',
    districtId: '2171060',
    name: 'Sungai Harapan',
  },
  {
    id: '2171060008',
    districtId: '2171060',
    name: 'Tanjung Pinggir',
  },
  {
    id: '2171061001',
    districtId: '2171061',
    name: 'Tanjung Uncang',
  },
  {
    id: '2171061002',
    districtId: '2171061',
    name: 'Bukit Tempayan',
  },
  {
    id: '2171061003',
    districtId: '2171061',
    name: 'Buliang',
  },
  {
    id: '2171061004',
    districtId: '2171061',
    name: 'Kibing',
  },
  {
    id: '2171070001',
    districtId: '2171070',
    name: 'Baloi Indah',
  },
  {
    id: '2171070002',
    districtId: '2171070',
    name: 'Batu Selicin',
  },
  {
    id: '2171070003',
    districtId: '2171070',
    name: 'Kampung Pelita',
  },
  {
    id: '2171070004',
    districtId: '2171070',
    name: 'Lubuk Baja Kota',
  },
  {
    id: '2171070005',
    districtId: '2171070',
    name: 'Tanjung Uma',
  },
  {
    id: '2171080004',
    districtId: '2171080',
    name: 'Kampung Seraya',
  },
  {
    id: '2171080005',
    districtId: '2171080',
    name: 'Sungai Jodoh',
  },
  {
    id: '2171080007',
    districtId: '2171080',
    name: 'Tanjung Sengkuang',
  },
  {
    id: '2171080008',
    districtId: '2171080',
    name: 'Batu Merah',
  },
  {
    id: '2171081001',
    districtId: '2171081',
    name: 'Bengkong Laut',
  },
  {
    id: '2171081002',
    districtId: '2171081',
    name: 'Bengkong Indah',
  },
  {
    id: '2171081003',
    districtId: '2171081',
    name: 'Sadai',
  },
  {
    id: '2171081004',
    districtId: '2171081',
    name: 'Tanjung Buntung',
  },
  {
    id: '2172010001',
    districtId: '2172010',
    name: 'Dompak',
  },
  {
    id: '2172010002',
    districtId: '2172010',
    name: 'Tanjungpinang Timur',
  },
  {
    id: '2172010003',
    districtId: '2172010',
    name: 'Tanjung Ayun Sakti',
  },
  {
    id: '2172010004',
    districtId: '2172010',
    name: 'Sei Jang',
  },
  {
    id: '2172010005',
    districtId: '2172010',
    name: 'Tanjung Unggat',
  },
  {
    id: '2172020001',
    districtId: '2172020',
    name: 'Batu Sembilan',
  },
  {
    id: '2172020002',
    districtId: '2172020',
    name: 'Melayu Kota Piring',
  },
  {
    id: '2172020003',
    districtId: '2172020',
    name: 'Air Raja',
  },
  {
    id: '2172020004',
    districtId: '2172020',
    name: 'Pinang Kencana',
  },
  {
    id: '2172020005',
    districtId: '2172020',
    name: 'Kampung Bulang',
  },
  {
    id: '2172030001',
    districtId: '2172030',
    name: 'Tanjungpinang Kota',
  },
  {
    id: '2172030002',
    districtId: '2172030',
    name: 'Penyengat',
  },
  {
    id: '2172030003',
    districtId: '2172030',
    name: 'Kampung Bugis',
  },
  {
    id: '2172030004',
    districtId: '2172030',
    name: 'Senggarang',
  },
  {
    id: '2172040001',
    districtId: '2172040',
    name: 'Tanjungpinang Barat',
  },
  {
    id: '2172040002',
    districtId: '2172040',
    name: 'Kemboja',
  },
  {
    id: '2172040003',
    districtId: '2172040',
    name: 'Kampung Baru',
  },
  {
    id: '2172040004',
    districtId: '2172040',
    name: 'Bukit Cermin',
  },
  {
    id: '3101010001',
    districtId: '3101010',
    name: 'Pulau Tidung',
  },
  {
    id: '3101010002',
    districtId: '3101010',
    name: 'Pulau Pari',
  },
  {
    id: '3101010003',
    districtId: '3101010',
    name: 'Pulau Untung Jawa',
  },
  {
    id: '3101020001',
    districtId: '3101020',
    name: 'Pulau Panggang',
  },
  {
    id: '3101020002',
    districtId: '3101020',
    name: 'Pulau Kelapa',
  },
  {
    id: '3101020003',
    districtId: '3101020',
    name: 'Pulau Harapan',
  },
  {
    id: '3171010001',
    districtId: '3171010',
    name: 'Cipedak',
  },
  {
    id: '3171010002',
    districtId: '3171010',
    name: 'Srengseng Sawah',
  },
  {
    id: '3171010003',
    districtId: '3171010',
    name: 'Ciganjur',
  },
  {
    id: '3171010004',
    districtId: '3171010',
    name: 'Jagakarsa',
  },
  {
    id: '3171010005',
    districtId: '3171010',
    name: 'Lenteng Agung',
  },
  {
    id: '3171010006',
    districtId: '3171010',
    name: 'Tanjung Barat',
  },
  {
    id: '3171020001',
    districtId: '3171020',
    name: 'Cilandak Timur',
  },
  {
    id: '3171020002',
    districtId: '3171020',
    name: 'Ragunan',
  },
  {
    id: '3171020003',
    districtId: '3171020',
    name: 'Kebagusan',
  },
  {
    id: '3171020004',
    districtId: '3171020',
    name: 'Pasar Minggu',
  },
  {
    id: '3171020005',
    districtId: '3171020',
    name: 'Jati Padang',
  },
  {
    id: '3171020006',
    districtId: '3171020',
    name: 'Pejaten Barat',
  },
  {
    id: '3171020007',
    districtId: '3171020',
    name: 'Pejaten Timur',
  },
  {
    id: '3171030001',
    districtId: '3171030',
    name: 'Lebak Bulus',
  },
  {
    id: '3171030002',
    districtId: '3171030',
    name: 'Pondok Labu',
  },
  {
    id: '3171030003',
    districtId: '3171030',
    name: 'Cilandak Barat',
  },
  {
    id: '3171030004',
    districtId: '3171030',
    name: 'Gandaria Selatan',
  },
  {
    id: '3171030005',
    districtId: '3171030',
    name: 'Cipete Selatan',
  },
  {
    id: '3171040001',
    districtId: '3171040',
    name: 'Bintaro',
  },
  {
    id: '3171040002',
    districtId: '3171040',
    name: 'Pesanggrahan',
  },
  {
    id: '3171040003',
    districtId: '3171040',
    name: 'Ulujami',
  },
  {
    id: '3171040004',
    districtId: '3171040',
    name: 'Petukangan Selatan',
  },
  {
    id: '3171040005',
    districtId: '3171040',
    name: 'Petukangan Utara',
  },
  {
    id: '3171050001',
    districtId: '3171050',
    name: 'Pondok Pinang',
  },
  {
    id: '3171050002',
    districtId: '3171050',
    name: 'Kebayoran Lama Selatan',
  },
  {
    id: '3171050003',
    districtId: '3171050',
    name: 'Kebayoran Lama Utara',
  },
  {
    id: '3171050004',
    districtId: '3171050',
    name: 'Cipulir',
  },
  {
    id: '3171050005',
    districtId: '3171050',
    name: 'Grogol Selatan',
  },
  {
    id: '3171050006',
    districtId: '3171050',
    name: 'Grogol Utara',
  },
  {
    id: '3171060001',
    districtId: '3171060',
    name: 'Gandaria Utara',
  },
  {
    id: '3171060002',
    districtId: '3171060',
    name: 'Cipete Utara',
  },
  {
    id: '3171060003',
    districtId: '3171060',
    name: 'Pulo',
  },
  {
    id: '3171060004',
    districtId: '3171060',
    name: 'Petogogan',
  },
  {
    id: '3171060005',
    districtId: '3171060',
    name: 'Melawai',
  },
  {
    id: '3171060006',
    districtId: '3171060',
    name: 'Kramat Pela',
  },
  {
    id: '3171060008',
    districtId: '3171060',
    name: 'Selong',
  },
  {
    id: '3171060009',
    districtId: '3171060',
    name: 'Rawa Barat',
  },
  {
    id: '3171060010',
    districtId: '3171060',
    name: 'Senayan',
  },
  {
    id: '3171070001',
    districtId: '3171070',
    name: 'Bangka',
  },
  {
    id: '3171070002',
    districtId: '3171070',
    name: 'Pela Mampang',
  },
  {
    id: '3171070003',
    districtId: '3171070',
    name: 'Tegal Parang',
  },
  {
    id: '3171070004',
    districtId: '3171070',
    name: 'Mampang Prapatan',
  },
  {
    id: '3171070005',
    districtId: '3171070',
    name: 'Kuningan Barat',
  },
  {
    id: '3171080001',
    districtId: '3171080',
    name: 'Kalibata',
  },
  {
    id: '3171080002',
    districtId: '3171080',
    name: 'Rawajati',
  },
  {
    id: '3171080003',
    districtId: '3171080',
    name: 'Duren Tiga',
  },
  {
    id: '3171080004',
    districtId: '3171080',
    name: 'Pancoran',
  },
  {
    id: '3171080005',
    districtId: '3171080',
    name: 'Pengadegan',
  },
  {
    id: '3171080006',
    districtId: '3171080',
    name: 'Cikoko',
  },
  {
    id: '3171090001',
    districtId: '3171090',
    name: 'Menteng Dalam',
  },
  {
    id: '3171090002',
    districtId: '3171090',
    name: 'Tebet Barat',
  },
  {
    id: '3171090003',
    districtId: '3171090',
    name: 'Tebet Timur',
  },
  {
    id: '3171090004',
    districtId: '3171090',
    name: 'Kebon Baru',
  },
  {
    id: '3171090005',
    districtId: '3171090',
    name: 'Bukit Duri',
  },
  {
    id: '3171090006',
    districtId: '3171090',
    name: 'Manggarai Selatan',
  },
  {
    id: '3171090007',
    districtId: '3171090',
    name: 'Manggarai',
  },
  {
    id: '3171100001',
    districtId: '3171100',
    name: 'Karet Semanggi',
  },
  {
    id: '3171100002',
    districtId: '3171100',
    name: 'Kuningan Timur',
  },
  {
    id: '3171100003',
    districtId: '3171100',
    name: 'Karet Kuningan',
  },
  {
    id: '3171100004',
    districtId: '3171100',
    name: 'Karet',
  },
  {
    id: '3171100005',
    districtId: '3171100',
    name: 'Menteng Atas',
  },
  {
    id: '3171100006',
    districtId: '3171100',
    name: 'Pasar Manggis',
  },
  {
    id: '3171100008',
    districtId: '3171100',
    name: 'Setia Budi',
  },
  {
    id: '3172010001',
    districtId: '3172010',
    name: 'Pekayon',
  },
  {
    id: '3172010002',
    districtId: '3172010',
    name: 'Kalisari',
  },
  {
    id: '3172010003',
    districtId: '3172010',
    name: 'Baru',
  },
  {
    id: '3172010004',
    districtId: '3172010',
    name: 'Cijantung',
  },
  {
    id: '3172010005',
    districtId: '3172010',
    name: 'Gedong',
  },
  {
    id: '3172020001',
    districtId: '3172020',
    name: 'Cibubur',
  },
  {
    id: '3172020002',
    districtId: '3172020',
    name: 'Kelapa Dua Wetan',
  },
  {
    id: '3172020003',
    districtId: '3172020',
    name: 'Ciracas',
  },
  {
    id: '3172020004',
    districtId: '3172020',
    name: 'Susukan',
  },
  {
    id: '3172020005',
    districtId: '3172020',
    name: 'Rambutan',
  },
  {
    id: '3172030001',
    districtId: '3172030',
    name: 'Pondok Ranggon',
  },
  {
    id: '3172030002',
    districtId: '3172030',
    name: 'Cilangkap',
  },
  {
    id: '3172030004',
    districtId: '3172030',
    name: 'Cipayung',
  },
  {
    id: '3172030006',
    districtId: '3172030',
    name: 'Bambu Apus',
  },
  {
    id: '3172030008',
    districtId: '3172030',
    name: 'Lubang Buaya',
  },
  {
    id: '3172040001',
    districtId: '3172040',
    name: 'Pinang Ranti',
  },
  {
    id: '3172040002',
    districtId: '3172040',
    name: 'Makasar',
  },
  {
    id: '3172040003',
    districtId: '3172040',
    name: 'Kebon Pala',
  },
  {
    id: '3172040004',
    districtId: '3172040',
    name: 'Halim Perdana Kusumah',
  },
  {
    id: '3172040005',
    districtId: '3172040',
    name: 'Cipinang Melayu',
  },
  {
    id: '3172050001',
    districtId: '3172050',
    name: 'Bale Kambang',
  },
  {
    id: '3172050002',
    districtId: '3172050',
    name: 'Batu Ampar',
  },
  {
    id: '3172050003',
    districtId: '3172050',
    name: 'Kampung Tengah',
  },
  {
    id: '3172050005',
    districtId: '3172050',
    name: 'Kramat Jati',
  },
  {
    id: '3172050006',
    districtId: '3172050',
    name: 'Cililitan',
  },
  {
    id: '3172050007',
    districtId: '3172050',
    name: 'Cawang',
  },
  {
    id: '3172060001',
    districtId: '3172060',
    name: 'Bidara Cina',
  },
  {
    id: '3172060002',
    districtId: '3172060',
    name: 'Cipinang Cempedak',
  },
  {
    id: '3172060003',
    districtId: '3172060',
    name: 'Cipinang Besar Selatan',
  },
  {
    id: '3172060004',
    districtId: '3172060',
    name: 'Cipinang Muara',
  },
  {
    id: '3172060005',
    districtId: '3172060',
    name: 'Cipinang Besar Utara',
  },
  {
    id: '3172060006',
    districtId: '3172060',
    name: 'Rawa Bunga',
  },
  {
    id: '3172060007',
    districtId: '3172060',
    name: 'Bali Mester',
  },
  {
    id: '3172060008',
    districtId: '3172060',
    name: 'Kampung Melayu',
  },
  {
    id: '3172070001',
    districtId: '3172070',
    name: 'Pondok Bambu',
  },
  {
    id: '3172070002',
    districtId: '3172070',
    name: 'Duren Sawit',
  },
  {
    id: '3172070003',
    districtId: '3172070',
    name: 'Pondok Kelapa',
  },
  {
    id: '3172070004',
    districtId: '3172070',
    name: 'Pondok Kopi',
  },
  {
    id: '3172070005',
    districtId: '3172070',
    name: 'Malaka Jaya',
  },
  {
    id: '3172070006',
    districtId: '3172070',
    name: 'Malaka Sari',
  },
  {
    id: '3172080001',
    districtId: '3172080',
    name: 'Jatinegara',
  },
  {
    id: '3172080002',
    districtId: '3172080',
    name: 'Penggilingan',
  },
  {
    id: '3172080003',
    districtId: '3172080',
    name: 'Pulo Gebang',
  },
  {
    id: '3172080005',
    districtId: '3172080',
    name: 'Cakung Timur',
  },
  {
    id: '3172080006',
    districtId: '3172080',
    name: 'Cakung Barat',
  },
  {
    id: '3172080007',
    districtId: '3172080',
    name: 'Rawa Terate',
  },
  {
    id: '3172090001',
    districtId: '3172090',
    name: 'Pisangan Timur',
  },
  {
    id: '3172090002',
    districtId: '3172090',
    name: 'Cipinang',
  },
  {
    id: '3172090003',
    districtId: '3172090',
    name: 'Jatinegara Kaum',
  },
  {
    id: '3172090004',
    districtId: '3172090',
    name: 'Jati',
  },
  {
    id: '3172090005',
    districtId: '3172090',
    name: 'Rawamangun',
  },
  {
    id: '3172090006',
    districtId: '3172090',
    name: 'Kayu Putih',
  },
  {
    id: '3172090007',
    districtId: '3172090',
    name: 'Pulo Gadung',
  },
  {
    id: '3172100001',
    districtId: '3172100',
    name: 'Kebon Manggis',
  },
  {
    id: '3172100002',
    districtId: '3172100',
    name: 'Pal Meriem',
  },
  {
    id: '3172100003',
    districtId: '3172100',
    name: 'Pisangan Baru',
  },
  {
    id: '3172100004',
    districtId: '3172100',
    name: 'Kayu Manis',
  },
  {
    id: '3172100005',
    districtId: '3172100',
    name: 'Utan Kayu Selatan',
  },
  {
    id: '3172100006',
    districtId: '3172100',
    name: 'Utan Kayu Utara',
  },
  {
    id: '3173010001',
    districtId: '3173010',
    name: 'Gelora',
  },
  {
    id: '3173010002',
    districtId: '3173010',
    name: 'Bendungan Hilir',
  },
  {
    id: '3173010003',
    districtId: '3173010',
    name: 'Karet Tengsin',
  },
  {
    id: '3173010004',
    districtId: '3173010',
    name: 'Kebon Melati',
  },
  {
    id: '3173010005',
    districtId: '3173010',
    name: 'Petamburan',
  },
  {
    id: '3173010006',
    districtId: '3173010',
    name: 'Kebon Kacang',
  },
  {
    id: '3173010007',
    districtId: '3173010',
    name: 'Kampung Bali',
  },
  {
    id: '3173020002',
    districtId: '3173020',
    name: 'Pegangsaan',
  },
  {
    id: '3173020003',
    districtId: '3173020',
    name: 'Cikini',
  },
  {
    id: '3173020004',
    districtId: '3173020',
    name: 'Gondangdia',
  },
  {
    id: '3173020005',
    districtId: '3173020',
    name: 'Kebon Sirih',
  },
  {
    id: '3173030001',
    districtId: '3173030',
    name: 'Kenari',
  },
  {
    id: '3173030002',
    districtId: '3173030',
    name: 'Paseban',
  },
  {
    id: '3173030003',
    districtId: '3173030',
    name: 'Kramat',
  },
  {
    id: '3173030004',
    districtId: '3173030',
    name: 'Kwitang',
  },
  {
    id: '3173040001',
    districtId: '3173040',
    name: 'Johar Baru',
  },
  {
    id: '3173040002',
    districtId: '3173040',
    name: 'Kampung Rawa',
  },
  {
    id: '3173040003',
    districtId: '3173040',
    name: 'Tanah Tinggi',
  },
  {
    id: '3173040004',
    districtId: '3173040',
    name: 'Galur',
  },
  {
    id: '3173050001',
    districtId: '3173050',
    name: 'Rawa Sari',
  },
  {
    id: '3173050002',
    districtId: '3173050',
    name: 'Cempaka Putih Timur',
  },
  {
    id: '3173050003',
    districtId: '3173050',
    name: 'Cempaka Putih Barat',
  },
  {
    id: '3173060001',
    districtId: '3173060',
    name: 'Harapan Mulya',
  },
  {
    id: '3173060002',
    districtId: '3173060',
    name: 'Cempaka Baru',
  },
  {
    id: '3173060003',
    districtId: '3173060',
    name: 'Sumur Batu',
  },
  {
    id: '3173060004',
    districtId: '3173060',
    name: 'Serdang',
  },
  {
    id: '3173060005',
    districtId: '3173060',
    name: 'Utan Panjang',
  },
  {
    id: '3173060006',
    districtId: '3173060',
    name: 'Kebon Kosong',
  },
  {
    id: '3173060007',
    districtId: '3173060',
    name: 'Kemayoran',
  },
  {
    id: '3173060008',
    districtId: '3173060',
    name: 'Gunung Sahari Selatan',
  },
  {
    id: '3173070001',
    districtId: '3173070',
    name: 'Pasar Baru',
  },
  {
    id: '3173070002',
    districtId: '3173070',
    name: 'Gunung Sahari Utara',
  },
  {
    id: '3173070003',
    districtId: '3173070',
    name: 'Kartini',
  },
  {
    id: '3173070004',
    districtId: '3173070',
    name: 'Karang Anyar',
  },
  {
    id: '3173070005',
    districtId: '3173070',
    name: 'Mangga Dua Selatan',
  },
  {
    id: '3173080001',
    districtId: '3173080',
    name: 'Cideng',
  },
  {
    id: '3173080002',
    districtId: '3173080',
    name: 'Petojo Selatan',
  },
  {
    id: '3173080003',
    districtId: '3173080',
    name: 'Gambir',
  },
  {
    id: '3173080004',
    districtId: '3173080',
    name: 'Kebon Kelapa',
  },
  {
    id: '3173080005',
    districtId: '3173080',
    name: 'Petojo Utara',
  },
  {
    id: '3173080006',
    districtId: '3173080',
    name: 'Duri Pulo',
  },
  {
    id: '3174010001',
    districtId: '3174010',
    name: 'Joglo',
  },
  {
    id: '3174010003',
    districtId: '3174010',
    name: 'Meruya Selatan',
  },
  {
    id: '3174010004',
    districtId: '3174010',
    name: 'Meruya Utara',
  },
  {
    id: '3174010005',
    districtId: '3174010',
    name: 'Kembangan Selatan',
  },
  {
    id: '3174010006',
    districtId: '3174010',
    name: 'Kembangan Utara',
  },
  {
    id: '3174020001',
    districtId: '3174020',
    name: 'Sukabumi Selatan',
  },
  {
    id: '3174020002',
    districtId: '3174020',
    name: 'Sukabumi Utara',
  },
  {
    id: '3174020003',
    districtId: '3174020',
    name: 'Kelapa Dua',
  },
  {
    id: '3174020004',
    districtId: '3174020',
    name: 'Kebon Jeruk',
  },
  {
    id: '3174020005',
    districtId: '3174020',
    name: 'Duri Kepa',
  },
  {
    id: '3174020006',
    districtId: '3174020',
    name: 'Kedoya Selatan',
  },
  {
    id: '3174020007',
    districtId: '3174020',
    name: 'Kedoya Utara',
  },
  {
    id: '3174030001',
    districtId: '3174030',
    name: 'Palmerah',
  },
  {
    id: '3174030002',
    districtId: '3174030',
    name: 'Slipi',
  },
  {
    id: '3174030003',
    districtId: '3174030',
    name: 'Kemanggisan',
  },
  {
    id: '3174030004',
    districtId: '3174030',
    name: 'Kota Bambu Utara',
  },
  {
    id: '3174030005',
    districtId: '3174030',
    name: 'Kota Bambu Selatan',
  },
  {
    id: '3174030006',
    districtId: '3174030',
    name: 'Jati Pulo',
  },
  {
    id: '3174040001',
    districtId: '3174040',
    name: 'Tanjung Duren Utara',
  },
  {
    id: '3174040002',
    districtId: '3174040',
    name: 'Tanjung Duren Selatan',
  },
  {
    id: '3174040003',
    districtId: '3174040',
    name: 'Tomang',
  },
  {
    id: '3174040004',
    districtId: '3174040',
    name: 'Grogol',
  },
  {
    id: '3174040005',
    districtId: '3174040',
    name: 'Jelambar',
  },
  {
    id: '3174040006',
    districtId: '3174040',
    name: 'Wijaya Kesuma',
  },
  {
    id: '3174040007',
    districtId: '3174040',
    name: 'Jelambar Baru',
  },
  {
    id: '3174050001',
    districtId: '3174050',
    name: 'Kalianyar',
  },
  {
    id: '3174050002',
    districtId: '3174050',
    name: 'Duri Selatan',
  },
  {
    id: '3174050003',
    districtId: '3174050',
    name: 'Tanah Sereal',
  },
  {
    id: '3174050004',
    districtId: '3174050',
    name: 'Duri Utara',
  },
  {
    id: '3174050005',
    districtId: '3174050',
    name: 'Krendang',
  },
  {
    id: '3174050006',
    districtId: '3174050',
    name: 'Jembatan Besi',
  },
  {
    id: '3174050007',
    districtId: '3174050',
    name: 'Angke',
  },
  {
    id: '3174050008',
    districtId: '3174050',
    name: 'Jembatan Lima',
  },
  {
    id: '3174050009',
    districtId: '3174050',
    name: 'Tambora',
  },
  {
    id: '3174050010',
    districtId: '3174050',
    name: 'Roa Malaka',
  },
  {
    id: '3174050011',
    districtId: '3174050',
    name: 'Pekojan',
  },
  {
    id: '3174060002',
    districtId: '3174060',
    name: 'Maphar',
  },
  {
    id: '3174060003',
    districtId: '3174060',
    name: 'Taman Sari',
  },
  {
    id: '3174060004',
    districtId: '3174060',
    name: 'Tangki',
  },
  {
    id: '3174060005',
    districtId: '3174060',
    name: 'Mangga Besar',
  },
  {
    id: '3174060006',
    districtId: '3174060',
    name: 'Keagungan',
  },
  {
    id: '3174060007',
    districtId: '3174060',
    name: 'Glodok',
  },
  {
    id: '3174060008',
    districtId: '3174060',
    name: 'Pinangsia',
  },
  {
    id: '3174070001',
    districtId: '3174070',
    name: 'Duri Kosambi',
  },
  {
    id: '3174070002',
    districtId: '3174070',
    name: 'Rawa Buaya',
  },
  {
    id: '3174070003',
    districtId: '3174070',
    name: 'Kedaung Kali Angke',
  },
  {
    id: '3174070004',
    districtId: '3174070',
    name: 'Kapuk',
  },
  {
    id: '3174070005',
    districtId: '3174070',
    name: 'Cengkareng Timur',
  },
  {
    id: '3174070006',
    districtId: '3174070',
    name: 'Cengkareng Barat',
  },
  {
    id: '3174080001',
    districtId: '3174080',
    name: 'Semanan',
  },
  {
    id: '3174080002',
    districtId: '3174080',
    name: 'Kalideres',
  },
  {
    id: '3174080003',
    districtId: '3174080',
    name: 'Pegadungan',
  },
  {
    id: '3174080004',
    districtId: '3174080',
    name: 'Tegal Alur',
  },
  {
    id: '3174080005',
    districtId: '3174080',
    name: 'Kamal',
  },
  {
    id: '3175010001',
    districtId: '3175010',
    name: 'Kamal Muara',
  },
  {
    id: '3175010002',
    districtId: '3175010',
    name: 'Kapuk Muara',
  },
  {
    id: '3175010003',
    districtId: '3175010',
    name: 'Pejagalan',
  },
  {
    id: '3175010004',
    districtId: '3175010',
    name: 'Penjaringan',
  },
  {
    id: '3175010005',
    districtId: '3175010',
    name: 'Pluit',
  },
  {
    id: '3175020001',
    districtId: '3175020',
    name: 'Pademangan Barat',
  },
  {
    id: '3175020002',
    districtId: '3175020',
    name: 'Pademangan Timur',
  },
  {
    id: '3175020003',
    districtId: '3175020',
    name: 'Ancol',
  },
  {
    id: '3175030001',
    districtId: '3175030',
    name: 'Sunter Agung',
  },
  {
    id: '3175030002',
    districtId: '3175030',
    name: 'Sunter Jaya',
  },
  {
    id: '3175030003',
    districtId: '3175030',
    name: 'Papango',
  },
  {
    id: '3175030004',
    districtId: '3175030',
    name: 'Warakas',
  },
  {
    id: '3175030005',
    districtId: '3175030',
    name: 'Sungai Bambu',
  },
  {
    id: '3175030006',
    districtId: '3175030',
    name: 'Kebon Bawang',
  },
  {
    id: '3175030007',
    districtId: '3175030',
    name: 'Tanjung Priuk',
  },
  {
    id: '3175040001',
    districtId: '3175040',
    name: 'Rawabadak Selatan',
  },
  {
    id: '3175040002',
    districtId: '3175040',
    name: 'Tugu Selatan',
  },
  {
    id: '3175040003',
    districtId: '3175040',
    name: 'Tugu Utara',
  },
  {
    id: '3175040004',
    districtId: '3175040',
    name: 'Lagoa',
  },
  {
    id: '3175040005',
    districtId: '3175040',
    name: 'Rawabadak Utara',
  },
  {
    id: '3175040006',
    districtId: '3175040',
    name: 'Koja',
  },
  {
    id: '3175050001',
    districtId: '3175050',
    name: 'Kelapa Gading Barat',
  },
  {
    id: '3175050002',
    districtId: '3175050',
    name: 'Kelapa Gading Timur',
  },
  {
    id: '3175050003',
    districtId: '3175050',
    name: 'Pegangsaan Dua',
  },
  {
    id: '3175060001',
    districtId: '3175060',
    name: 'Suka Pura',
  },
  {
    id: '3175060002',
    districtId: '3175060',
    name: 'Rorotan',
  },
  {
    id: '3175060003',
    districtId: '3175060',
    name: 'Marunda',
  },
  {
    id: '3175060004',
    districtId: '3175060',
    name: 'Cilincing',
  },
  {
    id: '3175060005',
    districtId: '3175060',
    name: 'Semper Timur',
  },
  {
    id: '3175060006',
    districtId: '3175060',
    name: 'Semper Barat',
  },
  {
    id: '3175060007',
    districtId: '3175060',
    name: 'Kali Baru',
  },
  {
    id: '3201010001',
    districtId: '3201010',
    name: 'Malasari',
  },
  {
    id: '3201010002',
    districtId: '3201010',
    name: 'Bantar Karet',
  },
  {
    id: '3201010003',
    districtId: '3201010',
    name: 'Cisarua',
  },
  {
    id: '3201010004',
    districtId: '3201010',
    name: 'Curug Bitung',
  },
  {
    id: '3201010005',
    districtId: '3201010',
    name: 'Nanggung',
  },
  {
    id: '3201010006',
    districtId: '3201010',
    name: 'Pangkal Jaya',
  },
  {
    id: '3201010007',
    districtId: '3201010',
    name: 'Sukaluyu',
  },
  {
    id: '3201010008',
    districtId: '3201010',
    name: 'Hambaro',
  },
  {
    id: '3201010009',
    districtId: '3201010',
    name: 'Kalong Liud',
  },
  {
    id: '3201010010',
    districtId: '3201010',
    name: 'Parakan Muncang',
  },
  {
    id: '3201010011',
    districtId: '3201010',
    name: 'Batu Tulis',
  },
  {
    id: '3201020001',
    districtId: '3201020',
    name: 'Purasari',
  },
  {
    id: '3201020002',
    districtId: '3201020',
    name: 'Puraseda',
  },
  {
    id: '3201020003',
    districtId: '3201020',
    name: 'Karyasari',
  },
  {
    id: '3201020004',
    districtId: '3201020',
    name: 'Pabangbon',
  },
  {
    id: '3201020005',
    districtId: '3201020',
    name: 'Karacak',
  },
  {
    id: '3201020006',
    districtId: '3201020',
    name: 'Barengkok',
  },
  {
    id: '3201020007',
    districtId: '3201020',
    name: 'Cibeber II',
  },
  {
    id: '3201020016',
    districtId: '3201020',
    name: 'Cibeber I',
  },
  {
    id: '3201020017',
    districtId: '3201020',
    name: 'Leuwimekar',
  },
  {
    id: '3201020018',
    districtId: '3201020',
    name: 'Leuwiliang',
  },
  {
    id: '3201020019',
    districtId: '3201020',
    name: 'Karehkel',
  },
  {
    id: '3201021001',
    districtId: '3201021',
    name: 'Wangun Jaya',
  },
  {
    id: '3201021002',
    districtId: '3201021',
    name: 'Sadengkolot',
  },
  {
    id: '3201021003',
    districtId: '3201021',
    name: 'Leuwisadeng',
  },
  {
    id: '3201021004',
    districtId: '3201021',
    name: 'Sibanteng',
  },
  {
    id: '3201021005',
    districtId: '3201021',
    name: 'Babakan Sadeng',
  },
  {
    id: '3201021006',
    districtId: '3201021',
    name: 'Sadeng',
  },
  {
    id: '3201021007',
    districtId: '3201021',
    name: 'Kalong II',
  },
  {
    id: '3201021008',
    districtId: '3201021',
    name: 'Kalong I',
  },
  {
    id: '3201030001',
    districtId: '3201030',
    name: 'Cibunian',
  },
  {
    id: '3201030002',
    districtId: '3201030',
    name: 'Purwabakti',
  },
  {
    id: '3201030003',
    districtId: '3201030',
    name: 'Ciasmara',
  },
  {
    id: '3201030004',
    districtId: '3201030',
    name: 'Ciasihan',
  },
  {
    id: '3201030005',
    districtId: '3201030',
    name: 'Gunung Sari',
  },
  {
    id: '3201030008',
    districtId: '3201030',
    name: 'Cibening',
  },
  {
    id: '3201030009',
    districtId: '3201030',
    name: 'Gunung Picung',
  },
  {
    id: '3201030010',
    districtId: '3201030',
    name: 'Cibitung Kulon',
  },
  {
    id: '3201030011',
    districtId: '3201030',
    name: 'Cibitung Wetan',
  },
  {
    id: '3201030012',
    districtId: '3201030',
    name: 'Pamijahan',
  },
  {
    id: '3201030013',
    districtId: '3201030',
    name: 'Pasarean',
  },
  {
    id: '3201030014',
    districtId: '3201030',
    name: 'Gunung Menyan',
  },
  {
    id: '3201030015',
    districtId: '3201030',
    name: 'Cimayang',
  },
  {
    id: '3201040001',
    districtId: '3201040',
    name: 'Situ Udik',
  },
  {
    id: '3201040002',
    districtId: '3201040',
    name: 'Situ Ilir',
  },
  {
    id: '3201040003',
    districtId: '3201040',
    name: 'Cibatok 2',
  },
  {
    id: '3201040004',
    districtId: '3201040',
    name: 'Ciaruten Udik',
  },
  {
    id: '3201040005',
    districtId: '3201040',
    name: 'Cibatok 1',
  },
  {
    id: '3201040006',
    districtId: '3201040',
    name: 'Sukamaju',
  },
  {
    id: '3201040007',
    districtId: '3201040',
    name: 'Cemplang',
  },
  {
    id: '3201040008',
    districtId: '3201040',
    name: 'Galuga',
  },
  {
    id: '3201040010',
    districtId: '3201040',
    name: 'Cimanggu 2',
  },
  {
    id: '3201040011',
    districtId: '3201040',
    name: 'Cimanggu 1',
  },
  {
    id: '3201040012',
    districtId: '3201040',
    name: 'Girimulya',
  },
  {
    id: '3201040013',
    districtId: '3201040',
    name: 'Leuweung Kolot',
  },
  {
    id: '3201040014',
    districtId: '3201040',
    name: 'Ciaruten Ilir',
  },
  {
    id: '3201040015',
    districtId: '3201040',
    name: 'Cijujung',
  },
  {
    id: '3201050004',
    districtId: '3201050',
    name: 'Ciampea Udik',
  },
  {
    id: '3201050008',
    districtId: '3201050',
    name: 'Cinangka',
  },
  {
    id: '3201050009',
    districtId: '3201050',
    name: 'Cibuntu',
  },
  {
    id: '3201050010',
    districtId: '3201050',
    name: 'Cicadas',
  },
  {
    id: '3201050011',
    districtId: '3201050',
    name: 'Tegal Waru',
  },
  {
    id: '3201050012',
    districtId: '3201050',
    name: 'Bojong Jengkol',
  },
  {
    id: '3201050013',
    districtId: '3201050',
    name: 'Cihideung Udik',
  },
  {
    id: '3201050014',
    districtId: '3201050',
    name: 'Cihideung Ilir',
  },
  {
    id: '3201050015',
    districtId: '3201050',
    name: 'Cibanteng',
  },
  {
    id: '3201050016',
    districtId: '3201050',
    name: 'Bojong Rangkas',
  },
  {
    id: '3201050017',
    districtId: '3201050',
    name: 'Cibadak',
  },
  {
    id: '3201050019',
    districtId: '3201050',
    name: 'Ciampea',
  },
  {
    id: '3201051001',
    districtId: '3201051',
    name: 'Tapos 1',
  },
  {
    id: '3201051002',
    districtId: '3201051',
    name: 'Gunung Malang',
  },
  {
    id: '3201051003',
    districtId: '3201051',
    name: 'Tapos 2',
  },
  {
    id: '3201051004',
    districtId: '3201051',
    name: 'Situ Daun',
  },
  {
    id: '3201051005',
    districtId: '3201051',
    name: 'Cibitung Tengah',
  },
  {
    id: '3201051006',
    districtId: '3201051',
    name: 'Cinangneng',
  },
  {
    id: '3201051007',
    districtId: '3201051',
    name: 'Gunung Mulya',
  },
  {
    id: '3201060001',
    districtId: '3201060',
    name: 'Purwasari',
  },
  {
    id: '3201060002',
    districtId: '3201060',
    name: 'Petir',
  },
  {
    id: '3201060003',
    districtId: '3201060',
    name: 'Sukadamai',
  },
  {
    id: '3201060004',
    districtId: '3201060',
    name: 'Sukawening',
  },
  {
    id: '3201060005',
    districtId: '3201060',
    name: 'Neglasari',
  },
  {
    id: '3201060006',
    districtId: '3201060',
    name: 'Sinar Sari',
  },
  {
    id: '3201060007',
    districtId: '3201060',
    name: 'Ciherang',
  },
  {
    id: '3201060008',
    districtId: '3201060',
    name: 'Dramaga',
  },
  {
    id: '3201060009',
    districtId: '3201060',
    name: 'Babakan',
  },
  {
    id: '3201060010',
    districtId: '3201060',
    name: 'Cikarawang',
  },
  {
    id: '3201070009',
    districtId: '3201070',
    name: 'Kota Batu',
  },
  {
    id: '3201070010',
    districtId: '3201070',
    name: 'Mekarjaya',
  },
  {
    id: '3201070011',
    districtId: '3201070',
    name: 'Parakan',
  },
  {
    id: '3201070012',
    districtId: '3201070',
    name: 'Ciomas',
  },
  {
    id: '3201070013',
    districtId: '3201070',
    name: 'Pagelaran',
  },
  {
    id: '3201070014',
    districtId: '3201070',
    name: 'Sukamakmur',
  },
  {
    id: '3201070015',
    districtId: '3201070',
    name: 'Ciapus',
  },
  {
    id: '3201070016',
    districtId: '3201070',
    name: 'Sukaharja',
  },
  {
    id: '3201070017',
    districtId: '3201070',
    name: 'Padasuka',
  },
  {
    id: '3201070018',
    districtId: '3201070',
    name: 'Ciomas Rahayu',
  },
  {
    id: '3201070019',
    districtId: '3201070',
    name: 'Laladon',
  },
  {
    id: '3201071001',
    districtId: '3201071',
    name: 'Sukajadi',
  },
  {
    id: '3201071002',
    districtId: '3201071',
    name: 'Sukaluyu',
  },
  {
    id: '3201071003',
    districtId: '3201071',
    name: 'Sukajaya',
  },
  {
    id: '3201071004',
    districtId: '3201071',
    name: 'Sukaresmi',
  },
  {
    id: '3201071005',
    districtId: '3201071',
    name: 'Pasir Eurih',
  },
  {
    id: '3201071006',
    districtId: '3201071',
    name: 'Taman Sari',
  },
  {
    id: '3201071007',
    districtId: '3201071',
    name: 'Sukamantri',
  },
  {
    id: '3201071008',
    districtId: '3201071',
    name: 'Sirnagalih',
  },
  {
    id: '3201080010',
    districtId: '3201080',
    name: 'Warung Menteng',
  },
  {
    id: '3201080011',
    districtId: '3201080',
    name: 'Cijeruk',
  },
  {
    id: '3201080012',
    districtId: '3201080',
    name: 'Cipelang',
  },
  {
    id: '3201080013',
    districtId: '3201080',
    name: 'Cibalung',
  },
  {
    id: '3201080014',
    districtId: '3201080',
    name: 'Cipicung',
  },
  {
    id: '3201080015',
    districtId: '3201080',
    name: 'Tanjung Sari',
  },
  {
    id: '3201080016',
    districtId: '3201080',
    name: 'Tajur Halang',
  },
  {
    id: '3201080017',
    districtId: '3201080',
    name: 'Palasari',
  },
  {
    id: '3201080018',
    districtId: '3201080',
    name: 'Sukaharja',
  },
  {
    id: '3201081001',
    districtId: '3201081',
    name: 'Tugu Jaya',
  },
  {
    id: '3201081002',
    districtId: '3201081',
    name: 'Cigombong',
  },
  {
    id: '3201081003',
    districtId: '3201081',
    name: 'Wates Jaya',
  },
  {
    id: '3201081004',
    districtId: '3201081',
    name: 'Srogol',
  },
  {
    id: '3201081005',
    districtId: '3201081',
    name: 'Ciburuy',
  },
  {
    id: '3201081006',
    districtId: '3201081',
    name: 'Cisalada',
  },
  {
    id: '3201081007',
    districtId: '3201081',
    name: 'Pasir Jaya',
  },
  {
    id: '3201081008',
    districtId: '3201081',
    name: 'Ciburayut',
  },
  {
    id: '3201081009',
    districtId: '3201081',
    name: 'Ciadeg',
  },
  {
    id: '3201090001',
    districtId: '3201090',
    name: 'Pasir Buncir',
  },
  {
    id: '3201090002',
    districtId: '3201090',
    name: 'Cinagara',
  },
  {
    id: '3201090003',
    districtId: '3201090',
    name: 'Tangkil',
  },
  {
    id: '3201090004',
    districtId: '3201090',
    name: 'Pasir Muncang',
  },
  {
    id: '3201090005',
    districtId: '3201090',
    name: 'Muara Jaya',
  },
  {
    id: '3201090006',
    districtId: '3201090',
    name: 'Caringin',
  },
  {
    id: '3201090007',
    districtId: '3201090',
    name: 'Lemah Duhur',
  },
  {
    id: '3201090008',
    districtId: '3201090',
    name: 'Cimande',
  },
  {
    id: '3201090009',
    districtId: '3201090',
    name: 'Pancawati',
  },
  {
    id: '3201090010',
    districtId: '3201090',
    name: 'Ciderum',
  },
  {
    id: '3201090011',
    districtId: '3201090',
    name: 'Ciherang Pondok',
  },
  {
    id: '3201090012',
    districtId: '3201090',
    name: 'Cimande Hilir',
  },
  {
    id: '3201100001',
    districtId: '3201100',
    name: 'Cileungsi',
  },
  {
    id: '3201100002',
    districtId: '3201100',
    name: 'Citapen',
  },
  {
    id: '3201100003',
    districtId: '3201100',
    name: 'Cibedug',
  },
  {
    id: '3201100004',
    districtId: '3201100',
    name: 'Bojong Murni',
  },
  {
    id: '3201100005',
    districtId: '3201100',
    name: 'Jambu Luwuk',
  },
  {
    id: '3201100006',
    districtId: '3201100',
    name: 'Banjar Sari',
  },
  {
    id: '3201100007',
    districtId: '3201100',
    name: 'Banjar Wangi',
  },
  {
    id: '3201100008',
    districtId: '3201100',
    name: 'Bitung Sari',
  },
  {
    id: '3201100009',
    districtId: '3201100',
    name: 'Teluk Pinang',
  },
  {
    id: '3201100010',
    districtId: '3201100',
    name: 'Banjar Waru',
  },
  {
    id: '3201100011',
    districtId: '3201100',
    name: 'Ciawi',
  },
  {
    id: '3201100012',
    districtId: '3201100',
    name: 'Bendungan',
  },
  {
    id: '3201100013',
    districtId: '3201100',
    name: 'Pandansari',
  },
  {
    id: '3201110001',
    districtId: '3201110',
    name: 'Citeko',
  },
  {
    id: '3201110002',
    districtId: '3201110',
    name: 'Cibeureum',
  },
  {
    id: '3201110003',
    districtId: '3201110',
    name: 'Tugu Selatan',
  },
  {
    id: '3201110004',
    districtId: '3201110',
    name: 'Tugu Utara',
  },
  {
    id: '3201110005',
    districtId: '3201110',
    name: 'Batu Layang',
  },
  {
    id: '3201110006',
    districtId: '3201110',
    name: 'Cisarua',
  },
  {
    id: '3201110007',
    districtId: '3201110',
    name: 'Kopo',
  },
  {
    id: '3201110008',
    districtId: '3201110',
    name: 'Leuwimalang',
  },
  {
    id: '3201110009',
    districtId: '3201110',
    name: 'Jogjogan',
  },
  {
    id: '3201110010',
    districtId: '3201110',
    name: 'Cilember',
  },
  {
    id: '3201120001',
    districtId: '3201120',
    name: 'Sukaresmi',
  },
  {
    id: '3201120002',
    districtId: '3201120',
    name: 'Sukagalih',
  },
  {
    id: '3201120003',
    districtId: '3201120',
    name: 'Kuta',
  },
  {
    id: '3201120004',
    districtId: '3201120',
    name: 'Sukakarya',
  },
  {
    id: '3201120005',
    districtId: '3201120',
    name: 'Sukamanah',
  },
  {
    id: '3201120006',
    districtId: '3201120',
    name: 'Sukamaju',
  },
  {
    id: '3201120007',
    districtId: '3201120',
    name: 'Sukamahi',
  },
  {
    id: '3201120008',
    districtId: '3201120',
    name: 'Gadog',
  },
  {
    id: '3201120009',
    districtId: '3201120',
    name: 'Cipayung',
  },
  {
    id: '3201120010',
    districtId: '3201120',
    name: 'Cipayung Girang',
  },
  {
    id: '3201120011',
    districtId: '3201120',
    name: 'Megamendung',
  },
  {
    id: '3201120012',
    districtId: '3201120',
    name: 'Pasir Angin',
  },
  {
    id: '3201130001',
    districtId: '3201130',
    name: 'Cibanon',
  },
  {
    id: '3201130002',
    districtId: '3201130',
    name: 'Gunung Geulis',
  },
  {
    id: '3201130003',
    districtId: '3201130',
    name: 'Nagrak',
  },
  {
    id: '3201130004',
    districtId: '3201130',
    name: 'Sukatani',
  },
  {
    id: '3201130005',
    districtId: '3201130',
    name: 'Sukaraja',
  },
  {
    id: '3201130006',
    districtId: '3201130',
    name: 'Cikeas',
  },
  {
    id: '3201130007',
    districtId: '3201130',
    name: 'Cadas Ngampar',
  },
  {
    id: '3201130008',
    districtId: '3201130',
    name: 'Pasirlaja',
  },
  {
    id: '3201130009',
    districtId: '3201130',
    name: 'Cijujung',
  },
  {
    id: '3201130010',
    districtId: '3201130',
    name: 'Cimandala',
  },
  {
    id: '3201130011',
    districtId: '3201130',
    name: 'Pasir Jambu',
  },
  {
    id: '3201130012',
    districtId: '3201130',
    name: 'Cilebut Timur',
  },
  {
    id: '3201130013',
    districtId: '3201130',
    name: 'Cilebut Barat',
  },
  {
    id: '3201140001',
    districtId: '3201140',
    name: 'Cijayanti',
  },
  {
    id: '3201140002',
    districtId: '3201140',
    name: 'Bojong Koneng',
  },
  {
    id: '3201140003',
    districtId: '3201140',
    name: 'Karang Tengah',
  },
  {
    id: '3201140004',
    districtId: '3201140',
    name: 'Sumur Batu',
  },
  {
    id: '3201140005',
    districtId: '3201140',
    name: 'Babakan Madang',
  },
  {
    id: '3201140006',
    districtId: '3201140',
    name: 'Citaringgul',
  },
  {
    id: '3201140007',
    districtId: '3201140',
    name: 'Cipambuan',
  },
  {
    id: '3201140008',
    districtId: '3201140',
    name: 'Kadumangu',
  },
  {
    id: '3201150001',
    districtId: '3201150',
    name: 'Sukawangi',
  },
  {
    id: '3201150002',
    districtId: '3201150',
    name: 'Sukaharja',
  },
  {
    id: '3201150003',
    districtId: '3201150',
    name: 'Wargajaya',
  },
  {
    id: '3201150004',
    districtId: '3201150',
    name: 'Sirnajaya',
  },
  {
    id: '3201150005',
    districtId: '3201150',
    name: 'Sukamulya',
  },
  {
    id: '3201150006',
    districtId: '3201150',
    name: 'Sukamakmur',
  },
  {
    id: '3201150007',
    districtId: '3201150',
    name: 'Cibadak',
  },
  {
    id: '3201150008',
    districtId: '3201150',
    name: 'Pabuaran',
  },
  {
    id: '3201150009',
    districtId: '3201150',
    name: 'Sukadamai',
  },
  {
    id: '3201150010',
    districtId: '3201150',
    name: 'Sukaresmi',
  },
  {
    id: '3201160011',
    districtId: '3201160',
    name: 'Karya Mekar',
  },
  {
    id: '3201160012',
    districtId: '3201160',
    name: 'Bantar Kuning',
  },
  {
    id: '3201160013',
    districtId: '3201160',
    name: 'Cikutamahi',
  },
  {
    id: '3201160014',
    districtId: '3201160',
    name: 'Cibatu Tiga',
  },
  {
    id: '3201160015',
    districtId: '3201160',
    name: 'Mekarwangi',
  },
  {
    id: '3201160016',
    districtId: '3201160',
    name: 'Tegal Panjang',
  },
  {
    id: '3201160017',
    districtId: '3201160',
    name: 'Cariu',
  },
  {
    id: '3201160018',
    districtId: '3201160',
    name: 'Kuta Mekar',
  },
  {
    id: '3201160019',
    districtId: '3201160',
    name: 'Sukajadi',
  },
  {
    id: '3201160020',
    districtId: '3201160',
    name: 'Babakan Raden',
  },
  {
    id: '3201161001',
    districtId: '3201161',
    name: 'Cibadak',
  },
  {
    id: '3201161002',
    districtId: '3201161',
    name: 'Tanjung Sari',
  },
  {
    id: '3201161003',
    districtId: '3201161',
    name: 'Sinarsari',
  },
  {
    id: '3201161004',
    districtId: '3201161',
    name: 'Sinarrasa',
  },
  {
    id: '3201161005',
    districtId: '3201161',
    name: 'Buanajaya',
  },
  {
    id: '3201161006',
    districtId: '3201161',
    name: 'Antajaya',
  },
  {
    id: '3201161007',
    districtId: '3201161',
    name: 'Pasir Tanjung',
  },
  {
    id: '3201161008',
    districtId: '3201161',
    name: 'Tanjung Rasa',
  },
  {
    id: '3201161009',
    districtId: '3201161',
    name: 'Sukarasa',
  },
  {
    id: '3201161010',
    districtId: '3201161',
    name: 'Selawangi',
  },
  {
    id: '3201170001',
    districtId: '3201170',
    name: 'Sukajaya',
  },
  {
    id: '3201170002',
    districtId: '3201170',
    name: 'Sukanegara',
  },
  {
    id: '3201170003',
    districtId: '3201170',
    name: 'Cibodas',
  },
  {
    id: '3201170004',
    districtId: '3201170',
    name: 'Singasari',
  },
  {
    id: '3201170005',
    districtId: '3201170',
    name: 'Singajaya',
  },
  {
    id: '3201170006',
    districtId: '3201170',
    name: 'Sukasirna',
  },
  {
    id: '3201170007',
    districtId: '3201170',
    name: 'Balekambang',
  },
  {
    id: '3201170008',
    districtId: '3201170',
    name: 'Bendungan',
  },
  {
    id: '3201170009',
    districtId: '3201170',
    name: 'Sirnagalih',
  },
  {
    id: '3201170010',
    districtId: '3201170',
    name: 'Jonggol',
  },
  {
    id: '3201170011',
    districtId: '3201170',
    name: 'Sukamaju',
  },
  {
    id: '3201170012',
    districtId: '3201170',
    name: 'Sukamanah',
  },
  {
    id: '3201170013',
    districtId: '3201170',
    name: 'Weninggalih',
  },
  {
    id: '3201170014',
    districtId: '3201170',
    name: 'Sukagalih',
  },
  {
    id: '3201180010',
    districtId: '3201180',
    name: 'Dayeuh',
  },
  {
    id: '3201180011',
    districtId: '3201180',
    name: 'Mampir',
  },
  {
    id: '3201180012',
    districtId: '3201180',
    name: 'Setu Sari',
  },
  {
    id: '3201180013',
    districtId: '3201180',
    name: 'Cipeucang',
  },
  {
    id: '3201180014',
    districtId: '3201180',
    name: 'Jatisari',
  },
  {
    id: '3201180015',
    districtId: '3201180',
    name: 'Gandoang',
  },
  {
    id: '3201180016',
    districtId: '3201180',
    name: 'Mekarsari',
  },
  {
    id: '3201180017',
    districtId: '3201180',
    name: 'Cileungsi Kidul',
  },
  {
    id: '3201180018',
    districtId: '3201180',
    name: 'Cileungsi',
  },
  {
    id: '3201180019',
    districtId: '3201180',
    name: 'Limus Nunggal',
  },
  {
    id: '3201180020',
    districtId: '3201180',
    name: 'Pasir Angin',
  },
  {
    id: '3201180021',
    districtId: '3201180',
    name: 'Cipenjo',
  },
  {
    id: '3201181001',
    districtId: '3201181',
    name: 'Leuwikaret',
  },
  {
    id: '3201181003',
    districtId: '3201181',
    name: 'Bantar Jati',
  },
  {
    id: '3201181004',
    districtId: '3201181',
    name: 'Nambo',
  },
  {
    id: '3201181005',
    districtId: '3201181',
    name: 'Kembang Kuning',
  },
  {
    id: '3201181006',
    districtId: '3201181',
    name: 'Kelapa Nunggal',
  },
  {
    id: '3201181007',
    districtId: '3201181',
    name: 'Ligarmukti',
  },
  {
    id: '3201181008',
    districtId: '3201181',
    name: 'Bojong',
  },
  {
    id: '3201181009',
    districtId: '3201181',
    name: 'Cikahuripan',
  },
  {
    id: '3201190001',
    districtId: '3201190',
    name: 'Karanggan',
  },
  {
    id: '3201190002',
    districtId: '3201190',
    name: 'Gunung Putri',
  },
  {
    id: '3201190003',
    districtId: '3201190',
    name: 'Tlajung Udik',
  },
  {
    id: '3201190004',
    districtId: '3201190',
    name: 'Bojong Nangka',
  },
  {
    id: '3201190005',
    districtId: '3201190',
    name: 'Cicadas',
  },
  {
    id: '3201190006',
    districtId: '3201190',
    name: 'Wanaherang',
  },
  {
    id: '3201190007',
    districtId: '3201190',
    name: 'Cikeas Udik',
  },
  {
    id: '3201190008',
    districtId: '3201190',
    name: 'Nagrak',
  },
  {
    id: '3201190009',
    districtId: '3201190',
    name: 'Ciangsana',
  },
  {
    id: '3201190010',
    districtId: '3201190',
    name: 'Bojong Kulur',
  },
  {
    id: '3201200001',
    districtId: '3201200',
    name: 'Tangkil',
  },
  {
    id: '3201200002',
    districtId: '3201200',
    name: 'Hambalang',
  },
  {
    id: '3201200003',
    districtId: '3201200',
    name: 'Tajur',
  },
  {
    id: '3201200004',
    districtId: '3201200',
    name: 'Pasir Mukti',
  },
  {
    id: '3201200005',
    districtId: '3201200',
    name: 'Sukahati',
  },
  {
    id: '3201200006',
    districtId: '3201200',
    name: 'Leuwinutug',
  },
  {
    id: '3201200007',
    districtId: '3201200',
    name: 'Sanja',
  },
  {
    id: '3201200008',
    districtId: '3201200',
    name: 'Karang Asem Barat',
  },
  {
    id: '3201200009',
    districtId: '3201200',
    name: 'Karang Asem Timur',
  },
  {
    id: '3201200010',
    districtId: '3201200',
    name: 'Tarikolot',
  },
  {
    id: '3201200011',
    districtId: '3201200',
    name: 'Gunung Sari',
  },
  {
    id: '3201200012',
    districtId: '3201200',
    name: 'Citeureup',
  },
  {
    id: '3201200013',
    districtId: '3201200',
    name: 'Puspanegara',
  },
  {
    id: '3201200014',
    districtId: '3201200',
    name: 'Puspasari',
  },
  {
    id: '3201210001',
    districtId: '3201210',
    name: 'Karadenan',
  },
  {
    id: '3201210002',
    districtId: '3201210',
    name: 'Nanggewer',
  },
  {
    id: '3201210003',
    districtId: '3201210',
    name: 'Nanggewer Mekar',
  },
  {
    id: '3201210004',
    districtId: '3201210',
    name: 'Cibinong',
  },
  {
    id: '3201210005',
    districtId: '3201210',
    name: 'Pakansari',
  },
  {
    id: '3201210006',
    districtId: '3201210',
    name: 'Sukahati',
  },
  {
    id: '3201210007',
    districtId: '3201210',
    name: 'Tengah',
  },
  {
    id: '3201210008',
    districtId: '3201210',
    name: 'Pondok Rajeg',
  },
  {
    id: '3201210009',
    districtId: '3201210',
    name: 'Harapan Jaya',
  },
  {
    id: '3201210010',
    districtId: '3201210',
    name: 'Pabuaran',
  },
  {
    id: '3201210011',
    districtId: '3201210',
    name: 'Cirimekar',
  },
  {
    id: '3201210012',
    districtId: '3201210',
    name: 'Ciriung',
  },
  {
    id: '3201210013',
    districtId: '3201210',
    name: 'Pabuaran Mekar',
  },
  {
    id: '3201220002',
    districtId: '3201220',
    name: 'Cimanggis',
  },
  {
    id: '3201220003',
    districtId: '3201220',
    name: 'Waringin Jaya',
  },
  {
    id: '3201220004',
    districtId: '3201220',
    name: 'Kedung Waringin',
  },
  {
    id: '3201220005',
    districtId: '3201220',
    name: 'Bojong Gede',
  },
  {
    id: '3201220011',
    districtId: '3201220',
    name: 'Susukan',
  },
  {
    id: '3201220012',
    districtId: '3201220',
    name: 'Bojong Baru',
  },
  {
    id: '3201220013',
    districtId: '3201220',
    name: 'Rawa Panjang',
  },
  {
    id: '3201220014',
    districtId: '3201220',
    name: 'Pabuaran',
  },
  {
    id: '3201220015',
    districtId: '3201220',
    name: 'Ragajaya',
  },
  {
    id: '3201221001',
    districtId: '3201221',
    name: 'Tonjong',
  },
  {
    id: '3201221002',
    districtId: '3201221',
    name: 'Tajur Halang',
  },
  {
    id: '3201221003',
    districtId: '3201221',
    name: 'Sukmajaya',
  },
  {
    id: '3201221004',
    districtId: '3201221',
    name: 'Nanggerang',
  },
  {
    id: '3201221005',
    districtId: '3201221',
    name: 'Sasak Panjang',
  },
  {
    id: '3201221006',
    districtId: '3201221',
    name: 'Kalisuren',
  },
  {
    id: '3201221007',
    districtId: '3201221',
    name: 'Citayam',
  },
  {
    id: '3201230006',
    districtId: '3201230',
    name: 'Semplak Barat',
  },
  {
    id: '3201230007',
    districtId: '3201230',
    name: 'Atang Senjaya',
  },
  {
    id: '3201230008',
    districtId: '3201230',
    name: 'Parakan Jaya',
  },
  {
    id: '3201230009',
    districtId: '3201230',
    name: 'Bojong',
  },
  {
    id: '3201230010',
    districtId: '3201230',
    name: 'Kemang',
  },
  {
    id: '3201230011',
    districtId: '3201230',
    name: 'Pabuaran',
  },
  {
    id: '3201230013',
    districtId: '3201230',
    name: 'Tegal',
  },
  {
    id: '3201230014',
    districtId: '3201230',
    name: 'Pondok Udik',
  },
  {
    id: '3201230015',
    districtId: '3201230',
    name: 'Jampang',
  },
  {
    id: '3201231001',
    districtId: '3201231',
    name: 'Mekarsari',
  },
  {
    id: '3201231002',
    districtId: '3201231',
    name: 'Ranca Bungur',
  },
  {
    id: '3201231003',
    districtId: '3201231',
    name: 'Pasir Gaok',
  },
  {
    id: '3201231004',
    districtId: '3201231',
    name: 'Bantarjaya',
  },
  {
    id: '3201231005',
    districtId: '3201231',
    name: 'Bantar Sari',
  },
  {
    id: '3201231006',
    districtId: '3201231',
    name: 'Candali',
  },
  {
    id: '3201231007',
    districtId: '3201231',
    name: 'Cimulang',
  },
  {
    id: '3201240009',
    districtId: '3201240',
    name: 'Iwul',
  },
  {
    id: '3201240010',
    districtId: '3201240',
    name: 'Jabon Mekar',
  },
  {
    id: '3201240011',
    districtId: '3201240',
    name: 'Pamager Sari',
  },
  {
    id: '3201240012',
    districtId: '3201240',
    name: 'Parung',
  },
  {
    id: '3201240013',
    districtId: '3201240',
    name: 'Waru',
  },
  {
    id: '3201240014',
    districtId: '3201240',
    name: 'Warujaya',
  },
  {
    id: '3201240015',
    districtId: '3201240',
    name: 'Bojong Sempu',
  },
  {
    id: '3201240016',
    districtId: '3201240',
    name: 'Bojong Indah',
  },
  {
    id: '3201240017',
    districtId: '3201240',
    name: 'Cogreg',
  },
  {
    id: '3201241001',
    districtId: '3201241',
    name: 'Karihkil',
  },
  {
    id: '3201241002',
    districtId: '3201241',
    name: 'Cibeuteung Udik',
  },
  {
    id: '3201241003',
    districtId: '3201241',
    name: 'Babakan',
  },
  {
    id: '3201241004',
    districtId: '3201241',
    name: 'Putat Nutug',
  },
  {
    id: '3201241005',
    districtId: '3201241',
    name: 'Cibeuteung Muara',
  },
  {
    id: '3201241006',
    districtId: '3201241',
    name: 'Cibentang',
  },
  {
    id: '3201241007',
    districtId: '3201241',
    name: 'Parigi Mekar',
  },
  {
    id: '3201241008',
    districtId: '3201241',
    name: 'Ciseeng',
  },
  {
    id: '3201241009',
    districtId: '3201241',
    name: 'Cihowe',
  },
  {
    id: '3201241010',
    districtId: '3201241',
    name: 'Kuripan',
  },
  {
    id: '3201250001',
    districtId: '3201250',
    name: 'Jampang',
  },
  {
    id: '3201250002',
    districtId: '3201250',
    name: 'Cibadung',
  },
  {
    id: '3201250003',
    districtId: '3201250',
    name: 'Cibinong',
  },
  {
    id: '3201250004',
    districtId: '3201250',
    name: 'Cidokom',
  },
  {
    id: '3201250005',
    districtId: '3201250',
    name: 'Padurenan',
  },
  {
    id: '3201250007',
    districtId: '3201250',
    name: 'Rawakalong',
  },
  {
    id: '3201250008',
    districtId: '3201250',
    name: 'Pengasinan',
  },
  {
    id: '3201250009',
    districtId: '3201250',
    name: 'Gunung Sindur',
  },
  {
    id: '3201250010',
    districtId: '3201250',
    name: 'Pabuaran',
  },
  {
    id: '3201260001',
    districtId: '3201260',
    name: 'Leuwibatu',
  },
  {
    id: '3201260002',
    districtId: '3201260',
    name: 'Cidokom',
  },
  {
    id: '3201260003',
    districtId: '3201260',
    name: 'Gobang',
  },
  {
    id: '3201260004',
    districtId: '3201260',
    name: 'Rabak',
  },
  {
    id: '3201260005',
    districtId: '3201260',
    name: 'Cibodas',
  },
  {
    id: '3201260006',
    districtId: '3201260',
    name: 'Kampung Sawah',
  },
  {
    id: '3201260007',
    districtId: '3201260',
    name: 'Rumpin',
  },
  {
    id: '3201260008',
    districtId: '3201260',
    name: 'Cipinang',
  },
  {
    id: '3201260009',
    districtId: '3201260',
    name: 'Sukasari',
  },
  {
    id: '3201260010',
    districtId: '3201260',
    name: 'Kertajaya',
  },
  {
    id: '3201260011',
    districtId: '3201260',
    name: 'Taman Sari',
  },
  {
    id: '3201260012',
    districtId: '3201260',
    name: 'Sukamulya',
  },
  {
    id: '3201260013',
    districtId: '3201260',
    name: 'Mekar Sari',
  },
  {
    id: '3201260014',
    districtId: '3201260',
    name: 'Mekarjaya',
  },
  {
    id: '3201270006',
    districtId: '3201270',
    name: 'Sukaraksa',
  },
  {
    id: '3201270009',
    districtId: '3201270',
    name: 'Sukamaju',
  },
  {
    id: '3201270010',
    districtId: '3201270',
    name: 'Cigudeg',
  },
  {
    id: '3201270011',
    districtId: '3201270',
    name: 'Banyu Resmi',
  },
  {
    id: '3201270012',
    districtId: '3201270',
    name: 'Wargajaya',
  },
  {
    id: '3201270013',
    districtId: '3201270',
    name: 'Bunar',
  },
  {
    id: '3201270014',
    districtId: '3201270',
    name: 'Mekarjaya',
  },
  {
    id: '3201270015',
    districtId: '3201270',
    name: 'Cintamanik',
  },
  {
    id: '3201270016',
    districtId: '3201270',
    name: 'Banyu Wangi',
  },
  {
    id: '3201270017',
    districtId: '3201270',
    name: 'Banyu Asih',
  },
  {
    id: '3201270018',
    districtId: '3201270',
    name: 'Tegalega',
  },
  {
    id: '3201270019',
    districtId: '3201270',
    name: 'Batu Jajar',
  },
  {
    id: '3201270020',
    districtId: '3201270',
    name: 'Rengasjajar',
  },
  {
    id: '3201270021',
    districtId: '3201270',
    name: 'Bangunjaya',
  },
  {
    id: '3201270022',
    districtId: '3201270',
    name: 'Argapura',
  },
  {
    id: '3201271001',
    districtId: '3201271',
    name: 'Cisarua',
  },
  {
    id: '3201271002',
    districtId: '3201271',
    name: 'Kiarasari',
  },
  {
    id: '3201271003',
    districtId: '3201271',
    name: 'Kiarapandak',
  },
  {
    id: '3201271004',
    districtId: '3201271',
    name: 'Harkatjaya',
  },
  {
    id: '3201271005',
    districtId: '3201271',
    name: 'Sukajaya',
  },
  {
    id: '3201271006',
    districtId: '3201271',
    name: 'Sipayung',
  },
  {
    id: '3201271007',
    districtId: '3201271',
    name: 'Sukamulih',
  },
  {
    id: '3201271008',
    districtId: '3201271',
    name: 'Pasir Madang',
  },
  {
    id: '3201271009',
    districtId: '3201271',
    name: 'Cileuksa',
  },
  {
    id: '3201271011',
    districtId: '3201271',
    name: 'Jayaraharja',
  },
  {
    id: '3201280003',
    districtId: '3201280',
    name: 'Pangradin',
  },
  {
    id: '3201280004',
    districtId: '3201280',
    name: 'Kalongsawah',
  },
  {
    id: '3201280005',
    districtId: '3201280',
    name: 'Sipak',
  },
  {
    id: '3201280006',
    districtId: '3201280',
    name: 'Pamagersari',
  },
  {
    id: '3201280007',
    districtId: '3201280',
    name: 'Jugala Jaya',
  },
  {
    id: '3201280009',
    districtId: '3201280',
    name: 'Tegal Wangi',
  },
  {
    id: '3201280010',
    districtId: '3201280',
    name: 'Koleang',
  },
  {
    id: '3201280011',
    districtId: '3201280',
    name: 'Jasinga',
  },
  {
    id: '3201280013',
    districtId: '3201280',
    name: 'Cikopomayak',
  },
  {
    id: '3201280014',
    districtId: '3201280',
    name: 'Neglasari',
  },
  {
    id: '3201280015',
    districtId: '3201280',
    name: 'Bagoang',
  },
  {
    id: '3201280016',
    districtId: '3201280',
    name: 'Barengkok',
  },
  {
    id: '3201280017',
    districtId: '3201280',
    name: 'Pangaur',
  },
  {
    id: '3201280018',
    districtId: '3201280',
    name: 'Wirajaya',
  },
  {
    id: '3201290001',
    districtId: '3201290',
    name: 'Ciomas',
  },
  {
    id: '3201290002',
    districtId: '3201290',
    name: 'Tapos',
  },
  {
    id: '3201290003',
    districtId: '3201290',
    name: 'Batok',
  },
  {
    id: '3201290004',
    districtId: '3201290',
    name: 'Babakan',
  },
  {
    id: '3201290005',
    districtId: '3201290',
    name: 'Bojong',
  },
  {
    id: '3201290006',
    districtId: '3201290',
    name: 'Singabraja',
  },
  {
    id: '3201290007',
    districtId: '3201290',
    name: 'Tenjo',
  },
  {
    id: '3201290008',
    districtId: '3201290',
    name: 'Cilaku',
  },
  {
    id: '3201290009',
    districtId: '3201290',
    name: 'Singabangsa',
  },
  {
    id: '3201300001',
    districtId: '3201300',
    name: 'Jagabaya',
  },
  {
    id: '3201300002',
    districtId: '3201300',
    name: 'Gorowong',
  },
  {
    id: '3201300003',
    districtId: '3201300',
    name: 'Dago',
  },
  {
    id: '3201300004',
    districtId: '3201300',
    name: 'Cikuda',
  },
  {
    id: '3201300005',
    districtId: '3201300',
    name: 'Pingku',
  },
  {
    id: '3201300006',
    districtId: '3201300',
    name: 'Lumpang',
  },
  {
    id: '3201300007',
    districtId: '3201300',
    name: 'Gintung Cilejet',
  },
  {
    id: '3201300008',
    districtId: '3201300',
    name: 'Jagabita',
  },
  {
    id: '3201300009',
    districtId: '3201300',
    name: 'Cibunar',
  },
  {
    id: '3201300010',
    districtId: '3201300',
    name: 'Parung Panjang',
  },
  {
    id: '3201300011',
    districtId: '3201300',
    name: 'Kabasiran',
  },
  {
    id: '3202010001',
    districtId: '3202010',
    name: 'Cibenda',
  },
  {
    id: '3202010002',
    districtId: '3202010',
    name: 'Ciwaru',
  },
  {
    id: '3202010003',
    districtId: '3202010',
    name: 'Tamanjaya',
  },
  {
    id: '3202010004',
    districtId: '3202010',
    name: 'Mekarjaya',
  },
  {
    id: '3202010005',
    districtId: '3202010',
    name: 'Ciemas',
  },
  {
    id: '3202010006',
    districtId: '3202010',
    name: 'Girimukti',
  },
  {
    id: '3202010007',
    districtId: '3202010',
    name: 'Mandrajaya',
  },
  {
    id: '3202010008',
    districtId: '3202010',
    name: 'Mekarsakti',
  },
  {
    id: '3202010009',
    districtId: '3202010',
    name: 'Sidamulya',
  },
  {
    id: '3202020001',
    districtId: '3202020',
    name: 'Gunungbatu',
  },
  {
    id: '3202020002',
    districtId: '3202020',
    name: 'Cikangkung',
  },
  {
    id: '3202020003',
    districtId: '3202020',
    name: 'Purwasedar',
  },
  {
    id: '3202020004',
    districtId: '3202020',
    name: 'Ciracap',
  },
  {
    id: '3202020005',
    districtId: '3202020',
    name: 'Pasirpanjang',
  },
  {
    id: '3202020006',
    districtId: '3202020',
    name: 'Mekarsari',
  },
  {
    id: '3202020007',
    districtId: '3202020',
    name: 'Pangumbahan',
  },
  {
    id: '3202021001',
    districtId: '3202021',
    name: 'Caringin Nunggal',
  },
  {
    id: '3202021002',
    districtId: '3202021',
    name: 'Waluran',
  },
  {
    id: '3202021003',
    districtId: '3202021',
    name: 'Sukamukti',
  },
  {
    id: '3202021004',
    districtId: '3202021',
    name: 'Mekar Mukti',
  },
  {
    id: '3202021005',
    districtId: '3202021',
    name: 'Waluran Mandiri',
  },
  {
    id: '3202021006',
    districtId: '3202021',
    name: 'Mangunjaya',
  },
  {
    id: '3202030001',
    districtId: '3202030',
    name: 'Pasiripis',
  },
  {
    id: '3202030002',
    districtId: '3202030',
    name: 'Buniwangi',
  },
  {
    id: '3202030003',
    districtId: '3202030',
    name: 'Cipeundeuy',
  },
  {
    id: '3202030004',
    districtId: '3202030',
    name: 'Gunung Sungging',
  },
  {
    id: '3202030011',
    districtId: '3202030',
    name: 'Citanglar',
  },
  {
    id: '3202030012',
    districtId: '3202030',
    name: 'Jagamukti',
  },
  {
    id: '3202030013',
    districtId: '3202030',
    name: 'Surade',
  },
  {
    id: '3202030014',
    districtId: '3202030',
    name: 'Kadaleman',
  },
  {
    id: '3202030015',
    districtId: '3202030',
    name: 'Wanasari',
  },
  {
    id: '3202030016',
    districtId: '3202030',
    name: 'Sirnasari',
  },
  {
    id: '3202030017',
    districtId: '3202030',
    name: 'Sukatani',
  },
  {
    id: '3202030018',
    districtId: '3202030',
    name: 'Kademangan',
  },
  {
    id: '3202031001',
    districtId: '3202031',
    name: 'Cidahu',
  },
  {
    id: '3202031002',
    districtId: '3202031',
    name: 'Cibitung',
  },
  {
    id: '3202031003',
    districtId: '3202031',
    name: 'Banyuwangi',
  },
  {
    id: '3202031004',
    districtId: '3202031',
    name: 'Cibodas',
  },
  {
    id: '3202031005',
    districtId: '3202031',
    name: 'Banyumurni',
  },
  {
    id: '3202031006',
    districtId: '3202031',
    name: 'Talagamurni',
  },
  {
    id: '3202040001',
    districtId: '3202040',
    name: 'Ciparay',
  },
  {
    id: '3202040002',
    districtId: '3202040',
    name: 'Bojong Genteng',
  },
  {
    id: '3202040003',
    districtId: '3202040',
    name: 'Bojongsari',
  },
  {
    id: '3202040004',
    districtId: '3202040',
    name: 'Mekarjaya',
  },
  {
    id: '3202040005',
    districtId: '3202040',
    name: 'Nagraksari',
  },
  {
    id: '3202040006',
    districtId: '3202040',
    name: 'Jampang Kulon',
  },
  {
    id: '3202040007',
    districtId: '3202040',
    name: 'Tanjung',
  },
  {
    id: '3202040008',
    districtId: '3202040',
    name: 'Padajaya',
  },
  {
    id: '3202040013',
    districtId: '3202040',
    name: 'Cikarang',
  },
  {
    id: '3202040014',
    districtId: '3202040',
    name: 'Karanganyar',
  },
  {
    id: '3202040015',
    districtId: '3202040',
    name: 'Cikaranggeusan',
  },
  {
    id: '3202041001',
    districtId: '3202041',
    name: 'Boregah Indah',
  },
  {
    id: '3202041002',
    districtId: '3202041',
    name: 'Cimanggu',
  },
  {
    id: '3202041003',
    districtId: '3202041',
    name: 'Sukamaju',
  },
  {
    id: '3202041004',
    districtId: '3202041',
    name: 'Sukajadi',
  },
  {
    id: '3202041005',
    districtId: '3202041',
    name: 'Karangmekar',
  },
  {
    id: '3202041006',
    districtId: '3202041',
    name: 'Sukamanah',
  },
  {
    id: '3202050001',
    districtId: '3202050',
    name: 'Cimahpar',
  },
  {
    id: '3202050002',
    districtId: '3202050',
    name: 'Sekarsari',
  },
  {
    id: '3202050003',
    districtId: '3202050',
    name: 'Kalibunder',
  },
  {
    id: '3202050004',
    districtId: '3202050',
    name: 'Sukaluyu',
  },
  {
    id: '3202050005',
    districtId: '3202050',
    name: 'Bojong',
  },
  {
    id: '3202050006',
    districtId: '3202050',
    name: 'Balekambang',
  },
  {
    id: '3202050007',
    districtId: '3202050',
    name: 'Mekarwangi',
  },
  {
    id: '3202060001',
    districtId: '3202060',
    name: 'Sumberjaya',
  },
  {
    id: '3202060002',
    districtId: '3202060',
    name: 'Buniasih',
  },
  {
    id: '3202060003',
    districtId: '3202060',
    name: 'Tegalbuleud',
  },
  {
    id: '3202060004',
    districtId: '3202060',
    name: 'Calingcing',
  },
  {
    id: '3202060005',
    districtId: '3202060',
    name: 'Rambay',
  },
  {
    id: '3202060006',
    districtId: '3202060',
    name: 'Nangela',
  },
  {
    id: '3202060007',
    districtId: '3202060',
    name: 'Bangbayang',
  },
  {
    id: '3202060008',
    districtId: '3202060',
    name: 'Sirnamekar',
  },
  {
    id: '3202070001',
    districtId: '3202070',
    name: 'Cidolog',
  },
  {
    id: '3202070002',
    districtId: '3202070',
    name: 'Mekarjaya',
  },
  {
    id: '3202070003',
    districtId: '3202070',
    name: 'Cikarang',
  },
  {
    id: '3202070004',
    districtId: '3202070',
    name: 'Cipamingkis',
  },
  {
    id: '3202070005',
    districtId: '3202070',
    name: 'Tegallega',
  },
  {
    id: '3202080005',
    districtId: '3202080',
    name: 'Sinar Bentang',
  },
  {
    id: '3202080006',
    districtId: '3202080',
    name: 'Gunung Bentang',
  },
  {
    id: '3202080007',
    districtId: '3202080',
    name: 'Pasanggrahan',
  },
  {
    id: '3202080009',
    districtId: '3202080',
    name: 'Datarnangka',
  },
  {
    id: '3202080010',
    districtId: '3202080',
    name: 'Sagaranten',
  },
  {
    id: '3202080011',
    districtId: '3202080',
    name: 'Margaluyu',
  },
  {
    id: '3202080012',
    districtId: '3202080',
    name: 'Cibitung',
  },
  {
    id: '3202080017',
    districtId: '3202080',
    name: 'Hegarmanah',
  },
  {
    id: '3202080018',
    districtId: '3202080',
    name: 'Cibaregbeg',
  },
  {
    id: '3202080019',
    districtId: '3202080',
    name: 'Puncakmanggis',
  },
  {
    id: '3202080020',
    districtId: '3202080',
    name: 'Mekarsari',
  },
  {
    id: '3202081001',
    districtId: '3202081',
    name: 'Hegarmulya',
  },
  {
    id: '3202081002',
    districtId: '3202081',
    name: 'Cidadap',
  },
  {
    id: '3202081003',
    districtId: '3202081',
    name: 'Padasenang',
  },
  {
    id: '3202081004',
    districtId: '3202081',
    name: 'Banjarsari',
  },
  {
    id: '3202081005',
    districtId: '3202081',
    name: 'Tenjolaut',
  },
  {
    id: '3202081006',
    districtId: '3202081',
    name: 'Mekartani',
  },
  {
    id: '3202082001',
    districtId: '3202082',
    name: 'Cimenteng',
  },
  {
    id: '3202082002',
    districtId: '3202082',
    name: 'Curugkembar',
  },
  {
    id: '3202082003',
    districtId: '3202082',
    name: 'Tanjungsari',
  },
  {
    id: '3202082004',
    districtId: '3202082',
    name: 'Sindangraja',
  },
  {
    id: '3202082005',
    districtId: '3202082',
    name: 'Mekartanjung',
  },
  {
    id: '3202082006',
    districtId: '3202082',
    name: 'Bojong Tugu',
  },
  {
    id: '3202082007',
    districtId: '3202082',
    name: 'Nagrakjaya',
  },
  {
    id: '3202090001',
    districtId: '3202090',
    name: 'Sukajaya',
  },
  {
    id: '3202090002',
    districtId: '3202090',
    name: 'Ciwalat',
  },
  {
    id: '3202090003',
    districtId: '3202090',
    name: 'Pabuaran',
  },
  {
    id: '3202090004',
    districtId: '3202090',
    name: 'Cibadak',
  },
  {
    id: '3202090005',
    districtId: '3202090',
    name: 'Sirnasari',
  },
  {
    id: '3202090006',
    districtId: '3202090',
    name: 'Bantarsari',
  },
  {
    id: '3202090007',
    districtId: '3202090',
    name: 'Lembursawah',
  },
  {
    id: '3202100001',
    districtId: '3202100',
    name: 'Langkapjaya',
  },
  {
    id: '3202100002',
    districtId: '3202100',
    name: 'Cilangkap',
  },
  {
    id: '3202100003',
    districtId: '3202100',
    name: 'Lengkong',
  },
  {
    id: '3202100004',
    districtId: '3202100',
    name: 'Tegallega',
  },
  {
    id: '3202100005',
    districtId: '3202100',
    name: 'Neglasari',
  },
  {
    id: '3202110005',
    districtId: '3202110',
    name: 'Citarik',
  },
  {
    id: '3202110006',
    districtId: '3202110',
    name: 'Palabuhanratu',
  },
  {
    id: '3202110007',
    districtId: '3202110',
    name: 'Citepus',
  },
  {
    id: '3202110008',
    districtId: '3202110',
    name: 'Cibodas',
  },
  {
    id: '3202110009',
    districtId: '3202110',
    name: 'Buniwangi',
  },
  {
    id: '3202110010',
    districtId: '3202110',
    name: 'Cikadu',
  },
  {
    id: '3202110011',
    districtId: '3202110',
    name: 'Pasirsuren',
  },
  {
    id: '3202110012',
    districtId: '3202110',
    name: 'Tonjong',
  },
  {
    id: '3202110013',
    districtId: '3202110',
    name: 'Jayanti',
  },
  {
    id: '3202110014',
    districtId: '3202110',
    name: 'Cimanggu',
  },
  {
    id: '3202111001',
    districtId: '3202111',
    name: 'Cihaur',
  },
  {
    id: '3202111002',
    districtId: '3202111',
    name: 'Kertajaya',
  },
  {
    id: '3202111003',
    districtId: '3202111',
    name: 'Loji',
  },
  {
    id: '3202111004',
    districtId: '3202111',
    name: 'Cidadap',
  },
  {
    id: '3202111005',
    districtId: '3202111',
    name: 'Cibuntu',
  },
  {
    id: '3202111006',
    districtId: '3202111',
    name: 'Mekarasih',
  },
  {
    id: '3202111007',
    districtId: '3202111',
    name: 'Sangrawayang',
  },
  {
    id: '3202120002',
    districtId: '3202120',
    name: 'Hegarmanah',
  },
  {
    id: '3202120003',
    districtId: '3202120',
    name: 'Bantarkalong',
  },
  {
    id: '3202120004',
    districtId: '3202120',
    name: 'Sirnajaya',
  },
  {
    id: '3202120005',
    districtId: '3202120',
    name: 'Bojongkerta',
  },
  {
    id: '3202120007',
    districtId: '3202120',
    name: 'Girijaya',
  },
  {
    id: '3202120008',
    districtId: '3202120',
    name: 'Warungkiara',
  },
  {
    id: '3202120009',
    districtId: '3202120',
    name: 'Sukaharja',
  },
  {
    id: '3202120010',
    districtId: '3202120',
    name: 'Tarisi',
  },
  {
    id: '3202120011',
    districtId: '3202120',
    name: 'Damarraja',
  },
  {
    id: '3202120012',
    districtId: '3202120',
    name: 'Mekarjaya',
  },
  {
    id: '3202120013',
    districtId: '3202120',
    name: 'Kertamukti',
  },
  {
    id: '3202121001',
    districtId: '3202121',
    name: 'Bantargebang',
  },
  {
    id: '3202121002',
    districtId: '3202121',
    name: 'Bojonggaling',
  },
  {
    id: '3202121003',
    districtId: '3202121',
    name: 'Bantargadung',
  },
  {
    id: '3202121004',
    districtId: '3202121',
    name: 'Mangunjaya',
  },
  {
    id: '3202121005',
    districtId: '3202121',
    name: 'Limusnunggal',
  },
  {
    id: '3202121006',
    districtId: '3202121',
    name: 'Buanajaya',
  },
  {
    id: '3202121007',
    districtId: '3202121',
    name: 'Boyongsari',
  },
  {
    id: '3202130001',
    districtId: '3202130',
    name: 'Bantarpanjang',
  },
  {
    id: '3202130009',
    districtId: '3202130',
    name: 'Bojongtipar',
  },
  {
    id: '3202130010',
    districtId: '3202130',
    name: 'Cijulang',
  },
  {
    id: '3202130011',
    districtId: '3202130',
    name: 'Nangerang',
  },
  {
    id: '3202130012',
    districtId: '3202130',
    name: 'Bojong Jengkol',
  },
  {
    id: '3202130013',
    districtId: '3202130',
    name: 'Bantar Agung',
  },
  {
    id: '3202130014',
    districtId: '3202130',
    name: 'Jampang Tengah',
  },
  {
    id: '3202130015',
    districtId: '3202130',
    name: 'Panumbangan',
  },
  {
    id: '3202130016',
    districtId: '3202130',
    name: 'Sindangresmi',
  },
  {
    id: '3202130017',
    districtId: '3202130',
    name: 'Tanjungsari',
  },
  {
    id: '3202130018',
    districtId: '3202130',
    name: 'Padabeunghar',
  },
  {
    id: '3202131001',
    districtId: '3202131',
    name: 'Neglasari',
  },
  {
    id: '3202131002',
    districtId: '3202131',
    name: 'Cicukang',
  },
  {
    id: '3202131003',
    districtId: '3202131',
    name: 'Margaluyu',
  },
  {
    id: '3202131004',
    districtId: '3202131',
    name: 'Purabaya',
  },
  {
    id: '3202131005',
    districtId: '3202131',
    name: 'Pagelaran',
  },
  {
    id: '3202131006',
    districtId: '3202131',
    name: 'Citamiang',
  },
  {
    id: '3202131007',
    districtId: '3202131',
    name: 'Cimerang',
  },
  {
    id: '3202140001',
    districtId: '3202140',
    name: 'Sukamaju',
  },
  {
    id: '3202140002',
    districtId: '3202140',
    name: 'Cibatu',
  },
  {
    id: '3202140003',
    districtId: '3202140',
    name: 'Parakanlima',
  },
  {
    id: '3202140004',
    districtId: '3202140',
    name: 'Kertaraharja',
  },
  {
    id: '3202140005',
    districtId: '3202140',
    name: 'Bojong',
  },
  {
    id: '3202140006',
    districtId: '3202140',
    name: 'Bojongkembar',
  },
  {
    id: '3202140007',
    districtId: '3202140',
    name: 'Cikembar',
  },
  {
    id: '3202140008',
    districtId: '3202140',
    name: 'Cimanggu',
  },
  {
    id: '3202140009',
    districtId: '3202140',
    name: 'Sukamulya',
  },
  {
    id: '3202140010',
    districtId: '3202140',
    name: 'Bojongraharja',
  },
  {
    id: '3202150001',
    districtId: '3202150',
    name: 'Cisitu',
  },
  {
    id: '3202150002',
    districtId: '3202150',
    name: 'Nyalindung',
  },
  {
    id: '3202150003',
    districtId: '3202150',
    name: 'Kertaangsana',
  },
  {
    id: '3202150004',
    districtId: '3202150',
    name: 'Mekarsari',
  },
  {
    id: '3202150005',
    districtId: '3202150',
    name: 'Bojongkalong',
  },
  {
    id: '3202150006',
    districtId: '3202150',
    name: 'Bojongsari',
  },
  {
    id: '3202150007',
    districtId: '3202150',
    name: 'Sukamaju',
  },
  {
    id: '3202150008',
    districtId: '3202150',
    name: 'Wangunreja',
  },
  {
    id: '3202150009',
    districtId: '3202150',
    name: 'Neglasari',
  },
  {
    id: '3202150010',
    districtId: '3202150',
    name: 'Cijangkar',
  },
  {
    id: '3202160001',
    districtId: '3202160',
    name: 'Ciengang',
  },
  {
    id: '3202160002',
    districtId: '3202160',
    name: 'Sukamanah',
  },
  {
    id: '3202160003',
    districtId: '3202160',
    name: 'Gegerbitung',
  },
  {
    id: '3202160004',
    districtId: '3202160',
    name: 'Cijurey',
  },
  {
    id: '3202160005',
    districtId: '3202160',
    name: 'Karangjaya',
  },
  {
    id: '3202160006',
    districtId: '3202160',
    name: 'Buniwangi',
  },
  {
    id: '3202160007',
    districtId: '3202160',
    name: 'Caringin',
  },
  {
    id: '3202170011',
    districtId: '3202170',
    name: 'Selawangi',
  },
  {
    id: '3202170012',
    districtId: '3202170',
    name: 'Pasirhalang',
  },
  {
    id: '3202170013',
    districtId: '3202170',
    name: 'Sukaraja',
  },
  {
    id: '3202170014',
    districtId: '3202170',
    name: 'Sukamekar',
  },
  {
    id: '3202170015',
    districtId: '3202170',
    name: 'Cisarua',
  },
  {
    id: '3202170016',
    districtId: '3202170',
    name: 'Limbangan',
  },
  {
    id: '3202170017',
    districtId: '3202170',
    name: 'Langensari',
  },
  {
    id: '3202170018',
    districtId: '3202170',
    name: 'Selaawi',
  },
  {
    id: '3202170021',
    districtId: '3202170',
    name: 'Margaluyu',
  },
  {
    id: '3202171001',
    districtId: '3202171',
    name: 'Sasagaran',
  },
  {
    id: '3202171002',
    districtId: '3202171',
    name: 'Jambenenggang',
  },
  {
    id: '3202171003',
    districtId: '3202171',
    name: 'Cikaret',
  },
  {
    id: '3202171004',
    districtId: '3202171',
    name: 'Kebonpedes',
  },
  {
    id: '3202171005',
    districtId: '3202171',
    name: 'Bojongsawah',
  },
  {
    id: '3202172001',
    districtId: '3202172',
    name: 'Cipurut',
  },
  {
    id: '3202172002',
    districtId: '3202172',
    name: 'Cireunghas',
  },
  {
    id: '3202172003',
    districtId: '3202172',
    name: 'Bencoy',
  },
  {
    id: '3202172004',
    districtId: '3202172',
    name: 'Cikurutug',
  },
  {
    id: '3202172005',
    districtId: '3202172',
    name: 'Tegalpanjang',
  },
  {
    id: '3202173001',
    districtId: '3202173',
    name: 'Semplak',
  },
  {
    id: '3202173002',
    districtId: '3202173',
    name: 'Prianganjaya',
  },
  {
    id: '3202173003',
    districtId: '3202173',
    name: 'Titisan',
  },
  {
    id: '3202173004',
    districtId: '3202173',
    name: 'Cimangkok',
  },
  {
    id: '3202173005',
    districtId: '3202173',
    name: 'Sukalarang',
  },
  {
    id: '3202173006',
    districtId: '3202173',
    name: 'Sukamaju',
  },
  {
    id: '3202180001',
    districtId: '3202180',
    name: 'Parungseah',
  },
  {
    id: '3202180002',
    districtId: '3202180',
    name: 'Warnasari',
  },
  {
    id: '3202180003',
    districtId: '3202180',
    name: 'Sukajaya',
  },
  {
    id: '3202180004',
    districtId: '3202180',
    name: 'Sudajaya Girang',
  },
  {
    id: '3202180005',
    districtId: '3202180',
    name: 'Karawang',
  },
  {
    id: '3202180006',
    districtId: '3202180',
    name: 'Perbawati',
  },
  {
    id: '3202190001',
    districtId: '3202190',
    name: 'Muaradua',
  },
  {
    id: '3202190002',
    districtId: '3202190',
    name: 'Citamiang',
  },
  {
    id: '3202190003',
    districtId: '3202190',
    name: 'Cikahuripan',
  },
  {
    id: '3202190004',
    districtId: '3202190',
    name: 'Sukamanis',
  },
  {
    id: '3202190005',
    districtId: '3202190',
    name: 'Kadudampit',
  },
  {
    id: '3202190006',
    districtId: '3202190',
    name: 'Gede Pangrango',
  },
  {
    id: '3202190007',
    districtId: '3202190',
    name: 'Sukamaju',
  },
  {
    id: '3202190008',
    districtId: '3202190',
    name: 'Cipetir',
  },
  {
    id: '3202190009',
    districtId: '3202190',
    name: 'Undrus Binangun',
  },
  {
    id: '3202200007',
    districtId: '3202200',
    name: 'Padaasih',
  },
  {
    id: '3202200008',
    districtId: '3202200',
    name: 'Cisaat',
  },
  {
    id: '3202200009',
    districtId: '3202200',
    name: 'Babakan',
  },
  {
    id: '3202200010',
    districtId: '3202200',
    name: 'Sukamantri',
  },
  {
    id: '3202200011',
    districtId: '3202200',
    name: 'Sukamanah',
  },
  {
    id: '3202200012',
    districtId: '3202200',
    name: 'Nagrak',
  },
  {
    id: '3202200013',
    districtId: '3202200',
    name: 'Cibatu',
  },
  {
    id: '3202200014',
    districtId: '3202200',
    name: 'Cibolang Kaler',
  },
  {
    id: '3202200015',
    districtId: '3202200',
    name: 'Kutasirna',
  },
  {
    id: '3202200016',
    districtId: '3202200',
    name: 'Selajambe',
  },
  {
    id: '3202200017',
    districtId: '3202200',
    name: 'Sukasari',
  },
  {
    id: '3202200018',
    districtId: '3202200',
    name: 'Gunungjaya',
  },
  {
    id: '3202200019',
    districtId: '3202200',
    name: 'Sukaresmi',
  },
  {
    id: '3202201001',
    districtId: '3202201',
    name: 'Sirnaresmi',
  },
  {
    id: '3202201002',
    districtId: '3202201',
    name: 'Kebonmanggu',
  },
  {
    id: '3202201004',
    districtId: '3202201',
    name: 'Cikujang',
  },
  {
    id: '3202201005',
    districtId: '3202201',
    name: 'Cibentang',
  },
  {
    id: '3202201006',
    districtId: '3202201',
    name: 'Cibolang',
  },
  {
    id: '3202201007',
    districtId: '3202201',
    name: 'Mangkalaya',
  },
  {
    id: '3202210001',
    districtId: '3202210',
    name: 'Neglasari',
  },
  {
    id: '3202210002',
    districtId: '3202210',
    name: 'Tenjojaya',
  },
  {
    id: '3202210003',
    districtId: '3202210',
    name: 'Sekarwangi',
  },
  {
    id: '3202210009',
    districtId: '3202210',
    name: 'Batununggal',
  },
  {
    id: '3202210010',
    districtId: '3202210',
    name: 'Karangtengah',
  },
  {
    id: '3202210011',
    districtId: '3202210',
    name: 'Cibadak',
  },
  {
    id: '3202210012',
    districtId: '3202210',
    name: 'Warnajati',
  },
  {
    id: '3202210013',
    districtId: '3202210',
    name: 'Sukasirna',
  },
  {
    id: '3202210014',
    districtId: '3202210',
    name: 'Pamuruyan',
  },
  {
    id: '3202210015',
    districtId: '3202210',
    name: 'Ciheulang Tonggoh',
  },
  {
    id: '3202211001',
    districtId: '3202211',
    name: 'Hegarmanah',
  },
  {
    id: '3202211002',
    districtId: '3202211',
    name: 'Cicantayan',
  },
  {
    id: '3202211003',
    districtId: '3202211',
    name: 'Cimahi',
  },
  {
    id: '3202211004',
    districtId: '3202211',
    name: 'Cisande',
  },
  {
    id: '3202211005',
    districtId: '3202211',
    name: 'Cijalingan',
  },
  {
    id: '3202211006',
    districtId: '3202211',
    name: 'Lembursawah',
  },
  {
    id: '3202211007',
    districtId: '3202211',
    name: 'Sukadamai',
  },
  {
    id: '3202211008',
    districtId: '3202211',
    name: 'Cimanggis',
  },
  {
    id: '3202212001',
    districtId: '3202212',
    name: 'Cijengkol',
  },
  {
    id: '3202212002',
    districtId: '3202212',
    name: 'Mekarjaya',
  },
  {
    id: '3202212003',
    districtId: '3202212',
    name: 'Talaga',
  },
  {
    id: '3202212004',
    districtId: '3202212',
    name: 'Caringin Kulon',
  },
  {
    id: '3202212005',
    districtId: '3202212',
    name: 'Caringin Wetan',
  },
  {
    id: '3202212006',
    districtId: '3202212',
    name: 'Seuseupan',
  },
  {
    id: '3202212007',
    districtId: '3202212',
    name: 'Sukamulya',
  },
  {
    id: '3202212008',
    districtId: '3202212',
    name: 'Cikembang',
  },
  {
    id: '3202212009',
    districtId: '3202212',
    name: 'Pasirdatar Indah',
  },
  {
    id: '3202220001',
    districtId: '3202220',
    name: 'Cisarua',
  },
  {
    id: '3202220002',
    districtId: '3202220',
    name: 'Balekambang',
  },
  {
    id: '3202220003',
    districtId: '3202220',
    name: 'Nagrak Selatan',
  },
  {
    id: '3202220004',
    districtId: '3202220',
    name: 'Nagrak Utara',
  },
  {
    id: '3202220005',
    districtId: '3202220',
    name: 'Kalaparea',
  },
  {
    id: '3202220006',
    districtId: '3202220',
    name: 'Darmareja',
  },
  {
    id: '3202220007',
    districtId: '3202220',
    name: 'Girijaya',
  },
  {
    id: '3202220008',
    districtId: '3202220',
    name: 'Babakan Panjang',
  },
  {
    id: '3202220009',
    districtId: '3202220',
    name: 'Pawenang',
  },
  {
    id: '3202220010',
    districtId: '3202220',
    name: 'Cihanyawar',
  },
  {
    id: '3202221002',
    districtId: '3202221',
    name: 'Ciambar',
  },
  {
    id: '3202221003',
    districtId: '3202221',
    name: 'Ginanjar',
  },
  {
    id: '3202221004',
    districtId: '3202221',
    name: 'Wangunjaya',
  },
  {
    id: '3202221005',
    districtId: '3202221',
    name: 'Cibunarjaya',
  },
  {
    id: '3202221006',
    districtId: '3202221',
    name: 'Ambarjaya',
  },
  {
    id: '3202230001',
    districtId: '3202230',
    name: 'Mekarsari',
  },
  {
    id: '3202230002',
    districtId: '3202230',
    name: 'Nyangkowek',
  },
  {
    id: '3202230003',
    districtId: '3202230',
    name: 'Purwasari',
  },
  {
    id: '3202230004',
    districtId: '3202230',
    name: 'Caringin',
  },
  {
    id: '3202230005',
    districtId: '3202230',
    name: 'Bangbayang',
  },
  {
    id: '3202230006',
    districtId: '3202230',
    name: 'Cisaat',
  },
  {
    id: '3202230007',
    districtId: '3202230',
    name: 'Tenjolaya',
  },
  {
    id: '3202230008',
    districtId: '3202230',
    name: 'Pasawahan',
  },
  {
    id: '3202230009',
    districtId: '3202230',
    name: 'Cicurug',
  },
  {
    id: '3202230010',
    districtId: '3202230',
    name: 'Nanggerang',
  },
  {
    id: '3202230011',
    districtId: '3202230',
    name: 'Tenjoayu',
  },
  {
    id: '3202230012',
    districtId: '3202230',
    name: 'Benda',
  },
  {
    id: '3202230013',
    districtId: '3202230',
    name: 'Kutajaya',
  },
  {
    id: '3202240001',
    districtId: '3202240',
    name: 'Pondok Kaso Tengah',
  },
  {
    id: '3202240002',
    districtId: '3202240',
    name: 'Pasirdoton',
  },
  {
    id: '3202240003',
    districtId: '3202240',
    name: 'Pondok Kaso Tonggoh',
  },
  {
    id: '3202240004',
    districtId: '3202240',
    name: 'Babakan Pari',
  },
  {
    id: '3202240005',
    districtId: '3202240',
    name: 'Tangkil',
  },
  {
    id: '3202240006',
    districtId: '3202240',
    name: 'Jayabakti',
  },
  {
    id: '3202240007',
    districtId: '3202240',
    name: 'Cidahu',
  },
  {
    id: '3202240008',
    districtId: '3202240',
    name: 'Girijaya',
  },
  {
    id: '3202250001',
    districtId: '3202250',
    name: 'Sukatani',
  },
  {
    id: '3202250002',
    districtId: '3202250',
    name: 'Sukakersa',
  },
  {
    id: '3202250003',
    districtId: '3202250',
    name: 'Bojonglongok',
  },
  {
    id: '3202250004',
    districtId: '3202250',
    name: 'Bojongasih',
  },
  {
    id: '3202250005',
    districtId: '3202250',
    name: 'Lebaksari',
  },
  {
    id: '3202250006',
    districtId: '3202250',
    name: 'Parakansalak',
  },
  {
    id: '3202260002',
    districtId: '3202260',
    name: 'Palasari Hilir',
  },
  {
    id: '3202260003',
    districtId: '3202260',
    name: 'Sundawenang',
  },
  {
    id: '3202260004',
    districtId: '3202260',
    name: 'Parungkuda',
  },
  {
    id: '3202260008',
    districtId: '3202260',
    name: 'Langensari',
  },
  {
    id: '3202260009',
    districtId: '3202260',
    name: 'Bojong Kokosan',
  },
  {
    id: '3202260010',
    districtId: '3202260',
    name: 'Kompa',
  },
  {
    id: '3202260011',
    districtId: '3202260',
    name: 'Pondok Kaso Landeuh',
  },
  {
    id: '3202260012',
    districtId: '3202260',
    name: 'Babakanjaya',
  },
  {
    id: '3202261001',
    districtId: '3202261',
    name: 'Berekah',
  },
  {
    id: '3202261002',
    districtId: '3202261',
    name: 'Bojong Genteng',
  },
  {
    id: '3202261003',
    districtId: '3202261',
    name: 'Bojong Galing',
  },
  {
    id: '3202261004',
    districtId: '3202261',
    name: 'Cibodas',
  },
  {
    id: '3202261005',
    districtId: '3202261',
    name: 'Cipanengah',
  },
  {
    id: '3202270001',
    districtId: '3202270',
    name: 'Walangsari',
  },
  {
    id: '3202270002',
    districtId: '3202270',
    name: 'Palasari Girang',
  },
  {
    id: '3202270003',
    districtId: '3202270',
    name: 'Kalapanunggal',
  },
  {
    id: '3202270004',
    districtId: '3202270',
    name: 'Kadununggal',
  },
  {
    id: '3202270005',
    districtId: '3202270',
    name: 'Makasari',
  },
  {
    id: '3202270007',
    districtId: '3202270',
    name: 'Pulosari',
  },
  {
    id: '3202280001',
    districtId: '3202280',
    name: 'Sampora',
  },
  {
    id: '3202280002',
    districtId: '3202280',
    name: 'Cijambe',
  },
  {
    id: '3202280003',
    districtId: '3202280',
    name: 'Cikiray',
  },
  {
    id: '3202280004',
    districtId: '3202280',
    name: 'Mekarnangka',
  },
  {
    id: '3202280005',
    districtId: '3202280',
    name: 'Cikidang',
  },
  {
    id: '3202280006',
    districtId: '3202280',
    name: 'Gunung Malang',
  },
  {
    id: '3202280007',
    districtId: '3202280',
    name: 'Nangkakoneng',
  },
  {
    id: '3202280008',
    districtId: '3202280',
    name: 'Pangkalan',
  },
  {
    id: '3202280009',
    districtId: '3202280',
    name: 'Bumisari',
  },
  {
    id: '3202280010',
    districtId: '3202280',
    name: 'Cicareuh',
  },
  {
    id: '3202280011',
    districtId: '3202280',
    name: 'Tamansari',
  },
  {
    id: '3202280012',
    districtId: '3202280',
    name: 'Cikarae Thoyibah',
  },
  {
    id: '3202290001',
    districtId: '3202290',
    name: 'Pasirbaru',
  },
  {
    id: '3202290002',
    districtId: '3202290',
    name: 'Cikahuripan',
  },
  {
    id: '3202290003',
    districtId: '3202290',
    name: 'Cisolok',
  },
  {
    id: '3202290004',
    districtId: '3202290',
    name: 'Karangpapak',
  },
  {
    id: '3202290012',
    districtId: '3202290',
    name: 'Sirnaresmi',
  },
  {
    id: '3202290013',
    districtId: '3202290',
    name: 'Cicadas',
  },
  {
    id: '3202290014',
    districtId: '3202290',
    name: 'Cikelat',
  },
  {
    id: '3202290015',
    districtId: '3202290',
    name: 'Gunung Kramat',
  },
  {
    id: '3202290016',
    districtId: '3202290',
    name: 'Gunung Tanjung',
  },
  {
    id: '3202290017',
    districtId: '3202290',
    name: 'Caringin',
  },
  {
    id: '3202290018',
    districtId: '3202290',
    name: 'Sukarame',
  },
  {
    id: '3202290019',
    districtId: '3202290',
    name: 'Wangunsari',
  },
  {
    id: '3202290020',
    districtId: '3202290',
    name: 'Wanajaya',
  },
  {
    id: '3202291001',
    districtId: '3202291',
    name: 'Cimaja',
  },
  {
    id: '3202291002',
    districtId: '3202291',
    name: 'Cikakak',
  },
  {
    id: '3202291003',
    districtId: '3202291',
    name: 'Sukamaju',
  },
  {
    id: '3202291004',
    districtId: '3202291',
    name: 'Cileungsing',
  },
  {
    id: '3202291005',
    districtId: '3202291',
    name: 'Ridogalih',
  },
  {
    id: '3202291006',
    districtId: '3202291',
    name: 'Margalaksana',
  },
  {
    id: '3202291007',
    districtId: '3202291',
    name: 'Sirnarasa',
  },
  {
    id: '3202291008',
    districtId: '3202291',
    name: 'Gandasoli',
  },
  {
    id: '3202291009',
    districtId: '3202291',
    name: 'Cirendang',
  },
  {
    id: '3202300001',
    districtId: '3202300',
    name: 'Mekarjaya',
  },
  {
    id: '3202300002',
    districtId: '3202300',
    name: 'Tugubandung',
  },
  {
    id: '3202300003',
    districtId: '3202300',
    name: 'Kabandungan',
  },
  {
    id: '3202300004',
    districtId: '3202300',
    name: 'Cipeuteuy',
  },
  {
    id: '3202300005',
    districtId: '3202300',
    name: 'Cihamerang',
  },
  {
    id: '3202300006',
    districtId: '3202300',
    name: 'Cianaga',
  },
  {
    id: '3203010001',
    districtId: '3203010',
    name: 'Sinarlaut',
  },
  {
    id: '3203010002',
    districtId: '3203010',
    name: 'Bojongkaso',
  },
  {
    id: '3203010003',
    districtId: '3203010',
    name: 'Sukamanah',
  },
  {
    id: '3203010004',
    districtId: '3203010',
    name: 'Wanasari',
  },
  {
    id: '3203010007',
    districtId: '3203010',
    name: 'Karangsari',
  },
  {
    id: '3203010008',
    districtId: '3203010',
    name: 'Neglasari',
  },
  {
    id: '3203010009',
    districtId: '3203010',
    name: 'Mulyasari',
  },
  {
    id: '3203010010',
    districtId: '3203010',
    name: 'Bunisari',
  },
  {
    id: '3203010011',
    districtId: '3203010',
    name: 'Mekarsari',
  },
  {
    id: '3203010012',
    districtId: '3203010',
    name: 'Tanjungsari',
  },
  {
    id: '3203010013',
    districtId: '3203010',
    name: 'Wangunjaya',
  },
  {
    id: '3203011001',
    districtId: '3203011',
    name: 'Pusakasari',
  },
  {
    id: '3203011002',
    districtId: '3203011',
    name: 'Nagasari',
  },
  {
    id: '3203011003',
    districtId: '3203011',
    name: 'Sukajaya',
  },
  {
    id: '3203011004',
    districtId: '3203011',
    name: 'Sukamulya',
  },
  {
    id: '3203011005',
    districtId: '3203011',
    name: 'Purabaya',
  },
  {
    id: '3203011006',
    districtId: '3203011',
    name: 'Sukasirna',
  },
  {
    id: '3203011007',
    districtId: '3203011',
    name: 'Walahir',
  },
  {
    id: '3203011008',
    districtId: '3203011',
    name: 'Puncakwangi',
  },
  {
    id: '3203011009',
    districtId: '3203011',
    name: 'Sirnasari',
  },
  {
    id: '3203011010',
    districtId: '3203011',
    name: 'Karyamukti',
  },
  {
    id: '3203011011',
    districtId: '3203011',
    name: 'Mandalawangi',
  },
  {
    id: '3203011012',
    districtId: '3203011',
    name: 'Sindangsari',
  },
  {
    id: '3203020001',
    districtId: '3203020',
    name: 'Hegarsari',
  },
  {
    id: '3203020002',
    districtId: '3203020',
    name: 'Jatisari',
  },
  {
    id: '3203020003',
    districtId: '3203020',
    name: 'Kertasari',
  },
  {
    id: '3203020004',
    districtId: '3203020',
    name: 'Talagasari',
  },
  {
    id: '3203020005',
    districtId: '3203020',
    name: 'Sirnagalih',
  },
  {
    id: '3203020006',
    districtId: '3203020',
    name: 'Saganten',
  },
  {
    id: '3203020007',
    districtId: '3203020',
    name: 'Jayagiri',
  },
  {
    id: '3203020008',
    districtId: '3203020',
    name: 'Muaracikadu',
  },
  {
    id: '3203020009',
    districtId: '3203020',
    name: 'Girimukti',
  },
  {
    id: '3203020010',
    districtId: '3203020',
    name: 'Mekarlaksana',
  },
  {
    id: '3203020011',
    districtId: '3203020',
    name: 'Kertamukti',
  },
  {
    id: '3203030001',
    districtId: '3203030',
    name: 'Karyabakti',
  },
  {
    id: '3203030002',
    districtId: '3203030',
    name: 'Sukapura',
  },
  {
    id: '3203030003',
    districtId: '3203030',
    name: 'Cisalak',
  },
  {
    id: '3203030004',
    districtId: '3203030',
    name: 'Jayapura',
  },
  {
    id: '3203030005',
    districtId: '3203030',
    name: 'Kertajadi',
  },
  {
    id: '3203030006',
    districtId: '3203030',
    name: 'Cidamar',
  },
  {
    id: '3203030007',
    districtId: '3203030',
    name: 'Karangwangi',
  },
  {
    id: '3203030008',
    districtId: '3203030',
    name: 'Cimaragang',
  },
  {
    id: '3203030009',
    districtId: '3203030',
    name: 'Gelarpawitan',
  },
  {
    id: '3203030010',
    districtId: '3203030',
    name: 'Neglasari',
  },
  {
    id: '3203030011',
    districtId: '3203030',
    name: 'Cibuluh',
  },
  {
    id: '3203030012',
    districtId: '3203030',
    name: 'Puncakbaru',
  },
  {
    id: '3203030013',
    districtId: '3203030',
    name: 'Mekarjaya',
  },
  {
    id: '3203030014',
    districtId: '3203030',
    name: 'Gelarwangi',
  },
  {
    id: '3203040001',
    districtId: '3203040',
    name: 'Cinerang',
  },
  {
    id: '3203040002',
    districtId: '3203040',
    name: 'Wangunjaya',
  },
  {
    id: '3203040003',
    districtId: '3203040',
    name: 'Mekarsari',
  },
  {
    id: '3203040004',
    districtId: '3203040',
    name: 'Wangunsari',
  },
  {
    id: '3203040005',
    districtId: '3203040',
    name: 'Malati',
  },
  {
    id: '3203040006',
    districtId: '3203040',
    name: 'Sukamulya',
  },
  {
    id: '3203040007',
    districtId: '3203040',
    name: 'Naringgul',
  },
  {
    id: '3203040008',
    districtId: '3203040',
    name: 'Wanasari',
  },
  {
    id: '3203040009',
    districtId: '3203040',
    name: 'Sukabakti',
  },
  {
    id: '3203040010',
    districtId: '3203040',
    name: 'Balegede',
  },
  {
    id: '3203040011',
    districtId: '3203040',
    name: 'Margasari',
  },
  {
    id: '3203050001',
    districtId: '3203050',
    name: 'Panyindangan',
  },
  {
    id: '3203050002',
    districtId: '3203050',
    name: 'Wargaluyu',
  },
  {
    id: '3203050003',
    districtId: '3203050',
    name: 'Hamerang',
  },
  {
    id: '3203050004',
    districtId: '3203050',
    name: 'Pananggapan',
  },
  {
    id: '3203050005',
    districtId: '3203050',
    name: 'Girijaya',
  },
  {
    id: '3203050006',
    districtId: '3203050',
    name: 'Sukajadi',
  },
  {
    id: '3203050007',
    districtId: '3203050',
    name: 'Sukamekar',
  },
  {
    id: '3203050008',
    districtId: '3203050',
    name: 'Batulawang',
  },
  {
    id: '3203050009',
    districtId: '3203050',
    name: 'Cikangkareng',
  },
  {
    id: '3203050015',
    districtId: '3203050',
    name: 'Pamoyanan',
  },
  {
    id: '3203050016',
    districtId: '3203050',
    name: 'Cimaskara',
  },
  {
    id: '3203050020',
    districtId: '3203050',
    name: 'Padasuka',
  },
  {
    id: '3203050021',
    districtId: '3203050',
    name: 'Mekarmukti',
  },
  {
    id: '3203050022',
    districtId: '3203050',
    name: 'Ciburial',
  },
  {
    id: '3203051001',
    districtId: '3203051',
    name: 'Padaluyu',
  },
  {
    id: '3203051002',
    districtId: '3203051',
    name: 'Sukaluyu',
  },
  {
    id: '3203051003',
    districtId: '3203051',
    name: 'Mekarlaksana',
  },
  {
    id: '3203051004',
    districtId: '3203051',
    name: 'Cikadu',
  },
  {
    id: '3203051005',
    districtId: '3203051',
    name: 'Kalapanunggal',
  },
  {
    id: '3203051006',
    districtId: '3203051',
    name: 'Mekarwangi',
  },
  {
    id: '3203051007',
    districtId: '3203051',
    name: 'Cisaranten',
  },
  {
    id: '3203051008',
    districtId: '3203051',
    name: 'Sukamulya',
  },
  {
    id: '3203051009',
    districtId: '3203051',
    name: 'Mekarjaya',
  },
  {
    id: '3203051010',
    districtId: '3203051',
    name: 'Sukamanah',
  },
  {
    id: '3203060001',
    districtId: '3203060',
    name: 'Karangtengah',
  },
  {
    id: '3203060002',
    districtId: '3203060',
    name: 'Rawagede',
  },
  {
    id: '3203060003',
    districtId: '3203060',
    name: 'Sukajaya',
  },
  {
    id: '3203060004',
    districtId: '3203060',
    name: 'Tanggeung',
  },
  {
    id: '3203060005',
    districtId: '3203060',
    name: 'Kertajaya',
  },
  {
    id: '3203060006',
    districtId: '3203060',
    name: 'Sirnajaya',
  },
  {
    id: '3203060007',
    districtId: '3203060',
    name: 'Pasir Jambu',
  },
  {
    id: '3203060008',
    districtId: '3203060',
    name: 'Cilongsong',
  },
  {
    id: '3203060009',
    districtId: '3203060',
    name: 'Margaluyu',
  },
  {
    id: '3203060010',
    districtId: '3203060',
    name: 'Pagermaneuh',
  },
  {
    id: '3203060011',
    districtId: '3203060',
    name: 'Bojongpetir',
  },
  {
    id: '3203060012',
    districtId: '3203060',
    name: 'Padaluyu',
  },
  {
    id: '3203061001',
    districtId: '3203061',
    name: 'Mekarmulya',
  },
  {
    id: '3203061002',
    districtId: '3203061',
    name: 'Kubang',
  },
  {
    id: '3203061003',
    districtId: '3203061',
    name: 'Girijaya',
  },
  {
    id: '3203061004',
    districtId: '3203061',
    name: 'Girimukti',
  },
  {
    id: '3203061005',
    districtId: '3203061',
    name: 'Simpang',
  },
  {
    id: '3203061006',
    districtId: '3203061',
    name: 'Kalibaru',
  },
  {
    id: '3203061007',
    districtId: '3203061',
    name: 'Pusakajaya',
  },
  {
    id: '3203061008',
    districtId: '3203061',
    name: 'Karangjaya',
  },
  {
    id: '3203061009',
    districtId: '3203061',
    name: 'Padamulya',
  },
  {
    id: '3203070010',
    districtId: '3203070',
    name: 'Pasirdalem',
  },
  {
    id: '3203070011',
    districtId: '3203070',
    name: 'Sukaraja',
  },
  {
    id: '3203070012',
    districtId: '3203070',
    name: 'Kadupandak',
  },
  {
    id: '3203070013',
    districtId: '3203070',
    name: 'Talagasari',
  },
  {
    id: '3203070014',
    districtId: '3203070',
    name: 'Neglasari',
  },
  {
    id: '3203070015',
    districtId: '3203070',
    name: 'Sukakerta',
  },
  {
    id: '3203070016',
    districtId: '3203070',
    name: 'Sukaraharja',
  },
  {
    id: '3203070017',
    districtId: '3203070',
    name: 'Bojongkasih',
  },
  {
    id: '3203070018',
    districtId: '3203070',
    name: 'Sukasari',
  },
  {
    id: '3203070019',
    districtId: '3203070',
    name: 'Wargasari',
  },
  {
    id: '3203070020',
    districtId: '3203070',
    name: 'Wargaasih',
  },
  {
    id: '3203070021',
    districtId: '3203070',
    name: 'Sukaresmi',
  },
  {
    id: '3203070022',
    districtId: '3203070',
    name: 'Gandasari',
  },
  {
    id: '3203070023',
    districtId: '3203070',
    name: 'Sindangsari',
  },
  {
    id: '3203071001',
    districtId: '3203071',
    name: 'Padaasih',
  },
  {
    id: '3203071002',
    districtId: '3203071',
    name: 'Sukaluyu',
  },
  {
    id: '3203071003',
    districtId: '3203071',
    name: 'Sinarbakti',
  },
  {
    id: '3203071004',
    districtId: '3203071',
    name: 'Bojonglarang',
  },
  {
    id: '3203071005',
    districtId: '3203071',
    name: 'Sukamahi',
  },
  {
    id: '3203071006',
    districtId: '3203071',
    name: 'Cijati',
  },
  {
    id: '3203071007',
    districtId: '3203071',
    name: 'Cibodas',
  },
  {
    id: '3203071008',
    districtId: '3203071',
    name: 'Caringin',
  },
  {
    id: '3203071009',
    districtId: '3203071',
    name: 'Parakantugu',
  },
  {
    id: '3203071010',
    districtId: '3203071',
    name: 'Sukamaju',
  },
  {
    id: '3203080001',
    districtId: '3203080',
    name: 'Waringinsari',
  },
  {
    id: '3203080002',
    districtId: '3203080',
    name: 'Sukagalih',
  },
  {
    id: '3203080003',
    districtId: '3203080',
    name: 'Simpang',
  },
  {
    id: '3203080004',
    districtId: '3203080',
    name: 'Sindanghayu',
  },
  {
    id: '3203080005',
    districtId: '3203080',
    name: 'Sindangresmi',
  },
  {
    id: '3203080006',
    districtId: '3203080',
    name: 'Bungbangsari',
  },
  {
    id: '3203080007',
    districtId: '3203080',
    name: 'Cisujen',
  },
  {
    id: '3203080008',
    districtId: '3203080',
    name: 'Pasawahan',
  },
  {
    id: '3203080009',
    districtId: '3203080',
    name: 'Hegarmanah',
  },
  {
    id: '3203090001',
    districtId: '3203090',
    name: 'Jayagiri',
  },
  {
    id: '3203090002',
    districtId: '3203090',
    name: 'Ciguha',
  },
  {
    id: '3203090003',
    districtId: '3203090',
    name: 'Sukakarya',
  },
  {
    id: '3203090004',
    districtId: '3203090',
    name: 'Sukarame',
  },
  {
    id: '3203090005',
    districtId: '3203090',
    name: 'Sukalaksana',
  },
  {
    id: '3203090006',
    districtId: '3203090',
    name: 'Sukanagara',
  },
  {
    id: '3203090007',
    districtId: '3203090',
    name: 'Gunungsari',
  },
  {
    id: '3203090008',
    districtId: '3203090',
    name: 'Sindangsari',
  },
  {
    id: '3203090009',
    districtId: '3203090',
    name: 'Sukajembar',
  },
  {
    id: '3203090010',
    districtId: '3203090',
    name: 'Sukamekar',
  },
  {
    id: '3203100001',
    districtId: '3203100',
    name: 'Kertaraharja',
  },
  {
    id: '3203100002',
    districtId: '3203100',
    name: 'Pagelaran',
  },
  {
    id: '3203100003',
    districtId: '3203100',
    name: 'Padamaju',
  },
  {
    id: '3203100008',
    districtId: '3203100',
    name: 'Buniwangi',
  },
  {
    id: '3203100009',
    districtId: '3203100',
    name: 'Bunijaya',
  },
  {
    id: '3203100010',
    districtId: '3203100',
    name: 'Pangadegan',
  },
  {
    id: '3203100011',
    districtId: '3203100',
    name: 'Situhiang',
  },
  {
    id: '3203100012',
    districtId: '3203100',
    name: 'Pasirbaru',
  },
  {
    id: '3203100013',
    districtId: '3203100',
    name: 'Sindangkerta',
  },
  {
    id: '3203100014',
    districtId: '3203100',
    name: 'Karangharja',
  },
  {
    id: '3203100015',
    districtId: '3203100',
    name: 'Selagedang',
  },
  {
    id: '3203100016',
    districtId: '3203100',
    name: 'Gelar Anyar',
  },
  {
    id: '3203100017',
    districtId: '3203100',
    name: 'Mekarsari',
  },
  {
    id: '3203100018',
    districtId: '3203100',
    name: 'Sukamaju',
  },
  {
    id: '3203110001',
    districtId: '3203110',
    name: 'Wangunjaya',
  },
  {
    id: '3203110002',
    districtId: '3203110',
    name: 'Sukadana',
  },
  {
    id: '3203110003',
    districtId: '3203110',
    name: 'Karyamukti',
  },
  {
    id: '3203110004',
    districtId: '3203110',
    name: 'Cimenteng',
  },
  {
    id: '3203110005',
    districtId: '3203110',
    name: 'Girimukti',
  },
  {
    id: '3203110006',
    districtId: '3203110',
    name: 'Susukan',
  },
  {
    id: '3203110007',
    districtId: '3203110',
    name: 'Sukajadi',
  },
  {
    id: '3203110008',
    districtId: '3203110',
    name: 'Margaluyu',
  },
  {
    id: '3203110009',
    districtId: '3203110',
    name: 'Mekarjaya',
  },
  {
    id: '3203110010',
    districtId: '3203110',
    name: 'Cidadap',
  },
  {
    id: '3203110011',
    districtId: '3203110',
    name: 'Campaka',
  },
  {
    id: '3203111001',
    districtId: '3203111',
    name: 'Campakawarna',
  },
  {
    id: '3203111002',
    districtId: '3203111',
    name: 'Campakamulya',
  },
  {
    id: '3203111003',
    districtId: '3203111',
    name: 'Sukabungah',
  },
  {
    id: '3203111004',
    districtId: '3203111',
    name: 'Cibanggala',
  },
  {
    id: '3203111005',
    districtId: '3203111',
    name: 'Sukasirna',
  },
  {
    id: '3203120001',
    districtId: '3203120',
    name: 'Cibokor',
  },
  {
    id: '3203120002',
    districtId: '3203120',
    name: 'Kanoman',
  },
  {
    id: '3203120003',
    districtId: '3203120',
    name: 'Cipetir',
  },
  {
    id: '3203120004',
    districtId: '3203120',
    name: 'Cikondang',
  },
  {
    id: '3203120005',
    districtId: '3203120',
    name: 'Cihaur',
  },
  {
    id: '3203120006',
    districtId: '3203120',
    name: 'Sukamanah',
  },
  {
    id: '3203120007',
    districtId: '3203120',
    name: 'Salagedang',
  },
  {
    id: '3203120008',
    districtId: '3203120',
    name: 'Cibadak',
  },
  {
    id: '3203120009',
    districtId: '3203120',
    name: 'Girimulya',
  },
  {
    id: '3203120010',
    districtId: '3203120',
    name: 'Cimanggu',
  },
  {
    id: '3203120011',
    districtId: '3203120',
    name: 'Cisalak',
  },
  {
    id: '3203120012',
    districtId: '3203120',
    name: 'Mayak',
  },
  {
    id: '3203120013',
    districtId: '3203120',
    name: 'Peuteuycondong',
  },
  {
    id: '3203120014',
    districtId: '3203120',
    name: 'Sukaraharja',
  },
  {
    id: '3203120015',
    districtId: '3203120',
    name: 'Sukamaju',
  },
  {
    id: '3203120016',
    districtId: '3203120',
    name: 'Cibaregbeg',
  },
  {
    id: '3203120017',
    districtId: '3203120',
    name: 'Karangnunggal',
  },
  {
    id: '3203120018',
    districtId: '3203120',
    name: 'Salamnunggal',
  },
  {
    id: '3203130002',
    districtId: '3203130',
    name: 'Cisarandi',
  },
  {
    id: '3203130003',
    districtId: '3203130',
    name: 'Sukamulya',
  },
  {
    id: '3203130004',
    districtId: '3203130',
    name: 'Cikaroya',
  },
  {
    id: '3203130012',
    districtId: '3203130',
    name: 'Jambudipa',
  },
  {
    id: '3203130013',
    districtId: '3203130',
    name: 'Mekarwangi',
  },
  {
    id: '3203130014',
    districtId: '3203130',
    name: 'Tegallega',
  },
  {
    id: '3203130015',
    districtId: '3203130',
    name: 'Bunikasih',
  },
  {
    id: '3203130016',
    districtId: '3203130',
    name: 'Bunisari',
  },
  {
    id: '3203130017',
    districtId: '3203130',
    name: 'Cieundeur',
  },
  {
    id: '3203130018',
    districtId: '3203130',
    name: 'Ciwalen',
  },
  {
    id: '3203130019',
    districtId: '3203130',
    name: 'Sukawangi',
  },
  {
    id: '3203131001',
    districtId: '3203131',
    name: 'Cintaasih',
  },
  {
    id: '3203131002',
    districtId: '3203131',
    name: 'Cikancana',
  },
  {
    id: '3203131003',
    districtId: '3203131',
    name: 'Sukaratu',
  },
  {
    id: '3203131004',
    districtId: '3203131',
    name: 'Bangbayang',
  },
  {
    id: '3203131005',
    districtId: '3203131',
    name: 'Songgom',
  },
  {
    id: '3203131006',
    districtId: '3203131',
    name: 'Cikahuripan',
  },
  {
    id: '3203131007',
    districtId: '3203131',
    name: 'Gekbrong',
  },
  {
    id: '3203131008',
    districtId: '3203131',
    name: 'Kebonpeuteuy',
  },
  {
    id: '3203140001',
    districtId: '3203140',
    name: 'Sukasari',
  },
  {
    id: '3203140002',
    districtId: '3203140',
    name: 'Sukakerta',
  },
  {
    id: '3203140003',
    districtId: '3203140',
    name: 'Sindangsari',
  },
  {
    id: '3203140004',
    districtId: '3203140',
    name: 'Mulyasari',
  },
  {
    id: '3203140005',
    districtId: '3203140',
    name: 'Ciharashas',
  },
  {
    id: '3203140006',
    districtId: '3203140',
    name: 'Cibinong Hilir',
  },
  {
    id: '3203140007',
    districtId: '3203140',
    name: 'Sirnagalih',
  },
  {
    id: '3203140008',
    districtId: '3203140',
    name: 'Rahong',
  },
  {
    id: '3203140010',
    districtId: '3203140',
    name: 'Rancagoong',
  },
  {
    id: '3203150001',
    districtId: '3203150',
    name: 'Mekarjaya',
  },
  {
    id: '3203150002',
    districtId: '3203150',
    name: 'Panyusuhan',
  },
  {
    id: '3203150003',
    districtId: '3203150',
    name: 'Sukaluyu',
  },
  {
    id: '3203150004',
    districtId: '3203150',
    name: 'Sukamulya',
  },
  {
    id: '3203150005',
    districtId: '3203150',
    name: 'Babakansari',
  },
  {
    id: '3203150006',
    districtId: '3203150',
    name: 'Tanjungsari',
  },
  {
    id: '3203150007',
    districtId: '3203150',
    name: 'Selajambe',
  },
  {
    id: '3203150008',
    districtId: '3203150',
    name: 'Hegarmanah',
  },
  {
    id: '3203150009',
    districtId: '3203150',
    name: 'Sukasirna',
  },
  {
    id: '3203150010',
    districtId: '3203150',
    name: 'Sindangraja',
  },
  {
    id: '3203160001',
    districtId: '3203160',
    name: 'Sukarama',
  },
  {
    id: '3203160002',
    districtId: '3203160',
    name: 'Sukajaya',
  },
  {
    id: '3203160003',
    districtId: '3203160',
    name: 'Cikondang',
  },
  {
    id: '3203160004',
    districtId: '3203160',
    name: 'Jatisari',
  },
  {
    id: '3203160005',
    districtId: '3203160',
    name: 'Kemang',
  },
  {
    id: '3203160006',
    districtId: '3203160',
    name: 'Cibarengkok',
  },
  {
    id: '3203160007',
    districtId: '3203160',
    name: 'Jati',
  },
  {
    id: '3203160008',
    districtId: '3203160',
    name: 'Bojongpicung',
  },
  {
    id: '3203160009',
    districtId: '3203160',
    name: 'Sukaratu',
  },
  {
    id: '3203160012',
    districtId: '3203160',
    name: 'Neglasari',
  },
  {
    id: '3203160013',
    districtId: '3203160',
    name: 'Hegarmanah',
  },
  {
    id: '3203161001',
    districtId: '3203161',
    name: 'Cihea',
  },
  {
    id: '3203161002',
    districtId: '3203161',
    name: 'Sukatani',
  },
  {
    id: '3203161003',
    districtId: '3203161',
    name: 'Ramasari',
  },
  {
    id: '3203161004',
    districtId: '3203161',
    name: 'Haurwangi',
  },
  {
    id: '3203161005',
    districtId: '3203161',
    name: 'Kertasari',
  },
  {
    id: '3203161006',
    districtId: '3203161',
    name: 'Kertamukti',
  },
  {
    id: '3203161007',
    districtId: '3203161',
    name: 'Cipeuyeum',
  },
  {
    id: '3203161008',
    districtId: '3203161',
    name: 'Mekarwangi',
  },
  {
    id: '3203170004',
    districtId: '3203170',
    name: 'Karangwangi',
  },
  {
    id: '3203170005',
    districtId: '3203170',
    name: 'Gunungsari',
  },
  {
    id: '3203170006',
    districtId: '3203170',
    name: 'Kertajaya',
  },
  {
    id: '3203170007',
    districtId: '3203170',
    name: 'Sindangjaya',
  },
  {
    id: '3203170008',
    districtId: '3203170',
    name: 'Sindangsari',
  },
  {
    id: '3203170009',
    districtId: '3203170',
    name: 'Cibiuk',
  },
  {
    id: '3203170010',
    districtId: '3203170',
    name: 'Mekargalih',
  },
  {
    id: '3203170011',
    districtId: '3203170',
    name: 'Ciranjang',
  },
  {
    id: '3203170012',
    districtId: '3203170',
    name: 'Nanggalamekar',
  },
  {
    id: '3203180001',
    districtId: '3203180',
    name: 'Mekarjaya',
  },
  {
    id: '3203180002',
    districtId: '3203180',
    name: 'Leuwikoja',
  },
  {
    id: '3203180003',
    districtId: '3203180',
    name: 'Kutawaringin',
  },
  {
    id: '3203180004',
    districtId: '3203180',
    name: 'Sukamanah',
  },
  {
    id: '3203180005',
    districtId: '3203180',
    name: 'Ciandam',
  },
  {
    id: '3203180006',
    districtId: '3203180',
    name: 'Jamali',
  },
  {
    id: '3203180007',
    districtId: '3203180',
    name: 'Kademangan',
  },
  {
    id: '3203180008',
    districtId: '3203180',
    name: 'Mulyasari',
  },
  {
    id: '3203180009',
    districtId: '3203180',
    name: 'Bobojong',
  },
  {
    id: '3203180010',
    districtId: '3203180',
    name: 'Cikidangbayabang',
  },
  {
    id: '3203180011',
    districtId: '3203180',
    name: 'Murnisari',
  },
  {
    id: '3203180012',
    districtId: '3203180',
    name: 'Mande',
  },
  {
    id: '3203190001',
    districtId: '3203190',
    name: 'Sukamanah',
  },
  {
    id: '3203190002',
    districtId: '3203190',
    name: 'Sindangasih',
  },
  {
    id: '3203190003',
    districtId: '3203190',
    name: 'Langensari',
  },
  {
    id: '3203190004',
    districtId: '3203190',
    name: 'Sukasari',
  },
  {
    id: '3203190005',
    districtId: '3203190',
    name: 'Maleber',
  },
  {
    id: '3203190006',
    districtId: '3203190',
    name: 'Sabandar',
  },
  {
    id: '3203190007',
    districtId: '3203190',
    name: 'Bojong',
  },
  {
    id: '3203190008',
    districtId: '3203190',
    name: 'Hegarmanah',
  },
  {
    id: '3203190009',
    districtId: '3203190',
    name: 'Babakancaringin',
  },
  {
    id: '3203190010',
    districtId: '3203190',
    name: 'Ciherang',
  },
  {
    id: '3203190011',
    districtId: '3203190',
    name: 'Sukajadi',
  },
  {
    id: '3203190012',
    districtId: '3203190',
    name: 'Sukasarana',
  },
  {
    id: '3203190013',
    districtId: '3203190',
    name: 'Sukamantri',
  },
  {
    id: '3203190014',
    districtId: '3203190',
    name: 'Sukamulya',
  },
  {
    id: '3203190015',
    districtId: '3203190',
    name: 'Sindanglaka',
  },
  {
    id: '3203190016',
    districtId: '3203190',
    name: 'Sukataris',
  },
  {
    id: '3203200001',
    districtId: '3203200',
    name: 'Nagrak',
  },
  {
    id: '3203200002',
    districtId: '3203200',
    name: 'Sukamaju',
  },
  {
    id: '3203200003',
    districtId: '3203200',
    name: 'Sayang',
  },
  {
    id: '3203200004',
    districtId: '3203200',
    name: 'Solokpandan',
  },
  {
    id: '3203200005',
    districtId: '3203200',
    name: 'Muka',
  },
  {
    id: '3203200006',
    districtId: '3203200',
    name: 'Bojongherang',
  },
  {
    id: '3203200007',
    districtId: '3203200',
    name: 'Pamoyanan',
  },
  {
    id: '3203200008',
    districtId: '3203200',
    name: 'Sawah Gede',
  },
  {
    id: '3203200009',
    districtId: '3203200',
    name: 'Limbangan Sari',
  },
  {
    id: '3203200010',
    districtId: '3203200',
    name: 'Mekarsari',
  },
  {
    id: '3203200011',
    districtId: '3203200',
    name: 'Babakankaret',
  },
  {
    id: '3203210001',
    districtId: '3203210',
    name: 'Padaluyu',
  },
  {
    id: '3203210002',
    districtId: '3203210',
    name: 'Sukajaya',
  },
  {
    id: '3203210003',
    districtId: '3203210',
    name: 'Cibulakan',
  },
  {
    id: '3203210004',
    districtId: '3203210',
    name: 'Cirumput',
  },
  {
    id: '3203210005',
    districtId: '3203210',
    name: 'Talaga',
  },
  {
    id: '3203210006',
    districtId: '3203210',
    name: 'Benjot',
  },
  {
    id: '3203210007',
    districtId: '3203210',
    name: 'Gasol',
  },
  {
    id: '3203210008',
    districtId: '3203210',
    name: 'Sarampad',
  },
  {
    id: '3203210009',
    districtId: '3203210',
    name: 'Mangunkerta',
  },
  {
    id: '3203210010',
    districtId: '3203210',
    name: 'Sukamulya',
  },
  {
    id: '3203210011',
    districtId: '3203210',
    name: 'Galudra',
  },
  {
    id: '3203210012',
    districtId: '3203210',
    name: 'Nyalindung',
  },
  {
    id: '3203210013',
    districtId: '3203210',
    name: 'Cibeureum',
  },
  {
    id: '3203210014',
    districtId: '3203210',
    name: 'Cijedil',
  },
  {
    id: '3203210015',
    districtId: '3203210',
    name: 'Sukamanah',
  },
  {
    id: '3203210016',
    districtId: '3203210',
    name: 'Wangunjaya',
  },
  {
    id: '3203220001',
    districtId: '3203220',
    name: 'Ciputri',
  },
  {
    id: '3203220002',
    districtId: '3203220',
    name: 'Ciherang',
  },
  {
    id: '3203220003',
    districtId: '3203220',
    name: 'Cipendawa',
  },
  {
    id: '3203220004',
    districtId: '3203220',
    name: 'Cibodas',
  },
  {
    id: '3203220005',
    districtId: '3203220',
    name: 'Gadog',
  },
  {
    id: '3203220008',
    districtId: '3203220',
    name: 'Sukatani',
  },
  {
    id: '3203220014',
    districtId: '3203220',
    name: 'Sukanagalih',
  },
  {
    id: '3203221001',
    districtId: '3203221',
    name: 'Sindangjaya',
  },
  {
    id: '3203221002',
    districtId: '3203221',
    name: 'Cipanas',
  },
  {
    id: '3203221003',
    districtId: '3203221',
    name: 'Sindanglaya',
  },
  {
    id: '3203221004',
    districtId: '3203221',
    name: 'Palasari',
  },
  {
    id: '3203221005',
    districtId: '3203221',
    name: 'Cimacan',
  },
  {
    id: '3203221006',
    districtId: '3203221',
    name: 'Ciloto',
  },
  {
    id: '3203221007',
    districtId: '3203221',
    name: 'Batulawang',
  },
  {
    id: '3203230001',
    districtId: '3203230',
    name: 'Pakuon',
  },
  {
    id: '3203230002',
    districtId: '3203230',
    name: 'Cikanyere',
  },
  {
    id: '3203230003',
    districtId: '3203230',
    name: 'Sukaresmi',
  },
  {
    id: '3203230004',
    districtId: '3203230',
    name: 'Ciwalen',
  },
  {
    id: '3203230005',
    districtId: '3203230',
    name: 'Kawungluwuk',
  },
  {
    id: '3203230006',
    districtId: '3203230',
    name: 'Cibadak',
  },
  {
    id: '3203230007',
    districtId: '3203230',
    name: 'Rawabelut',
  },
  {
    id: '3203230008',
    districtId: '3203230',
    name: 'Cibanteng',
  },
  {
    id: '3203230009',
    districtId: '3203230',
    name: 'Kubang',
  },
  {
    id: '3203230010',
    districtId: '3203230',
    name: 'Sukamahi',
  },
  {
    id: '3203230011',
    districtId: '3203230',
    name: 'Cikancana',
  },
  {
    id: '3203240001',
    districtId: '3203240',
    name: 'Padajaya',
  },
  {
    id: '3203240002',
    districtId: '3203240',
    name: 'Cinangsi',
  },
  {
    id: '3203240003',
    districtId: '3203240',
    name: 'Mentengsari',
  },
  {
    id: '3203240004',
    districtId: '3203240',
    name: 'Gudang',
  },
  {
    id: '3203240005',
    districtId: '3203240',
    name: 'Sukagalih',
  },
  {
    id: '3203240006',
    districtId: '3203240',
    name: 'Majalaya',
  },
  {
    id: '3203240007',
    districtId: '3203240',
    name: 'Cijagang',
  },
  {
    id: '3203240008',
    districtId: '3203240',
    name: 'Mekarjaya',
  },
  {
    id: '3203240009',
    districtId: '3203240',
    name: 'Mekar Sari',
  },
  {
    id: '3203240010',
    districtId: '3203240',
    name: 'Sukamulya',
  },
  {
    id: '3203240011',
    districtId: '3203240',
    name: 'Mekargalih',
  },
  {
    id: '3203240012',
    districtId: '3203240',
    name: 'Neglasari',
  },
  {
    id: '3203240013',
    districtId: '3203240',
    name: 'Lembahsari',
  },
  {
    id: '3203240014',
    districtId: '3203240',
    name: 'Warudoyong',
  },
  {
    id: '3203240015',
    districtId: '3203240',
    name: 'Kamurang',
  },
  {
    id: '3203240016',
    districtId: '3203240',
    name: 'Cirama Girang',
  },
  {
    id: '3203240017',
    districtId: '3203240',
    name: 'Mekar Mulya',
  },
  {
    id: '3203240018',
    districtId: '3203240',
    name: 'Cigunungherang',
  },
  {
    id: '3204010001',
    districtId: '3204010',
    name: 'Panundaan',
  },
  {
    id: '3204010002',
    districtId: '3204010',
    name: 'Ciwidey',
  },
  {
    id: '3204010003',
    districtId: '3204010',
    name: 'Panyocokan',
  },
  {
    id: '3204010004',
    districtId: '3204010',
    name: 'Lebakmuncang',
  },
  {
    id: '3204010005',
    districtId: '3204010',
    name: 'Rawabogo',
  },
  {
    id: '3204010006',
    districtId: '3204010',
    name: 'Nengkelan',
  },
  {
    id: '3204010007',
    districtId: '3204010',
    name: 'Sukawening',
  },
  {
    id: '3204011001',
    districtId: '3204011',
    name: 'Cipelah',
  },
  {
    id: '3204011002',
    districtId: '3204011',
    name: 'Sukaresmi',
  },
  {
    id: '3204011003',
    districtId: '3204011',
    name: 'Indragiri',
  },
  {
    id: '3204011004',
    districtId: '3204011',
    name: 'Patengan',
  },
  {
    id: '3204011005',
    districtId: '3204011',
    name: 'Alamendah',
  },
  {
    id: '3204020001',
    districtId: '3204020',
    name: 'Sugihmukti',
  },
  {
    id: '3204020002',
    districtId: '3204020',
    name: 'Margamulya',
  },
  {
    id: '3204020003',
    districtId: '3204020',
    name: 'Tenjolaya',
  },
  {
    id: '3204020004',
    districtId: '3204020',
    name: 'Cisondari',
  },
  {
    id: '3204020005',
    districtId: '3204020',
    name: 'Mekarsari',
  },
  {
    id: '3204020006',
    districtId: '3204020',
    name: 'Cibodas',
  },
  {
    id: '3204020007',
    districtId: '3204020',
    name: 'Cukanggenteng',
  },
  {
    id: '3204020008',
    districtId: '3204020',
    name: 'Pasirjambu',
  },
  {
    id: '3204020009',
    districtId: '3204020',
    name: 'Mekarmaju',
  },
  {
    id: '3204020010',
    districtId: '3204020',
    name: 'Cikoneng',
  },
  {
    id: '3204030001',
    districtId: '3204030',
    name: 'Cikalong',
  },
  {
    id: '3204030002',
    districtId: '3204030',
    name: 'Mekarsari',
  },
  {
    id: '3204030003',
    districtId: '3204030',
    name: 'Cipinang',
  },
  {
    id: '3204030004',
    districtId: '3204030',
    name: 'Cimaung',
  },
  {
    id: '3204030005',
    districtId: '3204030',
    name: 'Campakamulya',
  },
  {
    id: '3204030006',
    districtId: '3204030',
    name: 'Pasirhuni',
  },
  {
    id: '3204030007',
    districtId: '3204030',
    name: 'Jagabaya',
  },
  {
    id: '3204030008',
    districtId: '3204030',
    name: 'Malasari',
  },
  {
    id: '3204030009',
    districtId: '3204030',
    name: 'Sukamaju',
  },
  {
    id: '3204030010',
    districtId: '3204030',
    name: 'Warjabakti',
  },
  {
    id: '3204040001',
    districtId: '3204040',
    name: 'Wanasuka',
  },
  {
    id: '3204040002',
    districtId: '3204040',
    name: 'Banjarsari',
  },
  {
    id: '3204040003',
    districtId: '3204040',
    name: 'Margaluyu',
  },
  {
    id: '3204040004',
    districtId: '3204040',
    name: 'Sukaluyu',
  },
  {
    id: '3204040005',
    districtId: '3204040',
    name: 'Warnasari',
  },
  {
    id: '3204040006',
    districtId: '3204040',
    name: 'Pulosari',
  },
  {
    id: '3204040007',
    districtId: '3204040',
    name: 'Margamekar',
  },
  {
    id: '3204040008',
    districtId: '3204040',
    name: 'Sukamanah',
  },
  {
    id: '3204040009',
    districtId: '3204040',
    name: 'Margamukti',
  },
  {
    id: '3204040010',
    districtId: '3204040',
    name: 'Pangalengan',
  },
  {
    id: '3204040011',
    districtId: '3204040',
    name: 'Margamulya',
  },
  {
    id: '3204040012',
    districtId: '3204040',
    name: 'Tribaktimulya',
  },
  {
    id: '3204040013',
    districtId: '3204040',
    name: 'Lamajang',
  },
  {
    id: '3204050001',
    districtId: '3204050',
    name: 'Neglawangi',
  },
  {
    id: '3204050002',
    districtId: '3204050',
    name: 'Santosa',
  },
  {
    id: '3204050003',
    districtId: '3204050',
    name: 'Tarumajaya',
  },
  {
    id: '3204050004',
    districtId: '3204050',
    name: 'Cikembang',
  },
  {
    id: '3204050005',
    districtId: '3204050',
    name: 'Cibeureum',
  },
  {
    id: '3204050006',
    districtId: '3204050',
    name: 'Cihawuk',
  },
  {
    id: '3204050007',
    districtId: '3204050',
    name: 'Sukapura',
  },
  {
    id: '3204050008',
    districtId: '3204050',
    name: 'Resmi Tinggal',
  },
  {
    id: '3204060001',
    districtId: '3204060',
    name: 'Cikitu',
  },
  {
    id: '3204060002',
    districtId: '3204060',
    name: 'Girimulya',
  },
  {
    id: '3204060003',
    districtId: '3204060',
    name: 'Sukarame',
  },
  {
    id: '3204060004',
    districtId: '3204060',
    name: 'Cikawao',
  },
  {
    id: '3204060005',
    districtId: '3204060',
    name: 'Nagrak',
  },
  {
    id: '3204060006',
    districtId: '3204060',
    name: 'Mandalahaji',
  },
  {
    id: '3204060007',
    districtId: '3204060',
    name: 'Maruyung',
  },
  {
    id: '3204060008',
    districtId: '3204060',
    name: 'Pangauban',
  },
  {
    id: '3204060009',
    districtId: '3204060',
    name: 'Cinanggela',
  },
  {
    id: '3204060010',
    districtId: '3204060',
    name: 'Mekarjaya',
  },
  {
    id: '3204060011',
    districtId: '3204060',
    name: 'Mekarsari',
  },
  {
    id: '3204060012',
    districtId: '3204060',
    name: 'Cipeujeuh',
  },
  {
    id: '3204060013',
    districtId: '3204060',
    name: 'Tanjungwangi',
  },
  {
    id: '3204070001',
    districtId: '3204070',
    name: 'Neglasari',
  },
  {
    id: '3204070003',
    districtId: '3204070',
    name: 'Ibun',
  },
  {
    id: '3204070004',
    districtId: '3204070',
    name: 'Laksana',
  },
  {
    id: '3204070005',
    districtId: '3204070',
    name: 'Mekarwangi',
  },
  {
    id: '3204070006',
    districtId: '3204070',
    name: 'Sudi',
  },
  {
    id: '3204070007',
    districtId: '3204070',
    name: 'Cibeet',
  },
  {
    id: '3204070008',
    districtId: '3204070',
    name: 'Pangguh',
  },
  {
    id: '3204070009',
    districtId: '3204070',
    name: 'Karyalaksana',
  },
  {
    id: '3204070010',
    districtId: '3204070',
    name: 'Lampegan',
  },
  {
    id: '3204070011',
    districtId: '3204070',
    name: 'Talun',
  },
  {
    id: '3204070012',
    districtId: '3204070',
    name: 'Tanggulun',
  },
  {
    id: '3204080001',
    districtId: '3204080',
    name: 'Loa',
  },
  {
    id: '3204080002',
    districtId: '3204080',
    name: 'Drawati',
  },
  {
    id: '3204080003',
    districtId: '3204080',
    name: 'Cipaku',
  },
  {
    id: '3204080004',
    districtId: '3204080',
    name: 'Sindangsari',
  },
  {
    id: '3204080005',
    districtId: '3204080',
    name: 'Sukamantri',
  },
  {
    id: '3204080006',
    districtId: '3204080',
    name: 'Sukamanah',
  },
  {
    id: '3204080007',
    districtId: '3204080',
    name: 'Mekarpawitan',
  },
  {
    id: '3204080008',
    districtId: '3204080',
    name: 'Cijagra',
  },
  {
    id: '3204080009',
    districtId: '3204080',
    name: 'Tangsimekar',
  },
  {
    id: '3204080010',
    districtId: '3204080',
    name: 'Cipedes',
  },
  {
    id: '3204080011',
    districtId: '3204080',
    name: 'Karangtunggal',
  },
  {
    id: '3204080012',
    districtId: '3204080',
    name: 'Cigentur',
  },
  {
    id: '3204090001',
    districtId: '3204090',
    name: 'Srirahayu',
  },
  {
    id: '3204090002',
    districtId: '3204090',
    name: 'Ciluluk',
  },
  {
    id: '3204090003',
    districtId: '3204090',
    name: 'Mekarlaksana',
  },
  {
    id: '3204090004',
    districtId: '3204090',
    name: 'Cihanyir',
  },
  {
    id: '3204090005',
    districtId: '3204090',
    name: 'Cikancung',
  },
  {
    id: '3204090006',
    districtId: '3204090',
    name: 'Mandalasari',
  },
  {
    id: '3204090007',
    districtId: '3204090',
    name: 'Hegarmanah',
  },
  {
    id: '3204090008',
    districtId: '3204090',
    name: 'Cikasungka',
  },
  {
    id: '3204090009',
    districtId: '3204090',
    name: 'Tanjunglaya',
  },
  {
    id: '3204100001',
    districtId: '3204100',
    name: 'Nagrog',
  },
  {
    id: '3204100002',
    districtId: '3204100',
    name: 'Narawita',
  },
  {
    id: '3204100003',
    districtId: '3204100',
    name: 'Margaasih',
  },
  {
    id: '3204100004',
    districtId: '3204100',
    name: 'Cicalengka Wetan',
  },
  {
    id: '3204100005',
    districtId: '3204100',
    name: 'Cikuya',
  },
  {
    id: '3204100006',
    districtId: '3204100',
    name: 'Waluya',
  },
  {
    id: '3204100007',
    districtId: '3204100',
    name: 'Panenjoan',
  },
  {
    id: '3204100008',
    districtId: '3204100',
    name: 'Tenjolaya',
  },
  {
    id: '3204100009',
    districtId: '3204100',
    name: 'Cicalengka Kulon',
  },
  {
    id: '3204100010',
    districtId: '3204100',
    name: 'Babakanpeuteuy',
  },
  {
    id: '3204100011',
    districtId: '3204100',
    name: 'Dampit',
  },
  {
    id: '3204100012',
    districtId: '3204100',
    name: 'Tanjungwangi',
  },
  {
    id: '3204101001',
    districtId: '3204101',
    name: 'Mandalawangi',
  },
  {
    id: '3204101002',
    districtId: '3204101',
    name: 'Bojong',
  },
  {
    id: '3204101003',
    districtId: '3204101',
    name: 'Ciherang',
  },
  {
    id: '3204101004',
    districtId: '3204101',
    name: 'Ciaro',
  },
  {
    id: '3204101005',
    districtId: '3204101',
    name: 'Nagreg',
  },
  {
    id: '3204101006',
    districtId: '3204101',
    name: 'Citaman',
  },
  {
    id: '3204101007',
    districtId: '3204101',
    name: 'Nagreg Kendan',
  },
  {
    id: '3204101008',
    districtId: '3204101',
    name: 'Ganjar Sabar',
  },
  {
    id: '3204110001',
    districtId: '3204110',
    name: 'Sukamanah',
  },
  {
    id: '3204110002',
    districtId: '3204110',
    name: 'Tegalsumedang',
  },
  {
    id: '3204110003',
    districtId: '3204110',
    name: 'Rancaekek Kulon',
  },
  {
    id: '3204110004',
    districtId: '3204110',
    name: 'Rancaekek Wetan',
  },
  {
    id: '3204110005',
    districtId: '3204110',
    name: 'Bojongloa',
  },
  {
    id: '3204110006',
    districtId: '3204110',
    name: 'Jelegong',
  },
  {
    id: '3204110007',
    districtId: '3204110',
    name: 'Linggar',
  },
  {
    id: '3204110008',
    districtId: '3204110',
    name: 'Sukamulya',
  },
  {
    id: '3204110009',
    districtId: '3204110',
    name: 'Haurpugur',
  },
  {
    id: '3204110010',
    districtId: '3204110',
    name: 'Sangiang',
  },
  {
    id: '3204110011',
    districtId: '3204110',
    name: 'Bojongsalam',
  },
  {
    id: '3204110012',
    districtId: '3204110',
    name: 'Cangkuang',
  },
  {
    id: '3204110013',
    districtId: '3204110',
    name: 'Nanjungmekar',
  },
  {
    id: '3204110014',
    districtId: '3204110',
    name: 'Rancaekek Kencana',
  },
  {
    id: '3204120001',
    districtId: '3204120',
    name: 'Neglasari',
  },
  {
    id: '3204120002',
    districtId: '3204120',
    name: 'Wangisagara',
  },
  {
    id: '3204120003',
    districtId: '3204120',
    name: 'Padamulya',
  },
  {
    id: '3204120004',
    districtId: '3204120',
    name: 'Sukamukti',
  },
  {
    id: '3204120005',
    districtId: '3204120',
    name: 'Padaulun',
  },
  {
    id: '3204120006',
    districtId: '3204120',
    name: 'Biru',
  },
  {
    id: '3204120007',
    districtId: '3204120',
    name: 'Sukamaju',
  },
  {
    id: '3204120008',
    districtId: '3204120',
    name: 'Majasetra',
  },
  {
    id: '3204120009',
    districtId: '3204120',
    name: 'Majalaya',
  },
  {
    id: '3204120010',
    districtId: '3204120',
    name: 'Majakerta',
  },
  {
    id: '3204120011',
    districtId: '3204120',
    name: 'Bojong',
  },
  {
    id: '3204121001',
    districtId: '3204121',
    name: 'Panyadap',
  },
  {
    id: '3204121002',
    districtId: '3204121',
    name: 'Padamukti',
  },
  {
    id: '3204121003',
    districtId: '3204121',
    name: 'Cibodas',
  },
  {
    id: '3204121004',
    districtId: '3204121',
    name: 'Langensari',
  },
  {
    id: '3204121005',
    districtId: '3204121',
    name: 'Solokanjeruk',
  },
  {
    id: '3204121006',
    districtId: '3204121',
    name: 'Rancakasumba',
  },
  {
    id: '3204121007',
    districtId: '3204121',
    name: 'Bojongemas',
  },
  {
    id: '3204130001',
    districtId: '3204130',
    name: 'Babakan',
  },
  {
    id: '3204130002',
    districtId: '3204130',
    name: 'Cikoneng',
  },
  {
    id: '3204130003',
    districtId: '3204130',
    name: 'Sigaracipta',
  },
  {
    id: '3204130004',
    districtId: '3204130',
    name: 'Pakutandang',
  },
  {
    id: '3204130005',
    districtId: '3204130',
    name: 'Manggungharja',
  },
  {
    id: '3204130006',
    districtId: '3204130',
    name: 'Mekarsari',
  },
  {
    id: '3204130007',
    districtId: '3204130',
    name: 'Ciparay',
  },
  {
    id: '3204130008',
    districtId: '3204130',
    name: 'Sumbersari',
  },
  {
    id: '3204130009',
    districtId: '3204130',
    name: 'Sarimahi',
  },
  {
    id: '3204130010',
    districtId: '3204130',
    name: 'Serangmekar',
  },
  {
    id: '3204130011',
    districtId: '3204130',
    name: 'Gunungleutik',
  },
  {
    id: '3204130012',
    districtId: '3204130',
    name: 'Ciheulang',
  },
  {
    id: '3204130013',
    districtId: '3204130',
    name: 'Mekarlaksana',
  },
  {
    id: '3204130014',
    districtId: '3204130',
    name: 'Bumiwangi',
  },
  {
    id: '3204140001',
    districtId: '3204140',
    name: 'Jelekong',
  },
  {
    id: '3204140002',
    districtId: '3204140',
    name: 'Manggahang',
  },
  {
    id: '3204140003',
    districtId: '3204140',
    name: 'Baleendah',
  },
  {
    id: '3204140004',
    districtId: '3204140',
    name: 'Andir',
  },
  {
    id: '3204140005',
    districtId: '3204140',
    name: 'Malakasari',
  },
  {
    id: '3204140006',
    districtId: '3204140',
    name: 'Bojongmalaka',
  },
  {
    id: '3204140007',
    districtId: '3204140',
    name: 'Rancamanyar',
  },
  {
    id: '3204140008',
    districtId: '3204140',
    name: 'Wargamekar',
  },
  {
    id: '3204150001',
    districtId: '3204150',
    name: 'Batukarut',
  },
  {
    id: '3204150002',
    districtId: '3204150',
    name: 'Mangunjaya',
  },
  {
    id: '3204150003',
    districtId: '3204150',
    name: 'Mekarjaya',
  },
  {
    id: '3204150004',
    districtId: '3204150',
    name: 'Baros',
  },
  {
    id: '3204150005',
    districtId: '3204150',
    name: 'Lebakwangi',
  },
  {
    id: '3204150006',
    districtId: '3204150',
    name: 'Wargaluyu',
  },
  {
    id: '3204150007',
    districtId: '3204150',
    name: 'Arjasari',
  },
  {
    id: '3204150008',
    districtId: '3204150',
    name: 'Pinggirsari',
  },
  {
    id: '3204150009',
    districtId: '3204150',
    name: 'Patrolsari',
  },
  {
    id: '3204150010',
    districtId: '3204150',
    name: 'Rancakole',
  },
  {
    id: '3204150011',
    districtId: '3204150',
    name: 'Ancolmekar',
  },
  {
    id: '3204160001',
    districtId: '3204160',
    name: 'Mekarjaya',
  },
  {
    id: '3204160002',
    districtId: '3204160',
    name: 'Banjaran Wetan',
  },
  {
    id: '3204160003',
    districtId: '3204160',
    name: 'Ciapus',
  },
  {
    id: '3204160004',
    districtId: '3204160',
    name: 'Sindangpanon',
  },
  {
    id: '3204160005',
    districtId: '3204160',
    name: 'Neglasari',
  },
  {
    id: '3204160006',
    districtId: '3204160',
    name: 'Margahurip',
  },
  {
    id: '3204160007',
    districtId: '3204160',
    name: 'Kiangroke',
  },
  {
    id: '3204160008',
    districtId: '3204160',
    name: 'Kamasan',
  },
  {
    id: '3204160009',
    districtId: '3204160',
    name: 'Banjaran',
  },
  {
    id: '3204160010',
    districtId: '3204160',
    name: 'Tarajusari',
  },
  {
    id: '3204160011',
    districtId: '3204160',
    name: 'Pasirmulya',
  },
  {
    id: '3204161001',
    districtId: '3204161',
    name: 'Jatisari',
  },
  {
    id: '3204161002',
    districtId: '3204161',
    name: 'Nagrak',
  },
  {
    id: '3204161003',
    districtId: '3204161',
    name: 'Bandasari',
  },
  {
    id: '3204161004',
    districtId: '3204161',
    name: 'Pananjung',
  },
  {
    id: '3204161005',
    districtId: '3204161',
    name: 'Ciluncat',
  },
  {
    id: '3204161006',
    districtId: '3204161',
    name: 'Cangkuang',
  },
  {
    id: '3204161007',
    districtId: '3204161',
    name: 'Tanjungsari',
  },
  {
    id: '3204170001',
    districtId: '3204170',
    name: 'Bojongmanggu',
  },
  {
    id: '3204170002',
    districtId: '3204170',
    name: 'Langonsari',
  },
  {
    id: '3204170003',
    districtId: '3204170',
    name: 'Sukasari',
  },
  {
    id: '3204170004',
    districtId: '3204170',
    name: 'Rancamulya',
  },
  {
    id: '3204170005',
    districtId: '3204170',
    name: 'Rancatungku',
  },
  {
    id: '3204170006',
    districtId: '3204170',
    name: 'Bojongkunci',
  },
  {
    id: '3204180004',
    districtId: '3204180',
    name: 'Gandasari',
  },
  {
    id: '3204180005',
    districtId: '3204180',
    name: 'Katapang',
  },
  {
    id: '3204180006',
    districtId: '3204180',
    name: 'Cilampeni',
  },
  {
    id: '3204180007',
    districtId: '3204180',
    name: 'Pangauban',
  },
  {
    id: '3204180008',
    districtId: '3204180',
    name: 'Banyusari',
  },
  {
    id: '3204180009',
    districtId: '3204180',
    name: 'Sangkanhurip',
  },
  {
    id: '3204180010',
    districtId: '3204180',
    name: 'Sukamukti',
  },
  {
    id: '3204190002',
    districtId: '3204190',
    name: 'Sadu',
  },
  {
    id: '3204190003',
    districtId: '3204190',
    name: 'Sukajadi',
  },
  {
    id: '3204190004',
    districtId: '3204190',
    name: 'Sukanagara',
  },
  {
    id: '3204190005',
    districtId: '3204190',
    name: 'Panyirapan',
  },
  {
    id: '3204190006',
    districtId: '3204190',
    name: 'Karamatmulya',
  },
  {
    id: '3204190007',
    districtId: '3204190',
    name: 'Soreang',
  },
  {
    id: '3204190008',
    districtId: '3204190',
    name: 'Pamekaran',
  },
  {
    id: '3204190019',
    districtId: '3204190',
    name: 'Parungserab',
  },
  {
    id: '3204190020',
    districtId: '3204190',
    name: 'Sekarwangi',
  },
  {
    id: '3204190021',
    districtId: '3204190',
    name: 'Cingcin',
  },
  {
    id: '3204191001',
    districtId: '3204191',
    name: 'Cilame',
  },
  {
    id: '3204191002',
    districtId: '3204191',
    name: 'Buninagara',
  },
  {
    id: '3204191003',
    districtId: '3204191',
    name: 'Padasuka',
  },
  {
    id: '3204191004',
    districtId: '3204191',
    name: 'Sukamulya',
  },
  {
    id: '3204191005',
    districtId: '3204191',
    name: 'Kutawaringin',
  },
  {
    id: '3204191006',
    districtId: '3204191',
    name: 'Kopo',
  },
  {
    id: '3204191007',
    districtId: '3204191',
    name: 'Cibodas',
  },
  {
    id: '3204191008',
    districtId: '3204191',
    name: 'Jatisari',
  },
  {
    id: '3204191009',
    districtId: '3204191',
    name: 'Jelegong',
  },
  {
    id: '3204191010',
    districtId: '3204191',
    name: 'Gajahmekar',
  },
  {
    id: '3204191011',
    districtId: '3204191',
    name: 'Pameuntasan',
  },
  {
    id: '3204250001',
    districtId: '3204250',
    name: 'Nanjung',
  },
  {
    id: '3204250002',
    districtId: '3204250',
    name: 'Mekar Rahayu',
  },
  {
    id: '3204250003',
    districtId: '3204250',
    name: 'Rahayu',
  },
  {
    id: '3204250004',
    districtId: '3204250',
    name: 'Cigondewah Hilir',
  },
  {
    id: '3204250005',
    districtId: '3204250',
    name: 'Margaasih',
  },
  {
    id: '3204250006',
    districtId: '3204250',
    name: 'Lagadar',
  },
  {
    id: '3204260001',
    districtId: '3204260',
    name: 'Sulaeman',
  },
  {
    id: '3204260002',
    districtId: '3204260',
    name: 'Sukamenak',
  },
  {
    id: '3204260003',
    districtId: '3204260',
    name: 'Sayati',
  },
  {
    id: '3204260004',
    districtId: '3204260',
    name: 'Margahayu Selatan',
  },
  {
    id: '3204260005',
    districtId: '3204260',
    name: 'Margahayu Tengah',
  },
  {
    id: '3204270001',
    districtId: '3204270',
    name: 'Cangkuang Kulon',
  },
  {
    id: '3204270002',
    districtId: '3204270',
    name: 'Cangkuang Wetan',
  },
  {
    id: '3204270003',
    districtId: '3204270',
    name: 'Pasawahan',
  },
  {
    id: '3204270004',
    districtId: '3204270',
    name: 'Dayeuhkolot',
  },
  {
    id: '3204270005',
    districtId: '3204270',
    name: 'Citeureup',
  },
  {
    id: '3204270006',
    districtId: '3204270',
    name: 'Sukapura',
  },
  {
    id: '3204280001',
    districtId: '3204280',
    name: 'Bojongsari',
  },
  {
    id: '3204280002',
    districtId: '3204280',
    name: 'Bojongsoang',
  },
  {
    id: '3204280003',
    districtId: '3204280',
    name: 'Lengkong',
  },
  {
    id: '3204280004',
    districtId: '3204280',
    name: 'Cipagalo',
  },
  {
    id: '3204280005',
    districtId: '3204280',
    name: 'Buahbatu',
  },
  {
    id: '3204280006',
    districtId: '3204280',
    name: 'Tegalluar',
  },
  {
    id: '3204290001',
    districtId: '3204290',
    name: 'Cibiru Hilir',
  },
  {
    id: '3204290002',
    districtId: '3204290',
    name: 'Cinunuk',
  },
  {
    id: '3204290003',
    districtId: '3204290',
    name: 'Cimekar',
  },
  {
    id: '3204290004',
    districtId: '3204290',
    name: 'Cileunyi Kulon',
  },
  {
    id: '3204290005',
    districtId: '3204290',
    name: 'Cileunyi Wetan',
  },
  {
    id: '3204290006',
    districtId: '3204290',
    name: 'Cibiru Wetan',
  },
  {
    id: '3204300001',
    districtId: '3204300',
    name: 'Girimekar',
  },
  {
    id: '3204300002',
    districtId: '3204300',
    name: 'Jatiendah',
  },
  {
    id: '3204300003',
    districtId: '3204300',
    name: 'Melatiwangi',
  },
  {
    id: '3204300004',
    districtId: '3204300',
    name: 'Cipanjalu',
  },
  {
    id: '3204300005',
    districtId: '3204300',
    name: 'Ciporeat',
  },
  {
    id: '3204300006',
    districtId: '3204300',
    name: 'Cilengkrang',
  },
  {
    id: '3204310001',
    districtId: '3204310',
    name: 'Cibeunying',
  },
  {
    id: '3204310002',
    districtId: '3204310',
    name: 'Padasuka',
  },
  {
    id: '3204310003',
    districtId: '3204310',
    name: 'Mandalamekar',
  },
  {
    id: '3204310004',
    districtId: '3204310',
    name: 'Cikadut',
  },
  {
    id: '3204310005',
    districtId: '3204310',
    name: 'Sindanglaya',
  },
  {
    id: '3204310006',
    districtId: '3204310',
    name: 'Mekarmanik',
  },
  {
    id: '3204310007',
    districtId: '3204310',
    name: 'Cimenyan',
  },
  {
    id: '3204310008',
    districtId: '3204310',
    name: 'Mekarsaluyu',
  },
  {
    id: '3204310009',
    districtId: '3204310',
    name: 'Ciburial',
  },
  {
    id: '3205010006',
    districtId: '3205010',
    name: 'Sukajaya',
  },
  {
    id: '3205010007',
    districtId: '3205010',
    name: 'Cikarang',
  },
  {
    id: '3205010008',
    districtId: '3205010',
    name: 'Pamalayan',
  },
  {
    id: '3205010009',
    districtId: '3205010',
    name: 'Cisewu',
  },
  {
    id: '3205010010',
    districtId: '3205010',
    name: 'Girimukti',
  },
  {
    id: '3205010011',
    districtId: '3205010',
    name: 'Nyalindung',
  },
  {
    id: '3205010012',
    districtId: '3205010',
    name: 'Karangsewu',
  },
  {
    id: '3205010013',
    districtId: '3205010',
    name: 'Mekarsewu',
  },
  {
    id: '3205010014',
    districtId: '3205010',
    name: 'Panggalih',
  },
  {
    id: '3205011001',
    districtId: '3205011',
    name: 'Cimahi',
  },
  {
    id: '3205011002',
    districtId: '3205011',
    name: 'Indralayang',
  },
  {
    id: '3205011003',
    districtId: '3205011',
    name: 'Purbayani',
  },
  {
    id: '3205011004',
    districtId: '3205011',
    name: 'Caringin',
  },
  {
    id: '3205011005',
    districtId: '3205011',
    name: 'Sukarame',
  },
  {
    id: '3205011006',
    districtId: '3205011',
    name: 'Samudrajaya',
  },
  {
    id: '3205020001',
    districtId: '3205020',
    name: 'Selaawi',
  },
  {
    id: '3205020002',
    districtId: '3205020',
    name: 'Mekarmukti',
  },
  {
    id: '3205020003',
    districtId: '3205020',
    name: 'Mekarmulya',
  },
  {
    id: '3205020004',
    districtId: '3205020',
    name: 'Sukamulya',
  },
  {
    id: '3205020005',
    districtId: '3205020',
    name: 'Sukamaju',
  },
  {
    id: '3205020006',
    districtId: '3205020',
    name: 'Sukalaksana',
  },
  {
    id: '3205020007',
    districtId: '3205020',
    name: 'Mekarwangi',
  },
  {
    id: '3205030001',
    districtId: '3205030',
    name: 'Sinarjaya',
  },
  {
    id: '3205030005',
    districtId: '3205030',
    name: 'Tegalega',
  },
  {
    id: '3205030006',
    districtId: '3205030',
    name: 'Wangunjaya',
  },
  {
    id: '3205030007',
    districtId: '3205030',
    name: 'Mekarjaya',
  },
  {
    id: '3205030008',
    districtId: '3205030',
    name: 'Hanjuang',
  },
  {
    id: '3205030009',
    districtId: '3205030',
    name: 'Margalaksana',
  },
  {
    id: '3205030010',
    districtId: '3205030',
    name: 'Gunamekar',
  },
  {
    id: '3205030011',
    districtId: '3205030',
    name: 'Bungbulang',
  },
  {
    id: '3205030012',
    districtId: '3205030',
    name: 'Cihikeu',
  },
  {
    id: '3205030013',
    districtId: '3205030',
    name: 'Bojong',
  },
  {
    id: '3205030014',
    districtId: '3205030',
    name: 'Mekarbakti',
  },
  {
    id: '3205030015',
    districtId: '3205030',
    name: 'Gunung Jampang',
  },
  {
    id: '3205030016',
    districtId: '3205030',
    name: 'Hegarmanah',
  },
  {
    id: '3205031001',
    districtId: '3205031',
    name: 'Karangwangi',
  },
  {
    id: '3205031002',
    districtId: '3205031',
    name: 'Cijayana',
  },
  {
    id: '3205031003',
    districtId: '3205031',
    name: 'Mekarmukti',
  },
  {
    id: '3205031004',
    districtId: '3205031',
    name: 'Jagabaya',
  },
  {
    id: '3205031005',
    districtId: '3205031',
    name: 'Mekarsari',
  },
  {
    id: '3205040001',
    districtId: '3205040',
    name: 'Linggarjati',
  },
  {
    id: '3205040002',
    districtId: '3205040',
    name: 'Garumukti',
  },
  {
    id: '3205040003',
    districtId: '3205040',
    name: 'Panawa',
  },
  {
    id: '3205040004',
    districtId: '3205040',
    name: 'Pakenjeng',
  },
  {
    id: '3205040005',
    districtId: '3205040',
    name: 'Pananjung',
  },
  {
    id: '3205050001',
    districtId: '3205050',
    name: 'Karangsari',
  },
  {
    id: '3205050002',
    districtId: '3205050',
    name: 'Tanjungmulya',
  },
  {
    id: '3205050003',
    districtId: '3205050',
    name: 'Tanjungjaya',
  },
  {
    id: '3205050004',
    districtId: '3205050',
    name: 'Tegalgede',
  },
  {
    id: '3205050005',
    districtId: '3205050',
    name: 'Neglasari',
  },
  {
    id: '3205050006',
    districtId: '3205050',
    name: 'Sukamulya',
  },
  {
    id: '3205050007',
    districtId: '3205050',
    name: 'Depok',
  },
  {
    id: '3205050008',
    districtId: '3205050',
    name: 'Pasirlangu',
  },
  {
    id: '3205050009',
    districtId: '3205050',
    name: 'Panyindangan',
  },
  {
    id: '3205050010',
    districtId: '3205050',
    name: 'Wangunjaya',
  },
  {
    id: '3205050011',
    districtId: '3205050',
    name: 'Jatiwangi',
  },
  {
    id: '3205050012',
    districtId: '3205050',
    name: 'Talagawangi',
  },
  {
    id: '3205050013',
    districtId: '3205050',
    name: 'Jayamekar',
  },
  {
    id: '3205060001',
    districtId: '3205060',
    name: 'Cigadog',
  },
  {
    id: '3205060002',
    districtId: '3205060',
    name: 'Cijambe',
  },
  {
    id: '3205060003',
    districtId: '3205060',
    name: 'Cikelet',
  },
  {
    id: '3205060004',
    districtId: '3205060',
    name: 'Pamalayan',
  },
  {
    id: '3205060005',
    districtId: '3205060',
    name: 'Linggamanik',
  },
  {
    id: '3205060006',
    districtId: '3205060',
    name: 'Karangsari',
  },
  {
    id: '3205060007',
    districtId: '3205060',
    name: 'Kertamukti',
  },
  {
    id: '3205060008',
    districtId: '3205060',
    name: 'Ciroyom',
  },
  {
    id: '3205060009',
    districtId: '3205060',
    name: 'Girimukti',
  },
  {
    id: '3205060010',
    districtId: '3205060',
    name: 'Tipar',
  },
  {
    id: '3205060011',
    districtId: '3205060',
    name: 'Awassagara',
  },
  {
    id: '3205070001',
    districtId: '3205070',
    name: 'Mancagahar',
  },
  {
    id: '3205070002',
    districtId: '3205070',
    name: 'Pameungpeuk',
  },
  {
    id: '3205070003',
    districtId: '3205070',
    name: 'Mandalakasih',
  },
  {
    id: '3205070004',
    districtId: '3205070',
    name: 'Sirnabakti',
  },
  {
    id: '3205070005',
    districtId: '3205070',
    name: 'Paas',
  },
  {
    id: '3205070006',
    districtId: '3205070',
    name: 'Bojong',
  },
  {
    id: '3205070007',
    districtId: '3205070',
    name: 'Jatimulya',
  },
  {
    id: '3205070008',
    districtId: '3205070',
    name: 'Bojongkidul',
  },
  {
    id: '3205080001',
    districtId: '3205080',
    name: 'Mekarsari',
  },
  {
    id: '3205080002',
    districtId: '3205080',
    name: 'Karyasari',
  },
  {
    id: '3205080003',
    districtId: '3205080',
    name: 'Karya Mukti',
  },
  {
    id: '3205080004',
    districtId: '3205080',
    name: 'Sagara',
  },
  {
    id: '3205080005',
    districtId: '3205080',
    name: 'Maroko',
  },
  {
    id: '3205080006',
    districtId: '3205080',
    name: 'Sancang',
  },
  {
    id: '3205080007',
    districtId: '3205080',
    name: 'Simpang',
  },
  {
    id: '3205080008',
    districtId: '3205080',
    name: 'Cigaronggong',
  },
  {
    id: '3205080009',
    districtId: '3205080',
    name: 'Mekarmukti',
  },
  {
    id: '3205080010',
    districtId: '3205080',
    name: 'Mekarwangi',
  },
  {
    id: '3205080011',
    districtId: '3205080',
    name: 'Najaten',
  },
  {
    id: '3205090001',
    districtId: '3205090',
    name: 'Depok',
  },
  {
    id: '3205090002',
    districtId: '3205090',
    name: 'Sukanagara',
  },
  {
    id: '3205090003',
    districtId: '3205090',
    name: 'Cihaurkuning',
  },
  {
    id: '3205090004',
    districtId: '3205090',
    name: 'Cikondang',
  },
  {
    id: '3205090005',
    districtId: '3205090',
    name: 'Jatisari',
  },
  {
    id: '3205090006',
    districtId: '3205090',
    name: 'Cisompet',
  },
  {
    id: '3205090007',
    districtId: '3205090',
    name: 'Sukamukti',
  },
  {
    id: '3205090008',
    districtId: '3205090',
    name: 'Panyindangan',
  },
  {
    id: '3205090009',
    districtId: '3205090',
    name: 'Margamulya',
  },
  {
    id: '3205090010',
    districtId: '3205090',
    name: 'Sindangsari',
  },
  {
    id: '3205090011',
    districtId: '3205090',
    name: 'Neglasari',
  },
  {
    id: '3205100001',
    districtId: '3205100',
    name: 'Pangrumasan',
  },
  {
    id: '3205100002',
    districtId: '3205100',
    name: 'Toblong',
  },
  {
    id: '3205100003',
    districtId: '3205100',
    name: 'Sukanagara',
  },
  {
    id: '3205100004',
    districtId: '3205100',
    name: 'Saribakti',
  },
  {
    id: '3205100006',
    districtId: '3205100',
    name: 'Purwajaya',
  },
  {
    id: '3205110005',
    districtId: '3205110',
    name: 'Singajaya',
  },
  {
    id: '3205110006',
    districtId: '3205110',
    name: 'Karangagung',
  },
  {
    id: '3205110007',
    districtId: '3205110',
    name: 'Mekartani',
  },
  {
    id: '3205110008',
    districtId: '3205110',
    name: 'Cigintung',
  },
  {
    id: '3205110009',
    districtId: '3205110',
    name: 'Sukawangi',
  },
  {
    id: '3205110010',
    districtId: '3205110',
    name: 'Pancasura',
  },
  {
    id: '3205110011',
    districtId: '3205110',
    name: 'Sukamulya',
  },
  {
    id: '3205110012',
    districtId: '3205110',
    name: 'Girimukti',
  },
  {
    id: '3205110013',
    districtId: '3205110',
    name: 'Ciudian',
  },
  {
    id: '3205111001',
    districtId: '3205111',
    name: 'Cisangkal',
  },
  {
    id: '3205111002',
    districtId: '3205111',
    name: 'Jayamukti',
  },
  {
    id: '3205111003',
    districtId: '3205111',
    name: 'Cihurip',
  },
  {
    id: '3205111004',
    districtId: '3205111',
    name: 'Mekarwangi',
  },
  {
    id: '3205120001',
    districtId: '3205120',
    name: 'Cipangramatan',
  },
  {
    id: '3205120002',
    districtId: '3205120',
    name: 'Mekarjaya',
  },
  {
    id: '3205120003',
    districtId: '3205120',
    name: 'Girijaya',
  },
  {
    id: '3205120004',
    districtId: '3205120',
    name: 'Giriawas',
  },
  {
    id: '3205120005',
    districtId: '3205120',
    name: 'Cibodas',
  },
  {
    id: '3205120006',
    districtId: '3205120',
    name: 'Cikajang',
  },
  {
    id: '3205120007',
    districtId: '3205120',
    name: 'Padasuka',
  },
  {
    id: '3205120008',
    districtId: '3205120',
    name: 'Mekarsari',
  },
  {
    id: '3205120009',
    districtId: '3205120',
    name: 'Simpang',
  },
  {
    id: '3205120010',
    districtId: '3205120',
    name: 'Cikandang',
  },
  {
    id: '3205120011',
    districtId: '3205120',
    name: 'Margamulya',
  },
  {
    id: '3205120012',
    districtId: '3205120',
    name: 'Karamatwangi',
  },
  {
    id: '3205130001',
    districtId: '3205130',
    name: 'Dangiang',
  },
  {
    id: '3205130002',
    districtId: '3205130',
    name: 'Jayabakti',
  },
  {
    id: '3205130003',
    districtId: '3205130',
    name: 'Bojong',
  },
  {
    id: '3205130004',
    districtId: '3205130',
    name: 'Banjarwangi',
  },
  {
    id: '3205130005',
    districtId: '3205130',
    name: 'Talagasari',
  },
  {
    id: '3205130006',
    districtId: '3205130',
    name: 'Padahurip',
  },
  {
    id: '3205130007',
    districtId: '3205130',
    name: 'Kadongdong',
  },
  {
    id: '3205130008',
    districtId: '3205130',
    name: 'Wangunjaya',
  },
  {
    id: '3205130009',
    districtId: '3205130',
    name: 'Talagajaya',
  },
  {
    id: '3205130010',
    districtId: '3205130',
    name: 'Tanjungjaya',
  },
  {
    id: '3205130011',
    districtId: '3205130',
    name: 'Mulyajaya',
  },
  {
    id: '3205140001',
    districtId: '3205140',
    name: 'Sukamurni',
  },
  {
    id: '3205140002',
    districtId: '3205140',
    name: 'Sukamaju',
  },
  {
    id: '3205140003',
    districtId: '3205140',
    name: 'Sukatani',
  },
  {
    id: '3205140004',
    districtId: '3205140',
    name: 'Mekarsari',
  },
  {
    id: '3205140005',
    districtId: '3205140',
    name: 'Dayeuhmanggung',
  },
  {
    id: '3205140006',
    districtId: '3205140',
    name: 'Karyamekar',
  },
  {
    id: '3205140007',
    districtId: '3205140',
    name: 'Cilawu',
  },
  {
    id: '3205140008',
    districtId: '3205140',
    name: 'Pasanggrahan',
  },
  {
    id: '3205140009',
    districtId: '3205140',
    name: 'Margalaksana',
  },
  {
    id: '3205140010',
    districtId: '3205140',
    name: 'Dawungsari',
  },
  {
    id: '3205140011',
    districtId: '3205140',
    name: 'Dangiang',
  },
  {
    id: '3205140012',
    districtId: '3205140',
    name: 'Sukamukti',
  },
  {
    id: '3205140013',
    districtId: '3205140',
    name: 'Mekarmukti',
  },
  {
    id: '3205140014',
    districtId: '3205140',
    name: 'Sukahati',
  },
  {
    id: '3205140015',
    districtId: '3205140',
    name: 'Mangkurayat',
  },
  {
    id: '3205140016',
    districtId: '3205140',
    name: 'Desakolot',
  },
  {
    id: '3205140017',
    districtId: '3205140',
    name: 'Ngamplang',
  },
  {
    id: '3205140018',
    districtId: '3205140',
    name: 'Ngamplangsari',
  },
  {
    id: '3205150006',
    districtId: '3205150',
    name: 'Pamalayan',
  },
  {
    id: '3205150007',
    districtId: '3205150',
    name: 'Ciburuy',
  },
  {
    id: '3205150008',
    districtId: '3205150',
    name: 'Mulyasari',
  },
  {
    id: '3205150009',
    districtId: '3205150',
    name: 'Bayongbong',
  },
  {
    id: '3205150010',
    districtId: '3205150',
    name: 'Cinisti',
  },
  {
    id: '3205150011',
    districtId: '3205150',
    name: 'Ciela',
  },
  {
    id: '3205150012',
    districtId: '3205150',
    name: 'Karyajaya',
  },
  {
    id: '3205150013',
    districtId: '3205150',
    name: 'Panembong',
  },
  {
    id: '3205150014',
    districtId: '3205150',
    name: 'Sukarame',
  },
  {
    id: '3205150015',
    districtId: '3205150',
    name: 'Hegarmanah',
  },
  {
    id: '3205150016',
    districtId: '3205150',
    name: 'Sirnagalih',
  },
  {
    id: '3205150017',
    districtId: '3205150',
    name: 'Salakuray',
  },
  {
    id: '3205150018',
    districtId: '3205150',
    name: 'Sukasenang',
  },
  {
    id: '3205150019',
    districtId: '3205150',
    name: 'Cikedokan',
  },
  {
    id: '3205150020',
    districtId: '3205150',
    name: 'Mekarsari',
  },
  {
    id: '3205150021',
    districtId: '3205150',
    name: 'Banjarsari',
  },
  {
    id: '3205150022',
    districtId: '3205150',
    name: 'Mekarjaya',
  },
  {
    id: '3205150023',
    districtId: '3205150',
    name: 'Sukamanah',
  },
  {
    id: '3205151001',
    districtId: '3205151',
    name: 'Barusuda',
  },
  {
    id: '3205151002',
    districtId: '3205151',
    name: 'Cigedug',
  },
  {
    id: '3205151003',
    districtId: '3205151',
    name: 'Sukahurip',
  },
  {
    id: '3205151004',
    districtId: '3205151',
    name: 'Sindangsari',
  },
  {
    id: '3205151005',
    districtId: '3205151',
    name: 'Cintanagara',
  },
  {
    id: '3205160001',
    districtId: '3205160',
    name: 'Sukawargi',
  },
  {
    id: '3205160002',
    districtId: '3205160',
    name: 'Sukatani',
  },
  {
    id: '3205160003',
    districtId: '3205160',
    name: 'Cidatar',
  },
  {
    id: '3205160004',
    districtId: '3205160',
    name: 'Cisero',
  },
  {
    id: '3205160005',
    districtId: '3205160',
    name: 'Cisurupan',
  },
  {
    id: '3205160006',
    districtId: '3205160',
    name: 'Karamatwangi',
  },
  {
    id: '3205160007',
    districtId: '3205160',
    name: 'Balewangi',
  },
  {
    id: '3205160008',
    districtId: '3205160',
    name: 'Tambakbaya',
  },
  {
    id: '3205160009',
    districtId: '3205160',
    name: 'Sirnajaya',
  },
  {
    id: '3205160010',
    districtId: '3205160',
    name: 'Sirnagalih',
  },
  {
    id: '3205160011',
    districtId: '3205160',
    name: 'Pakuwon',
  },
  {
    id: '3205160012',
    districtId: '3205160',
    name: 'Simpangsari',
  },
  {
    id: '3205160013',
    districtId: '3205160',
    name: 'Pangauban',
  },
  {
    id: '3205160014',
    districtId: '3205160',
    name: 'Cipaganti',
  },
  {
    id: '3205160015',
    districtId: '3205160',
    name: 'Pamulihan',
  },
  {
    id: '3205160016',
    districtId: '3205160',
    name: 'Situsari',
  },
  {
    id: '3205160017',
    districtId: '3205160',
    name: 'Cintaasih',
  },
  {
    id: '3205161001',
    districtId: '3205161',
    name: 'Sukamulya',
  },
  {
    id: '3205161002',
    districtId: '3205161',
    name: 'Sukaresmi',
  },
  {
    id: '3205161003',
    districtId: '3205161',
    name: 'Padamukti',
  },
  {
    id: '3205161004',
    districtId: '3205161',
    name: 'Cintadamai',
  },
  {
    id: '3205161005',
    districtId: '3205161',
    name: 'Sukajaya',
  },
  {
    id: '3205161006',
    districtId: '3205161',
    name: 'Mekarjaya',
  },
  {
    id: '3205161007',
    districtId: '3205161',
    name: 'Sukalilah',
  },
  {
    id: '3205170013',
    districtId: '3205170',
    name: 'Cisarua',
  },
  {
    id: '3205170014',
    districtId: '3205170',
    name: 'Parakan',
  },
  {
    id: '3205170015',
    districtId: '3205170',
    name: 'Sukalaksana',
  },
  {
    id: '3205170016',
    districtId: '3205170',
    name: 'Sirnasari',
  },
  {
    id: '3205170017',
    districtId: '3205170',
    name: 'Cintakarya',
  },
  {
    id: '3205170018',
    districtId: '3205170',
    name: 'Cintarasa',
  },
  {
    id: '3205170019',
    districtId: '3205170',
    name: 'Cintarayat',
  },
  {
    id: '3205170020',
    districtId: '3205170',
    name: 'Cintaasih',
  },
  {
    id: '3205170021',
    districtId: '3205170',
    name: 'Samarang',
  },
  {
    id: '3205170022',
    districtId: '3205170',
    name: 'Sukarasa',
  },
  {
    id: '3205170023',
    districtId: '3205170',
    name: 'Sukakarya',
  },
  {
    id: '3205170024',
    districtId: '3205170',
    name: 'Tanjung Karya',
  },
  {
    id: '3205170025',
    districtId: '3205170',
    name: 'Tanjunganom',
  },
  {
    id: '3205171001',
    districtId: '3205171',
    name: 'Karyamekar',
  },
  {
    id: '3205171002',
    districtId: '3205171',
    name: 'Sarimukti',
  },
  {
    id: '3205171003',
    districtId: '3205171',
    name: 'Talaga',
  },
  {
    id: '3205171004',
    districtId: '3205171',
    name: 'Pasirkiamis',
  },
  {
    id: '3205171005',
    districtId: '3205171',
    name: 'Padamukti',
  },
  {
    id: '3205171006',
    districtId: '3205171',
    name: 'Padaasih',
  },
  {
    id: '3205171007',
    districtId: '3205171',
    name: 'Padasuka',
  },
  {
    id: '3205171008',
    districtId: '3205171',
    name: 'Sirnajaya',
  },
  {
    id: '3205171009',
    districtId: '3205171',
    name: 'Padamulya',
  },
  {
    id: '3205171010',
    districtId: '3205171',
    name: 'Pasirwangi',
  },
  {
    id: '3205171011',
    districtId: '3205171',
    name: 'Padaawas',
  },
  {
    id: '3205171012',
    districtId: '3205171',
    name: 'Barusari',
  },
  {
    id: '3205181001',
    districtId: '3205181',
    name: 'Kersamenak',
  },
  {
    id: '3205181002',
    districtId: '3205181',
    name: 'Cibunar',
  },
  {
    id: '3205181003',
    districtId: '3205181',
    name: 'Sukabakti',
  },
  {
    id: '3205181004',
    districtId: '3205181',
    name: 'Sukakarya',
  },
  {
    id: '3205181005',
    districtId: '3205181',
    name: 'Sukajaya',
  },
  {
    id: '3205181006',
    districtId: '3205181',
    name: 'Jayawaras',
  },
  {
    id: '3205181007',
    districtId: '3205181',
    name: 'Haurpanggung',
  },
  {
    id: '3205181008',
    districtId: '3205181',
    name: 'Jayaraga',
  },
  {
    id: '3205181009',
    districtId: '3205181',
    name: 'Pataruman',
  },
  {
    id: '3205181010',
    districtId: '3205181',
    name: 'Sukagalih',
  },
  {
    id: '3205181011',
    districtId: '3205181',
    name: 'Mekargalih',
  },
  {
    id: '3205181012',
    districtId: '3205181',
    name: 'Tarogong',
  },
  {
    id: '3205182001',
    districtId: '3205182',
    name: 'Sirnajaya',
  },
  {
    id: '3205182002',
    districtId: '3205182',
    name: 'Mekarwangi',
  },
  {
    id: '3205182003',
    districtId: '3205182',
    name: 'Sukajadi',
  },
  {
    id: '3205182004',
    districtId: '3205182',
    name: 'Sukawangi',
  },
  {
    id: '3205182005',
    districtId: '3205182',
    name: 'Panjiwangi',
  },
  {
    id: '3205182006',
    districtId: '3205182',
    name: 'Mekarjaya',
  },
  {
    id: '3205182007',
    districtId: '3205182',
    name: 'Rancabango',
  },
  {
    id: '3205182008',
    districtId: '3205182',
    name: 'Langensari',
  },
  {
    id: '3205182009',
    districtId: '3205182',
    name: 'Cimanganten',
  },
  {
    id: '3205182010',
    districtId: '3205182',
    name: 'Jati',
  },
  {
    id: '3205182011',
    districtId: '3205182',
    name: 'Tanjungkamuning',
  },
  {
    id: '3205182012',
    districtId: '3205182',
    name: 'Pananjung',
  },
  {
    id: '3205182013',
    districtId: '3205182',
    name: 'Pasawahan',
  },
  {
    id: '3205190001',
    districtId: '3205190',
    name: 'Margawati',
  },
  {
    id: '3205190002',
    districtId: '3205190',
    name: 'Sukanegla',
  },
  {
    id: '3205190003',
    districtId: '3205190',
    name: 'Cimuncang',
  },
  {
    id: '3205190004',
    districtId: '3205190',
    name: 'Kotawetan',
  },
  {
    id: '3205190005',
    districtId: '3205190',
    name: 'Kotakulon',
  },
  {
    id: '3205190006',
    districtId: '3205190',
    name: 'Muara Sanding',
  },
  {
    id: '3205190007',
    districtId: '3205190',
    name: 'Paminggir',
  },
  {
    id: '3205190008',
    districtId: '3205190',
    name: 'Regol',
  },
  {
    id: '3205190009',
    districtId: '3205190',
    name: 'Ciwalen',
  },
  {
    id: '3205190010',
    districtId: '3205190',
    name: 'Pakuwon',
  },
  {
    id: '3205190011',
    districtId: '3205190',
    name: 'Sukamantri',
  },
  {
    id: '3205200001',
    districtId: '3205200',
    name: 'Lebakagung',
  },
  {
    id: '3205200002',
    districtId: '3205200',
    name: 'Suci',
  },
  {
    id: '3205200003',
    districtId: '3205200',
    name: 'Lebakjaya',
  },
  {
    id: '3205200004',
    districtId: '3205200',
    name: 'Tanjungsari',
  },
  {
    id: '3205200005',
    districtId: '3205200',
    name: 'Godog',
  },
  {
    id: '3205200006',
    districtId: '3205200',
    name: 'Sindanggalih',
  },
  {
    id: '3205200007',
    districtId: '3205200',
    name: 'Sindangpalay',
  },
  {
    id: '3205200008',
    districtId: '3205200',
    name: 'Karangpawitan',
  },
  {
    id: '3205200009',
    districtId: '3205200',
    name: 'Situgede',
  },
  {
    id: '3205200010',
    districtId: '3205200',
    name: 'Situsari',
  },
  {
    id: '3205200011',
    districtId: '3205200',
    name: 'Situjaya',
  },
  {
    id: '3205200012',
    districtId: '3205200',
    name: 'Situsaeur',
  },
  {
    id: '3205200013',
    districtId: '3205200',
    name: 'Karangsari',
  },
  {
    id: '3205200014',
    districtId: '3205200',
    name: 'Cimurah',
  },
  {
    id: '3205200015',
    districtId: '3205200',
    name: 'Sindanglaya',
  },
  {
    id: '3205200016',
    districtId: '3205200',
    name: 'Mekarsari',
  },
  {
    id: '3205200017',
    districtId: '3205200',
    name: 'Jatisari',
  },
  {
    id: '3205200018',
    districtId: '3205200',
    name: 'Karangmulya',
  },
  {
    id: '3205200019',
    districtId: '3205200',
    name: 'Sucikaler',
  },
  {
    id: '3205200020',
    districtId: '3205200',
    name: 'Lengkongjaya',
  },
  {
    id: '3205210005',
    districtId: '3205210',
    name: 'Sukamenak',
  },
  {
    id: '3205210007',
    districtId: '3205210',
    name: 'Sindangmekar',
  },
  {
    id: '3205210008',
    districtId: '3205210',
    name: 'Sindangratu',
  },
  {
    id: '3205210012',
    districtId: '3205210',
    name: 'Cinunuk',
  },
  {
    id: '3205210013',
    districtId: '3205210',
    name: 'Wanamekar',
  },
  {
    id: '3205210014',
    districtId: '3205210',
    name: 'Wanaraja',
  },
  {
    id: '3205210015',
    districtId: '3205210',
    name: 'Wanasari',
  },
  {
    id: '3205210016',
    districtId: '3205210',
    name: 'Wanajaya',
  },
  {
    id: '3205210017',
    districtId: '3205210',
    name: 'Sindangprabu',
  },
  {
    id: '3205211001',
    districtId: '3205211',
    name: 'Linggamukti',
  },
  {
    id: '3205211002',
    districtId: '3205211',
    name: 'Sukalaksana',
  },
  {
    id: '3205211003',
    districtId: '3205211',
    name: 'Cigadog',
  },
  {
    id: '3205211004',
    districtId: '3205211',
    name: 'Tenjonagara',
  },
  {
    id: '3205211005',
    districtId: '3205211',
    name: 'Sukaratu',
  },
  {
    id: '3205211006',
    districtId: '3205211',
    name: 'Tegalpanjang',
  },
  {
    id: '3205211007',
    districtId: '3205211',
    name: 'Sadang',
  },
  {
    id: '3205212001',
    districtId: '3205212',
    name: 'Sukahurip',
  },
  {
    id: '3205212002',
    districtId: '3205212',
    name: 'Babakanloa',
  },
  {
    id: '3205212003',
    districtId: '3205212',
    name: 'Sukarasa',
  },
  {
    id: '3205212004',
    districtId: '3205212',
    name: 'Cimaragas',
  },
  {
    id: '3205212005',
    districtId: '3205212',
    name: 'Cihuni',
  },
  {
    id: '3205212006',
    districtId: '3205212',
    name: 'Citangtu',
  },
  {
    id: '3205212007',
    districtId: '3205212',
    name: 'Karangsari',
  },
  {
    id: '3205212008',
    districtId: '3205212',
    name: 'Sukamulya',
  },
  {
    id: '3205220001',
    districtId: '3205220',
    name: 'Pasanggrahan',
  },
  {
    id: '3205220006',
    districtId: '3205220',
    name: 'Sukamukti',
  },
  {
    id: '3205220007',
    districtId: '3205220',
    name: 'Mekarluyu',
  },
  {
    id: '3205220008',
    districtId: '3205220',
    name: 'Sukawening',
  },
  {
    id: '3205220009',
    districtId: '3205220',
    name: 'Sudalarang',
  },
  {
    id: '3205220010',
    districtId: '3205220',
    name: 'Maripari',
  },
  {
    id: '3205220011',
    districtId: '3205220',
    name: 'Sukahaji',
  },
  {
    id: '3205220012',
    districtId: '3205220',
    name: 'Sukasono',
  },
  {
    id: '3205220013',
    districtId: '3205220',
    name: 'Sukaluyu',
  },
  {
    id: '3205220014',
    districtId: '3205220',
    name: 'Mekarwangi',
  },
  {
    id: '3205220015',
    districtId: '3205220',
    name: 'Mekarhurip',
  },
  {
    id: '3205221001',
    districtId: '3205221',
    name: 'Sindanggalih',
  },
  {
    id: '3205221002',
    districtId: '3205221',
    name: 'Cinta',
  },
  {
    id: '3205221003',
    districtId: '3205221',
    name: 'Cintamanik',
  },
  {
    id: '3205221004',
    districtId: '3205221',
    name: 'Caringin',
  },
  {
    id: '3205230003',
    districtId: '3205230',
    name: 'Sukaraja',
  },
  {
    id: '3205230004',
    districtId: '3205230',
    name: 'Sukakarya',
  },
  {
    id: '3205230005',
    districtId: '3205230',
    name: 'Pamekarsari',
  },
  {
    id: '3205230006',
    districtId: '3205230',
    name: 'Sukasenang',
  },
  {
    id: '3205230007',
    districtId: '3205230',
    name: 'Sukaratu',
  },
  {
    id: '3205230008',
    districtId: '3205230',
    name: 'Cipicung',
  },
  {
    id: '3205230009',
    districtId: '3205230',
    name: 'Bagendit',
  },
  {
    id: '3205230010',
    districtId: '3205230',
    name: 'Sukamukti',
  },
  {
    id: '3205230011',
    districtId: '3205230',
    name: 'Banyuresmi',
  },
  {
    id: '3205230012',
    districtId: '3205230',
    name: 'Binakarya',
  },
  {
    id: '3205230013',
    districtId: '3205230',
    name: 'Dangdeur',
  },
  {
    id: '3205230014',
    districtId: '3205230',
    name: 'Karyasari',
  },
  {
    id: '3205230015',
    districtId: '3205230',
    name: 'Karyamukti',
  },
  {
    id: '3205230016',
    districtId: '3205230',
    name: 'Cimareme',
  },
  {
    id: '3205230017',
    districtId: '3205230',
    name: 'Sukalaksana',
  },
  {
    id: '3205240001',
    districtId: '3205240',
    name: 'Dano',
  },
  {
    id: '3205240002',
    districtId: '3205240',
    name: 'Jangkurang',
  },
  {
    id: '3205240003',
    districtId: '3205240',
    name: 'Lembang',
  },
  {
    id: '3205240004',
    districtId: '3205240',
    name: 'Cipancar',
  },
  {
    id: '3205240005',
    districtId: '3205240',
    name: 'Kandangmukti',
  },
  {
    id: '3205240006',
    districtId: '3205240',
    name: 'Ciburial',
  },
  {
    id: '3205240007',
    districtId: '3205240',
    name: 'Salamnunggal',
  },
  {
    id: '3205240009',
    districtId: '3205240',
    name: 'Haruman',
  },
  {
    id: '3205240010',
    districtId: '3205240',
    name: 'Margaluyu',
  },
  {
    id: '3205240011',
    districtId: '3205240',
    name: 'Cangkuang',
  },
  {
    id: '3205240012',
    districtId: '3205240',
    name: 'Sukarame',
  },
  {
    id: '3205250001',
    districtId: '3205250',
    name: 'Margahayu',
  },
  {
    id: '3205250002',
    districtId: '3205250',
    name: 'Margacinta',
  },
  {
    id: '3205250003',
    districtId: '3205250',
    name: 'Dungusiku',
  },
  {
    id: '3205250004',
    districtId: '3205250',
    name: 'Tambaksari',
  },
  {
    id: '3205250005',
    districtId: '3205250',
    name: 'Karangsari',
  },
  {
    id: '3205250006',
    districtId: '3205250',
    name: 'Karanganyar',
  },
  {
    id: '3205250007',
    districtId: '3205250',
    name: 'Sindangsari',
  },
  {
    id: '3205250008',
    districtId: '3205250',
    name: 'Leuwigoong',
  },
  {
    id: '3205260001',
    districtId: '3205260',
    name: 'Cibatu',
  },
  {
    id: '3205260002',
    districtId: '3205260',
    name: 'Kertajaya',
  },
  {
    id: '3205260003',
    districtId: '3205260',
    name: 'Wanakerta',
  },
  {
    id: '3205260004',
    districtId: '3205260',
    name: 'Karyamukti',
  },
  {
    id: '3205260005',
    districtId: '3205260',
    name: 'Padasuka',
  },
  {
    id: '3205260007',
    districtId: '3205260',
    name: 'Cibunar',
  },
  {
    id: '3205260008',
    districtId: '3205260',
    name: 'Sukalilah',
  },
  {
    id: '3205260009',
    districtId: '3205260',
    name: 'Girimukti',
  },
  {
    id: '3205260015',
    districtId: '3205260',
    name: 'Mekarsari',
  },
  {
    id: '3205260016',
    districtId: '3205260',
    name: 'Sindangsuka',
  },
  {
    id: '3205261001',
    districtId: '3205261',
    name: 'Sukamaju',
  },
  {
    id: '3205261002',
    districtId: '3205261',
    name: 'Girijaya',
  },
  {
    id: '3205261003',
    districtId: '3205261',
    name: 'Kersamanah',
  },
  {
    id: '3205261004',
    districtId: '3205261',
    name: 'Nanjungjaya',
  },
  {
    id: '3205261005',
    districtId: '3205261',
    name: 'Sukamerang',
  },
  {
    id: '3205261006',
    districtId: '3205261',
    name: 'Mekarraya',
  },
  {
    id: '3205270001',
    districtId: '3205270',
    name: 'Cipareuan',
  },
  {
    id: '3205270002',
    districtId: '3205270',
    name: 'Cibiuk Kidul',
  },
  {
    id: '3205270003',
    districtId: '3205270',
    name: 'Cibiuk Kaler',
  },
  {
    id: '3205270004',
    districtId: '3205270',
    name: 'Majasari',
  },
  {
    id: '3205270005',
    districtId: '3205270',
    name: 'Lingkungpasir',
  },
  {
    id: '3205280001',
    districtId: '3205280',
    name: 'Rancasalak',
  },
  {
    id: '3205280002',
    districtId: '3205280',
    name: 'Mandalasari',
  },
  {
    id: '3205280003',
    districtId: '3205280',
    name: 'Hegarsari',
  },
  {
    id: '3205280004',
    districtId: '3205280',
    name: 'Talagasari',
  },
  {
    id: '3205280005',
    districtId: '3205280',
    name: 'Karangmulya',
  },
  {
    id: '3205280006',
    districtId: '3205280',
    name: 'Karangtengah',
  },
  {
    id: '3205280007',
    districtId: '3205280',
    name: 'Gandamekar',
  },
  {
    id: '3205280008',
    districtId: '3205280',
    name: 'Kadungora',
  },
  {
    id: '3205280009',
    districtId: '3205280',
    name: 'Neglasari',
  },
  {
    id: '3205280010',
    districtId: '3205280',
    name: 'Cikembulan',
  },
  {
    id: '3205280011',
    districtId: '3205280',
    name: 'Cisaat',
  },
  {
    id: '3205280012',
    districtId: '3205280',
    name: 'Mekarbakti',
  },
  {
    id: '3205280013',
    districtId: '3205280',
    name: 'Tanggulun',
  },
  {
    id: '3205280014',
    districtId: '3205280',
    name: 'Harumansari',
  },
  {
    id: '3205290002',
    districtId: '3205290',
    name: 'Cijolang',
  },
  {
    id: '3205290003',
    districtId: '3205290',
    name: 'Cigagade',
  },
  {
    id: '3205290004',
    districtId: '3205290',
    name: 'Pasirwaru',
  },
  {
    id: '3205290005',
    districtId: '3205290',
    name: 'Limbanganbarat',
  },
  {
    id: '3205290006',
    districtId: '3205290',
    name: 'Limbangantengah',
  },
  {
    id: '3205290007',
    districtId: '3205290',
    name: 'Limbangantimur',
  },
  {
    id: '3205290008',
    districtId: '3205290',
    name: 'Dunguswiru',
  },
  {
    id: '3205290009',
    districtId: '3205290',
    name: 'Galihpakuwon',
  },
  {
    id: '3205290010',
    districtId: '3205290',
    name: 'Neglasari',
  },
  {
    id: '3205290011',
    districtId: '3205290',
    name: 'Surabaya',
  },
  {
    id: '3205290012',
    districtId: '3205290',
    name: 'Ciwangi',
  },
  {
    id: '3205290013',
    districtId: '3205290',
    name: 'Pangeureunan',
  },
  {
    id: '3205290014',
    districtId: '3205290',
    name: 'Simpen Kidul',
  },
  {
    id: '3205290015',
    districtId: '3205290',
    name: 'Simpen Kaler',
  },
  {
    id: '3205300001',
    districtId: '3205300',
    name: 'Cigawir',
  },
  {
    id: '3205300002',
    districtId: '3205300',
    name: 'Putrajawa',
  },
  {
    id: '3205300003',
    districtId: '3205300',
    name: 'Mekarsari',
  },
  {
    id: '3205300004',
    districtId: '3205300',
    name: 'Selaawi',
  },
  {
    id: '3205300005',
    districtId: '3205300',
    name: 'Cirapuhan',
  },
  {
    id: '3205300006',
    districtId: '3205300',
    name: 'Samida',
  },
  {
    id: '3205300007',
    districtId: '3205300',
    name: 'Pelitaasih',
  },
  {
    id: '3205310001',
    districtId: '3205310',
    name: 'Kutanagara',
  },
  {
    id: '3205310002',
    districtId: '3205310',
    name: 'Sanding',
  },
  {
    id: '3205310003',
    districtId: '3205310',
    name: 'Karangmulya',
  },
  {
    id: '3205310004',
    districtId: '3205310',
    name: 'Cinagara',
  },
  {
    id: '3205310005',
    districtId: '3205310',
    name: 'Cikarag',
  },
  {
    id: '3205310006',
    districtId: '3205310',
    name: 'Campaka',
  },
  {
    id: '3205310007',
    districtId: '3205310',
    name: 'Sukamanah',
  },
  {
    id: '3205310008',
    districtId: '3205310',
    name: 'Cihaurkuning',
  },
  {
    id: '3205310009',
    districtId: '3205310',
    name: 'Citeras',
  },
  {
    id: '3205310010',
    districtId: '3205310',
    name: 'Lewobaru',
  },
  {
    id: '3205310011',
    districtId: '3205310',
    name: 'Sukaratu',
  },
  {
    id: '3205310012',
    districtId: '3205310',
    name: 'Sukarasa',
  },
  {
    id: '3205310013',
    districtId: '3205310',
    name: 'Cibunar',
  },
  {
    id: '3205310014',
    districtId: '3205310',
    name: 'Malangbong',
  },
  {
    id: '3205310015',
    districtId: '3205310',
    name: 'Cisitu',
  },
  {
    id: '3205310016',
    districtId: '3205310',
    name: 'Sakawayana',
  },
  {
    id: '3205310017',
    districtId: '3205310',
    name: 'Sekarwangi',
  },
  {
    id: '3205310018',
    districtId: '3205310',
    name: 'Mekarasih',
  },
  {
    id: '3205310019',
    districtId: '3205310',
    name: 'Cilampuyang',
  },
  {
    id: '3205310020',
    districtId: '3205310',
    name: 'Mekar Mulya',
  },
  {
    id: '3205310021',
    districtId: '3205310',
    name: 'Barudua',
  },
  {
    id: '3205310022',
    districtId: '3205310',
    name: 'Bunisari',
  },
  {
    id: '3205310023',
    districtId: '3205310',
    name: 'Sukajaya',
  },
  {
    id: '3205310024',
    districtId: '3205310',
    name: 'Girimakmur',
  },
  {
    id: '3206010001',
    districtId: '3206010',
    name: 'Ciheras',
  },
  {
    id: '3206010002',
    districtId: '3206010',
    name: 'Cipanas',
  },
  {
    id: '3206010003',
    districtId: '3206010',
    name: 'Ciandum',
  },
  {
    id: '3206010004',
    districtId: '3206010',
    name: 'Cipatujah',
  },
  {
    id: '3206010005',
    districtId: '3206010',
    name: 'Sindangkerta',
  },
  {
    id: '3206010006',
    districtId: '3206010',
    name: 'Cikawungading',
  },
  {
    id: '3206010007',
    districtId: '3206010',
    name: 'Kertasari',
  },
  {
    id: '3206010008',
    districtId: '3206010',
    name: 'Padawaras',
  },
  {
    id: '3206010009',
    districtId: '3206010',
    name: 'Darawati',
  },
  {
    id: '3206010010',
    districtId: '3206010',
    name: 'Bantarkalong',
  },
  {
    id: '3206010011',
    districtId: '3206010',
    name: 'Tobongjaya',
  },
  {
    id: '3206010012',
    districtId: '3206010',
    name: 'Nangelasari',
  },
  {
    id: '3206010013',
    districtId: '3206010',
    name: 'Nagrog',
  },
  {
    id: '3206010014',
    districtId: '3206010',
    name: 'Pameutingan',
  },
  {
    id: '3206010015',
    districtId: '3206010',
    name: 'Sukahurip',
  },
  {
    id: '3206020001',
    districtId: '3206020',
    name: 'Cidadap',
  },
  {
    id: '3206020002',
    districtId: '3206020',
    name: 'Kujang',
  },
  {
    id: '3206020003',
    districtId: '3206020',
    name: 'Sarimukti',
  },
  {
    id: '3206020004',
    districtId: '3206020',
    name: 'Ciawi',
  },
  {
    id: '3206020005',
    districtId: '3206020',
    name: 'Cikapinis',
  },
  {
    id: '3206020006',
    districtId: '3206020',
    name: 'Cikupa',
  },
  {
    id: '3206020007',
    districtId: '3206020',
    name: 'Karangnunggal',
  },
  {
    id: '3206020008',
    districtId: '3206020',
    name: 'Karangmekar',
  },
  {
    id: '3206020009',
    districtId: '3206020',
    name: 'Cibatuireng',
  },
  {
    id: '3206020010',
    districtId: '3206020',
    name: 'Cibatu',
  },
  {
    id: '3206020011',
    districtId: '3206020',
    name: 'Sukawangun',
  },
  {
    id: '3206020012',
    districtId: '3206020',
    name: 'Cintawangi',
  },
  {
    id: '3206020013',
    districtId: '3206020',
    name: 'Cikukulu',
  },
  {
    id: '3206020014',
    districtId: '3206020',
    name: 'Sarimanggu',
  },
  {
    id: '3206030001',
    districtId: '3206030',
    name: 'Mandalajaya',
  },
  {
    id: '3206030002',
    districtId: '3206030',
    name: 'Cikalong',
  },
  {
    id: '3206030003',
    districtId: '3206030',
    name: 'Cikancra',
  },
  {
    id: '3206030004',
    districtId: '3206030',
    name: 'Tonjongsari',
  },
  {
    id: '3206030005',
    districtId: '3206030',
    name: 'Singkir',
  },
  {
    id: '3206030006',
    districtId: '3206030',
    name: 'Panyiaran',
  },
  {
    id: '3206030007',
    districtId: '3206030',
    name: 'Cibeber',
  },
  {
    id: '3206030008',
    districtId: '3206030',
    name: 'Cidadali',
  },
  {
    id: '3206030009',
    districtId: '3206030',
    name: 'Kubangsari',
  },
  {
    id: '3206030010',
    districtId: '3206030',
    name: 'Cikadu',
  },
  {
    id: '3206030011',
    districtId: '3206030',
    name: 'Sindangjaya',
  },
  {
    id: '3206030012',
    districtId: '3206030',
    name: 'Kalapagenep',
  },
  {
    id: '3206030013',
    districtId: '3206030',
    name: 'Cimanuk',
  },
  {
    id: '3206040001',
    districtId: '3206040',
    name: 'Margaluyu',
  },
  {
    id: '3206040002',
    districtId: '3206040',
    name: 'Cibuniasih',
  },
  {
    id: '3206040003',
    districtId: '3206040',
    name: 'Pangliaran',
  },
  {
    id: '3206040004',
    districtId: '3206040',
    name: 'Pancawangi',
  },
  {
    id: '3206040005',
    districtId: '3206040',
    name: 'Jayamukti',
  },
  {
    id: '3206040006',
    districtId: '3206040',
    name: 'Tonjong',
  },
  {
    id: '3206040007',
    districtId: '3206040',
    name: 'Cibongas',
  },
  {
    id: '3206040008',
    districtId: '3206040',
    name: 'Cikawung',
  },
  {
    id: '3206040009',
    districtId: '3206040',
    name: 'Tawang',
  },
  {
    id: '3206040010',
    districtId: '3206040',
    name: 'Mekarsari',
  },
  {
    id: '3206040011',
    districtId: '3206040',
    name: 'Neglasari',
  },
  {
    id: '3206050001',
    districtId: '3206050',
    name: 'Gunungsari',
  },
  {
    id: '3206050002',
    districtId: '3206050',
    name: 'Cilumba',
  },
  {
    id: '3206050003',
    districtId: '3206050',
    name: 'Linggalaksana',
  },
  {
    id: '3206050004',
    districtId: '3206050',
    name: 'Pakemitan',
  },
  {
    id: '3206050005',
    districtId: '3206050',
    name: 'Cogreg',
  },
  {
    id: '3206050006',
    districtId: '3206050',
    name: 'Lengkongbarang',
  },
  {
    id: '3206050007',
    districtId: '3206050',
    name: 'Tanjungbarang',
  },
  {
    id: '3206050008',
    districtId: '3206050',
    name: 'Cayur',
  },
  {
    id: '3206050009',
    districtId: '3206050',
    name: 'Sindangasih',
  },
  {
    id: '3206060001',
    districtId: '3206060',
    name: 'Eureunpalay',
  },
  {
    id: '3206060002',
    districtId: '3206060',
    name: 'Setiawaras',
  },
  {
    id: '3206060003',
    districtId: '3206060',
    name: 'Cisempur',
  },
  {
    id: '3206060004',
    districtId: '3206060',
    name: 'Parung',
  },
  {
    id: '3206060005',
    districtId: '3206060',
    name: 'Cibalong',
  },
  {
    id: '3206060014',
    districtId: '3206060',
    name: 'Singajaya',
  },
  {
    id: '3206061001',
    districtId: '3206061',
    name: 'Karyabakti',
  },
  {
    id: '3206061002',
    districtId: '3206061',
    name: 'Cigunung',
  },
  {
    id: '3206061003',
    districtId: '3206061',
    name: 'Cibungur',
  },
  {
    id: '3206061004',
    districtId: '3206061',
    name: 'Parungponteng',
  },
  {
    id: '3206061005',
    districtId: '3206061',
    name: 'Girikencana',
  },
  {
    id: '3206061006',
    districtId: '3206061',
    name: 'Barumekar',
  },
  {
    id: '3206061007',
    districtId: '3206061',
    name: 'Cibanteng',
  },
  {
    id: '3206061008',
    districtId: '3206061',
    name: 'Burujuljaya',
  },
  {
    id: '3206070002',
    districtId: '3206070',
    name: 'Sirnagalih',
  },
  {
    id: '3206070003',
    districtId: '3206070',
    name: 'Simpang',
  },
  {
    id: '3206070004',
    districtId: '3206070',
    name: 'Hegarwangi',
  },
  {
    id: '3206070008',
    districtId: '3206070',
    name: 'Wangunsari',
  },
  {
    id: '3206070009',
    districtId: '3206070',
    name: 'Pamijahan',
  },
  {
    id: '3206070010',
    districtId: '3206070',
    name: 'Parakanhonje',
  },
  {
    id: '3206070016',
    districtId: '3206070',
    name: 'Sukamaju',
  },
  {
    id: '3206070017',
    districtId: '3206070',
    name: 'Wakap',
  },
  {
    id: '3206071001',
    districtId: '3206071',
    name: 'Girijaya',
  },
  {
    id: '3206071002',
    districtId: '3206071',
    name: 'Bojongasih',
  },
  {
    id: '3206071003',
    districtId: '3206071',
    name: 'Sindangsari',
  },
  {
    id: '3206071004',
    districtId: '3206071',
    name: 'Cikadongdong',
  },
  {
    id: '3206071005',
    districtId: '3206071',
    name: 'Mertajaya',
  },
  {
    id: '3206071006',
    districtId: '3206071',
    name: 'Toblongan',
  },
  {
    id: '3206072001',
    districtId: '3206072',
    name: 'Bojongsari',
  },
  {
    id: '3206072002',
    districtId: '3206072',
    name: 'Cintabodas',
  },
  {
    id: '3206072003',
    districtId: '3206072',
    name: 'Cikuya',
  },
  {
    id: '3206072004',
    districtId: '3206072',
    name: 'Cipicung',
  },
  {
    id: '3206072005',
    districtId: '3206072',
    name: 'Mekarlaksana',
  },
  {
    id: '3206080001',
    districtId: '3206080',
    name: 'Campakasari',
  },
  {
    id: '3206080002',
    districtId: '3206080',
    name: 'Bojongkapol',
  },
  {
    id: '3206080003',
    districtId: '3206080',
    name: 'Wandasari',
  },
  {
    id: '3206080004',
    districtId: '3206080',
    name: 'Pedangkamulyan',
  },
  {
    id: '3206080005',
    districtId: '3206080',
    name: 'Kertanegla',
  },
  {
    id: '3206080006',
    districtId: '3206080',
    name: 'Bojonggambir',
  },
  {
    id: '3206080007',
    districtId: '3206080',
    name: 'Mangkonjaya',
  },
  {
    id: '3206080008',
    districtId: '3206080',
    name: 'Ciroyom',
  },
  {
    id: '3206080009',
    districtId: '3206080',
    name: 'Purwaraharja',
  },
  {
    id: '3206080010',
    districtId: '3206080',
    name: 'Girimukti',
  },
  {
    id: '3206090001',
    districtId: '3206090',
    name: 'Cukangjayaguna',
  },
  {
    id: '3206090002',
    districtId: '3206090',
    name: 'Sukabakti',
  },
  {
    id: '3206090003',
    districtId: '3206090',
    name: 'Parumasan',
  },
  {
    id: '3206090004',
    districtId: '3206090',
    name: 'Sepatnunggal',
  },
  {
    id: '3206090005',
    districtId: '3206090',
    name: 'Raksajaya',
  },
  {
    id: '3206090006',
    districtId: '3206090',
    name: 'Sodonghilir',
  },
  {
    id: '3206090007',
    districtId: '3206090',
    name: 'Cukangkawung',
  },
  {
    id: '3206090008',
    districtId: '3206090',
    name: 'Cikalong',
  },
  {
    id: '3206090009',
    districtId: '3206090',
    name: 'Cipaingeun',
  },
  {
    id: '3206090010',
    districtId: '3206090',
    name: 'Pakalongan',
  },
  {
    id: '3206090011',
    districtId: '3206090',
    name: 'Leuwidulang',
  },
  {
    id: '3206090012',
    districtId: '3206090',
    name: 'Muncang',
  },
  {
    id: '3206100001',
    districtId: '3206100',
    name: 'Banyuasih',
  },
  {
    id: '3206100002',
    districtId: '3206100',
    name: 'Taraju',
  },
  {
    id: '3206100003',
    districtId: '3206100',
    name: 'Raksasari',
  },
  {
    id: '3206100004',
    districtId: '3206100',
    name: 'Singasari',
  },
  {
    id: '3206100005',
    districtId: '3206100',
    name: 'Cikubang',
  },
  {
    id: '3206100007',
    districtId: '3206100',
    name: 'Kertaraharja',
  },
  {
    id: '3206100008',
    districtId: '3206100',
    name: 'Purwarahayu',
  },
  {
    id: '3206100009',
    districtId: '3206100',
    name: 'Pageralam',
  },
  {
    id: '3206110009',
    districtId: '3206110',
    name: 'Sukarasa',
  },
  {
    id: '3206110010',
    districtId: '3206110',
    name: 'Jahiang',
  },
  {
    id: '3206110011',
    districtId: '3206110',
    name: 'Sundawenang',
  },
  {
    id: '3206110012',
    districtId: '3206110',
    name: 'Kawungsari',
  },
  {
    id: '3206110013',
    districtId: '3206110',
    name: 'Tenjowaringin',
  },
  {
    id: '3206110014',
    districtId: '3206110',
    name: 'Kutawaringin',
  },
  {
    id: '3206110015',
    districtId: '3206110',
    name: 'Tanjungsari',
  },
  {
    id: '3206110016',
    districtId: '3206110',
    name: 'Neglasari',
  },
  {
    id: '3206110017',
    districtId: '3206110',
    name: 'Karangmukti',
  },
  {
    id: '3206110018',
    districtId: '3206110',
    name: 'Salawu',
  },
  {
    id: '3206110019',
    districtId: '3206110',
    name: 'Margalaksana',
  },
  {
    id: '3206110020',
    districtId: '3206110',
    name: 'Serang',
  },
  {
    id: '3206111001',
    districtId: '3206111',
    name: 'Mandalasari',
  },
  {
    id: '3206111002',
    districtId: '3206111',
    name: 'Sukasari',
  },
  {
    id: '3206111003',
    districtId: '3206111',
    name: 'Puspasari',
  },
  {
    id: '3206111004',
    districtId: '3206111',
    name: 'Puspahiang',
  },
  {
    id: '3206111005',
    districtId: '3206111',
    name: 'Pusparahayu',
  },
  {
    id: '3206111006',
    districtId: '3206111',
    name: 'Luyubakti',
  },
  {
    id: '3206111007',
    districtId: '3206111',
    name: 'Cimanggu',
  },
  {
    id: '3206111008',
    districtId: '3206111',
    name: 'Puspajaya',
  },
  {
    id: '3206120001',
    districtId: '3206120',
    name: 'Cikeusal',
  },
  {
    id: '3206120002',
    districtId: '3206120',
    name: 'Sukanagara',
  },
  {
    id: '3206120003',
    districtId: '3206120',
    name: 'Sukasenang',
  },
  {
    id: '3206120004',
    districtId: '3206120',
    name: 'Tanjungjaya',
  },
  {
    id: '3206120005',
    districtId: '3206120',
    name: 'Cintajaya',
  },
  {
    id: '3206120006',
    districtId: '3206120',
    name: 'Cibalanarik',
  },
  {
    id: '3206120007',
    districtId: '3206120',
    name: 'Cilolohan',
  },
  {
    id: '3206130001',
    districtId: '3206130',
    name: 'Mekarjaya',
  },
  {
    id: '3206130002',
    districtId: '3206130',
    name: 'Sirnajaya',
  },
  {
    id: '3206130003',
    districtId: '3206130',
    name: 'Janggala',
  },
  {
    id: '3206130004',
    districtId: '3206130',
    name: 'Sukapura',
  },
  {
    id: '3206130005',
    districtId: '3206130',
    name: 'Tarunajaya',
  },
  {
    id: '3206130006',
    districtId: '3206130',
    name: 'Leuwibudah',
  },
  {
    id: '3206130007',
    districtId: '3206130',
    name: 'Linggaraja',
  },
  {
    id: '3206130008',
    districtId: '3206130',
    name: 'Margalaksana',
  },
  {
    id: '3206140003',
    districtId: '3206140',
    name: 'Mandalahayu',
  },
  {
    id: '3206140004',
    districtId: '3206140',
    name: 'Karyamandala',
  },
  {
    id: '3206140005',
    districtId: '3206140',
    name: 'Mulyasari',
  },
  {
    id: '3206140006',
    districtId: '3206140',
    name: 'Tanjungsari',
  },
  {
    id: '3206140007',
    districtId: '3206140',
    name: 'Mandalaguna',
  },
  {
    id: '3206140008',
    districtId: '3206140',
    name: 'Kawitan',
  },
  {
    id: '3206140009',
    districtId: '3206140',
    name: 'Mandalawangi',
  },
  {
    id: '3206140010',
    districtId: '3206140',
    name: 'Banjarwaringin',
  },
  {
    id: '3206140018',
    districtId: '3206140',
    name: 'Karyawangi',
  },
  {
    id: '3206141001',
    districtId: '3206141',
    name: 'Mandalamekar',
  },
  {
    id: '3206141002',
    districtId: '3206141',
    name: 'Kersagalih',
  },
  {
    id: '3206141003',
    districtId: '3206141',
    name: 'Ciwarak',
  },
  {
    id: '3206141004',
    districtId: '3206141',
    name: 'Jatiwaras',
  },
  {
    id: '3206141005',
    districtId: '3206141',
    name: 'Papayan',
  },
  {
    id: '3206141006',
    districtId: '3206141',
    name: 'Neglasari',
  },
  {
    id: '3206141007',
    districtId: '3206141',
    name: 'Kaputihan',
  },
  {
    id: '3206141008',
    districtId: '3206141',
    name: 'Setiawangi',
  },
  {
    id: '3206141009',
    districtId: '3206141',
    name: 'Sukakerta',
  },
  {
    id: '3206141010',
    districtId: '3206141',
    name: 'Kertarahayu',
  },
  {
    id: '3206141011',
    districtId: '3206141',
    name: 'Mandala Hurip',
  },
  {
    id: '3206150001',
    districtId: '3206150',
    name: 'Cisarua',
  },
  {
    id: '3206150006',
    districtId: '3206150',
    name: 'Pasirmukti',
  },
  {
    id: '3206150007',
    districtId: '3206150',
    name: 'Cikondang',
  },
  {
    id: '3206150008',
    districtId: '3206150',
    name: 'Cijulang',
  },
  {
    id: '3206150009',
    districtId: '3206150',
    name: 'Nagaratengah',
  },
  {
    id: '3206150010',
    districtId: '3206150',
    name: 'Ciampanan',
  },
  {
    id: '3206150011',
    districtId: '3206150',
    name: 'Cineam',
  },
  {
    id: '3206150012',
    districtId: '3206150',
    name: 'Madiasari',
  },
  {
    id: '3206150013',
    districtId: '3206150',
    name: 'Rajadatu',
  },
  {
    id: '3206150014',
    districtId: '3206150',
    name: 'Ancol',
  },
  {
    id: '3206151001',
    districtId: '3206151',
    name: 'Citalahab',
  },
  {
    id: '3206151002',
    districtId: '3206151',
    name: 'Sirnajaya',
  },
  {
    id: '3206151003',
    districtId: '3206151',
    name: 'Karangjaya',
  },
  {
    id: '3206151004',
    districtId: '3206151',
    name: 'Karanglayung',
  },
  {
    id: '3206160007',
    districtId: '3206160',
    name: 'Batusumur',
  },
  {
    id: '3206160008',
    districtId: '3206160',
    name: 'Cihaur',
  },
  {
    id: '3206160009',
    districtId: '3206160',
    name: 'Pasirpanjang',
  },
  {
    id: '3206160010',
    districtId: '3206160',
    name: 'Kalimanggis',
  },
  {
    id: '3206160011',
    districtId: '3206160',
    name: 'Cibeber',
  },
  {
    id: '3206160012',
    districtId: '3206160',
    name: 'Gunajaya',
  },
  {
    id: '3206160013',
    districtId: '3206160',
    name: 'Margahayu',
  },
  {
    id: '3206160014',
    districtId: '3206160',
    name: 'Kamulyan',
  },
  {
    id: '3206160015',
    districtId: '3206160',
    name: 'Manonjaya',
  },
  {
    id: '3206160016',
    districtId: '3206160',
    name: 'Margaluyu',
  },
  {
    id: '3206160017',
    districtId: '3206160',
    name: 'Cilangkap',
  },
  {
    id: '3206160018',
    districtId: '3206160',
    name: 'Pasirbatang',
  },
  {
    id: '3206161001',
    districtId: '3206161',
    name: 'Cinunjang',
  },
  {
    id: '3206161002',
    districtId: '3206161',
    name: 'Malatisuka',
  },
  {
    id: '3206161003',
    districtId: '3206161',
    name: 'Giriwangi',
  },
  {
    id: '3206161004',
    districtId: '3206161',
    name: 'Jatijaya',
  },
  {
    id: '3206161005',
    districtId: '3206161',
    name: 'Gunungtanjung',
  },
  {
    id: '3206161006',
    districtId: '3206161',
    name: 'Tanjungsari',
  },
  {
    id: '3206161007',
    districtId: '3206161',
    name: 'Bojongsari',
  },
  {
    id: '3206190007',
    districtId: '3206190',
    name: 'Sukaasih',
  },
  {
    id: '3206190008',
    districtId: '3206190',
    name: 'Cikunten',
  },
  {
    id: '3206190009',
    districtId: '3206190',
    name: 'Sukaherang',
  },
  {
    id: '3206190010',
    districtId: '3206190',
    name: 'Singasari',
  },
  {
    id: '3206190011',
    districtId: '3206190',
    name: 'Singaparna',
  },
  {
    id: '3206190012',
    districtId: '3206190',
    name: 'Sukamulya',
  },
  {
    id: '3206190013',
    districtId: '3206190',
    name: 'Cipakat',
  },
  {
    id: '3206190020',
    districtId: '3206190',
    name: 'Cintaraja',
  },
  {
    id: '3206190021',
    districtId: '3206190',
    name: 'Cikunir',
  },
  {
    id: '3206190022',
    districtId: '3206190',
    name: 'Cikadongdong',
  },
  {
    id: '3206191001',
    districtId: '3206191',
    name: 'Sukarapih',
  },
  {
    id: '3206191002',
    districtId: '3206191',
    name: 'Wargakerta',
  },
  {
    id: '3206191003',
    districtId: '3206191',
    name: 'Suka Menak',
  },
  {
    id: '3206191004',
    districtId: '3206191',
    name: 'Padasuka',
  },
  {
    id: '3206191005',
    districtId: '3206191',
    name: 'Sukakarsa',
  },
  {
    id: '3206191006',
    districtId: '3206191',
    name: 'Sukarame',
  },
  {
    id: '3206192001',
    districtId: '3206192',
    name: 'Pasirsalam',
  },
  {
    id: '3206192002',
    districtId: '3206192',
    name: 'Sukaluyu',
  },
  {
    id: '3206192003',
    districtId: '3206192',
    name: 'Sukasukur',
  },
  {
    id: '3206192004',
    districtId: '3206192',
    name: 'Salebu',
  },
  {
    id: '3206192005',
    districtId: '3206192',
    name: 'Mangunreja',
  },
  {
    id: '3206192006',
    districtId: '3206192',
    name: 'Margajaya',
  },
  {
    id: '3206200001',
    districtId: '3206200',
    name: 'Sirnagalih',
  },
  {
    id: '3206200002',
    districtId: '3206200',
    name: 'Kersamaju',
  },
  {
    id: '3206200003',
    districtId: '3206200',
    name: 'Tanjungkarang',
  },
  {
    id: '3206200004',
    districtId: '3206200',
    name: 'Nangtang',
  },
  {
    id: '3206200005',
    districtId: '3206200',
    name: 'Pusparaja',
  },
  {
    id: '3206200006',
    districtId: '3206200',
    name: 'Jayapura',
  },
  {
    id: '3206200007',
    districtId: '3206200',
    name: 'Lengkongjaya',
  },
  {
    id: '3206200008',
    districtId: '3206200',
    name: 'Tenjonagara',
  },
  {
    id: '3206200009',
    districtId: '3206200',
    name: 'Nanggerang',
  },
  {
    id: '3206200010',
    districtId: '3206200',
    name: 'Sukamanah',
  },
  {
    id: '3206200011',
    districtId: '3206200',
    name: 'Sirnaputra',
  },
  {
    id: '3206200012',
    districtId: '3206200',
    name: 'Sirnaraja',
  },
  {
    id: '3206200013',
    districtId: '3206200',
    name: 'Cigalontang',
  },
  {
    id: '3206200014',
    districtId: '3206200',
    name: 'Puspamukti',
  },
  {
    id: '3206200015',
    districtId: '3206200',
    name: 'Cidugaleun',
  },
  {
    id: '3206200016',
    districtId: '3206200',
    name: 'Parentas',
  },
  {
    id: '3206210003',
    districtId: '3206210',
    name: 'Arjasari',
  },
  {
    id: '3206210007',
    districtId: '3206210',
    name: 'Ciawang',
  },
  {
    id: '3206210008',
    districtId: '3206210',
    name: 'Jayamukti',
  },
  {
    id: '3206210015',
    districtId: '3206210',
    name: 'Linggawangi',
  },
  {
    id: '3206210016',
    districtId: '3206210',
    name: 'Linggamulya',
  },
  {
    id: '3206210017',
    districtId: '3206210',
    name: 'Cigadog',
  },
  {
    id: '3206210018',
    districtId: '3206210',
    name: 'Mandalagiri',
  },
  {
    id: '3206211001',
    districtId: '3206211',
    name: 'Sirnasari',
  },
  {
    id: '3206211002',
    districtId: '3206211',
    name: 'Linggasirna',
  },
  {
    id: '3206211003',
    districtId: '3206211',
    name: 'Selawangi',
  },
  {
    id: '3206211004',
    districtId: '3206211',
    name: 'Sariwangi',
  },
  {
    id: '3206211005',
    districtId: '3206211',
    name: 'Jayaputra',
  },
  {
    id: '3206211006',
    districtId: '3206211',
    name: 'Jayaratu',
  },
  {
    id: '3206211007',
    districtId: '3206211',
    name: 'Sukamulih',
  },
  {
    id: '3206211008',
    districtId: '3206211',
    name: 'Sukaharja',
  },
  {
    id: '3206212001',
    districtId: '3206212',
    name: 'Cilampunghilir',
  },
  {
    id: '3206212002',
    districtId: '3206212',
    name: 'Rancapaku',
  },
  {
    id: '3206212003',
    districtId: '3206212',
    name: 'Cisaruni',
  },
  {
    id: '3206212004',
    districtId: '3206212',
    name: 'Padakembang',
  },
  {
    id: '3206212005',
    districtId: '3206212',
    name: 'Mekarjaya',
  },
  {
    id: '3206221001',
    districtId: '3206221',
    name: 'Tawangbanteng',
  },
  {
    id: '3206221002',
    districtId: '3206221',
    name: 'Gunungsari',
  },
  {
    id: '3206221003',
    districtId: '3206221',
    name: 'Sukamahi',
  },
  {
    id: '3206221004',
    districtId: '3206221',
    name: 'Sukagalih',
  },
  {
    id: '3206221005',
    districtId: '3206221',
    name: 'Indrajaya',
  },
  {
    id: '3206221006',
    districtId: '3206221',
    name: 'Sukaratu',
  },
  {
    id: '3206221007',
    districtId: '3206221',
    name: 'Sinagar',
  },
  {
    id: '3206221008',
    districtId: '3206221',
    name: 'Linggajati',
  },
  {
    id: '3206230001',
    districtId: '3206230',
    name: 'Santanamekar',
  },
  {
    id: '3206230002',
    districtId: '3206230',
    name: 'Cisayong',
  },
  {
    id: '3206230003',
    districtId: '3206230',
    name: 'Sukajadi',
  },
  {
    id: '3206230004',
    districtId: '3206230',
    name: 'Sukasukur',
  },
  {
    id: '3206230005',
    districtId: '3206230',
    name: 'Jatihurip',
  },
  {
    id: '3206230006',
    districtId: '3206230',
    name: 'Sukaraharja',
  },
  {
    id: '3206230007',
    districtId: '3206230',
    name: 'Mekarwangi',
  },
  {
    id: '3206230008',
    districtId: '3206230',
    name: 'Nusawangi',
  },
  {
    id: '3206230009',
    districtId: '3206230',
    name: 'Cikadu',
  },
  {
    id: '3206230010',
    districtId: '3206230',
    name: 'Purwasari',
  },
  {
    id: '3206230011',
    districtId: '3206230',
    name: 'Cileuleus',
  },
  {
    id: '3206230013',
    districtId: '3206230',
    name: 'Sukasetia',
  },
  {
    id: '3206230014',
    districtId: '3206230',
    name: 'Sukamukti',
  },
  {
    id: '3206231001',
    districtId: '3206231',
    name: 'Banyurasa',
  },
  {
    id: '3206231002',
    districtId: '3206231',
    name: 'Banyuresmi',
  },
  {
    id: '3206231003',
    districtId: '3206231',
    name: 'Calingcing',
  },
  {
    id: '3206231004',
    districtId: '3206231',
    name: 'Kudadepa',
  },
  {
    id: '3206231005',
    districtId: '3206231',
    name: 'Sundakerta',
  },
  {
    id: '3206231006',
    districtId: '3206231',
    name: 'Sukahening',
  },
  {
    id: '3206231007',
    districtId: '3206231',
    name: 'Kiarajangkung',
  },
  {
    id: '3206240001',
    districtId: '3206240',
    name: 'Rajamandala',
  },
  {
    id: '3206240002',
    districtId: '3206240',
    name: 'Dawagung',
  },
  {
    id: '3206240003',
    districtId: '3206240',
    name: 'Rajapolah',
  },
  {
    id: '3206240004',
    districtId: '3206240',
    name: 'Manggungjaya',
  },
  {
    id: '3206240005',
    districtId: '3206240',
    name: 'Sukanagalih',
  },
  {
    id: '3206240006',
    districtId: '3206240',
    name: 'Sukaraja',
  },
  {
    id: '3206240007',
    districtId: '3206240',
    name: 'Manggungsari',
  },
  {
    id: '3206240008',
    districtId: '3206240',
    name: 'Tanjungpura',
  },
  {
    id: '3206250001',
    districtId: '3206250',
    name: 'Karangsembung',
  },
  {
    id: '3206250002',
    districtId: '3206250',
    name: 'Condong',
  },
  {
    id: '3206250003',
    districtId: '3206250',
    name: 'Bojonggaok',
  },
  {
    id: '3206250004',
    districtId: '3206250',
    name: 'Sindangraja',
  },
  {
    id: '3206250005',
    districtId: '3206250',
    name: 'Tanjungmekar',
  },
  {
    id: '3206250006',
    districtId: '3206250',
    name: 'Karangmulya',
  },
  {
    id: '3206250007',
    districtId: '3206250',
    name: 'Karangresik',
  },
  {
    id: '3206250008',
    districtId: '3206250',
    name: 'Geresik',
  },
  {
    id: '3206260001',
    districtId: '3206260',
    name: 'Kertamukti',
  },
  {
    id: '3206260002',
    districtId: '3206260',
    name: 'Gombong',
  },
  {
    id: '3206260004',
    districtId: '3206260',
    name: 'Margasari',
  },
  {
    id: '3206260005',
    districtId: '3206260',
    name: 'Pakemitankidul',
  },
  {
    id: '3206260006',
    districtId: '3206260',
    name: 'Ciawi',
  },
  {
    id: '3206260007',
    districtId: '3206260',
    name: 'Citamba',
  },
  {
    id: '3206260008',
    districtId: '3206260',
    name: 'Kurniabakti',
  },
  {
    id: '3206260009',
    districtId: '3206260',
    name: 'Pakemitan',
  },
  {
    id: '3206260010',
    districtId: '3206260',
    name: 'Sukamantri',
  },
  {
    id: '3206260011',
    districtId: '3206260',
    name: 'Pasirhuni',
  },
  {
    id: '3206261001',
    districtId: '3206261',
    name: 'Pamoyanan',
  },
  {
    id: '3206261002',
    districtId: '3206261',
    name: 'Buniasih',
  },
  {
    id: '3206261003',
    districtId: '3206261',
    name: 'Mekarsari',
  },
  {
    id: '3206261004',
    districtId: '3206261',
    name: 'Dirgahayu',
  },
  {
    id: '3206261005',
    districtId: '3206261',
    name: 'Cibahayu',
  },
  {
    id: '3206261006',
    districtId: '3206261',
    name: 'Kadipaten',
  },
  {
    id: '3206270007',
    districtId: '3206270',
    name: 'Cipacing',
  },
  {
    id: '3206270010',
    districtId: '3206270',
    name: 'Sukamaju',
  },
  {
    id: '3206270011',
    districtId: '3206270',
    name: 'Pagersari',
  },
  {
    id: '3206270012',
    districtId: '3206270',
    name: 'Pagerageung',
  },
  {
    id: '3206270013',
    districtId: '3206270',
    name: 'Sukadana',
  },
  {
    id: '3206270014',
    districtId: '3206270',
    name: 'Puteran',
  },
  {
    id: '3206270015',
    districtId: '3206270',
    name: 'Tanjungkerta',
  },
  {
    id: '3206270016',
    districtId: '3206270',
    name: 'Guranteng',
  },
  {
    id: '3206270017',
    districtId: '3206270',
    name: 'Nanggewer',
  },
  {
    id: '3206270018',
    districtId: '3206270',
    name: 'Sukapada',
  },
  {
    id: '3206271001',
    districtId: '3206271',
    name: 'Margamulya',
  },
  {
    id: '3206271002',
    districtId: '3206271',
    name: 'Cipondok',
  },
  {
    id: '3206271003',
    districtId: '3206271',
    name: 'Sukamenak',
  },
  {
    id: '3206271004',
    districtId: '3206271',
    name: 'Sukaresik',
  },
  {
    id: '3206271005',
    districtId: '3206271',
    name: 'Sukaratu',
  },
  {
    id: '3206271006',
    districtId: '3206271',
    name: 'Banjarsari',
  },
  {
    id: '3206271007',
    districtId: '3206271',
    name: 'Sukapancar',
  },
  {
    id: '3206271008',
    districtId: '3206271',
    name: 'Tanjungsari',
  },
  {
    id: '3207100009',
    districtId: '3207100',
    name: 'Sukasari',
  },
  {
    id: '3207100011',
    districtId: '3207100',
    name: 'Kawasen',
  },
  {
    id: '3207100012',
    districtId: '3207100',
    name: 'Cibadak',
  },
  {
    id: '3207100013',
    districtId: '3207100',
    name: 'Banjarsari',
  },
  {
    id: '3207100014',
    districtId: '3207100',
    name: 'Sindangsari',
  },
  {
    id: '3207100015',
    districtId: '3207100',
    name: 'Sindanghayu',
  },
  {
    id: '3207100016',
    districtId: '3207100',
    name: 'Sindangasih',
  },
  {
    id: '3207100017',
    districtId: '3207100',
    name: 'Purwasari',
  },
  {
    id: '3207100018',
    districtId: '3207100',
    name: 'Ciherang',
  },
  {
    id: '3207100019',
    districtId: '3207100',
    name: 'Ratawangi',
  },
  {
    id: '3207100020',
    districtId: '3207100',
    name: 'Cicapar',
  },
  {
    id: '3207100021',
    districtId: '3207100',
    name: 'Ciulu',
  },
  {
    id: '3207101001',
    districtId: '3207101',
    name: 'Cikupa',
  },
  {
    id: '3207101002',
    districtId: '3207101',
    name: 'Karyamukti',
  },
  {
    id: '3207101003',
    districtId: '3207101',
    name: 'Cigayam',
  },
  {
    id: '3207101004',
    districtId: '3207101',
    name: 'Banjaranyar',
  },
  {
    id: '3207101005',
    districtId: '3207101',
    name: 'Kalijaya',
  },
  {
    id: '3207101006',
    districtId: '3207101',
    name: 'Pasawahan',
  },
  {
    id: '3207101007',
    districtId: '3207101',
    name: 'Cikaso',
  },
  {
    id: '3207101008',
    districtId: '3207101',
    name: 'Sindangrasa',
  },
  {
    id: '3207101009',
    districtId: '3207101',
    name: 'Langkapsari',
  },
  {
    id: '3207101010',
    districtId: '3207101',
    name: 'Tanjungsari',
  },
  {
    id: '3207110001',
    districtId: '3207110',
    name: 'Sindangangin',
  },
  {
    id: '3207110002',
    districtId: '3207110',
    name: 'Puloerang',
  },
  {
    id: '3207110003',
    districtId: '3207110',
    name: 'Kalapasawit',
  },
  {
    id: '3207110004',
    districtId: '3207110',
    name: 'Sukanagara',
  },
  {
    id: '3207110005',
    districtId: '3207110',
    name: 'Kertajaya',
  },
  {
    id: '3207110006',
    districtId: '3207110',
    name: 'Sidaharja',
  },
  {
    id: '3207110007',
    districtId: '3207110',
    name: 'Baregbeg',
  },
  {
    id: '3207110008',
    districtId: '3207110',
    name: 'Cintajaya',
  },
  {
    id: '3207110009',
    districtId: '3207110',
    name: 'Tambakreja',
  },
  {
    id: '3207110010',
    districtId: '3207110',
    name: 'Cintaratu',
  },
  {
    id: '3207111001',
    districtId: '3207111',
    name: 'Kutawaringin',
  },
  {
    id: '3207111002',
    districtId: '3207111',
    name: 'Bantardawa',
  },
  {
    id: '3207111003',
    districtId: '3207111',
    name: 'Pasirlawang',
  },
  {
    id: '3207111004',
    districtId: '3207111',
    name: 'Purwadadi',
  },
  {
    id: '3207111005',
    districtId: '3207111',
    name: 'Purwajaya',
  },
  {
    id: '3207111006',
    districtId: '3207111',
    name: 'Sidarahayu',
  },
  {
    id: '3207111007',
    districtId: '3207111',
    name: 'Karangpaningal',
  },
  {
    id: '3207111008',
    districtId: '3207111',
    name: 'Sukamulya',
  },
  {
    id: '3207111009',
    districtId: '3207111',
    name: 'Padaringan',
  },
  {
    id: '3207120001',
    districtId: '3207120',
    name: 'Sidamulih',
  },
  {
    id: '3207120002',
    districtId: '3207120',
    name: 'Margajaya',
  },
  {
    id: '3207120003',
    districtId: '3207120',
    name: 'Neglasari',
  },
  {
    id: '3207120004',
    districtId: '3207120',
    name: 'Pamarican',
  },
  {
    id: '3207120005',
    districtId: '3207120',
    name: 'Sukahurip',
  },
  {
    id: '3207120006',
    districtId: '3207120',
    name: 'Kertahayu',
  },
  {
    id: '3207120007',
    districtId: '3207120',
    name: 'Sukajadi',
  },
  {
    id: '3207120008',
    districtId: '3207120',
    name: 'Sukamukti',
  },
  {
    id: '3207120009',
    districtId: '3207120',
    name: 'Sidaharja',
  },
  {
    id: '3207120010',
    districtId: '3207120',
    name: 'Bangunsari',
  },
  {
    id: '3207120011',
    districtId: '3207120',
    name: 'Sukajaya',
  },
  {
    id: '3207120012',
    districtId: '3207120',
    name: 'Bantarsari',
  },
  {
    id: '3207120013',
    districtId: '3207120',
    name: 'Pasirnagara',
  },
  {
    id: '3207120014',
    districtId: '3207120',
    name: 'Mekarmulya',
  },
  {
    id: '3207130001',
    districtId: '3207130',
    name: 'Jelegong',
  },
  {
    id: '3207130002',
    districtId: '3207130',
    name: 'Ciparay',
  },
  {
    id: '3207130003',
    districtId: '3207130',
    name: 'Cidolog',
  },
  {
    id: '3207130004',
    districtId: '3207130',
    name: 'Janggala',
  },
  {
    id: '3207130005',
    districtId: '3207130',
    name: 'Hegarmanah',
  },
  {
    id: '3207130006',
    districtId: '3207130',
    name: 'Sukasari',
  },
  {
    id: '3207140001',
    districtId: '3207140',
    name: 'Bojongmalang',
  },
  {
    id: '3207140002',
    districtId: '3207140',
    name: 'Raksabaya',
  },
  {
    id: '3207140004',
    districtId: '3207140',
    name: 'Cimaragas',
  },
  {
    id: '3207140005',
    districtId: '3207140',
    name: 'Jayaraksa',
  },
  {
    id: '3207150001',
    districtId: '3207150',
    name: 'Handapherang',
  },
  {
    id: '3207150002',
    districtId: '3207150',
    name: 'Ciharalang',
  },
  {
    id: '3207150003',
    districtId: '3207150',
    name: 'Bojongmengger',
  },
  {
    id: '3207150004',
    districtId: '3207150',
    name: 'Karangkamulyan',
  },
  {
    id: '3207150005',
    districtId: '3207150',
    name: 'Kertabumi',
  },
  {
    id: '3207150006',
    districtId: '3207150',
    name: 'Cijeungjing',
  },
  {
    id: '3207150007',
    districtId: '3207150',
    name: 'Pamalayan',
  },
  {
    id: '3207150008',
    districtId: '3207150',
    name: 'Dewasari',
  },
  {
    id: '3207150009',
    districtId: '3207150',
    name: 'Utama',
  },
  {
    id: '3207150010',
    districtId: '3207150',
    name: 'Kertaharja',
  },
  {
    id: '3207150011',
    districtId: '3207150',
    name: 'Karanganyar',
  },
  {
    id: '3207160001',
    districtId: '3207160',
    name: 'Danasari',
  },
  {
    id: '3207160002',
    districtId: '3207160',
    name: 'Sidamulya',
  },
  {
    id: '3207160004',
    districtId: '3207160',
    name: 'Mekarmukti',
  },
  {
    id: '3207160005',
    districtId: '3207160',
    name: 'Cisaga',
  },
  {
    id: '3207160006',
    districtId: '3207160',
    name: 'Wangunjaya',
  },
  {
    id: '3207160007',
    districtId: '3207160',
    name: 'Tanjungjaya',
  },
  {
    id: '3207160008',
    districtId: '3207160',
    name: 'Sukahurip',
  },
  {
    id: '3207160009',
    districtId: '3207160',
    name: 'Bangunharja',
  },
  {
    id: '3207160010',
    districtId: '3207160',
    name: 'Girimukti',
  },
  {
    id: '3207160011',
    districtId: '3207160',
    name: 'Karyamulya',
  },
  {
    id: '3207170001',
    districtId: '3207170',
    name: 'Tambaksari',
  },
  {
    id: '3207170002',
    districtId: '3207170',
    name: 'Karangpaningal',
  },
  {
    id: '3207170003',
    districtId: '3207170',
    name: 'Kaso',
  },
  {
    id: '3207170004',
    districtId: '3207170',
    name: 'Mekarsari',
  },
  {
    id: '3207170005',
    districtId: '3207170',
    name: 'Sukasari',
  },
  {
    id: '3207170006',
    districtId: '3207170',
    name: 'Kadupandak',
  },
  {
    id: '3207180001',
    districtId: '3207180',
    name: 'Karangpari',
  },
  {
    id: '3207180002',
    districtId: '3207180',
    name: 'Bojonggedang',
  },
  {
    id: '3207180003',
    districtId: '3207180',
    name: 'Cisontrol',
  },
  {
    id: '3207180004',
    districtId: '3207180',
    name: 'Cileungsir',
  },
  {
    id: '3207180005',
    districtId: '3207180',
    name: 'Kiarapayung',
  },
  {
    id: '3207180006',
    districtId: '3207180',
    name: 'Kawunglarang',
  },
  {
    id: '3207180007',
    districtId: '3207180',
    name: 'Rancah',
  },
  {
    id: '3207180008',
    districtId: '3207180',
    name: 'Situmandala',
  },
  {
    id: '3207180009',
    districtId: '3207180',
    name: 'Patakaharja',
  },
  {
    id: '3207180010',
    districtId: '3207180',
    name: 'Dadiharja',
  },
  {
    id: '3207180011',
    districtId: '3207180',
    name: 'Jangalaharja',
  },
  {
    id: '3207180012',
    districtId: '3207180',
    name: 'Giriharja',
  },
  {
    id: '3207180013',
    districtId: '3207180',
    name: 'Wangunsari',
  },
  {
    id: '3207190001',
    districtId: '3207190',
    name: 'Tanjungsukur',
  },
  {
    id: '3207190002',
    districtId: '3207190',
    name: 'Tanjungsari',
  },
  {
    id: '3207190003',
    districtId: '3207190',
    name: 'Tanjungjaya',
  },
  {
    id: '3207190004',
    districtId: '3207190',
    name: 'Rajadesa',
  },
  {
    id: '3207190005',
    districtId: '3207190',
    name: 'Sirnabaya',
  },
  {
    id: '3207190006',
    districtId: '3207190',
    name: 'Sirnajaya',
  },
  {
    id: '3207190007',
    districtId: '3207190',
    name: 'Purwaraja',
  },
  {
    id: '3207190008',
    districtId: '3207190',
    name: 'Andapraja',
  },
  {
    id: '3207190009',
    districtId: '3207190',
    name: 'Sukaharja',
  },
  {
    id: '3207190010',
    districtId: '3207190',
    name: 'Tigaherang',
  },
  {
    id: '3207190011',
    districtId: '3207190',
    name: 'Sukajaya',
  },
  {
    id: '3207200001',
    districtId: '3207200',
    name: 'Ciparigi',
  },
  {
    id: '3207200003',
    districtId: '3207200',
    name: 'Margaharja',
  },
  {
    id: '3207200004',
    districtId: '3207200',
    name: 'Margajaya',
  },
  {
    id: '3207200005',
    districtId: '3207200',
    name: 'Sukadana',
  },
  {
    id: '3207200006',
    districtId: '3207200',
    name: 'Salakaria',
  },
  {
    id: '3207210001',
    districtId: '3207210',
    name: 'Imbanagara Raya',
  },
  {
    id: '3207210002',
    districtId: '3207210',
    name: 'Cisadap',
  },
  {
    id: '3207210003',
    districtId: '3207210',
    name: 'Imbanagara',
  },
  {
    id: '3207210004',
    districtId: '3207210',
    name: 'Sindangrasa',
  },
  {
    id: '3207210005',
    districtId: '3207210',
    name: 'Panyingkiran',
  },
  {
    id: '3207210006',
    districtId: '3207210',
    name: 'Pawindan',
  },
  {
    id: '3207210007',
    districtId: '3207210',
    name: 'Linggasari',
  },
  {
    id: '3207210008',
    districtId: '3207210',
    name: 'Ciamis',
  },
  {
    id: '3207210010',
    districtId: '3207210',
    name: 'Cigembor',
  },
  {
    id: '3207210011',
    districtId: '3207210',
    name: 'Kertasari',
  },
  {
    id: '3207210012',
    districtId: '3207210',
    name: 'Maleber',
  },
  {
    id: '3207211001',
    districtId: '3207211',
    name: 'Sukamaju',
  },
  {
    id: '3207211002',
    districtId: '3207211',
    name: 'Mekarjaya',
  },
  {
    id: '3207211003',
    districtId: '3207211',
    name: 'Saguling',
  },
  {
    id: '3207211004',
    districtId: '3207211',
    name: 'Baregbeg',
  },
  {
    id: '3207211005',
    districtId: '3207211',
    name: 'Petirhilir',
  },
  {
    id: '3207211006',
    districtId: '3207211',
    name: 'Pusakanagara',
  },
  {
    id: '3207211007',
    districtId: '3207211',
    name: 'Karangampel',
  },
  {
    id: '3207211008',
    districtId: '3207211',
    name: 'Jelat',
  },
  {
    id: '3207211009',
    districtId: '3207211',
    name: 'Sukamulya',
  },
  {
    id: '3207220001',
    districtId: '3207220',
    name: 'Panaragan',
  },
  {
    id: '3207220002',
    districtId: '3207220',
    name: 'Margaluyu',
  },
  {
    id: '3207220003',
    districtId: '3207220',
    name: 'Cikoneng',
  },
  {
    id: '3207220004',
    districtId: '3207220',
    name: 'Kujang',
  },
  {
    id: '3207220005',
    districtId: '3207220',
    name: 'Darmacaang',
  },
  {
    id: '3207220006',
    districtId: '3207220',
    name: 'Nasol',
  },
  {
    id: '3207220007',
    districtId: '3207220',
    name: 'Sindangsari',
  },
  {
    id: '3207220008',
    districtId: '3207220',
    name: 'Cimari',
  },
  {
    id: '3207220009',
    districtId: '3207220',
    name: 'Gegempalan',
  },
  {
    id: '3207221001',
    districtId: '3207221',
    name: 'Sukamanah',
  },
  {
    id: '3207221002',
    districtId: '3207221',
    name: 'Sukaraja',
  },
  {
    id: '3207221003',
    districtId: '3207221',
    name: 'Budiharja',
  },
  {
    id: '3207221004',
    districtId: '3207221',
    name: 'Budiasih',
  },
  {
    id: '3207221006',
    districtId: '3207221',
    name: 'Sindangkasih',
  },
  {
    id: '3207221007',
    districtId: '3207221',
    name: 'Sukasenang',
  },
  {
    id: '3207221008',
    districtId: '3207221',
    name: 'Sukaresik',
  },
  {
    id: '3207221009',
    districtId: '3207221',
    name: 'Wanasigra',
  },
  {
    id: '3207230001',
    districtId: '3207230',
    name: 'Sukamulya',
  },
  {
    id: '3207230002',
    districtId: '3207230',
    name: 'Sukahaji',
  },
  {
    id: '3207230003',
    districtId: '3207230',
    name: 'Sukahurip',
  },
  {
    id: '3207230004',
    districtId: '3207230',
    name: 'Sukamaju',
  },
  {
    id: '3207230005',
    districtId: '3207230',
    name: 'Cijulang',
  },
  {
    id: '3207230006',
    districtId: '3207230',
    name: 'Sukasetia',
  },
  {
    id: '3207230007',
    districtId: '3207230',
    name: 'Sumberjaya',
  },
  {
    id: '3207230008',
    districtId: '3207230',
    name: 'Cihaurbeuti',
  },
  {
    id: '3207230009',
    districtId: '3207230',
    name: 'Pasirtamiang',
  },
  {
    id: '3207230010',
    districtId: '3207230',
    name: 'Padamulya',
  },
  {
    id: '3207230011',
    districtId: '3207230',
    name: 'Pamokolan',
  },
  {
    id: '3207240001',
    districtId: '3207240',
    name: 'Mekarjadi',
  },
  {
    id: '3207240002',
    districtId: '3207240',
    name: 'Sukajadi',
  },
  {
    id: '3207240003',
    districtId: '3207240',
    name: 'Werasari',
  },
  {
    id: '3207240004',
    districtId: '3207240',
    name: 'Mangkubumi',
  },
  {
    id: '3207240005',
    districtId: '3207240',
    name: 'Bendasari',
  },
  {
    id: '3207240006',
    districtId: '3207240',
    name: 'Sadananya',
  },
  {
    id: '3207240007',
    districtId: '3207240',
    name: 'Tanjungsari',
  },
  {
    id: '3207240008',
    districtId: '3207240',
    name: 'Gunungsari',
  },
  {
    id: '3207250001',
    districtId: '3207250',
    name: 'Muktisari',
  },
  {
    id: '3207250002',
    districtId: '3207250',
    name: 'Mekarsari',
  },
  {
    id: '3207250003',
    districtId: '3207250',
    name: 'Buniseuri',
  },
  {
    id: '3207250004',
    districtId: '3207250',
    name: 'Pusakasari',
  },
  {
    id: '3207250005',
    districtId: '3207250',
    name: 'Jalatrang',
  },
  {
    id: '3207250006',
    districtId: '3207250',
    name: 'Sukawening',
  },
  {
    id: '3207250007',
    districtId: '3207250',
    name: 'Cipaku',
  },
  {
    id: '3207250008',
    districtId: '3207250',
    name: 'Bangbayang',
  },
  {
    id: '3207250009',
    districtId: '3207250',
    name: 'Cieurih',
  },
  {
    id: '3207250010',
    districtId: '3207250',
    name: 'Selamanik',
  },
  {
    id: '3207250011',
    districtId: '3207250',
    name: 'Selacai',
  },
  {
    id: '3207250012',
    districtId: '3207250',
    name: 'Gereba',
  },
  {
    id: '3207250013',
    districtId: '3207250',
    name: 'Ciakar',
  },
  {
    id: '3207260001',
    districtId: '3207260',
    name: 'Cintanagara',
  },
  {
    id: '3207260002',
    districtId: '3207260',
    name: 'Bayasari',
  },
  {
    id: '3207260003',
    districtId: '3207260',
    name: 'Jatinagara',
  },
  {
    id: '3207260004',
    districtId: '3207260',
    name: 'Dayeuhluhur',
  },
  {
    id: '3207260005',
    districtId: '3207260',
    name: 'Sukanagara',
  },
  {
    id: '3207260006',
    districtId: '3207260',
    name: 'Mulyasari',
  },
  {
    id: '3207270001',
    districtId: '3207270',
    name: 'Kertayasa',
  },
  {
    id: '3207270002',
    districtId: '3207270',
    name: 'Karangpaningal',
  },
  {
    id: '3207270003',
    districtId: '3207270',
    name: 'Indragiri',
  },
  {
    id: '3207270004',
    districtId: '3207270',
    name: 'Panawangan',
  },
  {
    id: '3207270005',
    districtId: '3207270',
    name: 'Sagalaherang',
  },
  {
    id: '3207270006',
    districtId: '3207270',
    name: 'Nagarapageuh',
  },
  {
    id: '3207270007',
    districtId: '3207270',
    name: 'Nagarajaya',
  },
  {
    id: '3207270008',
    districtId: '3207270',
    name: 'Nagarajati',
  },
  {
    id: '3207270009',
    districtId: '3207270',
    name: 'Jagabaya',
  },
  {
    id: '3207270010',
    districtId: '3207270',
    name: 'Cinyasag',
  },
  {
    id: '3207270011',
    districtId: '3207270',
    name: 'Gardujaya',
  },
  {
    id: '3207270012',
    districtId: '3207270',
    name: 'Sadapaingan',
  },
  {
    id: '3207270013',
    districtId: '3207270',
    name: 'Bangunjaya',
  },
  {
    id: '3207270014',
    districtId: '3207270',
    name: 'Girilaya',
  },
  {
    id: '3207270015',
    districtId: '3207270',
    name: 'Kertajaya',
  },
  {
    id: '3207270016',
    districtId: '3207270',
    name: 'Nagarawangi',
  },
  {
    id: '3207270017',
    districtId: '3207270',
    name: 'Natanegara',
  },
  {
    id: '3207270018',
    districtId: '3207270',
    name: 'Mekarbuana',
  },
  {
    id: '3207280001',
    districtId: '3207280',
    name: 'Sindangsari',
  },
  {
    id: '3207280002',
    districtId: '3207280',
    name: 'Kawali',
  },
  {
    id: '3207280003',
    districtId: '3207280',
    name: 'Karangpawitan',
  },
  {
    id: '3207280004',
    districtId: '3207280',
    name: 'Kawalimukti',
  },
  {
    id: '3207280005',
    districtId: '3207280',
    name: 'Talagasari',
  },
  {
    id: '3207280006',
    districtId: '3207280',
    name: 'Selasari',
  },
  {
    id: '3207280007',
    districtId: '3207280',
    name: 'Margamulya',
  },
  {
    id: '3207280008',
    districtId: '3207280',
    name: 'Winduraja',
  },
  {
    id: '3207280009',
    districtId: '3207280',
    name: 'Purwasari',
  },
  {
    id: '3207280010',
    districtId: '3207280',
    name: 'Citeureup',
  },
  {
    id: '3207280011',
    districtId: '3207280',
    name: 'Linggapura',
  },
  {
    id: '3207281001',
    districtId: '3207281',
    name: 'Cikupa',
  },
  {
    id: '3207281002',
    districtId: '3207281',
    name: 'Sukaraharja',
  },
  {
    id: '3207281003',
    districtId: '3207281',
    name: 'Awiluar',
  },
  {
    id: '3207281005',
    districtId: '3207281',
    name: 'Darmaraja',
  },
  {
    id: '3207281006',
    districtId: '3207281',
    name: 'Lumbungsari',
  },
  {
    id: '3207281007',
    districtId: '3207281',
    name: 'Rawa',
  },
  {
    id: '3207281008',
    districtId: '3207281',
    name: 'Sadewata',
  },
  {
    id: '3207290001',
    districtId: '3207290',
    name: 'Mandalare',
  },
  {
    id: '3207290002',
    districtId: '3207290',
    name: 'Kertamandala',
  },
  {
    id: '3207290003',
    districtId: '3207290',
    name: 'Ciomas',
  },
  {
    id: '3207290004',
    districtId: '3207290',
    name: 'Sandingtaman',
  },
  {
    id: '3207290005',
    districtId: '3207290',
    name: 'Maparah',
  },
  {
    id: '3207290006',
    districtId: '3207290',
    name: 'Panjalu',
  },
  {
    id: '3207290007',
    districtId: '3207290',
    name: 'Bahara',
  },
  {
    id: '3207290008',
    districtId: '3207290',
    name: 'Hujungtiwu',
  },
  {
    id: '3207291001',
    districtId: '3207291',
    name: 'Tenggerraharja',
  },
  {
    id: '3207291002',
    districtId: '3207291',
    name: 'Sukamantri',
  },
  {
    id: '3207291003',
    districtId: '3207291',
    name: 'Cibeureum',
  },
  {
    id: '3207291004',
    districtId: '3207291',
    name: 'Sindanglaya',
  },
  {
    id: '3207291005',
    districtId: '3207291',
    name: 'Mekarwangi',
  },
  {
    id: '3207300001',
    districtId: '3207300',
    name: 'Medanglayang',
  },
  {
    id: '3207300002',
    districtId: '3207300',
    name: 'Panumbangan',
  },
  {
    id: '3207300003',
    districtId: '3207300',
    name: 'Tanjungmulya',
  },
  {
    id: '3207300004',
    districtId: '3207300',
    name: 'Kertaraharja',
  },
  {
    id: '3207300005',
    districtId: '3207300',
    name: 'Sukakerta',
  },
  {
    id: '3207300006',
    districtId: '3207300',
    name: 'Golat',
  },
  {
    id: '3207300007',
    districtId: '3207300',
    name: 'Sindangherang',
  },
  {
    id: '3207300008',
    districtId: '3207300',
    name: 'Sindangmukti',
  },
  {
    id: '3207300009',
    districtId: '3207300',
    name: 'Jayagiri',
  },
  {
    id: '3207300010',
    districtId: '3207300',
    name: 'Banjarangsana',
  },
  {
    id: '3207300011',
    districtId: '3207300',
    name: 'Payungsari',
  },
  {
    id: '3207300012',
    districtId: '3207300',
    name: 'Payungagung',
  },
  {
    id: '3207300013',
    districtId: '3207300',
    name: 'Sindangbarang',
  },
  {
    id: '3207300014',
    districtId: '3207300',
    name: 'Buanamekar',
  },
  {
    id: '3208010001',
    districtId: '3208010',
    name: 'Cimenga',
  },
  {
    id: '3208010002',
    districtId: '3208010',
    name: 'Tugumulya',
  },
  {
    id: '3208010003',
    districtId: '3208010',
    name: 'Cageur',
  },
  {
    id: '3208010004',
    districtId: '3208010',
    name: 'Sakerta Timur',
  },
  {
    id: '3208010005',
    districtId: '3208010',
    name: 'Sakerta Barat',
  },
  {
    id: '3208010006',
    districtId: '3208010',
    name: 'Sukarasa',
  },
  {
    id: '3208010007',
    districtId: '3208010',
    name: 'Paninggaran',
  },
  {
    id: '3208010008',
    districtId: '3208010',
    name: 'Cipasung',
  },
  {
    id: '3208010009',
    districtId: '3208010',
    name: 'Kawahmanuk',
  },
  {
    id: '3208010010',
    districtId: '3208010',
    name: 'Cikupa',
  },
  {
    id: '3208010011',
    districtId: '3208010',
    name: 'Parung',
  },
  {
    id: '3208010012',
    districtId: '3208010',
    name: 'Darma',
  },
  {
    id: '3208010013',
    districtId: '3208010',
    name: 'Jagara',
  },
  {
    id: '3208010014',
    districtId: '3208010',
    name: 'Bakom',
  },
  {
    id: '3208010015',
    districtId: '3208010',
    name: 'Karanganyar',
  },
  {
    id: '3208010016',
    districtId: '3208010',
    name: 'Gunungsirah',
  },
  {
    id: '3208010017',
    districtId: '3208010',
    name: 'Situsari',
  },
  {
    id: '3208010018',
    districtId: '3208010',
    name: 'Karangsari',
  },
  {
    id: '3208010019',
    districtId: '3208010',
    name: 'Sagarahiang',
  },
  {
    id: '3208020003',
    districtId: '3208020',
    name: 'Margabakti',
  },
  {
    id: '3208020004',
    districtId: '3208020',
    name: 'Sindangjawa',
  },
  {
    id: '3208020009',
    districtId: '3208020',
    name: 'Kadugede',
  },
  {
    id: '3208020010',
    districtId: '3208020',
    name: 'Ciketak',
  },
  {
    id: '3208020011',
    districtId: '3208020',
    name: 'Nangka',
  },
  {
    id: '3208020012',
    districtId: '3208020',
    name: 'Windujanten',
  },
  {
    id: '3208020013',
    districtId: '3208020',
    name: 'Cipondok',
  },
  {
    id: '3208020014',
    districtId: '3208020',
    name: 'Babatan',
  },
  {
    id: '3208020015',
    districtId: '3208020',
    name: 'Bayuning',
  },
  {
    id: '3208020017',
    districtId: '3208020',
    name: 'Ciherang',
  },
  {
    id: '3208020018',
    districtId: '3208020',
    name: 'Tinggar',
  },
  {
    id: '3208020019',
    districtId: '3208020',
    name: 'Cisukadana',
  },
  {
    id: '3208021001',
    districtId: '3208021',
    name: 'Haurkuning',
  },
  {
    id: '3208021002',
    districtId: '3208021',
    name: 'Kertayuga',
  },
  {
    id: '3208021003',
    districtId: '3208021',
    name: 'Windusari',
  },
  {
    id: '3208021004',
    districtId: '3208021',
    name: 'Nusaherang',
  },
  {
    id: '3208021005',
    districtId: '3208021',
    name: 'Kertawirama',
  },
  {
    id: '3208021006',
    districtId: '3208021',
    name: 'Cikadu',
  },
  {
    id: '3208021007',
    districtId: '3208021',
    name: 'Jambar',
  },
  {
    id: '3208021008',
    districtId: '3208021',
    name: 'Ciasih',
  },
  {
    id: '3208030009',
    districtId: '3208030',
    name: 'Gunungmanik',
  },
  {
    id: '3208030010',
    districtId: '3208030',
    name: 'Pinara',
  },
  {
    id: '3208030011',
    districtId: '3208030',
    name: 'Cipedes',
  },
  {
    id: '3208030012',
    districtId: '3208030',
    name: 'Pamupukan',
  },
  {
    id: '3208030013',
    districtId: '3208030',
    name: 'Cijemit',
  },
  {
    id: '3208030014',
    districtId: '3208030',
    name: 'Ciniru',
  },
  {
    id: '3208030015',
    districtId: '3208030',
    name: 'Rambatan',
  },
  {
    id: '3208030016',
    districtId: '3208030',
    name: 'Longkewang',
  },
  {
    id: '3208030017',
    districtId: '3208030',
    name: 'Mungkaldatar',
  },
  {
    id: '3208031001',
    districtId: '3208031',
    name: 'Tundagan',
  },
  {
    id: '3208031002',
    districtId: '3208031',
    name: 'Bunigeulis',
  },
  {
    id: '3208031003',
    districtId: '3208031',
    name: 'Hantara',
  },
  {
    id: '3208031004',
    districtId: '3208031',
    name: 'Cikondang',
  },
  {
    id: '3208031005',
    districtId: '3208031',
    name: 'Pasiragung',
  },
  {
    id: '3208031006',
    districtId: '3208031',
    name: 'Citapen',
  },
  {
    id: '3208031007',
    districtId: '3208031',
    name: 'Pakapasan Hilir',
  },
  {
    id: '3208031008',
    districtId: '3208031',
    name: 'Pakapasan Girang',
  },
  {
    id: '3208040001',
    districtId: '3208040',
    name: 'Cantilan',
  },
  {
    id: '3208040002',
    districtId: '3208040',
    name: 'Selajambe',
  },
  {
    id: '3208040003',
    districtId: '3208040',
    name: 'Ciberung',
  },
  {
    id: '3208040004',
    districtId: '3208040',
    name: 'Kutawaringin',
  },
  {
    id: '3208040005',
    districtId: '3208040',
    name: 'Bagawat',
  },
  {
    id: '3208040006',
    districtId: '3208040',
    name: 'Jamberama',
  },
  {
    id: '3208040007',
    districtId: '3208040',
    name: 'Padahurip',
  },
  {
    id: '3208050001',
    districtId: '3208050',
    name: 'Tangkolo',
  },
  {
    id: '3208050002',
    districtId: '3208050',
    name: 'Pamulihan',
  },
  {
    id: '3208050004',
    districtId: '3208050',
    name: 'Jatisari',
  },
  {
    id: '3208050009',
    districtId: '3208050',
    name: 'Subang',
  },
  {
    id: '3208050010',
    districtId: '3208050',
    name: 'Bangunjaya',
  },
  {
    id: '3208050011',
    districtId: '3208050',
    name: 'Gunungaci',
  },
  {
    id: '3208050012',
    districtId: '3208050',
    name: 'Situgede',
  },
  {
    id: '3208051001',
    districtId: '3208051',
    name: 'Mandapajaya',
  },
  {
    id: '3208051002',
    districtId: '3208051',
    name: 'Legokherang',
  },
  {
    id: '3208051004',
    districtId: '3208051',
    name: 'Cilebak',
  },
  {
    id: '3208051005',
    districtId: '3208051',
    name: 'Jalatrang',
  },
  {
    id: '3208051006',
    districtId: '3208051',
    name: 'Patala',
  },
  {
    id: '3208051007',
    districtId: '3208051',
    name: 'Cilimusari',
  },
  {
    id: '3208060001',
    districtId: '3208060',
    name: 'Citundun',
  },
  {
    id: '3208060006',
    districtId: '3208060',
    name: 'Sagaranten',
  },
  {
    id: '3208060007',
    districtId: '3208060',
    name: 'Sumberjaya',
  },
  {
    id: '3208060008',
    districtId: '3208060',
    name: 'Lebakherang',
  },
  {
    id: '3208060009',
    districtId: '3208060',
    name: 'Cilayung',
  },
  {
    id: '3208060010',
    districtId: '3208060',
    name: 'Ciwaru',
  },
  {
    id: '3208060011',
    districtId: '3208060',
    name: 'Lingga Jaya',
  },
  {
    id: '3208060013',
    districtId: '3208060',
    name: 'Karangbaru',
  },
  {
    id: '3208060014',
    districtId: '3208060',
    name: 'Garajati',
  },
  {
    id: '3208060016',
    districtId: '3208060',
    name: 'Baok',
  },
  {
    id: '3208060017',
    districtId: '3208060',
    name: 'Andamui',
  },
  {
    id: '3208060018',
    districtId: '3208060',
    name: 'Citikur',
  },
  {
    id: '3208061001',
    districtId: '3208061',
    name: 'Margacina',
  },
  {
    id: '3208061002',
    districtId: '3208061',
    name: 'Jabranti',
  },
  {
    id: '3208061003',
    districtId: '3208061',
    name: 'Karangkancana',
  },
  {
    id: '3208061004',
    districtId: '3208061',
    name: 'Kaduagung',
  },
  {
    id: '3208061005',
    districtId: '3208061',
    name: 'Segong',
  },
  {
    id: '3208061006',
    districtId: '3208061',
    name: 'Tanjungkerta',
  },
  {
    id: '3208061007',
    districtId: '3208061',
    name: 'Sukasari',
  },
  {
    id: '3208061008',
    districtId: '3208061',
    name: 'Simpay Jaya',
  },
  {
    id: '3208061009',
    districtId: '3208061',
    name: 'Cihanjaro',
  },
  {
    id: '3208070002',
    districtId: '3208070',
    name: 'Ciangir',
  },
  {
    id: '3208070003',
    districtId: '3208070',
    name: 'Cipondok',
  },
  {
    id: '3208070004',
    districtId: '3208070',
    name: 'Sukaharja',
  },
  {
    id: '3208070005',
    districtId: '3208070',
    name: 'Sindangjawa',
  },
  {
    id: '3208070011',
    districtId: '3208070',
    name: 'Sukamaju',
  },
  {
    id: '3208070012',
    districtId: '3208070',
    name: 'Cibingbin',
  },
  {
    id: '3208070013',
    districtId: '3208070',
    name: 'Citenjo',
  },
  {
    id: '3208070014',
    districtId: '3208070',
    name: 'Dukuhbadag',
  },
  {
    id: '3208070017',
    districtId: '3208070',
    name: 'Cisaat',
  },
  {
    id: '3208070018',
    districtId: '3208070',
    name: 'Bantarpanjang',
  },
  {
    id: '3208071001',
    districtId: '3208071',
    name: 'Cimara',
  },
  {
    id: '3208071002',
    districtId: '3208071',
    name: 'Kawungsari',
  },
  {
    id: '3208071003',
    districtId: '3208071',
    name: 'Sukarapih',
  },
  {
    id: '3208071004',
    districtId: '3208071',
    name: 'Sumurwiru',
  },
  {
    id: '3208071005',
    districtId: '3208071',
    name: 'Cibeureum',
  },
  {
    id: '3208071006',
    districtId: '3208071',
    name: 'Randusari',
  },
  {
    id: '3208071007',
    districtId: '3208071',
    name: 'Sukadana',
  },
  {
    id: '3208071008',
    districtId: '3208071',
    name: 'Tarikolot',
  },
  {
    id: '3208080001',
    districtId: '3208080',
    name: 'Walaharcageur',
  },
  {
    id: '3208080002',
    districtId: '3208080',
    name: 'Dukuhpicung',
  },
  {
    id: '3208080003',
    districtId: '3208080',
    name: 'Wilanagara',
  },
  {
    id: '3208080004',
    districtId: '3208080',
    name: 'Sindangsari',
  },
  {
    id: '3208080005',
    districtId: '3208080',
    name: 'Cigedang',
  },
  {
    id: '3208080006',
    districtId: '3208080',
    name: 'Luragungtonggoh',
  },
  {
    id: '3208080007',
    districtId: '3208080',
    name: 'Margasari',
  },
  {
    id: '3208080008',
    districtId: '3208080',
    name: 'Cirahayu',
  },
  {
    id: '3208080009',
    districtId: '3208080',
    name: 'Sindangsuka',
  },
  {
    id: '3208080010',
    districtId: '3208080',
    name: 'Cikandang',
  },
  {
    id: '3208080011',
    districtId: '3208080',
    name: 'Panyosogan',
  },
  {
    id: '3208080012',
    districtId: '3208080',
    name: 'Gunungkarung',
  },
  {
    id: '3208080013',
    districtId: '3208080',
    name: 'Dukuhmaja',
  },
  {
    id: '3208080014',
    districtId: '3208080',
    name: 'Luragunglandeuh',
  },
  {
    id: '3208080015',
    districtId: '3208080',
    name: 'Cikaduwetan',
  },
  {
    id: '3208080016',
    districtId: '3208080',
    name: 'Benda',
  },
  {
    id: '3208081001',
    districtId: '3208081',
    name: 'Cileuya',
  },
  {
    id: '3208081004',
    districtId: '3208081',
    name: 'Margamukti',
  },
  {
    id: '3208081005',
    districtId: '3208081',
    name: 'Cimulya',
  },
  {
    id: '3208081006',
    districtId: '3208081',
    name: 'Gunungsari',
  },
  {
    id: '3208081007',
    districtId: '3208081',
    name: 'Cimahi',
  },
  {
    id: '3208081008',
    districtId: '3208081',
    name: 'Kananga',
  },
  {
    id: '3208081009',
    districtId: '3208081',
    name: 'Cikeusal',
  },
  {
    id: '3208081010',
    districtId: '3208081',
    name: 'Mulyajaya',
  },
  {
    id: '3208081011',
    districtId: '3208081',
    name: 'Sukajaya',
  },
  {
    id: '3208081012',
    districtId: '3208081',
    name: 'Mekarjaya',
  },
  {
    id: '3208090001',
    districtId: '3208090',
    name: 'Cihideunggirang',
  },
  {
    id: '3208090002',
    districtId: '3208090',
    name: 'Cihideunghilir',
  },
  {
    id: '3208090003',
    districtId: '3208090',
    name: 'Cidahu',
  },
  {
    id: '3208090004',
    districtId: '3208090',
    name: 'Kertawinangun',
  },
  {
    id: '3208090005',
    districtId: '3208090',
    name: 'Datar',
  },
  {
    id: '3208090007',
    districtId: '3208090',
    name: 'Legok',
  },
  {
    id: '3208090008',
    districtId: '3208090',
    name: 'Cieurih',
  },
  {
    id: '3208090009',
    districtId: '3208090',
    name: 'Nanggela',
  },
  {
    id: '3208090016',
    districtId: '3208090',
    name: 'Cibulan',
  },
  {
    id: '3208090017',
    districtId: '3208090',
    name: 'Cikeusik',
  },
  {
    id: '3208090018',
    districtId: '3208090',
    name: 'Jatimulya',
  },
  {
    id: '3208091001',
    districtId: '3208091',
    name: 'Kalimanggis Kulon',
  },
  {
    id: '3208091002',
    districtId: '3208091',
    name: 'Kalimanggis Wetan',
  },
  {
    id: '3208091003',
    districtId: '3208091',
    name: 'Cipancur',
  },
  {
    id: '3208091004',
    districtId: '3208091',
    name: 'Partawangunan',
  },
  {
    id: '3208091005',
    districtId: '3208091',
    name: 'Kertawana',
  },
  {
    id: '3208091006',
    districtId: '3208091',
    name: 'Wanasaraya',
  },
  {
    id: '3208100002',
    districtId: '3208100',
    name: 'Cijagamulya',
  },
  {
    id: '3208100003',
    districtId: '3208100',
    name: 'Ciomas',
  },
  {
    id: '3208100004',
    districtId: '3208100',
    name: 'Sidaraja',
  },
  {
    id: '3208100005',
    districtId: '3208100',
    name: 'Pajawanlor',
  },
  {
    id: '3208100006',
    districtId: '3208100',
    name: 'Lebaksiuh',
  },
  {
    id: '3208100007',
    districtId: '3208100',
    name: 'Keramatmulya',
  },
  {
    id: '3208100008',
    districtId: '3208100',
    name: 'Geresik',
  },
  {
    id: '3208100009',
    districtId: '3208100',
    name: 'Ciputat',
  },
  {
    id: '3208100010',
    districtId: '3208100',
    name: 'Kapandayan',
  },
  {
    id: '3208100011',
    districtId: '3208100',
    name: 'Dukuhdalem',
  },
  {
    id: '3208100014',
    districtId: '3208100',
    name: 'Pangkalan',
  },
  {
    id: '3208100015',
    districtId: '3208100',
    name: 'Ciawigebang',
  },
  {
    id: '3208100016',
    districtId: '3208100',
    name: 'Kadurama',
  },
  {
    id: '3208100017',
    districtId: '3208100',
    name: 'Pamijahan',
  },
  {
    id: '3208100018',
    districtId: '3208100',
    name: 'Karangkamulyan',
  },
  {
    id: '3208100019',
    districtId: '3208100',
    name: 'Ciawilor',
  },
  {
    id: '3208100026',
    districtId: '3208100',
    name: 'Cihaur',
  },
  {
    id: '3208100027',
    districtId: '3208100',
    name: 'Cigarukgak',
  },
  {
    id: '3208100028',
    districtId: '3208100',
    name: 'Mekarjaya',
  },
  {
    id: '3208100029',
    districtId: '3208100',
    name: 'Sukaraja',
  },
  {
    id: '3208100031',
    districtId: '3208100',
    name: 'Padarama',
  },
  {
    id: '3208100032',
    districtId: '3208100',
    name: 'Sukadana',
  },
  {
    id: '3208100033',
    districtId: '3208100',
    name: 'Cikubangmulya',
  },
  {
    id: '3208100034',
    districtId: '3208100',
    name: 'Cihirup',
  },
  {
    id: '3208101001',
    districtId: '3208101',
    name: 'Muncangela',
  },
  {
    id: '3208101002',
    districtId: '3208101',
    name: 'Karoya',
  },
  {
    id: '3208101003',
    districtId: '3208101',
    name: 'Susukan',
  },
  {
    id: '3208101004',
    districtId: '3208101',
    name: 'Sukamukti',
  },
  {
    id: '3208101005',
    districtId: '3208101',
    name: 'Cipicung',
  },
  {
    id: '3208101006',
    districtId: '3208101',
    name: 'Mekarsari',
  },
  {
    id: '3208101007',
    districtId: '3208101',
    name: 'Cimaranten',
  },
  {
    id: '3208101008',
    districtId: '3208101',
    name: 'Pamulihan',
  },
  {
    id: '3208101009',
    districtId: '3208101',
    name: 'Salareuma',
  },
  {
    id: '3208101010',
    districtId: '3208101',
    name: 'Suganangan',
  },
  {
    id: '3208110014',
    districtId: '3208110',
    name: 'Cinagara',
  },
  {
    id: '3208110015',
    districtId: '3208110',
    name: 'Cineumbeuy',
  },
  {
    id: '3208110016',
    districtId: '3208110',
    name: 'Cipetir',
  },
  {
    id: '3208110017',
    districtId: '3208110',
    name: 'Lebakwangi',
  },
  {
    id: '3208110018',
    districtId: '3208110',
    name: 'Mancagar',
  },
  {
    id: '3208110019',
    districtId: '3208110',
    name: 'Langseb',
  },
  {
    id: '3208110023',
    districtId: '3208110',
    name: 'Pajawankidul',
  },
  {
    id: '3208110024',
    districtId: '3208110',
    name: 'Pagundan',
  },
  {
    id: '3208110025',
    districtId: '3208110',
    name: 'Manggari',
  },
  {
    id: '3208110026',
    districtId: '3208110',
    name: 'Pasayangan',
  },
  {
    id: '3208110027',
    districtId: '3208110',
    name: 'Sindang',
  },
  {
    id: '3208110028',
    districtId: '3208110',
    name: 'Bendungan',
  },
  {
    id: '3208110029',
    districtId: '3208110',
    name: 'Mekarwangi',
  },
  {
    id: '3208111001',
    districtId: '3208111',
    name: 'Cipakem',
  },
  {
    id: '3208111002',
    districtId: '3208111',
    name: 'Giriwaringin',
  },
  {
    id: '3208111003',
    districtId: '3208111',
    name: 'Garahaji',
  },
  {
    id: '3208111004',
    districtId: '3208111',
    name: 'Galaherang',
  },
  {
    id: '3208111005',
    districtId: '3208111',
    name: 'Mekarsari',
  },
  {
    id: '3208111006',
    districtId: '3208111',
    name: 'Padamulya',
  },
  {
    id: '3208111007',
    districtId: '3208111',
    name: 'Cikahuripan',
  },
  {
    id: '3208111008',
    districtId: '3208111',
    name: 'Parakan',
  },
  {
    id: '3208111009',
    districtId: '3208111',
    name: 'Kutamandarakan',
  },
  {
    id: '3208111010',
    districtId: '3208111',
    name: 'Maleber',
  },
  {
    id: '3208111011',
    districtId: '3208111',
    name: 'Karangtengah',
  },
  {
    id: '3208111012',
    districtId: '3208111',
    name: 'Dukuhtengah',
  },
  {
    id: '3208111013',
    districtId: '3208111',
    name: 'Buniasih',
  },
  {
    id: '3208111014',
    districtId: '3208111',
    name: 'Ciporang',
  },
  {
    id: '3208111015',
    districtId: '3208111',
    name: 'Kutaraja',
  },
  {
    id: '3208111016',
    districtId: '3208111',
    name: 'Mandalajaya',
  },
  {
    id: '3208120001',
    districtId: '3208120',
    name: 'Cirukem',
  },
  {
    id: '3208120002',
    districtId: '3208120',
    name: 'Gewok',
  },
  {
    id: '3208120003',
    districtId: '3208120',
    name: 'Kutakembaran',
  },
  {
    id: '3208120004',
    districtId: '3208120',
    name: 'Pakembangan',
  },
  {
    id: '3208120005',
    districtId: '3208120',
    name: 'Kadatuan',
  },
  {
    id: '3208120006',
    districtId: '3208120',
    name: 'Tembong',
  },
  {
    id: '3208120007',
    districtId: '3208120',
    name: 'Lengkong',
  },
  {
    id: '3208120008',
    districtId: '3208120',
    name: 'Purwasari',
  },
  {
    id: '3208120009',
    districtId: '3208120',
    name: 'Garawangi',
  },
  {
    id: '3208120010',
    districtId: '3208120',
    name: 'Karamatwangi',
  },
  {
    id: '3208120011',
    districtId: '3208120',
    name: 'Sukaimut',
  },
  {
    id: '3208120012',
    districtId: '3208120',
    name: 'Cikananga',
  },
  {
    id: '3208120013',
    districtId: '3208120',
    name: 'Tambakbaya',
  },
  {
    id: '3208120014',
    districtId: '3208120',
    name: 'Mekarmulya',
  },
  {
    id: '3208120015',
    districtId: '3208120',
    name: 'Sukamulya',
  },
  {
    id: '3208120016',
    districtId: '3208120',
    name: 'Mancagar',
  },
  {
    id: '3208120017',
    districtId: '3208120',
    name: 'Citiusari',
  },
  {
    id: '3208121001',
    districtId: '3208121',
    name: 'Kertaungaran',
  },
  {
    id: '3208121002',
    districtId: '3208121',
    name: 'Kaduagung',
  },
  {
    id: '3208121003',
    districtId: '3208121',
    name: 'Sindangsari',
  },
  {
    id: '3208121004',
    districtId: '3208121',
    name: 'Kertawangunan',
  },
  {
    id: '3208121005',
    districtId: '3208121',
    name: 'Sindangagung',
  },
  {
    id: '3208121006',
    districtId: '3208121',
    name: 'Balong',
  },
  {
    id: '3208121007',
    districtId: '3208121',
    name: 'Mekarmukti',
  },
  {
    id: '3208121008',
    districtId: '3208121',
    name: 'Kertayasa',
  },
  {
    id: '3208121009',
    districtId: '3208121',
    name: 'Tirtawangunan',
  },
  {
    id: '3208121010',
    districtId: '3208121',
    name: 'Babakanreuma',
  },
  {
    id: '3208121011',
    districtId: '3208121',
    name: 'Dukuhlor',
  },
  {
    id: '3208121012',
    districtId: '3208121',
    name: 'Taraju',
  },
  {
    id: '3208130001',
    districtId: '3208130',
    name: 'Cibinuang',
  },
  {
    id: '3208130002',
    districtId: '3208130',
    name: 'Citangtu',
  },
  {
    id: '3208130003',
    districtId: '3208130',
    name: 'Karangtawang',
  },
  {
    id: '3208130004',
    districtId: '3208130',
    name: 'Winduhaji',
  },
  {
    id: '3208130005',
    districtId: '3208130',
    name: 'Kuningan',
  },
  {
    id: '3208130006',
    districtId: '3208130',
    name: 'Purwawinangun',
  },
  {
    id: '3208130007',
    districtId: '3208130',
    name: 'Cigintung',
  },
  {
    id: '3208130008',
    districtId: '3208130',
    name: 'Cijoho',
  },
  {
    id: '3208130009',
    districtId: '3208130',
    name: 'Windusengkahan',
  },
  {
    id: '3208130010',
    districtId: '3208130',
    name: 'Ciporang',
  },
  {
    id: '3208130011',
    districtId: '3208130',
    name: 'Ancaran',
  },
  {
    id: '3208130012',
    districtId: '3208130',
    name: 'Kedungarum',
  },
  {
    id: '3208130013',
    districtId: '3208130',
    name: 'Cirendang',
  },
  {
    id: '3208130014',
    districtId: '3208130',
    name: 'Awirarangan',
  },
  {
    id: '3208130015',
    districtId: '3208130',
    name: 'Kasturi',
  },
  {
    id: '3208130016',
    districtId: '3208130',
    name: 'Padarek',
  },
  {
    id: '3208140001',
    districtId: '3208140',
    name: 'Cigadung',
  },
  {
    id: '3208140002',
    districtId: '3208140',
    name: 'Sukamulya',
  },
  {
    id: '3208140003',
    districtId: '3208140',
    name: 'Cileuleuy',
  },
  {
    id: '3208140004',
    districtId: '3208140',
    name: 'Puncak',
  },
  {
    id: '3208140005',
    districtId: '3208140',
    name: 'Babakanmulya',
  },
  {
    id: '3208140006',
    districtId: '3208140',
    name: 'Cisantana',
  },
  {
    id: '3208140007',
    districtId: '3208140',
    name: 'Cigugur',
  },
  {
    id: '3208140008',
    districtId: '3208140',
    name: 'Winduherang',
  },
  {
    id: '3208140009',
    districtId: '3208140',
    name: 'Gunungkeling',
  },
  {
    id: '3208140010',
    districtId: '3208140',
    name: 'Cipari',
  },
  {
    id: '3208150001',
    districtId: '3208150',
    name: 'Pajambon',
  },
  {
    id: '3208150002',
    districtId: '3208150',
    name: 'Ragawacana',
  },
  {
    id: '3208150003',
    districtId: '3208150',
    name: 'Cilowa',
  },
  {
    id: '3208150005',
    districtId: '3208150',
    name: 'Gereba',
  },
  {
    id: '3208150007',
    districtId: '3208150',
    name: 'Cikubangsari',
  },
  {
    id: '3208150008',
    districtId: '3208150',
    name: 'Widarasari',
  },
  {
    id: '3208150009',
    districtId: '3208150',
    name: 'Cilaja',
  },
  {
    id: '3208150010',
    districtId: '3208150',
    name: 'Bojong',
  },
  {
    id: '3208150011',
    districtId: '3208150',
    name: 'Cikaso',
  },
  {
    id: '3208150012',
    districtId: '3208150',
    name: 'Kramatmulya',
  },
  {
    id: '3208150013',
    districtId: '3208150',
    name: 'Cibentang',
  },
  {
    id: '3208150014',
    districtId: '3208150',
    name: 'Gandasoli',
  },
  {
    id: '3208150015',
    districtId: '3208150',
    name: 'Kalapagunung',
  },
  {
    id: '3208150017',
    districtId: '3208150',
    name: 'Karangmangu',
  },
  {
    id: '3208160001',
    districtId: '3208160',
    name: 'Sukamukti',
  },
  {
    id: '3208160002',
    districtId: '3208160',
    name: 'Sidamulya',
  },
  {
    id: '3208160003',
    districtId: '3208160',
    name: 'Jalaksana',
  },
  {
    id: '3208160004',
    districtId: '3208160',
    name: 'Babakanmulya',
  },
  {
    id: '3208160005',
    districtId: '3208160',
    name: 'Sangkanerang',
  },
  {
    id: '3208160006',
    districtId: '3208160',
    name: 'Sayana',
  },
  {
    id: '3208160007',
    districtId: '3208160',
    name: 'Peusing',
  },
  {
    id: '3208160008',
    districtId: '3208160',
    name: 'Sembawa',
  },
  {
    id: '3208160009',
    districtId: '3208160',
    name: 'Sadamantra',
  },
  {
    id: '3208160010',
    districtId: '3208160',
    name: 'Maniskidul',
  },
  {
    id: '3208160011',
    districtId: '3208160',
    name: 'Manislor',
  },
  {
    id: '3208160013',
    districtId: '3208160',
    name: 'Padamenak',
  },
  {
    id: '3208160014',
    districtId: '3208160',
    name: 'Ciniru',
  },
  {
    id: '3208160016',
    districtId: '3208160',
    name: 'Sindangbarang',
  },
  {
    id: '3208160017',
    districtId: '3208160',
    name: 'Nanggerang',
  },
  {
    id: '3208161001',
    districtId: '3208161',
    name: 'Rajadanu',
  },
  {
    id: '3208161002',
    districtId: '3208161',
    name: 'Dukuhdalem',
  },
  {
    id: '3208161003',
    districtId: '3208161',
    name: 'Garatengah',
  },
  {
    id: '3208161004',
    districtId: '3208161',
    name: 'Japara',
  },
  {
    id: '3208161005',
    districtId: '3208161',
    name: 'Singkup',
  },
  {
    id: '3208161006',
    districtId: '3208161',
    name: 'Wano',
  },
  {
    id: '3208161007',
    districtId: '3208161',
    name: 'Citapen',
  },
  {
    id: '3208161008',
    districtId: '3208161',
    name: 'Cengal',
  },
  {
    id: '3208161009',
    districtId: '3208161',
    name: 'Cikeleng',
  },
  {
    id: '3208161010',
    districtId: '3208161',
    name: 'Kalimati',
  },
  {
    id: '3208170001',
    districtId: '3208170',
    name: 'Bandorasa Kulon',
  },
  {
    id: '3208170002',
    districtId: '3208170',
    name: 'Bandorasa Wetan',
  },
  {
    id: '3208170012',
    districtId: '3208170',
    name: 'Bojong',
  },
  {
    id: '3208170013',
    districtId: '3208170',
    name: 'Linggamekar',
  },
  {
    id: '3208170014',
    districtId: '3208170',
    name: 'Linggasana',
  },
  {
    id: '3208170015',
    districtId: '3208170',
    name: 'Linggajati',
  },
  {
    id: '3208170016',
    districtId: '3208170',
    name: 'Linggaindah',
  },
  {
    id: '3208170017',
    districtId: '3208170',
    name: 'Cilimus',
  },
  {
    id: '3208170020',
    districtId: '3208170',
    name: 'Caracas',
  },
  {
    id: '3208170021',
    districtId: '3208170',
    name: 'Sampora',
  },
  {
    id: '3208170022',
    districtId: '3208170',
    name: 'Kaliaren',
  },
  {
    id: '3208170023',
    districtId: '3208170',
    name: 'Setianegara',
  },
  {
    id: '3208170024',
    districtId: '3208170',
    name: 'Cibeureum',
  },
  {
    id: '3208171001',
    districtId: '3208171',
    name: 'Sangkanurip',
  },
  {
    id: '3208171002',
    districtId: '3208171',
    name: 'Sangkanmulya',
  },
  {
    id: '3208171003',
    districtId: '3208171',
    name: 'Karangmuncang',
  },
  {
    id: '3208171004',
    districtId: '3208171',
    name: 'Koreak',
  },
  {
    id: '3208171005',
    districtId: '3208171',
    name: 'Jambugeulis',
  },
  {
    id: '3208171006',
    districtId: '3208171',
    name: 'Bunigeulis',
  },
  {
    id: '3208171007',
    districtId: '3208171',
    name: 'Babakanjati',
  },
  {
    id: '3208171008',
    districtId: '3208171',
    name: 'Timbang',
  },
  {
    id: '3208171009',
    districtId: '3208171',
    name: 'Panawuan',
  },
  {
    id: '3208171010',
    districtId: '3208171',
    name: 'Indapatra',
  },
  {
    id: '3208171011',
    districtId: '3208171',
    name: 'Cibuntu',
  },
  {
    id: '3208180001',
    districtId: '3208180',
    name: 'Trijaya',
  },
  {
    id: '3208180002',
    districtId: '3208180',
    name: 'Randobawagirang',
  },
  {
    id: '3208180003',
    districtId: '3208180',
    name: 'Salakadomas',
  },
  {
    id: '3208180004',
    districtId: '3208180',
    name: 'Pakembangan',
  },
  {
    id: '3208180007',
    districtId: '3208180',
    name: 'Randobawailir',
  },
  {
    id: '3208180008',
    districtId: '3208180',
    name: 'Kertawinangun',
  },
  {
    id: '3208180009',
    districtId: '3208180',
    name: 'Seda',
  },
  {
    id: '3208180010',
    districtId: '3208180',
    name: 'Nanggerangjaya',
  },
  {
    id: '3208180011',
    districtId: '3208180',
    name: 'Sukasari',
  },
  {
    id: '3208180012',
    districtId: '3208180',
    name: 'Cirea',
  },
  {
    id: '3208180013',
    districtId: '3208180',
    name: 'Nanggela',
  },
  {
    id: '3208180014',
    districtId: '3208180',
    name: 'Mandirancan',
  },
  {
    id: '3208181001',
    districtId: '3208181',
    name: 'Silebu',
  },
  {
    id: '3208181002',
    districtId: '3208181',
    name: 'Kahiyangan',
  },
  {
    id: '3208181003',
    districtId: '3208181',
    name: 'Patalagan',
  },
  {
    id: '3208181004',
    districtId: '3208181',
    name: 'Sumbakeling',
  },
  {
    id: '3208181005',
    districtId: '3208181',
    name: 'Danalampah',
  },
  {
    id: '3208181006',
    districtId: '3208181',
    name: 'Sindangkempeng',
  },
  {
    id: '3208181007',
    districtId: '3208181',
    name: 'Pancalang',
  },
  {
    id: '3208181008',
    districtId: '3208181',
    name: 'Tajurbuntu',
  },
  {
    id: '3208181009',
    districtId: '3208181',
    name: 'Rajawetan',
  },
  {
    id: '3208181010',
    districtId: '3208181',
    name: 'Mekarjaya',
  },
  {
    id: '3208181011',
    districtId: '3208181',
    name: 'Tenjolayar',
  },
  {
    id: '3208181012',
    districtId: '3208181',
    name: 'Tarikolot',
  },
  {
    id: '3208181013',
    districtId: '3208181',
    name: 'Sarewu',
  },
  {
    id: '3208190001',
    districtId: '3208190',
    name: 'Cibuntu',
  },
  {
    id: '3208190002',
    districtId: '3208190',
    name: 'Paniis',
  },
  {
    id: '3208190003',
    districtId: '3208190',
    name: 'Singkup',
  },
  {
    id: '3208190004',
    districtId: '3208190',
    name: 'Cidahu',
  },
  {
    id: '3208190005',
    districtId: '3208190',
    name: 'Pasawahan',
  },
  {
    id: '3208190006',
    districtId: '3208190',
    name: 'Padabeunghar',
  },
  {
    id: '3208190007',
    districtId: '3208190',
    name: 'Kaduela',
  },
  {
    id: '3208190008',
    districtId: '3208190',
    name: 'Padamatang',
  },
  {
    id: '3208190009',
    districtId: '3208190',
    name: 'Ciwiru',
  },
  {
    id: '3208190010',
    districtId: '3208190',
    name: 'Cimara',
  },
  {
    id: '3209010008',
    districtId: '3209010',
    name: 'Waled Desa',
  },
  {
    id: '3209010009',
    districtId: '3209010',
    name: 'Waled Kota',
  },
  {
    id: '3209010010',
    districtId: '3209010',
    name: 'Mekarsari',
  },
  {
    id: '3209010011',
    districtId: '3209010',
    name: 'Waled Asem',
  },
  {
    id: '3209010012',
    districtId: '3209010',
    name: 'Ambit',
  },
  {
    id: '3209010013',
    districtId: '3209010',
    name: 'Ciuyah',
  },
  {
    id: '3209010014',
    districtId: '3209010',
    name: 'Gunungsari',
  },
  {
    id: '3209010015',
    districtId: '3209010',
    name: 'Karangsari',
  },
  {
    id: '3209010016',
    districtId: '3209010',
    name: 'Cikulak Kidul',
  },
  {
    id: '3209010017',
    districtId: '3209010',
    name: 'Cikulak',
  },
  {
    id: '3209010018',
    districtId: '3209010',
    name: 'Cibogo',
  },
  {
    id: '3209010019',
    districtId: '3209010',
    name: 'Cisaat',
  },
  {
    id: '3209011001',
    districtId: '3209011',
    name: 'Tonjong',
  },
  {
    id: '3209011002',
    districtId: '3209011',
    name: 'Tanjung Anom',
  },
  {
    id: '3209011003',
    districtId: '3209011',
    name: 'Cilengkrang Girang',
  },
  {
    id: '3209011004',
    districtId: '3209011',
    name: 'Cilengkrang',
  },
  {
    id: '3209011005',
    districtId: '3209011',
    name: 'Pasaleman',
  },
  {
    id: '3209011006',
    districtId: '3209011',
    name: 'Cigobangwangi',
  },
  {
    id: '3209011007',
    districtId: '3209011',
    name: 'Cigobang',
  },
  {
    id: '3209020008',
    districtId: '3209020',
    name: 'Leuweunggajah',
  },
  {
    id: '3209020009',
    districtId: '3209020',
    name: 'Tenjomaya',
  },
  {
    id: '3209020010',
    districtId: '3209020',
    name: 'Damarguna',
  },
  {
    id: '3209020011',
    districtId: '3209020',
    name: 'Jatiseeng',
  },
  {
    id: '3209020012',
    districtId: '3209020',
    name: 'Jatiseeng Kidul',
  },
  {
    id: '3209020013',
    districtId: '3209020',
    name: 'Ciledug Kulon',
  },
  {
    id: '3209020014',
    districtId: '3209020',
    name: 'Ciledug Wetan',
  },
  {
    id: '3209020015',
    districtId: '3209020',
    name: 'Ciledug Lor',
  },
  {
    id: '3209020016',
    districtId: '3209020',
    name: 'Ciledug Tengah',
  },
  {
    id: '3209020017',
    districtId: '3209020',
    name: 'Bojongnegara',
  },
  {
    id: '3209021001',
    districtId: '3209021',
    name: 'Sukadana',
  },
  {
    id: '3209021002',
    districtId: '3209021',
    name: 'Pabuaran Kidul',
  },
  {
    id: '3209021003',
    districtId: '3209021',
    name: 'Pabuaran Wetan',
  },
  {
    id: '3209021004',
    districtId: '3209021',
    name: 'Pabuaran Lor',
  },
  {
    id: '3209021005',
    districtId: '3209021',
    name: 'Jatirenggang',
  },
  {
    id: '3209021006',
    districtId: '3209021',
    name: 'Hulubanteng',
  },
  {
    id: '3209021007',
    districtId: '3209021',
    name: 'Hulubanteng Lor',
  },
  {
    id: '3209030009',
    districtId: '3209030',
    name: 'Astanalanggar',
  },
  {
    id: '3209030010',
    districtId: '3209030',
    name: 'Barisan',
  },
  {
    id: '3209030011',
    districtId: '3209030',
    name: 'Losari Kidul',
  },
  {
    id: '3209030012',
    districtId: '3209030',
    name: 'Panggangsari',
  },
  {
    id: '3209030013',
    districtId: '3209030',
    name: 'Losari Lor',
  },
  {
    id: '3209030014',
    districtId: '3209030',
    name: 'Mulyasari',
  },
  {
    id: '3209030015',
    districtId: '3209030',
    name: 'Kalirahayu',
  },
  {
    id: '3209030016',
    districtId: '3209030',
    name: 'Kalisari',
  },
  {
    id: '3209030017',
    districtId: '3209030',
    name: 'Ambulu',
  },
  {
    id: '3209030018',
    districtId: '3209030',
    name: 'Tawangsari',
  },
  {
    id: '3209031001',
    districtId: '3209031',
    name: 'Babakan Losari',
  },
  {
    id: '3209031002',
    districtId: '3209031',
    name: 'Sidaresmi',
  },
  {
    id: '3209031003',
    districtId: '3209031',
    name: 'Kalibuntu',
  },
  {
    id: '3209031004',
    districtId: '3209031',
    name: 'Dukuhwidara',
  },
  {
    id: '3209031005',
    districtId: '3209031',
    name: 'Pasuruan',
  },
  {
    id: '3209031006',
    districtId: '3209031',
    name: 'Kalimukti',
  },
  {
    id: '3209031007',
    districtId: '3209031',
    name: 'Pabedilan Kaler',
  },
  {
    id: '3209031008',
    districtId: '3209031',
    name: 'Babakan Losari Lor',
  },
  {
    id: '3209031009',
    districtId: '3209031',
    name: 'Pabedilan Kidul',
  },
  {
    id: '3209031010',
    districtId: '3209031',
    name: 'Pabedilan Kulon',
  },
  {
    id: '3209031011',
    districtId: '3209031',
    name: 'Pabedilan Wetan',
  },
  {
    id: '3209031012',
    districtId: '3209031',
    name: 'Tersana',
  },
  {
    id: '3209031013',
    districtId: '3209031',
    name: 'Silihasih',
  },
  {
    id: '3209040001',
    districtId: '3209040',
    name: 'Cangkuang',
  },
  {
    id: '3209040002',
    districtId: '3209040',
    name: 'Serang Wetan',
  },
  {
    id: '3209040003',
    districtId: '3209040',
    name: 'Bojonggebang',
  },
  {
    id: '3209040004',
    districtId: '3209040',
    name: 'Kudukeras',
  },
  {
    id: '3209040005',
    districtId: '3209040',
    name: 'Sumber Kidul',
  },
  {
    id: '3209040006',
    districtId: '3209040',
    name: 'Kudumulya',
  },
  {
    id: '3209040007',
    districtId: '3209040',
    name: 'Sumber Lor',
  },
  {
    id: '3209040008',
    districtId: '3209040',
    name: 'Babakan',
  },
  {
    id: '3209040009',
    districtId: '3209040',
    name: 'Pakusamben',
  },
  {
    id: '3209040010',
    districtId: '3209040',
    name: 'Karangwangun',
  },
  {
    id: '3209040011',
    districtId: '3209040',
    name: 'Babakan Gebang',
  },
  {
    id: '3209040012',
    districtId: '3209040',
    name: 'Gembongan',
  },
  {
    id: '3209040013',
    districtId: '3209040',
    name: 'Serang Kulon',
  },
  {
    id: '3209040014',
    districtId: '3209040',
    name: 'Gembongan Mekar',
  },
  {
    id: '3209041001',
    districtId: '3209041',
    name: 'Dompyong Kulon',
  },
  {
    id: '3209041002',
    districtId: '3209041',
    name: 'Dompyong Wetan',
  },
  {
    id: '3209041003',
    districtId: '3209041',
    name: 'Kalimekar',
  },
  {
    id: '3209041004',
    districtId: '3209041',
    name: 'Kalimaro',
  },
  {
    id: '3209041005',
    districtId: '3209041',
    name: 'Gagasari',
  },
  {
    id: '3209041006',
    districtId: '3209041',
    name: 'Kalipasung',
  },
  {
    id: '3209041007',
    districtId: '3209041',
    name: 'Gebang Kulon',
  },
  {
    id: '3209041008',
    districtId: '3209041',
    name: 'Gebang',
  },
  {
    id: '3209041009',
    districtId: '3209041',
    name: 'Gebang Udik',
  },
  {
    id: '3209041010',
    districtId: '3209041',
    name: 'Gebang Ilir',
  },
  {
    id: '3209041011',
    districtId: '3209041',
    name: 'Gebang Mekar',
  },
  {
    id: '3209041012',
    districtId: '3209041',
    name: 'Pelayangan',
  },
  {
    id: '3209041013',
    districtId: '3209041',
    name: 'Melakasari',
  },
  {
    id: '3209050008',
    districtId: '3209050',
    name: 'Tambelang',
  },
  {
    id: '3209050015',
    districtId: '3209050',
    name: 'Karangsuwung',
  },
  {
    id: '3209050016',
    districtId: '3209050',
    name: 'Karangtengah',
  },
  {
    id: '3209050017',
    districtId: '3209050',
    name: 'Kalimeang',
  },
  {
    id: '3209050018',
    districtId: '3209050',
    name: 'Karangmalang',
  },
  {
    id: '3209050019',
    districtId: '3209050',
    name: 'Karangmekar',
  },
  {
    id: '3209050020',
    districtId: '3209050',
    name: 'Kubangkarang',
  },
  {
    id: '3209050021',
    districtId: '3209050',
    name: 'Karangsembung',
  },
  {
    id: '3209051001',
    districtId: '3209051',
    name: 'Seuseupan',
  },
  {
    id: '3209051002',
    districtId: '3209051',
    name: 'Sumurkondang',
  },
  {
    id: '3209051003',
    districtId: '3209051',
    name: 'Jatipiring',
  },
  {
    id: '3209051004',
    districtId: '3209051',
    name: 'Kubangdeleg',
  },
  {
    id: '3209051005',
    districtId: '3209051',
    name: 'Karanganyar',
  },
  {
    id: '3209051006',
    districtId: '3209051',
    name: 'Karangwangi',
  },
  {
    id: '3209051008',
    districtId: '3209051',
    name: 'Karangwareng',
  },
  {
    id: '3209051009',
    districtId: '3209051',
    name: 'Karangasem',
  },
  {
    id: '3209060005',
    districtId: '3209060',
    name: 'Picungpugur',
  },
  {
    id: '3209060006',
    districtId: '3209060',
    name: 'Leuwidingding',
  },
  {
    id: '3209060007',
    districtId: '3209060',
    name: 'Asem',
  },
  {
    id: '3209060013',
    districtId: '3209060',
    name: 'Cipeujeuh Kulon',
  },
  {
    id: '3209060014',
    districtId: '3209060',
    name: 'Sindanglaut',
  },
  {
    id: '3209060015',
    districtId: '3209060',
    name: 'Cipeujeuh Wetan',
  },
  {
    id: '3209060016',
    districtId: '3209060',
    name: 'Lemahabang Kulon',
  },
  {
    id: '3209060017',
    districtId: '3209060',
    name: 'Lemahabang',
  },
  {
    id: '3209060018',
    districtId: '3209060',
    name: 'Sigong',
  },
  {
    id: '3209060019',
    districtId: '3209060',
    name: 'Sarajaya',
  },
  {
    id: '3209060020',
    districtId: '3209060',
    name: 'Tuk Karangsuwung',
  },
  {
    id: '3209060021',
    districtId: '3209060',
    name: 'Belawa',
  },
  {
    id: '3209060022',
    districtId: '3209060',
    name: 'Wangkelang',
  },
  {
    id: '3209061001',
    districtId: '3209061',
    name: 'Karangmangu',
  },
  {
    id: '3209061002',
    districtId: '3209061',
    name: 'Kaligawe',
  },
  {
    id: '3209061003',
    districtId: '3209061',
    name: 'Kaligawe Wetan',
  },
  {
    id: '3209061004',
    districtId: '3209061',
    name: 'Curug Wetan',
  },
  {
    id: '3209061006',
    districtId: '3209061',
    name: 'Wilulang',
  },
  {
    id: '3209061007',
    districtId: '3209061',
    name: 'Susukan Agung',
  },
  {
    id: '3209061008',
    districtId: '3209061',
    name: 'Susukan Lebak',
  },
  {
    id: '3209061009',
    districtId: '3209061',
    name: 'Susukan Tonggoh',
  },
  {
    id: '3209061010',
    districtId: '3209061',
    name: 'Sampih',
  },
  {
    id: '3209061011',
    districtId: '3209061',
    name: 'Pasawahan',
  },
  {
    id: '3209061012',
    districtId: '3209061',
    name: 'Ciawi Asih',
  },
  {
    id: '3209061013',
    districtId: '3209061',
    name: 'Ciawijapura',
  },
  {
    id: '3209070001',
    districtId: '3209070',
    name: 'Karangwuni',
  },
  {
    id: '3209070002',
    districtId: '3209070',
    name: 'Sedong Kidul',
  },
  {
    id: '3209070003',
    districtId: '3209070',
    name: 'Sedong Lor',
  },
  {
    id: '3209070004',
    districtId: '3209070',
    name: 'Windujaya',
  },
  {
    id: '3209070005',
    districtId: '3209070',
    name: 'Winduhaji',
  },
  {
    id: '3209070006',
    districtId: '3209070',
    name: 'Kertawangun',
  },
  {
    id: '3209070007',
    districtId: '3209070',
    name: 'Panambangan',
  },
  {
    id: '3209070008',
    districtId: '3209070',
    name: 'Putat',
  },
  {
    id: '3209070009',
    districtId: '3209070',
    name: 'Panongan',
  },
  {
    id: '3209070010',
    districtId: '3209070',
    name: 'Panongan Lor',
  },
  {
    id: '3209080005',
    districtId: '3209080',
    name: 'Sidamulya',
  },
  {
    id: '3209080006',
    districtId: '3209080',
    name: 'Mertapada Kulon',
  },
  {
    id: '3209080007',
    districtId: '3209080',
    name: 'Mertapada Wetan',
  },
  {
    id: '3209080009',
    districtId: '3209080',
    name: 'Kanci Kulon',
  },
  {
    id: '3209080010',
    districtId: '3209080',
    name: 'Kanci',
  },
  {
    id: '3209080011',
    districtId: '3209080',
    name: 'Astanajapura',
  },
  {
    id: '3209080015',
    districtId: '3209080',
    name: 'Kendal',
  },
  {
    id: '3209080016',
    districtId: '3209080',
    name: 'Japura Kidul',
  },
  {
    id: '3209080017',
    districtId: '3209080',
    name: 'Japurabakti',
  },
  {
    id: '3209081001',
    districtId: '3209081',
    name: 'Astanamukti',
  },
  {
    id: '3209081002',
    districtId: '3209081',
    name: 'Pengarengan',
  },
  {
    id: '3209081003',
    districtId: '3209081',
    name: 'Japura Lor',
  },
  {
    id: '3209081004',
    districtId: '3209081',
    name: 'Beringin',
  },
  {
    id: '3209081005',
    districtId: '3209081',
    name: 'Rawaurip',
  },
  {
    id: '3209081006',
    districtId: '3209081',
    name: 'Bendungan',
  },
  {
    id: '3209081007',
    districtId: '3209081',
    name: 'Pangenan',
  },
  {
    id: '3209081008',
    districtId: '3209081',
    name: 'Getrakmoyan',
  },
  {
    id: '3209090001',
    districtId: '3209090',
    name: 'Setupatok',
  },
  {
    id: '3209090003',
    districtId: '3209090',
    name: 'Mundu Mesigit',
  },
  {
    id: '3209090005',
    districtId: '3209090',
    name: 'Waruduwur',
  },
  {
    id: '3209090006',
    districtId: '3209090',
    name: 'Citemu',
  },
  {
    id: '3209090007',
    districtId: '3209090',
    name: 'Bandengan',
  },
  {
    id: '3209090008',
    districtId: '3209090',
    name: 'Mundu Pesisir',
  },
  {
    id: '3209090009',
    districtId: '3209090',
    name: 'Suci',
  },
  {
    id: '3209090010',
    districtId: '3209090',
    name: 'Banjarwangunan',
  },
  {
    id: '3209090011',
    districtId: '3209090',
    name: 'Pamengkang',
  },
  {
    id: '3209090012',
    districtId: '3209090',
    name: 'Sinarancang',
  },
  {
    id: '3209100001',
    districtId: '3209100',
    name: 'Wanayasa',
  },
  {
    id: '3209100002',
    districtId: '3209100',
    name: 'Sindangkasih',
  },
  {
    id: '3209100003',
    districtId: '3209100',
    name: 'Sindanghayu',
  },
  {
    id: '3209100004',
    districtId: '3209100',
    name: 'Ciawigajah',
  },
  {
    id: '3209100008',
    districtId: '3209100',
    name: 'Cikancas',
  },
  {
    id: '3209100009',
    districtId: '3209100',
    name: 'Halimpu',
  },
  {
    id: '3209100010',
    districtId: '3209100',
    name: 'Cipinang',
  },
  {
    id: '3209100012',
    districtId: '3209100',
    name: 'Patapan',
  },
  {
    id: '3209100013',
    districtId: '3209100',
    name: 'Kondangsari',
  },
  {
    id: '3209101001',
    districtId: '3209101',
    name: 'Gumulung Lebak',
  },
  {
    id: '3209101002',
    districtId: '3209101',
    name: 'Lebak Mekar',
  },
  {
    id: '3209101003',
    districtId: '3209101',
    name: 'Gumulung Tonggoh',
  },
  {
    id: '3209101005',
    districtId: '3209101',
    name: 'Kamarang',
  },
  {
    id: '3209101007',
    districtId: '3209101',
    name: 'Kamarang Lebak',
  },
  {
    id: '3209101014',
    districtId: '3209101',
    name: 'Durajaya',
  },
  {
    id: '3209101015',
    districtId: '3209101',
    name: 'Jatipancur',
  },
  {
    id: '3209101016',
    districtId: '3209101',
    name: 'Sindang Kempeng',
  },
  {
    id: '3209101017',
    districtId: '3209101',
    name: 'Nanggela',
  },
  {
    id: '3209111001',
    districtId: '3209111',
    name: 'Sampiran',
  },
  {
    id: '3209111002',
    districtId: '3209111',
    name: 'Ciperna',
  },
  {
    id: '3209111003',
    districtId: '3209111',
    name: 'Kecomberan',
  },
  {
    id: '3209111004',
    districtId: '3209111',
    name: 'Cirebon Girang',
  },
  {
    id: '3209111005',
    districtId: '3209111',
    name: 'Kerandon',
  },
  {
    id: '3209111006',
    districtId: '3209111',
    name: 'Wanasaba Kidul',
  },
  {
    id: '3209111007',
    districtId: '3209111',
    name: 'Wanasaba Lor',
  },
  {
    id: '3209111012',
    districtId: '3209111',
    name: 'Cempaka',
  },
  {
    id: '3209111013',
    districtId: '3209111',
    name: 'Kepongpongan',
  },
  {
    id: '3209111014',
    districtId: '3209111',
    name: 'Kubang',
  },
  {
    id: '3209111015',
    districtId: '3209111',
    name: 'Sarwadadi',
  },
  {
    id: '3209120010',
    districtId: '3209120',
    name: 'Matangaji',
  },
  {
    id: '3209120011',
    districtId: '3209120',
    name: 'Sidawangi',
  },
  {
    id: '3209120014',
    districtId: '3209120',
    name: 'Babakan',
  },
  {
    id: '3209120016',
    districtId: '3209120',
    name: 'Perbutulan',
  },
  {
    id: '3209120017',
    districtId: '3209120',
    name: 'Kemantren',
  },
  {
    id: '3209120018',
    districtId: '3209120',
    name: 'Sendang',
  },
  {
    id: '3209120020',
    districtId: '3209120',
    name: 'Pejambon',
  },
  {
    id: '3209120021',
    districtId: '3209120',
    name: 'Watubelah',
  },
  {
    id: '3209120022',
    districtId: '3209120',
    name: 'Pasalakan',
  },
  {
    id: '3209120023',
    districtId: '3209120',
    name: 'Kaliwadas',
  },
  {
    id: '3209120024',
    districtId: '3209120',
    name: 'Tukmudal',
  },
  {
    id: '3209120025',
    districtId: '3209120',
    name: 'Kenanga',
  },
  {
    id: '3209121001',
    districtId: '3209121',
    name: 'Bobos',
  },
  {
    id: '3209121002',
    districtId: '3209121',
    name: 'Cikalahang',
  },
  {
    id: '3209121003',
    districtId: '3209121',
    name: 'Mandala',
  },
  {
    id: '3209121004',
    districtId: '3209121',
    name: 'Cisaat',
  },
  {
    id: '3209121005',
    districtId: '3209121',
    name: 'Sindangjawa',
  },
  {
    id: '3209121006',
    districtId: '3209121',
    name: 'Sindangmekar',
  },
  {
    id: '3209121007',
    districtId: '3209121',
    name: 'Cangkoak',
  },
  {
    id: '3209121008',
    districtId: '3209121',
    name: 'Kepunduan',
  },
  {
    id: '3209121009',
    districtId: '3209121',
    name: 'Balad',
  },
  {
    id: '3209121010',
    districtId: '3209121',
    name: 'Dukupuntang',
  },
  {
    id: '3209121011',
    districtId: '3209121',
    name: 'Cipanas',
  },
  {
    id: '3209121012',
    districtId: '3209121',
    name: 'Girinata',
  },
  {
    id: '3209121013',
    districtId: '3209121',
    name: 'Kedongdong Kidul',
  },
  {
    id: '3209130006',
    districtId: '3209130',
    name: 'Cilukrak',
  },
  {
    id: '3209130007',
    districtId: '3209130',
    name: 'Balerante',
  },
  {
    id: '3209130008',
    districtId: '3209130',
    name: 'Panongan',
  },
  {
    id: '3209130009',
    districtId: '3209130',
    name: 'Beberan',
  },
  {
    id: '3209130010',
    districtId: '3209130',
    name: 'Semplo',
  },
  {
    id: '3209130011',
    districtId: '3209130',
    name: 'Palimanan Timur',
  },
  {
    id: '3209130014',
    districtId: '3209130',
    name: 'Pegagan',
  },
  {
    id: '3209130015',
    districtId: '3209130',
    name: 'Lungbenda',
  },
  {
    id: '3209130016',
    districtId: '3209130',
    name: 'Ciawi',
  },
  {
    id: '3209130017',
    districtId: '3209130',
    name: 'Cengkuang',
  },
  {
    id: '3209130018',
    districtId: '3209130',
    name: 'Tegalkarang',
  },
  {
    id: '3209140006',
    districtId: '3209140',
    name: 'Cempaka',
  },
  {
    id: '3209140007',
    districtId: '3209140',
    name: 'Pamijahan',
  },
  {
    id: '3209140017',
    districtId: '3209140',
    name: 'Lurah',
  },
  {
    id: '3209140018',
    districtId: '3209140',
    name: 'Marikangen',
  },
  {
    id: '3209140019',
    districtId: '3209140',
    name: 'Bode Lor',
  },
  {
    id: '3209140020',
    districtId: '3209140',
    name: 'Bodesari',
  },
  {
    id: '3209140021',
    districtId: '3209140',
    name: 'Gombang',
  },
  {
    id: '3209140022',
    districtId: '3209140',
    name: 'Karangmulya',
  },
  {
    id: '3209140023',
    districtId: '3209140',
    name: 'Karangasem',
  },
  {
    id: '3209140024',
    districtId: '3209140',
    name: 'Plumbon',
  },
  {
    id: '3209140025',
    districtId: '3209140',
    name: 'Purbawinangun',
  },
  {
    id: '3209140026',
    districtId: '3209140',
    name: 'Kebarepan',
  },
  {
    id: '3209140027',
    districtId: '3209140',
    name: 'Pasanggrahan',
  },
  {
    id: '3209140028',
    districtId: '3209140',
    name: 'Kedungsana',
  },
  {
    id: '3209140029',
    districtId: '3209140',
    name: 'Danamulya',
  },
  {
    id: '3209141001',
    districtId: '3209141',
    name: 'Cikeduk',
  },
  {
    id: '3209141002',
    districtId: '3209141',
    name: 'Warugede',
  },
  {
    id: '3209141003',
    districtId: '3209141',
    name: 'Karangwangi',
  },
  {
    id: '3209141004',
    districtId: '3209141',
    name: 'Getasan',
  },
  {
    id: '3209141006',
    districtId: '3209141',
    name: 'Keduanan',
  },
  {
    id: '3209141007',
    districtId: '3209141',
    name: 'Waruroyom',
  },
  {
    id: '3209141008',
    districtId: '3209141',
    name: 'Warukawung',
  },
  {
    id: '3209141009',
    districtId: '3209141',
    name: 'Warujaya',
  },
  {
    id: '3209141010',
    districtId: '3209141',
    name: 'Depok',
  },
  {
    id: '3209141011',
    districtId: '3209141',
    name: 'Kasugengan Kidul',
  },
  {
    id: '3209141012',
    districtId: '3209141',
    name: 'Kasugengan Lor',
  },
  {
    id: '3209150005',
    districtId: '3209150',
    name: 'Karangsari',
  },
  {
    id: '3209150006',
    districtId: '3209150',
    name: 'Kertasari',
  },
  {
    id: '3209150007',
    districtId: '3209150',
    name: 'Megu Cilik',
  },
  {
    id: '3209150009',
    districtId: '3209150',
    name: 'Setu Wetan',
  },
  {
    id: '3209150010',
    districtId: '3209150',
    name: 'Weru Kidul',
  },
  {
    id: '3209150011',
    districtId: '3209150',
    name: 'Setu Kulon',
  },
  {
    id: '3209150012',
    districtId: '3209150',
    name: 'Tegalwangi',
  },
  {
    id: '3209150015',
    districtId: '3209150',
    name: 'Weru Lor',
  },
  {
    id: '3209151001',
    districtId: '3209151',
    name: 'Panembahan',
  },
  {
    id: '3209151002',
    districtId: '3209151',
    name: 'Trusmi Wetan',
  },
  {
    id: '3209151003',
    districtId: '3209151',
    name: 'Trusmi Kulon',
  },
  {
    id: '3209151004',
    districtId: '3209151',
    name: 'Sarabau',
  },
  {
    id: '3209151005',
    districtId: '3209151',
    name: 'Gamel',
  },
  {
    id: '3209151006',
    districtId: '3209151',
    name: 'Wotgali',
  },
  {
    id: '3209151007',
    districtId: '3209151',
    name: 'Kaliwulu',
  },
  {
    id: '3209151008',
    districtId: '3209151',
    name: 'Tegalsari',
  },
  {
    id: '3209151009',
    districtId: '3209151',
    name: 'Cangkring',
  },
  {
    id: '3209151010',
    districtId: '3209151',
    name: 'Pangkalan',
  },
  {
    id: '3209161001',
    districtId: '3209161',
    name: 'Palir',
  },
  {
    id: '3209161002',
    districtId: '3209161',
    name: 'Astapada',
  },
  {
    id: '3209161003',
    districtId: '3209161',
    name: 'Gesik',
  },
  {
    id: '3209161004',
    districtId: '3209161',
    name: 'Kemlakagede',
  },
  {
    id: '3209161005',
    districtId: '3209161',
    name: 'Dawuan',
  },
  {
    id: '3209161006',
    districtId: '3209161',
    name: 'Batembat',
  },
  {
    id: '3209161007',
    districtId: '3209161',
    name: 'Kalibaru',
  },
  {
    id: '3209161008',
    districtId: '3209161',
    name: 'Kalitengah',
  },
  {
    id: '3209162001',
    districtId: '3209162',
    name: 'Kalikoa',
  },
  {
    id: '3209162002',
    districtId: '3209162',
    name: 'Kedungdawa',
  },
  {
    id: '3209162004',
    districtId: '3209162',
    name: 'Kedungjaya',
  },
  {
    id: '3209162005',
    districtId: '3209162',
    name: 'Kedawung',
  },
  {
    id: '3209162006',
    districtId: '3209162',
    name: 'Kertawinangun',
  },
  {
    id: '3209162007',
    districtId: '3209162',
    name: 'Sutawinangun',
  },
  {
    id: '3209162008',
    districtId: '3209162',
    name: 'Pilangsari',
  },
  {
    id: '3209171001',
    districtId: '3209171',
    name: 'Adidharma',
  },
  {
    id: '3209171002',
    districtId: '3209171',
    name: 'Pasindangan',
  },
  {
    id: '3209171003',
    districtId: '3209171',
    name: 'Jadimulya',
  },
  {
    id: '3209171004',
    districtId: '3209171',
    name: 'Klayan',
  },
  {
    id: '3209171005',
    districtId: '3209171',
    name: 'Jatimerta',
  },
  {
    id: '3209171006',
    districtId: '3209171',
    name: 'Astana',
  },
  {
    id: '3209171007',
    districtId: '3209171',
    name: 'Kalisapu',
  },
  {
    id: '3209171008',
    districtId: '3209171',
    name: 'Wanakaya',
  },
  {
    id: '3209171009',
    districtId: '3209171',
    name: 'Grogol',
  },
  {
    id: '3209171010',
    districtId: '3209171',
    name: 'Babadan',
  },
  {
    id: '3209171012',
    districtId: '3209171',
    name: 'Mayung',
  },
  {
    id: '3209171013',
    districtId: '3209171',
    name: 'Sambeng',
  },
  {
    id: '3209171014',
    districtId: '3209171',
    name: 'Sirnabaya',
  },
  {
    id: '3209171015',
    districtId: '3209171',
    name: 'Mertasinga',
  },
  {
    id: '3209180010',
    districtId: '3209180',
    name: 'Bungko',
  },
  {
    id: '3209180011',
    districtId: '3209180',
    name: 'Kertasura',
  },
  {
    id: '3209180012',
    districtId: '3209180',
    name: 'Pegagan Kidul',
  },
  {
    id: '3209180015',
    districtId: '3209180',
    name: 'Pegagan Lor',
  },
  {
    id: '3209180017',
    districtId: '3209180',
    name: 'Karangkendal',
  },
  {
    id: '3209180018',
    districtId: '3209180',
    name: 'Grogol',
  },
  {
    id: '3209180020',
    districtId: '3209180',
    name: 'Kapetakan',
  },
  {
    id: '3209180021',
    districtId: '3209180',
    name: 'Bungko Lor',
  },
  {
    id: '3209181001',
    districtId: '3209181',
    name: 'Suranenggala Kulon',
  },
  {
    id: '3209181002',
    districtId: '3209181',
    name: 'Surakarta',
  },
  {
    id: '3209181003',
    districtId: '3209181',
    name: 'Keraton',
  },
  {
    id: '3209181004',
    districtId: '3209181',
    name: 'Purwawinangun',
  },
  {
    id: '3209181005',
    districtId: '3209181',
    name: 'Muara',
  },
  {
    id: '3209181006',
    districtId: '3209181',
    name: 'Karangreja',
  },
  {
    id: '3209181007',
    districtId: '3209181',
    name: 'Suranenggala Kidul',
  },
  {
    id: '3209181008',
    districtId: '3209181',
    name: 'Suranenggala Lor',
  },
  {
    id: '3209181009',
    districtId: '3209181',
    name: 'Suranenggala',
  },
  {
    id: '3209190001',
    districtId: '3209190',
    name: 'Serang',
  },
  {
    id: '3209190002',
    districtId: '3209190',
    name: 'Klangenan',
  },
  {
    id: '3209190003',
    districtId: '3209190',
    name: 'Danawinangun',
  },
  {
    id: '3209190007',
    districtId: '3209190',
    name: 'Pekantingan',
  },
  {
    id: '3209190008',
    districtId: '3209190',
    name: 'Jemaras Kidul',
  },
  {
    id: '3209190009',
    districtId: '3209190',
    name: 'Jemaras Lor',
  },
  {
    id: '3209190011',
    districtId: '3209190',
    name: 'Slangit',
  },
  {
    id: '3209190012',
    districtId: '3209190',
    name: 'Kreyo',
  },
  {
    id: '3209190013',
    districtId: '3209190',
    name: 'Bangodua',
  },
  {
    id: '3209191004',
    districtId: '3209191',
    name: 'Jamblang',
  },
  {
    id: '3209191005',
    districtId: '3209191',
    name: 'Sitiwinangun',
  },
  {
    id: '3209191006',
    districtId: '3209191',
    name: 'Wangunharja',
  },
  {
    id: '3209191014',
    districtId: '3209191',
    name: 'Bojong Wetan',
  },
  {
    id: '3209191015',
    districtId: '3209191',
    name: 'Bojong Lor',
  },
  {
    id: '3209191016',
    districtId: '3209191',
    name: 'Orimalang',
  },
  {
    id: '3209191017',
    districtId: '3209191',
    name: 'Bakung Kidul',
  },
  {
    id: '3209191018',
    districtId: '3209191',
    name: 'Bakung Lor',
  },
  {
    id: '3209200002',
    districtId: '3209200',
    name: 'Jungjang Wetan',
  },
  {
    id: '3209200010',
    districtId: '3209200',
    name: 'Jungjang',
  },
  {
    id: '3209200011',
    districtId: '3209200',
    name: 'Arjawinangun',
  },
  {
    id: '3209200012',
    districtId: '3209200',
    name: 'Tegalgubug',
  },
  {
    id: '3209200013',
    districtId: '3209200',
    name: 'Rawagatel',
  },
  {
    id: '3209200014',
    districtId: '3209200',
    name: 'Tegalgubug Lor',
  },
  {
    id: '3209200015',
    districtId: '3209200',
    name: 'Karangsambung',
  },
  {
    id: '3209200016',
    districtId: '3209200',
    name: 'Bulak',
  },
  {
    id: '3209200017',
    districtId: '3209200',
    name: 'Geyongan',
  },
  {
    id: '3209200018',
    districtId: '3209200',
    name: 'Kebonturi',
  },
  {
    id: '3209201001',
    districtId: '3209201',
    name: 'Kalianyar',
  },
  {
    id: '3209201002',
    districtId: '3209201',
    name: 'Panguragan Kulon',
  },
  {
    id: '3209201003',
    districtId: '3209201',
    name: 'Panguragan Wetan',
  },
  {
    id: '3209201004',
    districtId: '3209201',
    name: 'Panguragan Lor',
  },
  {
    id: '3209201005',
    districtId: '3209201',
    name: 'Panguragan',
  },
  {
    id: '3209201007',
    districtId: '3209201',
    name: 'Lemahtamba',
  },
  {
    id: '3209201008',
    districtId: '3209201',
    name: 'Karanganyar',
  },
  {
    id: '3209201009',
    districtId: '3209201',
    name: 'Kroya',
  },
  {
    id: '3209210004',
    districtId: '3209210',
    name: 'Ciwaringin',
  },
  {
    id: '3209210005',
    districtId: '3209210',
    name: 'Babakan',
  },
  {
    id: '3209210007',
    districtId: '3209210',
    name: 'Gintungranjeng',
  },
  {
    id: '3209210008',
    districtId: '3209210',
    name: 'Gintung Kidul',
  },
  {
    id: '3209210009',
    districtId: '3209210',
    name: 'Gintung Tengah',
  },
  {
    id: '3209210010',
    districtId: '3209210',
    name: 'Bringin',
  },
  {
    id: '3209210011',
    districtId: '3209210',
    name: 'Galagamba',
  },
  {
    id: '3209211001',
    districtId: '3209211',
    name: 'Cupang',
  },
  {
    id: '3209211002',
    districtId: '3209211',
    name: 'Cikeusal',
  },
  {
    id: '3209211003',
    districtId: '3209211',
    name: 'Walahar',
  },
  {
    id: '3209211004',
    districtId: '3209211',
    name: 'Palimanan Barat',
  },
  {
    id: '3209211005',
    districtId: '3209211',
    name: 'Gempol',
  },
  {
    id: '3209211008',
    districtId: '3209211',
    name: 'Winong',
  },
  {
    id: '3209220001',
    districtId: '3209220',
    name: 'Tangkil',
  },
  {
    id: '3209220002',
    districtId: '3209220',
    name: 'Wiyong',
  },
  {
    id: '3209220003',
    districtId: '3209220',
    name: 'Kedongdong',
  },
  {
    id: '3209220004',
    districtId: '3209220',
    name: 'Gintung Lor',
  },
  {
    id: '3209220005',
    districtId: '3209220',
    name: 'Bojong Kulon',
  },
  {
    id: '3209220006',
    districtId: '3209220',
    name: 'Kejiwan',
  },
  {
    id: '3209220007',
    districtId: '3209220',
    name: 'Susukan',
  },
  {
    id: '3209220008',
    districtId: '3209220',
    name: 'Luwung Kencana',
  },
  {
    id: '3209220010',
    districtId: '3209220',
    name: 'Jatipura',
  },
  {
    id: '3209220011',
    districtId: '3209220',
    name: 'Ujunggebang',
  },
  {
    id: '3209220012',
    districtId: '3209220',
    name: 'Jatianom',
  },
  {
    id: '3209230007',
    districtId: '3209230',
    name: 'Bayalangu Kidul',
  },
  {
    id: '3209230008',
    districtId: '3209230',
    name: 'Bayalangu Lor',
  },
  {
    id: '3209230009',
    districtId: '3209230',
    name: 'Kedungdalem',
  },
  {
    id: '3209230010',
    districtId: '3209230',
    name: 'Panunggul',
  },
  {
    id: '3209230011',
    districtId: '3209230',
    name: 'Gegesik Wetan',
  },
  {
    id: '3209230012',
    districtId: '3209230',
    name: 'Gegesik Kidul',
  },
  {
    id: '3209230016',
    districtId: '3209230',
    name: 'Slendra',
  },
  {
    id: '3209230017',
    districtId: '3209230',
    name: 'Jagapura Kidul',
  },
  {
    id: '3209230018',
    districtId: '3209230',
    name: 'Gegesik Lor',
  },
  {
    id: '3209230019',
    districtId: '3209230',
    name: 'Gegesik Kulon',
  },
  {
    id: '3209230020',
    districtId: '3209230',
    name: 'Jagapura Wetan',
  },
  {
    id: '3209230021',
    districtId: '3209230',
    name: 'Jagapura Kulon',
  },
  {
    id: '3209230022',
    districtId: '3209230',
    name: 'Jagapura Lor',
  },
  {
    id: '3209230023',
    districtId: '3209230',
    name: 'Sibubut',
  },
  {
    id: '3209231001',
    districtId: '3209231',
    name: 'Kalideres',
  },
  {
    id: '3209231002',
    districtId: '3209231',
    name: 'Prajawinangun Wetan',
  },
  {
    id: '3209231003',
    districtId: '3209231',
    name: 'Prajawinangun Kulon',
  },
  {
    id: '3209231004',
    districtId: '3209231',
    name: 'Kaliwedi Kidul',
  },
  {
    id: '3209231005',
    districtId: '3209231',
    name: 'Kaliwedi Lor',
  },
  {
    id: '3209231006',
    districtId: '3209231',
    name: 'Ujungsemi',
  },
  {
    id: '3209231007',
    districtId: '3209231',
    name: 'Wargabinangun',
  },
  {
    id: '3209231008',
    districtId: '3209231',
    name: 'Guwa Kidul',
  },
  {
    id: '3209231009',
    districtId: '3209231',
    name: 'Guwa Lor',
  },
  {
    id: '3210010001',
    districtId: '3210010',
    name: 'Cipasung',
  },
  {
    id: '3210010002',
    districtId: '3210010',
    name: 'Borogojol',
  },
  {
    id: '3210010003',
    districtId: '3210010',
    name: 'Bangbayang',
  },
  {
    id: '3210010004',
    districtId: '3210010',
    name: 'Cibulan',
  },
  {
    id: '3210010005',
    districtId: '3210010',
    name: 'Lemah Putih',
  },
  {
    id: '3210010006',
    districtId: '3210010',
    name: 'Sadawangi',
  },
  {
    id: '3210010007',
    districtId: '3210010',
    name: 'Margajaya',
  },
  {
    id: '3210010008',
    districtId: '3210010',
    name: 'Kalapadua',
  },
  {
    id: '3210010009',
    districtId: '3210010',
    name: 'Cigaleuh',
  },
  {
    id: '3210010010',
    districtId: '3210010',
    name: 'Mekarmulya',
  },
  {
    id: '3210010011',
    districtId: '3210010',
    name: 'Sinargalih',
  },
  {
    id: '3210010012',
    districtId: '3210010',
    name: 'Padarek',
  },
  {
    id: '3210010013',
    districtId: '3210010',
    name: 'Sukajadi',
  },
  {
    id: '3210010015',
    districtId: '3210010',
    name: 'Mekar Wangi',
  },
  {
    id: '3210010016',
    districtId: '3210010',
    name: 'Sukamaju',
  },
  {
    id: '3210010017',
    districtId: '3210010',
    name: 'Lemahsugih',
  },
  {
    id: '3210010018',
    districtId: '3210010',
    name: 'Dayeuhwangi',
  },
  {
    id: '3210010019',
    districtId: '3210010',
    name: 'Cisalak',
  },
  {
    id: '3210020009',
    districtId: '3210020',
    name: 'Sindanghurip',
  },
  {
    id: '3210020010',
    districtId: '3210020',
    name: 'Cipeundeuy',
  },
  {
    id: '3210020012',
    districtId: '3210020',
    name: 'Cimangguhilir',
  },
  {
    id: '3210020013',
    districtId: '3210020',
    name: 'Salawangi',
  },
  {
    id: '3210020014',
    districtId: '3210020',
    name: 'Silihwangi',
  },
  {
    id: '3210020015',
    districtId: '3210020',
    name: 'Wadowetan',
  },
  {
    id: '3210020016',
    districtId: '3210020',
    name: 'Bantarujeg',
  },
  {
    id: '3210020017',
    districtId: '3210020',
    name: 'Babakansari',
  },
  {
    id: '3210020018',
    districtId: '3210020',
    name: 'Gununglarang',
  },
  {
    id: '3210020019',
    districtId: '3210020',
    name: 'Cikidang',
  },
  {
    id: '3210020020',
    districtId: '3210020',
    name: 'Cinambo',
  },
  {
    id: '3210020021',
    districtId: '3210020',
    name: 'Haurgeulis',
  },
  {
    id: '3210020022',
    districtId: '3210020',
    name: 'Sukamenak',
  },
  {
    id: '3210021001',
    districtId: '3210021',
    name: 'Buninagara',
  },
  {
    id: '3210021002',
    districtId: '3210021',
    name: 'Werasari',
  },
  {
    id: '3210021003',
    districtId: '3210021',
    name: 'Malausma',
  },
  {
    id: '3210021004',
    districtId: '3210021',
    name: 'Banyusari',
  },
  {
    id: '3210021005',
    districtId: '3210021',
    name: 'Jagamulya',
  },
  {
    id: '3210021006',
    districtId: '3210021',
    name: 'Cimuncang',
  },
  {
    id: '3210021007',
    districtId: '3210021',
    name: 'Ciranca',
  },
  {
    id: '3210021008',
    districtId: '3210021',
    name: 'Lebakwangi',
  },
  {
    id: '3210021009',
    districtId: '3210021',
    name: 'Sukadana',
  },
  {
    id: '3210021010',
    districtId: '3210021',
    name: 'Girimukti',
  },
  {
    id: '3210021011',
    districtId: '3210021',
    name: 'Kramatjaya',
  },
  {
    id: '3210030014',
    districtId: '3210030',
    name: 'Cisoka',
  },
  {
    id: '3210030015',
    districtId: '3210030',
    name: 'Sindangpanji',
  },
  {
    id: '3210030016',
    districtId: '3210030',
    name: 'Cikijing',
  },
  {
    id: '3210030017',
    districtId: '3210030',
    name: 'Cidulang',
  },
  {
    id: '3210030018',
    districtId: '3210030',
    name: 'Sukamukti',
  },
  {
    id: '3210030019',
    districtId: '3210030',
    name: 'Kasturi',
  },
  {
    id: '3210030020',
    districtId: '3210030',
    name: 'Banjaransari',
  },
  {
    id: '3210030021',
    districtId: '3210030',
    name: 'Sindang',
  },
  {
    id: '3210030022',
    districtId: '3210030',
    name: 'Sukasari',
  },
  {
    id: '3210030023',
    districtId: '3210030',
    name: 'Sunalari',
  },
  {
    id: '3210030024',
    districtId: '3210030',
    name: 'Bagjasari',
  },
  {
    id: '3210030025',
    districtId: '3210030',
    name: 'Jagasari',
  },
  {
    id: '3210030026',
    districtId: '3210030',
    name: 'Cilangcang',
  },
  {
    id: '3210030027',
    districtId: '3210030',
    name: 'Kancana',
  },
  {
    id: '3210030028',
    districtId: '3210030',
    name: 'Cipulus',
  },
  {
    id: '3210031001',
    districtId: '3210031',
    name: 'Sedaraja',
  },
  {
    id: '3210031002',
    districtId: '3210031',
    name: 'Cintaasih',
  },
  {
    id: '3210031003',
    districtId: '3210031',
    name: 'Cidadap',
  },
  {
    id: '3210031004',
    districtId: '3210031',
    name: 'Maniis',
  },
  {
    id: '3210031005',
    districtId: '3210031',
    name: 'Rawa',
  },
  {
    id: '3210031006',
    districtId: '3210031',
    name: 'Nagarakembang',
  },
  {
    id: '3210031007',
    districtId: '3210031',
    name: 'Wangkelang',
  },
  {
    id: '3210031008',
    districtId: '3210031',
    name: 'Cimanggugirang',
  },
  {
    id: '3210031009',
    districtId: '3210031',
    name: 'Ciranjeng',
  },
  {
    id: '3210031010',
    districtId: '3210031',
    name: 'Cingambul',
  },
  {
    id: '3210031011',
    districtId: '3210031',
    name: 'Muktisari',
  },
  {
    id: '3210031012',
    districtId: '3210031',
    name: 'Cikondang',
  },
  {
    id: '3210031013',
    districtId: '3210031',
    name: 'Kondangmekar',
  },
  {
    id: '3210040001',
    districtId: '3210040',
    name: 'Margamukti',
  },
  {
    id: '3210040002',
    districtId: '3210040',
    name: 'Cibeureum',
  },
  {
    id: '3210040003',
    districtId: '3210040',
    name: 'Cikeusal',
  },
  {
    id: '3210040004',
    districtId: '3210040',
    name: 'Jatipamor',
  },
  {
    id: '3210040005',
    districtId: '3210040',
    name: 'Cicanir',
  },
  {
    id: '3210040006',
    districtId: '3210040',
    name: 'Campaga',
  },
  {
    id: '3210040007',
    districtId: '3210040',
    name: 'Lampuyang',
  },
  {
    id: '3210040008',
    districtId: '3210040',
    name: 'Mekarraharja',
  },
  {
    id: '3210040009',
    districtId: '3210040',
    name: 'Talagakulon',
  },
  {
    id: '3210040010',
    districtId: '3210040',
    name: 'Talagawetan',
  },
  {
    id: '3210040011',
    districtId: '3210040',
    name: 'Salado',
  },
  {
    id: '3210040012',
    districtId: '3210040',
    name: 'Argasari',
  },
  {
    id: '3210040013',
    districtId: '3210040',
    name: 'Gunungmanik',
  },
  {
    id: '3210040014',
    districtId: '3210040',
    name: 'Ganeas',
  },
  {
    id: '3210040015',
    districtId: '3210040',
    name: 'Sukaperna',
  },
  {
    id: '3210040016',
    districtId: '3210040',
    name: 'Kertarahayu',
  },
  {
    id: '3210040017',
    districtId: '3210040',
    name: 'Mekarhurip',
  },
  {
    id: '3210041002',
    districtId: '3210041',
    name: 'Hegarmanah',
  },
  {
    id: '3210041003',
    districtId: '3210041',
    name: 'Sindangpala',
  },
  {
    id: '3210041004',
    districtId: '3210041',
    name: 'Darmalarang',
  },
  {
    id: '3210041005',
    districtId: '3210041',
    name: 'Suniabaru',
  },
  {
    id: '3210041006',
    districtId: '3210041',
    name: 'Sangiang',
  },
  {
    id: '3210041007',
    districtId: '3210041',
    name: 'Sunia',
  },
  {
    id: '3210041008',
    districtId: '3210041',
    name: 'Kareo',
  },
  {
    id: '3210041009',
    districtId: '3210041',
    name: 'Banjaran',
  },
  {
    id: '3210041010',
    districtId: '3210041',
    name: 'Kagok',
  },
  {
    id: '3210041011',
    districtId: '3210041',
    name: 'Cimeong',
  },
  {
    id: '3210041012',
    districtId: '3210041',
    name: 'Panyindangan',
  },
  {
    id: '3210041013',
    districtId: '3210041',
    name: 'Girimulya',
  },
  {
    id: '3210050001',
    districtId: '3210050',
    name: 'Sagara',
  },
  {
    id: '3210050002',
    districtId: '3210050',
    name: 'Cibunut',
  },
  {
    id: '3210050003',
    districtId: '3210050',
    name: 'Tejamulya',
  },
  {
    id: '3210050004',
    districtId: '3210050',
    name: 'Sukasari Kidul',
  },
  {
    id: '3210050005',
    districtId: '3210050',
    name: 'Sukasari Kaler',
  },
  {
    id: '3210050006',
    districtId: '3210050',
    name: 'Sadasari',
  },
  {
    id: '3210050007',
    districtId: '3210050',
    name: 'Sukadana',
  },
  {
    id: '3210050008',
    districtId: '3210050',
    name: 'Argamukti',
  },
  {
    id: '3210050009',
    districtId: '3210050',
    name: 'Argalingga',
  },
  {
    id: '3210050010',
    districtId: '3210050',
    name: 'Haurseah',
  },
  {
    id: '3210050011',
    districtId: '3210050',
    name: 'Gunungwangi',
  },
  {
    id: '3210050012',
    districtId: '3210050',
    name: 'Mekarwangi',
  },
  {
    id: '3210050013',
    districtId: '3210050',
    name: 'Heubeulisuk',
  },
  {
    id: '3210050014',
    districtId: '3210050',
    name: 'Cikaracak',
  },
  {
    id: '3210060001',
    districtId: '3210060',
    name: 'Cihaur',
  },
  {
    id: '3210060002',
    districtId: '3210060',
    name: 'Wanahayu',
  },
  {
    id: '3210060003',
    districtId: '3210060',
    name: 'Cengal',
  },
  {
    id: '3210060004',
    districtId: '3210060',
    name: 'Anggrawati',
  },
  {
    id: '3210060005',
    districtId: '3210060',
    name: 'Cipicung',
  },
  {
    id: '3210060006',
    districtId: '3210060',
    name: 'Malongpong',
  },
  {
    id: '3210060007',
    districtId: '3210060',
    name: 'Tegalsari',
  },
  {
    id: '3210060008',
    districtId: '3210060',
    name: 'Maja Selatan',
  },
  {
    id: '3210060009',
    districtId: '3210060',
    name: 'Maja Utara',
  },
  {
    id: '3210060010',
    districtId: '3210060',
    name: 'Pasanggrahan',
  },
  {
    id: '3210060011',
    districtId: '3210060',
    name: 'Cieurih',
  },
  {
    id: '3210060012',
    districtId: '3210060',
    name: 'Kertabasuki',
  },
  {
    id: '3210060013',
    districtId: '3210060',
    name: 'Sindangkerta',
  },
  {
    id: '3210060014',
    districtId: '3210060',
    name: 'Banjaran',
  },
  {
    id: '3210060015',
    districtId: '3210060',
    name: 'Paniis',
  },
  {
    id: '3210060016',
    districtId: '3210060',
    name: 'Cicalung',
  },
  {
    id: '3210060017',
    districtId: '3210060',
    name: 'Pageraji',
  },
  {
    id: '3210060018',
    districtId: '3210060',
    name: 'Nunuk Baru',
  },
  {
    id: '3210070001',
    districtId: '3210070',
    name: 'Babakan Jawa',
  },
  {
    id: '3210070002',
    districtId: '3210070',
    name: 'Cibodas',
  },
  {
    id: '3210070004',
    districtId: '3210070',
    name: 'Kawunggirang',
  },
  {
    id: '3210070005',
    districtId: '3210070',
    name: 'Sindangkasih',
  },
  {
    id: '3210070006',
    districtId: '3210070',
    name: 'Cicurug',
  },
  {
    id: '3210070007',
    districtId: '3210070',
    name: 'Majalengka Wetan',
  },
  {
    id: '3210070008',
    districtId: '3210070',
    name: 'Tonjong',
  },
  {
    id: '3210070009',
    districtId: '3210070',
    name: 'Tarikolot',
  },
  {
    id: '3210070010',
    districtId: '3210070',
    name: 'Cikasarung',
  },
  {
    id: '3210070011',
    districtId: '3210070',
    name: 'Cijati',
  },
  {
    id: '3210070012',
    districtId: '3210070',
    name: 'Majalengka Kulon',
  },
  {
    id: '3210070014',
    districtId: '3210070',
    name: 'Sidamukti',
  },
  {
    id: '3210080001',
    districtId: '3210080',
    name: 'Kawunghilir',
  },
  {
    id: '3210080002',
    districtId: '3210080',
    name: 'Tajur',
  },
  {
    id: '3210080003',
    districtId: '3210080',
    name: 'Cigasong',
  },
  {
    id: '3210080004',
    districtId: '3210080',
    name: 'Simpeureum',
  },
  {
    id: '3210080005',
    districtId: '3210080',
    name: 'Tenjolayar',
  },
  {
    id: '3210080006',
    districtId: '3210080',
    name: 'Kutamanggu',
  },
  {
    id: '3210080007',
    districtId: '3210080',
    name: 'Cicenang',
  },
  {
    id: '3210080008',
    districtId: '3210080',
    name: 'Baribis',
  },
  {
    id: '3210080009',
    districtId: '3210080',
    name: 'Batujaya',
  },
  {
    id: '3210080010',
    districtId: '3210080',
    name: 'Karayunan',
  },
  {
    id: '3210090001',
    districtId: '3210090',
    name: 'Candrajaya',
  },
  {
    id: '3210090002',
    districtId: '3210090',
    name: 'Ciomas',
  },
  {
    id: '3210090010',
    districtId: '3210090',
    name: 'Padahanten',
  },
  {
    id: '3210090011',
    districtId: '3210090',
    name: 'Sukahaji',
  },
  {
    id: '3210090012',
    districtId: '3210090',
    name: 'Cikalong',
  },
  {
    id: '3210090013',
    districtId: '3210090',
    name: 'Babakan Manjeti',
  },
  {
    id: '3210090014',
    districtId: '3210090',
    name: 'Cikoneng',
  },
  {
    id: '3210090015',
    districtId: '3210090',
    name: 'Palabuan',
  },
  {
    id: '3210090016',
    districtId: '3210090',
    name: 'Cikeusik',
  },
  {
    id: '3210090017',
    districtId: '3210090',
    name: 'Salagedang',
  },
  {
    id: '3210090018',
    districtId: '3210090',
    name: 'Tanjungsari',
  },
  {
    id: '3210090019',
    districtId: '3210090',
    name: 'Jayi',
  },
  {
    id: '3210090020',
    districtId: '3210090',
    name: 'Nanggewer',
  },
  {
    id: '3210091001',
    districtId: '3210091',
    name: 'Pasirayu',
  },
  {
    id: '3210091002',
    districtId: '3210091',
    name: 'Garawastu',
  },
  {
    id: '3210091003',
    districtId: '3210091',
    name: 'Sangkanhurip',
  },
  {
    id: '3210091004',
    districtId: '3210091',
    name: 'Indrakila',
  },
  {
    id: '3210091005',
    districtId: '3210091',
    name: 'Sindang',
  },
  {
    id: '3210091006',
    districtId: '3210091',
    name: 'Gunung Kuning',
  },
  {
    id: '3210091007',
    districtId: '3210091',
    name: 'Bayureja',
  },
  {
    id: '3210100001',
    districtId: '3210100',
    name: 'Pajajar',
  },
  {
    id: '3210100002',
    districtId: '3210100',
    name: 'Teja',
  },
  {
    id: '3210100003',
    districtId: '3210100',
    name: 'Payung',
  },
  {
    id: '3210100004',
    districtId: '3210100',
    name: 'Sindangpano',
  },
  {
    id: '3210100005',
    districtId: '3210100',
    name: 'Babakankareo',
  },
  {
    id: '3210100006',
    districtId: '3210100',
    name: 'Sadomas',
  },
  {
    id: '3210100008',
    districtId: '3210100',
    name: 'Rajagaluh Kidul',
  },
  {
    id: '3210100009',
    districtId: '3210100',
    name: 'Singawada',
  },
  {
    id: '3210100010',
    districtId: '3210100',
    name: 'Rajagaluh',
  },
  {
    id: '3210100011',
    districtId: '3210100',
    name: 'Rajagaluh Lor',
  },
  {
    id: '3210100012',
    districtId: '3210100',
    name: 'Cipinang',
  },
  {
    id: '3210100013',
    districtId: '3210100',
    name: 'Cisetu',
  },
  {
    id: '3210110001',
    districtId: '3210110',
    name: 'Bantar Agung',
  },
  {
    id: '3210110002',
    districtId: '3210110',
    name: 'Padaherang',
  },
  {
    id: '3210110003',
    districtId: '3210110',
    name: 'Lengkongwetan',
  },
  {
    id: '3210110004',
    districtId: '3210110',
    name: 'Lengkongkulon',
  },
  {
    id: '3210110006',
    districtId: '3210110',
    name: 'Sindangwangi',
  },
  {
    id: '3210110007',
    districtId: '3210110',
    name: 'Buahkapas',
  },
  {
    id: '3210110009',
    districtId: '3210110',
    name: 'Leuwilaja',
  },
  {
    id: '3210110010',
    districtId: '3210110',
    name: 'Balagedog',
  },
  {
    id: '3210120001',
    districtId: '3210120',
    name: 'Parakan',
  },
  {
    id: '3210120002',
    districtId: '3210120',
    name: 'Lame',
  },
  {
    id: '3210120003',
    districtId: '3210120',
    name: 'Mindi',
  },
  {
    id: '3210120004',
    districtId: '3210120',
    name: 'Rajawangi',
  },
  {
    id: '3210120005',
    districtId: '3210120',
    name: 'Leuwikujang',
  },
  {
    id: '3210120006',
    districtId: '3210120',
    name: 'Nanggerang',
  },
  {
    id: '3210120007',
    districtId: '3210120',
    name: 'Patuanan',
  },
  {
    id: '3210120008',
    districtId: '3210120',
    name: 'Tanjungsari',
  },
  {
    id: '3210120009',
    districtId: '3210120',
    name: 'Karangasem',
  },
  {
    id: '3210120011',
    districtId: '3210120',
    name: 'Ciparay',
  },
  {
    id: '3210120012',
    districtId: '3210120',
    name: 'Leuwimunding',
  },
  {
    id: '3210120013',
    districtId: '3210120',
    name: 'Mirat',
  },
  {
    id: '3210120014',
    districtId: '3210120',
    name: 'Parungjaya',
  },
  {
    id: '3210130001',
    districtId: '3210130',
    name: 'Weragati',
  },
  {
    id: '3210130002',
    districtId: '3210130',
    name: 'Trajaya',
  },
  {
    id: '3210130003',
    districtId: '3210130',
    name: 'Tarikolot',
  },
  {
    id: '3210130004',
    districtId: '3210130',
    name: 'Sindanghaji',
  },
  {
    id: '3210130005',
    districtId: '3210130',
    name: 'Enggalwangi',
  },
  {
    id: '3210130006',
    districtId: '3210130',
    name: 'Buniwangi',
  },
  {
    id: '3210130007',
    districtId: '3210130',
    name: 'Palasah',
  },
  {
    id: '3210130008',
    districtId: '3210130',
    name: 'Pasir',
  },
  {
    id: '3210130009',
    districtId: '3210130',
    name: 'Waringin',
  },
  {
    id: '3210130010',
    districtId: '3210130',
    name: 'Karamat',
  },
  {
    id: '3210130011',
    districtId: '3210130',
    name: 'Sindangwasa',
  },
  {
    id: '3210130012',
    districtId: '3210130',
    name: 'Cisambeng',
  },
  {
    id: '3210130013',
    districtId: '3210130',
    name: 'Majasuka',
  },
  {
    id: '3210140001',
    districtId: '3210140',
    name: 'Pinangraja',
  },
  {
    id: '3210140002',
    districtId: '3210140',
    name: 'Sukaraja Kulon',
  },
  {
    id: '3210140003',
    districtId: '3210140',
    name: 'Sukaraja Wetan',
  },
  {
    id: '3210140004',
    districtId: '3210140',
    name: 'Cibentar',
  },
  {
    id: '3210140006',
    districtId: '3210140',
    name: 'Andir',
  },
  {
    id: '3210140007',
    districtId: '3210140',
    name: 'Cicadas',
  },
  {
    id: '3210140008',
    districtId: '3210140',
    name: 'Burujul Wetan',
  },
  {
    id: '3210140009',
    districtId: '3210140',
    name: 'Burujul Kulon',
  },
  {
    id: '3210140010',
    districtId: '3210140',
    name: 'Mekarsari',
  },
  {
    id: '3210140011',
    districtId: '3210140',
    name: 'Jatiwangi',
  },
  {
    id: '3210140012',
    districtId: '3210140',
    name: 'Surawangi',
  },
  {
    id: '3210140013',
    districtId: '3210140',
    name: 'Jatisura',
  },
  {
    id: '3210140014',
    districtId: '3210140',
    name: 'Sutawangi',
  },
  {
    id: '3210140015',
    districtId: '3210140',
    name: 'Ciborelang',
  },
  {
    id: '3210140016',
    districtId: '3210140',
    name: 'Loji',
  },
  {
    id: '3210150011',
    districtId: '3210150',
    name: 'Bojongcideres',
  },
  {
    id: '3210150012',
    districtId: '3210150',
    name: 'Dawuan',
  },
  {
    id: '3210150014',
    districtId: '3210150',
    name: 'Gandu',
  },
  {
    id: '3210150015',
    districtId: '3210150',
    name: 'Sinarjati',
  },
  {
    id: '3210150016',
    districtId: '3210150',
    name: 'Baturuyuk',
  },
  {
    id: '3210150017',
    districtId: '3210150',
    name: 'Mandapa',
  },
  {
    id: '3210150018',
    districtId: '3210150',
    name: 'Balida',
  },
  {
    id: '3210150019',
    districtId: '3210150',
    name: 'Pasirmalati',
  },
  {
    id: '3210150020',
    districtId: '3210150',
    name: 'Karanganyar',
  },
  {
    id: '3210150021',
    districtId: '3210150',
    name: 'Salawana',
  },
  {
    id: '3210151001',
    districtId: '3210151',
    name: 'Jatisawit',
  },
  {
    id: '3210151002',
    districtId: '3210151',
    name: 'Leuwikidang',
  },
  {
    id: '3210151003',
    districtId: '3210151',
    name: 'Girimukti',
  },
  {
    id: '3210151004',
    districtId: '3210151',
    name: 'Jatimulya',
  },
  {
    id: '3210151005',
    districtId: '3210151',
    name: 'Wanajaya',
  },
  {
    id: '3210151006',
    districtId: '3210151',
    name: 'Ranjiwetan',
  },
  {
    id: '3210151007',
    districtId: '3210151',
    name: 'Ranjikulon',
  },
  {
    id: '3210151008',
    districtId: '3210151',
    name: 'Gunungsari',
  },
  {
    id: '3210151009',
    districtId: '3210151',
    name: 'Kasokandel',
  },
  {
    id: '3210151010',
    districtId: '3210151',
    name: 'Gandasari',
  },
  {
    id: '3210160001',
    districtId: '3210160',
    name: 'Cijurey',
  },
  {
    id: '3210160002',
    districtId: '3210160',
    name: 'Pasirmuncang',
  },
  {
    id: '3210160003',
    districtId: '3210160',
    name: 'Jatipamor',
  },
  {
    id: '3210160004',
    districtId: '3210160',
    name: 'Bantrangsana',
  },
  {
    id: '3210160005',
    districtId: '3210160',
    name: 'Jatiserang',
  },
  {
    id: '3210160006',
    districtId: '3210160',
    name: 'Bonang',
  },
  {
    id: '3210160007',
    districtId: '3210160',
    name: 'Leuwiseeng',
  },
  {
    id: '3210160008',
    districtId: '3210160',
    name: 'Karyamukti',
  },
  {
    id: '3210160009',
    districtId: '3210160',
    name: 'Panyingkiran',
  },
  {
    id: '3210170001',
    districtId: '3210170',
    name: 'Liangjulang',
  },
  {
    id: '3210170003',
    districtId: '3210170',
    name: 'Cipaku',
  },
  {
    id: '3210170004',
    districtId: '3210170',
    name: 'Kadipaten',
  },
  {
    id: '3210170005',
    districtId: '3210170',
    name: 'Babakan Anyar',
  },
  {
    id: '3210170006',
    districtId: '3210170',
    name: 'Karangsambung',
  },
  {
    id: '3210170007',
    districtId: '3210170',
    name: 'Pagandon',
  },
  {
    id: '3210180001',
    districtId: '3210180',
    name: 'Mekarjaya',
  },
  {
    id: '3210180002',
    districtId: '3210180',
    name: 'Palasah',
  },
  {
    id: '3210180003',
    districtId: '3210180',
    name: 'Pakubeureum',
  },
  {
    id: '3210180004',
    districtId: '3210180',
    name: 'Sukawana',
  },
  {
    id: '3210180005',
    districtId: '3210180',
    name: 'Kertawinangun',
  },
  {
    id: '3210180006',
    districtId: '3210180',
    name: 'Babakan',
  },
  {
    id: '3210180007',
    districtId: '3210180',
    name: 'Kertajati',
  },
  {
    id: '3210180008',
    districtId: '3210180',
    name: 'Kertasari',
  },
  {
    id: '3210180009',
    districtId: '3210180',
    name: 'Mekarmulya',
  },
  {
    id: '3210180010',
    districtId: '3210180',
    name: 'Sukamulya',
  },
  {
    id: '3210180011',
    districtId: '3210180',
    name: 'Bantarjati',
  },
  {
    id: '3210180012',
    districtId: '3210180',
    name: 'Pasiripis',
  },
  {
    id: '3210180013',
    districtId: '3210180',
    name: 'Sukakerta',
  },
  {
    id: '3210180014',
    districtId: '3210180',
    name: 'Sahbandar',
  },
  {
    id: '3210190001',
    districtId: '3210190',
    name: 'Biyawak',
  },
  {
    id: '3210190002',
    districtId: '3210190',
    name: 'Pasindangan',
  },
  {
    id: '3210190003',
    districtId: '3210190',
    name: 'Panongan',
  },
  {
    id: '3210190004',
    districtId: '3210190',
    name: 'Panyingkiran',
  },
  {
    id: '3210190005',
    districtId: '3210190',
    name: 'Randegan Kulon',
  },
  {
    id: '3210190006',
    districtId: '3210190',
    name: 'Randegan Wetan',
  },
  {
    id: '3210190007',
    districtId: '3210190',
    name: 'Putridalem',
  },
  {
    id: '3210190008',
    districtId: '3210190',
    name: 'Jatitengah',
  },
  {
    id: '3210190009',
    districtId: '3210190',
    name: 'Jatitujuh',
  },
  {
    id: '3210190010',
    districtId: '3210190',
    name: 'Babajurang',
  },
  {
    id: '3210190011',
    districtId: '3210190',
    name: 'Pilangsari',
  },
  {
    id: '3210190012',
    districtId: '3210190',
    name: 'Jatiraga',
  },
  {
    id: '3210190013',
    districtId: '3210190',
    name: 'Sumber Kulon',
  },
  {
    id: '3210190014',
    districtId: '3210190',
    name: 'Sumber Wetan',
  },
  {
    id: '3210190015',
    districtId: '3210190',
    name: 'Pangkalanpari',
  },
  {
    id: '3210200001',
    districtId: '3210200',
    name: 'Cibogor',
  },
  {
    id: '3210200002',
    districtId: '3210200',
    name: 'Kertasari',
  },
  {
    id: '3210200003',
    districtId: '3210200',
    name: 'Gandawesi',
  },
  {
    id: '3210200004',
    districtId: '3210200',
    name: 'Beusi',
  },
  {
    id: '3210200005',
    districtId: '3210200',
    name: 'Tegalaren',
  },
  {
    id: '3210200008',
    districtId: '3210200',
    name: 'Wanasalam',
  },
  {
    id: '3210200009',
    districtId: '3210200',
    name: 'Ligung Lor',
  },
  {
    id: '3210200010',
    districtId: '3210200',
    name: 'Ligung',
  },
  {
    id: '3210200011',
    districtId: '3210200',
    name: 'Majasari',
  },
  {
    id: '3210200012',
    districtId: '3210200',
    name: 'Sukawera',
  },
  {
    id: '3210200013',
    districtId: '3210200',
    name: 'Bantarwaru',
  },
  {
    id: '3210200014',
    districtId: '3210200',
    name: 'Ampel',
  },
  {
    id: '3210200015',
    districtId: '3210200',
    name: 'Leuweunghapit',
  },
  {
    id: '3210200016',
    districtId: '3210200',
    name: 'Kodasari',
  },
  {
    id: '3210200017',
    districtId: '3210200',
    name: 'Kedungkancana',
  },
  {
    id: '3210200018',
    districtId: '3210200',
    name: 'Leuwiliang Baru',
  },
  {
    id: '3210200019',
    districtId: '3210200',
    name: 'Kedungsari',
  },
  {
    id: '3210210001',
    districtId: '3210210',
    name: 'Sumberjaya',
  },
  {
    id: '3210210002',
    districtId: '3210210',
    name: 'Garawangi',
  },
  {
    id: '3210210003',
    districtId: '3210210',
    name: 'Banjaran',
  },
  {
    id: '3210210004',
    districtId: '3210210',
    name: 'Sepat',
  },
  {
    id: '3210210005',
    districtId: '3210210',
    name: 'Paningkiran',
  },
  {
    id: '3210210006',
    districtId: '3210210',
    name: 'Parapatan',
  },
  {
    id: '3210210007',
    districtId: '3210210',
    name: 'Panjalin Kidul',
  },
  {
    id: '3210210008',
    districtId: '3210210',
    name: 'Rancaputat',
  },
  {
    id: '3210210009',
    districtId: '3210210',
    name: 'Bongas Wetan',
  },
  {
    id: '3210210010',
    districtId: '3210210',
    name: 'Bongas Kulon',
  },
  {
    id: '3210210011',
    districtId: '3210210',
    name: 'Panjalin Lor',
  },
  {
    id: '3210210012',
    districtId: '3210210',
    name: 'Cidenok',
  },
  {
    id: '3210210013',
    districtId: '3210210',
    name: 'Loji Kobong',
  },
  {
    id: '3210210014',
    districtId: '3210210',
    name: 'Gelokmulya',
  },
  {
    id: '3210210015',
    districtId: '3210210',
    name: 'Pancaksuji',
  },
  {
    id: '3211010001',
    districtId: '3211010',
    name: 'Cipacing',
  },
  {
    id: '3211010002',
    districtId: '3211010',
    name: 'Sayang',
  },
  {
    id: '3211010003',
    districtId: '3211010',
    name: 'Mekargalih',
  },
  {
    id: '3211010004',
    districtId: '3211010',
    name: 'Cinta Mulya',
  },
  {
    id: '3211010005',
    districtId: '3211010',
    name: 'Cisempur',
  },
  {
    id: '3211010006',
    districtId: '3211010',
    name: 'Jatimukti',
  },
  {
    id: '3211010007',
    districtId: '3211010',
    name: 'Jatiroke',
  },
  {
    id: '3211010008',
    districtId: '3211010',
    name: 'Hegarmanah',
  },
  {
    id: '3211010009',
    districtId: '3211010',
    name: 'Cikeruh',
  },
  {
    id: '3211010010',
    districtId: '3211010',
    name: 'Cibeusi',
  },
  {
    id: '3211010011',
    districtId: '3211010',
    name: 'Cileles',
  },
  {
    id: '3211010012',
    districtId: '3211010',
    name: 'Cilayung',
  },
  {
    id: '3211020001',
    districtId: '3211020',
    name: 'Mangunarga',
  },
  {
    id: '3211020002',
    districtId: '3211020',
    name: 'Sawahdadap',
  },
  {
    id: '3211020003',
    districtId: '3211020',
    name: 'Sukadana',
  },
  {
    id: '3211020004',
    districtId: '3211020',
    name: 'Cihanjuang',
  },
  {
    id: '3211020005',
    districtId: '3211020',
    name: 'Cikahuripan',
  },
  {
    id: '3211020006',
    districtId: '3211020',
    name: 'Sindanggalih',
  },
  {
    id: '3211020007',
    districtId: '3211020',
    name: 'Sindangpakuon',
  },
  {
    id: '3211020008',
    districtId: '3211020',
    name: 'Cimanggung',
  },
  {
    id: '3211020009',
    districtId: '3211020',
    name: 'Tegalmanggung',
  },
  {
    id: '3211020010',
    districtId: '3211020',
    name: 'Sindulang',
  },
  {
    id: '3211020011',
    districtId: '3211020',
    name: 'Pasirnanjung',
  },
  {
    id: '3211030001',
    districtId: '3211030',
    name: 'Cinanjung',
  },
  {
    id: '3211030002',
    districtId: '3211030',
    name: 'Raharja',
  },
  {
    id: '3211030008',
    districtId: '3211030',
    name: 'Gunungmanik',
  },
  {
    id: '3211030009',
    districtId: '3211030',
    name: 'Marga Jaya',
  },
  {
    id: '3211030010',
    districtId: '3211030',
    name: 'Tanjungsari',
  },
  {
    id: '3211030011',
    districtId: '3211030',
    name: 'Jatisari',
  },
  {
    id: '3211030012',
    districtId: '3211030',
    name: 'Kutamandiri',
  },
  {
    id: '3211030014',
    districtId: '3211030',
    name: 'Margaluyu',
  },
  {
    id: '3211030015',
    districtId: '3211030',
    name: 'Gudang',
  },
  {
    id: '3211030018',
    districtId: '3211030',
    name: 'Pasigaran',
  },
  {
    id: '3211030025',
    districtId: '3211030',
    name: 'Kadakajaya',
  },
  {
    id: '3211030027',
    districtId: '3211030',
    name: 'Cijambu',
  },
  {
    id: '3211031001',
    districtId: '3211031',
    name: 'Sukarapih',
  },
  {
    id: '3211031002',
    districtId: '3211031',
    name: 'Sukasari',
  },
  {
    id: '3211031003',
    districtId: '3211031',
    name: 'Mekarsari',
  },
  {
    id: '3211031004',
    districtId: '3211031',
    name: 'Sindangsari',
  },
  {
    id: '3211031005',
    districtId: '3211031',
    name: 'Nanggerang',
  },
  {
    id: '3211031006',
    districtId: '3211031',
    name: 'Banyuresmi',
  },
  {
    id: '3211032001',
    districtId: '3211032',
    name: 'Mekarbakti',
  },
  {
    id: '3211032002',
    districtId: '3211032',
    name: 'Cilembu',
  },
  {
    id: '3211032003',
    districtId: '3211032',
    name: 'Cimarias',
  },
  {
    id: '3211032004',
    districtId: '3211032',
    name: 'Cinanggerang',
  },
  {
    id: '3211032005',
    districtId: '3211032',
    name: 'Cijeruk',
  },
  {
    id: '3211032006',
    districtId: '3211032',
    name: 'Cigendel',
  },
  {
    id: '3211032007',
    districtId: '3211032',
    name: 'Haurngombong',
  },
  {
    id: '3211032008',
    districtId: '3211032',
    name: 'Ciptasari',
  },
  {
    id: '3211032009',
    districtId: '3211032',
    name: 'Citali',
  },
  {
    id: '3211032010',
    districtId: '3211032',
    name: 'Pamulihan',
  },
  {
    id: '3211032011',
    districtId: '3211032',
    name: 'Sukawangi',
  },
  {
    id: '3211040002',
    districtId: '3211040',
    name: 'Sukasirnarasa',
  },
  {
    id: '3211040006',
    districtId: '3211040',
    name: 'Pasir Biru',
  },
  {
    id: '3211040007',
    districtId: '3211040',
    name: 'Rancakalong',
  },
  {
    id: '3211040008',
    districtId: '3211040',
    name: 'Pamekaran',
  },
  {
    id: '3211040009',
    districtId: '3211040',
    name: 'Sukamaju',
  },
  {
    id: '3211040010',
    districtId: '3211040',
    name: 'Sukahayu',
  },
  {
    id: '3211040011',
    districtId: '3211040',
    name: 'Nagarawangi',
  },
  {
    id: '3211040012',
    districtId: '3211040',
    name: 'Cibunar',
  },
  {
    id: '3211040013',
    districtId: '3211040',
    name: 'Pangadegan',
  },
  {
    id: '3211040014',
    districtId: '3211040',
    name: 'Cibungur',
  },
  {
    id: '3211050001',
    districtId: '3211050',
    name: 'Sukajaya',
  },
  {
    id: '3211050002',
    districtId: '3211050',
    name: 'Margamekar',
  },
  {
    id: '3211050003',
    districtId: '3211050',
    name: 'Cipancar',
  },
  {
    id: '3211050004',
    districtId: '3211050',
    name: 'Citengah',
  },
  {
    id: '3211050007',
    districtId: '3211050',
    name: 'Gunasari',
  },
  {
    id: '3211050008',
    districtId: '3211050',
    name: 'Baginda',
  },
  {
    id: '3211050009',
    districtId: '3211050',
    name: 'Sukagalih',
  },
  {
    id: '3211050010',
    districtId: '3211050',
    name: 'Cipameungpeuk',
  },
  {
    id: '3211050011',
    districtId: '3211050',
    name: 'Regol Wetan',
  },
  {
    id: '3211050012',
    districtId: '3211050',
    name: 'Kotakulon',
  },
  {
    id: '3211050013',
    districtId: '3211050',
    name: 'Pasanggrahan Baru',
  },
  {
    id: '3211050014',
    districtId: '3211050',
    name: 'Ciherang',
  },
  {
    id: '3211050015',
    districtId: '3211050',
    name: 'Mekarrahayu',
  },
  {
    id: '3211050016',
    districtId: '3211050',
    name: 'Margalaksana',
  },
  {
    id: '3211060001',
    districtId: '3211060',
    name: 'Sirnamulya',
  },
  {
    id: '3211060002',
    districtId: '3211060',
    name: 'Girimukti',
  },
  {
    id: '3211060003',
    districtId: '3211060',
    name: 'Mulyasari',
  },
  {
    id: '3211060004',
    districtId: '3211060',
    name: 'Padasuka',
  },
  {
    id: '3211060005',
    districtId: '3211060',
    name: 'Margamukti',
  },
  {
    id: '3211060006',
    districtId: '3211060',
    name: 'Mekarjaya',
  },
  {
    id: '3211060007',
    districtId: '3211060',
    name: 'Jatimulya',
  },
  {
    id: '3211060008',
    districtId: '3211060',
    name: 'Jatihurip',
  },
  {
    id: '3211060009',
    districtId: '3211060',
    name: 'Kebonjati',
  },
  {
    id: '3211060010',
    districtId: '3211060',
    name: 'Situ',
  },
  {
    id: '3211060011',
    districtId: '3211060',
    name: 'Kotakaler',
  },
  {
    id: '3211060012',
    districtId: '3211060',
    name: 'Talun',
  },
  {
    id: '3211060013',
    districtId: '3211060',
    name: 'Rancamulya',
  },
  {
    id: '3211061001',
    districtId: '3211061',
    name: 'Cikondang',
  },
  {
    id: '3211061002',
    districtId: '3211061',
    name: 'Tanjunghurip',
  },
  {
    id: '3211061003',
    districtId: '3211061',
    name: 'Dayeuh Luhur',
  },
  {
    id: '3211061004',
    districtId: '3211061',
    name: 'Cikoneng',
  },
  {
    id: '3211061005',
    districtId: '3211061',
    name: 'Sukawening',
  },
  {
    id: '3211061006',
    districtId: '3211061',
    name: 'Ganeas',
  },
  {
    id: '3211061007',
    districtId: '3211061',
    name: 'Sukaluyu',
  },
  {
    id: '3211061008',
    districtId: '3211061',
    name: 'Cikoneng Kulon',
  },
  {
    id: '3211070001',
    districtId: '3211070',
    name: 'Bangbayang',
  },
  {
    id: '3211070002',
    districtId: '3211070',
    name: 'Kaduwulung',
  },
  {
    id: '3211070011',
    districtId: '3211070',
    name: 'Cijati',
  },
  {
    id: '3211070012',
    districtId: '3211070',
    name: 'Mekarmulya',
  },
  {
    id: '3211070013',
    districtId: '3211070',
    name: 'Cikadu',
  },
  {
    id: '3211070014',
    districtId: '3211070',
    name: 'Karangheuleut',
  },
  {
    id: '3211070015',
    districtId: '3211070',
    name: 'Cijeler',
  },
  {
    id: '3211070016',
    districtId: '3211070',
    name: 'Ambit',
  },
  {
    id: '3211070017',
    districtId: '3211070',
    name: 'Sukatali',
  },
  {
    id: '3211070018',
    districtId: '3211070',
    name: 'Situraja',
  },
  {
    id: '3211070019',
    districtId: '3211070',
    name: 'Jatimekar',
  },
  {
    id: '3211070020',
    districtId: '3211070',
    name: 'Situraja Utara',
  },
  {
    id: '3211070021',
    districtId: '3211070',
    name: 'Malaka',
  },
  {
    id: '3211070022',
    districtId: '3211070',
    name: 'Pamulihan',
  },
  {
    id: '3211070023',
    districtId: '3211070',
    name: 'Cicarimanah',
  },
  {
    id: '3211071001',
    districtId: '3211071',
    name: 'Sundamekar',
  },
  {
    id: '3211071002',
    districtId: '3211071',
    name: 'Cimarga',
  },
  {
    id: '3211071003',
    districtId: '3211071',
    name: 'Cinangsi',
  },
  {
    id: '3211071004',
    districtId: '3211071',
    name: 'Linggajaya',
  },
  {
    id: '3211071005',
    districtId: '3211071',
    name: 'Situmekar',
  },
  {
    id: '3211071006',
    districtId: '3211071',
    name: 'Cisitu',
  },
  {
    id: '3211071007',
    districtId: '3211071',
    name: 'Cigintung',
  },
  {
    id: '3211071008',
    districtId: '3211071',
    name: 'Ranjeng',
  },
  {
    id: '3211071009',
    districtId: '3211071',
    name: 'Cilopang',
  },
  {
    id: '3211071010',
    districtId: '3211071',
    name: 'Pajagan',
  },
  {
    id: '3211080003',
    districtId: '3211080',
    name: 'Neglasari',
  },
  {
    id: '3211080004',
    districtId: '3211080',
    name: 'Sukamenak',
  },
  {
    id: '3211080005',
    districtId: '3211080',
    name: 'Jatibungur',
  },
  {
    id: '3211080006',
    districtId: '3211080',
    name: 'Darmajaya',
  },
  {
    id: '3211080007',
    districtId: '3211080',
    name: 'Darmaraja',
  },
  {
    id: '3211080008',
    districtId: '3211080',
    name: 'Cipeuteuy',
  },
  {
    id: '3211080011',
    districtId: '3211080',
    name: 'Cikeusi',
  },
  {
    id: '3211080012',
    districtId: '3211080',
    name: 'Cieunteung',
  },
  {
    id: '3211080013',
    districtId: '3211080',
    name: 'Tarunajaya',
  },
  {
    id: '3211080014',
    districtId: '3211080',
    name: 'Sukaratu',
  },
  {
    id: '3211080015',
    districtId: '3211080',
    name: 'Leuwihideung',
  },
  {
    id: '3211080016',
    districtId: '3211080',
    name: 'Cibogo',
  },
  {
    id: '3211080017',
    districtId: '3211080',
    name: 'Cipaku',
  },
  {
    id: '3211080018',
    districtId: '3211080',
    name: 'Karang Pakuan',
  },
  {
    id: '3211080019',
    districtId: '3211080',
    name: 'Paku Alam',
  },
  {
    id: '3211080020',
    districtId: '3211080',
    name: 'Ranggon',
  },
  {
    id: '3211090001',
    districtId: '3211090',
    name: 'Buana Mekar',
  },
  {
    id: '3211090002',
    districtId: '3211090',
    name: 'Jaya Mekar',
  },
  {
    id: '3211090003',
    districtId: '3211090',
    name: 'Cibugel',
  },
  {
    id: '3211090004',
    districtId: '3211090',
    name: 'Tamansari',
  },
  {
    id: '3211090005',
    districtId: '3211090',
    name: 'Sukaraja',
  },
  {
    id: '3211090006',
    districtId: '3211090',
    name: 'Cipasang',
  },
  {
    id: '3211090007',
    districtId: '3211090',
    name: 'Jayamandiri',
  },
  {
    id: '3211100001',
    districtId: '3211100',
    name: 'Cilengkrang',
  },
  {
    id: '3211100002',
    districtId: '3211100',
    name: 'Sukajadi',
  },
  {
    id: '3211100003',
    districtId: '3211100',
    name: 'Ganjaresik',
  },
  {
    id: '3211100004',
    districtId: '3211100',
    name: 'Cimungkal',
  },
  {
    id: '3211100011',
    districtId: '3211100',
    name: 'Mulyajaya',
  },
  {
    id: '3211100012',
    districtId: '3211100',
    name: 'Cikareo Selatan',
  },
  {
    id: '3211100013',
    districtId: '3211100',
    name: 'Cikareo Utara',
  },
  {
    id: '3211100014',
    districtId: '3211100',
    name: 'Wado',
  },
  {
    id: '3211100015',
    districtId: '3211100',
    name: 'Padajaya',
  },
  {
    id: '3211100016',
    districtId: '3211100',
    name: 'Sukapura',
  },
  {
    id: '3211100017',
    districtId: '3211100',
    name: 'Cisurat',
  },
  {
    id: '3211101001',
    districtId: '3211101',
    name: 'Kirisik',
  },
  {
    id: '3211101002',
    districtId: '3211101',
    name: 'Cipeundeuy',
  },
  {
    id: '3211101003',
    districtId: '3211101',
    name: 'Cimanintin',
  },
  {
    id: '3211101004',
    districtId: '3211101',
    name: 'Sukamanah',
  },
  {
    id: '3211101005',
    districtId: '3211101',
    name: 'Banjarsari',
  },
  {
    id: '3211101006',
    districtId: '3211101',
    name: 'Sarimekar',
  },
  {
    id: '3211101007',
    districtId: '3211101',
    name: 'Tarikolot',
  },
  {
    id: '3211101008',
    districtId: '3211101',
    name: 'Sirnasari',
  },
  {
    id: '3211101009',
    districtId: '3211101',
    name: 'Pawenang',
  },
  {
    id: '3211111001',
    districtId: '3211111',
    name: 'Sukakersa',
  },
  {
    id: '3211111002',
    districtId: '3211111',
    name: 'Mekarasih',
  },
  {
    id: '3211111003',
    districtId: '3211111',
    name: 'Ciranggem',
  },
  {
    id: '3211111004',
    districtId: '3211111',
    name: 'Cisampih',
  },
  {
    id: '3211111006',
    districtId: '3211111',
    name: 'Kadu',
  },
  {
    id: '3211111007',
    districtId: '3211111',
    name: 'Lebaksiuh',
  },
  {
    id: '3211111008',
    districtId: '3211111',
    name: 'Cintajaya',
  },
  {
    id: '3211111009',
    districtId: '3211111',
    name: 'Cipicung',
  },
  {
    id: '3211111010',
    districtId: '3211111',
    name: 'Jemah',
  },
  {
    id: '3211111011',
    districtId: '3211111',
    name: 'Cijeungjing',
  },
  {
    id: '3211111012',
    districtId: '3211111',
    name: 'Kadujaya',
  },
  {
    id: '3211111013',
    districtId: '3211111',
    name: 'Karedok',
  },
  {
    id: '3211120003',
    districtId: '3211120',
    name: 'Cipeles',
  },
  {
    id: '3211120004',
    districtId: '3211120',
    name: 'Darmawangi',
  },
  {
    id: '3211120005',
    districtId: '3211120',
    name: 'Jembarwangi',
  },
  {
    id: '3211120006',
    districtId: '3211120',
    name: 'Marongge',
  },
  {
    id: '3211120007',
    districtId: '3211120',
    name: 'Tolengas',
  },
  {
    id: '3211120008',
    districtId: '3211120',
    name: 'Tomo',
  },
  {
    id: '3211120009',
    districtId: '3211120',
    name: 'Karyamukti',
  },
  {
    id: '3211120011',
    districtId: '3211120',
    name: 'Mekarwangi',
  },
  {
    id: '3211130001',
    districtId: '3211130',
    name: 'Cipelang',
  },
  {
    id: '3211130002',
    districtId: '3211130',
    name: 'Palabuan',
  },
  {
    id: '3211130003',
    districtId: '3211130',
    name: 'Kebon Cau',
  },
  {
    id: '3211130004',
    districtId: '3211130',
    name: 'Kudangwangi',
  },
  {
    id: '3211130005',
    districtId: '3211130',
    name: 'Sukamulya',
  },
  {
    id: '3211130006',
    districtId: '3211130',
    name: 'Palasari',
  },
  {
    id: '3211130007',
    districtId: '3211130',
    name: 'Ujungjaya',
  },
  {
    id: '3211130008',
    districtId: '3211130',
    name: 'Sakurjaya',
  },
  {
    id: '3211130009',
    districtId: '3211130',
    name: 'Cibuluh',
  },
  {
    id: '3211140001',
    districtId: '3211140',
    name: 'Narimbang',
  },
  {
    id: '3211140002',
    districtId: '3211140',
    name: 'Jambu',
  },
  {
    id: '3211140003',
    districtId: '3211140',
    name: 'Cipamekar',
  },
  {
    id: '3211140004',
    districtId: '3211140',
    name: 'Conggeang Kulon',
  },
  {
    id: '3211140005',
    districtId: '3211140',
    name: 'Conggeang Wetan',
  },
  {
    id: '3211140006',
    districtId: '3211140',
    name: 'Cibeureuyeuh',
  },
  {
    id: '3211140007',
    districtId: '3211140',
    name: 'Padaasih',
  },
  {
    id: '3211140008',
    districtId: '3211140',
    name: 'Babakan Asem',
  },
  {
    id: '3211140009',
    districtId: '3211140',
    name: 'Ungkal',
  },
  {
    id: '3211140010',
    districtId: '3211140',
    name: 'Cacaban',
  },
  {
    id: '3211140011',
    districtId: '3211140',
    name: 'Karanglayung',
  },
  {
    id: '3211140012',
    districtId: '3211140',
    name: 'Cibubuan',
  },
  {
    id: '3211150001',
    districtId: '3211150',
    name: 'Legok Kaler',
  },
  {
    id: '3211150002',
    districtId: '3211150',
    name: 'Legok Kidul',
  },
  {
    id: '3211150003',
    districtId: '3211150',
    name: 'Paseh Kidul',
  },
  {
    id: '3211150004',
    districtId: '3211150',
    name: 'Cijambe',
  },
  {
    id: '3211150005',
    districtId: '3211150',
    name: 'Pasireungit',
  },
  {
    id: '3211150006',
    districtId: '3211150',
    name: 'Padanaan',
  },
  {
    id: '3211150007',
    districtId: '3211150',
    name: 'Bongkok',
  },
  {
    id: '3211150008',
    districtId: '3211150',
    name: 'Paseh Kaler',
  },
  {
    id: '3211150009',
    districtId: '3211150',
    name: 'Haurkuning',
  },
  {
    id: '3211150010',
    districtId: '3211150',
    name: 'Citepok',
  },
  {
    id: '3211160001',
    districtId: '3211160',
    name: 'Cimuja',
  },
  {
    id: '3211160011',
    districtId: '3211160',
    name: 'Cibeureum Wetan',
  },
  {
    id: '3211160012',
    districtId: '3211160',
    name: 'Cibeureum Kulon',
  },
  {
    id: '3211160013',
    districtId: '3211160',
    name: 'Mandalaherang',
  },
  {
    id: '3211160014',
    districtId: '3211160',
    name: 'Cimalaka',
  },
  {
    id: '3211160015',
    districtId: '3211160',
    name: 'Serang',
  },
  {
    id: '3211160016',
    districtId: '3211160',
    name: 'Galudra',
  },
  {
    id: '3211160017',
    districtId: '3211160',
    name: 'Cikole',
  },
  {
    id: '3211160018',
    districtId: '3211160',
    name: 'Trunamanggala',
  },
  {
    id: '3211160019',
    districtId: '3211160',
    name: 'Nyalindung',
  },
  {
    id: '3211160020',
    districtId: '3211160',
    name: 'Naluk',
  },
  {
    id: '3211160021',
    districtId: '3211160',
    name: 'Citimun',
  },
  {
    id: '3211160022',
    districtId: '3211160',
    name: 'Licin',
  },
  {
    id: '3211160023',
    districtId: '3211160',
    name: 'Padasari',
  },
  {
    id: '3211161001',
    districtId: '3211161',
    name: 'Cisalak',
  },
  {
    id: '3211161002',
    districtId: '3211161',
    name: 'Kebonkalapa',
  },
  {
    id: '3211161003',
    districtId: '3211161',
    name: 'Cisarua',
  },
  {
    id: '3211161004',
    districtId: '3211161',
    name: 'Bantarmara',
  },
  {
    id: '3211161005',
    districtId: '3211161',
    name: 'Ciuyah',
  },
  {
    id: '3211161006',
    districtId: '3211161',
    name: 'Cimara',
  },
  {
    id: '3211161007',
    districtId: '3211161',
    name: 'Cipandanwangi',
  },
  {
    id: '3211170003',
    districtId: '3211170',
    name: 'Tanjungmekar',
  },
  {
    id: '3211170004',
    districtId: '3211170',
    name: 'Cigentur',
  },
  {
    id: '3211170005',
    districtId: '3211170',
    name: 'Gunturmekar',
  },
  {
    id: '3211170006',
    districtId: '3211170',
    name: 'Cipanas',
  },
  {
    id: '3211170007',
    districtId: '3211170',
    name: 'Banyuasih',
  },
  {
    id: '3211170008',
    districtId: '3211170',
    name: 'Mulyamekar',
  },
  {
    id: '3211170009',
    districtId: '3211170',
    name: 'Sukamantri',
  },
  {
    id: '3211170016',
    districtId: '3211170',
    name: 'Kertaharja',
  },
  {
    id: '3211170017',
    districtId: '3211170',
    name: 'Kertamekar',
  },
  {
    id: '3211170018',
    districtId: '3211170',
    name: 'Tanjungmulya',
  },
  {
    id: '3211170019',
    districtId: '3211170',
    name: 'Boros',
  },
  {
    id: '3211170020',
    districtId: '3211170',
    name: 'Awilega',
  },
  {
    id: '3211171001',
    districtId: '3211171',
    name: 'Wargaluyu',
  },
  {
    id: '3211171002',
    districtId: '3211171',
    name: 'Tanjungwangi',
  },
  {
    id: '3211171003',
    districtId: '3211171',
    name: 'Sukamukti',
  },
  {
    id: '3211171004',
    districtId: '3211171',
    name: 'Cikaramas',
  },
  {
    id: '3211171005',
    districtId: '3211171',
    name: 'Kertamukti',
  },
  {
    id: '3211171006',
    districtId: '3211171',
    name: 'Sukatani',
  },
  {
    id: '3211171007',
    districtId: '3211171',
    name: 'Kamal',
  },
  {
    id: '3211171008',
    districtId: '3211171',
    name: 'Jingkang',
  },
  {
    id: '3211171009',
    districtId: '3211171',
    name: 'Tanjungmedar',
  },
  {
    id: '3211180001',
    districtId: '3211180',
    name: 'Sekarwangi',
  },
  {
    id: '3211180002',
    districtId: '3211180',
    name: 'Cilangkap',
  },
  {
    id: '3211180003',
    districtId: '3211180',
    name: 'Cibitung',
  },
  {
    id: '3211180004',
    districtId: '3211180',
    name: 'Cikurubuk',
  },
  {
    id: '3211180005',
    districtId: '3211180',
    name: 'Bojongloa',
  },
  {
    id: '3211180006',
    districtId: '3211180',
    name: 'Nagrak',
  },
  {
    id: '3211180007',
    districtId: '3211180',
    name: 'Panyindangan',
  },
  {
    id: '3211180008',
    districtId: '3211180',
    name: 'Buahdua',
  },
  {
    id: '3211180010',
    districtId: '3211180',
    name: 'Citaleus',
  },
  {
    id: '3211180011',
    districtId: '3211180',
    name: 'Mekarmukti',
  },
  {
    id: '3211180012',
    districtId: '3211180',
    name: 'Hariang',
  },
  {
    id: '3211180014',
    districtId: '3211180',
    name: 'Karangbungur',
  },
  {
    id: '3211180015',
    districtId: '3211180',
    name: 'Ciawitali',
  },
  {
    id: '3211181001',
    districtId: '3211181',
    name: 'Wanajaya',
  },
  {
    id: '3211181002',
    districtId: '3211181',
    name: 'Wanasari',
  },
  {
    id: '3211181003',
    districtId: '3211181',
    name: 'Pamekarsari',
  },
  {
    id: '3211181004',
    districtId: '3211181',
    name: 'Surian',
  },
  {
    id: '3211181005',
    districtId: '3211181',
    name: 'Tanjung',
  },
  {
    id: '3211181006',
    districtId: '3211181',
    name: 'Ranggasari',
  },
  {
    id: '3211181007',
    districtId: '3211181',
    name: 'Suriamedal',
  },
  {
    id: '3211181008',
    districtId: '3211181',
    name: 'Suriamukti',
  },
  {
    id: '3211181009',
    districtId: '3211181',
    name: 'Nanjungwangi',
  },
  {
    id: '3212010007',
    districtId: '3212010',
    name: 'Haurkolot',
  },
  {
    id: '3212010008',
    districtId: '3212010',
    name: 'Haurgeulis',
  },
  {
    id: '3212010009',
    districtId: '3212010',
    name: 'Sukajati',
  },
  {
    id: '3212010010',
    districtId: '3212010',
    name: 'Wanakaya',
  },
  {
    id: '3212010011',
    districtId: '3212010',
    name: 'Karangtumaritis',
  },
  {
    id: '3212010012',
    districtId: '3212010',
    name: 'Kertanegara',
  },
  {
    id: '3212010013',
    districtId: '3212010',
    name: 'Cipancuh',
  },
  {
    id: '3212010014',
    districtId: '3212010',
    name: 'Mekarjati',
  },
  {
    id: '3212010015',
    districtId: '3212010',
    name: 'Sidadadi',
  },
  {
    id: '3212010016',
    districtId: '3212010',
    name: 'Sumbermulya',
  },
  {
    id: '3212011001',
    districtId: '3212011',
    name: 'Bantarwaru',
  },
  {
    id: '3212011002',
    districtId: '3212011',
    name: 'Sanca',
  },
  {
    id: '3212011003',
    districtId: '3212011',
    name: 'Mekarjaya',
  },
  {
    id: '3212011004',
    districtId: '3212011',
    name: 'Gantar',
  },
  {
    id: '3212011005',
    districtId: '3212011',
    name: 'Situraja',
  },
  {
    id: '3212011006',
    districtId: '3212011',
    name: 'Baleraja',
  },
  {
    id: '3212011007',
    districtId: '3212011',
    name: 'Mekarwaru',
  },
  {
    id: '3212020001',
    districtId: '3212020',
    name: 'Sukaslamet',
  },
  {
    id: '3212020002',
    districtId: '3212020',
    name: 'Tanjungkerta',
  },
  {
    id: '3212020003',
    districtId: '3212020',
    name: 'Kroya',
  },
  {
    id: '3212020004',
    districtId: '3212020',
    name: 'Sumbon',
  },
  {
    id: '3212020005',
    districtId: '3212020',
    name: 'Sukamelang',
  },
  {
    id: '3212020006',
    districtId: '3212020',
    name: 'Temiyang',
  },
  {
    id: '3212020007',
    districtId: '3212020',
    name: 'Temiyangsari',
  },
  {
    id: '3212020008',
    districtId: '3212020',
    name: 'Jayamulya',
  },
  {
    id: '3212020009',
    districtId: '3212020',
    name: 'Sumberjaya',
  },
  {
    id: '3212030001',
    districtId: '3212030',
    name: 'Kedungdawa',
  },
  {
    id: '3212030002',
    districtId: '3212030',
    name: 'Babakanjaya',
  },
  {
    id: '3212030003',
    districtId: '3212030',
    name: 'Gabuskulon',
  },
  {
    id: '3212030004',
    districtId: '3212030',
    name: 'Sekarmulya',
  },
  {
    id: '3212030005',
    districtId: '3212030',
    name: 'Kedokangabus',
  },
  {
    id: '3212030006',
    districtId: '3212030',
    name: 'Rancamulya',
  },
  {
    id: '3212030007',
    districtId: '3212030',
    name: 'Rancahan',
  },
  {
    id: '3212030008',
    districtId: '3212030',
    name: 'Gabuswetan',
  },
  {
    id: '3212030009',
    districtId: '3212030',
    name: 'Drunten Wetan',
  },
  {
    id: '3212030010',
    districtId: '3212030',
    name: 'Drunten Kulon',
  },
  {
    id: '3212040003',
    districtId: '3212040',
    name: 'Loyang',
  },
  {
    id: '3212040004',
    districtId: '3212040',
    name: 'Amis',
  },
  {
    id: '3212040005',
    districtId: '3212040',
    name: 'Jatisura',
  },
  {
    id: '3212040006',
    districtId: '3212040',
    name: 'Jambak',
  },
  {
    id: '3212040007',
    districtId: '3212040',
    name: 'Cikedung',
  },
  {
    id: '3212040012',
    districtId: '3212040',
    name: 'Cikedung Lor',
  },
  {
    id: '3212040013',
    districtId: '3212040',
    name: 'Mundakjaya',
  },
  {
    id: '3212041001',
    districtId: '3212041',
    name: 'Cikawung',
  },
  {
    id: '3212041002',
    districtId: '3212041',
    name: 'Jatimunggul',
  },
  {
    id: '3212041003',
    districtId: '3212041',
    name: 'Jatimulya',
  },
  {
    id: '3212041004',
    districtId: '3212041',
    name: 'Plosokerep',
  },
  {
    id: '3212041005',
    districtId: '3212041',
    name: 'Rajasinga',
  },
  {
    id: '3212041006',
    districtId: '3212041',
    name: 'Karangasem',
  },
  {
    id: '3212041007',
    districtId: '3212041',
    name: 'Cibereng',
  },
  {
    id: '3212041008',
    districtId: '3212041',
    name: 'Kendayakan',
  },
  {
    id: '3212041009',
    districtId: '3212041',
    name: 'Manggungan',
  },
  {
    id: '3212050001',
    districtId: '3212050',
    name: 'Tunggulpayung',
  },
  {
    id: '3212050005',
    districtId: '3212050',
    name: 'Pangauban',
  },
  {
    id: '3212050006',
    districtId: '3212050',
    name: 'Telagasari',
  },
  {
    id: '3212050007',
    districtId: '3212050',
    name: 'Langgengsari',
  },
  {
    id: '3212050008',
    districtId: '3212050',
    name: 'Tamansari',
  },
  {
    id: '3212050009',
    districtId: '3212050',
    name: 'Lelea',
  },
  {
    id: '3212050011',
    districtId: '3212050',
    name: 'Tempelkulon',
  },
  {
    id: '3212060008',
    districtId: '3212060',
    name: 'Mulyasari',
  },
  {
    id: '3212060015',
    districtId: '3212060',
    name: 'Bangodua',
  },
  {
    id: '3212060017',
    districtId: '3212060',
    name: 'Karanggetas',
  },
  {
    id: '3212060018',
    districtId: '3212060',
    name: 'Tegalgirang',
  },
  {
    id: '3212060019',
    districtId: '3212060',
    name: 'Wanasari',
  },
  {
    id: '3212060020',
    districtId: '3212060',
    name: 'Malangsari',
  },
  {
    id: '3212060021',
    districtId: '3212060',
    name: 'Rancasari',
  },
  {
    id: '3212061001',
    districtId: '3212061',
    name: 'Bodas',
  },
  {
    id: '3212061002',
    districtId: '3212061',
    name: 'Gadel',
  },
  {
    id: '3212061003',
    districtId: '3212061',
    name: 'Rancajawat',
  },
  {
    id: '3212061004',
    districtId: '3212061',
    name: 'Kerticala',
  },
  {
    id: '3212061005',
    districtId: '3212061',
    name: 'Sukamulya',
  },
  {
    id: '3212061006',
    districtId: '3212061',
    name: 'Karangkerta',
  },
  {
    id: '3212061007',
    districtId: '3212061',
    name: 'Cangko',
  },
  {
    id: '3212061008',
    districtId: '3212061',
    name: 'Pagedangan',
  },
  {
    id: '3212061009',
    districtId: '3212061',
    name: 'Sukaperna',
  },
  {
    id: '3212061010',
    districtId: '3212061',
    name: 'Sukadana',
  },
  {
    id: '3212061011',
    districtId: '3212061',
    name: 'Tukdana',
  },
  {
    id: '3212061012',
    districtId: '3212061',
    name: 'Lajer',
  },
  {
    id: '3212061013',
    districtId: '3212061',
    name: 'Mekarsari',
  },
  {
    id: '3212070006',
    districtId: '3212070',
    name: 'Bangkaloa Ilir',
  },
  {
    id: '3212070007',
    districtId: '3212070',
    name: 'Widasari',
  },
  {
    id: '3212070008',
    districtId: '3212070',
    name: 'Kalensari',
  },
  {
    id: '3212070011',
    districtId: '3212070',
    name: 'Ujungaris',
  },
  {
    id: '3212070012',
    districtId: '3212070',
    name: 'Kongsijaya',
  },
  {
    id: '3212070013',
    districtId: '3212070',
    name: 'Ujungjaya',
  },
  {
    id: '3212070014',
    districtId: '3212070',
    name: 'Ujungpendokjaya',
  },
  {
    id: '3212070015',
    districtId: '3212070',
    name: 'Leuwigede',
  },
  {
    id: '3212070016',
    districtId: '3212070',
    name: 'Kasmaran',
  },
  {
    id: '3212080007',
    districtId: '3212080',
    name: 'Tulungagung',
  },
  {
    id: '3212080008',
    districtId: '3212080',
    name: 'Jengkok',
  },
  {
    id: '3212080009',
    districtId: '3212080',
    name: 'Tegalwirangrong',
  },
  {
    id: '3212080010',
    districtId: '3212080',
    name: 'Manguntara',
  },
  {
    id: '3212080011',
    districtId: '3212080',
    name: 'Jambe',
  },
  {
    id: '3212080012',
    districtId: '3212080',
    name: 'Lemahayu',
  },
  {
    id: '3212080013',
    districtId: '3212080',
    name: 'Tenajar Kidul',
  },
  {
    id: '3212080014',
    districtId: '3212080',
    name: 'Kertasemaya',
  },
  {
    id: '3212080015',
    districtId: '3212080',
    name: 'Kliwed',
  },
  {
    id: '3212080016',
    districtId: '3212080',
    name: 'Tenajar',
  },
  {
    id: '3212080017',
    districtId: '3212080',
    name: 'Laranganjambe',
  },
  {
    id: '3212080018',
    districtId: '3212080',
    name: 'Tenajar Lor',
  },
  {
    id: '3212080019',
    districtId: '3212080',
    name: 'Sukawera',
  },
  {
    id: '3212081001',
    districtId: '3212081',
    name: 'Cibeber',
  },
  {
    id: '3212081002',
    districtId: '3212081',
    name: 'Bondan',
  },
  {
    id: '3212081003',
    districtId: '3212081',
    name: 'Gunungsari',
  },
  {
    id: '3212081004',
    districtId: '3212081',
    name: 'Sukagumiwang',
  },
  {
    id: '3212081005',
    districtId: '3212081',
    name: 'Tersana',
  },
  {
    id: '3212081006',
    districtId: '3212081',
    name: 'Cadangpinggan',
  },
  {
    id: '3212081007',
    districtId: '3212081',
    name: 'Gedangan',
  },
  {
    id: '3212090001',
    districtId: '3212090',
    name: 'Purwajaya',
  },
  {
    id: '3212090002',
    districtId: '3212090',
    name: 'Kapringan',
  },
  {
    id: '3212090003',
    districtId: '3212090',
    name: 'Singakerta',
  },
  {
    id: '3212090004',
    districtId: '3212090',
    name: 'Dukuhjati',
  },
  {
    id: '3212090005',
    districtId: '3212090',
    name: 'Tegalmulya',
  },
  {
    id: '3212090008',
    districtId: '3212090',
    name: 'Luwunggesik',
  },
  {
    id: '3212090009',
    districtId: '3212090',
    name: 'Kalianyar',
  },
  {
    id: '3212090010',
    districtId: '3212090',
    name: 'Krangkeng',
  },
  {
    id: '3212090011',
    districtId: '3212090',
    name: 'Tanjakan',
  },
  {
    id: '3212100007',
    districtId: '3212100',
    name: 'Kaplonganlor',
  },
  {
    id: '3212100008',
    districtId: '3212100',
    name: 'Tanjungpura',
  },
  {
    id: '3212100009',
    districtId: '3212100',
    name: 'Tanjungsari',
  },
  {
    id: '3212100010',
    districtId: '3212100',
    name: 'Pringgacala',
  },
  {
    id: '3212100011',
    districtId: '3212100',
    name: 'Benda',
  },
  {
    id: '3212100012',
    districtId: '3212100',
    name: 'Sendang',
  },
  {
    id: '3212100013',
    districtId: '3212100',
    name: 'Karangampel Kidul',
  },
  {
    id: '3212100014',
    districtId: '3212100',
    name: 'Karangampel',
  },
  {
    id: '3212100016',
    districtId: '3212100',
    name: 'Dukuhtengah',
  },
  {
    id: '3212101001',
    districtId: '3212101',
    name: 'Kedokanbunder Wetan',
  },
  {
    id: '3212101002',
    districtId: '3212101',
    name: 'Kaplongan',
  },
  {
    id: '3212101003',
    districtId: '3212101',
    name: 'Kedokan Agung',
  },
  {
    id: '3212101004',
    districtId: '3212101',
    name: 'Kedokanbunder',
  },
  {
    id: '3212101005',
    districtId: '3212101',
    name: 'Jayawinangun',
  },
  {
    id: '3212101006',
    districtId: '3212101',
    name: 'Cangkingan',
  },
  {
    id: '3212101007',
    districtId: '3212101',
    name: 'Jayalaksana',
  },
  {
    id: '3212110001',
    districtId: '3212110',
    name: 'Segeran Kidul',
  },
  {
    id: '3212110002',
    districtId: '3212110',
    name: 'Segeran',
  },
  {
    id: '3212110003',
    districtId: '3212110',
    name: 'Juntiweden',
  },
  {
    id: '3212110004',
    districtId: '3212110',
    name: 'Juntikebon',
  },
  {
    id: '3212110005',
    districtId: '3212110',
    name: 'Dadap',
  },
  {
    id: '3212110006',
    districtId: '3212110',
    name: 'Juntinyuat',
  },
  {
    id: '3212110007',
    districtId: '3212110',
    name: 'Juntikedokan',
  },
  {
    id: '3212110008',
    districtId: '3212110',
    name: 'Pondoh',
  },
  {
    id: '3212110009',
    districtId: '3212110',
    name: 'Sambimaya',
  },
  {
    id: '3212110010',
    districtId: '3212110',
    name: 'Tinumpuk',
  },
  {
    id: '3212110011',
    districtId: '3212110',
    name: 'Lombang',
  },
  {
    id: '3212110012',
    districtId: '3212110',
    name: 'Limbangan',
  },
  {
    id: '3212120001',
    districtId: '3212120',
    name: 'Sleman',
  },
  {
    id: '3212120002',
    districtId: '3212120',
    name: 'Tambi',
  },
  {
    id: '3212120003',
    districtId: '3212120',
    name: 'Sudikampiran',
  },
  {
    id: '3212120004',
    districtId: '3212120',
    name: 'Tambi Lor',
  },
  {
    id: '3212120005',
    districtId: '3212120',
    name: 'Sleman Lor',
  },
  {
    id: '3212120006',
    districtId: '3212120',
    name: 'Majasari',
  },
  {
    id: '3212120007',
    districtId: '3212120',
    name: 'Majasih',
  },
  {
    id: '3212120008',
    districtId: '3212120',
    name: 'Sliyeg',
  },
  {
    id: '3212120009',
    districtId: '3212120',
    name: 'Gadingan',
  },
  {
    id: '3212120010',
    districtId: '3212120',
    name: 'Mekargading',
  },
  {
    id: '3212120011',
    districtId: '3212120',
    name: 'Sliyeglor',
  },
  {
    id: '3212120012',
    districtId: '3212120',
    name: 'Tugu Kidul',
  },
  {
    id: '3212120016',
    districtId: '3212120',
    name: 'Longok',
  },
  {
    id: '3212130001',
    districtId: '3212130',
    name: 'Sukalila',
  },
  {
    id: '3212130002',
    districtId: '3212130',
    name: 'Pilangsari',
  },
  {
    id: '3212130003',
    districtId: '3212130',
    name: 'Jatibarang Baru',
  },
  {
    id: '3212130004',
    districtId: '3212130',
    name: 'Bulak',
  },
  {
    id: '3212130005',
    districtId: '3212130',
    name: 'Bulak Lor',
  },
  {
    id: '3212130006',
    districtId: '3212130',
    name: 'Jatibarang',
  },
  {
    id: '3212130008',
    districtId: '3212130',
    name: 'Pawidean',
  },
  {
    id: '3212130009',
    districtId: '3212130',
    name: 'Jatisawit',
  },
  {
    id: '3212130010',
    districtId: '3212130',
    name: 'Jatisawit Lor',
  },
  {
    id: '3212130011',
    districtId: '3212130',
    name: 'Krasak',
  },
  {
    id: '3212130012',
    districtId: '3212130',
    name: 'Kalimati',
  },
  {
    id: '3212130013',
    districtId: '3212130',
    name: 'Malangsemirang',
  },
  {
    id: '3212130014',
    districtId: '3212130',
    name: 'Lobener',
  },
  {
    id: '3212130015',
    districtId: '3212130',
    name: 'Lobener Lor',
  },
  {
    id: '3212140001',
    districtId: '3212140',
    name: 'Tegalsembadra',
  },
  {
    id: '3212140002',
    districtId: '3212140',
    name: 'Sukareja',
  },
  {
    id: '3212140003',
    districtId: '3212140',
    name: 'Sukaurip',
  },
  {
    id: '3212140004',
    districtId: '3212140',
    name: 'Rawadalem',
  },
  {
    id: '3212140005',
    districtId: '3212140',
    name: 'Gelarmendala',
  },
  {
    id: '3212140006',
    districtId: '3212140',
    name: 'Tegalurung',
  },
  {
    id: '3212140007',
    districtId: '3212140',
    name: 'Balongan',
  },
  {
    id: '3212140008',
    districtId: '3212140',
    name: 'Sudimampir',
  },
  {
    id: '3212140009',
    districtId: '3212140',
    name: 'Sudimampirlor',
  },
  {
    id: '3212140010',
    districtId: '3212140',
    name: 'Majakerta',
  },
  {
    id: '3212150001',
    districtId: '3212150',
    name: 'Telukagung',
  },
  {
    id: '3212150002',
    districtId: '3212150',
    name: 'Plumbon',
  },
  {
    id: '3212150004',
    districtId: '3212150',
    name: 'Pekandangan Jaya',
  },
  {
    id: '3212150005',
    districtId: '3212150',
    name: 'Singaraja',
  },
  {
    id: '3212150006',
    districtId: '3212150',
    name: 'Singajaya',
  },
  {
    id: '3212150007',
    districtId: '3212150',
    name: 'Pekandangan',
  },
  {
    id: '3212150008',
    districtId: '3212150',
    name: 'Bojongsari',
  },
  {
    id: '3212150009',
    districtId: '3212150',
    name: 'Kepandean',
  },
  {
    id: '3212150010',
    districtId: '3212150',
    name: 'Karangmalang',
  },
  {
    id: '3212150011',
    districtId: '3212150',
    name: 'Karanganyar',
  },
  {
    id: '3212150012',
    districtId: '3212150',
    name: 'Lemahmekar',
  },
  {
    id: '3212150013',
    districtId: '3212150',
    name: 'Lemahabang',
  },
  {
    id: '3212150014',
    districtId: '3212150',
    name: 'Margadadi',
  },
  {
    id: '3212150015',
    districtId: '3212150',
    name: 'Paoman',
  },
  {
    id: '3212150016',
    districtId: '3212150',
    name: 'Karangsong',
  },
  {
    id: '3212150017',
    districtId: '3212150',
    name: 'Pabeanudik',
  },
  {
    id: '3212150018',
    districtId: '3212150',
    name: 'Tambak',
  },
  {
    id: '3212160007',
    districtId: '3212160',
    name: 'Panyindangan Kulon',
  },
  {
    id: '3212160008',
    districtId: '3212160',
    name: 'Rambatan Wetan',
  },
  {
    id: '3212160009',
    districtId: '3212160',
    name: 'Panyindangan Wetan',
  },
  {
    id: '3212160010',
    districtId: '3212160',
    name: 'Kenanga',
  },
  {
    id: '3212160011',
    districtId: '3212160',
    name: 'Terusan',
  },
  {
    id: '3212160012',
    districtId: '3212160',
    name: 'Dermayu',
  },
  {
    id: '3212160013',
    districtId: '3212160',
    name: 'Sindang',
  },
  {
    id: '3212160014',
    districtId: '3212160',
    name: 'Penganjang',
  },
  {
    id: '3212160015',
    districtId: '3212160',
    name: 'Babadan',
  },
  {
    id: '3212160016',
    districtId: '3212160',
    name: 'Wanantara',
  },
  {
    id: '3212161001',
    districtId: '3212161',
    name: 'Cangkring',
  },
  {
    id: '3212161002',
    districtId: '3212161',
    name: 'Cantigi Kulon',
  },
  {
    id: '3212161003',
    districtId: '3212161',
    name: 'Cantigi Wetan',
  },
  {
    id: '3212161004',
    districtId: '3212161',
    name: 'Panyingkiran Lor',
  },
  {
    id: '3212161005',
    districtId: '3212161',
    name: 'Panyingkiran Kidul',
  },
  {
    id: '3212161006',
    districtId: '3212161',
    name: 'Lamarantarung',
  },
  {
    id: '3212161007',
    districtId: '3212161',
    name: 'Cemara',
  },
  {
    id: '3212162001',
    districtId: '3212162',
    name: 'Pagirikan',
  },
  {
    id: '3212162002',
    districtId: '3212162',
    name: 'Pasekan',
  },
  {
    id: '3212162003',
    districtId: '3212162',
    name: 'Brondong',
  },
  {
    id: '3212162004',
    districtId: '3212162',
    name: 'Pabeanilir',
  },
  {
    id: '3212162005',
    districtId: '3212162',
    name: 'Totoran',
  },
  {
    id: '3212162006',
    districtId: '3212162',
    name: 'Karanganyar',
  },
  {
    id: '3212170001',
    districtId: '3212170',
    name: 'Kiajaran Kulon',
  },
  {
    id: '3212170002',
    districtId: '3212170',
    name: 'Kijaran Wetan',
  },
  {
    id: '3212170003',
    districtId: '3212170',
    name: 'Lanjan',
  },
  {
    id: '3212170004',
    districtId: '3212170',
    name: 'Langut',
  },
  {
    id: '3212170005',
    districtId: '3212170',
    name: 'Larangan',
  },
  {
    id: '3212170006',
    districtId: '3212170',
    name: 'Waru',
  },
  {
    id: '3212170007',
    districtId: '3212170',
    name: 'Legok',
  },
  {
    id: '3212170008',
    districtId: '3212170',
    name: 'Bojongslawi',
  },
  {
    id: '3212170009',
    districtId: '3212170',
    name: 'Lohbener',
  },
  {
    id: '3212170010',
    districtId: '3212170',
    name: 'Pamayahan',
  },
  {
    id: '3212170011',
    districtId: '3212170',
    name: 'Sindangkerta',
  },
  {
    id: '3212170015',
    districtId: '3212170',
    name: 'Rambatan Kulon',
  },
  {
    id: '3212171001',
    districtId: '3212171',
    name: 'Sukasari',
  },
  {
    id: '3212171002',
    districtId: '3212171',
    name: 'Arahan Kidul',
  },
  {
    id: '3212171003',
    districtId: '3212171',
    name: 'Arahan Lor',
  },
  {
    id: '3212171004',
    districtId: '3212171',
    name: 'Linggajati',
  },
  {
    id: '3212171005',
    districtId: '3212171',
    name: 'Tawangsari',
  },
  {
    id: '3212171006',
    districtId: '3212171',
    name: 'Sukadadi',
  },
  {
    id: '3212171007',
    districtId: '3212171',
    name: 'Pranggong',
  },
  {
    id: '3212171008',
    districtId: '3212171',
    name: 'Cidempet',
  },
  {
    id: '3212180001',
    districtId: '3212180',
    name: 'Ranjeng',
  },
  {
    id: '3212180002',
    districtId: '3212180',
    name: 'Krimun',
  },
  {
    id: '3212180003',
    districtId: '3212180',
    name: 'Puntang',
  },
  {
    id: '3212180004',
    districtId: '3212180',
    name: 'Pegagan',
  },
  {
    id: '3212180005',
    districtId: '3212180',
    name: 'Rajaiyang',
  },
  {
    id: '3212180006',
    districtId: '3212180',
    name: 'Jangga',
  },
  {
    id: '3212180008',
    districtId: '3212180',
    name: 'Pangkalan',
  },
  {
    id: '3212180010',
    districtId: '3212180',
    name: 'Losarang',
  },
  {
    id: '3212180012',
    districtId: '3212180',
    name: 'Santing',
  },
  {
    id: '3212180013',
    districtId: '3212180',
    name: 'Cemara Kulon',
  },
  {
    id: '3212190002',
    districtId: '3212190',
    name: 'Pranti',
  },
  {
    id: '3212190003',
    districtId: '3212190',
    name: 'Wirakanan',
  },
  {
    id: '3212190004',
    districtId: '3212190',
    name: 'Karangmulya',
  },
  {
    id: '3212190005',
    districtId: '3212190',
    name: 'Karanganyar',
  },
  {
    id: '3212190006',
    districtId: '3212190',
    name: 'Wirapanjunan',
  },
  {
    id: '3212190007',
    districtId: '3212190',
    name: 'Parean Girang',
  },
  {
    id: '3212190008',
    districtId: '3212190',
    name: 'Bulak',
  },
  {
    id: '3212190009',
    districtId: '3212190',
    name: 'Ilir',
  },
  {
    id: '3212190010',
    districtId: '3212190',
    name: 'Soge',
  },
  {
    id: '3212190011',
    districtId: '3212190',
    name: 'Eretan Wetan',
  },
  {
    id: '3212190012',
    districtId: '3212190',
    name: 'Eretan Kulon',
  },
  {
    id: '3212190013',
    districtId: '3212190',
    name: 'Kertawinangun',
  },
  {
    id: '3212200001',
    districtId: '3212200',
    name: 'Cipedang',
  },
  {
    id: '3212200002',
    districtId: '3212200',
    name: 'Sidamulya',
  },
  {
    id: '3212200003',
    districtId: '3212200',
    name: 'Margamulya',
  },
  {
    id: '3212200004',
    districtId: '3212200',
    name: 'Kertajaya',
  },
  {
    id: '3212200005',
    districtId: '3212200',
    name: 'Bongas',
  },
  {
    id: '3212200006',
    districtId: '3212200',
    name: 'Cipaat',
  },
  {
    id: '3212200007',
    districtId: '3212200',
    name: 'Kertamulya',
  },
  {
    id: '3212200008',
    districtId: '3212200',
    name: 'Plawangan',
  },
  {
    id: '3212210001',
    districtId: '3212210',
    name: 'Mangunjaya',
  },
  {
    id: '3212210002',
    districtId: '3212210',
    name: 'Bugistua',
  },
  {
    id: '3212210003',
    districtId: '3212210',
    name: 'Bugis',
  },
  {
    id: '3212210004',
    districtId: '3212210',
    name: 'Salamdarma',
  },
  {
    id: '3212210006',
    districtId: '3212210',
    name: 'Wanguk',
  },
  {
    id: '3212210007',
    districtId: '3212210',
    name: 'Lempuyang',
  },
  {
    id: '3212210008',
    districtId: '3212210',
    name: 'Kopyah',
  },
  {
    id: '3212210009',
    districtId: '3212210',
    name: 'Anjatan Baru',
  },
  {
    id: '3212210010',
    districtId: '3212210',
    name: 'Anjatan',
  },
  {
    id: '3212210011',
    districtId: '3212210',
    name: 'Cilandak',
  },
  {
    id: '3212210012',
    districtId: '3212210',
    name: 'Cilandak Lor',
  },
  {
    id: '3212210013',
    districtId: '3212210',
    name: 'Anjatan Utara',
  },
  {
    id: '3212220001',
    districtId: '3212220',
    name: 'Bogor',
  },
  {
    id: '3212220002',
    districtId: '3212220',
    name: 'Sukra',
  },
  {
    id: '3212220003',
    districtId: '3212220',
    name: 'Ujunggebang',
  },
  {
    id: '3212220004',
    districtId: '3212220',
    name: 'Tegaltaman',
  },
  {
    id: '3212220005',
    districtId: '3212220',
    name: 'Sukrawetan',
  },
  {
    id: '3212220006',
    districtId: '3212220',
    name: 'Sumuradem',
  },
  {
    id: '3212220007',
    districtId: '3212220',
    name: 'Sumuradem Timur',
  },
  {
    id: '3212220008',
    districtId: '3212220',
    name: 'Karanglayung',
  },
  {
    id: '3212221001',
    districtId: '3212221',
    name: 'Limpas',
  },
  {
    id: '3212221002',
    districtId: '3212221',
    name: 'Patrol',
  },
  {
    id: '3212221003',
    districtId: '3212221',
    name: 'Arjasari',
  },
  {
    id: '3212221004',
    districtId: '3212221',
    name: 'Sukahaji',
  },
  {
    id: '3212221006',
    districtId: '3212221',
    name: 'Patrollor',
  },
  {
    id: '3212221007',
    districtId: '3212221',
    name: 'Patrol Baru',
  },
  {
    id: '3212221008',
    districtId: '3212221',
    name: 'Mekarsari',
  },
  {
    id: '3213010003',
    districtId: '3213010',
    name: 'Sukamandi',
  },
  {
    id: '3213010004',
    districtId: '3213010',
    name: 'Cicadas',
  },
  {
    id: '3213010005',
    districtId: '3213010',
    name: 'Sagalaherang',
  },
  {
    id: '3213010006',
    districtId: '3213010',
    name: 'Dayeuhkolot',
  },
  {
    id: '3213010012',
    districtId: '3213010',
    name: 'Sagalaherang Kaler',
  },
  {
    id: '3213010013',
    districtId: '3213010',
    name: 'Curugagung',
  },
  {
    id: '3213011001',
    districtId: '3213011',
    name: 'Cipancar',
  },
  {
    id: '3213011002',
    districtId: '3213011',
    name: 'Cikujang',
  },
  {
    id: '3213011003',
    districtId: '3213011',
    name: 'Cijengkol',
  },
  {
    id: '3213011004',
    districtId: '3213011',
    name: 'Cintamekar',
  },
  {
    id: '3213011005',
    districtId: '3213011',
    name: 'Ponggang',
  },
  {
    id: '3213011006',
    districtId: '3213011',
    name: 'Talagasari',
  },
  {
    id: '3213020008',
    districtId: '3213020',
    name: 'Sarireja',
  },
  {
    id: '3213020013',
    districtId: '3213020',
    name: 'Kumpay',
  },
  {
    id: '3213020014',
    districtId: '3213020',
    name: 'Tambakan',
  },
  {
    id: '3213020015',
    districtId: '3213020',
    name: 'Jalancagak',
  },
  {
    id: '3213020016',
    districtId: '3213020',
    name: 'Bunihayu',
  },
  {
    id: '3213020017',
    districtId: '3213020',
    name: 'Tambakmekar',
  },
  {
    id: '3213021001',
    districtId: '3213021',
    name: 'Ciater',
  },
  {
    id: '3213021002',
    districtId: '3213021',
    name: 'Nagrak',
  },
  {
    id: '3213021003',
    districtId: '3213021',
    name: 'Cibeusi',
  },
  {
    id: '3213021004',
    districtId: '3213021',
    name: 'Cibitung',
  },
  {
    id: '3213021005',
    districtId: '3213021',
    name: 'Sanca',
  },
  {
    id: '3213021006',
    districtId: '3213021',
    name: 'Palasari',
  },
  {
    id: '3213021007',
    districtId: '3213021',
    name: 'Cisaat',
  },
  {
    id: '3213030001',
    districtId: '3213030',
    name: 'Cupunagara',
  },
  {
    id: '3213030002',
    districtId: '3213030',
    name: 'Cimanggu',
  },
  {
    id: '3213030003',
    districtId: '3213030',
    name: 'Gardusayang',
  },
  {
    id: '3213030004',
    districtId: '3213030',
    name: 'Mayang',
  },
  {
    id: '3213030005',
    districtId: '3213030',
    name: 'Sukakerti',
  },
  {
    id: '3213030008',
    districtId: '3213030',
    name: 'Darmaga',
  },
  {
    id: '3213030009',
    districtId: '3213030',
    name: 'Cisalak',
  },
  {
    id: '3213030010',
    districtId: '3213030',
    name: 'Cigadog',
  },
  {
    id: '3213030014',
    districtId: '3213030',
    name: 'Pakuhaji',
  },
  {
    id: '3213031001',
    districtId: '3213031',
    name: 'Pasanggrahan',
  },
  {
    id: '3213031002',
    districtId: '3213031',
    name: 'Sindangsari',
  },
  {
    id: '3213031003',
    districtId: '3213031',
    name: 'Bojongloa',
  },
  {
    id: '3213031004',
    districtId: '3213031',
    name: 'Tenjolaya',
  },
  {
    id: '3213031005',
    districtId: '3213031',
    name: 'Sukamelang',
  },
  {
    id: '3213031006',
    districtId: '3213031',
    name: 'Kasomalang Wetan',
  },
  {
    id: '3213031007',
    districtId: '3213031',
    name: 'Kasomalang Kulon',
  },
  {
    id: '3213031008',
    districtId: '3213031',
    name: 'Cimanglid',
  },
  {
    id: '3213040001',
    districtId: '3213040',
    name: 'Buniara',
  },
  {
    id: '3213040002',
    districtId: '3213040',
    name: 'Tanjungsiang',
  },
  {
    id: '3213040003',
    districtId: '3213040',
    name: 'Cikawung',
  },
  {
    id: '3213040004',
    districtId: '3213040',
    name: 'Cimeuhmal',
  },
  {
    id: '3213040005',
    districtId: '3213040',
    name: 'Sirap',
  },
  {
    id: '3213040006',
    districtId: '3213040',
    name: 'Kawungluwuk',
  },
  {
    id: '3213040008',
    districtId: '3213040',
    name: 'Cibuluh',
  },
  {
    id: '3213040009',
    districtId: '3213040',
    name: 'Sindanglaya',
  },
  {
    id: '3213040010',
    districtId: '3213040',
    name: 'Rancamanggung',
  },
  {
    id: '3213040011',
    districtId: '3213040',
    name: 'Gandasoli',
  },
  {
    id: '3213050001',
    districtId: '3213050',
    name: 'Gunungtua',
  },
  {
    id: '3213050002',
    districtId: '3213050',
    name: 'Cijambe',
  },
  {
    id: '3213050003',
    districtId: '3213050',
    name: 'Cirangkong',
  },
  {
    id: '3213050004',
    districtId: '3213050',
    name: 'Cimenteng',
  },
  {
    id: '3213050005',
    districtId: '3213050',
    name: 'Cikadu',
  },
  {
    id: '3213050006',
    districtId: '3213050',
    name: 'Sukahurip',
  },
  {
    id: '3213050007',
    districtId: '3213050',
    name: 'Bantarsari',
  },
  {
    id: '3213050008',
    districtId: '3213050',
    name: 'Tanjungwangi',
  },
  {
    id: '3213060002',
    districtId: '3213060',
    name: 'Sadawarna',
  },
  {
    id: '3213060003',
    districtId: '3213060',
    name: 'Sumurbarang',
  },
  {
    id: '3213060004',
    districtId: '3213060',
    name: 'Padaasih',
  },
  {
    id: '3213060005',
    districtId: '3213060',
    name: 'Cibogo',
  },
  {
    id: '3213060006',
    districtId: '3213060',
    name: 'Cinangsi',
  },
  {
    id: '3213060007',
    districtId: '3213060',
    name: 'Majasari',
  },
  {
    id: '3213060008',
    districtId: '3213060',
    name: 'Cibalandongjaya',
  },
  {
    id: '3213060010',
    districtId: '3213060',
    name: 'Cisaga',
  },
  {
    id: '3213070001',
    districtId: '3213070',
    name: 'Parung',
  },
  {
    id: '3213070002',
    districtId: '3213070',
    name: 'Pasirkareumbi',
  },
  {
    id: '3213070003',
    districtId: '3213070',
    name: 'Soklat',
  },
  {
    id: '3213070004',
    districtId: '3213070',
    name: 'Karanganyar',
  },
  {
    id: '3213070005',
    districtId: '3213070',
    name: 'Cigadung',
  },
  {
    id: '3213070006',
    districtId: '3213070',
    name: 'Dangdeur',
  },
  {
    id: '3213070007',
    districtId: '3213070',
    name: 'Sukamelang',
  },
  {
    id: '3213070012',
    districtId: '3213070',
    name: 'Wanareja',
  },
  {
    id: '3213080004',
    districtId: '3213080',
    name: 'Tanggulun Timur',
  },
  {
    id: '3213080005',
    districtId: '3213080',
    name: 'Tanggulun Barat',
  },
  {
    id: '3213080006',
    districtId: '3213080',
    name: 'Marengmang',
  },
  {
    id: '3213080007',
    districtId: '3213080',
    name: 'Kalijati Barat',
  },
  {
    id: '3213080008',
    districtId: '3213080',
    name: 'Kalijati Timur',
  },
  {
    id: '3213080016',
    districtId: '3213080',
    name: 'Kaliangsana',
  },
  {
    id: '3213080017',
    districtId: '3213080',
    name: 'Banggalamulya',
  },
  {
    id: '3213080018',
    districtId: '3213080',
    name: 'Jalupang',
  },
  {
    id: '3213080019',
    districtId: '3213080',
    name: 'Caracas',
  },
  {
    id: '3213080020',
    districtId: '3213080',
    name: 'Ciruluk',
  },
  {
    id: '3213081001',
    districtId: '3213081',
    name: 'Jambelaer',
  },
  {
    id: '3213081002',
    districtId: '3213081',
    name: 'Margasari',
  },
  {
    id: '3213081003',
    districtId: '3213081',
    name: 'Cisampih',
  },
  {
    id: '3213081004',
    districtId: '3213081',
    name: 'Situsari',
  },
  {
    id: '3213081005',
    districtId: '3213081',
    name: 'Sukasari',
  },
  {
    id: '3213081006',
    districtId: '3213081',
    name: 'Rawalele',
  },
  {
    id: '3213081007',
    districtId: '3213081',
    name: 'Dawuan Kidul',
  },
  {
    id: '3213081008',
    districtId: '3213081',
    name: 'Dawuan Kaler',
  },
  {
    id: '3213081009',
    districtId: '3213081',
    name: 'Manyeti',
  },
  {
    id: '3213081010',
    districtId: '3213081',
    name: 'Batusari',
  },
  {
    id: '3213090003',
    districtId: '3213090',
    name: 'Cimayasari',
  },
  {
    id: '3213090004',
    districtId: '3213090',
    name: 'Lengkong',
  },
  {
    id: '3213090005',
    districtId: '3213090',
    name: 'Cipeundeuy',
  },
  {
    id: '3213090006',
    districtId: '3213090',
    name: 'Wantilan',
  },
  {
    id: '3213090007',
    districtId: '3213090',
    name: 'Sawangan',
  },
  {
    id: '3213090008',
    districtId: '3213090',
    name: 'Karangmukti',
  },
  {
    id: '3213090009',
    districtId: '3213090',
    name: 'Kosar',
  },
  {
    id: '3213100002',
    districtId: '3213100',
    name: 'Cihambulu',
  },
  {
    id: '3213100003',
    districtId: '3213100',
    name: 'Siluman',
  },
  {
    id: '3213100004',
    districtId: '3213100',
    name: 'Pabuaran',
  },
  {
    id: '3213100005',
    districtId: '3213100',
    name: 'Salamjaya',
  },
  {
    id: '3213100006',
    districtId: '3213100',
    name: 'Kadawung',
  },
  {
    id: '3213100007',
    districtId: '3213100',
    name: 'Pringkasap',
  },
  {
    id: '3213100008',
    districtId: '3213100',
    name: 'Karanghegar',
  },
  {
    id: '3213100011',
    districtId: '3213100',
    name: 'Balebandung Jaya',
  },
  {
    id: '3213110001',
    districtId: '3213110',
    name: 'Tanjungrasa Kidul',
  },
  {
    id: '3213110002',
    districtId: '3213110',
    name: 'Tanjungrasa',
  },
  {
    id: '3213110003',
    districtId: '3213110',
    name: 'Jatiragas Hilir',
  },
  {
    id: '3213110004',
    districtId: '3213110',
    name: 'Tambakjati',
  },
  {
    id: '3213110005',
    districtId: '3213110',
    name: 'Ciberes',
  },
  {
    id: '3213110006',
    districtId: '3213110',
    name: 'Gempolsari',
  },
  {
    id: '3213110007',
    districtId: '3213110',
    name: 'Rancamulya',
  },
  {
    id: '3213110008',
    districtId: '3213110',
    name: 'Rancajaya',
  },
  {
    id: '3213110009',
    districtId: '3213110',
    name: 'Rancabango',
  },
  {
    id: '3213110010',
    districtId: '3213110',
    name: 'Rancaasih',
  },
  {
    id: '3213120001',
    districtId: '3213120',
    name: 'Koranji',
  },
  {
    id: '3213120003',
    districtId: '3213120',
    name: 'Wanakerta',
  },
  {
    id: '3213120005',
    districtId: '3213120',
    name: 'Pagon',
  },
  {
    id: '3213120006',
    districtId: '3213120',
    name: 'Parapatan',
  },
  {
    id: '3213120007',
    districtId: '3213120',
    name: 'Purwadadi Timur',
  },
  {
    id: '3213120008',
    districtId: '3213120',
    name: 'Purwadadi Barat',
  },
  {
    id: '3213120009',
    districtId: '3213120',
    name: 'Pasirbungur',
  },
  {
    id: '3213120010',
    districtId: '3213120',
    name: 'Rancamahi',
  },
  {
    id: '3213120011',
    districtId: '3213120',
    name: 'Panyingkiran',
  },
  {
    id: '3213130001',
    districtId: '3213130',
    name: 'Kaunganten',
  },
  {
    id: '3213130002',
    districtId: '3213130',
    name: 'Sindangsari',
  },
  {
    id: '3213130003',
    districtId: '3213130',
    name: 'Cikaum Timur',
  },
  {
    id: '3213130004',
    districtId: '3213130',
    name: 'Cikaum Barat',
  },
  {
    id: '3213130005',
    districtId: '3213130',
    name: 'Pasirmuncang',
  },
  {
    id: '3213130006',
    districtId: '3213130',
    name: 'Gandasari',
  },
  {
    id: '3213130007',
    districtId: '3213130',
    name: 'Mekarsari',
  },
  {
    id: '3213130008',
    districtId: '3213130',
    name: 'Tanjungsari Barat',
  },
  {
    id: '3213130009',
    districtId: '3213130',
    name: 'Tanjungsari Timur',
  },
  {
    id: '3213140005',
    districtId: '3213140',
    name: 'Gembor',
  },
  {
    id: '3213140006',
    districtId: '3213140',
    name: 'Gunungsari',
  },
  {
    id: '3213140007',
    districtId: '3213140',
    name: 'Sukamulya',
  },
  {
    id: '3213140013',
    districtId: '3213140',
    name: 'Sumbersari',
  },
  {
    id: '3213140014',
    districtId: '3213140',
    name: 'Gambarsari',
  },
  {
    id: '3213140015',
    districtId: '3213140',
    name: 'Neglasari',
  },
  {
    id: '3213140016',
    districtId: '3213140',
    name: 'Pagaden',
  },
  {
    id: '3213140017',
    districtId: '3213140',
    name: 'Kamarung',
  },
  {
    id: '3213140018',
    districtId: '3213140',
    name: 'Jabong',
  },
  {
    id: '3213141001',
    districtId: '3213141',
    name: 'Balingbing',
  },
  {
    id: '3213141002',
    districtId: '3213141',
    name: 'Cidadap',
  },
  {
    id: '3213141003',
    districtId: '3213141',
    name: 'Cidahu',
  },
  {
    id: '3213141004',
    districtId: '3213141',
    name: 'Pangsor',
  },
  {
    id: '3213141006',
    districtId: '3213141',
    name: 'Margahayu',
  },
  {
    id: '3213141007',
    districtId: '3213141',
    name: 'Bendungan',
  },
  {
    id: '3213141008',
    districtId: '3213141',
    name: 'Mekarwangi',
  },
  {
    id: '3213141009',
    districtId: '3213141',
    name: 'Sumurgintung',
  },
  {
    id: '3213150001',
    districtId: '3213150',
    name: 'Wanasari',
  },
  {
    id: '3213150002',
    districtId: '3213150',
    name: 'Sidamulya',
  },
  {
    id: '3213150003',
    districtId: '3213150',
    name: 'Sidajaya',
  },
  {
    id: '3213150004',
    districtId: '3213150',
    name: 'Tanjung',
  },
  {
    id: '3213150005',
    districtId: '3213150',
    name: 'Parigimulya',
  },
  {
    id: '3213150006',
    districtId: '3213150',
    name: 'Manyingsal',
  },
  {
    id: '3213150007',
    districtId: '3213150',
    name: 'Padamulya',
  },
  {
    id: '3213150008',
    districtId: '3213150',
    name: 'Jati',
  },
  {
    id: '3213150009',
    districtId: '3213150',
    name: 'Kosambi',
  },
  {
    id: '3213150010',
    districtId: '3213150',
    name: 'Simpar',
  },
  {
    id: '3213160001',
    districtId: '3213160',
    name: 'Sukadana',
  },
  {
    id: '3213160002',
    districtId: '3213160',
    name: 'Sukatani',
  },
  {
    id: '3213160003',
    districtId: '3213160',
    name: 'Kiarasari',
  },
  {
    id: '3213160004',
    districtId: '3213160',
    name: 'Jatireja',
  },
  {
    id: '3213160005',
    districtId: '3213160',
    name: 'Mekarjaya',
  },
  {
    id: '3213160006',
    districtId: '3213160',
    name: 'Kalensari',
  },
  {
    id: '3213160007',
    districtId: '3213160',
    name: 'Compreng',
  },
  {
    id: '3213160008',
    districtId: '3213160',
    name: 'Jatimulya',
  },
  {
    id: '3213170001',
    districtId: '3213170',
    name: 'Nangerang',
  },
  {
    id: '3213170002',
    districtId: '3213170',
    name: 'Cicadas',
  },
  {
    id: '3213170003',
    districtId: '3213170',
    name: 'Kihiyang',
  },
  {
    id: '3213170004',
    districtId: '3213170',
    name: 'Karangsari',
  },
  {
    id: '3213170005',
    districtId: '3213170',
    name: 'Citrajaya',
  },
  {
    id: '3213170006',
    districtId: '3213170',
    name: 'Binong',
  },
  {
    id: '3213170007',
    districtId: '3213170',
    name: 'Kediri',
  },
  {
    id: '3213170008',
    districtId: '3213170',
    name: 'Mulyasari',
  },
  {
    id: '3213170018',
    districtId: '3213170',
    name: 'Karangwangi',
  },
  {
    id: '3213171001',
    districtId: '3213171',
    name: 'Tanjungrasa',
  },
  {
    id: '3213171002',
    districtId: '3213171',
    name: 'Wanajaya',
  },
  {
    id: '3213171003',
    districtId: '3213171',
    name: 'Gardumukti',
  },
  {
    id: '3213171004',
    districtId: '3213171',
    name: 'Mariuk',
  },
  {
    id: '3213171005',
    districtId: '3213171',
    name: 'Kertajaya',
  },
  {
    id: '3213171006',
    districtId: '3213171',
    name: 'Tambakdahan',
  },
  {
    id: '3213171007',
    districtId: '3213171',
    name: 'Bojongkeding',
  },
  {
    id: '3213171008',
    districtId: '3213171',
    name: 'Bojonegara',
  },
  {
    id: '3213171009',
    districtId: '3213171',
    name: 'Rancaudik',
  },
  {
    id: '3213180001',
    districtId: '3213180',
    name: 'Sukamandijaya',
  },
  {
    id: '3213180002',
    districtId: '3213180',
    name: 'Ciasem Tengah',
  },
  {
    id: '3213180004',
    districtId: '3213180',
    name: 'Jatibaru',
  },
  {
    id: '3213180006',
    districtId: '3213180',
    name: 'Ciasem Hilir',
  },
  {
    id: '3213180007',
    districtId: '3213180',
    name: 'Ciasem Baru',
  },
  {
    id: '3213180008',
    districtId: '3213180',
    name: 'Ciasem Girang',
  },
  {
    id: '3213180009',
    districtId: '3213180',
    name: 'Sukahaji',
  },
  {
    id: '3213180010',
    districtId: '3213180',
    name: 'Pinangsari',
  },
  {
    id: '3213190006',
    districtId: '3213190',
    name: 'Rancasari',
  },
  {
    id: '3213190007',
    districtId: '3213190',
    name: 'Pamanukan',
  },
  {
    id: '3213190008',
    districtId: '3213190',
    name: 'Pamanukan Hilir',
  },
  {
    id: '3213190009',
    districtId: '3213190',
    name: 'Lengkongjaya',
  },
  {
    id: '3213190010',
    districtId: '3213190',
    name: 'Pamanukan Sebrang',
  },
  {
    id: '3213190012',
    districtId: '3213190',
    name: 'Mulyasari',
  },
  {
    id: '3213190013',
    districtId: '3213190',
    name: 'Rancahilir',
  },
  {
    id: '3213190014',
    districtId: '3213190',
    name: 'Bongas',
  },
  {
    id: '3213191001',
    districtId: '3213191',
    name: 'Mandalawangi',
  },
  {
    id: '3213191002',
    districtId: '3213191',
    name: 'Curugreja',
  },
  {
    id: '3213191003',
    districtId: '3213191',
    name: 'Batangsari',
  },
  {
    id: '3213191004',
    districtId: '3213191',
    name: 'Sukasari',
  },
  {
    id: '3213191005',
    districtId: '3213191',
    name: 'Sukareja',
  },
  {
    id: '3213191006',
    districtId: '3213191',
    name: 'Anggasari',
  },
  {
    id: '3213191007',
    districtId: '3213191',
    name: 'Sukamaju',
  },
  {
    id: '3213200009',
    districtId: '3213200',
    name: 'Pusakaratu',
  },
  {
    id: '3213200010',
    districtId: '3213200',
    name: 'Gempol',
  },
  {
    id: '3213200011',
    districtId: '3213200',
    name: 'Kalentambo',
  },
  {
    id: '3213200012',
    districtId: '3213200',
    name: 'Kotasari',
  },
  {
    id: '3213200013',
    districtId: '3213200',
    name: 'Rancadaka',
  },
  {
    id: '3213200014',
    districtId: '3213200',
    name: 'Patimban',
  },
  {
    id: '3213200015',
    districtId: '3213200',
    name: 'Mundusari',
  },
  {
    id: '3213201001',
    districtId: '3213201',
    name: 'Bojong Tengah',
  },
  {
    id: '3213201002',
    districtId: '3213201',
    name: 'Bojongjaya',
  },
  {
    id: '3213201003',
    districtId: '3213201',
    name: 'Cigugur',
  },
  {
    id: '3213201004',
    districtId: '3213201',
    name: 'Cigugur Kaler',
  },
  {
    id: '3213201005',
    districtId: '3213201',
    name: 'Rangdu',
  },
  {
    id: '3213201006',
    districtId: '3213201',
    name: 'Karanganyar',
  },
  {
    id: '3213201007',
    districtId: '3213201',
    name: 'Kebondanas',
  },
  {
    id: '3213201008',
    districtId: '3213201',
    name: 'Pusakajaya',
  },
  {
    id: '3213210002',
    districtId: '3213210',
    name: 'Tegalurung',
  },
  {
    id: '3213210003',
    districtId: '3213210',
    name: 'Mayangan',
  },
  {
    id: '3213210004',
    districtId: '3213210',
    name: 'Legonwetan',
  },
  {
    id: '3213210005',
    districtId: '3213210',
    name: 'Legonkulon',
  },
  {
    id: '3213210006',
    districtId: '3213210',
    name: 'Pangarengan',
  },
  {
    id: '3213210007',
    districtId: '3213210',
    name: 'Bobos',
  },
  {
    id: '3213210008',
    districtId: '3213210',
    name: 'Karangmulya',
  },
  {
    id: '3213220001',
    districtId: '3213220',
    name: 'Cilamaya Hilir',
  },
  {
    id: '3213220002',
    districtId: '3213220',
    name: 'Cilamaya Girang',
  },
  {
    id: '3213220003',
    districtId: '3213220',
    name: 'Rawamekar',
  },
  {
    id: '3213220004',
    districtId: '3213220',
    name: 'Rawameneng',
  },
  {
    id: '3213220005',
    districtId: '3213220',
    name: 'Jayamukti',
  },
  {
    id: '3213220006',
    districtId: '3213220',
    name: 'Blanakan',
  },
  {
    id: '3213220007',
    districtId: '3213220',
    name: 'Langensari',
  },
  {
    id: '3213220008',
    districtId: '3213220',
    name: 'Muara',
  },
  {
    id: '3213220009',
    districtId: '3213220',
    name: 'Tanjungtiga',
  },
  {
    id: '3214010006',
    districtId: '3214010',
    name: 'Jatimekar',
  },
  {
    id: '3214010007',
    districtId: '3214010',
    name: 'Cikaobandung',
  },
  {
    id: '3214010008',
    districtId: '3214010',
    name: 'Jatiluhur',
  },
  {
    id: '3214010009',
    districtId: '3214010',
    name: 'Cilegong',
  },
  {
    id: '3214010010',
    districtId: '3214010',
    name: 'Kembangkuning',
  },
  {
    id: '3214010011',
    districtId: '3214010',
    name: 'Cibinong',
  },
  {
    id: '3214010015',
    districtId: '3214010',
    name: 'Parakanlima',
  },
  {
    id: '3214010016',
    districtId: '3214010',
    name: 'Cisalada',
  },
  {
    id: '3214010017',
    districtId: '3214010',
    name: 'Mekargalih',
  },
  {
    id: '3214011001',
    districtId: '3214011',
    name: 'Parungbanteng',
  },
  {
    id: '3214011002',
    districtId: '3214011',
    name: 'Sukasari',
  },
  {
    id: '3214011003',
    districtId: '3214011',
    name: 'Ciririp',
  },
  {
    id: '3214011004',
    districtId: '3214011',
    name: 'Kertamanah',
  },
  {
    id: '3214011005',
    districtId: '3214011',
    name: 'Kutamanah',
  },
  {
    id: '3214020001',
    districtId: '3214020',
    name: 'Tegaldatar',
  },
  {
    id: '3214020002',
    districtId: '3214020',
    name: 'Sinargalih',
  },
  {
    id: '3214020003',
    districtId: '3214020',
    name: 'Citamiang',
  },
  {
    id: '3214020004',
    districtId: '3214020',
    name: 'Cijati',
  },
  {
    id: '3214020005',
    districtId: '3214020',
    name: 'Gunungkarung',
  },
  {
    id: '3214020006',
    districtId: '3214020',
    name: 'Pasirjambu',
  },
  {
    id: '3214020007',
    districtId: '3214020',
    name: 'Ciramahilir',
  },
  {
    id: '3214020008',
    districtId: '3214020',
    name: 'Sukamukti',
  },
  {
    id: '3214030001',
    districtId: '3214030',
    name: 'Sukahaji',
  },
  {
    id: '3214030002',
    districtId: '3214030',
    name: 'Karoya',
  },
  {
    id: '3214030003',
    districtId: '3214030',
    name: 'Cadassari',
  },
  {
    id: '3214030004',
    districtId: '3214030',
    name: 'Cadasmekar',
  },
  {
    id: '3214030005',
    districtId: '3214030',
    name: 'Citalang',
  },
  {
    id: '3214030006',
    districtId: '3214030',
    name: 'Batutumpang',
  },
  {
    id: '3214030007',
    districtId: '3214030',
    name: 'Tegalwaru',
  },
  {
    id: '3214030008',
    districtId: '3214030',
    name: 'Tegalsari',
  },
  {
    id: '3214030009',
    districtId: '3214030',
    name: 'Warungjeruk',
  },
  {
    id: '3214030010',
    districtId: '3214030',
    name: 'Galumpit',
  },
  {
    id: '3214030011',
    districtId: '3214030',
    name: 'Cisarua',
  },
  {
    id: '3214030012',
    districtId: '3214030',
    name: 'Sukamulya',
  },
  {
    id: '3214030013',
    districtId: '3214030',
    name: 'Pasanggrahan',
  },
  {
    id: '3214040001',
    districtId: '3214040',
    name: 'Rawasari',
  },
  {
    id: '3214040002',
    districtId: '3214040',
    name: 'Gandasoli',
  },
  {
    id: '3214040003',
    districtId: '3214040',
    name: 'Gandamekar',
  },
  {
    id: '3214040004',
    districtId: '3214040',
    name: 'Cibogohilir',
  },
  {
    id: '3214040005',
    districtId: '3214040',
    name: 'Palinggihan',
  },
  {
    id: '3214040006',
    districtId: '3214040',
    name: 'Babakan Sari',
  },
  {
    id: '3214040008',
    districtId: '3214040',
    name: 'Sindangsari',
  },
  {
    id: '3214040009',
    districtId: '3214040',
    name: 'Citeko',
  },
  {
    id: '3214040010',
    districtId: '3214040',
    name: 'Citekokaler',
  },
  {
    id: '3214040011',
    districtId: '3214040',
    name: 'Linggarsari',
  },
  {
    id: '3214040012',
    districtId: '3214040',
    name: 'Pamoyanan',
  },
  {
    id: '3214040013',
    districtId: '3214040',
    name: 'Liunggunung',
  },
  {
    id: '3214040014',
    districtId: '3214040',
    name: 'Anjun',
  },
  {
    id: '3214040015',
    districtId: '3214040',
    name: 'Cibogo Girang',
  },
  {
    id: '3214050002',
    districtId: '3214050',
    name: 'Cianting',
  },
  {
    id: '3214050003',
    districtId: '3214050',
    name: 'Pasirmunjul',
  },
  {
    id: '3214050004',
    districtId: '3214050',
    name: 'Cibodas',
  },
  {
    id: '3214050005',
    districtId: '3214050',
    name: 'Cianting Utara',
  },
  {
    id: '3214050006',
    districtId: '3214050',
    name: 'Sukatani',
  },
  {
    id: '3214050007',
    districtId: '3214050',
    name: 'Malangnengah',
  },
  {
    id: '3214050008',
    districtId: '3214050',
    name: 'Cilalawi',
  },
  {
    id: '3214050009',
    districtId: '3214050',
    name: 'Sukamaju',
  },
  {
    id: '3214050010',
    districtId: '3214050',
    name: 'Cipicung',
  },
  {
    id: '3214050011',
    districtId: '3214050',
    name: 'Tajursindang',
  },
  {
    id: '3214050012',
    districtId: '3214050',
    name: 'Sindanglaya',
  },
  {
    id: '3214050013',
    districtId: '3214050',
    name: 'Panyindangan',
  },
  {
    id: '3214050014',
    districtId: '3214050',
    name: 'Sukajaya',
  },
  {
    id: '3214050015',
    districtId: '3214050',
    name: 'Cijantung',
  },
  {
    id: '3214060001',
    districtId: '3214060',
    name: 'Pasirangin',
  },
  {
    id: '3214060002',
    districtId: '3214060',
    name: 'Nangewer',
  },
  {
    id: '3214060003',
    districtId: '3214060',
    name: 'Neglasari',
  },
  {
    id: '3214060004',
    districtId: '3214060',
    name: 'Linggasari',
  },
  {
    id: '3214060005',
    districtId: '3214060',
    name: 'Sawit',
  },
  {
    id: '3214060006',
    districtId: '3214060',
    name: 'Sirnamanah',
  },
  {
    id: '3214060007',
    districtId: '3214060',
    name: 'Depok',
  },
  {
    id: '3214060008',
    districtId: '3214060',
    name: 'Legoksari',
  },
  {
    id: '3214060009',
    districtId: '3214060',
    name: 'Mekarsari',
  },
  {
    id: '3214060012',
    districtId: '3214060',
    name: 'Gununghejo',
  },
  {
    id: '3214060013',
    districtId: '3214060',
    name: 'Darangdan',
  },
  {
    id: '3214060014',
    districtId: '3214060',
    name: 'Sadarkarya',
  },
  {
    id: '3214060015',
    districtId: '3214060',
    name: 'Linggamukti',
  },
  {
    id: '3214060016',
    districtId: '3214060',
    name: 'Cilingga',
  },
  {
    id: '3214060017',
    districtId: '3214060',
    name: 'Nagrak',
  },
  {
    id: '3214070001',
    districtId: '3214070',
    name: 'Cibingbin',
  },
  {
    id: '3214070002',
    districtId: '3214070',
    name: 'Bojong Timur',
  },
  {
    id: '3214070003',
    districtId: '3214070',
    name: 'Pasanggrahan',
  },
  {
    id: '3214070004',
    districtId: '3214070',
    name: 'Cihanjawar',
  },
  {
    id: '3214070005',
    districtId: '3214070',
    name: 'Cikeris',
  },
  {
    id: '3214070006',
    districtId: '3214070',
    name: 'Bojong Barat',
  },
  {
    id: '3214070007',
    districtId: '3214070',
    name: 'Pangkalan',
  },
  {
    id: '3214070008',
    districtId: '3214070',
    name: 'Sukamanah',
  },
  {
    id: '3214070009',
    districtId: '3214070',
    name: 'Pawenang',
  },
  {
    id: '3214070010',
    districtId: '3214070',
    name: 'Sindangsari',
  },
  {
    id: '3214070011',
    districtId: '3214070',
    name: 'Sindangpanon',
  },
  {
    id: '3214070012',
    districtId: '3214070',
    name: 'Cipeundeuy',
  },
  {
    id: '3214070013',
    districtId: '3214070',
    name: 'Cileunca',
  },
  {
    id: '3214070014',
    districtId: '3214070',
    name: 'Kertasari',
  },
  {
    id: '3214080001',
    districtId: '3214080',
    name: 'Nangerang',
  },
  {
    id: '3214080002',
    districtId: '3214080',
    name: 'Simpang',
  },
  {
    id: '3214080003',
    districtId: '3214080',
    name: 'Sakambang',
  },
  {
    id: '3214080004',
    districtId: '3214080',
    name: 'Nagrog',
  },
  {
    id: '3214080005',
    districtId: '3214080',
    name: 'Cibuntu',
  },
  {
    id: '3214080007',
    districtId: '3214080',
    name: 'Raharja',
  },
  {
    id: '3214080008',
    districtId: '3214080',
    name: 'Wanayasa',
  },
  {
    id: '3214080009',
    districtId: '3214080',
    name: 'Babakan',
  },
  {
    id: '3214080016',
    districtId: '3214080',
    name: 'Wanasari',
  },
  {
    id: '3214080017',
    districtId: '3214080',
    name: 'Legokhuni',
  },
  {
    id: '3214080018',
    districtId: '3214080',
    name: 'Ciawi',
  },
  {
    id: '3214080019',
    districtId: '3214080',
    name: 'Sukadami',
  },
  {
    id: '3214080020',
    districtId: '3214080',
    name: 'Taringgul Tonggoh',
  },
  {
    id: '3214080021',
    districtId: '3214080',
    name: 'Taringgul Tengah',
  },
  {
    id: '3214081001',
    districtId: '3214081',
    name: 'Pusakamulya',
  },
  {
    id: '3214081002',
    districtId: '3214081',
    name: 'Parakan Garokgek',
  },
  {
    id: '3214081003',
    districtId: '3214081',
    name: 'Ciracas',
  },
  {
    id: '3214081004',
    districtId: '3214081',
    name: 'Kiarapedes',
  },
  {
    id: '3214081005',
    districtId: '3214081',
    name: 'Cibeber',
  },
  {
    id: '3214081006',
    districtId: '3214081',
    name: 'Sumbersari',
  },
  {
    id: '3214081007',
    districtId: '3214081',
    name: 'Mekarjaya',
  },
  {
    id: '3214081008',
    districtId: '3214081',
    name: 'Margaluyu',
  },
  {
    id: '3214081009',
    districtId: '3214081',
    name: 'Gardu',
  },
  {
    id: '3214081010',
    districtId: '3214081',
    name: 'Taringgul Landeuh',
  },
  {
    id: '3214090009',
    districtId: '3214090',
    name: 'Ciherang',
  },
  {
    id: '3214090010',
    districtId: '3214090',
    name: 'Cidahu',
  },
  {
    id: '3214090011',
    districtId: '3214090',
    name: 'Pasawahan Anyar',
  },
  {
    id: '3214090012',
    districtId: '3214090',
    name: 'Pasawahankidul',
  },
  {
    id: '3214090013',
    districtId: '3214090',
    name: 'Sawah Kulon',
  },
  {
    id: '3214090014',
    districtId: '3214090',
    name: 'Kertajaya',
  },
  {
    id: '3214090015',
    districtId: '3214090',
    name: 'Lebakanyar',
  },
  {
    id: '3214090016',
    districtId: '3214090',
    name: 'Cihuni',
  },
  {
    id: '3214090017',
    districtId: '3214090',
    name: 'Warungkadu',
  },
  {
    id: '3214090018',
    districtId: '3214090',
    name: 'Selaawi',
  },
  {
    id: '3214090019',
    districtId: '3214090',
    name: 'Margasari',
  },
  {
    id: '3214090020',
    districtId: '3214090',
    name: 'Pasawahan',
  },
  {
    id: '3214091001',
    districtId: '3214091',
    name: 'Bungur Jaya',
  },
  {
    id: '3214091002',
    districtId: '3214091',
    name: 'Pondokbungur',
  },
  {
    id: '3214091003',
    districtId: '3214091',
    name: 'Salem',
  },
  {
    id: '3214091004',
    districtId: '3214091',
    name: 'Galudra',
  },
  {
    id: '3214091005',
    districtId: '3214091',
    name: 'Sukajadi',
  },
  {
    id: '3214091006',
    districtId: '3214091',
    name: 'Tanjungsari',
  },
  {
    id: '3214091007',
    districtId: '3214091',
    name: 'Salam Jaya',
  },
  {
    id: '3214091008',
    districtId: '3214091',
    name: 'Situ',
  },
  {
    id: '3214091009',
    districtId: '3214091',
    name: 'Parakansalam',
  },
  {
    id: '3214091010',
    districtId: '3214091',
    name: 'Salam Mulya',
  },
  {
    id: '3214100005',
    districtId: '3214100',
    name: 'Sindangkasih',
  },
  {
    id: '3214100006',
    districtId: '3214100',
    name: 'Nageri Kidul',
  },
  {
    id: '3214100007',
    districtId: '3214100',
    name: 'Nageri Tengah',
  },
  {
    id: '3214100008',
    districtId: '3214100',
    name: 'Cipaisan',
  },
  {
    id: '3214100009',
    districtId: '3214100',
    name: 'Nageri Kaler',
  },
  {
    id: '3214100010',
    districtId: '3214100',
    name: 'Tegalmunjul',
  },
  {
    id: '3214100011',
    districtId: '3214100',
    name: 'Citalang',
  },
  {
    id: '3214100012',
    districtId: '3214100',
    name: 'Munjuljaya',
  },
  {
    id: '3214100013',
    districtId: '3214100',
    name: 'Ciseureuh',
  },
  {
    id: '3214100016',
    districtId: '3214100',
    name: 'Purwamekar',
  },
  {
    id: '3214101001',
    districtId: '3214101',
    name: 'Maracang',
  },
  {
    id: '3214101002',
    districtId: '3214101',
    name: 'Ciwareng',
  },
  {
    id: '3214101003',
    districtId: '3214101',
    name: 'Mulyamekar',
  },
  {
    id: '3214101004',
    districtId: '3214101',
    name: 'Cigelam',
  },
  {
    id: '3214101005',
    districtId: '3214101',
    name: 'Babakancikao',
  },
  {
    id: '3214101006',
    districtId: '3214101',
    name: 'Kadumekar',
  },
  {
    id: '3214101007',
    districtId: '3214101',
    name: 'Hegarmanah',
  },
  {
    id: '3214101008',
    districtId: '3214101',
    name: 'Cicadas',
  },
  {
    id: '3214101009',
    districtId: '3214101',
    name: 'Cilangkap',
  },
  {
    id: '3214110001',
    districtId: '3214110',
    name: 'Cirende',
  },
  {
    id: '3214110011',
    districtId: '3214110',
    name: 'Campaka',
  },
  {
    id: '3214110012',
    districtId: '3214110',
    name: 'Campakasari',
  },
  {
    id: '3214110023',
    districtId: '3214110',
    name: 'Cijunti',
  },
  {
    id: '3214110024',
    districtId: '3214110',
    name: 'Cisaat',
  },
  {
    id: '3214110025',
    districtId: '3214110',
    name: 'Cimahi',
  },
  {
    id: '3214110026',
    districtId: '3214110',
    name: 'Cikumpay',
  },
  {
    id: '3214110027',
    districtId: '3214110',
    name: 'Cijaya',
  },
  {
    id: '3214110028',
    districtId: '3214110',
    name: 'Kertamukti',
  },
  {
    id: '3214111001',
    districtId: '3214111',
    name: 'Wanawali',
  },
  {
    id: '3214111002',
    districtId: '3214111',
    name: 'Cikadu',
  },
  {
    id: '3214111003',
    districtId: '3214111',
    name: 'Cibukamanah',
  },
  {
    id: '3214111004',
    districtId: '3214111',
    name: 'Cirangkong',
  },
  {
    id: '3214111005',
    districtId: '3214111',
    name: 'Cipancur',
  },
  {
    id: '3214111006',
    districtId: '3214111',
    name: 'Cipinang',
  },
  {
    id: '3214111007',
    districtId: '3214111',
    name: 'Ciparungsari',
  },
  {
    id: '3214111008',
    districtId: '3214111',
    name: 'Karyamekar',
  },
  {
    id: '3214111009',
    districtId: '3214111',
    name: 'Cibatu',
  },
  {
    id: '3214111010',
    districtId: '3214111',
    name: 'Cilandak',
  },
  {
    id: '3214112001',
    districtId: '3214112',
    name: 'Ciwangi',
  },
  {
    id: '3214112002',
    districtId: '3214112',
    name: 'Cibening',
  },
  {
    id: '3214112003',
    districtId: '3214112',
    name: 'Bungursari',
  },
  {
    id: '3214112004',
    districtId: '3214112',
    name: 'Cibungur',
  },
  {
    id: '3214112005',
    districtId: '3214112',
    name: 'Dangdeur',
  },
  {
    id: '3214112006',
    districtId: '3214112',
    name: 'Wanakerta',
  },
  {
    id: '3214112007',
    districtId: '3214112',
    name: 'Cinangka',
  },
  {
    id: '3214112008',
    districtId: '3214112',
    name: 'Cikopo',
  },
  {
    id: '3214112009',
    districtId: '3214112',
    name: 'Karangmukti',
  },
  {
    id: '3214112010',
    districtId: '3214112',
    name: 'Cibodas',
  },
  {
    id: '3215010001',
    districtId: '3215010',
    name: 'Medalsari',
  },
  {
    id: '3215010011',
    districtId: '3215010',
    name: 'Kertasari',
  },
  {
    id: '3215010012',
    districtId: '3215010',
    name: 'Cintaasih',
  },
  {
    id: '3215010013',
    districtId: '3215010',
    name: 'Mulangsari',
  },
  {
    id: '3215010014',
    districtId: '3215010',
    name: 'Jatilaksana',
  },
  {
    id: '3215010015',
    districtId: '3215010',
    name: 'Ciptasari',
  },
  {
    id: '3215010016',
    districtId: '3215010',
    name: 'Tamansari',
  },
  {
    id: '3215010017',
    districtId: '3215010',
    name: 'Tamanmekar',
  },
  {
    id: '3215011001',
    districtId: '3215011',
    name: 'Cipurwasari',
  },
  {
    id: '3215011002',
    districtId: '3215011',
    name: 'Cigunungsari',
  },
  {
    id: '3215011003',
    districtId: '3215011',
    name: 'Mekarbuana',
  },
  {
    id: '3215011004',
    districtId: '3215011',
    name: 'Wargasetra',
  },
  {
    id: '3215011005',
    districtId: '3215011',
    name: 'Cintalaksana',
  },
  {
    id: '3215011006',
    districtId: '3215011',
    name: 'Cintawargi',
  },
  {
    id: '3215011007',
    districtId: '3215011',
    name: 'Cintalanggeng',
  },
  {
    id: '3215011008',
    districtId: '3215011',
    name: 'Kutamaneuh',
  },
  {
    id: '3215011009',
    districtId: '3215011',
    name: 'Kutalanggeng',
  },
  {
    id: '3215020001',
    districtId: '3215020',
    name: 'Tegalega',
  },
  {
    id: '3215020002',
    districtId: '3215020',
    name: 'Mulyasejati',
  },
  {
    id: '3215020003',
    districtId: '3215020',
    name: 'Mulyasari',
  },
  {
    id: '3215020004',
    districtId: '3215020',
    name: 'Kutanegara',
  },
  {
    id: '3215020005',
    districtId: '3215020',
    name: 'Kutapohaci',
  },
  {
    id: '3215020006',
    districtId: '3215020',
    name: 'Kutamekar',
  },
  {
    id: '3215020007',
    districtId: '3215020',
    name: 'Parungmulya',
  },
  {
    id: '3215031001',
    districtId: '3215031',
    name: 'Sirnabaya',
  },
  {
    id: '3215031002',
    districtId: '3215031',
    name: 'Pinayungan',
  },
  {
    id: '3215031003',
    districtId: '3215031',
    name: 'Telukjambe',
  },
  {
    id: '3215031004',
    districtId: '3215031',
    name: 'Puseurjaya',
  },
  {
    id: '3215031005',
    districtId: '3215031',
    name: 'Sukaluyu',
  },
  {
    id: '3215031006',
    districtId: '3215031',
    name: 'Sukaharja',
  },
  {
    id: '3215031007',
    districtId: '3215031',
    name: 'Wadas',
  },
  {
    id: '3215031008',
    districtId: '3215031',
    name: 'Sukamakmur',
  },
  {
    id: '3215031009',
    districtId: '3215031',
    name: 'Purwadana',
  },
  {
    id: '3215032001',
    districtId: '3215032',
    name: 'Wanajaya',
  },
  {
    id: '3215032002',
    districtId: '3215032',
    name: 'Wanakerta',
  },
  {
    id: '3215032003',
    districtId: '3215032',
    name: 'Wanasari',
  },
  {
    id: '3215032004',
    districtId: '3215032',
    name: 'Margamulya',
  },
  {
    id: '3215032005',
    districtId: '3215032',
    name: 'Margakaya',
  },
  {
    id: '3215032006',
    districtId: '3215032',
    name: 'Karangligar',
  },
  {
    id: '3215032007',
    districtId: '3215032',
    name: 'Karangmulya',
  },
  {
    id: '3215032008',
    districtId: '3215032',
    name: 'Mulyajaya',
  },
  {
    id: '3215032009',
    districtId: '3215032',
    name: 'Mekarmulya',
  },
  {
    id: '3215032010',
    districtId: '3215032',
    name: 'Parungsari',
  },
  {
    id: '3215040001',
    districtId: '3215040',
    name: 'Karanganyar',
  },
  {
    id: '3215040003',
    districtId: '3215040',
    name: 'Cimahi',
  },
  {
    id: '3215040004',
    districtId: '3215040',
    name: 'Sumurkondang',
  },
  {
    id: '3215040005',
    districtId: '3215040',
    name: 'Walahar',
  },
  {
    id: '3215040006',
    districtId: '3215040',
    name: 'Kiarapayung',
  },
  {
    id: '3215040007',
    districtId: '3215040',
    name: 'Gintungkerta',
  },
  {
    id: '3215040008',
    districtId: '3215040',
    name: 'Anggadita',
  },
  {
    id: '3215040011',
    districtId: '3215040',
    name: 'Klari',
  },
  {
    id: '3215040012',
    districtId: '3215040',
    name: 'Cibalongsari',
  },
  {
    id: '3215040014',
    districtId: '3215040',
    name: 'Pancawati',
  },
  {
    id: '3215050001',
    districtId: '3215050',
    name: 'Kalihurip',
  },
  {
    id: '3215050002',
    districtId: '3215050',
    name: 'Kamojing',
  },
  {
    id: '3215050006',
    districtId: '3215050',
    name: 'Cikampek Timur',
  },
  {
    id: '3215050007',
    districtId: '3215050',
    name: 'Cikampek Pusaka',
  },
  {
    id: '3215050008',
    districtId: '3215050',
    name: 'Cikampek Selatan',
  },
  {
    id: '3215050009',
    districtId: '3215050',
    name: 'Cikampek Kota',
  },
  {
    id: '3215050011',
    districtId: '3215050',
    name: 'Cikampek Barat',
  },
  {
    id: '3215050012',
    districtId: '3215050',
    name: 'Dawuan Timur',
  },
  {
    id: '3215050013',
    districtId: '3215050',
    name: 'Dawuan Tengah',
  },
  {
    id: '3215050014',
    districtId: '3215050',
    name: 'Dawuan Barat',
  },
  {
    id: '3215051001',
    districtId: '3215051',
    name: 'Mekarjaya',
  },
  {
    id: '3215051002',
    districtId: '3215051',
    name: 'Tamelang',
  },
  {
    id: '3215051003',
    districtId: '3215051',
    name: 'Purwasari',
  },
  {
    id: '3215051004',
    districtId: '3215051',
    name: 'Sukasari',
  },
  {
    id: '3215051005',
    districtId: '3215051',
    name: 'Tegalsari',
  },
  {
    id: '3215051006',
    districtId: '3215051',
    name: 'Karangsari',
  },
  {
    id: '3215051007',
    districtId: '3215051',
    name: 'Darawolong',
  },
  {
    id: '3215051008',
    districtId: '3215051',
    name: 'Cengkong',
  },
  {
    id: '3215060002',
    districtId: '3215060',
    name: 'Karangsinom',
  },
  {
    id: '3215060003',
    districtId: '3215060',
    name: 'Karangjaya',
  },
  {
    id: '3215060004',
    districtId: '3215060',
    name: 'Parakanmulya',
  },
  {
    id: '3215060005',
    districtId: '3215060',
    name: 'Citarik',
  },
  {
    id: '3215060006',
    districtId: '3215060',
    name: 'Tirtasari',
  },
  {
    id: '3215060007',
    districtId: '3215060',
    name: 'Parakan',
  },
  {
    id: '3215060008',
    districtId: '3215060',
    name: 'Kamurang',
  },
  {
    id: '3215060009',
    districtId: '3215060',
    name: 'Bojongsari',
  },
  {
    id: '3215060010',
    districtId: '3215060',
    name: 'Cipondoh',
  },
  {
    id: '3215060011',
    districtId: '3215060',
    name: 'Kertawaluya',
  },
  {
    id: '3215070004',
    districtId: '3215070',
    name: 'Barugbug',
  },
  {
    id: '3215070005',
    districtId: '3215070',
    name: 'Situdam',
  },
  {
    id: '3215070006',
    districtId: '3215070',
    name: 'Balonggandu',
  },
  {
    id: '3215070009',
    districtId: '3215070',
    name: 'Kalijati',
  },
  {
    id: '3215070010',
    districtId: '3215070',
    name: 'Mekarsari',
  },
  {
    id: '3215070011',
    districtId: '3215070',
    name: 'Jatisari',
  },
  {
    id: '3215070012',
    districtId: '3215070',
    name: 'Cirejag',
  },
  {
    id: '3215070013',
    districtId: '3215070',
    name: 'Cikalongsari',
  },
  {
    id: '3215070014',
    districtId: '3215070',
    name: 'Jatiragas',
  },
  {
    id: '3215070015',
    districtId: '3215070',
    name: 'Jatiwangi',
  },
  {
    id: '3215070016',
    districtId: '3215070',
    name: 'Jatibaru',
  },
  {
    id: '3215070017',
    districtId: '3215070',
    name: 'Telarsari',
  },
  {
    id: '3215070018',
    districtId: '3215070',
    name: 'Sukamekar',
  },
  {
    id: '3215070019',
    districtId: '3215070',
    name: 'Pacing',
  },
  {
    id: '3215071001',
    districtId: '3215071',
    name: 'Pamekaran',
  },
  {
    id: '3215071002',
    districtId: '3215071',
    name: 'Cicinde Selatan',
  },
  {
    id: '3215071003',
    districtId: '3215071',
    name: 'Cicinde Utara',
  },
  {
    id: '3215071004',
    districtId: '3215071',
    name: 'Jayamukti',
  },
  {
    id: '3215071005',
    districtId: '3215071',
    name: 'Gempolkolot',
  },
  {
    id: '3215071006',
    districtId: '3215071',
    name: 'Gempol',
  },
  {
    id: '3215071007',
    districtId: '3215071',
    name: 'Gembongan',
  },
  {
    id: '3215071008',
    districtId: '3215071',
    name: 'Mekarasih',
  },
  {
    id: '3215071009',
    districtId: '3215071',
    name: 'Banyuasih',
  },
  {
    id: '3215071010',
    districtId: '3215071',
    name: 'Talunjaya',
  },
  {
    id: '3215071011',
    districtId: '3215071',
    name: 'Tanjung',
  },
  {
    id: '3215071012',
    districtId: '3215071',
    name: 'Kutaraharja',
  },
  {
    id: '3215072001',
    districtId: '3215072',
    name: 'Sarimulya',
  },
  {
    id: '3215072002',
    districtId: '3215072',
    name: 'Jomin Barat',
  },
  {
    id: '3215072003',
    districtId: '3215072',
    name: 'Jomin Timur',
  },
  {
    id: '3215072004',
    districtId: '3215072',
    name: 'Pangulah Selatan',
  },
  {
    id: '3215072005',
    districtId: '3215072',
    name: 'Pangulah Utara',
  },
  {
    id: '3215072006',
    districtId: '3215072',
    name: 'Pangulah Baru',
  },
  {
    id: '3215072007',
    districtId: '3215072',
    name: 'Wancimekar',
  },
  {
    id: '3215072009',
    districtId: '3215072',
    name: 'Cikampek Utara',
  },
  {
    id: '3215081001',
    districtId: '3215081',
    name: 'Cikarang',
  },
  {
    id: '3215081002',
    districtId: '3215081',
    name: 'Cikalong',
  },
  {
    id: '3215081003',
    districtId: '3215081',
    name: 'Tegalsari',
  },
  {
    id: '3215081004',
    districtId: '3215081',
    name: 'Tegalwaru',
  },
  {
    id: '3215081005',
    districtId: '3215081',
    name: 'Mekarmaya',
  },
  {
    id: '3215081006',
    districtId: '3215081',
    name: 'Cilamaya',
  },
  {
    id: '3215081007',
    districtId: '3215081',
    name: 'Sukatani',
  },
  {
    id: '3215081008',
    districtId: '3215081',
    name: 'Sukakerta',
  },
  {
    id: '3215081009',
    districtId: '3215081',
    name: 'Rawagempol Kulon',
  },
  {
    id: '3215081010',
    districtId: '3215081',
    name: 'Rawagempol Wetan',
  },
  {
    id: '3215081011',
    districtId: '3215081',
    name: 'Muarabaru',
  },
  {
    id: '3215081012',
    districtId: '3215081',
    name: 'Muara',
  },
  {
    id: '3215082001',
    districtId: '3215082',
    name: 'Kiara',
  },
  {
    id: '3215082002',
    districtId: '3215082',
    name: 'Bayur Kidul',
  },
  {
    id: '3215082003',
    districtId: '3215082',
    name: 'Bayur Lor',
  },
  {
    id: '3215082004',
    districtId: '3215082',
    name: 'Langensari',
  },
  {
    id: '3215082005',
    districtId: '3215082',
    name: 'Sukamulya',
  },
  {
    id: '3215082006',
    districtId: '3215082',
    name: 'Pasirukem',
  },
  {
    id: '3215082007',
    districtId: '3215082',
    name: 'Sukajaya',
  },
  {
    id: '3215082008',
    districtId: '3215082',
    name: 'Pasirjaya',
  },
  {
    id: '3215082009',
    districtId: '3215082',
    name: 'Muktijaya',
  },
  {
    id: '3215082010',
    districtId: '3215082',
    name: 'Tegalurung',
  },
  {
    id: '3215082011',
    districtId: '3215082',
    name: 'Manggungjaya',
  },
  {
    id: '3215090001',
    districtId: '3215090',
    name: 'Ciwaringin',
  },
  {
    id: '3215090002',
    districtId: '3215090',
    name: 'Waringinkarya',
  },
  {
    id: '3215090003',
    districtId: '3215090',
    name: 'Pasirtanjung',
  },
  {
    id: '3215090004',
    districtId: '3215090',
    name: 'Karangtanjung',
  },
  {
    id: '3215090005',
    districtId: '3215090',
    name: 'Kedawung',
  },
  {
    id: '3215090006',
    districtId: '3215090',
    name: 'Lemahabang',
  },
  {
    id: '3215090007',
    districtId: '3215090',
    name: 'Karyamukti',
  },
  {
    id: '3215090008',
    districtId: '3215090',
    name: 'Pulojaya',
  },
  {
    id: '3215090009',
    districtId: '3215090',
    name: 'Pulokelapa',
  },
  {
    id: '3215090010',
    districtId: '3215090',
    name: 'Lemahmukti',
  },
  {
    id: '3215090011',
    districtId: '3215090',
    name: 'Pulomulya',
  },
  {
    id: '3215100001',
    districtId: '3215100',
    name: 'Pasirtalaga',
  },
  {
    id: '3215100002',
    districtId: '3215100',
    name: 'Talagamulya',
  },
  {
    id: '3215100003',
    districtId: '3215100',
    name: 'Cariumulya',
  },
  {
    id: '3215100004',
    districtId: '3215100',
    name: 'Cilewo',
  },
  {
    id: '3215100005',
    districtId: '3215100',
    name: 'Linggarsari',
  },
  {
    id: '3215100006',
    districtId: '3215100',
    name: 'Pulosari',
  },
  {
    id: '3215100007',
    districtId: '3215100',
    name: 'Ciwulan',
  },
  {
    id: '3215100008',
    districtId: '3215100',
    name: 'Kalijaya',
  },
  {
    id: '3215100009',
    districtId: '3215100',
    name: 'Cadaskertajaya',
  },
  {
    id: '3215100010',
    districtId: '3215100',
    name: 'Kalibuaya',
  },
  {
    id: '3215100011',
    districtId: '3215100',
    name: 'Talagasari',
  },
  {
    id: '3215100012',
    districtId: '3215100',
    name: 'Pasirmukti',
  },
  {
    id: '3215100013',
    districtId: '3215100',
    name: 'Pasirkamuning',
  },
  {
    id: '3215100014',
    districtId: '3215100',
    name: 'Kalisari',
  },
  {
    id: '3215111001',
    districtId: '3215111',
    name: 'Pasirjengkol',
  },
  {
    id: '3215111002',
    districtId: '3215111',
    name: 'Majalaya',
  },
  {
    id: '3215111003',
    districtId: '3215111',
    name: 'Ciranggon',
  },
  {
    id: '3215111004',
    districtId: '3215111',
    name: 'Sarijaya',
  },
  {
    id: '3215111006',
    districtId: '3215111',
    name: 'Lemahmulya',
  },
  {
    id: '3215111007',
    districtId: '3215111',
    name: 'Pasirmulya',
  },
  {
    id: '3215112001',
    districtId: '3215112',
    name: 'Adiarsa Timur',
  },
  {
    id: '3215112002',
    districtId: '3215112',
    name: 'Warungbambu',
  },
  {
    id: '3215112003',
    districtId: '3215112',
    name: 'Kondangjaya',
  },
  {
    id: '3215112004',
    districtId: '3215112',
    name: 'Margasari',
  },
  {
    id: '3215112005',
    districtId: '3215112',
    name: 'Karawang Wetan',
  },
  {
    id: '3215112006',
    districtId: '3215112',
    name: 'Palumbonsari',
  },
  {
    id: '3215112007',
    districtId: '3215112',
    name: 'Palawad',
  },
  {
    id: '3215112008',
    districtId: '3215112',
    name: 'Tegalsawah',
  },
  {
    id: '3215113001',
    districtId: '3215113',
    name: 'Adiarsa Barat',
  },
  {
    id: '3215113002',
    districtId: '3215113',
    name: 'Nagasari',
  },
  {
    id: '3215113003',
    districtId: '3215113',
    name: 'Karawang Kulon',
  },
  {
    id: '3215113004',
    districtId: '3215113',
    name: 'Tanjungpura',
  },
  {
    id: '3215113005',
    districtId: '3215113',
    name: 'Tanjungmekar',
  },
  {
    id: '3215113006',
    districtId: '3215113',
    name: 'Karangpawitan',
  },
  {
    id: '3215113007',
    districtId: '3215113',
    name: 'Mekarjati',
  },
  {
    id: '3215113008',
    districtId: '3215113',
    name: 'Tunggakjati',
  },
  {
    id: '3215120001',
    districtId: '3215120',
    name: 'Pasirkaliki',
  },
  {
    id: '3215120002',
    districtId: '3215120',
    name: 'Kutawargi',
  },
  {
    id: '3215120003',
    districtId: '3215120',
    name: 'Cibadak',
  },
  {
    id: '3215120004',
    districtId: '3215120',
    name: 'Sukamerta',
  },
  {
    id: '3215120005',
    districtId: '3215120',
    name: 'Pasirawi',
  },
  {
    id: '3215120006',
    districtId: '3215120',
    name: 'Balongsari',
  },
  {
    id: '3215120007',
    districtId: '3215120',
    name: 'Purwamekar',
  },
  {
    id: '3215120008',
    districtId: '3215120',
    name: 'Mekarjaya',
  },
  {
    id: '3215120009',
    districtId: '3215120',
    name: 'Sekarwangi',
  },
  {
    id: '3215120010',
    districtId: '3215120',
    name: 'Panyingkiran',
  },
  {
    id: '3215120011',
    districtId: '3215120',
    name: 'Sukapura',
  },
  {
    id: '3215120012',
    districtId: '3215120',
    name: 'Gombongsari',
  },
  {
    id: '3215120013',
    districtId: '3215120',
    name: 'Sukaraja',
  },
  {
    id: '3215130001',
    districtId: '3215130',
    name: 'Dayeuhluhur',
  },
  {
    id: '3215130002',
    districtId: '3215130',
    name: 'Lemahkarya',
  },
  {
    id: '3215130003',
    districtId: '3215130',
    name: 'Lemahduhur',
  },
  {
    id: '3215130004',
    districtId: '3215130',
    name: 'Lemahsubur',
  },
  {
    id: '3215130005',
    districtId: '3215130',
    name: 'Lemahmakmur',
  },
  {
    id: '3215130006',
    districtId: '3215130',
    name: 'Pagadungan',
  },
  {
    id: '3215130007',
    districtId: '3215130',
    name: 'Purwajaya',
  },
  {
    id: '3215130008',
    districtId: '3215130',
    name: 'Jayanagara',
  },
  {
    id: '3215130009',
    districtId: '3215130',
    name: 'Tempuran',
  },
  {
    id: '3215130010',
    districtId: '3215130',
    name: 'Ciparagejaya',
  },
  {
    id: '3215130011',
    districtId: '3215130',
    name: 'Cikuntul',
  },
  {
    id: '3215130012',
    districtId: '3215130',
    name: 'Sumberjaya',
  },
  {
    id: '3215130013',
    districtId: '3215130',
    name: 'Pancakarya',
  },
  {
    id: '3215130014',
    districtId: '3215130',
    name: 'Tanjungjaya',
  },
  {
    id: '3215140001',
    districtId: '3215140',
    name: 'Sindangkarya',
  },
  {
    id: '3215140002',
    districtId: '3215140',
    name: 'Sindangmukti',
  },
  {
    id: '3215140003',
    districtId: '3215140',
    name: 'Sindangmulya',
  },
  {
    id: '3215140004',
    districtId: '3215140',
    name: 'Mulyajaya',
  },
  {
    id: '3215140005',
    districtId: '3215140',
    name: 'Kutakarya',
  },
  {
    id: '3215140006',
    districtId: '3215140',
    name: 'Kutagandok',
  },
  {
    id: '3215140007',
    districtId: '3215140',
    name: 'Waluya',
  },
  {
    id: '3215140008',
    districtId: '3215140',
    name: 'Sampalan',
  },
  {
    id: '3215140009',
    districtId: '3215140',
    name: 'Sindangsari',
  },
  {
    id: '3215140010',
    districtId: '3215140',
    name: 'Kutaraja',
  },
  {
    id: '3215140011',
    districtId: '3215140',
    name: 'Kutamukti',
  },
  {
    id: '3215140012',
    districtId: '3215140',
    name: 'Kutajaya',
  },
  {
    id: '3215150001',
    districtId: '3215150',
    name: 'Kalangsari',
  },
  {
    id: '3215150002',
    districtId: '3215150',
    name: 'Kalangsuria',
  },
  {
    id: '3215150003',
    districtId: '3215150',
    name: 'Karyasari',
  },
  {
    id: '3215150004',
    districtId: '3215150',
    name: 'Dukuhkarya',
  },
  {
    id: '3215150005',
    districtId: '3215150',
    name: 'Amansari',
  },
  {
    id: '3215150006',
    districtId: '3215150',
    name: 'Rengasdengklok Selatan',
  },
  {
    id: '3215150007',
    districtId: '3215150',
    name: 'Rengasdengklok Utara',
  },
  {
    id: '3215150008',
    districtId: '3215150',
    name: 'Kertasari',
  },
  {
    id: '3215150009',
    districtId: '3215150',
    name: 'Dewisari',
  },
  {
    id: '3215151001',
    districtId: '3215151',
    name: 'Kemiri',
  },
  {
    id: '3215151002',
    districtId: '3215151',
    name: 'Makmurjaya',
  },
  {
    id: '3215151003',
    districtId: '3215151',
    name: 'Jayamakmur',
  },
  {
    id: '3215151004',
    districtId: '3215151',
    name: 'Jayakerta',
  },
  {
    id: '3215151005',
    districtId: '3215151',
    name: 'Kertajaya',
  },
  {
    id: '3215151006',
    districtId: '3215151',
    name: 'Ciptamarga',
  },
  {
    id: '3215151007',
    districtId: '3215151',
    name: 'Medangasem',
  },
  {
    id: '3215151008',
    districtId: '3215151',
    name: 'Kampungsawah',
  },
  {
    id: '3215160001',
    districtId: '3215160',
    name: 'Jatimulya',
  },
  {
    id: '3215160006',
    districtId: '3215160',
    name: 'Kertaraharja',
  },
  {
    id: '3215160007',
    districtId: '3215160',
    name: 'Karangjaya',
  },
  {
    id: '3215160008',
    districtId: '3215160',
    name: 'Malangsari',
  },
  {
    id: '3215160009',
    districtId: '3215160',
    name: 'Kertamulya',
  },
  {
    id: '3215160010',
    districtId: '3215160',
    name: 'Payungsari',
  },
  {
    id: '3215160011',
    districtId: '3215160',
    name: 'Randumulya',
  },
  {
    id: '3215160012',
    districtId: '3215160',
    name: 'Labanjaya',
  },
  {
    id: '3215160015',
    districtId: '3215160',
    name: 'Sungaibuntu',
  },
  {
    id: '3215160016',
    districtId: '3215160',
    name: 'Kedaljaya',
  },
  {
    id: '3215160017',
    districtId: '3215160',
    name: 'Dongkal',
  },
  {
    id: '3215160018',
    districtId: '3215160',
    name: 'Puspasari',
  },
  {
    id: '3215161001',
    districtId: '3215161',
    name: 'Sukaratu',
  },
  {
    id: '3215161002',
    districtId: '3215161',
    name: 'Ciptamargi',
  },
  {
    id: '3215161003',
    districtId: '3215161',
    name: 'Tanjungsari',
  },
  {
    id: '3215161004',
    districtId: '3215161',
    name: 'Mekarpohaci',
  },
  {
    id: '3215161005',
    districtId: '3215161',
    name: 'Kertamukti',
  },
  {
    id: '3215161006',
    districtId: '3215161',
    name: 'Cikande',
  },
  {
    id: '3215161007',
    districtId: '3215161',
    name: 'Rawasari',
  },
  {
    id: '3215161008',
    districtId: '3215161',
    name: 'Kosambibatu',
  },
  {
    id: '3215161009',
    districtId: '3215161',
    name: 'Pusakajaya Selatan',
  },
  {
    id: '3215161010',
    districtId: '3215161',
    name: 'Pusakajaya Utara',
  },
  {
    id: '3215170001',
    districtId: '3215170',
    name: 'Sukasari',
  },
  {
    id: '3215170002',
    districtId: '3215170',
    name: 'Kertarahayu',
  },
  {
    id: '3215170003',
    districtId: '3215170',
    name: 'Cibuaya',
  },
  {
    id: '3215170004',
    districtId: '3215170',
    name: 'Pejaten',
  },
  {
    id: '3215170006',
    districtId: '3215170',
    name: 'Kalidungjaya',
  },
  {
    id: '3215170007',
    districtId: '3215170',
    name: 'Kedungjaya',
  },
  {
    id: '3215170008',
    districtId: '3215170',
    name: 'Jayamulya',
  },
  {
    id: '3215170009',
    districtId: '3215170',
    name: 'Gebangjaya',
  },
  {
    id: '3215170010',
    districtId: '3215170',
    name: 'Cemarajaya',
  },
  {
    id: '3215170011',
    districtId: '3215170',
    name: 'Sedari',
  },
  {
    id: '3215180001',
    districtId: '3215180',
    name: 'Medankarya',
  },
  {
    id: '3215180002',
    districtId: '3215180',
    name: 'Pisangsambo',
  },
  {
    id: '3215180003',
    districtId: '3215180',
    name: 'Sabajaya',
  },
  {
    id: '3215180004',
    districtId: '3215180',
    name: 'Gempolkarya',
  },
  {
    id: '3215180005',
    districtId: '3215180',
    name: 'Srijaya',
  },
  {
    id: '3215180006',
    districtId: '3215180',
    name: 'Kutamakmur',
  },
  {
    id: '3215180007',
    districtId: '3215180',
    name: 'Bolang',
  },
  {
    id: '3215180008',
    districtId: '3215180',
    name: 'Srikamulyan',
  },
  {
    id: '3215180009',
    districtId: '3215180',
    name: 'Sumurlaban',
  },
  {
    id: '3215180010',
    districtId: '3215180',
    name: 'Tambaksumur',
  },
  {
    id: '3215180011',
    districtId: '3215180',
    name: 'Tambaksari',
  },
  {
    id: '3215190001',
    districtId: '3215190',
    name: 'Kutaampel',
  },
  {
    id: '3215190002',
    districtId: '3215190',
    name: 'Karyamakmur',
  },
  {
    id: '3215190003',
    districtId: '3215190',
    name: 'Karyamulya',
  },
  {
    id: '3215190004',
    districtId: '3215190',
    name: 'Telukbango',
  },
  {
    id: '3215190005',
    districtId: '3215190',
    name: 'Telukambulu',
  },
  {
    id: '3215190006',
    districtId: '3215190',
    name: 'Karyabakti',
  },
  {
    id: '3215190007',
    districtId: '3215190',
    name: 'Baturaden',
  },
  {
    id: '3215190008',
    districtId: '3215190',
    name: 'Batujaya',
  },
  {
    id: '3215190009',
    districtId: '3215190',
    name: 'Segaran',
  },
  {
    id: '3215190010',
    districtId: '3215190',
    name: 'Segarjaya',
  },
  {
    id: '3215200001',
    districtId: '3215200',
    name: 'Talagajaya',
  },
  {
    id: '3215200003',
    districtId: '3215200',
    name: 'Tanahbaru',
  },
  {
    id: '3215200004',
    districtId: '3215200',
    name: 'Solokan',
  },
  {
    id: '3215200005',
    districtId: '3215200',
    name: 'Tanjungbungin',
  },
  {
    id: '3215200006',
    districtId: '3215200',
    name: 'Tanjungmekar',
  },
  {
    id: '3215200007',
    districtId: '3215200',
    name: 'Tanjungpakis',
  },
  {
    id: '3215200008',
    districtId: '3215200',
    name: 'Telukjaya',
  },
  {
    id: '3216010001',
    districtId: '3216010',
    name: 'Ragemanunggal',
  },
  {
    id: '3216010002',
    districtId: '3216010',
    name: 'Muktijaya',
  },
  {
    id: '3216010003',
    districtId: '3216010',
    name: 'Kertarahayu',
  },
  {
    id: '3216010004',
    districtId: '3216010',
    name: 'Cikarageman',
  },
  {
    id: '3216010005',
    districtId: '3216010',
    name: 'Taman Sari',
  },
  {
    id: '3216010006',
    districtId: '3216010',
    name: 'Taman Rahayu',
  },
  {
    id: '3216010007',
    districtId: '3216010',
    name: 'Burangkeng',
  },
  {
    id: '3216010008',
    districtId: '3216010',
    name: 'Cileduk',
  },
  {
    id: '3216010009',
    districtId: '3216010',
    name: 'Cibening',
  },
  {
    id: '3216010012',
    districtId: '3216010',
    name: 'Cijengkol',
  },
  {
    id: '3216010013',
    districtId: '3216010',
    name: 'Lubangbuaya',
  },
  {
    id: '3216021001',
    districtId: '3216021',
    name: 'Jayamulya',
  },
  {
    id: '3216021002',
    districtId: '3216021',
    name: 'Sukaragam',
  },
  {
    id: '3216021003',
    districtId: '3216021',
    name: 'Sirnajaya',
  },
  {
    id: '3216021004',
    districtId: '3216021',
    name: 'Nagacipta',
  },
  {
    id: '3216021005',
    districtId: '3216021',
    name: 'Nagasari',
  },
  {
    id: '3216021006',
    districtId: '3216021',
    name: 'Cilangkara',
  },
  {
    id: '3216021007',
    districtId: '3216021',
    name: 'Sukasari',
  },
  {
    id: '3216021008',
    districtId: '3216021',
    name: 'Jayasampurna',
  },
  {
    id: '3216022001',
    districtId: '3216022',
    name: 'Cicau',
  },
  {
    id: '3216022002',
    districtId: '3216022',
    name: 'Sukamahi',
  },
  {
    id: '3216022003',
    districtId: '3216022',
    name: 'Pasirranji',
  },
  {
    id: '3216022004',
    districtId: '3216022',
    name: 'Pasirtanjung',
  },
  {
    id: '3216022005',
    districtId: '3216022',
    name: 'Hegarmukti',
  },
  {
    id: '3216022006',
    districtId: '3216022',
    name: 'Jayamukti',
  },
  {
    id: '3216023001',
    districtId: '3216023',
    name: 'Sukasejati',
  },
  {
    id: '3216023002',
    districtId: '3216023',
    name: 'Ciantra',
  },
  {
    id: '3216023003',
    districtId: '3216023',
    name: 'Sukadami',
  },
  {
    id: '3216023004',
    districtId: '3216023',
    name: 'Serang',
  },
  {
    id: '3216023005',
    districtId: '3216023',
    name: 'Sukaresmi',
  },
  {
    id: '3216023006',
    districtId: '3216023',
    name: 'Cibatu',
  },
  {
    id: '3216023007',
    districtId: '3216023',
    name: 'Pasirsari',
  },
  {
    id: '3216030001',
    districtId: '3216030',
    name: 'Cibarusahjaya',
  },
  {
    id: '3216030002',
    districtId: '3216030',
    name: 'Cibarusahkota',
  },
  {
    id: '3216030003',
    districtId: '3216030',
    name: 'Sindangmulya',
  },
  {
    id: '3216030004',
    districtId: '3216030',
    name: 'Wibawamulya',
  },
  {
    id: '3216030005',
    districtId: '3216030',
    name: 'Sirnajati',
  },
  {
    id: '3216030006',
    districtId: '3216030',
    name: 'Ridogalih',
  },
  {
    id: '3216030007',
    districtId: '3216030',
    name: 'Ridomanah',
  },
  {
    id: '3216031001',
    districtId: '3216031',
    name: 'Karangindah',
  },
  {
    id: '3216031002',
    districtId: '3216031',
    name: 'Karangmulya',
  },
  {
    id: '3216031003',
    districtId: '3216031',
    name: 'Bojongmangu',
  },
  {
    id: '3216031004',
    districtId: '3216031',
    name: 'Medalkrisna',
  },
  {
    id: '3216031005',
    districtId: '3216031',
    name: 'Sukamukti',
  },
  {
    id: '3216031006',
    districtId: '3216031',
    name: 'Sukabungah',
  },
  {
    id: '3216041001',
    districtId: '3216041',
    name: 'Sertajaya',
  },
  {
    id: '3216041002',
    districtId: '3216041',
    name: 'Hegarmanah',
  },
  {
    id: '3216041003',
    districtId: '3216041',
    name: 'Cipayung',
  },
  {
    id: '3216041004',
    districtId: '3216041',
    name: 'Jatireja',
  },
  {
    id: '3216041005',
    districtId: '3216041',
    name: 'Jatibaru',
  },
  {
    id: '3216041006',
    districtId: '3216041',
    name: 'Tanjungbaru',
  },
  {
    id: '3216041007',
    districtId: '3216041',
    name: 'Labansari',
  },
  {
    id: '3216041008',
    districtId: '3216041',
    name: 'Karangsari',
  },
  {
    id: '3216050002',
    districtId: '3216050',
    name: 'Bojongsari',
  },
  {
    id: '3216050003',
    districtId: '3216050',
    name: 'Kedungwaringin',
  },
  {
    id: '3216050004',
    districtId: '3216050',
    name: 'Waringinjaya',
  },
  {
    id: '3216050005',
    districtId: '3216050',
    name: 'Karangsambung',
  },
  {
    id: '3216050007',
    districtId: '3216050',
    name: 'Karangharum',
  },
  {
    id: '3216050008',
    districtId: '3216050',
    name: 'Mekarjaya',
  },
  {
    id: '3216050009',
    districtId: '3216050',
    name: 'Karangmekar',
  },
  {
    id: '3216061001',
    districtId: '3216061',
    name: 'Wangunharja',
  },
  {
    id: '3216061002',
    districtId: '3216061',
    name: 'Harjamekar',
  },
  {
    id: '3216061003',
    districtId: '3216061',
    name: 'Pasirgombong',
  },
  {
    id: '3216061004',
    districtId: '3216061',
    name: 'Mekarmukti',
  },
  {
    id: '3216061005',
    districtId: '3216061',
    name: 'Simpangan',
  },
  {
    id: '3216061006',
    districtId: '3216061',
    name: 'Tanjungsari',
  },
  {
    id: '3216061007',
    districtId: '3216061',
    name: 'Cikarang Kota',
  },
  {
    id: '3216061008',
    districtId: '3216061',
    name: 'Karangbaru',
  },
  {
    id: '3216061009',
    districtId: '3216061',
    name: 'Karangasih',
  },
  {
    id: '3216061010',
    districtId: '3216061',
    name: 'Karangraharja',
  },
  {
    id: '3216061011',
    districtId: '3216061',
    name: 'Waluya',
  },
  {
    id: '3216062001',
    districtId: '3216062',
    name: 'Sukaraya',
  },
  {
    id: '3216062002',
    districtId: '3216062',
    name: 'Karangrahayu',
  },
  {
    id: '3216062003',
    districtId: '3216062',
    name: 'Karangsetia',
  },
  {
    id: '3216062004',
    districtId: '3216062',
    name: 'Karangsatu',
  },
  {
    id: '3216062005',
    districtId: '3216062',
    name: 'Karangmukti',
  },
  {
    id: '3216062006',
    districtId: '3216062',
    name: 'Karanganyar',
  },
  {
    id: '3216062007',
    districtId: '3216062',
    name: 'Karangbahagia',
  },
  {
    id: '3216062008',
    districtId: '3216062',
    name: 'Karangsentosa',
  },
  {
    id: '3216070006',
    districtId: '3216070',
    name: 'Cibuntu',
  },
  {
    id: '3216070013',
    districtId: '3216070',
    name: 'Wanasari',
  },
  {
    id: '3216070014',
    districtId: '3216070',
    name: 'Wanajaya',
  },
  {
    id: '3216070015',
    districtId: '3216070',
    name: 'Sukajaya',
  },
  {
    id: '3216070016',
    districtId: '3216070',
    name: 'Kertamukti',
  },
  {
    id: '3216070017',
    districtId: '3216070',
    name: 'Muktiwari',
  },
  {
    id: '3216070018',
    districtId: '3216070',
    name: 'Sarimukti',
  },
  {
    id: '3216071001',
    districtId: '3216071',
    name: 'Telajung',
  },
  {
    id: '3216071002',
    districtId: '3216071',
    name: 'Cikedokan',
  },
  {
    id: '3216071003',
    districtId: '3216071',
    name: 'Jatiwangi',
  },
  {
    id: '3216071004',
    districtId: '3216071',
    name: 'Mekarwangi',
  },
  {
    id: '3216071005',
    districtId: '3216071',
    name: 'Gandamekar',
  },
  {
    id: '3216071006',
    districtId: '3216071',
    name: 'Danauindah',
  },
  {
    id: '3216071007',
    districtId: '3216071',
    name: 'Gandasari',
  },
  {
    id: '3216071008',
    districtId: '3216071',
    name: 'Sukadanau',
  },
  {
    id: '3216071009',
    districtId: '3216071',
    name: 'Telaga Asih',
  },
  {
    id: '3216071010',
    districtId: '3216071',
    name: 'Telagamurni',
  },
  {
    id: '3216071011',
    districtId: '3216071',
    name: 'Kalijaya',
  },
  {
    id: '3216081001',
    districtId: '3216081',
    name: 'Jatimulya',
  },
  {
    id: '3216081002',
    districtId: '3216081',
    name: 'Lambangsari',
  },
  {
    id: '3216081003',
    districtId: '3216081',
    name: 'Lambangjaya',
  },
  {
    id: '3216081004',
    districtId: '3216081',
    name: 'Tambun',
  },
  {
    id: '3216081005',
    districtId: '3216081',
    name: 'Setiadarma',
  },
  {
    id: '3216081006',
    districtId: '3216081',
    name: 'Setiamekar',
  },
  {
    id: '3216081007',
    districtId: '3216081',
    name: 'Mekarsari',
  },
  {
    id: '3216081008',
    districtId: '3216081',
    name: 'Tridayasakti',
  },
  {
    id: '3216081009',
    districtId: '3216081',
    name: 'Mangunjaya',
  },
  {
    id: '3216081010',
    districtId: '3216081',
    name: 'Sumberjaya',
  },
  {
    id: '3216082001',
    districtId: '3216082',
    name: 'Karangsatria',
  },
  {
    id: '3216082002',
    districtId: '3216082',
    name: 'Satriajaya',
  },
  {
    id: '3216082003',
    districtId: '3216082',
    name: 'Jejalenjaya',
  },
  {
    id: '3216082004',
    districtId: '3216082',
    name: 'Satriamekar',
  },
  {
    id: '3216082005',
    districtId: '3216082',
    name: 'Sriamur',
  },
  {
    id: '3216082006',
    districtId: '3216082',
    name: 'Srimukti',
  },
  {
    id: '3216082007',
    districtId: '3216082',
    name: 'Srijaya',
  },
  {
    id: '3216082008',
    districtId: '3216082',
    name: 'Srimahi',
  },
  {
    id: '3216090001',
    districtId: '3216090',
    name: 'Bahagia',
  },
  {
    id: '3216090002',
    districtId: '3216090',
    name: 'Kebalen',
  },
  {
    id: '3216090003',
    districtId: '3216090',
    name: 'Babelan Kota',
  },
  {
    id: '3216090004',
    districtId: '3216090',
    name: 'Kedungpengawas',
  },
  {
    id: '3216090005',
    districtId: '3216090',
    name: 'Kedungjaya',
  },
  {
    id: '3216090006',
    districtId: '3216090',
    name: 'Bunibakti',
  },
  {
    id: '3216090007',
    districtId: '3216090',
    name: 'Muarabakti',
  },
  {
    id: '3216090008',
    districtId: '3216090',
    name: 'Pantai Hurip',
  },
  {
    id: '3216090009',
    districtId: '3216090',
    name: 'Huripjaya',
  },
  {
    id: '3216100001',
    districtId: '3216100',
    name: 'Pusakarakyat',
  },
  {
    id: '3216100002',
    districtId: '3216100',
    name: 'Setia Asih',
  },
  {
    id: '3216100003',
    districtId: '3216100',
    name: 'Pahlawan Setia',
  },
  {
    id: '3216100004',
    districtId: '3216100',
    name: 'Setiamulya',
  },
  {
    id: '3216100005',
    districtId: '3216100',
    name: 'Segaramakmur',
  },
  {
    id: '3216100006',
    districtId: '3216100',
    name: 'Pantaimakmur',
  },
  {
    id: '3216100007',
    districtId: '3216100',
    name: 'Segarajaya',
  },
  {
    id: '3216100008',
    districtId: '3216100',
    name: 'Samudrajaya',
  },
  {
    id: '3216110003',
    districtId: '3216110',
    name: 'Sukamaju',
  },
  {
    id: '3216110004',
    districtId: '3216110',
    name: 'Sukaraja',
  },
  {
    id: '3216110005',
    districtId: '3216110',
    name: 'Sukarapih',
  },
  {
    id: '3216110006',
    districtId: '3216110',
    name: 'Sukarahayu',
  },
  {
    id: '3216110007',
    districtId: '3216110',
    name: 'Sukabakti',
  },
  {
    id: '3216110008',
    districtId: '3216110',
    name: 'Sukawijaya',
  },
  {
    id: '3216110009',
    districtId: '3216110',
    name: 'Sukamantri',
  },
  {
    id: '3216111001',
    districtId: '3216111',
    name: 'Sukamekar',
  },
  {
    id: '3216111002',
    districtId: '3216111',
    name: 'Sukadaya',
  },
  {
    id: '3216111003',
    districtId: '3216111',
    name: 'Sukabudi',
  },
  {
    id: '3216111004',
    districtId: '3216111',
    name: 'Sukawangi',
  },
  {
    id: '3216111005',
    districtId: '3216111',
    name: 'Sukakerta',
  },
  {
    id: '3216111006',
    districtId: '3216111',
    name: 'Sukaringin',
  },
  {
    id: '3216111007',
    districtId: '3216111',
    name: 'Sukatenang',
  },
  {
    id: '3216120001',
    districtId: '3216120',
    name: 'Sukaasih',
  },
  {
    id: '3216120002',
    districtId: '3216120',
    name: 'Sukarukun',
  },
  {
    id: '3216120003',
    districtId: '3216120',
    name: 'Banjarsari',
  },
  {
    id: '3216120004',
    districtId: '3216120',
    name: 'Sukahurip',
  },
  {
    id: '3216120005',
    districtId: '3216120',
    name: 'Sukamanah',
  },
  {
    id: '3216120006',
    districtId: '3216120',
    name: 'Sukamulya',
  },
  {
    id: '3216120007',
    districtId: '3216120',
    name: 'Sukadarma',
  },
  {
    id: '3216121001',
    districtId: '3216121',
    name: 'Sukajadi',
  },
  {
    id: '3216121002',
    districtId: '3216121',
    name: 'Sukamakmur',
  },
  {
    id: '3216121003',
    districtId: '3216121',
    name: 'Sukalaksana',
  },
  {
    id: '3216121004',
    districtId: '3216121',
    name: 'Sukakarsa',
  },
  {
    id: '3216121005',
    districtId: '3216121',
    name: 'Sukakarya',
  },
  {
    id: '3216121006',
    districtId: '3216121',
    name: 'Sukaindah',
  },
  {
    id: '3216121007',
    districtId: '3216121',
    name: 'Sukamurni',
  },
  {
    id: '3216130001',
    districtId: '3216130',
    name: 'Bantarsari',
  },
  {
    id: '3216130002',
    districtId: '3216130',
    name: 'Bantarjaya',
  },
  {
    id: '3216130003',
    districtId: '3216130',
    name: 'Kertasari',
  },
  {
    id: '3216130004',
    districtId: '3216130',
    name: 'Kertajaya',
  },
  {
    id: '3216130005',
    districtId: '3216130',
    name: 'Karanghaur',
  },
  {
    id: '3216130006',
    districtId: '3216130',
    name: 'Karangpatri',
  },
  {
    id: '3216130007',
    districtId: '3216130',
    name: 'Karangreja',
  },
  {
    id: '3216130008',
    districtId: '3216130',
    name: 'Karangjaya',
  },
  {
    id: '3216130009',
    districtId: '3216130',
    name: 'Sumbersari',
  },
  {
    id: '3216130010',
    districtId: '3216130',
    name: 'Sumberreja',
  },
  {
    id: '3216130011',
    districtId: '3216130',
    name: 'Sumberurip',
  },
  {
    id: '3216130012',
    districtId: '3216130',
    name: 'Karangsegar',
  },
  {
    id: '3216130013',
    districtId: '3216130',
    name: 'Karangharja',
  },
  {
    id: '3216140001',
    districtId: '3216140',
    name: 'Jayabakti',
  },
  {
    id: '3216140002',
    districtId: '3216140',
    name: 'Sindangjaya',
  },
  {
    id: '3216140003',
    districtId: '3216140',
    name: 'Sindangsari',
  },
  {
    id: '3216140004',
    districtId: '3216140',
    name: 'Jayalaksana',
  },
  {
    id: '3216140005',
    districtId: '3216140',
    name: 'Setialaksana',
  },
  {
    id: '3216140006',
    districtId: '3216140',
    name: 'Lenggahjaya',
  },
  {
    id: '3216140007',
    districtId: '3216140',
    name: 'Setiajaya',
  },
  {
    id: '3216140008',
    districtId: '3216140',
    name: 'Lenggahsari',
  },
  {
    id: '3216150001',
    districtId: '3216150',
    name: 'Pantai Harapanjaya',
  },
  {
    id: '3216150002',
    districtId: '3216150',
    name: 'Pantaimekar',
  },
  {
    id: '3216150003',
    districtId: '3216150',
    name: 'Pantai Sederhana',
  },
  {
    id: '3216150004',
    districtId: '3216150',
    name: 'Pantaibakti',
  },
  {
    id: '3216150005',
    districtId: '3216150',
    name: 'Pantaibahagia',
  },
  {
    id: '3216150006',
    districtId: '3216150',
    name: 'Jayasakti',
  },
  {
    id: '3217010001',
    districtId: '3217010',
    name: 'Cicadas',
  },
  {
    id: '3217010002',
    districtId: '3217010',
    name: 'Cibedug',
  },
  {
    id: '3217010003',
    districtId: '3217010',
    name: 'Sukamanah',
  },
  {
    id: '3217010004',
    districtId: '3217010',
    name: 'Bojong',
  },
  {
    id: '3217010005',
    districtId: '3217010',
    name: 'Bojongsalam',
  },
  {
    id: '3217010006',
    districtId: '3217010',
    name: 'Cinengah',
  },
  {
    id: '3217010007',
    districtId: '3217010',
    name: 'Sukaresmi',
  },
  {
    id: '3217010008',
    districtId: '3217010',
    name: 'Cibitung',
  },
  {
    id: '3217020001',
    districtId: '3217020',
    name: 'Cilangari',
  },
  {
    id: '3217020002',
    districtId: '3217020',
    name: 'Sindangjaya',
  },
  {
    id: '3217020003',
    districtId: '3217020',
    name: 'Bunijaya',
  },
  {
    id: '3217020004',
    districtId: '3217020',
    name: 'Sirnajaya',
  },
  {
    id: '3217020005',
    districtId: '3217020',
    name: 'Gununghalu',
  },
  {
    id: '3217020006',
    districtId: '3217020',
    name: 'Celak',
  },
  {
    id: '3217020007',
    districtId: '3217020',
    name: 'Wargasaluyu',
  },
  {
    id: '3217020008',
    districtId: '3217020',
    name: 'Sukasari',
  },
  {
    id: '3217020009',
    districtId: '3217020',
    name: 'Tamanjaya',
  },
  {
    id: '3217030001',
    districtId: '3217030',
    name: 'Mekarwangi',
  },
  {
    id: '3217030002',
    districtId: '3217030',
    name: 'Weninggalih',
  },
  {
    id: '3217030003',
    districtId: '3217030',
    name: 'Wangunsari',
  },
  {
    id: '3217030004',
    districtId: '3217030',
    name: 'Buninagara',
  },
  {
    id: '3217030005',
    districtId: '3217030',
    name: 'Cikadu',
  },
  {
    id: '3217030006',
    districtId: '3217030',
    name: 'Ranca Senggang',
  },
  {
    id: '3217030007',
    districtId: '3217030',
    name: 'Cintakarya',
  },
  {
    id: '3217030008',
    districtId: '3217030',
    name: 'Cicangkang Girang',
  },
  {
    id: '3217030009',
    districtId: '3217030',
    name: 'Puncaksari',
  },
  {
    id: '3217030010',
    districtId: '3217030',
    name: 'Pasirpogor',
  },
  {
    id: '3217030011',
    districtId: '3217030',
    name: 'Sindangkerta',
  },
  {
    id: '3217040001',
    districtId: '3217040',
    name: 'Karyamukti',
  },
  {
    id: '3217040002',
    districtId: '3217040',
    name: 'Nanggerang',
  },
  {
    id: '3217040003',
    districtId: '3217040',
    name: 'Mukapayung',
  },
  {
    id: '3217040004',
    districtId: '3217040',
    name: 'Rancapanggung',
  },
  {
    id: '3217040005',
    districtId: '3217040',
    name: 'Bongas',
  },
  {
    id: '3217040006',
    districtId: '3217040',
    name: 'Batulayang',
  },
  {
    id: '3217040007',
    districtId: '3217040',
    name: 'Cililin',
  },
  {
    id: '3217040008',
    districtId: '3217040',
    name: 'Karangtanjung',
  },
  {
    id: '3217040010',
    districtId: '3217040',
    name: 'Kidangpananjung',
  },
  {
    id: '3217040018',
    districtId: '3217040',
    name: 'Budiharja',
  },
  {
    id: '3217040019',
    districtId: '3217040',
    name: 'Karanganyar',
  },
  {
    id: '3217050009',
    districtId: '3217050',
    name: 'Singajaya',
  },
  {
    id: '3217050011',
    districtId: '3217050',
    name: 'Tanjungwangi',
  },
  {
    id: '3217050012',
    districtId: '3217050',
    name: 'Situwangi',
  },
  {
    id: '3217050013',
    districtId: '3217050',
    name: 'Pataruman',
  },
  {
    id: '3217050014',
    districtId: '3217050',
    name: 'Cipatik',
  },
  {
    id: '3217050015',
    districtId: '3217050',
    name: 'Citapen',
  },
  {
    id: '3217050016',
    districtId: '3217050',
    name: 'Cihampelas',
  },
  {
    id: '3217050017',
    districtId: '3217050',
    name: 'Mekarmukti',
  },
  {
    id: '3217050020',
    districtId: '3217050',
    name: 'Tanjungjaya',
  },
  {
    id: '3217050021',
    districtId: '3217050',
    name: 'Mekarjaya',
  },
  {
    id: '3217060001',
    districtId: '3217060',
    name: 'Cintaasih',
  },
  {
    id: '3217060002',
    districtId: '3217060',
    name: 'Karangsari',
  },
  {
    id: '3217060003',
    districtId: '3217060',
    name: 'Neglasari',
  },
  {
    id: '3217060004',
    districtId: '3217060',
    name: 'Girimukti',
  },
  {
    id: '3217060005',
    districtId: '3217060',
    name: 'Cijenuk',
  },
  {
    id: '3217060006',
    districtId: '3217060',
    name: 'Cicangkang Hilir',
  },
  {
    id: '3217060007',
    districtId: '3217060',
    name: 'Sukamulya',
  },
  {
    id: '3217060008',
    districtId: '3217060',
    name: 'Citalem',
  },
  {
    id: '3217060009',
    districtId: '3217060',
    name: 'Mekarsari',
  },
  {
    id: '3217060010',
    districtId: '3217060',
    name: 'Sarinagen',
  },
  {
    id: '3217060011',
    districtId: '3217060',
    name: 'Cibenda',
  },
  {
    id: '3217060012',
    districtId: '3217060',
    name: 'Cijambu',
  },
  {
    id: '3217060013',
    districtId: '3217060',
    name: 'Sirnagalih',
  },
  {
    id: '3217060014',
    districtId: '3217060',
    name: 'Baranangsiang',
  },
  {
    id: '3217070001',
    districtId: '3217070',
    name: 'Selacau',
  },
  {
    id: '3217070002',
    districtId: '3217070',
    name: 'Batujajar Barat',
  },
  {
    id: '3217070003',
    districtId: '3217070',
    name: 'Batujajar Timur',
  },
  {
    id: '3217070004',
    districtId: '3217070',
    name: 'Giriasih',
  },
  {
    id: '3217070005',
    districtId: '3217070',
    name: 'Galanggang',
  },
  {
    id: '3217070006',
    districtId: '3217070',
    name: 'Pangauban',
  },
  {
    id: '3217070007',
    districtId: '3217070',
    name: 'Cangkorah',
  },
  {
    id: '3217071001',
    districtId: '3217071',
    name: 'Bojonghaleuang',
  },
  {
    id: '3217071002',
    districtId: '3217071',
    name: 'Cikande',
  },
  {
    id: '3217071003',
    districtId: '3217071',
    name: 'Girimukti',
  },
  {
    id: '3217071004',
    districtId: '3217071',
    name: 'Cipangeran',
  },
  {
    id: '3217071005',
    districtId: '3217071',
    name: 'Jati',
  },
  {
    id: '3217071006',
    districtId: '3217071',
    name: 'Saguling',
  },
  {
    id: '3217080001',
    districtId: '3217080',
    name: 'Rajamandala Kulon',
  },
  {
    id: '3217080002',
    districtId: '3217080',
    name: 'Ciptaharja',
  },
  {
    id: '3217080003',
    districtId: '3217080',
    name: 'Cipatat',
  },
  {
    id: '3217080004',
    districtId: '3217080',
    name: 'Citatah',
  },
  {
    id: '3217080005',
    districtId: '3217080',
    name: 'Gunungmasigit',
  },
  {
    id: '3217080006',
    districtId: '3217080',
    name: 'Cirawamekar',
  },
  {
    id: '3217080007',
    districtId: '3217080',
    name: 'Nyalindung',
  },
  {
    id: '3217080008',
    districtId: '3217080',
    name: 'Sumurbandung',
  },
  {
    id: '3217080009',
    districtId: '3217080',
    name: 'Kertamukti',
  },
  {
    id: '3217080010',
    districtId: '3217080',
    name: 'Sarimukti',
  },
  {
    id: '3217080011',
    districtId: '3217080',
    name: 'Mandalasari',
  },
  {
    id: '3217080012',
    districtId: '3217080',
    name: 'Mandalawangi',
  },
  {
    id: '3217090001',
    districtId: '3217090',
    name: 'Laksanamekar',
  },
  {
    id: '3217090002',
    districtId: '3217090',
    name: 'Cimerang',
  },
  {
    id: '3217090003',
    districtId: '3217090',
    name: 'Cipeundeuy',
  },
  {
    id: '3217090004',
    districtId: '3217090',
    name: 'Kertajaya',
  },
  {
    id: '3217090005',
    districtId: '3217090',
    name: 'Jayamekar',
  },
  {
    id: '3217090006',
    districtId: '3217090',
    name: 'Padalarang',
  },
  {
    id: '3217090007',
    districtId: '3217090',
    name: 'Kertamulya',
  },
  {
    id: '3217090008',
    districtId: '3217090',
    name: 'Ciburuy',
  },
  {
    id: '3217090009',
    districtId: '3217090',
    name: 'Tagogapu',
  },
  {
    id: '3217090010',
    districtId: '3217090',
    name: 'Cempakamekar',
  },
  {
    id: '3217100001',
    districtId: '3217100',
    name: 'Cimareme',
  },
  {
    id: '3217100002',
    districtId: '3217100',
    name: 'Gadobangkong',
  },
  {
    id: '3217100003',
    districtId: '3217100',
    name: 'Tanimulya',
  },
  {
    id: '3217100004',
    districtId: '3217100',
    name: 'Pakuhaji',
  },
  {
    id: '3217100005',
    districtId: '3217100',
    name: 'Cilame',
  },
  {
    id: '3217100006',
    districtId: '3217100',
    name: 'Margajaya',
  },
  {
    id: '3217100007',
    districtId: '3217100',
    name: 'Mekarsari',
  },
  {
    id: '3217100008',
    districtId: '3217100',
    name: 'Ngamprah',
  },
  {
    id: '3217100009',
    districtId: '3217100',
    name: 'Sukatani',
  },
  {
    id: '3217100010',
    districtId: '3217100',
    name: 'Cimanggu',
  },
  {
    id: '3217100011',
    districtId: '3217100',
    name: 'Bojongkoneng',
  },
  {
    id: '3217110001',
    districtId: '3217110',
    name: 'Ciwaruga',
  },
  {
    id: '3217110002',
    districtId: '3217110',
    name: 'Cihideung',
  },
  {
    id: '3217110003',
    districtId: '3217110',
    name: 'Cigugur Girang',
  },
  {
    id: '3217110004',
    districtId: '3217110',
    name: 'Sariwangi',
  },
  {
    id: '3217110005',
    districtId: '3217110',
    name: 'Cihanjuang',
  },
  {
    id: '3217110006',
    districtId: '3217110',
    name: 'Cihanjuang Rahayu',
  },
  {
    id: '3217110007',
    districtId: '3217110',
    name: 'Karyawangi',
  },
  {
    id: '3217120001',
    districtId: '3217120',
    name: 'Gudangkahuripan',
  },
  {
    id: '3217120002',
    districtId: '3217120',
    name: 'Wangunsari',
  },
  {
    id: '3217120003',
    districtId: '3217120',
    name: 'Pagerwangi',
  },
  {
    id: '3217120004',
    districtId: '3217120',
    name: 'Mekarwangi',
  },
  {
    id: '3217120005',
    districtId: '3217120',
    name: 'Langensari',
  },
  {
    id: '3217120006',
    districtId: '3217120',
    name: 'Kayuambon',
  },
  {
    id: '3217120007',
    districtId: '3217120',
    name: 'Lembang',
  },
  {
    id: '3217120008',
    districtId: '3217120',
    name: 'Cikahuripan',
  },
  {
    id: '3217120009',
    districtId: '3217120',
    name: 'Sukajaya',
  },
  {
    id: '3217120010',
    districtId: '3217120',
    name: 'Jayagiri',
  },
  {
    id: '3217120011',
    districtId: '3217120',
    name: 'Cibogo',
  },
  {
    id: '3217120012',
    districtId: '3217120',
    name: 'Cikole',
  },
  {
    id: '3217120013',
    districtId: '3217120',
    name: 'Cikidang',
  },
  {
    id: '3217120014',
    districtId: '3217120',
    name: 'Wangunharja',
  },
  {
    id: '3217120015',
    districtId: '3217120',
    name: 'Cibodas',
  },
  {
    id: '3217120016',
    districtId: '3217120',
    name: 'Suntenjaya',
  },
  {
    id: '3217130001',
    districtId: '3217130',
    name: 'Pasirhalang',
  },
  {
    id: '3217130002',
    districtId: '3217130',
    name: 'Jambudipa',
  },
  {
    id: '3217130003',
    districtId: '3217130',
    name: 'Padaasih',
  },
  {
    id: '3217130004',
    districtId: '3217130',
    name: 'Kertawangi',
  },
  {
    id: '3217130005',
    districtId: '3217130',
    name: 'Tugumukti',
  },
  {
    id: '3217130006',
    districtId: '3217130',
    name: 'Pasirlangu',
  },
  {
    id: '3217130007',
    districtId: '3217130',
    name: 'Cipada',
  },
  {
    id: '3217130008',
    districtId: '3217130',
    name: 'Sadangmekar',
  },
  {
    id: '3217140001',
    districtId: '3217140',
    name: 'Kanangasari',
  },
  {
    id: '3217140002',
    districtId: '3217140',
    name: 'Mandalasari',
  },
  {
    id: '3217140003',
    districtId: '3217140',
    name: 'Mekarjaya',
  },
  {
    id: '3217140004',
    districtId: '3217140',
    name: 'Cipada',
  },
  {
    id: '3217140005',
    districtId: '3217140',
    name: 'Ganjarsari',
  },
  {
    id: '3217140006',
    districtId: '3217140',
    name: 'Mandalamukti',
  },
  {
    id: '3217140007',
    districtId: '3217140',
    name: 'Ciptagumati',
  },
  {
    id: '3217140008',
    districtId: '3217140',
    name: 'Cikalong',
  },
  {
    id: '3217140010',
    districtId: '3217140',
    name: 'Puteran',
  },
  {
    id: '3217140011',
    districtId: '3217140',
    name: 'Tenjolaut',
  },
  {
    id: '3217140012',
    districtId: '3217140',
    name: 'Cisomang Barat',
  },
  {
    id: '3217140013',
    districtId: '3217140',
    name: 'Wangunjaya',
  },
  {
    id: '3217150001',
    districtId: '3217150',
    name: 'Margaluyu',
  },
  {
    id: '3217150002',
    districtId: '3217150',
    name: 'Nanggeleng',
  },
  {
    id: '3217150003',
    districtId: '3217150',
    name: 'Sirnaraja',
  },
  {
    id: '3217150004',
    districtId: '3217150',
    name: 'Jatimekar',
  },
  {
    id: '3217150005',
    districtId: '3217150',
    name: 'Bojongmekar',
  },
  {
    id: '3217150006',
    districtId: '3217150',
    name: 'Nyenang',
  },
  {
    id: '3217150007',
    districtId: '3217150',
    name: 'Cipeundeuy',
  },
  {
    id: '3217150008',
    districtId: '3217150',
    name: 'Margalaksana',
  },
  {
    id: '3217150009',
    districtId: '3217150',
    name: 'Sukahaji',
  },
  {
    id: '3217150010',
    districtId: '3217150',
    name: 'Ciharashas',
  },
  {
    id: '3217150011',
    districtId: '3217150',
    name: 'Sirnagalih',
  },
  {
    id: '3217150012',
    districtId: '3217150',
    name: 'Ciroyom',
  },
  {
    id: '3218010001',
    districtId: '3218010',
    name: 'Kertamukti',
  },
  {
    id: '3218010002',
    districtId: '3218010',
    name: 'Ciparanti',
  },
  {
    id: '3218010003',
    districtId: '3218010',
    name: 'Legokjawa',
  },
  {
    id: '3218010004',
    districtId: '3218010',
    name: 'Masawah',
  },
  {
    id: '3218010005',
    districtId: '3218010',
    name: 'Batumalang',
  },
  {
    id: '3218010006',
    districtId: '3218010',
    name: 'Cimerak',
  },
  {
    id: '3218010007',
    districtId: '3218010',
    name: 'Limusgede',
  },
  {
    id: '3218010008',
    districtId: '3218010',
    name: 'Kertaharja',
  },
  {
    id: '3218010009',
    districtId: '3218010',
    name: 'Mekarsari',
  },
  {
    id: '3218010010',
    districtId: '3218010',
    name: 'Sindangsari',
  },
  {
    id: '3218010011',
    districtId: '3218010',
    name: 'Sukajaya',
  },
  {
    id: '3218020001',
    districtId: '3218020',
    name: 'Ciakar',
  },
  {
    id: '3218020002',
    districtId: '3218020',
    name: 'Cibanten',
  },
  {
    id: '3218020003',
    districtId: '3218020',
    name: 'Kertayasa',
  },
  {
    id: '3218020004',
    districtId: '3218020',
    name: 'Batukaras',
  },
  {
    id: '3218020005',
    districtId: '3218020',
    name: 'Cijulang',
  },
  {
    id: '3218020006',
    districtId: '3218020',
    name: 'Kondangjajar',
  },
  {
    id: '3218020007',
    districtId: '3218020',
    name: 'Margacinta',
  },
  {
    id: '3218030001',
    districtId: '3218030',
    name: 'Kertajaya',
  },
  {
    id: '3218030002',
    districtId: '3218030',
    name: 'Bunisari',
  },
  {
    id: '3218030003',
    districtId: '3218030',
    name: 'Cimindi',
  },
  {
    id: '3218030004',
    districtId: '3218030',
    name: 'Cigugur',
  },
  {
    id: '3218030005',
    districtId: '3218030',
    name: 'Campaka',
  },
  {
    id: '3218030006',
    districtId: '3218030',
    name: 'Pagerbumi',
  },
  {
    id: '3218030007',
    districtId: '3218030',
    name: 'Harum Mandala',
  },
  {
    id: '3218040001',
    districtId: '3218040',
    name: 'Jadimulya',
  },
  {
    id: '3218040002',
    districtId: '3218040',
    name: 'Bangunkarya',
  },
  {
    id: '3218040003',
    districtId: '3218040',
    name: 'Sukamulya',
  },
  {
    id: '3218040004',
    districtId: '3218040',
    name: 'Jadikarya',
  },
  {
    id: '3218040005',
    districtId: '3218040',
    name: 'Bunguraya',
  },
  {
    id: '3218040006',
    districtId: '3218040',
    name: 'Bojong',
  },
  {
    id: '3218040007',
    districtId: '3218040',
    name: 'Karangkamiri',
  },
  {
    id: '3218040008',
    districtId: '3218040',
    name: 'Cisarua',
  },
  {
    id: '3218040009',
    districtId: '3218040',
    name: 'Cimanggu',
  },
  {
    id: '3218040010',
    districtId: '3218040',
    name: 'Bangunjaya',
  },
  {
    id: '3218040011',
    districtId: '3218040',
    name: 'Langkaplancar',
  },
  {
    id: '3218040012',
    districtId: '3218040',
    name: 'Jayasari',
  },
  {
    id: '3218040013',
    districtId: '3218040',
    name: 'Pangkalan',
  },
  {
    id: '3218040014',
    districtId: '3218040',
    name: 'Bojongkondang',
  },
  {
    id: '3218040015',
    districtId: '3218040',
    name: 'Mekarwangi',
  },
  {
    id: '3218050001',
    districtId: '3218050',
    name: 'Karangjaladri',
  },
  {
    id: '3218050002',
    districtId: '3218050',
    name: 'Parigi',
  },
  {
    id: '3218050003',
    districtId: '3218050',
    name: 'Karangbenda',
  },
  {
    id: '3218050004',
    districtId: '3218050',
    name: 'Ciliang',
  },
  {
    id: '3218050005',
    districtId: '3218050',
    name: 'Cibenda',
  },
  {
    id: '3218050006',
    districtId: '3218050',
    name: 'Bojong',
  },
  {
    id: '3218050007',
    districtId: '3218050',
    name: 'Selasari',
  },
  {
    id: '3218050008',
    districtId: '3218050',
    name: 'Cintaratu',
  },
  {
    id: '3218050009',
    districtId: '3218050',
    name: 'Cintakarya',
  },
  {
    id: '3218050010',
    districtId: '3218050',
    name: 'Parakanmanggu',
  },
  {
    id: '3218060001',
    districtId: '3218060',
    name: 'Sukaresik',
  },
  {
    id: '3218060002',
    districtId: '3218060',
    name: 'Cikembulan',
  },
  {
    id: '3218060003',
    districtId: '3218060',
    name: 'Pajaten',
  },
  {
    id: '3218060004',
    districtId: '3218060',
    name: 'Sidamulih',
  },
  {
    id: '3218060005',
    districtId: '3218060',
    name: 'Cikalong',
  },
  {
    id: '3218060006',
    districtId: '3218060',
    name: 'Kersaratu',
  },
  {
    id: '3218060007',
    districtId: '3218060',
    name: 'Kalijati',
  },
  {
    id: '3218070001',
    districtId: '3218070',
    name: 'Wonoharjo',
  },
  {
    id: '3218070002',
    districtId: '3218070',
    name: 'Pananjung',
  },
  {
    id: '3218070003',
    districtId: '3218070',
    name: 'Pangandaran',
  },
  {
    id: '3218070004',
    districtId: '3218070',
    name: 'Babakan',
  },
  {
    id: '3218070005',
    districtId: '3218070',
    name: 'Sukahurip',
  },
  {
    id: '3218070006',
    districtId: '3218070',
    name: 'Purbahayu',
  },
  {
    id: '3218070007',
    districtId: '3218070',
    name: 'Sidomulyo',
  },
  {
    id: '3218070008',
    districtId: '3218070',
    name: 'Pagergunung',
  },
  {
    id: '3218080001',
    districtId: '3218080',
    name: 'Putrapinggan',
  },
  {
    id: '3218080002',
    districtId: '3218080',
    name: 'Emplak',
  },
  {
    id: '3218080003',
    districtId: '3218080',
    name: 'Bagolo',
  },
  {
    id: '3218080004',
    districtId: '3218080',
    name: 'Pamotan',
  },
  {
    id: '3218080005',
    districtId: '3218080',
    name: 'Kalipucang',
  },
  {
    id: '3218080006',
    districtId: '3218080',
    name: 'Cibuluh',
  },
  {
    id: '3218080007',
    districtId: '3218080',
    name: 'Banjarharja',
  },
  {
    id: '3218080008',
    districtId: '3218080',
    name: 'Tunggilis',
  },
  {
    id: '3218080009',
    districtId: '3218080',
    name: 'Ciparakan',
  },
  {
    id: '3218090001',
    districtId: '3218090',
    name: 'Panyutran',
  },
  {
    id: '3218090002',
    districtId: '3218090',
    name: 'Bojongsari',
  },
  {
    id: '3218090003',
    districtId: '3218090',
    name: 'Ciganjeng',
  },
  {
    id: '3218090004',
    districtId: '3218090',
    name: 'Sukanagara',
  },
  {
    id: '3218090005',
    districtId: '3218090',
    name: 'Sindangwangi',
  },
  {
    id: '3218090006',
    districtId: '3218090',
    name: 'Karangsari',
  },
  {
    id: '3218090007',
    districtId: '3218090',
    name: 'Paledah',
  },
  {
    id: '3218090008',
    districtId: '3218090',
    name: 'Maruyung Sari',
  },
  {
    id: '3218090009',
    districtId: '3218090',
    name: 'Karangpawitan',
  },
  {
    id: '3218090010',
    districtId: '3218090',
    name: 'Padaherang',
  },
  {
    id: '3218090012',
    districtId: '3218090',
    name: 'Karangmulya',
  },
  {
    id: '3218090013',
    districtId: '3218090',
    name: 'Cibogo',
  },
  {
    id: '3218090014',
    districtId: '3218090',
    name: 'Pasirgeulis',
  },
  {
    id: '3218100001',
    districtId: '3218100',
    name: 'Sukamaju',
  },
  {
    id: '3218100002',
    districtId: '3218100',
    name: 'Kertajaya',
  },
  {
    id: '3218100003',
    districtId: '3218100',
    name: 'Mangunjaya',
  },
  {
    id: '3218100004',
    districtId: '3218100',
    name: 'Jangraga',
  },
  {
    id: '3218100005',
    districtId: '3218100',
    name: 'Sindang Jaya',
  },
  {
    id: '3271010001',
    districtId: '3271010',
    name: 'Mulyaharja',
  },
  {
    id: '3271010002',
    districtId: '3271010',
    name: 'Pamoyanan',
  },
  {
    id: '3271010003',
    districtId: '3271010',
    name: 'Ranggamekar',
  },
  {
    id: '3271010005',
    districtId: '3271010',
    name: 'Kertamaya',
  },
  {
    id: '3271010006',
    districtId: '3271010',
    name: 'Rancamaya',
  },
  {
    id: '3271010007',
    districtId: '3271010',
    name: 'Bojongkerta',
  },
  {
    id: '3271010008',
    districtId: '3271010',
    name: 'Harjasari',
  },
  {
    id: '3271010009',
    districtId: '3271010',
    name: 'Muarasari',
  },
  {
    id: '3271010010',
    districtId: '3271010',
    name: 'Pakuan',
  },
  {
    id: '3271010011',
    districtId: '3271010',
    name: 'Cipaku',
  },
  {
    id: '3271010012',
    districtId: '3271010',
    name: 'Lawanggintung',
  },
  {
    id: '3271010013',
    districtId: '3271010',
    name: 'Batutulis',
  },
  {
    id: '3271010014',
    districtId: '3271010',
    name: 'Bondongan',
  },
  {
    id: '3271010015',
    districtId: '3271010',
    name: 'Empang',
  },
  {
    id: '3271010016',
    districtId: '3271010',
    name: 'Cikaret',
  },
  {
    id: '3271020001',
    districtId: '3271020',
    name: 'Sindangsari',
  },
  {
    id: '3271020002',
    districtId: '3271020',
    name: 'Sindangrasa',
  },
  {
    id: '3271020003',
    districtId: '3271020',
    name: 'Tajur',
  },
  {
    id: '3271020004',
    districtId: '3271020',
    name: 'Katulampa',
  },
  {
    id: '3271020005',
    districtId: '3271020',
    name: 'Baranangsiang',
  },
  {
    id: '3271020006',
    districtId: '3271020',
    name: 'Sukasari',
  },
  {
    id: '3271030001',
    districtId: '3271030',
    name: 'Bantarjati',
  },
  {
    id: '3271030002',
    districtId: '3271030',
    name: 'Tegalgundil',
  },
  {
    id: '3271030003',
    districtId: '3271030',
    name: 'Tanahbaru',
  },
  {
    id: '3271030004',
    districtId: '3271030',
    name: 'Cimahpar',
  },
  {
    id: '3271030005',
    districtId: '3271030',
    name: 'Ciluar',
  },
  {
    id: '3271030006',
    districtId: '3271030',
    name: 'Cibuluh',
  },
  {
    id: '3271030007',
    districtId: '3271030',
    name: 'Kedunghalang',
  },
  {
    id: '3271030008',
    districtId: '3271030',
    name: 'Ciparigi',
  },
  {
    id: '3271040001',
    districtId: '3271040',
    name: 'Paledang',
  },
  {
    id: '3271040002',
    districtId: '3271040',
    name: 'Gudang',
  },
  {
    id: '3271040003',
    districtId: '3271040',
    name: 'Babakanpasar',
  },
  {
    id: '3271040004',
    districtId: '3271040',
    name: 'Tegallega',
  },
  {
    id: '3271040005',
    districtId: '3271040',
    name: 'Babakan',
  },
  {
    id: '3271040007',
    districtId: '3271040',
    name: 'Pabaton',
  },
  {
    id: '3271040008',
    districtId: '3271040',
    name: 'Cibogor',
  },
  {
    id: '3271040009',
    districtId: '3271040',
    name: 'Panaragan',
  },
  {
    id: '3271040010',
    districtId: '3271040',
    name: 'Kebonkelapa',
  },
  {
    id: '3271040011',
    districtId: '3271040',
    name: 'Ciwaringin',
  },
  {
    id: '3271050001',
    districtId: '3271050',
    name: 'Pasirmulya',
  },
  {
    id: '3271050002',
    districtId: '3271050',
    name: 'Pasirkuda',
  },
  {
    id: '3271050003',
    districtId: '3271050',
    name: 'Pasirjaya',
  },
  {
    id: '3271050004',
    districtId: '3271050',
    name: 'Gunungbatu',
  },
  {
    id: '3271050005',
    districtId: '3271050',
    name: 'Loji',
  },
  {
    id: '3271050007',
    districtId: '3271050',
    name: 'Cilendek Timur',
  },
  {
    id: '3271050008',
    districtId: '3271050',
    name: 'Cilendek Barat',
  },
  {
    id: '3271050009',
    districtId: '3271050',
    name: 'Sindangbarang',
  },
  {
    id: '3271050010',
    districtId: '3271050',
    name: 'Margajaya',
  },
  {
    id: '3271050011',
    districtId: '3271050',
    name: 'Balungbangjaya',
  },
  {
    id: '3271050012',
    districtId: '3271050',
    name: 'Situgede',
  },
  {
    id: '3271050013',
    districtId: '3271050',
    name: 'Bubulak',
  },
  {
    id: '3271050014',
    districtId: '3271050',
    name: 'Semplak',
  },
  {
    id: '3271050015',
    districtId: '3271050',
    name: 'Curugmekar',
  },
  {
    id: '3271060001',
    districtId: '3271060',
    name: 'Kedungwaringin',
  },
  {
    id: '3271060002',
    districtId: '3271060',
    name: 'Kedungjaya',
  },
  {
    id: '3271060003',
    districtId: '3271060',
    name: 'Kebonpedes',
  },
  {
    id: '3271060004',
    districtId: '3271060',
    name: 'Tanahsareal',
  },
  {
    id: '3271060005',
    districtId: '3271060',
    name: 'Kedungbadak',
  },
  {
    id: '3271060006',
    districtId: '3271060',
    name: 'Sukaresmi',
  },
  {
    id: '3271060007',
    districtId: '3271060',
    name: 'Sukadamai',
  },
  {
    id: '3271060008',
    districtId: '3271060',
    name: 'Cibadak',
  },
  {
    id: '3271060009',
    districtId: '3271060',
    name: 'Kayumanis',
  },
  {
    id: '3271060010',
    districtId: '3271060',
    name: 'Mekarwangi',
  },
  {
    id: '3271060011',
    districtId: '3271060',
    name: 'Kencana',
  },
  {
    id: '3272010006',
    districtId: '3272010',
    name: 'Sudajaya Hilir',
  },
  {
    id: '3272010007',
    districtId: '3272010',
    name: 'Jayamekar',
  },
  {
    id: '3272010008',
    districtId: '3272010',
    name: 'Jayaraksa',
  },
  {
    id: '3272010009',
    districtId: '3272010',
    name: 'Baros',
  },
  {
    id: '3272011001',
    districtId: '3272011',
    name: 'Lembursitu',
  },
  {
    id: '3272011002',
    districtId: '3272011',
    name: 'Situmekar',
  },
  {
    id: '3272011003',
    districtId: '3272011',
    name: 'Cipanengah',
  },
  {
    id: '3272011004',
    districtId: '3272011',
    name: 'Cikundul',
  },
  {
    id: '3272011005',
    districtId: '3272011',
    name: 'Sindangsari',
  },
  {
    id: '3272012001',
    districtId: '3272012',
    name: 'Sindangpalay',
  },
  {
    id: '3272012002',
    districtId: '3272012',
    name: 'Limusnunggal',
  },
  {
    id: '3272012003',
    districtId: '3272012',
    name: 'Babakan',
  },
  {
    id: '3272012004',
    districtId: '3272012',
    name: 'Cibeureum Hilir',
  },
  {
    id: '3272020001',
    districtId: '3272020',
    name: 'Cikondang',
  },
  {
    id: '3272020002',
    districtId: '3272020',
    name: 'Gedong Panjang',
  },
  {
    id: '3272020003',
    districtId: '3272020',
    name: 'Citamiang',
  },
  {
    id: '3272020004',
    districtId: '3272020',
    name: 'Nanggeleng',
  },
  {
    id: '3272020005',
    districtId: '3272020',
    name: 'Tipar',
  },
  {
    id: '3272030001',
    districtId: '3272030',
    name: 'Dayeuhluhur',
  },
  {
    id: '3272030002',
    districtId: '3272030',
    name: 'Warudoyong',
  },
  {
    id: '3272030003',
    districtId: '3272030',
    name: 'Nyomplong',
  },
  {
    id: '3272030005',
    districtId: '3272030',
    name: 'Sukakarya',
  },
  {
    id: '3272040001',
    districtId: '3272040',
    name: 'Karang Tengah',
  },
  {
    id: '3272040003',
    districtId: '3272040',
    name: 'Sriwidari',
  },
  {
    id: '3272040004',
    districtId: '3272040',
    name: 'Karamat',
  },
  {
    id: '3272050001',
    districtId: '3272050',
    name: 'Gunung Parang',
  },
  {
    id: '3272050002',
    districtId: '3272050',
    name: 'Kebonjati',
  },
  {
    id: '3272050003',
    districtId: '3272050',
    name: 'Cikole',
  },
  {
    id: '3272050004',
    districtId: '3272050',
    name: 'Selabatu',
  },
  {
    id: '3272050005',
    districtId: '3272050',
    name: 'Cisarua',
  },
  {
    id: '3272050006',
    districtId: '3272050',
    name: 'Subangjaya',
  },
  {
    id: '3273010001',
    districtId: '3273010',
    name: 'Gempol Sari',
  },
  {
    id: '3273010002',
    districtId: '3273010',
    name: 'Cigondewah Kaler',
  },
  {
    id: '3273010003',
    districtId: '3273010',
    name: 'Cigondewah Kidul',
  },
  {
    id: '3273010004',
    districtId: '3273010',
    name: 'Cigondewah Rahayu',
  },
  {
    id: '3273010005',
    districtId: '3273010',
    name: 'Caringin',
  },
  {
    id: '3273010006',
    districtId: '3273010',
    name: 'Warung Muncang',
  },
  {
    id: '3273010007',
    districtId: '3273010',
    name: 'Cibuntu',
  },
  {
    id: '3273010008',
    districtId: '3273010',
    name: 'Cijerah',
  },
  {
    id: '3273020001',
    districtId: '3273020',
    name: 'Margasuka',
  },
  {
    id: '3273020002',
    districtId: '3273020',
    name: 'Cirangrang',
  },
  {
    id: '3273020003',
    districtId: '3273020',
    name: 'Margahayu Utara',
  },
  {
    id: '3273020004',
    districtId: '3273020',
    name: 'Babakan Ciparay',
  },
  {
    id: '3273020005',
    districtId: '3273020',
    name: 'Babakan',
  },
  {
    id: '3273020006',
    districtId: '3273020',
    name: 'Sukahaji',
  },
  {
    id: '3273030001',
    districtId: '3273030',
    name: 'Kopo',
  },
  {
    id: '3273030002',
    districtId: '3273030',
    name: 'Suka Asih',
  },
  {
    id: '3273030003',
    districtId: '3273030',
    name: 'Babakan Asih',
  },
  {
    id: '3273030004',
    districtId: '3273030',
    name: 'Babakan Tarogong',
  },
  {
    id: '3273030005',
    districtId: '3273030',
    name: 'Jamika',
  },
  {
    id: '3273040001',
    districtId: '3273040',
    name: 'Cibaduyut Kidul',
  },
  {
    id: '3273040002',
    districtId: '3273040',
    name: 'Cibaduyut Wetan',
  },
  {
    id: '3273040003',
    districtId: '3273040',
    name: 'Mekar Wangi',
  },
  {
    id: '3273040004',
    districtId: '3273040',
    name: 'Cibaduyut',
  },
  {
    id: '3273040005',
    districtId: '3273040',
    name: 'Kebon Lega',
  },
  {
    id: '3273040006',
    districtId: '3273040',
    name: 'Situsaeur',
  },
  {
    id: '3273050001',
    districtId: '3273050',
    name: 'Karasak',
  },
  {
    id: '3273050002',
    districtId: '3273050',
    name: 'Pelindung Hewan',
  },
  {
    id: '3273050004',
    districtId: '3273050',
    name: 'Panjunan',
  },
  {
    id: '3273050005',
    districtId: '3273050',
    name: 'Cibadak',
  },
  {
    id: '3273050006',
    districtId: '3273050',
    name: 'Karang Anyar',
  },
  {
    id: '3273060001',
    districtId: '3273060',
    name: 'Ciseureuh',
  },
  {
    id: '3273060002',
    districtId: '3273060',
    name: 'Pasirluyu',
  },
  {
    id: '3273060003',
    districtId: '3273060',
    name: 'Ancol',
  },
  {
    id: '3273060004',
    districtId: '3273060',
    name: 'Cigereleng',
  },
  {
    id: '3273060005',
    districtId: '3273060',
    name: 'Ciateul',
  },
  {
    id: '3273060007',
    districtId: '3273060',
    name: 'Balong Gede',
  },
  {
    id: '3273070001',
    districtId: '3273070',
    name: 'Cijagra',
  },
  {
    id: '3273070002',
    districtId: '3273070',
    name: 'Turangga',
  },
  {
    id: '3273070003',
    districtId: '3273070',
    name: 'Lingkar Selatan',
  },
  {
    id: '3273070004',
    districtId: '3273070',
    name: 'Malabar',
  },
  {
    id: '3273070005',
    districtId: '3273070',
    name: 'Burangrang',
  },
  {
    id: '3273070006',
    districtId: '3273070',
    name: 'Cikawao',
  },
  {
    id: '3273070007',
    districtId: '3273070',
    name: 'Paledang',
  },
  {
    id: '3273080001',
    districtId: '3273080',
    name: 'Wates',
  },
  {
    id: '3273080003',
    districtId: '3273080',
    name: 'Batununggal',
  },
  {
    id: '3273080004',
    districtId: '3273080',
    name: 'Kujangsari',
  },
  {
    id: '3273090001',
    districtId: '3273090',
    name: 'Cijaura',
  },
  {
    id: '3273090002',
    districtId: '3273090',
    name: 'Margasari',
  },
  {
    id: '3273090003',
    districtId: '3273090',
    name: 'Sekejati',
  },
  {
    id: '3273090004',
    districtId: '3273090',
    name: 'Jati Sari',
  },
  {
    id: '3273100001',
    districtId: '3273100',
    name: 'Derwati',
  },
  {
    id: '3273100002',
    districtId: '3273100',
    name: 'Cipamokolan',
  },
  {
    id: '3273100005',
    districtId: '3273100',
    name: 'Manjahlega',
  },
  {
    id: '3273100006',
    districtId: '3273100',
    name: 'Mekarjaya',
  },
  {
    id: '3273101001',
    districtId: '3273101',
    name: 'Rancabolang',
  },
  {
    id: '3273101002',
    districtId: '3273101',
    name: 'Rancanumpang',
  },
  {
    id: '3273101003',
    districtId: '3273101',
    name: 'Cisaranten Kidul',
  },
  {
    id: '3273101004',
    districtId: '3273101',
    name: 'Cimincrang',
  },
  {
    id: '3273110003',
    districtId: '3273110',
    name: 'Pasir Biru',
  },
  {
    id: '3273110004',
    districtId: '3273110',
    name: 'Cipadung',
  },
  {
    id: '3273110005',
    districtId: '3273110',
    name: 'Palasari',
  },
  {
    id: '3273110006',
    districtId: '3273110',
    name: 'Cisurupan',
  },
  {
    id: '3273111001',
    districtId: '3273111',
    name: 'Mekar Mulya',
  },
  {
    id: '3273111002',
    districtId: '3273111',
    name: 'Cipadung Kidul',
  },
  {
    id: '3273111003',
    districtId: '3273111',
    name: 'Cipadung Wetan',
  },
  {
    id: '3273111004',
    districtId: '3273111',
    name: 'Cipadung Kulon',
  },
  {
    id: '3273120003',
    districtId: '3273120',
    name: 'Pasanggrahan',
  },
  {
    id: '3273120004',
    districtId: '3273120',
    name: 'Pasirjati',
  },
  {
    id: '3273120005',
    districtId: '3273120',
    name: 'Pasir Wangi',
  },
  {
    id: '3273120006',
    districtId: '3273120',
    name: 'Cigending',
  },
  {
    id: '3273120007',
    districtId: '3273120',
    name: 'Pasir Endah',
  },
  {
    id: '3273121001',
    districtId: '3273121',
    name: 'Cisaranten Wetan',
  },
  {
    id: '3273121002',
    districtId: '3273121',
    name: 'Babakan Penghulu',
  },
  {
    id: '3273121003',
    districtId: '3273121',
    name: 'Pakemitan',
  },
  {
    id: '3273121004',
    districtId: '3273121',
    name: 'Sukamulya',
  },
  {
    id: '3273130001',
    districtId: '3273130',
    name: 'Cisaranten Kulon',
  },
  {
    id: '3273130002',
    districtId: '3273130',
    name: 'Cisaranten Bina Harapan',
  },
  {
    id: '3273130003',
    districtId: '3273130',
    name: 'Sukamiskin',
  },
  {
    id: '3273130005',
    districtId: '3273130',
    name: 'Cisaranten Endah',
  },
  {
    id: '3273141001',
    districtId: '3273141',
    name: 'Antapani Kidul',
  },
  {
    id: '3273141002',
    districtId: '3273141',
    name: 'Antapani Tengah',
  },
  {
    id: '3273141003',
    districtId: '3273141',
    name: 'Antapani Wetan',
  },
  {
    id: '3273141004',
    districtId: '3273141',
    name: 'Antapani Kulon',
  },
  {
    id: '3273142001',
    districtId: '3273142',
    name: 'Jatihandap',
  },
  {
    id: '3273142002',
    districtId: '3273142',
    name: 'Karang Pamulang',
  },
  {
    id: '3273142003',
    districtId: '3273142',
    name: 'Sindang Jaya',
  },
  {
    id: '3273142004',
    districtId: '3273142',
    name: 'Pasir Impun',
  },
  {
    id: '3273150001',
    districtId: '3273150',
    name: 'Kebon Kangkung',
  },
  {
    id: '3273150002',
    districtId: '3273150',
    name: 'Sukapura',
  },
  {
    id: '3273150003',
    districtId: '3273150',
    name: 'Kebun Jayanti',
  },
  {
    id: '3273150004',
    districtId: '3273150',
    name: 'Babakan Sari',
  },
  {
    id: '3273150005',
    districtId: '3273150',
    name: 'Babakan Surabaya',
  },
  {
    id: '3273150006',
    districtId: '3273150',
    name: 'Cicaheum',
  },
  {
    id: '3273160002',
    districtId: '3273160',
    name: 'Binong',
  },
  {
    id: '3273160003',
    districtId: '3273160',
    name: 'Kebon Gedang',
  },
  {
    id: '3273160004',
    districtId: '3273160',
    name: 'Maleer',
  },
  {
    id: '3273160005',
    districtId: '3273160',
    name: 'Cibangkong',
  },
  {
    id: '3273160006',
    districtId: '3273160',
    name: 'Samoja',
  },
  {
    id: '3273160007',
    districtId: '3273160',
    name: 'Kacapiring',
  },
  {
    id: '3273160008',
    districtId: '3273160',
    name: 'Kebon Waru',
  },
  {
    id: '3273170001',
    districtId: '3273170',
    name: 'Braga',
  },
  {
    id: '3273170002',
    districtId: '3273170',
    name: 'Kebon Pisang',
  },
  {
    id: '3273170003',
    districtId: '3273170',
    name: 'Merdeka',
  },
  {
    id: '3273170004',
    districtId: '3273170',
    name: 'Babakan Ciamis',
  },
  {
    id: '3273180001',
    districtId: '3273180',
    name: 'Campaka',
  },
  {
    id: '3273180002',
    districtId: '3273180',
    name: 'Maleber',
  },
  {
    id: '3273180003',
    districtId: '3273180',
    name: 'Garuda',
  },
  {
    id: '3273180004',
    districtId: '3273180',
    name: 'Dungus Cariang',
  },
  {
    id: '3273180005',
    districtId: '3273180',
    name: 'Ciroyom',
  },
  {
    id: '3273180006',
    districtId: '3273180',
    name: 'Kebon Jeruk',
  },
  {
    id: '3273190001',
    districtId: '3273190',
    name: 'Arjuna',
  },
  {
    id: '3273190002',
    districtId: '3273190',
    name: 'Pasirkaliki',
  },
  {
    id: '3273190003',
    districtId: '3273190',
    name: 'Pamoyanan',
  },
  {
    id: '3273190004',
    districtId: '3273190',
    name: 'Pajajaran',
  },
  {
    id: '3273190005',
    districtId: '3273190',
    name: 'Husen Sastranegara',
  },
  {
    id: '3273190006',
    districtId: '3273190',
    name: 'Sukaraja',
  },
  {
    id: '3273200001',
    districtId: '3273200',
    name: 'Taman Sari',
  },
  {
    id: '3273200002',
    districtId: '3273200',
    name: 'Citarum',
  },
  {
    id: '3273200003',
    districtId: '3273200',
    name: 'Cihapit',
  },
  {
    id: '3273210001',
    districtId: '3273210',
    name: 'Sukamaju',
  },
  {
    id: '3273210002',
    districtId: '3273210',
    name: 'Cicadas',
  },
  {
    id: '3273210003',
    districtId: '3273210',
    name: 'Cikutra',
  },
  {
    id: '3273210004',
    districtId: '3273210',
    name: 'Padasuka',
  },
  {
    id: '3273210005',
    districtId: '3273210',
    name: 'Pasirlayung',
  },
  {
    id: '3273210006',
    districtId: '3273210',
    name: 'Sukapada',
  },
  {
    id: '3273220001',
    districtId: '3273220',
    name: 'Cihaurgeulis',
  },
  {
    id: '3273220002',
    districtId: '3273220',
    name: 'Sukaluyu',
  },
  {
    id: '3273220003',
    districtId: '3273220',
    name: 'Neglasari',
  },
  {
    id: '3273220004',
    districtId: '3273220',
    name: 'Cigadung',
  },
  {
    id: '3273230001',
    districtId: '3273230',
    name: 'Cipaganti',
  },
  {
    id: '3273230002',
    districtId: '3273230',
    name: 'Lebak Siliwangi',
  },
  {
    id: '3273230003',
    districtId: '3273230',
    name: 'Lebak Gede',
  },
  {
    id: '3273230004',
    districtId: '3273230',
    name: 'Sadang Serang',
  },
  {
    id: '3273230005',
    districtId: '3273230',
    name: 'Sekeloa',
  },
  {
    id: '3273230006',
    districtId: '3273230',
    name: 'Dago',
  },
  {
    id: '3273240001',
    districtId: '3273240',
    name: 'Sukawarna',
  },
  {
    id: '3273240002',
    districtId: '3273240',
    name: 'Sukagalih',
  },
  {
    id: '3273240003',
    districtId: '3273240',
    name: 'Sukabungah',
  },
  {
    id: '3273240004',
    districtId: '3273240',
    name: 'Cipedes',
  },
  {
    id: '3273240005',
    districtId: '3273240',
    name: 'Pasteur',
  },
  {
    id: '3273250001',
    districtId: '3273250',
    name: 'Sarijadi',
  },
  {
    id: '3273250002',
    districtId: '3273250',
    name: 'Sukarasa',
  },
  {
    id: '3273250003',
    districtId: '3273250',
    name: 'Gegerkalong',
  },
  {
    id: '3273250004',
    districtId: '3273250',
    name: 'Isola',
  },
  {
    id: '3273260001',
    districtId: '3273260',
    name: 'Hegarmanah',
  },
  {
    id: '3273260002',
    districtId: '3273260',
    name: 'Ciumbuleuit',
  },
  {
    id: '3274010001',
    districtId: '3274010',
    name: 'Argasunya',
  },
  {
    id: '3274010002',
    districtId: '3274010',
    name: 'Kalijaga',
  },
  {
    id: '3274010003',
    districtId: '3274010',
    name: 'Harjamukti',
  },
  {
    id: '3274010004',
    districtId: '3274010',
    name: 'Kecapi',
  },
  {
    id: '3274010005',
    districtId: '3274010',
    name: 'Larangan',
  },
  {
    id: '3274020001',
    districtId: '3274020',
    name: 'Pegambiran',
  },
  {
    id: '3274020002',
    districtId: '3274020',
    name: 'Kesepuhan',
  },
  {
    id: '3274020003',
    districtId: '3274020',
    name: 'Lemahwungkuk',
  },
  {
    id: '3274020004',
    districtId: '3274020',
    name: 'Panjunan',
  },
  {
    id: '3274030001',
    districtId: '3274030',
    name: 'Jagasatru',
  },
  {
    id: '3274030002',
    districtId: '3274030',
    name: 'Pulasaren',
  },
  {
    id: '3274030003',
    districtId: '3274030',
    name: 'Pekalipan',
  },
  {
    id: '3274030004',
    districtId: '3274030',
    name: 'Pekalangan',
  },
  {
    id: '3274040001',
    districtId: '3274040',
    name: 'Karyamulya',
  },
  {
    id: '3274040002',
    districtId: '3274040',
    name: 'Sunyaragi',
  },
  {
    id: '3274040003',
    districtId: '3274040',
    name: 'Drajat',
  },
  {
    id: '3274040004',
    districtId: '3274040',
    name: 'Kesambi',
  },
  {
    id: '3274040005',
    districtId: '3274040',
    name: 'Pekiringan',
  },
  {
    id: '3274050001',
    districtId: '3274050',
    name: 'Kejaksan',
  },
  {
    id: '3274050002',
    districtId: '3274050',
    name: 'Kebonbaru',
  },
  {
    id: '3274050003',
    districtId: '3274050',
    name: 'Sukapura',
  },
  {
    id: '3275010008',
    districtId: '3275010',
    name: 'Jatimakmur',
  },
  {
    id: '3275010009',
    districtId: '3275010',
    name: 'Jatiwaringin',
  },
  {
    id: '3275010010',
    districtId: '3275010',
    name: 'Jatibening',
  },
  {
    id: '3275010011',
    districtId: '3275010',
    name: 'Jaticempaka',
  },
  {
    id: '3275010012',
    districtId: '3275010',
    name: 'Jatibening Baru',
  },
  {
    id: '3275011001',
    districtId: '3275011',
    name: 'Jatikarya',
  },
  {
    id: '3275011002',
    districtId: '3275011',
    name: 'Jatisampurna',
  },
  {
    id: '3275011003',
    districtId: '3275011',
    name: 'Jatirangga',
  },
  {
    id: '3275011004',
    districtId: '3275011',
    name: 'Jatiranggon',
  },
  {
    id: '3275011006',
    districtId: '3275011',
    name: 'Jatiraden',
  },
  {
    id: '3275012001',
    districtId: '3275012',
    name: 'Jatimurni',
  },
  {
    id: '3275012002',
    districtId: '3275012',
    name: 'Jatimelati',
  },
  {
    id: '3275012003',
    districtId: '3275012',
    name: 'Jatiwarna',
  },
  {
    id: '3275012004',
    districtId: '3275012',
    name: 'Jatirahayu',
  },
  {
    id: '3275020001',
    districtId: '3275020',
    name: 'Jatisari',
  },
  {
    id: '3275020002',
    districtId: '3275020',
    name: 'Jatiluhur',
  },
  {
    id: '3275020003',
    districtId: '3275020',
    name: 'Jatirasa',
  },
  {
    id: '3275020004',
    districtId: '3275020',
    name: 'Jatiasih',
  },
  {
    id: '3275020005',
    districtId: '3275020',
    name: 'Jatimekar',
  },
  {
    id: '3275020006',
    districtId: '3275020',
    name: 'Jatikramat',
  },
  {
    id: '3275030001',
    districtId: '3275030',
    name: 'Ciketingudik',
  },
  {
    id: '3275030002',
    districtId: '3275030',
    name: 'Sumur Batu',
  },
  {
    id: '3275030003',
    districtId: '3275030',
    name: 'Cikiwul',
  },
  {
    id: '3275030004',
    districtId: '3275030',
    name: 'Bantargebang',
  },
  {
    id: '3275031001',
    districtId: '3275031',
    name: 'Padurenan',
  },
  {
    id: '3275031002',
    districtId: '3275031',
    name: 'Cimuning',
  },
  {
    id: '3275031003',
    districtId: '3275031',
    name: 'Mustika Jaya',
  },
  {
    id: '3275031004',
    districtId: '3275031',
    name: 'Mustika Sari',
  },
  {
    id: '3275040005',
    districtId: '3275040',
    name: 'Margahayu',
  },
  {
    id: '3275040006',
    districtId: '3275040',
    name: 'Bekasi Jaya',
  },
  {
    id: '3275040007',
    districtId: '3275040',
    name: 'Duren Jaya',
  },
  {
    id: '3275040008',
    districtId: '3275040',
    name: 'Aren Jaya',
  },
  {
    id: '3275041001',
    districtId: '3275041',
    name: 'Bojong Menteng',
  },
  {
    id: '3275041002',
    districtId: '3275041',
    name: 'Bojong Rawalumbu',
  },
  {
    id: '3275041003',
    districtId: '3275041',
    name: 'Sepanjang Jaya',
  },
  {
    id: '3275041004',
    districtId: '3275041',
    name: 'Pengasinan',
  },
  {
    id: '3275050001',
    districtId: '3275050',
    name: 'Jaka Mulya',
  },
  {
    id: '3275050002',
    districtId: '3275050',
    name: 'Jaka Setia',
  },
  {
    id: '3275050003',
    districtId: '3275050',
    name: 'Pekayon Jaya',
  },
  {
    id: '3275050004',
    districtId: '3275050',
    name: 'Marga Jaya',
  },
  {
    id: '3275050007',
    districtId: '3275050',
    name: 'Kayuringin Jaya',
  },
  {
    id: '3275060001',
    districtId: '3275060',
    name: 'Bintara Jaya',
  },
  {
    id: '3275060002',
    districtId: '3275060',
    name: 'Bintara',
  },
  {
    id: '3275060003',
    districtId: '3275060',
    name: 'Kranji',
  },
  {
    id: '3275060005',
    districtId: '3275060',
    name: 'Kota Baru',
  },
  {
    id: '3275060008',
    districtId: '3275060',
    name: 'Jaka Sampurna',
  },
  {
    id: '3275061001',
    districtId: '3275061',
    name: 'Harapan Mulya',
  },
  {
    id: '3275061002',
    districtId: '3275061',
    name: 'Kali Baru',
  },
  {
    id: '3275061003',
    districtId: '3275061',
    name: 'Medan Satria',
  },
  {
    id: '3275061004',
    districtId: '3275061',
    name: 'Pejuang',
  },
  {
    id: '3275070001',
    districtId: '3275070',
    name: 'Harapan Jaya',
  },
  {
    id: '3275070002',
    districtId: '3275070',
    name: 'Kaliabang Tengah',
  },
  {
    id: '3275070003',
    districtId: '3275070',
    name: 'Perwira',
  },
  {
    id: '3275070004',
    districtId: '3275070',
    name: 'Harapan Baru',
  },
  {
    id: '3275070006',
    districtId: '3275070',
    name: 'Marga Mulya',
  },
  {
    id: '3276010003',
    districtId: '3276010',
    name: 'Pengasinan',
  },
  {
    id: '3276010004',
    districtId: '3276010',
    name: 'Bedahan',
  },
  {
    id: '3276010005',
    districtId: '3276010',
    name: 'Pasir Putih',
  },
  {
    id: '3276010006',
    districtId: '3276010',
    name: 'Sawangan Baru',
  },
  {
    id: '3276010007',
    districtId: '3276010',
    name: 'Sawangan Lama',
  },
  {
    id: '3276010013',
    districtId: '3276010',
    name: 'Kedaung',
  },
  {
    id: '3276010014',
    districtId: '3276010',
    name: 'Cinangka',
  },
  {
    id: '3276011001',
    districtId: '3276011',
    name: 'Duren Seribu',
  },
  {
    id: '3276011002',
    districtId: '3276011',
    name: 'Duren Mekar',
  },
  {
    id: '3276011003',
    districtId: '3276011',
    name: 'Bojongsari Lama',
  },
  {
    id: '3276011004',
    districtId: '3276011',
    name: 'Bojongsari Baru',
  },
  {
    id: '3276011006',
    districtId: '3276011',
    name: 'Pondok Petir',
  },
  {
    id: '3276011007',
    districtId: '3276011',
    name: 'Serua',
  },
  {
    id: '3276020006',
    districtId: '3276020',
    name: 'Rangkapan Jaya Baru',
  },
  {
    id: '3276020007',
    districtId: '3276020',
    name: 'Rangkapan Jaya',
  },
  {
    id: '3276020008',
    districtId: '3276020',
    name: 'Mampang',
  },
  {
    id: '3276020009',
    districtId: '3276020',
    name: 'Pancoran Mas',
  },
  {
    id: '3276020010',
    districtId: '3276020',
    name: 'Depok Jaya',
  },
  {
    id: '3276020011',
    districtId: '3276020',
    name: 'Depok',
  },
  {
    id: '3276021001',
    districtId: '3276021',
    name: 'Cipayung Jaya',
  },
  {
    id: '3276021002',
    districtId: '3276021',
    name: 'Bojong Pondok Terong',
  },
  {
    id: '3276021003',
    districtId: '3276021',
    name: 'Pondok Jaya',
  },
  {
    id: '3276021004',
    districtId: '3276021',
    name: 'Ratujaya',
  },
  {
    id: '3276021005',
    districtId: '3276021',
    name: 'Cipayung',
  },
  {
    id: '3276030006',
    districtId: '3276030',
    name: 'Sukmajaya',
  },
  {
    id: '3276030007',
    districtId: '3276030',
    name: 'Tirtajaya',
  },
  {
    id: '3276030008',
    districtId: '3276030',
    name: 'Mekar Jaya',
  },
  {
    id: '3276030009',
    districtId: '3276030',
    name: 'Abadijaya',
  },
  {
    id: '3276030010',
    districtId: '3276030',
    name: 'Bakti Jaya',
  },
  {
    id: '3276030011',
    districtId: '3276030',
    name: 'Cisalak',
  },
  {
    id: '3276031001',
    districtId: '3276031',
    name: 'Kalimulya',
  },
  {
    id: '3276031002',
    districtId: '3276031',
    name: 'Jatimulya',
  },
  {
    id: '3276031003',
    districtId: '3276031',
    name: 'Kalibaru',
  },
  {
    id: '3276031004',
    districtId: '3276031',
    name: 'Cilodong',
  },
  {
    id: '3276031005',
    districtId: '3276031',
    name: 'Sukamaju',
  },
  {
    id: '3276040009',
    districtId: '3276040',
    name: 'Harjamukti',
  },
  {
    id: '3276040010',
    districtId: '3276040',
    name: 'Cisalak Pasar',
  },
  {
    id: '3276040011',
    districtId: '3276040',
    name: 'Mekarsari',
  },
  {
    id: '3276040013',
    districtId: '3276040',
    name: 'Pasir Gunung Selatan',
  },
  {
    id: '3276041001',
    districtId: '3276041',
    name: 'Cilangkap',
  },
  {
    id: '3276041002',
    districtId: '3276041',
    name: 'Cimpaeun',
  },
  {
    id: '3276041003',
    districtId: '3276041',
    name: 'Tapos',
  },
  {
    id: '3276041004',
    districtId: '3276041',
    name: 'Leuwinaggung',
  },
  {
    id: '3276041005',
    districtId: '3276041',
    name: 'Jatijajar',
  },
  {
    id: '3276041006',
    districtId: '3276041',
    name: 'Sukamaju Baru',
  },
  {
    id: '3276041007',
    districtId: '3276041',
    name: 'Sukatani',
  },
  {
    id: '3276050001',
    districtId: '3276050',
    name: 'Beji',
  },
  {
    id: '3276050002',
    districtId: '3276050',
    name: 'Beji Timur',
  },
  {
    id: '3276050003',
    districtId: '3276050',
    name: 'Kemirimuka',
  },
  {
    id: '3276050004',
    districtId: '3276050',
    name: 'Pondok Cina',
  },
  {
    id: '3276050005',
    districtId: '3276050',
    name: 'Kukusan',
  },
  {
    id: '3276050006',
    districtId: '3276050',
    name: 'Tanah Baru',
  },
  {
    id: '3276060002',
    districtId: '3276060',
    name: 'Grogol',
  },
  {
    id: '3276060004',
    districtId: '3276060',
    name: 'Limo',
  },
  {
    id: '3276061001',
    districtId: '3276061',
    name: 'Cinere',
  },
  {
    id: '3276061002',
    districtId: '3276061',
    name: 'Gandul',
  },
  {
    id: '3276061003',
    districtId: '3276061',
    name: 'Pangkalanjati Baru',
  },
  {
    id: '3276061004',
    districtId: '3276061',
    name: 'Pangkalanjati',
  },
  {
    id: '3277010001',
    districtId: '3277010',
    name: 'Melong',
  },
  {
    id: '3277010002',
    districtId: '3277010',
    name: 'Cibeureum',
  },
  {
    id: '3277010003',
    districtId: '3277010',
    name: 'Utama',
  },
  {
    id: '3277010004',
    districtId: '3277010',
    name: 'Leuwigajah',
  },
  {
    id: '3277010005',
    districtId: '3277010',
    name: 'Cibeber',
  },
  {
    id: '3277020001',
    districtId: '3277020',
    name: 'Baros',
  },
  {
    id: '3277020002',
    districtId: '3277020',
    name: 'Cigugur Tengah',
  },
  {
    id: '3277020003',
    districtId: '3277020',
    name: 'Karangmekar',
  },
  {
    id: '3277020004',
    districtId: '3277020',
    name: 'Setiamanah',
  },
  {
    id: '3277020005',
    districtId: '3277020',
    name: 'Padasuka',
  },
  {
    id: '3277020006',
    districtId: '3277020',
    name: 'Cimahi',
  },
  {
    id: '3277030001',
    districtId: '3277030',
    name: 'Pasirkaliki',
  },
  {
    id: '3277030002',
    districtId: '3277030',
    name: 'Cibabat',
  },
  {
    id: '3277030003',
    districtId: '3277030',
    name: 'Citeureup',
  },
  {
    id: '3277030004',
    districtId: '3277030',
    name: 'Cipageran',
  },
  {
    id: '3278010001',
    districtId: '3278010',
    name: 'Leuwiliang',
  },
  {
    id: '3278010003',
    districtId: '3278010',
    name: 'Gunungtandala',
  },
  {
    id: '3278010005',
    districtId: '3278010',
    name: 'Talagasari',
  },
  {
    id: '3278010006',
    districtId: '3278010',
    name: 'Tanjung',
  },
  {
    id: '3278010007',
    districtId: '3278010',
    name: 'Cibeuti',
  },
  {
    id: '3278010008',
    districtId: '3278010',
    name: 'Karanganyar',
  },
  {
    id: '3278010009',
    districtId: '3278010',
    name: 'Cilamajang',
  },
  {
    id: '3278010010',
    districtId: '3278010',
    name: 'Karsamenak',
  },
  {
    id: '3278020001',
    districtId: '3278020',
    name: 'Setiamulya',
  },
  {
    id: '3278020002',
    districtId: '3278020',
    name: 'Setiawargi',
  },
  {
    id: '3278020003',
    districtId: '3278020',
    name: 'Tamansari',
  },
  {
    id: '3278020004',
    districtId: '3278020',
    name: 'Tamanjaya',
  },
  {
    id: '3278020005',
    districtId: '3278020',
    name: 'Mulyasari',
  },
  {
    id: '3278020006',
    districtId: '3278020',
    name: 'Sukahurip',
  },
  {
    id: '3278020007',
    districtId: '3278020',
    name: 'Mugarsari',
  },
  {
    id: '3278020008',
    districtId: '3278020',
    name: 'Sumelap',
  },
  {
    id: '3278030001',
    districtId: '3278030',
    name: 'Ciherang',
  },
  {
    id: '3278030002',
    districtId: '3278030',
    name: 'Ciakar',
  },
  {
    id: '3278030003',
    districtId: '3278030',
    name: 'Margabakti',
  },
  {
    id: '3278030004',
    districtId: '3278030',
    name: 'Awipari',
  },
  {
    id: '3278030005',
    districtId: '3278030',
    name: 'Kotabaru',
  },
  {
    id: '3278030006',
    districtId: '3278030',
    name: 'Kersanagara',
  },
  {
    id: '3278030007',
    districtId: '3278030',
    name: 'Setiajaya',
  },
  {
    id: '3278030008',
    districtId: '3278030',
    name: 'Setiaratu',
  },
  {
    id: '3278030009',
    districtId: '3278030',
    name: 'Setianagara',
  },
  {
    id: '3278031001',
    districtId: '3278031',
    name: 'Sukanagara',
  },
  {
    id: '3278031002',
    districtId: '3278031',
    name: 'Sukamenak',
  },
  {
    id: '3278031003',
    districtId: '3278031',
    name: 'Purbaratu',
  },
  {
    id: '3278031004',
    districtId: '3278031',
    name: 'Sukaasih',
  },
  {
    id: '3278031005',
    districtId: '3278031',
    name: 'Sukajaya',
  },
  {
    id: '3278031006',
    districtId: '3278031',
    name: 'Singkup',
  },
  {
    id: '3278040001',
    districtId: '3278040',
    name: 'Kahuripan',
  },
  {
    id: '3278040002',
    districtId: '3278040',
    name: 'Cikalang',
  },
  {
    id: '3278040003',
    districtId: '3278040',
    name: 'Empangsari',
  },
  {
    id: '3278040004',
    districtId: '3278040',
    name: 'Tawangsari',
  },
  {
    id: '3278040005',
    districtId: '3278040',
    name: 'Lengkongsari',
  },
  {
    id: '3278050001',
    districtId: '3278050',
    name: 'Tugujaya',
  },
  {
    id: '3278050002',
    districtId: '3278050',
    name: 'Tuguraja',
  },
  {
    id: '3278050003',
    districtId: '3278050',
    name: 'Nagarawangi',
  },
  {
    id: '3278050004',
    districtId: '3278050',
    name: 'Yudanagara',
  },
  {
    id: '3278050005',
    districtId: '3278050',
    name: 'Cilembang',
  },
  {
    id: '3278050006',
    districtId: '3278050',
    name: 'Argasari',
  },
  {
    id: '3278060001',
    districtId: '3278060',
    name: 'Karikil',
  },
  {
    id: '3278060002',
    districtId: '3278060',
    name: 'Cigantang',
  },
  {
    id: '3278060003',
    districtId: '3278060',
    name: 'Sambongjaya',
  },
  {
    id: '3278060004',
    districtId: '3278060',
    name: 'Sambongpari',
  },
  {
    id: '3278060005',
    districtId: '3278060',
    name: 'Linggajaya',
  },
  {
    id: '3278060006',
    districtId: '3278060',
    name: 'Mangkubumi',
  },
  {
    id: '3278060007',
    districtId: '3278060',
    name: 'Cipari',
  },
  {
    id: '3278060008',
    districtId: '3278060',
    name: 'Cipawitra',
  },
  {
    id: '3278070005',
    districtId: '3278070',
    name: 'Panyingkiran',
  },
  {
    id: '3278070006',
    districtId: '3278070',
    name: 'Parakannyasag',
  },
  {
    id: '3278070007',
    districtId: '3278070',
    name: 'Sirnagalih',
  },
  {
    id: '3278070008',
    districtId: '3278070',
    name: 'Indihiang',
  },
  {
    id: '3278070012',
    districtId: '3278070',
    name: 'Sukamajukidul',
  },
  {
    id: '3278070013',
    districtId: '3278070',
    name: 'Sukamajukaler',
  },
  {
    id: '3278071001',
    districtId: '3278071',
    name: 'Sukamulya',
  },
  {
    id: '3278071002',
    districtId: '3278071',
    name: 'Sukarindik',
  },
  {
    id: '3278071003',
    districtId: '3278071',
    name: 'Bungursari',
  },
  {
    id: '3278071004',
    districtId: '3278071',
    name: 'Sukajaya',
  },
  {
    id: '3278071005',
    districtId: '3278071',
    name: 'Cibunigeulis',
  },
  {
    id: '3278071006',
    districtId: '3278071',
    name: 'Bantarsari',
  },
  {
    id: '3278071007',
    districtId: '3278071',
    name: 'Sukalaksana',
  },
  {
    id: '3278080001',
    districtId: '3278080',
    name: 'Panglayungan',
  },
  {
    id: '3278080002',
    districtId: '3278080',
    name: 'Cipedes',
  },
  {
    id: '3278080003',
    districtId: '3278080',
    name: 'Nagarasari',
  },
  {
    id: '3278080004',
    districtId: '3278080',
    name: 'Sukamanah',
  },
  {
    id: '3279010001',
    districtId: '3279010',
    name: 'Situbatu',
  },
  {
    id: '3279010002',
    districtId: '3279010',
    name: 'Neglasari',
  },
  {
    id: '3279010003',
    districtId: '3279010',
    name: 'Cibeureum',
  },
  {
    id: '3279010004',
    districtId: '3279010',
    name: 'Balokang',
  },
  {
    id: '3279010005',
    districtId: '3279010',
    name: 'Banjar',
  },
  {
    id: '3279010006',
    districtId: '3279010',
    name: 'Mekarsari',
  },
  {
    id: '3279010007',
    districtId: '3279010',
    name: 'Jajawar',
  },
  {
    id: '3279020001',
    districtId: '3279020',
    name: 'Purwaharja',
  },
  {
    id: '3279020002',
    districtId: '3279020',
    name: 'Karangpanimbal',
  },
  {
    id: '3279020003',
    districtId: '3279020',
    name: 'Raharja',
  },
  {
    id: '3279020004',
    districtId: '3279020',
    name: 'Mekarharja',
  },
  {
    id: '3279030001',
    districtId: '3279030',
    name: 'Binangun',
  },
  {
    id: '3279030002',
    districtId: '3279030',
    name: 'Batulawang',
  },
  {
    id: '3279030003',
    districtId: '3279030',
    name: 'Karyamukti',
  },
  {
    id: '3279030004',
    districtId: '3279030',
    name: 'Mulyasari',
  },
  {
    id: '3279030005',
    districtId: '3279030',
    name: 'Pataruman',
  },
  {
    id: '3279030006',
    districtId: '3279030',
    name: 'Hegarsari',
  },
  {
    id: '3279030007',
    districtId: '3279030',
    name: 'Sukamukti',
  },
  {
    id: '3279030008',
    districtId: '3279030',
    name: 'Sinartanjung',
  },
  {
    id: '3279040001',
    districtId: '3279040',
    name: 'Kujangsari',
  },
  {
    id: '3279040002',
    districtId: '3279040',
    name: 'Bojongkantong',
  },
  {
    id: '3279040003',
    districtId: '3279040',
    name: 'Rejasari',
  },
  {
    id: '3279040004',
    districtId: '3279040',
    name: 'Langensari',
  },
  {
    id: '3279040005',
    districtId: '3279040',
    name: 'Muktisari',
  },
  {
    id: '3279040006',
    districtId: '3279040',
    name: 'Waringinsari',
  },
  {
    id: '3301010001',
    districtId: '3301010',
    name: 'Panulisan Barat',
  },
  {
    id: '3301010002',
    districtId: '3301010',
    name: 'Panulisan',
  },
  {
    id: '3301010003',
    districtId: '3301010',
    name: 'Panulisan Timur',
  },
  {
    id: '3301010004',
    districtId: '3301010',
    name: 'Matenggeng',
  },
  {
    id: '3301010005',
    districtId: '3301010',
    name: 'Ciwalen',
  },
  {
    id: '3301010006',
    districtId: '3301010',
    name: 'Dayeuhluhur',
  },
  {
    id: '3301010007',
    districtId: '3301010',
    name: 'Hanum',
  },
  {
    id: '3301010008',
    districtId: '3301010',
    name: 'Datar',
  },
  {
    id: '3301010009',
    districtId: '3301010',
    name: 'Bingkeng',
  },
  {
    id: '3301010010',
    districtId: '3301010',
    name: 'Bolang',
  },
  {
    id: '3301010011',
    districtId: '3301010',
    name: 'Kutaagung',
  },
  {
    id: '3301010012',
    districtId: '3301010',
    name: 'Cijeruk',
  },
  {
    id: '3301010013',
    districtId: '3301010',
    name: 'Cilumping',
  },
  {
    id: '3301010014',
    districtId: '3301010',
    name: 'Sumpinghayu',
  },
  {
    id: '3301020001',
    districtId: '3301020',
    name: 'Purwasari',
  },
  {
    id: '3301020002',
    districtId: '3301020',
    name: 'Cilongkrang',
  },
  {
    id: '3301020003',
    districtId: '3301020',
    name: 'Tarisi',
  },
  {
    id: '3301020004',
    districtId: '3301020',
    name: 'Bantar',
  },
  {
    id: '3301020005',
    districtId: '3301020',
    name: 'Sidamulya',
  },
  {
    id: '3301020006',
    districtId: '3301020',
    name: 'Adimulya',
  },
  {
    id: '3301020007',
    districtId: '3301020',
    name: 'Wanareja',
  },
  {
    id: '3301020008',
    districtId: '3301020',
    name: 'Madura',
  },
  {
    id: '3301020009',
    districtId: '3301020',
    name: 'Madusari',
  },
  {
    id: '3301020010',
    districtId: '3301020',
    name: 'Tambaksari',
  },
  {
    id: '3301020011',
    districtId: '3301020',
    name: 'Majingklak',
  },
  {
    id: '3301020012',
    districtId: '3301020',
    name: 'Malabar',
  },
  {
    id: '3301020013',
    districtId: '3301020',
    name: 'Limbangan',
  },
  {
    id: '3301020014',
    districtId: '3301020',
    name: 'Cigintung',
  },
  {
    id: '3301020015',
    districtId: '3301020',
    name: 'Palugon',
  },
  {
    id: '3301020016',
    districtId: '3301020',
    name: 'Jambu',
  },
  {
    id: '3301030001',
    districtId: '3301030',
    name: 'Pahonjean',
  },
  {
    id: '3301030002',
    districtId: '3301030',
    name: 'Mulyadadi',
  },
  {
    id: '3301030003',
    districtId: '3301030',
    name: 'Mulyasari',
  },
  {
    id: '3301030004',
    districtId: '3301030',
    name: 'Padangsari',
  },
  {
    id: '3301030005',
    districtId: '3301030',
    name: 'Cilopadang',
  },
  {
    id: '3301030006',
    districtId: '3301030',
    name: 'Padangjaya',
  },
  {
    id: '3301030007',
    districtId: '3301030',
    name: 'Sindangsari',
  },
  {
    id: '3301030008',
    districtId: '3301030',
    name: 'Jenang',
  },
  {
    id: '3301030009',
    districtId: '3301030',
    name: 'Salebu',
  },
  {
    id: '3301030010',
    districtId: '3301030',
    name: 'Cibeunying',
  },
  {
    id: '3301030011',
    districtId: '3301030',
    name: 'Sepatnunggal',
  },
  {
    id: '3301030013',
    districtId: '3301030',
    name: 'Boja',
  },
  {
    id: '3301030014',
    districtId: '3301030',
    name: 'Ujungbarang',
  },
  {
    id: '3301030015',
    districtId: '3301030',
    name: 'Pengadegan',
  },
  {
    id: '3301030016',
    districtId: '3301030',
    name: 'Sadabumi',
  },
  {
    id: '3301030017',
    districtId: '3301030',
    name: 'Sadahayu',
  },
  {
    id: '3301040001',
    districtId: '3301040',
    name: 'Karangreja',
  },
  {
    id: '3301040002',
    districtId: '3301040',
    name: 'Cimanggu',
  },
  {
    id: '3301040003',
    districtId: '3301040',
    name: 'Bantarpanjang',
  },
  {
    id: '3301040004',
    districtId: '3301040',
    name: 'Panimbang',
  },
  {
    id: '3301040005',
    districtId: '3301040',
    name: 'Mandala',
  },
  {
    id: '3301040006',
    districtId: '3301040',
    name: 'Bantarmangu',
  },
  {
    id: '3301040007',
    districtId: '3301040',
    name: 'Cilempuyang',
  },
  {
    id: '3301040008',
    districtId: '3301040',
    name: 'Rejodadi',
  },
  {
    id: '3301040009',
    districtId: '3301040',
    name: 'Negarajati',
  },
  {
    id: '3301040010',
    districtId: '3301040',
    name: 'Cisalak',
  },
  {
    id: '3301040011',
    districtId: '3301040',
    name: 'Cibalung',
  },
  {
    id: '3301040012',
    districtId: '3301040',
    name: 'Karangsari',
  },
  {
    id: '3301040013',
    districtId: '3301040',
    name: 'Kutabima',
  },
  {
    id: '3301040014',
    districtId: '3301040',
    name: 'Pesahangan',
  },
  {
    id: '3301040015',
    districtId: '3301040',
    name: 'Cijati',
  },
  {
    id: '3301050001',
    districtId: '3301050',
    name: 'Cidadap',
  },
  {
    id: '3301050002',
    districtId: '3301050',
    name: 'Pengawaren',
  },
  {
    id: '3301050004',
    districtId: '3301050',
    name: 'Sindangbarang',
  },
  {
    id: '3301050005',
    districtId: '3301050',
    name: 'Karangpucung',
  },
  {
    id: '3301050006',
    districtId: '3301050',
    name: 'Tayemtimur',
  },
  {
    id: '3301050007',
    districtId: '3301050',
    name: 'Tayem',
  },
  {
    id: '3301050008',
    districtId: '3301050',
    name: 'Ciporos',
  },
  {
    id: '3301050009',
    districtId: '3301050',
    name: 'Surusunda',
  },
  {
    id: '3301050010',
    districtId: '3301050',
    name: 'Bengbulang',
  },
  {
    id: '3301050011',
    districtId: '3301050',
    name: 'Sidamulya',
  },
  {
    id: '3301050012',
    districtId: '3301050',
    name: 'Ciruyung',
  },
  {
    id: '3301050013',
    districtId: '3301050',
    name: 'Pamulihan',
  },
  {
    id: '3301050014',
    districtId: '3301050',
    name: 'Babakan',
  },
  {
    id: '3301060001',
    districtId: '3301060',
    name: 'Serang',
  },
  {
    id: '3301060002',
    districtId: '3301060',
    name: 'Mulyadadi',
  },
  {
    id: '3301060003',
    districtId: '3301060',
    name: 'Cipari',
  },
  {
    id: '3301060004',
    districtId: '3301060',
    name: 'Segaralangu',
  },
  {
    id: '3301060005',
    districtId: '3301060',
    name: 'Karangreja',
  },
  {
    id: '3301060006',
    districtId: '3301060',
    name: 'Kutasari',
  },
  {
    id: '3301060007',
    districtId: '3301060',
    name: 'Pegadingan',
  },
  {
    id: '3301060008',
    districtId: '3301060',
    name: 'Cisuru',
  },
  {
    id: '3301060009',
    districtId: '3301060',
    name: 'Mekarsari',
  },
  {
    id: '3301060010',
    districtId: '3301060',
    name: 'Sidasari',
  },
  {
    id: '3301060011',
    districtId: '3301060',
    name: 'Caruy',
  },
  {
    id: '3301070001',
    districtId: '3301070',
    name: 'Tegalsari',
  },
  {
    id: '3301070002',
    districtId: '3301070',
    name: 'Margasari',
  },
  {
    id: '3301070003',
    districtId: '3301070',
    name: 'Tinggarjaya',
  },
  {
    id: '3301070004',
    districtId: '3301070',
    name: 'Gunungreja',
  },
  {
    id: '3301070005',
    districtId: '3301070',
    name: 'Sidareja',
  },
  {
    id: '3301070006',
    districtId: '3301070',
    name: 'Sidamulya',
  },
  {
    id: '3301070007',
    districtId: '3301070',
    name: 'Sudagaran',
  },
  {
    id: '3301070008',
    districtId: '3301070',
    name: 'Kunci',
  },
  {
    id: '3301070009',
    districtId: '3301070',
    name: 'Karanggedang',
  },
  {
    id: '3301070010',
    districtId: '3301070',
    name: 'Penyarang',
  },
  {
    id: '3301080001',
    districtId: '3301080',
    name: 'Sidanegara',
  },
  {
    id: '3301080002',
    districtId: '3301080',
    name: 'Tambakreja',
  },
  {
    id: '3301080003',
    districtId: '3301080',
    name: 'Kaliwungu',
  },
  {
    id: '3301080004',
    districtId: '3301080',
    name: 'Bumireja',
  },
  {
    id: '3301080005',
    districtId: '3301080',
    name: 'Jatisari',
  },
  {
    id: '3301080006',
    districtId: '3301080',
    name: 'Ciklapa',
  },
  {
    id: '3301080007',
    districtId: '3301080',
    name: 'Bangunreja',
  },
  {
    id: '3301080008',
    districtId: '3301080',
    name: 'Kedungreja',
  },
  {
    id: '3301080009',
    districtId: '3301080',
    name: 'Tambaksari',
  },
  {
    id: '3301080010',
    districtId: '3301080',
    name: 'Rejamulya',
  },
  {
    id: '3301080011',
    districtId: '3301080',
    name: 'Bojongsari',
  },
  {
    id: '3301090001',
    districtId: '3301090',
    name: 'Rawaapu',
  },
  {
    id: '3301090002',
    districtId: '3301090',
    name: 'Sidamukti',
  },
  {
    id: '3301090003',
    districtId: '3301090',
    name: 'Purwodadi',
  },
  {
    id: '3301090004',
    districtId: '3301090',
    name: 'Cimrutu',
  },
  {
    id: '3301090005',
    districtId: '3301090',
    name: 'Patimuan',
  },
  {
    id: '3301090006',
    districtId: '3301090',
    name: 'Cinyawang',
  },
  {
    id: '3301090007',
    districtId: '3301090',
    name: 'Bulupayung',
  },
  {
    id: '3301100001',
    districtId: '3301100',
    name: 'Cisumur',
  },
  {
    id: '3301100002',
    districtId: '3301100',
    name: 'Sidaurip',
  },
  {
    id: '3301100003',
    districtId: '3301100',
    name: 'Gintungreja',
  },
  {
    id: '3301100004',
    districtId: '3301100',
    name: 'Layansari',
  },
  {
    id: '3301100005',
    districtId: '3301100',
    name: 'Gandrungmanis',
  },
  {
    id: '3301100006',
    districtId: '3301100',
    name: 'Bulusari',
  },
  {
    id: '3301100007',
    districtId: '3301100',
    name: 'Gandrungmangu',
  },
  {
    id: '3301100008',
    districtId: '3301100',
    name: 'Wringinharjo',
  },
  {
    id: '3301100009',
    districtId: '3301100',
    name: 'Karanganyar',
  },
  {
    id: '3301100010',
    districtId: '3301100',
    name: 'Muktisari',
  },
  {
    id: '3301100011',
    districtId: '3301100',
    name: 'Kertajaya',
  },
  {
    id: '3301100012',
    districtId: '3301100',
    name: 'Cinangsi',
  },
  {
    id: '3301100013',
    districtId: '3301100',
    name: 'Karanggintung',
  },
  {
    id: '3301100014',
    districtId: '3301100',
    name: 'Rungkang',
  },
  {
    id: '3301110001',
    districtId: '3301110',
    name: 'Bantarsari',
  },
  {
    id: '3301110002',
    districtId: '3301110',
    name: 'Rawajaya',
  },
  {
    id: '3301110003',
    districtId: '3301110',
    name: 'Binangun',
  },
  {
    id: '3301110004',
    districtId: '3301110',
    name: 'Bulaksari',
  },
  {
    id: '3301110005',
    districtId: '3301110',
    name: 'Kamulyan',
  },
  {
    id: '3301110006',
    districtId: '3301110',
    name: 'Cikedondong',
  },
  {
    id: '3301110007',
    districtId: '3301110',
    name: 'Kedungwadas',
  },
  {
    id: '3301110008',
    districtId: '3301110',
    name: 'Citembong',
  },
  {
    id: '3301120005',
    districtId: '3301120',
    name: 'Bringkeng',
  },
  {
    id: '3301120006',
    districtId: '3301120',
    name: 'Ujungmanik',
  },
  {
    id: '3301120007',
    districtId: '3301120',
    name: 'Kubangkangkung',
  },
  {
    id: '3301120008',
    districtId: '3301120',
    name: 'Bojong',
  },
  {
    id: '3301120009',
    districtId: '3301120',
    name: 'Kawunganten',
  },
  {
    id: '3301120010',
    districtId: '3301120',
    name: 'Kawunganten Lor',
  },
  {
    id: '3301120011',
    districtId: '3301120',
    name: 'Sarwadadi',
  },
  {
    id: '3301120012',
    districtId: '3301120',
    name: 'Kalijeruk',
  },
  {
    id: '3301120013',
    districtId: '3301120',
    name: 'Mentasan',
  },
  {
    id: '3301120015',
    districtId: '3301120',
    name: 'Sidaurip',
  },
  {
    id: '3301120016',
    districtId: '3301120',
    name: 'Babakan',
  },
  {
    id: '3301121001',
    districtId: '3301121',
    name: 'Ujunggagak',
  },
  {
    id: '3301121002',
    districtId: '3301121',
    name: 'Klaces',
  },
  {
    id: '3301121003',
    districtId: '3301121',
    name: 'Ujungalang',
  },
  {
    id: '3301121004',
    districtId: '3301121',
    name: 'Panikel',
  },
  {
    id: '3301130002',
    districtId: '3301130',
    name: 'Tritih Wetan',
  },
  {
    id: '3301130003',
    districtId: '3301130',
    name: 'Tritih Lor',
  },
  {
    id: '3301130004',
    districtId: '3301130',
    name: 'Sumingkir',
  },
  {
    id: '3301130005',
    districtId: '3301130',
    name: 'Jeruklegi Wetan',
  },
  {
    id: '3301130006',
    districtId: '3301130',
    name: 'Jeruklegi Kulon',
  },
  {
    id: '3301130007',
    districtId: '3301130',
    name: 'Sawangan',
  },
  {
    id: '3301130008',
    districtId: '3301130',
    name: 'Cilibang',
  },
  {
    id: '3301130009',
    districtId: '3301130',
    name: 'Mendala',
  },
  {
    id: '3301130010',
    districtId: '3301130',
    name: 'Karangkemiri',
  },
  {
    id: '3301130011',
    districtId: '3301130',
    name: 'Jambusari',
  },
  {
    id: '3301130012',
    districtId: '3301130',
    name: 'Prapagan',
  },
  {
    id: '3301130013',
    districtId: '3301130',
    name: 'Citepus',
  },
  {
    id: '3301140001',
    districtId: '3301140',
    name: 'Menganti',
  },
  {
    id: '3301140002',
    districtId: '3301140',
    name: 'Karangkandri',
  },
  {
    id: '3301140003',
    districtId: '3301140',
    name: 'Slarang',
  },
  {
    id: '3301140004',
    districtId: '3301140',
    name: 'Kesugihan Kidul',
  },
  {
    id: '3301140005',
    districtId: '3301140',
    name: 'Kesugihan',
  },
  {
    id: '3301140006',
    districtId: '3301140',
    name: 'Kalisabuk',
  },
  {
    id: '3301140007',
    districtId: '3301140',
    name: 'Kuripan Kidul',
  },
  {
    id: '3301140008',
    districtId: '3301140',
    name: 'Kuripan',
  },
  {
    id: '3301140009',
    districtId: '3301140',
    name: 'Jangrana',
  },
  {
    id: '3301140010',
    districtId: '3301140',
    name: 'Planjan',
  },
  {
    id: '3301140011',
    districtId: '3301140',
    name: 'Dondong',
  },
  {
    id: '3301140012',
    districtId: '3301140',
    name: 'Ciwuni',
  },
  {
    id: '3301140013',
    districtId: '3301140',
    name: 'Karangjengkol',
  },
  {
    id: '3301140015',
    districtId: '3301140',
    name: 'Pesanggrahan',
  },
  {
    id: '3301140016',
    districtId: '3301140',
    name: 'Bulupayung',
  },
  {
    id: '3301150001',
    districtId: '3301150',
    name: 'Gombolharjo',
  },
  {
    id: '3301150002',
    districtId: '3301150',
    name: 'Wlahar',
  },
  {
    id: '3301150003',
    districtId: '3301150',
    name: 'Bunton',
  },
  {
    id: '3301150004',
    districtId: '3301150',
    name: 'Karanganyar',
  },
  {
    id: '3301150005',
    districtId: '3301150',
    name: 'Karangbenda',
  },
  {
    id: '3301150006',
    districtId: '3301150',
    name: 'Pedasong',
  },
  {
    id: '3301150007',
    districtId: '3301150',
    name: 'Glempangpasir',
  },
  {
    id: '3301150008',
    districtId: '3301150',
    name: 'Welahan Wetan',
  },
  {
    id: '3301150009',
    districtId: '3301150',
    name: 'Adiraja',
  },
  {
    id: '3301150010',
    districtId: '3301150',
    name: 'Adireja Wetan',
  },
  {
    id: '3301150011',
    districtId: '3301150',
    name: 'Adireja Kulon',
  },
  {
    id: '3301150012',
    districtId: '3301150',
    name: 'Adipala',
  },
  {
    id: '3301150013',
    districtId: '3301150',
    name: 'Penggalang',
  },
  {
    id: '3301150014',
    districtId: '3301150',
    name: 'Karangsari',
  },
  {
    id: '3301150015',
    districtId: '3301150',
    name: 'Kalikudi',
  },
  {
    id: '3301150016',
    districtId: '3301150',
    name: 'Doplang',
  },
  {
    id: '3301160001',
    districtId: '3301160',
    name: 'Karangkemiri',
  },
  {
    id: '3301160002',
    districtId: '3301160',
    name: 'Karangreja',
  },
  {
    id: '3301160003',
    districtId: '3301160',
    name: 'Klapagada',
  },
  {
    id: '3301160004',
    districtId: '3301160',
    name: 'Karangrena',
  },
  {
    id: '3301160005',
    districtId: '3301160',
    name: 'Maos Kidul',
  },
  {
    id: '3301160006',
    districtId: '3301160',
    name: 'Maos Lor',
  },
  {
    id: '3301160007',
    districtId: '3301160',
    name: 'Kalijaran',
  },
  {
    id: '3301160009',
    districtId: '3301160',
    name: 'Penisihan',
  },
  {
    id: '3301160010',
    districtId: '3301160',
    name: 'Glempang',
  },
  {
    id: '3301170001',
    districtId: '3301170',
    name: 'Paketingan',
  },
  {
    id: '3301170002',
    districtId: '3301170',
    name: 'Ketanggung',
  },
  {
    id: '3301170003',
    districtId: '3301170',
    name: 'Nusajati',
  },
  {
    id: '3301170004',
    districtId: '3301170',
    name: 'Paberasan',
  },
  {
    id: '3301170005',
    districtId: '3301170',
    name: 'Karangjati',
  },
  {
    id: '3301170006',
    districtId: '3301170',
    name: 'Sidasari',
  },
  {
    id: '3301170007',
    districtId: '3301170',
    name: 'Karangasem',
  },
  {
    id: '3301170008',
    districtId: '3301170',
    name: 'Sampang',
  },
  {
    id: '3301170009',
    districtId: '3301170',
    name: 'Karangtengah',
  },
  {
    id: '3301170010',
    districtId: '3301170',
    name: 'B R A N I',
  },
  {
    id: '3301180001',
    districtId: '3301180',
    name: 'Sikampuh',
  },
  {
    id: '3301180002',
    districtId: '3301180',
    name: 'Karangturi',
  },
  {
    id: '3301180003',
    districtId: '3301180',
    name: 'Ayamalas',
  },
  {
    id: '3301180004',
    districtId: '3301180',
    name: 'Karangmangu',
  },
  {
    id: '3301180005',
    districtId: '3301180',
    name: 'Pucung Kidul',
  },
  {
    id: '3301180006',
    districtId: '3301180',
    name: 'Mergawati',
  },
  {
    id: '3301180007',
    districtId: '3301180',
    name: 'Pucung Lor',
  },
  {
    id: '3301180008',
    districtId: '3301180',
    name: 'Bajing',
  },
  {
    id: '3301180009',
    districtId: '3301180',
    name: 'Kroya',
  },
  {
    id: '3301180010',
    districtId: '3301180',
    name: 'Pesanggrahan',
  },
  {
    id: '3301180012',
    districtId: '3301180',
    name: 'Bajing Kulon',
  },
  {
    id: '3301180013',
    districtId: '3301180',
    name: 'Kedawung',
  },
  {
    id: '3301180015',
    districtId: '3301180',
    name: 'Gentasari',
  },
  {
    id: '3301180016',
    districtId: '3301180',
    name: 'Mujur Lor',
  },
  {
    id: '3301190001',
    districtId: '3301190',
    name: 'Widarapayung Kulon',
  },
  {
    id: '3301190002',
    districtId: '3301190',
    name: 'Sidayu',
  },
  {
    id: '3301190003',
    districtId: '3301190',
    name: 'Widarapayung Wetan',
  },
  {
    id: '3301190004',
    districtId: '3301190',
    name: 'Sidaurip',
  },
  {
    id: '3301190005',
    districtId: '3301190',
    name: 'Pagubugan Kulon',
  },
  {
    id: '3301190006',
    districtId: '3301190',
    name: 'Pagubugan',
  },
  {
    id: '3301190007',
    districtId: '3301190',
    name: 'Karangnangka',
  },
  {
    id: '3301190008',
    districtId: '3301190',
    name: 'Kemojing',
  },
  {
    id: '3301190009',
    districtId: '3301190',
    name: 'Pesawahan',
  },
  {
    id: '3301190010',
    districtId: '3301190',
    name: 'Pasuruhan',
  },
  {
    id: '3301190011',
    districtId: '3301190',
    name: 'Alangamba',
  },
  {
    id: '3301190012',
    districtId: '3301190',
    name: 'Binangun',
  },
  {
    id: '3301190013',
    districtId: '3301190',
    name: 'Bangkal',
  },
  {
    id: '3301190014',
    districtId: '3301190',
    name: 'Jepara Wetan',
  },
  {
    id: '3301190015',
    districtId: '3301190',
    name: 'Jepara Kulon',
  },
  {
    id: '3301190016',
    districtId: '3301190',
    name: 'Kepudang',
  },
  {
    id: '3301190017',
    districtId: '3301190',
    name: 'Jati',
  },
  {
    id: '3301200001',
    districtId: '3301200',
    name: 'Karangtawang',
  },
  {
    id: '3301200002',
    districtId: '3301200',
    name: 'Karangpakis',
  },
  {
    id: '3301200003',
    districtId: '3301200',
    name: 'Banjarsari',
  },
  {
    id: '3301200004',
    districtId: '3301200',
    name: 'Jetis',
  },
  {
    id: '3301200005',
    districtId: '3301200',
    name: 'Banjareja',
  },
  {
    id: '3301200006',
    districtId: '3301200',
    name: 'Kedungbenda',
  },
  {
    id: '3301200007',
    districtId: '3301200',
    name: 'Klumprit',
  },
  {
    id: '3301200008',
    districtId: '3301200',
    name: 'Karangsembung',
  },
  {
    id: '3301200009',
    districtId: '3301200',
    name: 'Purwadadi',
  },
  {
    id: '3301200010',
    districtId: '3301200',
    name: 'Nusawangkal',
  },
  {
    id: '3301200011',
    districtId: '3301200',
    name: 'Karangputat',
  },
  {
    id: '3301200012',
    districtId: '3301200',
    name: 'Banjarwaru',
  },
  {
    id: '3301200013',
    districtId: '3301200',
    name: 'Danasri',
  },
  {
    id: '3301200014',
    districtId: '3301200',
    name: 'Danasri Kidul',
  },
  {
    id: '3301200015',
    districtId: '3301200',
    name: 'Nusawungu',
  },
  {
    id: '3301200016',
    districtId: '3301200',
    name: 'Danasri Lor',
  },
  {
    id: '3301200017',
    districtId: '3301200',
    name: 'Sikanco',
  },
  {
    id: '3301710001',
    districtId: '3301710',
    name: 'Tambakreja',
  },
  {
    id: '3301710002',
    districtId: '3301710',
    name: 'Tegalrejo',
  },
  {
    id: '3301710003',
    districtId: '3301710',
    name: 'Sidakaya',
  },
  {
    id: '3301710004',
    districtId: '3301710',
    name: 'Cilacap',
  },
  {
    id: '3301710005',
    districtId: '3301710',
    name: 'Tegalkamulyan',
  },
  {
    id: '3301720001',
    districtId: '3301720',
    name: 'Kutawaru',
  },
  {
    id: '3301720002',
    districtId: '3301720',
    name: 'Lomanis',
  },
  {
    id: '3301720003',
    districtId: '3301720',
    name: 'Donan',
  },
  {
    id: '3301720004',
    districtId: '3301720',
    name: 'Sidanegara',
  },
  {
    id: '3301720005',
    districtId: '3301720',
    name: 'Gunungsimping',
  },
  {
    id: '3301730001',
    districtId: '3301730',
    name: 'Kebonmanis',
  },
  {
    id: '3301730002',
    districtId: '3301730',
    name: 'Gumilir',
  },
  {
    id: '3301730003',
    districtId: '3301730',
    name: 'Mertasinga',
  },
  {
    id: '3301730004',
    districtId: '3301730',
    name: 'Tritih Kulon',
  },
  {
    id: '3301730005',
    districtId: '3301730',
    name: 'Karangtalun',
  },
  {
    id: '3302010001',
    districtId: '3302010',
    name: 'Cingebul',
  },
  {
    id: '3302010003',
    districtId: '3302010',
    name: 'Cidora',
  },
  {
    id: '3302010004',
    districtId: '3302010',
    name: 'Besuki',
  },
  {
    id: '3302010005',
    districtId: '3302010',
    name: 'Parungkamal',
  },
  {
    id: '3302010006',
    districtId: '3302010',
    name: 'Cirahab',
  },
  {
    id: '3302010007',
    districtId: '3302010',
    name: 'Canduk',
  },
  {
    id: '3302010008',
    districtId: '3302010',
    name: 'Karanggayam',
  },
  {
    id: '3302010009',
    districtId: '3302010',
    name: 'Lumbir',
  },
  {
    id: '3302010010',
    districtId: '3302010',
    name: 'Dermaji',
  },
  {
    id: '3302020001',
    districtId: '3302020',
    name: 'Randegan',
  },
  {
    id: '3302020002',
    districtId: '3302020',
    name: 'Rawaheng',
  },
  {
    id: '3302020003',
    districtId: '3302020',
    name: 'Pangadegan',
  },
  {
    id: '3302020004',
    districtId: '3302020',
    name: 'Klapagading',
  },
  {
    id: '3302020005',
    districtId: '3302020',
    name: 'Klapagading Kulon',
  },
  {
    id: '3302020006',
    districtId: '3302020',
    name: 'Wangon',
  },
  {
    id: '3302020007',
    districtId: '3302020',
    name: 'Banteran',
  },
  {
    id: '3302020008',
    districtId: '3302020',
    name: 'Jambu',
  },
  {
    id: '3302020009',
    districtId: '3302020',
    name: 'Jurangbahas',
  },
  {
    id: '3302020010',
    districtId: '3302020',
    name: 'Cikakak',
  },
  {
    id: '3302020011',
    districtId: '3302020',
    name: 'Wlahar',
  },
  {
    id: '3302020012',
    districtId: '3302020',
    name: 'Windunegara',
  },
  {
    id: '3302030001',
    districtId: '3302030',
    name: 'Gunung Wetan',
  },
  {
    id: '3302030003',
    districtId: '3302030',
    name: 'Karanglewas',
  },
  {
    id: '3302030004',
    districtId: '3302030',
    name: 'Karanganyar',
  },
  {
    id: '3302030005',
    districtId: '3302030',
    name: 'Margasana',
  },
  {
    id: '3302030006',
    districtId: '3302030',
    name: 'Adisara',
  },
  {
    id: '3302030007',
    districtId: '3302030',
    name: 'Kedungwringin',
  },
  {
    id: '3302030008',
    districtId: '3302030',
    name: 'Bantar',
  },
  {
    id: '3302030009',
    districtId: '3302030',
    name: 'Tinggarjaya',
  },
  {
    id: '3302030011',
    districtId: '3302030',
    name: 'Gentawangi',
  },
  {
    id: '3302040001',
    districtId: '3302040',
    name: 'Losari',
  },
  {
    id: '3302040002',
    districtId: '3302040',
    name: 'Menganti',
  },
  {
    id: '3302040003',
    districtId: '3302040',
    name: 'Banjarparakan',
  },
  {
    id: '3302040004',
    districtId: '3302040',
    name: 'Rawalo',
  },
  {
    id: '3302040005',
    districtId: '3302040',
    name: 'Tambaknegara',
  },
  {
    id: '3302040006',
    districtId: '3302040',
    name: 'Sidamulih',
  },
  {
    id: '3302040007',
    districtId: '3302040',
    name: 'Pesawahan',
  },
  {
    id: '3302040008',
    districtId: '3302040',
    name: 'Tipar',
  },
  {
    id: '3302040009',
    districtId: '3302040',
    name: 'Sanggreman',
  },
  {
    id: '3302050001',
    districtId: '3302050',
    name: 'Adisana',
  },
  {
    id: '3302050002',
    districtId: '3302050',
    name: 'Bangsa',
  },
  {
    id: '3302050003',
    districtId: '3302050',
    name: 'Karangsari',
  },
  {
    id: '3302050004',
    districtId: '3302050',
    name: 'Randegan',
  },
  {
    id: '3302050005',
    districtId: '3302050',
    name: 'Kaliwedi',
  },
  {
    id: '3302050006',
    districtId: '3302050',
    name: 'Sawangan',
  },
  {
    id: '3302050007',
    districtId: '3302050',
    name: 'Kalisalak',
  },
  {
    id: '3302050008',
    districtId: '3302050',
    name: 'Cindaga',
  },
  {
    id: '3302050009',
    districtId: '3302050',
    name: 'Kebasen',
  },
  {
    id: '3302050010',
    districtId: '3302050',
    name: 'Gambarsari',
  },
  {
    id: '3302050011',
    districtId: '3302050',
    name: 'Tumiyang',
  },
  {
    id: '3302050012',
    districtId: '3302050',
    name: 'Mandirancan',
  },
  {
    id: '3302060001',
    districtId: '3302060',
    name: 'Grujugan',
  },
  {
    id: '3302060002',
    districtId: '3302060',
    name: 'Sirau',
  },
  {
    id: '3302060003',
    districtId: '3302060',
    name: 'Sibalung',
  },
  {
    id: '3302060004',
    districtId: '3302060',
    name: 'Sibrama',
  },
  {
    id: '3302060005',
    districtId: '3302060',
    name: 'Kedungpring',
  },
  {
    id: '3302060006',
    districtId: '3302060',
    name: 'Kecila',
  },
  {
    id: '3302060007',
    districtId: '3302060',
    name: 'Nusamangir',
  },
  {
    id: '3302060008',
    districtId: '3302060',
    name: 'Karangjati',
  },
  {
    id: '3302060009',
    districtId: '3302060',
    name: 'Kebarongan',
  },
  {
    id: '3302060010',
    districtId: '3302060',
    name: 'Sidamulya',
  },
  {
    id: '3302060011',
    districtId: '3302060',
    name: 'Pageralang',
  },
  {
    id: '3302060012',
    districtId: '3302060',
    name: 'Alasmalang',
  },
  {
    id: '3302060013',
    districtId: '3302060',
    name: 'Petarangan',
  },
  {
    id: '3302060014',
    districtId: '3302060',
    name: 'Karanggintung',
  },
  {
    id: '3302060015',
    districtId: '3302060',
    name: 'Karangsalam',
  },
  {
    id: '3302070001',
    districtId: '3302070',
    name: 'Pandak',
  },
  {
    id: '3302070002',
    districtId: '3302070',
    name: 'Kuntili',
  },
  {
    id: '3302070003',
    districtId: '3302070',
    name: 'Kemiri',
  },
  {
    id: '3302070004',
    districtId: '3302070',
    name: 'Karanggedang',
  },
  {
    id: '3302070005',
    districtId: '3302070',
    name: 'Nusadadi',
  },
  {
    id: '3302070006',
    districtId: '3302070',
    name: 'Selandaka',
  },
  {
    id: '3302070007',
    districtId: '3302070',
    name: 'Sumpiuh',
  },
  {
    id: '3302070008',
    districtId: '3302070',
    name: 'Kradenan',
  },
  {
    id: '3302070009',
    districtId: '3302070',
    name: 'Selanegara',
  },
  {
    id: '3302070010',
    districtId: '3302070',
    name: 'Kebokura',
  },
  {
    id: '3302070012',
    districtId: '3302070',
    name: 'Ketanda',
  },
  {
    id: '3302070013',
    districtId: '3302070',
    name: 'Banjarpanepen',
  },
  {
    id: '3302070014',
    districtId: '3302070',
    name: 'Bogangin',
  },
  {
    id: '3302080001',
    districtId: '3302080',
    name: 'Plangkapan',
  },
  {
    id: '3302080002',
    districtId: '3302080',
    name: 'Gumelar Lor',
  },
  {
    id: '3302080003',
    districtId: '3302080',
    name: 'Gumelar Kidul',
  },
  {
    id: '3302080004',
    districtId: '3302080',
    name: 'Karangpetir',
  },
  {
    id: '3302080005',
    districtId: '3302080',
    name: 'Gebangsari',
  },
  {
    id: '3302080006',
    districtId: '3302080',
    name: 'Karangpucung',
  },
  {
    id: '3302080008',
    districtId: '3302080',
    name: 'Pesantren',
  },
  {
    id: '3302080009',
    districtId: '3302080',
    name: 'Buniayu',
  },
  {
    id: '3302080010',
    districtId: '3302080',
    name: 'Purwodadi',
  },
  {
    id: '3302080011',
    districtId: '3302080',
    name: 'Kamulyan',
  },
  {
    id: '3302080012',
    districtId: '3302080',
    name: 'Watuagung',
  },
  {
    id: '3302090001',
    districtId: '3302090',
    name: 'Tanggeran',
  },
  {
    id: '3302090002',
    districtId: '3302090',
    name: 'Sokawera',
  },
  {
    id: '3302090003',
    districtId: '3302090',
    name: 'Somagede',
  },
  {
    id: '3302090004',
    districtId: '3302090',
    name: 'Klinting',
  },
  {
    id: '3302090005',
    districtId: '3302090',
    name: 'Kemawi',
  },
  {
    id: '3302090006',
    districtId: '3302090',
    name: 'Piasa Kulon',
  },
  {
    id: '3302090007',
    districtId: '3302090',
    name: 'Kanding',
  },
  {
    id: '3302090008',
    districtId: '3302090',
    name: 'Somakaton',
  },
  {
    id: '3302090009',
    districtId: '3302090',
    name: 'Plana',
  },
  {
    id: '3302100001',
    districtId: '3302100',
    name: 'Srowot',
  },
  {
    id: '3302100002',
    districtId: '3302100',
    name: 'Suro',
  },
  {
    id: '3302100003',
    districtId: '3302100',
    name: 'Kaliori',
  },
  {
    id: '3302100004',
    districtId: '3302100',
    name: 'Wlahar Wetan',
  },
  {
    id: '3302100005',
    districtId: '3302100',
    name: 'Pekaja',
  },
  {
    id: '3302100006',
    districtId: '3302100',
    name: 'Karangdadap',
  },
  {
    id: '3302100007',
    districtId: '3302100',
    name: 'Kalibagor',
  },
  {
    id: '3302100008',
    districtId: '3302100',
    name: 'Pajerukan',
  },
  {
    id: '3302100009',
    districtId: '3302100',
    name: 'Petir',
  },
  {
    id: '3302100010',
    districtId: '3302100',
    name: 'Kalicupak Kidul',
  },
  {
    id: '3302100011',
    districtId: '3302100',
    name: 'Kalicupak Lor',
  },
  {
    id: '3302100012',
    districtId: '3302100',
    name: 'Kalisogra Wetan',
  },
  {
    id: '3302110001',
    districtId: '3302110',
    name: 'Binangun',
  },
  {
    id: '3302110002',
    districtId: '3302110',
    name: 'Pasinggangan',
  },
  {
    id: '3302110004',
    districtId: '3302110',
    name: 'Karangrau',
  },
  {
    id: '3302110005',
    districtId: '3302110',
    name: 'Kejawar',
  },
  {
    id: '3302110006',
    districtId: '3302110',
    name: 'Danaraja',
  },
  {
    id: '3302110008',
    districtId: '3302110',
    name: 'Sudagaran',
  },
  {
    id: '3302110010',
    districtId: '3302110',
    name: 'Kalisube',
  },
  {
    id: '3302110011',
    districtId: '3302110',
    name: 'Dawuhan',
  },
  {
    id: '3302110012',
    districtId: '3302110',
    name: 'Papringan',
  },
  {
    id: '3302120001',
    districtId: '3302120',
    name: 'Sawangan Wetan',
  },
  {
    id: '3302120002',
    districtId: '3302120',
    name: 'Karangendep',
  },
  {
    id: '3302120003',
    districtId: '3302120',
    name: 'Notog',
  },
  {
    id: '3302120004',
    districtId: '3302120',
    name: 'Patikraja',
  },
  {
    id: '3302120005',
    districtId: '3302120',
    name: 'Pegalongan',
  },
  {
    id: '3302120006',
    districtId: '3302120',
    name: 'Sokawera Kidul',
  },
  {
    id: '3302120007',
    districtId: '3302120',
    name: 'Wlahar Kulon',
  },
  {
    id: '3302120008',
    districtId: '3302120',
    name: 'Kedungrandu',
  },
  {
    id: '3302120009',
    districtId: '3302120',
    name: 'Kedungwuluh Kidul',
  },
  {
    id: '3302120010',
    districtId: '3302120',
    name: 'Kedungwuluh Lor',
  },
  {
    id: '3302120011',
    districtId: '3302120',
    name: 'Karanganyar',
  },
  {
    id: '3302120012',
    districtId: '3302120',
    name: 'Sidabowa',
  },
  {
    id: '3302120013',
    districtId: '3302120',
    name: 'Kedungwringin',
  },
  {
    id: '3302130002',
    districtId: '3302130',
    name: 'Karangtalun Kidul',
  },
  {
    id: '3302130003',
    districtId: '3302130',
    name: 'Kaliurip',
  },
  {
    id: '3302130004',
    districtId: '3302130',
    name: 'Karangtalun Lor',
  },
  {
    id: '3302130005',
    districtId: '3302130',
    name: 'Purwojati',
  },
  {
    id: '3302130006',
    districtId: '3302130',
    name: 'Klapasawit',
  },
  {
    id: '3302130007',
    districtId: '3302130',
    name: 'Karangmangu',
  },
  {
    id: '3302130008',
    districtId: '3302130',
    name: 'Kaliputih',
  },
  {
    id: '3302130009',
    districtId: '3302130',
    name: 'Kaliwangi',
  },
  {
    id: '3302130010',
    districtId: '3302130',
    name: 'Kalitapen',
  },
  {
    id: '3302140001',
    districtId: '3302140',
    name: 'Darmakradenan',
  },
  {
    id: '3302140002',
    districtId: '3302140',
    name: 'Tipar Kidul',
  },
  {
    id: '3302140003',
    districtId: '3302140',
    name: 'Sawangan',
  },
  {
    id: '3302140004',
    districtId: '3302140',
    name: 'Jingkang',
  },
  {
    id: '3302140005',
    districtId: '3302140',
    name: 'Banjarsari',
  },
  {
    id: '3302140006',
    districtId: '3302140',
    name: 'Kalibenda',
  },
  {
    id: '3302140007',
    districtId: '3302140',
    name: 'Pancurendang',
  },
  {
    id: '3302140008',
    districtId: '3302140',
    name: 'Pancasan',
  },
  {
    id: '3302140009',
    districtId: '3302140',
    name: 'Karangbawang',
  },
  {
    id: '3302140010',
    districtId: '3302140',
    name: 'Kracak',
  },
  {
    id: '3302140011',
    districtId: '3302140',
    name: 'Ajibarang Kulon',
  },
  {
    id: '3302140012',
    districtId: '3302140',
    name: 'Ajibarang Wetan',
  },
  {
    id: '3302140013',
    districtId: '3302140',
    name: 'Lesmana',
  },
  {
    id: '3302140014',
    districtId: '3302140',
    name: 'Pandansari',
  },
  {
    id: '3302140015',
    districtId: '3302140',
    name: 'Ciberung',
  },
  {
    id: '3302150001',
    districtId: '3302150',
    name: 'Cilangkap',
  },
  {
    id: '3302150002',
    districtId: '3302150',
    name: 'Cihonje',
  },
  {
    id: '3302150003',
    districtId: '3302150',
    name: 'Paningkaban',
  },
  {
    id: '3302150004',
    districtId: '3302150',
    name: 'Karangkemojing',
  },
  {
    id: '3302150005',
    districtId: '3302150',
    name: 'Gancang',
  },
  {
    id: '3302150006',
    districtId: '3302150',
    name: 'Kedungurang',
  },
  {
    id: '3302150007',
    districtId: '3302150',
    name: 'Gumelar',
  },
  {
    id: '3302150008',
    districtId: '3302150',
    name: 'Tlaga',
  },
  {
    id: '3302150009',
    districtId: '3302150',
    name: 'Samudra',
  },
  {
    id: '3302150010',
    districtId: '3302150',
    name: 'Samudra Kulon',
  },
  {
    id: '3302160001',
    districtId: '3302160',
    name: 'Cibangkong',
  },
  {
    id: '3302160002',
    districtId: '3302160',
    name: 'Petahunan',
  },
  {
    id: '3302160003',
    districtId: '3302160',
    name: 'Semedo',
  },
  {
    id: '3302160004',
    districtId: '3302160',
    name: 'Cikawung',
  },
  {
    id: '3302160005',
    districtId: '3302160',
    name: 'Karangklesem',
  },
  {
    id: '3302160006',
    districtId: '3302160',
    name: 'Candinegara',
  },
  {
    id: '3302160007',
    districtId: '3302160',
    name: 'Cikembulan',
  },
  {
    id: '3302160008',
    districtId: '3302160',
    name: 'Tumiyang',
  },
  {
    id: '3302160009',
    districtId: '3302160',
    name: 'Glempang',
  },
  {
    id: '3302160011',
    districtId: '3302160',
    name: 'Pasiraman Lor',
  },
  {
    id: '3302160012',
    districtId: '3302160',
    name: 'Pasiraman Kidul',
  },
  {
    id: '3302160013',
    districtId: '3302160',
    name: 'Banjaranyar',
  },
  {
    id: '3302160014',
    districtId: '3302160',
    name: 'Karangkemiri',
  },
  {
    id: '3302160015',
    districtId: '3302160',
    name: 'Kranggan',
  },
  {
    id: '3302160016',
    districtId: '3302160',
    name: 'Krajan',
  },
  {
    id: '3302170001',
    districtId: '3302170',
    name: 'Batuanten',
  },
  {
    id: '3302170002',
    districtId: '3302170',
    name: 'Kasegeran',
  },
  {
    id: '3302170003',
    districtId: '3302170',
    name: 'Jatisaba',
  },
  {
    id: '3302170004',
    districtId: '3302170',
    name: 'Panusupan',
  },
  {
    id: '3302170005',
    districtId: '3302170',
    name: 'Pejogol',
  },
  {
    id: '3302170006',
    districtId: '3302170',
    name: 'Pageraji',
  },
  {
    id: '3302170007',
    districtId: '3302170',
    name: 'Sudimara',
  },
  {
    id: '3302170008',
    districtId: '3302170',
    name: 'Cilongok',
  },
  {
    id: '3302170009',
    districtId: '3302170',
    name: 'Cipete',
  },
  {
    id: '3302170010',
    districtId: '3302170',
    name: 'Cikidang',
  },
  {
    id: '3302170011',
    districtId: '3302170',
    name: 'Pernasidi',
  },
  {
    id: '3302170012',
    districtId: '3302170',
    name: 'Langgongsari',
  },
  {
    id: '3302170013',
    districtId: '3302170',
    name: 'Rancamaya',
  },
  {
    id: '3302170014',
    districtId: '3302170',
    name: 'Panembangan',
  },
  {
    id: '3302170015',
    districtId: '3302170',
    name: 'Karanglo',
  },
  {
    id: '3302170016',
    districtId: '3302170',
    name: 'Kalisari',
  },
  {
    id: '3302170017',
    districtId: '3302170',
    name: 'Karangtengah',
  },
  {
    id: '3302170018',
    districtId: '3302170',
    name: 'Sambirata',
  },
  {
    id: '3302170019',
    districtId: '3302170',
    name: 'Gununglurah',
  },
  {
    id: '3302170020',
    districtId: '3302170',
    name: 'Sokawera',
  },
  {
    id: '3302180001',
    districtId: '3302180',
    name: 'Kediri',
  },
  {
    id: '3302180002',
    districtId: '3302180',
    name: 'Pangebatan',
  },
  {
    id: '3302180003',
    districtId: '3302180',
    name: 'Karanglewas Kidul',
  },
  {
    id: '3302180004',
    districtId: '3302180',
    name: 'Tamansari',
  },
  {
    id: '3302180005',
    districtId: '3302180',
    name: 'Karangkemiri',
  },
  {
    id: '3302180006',
    districtId: '3302180',
    name: 'Karanggude Kulon',
  },
  {
    id: '3302180007',
    districtId: '3302180',
    name: 'Pasir Kulon',
  },
  {
    id: '3302180008',
    districtId: '3302180',
    name: 'Pasir Wetan',
  },
  {
    id: '3302180009',
    districtId: '3302180',
    name: 'Pasir Lor',
  },
  {
    id: '3302180010',
    districtId: '3302180',
    name: 'Jipang',
  },
  {
    id: '3302180011',
    districtId: '3302180',
    name: 'Singasari',
  },
  {
    id: '3302180012',
    districtId: '3302180',
    name: 'Babakan',
  },
  {
    id: '3302180013',
    districtId: '3302180',
    name: 'Sunyalangu',
  },
  {
    id: '3302190001',
    districtId: '3302190',
    name: 'Kedungbanteng',
  },
  {
    id: '3302190002',
    districtId: '3302190',
    name: 'Kebocoran',
  },
  {
    id: '3302190003',
    districtId: '3302190',
    name: 'Karangsalam Kidul',
  },
  {
    id: '3302190004',
    districtId: '3302190',
    name: 'Beji',
  },
  {
    id: '3302190005',
    districtId: '3302190',
    name: 'Karangnangka',
  },
  {
    id: '3302190006',
    districtId: '3302190',
    name: 'Keniten',
  },
  {
    id: '3302190007',
    districtId: '3302190',
    name: 'Dawuhan Wetan',
  },
  {
    id: '3302190008',
    districtId: '3302190',
    name: 'Dawuhan Kulon',
  },
  {
    id: '3302190009',
    districtId: '3302190',
    name: 'Baseh',
  },
  {
    id: '3302190010',
    districtId: '3302190',
    name: 'Kalisalak',
  },
  {
    id: '3302190011',
    districtId: '3302190',
    name: 'Windujaya',
  },
  {
    id: '3302190012',
    districtId: '3302190',
    name: 'Kalikesur',
  },
  {
    id: '3302190013',
    districtId: '3302190',
    name: 'Kutaliman',
  },
  {
    id: '3302200001',
    districtId: '3302200',
    name: 'Purwosari',
  },
  {
    id: '3302200002',
    districtId: '3302200',
    name: 'Kutasari',
  },
  {
    id: '3302200003',
    districtId: '3302200',
    name: 'Pandak',
  },
  {
    id: '3302200004',
    districtId: '3302200',
    name: 'Pamijen',
  },
  {
    id: '3302200005',
    districtId: '3302200',
    name: 'Rempoah',
  },
  {
    id: '3302200007',
    districtId: '3302200',
    name: 'Karangtengah',
  },
  {
    id: '3302200008',
    districtId: '3302200',
    name: 'Kemutug Kidul',
  },
  {
    id: '3302200009',
    districtId: '3302200',
    name: 'Karangsalam',
  },
  {
    id: '3302200010',
    districtId: '3302200',
    name: 'Kemutug Lor',
  },
  {
    id: '3302200011',
    districtId: '3302200',
    name: 'Karangmangu',
  },
  {
    id: '3302210001',
    districtId: '3302210',
    name: 'Karanggintung',
  },
  {
    id: '3302210002',
    districtId: '3302210',
    name: 'Tambaksogra',
  },
  {
    id: '3302210003',
    districtId: '3302210',
    name: 'Karangcegak',
  },
  {
    id: '3302210004',
    districtId: '3302210',
    name: 'Karangturi',
  },
  {
    id: '3302210005',
    districtId: '3302210',
    name: 'Silado',
  },
  {
    id: '3302210006',
    districtId: '3302210',
    name: 'Susukan',
  },
  {
    id: '3302210007',
    districtId: '3302210',
    name: 'Sumbang',
  },
  {
    id: '3302210008',
    districtId: '3302210',
    name: 'Kebanggan',
  },
  {
    id: '3302210009',
    districtId: '3302210',
    name: 'Kawungcarang',
  },
  {
    id: '3302210010',
    districtId: '3302210',
    name: 'Datar',
  },
  {
    id: '3302210011',
    districtId: '3302210',
    name: 'Banjarsari Kulon',
  },
  {
    id: '3302210012',
    districtId: '3302210',
    name: 'Banjarsari Wetan',
  },
  {
    id: '3302210013',
    districtId: '3302210',
    name: 'Banteran',
  },
  {
    id: '3302210014',
    districtId: '3302210',
    name: 'Ciberem',
  },
  {
    id: '3302210015',
    districtId: '3302210',
    name: 'Sikapat',
  },
  {
    id: '3302210016',
    districtId: '3302210',
    name: 'Gandatapa',
  },
  {
    id: '3302210017',
    districtId: '3302210',
    name: 'Kotayasa',
  },
  {
    id: '3302210018',
    districtId: '3302210',
    name: 'Limpakuwus',
  },
  {
    id: '3302210019',
    districtId: '3302210',
    name: 'Kedung Malang',
  },
  {
    id: '3302220002',
    districtId: '3302220',
    name: 'Pliken',
  },
  {
    id: '3302220003',
    districtId: '3302220',
    name: 'Purwodadi',
  },
  {
    id: '3302220004',
    districtId: '3302220',
    name: 'Karangtengah',
  },
  {
    id: '3302220005',
    districtId: '3302220',
    name: 'Kramat',
  },
  {
    id: '3302220006',
    districtId: '3302220',
    name: 'Sambeng Wetan',
  },
  {
    id: '3302220007',
    districtId: '3302220',
    name: 'Sambeng Kulon',
  },
  {
    id: '3302220008',
    districtId: '3302220',
    name: 'Purbadana',
  },
  {
    id: '3302220009',
    districtId: '3302220',
    name: 'Kembaran',
  },
  {
    id: '3302220010',
    districtId: '3302220',
    name: 'Bojongsari',
  },
  {
    id: '3302220011',
    districtId: '3302220',
    name: 'Karangsoka',
  },
  {
    id: '3302220012',
    districtId: '3302220',
    name: 'Dukuhwaluh',
  },
  {
    id: '3302220013',
    districtId: '3302220',
    name: 'Tambaksari Kidul',
  },
  {
    id: '3302220014',
    districtId: '3302220',
    name: 'Bantarwuni',
  },
  {
    id: '3302220015',
    districtId: '3302220',
    name: 'Karangsari',
  },
  {
    id: '3302220016',
    districtId: '3302220',
    name: 'Linggasari',
  },
  {
    id: '3302230001',
    districtId: '3302230',
    name: 'Kalikidang',
  },
  {
    id: '3302230002',
    districtId: '3302230',
    name: 'Sokaraja Tengah',
  },
  {
    id: '3302230003',
    districtId: '3302230',
    name: 'Sokaraja Kidul',
  },
  {
    id: '3302230004',
    districtId: '3302230',
    name: 'Sokaraja Wetan',
  },
  {
    id: '3302230005',
    districtId: '3302230',
    name: 'Klahang',
  },
  {
    id: '3302230006',
    districtId: '3302230',
    name: 'Banjarsari Kidul',
  },
  {
    id: '3302230007',
    districtId: '3302230',
    name: 'Jompo Kulon',
  },
  {
    id: '3302230008',
    districtId: '3302230',
    name: 'Banjaranyar',
  },
  {
    id: '3302230009',
    districtId: '3302230',
    name: 'Lemberang',
  },
  {
    id: '3302230010',
    districtId: '3302230',
    name: 'Karangduren',
  },
  {
    id: '3302230011',
    districtId: '3302230',
    name: 'Sokaraja Lor',
  },
  {
    id: '3302230012',
    districtId: '3302230',
    name: 'Kedondong',
  },
  {
    id: '3302230013',
    districtId: '3302230',
    name: 'Pamijen',
  },
  {
    id: '3302230014',
    districtId: '3302230',
    name: 'Sokaraja Kulon',
  },
  {
    id: '3302230015',
    districtId: '3302230',
    name: 'Karangkedawung',
  },
  {
    id: '3302230016',
    districtId: '3302230',
    name: 'Wiradadi',
  },
  {
    id: '3302230017',
    districtId: '3302230',
    name: 'Karangnanas',
  },
  {
    id: '3302230018',
    districtId: '3302230',
    name: 'Karangrau',
  },
  {
    id: '3302710001',
    districtId: '3302710',
    name: 'Karangklesem',
  },
  {
    id: '3302710003',
    districtId: '3302710',
    name: 'Berkoh',
  },
  {
    id: '3302710004',
    districtId: '3302710',
    name: 'Purwokerto Kidul',
  },
  {
    id: '3302710005',
    districtId: '3302710',
    name: 'Purwokerto Kulon',
  },
  {
    id: '3302710006',
    districtId: '3302710',
    name: 'Karangpucung',
  },
  {
    id: '3302710007',
    districtId: '3302710',
    name: 'Tanjung',
  },
  {
    id: '3302720001',
    districtId: '3302720',
    name: 'Karanglewas Lor',
  },
  {
    id: '3302720002',
    districtId: '3302720',
    name: 'Pasir Kidul',
  },
  {
    id: '3302720003',
    districtId: '3302720',
    name: 'Rejasari',
  },
  {
    id: '3302720004',
    districtId: '3302720',
    name: 'Pasirmuncang',
  },
  {
    id: '3302720005',
    districtId: '3302720',
    name: 'Bantarsoka',
  },
  {
    id: '3302720006',
    districtId: '3302720',
    name: 'Kober',
  },
  {
    id: '3302730001',
    districtId: '3302730',
    name: 'Sokanegara',
  },
  {
    id: '3302730002',
    districtId: '3302730',
    name: 'Kranji',
  },
  {
    id: '3302730003',
    districtId: '3302730',
    name: 'Purwokerto Lor',
  },
  {
    id: '3302730004',
    districtId: '3302730',
    name: 'Purwokerto Wetan',
  },
  {
    id: '3302730005',
    districtId: '3302730',
    name: 'Mersi',
  },
  {
    id: '3302730006',
    districtId: '3302730',
    name: 'Arcawinangun',
  },
  {
    id: '3302740001',
    districtId: '3302740',
    name: 'Bobosan',
  },
  {
    id: '3302740002',
    districtId: '3302740',
    name: 'Purwanegara',
  },
  {
    id: '3302740003',
    districtId: '3302740',
    name: 'Bancarkembar',
  },
  {
    id: '3302740004',
    districtId: '3302740',
    name: 'Sumampir',
  },
  {
    id: '3302740005',
    districtId: '3302740',
    name: 'Pabuaran',
  },
  {
    id: '3302740007',
    districtId: '3302740',
    name: 'Karangwangkal',
  },
  {
    id: '3303010001',
    districtId: '3303010',
    name: 'Kedungbenda',
  },
  {
    id: '3303010002',
    districtId: '3303010',
    name: 'Bokol',
  },
  {
    id: '3303010003',
    districtId: '3303010',
    name: 'Plumutan',
  },
  {
    id: '3303010004',
    districtId: '3303010',
    name: 'Majatengah',
  },
  {
    id: '3303010005',
    districtId: '3303010',
    name: 'Kedunglegok',
  },
  {
    id: '3303010006',
    districtId: '3303010',
    name: 'Kemangkon',
  },
  {
    id: '3303010007',
    districtId: '3303010',
    name: 'Panican',
  },
  {
    id: '3303010008',
    districtId: '3303010',
    name: 'Bakulan',
  },
  {
    id: '3303010009',
    districtId: '3303010',
    name: 'Karangkemiri',
  },
  {
    id: '3303010010',
    districtId: '3303010',
    name: 'Pegandekan',
  },
  {
    id: '3303010011',
    districtId: '3303010',
    name: 'Senon',
  },
  {
    id: '3303010012',
    districtId: '3303010',
    name: 'Sumilir',
  },
  {
    id: '3303010013',
    districtId: '3303010',
    name: 'Kalialang',
  },
  {
    id: '3303010014',
    districtId: '3303010',
    name: 'Karangtengah',
  },
  {
    id: '3303010015',
    districtId: '3303010',
    name: 'Muntang',
  },
  {
    id: '3303010016',
    districtId: '3303010',
    name: 'Gambarsari',
  },
  {
    id: '3303010017',
    districtId: '3303010',
    name: 'Toyareka',
  },
  {
    id: '3303010018',
    districtId: '3303010',
    name: 'Jetis',
  },
  {
    id: '3303010019',
    districtId: '3303010',
    name: 'Majasem',
  },
  {
    id: '3303020001',
    districtId: '3303020',
    name: 'Tidu',
  },
  {
    id: '3303020002',
    districtId: '3303020',
    name: 'Wirasaba',
  },
  {
    id: '3303020003',
    districtId: '3303020',
    name: 'Kembangan',
  },
  {
    id: '3303020004',
    districtId: '3303020',
    name: 'Cipawon',
  },
  {
    id: '3303020005',
    districtId: '3303020',
    name: 'Karangcengis',
  },
  {
    id: '3303020006',
    districtId: '3303020',
    name: 'Karanggedang',
  },
  {
    id: '3303020007',
    districtId: '3303020',
    name: 'Karangnangka',
  },
  {
    id: '3303020008',
    districtId: '3303020',
    name: 'Kutawis',
  },
  {
    id: '3303020010',
    districtId: '3303020',
    name: 'Penaruban',
  },
  {
    id: '3303020011',
    districtId: '3303020',
    name: 'Kedungjati',
  },
  {
    id: '3303020012',
    districtId: '3303020',
    name: 'Bukateja',
  },
  {
    id: '3303020013',
    districtId: '3303020',
    name: 'Majasari',
  },
  {
    id: '3303020014',
    districtId: '3303020',
    name: 'Bajong',
  },
  {
    id: '3303030001',
    districtId: '3303030',
    name: 'Bandingan',
  },
  {
    id: '3303030002',
    districtId: '3303030',
    name: 'Lamuk',
  },
  {
    id: '3303030003',
    districtId: '3303030',
    name: 'Sokanegara',
  },
  {
    id: '3303030004',
    districtId: '3303030',
    name: 'Gumiwang',
  },
  {
    id: '3303030006',
    districtId: '3303030',
    name: 'Nangkasawit',
  },
  {
    id: '3303030007',
    districtId: '3303030',
    name: 'Pandansari',
  },
  {
    id: '3303030008',
    districtId: '3303030',
    name: 'Kejobong',
  },
  {
    id: '3303030009',
    districtId: '3303030',
    name: 'Langgar',
  },
  {
    id: '3303030010',
    districtId: '3303030',
    name: 'Timbang',
  },
  {
    id: '3303030011',
    districtId: '3303030',
    name: 'Nangkod',
  },
  {
    id: '3303030012',
    districtId: '3303030',
    name: 'Kedarpan',
  },
  {
    id: '3303030013',
    districtId: '3303030',
    name: 'Pangempon',
  },
  {
    id: '3303040001',
    districtId: '3303040',
    name: 'Pasunggingan',
  },
  {
    id: '3303040002',
    districtId: '3303040',
    name: 'Pengadegan',
  },
  {
    id: '3303040003',
    districtId: '3303040',
    name: 'Karangjoho',
  },
  {
    id: '3303040004',
    districtId: '3303040',
    name: 'Larangan',
  },
  {
    id: '3303040005',
    districtId: '3303040',
    name: 'Panunggalan',
  },
  {
    id: '3303040006',
    districtId: '3303040',
    name: 'Bedagas',
  },
  {
    id: '3303040007',
    districtId: '3303040',
    name: 'Tumanggal',
  },
  {
    id: '3303040008',
    districtId: '3303040',
    name: 'Tegalpingen',
  },
  {
    id: '3303050001',
    districtId: '3303050',
    name: 'Lamongan',
  },
  {
    id: '3303050002',
    districtId: '3303050',
    name: 'Tejasari',
  },
  {
    id: '3303050003',
    districtId: '3303050',
    name: 'Cilapar',
  },
  {
    id: '3303050004',
    districtId: '3303050',
    name: 'Penolih',
  },
  {
    id: '3303050005',
    districtId: '3303050',
    name: 'Sinduraja',
  },
  {
    id: '3303050006',
    districtId: '3303050',
    name: 'Selakambang',
  },
  {
    id: '3303050007',
    districtId: '3303050',
    name: 'Selanegara',
  },
  {
    id: '3303050008',
    districtId: '3303050',
    name: 'Kaligondang',
  },
  {
    id: '3303050010',
    districtId: '3303050',
    name: 'Sempor Lor',
  },
  {
    id: '3303050011',
    districtId: '3303050',
    name: 'Penaruban',
  },
  {
    id: '3303050012',
    districtId: '3303050',
    name: 'Kalikajar',
  },
  {
    id: '3303050013',
    districtId: '3303050',
    name: 'Kembaran Wetan',
  },
  {
    id: '3303050014',
    districtId: '3303050',
    name: 'Slinga',
  },
  {
    id: '3303050015',
    districtId: '3303050',
    name: 'Arenan',
  },
  {
    id: '3303050016',
    districtId: '3303050',
    name: 'Sidanegara',
  },
  {
    id: '3303050017',
    districtId: '3303050',
    name: 'Pagerandong',
  },
  {
    id: '3303050018',
    districtId: '3303050',
    name: 'Sidareja',
  },
  {
    id: '3303060001',
    districtId: '3303060',
    name: 'Bojong',
  },
  {
    id: '3303060002',
    districtId: '3303060',
    name: 'Toyareja',
  },
  {
    id: '3303060003',
    districtId: '3303060',
    name: 'Kedung Menjangan',
  },
  {
    id: '3303060004',
    districtId: '3303060',
    name: 'Jatisaba',
  },
  {
    id: '3303060005',
    districtId: '3303060',
    name: 'Bancar',
  },
  {
    id: '3303060006',
    districtId: '3303060',
    name: 'Purbalingga Wetan',
  },
  {
    id: '3303060007',
    districtId: '3303060',
    name: 'Penambongan',
  },
  {
    id: '3303060008',
    districtId: '3303060',
    name: 'Purbalingga Kidul',
  },
  {
    id: '3303060009',
    districtId: '3303060',
    name: 'Kandang Gampang',
  },
  {
    id: '3303060010',
    districtId: '3303060',
    name: 'Purbalingga Kulon',
  },
  {
    id: '3303060011',
    districtId: '3303060',
    name: 'Purbalingga Lor',
  },
  {
    id: '3303060012',
    districtId: '3303060',
    name: 'Kembaran Kulon',
  },
  {
    id: '3303060013',
    districtId: '3303060',
    name: 'Wirasana',
  },
  {
    id: '3303070001',
    districtId: '3303070',
    name: 'Jompo',
  },
  {
    id: '3303070002',
    districtId: '3303070',
    name: 'Rabak',
  },
  {
    id: '3303070003',
    districtId: '3303070',
    name: 'Blater',
  },
  {
    id: '3303070004',
    districtId: '3303070',
    name: 'Sidakangen',
  },
  {
    id: '3303070005',
    districtId: '3303070',
    name: 'Karangpetir',
  },
  {
    id: '3303070006',
    districtId: '3303070',
    name: 'Grecol',
  },
  {
    id: '3303070008',
    districtId: '3303070',
    name: 'Karangmanyar',
  },
  {
    id: '3303070009',
    districtId: '3303070',
    name: 'Kalikabong',
  },
  {
    id: '3303070010',
    districtId: '3303070',
    name: 'Selabaya',
  },
  {
    id: '3303070011',
    districtId: '3303070',
    name: 'Kalimanah Wetan',
  },
  {
    id: '3303070012',
    districtId: '3303070',
    name: 'Kalimanah Kulon',
  },
  {
    id: '3303070013',
    districtId: '3303070',
    name: 'Manduraga',
  },
  {
    id: '3303070014',
    districtId: '3303070',
    name: 'Karangsari',
  },
  {
    id: '3303070016',
    districtId: '3303070',
    name: 'Klapasawit',
  },
  {
    id: '3303070017',
    districtId: '3303070',
    name: 'Babakan',
  },
  {
    id: '3303080001',
    districtId: '3303080',
    name: 'Karangpule',
  },
  {
    id: '3303080002',
    districtId: '3303080',
    name: 'Kalitinggar',
  },
  {
    id: '3303080003',
    districtId: '3303080',
    name: 'Sokawera',
  },
  {
    id: '3303080004',
    districtId: '3303080',
    name: 'Padamara',
  },
  {
    id: '3303080005',
    districtId: '3303080',
    name: 'Karangjambe',
  },
  {
    id: '3303080006',
    districtId: '3303080',
    name: 'Bojanegara',
  },
  {
    id: '3303080007',
    districtId: '3303080',
    name: 'Karangsentul',
  },
  {
    id: '3303080009',
    districtId: '3303080',
    name: 'Dawuhan',
  },
  {
    id: '3303080010',
    districtId: '3303080',
    name: 'Prigi',
  },
  {
    id: '3303080011',
    districtId: '3303080',
    name: 'Purbayasa',
  },
  {
    id: '3303080012',
    districtId: '3303080',
    name: 'Karanggambas',
  },
  {
    id: '3303080013',
    districtId: '3303080',
    name: 'Mipiran',
  },
  {
    id: '3303080014',
    districtId: '3303080',
    name: 'Kalitinggar Kidul',
  },
  {
    id: '3303090001',
    districtId: '3303090',
    name: 'Karanglewas',
  },
  {
    id: '3303090003',
    districtId: '3303090',
    name: 'Karangklesem',
  },
  {
    id: '3303090004',
    districtId: '3303090',
    name: 'Kutasari',
  },
  {
    id: '3303090005',
    districtId: '3303090',
    name: 'Sumingkir',
  },
  {
    id: '3303090006',
    districtId: '3303090',
    name: 'Meri',
  },
  {
    id: '3303090007',
    districtId: '3303090',
    name: 'Karangreja',
  },
  {
    id: '3303090008',
    districtId: '3303090',
    name: 'Karangaren',
  },
  {
    id: '3303090009',
    districtId: '3303090',
    name: 'Limbangan',
  },
  {
    id: '3303090010',
    districtId: '3303090',
    name: 'Cendana',
  },
  {
    id: '3303090011',
    districtId: '3303090',
    name: 'Candiwulan',
  },
  {
    id: '3303090012',
    districtId: '3303090',
    name: 'Karangcegak',
  },
  {
    id: '3303090013',
    districtId: '3303090',
    name: 'Candinata',
  },
  {
    id: '3303090014',
    districtId: '3303090',
    name: 'Karangjengkol',
  },
  {
    id: '3303100001',
    districtId: '3303100',
    name: 'Brobot',
  },
  {
    id: '3303100002',
    districtId: '3303100',
    name: 'Gembong',
  },
  {
    id: '3303100003',
    districtId: '3303100',
    name: 'Galuh',
  },
  {
    id: '3303100004',
    districtId: '3303100',
    name: 'Banjaran',
  },
  {
    id: '3303100005',
    districtId: '3303100',
    name: 'Patemon',
  },
  {
    id: '3303100006',
    districtId: '3303100',
    name: 'Bojongsari',
  },
  {
    id: '3303100007',
    districtId: '3303100',
    name: 'Kajongan',
  },
  {
    id: '3303100008',
    districtId: '3303100',
    name: 'Karangbanjar',
  },
  {
    id: '3303100009',
    districtId: '3303100',
    name: 'Beji',
  },
  {
    id: '3303100010',
    districtId: '3303100',
    name: 'Pagedangan',
  },
  {
    id: '3303100011',
    districtId: '3303100',
    name: 'Pekalongan',
  },
  {
    id: '3303100013',
    districtId: '3303100',
    name: 'Bumisari',
  },
  {
    id: '3303110001',
    districtId: '3303110',
    name: 'Karangturi',
  },
  {
    id: '3303110002',
    districtId: '3303110',
    name: 'Onje',
  },
  {
    id: '3303110003',
    districtId: '3303110',
    name: 'Sindang',
  },
  {
    id: '3303110004',
    districtId: '3303110',
    name: 'Tangkisan',
  },
  {
    id: '3303110005',
    districtId: '3303110',
    name: 'Kradenan',
  },
  {
    id: '3303110006',
    districtId: '3303110',
    name: 'Lambur',
  },
  {
    id: '3303110007',
    districtId: '3303110',
    name: 'Selaganggeng',
  },
  {
    id: '3303110008',
    districtId: '3303110',
    name: 'Mangunegara',
  },
  {
    id: '3303110009',
    districtId: '3303110',
    name: 'Karang Nangka',
  },
  {
    id: '3303110011',
    districtId: '3303110',
    name: 'Bojong',
  },
  {
    id: '3303110012',
    districtId: '3303110',
    name: 'Serayu Karanganyar',
  },
  {
    id: '3303110013',
    districtId: '3303110',
    name: 'Serayu Larangan',
  },
  {
    id: '3303110014',
    districtId: '3303110',
    name: 'Campakoah',
  },
  {
    id: '3303110015',
    districtId: '3303110',
    name: 'Pager Andong',
  },
  {
    id: '3303110016',
    districtId: '3303110',
    name: 'Cipaku',
  },
  {
    id: '3303110017',
    districtId: '3303110',
    name: 'Binangun',
  },
  {
    id: '3303110018',
    districtId: '3303110',
    name: 'Pengalusan',
  },
  {
    id: '3303110019',
    districtId: '3303110',
    name: 'Sangkanayu',
  },
  {
    id: '3303120001',
    districtId: '3303120',
    name: 'Gandasuli',
  },
  {
    id: '3303120002',
    districtId: '3303120',
    name: 'Kalapacung',
  },
  {
    id: '3303120003',
    districtId: '3303120',
    name: 'Karangmalang',
  },
  {
    id: '3303120004',
    districtId: '3303120',
    name: 'Banjarsari',
  },
  {
    id: '3303120005',
    districtId: '3303120',
    name: 'Majapura',
  },
  {
    id: '3303120006',
    districtId: '3303120',
    name: 'Bobotsari',
  },
  {
    id: '3303120007',
    districtId: '3303120',
    name: 'Karangduren',
  },
  {
    id: '3303120008',
    districtId: '3303120',
    name: 'Pakuncen',
  },
  {
    id: '3303120009',
    districtId: '3303120',
    name: 'Karangtalun',
  },
  {
    id: '3303120010',
    districtId: '3303120',
    name: 'Gunungkarang',
  },
  {
    id: '3303120011',
    districtId: '3303120',
    name: 'Talagening',
  },
  {
    id: '3303120012',
    districtId: '3303120',
    name: 'Tlagayasa',
  },
  {
    id: '3303120013',
    districtId: '3303120',
    name: 'Dagan',
  },
  {
    id: '3303120015',
    districtId: '3303120',
    name: 'Limbasari',
  },
  {
    id: '3303120016',
    districtId: '3303120',
    name: 'Palumbungan',
  },
  {
    id: '3303120017',
    districtId: '3303120',
    name: 'Palumbungan Wetan',
  },
  {
    id: '3303130001',
    districtId: '3303130',
    name: 'Serang',
  },
  {
    id: '3303130002',
    districtId: '3303130',
    name: 'Kutabawa',
  },
  {
    id: '3303130003',
    districtId: '3303130',
    name: 'Siwarak',
  },
  {
    id: '3303130004',
    districtId: '3303130',
    name: 'Tlahab Lor',
  },
  {
    id: '3303130005',
    districtId: '3303130',
    name: 'Tlahab Kidul',
  },
  {
    id: '3303130006',
    districtId: '3303130',
    name: 'Karangreja',
  },
  {
    id: '3303130007',
    districtId: '3303130',
    name: 'Gondang',
  },
  {
    id: '3303131001',
    districtId: '3303131',
    name: 'Sirandu',
  },
  {
    id: '3303131002',
    districtId: '3303131',
    name: 'Purbasari',
  },
  {
    id: '3303131003',
    districtId: '3303131',
    name: 'Karangjambu',
  },
  {
    id: '3303131004',
    districtId: '3303131',
    name: 'Sanguwatang',
  },
  {
    id: '3303131005',
    districtId: '3303131',
    name: 'Jingkang',
  },
  {
    id: '3303131006',
    districtId: '3303131',
    name: 'Danasari',
  },
  {
    id: '3303140001',
    districtId: '3303140',
    name: 'Kaliori',
  },
  {
    id: '3303140005',
    districtId: '3303140',
    name: 'Kalijaran',
  },
  {
    id: '3303140006',
    districtId: '3303140',
    name: 'Karanganyar',
  },
  {
    id: '3303140007',
    districtId: '3303140',
    name: 'Banjarkerta',
  },
  {
    id: '3303140008',
    districtId: '3303140',
    name: 'Karanggedang',
  },
  {
    id: '3303140009',
    districtId: '3303140',
    name: 'Kabunderan',
  },
  {
    id: '3303140010',
    districtId: '3303140',
    name: 'Jambudesa',
  },
  {
    id: '3303140016',
    districtId: '3303140',
    name: 'Maribaya',
  },
  {
    id: '3303140017',
    districtId: '3303140',
    name: 'Bungkanel',
  },
  {
    id: '3303140018',
    districtId: '3303140',
    name: 'Lumpang',
  },
  {
    id: '3303140019',
    districtId: '3303140',
    name: 'Buara',
  },
  {
    id: '3303140020',
    districtId: '3303140',
    name: 'Brakas',
  },
  {
    id: '3303140021',
    districtId: '3303140',
    name: 'Ponjen',
  },
  {
    id: '3303141001',
    districtId: '3303141',
    name: 'Mergasana',
  },
  {
    id: '3303141002',
    districtId: '3303141',
    name: 'Kertanegara',
  },
  {
    id: '3303141003',
    districtId: '3303141',
    name: 'Kasih',
  },
  {
    id: '3303141004',
    districtId: '3303141',
    name: 'Karang Tengah',
  },
  {
    id: '3303141005',
    districtId: '3303141',
    name: 'Condong',
  },
  {
    id: '3303141006',
    districtId: '3303141',
    name: 'Karangpucung',
  },
  {
    id: '3303141007',
    districtId: '3303141',
    name: 'Karangasem',
  },
  {
    id: '3303141008',
    districtId: '3303141',
    name: 'Adiarsa',
  },
  {
    id: '3303141009',
    districtId: '3303141',
    name: 'Langkap',
  },
  {
    id: '3303141010',
    districtId: '3303141',
    name: 'Darma',
  },
  {
    id: '3303141011',
    districtId: '3303141',
    name: 'Krangean',
  },
  {
    id: '3303150001',
    districtId: '3303150',
    name: 'Karangsari',
  },
  {
    id: '3303150002',
    districtId: '3303150',
    name: 'Pepedan',
  },
  {
    id: '3303150003',
    districtId: '3303150',
    name: 'Pekiringan',
  },
  {
    id: '3303150004',
    districtId: '3303150',
    name: 'Grantung',
  },
  {
    id: '3303150005',
    districtId: '3303150',
    name: 'Rajawana',
  },
  {
    id: '3303150006',
    districtId: '3303150',
    name: 'Tajug',
  },
  {
    id: '3303150007',
    districtId: '3303150',
    name: 'Tamansari',
  },
  {
    id: '3303150008',
    districtId: '3303150',
    name: 'Baleraksa',
  },
  {
    id: '3303150009',
    districtId: '3303150',
    name: 'Tunjungmuli',
  },
  {
    id: '3303150010',
    districtId: '3303150',
    name: 'Kramat',
  },
  {
    id: '3303150011',
    districtId: '3303150',
    name: 'Sirau',
  },
  {
    id: '3303160001',
    districtId: '3303160',
    name: 'Wlahar',
  },
  {
    id: '3303160002',
    districtId: '3303160',
    name: 'Bantarbarang',
  },
  {
    id: '3303160003',
    districtId: '3303160',
    name: 'Karangbawang',
  },
  {
    id: '3303160005',
    districtId: '3303160',
    name: 'Losari',
  },
  {
    id: '3303160006',
    districtId: '3303160',
    name: 'Bodas Karangjati',
  },
  {
    id: '3303160007',
    districtId: '3303160',
    name: 'Wanogara Wetan',
  },
  {
    id: '3303160008',
    districtId: '3303160',
    name: 'Wanogara Kulon',
  },
  {
    id: '3303160009',
    districtId: '3303160',
    name: 'Makam',
  },
  {
    id: '3303160010',
    districtId: '3303160',
    name: 'Sumampir',
  },
  {
    id: '3303160011',
    districtId: '3303160',
    name: 'Tanalum',
  },
  {
    id: '3303160012',
    districtId: '3303160',
    name: 'Panusupan',
  },
  {
    id: '3304010001',
    districtId: '3304010',
    name: 'Piasa Wetan',
  },
  {
    id: '3304010002',
    districtId: '3304010',
    name: 'Pekikiran',
  },
  {
    id: '3304010003',
    districtId: '3304010',
    name: 'Brengkok',
  },
  {
    id: '3304010004',
    districtId: '3304010',
    name: 'Panarusan Kulon',
  },
  {
    id: '3304010005',
    districtId: '3304010',
    name: 'Panarusan Wetan',
  },
  {
    id: '3304010006',
    districtId: '3304010',
    name: 'Gumelem Kulon',
  },
  {
    id: '3304010007',
    districtId: '3304010',
    name: 'Gumelem Wetan',
  },
  {
    id: '3304010008',
    districtId: '3304010',
    name: 'Derik',
  },
  {
    id: '3304010009',
    districtId: '3304010',
    name: 'Berta',
  },
  {
    id: '3304010010',
    districtId: '3304010',
    name: 'Karangjati',
  },
  {
    id: '3304010011',
    districtId: '3304010',
    name: 'Kedawung',
  },
  {
    id: '3304010012',
    districtId: '3304010',
    name: 'Dermasari',
  },
  {
    id: '3304010013',
    districtId: '3304010',
    name: 'Susukan',
  },
  {
    id: '3304010014',
    districtId: '3304010',
    name: 'Kemranggon',
  },
  {
    id: '3304010015',
    districtId: '3304010',
    name: 'Karangsalam',
  },
  {
    id: '3304020001',
    districtId: '3304020',
    name: 'Purwareja',
  },
  {
    id: '3304020002',
    districtId: '3304020',
    name: 'Kecitran',
  },
  {
    id: '3304020003',
    districtId: '3304020',
    name: 'Sirkandi',
  },
  {
    id: '3304020004',
    districtId: '3304020',
    name: 'Pagak',
  },
  {
    id: '3304020005',
    districtId: '3304020',
    name: 'Kalilandak',
  },
  {
    id: '3304020006',
    districtId: '3304020',
    name: 'Klampok',
  },
  {
    id: '3304020007',
    districtId: '3304020',
    name: 'Kalimandi',
  },
  {
    id: '3304020008',
    districtId: '3304020',
    name: 'Kaliwinasuh',
  },
  {
    id: '3304030001',
    districtId: '3304030',
    name: 'Salamerta',
  },
  {
    id: '3304030002',
    districtId: '3304030',
    name: 'Glempang',
  },
  {
    id: '3304030003',
    districtId: '3304030',
    name: 'Kebanaran',
  },
  {
    id: '3304030004',
    districtId: '3304030',
    name: 'Kaliwungu',
  },
  {
    id: '3304030005',
    districtId: '3304030',
    name: 'Somawangi',
  },
  {
    id: '3304030006',
    districtId: '3304030',
    name: 'Jalatunda',
  },
  {
    id: '3304030007',
    districtId: '3304030',
    name: 'Kebakalan',
  },
  {
    id: '3304030008',
    districtId: '3304030',
    name: 'Mandiraja Wetan',
  },
  {
    id: '3304030009',
    districtId: '3304030',
    name: 'Mandiraja Kulon',
  },
  {
    id: '3304030010',
    districtId: '3304030',
    name: 'Banjengan',
  },
  {
    id: '3304030011',
    districtId: '3304030',
    name: 'Kertayasa',
  },
  {
    id: '3304030012',
    districtId: '3304030',
    name: 'Candiwulan',
  },
  {
    id: '3304030013',
    districtId: '3304030',
    name: 'Simbang',
  },
  {
    id: '3304030014',
    districtId: '3304030',
    name: 'Purwasaba',
  },
  {
    id: '3304030015',
    districtId: '3304030',
    name: 'Blimbing',
  },
  {
    id: '3304030016',
    districtId: '3304030',
    name: 'Panggisari',
  },
  {
    id: '3304040001',
    districtId: '3304040',
    name: 'Kalitengah',
  },
  {
    id: '3304040002',
    districtId: '3304040',
    name: 'Petir',
  },
  {
    id: '3304040003',
    districtId: '3304040',
    name: 'Kaliajir',
  },
  {
    id: '3304040004',
    districtId: '3304040',
    name: 'Karanganyar',
  },
  {
    id: '3304040006',
    districtId: '3304040',
    name: 'Mertasari',
  },
  {
    id: '3304040007',
    districtId: '3304040',
    name: 'Parakan',
  },
  {
    id: '3304040009',
    districtId: '3304040',
    name: 'Kutawuluh',
  },
  {
    id: '3304040010',
    districtId: '3304040',
    name: 'Gumiwang',
  },
  {
    id: '3304040011',
    districtId: '3304040',
    name: 'Kalipelus',
  },
  {
    id: '3304040012',
    districtId: '3304040',
    name: 'Purwonegoro',
  },
  {
    id: '3304040013',
    districtId: '3304040',
    name: 'Danaraja',
  },
  {
    id: '3304050001',
    districtId: '3304050',
    name: 'Wanadri',
  },
  {
    id: '3304050002',
    districtId: '3304050',
    name: 'Kebondalem',
  },
  {
    id: '3304050005',
    districtId: '3304050',
    name: 'Majalengka',
  },
  {
    id: '3304050006',
    districtId: '3304050',
    name: 'Wiramastra',
  },
  {
    id: '3304050007',
    districtId: '3304050',
    name: 'Kutayasa',
  },
  {
    id: '3304050008',
    districtId: '3304050',
    name: 'Winong',
  },
  {
    id: '3304050009',
    districtId: '3304050',
    name: 'Depok',
  },
  {
    id: '3304050010',
    districtId: '3304050',
    name: 'Watuurip',
  },
  {
    id: '3304050012',
    districtId: '3304050',
    name: 'Masaran',
  },
  {
    id: '3304050013',
    districtId: '3304050',
    name: 'Serang',
  },
  {
    id: '3304050014',
    districtId: '3304050',
    name: 'Mantrianom',
  },
  {
    id: '3304050015',
    districtId: '3304050',
    name: 'Binorong',
  },
  {
    id: '3304050016',
    districtId: '3304050',
    name: 'Joho',
  },
  {
    id: '3304050017',
    districtId: '3304050',
    name: 'Bawang',
  },
  {
    id: '3304050018',
    districtId: '3304050',
    name: 'Bandingan',
  },
  {
    id: '3304050019',
    districtId: '3304050',
    name: 'Blambangan',
  },
  {
    id: '3304050021',
    districtId: '3304050',
    name: 'Pucang',
  },
  {
    id: '3304060007',
    districtId: '3304060',
    name: 'Argasoka',
  },
  {
    id: '3304060008',
    districtId: '3304060',
    name: 'Ampelsari',
  },
  {
    id: '3304060009',
    districtId: '3304060',
    name: 'Tlagawera',
  },
  {
    id: '3304060010',
    districtId: '3304060',
    name: 'Cendana',
  },
  {
    id: '3304060011',
    districtId: '3304060',
    name: 'Sokayasa',
  },
  {
    id: '3304060012',
    districtId: '3304060',
    name: 'Sokanandi',
  },
  {
    id: '3304060013',
    districtId: '3304060',
    name: 'Parakancanggah',
  },
  {
    id: '3304060014',
    districtId: '3304060',
    name: 'Semarang',
  },
  {
    id: '3304060015',
    districtId: '3304060',
    name: 'Krandegan',
  },
  {
    id: '3304060016',
    districtId: '3304060',
    name: 'Kutabanjarnegara',
  },
  {
    id: '3304060017',
    districtId: '3304060',
    name: 'Karangtengah',
  },
  {
    id: '3304060018',
    districtId: '3304060',
    name: 'Wangon',
  },
  {
    id: '3304060019',
    districtId: '3304060',
    name: 'Semampir',
  },
  {
    id: '3304061002',
    districtId: '3304061',
    name: 'Kebutuhjurang',
  },
  {
    id: '3304061004',
    districtId: '3304061',
    name: 'Pesangkalan',
  },
  {
    id: '3304061005',
    districtId: '3304061',
    name: 'Pagedongan',
  },
  {
    id: '3304061006',
    districtId: '3304061',
    name: 'Gunungjati',
  },
  {
    id: '3304061007',
    districtId: '3304061',
    name: 'Lebakwangi',
  },
  {
    id: '3304061008',
    districtId: '3304061',
    name: 'Gentansari',
  },
  {
    id: '3304061009',
    districtId: '3304061',
    name: 'Twelagiri',
  },
  {
    id: '3304070001',
    districtId: '3304070',
    name: 'Pringamba',
  },
  {
    id: '3304070002',
    districtId: '3304070',
    name: 'Sawal',
  },
  {
    id: '3304070003',
    districtId: '3304070',
    name: 'Panawaren',
  },
  {
    id: '3304070004',
    districtId: '3304070',
    name: 'Tunggara',
  },
  {
    id: '3304070005',
    districtId: '3304070',
    name: 'Randegan',
  },
  {
    id: '3304070006',
    districtId: '3304070',
    name: 'Bojanegara',
  },
  {
    id: '3304070007',
    districtId: '3304070',
    name: 'Bandingan',
  },
  {
    id: '3304070008',
    districtId: '3304070',
    name: 'Prigi',
  },
  {
    id: '3304070009',
    districtId: '3304070',
    name: 'Gembongan',
  },
  {
    id: '3304070010',
    districtId: '3304070',
    name: 'Kemiri',
  },
  {
    id: '3304070011',
    districtId: '3304070',
    name: 'Karangmangu',
  },
  {
    id: '3304070012',
    districtId: '3304070',
    name: 'Wanacipta',
  },
  {
    id: '3304070013',
    districtId: '3304070',
    name: 'Sigaluh',
  },
  {
    id: '3304070014',
    districtId: '3304070',
    name: 'Singamerta',
  },
  {
    id: '3304070015',
    districtId: '3304070',
    name: 'Kalibenda',
  },
  {
    id: '3304080001',
    districtId: '3304080',
    name: 'Rejasa',
  },
  {
    id: '3304080003',
    districtId: '3304080',
    name: 'Bantarwaru',
  },
  {
    id: '3304080004',
    districtId: '3304080',
    name: 'Dawuhan',
  },
  {
    id: '3304080005',
    districtId: '3304080',
    name: 'Pagelak',
  },
  {
    id: '3304080006',
    districtId: '3304080',
    name: 'Kutayasa',
  },
  {
    id: '3304080007',
    districtId: '3304080',
    name: 'Pekauman',
  },
  {
    id: '3304080008',
    districtId: '3304080',
    name: 'Talunamba',
  },
  {
    id: '3304080009',
    districtId: '3304080',
    name: 'Penawangan',
  },
  {
    id: '3304080010',
    districtId: '3304080',
    name: 'Limbangan',
  },
  {
    id: '3304080011',
    districtId: '3304080',
    name: 'Clapar',
  },
  {
    id: '3304080012',
    districtId: '3304080',
    name: 'Madukara',
  },
  {
    id: '3304080013',
    districtId: '3304080',
    name: 'Karanganyar',
  },
  {
    id: '3304080015',
    districtId: '3304080',
    name: 'Blitar',
  },
  {
    id: '3304080016',
    districtId: '3304080',
    name: 'Petambakan',
  },
  {
    id: '3304080017',
    districtId: '3304080',
    name: 'Rakitan',
  },
  {
    id: '3304080018',
    districtId: '3304080',
    name: 'Kaliurip',
  },
  {
    id: '3304080019',
    districtId: '3304080',
    name: 'Gununggiana',
  },
  {
    id: '3304080020',
    districtId: '3304080',
    name: 'Pakelen',
  },
  {
    id: '3304090001',
    districtId: '3304090',
    name: 'Jenggawur',
  },
  {
    id: '3304090002',
    districtId: '3304090',
    name: 'Banjarkulon',
  },
  {
    id: '3304090003',
    districtId: '3304090',
    name: 'Banjarmangu',
  },
  {
    id: '3304090004',
    districtId: '3304090',
    name: 'Rejasari',
  },
  {
    id: '3304090006',
    districtId: '3304090',
    name: 'Gripit',
  },
  {
    id: '3304090007',
    districtId: '3304090',
    name: 'Sigeblog',
  },
  {
    id: '3304090008',
    districtId: '3304090',
    name: 'Paseh',
  },
  {
    id: '3304090009',
    districtId: '3304090',
    name: 'Sipedang',
  },
  {
    id: '3304090010',
    districtId: '3304090',
    name: 'Pekandangan',
  },
  {
    id: '3304090011',
    districtId: '3304090',
    name: 'Kendaga',
  },
  {
    id: '3304090012',
    districtId: '3304090',
    name: 'Kalilunjar',
  },
  {
    id: '3304090013',
    districtId: '3304090',
    name: 'Sijeruk',
  },
  {
    id: '3304090014',
    districtId: '3304090',
    name: 'Prendengan',
  },
  {
    id: '3304090015',
    districtId: '3304090',
    name: 'Majatengah',
  },
  {
    id: '3304090016',
    districtId: '3304090',
    name: 'Beji',
  },
  {
    id: '3304090017',
    districtId: '3304090',
    name: 'Sijenggung',
  },
  {
    id: '3304100001',
    districtId: '3304100',
    name: 'Tapen',
  },
  {
    id: '3304100002',
    districtId: '3304100',
    name: 'Kasilib',
  },
  {
    id: '3304100003',
    districtId: '3304100',
    name: 'Karangjambe',
  },
  {
    id: '3304100004',
    districtId: '3304100',
    name: 'Wanadadi',
  },
  {
    id: '3304100005',
    districtId: '3304100',
    name: 'Wanakarsa',
  },
  {
    id: '3304100006',
    districtId: '3304100',
    name: 'Karangkemiri',
  },
  {
    id: '3304100007',
    districtId: '3304100',
    name: 'Gumingsir',
  },
  {
    id: '3304100008',
    districtId: '3304100',
    name: 'Linggasari',
  },
  {
    id: '3304100009',
    districtId: '3304100',
    name: 'Medayu',
  },
  {
    id: '3304100010',
    districtId: '3304100',
    name: 'Kandangwangi',
  },
  {
    id: '3304100011',
    districtId: '3304100',
    name: 'Lemahjaya',
  },
  {
    id: '3304110001',
    districtId: '3304110',
    name: 'Situwangi',
  },
  {
    id: '3304110002',
    districtId: '3304110',
    name: 'Gelang',
  },
  {
    id: '3304110003',
    districtId: '3304110',
    name: 'Rakit',
  },
  {
    id: '3304110004',
    districtId: '3304110',
    name: 'Adipasir',
  },
  {
    id: '3304110005',
    districtId: '3304110',
    name: 'Kincang',
  },
  {
    id: '3304110006',
    districtId: '3304110',
    name: 'Tanjunganom',
  },
  {
    id: '3304110008',
    districtId: '3304110',
    name: 'Lengkong',
  },
  {
    id: '3304110009',
    districtId: '3304110',
    name: 'Badamita',
  },
  {
    id: '3304110010',
    districtId: '3304110',
    name: 'Bandingan',
  },
  {
    id: '3304110011',
    districtId: '3304110',
    name: 'Pingit',
  },
  {
    id: '3304120001',
    districtId: '3304120',
    name: 'Sambong',
  },
  {
    id: '3304120002',
    districtId: '3304120',
    name: 'Tribuana',
  },
  {
    id: '3304120003',
    districtId: '3304120',
    name: 'Sawangan',
  },
  {
    id: '3304120004',
    districtId: '3304120',
    name: 'Sidarata',
  },
  {
    id: '3304120005',
    districtId: '3304120',
    name: 'Badakarya',
  },
  {
    id: '3304120006',
    districtId: '3304120',
    name: 'Bondolharjo',
  },
  {
    id: '3304120007',
    districtId: '3304120',
    name: 'Punggelan',
  },
  {
    id: '3304120008',
    districtId: '3304120',
    name: 'Karangsari',
  },
  {
    id: '3304120009',
    districtId: '3304120',
    name: 'Kecepit',
  },
  {
    id: '3304120010',
    districtId: '3304120',
    name: 'Danakerta',
  },
  {
    id: '3304120011',
    districtId: '3304120',
    name: 'Klapa',
  },
  {
    id: '3304120012',
    districtId: '3304120',
    name: 'Jembangan',
  },
  {
    id: '3304120013',
    districtId: '3304120',
    name: 'Purwasana',
  },
  {
    id: '3304120014',
    districtId: '3304120',
    name: 'Petuguran',
  },
  {
    id: '3304120015',
    districtId: '3304120',
    name: 'Tanjungtirta',
  },
  {
    id: '3304120016',
    districtId: '3304120',
    name: 'Mlaya',
  },
  {
    id: '3304120017',
    districtId: '3304120',
    name: 'Tlaga',
  },
  {
    id: '3304130001',
    districtId: '3304130',
    name: 'Slatri',
  },
  {
    id: '3304130002',
    districtId: '3304130',
    name: 'Paweden',
  },
  {
    id: '3304130003',
    districtId: '3304130',
    name: 'Gumelar',
  },
  {
    id: '3304130004',
    districtId: '3304130',
    name: 'Purwodadi',
  },
  {
    id: '3304130005',
    districtId: '3304130',
    name: 'Sampang',
  },
  {
    id: '3304130006',
    districtId: '3304130',
    name: 'Ambal',
  },
  {
    id: '3304130007',
    districtId: '3304130',
    name: 'Pagerpelah',
  },
  {
    id: '3304130008',
    districtId: '3304130',
    name: 'Pasuruhan',
  },
  {
    id: '3304130009',
    districtId: '3304130',
    name: 'Karanggondang',
  },
  {
    id: '3304130010',
    districtId: '3304130',
    name: 'Jlegong',
  },
  {
    id: '3304130011',
    districtId: '3304130',
    name: 'Binangun',
  },
  {
    id: '3304130012',
    districtId: '3304130',
    name: 'Karangkobar',
  },
  {
    id: '3304130013',
    districtId: '3304130',
    name: 'Leksana',
  },
  {
    id: '3304140001',
    districtId: '3304140',
    name: 'Nagasari',
  },
  {
    id: '3304140002',
    districtId: '3304140',
    name: 'Aribaya',
  },
  {
    id: '3304140003',
    districtId: '3304140',
    name: 'Larangan',
  },
  {
    id: '3304140004',
    districtId: '3304140',
    name: 'Karangnangka',
  },
  {
    id: '3304140005',
    districtId: '3304140',
    name: 'Sokaraja',
  },
  {
    id: '3304140006',
    districtId: '3304140',
    name: 'Metawana',
  },
  {
    id: '3304140007',
    districtId: '3304140',
    name: 'Gumingsir',
  },
  {
    id: '3304140008',
    districtId: '3304140',
    name: 'Kayuares',
  },
  {
    id: '3304140009',
    districtId: '3304140',
    name: 'Kalitlaga',
  },
  {
    id: '3304140010',
    districtId: '3304140',
    name: 'Plumbungan',
  },
  {
    id: '3304140011',
    districtId: '3304140',
    name: 'Karekan',
  },
  {
    id: '3304140012',
    districtId: '3304140',
    name: 'Kasmaran',
  },
  {
    id: '3304140013',
    districtId: '3304140',
    name: 'Pagentan',
  },
  {
    id: '3304140014',
    districtId: '3304140',
    name: 'Majasari',
  },
  {
    id: '3304140015',
    districtId: '3304140',
    name: 'Babadan',
  },
  {
    id: '3304140016',
    districtId: '3304140',
    name: 'Tegaljeruk',
  },
  {
    id: '3304150001',
    districtId: '3304150',
    name: 'Kalilunjar',
  },
  {
    id: '3304150002',
    districtId: '3304150',
    name: 'Biting',
  },
  {
    id: '3304150003',
    districtId: '3304150',
    name: 'Tlahab',
  },
  {
    id: '3304150004',
    districtId: '3304150',
    name: 'Dermayasa',
  },
  {
    id: '3304150005',
    districtId: '3304150',
    name: 'Pejawaran',
  },
  {
    id: '3304150006',
    districtId: '3304150',
    name: 'Pegundungan',
  },
  {
    id: '3304150007',
    districtId: '3304150',
    name: 'Beji',
  },
  {
    id: '3304150008',
    districtId: '3304150',
    name: 'Semangkung',
  },
  {
    id: '3304150009',
    districtId: '3304150',
    name: 'Condongcampur',
  },
  {
    id: '3304150010',
    districtId: '3304150',
    name: 'Gembol',
  },
  {
    id: '3304150011',
    districtId: '3304150',
    name: 'Sidengok',
  },
  {
    id: '3304150012',
    districtId: '3304150',
    name: 'Ratamba',
  },
  {
    id: '3304150013',
    districtId: '3304150',
    name: 'Penusupan',
  },
  {
    id: '3304150014',
    districtId: '3304150',
    name: 'Giritirta',
  },
  {
    id: '3304150015',
    districtId: '3304150',
    name: 'Karangsari',
  },
  {
    id: '3304150016',
    districtId: '3304150',
    name: 'Sarwodadi',
  },
  {
    id: '3304150017',
    districtId: '3304150',
    name: 'Grogol',
  },
  {
    id: '3304160001',
    districtId: '3304160',
    name: 'Batur',
  },
  {
    id: '3304160002',
    districtId: '3304160',
    name: 'Sumberejo',
  },
  {
    id: '3304160003',
    districtId: '3304160',
    name: 'Pesurenan',
  },
  {
    id: '3304160004',
    districtId: '3304160',
    name: 'Bakal',
  },
  {
    id: '3304160005',
    districtId: '3304160',
    name: 'Dieng Kulon',
  },
  {
    id: '3304160006',
    districtId: '3304160',
    name: 'Karangtengah',
  },
  {
    id: '3304160007',
    districtId: '3304160',
    name: 'Kepakisan',
  },
  {
    id: '3304160008',
    districtId: '3304160',
    name: 'Pekasiran',
  },
  {
    id: '3304170001',
    districtId: '3304170',
    name: 'Suwidak',
  },
  {
    id: '3304170002',
    districtId: '3304170',
    name: 'Karangtengah',
  },
  {
    id: '3304170003',
    districtId: '3304170',
    name: 'Bantar',
  },
  {
    id: '3304170004',
    districtId: '3304170',
    name: 'Pandansari',
  },
  {
    id: '3304170005',
    districtId: '3304170',
    name: 'Pagergunung',
  },
  {
    id: '3304170006',
    districtId: '3304170',
    name: 'Dawuhan',
  },
  {
    id: '3304170007',
    districtId: '3304170',
    name: 'Kubang',
  },
  {
    id: '3304170008',
    districtId: '3304170',
    name: 'Susukan',
  },
  {
    id: '3304170009',
    districtId: '3304170',
    name: 'Wanayasa',
  },
  {
    id: '3304170010',
    districtId: '3304170',
    name: 'Pesantren',
  },
  {
    id: '3304170011',
    districtId: '3304170',
    name: 'Balun',
  },
  {
    id: '3304170012',
    districtId: '3304170',
    name: 'Tempuran',
  },
  {
    id: '3304170013',
    districtId: '3304170',
    name: 'Wanaraja',
  },
  {
    id: '3304170014',
    districtId: '3304170',
    name: 'Jatilawang',
  },
  {
    id: '3304170015',
    districtId: '3304170',
    name: 'Legoksayem',
  },
  {
    id: '3304170016',
    districtId: '3304170',
    name: 'Kasimpar',
  },
  {
    id: '3304170017',
    districtId: '3304170',
    name: 'Penanggungan',
  },
  {
    id: '3304180004',
    districtId: '3304180',
    name: 'Asinan',
  },
  {
    id: '3304180005',
    districtId: '3304180',
    name: 'Sembawa',
  },
  {
    id: '3304180006',
    districtId: '3304180',
    name: 'Kalibombong',
  },
  {
    id: '3304180007',
    districtId: '3304180',
    name: 'Kalisat Kidul',
  },
  {
    id: '3304180008',
    districtId: '3304180',
    name: 'Sirukem',
  },
  {
    id: '3304180009',
    districtId: '3304180',
    name: 'Kertosari',
  },
  {
    id: '3304180010',
    districtId: '3304180',
    name: 'Sidakangen',
  },
  {
    id: '3304180011',
    districtId: '3304180',
    name: 'Majatengah',
  },
  {
    id: '3304180012',
    districtId: '3304180',
    name: 'Kalibening',
  },
  {
    id: '3304180018',
    districtId: '3304180',
    name: 'Sikumpul',
  },
  {
    id: '3304180019',
    districtId: '3304180',
    name: 'Gununglangit',
  },
  {
    id: '3304180020',
    districtId: '3304180',
    name: 'Bedana',
  },
  {
    id: '3304180021',
    districtId: '3304180',
    name: 'Sirukun',
  },
  {
    id: '3304180022',
    districtId: '3304180',
    name: 'Karanganyar',
  },
  {
    id: '3304180023',
    districtId: '3304180',
    name: 'Plorengan',
  },
  {
    id: '3304180024',
    districtId: '3304180',
    name: 'Kasinoman',
  },
  {
    id: '3304181001',
    districtId: '3304181',
    name: 'Sinduaji',
  },
  {
    id: '3304181002',
    districtId: '3304181',
    name: 'Pandanarum',
  },
  {
    id: '3304181003',
    districtId: '3304181',
    name: 'Beji',
  },
  {
    id: '3304181004',
    districtId: '3304181',
    name: 'Pringamba',
  },
  {
    id: '3304181005',
    districtId: '3304181',
    name: 'Pasegeran',
  },
  {
    id: '3304181006',
    districtId: '3304181',
    name: 'Pingit Lor',
  },
  {
    id: '3304181007',
    districtId: '3304181',
    name: 'Lawen',
  },
  {
    id: '3304181008',
    districtId: '3304181',
    name: 'Sirongge',
  },
  {
    id: '3305010001',
    districtId: '3305010',
    name: 'Argopeni',
  },
  {
    id: '3305010002',
    districtId: '3305010',
    name: 'Karangduwur',
  },
  {
    id: '3305010003',
    districtId: '3305010',
    name: 'Srati',
  },
  {
    id: '3305010004',
    districtId: '3305010',
    name: 'Pasir',
  },
  {
    id: '3305010005',
    districtId: '3305010',
    name: 'Jintung',
  },
  {
    id: '3305010006',
    districtId: '3305010',
    name: 'Banjararjo',
  },
  {
    id: '3305010007',
    districtId: '3305010',
    name: 'Argosari',
  },
  {
    id: '3305010008',
    districtId: '3305010',
    name: 'Watukelir',
  },
  {
    id: '3305010009',
    districtId: '3305010',
    name: 'Kalibangkang',
  },
  {
    id: '3305010010',
    districtId: '3305010',
    name: 'Tlogosari',
  },
  {
    id: '3305010011',
    districtId: '3305010',
    name: 'Kalipoh',
  },
  {
    id: '3305010012',
    districtId: '3305010',
    name: 'Ayah',
  },
  {
    id: '3305010013',
    districtId: '3305010',
    name: 'Candirenggo',
  },
  {
    id: '3305010014',
    districtId: '3305010',
    name: 'Mangunweni',
  },
  {
    id: '3305010015',
    districtId: '3305010',
    name: 'Jatijajar',
  },
  {
    id: '3305010016',
    districtId: '3305010',
    name: 'Demangsari',
  },
  {
    id: '3305010017',
    districtId: '3305010',
    name: 'Bulurejo',
  },
  {
    id: '3305020001',
    districtId: '3305020',
    name: 'Karangbolong',
  },
  {
    id: '3305020002',
    districtId: '3305020',
    name: 'Jladri',
  },
  {
    id: '3305020003',
    districtId: '3305020',
    name: 'Adiwarno',
  },
  {
    id: '3305020004',
    districtId: '3305020',
    name: 'Rangkah',
  },
  {
    id: '3305020005',
    districtId: '3305020',
    name: 'Wonodadi',
  },
  {
    id: '3305020007',
    districtId: '3305020',
    name: 'Rogodadi',
  },
  {
    id: '3305020008',
    districtId: '3305020',
    name: 'Pakuran',
  },
  {
    id: '3305020009',
    districtId: '3305020',
    name: 'Buayan',
  },
  {
    id: '3305020010',
    districtId: '3305020',
    name: 'Sikayu',
  },
  {
    id: '3305020011',
    districtId: '3305020',
    name: 'Karangsari',
  },
  {
    id: '3305020012',
    districtId: '3305020',
    name: 'Rogodono',
  },
  {
    id: '3305020013',
    districtId: '3305020',
    name: 'Banyumudal',
  },
  {
    id: '3305020015',
    districtId: '3305020',
    name: 'Nogoraji',
  },
  {
    id: '3305020016',
    districtId: '3305020',
    name: 'Mergosono',
  },
  {
    id: '3305020017',
    districtId: '3305020',
    name: 'Semampir',
  },
  {
    id: '3305020018',
    districtId: '3305020',
    name: 'Jogomulyo',
  },
  {
    id: '3305020019',
    districtId: '3305020',
    name: 'Purbowangi',
  },
  {
    id: '3305020020',
    districtId: '3305020',
    name: 'Jatiroto',
  },
  {
    id: '3305030001',
    districtId: '3305030',
    name: 'Tambakmulyo',
  },
  {
    id: '3305030002',
    districtId: '3305030',
    name: 'Surorejan',
  },
  {
    id: '3305030003',
    districtId: '3305030',
    name: 'Waluyorejo',
  },
  {
    id: '3305030004',
    districtId: '3305030',
    name: 'Sidoharjo',
  },
  {
    id: '3305030005',
    districtId: '3305030',
    name: 'Puliharjo',
  },
  {
    id: '3305030006',
    districtId: '3305030',
    name: 'Purwosari',
  },
  {
    id: '3305030007',
    districtId: '3305030',
    name: 'Arjowinangun',
  },
  {
    id: '3305030008',
    districtId: '3305030',
    name: 'Krandegan',
  },
  {
    id: '3305030009',
    districtId: '3305030',
    name: 'Kaleng',
  },
  {
    id: '3305030010',
    districtId: '3305030',
    name: 'Tukinggedong',
  },
  {
    id: '3305030011',
    districtId: '3305030',
    name: 'Purwoharjo',
  },
  {
    id: '3305030012',
    districtId: '3305030',
    name: 'Banjareja',
  },
  {
    id: '3305030013',
    districtId: '3305030',
    name: 'Wetonkulon',
  },
  {
    id: '3305030014',
    districtId: '3305030',
    name: 'Pesuruhan',
  },
  {
    id: '3305030015',
    districtId: '3305030',
    name: 'Wetonwetan',
  },
  {
    id: '3305030016',
    districtId: '3305030',
    name: 'Kedalemankulon',
  },
  {
    id: '3305030017',
    districtId: '3305030',
    name: 'Kedalemanwetan',
  },
  {
    id: '3305030018',
    districtId: '3305030',
    name: 'Srusuhjurutengah',
  },
  {
    id: '3305030019',
    districtId: '3305030',
    name: 'Sitiadi',
  },
  {
    id: '3305030020',
    districtId: '3305030',
    name: 'Bumirejo',
  },
  {
    id: '3305030021',
    districtId: '3305030',
    name: 'Madurejo',
  },
  {
    id: '3305030022',
    districtId: '3305030',
    name: 'Sidobunder',
  },
  {
    id: '3305030023',
    districtId: '3305030',
    name: 'Sidodadi',
  },
  {
    id: '3305040001',
    districtId: '3305040',
    name: 'Karangrejo',
  },
  {
    id: '3305040002',
    districtId: '3305040',
    name: 'Karanggadung',
  },
  {
    id: '3305040003',
    districtId: '3305040',
    name: 'Tegalretno',
  },
  {
    id: '3305040004',
    districtId: '3305040',
    name: 'Ampelsari',
  },
  {
    id: '3305040006',
    districtId: '3305040',
    name: 'Kewangunan',
  },
  {
    id: '3305040007',
    districtId: '3305040',
    name: 'Karangduwur',
  },
  {
    id: '3305040008',
    districtId: '3305040',
    name: 'Petanahan',
  },
  {
    id: '3305040009',
    districtId: '3305040',
    name: 'Kebonsari',
  },
  {
    id: '3305040010',
    districtId: '3305040',
    name: 'Grogolpenatus',
  },
  {
    id: '3305040011',
    districtId: '3305040',
    name: 'Grogolbeningsari',
  },
  {
    id: '3305040012',
    districtId: '3305040',
    name: 'Jogomertan',
  },
  {
    id: '3305040013',
    districtId: '3305040',
    name: 'Tanjungsari',
  },
  {
    id: '3305040014',
    districtId: '3305040',
    name: 'Sidomulyo',
  },
  {
    id: '3305040015',
    districtId: '3305040',
    name: 'Grujugan',
  },
  {
    id: '3305040016',
    districtId: '3305040',
    name: 'Kritig',
  },
  {
    id: '3305040017',
    districtId: '3305040',
    name: 'Nampudadi',
  },
  {
    id: '3305040018',
    districtId: '3305040',
    name: 'Tresnorejo',
  },
  {
    id: '3305040019',
    districtId: '3305040',
    name: 'Podourip',
  },
  {
    id: '3305040020',
    districtId: '3305040',
    name: 'Jatimulyo',
  },
  {
    id: '3305040021',
    districtId: '3305040',
    name: 'Banjarwinangun',
  },
  {
    id: '3305050001',
    districtId: '3305050',
    name: 'Jogosimo',
  },
  {
    id: '3305050002',
    districtId: '3305050',
    name: 'Tanggulangin',
  },
  {
    id: '3305050003',
    districtId: '3305050',
    name: 'Pandanlor',
  },
  {
    id: '3305050004',
    districtId: '3305050',
    name: 'Tambakprogaten',
  },
  {
    id: '3305050005',
    districtId: '3305050',
    name: 'Gebangsari',
  },
  {
    id: '3305050006',
    districtId: '3305050',
    name: 'Klegenrejo',
  },
  {
    id: '3305050007',
    districtId: '3305050',
    name: 'Bendogarap',
  },
  {
    id: '3305050008',
    districtId: '3305050',
    name: 'Kedungsari',
  },
  {
    id: '3305050009',
    districtId: '3305050',
    name: 'Jerukagung',
  },
  {
    id: '3305050010',
    districtId: '3305050',
    name: 'Klegenwonosari',
  },
  {
    id: '3305050011',
    districtId: '3305050',
    name: 'Klirong',
  },
  {
    id: '3305050012',
    districtId: '3305050',
    name: 'Kaliwungu',
  },
  {
    id: '3305050013',
    districtId: '3305050',
    name: 'Jatimalang',
  },
  {
    id: '3305050014',
    districtId: '3305050',
    name: 'Karangglonggong',
  },
  {
    id: '3305050015',
    districtId: '3305050',
    name: 'Ranterejo',
  },
  {
    id: '3305050016',
    districtId: '3305050',
    name: 'Wotbuwono',
  },
  {
    id: '3305050017',
    districtId: '3305050',
    name: 'Tambakagung',
  },
  {
    id: '3305050018',
    districtId: '3305050',
    name: 'Sitirejo',
  },
  {
    id: '3305050019',
    districtId: '3305050',
    name: 'Gadungrejo',
  },
  {
    id: '3305050020',
    districtId: '3305050',
    name: 'Dorowati',
  },
  {
    id: '3305050021',
    districtId: '3305050',
    name: 'Bumiharjo',
  },
  {
    id: '3305050022',
    districtId: '3305050',
    name: 'Kebadongan',
  },
  {
    id: '3305050023',
    districtId: '3305050',
    name: 'Podoluhur',
  },
  {
    id: '3305050024',
    districtId: '3305050',
    name: 'Kedungwinangun',
  },
  {
    id: '3305060001',
    districtId: '3305060',
    name: 'Ayamputih',
  },
  {
    id: '3305060002',
    districtId: '3305060',
    name: 'Setrojenar',
  },
  {
    id: '3305060003',
    districtId: '3305060',
    name: 'Brecong',
  },
  {
    id: '3305060004',
    districtId: '3305060',
    name: 'Banjurpasar',
  },
  {
    id: '3305060005',
    districtId: '3305060',
    name: 'Indrosari',
  },
  {
    id: '3305060006',
    districtId: '3305060',
    name: 'Buluspesantren',
  },
  {
    id: '3305060007',
    districtId: '3305060',
    name: 'Banjurmukadan',
  },
  {
    id: '3305060008',
    districtId: '3305060',
    name: 'Waluyo',
  },
  {
    id: '3305060009',
    districtId: '3305060',
    name: 'Bocor',
  },
  {
    id: '3305060010',
    districtId: '3305060',
    name: 'Maduretno',
  },
  {
    id: '3305060011',
    districtId: '3305060',
    name: 'Ambalkumolo',
  },
  {
    id: '3305060012',
    districtId: '3305060',
    name: 'Rantewringin',
  },
  {
    id: '3305060013',
    districtId: '3305060',
    name: 'Tambakrejo',
  },
  {
    id: '3305060014',
    districtId: '3305060',
    name: 'Sangubanyu',
  },
  {
    id: '3305060015',
    districtId: '3305060',
    name: 'Arjowinangun',
  },
  {
    id: '3305060016',
    districtId: '3305060',
    name: 'Ampih',
  },
  {
    id: '3305060017',
    districtId: '3305060',
    name: 'Jogopaten',
  },
  {
    id: '3305060018',
    districtId: '3305060',
    name: 'Kloposawit',
  },
  {
    id: '3305060019',
    districtId: '3305060',
    name: 'Sidomoro',
  },
  {
    id: '3305060020',
    districtId: '3305060',
    name: 'Tanjungrejo',
  },
  {
    id: '3305060021',
    districtId: '3305060',
    name: 'Tanjungsari',
  },
  {
    id: '3305070001',
    districtId: '3305070',
    name: 'Entak',
  },
  {
    id: '3305070002',
    districtId: '3305070',
    name: 'Plempukankembaran',
  },
  {
    id: '3305070003',
    districtId: '3305070',
    name: 'Kenoyojayan',
  },
  {
    id: '3305070004',
    districtId: '3305070',
    name: 'Ambalresmi',
  },
  {
    id: '3305070005',
    districtId: '3305070',
    name: 'Kaibonpetangkuran',
  },
  {
    id: '3305070006',
    districtId: '3305070',
    name: 'Kaibon',
  },
  {
    id: '3305070007',
    districtId: '3305070',
    name: 'Sumberjati',
  },
  {
    id: '3305070008',
    districtId: '3305070',
    name: 'Blengorwetan',
  },
  {
    id: '3305070009',
    districtId: '3305070',
    name: 'Blengorkulon',
  },
  {
    id: '3305070010',
    districtId: '3305070',
    name: 'Benerwetan',
  },
  {
    id: '3305070011',
    districtId: '3305070',
    name: 'Benerkulon',
  },
  {
    id: '3305070012',
    districtId: '3305070',
    name: 'Ambalkliwonan',
  },
  {
    id: '3305070013',
    districtId: '3305070',
    name: 'Pasarsenen',
  },
  {
    id: '3305070014',
    districtId: '3305070',
    name: 'Pucangan',
  },
  {
    id: '3305070015',
    districtId: '3305070',
    name: 'Ambalkebrek',
  },
  {
    id: '3305070016',
    districtId: '3305070',
    name: 'Gondanglegi',
  },
  {
    id: '3305070017',
    districtId: '3305070',
    name: 'Banjarsari',
  },
  {
    id: '3305070018',
    districtId: '3305070',
    name: 'Lajer',
  },
  {
    id: '3305070019',
    districtId: '3305070',
    name: 'Singosari',
  },
  {
    id: '3305070020',
    districtId: '3305070',
    name: 'Sidoluhur',
  },
  {
    id: '3305070021',
    districtId: '3305070',
    name: 'Sinungrejo',
  },
  {
    id: '3305070022',
    districtId: '3305070',
    name: 'Ambarwinangun',
  },
  {
    id: '3305070024',
    districtId: '3305070',
    name: 'Sidorejo',
  },
  {
    id: '3305070025',
    districtId: '3305070',
    name: 'Sidomulyo',
  },
  {
    id: '3305070026',
    districtId: '3305070',
    name: 'Sidomukti',
  },
  {
    id: '3305070027',
    districtId: '3305070',
    name: 'Prasutan',
  },
  {
    id: '3305070028',
    districtId: '3305070',
    name: 'Kradenan',
  },
  {
    id: '3305070029',
    districtId: '3305070',
    name: 'Pagedangan',
  },
  {
    id: '3305070030',
    districtId: '3305070',
    name: 'Surobayan',
  },
  {
    id: '3305070031',
    districtId: '3305070',
    name: 'Dukuhrejosari',
  },
  {
    id: '3305070032',
    districtId: '3305070',
    name: 'Kembangsawit',
  },
  {
    id: '3305080001',
    districtId: '3305080',
    name: 'Miritpetikusan',
  },
  {
    id: '3305080002',
    districtId: '3305080',
    name: 'Tlogodepok',
  },
  {
    id: '3305080003',
    districtId: '3305080',
    name: 'Mirit',
  },
  {
    id: '3305080004',
    districtId: '3305080',
    name: 'Tlogopragoto',
  },
  {
    id: '3305080005',
    districtId: '3305080',
    name: 'Lembupurwo',
  },
  {
    id: '3305080006',
    districtId: '3305080',
    name: 'Wiromartan',
  },
  {
    id: '3305080007',
    districtId: '3305080',
    name: 'Rowo',
  },
  {
    id: '3305080008',
    districtId: '3305080',
    name: 'Singoyudan',
  },
  {
    id: '3305080009',
    districtId: '3305080',
    name: 'Wergonayan',
  },
  {
    id: '3305080010',
    districtId: '3305080',
    name: 'Selotumpeng',
  },
  {
    id: '3305080011',
    districtId: '3305080',
    name: 'Sitibentar',
  },
  {
    id: '3305080012',
    districtId: '3305080',
    name: 'Karanggede',
  },
  {
    id: '3305080013',
    districtId: '3305080',
    name: 'Kertodeso',
  },
  {
    id: '3305080014',
    districtId: '3305080',
    name: 'Patukrejomulyo',
  },
  {
    id: '3305080015',
    districtId: '3305080',
    name: 'Patukgawemulyo',
  },
  {
    id: '3305080024',
    districtId: '3305080',
    name: 'Mangunranan',
  },
  {
    id: '3305080025',
    districtId: '3305080',
    name: 'Pekutan',
  },
  {
    id: '3305080026',
    districtId: '3305080',
    name: 'Wirogaten',
  },
  {
    id: '3305080027',
    districtId: '3305080',
    name: 'Winong',
  },
  {
    id: '3305080028',
    districtId: '3305080',
    name: 'Ngabean',
  },
  {
    id: '3305080032',
    districtId: '3305080',
    name: 'Sarwogadung',
  },
  {
    id: '3305080033',
    districtId: '3305080',
    name: 'Krubungan',
  },
  {
    id: '3305081001',
    districtId: '3305081',
    name: 'Patukrejo',
  },
  {
    id: '3305081002',
    districtId: '3305081',
    name: 'Ngasinan',
  },
  {
    id: '3305081003',
    districtId: '3305081',
    name: 'Pujodadi',
  },
  {
    id: '3305081004',
    districtId: '3305081',
    name: 'Balorejo',
  },
  {
    id: '3305081005',
    districtId: '3305081',
    name: 'Tlogorejo',
  },
  {
    id: '3305081006',
    districtId: '3305081',
    name: 'Rowosari',
  },
  {
    id: '3305081007',
    districtId: '3305081',
    name: 'Bonorowo',
  },
  {
    id: '3305081008',
    districtId: '3305081',
    name: 'Sirnoboyo',
  },
  {
    id: '3305081009',
    districtId: '3305081',
    name: 'Bonjokkidul',
  },
  {
    id: '3305081010',
    districtId: '3305081',
    name: 'Bonjoklor',
  },
  {
    id: '3305090001',
    districtId: '3305090',
    name: 'Tersobo',
  },
  {
    id: '3305090003',
    districtId: '3305090',
    name: 'Kabekelan',
  },
  {
    id: '3305090004',
    districtId: '3305090',
    name: 'Tunggalroso',
  },
  {
    id: '3305090005',
    districtId: '3305090',
    name: 'Kedungwaru',
  },
  {
    id: '3305090006',
    districtId: '3305090',
    name: 'Bagung',
  },
  {
    id: '3305090007',
    districtId: '3305090',
    name: 'Sidogede',
  },
  {
    id: '3305090008',
    districtId: '3305090',
    name: 'Sembirkadipaten',
  },
  {
    id: '3305090010',
    districtId: '3305090',
    name: 'Mulyosri',
  },
  {
    id: '3305090011',
    districtId: '3305090',
    name: 'Pesuningan',
  },
  {
    id: '3305090012',
    districtId: '3305090',
    name: 'Pecarikan',
  },
  {
    id: '3305090013',
    districtId: '3305090',
    name: 'Kabuaran',
  },
  {
    id: '3305091001',
    districtId: '3305091',
    name: 'Pejengkolan',
  },
  {
    id: '3305091002',
    districtId: '3305091',
    name: 'Balingasal',
  },
  {
    id: '3305091004',
    districtId: '3305091',
    name: 'Kalijering',
  },
  {
    id: '3305091005',
    districtId: '3305091',
    name: 'Kaligubuk',
  },
  {
    id: '3305091006',
    districtId: '3305091',
    name: 'Sidototo',
  },
  {
    id: '3305091007',
    districtId: '3305091',
    name: 'Rahayu',
  },
  {
    id: '3305091008',
    districtId: '3305091',
    name: 'Sendangdalem',
  },
  {
    id: '3305091009',
    districtId: '3305091',
    name: 'Padureso',
  },
  {
    id: '3305100002',
    districtId: '3305100',
    name: 'Tanjungmeru',
  },
  {
    id: '3305100003',
    districtId: '3305100',
    name: 'Kuwarisan',
  },
  {
    id: '3305100004',
    districtId: '3305100',
    name: 'Kutowinangun',
  },
  {
    id: '3305100005',
    districtId: '3305100',
    name: 'Lundong',
  },
  {
    id: '3305100006',
    districtId: '3305100',
    name: 'Mekarsari',
  },
  {
    id: '3305100007',
    districtId: '3305100',
    name: 'Babadsari',
  },
  {
    id: '3305100008',
    districtId: '3305100',
    name: 'Ungaran',
  },
  {
    id: '3305100009',
    districtId: '3305100',
    name: 'Mrinen',
  },
  {
    id: '3305100010',
    districtId: '3305100',
    name: 'Pejagatan',
  },
  {
    id: '3305100011',
    districtId: '3305100',
    name: 'Triwarno',
  },
  {
    id: '3305100012',
    districtId: '3305100',
    name: 'Korowelang',
  },
  {
    id: '3305100013',
    districtId: '3305100',
    name: 'Jlegiwinangun',
  },
  {
    id: '3305100015',
    districtId: '3305100',
    name: 'Tanjungsari',
  },
  {
    id: '3305100016',
    districtId: '3305100',
    name: 'Kaliputih',
  },
  {
    id: '3305100017',
    districtId: '3305100',
    name: 'Tunjungseto',
  },
  {
    id: '3305100018',
    districtId: '3305100',
    name: 'Pesalakan',
  },
  {
    id: '3305100019',
    districtId: '3305100',
    name: 'Karangsari',
  },
  {
    id: '3305110011',
    districtId: '3305110',
    name: 'Bojongsari',
  },
  {
    id: '3305110012',
    districtId: '3305110',
    name: 'Surotrunan',
  },
  {
    id: '3305110013',
    districtId: '3305110',
    name: 'Kambangsari',
  },
  {
    id: '3305110014',
    districtId: '3305110',
    name: 'Jatimulyo',
  },
  {
    id: '3305110015',
    districtId: '3305110',
    name: 'Tanuharjo',
  },
  {
    id: '3305110016',
    districtId: '3305110',
    name: 'Karangtanjung',
  },
  {
    id: '3305110017',
    districtId: '3305110',
    name: 'Kemangguhan',
  },
  {
    id: '3305110018',
    districtId: '3305110',
    name: 'Kalijaya',
  },
  {
    id: '3305110019',
    districtId: '3305110',
    name: 'Karangkembang',
  },
  {
    id: '3305110020',
    districtId: '3305110',
    name: 'Seliling',
  },
  {
    id: '3305110021',
    districtId: '3305110',
    name: 'Tlogowulung',
  },
  {
    id: '3305110023',
    districtId: '3305110',
    name: 'Kaliputih',
  },
  {
    id: '3305110024',
    districtId: '3305110',
    name: 'Wonokromo',
  },
  {
    id: '3305110025',
    districtId: '3305110',
    name: 'Sawangan',
  },
  {
    id: '3305110026',
    districtId: '3305110',
    name: 'Kalirancang',
  },
  {
    id: '3305110027',
    districtId: '3305110',
    name: 'Krakal',
  },
  {
    id: '3305111001',
    districtId: '3305111',
    name: 'Jatipurus',
  },
  {
    id: '3305111003',
    districtId: '3305111',
    name: 'Blater',
  },
  {
    id: '3305111004',
    districtId: '3305111',
    name: 'Poncowarno',
  },
  {
    id: '3305111005',
    districtId: '3305111',
    name: 'Tegalrejo',
  },
  {
    id: '3305111006',
    districtId: '3305111',
    name: 'Jembangan',
  },
  {
    id: '3305111007',
    districtId: '3305111',
    name: 'Kedungdowo',
  },
  {
    id: '3305111008',
    districtId: '3305111',
    name: 'Karangtengah',
  },
  {
    id: '3305111009',
    districtId: '3305111',
    name: 'Tirtomoyo',
  },
  {
    id: '3305111010',
    districtId: '3305111',
    name: 'Soka',
  },
  {
    id: '3305111011',
    districtId: '3305111',
    name: 'Kebapangan',
  },
  {
    id: '3305120001',
    districtId: '3305120',
    name: 'Muktisari',
  },
  {
    id: '3305120002',
    districtId: '3305120',
    name: 'Murtirejo',
  },
  {
    id: '3305120003',
    districtId: '3305120',
    name: 'Depokrejo',
  },
  {
    id: '3305120004',
    districtId: '3305120',
    name: 'Mengkowo',
  },
  {
    id: '3305120005',
    districtId: '3305120',
    name: 'Gesikan',
  },
  {
    id: '3305120006',
    districtId: '3305120',
    name: 'Kalibagor',
  },
  {
    id: '3305120007',
    districtId: '3305120',
    name: 'Argopeni',
  },
  {
    id: '3305120008',
    districtId: '3305120',
    name: 'Jatisari',
  },
  {
    id: '3305120009',
    districtId: '3305120',
    name: 'Kalirejo',
  },
  {
    id: '3305120010',
    districtId: '3305120',
    name: 'Selang',
  },
  {
    id: '3305120011',
    districtId: '3305120',
    name: 'Adikarso',
  },
  {
    id: '3305120012',
    districtId: '3305120',
    name: 'Tamanwinangun',
  },
  {
    id: '3305120013',
    districtId: '3305120',
    name: 'Panjer',
  },
  {
    id: '3305120014',
    districtId: '3305120',
    name: 'Kembaran',
  },
  {
    id: '3305120015',
    districtId: '3305120',
    name: 'Sumberadi',
  },
  {
    id: '3305120016',
    districtId: '3305120',
    name: 'Wonosari',
  },
  {
    id: '3305120017',
    districtId: '3305120',
    name: 'Roworejo',
  },
  {
    id: '3305120018',
    districtId: '3305120',
    name: 'Tanahsari',
  },
  {
    id: '3305120019',
    districtId: '3305120',
    name: 'Bandung',
  },
  {
    id: '3305120020',
    districtId: '3305120',
    name: 'Candimulyo',
  },
  {
    id: '3305120021',
    districtId: '3305120',
    name: 'Kalijirek',
  },
  {
    id: '3305120022',
    districtId: '3305120',
    name: 'Candiwulan',
  },
  {
    id: '3305120023',
    districtId: '3305120',
    name: 'Kawedusan',
  },
  {
    id: '3305120025',
    districtId: '3305120',
    name: 'Kutosari',
  },
  {
    id: '3305120026',
    districtId: '3305120',
    name: 'Bumirejo',
  },
  {
    id: '3305120027',
    districtId: '3305120',
    name: 'Gemeksekti',
  },
  {
    id: '3305120028',
    districtId: '3305120',
    name: 'Karangsari',
  },
  {
    id: '3305130001',
    districtId: '3305130',
    name: 'Logede',
  },
  {
    id: '3305130002',
    districtId: '3305130',
    name: 'Kuwayuhan',
  },
  {
    id: '3305130003',
    districtId: '3305130',
    name: 'Kedawung',
  },
  {
    id: '3305130004',
    districtId: '3305130',
    name: 'Pejagoan',
  },
  {
    id: '3305130005',
    districtId: '3305130',
    name: 'Kebulusan',
  },
  {
    id: '3305130006',
    districtId: '3305130',
    name: 'Aditirto',
  },
  {
    id: '3305130007',
    districtId: '3305130',
    name: 'Karangpoh',
  },
  {
    id: '3305130009',
    districtId: '3305130',
    name: 'Prigi',
  },
  {
    id: '3305130010',
    districtId: '3305130',
    name: 'Kebagoran',
  },
  {
    id: '3305130011',
    districtId: '3305130',
    name: 'Pengaringan',
  },
  {
    id: '3305130012',
    districtId: '3305130',
    name: 'Peniron',
  },
  {
    id: '3305130013',
    districtId: '3305130',
    name: 'Watulawang',
  },
  {
    id: '3305140001',
    districtId: '3305140',
    name: 'Menganti',
  },
  {
    id: '3305140002',
    districtId: '3305140',
    name: 'Trikarso',
  },
  {
    id: '3305140003',
    districtId: '3305140',
    name: 'Sidoharjo',
  },
  {
    id: '3305140004',
    districtId: '3305140',
    name: 'Giwangretno',
  },
  {
    id: '3305140005',
    districtId: '3305140',
    name: 'Jabres',
  },
  {
    id: '3305140007',
    districtId: '3305140',
    name: 'Karanggedang',
  },
  {
    id: '3305140008',
    districtId: '3305140',
    name: 'Purwodeso',
  },
  {
    id: '3305140009',
    districtId: '3305140',
    name: 'Klepusanggar',
  },
  {
    id: '3305140010',
    districtId: '3305140',
    name: 'Tanggeran',
  },
  {
    id: '3305140011',
    districtId: '3305140',
    name: 'Karangsari',
  },
  {
    id: '3305140012',
    districtId: '3305140',
    name: 'Karangpule',
  },
  {
    id: '3305140013',
    districtId: '3305140',
    name: 'Pakuran',
  },
  {
    id: '3305140014',
    districtId: '3305140',
    name: 'Pengempon',
  },
  {
    id: '3305140015',
    districtId: '3305140',
    name: 'Kejawang',
  },
  {
    id: '3305140016',
    districtId: '3305140',
    name: 'Karangjambu',
  },
  {
    id: '3305140017',
    districtId: '3305140',
    name: 'Sidoagung',
  },
  {
    id: '3305140018',
    districtId: '3305140',
    name: 'Penusupan',
  },
  {
    id: '3305140019',
    districtId: '3305140',
    name: 'Donosari',
  },
  {
    id: '3305140020',
    districtId: '3305140',
    name: 'Pandansari',
  },
  {
    id: '3305140021',
    districtId: '3305140',
    name: 'Condongcampur',
  },
  {
    id: '3305150001',
    districtId: '3305150',
    name: 'Sugihwaras',
  },
  {
    id: '3305150002',
    districtId: '3305150',
    name: 'Tambakharjo',
  },
  {
    id: '3305150003',
    districtId: '3305150',
    name: 'Tepakyang',
  },
  {
    id: '3305150004',
    districtId: '3305150',
    name: 'Sidamulyo',
  },
  {
    id: '3305150005',
    districtId: '3305150',
    name: 'Wajasari',
  },
  {
    id: '3305150006',
    districtId: '3305150',
    name: 'Candi Wulan',
  },
  {
    id: '3305150007',
    districtId: '3305150',
    name: 'Adikarto',
  },
  {
    id: '3305150008',
    districtId: '3305150',
    name: 'Adimulyo',
  },
  {
    id: '3305150009',
    districtId: '3305150',
    name: 'Temanggal',
  },
  {
    id: '3305150010',
    districtId: '3305150',
    name: 'Joho',
  },
  {
    id: '3305150011',
    districtId: '3305150',
    name: 'Adiluhur',
  },
  {
    id: '3305150012',
    districtId: '3305150',
    name: 'Tegalsari',
  },
  {
    id: '3305150013',
    districtId: '3305150',
    name: 'Sekarteja',
  },
  {
    id: '3305150014',
    districtId: '3305150',
    name: 'Kemujan',
  },
  {
    id: '3305150015',
    districtId: '3305150',
    name: 'Mangunharjo',
  },
  {
    id: '3305150016',
    districtId: '3305150',
    name: 'Banyuroto',
  },
  {
    id: '3305150018',
    districtId: '3305150',
    name: 'Caruban',
  },
  {
    id: '3305150019',
    districtId: '3305150',
    name: 'Bonjok',
  },
  {
    id: '3305150020',
    districtId: '3305150',
    name: 'Arjomulyo',
  },
  {
    id: '3305150021',
    districtId: '3305150',
    name: 'Arjosari',
  },
  {
    id: '3305150022',
    districtId: '3305150',
    name: 'Pekuwon',
  },
  {
    id: '3305150023',
    districtId: '3305150',
    name: 'Sidamukti',
  },
  {
    id: '3305160001',
    districtId: '3305160',
    name: 'Kamulyan',
  },
  {
    id: '3305160002',
    districtId: '3305160',
    name: 'Sidomukti',
  },
  {
    id: '3305160003',
    districtId: '3305160',
    name: 'Tambaksari',
  },
  {
    id: '3305160004',
    districtId: '3305160',
    name: 'Kalipurwo',
  },
  {
    id: '3305160005',
    districtId: '3305160',
    name: 'Purwodadi',
  },
  {
    id: '3305160006',
    districtId: '3305160',
    name: 'Pondokgebangsari',
  },
  {
    id: '3305160007',
    districtId: '3305160',
    name: 'Kuwarasan',
  },
  {
    id: '3305160008',
    districtId: '3305160',
    name: 'Harjodowo',
  },
  {
    id: '3305160009',
    districtId: '3305160',
    name: 'Lemahduwur',
  },
  {
    id: '3305160010',
    districtId: '3305160',
    name: 'Madureso',
  },
  {
    id: '3305160011',
    districtId: '3305160',
    name: 'Mangli',
  },
  {
    id: '3305160012',
    districtId: '3305160',
    name: 'Gandusari',
  },
  {
    id: '3305160013',
    districtId: '3305160',
    name: 'Ori',
  },
  {
    id: '3305160015',
    districtId: '3305160',
    name: 'Banjareja',
  },
  {
    id: '3305160016',
    districtId: '3305160',
    name: 'Gumawang',
  },
  {
    id: '3305160017',
    districtId: '3305160',
    name: 'Wonoyoso',
  },
  {
    id: '3305160018',
    districtId: '3305160',
    name: 'Gunungmujil',
  },
  {
    id: '3305160019',
    districtId: '3305160',
    name: 'Kuwaru',
  },
  {
    id: '3305160020',
    districtId: '3305160',
    name: 'Bendungan',
  },
  {
    id: '3305160021',
    districtId: '3305160',
    name: 'Jatimulya',
  },
  {
    id: '3305160022',
    districtId: '3305160',
    name: 'Sawangan',
  },
  {
    id: '3305170001',
    districtId: '3305170',
    name: 'Redisari',
  },
  {
    id: '3305170002',
    districtId: '3305170',
    name: 'Kalisari',
  },
  {
    id: '3305170003',
    districtId: '3305170',
    name: 'Pringtutul',
  },
  {
    id: '3305170004',
    districtId: '3305170',
    name: 'Rowokele',
  },
  {
    id: '3305170005',
    districtId: '3305170',
    name: 'Bumiagung',
  },
  {
    id: '3305170006',
    districtId: '3305170',
    name: 'Jatiluhur',
  },
  {
    id: '3305170008',
    districtId: '3305170',
    name: 'Sukomulyo',
  },
  {
    id: '3305170009',
    districtId: '3305170',
    name: 'Giyanti',
  },
  {
    id: '3305170010',
    districtId: '3305170',
    name: 'Wonoharjo',
  },
  {
    id: '3305170011',
    districtId: '3305170',
    name: 'Wagirpandan',
  },
  {
    id: '3305180001',
    districtId: '3305180',
    name: 'Sidoharum',
  },
  {
    id: '3305180002',
    districtId: '3305180',
    name: 'Selokerto',
  },
  {
    id: '3305180003',
    districtId: '3305180',
    name: 'Kalibeji',
  },
  {
    id: '3305180004',
    districtId: '3305180',
    name: 'Jatinegoro',
  },
  {
    id: '3305180005',
    districtId: '3305180',
    name: 'Bejiruyung',
  },
  {
    id: '3305180007',
    districtId: '3305180',
    name: 'Kedungjati',
  },
  {
    id: '3305180008',
    districtId: '3305180',
    name: 'Semali',
  },
  {
    id: '3305180009',
    districtId: '3305180',
    name: 'Bonosari',
  },
  {
    id: '3305180010',
    districtId: '3305180',
    name: 'Sempor',
  },
  {
    id: '3305180011',
    districtId: '3305180',
    name: 'Tunjungseto',
  },
  {
    id: '3305180012',
    districtId: '3305180',
    name: 'Sampang',
  },
  {
    id: '3305180013',
    districtId: '3305180',
    name: 'Donorojo',
  },
  {
    id: '3305180014',
    districtId: '3305180',
    name: 'Kedungwringin',
  },
  {
    id: '3305180016',
    districtId: '3305180',
    name: 'Somagede',
  },
  {
    id: '3305190001',
    districtId: '3305190',
    name: 'Kalitengah',
  },
  {
    id: '3305190003',
    districtId: '3305190',
    name: 'Banjarsari',
  },
  {
    id: '3305190004',
    districtId: '3305190',
    name: 'Panjangsari',
  },
  {
    id: '3305190005',
    districtId: '3305190',
    name: 'Patemon',
  },
  {
    id: '3305190006',
    districtId: '3305190',
    name: 'Kedungpuji',
  },
  {
    id: '3305190007',
    districtId: '3305190',
    name: 'Wero',
  },
  {
    id: '3305190008',
    districtId: '3305190',
    name: 'Gombong',
  },
  {
    id: '3305190009',
    districtId: '3305190',
    name: 'Wonokriyo',
  },
  {
    id: '3305190010',
    districtId: '3305190',
    name: 'Semondo',
  },
  {
    id: '3305190011',
    districtId: '3305190',
    name: 'Semanding',
  },
  {
    id: '3305190012',
    districtId: '3305190',
    name: 'Sidayu',
  },
  {
    id: '3305190013',
    districtId: '3305190',
    name: 'Wonosigro',
  },
  {
    id: '3305190014',
    districtId: '3305190',
    name: 'Klopogodo',
  },
  {
    id: '3305200001',
    districtId: '3305200',
    name: 'Sidomulyo',
  },
  {
    id: '3305200002',
    districtId: '3305200',
    name: 'Panjatan',
  },
  {
    id: '3305200003',
    districtId: '3305200',
    name: 'Karanganyar',
  },
  {
    id: '3305200004',
    districtId: '3305200',
    name: 'Jatiluhur',
  },
  {
    id: '3305200005',
    districtId: '3305200',
    name: 'Candi',
  },
  {
    id: '3305200006',
    districtId: '3305200',
    name: 'Giripurno',
  },
  {
    id: '3305200007',
    districtId: '3305200',
    name: 'Plarangan',
  },
  {
    id: '3305200008',
    districtId: '3305200',
    name: 'Karangkemiri',
  },
  {
    id: '3305200009',
    districtId: '3305200',
    name: 'Wonorejo',
  },
  {
    id: '3305200011',
    districtId: '3305200',
    name: 'Pohkumbang',
  },
  {
    id: '3305210001',
    districtId: '3305210',
    name: 'Karanggayam',
  },
  {
    id: '3305210002',
    districtId: '3305210',
    name: 'Kajoran',
  },
  {
    id: '3305210003',
    districtId: '3305210',
    name: 'Karangtengah',
  },
  {
    id: '3305210004',
    districtId: '3305210',
    name: 'Karangmojo',
  },
  {
    id: '3305210005',
    districtId: '3305210',
    name: 'Penimbun',
  },
  {
    id: '3305210006',
    districtId: '3305210',
    name: 'Kalirejo',
  },
  {
    id: '3305210007',
    districtId: '3305210',
    name: 'Pagebangan',
  },
  {
    id: '3305210008',
    districtId: '3305210',
    name: 'Clapar',
  },
  {
    id: '3305210009',
    districtId: '3305210',
    name: 'Logandu',
  },
  {
    id: '3305210010',
    districtId: '3305210',
    name: 'Kebakalan',
  },
  {
    id: '3305210011',
    districtId: '3305210',
    name: 'Karangrejo',
  },
  {
    id: '3305210012',
    districtId: '3305210',
    name: 'Wonotirto',
  },
  {
    id: '3305210013',
    districtId: '3305210',
    name: 'Kalibening',
  },
  {
    id: '3305210014',
    districtId: '3305210',
    name: 'Gunungsari',
  },
  {
    id: '3305210015',
    districtId: '3305210',
    name: 'Ginandong',
  },
  {
    id: '3305210016',
    districtId: '3305210',
    name: 'Binangun',
  },
  {
    id: '3305210017',
    districtId: '3305210',
    name: 'Glontor',
  },
  {
    id: '3305210018',
    districtId: '3305210',
    name: 'Selogiri',
  },
  {
    id: '3305210019',
    districtId: '3305210',
    name: 'Giritirto',
  },
  {
    id: '3305220015',
    districtId: '3305220',
    name: 'Pucangan',
  },
  {
    id: '3305220016',
    districtId: '3305220',
    name: 'Seboro',
  },
  {
    id: '3305220017',
    districtId: '3305220',
    name: 'Wonosari',
  },
  {
    id: '3305220018',
    districtId: '3305220',
    name: 'Sadangkulon',
  },
  {
    id: '3305220019',
    districtId: '3305220',
    name: 'Cangkring',
  },
  {
    id: '3305220020',
    districtId: '3305220',
    name: 'Sadangwetan',
  },
  {
    id: '3305220021',
    districtId: '3305220',
    name: 'Kedunggong',
  },
  {
    id: '3305221001',
    districtId: '3305221',
    name: 'Widoro',
  },
  {
    id: '3305221002',
    districtId: '3305221',
    name: 'Seling',
  },
  {
    id: '3305221003',
    districtId: '3305221',
    name: 'Kedungwaru',
  },
  {
    id: '3305221004',
    districtId: '3305221',
    name: 'Pencil',
  },
  {
    id: '3305221005',
    districtId: '3305221',
    name: 'Kaligending',
  },
  {
    id: '3305221006',
    districtId: '3305221',
    name: 'Plumbon',
  },
  {
    id: '3305221007',
    districtId: '3305221',
    name: 'Pujotirto',
  },
  {
    id: '3305221008',
    districtId: '3305221',
    name: 'Wadasmalang',
  },
  {
    id: '3305221009',
    districtId: '3305221',
    name: 'Tlepok',
  },
  {
    id: '3305221010',
    districtId: '3305221',
    name: 'Kalisana',
  },
  {
    id: '3305221011',
    districtId: '3305221',
    name: 'Langse',
  },
  {
    id: '3305221012',
    districtId: '3305221',
    name: 'Banioro',
  },
  {
    id: '3305221013',
    districtId: '3305221',
    name: 'Karangsambung',
  },
  {
    id: '3305221014',
    districtId: '3305221',
    name: 'Totogan',
  },
  {
    id: '3306010001',
    districtId: '3306010',
    name: 'Kertojayan',
  },
  {
    id: '3306010002',
    districtId: '3306010',
    name: 'Ukirsari',
  },
  {
    id: '3306010003',
    districtId: '3306010',
    name: 'Pasaranom',
  },
  {
    id: '3306010004',
    districtId: '3306010',
    name: 'Munggangsari',
  },
  {
    id: '3306010005',
    districtId: '3306010',
    name: 'Ketawangrejo',
  },
  {
    id: '3306010006',
    districtId: '3306010',
    name: 'Patutrejo',
  },
  {
    id: '3306010007',
    districtId: '3306010',
    name: 'Harjobinangun',
  },
  {
    id: '3306010008',
    districtId: '3306010',
    name: 'Roworejo',
  },
  {
    id: '3306010009',
    districtId: '3306010',
    name: 'Tunggulrejo',
  },
  {
    id: '3306010010',
    districtId: '3306010',
    name: 'Aglik',
  },
  {
    id: '3306010011',
    districtId: '3306010',
    name: 'Grabag',
  },
  {
    id: '3306010012',
    districtId: '3306010',
    name: 'Banyuyoso',
  },
  {
    id: '3306010013',
    districtId: '3306010',
    name: 'Wonoenggal',
  },
  {
    id: '3306010014',
    districtId: '3306010',
    name: 'Kalirejo',
  },
  {
    id: '3306010015',
    districtId: '3306010',
    name: 'Tegalrejo',
  },
  {
    id: '3306010016',
    districtId: '3306010',
    name: 'Rejosari',
  },
  {
    id: '3306010017',
    districtId: '3306010',
    name: 'Duduwetan',
  },
  {
    id: '3306010018',
    districtId: '3306010',
    name: 'Dudukulon',
  },
  {
    id: '3306010019',
    districtId: '3306010',
    name: 'Bakurejo',
  },
  {
    id: '3306010020',
    districtId: '3306010',
    name: 'Sumberagung',
  },
  {
    id: '3306010021',
    districtId: '3306010',
    name: 'Nambangan',
  },
  {
    id: '3306010022',
    districtId: '3306010',
    name: 'Bendungan',
  },
  {
    id: '3306010023',
    districtId: '3306010',
    name: 'Rowodadi',
  },
  {
    id: '3306010024',
    districtId: '3306010',
    name: 'Trimulyo',
  },
  {
    id: '3306010025',
    districtId: '3306010',
    name: 'Tulusrejo',
  },
  {
    id: '3306010026',
    districtId: '3306010',
    name: 'Kumpulrejo',
  },
  {
    id: '3306010027',
    districtId: '3306010',
    name: 'Tlepok Kulon',
  },
  {
    id: '3306010029',
    districtId: '3306010',
    name: 'Tlepok Wetan',
  },
  {
    id: '3306010031',
    districtId: '3306010',
    name: 'Sangubanyu',
  },
  {
    id: '3306010032',
    districtId: '3306010',
    name: 'Kedung Kamal',
  },
  {
    id: '3306020001',
    districtId: '3306020',
    name: 'Keburuhan',
  },
  {
    id: '3306020002',
    districtId: '3306020',
    name: 'Depokrejo',
  },
  {
    id: '3306020003',
    districtId: '3306020',
    name: 'Malang',
  },
  {
    id: '3306020004',
    districtId: '3306020',
    name: 'Pagak',
  },
  {
    id: '3306020005',
    districtId: '3306020',
    name: 'Wero',
  },
  {
    id: '3306020006',
    districtId: '3306020',
    name: 'Girirejo',
  },
  {
    id: '3306020007',
    districtId: '3306020',
    name: 'Ngentak',
  },
  {
    id: '3306020008',
    districtId: '3306020',
    name: 'Wonosari',
  },
  {
    id: '3306020009',
    districtId: '3306020',
    name: 'Pejagran',
  },
  {
    id: '3306020010',
    districtId: '3306020',
    name: 'Wonoroto',
  },
  {
    id: '3306020011',
    districtId: '3306020',
    name: 'Kesidan',
  },
  {
    id: '3306020012',
    districtId: '3306020',
    name: 'Kumpulsari',
  },
  {
    id: '3306020013',
    districtId: '3306020',
    name: 'Awuawu',
  },
  {
    id: '3306020014',
    districtId: '3306020',
    name: 'Kaliwungu Kidul',
  },
  {
    id: '3306020015',
    districtId: '3306020',
    name: 'Kaliwungu Lor',
  },
  {
    id: '3306020016',
    districtId: '3306020',
    name: 'Ringgit',
  },
  {
    id: '3306020017',
    districtId: '3306020',
    name: 'Tunjungan',
  },
  {
    id: '3306020018',
    districtId: '3306020',
    name: 'Wasiat',
  },
  {
    id: '3306020019',
    districtId: '3306020',
    name: 'Laban',
  },
  {
    id: '3306020020',
    districtId: '3306020',
    name: 'Rasukan',
  },
  {
    id: '3306020021',
    districtId: '3306020',
    name: 'Wonosri',
  },
  {
    id: '3306020023',
    districtId: '3306020',
    name: 'Tanjungrejo',
  },
  {
    id: '3306020024',
    districtId: '3306020',
    name: 'Kalitanjung',
  },
  {
    id: '3306020025',
    districtId: '3306020',
    name: 'Kuwukan',
  },
  {
    id: '3306020026',
    districtId: '3306020',
    name: 'Kedondong',
  },
  {
    id: '3306020027',
    districtId: '3306020',
    name: 'Candi',
  },
  {
    id: '3306020028',
    districtId: '3306020',
    name: 'Joso',
  },
  {
    id: '3306020029',
    districtId: '3306020',
    name: 'Ngombol',
  },
  {
    id: '3306020030',
    districtId: '3306020',
    name: 'Briyan',
  },
  {
    id: '3306020031',
    districtId: '3306020',
    name: 'Klandaran',
  },
  {
    id: '3306020033',
    districtId: '3306020',
    name: 'Karangtalun',
  },
  {
    id: '3306020034',
    districtId: '3306020',
    name: 'Bojong',
  },
  {
    id: '3306020035',
    districtId: '3306020',
    name: 'Cokroyasan',
  },
  {
    id: '3306020036',
    districtId: '3306020',
    name: 'Sumberejo',
  },
  {
    id: '3306020038',
    districtId: '3306020',
    name: 'Mendiro',
  },
  {
    id: '3306020039',
    districtId: '3306020',
    name: 'Jombang',
  },
  {
    id: '3306020040',
    districtId: '3306020',
    name: 'Kembangkuning',
  },
  {
    id: '3306020041',
    districtId: '3306020',
    name: 'Pulutan',
  },
  {
    id: '3306020042',
    districtId: '3306020',
    name: 'Walikoro',
  },
  {
    id: '3306020043',
    districtId: '3306020',
    name: 'Sruwoh',
  },
  {
    id: '3306020044',
    districtId: '3306020',
    name: 'Wonoboyo',
  },
  {
    id: '3306020045',
    districtId: '3306020',
    name: 'Singkil Wetan',
  },
  {
    id: '3306020046',
    districtId: '3306020',
    name: 'Tumenggungan',
  },
  {
    id: '3306020048',
    districtId: '3306020',
    name: 'Wingko Sanggrahan',
  },
  {
    id: '3306020049',
    districtId: '3306020',
    name: 'Singkil Kulon',
  },
  {
    id: '3306020050',
    districtId: '3306020',
    name: 'Wingkoharjo',
  },
  {
    id: '3306020051',
    districtId: '3306020',
    name: 'Wingko Sigromulyo',
  },
  {
    id: '3306020052',
    districtId: '3306020',
    name: 'Wingkomulyo',
  },
  {
    id: '3306020053',
    districtId: '3306020',
    name: 'Wingko Tinumpuk',
  },
  {
    id: '3306020054',
    districtId: '3306020',
    name: 'Piyono',
  },
  {
    id: '3306020055',
    districtId: '3306020',
    name: 'Tanjung',
  },
  {
    id: '3306020056',
    districtId: '3306020',
    name: 'Secang',
  },
  {
    id: '3306020057',
    districtId: '3306020',
    name: 'Seboro Pasar',
  },
  {
    id: '3306030001',
    districtId: '3306030',
    name: 'Jatimalang',
  },
  {
    id: '3306030002',
    districtId: '3306030',
    name: 'Jatikontal',
  },
  {
    id: '3306030003',
    districtId: '3306030',
    name: 'Gedangan',
  },
  {
    id: '3306030004',
    districtId: '3306030',
    name: 'Karanganyar',
  },
  {
    id: '3306030005',
    districtId: '3306030',
    name: 'Jogoboyo',
  },
  {
    id: '3306030006',
    districtId: '3306030',
    name: 'Watukuro',
  },
  {
    id: '3306030007',
    districtId: '3306030',
    name: 'Karangsari',
  },
  {
    id: '3306030008',
    districtId: '3306030',
    name: 'Banjarsari',
  },
  {
    id: '3306030009',
    districtId: '3306030',
    name: 'Kebonsari',
  },
  {
    id: '3306030010',
    districtId: '3306030',
    name: 'Sidoharjo',
  },
  {
    id: '3306030011',
    districtId: '3306030',
    name: 'Jogoresan',
  },
  {
    id: '3306030012',
    districtId: '3306030',
    name: 'Geparang',
  },
  {
    id: '3306030013',
    districtId: '3306030',
    name: 'Nampurejo',
  },
  {
    id: '3306030014',
    districtId: '3306030',
    name: 'Kentengrejo',
  },
  {
    id: '3306030015',
    districtId: '3306030',
    name: 'Nampu',
  },
  {
    id: '3306030016',
    districtId: '3306030',
    name: 'Gesing',
  },
  {
    id: '3306030017',
    districtId: '3306030',
    name: 'Keponggok',
  },
  {
    id: '3306030018',
    districtId: '3306030',
    name: 'Bubutan',
  },
  {
    id: '3306030019',
    districtId: '3306030',
    name: 'Tegalaren',
  },
  {
    id: '3306030020',
    districtId: '3306030',
    name: 'Sukomanah',
  },
  {
    id: '3306030022',
    districtId: '3306030',
    name: 'Guyangan',
  },
  {
    id: '3306030023',
    districtId: '3306030',
    name: 'Bongkot',
  },
  {
    id: '3306030024',
    districtId: '3306030',
    name: 'Purwodadi',
  },
  {
    id: '3306030025',
    districtId: '3306030',
    name: 'Sumbersari',
  },
  {
    id: '3306030026',
    districtId: '3306030',
    name: 'Purwosari',
  },
  {
    id: '3306030027',
    districtId: '3306030',
    name: 'Jenar Wetan',
  },
  {
    id: '3306030028',
    districtId: '3306030',
    name: 'Jenar Kidul',
  },
  {
    id: '3306030029',
    districtId: '3306030',
    name: 'Jenar Lor',
  },
  {
    id: '3306030030',
    districtId: '3306030',
    name: 'Pundensari',
  },
  {
    id: '3306030031',
    districtId: '3306030',
    name: 'Kesugihan',
  },
  {
    id: '3306030032',
    districtId: '3306030',
    name: 'Tlogorejo',
  },
  {
    id: '3306030033',
    districtId: '3306030',
    name: 'Plandi',
  },
  {
    id: '3306030034',
    districtId: '3306030',
    name: 'Bragolan',
  },
  {
    id: '3306030035',
    districtId: '3306030',
    name: 'Ketangi',
  },
  {
    id: '3306030036',
    districtId: '3306030',
    name: 'Karangmulyo',
  },
  {
    id: '3306030038',
    districtId: '3306030',
    name: 'Sumberejo',
  },
  {
    id: '3306030039',
    districtId: '3306030',
    name: 'Brondongrejo',
  },
  {
    id: '3306030040',
    districtId: '3306030',
    name: 'Sendangsari',
  },
  {
    id: '3306040001',
    districtId: '3306040',
    name: 'Dadirejo',
  },
  {
    id: '3306040002',
    districtId: '3306040',
    name: 'Bapangsari',
  },
  {
    id: '3306040003',
    districtId: '3306040',
    name: 'Tlogokotes',
  },
  {
    id: '3306040004',
    districtId: '3306040',
    name: 'Somorejo',
  },
  {
    id: '3306040005',
    districtId: '3306040',
    name: 'Krendetan',
  },
  {
    id: '3306040007',
    districtId: '3306040',
    name: 'Bagelen',
  },
  {
    id: '3306040008',
    districtId: '3306040',
    name: 'Kalirejo',
  },
  {
    id: '3306040009',
    districtId: '3306040',
    name: 'Hargorojo',
  },
  {
    id: '3306040010',
    districtId: '3306040',
    name: 'Durensari',
  },
  {
    id: '3306040011',
    districtId: '3306040',
    name: 'Sokoagung',
  },
  {
    id: '3306040012',
    districtId: '3306040',
    name: 'Semono',
  },
  {
    id: '3306040013',
    districtId: '3306040',
    name: 'Semagung',
  },
  {
    id: '3306040014',
    districtId: '3306040',
    name: 'Clapar',
  },
  {
    id: '3306040015',
    districtId: '3306040',
    name: 'Soko',
  },
  {
    id: '3306040016',
    districtId: '3306040',
    name: 'Piji',
  },
  {
    id: '3306040017',
    districtId: '3306040',
    name: 'Kemanukan',
  },
  {
    id: '3306050001',
    districtId: '3306050',
    name: 'Jatirejo',
  },
  {
    id: '3306050002',
    districtId: '3306050',
    name: 'Somongari',
  },
  {
    id: '3306050003',
    districtId: '3306050',
    name: 'Donorejo',
  },
  {
    id: '3306050004',
    districtId: '3306050',
    name: 'Hulosobo',
  },
  {
    id: '3306050005',
    districtId: '3306050',
    name: 'Kaliharjo',
  },
  {
    id: '3306050006',
    districtId: '3306050',
    name: 'Kaligono',
  },
  {
    id: '3306050007',
    districtId: '3306050',
    name: 'Tlogoguwo',
  },
  {
    id: '3306050008',
    districtId: '3306050',
    name: 'Pandanrejo',
  },
  {
    id: '3306050009',
    districtId: '3306050',
    name: 'Tawangsari',
  },
  {
    id: '3306050010',
    districtId: '3306050',
    name: 'Tlogobulu',
  },
  {
    id: '3306050011',
    districtId: '3306050',
    name: 'Purbowono',
  },
  {
    id: '3306050012',
    districtId: '3306050',
    name: 'Ngaran',
  },
  {
    id: '3306050013',
    districtId: '3306050',
    name: 'Kedunggubah',
  },
  {
    id: '3306050014',
    districtId: '3306050',
    name: 'Jelok',
  },
  {
    id: '3306050015',
    districtId: '3306050',
    name: 'Tlogo Rejo',
  },
  {
    id: '3306050016',
    districtId: '3306050',
    name: 'Gunungwangi',
  },
  {
    id: '3306050017',
    districtId: '3306050',
    name: 'Hardimulyo',
  },
  {
    id: '3306050018',
    districtId: '3306050',
    name: 'Sudorogo',
  },
  {
    id: '3306050019',
    districtId: '3306050',
    name: 'Somowono',
  },
  {
    id: '3306050020',
    districtId: '3306050',
    name: 'Ngadirejo',
  },
  {
    id: '3306050021',
    districtId: '3306050',
    name: 'Pucungroto',
  },
  {
    id: '3306060001',
    districtId: '3306060',
    name: 'Pangenrejo',
  },
  {
    id: '3306060002',
    districtId: '3306060',
    name: 'Kedung Sari',
  },
  {
    id: '3306060003',
    districtId: '3306060',
    name: 'Wonoroto',
  },
  {
    id: '3306060004',
    districtId: '3306060',
    name: 'Semawung',
  },
  {
    id: '3306060005',
    districtId: '3306060',
    name: 'Ganggeng',
  },
  {
    id: '3306060006',
    districtId: '3306060',
    name: 'Pacekelan',
  },
  {
    id: '3306060007',
    districtId: '3306060',
    name: 'Plipir',
  },
  {
    id: '3306060008',
    districtId: '3306060',
    name: 'Brenggong',
  },
  {
    id: '3306060009',
    districtId: '3306060',
    name: 'Cangkrep Kidul',
  },
  {
    id: '3306060010',
    districtId: '3306060',
    name: 'Cangkrep Lor',
  },
  {
    id: '3306060011',
    districtId: '3306060',
    name: 'Sidorejo',
  },
  {
    id: '3306060012',
    districtId: '3306060',
    name: 'Tambakrejo',
  },
  {
    id: '3306060013',
    districtId: '3306060',
    name: 'Purworejo',
  },
  {
    id: '3306060014',
    districtId: '3306060',
    name: 'Pangenjuru Tengah',
  },
  {
    id: '3306060015',
    districtId: '3306060',
    name: 'Doplang',
  },
  {
    id: '3306060016',
    districtId: '3306060',
    name: 'Sindurjan',
  },
  {
    id: '3306060017',
    districtId: '3306060',
    name: 'Paduroso',
  },
  {
    id: '3306060018',
    districtId: '3306060',
    name: 'Mranti',
  },
  {
    id: '3306060019',
    districtId: '3306060',
    name: 'Mudal',
  },
  {
    id: '3306060021',
    districtId: '3306060',
    name: 'Baledono',
  },
  {
    id: '3306060022',
    districtId: '3306060',
    name: 'Sido Mulyo',
  },
  {
    id: '3306060023',
    districtId: '3306060',
    name: 'Sudimoro',
  },
  {
    id: '3306060024',
    districtId: '3306060',
    name: 'Donorati',
  },
  {
    id: '3306060025',
    districtId: '3306060',
    name: 'Wonotulus',
  },
  {
    id: '3306070001',
    districtId: '3306070',
    name: 'Seborokrapyak',
  },
  {
    id: '3306070002',
    districtId: '3306070',
    name: 'Triwarno',
  },
  {
    id: '3306070003',
    districtId: '3306070',
    name: 'Bajangrejo',
  },
  {
    id: '3306070004',
    districtId: '3306070',
    name: 'Bencorejo',
  },
  {
    id: '3306070005',
    districtId: '3306070',
    name: 'Surorejo',
  },
  {
    id: '3306070006',
    districtId: '3306070',
    name: 'Wangunrejo',
  },
  {
    id: '3306070007',
    districtId: '3306070',
    name: 'Cengkawakrejo',
  },
  {
    id: '3306070008',
    districtId: '3306070',
    name: 'Popongan',
  },
  {
    id: '3306070009',
    districtId: '3306070',
    name: 'Boro Wetan',
  },
  {
    id: '3306070010',
    districtId: '3306070',
    name: 'Boro Kulon',
  },
  {
    id: '3306070011',
    districtId: '3306070',
    name: 'Tegalrejo',
  },
  {
    id: '3306070012',
    districtId: '3306070',
    name: 'Banyu Urip',
  },
  {
    id: '3306070013',
    districtId: '3306070',
    name: 'Malangrejo',
  },
  {
    id: '3306070014',
    districtId: '3306070',
    name: 'Tegalkuning',
  },
  {
    id: '3306070015',
    districtId: '3306070',
    name: 'Kliwonan',
  },
  {
    id: '3306070016',
    districtId: '3306070',
    name: 'Kertosono',
  },
  {
    id: '3306070017',
    districtId: '3306070',
    name: 'Tanjunganom',
  },
  {
    id: '3306070018',
    districtId: '3306070',
    name: 'Sawit',
  },
  {
    id: '3306070019',
    districtId: '3306070',
    name: 'Sumber Sari',
  },
  {
    id: '3306070020',
    districtId: '3306070',
    name: 'Pakisrejo',
  },
  {
    id: '3306070021',
    districtId: '3306070',
    name: 'Candingasinan',
  },
  {
    id: '3306070022',
    districtId: '3306070',
    name: 'Sokowaten',
  },
  {
    id: '3306070023',
    districtId: '3306070',
    name: 'Golok',
  },
  {
    id: '3306070024',
    districtId: '3306070',
    name: 'Candisari',
  },
  {
    id: '3306070025',
    districtId: '3306070',
    name: 'Condongsari',
  },
  {
    id: '3306070026',
    districtId: '3306070',
    name: 'Kledung Kradenan',
  },
  {
    id: '3306070027',
    districtId: '3306070',
    name: 'Kledung Karangdalem',
  },
  {
    id: '3306080001',
    districtId: '3306080',
    name: 'Jono',
  },
  {
    id: '3306080002',
    districtId: '3306080',
    name: 'Pogung Juru Tengah',
  },
  {
    id: '3306080003',
    districtId: '3306080',
    name: 'Pogungrejo',
  },
  {
    id: '3306080004',
    districtId: '3306080',
    name: 'Banjarejo',
  },
  {
    id: '3306080005',
    districtId: '3306080',
    name: 'Pogungkalangan',
  },
  {
    id: '3306080006',
    districtId: '3306080',
    name: 'Ketiwijayan',
  },
  {
    id: '3306080007',
    districtId: '3306080',
    name: 'Krandegan',
  },
  {
    id: '3306080008',
    districtId: '3306080',
    name: 'Tanjungrejo',
  },
  {
    id: '3306080009',
    districtId: '3306080',
    name: 'Tangkisan',
  },
  {
    id: '3306080010',
    districtId: '3306080',
    name: 'Jatingarang',
  },
  {
    id: '3306080011',
    districtId: '3306080',
    name: 'Bandung Kidul',
  },
  {
    id: '3306080012',
    districtId: '3306080',
    name: 'Bandungrejo',
  },
  {
    id: '3306080013',
    districtId: '3306080',
    name: 'Dewi',
  },
  {
    id: '3306080014',
    districtId: '3306080',
    name: 'Botorejo',
  },
  {
    id: '3306080015',
    districtId: '3306080',
    name: 'Dukuhrejo',
  },
  {
    id: '3306080016',
    districtId: '3306080',
    name: 'Boto Daleman',
  },
  {
    id: '3306080017',
    districtId: '3306080',
    name: 'Besole',
  },
  {
    id: '3306080018',
    districtId: '3306080',
    name: 'Bayan',
  },
  {
    id: '3306080019',
    districtId: '3306080',
    name: 'Grantung',
  },
  {
    id: '3306080020',
    districtId: '3306080',
    name: 'Kalimiru',
  },
  {
    id: '3306080021',
    districtId: '3306080',
    name: 'Bringin',
  },
  {
    id: '3306080022',
    districtId: '3306080',
    name: 'Pekutan',
  },
  {
    id: '3306080023',
    districtId: '3306080',
    name: 'Jrakah',
  },
  {
    id: '3306080024',
    districtId: '3306080',
    name: 'Sucenjuru Tengah',
  },
  {
    id: '3306080025',
    districtId: '3306080',
    name: 'Sambeng',
  },
  {
    id: '3306080026',
    districtId: '3306080',
    name: 'Pucang Agung',
  },
  {
    id: '3306090001',
    districtId: '3306090',
    name: 'Purwosari',
  },
  {
    id: '3306090002',
    districtId: '3306090',
    name: 'Karangwuluh',
  },
  {
    id: '3306090003',
    districtId: '3306090',
    name: 'Kebondalem',
  },
  {
    id: '3306090004',
    districtId: '3306090',
    name: 'Tuntungpahit',
  },
  {
    id: '3306090005',
    districtId: '3306090',
    name: 'Kiyangkongrejo',
  },
  {
    id: '3306090006',
    districtId: '3306090',
    name: 'Pringgowijayan',
  },
  {
    id: '3306090009',
    districtId: '3306090',
    name: 'Majir',
  },
  {
    id: '3306090010',
    districtId: '3306090',
    name: 'Semawung Daleman',
  },
  {
    id: '3306090011',
    districtId: '3306090',
    name: 'Semawung Kembaran',
  },
  {
    id: '3306090012',
    districtId: '3306090',
    name: 'Kuwurejo',
  },
  {
    id: '3306090013',
    districtId: '3306090',
    name: 'Sidarum',
  },
  {
    id: '3306090014',
    districtId: '3306090',
    name: 'Bayem',
  },
  {
    id: '3306090015',
    districtId: '3306090',
    name: 'Katerban',
  },
  {
    id: '3306090016',
    districtId: '3306090',
    name: 'Kutoarjo',
  },
  {
    id: '3306090017',
    districtId: '3306090',
    name: 'Bandung',
  },
  {
    id: '3306090018',
    districtId: '3306090',
    name: 'Sokoharjo',
  },
  {
    id: '3306090019',
    districtId: '3306090',
    name: 'Pacor',
  },
  {
    id: '3306090020',
    districtId: '3306090',
    name: 'Tunggorono',
  },
  {
    id: '3306090021',
    districtId: '3306090',
    name: 'Tepus Kulon',
  },
  {
    id: '3306090022',
    districtId: '3306090',
    name: 'Tepus Wetan',
  },
  {
    id: '3306090023',
    districtId: '3306090',
    name: 'Kemadu Lor',
  },
  {
    id: '3306090024',
    districtId: '3306090',
    name: 'Kaligesing',
  },
  {
    id: '3306090025',
    districtId: '3306090',
    name: 'Karangrejo',
  },
  {
    id: '3306090026',
    districtId: '3306090',
    name: 'Wirun',
  },
  {
    id: '3306090027',
    districtId: '3306090',
    name: 'Tursino',
  },
  {
    id: '3306100001',
    districtId: '3306100',
    name: 'Mangunjayan',
  },
  {
    id: '3306100002',
    districtId: '3306100',
    name: 'Kedungmulyo',
  },
  {
    id: '3306100003',
    districtId: '3306100',
    name: 'Sidomulyo',
  },
  {
    id: '3306100004',
    districtId: '3306100',
    name: 'Sumbersari',
  },
  {
    id: '3306100005',
    districtId: '3306100',
    name: 'Langenrejo',
  },
  {
    id: '3306100006',
    districtId: '3306100',
    name: 'Tamansari',
  },
  {
    id: '3306100007',
    districtId: '3306100',
    name: 'Wareng',
  },
  {
    id: '3306100009',
    districtId: '3306100',
    name: 'Rowodadi',
  },
  {
    id: '3306100010',
    districtId: '3306100',
    name: 'Kedungsari',
  },
  {
    id: '3306100011',
    districtId: '3306100',
    name: 'Tanjunganom',
  },
  {
    id: '3306100012',
    districtId: '3306100',
    name: 'Karanganom',
  },
  {
    id: '3306100013',
    districtId: '3306100',
    name: 'Wonodadi',
  },
  {
    id: '3306100014',
    districtId: '3306100',
    name: 'Sruwoh Dukuh',
  },
  {
    id: '3306100015',
    districtId: '3306100',
    name: 'Kedungsri',
  },
  {
    id: '3306100016',
    districtId: '3306100',
    name: 'Kedungagung',
  },
  {
    id: '3306100017',
    districtId: '3306100',
    name: 'Sruwohrejo',
  },
  {
    id: '3306100018',
    districtId: '3306100',
    name: 'Lugurejo',
  },
  {
    id: '3306100019',
    districtId: '3306100',
    name: 'Kunir',
  },
  {
    id: '3306100020',
    districtId: '3306100',
    name: 'Wonorejo Wetan',
  },
  {
    id: '3306100021',
    districtId: '3306100',
    name: 'Wonorejo Kulon',
  },
  {
    id: '3306100022',
    districtId: '3306100',
    name: 'Kunirejo Kulon',
  },
  {
    id: '3306100023',
    districtId: '3306100',
    name: 'Kunirejo Wetan',
  },
  {
    id: '3306100024',
    districtId: '3306100',
    name: 'Lubang Dukuh',
  },
  {
    id: '3306100025',
    districtId: '3306100',
    name: 'Tlogorejo',
  },
  {
    id: '3306100026',
    districtId: '3306100',
    name: 'Polomarto',
  },
  {
    id: '3306100027',
    districtId: '3306100',
    name: 'Wironatan',
  },
  {
    id: '3306100029',
    districtId: '3306100',
    name: 'Tegalgondo',
  },
  {
    id: '3306100030',
    districtId: '3306100',
    name: 'Lubang Indangan',
  },
  {
    id: '3306100031',
    districtId: '3306100',
    name: 'Lubang Lor',
  },
  {
    id: '3306100032',
    districtId: '3306100',
    name: 'Lubang Kidul',
  },
  {
    id: '3306100033',
    districtId: '3306100',
    name: 'Lubang Sampang',
  },
  {
    id: '3306100035',
    districtId: '3306100',
    name: 'Binangun',
  },
  {
    id: '3306100036',
    districtId: '3306100',
    name: 'Panggeldlanggu',
  },
  {
    id: '3306100037',
    districtId: '3306100',
    name: 'Dlangu',
  },
  {
    id: '3306100039',
    districtId: '3306100',
    name: 'Andong',
  },
  {
    id: '3306100040',
    districtId: '3306100',
    name: 'Kaliwatukranggan',
  },
  {
    id: '3306100041',
    districtId: '3306100',
    name: 'Kaliwatubumi',
  },
  {
    id: '3306110002',
    districtId: '3306110',
    name: 'Pangkalan',
  },
  {
    id: '3306110003',
    districtId: '3306110',
    name: 'Wonoyoso',
  },
  {
    id: '3306110004',
    districtId: '3306110',
    name: 'Tasikmadu',
  },
  {
    id: '3306110005',
    districtId: '3306110',
    name: 'Tapen',
  },
  {
    id: '3306110006',
    districtId: '3306110',
    name: 'Tersidi Kidul',
  },
  {
    id: '3306110007',
    districtId: '3306110',
    name: 'Tersidi Lor',
  },
  {
    id: '3306110008',
    districtId: '3306110',
    name: 'Sekartejo',
  },
  {
    id: '3306110010',
    districtId: '3306110',
    name: 'Kalimati',
  },
  {
    id: '3306110011',
    districtId: '3306110',
    name: 'Kendalrejo',
  },
  {
    id: '3306110012',
    districtId: '3306110',
    name: 'Ngampel',
  },
  {
    id: '3306110013',
    districtId: '3306110',
    name: 'Sikambang',
  },
  {
    id: '3306110014',
    districtId: '3306110',
    name: 'Tunjungtejo',
  },
  {
    id: '3306110015',
    districtId: '3306110',
    name: 'Dlisen Wetan',
  },
  {
    id: '3306110016',
    districtId: '3306110',
    name: 'Dlisen Kulon',
  },
  {
    id: '3306110017',
    districtId: '3306110',
    name: 'Blekatuk',
  },
  {
    id: '3306110018',
    districtId: '3306110',
    name: 'Waru',
  },
  {
    id: '3306110019',
    districtId: '3306110',
    name: 'Keburusan',
  },
  {
    id: '3306110020',
    districtId: '3306110',
    name: 'Semampir',
  },
  {
    id: '3306110021',
    districtId: '3306110',
    name: 'Gumawangrejo',
  },
  {
    id: '3306110022',
    districtId: '3306110',
    name: 'Petuguran',
  },
  {
    id: '3306110023',
    districtId: '3306110',
    name: 'Pekacangan',
  },
  {
    id: '3306110024',
    districtId: '3306110',
    name: 'Karanggetas',
  },
  {
    id: '3306110025',
    districtId: '3306110',
    name: 'Luweng Lor',
  },
  {
    id: '3306110026',
    districtId: '3306110',
    name: 'Luweng Kidul',
  },
  {
    id: '3306110027',
    districtId: '3306110',
    name: 'Sambeng',
  },
  {
    id: '3306110028',
    districtId: '3306110',
    name: 'Megulung Kidul',
  },
  {
    id: '3306110029',
    districtId: '3306110',
    name: 'Pituruh',
  },
  {
    id: '3306110030',
    districtId: '3306110',
    name: 'Prigelan',
  },
  {
    id: '3306110031',
    districtId: '3306110',
    name: 'Karanganyar',
  },
  {
    id: '3306110032',
    districtId: '3306110',
    name: 'Megulung Lor',
  },
  {
    id: '3306110033',
    districtId: '3306110',
    name: 'Prapag Kidul',
  },
  {
    id: '3306110034',
    districtId: '3306110',
    name: 'Kembangkuning',
  },
  {
    id: '3306110035',
    districtId: '3306110',
    name: 'Brengkol',
  },
  {
    id: '3306110036',
    districtId: '3306110',
    name: 'Girigondo',
  },
  {
    id: '3306110037',
    districtId: '3306110',
    name: 'Prapag Lor',
  },
  {
    id: '3306110038',
    districtId: '3306110',
    name: 'Kalikotes',
  },
  {
    id: '3306110039',
    districtId: '3306110',
    name: 'Ngandagan',
  },
  {
    id: '3306110040',
    districtId: '3306110',
    name: 'Kesawen',
  },
  {
    id: '3306110041',
    districtId: '3306110',
    name: 'Kedung Batur',
  },
  {
    id: '3306110042',
    districtId: '3306110',
    name: 'Polowangi',
  },
  {
    id: '3306110043',
    districtId: '3306110',
    name: 'Kalijering',
  },
  {
    id: '3306110044',
    districtId: '3306110',
    name: 'Somogede',
  },
  {
    id: '3306110045',
    districtId: '3306110',
    name: 'Kaligondang',
  },
  {
    id: '3306110046',
    districtId: '3306110',
    name: 'Kaligintung',
  },
  {
    id: '3306110047',
    districtId: '3306110',
    name: 'Sawangan',
  },
  {
    id: '3306110048',
    districtId: '3306110',
    name: 'Wonosido',
  },
  {
    id: '3306110049',
    districtId: '3306110',
    name: 'Pamriyan',
  },
  {
    id: '3306120001',
    districtId: '3306120',
    name: 'Kroyo Kulon',
  },
  {
    id: '3306120002',
    districtId: '3306120',
    name: 'Waled',
  },
  {
    id: '3306120003',
    districtId: '3306120',
    name: 'Paitan',
  },
  {
    id: '3306120004',
    districtId: '3306120',
    name: 'Gedong',
  },
  {
    id: '3306120005',
    districtId: '3306120',
    name: 'Rowobayem',
  },
  {
    id: '3306120006',
    districtId: '3306120',
    name: 'Kemiri Kidul',
  },
  {
    id: '3306120008',
    districtId: '3306120',
    name: 'Gesikan',
  },
  {
    id: '3306120009',
    districtId: '3306120',
    name: 'Rejosari',
  },
  {
    id: '3306120010',
    districtId: '3306120',
    name: 'Kroyo Lor',
  },
  {
    id: '3306120011',
    districtId: '3306120',
    name: 'Kemiri Lor',
  },
  {
    id: '3306120012',
    districtId: '3306120',
    name: 'Bedono Kluwung',
  },
  {
    id: '3306120013',
    districtId: '3306120',
    name: 'Bedono Pageron',
  },
  {
    id: '3306120014',
    districtId: '3306120',
    name: 'Karangduwur (Bedono)',
  },
  {
    id: '3306120016',
    districtId: '3306120',
    name: 'Loning',
  },
  {
    id: '3306120017',
    districtId: '3306120',
    name: 'Winong',
  },
  {
    id: '3306120018',
    districtId: '3306120',
    name: 'Sutoragan',
  },
  {
    id: '3306120019',
    districtId: '3306120',
    name: 'Jatiwangsan',
  },
  {
    id: '3306120021',
    districtId: '3306120',
    name: 'Kedunglo',
  },
  {
    id: '3306120022',
    districtId: '3306120',
    name: 'Sidodadi',
  },
  {
    id: '3306120023',
    districtId: '3306120',
    name: 'Kaliurip',
  },
  {
    id: '3306120024',
    districtId: '3306120',
    name: 'Kalimeneng',
  },
  {
    id: '3306120025',
    districtId: '3306120',
    name: 'Rejowinangun',
  },
  {
    id: '3306120026',
    districtId: '3306120',
    name: 'Samping',
  },
  {
    id: '3306120027',
    districtId: '3306120',
    name: 'Wonosari',
  },
  {
    id: '3306120028',
    districtId: '3306120',
    name: 'Kapiteran',
  },
  {
    id: '3306120029',
    districtId: '3306120',
    name: 'Wanurojo',
  },
  {
    id: '3306120030',
    districtId: '3306120',
    name: 'Sokogelap',
  },
  {
    id: '3306120031',
    districtId: '3306120',
    name: 'Kaliglagah',
  },
  {
    id: '3306120033',
    districtId: '3306120',
    name: 'Purbayan',
  },
  {
    id: '3306120034',
    districtId: '3306120',
    name: 'Kedung Pomahan Kulon',
  },
  {
    id: '3306120035',
    districtId: '3306120',
    name: 'Karangluas',
  },
  {
    id: '3306120036',
    districtId: '3306120',
    name: 'Kedung Pomahan Wetan',
  },
  {
    id: '3306120037',
    districtId: '3306120',
    name: 'Wonosuko',
  },
  {
    id: '3306120038',
    districtId: '3306120',
    name: 'Dilem',
  },
  {
    id: '3306120039',
    districtId: '3306120',
    name: 'Girijoyo',
  },
  {
    id: '3306120040',
    districtId: '3306120',
    name: 'Girimulyo',
  },
  {
    id: '3306130001',
    districtId: '3306130',
    name: 'Pakisarum',
  },
  {
    id: '3306130002',
    districtId: '3306130',
    name: 'Plipiran',
  },
  {
    id: '3306130003',
    districtId: '3306130',
    name: 'Puspo',
  },
  {
    id: '3306130004',
    districtId: '3306130',
    name: 'Somoleter',
  },
  {
    id: '3306130005',
    districtId: '3306130',
    name: 'Brunosari',
  },
  {
    id: '3306130006',
    districtId: '3306130',
    name: 'Brunorejo',
  },
  {
    id: '3306130007',
    districtId: '3306130',
    name: 'Cepedak',
  },
  {
    id: '3306130008',
    districtId: '3306130',
    name: 'Gunung Condong',
  },
  {
    id: '3306130009',
    districtId: '3306130',
    name: 'Kemranggen',
  },
  {
    id: '3306130010',
    districtId: '3306130',
    name: 'Karanggedang',
  },
  {
    id: '3306130011',
    districtId: '3306130',
    name: 'Giyombong',
  },
  {
    id: '3306130012',
    districtId: '3306130',
    name: 'Brondong',
  },
  {
    id: '3306130013',
    districtId: '3306130',
    name: 'Gowong',
  },
  {
    id: '3306130014',
    districtId: '3306130',
    name: 'Blimbing',
  },
  {
    id: '3306130015',
    districtId: '3306130',
    name: 'Tegalsari',
  },
  {
    id: '3306130016',
    districtId: '3306130',
    name: 'Kaliwungu',
  },
  {
    id: '3306130017',
    districtId: '3306130',
    name: 'Watuduwur',
  },
  {
    id: '3306130018',
    districtId: '3306130',
    name: 'Kambangan',
  },
  {
    id: '3306140001',
    districtId: '3306140',
    name: 'Winong Kidul',
  },
  {
    id: '3306140003',
    districtId: '3306140',
    name: 'Lugosobo',
  },
  {
    id: '3306140004',
    districtId: '3306140',
    name: 'Gintungan',
  },
  {
    id: '3306140007',
    districtId: '3306140',
    name: 'Kroyo',
  },
  {
    id: '3306140008',
    districtId: '3306140',
    name: 'Winong Lor',
  },
  {
    id: '3306140009',
    districtId: '3306140',
    name: 'Mlaran',
  },
  {
    id: '3306140010',
    districtId: '3306140',
    name: 'Pelutan',
  },
  {
    id: '3306140011',
    districtId: '3306140',
    name: 'Bendosari',
  },
  {
    id: '3306140012',
    districtId: '3306140',
    name: 'Gebang',
  },
  {
    id: '3306140013',
    districtId: '3306140',
    name: 'Pakem',
  },
  {
    id: '3306140014',
    districtId: '3306140',
    name: 'Salam',
  },
  {
    id: '3306140015',
    districtId: '3306140',
    name: 'Wonotopo',
  },
  {
    id: '3306140016',
    districtId: '3306140',
    name: 'Sidoleren',
  },
  {
    id: '3306140017',
    districtId: '3306140',
    name: 'Penungkulan',
  },
  {
    id: '3306140018',
    districtId: '3306140',
    name: 'Redin',
  },
  {
    id: '3306140019',
    districtId: '3306140',
    name: 'Tlogosono',
  },
  {
    id: '3306140020',
    districtId: '3306140',
    name: 'Ngemplak',
  },
  {
    id: '3306140021',
    districtId: '3306140',
    name: 'Kragilan',
  },
  {
    id: '3306140023',
    districtId: '3306140',
    name: 'Ngaglik',
  },
  {
    id: '3306140024',
    districtId: '3306140',
    name: 'Kalitengkek',
  },
  {
    id: '3306140025',
    districtId: '3306140',
    name: 'Kemiri',
  },
  {
    id: '3306150001',
    districtId: '3306150',
    name: 'Kalinongko',
  },
  {
    id: '3306150002',
    districtId: '3306150',
    name: 'Trirejo',
  },
  {
    id: '3306150003',
    districtId: '3306150',
    name: 'Karangrejo',
  },
  {
    id: '3306150004',
    districtId: '3306150',
    name: 'Kalikalong',
  },
  {
    id: '3306150005',
    districtId: '3306150',
    name: 'Rimun',
  },
  {
    id: '3306150006',
    districtId: '3306150',
    name: 'Tepansari',
  },
  {
    id: '3306150007',
    districtId: '3306150',
    name: 'Kali Glagah',
  },
  {
    id: '3306150008',
    districtId: '3306150',
    name: 'Tridadi',
  },
  {
    id: '3306150009',
    districtId: '3306150',
    name: 'Banyuasin Separe',
  },
  {
    id: '3306150010',
    districtId: '3306150',
    name: 'Guyangan',
  },
  {
    id: '3306150011',
    districtId: '3306150',
    name: 'Kalisemo',
  },
  {
    id: '3306150012',
    districtId: '3306150',
    name: 'Loano',
  },
  {
    id: '3306150013',
    districtId: '3306150',
    name: 'Jetis',
  },
  {
    id: '3306150014',
    districtId: '3306150',
    name: 'Maron',
  },
  {
    id: '3306150015',
    districtId: '3306150',
    name: 'Kedungpoh',
  },
  {
    id: '3306150016',
    districtId: '3306150',
    name: 'Kebongunung',
  },
  {
    id: '3306150017',
    districtId: '3306150',
    name: 'Mudalrejo',
  },
  {
    id: '3306150018',
    districtId: '3306150',
    name: 'Kemejing',
  },
  {
    id: '3306150019',
    districtId: '3306150',
    name: 'Banyuasin Kembaran',
  },
  {
    id: '3306150020',
    districtId: '3306150',
    name: 'Sedayu',
  },
  {
    id: '3306150021',
    districtId: '3306150',
    name: 'Ngargosari',
  },
  {
    id: '3306160001',
    districtId: '3306160',
    name: 'Kedung Pucang',
  },
  {
    id: '3306160002',
    districtId: '3306160',
    name: 'Kali Urip',
  },
  {
    id: '3306160003',
    districtId: '3306160',
    name: 'Kaliwader',
  },
  {
    id: '3306160004',
    districtId: '3306160',
    name: 'Kalitapas',
  },
  {
    id: '3306160005',
    districtId: '3306160',
    name: 'Benowo',
  },
  {
    id: '3306160006',
    districtId: '3306160',
    name: 'Cacaban Kidul',
  },
  {
    id: '3306160007',
    districtId: '3306160',
    name: 'Cacaban Lor',
  },
  {
    id: '3306160008',
    districtId: '3306160',
    name: 'Wadas',
  },
  {
    id: '3306160009',
    districtId: '3306160',
    name: 'Kedung Loteng',
  },
  {
    id: '3306160011',
    districtId: '3306160',
    name: 'Kaliboto',
  },
  {
    id: '3306160012',
    districtId: '3306160',
    name: 'Sendangsari',
  },
  {
    id: '3306160013',
    districtId: '3306160',
    name: 'Karang Sari',
  },
  {
    id: '3306160015',
    districtId: '3306160',
    name: 'Legetan',
  },
  {
    id: '3306160016',
    districtId: '3306160',
    name: 'Ketosari',
  },
  {
    id: '3306160017',
    districtId: '3306160',
    name: 'Kamijoro',
  },
  {
    id: '3306160019',
    districtId: '3306160',
    name: 'Pekacangan',
  },
  {
    id: '3306160020',
    districtId: '3306160',
    name: 'Medono',
  },
  {
    id: '3306160021',
    districtId: '3306160',
    name: 'Jati',
  },
  {
    id: '3306160022',
    districtId: '3306160',
    name: 'Mayung Sari',
  },
  {
    id: '3306160023',
    districtId: '3306160',
    name: 'Kalijambe',
  },
  {
    id: '3306160024',
    districtId: '3306160',
    name: 'Sukowuwuh',
  },
  {
    id: '3306160025',
    districtId: '3306160',
    name: 'Limbangan',
  },
  {
    id: '3306160026',
    districtId: '3306160',
    name: 'Nglaris',
  },
  {
    id: '3306160027',
    districtId: '3306160',
    name: 'Sidomukti',
  },
  {
    id: '3306160028',
    districtId: '3306160',
    name: 'Ngasinan',
  },
  {
    id: '3307010001',
    districtId: '3307010',
    name: 'Kaligowong',
  },
  {
    id: '3307010002',
    districtId: '3307010',
    name: 'Sumbersari',
  },
  {
    id: '3307010003',
    districtId: '3307010',
    name: 'Sumberejo',
  },
  {
    id: '3307010004',
    districtId: '3307010',
    name: 'Erorejo',
  },
  {
    id: '3307010005',
    districtId: '3307010',
    name: 'Karang Anyar',
  },
  {
    id: '3307010006',
    districtId: '3307010',
    name: 'Panerusan',
  },
  {
    id: '3307010007',
    districtId: '3307010',
    name: 'Wadaslintang',
  },
  {
    id: '3307010008',
    districtId: '3307010',
    name: 'Plunjaran',
  },
  {
    id: '3307010009',
    districtId: '3307010',
    name: 'Kumejing',
  },
  {
    id: '3307010010',
    districtId: '3307010',
    name: 'Lancar',
  },
  {
    id: '3307010011',
    districtId: '3307010',
    name: 'Somogede',
  },
  {
    id: '3307010012',
    districtId: '3307010',
    name: 'Trimulyo',
  },
  {
    id: '3307010013',
    districtId: '3307010',
    name: 'Tirip',
  },
  {
    id: '3307010014',
    districtId: '3307010',
    name: 'Besuki',
  },
  {
    id: '3307010015',
    districtId: '3307010',
    name: 'Gumelar',
  },
  {
    id: '3307010016',
    districtId: '3307010',
    name: 'Ngalian',
  },
  {
    id: '3307010017',
    districtId: '3307010',
    name: 'Kalidadap',
  },
  {
    id: '3307020001',
    districtId: '3307020',
    name: 'Gadingsukuh',
  },
  {
    id: '3307020002',
    districtId: '3307020',
    name: 'Burat',
  },
  {
    id: '3307020003',
    districtId: '3307020',
    name: 'Gadingrejo',
  },
  {
    id: '3307020005',
    districtId: '3307020',
    name: 'Teges Wetan',
  },
  {
    id: '3307020008',
    districtId: '3307020',
    name: 'Gondowulan',
  },
  {
    id: '3307020009',
    districtId: '3307020',
    name: 'Jangkrikan',
  },
  {
    id: '3307020010',
    districtId: '3307020',
    name: 'Kepil',
  },
  {
    id: '3307020011',
    districtId: '3307020',
    name: 'Kapulogo',
  },
  {
    id: '3307020012',
    districtId: '3307020',
    name: 'Kagungan',
  },
  {
    id: '3307020013',
    districtId: '3307020',
    name: 'Randusari',
  },
  {
    id: '3307020014',
    districtId: '3307020',
    name: 'Rejosari',
  },
  {
    id: '3307020015',
    districtId: '3307020',
    name: 'Kalipuru',
  },
  {
    id: '3307020016',
    districtId: '3307020',
    name: 'Ngalian',
  },
  {
    id: '3307020017',
    districtId: '3307020',
    name: 'Tanjunganom',
  },
  {
    id: '3307020018',
    districtId: '3307020',
    name: 'Kaliwuluh',
  },
  {
    id: '3307020019',
    districtId: '3307020',
    name: 'Beran',
  },
  {
    id: '3307020020',
    districtId: '3307020',
    name: 'Tegalgot',
  },
  {
    id: '3307020021',
    districtId: '3307020',
    name: 'Warangan',
  },
  {
    id: '3307020022',
    districtId: '3307020',
    name: 'Ropoh',
  },
  {
    id: '3307020023',
    districtId: '3307020',
    name: 'Pulosaren',
  },
  {
    id: '3307030004',
    districtId: '3307030',
    name: 'Bogoran',
  },
  {
    id: '3307030005',
    districtId: '3307030',
    name: 'Karangsari',
  },
  {
    id: '3307030006',
    districtId: '3307030',
    name: 'Pecekelan',
  },
  {
    id: '3307030007',
    districtId: '3307030',
    name: 'Glagah',
  },
  {
    id: '3307030008',
    districtId: '3307030',
    name: 'Surojoyo',
  },
  {
    id: '3307030009',
    districtId: '3307030',
    name: 'Talunombo',
  },
  {
    id: '3307030010',
    districtId: '3307030',
    name: 'Tempursari',
  },
  {
    id: '3307030011',
    districtId: '3307030',
    name: 'Sapuran',
  },
  {
    id: '3307030012',
    districtId: '3307030',
    name: 'Jolontoro',
  },
  {
    id: '3307030013',
    districtId: '3307030',
    name: 'Sedayu',
  },
  {
    id: '3307030014',
    districtId: '3307030',
    name: 'Ngadisalam',
  },
  {
    id: '3307030015',
    districtId: '3307030',
    name: 'Tempuranduwur',
  },
  {
    id: '3307030016',
    districtId: '3307030',
    name: 'Marongsari',
  },
  {
    id: '3307030017',
    districtId: '3307030',
    name: 'Batursari',
  },
  {
    id: '3307030018',
    districtId: '3307030',
    name: 'Ngadikerso',
  },
  {
    id: '3307030019',
    districtId: '3307030',
    name: 'Rimpak',
  },
  {
    id: '3307030020',
    districtId: '3307030',
    name: 'Banyumudal',
  },
  {
    id: '3307031001',
    districtId: '3307031',
    name: 'Mergolangu',
  },
  {
    id: '3307031003',
    districtId: '3307031',
    name: 'Pengarengan',
  },
  {
    id: '3307031004',
    districtId: '3307031',
    name: 'Kalikarung',
  },
  {
    id: '3307031005',
    districtId: '3307031',
    name: 'Karangsambung',
  },
  {
    id: '3307031006',
    districtId: '3307031',
    name: 'Depok',
  },
  {
    id: '3307031007',
    districtId: '3307031',
    name: 'Kalialang',
  },
  {
    id: '3307031008',
    districtId: '3307031',
    name: 'Tempurejo',
  },
  {
    id: '3307040001',
    districtId: '3307040',
    name: 'Ngadisono',
  },
  {
    id: '3307040002',
    districtId: '3307040',
    name: 'Medono',
  },
  {
    id: '3307040004',
    districtId: '3307040',
    name: 'Bendungan',
  },
  {
    id: '3307040005',
    districtId: '3307040',
    name: 'Selomanik',
  },
  {
    id: '3307040008',
    districtId: '3307040',
    name: 'Kauman',
  },
  {
    id: '3307040009',
    districtId: '3307040',
    name: 'Kaliwiro',
  },
  {
    id: '3307040010',
    districtId: '3307040',
    name: 'Tracap',
  },
  {
    id: '3307040012',
    districtId: '3307040',
    name: 'Purwosari',
  },
  {
    id: '3307040013',
    districtId: '3307040',
    name: 'Lebak',
  },
  {
    id: '3307040014',
    districtId: '3307040',
    name: 'Ngasinan',
  },
  {
    id: '3307040015',
    districtId: '3307040',
    name: 'Kaliguwo',
  },
  {
    id: '3307040016',
    districtId: '3307040',
    name: 'Pesodongan',
  },
  {
    id: '3307040017',
    districtId: '3307040',
    name: 'Lamuk',
  },
  {
    id: '3307040019',
    districtId: '3307040',
    name: 'Gambaran',
  },
  {
    id: '3307040020',
    districtId: '3307040',
    name: 'Tanjunganom',
  },
  {
    id: '3307040021',
    districtId: '3307040',
    name: 'Kemiriombo',
  },
  {
    id: '3307040022',
    districtId: '3307040',
    name: 'Sukoreno',
  },
  {
    id: '3307040023',
    districtId: '3307040',
    name: 'Winongsari',
  },
  {
    id: '3307040024',
    districtId: '3307040',
    name: 'Cledok',
  },
  {
    id: '3307050001',
    districtId: '3307050',
    name: 'Sawangan',
  },
  {
    id: '3307050002',
    districtId: '3307050',
    name: 'Lipursari',
  },
  {
    id: '3307050003',
    districtId: '3307050',
    name: 'Selokromo',
  },
  {
    id: '3307050004',
    districtId: '3307050',
    name: 'Sojokerto',
  },
  {
    id: '3307050005',
    districtId: '3307050',
    name: 'Besani',
  },
  {
    id: '3307050006',
    districtId: '3307050',
    name: 'Leksono',
  },
  {
    id: '3307050007',
    districtId: '3307050',
    name: 'Jlamprang',
  },
  {
    id: '3307050008',
    districtId: '3307050',
    name: 'Wonokerto',
  },
  {
    id: '3307050019',
    districtId: '3307050',
    name: 'Jonggolsari',
  },
  {
    id: '3307050020',
    districtId: '3307050',
    name: 'Timbang',
  },
  {
    id: '3307050021',
    districtId: '3307050',
    name: 'Kalimendong',
  },
  {
    id: '3307050029',
    districtId: '3307050',
    name: 'Manggis',
  },
  {
    id: '3307050030',
    districtId: '3307050',
    name: 'Durensawit',
  },
  {
    id: '3307050031',
    districtId: '3307050',
    name: 'Pacarmulyo',
  },
  {
    id: '3307051001',
    districtId: '3307051',
    name: 'Sempol',
  },
  {
    id: '3307051002',
    districtId: '3307051',
    name: 'Karanganyar',
  },
  {
    id: '3307051003',
    districtId: '3307051',
    name: 'Rogojati',
  },
  {
    id: '3307051004',
    districtId: '3307051',
    name: 'Sukoharjo',
  },
  {
    id: '3307051005',
    districtId: '3307051',
    name: 'Mergosari',
  },
  {
    id: '3307051006',
    districtId: '3307051',
    name: 'Kupangan',
  },
  {
    id: '3307051007',
    districtId: '3307051',
    name: 'Kajeksan',
  },
  {
    id: '3307051009',
    districtId: '3307051',
    name: 'Gumiwang',
  },
  {
    id: '3307051010',
    districtId: '3307051',
    name: 'Plodongan',
  },
  {
    id: '3307051011',
    districtId: '3307051',
    name: 'Suroyudan',
  },
  {
    id: '3307051013',
    districtId: '3307051',
    name: 'Pucungwetan',
  },
  {
    id: '3307051014',
    districtId: '3307051',
    name: 'Tlogo',
  },
  {
    id: '3307051015',
    districtId: '3307051',
    name: 'Kalibening',
  },
  {
    id: '3307051016',
    districtId: '3307051',
    name: 'Garunglor',
  },
  {
    id: '3307051017',
    districtId: '3307051',
    name: 'Jebengplampitan',
  },
  {
    id: '3307060001',
    districtId: '3307060',
    name: 'Kecis',
  },
  {
    id: '3307060002',
    districtId: '3307060',
    name: 'Kaliputih',
  },
  {
    id: '3307060003',
    districtId: '3307060',
    name: 'Candi',
  },
  {
    id: '3307060004',
    districtId: '3307060',
    name: 'Balekambang',
  },
  {
    id: '3307060005',
    districtId: '3307060',
    name: 'Karangrejo',
  },
  {
    id: '3307060006',
    districtId: '3307060',
    name: 'Krasak',
  },
  {
    id: '3307060007',
    districtId: '3307060',
    name: 'Gunungtawang',
  },
  {
    id: '3307060008',
    districtId: '3307060',
    name: 'Pakuncen',
  },
  {
    id: '3307060009',
    districtId: '3307060',
    name: 'Selomerto',
  },
  {
    id: '3307060010',
    districtId: '3307060',
    name: 'Sumberwulan',
  },
  {
    id: '3307060011',
    districtId: '3307060',
    name: 'Plobangan',
  },
  {
    id: '3307060012',
    districtId: '3307060',
    name: 'Simbarejo',
  },
  {
    id: '3307060013',
    districtId: '3307060',
    name: 'Wulungsari',
  },
  {
    id: '3307060014',
    districtId: '3307060',
    name: 'Bumitirto',
  },
  {
    id: '3307060015',
    districtId: '3307060',
    name: 'Semayu',
  },
  {
    id: '3307060016',
    districtId: '3307060',
    name: 'Adiwarno',
  },
  {
    id: '3307060017',
    districtId: '3307060',
    name: 'Kadipaten',
  },
  {
    id: '3307060018',
    districtId: '3307060',
    name: 'Sinduagung',
  },
  {
    id: '3307060019',
    districtId: '3307060',
    name: 'Wilayu',
  },
  {
    id: '3307060020',
    districtId: '3307060',
    name: 'Kalierang',
  },
  {
    id: '3307060021',
    districtId: '3307060',
    name: 'Wonorejo',
  },
  {
    id: '3307060022',
    districtId: '3307060',
    name: 'Sidorejo',
  },
  {
    id: '3307060023',
    districtId: '3307060',
    name: 'Tumenggungan',
  },
  {
    id: '3307060024',
    districtId: '3307060',
    name: 'Ngadimulyo',
  },
  {
    id: '3307070001',
    districtId: '3307070',
    name: 'Mangunrejo',
  },
  {
    id: '3307070003',
    districtId: '3307070',
    name: 'Perboto',
  },
  {
    id: '3307070004',
    districtId: '3307070',
    name: 'Kedalon',
  },
  {
    id: '3307070005',
    districtId: '3307070',
    name: 'Rejosari',
  },
  {
    id: '3307070006',
    districtId: '3307070',
    name: 'Kalikajar',
  },
  {
    id: '3307070007',
    districtId: '3307070',
    name: 'Simbang',
  },
  {
    id: '3307070008',
    districtId: '3307070',
    name: 'Karangduwur',
  },
  {
    id: '3307070009',
    districtId: '3307070',
    name: 'Kwadungan',
  },
  {
    id: '3307070010',
    districtId: '3307070',
    name: 'Purwojiwo',
  },
  {
    id: '3307070011',
    districtId: '3307070',
    name: 'Wonosari',
  },
  {
    id: '3307070012',
    districtId: '3307070',
    name: 'Kalikuning',
  },
  {
    id: '3307070013',
    districtId: '3307070',
    name: 'Maduretno',
  },
  {
    id: '3307070014',
    districtId: '3307070',
    name: 'Tegalombo',
  },
  {
    id: '3307070015',
    districtId: '3307070',
    name: 'Kembaran',
  },
  {
    id: '3307070016',
    districtId: '3307070',
    name: 'Lamuk',
  },
  {
    id: '3307070017',
    districtId: '3307070',
    name: 'Bowongso',
  },
  {
    id: '3307070018',
    districtId: '3307070',
    name: 'Butuh Kidul',
  },
  {
    id: '3307080001',
    districtId: '3307080',
    name: 'Sindupaten',
  },
  {
    id: '3307080003',
    districtId: '3307080',
    name: 'Bojasari',
  },
  {
    id: '3307080005',
    districtId: '3307080',
    name: 'Sumberdalem',
  },
  {
    id: '3307080006',
    districtId: '3307080',
    name: 'Purwojati',
  },
  {
    id: '3307080007',
    districtId: '3307080',
    name: 'Karangluhur',
  },
  {
    id: '3307080008',
    districtId: '3307080',
    name: 'Ngadikusuman',
  },
  {
    id: '3307080009',
    districtId: '3307080',
    name: 'Wringinanom',
  },
  {
    id: '3307080010',
    districtId: '3307080',
    name: 'Sudungdewo',
  },
  {
    id: '3307080011',
    districtId: '3307080',
    name: 'Bejiarum',
  },
  {
    id: '3307080012',
    districtId: '3307080',
    name: 'Damarkasian',
  },
  {
    id: '3307080013',
    districtId: '3307080',
    name: 'Banjar',
  },
  {
    id: '3307080014',
    districtId: '3307080',
    name: 'Tlogodalem',
  },
  {
    id: '3307080015',
    districtId: '3307080',
    name: 'Tlogomulyo',
  },
  {
    id: '3307080016',
    districtId: '3307080',
    name: 'Pagerejo',
  },
  {
    id: '3307080017',
    districtId: '3307080',
    name: 'Candimulyo',
  },
  {
    id: '3307080018',
    districtId: '3307080',
    name: 'Purbosono',
  },
  {
    id: '3307080019',
    districtId: '3307080',
    name: 'Candiyasan',
  },
  {
    id: '3307080020',
    districtId: '3307080',
    name: 'Kapencar',
  },
  {
    id: '3307080021',
    districtId: '3307080',
    name: 'Reco',
  },
  {
    id: '3307090001',
    districtId: '3307090',
    name: 'Tawangsari',
  },
  {
    id: '3307090002',
    districtId: '3307090',
    name: 'Wonolelo',
  },
  {
    id: '3307090003',
    districtId: '3307090',
    name: 'Jogoyitnan',
  },
  {
    id: '3307090004',
    districtId: '3307090',
    name: 'Jaraksari',
  },
  {
    id: '3307090005',
    districtId: '3307090',
    name: 'Mlipak',
  },
  {
    id: '3307090006',
    districtId: '3307090',
    name: 'Sambek',
  },
  {
    id: '3307090008',
    districtId: '3307090',
    name: 'Kramatan',
  },
  {
    id: '3307090009',
    districtId: '3307090',
    name: 'Pancurwening',
  },
  {
    id: '3307090010',
    districtId: '3307090',
    name: 'Bumireso',
  },
  {
    id: '3307090011',
    districtId: '3307090',
    name: 'Rojoimo',
  },
  {
    id: '3307090012',
    districtId: '3307090',
    name: 'Pagerkukuh',
  },
  {
    id: '3307090013',
    districtId: '3307090',
    name: 'Kejiwan',
  },
  {
    id: '3307090014',
    districtId: '3307090',
    name: 'Kalianget',
  },
  {
    id: '3307090015',
    districtId: '3307090',
    name: 'Jlamprang',
  },
  {
    id: '3307090016',
    districtId: '3307090',
    name: 'Wonosari',
  },
  {
    id: '3307090017',
    districtId: '3307090',
    name: 'Bomerto',
  },
  {
    id: '3307090018',
    districtId: '3307090',
    name: 'Sariyoso',
  },
  {
    id: '3307090019',
    districtId: '3307090',
    name: 'Tlogojati',
  },
  {
    id: '3307090020',
    districtId: '3307090',
    name: 'Wonosobo Barat',
  },
  {
    id: '3307090021',
    districtId: '3307090',
    name: 'Wonosobo Timur',
  },
  {
    id: '3307100001',
    districtId: '3307100',
    name: 'Wonosroyo',
  },
  {
    id: '3307100002',
    districtId: '3307100',
    name: 'Gumawang Kidul',
  },
  {
    id: '3307100003',
    districtId: '3307100',
    name: 'Banyukembar',
  },
  {
    id: '3307100004',
    districtId: '3307100',
    name: 'Kuripan',
  },
  {
    id: '3307100005',
    districtId: '3307100',
    name: 'Limbangan',
  },
  {
    id: '3307100006',
    districtId: '3307100',
    name: 'Gondang',
  },
  {
    id: '3307100007',
    districtId: '3307100',
    name: 'Bumiroso',
  },
  {
    id: '3307100008',
    districtId: '3307100',
    name: 'Wonoroto',
  },
  {
    id: '3307100009',
    districtId: '3307100',
    name: 'Pasuruhan',
  },
  {
    id: '3307100010',
    districtId: '3307100',
    name: 'Watumalang',
  },
  {
    id: '3307100011',
    districtId: '3307100',
    name: 'Binangun',
  },
  {
    id: '3307100012',
    districtId: '3307100',
    name: 'Lumajang',
  },
  {
    id: '3307100013',
    districtId: '3307100',
    name: 'Wonokampir',
  },
  {
    id: '3307100014',
    districtId: '3307100',
    name: 'Krinjing',
  },
  {
    id: '3307100015',
    districtId: '3307100',
    name: 'Mutisari',
  },
  {
    id: '3307100016',
    districtId: '3307100',
    name: 'Kalidesel',
  },
  {
    id: '3307110001',
    districtId: '3307110',
    name: 'Guntur Madu',
  },
  {
    id: '3307110002',
    districtId: '3307110',
    name: 'Pungangan',
  },
  {
    id: '3307110003',
    districtId: '3307110',
    name: 'Larangan Kulon',
  },
  {
    id: '3307110004',
    districtId: '3307110',
    name: 'Mudal',
  },
  {
    id: '3307110005',
    districtId: '3307110',
    name: 'Candirejo',
  },
  {
    id: '3307110006',
    districtId: '3307110',
    name: 'Sojopuro',
  },
  {
    id: '3307110008',
    districtId: '3307110',
    name: 'Andongsili',
  },
  {
    id: '3307110009',
    districtId: '3307110',
    name: 'Krasak',
  },
  {
    id: '3307110010',
    districtId: '3307110',
    name: 'Kalibeber',
  },
  {
    id: '3307110011',
    districtId: '3307110',
    name: 'Sukorejo',
  },
  {
    id: '3307110012',
    districtId: '3307110',
    name: 'Mojosari',
  },
  {
    id: '3307110013',
    districtId: '3307110',
    name: 'Bumirejo',
  },
  {
    id: '3307110014',
    districtId: '3307110',
    name: 'Blederan',
  },
  {
    id: '3307110015',
    districtId: '3307110',
    name: 'Kebrengan',
  },
  {
    id: '3307110016',
    districtId: '3307110',
    name: 'Wonokromo',
  },
  {
    id: '3307110017',
    districtId: '3307110',
    name: 'Derongisor',
  },
  {
    id: '3307110018',
    districtId: '3307110',
    name: 'Slukatan',
  },
  {
    id: '3307110019',
    districtId: '3307110',
    name: 'Deroduwur',
  },
  {
    id: '3307120001',
    districtId: '3307120',
    name: 'Tegalsari',
  },
  {
    id: '3307120002',
    districtId: '3307120',
    name: 'Sitiharjo',
  },
  {
    id: '3307120003',
    districtId: '3307120',
    name: 'Sendangsari',
  },
  {
    id: '3307120004',
    districtId: '3307120',
    name: 'Gemblengan',
  },
  {
    id: '3307120005',
    districtId: '3307120',
    name: 'Lengkong',
  },
  {
    id: '3307120006',
    districtId: '3307120',
    name: 'Kayugiyang',
  },
  {
    id: '3307120007',
    districtId: '3307120',
    name: 'Garung',
  },
  {
    id: '3307120008',
    districtId: '3307120',
    name: 'Siwuran',
  },
  {
    id: '3307120009',
    districtId: '3307120',
    name: 'Kuripan',
  },
  {
    id: '3307120010',
    districtId: '3307120',
    name: 'Jengkol',
  },
  {
    id: '3307120011',
    districtId: '3307120',
    name: 'Tlogo',
  },
  {
    id: '3307120012',
    districtId: '3307120',
    name: 'Maron',
  },
  {
    id: '3307120014',
    districtId: '3307120',
    name: 'Larangan Lor',
  },
  {
    id: '3307120015',
    districtId: '3307120',
    name: 'Mlandi',
  },
  {
    id: '3307130002',
    districtId: '3307130',
    name: 'Sigedang',
  },
  {
    id: '3307130003',
    districtId: '3307130',
    name: 'Tambi',
  },
  {
    id: '3307130004',
    districtId: '3307130',
    name: 'Kreo',
  },
  {
    id: '3307130005',
    districtId: '3307130',
    name: 'Serang',
  },
  {
    id: '3307130006',
    districtId: '3307130',
    name: 'Kejajar',
  },
  {
    id: '3307130007',
    districtId: '3307130',
    name: 'Igirmranak',
  },
  {
    id: '3307130009',
    districtId: '3307130',
    name: 'Tieng',
  },
  {
    id: '3307130010',
    districtId: '3307130',
    name: 'Parikesit',
  },
  {
    id: '3307130011',
    districtId: '3307130',
    name: 'Sembungan',
  },
  {
    id: '3307130012',
    districtId: '3307130',
    name: 'Jojogan',
  },
  {
    id: '3307130013',
    districtId: '3307130',
    name: 'Patakbanteng',
  },
  {
    id: '3307130014',
    districtId: '3307130',
    name: 'Dieng',
  },
  {
    id: '3307130015',
    districtId: '3307130',
    name: 'Sikunang',
  },
  {
    id: '3307130016',
    districtId: '3307130',
    name: 'Campursari',
  },
  {
    id: '3308010001',
    districtId: '3308010',
    name: 'Ngargoretno',
  },
  {
    id: '3308010002',
    districtId: '3308010',
    name: 'Paripurno',
  },
  {
    id: '3308010003',
    districtId: '3308010',
    name: 'Kalirejo',
  },
  {
    id: '3308010004',
    districtId: '3308010',
    name: 'Menoreh',
  },
  {
    id: '3308010005',
    districtId: '3308010',
    name: 'Ngadirejo',
  },
  {
    id: '3308010006',
    districtId: '3308010',
    name: 'Sidomulyo',
  },
  {
    id: '3308010007',
    districtId: '3308010',
    name: 'Kebonrejo',
  },
  {
    id: '3308010008',
    districtId: '3308010',
    name: 'Salaman',
  },
  {
    id: '3308010009',
    districtId: '3308010',
    name: 'Kalisalak',
  },
  {
    id: '3308010010',
    districtId: '3308010',
    name: 'Sriwedari',
  },
  {
    id: '3308010011',
    districtId: '3308010',
    name: 'Jebengsari',
  },
  {
    id: '3308010012',
    districtId: '3308010',
    name: 'Tanjunganom',
  },
  {
    id: '3308010013',
    districtId: '3308010',
    name: 'Banjarharjo',
  },
  {
    id: '3308010014',
    districtId: '3308010',
    name: 'Purwosari',
  },
  {
    id: '3308010015',
    districtId: '3308010',
    name: 'Ngampeldento',
  },
  {
    id: '3308010016',
    districtId: '3308010',
    name: 'Sidosari',
  },
  {
    id: '3308010017',
    districtId: '3308010',
    name: 'Sawangargo',
  },
  {
    id: '3308010018',
    districtId: '3308010',
    name: 'Krasak',
  },
  {
    id: '3308010019',
    districtId: '3308010',
    name: 'Margoyoso',
  },
  {
    id: '3308010020',
    districtId: '3308010',
    name: 'Kaliabu',
  },
  {
    id: '3308020001',
    districtId: '3308020',
    name: 'Giripurno',
  },
  {
    id: '3308020002',
    districtId: '3308020',
    name: 'Giritengah',
  },
  {
    id: '3308020003',
    districtId: '3308020',
    name: 'Tuksongo',
  },
  {
    id: '3308020004',
    districtId: '3308020',
    name: 'Majaksingi',
  },
  {
    id: '3308020005',
    districtId: '3308020',
    name: 'Kenalan',
  },
  {
    id: '3308020006',
    districtId: '3308020',
    name: 'Bigaran',
  },
  {
    id: '3308020007',
    districtId: '3308020',
    name: 'Sambeng',
  },
  {
    id: '3308020008',
    districtId: '3308020',
    name: 'Candirejo',
  },
  {
    id: '3308020009',
    districtId: '3308020',
    name: 'Ngargogondo',
  },
  {
    id: '3308020010',
    districtId: '3308020',
    name: 'Wanurejo',
  },
  {
    id: '3308020011',
    districtId: '3308020',
    name: 'Borobudur',
  },
  {
    id: '3308020012',
    districtId: '3308020',
    name: 'Tanjungsari',
  },
  {
    id: '3308020013',
    districtId: '3308020',
    name: 'Karanganyar',
  },
  {
    id: '3308020014',
    districtId: '3308020',
    name: 'Karangrejo',
  },
  {
    id: '3308020015',
    districtId: '3308020',
    name: 'Ngadiharjo',
  },
  {
    id: '3308020016',
    districtId: '3308020',
    name: 'Kebonsari',
  },
  {
    id: '3308020017',
    districtId: '3308020',
    name: 'Tegalarum',
  },
  {
    id: '3308020018',
    districtId: '3308020',
    name: 'Kembanglimus',
  },
  {
    id: '3308020019',
    districtId: '3308020',
    name: 'Wringinputih',
  },
  {
    id: '3308020020',
    districtId: '3308020',
    name: 'Bumiharjo',
  },
  {
    id: '3308030001',
    districtId: '3308030',
    name: 'Bligo',
  },
  {
    id: '3308030002',
    districtId: '3308030',
    name: 'Pakunden',
  },
  {
    id: '3308030003',
    districtId: '3308030',
    name: 'Somokaton',
  },
  {
    id: '3308030004',
    districtId: '3308030',
    name: 'Ngluwar',
  },
  {
    id: '3308030005',
    districtId: '3308030',
    name: 'Karangtalun',
  },
  {
    id: '3308030006',
    districtId: '3308030',
    name: 'Jamuskauman',
  },
  {
    id: '3308030007',
    districtId: '3308030',
    name: 'Plosogede',
  },
  {
    id: '3308030008',
    districtId: '3308030',
    name: 'Blongkeng',
  },
  {
    id: '3308040001',
    districtId: '3308040',
    name: 'Sirahan',
  },
  {
    id: '3308040002',
    districtId: '3308040',
    name: 'Tersan Gede',
  },
  {
    id: '3308040003',
    districtId: '3308040',
    name: 'Baturono',
  },
  {
    id: '3308040004',
    districtId: '3308040',
    name: 'Tirto',
  },
  {
    id: '3308040005',
    districtId: '3308040',
    name: 'Seloboro',
  },
  {
    id: '3308040006',
    districtId: '3308040',
    name: 'Gulon',
  },
  {
    id: '3308040007',
    districtId: '3308040',
    name: 'Jumoyo',
  },
  {
    id: '3308040009',
    districtId: '3308040',
    name: 'Somoketro',
  },
  {
    id: '3308040010',
    districtId: '3308040',
    name: 'Kadiluwih',
  },
  {
    id: '3308040011',
    districtId: '3308040',
    name: 'Mantingan',
  },
  {
    id: '3308040012',
    districtId: '3308040',
    name: 'Salam',
  },
  {
    id: '3308050001',
    districtId: '3308050',
    name: 'Sudimoro',
  },
  {
    id: '3308050003',
    districtId: '3308050',
    name: 'Kaliurang',
  },
  {
    id: '3308050004',
    districtId: '3308050',
    name: 'Kemiren',
  },
  {
    id: '3308050005',
    districtId: '3308050',
    name: 'Kamongan',
  },
  {
    id: '3308050006',
    districtId: '3308050',
    name: 'Jerukagung',
  },
  {
    id: '3308050007',
    districtId: '3308050',
    name: 'Kradenan',
  },
  {
    id: '3308050008',
    districtId: '3308050',
    name: 'Banyuadem',
  },
  {
    id: '3308050009',
    districtId: '3308050',
    name: 'Ngablak',
  },
  {
    id: '3308050011',
    districtId: '3308050',
    name: 'Bringin',
  },
  {
    id: '3308050012',
    districtId: '3308050',
    name: 'Mranggen',
  },
  {
    id: '3308050013',
    districtId: '3308050',
    name: 'Ngargosoko',
  },
  {
    id: '3308050014',
    districtId: '3308050',
    name: 'Polengan',
  },
  {
    id: '3308050015',
    districtId: '3308050',
    name: 'Pucanganom',
  },
  {
    id: '3308050016',
    districtId: '3308050',
    name: 'Pandanretno',
  },
  {
    id: '3308050017',
    districtId: '3308050',
    name: 'Tegalrandu',
  },
  {
    id: '3308060002',
    districtId: '3308060',
    name: 'Ngadipuro',
  },
  {
    id: '3308060003',
    districtId: '3308060',
    name: 'Wates',
  },
  {
    id: '3308060004',
    districtId: '3308060',
    name: 'Kalibening',
  },
  {
    id: '3308060005',
    districtId: '3308060',
    name: 'Ngargomulyo',
  },
  {
    id: '3308060006',
    districtId: '3308060',
    name: 'Keningar',
  },
  {
    id: '3308060009',
    districtId: '3308060',
    name: 'Banyubiru',
  },
  {
    id: '3308060010',
    districtId: '3308060',
    name: 'Banyudono',
  },
  {
    id: '3308060011',
    districtId: '3308060',
    name: 'Mangunsoko',
  },
  {
    id: '3308060012',
    districtId: '3308060',
    name: 'Sewukan',
  },
  {
    id: '3308060013',
    districtId: '3308060',
    name: 'Krinjing',
  },
  {
    id: '3308060014',
    districtId: '3308060',
    name: 'Paten',
  },
  {
    id: '3308060015',
    districtId: '3308060',
    name: 'Sengi',
  },
  {
    id: '3308070001',
    districtId: '3308070',
    name: 'Tanjung',
  },
  {
    id: '3308070002',
    districtId: '3308070',
    name: 'Sokorini',
  },
  {
    id: '3308070003',
    districtId: '3308070',
    name: 'Sriwedari',
  },
  {
    id: '3308070004',
    districtId: '3308070',
    name: 'Congkrang',
  },
  {
    id: '3308070005',
    districtId: '3308070',
    name: 'Adikarto',
  },
  {
    id: '3308070006',
    districtId: '3308070',
    name: 'Menayu',
  },
  {
    id: '3308070007',
    districtId: '3308070',
    name: 'Keji',
  },
  {
    id: '3308070008',
    districtId: '3308070',
    name: 'Ngawen',
  },
  {
    id: '3308070009',
    districtId: '3308070',
    name: 'Gunungpring',
  },
  {
    id: '3308070010',
    districtId: '3308070',
    name: 'Pucungrejo',
  },
  {
    id: '3308070011',
    districtId: '3308070',
    name: 'Tamanagung',
  },
  {
    id: '3308070012',
    districtId: '3308070',
    name: 'Gondosuli',
  },
  {
    id: '3308070013',
    districtId: '3308070',
    name: 'Sedayu',
  },
  {
    id: '3308070014',
    districtId: '3308070',
    name: 'Muntilan',
  },
  {
    id: '3308080001',
    districtId: '3308080',
    name: 'Progowati',
  },
  {
    id: '3308080003',
    districtId: '3308080',
    name: 'Sawitan',
  },
  {
    id: '3308080004',
    districtId: '3308080',
    name: 'Rambeanak',
  },
  {
    id: '3308080005',
    districtId: '3308080',
    name: 'Ngrajek',
  },
  {
    id: '3308080006',
    districtId: '3308080',
    name: 'Pabelan',
  },
  {
    id: '3308080007',
    districtId: '3308080',
    name: 'Paremono',
  },
  {
    id: '3308080008',
    districtId: '3308080',
    name: 'Bumirejo',
  },
  {
    id: '3308080009',
    districtId: '3308080',
    name: 'Blondo',
  },
  {
    id: '3308080010',
    districtId: '3308080',
    name: 'Ambartawang',
  },
  {
    id: '3308080011',
    districtId: '3308080',
    name: 'Mungkid',
  },
  {
    id: '3308080012',
    districtId: '3308080',
    name: 'Bojong',
  },
  {
    id: '3308080013',
    districtId: '3308080',
    name: 'Pagersari',
  },
  {
    id: '3308080015',
    districtId: '3308080',
    name: 'Treko',
  },
  {
    id: '3308080016',
    districtId: '3308080',
    name: 'Gondang',
  },
  {
    id: '3308090001',
    districtId: '3308090',
    name: 'Gondowangi',
  },
  {
    id: '3308090002',
    districtId: '3308090',
    name: 'Sawangan',
  },
  {
    id: '3308090003',
    districtId: '3308090',
    name: 'Mangunsari',
  },
  {
    id: '3308090004',
    districtId: '3308090',
    name: 'Tirtosari',
  },
  {
    id: '3308090005',
    districtId: '3308090',
    name: 'Podosoko',
  },
  {
    id: '3308090007',
    districtId: '3308090',
    name: 'Krogowanan',
  },
  {
    id: '3308090008',
    districtId: '3308090',
    name: 'Kapuhan',
  },
  {
    id: '3308090009',
    districtId: '3308090',
    name: 'Gantang',
  },
  {
    id: '3308090010',
    districtId: '3308090',
    name: 'Jati',
  },
  {
    id: '3308090011',
    districtId: '3308090',
    name: 'Soronalan',
  },
  {
    id: '3308090014',
    districtId: '3308090',
    name: 'Wonolelo',
  },
  {
    id: '3308090015',
    districtId: '3308090',
    name: 'Banyuroto',
  },
  {
    id: '3308100001',
    districtId: '3308100',
    name: 'Tampir Kulon',
  },
  {
    id: '3308100002',
    districtId: '3308100',
    name: 'Tampir Wetan',
  },
  {
    id: '3308100003',
    districtId: '3308100',
    name: 'Bateh',
  },
  {
    id: '3308100005',
    districtId: '3308100',
    name: 'Kebonrejo',
  },
  {
    id: '3308100006',
    districtId: '3308100',
    name: 'Kembaran',
  },
  {
    id: '3308100007',
    districtId: '3308100',
    name: 'Tegalsari',
  },
  {
    id: '3308100008',
    districtId: '3308100',
    name: 'Podosoko',
  },
  {
    id: '3308100009',
    districtId: '3308100',
    name: 'Tempak',
  },
  {
    id: '3308100010',
    districtId: '3308100',
    name: 'Sidomulyo',
  },
  {
    id: '3308100011',
    districtId: '3308100',
    name: 'Mejing',
  },
  {
    id: '3308100012',
    districtId: '3308100',
    name: 'Surojoyo',
  },
  {
    id: '3308100013',
    districtId: '3308100',
    name: 'Candimulyo',
  },
  {
    id: '3308100014',
    districtId: '3308100',
    name: 'Giyanti',
  },
  {
    id: '3308100015',
    districtId: '3308100',
    name: 'Sonorejo',
  },
  {
    id: '3308100016',
    districtId: '3308100',
    name: 'Tembelang',
  },
  {
    id: '3308100017',
    districtId: '3308100',
    name: 'Tempursari',
  },
  {
    id: '3308100018',
    districtId: '3308100',
    name: 'Purworejo',
  },
  {
    id: '3308100019',
    districtId: '3308100',
    name: 'Surodadi',
  },
  {
    id: '3308110001',
    districtId: '3308110',
    name: 'Deyangan',
  },
  {
    id: '3308110002',
    districtId: '3308110',
    name: 'Pasuruhan',
  },
  {
    id: '3308110003',
    districtId: '3308110',
    name: 'Donorojo',
  },
  {
    id: '3308110004',
    districtId: '3308110',
    name: 'Kalinegoro',
  },
  {
    id: '3308110005',
    districtId: '3308110',
    name: 'Jogonegoro',
  },
  {
    id: '3308110006',
    districtId: '3308110',
    name: 'Sukorejo',
  },
  {
    id: '3308110007',
    districtId: '3308110',
    name: 'Bondowoso',
  },
  {
    id: '3308110008',
    districtId: '3308110',
    name: 'Danurejo',
  },
  {
    id: '3308110009',
    districtId: '3308110',
    name: 'Sumberrejo',
  },
  {
    id: '3308110010',
    districtId: '3308110',
    name: 'Mertoyudan',
  },
  {
    id: '3308110011',
    districtId: '3308110',
    name: 'Banyurojo',
  },
  {
    id: '3308110012',
    districtId: '3308110',
    name: 'Banjarnegoro',
  },
  {
    id: '3308110013',
    districtId: '3308110',
    name: 'Bulurejo',
  },
  {
    id: '3308120001',
    districtId: '3308120',
    name: 'Ringinanom',
  },
  {
    id: '3308120002',
    districtId: '3308120',
    name: 'Sumberarum',
  },
  {
    id: '3308120003',
    districtId: '3308120',
    name: 'Sidoagung',
  },
  {
    id: '3308120004',
    districtId: '3308120',
    name: 'Tanggulrejo',
  },
  {
    id: '3308120005',
    districtId: '3308120',
    name: 'Kalisari',
  },
  {
    id: '3308120006',
    districtId: '3308120',
    name: 'Girirejo',
  },
  {
    id: '3308120007',
    districtId: '3308120',
    name: 'Tempurejo',
  },
  {
    id: '3308120008',
    districtId: '3308120',
    name: 'Prajeksari',
  },
  {
    id: '3308120009',
    districtId: '3308120',
    name: 'Tugurejo',
  },
  {
    id: '3308120010',
    districtId: '3308120',
    name: 'Jogomulyo',
  },
  {
    id: '3308120011',
    districtId: '3308120',
    name: 'Growong',
  },
  {
    id: '3308120012',
    districtId: '3308120',
    name: 'Temanggal',
  },
  {
    id: '3308120013',
    districtId: '3308120',
    name: 'Pringombo',
  },
  {
    id: '3308120015',
    districtId: '3308120',
    name: 'Bawang',
  },
  {
    id: '3308130001',
    districtId: '3308130',
    name: 'Wuwuharjo',
  },
  {
    id: '3308130002',
    districtId: '3308130',
    name: 'Wonogiri',
  },
  {
    id: '3308130003',
    districtId: '3308130',
    name: 'Kwaderan',
  },
  {
    id: '3308130004',
    districtId: '3308130',
    name: 'Madukoro',
  },
  {
    id: '3308130005',
    districtId: '3308130',
    name: 'Bumiayu',
  },
  {
    id: '3308130006',
    districtId: '3308130',
    name: 'Ngargosari',
  },
  {
    id: '3308130007',
    districtId: '3308130',
    name: 'Lesanpuro',
  },
  {
    id: '3308130008',
    districtId: '3308130',
    name: 'Ngendrosari',
  },
  {
    id: '3308130009',
    districtId: '3308130',
    name: 'Madugondo',
  },
  {
    id: '3308130010',
    districtId: '3308130',
    name: 'Wadas',
  },
  {
    id: '3308130011',
    districtId: '3308130',
    name: 'Banjaretno',
  },
  {
    id: '3308130012',
    districtId: '3308130',
    name: 'Krinjing',
  },
  {
    id: '3308130013',
    districtId: '3308130',
    name: 'Bangsri',
  },
  {
    id: '3308130014',
    districtId: '3308130',
    name: 'Kajoran',
  },
  {
    id: '3308130015',
    districtId: '3308130',
    name: 'Mangunrejo',
  },
  {
    id: '3308130016',
    districtId: '3308130',
    name: 'Sambak',
  },
  {
    id: '3308130017',
    districtId: '3308130',
    name: 'Bambusari',
  },
  {
    id: '3308130018',
    districtId: '3308130',
    name: 'Pandansari',
  },
  {
    id: '3308130019',
    districtId: '3308130',
    name: 'Pandanretno',
  },
  {
    id: '3308130020',
    districtId: '3308130',
    name: 'Krumpakan',
  },
  {
    id: '3308130021',
    districtId: '3308130',
    name: 'Banjaragung',
  },
  {
    id: '3308130022',
    districtId: '3308130',
    name: 'Sangen',
  },
  {
    id: '3308130023',
    districtId: '3308130',
    name: 'Pucungroto',
  },
  {
    id: '3308130024',
    districtId: '3308130',
    name: 'Sidorejo',
  },
  {
    id: '3308130025',
    districtId: '3308130',
    name: 'Sidowangi',
  },
  {
    id: '3308130026',
    districtId: '3308130',
    name: 'Sukomulyo',
  },
  {
    id: '3308130027',
    districtId: '3308130',
    name: 'Sukorejo',
  },
  {
    id: '3308130028',
    districtId: '3308130',
    name: 'Sutopati',
  },
  {
    id: '3308130029',
    districtId: '3308130',
    name: 'Sukomakmur',
  },
  {
    id: '3308140001',
    districtId: '3308140',
    name: 'Temanggung',
  },
  {
    id: '3308140002',
    districtId: '3308140',
    name: 'Ngawonggo',
  },
  {
    id: '3308140003',
    districtId: '3308140',
    name: 'Kaliangkrik',
  },
  {
    id: '3308140004',
    districtId: '3308140',
    name: 'Girirejo',
  },
  {
    id: '3308140005',
    districtId: '3308140',
    name: 'Ketangi',
  },
  {
    id: '3308140006',
    districtId: '3308140',
    name: 'Balekerto',
  },
  {
    id: '3308140007',
    districtId: '3308140',
    name: 'Bumirejo',
  },
  {
    id: '3308140008',
    districtId: '3308140',
    name: 'Beseran',
  },
  {
    id: '3308140009',
    districtId: '3308140',
    name: 'Giriwarno',
  },
  {
    id: '3308140010',
    districtId: '3308140',
    name: 'Maduretno',
  },
  {
    id: '3308140011',
    districtId: '3308140',
    name: 'Banjarejo',
  },
  {
    id: '3308140012',
    districtId: '3308140',
    name: 'Balerejo',
  },
  {
    id: '3308140013',
    districtId: '3308140',
    name: 'Selomoyo',
  },
  {
    id: '3308140014',
    districtId: '3308140',
    name: 'Ngendrokilo',
  },
  {
    id: '3308140015',
    districtId: '3308140',
    name: 'Munggangsari',
  },
  {
    id: '3308140016',
    districtId: '3308140',
    name: 'Ngargosoko',
  },
  {
    id: '3308140017',
    districtId: '3308140',
    name: 'Pengarengan',
  },
  {
    id: '3308140018',
    districtId: '3308140',
    name: 'Mangli',
  },
  {
    id: '3308140019',
    districtId: '3308140',
    name: 'Kebonlegi',
  },
  {
    id: '3308140020',
    districtId: '3308140',
    name: 'Adipuro',
  },
  {
    id: '3308150001',
    districtId: '3308150',
    name: 'Sukosari',
  },
  {
    id: '3308150002',
    districtId: '3308150',
    name: 'Kedungsari',
  },
  {
    id: '3308150003',
    districtId: '3308150',
    name: 'Salamkanci',
  },
  {
    id: '3308150004',
    districtId: '3308150',
    name: 'Banyuwangi',
  },
  {
    id: '3308150005',
    districtId: '3308150',
    name: 'Trasan',
  },
  {
    id: '3308150006',
    districtId: '3308150',
    name: 'Bandongan',
  },
  {
    id: '3308150007',
    districtId: '3308150',
    name: 'Sukodadi',
  },
  {
    id: '3308150008',
    districtId: '3308150',
    name: 'Tonoboyo',
  },
  {
    id: '3308150009',
    districtId: '3308150',
    name: 'Kebonagung',
  },
  {
    id: '3308150010',
    districtId: '3308150',
    name: 'Kalegen',
  },
  {
    id: '3308150011',
    districtId: '3308150',
    name: 'Ngepanrejo',
  },
  {
    id: '3308150012',
    districtId: '3308150',
    name: 'Gandusari',
  },
  {
    id: '3308150013',
    districtId: '3308150',
    name: 'Sidorejo',
  },
  {
    id: '3308150014',
    districtId: '3308150',
    name: 'Rejosari',
  },
  {
    id: '3308160001',
    districtId: '3308160',
    name: 'Dampit',
  },
  {
    id: '3308160002',
    districtId: '3308160',
    name: 'Tanjungsari',
  },
  {
    id: '3308160003',
    districtId: '3308160',
    name: 'Pasangsari',
  },
  {
    id: '3308160004',
    districtId: '3308160',
    name: 'Kembangkuning',
  },
  {
    id: '3308160005',
    districtId: '3308160',
    name: 'Balesari',
  },
  {
    id: '3308160006',
    districtId: '3308160',
    name: 'Banjarsari',
  },
  {
    id: '3308160007',
    districtId: '3308160',
    name: 'Bandarsedayu',
  },
  {
    id: '3308160008',
    districtId: '3308160',
    name: 'Windusari',
  },
  {
    id: '3308160009',
    districtId: '3308160',
    name: 'Candisari',
  },
  {
    id: '3308160010',
    districtId: '3308160',
    name: 'Genito',
  },
  {
    id: '3308160011',
    districtId: '3308160',
    name: 'Wonoroto',
  },
  {
    id: '3308160012',
    districtId: '3308160',
    name: 'Girimulyo',
  },
  {
    id: '3308160013',
    districtId: '3308160',
    name: 'Ngemplak',
  },
  {
    id: '3308160014',
    districtId: '3308160',
    name: 'Kalijoso',
  },
  {
    id: '3308160015',
    districtId: '3308160',
    name: 'Gunungsari',
  },
  {
    id: '3308160016',
    districtId: '3308160',
    name: 'Mangunsari',
  },
  {
    id: '3308160017',
    districtId: '3308160',
    name: 'Kentengsari',
  },
  {
    id: '3308160018',
    districtId: '3308160',
    name: 'Umbulsari',
  },
  {
    id: '3308160020',
    districtId: '3308160',
    name: 'Gondangrejo',
  },
  {
    id: '3308170001',
    districtId: '3308170',
    name: 'Pancuranmas',
  },
  {
    id: '3308170002',
    districtId: '3308170',
    name: 'Jambewangi',
  },
  {
    id: '3308170003',
    districtId: '3308170',
    name: 'Candiretno',
  },
  {
    id: '3308170004',
    districtId: '3308170',
    name: 'Pirikan',
  },
  {
    id: '3308170005',
    districtId: '3308170',
    name: 'Girikulon',
  },
  {
    id: '3308170006',
    districtId: '3308170',
    name: 'Donomulyo',
  },
  {
    id: '3308170007',
    districtId: '3308170',
    name: 'Sidomulyo',
  },
  {
    id: '3308170008',
    districtId: '3308170',
    name: 'Pucang',
  },
  {
    id: '3308170009',
    districtId: '3308170',
    name: 'Candisari',
  },
  {
    id: '3308170010',
    districtId: '3308170',
    name: 'Madusari',
  },
  {
    id: '3308170011',
    districtId: '3308170',
    name: 'Payaman',
  },
  {
    id: '3308170012',
    districtId: '3308170',
    name: 'Kalijoso',
  },
  {
    id: '3308170013',
    districtId: '3308170',
    name: 'Ngadirojo',
  },
  {
    id: '3308170014',
    districtId: '3308170',
    name: 'Madiocondro',
  },
  {
    id: '3308170015',
    districtId: '3308170',
    name: 'Ngabean',
  },
  {
    id: '3308170016',
    districtId: '3308170',
    name: 'Secang',
  },
  {
    id: '3308170017',
    districtId: '3308170',
    name: 'Krincing',
  },
  {
    id: '3308170018',
    districtId: '3308170',
    name: 'Donorejo',
  },
  {
    id: '3308170019',
    districtId: '3308170',
    name: 'Karangkajen',
  },
  {
    id: '3308170020',
    districtId: '3308170',
    name: 'Purwosari',
  },
  {
    id: '3308180001',
    districtId: '3308180',
    name: 'Banyuurip',
  },
  {
    id: '3308180002',
    districtId: '3308180',
    name: 'Tampingan',
  },
  {
    id: '3308180003',
    districtId: '3308180',
    name: 'Purwosari',
  },
  {
    id: '3308180004',
    districtId: '3308180',
    name: 'Sidorejo',
  },
  {
    id: '3308180005',
    districtId: '3308180',
    name: 'Soroyudan',
  },
  {
    id: '3308180006',
    districtId: '3308180',
    name: 'Tegalrejo',
  },
  {
    id: '3308180007',
    districtId: '3308180',
    name: 'Sukorejo',
  },
  {
    id: '3308180008',
    districtId: '3308180',
    name: 'Kebonagung',
  },
  {
    id: '3308180009',
    districtId: '3308180',
    name: 'Japan',
  },
  {
    id: '3308180010',
    districtId: '3308180',
    name: 'Banyusari',
  },
  {
    id: '3308180011',
    districtId: '3308180',
    name: 'Dlimas',
  },
  {
    id: '3308180012',
    districtId: '3308180',
    name: 'Glagahombo',
  },
  {
    id: '3308180013',
    districtId: '3308180',
    name: 'Ngasem',
  },
  {
    id: '3308180014',
    districtId: '3308180',
    name: 'Girirejo',
  },
  {
    id: '3308180015',
    districtId: '3308180',
    name: 'Purwodadi',
  },
  {
    id: '3308180016',
    districtId: '3308180',
    name: 'Wonokerto',
  },
  {
    id: '3308180017',
    districtId: '3308180',
    name: 'Dawung',
  },
  {
    id: '3308180018',
    districtId: '3308180',
    name: 'Klopo',
  },
  {
    id: '3308180019',
    districtId: '3308180',
    name: 'Ngadirejo',
  },
  {
    id: '3308180020',
    districtId: '3308180',
    name: 'Donorojo',
  },
  {
    id: '3308180021',
    districtId: '3308180',
    name: 'Mangunrejo',
  },
  {
    id: '3308190002',
    districtId: '3308190',
    name: 'Daleman Kidul',
  },
  {
    id: '3308190003',
    districtId: '3308190',
    name: 'Pogalan',
  },
  {
    id: '3308190004',
    districtId: '3308190',
    name: 'Ketundan',
  },
  {
    id: '3308190005',
    districtId: '3308190',
    name: 'Kenalan',
  },
  {
    id: '3308190006',
    districtId: '3308190',
    name: 'Kragilan',
  },
  {
    id: '3308190007',
    districtId: '3308190',
    name: 'Banyusidi',
  },
  {
    id: '3308190008',
    districtId: '3308190',
    name: 'Pakis',
  },
  {
    id: '3308190009',
    districtId: '3308190',
    name: 'Losari',
  },
  {
    id: '3308190010',
    districtId: '3308190',
    name: 'Bawang',
  },
  {
    id: '3308190011',
    districtId: '3308190',
    name: 'Rejosari',
  },
  {
    id: '3308190012',
    districtId: '3308190',
    name: 'Daseh',
  },
  {
    id: '3308190014',
    districtId: '3308190',
    name: 'Kaponan',
  },
  {
    id: '3308190015',
    districtId: '3308190',
    name: 'Gondangsari',
  },
  {
    id: '3308190016',
    districtId: '3308190',
    name: 'Muneng Warangan',
  },
  {
    id: '3308190017',
    districtId: '3308190',
    name: 'Kajangkoso',
  },
  {
    id: '3308190018',
    districtId: '3308190',
    name: 'Gejagan',
  },
  {
    id: '3308190020',
    districtId: '3308190',
    name: 'Jambewangi',
  },
  {
    id: '3308200001',
    districtId: '3308200',
    name: 'Lebak',
  },
  {
    id: '3308200002',
    districtId: '3308200',
    name: 'Pucungsari',
  },
  {
    id: '3308200003',
    districtId: '3308200',
    name: 'Sugihmas',
  },
  {
    id: '3308200004',
    districtId: '3308200',
    name: 'Pesidi',
  },
  {
    id: '3308200005',
    districtId: '3308200',
    name: 'Giriwetan',
  },
  {
    id: '3308200006',
    districtId: '3308200',
    name: 'Cokro',
  },
  {
    id: '3308200007',
    districtId: '3308200',
    name: 'Salam',
  },
  {
    id: '3308200008',
    districtId: '3308200',
    name: 'Ketawang',
  },
  {
    id: '3308200009',
    districtId: '3308200',
    name: 'Banaran',
  },
  {
    id: '3308200010',
    districtId: '3308200',
    name: 'Baleagung',
  },
  {
    id: '3308200012',
    districtId: '3308200',
    name: 'Sumurarum',
  },
  {
    id: '3308200013',
    districtId: '3308200',
    name: 'Kalikuto',
  },
  {
    id: '3308200014',
    districtId: '3308200',
    name: 'Banyusari',
  },
  {
    id: '3308200015',
    districtId: '3308200',
    name: 'Kartoharjo',
  },
  {
    id: '3308200016',
    districtId: '3308200',
    name: 'Grabag',
  },
  {
    id: '3308200017',
    districtId: '3308200',
    name: 'Kleteran',
  },
  {
    id: '3308200018',
    districtId: '3308200',
    name: 'Ngasinan',
  },
  {
    id: '3308200019',
    districtId: '3308200',
    name: 'Tirto',
  },
  {
    id: '3308200020',
    districtId: '3308200',
    name: 'Tlogorejo',
  },
  {
    id: '3308200021',
    districtId: '3308200',
    name: 'Sambungrejo',
  },
  {
    id: '3308200022',
    districtId: '3308200',
    name: 'Citrosono',
  },
  {
    id: '3308200023',
    districtId: '3308200',
    name: 'Sidogede',
  },
  {
    id: '3308200024',
    districtId: '3308200',
    name: 'Kalipucang',
  },
  {
    id: '3308200025',
    districtId: '3308200',
    name: 'Seworan',
  },
  {
    id: '3308200026',
    districtId: '3308200',
    name: 'Banjarsari',
  },
  {
    id: '3308200027',
    districtId: '3308200',
    name: 'Losari',
  },
  {
    id: '3308200028',
    districtId: '3308200',
    name: 'Ngrancah',
  },
  {
    id: '3308210001',
    districtId: '3308210',
    name: 'Magersari',
  },
  {
    id: '3308210002',
    districtId: '3308210',
    name: 'Bandungrejo',
  },
  {
    id: '3308210003',
    districtId: '3308210',
    name: 'Tejosari',
  },
  {
    id: '3308210004',
    districtId: '3308210',
    name: 'Genikan',
  },
  {
    id: '3308210005',
    districtId: '3308210',
    name: 'Jogonayan',
  },
  {
    id: '3308210006',
    districtId: '3308210',
    name: 'Ngablak',
  },
  {
    id: '3308210007',
    districtId: '3308210',
    name: 'Sumberejo',
  },
  {
    id: '3308210008',
    districtId: '3308210',
    name: 'Madyogondo',
  },
  {
    id: '3308210009',
    districtId: '3308210',
    name: 'Kanigoro',
  },
  {
    id: '3308210010',
    districtId: '3308210',
    name: 'Selomirah',
  },
  {
    id: '3308210011',
    districtId: '3308210',
    name: 'Girirejo',
  },
  {
    id: '3308210012',
    districtId: '3308210',
    name: 'Pandean',
  },
  {
    id: '3308210013',
    districtId: '3308210',
    name: 'Jogoyasan',
  },
  {
    id: '3308210014',
    districtId: '3308210',
    name: 'Pagergunung',
  },
  {
    id: '3308210015',
    districtId: '3308210',
    name: 'Keditan',
  },
  {
    id: '3308210016',
    districtId: '3308210',
    name: 'Seloprojo',
  },
  {
    id: '3309010001',
    districtId: '3309010',
    name: 'Tlogolele',
  },
  {
    id: '3309010002',
    districtId: '3309010',
    name: 'Klakah',
  },
  {
    id: '3309010003',
    districtId: '3309010',
    name: 'Jrakah',
  },
  {
    id: '3309010004',
    districtId: '3309010',
    name: 'Lencoh',
  },
  {
    id: '3309010005',
    districtId: '3309010',
    name: 'Suroteleng',
  },
  {
    id: '3309010006',
    districtId: '3309010',
    name: 'Samiran',
  },
  {
    id: '3309010007',
    districtId: '3309010',
    name: 'Selo',
  },
  {
    id: '3309010008',
    districtId: '3309010',
    name: 'Tarubatang',
  },
  {
    id: '3309020001',
    districtId: '3309020',
    name: 'Ngagrong',
  },
  {
    id: '3309020002',
    districtId: '3309020',
    name: 'Seboto',
  },
  {
    id: '3309020003',
    districtId: '3309020',
    name: 'Tanduk',
  },
  {
    id: '3309020004',
    districtId: '3309020',
    name: 'Banyuanyar',
  },
  {
    id: '3309020005',
    districtId: '3309020',
    name: 'Sidomulyo',
  },
  {
    id: '3309020006',
    districtId: '3309020',
    name: 'Ngargosari',
  },
  {
    id: '3309020007',
    districtId: '3309020',
    name: 'Selodoko',
  },
  {
    id: '3309020009',
    districtId: '3309020',
    name: 'Ngampon',
  },
  {
    id: '3309020010',
    districtId: '3309020',
    name: 'Gondangslamet',
  },
  {
    id: '3309020011',
    districtId: '3309020',
    name: 'Candi',
  },
  {
    id: '3309020013',
    districtId: '3309020',
    name: 'Kaligentong',
  },
  {
    id: '3309020014',
    districtId: '3309020',
    name: 'Gladagsari',
  },
  {
    id: '3309020015',
    districtId: '3309020',
    name: 'Kembang',
  },
  {
    id: '3309020016',
    districtId: '3309020',
    name: 'Candisari',
  },
  {
    id: '3309020017',
    districtId: '3309020',
    name: 'Ngargoloko',
  },
  {
    id: '3309020018',
    districtId: '3309020',
    name: 'Sampetan',
  },
  {
    id: '3309020019',
    districtId: '3309020',
    name: 'Ngadirojo',
  },
  {
    id: '3309020020',
    districtId: '3309020',
    name: 'Jlarem',
  },
  {
    id: '3309030001',
    districtId: '3309030',
    name: 'Wonodoyo',
  },
  {
    id: '3309030002',
    districtId: '3309030',
    name: 'Jombong',
  },
  {
    id: '3309030003',
    districtId: '3309030',
    name: 'Gedangan',
  },
  {
    id: '3309030005',
    districtId: '3309030',
    name: 'Paras',
  },
  {
    id: '3309030006',
    districtId: '3309030',
    name: 'Jelok',
  },
  {
    id: '3309030007',
    districtId: '3309030',
    name: 'Bakulan',
  },
  {
    id: '3309030008',
    districtId: '3309030',
    name: 'Mliwis',
  },
  {
    id: '3309030009',
    districtId: '3309030',
    name: 'Sukabumi',
  },
  {
    id: '3309030010',
    districtId: '3309030',
    name: 'Genting',
  },
  {
    id: '3309030011',
    districtId: '3309030',
    name: 'Cepogo',
  },
  {
    id: '3309030012',
    districtId: '3309030',
    name: 'Kembangkuning',
  },
  {
    id: '3309030013',
    districtId: '3309030',
    name: 'Cabeankunti',
  },
  {
    id: '3309030014',
    districtId: '3309030',
    name: 'Candigatak',
  },
  {
    id: '3309040001',
    districtId: '3309040',
    name: 'Lampar',
  },
  {
    id: '3309040002',
    districtId: '3309040',
    name: 'Dragan',
  },
  {
    id: '3309040003',
    districtId: '3309040',
    name: 'Karanganyar',
  },
  {
    id: '3309040004',
    districtId: '3309040',
    name: 'Jemowo',
  },
  {
    id: '3309040006',
    districtId: '3309040',
    name: 'Sangup',
  },
  {
    id: '3309040007',
    districtId: '3309040',
    name: 'Mriyan',
  },
  {
    id: '3309040008',
    districtId: '3309040',
    name: 'Lanjaran',
  },
  {
    id: '3309040009',
    districtId: '3309040',
    name: 'Karangkendal',
  },
  {
    id: '3309040010',
    districtId: '3309040',
    name: 'Keposong',
  },
  {
    id: '3309040011',
    districtId: '3309040',
    name: 'Pagerjurang',
  },
  {
    id: '3309040012',
    districtId: '3309040',
    name: 'Sukorejo',
  },
  {
    id: '3309040013',
    districtId: '3309040',
    name: 'Sruni',
  },
  {
    id: '3309040014',
    districtId: '3309040',
    name: 'Cluntang',
  },
  {
    id: '3309040015',
    districtId: '3309040',
    name: 'Kembangsari',
  },
  {
    id: '3309040016',
    districtId: '3309040',
    name: 'Ringinlarik',
  },
  {
    id: '3309040017',
    districtId: '3309040',
    name: 'Kebongulo',
  },
  {
    id: '3309040019',
    districtId: '3309040',
    name: 'Sukorame',
  },
  {
    id: '3309040020',
    districtId: '3309040',
    name: 'Pusporenggo',
  },
  {
    id: '3309050001',
    districtId: '3309050',
    name: 'Pulisen',
  },
  {
    id: '3309050002',
    districtId: '3309050',
    name: 'Siswodipuran',
  },
  {
    id: '3309050003',
    districtId: '3309050',
    name: 'Banaran',
  },
  {
    id: '3309050004',
    districtId: '3309050',
    name: 'Winong',
  },
  {
    id: '3309050006',
    districtId: '3309050',
    name: 'Kiringan',
  },
  {
    id: '3309050007',
    districtId: '3309050',
    name: 'Karanggeneng',
  },
  {
    id: '3309050008',
    districtId: '3309050',
    name: 'Mudal',
  },
  {
    id: '3309050009',
    districtId: '3309050',
    name: 'Kebonbimo',
  },
  {
    id: '3309060001',
    districtId: '3309060',
    name: 'Singosari',
  },
  {
    id: '3309060002',
    districtId: '3309060',
    name: 'Tambak',
  },
  {
    id: '3309060003',
    districtId: '3309060',
    name: 'Manggis',
  },
  {
    id: '3309060005',
    districtId: '3309060',
    name: 'Karangnongko',
  },
  {
    id: '3309060006',
    districtId: '3309060',
    name: 'Madu',
  },
  {
    id: '3309060007',
    districtId: '3309060',
    name: 'Kemiri',
  },
  {
    id: '3309060009',
    districtId: '3309060',
    name: 'Mojosongo',
  },
  {
    id: '3309060010',
    districtId: '3309060',
    name: 'Kragilan',
  },
  {
    id: '3309060011',
    districtId: '3309060',
    name: 'Brajan',
  },
  {
    id: '3309060013',
    districtId: '3309060',
    name: 'Dlingo',
  },
  {
    id: '3309070001',
    districtId: '3309070',
    name: 'Kopen',
  },
  {
    id: '3309070002',
    districtId: '3309070',
    name: 'Doplang',
  },
  {
    id: '3309070003',
    districtId: '3309070',
    name: 'Kadireso',
  },
  {
    id: '3309070005',
    districtId: '3309070',
    name: 'Sudimoro',
  },
  {
    id: '3309070006',
    districtId: '3309070',
    name: 'Bangsalan',
  },
  {
    id: '3309070007',
    districtId: '3309070',
    name: 'Salakan',
  },
  {
    id: '3309070008',
    districtId: '3309070',
    name: 'Teras',
  },
  {
    id: '3309070009',
    districtId: '3309070',
    name: 'Randusari',
  },
  {
    id: '3309070010',
    districtId: '3309070',
    name: 'Mojolegi',
  },
  {
    id: '3309070011',
    districtId: '3309070',
    name: 'Gumukrejo',
  },
  {
    id: '3309070012',
    districtId: '3309070',
    name: 'Tawangsari',
  },
  {
    id: '3309070013',
    districtId: '3309070',
    name: 'Krasak',
  },
  {
    id: '3309080001',
    districtId: '3309080',
    name: 'Tegalrejo',
  },
  {
    id: '3309080002',
    districtId: '3309080',
    name: 'Gombang',
  },
  {
    id: '3309080003',
    districtId: '3309080',
    name: 'Manjung',
  },
  {
    id: '3309080004',
    districtId: '3309080',
    name: 'Kateguhan',
  },
  {
    id: '3309080005',
    districtId: '3309080',
    name: 'Bendosari',
  },
  {
    id: '3309080006',
    districtId: '3309080',
    name: 'Jatirejo',
  },
  {
    id: '3309080007',
    districtId: '3309080',
    name: 'Kemasan',
  },
  {
    id: '3309080008',
    districtId: '3309080',
    name: 'Tlawong',
  },
  {
    id: '3309080009',
    districtId: '3309080',
    name: 'Jenengan',
  },
  {
    id: '3309080010',
    districtId: '3309080',
    name: 'Cepokosawit',
  },
  {
    id: '3309080011',
    districtId: '3309080',
    name: 'Guwokajen',
  },
  {
    id: '3309080012',
    districtId: '3309080',
    name: 'Karangduren',
  },
  {
    id: '3309090002',
    districtId: '3309090',
    name: 'Jipangan',
  },
  {
    id: '3309090003',
    districtId: '3309090',
    name: 'Jembungan',
  },
  {
    id: '3309090004',
    districtId: '3309090',
    name: 'Sambon',
  },
  {
    id: '3309090005',
    districtId: '3309090',
    name: 'Kuwiran',
  },
  {
    id: '3309090006',
    districtId: '3309090',
    name: 'Cangkringan',
  },
  {
    id: '3309090007',
    districtId: '3309090',
    name: 'Ngaru Aru',
  },
  {
    id: '3309090008',
    districtId: '3309090',
    name: 'Bendan',
  },
  {
    id: '3309090009',
    districtId: '3309090',
    name: 'Ketaon',
  },
  {
    id: '3309090010',
    districtId: '3309090',
    name: 'Banyudono',
  },
  {
    id: '3309090011',
    districtId: '3309090',
    name: 'Batan',
  },
  {
    id: '3309090012',
    districtId: '3309090',
    name: 'Denggungan',
  },
  {
    id: '3309090013',
    districtId: '3309090',
    name: 'Bangak',
  },
  {
    id: '3309090014',
    districtId: '3309090',
    name: 'Trayu',
  },
  {
    id: '3309090015',
    districtId: '3309090',
    name: 'Tanjungsari',
  },
  {
    id: '3309100001',
    districtId: '3309100',
    name: 'Glintang',
  },
  {
    id: '3309100002',
    districtId: '3309100',
    name: 'Jatisari',
  },
  {
    id: '3309100003',
    districtId: '3309100',
    name: 'Canden',
  },
  {
    id: '3309100004',
    districtId: '3309100',
    name: 'Senting',
  },
  {
    id: '3309100005',
    districtId: '3309100',
    name: 'Tempursari',
  },
  {
    id: '3309100006',
    districtId: '3309100',
    name: 'Sambi',
  },
  {
    id: '3309100007',
    districtId: '3309100',
    name: 'Demangan',
  },
  {
    id: '3309100008',
    districtId: '3309100',
    name: 'Kepoh',
  },
  {
    id: '3309100009',
    districtId: '3309100',
    name: 'Jagoan',
  },
  {
    id: '3309100010',
    districtId: '3309100',
    name: 'Babadan',
  },
  {
    id: '3309100011',
    districtId: '3309100',
    name: 'Tawengan',
  },
  {
    id: '3309100012',
    districtId: '3309100',
    name: 'Catur',
  },
  {
    id: '3309100013',
    districtId: '3309100',
    name: 'Ngaglik',
  },
  {
    id: '3309100014',
    districtId: '3309100',
    name: 'Trosobo',
  },
  {
    id: '3309100015',
    districtId: '3309100',
    name: 'Cermo',
  },
  {
    id: '3309110001',
    districtId: '3309110',
    name: 'Ngargorejo',
  },
  {
    id: '3309110002',
    districtId: '3309110',
    name: 'Sobokerto',
  },
  {
    id: '3309110004',
    districtId: '3309110',
    name: 'Gagaksipat',
  },
  {
    id: '3309110005',
    districtId: '3309110',
    name: 'Donohudan',
  },
  {
    id: '3309110006',
    districtId: '3309110',
    name: 'Sawahan',
  },
  {
    id: '3309110007',
    districtId: '3309110',
    name: 'Pandeyan',
  },
  {
    id: '3309110008',
    districtId: '3309110',
    name: 'Kismoyoso',
  },
  {
    id: '3309110009',
    districtId: '3309110',
    name: 'Dibal',
  },
  {
    id: '3309110010',
    districtId: '3309110',
    name: 'Sindon',
  },
  {
    id: '3309110011',
    districtId: '3309110',
    name: 'Manggung',
  },
  {
    id: '3309110012',
    districtId: '3309110',
    name: 'Giriroto',
  },
  {
    id: '3309120002',
    districtId: '3309120',
    name: 'Potronayan',
  },
  {
    id: '3309120003',
    districtId: '3309120',
    name: 'Sembungan',
  },
  {
    id: '3309120004',
    districtId: '3309120',
    name: 'Jeron',
  },
  {
    id: '3309120005',
    districtId: '3309120',
    name: 'Ketitang',
  },
  {
    id: '3309120007',
    districtId: '3309120',
    name: 'Guli',
  },
  {
    id: '3309120008',
    districtId: '3309120',
    name: 'Tegalgiri',
  },
  {
    id: '3309120009',
    districtId: '3309120',
    name: 'Bendo',
  },
  {
    id: '3309120010',
    districtId: '3309120',
    name: 'Keyongan',
  },
  {
    id: '3309120011',
    districtId: '3309120',
    name: 'Pojok',
  },
  {
    id: '3309120012',
    districtId: '3309120',
    name: 'Glonggong',
  },
  {
    id: '3309120013',
    districtId: '3309120',
    name: 'Pulutan',
  },
  {
    id: '3309130002',
    districtId: '3309130',
    name: 'Bendungan',
  },
  {
    id: '3309130003',
    districtId: '3309130',
    name: 'Temon',
  },
  {
    id: '3309130005',
    districtId: '3309130',
    name: 'Simo',
  },
  {
    id: '3309130006',
    districtId: '3309130',
    name: 'Walen',
  },
  {
    id: '3309130009',
    districtId: '3309130',
    name: 'Talakbroto',
  },
  {
    id: '3309130010',
    districtId: '3309130',
    name: 'Kedunglengkong',
  },
  {
    id: '3309130011',
    districtId: '3309130',
    name: 'Blagung',
  },
  {
    id: '3309130013',
    districtId: '3309130',
    name: 'Wates',
  },
  {
    id: '3309140001',
    districtId: '3309140',
    name: 'Manyaran',
  },
  {
    id: '3309140003',
    districtId: '3309140',
    name: 'Klumpit',
  },
  {
    id: '3309140004',
    districtId: '3309140',
    name: 'Pinggir',
  },
  {
    id: '3309140005',
    districtId: '3309140',
    name: 'Bantengan',
  },
  {
    id: '3309140006',
    districtId: '3309140',
    name: 'Tegalsari',
  },
  {
    id: '3309140007',
    districtId: '3309140',
    name: 'Sranten',
  },
  {
    id: '3309140008',
    districtId: '3309140',
    name: 'Grogolan',
  },
  {
    id: '3309140009',
    districtId: '3309140',
    name: 'Mojosari',
  },
  {
    id: '3309140010',
    districtId: '3309140',
    name: 'Pengkol',
  },
  {
    id: '3309140011',
    districtId: '3309140',
    name: 'Karangkepoh',
  },
  {
    id: '3309140012',
    districtId: '3309140',
    name: 'Sendang',
  },
  {
    id: '3309140013',
    districtId: '3309140',
    name: 'Kebonan',
  },
  {
    id: '3309140014',
    districtId: '3309140',
    name: 'Klari',
  },
  {
    id: '3309140015',
    districtId: '3309140',
    name: 'Bangkok',
  },
  {
    id: '3309140016',
    districtId: '3309140',
    name: 'Dologan',
  },
  {
    id: '3309150001',
    districtId: '3309150',
    name: 'Tanjung',
  },
  {
    id: '3309150002',
    districtId: '3309150',
    name: 'Sendangrejo',
  },
  {
    id: '3309150003',
    districtId: '3309150',
    name: 'Kalangan',
  },
  {
    id: '3309150004',
    districtId: '3309150',
    name: 'Sangge',
  },
  {
    id: '3309150005',
    districtId: '3309150',
    name: 'Jaten',
  },
  {
    id: '3309150006',
    districtId: '3309150',
    name: 'Blumbang',
  },
  {
    id: '3309150007',
    districtId: '3309150',
    name: 'Bade',
  },
  {
    id: '3309150008',
    districtId: '3309150',
    name: 'Klego',
  },
  {
    id: '3309150009',
    districtId: '3309150',
    name: 'Gondanglegi',
  },
  {
    id: '3309150010',
    districtId: '3309150',
    name: 'Karanggatak',
  },
  {
    id: '3309150011',
    districtId: '3309150',
    name: 'Banyuurip',
  },
  {
    id: '3309150012',
    districtId: '3309150',
    name: 'Sumberagung',
  },
  {
    id: '3309150013',
    districtId: '3309150',
    name: 'Karangmojo',
  },
  {
    id: '3309160002',
    districtId: '3309160',
    name: 'Gondangrawe',
  },
  {
    id: '3309160003',
    districtId: '3309160',
    name: 'Pakel',
  },
  {
    id: '3309160004',
    districtId: '3309160',
    name: 'Senggrong',
  },
  {
    id: '3309160005',
    districtId: '3309160',
    name: 'Mojo',
  },
  {
    id: '3309160006',
    districtId: '3309160',
    name: 'Beji',
  },
  {
    id: '3309160007',
    districtId: '3309160',
    name: 'Andong',
  },
  {
    id: '3309160008',
    districtId: '3309160',
    name: 'Kacangan',
  },
  {
    id: '3309160009',
    districtId: '3309160',
    name: 'Kedungdowo',
  },
  {
    id: '3309160010',
    districtId: '3309160',
    name: 'Pranggong',
  },
  {
    id: '3309160011',
    districtId: '3309160',
    name: 'Pakang',
  },
  {
    id: '3309160013',
    districtId: '3309160',
    name: 'Kadipaten',
  },
  {
    id: '3309160014',
    districtId: '3309160',
    name: 'Semawung',
  },
  {
    id: '3309160015',
    districtId: '3309160',
    name: 'Kunti',
  },
  {
    id: '3309160016',
    districtId: '3309160',
    name: 'Pelemrejo',
  },
  {
    id: '3309170001',
    districtId: '3309170',
    name: 'Kauman',
  },
  {
    id: '3309170003',
    districtId: '3309170',
    name: 'Bawu',
  },
  {
    id: '3309170004',
    districtId: '3309170',
    name: 'Klewor',
  },
  {
    id: '3309170005',
    districtId: '3309170',
    name: 'Sarimulyo',
  },
  {
    id: '3309170006',
    districtId: '3309170',
    name: 'Watugede',
  },
  {
    id: '3309170007',
    districtId: '3309170',
    name: 'Kedungrejo',
  },
  {
    id: '3309170008',
    districtId: '3309170',
    name: 'Genengsari',
  },
  {
    id: '3309170010',
    districtId: '3309170',
    name: 'Lemahireng',
  },
  {
    id: '3309170011',
    districtId: '3309170',
    name: 'Guwo',
  },
  {
    id: '3309170012',
    districtId: '3309170',
    name: 'Kedungmulyo',
  },
  {
    id: '3309170013',
    districtId: '3309170',
    name: 'Wonoharjo',
  },
  {
    id: '3309180001',
    districtId: '3309180',
    name: 'Ngablak',
  },
  {
    id: '3309180002',
    districtId: '3309180',
    name: 'Karangjati',
  },
  {
    id: '3309180003',
    districtId: '3309180',
    name: 'Ketoyan',
  },
  {
    id: '3309180004',
    districtId: '3309180',
    name: 'Bolo',
  },
  {
    id: '3309180005',
    districtId: '3309180',
    name: 'Wonosegoro',
  },
  {
    id: '3309180006',
    districtId: '3309180',
    name: 'Bandung',
  },
  {
    id: '3309180007',
    districtId: '3309180',
    name: 'Kedungpilang',
  },
  {
    id: '3309180008',
    districtId: '3309180',
    name: 'Kalinanas',
  },
  {
    id: '3309180009',
    districtId: '3309180',
    name: 'Gilirejo',
  },
  {
    id: '3309180010',
    districtId: '3309180',
    name: 'Jatilawang',
  },
  {
    id: '3309180011',
    districtId: '3309180',
    name: 'Garangan',
  },
  {
    id: '3309180012',
    districtId: '3309180',
    name: 'Gosono',
  },
  {
    id: '3309180013',
    districtId: '3309180',
    name: 'Banyusri',
  },
  {
    id: '3309180014',
    districtId: '3309180',
    name: 'Bojong',
  },
  {
    id: '3309180015',
    districtId: '3309180',
    name: 'Bercak',
  },
  {
    id: '3309180017',
    districtId: '3309180',
    name: 'Gunungsari',
  },
  {
    id: '3309180018',
    districtId: '3309180',
    name: 'Repaking',
  },
  {
    id: '3309190001',
    districtId: '3309190',
    name: 'Krobokan',
  },
  {
    id: '3309190002',
    districtId: '3309190',
    name: 'Ngaren',
  },
  {
    id: '3309190003',
    districtId: '3309190',
    name: 'Kalimati',
  },
  {
    id: '3309190004',
    districtId: '3309190',
    name: 'Sambeng',
  },
  {
    id: '3309190006',
    districtId: '3309190',
    name: 'Juwangi',
  },
  {
    id: '3309190007',
    districtId: '3309190',
    name: 'Pilangrejo',
  },
  {
    id: '3309190008',
    districtId: '3309190',
    name: 'Jerukan',
  },
  {
    id: '3309190009',
    districtId: '3309190',
    name: 'Kayen',
  },
  {
    id: '3310010001',
    districtId: '3310010',
    name: 'Kebon Dalem Kidul',
  },
  {
    id: '3310010003',
    districtId: '3310010',
    name: 'Kotesan',
  },
  {
    id: '3310010004',
    districtId: '3310010',
    name: 'Sengon',
  },
  {
    id: '3310010005',
    districtId: '3310010',
    name: 'Cucukan',
  },
  {
    id: '3310010006',
    districtId: '3310010',
    name: 'Sanggrahan',
  },
  {
    id: '3310010008',
    districtId: '3310010',
    name: 'Kemudo',
  },
  {
    id: '3310010009',
    districtId: '3310010',
    name: 'Taji',
  },
  {
    id: '3310010010',
    districtId: '3310010',
    name: 'Tlogo',
  },
  {
    id: '3310010011',
    districtId: '3310010',
    name: 'Bugisan',
  },
  {
    id: '3310010012',
    districtId: '3310010',
    name: 'Kokosan',
  },
  {
    id: '3310010013',
    districtId: '3310010',
    name: 'Kebon Dalem Lor',
  },
  {
    id: '3310010014',
    districtId: '3310010',
    name: 'Brajan',
  },
  {
    id: '3310010015',
    districtId: '3310010',
    name: 'Randusari',
  },
  {
    id: '3310010016',
    districtId: '3310010',
    name: 'Joho',
  },
  {
    id: '3310020001',
    districtId: '3310020',
    name: 'Katekan',
  },
  {
    id: '3310020003',
    districtId: '3310020',
    name: 'Ngandong',
  },
  {
    id: '3310020004',
    districtId: '3310020',
    name: 'Kragilan',
  },
  {
    id: '3310020005',
    districtId: '3310020',
    name: 'Jogoprayan',
  },
  {
    id: '3310020006',
    districtId: '3310020',
    name: 'Karangturi',
  },
  {
    id: '3310020007',
    districtId: '3310020',
    name: 'Gentan',
  },
  {
    id: '3310020008',
    districtId: '3310020',
    name: 'Gesikan',
  },
  {
    id: '3310020010',
    districtId: '3310020',
    name: 'Sawit',
  },
  {
    id: '3310020011',
    districtId: '3310020',
    name: 'Mutihan',
  },
  {
    id: '3310020013',
    districtId: '3310020',
    name: 'Baturan',
  },
  {
    id: '3310020014',
    districtId: '3310020',
    name: 'Ceporan',
  },
  {
    id: '3310020015',
    districtId: '3310020',
    name: 'Jabung',
  },
  {
    id: '3310020016',
    districtId: '3310020',
    name: 'Towangsan',
  },
  {
    id: '3310030003',
    districtId: '3310030',
    name: 'Tanjungan',
  },
  {
    id: '3310030004',
    districtId: '3310030',
    name: 'Pasung',
  },
  {
    id: '3310030005',
    districtId: '3310030',
    name: 'Brangkal',
  },
  {
    id: '3310030006',
    districtId: '3310030',
    name: 'Pacing',
  },
  {
    id: '3310030007',
    districtId: '3310030',
    name: 'Kadilanggon',
  },
  {
    id: '3310030008',
    districtId: '3310030',
    name: 'Kaligayam',
  },
  {
    id: '3310030009',
    districtId: '3310030',
    name: 'Melikan',
  },
  {
    id: '3310030010',
    districtId: '3310030',
    name: 'Jiwo Wetan',
  },
  {
    id: '3310030011',
    districtId: '3310030',
    name: 'Kadibolo',
  },
  {
    id: '3310030012',
    districtId: '3310030',
    name: 'Trotok',
  },
  {
    id: '3310030014',
    districtId: '3310030',
    name: 'Sukorejo',
  },
  {
    id: '3310030015',
    districtId: '3310030',
    name: 'Birit',
  },
  {
    id: '3310030016',
    districtId: '3310030',
    name: 'Pandes',
  },
  {
    id: '3310030017',
    districtId: '3310030',
    name: 'Gadungan',
  },
  {
    id: '3310030018',
    districtId: '3310030',
    name: 'Canan',
  },
  {
    id: '3310030019',
    districtId: '3310030',
    name: 'Kalitengah',
  },
  {
    id: '3310040001',
    districtId: '3310040',
    name: 'Bogem',
  },
  {
    id: '3310040002',
    districtId: '3310040',
    name: 'Nengahan',
  },
  {
    id: '3310040003',
    districtId: '3310040',
    name: 'Jarum',
  },
  {
    id: '3310040004',
    districtId: '3310040',
    name: 'Ngerangan',
  },
  {
    id: '3310040005',
    districtId: '3310040',
    name: 'Jambakan',
  },
  {
    id: '3310040007',
    districtId: '3310040',
    name: 'Banyuripan',
  },
  {
    id: '3310040009',
    districtId: '3310040',
    name: 'Paseban',
  },
  {
    id: '3310040010',
    districtId: '3310040',
    name: 'Krikilan',
  },
  {
    id: '3310040011',
    districtId: '3310040',
    name: 'Kebon',
  },
  {
    id: '3310040012',
    districtId: '3310040',
    name: 'Gunung Gajah',
  },
  {
    id: '3310040013',
    districtId: '3310040',
    name: 'Tegalrejo',
  },
  {
    id: '3310040014',
    districtId: '3310040',
    name: 'Talang',
  },
  {
    id: '3310040015',
    districtId: '3310040',
    name: 'Tawangrejo',
  },
  {
    id: '3310040016',
    districtId: '3310040',
    name: 'Wiro',
  },
  {
    id: '3310040017',
    districtId: '3310040',
    name: 'Jotangan',
  },
  {
    id: '3310040018',
    districtId: '3310040',
    name: 'Krakitan',
  },
  {
    id: '3310050001',
    districtId: '3310050',
    name: 'Karangasem',
  },
  {
    id: '3310050002',
    districtId: '3310050',
    name: 'Burikan',
  },
  {
    id: '3310050003',
    districtId: '3310050',
    name: 'Nanggulan',
  },
  {
    id: '3310050004',
    districtId: '3310050',
    name: 'Bendungan',
  },
  {
    id: '3310050006',
    districtId: '3310050',
    name: 'Kedungampel',
  },
  {
    id: '3310050007',
    districtId: '3310050',
    name: 'Bawak',
  },
  {
    id: '3310050008',
    districtId: '3310050',
    name: 'Barepan',
  },
  {
    id: '3310050009',
    districtId: '3310050',
    name: 'Pakisan',
  },
  {
    id: '3310050010',
    districtId: '3310050',
    name: 'Balak',
  },
  {
    id: '3310050011',
    districtId: '3310050',
    name: 'Cawas',
  },
  {
    id: '3310050012',
    districtId: '3310050',
    name: 'Plosowangi',
  },
  {
    id: '3310050013',
    districtId: '3310050',
    name: 'Baran',
  },
  {
    id: '3310050014',
    districtId: '3310050',
    name: 'Tirtomarto',
  },
  {
    id: '3310050015',
    districtId: '3310050',
    name: 'Japanan',
  },
  {
    id: '3310050016',
    districtId: '3310050',
    name: 'Tlingsing',
  },
  {
    id: '3310050018',
    districtId: '3310050',
    name: 'Gombang',
  },
  {
    id: '3310050019',
    districtId: '3310050',
    name: 'Pogung',
  },
  {
    id: '3310050020',
    districtId: '3310050',
    name: 'Bogor',
  },
  {
    id: '3310060001',
    districtId: '3310060',
    name: 'Karangpakel',
  },
  {
    id: '3310060002',
    districtId: '3310060',
    name: 'Wanglu',
  },
  {
    id: '3310060004',
    districtId: '3310060',
    name: 'Kalikebo',
  },
  {
    id: '3310060005',
    districtId: '3310060',
    name: 'Gaden',
  },
  {
    id: '3310060006',
    districtId: '3310060',
    name: 'Planggu',
  },
  {
    id: '3310060007',
    districtId: '3310060',
    name: 'Pundungsari',
  },
  {
    id: '3310060008',
    districtId: '3310060',
    name: 'Sajen',
  },
  {
    id: '3310060009',
    districtId: '3310060',
    name: 'Puluhan',
  },
  {
    id: '3310060010',
    districtId: '3310060',
    name: 'Kradenan',
  },
  {
    id: '3310060011',
    districtId: '3310060',
    name: 'Sabrang Lor',
  },
  {
    id: '3310060012',
    districtId: '3310060',
    name: 'Jatipuro',
  },
  {
    id: '3310060013',
    districtId: '3310060',
    name: 'Wonosari',
  },
  {
    id: '3310060014',
    districtId: '3310060',
    name: 'Mireng',
  },
  {
    id: '3310060015',
    districtId: '3310060',
    name: 'Bero',
  },
  {
    id: '3310060016',
    districtId: '3310060',
    name: 'Mandong',
  },
  {
    id: '3310060018',
    districtId: '3310060',
    name: 'Palar',
  },
  {
    id: '3310070001',
    districtId: '3310070',
    name: 'Jimbung',
  },
  {
    id: '3310070002',
    districtId: '3310070',
    name: 'Ngemplak',
  },
  {
    id: '3310070003',
    districtId: '3310070',
    name: 'Kalikotes',
  },
  {
    id: '3310070004',
    districtId: '3310070',
    name: 'Krajan',
  },
  {
    id: '3310070005',
    districtId: '3310070',
    name: 'Tambongwetan',
  },
  {
    id: '3310070006',
    districtId: '3310070',
    name: 'Gemblegan',
  },
  {
    id: '3310070007',
    districtId: '3310070',
    name: 'Jogosetran',
  },
  {
    id: '3310080001',
    districtId: '3310080',
    name: 'Basin',
  },
  {
    id: '3310080002',
    districtId: '3310080',
    name: 'Gondang',
  },
  {
    id: '3310080005',
    districtId: '3310080',
    name: 'Malangjiwan',
  },
  {
    id: '3310080007',
    districtId: '3310080',
    name: 'Karangduren',
  },
  {
    id: '3310090001',
    districtId: '3310090',
    name: 'Somopuro',
  },
  {
    id: '3310090002',
    districtId: '3310090',
    name: 'Titang',
  },
  {
    id: '3310090003',
    districtId: '3310090',
    name: 'Tangkisan Pos',
  },
  {
    id: '3310090004',
    districtId: '3310090',
    name: 'Rejoso',
  },
  {
    id: '3310090005',
    districtId: '3310090',
    name: 'Gondangan',
  },
  {
    id: '3310090006',
    districtId: '3310090',
    name: 'Bakung',
  },
  {
    id: '3310090007',
    districtId: '3310090',
    name: 'Ngering',
  },
  {
    id: '3310090008',
    districtId: '3310090',
    name: 'Pakahan',
  },
  {
    id: '3310090009',
    districtId: '3310090',
    name: 'Sumyang',
  },
  {
    id: '3310090010',
    districtId: '3310090',
    name: 'Karangdukuh',
  },
  {
    id: '3310090011',
    districtId: '3310090',
    name: 'Plawikan',
  },
  {
    id: '3310090012',
    districtId: '3310090',
    name: 'Kraguman',
  },
  {
    id: '3310090013',
    districtId: '3310090',
    name: 'Granting',
  },
  {
    id: '3310090014',
    districtId: '3310090',
    name: 'Prawatan',
  },
  {
    id: '3310090015',
    districtId: '3310090',
    name: 'Wonoboyo',
  },
  {
    id: '3310090016',
    districtId: '3310090',
    name: 'Dompyongan',
  },
  {
    id: '3310090017',
    districtId: '3310090',
    name: 'Joton',
  },
  {
    id: '3310090018',
    districtId: '3310090',
    name: 'Tambakan',
  },
  {
    id: '3310100001',
    districtId: '3310100',
    name: 'Taskombang',
  },
  {
    id: '3310100002',
    districtId: '3310100',
    name: 'Solodiran',
  },
  {
    id: '3310100003',
    districtId: '3310100',
    name: 'Nangsri',
  },
  {
    id: '3310100004',
    districtId: '3310100',
    name: 'Borangan',
  },
  {
    id: '3310100005',
    districtId: '3310100',
    name: 'Barukan',
  },
  {
    id: '3310100006',
    districtId: '3310100',
    name: 'Tanjungsari',
  },
  {
    id: '3310100007',
    districtId: '3310100',
    name: 'Kranggan',
  },
  {
    id: '3310100009',
    districtId: '3310100',
    name: 'Kebonalas',
  },
  {
    id: '3310100010',
    districtId: '3310100',
    name: 'Bendan',
  },
  {
    id: '3310100011',
    districtId: '3310100',
    name: 'Tijayan',
  },
  {
    id: '3310100012',
    districtId: '3310100',
    name: 'Sukorini',
  },
  {
    id: '3310100014',
    districtId: '3310100',
    name: 'Ngemplak Seneng',
  },
  {
    id: '3310100015',
    districtId: '3310100',
    name: 'Sapen',
  },
  {
    id: '3310110002',
    districtId: '3310110',
    name: 'Banyuaeng',
  },
  {
    id: '3310110003',
    districtId: '3310110',
    name: 'Kadilajo',
  },
  {
    id: '3310110004',
    districtId: '3310110',
    name: 'Somokaton',
  },
  {
    id: '3310110005',
    districtId: '3310110',
    name: 'Jetis',
  },
  {
    id: '3310110006',
    districtId: '3310110',
    name: 'Karangnongko',
  },
  {
    id: '3310110007',
    districtId: '3310110',
    name: 'Jagalan',
  },
  {
    id: '3310110008',
    districtId: '3310110',
    name: 'Demakijo',
  },
  {
    id: '3310110009',
    districtId: '3310110',
    name: 'Blimbing',
  },
  {
    id: '3310110010',
    districtId: '3310110',
    name: 'Kanoman',
  },
  {
    id: '3310110011',
    districtId: '3310110',
    name: 'Gemampir',
  },
  {
    id: '3310110012',
    districtId: '3310110',
    name: 'Logede',
  },
  {
    id: '3310110013',
    districtId: '3310110',
    name: 'Jiwan',
  },
  {
    id: '3310110014',
    districtId: '3310110',
    name: 'Ngemplak',
  },
  {
    id: '3310120002',
    districtId: '3310120',
    name: 'Gatak',
  },
  {
    id: '3310120003',
    districtId: '3310120',
    name: 'Manjung',
  },
  {
    id: '3310120005',
    districtId: '3310120',
    name: 'Ngawen',
  },
  {
    id: '3310120006',
    districtId: '3310120',
    name: 'Kahuman',
  },
  {
    id: '3310120007',
    districtId: '3310120',
    name: 'Kwaren',
  },
  {
    id: '3310120009',
    districtId: '3310120',
    name: 'Manjungan',
  },
  {
    id: '3310120010',
    districtId: '3310120',
    name: 'Tempursari',
  },
  {
    id: '3310120011',
    districtId: '3310120',
    name: 'Mayungan',
  },
  {
    id: '3310120012',
    districtId: '3310120',
    name: 'Candi Rejo',
  },
  {
    id: '3310120013',
    districtId: '3310120',
    name: 'Drono',
  },
  {
    id: '3310130001',
    districtId: '3310130',
    name: 'Srebegan',
  },
  {
    id: '3310130002',
    districtId: '3310130',
    name: 'Pasungan',
  },
  {
    id: '3310130003',
    districtId: '3310130',
    name: 'Kajen',
  },
  {
    id: '3310130004',
    districtId: '3310130',
    name: 'Jambu Kidul',
  },
  {
    id: '3310130005',
    districtId: '3310130',
    name: 'Kujon',
  },
  {
    id: '3310130006',
    districtId: '3310130',
    name: 'Pokak',
  },
  {
    id: '3310130008',
    districtId: '3310130',
    name: 'Jombor',
  },
  {
    id: '3310130009',
    districtId: '3310130',
    name: 'Dlimas',
  },
  {
    id: '3310130011',
    districtId: '3310130',
    name: 'Cetan',
  },
  {
    id: '3310130012',
    districtId: '3310130',
    name: 'Tegalrejo',
  },
  {
    id: '3310130014',
    districtId: '3310130',
    name: 'Jambu Kulon',
  },
  {
    id: '3310130017',
    districtId: '3310130',
    name: 'Ngawonggo',
  },
  {
    id: '3310140001',
    districtId: '3310140',
    name: 'Temuwangi',
  },
  {
    id: '3310140002',
    districtId: '3310140',
    name: 'Beji',
  },
  {
    id: '3310140003',
    districtId: '3310140',
    name: 'Ngaren',
  },
  {
    id: '3310140004',
    districtId: '3310140',
    name: 'Jatimulyo',
  },
  {
    id: '3310140005',
    districtId: '3310140',
    name: 'Jetis Wetan',
  },
  {
    id: '3310140007',
    districtId: '3310140',
    name: 'Bendo',
  },
  {
    id: '3310140008',
    districtId: '3310140',
    name: 'Tambakboyo',
  },
  {
    id: '3310140009',
    districtId: '3310140',
    name: 'Kedungan',
  },
  {
    id: '3310140010',
    districtId: '3310140',
    name: 'Sobayan',
  },
  {
    id: '3310140011',
    districtId: '3310140',
    name: 'Kalangan',
  },
  {
    id: '3310140012',
    districtId: '3310140',
    name: 'Troketon',
  },
  {
    id: '3310140013',
    districtId: '3310140',
    name: 'Kaligawe',
  },
  {
    id: '3310140014',
    districtId: '3310140',
    name: 'Lemahireng',
  },
  {
    id: '3310150001',
    districtId: '3310150',
    name: 'Tulas',
  },
  {
    id: '3310150002',
    districtId: '3310150',
    name: 'Bulusan',
  },
  {
    id: '3310150003',
    districtId: '3310150',
    name: 'Tumpukan',
  },
  {
    id: '3310150004',
    districtId: '3310150',
    name: 'Soka',
  },
  {
    id: '3310150005',
    districtId: '3310150',
    name: 'Karangjoho',
  },
  {
    id: '3310150006',
    districtId: '3310150',
    name: 'Ringinputih',
  },
  {
    id: '3310150007',
    districtId: '3310150',
    name: 'Tambak',
  },
  {
    id: '3310150008',
    districtId: '3310150',
    name: 'Karangdowo',
  },
  {
    id: '3310150010',
    districtId: '3310150',
    name: 'Sentono',
  },
  {
    id: '3310150011',
    districtId: '3310150',
    name: 'Ngolodono',
  },
  {
    id: '3310150012',
    districtId: '3310150',
    name: 'Pugeran',
  },
  {
    id: '3310150013',
    districtId: '3310150',
    name: 'Demangan',
  },
  {
    id: '3310150014',
    districtId: '3310150',
    name: 'Babadan',
  },
  {
    id: '3310150015',
    districtId: '3310150',
    name: 'Tegalampel',
  },
  {
    id: '3310150016',
    districtId: '3310150',
    name: 'Karangtalun',
  },
  {
    id: '3310150017',
    districtId: '3310150',
    name: 'Karangwungu',
  },
  {
    id: '3310150018',
    districtId: '3310150',
    name: 'Kupang',
  },
  {
    id: '3310150019',
    districtId: '3310150',
    name: 'Bakungan',
  },
  {
    id: '3310160001',
    districtId: '3310160',
    name: 'Trasan',
  },
  {
    id: '3310160002',
    districtId: '3310160',
    name: 'Sawahan',
  },
  {
    id: '3310160003',
    districtId: '3310160',
    name: 'Juwiran',
  },
  {
    id: '3310160004',
    districtId: '3310160',
    name: 'Jetis',
  },
  {
    id: '3310160005',
    districtId: '3310160',
    name: 'Ketitang',
  },
  {
    id: '3310160006',
    districtId: '3310160',
    name: 'Gondangsari',
  },
  {
    id: '3310160007',
    districtId: '3310160',
    name: 'Serenan',
  },
  {
    id: '3310160008',
    districtId: '3310160',
    name: 'Tlogorandu',
  },
  {
    id: '3310160009',
    districtId: '3310160',
    name: 'Bolopleret',
  },
  {
    id: '3310160010',
    districtId: '3310160',
    name: 'Tanjung',
  },
  {
    id: '3310160011',
    districtId: '3310160',
    name: 'Kenaiban',
  },
  {
    id: '3310160012',
    districtId: '3310160',
    name: 'Bulurejo',
  },
  {
    id: '3310160013',
    districtId: '3310160',
    name: 'Jaten',
  },
  {
    id: '3310160014',
    districtId: '3310160',
    name: 'Mrisen',
  },
  {
    id: '3310160015',
    districtId: '3310160',
    name: 'Pundungan',
  },
  {
    id: '3310160016',
    districtId: '3310160',
    name: 'Juwiring',
  },
  {
    id: '3310160017',
    districtId: '3310160',
    name: 'Kwarasan',
  },
  {
    id: '3310160018',
    districtId: '3310160',
    name: 'Carikan',
  },
  {
    id: '3310160019',
    districtId: '3310160',
    name: 'Taji',
  },
  {
    id: '3310170001',
    districtId: '3310170',
    name: 'Wadung Getas',
  },
  {
    id: '3310170002',
    districtId: '3310170',
    name: 'Boto',
  },
  {
    id: '3310170003',
    districtId: '3310170',
    name: 'Bulan',
  },
  {
    id: '3310170005',
    districtId: '3310170',
    name: 'Jelobo',
  },
  {
    id: '3310170006',
    districtId: '3310170',
    name: 'Gunting',
  },
  {
    id: '3310170007',
    districtId: '3310170',
    name: 'Sidowarno',
  },
  {
    id: '3310170009',
    districtId: '3310170',
    name: 'Kingkang',
  },
  {
    id: '3310170010',
    districtId: '3310170',
    name: 'Teloyo',
  },
  {
    id: '3310170011',
    districtId: '3310170',
    name: 'Pandanan',
  },
  {
    id: '3310170013',
    districtId: '3310170',
    name: 'Bentangan',
  },
  {
    id: '3310170015',
    districtId: '3310170',
    name: 'Sekaran',
  },
  {
    id: '3310170016',
    districtId: '3310170',
    name: 'Sukorejo',
  },
  {
    id: '3310170017',
    districtId: '3310170',
    name: 'Tegalgondo',
  },
  {
    id: '3310170018',
    districtId: '3310170',
    name: 'Bolali',
  },
  {
    id: '3310180001',
    districtId: '3310180',
    name: 'Bowan',
  },
  {
    id: '3310180003',
    districtId: '3310180',
    name: 'Jetis',
  },
  {
    id: '3310180004',
    districtId: '3310180',
    name: 'Butuhan',
  },
  {
    id: '3310180005',
    districtId: '3310180',
    name: 'Banaran',
  },
  {
    id: '3310180006',
    districtId: '3310180',
    name: 'Karang',
  },
  {
    id: '3310180007',
    districtId: '3310180',
    name: 'Sribit',
  },
  {
    id: '3310180009',
    districtId: '3310180',
    name: 'Mendak',
  },
  {
    id: '3310180010',
    districtId: '3310180',
    name: 'Delanggu',
  },
  {
    id: '3310180011',
    districtId: '3310180',
    name: 'Sabrang',
  },
  {
    id: '3310180012',
    districtId: '3310180',
    name: 'Tlobong',
  },
  {
    id: '3310180013',
    districtId: '3310180',
    name: 'Gatak',
  },
  {
    id: '3310180014',
    districtId: '3310180',
    name: 'Kepanjen',
  },
  {
    id: '3310180015',
    districtId: '3310180',
    name: 'Segaran',
  },
  {
    id: '3310180016',
    districtId: '3310180',
    name: 'Sidomulyo',
  },
  {
    id: '3310190001',
    districtId: '3310190',
    name: 'Glagah Wangi',
  },
  {
    id: '3310190002',
    districtId: '3310190',
    name: 'Kapungan',
  },
  {
    id: '3310190003',
    districtId: '3310190',
    name: 'Kauman',
  },
  {
    id: '3310190004',
    districtId: '3310190',
    name: 'Ngaran',
  },
  {
    id: '3310190005',
    districtId: '3310190',
    name: 'Borongan',
  },
  {
    id: '3310190006',
    districtId: '3310190',
    name: 'Nganjat',
  },
  {
    id: '3310190007',
    districtId: '3310190',
    name: 'Jimus',
  },
  {
    id: '3310190009',
    districtId: '3310190',
    name: 'Polan',
  },
  {
    id: '3310190010',
    districtId: '3310190',
    name: 'Karanglo',
  },
  {
    id: '3310190011',
    districtId: '3310190',
    name: 'Ponggok',
  },
  {
    id: '3310190012',
    districtId: '3310190',
    name: 'Wangen',
  },
  {
    id: '3310190013',
    districtId: '3310190',
    name: 'Keprabon',
  },
  {
    id: '3310190014',
    districtId: '3310190',
    name: 'Kranggan',
  },
  {
    id: '3310190015',
    districtId: '3310190',
    name: 'Kebonharjo',
  },
  {
    id: '3310190016',
    districtId: '3310190',
    name: 'Janti',
  },
  {
    id: '3310190017',
    districtId: '3310190',
    name: 'Sidowayah',
  },
  {
    id: '3310190018',
    districtId: '3310190',
    name: 'Sidoharjo',
  },
  {
    id: '3310200001',
    districtId: '3310200',
    name: 'Jambeyan',
  },
  {
    id: '3310200002',
    districtId: '3310200',
    name: 'Jungkare',
  },
  {
    id: '3310200003',
    districtId: '3310200',
    name: 'Kadirejo',
  },
  {
    id: '3310200004',
    districtId: '3310200',
    name: 'Tarubasan',
  },
  {
    id: '3310200005',
    districtId: '3310200',
    name: 'Troso',
  },
  {
    id: '3310200006',
    districtId: '3310200',
    name: 'Blanceran',
  },
  {
    id: '3310200008',
    districtId: '3310200',
    name: 'Brangkal',
  },
  {
    id: '3310200010',
    districtId: '3310200',
    name: 'Karangan',
  },
  {
    id: '3310200011',
    districtId: '3310200',
    name: 'Karanganom',
  },
  {
    id: '3310200012',
    districtId: '3310200',
    name: 'Padas',
  },
  {
    id: '3310200013',
    districtId: '3310200',
    name: 'Soropaten',
  },
  {
    id: '3310200014',
    districtId: '3310200',
    name: 'Jurangjero',
  },
  {
    id: '3310200015',
    districtId: '3310200',
    name: 'Ngabeyan',
  },
  {
    id: '3310200017',
    districtId: '3310200',
    name: 'Gempol',
  },
  {
    id: '3310200018',
    districtId: '3310200',
    name: 'Pondok',
  },
  {
    id: '3310200019',
    districtId: '3310200',
    name: 'Jeblog',
  },
  {
    id: '3310210002',
    districtId: '3310210',
    name: 'Sedayu',
  },
  {
    id: '3310210003',
    districtId: '3310210',
    name: 'Pomah',
  },
  {
    id: '3310210004',
    districtId: '3310210',
    name: 'Bono',
  },
  {
    id: '3310210005',
    districtId: '3310210',
    name: 'Kiringan',
  },
  {
    id: '3310210006',
    districtId: '3310210',
    name: 'Majegan',
  },
  {
    id: '3310210007',
    districtId: '3310210',
    name: 'Dalangan',
  },
  {
    id: '3310210008',
    districtId: '3310210',
    name: 'Gedongjetis',
  },
  {
    id: '3310210009',
    districtId: '3310210',
    name: 'Sorogaten',
  },
  {
    id: '3310210010',
    districtId: '3310210',
    name: 'Beji',
  },
  {
    id: '3310210011',
    districtId: '3310210',
    name: 'Kemiri',
  },
  {
    id: '3310210012',
    districtId: '3310210',
    name: 'Sudimoro',
  },
  {
    id: '3310210014',
    districtId: '3310210',
    name: 'Malangan',
  },
  {
    id: '3310210015',
    districtId: '3310210',
    name: 'Pucang Miliran',
  },
  {
    id: '3310210016',
    districtId: '3310210',
    name: 'Cokro',
  },
  {
    id: '3310210017',
    districtId: '3310210',
    name: 'Daleman',
  },
  {
    id: '3310220002',
    districtId: '3310220',
    name: 'Randulanang',
  },
  {
    id: '3310220003',
    districtId: '3310220',
    name: 'Mranggen',
  },
  {
    id: '3310220004',
    districtId: '3310220',
    name: 'Jemawan',
  },
  {
    id: '3310220005',
    districtId: '3310220',
    name: 'Gedaren',
  },
  {
    id: '3310220006',
    districtId: '3310220',
    name: 'Cawan',
  },
  {
    id: '3310220007',
    districtId: '3310220',
    name: 'Tibayan',
  },
  {
    id: '3310220008',
    districtId: '3310220',
    name: 'Bengking',
  },
  {
    id: '3310220009',
    districtId: '3310220',
    name: 'Temuireng',
  },
  {
    id: '3310220010',
    districtId: '3310220',
    name: 'Bandungan',
  },
  {
    id: '3310220011',
    districtId: '3310220',
    name: 'Kayumas',
  },
  {
    id: '3310220012',
    districtId: '3310220',
    name: 'Socokangsi',
  },
  {
    id: '3310220013',
    districtId: '3310220',
    name: 'Glagah',
  },
  {
    id: '3310220014',
    districtId: '3310220',
    name: 'Krajan',
  },
  {
    id: '3310220015',
    districtId: '3310220',
    name: 'Jatinom',
  },
  {
    id: '3310220016',
    districtId: '3310220',
    name: 'Bonyokan',
  },
  {
    id: '3310220017',
    districtId: '3310220',
    name: 'Pandeyan',
  },
  {
    id: '3310220018',
    districtId: '3310220',
    name: 'Puluhan',
  },
  {
    id: '3310230001',
    districtId: '3310230',
    name: 'Bawukan',
  },
  {
    id: '3310230002',
    districtId: '3310230',
    name: 'Panggang',
  },
  {
    id: '3310230003',
    districtId: '3310230',
    name: 'Talun',
  },
  {
    id: '3310230004',
    districtId: '3310230',
    name: 'Kendalsari',
  },
  {
    id: '3310230005',
    districtId: '3310230',
    name: 'Keputran',
  },
  {
    id: '3310230006',
    districtId: '3310230',
    name: 'Kemalang',
  },
  {
    id: '3310230007',
    districtId: '3310230',
    name: 'Dompol',
  },
  {
    id: '3310230008',
    districtId: '3310230',
    name: 'Tangkil',
  },
  {
    id: '3310230009',
    districtId: '3310230',
    name: 'Bumiharjo',
  },
  {
    id: '3310230010',
    districtId: '3310230',
    name: 'Tlogowatu',
  },
  {
    id: '3310230011',
    districtId: '3310230',
    name: 'Sidorejo',
  },
  {
    id: '3310230012',
    districtId: '3310230',
    name: 'Balerante',
  },
  {
    id: '3310230013',
    districtId: '3310230',
    name: 'Tegalmulyo',
  },
  {
    id: '3310710001',
    districtId: '3310710',
    name: 'Kajoran',
  },
  {
    id: '3310710002',
    districtId: '3310710',
    name: 'Glodogan',
  },
  {
    id: '3310710003',
    districtId: '3310710',
    name: 'Ngalas',
  },
  {
    id: '3310710004',
    districtId: '3310710',
    name: 'Danguran',
  },
  {
    id: '3310710006',
    districtId: '3310710',
    name: 'Sumberejo',
  },
  {
    id: '3310710008',
    districtId: '3310710',
    name: 'Tegalyoso',
  },
  {
    id: '3310710009',
    districtId: '3310710',
    name: 'Gayamprit',
  },
  {
    id: '3310710010',
    districtId: '3310710',
    name: 'Karanglo',
  },
  {
    id: '3310710011',
    districtId: '3310710',
    name: 'Nglinggi',
  },
  {
    id: '3310710012',
    districtId: '3310710',
    name: 'Jetis',
  },
  {
    id: '3310720001',
    districtId: '3310720',
    name: 'Buntalan',
  },
  {
    id: '3310720002',
    districtId: '3310720',
    name: 'Jomboran',
  },
  {
    id: '3310720003',
    districtId: '3310720',
    name: 'Gumulan',
  },
  {
    id: '3310720004',
    districtId: '3310720',
    name: 'Mojayan',
  },
  {
    id: '3310720005',
    districtId: '3310720',
    name: 'Bareng',
  },
  {
    id: '3310720006',
    districtId: '3310720',
    name: 'Semangkak',
  },
  {
    id: '3310720007',
    districtId: '3310720',
    name: 'Kabupaten',
  },
  {
    id: '3310720008',
    districtId: '3310720',
    name: 'Klaten',
  },
  {
    id: '3310720009',
    districtId: '3310720',
    name: 'Tonggalan',
  },
  {
    id: '3310730001',
    districtId: '3310730',
    name: 'Sekarsuli',
  },
  {
    id: '3310730002',
    districtId: '3310730',
    name: 'Bareng Lor',
  },
  {
    id: '3310730003',
    districtId: '3310730',
    name: 'Karanganom',
  },
  {
    id: '3310730004',
    districtId: '3310730',
    name: 'Ketandan',
  },
  {
    id: '3310730005',
    districtId: '3310730',
    name: 'Belang Wetan',
  },
  {
    id: '3310730006',
    districtId: '3310730',
    name: 'Jonggrangan',
  },
  {
    id: '3310730008',
    districtId: '3310730',
    name: 'Jebugan',
  },
  {
    id: '3311010001',
    districtId: '3311010',
    name: 'Grogol',
  },
  {
    id: '3311010002',
    districtId: '3311010',
    name: 'Karangtengah',
  },
  {
    id: '3311010003',
    districtId: '3311010',
    name: 'Karangwuni',
  },
  {
    id: '3311010004',
    districtId: '3311010',
    name: 'Krajan',
  },
  {
    id: '3311010005',
    districtId: '3311010',
    name: 'Jatingarang',
  },
  {
    id: '3311010006',
    districtId: '3311010',
    name: 'Karanganyar',
  },
  {
    id: '3311010007',
    districtId: '3311010',
    name: 'Alasombo',
  },
  {
    id: '3311010008',
    districtId: '3311010',
    name: 'Karangmojo',
  },
  {
    id: '3311010010',
    districtId: '3311010',
    name: 'Karakan',
  },
  {
    id: '3311010011',
    districtId: '3311010',
    name: 'Tegalsari',
  },
  {
    id: '3311010012',
    districtId: '3311010',
    name: 'Tawang',
  },
  {
    id: '3311010013',
    districtId: '3311010',
    name: 'Ngreco',
  },
  {
    id: '3311020001',
    districtId: '3311020',
    name: 'Sanggang',
  },
  {
    id: '3311020002',
    districtId: '3311020',
    name: 'Kamal',
  },
  {
    id: '3311020003',
    districtId: '3311020',
    name: 'Gentan',
  },
  {
    id: '3311020004',
    districtId: '3311020',
    name: 'Kedungsono',
  },
  {
    id: '3311020005',
    districtId: '3311020',
    name: 'Tiyaran',
  },
  {
    id: '3311020008',
    districtId: '3311020',
    name: 'Puron',
  },
  {
    id: '3311020009',
    districtId: '3311020',
    name: 'Malangan',
  },
  {
    id: '3311020010',
    districtId: '3311020',
    name: 'Lengking',
  },
  {
    id: '3311020011',
    districtId: '3311020',
    name: 'Ngasinan',
  },
  {
    id: '3311020012',
    districtId: '3311020',
    name: 'Karangasem',
  },
  {
    id: '3311030001',
    districtId: '3311030',
    name: 'Watubonang',
  },
  {
    id: '3311030002',
    districtId: '3311030',
    name: 'Pundungrejo',
  },
  {
    id: '3311030003',
    districtId: '3311030',
    name: 'Lorog',
  },
  {
    id: '3311030004',
    districtId: '3311030',
    name: 'Grajegan',
  },
  {
    id: '3311030005',
    districtId: '3311030',
    name: 'Kedungjambal',
  },
  {
    id: '3311030006',
    districtId: '3311030',
    name: 'Ponowaren',
  },
  {
    id: '3311030007',
    districtId: '3311030',
    name: 'Kateguhan',
  },
  {
    id: '3311030008',
    districtId: '3311030',
    name: 'Dalangan',
  },
  {
    id: '3311030009',
    districtId: '3311030',
    name: 'Pojok',
  },
  {
    id: '3311030010',
    districtId: '3311030',
    name: 'Tangkisan',
  },
  {
    id: '3311030011',
    districtId: '3311030',
    name: 'Majasto',
  },
  {
    id: '3311030012',
    districtId: '3311030',
    name: 'Tambakboyo',
  },
  {
    id: '3311040002',
    districtId: '3311040',
    name: 'Banmati',
  },
  {
    id: '3311040003',
    districtId: '3311040',
    name: 'Mandan',
  },
  {
    id: '3311040004',
    districtId: '3311040',
    name: 'Begajah',
  },
  {
    id: '3311040005',
    districtId: '3311040',
    name: 'Gayam',
  },
  {
    id: '3311040006',
    districtId: '3311040',
    name: 'Joho',
  },
  {
    id: '3311040007',
    districtId: '3311040',
    name: 'Jetis',
  },
  {
    id: '3311040008',
    districtId: '3311040',
    name: 'Combongan',
  },
  {
    id: '3311040009',
    districtId: '3311040',
    name: 'Kriwen',
  },
  {
    id: '3311040010',
    districtId: '3311040',
    name: 'Bulakan',
  },
  {
    id: '3311040012',
    districtId: '3311040',
    name: 'Sukoharjo',
  },
  {
    id: '3311040013',
    districtId: '3311040',
    name: 'Bulakrejo',
  },
  {
    id: '3311040014',
    districtId: '3311040',
    name: 'Sonorejo',
  },
  {
    id: '3311050001',
    districtId: '3311050',
    name: 'Lawu',
  },
  {
    id: '3311050002',
    districtId: '3311050',
    name: 'Baran',
  },
  {
    id: '3311050004',
    districtId: '3311050',
    name: 'Gupit',
  },
  {
    id: '3311050005',
    districtId: '3311050',
    name: 'Pengkol',
  },
  {
    id: '3311050006',
    districtId: '3311050',
    name: 'Jangglengan',
  },
  {
    id: '3311050007',
    districtId: '3311050',
    name: 'Tanjungrejo',
  },
  {
    id: '3311050009',
    districtId: '3311050',
    name: 'Juron',
  },
  {
    id: '3311050011',
    districtId: '3311050',
    name: 'Plesan',
  },
  {
    id: '3311050012',
    districtId: '3311050',
    name: 'Kedungwinong',
  },
  {
    id: '3311050013',
    districtId: '3311050',
    name: 'Daleman',
  },
  {
    id: '3311050015',
    districtId: '3311050',
    name: 'Pondok',
  },
  {
    id: '3311050016',
    districtId: '3311050',
    name: 'Tanjung',
  },
  {
    id: '3311060001',
    districtId: '3311060',
    name: 'Jagan',
  },
  {
    id: '3311060002',
    districtId: '3311060',
    name: 'Manisharjo',
  },
  {
    id: '3311060003',
    districtId: '3311060',
    name: 'Cabeyan',
  },
  {
    id: '3311060004',
    districtId: '3311060',
    name: 'Puhgogor',
  },
  {
    id: '3311060005',
    districtId: '3311060',
    name: 'Paluhombo',
  },
  {
    id: '3311060006',
    districtId: '3311060',
    name: 'Bendosari',
  },
  {
    id: '3311060007',
    districtId: '3311060',
    name: 'Mojorejo',
  },
  {
    id: '3311060008',
    districtId: '3311060',
    name: 'Mertan',
  },
  {
    id: '3311060010',
    districtId: '3311060',
    name: 'Toriyo',
  },
  {
    id: '3311060011',
    districtId: '3311060',
    name: 'Jombor',
  },
  {
    id: '3311060012',
    districtId: '3311060',
    name: 'Sidorejo',
  },
  {
    id: '3311060013',
    districtId: '3311060',
    name: 'Sugihan',
  },
  {
    id: '3311060014',
    districtId: '3311060',
    name: 'Gentan',
  },
  {
    id: '3311070001',
    districtId: '3311070',
    name: 'Pranan',
  },
  {
    id: '3311070003',
    districtId: '3311070',
    name: 'Karangwuni',
  },
  {
    id: '3311070004',
    districtId: '3311070',
    name: 'Ngombakan',
  },
  {
    id: '3311070005',
    districtId: '3311070',
    name: 'Bakalan',
  },
  {
    id: '3311070006',
    districtId: '3311070',
    name: 'Godog',
  },
  {
    id: '3311070007',
    districtId: '3311070',
    name: 'Kemasan',
  },
  {
    id: '3311070008',
    districtId: '3311070',
    name: 'Kenokorejo',
  },
  {
    id: '3311070009',
    districtId: '3311070',
    name: 'Tepisari',
  },
  {
    id: '3311070011',
    districtId: '3311070',
    name: 'Rejosari',
  },
  {
    id: '3311070012',
    districtId: '3311070',
    name: 'Polokarto',
  },
  {
    id: '3311070013',
    districtId: '3311070',
    name: 'Mranggen',
  },
  {
    id: '3311070014',
    districtId: '3311070',
    name: 'Wonorejo',
  },
  {
    id: '3311070015',
    districtId: '3311070',
    name: 'Jatisobo',
  },
  {
    id: '3311070016',
    districtId: '3311070',
    name: 'Kayuapak',
  },
  {
    id: '3311070017',
    districtId: '3311070',
    name: 'Genengsari',
  },
  {
    id: '3311080001',
    districtId: '3311080',
    name: 'Tegalmade',
  },
  {
    id: '3311080002',
    districtId: '3311080',
    name: 'Laban',
  },
  {
    id: '3311080003',
    districtId: '3311080',
    name: 'Wirun',
  },
  {
    id: '3311080004',
    districtId: '3311080',
    name: 'Bekonang',
  },
  {
    id: '3311080005',
    districtId: '3311080',
    name: 'Cangkol',
  },
  {
    id: '3311080006',
    districtId: '3311080',
    name: 'Klumprit',
  },
  {
    id: '3311080007',
    districtId: '3311080',
    name: 'Kragilan',
  },
  {
    id: '3311080008',
    districtId: '3311080',
    name: 'Sapen',
  },
  {
    id: '3311080009',
    districtId: '3311080',
    name: 'Triyagan',
  },
  {
    id: '3311080010',
    districtId: '3311080',
    name: 'Joho',
  },
  {
    id: '3311080011',
    districtId: '3311080',
    name: 'Demakan',
  },
  {
    id: '3311080013',
    districtId: '3311080',
    name: 'Plumbon',
  },
  {
    id: '3311080014',
    districtId: '3311080',
    name: 'Gadingan',
  },
  {
    id: '3311080015',
    districtId: '3311080',
    name: 'Palur',
  },
  {
    id: '3311090001',
    districtId: '3311090',
    name: 'Pondok',
  },
  {
    id: '3311090002',
    districtId: '3311090',
    name: 'Parangjoro',
  },
  {
    id: '3311090003',
    districtId: '3311090',
    name: 'Pandeyan',
  },
  {
    id: '3311090004',
    districtId: '3311090',
    name: 'Telukan',
  },
  {
    id: '3311090005',
    districtId: '3311090',
    name: 'Kadokan',
  },
  {
    id: '3311090006',
    districtId: '3311090',
    name: 'Grogol',
  },
  {
    id: '3311090007',
    districtId: '3311090',
    name: 'Madegondo',
  },
  {
    id: '3311090008',
    districtId: '3311090',
    name: 'Langenharjo',
  },
  {
    id: '3311090009',
    districtId: '3311090',
    name: 'Gedangan',
  },
  {
    id: '3311090010',
    districtId: '3311090',
    name: 'Kwarasan',
  },
  {
    id: '3311090011',
    districtId: '3311090',
    name: 'Sanggrahan',
  },
  {
    id: '3311090012',
    districtId: '3311090',
    name: 'Manang',
  },
  {
    id: '3311090013',
    districtId: '3311090',
    name: 'Banaran',
  },
  {
    id: '3311090014',
    districtId: '3311090',
    name: 'Cemani',
  },
  {
    id: '3311100001',
    districtId: '3311100',
    name: 'Ngrombo',
  },
  {
    id: '3311100002',
    districtId: '3311100',
    name: 'Mancasan',
  },
  {
    id: '3311100003',
    districtId: '3311100',
    name: 'Gedongan',
  },
  {
    id: '3311100004',
    districtId: '3311100',
    name: 'Jetis',
  },
  {
    id: '3311100005',
    districtId: '3311100',
    name: 'Bentakan',
  },
  {
    id: '3311100007',
    districtId: '3311100',
    name: 'Kadilangu',
  },
  {
    id: '3311100008',
    districtId: '3311100',
    name: 'Bakipandeyan',
  },
  {
    id: '3311100009',
    districtId: '3311100',
    name: 'Menuran',
  },
  {
    id: '3311100011',
    districtId: '3311100',
    name: 'Siwal',
  },
  {
    id: '3311100012',
    districtId: '3311100',
    name: 'Waru',
  },
  {
    id: '3311100013',
    districtId: '3311100',
    name: 'Gentan',
  },
  {
    id: '3311100014',
    districtId: '3311100',
    name: 'Purbayan',
  },
  {
    id: '3311110001',
    districtId: '3311110',
    name: 'Sanggung',
  },
  {
    id: '3311110002',
    districtId: '3311110',
    name: 'Kagokan',
  },
  {
    id: '3311110003',
    districtId: '3311110',
    name: 'Blimbing',
  },
  {
    id: '3311110004',
    districtId: '3311110',
    name: 'Krajan',
  },
  {
    id: '3311110006',
    districtId: '3311110',
    name: 'Jati',
  },
  {
    id: '3311110007',
    districtId: '3311110',
    name: 'Trosemi',
  },
  {
    id: '3311110008',
    districtId: '3311110',
    name: 'Luwang',
  },
  {
    id: '3311110009',
    districtId: '3311110',
    name: 'Klaseman',
  },
  {
    id: '3311110011',
    districtId: '3311110',
    name: 'Sraten',
  },
  {
    id: '3311110012',
    districtId: '3311110',
    name: 'Wironanggan',
  },
  {
    id: '3311110013',
    districtId: '3311110',
    name: 'Trangsan',
  },
  {
    id: '3311110014',
    districtId: '3311110',
    name: 'Mayang',
  },
  {
    id: '3311120001',
    districtId: '3311120',
    name: 'Ngemplak',
  },
  {
    id: '3311120002',
    districtId: '3311120',
    name: 'Gumpang',
  },
  {
    id: '3311120003',
    districtId: '3311120',
    name: 'Makamhaji',
  },
  {
    id: '3311120004',
    districtId: '3311120',
    name: 'Pabelan',
  },
  {
    id: '3311120005',
    districtId: '3311120',
    name: 'Ngadirejo',
  },
  {
    id: '3311120006',
    districtId: '3311120',
    name: 'Kartasura',
  },
  {
    id: '3311120007',
    districtId: '3311120',
    name: 'Pucangan',
  },
  {
    id: '3311120008',
    districtId: '3311120',
    name: 'Kertonatan',
  },
  {
    id: '3311120009',
    districtId: '3311120',
    name: 'Wirogunan',
  },
  {
    id: '3311120010',
    districtId: '3311120',
    name: 'Ngabeyan',
  },
  {
    id: '3311120011',
    districtId: '3311120',
    name: 'Singopuran',
  },
  {
    id: '3311120012',
    districtId: '3311120',
    name: 'Gonilan',
  },
  {
    id: '3312010001',
    districtId: '3312010',
    name: 'Sumberagung',
  },
  {
    id: '3312010002',
    districtId: '3312010',
    name: 'Petirsari',
  },
  {
    id: '3312010003',
    districtId: '3312010',
    name: 'Joho',
  },
  {
    id: '3312010004',
    districtId: '3312010',
    name: 'Gambirmanis',
  },
  {
    id: '3312010005',
    districtId: '3312010',
    name: 'Watangrejo',
  },
  {
    id: '3312010006',
    districtId: '3312010',
    name: 'Suci',
  },
  {
    id: '3312010007',
    districtId: '3312010',
    name: 'Jimbar',
  },
  {
    id: '3312010008',
    districtId: '3312010',
    name: 'Sambiroto',
  },
  {
    id: '3312010009',
    districtId: '3312010',
    name: 'Pracimantoro',
  },
  {
    id: '3312010010',
    districtId: '3312010',
    name: 'Gedong',
  },
  {
    id: '3312010011',
    districtId: '3312010',
    name: 'Gebangharjo',
  },
  {
    id: '3312010012',
    districtId: '3312010',
    name: 'Sedayu',
  },
  {
    id: '3312010013',
    districtId: '3312010',
    name: 'Banaran',
  },
  {
    id: '3312010014',
    districtId: '3312010',
    name: 'Trukan',
  },
  {
    id: '3312010015',
    districtId: '3312010',
    name: 'Tubokarto',
  },
  {
    id: '3312010016',
    districtId: '3312010',
    name: 'Lebak',
  },
  {
    id: '3312010017',
    districtId: '3312010',
    name: 'Glinggang',
  },
  {
    id: '3312010018',
    districtId: '3312010',
    name: 'Wonodadi',
  },
  {
    id: '3312020001',
    districtId: '3312020',
    name: 'Paranggupito',
  },
  {
    id: '3312020002',
    districtId: '3312020',
    name: 'Gudangharjo',
  },
  {
    id: '3312020003',
    districtId: '3312020',
    name: 'Gunturharjo',
  },
  {
    id: '3312020004',
    districtId: '3312020',
    name: 'Gendayakan',
  },
  {
    id: '3312020005',
    districtId: '3312020',
    name: 'Sambiharjo',
  },
  {
    id: '3312020006',
    districtId: '3312020',
    name: 'Ketos',
  },
  {
    id: '3312020007',
    districtId: '3312020',
    name: 'Songbledeg',
  },
  {
    id: '3312020008',
    districtId: '3312020',
    name: 'Johunut',
  },
  {
    id: '3312030001',
    districtId: '3312030',
    name: 'Ngargoharjo',
  },
  {
    id: '3312030002',
    districtId: '3312030',
    name: 'Tlogosari',
  },
  {
    id: '3312030003',
    districtId: '3312030',
    name: 'Tlogoharjo',
  },
  {
    id: '3312030004',
    districtId: '3312030',
    name: 'Bayemharjo',
  },
  {
    id: '3312030005',
    districtId: '3312030',
    name: 'Jatirejo',
  },
  {
    id: '3312030006',
    districtId: '3312030',
    name: 'Giritontro',
  },
  {
    id: '3312030007',
    districtId: '3312030',
    name: 'Pucanganom',
  },
  {
    id: '3312040001',
    districtId: '3312040',
    name: 'Tirtosuworo',
  },
  {
    id: '3312040002',
    districtId: '3312040',
    name: 'Girikikis',
  },
  {
    id: '3312040003',
    districtId: '3312040',
    name: 'Guwotirto',
  },
  {
    id: '3312040004',
    districtId: '3312040',
    name: 'Ngancar',
  },
  {
    id: '3312040005',
    districtId: '3312040',
    name: 'Bulurejo',
  },
  {
    id: '3312040006',
    districtId: '3312040',
    name: 'Gedongrejo',
  },
  {
    id: '3312040007',
    districtId: '3312040',
    name: 'Pideksa',
  },
  {
    id: '3312040008',
    districtId: '3312040',
    name: 'Tukulrejo',
  },
  {
    id: '3312040009',
    districtId: '3312040',
    name: 'Bumiharjo',
  },
  {
    id: '3312040010',
    districtId: '3312040',
    name: 'Selomarto',
  },
  {
    id: '3312040011',
    districtId: '3312040',
    name: 'Giriwoyo',
  },
  {
    id: '3312040012',
    districtId: '3312040',
    name: 'Sejati',
  },
  {
    id: '3312040013',
    districtId: '3312040',
    name: 'Sendangagung',
  },
  {
    id: '3312040014',
    districtId: '3312040',
    name: 'Platarejo',
  },
  {
    id: '3312040015',
    districtId: '3312040',
    name: 'Sirnoboyo',
  },
  {
    id: '3312040016',
    districtId: '3312040',
    name: 'Tawangharjo',
  },
  {
    id: '3312050001',
    districtId: '3312050',
    name: 'Selopuro',
  },
  {
    id: '3312050002',
    districtId: '3312050',
    name: 'Sendangsari',
  },
  {
    id: '3312050003',
    districtId: '3312050',
    name: 'Tegiri',
  },
  {
    id: '3312050004',
    districtId: '3312050',
    name: 'Batuwarno',
  },
  {
    id: '3312050005',
    districtId: '3312050',
    name: 'Sumberejo',
  },
  {
    id: '3312050006',
    districtId: '3312050',
    name: 'Ronggojati',
  },
  {
    id: '3312050007',
    districtId: '3312050',
    name: 'Sumberagung',
  },
  {
    id: '3312050008',
    districtId: '3312050',
    name: 'Kudi',
  },
  {
    id: '3312060001',
    districtId: '3312060',
    name: 'Jeblogan',
  },
  {
    id: '3312060002',
    districtId: '3312060',
    name: 'Ngambarsari',
  },
  {
    id: '3312060003',
    districtId: '3312060',
    name: 'Karangtengah',
  },
  {
    id: '3312060004',
    districtId: '3312060',
    name: 'Purwoharjo',
  },
  {
    id: '3312060005',
    districtId: '3312060',
    name: 'Temboro',
  },
  {
    id: '3312070001',
    districtId: '3312070',
    name: 'Hargosari',
  },
  {
    id: '3312070002',
    districtId: '3312070',
    name: 'Dlepih',
  },
  {
    id: '3312070003',
    districtId: '3312070',
    name: 'Wiroko',
  },
  {
    id: '3312070004',
    districtId: '3312070',
    name: 'Sukoharjo',
  },
  {
    id: '3312070005',
    districtId: '3312070',
    name: 'Hargorejo',
  },
  {
    id: '3312070006',
    districtId: '3312070',
    name: 'Sidorejo',
  },
  {
    id: '3312070007',
    districtId: '3312070',
    name: 'Genengharjo',
  },
  {
    id: '3312070008',
    districtId: '3312070',
    name: 'Girirejo',
  },
  {
    id: '3312070009',
    districtId: '3312070',
    name: 'Hargantoro',
  },
  {
    id: '3312070010',
    districtId: '3312070',
    name: 'Tirtomoyo',
  },
  {
    id: '3312070011',
    districtId: '3312070',
    name: 'Banyakprodo',
  },
  {
    id: '3312070012',
    districtId: '3312070',
    name: 'Ngarjosari',
  },
  {
    id: '3312070013',
    districtId: '3312070',
    name: 'Sendangmulyo',
  },
  {
    id: '3312070014',
    districtId: '3312070',
    name: 'Tanjungsari',
  },
  {
    id: '3312080001',
    districtId: '3312080',
    name: 'Kedungrejo',
  },
  {
    id: '3312080002',
    districtId: '3312080',
    name: 'Bulurejo',
  },
  {
    id: '3312080003',
    districtId: '3312080',
    name: 'Kulurejo',
  },
  {
    id: '3312080004',
    districtId: '3312080',
    name: 'Semin',
  },
  {
    id: '3312080005',
    districtId: '3312080',
    name: 'Beji',
  },
  {
    id: '3312080006',
    districtId: '3312080',
    name: 'Wonoharjo',
  },
  {
    id: '3312080007',
    districtId: '3312080',
    name: 'Bumiharjo',
  },
  {
    id: '3312080008',
    districtId: '3312080',
    name: 'Gebang',
  },
  {
    id: '3312080009',
    districtId: '3312080',
    name: 'Pondoksari',
  },
  {
    id: '3312080010',
    districtId: '3312080',
    name: 'Ngadiroyo',
  },
  {
    id: '3312080011',
    districtId: '3312080',
    name: 'Ngadipiro',
  },
  {
    id: '3312090001',
    districtId: '3312090',
    name: 'Glesungrejo',
  },
  {
    id: '3312090002',
    districtId: '3312090',
    name: 'Gambiranom',
  },
  {
    id: '3312090003',
    districtId: '3312090',
    name: 'Balepanjang',
  },
  {
    id: '3312090004',
    districtId: '3312090',
    name: 'Watuagung',
  },
  {
    id: '3312090005',
    districtId: '3312090',
    name: 'Baturetno',
  },
  {
    id: '3312090006',
    districtId: '3312090',
    name: 'Belikurip',
  },
  {
    id: '3312090007',
    districtId: '3312090',
    name: 'Temon',
  },
  {
    id: '3312090008',
    districtId: '3312090',
    name: 'Saradan',
  },
  {
    id: '3312090009',
    districtId: '3312090',
    name: 'Talunombo',
  },
  {
    id: '3312090010',
    districtId: '3312090',
    name: 'Sendangrejo',
  },
  {
    id: '3312090011',
    districtId: '3312090',
    name: 'Boto',
  },
  {
    id: '3312090012',
    districtId: '3312090',
    name: 'Kedungombo',
  },
  {
    id: '3312090013',
    districtId: '3312090',
    name: 'Setrorejo',
  },
  {
    id: '3312100001',
    districtId: '3312100',
    name: 'Basuhan',
  },
  {
    id: '3312100003',
    districtId: '3312100',
    name: 'Sindukarta',
  },
  {
    id: '3312100004',
    districtId: '3312100',
    name: 'Panekan',
  },
  {
    id: '3312100005',
    districtId: '3312100',
    name: 'Baleharjo',
  },
  {
    id: '3312100006',
    districtId: '3312100',
    name: 'Minggarharjo',
  },
  {
    id: '3312100007',
    districtId: '3312100',
    name: 'Tegalharjo',
  },
  {
    id: '3312100008',
    districtId: '3312100',
    name: 'Ngadirejo',
  },
  {
    id: '3312100009',
    districtId: '3312100',
    name: 'Sumberharjo',
  },
  {
    id: '3312100010',
    districtId: '3312100',
    name: 'Puloharjo',
  },
  {
    id: '3312100011',
    districtId: '3312100',
    name: 'Eromoko',
  },
  {
    id: '3312100012',
    districtId: '3312100',
    name: 'Pasekan',
  },
  {
    id: '3312100013',
    districtId: '3312100',
    name: 'Ngandong',
  },
  {
    id: '3312100014',
    districtId: '3312100',
    name: 'Tempurharjo',
  },
  {
    id: '3312100015',
    districtId: '3312100',
    name: 'Ngunggahan',
  },
  {
    id: '3312110001',
    districtId: '3312110',
    name: 'Genukharjo',
  },
  {
    id: '3312110002',
    districtId: '3312110',
    name: 'Sumberejo',
  },
  {
    id: '3312110003',
    districtId: '3312110',
    name: 'Mojopura',
  },
  {
    id: '3312110004',
    districtId: '3312110',
    name: 'Wuryantoro',
  },
  {
    id: '3312110005',
    districtId: '3312110',
    name: 'Mlopoharjo',
  },
  {
    id: '3312110006',
    districtId: '3312110',
    name: 'Pulutankulon',
  },
  {
    id: '3312110007',
    districtId: '3312110',
    name: 'Pulutanwetan',
  },
  {
    id: '3312110008',
    districtId: '3312110',
    name: 'Gumiwanglor',
  },
  {
    id: '3312120001',
    districtId: '3312120',
    name: 'Kepuhsari',
  },
  {
    id: '3312120002',
    districtId: '3312120',
    name: 'Pijiharjo',
  },
  {
    id: '3312120003',
    districtId: '3312120',
    name: 'Bero',
  },
  {
    id: '3312120004',
    districtId: '3312120',
    name: 'Gunungan',
  },
  {
    id: '3312120005',
    districtId: '3312120',
    name: 'Karanglor',
  },
  {
    id: '3312120006',
    districtId: '3312120',
    name: 'Pagutan',
  },
  {
    id: '3312120007',
    districtId: '3312120',
    name: 'Punduhsari',
  },
  {
    id: '3312130001',
    districtId: '3312130',
    name: 'Kepatihan',
  },
  {
    id: '3312130002',
    districtId: '3312130',
    name: 'Keloran',
  },
  {
    id: '3312130003',
    districtId: '3312130',
    name: 'Pare',
  },
  {
    id: '3312130004',
    districtId: '3312130',
    name: 'Singodutan',
  },
  {
    id: '3312130005',
    districtId: '3312130',
    name: 'Kaliancar',
  },
  {
    id: '3312130006',
    districtId: '3312130',
    name: 'Jendi',
  },
  {
    id: '3312130008',
    districtId: '3312130',
    name: 'Jaten',
  },
  {
    id: '3312130009',
    districtId: '3312130',
    name: 'Gemantar',
  },
  {
    id: '3312130010',
    districtId: '3312130',
    name: 'Nambangan',
  },
  {
    id: '3312130011',
    districtId: '3312130',
    name: 'Sendangijo',
  },
  {
    id: '3312140001',
    districtId: '3312140',
    name: 'Sendang',
  },
  {
    id: '3312140002',
    districtId: '3312140',
    name: 'Wuryorejo',
  },
  {
    id: '3312140003',
    districtId: '3312140',
    name: 'Pokohkidul',
  },
  {
    id: '3312140004',
    districtId: '3312140',
    name: 'Purworejo',
  },
  {
    id: '3312140006',
    districtId: '3312140',
    name: 'Wonoboyo',
  },
  {
    id: '3312140007',
    districtId: '3312140',
    name: 'Giripurwo',
  },
  {
    id: '3312140008',
    districtId: '3312140',
    name: 'Giritirto',
  },
  {
    id: '3312140009',
    districtId: '3312140',
    name: 'Giriwono',
  },
  {
    id: '3312140010',
    districtId: '3312140',
    name: 'Wonokarto',
  },
  {
    id: '3312140011',
    districtId: '3312140',
    name: 'Purwosari',
  },
  {
    id: '3312140012',
    districtId: '3312140',
    name: 'Manjung',
  },
  {
    id: '3312140013',
    districtId: '3312140',
    name: 'Sonoharjo',
  },
  {
    id: '3312140014',
    districtId: '3312140',
    name: 'Wonokerto',
  },
  {
    id: '3312140015',
    districtId: '3312140',
    name: 'Wonoharjo',
  },
  {
    id: '3312150001',
    districtId: '3312150',
    name: 'Gedong',
  },
  {
    id: '3312150002',
    districtId: '3312150',
    name: 'Gemawang',
  },
  {
    id: '3312150003',
    districtId: '3312150',
    name: 'Kerjokidul',
  },
  {
    id: '3312150004',
    districtId: '3312150',
    name: 'Kerjolor',
  },
  {
    id: '3312150005',
    districtId: '3312150',
    name: 'Pondok',
  },
  {
    id: '3312150006',
    districtId: '3312150',
    name: 'Ngadirojokidul',
  },
  {
    id: '3312150007',
    districtId: '3312150',
    name: 'Mlokomaniswetan',
  },
  {
    id: '3312150008',
    districtId: '3312150',
    name: 'Ngadirojolor',
  },
  {
    id: '3312150009',
    districtId: '3312150',
    name: 'Mlokomaniskulon',
  },
  {
    id: '3312150010',
    districtId: '3312150',
    name: 'Jatimarto',
  },
  {
    id: '3312150011',
    districtId: '3312150',
    name: 'Kasihan',
  },
  {
    id: '3312160001',
    districtId: '3312160',
    name: 'Sembukan',
  },
  {
    id: '3312160003',
    districtId: '3312160',
    name: 'Tempursari',
  },
  {
    id: '3312160004',
    districtId: '3312160',
    name: 'Widoro',
  },
  {
    id: '3312160005',
    districtId: '3312160',
    name: 'Kebonagung',
  },
  {
    id: '3312160006',
    districtId: '3312160',
    name: 'Ngabeyan',
  },
  {
    id: '3312160007',
    districtId: '3312160',
    name: 'Mojoreno',
  },
  {
    id: '3312160009',
    districtId: '3312160',
    name: 'Kayuloko',
  },
  {
    id: '3312160010',
    districtId: '3312160',
    name: 'Kedunggupit',
  },
  {
    id: '3312160011',
    districtId: '3312160',
    name: 'Sidoharjo',
  },
  {
    id: '3312160012',
    districtId: '3312160',
    name: 'Jatinom',
  },
  {
    id: '3312170001',
    districtId: '3312170',
    name: 'Pingkuk',
  },
  {
    id: '3312170002',
    districtId: '3312170',
    name: 'Ngelo',
  },
  {
    id: '3312170003',
    districtId: '3312170',
    name: 'Dawungan',
  },
  {
    id: '3312170004',
    districtId: '3312170',
    name: 'Brenggolo',
  },
  {
    id: '3312170005',
    districtId: '3312170',
    name: 'Boto',
  },
  {
    id: '3312170006',
    districtId: '3312170',
    name: 'Guno',
  },
  {
    id: '3312170007',
    districtId: '3312170',
    name: 'Pengkol',
  },
  {
    id: '3312170008',
    districtId: '3312170',
    name: 'Cangkring',
  },
  {
    id: '3312170009',
    districtId: '3312170',
    name: 'Sanggrong',
  },
  {
    id: '3312170010',
    districtId: '3312170',
    name: 'Pesido',
  },
  {
    id: '3312170011',
    districtId: '3312170',
    name: 'Mojopura',
  },
  {
    id: '3312170012',
    districtId: '3312170',
    name: 'Jatirejo',
  },
  {
    id: '3312170013',
    districtId: '3312170',
    name: 'Jatiroto',
  },
  {
    id: '3312170015',
    districtId: '3312170',
    name: 'Sugihan',
  },
  {
    id: '3312180001',
    districtId: '3312180',
    name: 'Bugelan',
  },
  {
    id: '3312180002',
    districtId: '3312180',
    name: 'Plosorejo',
  },
  {
    id: '3312180004',
    districtId: '3312180',
    name: 'Miri',
  },
  {
    id: '3312180005',
    districtId: '3312180',
    name: 'Lemahbang',
  },
  {
    id: '3312180006',
    districtId: '3312180',
    name: 'Gesing',
  },
  {
    id: '3312180007',
    districtId: '3312180',
    name: 'Kismantoro',
  },
  {
    id: '3312180008',
    districtId: '3312180',
    name: 'Ngroto',
  },
  {
    id: '3312180009',
    districtId: '3312180',
    name: 'Gedawung',
  },
  {
    id: '3312180010',
    districtId: '3312180',
    name: 'Gambiranom',
  },
  {
    id: '3312190002',
    districtId: '3312190',
    name: 'Bangsri',
  },
  {
    id: '3312190003',
    districtId: '3312190',
    name: 'Tegalrejo',
  },
  {
    id: '3312190004',
    districtId: '3312190',
    name: 'Biting',
  },
  {
    id: '3312190005',
    districtId: '3312190',
    name: 'Kepyar',
  },
  {
    id: '3312190006',
    districtId: '3312190',
    name: 'Purwantoro',
  },
  {
    id: '3312190007',
    districtId: '3312190',
    name: 'Miricinde',
  },
  {
    id: '3312190008',
    districtId: '3312190',
    name: 'Joho',
  },
  {
    id: '3312190009',
    districtId: '3312190',
    name: 'Sukomangu',
  },
  {
    id: '3312190010',
    districtId: '3312190',
    name: 'Talesan',
  },
  {
    id: '3312190011',
    districtId: '3312190',
    name: 'Sendang',
  },
  {
    id: '3312190013',
    districtId: '3312190',
    name: 'Ploso',
  },
  {
    id: '3312190014',
    districtId: '3312190',
    name: 'Gondang',
  },
  {
    id: '3312190015',
    districtId: '3312190',
    name: 'Bakalan',
  },
  {
    id: '3312200001',
    districtId: '3312200',
    name: 'Domas',
  },
  {
    id: '3312200002',
    districtId: '3312200',
    name: 'Nadi',
  },
  {
    id: '3312200003',
    districtId: '3312200',
    name: 'Ngaglik',
  },
  {
    id: '3312200004',
    districtId: '3312200',
    name: 'Bulurejo',
  },
  {
    id: '3312200010',
    districtId: '3312200',
    name: 'Bulukerto',
  },
  {
    id: '3312200011',
    districtId: '3312200',
    name: 'Krandegan',
  },
  {
    id: '3312200012',
    districtId: '3312200',
    name: 'Tanjung',
  },
  {
    id: '3312200013',
    districtId: '3312200',
    name: 'Sugihan',
  },
  {
    id: '3312200014',
    districtId: '3312200',
    name: 'Conto',
  },
  {
    id: '3312201002',
    districtId: '3312201',
    name: 'Giriharjo',
  },
  {
    id: '3312201004',
    districtId: '3312201',
    name: 'Sukorejo',
  },
  {
    id: '3312201006',
    districtId: '3312201',
    name: 'Golo',
  },
  {
    id: '3312210001',
    districtId: '3312210',
    name: 'Padarangin',
  },
  {
    id: '3312210002',
    districtId: '3312210',
    name: 'Watusomo',
  },
  {
    id: '3312210003',
    districtId: '3312210',
    name: 'Pandan',
  },
  {
    id: '3312210004',
    districtId: '3312210',
    name: 'Sambirejo',
  },
  {
    id: '3312210005',
    districtId: '3312210',
    name: 'Made',
  },
  {
    id: '3312210007',
    districtId: '3312210',
    name: 'Waru',
  },
  {
    id: '3312210008',
    districtId: '3312210',
    name: 'Bulusari',
  },
  {
    id: '3312210009',
    districtId: '3312210',
    name: 'Slogohimo',
  },
  {
    id: '3312210010',
    districtId: '3312210',
    name: 'Gunan',
  },
  {
    id: '3312210011',
    districtId: '3312210',
    name: 'Sedayu',
  },
  {
    id: '3312210012',
    districtId: '3312210',
    name: 'Soco',
  },
  {
    id: '3312210014',
    districtId: '3312210',
    name: 'Randusari',
  },
  {
    id: '3312210015',
    districtId: '3312210',
    name: 'Karang',
  },
  {
    id: '3312210016',
    districtId: '3312210',
    name: 'Sokoboyo',
  },
  {
    id: '3312220001',
    districtId: '3312220',
    name: 'Tasikhargo',
  },
  {
    id: '3312220002',
    districtId: '3312220',
    name: 'Sumberejo',
  },
  {
    id: '3312220003',
    districtId: '3312220',
    name: 'Rejosari',
  },
  {
    id: '3312220004',
    districtId: '3312220',
    name: 'Gondangsari',
  },
  {
    id: '3312220005',
    districtId: '3312220',
    name: 'Sidorejo',
  },
  {
    id: '3312220006',
    districtId: '3312220',
    name: 'Ngrompak',
  },
  {
    id: '3312220010',
    districtId: '3312220',
    name: 'Sambirejo',
  },
  {
    id: '3312220011',
    districtId: '3312220',
    name: 'Gunungsari',
  },
  {
    id: '3312220012',
    districtId: '3312220',
    name: 'Jatisari',
  },
  {
    id: '3312220013',
    districtId: '3312220',
    name: 'Pandeyan',
  },
  {
    id: '3312220014',
    districtId: '3312220',
    name: 'Watangsono',
  },
  {
    id: '3312220015',
    districtId: '3312220',
    name: 'Jatisrono',
  },
  {
    id: '3312220016',
    districtId: '3312220',
    name: 'Tanjungsari',
  },
  {
    id: '3312220017',
    districtId: '3312220',
    name: 'Tanggulangin',
  },
  {
    id: '3312230001',
    districtId: '3312230',
    name: 'Giriyoso',
  },
  {
    id: '3312230002',
    districtId: '3312230',
    name: 'Kopen',
  },
  {
    id: '3312230003',
    districtId: '3312230',
    name: 'Jatipurno',
  },
  {
    id: '3312230004',
    districtId: '3312230',
    name: 'Tawangrejo',
  },
  {
    id: '3312230005',
    districtId: '3312230',
    name: 'Jatipurwo',
  },
  {
    id: '3312230006',
    districtId: '3312230',
    name: 'Slogoretno',
  },
  {
    id: '3312230007',
    districtId: '3312230',
    name: 'Kembang',
  },
  {
    id: '3312230008',
    districtId: '3312230',
    name: 'Girimulyo',
  },
  {
    id: '3312230009',
    districtId: '3312230',
    name: 'Balepanjang',
  },
  {
    id: '3312230010',
    districtId: '3312230',
    name: 'Jeporo',
  },
  {
    id: '3312230011',
    districtId: '3312230',
    name: 'Mangunharjo',
  },
  {
    id: '3312240001',
    districtId: '3312240',
    name: 'Waleng',
  },
  {
    id: '3312240002',
    districtId: '3312240',
    name: 'Doho',
  },
  {
    id: '3312240003',
    districtId: '3312240',
    name: 'Sidokerto',
  },
  {
    id: '3312240004',
    districtId: '3312240',
    name: 'Girimarto',
  },
  {
    id: '3312240005',
    districtId: '3312240',
    name: 'Jendi',
  },
  {
    id: '3312240006',
    districtId: '3312240',
    name: 'Nungkulan',
  },
  {
    id: '3312240007',
    districtId: '3312240',
    name: 'Gemawang',
  },
  {
    id: '3312240008',
    districtId: '3312240',
    name: 'Tambakmerang',
  },
  {
    id: '3312240009',
    districtId: '3312240',
    name: 'Selorejo',
  },
  {
    id: '3312240010',
    districtId: '3312240',
    name: 'Jatirejo',
  },
  {
    id: '3312240011',
    districtId: '3312240',
    name: 'Giriwarno',
  },
  {
    id: '3312240012',
    districtId: '3312240',
    name: 'Sanan',
  },
  {
    id: '3312240013',
    districtId: '3312240',
    name: 'Semagarduwur',
  },
  {
    id: '3312240014',
    districtId: '3312240',
    name: 'Bubakan',
  },
  {
    id: '3313010001',
    districtId: '3313010',
    name: 'Ngepungsari',
  },
  {
    id: '3313010002',
    districtId: '3313010',
    name: 'Jatipurwo',
  },
  {
    id: '3313010003',
    districtId: '3313010',
    name: 'Jatipuro',
  },
  {
    id: '3313010004',
    districtId: '3313010',
    name: 'Jatisobo',
  },
  {
    id: '3313010005',
    districtId: '3313010',
    name: 'Jatiwarno',
  },
  {
    id: '3313010006',
    districtId: '3313010',
    name: 'Jatimulyo',
  },
  {
    id: '3313010007',
    districtId: '3313010',
    name: 'Jatisuko',
  },
  {
    id: '3313010008',
    districtId: '3313010',
    name: 'Jatiharjo',
  },
  {
    id: '3313010009',
    districtId: '3313010',
    name: 'Jatikuwung',
  },
  {
    id: '3313010010',
    districtId: '3313010',
    name: 'Jatiroyo',
  },
  {
    id: '3313020001',
    districtId: '3313020',
    name: 'Jatisawit',
  },
  {
    id: '3313020003',
    districtId: '3313020',
    name: 'Wonokeling',
  },
  {
    id: '3313020004',
    districtId: '3313020',
    name: 'Jatiyoso',
  },
  {
    id: '3313020005',
    districtId: '3313020',
    name: 'Tlobo',
  },
  {
    id: '3313020006',
    districtId: '3313020',
    name: 'Wonorejo',
  },
  {
    id: '3313020008',
    districtId: '3313020',
    name: 'Karangsari',
  },
  {
    id: '3313020009',
    districtId: '3313020',
    name: 'Wukirsawit',
  },
  {
    id: '3313030001',
    districtId: '3313030',
    name: 'Paseban',
  },
  {
    id: '3313030002',
    districtId: '3313030',
    name: 'Lemahbang',
  },
  {
    id: '3313030003',
    districtId: '3313030',
    name: 'Karangbangun',
  },
  {
    id: '3313030004',
    districtId: '3313030',
    name: 'Ploso',
  },
  {
    id: '3313030005',
    districtId: '3313030',
    name: 'Giriwondo',
  },
  {
    id: '3313030006',
    districtId: '3313030',
    name: 'Kadipiro',
  },
  {
    id: '3313030007',
    districtId: '3313030',
    name: 'Jumantoro',
  },
  {
    id: '3313030008',
    districtId: '3313030',
    name: 'Kedawung',
  },
  {
    id: '3313030009',
    districtId: '3313030',
    name: 'Bakalan',
  },
  {
    id: '3313030010',
    districtId: '3313030',
    name: 'Jumapolo',
  },
  {
    id: '3313030011',
    districtId: '3313030',
    name: 'Kwangsan',
  },
  {
    id: '3313030012',
    districtId: '3313030',
    name: 'Jatirejo',
  },
  {
    id: '3313040001',
    districtId: '3313040',
    name: 'Sedayu',
  },
  {
    id: '3313040002',
    districtId: '3313040',
    name: 'Kebak',
  },
  {
    id: '3313040003',
    districtId: '3313040',
    name: 'Gemantar',
  },
  {
    id: '3313040004',
    districtId: '3313040',
    name: 'Tunggulrejo',
  },
  {
    id: '3313040005',
    districtId: '3313040',
    name: 'Genengan',
  },
  {
    id: '3313040008',
    districtId: '3313040',
    name: 'Sukosari',
  },
  {
    id: '3313040009',
    districtId: '3313040',
    name: 'Sambirejo',
  },
  {
    id: '3313040010',
    districtId: '3313040',
    name: 'Blorong',
  },
  {
    id: '3313040011',
    districtId: '3313040',
    name: 'Sringin',
  },
  {
    id: '3313050001',
    districtId: '3313050',
    name: 'Ngadiluwih',
  },
  {
    id: '3313050002',
    districtId: '3313050',
    name: 'Dawung',
  },
  {
    id: '3313050003',
    districtId: '3313050',
    name: 'Matesih',
  },
  {
    id: '3313050004',
    districtId: '3313050',
    name: 'Karangbangun',
  },
  {
    id: '3313050005',
    districtId: '3313050',
    name: 'Koripan',
  },
  {
    id: '3313050006',
    districtId: '3313050',
    name: 'Girilayu',
  },
  {
    id: '3313050007',
    districtId: '3313050',
    name: 'Pablengan',
  },
  {
    id: '3313050008',
    districtId: '3313050',
    name: 'Plosorejo',
  },
  {
    id: '3313050009',
    districtId: '3313050',
    name: 'Gantiwarno',
  },
  {
    id: '3313060001',
    districtId: '3313060',
    name: 'Bandardawung',
  },
  {
    id: '3313060002',
    districtId: '3313060',
    name: 'Sepanjang',
  },
  {
    id: '3313060003',
    districtId: '3313060',
    name: 'Tawangmangu',
  },
  {
    id: '3313060004',
    districtId: '3313060',
    name: 'Kalisoro',
  },
  {
    id: '3313060005',
    districtId: '3313060',
    name: 'Blumbang',
  },
  {
    id: '3313060006',
    districtId: '3313060',
    name: 'Gondosuli',
  },
  {
    id: '3313060007',
    districtId: '3313060',
    name: 'Tengklik',
  },
  {
    id: '3313060008',
    districtId: '3313060',
    name: 'Nglebak',
  },
  {
    id: '3313060009',
    districtId: '3313060',
    name: 'Karanglo',
  },
  {
    id: '3313060010',
    districtId: '3313060',
    name: 'Plumbon',
  },
  {
    id: '3313070001',
    districtId: '3313070',
    name: 'Puntukrejo',
  },
  {
    id: '3313070002',
    districtId: '3313070',
    name: 'Berjo',
  },
  {
    id: '3313070003',
    districtId: '3313070',
    name: 'Girimulyo',
  },
  {
    id: '3313070004',
    districtId: '3313070',
    name: 'Segorogunung',
  },
  {
    id: '3313070005',
    districtId: '3313070',
    name: 'Kemuning',
  },
  {
    id: '3313070006',
    districtId: '3313070',
    name: 'Nglegok',
  },
  {
    id: '3313070008',
    districtId: '3313070',
    name: 'Jatirejo',
  },
  {
    id: '3313070009',
    districtId: '3313070',
    name: 'Ngargoyoso',
  },
  {
    id: '3313080001',
    districtId: '3313080',
    name: 'Bangsri',
  },
  {
    id: '3313080002',
    districtId: '3313080',
    name: 'Ngemplak',
  },
  {
    id: '3313080003',
    districtId: '3313080',
    name: 'Doplang',
  },
  {
    id: '3313080005',
    districtId: '3313080',
    name: 'Karang',
  },
  {
    id: '3313080006',
    districtId: '3313080',
    name: 'Salam',
  },
  {
    id: '3313080007',
    districtId: '3313080',
    name: 'Karangpandan',
  },
  {
    id: '3313080008',
    districtId: '3313080',
    name: 'Tohkuning',
  },
  {
    id: '3313080009',
    districtId: '3313080',
    name: 'Gondangmanis',
  },
  {
    id: '3313080010',
    districtId: '3313080',
    name: 'Dayu',
  },
  {
    id: '3313080011',
    districtId: '3313080',
    name: 'Harjosari',
  },
  {
    id: '3313090001',
    districtId: '3313090',
    name: 'Lalung',
  },
  {
    id: '3313090002',
    districtId: '3313090',
    name: 'Bolong',
  },
  {
    id: '3313090003',
    districtId: '3313090',
    name: 'Jantiharjo',
  },
  {
    id: '3313090004',
    districtId: '3313090',
    name: 'Tegalgede',
  },
  {
    id: '3313090006',
    districtId: '3313090',
    name: 'Cangakan',
  },
  {
    id: '3313090007',
    districtId: '3313090',
    name: 'Karanganyar',
  },
  {
    id: '3313090009',
    districtId: '3313090',
    name: 'Popongan',
  },
  {
    id: '3313090010',
    districtId: '3313090',
    name: 'Gayamdompo',
  },
  {
    id: '3313090011',
    districtId: '3313090',
    name: 'Delingan',
  },
  {
    id: '3313090012',
    districtId: '3313090',
    name: 'Gedong',
  },
  {
    id: '3313100001',
    districtId: '3313100',
    name: 'Buran',
  },
  {
    id: '3313100002',
    districtId: '3313100',
    name: 'Papahan',
  },
  {
    id: '3313100003',
    districtId: '3313100',
    name: 'Ngijo',
  },
  {
    id: '3313100004',
    districtId: '3313100',
    name: 'Gaum',
  },
  {
    id: '3313100006',
    districtId: '3313100',
    name: 'Pandeyan',
  },
  {
    id: '3313100007',
    districtId: '3313100',
    name: 'Karangmojo',
  },
  {
    id: '3313100008',
    districtId: '3313100',
    name: 'Kaling',
  },
  {
    id: '3313100009',
    districtId: '3313100',
    name: 'Wonolopo',
  },
  {
    id: '3313100010',
    districtId: '3313100',
    name: 'Kalijirak',
  },
  {
    id: '3313110001',
    districtId: '3313110',
    name: 'Suruhkalang',
  },
  {
    id: '3313110002',
    districtId: '3313110',
    name: 'Jati',
  },
  {
    id: '3313110003',
    districtId: '3313110',
    name: 'Jaten',
  },
  {
    id: '3313110004',
    districtId: '3313110',
    name: 'Dagen',
  },
  {
    id: '3313110005',
    districtId: '3313110',
    name: 'Ngringo',
  },
  {
    id: '3313110006',
    districtId: '3313110',
    name: 'Jetis',
  },
  {
    id: '3313110007',
    districtId: '3313110',
    name: 'Sroyo',
  },
  {
    id: '3313120001',
    districtId: '3313120',
    name: 'Ngasem',
  },
  {
    id: '3313120002',
    districtId: '3313120',
    name: 'Bolon',
  },
  {
    id: '3313120003',
    districtId: '3313120',
    name: 'Malangjiwan',
  },
  {
    id: '3313120004',
    districtId: '3313120',
    name: 'Paulan',
  },
  {
    id: '3313120005',
    districtId: '3313120',
    name: 'Gajahan',
  },
  {
    id: '3313120006',
    districtId: '3313120',
    name: 'Blulukan',
  },
  {
    id: '3313120007',
    districtId: '3313120',
    name: 'Gawanan',
  },
  {
    id: '3313120008',
    districtId: '3313120',
    name: 'Gedongan',
  },
  {
    id: '3313120009',
    districtId: '3313120',
    name: 'Tohudan',
  },
  {
    id: '3313120010',
    districtId: '3313120',
    name: 'Baturan',
  },
  {
    id: '3313120011',
    districtId: '3313120',
    name: 'Klodran',
  },
  {
    id: '3313130001',
    districtId: '3313130',
    name: 'Wonorejo',
  },
  {
    id: '3313130002',
    districtId: '3313130',
    name: 'Plesungan',
  },
  {
    id: '3313130003',
    districtId: '3313130',
    name: 'Jatikuwung',
  },
  {
    id: '3313130004',
    districtId: '3313130',
    name: 'Selokaton',
  },
  {
    id: '3313130005',
    districtId: '3313130',
    name: 'Bulurejo',
  },
  {
    id: '3313130006',
    districtId: '3313130',
    name: 'Rejosari',
  },
  {
    id: '3313130007',
    districtId: '3313130',
    name: 'Jeruksawit',
  },
  {
    id: '3313130008',
    districtId: '3313130',
    name: 'Karangturi',
  },
  {
    id: '3313130009',
    districtId: '3313130',
    name: 'Kragan',
  },
  {
    id: '3313130010',
    districtId: '3313130',
    name: 'Wonosari',
  },
  {
    id: '3313130011',
    districtId: '3313130',
    name: 'Dayu',
  },
  {
    id: '3313130012',
    districtId: '3313130',
    name: 'Tuban',
  },
  {
    id: '3313130013',
    districtId: '3313130',
    name: 'Krendowahono',
  },
  {
    id: '3313140001',
    districtId: '3313140',
    name: 'Kemiri',
  },
  {
    id: '3313140002',
    districtId: '3313140',
    name: 'Nangsri',
  },
  {
    id: '3313140003',
    districtId: '3313140',
    name: 'Macanan',
  },
  {
    id: '3313140004',
    districtId: '3313140',
    name: 'Alastuwo',
  },
  {
    id: '3313140005',
    districtId: '3313140',
    name: 'Banjarharjo',
  },
  {
    id: '3313140006',
    districtId: '3313140',
    name: 'Malanggaten',
  },
  {
    id: '3313140007',
    districtId: '3313140',
    name: 'Kaliwuluh',
  },
  {
    id: '3313140008',
    districtId: '3313140',
    name: 'Pulosari',
  },
  {
    id: '3313140009',
    districtId: '3313140',
    name: 'Kebak',
  },
  {
    id: '3313140010',
    districtId: '3313140',
    name: 'Waru',
  },
  {
    id: '3313150001',
    districtId: '3313150',
    name: 'Sewurejo',
  },
  {
    id: '3313150002',
    districtId: '3313150',
    name: 'Ngadirejo',
  },
  {
    id: '3313150003',
    districtId: '3313150',
    name: 'Mojogedang',
  },
  {
    id: '3313150004',
    districtId: '3313150',
    name: 'Pojok',
  },
  {
    id: '3313150005',
    districtId: '3313150',
    name: 'Mojoroto',
  },
  {
    id: '3313150006',
    districtId: '3313150',
    name: 'Kaliboto',
  },
  {
    id: '3313150007',
    districtId: '3313150',
    name: 'Buntar',
  },
  {
    id: '3313150008',
    districtId: '3313150',
    name: 'Gebyog',
  },
  {
    id: '3313150009',
    districtId: '3313150',
    name: 'Gentungan',
  },
  {
    id: '3313160001',
    districtId: '3313160',
    name: 'Kuto',
  },
  {
    id: '3313160002',
    districtId: '3313160',
    name: 'Tamansari',
  },
  {
    id: '3313160003',
    districtId: '3313160',
    name: 'Ganten',
  },
  {
    id: '3313160004',
    districtId: '3313160',
    name: 'Gempolan',
  },
  {
    id: '3313160005',
    districtId: '3313160',
    name: 'Plosorejo',
  },
  {
    id: '3313160006',
    districtId: '3313160',
    name: 'Karangrejo',
  },
  {
    id: '3313160007',
    districtId: '3313160',
    name: 'Kwadungan',
  },
  {
    id: '3313160008',
    districtId: '3313160',
    name: 'Botok',
  },
  {
    id: '3313160009',
    districtId: '3313160',
    name: 'Sumberejo',
  },
  {
    id: '3313160010',
    districtId: '3313160',
    name: 'Tawangsari',
  },
  {
    id: '3313170002',
    districtId: '3313170',
    name: 'Anggrasmanis',
  },
  {
    id: '3313170003',
    districtId: '3313170',
    name: 'Jenawi',
  },
  {
    id: '3313170004',
    districtId: '3313170',
    name: 'Trengguli',
  },
  {
    id: '3313170005',
    districtId: '3313170',
    name: 'Sidomukti',
  },
  {
    id: '3313170006',
    districtId: '3313170',
    name: 'Balong',
  },
  {
    id: '3313170007',
    districtId: '3313170',
    name: 'Seloromo',
  },
  {
    id: '3313170008',
    districtId: '3313170',
    name: 'Menjing',
  },
  {
    id: '3313170009',
    districtId: '3313170',
    name: 'Lempong',
  },
  {
    id: '3314010002',
    districtId: '3314010',
    name: 'Trobayan',
  },
  {
    id: '3314010003',
    districtId: '3314010',
    name: 'Kalimacan',
  },
  {
    id: '3314010004',
    districtId: '3314010',
    name: 'Jetis Karangpung',
  },
  {
    id: '3314010005',
    districtId: '3314010',
    name: 'Krikilan',
  },
  {
    id: '3314010006',
    districtId: '3314010',
    name: 'Bukuran',
  },
  {
    id: '3314010008',
    districtId: '3314010',
    name: 'Banaran',
  },
  {
    id: '3314010009',
    districtId: '3314010',
    name: 'Samberembe',
  },
  {
    id: '3314010010',
    districtId: '3314010',
    name: 'Donoyudan',
  },
  {
    id: '3314010011',
    districtId: '3314010',
    name: 'Wonorejo',
  },
  {
    id: '3314010012',
    districtId: '3314010',
    name: 'Saren',
  },
  {
    id: '3314010013',
    districtId: '3314010',
    name: 'Karangjati',
  },
  {
    id: '3314010014',
    districtId: '3314010',
    name: 'Tegalombo',
  },
  {
    id: '3314020001',
    districtId: '3314020',
    name: 'Jembangan',
  },
  {
    id: '3314020002',
    districtId: '3314020',
    name: 'Sidokerto',
  },
  {
    id: '3314020003',
    districtId: '3314020',
    name: 'Jabung',
  },
  {
    id: '3314020004',
    districtId: '3314020',
    name: 'Pungsari',
  },
  {
    id: '3314020005',
    districtId: '3314020',
    name: 'Manyarejo',
  },
  {
    id: '3314020006',
    districtId: '3314020',
    name: 'Gedongan',
  },
  {
    id: '3314020008',
    districtId: '3314020',
    name: 'Cangkol',
  },
  {
    id: '3314020009',
    districtId: '3314020',
    name: 'Somomoro Dukuh',
  },
  {
    id: '3314020010',
    districtId: '3314020',
    name: 'Sambirejo',
  },
  {
    id: '3314020011',
    districtId: '3314020',
    name: 'Dari',
  },
  {
    id: '3314020012',
    districtId: '3314020',
    name: 'Karang Anyar',
  },
  {
    id: '3314020013',
    districtId: '3314020',
    name: 'Gentan Banaran',
  },
  {
    id: '3314020014',
    districtId: '3314020',
    name: 'Karungan',
  },
  {
    id: '3314020015',
    districtId: '3314020',
    name: 'Karangwaru',
  },
  {
    id: '3314020016',
    districtId: '3314020',
    name: 'Ngrombo',
  },
  {
    id: '3314030001',
    districtId: '3314030',
    name: 'Sidodadi',
  },
  {
    id: '3314030002',
    districtId: '3314030',
    name: 'Karang Malang',
  },
  {
    id: '3314030004',
    districtId: '3314030',
    name: 'Sepat',
  },
  {
    id: '3314030005',
    districtId: '3314030',
    name: 'Jirapan',
  },
  {
    id: '3314030006',
    districtId: '3314030',
    name: 'Gebang',
  },
  {
    id: '3314030007',
    districtId: '3314030',
    name: 'Dawungan',
  },
  {
    id: '3314030008',
    districtId: '3314030',
    name: 'Masaran',
  },
  {
    id: '3314030009',
    districtId: '3314030',
    name: 'Jati',
  },
  {
    id: '3314030010',
    districtId: '3314030',
    name: 'Kliwonan',
  },
  {
    id: '3314030011',
    districtId: '3314030',
    name: 'Pilang',
  },
  {
    id: '3314030012',
    districtId: '3314030',
    name: 'Pringanom',
  },
  {
    id: '3314030013',
    districtId: '3314030',
    name: 'Krikilan',
  },
  {
    id: '3314040001',
    districtId: '3314040',
    name: 'Karang Pelem',
  },
  {
    id: '3314040002',
    districtId: '3314040',
    name: 'Mojodoyong',
  },
  {
    id: '3314040003',
    districtId: '3314040',
    name: 'Jenggrik',
  },
  {
    id: '3314040004',
    districtId: '3314040',
    name: 'Mojokerto',
  },
  {
    id: '3314040005',
    districtId: '3314040',
    name: 'Kedawung',
  },
  {
    id: '3314040006',
    districtId: '3314040',
    name: 'Bendungan',
  },
  {
    id: '3314040007',
    districtId: '3314040',
    name: 'Wonokerso',
  },
  {
    id: '3314040008',
    districtId: '3314040',
    name: 'Wonorejo',
  },
  {
    id: '3314040010',
    districtId: '3314040',
    name: 'Pengkok',
  },
  {
    id: '3314050002',
    districtId: '3314050',
    name: 'Jetis',
  },
  {
    id: '3314050003',
    districtId: '3314050',
    name: 'Sukorejo',
  },
  {
    id: '3314050004',
    districtId: '3314050',
    name: 'Jambeyan',
  },
  {
    id: '3314050005',
    districtId: '3314050',
    name: 'Sambi',
  },
  {
    id: '3314050006',
    districtId: '3314050',
    name: 'Dawung',
  },
  {
    id: '3314050007',
    districtId: '3314050',
    name: 'Blimbing',
  },
  {
    id: '3314050008',
    districtId: '3314050',
    name: 'Sambirejo',
  },
  {
    id: '3314050009',
    districtId: '3314050',
    name: 'Kadipiro',
  },
  {
    id: '3314060001',
    districtId: '3314060',
    name: 'Srimulyo',
  },
  {
    id: '3314060002',
    districtId: '3314060',
    name: 'Tegalrejo',
  },
  {
    id: '3314060004',
    districtId: '3314060',
    name: 'Glonggong',
  },
  {
    id: '3314060005',
    districtId: '3314060',
    name: 'Kaliwedi',
  },
  {
    id: '3314060006',
    districtId: '3314060',
    name: 'Plosorejo',
  },
  {
    id: '3314060007',
    districtId: '3314060',
    name: 'Wonotolo',
  },
  {
    id: '3314060008',
    districtId: '3314060',
    name: 'Bumiaji',
  },
  {
    id: '3314060009',
    districtId: '3314060',
    name: 'Gondang',
  },
  {
    id: '3314070001',
    districtId: '3314070',
    name: 'Karanganyar',
  },
  {
    id: '3314070002',
    districtId: '3314070',
    name: 'Toyogo',
  },
  {
    id: '3314070003',
    districtId: '3314070',
    name: 'Banyuurip',
  },
  {
    id: '3314070004',
    districtId: '3314070',
    name: 'Gringging',
  },
  {
    id: '3314070005',
    districtId: '3314070',
    name: 'Banaran',
  },
  {
    id: '3314070006',
    districtId: '3314070',
    name: 'Sambungmacan',
  },
  {
    id: '3314070007',
    districtId: '3314070',
    name: 'Bedoro',
  },
  {
    id: '3314070008',
    districtId: '3314070',
    name: 'Plumbon',
  },
  {
    id: '3314080001',
    districtId: '3314080',
    name: 'Pilangsari',
  },
  {
    id: '3314080002',
    districtId: '3314080',
    name: 'Ngarum',
  },
  {
    id: '3314080004',
    districtId: '3314080',
    name: 'Kebonromo',
  },
  {
    id: '3314080005',
    districtId: '3314080',
    name: 'Bandung',
  },
  {
    id: '3314080006',
    districtId: '3314080',
    name: 'Gabus',
  },
  {
    id: '3314080007',
    districtId: '3314080',
    name: 'Karangudi',
  },
  {
    id: '3314080008',
    districtId: '3314080',
    name: 'Klandungan',
  },
  {
    id: '3314090001',
    districtId: '3314090',
    name: 'Kedung Waduk',
  },
  {
    id: '3314090002',
    districtId: '3314090',
    name: 'Jurangjero',
  },
  {
    id: '3314090003',
    districtId: '3314090',
    name: 'Saradan',
  },
  {
    id: '3314090004',
    districtId: '3314090',
    name: 'Plosokerep',
  },
  {
    id: '3314090005',
    districtId: '3314090',
    name: 'Guworejo',
  },
  {
    id: '3314090006',
    districtId: '3314090',
    name: 'Puro',
  },
  {
    id: '3314090007',
    districtId: '3314090',
    name: 'Mojorejo',
  },
  {
    id: '3314090008',
    districtId: '3314090',
    name: 'Pelem Gadung',
  },
  {
    id: '3314090009',
    districtId: '3314090',
    name: 'Plumbungan',
  },
  {
    id: '3314090010',
    districtId: '3314090',
    name: 'Kroyo',
  },
  {
    id: '3314100001',
    districtId: '3314100',
    name: 'Sine',
  },
  {
    id: '3314100002',
    districtId: '3314100',
    name: 'Sragen Kulon',
  },
  {
    id: '3314100003',
    districtId: '3314100',
    name: 'Sragen Tengah',
  },
  {
    id: '3314100004',
    districtId: '3314100',
    name: 'Sragen Wetan',
  },
  {
    id: '3314100005',
    districtId: '3314100',
    name: 'Nglorog',
  },
  {
    id: '3314100006',
    districtId: '3314100',
    name: 'Karang Tengah',
  },
  {
    id: '3314100007',
    districtId: '3314100',
    name: 'Tangkil',
  },
  {
    id: '3314100008',
    districtId: '3314100',
    name: 'Kedungupit',
  },
  {
    id: '3314110001',
    districtId: '3314110',
    name: 'Bentak',
  },
  {
    id: '3314110002',
    districtId: '3314110',
    name: 'Purwosuman',
  },
  {
    id: '3314110003',
    districtId: '3314110',
    name: 'Patihan',
  },
  {
    id: '3314110004',
    districtId: '3314110',
    name: 'Duyungan',
  },
  {
    id: '3314110005',
    districtId: '3314110',
    name: 'Jetak',
  },
  {
    id: '3314110006',
    districtId: '3314110',
    name: 'Sidoharjo',
  },
  {
    id: '3314110007',
    districtId: '3314110',
    name: 'Singopadu',
  },
  {
    id: '3314110008',
    districtId: '3314110',
    name: 'Jambanan',
  },
  {
    id: '3314110009',
    districtId: '3314110',
    name: 'Taraman',
  },
  {
    id: '3314110010',
    districtId: '3314110',
    name: 'Tenggak',
  },
  {
    id: '3314110011',
    districtId: '3314110',
    name: 'Sribit',
  },
  {
    id: '3314110012',
    districtId: '3314110',
    name: 'Pandak',
  },
  {
    id: '3314120001',
    districtId: '3314120',
    name: 'Karangasem',
  },
  {
    id: '3314120002',
    districtId: '3314120',
    name: 'Slogo',
  },
  {
    id: '3314120003',
    districtId: '3314120',
    name: 'Jono',
  },
  {
    id: '3314120004',
    districtId: '3314120',
    name: 'Gawan',
  },
  {
    id: '3314120005',
    districtId: '3314120',
    name: 'Kecik',
  },
  {
    id: '3314120006',
    districtId: '3314120',
    name: 'Padas',
  },
  {
    id: '3314120007',
    districtId: '3314120',
    name: 'Gabugan',
  },
  {
    id: '3314120008',
    districtId: '3314120',
    name: 'Ketro',
  },
  {
    id: '3314120009',
    districtId: '3314120',
    name: 'Sambi Duwur',
  },
  {
    id: '3314120010',
    districtId: '3314120',
    name: 'Karang Talun',
  },
  {
    id: '3314120011',
    districtId: '3314120',
    name: 'Gading',
  },
  {
    id: '3314120012',
    districtId: '3314120',
    name: 'Bonagung',
  },
  {
    id: '3314120013',
    districtId: '3314120',
    name: 'Kalikobok',
  },
  {
    id: '3314120014',
    districtId: '3314120',
    name: 'Tanon',
  },
  {
    id: '3314120015',
    districtId: '3314120',
    name: 'Suwatu',
  },
  {
    id: '3314120016',
    districtId: '3314120',
    name: 'Pengkol',
  },
  {
    id: '3314130001',
    districtId: '3314130',
    name: 'Kaloran',
  },
  {
    id: '3314130002',
    districtId: '3314130',
    name: 'Ngembat Padas',
  },
  {
    id: '3314130003',
    districtId: '3314130',
    name: 'Kragilan',
  },
  {
    id: '3314130004',
    districtId: '3314130',
    name: 'Brangkal',
  },
  {
    id: '3314130005',
    districtId: '3314130',
    name: 'Jatibatur',
  },
  {
    id: '3314130006',
    districtId: '3314130',
    name: 'Peleman',
  },
  {
    id: '3314130008',
    districtId: '3314130',
    name: 'Tegaldowo',
  },
  {
    id: '3314130009',
    districtId: '3314130',
    name: 'Gemolong',
  },
  {
    id: '3314130010',
    districtId: '3314130',
    name: 'Kwangen',
  },
  {
    id: '3314130011',
    districtId: '3314130',
    name: 'Purworejo',
  },
  {
    id: '3314130012',
    districtId: '3314130',
    name: 'Jenalas',
  },
  {
    id: '3314130013',
    districtId: '3314130',
    name: 'Kalangan',
  },
  {
    id: '3314130014',
    districtId: '3314130',
    name: 'Nganti',
  },
  {
    id: '3314140003',
    districtId: '3314140',
    name: 'Sunggingan',
  },
  {
    id: '3314140004',
    districtId: '3314140',
    name: 'Girimargo',
  },
  {
    id: '3314140005',
    districtId: '3314140',
    name: 'Doyong',
  },
  {
    id: '3314140006',
    districtId: '3314140',
    name: 'Soko',
  },
  {
    id: '3314140007',
    districtId: '3314140',
    name: 'Brojol',
  },
  {
    id: '3314140008',
    districtId: '3314140',
    name: 'Bagor',
  },
  {
    id: '3314140009',
    districtId: '3314140',
    name: 'Gilirejo',
  },
  {
    id: '3314140010',
    districtId: '3314140',
    name: 'Gilirejo Baru',
  },
  {
    id: '3314150002',
    districtId: '3314150',
    name: 'Hadiluwih',
  },
  {
    id: '3314150003',
    districtId: '3314150',
    name: 'Jati',
  },
  {
    id: '3314150004',
    districtId: '3314150',
    name: 'Cepoko',
  },
  {
    id: '3314150005',
    districtId: '3314150',
    name: 'Mojopuro',
  },
  {
    id: '3314150006',
    districtId: '3314150',
    name: 'Ngandul',
  },
  {
    id: '3314150007',
    districtId: '3314150',
    name: 'Ngargotirto',
  },
  {
    id: '3314150008',
    districtId: '3314150',
    name: 'Kacangan',
  },
  {
    id: '3314150009',
    districtId: '3314150',
    name: 'Pagak',
  },
  {
    id: '3314150010',
    districtId: '3314150',
    name: 'Tlogo Tirto',
  },
  {
    id: '3314150011',
    districtId: '3314150',
    name: 'Ngargosari',
  },
  {
    id: '3314160001',
    districtId: '3314160',
    name: 'Sono',
  },
  {
    id: '3314160002',
    districtId: '3314160',
    name: 'Tempelrejo',
  },
  {
    id: '3314160003',
    districtId: '3314160',
    name: 'Trombol',
  },
  {
    id: '3314160004',
    districtId: '3314160',
    name: 'Jekani',
  },
  {
    id: '3314160005',
    districtId: '3314160',
    name: 'Pare',
  },
  {
    id: '3314160006',
    districtId: '3314160',
    name: 'Kedawung',
  },
  {
    id: '3314160007',
    districtId: '3314160',
    name: 'Jambangan',
  },
  {
    id: '3314160008',
    districtId: '3314160',
    name: 'Gemantar',
  },
  {
    id: '3314160009',
    districtId: '3314160',
    name: 'Sumberejo',
  },
  {
    id: '3314170002',
    districtId: '3314170',
    name: 'Jati Tengah',
  },
  {
    id: '3314170003',
    districtId: '3314170',
    name: 'Bendo',
  },
  {
    id: '3314170004',
    districtId: '3314170',
    name: 'Juwok',
  },
  {
    id: '3314170005',
    districtId: '3314170',
    name: 'Pantirejo',
  },
  {
    id: '3314170006',
    districtId: '3314170',
    name: 'Majenang',
  },
  {
    id: '3314170007',
    districtId: '3314170',
    name: 'Karang Anom',
  },
  {
    id: '3314170008',
    districtId: '3314170',
    name: 'Gebang',
  },
  {
    id: '3314170009',
    districtId: '3314170',
    name: 'Baleharjo',
  },
  {
    id: '3314180001',
    districtId: '3314180',
    name: 'Pilangsari',
  },
  {
    id: '3314180002',
    districtId: '3314180',
    name: 'Tanggan',
  },
  {
    id: '3314180003',
    districtId: '3314180',
    name: 'Srawung',
  },
  {
    id: '3314180004',
    districtId: '3314180',
    name: 'Gesi',
  },
  {
    id: '3314180005',
    districtId: '3314180',
    name: 'Blangu',
  },
  {
    id: '3314180006',
    districtId: '3314180',
    name: 'Slendro',
  },
  {
    id: '3314180007',
    districtId: '3314180',
    name: 'Poleng',
  },
  {
    id: '3314190001',
    districtId: '3314190',
    name: 'Katelan',
  },
  {
    id: '3314190003',
    districtId: '3314190',
    name: 'Jekawal',
  },
  {
    id: '3314190004',
    districtId: '3314190',
    name: 'Galeh',
  },
  {
    id: '3314190005',
    districtId: '3314190',
    name: 'Ngrombo',
  },
  {
    id: '3314190006',
    districtId: '3314190',
    name: 'Sigit',
  },
  {
    id: '3314190007',
    districtId: '3314190',
    name: 'Denanyar',
  },
  {
    id: '3314200001',
    districtId: '3314200',
    name: 'Japoh',
  },
  {
    id: '3314200002',
    districtId: '3314200',
    name: 'Ngepringan',
  },
  {
    id: '3314200003',
    districtId: '3314200',
    name: 'Mlale',
  },
  {
    id: '3314200004',
    districtId: '3314200',
    name: 'Dawung',
  },
  {
    id: '3314200005',
    districtId: '3314200',
    name: 'Kandang Sapi',
  },
  {
    id: '3314200006',
    districtId: '3314200',
    name: 'Jenar',
  },
  {
    id: '3314200007',
    districtId: '3314200',
    name: 'Banyuurip',
  },
  {
    id: '3315010001',
    districtId: '3315010',
    name: 'Prigi',
  },
  {
    id: '3315010002',
    districtId: '3315010',
    name: 'Ngombak',
  },
  {
    id: '3315010003',
    districtId: '3315010',
    name: 'Kentengsari',
  },
  {
    id: '3315010004',
    districtId: '3315010',
    name: 'Karanglangu',
  },
  {
    id: '3315010005',
    districtId: '3315010',
    name: 'Panimbo',
  },
  {
    id: '3315010006',
    districtId: '3315010',
    name: 'Padas',
  },
  {
    id: '3315010007',
    districtId: '3315010',
    name: 'Deras',
  },
  {
    id: '3315010008',
    districtId: '3315010',
    name: 'Klitikan',
  },
  {
    id: '3315010009',
    districtId: '3315010',
    name: 'Kedungjati',
  },
  {
    id: '3315010010',
    districtId: '3315010',
    name: 'Kalimaro',
  },
  {
    id: '3315010011',
    districtId: '3315010',
    name: 'Jumo',
  },
  {
    id: '3315010012',
    districtId: '3315010',
    name: 'Wates',
  },
  {
    id: '3315020002',
    districtId: '3315020',
    name: 'Ketro',
  },
  {
    id: '3315020003',
    districtId: '3315020',
    name: 'Sendangharjo',
  },
  {
    id: '3315020004',
    districtId: '3315020',
    name: 'Karanganyar',
  },
  {
    id: '3315020005',
    districtId: '3315020',
    name: 'Parakan',
  },
  {
    id: '3315020006',
    districtId: '3315020',
    name: 'Nampu',
  },
  {
    id: '3315020007',
    districtId: '3315020',
    name: 'Karangsono',
  },
  {
    id: '3315020008',
    districtId: '3315020',
    name: 'Jetis',
  },
  {
    id: '3315020009',
    districtId: '3315020',
    name: 'Telawah',
  },
  {
    id: '3315020011',
    districtId: '3315020',
    name: 'Mangin',
  },
  {
    id: '3315020012',
    districtId: '3315020',
    name: 'Sumberjosari',
  },
  {
    id: '3315020013',
    districtId: '3315020',
    name: 'Mojoagung',
  },
  {
    id: '3315020014',
    districtId: '3315020',
    name: 'Pangkalan',
  },
  {
    id: '3315020015',
    districtId: '3315020',
    name: 'Rawoh',
  },
  {
    id: '3315020017',
    districtId: '3315020',
    name: 'Termas',
  },
  {
    id: '3315020018',
    districtId: '3315020',
    name: 'Putatnganten',
  },
  {
    id: '3315020019',
    districtId: '3315020',
    name: 'Temurejo',
  },
  {
    id: '3315030001',
    districtId: '3315030',
    name: 'Lajer',
  },
  {
    id: '3315030002',
    districtId: '3315030',
    name: 'Sedadi',
  },
  {
    id: '3315030003',
    districtId: '3315030',
    name: 'Bologarang',
  },
  {
    id: '3315030004',
    districtId: '3315030',
    name: 'Karangwader',
  },
  {
    id: '3315030005',
    districtId: '3315030',
    name: 'Toko',
  },
  {
    id: '3315030006',
    districtId: '3315030',
    name: 'Pengkol',
  },
  {
    id: '3315030007',
    districtId: '3315030',
    name: 'Leyangan',
  },
  {
    id: '3315030008',
    districtId: '3315030',
    name: 'Watu Pawon',
  },
  {
    id: '3315030010',
    districtId: '3315030',
    name: 'Jipang',
  },
  {
    id: '3315030011',
    districtId: '3315030',
    name: 'Kramat',
  },
  {
    id: '3315030013',
    districtId: '3315030',
    name: 'Wedoro',
  },
  {
    id: '3315030014',
    districtId: '3315030',
    name: 'Kluwan',
  },
  {
    id: '3315030015',
    districtId: '3315030',
    name: 'Karangpaing',
  },
  {
    id: '3315030016',
    districtId: '3315030',
    name: 'Pulutan',
  },
  {
    id: '3315030017',
    districtId: '3315030',
    name: 'Winong',
  },
  {
    id: '3315030018',
    districtId: '3315030',
    name: 'Wolo',
  },
  {
    id: '3315030020',
    districtId: '3315030',
    name: 'Penawangan',
  },
  {
    id: '3315040001',
    districtId: '3315040',
    name: 'Dimoro',
  },
  {
    id: '3315040002',
    districtId: '3315040',
    name: 'Genengadal',
  },
  {
    id: '3315040003',
    districtId: '3315040',
    name: 'Sindurejo',
  },
  {
    id: '3315040004',
    districtId: '3315040',
    name: 'Bandungharjo',
  },
  {
    id: '3315040005',
    districtId: '3315040',
    name: 'Genengsari',
  },
  {
    id: '3315040007',
    districtId: '3315040',
    name: 'Ngrandah',
  },
  {
    id: '3315040008',
    districtId: '3315040',
    name: 'Tunggak',
  },
  {
    id: '3315040009',
    districtId: '3315040',
    name: 'Boloh',
  },
  {
    id: '3315040010',
    districtId: '3315040',
    name: 'Plosoharjo',
  },
  {
    id: '3315040011',
    districtId: '3315040',
    name: 'Tambirejo',
  },
  {
    id: '3315040012',
    districtId: '3315040',
    name: 'Depok',
  },
  {
    id: '3315040013',
    districtId: '3315040',
    name: 'Krangganharjo',
  },
  {
    id: '3315040014',
    districtId: '3315040',
    name: 'Sugihan',
  },
  {
    id: '3315040015',
    districtId: '3315040',
    name: 'Pilangpayung',
  },
  {
    id: '3315040016',
    districtId: '3315040',
    name: 'Katong',
  },
  {
    id: '3315050001',
    districtId: '3315050',
    name: 'Rambat',
  },
  {
    id: '3315050002',
    districtId: '3315050',
    name: 'Kalangbancar',
  },
  {
    id: '3315050003',
    districtId: '3315050',
    name: 'Juworo',
  },
  {
    id: '3315050004',
    districtId: '3315050',
    name: 'Monggot',
  },
  {
    id: '3315050005',
    districtId: '3315050',
    name: 'Ngrandu',
  },
  {
    id: '3315050006',
    districtId: '3315050',
    name: 'Bangsri',
  },
  {
    id: '3315050007',
    districtId: '3315050',
    name: 'Karang Anyar',
  },
  {
    id: '3315050008',
    districtId: '3315050',
    name: 'Asemrudung',
  },
  {
    id: '3315050009',
    districtId: '3315050',
    name: 'Jambangan',
  },
  {
    id: '3315050011',
    districtId: '3315050',
    name: 'Ledokdawan',
  },
  {
    id: '3315050012',
    districtId: '3315050',
    name: 'Sobo',
  },
  {
    id: '3315060001',
    districtId: '3315060',
    name: 'Randurejo',
  },
  {
    id: '3315060002',
    districtId: '3315060',
    name: 'Mlowokarangtalun',
  },
  {
    id: '3315060003',
    districtId: '3315060',
    name: 'Pojok',
  },
  {
    id: '3315060004',
    districtId: '3315060',
    name: 'Jatiharjo',
  },
  {
    id: '3315060005',
    districtId: '3315060',
    name: 'Sidorejo',
  },
  {
    id: '3315060006',
    districtId: '3315060',
    name: 'Tuko',
  },
  {
    id: '3315060007',
    districtId: '3315060',
    name: 'Panunggalan',
  },
  {
    id: '3315060008',
    districtId: '3315060',
    name: 'Mangunrejo',
  },
  {
    id: '3315060009',
    districtId: '3315060',
    name: 'Jetaksari',
  },
  {
    id: '3315060010',
    districtId: '3315060',
    name: 'Pulokulon',
  },
  {
    id: '3315060011',
    districtId: '3315060',
    name: 'Jambon',
  },
  {
    id: '3315060012',
    districtId: '3315060',
    name: 'Karangharjo',
  },
  {
    id: '3315060013',
    districtId: '3315060',
    name: 'Sembungharjo',
  },
  {
    id: '3315070001',
    districtId: '3315070',
    name: 'Bago',
  },
  {
    id: '3315070002',
    districtId: '3315070',
    name: 'Simo',
  },
  {
    id: '3315070003',
    districtId: '3315070',
    name: 'Rejosari',
  },
  {
    id: '3315070004',
    districtId: '3315070',
    name: 'Pakis',
  },
  {
    id: '3315070006',
    districtId: '3315070',
    name: 'Banjarsari',
  },
  {
    id: '3315070007',
    districtId: '3315070',
    name: 'Kradenan',
  },
  {
    id: '3315070008',
    districtId: '3315070',
    name: 'Sambongbangi',
  },
  {
    id: '3315070009',
    districtId: '3315070',
    name: 'Sengonwetan',
  },
  {
    id: '3315070010',
    districtId: '3315070',
    name: 'Banjardowo',
  },
  {
    id: '3315070011',
    districtId: '3315070',
    name: 'Kalisari',
  },
  {
    id: '3315070013',
    districtId: '3315070',
    name: 'Grabagan',
  },
  {
    id: '3315070014',
    districtId: '3315070',
    name: 'Tanjungsari',
  },
  {
    id: '3315080001',
    districtId: '3315080',
    name: 'Keyongan',
  },
  {
    id: '3315080002',
    districtId: '3315080',
    name: 'Suwatu',
  },
  {
    id: '3315080003',
    districtId: '3315080',
    name: 'Nglinduk',
  },
  {
    id: '3315080005',
    districtId: '3315080',
    name: 'Sulursari',
  },
  {
    id: '3315080006',
    districtId: '3315080',
    name: 'Tlogotirto',
  },
  {
    id: '3315080007',
    districtId: '3315080',
    name: 'Gabus',
  },
  {
    id: '3315080008',
    districtId: '3315080',
    name: 'Pandanharum',
  },
  {
    id: '3315080009',
    districtId: '3315080',
    name: 'Tunggulrejo',
  },
  {
    id: '3315080010',
    districtId: '3315080',
    name: 'Tahunan',
  },
  {
    id: '3315080011',
    districtId: '3315080',
    name: 'Bendoharjo',
  },
  {
    id: '3315080012',
    districtId: '3315080',
    name: 'Kalipang',
  },
  {
    id: '3315080013',
    districtId: '3315080',
    name: 'Karangrejo',
  },
  {
    id: '3315080014',
    districtId: '3315080',
    name: 'Banjarejo',
  },
  {
    id: '3315090001',
    districtId: '3315090',
    name: 'Sendangrejo',
  },
  {
    id: '3315090002',
    districtId: '3315090',
    name: 'Sarirejo',
  },
  {
    id: '3315090003',
    districtId: '3315090',
    name: 'Kalangdosari',
  },
  {
    id: '3315090004',
    districtId: '3315090',
    name: 'Kalanglundo',
  },
  {
    id: '3315090005',
    districtId: '3315090',
    name: 'Truwolu',
  },
  {
    id: '3315090007',
    districtId: '3315090',
    name: 'Bandungsari',
  },
  {
    id: '3315090008',
    districtId: '3315090',
    name: 'Ngaringan',
  },
  {
    id: '3315090009',
    districtId: '3315090',
    name: 'Ngaraparap',
  },
  {
    id: '3315090010',
    districtId: '3315090',
    name: 'Belor',
  },
  {
    id: '3315090011',
    districtId: '3315090',
    name: 'Tanjungharjo',
  },
  {
    id: '3315090012',
    districtId: '3315090',
    name: 'Sumberagung',
  },
  {
    id: '3315100001',
    districtId: '3315100',
    name: 'Sambirejo',
  },
  {
    id: '3315100002',
    districtId: '3315100',
    name: 'Tanjungrejo',
  },
  {
    id: '3315100004',
    districtId: '3315100',
    name: 'Tambahrejo',
  },
  {
    id: '3315100005',
    districtId: '3315100',
    name: 'Kropak',
  },
  {
    id: '3315100006',
    districtId: '3315100',
    name: 'Kalirejo',
  },
  {
    id: '3315100007',
    districtId: '3315100',
    name: 'Dapurno',
  },
  {
    id: '3315100008',
    districtId: '3315100',
    name: 'Mojorebo',
  },
  {
    id: '3315100009',
    districtId: '3315100',
    name: 'Wirosari',
  },
  {
    id: '3315100010',
    districtId: '3315100',
    name: 'Gedangan',
  },
  {
    id: '3315100011',
    districtId: '3315100',
    name: 'Tambakselo',
  },
  {
    id: '3315100012',
    districtId: '3315100',
    name: 'Karangasem',
  },
  {
    id: '3315100013',
    districtId: '3315100',
    name: 'Dokoro',
  },
  {
    id: '3315100014',
    districtId: '3315100',
    name: 'Tegalrejo',
  },
  {
    id: '3315110001',
    districtId: '3315110',
    name: 'Pulongrambe',
  },
  {
    id: '3315110002',
    districtId: '3315110',
    name: 'Mayahan',
  },
  {
    id: '3315110003',
    districtId: '3315110',
    name: 'Jono',
  },
  {
    id: '3315110004',
    districtId: '3315110',
    name: 'Selo',
  },
  {
    id: '3315110005',
    districtId: '3315110',
    name: 'Tawangharjo',
  },
  {
    id: '3315110006',
    districtId: '3315110',
    name: 'Tarub',
  },
  {
    id: '3315110007',
    districtId: '3315110',
    name: 'Pojok',
  },
  {
    id: '3315110008',
    districtId: '3315110',
    name: 'Plosorejo',
  },
  {
    id: '3315110009',
    districtId: '3315110',
    name: 'Godan',
  },
  {
    id: '3315110010',
    districtId: '3315110',
    name: 'Kemaduhbatur',
  },
  {
    id: '3315120001',
    districtId: '3315120',
    name: 'Getasrejo',
  },
  {
    id: '3315120002',
    districtId: '3315120',
    name: 'Rejosari',
  },
  {
    id: '3315120003',
    districtId: '3315120',
    name: 'Tanggungharjo',
  },
  {
    id: '3315120004',
    districtId: '3315120',
    name: 'Teguhan',
  },
  {
    id: '3315120005',
    districtId: '3315120',
    name: 'Ngabenrejo',
  },
  {
    id: '3315120006',
    districtId: '3315120',
    name: 'Grobogan',
  },
  {
    id: '3315120007',
    districtId: '3315120',
    name: 'Karangrejo',
  },
  {
    id: '3315120008',
    districtId: '3315120',
    name: 'Putatsari',
  },
  {
    id: '3315120009',
    districtId: '3315120',
    name: 'Lebak',
  },
  {
    id: '3315120011',
    districtId: '3315120',
    name: 'Sedayu',
  },
  {
    id: '3315120012',
    districtId: '3315120',
    name: 'Sumber Jatipohon',
  },
  {
    id: '3315130001',
    districtId: '3315130',
    name: 'Candisari',
  },
  {
    id: '3315130002',
    districtId: '3315130',
    name: 'Genuksuran',
  },
  {
    id: '3315130003',
    districtId: '3315130',
    name: 'Danyang',
  },
  {
    id: '3315130004',
    districtId: '3315130',
    name: 'Kalongan',
  },
  {
    id: '3315130005',
    districtId: '3315130',
    name: 'Ngraji',
  },
  {
    id: '3315130006',
    districtId: '3315130',
    name: 'Kandangan',
  },
  {
    id: '3315130007',
    districtId: '3315130',
    name: 'Nambuhan',
  },
  {
    id: '3315130008',
    districtId: '3315130',
    name: 'Warukaranganyar',
  },
  {
    id: '3315130009',
    districtId: '3315130',
    name: 'Nglobar',
  },
  {
    id: '3315130010',
    districtId: '3315130',
    name: 'Kedungrejo',
  },
  {
    id: '3315130011',
    districtId: '3315130',
    name: 'Karanganyar',
  },
  {
    id: '3315130012',
    districtId: '3315130',
    name: 'Purwodadi',
  },
  {
    id: '3315130013',
    districtId: '3315130',
    name: 'Kuripan',
  },
  {
    id: '3315130014',
    districtId: '3315130',
    name: 'Ngembak',
  },
  {
    id: '3315130015',
    districtId: '3315130',
    name: 'Cingkrong',
  },
  {
    id: '3315130016',
    districtId: '3315130',
    name: 'Pulorejo',
  },
  {
    id: '3315130017',
    districtId: '3315130',
    name: 'Putat',
  },
  {
    id: '3315140001',
    districtId: '3315140',
    name: 'Menduran',
  },
  {
    id: '3315140002',
    districtId: '3315140',
    name: 'Jangkungharjo',
  },
  {
    id: '3315140003',
    districtId: '3315140',
    name: 'Temon',
  },
  {
    id: '3315140004',
    districtId: '3315140',
    name: 'Lemahputih',
  },
  {
    id: '3315140005',
    districtId: '3315140',
    name: 'Tirem',
  },
  {
    id: '3315140006',
    districtId: '3315140',
    name: 'Karangsari',
  },
  {
    id: '3315140007',
    districtId: '3315140',
    name: 'Kronggen',
  },
  {
    id: '3315140008',
    districtId: '3315140',
    name: 'Katekan',
  },
  {
    id: '3315140009',
    districtId: '3315140',
    name: 'Tegalsumur',
  },
  {
    id: '3315150001',
    districtId: '3315150',
    name: 'Kandangrejo',
  },
  {
    id: '3315150002',
    districtId: '3315150',
    name: 'Selojari',
  },
  {
    id: '3315150003',
    districtId: '3315150',
    name: 'Taruman',
  },
  {
    id: '3315150004',
    districtId: '3315150',
    name: 'Penganten',
  },
  {
    id: '3315150005',
    districtId: '3315150',
    name: 'Klambu',
  },
  {
    id: '3315150006',
    districtId: '3315150',
    name: 'Menawan',
  },
  {
    id: '3315150007',
    districtId: '3315150',
    name: 'Terkesi',
  },
  {
    id: '3315150008',
    districtId: '3315150',
    name: 'Jenengan',
  },
  {
    id: '3315150009',
    districtId: '3315150',
    name: 'Wandankemiri',
  },
  {
    id: '3315160002',
    districtId: '3315160',
    name: 'Pahesan',
  },
  {
    id: '3315160003',
    districtId: '3315160',
    name: 'Latak',
  },
  {
    id: '3315160005',
    districtId: '3315160',
    name: 'Sambung',
  },
  {
    id: '3315160006',
    districtId: '3315160',
    name: 'Ketangirejo',
  },
  {
    id: '3315160007',
    districtId: '3315160',
    name: 'Anggaswangi',
  },
  {
    id: '3315160008',
    districtId: '3315160',
    name: 'Guci',
  },
  {
    id: '3315160009',
    districtId: '3315160',
    name: 'Werdoyo',
  },
  {
    id: '3315160010',
    districtId: '3315160',
    name: 'Guyangan',
  },
  {
    id: '3315160011',
    districtId: '3315160',
    name: 'Gundi',
  },
  {
    id: '3315160012',
    districtId: '3315160',
    name: 'Jatilor',
  },
  {
    id: '3315160013',
    districtId: '3315160',
    name: 'Sumberagung',
  },
  {
    id: '3315160014',
    districtId: '3315160',
    name: 'Bringin',
  },
  {
    id: '3315160015',
    districtId: '3315160',
    name: 'Klampok',
  },
  {
    id: '3315160016',
    districtId: '3315160',
    name: 'Kemloko',
  },
  {
    id: '3315160017',
    districtId: '3315160',
    name: 'Godong',
  },
  {
    id: '3315160019',
    districtId: '3315160',
    name: 'Ketitang',
  },
  {
    id: '3315160020',
    districtId: '3315160',
    name: 'Kopek',
  },
  {
    id: '3315160021',
    districtId: '3315160',
    name: 'Dorolegi',
  },
  {
    id: '3315160022',
    districtId: '3315160',
    name: 'Rajek',
  },
  {
    id: '3315160023',
    districtId: '3315160',
    name: 'Harjowinangun',
  },
  {
    id: '3315160024',
    districtId: '3315160',
    name: 'Karanggeneng',
  },
  {
    id: '3315160025',
    districtId: '3315160',
    name: 'Wanutunggal',
  },
  {
    id: '3315160026',
    districtId: '3315160',
    name: 'Manggarwetan',
  },
  {
    id: '3315160027',
    districtId: '3315160',
    name: 'Manggarmas',
  },
  {
    id: '3315160028',
    districtId: '3315160',
    name: 'Tinanding',
  },
  {
    id: '3315170001',
    districtId: '3315170',
    name: 'Penadaran',
  },
  {
    id: '3315170002',
    districtId: '3315170',
    name: 'Gelapan',
  },
  {
    id: '3315170003',
    districtId: '3315170',
    name: 'Ngroto',
  },
  {
    id: '3315170004',
    districtId: '3315170',
    name: 'Ginggangtani',
  },
  {
    id: '3315170005',
    districtId: '3315170',
    name: 'Jeketro',
  },
  {
    id: '3315170006',
    districtId: '3315170',
    name: 'Saban',
  },
  {
    id: '3315170007',
    districtId: '3315170',
    name: 'Mlilir',
  },
  {
    id: '3315170008',
    districtId: '3315170',
    name: 'Kemiri',
  },
  {
    id: '3315170009',
    districtId: '3315170',
    name: 'Papanrejo',
  },
  {
    id: '3315170011',
    districtId: '3315170',
    name: 'Trisari',
  },
  {
    id: '3315170012',
    districtId: '3315170',
    name: 'Kuwaron',
  },
  {
    id: '3315170013',
    districtId: '3315170',
    name: 'Rowosari',
  },
  {
    id: '3315170015',
    districtId: '3315170',
    name: 'Pranten',
  },
  {
    id: '3315170016',
    districtId: '3315170',
    name: 'Jatipecaron',
  },
  {
    id: '3315170017',
    districtId: '3315170',
    name: 'Baturagung',
  },
  {
    id: '3315170018',
    districtId: '3315170',
    name: 'Tambakan',
  },
  {
    id: '3315170019',
    districtId: '3315170',
    name: 'Ringinkidul',
  },
  {
    id: '3315170020',
    districtId: '3315170',
    name: 'Ringinharjo',
  },
  {
    id: '3315170021',
    districtId: '3315170',
    name: 'Tlogomulyo',
  },
  {
    id: '3315180001',
    districtId: '3315180',
    name: 'Kebonagung',
  },
  {
    id: '3315180002',
    districtId: '3315180',
    name: 'Tlogorejo',
  },
  {
    id: '3315180003',
    districtId: '3315180',
    name: 'Medani',
  },
  {
    id: '3315180004',
    districtId: '3315180',
    name: 'Sukorejo',
  },
  {
    id: '3315180005',
    districtId: '3315180',
    name: 'Tanggirejo',
  },
  {
    id: '3315180006',
    districtId: '3315180',
    name: 'Mangunsari',
  },
  {
    id: '3315180007',
    districtId: '3315180',
    name: 'Gebangan',
  },
  {
    id: '3315180008',
    districtId: '3315180',
    name: 'Kejawan',
  },
  {
    id: '3315180009',
    districtId: '3315180',
    name: 'Tegowanu Wetan',
  },
  {
    id: '3315180010',
    districtId: '3315180',
    name: 'Tegowanu Kulon',
  },
  {
    id: '3315180011',
    districtId: '3315180',
    name: 'Tajemsari',
  },
  {
    id: '3315180012',
    districtId: '3315180',
    name: 'Karangpasar',
  },
  {
    id: '3315180016',
    districtId: '3315180',
    name: 'Cangkring',
  },
  {
    id: '3315180017',
    districtId: '3315180',
    name: 'Gaji',
  },
  {
    id: '3315180018',
    districtId: '3315180',
    name: 'Tunjungharjo',
  },
  {
    id: '3315190001',
    districtId: '3315190',
    name: 'Ringinpitu',
  },
  {
    id: '3315190002',
    districtId: '3315190',
    name: 'Mrisi',
  },
  {
    id: '3315190003',
    districtId: '3315190',
    name: 'Ngambakrejo',
  },
  {
    id: '3315190004',
    districtId: '3315190',
    name: 'Kapung',
  },
  {
    id: '3315190005',
    districtId: '3315190',
    name: 'Kaliwenang',
  },
  {
    id: '3315190006',
    districtId: '3315190',
    name: 'Sugihmanik',
  },
  {
    id: '3315190007',
    districtId: '3315190',
    name: 'Tanggungharjo',
  },
  {
    id: '3315190008',
    districtId: '3315190',
    name: 'Brabo',
  },
  {
    id: '3315190009',
    districtId: '3315190',
    name: 'Padang',
  },
  {
    id: '3316010001',
    districtId: '3316010',
    name: 'Bangkleyan',
  },
  {
    id: '3316010002',
    districtId: '3316010',
    name: 'Gempol',
  },
  {
    id: '3316010003',
    districtId: '3316010',
    name: 'Kepoh',
  },
  {
    id: '3316010005',
    districtId: '3316010',
    name: 'Jegong',
  },
  {
    id: '3316010006',
    districtId: '3316010',
    name: 'Jati',
  },
  {
    id: '3316010007',
    districtId: '3316010',
    name: 'Singget',
  },
  {
    id: '3316010008',
    districtId: '3316010',
    name: 'Gabusan',
  },
  {
    id: '3316010009',
    districtId: '3316010',
    name: 'Doplang',
  },
  {
    id: '3316010010',
    districtId: '3316010',
    name: 'Randulawang',
  },
  {
    id: '3316010011',
    districtId: '3316010',
    name: 'Tobo',
  },
  {
    id: '3316010012',
    districtId: '3316010',
    name: 'Pengkoljagong',
  },
  {
    id: '3316020001',
    districtId: '3316020',
    name: 'Tlogotuwung',
  },
  {
    id: '3316020002',
    districtId: '3316020',
    name: 'Bodeh',
  },
  {
    id: '3316020003',
    districtId: '3316020',
    name: 'Gembyungan',
  },
  {
    id: '3316020004',
    districtId: '3316020',
    name: 'Sambongwangan',
  },
  {
    id: '3316020005',
    districtId: '3316020',
    name: 'Randublatung',
  },
  {
    id: '3316020006',
    districtId: '3316020',
    name: 'Pilang',
  },
  {
    id: '3316020008',
    districtId: '3316020',
    name: 'Sumberjo',
  },
  {
    id: '3316020009',
    districtId: '3316020',
    name: 'Kutukan',
  },
  {
    id: '3316020010',
    districtId: '3316020',
    name: 'Kalisari',
  },
  {
    id: '3316020011',
    districtId: '3316020',
    name: 'Kediren',
  },
  {
    id: '3316020013',
    districtId: '3316020',
    name: 'Kadengan',
  },
  {
    id: '3316020015',
    districtId: '3316020',
    name: 'Plosorejo',
  },
  {
    id: '3316020017',
    districtId: '3316020',
    name: 'Tanggel',
  },
  {
    id: '3316020018',
    districtId: '3316020',
    name: 'Ngliron',
  },
  {
    id: '3316030001',
    districtId: '3316030',
    name: 'Megeri',
  },
  {
    id: '3316030002',
    districtId: '3316030',
    name: 'Nglebak',
  },
  {
    id: '3316030003',
    districtId: '3316030',
    name: 'Getas',
  },
  {
    id: '3316030004',
    districtId: '3316030',
    name: 'Nginggil',
  },
  {
    id: '3316030005',
    districtId: '3316030',
    name: 'Ngrawoh',
  },
  {
    id: '3316030006',
    districtId: '3316030',
    name: 'Mendenrejo',
  },
  {
    id: '3316030008',
    districtId: '3316030',
    name: 'Mojorembun',
  },
  {
    id: '3316030009',
    districtId: '3316030',
    name: 'Medalem',
  },
  {
    id: '3316040001',
    districtId: '3316040',
    name: 'Gondel',
  },
  {
    id: '3316040002',
    districtId: '3316040',
    name: 'Ketuwan',
  },
  {
    id: '3316040003',
    districtId: '3316040',
    name: 'Jimbung',
  },
  {
    id: '3316040004',
    districtId: '3316040',
    name: 'Panolan',
  },
  {
    id: '3316040005',
    districtId: '3316040',
    name: 'Klagen',
  },
  {
    id: '3316040006',
    districtId: '3316040',
    name: 'Kemantren',
  },
  {
    id: '3316040007',
    districtId: '3316040',
    name: 'Sidorejo',
  },
  {
    id: '3316040008',
    districtId: '3316040',
    name: 'Wado',
  },
  {
    id: '3316040009',
    districtId: '3316040',
    name: 'Pulo',
  },
  {
    id: '3316040010',
    districtId: '3316040',
    name: 'Tanjung',
  },
  {
    id: '3316040011',
    districtId: '3316040',
    name: 'Sogo',
  },
  {
    id: '3316040012',
    districtId: '3316040',
    name: 'Bajo',
  },
  {
    id: '3316040013',
    districtId: '3316040',
    name: 'Nglandeyan',
  },
  {
    id: '3316040014',
    districtId: '3316040',
    name: 'Kalen',
  },
  {
    id: '3316040015',
    districtId: '3316040',
    name: 'Ngraho',
  },
  {
    id: '3316040016',
    districtId: '3316040',
    name: 'Kedungtuban',
  },
  {
    id: '3316040017',
    districtId: '3316040',
    name: 'Galuk',
  },
  {
    id: '3316050001',
    districtId: '3316050',
    name: 'Gadon',
  },
  {
    id: '3316050002',
    districtId: '3316050',
    name: 'Ngloram',
  },
  {
    id: '3316050003',
    districtId: '3316050',
    name: 'Cabeyan',
  },
  {
    id: '3316050004',
    districtId: '3316050',
    name: 'Kapuan',
  },
  {
    id: '3316050005',
    districtId: '3316050',
    name: 'Jipang',
  },
  {
    id: '3316050006',
    districtId: '3316050',
    name: 'Getas',
  },
  {
    id: '3316050007',
    districtId: '3316050',
    name: 'Sumberpitu',
  },
  {
    id: '3316050008',
    districtId: '3316050',
    name: 'Kentong',
  },
  {
    id: '3316050010',
    districtId: '3316050',
    name: 'Mulyorejo',
  },
  {
    id: '3316050011',
    districtId: '3316050',
    name: 'Tambakromo',
  },
  {
    id: '3316050012',
    districtId: '3316050',
    name: 'Nglanjuk',
  },
  {
    id: '3316050013',
    districtId: '3316050',
    name: 'Balun',
  },
  {
    id: '3316050015',
    districtId: '3316050',
    name: 'Ngelo',
  },
  {
    id: '3316050016',
    districtId: '3316050',
    name: 'Karangboyo',
  },
  {
    id: '3316050017',
    districtId: '3316050',
    name: 'Ngroto',
  },
  {
    id: '3316060002',
    districtId: '3316060',
    name: 'Sambongrejo',
  },
  {
    id: '3316060003',
    districtId: '3316060',
    name: 'Gadu',
  },
  {
    id: '3316060004',
    districtId: '3316060',
    name: 'Sambong',
  },
  {
    id: '3316060005',
    districtId: '3316060',
    name: 'Pojokwatu',
  },
  {
    id: '3316060006',
    districtId: '3316060',
    name: 'Gagakan',
  },
  {
    id: '3316060007',
    districtId: '3316060',
    name: 'Biting',
  },
  {
    id: '3316060008',
    districtId: '3316060',
    name: 'Brabowan',
  },
  {
    id: '3316060009',
    districtId: '3316060',
    name: 'Ledok',
  },
  {
    id: '3316060010',
    districtId: '3316060',
    name: 'Giyanti',
  },
  {
    id: '3316070001',
    districtId: '3316070',
    name: 'Nglobo',
  },
  {
    id: '3316070002',
    districtId: '3316070',
    name: 'Cabak',
  },
  {
    id: '3316070004',
    districtId: '3316070',
    name: 'Janjang',
  },
  {
    id: '3316070005',
    districtId: '3316070',
    name: 'Bleboh',
  },
  {
    id: '3316070006',
    districtId: '3316070',
    name: 'Ketringan',
  },
  {
    id: '3316070007',
    districtId: '3316070',
    name: 'Singonegoro',
  },
  {
    id: '3316070008',
    districtId: '3316070',
    name: 'Jiken',
  },
  {
    id: '3316070009',
    districtId: '3316070',
    name: 'Genjahan',
  },
  {
    id: '3316070010',
    districtId: '3316070',
    name: 'Jiworejo',
  },
  {
    id: '3316070011',
    districtId: '3316070',
    name: 'Bangowan',
  },
  {
    id: '3316080001',
    districtId: '3316080',
    name: 'Gombang',
  },
  {
    id: '3316080002',
    districtId: '3316080',
    name: 'Sarirejo',
  },
  {
    id: '3316080003',
    districtId: '3316080',
    name: 'Karanganyar',
  },
  {
    id: '3316080004',
    districtId: '3316080',
    name: 'Karang',
  },
  {
    id: '3316080005',
    districtId: '3316080',
    name: 'Prantaan',
  },
  {
    id: '3316080007',
    districtId: '3316080',
    name: 'Bogorejo',
  },
  {
    id: '3316080008',
    districtId: '3316080',
    name: 'Gembol',
  },
  {
    id: '3316080009',
    districtId: '3316080',
    name: 'Tempurejo',
  },
  {
    id: '3316080010',
    districtId: '3316080',
    name: 'Gayam',
  },
  {
    id: '3316080011',
    districtId: '3316080',
    name: 'Sendangrejo',
  },
  {
    id: '3316080012',
    districtId: '3316080',
    name: 'Gandu',
  },
  {
    id: '3316080013',
    districtId: '3316080',
    name: 'Nglengkir',
  },
  {
    id: '3316080014',
    districtId: '3316080',
    name: 'Jurangjero',
  },
  {
    id: '3316090002',
    districtId: '3316090',
    name: 'Semanggi',
  },
  {
    id: '3316090003',
    districtId: '3316090',
    name: 'Ngampon',
  },
  {
    id: '3316090004',
    districtId: '3316090',
    name: 'Jomblang',
  },
  {
    id: '3316090005',
    districtId: '3316090',
    name: 'Palon',
  },
  {
    id: '3316090006',
    districtId: '3316090',
    name: 'Bangsri',
  },
  {
    id: '3316090007',
    districtId: '3316090',
    name: 'Sumurboto',
  },
  {
    id: '3316090009',
    districtId: '3316090',
    name: 'Turirejo',
  },
  {
    id: '3316090010',
    districtId: '3316090',
    name: 'Semampir',
  },
  {
    id: '3316090011',
    districtId: '3316090',
    name: 'Kemiri',
  },
  {
    id: '3316090012',
    districtId: '3316090',
    name: 'Tempellemahbang',
  },
  {
    id: '3316090013',
    districtId: '3316090',
    name: 'Jepon',
  },
  {
    id: '3316090014',
    districtId: '3316090',
    name: 'Seso',
  },
  {
    id: '3316090015',
    districtId: '3316090',
    name: 'Balong',
  },
  {
    id: '3316090017',
    districtId: '3316090',
    name: 'Nglarohgunung',
  },
  {
    id: '3316090018',
    districtId: '3316090',
    name: 'Kawengan',
  },
  {
    id: '3316090019',
    districtId: '3316090',
    name: 'Gersi',
  },
  {
    id: '3316090020',
    districtId: '3316090',
    name: 'Gedangdowo',
  },
  {
    id: '3316090021',
    districtId: '3316090',
    name: 'Puledagel',
  },
  {
    id: '3316090022',
    districtId: '3316090',
    name: 'Bacem',
  },
  {
    id: '3316090023',
    districtId: '3316090',
    name: 'Jatirejo',
  },
  {
    id: '3316090024',
    districtId: '3316090',
    name: 'Soko',
  },
  {
    id: '3316090025',
    districtId: '3316090',
    name: 'Waru',
  },
  {
    id: '3316100001',
    districtId: '3316100',
    name: 'Jepangrejo',
  },
  {
    id: '3316100002',
    districtId: '3316100',
    name: 'Kamolan',
  },
  {
    id: '3316100004',
    districtId: '3316100',
    name: 'Purworejo',
  },
  {
    id: '3316100005',
    districtId: '3316100',
    name: 'Andongrejo',
  },
  {
    id: '3316100006',
    districtId: '3316100',
    name: 'Beran',
  },
  {
    id: '3316100008',
    districtId: '3316100',
    name: 'Bangkle',
  },
  {
    id: '3316100009',
    districtId: '3316100',
    name: 'Kedungjenar',
  },
  {
    id: '3316100010',
    districtId: '3316100',
    name: 'Mlangsen',
  },
  {
    id: '3316100011',
    districtId: '3316100',
    name: 'Jetis',
  },
  {
    id: '3316100012',
    districtId: '3316100',
    name: 'Tambahrejo',
  },
  {
    id: '3316100013',
    districtId: '3316100',
    name: 'Kauman',
  },
  {
    id: '3316100014',
    districtId: '3316100',
    name: 'Sonorejo',
  },
  {
    id: '3316100016',
    districtId: '3316100',
    name: 'Tempelan',
  },
  {
    id: '3316100017',
    districtId: '3316100',
    name: 'Tegalgunung',
  },
  {
    id: '3316100018',
    districtId: '3316100',
    name: 'Karangjati',
  },
  {
    id: '3316100019',
    districtId: '3316100',
    name: 'Temurejo',
  },
  {
    id: '3316100020',
    districtId: '3316100',
    name: 'Tempurejo',
  },
  {
    id: '3316100021',
    districtId: '3316100',
    name: 'Patalan',
  },
  {
    id: '3316100022',
    districtId: '3316100',
    name: 'Tambaksari',
  },
  {
    id: '3316100023',
    districtId: '3316100',
    name: 'Purwosari',
  },
  {
    id: '3316100024',
    districtId: '3316100',
    name: 'Ngadipurwo',
  },
  {
    id: '3316100025',
    districtId: '3316100',
    name: 'Sendangharjo',
  },
  {
    id: '3316100026',
    districtId: '3316100',
    name: 'Tempuran',
  },
  {
    id: '3316100027',
    districtId: '3316100',
    name: 'Plantungan',
  },
  {
    id: '3316100028',
    districtId: '3316100',
    name: 'Ngampel',
  },
  {
    id: '3316110001',
    districtId: '3316110',
    name: 'Jatisari',
  },
  {
    id: '3316110002',
    districtId: '3316110',
    name: 'Jatiklampok',
  },
  {
    id: '3316110003',
    districtId: '3316110',
    name: 'Sidomulyo',
  },
  {
    id: '3316110004',
    districtId: '3316110',
    name: 'Balongsari',
  },
  {
    id: '3316110005',
    districtId: '3316110',
    name: 'Bacem',
  },
  {
    id: '3316110006',
    districtId: '3316110',
    name: 'Wonosemi',
  },
  {
    id: '3316110007',
    districtId: '3316110',
    name: 'Sendanggayam',
  },
  {
    id: '3316110008',
    districtId: '3316110',
    name: 'Banjarejo',
  },
  {
    id: '3316110009',
    districtId: '3316110',
    name: 'Mojowetan',
  },
  {
    id: '3316110010',
    districtId: '3316110',
    name: 'Sumberagung',
  },
  {
    id: '3316110011',
    districtId: '3316110',
    name: 'Klopoduwur',
  },
  {
    id: '3316110012',
    districtId: '3316110',
    name: 'Gedongsari',
  },
  {
    id: '3316110013',
    districtId: '3316110',
    name: 'Sendangwungu',
  },
  {
    id: '3316110014',
    districtId: '3316110',
    name: 'Balongrejo',
  },
  {
    id: '3316110015',
    districtId: '3316110',
    name: 'Karangtalun',
  },
  {
    id: '3316110016',
    districtId: '3316110',
    name: 'Kebonrejo',
  },
  {
    id: '3316110017',
    districtId: '3316110',
    name: 'Sembongin',
  },
  {
    id: '3316110018',
    districtId: '3316110',
    name: 'Kembang',
  },
  {
    id: '3316110019',
    districtId: '3316110',
    name: 'Plosorejo',
  },
  {
    id: '3316110020',
    districtId: '3316110',
    name: 'Buluroto',
  },
  {
    id: '3316120001',
    districtId: '3316120',
    name: 'Tawangrejo',
  },
  {
    id: '3316120002',
    districtId: '3316120',
    name: 'Kedungringin',
  },
  {
    id: '3316120003',
    districtId: '3316120',
    name: 'Adirejo',
  },
  {
    id: '3316120004',
    districtId: '3316120',
    name: 'Tamanrejo',
  },
  {
    id: '3316120006',
    districtId: '3316120',
    name: 'Sukorejo',
  },
  {
    id: '3316120007',
    districtId: '3316120',
    name: 'Tambahrejo',
  },
  {
    id: '3316120008',
    districtId: '3316120',
    name: 'Kalangan',
  },
  {
    id: '3316120009',
    districtId: '3316120',
    name: 'Sambongrejo',
  },
  {
    id: '3316120010',
    districtId: '3316120',
    name: 'Tunjungan',
  },
  {
    id: '3316120011',
    districtId: '3316120',
    name: 'Kedungrejo',
  },
  {
    id: '3316120012',
    districtId: '3316120',
    name: 'Gempolrejo',
  },
  {
    id: '3316120013',
    districtId: '3316120',
    name: 'Nglangitan',
  },
  {
    id: '3316120015',
    districtId: '3316120',
    name: 'Sitirejo',
  },
  {
    id: '3316130001',
    districtId: '3316130',
    name: 'Ngapus',
  },
  {
    id: '3316130002',
    districtId: '3316130',
    name: 'Krocok',
  },
  {
    id: '3316130004',
    districtId: '3316130',
    name: 'Harjowinangun',
  },
  {
    id: '3316130005',
    districtId: '3316130',
    name: 'Beganjing',
  },
  {
    id: '3316130006',
    districtId: '3316130',
    name: 'Ngrambitan',
  },
  {
    id: '3316130007',
    districtId: '3316130',
    name: 'Pengkolrejo',
  },
  {
    id: '3316130008',
    districtId: '3316130',
    name: 'Bogorejo',
  },
  {
    id: '3316130009',
    districtId: '3316130',
    name: 'Wotbakah',
  },
  {
    id: '3316130010',
    districtId: '3316130',
    name: 'Padaan',
  },
  {
    id: '3316130011',
    districtId: '3316130',
    name: 'Japah',
  },
  {
    id: '3316130012',
    districtId: '3316130',
    name: 'Dologan',
  },
  {
    id: '3316130013',
    districtId: '3316130',
    name: 'Tlogowungu',
  },
  {
    id: '3316130014',
    districtId: '3316130',
    name: 'Bogem',
  },
  {
    id: '3316130015',
    districtId: '3316130',
    name: 'Sumberejo',
  },
  {
    id: '3316130016',
    districtId: '3316130',
    name: 'Ngiyono',
  },
  {
    id: '3316130017',
    districtId: '3316130',
    name: 'Gaplokan',
  },
  {
    id: '3316130018',
    districtId: '3316130',
    name: 'Kalinanas',
  },
  {
    id: '3316140001',
    districtId: '3316140',
    name: 'Rowobungkul',
  },
  {
    id: '3316140003',
    districtId: '3316140',
    name: 'Sambonganyar',
  },
  {
    id: '3316140004',
    districtId: '3316140',
    name: 'Kendayaan',
  },
  {
    id: '3316140005',
    districtId: '3316140',
    name: 'Plumbon',
  },
  {
    id: '3316140006',
    districtId: '3316140',
    name: 'Bergolo',
  },
  {
    id: '3316140007',
    districtId: '3316140',
    name: 'Bandungrojo',
  },
  {
    id: '3316140008',
    districtId: '3316140',
    name: 'Kedungsatriyan',
  },
  {
    id: '3316140009',
    districtId: '3316140',
    name: 'Karangtengah',
  },
  {
    id: '3316140010',
    districtId: '3316140',
    name: 'Jetakwanger',
  },
  {
    id: '3316140011',
    districtId: '3316140',
    name: 'Sumberejo',
  },
  {
    id: '3316140012',
    districtId: '3316140',
    name: 'Sendangagung',
  },
  {
    id: '3316140013',
    districtId: '3316140',
    name: 'Sendangrejo',
  },
  {
    id: '3316140014',
    districtId: '3316140',
    name: 'Talokwohmojo',
  },
  {
    id: '3316140015',
    districtId: '3316140',
    name: 'Trembulrejo',
  },
  {
    id: '3316140016',
    districtId: '3316140',
    name: 'Punggursugih',
  },
  {
    id: '3316140017',
    districtId: '3316140',
    name: 'Gondang',
  },
  {
    id: '3316140018',
    districtId: '3316140',
    name: 'Ngawen',
  },
  {
    id: '3316140019',
    districtId: '3316140',
    name: 'Berbak',
  },
  {
    id: '3316140020',
    districtId: '3316140',
    name: 'Sarimulyo',
  },
  {
    id: '3316140021',
    districtId: '3316140',
    name: 'Sendangmulyo',
  },
  {
    id: '3316140022',
    districtId: '3316140',
    name: 'Wantilgung',
  },
  {
    id: '3316140023',
    districtId: '3316140',
    name: 'Bogowanti',
  },
  {
    id: '3316140024',
    districtId: '3316140',
    name: 'Sambongrejo',
  },
  {
    id: '3316140025',
    districtId: '3316140',
    name: 'Gotputuk',
  },
  {
    id: '3316140026',
    districtId: '3316140',
    name: 'Bradag',
  },
  {
    id: '3316140027',
    districtId: '3316140',
    name: 'Semawur',
  },
  {
    id: '3316140028',
    districtId: '3316140',
    name: 'Srigading',
  },
  {
    id: '3316140029',
    districtId: '3316140',
    name: 'Karangjong',
  },
  {
    id: '3316150001',
    districtId: '3316150',
    name: 'Botoreco',
  },
  {
    id: '3316150002',
    districtId: '3316150',
    name: 'Buloh',
  },
  {
    id: '3316150003',
    districtId: '3316150',
    name: 'Kemiri',
  },
  {
    id: '3316150004',
    districtId: '3316150',
    name: 'Kodokan',
  },
  {
    id: '3316150005',
    districtId: '3316150',
    name: 'Sonokidul',
  },
  {
    id: '3316150008',
    districtId: '3316150',
    name: 'Ploso Rejo',
  },
  {
    id: '3316150009',
    districtId: '3316150',
    name: 'Ngilen',
  },
  {
    id: '3316150010',
    districtId: '3316150',
    name: 'Bakah',
  },
  {
    id: '3316150011',
    districtId: '3316150',
    name: 'Kalangrejo',
  },
  {
    id: '3316150012',
    districtId: '3316150',
    name: 'Blumbangrejo',
  },
  {
    id: '3316150013',
    districtId: '3316150',
    name: 'Tawangrejo',
  },
  {
    id: '3316150014',
    districtId: '3316150',
    name: 'Klokah',
  },
  {
    id: '3316150015',
    districtId: '3316150',
    name: 'Jetak',
  },
  {
    id: '3316150016',
    districtId: '3316150',
    name: 'Muraharjo',
  },
  {
    id: '3316150017',
    districtId: '3316150',
    name: 'Jagong',
  },
  {
    id: '3316150018',
    districtId: '3316150',
    name: 'Kunduran',
  },
  {
    id: '3316150019',
    districtId: '3316150',
    name: 'Gagaan',
  },
  {
    id: '3316150020',
    districtId: '3316150',
    name: 'Sambiroto',
  },
  {
    id: '3316150021',
    districtId: '3316150',
    name: 'Bejirejo',
  },
  {
    id: '3316150022',
    districtId: '3316150',
    name: 'Karanggeneng',
  },
  {
    id: '3316150023',
    districtId: '3316150',
    name: 'Balong',
  },
  {
    id: '3316150024',
    districtId: '3316150',
    name: 'Ngawenombo',
  },
  {
    id: '3316150025',
    districtId: '3316150',
    name: 'Sendangwates',
  },
  {
    id: '3316150026',
    districtId: '3316150',
    name: 'Kedungwaru',
  },
  {
    id: '3316160001',
    districtId: '3316160',
    name: 'Pelemsengir',
  },
  {
    id: '3316160002',
    districtId: '3316160',
    name: 'Prigi',
  },
  {
    id: '3316160003',
    districtId: '3316160',
    name: 'Sambeng',
  },
  {
    id: '3316160004',
    districtId: '3316160',
    name: 'Tinapan',
  },
  {
    id: '3316160006',
    districtId: '3316160',
    name: 'Sonokulon',
  },
  {
    id: '3316160008',
    districtId: '3316160',
    name: 'Kacangan',
  },
  {
    id: '3316160009',
    districtId: '3316160',
    name: 'Bicak',
  },
  {
    id: '3316160010',
    districtId: '3316160',
    name: 'Sendang',
  },
  {
    id: '3316160011',
    districtId: '3316160',
    name: 'Wukirsari',
  },
  {
    id: '3316160012',
    districtId: '3316160',
    name: 'Karanganyar',
  },
  {
    id: '3316160013',
    districtId: '3316160',
    name: 'Todanan',
  },
  {
    id: '3316160014',
    districtId: '3316160',
    name: 'Ketileng',
  },
  {
    id: '3316160015',
    districtId: '3316160',
    name: 'Cokrowati',
  },
  {
    id: '3316160016',
    districtId: '3316160',
    name: 'Kajengan',
  },
  {
    id: '3316160017',
    districtId: '3316160',
    name: 'Gunungan',
  },
  {
    id: '3316160018',
    districtId: '3316160',
    name: 'Dringo',
  },
  {
    id: '3316160019',
    districtId: '3316160',
    name: 'Dalangan',
  },
  {
    id: '3316160020',
    districtId: '3316160',
    name: 'Candi',
  },
  {
    id: '3316160021',
    districtId: '3316160',
    name: 'Gondoriyo',
  },
  {
    id: '3316160022',
    districtId: '3316160',
    name: 'Kembang',
  },
  {
    id: '3316160023',
    districtId: '3316160',
    name: 'Bedingin',
  },
  {
    id: '3316160024',
    districtId: '3316160',
    name: 'Ledok',
  },
  {
    id: '3316160025',
    districtId: '3316160',
    name: 'Kedungbacin',
  },
  {
    id: '3317010001',
    districtId: '3317010',
    name: 'Ronggomulyo',
  },
  {
    id: '3317010002',
    districtId: '3317010',
    name: 'Logede',
  },
  {
    id: '3317010003',
    districtId: '3317010',
    name: 'Pelemsari',
  },
  {
    id: '3317010004',
    districtId: '3317010',
    name: 'Logung',
  },
  {
    id: '3317010005',
    districtId: '3317010',
    name: 'Krikilan',
  },
  {
    id: '3317010007',
    districtId: '3317010',
    name: 'Jatihadi',
  },
  {
    id: '3317010008',
    districtId: '3317010',
    name: 'Polbayem',
  },
  {
    id: '3317010010',
    districtId: '3317010',
    name: 'Jadi',
  },
  {
    id: '3317010011',
    districtId: '3317010',
    name: 'Grawan',
  },
  {
    id: '3317010012',
    districtId: '3317010',
    name: 'Randuagung',
  },
  {
    id: '3317010013',
    districtId: '3317010',
    name: 'Sukorejo',
  },
  {
    id: '3317010014',
    districtId: '3317010',
    name: 'Tlogotunggal',
  },
  {
    id: '3317010015',
    districtId: '3317010',
    name: 'Bogorejo',
  },
  {
    id: '3317010017',
    districtId: '3317010',
    name: 'Kedungasem',
  },
  {
    id: '3317010018',
    districtId: '3317010',
    name: 'Sekarsari',
  },
  {
    id: '3317020001',
    districtId: '3317020',
    name: 'Mlatirejo',
  },
  {
    id: '3317020002',
    districtId: '3317020',
    name: 'Sendangmulyo',
  },
  {
    id: '3317020003',
    districtId: '3317020',
    name: 'Pondokrejo',
  },
  {
    id: '3317020004',
    districtId: '3317020',
    name: 'Warugunung',
  },
  {
    id: '3317020005',
    districtId: '3317020',
    name: 'Pinggan',
  },
  {
    id: '3317020006',
    districtId: '3317020',
    name: 'Cabean',
  },
  {
    id: '3317020007',
    districtId: '3317020',
    name: 'Lambangan Kulon',
  },
  {
    id: '3317020008',
    districtId: '3317020',
    name: 'Lambangan Wetan',
  },
  {
    id: '3317020009',
    districtId: '3317020',
    name: 'Sumbermulyo',
  },
  {
    id: '3317020010',
    districtId: '3317020',
    name: 'Karangasem',
  },
  {
    id: '3317020011',
    districtId: '3317020',
    name: 'Pasedan',
  },
  {
    id: '3317020012',
    districtId: '3317020',
    name: 'Ngulaan',
  },
  {
    id: '3317020015',
    districtId: '3317020',
    name: 'Mantingan',
  },
  {
    id: '3317020016',
    districtId: '3317020',
    name: 'Kadiwono',
  },
  {
    id: '3317030001',
    districtId: '3317030',
    name: 'Kajar',
  },
  {
    id: '3317030002',
    districtId: '3317030',
    name: 'Timbrangan',
  },
  {
    id: '3317030003',
    districtId: '3317030',
    name: 'Tegaldowo',
  },
  {
    id: '3317030004',
    districtId: '3317030',
    name: 'Pasucen',
  },
  {
    id: '3317030005',
    districtId: '3317030',
    name: 'Suntri',
  },
  {
    id: '3317030006',
    districtId: '3317030',
    name: 'Dowan',
  },
  {
    id: '3317030009',
    districtId: '3317030',
    name: 'Kulutan',
  },
  {
    id: '3317030010',
    districtId: '3317030',
    name: 'Sidomulyo',
  },
  {
    id: '3317030011',
    districtId: '3317030',
    name: 'Telgawah',
  },
  {
    id: '3317030012',
    districtId: '3317030',
    name: 'Sendangmulyo',
  },
  {
    id: '3317030013',
    districtId: '3317030',
    name: 'Panohan',
  },
  {
    id: '3317030014',
    districtId: '3317030',
    name: 'Demaan',
  },
  {
    id: '3317030015',
    districtId: '3317030',
    name: 'Banyuurip',
  },
  {
    id: '3317030016',
    districtId: '3317030',
    name: 'Sambongpayak',
  },
  {
    id: '3317040001',
    districtId: '3317040',
    name: 'Tahunan',
  },
  {
    id: '3317040002',
    districtId: '3317040',
    name: 'Ngajaran',
  },
  {
    id: '3317040003',
    districtId: '3317040',
    name: 'Mrayun',
  },
  {
    id: '3317040004',
    districtId: '3317040',
    name: 'Bancang',
  },
  {
    id: '3317040005',
    districtId: '3317040',
    name: 'Sale',
  },
  {
    id: '3317040006',
    districtId: '3317040',
    name: 'Joho',
  },
  {
    id: '3317040007',
    districtId: '3317040',
    name: 'Jinanten',
  },
  {
    id: '3317040008',
    districtId: '3317040',
    name: 'Gading',
  },
  {
    id: '3317040009',
    districtId: '3317040',
    name: 'Wonokerto',
  },
  {
    id: '3317040010',
    districtId: '3317040',
    name: 'Sumbermulyo',
  },
  {
    id: '3317040012',
    districtId: '3317040',
    name: 'Bitingan',
  },
  {
    id: '3317040013',
    districtId: '3317040',
    name: 'Pakis',
  },
  {
    id: '3317040014',
    districtId: '3317040',
    name: 'Ukir',
  },
  {
    id: '3317050001',
    districtId: '3317050',
    name: 'Lodan Kulon',
  },
  {
    id: '3317050002',
    districtId: '3317050',
    name: 'Lodan Wetan',
  },
  {
    id: '3317050003',
    districtId: '3317050',
    name: 'Bonjor',
  },
  {
    id: '3317050004',
    districtId: '3317050',
    name: 'Tawangrejo',
  },
  {
    id: '3317050005',
    districtId: '3317050',
    name: 'Sampung',
  },
  {
    id: '3317050006',
    districtId: '3317050',
    name: 'Baturno',
  },
  {
    id: '3317050007',
    districtId: '3317050',
    name: 'Babaktulung',
  },
  {
    id: '3317050008',
    districtId: '3317050',
    name: 'Nglojo',
  },
  {
    id: '3317050009',
    districtId: '3317050',
    name: 'Jambangan',
  },
  {
    id: '3317050010',
    districtId: '3317050',
    name: 'Pelang',
  },
  {
    id: '3317050011',
    districtId: '3317050',
    name: 'Gilis',
  },
  {
    id: '3317050012',
    districtId: '3317050',
    name: 'Gunungmulyo',
  },
  {
    id: '3317050013',
    districtId: '3317050',
    name: 'Gonggang',
  },
  {
    id: '3317050014',
    districtId: '3317050',
    name: 'Sumbermulyo',
  },
  {
    id: '3317050015',
    districtId: '3317050',
    name: 'Kalipang',
  },
  {
    id: '3317050016',
    districtId: '3317050',
    name: 'Dadapmulyo',
  },
  {
    id: '3317050017',
    districtId: '3317050',
    name: 'Sendangmulyo',
  },
  {
    id: '3317050018',
    districtId: '3317050',
    name: 'Banowan',
  },
  {
    id: '3317050019',
    districtId: '3317050',
    name: 'Temperak',
  },
  {
    id: '3317050020',
    districtId: '3317050',
    name: 'Karangmangu',
  },
  {
    id: '3317050021',
    districtId: '3317050',
    name: 'Bajingjowo',
  },
  {
    id: '3317050022',
    districtId: '3317050',
    name: 'Bajingmeduro',
  },
  {
    id: '3317050023',
    districtId: '3317050',
    name: 'Sarangmeduro',
  },
  {
    id: '3317060001',
    districtId: '3317060',
    name: 'Ngulahan',
  },
  {
    id: '3317060002',
    districtId: '3317060',
    name: 'Pacing',
  },
  {
    id: '3317060003',
    districtId: '3317060',
    name: 'Karas',
  },
  {
    id: '3317060004',
    districtId: '3317060',
    name: 'Mojosari',
  },
  {
    id: '3317060005',
    districtId: '3317060',
    name: 'Gesikan',
  },
  {
    id: '3317060006',
    districtId: '3317060',
    name: 'Sambiroto',
  },
  {
    id: '3317060007',
    districtId: '3317060',
    name: 'Sedan',
  },
  {
    id: '3317060008',
    districtId: '3317060',
    name: 'Karangasem',
  },
  {
    id: '3317060009',
    districtId: '3317060',
    name: 'Sidorejo',
  },
  {
    id: '3317060010',
    districtId: '3317060',
    name: 'Sidomulyo',
  },
  {
    id: '3317060011',
    districtId: '3317060',
    name: 'Kedungringin',
  },
  {
    id: '3317060012',
    districtId: '3317060',
    name: 'Gandrirojo',
  },
  {
    id: '3317060013',
    districtId: '3317060',
    name: 'Candimulyo',
  },
  {
    id: '3317060014',
    districtId: '3317060',
    name: 'Lemahputih',
  },
  {
    id: '3317060015',
    districtId: '3317060',
    name: 'Kumbo',
  },
  {
    id: '3317060016',
    districtId: '3317060',
    name: 'Dadapan',
  },
  {
    id: '3317060017',
    districtId: '3317060',
    name: 'Sambong',
  },
  {
    id: '3317060018',
    districtId: '3317060',
    name: 'Bogorejo',
  },
  {
    id: '3317060019',
    districtId: '3317060',
    name: 'Kenongo',
  },
  {
    id: '3317060020',
    districtId: '3317060',
    name: 'Jambeyan',
  },
  {
    id: '3317060021',
    districtId: '3317060',
    name: 'Menoro',
  },
  {
    id: '3317070001',
    districtId: '3317070',
    name: 'Megal',
  },
  {
    id: '3317070002',
    districtId: '3317070',
    name: 'Ngemplakrejo',
  },
  {
    id: '3317070003',
    districtId: '3317070',
    name: 'Pragen',
  },
  {
    id: '3317070004',
    districtId: '3317070',
    name: 'Samaran',
  },
  {
    id: '3317070005',
    districtId: '3317070',
    name: 'Gambiran',
  },
  {
    id: '3317070006',
    districtId: '3317070',
    name: 'Bamban',
  },
  {
    id: '3317070007',
    districtId: '3317070',
    name: 'Bangunrejo',
  },
  {
    id: '3317070008',
    districtId: '3317070',
    name: 'Pamotan',
  },
  {
    id: '3317070009',
    districtId: '3317070',
    name: 'Sidorejo',
  },
  {
    id: '3317070010',
    districtId: '3317070',
    name: 'Tempaling',
  },
  {
    id: '3317070011',
    districtId: '3317070',
    name: 'Joho',
  },
  {
    id: '3317070012',
    districtId: '3317070',
    name: 'Mlagen',
  },
  {
    id: '3317070013',
    districtId: '3317070',
    name: 'Kepohagung',
  },
  {
    id: '3317070014',
    districtId: '3317070',
    name: 'Mlawat',
  },
  {
    id: '3317070015',
    districtId: '3317070',
    name: 'Segoromulyo',
  },
  {
    id: '3317070016',
    districtId: '3317070',
    name: 'Ketangi',
  },
  {
    id: '3317070017',
    districtId: '3317070',
    name: 'Sendangagung',
  },
  {
    id: '3317070018',
    districtId: '3317070',
    name: 'Gegersimo',
  },
  {
    id: '3317070019',
    districtId: '3317070',
    name: 'Sumbangrejo',
  },
  {
    id: '3317070020',
    districtId: '3317070',
    name: 'Japerejo',
  },
  {
    id: '3317070022',
    districtId: '3317070',
    name: 'Ringin',
  },
  {
    id: '3317070023',
    districtId: '3317070',
    name: 'Sumberejo',
  },
  {
    id: '3317080001',
    districtId: '3317080',
    name: 'Tanjung',
  },
  {
    id: '3317080002',
    districtId: '3317080',
    name: 'Kemadu',
  },
  {
    id: '3317080003',
    districtId: '3317080',
    name: 'Sulang',
  },
  {
    id: '3317080004',
    districtId: '3317080',
    name: 'Pomahan',
  },
  {
    id: '3317080006',
    districtId: '3317080',
    name: 'Korowelang',
  },
  {
    id: '3317080007',
    districtId: '3317080',
    name: 'Karangharjo',
  },
  {
    id: '3317080008',
    districtId: '3317080',
    name: 'Jatimudo',
  },
  {
    id: '3317080009',
    districtId: '3317080',
    name: 'Kunir',
  },
  {
    id: '3317080011',
    districtId: '3317080',
    name: 'Bogorame',
  },
  {
    id: '3317080012',
    districtId: '3317080',
    name: 'Kaliombo',
  },
  {
    id: '3317080013',
    districtId: '3317080',
    name: 'Sudo',
  },
  {
    id: '3317080014',
    districtId: '3317080',
    name: 'Karangsari',
  },
  {
    id: '3317080015',
    districtId: '3317080',
    name: 'Pragu',
  },
  {
    id: '3317080016',
    districtId: '3317080',
    name: 'Kebonagung',
  },
  {
    id: '3317080018',
    districtId: '3317080',
    name: 'Pranti',
  },
  {
    id: '3317080019',
    districtId: '3317080',
    name: 'Pedak',
  },
  {
    id: '3317080020',
    districtId: '3317080',
    name: 'Landoh',
  },
  {
    id: '3317090002',
    districtId: '3317090',
    name: 'Maguan',
  },
  {
    id: '3317090003',
    districtId: '3317090',
    name: 'Sidomulyo',
  },
  {
    id: '3317090004',
    districtId: '3317090',
    name: 'Wiroto',
  },
  {
    id: '3317090005',
    districtId: '3317090',
    name: 'Banggi',
  },
  {
    id: '3317090006',
    districtId: '3317090',
    name: 'Kuangsan',
  },
  {
    id: '3317090007',
    districtId: '3317090',
    name: 'Gunungsari',
  },
  {
    id: '3317090008',
    districtId: '3317090',
    name: 'Sendangagung',
  },
  {
    id: '3317090009',
    districtId: '3317090',
    name: 'Karangsekar',
  },
  {
    id: '3317090010',
    districtId: '3317090',
    name: 'Babadan',
  },
  {
    id: '3317090011',
    districtId: '3317090',
    name: 'Pengkol',
  },
  {
    id: '3317090012',
    districtId: '3317090',
    name: 'Sambiyan',
  },
  {
    id: '3317090013',
    districtId: '3317090',
    name: 'Mojorembun',
  },
  {
    id: '3317090014',
    districtId: '3317090',
    name: 'Tunggulsari',
  },
  {
    id: '3317090015',
    districtId: '3317090',
    name: 'Tambakagung',
  },
  {
    id: '3317090016',
    districtId: '3317090',
    name: 'Mojowarno',
  },
  {
    id: '3317090017',
    districtId: '3317090',
    name: 'Dresi Kulon',
  },
  {
    id: '3317090018',
    districtId: '3317090',
    name: 'Dresi Wetan',
  },
  {
    id: '3317090019',
    districtId: '3317090',
    name: 'Tasikharjo',
  },
  {
    id: '3317090020',
    districtId: '3317090',
    name: 'Purworejo',
  },
  {
    id: '3317090021',
    districtId: '3317090',
    name: 'Bogoharjo',
  },
  {
    id: '3317090022',
    districtId: '3317090',
    name: 'Banyudono',
  },
  {
    id: '3317090023',
    districtId: '3317090',
    name: 'Pantiharjo',
  },
  {
    id: '3317100001',
    districtId: '3317100',
    name: 'Kedungrejo',
  },
  {
    id: '3317100004',
    districtId: '3317100',
    name: 'Sridadi',
  },
  {
    id: '3317100005',
    districtId: '3317100',
    name: 'Padaran',
  },
  {
    id: '3317100006',
    districtId: '3317100',
    name: 'Tlogomojo',
  },
  {
    id: '3317100007',
    districtId: '3317100',
    name: 'Kasreman',
  },
  {
    id: '3317100008',
    districtId: '3317100',
    name: 'Punjulharjo',
  },
  {
    id: '3317100009',
    districtId: '3317100',
    name: 'Tritunggal',
  },
  {
    id: '3317100010',
    districtId: '3317100',
    name: 'Pasarbanggi',
  },
  {
    id: '3317100011',
    districtId: '3317100',
    name: 'Gedangan',
  },
  {
    id: '3317100012',
    districtId: '3317100',
    name: 'Weton',
  },
  {
    id: '3317100013',
    districtId: '3317100',
    name: 'Ngotet',
  },
  {
    id: '3317100014',
    districtId: '3317100',
    name: 'Mondoteko',
  },
  {
    id: '3317100015',
    districtId: '3317100',
    name: 'Ngadem',
  },
  {
    id: '3317100016',
    districtId: '3317100',
    name: 'Ketanggi',
  },
  {
    id: '3317100017',
    districtId: '3317100',
    name: 'Pulo',
  },
  {
    id: '3317100018',
    districtId: '3317100',
    name: 'Waru',
  },
  {
    id: '3317100019',
    districtId: '3317100',
    name: 'Magersari',
  },
  {
    id: '3317100020',
    districtId: '3317100',
    name: 'Gegunung Kulon',
  },
  {
    id: '3317100021',
    districtId: '3317100',
    name: 'Gegunung Wetan',
  },
  {
    id: '3317100022',
    districtId: '3317100',
    name: 'Pacar',
  },
  {
    id: '3317100023',
    districtId: '3317100',
    name: 'Tanjungsari',
  },
  {
    id: '3317100024',
    districtId: '3317100',
    name: 'Sumberjo',
  },
  {
    id: '3317100025',
    districtId: '3317100',
    name: 'Tasikagung',
  },
  {
    id: '3317100026',
    districtId: '3317100',
    name: 'Sawahan',
  },
  {
    id: '3317100028',
    districtId: '3317100',
    name: 'Sidowayah',
  },
  {
    id: '3317100029',
    districtId: '3317100',
    name: 'Kutoharjo',
  },
  {
    id: '3317100030',
    districtId: '3317100',
    name: 'Pandean',
  },
  {
    id: '3317100031',
    districtId: '3317100',
    name: 'Sukoharjo',
  },
  {
    id: '3317100032',
    districtId: '3317100',
    name: 'Kabongan Lor',
  },
  {
    id: '3317100033',
    districtId: '3317100',
    name: 'Kabongan Kidul',
  },
  {
    id: '3317100034',
    districtId: '3317100',
    name: 'Tireman',
  },
  {
    id: '3317110001',
    districtId: '3317110',
    name: 'Japeledok',
  },
  {
    id: '3317110003',
    districtId: '3317110',
    name: 'Doropayung',
  },
  {
    id: '3317110004',
    districtId: '3317110',
    name: 'Karaskepoh',
  },
  {
    id: '3317110005',
    districtId: '3317110',
    name: 'Tuyuhan',
  },
  {
    id: '3317110006',
    districtId: '3317110',
    name: 'Pandan',
  },
  {
    id: '3317110007',
    districtId: '3317110',
    name: 'Gemblengmulyo',
  },
  {
    id: '3317110008',
    districtId: '3317110',
    name: 'Sumberagung',
  },
  {
    id: '3317110009',
    districtId: '3317110',
    name: 'Kalitengah',
  },
  {
    id: '3317110010',
    districtId: '3317110',
    name: 'Sidowayah',
  },
  {
    id: '3317110012',
    districtId: '3317110',
    name: 'Punggurharjo',
  },
  {
    id: '3317110013',
    districtId: '3317110',
    name: 'Langkir',
  },
  {
    id: '3317110014',
    districtId: '3317110',
    name: 'Pancur',
  },
  {
    id: '3317110015',
    districtId: '3317110',
    name: 'Pohlandak',
  },
  {
    id: '3317110016',
    districtId: '3317110',
    name: 'Warugunung',
  },
  {
    id: '3317110017',
    districtId: '3317110',
    name: 'Criwik',
  },
  {
    id: '3317110019',
    districtId: '3317110',
    name: 'Ngulangan',
  },
  {
    id: '3317110020',
    districtId: '3317110',
    name: 'Banyuurip',
  },
  {
    id: '3317110021',
    districtId: '3317110',
    name: 'Johogunung',
  },
  {
    id: '3317110022',
    districtId: '3317110',
    name: 'Trenggulunan',
  },
  {
    id: '3317110023',
    districtId: '3317110',
    name: 'Ngroto',
  },
  {
    id: '3317120001',
    districtId: '3317120',
    name: 'Tanjungsari',
  },
  {
    id: '3317120002',
    districtId: '3317120',
    name: 'Sendangmulyo',
  },
  {
    id: '3317120003',
    districtId: '3317120',
    name: 'Sendangwaru',
  },
  {
    id: '3317120004',
    districtId: '3317120',
    name: 'Ngasinan',
  },
  {
    id: '3317120005',
    districtId: '3317120',
    name: 'Kendalagung',
  },
  {
    id: '3317120006',
    districtId: '3317120',
    name: 'Mojokerto',
  },
  {
    id: '3317120007',
    districtId: '3317120',
    name: 'Tanjungan',
  },
  {
    id: '3317120008',
    districtId: '3317120',
    name: 'Kebloran',
  },
  {
    id: '3317120009',
    districtId: '3317120',
    name: 'Karanganyar',
  },
  {
    id: '3317120010',
    districtId: '3317120',
    name: 'Karanglincak',
  },
  {
    id: '3317120011',
    districtId: '3317120',
    name: 'Karangharjo',
  },
  {
    id: '3317120012',
    districtId: '3317120',
    name: 'Kragan',
  },
  {
    id: '3317120013',
    districtId: '3317120',
    name: 'Tegalmulyo',
  },
  {
    id: '3317120014',
    districtId: '3317120',
    name: 'Balongmulyo',
  },
  {
    id: '3317120015',
    districtId: '3317120',
    name: 'Narukan',
  },
  {
    id: '3317120016',
    districtId: '3317120',
    name: 'Sudan',
  },
  {
    id: '3317120017',
    districtId: '3317120',
    name: 'Terjan',
  },
  {
    id: '3317120018',
    districtId: '3317120',
    name: 'Sendang',
  },
  {
    id: '3317120019',
    districtId: '3317120',
    name: 'Watupecah',
  },
  {
    id: '3317120020',
    districtId: '3317120',
    name: 'Woro',
  },
  {
    id: '3317120022',
    districtId: '3317120',
    name: 'Plawangan',
  },
  {
    id: '3317120023',
    districtId: '3317120',
    name: 'Sumbergayam',
  },
  {
    id: '3317120024',
    districtId: '3317120',
    name: 'Pandangan Wetan',
  },
  {
    id: '3317120025',
    districtId: '3317120',
    name: 'Pandangan Kulon',
  },
  {
    id: '3317120026',
    districtId: '3317120',
    name: 'Sumurtawang',
  },
  {
    id: '3317120027',
    districtId: '3317120',
    name: 'Sumbersari',
  },
  {
    id: '3317130001',
    districtId: '3317130',
    name: 'Sanetan',
  },
  {
    id: '3317130002',
    districtId: '3317130',
    name: 'Rakitan',
  },
  {
    id: '3317130003',
    districtId: '3317130',
    name: 'Bendo',
  },
  {
    id: '3317130004',
    districtId: '3317130',
    name: 'Labuhan Kidul',
  },
  {
    id: '3317130005',
    districtId: '3317130',
    name: 'Sendangmulyo',
  },
  {
    id: '3317130006',
    districtId: '3317130',
    name: 'Blimbing',
  },
  {
    id: '3317130007',
    districtId: '3317130',
    name: 'Manggar',
  },
  {
    id: '3317130008',
    districtId: '3317130',
    name: 'Jatisari',
  },
  {
    id: '3317130009',
    districtId: '3317130',
    name: 'Langgar',
  },
  {
    id: '3317130011',
    districtId: '3317130',
    name: 'Jurangjero',
  },
  {
    id: '3317130012',
    districtId: '3317130',
    name: 'Leran',
  },
  {
    id: '3317130013',
    districtId: '3317130',
    name: 'Trahan',
  },
  {
    id: '3317130014',
    districtId: '3317130',
    name: 'Pangkalan',
  },
  {
    id: '3317140001',
    districtId: '3317140',
    name: 'Karasgede',
  },
  {
    id: '3317140002',
    districtId: '3317140',
    name: 'Jolotundo',
  },
  {
    id: '3317140003',
    districtId: '3317140',
    name: 'Sumbergirang',
  },
  {
    id: '3317140004',
    districtId: '3317140',
    name: 'Karangturi',
  },
  {
    id: '3317140005',
    districtId: '3317140',
    name: 'Babagan',
  },
  {
    id: '3317140006',
    districtId: '3317140',
    name: 'Dorokandang',
  },
  {
    id: '3317140007',
    districtId: '3317140',
    name: 'Gedongmulyo',
  },
  {
    id: '3317140008',
    districtId: '3317140',
    name: 'Dasun',
  },
  {
    id: '3317140009',
    districtId: '3317140',
    name: 'Soditan',
  },
  {
    id: '3317140010',
    districtId: '3317140',
    name: 'Ngemplak',
  },
  {
    id: '3317140011',
    districtId: '3317140',
    name: 'Selopuro',
  },
  {
    id: '3317140012',
    districtId: '3317140',
    name: 'Sendangcoyo',
  },
  {
    id: '3317140013',
    districtId: '3317140',
    name: 'Ngargomulyo',
  },
  {
    id: '3317140014',
    districtId: '3317140',
    name: 'Kajar',
  },
  {
    id: '3317140015',
    districtId: '3317140',
    name: 'Gowak',
  },
  {
    id: '3317140016',
    districtId: '3317140',
    name: 'Sendangasri',
  },
  {
    id: '3317140017',
    districtId: '3317140',
    name: 'Tasiksono',
  },
  {
    id: '3317140018',
    districtId: '3317140',
    name: 'Sriombo',
  },
  {
    id: '3317140019',
    districtId: '3317140',
    name: 'Bonang',
  },
  {
    id: '3317140020',
    districtId: '3317140',
    name: 'Binangun',
  },
  {
    id: '3318010001',
    districtId: '3318010',
    name: 'Pakem',
  },
  {
    id: '3318010002',
    districtId: '3318010',
    name: 'Prawoto',
  },
  {
    id: '3318010003',
    districtId: '3318010',
    name: 'Wegil',
  },
  {
    id: '3318010004',
    districtId: '3318010',
    name: 'Kuwawur',
  },
  {
    id: '3318010005',
    districtId: '3318010',
    name: 'Porang Paring',
  },
  {
    id: '3318010006',
    districtId: '3318010',
    name: 'Sumbersoko',
  },
  {
    id: '3318010007',
    districtId: '3318010',
    name: 'Tompegunung',
  },
  {
    id: '3318010008',
    districtId: '3318010',
    name: 'Kedumulyo',
  },
  {
    id: '3318010009',
    districtId: '3318010',
    name: 'Gadudero',
  },
  {
    id: '3318010010',
    districtId: '3318010',
    name: 'Sukolilo',
  },
  {
    id: '3318010011',
    districtId: '3318010',
    name: 'Kedungwinong',
  },
  {
    id: '3318010012',
    districtId: '3318010',
    name: 'Baleadi',
  },
  {
    id: '3318010013',
    districtId: '3318010',
    name: 'Wotan',
  },
  {
    id: '3318010014',
    districtId: '3318010',
    name: 'Baturejo',
  },
  {
    id: '3318010015',
    districtId: '3318010',
    name: 'Kasiyan',
  },
  {
    id: '3318010016',
    districtId: '3318010',
    name: 'Cengkalsewu',
  },
  {
    id: '3318020001',
    districtId: '3318020',
    name: 'Jimbaran',
  },
  {
    id: '3318020002',
    districtId: '3318020',
    name: 'Durensawit',
  },
  {
    id: '3318020005',
    districtId: '3318020',
    name: 'Purwokerto',
  },
  {
    id: '3318020006',
    districtId: '3318020',
    name: 'Sumbersari',
  },
  {
    id: '3318020007',
    districtId: '3318020',
    name: 'Brati',
  },
  {
    id: '3318020008',
    districtId: '3318020',
    name: 'Jatiroto',
  },
  {
    id: '3318020009',
    districtId: '3318020',
    name: 'Kayen',
  },
  {
    id: '3318020010',
    districtId: '3318020',
    name: 'Trimulyo',
  },
  {
    id: '3318020011',
    districtId: '3318020',
    name: 'Srikaton',
  },
  {
    id: '3318020012',
    districtId: '3318020',
    name: 'Pasuruhan',
  },
  {
    id: '3318020013',
    districtId: '3318020',
    name: 'Pesagi',
  },
  {
    id: '3318020014',
    districtId: '3318020',
    name: 'Rogomulyo',
  },
  {
    id: '3318020015',
    districtId: '3318020',
    name: 'Talun',
  },
  {
    id: '3318020016',
    districtId: '3318020',
    name: 'Boloagung',
  },
  {
    id: '3318020017',
    districtId: '3318020',
    name: 'Sundoluhur',
  },
  {
    id: '3318030001',
    districtId: '3318030',
    name: 'Pakis',
  },
  {
    id: '3318030002',
    districtId: '3318030',
    name: 'Maitan',
  },
  {
    id: '3318030003',
    districtId: '3318030',
    name: 'Wukirsari',
  },
  {
    id: '3318030004',
    districtId: '3318030',
    name: 'Sinomwidodo',
  },
  {
    id: '3318030006',
    districtId: '3318030',
    name: 'Larangan',
  },
  {
    id: '3318030007',
    districtId: '3318030',
    name: 'Tambakromo',
  },
  {
    id: '3318030008',
    districtId: '3318030',
    name: 'Mojomulyo',
  },
  {
    id: '3318030009',
    districtId: '3318030',
    name: 'Karangawen',
  },
  {
    id: '3318030010',
    districtId: '3318030',
    name: 'Mangunrekso',
  },
  {
    id: '3318030011',
    districtId: '3318030',
    name: 'Tambaharjo',
  },
  {
    id: '3318030012',
    districtId: '3318030',
    name: 'Tambahagung',
  },
  {
    id: '3318030013',
    districtId: '3318030',
    name: 'Sitirejo',
  },
  {
    id: '3318030014',
    districtId: '3318030',
    name: 'Kedalingan',
  },
  {
    id: '3318030015',
    districtId: '3318030',
    name: 'Karangmulyo',
  },
  {
    id: '3318030016',
    districtId: '3318030',
    name: 'Karangwono',
  },
  {
    id: '3318030017',
    districtId: '3318030',
    name: 'Angkatan Lor',
  },
  {
    id: '3318030018',
    districtId: '3318030',
    name: 'Angkatan Kidul',
  },
  {
    id: '3318040001',
    districtId: '3318040',
    name: 'Pohgading',
  },
  {
    id: '3318040002',
    districtId: '3318040',
    name: 'Gunungpanti',
  },
  {
    id: '3318040003',
    districtId: '3318040',
    name: 'Godo',
  },
  {
    id: '3318040004',
    districtId: '3318040',
    name: 'Kropak',
  },
  {
    id: '3318040005',
    districtId: '3318040',
    name: 'Karangsumber',
  },
  {
    id: '3318040006',
    districtId: '3318040',
    name: 'Guyangan',
  },
  {
    id: '3318040007',
    districtId: '3318040',
    name: 'Sugihan',
  },
  {
    id: '3318040008',
    districtId: '3318040',
    name: 'Kebolampang',
  },
  {
    id: '3318040009',
    districtId: '3318040',
    name: 'Tlogorejo',
  },
  {
    id: '3318040010',
    districtId: '3318040',
    name: 'Pagendisan',
  },
  {
    id: '3318040011',
    districtId: '3318040',
    name: 'Pekalongan',
  },
  {
    id: '3318040012',
    districtId: '3318040',
    name: 'Danyangmulyo',
  },
  {
    id: '3318040014',
    districtId: '3318040',
    name: 'Padangan',
  },
  {
    id: '3318040015',
    districtId: '3318040',
    name: 'Blingijati',
  },
  {
    id: '3318040016',
    districtId: '3318040',
    name: 'Mintorahayu',
  },
  {
    id: '3318040017',
    districtId: '3318040',
    name: 'Kebowan',
  },
  {
    id: '3318040018',
    districtId: '3318040',
    name: 'Winong',
  },
  {
    id: '3318040019',
    districtId: '3318040',
    name: 'Klecoregonang',
  },
  {
    id: '3318040020',
    districtId: '3318040',
    name: 'Bumiharjo',
  },
  {
    id: '3318040021',
    districtId: '3318040',
    name: 'Tawangrejo',
  },
  {
    id: '3318040022',
    districtId: '3318040',
    name: 'Bringinwareng',
  },
  {
    id: '3318040023',
    districtId: '3318040',
    name: 'Sumbermulyo',
  },
  {
    id: '3318040024',
    districtId: '3318040',
    name: 'Degan',
  },
  {
    id: '3318040025',
    districtId: '3318040',
    name: 'Serutsadang',
  },
  {
    id: '3318040026',
    districtId: '3318040',
    name: 'Pulorejo',
  },
  {
    id: '3318040027',
    districtId: '3318040',
    name: 'Karangkonang',
  },
  {
    id: '3318040028',
    districtId: '3318040',
    name: 'Tanggel',
  },
  {
    id: '3318040029',
    districtId: '3318040',
    name: 'Wirun',
  },
  {
    id: '3318040030',
    districtId: '3318040',
    name: 'Sarimulyo',
  },
  {
    id: '3318050001',
    districtId: '3318050',
    name: 'Wateshaji',
  },
  {
    id: '3318050002',
    districtId: '3318050',
    name: 'Lumbungmas',
  },
  {
    id: '3318050003',
    districtId: '3318050',
    name: 'Mojoagung',
  },
  {
    id: '3318050004',
    districtId: '3318050',
    name: 'Sitimulyo',
  },
  {
    id: '3318050007',
    districtId: '3318050',
    name: 'Mencon',
  },
  {
    id: '3318050008',
    districtId: '3318050',
    name: 'Pucakwangi',
  },
  {
    id: '3318050009',
    districtId: '3318050',
    name: 'Kepohkencono',
  },
  {
    id: '3318050010',
    districtId: '3318050',
    name: 'Karangwotan',
  },
  {
    id: '3318050011',
    districtId: '3318050',
    name: 'Bodeh',
  },
  {
    id: '3318050012',
    districtId: '3318050',
    name: 'Triguno',
  },
  {
    id: '3318050013',
    districtId: '3318050',
    name: 'Tanjungsekar',
  },
  {
    id: '3318050015',
    districtId: '3318050',
    name: 'Sokopuluhan',
  },
  {
    id: '3318050016',
    districtId: '3318050',
    name: 'Tegalwero',
  },
  {
    id: '3318050017',
    districtId: '3318050',
    name: 'Plosorejo',
  },
  {
    id: '3318050018',
    districtId: '3318050',
    name: 'Karangrejo',
  },
  {
    id: '3318050019',
    districtId: '3318050',
    name: 'Jetak',
  },
  {
    id: '3318050020',
    districtId: '3318050',
    name: 'Grogolsari',
  },
  {
    id: '3318060001',
    districtId: '3318060',
    name: 'Boto',
  },
  {
    id: '3318060002',
    districtId: '3318060',
    name: 'Trikoyo',
  },
  {
    id: '3318060003',
    districtId: '3318060',
    name: 'Sumberan',
  },
  {
    id: '3318060004',
    districtId: '3318060',
    name: 'Mojolampir',
  },
  {
    id: '3318060005',
    districtId: '3318060',
    name: 'Mantingan',
  },
  {
    id: '3318060006',
    districtId: '3318060',
    name: 'Ronggo',
  },
  {
    id: '3318060007',
    districtId: '3318060',
    name: 'Sumberagung',
  },
  {
    id: '3318060008',
    districtId: '3318060',
    name: 'Sidoluhur',
  },
  {
    id: '3318060009',
    districtId: '3318060',
    name: 'Srikaton',
  },
  {
    id: '3318060010',
    districtId: '3318060',
    name: 'Arumanis',
  },
  {
    id: '3318060011',
    districtId: '3318060',
    name: 'Tegalarum',
  },
  {
    id: '3318060012',
    districtId: '3318060',
    name: 'Sidomukti',
  },
  {
    id: '3318060013',
    districtId: '3318060',
    name: 'Mojoluhur',
  },
  {
    id: '3318060014',
    districtId: '3318060',
    name: 'Kebonturi',
  },
  {
    id: '3318060015',
    districtId: '3318060',
    name: 'Lundo',
  },
  {
    id: '3318060016',
    districtId: '3318060',
    name: 'Sukorukun',
  },
  {
    id: '3318060017',
    districtId: '3318060',
    name: 'Sumberejo',
  },
  {
    id: '3318060018',
    districtId: '3318060',
    name: 'Manjang',
  },
  {
    id: '3318060019',
    districtId: '3318060',
    name: 'Tamansari',
  },
  {
    id: '3318060020',
    districtId: '3318060',
    name: 'Sumberarum',
  },
  {
    id: '3318060021',
    districtId: '3318060',
    name: 'Sriwedari',
  },
  {
    id: '3318070001',
    districtId: '3318070',
    name: 'Tlogomojo',
  },
  {
    id: '3318070002',
    districtId: '3318070',
    name: 'Sukoagung',
  },
  {
    id: '3318070003',
    districtId: '3318070',
    name: 'Bulumulyo',
  },
  {
    id: '3318070004',
    districtId: '3318070',
    name: 'Tompomulyo',
  },
  {
    id: '3318070005',
    districtId: '3318070',
    name: 'Kuniran',
  },
  {
    id: '3318070006',
    districtId: '3318070',
    name: 'Gunungsari',
  },
  {
    id: '3318070007',
    districtId: '3318070',
    name: 'Kedalon',
  },
  {
    id: '3318070008',
    districtId: '3318070',
    name: 'Klayusiwalan',
  },
  {
    id: '3318070009',
    districtId: '3318070',
    name: 'Ngening',
  },
  {
    id: '3318070010',
    districtId: '3318070',
    name: 'Raci',
  },
  {
    id: '3318070011',
    districtId: '3318070',
    name: 'Ketitangwetan',
  },
  {
    id: '3318070012',
    districtId: '3318070',
    name: 'Bumimulyo',
  },
  {
    id: '3318070013',
    districtId: '3318070',
    name: 'Jembangan',
  },
  {
    id: '3318070014',
    districtId: '3318070',
    name: 'Lengkong',
  },
  {
    id: '3318070015',
    districtId: '3318070',
    name: 'Mangunlegi',
  },
  {
    id: '3318070016',
    districtId: '3318070',
    name: 'Batursari',
  },
  {
    id: '3318070017',
    districtId: '3318070',
    name: 'Gajahkumpul',
  },
  {
    id: '3318070018',
    districtId: '3318070',
    name: 'Pecangaan',
  },
  {
    id: '3318080001',
    districtId: '3318080',
    name: 'Sejomulyo',
  },
  {
    id: '3318080002',
    districtId: '3318080',
    name: 'Bringin',
  },
  {
    id: '3318080003',
    districtId: '3318080',
    name: 'Ketip',
  },
  {
    id: '3318080004',
    districtId: '3318080',
    name: 'Pekuwon',
  },
  {
    id: '3318080005',
    districtId: '3318080',
    name: 'Karang',
  },
  {
    id: '3318080006',
    districtId: '3318080',
    name: 'Karangrejo',
  },
  {
    id: '3318080007',
    districtId: '3318080',
    name: 'Bumirejo',
  },
  {
    id: '3318080008',
    districtId: '3318080',
    name: 'Kedungpancing',
  },
  {
    id: '3318080009',
    districtId: '3318080',
    name: 'Jepuro',
  },
  {
    id: '3318080010',
    districtId: '3318080',
    name: 'Tluwah',
  },
  {
    id: '3318080011',
    districtId: '3318080',
    name: 'Doropayung',
  },
  {
    id: '3318080012',
    districtId: '3318080',
    name: 'Mintomulyo',
  },
  {
    id: '3318080013',
    districtId: '3318080',
    name: 'Gadingrejo',
  },
  {
    id: '3318080014',
    districtId: '3318080',
    name: 'Margomulyo',
  },
  {
    id: '3318080015',
    districtId: '3318080',
    name: 'Langgenharjo',
  },
  {
    id: '3318080016',
    districtId: '3318080',
    name: 'Genengmulyo',
  },
  {
    id: '3318080017',
    districtId: '3318080',
    name: 'Agungmulyo',
  },
  {
    id: '3318080018',
    districtId: '3318080',
    name: 'Bakaran Kulon',
  },
  {
    id: '3318080019',
    districtId: '3318080',
    name: 'Bakaran Wetan',
  },
  {
    id: '3318080020',
    districtId: '3318080',
    name: 'Dukutalit',
  },
  {
    id: '3318080021',
    districtId: '3318080',
    name: 'Growong Kidul',
  },
  {
    id: '3318080022',
    districtId: '3318080',
    name: 'Growong Lor',
  },
  {
    id: '3318080023',
    districtId: '3318080',
    name: 'Kauman',
  },
  {
    id: '3318080024',
    districtId: '3318080',
    name: 'Pajeksan',
  },
  {
    id: '3318080025',
    districtId: '3318080',
    name: 'Kudukeras',
  },
  {
    id: '3318080026',
    districtId: '3318080',
    name: 'Kebonsawahan',
  },
  {
    id: '3318080027',
    districtId: '3318080',
    name: 'Bajomulyo',
  },
  {
    id: '3318080028',
    districtId: '3318080',
    name: 'Bendar',
  },
  {
    id: '3318080029',
    districtId: '3318080',
    name: 'Trimulyo',
  },
  {
    id: '3318090001',
    districtId: '3318090',
    name: 'Kedungmulyo',
  },
  {
    id: '3318090002',
    districtId: '3318090',
    name: 'Sendangsoko',
  },
  {
    id: '3318090003',
    districtId: '3318090',
    name: 'Tambahmulyo',
  },
  {
    id: '3318090004',
    districtId: '3318090',
    name: 'Tondokerto',
  },
  {
    id: '3318090005',
    districtId: '3318090',
    name: 'Mantingan Tengah',
  },
  {
    id: '3318090006',
    districtId: '3318090',
    name: 'Jatisari',
  },
  {
    id: '3318090007',
    districtId: '3318090',
    name: 'Karangrejo Lor',
  },
  {
    id: '3318090008',
    districtId: '3318090',
    name: 'Sidomulyo',
  },
  {
    id: '3318090009',
    districtId: '3318090',
    name: 'Plosojenar',
  },
  {
    id: '3318090010',
    districtId: '3318090',
    name: 'Jakenan',
  },
  {
    id: '3318090011',
    districtId: '3318090',
    name: 'Dukuhmulyo',
  },
  {
    id: '3318090012',
    districtId: '3318090',
    name: 'Tanjungsari',
  },
  {
    id: '3318090013',
    districtId: '3318090',
    name: 'Puluhan Tengah',
  },
  {
    id: '3318090014',
    districtId: '3318090',
    name: 'Sembaturagung',
  },
  {
    id: '3318090015',
    districtId: '3318090',
    name: 'Glonggong',
  },
  {
    id: '3318090016',
    districtId: '3318090',
    name: 'Kalimulyo',
  },
  {
    id: '3318090017',
    districtId: '3318090',
    name: 'Tlogorejo',
  },
  {
    id: '3318090018',
    districtId: '3318090',
    name: 'Sonorejo',
  },
  {
    id: '3318090019',
    districtId: '3318090',
    name: 'Ngastorejo',
  },
  {
    id: '3318090020',
    districtId: '3318090',
    name: 'Sidoarum',
  },
  {
    id: '3318090021',
    districtId: '3318090',
    name: 'Karangrowo',
  },
  {
    id: '3318090022',
    districtId: '3318090',
    name: 'Tondomulyo',
  },
  {
    id: '3318090023',
    districtId: '3318090',
    name: 'Bungasrejo',
  },
  {
    id: '3318100001',
    districtId: '3318100',
    name: 'Panjunan',
  },
  {
    id: '3318100002',
    districtId: '3318100',
    name: 'Gajahmati',
  },
  {
    id: '3318100003',
    districtId: '3318100',
    name: 'Mustokoharjo',
  },
  {
    id: '3318100004',
    districtId: '3318100',
    name: 'Semampir',
  },
  {
    id: '3318100005',
    districtId: '3318100',
    name: 'Pati Wetan',
  },
  {
    id: '3318100006',
    districtId: '3318100',
    name: 'Blaru',
  },
  {
    id: '3318100007',
    districtId: '3318100',
    name: 'Pati Kidul',
  },
  {
    id: '3318100008',
    districtId: '3318100',
    name: 'Plangitan',
  },
  {
    id: '3318100009',
    districtId: '3318100',
    name: 'Puri',
  },
  {
    id: '3318100010',
    districtId: '3318100',
    name: 'Winong',
  },
  {
    id: '3318100011',
    districtId: '3318100',
    name: 'Ngarus',
  },
  {
    id: '3318100012',
    districtId: '3318100',
    name: 'Pati Lor',
  },
  {
    id: '3318100013',
    districtId: '3318100',
    name: 'Parenggan',
  },
  {
    id: '3318100014',
    districtId: '3318100',
    name: 'Sidoharjo',
  },
  {
    id: '3318100015',
    districtId: '3318100',
    name: 'Kalidoro',
  },
  {
    id: '3318100016',
    districtId: '3318100',
    name: 'Sarirejo',
  },
  {
    id: '3318100017',
    districtId: '3318100',
    name: 'Geritan',
  },
  {
    id: '3318100019',
    districtId: '3318100',
    name: 'Sugiharjo',
  },
  {
    id: '3318100020',
    districtId: '3318100',
    name: 'Widorokandang',
  },
  {
    id: '3318100021',
    districtId: '3318100',
    name: 'Payang',
  },
  {
    id: '3318100022',
    districtId: '3318100',
    name: 'Kutoharjo',
  },
  {
    id: '3318100023',
    districtId: '3318100',
    name: 'Sidokerto',
  },
  {
    id: '3318100024',
    districtId: '3318100',
    name: 'Mulyoharjo',
  },
  {
    id: '3318100025',
    districtId: '3318100',
    name: 'Tambaharjo',
  },
  {
    id: '3318100026',
    districtId: '3318100',
    name: 'Tambahsari',
  },
  {
    id: '3318100027',
    districtId: '3318100',
    name: 'Ngepungrojo',
  },
  {
    id: '3318100028',
    districtId: '3318100',
    name: 'Purworejo',
  },
  {
    id: '3318100029',
    districtId: '3318100',
    name: 'Sinoman',
  },
  {
    id: '3318110002',
    districtId: '3318110',
    name: 'Karaban',
  },
  {
    id: '3318110003',
    districtId: '3318110',
    name: 'Tlogoayu',
  },
  {
    id: '3318110004',
    districtId: '3318110',
    name: 'Bogotanjung',
  },
  {
    id: '3318110005',
    districtId: '3318110',
    name: 'Koryokalangan',
  },
  {
    id: '3318110006',
    districtId: '3318110',
    name: 'Gabus',
  },
  {
    id: '3318110007',
    districtId: '3318110',
    name: 'Tanjunganom',
  },
  {
    id: '3318110008',
    districtId: '3318110',
    name: 'Sunggingwarno',
  },
  {
    id: '3318110009',
    districtId: '3318110',
    name: 'Penanggungan',
  },
  {
    id: '3318110010',
    districtId: '3318110',
    name: 'Tambahmulyo',
  },
  {
    id: '3318110011',
    districtId: '3318110',
    name: 'Sugihrejo',
  },
  {
    id: '3318110012',
    districtId: '3318110',
    name: 'Mojolawaran',
  },
  {
    id: '3318110013',
    districtId: '3318110',
    name: 'Sambirejo',
  },
  {
    id: '3318110014',
    districtId: '3318110',
    name: 'Pantirejo',
  },
  {
    id: '3318110015',
    districtId: '3318110',
    name: 'Tanjang',
  },
  {
    id: '3318110016',
    districtId: '3318110',
    name: 'Gebang',
  },
  {
    id: '3318110017',
    districtId: '3318110',
    name: 'Plumbungan',
  },
  {
    id: '3318110018',
    districtId: '3318110',
    name: 'Babalan',
  },
  {
    id: '3318110019',
    districtId: '3318110',
    name: 'Koripandriyo',
  },
  {
    id: '3318110020',
    districtId: '3318110',
    name: 'Soko',
  },
  {
    id: '3318110021',
    districtId: '3318110',
    name: 'Gempolsari',
  },
  {
    id: '3318110022',
    districtId: '3318110',
    name: 'Banjarsari',
  },
  {
    id: '3318110023',
    districtId: '3318110',
    name: 'Mintobasuki',
  },
  {
    id: '3318110024',
    districtId: '3318110',
    name: 'Kosekan',
  },
  {
    id: '3318120001',
    districtId: '3318120',
    name: 'Jambean Kidul',
  },
  {
    id: '3318120002',
    districtId: '3318120',
    name: 'Wangunrejo',
  },
  {
    id: '3318120003',
    districtId: '3318120',
    name: 'Bumirejo',
  },
  {
    id: '3318120004',
    districtId: '3318120',
    name: 'Sokokulon',
  },
  {
    id: '3318120005',
    districtId: '3318120',
    name: 'Jimbaran',
  },
  {
    id: '3318120006',
    districtId: '3318120',
    name: 'Ngawen',
  },
  {
    id: '3318120007',
    districtId: '3318120',
    name: 'Margorejo',
  },
  {
    id: '3318120008',
    districtId: '3318120',
    name: 'Penambuhan',
  },
  {
    id: '3318120009',
    districtId: '3318120',
    name: 'Langenharjo',
  },
  {
    id: '3318120010',
    districtId: '3318120',
    name: 'Dadirejo',
  },
  {
    id: '3318120011',
    districtId: '3318120',
    name: 'Sukoharjo',
  },
  {
    id: '3318120012',
    districtId: '3318120',
    name: 'Badegan',
  },
  {
    id: '3318120013',
    districtId: '3318120',
    name: 'Pegandan',
  },
  {
    id: '3318120014',
    districtId: '3318120',
    name: 'Sukobubuk',
  },
  {
    id: '3318120015',
    districtId: '3318120',
    name: 'Banyuurip',
  },
  {
    id: '3318120016',
    districtId: '3318120',
    name: 'Langse',
  },
  {
    id: '3318120017',
    districtId: '3318120',
    name: 'Metaraman',
  },
  {
    id: '3318120018',
    districtId: '3318120',
    name: 'Muktiharjo',
  },
  {
    id: '3318130001',
    districtId: '3318130',
    name: 'Bermi',
  },
  {
    id: '3318130003',
    districtId: '3318130',
    name: 'Semirejo',
  },
  {
    id: '3318130004',
    districtId: '3318130',
    name: 'Wonosekar',
  },
  {
    id: '3318130005',
    districtId: '3318130',
    name: 'Gembong',
  },
  {
    id: '3318130006',
    districtId: '3318130',
    name: 'Plukaran',
  },
  {
    id: '3318130007',
    districtId: '3318130',
    name: 'Bageng',
  },
  {
    id: '3318130008',
    districtId: '3318130',
    name: 'Pohgading',
  },
  {
    id: '3318130009',
    districtId: '3318130',
    name: 'Klakah Kasian',
  },
  {
    id: '3318130010',
    districtId: '3318130',
    name: 'Ketanggan',
  },
  {
    id: '3318130011',
    districtId: '3318130',
    name: 'Sitiluhur',
  },
  {
    id: '3318140001',
    districtId: '3318140',
    name: 'Tamansari',
  },
  {
    id: '3318140002',
    districtId: '3318140',
    name: 'Sambirejo',
  },
  {
    id: '3318140003',
    districtId: '3318140',
    name: 'Tlogorejo',
  },
  {
    id: '3318140004',
    districtId: '3318140',
    name: 'Purwosari',
  },
  {
    id: '3318140005',
    districtId: '3318140',
    name: 'Regaloh',
  },
  {
    id: '3318140006',
    districtId: '3318140',
    name: 'Wonorejo',
  },
  {
    id: '3318140007',
    districtId: '3318140',
    name: 'Tlogosari',
  },
  {
    id: '3318140008',
    districtId: '3318140',
    name: 'Sumbermulyo',
  },
  {
    id: '3318140009',
    districtId: '3318140',
    name: 'Guwo',
  },
  {
    id: '3318140010',
    districtId: '3318140',
    name: 'Tajungsari',
  },
  {
    id: '3318140011',
    districtId: '3318140',
    name: 'Lahar',
  },
  {
    id: '3318140012',
    districtId: '3318140',
    name: 'Suwatu',
  },
  {
    id: '3318140013',
    districtId: '3318140',
    name: 'Cabak',
  },
  {
    id: '3318140014',
    districtId: '3318140',
    name: 'Klumpit',
  },
  {
    id: '3318140015',
    districtId: '3318140',
    name: 'Gunungsari',
  },
  {
    id: '3318150001',
    districtId: '3318150',
    name: 'Bumiayu',
  },
  {
    id: '3318150002',
    districtId: '3318150',
    name: 'Margorejo',
  },
  {
    id: '3318150003',
    districtId: '3318150',
    name: 'Sukoharjo',
  },
  {
    id: '3318150004',
    districtId: '3318150',
    name: 'Tawangharjo',
  },
  {
    id: '3318150005',
    districtId: '3318150',
    name: 'Ngurensiti',
  },
  {
    id: '3318150006',
    districtId: '3318150',
    name: 'Bangsalrejo',
  },
  {
    id: '3318150008',
    districtId: '3318150',
    name: 'Sidoharjo',
  },
  {
    id: '3318150009',
    districtId: '3318150',
    name: 'Ngurenrejo',
  },
  {
    id: '3318150010',
    districtId: '3318150',
    name: 'Jontro',
  },
  {
    id: '3318150011',
    districtId: '3318150',
    name: 'Panggungroyom',
  },
  {
    id: '3318150012',
    districtId: '3318150',
    name: 'Suwaduk',
  },
  {
    id: '3318150013',
    districtId: '3318150',
    name: 'Wedarijaksa',
  },
  {
    id: '3318150014',
    districtId: '3318150',
    name: 'Pagerharjo',
  },
  {
    id: '3318150015',
    districtId: '3318150',
    name: 'Jatimulyo',
  },
  {
    id: '3318150016',
    districtId: '3318150',
    name: 'Jetak',
  },
  {
    id: '3318150017',
    districtId: '3318150',
    name: 'Kepoh',
  },
  {
    id: '3318150018',
    districtId: '3318150',
    name: 'Tlogoharum',
  },
  {
    id: '3318160001',
    districtId: '3318160',
    name: 'Pasucen',
  },
  {
    id: '3318160002',
    districtId: '3318160',
    name: 'Ketanen',
  },
  {
    id: '3318160003',
    districtId: '3318160',
    name: 'Trangkil',
  },
  {
    id: '3318160004',
    districtId: '3318160',
    name: 'Kajar',
  },
  {
    id: '3318160005',
    districtId: '3318160',
    name: 'Asempapan',
  },
  {
    id: '3318160006',
    districtId: '3318160',
    name: 'Sambilawang',
  },
  {
    id: '3318160007',
    districtId: '3318160',
    name: 'Guyangan',
  },
  {
    id: '3318160008',
    districtId: '3318160',
    name: 'Kertomulyo',
  },
  {
    id: '3318160010',
    districtId: '3318160',
    name: 'Kadilangu',
  },
  {
    id: '3318160011',
    districtId: '3318160',
    name: 'Krandan',
  },
  {
    id: '3318160012',
    districtId: '3318160',
    name: 'Rejoagung',
  },
  {
    id: '3318160013',
    districtId: '3318160',
    name: 'Karanglegi',
  },
  {
    id: '3318160014',
    districtId: '3318160',
    name: 'Karangwage',
  },
  {
    id: '3318160015',
    districtId: '3318160',
    name: 'Mojoagung',
  },
  {
    id: '3318160016',
    districtId: '3318160',
    name: 'Tegalharjo',
  },
  {
    id: '3318170001',
    districtId: '3318170',
    name: 'Tegalarum',
  },
  {
    id: '3318170002',
    districtId: '3318170',
    name: 'Soneyan',
  },
  {
    id: '3318170003',
    districtId: '3318170',
    name: 'Tanjungrejo',
  },
  {
    id: '3318170004',
    districtId: '3318170',
    name: 'Sidomukti',
  },
  {
    id: '3318170005',
    districtId: '3318170',
    name: 'Pohijo',
  },
  {
    id: '3318170006',
    districtId: '3318170',
    name: 'Kertomulyo',
  },
  {
    id: '3318170007',
    districtId: '3318170',
    name: 'Langgenharjo',
  },
  {
    id: '3318170008',
    districtId: '3318170',
    name: 'Pangkalan',
  },
  {
    id: '3318170009',
    districtId: '3318170',
    name: 'Bulumanis Kidul',
  },
  {
    id: '3318170010',
    districtId: '3318170',
    name: 'Bulumanis Lor',
  },
  {
    id: '3318170011',
    districtId: '3318170',
    name: 'Sekarjalak',
  },
  {
    id: '3318170012',
    districtId: '3318170',
    name: 'Kajen',
  },
  {
    id: '3318170013',
    districtId: '3318170',
    name: 'Ngemplak Kidul',
  },
  {
    id: '3318170014',
    districtId: '3318170',
    name: 'Purworejo',
  },
  {
    id: '3318170015',
    districtId: '3318170',
    name: 'Purwodadi',
  },
  {
    id: '3318170016',
    districtId: '3318170',
    name: 'Ngemplak Lor',
  },
  {
    id: '3318170017',
    districtId: '3318170',
    name: 'Waturoyo',
  },
  {
    id: '3318170018',
    districtId: '3318170',
    name: 'Cebolek Kidul',
  },
  {
    id: '3318170019',
    districtId: '3318170',
    name: 'Tunjungrejo',
  },
  {
    id: '3318170020',
    districtId: '3318170',
    name: 'Margoyoso',
  },
  {
    id: '3318170021',
    districtId: '3318170',
    name: 'Margotuhu Kidul',
  },
  {
    id: '3318170022',
    districtId: '3318170',
    name: 'Semerak',
  },
  {
    id: '3318180001',
    districtId: '3318180',
    name: 'Jepalo',
  },
  {
    id: '3318180002',
    districtId: '3318180',
    name: 'Sidomulyo',
  },
  {
    id: '3318180003',
    districtId: '3318180',
    name: 'Sampok',
  },
  {
    id: '3318180004',
    districtId: '3318180',
    name: 'Pesagen',
  },
  {
    id: '3318180005',
    districtId: '3318180',
    name: 'Gadu',
  },
  {
    id: '3318180006',
    districtId: '3318180',
    name: 'Gajihan',
  },
  {
    id: '3318180007',
    districtId: '3318180',
    name: 'Perdopo',
  },
  {
    id: '3318180008',
    districtId: '3318180',
    name: 'Gulangpongge',
  },
  {
    id: '3318180009',
    districtId: '3318180',
    name: 'Jrahi',
  },
  {
    id: '3318180010',
    districtId: '3318180',
    name: 'Giling',
  },
  {
    id: '3318180011',
    districtId: '3318180',
    name: 'Bancak',
  },
  {
    id: '3318180012',
    districtId: '3318180',
    name: 'Gunungwungkal',
  },
  {
    id: '3318180015',
    districtId: '3318180',
    name: 'Sumberrejo',
  },
  {
    id: '3318190001',
    districtId: '3318190',
    name: 'Medani',
  },
  {
    id: '3318190003',
    districtId: '3318190',
    name: 'Plaosan',
  },
  {
    id: '3318190004',
    districtId: '3318190',
    name: 'Payak',
  },
  {
    id: '3318190005',
    districtId: '3318190',
    name: 'Sirahan',
  },
  {
    id: '3318190006',
    districtId: '3318190',
    name: 'Mojo',
  },
  {
    id: '3318190007',
    districtId: '3318190',
    name: 'Karangsari',
  },
  {
    id: '3318190009',
    districtId: '3318190',
    name: 'Ngawen',
  },
  {
    id: '3318190010',
    districtId: '3318190',
    name: 'Ngablak',
  },
  {
    id: '3318190011',
    districtId: '3318190',
    name: 'Gesengan',
  },
  {
    id: '3318190012',
    districtId: '3318190',
    name: 'Gerit',
  },
  {
    id: '3318200001',
    districtId: '3318200',
    name: 'Pondowan',
  },
  {
    id: '3318200002',
    districtId: '3318200',
    name: 'Kedungsari',
  },
  {
    id: '3318200003',
    districtId: '3318200',
    name: 'Margomulyo',
  },
  {
    id: '3318200004',
    districtId: '3318200',
    name: 'Pakis',
  },
  {
    id: '3318200005',
    districtId: '3318200',
    name: 'Sendangrejo',
  },
  {
    id: '3318200006',
    districtId: '3318200',
    name: 'Jepat Kidul',
  },
  {
    id: '3318200007',
    districtId: '3318200',
    name: 'Tunggulsari',
  },
  {
    id: '3318200008',
    districtId: '3318200',
    name: 'Jepat Lor',
  },
  {
    id: '3318200009',
    districtId: '3318200',
    name: 'Tendas',
  },
  {
    id: '3318200010',
    districtId: '3318200',
    name: 'Keboromo',
  },
  {
    id: '3318200011',
    districtId: '3318200',
    name: 'Sambiroto',
  },
  {
    id: '3318200012',
    districtId: '3318200',
    name: 'Tayu Wetan',
  },
  {
    id: '3318200013',
    districtId: '3318200',
    name: 'Tayu Kulon',
  },
  {
    id: '3318200014',
    districtId: '3318200',
    name: 'Pundenrejo',
  },
  {
    id: '3318200015',
    districtId: '3318200',
    name: 'Kedungbang',
  },
  {
    id: '3318200016',
    districtId: '3318200',
    name: 'Bendokaton Kidul',
  },
  {
    id: '3318200017',
    districtId: '3318200',
    name: 'Purwokerto',
  },
  {
    id: '3318200018',
    districtId: '3318200',
    name: 'Bulungan',
  },
  {
    id: '3318200019',
    districtId: '3318200',
    name: 'Luwang',
  },
  {
    id: '3318200020',
    districtId: '3318200',
    name: 'Dororejo',
  },
  {
    id: '3318200021',
    districtId: '3318200',
    name: 'Kalikalong',
  },
  {
    id: '3318210001',
    districtId: '3318210',
    name: 'Wedusan',
  },
  {
    id: '3318210002',
    districtId: '3318210',
    name: 'Grogolan',
  },
  {
    id: '3318210003',
    districtId: '3318210',
    name: 'Dumpil',
  },
  {
    id: '3318210004',
    districtId: '3318210',
    name: 'Bakalan',
  },
  {
    id: '3318210005',
    districtId: '3318210',
    name: 'Ngagel',
  },
  {
    id: '3318210006',
    districtId: '3318210',
    name: 'Kenanti',
  },
  {
    id: '3318210007',
    districtId: '3318210',
    name: 'Alasdowo',
  },
  {
    id: '3318210008',
    districtId: '3318210',
    name: 'Banyutowo',
  },
  {
    id: '3318210009',
    districtId: '3318210',
    name: 'Dukuhseti',
  },
  {
    id: '3318210010',
    districtId: '3318210',
    name: 'Kembang',
  },
  {
    id: '3318210011',
    districtId: '3318210',
    name: 'Tegalombo',
  },
  {
    id: '3319010001',
    districtId: '3319010',
    name: 'Blimbing Kidul',
  },
  {
    id: '3319010002',
    districtId: '3319010',
    name: 'Banget',
  },
  {
    id: '3319010003',
    districtId: '3319010',
    name: 'Setrokalangan',
  },
  {
    id: '3319010004',
    districtId: '3319010',
    name: 'Garung Kidul',
  },
  {
    id: '3319010005',
    districtId: '3319010',
    name: 'Kedung Dowo',
  },
  {
    id: '3319010006',
    districtId: '3319010',
    name: 'Gamong',
  },
  {
    id: '3319010007',
    districtId: '3319010',
    name: 'Sidorekso',
  },
  {
    id: '3319010008',
    districtId: '3319010',
    name: 'Papringan',
  },
  {
    id: '3319010009',
    districtId: '3319010',
    name: 'Kaliwungu',
  },
  {
    id: '3319010010',
    districtId: '3319010',
    name: 'Mijen',
  },
  {
    id: '3319010011',
    districtId: '3319010',
    name: 'Karang Ampel',
  },
  {
    id: '3319010012',
    districtId: '3319010',
    name: 'Garung Lor',
  },
  {
    id: '3319010013',
    districtId: '3319010',
    name: 'Prambatan Lor',
  },
  {
    id: '3319010014',
    districtId: '3319010',
    name: 'Prambatan Kidul',
  },
  {
    id: '3319010015',
    districtId: '3319010',
    name: 'Bakalan Krapyak',
  },
  {
    id: '3319020001',
    districtId: '3319020',
    name: 'Purwosari',
  },
  {
    id: '3319020002',
    districtId: '3319020',
    name: 'Janggalan',
  },
  {
    id: '3319020003',
    districtId: '3319020',
    name: 'Demangan',
  },
  {
    id: '3319020004',
    districtId: '3319020',
    name: 'Sunggingan',
  },
  {
    id: '3319020005',
    districtId: '3319020',
    name: 'Panjunan',
  },
  {
    id: '3319020006',
    districtId: '3319020',
    name: 'Wergu Kulon',
  },
  {
    id: '3319020007',
    districtId: '3319020',
    name: 'Wergu Wetan',
  },
  {
    id: '3319020008',
    districtId: '3319020',
    name: 'Mlati Kidul',
  },
  {
    id: '3319020009',
    districtId: '3319020',
    name: 'Mlati Norowito',
  },
  {
    id: '3319020010',
    districtId: '3319020',
    name: 'Mlati Lor',
  },
  {
    id: '3319020011',
    districtId: '3319020',
    name: 'Nganguk',
  },
  {
    id: '3319020012',
    districtId: '3319020',
    name: 'Kramat',
  },
  {
    id: '3319020013',
    districtId: '3319020',
    name: 'Demaan',
  },
  {
    id: '3319020014',
    districtId: '3319020',
    name: 'Langgar Dalem',
  },
  {
    id: '3319020015',
    districtId: '3319020',
    name: 'Kauman',
  },
  {
    id: '3319020016',
    districtId: '3319020',
    name: 'Damaran',
  },
  {
    id: '3319020017',
    districtId: '3319020',
    name: 'Kerjasan',
  },
  {
    id: '3319020018',
    districtId: '3319020',
    name: 'Kajeksan',
  },
  {
    id: '3319020019',
    districtId: '3319020',
    name: 'Krandon',
  },
  {
    id: '3319020020',
    districtId: '3319020',
    name: 'Singocandi',
  },
  {
    id: '3319020021',
    districtId: '3319020',
    name: 'Glantengan',
  },
  {
    id: '3319020022',
    districtId: '3319020',
    name: 'Barongan',
  },
  {
    id: '3319020023',
    districtId: '3319020',
    name: 'Kaliputu',
  },
  {
    id: '3319020024',
    districtId: '3319020',
    name: 'Burikan',
  },
  {
    id: '3319030001',
    districtId: '3319030',
    name: 'Tanjung Karang',
  },
  {
    id: '3319030002',
    districtId: '3319030',
    name: 'Jetis Kapuan',
  },
  {
    id: '3319030003',
    districtId: '3319030',
    name: 'Loram Kulon',
  },
  {
    id: '3319030004',
    districtId: '3319030',
    name: 'Jati Wetan',
  },
  {
    id: '3319030005',
    districtId: '3319030',
    name: 'Jati Kulon',
  },
  {
    id: '3319030006',
    districtId: '3319030',
    name: 'Pasuruhan Lor',
  },
  {
    id: '3319030007',
    districtId: '3319030',
    name: 'Pasuruhan Kidul',
  },
  {
    id: '3319030008',
    districtId: '3319030',
    name: 'Ploso',
  },
  {
    id: '3319030009',
    districtId: '3319030',
    name: 'Getas Pejaten',
  },
  {
    id: '3319030010',
    districtId: '3319030',
    name: 'Loram Wetan',
  },
  {
    id: '3319030011',
    districtId: '3319030',
    name: 'Jepang Pakis',
  },
  {
    id: '3319030012',
    districtId: '3319030',
    name: 'Megawon',
  },
  {
    id: '3319030013',
    districtId: '3319030',
    name: 'Tumpang Krasak',
  },
  {
    id: '3319030014',
    districtId: '3319030',
    name: 'Ngembal Kulon',
  },
  {
    id: '3319040001',
    districtId: '3319040',
    name: 'Wonosoco',
  },
  {
    id: '3319040002',
    districtId: '3319040',
    name: 'Lambangan',
  },
  {
    id: '3319040003',
    districtId: '3319040',
    name: 'Kalirejo',
  },
  {
    id: '3319040004',
    districtId: '3319040',
    name: 'Medini',
  },
  {
    id: '3319040005',
    districtId: '3319040',
    name: 'Sambung',
  },
  {
    id: '3319040006',
    districtId: '3319040',
    name: 'Glagah Waru',
  },
  {
    id: '3319040008',
    districtId: '3319040',
    name: 'Undaan Kidul',
  },
  {
    id: '3319040009',
    districtId: '3319040',
    name: 'Undaan Tengah',
  },
  {
    id: '3319040010',
    districtId: '3319040',
    name: 'Karang Rowo',
  },
  {
    id: '3319040011',
    districtId: '3319040',
    name: 'Larikrejo',
  },
  {
    id: '3319040012',
    districtId: '3319040',
    name: 'Undaan Lor',
  },
  {
    id: '3319040013',
    districtId: '3319040',
    name: 'Wates',
  },
  {
    id: '3319040014',
    districtId: '3319040',
    name: 'Ngemplak',
  },
  {
    id: '3319040015',
    districtId: '3319040',
    name: 'Terang Mas',
  },
  {
    id: '3319040016',
    districtId: '3319040',
    name: 'Berugenjang',
  },
  {
    id: '3319050001',
    districtId: '3319050',
    name: 'Gulang',
  },
  {
    id: '3319050002',
    districtId: '3319050',
    name: 'Jepang',
  },
  {
    id: '3319050003',
    districtId: '3319050',
    name: 'Payaman',
  },
  {
    id: '3319050004',
    districtId: '3319050',
    name: 'Kirig',
  },
  {
    id: '3319050006',
    districtId: '3319050',
    name: 'Kesambi',
  },
  {
    id: '3319050007',
    districtId: '3319050',
    name: 'Jojo',
  },
  {
    id: '3319050008',
    districtId: '3319050',
    name: 'Hadiwarno',
  },
  {
    id: '3319050009',
    districtId: '3319050',
    name: 'Mejobo',
  },
  {
    id: '3319050010',
    districtId: '3319050',
    name: 'Golantepus',
  },
  {
    id: '3319060001',
    districtId: '3319060',
    name: 'Sadang',
  },
  {
    id: '3319060002',
    districtId: '3319060',
    name: 'Bulung Cangkring',
  },
  {
    id: '3319060003',
    districtId: '3319060',
    name: 'Bulung Kulon',
  },
  {
    id: '3319060004',
    districtId: '3319060',
    name: 'Sidomulyo',
  },
  {
    id: '3319060005',
    districtId: '3319060',
    name: 'Gondoharum',
  },
  {
    id: '3319060006',
    districtId: '3319060',
    name: 'Terban',
  },
  {
    id: '3319060007',
    districtId: '3319060',
    name: 'Pladen',
  },
  {
    id: '3319060008',
    districtId: '3319060',
    name: 'Klaling',
  },
  {
    id: '3319060009',
    districtId: '3319060',
    name: 'Jekulo',
  },
  {
    id: '3319060010',
    districtId: '3319060',
    name: 'Hadipolo',
  },
  {
    id: '3319060011',
    districtId: '3319060',
    name: 'Tanjung Rejo',
  },
  {
    id: '3319060012',
    districtId: '3319060',
    name: 'Honggosoco',
  },
  {
    id: '3319070001',
    districtId: '3319070',
    name: 'Peganjaran',
  },
  {
    id: '3319070002',
    districtId: '3319070',
    name: 'Panjang',
  },
  {
    id: '3319070003',
    districtId: '3319070',
    name: 'Purworejo',
  },
  {
    id: '3319070004',
    districtId: '3319070',
    name: 'Bacin',
  },
  {
    id: '3319070005',
    districtId: '3319070',
    name: 'Pedawang',
  },
  {
    id: '3319070006',
    districtId: '3319070',
    name: 'Dersalam',
  },
  {
    id: '3319070007',
    districtId: '3319070',
    name: 'Ngembal Rejo',
  },
  {
    id: '3319070008',
    districtId: '3319070',
    name: 'Karang Bener',
  },
  {
    id: '3319070009',
    districtId: '3319070',
    name: 'Gondang Manis',
  },
  {
    id: '3319070010',
    districtId: '3319070',
    name: 'Bae',
  },
  {
    id: '3319080001',
    districtId: '3319080',
    name: 'Getasrabi',
  },
  {
    id: '3319080002',
    districtId: '3319080',
    name: 'Klumpit',
  },
  {
    id: '3319080003',
    districtId: '3319080',
    name: 'Gribig',
  },
  {
    id: '3319080004',
    districtId: '3319080',
    name: 'Karang Malang',
  },
  {
    id: '3319080005',
    districtId: '3319080',
    name: 'Padurenan',
  },
  {
    id: '3319080006',
    districtId: '3319080',
    name: 'Besito',
  },
  {
    id: '3319080007',
    districtId: '3319080',
    name: 'Jurang',
  },
  {
    id: '3319080008',
    districtId: '3319080',
    name: 'Gondosari',
  },
  {
    id: '3319080009',
    districtId: '3319080',
    name: 'Kedungsari',
  },
  {
    id: '3319080010',
    districtId: '3319080',
    name: 'Menawan',
  },
  {
    id: '3319080011',
    districtId: '3319080',
    name: 'Rahtawu',
  },
  {
    id: '3319090001',
    districtId: '3319090',
    name: 'Samirejo',
  },
  {
    id: '3319090002',
    districtId: '3319090',
    name: 'Cendono',
  },
  {
    id: '3319090003',
    districtId: '3319090',
    name: 'Margorejo',
  },
  {
    id: '3319090004',
    districtId: '3319090',
    name: 'Rejosari',
  },
  {
    id: '3319090005',
    districtId: '3319090',
    name: 'Kandang Mas',
  },
  {
    id: '3319090006',
    districtId: '3319090',
    name: 'Lau',
  },
  {
    id: '3319090007',
    districtId: '3319090',
    name: 'Piji',
  },
  {
    id: '3319090008',
    districtId: '3319090',
    name: 'Puyoh',
  },
  {
    id: '3319090009',
    districtId: '3319090',
    name: 'Soco',
  },
  {
    id: '3319090010',
    districtId: '3319090',
    name: 'Ternadi',
  },
  {
    id: '3319090011',
    districtId: '3319090',
    name: 'Kajar',
  },
  {
    id: '3319090012',
    districtId: '3319090',
    name: 'Cranggang',
  },
  {
    id: '3319090013',
    districtId: '3319090',
    name: 'Tergo',
  },
  {
    id: '3319090014',
    districtId: '3319090',
    name: 'Glagah Kulon',
  },
  {
    id: '3319090015',
    districtId: '3319090',
    name: 'Dukuh Waringin',
  },
  {
    id: '3319090016',
    districtId: '3319090',
    name: 'Kuwukan',
  },
  {
    id: '3319090017',
    districtId: '3319090',
    name: 'Colo',
  },
  {
    id: '3319090018',
    districtId: '3319090',
    name: 'Japan',
  },
  {
    id: '3320010001',
    districtId: '3320010',
    name: 'Kedungmalang',
  },
  {
    id: '3320010002',
    districtId: '3320010',
    name: 'Kalianyar',
  },
  {
    id: '3320010003',
    districtId: '3320010',
    name: 'Karangaji',
  },
  {
    id: '3320010004',
    districtId: '3320010',
    name: 'Tedunan',
  },
  {
    id: '3320010005',
    districtId: '3320010',
    name: 'Sowan Lor',
  },
  {
    id: '3320010006',
    districtId: '3320010',
    name: 'Jondang',
  },
  {
    id: '3320010007',
    districtId: '3320010',
    name: 'Wanusobo',
  },
  {
    id: '3320010008',
    districtId: '3320010',
    name: 'Sowan Kidul',
  },
  {
    id: '3320010009',
    districtId: '3320010',
    name: 'Surodadi',
  },
  {
    id: '3320010010',
    districtId: '3320010',
    name: 'Panggung',
  },
  {
    id: '3320010011',
    districtId: '3320010',
    name: 'Bulakbaru',
  },
  {
    id: '3320010013',
    districtId: '3320010',
    name: 'Dongos',
  },
  {
    id: '3320010014',
    districtId: '3320010',
    name: 'Menganti',
  },
  {
    id: '3320010015',
    districtId: '3320010',
    name: 'Kerso',
  },
  {
    id: '3320010016',
    districtId: '3320010',
    name: 'Tanggultlare',
  },
  {
    id: '3320010017',
    districtId: '3320010',
    name: 'Rau',
  },
  {
    id: '3320010018',
    districtId: '3320010',
    name: 'Sukosono',
  },
  {
    id: '3320020013',
    districtId: '3320020',
    name: 'Krasak',
  },
  {
    id: '3320020014',
    districtId: '3320020',
    name: 'Karangrandu',
  },
  {
    id: '3320020015',
    districtId: '3320020',
    name: 'Kaliombo',
  },
  {
    id: '3320020016',
    districtId: '3320020',
    name: 'Ngeling',
  },
  {
    id: '3320020017',
    districtId: '3320020',
    name: 'Troso',
  },
  {
    id: '3320020018',
    districtId: '3320020',
    name: 'Pecangaan Kulon',
  },
  {
    id: '3320020019',
    districtId: '3320020',
    name: 'Pecangaan Wetan',
  },
  {
    id: '3320020020',
    districtId: '3320020',
    name: 'Lebuawu',
  },
  {
    id: '3320020021',
    districtId: '3320020',
    name: 'Pulodarat',
  },
  {
    id: '3320020024',
    districtId: '3320020',
    name: 'Rengging',
  },
  {
    id: '3320021001',
    districtId: '3320021',
    name: 'Batukali',
  },
  {
    id: '3320021002',
    districtId: '3320021',
    name: 'Bandungrejo',
  },
  {
    id: '3320021003',
    districtId: '3320021',
    name: 'Manyargading',
  },
  {
    id: '3320021004',
    districtId: '3320021',
    name: 'Robayan',
  },
  {
    id: '3320021005',
    districtId: '3320021',
    name: 'Bakalan',
  },
  {
    id: '3320021006',
    districtId: '3320021',
    name: 'Kriyan',
  },
  {
    id: '3320021007',
    districtId: '3320021',
    name: 'Purwogondo',
  },
  {
    id: '3320021008',
    districtId: '3320021',
    name: 'Sendang',
  },
  {
    id: '3320021009',
    districtId: '3320021',
    name: 'Margoyoso',
  },
  {
    id: '3320021010',
    districtId: '3320021',
    name: 'Banyuputih',
  },
  {
    id: '3320021011',
    districtId: '3320021',
    name: 'Pendosawalan',
  },
  {
    id: '3320021012',
    districtId: '3320021',
    name: 'Damarjati',
  },
  {
    id: '3320030001',
    districtId: '3320030',
    name: 'Ujungpandan',
  },
  {
    id: '3320030002',
    districtId: '3320030',
    name: 'Karanganyar',
  },
  {
    id: '3320030003',
    districtId: '3320030',
    name: 'Guwosobokerto',
  },
  {
    id: '3320030004',
    districtId: '3320030',
    name: 'Kedungsarimulyo',
  },
  {
    id: '3320030005',
    districtId: '3320030',
    name: 'Bugo',
  },
  {
    id: '3320030006',
    districtId: '3320030',
    name: 'Welahan',
  },
  {
    id: '3320030007',
    districtId: '3320030',
    name: 'Gedangan',
  },
  {
    id: '3320030008',
    districtId: '3320030',
    name: 'Ketilengsingolelo',
  },
  {
    id: '3320030009',
    districtId: '3320030',
    name: 'Kalipucang Wetan',
  },
  {
    id: '3320030010',
    districtId: '3320030',
    name: 'Kalipucang Kulon',
  },
  {
    id: '3320030011',
    districtId: '3320030',
    name: 'Gidangelo',
  },
  {
    id: '3320030012',
    districtId: '3320030',
    name: 'Kendengsidialit',
  },
  {
    id: '3320030013',
    districtId: '3320030',
    name: 'Sidigede',
  },
  {
    id: '3320030014',
    districtId: '3320030',
    name: 'Telukwetan',
  },
  {
    id: '3320030015',
    districtId: '3320030',
    name: 'Brantaksekarjati',
  },
  {
    id: '3320040001',
    districtId: '3320040',
    name: 'Mayong Kidul',
  },
  {
    id: '3320040002',
    districtId: '3320040',
    name: 'Mayong Lor',
  },
  {
    id: '3320040003',
    districtId: '3320040',
    name: 'Tigajuru',
  },
  {
    id: '3320040004',
    districtId: '3320040',
    name: 'Paren',
  },
  {
    id: '3320040005',
    districtId: '3320040',
    name: 'Kuanyar',
  },
  {
    id: '3320040006',
    districtId: '3320040',
    name: 'Pelang',
  },
  {
    id: '3320040007',
    districtId: '3320040',
    name: 'Sengonbugel',
  },
  {
    id: '3320040009',
    districtId: '3320040',
    name: 'Singorojo',
  },
  {
    id: '3320040010',
    districtId: '3320040',
    name: 'Jebol',
  },
  {
    id: '3320040011',
    districtId: '3320040',
    name: 'Buaran',
  },
  {
    id: '3320040012',
    districtId: '3320040',
    name: 'Ngroto',
  },
  {
    id: '3320040013',
    districtId: '3320040',
    name: 'Rajekwesi',
  },
  {
    id: '3320040014',
    districtId: '3320040',
    name: 'Datar',
  },
  {
    id: '3320040016',
    districtId: '3320040',
    name: 'Bandung',
  },
  {
    id: '3320040018',
    districtId: '3320040',
    name: 'Pancur',
  },
  {
    id: '3320050001',
    districtId: '3320050',
    name: 'Dorang',
  },
  {
    id: '3320050002',
    districtId: '3320050',
    name: 'Blimbingrejo',
  },
  {
    id: '3320050003',
    districtId: '3320050',
    name: 'Tunggulpandean',
  },
  {
    id: '3320050004',
    districtId: '3320050',
    name: 'Pringtulis',
  },
  {
    id: '3320050005',
    districtId: '3320050',
    name: 'Jatisari',
  },
  {
    id: '3320050006',
    districtId: '3320050',
    name: 'Gemiring Kidul',
  },
  {
    id: '3320050007',
    districtId: '3320050',
    name: 'Gemiring Lor',
  },
  {
    id: '3320050008',
    districtId: '3320050',
    name: 'Nalumsari',
  },
  {
    id: '3320050009',
    districtId: '3320050',
    name: 'Tritis',
  },
  {
    id: '3320050010',
    districtId: '3320050',
    name: 'Daren',
  },
  {
    id: '3320050011',
    districtId: '3320050',
    name: 'Karangnongko',
  },
  {
    id: '3320050013',
    districtId: '3320050',
    name: 'Bendanpete',
  },
  {
    id: '3320050014',
    districtId: '3320050',
    name: 'Muryolobo',
  },
  {
    id: '3320050015',
    districtId: '3320050',
    name: 'Bategede',
  },
  {
    id: '3320060001',
    districtId: '3320060',
    name: 'Ngasem',
  },
  {
    id: '3320060003',
    districtId: '3320060',
    name: 'Raguklampitan',
  },
  {
    id: '3320060004',
    districtId: '3320060',
    name: 'Mindahan Kidul',
  },
  {
    id: '3320060005',
    districtId: '3320060',
    name: 'Mindahan',
  },
  {
    id: '3320060006',
    districtId: '3320060',
    name: 'Somosari',
  },
  {
    id: '3320060007',
    districtId: '3320060',
    name: 'Batealit',
  },
  {
    id: '3320060008',
    districtId: '3320060',
    name: 'Bringin',
  },
  {
    id: '3320060009',
    districtId: '3320060',
    name: 'Bantrung',
  },
  {
    id: '3320060010',
    districtId: '3320060',
    name: 'Bawu',
  },
  {
    id: '3320060011',
    districtId: '3320060',
    name: 'Pekalongan',
  },
  {
    id: '3320070001',
    districtId: '3320070',
    name: 'Telukawur',
  },
  {
    id: '3320070002',
    districtId: '3320070',
    name: 'Semat',
  },
  {
    id: '3320070003',
    districtId: '3320070',
    name: 'Platar',
  },
  {
    id: '3320070004',
    districtId: '3320070',
    name: 'Mangunan',
  },
  {
    id: '3320070005',
    districtId: '3320070',
    name: 'Petekeyan',
  },
  {
    id: '3320070006',
    districtId: '3320070',
    name: 'Sukodono',
  },
  {
    id: '3320070007',
    districtId: '3320070',
    name: 'Langon',
  },
  {
    id: '3320070008',
    districtId: '3320070',
    name: 'Ngabul',
  },
  {
    id: '3320070009',
    districtId: '3320070',
    name: 'Tahunan',
  },
  {
    id: '3320070010',
    districtId: '3320070',
    name: 'Mantingan',
  },
  {
    id: '3320070011',
    districtId: '3320070',
    name: 'Demangan',
  },
  {
    id: '3320070012',
    districtId: '3320070',
    name: 'Tegalsambi',
  },
  {
    id: '3320070013',
    districtId: '3320070',
    name: 'Krapyak',
  },
  {
    id: '3320070014',
    districtId: '3320070',
    name: 'Senenan',
  },
  {
    id: '3320070015',
    districtId: '3320070',
    name: 'Kecapi',
  },
  {
    id: '3320080001',
    districtId: '3320080',
    name: 'Karangkebagusan',
  },
  {
    id: '3320080002',
    districtId: '3320080',
    name: 'Demaan',
  },
  {
    id: '3320080004',
    districtId: '3320080',
    name: 'Kauman',
  },
  {
    id: '3320080005',
    districtId: '3320080',
    name: 'Panggang',
  },
  {
    id: '3320080006',
    districtId: '3320080',
    name: 'Potroyudan',
  },
  {
    id: '3320080007',
    districtId: '3320080',
    name: 'Bapangan',
  },
  {
    id: '3320080008',
    districtId: '3320080',
    name: 'Saripan',
  },
  {
    id: '3320080009',
    districtId: '3320080',
    name: 'Jobokuto',
  },
  {
    id: '3320080010',
    districtId: '3320080',
    name: 'Ujungbatu',
  },
  {
    id: '3320080011',
    districtId: '3320080',
    name: 'Pengkol',
  },
  {
    id: '3320080012',
    districtId: '3320080',
    name: 'Mulyoharjo',
  },
  {
    id: '3320080013',
    districtId: '3320080',
    name: 'Kuwasen',
  },
  {
    id: '3320080014',
    districtId: '3320080',
    name: 'Bandengan',
  },
  {
    id: '3320080015',
    districtId: '3320080',
    name: 'Wonorejo',
  },
  {
    id: '3320080016',
    districtId: '3320080',
    name: 'Kedungcino',
  },
  {
    id: '3320090001',
    districtId: '3320090',
    name: 'Mororejo',
  },
  {
    id: '3320090010',
    districtId: '3320090',
    name: 'Suwawal',
  },
  {
    id: '3320090011',
    districtId: '3320090',
    name: 'Sinanggul',
  },
  {
    id: '3320090012',
    districtId: '3320090',
    name: 'Jambu Timur',
  },
  {
    id: '3320090013',
    districtId: '3320090',
    name: 'Jambu',
  },
  {
    id: '3320090014',
    districtId: '3320090',
    name: 'Sekuro',
  },
  {
    id: '3320090015',
    districtId: '3320090',
    name: 'Srobyong',
  },
  {
    id: '3320090016',
    districtId: '3320090',
    name: 'Karanggondang',
  },
  {
    id: '3320091001',
    districtId: '3320091',
    name: 'Lebak',
  },
  {
    id: '3320091002',
    districtId: '3320091',
    name: 'Bulungan',
  },
  {
    id: '3320091003',
    districtId: '3320091',
    name: 'Suwawal Timur',
  },
  {
    id: '3320091004',
    districtId: '3320091',
    name: 'Kawak',
  },
  {
    id: '3320091005',
    districtId: '3320091',
    name: 'Tanjung',
  },
  {
    id: '3320091006',
    districtId: '3320091',
    name: 'Plajan',
  },
  {
    id: '3320091007',
    districtId: '3320091',
    name: 'Slagi',
  },
  {
    id: '3320091008',
    districtId: '3320091',
    name: 'Mambak',
  },
  {
    id: '3320100001',
    districtId: '3320100',
    name: 'Guyangan',
  },
  {
    id: '3320100003',
    districtId: '3320100',
    name: 'Papasan',
  },
  {
    id: '3320100009',
    districtId: '3320100',
    name: 'Srikandang',
  },
  {
    id: '3320100010',
    districtId: '3320100',
    name: 'Tengguli',
  },
  {
    id: '3320100011',
    districtId: '3320100',
    name: 'Bangsri',
  },
  {
    id: '3320100012',
    districtId: '3320100',
    name: 'Banjaran',
  },
  {
    id: '3320100014',
    districtId: '3320100',
    name: 'Wedelan',
  },
  {
    id: '3320100015',
    districtId: '3320100',
    name: 'Jerukwangi',
  },
  {
    id: '3320100022',
    districtId: '3320100',
    name: 'Bondo',
  },
  {
    id: '3320100023',
    districtId: '3320100',
    name: 'Banjar Agung',
  },
  {
    id: '3320101001',
    districtId: '3320101',
    name: 'Dudakawu',
  },
  {
    id: '3320101002',
    districtId: '3320101',
    name: 'Sumanding',
  },
  {
    id: '3320101004',
    districtId: '3320101',
    name: 'Cepogo',
  },
  {
    id: '3320101006',
    districtId: '3320101',
    name: 'Jinggotan',
  },
  {
    id: '3320101007',
    districtId: '3320101',
    name: 'Kancilan',
  },
  {
    id: '3320101008',
    districtId: '3320101',
    name: 'Dermolo',
  },
  {
    id: '3320101009',
    districtId: '3320101',
    name: 'Balong',
  },
  {
    id: '3320101010',
    districtId: '3320101',
    name: 'Tubanan',
  },
  {
    id: '3320101011',
    districtId: '3320101',
    name: 'Kaliaman',
  },
  {
    id: '3320110002',
    districtId: '3320110',
    name: 'Damarwulan',
  },
  {
    id: '3320110003',
    districtId: '3320110',
    name: 'Kunir',
  },
  {
    id: '3320110004',
    districtId: '3320110',
    name: 'Watuaji',
  },
  {
    id: '3320110006',
    districtId: '3320110',
    name: 'Tunahan',
  },
  {
    id: '3320110007',
    districtId: '3320110',
    name: 'Kaligarang',
  },
  {
    id: '3320110008',
    districtId: '3320110',
    name: 'Keling',
  },
  {
    id: '3320110009',
    districtId: '3320110',
    name: 'Gelang',
  },
  {
    id: '3320110010',
    districtId: '3320110',
    name: 'Jlegong',
  },
  {
    id: '3320110019',
    districtId: '3320110',
    name: 'Bumiharjo',
  },
  {
    id: '3320111001',
    districtId: '3320111',
    name: 'Sumber Rejo',
  },
  {
    id: '3320111002',
    districtId: '3320111',
    name: 'Clering',
  },
  {
    id: '3320111003',
    districtId: '3320111',
    name: 'Ujungwatu',
  },
  {
    id: '3320111004',
    districtId: '3320111',
    name: 'Banyumanis',
  },
  {
    id: '3320111005',
    districtId: '3320111',
    name: 'Tulakan',
  },
  {
    id: '3320111006',
    districtId: '3320111',
    name: 'Bandungharjo',
  },
  {
    id: '3320111007',
    districtId: '3320111',
    name: 'Blingoh',
  },
  {
    id: '3320111008',
    districtId: '3320111',
    name: 'Jugo',
  },
  {
    id: '3320120001',
    districtId: '3320120',
    name: 'Karimunjawa',
  },
  {
    id: '3320120002',
    districtId: '3320120',
    name: 'Kemujan',
  },
  {
    id: '3320120003',
    districtId: '3320120',
    name: 'Parang',
  },
  {
    id: '3320120004',
    districtId: '3320120',
    name: 'Nyamuk',
  },
  {
    id: '3321010001',
    districtId: '3321010',
    name: 'Banyumeneng',
  },
  {
    id: '3321010002',
    districtId: '3321010',
    name: 'Sumberejo',
  },
  {
    id: '3321010003',
    districtId: '3321010',
    name: 'Kebonbatur',
  },
  {
    id: '3321010004',
    districtId: '3321010',
    name: 'Kangkung',
  },
  {
    id: '3321010005',
    districtId: '3321010',
    name: 'Kalitengah',
  },
  {
    id: '3321010006',
    districtId: '3321010',
    name: 'Kembangarum',
  },
  {
    id: '3321010007',
    districtId: '3321010',
    name: 'Mranggen',
  },
  {
    id: '3321010008',
    districtId: '3321010',
    name: 'Batursari',
  },
  {
    id: '3321010009',
    districtId: '3321010',
    name: 'Bandungrejo',
  },
  {
    id: '3321010011',
    districtId: '3321010',
    name: 'Ngemplak',
  },
  {
    id: '3321010012',
    districtId: '3321010',
    name: 'Tamansari',
  },
  {
    id: '3321010013',
    districtId: '3321010',
    name: 'Karangsono',
  },
  {
    id: '3321010014',
    districtId: '3321010',
    name: 'Candisari',
  },
  {
    id: '3321010015',
    districtId: '3321010',
    name: 'Tegalarum',
  },
  {
    id: '3321010016',
    districtId: '3321010',
    name: 'Waru',
  },
  {
    id: '3321010018',
    districtId: '3321010',
    name: 'Jamus',
  },
  {
    id: '3321010019',
    districtId: '3321010',
    name: 'Wringin Jajar',
  },
  {
    id: '3321020001',
    districtId: '3321020',
    name: 'Jragung',
  },
  {
    id: '3321020002',
    districtId: '3321020',
    name: 'Wonosekar',
  },
  {
    id: '3321020003',
    districtId: '3321020',
    name: 'Margohayu',
  },
  {
    id: '3321020004',
    districtId: '3321020',
    name: 'Tlogorejo',
  },
  {
    id: '3321020006',
    districtId: '3321020',
    name: 'Rejosari',
  },
  {
    id: '3321020007',
    districtId: '3321020',
    name: 'Karangawen',
  },
  {
    id: '3321020008',
    districtId: '3321020',
    name: 'Kuripan',
  },
  {
    id: '3321020009',
    districtId: '3321020',
    name: 'Bumirejo',
  },
  {
    id: '3321020010',
    districtId: '3321020',
    name: 'Brambang',
  },
  {
    id: '3321020011',
    districtId: '3321020',
    name: 'Sido Rejo',
  },
  {
    id: '3321020012',
    districtId: '3321020',
    name: 'Pundenarum',
  },
  {
    id: '3321030001',
    districtId: '3321030',
    name: 'Banjarejo',
  },
  {
    id: '3321030002',
    districtId: '3321030',
    name: 'Wonorejo',
  },
  {
    id: '3321030003',
    districtId: '3321030',
    name: 'Pamongan',
  },
  {
    id: '3321030004',
    districtId: '3321030',
    name: 'Tlogoweru',
  },
  {
    id: '3321030005',
    districtId: '3321030',
    name: 'Bogosari',
  },
  {
    id: '3321030006',
    districtId: '3321030',
    name: 'Sukorejo',
  },
  {
    id: '3321030007',
    districtId: '3321030',
    name: 'Sarirejo',
  },
  {
    id: '3321030008',
    districtId: '3321030',
    name: 'Sidokumpul',
  },
  {
    id: '3321030009',
    districtId: '3321030',
    name: 'Gaji',
  },
  {
    id: '3321030010',
    districtId: '3321030',
    name: 'Blerong',
  },
  {
    id: '3321030011',
    districtId: '3321030',
    name: 'Krandon',
  },
  {
    id: '3321030012',
    districtId: '3321030',
    name: 'Tangkis',
  },
  {
    id: '3321030013',
    districtId: '3321030',
    name: 'Temuroso',
  },
  {
    id: '3321030015',
    districtId: '3321030',
    name: 'Trimulyo',
  },
  {
    id: '3321030016',
    districtId: '3321030',
    name: 'Tlogorejo',
  },
  {
    id: '3321030017',
    districtId: '3321030',
    name: 'Bumiharjo',
  },
  {
    id: '3321030018',
    districtId: '3321030',
    name: 'Bakalrejo',
  },
  {
    id: '3321030019',
    districtId: '3321030',
    name: 'Turitempel',
  },
  {
    id: '3321030020',
    districtId: '3321030',
    name: 'Sidoharjo',
  },
  {
    id: '3321040001',
    districtId: '3321040',
    name: 'Jetaksari',
  },
  {
    id: '3321040002',
    districtId: '3321040',
    name: 'Dombo',
  },
  {
    id: '3321040003',
    districtId: '3321040',
    name: 'Bulusari',
  },
  {
    id: '3321040004',
    districtId: '3321040',
    name: 'Perampelan',
  },
  {
    id: '3321040005',
    districtId: '3321040',
    name: 'Karangasem',
  },
  {
    id: '3321040006',
    districtId: '3321040',
    name: 'Kalisari',
  },
  {
    id: '3321040007',
    districtId: '3321040',
    name: 'Sayung',
  },
  {
    id: '3321040008',
    districtId: '3321040',
    name: 'Tambakroto',
  },
  {
    id: '3321040009',
    districtId: '3321040',
    name: 'Pilangsari',
  },
  {
    id: '3321040010',
    districtId: '3321040',
    name: 'Loireng',
  },
  {
    id: '3321040011',
    districtId: '3321040',
    name: 'Gemulak',
  },
  {
    id: '3321040012',
    districtId: '3321040',
    name: 'Sidogemah',
  },
  {
    id: '3321040013',
    districtId: '3321040',
    name: 'Purwosari',
  },
  {
    id: '3321040014',
    districtId: '3321040',
    name: 'Sriwulan',
  },
  {
    id: '3321040015',
    districtId: '3321040',
    name: 'Bedono',
  },
  {
    id: '3321040016',
    districtId: '3321040',
    name: 'Timbulsloko',
  },
  {
    id: '3321040018',
    districtId: '3321040',
    name: 'Sidorejo',
  },
  {
    id: '3321040019',
    districtId: '3321040',
    name: 'Banjarsari',
  },
  {
    id: '3321040020',
    districtId: '3321040',
    name: 'Surodadi',
  },
  {
    id: '3321050001',
    districtId: '3321050',
    name: 'Sampang',
  },
  {
    id: '3321050002',
    districtId: '3321050',
    name: 'Klitih',
  },
  {
    id: '3321050003',
    districtId: '3321050',
    name: 'Pidodo',
  },
  {
    id: '3321050004',
    districtId: '3321050',
    name: 'Donorejo',
  },
  {
    id: '3321050005',
    districtId: '3321050',
    name: 'Grogol',
  },
  {
    id: '3321050006',
    districtId: '3321050',
    name: 'Ploso',
  },
  {
    id: '3321050007',
    districtId: '3321050',
    name: 'Pulosari',
  },
  {
    id: '3321050008',
    districtId: '3321050',
    name: 'Karangsari',
  },
  {
    id: '3321050009',
    districtId: '3321050',
    name: 'Karangtowo',
  },
  {
    id: '3321050012',
    districtId: '3321050',
    name: 'Batu',
  },
  {
    id: '3321050013',
    districtId: '3321050',
    name: 'Wonokerto',
  },
  {
    id: '3321050014',
    districtId: '3321050',
    name: 'Wonowoso',
  },
  {
    id: '3321050015',
    districtId: '3321050',
    name: 'Rejosari',
  },
  {
    id: '3321050016',
    districtId: '3321050',
    name: 'Wonoagung',
  },
  {
    id: '3321050017',
    districtId: '3321050',
    name: 'Tambakbulusan',
  },
  {
    id: '3321060001',
    districtId: '3321060',
    name: 'Morodemak',
  },
  {
    id: '3321060002',
    districtId: '3321060',
    name: 'Margolinduk',
  },
  {
    id: '3321060003',
    districtId: '3321060',
    name: 'Gebang',
  },
  {
    id: '3321060004',
    districtId: '3321060',
    name: 'Gebangarum',
  },
  {
    id: '3321060005',
    districtId: '3321060',
    name: 'Karangrejo',
  },
  {
    id: '3321060006',
    districtId: '3321060',
    name: 'Tlogoboyo',
  },
  {
    id: '3321060007',
    districtId: '3321060',
    name: 'Krajanbogo',
  },
  {
    id: '3321060008',
    districtId: '3321060',
    name: 'Kembangan',
  },
  {
    id: '3321060009',
    districtId: '3321060',
    name: 'Sumberejo',
  },
  {
    id: '3321060010',
    districtId: '3321060',
    name: 'Sukodono',
  },
  {
    id: '3321060011',
    districtId: '3321060',
    name: 'Jatimulyo',
  },
  {
    id: '3321060012',
    districtId: '3321060',
    name: 'Bonangrejo',
  },
  {
    id: '3321060013',
    districtId: '3321060',
    name: 'Jatirogo',
  },
  {
    id: '3321060014',
    districtId: '3321060',
    name: 'Tridonorejo',
  },
  {
    id: '3321060015',
    districtId: '3321060',
    name: 'Purworejo',
  },
  {
    id: '3321060016',
    districtId: '3321060',
    name: 'Betahwalang',
  },
  {
    id: '3321060017',
    districtId: '3321060',
    name: 'Serangan',
  },
  {
    id: '3321060018',
    districtId: '3321060',
    name: 'Poncoharjo',
  },
  {
    id: '3321060019',
    districtId: '3321060',
    name: 'Wonosari',
  },
  {
    id: '3321060020',
    districtId: '3321060',
    name: 'Jali',
  },
  {
    id: '3321060021',
    districtId: '3321060',
    name: 'Weding',
  },
  {
    id: '3321070001',
    districtId: '3321070',
    name: 'Kalikondang',
  },
  {
    id: '3321070002',
    districtId: '3321070',
    name: 'Donorejo',
  },
  {
    id: '3321070003',
    districtId: '3321070',
    name: 'Katonsari',
  },
  {
    id: '3321070004',
    districtId: '3321070',
    name: 'Mangunjiwan',
  },
  {
    id: '3321070005',
    districtId: '3321070',
    name: 'Karangmlati',
  },
  {
    id: '3321070006',
    districtId: '3321070',
    name: 'Kalicilik',
  },
  {
    id: '3321070007',
    districtId: '3321070',
    name: 'Singorejo',
  },
  {
    id: '3321070008',
    districtId: '3321070',
    name: 'Betokan',
  },
  {
    id: '3321070009',
    districtId: '3321070',
    name: 'Bintoro',
  },
  {
    id: '3321070010',
    districtId: '3321070',
    name: 'Kadilangu',
  },
  {
    id: '3321070011',
    districtId: '3321070',
    name: 'Bolo',
  },
  {
    id: '3321070012',
    districtId: '3321070',
    name: 'Bango',
  },
  {
    id: '3321070013',
    districtId: '3321070',
    name: 'Cabean',
  },
  {
    id: '3321070014',
    districtId: '3321070',
    name: 'Tempuran',
  },
  {
    id: '3321070015',
    districtId: '3321070',
    name: 'Turirejo',
  },
  {
    id: '3321070016',
    districtId: '3321070',
    name: 'Raji',
  },
  {
    id: '3321070017',
    districtId: '3321070',
    name: 'Kedondong',
  },
  {
    id: '3321070018',
    districtId: '3321070',
    name: 'Sedo',
  },
  {
    id: '3321070019',
    districtId: '3321070',
    name: 'Mulyorejo',
  },
  {
    id: '3321080001',
    districtId: '3321080',
    name: 'Doreng',
  },
  {
    id: '3321080002',
    districtId: '3321080',
    name: 'Tlogodowo',
  },
  {
    id: '3321080003',
    districtId: '3321080',
    name: 'Kalianyar',
  },
  {
    id: '3321080004',
    districtId: '3321080',
    name: 'Bunderan',
  },
  {
    id: '3321080005',
    districtId: '3321080',
    name: 'Getas',
  },
  {
    id: '3321080006',
    districtId: '3321080',
    name: 'Kerangkulon',
  },
  {
    id: '3321080007',
    districtId: '3321080',
    name: 'Karangrowo',
  },
  {
    id: '3321080008',
    districtId: '3321080',
    name: 'Lempuyang',
  },
  {
    id: '3321080009',
    districtId: '3321080',
    name: 'Tlogorejo',
  },
  {
    id: '3321080010',
    districtId: '3321080',
    name: 'Pilangrejo',
  },
  {
    id: '3321080011',
    districtId: '3321080',
    name: 'Mojodemak',
  },
  {
    id: '3321080012',
    districtId: '3321080',
    name: 'Sido Mulyo',
  },
  {
    id: '3321080013',
    districtId: '3321080',
    name: 'Kendaldoyong',
  },
  {
    id: '3321080014',
    districtId: '3321080',
    name: 'Wonosalam',
  },
  {
    id: '3321080015',
    districtId: '3321080',
    name: 'Karangrejo',
  },
  {
    id: '3321080016',
    districtId: '3321080',
    name: 'Jogoloyo',
  },
  {
    id: '3321080017',
    districtId: '3321080',
    name: 'Botorejo',
  },
  {
    id: '3321080018',
    districtId: '3321080',
    name: 'Mranak',
  },
  {
    id: '3321080019',
    districtId: '3321080',
    name: 'Mrisen',
  },
  {
    id: '3321080020',
    districtId: '3321080',
    name: 'Kuncir',
  },
  {
    id: '3321080021',
    districtId: '3321080',
    name: 'Trengguli',
  },
  {
    id: '3321090008',
    districtId: '3321090',
    name: 'Merak',
  },
  {
    id: '3321090009',
    districtId: '3321090',
    name: 'Karangrejo',
  },
  {
    id: '3321090016',
    districtId: '3321090',
    name: 'Botosengon',
  },
  {
    id: '3321090018',
    districtId: '3321090',
    name: 'Baleromo',
  },
  {
    id: '3321090020',
    districtId: '3321090',
    name: 'Kunir',
  },
  {
    id: '3321090021',
    districtId: '3321090',
    name: 'Brakas',
  },
  {
    id: '3321090022',
    districtId: '3321090',
    name: 'Balerejo',
  },
  {
    id: '3321090023',
    districtId: '3321090',
    name: 'Sidomulyo',
  },
  {
    id: '3321090024',
    districtId: '3321090',
    name: 'Gempoldenok',
  },
  {
    id: '3321090025',
    districtId: '3321090',
    name: 'Kebonsari',
  },
  {
    id: '3321090026',
    districtId: '3321090',
    name: 'Kedungori',
  },
  {
    id: '3321090029',
    districtId: '3321090',
    name: 'Kramat',
  },
  {
    id: '3321090030',
    districtId: '3321090',
    name: 'Harjowinangun',
  },
  {
    id: '3321091001',
    districtId: '3321091',
    name: 'Pilangwetan',
  },
  {
    id: '3321091002',
    districtId: '3321091',
    name: 'Kebonagung',
  },
  {
    id: '3321091003',
    districtId: '3321091',
    name: 'Mijen',
  },
  {
    id: '3321091004',
    districtId: '3321091',
    name: 'Klampok Lor',
  },
  {
    id: '3321091005',
    districtId: '3321091',
    name: 'Mangunan Lor',
  },
  {
    id: '3321091006',
    districtId: '3321091',
    name: 'Werdoyo',
  },
  {
    id: '3321091007',
    districtId: '3321091',
    name: 'Mangunrejo',
  },
  {
    id: '3321091008',
    districtId: '3321091',
    name: 'Babad',
  },
  {
    id: '3321091009',
    districtId: '3321091',
    name: 'Megonten',
  },
  {
    id: '3321091010',
    districtId: '3321091',
    name: 'Soko Kidul',
  },
  {
    id: '3321091011',
    districtId: '3321091',
    name: 'Tlogosih',
  },
  {
    id: '3321091012',
    districtId: '3321091',
    name: 'Prigi',
  },
  {
    id: '3321091013',
    districtId: '3321091',
    name: 'Sarimulyo',
  },
  {
    id: '3321091014',
    districtId: '3321091',
    name: 'Solowire',
  },
  {
    id: '3321100001',
    districtId: '3321100',
    name: 'Surodadi',
  },
  {
    id: '3321100002',
    districtId: '3321100',
    name: 'Jatisono',
  },
  {
    id: '3321100003',
    districtId: '3321100',
    name: 'Kedondong',
  },
  {
    id: '3321100004',
    districtId: '3321100',
    name: 'Gedangalas',
  },
  {
    id: '3321100005',
    districtId: '3321100',
    name: 'Sambiroto',
  },
  {
    id: '3321100006',
    districtId: '3321100',
    name: 'Tanjunganyar',
  },
  {
    id: '3321100007',
    districtId: '3321100',
    name: 'Wilalung',
  },
  {
    id: '3321100008',
    districtId: '3321100',
    name: 'Medini',
  },
  {
    id: '3321100009',
    districtId: '3321100',
    name: 'Mlatiharjo',
  },
  {
    id: '3321100010',
    districtId: '3321100',
    name: 'Tambirejo',
  },
  {
    id: '3321100011',
    districtId: '3321100',
    name: 'Banjarsari',
  },
  {
    id: '3321100012',
    districtId: '3321100',
    name: 'Boyolali',
  },
  {
    id: '3321100013',
    districtId: '3321100',
    name: 'Gajah',
  },
  {
    id: '3321100014',
    districtId: '3321100',
    name: 'Sari',
  },
  {
    id: '3321100015',
    districtId: '3321100',
    name: 'Mlekang',
  },
  {
    id: '3321100016',
    districtId: '3321100',
    name: 'Sambung',
  },
  {
    id: '3321100017',
    districtId: '3321100',
    name: 'Tlogopandogan',
  },
  {
    id: '3321100018',
    districtId: '3321100',
    name: 'Mojosimo',
  },
  {
    id: '3321110001',
    districtId: '3321110',
    name: 'Jatirejo',
  },
  {
    id: '3321110002',
    districtId: '3321110',
    name: 'Ngaluran',
  },
  {
    id: '3321110003',
    districtId: '3321110',
    name: 'Wonoketingal',
  },
  {
    id: '3321110004',
    districtId: '3321110',
    name: 'Cangkring Rembang',
  },
  {
    id: '3321110005',
    districtId: '3321110',
    name: 'Cangkring',
  },
  {
    id: '3321110006',
    districtId: '3321110',
    name: 'Tuwang',
  },
  {
    id: '3321110007',
    districtId: '3321110',
    name: 'Undaan Kidul',
  },
  {
    id: '3321110008',
    districtId: '3321110',
    name: 'Undaan Lor',
  },
  {
    id: '3321110009',
    districtId: '3321110',
    name: 'Ketanjung',
  },
  {
    id: '3321110010',
    districtId: '3321110',
    name: 'Ngemplik Wetan',
  },
  {
    id: '3321110011',
    districtId: '3321110',
    name: 'Wonorejo',
  },
  {
    id: '3321110012',
    districtId: '3321110',
    name: 'Karanganyar',
  },
  {
    id: '3321110013',
    districtId: '3321110',
    name: 'Kedungwaru Kidul',
  },
  {
    id: '3321110014',
    districtId: '3321110',
    name: 'Kedungwaru Lor',
  },
  {
    id: '3321110015',
    districtId: '3321110',
    name: 'Bandungrejo',
  },
  {
    id: '3321110016',
    districtId: '3321110',
    name: 'Tugu Lor',
  },
  {
    id: '3321110017',
    districtId: '3321110',
    name: 'Kotakan',
  },
  {
    id: '3321120001',
    districtId: '3321120',
    name: 'Banteng Mati',
  },
  {
    id: '3321120002',
    districtId: '3321120',
    name: 'Mlaten',
  },
  {
    id: '3321120003',
    districtId: '3321120',
    name: 'Ngelo Wetan',
  },
  {
    id: '3321120005',
    districtId: '3321120',
    name: 'Bakung',
  },
  {
    id: '3321120006',
    districtId: '3321120',
    name: 'Bermi',
  },
  {
    id: '3321120007',
    districtId: '3321120',
    name: 'Tanggul',
  },
  {
    id: '3321120008',
    districtId: '3321120',
    name: 'Ngelo Kulon',
  },
  {
    id: '3321120009',
    districtId: '3321120',
    name: 'Pasir',
  },
  {
    id: '3321120010',
    districtId: '3321120',
    name: 'Rejosari',
  },
  {
    id: '3321120011',
    districtId: '3321120',
    name: 'Ngegot',
  },
  {
    id: '3321120014',
    districtId: '3321120',
    name: 'Mijen',
  },
  {
    id: '3321120015',
    districtId: '3321120',
    name: 'Gempolsongo',
  },
  {
    id: '3321130002',
    districtId: '3321130',
    name: 'Ngawen',
  },
  {
    id: '3321130003',
    districtId: '3321130',
    name: 'Ruwit',
  },
  {
    id: '3321130005',
    districtId: '3321130',
    name: 'Buko',
  },
  {
    id: '3321130006',
    districtId: '3321130',
    name: 'Mandung',
  },
  {
    id: '3321130007',
    districtId: '3321130',
    name: 'Berahan Kulon',
  },
  {
    id: '3321130008',
    districtId: '3321130',
    name: 'Berahan Wetan',
  },
  {
    id: '3321130009',
    districtId: '3321130',
    name: 'Bungo',
  },
  {
    id: '3321130011',
    districtId: '3321130',
    name: 'Jetak',
  },
  {
    id: '3321130012',
    districtId: '3321130',
    name: 'Jungsemi',
  },
  {
    id: '3321130013',
    districtId: '3321130',
    name: 'Jungpasir',
  },
  {
    id: '3321130014',
    districtId: '3321130',
    name: 'Mutih Wetan',
  },
  {
    id: '3321130015',
    districtId: '3321130',
    name: 'Mutih Kulon',
  },
  {
    id: '3321130016',
    districtId: '3321130',
    name: 'Tedunan',
  },
  {
    id: '3321130017',
    districtId: '3321130',
    name: 'Kendalasem',
  },
  {
    id: '3321130018',
    districtId: '3321130',
    name: 'Kedungkarang',
  },
  {
    id: '3321130019',
    districtId: '3321130',
    name: 'Kedungmutih',
  },
  {
    id: '3321130020',
    districtId: '3321130',
    name: 'Babalan',
  },
  {
    id: '3322010001',
    districtId: '3322010',
    name: 'Kopeng',
  },
  {
    id: '3322010002',
    districtId: '3322010',
    name: 'Batur',
  },
  {
    id: '3322010003',
    districtId: '3322010',
    name: 'Tajuk',
  },
  {
    id: '3322010004',
    districtId: '3322010',
    name: 'Jetak',
  },
  {
    id: '3322010005',
    districtId: '3322010',
    name: 'Samirono',
  },
  {
    id: '3322010006',
    districtId: '3322010',
    name: 'Sumogawe',
  },
  {
    id: '3322010007',
    districtId: '3322010',
    name: 'Polobogo',
  },
  {
    id: '3322010008',
    districtId: '3322010',
    name: 'Manggihan',
  },
  {
    id: '3322010009',
    districtId: '3322010',
    name: 'Getasan',
  },
  {
    id: '3322010010',
    districtId: '3322010',
    name: 'Wates',
  },
  {
    id: '3322010011',
    districtId: '3322010',
    name: 'Tolokan',
  },
  {
    id: '3322010012',
    districtId: '3322010',
    name: 'Ngrawan',
  },
  {
    id: '3322010013',
    districtId: '3322010',
    name: 'Nogosaren',
  },
  {
    id: '3322020001',
    districtId: '3322020',
    name: 'Tengaran',
  },
  {
    id: '3322020002',
    districtId: '3322020',
    name: 'Tegalrejo',
  },
  {
    id: '3322020004',
    districtId: '3322020',
    name: 'Sugihan',
  },
  {
    id: '3322020007',
    districtId: '3322020',
    name: 'Cukil',
  },
  {
    id: '3322020008',
    districtId: '3322020',
    name: 'Klero',
  },
  {
    id: '3322020010',
    districtId: '3322020',
    name: 'Patemon',
  },
  {
    id: '3322020011',
    districtId: '3322020',
    name: 'Karangduren',
  },
  {
    id: '3322020013',
    districtId: '3322020',
    name: 'Tegalwaton',
  },
  {
    id: '3322020014',
    districtId: '3322020',
    name: 'Barukan',
  },
  {
    id: '3322020015',
    districtId: '3322020',
    name: 'Nyamat',
  },
  {
    id: '3322030012',
    districtId: '3322030',
    name: 'Badran',
  },
  {
    id: '3322030013',
    districtId: '3322030',
    name: 'Timpik',
  },
  {
    id: '3322030014',
    districtId: '3322030',
    name: 'Tawang',
  },
  {
    id: '3322030015',
    districtId: '3322030',
    name: 'Bakalrejo',
  },
  {
    id: '3322030016',
    districtId: '3322030',
    name: 'Ketapang',
  },
  {
    id: '3322030017',
    districtId: '3322030',
    name: 'Susukan',
  },
  {
    id: '3322030018',
    districtId: '3322030',
    name: 'Sidoharjo',
  },
  {
    id: '3322030019',
    districtId: '3322030',
    name: 'Gentan',
  },
  {
    id: '3322030020',
    districtId: '3322030',
    name: 'Muncar',
  },
  {
    id: '3322030021',
    districtId: '3322030',
    name: 'Ngasinan',
  },
  {
    id: '3322030022',
    districtId: '3322030',
    name: 'Koripan',
  },
  {
    id: '3322031001',
    districtId: '3322031',
    name: 'Siwal',
  },
  {
    id: '3322031002',
    districtId: '3322031',
    name: 'Pager',
  },
  {
    id: '3322031003',
    districtId: '3322031',
    name: 'Udanwuh',
  },
  {
    id: '3322031005',
    districtId: '3322031',
    name: 'Papringan',
  },
  {
    id: '3322031006',
    districtId: '3322031',
    name: 'Kradenan',
  },
  {
    id: '3322031007',
    districtId: '3322031',
    name: 'Kaliwungu',
  },
  {
    id: '3322031008',
    districtId: '3322031',
    name: 'Mukiran',
  },
  {
    id: '3322031009',
    districtId: '3322031',
    name: 'Payungan',
  },
  {
    id: '3322031010',
    districtId: '3322031',
    name: 'Jetis',
  },
  {
    id: '3322031011',
    districtId: '3322031',
    name: 'Rogomulyo',
  },
  {
    id: '3322040001',
    districtId: '3322040',
    name: 'Kebowan',
  },
  {
    id: '3322040002',
    districtId: '3322040',
    name: 'Beji Lor',
  },
  {
    id: '3322040003',
    districtId: '3322040',
    name: 'Jatirejo',
  },
  {
    id: '3322040004',
    districtId: '3322040',
    name: 'Dersansari',
  },
  {
    id: '3322040005',
    districtId: '3322040',
    name: 'Purworejo',
  },
  {
    id: '3322040006',
    districtId: '3322040',
    name: 'Ketanggi',
  },
  {
    id: '3322040007',
    districtId: '3322040',
    name: 'Medayu',
  },
  {
    id: '3322040008',
    districtId: '3322040',
    name: 'Bonomerto',
  },
  {
    id: '3322040009',
    districtId: '3322040',
    name: 'Sukorejo',
  },
  {
    id: '3322040010',
    districtId: '3322040',
    name: 'Kedungringin',
  },
  {
    id: '3322040012',
    districtId: '3322040',
    name: 'Reksosari',
  },
  {
    id: '3322040014',
    districtId: '3322040',
    name: 'Plumbon',
  },
  {
    id: '3322040015',
    districtId: '3322040',
    name: 'Krandon Lor',
  },
  {
    id: '3322040016',
    districtId: '3322040',
    name: 'Cukilan',
  },
  {
    id: '3322040017',
    districtId: '3322040',
    name: 'Dadapayam',
  },
  {
    id: '3322050002',
    districtId: '3322050',
    name: 'Sumberejo',
  },
  {
    id: '3322050003',
    districtId: '3322050',
    name: 'Segiri',
  },
  {
    id: '3322050004',
    districtId: '3322050',
    name: 'Terban',
  },
  {
    id: '3322050005',
    districtId: '3322050',
    name: 'Tukang',
  },
  {
    id: '3322050006',
    districtId: '3322050',
    name: 'Semowo',
  },
  {
    id: '3322050007',
    districtId: '3322050',
    name: 'Bendungan',
  },
  {
    id: '3322050008',
    districtId: '3322050',
    name: 'Karanggondang',
  },
  {
    id: '3322050009',
    districtId: '3322050',
    name: 'Sukoharjo',
  },
  {
    id: '3322050010',
    districtId: '3322050',
    name: 'Jembrak',
  },
  {
    id: '3322050011',
    districtId: '3322050',
    name: 'Glawan',
  },
  {
    id: '3322050012',
    districtId: '3322050',
    name: 'Kadirejo',
  },
  {
    id: '3322050013',
    districtId: '3322050',
    name: 'Bejaten',
  },
  {
    id: '3322050014',
    districtId: '3322050',
    name: 'Giling',
  },
  {
    id: '3322050015',
    districtId: '3322050',
    name: 'Padaan',
  },
  {
    id: '3322050016',
    districtId: '3322050',
    name: 'Kauman Lor',
  },
  {
    id: '3322050017',
    districtId: '3322050',
    name: 'Pabelan',
  },
  {
    id: '3322060001',
    districtId: '3322060',
    name: 'Kalibeji',
  },
  {
    id: '3322060002',
    districtId: '3322060',
    name: 'Gedangan',
  },
  {
    id: '3322060003',
    districtId: '3322060',
    name: 'Sraten',
  },
  {
    id: '3322060004',
    districtId: '3322060',
    name: 'Rowosari',
  },
  {
    id: '3322060005',
    districtId: '3322060',
    name: 'Jombor',
  },
  {
    id: '3322060006',
    districtId: '3322060',
    name: 'Candirejo',
  },
  {
    id: '3322060007',
    districtId: '3322060',
    name: 'Kesongo',
  },
  {
    id: '3322060008',
    districtId: '3322060',
    name: 'Watuagung',
  },
  {
    id: '3322060009',
    districtId: '3322060',
    name: 'Lopait',
  },
  {
    id: '3322060010',
    districtId: '3322060',
    name: 'Tuntang',
  },
  {
    id: '3322060011',
    districtId: '3322060',
    name: 'Delik',
  },
  {
    id: '3322060012',
    districtId: '3322060',
    name: 'Tlogo',
  },
  {
    id: '3322060013',
    districtId: '3322060',
    name: 'Karangtengah',
  },
  {
    id: '3322060014',
    districtId: '3322060',
    name: 'Karanganyar',
  },
  {
    id: '3322060015',
    districtId: '3322060',
    name: 'Tlompakan',
  },
  {
    id: '3322060016',
    districtId: '3322060',
    name: 'Ngajaran',
  },
  {
    id: '3322070001',
    districtId: '3322070',
    name: 'Wirogomo',
  },
  {
    id: '3322070002',
    districtId: '3322070',
    name: 'Kemambang',
  },
  {
    id: '3322070003',
    districtId: '3322070',
    name: 'Sepakung',
  },
  {
    id: '3322070005',
    districtId: '3322070',
    name: 'Gedong',
  },
  {
    id: '3322070006',
    districtId: '3322070',
    name: 'Rowoboni',
  },
  {
    id: '3322070007',
    districtId: '3322070',
    name: 'Tegaron',
  },
  {
    id: '3322070008',
    districtId: '3322070',
    name: 'Kebondowo',
  },
  {
    id: '3322070009',
    districtId: '3322070',
    name: 'Banyubiru',
  },
  {
    id: '3322070010',
    districtId: '3322070',
    name: 'Ngrapah',
  },
  {
    id: '3322080001',
    districtId: '3322080',
    name: 'Gemawang',
  },
  {
    id: '3322080002',
    districtId: '3322080',
    name: 'Bedono',
  },
  {
    id: '3322080003',
    districtId: '3322080',
    name: 'Kelurahan',
  },
  {
    id: '3322080004',
    districtId: '3322080',
    name: 'Brongkol',
  },
  {
    id: '3322080005',
    districtId: '3322080',
    name: 'Jambu',
  },
  {
    id: '3322080006',
    districtId: '3322080',
    name: 'Gondoriyo',
  },
  {
    id: '3322080007',
    districtId: '3322080',
    name: 'Kuwarasan',
  },
  {
    id: '3322080008',
    districtId: '3322080',
    name: 'Kebondalem',
  },
  {
    id: '3322080009',
    districtId: '3322080',
    name: 'Rejosari',
  },
  {
    id: '3322080010',
    districtId: '3322080',
    name: 'Genting',
  },
  {
    id: '3322090001',
    districtId: '3322090',
    name: 'Kebonagung',
  },
  {
    id: '3322090002',
    districtId: '3322090',
    name: 'Ngadikerso',
  },
  {
    id: '3322090003',
    districtId: '3322090',
    name: 'Lanjan',
  },
  {
    id: '3322090004',
    districtId: '3322090',
    name: 'Candigaron',
  },
  {
    id: '3322090005',
    districtId: '3322090',
    name: 'Kemitir',
  },
  {
    id: '3322090006',
    districtId: '3322090',
    name: 'Trayu',
  },
  {
    id: '3322090007',
    districtId: '3322090',
    name: 'Sumowono',
  },
  {
    id: '3322090008',
    districtId: '3322090',
    name: 'Jubelan',
  },
  {
    id: '3322090010',
    districtId: '3322090',
    name: 'Mendongan',
  },
  {
    id: '3322090011',
    districtId: '3322090',
    name: 'Losari',
  },
  {
    id: '3322090012',
    districtId: '3322090',
    name: 'Kemawi',
  },
  {
    id: '3322090013',
    districtId: '3322090',
    name: 'Piyanggang',
  },
  {
    id: '3322090014',
    districtId: '3322090',
    name: 'Pledokan',
  },
  {
    id: '3322100001',
    districtId: '3322100',
    name: 'Ngampin',
  },
  {
    id: '3322100002',
    districtId: '3322100',
    name: 'Pojoksari',
  },
  {
    id: '3322100003',
    districtId: '3322100',
    name: 'Bejalen',
  },
  {
    id: '3322100004',
    districtId: '3322100',
    name: 'Tambakboyo',
  },
  {
    id: '3322100005',
    districtId: '3322100',
    name: 'Kupang',
  },
  {
    id: '3322100006',
    districtId: '3322100',
    name: 'Lodoyong',
  },
  {
    id: '3322100007',
    districtId: '3322100',
    name: 'Kranggan',
  },
  {
    id: '3322100008',
    districtId: '3322100',
    name: 'Panjang',
  },
  {
    id: '3322100009',
    districtId: '3322100',
    name: 'Pasekan',
  },
  {
    id: '3322100010',
    districtId: '3322100',
    name: 'Baran',
  },
  {
    id: '3322101001',
    districtId: '3322101',
    name: 'Mlilir',
  },
  {
    id: '3322101003',
    districtId: '3322101',
    name: 'Jetis',
  },
  {
    id: '3322101004',
    districtId: '3322101',
    name: 'Bandungan',
  },
  {
    id: '3322101006',
    districtId: '3322101',
    name: 'Candi',
  },
  {
    id: '3322101007',
    districtId: '3322101',
    name: 'Banyukuning',
  },
  {
    id: '3322101008',
    districtId: '3322101',
    name: 'Jimbaran',
  },
  {
    id: '3322101009',
    districtId: '3322101',
    name: 'Pakopen',
  },
  {
    id: '3322101010',
    districtId: '3322101',
    name: 'Sidomukti',
  },
  {
    id: '3322110001',
    districtId: '3322110',
    name: 'Doplang',
  },
  {
    id: '3322110002',
    districtId: '3322110',
    name: 'Bawen',
  },
  {
    id: '3322110003',
    districtId: '3322110',
    name: 'Asinan',
  },
  {
    id: '3322110004',
    districtId: '3322110',
    name: 'Polosiri',
  },
  {
    id: '3322110005',
    districtId: '3322110',
    name: 'Kandangan',
  },
  {
    id: '3322110006',
    districtId: '3322110',
    name: 'Lemahireng',
  },
  {
    id: '3322110007',
    districtId: '3322110',
    name: 'Harjosari',
  },
  {
    id: '3322110008',
    districtId: '3322110',
    name: 'Samban',
  },
  {
    id: '3322110009',
    districtId: '3322110',
    name: 'Poncoruso',
  },
  {
    id: '3322120001',
    districtId: '3322120',
    name: 'Bringin',
  },
  {
    id: '3322120002',
    districtId: '3322120',
    name: 'Popongan',
  },
  {
    id: '3322120003',
    districtId: '3322120',
    name: 'Pakis',
  },
  {
    id: '3322120004',
    districtId: '3322120',
    name: 'Lebak',
  },
  {
    id: '3322120005',
    districtId: '3322120',
    name: 'Banding',
  },
  {
    id: '3322120006',
    districtId: '3322120',
    name: 'Truko',
  },
  {
    id: '3322120016',
    districtId: '3322120',
    name: 'Nyemoh',
  },
  {
    id: '3322120017',
    districtId: '3322120',
    name: 'Tempuran',
  },
  {
    id: '3322120018',
    districtId: '3322120',
    name: 'Wiru',
  },
  {
    id: '3322120019',
    districtId: '3322120',
    name: 'Sendang',
  },
  {
    id: '3322120020',
    districtId: '3322120',
    name: 'Gogodalem',
  },
  {
    id: '3322120022',
    districtId: '3322120',
    name: 'Kalikurmo',
  },
  {
    id: '3322120023',
    districtId: '3322120',
    name: 'Sambirejo',
  },
  {
    id: '3322120024',
    districtId: '3322120',
    name: 'Kalijambe',
  },
  {
    id: '3322120025',
    districtId: '3322120',
    name: 'Tanjung',
  },
  {
    id: '3322121002',
    districtId: '3322121',
    name: 'Rejosari',
  },
  {
    id: '3322121004',
    districtId: '3322121',
    name: 'Plumutan',
  },
  {
    id: '3322121005',
    districtId: '3322121',
    name: 'Bantal',
  },
  {
    id: '3322121006',
    districtId: '3322121',
    name: 'Jlumpang',
  },
  {
    id: '3322121007',
    districtId: '3322121',
    name: 'Bancak',
  },
  {
    id: '3322121008',
    districtId: '3322121',
    name: 'Wonokerto',
  },
  {
    id: '3322121009',
    districtId: '3322121',
    name: 'Boto',
  },
  {
    id: '3322130001',
    districtId: '3322130',
    name: 'Derekan',
  },
  {
    id: '3322130003',
    districtId: '3322130',
    name: 'Pringapus',
  },
  {
    id: '3322130004',
    districtId: '3322130',
    name: 'Pringsari',
  },
  {
    id: '3322130005',
    districtId: '3322130',
    name: 'Jatirunggo',
  },
  {
    id: '3322130006',
    districtId: '3322130',
    name: 'Wonoyoso',
  },
  {
    id: '3322130007',
    districtId: '3322130',
    name: 'Wonorejo',
  },
  {
    id: '3322130008',
    districtId: '3322130',
    name: 'Candirejo',
  },
  {
    id: '3322130009',
    districtId: '3322130',
    name: 'Penawangan',
  },
  {
    id: '3322140001',
    districtId: '3322140',
    name: 'Munding',
  },
  {
    id: '3322140002',
    districtId: '3322140',
    name: 'Pagersari',
  },
  {
    id: '3322140003',
    districtId: '3322140',
    name: 'Gebugan',
  },
  {
    id: '3322140004',
    districtId: '3322140',
    name: 'Wujil',
  },
  {
    id: '3322140005',
    districtId: '3322140',
    name: 'Bergas Lor',
  },
  {
    id: '3322140006',
    districtId: '3322140',
    name: 'Bergas Kidul',
  },
  {
    id: '3322140007',
    districtId: '3322140',
    name: 'Randugunting',
  },
  {
    id: '3322140008',
    districtId: '3322140',
    name: 'Jatijajar',
  },
  {
    id: '3322140009',
    districtId: '3322140',
    name: 'Diwak',
  },
  {
    id: '3322140010',
    districtId: '3322140',
    name: 'Ngempon',
  },
  {
    id: '3322140011',
    districtId: '3322140',
    name: 'Karangjati',
  },
  {
    id: '3322140012',
    districtId: '3322140',
    name: 'Wringin Putih',
  },
  {
    id: '3322140013',
    districtId: '3322140',
    name: 'Gondoriyo',
  },
  {
    id: '3322151001',
    districtId: '3322151',
    name: 'Gogik',
  },
  {
    id: '3322151002',
    districtId: '3322151',
    name: 'Langensari',
  },
  {
    id: '3322151003',
    districtId: '3322151',
    name: 'Candirejo',
  },
  {
    id: '3322151004',
    districtId: '3322151',
    name: 'Nyatnyono',
  },
  {
    id: '3322151006',
    districtId: '3322151',
    name: 'Ungaran',
  },
  {
    id: '3322151007',
    districtId: '3322151',
    name: 'Bandarjo',
  },
  {
    id: '3322151009',
    districtId: '3322151',
    name: 'Keji',
  },
  {
    id: '3322151010',
    districtId: '3322151',
    name: 'Kalisidi',
  },
  {
    id: '3322151011',
    districtId: '3322151',
    name: 'Branjang',
  },
  {
    id: '3322152001',
    districtId: '3322152',
    name: 'Beji',
  },
  {
    id: '3322152002',
    districtId: '3322152',
    name: 'Leyangan',
  },
  {
    id: '3322152003',
    districtId: '3322152',
    name: 'Kalongan',
  },
  {
    id: '3322152004',
    districtId: '3322152',
    name: 'Kawengen',
  },
  {
    id: '3322152005',
    districtId: '3322152',
    name: 'Kalikayen',
  },
  {
    id: '3322152007',
    districtId: '3322152',
    name: 'Susukan',
  },
  {
    id: '3322152008',
    districtId: '3322152',
    name: 'Kalirejo',
  },
  {
    id: '3322152009',
    districtId: '3322152',
    name: 'Sidomulyo',
  },
  {
    id: '3322152010',
    districtId: '3322152',
    name: 'Gedanganak',
  },
  {
    id: '3323010012',
    districtId: '3323010',
    name: 'Caturanom',
  },
  {
    id: '3323010013',
    districtId: '3323010',
    name: 'Parakan Kauman',
  },
  {
    id: '3323010014',
    districtId: '3323010',
    name: 'Parakan Wetan',
  },
  {
    id: '3323010015',
    districtId: '3323010',
    name: 'Campursalam',
  },
  {
    id: '3323010016',
    districtId: '3323010',
    name: 'Mandisari',
  },
  {
    id: '3323010017',
    districtId: '3323010',
    name: 'Dangkel',
  },
  {
    id: '3323010018',
    districtId: '3323010',
    name: 'Ringinanom',
  },
  {
    id: '3323010019',
    districtId: '3323010',
    name: 'Depokharjo',
  },
  {
    id: '3323010029',
    districtId: '3323010',
    name: 'Watukumpul',
  },
  {
    id: '3323010030',
    districtId: '3323010',
    name: 'Tegalroso',
  },
  {
    id: '3323010037',
    districtId: '3323010',
    name: 'Glapansari',
  },
  {
    id: '3323010038',
    districtId: '3323010',
    name: 'Sunggingsari',
  },
  {
    id: '3323010039',
    districtId: '3323010',
    name: 'Wanutengah',
  },
  {
    id: '3323010040',
    districtId: '3323010',
    name: 'Traji',
  },
  {
    id: '3323010041',
    districtId: '3323010',
    name: 'Bagusan',
  },
  {
    id: '3323010042',
    districtId: '3323010',
    name: 'Nglondong',
  },
  {
    id: '3323011001',
    districtId: '3323011',
    name: 'Batursari',
  },
  {
    id: '3323011003',
    districtId: '3323011',
    name: 'Jambu',
  },
  {
    id: '3323011004',
    districtId: '3323011',
    name: 'Canggal',
  },
  {
    id: '3323011005',
    districtId: '3323011',
    name: 'Kruwisan',
  },
  {
    id: '3323011006',
    districtId: '3323011',
    name: 'Petarangan',
  },
  {
    id: '3323011007',
    districtId: '3323011',
    name: 'Tlahap',
  },
  {
    id: '3323011008',
    districtId: '3323011',
    name: 'Kwadungan Jurang',
  },
  {
    id: '3323011009',
    districtId: '3323011',
    name: 'Kwadungan Gunung',
  },
  {
    id: '3323011010',
    districtId: '3323011',
    name: 'Jeketro',
  },
  {
    id: '3323011011',
    districtId: '3323011',
    name: 'Tuksari',
  },
  {
    id: '3323011012',
    districtId: '3323011',
    name: 'Paponan',
  },
  {
    id: '3323011013',
    districtId: '3323011',
    name: 'Kalirejo',
  },
  {
    id: '3323012001',
    districtId: '3323012',
    name: 'Tlogowero',
  },
  {
    id: '3323012002',
    districtId: '3323012',
    name: 'Balesari',
  },
  {
    id: '3323012003',
    districtId: '3323012',
    name: 'Campuranom',
  },
  {
    id: '3323012004',
    districtId: '3323012',
    name: 'Mojosari',
  },
  {
    id: '3323012005',
    districtId: '3323012',
    name: 'Mranggen Kidul',
  },
  {
    id: '3323012006',
    districtId: '3323012',
    name: 'Mranggen Tengah',
  },
  {
    id: '3323012007',
    districtId: '3323012',
    name: 'Bansari',
  },
  {
    id: '3323012008',
    districtId: '3323012',
    name: 'Gentingsari',
  },
  {
    id: '3323012009',
    districtId: '3323012',
    name: 'Tanurejo',
  },
  {
    id: '3323012010',
    districtId: '3323012',
    name: 'Purborejo',
  },
  {
    id: '3323012011',
    districtId: '3323012',
    name: 'Rejosari',
  },
  {
    id: '3323012012',
    districtId: '3323012',
    name: 'Candisari',
  },
  {
    id: '3323012013',
    districtId: '3323012',
    name: 'Gunungsari',
  },
  {
    id: '3323020002',
    districtId: '3323020',
    name: 'Wonotirto',
  },
  {
    id: '3323020003',
    districtId: '3323020',
    name: 'Pagergunung',
  },
  {
    id: '3323020004',
    districtId: '3323020',
    name: 'Wonosari',
  },
  {
    id: '3323020005',
    districtId: '3323020',
    name: 'Bansari',
  },
  {
    id: '3323020007',
    districtId: '3323020',
    name: 'Pandemulyo',
  },
  {
    id: '3323020008',
    districtId: '3323020',
    name: 'Malangsari',
  },
  {
    id: '3323020009',
    districtId: '3323020',
    name: 'Mondoretno',
  },
  {
    id: '3323020010',
    districtId: '3323020',
    name: 'Pakurejo',
  },
  {
    id: '3323020011',
    districtId: '3323020',
    name: 'Pengilon',
  },
  {
    id: '3323020012',
    districtId: '3323020',
    name: 'Pasuruhan',
  },
  {
    id: '3323020013',
    districtId: '3323020',
    name: 'Gondosuli',
  },
  {
    id: '3323020014',
    districtId: '3323020',
    name: 'Tegalrejo',
  },
  {
    id: '3323020015',
    districtId: '3323020',
    name: 'Gandurejo',
  },
  {
    id: '3323020018',
    districtId: '3323020',
    name: 'Campursari',
  },
  {
    id: '3323020019',
    districtId: '3323020',
    name: 'Tegallurung',
  },
  {
    id: '3323020021',
    districtId: '3323020',
    name: 'Putat',
  },
  {
    id: '3323020022',
    districtId: '3323020',
    name: 'Ngimbrang',
  },
  {
    id: '3323020023',
    districtId: '3323020',
    name: 'Danupayan',
  },
  {
    id: '3323030005',
    districtId: '3323030',
    name: 'Purworejo',
  },
  {
    id: '3323030006',
    districtId: '3323030',
    name: 'Mudal',
  },
  {
    id: '3323030007',
    districtId: '3323030',
    name: 'Nampirejo',
  },
  {
    id: '3323030009',
    districtId: '3323030',
    name: 'Madureso',
  },
  {
    id: '3323030011',
    districtId: '3323030',
    name: 'Kowangan',
  },
  {
    id: '3323030012',
    districtId: '3323030',
    name: 'Jampirejo',
  },
  {
    id: '3323030014',
    districtId: '3323030',
    name: 'Giyanti',
  },
  {
    id: '3323030020',
    districtId: '3323030',
    name: 'Gilingsari',
  },
  {
    id: '3323030021',
    districtId: '3323030',
    name: 'Kebonsari',
  },
  {
    id: '3323030022',
    districtId: '3323030',
    name: 'Manding',
  },
  {
    id: '3323030023',
    districtId: '3323030',
    name: 'Temanggung II',
  },
  {
    id: '3323030024',
    districtId: '3323030',
    name: 'Temanggung I',
  },
  {
    id: '3323030025',
    districtId: '3323030',
    name: 'Jampiroso',
  },
  {
    id: '3323030026',
    districtId: '3323030',
    name: 'Kertosari',
  },
  {
    id: '3323030027',
    districtId: '3323030',
    name: 'Banyuurip',
  },
  {
    id: '3323030029',
    districtId: '3323030',
    name: 'Sidorejo',
  },
  {
    id: '3323030030',
    districtId: '3323030',
    name: 'Jurang',
  },
  {
    id: '3323030031',
    districtId: '3323030',
    name: 'Tlogorejo',
  },
  {
    id: '3323030032',
    districtId: '3323030',
    name: 'Joho',
  },
  {
    id: '3323030033',
    districtId: '3323030',
    name: 'Walitelon Selatan',
  },
  {
    id: '3323030034',
    districtId: '3323030',
    name: 'Walitelon Utara',
  },
  {
    id: '3323031001',
    districtId: '3323031',
    name: 'Pagersari',
  },
  {
    id: '3323031002',
    districtId: '3323031',
    name: 'Losari',
  },
  {
    id: '3323031003',
    districtId: '3323031',
    name: 'Legoksari',
  },
  {
    id: '3323031004',
    districtId: '3323031',
    name: 'Gedegan',
  },
  {
    id: '3323031005',
    districtId: '3323031',
    name: 'Tlilir',
  },
  {
    id: '3323031006',
    districtId: '3323031',
    name: 'Tlogomulyo',
  },
  {
    id: '3323031007',
    districtId: '3323031',
    name: 'Tanjungsari',
  },
  {
    id: '3323031008',
    districtId: '3323031',
    name: 'Kerokan',
  },
  {
    id: '3323031009',
    districtId: '3323031',
    name: 'Balerejo',
  },
  {
    id: '3323031010',
    districtId: '3323031',
    name: 'Sriwungu',
  },
  {
    id: '3323031011',
    districtId: '3323031',
    name: 'Langgeng',
  },
  {
    id: '3323031012',
    districtId: '3323031',
    name: 'Candisari',
  },
  {
    id: '3323040012',
    districtId: '3323040',
    name: 'Wonokerso',
  },
  {
    id: '3323040013',
    districtId: '3323040',
    name: 'Tembarak',
  },
  {
    id: '3323040014',
    districtId: '3323040',
    name: 'Menggoro',
  },
  {
    id: '3323040015',
    districtId: '3323040',
    name: 'Purwodadi',
  },
  {
    id: '3323040017',
    districtId: '3323040',
    name: 'Kemloko',
  },
  {
    id: '3323040018',
    districtId: '3323040',
    name: 'Tawangsari',
  },
  {
    id: '3323040020',
    districtId: '3323040',
    name: 'Botoputih',
  },
  {
    id: '3323040021',
    districtId: '3323040',
    name: 'Gandu',
  },
  {
    id: '3323040023',
    districtId: '3323040',
    name: 'Banaran',
  },
  {
    id: '3323040026',
    districtId: '3323040',
    name: 'Drono',
  },
  {
    id: '3323040027',
    districtId: '3323040',
    name: 'Krajan',
  },
  {
    id: '3323040028',
    districtId: '3323040',
    name: 'Jragan',
  },
  {
    id: '3323041001',
    districtId: '3323041',
    name: 'Tanggulanom',
  },
  {
    id: '3323041002',
    districtId: '3323041',
    name: 'Jetis',
  },
  {
    id: '3323041003',
    districtId: '3323041',
    name: 'Ngaditirto',
  },
  {
    id: '3323041004',
    districtId: '3323041',
    name: 'Bulan',
  },
  {
    id: '3323041005',
    districtId: '3323041',
    name: 'Salamrejo',
  },
  {
    id: '3323041006',
    districtId: '3323041',
    name: 'Selopampang',
  },
  {
    id: '3323041007',
    districtId: '3323041',
    name: 'Kacepit',
  },
  {
    id: '3323041008',
    districtId: '3323041',
    name: 'Gambasan',
  },
  {
    id: '3323041009',
    districtId: '3323041',
    name: 'Kebonagung',
  },
  {
    id: '3323041010',
    districtId: '3323041',
    name: 'Bagusan',
  },
  {
    id: '3323041011',
    districtId: '3323041',
    name: 'Plumbon',
  },
  {
    id: '3323041012',
    districtId: '3323041',
    name: 'Bumiayu',
  },
  {
    id: '3323050001',
    districtId: '3323050',
    name: 'Bengkal',
  },
  {
    id: '3323050002',
    districtId: '3323050',
    name: 'Pare',
  },
  {
    id: '3323050004',
    districtId: '3323050',
    name: 'Badran',
  },
  {
    id: '3323050005',
    districtId: '3323050',
    name: 'Kranggan',
  },
  {
    id: '3323050006',
    districtId: '3323050',
    name: 'Pendowo',
  },
  {
    id: '3323050007',
    districtId: '3323050',
    name: 'Ngropoh',
  },
  {
    id: '3323050008',
    districtId: '3323050',
    name: 'Purwosari',
  },
  {
    id: '3323050009',
    districtId: '3323050',
    name: 'Kramat',
  },
  {
    id: '3323050010',
    districtId: '3323050',
    name: 'Sanggrahan',
  },
  {
    id: '3323050012',
    districtId: '3323050',
    name: 'Kemloko',
  },
  {
    id: '3323050013',
    districtId: '3323050',
    name: 'Gentan',
  },
  {
    id: '3323060002',
    districtId: '3323060',
    name: 'Soropadan',
  },
  {
    id: '3323060004',
    districtId: '3323060',
    name: 'Pringsurat',
  },
  {
    id: '3323060005',
    districtId: '3323060',
    name: 'Karangwuni',
  },
  {
    id: '3323060006',
    districtId: '3323060',
    name: 'Gowak',
  },
  {
    id: '3323060007',
    districtId: '3323060',
    name: 'Rejosari',
  },
  {
    id: '3323060008',
    districtId: '3323060',
    name: 'Ngipik',
  },
  {
    id: '3323060009',
    districtId: '3323060',
    name: 'Pingit',
  },
  {
    id: '3323060011',
    districtId: '3323060',
    name: 'Pagergunung',
  },
  {
    id: '3323060012',
    districtId: '3323060',
    name: 'Nglorog',
  },
  {
    id: '3323060013',
    districtId: '3323060',
    name: 'Soborejo',
  },
  {
    id: '3323060014',
    districtId: '3323060',
    name: 'Wonokerso',
  },
  {
    id: '3323070001',
    districtId: '3323070',
    name: 'Gandulan',
  },
  {
    id: '3323070002',
    districtId: '3323070',
    name: 'Tegowanuh',
  },
  {
    id: '3323070003',
    districtId: '3323070',
    name: 'Keblukan',
  },
  {
    id: '3323070005',
    districtId: '3323070',
    name: 'Geblog',
  },
  {
    id: '3323070006',
    districtId: '3323070',
    name: 'Gandon',
  },
  {
    id: '3323070008',
    districtId: '3323070',
    name: 'Kwarakan',
  },
  {
    id: '3323070009',
    districtId: '3323070',
    name: 'Getas',
  },
  {
    id: '3323070010',
    districtId: '3323070',
    name: 'Kalimanggis',
  },
  {
    id: '3323070011',
    districtId: '3323070',
    name: 'Tlogowungu',
  },
  {
    id: '3323070012',
    districtId: '3323070',
    name: 'Kaloran',
  },
  {
    id: '3323070013',
    districtId: '3323070',
    name: 'Kemiri',
  },
  {
    id: '3323070014',
    districtId: '3323070',
    name: 'Tempuran',
  },
  {
    id: '3323080002',
    districtId: '3323080',
    name: 'Wadas',
  },
  {
    id: '3323080003',
    districtId: '3323080',
    name: 'Caruban',
  },
  {
    id: '3323080004',
    districtId: '3323080',
    name: 'Baledu',
  },
  {
    id: '3323080005',
    districtId: '3323080',
    name: 'Rowo',
  },
  {
    id: '3323080006',
    districtId: '3323080',
    name: 'Malebo',
  },
  {
    id: '3323080007',
    districtId: '3323080',
    name: 'Gesing',
  },
  {
    id: '3323080008',
    districtId: '3323080',
    name: 'Kandangan',
  },
  {
    id: '3323080009',
    districtId: '3323080',
    name: 'Kembangsari',
  },
  {
    id: '3323080010',
    districtId: '3323080',
    name: 'Samiranan',
  },
  {
    id: '3323080011',
    districtId: '3323080',
    name: 'Ngemplak',
  },
  {
    id: '3323080012',
    districtId: '3323080',
    name: 'Tlogopucang',
  },
  {
    id: '3323080013',
    districtId: '3323080',
    name: 'Kedawung',
  },
  {
    id: '3323080014',
    districtId: '3323080',
    name: 'Margolelo',
  },
  {
    id: '3323080015',
    districtId: '3323080',
    name: 'Blimbing',
  },
  {
    id: '3323080016',
    districtId: '3323080',
    name: 'Banjarsari',
  },
  {
    id: '3323090001',
    districtId: '3323090',
    name: 'Danurejo',
  },
  {
    id: '3323090002',
    districtId: '3323090',
    name: 'Salamsari',
  },
  {
    id: '3323090003',
    districtId: '3323090',
    name: 'Candimulya',
  },
  {
    id: '3323090005',
    districtId: '3323090',
    name: 'Mojotengah',
  },
  {
    id: '3323090006',
    districtId: '3323090',
    name: 'Kutoanyar',
  },
  {
    id: '3323090008',
    districtId: '3323090',
    name: 'Tegalsari',
  },
  {
    id: '3323090009',
    districtId: '3323090',
    name: 'Kundisari',
  },
  {
    id: '3323090010',
    districtId: '3323090',
    name: 'Mergowati',
  },
  {
    id: '3323090011',
    districtId: '3323090',
    name: 'Karangtejo',
  },
  {
    id: '3323090012',
    districtId: '3323090',
    name: 'Ngadimulyo',
  },
  {
    id: '3323090013',
    districtId: '3323090',
    name: 'Gondangwayang',
  },
  {
    id: '3323090014',
    districtId: '3323090',
    name: 'Bojonegoro',
  },
  {
    id: '3323090015',
    districtId: '3323090',
    name: 'Bandunggede',
  },
  {
    id: '3323100001',
    districtId: '3323100',
    name: 'Katekan',
  },
  {
    id: '3323100002',
    districtId: '3323100',
    name: 'Banjarsari',
  },
  {
    id: '3323100003',
    districtId: '3323100',
    name: 'Medari',
  },
  {
    id: '3323100006',
    districtId: '3323100',
    name: 'Karanggedong',
  },
  {
    id: '3323100007',
    districtId: '3323100',
    name: 'Petirejo',
  },
  {
    id: '3323100008',
    districtId: '3323100',
    name: 'Munggangsari',
  },
  {
    id: '3323100009',
    districtId: '3323100',
    name: 'Kataan',
  },
  {
    id: '3323100010',
    districtId: '3323100',
    name: 'Pringapus',
  },
  {
    id: '3323100011',
    districtId: '3323100',
    name: 'Giripurno',
  },
  {
    id: '3323100012',
    districtId: '3323100',
    name: 'Gejagan',
  },
  {
    id: '3323100013',
    districtId: '3323100',
    name: 'Manggong',
  },
  {
    id: '3323100014',
    districtId: '3323100',
    name: 'Gandu Wetan',
  },
  {
    id: '3323100015',
    districtId: '3323100',
    name: 'Ngaren',
  },
  {
    id: '3323100016',
    districtId: '3323100',
    name: 'Ngadirejo',
  },
  {
    id: '3323100017',
    districtId: '3323100',
    name: 'Gondangwinangun',
  },
  {
    id: '3323100018',
    districtId: '3323100',
    name: 'Dlimoyo',
  },
  {
    id: '3323100019',
    districtId: '3323100',
    name: 'Purbosari',
  },
  {
    id: '3323100020',
    districtId: '3323100',
    name: 'Tegalrejo',
  },
  {
    id: '3323100021',
    districtId: '3323100',
    name: 'Campursari',
  },
  {
    id: '3323100022',
    districtId: '3323100',
    name: 'Mangunsari',
  },
  {
    id: '3323110001',
    districtId: '3323110',
    name: 'Morobongo',
  },
  {
    id: '3323110002',
    districtId: '3323110',
    name: 'Sukomarto',
  },
  {
    id: '3323110003',
    districtId: '3323110',
    name: 'Padureso',
  },
  {
    id: '3323110004',
    districtId: '3323110',
    name: 'Barang',
  },
  {
    id: '3323110005',
    districtId: '3323110',
    name: 'Karangtejo',
  },
  {
    id: '3323110006',
    districtId: '3323110',
    name: 'Ketitang',
  },
  {
    id: '3323110007',
    districtId: '3323110',
    name: 'Jombor',
  },
  {
    id: '3323110008',
    districtId: '3323110',
    name: 'Giyono',
  },
  {
    id: '3323110009',
    districtId: '3323110',
    name: 'Gunung Gempol',
  },
  {
    id: '3323110010',
    districtId: '3323110',
    name: 'Jumo',
  },
  {
    id: '3323110011',
    districtId: '3323110',
    name: 'Kertosari',
  },
  {
    id: '3323110012',
    districtId: '3323110',
    name: 'Jamusan',
  },
  {
    id: '3323110019',
    districtId: '3323110',
    name: 'Gedongsari',
  },
  {
    id: '3323111001',
    districtId: '3323111',
    name: 'Jambon',
  },
  {
    id: '3323111002',
    districtId: '3323111',
    name: 'Kalibanger',
  },
  {
    id: '3323111003',
    districtId: '3323111',
    name: 'Ngadisepi',
  },
  {
    id: '3323111004',
    districtId: '3323111',
    name: 'Kemiriombo',
  },
  {
    id: '3323111005',
    districtId: '3323111',
    name: 'Gemawang',
  },
  {
    id: '3323111006',
    districtId: '3323111',
    name: 'Banaran',
  },
  {
    id: '3323111007',
    districtId: '3323111',
    name: 'Krempong',
  },
  {
    id: '3323111008',
    districtId: '3323111',
    name: 'Muncar',
  },
  {
    id: '3323111010',
    districtId: '3323111',
    name: 'Karangseneng',
  },
  {
    id: '3323120001',
    districtId: '3323120',
    name: 'Canggal',
  },
  {
    id: '3323120002',
    districtId: '3323120',
    name: 'Kentengsari',
  },
  {
    id: '3323120003',
    districtId: '3323120',
    name: 'Bantir',
  },
  {
    id: '3323120004',
    districtId: '3323120',
    name: 'Ngabean',
  },
  {
    id: '3323120005',
    districtId: '3323120',
    name: 'Krawitan',
  },
  {
    id: '3323120007',
    districtId: '3323120',
    name: 'Mento',
  },
  {
    id: '3323120008',
    districtId: '3323120',
    name: 'Batursari',
  },
  {
    id: '3323120009',
    districtId: '3323120',
    name: 'Lempuyang',
  },
  {
    id: '3323120010',
    districtId: '3323120',
    name: 'Candiroto',
  },
  {
    id: '3323120011',
    districtId: '3323120',
    name: 'Gunungpayung',
  },
  {
    id: '3323120013',
    districtId: '3323120',
    name: 'Plosogaden',
  },
  {
    id: '3323120014',
    districtId: '3323120',
    name: 'Sidoharjo',
  },
  {
    id: '3323121001',
    districtId: '3323121',
    name: 'Lowungu',
  },
  {
    id: '3323121002',
    districtId: '3323121',
    name: 'Larangan Luwok',
  },
  {
    id: '3323121003',
    districtId: '3323121',
    name: 'Prangkokan',
  },
  {
    id: '3323121004',
    districtId: '3323121',
    name: 'Jlegong',
  },
  {
    id: '3323121005',
    districtId: '3323121',
    name: 'Banjarsari',
  },
  {
    id: '3323121006',
    districtId: '3323121',
    name: 'Congkrang',
  },
  {
    id: '3323121007',
    districtId: '3323121',
    name: 'Kebondalem',
  },
  {
    id: '3323121008',
    districtId: '3323121',
    name: 'Kemuning',
  },
  {
    id: '3323121010',
    districtId: '3323121',
    name: 'Selosabrang',
  },
  {
    id: '3323121012',
    districtId: '3323121',
    name: 'Tanjung Sari',
  },
  {
    id: '3323121014',
    districtId: '3323121',
    name: 'Ngaliyan',
  },
  {
    id: '3323130007',
    districtId: '3323130',
    name: 'Campurejo',
  },
  {
    id: '3323130008',
    districtId: '3323130',
    name: 'Tempelsari',
  },
  {
    id: '3323130009',
    districtId: '3323130',
    name: 'Bonjor',
  },
  {
    id: '3323130010',
    districtId: '3323130',
    name: 'Sigedong',
  },
  {
    id: '3323130011',
    districtId: '3323130',
    name: 'Nglarangan',
  },
  {
    id: '3323130012',
    districtId: '3323130',
    name: 'Donorojo',
  },
  {
    id: '3323130014',
    districtId: '3323130',
    name: 'Bojong',
  },
  {
    id: '3323130022',
    districtId: '3323130',
    name: 'Bendungan',
  },
  {
    id: '3323130023',
    districtId: '3323130',
    name: 'Simpar',
  },
  {
    id: '3323130024',
    districtId: '3323130',
    name: 'Tlogo',
  },
  {
    id: '3323131001',
    districtId: '3323131',
    name: 'Wates',
  },
  {
    id: '3323131002',
    districtId: '3323131',
    name: 'Cemoro',
  },
  {
    id: '3323131003',
    districtId: '3323131',
    name: 'Tawangsari',
  },
  {
    id: '3323131004',
    districtId: '3323131',
    name: 'Rejosari',
  },
  {
    id: '3323131005',
    districtId: '3323131',
    name: 'Pitrosari',
  },
  {
    id: '3323131006',
    districtId: '3323131',
    name: 'Purwosari',
  },
  {
    id: '3323131007',
    districtId: '3323131',
    name: 'Pateken',
  },
  {
    id: '3323131008',
    districtId: '3323131',
    name: 'Kebonsari',
  },
  {
    id: '3323131009',
    districtId: '3323131',
    name: 'Wonoboyo',
  },
  {
    id: '3323131011',
    districtId: '3323131',
    name: 'Pesantren',
  },
  {
    id: '3323131012',
    districtId: '3323131',
    name: 'Wonocoyo',
  },
  {
    id: '3323131013',
    districtId: '3323131',
    name: 'Tening',
  },
  {
    id: '3324010001',
    districtId: '3324010',
    name: 'Blumah',
  },
  {
    id: '3324010002',
    districtId: '3324010',
    name: 'Tlogopayung',
  },
  {
    id: '3324010003',
    districtId: '3324010',
    name: 'Kediten',
  },
  {
    id: '3324010004',
    districtId: '3324010',
    name: 'Wonodadi',
  },
  {
    id: '3324010005',
    districtId: '3324010',
    name: 'Manggungmangu',
  },
  {
    id: '3324010006',
    districtId: '3324010',
    name: 'Tirtomulyo',
  },
  {
    id: '3324010007',
    districtId: '3324010',
    name: 'Jurangagung',
  },
  {
    id: '3324010008',
    districtId: '3324010',
    name: 'Karanganyar',
  },
  {
    id: '3324010009',
    districtId: '3324010',
    name: 'Jati',
  },
  {
    id: '3324010010',
    districtId: '3324010',
    name: 'Bendosari',
  },
  {
    id: '3324010011',
    districtId: '3324010',
    name: 'Wadas',
  },
  {
    id: '3324010012',
    districtId: '3324010',
    name: 'Mojoagung',
  },
  {
    id: '3324020001',
    districtId: '3324020',
    name: 'Genting Gunung',
  },
  {
    id: '3324020002',
    districtId: '3324020',
    name: 'Bringinsari',
  },
  {
    id: '3324020003',
    districtId: '3324020',
    name: 'Purwo Sari',
  },
  {
    id: '3324020004',
    districtId: '3324020',
    name: 'Ngargosari',
  },
  {
    id: '3324020005',
    districtId: '3324020',
    name: 'Pesaren',
  },
  {
    id: '3324020006',
    districtId: '3324020',
    name: 'Taman Rejo',
  },
  {
    id: '3324020007',
    districtId: '3324020',
    name: 'Harjodowo',
  },
  {
    id: '3324020008',
    districtId: '3324020',
    name: 'Peron',
  },
  {
    id: '3324020009',
    districtId: '3324020',
    name: 'Damarjati',
  },
  {
    id: '3324020010',
    districtId: '3324020',
    name: 'Mulyosari',
  },
  {
    id: '3324020011',
    districtId: '3324020',
    name: 'Kalipakis',
  },
  {
    id: '3324020012',
    districtId: '3324020',
    name: 'Trimulyo',
  },
  {
    id: '3324020013',
    districtId: '3324020',
    name: 'Selokaton',
  },
  {
    id: '3324020014',
    districtId: '3324020',
    name: 'Ngadiwarno',
  },
  {
    id: '3324020015',
    districtId: '3324020',
    name: 'Tamping Winarno',
  },
  {
    id: '3324020017',
    districtId: '3324020',
    name: 'Sukorejo',
  },
  {
    id: '3324020018',
    districtId: '3324020',
    name: 'Kalibogor',
  },
  {
    id: '3324030001',
    districtId: '3324030',
    name: 'Gondoharum',
  },
  {
    id: '3324030002',
    districtId: '3324030',
    name: 'Getas Blawong',
  },
  {
    id: '3324030003',
    districtId: '3324030',
    name: 'Parakan Sebaran',
  },
  {
    id: '3324030005',
    districtId: '3324030',
    name: 'Krikil',
  },
  {
    id: '3324030006',
    districtId: '3324030',
    name: 'Pucakwangi',
  },
  {
    id: '3324030007',
    districtId: '3324030',
    name: 'Pageruyung',
  },
  {
    id: '3324030008',
    districtId: '3324030',
    name: 'Tambahrejo',
  },
  {
    id: '3324030009',
    districtId: '3324030',
    name: 'Gebangan',
  },
  {
    id: '3324030010',
    districtId: '3324030',
    name: 'Surokonto Wetan',
  },
  {
    id: '3324030011',
    districtId: '3324030',
    name: 'Bangunsari',
  },
  {
    id: '3324030012',
    districtId: '3324030',
    name: 'Kebon Gembong',
  },
  {
    id: '3324030013',
    districtId: '3324030',
    name: 'Surokonto Kulon',
  },
  {
    id: '3324030014',
    districtId: '3324030',
    name: 'Pagergunung',
  },
  {
    id: '3324040001',
    districtId: '3324040',
    name: 'Pakisan',
  },
  {
    id: '3324040002',
    districtId: '3324040',
    name: 'Mlatiharjo',
  },
  {
    id: '3324040003',
    districtId: '3324040',
    name: 'Plososari',
  },
  {
    id: '3324040004',
    districtId: '3324040',
    name: 'Wirosari',
  },
  {
    id: '3324040005',
    districtId: '3324040',
    name: 'Pagersari',
  },
  {
    id: '3324040006',
    districtId: '3324040',
    name: 'Selo',
  },
  {
    id: '3324040008',
    districtId: '3324040',
    name: 'Gedong',
  },
  {
    id: '3324040009',
    districtId: '3324040',
    name: 'Sukomangli',
  },
  {
    id: '3324040010',
    districtId: '3324040',
    name: 'Kalibareng',
  },
  {
    id: '3324040011',
    districtId: '3324040',
    name: 'Kalilumpang',
  },
  {
    id: '3324040012',
    districtId: '3324040',
    name: 'Kalices',
  },
  {
    id: '3324040013',
    districtId: '3324040',
    name: 'Sidokumpul',
  },
  {
    id: '3324040014',
    districtId: '3324040',
    name: 'Sidodadi',
  },
  {
    id: '3324050001',
    districtId: '3324050',
    name: 'Cening',
  },
  {
    id: '3324050002',
    districtId: '3324050',
    name: 'Sukodadi',
  },
  {
    id: '3324050003',
    districtId: '3324050',
    name: 'Kaliputih',
  },
  {
    id: '3324050004',
    districtId: '3324050',
    name: 'Getas',
  },
  {
    id: '3324050005',
    districtId: '3324050',
    name: 'Banyuringin',
  },
  {
    id: '3324050006',
    districtId: '3324050',
    name: 'Kedungsari',
  },
  {
    id: '3324050007',
    districtId: '3324050',
    name: 'Ngareanak',
  },
  {
    id: '3324050008',
    districtId: '3324050',
    name: 'Singorojo',
  },
  {
    id: '3324050009',
    districtId: '3324050',
    name: 'Cacaban',
  },
  {
    id: '3324050010',
    districtId: '3324050',
    name: 'Kalirejo',
  },
  {
    id: '3324050012',
    districtId: '3324050',
    name: 'Trayu',
  },
  {
    id: '3324050013',
    districtId: '3324050',
    name: 'Kertosari',
  },
  {
    id: '3324060001',
    districtId: '3324060',
    name: 'Kedungboto',
  },
  {
    id: '3324060002',
    districtId: '3324060',
    name: 'Peron',
  },
  {
    id: '3324060003',
    districtId: '3324060',
    name: 'Gondang',
  },
  {
    id: '3324060004',
    districtId: '3324060',
    name: 'Pakis',
  },
  {
    id: '3324060005',
    districtId: '3324060',
    name: 'Sumber Rahayu',
  },
  {
    id: '3324060006',
    districtId: '3324060',
    name: 'Tambahsari',
  },
  {
    id: '3324060007',
    districtId: '3324060',
    name: 'Limbangan',
  },
  {
    id: '3324060008',
    districtId: '3324060',
    name: 'Pagertoyo',
  },
  {
    id: '3324060009',
    districtId: '3324060',
    name: 'Sriwulan',
  },
  {
    id: '3324060010',
    districtId: '3324060',
    name: 'Tabet',
  },
  {
    id: '3324060011',
    districtId: '3324060',
    name: 'Ngesrepbalong',
  },
  {
    id: '3324060012',
    districtId: '3324060',
    name: 'Gonoharjo',
  },
  {
    id: '3324060013',
    districtId: '3324060',
    name: 'Jawisari',
  },
  {
    id: '3324060014',
    districtId: '3324060',
    name: 'Margosari',
  },
  {
    id: '3324060015',
    districtId: '3324060',
    name: 'Tamanrejo',
  },
  {
    id: '3324060016',
    districtId: '3324060',
    name: 'Pagerwojo',
  },
  {
    id: '3324070001',
    districtId: '3324070',
    name: 'Purwogondo',
  },
  {
    id: '3324070002',
    districtId: '3324070',
    name: 'Kaligading',
  },
  {
    id: '3324070003',
    districtId: '3324070',
    name: 'Salamsari',
  },
  {
    id: '3324070004',
    districtId: '3324070',
    name: 'Blimbing',
  },
  {
    id: '3324070005',
    districtId: '3324070',
    name: 'Bebengan',
  },
  {
    id: '3324070006',
    districtId: '3324070',
    name: 'Boja',
  },
  {
    id: '3324070007',
    districtId: '3324070',
    name: 'Metesih',
  },
  {
    id: '3324070008',
    districtId: '3324070',
    name: 'Trisobo',
  },
  {
    id: '3324070009',
    districtId: '3324070',
    name: 'Campurejo',
  },
  {
    id: '3324070010',
    districtId: '3324070',
    name: 'Tampingan',
  },
  {
    id: '3324070011',
    districtId: '3324070',
    name: 'Karangmanggis',
  },
  {
    id: '3324070012',
    districtId: '3324070',
    name: 'Ngabean',
  },
  {
    id: '3324070013',
    districtId: '3324070',
    name: 'Kliris',
  },
  {
    id: '3324070015',
    districtId: '3324070',
    name: 'Medono',
  },
  {
    id: '3324070016',
    districtId: '3324070',
    name: 'Pasigitan',
  },
  {
    id: '3324070017',
    districtId: '3324070',
    name: 'Leban',
  },
  {
    id: '3324070018',
    districtId: '3324070',
    name: 'Banjarejo',
  },
  {
    id: '3324080007',
    districtId: '3324080',
    name: 'Kumpul Rejo',
  },
  {
    id: '3324080008',
    districtId: '3324080',
    name: 'Karangtengah',
  },
  {
    id: '3324080009',
    districtId: '3324080',
    name: 'Sarirejo',
  },
  {
    id: '3324080010',
    districtId: '3324080',
    name: 'Krajan Kulon',
  },
  {
    id: '3324080011',
    districtId: '3324080',
    name: 'Kutoharjo',
  },
  {
    id: '3324080012',
    districtId: '3324080',
    name: 'Nolokerto',
  },
  {
    id: '3324080013',
    districtId: '3324080',
    name: 'Sumberejo',
  },
  {
    id: '3324080014',
    districtId: '3324080',
    name: 'Mororejo',
  },
  {
    id: '3324080015',
    districtId: '3324080',
    name: 'Wonorejo',
  },
  {
    id: '3324081002',
    districtId: '3324081',
    name: 'Jerukgiling',
  },
  {
    id: '3324081003',
    districtId: '3324081',
    name: 'Darupono',
  },
  {
    id: '3324081004',
    districtId: '3324081',
    name: 'Protomulyo',
  },
  {
    id: '3324081005',
    districtId: '3324081',
    name: 'Magelung',
  },
  {
    id: '3324081006',
    districtId: '3324081',
    name: 'Plantaran',
  },
  {
    id: '3324081007',
    districtId: '3324081',
    name: 'Sukomulyo',
  },
  {
    id: '3324081008',
    districtId: '3324081',
    name: 'Sidomakmur',
  },
  {
    id: '3324090001',
    districtId: '3324090',
    name: 'Tunggulsari',
  },
  {
    id: '3324090003',
    districtId: '3324090',
    name: 'Penjalin',
  },
  {
    id: '3324090004',
    districtId: '3324090',
    name: 'Kertomulyo',
  },
  {
    id: '3324090005',
    districtId: '3324090',
    name: 'Blorok',
  },
  {
    id: '3324090006',
    districtId: '3324090',
    name: 'Sidorejo',
  },
  {
    id: '3324090007',
    districtId: '3324090',
    name: 'Tosari',
  },
  {
    id: '3324090008',
    districtId: '3324090',
    name: 'Rejosari',
  },
  {
    id: '3324090009',
    districtId: '3324090',
    name: 'Turunrejo',
  },
  {
    id: '3324090010',
    districtId: '3324090',
    name: 'Purwokerto',
  },
  {
    id: '3324090011',
    districtId: '3324090',
    name: 'Brangsong',
  },
  {
    id: '3324090012',
    districtId: '3324090',
    name: 'Kebon Adem',
  },
  {
    id: '3324100003',
    districtId: '3324100',
    name: 'Wonosari',
  },
  {
    id: '3324100008',
    districtId: '3324100',
    name: 'Dawungsari',
  },
  {
    id: '3324100009',
    districtId: '3324100',
    name: 'Margomulyo',
  },
  {
    id: '3324100010',
    districtId: '3324100',
    name: 'Tegorejo',
  },
  {
    id: '3324100011',
    districtId: '3324100',
    name: 'Pesawahan',
  },
  {
    id: '3324100012',
    districtId: '3324100',
    name: 'Karangmulyo',
  },
  {
    id: '3324100021',
    districtId: '3324100',
    name: 'Pucang Rejo',
  },
  {
    id: '3324100022',
    districtId: '3324100',
    name: 'Gubugsari',
  },
  {
    id: '3324100023',
    districtId: '3324100',
    name: 'Pegandon',
  },
  {
    id: '3324100024',
    districtId: '3324100',
    name: 'Penanggulan',
  },
  {
    id: '3324101001',
    districtId: '3324101',
    name: 'Winong',
  },
  {
    id: '3324101002',
    districtId: '3324101',
    name: 'Jatirejo',
  },
  {
    id: '3324101003',
    districtId: '3324101',
    name: 'Rejosari',
  },
  {
    id: '3324101004',
    districtId: '3324101',
    name: 'Sumbersari',
  },
  {
    id: '3324101005',
    districtId: '3324101',
    name: 'Kebonagung',
  },
  {
    id: '3324101006',
    districtId: '3324101',
    name: 'Ngampel Kulon',
  },
  {
    id: '3324101007',
    districtId: '3324101',
    name: 'Ngampel Wetan',
  },
  {
    id: '3324101008',
    districtId: '3324101',
    name: 'Sudipayung',
  },
  {
    id: '3324101009',
    districtId: '3324101',
    name: 'Dempelrejo',
  },
  {
    id: '3324101010',
    districtId: '3324101',
    name: 'Banyuurip',
  },
  {
    id: '3324101011',
    districtId: '3324101',
    name: 'Bojonggede',
  },
  {
    id: '3324101012',
    districtId: '3324101',
    name: 'Putatgede',
  },
  {
    id: '3324110003',
    districtId: '3324110',
    name: 'Sojomerto',
  },
  {
    id: '3324110004',
    districtId: '3324110',
    name: 'Triharjo',
  },
  {
    id: '3324110005',
    districtId: '3324110',
    name: 'Cepokomulyo',
  },
  {
    id: '3324110012',
    districtId: '3324110',
    name: 'Galih',
  },
  {
    id: '3324110013',
    districtId: '3324110',
    name: 'Pamriyan',
  },
  {
    id: '3324110018',
    districtId: '3324110',
    name: 'Jenarsari',
  },
  {
    id: '3324110019',
    districtId: '3324110',
    name: 'Poncorejo',
  },
  {
    id: '3324110020',
    districtId: '3324110',
    name: 'Gebang',
  },
  {
    id: '3324110021',
    districtId: '3324110',
    name: 'Krompaan',
  },
  {
    id: '3324110022',
    districtId: '3324110',
    name: 'Sedayu',
  },
  {
    id: '3324110023',
    districtId: '3324110',
    name: 'Gemuhblanten',
  },
  {
    id: '3324110024',
    districtId: '3324110',
    name: 'Tamangede',
  },
  {
    id: '3324110025',
    districtId: '3324110',
    name: 'Lumansari',
  },
  {
    id: '3324110026',
    districtId: '3324110',
    name: 'Johorejo',
  },
  {
    id: '3324110027',
    districtId: '3324110',
    name: 'Tlahab',
  },
  {
    id: '3324110028',
    districtId: '3324110',
    name: 'Pucangrejo',
  },
  {
    id: '3324111001',
    districtId: '3324111',
    name: 'Ngerjo',
  },
  {
    id: '3324111002',
    districtId: '3324111',
    name: 'Kedungasri',
  },
  {
    id: '3324111003',
    districtId: '3324111',
    name: 'Kedunggading',
  },
  {
    id: '3324111004',
    districtId: '3324111',
    name: 'Ringinarum',
  },
  {
    id: '3324111005',
    districtId: '3324111',
    name: 'Tejorejo',
  },
  {
    id: '3324111006',
    districtId: '3324111',
    name: 'Ngawensari',
  },
  {
    id: '3324111007',
    districtId: '3324111',
    name: 'Wungurejo',
  },
  {
    id: '3324111008',
    districtId: '3324111',
    name: 'Rowobranten',
  },
  {
    id: '3324111009',
    districtId: '3324111',
    name: 'Mojo',
  },
  {
    id: '3324111010',
    districtId: '3324111',
    name: 'Purworejo',
  },
  {
    id: '3324111011',
    districtId: '3324111',
    name: 'Pagerdawung',
  },
  {
    id: '3324111012',
    districtId: '3324111',
    name: 'Caruban',
  },
  {
    id: '3324120001',
    districtId: '3324120',
    name: 'Sidomukti',
  },
  {
    id: '3324120002',
    districtId: '3324120',
    name: 'Penyangkringan',
  },
  {
    id: '3324120003',
    districtId: '3324120',
    name: 'Bumiayu',
  },
  {
    id: '3324120004',
    districtId: '3324120',
    name: 'Manggungsari',
  },
  {
    id: '3324120005',
    districtId: '3324120',
    name: 'Sumberagung',
  },
  {
    id: '3324120006',
    districtId: '3324120',
    name: 'Ngasinan',
  },
  {
    id: '3324120007',
    districtId: '3324120',
    name: 'Weleri',
  },
  {
    id: '3324120008',
    districtId: '3324120',
    name: 'Nawangsari',
  },
  {
    id: '3324120009',
    districtId: '3324120',
    name: 'Karangdowo',
  },
  {
    id: '3324120010',
    districtId: '3324120',
    name: 'Penaruban',
  },
  {
    id: '3324120011',
    districtId: '3324120',
    name: 'Sambongsari',
  },
  {
    id: '3324120012',
    districtId: '3324120',
    name: 'Karanganom',
  },
  {
    id: '3324120013',
    districtId: '3324120',
    name: 'Payung',
  },
  {
    id: '3324120014',
    districtId: '3324120',
    name: 'Pucuksari',
  },
  {
    id: '3324120015',
    districtId: '3324120',
    name: 'Tratemulyo',
  },
  {
    id: '3324120016',
    districtId: '3324120',
    name: 'Montongsari',
  },
  {
    id: '3324130001',
    districtId: '3324130',
    name: 'Tambaksari',
  },
  {
    id: '3324130002',
    districtId: '3324130',
    name: 'Tanjungsari',
  },
  {
    id: '3324130003',
    districtId: '3324130',
    name: 'Parakan',
  },
  {
    id: '3324130004',
    districtId: '3324130',
    name: 'Wonotenggang',
  },
  {
    id: '3324130005',
    districtId: '3324130',
    name: 'Randusari',
  },
  {
    id: '3324130006',
    districtId: '3324130',
    name: 'Karangsari',
  },
  {
    id: '3324130007',
    districtId: '3324130',
    name: 'Tanjunganom',
  },
  {
    id: '3324130008',
    districtId: '3324130',
    name: 'Sendangdawuhan',
  },
  {
    id: '3324130009',
    districtId: '3324130',
    name: 'Pojoksari',
  },
  {
    id: '3324130010',
    districtId: '3324130',
    name: 'Kebonsari',
  },
  {
    id: '3324130011',
    districtId: '3324130',
    name: 'Bulak',
  },
  {
    id: '3324130012',
    districtId: '3324130',
    name: 'Gebanganom',
  },
  {
    id: '3324130013',
    districtId: '3324130',
    name: 'Rowosari',
  },
  {
    id: '3324130014',
    districtId: '3324130',
    name: 'Jatipurwo',
  },
  {
    id: '3324130015',
    districtId: '3324130',
    name: 'Gempolsewu',
  },
  {
    id: '3324130016',
    districtId: '3324130',
    name: 'Sendang Sikucing',
  },
  {
    id: '3324140001',
    districtId: '3324140',
    name: 'Sendangkulon',
  },
  {
    id: '3324140002',
    districtId: '3324140',
    name: 'Sendangdawung',
  },
  {
    id: '3324140003',
    districtId: '3324140',
    name: 'Sukodadi',
  },
  {
    id: '3324140004',
    districtId: '3324140',
    name: 'Kaliyoso',
  },
  {
    id: '3324140005',
    districtId: '3324140',
    name: 'Gebanganom Wetan',
  },
  {
    id: '3324140006',
    districtId: '3324140',
    name: 'Kadilangu',
  },
  {
    id: '3324140007',
    districtId: '3324140',
    name: 'Truko',
  },
  {
    id: '3324140008',
    districtId: '3324140',
    name: 'Lebosari',
  },
  {
    id: '3324140009',
    districtId: '3324140',
    name: 'Kangkung',
  },
  {
    id: '3324140010',
    districtId: '3324140',
    name: 'Laban',
  },
  {
    id: '3324140011',
    districtId: '3324140',
    name: 'Karangmalang Wetan',
  },
  {
    id: '3324140012',
    districtId: '3324140',
    name: 'Jungsemi',
  },
  {
    id: '3324140013',
    districtId: '3324140',
    name: 'Tanjungmojo',
  },
  {
    id: '3324140014',
    districtId: '3324140',
    name: 'Rejosari',
  },
  {
    id: '3324140015',
    districtId: '3324140',
    name: 'Kalirejo',
  },
  {
    id: '3324150001',
    districtId: '3324150',
    name: 'Pandes',
  },
  {
    id: '3324150002',
    districtId: '3324150',
    name: 'Podosari',
  },
  {
    id: '3324150003',
    districtId: '3324150',
    name: 'Botomulyo',
  },
  {
    id: '3324150004',
    districtId: '3324150',
    name: 'Gondang',
  },
  {
    id: '3324150005',
    districtId: '3324150',
    name: 'Karangsuno',
  },
  {
    id: '3324150006',
    districtId: '3324150',
    name: 'Cepiring',
  },
  {
    id: '3324150007',
    districtId: '3324150',
    name: 'Karangayu',
  },
  {
    id: '3324150008',
    districtId: '3324150',
    name: 'Sidomulyo',
  },
  {
    id: '3324150009',
    districtId: '3324150',
    name: 'Damarsari',
  },
  {
    id: '3324150010',
    districtId: '3324150',
    name: 'Juwiring',
  },
  {
    id: '3324150011',
    districtId: '3324150',
    name: 'Kaliayu',
  },
  {
    id: '3324150012',
    districtId: '3324150',
    name: 'Kalirandu Gede',
  },
  {
    id: '3324150013',
    districtId: '3324150',
    name: 'Korowelang Kulon',
  },
  {
    id: '3324150014',
    districtId: '3324150',
    name: 'Korowelang Anyar',
  },
  {
    id: '3324150015',
    districtId: '3324150',
    name: 'Margorejo',
  },
  {
    id: '3324160001',
    districtId: '3324160',
    name: 'Lanji',
  },
  {
    id: '3324160002',
    districtId: '3324160',
    name: 'Donosari',
  },
  {
    id: '3324160003',
    districtId: '3324160',
    name: 'Margosari',
  },
  {
    id: '3324160005',
    districtId: '3324160',
    name: 'Tambakrejo',
  },
  {
    id: '3324160006',
    districtId: '3324160',
    name: 'Kebonharjo',
  },
  {
    id: '3324160007',
    districtId: '3324160',
    name: 'Purwosari',
  },
  {
    id: '3324160008',
    districtId: '3324160',
    name: 'Jambearum',
  },
  {
    id: '3324160009',
    districtId: '3324160',
    name: 'Purwokerto',
  },
  {
    id: '3324160010',
    districtId: '3324160',
    name: 'Sukolilan',
  },
  {
    id: '3324160011',
    districtId: '3324160',
    name: 'Bangunrejo',
  },
  {
    id: '3324160012',
    districtId: '3324160',
    name: 'Kumpulrejo',
  },
  {
    id: '3324160013',
    districtId: '3324160',
    name: 'Magersari',
  },
  {
    id: '3324160014',
    districtId: '3324160',
    name: 'Wonosari',
  },
  {
    id: '3324160015',
    districtId: '3324160',
    name: 'Kartikajaya',
  },
  {
    id: '3324160016',
    districtId: '3324160',
    name: 'Bangunsari',
  },
  {
    id: '3324160017',
    districtId: '3324160',
    name: 'Pidodo Wetan',
  },
  {
    id: '3324160018',
    districtId: '3324160',
    name: 'Pidodo Kulon',
  },
  {
    id: '3324170001',
    districtId: '3324170',
    name: 'Sukodono',
  },
  {
    id: '3324170002',
    districtId: '3324170',
    name: 'Candiroto',
  },
  {
    id: '3324170003',
    districtId: '3324170',
    name: 'Trompo',
  },
  {
    id: '3324170004',
    districtId: '3324170',
    name: 'Jotang',
  },
  {
    id: '3324170005',
    districtId: '3324170',
    name: 'Tunggulrejo',
  },
  {
    id: '3324170006',
    districtId: '3324170',
    name: 'Sijeruk',
  },
  {
    id: '3324170007',
    districtId: '3324170',
    name: 'Jetis',
  },
  {
    id: '3324170008',
    districtId: '3324170',
    name: 'Bugangin',
  },
  {
    id: '3324170009',
    districtId: '3324170',
    name: 'Langenharjo',
  },
  {
    id: '3324170010',
    districtId: '3324170',
    name: 'Kalibuntu Wetan',
  },
  {
    id: '3324170011',
    districtId: '3324170',
    name: 'Kebondalem',
  },
  {
    id: '3324170012',
    districtId: '3324170',
    name: 'Ketapang',
  },
  {
    id: '3324170013',
    districtId: '3324170',
    name: 'Banyutowo',
  },
  {
    id: '3324170014',
    districtId: '3324170',
    name: 'Karang Sari',
  },
  {
    id: '3324170015',
    districtId: '3324170',
    name: 'Patukangan',
  },
  {
    id: '3324170016',
    districtId: '3324170',
    name: 'Pegulon',
  },
  {
    id: '3324170017',
    districtId: '3324170',
    name: 'Pakauman',
  },
  {
    id: '3324170018',
    districtId: '3324170',
    name: 'Ngilir',
  },
  {
    id: '3324170019',
    districtId: '3324170',
    name: 'Balok',
  },
  {
    id: '3324170020',
    districtId: '3324170',
    name: 'Bandengan',
  },
  {
    id: '3325010001',
    districtId: '3325010',
    name: 'Silurah',
  },
  {
    id: '3325010002',
    districtId: '3325010',
    name: 'Sodong',
  },
  {
    id: '3325010003',
    districtId: '3325010',
    name: 'Gringgingsari',
  },
  {
    id: '3325010004',
    districtId: '3325010',
    name: 'Kedungmalang',
  },
  {
    id: '3325010005',
    districtId: '3325010',
    name: 'Sendang',
  },
  {
    id: '3325010006',
    districtId: '3325010',
    name: 'Wonotunggal',
  },
  {
    id: '3325010007',
    districtId: '3325010',
    name: 'Brokoh',
  },
  {
    id: '3325010008',
    districtId: '3325010',
    name: 'Wates',
  },
  {
    id: '3325010009',
    districtId: '3325010',
    name: 'Brayo',
  },
  {
    id: '3325010010',
    districtId: '3325010',
    name: 'Kemligi',
  },
  {
    id: '3325010011',
    districtId: '3325010',
    name: 'Sigayam',
  },
  {
    id: '3325010012',
    districtId: '3325010',
    name: 'Kreyo',
  },
  {
    id: '3325010013',
    districtId: '3325010',
    name: 'Siwatu',
  },
  {
    id: '3325010014',
    districtId: '3325010',
    name: 'Dringo',
  },
  {
    id: '3325010015',
    districtId: '3325010',
    name: 'Penangkan',
  },
  {
    id: '3325020001',
    districtId: '3325020',
    name: 'Tombo',
  },
  {
    id: '3325020002',
    districtId: '3325020',
    name: 'Wonomerto',
  },
  {
    id: '3325020004',
    districtId: '3325020',
    name: 'Toso',
  },
  {
    id: '3325020005',
    districtId: '3325020',
    name: 'Sidayu',
  },
  {
    id: '3325020006',
    districtId: '3325020',
    name: 'Binangun',
  },
  {
    id: '3325020007',
    districtId: '3325020',
    name: 'Wonodadi',
  },
  {
    id: '3325020008',
    districtId: '3325020',
    name: 'Pesalakan',
  },
  {
    id: '3325020009',
    districtId: '3325020',
    name: 'Tambahrejo',
  },
  {
    id: '3325020010',
    districtId: '3325020',
    name: 'Bandar',
  },
  {
    id: '3325020011',
    districtId: '3325020',
    name: 'Wonokerto',
  },
  {
    id: '3325020012',
    districtId: '3325020',
    name: 'Candi',
  },
  {
    id: '3325020013',
    districtId: '3325020',
    name: 'Pucanggading',
  },
  {
    id: '3325020014',
    districtId: '3325020',
    name: 'Simpar',
  },
  {
    id: '3325020015',
    districtId: '3325020',
    name: 'Batiombo',
  },
  {
    id: '3325020016',
    districtId: '3325020',
    name: 'Wonosegoro',
  },
  {
    id: '3325020018',
    districtId: '3325020',
    name: 'Kluwih',
  },
  {
    id: '3325030001',
    districtId: '3325030',
    name: 'Gerlang',
  },
  {
    id: '3325030002',
    districtId: '3325030',
    name: 'Kalitengah',
  },
  {
    id: '3325030003',
    districtId: '3325030',
    name: 'Kembanglangit',
  },
  {
    id: '3325030004',
    districtId: '3325030',
    name: 'Gondang',
  },
  {
    id: '3325030005',
    districtId: '3325030',
    name: 'Bismo',
  },
  {
    id: '3325030007',
    districtId: '3325030',
    name: 'Kalisari',
  },
  {
    id: '3325030009',
    districtId: '3325030',
    name: 'Besani',
  },
  {
    id: '3325030010',
    districtId: '3325030',
    name: 'Wonobodro',
  },
  {
    id: '3325030011',
    districtId: '3325030',
    name: 'Bawang',
  },
  {
    id: '3325030012',
    districtId: '3325030',
    name: 'Pesantren',
  },
  {
    id: '3325030013',
    districtId: '3325030',
    name: 'Kambangan',
  },
  {
    id: '3325030014',
    districtId: '3325030',
    name: 'Keputon',
  },
  {
    id: '3325030015',
    districtId: '3325030',
    name: 'Blado',
  },
  {
    id: '3325030016',
    districtId: '3325030',
    name: 'Cokro',
  },
  {
    id: '3325030020',
    districtId: '3325030',
    name: 'Kalipancur',
  },
  {
    id: '3325030021',
    districtId: '3325030',
    name: 'Selopajang Barat',
  },
  {
    id: '3325030022',
    districtId: '3325030',
    name: 'Selopajang Timur',
  },
  {
    id: '3325040001',
    districtId: '3325040',
    name: 'Pacet',
  },
  {
    id: '3325040002',
    districtId: '3325040',
    name: 'Mojotengah',
  },
  {
    id: '3325040003',
    districtId: '3325040',
    name: 'Cablikan',
  },
  {
    id: '3325040004',
    districtId: '3325040',
    name: 'Ngroto',
  },
  {
    id: '3325040005',
    districtId: '3325040',
    name: 'Ngadirejo',
  },
  {
    id: '3325040006',
    districtId: '3325040',
    name: 'Reban',
  },
  {
    id: '3325040007',
    districtId: '3325040',
    name: 'Tambakboyo',
  },
  {
    id: '3325040008',
    districtId: '3325040',
    name: 'Adinuso',
  },
  {
    id: '3325040011',
    districtId: '3325040',
    name: 'Padomasan',
  },
  {
    id: '3325040012',
    districtId: '3325040',
    name: 'Semampir',
  },
  {
    id: '3325040013',
    districtId: '3325040',
    name: 'Wonosobo',
  },
  {
    id: '3325040014',
    districtId: '3325040',
    name: 'Sojomerto',
  },
  {
    id: '3325040015',
    districtId: '3325040',
    name: 'Karanganyar',
  },
  {
    id: '3325040016',
    districtId: '3325040',
    name: 'Polodoro',
  },
  {
    id: '3325040017',
    districtId: '3325040',
    name: 'Kalisari',
  },
  {
    id: '3325040018',
    districtId: '3325040',
    name: 'Sukomangli',
  },
  {
    id: '3325040022',
    districtId: '3325040',
    name: 'Wonorojo',
  },
  {
    id: '3325050001',
    districtId: '3325050',
    name: 'Pranten',
  },
  {
    id: '3325050003',
    districtId: '3325050',
    name: 'Gunungsari',
  },
  {
    id: '3325050004',
    districtId: '3325050',
    name: 'Jambangan',
  },
  {
    id: '3325050005',
    districtId: '3325050',
    name: 'Kebaturan',
  },
  {
    id: '3325050006',
    districtId: '3325050',
    name: 'Kalirejo',
  },
  {
    id: '3325050007',
    districtId: '3325050',
    name: 'Sangubanyu',
  },
  {
    id: '3325050008',
    districtId: '3325050',
    name: 'Wono Sari',
  },
  {
    id: '3325050009',
    districtId: '3325050',
    name: 'Jlamprang',
  },
  {
    id: '3325050010',
    districtId: '3325050',
    name: 'Bawang',
  },
  {
    id: '3325050011',
    districtId: '3325050',
    name: 'Candigugur',
  },
  {
    id: '3325050012',
    districtId: '3325050',
    name: 'Pangempon',
  },
  {
    id: '3325050013',
    districtId: '3325050',
    name: 'Sidoharjo',
  },
  {
    id: '3325050014',
    districtId: '3325050',
    name: 'Surjo',
  },
  {
    id: '3325050015',
    districtId: '3325050',
    name: 'Soka',
  },
  {
    id: '3325050016',
    districtId: '3325050',
    name: 'Sibebek',
  },
  {
    id: '3325050017',
    districtId: '3325050',
    name: 'Getas',
  },
  {
    id: '3325050018',
    districtId: '3325050',
    name: 'Pasusukan',
  },
  {
    id: '3325050019',
    districtId: '3325050',
    name: 'Candirejo',
  },
  {
    id: '3325050020',
    districtId: '3325050',
    name: 'Purbo',
  },
  {
    id: '3325060002',
    districtId: '3325060',
    name: 'Sendang',
  },
  {
    id: '3325060003',
    districtId: '3325060',
    name: 'Gondo',
  },
  {
    id: '3325060004',
    districtId: '3325060',
    name: 'Banteng',
  },
  {
    id: '3325060005',
    districtId: '3325060',
    name: 'Wanar',
  },
  {
    id: '3325060006',
    districtId: '3325060',
    name: 'Sumurbanger',
  },
  {
    id: '3325060007',
    districtId: '3325060',
    name: 'Sidalang',
  },
  {
    id: '3325060008',
    districtId: '3325060',
    name: 'Margosono',
  },
  {
    id: '3325060009',
    districtId: '3325060',
    name: 'Plosowangi',
  },
  {
    id: '3325060010',
    districtId: '3325060',
    name: 'Boja',
  },
  {
    id: '3325060012',
    districtId: '3325060',
    name: 'Tersono',
  },
  {
    id: '3325060015',
    districtId: '3325060',
    name: 'Tanjungsari',
  },
  {
    id: '3325060016',
    districtId: '3325060',
    name: 'Kranggan',
  },
  {
    id: '3325060018',
    districtId: '3325060',
    name: 'Tegalombo',
  },
  {
    id: '3325060021',
    districtId: '3325060',
    name: 'Satriyan',
  },
  {
    id: '3325060022',
    districtId: '3325060',
    name: 'Rejosari Barat',
  },
  {
    id: '3325060023',
    districtId: '3325060',
    name: 'Rejosari Timur',
  },
  {
    id: '3325060024',
    districtId: '3325060',
    name: 'Harjowinangun Barat',
  },
  {
    id: '3325060025',
    districtId: '3325060',
    name: 'Harjowinangun Timur',
  },
  {
    id: '3325070005',
    districtId: '3325070',
    name: 'Surodadi',
  },
  {
    id: '3325070008',
    districtId: '3325070',
    name: 'Kutosari',
  },
  {
    id: '3325070009',
    districtId: '3325070',
    name: 'Mentosari',
  },
  {
    id: '3325070010',
    districtId: '3325070',
    name: 'Gringsing',
  },
  {
    id: '3325070011',
    districtId: '3325070',
    name: 'Lebo',
  },
  {
    id: '3325070013',
    districtId: '3325070',
    name: 'Kebondalem',
  },
  {
    id: '3325070014',
    districtId: '3325070',
    name: 'Yosorejo',
  },
  {
    id: '3325070015',
    districtId: '3325070',
    name: 'Sidorejo',
  },
  {
    id: '3325070016',
    districtId: '3325070',
    name: 'Sawangan',
  },
  {
    id: '3325070017',
    districtId: '3325070',
    name: 'Ketanggan',
  },
  {
    id: '3325070018',
    districtId: '3325070',
    name: 'Madugowongjati',
  },
  {
    id: '3325070019',
    districtId: '3325070',
    name: 'Tedunan',
  },
  {
    id: '3325080001',
    districtId: '3325080',
    name: 'Sidomulyo',
  },
  {
    id: '3325080002',
    districtId: '3325080',
    name: 'Donorejo',
  },
  {
    id: '3325080003',
    districtId: '3325080',
    name: 'Tembok',
  },
  {
    id: '3325080004',
    districtId: '3325080',
    name: 'Sukorejo',
  },
  {
    id: '3325080005',
    districtId: '3325080',
    name: 'Ngaliyan',
  },
  {
    id: '3325080006',
    districtId: '3325080',
    name: 'Amongrogo',
  },
  {
    id: '3325080007',
    districtId: '3325080',
    name: 'Plumbon',
  },
  {
    id: '3325080008',
    districtId: '3325080',
    name: 'Babadan',
  },
  {
    id: '3325080010',
    districtId: '3325080',
    name: 'Limpung',
  },
  {
    id: '3325080012',
    districtId: '3325080',
    name: 'Kalisalak',
  },
  {
    id: '3325080015',
    districtId: '3325080',
    name: 'Pungangan',
  },
  {
    id: '3325080016',
    districtId: '3325080',
    name: 'Rowosari',
  },
  {
    id: '3325080017',
    districtId: '3325080',
    name: 'Dlisen',
  },
  {
    id: '3325080023',
    districtId: '3325080',
    name: 'Wonokerso',
  },
  {
    id: '3325080024',
    districtId: '3325080',
    name: 'Lobang',
  },
  {
    id: '3325081001',
    districtId: '3325081',
    name: 'Dlimas',
  },
  {
    id: '3325081003',
    districtId: '3325081',
    name: 'Banyuputih',
  },
  {
    id: '3325081004',
    districtId: '3325081',
    name: 'Kalibalik',
  },
  {
    id: '3325081005',
    districtId: '3325081',
    name: 'Kalangsono',
  },
  {
    id: '3325081007',
    districtId: '3325081',
    name: 'Banaran',
  },
  {
    id: '3325081008',
    districtId: '3325081',
    name: 'Timbang',
  },
  {
    id: '3325081009',
    districtId: '3325081',
    name: 'Penundan',
  },
  {
    id: '3325081011',
    districtId: '3325081',
    name: 'Kedawung',
  },
  {
    id: '3325090004',
    districtId: '3325090',
    name: 'Menjangan',
  },
  {
    id: '3325090005',
    districtId: '3325090',
    name: 'Karangtengah',
  },
  {
    id: '3325090006',
    districtId: '3325090',
    name: 'Mangunharjo',
  },
  {
    id: '3325090007',
    districtId: '3325090',
    name: 'Tenggulangharjo',
  },
  {
    id: '3325090008',
    districtId: '3325090',
    name: 'Keborangan',
  },
  {
    id: '3325090009',
    districtId: '3325090',
    name: 'Kalimanggis',
  },
  {
    id: '3325090010',
    districtId: '3325090',
    name: 'Jatisari',
  },
  {
    id: '3325090011',
    districtId: '3325090',
    name: 'Subah',
  },
  {
    id: '3325090012',
    districtId: '3325090',
    name: 'Kumejing',
  },
  {
    id: '3325090014',
    districtId: '3325090',
    name: 'Durenombo',
  },
  {
    id: '3325090019',
    districtId: '3325090',
    name: 'Clapar',
  },
  {
    id: '3325090021',
    districtId: '3325090',
    name: 'Sengon',
  },
  {
    id: '3325090022',
    districtId: '3325090',
    name: 'Adinuso',
  },
  {
    id: '3325090023',
    districtId: '3325090',
    name: 'Gondang',
  },
  {
    id: '3325090024',
    districtId: '3325090',
    name: 'Kuripan',
  },
  {
    id: '3325090026',
    districtId: '3325090',
    name: 'Kemiri Barat',
  },
  {
    id: '3325090027',
    districtId: '3325090',
    name: 'Kemiri Timur',
  },
  {
    id: '3325091002',
    districtId: '3325091',
    name: 'Siguci',
  },
  {
    id: '3325091003',
    districtId: '3325091',
    name: 'Selokarto',
  },
  {
    id: '3325091005',
    districtId: '3325091',
    name: 'Gumawang',
  },
  {
    id: '3325091006',
    districtId: '3325091',
    name: 'Keniten',
  },
  {
    id: '3325091007',
    districtId: '3325091',
    name: 'Randu',
  },
  {
    id: '3325091008',
    districtId: '3325091',
    name: 'Gombong',
  },
  {
    id: '3325091009',
    districtId: '3325091',
    name: 'Pecalungan',
  },
  {
    id: '3325091010',
    districtId: '3325091',
    name: 'Bandung',
  },
  {
    id: '3325100005',
    districtId: '3325100',
    name: 'Tulis',
  },
  {
    id: '3325100006',
    districtId: '3325100',
    name: 'Wringingintung',
  },
  {
    id: '3325100007',
    districtId: '3325100',
    name: 'Posong',
  },
  {
    id: '3325100008',
    districtId: '3325100',
    name: 'Sembojo',
  },
  {
    id: '3325100009',
    districtId: '3325100',
    name: 'Beji',
  },
  {
    id: '3325100010',
    districtId: '3325100',
    name: 'Kaliboyo',
  },
  {
    id: '3325100011',
    districtId: '3325100',
    name: 'Simbangdesa',
  },
  {
    id: '3325100012',
    districtId: '3325100',
    name: 'Simbangjati',
  },
  {
    id: '3325100021',
    districtId: '3325100',
    name: 'Ponowareng',
  },
  {
    id: '3325100022',
    districtId: '3325100',
    name: 'Kenconorejo',
  },
  {
    id: '3325100023',
    districtId: '3325100',
    name: 'Kedungsegog',
  },
  {
    id: '3325100024',
    districtId: '3325100',
    name: 'Manggis',
  },
  {
    id: '3325100025',
    districtId: '3325100',
    name: 'Jolosekti',
  },
  {
    id: '3325100026',
    districtId: '3325100',
    name: 'Siberuk',
  },
  {
    id: '3325100029',
    districtId: '3325100',
    name: 'Jrakahpayung',
  },
  {
    id: '3325101001',
    districtId: '3325101',
    name: 'Lawangaji',
  },
  {
    id: '3325101002',
    districtId: '3325101',
    name: 'Karanganom',
  },
  {
    id: '3325101003',
    districtId: '3325101',
    name: 'Botolambat',
  },
  {
    id: '3325101005',
    districtId: '3325101',
    name: 'Tragung',
  },
  {
    id: '3325101006',
    districtId: '3325101',
    name: 'Tegalsari',
  },
  {
    id: '3325101007',
    districtId: '3325101',
    name: 'Kandeman',
  },
  {
    id: '3325101008',
    districtId: '3325101',
    name: 'Juragan',
  },
  {
    id: '3325101009',
    districtId: '3325101',
    name: 'Bakalan',
  },
  {
    id: '3325101010',
    districtId: '3325101',
    name: 'Wonokerso',
  },
  {
    id: '3325101011',
    districtId: '3325101',
    name: 'Karanggeneng',
  },
  {
    id: '3325101012',
    districtId: '3325101',
    name: 'Ujungnegoro',
  },
  {
    id: '3325101013',
    districtId: '3325101',
    name: 'Depok',
  },
  {
    id: '3325110001',
    districtId: '3325110',
    name: 'Rowobelang',
  },
  {
    id: '3325110002',
    districtId: '3325110',
    name: 'Cepokokuning',
  },
  {
    id: '3325110003',
    districtId: '3325110',
    name: 'Pasekaran',
  },
  {
    id: '3325110004',
    districtId: '3325110',
    name: 'Kalisalak',
  },
  {
    id: '3325110005',
    districtId: '3325110',
    name: 'Kauman',
  },
  {
    id: '3325110007',
    districtId: '3325110',
    name: 'Kecepak',
  },
  {
    id: '3325110008',
    districtId: '3325110',
    name: 'Sambong',
  },
  {
    id: '3325110009',
    districtId: '3325110',
    name: 'Klidang Wetan',
  },
  {
    id: '3325110010',
    districtId: '3325110',
    name: 'Klidang Lor',
  },
  {
    id: '3325110012',
    districtId: '3325110',
    name: 'Kasepuhan',
  },
  {
    id: '3325110013',
    districtId: '3325110',
    name: 'Watesalit',
  },
  {
    id: '3325110014',
    districtId: '3325110',
    name: 'Kalipucang Wetan',
  },
  {
    id: '3325110015',
    districtId: '3325110',
    name: 'Kalipucang Kulon',
  },
  {
    id: '3325110016',
    districtId: '3325110',
    name: 'Karanganyar',
  },
  {
    id: '3325110017',
    districtId: '3325110',
    name: 'Denasri Kulon',
  },
  {
    id: '3325110018',
    districtId: '3325110',
    name: 'Denasri Wetan',
  },
  {
    id: '3325110019',
    districtId: '3325110',
    name: 'Proyonanggan Tengah',
  },
  {
    id: '3325110020',
    districtId: '3325110',
    name: 'Proyonanggan Utara',
  },
  {
    id: '3325110021',
    districtId: '3325110',
    name: 'Proyonanggan Selatan',
  },
  {
    id: '3325110022',
    districtId: '3325110',
    name: 'Karangasem Utara',
  },
  {
    id: '3325110023',
    districtId: '3325110',
    name: 'Karangasem Selatan',
  },
  {
    id: '3325120001',
    districtId: '3325120',
    name: 'Pandansari',
  },
  {
    id: '3325120002',
    districtId: '3325120',
    name: 'Kaliwareng',
  },
  {
    id: '3325120003',
    districtId: '3325120',
    name: 'Pejambon',
  },
  {
    id: '3325120004',
    districtId: '3325120',
    name: 'Sariglagah',
  },
  {
    id: '3325120005',
    districtId: '3325120',
    name: 'Pesaren',
  },
  {
    id: '3325120006',
    districtId: '3325120',
    name: 'Sidorejo',
  },
  {
    id: '3325120007',
    districtId: '3325120',
    name: 'Cepagan',
  },
  {
    id: '3325120008',
    districtId: '3325120',
    name: 'Masin',
  },
  {
    id: '3325120009',
    districtId: '3325120',
    name: 'Banjiran',
  },
  {
    id: '3325120010',
    districtId: '3325120',
    name: 'Warungasem',
  },
  {
    id: '3325120011',
    districtId: '3325120',
    name: 'Gapuro',
  },
  {
    id: '3325120012',
    districtId: '3325120',
    name: 'Kalibeluk',
  },
  {
    id: '3325120013',
    districtId: '3325120',
    name: 'Sawahjoho',
  },
  {
    id: '3325120014',
    districtId: '3325120',
    name: 'Candiareng',
  },
  {
    id: '3325120015',
    districtId: '3325120',
    name: 'Lebo',
  },
  {
    id: '3325120017',
    districtId: '3325120',
    name: 'Terban',
  },
  {
    id: '3325120018',
    districtId: '3325120',
    name: 'Sijono',
  },
  {
    id: '3326010002',
    districtId: '3326010',
    name: 'Bodas',
  },
  {
    id: '3326010003',
    districtId: '3326010',
    name: 'Gembong',
  },
  {
    id: '3326010004',
    districtId: '3326010',
    name: 'Sukoharjo',
  },
  {
    id: '3326010005',
    districtId: '3326010',
    name: 'Garungwiyoro',
  },
  {
    id: '3326010006',
    districtId: '3326010',
    name: 'Bubak',
  },
  {
    id: '3326010007',
    districtId: '3326010',
    name: 'Bojongkoneng',
  },
  {
    id: '3326010008',
    districtId: '3326010',
    name: 'Luragung',
  },
  {
    id: '3326010009',
    districtId: '3326010',
    name: 'Kandangserang',
  },
  {
    id: '3326010010',
    districtId: '3326010',
    name: 'Wangkelang',
  },
  {
    id: '3326010011',
    districtId: '3326010',
    name: 'Lambur',
  },
  {
    id: '3326010012',
    districtId: '3326010',
    name: 'Tajur',
  },
  {
    id: '3326010013',
    districtId: '3326010',
    name: 'Trajumas',
  },
  {
    id: '3326010014',
    districtId: '3326010',
    name: 'Karanggondang',
  },
  {
    id: '3326020001',
    districtId: '3326020',
    name: 'Werdi',
  },
  {
    id: '3326020002',
    districtId: '3326020',
    name: 'Winduaji',
  },
  {
    id: '3326020003',
    districtId: '3326020',
    name: 'Krandegan',
  },
  {
    id: '3326020004',
    districtId: '3326020',
    name: 'Lomeneng',
  },
  {
    id: '3326020005',
    districtId: '3326020',
    name: 'Tanggeran',
  },
  {
    id: '3326020006',
    districtId: '3326020',
    name: 'Kaliboja',
  },
  {
    id: '3326020007',
    districtId: '3326020',
    name: 'Kaliombo',
  },
  {
    id: '3326020008',
    districtId: '3326020',
    name: 'Botosari',
  },
  {
    id: '3326020009',
    districtId: '3326020',
    name: 'Sawangan',
  },
  {
    id: '3326020010',
    districtId: '3326020',
    name: 'Paninggaran',
  },
  {
    id: '3326020011',
    districtId: '3326020',
    name: 'Domiyang',
  },
  {
    id: '3326020012',
    districtId: '3326020',
    name: 'Notogiwang',
  },
  {
    id: '3326020013',
    districtId: '3326020',
    name: 'Lambanggelun',
  },
  {
    id: '3326020014',
    districtId: '3326020',
    name: 'Tenogo',
  },
  {
    id: '3326020015',
    districtId: '3326020',
    name: 'Bedagung',
  },
  {
    id: '3326030001',
    districtId: '3326030',
    name: 'Tembelang Gunung',
  },
  {
    id: '3326030002',
    districtId: '3326030',
    name: 'Pamutuh',
  },
  {
    id: '3326030003',
    districtId: '3326030',
    name: 'Depok',
  },
  {
    id: '3326030004',
    districtId: '3326030',
    name: 'Wonosido',
  },
  {
    id: '3326030005',
    districtId: '3326030',
    name: 'Timbangsari',
  },
  {
    id: '3326030006',
    districtId: '3326030',
    name: 'Sidomulyo',
  },
  {
    id: '3326030007',
    districtId: '3326030',
    name: 'Kutorembet',
  },
  {
    id: '3326030008',
    districtId: '3326030',
    name: 'Lebakbarang',
  },
  {
    id: '3326030009',
    districtId: '3326030',
    name: 'Kapundutan',
  },
  {
    id: '3326030010',
    districtId: '3326030',
    name: 'Bantar Kulon',
  },
  {
    id: '3326030011',
    districtId: '3326030',
    name: 'Mendolo',
  },
  {
    id: '3326040001',
    districtId: '3326040',
    name: 'Simego',
  },
  {
    id: '3326040002',
    districtId: '3326040',
    name: 'Songgodadi',
  },
  {
    id: '3326040003',
    districtId: '3326040',
    name: 'Curugmuncar',
  },
  {
    id: '3326040005',
    districtId: '3326040',
    name: 'Tlogohendro',
  },
  {
    id: '3326040006',
    districtId: '3326040',
    name: 'Yosorejo',
  },
  {
    id: '3326040007',
    districtId: '3326040',
    name: 'Tlogopakis',
  },
  {
    id: '3326040008',
    districtId: '3326040',
    name: 'Kasimpar',
  },
  {
    id: '3326040009',
    districtId: '3326040',
    name: 'Kayupuring',
  },
  {
    id: '3326050001',
    districtId: '3326050',
    name: 'Mesoyi',
  },
  {
    id: '3326050002',
    districtId: '3326050',
    name: 'Jolotigo',
  },
  {
    id: '3326050003',
    districtId: '3326050',
    name: 'Sengare',
  },
  {
    id: '3326050004',
    districtId: '3326050',
    name: 'Donowangun',
  },
  {
    id: '3326050005',
    districtId: '3326050',
    name: 'Talun',
  },
  {
    id: '3326050006',
    districtId: '3326050',
    name: 'Banjarsari',
  },
  {
    id: '3326050007',
    districtId: '3326050',
    name: 'Kalirejo',
  },
  {
    id: '3326050008',
    districtId: '3326050',
    name: 'Batursari',
  },
  {
    id: '3326050009',
    districtId: '3326050',
    name: 'Karangasem',
  },
  {
    id: '3326050010',
    districtId: '3326050',
    name: 'Krompeng',
  },
  {
    id: '3326060001',
    districtId: '3326060',
    name: 'Pungangan',
  },
  {
    id: '3326060002',
    districtId: '3326060',
    name: 'Sidoharjo',
  },
  {
    id: '3326060003',
    districtId: '3326060',
    name: 'Lemah Abang',
  },
  {
    id: '3326060004',
    districtId: '3326060',
    name: 'Rogoselo',
  },
  {
    id: '3326060005',
    districtId: '3326060',
    name: 'Harjosari',
  },
  {
    id: '3326060006',
    districtId: '3326060',
    name: 'Larikan',
  },
  {
    id: '3326060007',
    districtId: '3326060',
    name: 'Sawangan',
  },
  {
    id: '3326060008',
    districtId: '3326060',
    name: 'Dororejo',
  },
  {
    id: '3326060009',
    districtId: '3326060',
    name: 'Doro',
  },
  {
    id: '3326060010',
    districtId: '3326060',
    name: 'Randusari',
  },
  {
    id: '3326060011',
    districtId: '3326060',
    name: 'Kutosari',
  },
  {
    id: '3326060012',
    districtId: '3326060',
    name: 'Wringin Agung',
  },
  {
    id: '3326060013',
    districtId: '3326060',
    name: 'Kalimojosari',
  },
  {
    id: '3326060014',
    districtId: '3326060',
    name: 'Bligorejo',
  },
  {
    id: '3326070001',
    districtId: '3326070',
    name: 'Gutomo',
  },
  {
    id: '3326070002',
    districtId: '3326070',
    name: 'Limbangan',
  },
  {
    id: '3326070003',
    districtId: '3326070',
    name: 'Karang Gondang',
  },
  {
    id: '3326070004',
    districtId: '3326070',
    name: 'Lolong',
  },
  {
    id: '3326070005',
    districtId: '3326070',
    name: 'Pedawang',
  },
  {
    id: '3326070006',
    districtId: '3326070',
    name: 'Pododadi',
  },
  {
    id: '3326070007',
    districtId: '3326070',
    name: 'Legok Kalong',
  },
  {
    id: '3326070008',
    districtId: '3326070',
    name: 'Karangsari',
  },
  {
    id: '3326070010',
    districtId: '3326070',
    name: 'Banjarejo',
  },
  {
    id: '3326070011',
    districtId: '3326070',
    name: 'Wonosari',
  },
  {
    id: '3326070012',
    districtId: '3326070',
    name: 'Sukosari',
  },
  {
    id: '3326070013',
    districtId: '3326070',
    name: 'Sidomukti',
  },
  {
    id: '3326070014',
    districtId: '3326070',
    name: 'Kayugeritan',
  },
  {
    id: '3326070015',
    districtId: '3326070',
    name: 'Kutosari',
  },
  {
    id: '3326080001',
    districtId: '3326080',
    name: 'Tambakroto',
  },
  {
    id: '3326080002',
    districtId: '3326080',
    name: 'Kutorojo',
  },
  {
    id: '3326080003',
    districtId: '3326080',
    name: 'Linggoasri',
  },
  {
    id: '3326080004',
    districtId: '3326080',
    name: 'Brengkolang',
  },
  {
    id: '3326080005',
    districtId: '3326080',
    name: 'Pringsurat',
  },
  {
    id: '3326080006',
    districtId: '3326080',
    name: 'Sokoyoso',
  },
  {
    id: '3326080007',
    districtId: '3326080',
    name: 'Sinangoh Prendeng',
  },
  {
    id: '3326080008',
    districtId: '3326080',
    name: 'Kajongan',
  },
  {
    id: '3326080009',
    districtId: '3326080',
    name: 'Pekiringan Ageng',
  },
  {
    id: '3326080010',
    districtId: '3326080',
    name: 'Gandarum',
  },
  {
    id: '3326080011',
    districtId: '3326080',
    name: 'Sabarwangi',
  },
  {
    id: '3326080012',
    districtId: '3326080',
    name: 'Kalijoyo',
  },
  {
    id: '3326080013',
    districtId: '3326080',
    name: 'Wonorejo',
  },
  {
    id: '3326080014',
    districtId: '3326080',
    name: 'Pekiringan Alit',
  },
  {
    id: '3326080015',
    districtId: '3326080',
    name: 'Kutorejo',
  },
  {
    id: '3326080016',
    districtId: '3326080',
    name: 'Kajen',
  },
  {
    id: '3326080017',
    districtId: '3326080',
    name: 'Nyamok',
  },
  {
    id: '3326080018',
    districtId: '3326080',
    name: 'Tanjung Kulon',
  },
  {
    id: '3326080019',
    districtId: '3326080',
    name: 'Tanjungsari',
  },
  {
    id: '3326080020',
    districtId: '3326080',
    name: 'Gejlig',
  },
  {
    id: '3326080021',
    districtId: '3326080',
    name: 'Kebon Agung',
  },
  {
    id: '3326080022',
    districtId: '3326080',
    name: 'Sangkan Joyo',
  },
  {
    id: '3326080023',
    districtId: '3326080',
    name: 'Salit',
  },
  {
    id: '3326080024',
    districtId: '3326080',
    name: 'Sambiroto',
  },
  {
    id: '3326080025',
    districtId: '3326080',
    name: 'Rowolaku',
  },
  {
    id: '3326090001',
    districtId: '3326090',
    name: 'Windurojo',
  },
  {
    id: '3326090002',
    districtId: '3326090',
    name: 'Ujung Negoro',
  },
  {
    id: '3326090003',
    districtId: '3326090',
    name: 'Brondong',
  },
  {
    id: '3326090004',
    districtId: '3326090',
    name: 'Podosari',
  },
  {
    id: '3326090005',
    districtId: '3326090',
    name: 'Kwasen',
  },
  {
    id: '3326090006',
    districtId: '3326090',
    name: 'Langensari',
  },
  {
    id: '3326090007',
    districtId: '3326090',
    name: 'Jagung',
  },
  {
    id: '3326090008',
    districtId: '3326090',
    name: 'Watugajah',
  },
  {
    id: '3326090009',
    districtId: '3326090',
    name: 'Karangrejo',
  },
  {
    id: '3326090010',
    districtId: '3326090',
    name: 'Karyomukti',
  },
  {
    id: '3326090011',
    districtId: '3326090',
    name: 'Kesesi',
  },
  {
    id: '3326090012',
    districtId: '3326090',
    name: 'Srinahan',
  },
  {
    id: '3326090013',
    districtId: '3326090',
    name: 'Kaibahan',
  },
  {
    id: '3326090014',
    districtId: '3326090',
    name: 'Watupayung',
  },
  {
    id: '3326090015',
    districtId: '3326090',
    name: 'Krandon',
  },
  {
    id: '3326090016',
    districtId: '3326090',
    name: 'Ponolawen',
  },
  {
    id: '3326090017',
    districtId: '3326090',
    name: 'Kalimade',
  },
  {
    id: '3326090018',
    districtId: '3326090',
    name: 'Sidomulyo',
  },
  {
    id: '3326090019',
    districtId: '3326090',
    name: 'Sukorejo',
  },
  {
    id: '3326090020',
    districtId: '3326090',
    name: 'Sidosari',
  },
  {
    id: '3326090021',
    districtId: '3326090',
    name: 'Mulyorejo',
  },
  {
    id: '3326090022',
    districtId: '3326090',
    name: 'Pantirejo',
  },
  {
    id: '3326090023',
    districtId: '3326090',
    name: 'Kwigaran',
  },
  {
    id: '3326100001',
    districtId: '3326100',
    name: 'Ketanon Ageng',
  },
  {
    id: '3326100002',
    districtId: '3326100',
    name: 'Mrican',
  },
  {
    id: '3326100003',
    districtId: '3326100',
    name: 'Bulaksari',
  },
  {
    id: '3326100004',
    districtId: '3326100',
    name: 'Sumub Lor',
  },
  {
    id: '3326100005',
    districtId: '3326100',
    name: 'Sumub Kidul',
  },
  {
    id: '3326100006',
    districtId: '3326100',
    name: 'Kalijambe',
  },
  {
    id: '3326100007',
    districtId: '3326100',
    name: 'Purworejo',
  },
  {
    id: '3326100008',
    districtId: '3326100',
    name: 'Kedungjaran',
  },
  {
    id: '3326100009',
    districtId: '3326100',
    name: 'Klunjukan',
  },
  {
    id: '3326100010',
    districtId: '3326100',
    name: 'Gebangkerep',
  },
  {
    id: '3326100011',
    districtId: '3326100',
    name: 'Purwodadi',
  },
  {
    id: '3326100012',
    districtId: '3326100',
    name: 'Bulak Pelem',
  },
  {
    id: '3326100013',
    districtId: '3326100',
    name: 'Tegal Suruh',
  },
  {
    id: '3326100014',
    districtId: '3326100',
    name: 'Krasakageng',
  },
  {
    id: '3326100015',
    districtId: '3326100',
    name: 'Sijeruk',
  },
  {
    id: '3326100016',
    districtId: '3326100',
    name: 'Sragi',
  },
  {
    id: '3326100017',
    districtId: '3326100',
    name: 'Tegalontar',
  },
  {
    id: '3326101001',
    districtId: '3326101',
    name: 'Mejasem',
  },
  {
    id: '3326101002',
    districtId: '3326101',
    name: 'Wonosari',
  },
  {
    id: '3326101003',
    districtId: '3326101',
    name: 'Tengeng Wetan',
  },
  {
    id: '3326101004',
    districtId: '3326101',
    name: 'Tunjungsari',
  },
  {
    id: '3326101005',
    districtId: '3326101',
    name: 'Blimbing Wuluh',
  },
  {
    id: '3326101006',
    districtId: '3326101',
    name: 'Pait',
  },
  {
    id: '3326101007',
    districtId: '3326101',
    name: 'Tengengkulon',
  },
  {
    id: '3326101009',
    districtId: '3326101',
    name: 'Yosorejo',
  },
  {
    id: '3326101010',
    districtId: '3326101',
    name: 'Siwalan',
  },
  {
    id: '3326101011',
    districtId: '3326101',
    name: 'Boyo Teluk',
  },
  {
    id: '3326101012',
    districtId: '3326101',
    name: 'Depok',
  },
  {
    id: '3326101013',
    districtId: '3326101',
    name: 'Blacanan',
  },
  {
    id: '3326110002',
    districtId: '3326110',
    name: 'Kalipancur',
  },
  {
    id: '3326110003',
    districtId: '3326110',
    name: 'Sumur Jomblangbogo',
  },
  {
    id: '3326110004',
    districtId: '3326110',
    name: 'Pantianom',
  },
  {
    id: '3326110005',
    districtId: '3326110',
    name: 'Randu Muktiwaren',
  },
  {
    id: '3326110006',
    districtId: '3326110',
    name: 'Legok Clile',
  },
  {
    id: '3326110007',
    districtId: '3326110',
    name: 'Bojong Wetan',
  },
  {
    id: '3326110008',
    districtId: '3326110',
    name: 'Wangandowo',
  },
  {
    id: '3326110010',
    districtId: '3326110',
    name: 'Ketitang Kidul',
  },
  {
    id: '3326110011',
    districtId: '3326110',
    name: 'Menjangan',
  },
  {
    id: '3326110012',
    districtId: '3326110',
    name: 'Ketitanglor',
  },
  {
    id: '3326110013',
    districtId: '3326110',
    name: 'Rejosari',
  },
  {
    id: '3326110014',
    districtId: '3326110',
    name: 'Bojonglor',
  },
  {
    id: '3326110015',
    districtId: '3326110',
    name: 'Bojong Minggir',
  },
  {
    id: '3326110016',
    districtId: '3326110',
    name: 'Wiroditan',
  },
  {
    id: '3326110017',
    districtId: '3326110',
    name: 'Kemasan',
  },
  {
    id: '3326110018',
    districtId: '3326110',
    name: 'Jajar Wayang',
  },
  {
    id: '3326110019',
    districtId: '3326110',
    name: 'Babalanlor',
  },
  {
    id: '3326110020',
    districtId: '3326110',
    name: 'Babalan Kidul',
  },
  {
    id: '3326110021',
    districtId: '3326110',
    name: 'Karangsari',
  },
  {
    id: '3326110022',
    districtId: '3326110',
    name: 'Sembung Jambu',
  },
  {
    id: '3326120001',
    districtId: '3326120',
    name: 'Jetak Kidul',
  },
  {
    id: '3326120002',
    districtId: '3326120',
    name: 'Sastrodirjan',
  },
  {
    id: '3326120003',
    districtId: '3326120',
    name: 'Legok Gunung',
  },
  {
    id: '3326120004',
    districtId: '3326120',
    name: 'Galang Pengampon Gede',
  },
  {
    id: '3326120005',
    districtId: '3326120',
    name: 'Kwagean',
  },
  {
    id: '3326120006',
    districtId: '3326120',
    name: 'Getas',
  },
  {
    id: '3326120007',
    districtId: '3326120',
    name: 'Rowokembu',
  },
  {
    id: '3326120008',
    districtId: '3326120',
    name: 'Wonopringgo',
  },
  {
    id: '3326120009',
    districtId: '3326120',
    name: 'Sampih',
  },
  {
    id: '3326120010',
    districtId: '3326120',
    name: 'Gondang',
  },
  {
    id: '3326120011',
    districtId: '3326120',
    name: 'Wonorejo',
  },
  {
    id: '3326120012',
    districtId: '3326120',
    name: 'Jetak Lengkong',
  },
  {
    id: '3326120013',
    districtId: '3326120',
    name: 'Pegaden Tengah',
  },
  {
    id: '3326120014',
    districtId: '3326120',
    name: 'Surabayan',
  },
  {
    id: '3326130001',
    districtId: '3326130',
    name: 'Rowocacing',
  },
  {
    id: '3326130002',
    districtId: '3326130',
    name: 'Langkap',
  },
  {
    id: '3326130010',
    districtId: '3326130',
    name: 'Pajomblangan',
  },
  {
    id: '3326130011',
    districtId: '3326130',
    name: 'Tosaran',
  },
  {
    id: '3326130012',
    districtId: '3326130',
    name: 'Pakisputih',
  },
  {
    id: '3326130013',
    districtId: '3326130',
    name: 'Kedung Patangewu',
  },
  {
    id: '3326130015',
    districtId: '3326130',
    name: 'Podo',
  },
  {
    id: '3326130016',
    districtId: '3326130',
    name: 'Kwayangan',
  },
  {
    id: '3326130017',
    districtId: '3326130',
    name: 'Proto',
  },
  {
    id: '3326130022',
    districtId: '3326130',
    name: 'Salakbrojo',
  },
  {
    id: '3326130023',
    districtId: '3326130',
    name: 'Ambokembang',
  },
  {
    id: '3326130024',
    districtId: '3326130',
    name: 'Pekajangan',
  },
  {
    id: '3326130025',
    districtId: '3326130',
    name: 'Tangkil Tengah',
  },
  {
    id: '3326130026',
    districtId: '3326130',
    name: 'Tangkil Kulon',
  },
  {
    id: '3326130027',
    districtId: '3326130',
    name: 'Karangdowo',
  },
  {
    id: '3326130028',
    districtId: '3326130',
    name: 'Bugangan',
  },
  {
    id: '3326130029',
    districtId: '3326130',
    name: 'Rengas',
  },
  {
    id: '3326130030',
    districtId: '3326130',
    name: 'Kedungwuni Barat',
  },
  {
    id: '3326130031',
    districtId: '3326130',
    name: 'Kedungwuni Timur',
  },
  {
    id: '3326131001',
    districtId: '3326131',
    name: 'Logandeng',
  },
  {
    id: '3326131002',
    districtId: '3326131',
    name: 'Jrebeng Kembang',
  },
  {
    id: '3326131003',
    districtId: '3326131',
    name: 'Pagumengan Mas',
  },
  {
    id: '3326131004',
    districtId: '3326131',
    name: 'Kedung Kebo',
  },
  {
    id: '3326131005',
    districtId: '3326131',
    name: 'Kaligawe',
  },
  {
    id: '3326131006',
    districtId: '3326131',
    name: 'Karangdadap',
  },
  {
    id: '3326131007',
    districtId: '3326131',
    name: 'Kalilembu',
  },
  {
    id: '3326131008',
    districtId: '3326131',
    name: 'Pangkah',
  },
  {
    id: '3326131009',
    districtId: '3326131',
    name: 'Kebonrowo Pucang',
  },
  {
    id: '3326131010',
    districtId: '3326131',
    name: 'Kebonsari',
  },
  {
    id: '3326131011',
    districtId: '3326131',
    name: 'Pegandon',
  },
  {
    id: '3326140001',
    districtId: '3326140',
    name: 'Coprayan',
  },
  {
    id: '3326140002',
    districtId: '3326140',
    name: 'Sapugarut',
  },
  {
    id: '3326140003',
    districtId: '3326140',
    name: 'Wonoyoso',
  },
  {
    id: '3326140004',
    districtId: '3326140',
    name: 'Bligo',
  },
  {
    id: '3326140005',
    districtId: '3326140',
    name: 'Pakumbulan',
  },
  {
    id: '3326140006',
    districtId: '3326140',
    name: 'Watusalam',
  },
  {
    id: '3326140007',
    districtId: '3326140',
    name: 'Simbang Wetan',
  },
  {
    id: '3326140008',
    districtId: '3326140',
    name: 'Simbang Kulon',
  },
  {
    id: '3326140009',
    districtId: '3326140',
    name: 'Kertijayan',
  },
  {
    id: '3326140010',
    districtId: '3326140',
    name: 'Paweden',
  },
  {
    id: '3326150002',
    districtId: '3326150',
    name: 'Ngalian',
  },
  {
    id: '3326150003',
    districtId: '3326150',
    name: 'Pandan Arum',
  },
  {
    id: '3326150004',
    districtId: '3326150',
    name: 'Karanganyar',
  },
  {
    id: '3326150005',
    districtId: '3326150',
    name: 'Silirejo',
  },
  {
    id: '3326150007',
    districtId: '3326150',
    name: 'Dadirejo',
  },
  {
    id: '3326150008',
    districtId: '3326150',
    name: 'Sidorejo',
  },
  {
    id: '3326150010',
    districtId: '3326150',
    name: 'Tanjung',
  },
  {
    id: '3326150011',
    districtId: '3326150',
    name: 'Samborejo',
  },
  {
    id: '3326150012',
    districtId: '3326150',
    name: 'Pacar',
  },
  {
    id: '3326150013',
    districtId: '3326150',
    name: 'Karangjompo',
  },
  {
    id: '3326150014',
    districtId: '3326150',
    name: 'Tegaldowo',
  },
  {
    id: '3326150015',
    districtId: '3326150',
    name: 'Mulyorejo',
  },
  {
    id: '3326150016',
    districtId: '3326150',
    name: 'Jeruksari',
  },
  {
    id: '3326160001',
    districtId: '3326160',
    name: 'Kadipaten',
  },
  {
    id: '3326160002',
    districtId: '3326160',
    name: 'Delegtukang',
  },
  {
    id: '3326160003',
    districtId: '3326160',
    name: 'Karangjati',
  },
  {
    id: '3326160004',
    districtId: '3326160',
    name: 'Petukangan',
  },
  {
    id: '3326160005',
    districtId: '3326160',
    name: 'Wiradesa',
  },
  {
    id: '3326160006',
    districtId: '3326160',
    name: 'Warukidul',
  },
  {
    id: '3326160007',
    districtId: '3326160',
    name: 'Bondansari',
  },
  {
    id: '3326160008',
    districtId: '3326160',
    name: 'Warulor',
  },
  {
    id: '3326160009',
    districtId: '3326160',
    name: 'Kampil',
  },
  {
    id: '3326160010',
    districtId: '3326160',
    name: 'Gumawang',
  },
  {
    id: '3326160011',
    districtId: '3326160',
    name: 'Kepatihan',
  },
  {
    id: '3326160012',
    districtId: '3326160',
    name: 'Mayangan',
  },
  {
    id: '3326160018',
    districtId: '3326160',
    name: 'Kemplong',
  },
  {
    id: '3326160019',
    districtId: '3326160',
    name: 'Kauman',
  },
  {
    id: '3326161001',
    districtId: '3326161',
    name: 'Werdi',
  },
  {
    id: '3326161002',
    districtId: '3326161',
    name: 'Rowoyoso',
  },
  {
    id: '3326161004',
    districtId: '3326161',
    name: 'Wonokerto Wetan',
  },
  {
    id: '3326161005',
    districtId: '3326161',
    name: 'Sijambe',
  },
  {
    id: '3326161006',
    districtId: '3326161',
    name: 'Pesanggrahan',
  },
  {
    id: '3326161007',
    districtId: '3326161',
    name: 'Pecakaran',
  },
  {
    id: '3326161008',
    districtId: '3326161',
    name: 'Api-Api',
  },
  {
    id: '3326161009',
    districtId: '3326161',
    name: 'Wonokerto Kulon',
  },
  {
    id: '3326161010',
    districtId: '3326161',
    name: 'Tratebang',
  },
  {
    id: '3327010001',
    districtId: '3327010',
    name: 'Plakaran',
  },
  {
    id: '3327010002',
    districtId: '3327010',
    name: 'Mandiraja',
  },
  {
    id: '3327010003',
    districtId: '3327010',
    name: 'Walangsanga',
  },
  {
    id: '3327010004',
    districtId: '3327010',
    name: 'Sima',
  },
  {
    id: '3327010005',
    districtId: '3327010',
    name: 'Banyumudal',
  },
  {
    id: '3327010006',
    districtId: '3327010',
    name: 'Moga',
  },
  {
    id: '3327010007',
    districtId: '3327010',
    name: 'Wangkelang',
  },
  {
    id: '3327010008',
    districtId: '3327010',
    name: 'Kebanggan',
  },
  {
    id: '3327010009',
    districtId: '3327010',
    name: 'Pepedan',
  },
  {
    id: '3327010010',
    districtId: '3327010',
    name: 'Gendowang',
  },
  {
    id: '3327011001',
    districtId: '3327011',
    name: 'Pakembaran',
  },
  {
    id: '3327011002',
    districtId: '3327011',
    name: 'Warungpring',
  },
  {
    id: '3327011003',
    districtId: '3327011',
    name: 'Karangdawa',
  },
  {
    id: '3327011004',
    districtId: '3327011',
    name: 'Datar',
  },
  {
    id: '3327011005',
    districtId: '3327011',
    name: 'Cibuyur',
  },
  {
    id: '3327020001',
    districtId: '3327020',
    name: 'Clekatakan',
  },
  {
    id: '3327020002',
    districtId: '3327020',
    name: 'Batursari',
  },
  {
    id: '3327020003',
    districtId: '3327020',
    name: 'Penakir',
  },
  {
    id: '3327020004',
    districtId: '3327020',
    name: 'Gunungsari',
  },
  {
    id: '3327020005',
    districtId: '3327020',
    name: 'Jurangmangu',
  },
  {
    id: '3327020006',
    districtId: '3327020',
    name: 'Gambuhan',
  },
  {
    id: '3327020007',
    districtId: '3327020',
    name: 'Karangsari',
  },
  {
    id: '3327020008',
    districtId: '3327020',
    name: 'Nyalembeng',
  },
  {
    id: '3327020009',
    districtId: '3327020',
    name: 'Pulosari',
  },
  {
    id: '3327020010',
    districtId: '3327020',
    name: 'Pagenteran',
  },
  {
    id: '3327020011',
    districtId: '3327020',
    name: 'Siremeng',
  },
  {
    id: '3327020012',
    districtId: '3327020',
    name: 'Cikendung',
  },
  {
    id: '3327030001',
    districtId: '3327030',
    name: 'Gombong',
  },
  {
    id: '3327030002',
    districtId: '3327030',
    name: 'Belik',
  },
  {
    id: '3327030003',
    districtId: '3327030',
    name: 'Gunungtiga',
  },
  {
    id: '3327030004',
    districtId: '3327030',
    name: 'Kuta',
  },
  {
    id: '3327030005',
    districtId: '3327030',
    name: 'Badak',
  },
  {
    id: '3327030006',
    districtId: '3327030',
    name: 'Gunungjaya',
  },
  {
    id: '3327030007',
    districtId: '3327030',
    name: 'Simpur',
  },
  {
    id: '3327030010',
    districtId: '3327030',
    name: 'Bulakan',
  },
  {
    id: '3327030011',
    districtId: '3327030',
    name: 'Sikasur',
  },
  {
    id: '3327030012',
    districtId: '3327030',
    name: 'Kalisaleh',
  },
  {
    id: '3327040001',
    districtId: '3327040',
    name: 'Tundagan',
  },
  {
    id: '3327040002',
    districtId: '3327040',
    name: 'Tlagasana',
  },
  {
    id: '3327040003',
    districtId: '3327040',
    name: 'Bongas',
  },
  {
    id: '3327040004',
    districtId: '3327040',
    name: 'Cikadu',
  },
  {
    id: '3327040005',
    districtId: '3327040',
    name: 'Cawet',
  },
  {
    id: '3327040006',
    districtId: '3327040',
    name: 'Medayu',
  },
  {
    id: '3327040007',
    districtId: '3327040',
    name: 'Pagelaran',
  },
  {
    id: '3327040008',
    districtId: '3327040',
    name: 'Bodas',
  },
  {
    id: '3327040009',
    districtId: '3327040',
    name: 'Jojogan',
  },
  {
    id: '3327040010',
    districtId: '3327040',
    name: 'Majalangu',
  },
  {
    id: '3327040011',
    districtId: '3327040',
    name: 'Tambi',
  },
  {
    id: '3327040012',
    districtId: '3327040',
    name: 'Watukumpul',
  },
  {
    id: '3327040013',
    districtId: '3327040',
    name: 'Gapura',
  },
  {
    id: '3327040014',
    districtId: '3327040',
    name: 'Majakerta',
  },
  {
    id: '3327040015',
    districtId: '3327040',
    name: 'Wisnu',
  },
  {
    id: '3327050001',
    districtId: '3327050',
    name: 'Longkeyang',
  },
  {
    id: '3327050002',
    districtId: '3327050',
    name: 'Jatingarang',
  },
  {
    id: '3327050003',
    districtId: '3327050',
    name: 'Gunungbatu',
  },
  {
    id: '3327050004',
    districtId: '3327050',
    name: 'Pasir',
  },
  {
    id: '3327050005',
    districtId: '3327050',
    name: 'Kwasen',
  },
  {
    id: '3327050006',
    districtId: '3327050',
    name: 'Jatiroyom',
  },
  {
    id: '3327050007',
    districtId: '3327050',
    name: 'Parunggalih',
  },
  {
    id: '3327050008',
    districtId: '3327050',
    name: 'Payung',
  },
  {
    id: '3327050009',
    districtId: '3327050',
    name: 'Cangak',
  },
  {
    id: '3327050010',
    districtId: '3327050',
    name: 'Kebandungan',
  },
  {
    id: '3327050011',
    districtId: '3327050',
    name: 'Kesesirejo',
  },
  {
    id: '3327050012',
    districtId: '3327050',
    name: 'Babakan',
  },
  {
    id: '3327050013',
    districtId: '3327050',
    name: 'Karangbrai',
  },
  {
    id: '3327050014',
    districtId: '3327050',
    name: 'Jraganan',
  },
  {
    id: '3327050015',
    districtId: '3327050',
    name: 'Kebandaran',
  },
  {
    id: '3327050016',
    districtId: '3327050',
    name: 'Bodeh',
  },
  {
    id: '3327050017',
    districtId: '3327050',
    name: 'Muncang',
  },
  {
    id: '3327050018',
    districtId: '3327050',
    name: 'Kelangdepok',
  },
  {
    id: '3327050019',
    districtId: '3327050',
    name: 'Pendowo',
  },
  {
    id: '3327060001',
    districtId: '3327060',
    name: 'Sumurkidang',
  },
  {
    id: '3327060002',
    districtId: '3327060',
    name: 'Wanarata',
  },
  {
    id: '3327060003',
    districtId: '3327060',
    name: 'Pedagung',
  },
  {
    id: '3327060005',
    districtId: '3327060',
    name: 'Banjarsari',
  },
  {
    id: '3327060006',
    districtId: '3327060',
    name: 'Pegiringan',
  },
  {
    id: '3327060007',
    districtId: '3327060',
    name: 'Karanganyar',
  },
  {
    id: '3327060008',
    districtId: '3327060',
    name: 'Purana',
  },
  {
    id: '3327060009',
    districtId: '3327060',
    name: 'Pabuaran',
  },
  {
    id: '3327060010',
    districtId: '3327060',
    name: 'Sarwodadi',
  },
  {
    id: '3327060011',
    districtId: '3327060',
    name: 'Bantarbolang',
  },
  {
    id: '3327060012',
    districtId: '3327060',
    name: 'Sambeng',
  },
  {
    id: '3327060013',
    districtId: '3327060',
    name: 'Glandang',
  },
  {
    id: '3327060014',
    districtId: '3327060',
    name: 'Kuta',
  },
  {
    id: '3327060015',
    districtId: '3327060',
    name: 'Kebon Gede',
  },
  {
    id: '3327060016',
    districtId: '3327060',
    name: 'Paguyangan',
  },
  {
    id: '3327060017',
    districtId: '3327060',
    name: 'Lenggerong',
  },
  {
    id: '3327070001',
    districtId: '3327070',
    name: 'Kecepit',
  },
  {
    id: '3327070002',
    districtId: '3327070',
    name: 'Gembyang',
  },
  {
    id: '3327070003',
    districtId: '3327070',
    name: 'Mejagong',
  },
  {
    id: '3327070004',
    districtId: '3327070',
    name: 'Penusupan',
  },
  {
    id: '3327070005',
    districtId: '3327070',
    name: 'Banjaranyar',
  },
  {
    id: '3327070006',
    districtId: '3327070',
    name: 'Randudongkal',
  },
  {
    id: '3327070007',
    districtId: '3327070',
    name: 'Karangmoncol',
  },
  {
    id: '3327070008',
    districtId: '3327070',
    name: 'Semingkir',
  },
  {
    id: '3327070009',
    districtId: '3327070',
    name: 'Semaya',
  },
  {
    id: '3327070010',
    districtId: '3327070',
    name: 'Tanahbaya',
  },
  {
    id: '3327070011',
    districtId: '3327070',
    name: 'Lodaya',
  },
  {
    id: '3327070013',
    districtId: '3327070',
    name: 'Kreyo',
  },
  {
    id: '3327070014',
    districtId: '3327070',
    name: 'Kalimas',
  },
  {
    id: '3327070015',
    districtId: '3327070',
    name: 'Mangli',
  },
  {
    id: '3327070016',
    districtId: '3327070',
    name: 'Kalitorong',
  },
  {
    id: '3327070018',
    districtId: '3327070',
    name: 'Gongseng',
  },
  {
    id: '3327080001',
    districtId: '3327080',
    name: 'Banjarmulya',
  },
  {
    id: '3327080002',
    districtId: '3327080',
    name: 'Surajaya',
  },
  {
    id: '3327080003',
    districtId: '3327080',
    name: 'Pagongsoran',
  },
  {
    id: '3327080004',
    districtId: '3327080',
    name: 'Sungapan',
  },
  {
    id: '3327080005',
    districtId: '3327080',
    name: 'Paduraksa',
  },
  {
    id: '3327080006',
    districtId: '3327080',
    name: 'Kramat',
  },
  {
    id: '3327080007',
    districtId: '3327080',
    name: 'Wanamulya',
  },
  {
    id: '3327080008',
    districtId: '3327080',
    name: 'Mengori',
  },
  {
    id: '3327080009',
    districtId: '3327080',
    name: 'Sewaka',
  },
  {
    id: '3327080010',
    districtId: '3327080',
    name: 'Saradan',
  },
  {
    id: '3327080011',
    districtId: '3327080',
    name: 'Bojongbata',
  },
  {
    id: '3327080012',
    districtId: '3327080',
    name: 'Bojongnangka',
  },
  {
    id: '3327080013',
    districtId: '3327080',
    name: 'Tambakrejo',
  },
  {
    id: '3327080014',
    districtId: '3327080',
    name: 'Kebondalem',
  },
  {
    id: '3327080015',
    districtId: '3327080',
    name: 'Mulyoharjo',
  },
  {
    id: '3327080016',
    districtId: '3327080',
    name: 'Pelutan',
  },
  {
    id: '3327080017',
    districtId: '3327080',
    name: 'Lawangrejo',
  },
  {
    id: '3327080018',
    districtId: '3327080',
    name: 'Sugihwaras',
  },
  {
    id: '3327080019',
    districtId: '3327080',
    name: 'Widuri',
  },
  {
    id: '3327080020',
    districtId: '3327080',
    name: 'Danasari',
  },
  {
    id: '3327090001',
    districtId: '3327090',
    name: 'Penggarit',
  },
  {
    id: '3327090003',
    districtId: '3327090',
    name: 'Gondang',
  },
  {
    id: '3327090004',
    districtId: '3327090',
    name: 'Jrakah',
  },
  {
    id: '3327090005',
    districtId: '3327090',
    name: 'Sokawangi',
  },
  {
    id: '3327090006',
    districtId: '3327090',
    name: 'Kejambon',
  },
  {
    id: '3327090007',
    districtId: '3327090',
    name: 'Jebed Selatan',
  },
  {
    id: '3327090008',
    districtId: '3327090',
    name: 'Jebed Utara',
  },
  {
    id: '3327090009',
    districtId: '3327090',
    name: 'Cibelok',
  },
  {
    id: '3327090010',
    districtId: '3327090',
    name: 'Kaligelang',
  },
  {
    id: '3327090011',
    districtId: '3327090',
    name: 'Banjardawa',
  },
  {
    id: '3327090012',
    districtId: '3327090',
    name: 'Banjaran',
  },
  {
    id: '3327090013',
    districtId: '3327090',
    name: 'Sitemu',
  },
  {
    id: '3327090014',
    districtId: '3327090',
    name: 'Pedurungan',
  },
  {
    id: '3327090015',
    districtId: '3327090',
    name: 'Taman',
  },
  {
    id: '3327090016',
    districtId: '3327090',
    name: 'Wanarejan Selatan',
  },
  {
    id: '3327090017',
    districtId: '3327090',
    name: 'Wanarejan Utara',
  },
  {
    id: '3327090018',
    districtId: '3327090',
    name: 'Beji',
  },
  {
    id: '3327090019',
    districtId: '3327090',
    name: 'Kabunan',
  },
  {
    id: '3327090020',
    districtId: '3327090',
    name: 'Asemdoyong',
  },
  {
    id: '3327090021',
    districtId: '3327090',
    name: 'Kedungbanjar',
  },
  {
    id: '3327100001',
    districtId: '3327100',
    name: 'Kendalsari',
  },
  {
    id: '3327100002',
    districtId: '3327100',
    name: 'Widodaren',
  },
  {
    id: '3327100003',
    districtId: '3327100',
    name: 'Karangasem',
  },
  {
    id: '3327100004',
    districtId: '3327100',
    name: 'Petanjungan',
  },
  {
    id: '3327100005',
    districtId: '3327100',
    name: 'Sirangkang',
  },
  {
    id: '3327100006',
    districtId: '3327100',
    name: 'Iser',
  },
  {
    id: '3327100007',
    districtId: '3327100',
    name: 'Serang',
  },
  {
    id: '3327100008',
    districtId: '3327100',
    name: 'Petarukan',
  },
  {
    id: '3327100009',
    districtId: '3327100',
    name: 'Kalirandu',
  },
  {
    id: '3327100011',
    districtId: '3327100',
    name: 'Panjunan',
  },
  {
    id: '3327100012',
    districtId: '3327100',
    name: 'Temuireng',
  },
  {
    id: '3327100013',
    districtId: '3327100',
    name: 'Pegundan',
  },
  {
    id: '3327100015',
    districtId: '3327100',
    name: 'Tegalmlati',
  },
  {
    id: '3327100016',
    districtId: '3327100',
    name: 'Loning',
  },
  {
    id: '3327100017',
    districtId: '3327100',
    name: 'Nyamplung Sari',
  },
  {
    id: '3327100018',
    districtId: '3327100',
    name: 'Klareyan',
  },
  {
    id: '3327100019',
    districtId: '3327100',
    name: 'Kendaldoyong',
  },
  {
    id: '3327100020',
    districtId: '3327100',
    name: 'Kendalrejo',
  },
  {
    id: '3327110001',
    districtId: '3327110',
    name: 'Sokawati',
  },
  {
    id: '3327110002',
    districtId: '3327110',
    name: 'Tegalsari Barat',
  },
  {
    id: '3327110003',
    districtId: '3327110',
    name: 'Tegalsari Timur',
  },
  {
    id: '3327110004',
    districtId: '3327110',
    name: 'Kemuning',
  },
  {
    id: '3327110005',
    districtId: '3327110',
    name: 'Karangtalok',
  },
  {
    id: '3327110006',
    districtId: '3327110',
    name: 'Wonogiri',
  },
  {
    id: '3327110007',
    districtId: '3327110',
    name: 'Blimbing',
  },
  {
    id: '3327110008',
    districtId: '3327110',
    name: 'Ampelgading',
  },
  {
    id: '3327110009',
    districtId: '3327110',
    name: 'Cibiyuk',
  },
  {
    id: '3327110010',
    districtId: '3327110',
    name: 'Karangtengah',
  },
  {
    id: '3327110011',
    districtId: '3327110',
    name: 'Banglarangan',
  },
  {
    id: '3327110012',
    districtId: '3327110',
    name: 'Losari',
  },
  {
    id: '3327110014',
    districtId: '3327110',
    name: 'Jatirejo',
  },
  {
    id: '3327110015',
    districtId: '3327110',
    name: 'Kebagusan',
  },
  {
    id: '3327110016',
    districtId: '3327110',
    name: 'Sidokare',
  },
  {
    id: '3327120001',
    districtId: '3327120',
    name: 'Tumbal',
  },
  {
    id: '3327120002',
    districtId: '3327120',
    name: 'Pecangakan',
  },
  {
    id: '3327120003',
    districtId: '3327120',
    name: 'Sikayu',
  },
  {
    id: '3327120004',
    districtId: '3327120',
    name: 'Purwosari',
  },
  {
    id: '3327120005',
    districtId: '3327120',
    name: 'Purwoharjo',
  },
  {
    id: '3327120006',
    districtId: '3327120',
    name: 'Kauman',
  },
  {
    id: '3327120007',
    districtId: '3327120',
    name: 'Sidorejo',
  },
  {
    id: '3327120008',
    districtId: '3327120',
    name: 'Lowa',
  },
  {
    id: '3327120009',
    districtId: '3327120',
    name: 'Ambokulon',
  },
  {
    id: '3327120011',
    districtId: '3327120',
    name: 'Gintung',
  },
  {
    id: '3327120012',
    districtId: '3327120',
    name: 'Gandu',
  },
  {
    id: '3327120013',
    districtId: '3327120',
    name: 'Sarwodadi',
  },
  {
    id: '3327120014',
    districtId: '3327120',
    name: 'Susukan',
  },
  {
    id: '3327120016',
    districtId: '3327120',
    name: 'Wonokromo',
  },
  {
    id: '3327120017',
    districtId: '3327120',
    name: 'Kebojongan',
  },
  {
    id: '3327120018',
    districtId: '3327120',
    name: 'Kandang',
  },
  {
    id: '3327130001',
    districtId: '3327130',
    name: 'Sukorejo',
  },
  {
    id: '3327130002',
    districtId: '3327130',
    name: 'Botekan',
  },
  {
    id: '3327130003',
    districtId: '3327130',
    name: 'Rowosari',
  },
  {
    id: '3327130004',
    districtId: '3327130',
    name: 'Ambowetan',
  },
  {
    id: '3327130005',
    districtId: '3327130',
    name: 'Pagergunung',
  },
  {
    id: '3327130006',
    districtId: '3327130',
    name: 'Wiyorowetan',
  },
  {
    id: '3327130007',
    districtId: '3327130',
    name: 'Samong',
  },
  {
    id: '3327130008',
    districtId: '3327130',
    name: 'Tasikrejo',
  },
  {
    id: '3327130009',
    districtId: '3327130',
    name: 'Bumirejo',
  },
  {
    id: '3327130010',
    districtId: '3327130',
    name: 'Kaliprau',
  },
  {
    id: '3327130011',
    districtId: '3327130',
    name: 'Kertosari',
  },
  {
    id: '3327130012',
    districtId: '3327130',
    name: 'Pamutih',
  },
  {
    id: '3327130013',
    districtId: '3327130',
    name: 'Padek',
  },
  {
    id: '3327130015',
    districtId: '3327130',
    name: 'Ketapang',
  },
  {
    id: '3327130016',
    districtId: '3327130',
    name: 'Limbangan',
  },
  {
    id: '3327130017',
    districtId: '3327130',
    name: 'Mojo',
  },
  {
    id: '3327130018',
    districtId: '3327130',
    name: 'Pesantren',
  },
  {
    id: '3328010001',
    districtId: '3328010',
    name: 'Prupuk Selatan',
  },
  {
    id: '3328010002',
    districtId: '3328010',
    name: 'Prupuk Utara',
  },
  {
    id: '3328010003',
    districtId: '3328010',
    name: 'Kaligayam',
  },
  {
    id: '3328010004',
    districtId: '3328010',
    name: 'Wanasari',
  },
  {
    id: '3328010005',
    districtId: '3328010',
    name: 'Danaraja',
  },
  {
    id: '3328010006',
    districtId: '3328010',
    name: 'Jembayat',
  },
  {
    id: '3328010007',
    districtId: '3328010',
    name: 'Margasari',
  },
  {
    id: '3328010008',
    districtId: '3328010',
    name: 'Dukuh Tengah',
  },
  {
    id: '3328010009',
    districtId: '3328010',
    name: 'Pakulaut',
  },
  {
    id: '3328010010',
    districtId: '3328010',
    name: 'Margaayu',
  },
  {
    id: '3328010011',
    districtId: '3328010',
    name: 'Kalisalak',
  },
  {
    id: '3328010012',
    districtId: '3328010',
    name: 'Karangdawa',
  },
  {
    id: '3328010013',
    districtId: '3328010',
    name: 'Jatilaba',
  },
  {
    id: '3328020001',
    districtId: '3328020',
    name: 'Cempaka',
  },
  {
    id: '3328020002',
    districtId: '3328020',
    name: 'Cintamanik',
  },
  {
    id: '3328020003',
    districtId: '3328020',
    name: 'Dukuhbenda',
  },
  {
    id: '3328020004',
    districtId: '3328020',
    name: 'Sigedong',
  },
  {
    id: '3328020005',
    districtId: '3328020',
    name: 'Guci',
  },
  {
    id: '3328020006',
    districtId: '3328020',
    name: 'Batumirah',
  },
  {
    id: '3328020007',
    districtId: '3328020',
    name: 'Begawat',
  },
  {
    id: '3328020008',
    districtId: '3328020',
    name: 'Gunung Agung',
  },
  {
    id: '3328020010',
    districtId: '3328020',
    name: 'Muncanglarang',
  },
  {
    id: '3328020011',
    districtId: '3328020',
    name: 'Bumijawa',
  },
  {
    id: '3328020012',
    districtId: '3328020',
    name: 'Traju',
  },
  {
    id: '3328020013',
    districtId: '3328020',
    name: 'Pagerkasih',
  },
  {
    id: '3328020014',
    districtId: '3328020',
    name: 'Cawitali',
  },
  {
    id: '3328020015',
    districtId: '3328020',
    name: 'Carul',
  },
  {
    id: '3328020016',
    districtId: '3328020',
    name: 'Sumbaga',
  },
  {
    id: '3328020017',
    districtId: '3328020',
    name: 'Sokatengah',
  },
  {
    id: '3328020018',
    districtId: '3328020',
    name: 'Sokasari',
  },
  {
    id: '3328030002',
    districtId: '3328030',
    name: 'Dukuhtengah',
  },
  {
    id: '3328030003',
    districtId: '3328030',
    name: 'Kedawung',
  },
  {
    id: '3328030004',
    districtId: '3328030',
    name: 'Suniarsih',
  },
  {
    id: '3328030005',
    districtId: '3328030',
    name: 'Karangmulyo',
  },
  {
    id: '3328030007',
    districtId: '3328030',
    name: 'Bojong',
  },
  {
    id: '3328030008',
    districtId: '3328030',
    name: 'Buniwah',
  },
  {
    id: '3328030009',
    districtId: '3328030',
    name: 'Lengkong',
  },
  {
    id: '3328030010',
    districtId: '3328030',
    name: 'Batunyana',
  },
  {
    id: '3328030011',
    districtId: '3328030',
    name: 'Sangkanayu',
  },
  {
    id: '3328030012',
    districtId: '3328030',
    name: 'Gunungjati',
  },
  {
    id: '3328030013',
    districtId: '3328030',
    name: 'Pucangluwuk',
  },
  {
    id: '3328030014',
    districtId: '3328030',
    name: 'Kajenengan',
  },
  {
    id: '3328030015',
    districtId: '3328030',
    name: 'Kalijambu',
  },
  {
    id: '3328030016',
    districtId: '3328030',
    name: 'Danasari',
  },
  {
    id: '3328030017',
    districtId: '3328030',
    name: 'Cikura',
  },
  {
    id: '3328040001',
    districtId: '3328040',
    name: 'Cenggini',
  },
  {
    id: '3328040002',
    districtId: '3328040',
    name: 'Bukateja',
  },
  {
    id: '3328040003',
    districtId: '3328040',
    name: 'Kalibakung',
  },
  {
    id: '3328040004',
    districtId: '3328040',
    name: 'Karangjambu',
  },
  {
    id: '3328040005',
    districtId: '3328040',
    name: 'Cilongok',
  },
  {
    id: '3328040006',
    districtId: '3328040',
    name: 'Tembongwah',
  },
  {
    id: '3328040007',
    districtId: '3328040',
    name: 'Danareja',
  },
  {
    id: '3328040008',
    districtId: '3328040',
    name: 'Sangkanjaya',
  },
  {
    id: '3328040009',
    districtId: '3328040',
    name: 'Danawarih',
  },
  {
    id: '3328040010',
    districtId: '3328040',
    name: 'Pagerwangi',
  },
  {
    id: '3328040011',
    districtId: '3328040',
    name: 'Harjowinangun',
  },
  {
    id: '3328040012',
    districtId: '3328040',
    name: 'Batuagung',
  },
  {
    id: '3328040013',
    districtId: '3328040',
    name: 'Kaliwungu',
  },
  {
    id: '3328040014',
    districtId: '3328040',
    name: 'Banjar Anyar',
  },
  {
    id: '3328040015',
    districtId: '3328040',
    name: 'Sesepan',
  },
  {
    id: '3328040016',
    districtId: '3328040',
    name: 'Wringin Jenggot',
  },
  {
    id: '3328040017',
    districtId: '3328040',
    name: 'Pamiritan',
  },
  {
    id: '3328040018',
    districtId: '3328040',
    name: 'Balapulang Wetan',
  },
  {
    id: '3328040019',
    districtId: '3328040',
    name: 'Balapulang Kulon',
  },
  {
    id: '3328040020',
    districtId: '3328040',
    name: 'Cibunar',
  },
  {
    id: '3328050002',
    districtId: '3328050',
    name: 'Rajegwesi',
  },
  {
    id: '3328050003',
    districtId: '3328050',
    name: 'Sido Mulyo',
  },
  {
    id: '3328050004',
    districtId: '3328050',
    name: 'Mulyoharjo',
  },
  {
    id: '3328050005',
    districtId: '3328050',
    name: 'Semboja',
  },
  {
    id: '3328050006',
    districtId: '3328050',
    name: 'Randusari',
  },
  {
    id: '3328050007',
    districtId: '3328050',
    name: 'Jatiwangi',
  },
  {
    id: '3328050008',
    districtId: '3328050',
    name: 'Pagerbarang',
  },
  {
    id: '3328050009',
    districtId: '3328050',
    name: 'Karanganyar',
  },
  {
    id: '3328050010',
    districtId: '3328050',
    name: 'Kertaharja',
  },
  {
    id: '3328050011',
    districtId: '3328050',
    name: 'Kedungsugih',
  },
  {
    id: '3328050012',
    districtId: '3328050',
    name: 'Surokidul',
  },
  {
    id: '3328050013',
    districtId: '3328050',
    name: 'Pesarean',
  },
  {
    id: '3328060001',
    districtId: '3328060',
    name: 'Timbangreja',
  },
  {
    id: '3328060002',
    districtId: '3328060',
    name: 'Yamansari',
  },
  {
    id: '3328060003',
    districtId: '3328060',
    name: 'Lebaksiu Kidul',
  },
  {
    id: '3328060004',
    districtId: '3328060',
    name: 'Lebaksiu Lor',
  },
  {
    id: '3328060005',
    districtId: '3328060',
    name: 'Kajen',
  },
  {
    id: '3328060006',
    districtId: '3328060',
    name: 'Dukuhlo',
  },
  {
    id: '3328060007',
    districtId: '3328060',
    name: 'Pendawa',
  },
  {
    id: '3328060008',
    districtId: '3328060',
    name: 'Jatimulyo',
  },
  {
    id: '3328060009',
    districtId: '3328060',
    name: 'Lebak Goah',
  },
  {
    id: '3328060011',
    districtId: '3328060',
    name: 'Balaradin',
  },
  {
    id: '3328060012',
    districtId: '3328060',
    name: 'Kambangan',
  },
  {
    id: '3328060013',
    districtId: '3328060',
    name: 'Tegalandong',
  },
  {
    id: '3328060014',
    districtId: '3328060',
    name: 'Dukuhdamu',
  },
  {
    id: '3328060015',
    districtId: '3328060',
    name: 'Slarang Kidul',
  },
  {
    id: '3328070002',
    districtId: '3328070',
    name: 'Mokaha',
  },
  {
    id: '3328070003',
    districtId: '3328070',
    name: 'Penyalahan',
  },
  {
    id: '3328070004',
    districtId: '3328070',
    name: 'Sitail',
  },
  {
    id: '3328070005',
    districtId: '3328070',
    name: 'Sumbarang',
  },
  {
    id: '3328070006',
    districtId: '3328070',
    name: 'Cerih',
  },
  {
    id: '3328070007',
    districtId: '3328070',
    name: 'Gantungan',
  },
  {
    id: '3328070008',
    districtId: '3328070',
    name: 'Argatawang',
  },
  {
    id: '3328070009',
    districtId: '3328070',
    name: 'Padasari',
  },
  {
    id: '3328070010',
    districtId: '3328070',
    name: 'Capar',
  },
  {
    id: '3328070011',
    districtId: '3328070',
    name: 'Lebakwangi',
  },
  {
    id: '3328070012',
    districtId: '3328070',
    name: 'Dukuhbangsa',
  },
  {
    id: '3328070013',
    districtId: '3328070',
    name: 'Jatinegara',
  },
  {
    id: '3328070014',
    districtId: '3328070',
    name: 'Luwijawa',
  },
  {
    id: '3328070015',
    districtId: '3328070',
    name: 'Lembasari',
  },
  {
    id: '3328070016',
    districtId: '3328070',
    name: 'Tamansari',
  },
  {
    id: '3328070017',
    districtId: '3328070',
    name: 'Wotgalih',
  },
  {
    id: '3328080001',
    districtId: '3328080',
    name: 'Penujah',
  },
  {
    id: '3328080002',
    districtId: '3328080',
    name: 'Karang Anyar',
  },
  {
    id: '3328080003',
    districtId: '3328080',
    name: 'Tonggara',
  },
  {
    id: '3328080004',
    districtId: '3328080',
    name: 'Kedungbanteng',
  },
  {
    id: '3328080005',
    districtId: '3328080',
    name: 'Dukuhjati Wetan',
  },
  {
    id: '3328080006',
    districtId: '3328080',
    name: 'Sumingkir',
  },
  {
    id: '3328080007',
    districtId: '3328080',
    name: 'Margamulya',
  },
  {
    id: '3328080008',
    districtId: '3328080',
    name: 'Kebandingan',
  },
  {
    id: '3328080009',
    districtId: '3328080',
    name: 'Karangmalang',
  },
  {
    id: '3328080010',
    districtId: '3328080',
    name: 'Semedo',
  },
  {
    id: '3328090002',
    districtId: '3328090',
    name: 'Dermasuci',
  },
  {
    id: '3328090003',
    districtId: '3328090',
    name: 'Dukuhjati Kidul',
  },
  {
    id: '3328090004',
    districtId: '3328090',
    name: 'Depok',
  },
  {
    id: '3328090005',
    districtId: '3328090',
    name: 'Penusupan',
  },
  {
    id: '3328090006',
    districtId: '3328090',
    name: 'Bogares Kidul',
  },
  {
    id: '3328090007',
    districtId: '3328090',
    name: 'Bogares Lor',
  },
  {
    id: '3328090008',
    districtId: '3328090',
    name: 'Pangkah',
  },
  {
    id: '3328090011',
    districtId: '3328090',
    name: 'Kendalserut',
  },
  {
    id: '3328090012',
    districtId: '3328090',
    name: 'Grobog Kulon',
  },
  {
    id: '3328090013',
    districtId: '3328090',
    name: 'Grobog Wetan',
  },
  {
    id: '3328090014',
    districtId: '3328090',
    name: 'Talok',
  },
  {
    id: '3328090015',
    districtId: '3328090',
    name: 'Paketiban',
  },
  {
    id: '3328090016',
    districtId: '3328090',
    name: 'Rancawiru',
  },
  {
    id: '3328090017',
    districtId: '3328090',
    name: 'Balamoa',
  },
  {
    id: '3328090018',
    districtId: '3328090',
    name: 'Dermasandi',
  },
  {
    id: '3328090019',
    districtId: '3328090',
    name: 'Purbayasa',
  },
  {
    id: '3328090020',
    districtId: '3328090',
    name: 'Jenggawur',
  },
  {
    id: '3328090021',
    districtId: '3328090',
    name: 'Kalikangkung',
  },
  {
    id: '3328090022',
    districtId: '3328090',
    name: 'Pecabean',
  },
  {
    id: '3328100001',
    districtId: '3328100',
    name: 'Kalisapu',
  },
  {
    id: '3328100002',
    districtId: '3328100',
    name: 'Dukuh Ringin',
  },
  {
    id: '3328100003',
    districtId: '3328100',
    name: 'Dukuh Salam',
  },
  {
    id: '3328100004',
    districtId: '3328100',
    name: 'Slawi Kulon',
  },
  {
    id: '3328100005',
    districtId: '3328100',
    name: 'Slawi Wetan',
  },
  {
    id: '3328100006',
    districtId: '3328100',
    name: 'Kagok',
  },
  {
    id: '3328100007',
    districtId: '3328100',
    name: 'Procot',
  },
  {
    id: '3328100008',
    districtId: '3328100',
    name: 'Kudaile',
  },
  {
    id: '3328100009',
    districtId: '3328100',
    name: 'Trayeman',
  },
  {
    id: '3328100010',
    districtId: '3328100',
    name: 'Pakembaran',
  },
  {
    id: '3328110001',
    districtId: '3328110',
    name: 'Slarang Lor',
  },
  {
    id: '3328110002',
    districtId: '3328110',
    name: 'Selapura',
  },
  {
    id: '3328110004',
    districtId: '3328110',
    name: 'Dukuhwaru',
  },
  {
    id: '3328110005',
    districtId: '3328110',
    name: 'Gumayun',
  },
  {
    id: '3328110006',
    districtId: '3328110',
    name: 'Kabunan',
  },
  {
    id: '3328110007',
    districtId: '3328110',
    name: 'Pedagangan',
  },
  {
    id: '3328110008',
    districtId: '3328110',
    name: 'Kalisoka',
  },
  {
    id: '3328110009',
    districtId: '3328110',
    name: 'Sindang',
  },
  {
    id: '3328110010',
    districtId: '3328110',
    name: 'Bulakpacing',
  },
  {
    id: '3328120001',
    districtId: '3328120',
    name: 'Pedeslohor',
  },
  {
    id: '3328120002',
    districtId: '3328120',
    name: 'Lumingser',
  },
  {
    id: '3328120004',
    districtId: '3328120',
    name: 'Pagiyanten',
  },
  {
    id: '3328120005',
    districtId: '3328120',
    name: 'Penarukan',
  },
  {
    id: '3328120006',
    districtId: '3328120',
    name: 'Harjosari Lor',
  },
  {
    id: '3328120007',
    districtId: '3328120',
    name: 'Harjosari Kidul',
  },
  {
    id: '3328120008',
    districtId: '3328120',
    name: 'Tembok Lor',
  },
  {
    id: '3328120009',
    districtId: '3328120',
    name: 'Tembok Kidul',
  },
  {
    id: '3328120010',
    districtId: '3328120',
    name: 'Tembok Banjaran',
  },
  {
    id: '3328120011',
    districtId: '3328120',
    name: 'Tembok Luwung',
  },
  {
    id: '3328120012',
    districtId: '3328120',
    name: 'Adiwerna',
  },
  {
    id: '3328120013',
    districtId: '3328120',
    name: 'Kalimati',
  },
  {
    id: '3328120014',
    districtId: '3328120',
    name: 'Lemahduwur',
  },
  {
    id: '3328120015',
    districtId: '3328120',
    name: 'Pesarean',
  },
  {
    id: '3328120016',
    districtId: '3328120',
    name: 'Ujungrusi',
  },
  {
    id: '3328120017',
    districtId: '3328120',
    name: 'Pagedangan',
  },
  {
    id: '3328120018',
    districtId: '3328120',
    name: 'Kaliwadas',
  },
  {
    id: '3328120019',
    districtId: '3328120',
    name: 'Pecangakan',
  },
  {
    id: '3328120020',
    districtId: '3328120',
    name: 'Gumalar',
  },
  {
    id: '3328120021',
    districtId: '3328120',
    name: 'Bersole',
  },
  {
    id: '3328130001',
    districtId: '3328130',
    name: 'Ketanggungan',
  },
  {
    id: '3328130002',
    districtId: '3328130',
    name: 'Pengarasan',
  },
  {
    id: '3328130004',
    districtId: '3328130',
    name: 'Sidakaton',
  },
  {
    id: '3328130005',
    districtId: '3328130',
    name: 'Sidapurna',
  },
  {
    id: '3328130006',
    districtId: '3328130',
    name: 'Dukuhturi',
  },
  {
    id: '3328130007',
    districtId: '3328130',
    name: 'Lawatan',
  },
  {
    id: '3328130008',
    districtId: '3328130',
    name: 'Kepandean',
  },
  {
    id: '3328130009',
    districtId: '3328130',
    name: 'Pagongan',
  },
  {
    id: '3328130010',
    districtId: '3328130',
    name: 'Grogol',
  },
  {
    id: '3328130011',
    districtId: '3328130',
    name: 'Pepedan',
  },
  {
    id: '3328130012',
    districtId: '3328130',
    name: 'Debong Wetan',
  },
  {
    id: '3328130013',
    districtId: '3328130',
    name: 'Pekauman Kulon',
  },
  {
    id: '3328130014',
    districtId: '3328130',
    name: 'Karanganyar',
  },
  {
    id: '3328130015',
    districtId: '3328130',
    name: 'Bandasari',
  },
  {
    id: '3328130016',
    districtId: '3328130',
    name: 'Sutapranan',
  },
  {
    id: '3328130017',
    districtId: '3328130',
    name: 'Kademangaran',
  },
  {
    id: '3328130018',
    districtId: '3328130',
    name: 'Pengabean',
  },
  {
    id: '3328140001',
    districtId: '3328140',
    name: 'Pegirikan',
  },
  {
    id: '3328140002',
    districtId: '3328140',
    name: 'Pekiringan',
  },
  {
    id: '3328140003',
    districtId: '3328140',
    name: 'Gembong Kulon',
  },
  {
    id: '3328140004',
    districtId: '3328140',
    name: 'Pasangan',
  },
  {
    id: '3328140005',
    districtId: '3328140',
    name: 'Langgen',
  },
  {
    id: '3328140007',
    districtId: '3328140',
    name: 'Dukuhmalang',
  },
  {
    id: '3328140008',
    districtId: '3328140',
    name: 'Pesayangan',
  },
  {
    id: '3328140009',
    districtId: '3328140',
    name: 'Kajen',
  },
  {
    id: '3328140010',
    districtId: '3328140',
    name: 'Kebasen',
  },
  {
    id: '3328140011',
    districtId: '3328140',
    name: 'Tegalwangi',
  },
  {
    id: '3328140012',
    districtId: '3328140',
    name: 'Talang',
  },
  {
    id: '3328140013',
    districtId: '3328140',
    name: 'Kaligayam',
  },
  {
    id: '3328140014',
    districtId: '3328140',
    name: 'Kaladawa',
  },
  {
    id: '3328140015',
    districtId: '3328140',
    name: 'Cangkring',
  },
  {
    id: '3328140016',
    districtId: '3328140',
    name: 'Dawuhan',
  },
  {
    id: '3328140017',
    districtId: '3328140',
    name: 'Getaskerep',
  },
  {
    id: '3328140018',
    districtId: '3328140',
    name: 'Pacul',
  },
  {
    id: '3328140019',
    districtId: '3328140',
    name: 'Wangandawa',
  },
  {
    id: '3328150001',
    districtId: '3328150',
    name: 'Jatirawa',
  },
  {
    id: '3328150002',
    districtId: '3328150',
    name: 'Kabukan',
  },
  {
    id: '3328150004',
    districtId: '3328150',
    name: 'Purbasana',
  },
  {
    id: '3328150005',
    districtId: '3328150',
    name: 'Kemanggungan',
  },
  {
    id: '3328150006',
    districtId: '3328150',
    name: 'Karangmangu',
  },
  {
    id: '3328150008',
    districtId: '3328150',
    name: 'Brekat',
  },
  {
    id: '3328150009',
    districtId: '3328150',
    name: 'Karangjati',
  },
  {
    id: '3328150010',
    districtId: '3328150',
    name: 'Bulakwaru',
  },
  {
    id: '3328150011',
    districtId: '3328150',
    name: 'Mindaka',
  },
  {
    id: '3328150012',
    districtId: '3328150',
    name: 'Tarub',
  },
  {
    id: '3328150014',
    districtId: '3328150',
    name: 'Kedokan Sayang',
  },
  {
    id: '3328150015',
    districtId: '3328150',
    name: 'Bumiharja',
  },
  {
    id: '3328150016',
    districtId: '3328150',
    name: 'Kalijambe',
  },
  {
    id: '3328150017',
    districtId: '3328150',
    name: 'Mangunsaren',
  },
  {
    id: '3328150018',
    districtId: '3328150',
    name: 'Margapadang',
  },
  {
    id: '3328150019',
    districtId: '3328150',
    name: 'Kesamiran',
  },
  {
    id: '3328150020',
    districtId: '3328150',
    name: 'Kesadikan',
  },
  {
    id: '3328160001',
    districtId: '3328160',
    name: 'Mejasem Barat',
  },
  {
    id: '3328160002',
    districtId: '3328160',
    name: 'Mejasem Timur',
  },
  {
    id: '3328160003',
    districtId: '3328160',
    name: 'Dinuk',
  },
  {
    id: '3328160004',
    districtId: '3328160',
    name: 'Jatilawang',
  },
  {
    id: '3328160005',
    districtId: '3328160',
    name: 'Kemantran',
  },
  {
    id: '3328160006',
    districtId: '3328160',
    name: 'Babakan',
  },
  {
    id: '3328160007',
    districtId: '3328160',
    name: 'Kertaharja',
  },
  {
    id: '3328160008',
    districtId: '3328160',
    name: 'Ketileng',
  },
  {
    id: '3328160009',
    districtId: '3328160',
    name: 'Kepunduhan',
  },
  {
    id: '3328160010',
    districtId: '3328160',
    name: 'Bangun Galih',
  },
  {
    id: '3328160011',
    districtId: '3328160',
    name: 'Tanjungharja',
  },
  {
    id: '3328160012',
    districtId: '3328160',
    name: 'Kemuning',
  },
  {
    id: '3328160013',
    districtId: '3328160',
    name: 'Plumbungan',
  },
  {
    id: '3328160014',
    districtId: '3328160',
    name: 'Maribaya',
  },
  {
    id: '3328160015',
    districtId: '3328160',
    name: 'Kramat',
  },
  {
    id: '3328160016',
    districtId: '3328160',
    name: 'Kertayasa',
  },
  {
    id: '3328160017',
    districtId: '3328160',
    name: 'Bongkok',
  },
  {
    id: '3328160018',
    districtId: '3328160',
    name: 'Munjung Agung',
  },
  {
    id: '3328160019',
    districtId: '3328160',
    name: 'Padaharja',
  },
  {
    id: '3328160020',
    districtId: '3328160',
    name: 'Dampyak',
  },
  {
    id: '3328170001',
    districtId: '3328170',
    name: 'Karangwuluh',
  },
  {
    id: '3328170002',
    districtId: '3328170',
    name: 'Gembongdadi',
  },
  {
    id: '3328170003',
    districtId: '3328170',
    name: 'Karangmulya',
  },
  {
    id: '3328170004',
    districtId: '3328170',
    name: 'Harjasari',
  },
  {
    id: '3328170005',
    districtId: '3328170',
    name: 'Kertasari',
  },
  {
    id: '3328170006',
    districtId: '3328170',
    name: 'Jatimulya',
  },
  {
    id: '3328170007',
    districtId: '3328170',
    name: 'Jatibogor',
  },
  {
    id: '3328170008',
    districtId: '3328170',
    name: 'Sidoharjo',
  },
  {
    id: '3328170009',
    districtId: '3328170',
    name: 'Purwahamba',
  },
  {
    id: '3328170010',
    districtId: '3328170',
    name: 'Suradadi',
  },
  {
    id: '3328170011',
    districtId: '3328170',
    name: 'Bojongsana',
  },
  {
    id: '3328180001',
    districtId: '3328180',
    name: 'Kedungjati',
  },
  {
    id: '3328180002',
    districtId: '3328180',
    name: 'Sidomulyo',
  },
  {
    id: '3328180003',
    districtId: '3328180',
    name: 'Sigentong',
  },
  {
    id: '3328180004',
    districtId: '3328180',
    name: 'Kreman',
  },
  {
    id: '3328180005',
    districtId: '3328180',
    name: 'Kendayakan',
  },
  {
    id: '3328180006',
    districtId: '3328180',
    name: 'Sukareja',
  },
  {
    id: '3328180007',
    districtId: '3328180',
    name: 'Warureja',
  },
  {
    id: '3328180008',
    districtId: '3328180',
    name: 'Rangimulya',
  },
  {
    id: '3328180009',
    districtId: '3328180',
    name: 'Banjarturi',
  },
  {
    id: '3328180010',
    districtId: '3328180',
    name: 'Banjar Agung',
  },
  {
    id: '3328180011',
    districtId: '3328180',
    name: 'Kedungkelor',
  },
  {
    id: '3328180012',
    districtId: '3328180',
    name: 'Demangharjo',
  },
  {
    id: '3329010001',
    districtId: '3329010',
    name: 'Gunung Jaya',
  },
  {
    id: '3329010002',
    districtId: '3329010',
    name: 'Indrajaya',
  },
  {
    id: '3329010003',
    districtId: '3329010',
    name: 'Banjaran',
  },
  {
    id: '3329010004',
    districtId: '3329010',
    name: 'Salem',
  },
  {
    id: '3329010005',
    districtId: '3329010',
    name: 'Gunung Larang',
  },
  {
    id: '3329010006',
    districtId: '3329010',
    name: 'Gunung Sugih',
  },
  {
    id: '3329010007',
    districtId: '3329010',
    name: 'Ganggawang',
  },
  {
    id: '3329010008',
    districtId: '3329010',
    name: 'Citimbang',
  },
  {
    id: '3329010009',
    districtId: '3329010',
    name: 'Kadumanis',
  },
  {
    id: '3329010010',
    districtId: '3329010',
    name: 'Gandoang',
  },
  {
    id: '3329010011',
    districtId: '3329010',
    name: 'Ciputih',
  },
  {
    id: '3329010012',
    districtId: '3329010',
    name: 'Bentarsari',
  },
  {
    id: '3329010013',
    districtId: '3329010',
    name: 'Bentar',
  },
  {
    id: '3329010014',
    districtId: '3329010',
    name: 'Pabuaran',
  },
  {
    id: '3329010015',
    districtId: '3329010',
    name: 'Tembongraja',
  },
  {
    id: '3329010016',
    districtId: '3329010',
    name: 'Gunung Tajem',
  },
  {
    id: '3329010017',
    districtId: '3329010',
    name: 'Windusakti',
  },
  {
    id: '3329010018',
    districtId: '3329010',
    name: 'Winduasri',
  },
  {
    id: '3329010019',
    districtId: '3329010',
    name: 'Capar',
  },
  {
    id: '3329010020',
    districtId: '3329010',
    name: 'Wanoja',
  },
  {
    id: '3329010021',
    districtId: '3329010',
    name: 'Pasir Panjang',
  },
  {
    id: '3329020001',
    districtId: '3329020',
    name: 'Cinanas',
  },
  {
    id: '3329020002',
    districtId: '3329020',
    name: 'Banjarsari',
  },
  {
    id: '3329020003',
    districtId: '3329020',
    name: 'Cibentang',
  },
  {
    id: '3329020004',
    districtId: '3329020',
    name: 'Telaga',
  },
  {
    id: '3329020005',
    districtId: '3329020',
    name: 'Karangpari',
  },
  {
    id: '3329020006',
    districtId: '3329020',
    name: 'Waru',
  },
  {
    id: '3329020007',
    districtId: '3329020',
    name: 'Pangebatan',
  },
  {
    id: '3329020008',
    districtId: '3329020',
    name: 'Ciomas',
  },
  {
    id: '3329020009',
    districtId: '3329020',
    name: 'Tambakserang',
  },
  {
    id: '3329020010',
    districtId: '3329020',
    name: 'Legok',
  },
  {
    id: '3329020011',
    districtId: '3329020',
    name: 'Terlaya',
  },
  {
    id: '3329020012',
    districtId: '3329020',
    name: 'Jipang',
  },
  {
    id: '3329020013',
    districtId: '3329020',
    name: 'Bantarkawung',
  },
  {
    id: '3329020014',
    districtId: '3329020',
    name: 'Bangbayang',
  },
  {
    id: '3329020015',
    districtId: '3329020',
    name: 'Bantarwaru',
  },
  {
    id: '3329020016',
    districtId: '3329020',
    name: 'Sindangwangi',
  },
  {
    id: '3329020017',
    districtId: '3329020',
    name: 'Pengarasan',
  },
  {
    id: '3329020018',
    districtId: '3329020',
    name: 'Kebandungan',
  },
  {
    id: '3329030001',
    districtId: '3329030',
    name: 'Pruwatan',
  },
  {
    id: '3329030002',
    districtId: '3329030',
    name: 'Laren',
  },
  {
    id: '3329030003',
    districtId: '3329030',
    name: 'Jatisawit',
  },
  {
    id: '3329030004',
    districtId: '3329030',
    name: 'Negaradaha',
  },
  {
    id: '3329030005',
    districtId: '3329030',
    name: 'Kalierang',
  },
  {
    id: '3329030006',
    districtId: '3329030',
    name: 'Langkap',
  },
  {
    id: '3329030007',
    districtId: '3329030',
    name: 'Adisana',
  },
  {
    id: '3329030008',
    districtId: '3329030',
    name: 'Penggarutan',
  },
  {
    id: '3329030009',
    districtId: '3329030',
    name: 'Dukuhturi',
  },
  {
    id: '3329030010',
    districtId: '3329030',
    name: 'Bumiayu',
  },
  {
    id: '3329030011',
    districtId: '3329030',
    name: 'Kaliwadas',
  },
  {
    id: '3329030012',
    districtId: '3329030',
    name: 'Pamijen',
  },
  {
    id: '3329030013',
    districtId: '3329030',
    name: 'Kalisumur',
  },
  {
    id: '3329030014',
    districtId: '3329030',
    name: 'Kalilangkap',
  },
  {
    id: '3329030015',
    districtId: '3329030',
    name: 'Kalinusu',
  },
  {
    id: '3329040001',
    districtId: '3329040',
    name: 'Kedungoleng',
  },
  {
    id: '3329040002',
    districtId: '3329040',
    name: 'Winduaji',
  },
  {
    id: '3329040003',
    districtId: '3329040',
    name: 'Wanatirta',
  },
  {
    id: '3329040004',
    districtId: '3329040',
    name: 'Paguyangan',
  },
  {
    id: '3329040005',
    districtId: '3329040',
    name: 'Pakujati',
  },
  {
    id: '3329040006',
    districtId: '3329040',
    name: 'Taraban',
  },
  {
    id: '3329040007',
    districtId: '3329040',
    name: 'Pagojengan',
  },
  {
    id: '3329040009',
    districtId: '3329040',
    name: 'Ragatunjung',
  },
  {
    id: '3329040010',
    districtId: '3329040',
    name: 'Cilibur',
  },
  {
    id: '3329040011',
    districtId: '3329040',
    name: 'Cipetung',
  },
  {
    id: '3329040012',
    districtId: '3329040',
    name: 'Pandansari',
  },
  {
    id: '3329050001',
    districtId: '3329050',
    name: 'Wanareja',
  },
  {
    id: '3329050002',
    districtId: '3329050',
    name: 'Igirklanceng',
  },
  {
    id: '3329050003',
    districtId: '3329050',
    name: 'Dawuhan',
  },
  {
    id: '3329050004',
    districtId: '3329050',
    name: 'Batursari',
  },
  {
    id: '3329050005',
    districtId: '3329050',
    name: 'Kaligiri',
  },
  {
    id: '3329050006',
    districtId: '3329050',
    name: 'Sridadi',
  },
  {
    id: '3329050007',
    districtId: '3329050',
    name: 'Plompong',
  },
  {
    id: '3329050008',
    districtId: '3329050',
    name: 'Benda',
  },
  {
    id: '3329050009',
    districtId: '3329050',
    name: 'Kaliloka',
  },
  {
    id: '3329050010',
    districtId: '3329050',
    name: 'Manggis',
  },
  {
    id: '3329050011',
    districtId: '3329050',
    name: 'Mlayang',
  },
  {
    id: '3329050012',
    districtId: '3329050',
    name: 'Mendala',
  },
  {
    id: '3329050013',
    districtId: '3329050',
    name: 'Buniwah',
  },
  {
    id: '3329060001',
    districtId: '3329060',
    name: 'Kalijurang',
  },
  {
    id: '3329060002',
    districtId: '3329060',
    name: 'Galuh Timur',
  },
  {
    id: '3329060003',
    districtId: '3329060',
    name: 'Kutamendala',
  },
  {
    id: '3329060004',
    districtId: '3329060',
    name: 'Karangjongkeng',
  },
  {
    id: '3329060005',
    districtId: '3329060',
    name: 'Tonjong',
  },
  {
    id: '3329060006',
    districtId: '3329060',
    name: 'Pepedan',
  },
  {
    id: '3329060007',
    districtId: '3329060',
    name: 'Linggapura',
  },
  {
    id: '3329060008',
    districtId: '3329060',
    name: 'Negarayu',
  },
  {
    id: '3329060009',
    districtId: '3329060',
    name: 'Tanggeran',
  },
  {
    id: '3329060010',
    districtId: '3329060',
    name: 'Purwodadi',
  },
  {
    id: '3329060011',
    districtId: '3329060',
    name: 'Purbayasa',
  },
  {
    id: '3329060012',
    districtId: '3329060',
    name: 'Watujaya',
  },
  {
    id: '3329060013',
    districtId: '3329060',
    name: 'Kutayu',
  },
  {
    id: '3329060014',
    districtId: '3329060',
    name: 'Rajawetan',
  },
  {
    id: '3329070001',
    districtId: '3329070',
    name: 'Kamal',
  },
  {
    id: '3329070002',
    districtId: '3329070',
    name: 'Wlahar',
  },
  {
    id: '3329070003',
    districtId: '3329070',
    name: 'Pamulihan',
  },
  {
    id: '3329070004',
    districtId: '3329070',
    name: 'Kedungbokor',
  },
  {
    id: '3329070005',
    districtId: '3329070',
    name: 'Larangan',
  },
  {
    id: '3329070006',
    districtId: '3329070',
    name: 'Karangbale',
  },
  {
    id: '3329070008',
    districtId: '3329070',
    name: 'Slatri',
  },
  {
    id: '3329070009',
    districtId: '3329070',
    name: 'Sitanggal',
  },
  {
    id: '3329070010',
    districtId: '3329070',
    name: 'Siandong',
  },
  {
    id: '3329070011',
    districtId: '3329070',
    name: 'Rengaspendawa',
  },
  {
    id: '3329080001',
    districtId: '3329080',
    name: 'Jemasih',
  },
  {
    id: '3329080002',
    districtId: '3329080',
    name: 'Ciseureuh',
  },
  {
    id: '3329080003',
    districtId: '3329080',
    name: 'Sindangjaya',
  },
  {
    id: '3329080004',
    districtId: '3329080',
    name: 'Pamedaran',
  },
  {
    id: '3329080005',
    districtId: '3329080',
    name: 'Cikeusal Kidul',
  },
  {
    id: '3329080006',
    districtId: '3329080',
    name: 'Cikeusal Lor',
  },
  {
    id: '3329080007',
    districtId: '3329080',
    name: 'Buara',
  },
  {
    id: '3329080008',
    districtId: '3329080',
    name: 'Karangbandung',
  },
  {
    id: '3329080009',
    districtId: '3329080',
    name: 'Baros',
  },
  {
    id: '3329080010',
    districtId: '3329080',
    name: 'Kubangsari',
  },
  {
    id: '3329080011',
    districtId: '3329080',
    name: 'Kubangwungu',
  },
  {
    id: '3329080012',
    districtId: '3329080',
    name: 'Tanggungsari',
  },
  {
    id: '3329080013',
    districtId: '3329080',
    name: 'Dukuhbadag',
  },
  {
    id: '3329080014',
    districtId: '3329080',
    name: 'Kubangjati',
  },
  {
    id: '3329080015',
    districtId: '3329080',
    name: 'Karangmalang',
  },
  {
    id: '3329080016',
    districtId: '3329080',
    name: 'Dukuh Tengah',
  },
  {
    id: '3329080017',
    districtId: '3329080',
    name: 'Ketanggungan',
  },
  {
    id: '3329080018',
    districtId: '3329080',
    name: 'Dukuhturi',
  },
  {
    id: '3329080019',
    districtId: '3329080',
    name: 'Bulakelor',
  },
  {
    id: '3329080020',
    districtId: '3329080',
    name: 'Padakaton',
  },
  {
    id: '3329080021',
    districtId: '3329080',
    name: 'Ciduwet',
  },
  {
    id: '3329090001',
    districtId: '3329090',
    name: 'Sindangheula',
  },
  {
    id: '3329090002',
    districtId: '3329090',
    name: 'Blandongan',
  },
  {
    id: '3329090003',
    districtId: '3329090',
    name: 'Kertasari',
  },
  {
    id: '3329090004',
    districtId: '3329090',
    name: 'Bandungsari',
  },
  {
    id: '3329090005',
    districtId: '3329090',
    name: 'Cipajang',
  },
  {
    id: '3329090006',
    districtId: '3329090',
    name: 'Penanggapan',
  },
  {
    id: '3329090007',
    districtId: '3329090',
    name: 'Malahayu',
  },
  {
    id: '3329090008',
    districtId: '3329090',
    name: 'Cikuya',
  },
  {
    id: '3329090009',
    districtId: '3329090',
    name: 'Banjarharjo',
  },
  {
    id: '3329090010',
    districtId: '3329090',
    name: 'Parireja',
  },
  {
    id: '3329090011',
    districtId: '3329090',
    name: 'Cigadung',
  },
  {
    id: '3329090012',
    districtId: '3329090',
    name: 'Tiwulandu',
  },
  {
    id: '3329090013',
    districtId: '3329090',
    name: 'Cikakak',
  },
  {
    id: '3329090014',
    districtId: '3329090',
    name: 'Cibendung',
  },
  {
    id: '3329090015',
    districtId: '3329090',
    name: 'Karangmaja',
  },
  {
    id: '3329090018',
    districtId: '3329090',
    name: 'Sukareja',
  },
  {
    id: '3329090019',
    districtId: '3329090',
    name: 'Kubangjero',
  },
  {
    id: '3329090020',
    districtId: '3329090',
    name: 'Cibuniwangi',
  },
  {
    id: '3329090021',
    districtId: '3329090',
    name: 'Cimunding',
  },
  {
    id: '3329090022',
    districtId: '3329090',
    name: 'Ciawi',
  },
  {
    id: '3329090023',
    districtId: '3329090',
    name: 'Cihaur',
  },
  {
    id: '3329090024',
    districtId: '3329090',
    name: 'Tegalreja',
  },
  {
    id: '3329090025',
    districtId: '3329090',
    name: 'Banjar Lor',
  },
  {
    id: '3329100001',
    districtId: '3329100',
    name: 'Randegan',
  },
  {
    id: '3329100002',
    districtId: '3329100',
    name: 'Jati Sawit',
  },
  {
    id: '3329100003',
    districtId: '3329100',
    name: 'Karangsambung',
  },
  {
    id: '3329100004',
    districtId: '3329100',
    name: 'Negla',
  },
  {
    id: '3329100005',
    districtId: '3329100',
    name: 'Bojongsari',
  },
  {
    id: '3329100006',
    districtId: '3329100',
    name: 'Karangjunti',
  },
  {
    id: '3329100007',
    districtId: '3329100',
    name: 'Rungkang',
  },
  {
    id: '3329100008',
    districtId: '3329100',
    name: 'Dukuhsalam',
  },
  {
    id: '3329100009',
    districtId: '3329100',
    name: 'Babakan',
  },
  {
    id: '3329100010',
    districtId: '3329100',
    name: 'Kalibuntu',
  },
  {
    id: '3329100012',
    districtId: '3329100',
    name: 'Randusari',
  },
  {
    id: '3329100014',
    districtId: '3329100',
    name: 'Pekauman',
  },
  {
    id: '3329100015',
    districtId: '3329100',
    name: 'Losari Kidul',
  },
  {
    id: '3329100016',
    districtId: '3329100',
    name: 'Losari Lor',
  },
  {
    id: '3329100017',
    districtId: '3329100',
    name: 'Kecipir',
  },
  {
    id: '3329100018',
    districtId: '3329100',
    name: 'Pengabean',
  },
  {
    id: '3329100019',
    districtId: '3329100',
    name: 'Limbangan',
  },
  {
    id: '3329100020',
    districtId: '3329100',
    name: 'Prapag Kidul',
  },
  {
    id: '3329100021',
    districtId: '3329100',
    name: 'Karangdempel',
  },
  {
    id: '3329100022',
    districtId: '3329100',
    name: 'Prapag Lor',
  },
  {
    id: '3329110001',
    districtId: '3329110',
    name: 'Sarireja',
  },
  {
    id: '3329110002',
    districtId: '3329110',
    name: 'Kubangputat',
  },
  {
    id: '3329110005',
    districtId: '3329110',
    name: 'Luwungbata',
  },
  {
    id: '3329110006',
    districtId: '3329110',
    name: 'Karangreja',
  },
  {
    id: '3329110007',
    districtId: '3329110',
    name: 'Sidakaton',
  },
  {
    id: '3329110008',
    districtId: '3329110',
    name: 'Sengon',
  },
  {
    id: '3329110009',
    districtId: '3329110',
    name: 'Kedawung',
  },
  {
    id: '3329110010',
    districtId: '3329110',
    name: 'Tegongan',
  },
  {
    id: '3329110011',
    districtId: '3329110',
    name: 'Kemurang Wetan',
  },
  {
    id: '3329110012',
    districtId: '3329110',
    name: 'Kemurang Kulon',
  },
  {
    id: '3329110013',
    districtId: '3329110',
    name: 'Krakahan',
  },
  {
    id: '3329110014',
    districtId: '3329110',
    name: 'Pejagan',
  },
  {
    id: '3329110015',
    districtId: '3329110',
    name: 'Pengaradan',
  },
  {
    id: '3329110016',
    districtId: '3329110',
    name: 'Tanjung',
  },
  {
    id: '3329110017',
    districtId: '3329110',
    name: 'Lemah Abang',
  },
  {
    id: '3329110018',
    districtId: '3329110',
    name: 'Tengguli',
  },
  {
    id: '3329120001',
    districtId: '3329120',
    name: 'Kradenan',
  },
  {
    id: '3329120002',
    districtId: '3329120',
    name: 'Sindangjaya',
  },
  {
    id: '3329120004',
    districtId: '3329120',
    name: 'Kubangpari',
  },
  {
    id: '3329120005',
    districtId: '3329120',
    name: 'Cikandang',
  },
  {
    id: '3329120006',
    districtId: '3329120',
    name: 'Cigedog',
  },
  {
    id: '3329120007',
    districtId: '3329120',
    name: 'Ciampel',
  },
  {
    id: '3329120008',
    districtId: '3329120',
    name: 'Jagapura',
  },
  {
    id: '3329120009',
    districtId: '3329120',
    name: 'Kersana',
  },
  {
    id: '3329120011',
    districtId: '3329120',
    name: 'Kramatsampang',
  },
  {
    id: '3329120012',
    districtId: '3329120',
    name: 'Limbangan',
  },
  {
    id: '3329120013',
    districtId: '3329120',
    name: 'Sutamaja',
  },
  {
    id: '3329130001',
    districtId: '3329130',
    name: 'Tegalglagah',
  },
  {
    id: '3329130002',
    districtId: '3329130',
    name: 'Petunjungan',
  },
  {
    id: '3329130003',
    districtId: '3329130',
    name: 'Jubang',
  },
  {
    id: '3329130004',
    districtId: '3329130',
    name: 'Dukuhlo',
  },
  {
    id: '3329130005',
    districtId: '3329130',
    name: 'Cipelem',
  },
  {
    id: '3329130006',
    districtId: '3329130',
    name: 'Banjaratma',
  },
  {
    id: '3329130007',
    districtId: '3329130',
    name: 'Siwuluh',
  },
  {
    id: '3329130008',
    districtId: '3329130',
    name: 'Luwungragi',
  },
  {
    id: '3329130009',
    districtId: '3329130',
    name: 'Bangsri',
  },
  {
    id: '3329130010',
    districtId: '3329130',
    name: 'Rancawuluh',
  },
  {
    id: '3329130011',
    districtId: '3329130',
    name: 'Bulusari',
  },
  {
    id: '3329130012',
    districtId: '3329130',
    name: 'Karangsari',
  },
  {
    id: '3329130014',
    districtId: '3329130',
    name: 'Bulakparen',
  },
  {
    id: '3329130015',
    districtId: '3329130',
    name: 'Cimohong',
  },
  {
    id: '3329130016',
    districtId: '3329130',
    name: 'Grinting',
  },
  {
    id: '3329130017',
    districtId: '3329130',
    name: 'Bulakamba',
  },
  {
    id: '3329130018',
    districtId: '3329130',
    name: 'Pakijangan',
  },
  {
    id: '3329130019',
    districtId: '3329130',
    name: 'Pulogading',
  },
  {
    id: '3329140001',
    districtId: '3329140',
    name: 'Tegalgandu',
  },
  {
    id: '3329140002',
    districtId: '3329140',
    name: 'Jagalempeni',
  },
  {
    id: '3329140003',
    districtId: '3329140',
    name: 'Glonggong',
  },
  {
    id: '3329140004',
    districtId: '3329140',
    name: 'Sisalam',
  },
  {
    id: '3329140005',
    districtId: '3329140',
    name: 'Lengkong',
  },
  {
    id: '3329140006',
    districtId: '3329140',
    name: 'Tanjungsari',
  },
  {
    id: '3329140007',
    districtId: '3329140',
    name: 'Siwungkuk',
  },
  {
    id: '3329140008',
    districtId: '3329140',
    name: 'Dukuhwringin',
  },
  {
    id: '3329140009',
    districtId: '3329140',
    name: 'Sigentong',
  },
  {
    id: '3329140010',
    districtId: '3329140',
    name: 'Sidamulya',
  },
  {
    id: '3329140011',
    districtId: '3329140',
    name: 'Wanasari',
  },
  {
    id: '3329140012',
    districtId: '3329140',
    name: 'Siasem',
  },
  {
    id: '3329140013',
    districtId: '3329140',
    name: 'Klampok',
  },
  {
    id: '3329140014',
    districtId: '3329140',
    name: 'Pebatan',
  },
  {
    id: '3329140015',
    districtId: '3329140',
    name: 'Pesantunan',
  },
  {
    id: '3329140016',
    districtId: '3329140',
    name: 'Keboledan',
  },
  {
    id: '3329140018',
    districtId: '3329140',
    name: 'Dumeling',
  },
  {
    id: '3329140019',
    districtId: '3329140',
    name: 'Kertabesuki',
  },
  {
    id: '3329140020',
    districtId: '3329140',
    name: 'Sawojajar',
  },
  {
    id: '3329150001',
    districtId: '3329150',
    name: 'Songgom',
  },
  {
    id: '3329150002',
    districtId: '3329150',
    name: 'Songgom Lor',
  },
  {
    id: '3329150003',
    districtId: '3329150',
    name: 'Gegerkunci',
  },
  {
    id: '3329150004',
    districtId: '3329150',
    name: 'Jatimakmur',
  },
  {
    id: '3329150005',
    districtId: '3329150',
    name: 'Jatirokeh',
  },
  {
    id: '3329150006',
    districtId: '3329150',
    name: 'Cenang',
  },
  {
    id: '3329150007',
    districtId: '3329150',
    name: 'Wanatawang',
  },
  {
    id: '3329150008',
    districtId: '3329150',
    name: 'Wanacala',
  },
  {
    id: '3329150009',
    districtId: '3329150',
    name: 'Karangsembung',
  },
  {
    id: '3329150010',
    districtId: '3329150',
    name: 'Dukuhmaja',
  },
  {
    id: '3329160001',
    districtId: '3329160',
    name: 'Kebogadung',
  },
  {
    id: '3329160002',
    districtId: '3329160',
    name: 'Kebonagung',
  },
  {
    id: '3329160003',
    districtId: '3329160',
    name: 'Klampis',
  },
  {
    id: '3329160004',
    districtId: '3329160',
    name: 'Kemiriamba',
  },
  {
    id: '3329160005',
    districtId: '3329160',
    name: 'Jatibarang Kidul',
  },
  {
    id: '3329160006',
    districtId: '3329160',
    name: 'Karanglo',
  },
  {
    id: '3329160007',
    districtId: '3329160',
    name: 'Tegalwulung',
  },
  {
    id: '3329160008',
    districtId: '3329160',
    name: 'Jatibarang Lor',
  },
  {
    id: '3329160009',
    districtId: '3329160',
    name: 'Pamengger',
  },
  {
    id: '3329160010',
    districtId: '3329160',
    name: 'Kertasinduyasa',
  },
  {
    id: '3329160011',
    districtId: '3329160',
    name: 'Janegara',
  },
  {
    id: '3329160012',
    districtId: '3329160',
    name: 'Kendawa',
  },
  {
    id: '3329160013',
    districtId: '3329160',
    name: 'Klikiran',
  },
  {
    id: '3329160014',
    districtId: '3329160',
    name: 'Bojong',
  },
  {
    id: '3329160015',
    districtId: '3329160',
    name: 'Buaran',
  },
  {
    id: '3329160016',
    districtId: '3329160',
    name: 'Kedungtukang',
  },
  {
    id: '3329160017',
    districtId: '3329160',
    name: 'Rengasbandung',
  },
  {
    id: '3329160018',
    districtId: '3329160',
    name: 'Tembelang',
  },
  {
    id: '3329160019',
    districtId: '3329160',
    name: 'Pedeslohor',
  },
  {
    id: '3329160020',
    districtId: '3329160',
    name: 'Kramat',
  },
  {
    id: '3329160021',
    districtId: '3329160',
    name: 'Kalipucang',
  },
  {
    id: '3329160022',
    districtId: '3329160',
    name: 'Kalialang',
  },
  {
    id: '3329170001',
    districtId: '3329170',
    name: 'Pemaron',
  },
  {
    id: '3329170002',
    districtId: '3329170',
    name: 'Kalimati',
  },
  {
    id: '3329170003',
    districtId: '3329170',
    name: 'Lembarawa',
  },
  {
    id: '3329170004',
    districtId: '3329170',
    name: 'Krasak',
  },
  {
    id: '3329170005',
    districtId: '3329170',
    name: 'Padasugih',
  },
  {
    id: '3329170006',
    districtId: '3329170',
    name: 'Wangandalem',
  },
  {
    id: '3329170007',
    districtId: '3329170',
    name: 'Terlangu',
  },
  {
    id: '3329170008',
    districtId: '3329170',
    name: 'Pulosari',
  },
  {
    id: '3329170010',
    districtId: '3329170',
    name: 'Gandasuli',
  },
  {
    id: '3329170011',
    districtId: '3329170',
    name: 'Banjaranyar',
  },
  {
    id: '3329170012',
    districtId: '3329170',
    name: 'Kaligangsa Kulon',
  },
  {
    id: '3329170013',
    districtId: '3329170',
    name: 'Kaligangsa Wetan',
  },
  {
    id: '3329170014',
    districtId: '3329170',
    name: 'Randusanga Wetan',
  },
  {
    id: '3329170015',
    districtId: '3329170',
    name: 'Randusanga Kulon',
  },
  {
    id: '3329170016',
    districtId: '3329170',
    name: 'Limbangan Wetan',
  },
  {
    id: '3329170017',
    districtId: '3329170',
    name: 'Limbangan Kulon',
  },
  {
    id: '3329170018',
    districtId: '3329170',
    name: 'Pasar Batang',
  },
  {
    id: '3329170019',
    districtId: '3329170',
    name: 'Sigambir',
  },
  {
    id: '3329170020',
    districtId: '3329170',
    name: 'Pagejugan',
  },
  {
    id: '3329170022',
    districtId: '3329170',
    name: 'Tengki',
  },
  {
    id: '3329170023',
    districtId: '3329170',
    name: 'Kaliwlingi',
  },
  {
    id: '3371010002',
    districtId: '3371010',
    name: 'Magersari',
  },
  {
    id: '3371010004',
    districtId: '3371010',
    name: 'Rejowinangun Selatan',
  },
  {
    id: '3371010005',
    districtId: '3371010',
    name: 'Jurangombo Utara',
  },
  {
    id: '3371010006',
    districtId: '3371010',
    name: 'Jurangombo Selatan',
  },
  {
    id: '3371010007',
    districtId: '3371010',
    name: 'Tidar Utara',
  },
  {
    id: '3371010008',
    districtId: '3371010',
    name: 'Tidar Selatan',
  },
  {
    id: '3371011001',
    districtId: '3371011',
    name: 'Rejowinangun Utara',
  },
  {
    id: '3371011002',
    districtId: '3371011',
    name: 'Kemirirejo',
  },
  {
    id: '3371011003',
    districtId: '3371011',
    name: 'Cacaban',
  },
  {
    id: '3371011004',
    districtId: '3371011',
    name: 'Magelang',
  },
  {
    id: '3371011005',
    districtId: '3371011',
    name: 'Panjang',
  },
  {
    id: '3371011006',
    districtId: '3371011',
    name: 'Gelangan',
  },
  {
    id: '3371020004',
    districtId: '3371020',
    name: 'Wates',
  },
  {
    id: '3371020005',
    districtId: '3371020',
    name: 'Potrobangsan',
  },
  {
    id: '3371020006',
    districtId: '3371020',
    name: 'Kedungsari',
  },
  {
    id: '3371020008',
    districtId: '3371020',
    name: 'Kramat Utara',
  },
  {
    id: '3371020009',
    districtId: '3371020',
    name: 'Kramat Selatan',
  },
  {
    id: '3372010001',
    districtId: '3372010',
    name: 'Pajang',
  },
  {
    id: '3372010002',
    districtId: '3372010',
    name: 'Laweyan',
  },
  {
    id: '3372010003',
    districtId: '3372010',
    name: 'Bumi',
  },
  {
    id: '3372010004',
    districtId: '3372010',
    name: 'Panularan',
  },
  {
    id: '3372010005',
    districtId: '3372010',
    name: 'Sriwedari',
  },
  {
    id: '3372010006',
    districtId: '3372010',
    name: 'Penumping',
  },
  {
    id: '3372010007',
    districtId: '3372010',
    name: 'Purwosari',
  },
  {
    id: '3372010008',
    districtId: '3372010',
    name: 'Sondakan',
  },
  {
    id: '3372010010',
    districtId: '3372010',
    name: 'Jajar',
  },
  {
    id: '3372010011',
    districtId: '3372010',
    name: 'Karangasem',
  },
  {
    id: '3372020001',
    districtId: '3372020',
    name: 'Joyotakan',
  },
  {
    id: '3372020002',
    districtId: '3372020',
    name: 'Danukusuman',
  },
  {
    id: '3372020003',
    districtId: '3372020',
    name: 'Serengan',
  },
  {
    id: '3372020004',
    districtId: '3372020',
    name: 'Tipes',
  },
  {
    id: '3372020005',
    districtId: '3372020',
    name: 'Kratonan',
  },
  {
    id: '3372020006',
    districtId: '3372020',
    name: 'Jayengan',
  },
  {
    id: '3372020007',
    districtId: '3372020',
    name: 'Kemlayan',
  },
  {
    id: '3372030001',
    districtId: '3372030',
    name: 'Joyosuran',
  },
  {
    id: '3372030002',
    districtId: '3372030',
    name: 'Semanggi',
  },
  {
    id: '3372030003',
    districtId: '3372030',
    name: 'Pasar Kliwon',
  },
  {
    id: '3372030004',
    districtId: '3372030',
    name: 'Baluwarti',
  },
  {
    id: '3372030005',
    districtId: '3372030',
    name: 'Gajahan',
  },
  {
    id: '3372030006',
    districtId: '3372030',
    name: 'Kauman',
  },
  {
    id: '3372030007',
    districtId: '3372030',
    name: 'Kampung Baru',
  },
  {
    id: '3372030009',
    districtId: '3372030',
    name: 'Sangkrah',
  },
  {
    id: '3372040001',
    districtId: '3372040',
    name: 'Kepatihan Kulon',
  },
  {
    id: '3372040002',
    districtId: '3372040',
    name: 'Kepatihan Wetan',
  },
  {
    id: '3372040003',
    districtId: '3372040',
    name: 'Sudiroprajan',
  },
  {
    id: '3372040004',
    districtId: '3372040',
    name: 'Gandekan',
  },
  {
    id: '3372040006',
    districtId: '3372040',
    name: 'Pucangsawit',
  },
  {
    id: '3372040007',
    districtId: '3372040',
    name: 'Jagalan',
  },
  {
    id: '3372040008',
    districtId: '3372040',
    name: 'Purwodiningratan',
  },
  {
    id: '3372040009',
    districtId: '3372040',
    name: 'Tegalharjo',
  },
  {
    id: '3372040011',
    districtId: '3372040',
    name: 'Mojosongo',
  },
  {
    id: '3372050001',
    districtId: '3372050',
    name: 'Mangkubumen',
  },
  {
    id: '3372050002',
    districtId: '3372050',
    name: 'Timuran',
  },
  {
    id: '3372050003',
    districtId: '3372050',
    name: 'Keprabon',
  },
  {
    id: '3372050004',
    districtId: '3372050',
    name: 'Ketelan',
  },
  {
    id: '3372050005',
    districtId: '3372050',
    name: 'Punggawan',
  },
  {
    id: '3372050006',
    districtId: '3372050',
    name: 'Kestalan',
  },
  {
    id: '3372050007',
    districtId: '3372050',
    name: 'Setabelan',
  },
  {
    id: '3372050008',
    districtId: '3372050',
    name: 'Gilingan',
  },
  {
    id: '3372050009',
    districtId: '3372050',
    name: 'Manahan',
  },
  {
    id: '3372050011',
    districtId: '3372050',
    name: 'Nusukan',
  },
  {
    id: '3372050012',
    districtId: '3372050',
    name: 'Kadipiro',
  },
  {
    id: '3372050013',
    districtId: '3372050',
    name: 'Banyuanyar',
  },
  {
    id: '3373010001',
    districtId: '3373010',
    name: 'Noborejo',
  },
  {
    id: '3373010002',
    districtId: '3373010',
    name: 'Cebongan',
  },
  {
    id: '3373010003',
    districtId: '3373010',
    name: 'Randuacir',
  },
  {
    id: '3373010004',
    districtId: '3373010',
    name: 'Ledok',
  },
  {
    id: '3373010005',
    districtId: '3373010',
    name: 'Tegalrejo',
  },
  {
    id: '3373010006',
    districtId: '3373010',
    name: 'Kumpulrejo',
  },
  {
    id: '3373020001',
    districtId: '3373020',
    name: 'Tingkir Tengah',
  },
  {
    id: '3373020002',
    districtId: '3373020',
    name: 'Tingkir Lor',
  },
  {
    id: '3373020003',
    districtId: '3373020',
    name: 'Kalibening',
  },
  {
    id: '3373020004',
    districtId: '3373020',
    name: 'Sidorejo Kidul',
  },
  {
    id: '3373020006',
    districtId: '3373020',
    name: 'Gendongan',
  },
  {
    id: '3373020007',
    districtId: '3373020',
    name: 'Kutowinangun Kidul',
  },
  {
    id: '3373020008',
    districtId: '3373020',
    name: 'Kutowinangun Lor',
  },
  {
    id: '3373030001',
    districtId: '3373030',
    name: 'Kecandran',
  },
  {
    id: '3373030003',
    districtId: '3373030',
    name: 'Mangunsari',
  },
  {
    id: '3373030004',
    districtId: '3373030',
    name: 'Kalicacing',
  },
  {
    id: '3373040001',
    districtId: '3373040',
    name: 'Pulutan',
  },
  {
    id: '3373040002',
    districtId: '3373040',
    name: 'Blotongan',
  },
  {
    id: '3373040003',
    districtId: '3373040',
    name: 'Sidorejo Lor',
  },
  {
    id: '3373040004',
    districtId: '3373040',
    name: 'Salatiga',
  },
  {
    id: '3373040006',
    districtId: '3373040',
    name: 'Kauman Kidul',
  },
  {
    id: '3374010001',
    districtId: '3374010',
    name: 'Cangkiran',
  },
  {
    id: '3374010002',
    districtId: '3374010',
    name: 'Bubakan',
  },
  {
    id: '3374010003',
    districtId: '3374010',
    name: 'Karangmalang',
  },
  {
    id: '3374010004',
    districtId: '3374010',
    name: 'Polaman',
  },
  {
    id: '3374010005',
    districtId: '3374010',
    name: 'Purwosari',
  },
  {
    id: '3374010006',
    districtId: '3374010',
    name: 'Tambangan',
  },
  {
    id: '3374010007',
    districtId: '3374010',
    name: 'Jatisari',
  },
  {
    id: '3374010008',
    districtId: '3374010',
    name: 'Mijen',
  },
  {
    id: '3374010009',
    districtId: '3374010',
    name: 'Jatibarang',
  },
  {
    id: '3374010010',
    districtId: '3374010',
    name: 'Kedungpani',
  },
  {
    id: '3374010011',
    districtId: '3374010',
    name: 'Pesantren',
  },
  {
    id: '3374010012',
    districtId: '3374010',
    name: 'Ngadirgo',
  },
  {
    id: '3374010013',
    districtId: '3374010',
    name: 'Wonolopo',
  },
  {
    id: '3374010014',
    districtId: '3374010',
    name: 'Wonoplumbon',
  },
  {
    id: '3374020001',
    districtId: '3374020',
    name: 'Gunungpati',
  },
  {
    id: '3374020002',
    districtId: '3374020',
    name: 'Plalangan',
  },
  {
    id: '3374020003',
    districtId: '3374020',
    name: 'Sumurejo',
  },
  {
    id: '3374020004',
    districtId: '3374020',
    name: 'Pakintelan',
  },
  {
    id: '3374020005',
    districtId: '3374020',
    name: 'Mangunsari',
  },
  {
    id: '3374020006',
    districtId: '3374020',
    name: 'Patemon',
  },
  {
    id: '3374020007',
    districtId: '3374020',
    name: 'Ngijo',
  },
  {
    id: '3374020008',
    districtId: '3374020',
    name: 'Nongkosawit',
  },
  {
    id: '3374020009',
    districtId: '3374020',
    name: 'Cepoko',
  },
  {
    id: '3374020010',
    districtId: '3374020',
    name: 'Jatirejo',
  },
  {
    id: '3374020011',
    districtId: '3374020',
    name: 'Kandri',
  },
  {
    id: '3374020012',
    districtId: '3374020',
    name: 'Pungangan',
  },
  {
    id: '3374020013',
    districtId: '3374020',
    name: 'Kalisegoro',
  },
  {
    id: '3374020014',
    districtId: '3374020',
    name: 'Sekaran',
  },
  {
    id: '3374020015',
    districtId: '3374020',
    name: 'Sukorejo',
  },
  {
    id: '3374020016',
    districtId: '3374020',
    name: 'Sadeng',
  },
  {
    id: '3374030001',
    districtId: '3374030',
    name: 'Pudakpayung',
  },
  {
    id: '3374030002',
    districtId: '3374030',
    name: 'Gedawang',
  },
  {
    id: '3374030003',
    districtId: '3374030',
    name: 'Jabungan',
  },
  {
    id: '3374030004',
    districtId: '3374030',
    name: 'Padangsari',
  },
  {
    id: '3374030005',
    districtId: '3374030',
    name: 'Banyumanik',
  },
  {
    id: '3374030006',
    districtId: '3374030',
    name: 'Srondol Wetan',
  },
  {
    id: '3374030007',
    districtId: '3374030',
    name: 'Pedalangan',
  },
  {
    id: '3374030008',
    districtId: '3374030',
    name: 'Sumurboto',
  },
  {
    id: '3374030009',
    districtId: '3374030',
    name: 'Srondol Kulon',
  },
  {
    id: '3374030010',
    districtId: '3374030',
    name: 'Tinjomoyo',
  },
  {
    id: '3374040001',
    districtId: '3374040',
    name: 'Sampangan',
  },
  {
    id: '3374040002',
    districtId: '3374040',
    name: 'Bendan Duwur',
  },
  {
    id: '3374040003',
    districtId: '3374040',
    name: 'Karang Rejo',
  },
  {
    id: '3374040004',
    districtId: '3374040',
    name: 'Gajahmungkur',
  },
  {
    id: '3374040005',
    districtId: '3374040',
    name: 'Bendan Ngisor',
  },
  {
    id: '3374040006',
    districtId: '3374040',
    name: 'Petompon',
  },
  {
    id: '3374040007',
    districtId: '3374040',
    name: 'Bendungan',
  },
  {
    id: '3374040008',
    districtId: '3374040',
    name: 'Lempongsari',
  },
  {
    id: '3374050001',
    districtId: '3374050',
    name: 'Bulustalan',
  },
  {
    id: '3374050002',
    districtId: '3374050',
    name: 'Barusari',
  },
  {
    id: '3374050003',
    districtId: '3374050',
    name: 'Randusari',
  },
  {
    id: '3374050004',
    districtId: '3374050',
    name: 'Mugassari',
  },
  {
    id: '3374050005',
    districtId: '3374050',
    name: 'Pleburan',
  },
  {
    id: '3374050006',
    districtId: '3374050',
    name: 'Wonodri',
  },
  {
    id: '3374050007',
    districtId: '3374050',
    name: 'Peterongan',
  },
  {
    id: '3374050008',
    districtId: '3374050',
    name: 'Lamper Kidul',
  },
  {
    id: '3374050009',
    districtId: '3374050',
    name: 'Lamper Lor',
  },
  {
    id: '3374050010',
    districtId: '3374050',
    name: 'Lamper Tengah',
  },
  {
    id: '3374060001',
    districtId: '3374060',
    name: 'Jatingaleh',
  },
  {
    id: '3374060002',
    districtId: '3374060',
    name: 'Karanganyar Gunung',
  },
  {
    id: '3374060003',
    districtId: '3374060',
    name: 'Jomblang',
  },
  {
    id: '3374060004',
    districtId: '3374060',
    name: 'Candi',
  },
  {
    id: '3374060005',
    districtId: '3374060',
    name: 'Kaliwiru',
  },
  {
    id: '3374060006',
    districtId: '3374060',
    name: 'Wonotingal',
  },
  {
    id: '3374060007',
    districtId: '3374060',
    name: 'Tegalsari',
  },
  {
    id: '3374070001',
    districtId: '3374070',
    name: 'Rowosari',
  },
  {
    id: '3374070003',
    districtId: '3374070',
    name: 'Kramas',
  },
  {
    id: '3374070004',
    districtId: '3374070',
    name: 'Tembalang',
  },
  {
    id: '3374070005',
    districtId: '3374070',
    name: 'Bulusan',
  },
  {
    id: '3374070006',
    districtId: '3374070',
    name: 'Mangunharjo',
  },
  {
    id: '3374070007',
    districtId: '3374070',
    name: 'Sendangmulyo',
  },
  {
    id: '3374070008',
    districtId: '3374070',
    name: 'Sambiroto',
  },
  {
    id: '3374070009',
    districtId: '3374070',
    name: 'Jangli',
  },
  {
    id: '3374070010',
    districtId: '3374070',
    name: 'Tandang',
  },
  {
    id: '3374070012',
    districtId: '3374070',
    name: 'Sendangguwo',
  },
  {
    id: '3374080001',
    districtId: '3374080',
    name: 'Gemah',
  },
  {
    id: '3374080002',
    districtId: '3374080',
    name: 'Pedurungan Kidul',
  },
  {
    id: '3374080003',
    districtId: '3374080',
    name: 'Plamongan Sari',
  },
  {
    id: '3374080004',
    districtId: '3374080',
    name: 'Penggaron Kidul',
  },
  {
    id: '3374080005',
    districtId: '3374080',
    name: 'Pedurungan Lor',
  },
  {
    id: '3374080006',
    districtId: '3374080',
    name: 'Tlogomulyo',
  },
  {
    id: '3374080007',
    districtId: '3374080',
    name: 'Pedurungan Tengah',
  },
  {
    id: '3374080008',
    districtId: '3374080',
    name: 'Palebon',
  },
  {
    id: '3374080009',
    districtId: '3374080',
    name: 'Kalicari',
  },
  {
    id: '3374080010',
    districtId: '3374080',
    name: 'Tlogosari Kulon',
  },
  {
    id: '3374080011',
    districtId: '3374080',
    name: 'Tlogosari Wetan',
  },
  {
    id: '3374080012',
    districtId: '3374080',
    name: 'Muktiharjo Kidul',
  },
  {
    id: '3374090001',
    districtId: '3374090',
    name: 'Muktiharjo Lor',
  },
  {
    id: '3374090002',
    districtId: '3374090',
    name: 'Gebangsari',
  },
  {
    id: '3374090003',
    districtId: '3374090',
    name: 'Genuksari',
  },
  {
    id: '3374090004',
    districtId: '3374090',
    name: 'Bangetayu Kulon',
  },
  {
    id: '3374090005',
    districtId: '3374090',
    name: 'Bangetayu Wetan',
  },
  {
    id: '3374090006',
    districtId: '3374090',
    name: 'Sembungharjo',
  },
  {
    id: '3374090007',
    districtId: '3374090',
    name: 'Penggaron Lor',
  },
  {
    id: '3374090009',
    districtId: '3374090',
    name: 'Karangroto',
  },
  {
    id: '3374090010',
    districtId: '3374090',
    name: 'Banjardowo',
  },
  {
    id: '3374090011',
    districtId: '3374090',
    name: 'Trimulyo',
  },
  {
    id: '3374090012',
    districtId: '3374090',
    name: 'Terboyo Wetan',
  },
  {
    id: '3374090013',
    districtId: '3374090',
    name: 'Terboyo Kulon',
  },
  {
    id: '3374100001',
    districtId: '3374100',
    name: 'Pandean Lamper',
  },
  {
    id: '3374100002',
    districtId: '3374100',
    name: 'Gayamsari',
  },
  {
    id: '3374100003',
    districtId: '3374100',
    name: 'Siwalan',
  },
  {
    id: '3374100004',
    districtId: '3374100',
    name: 'Sambirejo',
  },
  {
    id: '3374100005',
    districtId: '3374100',
    name: 'Sawahbesar',
  },
  {
    id: '3374100006',
    districtId: '3374100',
    name: 'Kaligawe',
  },
  {
    id: '3374100007',
    districtId: '3374100',
    name: 'Tambakrejo',
  },
  {
    id: '3374110001',
    districtId: '3374110',
    name: 'Karangturi',
  },
  {
    id: '3374110002',
    districtId: '3374110',
    name: 'Karangtempel',
  },
  {
    id: '3374110003',
    districtId: '3374110',
    name: 'Rejosari',
  },
  {
    id: '3374110004',
    districtId: '3374110',
    name: 'Sarirejo',
  },
  {
    id: '3374110005',
    districtId: '3374110',
    name: 'Kebonagung',
  },
  {
    id: '3374110006',
    districtId: '3374110',
    name: 'Bugangan',
  },
  {
    id: '3374110007',
    districtId: '3374110',
    name: 'Mlatiharjo',
  },
  {
    id: '3374110008',
    districtId: '3374110',
    name: 'Mlatibaru',
  },
  {
    id: '3374110009',
    districtId: '3374110',
    name: 'Rejomulyo',
  },
  {
    id: '3374110010',
    districtId: '3374110',
    name: 'Kemijen',
  },
  {
    id: '3374120001',
    districtId: '3374120',
    name: 'Bulu Lor',
  },
  {
    id: '3374120002',
    districtId: '3374120',
    name: 'Plombokan',
  },
  {
    id: '3374120003',
    districtId: '3374120',
    name: 'Panggung Kidul',
  },
  {
    id: '3374120004',
    districtId: '3374120',
    name: 'Panggung Lor',
  },
  {
    id: '3374120005',
    districtId: '3374120',
    name: 'Kuningan',
  },
  {
    id: '3374120006',
    districtId: '3374120',
    name: 'Purwosari',
  },
  {
    id: '3374120007',
    districtId: '3374120',
    name: 'Dadapsari',
  },
  {
    id: '3374120008',
    districtId: '3374120',
    name: 'Bandarharjo',
  },
  {
    id: '3374120009',
    districtId: '3374120',
    name: 'Tanjungmas',
  },
  {
    id: '3374130002',
    districtId: '3374130',
    name: 'Karangkidul',
  },
  {
    id: '3374130003',
    districtId: '3374130',
    name: 'Jagalan',
  },
  {
    id: '3374130004',
    districtId: '3374130',
    name: 'Brumbungan',
  },
  {
    id: '3374130005',
    districtId: '3374130',
    name: 'Miroto',
  },
  {
    id: '3374130006',
    districtId: '3374130',
    name: 'Gabahan',
  },
  {
    id: '3374130007',
    districtId: '3374130',
    name: 'Kranggan',
  },
  {
    id: '3374130008',
    districtId: '3374130',
    name: 'Purwodinatan',
  },
  {
    id: '3374130009',
    districtId: '3374130',
    name: 'Kauman',
  },
  {
    id: '3374130010',
    districtId: '3374130',
    name: 'Bangunharjo',
  },
  {
    id: '3374130011',
    districtId: '3374130',
    name: 'Kembangsari',
  },
  {
    id: '3374130012',
    districtId: '3374130',
    name: 'Pandansari',
  },
  {
    id: '3374130013',
    districtId: '3374130',
    name: 'Sekayu',
  },
  {
    id: '3374130014',
    districtId: '3374130',
    name: 'Pendrikan Kidul',
  },
  {
    id: '3374130015',
    districtId: '3374130',
    name: 'Pendrikan Lor',
  },
  {
    id: '3374140001',
    districtId: '3374140',
    name: 'Kembangarum',
  },
  {
    id: '3374140002',
    districtId: '3374140',
    name: 'Manyaran',
  },
  {
    id: '3374140003',
    districtId: '3374140',
    name: 'Ngemplaksimongan',
  },
  {
    id: '3374140004',
    districtId: '3374140',
    name: 'Bongsari',
  },
  {
    id: '3374140005',
    districtId: '3374140',
    name: 'Bojongsalaman',
  },
  {
    id: '3374140006',
    districtId: '3374140',
    name: 'Cabean',
  },
  {
    id: '3374140007',
    districtId: '3374140',
    name: 'Salamanmloyo',
  },
  {
    id: '3374140008',
    districtId: '3374140',
    name: 'Gisikdrono',
  },
  {
    id: '3374140009',
    districtId: '3374140',
    name: 'Kalibanteng Kidul',
  },
  {
    id: '3374140010',
    districtId: '3374140',
    name: 'Kalibanteng Kulon',
  },
  {
    id: '3374140011',
    districtId: '3374140',
    name: 'Krapyak',
  },
  {
    id: '3374140012',
    districtId: '3374140',
    name: 'Tambak Harjo',
  },
  {
    id: '3374140013',
    districtId: '3374140',
    name: 'Tawangsari',
  },
  {
    id: '3374140014',
    districtId: '3374140',
    name: 'Karang Ayu',
  },
  {
    id: '3374140015',
    districtId: '3374140',
    name: 'Krobokan',
  },
  {
    id: '3374140016',
    districtId: '3374140',
    name: 'Tawangmas',
  },
  {
    id: '3374150001',
    districtId: '3374150',
    name: 'Jerakah',
  },
  {
    id: '3374150002',
    districtId: '3374150',
    name: 'Tugurejo',
  },
  {
    id: '3374150003',
    districtId: '3374150',
    name: 'Karanganyar',
  },
  {
    id: '3374150004',
    districtId: '3374150',
    name: 'Randu Garut',
  },
  {
    id: '3374150005',
    districtId: '3374150',
    name: 'Mangkang Wetan',
  },
  {
    id: '3374150006',
    districtId: '3374150',
    name: 'Mangunharjo',
  },
  {
    id: '3374150007',
    districtId: '3374150',
    name: 'Mangkang Kulon',
  },
  {
    id: '3374160001',
    districtId: '3374160',
    name: 'Podorejo',
  },
  {
    id: '3374160002',
    districtId: '3374160',
    name: 'Wates',
  },
  {
    id: '3374160003',
    districtId: '3374160',
    name: 'Bringin',
  },
  {
    id: '3374160004',
    districtId: '3374160',
    name: 'Ngaliyan',
  },
  {
    id: '3374160005',
    districtId: '3374160',
    name: 'Bambankerep',
  },
  {
    id: '3374160006',
    districtId: '3374160',
    name: 'Kalipancur',
  },
  {
    id: '3374160007',
    districtId: '3374160',
    name: 'Purwoyoso',
  },
  {
    id: '3374160008',
    districtId: '3374160',
    name: 'Tambakaji',
  },
  {
    id: '3374160009',
    districtId: '3374160',
    name: 'Gondoriyo',
  },
  {
    id: '3374160010',
    districtId: '3374160',
    name: 'Wonosari',
  },
  {
    id: '3375010004',
    districtId: '3375010',
    name: 'Medono',
  },
  {
    id: '3375010007',
    districtId: '3375010',
    name: 'Podosugih',
  },
  {
    id: '3375010010',
    districtId: '3375010',
    name: 'Tirto',
  },
  {
    id: '3375010014',
    districtId: '3375010',
    name: 'Pringrejo',
  },
  {
    id: '3375010015',
    districtId: '3375010',
    name: 'Sapuro Kebulen',
  },
  {
    id: '3375010016',
    districtId: '3375010',
    name: 'Bendan Kergon',
  },
  {
    id: '3375010017',
    districtId: '3375010',
    name: 'Pasirkratonkramat',
  },
  {
    id: '3375020007',
    districtId: '3375020',
    name: 'Kauman',
  },
  {
    id: '3375020010',
    districtId: '3375020',
    name: 'Poncol',
  },
  {
    id: '3375020011',
    districtId: '3375020',
    name: 'Klego',
  },
  {
    id: '3375020013',
    districtId: '3375020',
    name: 'Gamer',
  },
  {
    id: '3375020014',
    districtId: '3375020',
    name: 'Noyontaansari',
  },
  {
    id: '3375020015',
    districtId: '3375020',
    name: 'Setono',
  },
  {
    id: '3375020016',
    districtId: '3375020',
    name: 'Kali Baros',
  },
  {
    id: '3375030005',
    districtId: '3375030',
    name: 'Jenggot',
  },
  {
    id: '3375030012',
    districtId: '3375030',
    name: 'Banyurip',
  },
  {
    id: '3375030013',
    districtId: '3375030',
    name: 'Buaran Kradenan',
  },
  {
    id: '3375030014',
    districtId: '3375030',
    name: 'Kuripan Kertoharjo',
  },
  {
    id: '3375030015',
    districtId: '3375030',
    name: 'Kuripan Yosorejo',
  },
  {
    id: '3375030016',
    districtId: '3375030',
    name: 'Sokoduwet',
  },
  {
    id: '3375040004',
    districtId: '3375040',
    name: 'Bandengan',
  },
  {
    id: '3375040005',
    districtId: '3375040',
    name: 'Kandangpanjang',
  },
  {
    id: '3375040006',
    districtId: '3375040',
    name: 'Panjang Wetan',
  },
  {
    id: '3375040009',
    districtId: '3375040',
    name: 'Degayu',
  },
  {
    id: '3375040010',
    districtId: '3375040',
    name: 'Panjang Baru',
  },
  {
    id: '3375040011',
    districtId: '3375040',
    name: 'Krapyak',
  },
  {
    id: '3375040012',
    districtId: '3375040',
    name: 'Padukuhan Kraton',
  },
  {
    id: '3376010001',
    districtId: '3376010',
    name: 'Kalinyamat Wetan',
  },
  {
    id: '3376010002',
    districtId: '3376010',
    name: 'Bandung',
  },
  {
    id: '3376010003',
    districtId: '3376010',
    name: 'Debong Kidul',
  },
  {
    id: '3376010004',
    districtId: '3376010',
    name: 'Tunon',
  },
  {
    id: '3376010006',
    districtId: '3376010',
    name: 'Debong Kulon',
  },
  {
    id: '3376010007',
    districtId: '3376010',
    name: 'Debong Tengah',
  },
  {
    id: '3376010008',
    districtId: '3376010',
    name: 'Randugunting',
  },
  {
    id: '3376020001',
    districtId: '3376020',
    name: 'Kejambon',
  },
  {
    id: '3376020002',
    districtId: '3376020',
    name: 'Slerok',
  },
  {
    id: '3376020003',
    districtId: '3376020',
    name: 'Panggung',
  },
  {
    id: '3376020004',
    districtId: '3376020',
    name: 'Mangkukusuman',
  },
  {
    id: '3376020005',
    districtId: '3376020',
    name: 'Mintaragen',
  },
  {
    id: '3376030001',
    districtId: '3376030',
    name: 'Pesurungan Kidul',
  },
  {
    id: '3376030002',
    districtId: '3376030',
    name: 'Debong Lor',
  },
  {
    id: '3376030003',
    districtId: '3376030',
    name: 'Kemandungan',
  },
  {
    id: '3376030004',
    districtId: '3376030',
    name: 'Pekauman',
  },
  {
    id: '3376030005',
    districtId: '3376030',
    name: 'Kraton',
  },
  {
    id: '3376030006',
    districtId: '3376030',
    name: 'Tegalsari',
  },
  {
    id: '3376030007',
    districtId: '3376030',
    name: 'Muarareja',
  },
  {
    id: '3376040001',
    districtId: '3376040',
    name: 'Kaligangsa',
  },
  {
    id: '3376040002',
    districtId: '3376040',
    name: 'Krandon',
  },
  {
    id: '3376040003',
    districtId: '3376040',
    name: 'Cabawan',
  },
  {
    id: '3376040004',
    districtId: '3376040',
    name: 'Margadana',
  },
  {
    id: '3376040005',
    districtId: '3376040',
    name: 'Kalinyamat Kulon',
  },
  {
    id: '3376040006',
    districtId: '3376040',
    name: 'Sumurpanggang',
  },
  {
    id: '3376040007',
    districtId: '3376040',
    name: 'Pesurungan Lor',
  },
  {
    id: '3401010001',
    districtId: '3401010',
    name: 'Jangkaran',
  },
  {
    id: '3401010002',
    districtId: '3401010',
    name: 'Sindutan',
  },
  {
    id: '3401010003',
    districtId: '3401010',
    name: 'Palihan',
  },
  {
    id: '3401010004',
    districtId: '3401010',
    name: 'Glagah',
  },
  {
    id: '3401010005',
    districtId: '3401010',
    name: 'Kali Dengen',
  },
  {
    id: '3401010006',
    districtId: '3401010',
    name: 'Plumbon',
  },
  {
    id: '3401010007',
    districtId: '3401010',
    name: 'Kedundang',
  },
  {
    id: '3401010010',
    districtId: '3401010',
    name: 'Kaligintung',
  },
  {
    id: '3401010011',
    districtId: '3401010',
    name: 'Temon Wetan',
  },
  {
    id: '3401010012',
    districtId: '3401010',
    name: 'Temon Kulon',
  },
  {
    id: '3401010013',
    districtId: '3401010',
    name: 'Kebonrejo',
  },
  {
    id: '3401010014',
    districtId: '3401010',
    name: 'Janten',
  },
  {
    id: '3401010015',
    districtId: '3401010',
    name: 'Karang Wuluh',
  },
  {
    id: '3401020001',
    districtId: '3401020',
    name: 'Karang Wuni',
  },
  {
    id: '3401020002',
    districtId: '3401020',
    name: 'Sogan',
  },
  {
    id: '3401020003',
    districtId: '3401020',
    name: 'Kulwaru',
  },
  {
    id: '3401020004',
    districtId: '3401020',
    name: 'Ngestiharjo',
  },
  {
    id: '3401020005',
    districtId: '3401020',
    name: 'Triharjo',
  },
  {
    id: '3401020006',
    districtId: '3401020',
    name: 'Bendungan',
  },
  {
    id: '3401020007',
    districtId: '3401020',
    name: 'Giri Peni',
  },
  {
    id: '3401020008',
    districtId: '3401020',
    name: 'Wates',
  },
  {
    id: '3401030001',
    districtId: '3401030',
    name: 'Garongan',
  },
  {
    id: '3401030004',
    districtId: '3401030',
    name: 'Kanoman',
  },
  {
    id: '3401030005',
    districtId: '3401030',
    name: 'Depok',
  },
  {
    id: '3401030006',
    districtId: '3401030',
    name: 'Bojong',
  },
  {
    id: '3401030007',
    districtId: '3401030',
    name: 'Tayuban',
  },
  {
    id: '3401030008',
    districtId: '3401030',
    name: 'Gotakan',
  },
  {
    id: '3401030009',
    districtId: '3401030',
    name: 'Panjatan',
  },
  {
    id: '3401030011',
    districtId: '3401030',
    name: 'Krembangan',
  },
  {
    id: '3401040001',
    districtId: '3401040',
    name: 'Karang Sewu',
  },
  {
    id: '3401040002',
    districtId: '3401040',
    name: 'Banaran',
  },
  {
    id: '3401040003',
    districtId: '3401040',
    name: 'Kranggan',
  },
  {
    id: '3401040004',
    districtId: '3401040',
    name: 'Nomporejo',
  },
  {
    id: '3401040005',
    districtId: '3401040',
    name: 'Brosot',
  },
  {
    id: '3401040006',
    districtId: '3401040',
    name: 'Pandowan',
  },
  {
    id: '3401040007',
    districtId: '3401040',
    name: 'Tirta Rahayu',
  },
  {
    id: '3401050001',
    districtId: '3401050',
    name: 'Wahyuharjo',
  },
  {
    id: '3401050002',
    districtId: '3401050',
    name: 'Bumirejo',
  },
  {
    id: '3401050003',
    districtId: '3401050',
    name: 'Jatirejo',
  },
  {
    id: '3401050004',
    districtId: '3401050',
    name: 'Sidorejo',
  },
  {
    id: '3401050005',
    districtId: '3401050',
    name: 'Gulurejo',
  },
  {
    id: '3401050006',
    districtId: '3401050',
    name: 'Ngentakrejo',
  },
  {
    id: '3401060001',
    districtId: '3401060',
    name: 'Demangrejo',
  },
  {
    id: '3401060002',
    districtId: '3401060',
    name: 'Srikayangan',
  },
  {
    id: '3401060003',
    districtId: '3401060',
    name: 'Tuksono',
  },
  {
    id: '3401060004',
    districtId: '3401060',
    name: 'Salamrejo',
  },
  {
    id: '3401060005',
    districtId: '3401060',
    name: 'Sukoreno',
  },
  {
    id: '3401060006',
    districtId: '3401060',
    name: 'Kaliagung',
  },
  {
    id: '3401060007',
    districtId: '3401060',
    name: 'Sentolo',
  },
  {
    id: '3401060008',
    districtId: '3401060',
    name: 'Banguncipto',
  },
  {
    id: '3401070001',
    districtId: '3401070',
    name: 'Tawangsari',
  },
  {
    id: '3401070002',
    districtId: '3401070',
    name: 'Karangsari',
  },
  {
    id: '3401070003',
    districtId: '3401070',
    name: 'Kedungsari',
  },
  {
    id: '3401070004',
    districtId: '3401070',
    name: 'Margosari',
  },
  {
    id: '3401070005',
    districtId: '3401070',
    name: 'Pengasih',
  },
  {
    id: '3401070006',
    districtId: '3401070',
    name: 'Sendangsari',
  },
  {
    id: '3401070007',
    districtId: '3401070',
    name: 'Sidomulyo',
  },
  {
    id: '3401080001',
    districtId: '3401080',
    name: 'Hargomulyo',
  },
  {
    id: '3401080002',
    districtId: '3401080',
    name: 'Hargorejo',
  },
  {
    id: '3401080003',
    districtId: '3401080',
    name: 'Hargowilis',
  },
  {
    id: '3401080004',
    districtId: '3401080',
    name: 'Kalirejo',
  },
  {
    id: '3401080005',
    districtId: '3401080',
    name: 'Hargotirto',
  },
  {
    id: '3401090001',
    districtId: '3401090',
    name: 'Jatimulyo',
  },
  {
    id: '3401090002',
    districtId: '3401090',
    name: 'Giripurwo',
  },
  {
    id: '3401090003',
    districtId: '3401090',
    name: 'Pendoworejo',
  },
  {
    id: '3401090004',
    districtId: '3401090',
    name: 'Purwosari',
  },
  {
    id: '3401100001',
    districtId: '3401100',
    name: 'Banyuroto',
  },
  {
    id: '3401100002',
    districtId: '3401100',
    name: 'Donomulyo',
  },
  {
    id: '3401100003',
    districtId: '3401100',
    name: 'Wijimulyo',
  },
  {
    id: '3401100004',
    districtId: '3401100',
    name: 'Tanjungharjo',
  },
  {
    id: '3401100005',
    districtId: '3401100',
    name: 'Jati Sarono',
  },
  {
    id: '3401100006',
    districtId: '3401100',
    name: 'Kembang',
  },
  {
    id: '3401110001',
    districtId: '3401110',
    name: 'Banjararum',
  },
  {
    id: '3401110002',
    districtId: '3401110',
    name: 'Banjarasri',
  },
  {
    id: '3401110003',
    districtId: '3401110',
    name: 'Banjarharjo',
  },
  {
    id: '3401110004',
    districtId: '3401110',
    name: 'Banjaroyo',
  },
  {
    id: '3401120001',
    districtId: '3401120',
    name: 'Kebon Harjo',
  },
  {
    id: '3401120002',
    districtId: '3401120',
    name: 'Banjarsari',
  },
  {
    id: '3401120003',
    districtId: '3401120',
    name: 'Purwoharjo',
  },
  {
    id: '3401120004',
    districtId: '3401120',
    name: 'Sidoharjo',
  },
  {
    id: '3401120005',
    districtId: '3401120',
    name: 'Gerbosari',
  },
  {
    id: '3401120006',
    districtId: '3401120',
    name: 'Ngargosari',
  },
  {
    id: '3401120007',
    districtId: '3401120',
    name: 'Pagerharjo',
  },
  {
    id: '3402010001',
    districtId: '3402010',
    name: 'Poncosari',
  },
  {
    id: '3402010002',
    districtId: '3402010',
    name: 'Trimurti',
  },
  {
    id: '3402020001',
    districtId: '3402020',
    name: 'Gadingsari',
  },
  {
    id: '3402020002',
    districtId: '3402020',
    name: 'Gadingharjo',
  },
  {
    id: '3402020003',
    districtId: '3402020',
    name: 'Srigading',
  },
  {
    id: '3402020004',
    districtId: '3402020',
    name: 'Murtigading',
  },
  {
    id: '3402030001',
    districtId: '3402030',
    name: 'Tirtohargo',
  },
  {
    id: '3402030002',
    districtId: '3402030',
    name: 'Parangtritis',
  },
  {
    id: '3402030003',
    districtId: '3402030',
    name: 'Donotirto',
  },
  {
    id: '3402030004',
    districtId: '3402030',
    name: 'Tirtosari',
  },
  {
    id: '3402030005',
    districtId: '3402030',
    name: 'Tirtomulyo',
  },
  {
    id: '3402040001',
    districtId: '3402040',
    name: 'Seloharjo',
  },
  {
    id: '3402040002',
    districtId: '3402040',
    name: 'Panjangrejo',
  },
  {
    id: '3402040003',
    districtId: '3402040',
    name: 'Srihardono',
  },
  {
    id: '3402050001',
    districtId: '3402050',
    name: 'Sidomulyo',
  },
  {
    id: '3402050002',
    districtId: '3402050',
    name: 'Mulyodadi',
  },
  {
    id: '3402050003',
    districtId: '3402050',
    name: 'Sumbermulyo',
  },
  {
    id: '3402060001',
    districtId: '3402060',
    name: 'Caturharjo',
  },
  {
    id: '3402060002',
    districtId: '3402060',
    name: 'Triharjo',
  },
  {
    id: '3402060003',
    districtId: '3402060',
    name: 'Gilangharjo',
  },
  {
    id: '3402060004',
    districtId: '3402060',
    name: 'Wijirejo',
  },
  {
    id: '3402070001',
    districtId: '3402070',
    name: 'Palbapang',
  },
  {
    id: '3402070002',
    districtId: '3402070',
    name: 'Ringin Harjo',
  },
  {
    id: '3402070003',
    districtId: '3402070',
    name: 'Bantul',
  },
  {
    id: '3402070004',
    districtId: '3402070',
    name: 'Trirenggo',
  },
  {
    id: '3402070005',
    districtId: '3402070',
    name: 'Sabdodadi',
  },
  {
    id: '3402080001',
    districtId: '3402080',
    name: 'Patalan',
  },
  {
    id: '3402080002',
    districtId: '3402080',
    name: 'Canden',
  },
  {
    id: '3402080003',
    districtId: '3402080',
    name: 'Sumber Agung',
  },
  {
    id: '3402080004',
    districtId: '3402080',
    name: 'Trimulyo',
  },
  {
    id: '3402090001',
    districtId: '3402090',
    name: 'Selopamioro',
  },
  {
    id: '3402090002',
    districtId: '3402090',
    name: 'Sriharjo',
  },
  {
    id: '3402090003',
    districtId: '3402090',
    name: 'Kebon Agung',
  },
  {
    id: '3402090004',
    districtId: '3402090',
    name: 'Karang Tengah',
  },
  {
    id: '3402090005',
    districtId: '3402090',
    name: 'Girirejo',
  },
  {
    id: '3402090006',
    districtId: '3402090',
    name: 'Karangtalun',
  },
  {
    id: '3402090007',
    districtId: '3402090',
    name: 'Imogiri',
  },
  {
    id: '3402090008',
    districtId: '3402090',
    name: 'Wukirsari',
  },
  {
    id: '3402100001',
    districtId: '3402100',
    name: 'Mangunan',
  },
  {
    id: '3402100003',
    districtId: '3402100',
    name: 'Dlingo',
  },
  {
    id: '3402100005',
    districtId: '3402100',
    name: 'Jatimulyo',
  },
  {
    id: '3402100006',
    districtId: '3402100',
    name: 'Terong',
  },
  {
    id: '3402110001',
    districtId: '3402110',
    name: 'Wonokromo',
  },
  {
    id: '3402110003',
    districtId: '3402110',
    name: 'Segoroyoso',
  },
  {
    id: '3402110004',
    districtId: '3402110',
    name: 'Bawuran',
  },
  {
    id: '3402110005',
    districtId: '3402110',
    name: 'Wonolelo',
  },
  {
    id: '3402120001',
    districtId: '3402120',
    name: 'Sitimulyo',
  },
  {
    id: '3402120002',
    districtId: '3402120',
    name: 'Srimulyo',
  },
  {
    id: '3402120003',
    districtId: '3402120',
    name: 'Srimartani',
  },
  {
    id: '3402130001',
    districtId: '3402130',
    name: 'Tamanan',
  },
  {
    id: '3402130002',
    districtId: '3402130',
    name: 'Jagalan',
  },
  {
    id: '3402130003',
    districtId: '3402130',
    name: 'Singosaren',
  },
  {
    id: '3402130004',
    districtId: '3402130',
    name: 'Wirokerten',
  },
  {
    id: '3402130005',
    districtId: '3402130',
    name: 'Jambidan',
  },
  {
    id: '3402130006',
    districtId: '3402130',
    name: 'Potorono',
  },
  {
    id: '3402130007',
    districtId: '3402130',
    name: 'Baturetno',
  },
  {
    id: '3402130008',
    districtId: '3402130',
    name: 'Banguntapan',
  },
  {
    id: '3402140001',
    districtId: '3402140',
    name: 'Pendowoharjo',
  },
  {
    id: '3402140002',
    districtId: '3402140',
    name: 'Timbulharjo',
  },
  {
    id: '3402140003',
    districtId: '3402140',
    name: 'Bangunharjo',
  },
  {
    id: '3402140004',
    districtId: '3402140',
    name: 'Panggungharjo',
  },
  {
    id: '3402150001',
    districtId: '3402150',
    name: 'Bangunjiwo',
  },
  {
    id: '3402150002',
    districtId: '3402150',
    name: 'Tirtonirmolo',
  },
  {
    id: '3402150003',
    districtId: '3402150',
    name: 'Tamantirto',
  },
  {
    id: '3402150004',
    districtId: '3402150',
    name: 'Ngestiharjo',
  },
  {
    id: '3402160001',
    districtId: '3402160',
    name: 'Triwidadi',
  },
  {
    id: '3402160002',
    districtId: '3402160',
    name: 'Sendangsari',
  },
  {
    id: '3402160003',
    districtId: '3402160',
    name: 'Guwosari',
  },
  {
    id: '3402170001',
    districtId: '3402170',
    name: 'Argodadi',
  },
  {
    id: '3402170002',
    districtId: '3402170',
    name: 'Argorejo',
  },
  {
    id: '3402170003',
    districtId: '3402170',
    name: 'Argosari',
  },
  {
    id: '3402170004',
    districtId: '3402170',
    name: 'Argomulyo',
  },
  {
    id: '3403010006',
    districtId: '3403010',
    name: 'Giriharjo',
  },
  {
    id: '3403010007',
    districtId: '3403010',
    name: 'Giriwungu',
  },
  {
    id: '3403010008',
    districtId: '3403010',
    name: 'Girimulyo',
  },
  {
    id: '3403010009',
    districtId: '3403010',
    name: 'Girikarto',
  },
  {
    id: '3403010010',
    districtId: '3403010',
    name: 'Girisekar',
  },
  {
    id: '3403010011',
    districtId: '3403010',
    name: 'Girisuko',
  },
  {
    id: '3403011001',
    districtId: '3403011',
    name: 'Girijati',
  },
  {
    id: '3403011002',
    districtId: '3403011',
    name: 'Giriasih',
  },
  {
    id: '3403011003',
    districtId: '3403011',
    name: 'Giricahyo',
  },
  {
    id: '3403011004',
    districtId: '3403011',
    name: 'Giripurwo',
  },
  {
    id: '3403011005',
    districtId: '3403011',
    name: 'Giritirto',
  },
  {
    id: '3403020001',
    districtId: '3403020',
    name: 'Karang Duwet',
  },
  {
    id: '3403020002',
    districtId: '3403020',
    name: 'Karang Asem',
  },
  {
    id: '3403020003',
    districtId: '3403020',
    name: 'Mulusan',
  },
  {
    id: '3403020004',
    districtId: '3403020',
    name: 'Giring',
  },
  {
    id: '3403020005',
    districtId: '3403020',
    name: 'Sodo',
  },
  {
    id: '3403020006',
    districtId: '3403020',
    name: 'Pampang',
  },
  {
    id: '3403020007',
    districtId: '3403020',
    name: 'Grogol',
  },
  {
    id: '3403030001',
    districtId: '3403030',
    name: 'Krambil Sawit',
  },
  {
    id: '3403030002',
    districtId: '3403030',
    name: 'Kanigoro',
  },
  {
    id: '3403030003',
    districtId: '3403030',
    name: 'Planjan',
  },
  {
    id: '3403030004',
    districtId: '3403030',
    name: 'Monggol',
  },
  {
    id: '3403030006',
    districtId: '3403030',
    name: 'Nglora',
  },
  {
    id: '3403030007',
    districtId: '3403030',
    name: 'Jetis',
  },
  {
    id: '3403040005',
    districtId: '3403040',
    name: 'Sidoharjo',
  },
  {
    id: '3403040007',
    districtId: '3403040',
    name: 'Purwodadi',
  },
  {
    id: '3403040008',
    districtId: '3403040',
    name: 'Giripanggung',
  },
  {
    id: '3403041001',
    districtId: '3403041',
    name: 'Kemadang',
  },
  {
    id: '3403041002',
    districtId: '3403041',
    name: 'Kemiri',
  },
  {
    id: '3403041003',
    districtId: '3403041',
    name: 'Banjarejo',
  },
  {
    id: '3403041004',
    districtId: '3403041',
    name: 'Ngestirejo',
  },
  {
    id: '3403041005',
    districtId: '3403041',
    name: 'Hargosari',
  },
  {
    id: '3403050007',
    districtId: '3403050',
    name: 'Melikan',
  },
  {
    id: '3403050010',
    districtId: '3403050',
    name: 'Bohol',
  },
  {
    id: '3403050011',
    districtId: '3403050',
    name: 'Pringombo',
  },
  {
    id: '3403050012',
    districtId: '3403050',
    name: 'Botodayakan',
  },
  {
    id: '3403050013',
    districtId: '3403050',
    name: 'Petir',
  },
  {
    id: '3403050014',
    districtId: '3403050',
    name: 'Semugih',
  },
  {
    id: '3403050015',
    districtId: '3403050',
    name: 'Karangwuni',
  },
  {
    id: '3403050016',
    districtId: '3403050',
    name: 'Pucanganom',
  },
  {
    id: '3403051001',
    districtId: '3403051',
    name: 'Balong',
  },
  {
    id: '3403051002',
    districtId: '3403051',
    name: 'Jepitu',
  },
  {
    id: '3403051003',
    districtId: '3403051',
    name: 'Karangawen',
  },
  {
    id: '3403051004',
    districtId: '3403051',
    name: 'Tileng',
  },
  {
    id: '3403051005',
    districtId: '3403051',
    name: 'Nglindur',
  },
  {
    id: '3403051008',
    districtId: '3403051',
    name: 'Songbanyu',
  },
  {
    id: '3403060001',
    districtId: '3403060',
    name: 'Pacarejo',
  },
  {
    id: '3403060002',
    districtId: '3403060',
    name: 'Candirejo',
  },
  {
    id: '3403060003',
    districtId: '3403060',
    name: 'Dadapayu',
  },
  {
    id: '3403060004',
    districtId: '3403060',
    name: 'Ngeposari',
  },
  {
    id: '3403060005',
    districtId: '3403060',
    name: 'Semanu',
  },
  {
    id: '3403070001',
    districtId: '3403070',
    name: 'Gombang',
  },
  {
    id: '3403070002',
    districtId: '3403070',
    name: 'Sidorejo',
  },
  {
    id: '3403070003',
    districtId: '3403070',
    name: 'Bedoyo',
  },
  {
    id: '3403070004',
    districtId: '3403070',
    name: 'Karang Asem',
  },
  {
    id: '3403070005',
    districtId: '3403070',
    name: 'Ponjong',
  },
  {
    id: '3403070006',
    districtId: '3403070',
    name: 'Genjahan',
  },
  {
    id: '3403070007',
    districtId: '3403070',
    name: 'Sumber Giri',
  },
  {
    id: '3403070009',
    districtId: '3403070',
    name: 'Tambakromo',
  },
  {
    id: '3403070010',
    districtId: '3403070',
    name: 'Sawahan',
  },
  {
    id: '3403070011',
    districtId: '3403070',
    name: 'Umbul Rejo',
  },
  {
    id: '3403080001',
    districtId: '3403080',
    name: 'Bendungan',
  },
  {
    id: '3403080002',
    districtId: '3403080',
    name: 'Bejiharjo',
  },
  {
    id: '3403080003',
    districtId: '3403080',
    name: 'Wiladeg',
  },
  {
    id: '3403080004',
    districtId: '3403080',
    name: 'Kelor',
  },
  {
    id: '3403080005',
    districtId: '3403080',
    name: 'Ngipak',
  },
  {
    id: '3403080006',
    districtId: '3403080',
    name: 'Karangmojo',
  },
  {
    id: '3403080007',
    districtId: '3403080',
    name: 'Gedang Rejo',
  },
  {
    id: '3403080008',
    districtId: '3403080',
    name: 'Ngawis',
  },
  {
    id: '3403080009',
    districtId: '3403080',
    name: 'Jati Ayu',
  },
  {
    id: '3403090002',
    districtId: '3403090',
    name: 'Mulo',
  },
  {
    id: '3403090004',
    districtId: '3403090',
    name: 'Wareng',
  },
  {
    id: '3403090005',
    districtId: '3403090',
    name: 'Pulutan',
  },
  {
    id: '3403090006',
    districtId: '3403090',
    name: 'Siraman',
  },
  {
    id: '3403090007',
    districtId: '3403090',
    name: 'Karang Rejek',
  },
  {
    id: '3403090008',
    districtId: '3403090',
    name: 'Baleharjo',
  },
  {
    id: '3403090009',
    districtId: '3403090',
    name: 'Selang',
  },
  {
    id: '3403090010',
    districtId: '3403090',
    name: 'Wonosari',
  },
  {
    id: '3403090012',
    districtId: '3403090',
    name: 'Piyaman',
  },
  {
    id: '3403090013',
    districtId: '3403090',
    name: 'Karang Tengah',
  },
  {
    id: '3403090014',
    districtId: '3403090',
    name: 'Gari',
  },
  {
    id: '3403100001',
    districtId: '3403100',
    name: 'Banyusoco',
  },
  {
    id: '3403100002',
    districtId: '3403100',
    name: 'Plembutan',
  },
  {
    id: '3403100003',
    districtId: '3403100',
    name: 'Bleberan',
  },
  {
    id: '3403100004',
    districtId: '3403100',
    name: 'Getas',
  },
  {
    id: '3403100005',
    districtId: '3403100',
    name: 'Dengok',
  },
  {
    id: '3403100007',
    districtId: '3403100',
    name: 'Playen',
  },
  {
    id: '3403100008',
    districtId: '3403100',
    name: 'Ngawu',
  },
  {
    id: '3403100009',
    districtId: '3403100',
    name: 'Bandung',
  },
  {
    id: '3403100010',
    districtId: '3403100',
    name: 'Logandeng',
  },
  {
    id: '3403100011',
    districtId: '3403100',
    name: 'Gading',
  },
  {
    id: '3403100012',
    districtId: '3403100',
    name: 'Banaran',
  },
  {
    id: '3403100013',
    districtId: '3403100',
    name: 'Ngleri',
  },
  {
    id: '3403110001',
    districtId: '3403110',
    name: 'Semoyo',
  },
  {
    id: '3403110002',
    districtId: '3403110',
    name: 'Pengkok',
  },
  {
    id: '3403110003',
    districtId: '3403110',
    name: 'Beji',
  },
  {
    id: '3403110005',
    districtId: '3403110',
    name: 'Nglegi',
  },
  {
    id: '3403110006',
    districtId: '3403110',
    name: 'Putat',
  },
  {
    id: '3403110007',
    districtId: '3403110',
    name: 'Salam',
  },
  {
    id: '3403110008',
    districtId: '3403110',
    name: 'Patuk',
  },
  {
    id: '3403110009',
    districtId: '3403110',
    name: 'Ngoro Oro',
  },
  {
    id: '3403110010',
    districtId: '3403110',
    name: 'Nglanggeran',
  },
  {
    id: '3403110011',
    districtId: '3403110',
    name: 'Terbah',
  },
  {
    id: '3403120001',
    districtId: '3403120',
    name: 'Ngalang',
  },
  {
    id: '3403120002',
    districtId: '3403120',
    name: 'Hargo Mulyo',
  },
  {
    id: '3403120004',
    districtId: '3403120',
    name: 'Tegalrejo',
  },
  {
    id: '3403120005',
    districtId: '3403120',
    name: 'Watu Gajah',
  },
  {
    id: '3403120006',
    districtId: '3403120',
    name: 'Sampang',
  },
  {
    id: '3403130001',
    districtId: '3403130',
    name: 'Kedung Keris',
  },
  {
    id: '3403130002',
    districtId: '3403130',
    name: 'Nglipar',
  },
  {
    id: '3403130003',
    districtId: '3403130',
    name: 'Pengkol',
  },
  {
    id: '3403130004',
    districtId: '3403130',
    name: 'Kedungpoh',
  },
  {
    id: '3403130005',
    districtId: '3403130',
    name: 'Katongan',
  },
  {
    id: '3403130006',
    districtId: '3403130',
    name: 'Pilang Rejo',
  },
  {
    id: '3403130007',
    districtId: '3403130',
    name: 'Natah',
  },
  {
    id: '3403140001',
    districtId: '3403140',
    name: 'Watu Sigar',
  },
  {
    id: '3403140002',
    districtId: '3403140',
    name: 'Beji',
  },
  {
    id: '3403140003',
    districtId: '3403140',
    name: 'Kampung',
  },
  {
    id: '3403140004',
    districtId: '3403140',
    name: 'Jurang Jero',
  },
  {
    id: '3403140005',
    districtId: '3403140',
    name: 'Sambirejo',
  },
  {
    id: '3403140006',
    districtId: '3403140',
    name: 'Tancep',
  },
  {
    id: '3403150001',
    districtId: '3403150',
    name: 'Kalitekuk',
  },
  {
    id: '3403150002',
    districtId: '3403150',
    name: 'Kemejing',
  },
  {
    id: '3403150003',
    districtId: '3403150',
    name: 'Semin',
  },
  {
    id: '3403150004',
    districtId: '3403150',
    name: 'Pundung Sari',
  },
  {
    id: '3403150005',
    districtId: '3403150',
    name: 'Karang Sari',
  },
  {
    id: '3403150006',
    districtId: '3403150',
    name: 'Rejosari',
  },
  {
    id: '3403150007',
    districtId: '3403150',
    name: 'Bulurejo',
  },
  {
    id: '3403150009',
    districtId: '3403150',
    name: 'Sumberrejo',
  },
  {
    id: '3403150010',
    districtId: '3403150',
    name: 'Candi Rejo',
  },
  {
    id: '3404010001',
    districtId: '3404010',
    name: 'Sumberrahayu',
  },
  {
    id: '3404010002',
    districtId: '3404010',
    name: 'Sumbersari',
  },
  {
    id: '3404010003',
    districtId: '3404010',
    name: 'Sumber Agung',
  },
  {
    id: '3404010004',
    districtId: '3404010',
    name: 'Sumberarum',
  },
  {
    id: '3404020001',
    districtId: '3404020',
    name: 'Sendang Mulyo',
  },
  {
    id: '3404020002',
    districtId: '3404020',
    name: 'Sendang Arum',
  },
  {
    id: '3404020003',
    districtId: '3404020',
    name: 'Sendang Rejo',
  },
  {
    id: '3404020004',
    districtId: '3404020',
    name: 'Sendangsari',
  },
  {
    id: '3404020005',
    districtId: '3404020',
    name: 'Sendangagung',
  },
  {
    id: '3404030001',
    districtId: '3404030',
    name: 'Margoluwih',
  },
  {
    id: '3404030002',
    districtId: '3404030',
    name: 'Margodadi',
  },
  {
    id: '3404030003',
    districtId: '3404030',
    name: 'Margomulyo',
  },
  {
    id: '3404030004',
    districtId: '3404030',
    name: 'Margoagung',
  },
  {
    id: '3404030005',
    districtId: '3404030',
    name: 'Margokaton',
  },
  {
    id: '3404040001',
    districtId: '3404040',
    name: 'Sidorejo',
  },
  {
    id: '3404040002',
    districtId: '3404040',
    name: 'Sidoluhur',
  },
  {
    id: '3404040003',
    districtId: '3404040',
    name: 'Sidomulyo',
  },
  {
    id: '3404040004',
    districtId: '3404040',
    name: 'Sidoagung',
  },
  {
    id: '3404040005',
    districtId: '3404040',
    name: 'Sidokarto',
  },
  {
    id: '3404040006',
    districtId: '3404040',
    name: 'Sidoarum',
  },
  {
    id: '3404040007',
    districtId: '3404040',
    name: 'Sidomoyo',
  },
  {
    id: '3404050001',
    districtId: '3404050',
    name: 'Balecatur',
  },
  {
    id: '3404050002',
    districtId: '3404050',
    name: 'Ambarketawang',
  },
  {
    id: '3404050003',
    districtId: '3404050',
    name: 'Banyuraden',
  },
  {
    id: '3404050004',
    districtId: '3404050',
    name: 'Nogotirto',
  },
  {
    id: '3404050005',
    districtId: '3404050',
    name: 'Trihanggo',
  },
  {
    id: '3404060001',
    districtId: '3404060',
    name: 'Tirtoadi',
  },
  {
    id: '3404060002',
    districtId: '3404060',
    name: 'Sumberadi',
  },
  {
    id: '3404060003',
    districtId: '3404060',
    name: 'Tlogoadi',
  },
  {
    id: '3404060004',
    districtId: '3404060',
    name: 'Sendangadi',
  },
  {
    id: '3404060005',
    districtId: '3404060',
    name: 'Sinduadi',
  },
  {
    id: '3404070001',
    districtId: '3404070',
    name: 'Catur Tunggal',
  },
  {
    id: '3404070002',
    districtId: '3404070',
    name: 'Maguwoharjo',
  },
  {
    id: '3404070003',
    districtId: '3404070',
    name: 'Condong Catur',
  },
  {
    id: '3404080001',
    districtId: '3404080',
    name: 'Sendang Tirto',
  },
  {
    id: '3404080002',
    districtId: '3404080',
    name: 'Tegal Tirto',
  },
  {
    id: '3404080003',
    districtId: '3404080',
    name: 'Jogo Tirto',
  },
  {
    id: '3404080004',
    districtId: '3404080',
    name: 'Kali Tirto',
  },
  {
    id: '3404090001',
    districtId: '3404090',
    name: 'Sumber Harjo',
  },
  {
    id: '3404090002',
    districtId: '3404090',
    name: 'Wukir Harjo',
  },
  {
    id: '3404090003',
    districtId: '3404090',
    name: 'Gayam Harjo',
  },
  {
    id: '3404090004',
    districtId: '3404090',
    name: 'Sambi Rejo',
  },
  {
    id: '3404090005',
    districtId: '3404090',
    name: 'Madu Rejo',
  },
  {
    id: '3404090006',
    districtId: '3404090',
    name: 'Boko Harjo',
  },
  {
    id: '3404100001',
    districtId: '3404100',
    name: 'Purwo Martani',
  },
  {
    id: '3404100002',
    districtId: '3404100',
    name: 'Tirto Martani',
  },
  {
    id: '3404100003',
    districtId: '3404100',
    name: 'Taman Martani',
  },
  {
    id: '3404100004',
    districtId: '3404100',
    name: 'Selo Martani',
  },
  {
    id: '3404110001',
    districtId: '3404110',
    name: 'Wedomartani',
  },
  {
    id: '3404110002',
    districtId: '3404110',
    name: 'Umbulmartani',
  },
  {
    id: '3404110003',
    districtId: '3404110',
    name: 'Widodo Martani',
  },
  {
    id: '3404110004',
    districtId: '3404110',
    name: 'Bimo Martani',
  },
  {
    id: '3404110005',
    districtId: '3404110',
    name: 'Sindumartani',
  },
  {
    id: '3404120001',
    districtId: '3404120',
    name: 'Sari Harjo',
  },
  {
    id: '3404120002',
    districtId: '3404120',
    name: 'Sinduharjo',
  },
  {
    id: '3404120003',
    districtId: '3404120',
    name: 'Minomartani',
  },
  {
    id: '3404120004',
    districtId: '3404120',
    name: 'Suko Harjo',
  },
  {
    id: '3404120005',
    districtId: '3404120',
    name: 'Sardonoharjo',
  },
  {
    id: '3404120006',
    districtId: '3404120',
    name: 'Donoharjo',
  },
  {
    id: '3404130001',
    districtId: '3404130',
    name: 'Catur Harjo',
  },
  {
    id: '3404130002',
    districtId: '3404130',
    name: 'Triharjo',
  },
  {
    id: '3404130003',
    districtId: '3404130',
    name: 'Tridadi',
  },
  {
    id: '3404130004',
    districtId: '3404130',
    name: 'Pandowo Harjo',
  },
  {
    id: '3404130005',
    districtId: '3404130',
    name: 'Tri Mulyo',
  },
  {
    id: '3404140001',
    districtId: '3404140',
    name: 'Banyu Rejo',
  },
  {
    id: '3404140002',
    districtId: '3404140',
    name: 'Tambak Rejo',
  },
  {
    id: '3404140003',
    districtId: '3404140',
    name: 'Sumber Rejo',
  },
  {
    id: '3404140004',
    districtId: '3404140',
    name: 'Pondok Rejo',
  },
  {
    id: '3404140005',
    districtId: '3404140',
    name: 'Moro Rejo',
  },
  {
    id: '3404140006',
    districtId: '3404140',
    name: 'Margo Rejo',
  },
  {
    id: '3404140007',
    districtId: '3404140',
    name: 'Lumbung Rejo',
  },
  {
    id: '3404140008',
    districtId: '3404140',
    name: 'Merdiko Rejo',
  },
  {
    id: '3404150001',
    districtId: '3404150',
    name: 'Bangun Kerto',
  },
  {
    id: '3404150002',
    districtId: '3404150',
    name: 'Donokerto',
  },
  {
    id: '3404150003',
    districtId: '3404150',
    name: 'Giri Kerto',
  },
  {
    id: '3404150004',
    districtId: '3404150',
    name: 'Wono Kerto',
  },
  {
    id: '3404160001',
    districtId: '3404160',
    name: 'Purwo Binangun',
  },
  {
    id: '3404160002',
    districtId: '3404160',
    name: 'Candi Binangun',
  },
  {
    id: '3404160003',
    districtId: '3404160',
    name: 'Harjo Binangun',
  },
  {
    id: '3404160004',
    districtId: '3404160',
    name: 'Pakem Binangun',
  },
  {
    id: '3404160005',
    districtId: '3404160',
    name: 'Hargo Binangun',
  },
  {
    id: '3404170001',
    districtId: '3404170',
    name: 'Wukir Sari',
  },
  {
    id: '3404170002',
    districtId: '3404170',
    name: 'Argo Mulyo',
  },
  {
    id: '3404170003',
    districtId: '3404170',
    name: 'Glagah Harjo',
  },
  {
    id: '3404170004',
    districtId: '3404170',
    name: 'Kepuh Harjo',
  },
  {
    id: '3404170005',
    districtId: '3404170',
    name: 'Umbul Harjo',
  },
  {
    id: '3471010001',
    districtId: '3471010',
    name: 'Gedongkiwo',
  },
  {
    id: '3471010002',
    districtId: '3471010',
    name: 'Suryodiningratan',
  },
  {
    id: '3471010003',
    districtId: '3471010',
    name: 'Mantrijeron',
  },
  {
    id: '3471020001',
    districtId: '3471020',
    name: 'Patehan',
  },
  {
    id: '3471020002',
    districtId: '3471020',
    name: 'Panembahan',
  },
  {
    id: '3471020003',
    districtId: '3471020',
    name: 'Kadipaten',
  },
  {
    id: '3471030001',
    districtId: '3471030',
    name: 'Brontokusuman',
  },
  {
    id: '3471030002',
    districtId: '3471030',
    name: 'Keparakan',
  },
  {
    id: '3471030003',
    districtId: '3471030',
    name: 'Wirogunan',
  },
  {
    id: '3471040001',
    districtId: '3471040',
    name: 'Giwangan',
  },
  {
    id: '3471040002',
    districtId: '3471040',
    name: 'Sorosutan',
  },
  {
    id: '3471040003',
    districtId: '3471040',
    name: 'Pandeyan',
  },
  {
    id: '3471040004',
    districtId: '3471040',
    name: 'Warungboto',
  },
  {
    id: '3471040005',
    districtId: '3471040',
    name: 'Tahunan',
  },
  {
    id: '3471040006',
    districtId: '3471040',
    name: 'Muja Muju',
  },
  {
    id: '3471040007',
    districtId: '3471040',
    name: 'Semaki',
  },
  {
    id: '3471050001',
    districtId: '3471050',
    name: 'Prenggan',
  },
  {
    id: '3471050002',
    districtId: '3471050',
    name: 'Purbayan',
  },
  {
    id: '3471050003',
    districtId: '3471050',
    name: 'Rejowinangun',
  },
  {
    id: '3471060001',
    districtId: '3471060',
    name: 'Baciro',
  },
  {
    id: '3471060002',
    districtId: '3471060',
    name: 'Demangan',
  },
  {
    id: '3471060003',
    districtId: '3471060',
    name: 'Klitren',
  },
  {
    id: '3471060004',
    districtId: '3471060',
    name: 'Kotabaru',
  },
  {
    id: '3471060005',
    districtId: '3471060',
    name: 'Terban',
  },
  {
    id: '3471070001',
    districtId: '3471070',
    name: 'Suryatmajan',
  },
  {
    id: '3471070002',
    districtId: '3471070',
    name: 'Tegal Panggung',
  },
  {
    id: '3471070003',
    districtId: '3471070',
    name: 'Bausasran',
  },
  {
    id: '3471080001',
    districtId: '3471080',
    name: 'Purwo Kinanti',
  },
  {
    id: '3471090001',
    districtId: '3471090',
    name: 'Prawirodirjan',
  },
  {
    id: '3471090002',
    districtId: '3471090',
    name: 'Ngupasan',
  },
  {
    id: '3471100001',
    districtId: '3471100',
    name: 'Notoprajan',
  },
  {
    id: '3471100002',
    districtId: '3471100',
    name: 'Ngampilan',
  },
  {
    id: '3471110001',
    districtId: '3471110',
    name: 'Patangpuluhan',
  },
  {
    id: '3471110002',
    districtId: '3471110',
    name: 'Wirobrajan',
  },
  {
    id: '3471110003',
    districtId: '3471110',
    name: 'Pakuncen',
  },
  {
    id: '3471120001',
    districtId: '3471120',
    name: 'Pringgokusuman',
  },
  {
    id: '3471120002',
    districtId: '3471120',
    name: 'Sosromenduran',
  },
  {
    id: '3471130001',
    districtId: '3471130',
    name: 'Bumijo',
  },
  {
    id: '3471130002',
    districtId: '3471130',
    name: 'Gowongan',
  },
  {
    id: '3471130003',
    districtId: '3471130',
    name: 'Cokrodiningratan',
  },
  {
    id: '3471140001',
    districtId: '3471140',
    name: 'Tegalrejo',
  },
  {
    id: '3471140003',
    districtId: '3471140',
    name: 'Kricak',
  },
  {
    id: '3471140004',
    districtId: '3471140',
    name: 'Karangwaru',
  },
  {
    id: '3501010001',
    districtId: '3501010',
    name: 'Widoro',
  },
  {
    id: '3501010002',
    districtId: '3501010',
    name: 'Sawahan',
  },
  {
    id: '3501010003',
    districtId: '3501010',
    name: 'Kalak',
  },
  {
    id: '3501010004',
    districtId: '3501010',
    name: 'Sendang',
  },
  {
    id: '3501010006',
    districtId: '3501010',
    name: 'Gedompol',
  },
  {
    id: '3501010008',
    districtId: '3501010',
    name: 'Gendaran',
  },
  {
    id: '3501010009',
    districtId: '3501010',
    name: 'Sukodono',
  },
  {
    id: '3501010010',
    districtId: '3501010',
    name: 'Sekar',
  },
  {
    id: '3501010011',
    districtId: '3501010',
    name: 'Donorojo',
  },
  {
    id: '3501010012',
    districtId: '3501010',
    name: 'Belah',
  },
  {
    id: '3501020001',
    districtId: '3501020',
    name: 'Bomo',
  },
  {
    id: '3501020002',
    districtId: '3501020',
    name: 'Sooka',
  },
  {
    id: '3501020004',
    districtId: '3501020',
    name: 'Mendolo Kidul',
  },
  {
    id: '3501020005',
    districtId: '3501020',
    name: 'Mendolo Lor',
  },
  {
    id: '3501020006',
    districtId: '3501020',
    name: 'Kendal',
  },
  {
    id: '3501020007',
    districtId: '3501020',
    name: 'Piton',
  },
  {
    id: '3501020008',
    districtId: '3501020',
    name: 'Wareng',
  },
  {
    id: '3501020009',
    districtId: '3501020',
    name: 'Mantren',
  },
  {
    id: '3501020010',
    districtId: '3501020',
    name: 'Ploso',
  },
  {
    id: '3501020011',
    districtId: '3501020',
    name: 'Gondosari',
  },
  {
    id: '3501020012',
    districtId: '3501020',
    name: 'Tinatar',
  },
  {
    id: '3501020013',
    districtId: '3501020',
    name: 'Kebonsari',
  },
  {
    id: '3501030001',
    districtId: '3501030',
    name: 'Watu Karung',
  },
  {
    id: '3501030002',
    districtId: '3501030',
    name: 'Dersono',
  },
  {
    id: '3501030003',
    districtId: '3501030',
    name: 'Sugihwaras',
  },
  {
    id: '3501030004',
    districtId: '3501030',
    name: 'Jlubang',
  },
  {
    id: '3501030005',
    districtId: '3501030',
    name: 'Candi',
  },
  {
    id: '3501030006',
    districtId: '3501030',
    name: 'Poko',
  },
  {
    id: '3501030007',
    districtId: '3501030',
    name: 'Dadapan',
  },
  {
    id: '3501030008',
    districtId: '3501030',
    name: 'Pringkuku',
  },
  {
    id: '3501030009',
    districtId: '3501030',
    name: 'Sobo',
  },
  {
    id: '3501030010',
    districtId: '3501030',
    name: 'Ngadirejan',
  },
  {
    id: '3501030011',
    districtId: '3501030',
    name: 'Glinggangan',
  },
  {
    id: '3501030013',
    districtId: '3501030',
    name: 'Tamanasri',
  },
  {
    id: '3501040001',
    districtId: '3501040',
    name: 'Sidoharjo',
  },
  {
    id: '3501040002',
    districtId: '3501040',
    name: 'Ploso',
  },
  {
    id: '3501040003',
    districtId: '3501040',
    name: 'Kembang',
  },
  {
    id: '3501040004',
    districtId: '3501040',
    name: 'Sukoharjo',
  },
  {
    id: '3501040005',
    districtId: '3501040',
    name: 'Kayen',
  },
  {
    id: '3501040006',
    districtId: '3501040',
    name: 'Sirnoboyo',
  },
  {
    id: '3501040007',
    districtId: '3501040',
    name: 'Arjowinangun',
  },
  {
    id: '3501040008',
    districtId: '3501040',
    name: 'Baleharjo',
  },
  {
    id: '3501040009',
    districtId: '3501040',
    name: 'Bangunsari',
  },
  {
    id: '3501040011',
    districtId: '3501040',
    name: 'Sumberharjo',
  },
  {
    id: '3501040012',
    districtId: '3501040',
    name: 'Pucangsewu',
  },
  {
    id: '3501040013',
    districtId: '3501040',
    name: 'Pacitan',
  },
  {
    id: '3501040014',
    districtId: '3501040',
    name: 'Tanjungsari',
  },
  {
    id: '3501040015',
    districtId: '3501040',
    name: 'Menadi',
  },
  {
    id: '3501040016',
    districtId: '3501040',
    name: 'Mentoro',
  },
  {
    id: '3501040017',
    districtId: '3501040',
    name: 'Purworejo',
  },
  {
    id: '3501040018',
    districtId: '3501040',
    name: 'Nanggungan',
  },
  {
    id: '3501040019',
    districtId: '3501040',
    name: 'Widoro',
  },
  {
    id: '3501040020',
    districtId: '3501040',
    name: 'Semanten',
  },
  {
    id: '3501040021',
    districtId: '3501040',
    name: 'Banjarsari',
  },
  {
    id: '3501040022',
    districtId: '3501040',
    name: 'Bolosingo',
  },
  {
    id: '3501040023',
    districtId: '3501040',
    name: 'Sambong',
  },
  {
    id: '3501040024',
    districtId: '3501040',
    name: 'Ponggok',
  },
  {
    id: '3501040025',
    districtId: '3501040',
    name: 'Tambakrejo',
  },
  {
    id: '3501050001',
    districtId: '3501050',
    name: 'Plumbungan',
  },
  {
    id: '3501050002',
    districtId: '3501050',
    name: 'Karangnongko',
  },
  {
    id: '3501050003',
    districtId: '3501050',
    name: 'Kalipelus',
  },
  {
    id: '3501050004',
    districtId: '3501050',
    name: 'Katipugal',
  },
  {
    id: '3501050006',
    districtId: '3501050',
    name: 'Sidomulyo',
  },
  {
    id: '3501050007',
    districtId: '3501050',
    name: 'Worawari',
  },
  {
    id: '3501050008',
    districtId: '3501050',
    name: 'Mantren',
  },
  {
    id: '3501050009',
    districtId: '3501050',
    name: 'Gawang',
  },
  {
    id: '3501050010',
    districtId: '3501050',
    name: 'Karanganyar',
  },
  {
    id: '3501050011',
    districtId: '3501050',
    name: 'Kebonagung',
  },
  {
    id: '3501050012',
    districtId: '3501050',
    name: 'Purwoasri',
  },
  {
    id: '3501050013',
    districtId: '3501050',
    name: 'Banjarjo',
  },
  {
    id: '3501050015',
    districtId: '3501050',
    name: 'Sanggrahan',
  },
  {
    id: '3501050017',
    districtId: '3501050',
    name: 'Wonogondo',
  },
  {
    id: '3501050019',
    districtId: '3501050',
    name: 'Ketro',
  },
  {
    id: '3501060001',
    districtId: '3501060',
    name: 'Mlati',
  },
  {
    id: '3501060002',
    districtId: '3501060',
    name: 'Sedayu',
  },
  {
    id: '3501060003',
    districtId: '3501060',
    name: 'Tremas',
  },
  {
    id: '3501060004',
    districtId: '3501060',
    name: 'Arjosari',
  },
  {
    id: '3501060005',
    districtId: '3501060',
    name: 'Gunungsari',
  },
  {
    id: '3501060006',
    districtId: '3501060',
    name: 'Pagutan',
  },
  {
    id: '3501060007',
    districtId: '3501060',
    name: 'Gembong',
  },
  {
    id: '3501060008',
    districtId: '3501060',
    name: 'Borang',
  },
  {
    id: '3501060009',
    districtId: '3501060',
    name: 'Gegeran',
  },
  {
    id: '3501060010',
    districtId: '3501060',
    name: 'Kedungbendo',
  },
  {
    id: '3501060011',
    districtId: '3501060',
    name: 'Mangunharjo',
  },
  {
    id: '3501060012',
    districtId: '3501060',
    name: 'Jetis Kidul',
  },
  {
    id: '3501060013',
    districtId: '3501060',
    name: 'Temon',
  },
  {
    id: '3501060014',
    districtId: '3501060',
    name: 'Jatimalang',
  },
  {
    id: '3501060015',
    districtId: '3501060',
    name: 'Gayuhan',
  },
  {
    id: '3501060016',
    districtId: '3501060',
    name: 'Karangrejo',
  },
  {
    id: '3501060017',
    districtId: '3501060',
    name: 'Karanggede',
  },
  {
    id: '3501070001',
    districtId: '3501070',
    name: 'Gondang',
  },
  {
    id: '3501070002',
    districtId: '3501070',
    name: 'Mujing',
  },
  {
    id: '3501070004',
    districtId: '3501070',
    name: 'Nawangan',
  },
  {
    id: '3501070005',
    districtId: '3501070',
    name: 'Tokawi',
  },
  {
    id: '3501070006',
    districtId: '3501070',
    name: 'Jetislor',
  },
  {
    id: '3501070008',
    districtId: '3501070',
    name: 'Pakisbaru',
  },
  {
    id: '3501070009',
    districtId: '3501070',
    name: 'Ngromo',
  },
  {
    id: '3501080001',
    districtId: '3501080',
    name: 'Petungsinarang',
  },
  {
    id: '3501080003',
    districtId: '3501080',
    name: 'Bandar',
  },
  {
    id: '3501080006',
    districtId: '3501080',
    name: 'Watupatok',
  },
  {
    id: '3501080007',
    districtId: '3501080',
    name: 'Bangunsari',
  },
  {
    id: '3501090001',
    districtId: '3501090',
    name: 'Kebondalem',
  },
  {
    id: '3501090002',
    districtId: '3501090',
    name: 'Gedangan',
  },
  {
    id: '3501090003',
    districtId: '3501090',
    name: 'Ngreco',
  },
  {
    id: '3501090004',
    districtId: '3501090',
    name: 'Kasihan',
  },
  {
    id: '3501090005',
    districtId: '3501090',
    name: 'Pucangombo',
  },
  {
    id: '3501090006',
    districtId: '3501090',
    name: 'Gemaharjo',
  },
  {
    id: '3501090007',
    districtId: '3501090',
    name: 'Ploso',
  },
  {
    id: '3501090008',
    districtId: '3501090',
    name: 'Tegalombo',
  },
  {
    id: '3501090009',
    districtId: '3501090',
    name: 'Kemuning',
  },
  {
    id: '3501090010',
    districtId: '3501090',
    name: 'Tahunan',
  },
  {
    id: '3501090011',
    districtId: '3501090',
    name: 'Tahunan Baru',
  },
  {
    id: '3501100001',
    districtId: '3501100',
    name: 'Jetak',
  },
  {
    id: '3501100002',
    districtId: '3501100',
    name: 'Nglaran',
  },
  {
    id: '3501100003',
    districtId: '3501100',
    name: 'Wonoanti',
  },
  {
    id: '3501100004',
    districtId: '3501100',
    name: 'Padi',
  },
  {
    id: '3501100005',
    districtId: '3501100',
    name: 'Kluwih',
  },
  {
    id: '3501100007',
    districtId: '3501100',
    name: 'Tulakan',
  },
  {
    id: '3501100008',
    districtId: '3501100',
    name: 'Jatigunung',
  },
  {
    id: '3501100009',
    districtId: '3501100',
    name: 'Kalikuning',
  },
  {
    id: '3501100010',
    districtId: '3501100',
    name: 'Gasang',
  },
  {
    id: '3501100011',
    districtId: '3501100',
    name: 'Ngile',
  },
  {
    id: '3501100012',
    districtId: '3501100',
    name: 'Bubakan',
  },
  {
    id: '3501100013',
    districtId: '3501100',
    name: 'Losari',
  },
  {
    id: '3501100015',
    districtId: '3501100',
    name: 'Wonosidi',
  },
  {
    id: '3501100016',
    districtId: '3501100',
    name: 'Ketro',
  },
  {
    id: '3501110001',
    districtId: '3501110',
    name: 'Sidomulyo',
  },
  {
    id: '3501110002',
    districtId: '3501110',
    name: 'Hadiwarno',
  },
  {
    id: '3501110003',
    districtId: '3501110',
    name: 'Tanjungpuro',
  },
  {
    id: '3501110004',
    districtId: '3501110',
    name: 'Hadiluwih',
  },
  {
    id: '3501110005',
    districtId: '3501110',
    name: 'Pagerejo',
  },
  {
    id: '3501110006',
    districtId: '3501110',
    name: 'Wiyoro',
  },
  {
    id: '3501110007',
    districtId: '3501110',
    name: 'Ngadirojo',
  },
  {
    id: '3501110008',
    districtId: '3501110',
    name: 'Bogoharjo',
  },
  {
    id: '3501110009',
    districtId: '3501110',
    name: 'Cokrokembang',
  },
  {
    id: '3501110010',
    districtId: '3501110',
    name: 'Bodag',
  },
  {
    id: '3501110011',
    districtId: '3501110',
    name: 'Tanjunglor',
  },
  {
    id: '3501110012',
    districtId: '3501110',
    name: 'Nogosari',
  },
  {
    id: '3501110013',
    districtId: '3501110',
    name: 'Cangkring',
  },
  {
    id: '3501110014',
    districtId: '3501110',
    name: 'Wonodadi Kulon',
  },
  {
    id: '3501110015',
    districtId: '3501110',
    name: 'Wonodadi Wetan',
  },
  {
    id: '3501110016',
    districtId: '3501110',
    name: 'Wonokarto',
  },
  {
    id: '3501110017',
    districtId: '3501110',
    name: 'Wonosobo',
  },
  {
    id: '3501110018',
    districtId: '3501110',
    name: 'Wonoasri',
  },
  {
    id: '3501120001',
    districtId: '3501120',
    name: 'Pager Kidul',
  },
  {
    id: '3501120002',
    districtId: '3501120',
    name: 'Pager Lor',
  },
  {
    id: '3501120003',
    districtId: '3501120',
    name: 'Sukorejo',
  },
  {
    id: '3501120004',
    districtId: '3501120',
    name: 'Sudimoro',
  },
  {
    id: '3501120005',
    districtId: '3501120',
    name: 'Ketanggung',
  },
  {
    id: '3501120007',
    districtId: '3501120',
    name: 'Sembowo',
  },
  {
    id: '3501120008',
    districtId: '3501120',
    name: 'Karang Mulyo',
  },
  {
    id: '3501120009',
    districtId: '3501120',
    name: 'Gunung Rejo',
  },
  {
    id: '3501120010',
    districtId: '3501120',
    name: 'Sumber Rejo',
  },
  {
    id: '3502010001',
    districtId: '3502010',
    name: 'Baosankidul',
  },
  {
    id: '3502010002',
    districtId: '3502010',
    name: 'Wonodadi',
  },
  {
    id: '3502010003',
    districtId: '3502010',
    name: 'Sendang',
  },
  {
    id: '3502010004',
    districtId: '3502010',
    name: 'Mrayan',
  },
  {
    id: '3502010005',
    districtId: '3502010',
    name: 'Binade',
  },
  {
    id: '3502010006',
    districtId: '3502010',
    name: 'Baosanlor',
  },
  {
    id: '3502010007',
    districtId: '3502010',
    name: 'Ngrayun',
  },
  {
    id: '3502010008',
    districtId: '3502010',
    name: 'Temon',
  },
  {
    id: '3502010010',
    districtId: '3502010',
    name: 'Cepoko',
  },
  {
    id: '3502010011',
    districtId: '3502010',
    name: 'Gedangan',
  },
  {
    id: '3502020001',
    districtId: '3502020',
    name: 'Tugurejo',
  },
  {
    id: '3502020002',
    districtId: '3502020',
    name: 'Senepo',
  },
  {
    id: '3502020003',
    districtId: '3502020',
    name: 'Slahung',
  },
  {
    id: '3502020004',
    districtId: '3502020',
    name: 'Caluk',
  },
  {
    id: '3502020005',
    districtId: '3502020',
    name: 'Broto',
  },
  {
    id: '3502020006',
    districtId: '3502020',
    name: 'Menggare',
  },
  {
    id: '3502020007',
    districtId: '3502020',
    name: 'Kambeng',
  },
  {
    id: '3502020008',
    districtId: '3502020',
    name: 'Wates',
  },
  {
    id: '3502020009',
    districtId: '3502020',
    name: 'Ngilo-Ilo',
  },
  {
    id: '3502020010',
    districtId: '3502020',
    name: 'Duri',
  },
  {
    id: '3502020011',
    districtId: '3502020',
    name: 'Ngloning',
  },
  {
    id: '3502020012',
    districtId: '3502020',
    name: 'Plancungan',
  },
  {
    id: '3502020014',
    districtId: '3502020',
    name: 'Galak',
  },
  {
    id: '3502020016',
    districtId: '3502020',
    name: 'Simo',
  },
  {
    id: '3502020017',
    districtId: '3502020',
    name: 'Crabak',
  },
  {
    id: '3502020018',
    districtId: '3502020',
    name: 'Mojopitu',
  },
  {
    id: '3502020019',
    districtId: '3502020',
    name: 'Gundik',
  },
  {
    id: '3502020020',
    districtId: '3502020',
    name: 'Nailan',
  },
  {
    id: '3502020021',
    districtId: '3502020',
    name: 'Gombang',
  },
  {
    id: '3502020022',
    districtId: '3502020',
    name: 'Janti',
  },
  {
    id: '3502030002',
    districtId: '3502030',
    name: 'Koripan',
  },
  {
    id: '3502030003',
    districtId: '3502030',
    name: 'Bekare',
  },
  {
    id: '3502030004',
    districtId: '3502030',
    name: 'Nambak',
  },
  {
    id: '3502030005',
    districtId: '3502030',
    name: 'Kalisat',
  },
  {
    id: '3502030007',
    districtId: '3502030',
    name: 'Pager',
  },
  {
    id: '3502030008',
    districtId: '3502030',
    name: 'Belang',
  },
  {
    id: '3502030009',
    districtId: '3502030',
    name: 'Bungkal',
  },
  {
    id: '3502030010',
    districtId: '3502030',
    name: 'Ketonggo',
  },
  {
    id: '3502030011',
    districtId: '3502030',
    name: 'Kunti',
  },
  {
    id: '3502030012',
    districtId: '3502030',
    name: 'Bancar',
  },
  {
    id: '3502030013',
    districtId: '3502030',
    name: 'Padas',
  },
  {
    id: '3502030016',
    districtId: '3502030',
    name: 'Sambilawang',
  },
  {
    id: '3502030017',
    districtId: '3502030',
    name: 'Kwajon',
  },
  {
    id: '3502030018',
    districtId: '3502030',
    name: 'Bediwetan',
  },
  {
    id: '3502030019',
    districtId: '3502030',
    name: 'Bedikulon',
  },
  {
    id: '3502040001',
    districtId: '3502040',
    name: 'Gajah',
  },
  {
    id: '3502040002',
    districtId: '3502040',
    name: 'Wringinanom',
  },
  {
    id: '3502040003',
    districtId: '3502040',
    name: 'Ngadisanan',
  },
  {
    id: '3502040004',
    districtId: '3502040',
    name: 'Maguwan',
  },
  {
    id: '3502040005',
    districtId: '3502040',
    name: 'Nglewan',
  },
  {
    id: '3502040006',
    districtId: '3502040',
    name: 'Bedingin',
  },
  {
    id: '3502040007',
    districtId: '3502040',
    name: 'Bancangan',
  },
  {
    id: '3502040008',
    districtId: '3502040',
    name: 'Campurejo',
  },
  {
    id: '3502040009',
    districtId: '3502040',
    name: 'Campursari',
  },
  {
    id: '3502040011',
    districtId: '3502040',
    name: 'Sambit',
  },
  {
    id: '3502040012',
    districtId: '3502040',
    name: 'Besuki',
  },
  {
    id: '3502040013',
    districtId: '3502040',
    name: 'Wilangan',
  },
  {
    id: '3502040014',
    districtId: '3502040',
    name: 'Bangsalan',
  },
  {
    id: '3502040015',
    districtId: '3502040',
    name: 'Kemuning',
  },
  {
    id: '3502040016',
    districtId: '3502040',
    name: 'Jrakah',
  },
  {
    id: '3502050002',
    districtId: '3502050',
    name: 'Pangkal',
  },
  {
    id: '3502050003',
    districtId: '3502050',
    name: 'Tumpakpelem',
  },
  {
    id: '3502050004',
    districtId: '3502050',
    name: 'Tempuran',
  },
  {
    id: '3502050005',
    districtId: '3502050',
    name: 'Sriti',
  },
  {
    id: '3502050006',
    districtId: '3502050',
    name: 'Temon',
  },
  {
    id: '3502050007',
    districtId: '3502050',
    name: 'Sawoo',
  },
  {
    id: '3502050008',
    districtId: '3502050',
    name: 'Prayungan',
  },
  {
    id: '3502050009',
    districtId: '3502050',
    name: 'Tugurejo',
  },
  {
    id: '3502050010',
    districtId: '3502050',
    name: 'Grogol',
  },
  {
    id: '3502050011',
    districtId: '3502050',
    name: 'Ketro',
  },
  {
    id: '3502050012',
    districtId: '3502050',
    name: 'Kori',
  },
  {
    id: '3502050013',
    districtId: '3502050',
    name: 'Bondrang',
  },
  {
    id: '3502050014',
    districtId: '3502050',
    name: 'Ngindeng',
  },
  {
    id: '3502060001',
    districtId: '3502060',
    name: 'Ngadirojo',
  },
  {
    id: '3502060004',
    districtId: '3502060',
    name: 'Sooko',
  },
  {
    id: '3502060005',
    districtId: '3502060',
    name: 'Bedoho',
  },
  {
    id: '3502061001',
    districtId: '3502061',
    name: 'Banjarjo',
  },
  {
    id: '3502061002',
    districtId: '3502061',
    name: 'Pudak Wetan',
  },
  {
    id: '3502061003',
    districtId: '3502061',
    name: 'Pudak Kulon',
  },
  {
    id: '3502061004',
    districtId: '3502061',
    name: 'Krisik',
  },
  {
    id: '3502061005',
    districtId: '3502061',
    name: 'Tambang',
  },
  {
    id: '3502061006',
    districtId: '3502061',
    name: 'Bareng',
  },
  {
    id: '3502070001',
    districtId: '3502070',
    name: 'Karangpatihan',
  },
  {
    id: '3502070002',
    districtId: '3502070',
    name: 'Tegalrejo',
  },
  {
    id: '3502070004',
    districtId: '3502070',
    name: 'Wagirkidul',
  },
  {
    id: '3502070005',
    districtId: '3502070',
    name: 'Singgahan',
  },
  {
    id: '3502070006',
    districtId: '3502070',
    name: 'Patik',
  },
  {
    id: '3502070008',
    districtId: '3502070',
    name: 'Pulung Merdiko',
  },
  {
    id: '3502070009',
    districtId: '3502070',
    name: 'Sidoharjo',
  },
  {
    id: '3502070010',
    districtId: '3502070',
    name: 'Wotan',
  },
  {
    id: '3502070011',
    districtId: '3502070',
    name: 'Plunturan',
  },
  {
    id: '3502070012',
    districtId: '3502070',
    name: 'Pomahan',
  },
  {
    id: '3502070013',
    districtId: '3502070',
    name: 'Kesugihan',
  },
  {
    id: '3502070014',
    districtId: '3502070',
    name: 'Serag',
  },
  {
    id: '3502070015',
    districtId: '3502070',
    name: 'Wayang',
  },
  {
    id: '3502070017',
    districtId: '3502070',
    name: 'Bekiring',
  },
  {
    id: '3502070018',
    districtId: '3502070',
    name: 'Banaran',
  },
  {
    id: '3502080002',
    districtId: '3502080',
    name: 'Candi',
  },
  {
    id: '3502080003',
    districtId: '3502080',
    name: 'Totokan',
  },
  {
    id: '3502080005',
    districtId: '3502080',
    name: 'Siwalan',
  },
  {
    id: '3502080006',
    districtId: '3502080',
    name: 'Joresan',
  },
  {
    id: '3502080007',
    districtId: '3502080',
    name: 'Nglumpang',
  },
  {
    id: '3502080008',
    districtId: '3502080',
    name: 'Gontor',
  },
  {
    id: '3502080009',
    districtId: '3502080',
    name: 'Gandu',
  },
  {
    id: '3502080010',
    districtId: '3502080',
    name: 'Jabung',
  },
  {
    id: '3502080011',
    districtId: '3502080',
    name: 'Bajang',
  },
  {
    id: '3502080012',
    districtId: '3502080',
    name: 'Mlarak',
  },
  {
    id: '3502080013',
    districtId: '3502080',
    name: 'Serangan',
  },
  {
    id: '3502080015',
    districtId: '3502080',
    name: 'Kaponan',
  },
  {
    id: '3502090001',
    districtId: '3502090',
    name: 'Demangan',
  },
  {
    id: '3502090002',
    districtId: '3502090',
    name: 'Ngabar',
  },
  {
    id: '3502090003',
    districtId: '3502090',
    name: 'Madusari',
  },
  {
    id: '3502090004',
    districtId: '3502090',
    name: 'Beton',
  },
  {
    id: '3502090005',
    districtId: '3502090',
    name: 'Sekaran',
  },
  {
    id: '3502090006',
    districtId: '3502090',
    name: 'Brahu',
  },
  {
    id: '3502090008',
    districtId: '3502090',
    name: 'Sawuh',
  },
  {
    id: '3502090009',
    districtId: '3502090',
    name: 'Jarak',
  },
  {
    id: '3502090010',
    districtId: '3502090',
    name: 'Tranjang',
  },
  {
    id: '3502090011',
    districtId: '3502090',
    name: 'Pijeran',
  },
  {
    id: '3502090012',
    districtId: '3502090',
    name: 'Manuk',
  },
  {
    id: '3502090013',
    districtId: '3502090',
    name: 'Siman',
  },
  {
    id: '3502090014',
    districtId: '3502090',
    name: 'Patihan Kidul',
  },
  {
    id: '3502090015',
    districtId: '3502090',
    name: 'Ronosentanan',
  },
  {
    id: '3502090016',
    districtId: '3502090',
    name: 'Tajug',
  },
  {
    id: '3502090017',
    districtId: '3502090',
    name: 'Ronowijayan',
  },
  {
    id: '3502090018',
    districtId: '3502090',
    name: 'Mangunsuman',
  },
  {
    id: '3502100001',
    districtId: '3502100',
    name: 'Ngasinan',
  },
  {
    id: '3502100002',
    districtId: '3502100',
    name: 'Kutukulon',
  },
  {
    id: '3502100003',
    districtId: '3502100',
    name: 'Kutuwetan',
  },
  {
    id: '3502100004',
    districtId: '3502100',
    name: 'Kradenan',
  },
  {
    id: '3502100005',
    districtId: '3502100',
    name: 'Mojomati',
  },
  {
    id: '3502100006',
    districtId: '3502100',
    name: 'Coper',
  },
  {
    id: '3502100007',
    districtId: '3502100',
    name: 'Mojorejo',
  },
  {
    id: '3502100008',
    districtId: '3502100',
    name: 'Karanggebang',
  },
  {
    id: '3502100009',
    districtId: '3502100',
    name: 'Jetis',
  },
  {
    id: '3502100010',
    districtId: '3502100',
    name: 'Tegalsari',
  },
  {
    id: '3502100011',
    districtId: '3502100',
    name: 'Wonoketro',
  },
  {
    id: '3502100012',
    districtId: '3502100',
    name: 'Josari',
  },
  {
    id: '3502100013',
    districtId: '3502100',
    name: 'Turi',
  },
  {
    id: '3502100014',
    districtId: '3502100',
    name: 'Winong',
  },
  {
    id: '3502110001',
    districtId: '3502110',
    name: 'Pandak',
  },
  {
    id: '3502110002',
    districtId: '3502110',
    name: 'Bulukidul',
  },
  {
    id: '3502110003',
    districtId: '3502110',
    name: 'Bulak',
  },
  {
    id: '3502110005',
    districtId: '3502110',
    name: 'Karangpatihan',
  },
  {
    id: '3502110006',
    districtId: '3502110',
    name: 'Sumberejo',
  },
  {
    id: '3502110008',
    districtId: '3502110',
    name: 'Ngraket',
  },
  {
    id: '3502110009',
    districtId: '3502110',
    name: 'Dadapan',
  },
  {
    id: '3502110010',
    districtId: '3502110',
    name: 'Singkil',
  },
  {
    id: '3502110011',
    districtId: '3502110',
    name: 'Karangan',
  },
  {
    id: '3502110012',
    districtId: '3502110',
    name: 'Bajang',
  },
  {
    id: '3502110013',
    districtId: '3502110',
    name: 'Balong',
  },
  {
    id: '3502110014',
    districtId: '3502110',
    name: 'Jalen',
  },
  {
    id: '3502110015',
    districtId: '3502110',
    name: 'Karangmojo',
  },
  {
    id: '3502110016',
    districtId: '3502110',
    name: 'Sedarat',
  },
  {
    id: '3502110017',
    districtId: '3502110',
    name: 'Purworejo',
  },
  {
    id: '3502110018',
    districtId: '3502110',
    name: 'Tatung',
  },
  {
    id: '3502110020',
    districtId: '3502110',
    name: 'Ngampel',
  },
  {
    id: '3502120001',
    districtId: '3502120',
    name: 'Tegalombo',
  },
  {
    id: '3502120002',
    districtId: '3502120',
    name: 'Nongkodono',
  },
  {
    id: '3502120003',
    districtId: '3502120',
    name: 'Sukosari',
  },
  {
    id: '3502120004',
    districtId: '3502120',
    name: 'Ngrandu',
  },
  {
    id: '3502120005',
    districtId: '3502120',
    name: 'Nglarangan',
  },
  {
    id: '3502120006',
    districtId: '3502120',
    name: 'Bringin',
  },
  {
    id: '3502120007',
    districtId: '3502120',
    name: 'Pengkol',
  },
  {
    id: '3502120008',
    districtId: '3502120',
    name: 'Gabel',
  },
  {
    id: '3502120009',
    districtId: '3502120',
    name: 'Ciluk',
  },
  {
    id: '3502120010',
    districtId: '3502120',
    name: 'Semanding',
  },
  {
    id: '3502120011',
    districtId: '3502120',
    name: 'Tosanan',
  },
  {
    id: '3502120012',
    districtId: '3502120',
    name: 'Maron',
  },
  {
    id: '3502120013',
    districtId: '3502120',
    name: 'Somoroto',
  },
  {
    id: '3502120014',
    districtId: '3502120',
    name: 'Plosojenar',
  },
  {
    id: '3502120015',
    districtId: '3502120',
    name: 'Carat',
  },
  {
    id: '3502120016',
    districtId: '3502120',
    name: 'Kauman',
  },
  {
    id: '3502130002',
    districtId: '3502130',
    name: 'Jonggol',
  },
  {
    id: '3502130003',
    districtId: '3502130',
    name: 'Poko',
  },
  {
    id: '3502130004',
    districtId: '3502130',
    name: 'Bringinan',
  },
  {
    id: '3502130005',
    districtId: '3502130',
    name: 'Sendang',
  },
  {
    id: '3502130006',
    districtId: '3502130',
    name: 'Karang Lokidul',
  },
  {
    id: '3502130007',
    districtId: '3502130',
    name: 'Bulu Lor',
  },
  {
    id: '3502130008',
    districtId: '3502130',
    name: 'Jambon',
  },
  {
    id: '3502130010',
    districtId: '3502130',
    name: 'Pulosari',
  },
  {
    id: '3502130011',
    districtId: '3502130',
    name: 'Menang',
  },
  {
    id: '3502130012',
    districtId: '3502130',
    name: 'Srandil',
  },
  {
    id: '3502130013',
    districtId: '3502130',
    name: 'Sidoharjo',
  },
  {
    id: '3502140001',
    districtId: '3502140',
    name: 'Dayakan',
  },
  {
    id: '3502140002',
    districtId: '3502140',
    name: 'Karangan',
  },
  {
    id: '3502140003',
    districtId: '3502140',
    name: 'Tanjunggunung',
  },
  {
    id: '3502140004',
    districtId: '3502140',
    name: 'Karangjoho',
  },
  {
    id: '3502140005',
    districtId: '3502140',
    name: 'Tanjungrejo',
  },
  {
    id: '3502140006',
    districtId: '3502140',
    name: 'Bandaralim',
  },
  {
    id: '3502140007',
    districtId: '3502140',
    name: 'Kapuran',
  },
  {
    id: '3502140008',
    districtId: '3502140',
    name: 'Badegan',
  },
  {
    id: '3502140009',
    districtId: '3502140',
    name: 'Watubonang',
  },
  {
    id: '3502140010',
    districtId: '3502140',
    name: 'Biting',
  },
  {
    id: '3502150001',
    districtId: '3502150',
    name: 'Gelangkulon',
  },
  {
    id: '3502150002',
    districtId: '3502150',
    name: 'Karang Waluh',
  },
  {
    id: '3502150003',
    districtId: '3502150',
    name: 'Glinggang',
  },
  {
    id: '3502150004',
    districtId: '3502150',
    name: 'Carang Rejo',
  },
  {
    id: '3502150006',
    districtId: '3502150',
    name: 'Kunti',
  },
  {
    id: '3502150007',
    districtId: '3502150',
    name: 'Pagerukir',
  },
  {
    id: '3502150008',
    districtId: '3502150',
    name: 'Pohijo',
  },
  {
    id: '3502150009',
    districtId: '3502150',
    name: 'Jenangan',
  },
  {
    id: '3502150011',
    districtId: '3502150',
    name: 'Sampung',
  },
  {
    id: '3502150012',
    districtId: '3502150',
    name: 'Ringin Putih',
  },
  {
    id: '3502160001',
    districtId: '3502160',
    name: 'Morosari',
  },
  {
    id: '3502160002',
    districtId: '3502160',
    name: 'Sragi',
  },
  {
    id: '3502160003',
    districtId: '3502160',
    name: 'Kalimalang',
  },
  {
    id: '3502160004',
    districtId: '3502160',
    name: 'Karanglolor',
  },
  {
    id: '3502160005',
    districtId: '3502160',
    name: 'Gandukepuh',
  },
  {
    id: '3502160006',
    districtId: '3502160',
    name: 'Nambangrejo',
  },
  {
    id: '3502160007',
    districtId: '3502160',
    name: 'Lengkong',
  },
  {
    id: '3502160008',
    districtId: '3502160',
    name: 'Golan',
  },
  {
    id: '3502160009',
    districtId: '3502160',
    name: 'Bangunrejo',
  },
  {
    id: '3502160010',
    districtId: '3502160',
    name: 'Sukorejo',
  },
  {
    id: '3502160011',
    districtId: '3502160',
    name: 'Nampan',
  },
  {
    id: '3502160012',
    districtId: '3502160',
    name: 'Kranggan',
  },
  {
    id: '3502160013',
    districtId: '3502160',
    name: 'Gelanglor',
  },
  {
    id: '3502160014',
    districtId: '3502160',
    name: 'Sidorejo',
  },
  {
    id: '3502160015',
    districtId: '3502160',
    name: 'Gegeran',
  },
  {
    id: '3502160016',
    districtId: '3502160',
    name: 'Prajegan',
  },
  {
    id: '3502160017',
    districtId: '3502160',
    name: 'Serangan',
  },
  {
    id: '3502160018',
    districtId: '3502160',
    name: 'Kedung Banteng',
  },
  {
    id: '3502170001',
    districtId: '3502170',
    name: 'Paju',
  },
  {
    id: '3502170002',
    districtId: '3502170',
    name: 'Brotonegaran',
  },
  {
    id: '3502170003',
    districtId: '3502170',
    name: 'Pakunden',
  },
  {
    id: '3502170004',
    districtId: '3502170',
    name: 'Kepatihan',
  },
  {
    id: '3502170005',
    districtId: '3502170',
    name: 'Surodikraman',
  },
  {
    id: '3502170006',
    districtId: '3502170',
    name: 'Purbosuman',
  },
  {
    id: '3502170007',
    districtId: '3502170',
    name: 'Tonatan',
  },
  {
    id: '3502170008',
    districtId: '3502170',
    name: 'Bangunsari',
  },
  {
    id: '3502170009',
    districtId: '3502170',
    name: 'Taman Arum',
  },
  {
    id: '3502170010',
    districtId: '3502170',
    name: 'Kauman',
  },
  {
    id: '3502170011',
    districtId: '3502170',
    name: 'Tambakbayan',
  },
  {
    id: '3502170012',
    districtId: '3502170',
    name: 'Pinggirsari',
  },
  {
    id: '3502170013',
    districtId: '3502170',
    name: 'Mangkujayan',
  },
  {
    id: '3502170014',
    districtId: '3502170',
    name: 'Banyudono',
  },
  {
    id: '3502170015',
    districtId: '3502170',
    name: 'Nologaten',
  },
  {
    id: '3502170016',
    districtId: '3502170',
    name: 'Cokromenggalan',
  },
  {
    id: '3502170017',
    districtId: '3502170',
    name: 'Keniten',
  },
  {
    id: '3502170018',
    districtId: '3502170',
    name: 'Jingglong',
  },
  {
    id: '3502170019',
    districtId: '3502170',
    name: 'Beduri',
  },
  {
    id: '3502180001',
    districtId: '3502180',
    name: 'Kertosari',
  },
  {
    id: '3502180002',
    districtId: '3502180',
    name: 'Cekok',
  },
  {
    id: '3502180003',
    districtId: '3502180',
    name: 'Patihan Wetan',
  },
  {
    id: '3502180004',
    districtId: '3502180',
    name: 'Kadipaten',
  },
  {
    id: '3502180005',
    districtId: '3502180',
    name: 'Japan',
  },
  {
    id: '3502180006',
    districtId: '3502180',
    name: 'Gupolo',
  },
  {
    id: '3502180007',
    districtId: '3502180',
    name: 'Polorejo',
  },
  {
    id: '3502180008',
    districtId: '3502180',
    name: 'Bareng',
  },
  {
    id: '3502180010',
    districtId: '3502180',
    name: 'Sukosari',
  },
  {
    id: '3502180011',
    districtId: '3502180',
    name: 'Lembah',
  },
  {
    id: '3502180012',
    districtId: '3502180',
    name: 'Pondok',
  },
  {
    id: '3502180013',
    districtId: '3502180',
    name: 'Babadan',
  },
  {
    id: '3502180014',
    districtId: '3502180',
    name: 'Purwosari',
  },
  {
    id: '3502180015',
    districtId: '3502180',
    name: 'Trisono',
  },
  {
    id: '3502190001',
    districtId: '3502190',
    name: 'Mrican',
  },
  {
    id: '3502190002',
    districtId: '3502190',
    name: 'Singosaren',
  },
  {
    id: '3502190003',
    districtId: '3502190',
    name: 'Setono',
  },
  {
    id: '3502190004',
    districtId: '3502190',
    name: 'Plalangan',
  },
  {
    id: '3502190005',
    districtId: '3502190',
    name: 'Ngrupit',
  },
  {
    id: '3502190006',
    districtId: '3502190',
    name: 'Sedah',
  },
  {
    id: '3502190007',
    districtId: '3502190',
    name: 'Pintu',
  },
  {
    id: '3502190008',
    districtId: '3502190',
    name: 'Panjeng',
  },
  {
    id: '3502190009',
    districtId: '3502190',
    name: 'Jimbe',
  },
  {
    id: '3502190010',
    districtId: '3502190',
    name: 'Jenangan',
  },
  {
    id: '3502190011',
    districtId: '3502190',
    name: 'Sraten',
  },
  {
    id: '3502190012',
    districtId: '3502190',
    name: 'Kemiri',
  },
  {
    id: '3502190013',
    districtId: '3502190',
    name: 'Semanding',
  },
  {
    id: '3502190014',
    districtId: '3502190',
    name: 'Tanjung Sari',
  },
  {
    id: '3502190015',
    districtId: '3502190',
    name: 'Nglayang',
  },
  {
    id: '3502190016',
    districtId: '3502190',
    name: 'Paringan',
  },
  {
    id: '3502190017',
    districtId: '3502190',
    name: 'Wates',
  },
  {
    id: '3502200001',
    districtId: '3502200',
    name: 'Ngrogung',
  },
  {
    id: '3502200002',
    districtId: '3502200',
    name: 'Sahang',
  },
  {
    id: '3502200003',
    districtId: '3502200',
    name: 'Wagirlor',
  },
  {
    id: '3502200004',
    districtId: '3502200',
    name: 'Talun',
  },
  {
    id: '3502200005',
    districtId: '3502200',
    name: 'Gondowido',
  },
  {
    id: '3503010002',
    districtId: '3503010',
    name: 'Banjar',
  },
  {
    id: '3503010003',
    districtId: '3503010',
    name: 'Ngrambingan',
  },
  {
    id: '3503010004',
    districtId: '3503010',
    name: 'Ngrencak',
  },
  {
    id: '3503010005',
    districtId: '3503010',
    name: 'Panggul',
  },
  {
    id: '3503010006',
    districtId: '3503010',
    name: 'Gayam',
  },
  {
    id: '3503010007',
    districtId: '3503010',
    name: 'Wonocoyo',
  },
  {
    id: '3503010008',
    districtId: '3503010',
    name: 'Besuki',
  },
  {
    id: '3503010009',
    districtId: '3503010',
    name: 'Terbis',
  },
  {
    id: '3503010010',
    districtId: '3503010',
    name: 'Karangtengah',
  },
  {
    id: '3503010011',
    districtId: '3503010',
    name: 'Kertosono',
  },
  {
    id: '3503010012',
    districtId: '3503010',
    name: 'Bodag',
  },
  {
    id: '3503010013',
    districtId: '3503010',
    name: 'Barang',
  },
  {
    id: '3503010014',
    districtId: '3503010',
    name: 'Sawahan',
  },
  {
    id: '3503010015',
    districtId: '3503010',
    name: 'Manggis',
  },
  {
    id: '3503010016',
    districtId: '3503010',
    name: 'Tangkil',
  },
  {
    id: '3503010017',
    districtId: '3503010',
    name: 'Depok',
  },
  {
    id: '3503020001',
    districtId: '3503020',
    name: 'Ngulungwetan',
  },
  {
    id: '3503020002',
    districtId: '3503020',
    name: 'Ngulungkulon',
  },
  {
    id: '3503020003',
    districtId: '3503020',
    name: 'Sobo',
  },
  {
    id: '3503020004',
    districtId: '3503020',
    name: 'Craken',
  },
  {
    id: '3503020005',
    districtId: '3503020',
    name: 'Masaran',
  },
  {
    id: '3503020006',
    districtId: '3503020',
    name: 'Munjungan',
  },
  {
    id: '3503020007',
    districtId: '3503020',
    name: 'Tawing',
  },
  {
    id: '3503020008',
    districtId: '3503020',
    name: 'Bendoroto',
  },
  {
    id: '3503020009',
    districtId: '3503020',
    name: 'Bangun',
  },
  {
    id: '3503020010',
    districtId: '3503020',
    name: 'Karangturi',
  },
  {
    id: '3503020011',
    districtId: '3503020',
    name: 'Besuki',
  },
  {
    id: '3503030001',
    districtId: '3503030',
    name: 'Karanggandu',
  },
  {
    id: '3503030002',
    districtId: '3503030',
    name: 'Prigi',
  },
  {
    id: '3503030003',
    districtId: '3503030',
    name: 'Tasikmadu',
  },
  {
    id: '3503030004',
    districtId: '3503030',
    name: 'Watulimo',
  },
  {
    id: '3503030005',
    districtId: '3503030',
    name: 'Margomulyo',
  },
  {
    id: '3503030006',
    districtId: '3503030',
    name: 'Sawahan',
  },
  {
    id: '3503030008',
    districtId: '3503030',
    name: 'Slawe',
  },
  {
    id: '3503030009',
    districtId: '3503030',
    name: 'Gemaharjo',
  },
  {
    id: '3503030010',
    districtId: '3503030',
    name: 'Pakel',
  },
  {
    id: '3503030012',
    districtId: '3503030',
    name: 'Watuagung',
  },
  {
    id: '3503040001',
    districtId: '3503040',
    name: 'Ngadimulyo',
  },
  {
    id: '3503040002',
    districtId: '3503040',
    name: 'Karangrejo',
  },
  {
    id: '3503040004',
    districtId: '3503040',
    name: 'Sugihan',
  },
  {
    id: '3503040005',
    districtId: '3503040',
    name: 'Bendoagung',
  },
  {
    id: '3503040006',
    districtId: '3503040',
    name: 'Bogoran',
  },
  {
    id: '3503040007',
    districtId: '3503040',
    name: 'Timahan',
  },
  {
    id: '3503050001',
    districtId: '3503050',
    name: 'Watuagung',
  },
  {
    id: '3503050002',
    districtId: '3503050',
    name: 'Pandean',
  },
  {
    id: '3503050003',
    districtId: '3503050',
    name: 'Salamwates',
  },
  {
    id: '3503050004',
    districtId: '3503050',
    name: 'Ngerdani',
  },
  {
    id: '3503050006',
    districtId: '3503050',
    name: 'Cakul',
  },
  {
    id: '3503050007',
    districtId: '3503050',
    name: 'Siki',
  },
  {
    id: '3503050008',
    districtId: '3503050',
    name: 'Dongko',
  },
  {
    id: '3503050009',
    districtId: '3503050',
    name: 'Sumberbening',
  },
  {
    id: '3503050010',
    districtId: '3503050',
    name: 'Pringapus',
  },
  {
    id: '3503060001',
    districtId: '3503060',
    name: 'Sidomulyo',
  },
  {
    id: '3503060003',
    districtId: '3503060',
    name: 'Joho',
  },
  {
    id: '3503060004',
    districtId: '3503060',
    name: 'Kembangan',
  },
  {
    id: '3503060005',
    districtId: '3503060',
    name: 'Pakel',
  },
  {
    id: '3503060007',
    districtId: '3503060',
    name: 'Jombok',
  },
  {
    id: '3503060008',
    districtId: '3503060',
    name: 'Tanggaran',
  },
  {
    id: '3503060009',
    districtId: '3503060',
    name: 'Karanganyar',
  },
  {
    id: '3503060010',
    districtId: '3503060',
    name: 'Sukokidul',
  },
  {
    id: '3503070005',
    districtId: '3503070',
    name: 'Sukowetan',
  },
  {
    id: '3503070006',
    districtId: '3503070',
    name: 'Jatiprahu',
  },
  {
    id: '3503070007',
    districtId: '3503070',
    name: 'Sumberingin',
  },
  {
    id: '3503070008',
    districtId: '3503070',
    name: 'Kedungsigit',
  },
  {
    id: '3503070009',
    districtId: '3503070',
    name: 'Jati',
  },
  {
    id: '3503070013',
    districtId: '3503070',
    name: 'Kayen',
  },
  {
    id: '3503070014',
    districtId: '3503070',
    name: 'Karangan',
  },
  {
    id: '3503070015',
    districtId: '3503070',
    name: 'Kerjo',
  },
  {
    id: '3503070016',
    districtId: '3503070',
    name: 'Salamrejo',
  },
  {
    id: '3503070017',
    districtId: '3503070',
    name: 'Buluagung',
  },
  {
    id: '3503070019',
    districtId: '3503070',
    name: 'Ngentrong',
  },
  {
    id: '3503071001',
    districtId: '3503071',
    name: 'Ngrandu',
  },
  {
    id: '3503071003',
    districtId: '3503071',
    name: 'Wonokerto',
  },
  {
    id: '3503071004',
    districtId: '3503071',
    name: 'Nglebo',
  },
  {
    id: '3503071005',
    districtId: '3503071',
    name: 'Gamping',
  },
  {
    id: '3503071007',
    districtId: '3503071',
    name: 'Mlinjon',
  },
  {
    id: '3503080001',
    districtId: '3503080',
    name: 'Ngrayung',
  },
  {
    id: '3503080002',
    districtId: '3503080',
    name: 'Jajar',
  },
  {
    id: '3503080003',
    districtId: '3503080',
    name: 'Wonorejo',
  },
  {
    id: '3503080004',
    districtId: '3503080',
    name: 'Sukorejo',
  },
  {
    id: '3503080005',
    districtId: '3503080',
    name: 'Gandusari',
  },
  {
    id: '3503080006',
    districtId: '3503080',
    name: 'Wonoanti',
  },
  {
    id: '3503080007',
    districtId: '3503080',
    name: 'Widoro',
  },
  {
    id: '3503080008',
    districtId: '3503080',
    name: 'Karanganyar',
  },
  {
    id: '3503080009',
    districtId: '3503080',
    name: 'Melis',
  },
  {
    id: '3503080010',
    districtId: '3503080',
    name: 'Krandegan',
  },
  {
    id: '3503080011',
    districtId: '3503080',
    name: 'Sukorame',
  },
  {
    id: '3503090001',
    districtId: '3503090',
    name: 'Ngadisuko',
  },
  {
    id: '3503090002',
    districtId: '3503090',
    name: 'Durenan',
  },
  {
    id: '3503090003',
    districtId: '3503090',
    name: 'Pandean',
  },
  {
    id: '3503090004',
    districtId: '3503090',
    name: 'Panggungsari',
  },
  {
    id: '3503090005',
    districtId: '3503090',
    name: 'Malasan',
  },
  {
    id: '3503090006',
    districtId: '3503090',
    name: 'Karanganom',
  },
  {
    id: '3503090007',
    districtId: '3503090',
    name: 'Baruharjo',
  },
  {
    id: '3503090008',
    districtId: '3503090',
    name: 'Kamulan',
  },
  {
    id: '3503090009',
    districtId: '3503090',
    name: 'Sumbergayam',
  },
  {
    id: '3503090010',
    districtId: '3503090',
    name: 'Pakis',
  },
  {
    id: '3503090011',
    districtId: '3503090',
    name: 'Semarum',
  },
  {
    id: '3503090012',
    districtId: '3503090',
    name: 'Kendalrejo',
  },
  {
    id: '3503090013',
    districtId: '3503090',
    name: 'Gador',
  },
  {
    id: '3503090014',
    districtId: '3503090',
    name: 'Sumberejo',
  },
  {
    id: '3503100001',
    districtId: '3503100',
    name: 'Ngadirejo',
  },
  {
    id: '3503100002',
    districtId: '3503100',
    name: 'Kedunglurah',
  },
  {
    id: '3503100003',
    districtId: '3503100',
    name: 'Bendorejo',
  },
  {
    id: '3503100004',
    districtId: '3503100',
    name: 'Wonocoyo',
  },
  {
    id: '3503100005',
    districtId: '3503100',
    name: 'Ngetal',
  },
  {
    id: '3503100006',
    districtId: '3503100',
    name: 'Ngadirenggo',
  },
  {
    id: '3503100008',
    districtId: '3503100',
    name: 'Ngulanwetan',
  },
  {
    id: '3503100009',
    districtId: '3503100',
    name: 'Ngulankulon',
  },
  {
    id: '3503100010',
    districtId: '3503100',
    name: 'Pogalan',
  },
  {
    id: '3503110001',
    districtId: '3503110',
    name: 'Karangsoko',
  },
  {
    id: '3503110002',
    districtId: '3503110',
    name: 'Sambirejo',
  },
  {
    id: '3503110003',
    districtId: '3503110',
    name: 'Kelutan',
  },
  {
    id: '3503110004',
    districtId: '3503110',
    name: 'Tamanan',
  },
  {
    id: '3503110005',
    districtId: '3503110',
    name: 'Ngantru',
  },
  {
    id: '3503110006',
    districtId: '3503110',
    name: 'Sumbergedong',
  },
  {
    id: '3503110007',
    districtId: '3503110',
    name: 'Surodakan',
  },
  {
    id: '3503110008',
    districtId: '3503110',
    name: 'Rejowinangun',
  },
  {
    id: '3503110009',
    districtId: '3503110',
    name: 'Parakan',
  },
  {
    id: '3503110010',
    districtId: '3503110',
    name: 'Ngares',
  },
  {
    id: '3503110011',
    districtId: '3503110',
    name: 'Sumberdadi',
  },
  {
    id: '3503110012',
    districtId: '3503110',
    name: 'Sukosari',
  },
  {
    id: '3503110013',
    districtId: '3503110',
    name: 'Dawuhan',
  },
  {
    id: '3503120004',
    districtId: '3503120',
    name: 'Gondang',
  },
  {
    id: '3503120005',
    districtId: '3503120',
    name: 'Nglongsor',
  },
  {
    id: '3503120006',
    districtId: '3503120',
    name: 'Banaran',
  },
  {
    id: '3503120007',
    districtId: '3503120',
    name: 'Winong',
  },
  {
    id: '3503120008',
    districtId: '3503120',
    name: 'Sukorejo',
  },
  {
    id: '3503120009',
    districtId: '3503120',
    name: 'Jambu',
  },
  {
    id: '3503120010',
    districtId: '3503120',
    name: 'Nglinggis',
  },
  {
    id: '3503120011',
    districtId: '3503120',
    name: 'Gading',
  },
  {
    id: '3503120012',
    districtId: '3503120',
    name: 'Pucanganak',
  },
  {
    id: '3503120013',
    districtId: '3503120',
    name: 'Dermosari',
  },
  {
    id: '3503120014',
    districtId: '3503120',
    name: 'Tegaren',
  },
  {
    id: '3503120015',
    districtId: '3503120',
    name: 'Prambon',
  },
  {
    id: '3503130001',
    districtId: '3503130',
    name: 'Masaran',
  },
  {
    id: '3503130002',
    districtId: '3503130',
    name: 'Sengon',
  },
  {
    id: '3503130004',
    districtId: '3503130',
    name: 'Srabah',
  },
  {
    id: '3503130005',
    districtId: '3503130',
    name: 'Depok',
  },
  {
    id: '3503130006',
    districtId: '3503130',
    name: 'Surenlor',
  },
  {
    id: '3503130007',
    districtId: '3503130',
    name: 'Dompyong',
  },
  {
    id: '3503130008',
    districtId: '3503130',
    name: 'Botoputih',
  },
  {
    id: '3504010001',
    districtId: '3504010',
    name: 'Sedayugunung',
  },
  {
    id: '3504010002',
    districtId: '3504010',
    name: 'Keboireng',
  },
  {
    id: '3504010003',
    districtId: '3504010',
    name: 'Besuki',
  },
  {
    id: '3504010004',
    districtId: '3504010',
    name: 'Besole',
  },
  {
    id: '3504010005',
    districtId: '3504010',
    name: 'Tanggulwelahan',
  },
  {
    id: '3504010006',
    districtId: '3504010',
    name: 'Tanggulturus',
  },
  {
    id: '3504010007',
    districtId: '3504010',
    name: 'Tanggulkundung',
  },
  {
    id: '3504010008',
    districtId: '3504010',
    name: 'Wateskroyo',
  },
  {
    id: '3504010009',
    districtId: '3504010',
    name: 'Siyotobagus',
  },
  {
    id: '3504010010',
    districtId: '3504010',
    name: 'Tulungrejo',
  },
  {
    id: '3504020001',
    districtId: '3504020',
    name: 'Nglampir',
  },
  {
    id: '3504020002',
    districtId: '3504020',
    name: 'Talunkulon',
  },
  {
    id: '3504020003',
    districtId: '3504020',
    name: 'Bantengan',
  },
  {
    id: '3504020004',
    districtId: '3504020',
    name: 'Kedungwilut',
  },
  {
    id: '3504020005',
    districtId: '3504020',
    name: 'Suwaru',
  },
  {
    id: '3504020006',
    districtId: '3504020',
    name: 'Ngunggahan',
  },
  {
    id: '3504020007',
    districtId: '3504020',
    name: 'Suruhan Kidul',
  },
  {
    id: '3504020008',
    districtId: '3504020',
    name: 'Bandung',
  },
  {
    id: '3504020009',
    districtId: '3504020',
    name: 'Mergayu',
  },
  {
    id: '3504020010',
    districtId: '3504020',
    name: 'Sebalor',
  },
  {
    id: '3504020011',
    districtId: '3504020',
    name: 'Sukoharjo',
  },
  {
    id: '3504020012',
    districtId: '3504020',
    name: 'Singgit',
  },
  {
    id: '3504020013',
    districtId: '3504020',
    name: 'Suruhan Lor',
  },
  {
    id: '3504020014',
    districtId: '3504020',
    name: 'Kesambi',
  },
  {
    id: '3504020015',
    districtId: '3504020',
    name: 'Gandong',
  },
  {
    id: '3504020018',
    districtId: '3504020',
    name: 'Soko',
  },
  {
    id: '3504030001',
    districtId: '3504030',
    name: 'Sambitan',
  },
  {
    id: '3504030002',
    districtId: '3504030',
    name: 'Bono',
  },
  {
    id: '3504030003',
    districtId: '3504030',
    name: 'Sukoanyar',
  },
  {
    id: '3504030005',
    districtId: '3504030',
    name: 'Tamban',
  },
  {
    id: '3504030006',
    districtId: '3504030',
    name: 'Ngebong',
  },
  {
    id: '3504030007',
    districtId: '3504030',
    name: 'Sodo',
  },
  {
    id: '3504030008',
    districtId: '3504030',
    name: 'Gombang',
  },
  {
    id: '3504030009',
    districtId: '3504030',
    name: 'Pakel',
  },
  {
    id: '3504030010',
    districtId: '3504030',
    name: 'Suwaluh',
  },
  {
    id: '3504030012',
    districtId: '3504030',
    name: 'Bangunmulyo',
  },
  {
    id: '3504030013',
    districtId: '3504030',
    name: 'Kasreman',
  },
  {
    id: '3504030014',
    districtId: '3504030',
    name: 'Sanan',
  },
  {
    id: '3504030015',
    districtId: '3504030',
    name: 'Bangunjaya',
  },
  {
    id: '3504030016',
    districtId: '3504030',
    name: 'Ngrance',
  },
  {
    id: '3504030017',
    districtId: '3504030',
    name: 'Gebang',
  },
  {
    id: '3504030018',
    districtId: '3504030',
    name: 'Gesikan',
  },
  {
    id: '3504030019',
    districtId: '3504030',
    name: 'Gempolan',
  },
  {
    id: '3504040001',
    districtId: '3504040',
    name: 'Ngentrong',
  },
  {
    id: '3504040002',
    districtId: '3504040',
    name: 'Sawo',
  },
  {
    id: '3504040003',
    districtId: '3504040',
    name: 'Gedangan',
  },
  {
    id: '3504040004',
    districtId: '3504040',
    name: 'Gamping',
  },
  {
    id: '3504040005',
    districtId: '3504040',
    name: 'Campurdarat',
  },
  {
    id: '3504040006',
    districtId: '3504040',
    name: 'Wates',
  },
  {
    id: '3504040008',
    districtId: '3504040',
    name: 'Pojok',
  },
  {
    id: '3504040009',
    districtId: '3504040',
    name: 'Tanggung',
  },
  {
    id: '3504050001',
    districtId: '3504050',
    name: 'Ngrejo',
  },
  {
    id: '3504050002',
    districtId: '3504050',
    name: 'Jengglungharjo',
  },
  {
    id: '3504050003',
    districtId: '3504050',
    name: 'Kresikan',
  },
  {
    id: '3504050004',
    districtId: '3504050',
    name: 'Tanggunggunung',
  },
  {
    id: '3504050005',
    districtId: '3504050',
    name: 'Ngepoh',
  },
  {
    id: '3504050006',
    districtId: '3504050',
    name: 'Tenggarejo',
  },
  {
    id: '3504050007',
    districtId: '3504050',
    name: 'Pakisrejo',
  },
  {
    id: '3504060001',
    districtId: '3504060',
    name: 'Kalibatur',
  },
  {
    id: '3504060002',
    districtId: '3504060',
    name: 'Rejosari',
  },
  {
    id: '3504060003',
    districtId: '3504060',
    name: 'Sukorejo Kulon',
  },
  {
    id: '3504060004',
    districtId: '3504060',
    name: 'Banyuurip',
  },
  {
    id: '3504060005',
    districtId: '3504060',
    name: 'Winong',
  },
  {
    id: '3504060006',
    districtId: '3504060',
    name: 'Joho',
  },
  {
    id: '3504060007',
    districtId: '3504060',
    name: 'Pakisaji',
  },
  {
    id: '3504060008',
    districtId: '3504060',
    name: 'Karangtalun',
  },
  {
    id: '3504060009',
    districtId: '3504060',
    name: 'Kalidawir',
  },
  {
    id: '3504060010',
    districtId: '3504060',
    name: 'Ngubalan',
  },
  {
    id: '3504060011',
    districtId: '3504060',
    name: 'Salak Kembang',
  },
  {
    id: '3504060012',
    districtId: '3504060',
    name: 'Tunggangri',
  },
  {
    id: '3504060013',
    districtId: '3504060',
    name: 'Jabon',
  },
  {
    id: '3504060014',
    districtId: '3504060',
    name: 'Pagersari',
  },
  {
    id: '3504060015',
    districtId: '3504060',
    name: 'Betak',
  },
  {
    id: '3504060016',
    districtId: '3504060',
    name: 'Tanjung',
  },
  {
    id: '3504060017',
    districtId: '3504060',
    name: 'Domasan',
  },
  {
    id: '3504070001',
    districtId: '3504070',
    name: 'Panggungkalak',
  },
  {
    id: '3504070002',
    districtId: '3504070',
    name: 'Kalidawe',
  },
  {
    id: '3504070003',
    districtId: '3504070',
    name: 'Pucanglaban',
  },
  {
    id: '3504070004',
    districtId: '3504070',
    name: 'Sumberbendo',
  },
  {
    id: '3504070005',
    districtId: '3504070',
    name: 'Kaligentong',
  },
  {
    id: '3504070006',
    districtId: '3504070',
    name: 'Manding',
  },
  {
    id: '3504070007',
    districtId: '3504070',
    name: 'Panggunguni',
  },
  {
    id: '3504070008',
    districtId: '3504070',
    name: 'Sumberdadap',
  },
  {
    id: '3504080001',
    districtId: '3504080',
    name: 'Tenggong',
  },
  {
    id: '3504080002',
    districtId: '3504080',
    name: 'Panjerejo',
  },
  {
    id: '3504080003',
    districtId: '3504080',
    name: 'Karangsari',
  },
  {
    id: '3504080005',
    districtId: '3504080',
    name: 'Sukorejo Wetan',
  },
  {
    id: '3504080006',
    districtId: '3504080',
    name: 'Tanen',
  },
  {
    id: '3504080007',
    districtId: '3504080',
    name: 'Sumberagung',
  },
  {
    id: '3504080008',
    districtId: '3504080',
    name: 'Blimbing',
  },
  {
    id: '3504080009',
    districtId: '3504080',
    name: 'Pakisrejo',
  },
  {
    id: '3504080010',
    districtId: '3504080',
    name: 'Tegalrejo',
  },
  {
    id: '3504080011',
    districtId: '3504080',
    name: 'Banjarejo',
  },
  {
    id: '3504080012',
    districtId: '3504080',
    name: 'Jatidowo',
  },
  {
    id: '3504080014',
    districtId: '3504080',
    name: 'Buntaran',
  },
  {
    id: '3504080015',
    districtId: '3504080',
    name: 'Ariyojeding',
  },
  {
    id: '3504080016',
    districtId: '3504080',
    name: 'Rejotangan',
  },
  {
    id: '3504090001',
    districtId: '3504090',
    name: 'Balesono',
  },
  {
    id: '3504090002',
    districtId: '3504090',
    name: 'Selorejo',
  },
  {
    id: '3504090003',
    districtId: '3504090',
    name: 'Samir',
  },
  {
    id: '3504090004',
    districtId: '3504090',
    name: 'Karangsono',
  },
  {
    id: '3504090005',
    districtId: '3504090',
    name: 'Kacangan',
  },
  {
    id: '3504090006',
    districtId: '3504090',
    name: 'Pandansari',
  },
  {
    id: '3504090007',
    districtId: '3504090',
    name: 'Sumberingin Kulon',
  },
  {
    id: '3504090008',
    districtId: '3504090',
    name: 'Sumberingin Kidul',
  },
  {
    id: '3504090009',
    districtId: '3504090',
    name: 'Kalangan',
  },
  {
    id: '3504090010',
    districtId: '3504090',
    name: 'Gilang',
  },
  {
    id: '3504090011',
    districtId: '3504090',
    name: 'Kaliwungu',
  },
  {
    id: '3504090013',
    districtId: '3504090',
    name: 'Sumberejo Wetan',
  },
  {
    id: '3504090014',
    districtId: '3504090',
    name: 'Sumberejo Kulon',
  },
  {
    id: '3504090015',
    districtId: '3504090',
    name: 'Purworejo',
  },
  {
    id: '3504090016',
    districtId: '3504090',
    name: 'Kromasan',
  },
  {
    id: '3504090017',
    districtId: '3504090',
    name: 'Pulosari',
  },
  {
    id: '3504090018',
    districtId: '3504090',
    name: 'Pulotondo',
  },
  {
    id: '3504100002',
    districtId: '3504100',
    name: 'Podorejo',
  },
  {
    id: '3504100003',
    districtId: '3504100',
    name: 'Wates',
  },
  {
    id: '3504100004',
    districtId: '3504100',
    name: 'Sambidoplang',
  },
  {
    id: '3504100005',
    districtId: '3504100',
    name: 'Mirigambar',
  },
  {
    id: '3504100007',
    districtId: '3504100',
    name: 'Bendilwungu',
  },
  {
    id: '3504100008',
    districtId: '3504100',
    name: 'Sambijajar',
  },
  {
    id: '3504100009',
    districtId: '3504100',
    name: 'Tambakrejo',
  },
  {
    id: '3504100010',
    districtId: '3504100',
    name: 'Doroampel',
  },
  {
    id: '3504100011',
    districtId: '3504100',
    name: 'Wonorejo',
  },
  {
    id: '3504100012',
    districtId: '3504100',
    name: 'Bendiljati Kulon',
  },
  {
    id: '3504100013',
    districtId: '3504100',
    name: 'Bendiljati Wetan',
  },
  {
    id: '3504100014',
    districtId: '3504100',
    name: 'Sumberdadi',
  },
  {
    id: '3504100015',
    districtId: '3504100',
    name: 'Jabalsari',
  },
  {
    id: '3504100016',
    districtId: '3504100',
    name: 'Sambirobyong',
  },
  {
    id: '3504110001',
    districtId: '3504110',
    name: 'Ngranti',
  },
  {
    id: '3504110002',
    districtId: '3504110',
    name: 'Kendalbulur',
  },
  {
    id: '3504110003',
    districtId: '3504110',
    name: 'Boyolangu',
  },
  {
    id: '3504110004',
    districtId: '3504110',
    name: 'Pucung Kidul',
  },
  {
    id: '3504110005',
    districtId: '3504110',
    name: 'Sanggrahan',
  },
  {
    id: '3504110006',
    districtId: '3504110',
    name: 'Wajak Kidul',
  },
  {
    id: '3504110007',
    districtId: '3504110',
    name: 'Karangrejo',
  },
  {
    id: '3504110008',
    districtId: '3504110',
    name: 'Wajak Lor',
  },
  {
    id: '3504110010',
    districtId: '3504110',
    name: 'Tanjungsari',
  },
  {
    id: '3504110012',
    districtId: '3504110',
    name: 'Beji',
  },
  {
    id: '3504110013',
    districtId: '3504110',
    name: 'Sobontoro',
  },
  {
    id: '3504110014',
    districtId: '3504110',
    name: 'Gedangsewu',
  },
  {
    id: '3504110015',
    districtId: '3504110',
    name: 'Moyoketen',
  },
  {
    id: '3504110016',
    districtId: '3504110',
    name: 'Waung',
  },
  {
    id: '3504110017',
    districtId: '3504110',
    name: 'Bono',
  },
  {
    id: '3504120001',
    districtId: '3504120',
    name: 'Kedungsoko',
  },
  {
    id: '3504120003',
    districtId: '3504120',
    name: 'Karangwaru',
  },
  {
    id: '3504120004',
    districtId: '3504120',
    name: 'Tamanan',
  },
  {
    id: '3504120006',
    districtId: '3504120',
    name: 'Bago',
  },
  {
    id: '3504120007',
    districtId: '3504120',
    name: 'Kepatihan',
  },
  {
    id: '3504120008',
    districtId: '3504120',
    name: 'Kampungdalem',
  },
  {
    id: '3504120009',
    districtId: '3504120',
    name: 'Kauman',
  },
  {
    id: '3504120010',
    districtId: '3504120',
    name: 'Kutoanyar',
  },
  {
    id: '3504120012',
    districtId: '3504120',
    name: 'Panggungrejo',
  },
  {
    id: '3504120013',
    districtId: '3504120',
    name: 'Botoran',
  },
  {
    id: '3504120014',
    districtId: '3504120',
    name: 'Kenayan',
  },
  {
    id: '3504130001',
    districtId: '3504130',
    name: 'Plosokandang',
  },
  {
    id: '3504130002',
    districtId: '3504130',
    name: 'Tunggulsari',
  },
  {
    id: '3504130003',
    districtId: '3504130',
    name: 'Ringinpitu',
  },
  {
    id: '3504130004',
    districtId: '3504130',
    name: 'Loderesan',
  },
  {
    id: '3504130005',
    districtId: '3504130',
    name: 'Bulusari',
  },
  {
    id: '3504130006',
    districtId: '3504130',
    name: 'Bangoan',
  },
  {
    id: '3504130007',
    districtId: '3504130',
    name: 'Rejoagung',
  },
  {
    id: '3504130008',
    districtId: '3504130',
    name: 'Kedungwaru',
  },
  {
    id: '3504130009',
    districtId: '3504130',
    name: 'Plandaan',
  },
  {
    id: '3504130010',
    districtId: '3504130',
    name: 'Mangunsari',
  },
  {
    id: '3504130011',
    districtId: '3504130',
    name: 'Tawangsari',
  },
  {
    id: '3504130012',
    districtId: '3504130',
    name: 'Winong',
  },
  {
    id: '3504130013',
    districtId: '3504130',
    name: 'Majan',
  },
  {
    id: '3504130014',
    districtId: '3504130',
    name: 'Simo',
  },
  {
    id: '3504130015',
    districtId: '3504130',
    name: 'Ketanon',
  },
  {
    id: '3504130016',
    districtId: '3504130',
    name: 'Gendingan',
  },
  {
    id: '3504130017',
    districtId: '3504130',
    name: 'Tapan',
  },
  {
    id: '3504130018',
    districtId: '3504130',
    name: 'Ngujang',
  },
  {
    id: '3504130019',
    districtId: '3504130',
    name: 'Boro',
  },
  {
    id: '3504140001',
    districtId: '3504140',
    name: 'Pakel',
  },
  {
    id: '3504140002',
    districtId: '3504140',
    name: 'Pucung Lor',
  },
  {
    id: '3504140003',
    districtId: '3504140',
    name: 'Srikaton',
  },
  {
    id: '3504140004',
    districtId: '3504140',
    name: 'Padangan',
  },
  {
    id: '3504140005',
    districtId: '3504140',
    name: 'Pinggirsari',
  },
  {
    id: '3504140006',
    districtId: '3504140',
    name: 'Bendosari',
  },
  {
    id: '3504140007',
    districtId: '3504140',
    name: 'Ngantru',
  },
  {
    id: '3504140008',
    districtId: '3504140',
    name: 'Pulerejo',
  },
  {
    id: '3504140009',
    districtId: '3504140',
    name: 'Pojok',
  },
  {
    id: '3504140010',
    districtId: '3504140',
    name: 'Kepuhrejo',
  },
  {
    id: '3504140011',
    districtId: '3504140',
    name: 'Mojoagung',
  },
  {
    id: '3504140012',
    districtId: '3504140',
    name: 'Batokan',
  },
  {
    id: '3504140013',
    districtId: '3504140',
    name: 'Banjarsari',
  },
  {
    id: '3504150002',
    districtId: '3504150',
    name: 'Babadan',
  },
  {
    id: '3504150003',
    districtId: '3504150',
    name: 'Sukowiyono',
  },
  {
    id: '3504150004',
    districtId: '3504150',
    name: 'Sembon',
  },
  {
    id: '3504150005',
    districtId: '3504150',
    name: 'Sukowidodo',
  },
  {
    id: '3504150006',
    districtId: '3504150',
    name: 'Tanjungsari',
  },
  {
    id: '3504150007',
    districtId: '3504150',
    name: 'Gedangan',
  },
  {
    id: '3504150008',
    districtId: '3504150',
    name: 'Sukodono',
  },
  {
    id: '3504150009',
    districtId: '3504150',
    name: 'Karangrejo',
  },
  {
    id: '3504150010',
    districtId: '3504150',
    name: 'Sukorejo',
  },
  {
    id: '3504150012',
    districtId: '3504150',
    name: 'Tulungrejo',
  },
  {
    id: '3504150013',
    districtId: '3504150',
    name: 'Jeli',
  },
  {
    id: '3504160001',
    districtId: '3504160',
    name: 'Pucangan',
  },
  {
    id: '3504160002',
    districtId: '3504160',
    name: 'Bolorejo',
  },
  {
    id: '3504160003',
    districtId: '3504160',
    name: 'Kauman',
  },
  {
    id: '3504160004',
    districtId: '3504160',
    name: 'Balerejo',
  },
  {
    id: '3504160005',
    districtId: '3504160',
    name: 'Batangsaren',
  },
  {
    id: '3504160006',
    districtId: '3504160',
    name: 'Panggungrejo',
  },
  {
    id: '3504160007',
    districtId: '3504160',
    name: 'Sidorejo',
  },
  {
    id: '3504160008',
    districtId: '3504160',
    name: 'Kalangbret',
  },
  {
    id: '3504160009',
    districtId: '3504160',
    name: 'Mojosari',
  },
  {
    id: '3504160010',
    districtId: '3504160',
    name: 'Karanganom',
  },
  {
    id: '3504160011',
    districtId: '3504160',
    name: 'Kates',
  },
  {
    id: '3504160012',
    districtId: '3504160',
    name: 'Banaran',
  },
  {
    id: '3504160013',
    districtId: '3504160',
    name: 'Jatimulyo',
  },
  {
    id: '3504170001',
    districtId: '3504170',
    name: 'Kendal',
  },
  {
    id: '3504170002',
    districtId: '3504170',
    name: 'Tawing',
  },
  {
    id: '3504170003',
    districtId: '3504170',
    name: 'Gondosuli',
  },
  {
    id: '3504170005',
    districtId: '3504170',
    name: 'Sepatan',
  },
  {
    id: '3504170006',
    districtId: '3504170',
    name: 'Macanbang',
  },
  {
    id: '3504170007',
    districtId: '3504170',
    name: 'Kiping',
  },
  {
    id: '3504170008',
    districtId: '3504170',
    name: 'Rejosari',
  },
  {
    id: '3504170009',
    districtId: '3504170',
    name: 'Bendo',
  },
  {
    id: '3504170011',
    districtId: '3504170',
    name: 'Gondang',
  },
  {
    id: '3504170012',
    districtId: '3504170',
    name: 'Bendungan',
  },
  {
    id: '3504170013',
    districtId: '3504170',
    name: 'Mojoarum',
  },
  {
    id: '3504170014',
    districtId: '3504170',
    name: 'Sidomulyo',
  },
  {
    id: '3504170015',
    districtId: '3504170',
    name: 'Notorejo',
  },
  {
    id: '3504170016',
    districtId: '3504170',
    name: 'Sidem',
  },
  {
    id: '3504170017',
    districtId: '3504170',
    name: 'Blendis',
  },
  {
    id: '3504170018',
    districtId: '3504170',
    name: 'Tiudan',
  },
  {
    id: '3504170019',
    districtId: '3504170',
    name: 'Wonokromo',
  },
  {
    id: '3504170020',
    districtId: '3504170',
    name: 'Jarakan',
  },
  {
    id: '3504180001',
    districtId: '3504180',
    name: 'Wonorejo',
  },
  {
    id: '3504180002',
    districtId: '3504180',
    name: 'Kedungcangkring',
  },
  {
    id: '3504180003',
    districtId: '3504180',
    name: 'Mulyosari',
  },
  {
    id: '3504180004',
    districtId: '3504180',
    name: 'Segawe',
  },
  {
    id: '3504180005',
    districtId: '3504180',
    name: 'Penjor',
  },
  {
    id: '3504180006',
    districtId: '3504180',
    name: 'Samar',
  },
  {
    id: '3504180007',
    districtId: '3504180',
    name: 'Sidomulyo',
  },
  {
    id: '3504180008',
    districtId: '3504180',
    name: 'Kradinan',
  },
  {
    id: '3504180009',
    districtId: '3504180',
    name: 'Pagerwojo',
  },
  {
    id: '3504180010',
    districtId: '3504180',
    name: 'Gondanggunung',
  },
  {
    id: '3504180011',
    districtId: '3504180',
    name: 'Gambiran',
  },
  {
    id: '3504190001',
    districtId: '3504190',
    name: 'Kedoyo',
  },
  {
    id: '3504190003',
    districtId: '3504190',
    name: 'Talang',
  },
  {
    id: '3504190004',
    districtId: '3504190',
    name: 'Dono',
  },
  {
    id: '3504190005',
    districtId: '3504190',
    name: 'Krosok',
  },
  {
    id: '3504190007',
    districtId: '3504190',
    name: 'Picisan',
  },
  {
    id: '3504190008',
    districtId: '3504190',
    name: 'Nyawangan',
  },
  {
    id: '3504190009',
    districtId: '3504190',
    name: 'Sendang',
  },
  {
    id: '3505010001',
    districtId: '3505010',
    name: 'Plandirejo',
  },
  {
    id: '3505010002',
    districtId: '3505010',
    name: 'Tumpakoyot',
  },
  {
    id: '3505010003',
    districtId: '3505010',
    name: 'Bululawang',
  },
  {
    id: '3505010004',
    districtId: '3505010',
    name: 'Sidomulyo',
  },
  {
    id: '3505010005',
    districtId: '3505010',
    name: 'Tumpakkepuh',
  },
  {
    id: '3505010006',
    districtId: '3505010',
    name: 'Lorejo',
  },
  {
    id: '3505010007',
    districtId: '3505010',
    name: 'Kedungbanteng',
  },
  {
    id: '3505010008',
    districtId: '3505010',
    name: 'Bakung',
  },
  {
    id: '3505010009',
    districtId: '3505010',
    name: 'Sumberdadi',
  },
  {
    id: '3505010010',
    districtId: '3505010',
    name: 'Pulerejo',
  },
  {
    id: '3505010011',
    districtId: '3505010',
    name: 'Ngrejo',
  },
  {
    id: '3505020001',
    districtId: '3505020',
    name: 'Tambakrejo',
  },
  {
    id: '3505020002',
    districtId: '3505020',
    name: 'Kaligrenjeng',
  },
  {
    id: '3505020003',
    districtId: '3505020',
    name: 'Pasiraman',
  },
  {
    id: '3505020004',
    districtId: '3505020',
    name: 'Sumberboto',
  },
  {
    id: '3505020006',
    districtId: '3505020',
    name: 'Ngadipuro',
  },
  {
    id: '3505020007',
    districtId: '3505020',
    name: 'Ngeni',
  },
  {
    id: '3505020008',
    districtId: '3505020',
    name: 'Wonotirto',
  },
  {
    id: '3505030001',
    districtId: '3505030',
    name: 'Serang',
  },
  {
    id: '3505030002',
    districtId: '3505030',
    name: 'Sumbersih',
  },
  {
    id: '3505030003',
    districtId: '3505030',
    name: 'Kali Gambir',
  },
  {
    id: '3505030004',
    districtId: '3505030',
    name: 'Bale Rejo',
  },
  {
    id: '3505030005',
    districtId: '3505030',
    name: 'Sumber Agung',
  },
  {
    id: '3505030006',
    districtId: '3505030',
    name: 'Panggung Rejo',
  },
  {
    id: '3505030007',
    districtId: '3505030',
    name: 'Kalitengah',
  },
  {
    id: '3505030008',
    districtId: '3505030',
    name: 'Margo Mulyo',
  },
  {
    id: '3505030009',
    districtId: '3505030',
    name: 'Bumiayu',
  },
  {
    id: '3505030010',
    districtId: '3505030',
    name: 'Panggung Asri',
  },
  {
    id: '3505040001',
    districtId: '3505040',
    name: 'Ringin Rejo',
  },
  {
    id: '3505040002',
    districtId: '3505040',
    name: 'Sukorejo',
  },
  {
    id: '3505040003',
    districtId: '3505040',
    name: 'Tugu Rejo',
  },
  {
    id: '3505040004',
    districtId: '3505040',
    name: 'Wates',
  },
  {
    id: '3505040005',
    districtId: '3505040',
    name: 'Tulungrejo',
  },
  {
    id: '3505040006',
    districtId: '3505040',
    name: 'Purworejo',
  },
  {
    id: '3505040007',
    districtId: '3505040',
    name: 'Sumberarum',
  },
  {
    id: '3505040008',
    districtId: '3505040',
    name: 'Mojorejo',
  },
  {
    id: '3505050001',
    districtId: '3505050',
    name: 'Salamrejo',
  },
  {
    id: '3505050002',
    districtId: '3505050',
    name: 'Sumber Kembar',
  },
  {
    id: '3505050003',
    districtId: '3505050',
    name: 'Binangun',
  },
  {
    id: '3505050004',
    districtId: '3505050',
    name: 'Birowo',
  },
  {
    id: '3505050005',
    districtId: '3505050',
    name: 'Sukorame',
  },
  {
    id: '3505050006',
    districtId: '3505050',
    name: 'Ngadri',
  },
  {
    id: '3505050007',
    districtId: '3505050',
    name: 'Sambigede',
  },
  {
    id: '3505050008',
    districtId: '3505050',
    name: 'Rejoso',
  },
  {
    id: '3505050009',
    districtId: '3505050',
    name: 'Umbul Damar',
  },
  {
    id: '3505050010',
    districtId: '3505050',
    name: 'Tawang Rejo',
  },
  {
    id: '3505060001',
    districtId: '3505060',
    name: 'Pandanarum',
  },
  {
    id: '3505060003',
    districtId: '3505060',
    name: 'Sotojayan',
  },
  {
    id: '3505060004',
    districtId: '3505060',
    name: 'Bacem',
  },
  {
    id: '3505060005',
    districtId: '3505060',
    name: 'Sumberjo',
  },
  {
    id: '3505060006',
    districtId: '3505060',
    name: 'Sukorejo',
  },
  {
    id: '3505060007',
    districtId: '3505060',
    name: 'Kalipang',
  },
  {
    id: '3505060008',
    districtId: '3505060',
    name: 'Kembangarum',
  },
  {
    id: '3505060009',
    districtId: '3505060',
    name: 'Jingglong',
  },
  {
    id: '3505060010',
    districtId: '3505060',
    name: 'Kaulon',
  },
  {
    id: '3505070001',
    districtId: '3505070',
    name: 'Panggungduwet',
  },
  {
    id: '3505070002',
    districtId: '3505070',
    name: 'Pakisaji',
  },
  {
    id: '3505070003',
    districtId: '3505070',
    name: 'Maron',
  },
  {
    id: '3505070004',
    districtId: '3505070',
    name: 'Kebonsari',
  },
  {
    id: '3505070005',
    districtId: '3505070',
    name: 'Bendosari',
  },
  {
    id: '3505070006',
    districtId: '3505070',
    name: 'Suruhwadang',
  },
  {
    id: '3505070007',
    districtId: '3505070',
    name: 'Sumberjo',
  },
  {
    id: '3505070008',
    districtId: '3505070',
    name: 'Dawuhan',
  },
  {
    id: '3505070009',
    districtId: '3505070',
    name: 'Sumberjati',
  },
  {
    id: '3505070010',
    districtId: '3505070',
    name: 'Plumpungrejo',
  },
  {
    id: '3505070011',
    districtId: '3505070',
    name: 'Jimbe',
  },
  {
    id: '3505070012',
    districtId: '3505070',
    name: 'Kademangan',
  },
  {
    id: '3505070013',
    districtId: '3505070',
    name: 'Rejowinangun',
  },
  {
    id: '3505070014',
    districtId: '3505070',
    name: 'Plosorejo',
  },
  {
    id: '3505070015',
    districtId: '3505070',
    name: 'Darungan',
  },
  {
    id: '3505080001',
    districtId: '3505080',
    name: 'Minggirsari',
  },
  {
    id: '3505080002',
    districtId: '3505080',
    name: 'Gogodeso',
  },
  {
    id: '3505080003',
    districtId: '3505080',
    name: 'Karangsono',
  },
  {
    id: '3505080004',
    districtId: '3505080',
    name: 'Satreyan',
  },
  {
    id: '3505080005',
    districtId: '3505080',
    name: 'Kanigoro',
  },
  {
    id: '3505080006',
    districtId: '3505080',
    name: 'Tlogo',
  },
  {
    id: '3505080007',
    districtId: '3505080',
    name: 'Gaprang',
  },
  {
    id: '3505080008',
    districtId: '3505080',
    name: 'Jatinom',
  },
  {
    id: '3505080009',
    districtId: '3505080',
    name: 'Kuningan',
  },
  {
    id: '3505080010',
    districtId: '3505080',
    name: 'Papungan',
  },
  {
    id: '3505080011',
    districtId: '3505080',
    name: 'Banggle',
  },
  {
    id: '3505080012',
    districtId: '3505080',
    name: 'Sawentar',
  },
  {
    id: '3505090001',
    districtId: '3505090',
    name: 'Tumpang',
  },
  {
    id: '3505090002',
    districtId: '3505090',
    name: 'Jabung',
  },
  {
    id: '3505090003',
    districtId: '3505090',
    name: 'Jeblog',
  },
  {
    id: '3505090004',
    districtId: '3505090',
    name: 'Bendosewu',
  },
  {
    id: '3505090006',
    districtId: '3505090',
    name: 'Sragi',
  },
  {
    id: '3505090007',
    districtId: '3505090',
    name: 'Wonorejo',
  },
  {
    id: '3505090008',
    districtId: '3505090',
    name: 'Pasirharjo',
  },
  {
    id: '3505090009',
    districtId: '3505090',
    name: 'Kendalrejo',
  },
  {
    id: '3505090010',
    districtId: '3505090',
    name: 'Kamulan',
  },
  {
    id: '3505090011',
    districtId: '3505090',
    name: 'Talun',
  },
  {
    id: '3505090012',
    districtId: '3505090',
    name: 'Bajang',
  },
  {
    id: '3505090013',
    districtId: '3505090',
    name: 'Kaweron',
  },
  {
    id: '3505090014',
    districtId: '3505090',
    name: 'Jajar',
  },
  {
    id: '3505100001',
    districtId: '3505100',
    name: 'Mronjo',
  },
  {
    id: '3505100002',
    districtId: '3505100',
    name: 'Mandesan',
  },
  {
    id: '3505100003',
    districtId: '3505100',
    name: 'Selopuro',
  },
  {
    id: '3505100004',
    districtId: '3505100',
    name: 'Ploso',
  },
  {
    id: '3505100005',
    districtId: '3505100',
    name: 'Jatitengah',
  },
  {
    id: '3505100006',
    districtId: '3505100',
    name: 'Jambewangi',
  },
  {
    id: '3505100007',
    districtId: '3505100',
    name: 'Tegalrejo',
  },
  {
    id: '3505100008',
    districtId: '3505100',
    name: 'Popoh',
  },
  {
    id: '3505110001',
    districtId: '3505110',
    name: 'Siraman',
  },
  {
    id: '3505110002',
    districtId: '3505110',
    name: 'Jugo',
  },
  {
    id: '3505110003',
    districtId: '3505110',
    name: 'Kesamben',
  },
  {
    id: '3505110004',
    districtId: '3505110',
    name: 'Pagergunung',
  },
  {
    id: '3505110005',
    districtId: '3505110',
    name: 'Sukoanyar',
  },
  {
    id: '3505110006',
    districtId: '3505110',
    name: 'Pagerwojo',
  },
  {
    id: '3505110007',
    districtId: '3505110',
    name: 'Tapakrejo',
  },
  {
    id: '3505110008',
    districtId: '3505110',
    name: 'Tepas',
  },
  {
    id: '3505110009',
    districtId: '3505110',
    name: 'Kemirigede',
  },
  {
    id: '3505110010',
    districtId: '3505110',
    name: 'Bumirejo',
  },
  {
    id: '3505120001',
    districtId: '3505120',
    name: 'Pohgajih',
  },
  {
    id: '3505120002',
    districtId: '3505120',
    name: 'Selorejo',
  },
  {
    id: '3505120003',
    districtId: '3505120',
    name: 'Ngreco',
  },
  {
    id: '3505120004',
    districtId: '3505120',
    name: 'Boro',
  },
  {
    id: '3505120005',
    districtId: '3505120',
    name: 'Olak Alen',
  },
  {
    id: '3505120006',
    districtId: '3505120',
    name: 'Sumber Agung',
  },
  {
    id: '3505120007',
    districtId: '3505120',
    name: 'Banjarsari',
  },
  {
    id: '3505120009',
    districtId: '3505120',
    name: 'Sidomulyo',
  },
  {
    id: '3505120010',
    districtId: '3505120',
    name: 'Ampelgading',
  },
  {
    id: '3505130001',
    districtId: '3505130',
    name: 'Slorok',
  },
  {
    id: '3505130002',
    districtId: '3505130',
    name: 'Genengan',
  },
  {
    id: '3505130003',
    districtId: '3505130',
    name: 'Jambepawon',
  },
  {
    id: '3505130004',
    districtId: '3505130',
    name: 'Sidorejo',
  },
  {
    id: '3505130005',
    districtId: '3505130',
    name: 'Doko',
  },
  {
    id: '3505130007',
    districtId: '3505130',
    name: 'Plumbangan',
  },
  {
    id: '3505130008',
    districtId: '3505130',
    name: 'Sumber Urip',
  },
  {
    id: '3505130009',
    districtId: '3505130',
    name: 'Resapombo',
  },
  {
    id: '3505130010',
    districtId: '3505130',
    name: 'Kalimanis',
  },
  {
    id: '3505140001',
    districtId: '3505140',
    name: 'Klemunan',
  },
  {
    id: '3505140002',
    districtId: '3505140',
    name: 'Wlingi',
  },
  {
    id: '3505140003',
    districtId: '3505140',
    name: 'Tangkil',
  },
  {
    id: '3505140005',
    districtId: '3505140',
    name: 'Babadan',
  },
  {
    id: '3505140006',
    districtId: '3505140',
    name: 'Tembalang',
  },
  {
    id: '3505140007',
    districtId: '3505140',
    name: 'Ngadirenggo',
  },
  {
    id: '3505140008',
    districtId: '3505140',
    name: 'Tegalasri',
  },
  {
    id: '3505140009',
    districtId: '3505140',
    name: 'Balerejo',
  },
  {
    id: '3505150001',
    districtId: '3505150',
    name: 'Sumberagung',
  },
  {
    id: '3505150002',
    districtId: '3505150',
    name: 'Gondang',
  },
  {
    id: '3505150003',
    districtId: '3505150',
    name: 'Kotes',
  },
  {
    id: '3505150004',
    districtId: '3505150',
    name: 'Tambakan',
  },
  {
    id: '3505150006',
    districtId: '3505150',
    name: 'Gandusari',
  },
  {
    id: '3505150007',
    districtId: '3505150',
    name: 'Sukosewu',
  },
  {
    id: '3505150008',
    districtId: '3505150',
    name: 'Gadungan',
  },
  {
    id: '3505150009',
    districtId: '3505150',
    name: 'Ngaringan',
  },
  {
    id: '3505150010',
    districtId: '3505150',
    name: 'Soso',
  },
  {
    id: '3505150013',
    districtId: '3505150',
    name: 'Tulungrejo',
  },
  {
    id: '3505150014',
    districtId: '3505150',
    name: 'Krisik',
  },
  {
    id: '3505160001',
    districtId: '3505160',
    name: 'Pojok',
  },
  {
    id: '3505160002',
    districtId: '3505160',
    name: 'Sumberdiren',
  },
  {
    id: '3505160003',
    districtId: '3505160',
    name: 'Garum',
  },
  {
    id: '3505160004',
    districtId: '3505160',
    name: 'Tingal',
  },
  {
    id: '3505160006',
    districtId: '3505160',
    name: 'Tawangsari',
  },
  {
    id: '3505160007',
    districtId: '3505160',
    name: 'Slorok',
  },
  {
    id: '3505160008',
    districtId: '3505160',
    name: 'Sidodadi',
  },
  {
    id: '3505160009',
    districtId: '3505160',
    name: 'Karangrejo',
  },
  {
    id: '3505170001',
    districtId: '3505170',
    name: 'Bangsri',
  },
  {
    id: '3505170002',
    districtId: '3505170',
    name: 'Jiwut',
  },
  {
    id: '3505170004',
    districtId: '3505170',
    name: 'Kemloko',
  },
  {
    id: '3505170005',
    districtId: '3505170',
    name: 'Dayu',
  },
  {
    id: '3505170006',
    districtId: '3505170',
    name: 'Ngoran',
  },
  {
    id: '3505170007',
    districtId: '3505170',
    name: 'Nglegok',
  },
  {
    id: '3505170008',
    districtId: '3505170',
    name: 'Modangan',
  },
  {
    id: '3505170009',
    districtId: '3505170',
    name: 'Penataran',
  },
  {
    id: '3505170010',
    districtId: '3505170',
    name: 'Kedawung',
  },
  {
    id: '3505170011',
    districtId: '3505170',
    name: 'Sumberasri',
  },
  {
    id: '3505180001',
    districtId: '3505180',
    name: 'Plosoarang',
  },
  {
    id: '3505180002',
    districtId: '3505180',
    name: 'Tuliskriyo',
  },
  {
    id: '3505180003',
    districtId: '3505180',
    name: 'Bendowulung',
  },
  {
    id: '3505180004',
    districtId: '3505180',
    name: 'Purworejo',
  },
  {
    id: '3505180005',
    districtId: '3505180',
    name: 'Bendosari',
  },
  {
    id: '3505180006',
    districtId: '3505180',
    name: 'Sanankulon',
  },
  {
    id: '3505180007',
    districtId: '3505180',
    name: 'Kalipucung',
  },
  {
    id: '3505180009',
    districtId: '3505180',
    name: 'Sumberjo',
  },
  {
    id: '3505180010',
    districtId: '3505180',
    name: 'Jeding',
  },
  {
    id: '3505180012',
    districtId: '3505180',
    name: 'Sumberingin',
  },
  {
    id: '3505190001',
    districtId: '3505190',
    name: 'Bendo',
  },
  {
    id: '3505190002',
    districtId: '3505190',
    name: 'Jatilengger',
  },
  {
    id: '3505190003',
    districtId: '3505190',
    name: 'Maliran',
  },
  {
    id: '3505190004',
    districtId: '3505190',
    name: 'Kawedusan',
  },
  {
    id: '3505190005',
    districtId: '3505190',
    name: 'Langon',
  },
  {
    id: '3505190006',
    districtId: '3505190',
    name: 'Dadaplangu',
  },
  {
    id: '3505190007',
    districtId: '3505190',
    name: 'Kebonduren',
  },
  {
    id: '3505190008',
    districtId: '3505190',
    name: 'Pojok',
  },
  {
    id: '3505190009',
    districtId: '3505190',
    name: 'Ponggok',
  },
  {
    id: '3505190010',
    districtId: '3505190',
    name: 'Karangbendo',
  },
  {
    id: '3505190011',
    districtId: '3505190',
    name: 'Candirejo',
  },
  {
    id: '3505190012',
    districtId: '3505190',
    name: 'Bacem',
  },
  {
    id: '3505190013',
    districtId: '3505190',
    name: 'Ringinanyar',
  },
  {
    id: '3505190014',
    districtId: '3505190',
    name: 'Gembongan',
  },
  {
    id: '3505190015',
    districtId: '3505190',
    name: 'Sidorejo',
  },
  {
    id: '3505200001',
    districtId: '3505200',
    name: 'Purwokerto',
  },
  {
    id: '3505200002',
    districtId: '3505200',
    name: 'Selokajang',
  },
  {
    id: '3505200003',
    districtId: '3505200',
    name: 'Ngaglik',
  },
  {
    id: '3505200004',
    districtId: '3505200',
    name: 'Maron',
  },
  {
    id: '3505200005',
    districtId: '3505200',
    name: 'Pakisrejo',
  },
  {
    id: '3505200006',
    districtId: '3505200',
    name: 'Karanggayam',
  },
  {
    id: '3505200008',
    districtId: '3505200',
    name: 'Wonorejo',
  },
  {
    id: '3505200009',
    districtId: '3505200',
    name: 'Kauman',
  },
  {
    id: '3505200010',
    districtId: '3505200',
    name: 'Kandangan',
  },
  {
    id: '3505200011',
    districtId: '3505200',
    name: 'Kendalrejo',
  },
  {
    id: '3505200012',
    districtId: '3505200',
    name: 'Dandong',
  },
  {
    id: '3505200013',
    districtId: '3505200',
    name: 'Bagelenan',
  },
  {
    id: '3505200014',
    districtId: '3505200',
    name: 'Srengat',
  },
  {
    id: '3505200015',
    districtId: '3505200',
    name: 'Togogan',
  },
  {
    id: '3505200016',
    districtId: '3505200',
    name: 'Dermojayan',
  },
  {
    id: '3505210001',
    districtId: '3505210',
    name: 'Gandekan',
  },
  {
    id: '3505210002',
    districtId: '3505210',
    name: 'Kunir',
  },
  {
    id: '3505210003',
    districtId: '3505210',
    name: 'Kolomayan',
  },
  {
    id: '3505210004',
    districtId: '3505210',
    name: 'Pikatan',
  },
  {
    id: '3505210005',
    districtId: '3505210',
    name: 'Wonodadi',
  },
  {
    id: '3505210006',
    districtId: '3505210',
    name: 'Kaliboto',
  },
  {
    id: '3505210007',
    districtId: '3505210',
    name: 'Rejosari',
  },
  {
    id: '3505210008',
    districtId: '3505210',
    name: 'Tawangrejo',
  },
  {
    id: '3505210009',
    districtId: '3505210',
    name: 'Kebonagung',
  },
  {
    id: '3505210010',
    districtId: '3505210',
    name: 'Salam',
  },
  {
    id: '3505210011',
    districtId: '3505210',
    name: 'Jaten',
  },
  {
    id: '3505220001',
    districtId: '3505220',
    name: 'Ringinanom',
  },
  {
    id: '3505220002',
    districtId: '3505220',
    name: 'Sumbersari',
  },
  {
    id: '3505220003',
    districtId: '3505220',
    name: 'Karanggondang',
  },
  {
    id: '3505220005',
    districtId: '3505220',
    name: 'Jati',
  },
  {
    id: '3505220006',
    districtId: '3505220',
    name: 'Temenggungan',
  },
  {
    id: '3505220007',
    districtId: '3505220',
    name: 'Besuki',
  },
  {
    id: '3505220008',
    districtId: '3505220',
    name: 'Bakung',
  },
  {
    id: '3505220009',
    districtId: '3505220',
    name: 'Mangunan',
  },
  {
    id: '3505220010',
    districtId: '3505220',
    name: 'Sukorejo',
  },
  {
    id: '3505220011',
    districtId: '3505220',
    name: 'Slemanan',
  },
  {
    id: '3505220012',
    districtId: '3505220',
    name: 'Bendorejo',
  },
  {
    id: '3506010002',
    districtId: '3506010',
    name: 'Ngadi',
  },
  {
    id: '3506010003',
    districtId: '3506010',
    name: 'Kranding',
  },
  {
    id: '3506010004',
    districtId: '3506010',
    name: 'Maesan',
  },
  {
    id: '3506010005',
    districtId: '3506010',
    name: 'Ponggok',
  },
  {
    id: '3506010006',
    districtId: '3506010',
    name: 'Petungroto',
  },
  {
    id: '3506010007',
    districtId: '3506010',
    name: 'Pamongan',
  },
  {
    id: '3506010008',
    districtId: '3506010',
    name: 'Kedawung',
  },
  {
    id: '3506010009',
    districtId: '3506010',
    name: 'Ploso',
  },
  {
    id: '3506010010',
    districtId: '3506010',
    name: 'Tambibendo',
  },
  {
    id: '3506010011',
    districtId: '3506010',
    name: 'Kraton',
  },
  {
    id: '3506010012',
    districtId: '3506010',
    name: 'Blimbing',
  },
  {
    id: '3506010013',
    districtId: '3506010',
    name: 'Jugo',
  },
  {
    id: '3506010014',
    districtId: '3506010',
    name: 'Mojo',
  },
  {
    id: '3506010015',
    districtId: '3506010',
    name: 'Mlati',
  },
  {
    id: '3506010016',
    districtId: '3506010',
    name: 'Surat',
  },
  {
    id: '3506010017',
    districtId: '3506010',
    name: 'Sukoanyar',
  },
  {
    id: '3506010018',
    districtId: '3506010',
    name: 'Keniten',
  },
  {
    id: '3506010019',
    districtId: '3506010',
    name: 'Mondo',
  },
  {
    id: '3506010020',
    districtId: '3506010',
    name: 'Petok',
  },
  {
    id: '3506020001',
    districtId: '3506020',
    name: 'Selopanggung',
  },
  {
    id: '3506020003',
    districtId: '3506020',
    name: 'Sidomulyo',
  },
  {
    id: '3506020005',
    districtId: '3506020',
    name: 'Bobang',
  },
  {
    id: '3506020006',
    districtId: '3506020',
    name: 'Puhsarang',
  },
  {
    id: '3506020007',
    districtId: '3506020',
    name: 'Kanyoran',
  },
  {
    id: '3506020008',
    districtId: '3506020',
    name: 'Joho',
  },
  {
    id: '3506020009',
    districtId: '3506020',
    name: 'Pagung',
  },
  {
    id: '3506020010',
    districtId: '3506020',
    name: 'Kedak',
  },
  {
    id: '3506020011',
    districtId: '3506020',
    name: 'Titik',
  },
  {
    id: '3506030001',
    districtId: '3506030',
    name: 'Tales',
  },
  {
    id: '3506030003',
    districtId: '3506030',
    name: 'Branggahan',
  },
  {
    id: '3506030004',
    districtId: '3506030',
    name: 'Seketi',
  },
  {
    id: '3506030005',
    districtId: '3506030',
    name: 'Banggle',
  },
  {
    id: '3506030006',
    districtId: '3506030',
    name: 'Ngadiluwih',
  },
  {
    id: '3506030007',
    districtId: '3506030',
    name: 'Purwokerto',
  },
  {
    id: '3506030009',
    districtId: '3506030',
    name: 'Rembangkepuh',
  },
  {
    id: '3506030011',
    districtId: '3506030',
    name: 'Rembang',
  },
  {
    id: '3506030012',
    districtId: '3506030',
    name: 'Badal',
  },
  {
    id: '3506030013',
    districtId: '3506030',
    name: 'Badal Pandean',
  },
  {
    id: '3506030014',
    districtId: '3506030',
    name: 'Wonorejo',
  },
  {
    id: '3506030015',
    districtId: '3506030',
    name: 'Banjarejo',
  },
  {
    id: '3506030016',
    districtId: '3506030',
    name: 'Mangunrejo',
  },
  {
    id: '3506040001',
    districtId: '3506040',
    name: 'Setonorejo',
  },
  {
    id: '3506040002',
    districtId: '3506040',
    name: 'Pelas',
  },
  {
    id: '3506040004',
    districtId: '3506040',
    name: 'Rejomulyo',
  },
  {
    id: '3506040005',
    districtId: '3506040',
    name: 'Mojosari',
  },
  {
    id: '3506040007',
    districtId: '3506040',
    name: 'Jabang',
  },
  {
    id: '3506040008',
    districtId: '3506040',
    name: 'Karangtalun',
  },
  {
    id: '3506040009',
    districtId: '3506040',
    name: 'Nyawangan',
  },
  {
    id: '3506040010',
    districtId: '3506040',
    name: 'Kras',
  },
  {
    id: '3506040011',
    districtId: '3506040',
    name: 'Bendosari',
  },
  {
    id: '3506040012',
    districtId: '3506040',
    name: 'Krandang',
  },
  {
    id: '3506040013',
    districtId: '3506040',
    name: 'Kanigoro',
  },
  {
    id: '3506040014',
    districtId: '3506040',
    name: 'Banjaranyar',
  },
  {
    id: '3506040015',
    districtId: '3506040',
    name: 'Purwodadi',
  },
  {
    id: '3506040016',
    districtId: '3506040',
    name: 'Jambean',
  },
  {
    id: '3506050001',
    districtId: '3506050',
    name: 'Jemekan',
  },
  {
    id: '3506050002',
    districtId: '3506050',
    name: 'Srikaton',
  },
  {
    id: '3506050003',
    districtId: '3506050',
    name: 'Sambi',
  },
  {
    id: '3506050004',
    districtId: '3506050',
    name: 'Ringinrejo',
  },
  {
    id: '3506050006',
    districtId: '3506050',
    name: 'Batuaji',
  },
  {
    id: '3506050007',
    districtId: '3506050',
    name: 'Dawung',
  },
  {
    id: '3506050008',
    districtId: '3506050',
    name: 'Purwodadi',
  },
  {
    id: '3506050009',
    districtId: '3506050',
    name: 'Selodono',
  },
  {
    id: '3506050010',
    districtId: '3506050',
    name: 'Susuhbango',
  },
  {
    id: '3506050011',
    districtId: '3506050',
    name: 'Nambakan',
  },
  {
    id: '3506060001',
    districtId: '3506060',
    name: 'Sumberjo',
  },
  {
    id: '3506060002',
    districtId: '3506060',
    name: 'Karangrejo',
  },
  {
    id: '3506060003',
    districtId: '3506060',
    name: 'Selosari',
  },
  {
    id: '3506060004',
    districtId: '3506060',
    name: 'Kandat',
  },
  {
    id: '3506060005',
    districtId: '3506060',
    name: 'Cendono',
  },
  {
    id: '3506060006',
    districtId: '3506060',
    name: 'Ringinsari',
  },
  {
    id: '3506060007',
    districtId: '3506060',
    name: 'Tegalan',
  },
  {
    id: '3506060008',
    districtId: '3506060',
    name: 'Ngletih',
  },
  {
    id: '3506060009',
    districtId: '3506060',
    name: 'Purworejo',
  },
  {
    id: '3506060011',
    districtId: '3506060',
    name: 'Blabak',
  },
  {
    id: '3506060012',
    districtId: '3506060',
    name: 'Ngreco',
  },
  {
    id: '3506070002',
    districtId: '3506070',
    name: 'Tawang',
  },
  {
    id: '3506070003',
    districtId: '3506070',
    name: 'Segaran',
  },
  {
    id: '3506070004',
    districtId: '3506070',
    name: 'Gadungan',
  },
  {
    id: '3506070005',
    districtId: '3506070',
    name: 'Pojok',
  },
  {
    id: '3506070006',
    districtId: '3506070',
    name: 'Wonorejo',
  },
  {
    id: '3506070007',
    districtId: '3506070',
    name: 'Wates',
  },
  {
    id: '3506070008',
    districtId: '3506070',
    name: 'Jajar',
  },
  {
    id: '3506070010',
    districtId: '3506070',
    name: 'Tempurejo',
  },
  {
    id: '3506070011',
    districtId: '3506070',
    name: 'Plaosan',
  },
  {
    id: '3506070012',
    districtId: '3506070',
    name: 'Karanganyar',
  },
  {
    id: '3506070013',
    districtId: '3506070',
    name: 'Sumberagung',
  },
  {
    id: '3506070014',
    districtId: '3506070',
    name: 'Pagu',
  },
  {
    id: '3506070015',
    districtId: '3506070',
    name: 'Joho',
  },
  {
    id: '3506070016',
    districtId: '3506070',
    name: 'Silir',
  },
  {
    id: '3506070017',
    districtId: '3506070',
    name: 'Janti',
  },
  {
    id: '3506070018',
    districtId: '3506070',
    name: 'Sidomulyo',
  },
  {
    id: '3506080001',
    districtId: '3506080',
    name: 'Bedali',
  },
  {
    id: '3506080002',
    districtId: '3506080',
    name: 'Margourip',
  },
  {
    id: '3506080003',
    districtId: '3506080',
    name: 'Manggis',
  },
  {
    id: '3506080005',
    districtId: '3506080',
    name: 'Sugihwaras',
  },
  {
    id: '3506080006',
    districtId: '3506080',
    name: 'Ngancar',
  },
  {
    id: '3506080007',
    districtId: '3506080',
    name: 'Pandantoyo',
  },
  {
    id: '3506080008',
    districtId: '3506080',
    name: 'Kunjang',
  },
  {
    id: '3506080009',
    districtId: '3506080',
    name: 'Jagul',
  },
  {
    id: '3506080010',
    districtId: '3506080',
    name: 'Babadan',
  },
  {
    id: '3506090001',
    districtId: '3506090',
    name: 'Gondang',
  },
  {
    id: '3506090002',
    districtId: '3506090',
    name: 'Kayunan',
  },
  {
    id: '3506090003',
    districtId: '3506090',
    name: 'Panjer',
  },
  {
    id: '3506090004',
    districtId: '3506090',
    name: 'Jarak',
  },
  {
    id: '3506090005',
    districtId: '3506090',
    name: 'Sepawon',
  },
  {
    id: '3506090006',
    districtId: '3506090',
    name: 'Plosokidul',
  },
  {
    id: '3506090007',
    districtId: '3506090',
    name: 'Brenggolo',
  },
  {
    id: '3506090008',
    districtId: '3506090',
    name: 'Plosolor',
  },
  {
    id: '3506090009',
    districtId: '3506090',
    name: 'Wonorejo Trisulo',
  },
  {
    id: '3506090010',
    districtId: '3506090',
    name: 'Pranggang',
  },
  {
    id: '3506090012',
    districtId: '3506090',
    name: 'Klanderan',
  },
  {
    id: '3506090013',
    districtId: '3506090',
    name: 'Donganti',
  },
  {
    id: '3506090014',
    districtId: '3506090',
    name: 'Kawedusan',
  },
  {
    id: '3506090015',
    districtId: '3506090',
    name: 'Sumberagung',
  },
  {
    id: '3506100001',
    districtId: '3506100',
    name: 'Nglumbang',
  },
  {
    id: '3506100002',
    districtId: '3506100',
    name: 'Blimbing',
  },
  {
    id: '3506100003',
    districtId: '3506100',
    name: 'Ngasem',
  },
  {
    id: '3506100004',
    districtId: '3506100',
    name: 'Bangkok',
  },
  {
    id: '3506100006',
    districtId: '3506100',
    name: 'Bogem',
  },
  {
    id: '3506100008',
    districtId: '3506100',
    name: 'Banyuanyar',
  },
  {
    id: '3506100009',
    districtId: '3506100',
    name: 'Gabru',
  },
  {
    id: '3506100010',
    districtId: '3506100',
    name: 'Wonojoyo',
  },
  {
    id: '3506100011',
    districtId: '3506100',
    name: 'Kranggan',
  },
  {
    id: '3506100012',
    districtId: '3506100',
    name: 'Gurah',
  },
  {
    id: '3506100013',
    districtId: '3506100',
    name: 'Sumbercangkring',
  },
  {
    id: '3506100014',
    districtId: '3506100',
    name: 'Tiru Kidul',
  },
  {
    id: '3506100015',
    districtId: '3506100',
    name: 'Tiru Lor',
  },
  {
    id: '3506100016',
    districtId: '3506100',
    name: 'Tambakrejo',
  },
  {
    id: '3506100017',
    districtId: '3506100',
    name: 'Gempolan',
  },
  {
    id: '3506100019',
    districtId: '3506100',
    name: 'Sukorejo',
  },
  {
    id: '3506100020',
    districtId: '3506100',
    name: 'Gayam',
  },
  {
    id: '3506100021',
    districtId: '3506100',
    name: 'Adan-Adan',
  },
  {
    id: '3506110001',
    districtId: '3506110',
    name: 'Satak',
  },
  {
    id: '3506110003',
    districtId: '3506110',
    name: 'Asmorobangun',
  },
  {
    id: '3506110004',
    districtId: '3506110',
    name: 'Wonorejo',
  },
  {
    id: '3506110005',
    districtId: '3506110',
    name: 'Manggis',
  },
  {
    id: '3506110006',
    districtId: '3506110',
    name: 'Sidomulyo',
  },
  {
    id: '3506110007',
    districtId: '3506110',
    name: 'Watugede',
  },
  {
    id: '3506110008',
    districtId: '3506110',
    name: 'Gadungan',
  },
  {
    id: '3506120001',
    districtId: '3506120',
    name: 'Kebonrejo',
  },
  {
    id: '3506120002',
    districtId: '3506120',
    name: 'Besowo',
  },
  {
    id: '3506120003',
    districtId: '3506120',
    name: 'Kampungbaru',
  },
  {
    id: '3506120004',
    districtId: '3506120',
    name: 'Siman',
  },
  {
    id: '3506120008',
    districtId: '3506120',
    name: 'Kencong',
  },
  {
    id: '3506120009',
    districtId: '3506120',
    name: 'Keling',
  },
  {
    id: '3506120010',
    districtId: '3506120',
    name: 'Damarwulan',
  },
  {
    id: '3506130001',
    districtId: '3506130',
    name: 'Klampisan',
  },
  {
    id: '3506130002',
    districtId: '3506130',
    name: 'Kandangan',
  },
  {
    id: '3506130003',
    districtId: '3506130',
    name: 'Mlancu',
  },
  {
    id: '3506130004',
    districtId: '3506130',
    name: 'Medowo',
  },
  {
    id: '3506130005',
    districtId: '3506130',
    name: 'Banaran',
  },
  {
    id: '3506130007',
    districtId: '3506130',
    name: 'Kasreman',
  },
  {
    id: '3506130008',
    districtId: '3506130',
    name: 'Kemiri',
  },
  {
    id: '3506130009',
    districtId: '3506130',
    name: 'Karangtengah',
  },
  {
    id: '3506130010',
    districtId: '3506130',
    name: 'Jerukwangi',
  },
  {
    id: '3506130012',
    districtId: '3506130',
    name: 'Jlumbang',
  },
  {
    id: '3506140001',
    districtId: '3506140',
    name: 'Sidorejo',
  },
  {
    id: '3506140002',
    districtId: '3506140',
    name: 'Gedangsewu',
  },
  {
    id: '3506140003',
    districtId: '3506140',
    name: 'Sumberbendo',
  },
  {
    id: '3506140004',
    districtId: '3506140',
    name: 'Darungan',
  },
  {
    id: '3506140005',
    districtId: '3506140',
    name: 'Sambirejo',
  },
  {
    id: '3506140006',
    districtId: '3506140',
    name: 'Bendo',
  },
  {
    id: '3506140008',
    districtId: '3506140',
    name: 'Tulungrejo',
  },
  {
    id: '3506140009',
    districtId: '3506140',
    name: 'Pare',
  },
  {
    id: '3506141001',
    districtId: '3506141',
    name: 'Sekoto',
  },
  {
    id: '3506141002',
    districtId: '3506141',
    name: 'Bringin',
  },
  {
    id: '3506141003',
    districtId: '3506141',
    name: 'Lamong',
  },
  {
    id: '3506141004',
    districtId: '3506141',
    name: 'Canggu',
  },
  {
    id: '3506141007',
    districtId: '3506141',
    name: 'Badas',
  },
  {
    id: '3506141008',
    districtId: '3506141',
    name: 'Blaru',
  },
  {
    id: '3506150001',
    districtId: '3506150',
    name: 'Kapas',
  },
  {
    id: '3506150002',
    districtId: '3506150',
    name: 'Kapi',
  },
  {
    id: '3506150003',
    districtId: '3506150',
    name: 'Tenggerlor',
  },
  {
    id: '3506150004',
    districtId: '3506150',
    name: 'Wonorejo',
  },
  {
    id: '3506150005',
    districtId: '3506150',
    name: 'Balongjeruk',
  },
  {
    id: '3506150006',
    districtId: '3506150',
    name: 'Kuwik',
  },
  {
    id: '3506150009',
    districtId: '3506150',
    name: 'Kunjang',
  },
  {
    id: '3506150011',
    districtId: '3506150',
    name: 'Pakis',
  },
  {
    id: '3506150012',
    districtId: '3506150',
    name: 'Parelor',
  },
  {
    id: '3506160001',
    districtId: '3506160',
    name: 'Kayen Lor',
  },
  {
    id: '3506160002',
    districtId: '3506160',
    name: 'Bogokidul',
  },
  {
    id: '3506160003',
    districtId: '3506160',
    name: 'Mejono',
  },
  {
    id: '3506160004',
    districtId: '3506160',
    name: 'Tegowangi',
  },
  {
    id: '3506160005',
    districtId: '3506160',
    name: 'Langenharjo',
  },
  {
    id: '3506160006',
    districtId: '3506160',
    name: 'Puhjarak',
  },
  {
    id: '3506160008',
    districtId: '3506160',
    name: 'Payaman',
  },
  {
    id: '3506160009',
    districtId: '3506160',
    name: 'Wonokerto',
  },
  {
    id: '3506160010',
    districtId: '3506160',
    name: 'Ngino',
  },
  {
    id: '3506160011',
    districtId: '3506160',
    name: 'Banjarejo',
  },
  {
    id: '3506160012',
    districtId: '3506160',
    name: 'Sidowarek',
  },
  {
    id: '3506160013',
    districtId: '3506160',
    name: 'Ringinpitu',
  },
  {
    id: '3506160014',
    districtId: '3506160',
    name: 'Sukoharjo',
  },
  {
    id: '3506160015',
    districtId: '3506160',
    name: 'Mojoayu',
  },
  {
    id: '3506160016',
    districtId: '3506160',
    name: 'Plemahan',
  },
  {
    id: '3506160017',
    districtId: '3506160',
    name: 'Mojokerep',
  },
  {
    id: '3506170001',
    districtId: '3506170',
    name: 'Mranggen',
  },
  {
    id: '3506170002',
    districtId: '3506170',
    name: 'Pesing',
  },
  {
    id: '3506170003',
    districtId: '3506170',
    name: 'Jantok',
  },
  {
    id: '3506170004',
    districtId: '3506170',
    name: 'Ketawang',
  },
  {
    id: '3506170005',
    districtId: '3506170',
    name: 'Wonotengah',
  },
  {
    id: '3506170006',
    districtId: '3506170',
    name: 'Purwoasri',
  },
  {
    id: '3506170007',
    districtId: '3506170',
    name: 'Pandansari',
  },
  {
    id: '3506170008',
    districtId: '3506170',
    name: 'Blawe',
  },
  {
    id: '3506170009',
    districtId: '3506170',
    name: 'Belor',
  },
  {
    id: '3506170012',
    districtId: '3506170',
    name: 'Purwodadi',
  },
  {
    id: '3506170014',
    districtId: '3506170',
    name: 'Klampitan',
  },
  {
    id: '3506170015',
    districtId: '3506170',
    name: 'Sidomulyo',
  },
  {
    id: '3506170016',
    districtId: '3506170',
    name: 'Sumberjo',
  },
  {
    id: '3506170018',
    districtId: '3506170',
    name: 'Woromarto',
  },
  {
    id: '3506170019',
    districtId: '3506170',
    name: 'Merjoyo',
  },
  {
    id: '3506170020',
    districtId: '3506170',
    name: 'Mekikis',
  },
  {
    id: '3506170021',
    districtId: '3506170',
    name: 'Karangpakis',
  },
  {
    id: '3506170022',
    districtId: '3506170',
    name: 'Dayu',
  },
  {
    id: '3506170023',
    districtId: '3506170',
    name: 'Dawuhan',
  },
  {
    id: '3506180001',
    districtId: '3506180',
    name: 'Purwotengah',
  },
  {
    id: '3506180002',
    districtId: '3506180',
    name: 'Kwaron',
  },
  {
    id: '3506180003',
    districtId: '3506180',
    name: 'Minggiran',
  },
  {
    id: '3506180004',
    districtId: '3506180',
    name: 'Pehkulon',
  },
  {
    id: '3506180005',
    districtId: '3506180',
    name: 'Pehwetan',
  },
  {
    id: '3506180006',
    districtId: '3506180',
    name: 'Dawuhan Kidul',
  },
  {
    id: '3506180007',
    districtId: '3506180',
    name: 'Janti',
  },
  {
    id: '3506180008',
    districtId: '3506180',
    name: 'Papar',
  },
  {
    id: '3506180009',
    districtId: '3506180',
    name: 'Maduretno',
  },
  {
    id: '3506180010',
    districtId: '3506180',
    name: 'Ngampel',
  },
  {
    id: '3506180011',
    districtId: '3506180',
    name: 'Kedungmalang',
  },
  {
    id: '3506180012',
    districtId: '3506180',
    name: 'Sukomoro',
  },
  {
    id: '3506180014',
    districtId: '3506180',
    name: 'Jambangan',
  },
  {
    id: '3506180015',
    districtId: '3506180',
    name: 'Srikaton',
  },
  {
    id: '3506180016',
    districtId: '3506180',
    name: 'Tanon',
  },
  {
    id: '3506180017',
    districtId: '3506180',
    name: 'Puhjajar',
  },
  {
    id: '3506190001',
    districtId: '3506190',
    name: 'Bulupasar',
  },
  {
    id: '3506190002',
    districtId: '3506190',
    name: 'Wonosari',
  },
  {
    id: '3506190003',
    districtId: '3506190',
    name: 'Kambingan',
  },
  {
    id: '3506190004',
    districtId: '3506190',
    name: 'Tanjung',
  },
  {
    id: '3506190006',
    districtId: '3506190',
    name: 'Wates',
  },
  {
    id: '3506190007',
    districtId: '3506190',
    name: 'Menang',
  },
  {
    id: '3506190008',
    districtId: '3506190',
    name: 'Tengger Kidul',
  },
  {
    id: '3506190009',
    districtId: '3506190',
    name: 'Semanding',
  },
  {
    id: '3506190010',
    districtId: '3506190',
    name: 'Sitimert0',
  },
  {
    id: '3506190011',
    districtId: '3506190',
    name: 'Pagu',
  },
  {
    id: '3506190012',
    districtId: '3506190',
    name: 'Bendo',
  },
  {
    id: '3506190013',
    districtId: '3506190',
    name: 'Jagung',
  },
  {
    id: '3506191001',
    districtId: '3506191',
    name: 'Baye',
  },
  {
    id: '3506191002',
    districtId: '3506191',
    name: 'Bangsongan',
  },
  {
    id: '3506191004',
    districtId: '3506191',
    name: 'Sambirobyong',
  },
  {
    id: '3506191006',
    districtId: '3506191',
    name: 'Sukoharjo',
  },
  {
    id: '3506191007',
    districtId: '3506191',
    name: 'Jambu',
  },
  {
    id: '3506191008',
    districtId: '3506191',
    name: 'Sekaran',
  },
  {
    id: '3506191009',
    districtId: '3506191',
    name: 'Padangan',
  },
  {
    id: '3506191010',
    districtId: '3506191',
    name: 'Kayen Kidul',
  },
  {
    id: '3506191011',
    districtId: '3506191',
    name: 'Nanggungan',
  },
  {
    id: '3506191012',
    districtId: '3506191',
    name: 'Semambung',
  },
  {
    id: '3506200010',
    districtId: '3506200',
    name: 'Jongbiru',
  },
  {
    id: '3506200011',
    districtId: '3506200',
    name: 'Putih',
  },
  {
    id: '3506200012',
    districtId: '3506200',
    name: 'Sambirejo',
  },
  {
    id: '3506200016',
    districtId: '3506200',
    name: 'Sambiresik',
  },
  {
    id: '3506200017',
    districtId: '3506200',
    name: 'Gampeng',
  },
  {
    id: '3506200018',
    districtId: '3506200',
    name: 'Ngebrak',
  },
  {
    id: '3506200019',
    districtId: '3506200',
    name: 'Wanengpaten',
  },
  {
    id: '3506200021',
    districtId: '3506200',
    name: 'Plosorejo',
  },
  {
    id: '3506200022',
    districtId: '3506200',
    name: 'Kepuhrejo',
  },
  {
    id: '3506200023',
    districtId: '3506200',
    name: 'Kalibelo',
  },
  {
    id: '3506201001',
    districtId: '3506201',
    name: 'Tugurejo',
  },
  {
    id: '3506201002',
    districtId: '3506201',
    name: 'Sumberejo',
  },
  {
    id: '3506201003',
    districtId: '3506201',
    name: 'Paron',
  },
  {
    id: '3506201004',
    districtId: '3506201',
    name: 'Sukorejo',
  },
  {
    id: '3506201005',
    districtId: '3506201',
    name: 'Ngasem',
  },
  {
    id: '3506201006',
    districtId: '3506201',
    name: 'Karangrejo',
  },
  {
    id: '3506201007',
    districtId: '3506201',
    name: 'Kwadungan',
  },
  {
    id: '3506201008',
    districtId: '3506201',
    name: 'Nambaan',
  },
  {
    id: '3506201009',
    districtId: '3506201',
    name: 'Toyoresmi',
  },
  {
    id: '3506201010',
    districtId: '3506201',
    name: 'Wonocatur',
  },
  {
    id: '3506201011',
    districtId: '3506201',
    name: 'Gogorante',
  },
  {
    id: '3506201012',
    districtId: '3506201',
    name: 'Doko',
  },
  {
    id: '3506210001',
    districtId: '3506210',
    name: 'Parang',
  },
  {
    id: '3506210002',
    districtId: '3506210',
    name: 'Tiron',
  },
  {
    id: '3506210003',
    districtId: '3506210',
    name: 'Manyaran',
  },
  {
    id: '3506210004',
    districtId: '3506210',
    name: 'Jatirejo',
  },
  {
    id: '3506210005',
    districtId: '3506210',
    name: 'Banyakan',
  },
  {
    id: '3506210006',
    districtId: '3506210',
    name: 'Maron',
  },
  {
    id: '3506210007',
    districtId: '3506210',
    name: 'Jabon',
  },
  {
    id: '3506210008',
    districtId: '3506210',
    name: 'Ngablak',
  },
  {
    id: '3506210009',
    districtId: '3506210',
    name: 'Sendang',
  },
  {
    id: '3506220001',
    districtId: '3506220',
    name: 'Kalipang',
  },
  {
    id: '3506220002',
    districtId: '3506220',
    name: 'Grogol',
  },
  {
    id: '3506220003',
    districtId: '3506220',
    name: 'Wonoasri',
  },
  {
    id: '3506220004',
    districtId: '3506220',
    name: 'Sonorejo',
  },
  {
    id: '3506220005',
    districtId: '3506220',
    name: 'Bakalan',
  },
  {
    id: '3506220006',
    districtId: '3506220',
    name: 'Datengan',
  },
  {
    id: '3506220007',
    districtId: '3506220',
    name: 'Gambyok',
  },
  {
    id: '3506220008',
    districtId: '3506220',
    name: 'Sumberjo',
  },
  {
    id: '3506230001',
    districtId: '3506230',
    name: 'Tarokan',
  },
  {
    id: '3506230002',
    districtId: '3506230',
    name: 'Bulusari',
  },
  {
    id: '3506230003',
    districtId: '3506230',
    name: 'Kalirong',
  },
  {
    id: '3506230004',
    districtId: '3506230',
    name: 'Kaliboto',
  },
  {
    id: '3506230005',
    districtId: '3506230',
    name: 'Kedungsari',
  },
  {
    id: '3506230008',
    districtId: '3506230',
    name: 'Blimbing',
  },
  {
    id: '3506230009',
    districtId: '3506230',
    name: 'Cengkok',
  },
  {
    id: '3506230010',
    districtId: '3506230',
    name: 'Jati',
  },
  {
    id: '3507010001',
    districtId: '3507010',
    name: 'Sumberoto',
  },
  {
    id: '3507010002',
    districtId: '3507010',
    name: 'Purworejo',
  },
  {
    id: '3507010003',
    districtId: '3507010',
    name: 'Mentaraman',
  },
  {
    id: '3507010004',
    districtId: '3507010',
    name: 'Donomulyo',
  },
  {
    id: '3507010005',
    districtId: '3507010',
    name: 'Tempursari',
  },
  {
    id: '3507010006',
    districtId: '3507010',
    name: 'Tlogosari',
  },
  {
    id: '3507010007',
    districtId: '3507010',
    name: 'Kedungsalam',
  },
  {
    id: '3507010008',
    districtId: '3507010',
    name: 'Banjarjo',
  },
  {
    id: '3507010009',
    districtId: '3507010',
    name: 'Tulungrejo',
  },
  {
    id: '3507010010',
    districtId: '3507010',
    name: 'Purwodadi',
  },
  {
    id: '3507020001',
    districtId: '3507020',
    name: 'Arjosari',
  },
  {
    id: '3507020002',
    districtId: '3507020',
    name: 'Tumpakrejo',
  },
  {
    id: '3507020003',
    districtId: '3507020',
    name: 'Kaliasri',
  },
  {
    id: '3507020004',
    districtId: '3507020',
    name: 'Putukrejo',
  },
  {
    id: '3507020006',
    districtId: '3507020',
    name: 'Kalipare',
  },
  {
    id: '3507020007',
    districtId: '3507020',
    name: 'Sukowilangun',
  },
  {
    id: '3507020008',
    districtId: '3507020',
    name: 'Arjowilangun',
  },
  {
    id: '3507020009',
    districtId: '3507020',
    name: 'Kalirejo',
  },
  {
    id: '3507030001',
    districtId: '3507030',
    name: 'Sumbermanjing Kulon',
  },
  {
    id: '3507030002',
    districtId: '3507030',
    name: 'Pandanrejo',
  },
  {
    id: '3507030003',
    districtId: '3507030',
    name: 'Sumberkerto',
  },
  {
    id: '3507030004',
    districtId: '3507030',
    name: 'Sempol',
  },
  {
    id: '3507030005',
    districtId: '3507030',
    name: 'Pagak',
  },
  {
    id: '3507030006',
    districtId: '3507030',
    name: 'Sumberrejo',
  },
  {
    id: '3507030007',
    districtId: '3507030',
    name: 'Gampingan',
  },
  {
    id: '3507030008',
    districtId: '3507030',
    name: 'Tlogorejo',
  },
  {
    id: '3507040001',
    districtId: '3507040',
    name: 'Bandungrejo',
  },
  {
    id: '3507040002',
    districtId: '3507040',
    name: 'Sumberbening',
  },
  {
    id: '3507040003',
    districtId: '3507040',
    name: 'Srigonco',
  },
  {
    id: '3507040004',
    districtId: '3507040',
    name: 'Wonorejo',
  },
  {
    id: '3507040005',
    districtId: '3507040',
    name: 'Bantur',
  },
  {
    id: '3507040006',
    districtId: '3507040',
    name: 'Pringgodani',
  },
  {
    id: '3507040007',
    districtId: '3507040',
    name: 'Rejosari',
  },
  {
    id: '3507040008',
    districtId: '3507040',
    name: 'Wonokerto',
  },
  {
    id: '3507040009',
    districtId: '3507040',
    name: 'Rejoyoso',
  },
  {
    id: '3507040010',
    districtId: '3507040',
    name: 'Karangsari',
  },
  {
    id: '3507050001',
    districtId: '3507050',
    name: 'Tumpakrejo',
  },
  {
    id: '3507050002',
    districtId: '3507050',
    name: 'Sindurejo',
  },
  {
    id: '3507050003',
    districtId: '3507050',
    name: 'Gajahrejo',
  },
  {
    id: '3507050004',
    districtId: '3507050',
    name: 'Sidodadi',
  },
  {
    id: '3507050005',
    districtId: '3507050',
    name: 'Gedangan',
  },
  {
    id: '3507050006',
    districtId: '3507050',
    name: 'Segaran',
  },
  {
    id: '3507050007',
    districtId: '3507050',
    name: 'Sumberejo',
  },
  {
    id: '3507050008',
    districtId: '3507050',
    name: 'Girimulyo',
  },
  {
    id: '3507060001',
    districtId: '3507060',
    name: 'Sitiarjo',
  },
  {
    id: '3507060002',
    districtId: '3507060',
    name: 'Tambakrejo',
  },
  {
    id: '3507060003',
    districtId: '3507060',
    name: 'Kedungbanteng',
  },
  {
    id: '3507060004',
    districtId: '3507060',
    name: 'Tambakasri',
  },
  {
    id: '3507060005',
    districtId: '3507060',
    name: 'Tegalrejo',
  },
  {
    id: '3507060006',
    districtId: '3507060',
    name: 'Ringinkembar',
  },
  {
    id: '3507060007',
    districtId: '3507060',
    name: 'Sumberagung',
  },
  {
    id: '3507060008',
    districtId: '3507060',
    name: 'Harjokuncaran',
  },
  {
    id: '3507060009',
    districtId: '3507060',
    name: 'Argotirto',
  },
  {
    id: '3507060010',
    districtId: '3507060',
    name: 'Ringinsari',
  },
  {
    id: '3507060012',
    districtId: '3507060',
    name: 'Sumbermanjing Wetan',
  },
  {
    id: '3507060014',
    districtId: '3507060',
    name: 'Sekarbanyu',
  },
  {
    id: '3507060015',
    districtId: '3507060',
    name: 'Sidoasri',
  },
  {
    id: '3507070001',
    districtId: '3507070',
    name: 'Sukodono',
  },
  {
    id: '3507070002',
    districtId: '3507070',
    name: 'Srimulyo',
  },
  {
    id: '3507070003',
    districtId: '3507070',
    name: 'Baturetno',
  },
  {
    id: '3507070004',
    districtId: '3507070',
    name: 'Bumirejo',
  },
  {
    id: '3507070005',
    districtId: '3507070',
    name: 'Sumbersuko',
  },
  {
    id: '3507070006',
    districtId: '3507070',
    name: 'Amadanom',
  },
  {
    id: '3507070007',
    districtId: '3507070',
    name: 'Dampit',
  },
  {
    id: '3507070008',
    districtId: '3507070',
    name: 'Pamotan',
  },
  {
    id: '3507070009',
    districtId: '3507070',
    name: 'Majangtengah',
  },
  {
    id: '3507070011',
    districtId: '3507070',
    name: 'Pojok',
  },
  {
    id: '3507070012',
    districtId: '3507070',
    name: 'Jambangan',
  },
  {
    id: '3507080001',
    districtId: '3507080',
    name: 'Purwodadi',
  },
  {
    id: '3507080002',
    districtId: '3507080',
    name: 'Pujiharjo',
  },
  {
    id: '3507080003',
    districtId: '3507080',
    name: 'Sumbertangkil',
  },
  {
    id: '3507080004',
    districtId: '3507080',
    name: 'Kepatihan',
  },
  {
    id: '3507080005',
    districtId: '3507080',
    name: 'Jogomulyan',
  },
  {
    id: '3507080006',
    districtId: '3507080',
    name: 'Tirtoyudo',
  },
  {
    id: '3507080007',
    districtId: '3507080',
    name: 'Gadungsari',
  },
  {
    id: '3507080008',
    districtId: '3507080',
    name: 'Tlogosari',
  },
  {
    id: '3507080009',
    districtId: '3507080',
    name: 'Sukorejo',
  },
  {
    id: '3507080010',
    districtId: '3507080',
    name: 'Ampelgading',
  },
  {
    id: '3507080011',
    districtId: '3507080',
    name: 'Tamankuncaran',
  },
  {
    id: '3507080012',
    districtId: '3507080',
    name: 'Wonoagung',
  },
  {
    id: '3507080013',
    districtId: '3507080',
    name: 'Tamansatriyan',
  },
  {
    id: '3507090001',
    districtId: '3507090',
    name: 'Lebakharjo',
  },
  {
    id: '3507090002',
    districtId: '3507090',
    name: 'Wirotaman',
  },
  {
    id: '3507090003',
    districtId: '3507090',
    name: 'Tamanasri',
  },
  {
    id: '3507090004',
    districtId: '3507090',
    name: 'Sonowangi',
  },
  {
    id: '3507090005',
    districtId: '3507090',
    name: 'Tirtomarto',
  },
  {
    id: '3507090006',
    districtId: '3507090',
    name: 'Purwoharjo',
  },
  {
    id: '3507090007',
    districtId: '3507090',
    name: 'Sidorenggo',
  },
  {
    id: '3507090008',
    districtId: '3507090',
    name: 'Tirtomoyo',
  },
  {
    id: '3507090009',
    districtId: '3507090',
    name: 'Tawangagung',
  },
  {
    id: '3507090010',
    districtId: '3507090',
    name: 'Simojayan',
  },
  {
    id: '3507090011',
    districtId: '3507090',
    name: 'Argoyuwono',
  },
  {
    id: '3507090012',
    districtId: '3507090',
    name: 'Mulyoasri',
  },
  {
    id: '3507090013',
    districtId: '3507090',
    name: 'Tamansari',
  },
  {
    id: '3507100001',
    districtId: '3507100',
    name: 'Dawuhan',
  },
  {
    id: '3507100002',
    districtId: '3507100',
    name: 'Sumberejo',
  },
  {
    id: '3507100003',
    districtId: '3507100',
    name: 'Pandansari',
  },
  {
    id: '3507100004',
    districtId: '3507100',
    name: 'Ngadireso',
  },
  {
    id: '3507100005',
    districtId: '3507100',
    name: 'Karanganyar',
  },
  {
    id: '3507100006',
    districtId: '3507100',
    name: 'Jambesari',
  },
  {
    id: '3507100007',
    districtId: '3507100',
    name: 'Pajaran',
  },
  {
    id: '3507100008',
    districtId: '3507100',
    name: 'Argosuko',
  },
  {
    id: '3507100010',
    districtId: '3507100',
    name: 'Karangnongko',
  },
  {
    id: '3507100011',
    districtId: '3507100',
    name: 'Wonomulyo',
  },
  {
    id: '3507100013',
    districtId: '3507100',
    name: 'Wonorejo',
  },
  {
    id: '3507100014',
    districtId: '3507100',
    name: 'Poncokusumo',
  },
  {
    id: '3507100015',
    districtId: '3507100',
    name: 'Wringinanom',
  },
  {
    id: '3507100016',
    districtId: '3507100',
    name: 'Gubukklakah',
  },
  {
    id: '3507100017',
    districtId: '3507100',
    name: 'Ngadas',
  },
  {
    id: '3507110001',
    districtId: '3507110',
    name: 'Sumberputih',
  },
  {
    id: '3507110002',
    districtId: '3507110',
    name: 'Wonoayu',
  },
  {
    id: '3507110003',
    districtId: '3507110',
    name: 'Bambang',
  },
  {
    id: '3507110004',
    districtId: '3507110',
    name: 'Bringin',
  },
  {
    id: '3507110005',
    districtId: '3507110',
    name: 'Dadapan',
  },
  {
    id: '3507110006',
    districtId: '3507110',
    name: 'Patokpicis',
  },
  {
    id: '3507110007',
    districtId: '3507110',
    name: 'Blayu',
  },
  {
    id: '3507110008',
    districtId: '3507110',
    name: 'Codo',
  },
  {
    id: '3507110009',
    districtId: '3507110',
    name: 'Sukolilo',
  },
  {
    id: '3507110010',
    districtId: '3507110',
    name: 'Kidangbang',
  },
  {
    id: '3507110011',
    districtId: '3507110',
    name: 'Sukoanyar',
  },
  {
    id: '3507110012',
    districtId: '3507110',
    name: 'Wajak',
  },
  {
    id: '3507110013',
    districtId: '3507110',
    name: 'Ngembal',
  },
  {
    id: '3507120001',
    districtId: '3507120',
    name: 'Kemulan',
  },
  {
    id: '3507120002',
    districtId: '3507120',
    name: 'Tawangrejeni',
  },
  {
    id: '3507120003',
    districtId: '3507120',
    name: 'Sawahan',
  },
  {
    id: '3507120004',
    districtId: '3507120',
    name: 'Undaan',
  },
  {
    id: '3507120005',
    districtId: '3507120',
    name: 'Gedog Kulon',
  },
  {
    id: '3507120006',
    districtId: '3507120',
    name: 'Gedog Wetan',
  },
  {
    id: '3507120007',
    districtId: '3507120',
    name: 'Talok',
  },
  {
    id: '3507120008',
    districtId: '3507120',
    name: 'Sedayu',
  },
  {
    id: '3507120009',
    districtId: '3507120',
    name: 'Tanggung',
  },
  {
    id: '3507120012',
    districtId: '3507120',
    name: 'Pagedangan',
  },
  {
    id: '3507120013',
    districtId: '3507120',
    name: 'Sanankerto',
  },
  {
    id: '3507120014',
    districtId: '3507120',
    name: 'Sananrejo',
  },
  {
    id: '3507120015',
    districtId: '3507120',
    name: 'Kedok',
  },
  {
    id: '3507120016',
    districtId: '3507120',
    name: 'Talangsuko',
  },
  {
    id: '3507130001',
    districtId: '3507130',
    name: 'Sukonolo',
  },
  {
    id: '3507130002',
    districtId: '3507130',
    name: 'Gading',
  },
  {
    id: '3507130004',
    districtId: '3507130',
    name: 'Bakalan',
  },
  {
    id: '3507130005',
    districtId: '3507130',
    name: 'Sudimoro',
  },
  {
    id: '3507130006',
    districtId: '3507130',
    name: 'Kasri',
  },
  {
    id: '3507130007',
    districtId: '3507130',
    name: 'Pringu',
  },
  {
    id: '3507130008',
    districtId: '3507130',
    name: 'Kasembon',
  },
  {
    id: '3507130009',
    districtId: '3507130',
    name: 'Kuwolu',
  },
  {
    id: '3507130010',
    districtId: '3507130',
    name: 'Krebet Senggrong',
  },
  {
    id: '3507130011',
    districtId: '3507130',
    name: 'Lumbangsari',
  },
  {
    id: '3507130012',
    districtId: '3507130',
    name: 'Wandanpuro',
  },
  {
    id: '3507130013',
    districtId: '3507130',
    name: 'Bululawang',
  },
  {
    id: '3507130014',
    districtId: '3507130',
    name: 'Sempalwadak',
  },
  {
    id: '3507140001',
    districtId: '3507140',
    name: 'Sukorejo',
  },
  {
    id: '3507140002',
    districtId: '3507140',
    name: 'Bulupitu',
  },
  {
    id: '3507140003',
    districtId: '3507140',
    name: 'Sukosari',
  },
  {
    id: '3507140004',
    districtId: '3507140',
    name: 'Panggungrejo',
  },
  {
    id: '3507140005',
    districtId: '3507140',
    name: 'Gondanglegi Kulon',
  },
  {
    id: '3507140006',
    districtId: '3507140',
    name: 'Gondanglegi Wetan',
  },
  {
    id: '3507140007',
    districtId: '3507140',
    name: 'Sepanjang',
  },
  {
    id: '3507140008',
    districtId: '3507140',
    name: 'Putat Kidul',
  },
  {
    id: '3507140009',
    districtId: '3507140',
    name: 'Putat Lor',
  },
  {
    id: '3507140011',
    districtId: '3507140',
    name: 'Ketawang',
  },
  {
    id: '3507140012',
    districtId: '3507140',
    name: 'Ganjaran',
  },
  {
    id: '3507140013',
    districtId: '3507140',
    name: 'Putukrejo',
  },
  {
    id: '3507140014',
    districtId: '3507140',
    name: 'Sumberjaya',
  },
  {
    id: '3507150001',
    districtId: '3507150',
    name: 'Kanigoro',
  },
  {
    id: '3507150002',
    districtId: '3507150',
    name: 'Balearjo',
  },
  {
    id: '3507150003',
    districtId: '3507150',
    name: 'Kademangan',
  },
  {
    id: '3507150004',
    districtId: '3507150',
    name: 'Suwaru',
  },
  {
    id: '3507150005',
    districtId: '3507150',
    name: 'Clumprit',
  },
  {
    id: '3507150006',
    districtId: '3507150',
    name: 'Sidorejo',
  },
  {
    id: '3507150007',
    districtId: '3507150',
    name: 'Pagelaran',
  },
  {
    id: '3507150008',
    districtId: '3507150',
    name: 'Banjarejo',
  },
  {
    id: '3507150009',
    districtId: '3507150',
    name: 'Brongkal',
  },
  {
    id: '3507150010',
    districtId: '3507150',
    name: 'Karangsuko',
  },
  {
    id: '3507160001',
    districtId: '3507160',
    name: 'Jenggolo',
  },
  {
    id: '3507160003',
    districtId: '3507160',
    name: 'Kemiri',
  },
  {
    id: '3507160004',
    districtId: '3507160',
    name: 'Tegalsari',
  },
  {
    id: '3507160005',
    districtId: '3507160',
    name: 'Mangunrejo',
  },
  {
    id: '3507160006',
    districtId: '3507160',
    name: 'Panggungrejo',
  },
  {
    id: '3507160007',
    districtId: '3507160',
    name: 'Kedungpedaringan',
  },
  {
    id: '3507160008',
    districtId: '3507160',
    name: 'Penarukan',
  },
  {
    id: '3507160009',
    districtId: '3507160',
    name: 'Cepokomulyo',
  },
  {
    id: '3507160010',
    districtId: '3507160',
    name: 'Kepanjen',
  },
  {
    id: '3507160011',
    districtId: '3507160',
    name: 'Talangagung',
  },
  {
    id: '3507160012',
    districtId: '3507160',
    name: 'Dilem',
  },
  {
    id: '3507160013',
    districtId: '3507160',
    name: 'Ardirejo',
  },
  {
    id: '3507160014',
    districtId: '3507160',
    name: 'Sukoraharjo',
  },
  {
    id: '3507160015',
    districtId: '3507160',
    name: 'Curung Rejo',
  },
  {
    id: '3507160016',
    districtId: '3507160',
    name: 'Jatirejoyoso',
  },
  {
    id: '3507160017',
    districtId: '3507160',
    name: 'Ngadilangkung',
  },
  {
    id: '3507160018',
    districtId: '3507160',
    name: 'Mojosari',
  },
  {
    id: '3507170001',
    districtId: '3507170',
    name: 'Karangkates',
  },
  {
    id: '3507170003',
    districtId: '3507170',
    name: 'Jatiguwi',
  },
  {
    id: '3507170004',
    districtId: '3507170',
    name: 'Sambigede',
  },
  {
    id: '3507170006',
    districtId: '3507170',
    name: 'Ternyang',
  },
  {
    id: '3507180001',
    districtId: '3507180',
    name: 'Slorok',
  },
  {
    id: '3507180002',
    districtId: '3507180',
    name: 'Jatikerto',
  },
  {
    id: '3507180003',
    districtId: '3507180',
    name: 'Ngadirejo',
  },
  {
    id: '3507180004',
    districtId: '3507180',
    name: 'Karangrejo',
  },
  {
    id: '3507180005',
    districtId: '3507180',
    name: 'Kromengan',
  },
  {
    id: '3507180006',
    districtId: '3507180',
    name: 'Peniwen',
  },
  {
    id: '3507180007',
    districtId: '3507180',
    name: 'Jambuwer',
  },
  {
    id: '3507190001',
    districtId: '3507190',
    name: 'Ngajum',
  },
  {
    id: '3507190002',
    districtId: '3507190',
    name: 'Palaan',
  },
  {
    id: '3507190003',
    districtId: '3507190',
    name: 'Ngasem',
  },
  {
    id: '3507190004',
    districtId: '3507190',
    name: 'Banjarsari',
  },
  {
    id: '3507190005',
    districtId: '3507190',
    name: 'Kranggan',
  },
  {
    id: '3507190006',
    districtId: '3507190',
    name: 'Kesamben',
  },
  {
    id: '3507190007',
    districtId: '3507190',
    name: 'Babadan',
  },
  {
    id: '3507190008',
    districtId: '3507190',
    name: 'Balesari',
  },
  {
    id: '3507190009',
    districtId: '3507190',
    name: 'Maguan',
  },
  {
    id: '3507200002',
    districtId: '3507200',
    name: 'Plandi',
  },
  {
    id: '3507200003',
    districtId: '3507200',
    name: 'Plaosan',
  },
  {
    id: '3507200004',
    districtId: '3507200',
    name: 'Kebobang',
  },
  {
    id: '3507200005',
    districtId: '3507200',
    name: 'Bangelan',
  },
  {
    id: '3507200008',
    districtId: '3507200',
    name: 'Wonosari',
  },
  {
    id: '3507210001',
    districtId: '3507210',
    name: 'Sumbersuko',
  },
  {
    id: '3507210002',
    districtId: '3507210',
    name: 'Mendalanwangi',
  },
  {
    id: '3507210003',
    districtId: '3507210',
    name: 'Sitirejo',
  },
  {
    id: '3507210004',
    districtId: '3507210',
    name: 'Parangargo',
  },
  {
    id: '3507210005',
    districtId: '3507210',
    name: 'Gondowangi',
  },
  {
    id: '3507210006',
    districtId: '3507210',
    name: 'Pandanrejo',
  },
  {
    id: '3507210008',
    districtId: '3507210',
    name: 'Sukodadi',
  },
  {
    id: '3507210009',
    districtId: '3507210',
    name: 'Sidorahayu',
  },
  {
    id: '3507210010',
    districtId: '3507210',
    name: 'Jedong',
  },
  {
    id: '3507210011',
    districtId: '3507210',
    name: 'Dalisodo',
  },
  {
    id: '3507210012',
    districtId: '3507210',
    name: 'Pandanlandung',
  },
  {
    id: '3507220001',
    districtId: '3507220',
    name: 'Permanu',
  },
  {
    id: '3507220002',
    districtId: '3507220',
    name: 'Karangpandan',
  },
  {
    id: '3507220003',
    districtId: '3507220',
    name: 'Glanggang',
  },
  {
    id: '3507220004',
    districtId: '3507220',
    name: 'Sutojayan',
  },
  {
    id: '3507220005',
    districtId: '3507220',
    name: 'Wonokerso',
  },
  {
    id: '3507220006',
    districtId: '3507220',
    name: 'Karangduren',
  },
  {
    id: '3507220007',
    districtId: '3507220',
    name: 'Pakisaji',
  },
  {
    id: '3507220008',
    districtId: '3507220',
    name: 'Jatisari',
  },
  {
    id: '3507220009',
    districtId: '3507220',
    name: 'Wadung',
  },
  {
    id: '3507220010',
    districtId: '3507220',
    name: 'Genengan',
  },
  {
    id: '3507220011',
    districtId: '3507220',
    name: 'Kebonagung',
  },
  {
    id: '3507220012',
    districtId: '3507220',
    name: 'Kendalpayak',
  },
  {
    id: '3507230001',
    districtId: '3507230',
    name: 'Tambakasri',
  },
  {
    id: '3507230002',
    districtId: '3507230',
    name: 'Tangkilsari',
  },
  {
    id: '3507230003',
    districtId: '3507230',
    name: 'Jambearjo',
  },
  {
    id: '3507230004',
    districtId: '3507230',
    name: 'Jatisari',
  },
  {
    id: '3507230005',
    districtId: '3507230',
    name: 'Pandanmulyo',
  },
  {
    id: '3507230006',
    districtId: '3507230',
    name: 'Ngawonggo',
  },
  {
    id: '3507230007',
    districtId: '3507230',
    name: 'Purwosekar',
  },
  {
    id: '3507230008',
    districtId: '3507230',
    name: 'Gunungronggo',
  },
  {
    id: '3507230009',
    districtId: '3507230',
    name: 'Gunungsari',
  },
  {
    id: '3507230010',
    districtId: '3507230',
    name: 'Tajinan',
  },
  {
    id: '3507230011',
    districtId: '3507230',
    name: 'Randugading',
  },
  {
    id: '3507230012',
    districtId: '3507230',
    name: 'Sumbersuko',
  },
  {
    id: '3507240001',
    districtId: '3507240',
    name: 'Ngingit',
  },
  {
    id: '3507240002',
    districtId: '3507240',
    name: 'Kidal',
  },
  {
    id: '3507240003',
    districtId: '3507240',
    name: 'Kambingan',
  },
  {
    id: '3507240004',
    districtId: '3507240',
    name: 'Pandanajeng',
  },
  {
    id: '3507240005',
    districtId: '3507240',
    name: 'Pulungdowo',
  },
  {
    id: '3507240006',
    districtId: '3507240',
    name: 'Bokor',
  },
  {
    id: '3507240007',
    districtId: '3507240',
    name: 'Slamet',
  },
  {
    id: '3507240008',
    districtId: '3507240',
    name: 'Wringinsongo',
  },
  {
    id: '3507240010',
    districtId: '3507240',
    name: 'Malangsuko',
  },
  {
    id: '3507240011',
    districtId: '3507240',
    name: 'Tumpang',
  },
  {
    id: '3507240012',
    districtId: '3507240',
    name: 'Tulusbesar',
  },
  {
    id: '3507240013',
    districtId: '3507240',
    name: 'Benjor',
  },
  {
    id: '3507240015',
    districtId: '3507240',
    name: 'Duwet Krajan',
  },
  {
    id: '3507250001',
    districtId: '3507250',
    name: 'Sekarpuro',
  },
  {
    id: '3507250002',
    districtId: '3507250',
    name: 'Ampeldento',
  },
  {
    id: '3507250003',
    districtId: '3507250',
    name: 'Sumberkradenan',
  },
  {
    id: '3507250004',
    districtId: '3507250',
    name: 'Kedungrejo',
  },
  {
    id: '3507250005',
    districtId: '3507250',
    name: 'Banjarrejo',
  },
  {
    id: '3507250006',
    districtId: '3507250',
    name: 'Pucang Songo',
  },
  {
    id: '3507250007',
    districtId: '3507250',
    name: 'Sukoanyar',
  },
  {
    id: '3507250008',
    districtId: '3507250',
    name: 'Sumberpasir',
  },
  {
    id: '3507250009',
    districtId: '3507250',
    name: 'Pakiskembar',
  },
  {
    id: '3507250010',
    districtId: '3507250',
    name: 'Pakisjajar',
  },
  {
    id: '3507250011',
    districtId: '3507250',
    name: 'Bunutwetan',
  },
  {
    id: '3507250012',
    districtId: '3507250',
    name: 'Asrikaton',
  },
  {
    id: '3507250013',
    districtId: '3507250',
    name: 'Saptorenggo',
  },
  {
    id: '3507250014',
    districtId: '3507250',
    name: 'Mangliawan',
  },
  {
    id: '3507250015',
    districtId: '3507250',
    name: 'Tirtomoyo',
  },
  {
    id: '3507260001',
    districtId: '3507260',
    name: 'Kenongo',
  },
  {
    id: '3507260002',
    districtId: '3507260',
    name: 'Ngadirejo',
  },
  {
    id: '3507260003',
    districtId: '3507260',
    name: 'Taji',
  },
  {
    id: '3507260004',
    districtId: '3507260',
    name: 'Pandansari Lor',
  },
  {
    id: '3507260005',
    districtId: '3507260',
    name: 'Sukopuro',
  },
  {
    id: '3507260006',
    districtId: '3507260',
    name: 'Sidorejo',
  },
  {
    id: '3507260007',
    districtId: '3507260',
    name: 'Sukolilo',
  },
  {
    id: '3507260008',
    districtId: '3507260',
    name: 'Sidomulyo',
  },
  {
    id: '3507260009',
    districtId: '3507260',
    name: 'Gading Kembar',
  },
  {
    id: '3507260010',
    districtId: '3507260',
    name: 'Kemantren',
  },
  {
    id: '3507260011',
    districtId: '3507260',
    name: 'Argosari',
  },
  {
    id: '3507260012',
    districtId: '3507260',
    name: 'Slamparejo',
  },
  {
    id: '3507260013',
    districtId: '3507260',
    name: 'Kemiri',
  },
  {
    id: '3507260014',
    districtId: '3507260',
    name: 'Jabung',
  },
  {
    id: '3507260015',
    districtId: '3507260',
    name: 'Gunung Jati',
  },
  {
    id: '3507270001',
    districtId: '3507270',
    name: 'Sidoluhur',
  },
  {
    id: '3507270002',
    districtId: '3507270',
    name: 'Srigading',
  },
  {
    id: '3507270003',
    districtId: '3507270',
    name: 'Sidodadi',
  },
  {
    id: '3507270004',
    districtId: '3507270',
    name: 'Bedali',
  },
  {
    id: '3507270005',
    districtId: '3507270',
    name: 'Kalirejo',
  },
  {
    id: '3507270006',
    districtId: '3507270',
    name: 'Mulyoarjo',
  },
  {
    id: '3507270007',
    districtId: '3507270',
    name: 'Sumber Ngepoh',
  },
  {
    id: '3507270008',
    districtId: '3507270',
    name: 'Sumber Porong',
  },
  {
    id: '3507270009',
    districtId: '3507270',
    name: 'Turirejo',
  },
  {
    id: '3507270010',
    districtId: '3507270',
    name: 'Lawang',
  },
  {
    id: '3507270011',
    districtId: '3507270',
    name: 'Ketindan',
  },
  {
    id: '3507270012',
    districtId: '3507270',
    name: 'Wonorejo',
  },
  {
    id: '3507280001',
    districtId: '3507280',
    name: 'Langlang',
  },
  {
    id: '3507280002',
    districtId: '3507280',
    name: 'Tunjungtirto',
  },
  {
    id: '3507280003',
    districtId: '3507280',
    name: 'Banjararum',
  },
  {
    id: '3507280004',
    districtId: '3507280',
    name: 'Watugede',
  },
  {
    id: '3507280005',
    districtId: '3507280',
    name: 'Dengkol',
  },
  {
    id: '3507280006',
    districtId: '3507280',
    name: 'Wonorejo',
  },
  {
    id: '3507280007',
    districtId: '3507280',
    name: 'Baturetno',
  },
  {
    id: '3507280008',
    districtId: '3507280',
    name: 'Tamanharjo',
  },
  {
    id: '3507280009',
    districtId: '3507280',
    name: 'Losari',
  },
  {
    id: '3507280010',
    districtId: '3507280',
    name: 'Pagentan',
  },
  {
    id: '3507280011',
    districtId: '3507280',
    name: 'Purwoasri',
  },
  {
    id: '3507280012',
    districtId: '3507280',
    name: 'Klampok',
  },
  {
    id: '3507280013',
    districtId: '3507280',
    name: 'Gunungrejo',
  },
  {
    id: '3507280014',
    districtId: '3507280',
    name: 'Candirenggo',
  },
  {
    id: '3507280015',
    districtId: '3507280',
    name: 'Ardimulyo',
  },
  {
    id: '3507280016',
    districtId: '3507280',
    name: 'Randuagung',
  },
  {
    id: '3507280017',
    districtId: '3507280',
    name: 'Toyomarto',
  },
  {
    id: '3507290001',
    districtId: '3507290',
    name: 'Tegalgondo',
  },
  {
    id: '3507290002',
    districtId: '3507290',
    name: 'Kepuharjo',
  },
  {
    id: '3507290004',
    districtId: '3507290',
    name: 'Ngijo',
  },
  {
    id: '3507290005',
    districtId: '3507290',
    name: 'Ampeldento',
  },
  {
    id: '3507290006',
    districtId: '3507290',
    name: 'Girimoyo',
  },
  {
    id: '3507290007',
    districtId: '3507290',
    name: 'Bocek',
  },
  {
    id: '3507290008',
    districtId: '3507290',
    name: 'Donowarih',
  },
  {
    id: '3507290009',
    districtId: '3507290',
    name: 'Tawangargo',
  },
  {
    id: '3507300002',
    districtId: '3507300',
    name: 'Kalisongo',
  },
  {
    id: '3507300003',
    districtId: '3507300',
    name: 'Karangwidoro',
  },
  {
    id: '3507300005',
    districtId: '3507300',
    name: 'Selorejo',
  },
  {
    id: '3507300006',
    districtId: '3507300',
    name: 'Tegalweru',
  },
  {
    id: '3507300007',
    districtId: '3507300',
    name: 'Landungsari',
  },
  {
    id: '3507300008',
    districtId: '3507300',
    name: 'Gadingkulon',
  },
  {
    id: '3507300009',
    districtId: '3507300',
    name: 'Mulyoagung',
  },
  {
    id: '3507300010',
    districtId: '3507300',
    name: 'Sumbersekar',
  },
  {
    id: '3507310001',
    districtId: '3507310',
    name: 'Bendosari',
  },
  {
    id: '3507310002',
    districtId: '3507310',
    name: 'Sukomulyo',
  },
  {
    id: '3507310003',
    districtId: '3507310',
    name: 'Pujon Kidul',
  },
  {
    id: '3507310004',
    districtId: '3507310',
    name: 'Pandesari',
  },
  {
    id: '3507310005',
    districtId: '3507310',
    name: 'Pujon Lor',
  },
  {
    id: '3507310006',
    districtId: '3507310',
    name: 'Ngroto',
  },
  {
    id: '3507310007',
    districtId: '3507310',
    name: 'Ngabab',
  },
  {
    id: '3507310008',
    districtId: '3507310',
    name: 'Tawangsari',
  },
  {
    id: '3507310009',
    districtId: '3507310',
    name: 'Madiredo',
  },
  {
    id: '3507310010',
    districtId: '3507310',
    name: 'Wiyurejo',
  },
  {
    id: '3507320001',
    districtId: '3507320',
    name: 'Pagersari',
  },
  {
    id: '3507320002',
    districtId: '3507320',
    name: 'Sidodadi',
  },
  {
    id: '3507320003',
    districtId: '3507320',
    name: 'Banjarejo',
  },
  {
    id: '3507320004',
    districtId: '3507320',
    name: 'Purworejo',
  },
  {
    id: '3507320005',
    districtId: '3507320',
    name: 'Ngantru',
  },
  {
    id: '3507320006',
    districtId: '3507320',
    name: 'Banturejo',
  },
  {
    id: '3507320007',
    districtId: '3507320',
    name: 'Pandansari',
  },
  {
    id: '3507320008',
    districtId: '3507320',
    name: 'Mulyorejo',
  },
  {
    id: '3507320009',
    districtId: '3507320',
    name: 'Sumberagung',
  },
  {
    id: '3507320010',
    districtId: '3507320',
    name: 'Kaumrejo',
  },
  {
    id: '3507320011',
    districtId: '3507320',
    name: 'Tulungrejo',
  },
  {
    id: '3507320012',
    districtId: '3507320',
    name: 'Waturejo',
  },
  {
    id: '3507320013',
    districtId: '3507320',
    name: 'Jombok',
  },
  {
    id: '3507330001',
    districtId: '3507330',
    name: 'Pondok Agung',
  },
  {
    id: '3507330002',
    districtId: '3507330',
    name: 'Bayem',
  },
  {
    id: '3507330003',
    districtId: '3507330',
    name: 'Pait',
  },
  {
    id: '3507330004',
    districtId: '3507330',
    name: 'Wonoagung',
  },
  {
    id: '3507330005',
    districtId: '3507330',
    name: 'Kasembon',
  },
  {
    id: '3507330006',
    districtId: '3507330',
    name: 'Sukosari',
  },
  {
    id: '3508010001',
    districtId: '3508010',
    name: 'Tegalrejo',
  },
  {
    id: '3508010002',
    districtId: '3508010',
    name: 'Bulurejo',
  },
  {
    id: '3508010003',
    districtId: '3508010',
    name: 'Purorejo',
  },
  {
    id: '3508010004',
    districtId: '3508010',
    name: 'Tempurrejo',
  },
  {
    id: '3508010005',
    districtId: '3508010',
    name: 'Tempursari',
  },
  {
    id: '3508010006',
    districtId: '3508010',
    name: 'Pundungsari',
  },
  {
    id: '3508010007',
    districtId: '3508010',
    name: 'Kaliuling',
  },
  {
    id: '3508020001',
    districtId: '3508020',
    name: 'Sidomulyo',
  },
  {
    id: '3508020002',
    districtId: '3508020',
    name: 'Pronojiwo',
  },
  {
    id: '3508020003',
    districtId: '3508020',
    name: 'Tamanayu',
  },
  {
    id: '3508020004',
    districtId: '3508020',
    name: 'Sumberurip',
  },
  {
    id: '3508020005',
    districtId: '3508020',
    name: 'Oro Oro Ombo',
  },
  {
    id: '3508020006',
    districtId: '3508020',
    name: 'Supiturang',
  },
  {
    id: '3508030001',
    districtId: '3508030',
    name: 'Jugosari',
  },
  {
    id: '3508030002',
    districtId: '3508030',
    name: 'Jarit',
  },
  {
    id: '3508030003',
    districtId: '3508030',
    name: 'Candipuro',
  },
  {
    id: '3508030004',
    districtId: '3508030',
    name: 'Sumberrejo',
  },
  {
    id: '3508030007',
    districtId: '3508030',
    name: 'Penanggal',
  },
  {
    id: '3508030008',
    districtId: '3508030',
    name: 'Tambahrejo',
  },
  {
    id: '3508030009',
    districtId: '3508030',
    name: 'Kloposawit',
  },
  {
    id: '3508040001',
    districtId: '3508040',
    name: 'Gondoruso',
  },
  {
    id: '3508040002',
    districtId: '3508040',
    name: 'Kalibendo',
  },
  {
    id: '3508040003',
    districtId: '3508040',
    name: 'Bades',
  },
  {
    id: '3508040004',
    districtId: '3508040',
    name: 'Bago',
  },
  {
    id: '3508040005',
    districtId: '3508040',
    name: 'Selok Awar Awar',
  },
  {
    id: '3508040006',
    districtId: '3508040',
    name: 'Condro',
  },
  {
    id: '3508040007',
    districtId: '3508040',
    name: 'Madurejo',
  },
  {
    id: '3508040008',
    districtId: '3508040',
    name: 'Pasirian',
  },
  {
    id: '3508040011',
    districtId: '3508040',
    name: 'Selok Anyar',
  },
  {
    id: '3508050001',
    districtId: '3508050',
    name: 'Pandanarum',
  },
  {
    id: '3508050002',
    districtId: '3508050',
    name: 'Pandanwangi',
  },
  {
    id: '3508050003',
    districtId: '3508050',
    name: 'Sumberjati',
  },
  {
    id: '3508050004',
    districtId: '3508050',
    name: 'Tempeh Kidul',
  },
  {
    id: '3508050005',
    districtId: '3508050',
    name: 'Lempeni',
  },
  {
    id: '3508050006',
    districtId: '3508050',
    name: 'Tempeh Tengah',
  },
  {
    id: '3508050007',
    districtId: '3508050',
    name: 'Kaliwungu',
  },
  {
    id: '3508050008',
    districtId: '3508050',
    name: 'Tempeh Lor',
  },
  {
    id: '3508050010',
    districtId: '3508050',
    name: 'Jatisari',
  },
  {
    id: '3508050011',
    districtId: '3508050',
    name: 'Pulo',
  },
  {
    id: '3508050012',
    districtId: '3508050',
    name: 'Gesang',
  },
  {
    id: '3508050013',
    districtId: '3508050',
    name: 'Jokarto',
  },
  {
    id: '3508060008',
    districtId: '3508060',
    name: 'Banjarwaru',
  },
  {
    id: '3508060009',
    districtId: '3508060',
    name: 'Labruk Lor',
  },
  {
    id: '3508060010',
    districtId: '3508060',
    name: 'Citrodiwangsan',
  },
  {
    id: '3508060011',
    districtId: '3508060',
    name: 'Ditotrunan',
  },
  {
    id: '3508060012',
    districtId: '3508060',
    name: 'Jogotrunan',
  },
  {
    id: '3508060013',
    districtId: '3508060',
    name: 'Denok',
  },
  {
    id: '3508060014',
    districtId: '3508060',
    name: 'Blukon',
  },
  {
    id: '3508060015',
    districtId: '3508060',
    name: 'Boreng',
  },
  {
    id: '3508060016',
    districtId: '3508060',
    name: 'Jogoyudan',
  },
  {
    id: '3508060017',
    districtId: '3508060',
    name: 'Rogotrunan',
  },
  {
    id: '3508060018',
    districtId: '3508060',
    name: 'Tompokersan',
  },
  {
    id: '3508060019',
    districtId: '3508060',
    name: 'Kepuharjo',
  },
  {
    id: '3508061001',
    districtId: '3508061',
    name: 'Sumbersuko',
  },
  {
    id: '3508061002',
    districtId: '3508061',
    name: 'Kebonsari',
  },
  {
    id: '3508061003',
    districtId: '3508061',
    name: 'Grati',
  },
  {
    id: '3508061004',
    districtId: '3508061',
    name: 'Labruk Kidul',
  },
  {
    id: '3508061005',
    districtId: '3508061',
    name: 'Mojosari',
  },
  {
    id: '3508061007',
    districtId: '3508061',
    name: 'Purwosono',
  },
  {
    id: '3508061008',
    districtId: '3508061',
    name: 'Petahunan',
  },
  {
    id: '3508070001',
    districtId: '3508070',
    name: 'Wonogriyo',
  },
  {
    id: '3508070002',
    districtId: '3508070',
    name: 'Wonosari',
  },
  {
    id: '3508070003',
    districtId: '3508070',
    name: 'Mangunsari',
  },
  {
    id: '3508070005',
    districtId: '3508070',
    name: 'Wonokerto',
  },
  {
    id: '3508070007',
    districtId: '3508070',
    name: 'Karangbendo',
  },
  {
    id: '3508070008',
    districtId: '3508070',
    name: 'Klampokarum',
  },
  {
    id: '3508080001',
    districtId: '3508080',
    name: 'Jatimulyo',
  },
  {
    id: '3508080002',
    districtId: '3508080',
    name: 'Jatirejo',
  },
  {
    id: '3508080003',
    districtId: '3508080',
    name: 'Jatigono',
  },
  {
    id: '3508080004',
    districtId: '3508080',
    name: 'Sukorejo',
  },
  {
    id: '3508080005',
    districtId: '3508080',
    name: 'Sukosari',
  },
  {
    id: '3508080006',
    districtId: '3508080',
    name: 'Kunir Kidul',
  },
  {
    id: '3508080007',
    districtId: '3508080',
    name: 'Kunir Lor',
  },
  {
    id: '3508080008',
    districtId: '3508080',
    name: 'Kedungmoro',
  },
  {
    id: '3508080009',
    districtId: '3508080',
    name: 'Karanglo',
  },
  {
    id: '3508080010',
    districtId: '3508080',
    name: 'Kabuaran',
  },
  {
    id: '3508080011',
    districtId: '3508080',
    name: 'Dorogowok',
  },
  {
    id: '3508090001',
    districtId: '3508090',
    name: 'Darungan',
  },
  {
    id: '3508090002',
    districtId: '3508090',
    name: 'Kraton',
  },
  {
    id: '3508090003',
    districtId: '3508090',
    name: 'Wotgalih',
  },
  {
    id: '3508090004',
    districtId: '3508090',
    name: 'Tunjungrejo',
  },
  {
    id: '3508090005',
    districtId: '3508090',
    name: 'Yosowilangun Kidul',
  },
  {
    id: '3508090006',
    districtId: '3508090',
    name: 'Yosowilangun Lor',
  },
  {
    id: '3508090007',
    districtId: '3508090',
    name: 'Krai',
  },
  {
    id: '3508090008',
    districtId: '3508090',
    name: 'Karangayar',
  },
  {
    id: '3508090009',
    districtId: '3508090',
    name: 'Karangrejo',
  },
  {
    id: '3508090011',
    districtId: '3508090',
    name: 'Kebonsari',
  },
  {
    id: '3508090012',
    districtId: '3508090',
    name: 'Kalipepe',
  },
  {
    id: '3508100001',
    districtId: '3508100',
    name: 'Nogosari',
  },
  {
    id: '3508100002',
    districtId: '3508100',
    name: 'Kedungrejo',
  },
  {
    id: '3508100003',
    districtId: '3508100',
    name: 'Sidorejo',
  },
  {
    id: '3508100004',
    districtId: '3508100',
    name: 'Rowokangkung',
  },
  {
    id: '3508100005',
    districtId: '3508100',
    name: 'Sumbersari',
  },
  {
    id: '3508100006',
    districtId: '3508100',
    name: 'Sumberanyar',
  },
  {
    id: '3508100007',
    districtId: '3508100',
    name: 'Dawuhan Wetan',
  },
  {
    id: '3508110001',
    districtId: '3508110',
    name: 'Banyuputih Kidul',
  },
  {
    id: '3508110002',
    districtId: '3508110',
    name: 'Rojopolo',
  },
  {
    id: '3508110003',
    districtId: '3508110',
    name: 'Sukosari',
  },
  {
    id: '3508110004',
    districtId: '3508110',
    name: 'Kaliboto Kidul',
  },
  {
    id: '3508110005',
    districtId: '3508110',
    name: 'Kaliboto Lor',
  },
  {
    id: '3508110006',
    districtId: '3508110',
    name: 'Jatiroto',
  },
  {
    id: '3508120001',
    districtId: '3508120',
    name: 'Banyuputih Lor',
  },
  {
    id: '3508120002',
    districtId: '3508120',
    name: 'Kalidilem',
  },
  {
    id: '3508120004',
    districtId: '3508120',
    name: 'Gedangmas',
  },
  {
    id: '3508120005',
    districtId: '3508120',
    name: 'Kalipenggung',
  },
  {
    id: '3508120006',
    districtId: '3508120',
    name: 'Ranulogong',
  },
  {
    id: '3508120007',
    districtId: '3508120',
    name: 'Randuagung',
  },
  {
    id: '3508120008',
    districtId: '3508120',
    name: 'Ledoktempuro',
  },
  {
    id: '3508120009',
    districtId: '3508120',
    name: 'Pejarakan',
  },
  {
    id: '3508120011',
    districtId: '3508120',
    name: 'Ranuwurung',
  },
  {
    id: '3508120012',
    districtId: '3508120',
    name: 'Salak',
  },
  {
    id: '3508130001',
    districtId: '3508130',
    name: 'Klanting',
  },
  {
    id: '3508130002',
    districtId: '3508130',
    name: 'Kebonagung',
  },
  {
    id: '3508130003',
    districtId: '3508130',
    name: 'Karangsari',
  },
  {
    id: '3508130004',
    districtId: '3508130',
    name: 'Dawuhan Lor',
  },
  {
    id: '3508130005',
    districtId: '3508130',
    name: 'Kutorenon',
  },
  {
    id: '3508130006',
    districtId: '3508130',
    name: 'Selokbesuki',
  },
  {
    id: '3508130007',
    districtId: '3508130',
    name: 'Sumberejo',
  },
  {
    id: '3508130008',
    districtId: '3508130',
    name: 'Uranggantung',
  },
  {
    id: '3508130009',
    districtId: '3508130',
    name: 'Selokgondang',
  },
  {
    id: '3508130010',
    districtId: '3508130',
    name: 'Bondoyudo',
  },
  {
    id: '3508140001',
    districtId: '3508140',
    name: 'Barat',
  },
  {
    id: '3508140002',
    districtId: '3508140',
    name: 'Babakan',
  },
  {
    id: '3508140003',
    districtId: '3508140',
    name: 'Mojo',
  },
  {
    id: '3508140004',
    districtId: '3508140',
    name: 'Bodang',
  },
  {
    id: '3508140005',
    districtId: '3508140',
    name: 'Kedawung',
  },
  {
    id: '3508140006',
    districtId: '3508140',
    name: 'Padang',
  },
  {
    id: '3508140007',
    districtId: '3508140',
    name: 'Kalisemut',
  },
  {
    id: '3508140008',
    districtId: '3508140',
    name: 'Merakan',
  },
  {
    id: '3508140009',
    districtId: '3508140',
    name: 'Tanggung',
  },
  {
    id: '3508150001',
    districtId: '3508150',
    name: 'Pasrujambe',
  },
  {
    id: '3508150002',
    districtId: '3508150',
    name: 'Jambekumbu',
  },
  {
    id: '3508150003',
    districtId: '3508150',
    name: 'Sukorejo',
  },
  {
    id: '3508150004',
    districtId: '3508150',
    name: 'Jambearum',
  },
  {
    id: '3508150005',
    districtId: '3508150',
    name: 'Kertosari',
  },
  {
    id: '3508150006',
    districtId: '3508150',
    name: 'Pagowan',
  },
  {
    id: '3508150007',
    districtId: '3508150',
    name: 'Karanganom',
  },
  {
    id: '3508160002',
    districtId: '3508160',
    name: 'Purworejo',
  },
  {
    id: '3508160003',
    districtId: '3508160',
    name: 'Sarikemuning',
  },
  {
    id: '3508160004',
    districtId: '3508160',
    name: 'Pandansari',
  },
  {
    id: '3508160005',
    districtId: '3508160',
    name: 'Senduro',
  },
  {
    id: '3508160006',
    districtId: '3508160',
    name: 'Burno',
  },
  {
    id: '3508160007',
    districtId: '3508160',
    name: 'Kandangtepus',
  },
  {
    id: '3508160008',
    districtId: '3508160',
    name: 'Kandangan',
  },
  {
    id: '3508160009',
    districtId: '3508160',
    name: 'Bedayu',
  },
  {
    id: '3508160010',
    districtId: '3508160',
    name: 'Bedayutalang',
  },
  {
    id: '3508160011',
    districtId: '3508160',
    name: 'Wonocepokoayu',
  },
  {
    id: '3508160012',
    districtId: '3508160',
    name: 'Argosari',
  },
  {
    id: '3508160013',
    districtId: '3508160',
    name: 'Ranupane',
  },
  {
    id: '3508170001',
    districtId: '3508170',
    name: 'Wonokerto',
  },
  {
    id: '3508170002',
    districtId: '3508170',
    name: 'Pakel',
  },
  {
    id: '3508170003',
    districtId: '3508170',
    name: 'Kenongo',
  },
  {
    id: '3508170004',
    districtId: '3508170',
    name: 'Gucialit',
  },
  {
    id: '3508170005',
    districtId: '3508170',
    name: 'Dadapan',
  },
  {
    id: '3508170006',
    districtId: '3508170',
    name: 'Kertowono',
  },
  {
    id: '3508170009',
    districtId: '3508170',
    name: 'Sombo',
  },
  {
    id: '3508180001',
    districtId: '3508180',
    name: 'Pandansari',
  },
  {
    id: '3508180002',
    districtId: '3508180',
    name: 'Krasak',
  },
  {
    id: '3508180003',
    districtId: '3508180',
    name: 'Kedungjajang',
  },
  {
    id: '3508180004',
    districtId: '3508180',
    name: 'Wonorejo',
  },
  {
    id: '3508180006',
    districtId: '3508180',
    name: 'Curahpetung',
  },
  {
    id: '3508180007',
    districtId: '3508180',
    name: 'Grobogan',
  },
  {
    id: '3508180009',
    districtId: '3508180',
    name: 'Jatisari',
  },
  {
    id: '3508180010',
    districtId: '3508180',
    name: 'Tempursari',
  },
  {
    id: '3508180011',
    districtId: '3508180',
    name: 'Bandaran',
  },
  {
    id: '3508180012',
    districtId: '3508180',
    name: 'Sawaran Kulon',
  },
  {
    id: '3508190001',
    districtId: '3508190',
    name: 'Kebonan',
  },
  {
    id: '3508190004',
    districtId: '3508190',
    name: 'Sumberwringin',
  },
  {
    id: '3508190005',
    districtId: '3508190',
    name: 'Papringan',
  },
  {
    id: '3508190006',
    districtId: '3508190',
    name: 'Ranupakis',
  },
  {
    id: '3508190007',
    districtId: '3508190',
    name: 'Tegalrandu',
  },
  {
    id: '3508190008',
    districtId: '3508190',
    name: 'Klakah',
  },
  {
    id: '3508190009',
    districtId: '3508190',
    name: 'Mlawang',
  },
  {
    id: '3508190010',
    districtId: '3508190',
    name: 'Sruni',
  },
  {
    id: '3508190011',
    districtId: '3508190',
    name: 'Tegalciut',
  },
  {
    id: '3508190012',
    districtId: '3508190',
    name: 'Sawaran Lor',
  },
  {
    id: '3508200001',
    districtId: '3508200',
    name: 'Jenggrong',
  },
  {
    id: '3508200002',
    districtId: '3508200',
    name: 'Meninjo',
  },
  {
    id: '3508200003',
    districtId: '3508200',
    name: 'Tegalbangsri',
  },
  {
    id: '3508200005',
    districtId: '3508200',
    name: 'Alun Alun',
  },
  {
    id: '3508200006',
    districtId: '3508200',
    name: 'Ranubedali',
  },
  {
    id: '3508200007',
    districtId: '3508200',
    name: 'Ranuyoso',
  },
  {
    id: '3508200008',
    districtId: '3508200',
    name: 'Wonoayu',
  },
  {
    id: '3508200009',
    districtId: '3508200',
    name: 'Penawungan',
  },
  {
    id: '3508200010',
    districtId: '3508200',
    name: 'Wates Kulon',
  },
  {
    id: '3508200011',
    districtId: '3508200',
    name: 'Wates Wetan',
  },
  {
    id: '3509010001',
    districtId: '3509010',
    name: 'Paseban',
  },
  {
    id: '3509010002',
    districtId: '3509010',
    name: 'Cakru',
  },
  {
    id: '3509010003',
    districtId: '3509010',
    name: 'Kraton',
  },
  {
    id: '3509010004',
    districtId: '3509010',
    name: 'Wonorejo',
  },
  {
    id: '3509010005',
    districtId: '3509010',
    name: 'Kencong',
  },
  {
    id: '3509020001',
    districtId: '3509020',
    name: 'Kepanjen',
  },
  {
    id: '3509020002',
    districtId: '3509020',
    name: 'Mayangan',
  },
  {
    id: '3509020003',
    districtId: '3509020',
    name: 'Menampu',
  },
  {
    id: '3509020004',
    districtId: '3509020',
    name: 'Bagorejo',
  },
  {
    id: '3509020005',
    districtId: '3509020',
    name: 'Gumukmas',
  },
  {
    id: '3509020006',
    districtId: '3509020',
    name: 'Purwoasri',
  },
  {
    id: '3509020007',
    districtId: '3509020',
    name: 'Tembokrejo',
  },
  {
    id: '3509020008',
    districtId: '3509020',
    name: 'Karangrejo',
  },
  {
    id: '3509030001',
    districtId: '3509030',
    name: 'Mojomulyo',
  },
  {
    id: '3509030002',
    districtId: '3509030',
    name: 'Mojosari',
  },
  {
    id: '3509030003',
    districtId: '3509030',
    name: 'Puger Kulon',
  },
  {
    id: '3509030004',
    districtId: '3509030',
    name: 'Puger Wetan',
  },
  {
    id: '3509030006',
    districtId: '3509030',
    name: 'Mlokorejo',
  },
  {
    id: '3509030007',
    districtId: '3509030',
    name: 'Kasiyan',
  },
  {
    id: '3509030008',
    districtId: '3509030',
    name: 'Kasiyan Timur',
  },
  {
    id: '3509030009',
    districtId: '3509030',
    name: 'Wonosari',
  },
  {
    id: '3509030010',
    districtId: '3509030',
    name: 'Jambearum',
  },
  {
    id: '3509030011',
    districtId: '3509030',
    name: 'Bagon',
  },
  {
    id: '3509030012',
    districtId: '3509030',
    name: 'Wringin Telu',
  },
  {
    id: '3509040001',
    districtId: '3509040',
    name: 'Lojejer',
  },
  {
    id: '3509040002',
    districtId: '3509040',
    name: 'Ampel',
  },
  {
    id: '3509040003',
    districtId: '3509040',
    name: 'Tanjung Rejo',
  },
  {
    id: '3509040004',
    districtId: '3509040',
    name: 'Kesilir',
  },
  {
    id: '3509040005',
    districtId: '3509040',
    name: 'Dukuh Dempok',
  },
  {
    id: '3509040006',
    districtId: '3509040',
    name: 'Tamansari',
  },
  {
    id: '3509040007',
    districtId: '3509040',
    name: 'Glundengan',
  },
  {
    id: '3509050001',
    districtId: '3509050',
    name: 'Sumberrejo',
  },
  {
    id: '3509050002',
    districtId: '3509050',
    name: 'Andongsari',
  },
  {
    id: '3509050003',
    districtId: '3509050',
    name: 'Sabrang',
  },
  {
    id: '3509050004',
    districtId: '3509050',
    name: 'Ambulu',
  },
  {
    id: '3509050005',
    districtId: '3509050',
    name: 'Pontang',
  },
  {
    id: '3509050006',
    districtId: '3509050',
    name: 'Karang Anyar',
  },
  {
    id: '3509050007',
    districtId: '3509050',
    name: 'Tegalsari',
  },
  {
    id: '3509060001',
    districtId: '3509060',
    name: 'Andongrejo',
  },
  {
    id: '3509060002',
    districtId: '3509060',
    name: 'Curahnongko',
  },
  {
    id: '3509060003',
    districtId: '3509060',
    name: 'Sanenrejo',
  },
  {
    id: '3509060004',
    districtId: '3509060',
    name: 'Wonoasri',
  },
  {
    id: '3509060005',
    districtId: '3509060',
    name: 'Sidodadi',
  },
  {
    id: '3509060006',
    districtId: '3509060',
    name: 'Pondokrejo',
  },
  {
    id: '3509060007',
    districtId: '3509060',
    name: 'Curahtakir',
  },
  {
    id: '3509060008',
    districtId: '3509060',
    name: 'Tempurejo',
  },
  {
    id: '3509070001',
    districtId: '3509070',
    name: 'Mulyorejo',
  },
  {
    id: '3509070002',
    districtId: '3509070',
    name: 'Pace',
  },
  {
    id: '3509070003',
    districtId: '3509070',
    name: 'Harjomulyo',
  },
  {
    id: '3509070004',
    districtId: '3509070',
    name: 'Karangharjo',
  },
  {
    id: '3509070005',
    districtId: '3509070',
    name: 'Silo',
  },
  {
    id: '3509070006',
    districtId: '3509070',
    name: 'Sempolan',
  },
  {
    id: '3509070007',
    districtId: '3509070',
    name: 'Sumberjati',
  },
  {
    id: '3509070008',
    districtId: '3509070',
    name: 'Garahan',
  },
  {
    id: '3509070009',
    districtId: '3509070',
    name: 'Sidomulyo',
  },
  {
    id: '3509080001',
    districtId: '3509080',
    name: 'Seputih',
  },
  {
    id: '3509080002',
    districtId: '3509080',
    name: 'Sidomukti',
  },
  {
    id: '3509080003',
    districtId: '3509080',
    name: 'Sumber Kejayan',
  },
  {
    id: '3509080004',
    districtId: '3509080',
    name: 'Tegalrejo',
  },
  {
    id: '3509080005',
    districtId: '3509080',
    name: 'Tegalwaru',
  },
  {
    id: '3509080006',
    districtId: '3509080',
    name: 'Mayang',
  },
  {
    id: '3509080007',
    districtId: '3509080',
    name: 'Mrawan',
  },
  {
    id: '3509090001',
    districtId: '3509090',
    name: 'Kawangrejo',
  },
  {
    id: '3509090002',
    districtId: '3509090',
    name: 'Tamansari',
  },
  {
    id: '3509090003',
    districtId: '3509090',
    name: 'Suco',
  },
  {
    id: '3509090004',
    districtId: '3509090',
    name: 'Lampeji',
  },
  {
    id: '3509090005',
    districtId: '3509090',
    name: 'Mumbulsari',
  },
  {
    id: '3509090006',
    districtId: '3509090',
    name: 'Lengkong',
  },
  {
    id: '3509090007',
    districtId: '3509090',
    name: 'Karangkedawung',
  },
  {
    id: '3509100001',
    districtId: '3509100',
    name: 'Kemuning Sari Kidul',
  },
  {
    id: '3509100002',
    districtId: '3509100',
    name: 'Kertonegoro',
  },
  {
    id: '3509100003',
    districtId: '3509100',
    name: 'Jatisari',
  },
  {
    id: '3509100004',
    districtId: '3509100',
    name: 'Sruni',
  },
  {
    id: '3509100005',
    districtId: '3509100',
    name: 'Cangkring',
  },
  {
    id: '3509100006',
    districtId: '3509100',
    name: 'Wonojati',
  },
  {
    id: '3509100007',
    districtId: '3509100',
    name: 'Jenggawah',
  },
  {
    id: '3509100008',
    districtId: '3509100',
    name: 'Jatimulyo',
  },
  {
    id: '3509110001',
    districtId: '3509110',
    name: 'Mangaran',
  },
  {
    id: '3509110002',
    districtId: '3509110',
    name: 'Sukamakmur',
  },
  {
    id: '3509110003',
    districtId: '3509110',
    name: 'Klompangan',
  },
  {
    id: '3509110004',
    districtId: '3509110',
    name: 'Pancakarya',
  },
  {
    id: '3509110005',
    districtId: '3509110',
    name: 'Ajung',
  },
  {
    id: '3509110006',
    districtId: '3509110',
    name: 'Wirowongso',
  },
  {
    id: '3509110007',
    districtId: '3509110',
    name: 'Rowo Indah',
  },
  {
    id: '3509120001',
    districtId: '3509120',
    name: 'Curahmalang',
  },
  {
    id: '3509120002',
    districtId: '3509120',
    name: 'Nogosari',
  },
  {
    id: '3509120003',
    districtId: '3509120',
    name: 'Rowotamtu',
  },
  {
    id: '3509120004',
    districtId: '3509120',
    name: 'Pecoro',
  },
  {
    id: '3509120005',
    districtId: '3509120',
    name: 'Rambipuji',
  },
  {
    id: '3509120006',
    districtId: '3509120',
    name: 'Kaliwining',
  },
  {
    id: '3509120007',
    districtId: '3509120',
    name: 'Rambigundam',
  },
  {
    id: '3509130001',
    districtId: '3509130',
    name: 'Karang Duren',
  },
  {
    id: '3509130002',
    districtId: '3509130',
    name: 'Karang Semanding',
  },
  {
    id: '3509130004',
    districtId: '3509130',
    name: 'Balung Kulon',
  },
  {
    id: '3509130005',
    districtId: '3509130',
    name: 'Balung Kidul',
  },
  {
    id: '3509130006',
    districtId: '3509130',
    name: 'Balung Lor',
  },
  {
    id: '3509130007',
    districtId: '3509130',
    name: 'Gumelar',
  },
  {
    id: '3509130008',
    districtId: '3509130',
    name: 'Curahlele',
  },
  {
    id: '3509140001',
    districtId: '3509140',
    name: 'Sukoreno',
  },
  {
    id: '3509140002',
    districtId: '3509140',
    name: 'Gunungsari',
  },
  {
    id: '3509140003',
    districtId: '3509140',
    name: 'Umbulsari',
  },
  {
    id: '3509140004',
    districtId: '3509140',
    name: 'Tanjungsari',
  },
  {
    id: '3509140005',
    districtId: '3509140',
    name: 'Paleran',
  },
  {
    id: '3509140006',
    districtId: '3509140',
    name: 'Umbulrejo',
  },
  {
    id: '3509140007',
    districtId: '3509140',
    name: 'Gadingrejo',
  },
  {
    id: '3509140008',
    districtId: '3509140',
    name: 'Sidorejo',
  },
  {
    id: '3509140009',
    districtId: '3509140',
    name: 'Tegalwangi',
  },
  {
    id: '3509140010',
    districtId: '3509140',
    name: 'Mundurejo',
  },
  {
    id: '3509150001',
    districtId: '3509150',
    name: 'Rejo Agung',
  },
  {
    id: '3509150002',
    districtId: '3509150',
    name: 'Semboro',
  },
  {
    id: '3509150003',
    districtId: '3509150',
    name: 'Sidomekar',
  },
  {
    id: '3509150004',
    districtId: '3509150',
    name: 'Sidomulyo',
  },
  {
    id: '3509150005',
    districtId: '3509150',
    name: 'Pondok Joyo',
  },
  {
    id: '3509150006',
    districtId: '3509150',
    name: 'Pondok Dalem',
  },
  {
    id: '3509160001',
    districtId: '3509160',
    name: 'Keting',
  },
  {
    id: '3509160002',
    districtId: '3509160',
    name: 'Jombang',
  },
  {
    id: '3509160003',
    districtId: '3509160',
    name: 'Padomasan',
  },
  {
    id: '3509160004',
    districtId: '3509160',
    name: 'Ngampelrejo',
  },
  {
    id: '3509160005',
    districtId: '3509160',
    name: 'Wringin Agung',
  },
  {
    id: '3509160006',
    districtId: '3509160',
    name: 'Sarimulyo',
  },
  {
    id: '3509170001',
    districtId: '3509170',
    name: 'Sumber Agung',
  },
  {
    id: '3509170002',
    districtId: '3509170',
    name: 'Rowo Tengah',
  },
  {
    id: '3509170003',
    districtId: '3509170',
    name: 'Yosorati',
  },
  {
    id: '3509170004',
    districtId: '3509170',
    name: 'Pringgowirawan',
  },
  {
    id: '3509170005',
    districtId: '3509170',
    name: 'Karang Bayat',
  },
  {
    id: '3509170006',
    districtId: '3509170',
    name: 'Gelang',
  },
  {
    id: '3509170007',
    districtId: '3509170',
    name: 'Jatiroto',
  },
  {
    id: '3509170008',
    districtId: '3509170',
    name: 'Jamintoro',
  },
  {
    id: '3509170009',
    districtId: '3509170',
    name: 'Kaliglagah',
  },
  {
    id: '3509170010',
    districtId: '3509170',
    name: 'Jambesari',
  },
  {
    id: '3509180001',
    districtId: '3509180',
    name: 'Tanggul Kulon',
  },
  {
    id: '3509180002',
    districtId: '3509180',
    name: 'Tanggul Wetan',
  },
  {
    id: '3509180003',
    districtId: '3509180',
    name: 'Klatakan',
  },
  {
    id: '3509180004',
    districtId: '3509180',
    name: 'Selodakon',
  },
  {
    id: '3509180005',
    districtId: '3509180',
    name: 'Darungan',
  },
  {
    id: '3509180006',
    districtId: '3509180',
    name: 'Manggisan',
  },
  {
    id: '3509180007',
    districtId: '3509180',
    name: 'Patemon',
  },
  {
    id: '3509180008',
    districtId: '3509180',
    name: 'Kramat Sukoharjo',
  },
  {
    id: '3509190001',
    districtId: '3509190',
    name: 'Karangsono',
  },
  {
    id: '3509190002',
    districtId: '3509190',
    name: 'Sukorejo',
  },
  {
    id: '3509190004',
    districtId: '3509190',
    name: 'Tisnogambar',
  },
  {
    id: '3509190005',
    districtId: '3509190',
    name: 'Langkap',
  },
  {
    id: '3509190006',
    districtId: '3509190',
    name: 'Bangsalsari',
  },
  {
    id: '3509190007',
    districtId: '3509190',
    name: 'Gambirono',
  },
  {
    id: '3509190008',
    districtId: '3509190',
    name: 'Curah Kalong',
  },
  {
    id: '3509190009',
    districtId: '3509190',
    name: 'Tugusari',
  },
  {
    id: '3509190010',
    districtId: '3509190',
    name: 'Banjarsari',
  },
  {
    id: '3509190011',
    districtId: '3509190',
    name: 'Badean',
  },
  {
    id: '3509200001',
    districtId: '3509200',
    name: 'Kemuningsari Lor',
  },
  {
    id: '3509200002',
    districtId: '3509200',
    name: 'Glagahwero',
  },
  {
    id: '3509200004',
    districtId: '3509200',
    name: 'Panti',
  },
  {
    id: '3509200005',
    districtId: '3509200',
    name: 'Pakis',
  },
  {
    id: '3509200006',
    districtId: '3509200',
    name: 'Suci',
  },
  {
    id: '3509200007',
    districtId: '3509200',
    name: 'Kemiri',
  },
  {
    id: '3509210003',
    districtId: '3509210',
    name: 'Sukorambi',
  },
  {
    id: '3509210004',
    districtId: '3509210',
    name: 'Karangpring',
  },
  {
    id: '3509220001',
    districtId: '3509220',
    name: 'Kemuningllor',
  },
  {
    id: '3509220002',
    districtId: '3509220',
    name: 'Darsono',
  },
  {
    id: '3509220003',
    districtId: '3509220',
    name: 'Arjasa',
  },
  {
    id: '3509220004',
    districtId: '3509220',
    name: 'Biting',
  },
  {
    id: '3509220005',
    districtId: '3509220',
    name: 'Candijati',
  },
  {
    id: '3509220006',
    districtId: '3509220',
    name: 'Kamal',
  },
  {
    id: '3509230001',
    districtId: '3509230',
    name: 'Kertosari',
  },
  {
    id: '3509230002',
    districtId: '3509230',
    name: 'Pakusari',
  },
  {
    id: '3509230003',
    districtId: '3509230',
    name: 'Jatian',
  },
  {
    id: '3509230004',
    districtId: '3509230',
    name: 'Subo',
  },
  {
    id: '3509230005',
    districtId: '3509230',
    name: 'Sumber Pinang',
  },
  {
    id: '3509230006',
    districtId: '3509230',
    name: 'Bedadung',
  },
  {
    id: '3509230007',
    districtId: '3509230',
    name: 'Patemon',
  },
  {
    id: '3509240001',
    districtId: '3509240',
    name: 'Gambiran',
  },
  {
    id: '3509240002',
    districtId: '3509240',
    name: 'Plalangan',
  },
  {
    id: '3509240003',
    districtId: '3509240',
    name: 'Ajung',
  },
  {
    id: '3509240004',
    districtId: '3509240',
    name: 'Glagahwero',
  },
  {
    id: '3509240006',
    districtId: '3509240',
    name: 'Gumuksari',
  },
  {
    id: '3509240007',
    districtId: '3509240',
    name: 'Patempuran',
  },
  {
    id: '3509240008',
    districtId: '3509240',
    name: 'Kalisat',
  },
  {
    id: '3509240009',
    districtId: '3509240',
    name: 'Sumber Ketempah',
  },
  {
    id: '3509240010',
    districtId: '3509240',
    name: 'Sukoreno',
  },
  {
    id: '3509240011',
    districtId: '3509240',
    name: 'Sumber Kalong',
  },
  {
    id: '3509240012',
    districtId: '3509240',
    name: 'Sebanen',
  },
  {
    id: '3509250002',
    districtId: '3509250',
    name: 'Sumber Salak',
  },
  {
    id: '3509250005',
    districtId: '3509250',
    name: 'Lembengan',
  },
  {
    id: '3509250006',
    districtId: '3509250',
    name: 'Sumber Anget',
  },
  {
    id: '3509250007',
    districtId: '3509250',
    name: 'Ledokombo',
  },
  {
    id: '3509250008',
    districtId: '3509250',
    name: 'Slateng',
  },
  {
    id: '3509250009',
    districtId: '3509250',
    name: 'Sukogidri',
  },
  {
    id: '3509250010',
    districtId: '3509250',
    name: 'Karang Paiton',
  },
  {
    id: '3509260001',
    districtId: '3509260',
    name: 'Randu Agung',
  },
  {
    id: '3509260002',
    districtId: '3509260',
    name: 'Cumedak',
  },
  {
    id: '3509260003',
    districtId: '3509260',
    name: 'Gunung Malang',
  },
  {
    id: '3509260004',
    districtId: '3509260',
    name: 'Rowosari',
  },
  {
    id: '3509260005',
    districtId: '3509260',
    name: 'Sumberjambe',
  },
  {
    id: '3509260006',
    districtId: '3509260',
    name: 'Sumber Pakem',
  },
  {
    id: '3509260007',
    districtId: '3509260',
    name: 'Plereyan',
  },
  {
    id: '3509260008',
    districtId: '3509260',
    name: 'Pringgondani',
  },
  {
    id: '3509260009',
    districtId: '3509260',
    name: 'Jambe Arum',
  },
  {
    id: '3509270001',
    districtId: '3509270',
    name: 'Sumberwaru',
  },
  {
    id: '3509270002',
    districtId: '3509270',
    name: 'Sukorejo',
  },
  {
    id: '3509270003',
    districtId: '3509270',
    name: 'Sukosari',
  },
  {
    id: '3509270004',
    districtId: '3509270',
    name: 'Balet Baru',
  },
  {
    id: '3509270005',
    districtId: '3509270',
    name: 'Sumber Wringin',
  },
  {
    id: '3509270006',
    districtId: '3509270',
    name: 'Mojogemi',
  },
  {
    id: '3509270007',
    districtId: '3509270',
    name: 'Sukokerto',
  },
  {
    id: '3509270008',
    districtId: '3509270',
    name: 'Sukowono',
  },
  {
    id: '3509270009',
    districtId: '3509270',
    name: 'Dawuhan Mangli',
  },
  {
    id: '3509270010',
    districtId: '3509270',
    name: 'Arjasa',
  },
  {
    id: '3509270011',
    districtId: '3509270',
    name: 'Sumberdanti',
  },
  {
    id: '3509270012',
    districtId: '3509270',
    name: 'Pocangan',
  },
  {
    id: '3509280001',
    districtId: '3509280',
    name: 'Panduman',
  },
  {
    id: '3509280003',
    districtId: '3509280',
    name: 'Sukowiryo',
  },
  {
    id: '3509280004',
    districtId: '3509280',
    name: 'Suger Kidul',
  },
  {
    id: '3509280005',
    districtId: '3509280',
    name: 'Suko Jember',
  },
  {
    id: '3509280006',
    districtId: '3509280',
    name: 'Suco Pangepok',
  },
  {
    id: '3509710001',
    districtId: '3509710',
    name: 'Mangli',
  },
  {
    id: '3509710002',
    districtId: '3509710',
    name: 'Sempusari',
  },
  {
    id: '3509710003',
    districtId: '3509710',
    name: 'Kaliwates',
  },
  {
    id: '3509710004',
    districtId: '3509710',
    name: 'Tegal Besar',
  },
  {
    id: '3509710005',
    districtId: '3509710',
    name: 'Jember Kidul',
  },
  {
    id: '3509710006',
    districtId: '3509710',
    name: 'Kepatihan',
  },
  {
    id: '3509710007',
    districtId: '3509710',
    name: 'Kebon Agung',
  },
  {
    id: '3509720001',
    districtId: '3509720',
    name: 'Keranjingan',
  },
  {
    id: '3509720002',
    districtId: '3509720',
    name: 'Wirolegi',
  },
  {
    id: '3509720003',
    districtId: '3509720',
    name: 'Karangrejo',
  },
  {
    id: '3509720004',
    districtId: '3509720',
    name: 'Kebonsari',
  },
  {
    id: '3509720005',
    districtId: '3509720',
    name: 'Sumbersari',
  },
  {
    id: '3509720006',
    districtId: '3509720',
    name: 'Tegal Gede',
  },
  {
    id: '3509720007',
    districtId: '3509720',
    name: 'Antirogo',
  },
  {
    id: '3509730001',
    districtId: '3509730',
    name: 'Gebang',
  },
  {
    id: '3509730002',
    districtId: '3509730',
    name: 'Jember Lor',
  },
  {
    id: '3509730003',
    districtId: '3509730',
    name: 'Patrang',
  },
  {
    id: '3509730004',
    districtId: '3509730',
    name: 'Baratan',
  },
  {
    id: '3509730005',
    districtId: '3509730',
    name: 'Bintoro',
  },
  {
    id: '3509730006',
    districtId: '3509730',
    name: 'Slawu',
  },
  {
    id: '3509730007',
    districtId: '3509730',
    name: 'Jumerto',
  },
  {
    id: '3509730008',
    districtId: '3509730',
    name: 'Banjar Sengon',
  },
  {
    id: '3510010001',
    districtId: '3510010',
    name: 'Sarongan',
  },
  {
    id: '3510010002',
    districtId: '3510010',
    name: 'Kandangan',
  },
  {
    id: '3510010003',
    districtId: '3510010',
    name: 'Sumberagung',
  },
  {
    id: '3510010004',
    districtId: '3510010',
    name: 'Pesanggaran',
  },
  {
    id: '3510010009',
    districtId: '3510010',
    name: 'Sumbermulyo',
  },
  {
    id: '3510011001',
    districtId: '3510011',
    name: 'Buluagung',
  },
  {
    id: '3510011002',
    districtId: '3510011',
    name: 'Siliragung',
  },
  {
    id: '3510011003',
    districtId: '3510011',
    name: 'Seneporejo',
  },
  {
    id: '3510011004',
    districtId: '3510011',
    name: 'Kesilir',
  },
  {
    id: '3510011005',
    districtId: '3510011',
    name: 'Barurejo',
  },
  {
    id: '3510020001',
    districtId: '3510020',
    name: 'Sukorejo',
  },
  {
    id: '3510020002',
    districtId: '3510020',
    name: 'Ringintelu',
  },
  {
    id: '3510020003',
    districtId: '3510020',
    name: 'Sambirejo',
  },
  {
    id: '3510020004',
    districtId: '3510020',
    name: 'Sambimulyo',
  },
  {
    id: '3510020006',
    districtId: '3510020',
    name: 'Temurejo',
  },
  {
    id: '3510020007',
    districtId: '3510020',
    name: 'Bangorejo',
  },
  {
    id: '3510020008',
    districtId: '3510020',
    name: 'Kebondalem',
  },
  {
    id: '3510030001',
    districtId: '3510030',
    name: 'Grajagan',
  },
  {
    id: '3510030002',
    districtId: '3510030',
    name: 'Sumberasri',
  },
  {
    id: '3510030003',
    districtId: '3510030',
    name: 'Glagahagung',
  },
  {
    id: '3510030004',
    districtId: '3510030',
    name: 'Karetan',
  },
  {
    id: '3510030005',
    districtId: '3510030',
    name: 'Bulurejo',
  },
  {
    id: '3510030006',
    districtId: '3510030',
    name: 'Purwoharjo',
  },
  {
    id: '3510030007',
    districtId: '3510030',
    name: 'Sidorejo',
  },
  {
    id: '3510030008',
    districtId: '3510030',
    name: 'Kradenan',
  },
  {
    id: '3510040001',
    districtId: '3510040',
    name: 'Purwoasri',
  },
  {
    id: '3510040002',
    districtId: '3510040',
    name: 'Kendalrejo',
  },
  {
    id: '3510040003',
    districtId: '3510040',
    name: 'Kedungasri',
  },
  {
    id: '3510040005',
    districtId: '3510040',
    name: 'Tegaldlimo',
  },
  {
    id: '3510040006',
    districtId: '3510040',
    name: 'Wringinpitu',
  },
  {
    id: '3510040007',
    districtId: '3510040',
    name: 'Kedunggebang',
  },
  {
    id: '3510040008',
    districtId: '3510040',
    name: 'Purwoagung',
  },
  {
    id: '3510040009',
    districtId: '3510040',
    name: 'Kalipait',
  },
  {
    id: '3510050001',
    districtId: '3510050',
    name: 'Sumberberas',
  },
  {
    id: '3510050002',
    districtId: '3510050',
    name: 'Wringin Putih',
  },
  {
    id: '3510050003',
    districtId: '3510050',
    name: 'Kedungringin',
  },
  {
    id: '3510050004',
    districtId: '3510050',
    name: 'Tambakrejo',
  },
  {
    id: '3510050005',
    districtId: '3510050',
    name: 'Tapanrejo',
  },
  {
    id: '3510050006',
    districtId: '3510050',
    name: 'Blambangan',
  },
  {
    id: '3510050007',
    districtId: '3510050',
    name: 'Kedungrejo',
  },
  {
    id: '3510050008',
    districtId: '3510050',
    name: 'Tembokrejo',
  },
  {
    id: '3510060002',
    districtId: '3510060',
    name: 'Tampo',
  },
  {
    id: '3510060003',
    districtId: '3510060',
    name: 'Plampangrejo',
  },
  {
    id: '3510060004',
    districtId: '3510060',
    name: 'Kaliploso',
  },
  {
    id: '3510060006',
    districtId: '3510060',
    name: 'Cluring',
  },
  {
    id: '3510060007',
    districtId: '3510060',
    name: 'Tamanagung',
  },
  {
    id: '3510060008',
    districtId: '3510060',
    name: 'Sraten',
  },
  {
    id: '3510060009',
    districtId: '3510060',
    name: 'Sarimulyo',
  },
  {
    id: '3510070004',
    districtId: '3510070',
    name: 'Purwodadi',
  },
  {
    id: '3510070005',
    districtId: '3510070',
    name: 'Jajag',
  },
  {
    id: '3510070006',
    districtId: '3510070',
    name: 'Wringin Agung',
  },
  {
    id: '3510070007',
    districtId: '3510070',
    name: 'Wringinrejo',
  },
  {
    id: '3510070008',
    districtId: '3510070',
    name: 'Yosomulyo',
  },
  {
    id: '3510070009',
    districtId: '3510070',
    name: 'Gambiran',
  },
  {
    id: '3510071001',
    districtId: '3510071',
    name: 'Karangdoro',
  },
  {
    id: '3510071002',
    districtId: '3510071',
    name: 'Karangmulyo',
  },
  {
    id: '3510071003',
    districtId: '3510071',
    name: 'Tegalsari',
  },
  {
    id: '3510071004',
    districtId: '3510071',
    name: 'Dasri',
  },
  {
    id: '3510071005',
    districtId: '3510071',
    name: 'Tamansari',
  },
  {
    id: '3510071006',
    districtId: '3510071',
    name: 'Tegalrejo',
  },
  {
    id: '3510080001',
    districtId: '3510080',
    name: 'Karangharjo',
  },
  {
    id: '3510080002',
    districtId: '3510080',
    name: 'Tulungrejo',
  },
  {
    id: '3510080003',
    districtId: '3510080',
    name: 'Sumbergondo',
  },
  {
    id: '3510080004',
    districtId: '3510080',
    name: 'Bumiharjo',
  },
  {
    id: '3510080005',
    districtId: '3510080',
    name: 'Sepanjang',
  },
  {
    id: '3510080006',
    districtId: '3510080',
    name: 'Tegalharjo',
  },
  {
    id: '3510080007',
    districtId: '3510080',
    name: 'Margomulyo',
  },
  {
    id: '3510090001',
    districtId: '3510090',
    name: 'Kebonrejo',
  },
  {
    id: '3510090002',
    districtId: '3510090',
    name: 'Kalibaru Manis',
  },
  {
    id: '3510090003',
    districtId: '3510090',
    name: 'Banyuanyar',
  },
  {
    id: '3510090004',
    districtId: '3510090',
    name: 'Kalibaru Kulon',
  },
  {
    id: '3510090005',
    districtId: '3510090',
    name: 'Kalibaru Wetan',
  },
  {
    id: '3510090006',
    districtId: '3510090',
    name: 'Kajarharjo',
  },
  {
    id: '3510100001',
    districtId: '3510100',
    name: 'Kaligondo',
  },
  {
    id: '3510100002',
    districtId: '3510100',
    name: 'Setail',
  },
  {
    id: '3510100003',
    districtId: '3510100',
    name: 'Genteng Kulon',
  },
  {
    id: '3510100004',
    districtId: '3510100',
    name: 'Genteng Wetan',
  },
  {
    id: '3510100005',
    districtId: '3510100',
    name: 'Kembiritan',
  },
  {
    id: '3510110001',
    districtId: '3510110',
    name: 'Sumbersari',
  },
  {
    id: '3510110002',
    districtId: '3510110',
    name: 'Kepundungan',
  },
  {
    id: '3510110003',
    districtId: '3510110',
    name: 'Kebaman',
  },
  {
    id: '3510110004',
    districtId: '3510110',
    name: 'Sukonatar',
  },
  {
    id: '3510110005',
    districtId: '3510110',
    name: 'Bagorejo',
  },
  {
    id: '3510110006',
    districtId: '3510110',
    name: 'Rejoagung',
  },
  {
    id: '3510110007',
    districtId: '3510110',
    name: 'Wonosobo',
  },
  {
    id: '3510110008',
    districtId: '3510110',
    name: 'Sukomaju',
  },
  {
    id: '3510110009',
    districtId: '3510110',
    name: 'Parijatah Wetan',
  },
  {
    id: '3510110010',
    districtId: '3510110',
    name: 'Parijatah Kulon',
  },
  {
    id: '3510120001',
    districtId: '3510120',
    name: 'Aliyan',
  },
  {
    id: '3510120002',
    districtId: '3510120',
    name: 'Mangir',
  },
  {
    id: '3510120007',
    districtId: '3510120',
    name: 'Gladag',
  },
  {
    id: '3510120009',
    districtId: '3510120',
    name: 'Kedaleman',
  },
  {
    id: '3510120010',
    districtId: '3510120',
    name: 'Lemahbang Dewo',
  },
  {
    id: '3510120011',
    districtId: '3510120',
    name: 'Rogojampi',
  },
  {
    id: '3510120016',
    districtId: '3510120',
    name: 'Karang Bendo',
  },
  {
    id: '3510120017',
    districtId: '3510120',
    name: 'Gitik',
  },
  {
    id: '3510120018',
    districtId: '3510120',
    name: 'Pengantigan',
  },
  {
    id: '3510121001',
    districtId: '3510121',
    name: 'Kaligung',
  },
  {
    id: '3510121002',
    districtId: '3510121',
    name: 'Karangrejo',
  },
  {
    id: '3510121003',
    districtId: '3510121',
    name: 'Bomo',
  },
  {
    id: '3510121004',
    districtId: '3510121',
    name: 'Gintangan',
  },
  {
    id: '3510121005',
    districtId: '3510121',
    name: 'Kaotan',
  },
  {
    id: '3510121006',
    districtId: '3510121',
    name: 'Watu Kebo',
  },
  {
    id: '3510121007',
    districtId: '3510121',
    name: 'Patoman',
  },
  {
    id: '3510121008',
    districtId: '3510121',
    name: 'Blimbing Sari',
  },
  {
    id: '3510121009',
    districtId: '3510121',
    name: 'Badean',
  },
  {
    id: '3510121010',
    districtId: '3510121',
    name: 'Sukojati',
  },
  {
    id: '3510130001',
    districtId: '3510130',
    name: 'Bareng',
  },
  {
    id: '3510130003',
    districtId: '3510130',
    name: 'Gombolirang',
  },
  {
    id: '3510130004',
    districtId: '3510130',
    name: 'Benelan Lor',
  },
  {
    id: '3510130005',
    districtId: '3510130',
    name: 'Labanasem',
  },
  {
    id: '3510130006',
    districtId: '3510130',
    name: 'Pakistaji',
  },
  {
    id: '3510130009',
    districtId: '3510130',
    name: 'Pondoknongko',
  },
  {
    id: '3510130010',
    districtId: '3510130',
    name: 'Dadapan',
  },
  {
    id: '3510130011',
    districtId: '3510130',
    name: 'Kedayunan',
  },
  {
    id: '3510130012',
    districtId: '3510130',
    name: 'Kabat',
  },
  {
    id: '3510130013',
    districtId: '3510130',
    name: 'Macan Putih',
  },
  {
    id: '3510130014',
    districtId: '3510130',
    name: 'Tambong',
  },
  {
    id: '3510130015',
    districtId: '3510130',
    name: 'Pendarungan',
  },
  {
    id: '3510130016',
    districtId: '3510130',
    name: 'Kalirejo',
  },
  {
    id: '3510140001',
    districtId: '3510140',
    name: 'Gambor',
  },
  {
    id: '3510140002',
    districtId: '3510140',
    name: 'Singojuruh',
  },
  {
    id: '3510140003',
    districtId: '3510140',
    name: 'Alas Malang',
  },
  {
    id: '3510140004',
    districtId: '3510140',
    name: 'Benelan Kidul',
  },
  {
    id: '3510140005',
    districtId: '3510140',
    name: 'Lemahbang Kulon',
  },
  {
    id: '3510140006',
    districtId: '3510140',
    name: 'Singolatren',
  },
  {
    id: '3510140007',
    districtId: '3510140',
    name: 'Padang',
  },
  {
    id: '3510140008',
    districtId: '3510140',
    name: 'Cantuk',
  },
  {
    id: '3510140009',
    districtId: '3510140',
    name: 'Gumirih',
  },
  {
    id: '3510140010',
    districtId: '3510140',
    name: 'Kemiri',
  },
  {
    id: '3510140011',
    districtId: '3510140',
    name: 'Sumber Baru',
  },
  {
    id: '3510150002',
    districtId: '3510150',
    name: 'Tegalarum',
  },
  {
    id: '3510150003',
    districtId: '3510150',
    name: 'Jambewangi',
  },
  {
    id: '3510150004',
    districtId: '3510150',
    name: 'Temuasri',
  },
  {
    id: '3510150005',
    districtId: '3510150',
    name: 'Karangsari',
  },
  {
    id: '3510150007',
    districtId: '3510150',
    name: 'Gendoh',
  },
  {
    id: '3510160001',
    districtId: '3510160',
    name: 'Bedewang',
  },
  {
    id: '3510160002',
    districtId: '3510160',
    name: 'Balak',
  },
  {
    id: '3510160003',
    districtId: '3510160',
    name: 'Bangunsari',
  },
  {
    id: '3510160004',
    districtId: '3510160',
    name: 'Songgon',
  },
  {
    id: '3510160005',
    districtId: '3510160',
    name: 'Parangharjo',
  },
  {
    id: '3510160006',
    districtId: '3510160',
    name: 'Sragi',
  },
  {
    id: '3510160007',
    districtId: '3510160',
    name: 'Sumber Arum',
  },
  {
    id: '3510160009',
    districtId: '3510160',
    name: 'Bayu',
  },
  {
    id: '3510170006',
    districtId: '3510170',
    name: 'Paspan',
  },
  {
    id: '3510170007',
    districtId: '3510170',
    name: 'Glagah',
  },
  {
    id: '3510170008',
    districtId: '3510170',
    name: 'Olehsari',
  },
  {
    id: '3510170009',
    districtId: '3510170',
    name: 'Rejosari',
  },
  {
    id: '3510170010',
    districtId: '3510170',
    name: 'Bakungan',
  },
  {
    id: '3510170011',
    districtId: '3510170',
    name: 'Banjarsari',
  },
  {
    id: '3510170012',
    districtId: '3510170',
    name: 'Kemiren',
  },
  {
    id: '3510170013',
    districtId: '3510170',
    name: 'Tamansuruh',
  },
  {
    id: '3510170014',
    districtId: '3510170',
    name: 'Kenjo',
  },
  {
    id: '3510170018',
    districtId: '3510170',
    name: 'Kampunganyar',
  },
  {
    id: '3510171001',
    districtId: '3510171',
    name: 'Pakel',
  },
  {
    id: '3510171002',
    districtId: '3510171',
    name: 'Kluncing',
  },
  {
    id: '3510171003',
    districtId: '3510171',
    name: 'Segobang',
  },
  {
    id: '3510171006',
    districtId: '3510171',
    name: 'Banjar',
  },
  {
    id: '3510171007',
    districtId: '3510171',
    name: 'Licin',
  },
  {
    id: '3510171008',
    districtId: '3510171',
    name: 'Tamansari',
  },
  {
    id: '3510180001',
    districtId: '3510180',
    name: 'Pakis',
  },
  {
    id: '3510180002',
    districtId: '3510180',
    name: 'Sobo',
  },
  {
    id: '3510180003',
    districtId: '3510180',
    name: 'Kebalenan',
  },
  {
    id: '3510180004',
    districtId: '3510180',
    name: 'Penganjuran',
  },
  {
    id: '3510180005',
    districtId: '3510180',
    name: 'Tukangkayu',
  },
  {
    id: '3510180006',
    districtId: '3510180',
    name: 'Kertosari',
  },
  {
    id: '3510180007',
    districtId: '3510180',
    name: 'Karangrejo',
  },
  {
    id: '3510180008',
    districtId: '3510180',
    name: 'Kepatihan',
  },
  {
    id: '3510180009',
    districtId: '3510180',
    name: 'Panderejo',
  },
  {
    id: '3510180010',
    districtId: '3510180',
    name: 'Singonegaran',
  },
  {
    id: '3510180011',
    districtId: '3510180',
    name: 'Temenggungan',
  },
  {
    id: '3510180012',
    districtId: '3510180',
    name: 'Kampung Melayu',
  },
  {
    id: '3510180013',
    districtId: '3510180',
    name: 'Kampungmandar',
  },
  {
    id: '3510180014',
    districtId: '3510180',
    name: 'Lateng',
  },
  {
    id: '3510180015',
    districtId: '3510180',
    name: 'Singotrunan',
  },
  {
    id: '3510180016',
    districtId: '3510180',
    name: 'Pengantigan',
  },
  {
    id: '3510180017',
    districtId: '3510180',
    name: 'Sumberrejo',
  },
  {
    id: '3510180018',
    districtId: '3510180',
    name: 'Taman Baru',
  },
  {
    id: '3510190001',
    districtId: '3510190',
    name: 'Jambesari',
  },
  {
    id: '3510190002',
    districtId: '3510190',
    name: 'Boyolangu',
  },
  {
    id: '3510190003',
    districtId: '3510190',
    name: 'Mojopanggung',
  },
  {
    id: '3510190004',
    districtId: '3510190',
    name: 'Penataban',
  },
  {
    id: '3510190005',
    districtId: '3510190',
    name: 'Giri',
  },
  {
    id: '3510190006',
    districtId: '3510190',
    name: 'Grogol',
  },
  {
    id: '3510200001',
    districtId: '3510200',
    name: 'Bulusari',
  },
  {
    id: '3510200004',
    districtId: '3510200',
    name: 'Kelir',
  },
  {
    id: '3510200005',
    districtId: '3510200',
    name: 'Kalipuro',
  },
  {
    id: '3510200006',
    districtId: '3510200',
    name: 'Klatak',
  },
  {
    id: '3510200007',
    districtId: '3510200',
    name: 'Ketapang',
  },
  {
    id: '3510200008',
    districtId: '3510200',
    name: 'Gombeng Sari',
  },
  {
    id: '3510200009',
    districtId: '3510200',
    name: 'Bulusan',
  },
  {
    id: '3510210001',
    districtId: '3510210',
    name: 'Bangsring',
  },
  {
    id: '3510210002',
    districtId: '3510210',
    name: 'Bengkak',
  },
  {
    id: '3510210003',
    districtId: '3510210',
    name: 'Alasbulu',
  },
  {
    id: '3510210004',
    districtId: '3510210',
    name: 'Wongsorejo',
  },
  {
    id: '3510210005',
    districtId: '3510210',
    name: 'Alasrejo',
  },
  {
    id: '3510210006',
    districtId: '3510210',
    name: 'Sumberkencono',
  },
  {
    id: '3510210007',
    districtId: '3510210',
    name: 'Sidowangi',
  },
  {
    id: '3510210008',
    districtId: '3510210',
    name: 'Sidodadi',
  },
  {
    id: '3510210009',
    districtId: '3510210',
    name: 'Bajulmati',
  },
  {
    id: '3510210010',
    districtId: '3510210',
    name: 'Watukebo',
  },
  {
    id: '3510210011',
    districtId: '3510210',
    name: 'Sumberanyar',
  },
  {
    id: '3510210012',
    districtId: '3510210',
    name: 'Bimorejo',
  },
  {
    id: '3511010001',
    districtId: '3511010',
    name: 'Sucolor',
  },
  {
    id: '3511010002',
    districtId: '3511010',
    name: 'Pujerbaru',
  },
  {
    id: '3511010003',
    districtId: '3511010',
    name: 'Tanahwulan',
  },
  {
    id: '3511010004',
    districtId: '3511010',
    name: 'Maesan',
  },
  {
    id: '3511010005',
    districtId: '3511010',
    name: 'Gambangan',
  },
  {
    id: '3511010006',
    districtId: '3511010',
    name: 'Suger Lor',
  },
  {
    id: '3511010007',
    districtId: '3511010',
    name: 'Sumberpakem',
  },
  {
    id: '3511010008',
    districtId: '3511010',
    name: 'Sumbersari',
  },
  {
    id: '3511010009',
    districtId: '3511010',
    name: 'Sumberanyar',
  },
  {
    id: '3511010010',
    districtId: '3511010',
    name: 'Penanggungan',
  },
  {
    id: '3511010011',
    districtId: '3511010',
    name: 'Pakuniran',
  },
  {
    id: '3511010012',
    districtId: '3511010',
    name: 'Gunungsari',
  },
  {
    id: '3511020001',
    districtId: '3511020',
    name: 'Sumberpandan',
  },
  {
    id: '3511020002',
    districtId: '3511020',
    name: 'Pekauman',
  },
  {
    id: '3511020003',
    districtId: '3511020',
    name: 'Wanisodo',
  },
  {
    id: '3511020004',
    districtId: '3511020',
    name: 'Dawuhan',
  },
  {
    id: '3511020005',
    districtId: '3511020',
    name: 'Kabuaran',
  },
  {
    id: '3511020006',
    districtId: '3511020',
    name: 'Wonosari',
  },
  {
    id: '3511020007',
    districtId: '3511020',
    name: 'Dadapan',
  },
  {
    id: '3511020008',
    districtId: '3511020',
    name: 'Taman',
  },
  {
    id: '3511020009',
    districtId: '3511020',
    name: 'Tegalmijin',
  },
  {
    id: '3511020011',
    districtId: '3511020',
    name: 'Grujugan Kidul',
  },
  {
    id: '3511020012',
    districtId: '3511020',
    name: 'Kejawan',
  },
  {
    id: '3511030001',
    districtId: '3511030',
    name: 'Sukosari',
  },
  {
    id: '3511030002',
    districtId: '3511030',
    name: 'Karangmelok',
  },
  {
    id: '3511030004',
    districtId: '3511030',
    name: 'Kemirian',
  },
  {
    id: '3511030005',
    districtId: '3511030',
    name: 'Tamanan',
  },
  {
    id: '3511030006',
    districtId: '3511030',
    name: 'Wonosuko',
  },
  {
    id: '3511030007',
    districtId: '3511030',
    name: 'Kalianyar',
  },
  {
    id: '3511030008',
    districtId: '3511030',
    name: 'Sumberkemuning',
  },
  {
    id: '3511030009',
    districtId: '3511030',
    name: 'Sumberanom',
  },
  {
    id: '3511031002',
    districtId: '3511031',
    name: 'Pucang Anom',
  },
  {
    id: '3511031003',
    districtId: '3511031',
    name: 'Jambeanom',
  },
  {
    id: '3511031004',
    districtId: '3511031',
    name: 'Jambesari',
  },
  {
    id: '3511031005',
    districtId: '3511031',
    name: 'Pejagan',
  },
  {
    id: '3511031006',
    districtId: '3511031',
    name: 'Grujugan Lor',
  },
  {
    id: '3511031007',
    districtId: '3511031',
    name: 'Tegalpasir',
  },
  {
    id: '3511031008',
    districtId: '3511031',
    name: 'Pengarang',
  },
  {
    id: '3511031010',
    districtId: '3511031',
    name: 'Sumber Anyar',
  },
  {
    id: '3511040001',
    districtId: '3511040',
    name: 'Sukokerto',
  },
  {
    id: '3511040002',
    districtId: '3511040',
    name: 'Sukowono',
  },
  {
    id: '3511040003',
    districtId: '3511040',
    name: 'Maskuning Wetan',
  },
  {
    id: '3511040004',
    districtId: '3511040',
    name: 'Maskuning Kulon',
  },
  {
    id: '3511040005',
    districtId: '3511040',
    name: 'Alassumur',
  },
  {
    id: '3511040007',
    districtId: '3511040',
    name: 'Mengok',
  },
  {
    id: '3511040008',
    districtId: '3511040',
    name: 'Kejayan',
  },
  {
    id: '3511040009',
    districtId: '3511040',
    name: 'Mangli',
  },
  {
    id: '3511040010',
    districtId: '3511040',
    name: 'Randucangkring',
  },
  {
    id: '3511040011',
    districtId: '3511040',
    name: 'Padasan',
  },
  {
    id: '3511040012',
    districtId: '3511040',
    name: 'Sukodono',
  },
  {
    id: '3511050001',
    districtId: '3511050',
    name: 'Pakisan',
  },
  {
    id: '3511050002',
    districtId: '3511050',
    name: 'Tlogosari',
  },
  {
    id: '3511050003',
    districtId: '3511050',
    name: 'Kembang',
  },
  {
    id: '3511050004',
    districtId: '3511050',
    name: 'Gunosari',
  },
  {
    id: '3511050005',
    districtId: '3511050',
    name: 'Trotosari',
  },
  {
    id: '3511050007',
    districtId: '3511050',
    name: 'Jebung Kidul',
  },
  {
    id: '3511050008',
    districtId: '3511050',
    name: 'Jebung Lor',
  },
  {
    id: '3511050009',
    districtId: '3511050',
    name: 'Patemon',
  },
  {
    id: '3511050010',
    districtId: '3511050',
    name: 'Brambang Darussalam',
  },
  {
    id: '3511060001',
    districtId: '3511060',
    name: 'Pecalongan',
  },
  {
    id: '3511060006',
    districtId: '3511060',
    name: 'Nogosari',
  },
  {
    id: '3511060007',
    districtId: '3511060',
    name: 'Sukosari Lor',
  },
  {
    id: '3511060008',
    districtId: '3511060',
    name: 'Kerang',
  },
  {
    id: '3511061001',
    districtId: '3511061',
    name: 'Sukosari Kidul',
  },
  {
    id: '3511061002',
    districtId: '3511061',
    name: 'Tegal Jati',
  },
  {
    id: '3511061003',
    districtId: '3511061',
    name: 'Rejo Agung',
  },
  {
    id: '3511061004',
    districtId: '3511061',
    name: 'Sukorejo',
  },
  {
    id: '3511061005',
    districtId: '3511061',
    name: 'Sumber Gading',
  },
  {
    id: '3511061006',
    districtId: '3511061',
    name: 'Sumberwringin',
  },
  {
    id: '3511070001',
    districtId: '3511070',
    name: 'Wonokusumo',
  },
  {
    id: '3511070002',
    districtId: '3511070',
    name: 'Mangli Wetan',
  },
  {
    id: '3511070003',
    districtId: '3511070',
    name: 'Gununganyar',
  },
  {
    id: '3511070004',
    districtId: '3511070',
    name: 'Jurangsapi',
  },
  {
    id: '3511070005',
    districtId: '3511070',
    name: 'Cindogo',
  },
  {
    id: '3511070006',
    districtId: '3511070',
    name: 'Kalitapen',
  },
  {
    id: '3511070007',
    districtId: '3511070',
    name: 'Mrawan',
  },
  {
    id: '3511070008',
    districtId: '3511070',
    name: 'Taal',
  },
  {
    id: '3511070009',
    districtId: '3511070',
    name: 'Tapen',
  },
  {
    id: '3511080001',
    districtId: '3511080',
    name: 'Lombok Kulon',
  },
  {
    id: '3511080002',
    districtId: '3511080',
    name: 'Lombok Wetan',
  },
  {
    id: '3511080004',
    districtId: '3511080',
    name: 'Jumpong',
  },
  {
    id: '3511080005',
    districtId: '3511080',
    name: 'Tangsil Wetan',
  },
  {
    id: '3511080006',
    districtId: '3511080',
    name: 'Pasarejo',
  },
  {
    id: '3511080007',
    districtId: '3511080',
    name: 'Bendoarum',
  },
  {
    id: '3511080008',
    districtId: '3511080',
    name: 'Kapuran',
  },
  {
    id: '3511080009',
    districtId: '3511080',
    name: 'Sumberkalong',
  },
  {
    id: '3511080010',
    districtId: '3511080',
    name: 'Traktakan',
  },
  {
    id: '3511080011',
    districtId: '3511080',
    name: 'Wonosari',
  },
  {
    id: '3511080012',
    districtId: '3511080',
    name: 'Pelalangan',
  },
  {
    id: '3511090001',
    districtId: '3511090',
    name: 'Koncer Kidul',
  },
  {
    id: '3511090002',
    districtId: '3511090',
    name: 'Sumbersalam',
  },
  {
    id: '3511090003',
    districtId: '3511090',
    name: 'Pekalangan',
  },
  {
    id: '3511090004',
    districtId: '3511090',
    name: 'Kasemek',
  },
  {
    id: '3511090005',
    districtId: '3511090',
    name: 'Lojajar',
  },
  {
    id: '3511090006',
    districtId: '3511090',
    name: 'Kajar',
  },
  {
    id: '3511090007',
    districtId: '3511090',
    name: 'Bataan',
  },
  {
    id: '3511090008',
    districtId: '3511090',
    name: 'Gebang',
  },
  {
    id: '3511090009',
    districtId: '3511090',
    name: 'Dawuhan',
  },
  {
    id: '3511090010',
    districtId: '3511090',
    name: 'Tenggarang',
  },
  {
    id: '3511090011',
    districtId: '3511090',
    name: 'Tangsil Kulon',
  },
  {
    id: '3511090012',
    districtId: '3511090',
    name: 'Koncer Darul Aman',
  },
  {
    id: '3511100001',
    districtId: '3511100',
    name: 'Pancoran',
  },
  {
    id: '3511100002',
    districtId: '3511100',
    name: 'Sukowiryo',
  },
  {
    id: '3511100003',
    districtId: '3511100',
    name: 'Kembang',
  },
  {
    id: '3511100004',
    districtId: '3511100',
    name: 'Nangkaan',
  },
  {
    id: '3511100005',
    districtId: '3511100',
    name: 'Tamansari',
  },
  {
    id: '3511100006',
    districtId: '3511100',
    name: 'Dabasah',
  },
  {
    id: '3511100007',
    districtId: '3511100',
    name: 'Badean',
  },
  {
    id: '3511100008',
    districtId: '3511100',
    name: 'Kotakulon',
  },
  {
    id: '3511100009',
    districtId: '3511100',
    name: 'Blindungan',
  },
  {
    id: '3511100010',
    districtId: '3511100',
    name: 'Kademangan',
  },
  {
    id: '3511100011',
    districtId: '3511100',
    name: 'Pejaten',
  },
  {
    id: '3511110001',
    districtId: '3511110',
    name: 'Jetis',
  },
  {
    id: '3511110002',
    districtId: '3511110',
    name: 'Pakuwesi',
  },
  {
    id: '3511110003',
    districtId: '3511110',
    name: 'Kupang',
  },
  {
    id: '3511110005',
    districtId: '3511110',
    name: 'Penambangan',
  },
  {
    id: '3511110006',
    districtId: '3511110',
    name: 'Curahpoh',
  },
  {
    id: '3511110007',
    districtId: '3511110',
    name: 'Curahdami',
  },
  {
    id: '3511110008',
    districtId: '3511110',
    name: 'Poncogati',
  },
  {
    id: '3511110009',
    districtId: '3511110',
    name: 'Sumbersuko',
  },
  {
    id: '3511110011',
    districtId: '3511110',
    name: 'Silolembu',
  },
  {
    id: '3511110019',
    districtId: '3511110',
    name: 'Locare',
  },
  {
    id: '3511110020',
    districtId: '3511110',
    name: 'Sumber Salak',
  },
  {
    id: '3511111001',
    districtId: '3511111',
    name: 'Gadingsari',
  },
  {
    id: '3511111002',
    districtId: '3511111',
    name: 'Binakal',
  },
  {
    id: '3511111003',
    districtId: '3511111',
    name: 'Sumber Waru',
  },
  {
    id: '3511111004',
    districtId: '3511111',
    name: 'Kembangan',
  },
  {
    id: '3511111005',
    districtId: '3511111',
    name: 'Baratan',
  },
  {
    id: '3511111006',
    districtId: '3511111',
    name: 'Jeruk Soksok',
  },
  {
    id: '3511111007',
    districtId: '3511111',
    name: 'Bendelan',
  },
  {
    id: '3511111008',
    districtId: '3511111',
    name: 'Sumber Tengah',
  },
  {
    id: '3511120001',
    districtId: '3511120',
    name: 'Andungsari',
  },
  {
    id: '3511120002',
    districtId: '3511120',
    name: 'K U P A N G',
  },
  {
    id: '3511120003',
    districtId: '3511120',
    name: 'Ardisaeng',
  },
  {
    id: '3511120004',
    districtId: '3511120',
    name: 'Sumberdumpyong',
  },
  {
    id: '3511120005',
    districtId: '3511120',
    name: 'Gadingsari',
  },
  {
    id: '3511120006',
    districtId: '3511120',
    name: 'P A K E M',
  },
  {
    id: '3511120007',
    districtId: '3511120',
    name: 'Patemon',
  },
  {
    id: '3511130001',
    districtId: '3511130',
    name: 'Ambulu',
  },
  {
    id: '3511130002',
    districtId: '3511130',
    name: 'Bukor',
  },
  {
    id: '3511130003',
    districtId: '3511130',
    name: 'Sumbermalang',
  },
  {
    id: '3511130004',
    districtId: '3511130',
    name: 'Jambewungu',
  },
  {
    id: '3511130005',
    districtId: '3511130',
    name: 'Gubrih',
  },
  {
    id: '3511130006',
    districtId: '3511130',
    name: 'Ampelan',
  },
  {
    id: '3511130007',
    districtId: '3511130',
    name: 'Banyuwulu',
  },
  {
    id: '3511130008',
    districtId: '3511130',
    name: 'Jatitamban',
  },
  {
    id: '3511130009',
    districtId: '3511130',
    name: 'Jatisari',
  },
  {
    id: '3511130010',
    districtId: '3511130',
    name: 'Glingseran',
  },
  {
    id: '3511130011',
    districtId: '3511130',
    name: 'Banyuputih',
  },
  {
    id: '3511130012',
    districtId: '3511130',
    name: 'Wringin',
  },
  {
    id: '3511130013',
    districtId: '3511130',
    name: 'Sumbercanting',
  },
  {
    id: '3511140001',
    districtId: '3511140',
    name: 'Karanganyar',
  },
  {
    id: '3511140002',
    districtId: '3511140',
    name: 'Sekarputih',
  },
  {
    id: '3511140003',
    districtId: '3511140',
    name: 'Tegalampel',
  },
  {
    id: '3511140011',
    districtId: '3511140',
    name: 'Mandiro',
  },
  {
    id: '3511140012',
    districtId: '3511140',
    name: 'Tanggulangin',
  },
  {
    id: '3511140013',
    districtId: '3511140',
    name: 'Klabang',
  },
  {
    id: '3511140014',
    districtId: '3511140',
    name: 'Klabang Agung',
  },
  {
    id: '3511140015',
    districtId: '3511140',
    name: 'Purnama',
  },
  {
    id: '3511141001',
    districtId: '3511141',
    name: 'Trebungan',
  },
  {
    id: '3511141002',
    districtId: '3511141',
    name: 'Paguan',
  },
  {
    id: '3511141003',
    districtId: '3511141',
    name: 'Sumberkokap',
  },
  {
    id: '3511141004',
    districtId: '3511141',
    name: 'Taman',
  },
  {
    id: '3511141005',
    districtId: '3511141',
    name: 'Gentong',
  },
  {
    id: '3511141006',
    districtId: '3511141',
    name: 'Kemuningan',
  },
  {
    id: '3511150005',
    districtId: '3511150',
    name: 'Karanganyar',
  },
  {
    id: '3511150006',
    districtId: '3511150',
    name: 'Blimbing',
  },
  {
    id: '3511150007',
    districtId: '3511150',
    name: 'Karang Sengon',
  },
  {
    id: '3511150008',
    districtId: '3511150',
    name: 'Wonokerto',
  },
  {
    id: '3511150009',
    districtId: '3511150',
    name: 'Klabang',
  },
  {
    id: '3511150011',
    districtId: '3511150',
    name: 'Klampokan',
  },
  {
    id: '3511150012',
    districtId: '3511150',
    name: 'Sumbersuko',
  },
  {
    id: '3511150013',
    districtId: '3511150',
    name: 'Pandak',
  },
  {
    id: '3511150014',
    districtId: '3511150',
    name: 'Leprak',
  },
  {
    id: '3511150015',
    districtId: '3511150',
    name: 'Wonoboyo',
  },
  {
    id: '3511151001',
    districtId: '3511151',
    name: 'Sempol',
  },
  {
    id: '3511151002',
    districtId: '3511151',
    name: 'Kalianyar',
  },
  {
    id: '3511151003',
    districtId: '3511151',
    name: 'Kalisat',
  },
  {
    id: '3511151004',
    districtId: '3511151',
    name: 'Jampit',
  },
  {
    id: '3511151005',
    districtId: '3511151',
    name: 'Sumber Rejo',
  },
  {
    id: '3511151006',
    districtId: '3511151',
    name: 'Kaligedang',
  },
  {
    id: '3511152001',
    districtId: '3511152',
    name: 'Sumbercanting',
  },
  {
    id: '3511152002',
    districtId: '3511152',
    name: 'Lanas',
  },
  {
    id: '3511152003',
    districtId: '3511152',
    name: 'Penang',
  },
  {
    id: '3511152004',
    districtId: '3511152',
    name: 'Klekean',
  },
  {
    id: '3511152005',
    districtId: '3511152',
    name: 'Gayam',
  },
  {
    id: '3511152006',
    districtId: '3511152',
    name: 'Lumutan',
  },
  {
    id: '3511152007',
    districtId: '3511152',
    name: 'Botolinggo',
  },
  {
    id: '3511152008',
    districtId: '3511152',
    name: 'Gayam Lor',
  },
  {
    id: '3511160002',
    districtId: '3511160',
    name: 'Tarum',
  },
  {
    id: '3511160003',
    districtId: '3511160',
    name: 'Bandilan',
  },
  {
    id: '3511160004',
    districtId: '3511160',
    name: 'Sempol',
  },
  {
    id: '3511160005',
    districtId: '3511160',
    name: 'Prajekan Lor',
  },
  {
    id: '3511160006',
    districtId: '3511160',
    name: 'Prajekan Kidul',
  },
  {
    id: '3511160007',
    districtId: '3511160',
    name: 'Cangkring',
  },
  {
    id: '3511160008',
    districtId: '3511160',
    name: 'Walidono',
  },
  {
    id: '3511170001',
    districtId: '3511170',
    name: 'Suling Kulon',
  },
  {
    id: '3511170002',
    districtId: '3511170',
    name: 'Solor',
  },
  {
    id: '3511170003',
    districtId: '3511170',
    name: 'Kladi',
  },
  {
    id: '3511170004',
    districtId: '3511170',
    name: 'Bercak',
  },
  {
    id: '3511170006',
    districtId: '3511170',
    name: 'Suling Wetan',
  },
  {
    id: '3511170007',
    districtId: '3511170',
    name: 'Ramban Wetan',
  },
  {
    id: '3511170008',
    districtId: '3511170',
    name: 'Ramban Kulon',
  },
  {
    id: '3511170009',
    districtId: '3511170',
    name: 'Grujugan',
  },
  {
    id: '3511170010',
    districtId: '3511170',
    name: 'Bajuran',
  },
  {
    id: '3511170011',
    districtId: '3511170',
    name: 'Jirek Mas',
  },
  {
    id: '3511170012',
    districtId: '3511170',
    name: 'Batusalang',
  },
  {
    id: '3511170013',
    districtId: '3511170',
    name: 'Pelalangan',
  },
  {
    id: '3511170014',
    districtId: '3511170',
    name: 'Batu Ampar',
  },
  {
    id: '3511170015',
    districtId: '3511170',
    name: 'Bercak Asri',
  },
  {
    id: '3512010001',
    districtId: '3512010',
    name: 'Alas Tengah',
  },
  {
    id: '3512010002',
    districtId: '3512010',
    name: 'Baderan',
  },
  {
    id: '3512010003',
    districtId: '3512010',
    name: 'Tamankursi',
  },
  {
    id: '3512010004',
    districtId: '3512010',
    name: 'Sumberargo',
  },
  {
    id: '3512010005',
    districtId: '3512010',
    name: 'Kalirejo',
  },
  {
    id: '3512010006',
    districtId: '3512010',
    name: 'Taman Sari',
  },
  {
    id: '3512010007',
    districtId: '3512010',
    name: 'Tlogosari',
  },
  {
    id: '3512010008',
    districtId: '3512010',
    name: 'Taman',
  },
  {
    id: '3512010009',
    districtId: '3512010',
    name: 'Plalangan',
  },
  {
    id: '3512020001',
    districtId: '3512020',
    name: 'Patemon',
  },
  {
    id: '3512020002',
    districtId: '3512020',
    name: 'Kembangsari',
  },
  {
    id: '3512020003',
    districtId: '3512020',
    name: 'Pategalan',
  },
  {
    id: '3512020004',
    districtId: '3512020',
    name: 'Semambung',
  },
  {
    id: '3512020005',
    districtId: '3512020',
    name: 'Sumberanyar',
  },
  {
    id: '3512020006',
    districtId: '3512020',
    name: 'Jatibanteng',
  },
  {
    id: '3512020007',
    districtId: '3512020',
    name: 'Wringinanom',
  },
  {
    id: '3512020008',
    districtId: '3512020',
    name: 'Curahsuri',
  },
  {
    id: '3512030001',
    districtId: '3512030',
    name: 'Tepos',
  },
  {
    id: '3512030002',
    districtId: '3512030',
    name: 'Kalisari',
  },
  {
    id: '3512030003',
    districtId: '3512030',
    name: 'Lubawang',
  },
  {
    id: '3512030004',
    districtId: '3512030',
    name: 'Kalianget',
  },
  {
    id: '3512030005',
    districtId: '3512030',
    name: 'Telempong',
  },
  {
    id: '3512030006',
    districtId: '3512030',
    name: 'Selobanteng',
  },
  {
    id: '3512030007',
    districtId: '3512030',
    name: 'Banyuglugur',
  },
  {
    id: '3512040001',
    districtId: '3512040',
    name: 'Bloro',
  },
  {
    id: '3512040002',
    districtId: '3512040',
    name: 'Langkap',
  },
  {
    id: '3512040003',
    districtId: '3512040',
    name: 'Blimbing',
  },
  {
    id: '3512040004',
    districtId: '3512040',
    name: 'Widoro Payung',
  },
  {
    id: '3512040005',
    districtId: '3512040',
    name: 'Sumberejo',
  },
  {
    id: '3512040006',
    districtId: '3512040',
    name: 'Jetis',
  },
  {
    id: '3512040007',
    districtId: '3512040',
    name: 'Kalimas',
  },
  {
    id: '3512040009',
    districtId: '3512040',
    name: 'Pesisir',
  },
  {
    id: '3512040010',
    districtId: '3512040',
    name: 'Besuki',
  },
  {
    id: '3512050001',
    districtId: '3512050',
    name: 'Cemara',
  },
  {
    id: '3512050002',
    districtId: '3512050',
    name: 'Mojo Dungkol',
  },
  {
    id: '3512050003',
    districtId: '3512050',
    name: 'Gunung Putri',
  },
  {
    id: '3512050004',
    districtId: '3512050',
    name: 'Gunung Malang',
  },
  {
    id: '3512050005',
    districtId: '3512050',
    name: 'Dawuan',
  },
  {
    id: '3512050006',
    districtId: '3512050',
    name: 'Suboh',
  },
  {
    id: '3512050007',
    districtId: '3512050',
    name: 'Buduan',
  },
  {
    id: '3512050008',
    districtId: '3512050',
    name: 'Ketah',
  },
  {
    id: '3512060001',
    districtId: '3512060',
    name: 'Selomukti',
  },
  {
    id: '3512060002',
    districtId: '3512060',
    name: 'Sumber Pinang',
  },
  {
    id: '3512060003',
    districtId: '3512060',
    name: 'Alas Bayur',
  },
  {
    id: '3512060004',
    districtId: '3512060',
    name: 'Sumberanyar',
  },
  {
    id: '3512060005',
    districtId: '3512060',
    name: 'Campoan',
  },
  {
    id: '3512060006',
    districtId: '3512060',
    name: 'Trebungan',
  },
  {
    id: '3512060007',
    districtId: '3512060',
    name: 'Mlandingan Kulon',
  },
  {
    id: '3512070001',
    districtId: '3512070',
    name: 'Selowogo',
  },
  {
    id: '3512070002',
    districtId: '3512070',
    name: 'Sumbertengah',
  },
  {
    id: '3512070003',
    districtId: '3512070',
    name: 'Patemon',
  },
  {
    id: '3512070004',
    districtId: '3512070',
    name: 'Pasir Putih',
  },
  {
    id: '3512070005',
    districtId: '3512070',
    name: 'Bungatan',
  },
  {
    id: '3512070006',
    districtId: '3512070',
    name: 'Bletok',
  },
  {
    id: '3512070007',
    districtId: '3512070',
    name: 'Mlandingan Wetan',
  },
  {
    id: '3512080001',
    districtId: '3512080',
    name: 'Rajekwesi',
  },
  {
    id: '3512080002',
    districtId: '3512080',
    name: 'Tambak Ukir',
  },
  {
    id: '3512080003',
    districtId: '3512080',
    name: 'Bugeman',
  },
  {
    id: '3512080004',
    districtId: '3512080',
    name: 'Kendit',
  },
  {
    id: '3512080005',
    districtId: '3512080',
    name: 'Balung',
  },
  {
    id: '3512080006',
    districtId: '3512080',
    name: 'Kukusan',
  },
  {
    id: '3512080007',
    districtId: '3512080',
    name: 'Klatakan',
  },
  {
    id: '3512090001',
    districtId: '3512090',
    name: 'Kilensari',
  },
  {
    id: '3512090002',
    districtId: '3512090',
    name: 'Paowan',
  },
  {
    id: '3512090003',
    districtId: '3512090',
    name: 'Sumber Kolak',
  },
  {
    id: '3512090004',
    districtId: '3512090',
    name: 'Wringin Anom',
  },
  {
    id: '3512090005',
    districtId: '3512090',
    name: 'Peleyan',
  },
  {
    id: '3512090006',
    districtId: '3512090',
    name: 'Alas Malang',
  },
  {
    id: '3512100001',
    districtId: '3512100',
    name: 'Kalibagor',
  },
  {
    id: '3512100002',
    districtId: '3512100',
    name: 'Kotakan',
  },
  {
    id: '3512100003',
    districtId: '3512100',
    name: 'Dawuhan',
  },
  {
    id: '3512100004',
    districtId: '3512100',
    name: 'Patokan',
  },
  {
    id: '3512100005',
    districtId: '3512100',
    name: 'Talkandang',
  },
  {
    id: '3512100006',
    districtId: '3512100',
    name: 'Olean',
  },
  {
    id: '3512110001',
    districtId: '3512110',
    name: 'Trebungan',
  },
  {
    id: '3512110002',
    districtId: '3512110',
    name: 'Mangaran',
  },
  {
    id: '3512110003',
    districtId: '3512110',
    name: 'Tanjung Kamal',
  },
  {
    id: '3512110004',
    districtId: '3512110',
    name: 'Tanjung Glugur',
  },
  {
    id: '3512110005',
    districtId: '3512110',
    name: 'Tanjung Pecinan',
  },
  {
    id: '3512110006',
    districtId: '3512110',
    name: 'Semiring',
  },
  {
    id: '3512120001',
    districtId: '3512120',
    name: 'Sliwung',
  },
  {
    id: '3512120002',
    districtId: '3512120',
    name: 'Ardirejo',
  },
  {
    id: '3512120003',
    districtId: '3512120',
    name: 'Battal',
  },
  {
    id: '3512120004',
    districtId: '3512120',
    name: 'Klampokan',
  },
  {
    id: '3512120005',
    districtId: '3512120',
    name: 'Juglangan',
  },
  {
    id: '3512120006',
    districtId: '3512120',
    name: 'Panji Kidul',
  },
  {
    id: '3512120007',
    districtId: '3512120',
    name: 'Panji Lor',
  },
  {
    id: '3512120008',
    districtId: '3512120',
    name: 'Mimbaan',
  },
  {
    id: '3512120009',
    districtId: '3512120',
    name: 'Curah Jeru',
  },
  {
    id: '3512120010',
    districtId: '3512120',
    name: 'Tokelan',
  },
  {
    id: '3512120011',
    districtId: '3512120',
    name: 'Tenggir',
  },
  {
    id: '3512120012',
    districtId: '3512120',
    name: 'Kayu Putih',
  },
  {
    id: '3512130001',
    districtId: '3512130',
    name: 'Kandang',
  },
  {
    id: '3512130002',
    districtId: '3512130',
    name: 'Curah Cotok',
  },
  {
    id: '3512130003',
    districtId: '3512130',
    name: 'Peleyan',
  },
  {
    id: '3512130004',
    districtId: '3512130',
    name: 'Wonokoyo',
  },
  {
    id: '3512130006',
    districtId: '3512130',
    name: 'Landangan',
  },
  {
    id: '3512130007',
    districtId: '3512130',
    name: 'Kapongan',
  },
  {
    id: '3512130008',
    districtId: '3512130',
    name: 'Kesambi Rampak',
  },
  {
    id: '3512130009',
    districtId: '3512130',
    name: 'Gebangan',
  },
  {
    id: '3512130010',
    districtId: '3512130',
    name: 'Pokaan',
  },
  {
    id: '3512140001',
    districtId: '3512140',
    name: 'Curah Tatal',
  },
  {
    id: '3512140002',
    districtId: '3512140',
    name: 'Jatisari',
  },
  {
    id: '3512140003',
    districtId: '3512140',
    name: 'Kayumas',
  },
  {
    id: '3512140004',
    districtId: '3512140',
    name: 'Bayeman',
  },
  {
    id: '3512140005',
    districtId: '3512140',
    name: 'Ketowan',
  },
  {
    id: '3512140006',
    districtId: '3512140',
    name: 'Kedungdowo',
  },
  {
    id: '3512140007',
    districtId: '3512140',
    name: 'Lamongan',
  },
  {
    id: '3512140008',
    districtId: '3512140',
    name: 'Arjasa',
  },
  {
    id: '3512150001',
    districtId: '3512150',
    name: 'Sopet',
  },
  {
    id: '3512150002',
    districtId: '3512150',
    name: 'Curah Kalak',
  },
  {
    id: '3512150003',
    districtId: '3512150',
    name: 'Palangan',
  },
  {
    id: '3512150004',
    districtId: '3512150',
    name: 'Jangkar',
  },
  {
    id: '3512150005',
    districtId: '3512150',
    name: 'Gadingan',
  },
  {
    id: '3512150006',
    districtId: '3512150',
    name: 'Kumbangsari',
  },
  {
    id: '3512150007',
    districtId: '3512150',
    name: 'Pesanggrahan',
  },
  {
    id: '3512150008',
    districtId: '3512150',
    name: 'Agel',
  },
  {
    id: '3512160001',
    districtId: '3512160',
    name: 'Mojosari',
  },
  {
    id: '3512160002',
    districtId: '3512160',
    name: 'Kertosari',
  },
  {
    id: '3512160003',
    districtId: '3512160',
    name: 'Kedonglo',
  },
  {
    id: '3512160004',
    districtId: '3512160',
    name: 'Bantal',
  },
  {
    id: '3512160005',
    districtId: '3512160',
    name: 'Awar-Awar',
  },
  {
    id: '3512160006',
    districtId: '3512160',
    name: 'Perante',
  },
  {
    id: '3512160007',
    districtId: '3512160',
    name: 'Trigonco',
  },
  {
    id: '3512160008',
    districtId: '3512160',
    name: 'Asembagus',
  },
  {
    id: '3512160009',
    districtId: '3512160',
    name: 'Gudang',
  },
  {
    id: '3512160010',
    districtId: '3512160',
    name: 'Wringin Anom',
  },
  {
    id: '3512170001',
    districtId: '3512170',
    name: 'Banyuputih',
  },
  {
    id: '3512170002',
    districtId: '3512170',
    name: 'Sumberejo',
  },
  {
    id: '3512170003',
    districtId: '3512170',
    name: 'Sumberanyar',
  },
  {
    id: '3512170004',
    districtId: '3512170',
    name: 'Sumberwaru',
  },
  {
    id: '3512170005',
    districtId: '3512170',
    name: 'Wonorejo',
  },
  {
    id: '3513010001',
    districtId: '3513010',
    name: 'Ngadisari',
  },
  {
    id: '3513010002',
    districtId: '3513010',
    name: 'Sariwani',
  },
  {
    id: '3513010003',
    districtId: '3513010',
    name: 'Kedasih',
  },
  {
    id: '3513010004',
    districtId: '3513010',
    name: 'Pakel',
  },
  {
    id: '3513010006',
    districtId: '3513010',
    name: 'Sukapura',
  },
  {
    id: '3513010007',
    districtId: '3513010',
    name: 'Sapikerep',
  },
  {
    id: '3513010008',
    districtId: '3513010',
    name: 'Wonokerto',
  },
  {
    id: '3513010009',
    districtId: '3513010',
    name: 'Ngadirejo',
  },
  {
    id: '3513010010',
    districtId: '3513010',
    name: 'Ngadas',
  },
  {
    id: '3513010011',
    districtId: '3513010',
    name: 'Jetak',
  },
  {
    id: '3513010012',
    districtId: '3513010',
    name: 'Wonotoro',
  },
  {
    id: '3513020001',
    districtId: '3513020',
    name: 'Ledokombo',
  },
  {
    id: '3513020002',
    districtId: '3513020',
    name: 'Pandansari',
  },
  {
    id: '3513020003',
    districtId: '3513020',
    name: 'Sumberanom',
  },
  {
    id: '3513020004',
    districtId: '3513020',
    name: 'Wonokerso',
  },
  {
    id: '3513020005',
    districtId: '3513020',
    name: 'Gemito',
  },
  {
    id: '3513020008',
    districtId: '3513020',
    name: 'Cepoko',
  },
  {
    id: '3513020009',
    districtId: '3513020',
    name: 'Rambaan',
  },
  {
    id: '3513030001',
    districtId: '3513030',
    name: 'Wonoasri',
  },
  {
    id: '3513030002',
    districtId: '3513030',
    name: 'Jatisari',
  },
  {
    id: '3513030003',
    districtId: '3513030',
    name: 'Kedawung',
  },
  {
    id: '3513030004',
    districtId: '3513030',
    name: 'Karangrejo',
  },
  {
    id: '3513030005',
    districtId: '3513030',
    name: 'Resongo',
  },
  {
    id: '3513030006',
    districtId: '3513030',
    name: 'Wringinanom',
  },
  {
    id: '3513030007',
    districtId: '3513030',
    name: 'Menyono',
  },
  {
    id: '3513040001',
    districtId: '3513040',
    name: 'Karanganyar',
  },
  {
    id: '3513040002',
    districtId: '3513040',
    name: 'Bantaran',
  },
  {
    id: '3513040004',
    districtId: '3513040',
    name: 'Kedungrejo',
  },
  {
    id: '3513040006',
    districtId: '3513040',
    name: 'Patokan',
  },
  {
    id: '3513040007',
    districtId: '3513040',
    name: 'Legundi',
  },
  {
    id: '3513040008',
    districtId: '3513040',
    name: 'Tempuran',
  },
  {
    id: '3513040009',
    districtId: '3513040',
    name: 'Kropak',
  },
  {
    id: '3513040010',
    districtId: '3513040',
    name: 'Kramatagung',
  },
  {
    id: '3513050001',
    districtId: '3513050',
    name: 'Tigasan Kulon',
  },
  {
    id: '3513050002',
    districtId: '3513050',
    name: 'Tigasan Wetan',
  },
  {
    id: '3513050003',
    districtId: '3513050',
    name: 'Malasan Kulon',
  },
  {
    id: '3513050005',
    districtId: '3513050',
    name: 'Pondokwuluh',
  },
  {
    id: '3513050006',
    districtId: '3513050',
    name: 'Kerpangan',
  },
  {
    id: '3513050007',
    districtId: '3513050',
    name: 'Sumberkedawung',
  },
  {
    id: '3513050008',
    districtId: '3513050',
    name: 'Clarak',
  },
  {
    id: '3513050009',
    districtId: '3513050',
    name: 'Jorongan',
  },
  {
    id: '3513050010',
    districtId: '3513050',
    name: 'Warujinggo',
  },
  {
    id: '3513060001',
    districtId: '3513060',
    name: 'Malasanwetan',
  },
  {
    id: '3513060003',
    districtId: '3513060',
    name: 'Tegalsono',
  },
  {
    id: '3513060004',
    districtId: '3513060',
    name: 'Bulujarankidul',
  },
  {
    id: '3513060005',
    districtId: '3513060',
    name: 'Bulujaranlor',
  },
  {
    id: '3513060006',
    districtId: '3513060',
    name: 'Paras',
  },
  {
    id: '3513060007',
    districtId: '3513060',
    name: 'Tegalsiwalan',
  },
  {
    id: '3513060008',
    districtId: '3513060',
    name: 'Banjarsawah',
  },
  {
    id: '3513060011',
    districtId: '3513060',
    name: 'Bladukulon',
  },
  {
    id: '3513060012',
    districtId: '3513060',
    name: 'Tegalmojo',
  },
  {
    id: '3513070001',
    districtId: '3513070',
    name: 'Gununggeni',
  },
  {
    id: '3513070002',
    districtId: '3513070',
    name: 'Liprak Kidul',
  },
  {
    id: '3513070003',
    districtId: '3513070',
    name: 'Sentulan',
  },
  {
    id: '3513070004',
    districtId: '3513070',
    name: 'Gading Kulon',
  },
  {
    id: '3513070005',
    districtId: '3513070',
    name: 'Klenang Kidul',
  },
  {
    id: '3513070006',
    districtId: '3513070',
    name: 'Klenang Lor',
  },
  {
    id: '3513070007',
    districtId: '3513070',
    name: 'Tarokan',
  },
  {
    id: '3513070008',
    districtId: '3513070',
    name: 'Liprak Wetan',
  },
  {
    id: '3513070009',
    districtId: '3513070',
    name: 'Liprak Kulon',
  },
  {
    id: '3513070010',
    districtId: '3513070',
    name: 'Banyuanyar Kidul',
  },
  {
    id: '3513070011',
    districtId: '3513070',
    name: 'Blado Wetan',
  },
  {
    id: '3513070012',
    districtId: '3513070',
    name: 'Banyuanyar Tengah',
  },
  {
    id: '3513070013',
    districtId: '3513070',
    name: 'Pendil',
  },
  {
    id: '3513070014',
    districtId: '3513070',
    name: 'Alassapi',
  },
  {
    id: '3513080001',
    districtId: '3513080',
    name: 'Tlogosari',
  },
  {
    id: '3513080002',
    districtId: '3513080',
    name: 'Andungsari',
  },
  {
    id: '3513080003',
    districtId: '3513080',
    name: 'Tlogoargo',
  },
  {
    id: '3513080004',
    districtId: '3513080',
    name: 'Andungbiru',
  },
  {
    id: '3513080005',
    districtId: '3513080',
    name: 'Tiris',
  },
  {
    id: '3513080006',
    districtId: '3513080',
    name: 'Ranuagung',
  },
  {
    id: '3513080007',
    districtId: '3513080',
    name: 'Segaran',
  },
  {
    id: '3513080008',
    districtId: '3513080',
    name: 'Ranugedang',
  },
  {
    id: '3513080009',
    districtId: '3513080',
    name: 'Jangkang',
  },
  {
    id: '3513080010',
    districtId: '3513080',
    name: 'Wedusan',
  },
  {
    id: '3513080011',
    districtId: '3513080',
    name: 'Racek',
  },
  {
    id: '3513080012',
    districtId: '3513080',
    name: 'Pesawahan',
  },
  {
    id: '3513080013',
    districtId: '3513080',
    name: 'Pedagangan',
  },
  {
    id: '3513080014',
    districtId: '3513080',
    name: 'Rejing',
  },
  {
    id: '3513080015',
    districtId: '3513080',
    name: 'Tegalwatu',
  },
  {
    id: '3513080016',
    districtId: '3513080',
    name: 'Tulupari',
  },
  {
    id: '3513090002',
    districtId: '3513090',
    name: 'Roto',
  },
  {
    id: '3513090003',
    districtId: '3513090',
    name: 'Kertosuko',
  },
  {
    id: '3513090004',
    districtId: '3513090',
    name: 'Tambelang',
  },
  {
    id: '3513090005',
    districtId: '3513090',
    name: 'Krucil',
  },
  {
    id: '3513090006',
    districtId: '3513090',
    name: 'Bermi',
  },
  {
    id: '3513090007',
    districtId: '3513090',
    name: 'Kalianan',
  },
  {
    id: '3513090008',
    districtId: '3513090',
    name: 'Watupanjang',
  },
  {
    id: '3513090009',
    districtId: '3513090',
    name: 'Guyangan',
  },
  {
    id: '3513090011',
    districtId: '3513090',
    name: 'Krobungan',
  },
  {
    id: '3513090013',
    districtId: '3513090',
    name: 'Pandanlaras',
  },
  {
    id: '3513090014',
    districtId: '3513090',
    name: 'Plaosan',
  },
  {
    id: '3513100001',
    districtId: '3513100',
    name: 'Condong',
  },
  {
    id: '3513100002',
    districtId: '3513100',
    name: 'Jurangjero',
  },
  {
    id: '3513100003',
    districtId: '3513100',
    name: 'Ranuwurung',
  },
  {
    id: '3513100004',
    districtId: '3513100',
    name: 'Gadingwetan',
  },
  {
    id: '3513100005',
    districtId: '3513100',
    name: 'Bulupandak',
  },
  {
    id: '3513100009',
    districtId: '3513100',
    name: 'Betektaman',
  },
  {
    id: '3513100010',
    districtId: '3513100',
    name: 'Batur',
  },
  {
    id: '3513100012',
    districtId: '3513100',
    name: 'Dandang',
  },
  {
    id: '3513100013',
    districtId: '3513100',
    name: 'Kertosono',
  },
  {
    id: '3513100014',
    districtId: '3513100',
    name: 'Prasi',
  },
  {
    id: '3513100015',
    districtId: '3513100',
    name: 'Nogosaren',
  },
  {
    id: '3513100016',
    districtId: '3513100',
    name: 'Wangkal',
  },
  {
    id: '3513100017',
    districtId: '3513100',
    name: 'Mojolegi',
  },
  {
    id: '3513100018',
    districtId: '3513100',
    name: 'Kaliacar',
  },
  {
    id: '3513100019',
    districtId: '3513100',
    name: 'Sumbersecang',
  },
  {
    id: '3513110001',
    districtId: '3513110',
    name: 'Ranon',
  },
  {
    id: '3513110003',
    districtId: '3513110',
    name: 'Gunggungan Kidul',
  },
  {
    id: '3513110004',
    districtId: '3513110',
    name: 'Kalidandan',
  },
  {
    id: '3513110005',
    districtId: '3513110',
    name: 'Blimbing',
  },
  {
    id: '3513110006',
    districtId: '3513110',
    name: 'Gondosuli',
  },
  {
    id: '3513110007',
    districtId: '3513110',
    name: 'Kertonegoro',
  },
  {
    id: '3513110008',
    districtId: '3513110',
    name: 'Bimo',
  },
  {
    id: '3513110009',
    districtId: '3513110',
    name: 'Pakuniran',
  },
  {
    id: '3513110010',
    districtId: '3513110',
    name: 'Patemon Kulon',
  },
  {
    id: '3513110011',
    districtId: '3513110',
    name: 'Gunggungan Lor',
  },
  {
    id: '3513110012',
    districtId: '3513110',
    name: 'Sogaan',
  },
  {
    id: '3513110013',
    districtId: '3513110',
    name: 'Sumberkembar',
  },
  {
    id: '3513110014',
    districtId: '3513110',
    name: 'Alaspandan',
  },
  {
    id: '3513110015',
    districtId: '3513110',
    name: 'Bucor Wetan',
  },
  {
    id: '3513110016',
    districtId: '3513110',
    name: 'Bucor Kulon',
  },
  {
    id: '3513110017',
    districtId: '3513110',
    name: 'Glagah',
  },
  {
    id: '3513120002',
    districtId: '3513120',
    name: 'Sambirampak Kidul',
  },
  {
    id: '3513120003',
    districtId: '3513120',
    name: 'Sidomulyo',
  },
  {
    id: '3513120004',
    districtId: '3513120',
    name: 'Tambakukir',
  },
  {
    id: '3513120005',
    districtId: '3513120',
    name: 'Curah Temu',
  },
  {
    id: '3513120006',
    districtId: '3513120',
    name: 'Pasembon',
  },
  {
    id: '3513120007',
    districtId: '3513120',
    name: 'Sidorejo',
  },
  {
    id: '3513120008',
    districtId: '3513120',
    name: 'Sambirampak Lor',
  },
  {
    id: '3513120009',
    districtId: '3513120',
    name: 'Sukorejo',
  },
  {
    id: '3513120010',
    districtId: '3513120',
    name: 'Talkandang',
  },
  {
    id: '3513120011',
    districtId: '3513120',
    name: 'Kedung Rejoso',
  },
  {
    id: '3513120012',
    districtId: '3513120',
    name: 'Triwungan',
  },
  {
    id: '3513120013',
    districtId: '3513120',
    name: 'Kotaanyar',
  },
  {
    id: '3513130001',
    districtId: '3513130',
    name: 'Jabung Wetan',
  },
  {
    id: '3513130002',
    districtId: '3513130',
    name: 'Kalikajar Kulon',
  },
  {
    id: '3513130003',
    districtId: '3513130',
    name: 'Kalikajar Wetan',
  },
  {
    id: '3513130004',
    districtId: '3513130',
    name: 'Alastengah',
  },
  {
    id: '3513130005',
    districtId: '3513130',
    name: 'Pandean',
  },
  {
    id: '3513130006',
    districtId: '3513130',
    name: 'Petunjungan',
  },
  {
    id: '3513130007',
    districtId: '3513130',
    name: 'Taman',
  },
  {
    id: '3513130008',
    districtId: '3513130',
    name: 'Plampang',
  },
  {
    id: '3513130009',
    districtId: '3513130',
    name: 'Sidodadi',
  },
  {
    id: '3513130010',
    districtId: '3513130',
    name: 'Jabung Candi',
  },
  {
    id: '3513130011',
    districtId: '3513130',
    name: 'Jabungsisir',
  },
  {
    id: '3513130012',
    districtId: '3513130',
    name: 'Randumerak',
  },
  {
    id: '3513130013',
    districtId: '3513130',
    name: 'Randutatah',
  },
  {
    id: '3513130014',
    districtId: '3513130',
    name: 'Karanganyar',
  },
  {
    id: '3513130015',
    districtId: '3513130',
    name: 'Pondok Kelor',
  },
  {
    id: '3513130016',
    districtId: '3513130',
    name: 'Sukodadi',
  },
  {
    id: '3513130017',
    districtId: '3513130',
    name: 'Paiton',
  },
  {
    id: '3513130018',
    districtId: '3513130',
    name: 'Sumberanyar',
  },
  {
    id: '3513130019',
    districtId: '3513130',
    name: 'Sumberejo',
  },
  {
    id: '3513130020',
    districtId: '3513130',
    name: 'Bhinar',
  },
  {
    id: '3513140001',
    districtId: '3513140',
    name: 'Matekan',
  },
  {
    id: '3513140002',
    districtId: '3513140',
    name: 'Krampilan',
  },
  {
    id: '3513140003',
    districtId: '3513140',
    name: 'Klampokan',
  },
  {
    id: '3513140004',
    districtId: '3513140',
    name: 'Jambangan',
  },
  {
    id: '3513140005',
    districtId: '3513140',
    name: 'Kecik',
  },
  {
    id: '3513140006',
    districtId: '3513140',
    name: 'Bago',
  },
  {
    id: '3513140007',
    districtId: '3513140',
    name: 'Alas Nyiur',
  },
  {
    id: '3513140008',
    districtId: '3513140',
    name: 'Sindet Anyar',
  },
  {
    id: '3513140009',
    districtId: '3513140',
    name: 'Sindet Lami',
  },
  {
    id: '3513140010',
    districtId: '3513140',
    name: 'Sumur Dalam',
  },
  {
    id: '3513140011',
    districtId: '3513140',
    name: 'Besuk Kidul',
  },
  {
    id: '3513140012',
    districtId: '3513140',
    name: 'Besuk Agung',
  },
  {
    id: '3513140013',
    districtId: '3513140',
    name: 'Randujalak',
  },
  {
    id: '3513140014',
    districtId: '3513140',
    name: 'Alas Tengah',
  },
  {
    id: '3513140015',
    districtId: '3513140',
    name: 'Alas Kandang',
  },
  {
    id: '3513140016',
    districtId: '3513140',
    name: 'Alassumur Lor',
  },
  {
    id: '3513140017',
    districtId: '3513140',
    name: 'Sumberan',
  },
  {
    id: '3513150001',
    districtId: '3513150',
    name: 'Kregenan',
  },
  {
    id: '3513150002',
    districtId: '3513150',
    name: 'Rondokuning',
  },
  {
    id: '3513150003',
    districtId: '3513150',
    name: 'Semampir',
  },
  {
    id: '3513150005',
    districtId: '3513150',
    name: 'Sidomukti',
  },
  {
    id: '3513150006',
    districtId: '3513150',
    name: 'Kraksaan Wetan',
  },
  {
    id: '3513150007',
    districtId: '3513150',
    name: 'Rangkang',
  },
  {
    id: '3513150008',
    districtId: '3513150',
    name: 'Kandangjati Kulon',
  },
  {
    id: '3513150009',
    districtId: '3513150',
    name: 'Kandangjati Wetan',
  },
  {
    id: '3513150010',
    districtId: '3513150',
    name: 'Alassumur Kulon',
  },
  {
    id: '3513150012',
    districtId: '3513150',
    name: 'Tamansari',
  },
  {
    id: '3513150013',
    districtId: '3513150',
    name: 'Asembakor',
  },
  {
    id: '3513150014',
    districtId: '3513150',
    name: 'Kebonagung',
  },
  {
    id: '3513150015',
    districtId: '3513150',
    name: 'Sidopekso',
  },
  {
    id: '3513150016',
    districtId: '3513150',
    name: 'Patokan',
  },
  {
    id: '3513150017',
    districtId: '3513150',
    name: 'Asembagus',
  },
  {
    id: '3513150018',
    districtId: '3513150',
    name: 'Kalibuntu',
  },
  {
    id: '3513160001',
    districtId: '3513160',
    name: 'Opo - Opo',
  },
  {
    id: '3513160002',
    districtId: '3513160',
    name: 'Rawan',
  },
  {
    id: '3513160003',
    districtId: '3513160',
    name: 'Seboro',
  },
  {
    id: '3513160004',
    districtId: '3513160',
    name: 'Karangren',
  },
  {
    id: '3513160005',
    districtId: '3513160',
    name: 'Kedungcaluk',
  },
  {
    id: '3513160006',
    districtId: '3513160',
    name: 'Sokaan',
  },
  {
    id: '3513160007',
    districtId: '3513160',
    name: 'Dawuhan',
  },
  {
    id: '3513160008',
    districtId: '3513160',
    name: 'Gebangan',
  },
  {
    id: '3513160009',
    districtId: '3513160',
    name: 'Widoro',
  },
  {
    id: '3513160010',
    districtId: '3513160',
    name: 'Sumberkatimoho',
  },
  {
    id: '3513160011',
    districtId: '3513160',
    name: 'Krejengan',
  },
  {
    id: '3513160012',
    districtId: '3513160',
    name: 'Kamalkuning',
  },
  {
    id: '3513160013',
    districtId: '3513160',
    name: 'Tanjungsari',
  },
  {
    id: '3513160014',
    districtId: '3513160',
    name: 'Patemon',
  },
  {
    id: '3513160015',
    districtId: '3513160',
    name: 'Temenggungan',
  },
  {
    id: '3513160016',
    districtId: '3513160',
    name: 'Jatiurip',
  },
  {
    id: '3513160017',
    districtId: '3513160',
    name: 'Sentong',
  },
  {
    id: '3513170001',
    districtId: '3513170',
    name: 'Selogudig Kulon',
  },
  {
    id: '3513170002',
    districtId: '3513170',
    name: 'Selogudig Wetan',
  },
  {
    id: '3513170003',
    districtId: '3513170',
    name: 'Ketompen',
  },
  {
    id: '3513170004',
    districtId: '3513170',
    name: 'Karangbong',
  },
  {
    id: '3513170005',
    districtId: '3513170',
    name: 'Karangpranti',
  },
  {
    id: '3513170006',
    districtId: '3513170',
    name: 'Gejugan',
  },
  {
    id: '3513170007',
    districtId: '3513170',
    name: 'Karanggeger',
  },
  {
    id: '3513170008',
    districtId: '3513170',
    name: 'Tanjung',
  },
  {
    id: '3513170009',
    districtId: '3513170',
    name: 'Pajarakan Kulon',
  },
  {
    id: '3513170010',
    districtId: '3513170',
    name: 'Sukokerto',
  },
  {
    id: '3513170011',
    districtId: '3513170',
    name: 'Sukomulyo',
  },
  {
    id: '3513170012',
    districtId: '3513170',
    name: 'Penambangan',
  },
  {
    id: '3513180001',
    districtId: '3513180',
    name: 'Sumberpoh',
  },
  {
    id: '3513180002',
    districtId: '3513180',
    name: 'Sumberdawe',
  },
  {
    id: '3513180003',
    districtId: '3513180',
    name: 'Brabe',
  },
  {
    id: '3513180004',
    districtId: '3513180',
    name: 'Maron Kidul',
  },
  {
    id: '3513180005',
    districtId: '3513180',
    name: 'Gerongan',
  },
  {
    id: '3513180006',
    districtId: '3513180',
    name: 'Satreyan',
  },
  {
    id: '3513180007',
    districtId: '3513180',
    name: 'Brani Wetan',
  },
  {
    id: '3513180008',
    districtId: '3513180',
    name: 'Brani Kulon',
  },
  {
    id: '3513180009',
    districtId: '3513180',
    name: 'Maron Wetan',
  },
  {
    id: '3513180010',
    districtId: '3513180',
    name: 'Maron Kulon',
  },
  {
    id: '3513180011',
    districtId: '3513180',
    name: 'Kedungsari',
  },
  {
    id: '3513180012',
    districtId: '3513180',
    name: 'Pegalangan Kidul',
  },
  {
    id: '3513180013',
    districtId: '3513180',
    name: 'Brumbungan Kidul',
  },
  {
    id: '3513180014',
    districtId: '3513180',
    name: 'Wonorejo',
  },
  {
    id: '3513180015',
    districtId: '3513180',
    name: 'Puspan',
  },
  {
    id: '3513180016',
    districtId: '3513180',
    name: 'Ganting Wetan',
  },
  {
    id: '3513180017',
    districtId: '3513180',
    name: 'Ganting Kulon',
  },
  {
    id: '3513180018',
    districtId: '3513180',
    name: 'Suko',
  },
  {
    id: '3513190001',
    districtId: '3513190',
    name: 'Banyuanyar Lor',
  },
  {
    id: '3513190002',
    districtId: '3513190',
    name: 'Sumberkerang',
  },
  {
    id: '3513190003',
    districtId: '3513190',
    name: 'Sebaung',
  },
  {
    id: '3513190004',
    districtId: '3513190',
    name: 'Pikatan',
  },
  {
    id: '3513190005',
    districtId: '3513190',
    name: 'Bulang',
  },
  {
    id: '3513190006',
    districtId: '3513190',
    name: 'Brumbungan Lor',
  },
  {
    id: '3513190007',
    districtId: '3513190',
    name: 'Jatiadi',
  },
  {
    id: '3513190008',
    districtId: '3513190',
    name: 'Klaseman',
  },
  {
    id: '3513190009',
    districtId: '3513190',
    name: 'Pesisir',
  },
  {
    id: '3513190010',
    districtId: '3513190',
    name: 'Randupitu',
  },
  {
    id: '3513190011',
    districtId: '3513190',
    name: 'Gending',
  },
  {
    id: '3513190012',
    districtId: '3513190',
    name: 'Pajurangan',
  },
  {
    id: '3513190013',
    districtId: '3513190',
    name: 'Curahsawo',
  },
  {
    id: '3513200001',
    districtId: '3513200',
    name: 'Ngepoh',
  },
  {
    id: '3513200002',
    districtId: '3513200',
    name: 'Sumberagung',
  },
  {
    id: '3513200003',
    districtId: '3513200',
    name: 'Sumbersuko',
  },
  {
    id: '3513200004',
    districtId: '3513200',
    name: 'Watuwungkuk',
  },
  {
    id: '3513200005',
    districtId: '3513200',
    name: 'Sekarkare',
  },
  {
    id: '3513200006',
    districtId: '3513200',
    name: 'Mranggon Lawang',
  },
  {
    id: '3513200007',
    districtId: '3513200',
    name: 'Tegalrejo',
  },
  {
    id: '3513200008',
    districtId: '3513200',
    name: 'Kalirejo',
  },
  {
    id: '3513200009',
    districtId: '3513200',
    name: 'Kedungdalem',
  },
  {
    id: '3513200010',
    districtId: '3513200',
    name: 'Tamansari',
  },
  {
    id: '3513200011',
    districtId: '3513200',
    name: 'Randuputih',
  },
  {
    id: '3513200012',
    districtId: '3513200',
    name: 'Kalisalam',
  },
  {
    id: '3513200013',
    districtId: '3513200',
    name: 'Dringu',
  },
  {
    id: '3513200014',
    districtId: '3513200',
    name: 'Pabean',
  },
  {
    id: '3513210001',
    districtId: '3513210',
    name: 'Patalan',
  },
  {
    id: '3513210003',
    districtId: '3513210',
    name: 'Wonorejo',
  },
  {
    id: '3513210004',
    districtId: '3513210',
    name: 'Tunggakcerme',
  },
  {
    id: '3513210005',
    districtId: '3513210',
    name: 'Pohsangit Tengah',
  },
  {
    id: '3513210006',
    districtId: '3513210',
    name: 'Kareng Kidul',
  },
  {
    id: '3513210007',
    districtId: '3513210',
    name: 'Kedungsupit',
  },
  {
    id: '3513210008',
    districtId: '3513210',
    name: 'Pohsangit Lor',
  },
  {
    id: '3513210009',
    districtId: '3513210',
    name: 'Pohsangit Ngisor',
  },
  {
    id: '3513210010',
    districtId: '3513210',
    name: 'Sepuhgempol',
  },
  {
    id: '3513210011',
    districtId: '3513210',
    name: 'Sumberkare',
  },
  {
    id: '3513220001',
    districtId: '3513220',
    name: 'Sapih',
  },
  {
    id: '3513220002',
    districtId: '3513220',
    name: 'Negororejo',
  },
  {
    id: '3513220003',
    districtId: '3513220',
    name: 'Branggah',
  },
  {
    id: '3513220004',
    districtId: '3513220',
    name: 'Lambangkuning',
  },
  {
    id: '3513220005',
    districtId: '3513220',
    name: 'Palangbesi',
  },
  {
    id: '3513220006',
    districtId: '3513220',
    name: 'Boto',
  },
  {
    id: '3513220007',
    districtId: '3513220',
    name: 'Wonogoro',
  },
  {
    id: '3513220008',
    districtId: '3513220',
    name: 'Lumbang',
  },
  {
    id: '3513220009',
    districtId: '3513220',
    name: 'Tandonsentul',
  },
  {
    id: '3513230001',
    districtId: '3513230',
    name: 'Pamatan',
  },
  {
    id: '3513230002',
    districtId: '3513230',
    name: 'Sumberkramat',
  },
  {
    id: '3513230003',
    districtId: '3513230',
    name: 'Sumberejo',
  },
  {
    id: '3513230004',
    districtId: '3513230',
    name: 'Sumendi',
  },
  {
    id: '3513230005',
    districtId: '3513230',
    name: 'Bayeman',
  },
  {
    id: '3513230007',
    districtId: '3513230',
    name: 'Curahdringu',
  },
  {
    id: '3513230008',
    districtId: '3513230',
    name: 'Wringinanom',
  },
  {
    id: '3513230009',
    districtId: '3513230',
    name: 'Tongaswetan',
  },
  {
    id: '3513230010',
    districtId: '3513230',
    name: 'Tongaskulon',
  },
  {
    id: '3513230011',
    districtId: '3513230',
    name: 'Curahtulis',
  },
  {
    id: '3513230012',
    districtId: '3513230',
    name: 'Klampok',
  },
  {
    id: '3513230013',
    districtId: '3513230',
    name: 'Tanjungrejo',
  },
  {
    id: '3513230014',
    districtId: '3513230',
    name: 'Tambakrejo',
  },
  {
    id: '3513240001',
    districtId: '3513240',
    name: 'Muneng Kidul',
  },
  {
    id: '3513240002',
    districtId: '3513240',
    name: 'Pohsangit Leres',
  },
  {
    id: '3513240003',
    districtId: '3513240',
    name: 'Laweyan',
  },
  {
    id: '3513240005',
    districtId: '3513240',
    name: 'Jangur',
  },
  {
    id: '3513240006',
    districtId: '3513240',
    name: 'Sumberbendo',
  },
  {
    id: '3513240007',
    districtId: '3513240',
    name: 'Mentor',
  },
  {
    id: '3513240008',
    districtId: '3513240',
    name: 'Sumurmati',
  },
  {
    id: '3513240009',
    districtId: '3513240',
    name: 'Pesisir',
  },
  {
    id: '3513240010',
    districtId: '3513240',
    name: 'Lemahkembar',
  },
  {
    id: '3513240011',
    districtId: '3513240',
    name: 'Ambulu',
  },
  {
    id: '3513240012',
    districtId: '3513240',
    name: 'Banjarsari',
  },
  {
    id: '3513240013',
    districtId: '3513240',
    name: 'Gili Ketapang',
  },
  {
    id: '3514010001',
    districtId: '3514010',
    name: 'Gerbo',
  },
  {
    id: '3514010002',
    districtId: '3514010',
    name: 'Dawuhan Sengon',
  },
  {
    id: '3514010003',
    districtId: '3514010',
    name: 'Lebak Rejo',
  },
  {
    id: '3514010004',
    districtId: '3514010',
    name: 'Cowek',
  },
  {
    id: '3514010005',
    districtId: '3514010',
    name: 'Purwodadi',
  },
  {
    id: '3514010006',
    districtId: '3514010',
    name: 'Parerejo',
  },
  {
    id: '3514010008',
    districtId: '3514010',
    name: 'Gajah Rejo',
  },
  {
    id: '3514010009',
    districtId: '3514010',
    name: 'Jatisari',
  },
  {
    id: '3514010010',
    districtId: '3514010',
    name: 'Tambak Sari',
  },
  {
    id: '3514010011',
    districtId: '3514010',
    name: 'Pucang Sari',
  },
  {
    id: '3514010012',
    districtId: '3514010',
    name: 'Capang',
  },
  {
    id: '3514020001',
    districtId: '3514020',
    name: 'Blarang',
  },
  {
    id: '3514020002',
    districtId: '3514020',
    name: 'Kayu Kebek',
  },
  {
    id: '3514020003',
    districtId: '3514020',
    name: 'Ngadirejo',
  },
  {
    id: '3514020004',
    districtId: '3514020',
    name: 'Andono Sari',
  },
  {
    id: '3514020005',
    districtId: '3514020',
    name: 'Wonosari',
  },
  {
    id: '3514020006',
    districtId: '3514020',
    name: 'Gendro',
  },
  {
    id: '3514020007',
    districtId: '3514020',
    name: 'Tlogosari',
  },
  {
    id: '3514020009',
    districtId: '3514020',
    name: 'Pungging',
  },
  {
    id: '3514020010',
    districtId: '3514020',
    name: 'Kali Pucang',
  },
  {
    id: '3514020011',
    districtId: '3514020',
    name: 'Sumber Pitu',
  },
  {
    id: '3514020012',
    districtId: '3514020',
    name: 'Ngembal',
  },
  {
    id: '3514030001',
    districtId: '3514030',
    name: 'Jangjangwulung',
  },
  {
    id: '3514030002',
    districtId: '3514030',
    name: 'Palang Sari',
  },
  {
    id: '3514030003',
    districtId: '3514030',
    name: 'Kemiri',
  },
  {
    id: '3514030004',
    districtId: '3514030',
    name: 'Puspo',
  },
  {
    id: '3514030005',
    districtId: '3514030',
    name: 'Jimbaran',
  },
  {
    id: '3514030007',
    districtId: '3514030',
    name: 'Pusung Malang',
  },
  {
    id: '3514040001',
    districtId: '3514040',
    name: 'Kandangan',
  },
  {
    id: '3514040002',
    districtId: '3514040',
    name: 'Mororejo',
  },
  {
    id: '3514040003',
    districtId: '3514040',
    name: 'Ngadiwono',
  },
  {
    id: '3514040004',
    districtId: '3514040',
    name: 'Podokoyo',
  },
  {
    id: '3514040005',
    districtId: '3514040',
    name: 'Wonokitri',
  },
  {
    id: '3514040006',
    districtId: '3514040',
    name: 'Tosari',
  },
  {
    id: '3514040007',
    districtId: '3514040',
    name: 'Baledono',
  },
  {
    id: '3514040008',
    districtId: '3514040',
    name: 'Sedaeng',
  },
  {
    id: '3514050001',
    districtId: '3514050',
    name: 'Wonorejo',
  },
  {
    id: '3514050002',
    districtId: '3514050',
    name: 'Kronto',
  },
  {
    id: '3514050003',
    districtId: '3514050',
    name: 'Pancur',
  },
  {
    id: '3514050004',
    districtId: '3514050',
    name: 'Karang Asem',
  },
  {
    id: '3514050005',
    districtId: '3514050',
    name: 'Cukurguling',
  },
  {
    id: '3514050006',
    districtId: '3514050',
    name: 'Lumbang',
  },
  {
    id: '3514050007',
    districtId: '3514050',
    name: 'Bulukandang',
  },
  {
    id: '3514050008',
    districtId: '3514050',
    name: 'Karang Jati',
  },
  {
    id: '3514050009',
    districtId: '3514050',
    name: 'Watulumbung',
  },
  {
    id: '3514050010',
    districtId: '3514050',
    name: 'Panditan',
  },
  {
    id: '3514050011',
    districtId: '3514050',
    name: 'Banjarimbo',
  },
  {
    id: '3514050012',
    districtId: '3514050',
    name: 'Welulang',
  },
  {
    id: '3514060001',
    districtId: '3514060',
    name: 'Tempuran',
  },
  {
    id: '3514060002',
    districtId: '3514060',
    name: 'Ampelsari',
  },
  {
    id: '3514060003',
    districtId: '3514060',
    name: 'Sapulante',
  },
  {
    id: '3514060004',
    districtId: '3514060',
    name: 'Pohgedang',
  },
  {
    id: '3514060005',
    districtId: '3514060',
    name: 'Mangguan',
  },
  {
    id: '3514060006',
    districtId: '3514060',
    name: 'Ngantungan',
  },
  {
    id: '3514060007',
    districtId: '3514060',
    name: 'Galih',
  },
  {
    id: '3514060009',
    districtId: '3514060',
    name: 'Klakah',
  },
  {
    id: '3514060010',
    districtId: '3514060',
    name: 'Sibon',
  },
  {
    id: '3514060011',
    districtId: '3514060',
    name: 'Pasrepan',
  },
  {
    id: '3514060012',
    districtId: '3514060',
    name: 'Rejosalam',
  },
  {
    id: '3514060013',
    districtId: '3514060',
    name: 'Cengkrong',
  },
  {
    id: '3514060014',
    districtId: '3514060',
    name: 'Lemahbang',
  },
  {
    id: '3514060015',
    districtId: '3514060',
    name: 'Tambakrejo',
  },
  {
    id: '3514060016',
    districtId: '3514060',
    name: 'Jogorepuh',
  },
  {
    id: '3514060017',
    districtId: '3514060',
    name: 'Pohgading',
  },
  {
    id: '3514070001',
    districtId: '3514070',
    name: 'Kedemungan',
  },
  {
    id: '3514070002',
    districtId: '3514070',
    name: 'Ambal Ambil',
  },
  {
    id: '3514070003',
    districtId: '3514070',
    name: 'Klangrong',
  },
  {
    id: '3514070004',
    districtId: '3514070',
    name: 'Oro Oro Pule',
  },
  {
    id: '3514070005',
    districtId: '3514070',
    name: 'Lorokan',
  },
  {
    id: '3514070006',
    districtId: '3514070',
    name: 'Kedung Pengaron',
  },
  {
    id: '3514070007',
    districtId: '3514070',
    name: 'Benerwojo',
  },
  {
    id: '3514070008',
    districtId: '3514070',
    name: 'Coban Joyo',
  },
  {
    id: '3514070010',
    districtId: '3514070',
    name: 'Linggo',
  },
  {
    id: '3514070011',
    districtId: '3514070',
    name: 'Wrati',
  },
  {
    id: '3514070012',
    districtId: '3514070',
    name: 'Sumber Suko',
  },
  {
    id: '3514070014',
    districtId: '3514070',
    name: 'Pacar Keling',
  },
  {
    id: '3514070015',
    districtId: '3514070',
    name: 'Sumber Banteng',
  },
  {
    id: '3514070017',
    districtId: '3514070',
    name: 'Tanggulangin',
  },
  {
    id: '3514070018',
    districtId: '3514070',
    name: 'Randu Gong',
  },
  {
    id: '3514070019',
    districtId: '3514070',
    name: 'Wangkal Wetan',
  },
  {
    id: '3514070020',
    districtId: '3514070',
    name: 'Klinter',
  },
  {
    id: '3514070021',
    districtId: '3514070',
    name: 'Tundo Soro',
  },
  {
    id: '3514070022',
    districtId: '3514070',
    name: 'Ketangi Rejo',
  },
  {
    id: '3514070023',
    districtId: '3514070',
    name: 'Patebon',
  },
  {
    id: '3514070024',
    districtId: '3514070',
    name: 'Kejayan',
  },
  {
    id: '3514070025',
    districtId: '3514070',
    name: 'Sladi',
  },
  {
    id: '3514080001',
    districtId: '3514080',
    name: 'Karang Menggah',
  },
  {
    id: '3514080002',
    districtId: '3514080',
    name: 'Karangjati Anyar',
  },
  {
    id: '3514080003',
    districtId: '3514080',
    name: 'Wonosari',
  },
  {
    id: '3514080004',
    districtId: '3514080',
    name: 'Tamansari',
  },
  {
    id: '3514080005',
    districtId: '3514080',
    name: 'Coban Blimbing',
  },
  {
    id: '3514080006',
    districtId: '3514080',
    name: 'Pakijangan',
  },
  {
    id: '3514080007',
    districtId: '3514080',
    name: 'Wonorejo',
  },
  {
    id: '3514080008',
    districtId: '3514080',
    name: 'Jati Gunting',
  },
  {
    id: '3514080009',
    districtId: '3514080',
    name: 'Rebono',
  },
  {
    id: '3514080010',
    districtId: '3514080',
    name: 'Karangsono',
  },
  {
    id: '3514080011',
    districtId: '3514080',
    name: 'Kendang Dukuh',
  },
  {
    id: '3514080012',
    districtId: '3514080',
    name: 'Karang Asem',
  },
  {
    id: '3514080014',
    districtId: '3514080',
    name: 'Sambisirah',
  },
  {
    id: '3514080015',
    districtId: '3514080',
    name: 'Lebaksari',
  },
  {
    id: '3514090001',
    districtId: '3514090',
    name: 'Sekar Mojo',
  },
  {
    id: '3514090002',
    districtId: '3514090',
    name: 'Tejowangi',
  },
  {
    id: '3514090003',
    districtId: '3514090',
    name: 'Kertosari',
  },
  {
    id: '3514090004',
    districtId: '3514090',
    name: 'Martopuro',
  },
  {
    id: '3514090005',
    districtId: '3514090',
    name: 'Purwosari',
  },
  {
    id: '3514090006',
    districtId: '3514090',
    name: 'Sumber Rejo',
  },
  {
    id: '3514090007',
    districtId: '3514090',
    name: 'Pager',
  },
  {
    id: '3514090008',
    districtId: '3514090',
    name: 'Cendono',
  },
  {
    id: '3514090009',
    districtId: '3514090',
    name: 'Karang Rejo',
  },
  {
    id: '3514090010',
    districtId: '3514090',
    name: 'Sumber Suko',
  },
  {
    id: '3514090011',
    districtId: '3514090',
    name: 'Sengon Agung',
  },
  {
    id: '3514090012',
    districtId: '3514090',
    name: 'Bakalan',
  },
  {
    id: '3514090013',
    districtId: '3514090',
    name: 'Sukodermo',
  },
  {
    id: '3514090014',
    districtId: '3514090',
    name: 'Pucangsari',
  },
  {
    id: '3514090015',
    districtId: '3514090',
    name: 'Kayoman',
  },
  {
    id: '3514100001',
    districtId: '3514100',
    name: 'Jatiarjo',
  },
  {
    id: '3514100002',
    districtId: '3514100',
    name: 'Watuagung',
  },
  {
    id: '3514100003',
    districtId: '3514100',
    name: 'Dayurejo',
  },
  {
    id: '3514100004',
    districtId: '3514100',
    name: 'Bulukandang',
  },
  {
    id: '3514100005',
    districtId: '3514100',
    name: 'Ketanireng',
  },
  {
    id: '3514100006',
    districtId: '3514100',
    name: 'Sukolelo',
  },
  {
    id: '3514100008',
    districtId: '3514100',
    name: 'Pecalukan',
  },
  {
    id: '3514100009',
    districtId: '3514100',
    name: 'Prigen',
  },
  {
    id: '3514100010',
    districtId: '3514100',
    name: 'Lumbang Rejo',
  },
  {
    id: '3514100011',
    districtId: '3514100',
    name: 'Sukoreno',
  },
  {
    id: '3514100012',
    districtId: '3514100',
    name: 'Sekarjoho',
  },
  {
    id: '3514100013',
    districtId: '3514100',
    name: 'Gambiran',
  },
  {
    id: '3514100014',
    districtId: '3514100',
    name: 'Candi Wates',
  },
  {
    id: '3514110001',
    districtId: '3514110',
    name: 'Gunting',
  },
  {
    id: '3514110002',
    districtId: '3514110',
    name: 'Pakukerto',
  },
  {
    id: '3514110003',
    districtId: '3514110',
    name: 'Glagah Sari',
  },
  {
    id: '3514110004',
    districtId: '3514110',
    name: 'Sukorejo',
  },
  {
    id: '3514110005',
    districtId: '3514110',
    name: 'Karangsono',
  },
  {
    id: '3514110006',
    districtId: '3514110',
    name: 'Sebandung',
  },
  {
    id: '3514110007',
    districtId: '3514110',
    name: 'Dukuh Sari',
  },
  {
    id: '3514110008',
    districtId: '3514110',
    name: 'Lecari',
  },
  {
    id: '3514110009',
    districtId: '3514110',
    name: 'Lemahbang',
  },
  {
    id: '3514110010',
    districtId: '3514110',
    name: 'Ngadimulyo',
  },
  {
    id: '3514110011',
    districtId: '3514110',
    name: 'Tanjungarum',
  },
  {
    id: '3514110012',
    districtId: '3514110',
    name: 'Suwayuwo',
  },
  {
    id: '3514110013',
    districtId: '3514110',
    name: 'Mojotengah',
  },
  {
    id: '3514110014',
    districtId: '3514110',
    name: 'Kalirejo',
  },
  {
    id: '3514110015',
    districtId: '3514110',
    name: 'Candi Binangun',
  },
  {
    id: '3514110016',
    districtId: '3514110',
    name: 'Kenduruan',
  },
  {
    id: '3514110017',
    districtId: '3514110',
    name: 'Curah Rejo',
  },
  {
    id: '3514110018',
    districtId: '3514110',
    name: 'Sukorame',
  },
  {
    id: '3514110019',
    districtId: '3514110',
    name: 'Wonokerto',
  },
  {
    id: '3514120001',
    districtId: '3514120',
    name: 'Plintahan',
  },
  {
    id: '3514120003',
    districtId: '3514120',
    name: 'Karang Jati',
  },
  {
    id: '3514120004',
    districtId: '3514120',
    name: 'Wedoro',
  },
  {
    id: '3514120006',
    districtId: '3514120',
    name: 'Kutorejo',
  },
  {
    id: '3514120007',
    districtId: '3514120',
    name: 'Jogosari',
  },
  {
    id: '3514120008',
    districtId: '3514120',
    name: 'Pandaan',
  },
  {
    id: '3514120009',
    districtId: '3514120',
    name: 'Petungasri',
  },
  {
    id: '3514120010',
    districtId: '3514120',
    name: 'Sumber Gedang',
  },
  {
    id: '3514120011',
    districtId: '3514120',
    name: 'Tawang Rejo',
  },
  {
    id: '3514120012',
    districtId: '3514120',
    name: 'Sumber Rejo',
  },
  {
    id: '3514120013',
    districtId: '3514120',
    name: 'Nogosari',
  },
  {
    id: '3514120014',
    districtId: '3514120',
    name: 'Kemiri Sewu',
  },
  {
    id: '3514120015',
    districtId: '3514120',
    name: 'Kebon Waris',
  },
  {
    id: '3514120016',
    districtId: '3514120',
    name: 'Sebani',
  },
  {
    id: '3514120017',
    districtId: '3514120',
    name: 'Banjarsari',
  },
  {
    id: '3514120018',
    districtId: '3514120',
    name: 'Banjar Kejen',
  },
  {
    id: '3514130001',
    districtId: '3514130',
    name: 'Wonosunyo',
  },
  {
    id: '3514130002',
    districtId: '3514130',
    name: 'Sumber Suko',
  },
  {
    id: '3514130003',
    districtId: '3514130',
    name: 'Wonosari',
  },
  {
    id: '3514130004',
    districtId: '3514130',
    name: 'Kepulungan',
  },
  {
    id: '3514130005',
    districtId: '3514130',
    name: 'Randupitu',
  },
  {
    id: '3514130006',
    districtId: '3514130',
    name: 'Ngerong',
  },
  {
    id: '3514130008',
    districtId: '3514130',
    name: 'Karangrejo',
  },
  {
    id: '3514130009',
    districtId: '3514130',
    name: 'Bulusari',
  },
  {
    id: '3514130010',
    districtId: '3514130',
    name: 'Watukosek',
  },
  {
    id: '3514130011',
    districtId: '3514130',
    name: 'Carat',
  },
  {
    id: '3514130012',
    districtId: '3514130',
    name: 'Kejapanan',
  },
  {
    id: '3514130013',
    districtId: '3514130',
    name: 'Winong',
  },
  {
    id: '3514130014',
    districtId: '3514130',
    name: 'Legok',
  },
  {
    id: '3514130015',
    districtId: '3514130',
    name: 'Gempol',
  },
  {
    id: '3514140001',
    districtId: '3514140',
    name: 'Baujeng',
  },
  {
    id: '3514140004',
    districtId: '3514140',
    name: 'Sidowayah',
  },
  {
    id: '3514140005',
    districtId: '3514140',
    name: 'Gajahbendo',
  },
  {
    id: '3514140006',
    districtId: '3514140',
    name: 'Beji',
  },
  {
    id: '3514140007',
    districtId: '3514140',
    name: 'Gunung Sari',
  },
  {
    id: '3514140008',
    districtId: '3514140',
    name: 'Wonokoyo',
  },
  {
    id: '3514140009',
    districtId: '3514140',
    name: 'Gunung Gangsir',
  },
  {
    id: '3514140010',
    districtId: '3514140',
    name: 'Cangkring Malang',
  },
  {
    id: '3514140011',
    districtId: '3514140',
    name: 'Kedung Ringin',
  },
  {
    id: '3514140012',
    districtId: '3514140',
    name: 'Pagak',
  },
  {
    id: '3514140013',
    districtId: '3514140',
    name: 'Kedung Boto',
  },
  {
    id: '3514140014',
    districtId: '3514140',
    name: 'Glanggang',
  },
  {
    id: '3514150001',
    districtId: '3514150',
    name: 'Kolursari',
  },
  {
    id: '3514150002',
    districtId: '3514150',
    name: 'Kidul Dalem',
  },
  {
    id: '3514150003',
    districtId: '3514150',
    name: 'Pogar',
  },
  {
    id: '3514150004',
    districtId: '3514150',
    name: 'Kauman',
  },
  {
    id: '3514150005',
    districtId: '3514150',
    name: 'Bendo Mungal',
  },
  {
    id: '3514150006',
    districtId: '3514150',
    name: 'Kersikan',
  },
  {
    id: '3514150008',
    districtId: '3514150',
    name: 'Dermo',
  },
  {
    id: '3514150009',
    districtId: '3514150',
    name: 'Latek',
  },
  {
    id: '3514150010',
    districtId: '3514150',
    name: 'Masangan',
  },
  {
    id: '3514150011',
    districtId: '3514150',
    name: 'Raci',
  },
  {
    id: '3514150012',
    districtId: '3514150',
    name: 'Kalianyar',
  },
  {
    id: '3514150013',
    districtId: '3514150',
    name: 'Manaruwi',
  },
  {
    id: '3514150014',
    districtId: '3514150',
    name: 'Kalirejo',
  },
  {
    id: '3514150015',
    districtId: '3514150',
    name: 'Tambakan',
  },
  {
    id: '3514160001',
    districtId: '3514160',
    name: 'Kalisat',
  },
  {
    id: '3514160002',
    districtId: '3514160',
    name: 'Tampung',
  },
  {
    id: '3514160003',
    districtId: '3514160',
    name: 'Pajaran',
  },
  {
    id: '3514160004',
    districtId: '3514160',
    name: 'Siyar',
  },
  {
    id: '3514160005',
    districtId: '3514160',
    name: 'Geneng Waru',
  },
  {
    id: '3514160006',
    districtId: '3514160',
    name: 'Kanigoro',
  },
  {
    id: '3514160007',
    districtId: '3514160',
    name: 'Krengih',
  },
  {
    id: '3514160008',
    districtId: '3514160',
    name: 'Sumber Glagah',
  },
  {
    id: '3514160009',
    districtId: '3514160',
    name: 'Rembang',
  },
  {
    id: '3514160010',
    districtId: '3514160',
    name: 'Orobulu',
  },
  {
    id: '3514160011',
    districtId: '3514160',
    name: 'Kedung Banteng',
  },
  {
    id: '3514160012',
    districtId: '3514160',
    name: 'Oroombo Wetan',
  },
  {
    id: '3514160013',
    districtId: '3514160',
    name: 'Oroombo Kulon',
  },
  {
    id: '3514160014',
    districtId: '3514160',
    name: 'Pekoren',
  },
  {
    id: '3514160015',
    districtId: '3514160',
    name: 'Pejangkungan',
  },
  {
    id: '3514160016',
    districtId: '3514160',
    name: 'Pandean',
  },
  {
    id: '3514160017',
    districtId: '3514160',
    name: 'Mojoparon',
  },
  {
    id: '3514170001',
    districtId: '3514170',
    name: 'Slambrit',
  },
  {
    id: '3514170002',
    districtId: '3514170',
    name: 'Ngabar',
  },
  {
    id: '3514170003',
    districtId: '3514170',
    name: 'Klampis Rejo',
  },
  {
    id: '3514170004',
    districtId: '3514170',
    name: 'Kebotohan',
  },
  {
    id: '3514170006',
    districtId: '3514170',
    name: 'Gambir Kuning',
  },
  {
    id: '3514170007',
    districtId: '3514170',
    name: 'Mulyo Rejo',
  },
  {
    id: '3514170008',
    districtId: '3514170',
    name: 'Tambaksari',
  },
  {
    id: '3514170009',
    districtId: '3514170',
    name: 'Plinggisan',
  },
  {
    id: '3514170010',
    districtId: '3514170',
    name: 'Dhompo',
  },
  {
    id: '3514170011',
    districtId: '3514170',
    name: 'Ngempit',
  },
  {
    id: '3514170013',
    districtId: '3514170',
    name: 'Sidogiri',
  },
  {
    id: '3514170014',
    districtId: '3514170',
    name: 'Karang Anyar',
  },
  {
    id: '3514170015',
    districtId: '3514170',
    name: 'Selotambak',
  },
  {
    id: '3514170016',
    districtId: '3514170',
    name: 'Curah Dukuh',
  },
  {
    id: '3514170017',
    districtId: '3514170',
    name: 'Rejosari',
  },
  {
    id: '3514170018',
    districtId: '3514170',
    name: 'Asemkandang',
  },
  {
    id: '3514170019',
    districtId: '3514170',
    name: 'Tambakrejo',
  },
  {
    id: '3514170020',
    districtId: '3514170',
    name: 'Kraton',
  },
  {
    id: '3514170021',
    districtId: '3514170',
    name: 'Kalirejo',
  },
  {
    id: '3514170022',
    districtId: '3514170',
    name: 'Semare',
  },
  {
    id: '3514170023',
    districtId: '3514170',
    name: 'Pulokerto',
  },
  {
    id: '3514170024',
    districtId: '3514170',
    name: 'Bendungan',
  },
  {
    id: '3514170025',
    districtId: '3514170',
    name: 'Gerongan',
  },
  {
    id: '3514180001',
    districtId: '3514180',
    name: 'Susukan Rejo',
  },
  {
    id: '3514180002',
    districtId: '3514180',
    name: 'Warung Dowo',
  },
  {
    id: '3514180004',
    districtId: '3514180',
    name: 'Paras Rejo',
  },
  {
    id: '3514180005',
    districtId: '3514180',
    name: 'Logowok',
  },
  {
    id: '3514180006',
    districtId: '3514180',
    name: 'Tidu',
  },
  {
    id: '3514180007',
    districtId: '3514180',
    name: 'Sungi Wetan',
  },
  {
    id: '3514180008',
    districtId: '3514180',
    name: 'Sungi Kulon',
  },
  {
    id: '3514180009',
    districtId: '3514180',
    name: 'Sukorejo',
  },
  {
    id: '3514190001',
    districtId: '3514190',
    name: 'Tebas',
  },
  {
    id: '3514190002',
    districtId: '3514190',
    name: 'Brambang',
  },
  {
    id: '3514190003',
    districtId: '3514190',
    name: 'Bayeman',
  },
  {
    id: '3514190004',
    districtId: '3514190',
    name: 'Kebon Candi',
  },
  {
    id: '3514190005',
    districtId: '3514190',
    name: 'Tenggilis Rejo',
  },
  {
    id: '3514190006',
    districtId: '3514190',
    name: 'Wonojati',
  },
  {
    id: '3514190007',
    districtId: '3514190',
    name: 'Wonosari',
  },
  {
    id: '3514190008',
    districtId: '3514190',
    name: 'Kersikan',
  },
  {
    id: '3514190009',
    districtId: '3514190',
    name: 'Karang Sentul',
  },
  {
    id: '3514190010',
    districtId: '3514190',
    name: 'Gayam',
  },
  {
    id: '3514190011',
    districtId: '3514190',
    name: 'Lajuk',
  },
  {
    id: '3514190012',
    districtId: '3514190',
    name: 'Kali Rejo',
  },
  {
    id: '3514190013',
    districtId: '3514190',
    name: 'Pateguhan',
  },
  {
    id: '3514190014',
    districtId: '3514190',
    name: 'Grogol',
  },
  {
    id: '3514190015',
    districtId: '3514190',
    name: 'Pekangkungan',
  },
  {
    id: '3514190016',
    districtId: '3514190',
    name: 'Gondang Wetan',
  },
  {
    id: '3514190017',
    districtId: '3514190',
    name: 'Ranggeh',
  },
  {
    id: '3514190018',
    districtId: '3514190',
    name: 'Sekar Putih',
  },
  {
    id: '3514190019',
    districtId: '3514190',
    name: 'Bajangan',
  },
  {
    id: '3514190020',
    districtId: '3514190',
    name: 'Gondang Rejo',
  },
  {
    id: '3514200001',
    districtId: '3514200',
    name: 'Sadeng Rejo',
  },
  {
    id: '3514200002',
    districtId: '3514200',
    name: 'Pandan Rejo',
  },
  {
    id: '3514200003',
    districtId: '3514200',
    name: 'Ketegan',
  },
  {
    id: '3514200004',
    districtId: '3514200',
    name: 'Toyaning',
  },
  {
    id: '3514200005',
    districtId: '3514200',
    name: 'Arjosari',
  },
  {
    id: '3514200006',
    districtId: '3514200',
    name: 'Kemantren Rejo',
  },
  {
    id: '3514200007',
    districtId: '3514200',
    name: 'Segoro Puro',
  },
  {
    id: '3514200008',
    districtId: '3514200',
    name: 'Patuguran',
  },
  {
    id: '3514200009',
    districtId: '3514200',
    name: 'Rejosolor',
  },
  {
    id: '3514200010',
    districtId: '3514200',
    name: 'Kawis Rejo',
  },
  {
    id: '3514200011',
    districtId: '3514200',
    name: 'Rejoso Kidul',
  },
  {
    id: '3514200012',
    districtId: '3514200',
    name: 'Kedung Bako',
  },
  {
    id: '3514200013',
    districtId: '3514200',
    name: 'Manik Rejo',
  },
  {
    id: '3514200014',
    districtId: '3514200',
    name: 'Karang Pandan',
  },
  {
    id: '3514200015',
    districtId: '3514200',
    name: 'Sambirejo',
  },
  {
    id: '3514200016',
    districtId: '3514200',
    name: 'Jarangan',
  },
  {
    id: '3514210001',
    districtId: '3514210',
    name: 'Minggir',
  },
  {
    id: '3514210002',
    districtId: '3514210',
    name: 'Karang Tengah',
  },
  {
    id: '3514210003',
    districtId: '3514210',
    name: 'Kedung Rejo',
  },
  {
    id: '3514210004',
    districtId: '3514210',
    name: 'Umbulan',
  },
  {
    id: '3514210005',
    districtId: '3514210',
    name: 'Sidepan',
  },
  {
    id: '3514210006',
    districtId: '3514210',
    name: 'Sruwi',
  },
  {
    id: '3514210007',
    districtId: '3514210',
    name: 'Jeladri',
  },
  {
    id: '3514210008',
    districtId: '3514210',
    name: 'Sumber Rejo',
  },
  {
    id: '3514210009',
    districtId: '3514210',
    name: 'Prodo',
  },
  {
    id: '3514210010',
    districtId: '3514210',
    name: 'Lebak',
  },
  {
    id: '3514210011',
    districtId: '3514210',
    name: 'Menyarik',
  },
  {
    id: '3514210012',
    districtId: '3514210',
    name: 'Kandung',
  },
  {
    id: '3514210013',
    districtId: '3514210',
    name: 'Mendalan',
  },
  {
    id: '3514210014',
    districtId: '3514210',
    name: 'Penataan',
  },
  {
    id: '3514210015',
    districtId: '3514210',
    name: 'Winongan Kidul',
  },
  {
    id: '3514210016',
    districtId: '3514210',
    name: 'Bandaran',
  },
  {
    id: '3514210017',
    districtId: '3514210',
    name: 'Winongan Lor',
  },
  {
    id: '3514210018',
    districtId: '3514210',
    name: 'Gading',
  },
  {
    id: '3514220001',
    districtId: '3514220',
    name: 'Kebon Rejo',
  },
  {
    id: '3514220002',
    districtId: '3514220',
    name: 'Karang Lo',
  },
  {
    id: '3514220003',
    districtId: '3514220',
    name: 'Rebalas',
  },
  {
    id: '3514220004',
    districtId: '3514220',
    name: 'Plososari',
  },
  {
    id: '3514220005',
    districtId: '3514220',
    name: 'Grati Tunon',
  },
  {
    id: '3514220006',
    districtId: '3514220',
    name: 'Kalipang',
  },
  {
    id: '3514220008',
    districtId: '3514220',
    name: 'Kambingan Rejo',
  },
  {
    id: '3514220009',
    districtId: '3514220',
    name: 'Karang Kliwon',
  },
  {
    id: '3514220010',
    districtId: '3514220',
    name: 'Kedawung Kulon',
  },
  {
    id: '3514220011',
    districtId: '3514220',
    name: 'Kedawung Wetan',
  },
  {
    id: '3514220012',
    districtId: '3514220',
    name: 'Sumber Agung',
  },
  {
    id: '3514220013',
    districtId: '3514220',
    name: 'Ranu Klindungan',
  },
  {
    id: '3514220014',
    districtId: '3514220',
    name: 'Sumber Dawesari',
  },
  {
    id: '3514220015',
    districtId: '3514220',
    name: 'Cukur Gondang',
  },
  {
    id: '3514230001',
    districtId: '3514230',
    name: 'Rowo Gempol',
  },
  {
    id: '3514230002',
    districtId: '3514230',
    name: 'Gejug Jati',
  },
  {
    id: '3514230003',
    districtId: '3514230',
    name: 'Alas Tlogo',
  },
  {
    id: '3514230004',
    districtId: '3514230',
    name: 'Balung Anyar',
  },
  {
    id: '3514230005',
    districtId: '3514230',
    name: 'Branang',
  },
  {
    id: '3514230006',
    districtId: '3514230',
    name: 'Tampung',
  },
  {
    id: '3514230007',
    districtId: '3514230',
    name: 'Tambak Lekok',
  },
  {
    id: '3514230008',
    districtId: '3514230',
    name: 'Jatirejo',
  },
  {
    id: '3514230009',
    districtId: '3514230',
    name: 'Pasinan',
  },
  {
    id: '3514230010',
    districtId: '3514230',
    name: 'Wates',
  },
  {
    id: '3514230011',
    districtId: '3514230',
    name: 'Semedusari',
  },
  {
    id: '3514240001',
    districtId: '3514240',
    name: 'Sang Anom',
  },
  {
    id: '3514240002',
    districtId: '3514240',
    name: 'Sebalong',
  },
  {
    id: '3514240003',
    districtId: '3514240',
    name: 'Wot Galih',
  },
  {
    id: '3514240004',
    districtId: '3514240',
    name: 'Wates Tani',
  },
  {
    id: '3514240005',
    districtId: '3514240',
    name: 'Sedarum',
  },
  {
    id: '3514240006',
    districtId: '3514240',
    name: 'Dandang Gendis',
  },
  {
    id: '3514240007',
    districtId: '3514240',
    name: 'Sumber Anyar',
  },
  {
    id: '3514240008',
    districtId: '3514240',
    name: 'Sudimulyo',
  },
  {
    id: '3514240009',
    districtId: '3514240',
    name: 'Nguling',
  },
  {
    id: '3514240011',
    districtId: '3514240',
    name: 'Mlaten',
  },
  {
    id: '3514240012',
    districtId: '3514240',
    name: 'Kedawang',
  },
  {
    id: '3514240013',
    districtId: '3514240',
    name: 'Randuati',
  },
  {
    id: '3514240014',
    districtId: '3514240',
    name: 'Kapasan',
  },
  {
    id: '3514240015',
    districtId: '3514240',
    name: 'Watuprapat',
  },
  {
    id: '3515010001',
    districtId: '3515010',
    name: 'Kramat Temenggung',
  },
  {
    id: '3515010002',
    districtId: '3515010',
    name: 'Mliriprowo',
  },
  {
    id: '3515010003',
    districtId: '3515010',
    name: 'Sebani',
  },
  {
    id: '3515010004',
    districtId: '3515010',
    name: 'Kedungbocok',
  },
  {
    id: '3515010005',
    districtId: '3515010',
    name: 'Singogalih',
  },
  {
    id: '3515010006',
    districtId: '3515010',
    name: 'Tarik',
  },
  {
    id: '3515010007',
    districtId: '3515010',
    name: 'Mergobener',
  },
  {
    id: '3515010008',
    districtId: '3515010',
    name: 'Mergosari',
  },
  {
    id: '3515010009',
    districtId: '3515010',
    name: 'Kendalsewu',
  },
  {
    id: '3515010010',
    districtId: '3515010',
    name: 'Klantingsari',
  },
  {
    id: '3515010011',
    districtId: '3515010',
    name: 'Kalimati',
  },
  {
    id: '3515010012',
    districtId: '3515010',
    name: 'Gempolklutuk',
  },
  {
    id: '3515010013',
    districtId: '3515010',
    name: 'Banjarwungu',
  },
  {
    id: '3515010014',
    districtId: '3515010',
    name: 'Kemuning',
  },
  {
    id: '3515010015',
    districtId: '3515010',
    name: 'Balongmacekan',
  },
  {
    id: '3515010016',
    districtId: '3515010',
    name: 'Gampingrowo',
  },
  {
    id: '3515010017',
    districtId: '3515010',
    name: 'Mindugading',
  },
  {
    id: '3515010018',
    districtId: '3515010',
    name: 'Janti',
  },
  {
    id: '3515010019',
    districtId: '3515010',
    name: 'Segodobancang',
  },
  {
    id: '3515010020',
    districtId: '3515010',
    name: 'Kedinding',
  },
  {
    id: '3515020001',
    districtId: '3515020',
    name: 'Prambon',
  },
  {
    id: '3515020002',
    districtId: '3515020',
    name: 'Kajartengguli',
  },
  {
    id: '3515020003',
    districtId: '3515020',
    name: 'Gedangrowo',
  },
  {
    id: '3515020004',
    districtId: '3515020',
    name: 'Wirobiting',
  },
  {
    id: '3515020005',
    districtId: '3515020',
    name: 'Simpang',
  },
  {
    id: '3515020006',
    districtId: '3515020',
    name: 'Bulang',
  },
  {
    id: '3515020007',
    districtId: '3515020',
    name: 'Gampang',
  },
  {
    id: '3515020008',
    districtId: '3515020',
    name: 'Jatikalang',
  },
  {
    id: '3515020009',
    districtId: '3515020',
    name: 'Pejangkungan',
  },
  {
    id: '3515020010',
    districtId: '3515020',
    name: 'Kedungsugo',
  },
  {
    id: '3515020011',
    districtId: '3515020',
    name: 'Kedungwonokerto',
  },
  {
    id: '3515020012',
    districtId: '3515020',
    name: 'Bendotretek',
  },
  {
    id: '3515020013',
    districtId: '3515020',
    name: 'Wono Plintahan',
  },
  {
    id: '3515020014',
    districtId: '3515020',
    name: 'Kedungkembar',
  },
  {
    id: '3515020015',
    districtId: '3515020',
    name: 'Jati Alun Alun',
  },
  {
    id: '3515020016',
    districtId: '3515020',
    name: 'Jedongcangkring',
  },
  {
    id: '3515020017',
    districtId: '3515020',
    name: 'Cangkringturi',
  },
  {
    id: '3515020018',
    districtId: '3515020',
    name: 'Simogirang',
  },
  {
    id: '3515020020',
    districtId: '3515020',
    name: 'Watutulis',
  },
  {
    id: '3515030001',
    districtId: '3515030',
    name: 'Tambakrejo',
  },
  {
    id: '3515030004',
    districtId: '3515030',
    name: 'Kedungrawan',
  },
  {
    id: '3515030005',
    districtId: '3515030',
    name: 'Tanjeg Wagir',
  },
  {
    id: '3515030006',
    districtId: '3515030',
    name: 'Mojoruntut',
  },
  {
    id: '3515030007',
    districtId: '3515030',
    name: 'Gading',
  },
  {
    id: '3515030008',
    districtId: '3515030',
    name: 'Wangkal',
  },
  {
    id: '3515030009',
    districtId: '3515030',
    name: 'Jenggot',
  },
  {
    id: '3515030010',
    districtId: '3515030',
    name: 'Waung',
  },
  {
    id: '3515030011',
    districtId: '3515030',
    name: 'Ploso',
  },
  {
    id: '3515030012',
    districtId: '3515030',
    name: 'Rejeni',
  },
  {
    id: '3515030013',
    districtId: '3515030',
    name: 'Kandangan',
  },
  {
    id: '3515030016',
    districtId: '3515030',
    name: 'Cangkring',
  },
  {
    id: '3515030018',
    districtId: '3515030',
    name: 'Wonomlati',
  },
  {
    id: '3515030019',
    districtId: '3515030',
    name: 'Balonggarut',
  },
  {
    id: '3515040001',
    districtId: '3515040',
    name: 'Kebonagung',
  },
  {
    id: '3515040002',
    districtId: '3515040',
    name: 'Porong',
  },
  {
    id: '3515040003',
    districtId: '3515040',
    name: 'Mindi',
  },
  {
    id: '3515040004',
    districtId: '3515040',
    name: 'Jatirejo',
  },
  {
    id: '3515040005',
    districtId: '3515040',
    name: 'Renokenongo',
  },
  {
    id: '3515040006',
    districtId: '3515040',
    name: 'Glagah Arum',
  },
  {
    id: '3515040007',
    districtId: '3515040',
    name: 'Plumbon',
  },
  {
    id: '3515040008',
    districtId: '3515040',
    name: 'Siring',
  },
  {
    id: '3515040009',
    districtId: '3515040',
    name: 'Gedang',
  },
  {
    id: '3515040010',
    districtId: '3515040',
    name: 'Juwet Kenongo',
  },
  {
    id: '3515040011',
    districtId: '3515040',
    name: 'Kedungsolo',
  },
  {
    id: '3515040012',
    districtId: '3515040',
    name: 'Kebakalan',
  },
  {
    id: '3515040013',
    districtId: '3515040',
    name: 'Kesambi',
  },
  {
    id: '3515040014',
    districtId: '3515040',
    name: 'Pamotan',
  },
  {
    id: '3515040016',
    districtId: '3515040',
    name: 'Candipari',
  },
  {
    id: '3515040017',
    districtId: '3515040',
    name: 'Lajuk',
  },
  {
    id: '3515040018',
    districtId: '3515040',
    name: 'Kedungboto',
  },
  {
    id: '3515040019',
    districtId: '3515040',
    name: 'Pesawahan',
  },
  {
    id: '3515050001',
    districtId: '3515050',
    name: 'Panggreh',
  },
  {
    id: '3515050002',
    districtId: '3515050',
    name: 'Trompoasri',
  },
  {
    id: '3515050003',
    districtId: '3515050',
    name: 'Kedungrejo',
  },
  {
    id: '3515050004',
    districtId: '3515050',
    name: 'Kedungpandan',
  },
  {
    id: '3515050005',
    districtId: '3515050',
    name: 'Semambung',
  },
  {
    id: '3515050006',
    districtId: '3515050',
    name: 'Kupang',
  },
  {
    id: '3515050007',
    districtId: '3515050',
    name: 'Tambak Kalisogo',
  },
  {
    id: '3515050008',
    districtId: '3515050',
    name: 'Balongtani',
  },
  {
    id: '3515050009',
    districtId: '3515050',
    name: 'Jemirahan',
  },
  {
    id: '3515050010',
    districtId: '3515050',
    name: 'Dukuhsari',
  },
  {
    id: '3515050011',
    districtId: '3515050',
    name: 'Kedungcangkring',
  },
  {
    id: '3515050012',
    districtId: '3515050',
    name: 'Pejarakan',
  },
  {
    id: '3515050013',
    districtId: '3515050',
    name: 'Besuki',
  },
  {
    id: '3515050014',
    districtId: '3515050',
    name: 'Keboguyang',
  },
  {
    id: '3515050015',
    districtId: '3515050',
    name: 'Permisan',
  },
  {
    id: '3515060001',
    districtId: '3515060',
    name: 'Randegan',
  },
  {
    id: '3515060002',
    districtId: '3515060',
    name: 'Kedensari',
  },
  {
    id: '3515060003',
    districtId: '3515060',
    name: 'Kalisampurno',
  },
  {
    id: '3515060004',
    districtId: '3515060',
    name: 'Ketapang',
  },
  {
    id: '3515060005',
    districtId: '3515060',
    name: 'Kedungbendo',
  },
  {
    id: '3515060006',
    districtId: '3515060',
    name: 'Gempolsari',
  },
  {
    id: '3515060008',
    districtId: '3515060',
    name: 'Penatarsewu',
  },
  {
    id: '3515060009',
    districtId: '3515060',
    name: 'Banjarasri',
  },
  {
    id: '3515060010',
    districtId: '3515060',
    name: 'Banjarpanji',
  },
  {
    id: '3515060011',
    districtId: '3515060',
    name: 'Kedungbanteng',
  },
  {
    id: '3515060012',
    districtId: '3515060',
    name: 'Kalidawir',
  },
  {
    id: '3515060013',
    districtId: '3515060',
    name: 'Putat',
  },
  {
    id: '3515060014',
    districtId: '3515060',
    name: 'Ngaban',
  },
  {
    id: '3515060015',
    districtId: '3515060',
    name: 'Kalitengah',
  },
  {
    id: '3515060016',
    districtId: '3515060',
    name: 'Kludan',
  },
  {
    id: '3515060017',
    districtId: '3515060',
    name: 'Boro',
  },
  {
    id: '3515060018',
    districtId: '3515060',
    name: 'Ketegan',
  },
  {
    id: '3515060019',
    districtId: '3515060',
    name: 'Ganggang Panjang',
  },
  {
    id: '3515070001',
    districtId: '3515070',
    name: 'Karangtanjung',
  },
  {
    id: '3515070002',
    districtId: '3515070',
    name: 'Sumorame',
  },
  {
    id: '3515070003',
    districtId: '3515070',
    name: 'Ngampelsari',
  },
  {
    id: '3515070004',
    districtId: '3515070',
    name: 'Balonggabus',
  },
  {
    id: '3515070005',
    districtId: '3515070',
    name: 'Balongdowo',
  },
  {
    id: '3515070006',
    districtId: '3515070',
    name: 'Kendalpecabean',
  },
  {
    id: '3515070008',
    districtId: '3515070',
    name: 'Kalipecabean',
  },
  {
    id: '3515070009',
    districtId: '3515070',
    name: 'Klurak',
  },
  {
    id: '3515070010',
    districtId: '3515070',
    name: 'Kebonsari',
  },
  {
    id: '3515070011',
    districtId: '3515070',
    name: 'Gelam',
  },
  {
    id: '3515070012',
    districtId: '3515070',
    name: 'Candi',
  },
  {
    id: '3515070013',
    districtId: '3515070',
    name: 'Sugih Waras',
  },
  {
    id: '3515070014',
    districtId: '3515070',
    name: 'Kedungkendo',
  },
  {
    id: '3515070015',
    districtId: '3515070',
    name: 'Durungbanjar',
  },
  {
    id: '3515070017',
    districtId: '3515070',
    name: 'Jambangan',
  },
  {
    id: '3515070018',
    districtId: '3515070',
    name: 'Sumokali',
  },
  {
    id: '3515070019',
    districtId: '3515070',
    name: 'Tenggulunan',
  },
  {
    id: '3515070020',
    districtId: '3515070',
    name: 'Bligo',
  },
  {
    id: '3515070021',
    districtId: '3515070',
    name: 'Wedoro Klurak',
  },
  {
    id: '3515070022',
    districtId: '3515070',
    name: 'Larangan',
  },
  {
    id: '3515070023',
    districtId: '3515070',
    name: 'Sepande',
  },
  {
    id: '3515070024',
    districtId: '3515070',
    name: 'Sidodadi',
  },
  {
    id: '3515080001',
    districtId: '3515080',
    name: 'Janti',
  },
  {
    id: '3515080002',
    districtId: '3515080',
    name: 'Kebaron',
  },
  {
    id: '3515080003',
    districtId: '3515080',
    name: 'Kenongo',
  },
  {
    id: '3515080004',
    districtId: '3515080',
    name: 'Gelang',
  },
  {
    id: '3515080005',
    districtId: '3515080',
    name: 'Jiken',
  },
  {
    id: '3515080006',
    districtId: '3515080',
    name: 'Pangkemiri',
  },
  {
    id: '3515080007',
    districtId: '3515080',
    name: 'Kepatihan',
  },
  {
    id: '3515080008',
    districtId: '3515080',
    name: 'Tulangan',
  },
  {
    id: '3515080009',
    districtId: '3515080',
    name: 'Kepadangan',
  },
  {
    id: '3515080010',
    districtId: '3515080',
    name: 'Tlasih',
  },
  {
    id: '3515080011',
    districtId: '3515080',
    name: 'Kajeksan',
  },
  {
    id: '3515080012',
    districtId: '3515080',
    name: 'Singopadu',
  },
  {
    id: '3515080013',
    districtId: '3515080',
    name: 'Kemantren',
  },
  {
    id: '3515080014',
    districtId: '3515080',
    name: 'Medalem',
  },
  {
    id: '3515080015',
    districtId: '3515080',
    name: 'Sudimoro',
  },
  {
    id: '3515080016',
    districtId: '3515080',
    name: 'Kedondong',
  },
  {
    id: '3515080017',
    districtId: '3515080',
    name: 'Grogol',
  },
  {
    id: '3515080018',
    districtId: '3515080',
    name: 'Modong',
  },
  {
    id: '3515080019',
    districtId: '3515080',
    name: 'Grinting',
  },
  {
    id: '3515080020',
    districtId: '3515080',
    name: 'Kepuh Kemiri',
  },
  {
    id: '3515080022',
    districtId: '3515080',
    name: 'Grabagan',
  },
  {
    id: '3515090001',
    districtId: '3515090',
    name: 'Simoketawang',
  },
  {
    id: '3515090002',
    districtId: '3515090',
    name: 'Popoh',
  },
  {
    id: '3515090003',
    districtId: '3515090',
    name: 'Jimbaran Wetan',
  },
  {
    id: '3515090004',
    districtId: '3515090',
    name: 'Ketimang',
  },
  {
    id: '3515090005',
    districtId: '3515090',
    name: 'Pilang',
  },
  {
    id: '3515090006',
    districtId: '3515090',
    name: 'Sumberejo',
  },
  {
    id: '3515090007',
    districtId: '3515090',
    name: 'Mojorangagung',
  },
  {
    id: '3515090008',
    districtId: '3515090',
    name: 'Wonokasian',
  },
  {
    id: '3515090009',
    districtId: '3515090',
    name: 'Ploso',
  },
  {
    id: '3515090010',
    districtId: '3515090',
    name: 'Jimbaran Kulon',
  },
  {
    id: '3515090011',
    districtId: '3515090',
    name: 'Wonoayu',
  },
  {
    id: '3515090012',
    districtId: '3515090',
    name: 'Semambung',
  },
  {
    id: '3515090013',
    districtId: '3515090',
    name: 'Simo Angin Angin',
  },
  {
    id: '3515090014',
    districtId: '3515090',
    name: 'Tanggul',
  },
  {
    id: '3515090015',
    districtId: '3515090',
    name: 'Wonokalang',
  },
  {
    id: '3515090016',
    districtId: '3515090',
    name: 'Pagerngumbuk',
  },
  {
    id: '3515090017',
    districtId: '3515090',
    name: 'Plaosan',
  },
  {
    id: '3515090018',
    districtId: '3515090',
    name: 'Mulyodadi',
  },
  {
    id: '3515090019',
    districtId: '3515090',
    name: 'Lambangan',
  },
  {
    id: '3515090020',
    districtId: '3515090',
    name: 'Sawocangkring',
  },
  {
    id: '3515090021',
    districtId: '3515090',
    name: 'Becirongengor',
  },
  {
    id: '3515090022',
    districtId: '3515090',
    name: 'Karangpuri',
  },
  {
    id: '3515090023',
    districtId: '3515090',
    name: 'Candinegoro',
  },
  {
    id: '3515100001',
    districtId: '3515100',
    name: 'Wilayut',
  },
  {
    id: '3515100002',
    districtId: '3515100',
    name: 'Kebonagung',
  },
  {
    id: '3515100003',
    districtId: '3515100',
    name: 'Anggaswangi',
  },
  {
    id: '3515100004',
    districtId: '3515100',
    name: 'Jumputrejo',
  },
  {
    id: '3515100006',
    districtId: '3515100',
    name: 'Pekarungan',
  },
  {
    id: '3515100007',
    districtId: '3515100',
    name: 'Pademonegoro',
  },
  {
    id: '3515100008',
    districtId: '3515100',
    name: 'Cangkringsari',
  },
  {
    id: '3515100009',
    districtId: '3515100',
    name: 'Jogosatru',
  },
  {
    id: '3515100010',
    districtId: '3515100',
    name: 'Ngaresrejo',
  },
  {
    id: '3515100011',
    districtId: '3515100',
    name: 'Sambungrejo',
  },
  {
    id: '3515100012',
    districtId: '3515100',
    name: 'Plumbungan',
  },
  {
    id: '3515100013',
    districtId: '3515100',
    name: 'Sukodono',
  },
  {
    id: '3515100014',
    districtId: '3515100',
    name: 'Keloposepuluh',
  },
  {
    id: '3515100015',
    districtId: '3515100',
    name: 'Masangan Wetan',
  },
  {
    id: '3515100016',
    districtId: '3515100',
    name: 'Suko',
  },
  {
    id: '3515100017',
    districtId: '3515100',
    name: 'Masangan Kulon',
  },
  {
    id: '3515100018',
    districtId: '3515100',
    name: 'Panjunan',
  },
  {
    id: '3515100019',
    districtId: '3515100',
    name: 'Bangsri',
  },
  {
    id: '3515110001',
    districtId: '3515110',
    name: 'Lebo',
  },
  {
    id: '3515110002',
    districtId: '3515110',
    name: 'Suko',
  },
  {
    id: '3515110003',
    districtId: '3515110',
    name: 'Banjarbendo',
  },
  {
    id: '3515110004',
    districtId: '3515110',
    name: 'Lemahputro',
  },
  {
    id: '3515110005',
    districtId: '3515110',
    name: 'Sidokare',
  },
  {
    id: '3515110007',
    districtId: '3515110',
    name: 'Sekardangan',
  },
  {
    id: '3515110008',
    districtId: '3515110',
    name: 'Gebang',
  },
  {
    id: '3515110009',
    districtId: '3515110',
    name: 'Rangkahkidul',
  },
  {
    id: '3515110010',
    districtId: '3515110',
    name: 'Bulusidokare',
  },
  {
    id: '3515110011',
    districtId: '3515110',
    name: 'Pucanganom',
  },
  {
    id: '3515110012',
    districtId: '3515110',
    name: 'Pekauman',
  },
  {
    id: '3515110013',
    districtId: '3515110',
    name: 'Sidokumpul',
  },
  {
    id: '3515110014',
    districtId: '3515110',
    name: 'Sidoklumpuk',
  },
  {
    id: '3515110015',
    districtId: '3515110',
    name: 'Bluru Kidul',
  },
  {
    id: '3515110016',
    districtId: '3515110',
    name: 'Kemiri',
  },
  {
    id: '3515110017',
    districtId: '3515110',
    name: 'Pucang',
  },
  {
    id: '3515110018',
    districtId: '3515110',
    name: 'Magersari',
  },
  {
    id: '3515110019',
    districtId: '3515110',
    name: 'Jati',
  },
  {
    id: '3515110020',
    districtId: '3515110',
    name: 'Cemeng Kalang',
  },
  {
    id: '3515110021',
    districtId: '3515110',
    name: 'Cemeng Bakalan',
  },
  {
    id: '3515110022',
    districtId: '3515110',
    name: 'Urangagung Jedong',
  },
  {
    id: '3515110023',
    districtId: '3515110',
    name: 'Sari Rogo',
  },
  {
    id: '3515120001',
    districtId: '3515120',
    name: 'Entalsewu',
  },
  {
    id: '3515120002',
    districtId: '3515120',
    name: 'Pagerwojo',
  },
  {
    id: '3515120003',
    districtId: '3515120',
    name: 'Sidokerto',
  },
  {
    id: '3515120004',
    districtId: '3515120',
    name: 'Buduran',
  },
  {
    id: '3515120005',
    districtId: '3515120',
    name: 'Siwalan Panji',
  },
  {
    id: '3515120006',
    districtId: '3515120',
    name: 'Sidomulyo',
  },
  {
    id: '3515120007',
    districtId: '3515120',
    name: 'Prasung',
  },
  {
    id: '3515120008',
    districtId: '3515120',
    name: 'Sawohan',
  },
  {
    id: '3515120009',
    districtId: '3515120',
    name: 'Damarsi',
  },
  {
    id: '3515120010',
    districtId: '3515120',
    name: 'Dukuhtengah',
  },
  {
    id: '3515120011',
    districtId: '3515120',
    name: 'Banjarsari',
  },
  {
    id: '3515120012',
    districtId: '3515120',
    name: 'Wadungasih',
  },
  {
    id: '3515120013',
    districtId: '3515120',
    name: 'Banjarkemantren',
  },
  {
    id: '3515120014',
    districtId: '3515120',
    name: 'Sukorejo',
  },
  {
    id: '3515120015',
    districtId: '3515120',
    name: 'Sidokepung',
  },
  {
    id: '3515130001',
    districtId: '3515130',
    name: 'Kwangsan',
  },
  {
    id: '3515130003',
    districtId: '3515130',
    name: 'Buncitan',
  },
  {
    id: '3515130004',
    districtId: '3515130',
    name: 'Kalanganyar',
  },
  {
    id: '3515130005',
    districtId: '3515130',
    name: 'Tambak Cemandi',
  },
  {
    id: '3515130006',
    districtId: '3515130',
    name: 'Gisik Cemandi',
  },
  {
    id: '3515130007',
    districtId: '3515130',
    name: 'Cemandi',
  },
  {
    id: '3515130008',
    districtId: '3515130',
    name: 'Pulungan',
  },
  {
    id: '3515130009',
    districtId: '3515130',
    name: 'Betro',
  },
  {
    id: '3515130010',
    districtId: '3515130',
    name: 'Sedati Agung',
  },
  {
    id: '3515130011',
    districtId: '3515130',
    name: 'Sedati Gede',
  },
  {
    id: '3515130012',
    districtId: '3515130',
    name: 'Pabean',
  },
  {
    id: '3515130013',
    districtId: '3515130',
    name: 'Semampir',
  },
  {
    id: '3515130014',
    districtId: '3515130',
    name: 'Pranti',
  },
  {
    id: '3515130015',
    districtId: '3515130',
    name: 'Segoro Tambak',
  },
  {
    id: '3515130016',
    districtId: '3515130',
    name: 'Banjar Kemuning',
  },
  {
    id: '3515140001',
    districtId: '3515140',
    name: 'Medaeng',
  },
  {
    id: '3515140002',
    districtId: '3515140',
    name: 'Pepelegi',
  },
  {
    id: '3515140003',
    districtId: '3515140',
    name: 'Waru',
  },
  {
    id: '3515140004',
    districtId: '3515140',
    name: 'Kureksari',
  },
  {
    id: '3515140005',
    districtId: '3515140',
    name: 'Ngingas',
  },
  {
    id: '3515140006',
    districtId: '3515140',
    name: 'Tropodo',
  },
  {
    id: '3515140007',
    districtId: '3515140',
    name: 'Tambak Sawah',
  },
  {
    id: '3515140008',
    districtId: '3515140',
    name: 'Tambak Rejo',
  },
  {
    id: '3515140009',
    districtId: '3515140',
    name: 'Tambak Oso',
  },
  {
    id: '3515140010',
    districtId: '3515140',
    name: 'Tambak Sumur',
  },
  {
    id: '3515140011',
    districtId: '3515140',
    name: 'Wadungasri',
  },
  {
    id: '3515140013',
    districtId: '3515140',
    name: 'Kepuh Kiriman',
  },
  {
    id: '3515140014',
    districtId: '3515140',
    name: 'Wedoro',
  },
  {
    id: '3515140015',
    districtId: '3515140',
    name: 'Janti',
  },
  {
    id: '3515140016',
    districtId: '3515140',
    name: 'Kedungrejo',
  },
  {
    id: '3515140017',
    districtId: '3515140',
    name: 'Bungurasih',
  },
  {
    id: '3515150001',
    districtId: '3515150',
    name: 'Ganting',
  },
  {
    id: '3515150002',
    districtId: '3515150',
    name: 'Karangbong',
  },
  {
    id: '3515150004',
    districtId: '3515150',
    name: 'Kragan',
  },
  {
    id: '3515150007',
    districtId: '3515150',
    name: 'Sruni',
  },
  {
    id: '3515150008',
    districtId: '3515150',
    name: 'Keboananom',
  },
  {
    id: '3515150009',
    districtId: '3515150',
    name: 'Keboansikep',
  },
  {
    id: '3515150010',
    districtId: '3515150',
    name: 'Gedangan',
  },
  {
    id: '3515150011',
    districtId: '3515150',
    name: 'Ketajen',
  },
  {
    id: '3515150012',
    districtId: '3515150',
    name: 'Wedi',
  },
  {
    id: '3515150013',
    districtId: '3515150',
    name: 'Semambung',
  },
  {
    id: '3515150014',
    districtId: '3515150',
    name: 'Sawotratap',
  },
  {
    id: '3515150015',
    districtId: '3515150',
    name: 'Bangah',
  },
  {
    id: '3515160001',
    districtId: '3515160',
    name: 'Kramat Jegu',
  },
  {
    id: '3515160002',
    districtId: '3515160',
    name: 'Trosobo',
  },
  {
    id: '3515160003',
    districtId: '3515160',
    name: 'Pertapan Maduretno',
  },
  {
    id: '3515160004',
    districtId: '3515160',
    name: 'Tanjungsari',
  },
  {
    id: '3515160005',
    districtId: '3515160',
    name: 'Sidodadi',
  },
  {
    id: '3515160006',
    districtId: '3515160',
    name: 'Bringinbendo',
  },
  {
    id: '3515160007',
    districtId: '3515160',
    name: 'Sambi Bulu',
  },
  {
    id: '3515160008',
    districtId: '3515160',
    name: 'Gilang',
  },
  {
    id: '3515160009',
    districtId: '3515160',
    name: 'Krembangan',
  },
  {
    id: '3515160010',
    districtId: '3515160',
    name: 'Tawangsari',
  },
  {
    id: '3515160012',
    districtId: '3515160',
    name: 'Jemundo',
  },
  {
    id: '3515160013',
    districtId: '3515160',
    name: 'Sadang',
  },
  {
    id: '3515160014',
    districtId: '3515160',
    name: 'Geluran',
  },
  {
    id: '3515160015',
    districtId: '3515160',
    name: 'Bohar',
  },
  {
    id: '3515160016',
    districtId: '3515160',
    name: 'Wage',
  },
  {
    id: '3515160017',
    districtId: '3515160',
    name: 'Kedungturi',
  },
  {
    id: '3515160018',
    districtId: '3515160',
    name: 'Taman',
  },
  {
    id: '3515160019',
    districtId: '3515160',
    name: 'Kalijaten',
  },
  {
    id: '3515160020',
    districtId: '3515160',
    name: 'Ngelom',
  },
  {
    id: '3515160021',
    districtId: '3515160',
    name: 'Wonocolo',
  },
  {
    id: '3515160022',
    districtId: '3515160',
    name: 'Ketegan',
  },
  {
    id: '3515160023',
    districtId: '3515160',
    name: 'Bebekan',
  },
  {
    id: '3515160024',
    districtId: '3515160',
    name: 'Sepanjang',
  },
  {
    id: '3515170001',
    districtId: '3515170',
    name: 'Tropodo',
  },
  {
    id: '3515170002',
    districtId: '3515170',
    name: 'Sedengan Mijen',
  },
  {
    id: '3515170003',
    districtId: '3515170',
    name: 'Katrungan',
  },
  {
    id: '3515170004',
    districtId: '3515170',
    name: 'Jeruk Gamping',
  },
  {
    id: '3515170005',
    districtId: '3515170',
    name: 'Gamping',
  },
  {
    id: '3515170006',
    districtId: '3515170',
    name: 'Terik',
  },
  {
    id: '3515170007',
    districtId: '3515170',
    name: 'Junwangi',
  },
  {
    id: '3515170008',
    districtId: '3515170',
    name: 'Terung Kulon',
  },
  {
    id: '3515170009',
    districtId: '3515170',
    name: 'Terung Wetan',
  },
  {
    id: '3515170010',
    districtId: '3515170',
    name: 'Jatikalang',
  },
  {
    id: '3515170011',
    districtId: '3515170',
    name: 'Keboharan',
  },
  {
    id: '3515170012',
    districtId: '3515170',
    name: 'Ponokawan',
  },
  {
    id: '3515170013',
    districtId: '3515170',
    name: 'Kemasan',
  },
  {
    id: '3515170014',
    districtId: '3515170',
    name: 'Sidomojo',
  },
  {
    id: '3515170015',
    districtId: '3515170',
    name: 'Tambak Kemerakan',
  },
  {
    id: '3515170016',
    districtId: '3515170',
    name: 'Krian',
  },
  {
    id: '3515170017',
    districtId: '3515170',
    name: 'Kraton',
  },
  {
    id: '3515170018',
    districtId: '3515170',
    name: 'Sidomulyo',
  },
  {
    id: '3515170020',
    districtId: '3515170',
    name: 'Watugolong',
  },
  {
    id: '3515170021',
    districtId: '3515170',
    name: 'Barengkrajan',
  },
  {
    id: '3515170022',
    districtId: '3515170',
    name: 'Sidorejo',
  },
  {
    id: '3515180001',
    districtId: '3515180',
    name: 'Singkalan',
  },
  {
    id: '3515180002',
    districtId: '3515180',
    name: 'Kedung Sukodani',
  },
  {
    id: '3515180003',
    districtId: '3515180',
    name: 'Bakung Temenggungan',
  },
  {
    id: '3515180004',
    districtId: '3515180',
    name: 'Sumokembangsri',
  },
  {
    id: '3515180005',
    districtId: '3515180',
    name: 'Seduri',
  },
  {
    id: '3515180006',
    districtId: '3515180',
    name: 'Wonokupang',
  },
  {
    id: '3515180007',
    districtId: '3515180',
    name: 'Waruberon',
  },
  {
    id: '3515180008',
    districtId: '3515180',
    name: 'Bakalan Wringinpitu',
  },
  {
    id: '3515180009',
    districtId: '3515180',
    name: 'Gagang Kepuhsari',
  },
  {
    id: '3515180010',
    districtId: '3515180',
    name: 'Suwaluh',
  },
  {
    id: '3515180011',
    districtId: '3515180',
    name: 'Watesari',
  },
  {
    id: '3515180012',
    districtId: '3515180',
    name: 'Seketi',
  },
  {
    id: '3515180013',
    districtId: '3515180',
    name: 'Kemangsen',
  },
  {
    id: '3515180014',
    districtId: '3515180',
    name: 'Jabaran',
  },
  {
    id: '3515180015',
    districtId: '3515180',
    name: 'Balongbendo',
  },
  {
    id: '3515180016',
    districtId: '3515180',
    name: 'Jeruk Legi',
  },
  {
    id: '3515180017',
    districtId: '3515180',
    name: 'Penambangan',
  },
  {
    id: '3515180018',
    districtId: '3515180',
    name: 'Wonokarang',
  },
  {
    id: '3515180019',
    districtId: '3515180',
    name: 'Bakung Pringgodani',
  },
  {
    id: '3515180020',
    districtId: '3515180',
    name: 'Bogem Pinggir',
  },
  {
    id: '3516010001',
    districtId: '3516010',
    name: 'Tawangrejo',
  },
  {
    id: '3516010002',
    districtId: '3516010',
    name: 'Rejosari',
  },
  {
    id: '3516010004',
    districtId: '3516010',
    name: 'Manting',
  },
  {
    id: '3516010005',
    districtId: '3516010',
    name: 'Sumberjati',
  },
  {
    id: '3516010006',
    districtId: '3516010',
    name: 'Lebakjabung',
  },
  {
    id: '3516010007',
    districtId: '3516010',
    name: 'Bleberan',
  },
  {
    id: '3516010008',
    districtId: '3516010',
    name: 'Sumberagung',
  },
  {
    id: '3516010009',
    districtId: '3516010',
    name: 'Baureno',
  },
  {
    id: '3516010010',
    districtId: '3516010',
    name: 'Jatirejo',
  },
  {
    id: '3516010011',
    districtId: '3516010',
    name: 'Dukuhngarjo',
  },
  {
    id: '3516010012',
    districtId: '3516010',
    name: 'Gading',
  },
  {
    id: '3516010013',
    districtId: '3516010',
    name: 'Kumitir',
  },
  {
    id: '3516010014',
    districtId: '3516010',
    name: 'Sumengko',
  },
  {
    id: '3516010015',
    districtId: '3516010',
    name: 'Gebangsari',
  },
  {
    id: '3516010016',
    districtId: '3516010',
    name: 'Dinoyo',
  },
  {
    id: '3516010017',
    districtId: '3516010',
    name: 'Padangasri',
  },
  {
    id: '3516010018',
    districtId: '3516010',
    name: 'Mojogeneng',
  },
  {
    id: '3516010019',
    districtId: '3516010',
    name: 'Karangjeruk',
  },
  {
    id: '3516020001',
    districtId: '3516020',
    name: 'Ngembat',
  },
  {
    id: '3516020002',
    districtId: '3516020',
    name: 'Jatidukuh',
  },
  {
    id: '3516020003',
    districtId: '3516020',
    name: 'Kalikatir',
  },
  {
    id: '3516020004',
    districtId: '3516020',
    name: 'Dilem',
  },
  {
    id: '3516020005',
    districtId: '3516020',
    name: 'Begaganlimo',
  },
  {
    id: '3516020007',
    districtId: '3516020',
    name: 'Kemasantani',
  },
  {
    id: '3516020008',
    districtId: '3516020',
    name: 'Padi',
  },
  {
    id: '3516020009',
    districtId: '3516020',
    name: 'Centong',
  },
  {
    id: '3516020010',
    districtId: '3516020',
    name: 'Bakalan',
  },
  {
    id: '3516020011',
    districtId: '3516020',
    name: 'Gondang',
  },
  {
    id: '3516020012',
    districtId: '3516020',
    name: 'Pugeran',
  },
  {
    id: '3516020013',
    districtId: '3516020',
    name: 'Kebontunggul',
  },
  {
    id: '3516020014',
    districtId: '3516020',
    name: 'Wonoploso',
  },
  {
    id: '3516020015',
    districtId: '3516020',
    name: 'Pohjejer',
  },
  {
    id: '3516020016',
    districtId: '3516020',
    name: 'Bening',
  },
  {
    id: '3516020017',
    districtId: '3516020',
    name: 'Karangkuten',
  },
  {
    id: '3516020018',
    districtId: '3516020',
    name: 'Tawar',
  },
  {
    id: '3516030001',
    districtId: '3516030',
    name: 'Kemiri',
  },
  {
    id: '3516030002',
    districtId: '3516030',
    name: 'Sajen',
  },
  {
    id: '3516030003',
    districtId: '3516030',
    name: 'Pacet',
  },
  {
    id: '3516030004',
    districtId: '3516030',
    name: 'Padusan',
  },
  {
    id: '3516030005',
    districtId: '3516030',
    name: 'Cepokolimo',
  },
  {
    id: '3516030006',
    districtId: '3516030',
    name: 'Claket',
  },
  {
    id: '3516030007',
    districtId: '3516030',
    name: 'Cembor',
  },
  {
    id: '3516030008',
    districtId: '3516030',
    name: 'Nogosari',
  },
  {
    id: '3516030009',
    districtId: '3516030',
    name: 'Kembangbelor',
  },
  {
    id: '3516030010',
    districtId: '3516030',
    name: 'Mojokembang',
  },
  {
    id: '3516030011',
    districtId: '3516030',
    name: 'Bendunganjati',
  },
  {
    id: '3516030012',
    districtId: '3516030',
    name: 'Petak',
  },
  {
    id: '3516030013',
    districtId: '3516030',
    name: 'Kesimantengah',
  },
  {
    id: '3516030014',
    districtId: '3516030',
    name: 'Wiyu',
  },
  {
    id: '3516030015',
    districtId: '3516030',
    name: 'Candiwatu',
  },
  {
    id: '3516030016',
    districtId: '3516030',
    name: 'Warugunung',
  },
  {
    id: '3516030017',
    districtId: '3516030',
    name: 'Tanjungkenongo',
  },
  {
    id: '3516030018',
    districtId: '3516030',
    name: 'Sumberkembar',
  },
  {
    id: '3516030019',
    districtId: '3516030',
    name: 'Kuripansari',
  },
  {
    id: '3516030020',
    districtId: '3516030',
    name: 'Pandanarum',
  },
  {
    id: '3516040001',
    districtId: '3516040',
    name: 'Ketapanrame',
  },
  {
    id: '3516040002',
    districtId: '3516040',
    name: 'Trawas',
  },
  {
    id: '3516040003',
    districtId: '3516040',
    name: 'Selotapak',
  },
  {
    id: '3516040004',
    districtId: '3516040',
    name: 'Tamiajeng',
  },
  {
    id: '3516040005',
    districtId: '3516040',
    name: 'Kesiman',
  },
  {
    id: '3516040006',
    districtId: '3516040',
    name: 'Belik',
  },
  {
    id: '3516040008',
    districtId: '3516040',
    name: 'Penanggungan',
  },
  {
    id: '3516040009',
    districtId: '3516040',
    name: 'Kedungudi',
  },
  {
    id: '3516040010',
    districtId: '3516040',
    name: 'Sukosari',
  },
  {
    id: '3516040011',
    districtId: '3516040',
    name: 'Jatijejer',
  },
  {
    id: '3516040013',
    districtId: '3516040',
    name: 'Seloliman',
  },
  {
    id: '3516050002',
    districtId: '3516050',
    name: 'Srigading',
  },
  {
    id: '3516050003',
    districtId: '3516050',
    name: 'Kutogirang',
  },
  {
    id: '3516050004',
    districtId: '3516050',
    name: 'Lolawang',
  },
  {
    id: '3516050005',
    districtId: '3516050',
    name: 'Wotanmasjedong',
  },
  {
    id: '3516050006',
    districtId: '3516050',
    name: 'Manduromanggunggaja',
  },
  {
    id: '3516050007',
    districtId: '3516050',
    name: 'Kunjorowesi',
  },
  {
    id: '3516050008',
    districtId: '3516050',
    name: 'Watesnegoro',
  },
  {
    id: '3516050009',
    districtId: '3516050',
    name: 'Wonosari',
  },
  {
    id: '3516050010',
    districtId: '3516050',
    name: 'Ngoro',
  },
  {
    id: '3516050011',
    districtId: '3516050',
    name: 'Sedati',
  },
  {
    id: '3516050012',
    districtId: '3516050',
    name: 'Purwojati',
  },
  {
    id: '3516050013',
    districtId: '3516050',
    name: 'Jasem',
  },
  {
    id: '3516050014',
    districtId: '3516050',
    name: 'Kembangsri',
  },
  {
    id: '3516050015',
    districtId: '3516050',
    name: 'Candiharjo',
  },
  {
    id: '3516050016',
    districtId: '3516050',
    name: 'Tambakrejo',
  },
  {
    id: '3516050017',
    districtId: '3516050',
    name: 'Bandarasri',
  },
  {
    id: '3516050018',
    districtId: '3516050',
    name: 'Sukoanyar',
  },
  {
    id: '3516050019',
    districtId: '3516050',
    name: 'Tanjangrono',
  },
  {
    id: '3516060001',
    districtId: '3516060',
    name: 'Purworejo',
  },
  {
    id: '3516060002',
    districtId: '3516060',
    name: 'Mojorejo',
  },
  {
    id: '3516060003',
    districtId: '3516060',
    name: 'Curahmojo',
  },
  {
    id: '3516060004',
    districtId: '3516060',
    name: 'Sekargadung',
  },
  {
    id: '3516060005',
    districtId: '3516060',
    name: 'Tempuran',
  },
  {
    id: '3516060006',
    districtId: '3516060',
    name: 'Jatilangkung',
  },
  {
    id: '3516060007',
    districtId: '3516060',
    name: 'Banjartanggul',
  },
  {
    id: '3516060008',
    districtId: '3516060',
    name: 'Kalipuro',
  },
  {
    id: '3516060009',
    districtId: '3516060',
    name: 'Randuharjo',
  },
  {
    id: '3516060010',
    districtId: '3516060',
    name: 'Kembangringgit',
  },
  {
    id: '3516060011',
    districtId: '3516060',
    name: 'Pungging',
  },
  {
    id: '3516060012',
    districtId: '3516060',
    name: 'Lebaksono',
  },
  {
    id: '3516060013',
    districtId: '3516060',
    name: 'Tunggalpager',
  },
  {
    id: '3516060014',
    districtId: '3516060',
    name: 'Balongmasin',
  },
  {
    id: '3516060015',
    districtId: '3516060',
    name: 'Jabontegal',
  },
  {
    id: '3516060016',
    districtId: '3516060',
    name: 'Kedungmunggal',
  },
  {
    id: '3516060017',
    districtId: '3516060',
    name: 'Watukenongo',
  },
  {
    id: '3516060018',
    districtId: '3516060',
    name: 'Ngrame',
  },
  {
    id: '3516060019',
    districtId: '3516060',
    name: 'Bangun',
  },
  {
    id: '3516070001',
    districtId: '3516070',
    name: 'Payungrejo',
  },
  {
    id: '3516070002',
    districtId: '3516070',
    name: 'Simbaringin',
  },
  {
    id: '3516070003',
    districtId: '3516070',
    name: 'Sampangagung',
  },
  {
    id: '3516070004',
    districtId: '3516070',
    name: 'Jiyu',
  },
  {
    id: '3516070005',
    districtId: '3516070',
    name: 'Pesanggrahan',
  },
  {
    id: '3516070006',
    districtId: '3516070',
    name: 'Windurejo',
  },
  {
    id: '3516070007',
    districtId: '3516070',
    name: 'Kertosari',
  },
  {
    id: '3516070008',
    districtId: '3516070',
    name: 'Kepuharum',
  },
  {
    id: '3516070009',
    districtId: '3516070',
    name: 'Gedangan',
  },
  {
    id: '3516070010',
    districtId: '3516070',
    name: 'Kutorejo',
  },
  {
    id: '3516070011',
    districtId: '3516070',
    name: 'Karangdiyeng',
  },
  {
    id: '3516070012',
    districtId: '3516070',
    name: 'Sawo',
  },
  {
    id: '3516070013',
    districtId: '3516070',
    name: 'Wonodadi',
  },
  {
    id: '3516070014',
    districtId: '3516070',
    name: 'Singowangi',
  },
  {
    id: '3516070015',
    districtId: '3516070',
    name: 'Kepuhpandak',
  },
  {
    id: '3516070016',
    districtId: '3516070',
    name: 'Karangasem',
  },
  {
    id: '3516070017',
    districtId: '3516070',
    name: 'Kaligoro',
  },
  {
    id: '3516080001',
    districtId: '3516080',
    name: 'Sumbertanggul',
  },
  {
    id: '3516080002',
    districtId: '3516080',
    name: 'Belahantengah',
  },
  {
    id: '3516080003',
    districtId: '3516080',
    name: 'Awang Awang',
  },
  {
    id: '3516080004',
    districtId: '3516080',
    name: 'Kauman',
  },
  {
    id: '3516080005',
    districtId: '3516080',
    name: 'Sarirejo',
  },
  {
    id: '3516080006',
    districtId: '3516080',
    name: 'Sawahan',
  },
  {
    id: '3516080007',
    districtId: '3516080',
    name: 'Mojosari',
  },
  {
    id: '3516080008',
    districtId: '3516080',
    name: 'Wonokusumo',
  },
  {
    id: '3516080009',
    districtId: '3516080',
    name: 'Seduri',
  },
  {
    id: '3516080010',
    districtId: '3516080',
    name: 'Mojosulur',
  },
  {
    id: '3516080011',
    districtId: '3516080',
    name: 'Randubango',
  },
  {
    id: '3516080012',
    districtId: '3516080',
    name: 'Jotangan',
  },
  {
    id: '3516080013',
    districtId: '3516080',
    name: 'Menanggal',
  },
  {
    id: '3516080014',
    districtId: '3516080',
    name: 'Pekukuhan',
  },
  {
    id: '3516080015',
    districtId: '3516080',
    name: 'Modopuro',
  },
  {
    id: '3516080016',
    districtId: '3516080',
    name: 'Kebondalem',
  },
  {
    id: '3516080017',
    districtId: '3516080',
    name: 'Kedunggempol',
  },
  {
    id: '3516080018',
    districtId: '3516080',
    name: 'Ngimbangan',
  },
  {
    id: '3516080019',
    districtId: '3516080',
    name: 'Leminggir',
  },
  {
    id: '3516090001',
    districtId: '3516090',
    name: 'Sumberwono',
  },
  {
    id: '3516090002',
    districtId: '3516090',
    name: 'Peterongan',
  },
  {
    id: '3516090004',
    districtId: '3516090',
    name: 'Kutoporong',
  },
  {
    id: '3516090005',
    districtId: '3516090',
    name: 'Ngastemi',
  },
  {
    id: '3516090006',
    districtId: '3516090',
    name: 'Mojotamping',
  },
  {
    id: '3516090007',
    districtId: '3516090',
    name: 'Ngrowo',
  },
  {
    id: '3516090009',
    districtId: '3516090',
    name: 'Sidomulyo',
  },
  {
    id: '3516090010',
    districtId: '3516090',
    name: 'Puloniti',
  },
  {
    id: '3516090011',
    districtId: '3516090',
    name: 'Bangsal',
  },
  {
    id: '3516090012',
    districtId: '3516090',
    name: 'Pacing',
  },
  {
    id: '3516090014',
    districtId: '3516090',
    name: 'Gayam',
  },
  {
    id: '3516090015',
    districtId: '3516090',
    name: 'Pekuwon',
  },
  {
    id: '3516090016',
    districtId: '3516090',
    name: 'Salen',
  },
  {
    id: '3516090017',
    districtId: '3516090',
    name: 'Mejoyo',
  },
  {
    id: '3516090018',
    districtId: '3516090',
    name: 'Tinggarbuntut',
  },
  {
    id: '3516091001',
    districtId: '3516091',
    name: 'Jabon',
  },
  {
    id: '3516091002',
    districtId: '3516091',
    name: 'Gayaman',
  },
  {
    id: '3516091003',
    districtId: '3516091',
    name: 'Gebang Malang',
  },
  {
    id: '3516091004',
    districtId: '3516091',
    name: 'Sumber Jati',
  },
  {
    id: '3516091005',
    districtId: '3516091',
    name: 'Kepuh Anyar',
  },
  {
    id: '3516091006',
    districtId: '3516091',
    name: 'Lengkong',
  },
  {
    id: '3516091007',
    districtId: '3516091',
    name: 'Sadar Tengah',
  },
  {
    id: '3516091008',
    districtId: '3516091',
    name: 'Ngarjo',
  },
  {
    id: '3516091011',
    districtId: '3516091',
    name: 'Kweden Kembar',
  },
  {
    id: '3516091012',
    districtId: '3516091',
    name: 'Kwatu',
  },
  {
    id: '3516100002',
    districtId: '3516100',
    name: 'Kalen',
  },
  {
    id: '3516100004',
    districtId: '3516100',
    name: 'Mojokarang',
  },
  {
    id: '3516100006',
    districtId: '3516100',
    name: 'Talok',
  },
  {
    id: '3516100007',
    districtId: '3516100',
    name: 'Sumbersono',
  },
  {
    id: '3516100008',
    districtId: '3516100',
    name: 'Sambilawang',
  },
  {
    id: '3516100009',
    districtId: '3516100',
    name: 'Jrambe',
  },
  {
    id: '3516100010',
    districtId: '3516100',
    name: 'Randugenengan',
  },
  {
    id: '3516100011',
    districtId: '3516100',
    name: 'Pohkecik',
  },
  {
    id: '3516100012',
    districtId: '3516100',
    name: 'Dlanggu',
  },
  {
    id: '3516100014',
    districtId: '3516100',
    name: 'Sumberkarang',
  },
  {
    id: '3516100015',
    districtId: '3516100',
    name: 'Kedunglengkong',
  },
  {
    id: '3516100016',
    districtId: '3516100',
    name: 'Tumapel',
  },
  {
    id: '3516110001',
    districtId: '3516110',
    name: 'Tampungrejo',
  },
  {
    id: '3516110002',
    districtId: '3516110',
    name: 'Plososari',
  },
  {
    id: '3516110003',
    districtId: '3516110',
    name: 'Kintelan',
  },
  {
    id: '3516110004',
    districtId: '3516110',
    name: 'Brayung',
  },
  {
    id: '3516110005',
    districtId: '3516110',
    name: 'Ketemasdungus',
  },
  {
    id: '3516110006',
    districtId: '3516110',
    name: 'Puri',
  },
  {
    id: '3516110007',
    districtId: '3516110',
    name: 'Tangunan',
  },
  {
    id: '3516110008',
    districtId: '3516110',
    name: 'Kebonagung',
  },
  {
    id: '3516110009',
    districtId: '3516110',
    name: 'Sumbergirang',
  },
  {
    id: '3516110010',
    districtId: '3516110',
    name: 'Mlaten',
  },
  {
    id: '3516110011',
    districtId: '3516110',
    name: 'Medali',
  },
  {
    id: '3516110012',
    districtId: '3516110',
    name: 'Balongmojo',
  },
  {
    id: '3516110013',
    districtId: '3516110',
    name: 'Sumolawang',
  },
  {
    id: '3516110014',
    districtId: '3516110',
    name: 'Tambakagung',
  },
  {
    id: '3516110015',
    districtId: '3516110',
    name: 'Kenanten',
  },
  {
    id: '3516110016',
    districtId: '3516110',
    name: 'Banjaragung',
  },
  {
    id: '3516120001',
    districtId: '3516120',
    name: 'Pakis',
  },
  {
    id: '3516120002',
    districtId: '3516120',
    name: 'Sentonorejo',
  },
  {
    id: '3516120003',
    districtId: '3516120',
    name: 'Temon',
  },
  {
    id: '3516120004',
    districtId: '3516120',
    name: 'Beloh',
  },
  {
    id: '3516120005',
    districtId: '3516120',
    name: 'Domas',
  },
  {
    id: '3516120006',
    districtId: '3516120',
    name: 'Jambuwok',
  },
  {
    id: '3516120007',
    districtId: '3516120',
    name: 'Watesumpak',
  },
  {
    id: '3516120008',
    districtId: '3516120',
    name: 'Jatipasar',
  },
  {
    id: '3516120009',
    districtId: '3516120',
    name: 'Trowulan',
  },
  {
    id: '3516120010',
    districtId: '3516120',
    name: 'Bejijong',
  },
  {
    id: '3516120011',
    districtId: '3516120',
    name: 'Kejagan',
  },
  {
    id: '3516120012',
    districtId: '3516120',
    name: 'Wonorejo',
  },
  {
    id: '3516120013',
    districtId: '3516120',
    name: 'Panggih',
  },
  {
    id: '3516120014',
    districtId: '3516120',
    name: 'Tawangsari',
  },
  {
    id: '3516120015',
    districtId: '3516120',
    name: 'Balongwono',
  },
  {
    id: '3516120016',
    districtId: '3516120',
    name: 'Bicak',
  },
  {
    id: '3516130001',
    districtId: '3516130',
    name: 'Gemekan',
  },
  {
    id: '3516130002',
    districtId: '3516130',
    name: 'Blimbingsari',
  },
  {
    id: '3516130003',
    districtId: '3516130',
    name: 'Brangkal',
  },
  {
    id: '3516130004',
    districtId: '3516130',
    name: 'Kedungmaling',
  },
  {
    id: '3516130005',
    districtId: '3516130',
    name: 'Klinterejo',
  },
  {
    id: '3516130006',
    districtId: '3516130',
    name: 'Modongan',
  },
  {
    id: '3516130007',
    districtId: '3516130',
    name: 'Sambiroto',
  },
  {
    id: '3516130008',
    districtId: '3516130',
    name: 'Jampirogo',
  },
  {
    id: '3516130009',
    districtId: '3516130',
    name: 'Japan',
  },
  {
    id: '3516130010',
    districtId: '3516130',
    name: 'Sooko',
  },
  {
    id: '3516130011',
    districtId: '3516130',
    name: 'Wringinrejo',
  },
  {
    id: '3516130012',
    districtId: '3516130',
    name: 'Karangkedawang',
  },
  {
    id: '3516130013',
    districtId: '3516130',
    name: 'Mojoranu',
  },
  {
    id: '3516130014',
    districtId: '3516130',
    name: 'Tempuran',
  },
  {
    id: '3516130015',
    districtId: '3516130',
    name: 'Ngingasrembyong',
  },
  {
    id: '3516140001',
    districtId: '3516140',
    name: 'Ngareskidul',
  },
  {
    id: '3516140002',
    districtId: '3516140',
    name: 'Gembongan',
  },
  {
    id: '3516140003',
    districtId: '3516140',
    name: 'Gempolkrep',
  },
  {
    id: '3516140004',
    districtId: '3516140',
    name: 'Bandung',
  },
  {
    id: '3516140006',
    districtId: '3516140',
    name: 'Pagerluyung',
  },
  {
    id: '3516140007',
    districtId: '3516140',
    name: 'Kemantren',
  },
  {
    id: '3516140008',
    districtId: '3516140',
    name: 'Terusan',
  },
  {
    id: '3516140009',
    districtId: '3516140',
    name: 'Sidoharjo',
  },
  {
    id: '3516140010',
    districtId: '3516140',
    name: 'Balongsari',
  },
  {
    id: '3516140011',
    districtId: '3516140',
    name: 'Batankrajan',
  },
  {
    id: '3516140012',
    districtId: '3516140',
    name: 'Pagerjo',
  },
  {
    id: '3516140014',
    districtId: '3516140',
    name: 'Beratwetan',
  },
  {
    id: '3516150001',
    districtId: '3516150',
    name: 'Watesprojo',
  },
  {
    id: '3516150002',
    districtId: '3516150',
    name: 'Betro',
  },
  {
    id: '3516150003',
    districtId: '3516150',
    name: 'Kedungsari',
  },
  {
    id: '3516150004',
    districtId: '3516150',
    name: 'Beratkulon',
  },
  {
    id: '3516150005',
    districtId: '3516150',
    name: 'Mojojajar',
  },
  {
    id: '3516150006',
    districtId: '3516150',
    name: 'Mojosarirejo',
  },
  {
    id: '3516150007',
    districtId: '3516150',
    name: 'Mojowiryo',
  },
  {
    id: '3516150008',
    districtId: '3516150',
    name: 'Mojowatesrejo',
  },
  {
    id: '3516150009',
    districtId: '3516150',
    name: 'Mojogebang',
  },
  {
    id: '3516150010',
    districtId: '3516150',
    name: 'Mojopilang',
  },
  {
    id: '3516150011',
    districtId: '3516150',
    name: 'Mojokusumo',
  },
  {
    id: '3516150012',
    districtId: '3516150',
    name: 'Japanan',
  },
  {
    id: '3516150013',
    districtId: '3516150',
    name: 'Mojokumpul',
  },
  {
    id: '3516150014',
    districtId: '3516150',
    name: 'Tanjungan',
  },
  {
    id: '3516150015',
    districtId: '3516150',
    name: 'Mojorejo',
  },
  {
    id: '3516150016',
    districtId: '3516150',
    name: 'Mojodadi',
  },
  {
    id: '3516150017',
    districtId: '3516150',
    name: 'Kemlagi',
  },
  {
    id: '3516150018',
    districtId: '3516150',
    name: 'Mojowono',
  },
  {
    id: '3516150019',
    districtId: '3516150',
    name: 'Pandankrajan',
  },
  {
    id: '3516150020',
    districtId: '3516150',
    name: 'Mojodowo',
  },
  {
    id: '3516160001',
    districtId: '3516160',
    name: 'Mlirip',
  },
  {
    id: '3516160002',
    districtId: '3516160',
    name: 'Penompo',
  },
  {
    id: '3516160003',
    districtId: '3516160',
    name: 'Canggu',
  },
  {
    id: '3516160004',
    districtId: '3516160',
    name: 'Ngabar',
  },
  {
    id: '3516160005',
    districtId: '3516160',
    name: 'Banjarsari',
  },
  {
    id: '3516160006',
    districtId: '3516160',
    name: 'Sawo',
  },
  {
    id: '3516160007',
    districtId: '3516160',
    name: 'Mojorejo',
  },
  {
    id: '3516160008',
    districtId: '3516160',
    name: 'Jolotundo',
  },
  {
    id: '3516160009',
    districtId: '3516160',
    name: 'Kupang',
  },
  {
    id: '3516160011',
    districtId: '3516160',
    name: 'Mojolebak',
  },
  {
    id: '3516160012',
    districtId: '3516160',
    name: 'Paringan',
  },
  {
    id: '3516160013',
    districtId: '3516160',
    name: 'Jetis',
  },
  {
    id: '3516160014',
    districtId: '3516160',
    name: 'Perning',
  },
  {
    id: '3516160015',
    districtId: '3516160',
    name: 'Sidorejo',
  },
  {
    id: '3516160016',
    districtId: '3516160',
    name: 'Lakardowo',
  },
  {
    id: '3516170001',
    districtId: '3516170',
    name: 'Cendoro',
  },
  {
    id: '3516170002',
    districtId: '3516170',
    name: 'Simongagrok',
  },
  {
    id: '3516170004',
    districtId: '3516170',
    name: 'Talunblandong',
  },
  {
    id: '3516170005',
    districtId: '3516170',
    name: 'Cinandang',
  },
  {
    id: '3516170006',
    districtId: '3516170',
    name: 'Gunungsari',
  },
  {
    id: '3516170007',
    districtId: '3516170',
    name: 'Dawarblandong',
  },
  {
    id: '3516170008',
    districtId: '3516170',
    name: 'Pulorejo',
  },
  {
    id: '3516170009',
    districtId: '3516170',
    name: 'Jatirowo',
  },
  {
    id: '3516170011',
    districtId: '3516170',
    name: 'Bangeran',
  },
  {
    id: '3516170013',
    districtId: '3516170',
    name: 'Banyulegi',
  },
  {
    id: '3516170014',
    districtId: '3516170',
    name: 'Gunungan',
  },
  {
    id: '3516170015',
    districtId: '3516170',
    name: 'Brayublandong',
  },
  {
    id: '3516170016',
    districtId: '3516170',
    name: 'Madureso',
  },
  {
    id: '3516170017',
    districtId: '3516170',
    name: 'Temuireng',
  },
  {
    id: '3516170018',
    districtId: '3516170',
    name: 'Randegan',
  },
  {
    id: '3517010001',
    districtId: '3517010',
    name: 'Bandar Kedung Mulyo',
  },
  {
    id: '3517010002',
    districtId: '3517010',
    name: 'Mojokambang',
  },
  {
    id: '3517010003',
    districtId: '3517010',
    name: 'Barong Sawahan',
  },
  {
    id: '3517010004',
    districtId: '3517010',
    name: 'Kayen',
  },
  {
    id: '3517010005',
    districtId: '3517010',
    name: 'Gondang Manis',
  },
  {
    id: '3517010006',
    districtId: '3517010',
    name: 'Pucang Simo',
  },
  {
    id: '3517010007',
    districtId: '3517010',
    name: 'Brodot',
  },
  {
    id: '3517010008',
    districtId: '3517010',
    name: 'Brangkal',
  },
  {
    id: '3517010009',
    districtId: '3517010',
    name: 'Banjar Sari',
  },
  {
    id: '3517010010',
    districtId: '3517010',
    name: 'Tinggar',
  },
  {
    id: '3517010011',
    districtId: '3517010',
    name: 'Karang Dagangan',
  },
  {
    id: '3517020001',
    districtId: '3517020',
    name: 'Jantiganggong',
  },
  {
    id: '3517020002',
    districtId: '3517020',
    name: 'Kepuhkajang',
  },
  {
    id: '3517020003',
    districtId: '3517020',
    name: 'Sumberagung',
  },
  {
    id: '3517020004',
    districtId: '3517020',
    name: 'Pagerwojo',
  },
  {
    id: '3517020005',
    districtId: '3517020',
    name: 'Perak',
  },
  {
    id: '3517020007',
    districtId: '3517020',
    name: 'Glagahan',
  },
  {
    id: '3517020008',
    districtId: '3517020',
    name: 'Kalang Semanding',
  },
  {
    id: '3517020009',
    districtId: '3517020',
    name: 'Gadingmangu',
  },
  {
    id: '3517020010',
    districtId: '3517020',
    name: 'Plosogenuk',
  },
  {
    id: '3517020011',
    districtId: '3517020',
    name: 'Sukorejo',
  },
  {
    id: '3517020012',
    districtId: '3517020',
    name: 'Temuwulan',
  },
  {
    id: '3517020013',
    districtId: '3517020',
    name: 'Cangkringrandu',
  },
  {
    id: '3517030001',
    districtId: '3517030',
    name: 'Pucangro',
  },
  {
    id: '3517030002',
    districtId: '3517030',
    name: 'Kedungturi',
  },
  {
    id: '3517030003',
    districtId: '3517030',
    name: 'Japanan',
  },
  {
    id: '3517030004',
    districtId: '3517030',
    name: 'Blimbing',
  },
  {
    id: '3517030005',
    districtId: '3517030',
    name: 'Mentaos',
  },
  {
    id: '3517030006',
    districtId: '3517030',
    name: 'Sukoiber',
  },
  {
    id: '3517030007',
    districtId: '3517030',
    name: 'Sukopinggir',
  },
  {
    id: '3517030008',
    districtId: '3517030',
    name: 'Bugasur Kedaleman',
  },
  {
    id: '3517030009',
    districtId: '3517030',
    name: 'Gudo',
  },
  {
    id: '3517030010',
    districtId: '3517030',
    name: 'Wangkalkepuh',
  },
  {
    id: '3517030011',
    districtId: '3517030',
    name: 'Pesanggrahan',
  },
  {
    id: '3517030012',
    districtId: '3517030',
    name: 'Krembangan',
  },
  {
    id: '3517030013',
    districtId: '3517030',
    name: 'Sepanyul',
  },
  {
    id: '3517030014',
    districtId: '3517030',
    name: 'Godong',
  },
  {
    id: '3517030015',
    districtId: '3517030',
    name: 'Mejoyolosari',
  },
  {
    id: '3517030016',
    districtId: '3517030',
    name: 'Plumbon Gambang',
  },
  {
    id: '3517030017',
    districtId: '3517030',
    name: 'Gempol Legundi',
  },
  {
    id: '3517030018',
    districtId: '3517030',
    name: 'Tanggungan',
  },
  {
    id: '3517040001',
    districtId: '3517040',
    name: 'Kayangan',
  },
  {
    id: '3517040002',
    districtId: '3517040',
    name: 'Puton',
  },
  {
    id: '3517040004',
    districtId: '3517040',
    name: 'Bulurejo',
  },
  {
    id: '3517040005',
    districtId: '3517040',
    name: 'Grogol',
  },
  {
    id: '3517040006',
    districtId: '3517040',
    name: 'Jatirejo',
  },
  {
    id: '3517040007',
    districtId: '3517040',
    name: 'Cukir',
  },
  {
    id: '3517040008',
    districtId: '3517040',
    name: 'Kwaron',
  },
  {
    id: '3517040009',
    districtId: '3517040',
    name: 'Keras',
  },
  {
    id: '3517040010',
    districtId: '3517040',
    name: 'Watugaluh',
  },
  {
    id: '3517040011',
    districtId: '3517040',
    name: 'Jatipelem',
  },
  {
    id: '3517040012',
    districtId: '3517040',
    name: 'Brambang',
  },
  {
    id: '3517040013',
    districtId: '3517040',
    name: 'Pundong',
  },
  {
    id: '3517040014',
    districtId: '3517040',
    name: 'Diwek',
  },
  {
    id: '3517040016',
    districtId: '3517040',
    name: 'Bandung',
  },
  {
    id: '3517040017',
    districtId: '3517040',
    name: 'Kedawong',
  },
  {
    id: '3517040018',
    districtId: '3517040',
    name: 'Ngudirejo',
  },
  {
    id: '3517040019',
    districtId: '3517040',
    name: 'Balong Besuk',
  },
  {
    id: '3517040020',
    districtId: '3517040',
    name: 'Pandanwangi',
  },
  {
    id: '3517050001',
    districtId: '3517050',
    name: 'Jombok',
  },
  {
    id: '3517050002',
    districtId: '3517050',
    name: 'Genukwatu',
  },
  {
    id: '3517050003',
    districtId: '3517050',
    name: 'Rejoagung',
  },
  {
    id: '3517050004',
    districtId: '3517050',
    name: 'Kauman',
  },
  {
    id: '3517050005',
    districtId: '3517050',
    name: 'Ngoro',
  },
  {
    id: '3517050006',
    districtId: '3517050',
    name: 'Badang',
  },
  {
    id: '3517050007',
    districtId: '3517050',
    name: 'Pulorejo',
  },
  {
    id: '3517050008',
    districtId: '3517050',
    name: 'Banyuarang',
  },
  {
    id: '3517050009',
    districtId: '3517050',
    name: 'Sidowarek',
  },
  {
    id: '3517050010',
    districtId: '3517050',
    name: 'Kesamben',
  },
  {
    id: '3517050011',
    districtId: '3517050',
    name: 'Kertorejo',
  },
  {
    id: '3517050012',
    districtId: '3517050',
    name: 'Gajah',
  },
  {
    id: '3517050013',
    districtId: '3517050',
    name: 'Sugihwaras',
  },
  {
    id: '3517060001',
    districtId: '3517060',
    name: 'Kedungpari',
  },
  {
    id: '3517060002',
    districtId: '3517060',
    name: 'Karanglo',
  },
  {
    id: '3517060003',
    districtId: '3517060',
    name: 'Latsari',
  },
  {
    id: '3517060004',
    districtId: '3517060',
    name: 'Mojowarno',
  },
  {
    id: '3517060005',
    districtId: '3517060',
    name: 'Penggaron',
  },
  {
    id: '3517060006',
    districtId: '3517060',
    name: 'Mojoduwur',
  },
  {
    id: '3517060007',
    districtId: '3517060',
    name: 'Mojowangi',
  },
  {
    id: '3517060008',
    districtId: '3517060',
    name: 'Gondek',
  },
  {
    id: '3517060009',
    districtId: '3517060',
    name: 'Gedangan',
  },
  {
    id: '3517060010',
    districtId: '3517060',
    name: 'Mojojejer',
  },
  {
    id: '3517060011',
    districtId: '3517060',
    name: 'Japanan',
  },
  {
    id: '3517060012',
    districtId: '3517060',
    name: 'Grobogan',
  },
  {
    id: '3517060013',
    districtId: '3517060',
    name: 'Rejoslamet',
  },
  {
    id: '3517060014',
    districtId: '3517060',
    name: 'Selorejo',
  },
  {
    id: '3517060015',
    districtId: '3517060',
    name: 'Menganto',
  },
  {
    id: '3517060016',
    districtId: '3517060',
    name: 'Sidokerto',
  },
  {
    id: '3517060017',
    districtId: '3517060',
    name: 'Sukomulyo',
  },
  {
    id: '3517060018',
    districtId: '3517060',
    name: 'Catak Gayam',
  },
  {
    id: '3517060019',
    districtId: '3517060',
    name: 'Wringinpitu',
  },
  {
    id: '3517070001',
    districtId: '3517070',
    name: 'Kebondalem',
  },
  {
    id: '3517070003',
    districtId: '3517070',
    name: 'Pakel',
  },
  {
    id: '3517070004',
    districtId: '3517070',
    name: 'Karangan',
  },
  {
    id: '3517070005',
    districtId: '3517070',
    name: 'Ngampungan',
  },
  {
    id: '3517070006',
    districtId: '3517070',
    name: 'Jenisgelaran',
  },
  {
    id: '3517070007',
    districtId: '3517070',
    name: 'Bareng',
  },
  {
    id: '3517070009',
    districtId: '3517070',
    name: 'Mojotengah',
  },
  {
    id: '3517070010',
    districtId: '3517070',
    name: 'Banjaragung',
  },
  {
    id: '3517070011',
    districtId: '3517070',
    name: 'Nglebak',
  },
  {
    id: '3517070012',
    districtId: '3517070',
    name: 'Pulosari',
  },
  {
    id: '3517070013',
    districtId: '3517070',
    name: 'Ngrimbi',
  },
  {
    id: '3517080001',
    districtId: '3517080',
    name: 'Galengdowo',
  },
  {
    id: '3517080002',
    districtId: '3517080',
    name: 'Wonomerto',
  },
  {
    id: '3517080003',
    districtId: '3517080',
    name: 'Jarak',
  },
  {
    id: '3517080004',
    districtId: '3517080',
    name: 'Sambirejo',
  },
  {
    id: '3517080005',
    districtId: '3517080',
    name: 'Wonosalam',
  },
  {
    id: '3517080006',
    districtId: '3517080',
    name: 'Carangwulung',
  },
  {
    id: '3517080007',
    districtId: '3517080',
    name: 'Panglungan',
  },
  {
    id: '3517080008',
    districtId: '3517080',
    name: 'Wonokerto',
  },
  {
    id: '3517080009',
    districtId: '3517080',
    name: 'Sumberjo',
  },
  {
    id: '3517090001',
    districtId: '3517090',
    name: 'Kedunglumpang',
  },
  {
    id: '3517090002',
    districtId: '3517090',
    name: 'Dukuh Mojo',
  },
  {
    id: '3517090003',
    districtId: '3517090',
    name: 'Karangwinongan',
  },
  {
    id: '3517090004',
    districtId: '3517090',
    name: 'Kademangan',
  },
  {
    id: '3517090005',
    districtId: '3517090',
    name: 'Janti',
  },
  {
    id: '3517090006',
    districtId: '3517090',
    name: 'Tejo',
  },
  {
    id: '3517090007',
    districtId: '3517090',
    name: 'Gambiran',
  },
  {
    id: '3517090008',
    districtId: '3517090',
    name: 'Kauman',
  },
  {
    id: '3517090009',
    districtId: '3517090',
    name: 'Mojotrisno',
  },
  {
    id: '3517090010',
    districtId: '3517090',
    name: 'Tanggalrejo',
  },
  {
    id: '3517090011',
    districtId: '3517090',
    name: 'Dukuhdimoro',
  },
  {
    id: '3517090012',
    districtId: '3517090',
    name: 'Miagan',
  },
  {
    id: '3517090013',
    districtId: '3517090',
    name: 'Mancilan',
  },
  {
    id: '3517090015',
    districtId: '3517090',
    name: 'Karobelah',
  },
  {
    id: '3517090016',
    districtId: '3517090',
    name: 'Murukan',
  },
  {
    id: '3517090017',
    districtId: '3517090',
    name: 'Johowinong',
  },
  {
    id: '3517090018',
    districtId: '3517090',
    name: 'Seketi',
  },
  {
    id: '3517100001',
    districtId: '3517100',
    name: 'Plosokerep',
  },
  {
    id: '3517100002',
    districtId: '3517100',
    name: 'Jogoloyo',
  },
  {
    id: '3517100003',
    districtId: '3517100',
    name: 'Palrejo',
  },
  {
    id: '3517100004',
    districtId: '3517100',
    name: 'Plemahan',
  },
  {
    id: '3517100006',
    districtId: '3517100',
    name: 'Badas',
  },
  {
    id: '3517100008',
    districtId: '3517100',
    name: 'Trawasan',
  },
  {
    id: '3517100009',
    districtId: '3517100',
    name: 'Sebani',
  },
  {
    id: '3517100010',
    districtId: '3517100',
    name: 'Mlaras',
  },
  {
    id: '3517100011',
    districtId: '3517100',
    name: 'Segodorejo',
  },
  {
    id: '3517100012',
    districtId: '3517100',
    name: 'Kedungpapar',
  },
  {
    id: '3517100013',
    districtId: '3517100',
    name: 'Sumobito',
  },
  {
    id: '3517100014',
    districtId: '3517100',
    name: 'Curah Malang',
  },
  {
    id: '3517100015',
    districtId: '3517100',
    name: 'Budugsidorejo',
  },
  {
    id: '3517100016',
    districtId: '3517100',
    name: 'Kendalsari',
  },
  {
    id: '3517100017',
    districtId: '3517100',
    name: 'Talun Kidul',
  },
  {
    id: '3517100018',
    districtId: '3517100',
    name: 'Madyo Puro',
  },
  {
    id: '3517100019',
    districtId: '3517100',
    name: 'Bakalan',
  },
  {
    id: '3517100020',
    districtId: '3517100',
    name: 'Gedangan',
  },
  {
    id: '3517100021',
    districtId: '3517100',
    name: 'Mentoro',
  },
  {
    id: '3517110001',
    districtId: '3517110',
    name: 'Jogoroto',
  },
  {
    id: '3517110002',
    districtId: '3517110',
    name: 'Jarak Kulon',
  },
  {
    id: '3517110003',
    districtId: '3517110',
    name: 'Alang Alang Caruban',
  },
  {
    id: '3517110004',
    districtId: '3517110',
    name: 'Sukosari',
  },
  {
    id: '3517110005',
    districtId: '3517110',
    name: 'Sawiji',
  },
  {
    id: '3517110006',
    districtId: '3517110',
    name: 'Mayangan',
  },
  {
    id: '3517110007',
    districtId: '3517110',
    name: 'Sumber Mulyo',
  },
  {
    id: '3517110009',
    districtId: '3517110',
    name: 'Tambar',
  },
  {
    id: '3517110010',
    districtId: '3517110',
    name: 'Janti',
  },
  {
    id: '3517110011',
    districtId: '3517110',
    name: 'Sambirejo',
  },
  {
    id: '3517120002',
    districtId: '3517120',
    name: 'Keplaksari',
  },
  {
    id: '3517120003',
    districtId: '3517120',
    name: 'Peterongan',
  },
  {
    id: '3517120004',
    districtId: '3517120',
    name: 'Mancar',
  },
  {
    id: '3517120005',
    districtId: '3517120',
    name: 'Kebontemu',
  },
  {
    id: '3517120006',
    districtId: '3517120',
    name: 'Dukuh Klopo',
  },
  {
    id: '3517120007',
    districtId: '3517120',
    name: 'Tanjung Gunung',
  },
  {
    id: '3517120008',
    districtId: '3517120',
    name: 'Morosunggingan',
  },
  {
    id: '3517120009',
    districtId: '3517120',
    name: 'Tugusumberjo',
  },
  {
    id: '3517120011',
    districtId: '3517120',
    name: 'Bongkot',
  },
  {
    id: '3517120012',
    districtId: '3517120',
    name: 'Sumberagung',
  },
  {
    id: '3517120013',
    districtId: '3517120',
    name: 'Tengaran',
  },
  {
    id: '3517120014',
    districtId: '3517120',
    name: 'Ngrandu Lor',
  },
  {
    id: '3517130001',
    districtId: '3517130',
    name: 'Tunggorono',
  },
  {
    id: '3517130002',
    districtId: '3517130',
    name: 'Jabon',
  },
  {
    id: '3517130003',
    districtId: '3517130',
    name: 'Sengon',
  },
  {
    id: '3517130004',
    districtId: '3517130',
    name: 'Jombatan',
  },
  {
    id: '3517130005',
    districtId: '3517130',
    name: 'Plandi',
  },
  {
    id: '3517130006',
    districtId: '3517130',
    name: 'Kaliwungu',
  },
  {
    id: '3517130007',
    districtId: '3517130',
    name: 'Jelakombo',
  },
  {
    id: '3517130008',
    districtId: '3517130',
    name: 'Kepanjen',
  },
  {
    id: '3517130009',
    districtId: '3517130',
    name: 'Kepatihan',
  },
  {
    id: '3517130010',
    districtId: '3517130',
    name: 'Pulo Lor',
  },
  {
    id: '3517130011',
    districtId: '3517130',
    name: 'Denanyar',
  },
  {
    id: '3517130012',
    districtId: '3517130',
    name: 'Jombang',
  },
  {
    id: '3517130013',
    districtId: '3517130',
    name: 'Candi Mulyo',
  },
  {
    id: '3517130014',
    districtId: '3517130',
    name: 'Mojongapit',
  },
  {
    id: '3517130015',
    districtId: '3517130',
    name: 'Dapur Kejambon',
  },
  {
    id: '3517130016',
    districtId: '3517130',
    name: 'Sambong Dukuh',
  },
  {
    id: '3517130017',
    districtId: '3517130',
    name: 'Tambak Rejo',
  },
  {
    id: '3517130018',
    districtId: '3517130',
    name: 'Plosogeneng',
  },
  {
    id: '3517130019',
    districtId: '3517130',
    name: 'Banjar Dowo',
  },
  {
    id: '3517130020',
    districtId: '3517130',
    name: 'Sumberjo',
  },
  {
    id: '3517140001',
    districtId: '3517140',
    name: 'Turi Pinggir',
  },
  {
    id: '3517140002',
    districtId: '3517140',
    name: 'Gongseng',
  },
  {
    id: '3517140003',
    districtId: '3517140',
    name: 'Balongsari',
  },
  {
    id: '3517140004',
    districtId: '3517140',
    name: 'Sumbersari',
  },
  {
    id: '3517140005',
    districtId: '3517140',
    name: 'Ngogri',
  },
  {
    id: '3517140006',
    districtId: '3517140',
    name: 'Sidomulyo',
  },
  {
    id: '3517140007',
    districtId: '3517140',
    name: 'Balonggemek',
  },
  {
    id: '3517140008',
    districtId: '3517140',
    name: 'Kedung Rejo',
  },
  {
    id: '3517140009',
    districtId: '3517140',
    name: 'Pacar Peluk',
  },
  {
    id: '3517140010',
    districtId: '3517140',
    name: 'Dukuh Arum',
  },
  {
    id: '3517140011',
    districtId: '3517140',
    name: 'Sumber Agung',
  },
  {
    id: '3517140012',
    districtId: '3517140',
    name: 'Sudimoro',
  },
  {
    id: '3517140013',
    districtId: '3517140',
    name: 'Megaluh',
  },
  {
    id: '3517150001',
    districtId: '3517150',
    name: 'Mojokrapak',
  },
  {
    id: '3517150002',
    districtId: '3517150',
    name: 'Kali Kejambon',
  },
  {
    id: '3517150003',
    districtId: '3517150',
    name: 'Kedung Losari',
  },
  {
    id: '3517150004',
    districtId: '3517150',
    name: 'Tamping Mojo',
  },
  {
    id: '3517150005',
    districtId: '3517150',
    name: 'Pesantren',
  },
  {
    id: '3517150006',
    districtId: '3517150',
    name: 'Tembelang',
  },
  {
    id: '3517150007',
    districtId: '3517150',
    name: 'Kedung Otok',
  },
  {
    id: '3517150008',
    districtId: '3517150',
    name: 'Rejoso Pinggir',
  },
  {
    id: '3517150009',
    districtId: '3517150',
    name: 'Pulorejo',
  },
  {
    id: '3517150011',
    districtId: '3517150',
    name: 'Bedah Lawak',
  },
  {
    id: '3517150012',
    districtId: '3517150',
    name: 'Gabusbanaran',
  },
  {
    id: '3517150013',
    districtId: '3517150',
    name: 'Pulo Gedang',
  },
  {
    id: '3517150014',
    districtId: '3517150',
    name: 'Jati Wates',
  },
  {
    id: '3517150015',
    districtId: '3517150',
    name: 'Kepuh Doko',
  },
  {
    id: '3517160001',
    districtId: '3517160',
    name: 'Kedung Betik',
  },
  {
    id: '3517160002',
    districtId: '3517160',
    name: 'Kedung Mlati',
  },
  {
    id: '3517160003',
    districtId: '3517160',
    name: 'Watu Dakon',
  },
  {
    id: '3517160004',
    districtId: '3517160',
    name: 'Carang Rejo',
  },
  {
    id: '3517160005',
    districtId: '3517160',
    name: 'Jombok',
  },
  {
    id: '3517160006',
    districtId: '3517160',
    name: 'Blimbing',
  },
  {
    id: '3517160008',
    districtId: '3517160',
    name: 'Pojok Rejo',
  },
  {
    id: '3517160009',
    districtId: '3517160',
    name: 'Kesamben',
  },
  {
    id: '3517160010',
    districtId: '3517160',
    name: 'Podoroto',
  },
  {
    id: '3517160011',
    districtId: '3517160',
    name: 'Jombatan',
  },
  {
    id: '3517160012',
    districtId: '3517160',
    name: 'Jati Duwur',
  },
  {
    id: '3517160013',
    districtId: '3517160',
    name: 'Pojok Kulon',
  },
  {
    id: '3517160014',
    districtId: '3517160',
    name: 'Gumulan',
  },
  {
    id: '3517170001',
    districtId: '3517170',
    name: 'Sidokaton',
  },
  {
    id: '3517170002',
    districtId: '3517170',
    name: 'Tapen',
  },
  {
    id: '3517170003',
    districtId: '3517170',
    name: 'Bakalanrayung',
  },
  {
    id: '3517170004',
    districtId: '3517170',
    name: 'Randuwatang',
  },
  {
    id: '3517170007',
    districtId: '3517170',
    name: 'Kudubanjar',
  },
  {
    id: '3517170013',
    districtId: '3517170',
    name: 'Made',
  },
  {
    id: '3517170014',
    districtId: '3517170',
    name: 'Kepuhrejo',
  },
  {
    id: '3517170015',
    districtId: '3517170',
    name: 'Bendungan',
  },
  {
    id: '3517170016',
    districtId: '3517170',
    name: 'Katemas',
  },
  {
    id: '3517171001',
    districtId: '3517171',
    name: 'Keboan',
  },
  {
    id: '3517171002',
    districtId: '3517171',
    name: 'Ketapang Kuning',
  },
  {
    id: '3517171003',
    districtId: '3517171',
    name: 'Kedung Bogo',
  },
  {
    id: '3517171004',
    districtId: '3517171',
    name: 'Ngusikan',
  },
  {
    id: '3517171005',
    districtId: '3517171',
    name: 'Sumber Nongko',
  },
  {
    id: '3517171006',
    districtId: '3517171',
    name: 'Manunggal',
  },
  {
    id: '3517171007',
    districtId: '3517171',
    name: 'Ngampel',
  },
  {
    id: '3517171008',
    districtId: '3517171',
    name: 'Mojodanu',
  },
  {
    id: '3517171009',
    districtId: '3517171',
    name: 'Cupak',
  },
  {
    id: '3517171010',
    districtId: '3517171',
    name: 'Asem Gede',
  },
  {
    id: '3517171011',
    districtId: '3517171',
    name: 'Kromong',
  },
  {
    id: '3517180001',
    districtId: '3517180',
    name: 'Tanggung Kramat',
  },
  {
    id: '3517180002',
    districtId: '3517180',
    name: 'Rejoagung',
  },
  {
    id: '3517180003',
    districtId: '3517180',
    name: 'Losari',
  },
  {
    id: '3517180004',
    districtId: '3517180',
    name: 'Ploso',
  },
  {
    id: '3517180005',
    districtId: '3517180',
    name: 'Jatigedong',
  },
  {
    id: '3517180006',
    districtId: '3517180',
    name: 'Dadi Tunggal',
  },
  {
    id: '3517180007',
    districtId: '3517180',
    name: 'Gedongombo',
  },
  {
    id: '3517180008',
    districtId: '3517180',
    name: 'Jatibanjar',
  },
  {
    id: '3517180009',
    districtId: '3517180',
    name: 'Pager Tanjung',
  },
  {
    id: '3517180010',
    districtId: '3517180',
    name: 'Pandan Blole',
  },
  {
    id: '3517180011',
    districtId: '3517180',
    name: 'Kedungdowo',
  },
  {
    id: '3517180012',
    districtId: '3517180',
    name: 'Bawangan',
  },
  {
    id: '3517180013',
    districtId: '3517180',
    name: 'Kebon Agung',
  },
  {
    id: '3517190001',
    districtId: '3517190',
    name: 'Marmoyo',
  },
  {
    id: '3517190002',
    districtId: '3517190',
    name: 'Tanjung Wadung',
  },
  {
    id: '3517190003',
    districtId: '3517190',
    name: 'Mangunan',
  },
  {
    id: '3517190004',
    districtId: '3517190',
    name: 'Kedung Jati',
  },
  {
    id: '3517190005',
    districtId: '3517190',
    name: 'Kabuh',
  },
  {
    id: '3517190006',
    districtId: '3517190',
    name: 'Karang Pakis',
  },
  {
    id: '3517190007',
    districtId: '3517190',
    name: 'Banjar Dowo',
  },
  {
    id: '3517190008',
    districtId: '3517190',
    name: 'Sumberringin',
  },
  {
    id: '3517190009',
    districtId: '3517190',
    name: 'Sumber Gondang',
  },
  {
    id: '3517190010',
    districtId: '3517190',
    name: 'Kauman',
  },
  {
    id: '3517190012',
    districtId: '3517190',
    name: 'Genengan Jasem',
  },
  {
    id: '3517190013',
    districtId: '3517190',
    name: 'Manduro',
  },
  {
    id: '3517190014',
    districtId: '3517190',
    name: 'Sukodadi',
  },
  {
    id: '3517190015',
    districtId: '3517190',
    name: 'Pengampon',
  },
  {
    id: '3517190016',
    districtId: '3517190',
    name: 'Sumberaji',
  },
  {
    id: '3517200001',
    districtId: '3517200',
    name: 'Klitih',
  },
  {
    id: '3517200002',
    districtId: '3517200',
    name: 'Plabuhan',
  },
  {
    id: '3517200003',
    districtId: '3517200',
    name: 'Kampungbaru',
  },
  {
    id: '3517200004',
    districtId: '3517200',
    name: 'Gebang Bunder',
  },
  {
    id: '3517200005',
    districtId: '3517200',
    name: 'Jatimlerek',
  },
  {
    id: '3517200006',
    districtId: '3517200',
    name: 'Karang Mojo',
  },
  {
    id: '3517200007',
    districtId: '3517200',
    name: 'Plandaan',
  },
  {
    id: '3517200008',
    districtId: '3517200',
    name: 'Bangsri',
  },
  {
    id: '3517200009',
    districtId: '3517200',
    name: 'Purisemanding',
  },
  {
    id: '3517200010',
    districtId: '3517200',
    name: 'Tondowulan',
  },
  {
    id: '3517200011',
    districtId: '3517200',
    name: 'Darurejo',
  },
  {
    id: '3517200012',
    districtId: '3517200',
    name: 'Sumberjo',
  },
  {
    id: '3517200013',
    districtId: '3517200',
    name: 'Jipurapah',
  },
  {
    id: '3518010001',
    districtId: '3518010',
    name: 'Ngliman',
  },
  {
    id: '3518010002',
    districtId: '3518010',
    name: 'Bareng',
  },
  {
    id: '3518010003',
    districtId: '3518010',
    name: 'Sawahan',
  },
  {
    id: '3518010004',
    districtId: '3518010',
    name: 'Bendolo',
  },
  {
    id: '3518010006',
    districtId: '3518010',
    name: 'Sidorejo',
  },
  {
    id: '3518010007',
    districtId: '3518010',
    name: 'Margopatut',
  },
  {
    id: '3518010008',
    districtId: '3518010',
    name: 'Siwalan',
  },
  {
    id: '3518010009',
    districtId: '3518010',
    name: 'Kebon Agung',
  },
  {
    id: '3518020001',
    districtId: '3518020',
    name: 'Klodan',
  },
  {
    id: '3518020002',
    districtId: '3518020',
    name: 'Blongko',
  },
  {
    id: '3518020005',
    districtId: '3518020',
    name: 'Ngetos',
  },
  {
    id: '3518020007',
    districtId: '3518020',
    name: 'Oro-Oro Ombo',
  },
  {
    id: '3518020008',
    districtId: '3518020',
    name: 'Mojoduwur',
  },
  {
    id: '3518020009',
    districtId: '3518020',
    name: 'Kuncir',
  },
  {
    id: '3518030001',
    districtId: '3518030',
    name: 'Salamrojo',
  },
  {
    id: '3518030002',
    districtId: '3518030',
    name: 'Cepoko',
  },
  {
    id: '3518030003',
    districtId: '3518030',
    name: 'Maguan',
  },
  {
    id: '3518030004',
    districtId: '3518030',
    name: 'Semare',
  },
  {
    id: '3518030005',
    districtId: '3518030',
    name: 'Mlilir',
  },
  {
    id: '3518030006',
    districtId: '3518030',
    name: 'Bendungrejo',
  },
  {
    id: '3518030009',
    districtId: '3518030',
    name: 'Ngrawan',
  },
  {
    id: '3518030010',
    districtId: '3518030',
    name: 'Sumberwindu',
  },
  {
    id: '3518030011',
    districtId: '3518030',
    name: 'Kacangan',
  },
  {
    id: '3518030012',
    districtId: '3518030',
    name: 'Sendang Bumen',
  },
  {
    id: '3518030013',
    districtId: '3518030',
    name: 'Sumber Urip',
  },
  {
    id: '3518030014',
    districtId: '3518030',
    name: 'Patranrejo',
  },
  {
    id: '3518030015',
    districtId: '3518030',
    name: 'Balongrejo',
  },
  {
    id: '3518030016',
    districtId: '3518030',
    name: 'Tiripan',
  },
  {
    id: '3518030017',
    districtId: '3518030',
    name: 'Sono Patik',
  },
  {
    id: '3518030018',
    districtId: '3518030',
    name: 'Grojogan',
  },
  {
    id: '3518040001',
    districtId: '3518040',
    name: 'Bajulan',
  },
  {
    id: '3518040002',
    districtId: '3518040',
    name: 'Macanan',
  },
  {
    id: '3518040004',
    districtId: '3518040',
    name: 'Karangsono',
  },
  {
    id: '3518040006',
    districtId: '3518040',
    name: 'Godean',
  },
  {
    id: '3518040007',
    districtId: '3518040',
    name: 'Patihan',
  },
  {
    id: '3518040008',
    districtId: '3518040',
    name: 'Sekaran',
  },
  {
    id: '3518040009',
    districtId: '3518040',
    name: 'Loceret',
  },
  {
    id: '3518040010',
    districtId: '3518040',
    name: 'Jatirejo',
  },
  {
    id: '3518040011',
    districtId: '3518040',
    name: 'Tempel Wetan',
  },
  {
    id: '3518040012',
    districtId: '3518040',
    name: 'Teken Glagahan',
  },
  {
    id: '3518040014',
    districtId: '3518040',
    name: 'Gejagan',
  },
  {
    id: '3518040015',
    districtId: '3518040',
    name: 'Candirejo',
  },
  {
    id: '3518040016',
    districtId: '3518040',
    name: 'Sukorejo',
  },
  {
    id: '3518040017',
    districtId: '3518040',
    name: 'Kwagean',
  },
  {
    id: '3518040019',
    districtId: '3518040',
    name: 'Putukrejo',
  },
  {
    id: '3518040020',
    districtId: '3518040',
    name: 'Nglaban',
  },
  {
    id: '3518040021',
    districtId: '3518040',
    name: 'Sombron',
  },
  {
    id: '3518040022',
    districtId: '3518040',
    name: 'Tanjungrejo',
  },
  {
    id: '3518050001',
    districtId: '3518050',
    name: 'Joho',
  },
  {
    id: '3518050002',
    districtId: '3518050',
    name: 'Jatigreges',
  },
  {
    id: '3518050003',
    districtId: '3518050',
    name: 'Sanan',
  },
  {
    id: '3518050004',
    districtId: '3518050',
    name: 'Pacekulon',
  },
  {
    id: '3518050005',
    districtId: '3518050',
    name: 'Gondang',
  },
  {
    id: '3518050007',
    districtId: '3518050',
    name: 'Mlandangan',
  },
  {
    id: '3518050008',
    districtId: '3518050',
    name: 'Jampes',
  },
  {
    id: '3518050009',
    districtId: '3518050',
    name: 'Batembat',
  },
  {
    id: '3518050010',
    districtId: '3518050',
    name: 'Babadan',
  },
  {
    id: '3518050011',
    districtId: '3518050',
    name: 'Bodor',
  },
  {
    id: '3518050012',
    districtId: '3518050',
    name: 'Pace Wetan',
  },
  {
    id: '3518050014',
    districtId: '3518050',
    name: 'Jetis',
  },
  {
    id: '3518050015',
    districtId: '3518050',
    name: 'Banaran',
  },
  {
    id: '3518050017',
    districtId: '3518050',
    name: 'Plosoharjo',
  },
  {
    id: '3518050018',
    districtId: '3518050',
    name: 'Kepanjen',
  },
  {
    id: '3518060001',
    districtId: '3518060',
    name: 'Kedung Ombo',
  },
  {
    id: '3518060004',
    districtId: '3518060',
    name: 'Kampungbaru',
  },
  {
    id: '3518060005',
    districtId: '3518060',
    name: 'Wates',
  },
  {
    id: '3518060006',
    districtId: '3518060',
    name: 'Malangsari',
  },
  {
    id: '3518060007',
    districtId: '3518060',
    name: 'Getas',
  },
  {
    id: '3518060008',
    districtId: '3518060',
    name: 'Sonobekel',
  },
  {
    id: '3518060009',
    districtId: '3518060',
    name: 'Ngadirejo',
  },
  {
    id: '3518060010',
    districtId: '3518060',
    name: 'Banjar Anyar',
  },
  {
    id: '3518060012',
    districtId: '3518060',
    name: 'Sidoharjo',
  },
  {
    id: '3518060013',
    districtId: '3518060',
    name: 'Tanjung Anom',
  },
  {
    id: '3518060014',
    districtId: '3518060',
    name: 'Jogomerto',
  },
  {
    id: '3518060015',
    districtId: '3518060',
    name: 'Warujayeng',
  },
  {
    id: '3518060016',
    districtId: '3518060',
    name: 'Kedungrejo',
  },
  {
    id: '3518060018',
    districtId: '3518060',
    name: 'Sambirejo',
  },
  {
    id: '3518060019',
    districtId: '3518060',
    name: 'Demangan',
  },
  {
    id: '3518070001',
    districtId: '3518070',
    name: 'Gondanglegi',
  },
  {
    id: '3518070002',
    districtId: '3518070',
    name: 'Singkal Anyar',
  },
  {
    id: '3518070003',
    districtId: '3518070',
    name: 'Mojo Agung',
  },
  {
    id: '3518070004',
    districtId: '3518070',
    name: 'Bandung',
  },
  {
    id: '3518070005',
    districtId: '3518070',
    name: 'Nglawak',
  },
  {
    id: '3518070006',
    districtId: '3518070',
    name: 'Baleturi',
  },
  {
    id: '3518070007',
    districtId: '3518070',
    name: 'Tegaron',
  },
  {
    id: '3518070008',
    districtId: '3518070',
    name: 'Tanjung Tani',
  },
  {
    id: '3518070009',
    districtId: '3518070',
    name: 'Sanggrahan',
  },
  {
    id: '3518070010',
    districtId: '3518070',
    name: 'Rowoharjo',
  },
  {
    id: '3518070011',
    districtId: '3518070',
    name: 'Sugihwaras',
  },
  {
    id: '3518070012',
    districtId: '3518070',
    name: 'Watu Dandang',
  },
  {
    id: '3518070013',
    districtId: '3518070',
    name: 'Sono Ageng',
  },
  {
    id: '3518070014',
    districtId: '3518070',
    name: 'Kurungrejo',
  },
  {
    id: '3518080002',
    districtId: '3518080',
    name: 'Tanjung Kalang',
  },
  {
    id: '3518080003',
    districtId: '3518080',
    name: 'Kelutan',
  },
  {
    id: '3518080004',
    districtId: '3518080',
    name: 'Cengkok',
  },
  {
    id: '3518080005',
    districtId: '3518080',
    name: 'Mojokendil',
  },
  {
    id: '3518080006',
    districtId: '3518080',
    name: 'Ngronggot',
  },
  {
    id: '3518080007',
    districtId: '3518080',
    name: 'Banjar Sari',
  },
  {
    id: '3518080008',
    districtId: '3518080',
    name: 'Dadapan',
  },
  {
    id: '3518080009',
    districtId: '3518080',
    name: 'Klurahan',
  },
  {
    id: '3518080011',
    districtId: '3518080',
    name: 'Kaloran',
  },
  {
    id: '3518080012',
    districtId: '3518080',
    name: 'Kali Anyar',
  },
  {
    id: '3518080013',
    districtId: '3518080',
    name: 'Trayang',
  },
  {
    id: '3518090002',
    districtId: '3518090',
    name: 'Juwono',
  },
  {
    id: '3518090003',
    districtId: '3518090',
    name: 'Bangsri',
  },
  {
    id: '3518090004',
    districtId: '3518090',
    name: 'Kalianyar',
  },
  {
    id: '3518090005',
    districtId: '3518090',
    name: 'Tanjung',
  },
  {
    id: '3518090006',
    districtId: '3518090',
    name: 'Nglawak',
  },
  {
    id: '3518090008',
    districtId: '3518090',
    name: 'Tembarak',
  },
  {
    id: '3518090010',
    districtId: '3518090',
    name: 'Kutorejo',
  },
  {
    id: '3518090011',
    districtId: '3518090',
    name: 'Banaran',
  },
  {
    id: '3518090012',
    districtId: '3518090',
    name: 'Lambang Kuning',
  },
  {
    id: '3518090013',
    districtId: '3518090',
    name: 'Pandan Toyo',
  },
  {
    id: '3518100001',
    districtId: '3518100',
    name: 'Lestari',
  },
  {
    id: '3518100002',
    districtId: '3518100',
    name: 'Pisang',
  },
  {
    id: '3518100004',
    districtId: '3518100',
    name: 'Ngrombot',
  },
  {
    id: '3518100005',
    districtId: '3518100',
    name: 'Tirtobinangun',
  },
  {
    id: '3518100006',
    districtId: '3518100',
    name: 'Rowomarto',
  },
  {
    id: '3518100007',
    districtId: '3518100',
    name: 'Pakuncen',
  },
  {
    id: '3518100008',
    districtId: '3518100',
    name: 'Patianrowo',
  },
  {
    id: '3518100010',
    districtId: '3518100',
    name: 'Babadan',
  },
  {
    id: '3518110001',
    districtId: '3518110',
    name: 'Sambiroto',
  },
  {
    id: '3518110002',
    districtId: '3518110',
    name: 'Gebang Kerep',
  },
  {
    id: '3518110003',
    districtId: '3518110',
    name: 'Baron',
  },
  {
    id: '3518110004',
    districtId: '3518110',
    name: 'Waung',
  },
  {
    id: '3518110005',
    districtId: '3518110',
    name: 'Kemlokolegi',
  },
  {
    id: '3518110006',
    districtId: '3518110',
    name: 'Kemaduh',
  },
  {
    id: '3518110007',
    districtId: '3518110',
    name: 'Garu',
  },
  {
    id: '3518110009',
    districtId: '3518110',
    name: 'Jambi',
  },
  {
    id: '3518110010',
    districtId: '3518110',
    name: 'Mabung',
  },
  {
    id: '3518110011',
    districtId: '3518110',
    name: 'Katerban',
  },
  {
    id: '3518120001',
    districtId: '3518120',
    name: 'Sumberjo',
  },
  {
    id: '3518120002',
    districtId: '3518120',
    name: 'Nglinggo',
  },
  {
    id: '3518120003',
    districtId: '3518120',
    name: 'Mojoseto',
  },
  {
    id: '3518120004',
    districtId: '3518120',
    name: 'Karangsemi',
  },
  {
    id: '3518120005',
    districtId: '3518120',
    name: 'Senjayan',
  },
  {
    id: '3518120007',
    districtId: '3518120',
    name: 'Jaan',
  },
  {
    id: '3518120008',
    districtId: '3518120',
    name: 'Sumber Agung',
  },
  {
    id: '3518120009',
    districtId: '3518120',
    name: 'Ketawang',
  },
  {
    id: '3518120011',
    districtId: '3518120',
    name: 'Losari',
  },
  {
    id: '3518120012',
    districtId: '3518120',
    name: 'Sanggrahan',
  },
  {
    id: '3518120013',
    districtId: '3518120',
    name: 'Balong Gebang',
  },
  {
    id: '3518120014',
    districtId: '3518120',
    name: 'Pandean',
  },
  {
    id: '3518120015',
    districtId: '3518120',
    name: 'Campur',
  },
  {
    id: '3518120016',
    districtId: '3518120',
    name: 'Gondang Kulon',
  },
  {
    id: '3518120017',
    districtId: '3518120',
    name: 'Senggowar',
  },
  {
    id: '3518130001',
    districtId: '3518130',
    name: 'Sumengko',
  },
  {
    id: '3518130002',
    districtId: '3518130',
    name: 'Kapas',
  },
  {
    id: '3518130003',
    districtId: '3518130',
    name: 'Blitaran',
  },
  {
    id: '3518130004',
    districtId: '3518130',
    name: 'Kedung Soko',
  },
  {
    id: '3518130005',
    districtId: '3518130',
    name: 'Nglundo',
  },
  {
    id: '3518130007',
    districtId: '3518130',
    name: 'Sukomoro',
  },
  {
    id: '3518130009',
    districtId: '3518130',
    name: 'Ngrami',
  },
  {
    id: '3518130010',
    districtId: '3518130',
    name: 'Bagor Wetan',
  },
  {
    id: '3518140001',
    districtId: '3518140',
    name: 'Jatirejo',
  },
  {
    id: '3518140002',
    districtId: '3518140',
    name: 'Ploso',
  },
  {
    id: '3518140003',
    districtId: '3518140',
    name: 'Kramat',
  },
  {
    id: '3518140004',
    districtId: '3518140',
    name: 'Payaman',
  },
  {
    id: '3518140005',
    districtId: '3518140',
    name: 'Kartoharjo',
  },
  {
    id: '3518140006',
    districtId: '3518140',
    name: 'Cangkringan',
  },
  {
    id: '3518140007',
    districtId: '3518140',
    name: 'Bogo',
  },
  {
    id: '3518140008',
    districtId: '3518140',
    name: 'Kauman',
  },
  {
    id: '3518140009',
    districtId: '3518140',
    name: 'Ganung Kidul',
  },
  {
    id: '3518140010',
    districtId: '3518140',
    name: 'Mangun Dikaran',
  },
  {
    id: '3518140011',
    districtId: '3518140',
    name: 'Werungotok',
  },
  {
    id: '3518140012',
    districtId: '3518140',
    name: 'Begadung',
  },
  {
    id: '3518140013',
    districtId: '3518140',
    name: 'Ringin Anom',
  },
  {
    id: '3518140014',
    districtId: '3518140',
    name: 'Kedung Dowo',
  },
  {
    id: '3518140015',
    districtId: '3518140',
    name: 'Balong Pacul',
  },
  {
    id: '3518150001',
    districtId: '3518150',
    name: 'Balongrejo',
  },
  {
    id: '3518150002',
    districtId: '3518150',
    name: 'Girirejo',
  },
  {
    id: '3518150004',
    districtId: '3518150',
    name: 'Sekar Putih',
  },
  {
    id: '3518150005',
    districtId: '3518150',
    name: 'Buduran',
  },
  {
    id: '3518150007',
    districtId: '3518150',
    name: 'Bagor Kulon',
  },
  {
    id: '3518150008',
    districtId: '3518150',
    name: 'Petak',
  },
  {
    id: '3518150009',
    districtId: '3518150',
    name: 'Paron',
  },
  {
    id: '3518150010',
    districtId: '3518150',
    name: 'Karang Tengah',
  },
  {
    id: '3518150011',
    districtId: '3518150',
    name: 'Selorejo',
  },
  {
    id: '3518150012',
    districtId: '3518150',
    name: 'Gandu',
  },
  {
    id: '3518150013',
    districtId: '3518150',
    name: 'Guyangan',
  },
  {
    id: '3518150014',
    districtId: '3518150',
    name: 'Kedondong',
  },
  {
    id: '3518150015',
    districtId: '3518150',
    name: 'Sugih Waras',
  },
  {
    id: '3518150016',
    districtId: '3518150',
    name: 'Kutorejo',
  },
  {
    id: '3518150017',
    districtId: '3518150',
    name: 'Kerep Kidul',
  },
  {
    id: '3518150019',
    districtId: '3518150',
    name: 'Kendal Rejo',
  },
  {
    id: '3518150020',
    districtId: '3518150',
    name: 'Banaran Kulon',
  },
  {
    id: '3518150021',
    districtId: '3518150',
    name: 'Banaran Wetan',
  },
  {
    id: '3518160001',
    districtId: '3518160',
    name: 'Sudimoroharjo',
  },
  {
    id: '3518160002',
    districtId: '3518160',
    name: 'Ngadipiro',
  },
  {
    id: '3518160003',
    districtId: '3518160',
    name: 'Wilangan',
  },
  {
    id: '3518160004',
    districtId: '3518160',
    name: 'Mancon',
  },
  {
    id: '3518160005',
    districtId: '3518160',
    name: 'Ngudikan',
  },
  {
    id: '3518160006',
    districtId: '3518160',
    name: 'Sukoharjo',
  },
  {
    id: '3518170001',
    districtId: '3518170',
    name: 'Sidokare',
  },
  {
    id: '3518170002',
    districtId: '3518170',
    name: 'Sukorejo',
  },
  {
    id: '3518170004',
    districtId: '3518170',
    name: 'Gempol',
  },
  {
    id: '3518170006',
    districtId: '3518170',
    name: 'Mlorah',
  },
  {
    id: '3518170007',
    districtId: '3518170',
    name: 'Jatirejo',
  },
  {
    id: '3518170008',
    districtId: '3518170',
    name: 'Klagen',
  },
  {
    id: '3518170010',
    districtId: '3518170',
    name: 'Mojorembun',
  },
  {
    id: '3518170011',
    districtId: '3518170',
    name: 'Ngadiboyo',
  },
  {
    id: '3518170012',
    districtId: '3518170',
    name: 'Rejoso',
  },
  {
    id: '3518170013',
    districtId: '3518170',
    name: 'Talang',
  },
  {
    id: '3518170014',
    districtId: '3518170',
    name: 'Ngangkatan',
  },
  {
    id: '3518170015',
    districtId: '3518170',
    name: 'Talun',
  },
  {
    id: '3518170016',
    districtId: '3518170',
    name: 'Jintel',
  },
  {
    id: '3518170017',
    districtId: '3518170',
    name: 'Musir Kidul',
  },
  {
    id: '3518170018',
    districtId: '3518170',
    name: 'Banjarejo',
  },
  {
    id: '3518170019',
    districtId: '3518170',
    name: 'Sambi Kerep',
  },
  {
    id: '3518170020',
    districtId: '3518170',
    name: 'Musir Lor',
  },
  {
    id: '3518170021',
    districtId: '3518170',
    name: 'Wengkal',
  },
  {
    id: '3518170022',
    districtId: '3518170',
    name: 'Kedung Padang',
  },
  {
    id: '3518170023',
    districtId: '3518170',
    name: 'Tritik',
  },
  {
    id: '3518170024',
    districtId: '3518170',
    name: 'Benda Asri',
  },
  {
    id: '3518180001',
    districtId: '3518180',
    name: 'Sugihwaras',
  },
  {
    id: '3518180003',
    districtId: '3518180',
    name: 'Tempuran',
  },
  {
    id: '3518180004',
    districtId: '3518180',
    name: 'Lengkong Lor',
  },
  {
    id: '3518180005',
    districtId: '3518180',
    name: 'Gampeng',
  },
  {
    id: '3518180006',
    districtId: '3518180',
    name: 'Bajang',
  },
  {
    id: '3518190001',
    districtId: '3518190',
    name: 'Banjar Dowo',
  },
  {
    id: '3518190002',
    districtId: '3518190',
    name: 'Jati Punggur',
  },
  {
    id: '3518190003',
    districtId: '3518190',
    name: 'Lengkong',
  },
  {
    id: '3518190005',
    districtId: '3518190',
    name: 'Kedung Mlaten',
  },
  {
    id: '3518190006',
    districtId: '3518190',
    name: 'Prayungan',
  },
  {
    id: '3518190007',
    districtId: '3518190',
    name: 'Balong Asem',
  },
  {
    id: '3518190008',
    districtId: '3518190',
    name: 'Sawahan',
  },
  {
    id: '3518190009',
    districtId: '3518190',
    name: 'Ngringin',
  },
  {
    id: '3518190010',
    districtId: '3518190',
    name: 'Ketandan',
  },
  {
    id: '3518190011',
    districtId: '3518190',
    name: 'Banggle',
  },
  {
    id: '3518190013',
    districtId: '3518190',
    name: 'Sumbersono',
  },
  {
    id: '3518190014',
    districtId: '3518190',
    name: 'Pinggir',
  },
  {
    id: '3518190016',
    districtId: '3518190',
    name: 'Sumbermiri',
  },
  {
    id: '3518200001',
    districtId: '3518200',
    name: 'Perning',
  },
  {
    id: '3518200002',
    districtId: '3518200',
    name: 'Ngasem',
  },
  {
    id: '3518200003',
    districtId: '3518200',
    name: 'Gondang Wetan',
  },
  {
    id: '3518200004',
    districtId: '3518200',
    name: 'Jatikalen',
  },
  {
    id: '3518200005',
    districtId: '3518200',
    name: 'Dlururejo',
  },
  {
    id: '3518200007',
    districtId: '3518200',
    name: 'Lumpang Kuwik',
  },
  {
    id: '3518200008',
    districtId: '3518200',
    name: 'Dawuhan',
  },
  {
    id: '3518200010',
    districtId: '3518200',
    name: 'Pulowetan',
  },
  {
    id: '3519010001',
    districtId: '3519010',
    name: 'Tambakmas',
  },
  {
    id: '3519010002',
    districtId: '3519010',
    name: 'Tanjungrejo',
  },
  {
    id: '3519010003',
    districtId: '3519010',
    name: 'Sukorejo',
  },
  {
    id: '3519010004',
    districtId: '3519010',
    name: 'Pucanganom',
  },
  {
    id: '3519010005',
    districtId: '3519010',
    name: 'Krandegan',
  },
  {
    id: '3519010006',
    districtId: '3519010',
    name: 'Singgahan',
  },
  {
    id: '3519010007',
    districtId: '3519010',
    name: 'Sidorejo',
  },
  {
    id: '3519010008',
    districtId: '3519010',
    name: 'Palur',
  },
  {
    id: '3519010009',
    districtId: '3519010',
    name: 'Mojorejo',
  },
  {
    id: '3519010010',
    districtId: '3519010',
    name: 'Kebonsari',
  },
  {
    id: '3519010011',
    districtId: '3519010',
    name: 'Rejosari',
  },
  {
    id: '3519010012',
    districtId: '3519010',
    name: 'Balerejo',
  },
  {
    id: '3519010013',
    districtId: '3519010',
    name: 'Bacem',
  },
  {
    id: '3519010014',
    districtId: '3519010',
    name: 'Kedondong',
  },
  {
    id: '3519020001',
    districtId: '3519020',
    name: 'Banaran',
  },
  {
    id: '3519020002',
    districtId: '3519020',
    name: 'Klorogan',
  },
  {
    id: '3519020003',
    districtId: '3519020',
    name: 'Slambur',
  },
  {
    id: '3519020005',
    districtId: '3519020',
    name: 'Sareng',
  },
  {
    id: '3519020006',
    districtId: '3519020',
    name: 'Purworejo',
  },
  {
    id: '3519020007',
    districtId: '3519020',
    name: 'Sumberejo',
  },
  {
    id: '3519020008',
    districtId: '3519020',
    name: 'Jatisari',
  },
  {
    id: '3519020009',
    districtId: '3519020',
    name: 'Uteran',
  },
  {
    id: '3519020010',
    districtId: '3519020',
    name: 'Pagotan',
  },
  {
    id: '3519020011',
    districtId: '3519020',
    name: 'Jogodayuh',
  },
  {
    id: '3519020012',
    districtId: '3519020',
    name: 'Nglandung',
  },
  {
    id: '3519020013',
    districtId: '3519020',
    name: 'Samberejo',
  },
  {
    id: '3519020014',
    districtId: '3519020',
    name: 'Putat',
  },
  {
    id: '3519020015',
    districtId: '3519020',
    name: 'Sangen',
  },
  {
    id: '3519020016',
    districtId: '3519020',
    name: 'Kertosari',
  },
  {
    id: '3519020017',
    districtId: '3519020',
    name: 'Kertobanyon',
  },
  {
    id: '3519020018',
    districtId: '3519020',
    name: 'Kaibon',
  },
  {
    id: '3519020019',
    districtId: '3519020',
    name: 'Kranggan',
  },
  {
    id: '3519030001',
    districtId: '3519030',
    name: 'Lembah',
  },
  {
    id: '3519030002',
    districtId: '3519030',
    name: 'Mlilir',
  },
  {
    id: '3519030003',
    districtId: '3519030',
    name: 'Kradinan',
  },
  {
    id: '3519030005',
    districtId: '3519030',
    name: 'Blimbing',
  },
  {
    id: '3519030006',
    districtId: '3519030',
    name: 'Bader',
  },
  {
    id: '3519030007',
    districtId: '3519030',
    name: 'Candimulyo',
  },
  {
    id: '3519030008',
    districtId: '3519030',
    name: 'Glonggong',
  },
  {
    id: '3519030009',
    districtId: '3519030',
    name: 'Dolopo',
  },
  {
    id: '3519030010',
    districtId: '3519030',
    name: 'Doho',
  },
  {
    id: '3519030011',
    districtId: '3519030',
    name: 'Ketawang',
  },
  {
    id: '3519030012',
    districtId: '3519030',
    name: 'Bangunsari',
  },
  {
    id: '3519040001',
    districtId: '3519040',
    name: 'Ketandan',
  },
  {
    id: '3519040002',
    districtId: '3519040',
    name: 'Tileng',
  },
  {
    id: '3519040003',
    districtId: '3519040',
    name: 'Mendak',
  },
  {
    id: '3519040005',
    districtId: '3519040',
    name: 'Padas',
  },
  {
    id: '3519040006',
    districtId: '3519040',
    name: 'Ngranget',
  },
  {
    id: '3519040007',
    districtId: '3519040',
    name: 'Joho',
  },
  {
    id: '3519040009',
    districtId: '3519040',
    name: 'Dagangan',
  },
  {
    id: '3519040010',
    districtId: '3519040',
    name: 'Jetis',
  },
  {
    id: '3519040011',
    districtId: '3519040',
    name: 'Prambon',
  },
  {
    id: '3519040012',
    districtId: '3519040',
    name: 'Banjarejo',
  },
  {
    id: '3519040013',
    districtId: '3519040',
    name: 'Mruwak',
  },
  {
    id: '3519040014',
    districtId: '3519040',
    name: 'Banjarsari Wetan',
  },
  {
    id: '3519040015',
    districtId: '3519040',
    name: 'Banjarsari Kulon',
  },
  {
    id: '3519040016',
    districtId: '3519040',
    name: 'Sewulan',
  },
  {
    id: '3519040017',
    districtId: '3519040',
    name: 'Sukosari',
  },
  {
    id: '3519050001',
    districtId: '3519050',
    name: 'Sidorejo',
  },
  {
    id: '3519050002',
    districtId: '3519050',
    name: 'Pilangrejo',
  },
  {
    id: '3519050004',
    districtId: '3519050',
    name: 'Mojopurno',
  },
  {
    id: '3519050005',
    districtId: '3519050',
    name: 'Karangrejo',
  },
  {
    id: '3519050009',
    districtId: '3519050',
    name: 'Mojorayung',
  },
  {
    id: '3519050010',
    districtId: '3519050',
    name: 'Bantengan',
  },
  {
    id: '3519050011',
    districtId: '3519050',
    name: 'Tempursari',
  },
  {
    id: '3519050012',
    districtId: '3519050',
    name: 'Nglanduk',
  },
  {
    id: '3519050013',
    districtId: '3519050',
    name: 'Nglambangan',
  },
  {
    id: '3519050014',
    districtId: '3519050',
    name: 'Sobrah',
  },
  {
    id: '3519060001',
    districtId: '3519060',
    name: 'Bodag',
  },
  {
    id: '3519060003',
    districtId: '3519060',
    name: 'Kare',
  },
  {
    id: '3519060004',
    districtId: '3519060',
    name: 'Bolo',
  },
  {
    id: '3519060005',
    districtId: '3519060',
    name: 'Kuwiran',
  },
  {
    id: '3519060006',
    districtId: '3519060',
    name: 'Randualas',
  },
  {
    id: '3519060007',
    districtId: '3519060',
    name: 'Cermo',
  },
  {
    id: '3519060008',
    districtId: '3519060',
    name: 'Morang',
  },
  {
    id: '3519070001',
    districtId: '3519070',
    name: 'Batok',
  },
  {
    id: '3519070002',
    districtId: '3519070',
    name: 'Durenan',
  },
  {
    id: '3519070003',
    districtId: '3519070',
    name: 'Winong',
  },
  {
    id: '3519070004',
    districtId: '3519070',
    name: 'Tawangrejo',
  },
  {
    id: '3519070005',
    districtId: '3519070',
    name: 'Gemarang',
  },
  {
    id: '3519070006',
    districtId: '3519070',
    name: 'Sebayi',
  },
  {
    id: '3519070007',
    districtId: '3519070',
    name: 'Nampu',
  },
  {
    id: '3519080001',
    districtId: '3519080',
    name: 'Bajulan',
  },
  {
    id: '3519080002',
    districtId: '3519080',
    name: 'Sukorejo',
  },
  {
    id: '3519080004',
    districtId: '3519080',
    name: 'Bongsopotro',
  },
  {
    id: '3519080005',
    districtId: '3519080',
    name: 'Sidorejo',
  },
  {
    id: '3519080006',
    districtId: '3519080',
    name: 'Sugihwaras',
  },
  {
    id: '3519080007',
    districtId: '3519080',
    name: 'Bandungan',
  },
  {
    id: '3519080008',
    districtId: '3519080',
    name: 'Pajaran',
  },
  {
    id: '3519080009',
    districtId: '3519080',
    name: 'Klumutan',
  },
  {
    id: '3519080010',
    districtId: '3519080',
    name: 'Sumbersari',
  },
  {
    id: '3519080013',
    districtId: '3519080',
    name: 'Sambirejo',
  },
  {
    id: '3519080014',
    districtId: '3519080',
    name: 'Sumberbendo',
  },
  {
    id: '3519080015',
    districtId: '3519080',
    name: 'Klangon',
  },
  {
    id: '3519090001',
    districtId: '3519090',
    name: 'Purworejo',
  },
  {
    id: '3519090002',
    districtId: '3519090',
    name: 'Wonoayu',
  },
  {
    id: '3519090003',
    districtId: '3519090',
    name: 'Kedungrejo',
  },
  {
    id: '3519090004',
    districtId: '3519090',
    name: 'Kedungmaron',
  },
  {
    id: '3519090006',
    districtId: '3519090',
    name: 'Sumbergandu',
  },
  {
    id: '3519090007',
    districtId: '3519090',
    name: 'Pilangkenceng',
  },
  {
    id: '3519090009',
    districtId: '3519090',
    name: 'Pulerejo',
  },
  {
    id: '3519090010',
    districtId: '3519090',
    name: 'Ngale',
  },
  {
    id: '3519090012',
    districtId: '3519090',
    name: 'Kedung Banteng',
  },
  {
    id: '3519090013',
    districtId: '3519090',
    name: 'Luworo',
  },
  {
    id: '3519090014',
    districtId: '3519090',
    name: 'Gandul',
  },
  {
    id: '3519090015',
    districtId: '3519090',
    name: 'Ngengor',
  },
  {
    id: '3519090016',
    districtId: '3519090',
    name: 'Kenongorejo',
  },
  {
    id: '3519090018',
    districtId: '3519090',
    name: 'Dawuhan',
  },
  {
    id: '3519100001',
    districtId: '3519100',
    name: 'Blabakan',
  },
  {
    id: '3519100002',
    districtId: '3519100',
    name: 'Wonorejo',
  },
  {
    id: '3519100003',
    districtId: '3519100',
    name: 'Kebonagung',
  },
  {
    id: '3519100004',
    districtId: '3519100',
    name: 'Darmorejo',
  },
  {
    id: '3519100005',
    districtId: '3519100',
    name: 'Kaligunting',
  },
  {
    id: '3519100006',
    districtId: '3519100',
    name: 'Sidodadi',
  },
  {
    id: '3519100008',
    districtId: '3519100',
    name: 'Klecorejo',
  },
  {
    id: '3519100009',
    districtId: '3519100',
    name: 'Kaliabu',
  },
  {
    id: '3519100010',
    districtId: '3519100',
    name: 'Krajan',
  },
  {
    id: '3519100011',
    districtId: '3519100',
    name: 'Pandeyan',
  },
  {
    id: '3519100012',
    districtId: '3519100',
    name: 'Mejayan',
  },
  {
    id: '3519100013',
    districtId: '3519100',
    name: 'Bangunsari',
  },
  {
    id: '3519100014',
    districtId: '3519100',
    name: 'Ngampel',
  },
  {
    id: '3519110001',
    districtId: '3519110',
    name: 'Ngadirejo',
  },
  {
    id: '3519110002',
    districtId: '3519110',
    name: 'Jatirejo',
  },
  {
    id: '3519110003',
    districtId: '3519110',
    name: 'Banyukambang',
  },
  {
    id: '3519110004',
    districtId: '3519110',
    name: 'Sidomulyo',
  },
  {
    id: '3519110005',
    districtId: '3519110',
    name: 'Plumpungrejo',
  },
  {
    id: '3519110006',
    districtId: '3519110',
    name: 'Wonoasri',
  },
  {
    id: '3519110007',
    districtId: '3519110',
    name: 'Bancong',
  },
  {
    id: '3519110008',
    districtId: '3519110',
    name: 'Klitik',
  },
  {
    id: '3519110009',
    districtId: '3519110',
    name: 'Purwosari',
  },
  {
    id: '3519110010',
    districtId: '3519110',
    name: 'Buduran',
  },
  {
    id: '3519120001',
    districtId: '3519120',
    name: 'Garon',
  },
  {
    id: '3519120002',
    districtId: '3519120',
    name: 'Balerejo',
  },
  {
    id: '3519120003',
    districtId: '3519120',
    name: 'Kebonagung',
  },
  {
    id: '3519120004',
    districtId: '3519120',
    name: 'Gading',
  },
  {
    id: '3519120006',
    districtId: '3519120',
    name: 'Sumberbening',
  },
  {
    id: '3519120007',
    districtId: '3519120',
    name: 'Bulakrejo',
  },
  {
    id: '3519120008',
    districtId: '3519120',
    name: 'Tapelan',
  },
  {
    id: '3519120009',
    districtId: '3519120',
    name: 'Babadan Lor',
  },
  {
    id: '3519120010',
    districtId: '3519120',
    name: 'Warurejo',
  },
  {
    id: '3519120011',
    districtId: '3519120',
    name: 'Kedungjati',
  },
  {
    id: '3519120012',
    districtId: '3519120',
    name: 'Glonggong',
  },
  {
    id: '3519120013',
    districtId: '3519120',
    name: 'Sogo',
  },
  {
    id: '3519120014',
    districtId: '3519120',
    name: 'Banaran',
  },
  {
    id: '3519120015',
    districtId: '3519120',
    name: 'Kedungrejo',
  },
  {
    id: '3519120017',
    districtId: '3519120',
    name: 'Pacinan',
  },
  {
    id: '3519120018',
    districtId: '3519120',
    name: 'Simo',
  },
  {
    id: '3519130001',
    districtId: '3519130',
    name: 'Dempelan',
  },
  {
    id: '3519130003',
    districtId: '3519130',
    name: 'Sendangrejo',
  },
  {
    id: '3519130004',
    districtId: '3519130',
    name: 'Sirapan',
  },
  {
    id: '3519130005',
    districtId: '3519130',
    name: 'Dimong',
  },
  {
    id: '3519130006',
    districtId: '3519130',
    name: 'Tulungrejo',
  },
  {
    id: '3519130007',
    districtId: '3519130',
    name: 'Sumberejo',
  },
  {
    id: '3519130008',
    districtId: '3519130',
    name: 'Tanjungrejo',
  },
  {
    id: '3519130009',
    districtId: '3519130',
    name: 'Banjarsari',
  },
  {
    id: '3519130010',
    districtId: '3519130',
    name: 'Nglames',
  },
  {
    id: '3519130011',
    districtId: '3519130',
    name: 'Tiron',
  },
  {
    id: '3519130012',
    districtId: '3519130',
    name: 'Gunungsari',
  },
  {
    id: '3519130013',
    districtId: '3519130',
    name: 'Bagi',
  },
  {
    id: '3519140001',
    districtId: '3519140',
    name: 'Kanung',
  },
  {
    id: '3519140002',
    districtId: '3519140',
    name: 'Sidomulyo',
  },
  {
    id: '3519140003',
    districtId: '3519140',
    name: 'Rejosari',
  },
  {
    id: '3519140004',
    districtId: '3519140',
    name: 'Bakur',
  },
  {
    id: '3519140005',
    districtId: '3519140',
    name: 'Pucangrejo',
  },
  {
    id: '3519140006',
    districtId: '3519140',
    name: 'Krokeh',
  },
  {
    id: '3519140007',
    districtId: '3519140',
    name: 'Lebakayu',
  },
  {
    id: '3519140008',
    districtId: '3519140',
    name: 'Golan',
  },
  {
    id: '3519140009',
    districtId: '3519140',
    name: 'Cabean',
  },
  {
    id: '3519140010',
    districtId: '3519140',
    name: 'Sawahan',
  },
  {
    id: '3519140012',
    districtId: '3519140',
    name: 'Kajang',
  },
  {
    id: '3519140013',
    districtId: '3519140',
    name: 'Klumpit',
  },
  {
    id: '3519150002',
    districtId: '3519150',
    name: 'Sambirejo',
  },
  {
    id: '3519150003',
    districtId: '3519150',
    name: 'Metesih',
  },
  {
    id: '3519150004',
    districtId: '3519150',
    name: 'Jiwan',
  },
  {
    id: '3519150005',
    districtId: '3519150',
    name: 'Sukolilo',
  },
  {
    id: '3519150006',
    districtId: '3519150',
    name: 'Kincang Wetan',
  },
  {
    id: '3519150007',
    districtId: '3519150',
    name: 'Kwangsen',
  },
  {
    id: '3519150008',
    districtId: '3519150',
    name: 'Grobogan',
  },
  {
    id: '3519150009',
    districtId: '3519150',
    name: 'Wayut',
  },
  {
    id: '3519150010',
    districtId: '3519150',
    name: 'Klagen Serut',
  },
  {
    id: '3519150011',
    districtId: '3519150',
    name: 'Teguhan',
  },
  {
    id: '3519150013',
    districtId: '3519150',
    name: 'Bedoho',
  },
  {
    id: '3519150014',
    districtId: '3519150',
    name: 'Bibrik',
  },
  {
    id: '3520010001',
    districtId: '3520010',
    name: 'Gonggang',
  },
  {
    id: '3520010002',
    districtId: '3520010',
    name: 'Poncol',
  },
  {
    id: '3520010003',
    districtId: '3520010',
    name: 'Cileng',
  },
  {
    id: '3520010004',
    districtId: '3520010',
    name: 'Sombo',
  },
  {
    id: '3520010007',
    districtId: '3520010',
    name: 'Plangkrongan',
  },
  {
    id: '3520010008',
    districtId: '3520010',
    name: 'Alastuwo',
  },
  {
    id: '3520010009',
    districtId: '3520010',
    name: 'Janggan',
  },
  {
    id: '3520010010',
    districtId: '3520010',
    name: 'Genilangit',
  },
  {
    id: '3520020001',
    districtId: '3520020',
    name: 'Sayutan',
  },
  {
    id: '3520020002',
    districtId: '3520020',
    name: 'Nglopang',
  },
  {
    id: '3520020003',
    districtId: '3520020',
    name: 'Mategal',
  },
  {
    id: '3520020005',
    districtId: '3520020',
    name: 'Trosono',
  },
  {
    id: '3520020007',
    districtId: '3520020',
    name: 'Ngaglik',
  },
  {
    id: '3520020008',
    districtId: '3520020',
    name: 'Parang',
  },
  {
    id: '3520020009',
    districtId: '3520020',
    name: 'Tamanarum',
  },
  {
    id: '3520020010',
    districtId: '3520020',
    name: 'Pragak',
  },
  {
    id: '3520020012',
    districtId: '3520020',
    name: 'Krajan',
  },
  {
    id: '3520020013',
    districtId: '3520020',
    name: 'Joketro',
  },
  {
    id: '3520030001',
    districtId: '3520030',
    name: 'Kediren',
  },
  {
    id: '3520030002',
    districtId: '3520030',
    name: 'Lembeyan Kulon',
  },
  {
    id: '3520030003',
    districtId: '3520030',
    name: 'Lembeyan Wetan',
  },
  {
    id: '3520030006',
    districtId: '3520030',
    name: 'Kedungpanji',
  },
  {
    id: '3520030007',
    districtId: '3520030',
    name: 'Nguri',
  },
  {
    id: '3520030009',
    districtId: '3520030',
    name: 'Tapen',
  },
  {
    id: '3520030010',
    districtId: '3520030',
    name: 'Krowe',
  },
  {
    id: '3520040009',
    districtId: '3520040',
    name: 'Kiringan',
  },
  {
    id: '3520040011',
    districtId: '3520040',
    name: 'Tawangrejo',
  },
  {
    id: '3520040012',
    districtId: '3520040',
    name: 'Sawojajar',
  },
  {
    id: '3520040013',
    districtId: '3520040',
    name: 'Takeran',
  },
  {
    id: '3520040014',
    districtId: '3520040',
    name: 'Kuwonharjo',
  },
  {
    id: '3520040015',
    districtId: '3520040',
    name: 'Kepuhrejo',
  },
  {
    id: '3520040016',
    districtId: '3520040',
    name: 'Kerik',
  },
  {
    id: '3520040017',
    districtId: '3520040',
    name: 'Waduk',
  },
  {
    id: '3520040018',
    districtId: '3520040',
    name: 'Jomblang',
  },
  {
    id: '3520040019',
    districtId: '3520040',
    name: 'Kerang',
  },
  {
    id: '3520040020',
    districtId: '3520040',
    name: 'Madigondo',
  },
  {
    id: '3520041001',
    districtId: '3520041',
    name: 'Sukowidi',
  },
  {
    id: '3520041003',
    districtId: '3520041',
    name: 'Gorang Gareng',
  },
  {
    id: '3520041004',
    districtId: '3520041',
    name: 'Petungrejo',
  },
  {
    id: '3520041005',
    districtId: '3520041',
    name: 'Nguntoronadi',
  },
  {
    id: '3520041006',
    districtId: '3520041',
    name: 'Driyorejo',
  },
  {
    id: '3520041007',
    districtId: '3520041',
    name: 'Simbatan',
  },
  {
    id: '3520041008',
    districtId: '3520041',
    name: 'Purworejo',
  },
  {
    id: '3520041009',
    districtId: '3520041',
    name: 'Kenongomulyo',
  },
  {
    id: '3520050002',
    districtId: '3520050',
    name: 'Giripurno',
  },
  {
    id: '3520050004',
    districtId: '3520050',
    name: 'Balerejo',
  },
  {
    id: '3520050005',
    districtId: '3520050',
    name: 'Garon',
  },
  {
    id: '3520050006',
    districtId: '3520050',
    name: 'Tladan',
  },
  {
    id: '3520050007',
    districtId: '3520050',
    name: 'Pojok',
  },
  {
    id: '3520050010',
    districtId: '3520050',
    name: 'Kawedanan',
  },
  {
    id: '3520050011',
    districtId: '3520050',
    name: 'Sampung',
  },
  {
    id: '3520050012',
    districtId: '3520050',
    name: 'Mangunrejo',
  },
  {
    id: '3520050014',
    districtId: '3520050',
    name: 'Selorejo',
  },
  {
    id: '3520050015',
    districtId: '3520050',
    name: 'Jambangan',
  },
  {
    id: '3520050016',
    districtId: '3520050',
    name: 'Bogem',
  },
  {
    id: '3520050017',
    districtId: '3520050',
    name: 'Rejosari',
  },
  {
    id: '3520050019',
    districtId: '3520050',
    name: 'Mojorejo',
  },
  {
    id: '3520050020',
    districtId: '3520050',
    name: 'Genengan',
  },
  {
    id: '3520050021',
    districtId: '3520050',
    name: 'Karangrejo',
  },
  {
    id: '3520050022',
    districtId: '3520050',
    name: 'Ngadirejo',
  },
  {
    id: '3520050023',
    districtId: '3520050',
    name: 'Sugihrejo',
  },
  {
    id: '3520060009',
    districtId: '3520060',
    name: 'Ringinagung',
  },
  {
    id: '3520060013',
    districtId: '3520060',
    name: 'Candirejo',
  },
  {
    id: '3520060014',
    districtId: '3520060',
    name: 'Selosari',
  },
  {
    id: '3520060015',
    districtId: '3520060',
    name: 'Magetan',
  },
  {
    id: '3520060016',
    districtId: '3520060',
    name: 'Bulukerto',
  },
  {
    id: '3520060017',
    districtId: '3520060',
    name: 'Mangkujayan',
  },
  {
    id: '3520060018',
    districtId: '3520060',
    name: 'Tambakrejo',
  },
  {
    id: '3520060019',
    districtId: '3520060',
    name: 'Tambran',
  },
  {
    id: '3520060020',
    districtId: '3520060',
    name: 'Kebonagung',
  },
  {
    id: '3520060021',
    districtId: '3520060',
    name: 'Kepolorejo',
  },
  {
    id: '3520060022',
    districtId: '3520060',
    name: 'Tawanganom',
  },
  {
    id: '3520060023',
    districtId: '3520060',
    name: 'Sukowinangun',
  },
  {
    id: '3520060024',
    districtId: '3520060',
    name: 'Baron',
  },
  {
    id: '3520060025',
    districtId: '3520060',
    name: 'Purwosari',
  },
  {
    id: '3520061001',
    districtId: '3520061',
    name: 'Selotinatah',
  },
  {
    id: '3520061003',
    districtId: '3520061',
    name: 'Banyudono',
  },
  {
    id: '3520061004',
    districtId: '3520061',
    name: 'Banjarpanjang',
  },
  {
    id: '3520061005',
    districtId: '3520061',
    name: 'Banjarejo',
  },
  {
    id: '3520061006',
    districtId: '3520061',
    name: 'Mojopurno',
  },
  {
    id: '3520061007',
    districtId: '3520061',
    name: 'Balegondo',
  },
  {
    id: '3520061008',
    districtId: '3520061',
    name: 'Ngariboyo',
  },
  {
    id: '3520061009',
    districtId: '3520061',
    name: 'Baleasri',
  },
  {
    id: '3520061011',
    districtId: '3520061',
    name: 'Selopanggung',
  },
  {
    id: '3520061012',
    districtId: '3520061',
    name: 'Bangsri',
  },
  {
    id: '3520070001',
    districtId: '3520070',
    name: 'Ngancar',
  },
  {
    id: '3520070003',
    districtId: '3520070',
    name: 'Puntukdoro',
  },
  {
    id: '3520070005',
    districtId: '3520070',
    name: 'Bogoarum',
  },
  {
    id: '3520070006',
    districtId: '3520070',
    name: 'Randugede',
  },
  {
    id: '3520070007',
    districtId: '3520070',
    name: 'Sumberagung',
  },
  {
    id: '3520070008',
    districtId: '3520070',
    name: 'Nitikan',
  },
  {
    id: '3520070009',
    districtId: '3520070',
    name: 'Sidomukti',
  },
  {
    id: '3520070010',
    districtId: '3520070',
    name: 'Buluharjo',
  },
  {
    id: '3520070011',
    districtId: '3520070',
    name: 'Plaosan',
  },
  {
    id: '3520070012',
    districtId: '3520070',
    name: 'Dadi',
  },
  {
    id: '3520070013',
    districtId: '3520070',
    name: 'Sarangan',
  },
  {
    id: '3520070014',
    districtId: '3520070',
    name: 'Pacalan',
  },
  {
    id: '3520070015',
    districtId: '3520070',
    name: 'Sendangagung',
  },
  {
    id: '3520071001',
    districtId: '3520071',
    name: 'Getasanyar',
  },
  {
    id: '3520071002',
    districtId: '3520071',
    name: 'Sidorejo',
  },
  {
    id: '3520071003',
    districtId: '3520071',
    name: 'Durenan',
  },
  {
    id: '3520071004',
    districtId: '3520071',
    name: 'Sambirobyong',
  },
  {
    id: '3520071005',
    districtId: '3520071',
    name: 'Campursari',
  },
  {
    id: '3520071006',
    districtId: '3520071',
    name: 'Kalang',
  },
  {
    id: '3520071007',
    districtId: '3520071',
    name: 'Widorokandang',
  },
  {
    id: '3520071008',
    districtId: '3520071',
    name: 'Sidokerto',
  },
  {
    id: '3520071009',
    districtId: '3520071',
    name: 'Sumbersawit',
  },
  {
    id: '3520071010',
    districtId: '3520071',
    name: 'Sidomulyo',
  },
  {
    id: '3520080005',
    districtId: '3520080',
    name: 'Cepoko',
  },
  {
    id: '3520080006',
    districtId: '3520080',
    name: 'Milangasri',
  },
  {
    id: '3520080007',
    districtId: '3520080',
    name: 'Wates',
  },
  {
    id: '3520080008',
    districtId: '3520080',
    name: 'Panekan',
  },
  {
    id: '3520080009',
    districtId: '3520080',
    name: 'Manjung',
  },
  {
    id: '3520080010',
    districtId: '3520080',
    name: 'Tanjungsari',
  },
  {
    id: '3520080011',
    districtId: '3520080',
    name: 'Sumberdodol',
  },
  {
    id: '3520080012',
    districtId: '3520080',
    name: 'Tapak',
  },
  {
    id: '3520080013',
    districtId: '3520080',
    name: 'Sukowidi',
  },
  {
    id: '3520080014',
    districtId: '3520080',
    name: 'Bedagung',
  },
  {
    id: '3520080015',
    districtId: '3520080',
    name: 'Ngiliran',
  },
  {
    id: '3520080016',
    districtId: '3520080',
    name: 'Jabung',
  },
  {
    id: '3520080017',
    districtId: '3520080',
    name: 'Rejomulyo',
  },
  {
    id: '3520080018',
    districtId: '3520080',
    name: 'Turi',
  },
  {
    id: '3520080019',
    districtId: '3520080',
    name: 'Sidowayah',
  },
  {
    id: '3520080020',
    districtId: '3520080',
    name: 'Banjarejo',
  },
  {
    id: '3520090001',
    districtId: '3520090',
    name: 'Kalangketi',
  },
  {
    id: '3520090002',
    districtId: '3520090',
    name: 'Tamanan',
  },
  {
    id: '3520090003',
    districtId: '3520090',
    name: 'Tambakmas',
  },
  {
    id: '3520090004',
    districtId: '3520090',
    name: 'Bandar',
  },
  {
    id: '3520090005',
    districtId: '3520090',
    name: 'Bibis',
  },
  {
    id: '3520090006',
    districtId: '3520090',
    name: 'Sukomoro',
  },
  {
    id: '3520090008',
    districtId: '3520090',
    name: 'Pojoksari',
  },
  {
    id: '3520090009',
    districtId: '3520090',
    name: 'Tinap',
  },
  {
    id: '3520090010',
    districtId: '3520090',
    name: 'Kembangan',
  },
  {
    id: '3520090011',
    districtId: '3520090',
    name: 'Kedungguwo',
  },
  {
    id: '3520090012',
    districtId: '3520090',
    name: 'Kentangan',
  },
  {
    id: '3520090013',
    districtId: '3520090',
    name: 'Bogem',
  },
  {
    id: '3520100002',
    districtId: '3520100',
    name: 'Belotan',
  },
  {
    id: '3520100003',
    districtId: '3520100',
    name: 'Pingkuk',
  },
  {
    id: '3520100004',
    districtId: '3520100',
    name: 'Tanjung',
  },
  {
    id: '3520100005',
    districtId: '3520100',
    name: 'Tegalarum',
  },
  {
    id: '3520100006',
    districtId: '3520100',
    name: 'Bulak',
  },
  {
    id: '3520100007',
    districtId: '3520100',
    name: 'Soco',
  },
  {
    id: '3520100008',
    districtId: '3520100',
    name: 'Carikan',
  },
  {
    id: '3520100009',
    districtId: '3520100',
    name: 'Bendo',
  },
  {
    id: '3520100013',
    districtId: '3520100',
    name: 'Kleco',
  },
  {
    id: '3520100014',
    districtId: '3520100',
    name: 'Kledokan',
  },
  {
    id: '3520100015',
    districtId: '3520100',
    name: 'Lemahbang',
  },
  {
    id: '3520100016',
    districtId: '3520100',
    name: 'Kinandang',
  },
  {
    id: '3520110001',
    districtId: '3520110',
    name: 'Sugihwaras',
  },
  {
    id: '3520110002',
    districtId: '3520110',
    name: 'Tanjungsepreh',
  },
  {
    id: '3520110004',
    districtId: '3520110',
    name: 'Malang',
  },
  {
    id: '3520110005',
    districtId: '3520110',
    name: 'Maospati',
  },
  {
    id: '3520110006',
    districtId: '3520110',
    name: 'Klagen Gambiran',
  },
  {
    id: '3520110007',
    districtId: '3520110',
    name: 'Pandeyan',
  },
  {
    id: '3520110008',
    districtId: '3520110',
    name: 'Suratmajan',
  },
  {
    id: '3520110009',
    districtId: '3520110',
    name: 'Ronowijayan',
  },
  {
    id: '3520110011',
    districtId: '3520110',
    name: 'Sumberejo',
  },
  {
    id: '3520110013',
    districtId: '3520110',
    name: 'Kraton',
  },
  {
    id: '3520110014',
    districtId: '3520110',
    name: 'Mranggen',
  },
  {
    id: '3520110015',
    districtId: '3520110',
    name: 'Sempol',
  },
  {
    id: '3520120004',
    districtId: '3520120',
    name: 'Mantren',
  },
  {
    id: '3520120005',
    districtId: '3520120',
    name: 'Gondang',
  },
  {
    id: '3520120006',
    districtId: '3520120',
    name: 'Sambirembe',
  },
  {
    id: '3520120007',
    districtId: '3520120',
    name: 'Patihan',
  },
  {
    id: '3520120008',
    districtId: '3520120',
    name: 'Karangrejo',
  },
  {
    id: '3520120009',
    districtId: '3520120',
    name: 'Manisrejo',
  },
  {
    id: '3520120017',
    districtId: '3520120',
    name: 'Gebyog',
  },
  {
    id: '3520120018',
    districtId: '3520120',
    name: 'Prampelan',
  },
  {
    id: '3520120019',
    districtId: '3520120',
    name: 'Grabahan',
  },
  {
    id: '3520120020',
    districtId: '3520120',
    name: 'Kauman',
  },
  {
    id: '3520120021',
    districtId: '3520120',
    name: 'Maron',
  },
  {
    id: '3520120022',
    districtId: '3520120',
    name: 'Baluk',
  },
  {
    id: '3520121001',
    districtId: '3520121',
    name: 'Botok',
  },
  {
    id: '3520121002',
    districtId: '3520121',
    name: 'Ginuk',
  },
  {
    id: '3520121003',
    districtId: '3520121',
    name: 'Taji',
  },
  {
    id: '3520121004',
    districtId: '3520121',
    name: 'Temboro',
  },
  {
    id: '3520121005',
    districtId: '3520121',
    name: 'Temenggungan',
  },
  {
    id: '3520121007',
    districtId: '3520121',
    name: 'Geplak',
  },
  {
    id: '3520121008',
    districtId: '3520121',
    name: 'Karas',
  },
  {
    id: '3520121009',
    districtId: '3520121',
    name: 'Kuwon',
  },
  {
    id: '3520121010',
    districtId: '3520121',
    name: 'Sobontoro',
  },
  {
    id: '3520121011',
    districtId: '3520121',
    name: 'Sumursongo',
  },
  {
    id: '3520130001',
    districtId: '3520130',
    name: 'Banjarejo',
  },
  {
    id: '3520130002',
    districtId: '3520130',
    name: 'Purwodadi',
  },
  {
    id: '3520130003',
    districtId: '3520130',
    name: 'Karangsono',
  },
  {
    id: '3520130004',
    districtId: '3520130',
    name: 'Bogorejo',
  },
  {
    id: '3520130005',
    districtId: '3520130',
    name: 'Tebon',
  },
  {
    id: '3520130006',
    districtId: '3520130',
    name: 'Manjung',
  },
  {
    id: '3520130007',
    districtId: '3520130',
    name: 'Panggung',
  },
  {
    id: '3520130008',
    districtId: '3520130',
    name: 'Klagen',
  },
  {
    id: '3520130014',
    districtId: '3520130',
    name: 'Bangunasri',
  },
  {
    id: '3520130015',
    districtId: '3520130',
    name: 'Blaran',
  },
  {
    id: '3520130016',
    districtId: '3520130',
    name: 'Mangge',
  },
  {
    id: '3520130017',
    districtId: '3520130',
    name: 'Jonggrang',
  },
  {
    id: '3520130023',
    districtId: '3520130',
    name: 'Rejomulyo',
  },
  {
    id: '3520131001',
    districtId: '3520131',
    name: 'Klurahan',
  },
  {
    id: '3520131002',
    districtId: '3520131',
    name: 'Pencol',
  },
  {
    id: '3520131003',
    districtId: '3520131',
    name: 'Sukowidi',
  },
  {
    id: '3520131004',
    districtId: '3520131',
    name: 'Kartoharjo',
  },
  {
    id: '3520131005',
    districtId: '3520131',
    name: 'Ngelang',
  },
  {
    id: '3520131006',
    districtId: '3520131',
    name: 'Jajar',
  },
  {
    id: '3520131007',
    districtId: '3520131',
    name: 'Gunungan',
  },
  {
    id: '3520131008',
    districtId: '3520131',
    name: 'Karangmojo',
  },
  {
    id: '3520131009',
    districtId: '3520131',
    name: 'Mrahu',
  },
  {
    id: '3520131010',
    districtId: '3520131',
    name: 'Bayem Taman',
  },
  {
    id: '3520131011',
    districtId: '3520131',
    name: 'Bayem Wetan',
  },
  {
    id: '3521010001',
    districtId: '3521010',
    name: 'Wonosari',
  },
  {
    id: '3521010002',
    districtId: '3521010',
    name: 'Pandansari',
  },
  {
    id: '3521010003',
    districtId: '3521010',
    name: 'Girikerto',
  },
  {
    id: '3521010005',
    districtId: '3521010',
    name: 'Hargosari',
  },
  {
    id: '3521010006',
    districtId: '3521010',
    name: 'Pocol',
  },
  {
    id: '3521010007',
    districtId: '3521010',
    name: 'Gendol',
  },
  {
    id: '3521010008',
    districtId: '3521010',
    name: 'Sine',
  },
  {
    id: '3521010009',
    districtId: '3521010',
    name: 'Sumberejo',
  },
  {
    id: '3521010010',
    districtId: '3521010',
    name: 'Sumbersari',
  },
  {
    id: '3521010011',
    districtId: '3521010',
    name: 'Kuniran',
  },
  {
    id: '3521010012',
    districtId: '3521010',
    name: 'Tulakan',
  },
  {
    id: '3521010013',
    districtId: '3521010',
    name: 'Ketanggung',
  },
  {
    id: '3521010014',
    districtId: '3521010',
    name: 'Jagir',
  },
  {
    id: '3521010015',
    districtId: '3521010',
    name: 'Kauman',
  },
  {
    id: '3521020001',
    districtId: '3521020',
    name: 'Hargomulyo',
  },
  {
    id: '3521020002',
    districtId: '3521020',
    name: 'Giriharjo',
  },
  {
    id: '3521020003',
    districtId: '3521020',
    name: 'Setono',
  },
  {
    id: '3521020004',
    districtId: '3521020',
    name: 'Wakah',
  },
  {
    id: '3521020005',
    districtId: '3521020',
    name: 'Tawangrejo',
  },
  {
    id: '3521020006',
    districtId: '3521020',
    name: 'Sambirejo',
  },
  {
    id: '3521020007',
    districtId: '3521020',
    name: 'Manisharjo',
  },
  {
    id: '3521020008',
    districtId: '3521020',
    name: 'Sidomulyo',
  },
  {
    id: '3521020009',
    districtId: '3521020',
    name: 'Ngrambe',
  },
  {
    id: '3521020010',
    districtId: '3521020',
    name: 'Babadan',
  },
  {
    id: '3521020011',
    districtId: '3521020',
    name: 'Krandegan',
  },
  {
    id: '3521020012',
    districtId: '3521020',
    name: 'Pucangan',
  },
  {
    id: '3521020013',
    districtId: '3521020',
    name: 'Cepoko',
  },
  {
    id: '3521020014',
    districtId: '3521020',
    name: 'Mendiro',
  },
  {
    id: '3521030001',
    districtId: '3521030',
    name: 'Umbulrejo',
  },
  {
    id: '3521030002',
    districtId: '3521030',
    name: 'Kletekan',
  },
  {
    id: '3521030003',
    districtId: '3521030',
    name: 'Jaten',
  },
  {
    id: '3521030004',
    districtId: '3521030',
    name: 'Girimulyo',
  },
  {
    id: '3521030005',
    districtId: '3521030',
    name: 'Ngrayudan',
  },
  {
    id: '3521030006',
    districtId: '3521030',
    name: 'Talang',
  },
  {
    id: '3521030007',
    districtId: '3521030',
    name: 'Macanan',
  },
  {
    id: '3521030009',
    districtId: '3521030',
    name: 'Jogorogo',
  },
  {
    id: '3521030010',
    districtId: '3521030',
    name: 'Dawung',
  },
  {
    id: '3521030011',
    districtId: '3521030',
    name: 'Tanjungsari',
  },
  {
    id: '3521030012',
    districtId: '3521030',
    name: 'Soco',
  },
  {
    id: '3521040001',
    districtId: '3521040',
    name: 'Karanggupito',
  },
  {
    id: '3521040002',
    districtId: '3521040',
    name: 'Karangrejo',
  },
  {
    id: '3521040003',
    districtId: '3521040',
    name: 'Simo',
  },
  {
    id: '3521040004',
    districtId: '3521040',
    name: 'Ploso',
  },
  {
    id: '3521040005',
    districtId: '3521040',
    name: 'Majasem',
  },
  {
    id: '3521040006',
    districtId: '3521040',
    name: 'Kendal',
  },
  {
    id: '3521040007',
    districtId: '3521040',
    name: 'Sidorejo',
  },
  {
    id: '3521040008',
    districtId: '3521040',
    name: 'Gayam',
  },
  {
    id: '3521040009',
    districtId: '3521040',
    name: 'Dadapan',
  },
  {
    id: '3521040010',
    districtId: '3521040',
    name: 'Patalan',
  },
  {
    id: '3521050005',
    districtId: '3521050',
    name: 'Keras Wetan',
  },
  {
    id: '3521050006',
    districtId: '3521050',
    name: 'Keniten',
  },
  {
    id: '3521050007',
    districtId: '3521050',
    name: 'Tambakromo',
  },
  {
    id: '3521050009',
    districtId: '3521050',
    name: 'Tepas',
  },
  {
    id: '3521050011',
    districtId: '3521050',
    name: 'Sidorejo',
  },
  {
    id: '3521050012',
    districtId: '3521050',
    name: 'Baderan',
  },
  {
    id: '3521050013',
    districtId: '3521050',
    name: 'Klampisan',
  },
  {
    id: '3521050014',
    districtId: '3521050',
    name: 'Kasreman',
  },
  {
    id: '3521050015',
    districtId: '3521050',
    name: 'Kersikan',
  },
  {
    id: '3521050017',
    districtId: '3521050',
    name: 'Klitik',
  },
  {
    id: '3521050018',
    districtId: '3521050',
    name: 'Kersoharjo',
  },
  {
    id: '3521051001',
    districtId: '3521051',
    name: 'Randusongo',
  },
  {
    id: '3521051002',
    districtId: '3521051',
    name: 'Widodaren',
  },
  {
    id: '3521051003',
    districtId: '3521051',
    name: 'Gerih',
  },
  {
    id: '3521051004',
    districtId: '3521051',
    name: 'Keras Kulon',
  },
  {
    id: '3521060002',
    districtId: '3521060',
    name: 'Mojomanis',
  },
  {
    id: '3521060003',
    districtId: '3521060',
    name: 'Karangsono',
  },
  {
    id: '3521060004',
    districtId: '3521060',
    name: 'Banget',
  },
  {
    id: '3521060005',
    districtId: '3521060',
    name: 'Kwadungan',
  },
  {
    id: '3521060006',
    districtId: '3521060',
    name: 'Waruk Kalong',
  },
  {
    id: '3521060007',
    districtId: '3521060',
    name: 'Simo',
  },
  {
    id: '3521060008',
    districtId: '3521060',
    name: 'Sumengko',
  },
  {
    id: '3521060009',
    districtId: '3521060',
    name: 'Tirak',
  },
  {
    id: '3521060010',
    districtId: '3521060',
    name: 'Purwosari',
  },
  {
    id: '3521060011',
    districtId: '3521060',
    name: 'Jenangan',
  },
  {
    id: '3521060012',
    districtId: '3521060',
    name: 'Pojok',
  },
  {
    id: '3521060013',
    districtId: '3521060',
    name: 'Dinden',
  },
  {
    id: '3521070001',
    districtId: '3521070',
    name: 'Gandri',
  },
  {
    id: '3521070003',
    districtId: '3521070',
    name: 'Babadan',
  },
  {
    id: '3521070004',
    districtId: '3521070',
    name: 'Poh Konyal',
  },
  {
    id: '3521070005',
    districtId: '3521070',
    name: 'Paras',
  },
  {
    id: '3521070007',
    districtId: '3521070',
    name: 'Pangkur',
  },
  {
    id: '3521070008',
    districtId: '3521070',
    name: 'Waruk Tengah',
  },
  {
    id: '3521070009',
    districtId: '3521070',
    name: 'Ngompro',
  },
  {
    id: '3521080001',
    districtId: '3521080',
    name: 'Campur Asri',
  },
  {
    id: '3521080002',
    districtId: '3521080',
    name: 'Danguk',
  },
  {
    id: '3521080003',
    districtId: '3521080',
    name: 'Gempol',
  },
  {
    id: '3521080004',
    districtId: '3521080',
    name: 'Ringin Anom',
  },
  {
    id: '3521080006',
    districtId: '3521080',
    name: 'Sidorejo',
  },
  {
    id: '3521080007',
    districtId: '3521080',
    name: 'Dungmiri',
  },
  {
    id: '3521080008',
    districtId: '3521080',
    name: 'Brangol',
  },
  {
    id: '3521080009',
    districtId: '3521080',
    name: 'Sidokerto',
  },
  {
    id: '3521080010',
    districtId: '3521080',
    name: 'Jatipuro',
  },
  {
    id: '3521080011',
    districtId: '3521080',
    name: 'Puhti',
  },
  {
    id: '3521080012',
    districtId: '3521080',
    name: 'Sawo',
  },
  {
    id: '3521080013',
    districtId: '3521080',
    name: 'Karangjati',
  },
  {
    id: '3521080014',
    districtId: '3521080',
    name: 'Legundi',
  },
  {
    id: '3521080015',
    districtId: '3521080',
    name: 'Rejomulyo',
  },
  {
    id: '3521080016',
    districtId: '3521080',
    name: 'Rejuno',
  },
  {
    id: '3521080017',
    districtId: '3521080',
    name: 'Ploso Lor',
  },
  {
    id: '3521090001',
    districtId: '3521090',
    name: 'Lego Wetan',
  },
  {
    id: '3521090002',
    districtId: '3521090',
    name: 'Dero',
  },
  {
    id: '3521090003',
    districtId: '3521090',
    name: 'Krompol',
  },
  {
    id: '3521090004',
    districtId: '3521090',
    name: 'Mojo',
  },
  {
    id: '3521090005',
    districtId: '3521090',
    name: 'Sumber Bening',
  },
  {
    id: '3521090006',
    districtId: '3521090',
    name: 'Bringin',
  },
  {
    id: '3521090007',
    districtId: '3521090',
    name: 'Dampit',
  },
  {
    id: '3521090009',
    districtId: '3521090',
    name: 'Gandong',
  },
  {
    id: '3521090010',
    districtId: '3521090',
    name: 'Kenongorejo',
  },
  {
    id: '3521100001',
    districtId: '3521100',
    name: 'Banjaransari',
  },
  {
    id: '3521100002',
    districtId: '3521100',
    name: 'Bendo',
  },
  {
    id: '3521100003',
    districtId: '3521100',
    name: 'Tambakromo',
  },
  {
    id: '3521100004',
    districtId: '3521100',
    name: 'Tungkulrejo',
  },
  {
    id: '3521100005',
    districtId: '3521100',
    name: 'Bintoyo',
  },
  {
    id: '3521100006',
    districtId: '3521100',
    name: 'Sukowiyono',
  },
  {
    id: '3521100011',
    districtId: '3521100',
    name: 'Pacing',
  },
  {
    id: '3521100012',
    districtId: '3521100',
    name: 'Padas',
  },
  {
    id: '3521100013',
    districtId: '3521100',
    name: 'Kedung Prahu',
  },
  {
    id: '3521100014',
    districtId: '3521100',
    name: 'Sambiroto',
  },
  {
    id: '3521100015',
    districtId: '3521100',
    name: 'Kwadungan Lor',
  },
  {
    id: '3521101001',
    districtId: '3521101',
    name: 'Jatirejo',
  },
  {
    id: '3521101002',
    districtId: '3521101',
    name: 'Cangakan',
  },
  {
    id: '3521101003',
    districtId: '3521101',
    name: 'Karang Malang',
  },
  {
    id: '3521101004',
    districtId: '3521101',
    name: 'Kasreman',
  },
  {
    id: '3521101005',
    districtId: '3521101',
    name: 'Lego Kulon',
  },
  {
    id: '3521101006',
    districtId: '3521101',
    name: 'Tawun',
  },
  {
    id: '3521101007',
    districtId: '3521101',
    name: 'Kiyonten',
  },
  {
    id: '3521101008',
    districtId: '3521101',
    name: 'Gunungsari',
  },
  {
    id: '3521110001',
    districtId: '3521110',
    name: 'Mangunharjo',
  },
  {
    id: '3521110002',
    districtId: '3521110',
    name: 'Kandangan',
  },
  {
    id: '3521110003',
    districtId: '3521110',
    name: 'Kartoharjo',
  },
  {
    id: '3521110004',
    districtId: '3521110',
    name: 'Beran',
  },
  {
    id: '3521110005',
    districtId: '3521110',
    name: 'Jururejo',
  },
  {
    id: '3521110006',
    districtId: '3521110',
    name: 'Watualang',
  },
  {
    id: '3521110007',
    districtId: '3521110',
    name: 'Grudo',
  },
  {
    id: '3521110008',
    districtId: '3521110',
    name: 'Margomulyo',
  },
  {
    id: '3521110009',
    districtId: '3521110',
    name: 'Karang Tengah',
  },
  {
    id: '3521110011',
    districtId: '3521110',
    name: 'Ketanggi',
  },
  {
    id: '3521110012',
    districtId: '3521110',
    name: 'Karangasri',
  },
  {
    id: '3521110013',
    districtId: '3521110',
    name: 'Ngawi',
  },
  {
    id: '3521110014',
    districtId: '3521110',
    name: 'Karang Tengah Prandon',
  },
  {
    id: '3521110015',
    districtId: '3521110',
    name: 'Banyu Urip',
  },
  {
    id: '3521120001',
    districtId: '3521120',
    name: 'Gentong',
  },
  {
    id: '3521120002',
    districtId: '3521120',
    name: 'Babadan',
  },
  {
    id: '3521120003',
    districtId: '3521120',
    name: 'Kedung Putri',
  },
  {
    id: '3521120005',
    districtId: '3521120',
    name: 'Teguhan',
  },
  {
    id: '3521120006',
    districtId: '3521120',
    name: 'Sirigan',
  },
  {
    id: '3521120007',
    districtId: '3521120',
    name: 'Jeblogan',
  },
  {
    id: '3521120008',
    districtId: '3521120',
    name: 'Jambangan',
  },
  {
    id: '3521120009',
    districtId: '3521120',
    name: 'Tempuran',
  },
  {
    id: '3521120010',
    districtId: '3521120',
    name: 'Dawu',
  },
  {
    id: '3521120011',
    districtId: '3521120',
    name: 'Paron',
  },
  {
    id: '3521120013',
    districtId: '3521120',
    name: 'Ngale',
  },
  {
    id: '3521120014',
    districtId: '3521120',
    name: 'Kebon',
  },
  {
    id: '3521130001',
    districtId: '3521130',
    name: 'Begal',
  },
  {
    id: '3521130002',
    districtId: '3521130',
    name: 'Wonorejo',
  },
  {
    id: '3521130003',
    districtId: '3521130',
    name: 'Katikan',
  },
  {
    id: '3521130004',
    districtId: '3521130',
    name: 'Pelang Kidul',
  },
  {
    id: '3521130005',
    districtId: '3521130',
    name: 'Kedunggalar',
  },
  {
    id: '3521130006',
    districtId: '3521130',
    name: 'Jati Gembol',
  },
  {
    id: '3521130007',
    districtId: '3521130',
    name: 'Pelang Lor',
  },
  {
    id: '3521130008',
    districtId: '3521130',
    name: 'Bangunrejo Kidul',
  },
  {
    id: '3521130009',
    districtId: '3521130',
    name: 'Jenggrik',
  },
  {
    id: '3521130010',
    districtId: '3521130',
    name: 'Wonokerto',
  },
  {
    id: '3521130011',
    districtId: '3521130',
    name: 'Gemarang',
  },
  {
    id: '3521130012',
    districtId: '3521130',
    name: 'Kawu',
  },
  {
    id: '3521140001',
    districtId: '3521140',
    name: 'Banjarbanggi',
  },
  {
    id: '3521140002',
    districtId: '3521140',
    name: 'Bangunrejo Lor',
  },
  {
    id: '3521140003',
    districtId: '3521140',
    name: 'Karanggeneng',
  },
  {
    id: '3521140004',
    districtId: '3521140',
    name: 'Papungan',
  },
  {
    id: '3521140005',
    districtId: '3521140',
    name: 'Cantel',
  },
  {
    id: '3521140006',
    districtId: '3521140',
    name: 'Ngancar',
  },
  {
    id: '3521140007',
    districtId: '3521140',
    name: 'Kalang',
  },
  {
    id: '3521140008',
    districtId: '3521140',
    name: 'Pitu',
  },
  {
    id: '3521140009',
    districtId: '3521140',
    name: 'Dumplengan',
  },
  {
    id: '3521140010',
    districtId: '3521140',
    name: 'Selopuro',
  },
  {
    id: '3521150001',
    districtId: '3521150',
    name: 'Banyu Biru',
  },
  {
    id: '3521150003',
    districtId: '3521150',
    name: 'Kayutrejo',
  },
  {
    id: '3521150004',
    districtId: '3521150',
    name: 'Sekar Alas',
  },
  {
    id: '3521150005',
    districtId: '3521150',
    name: 'Sekar Putih',
  },
  {
    id: '3521150006',
    districtId: '3521150',
    name: 'Sidomakmur',
  },
  {
    id: '3521150007',
    districtId: '3521150',
    name: 'Sidolaju',
  },
  {
    id: '3521150008',
    districtId: '3521150',
    name: 'Karang Banyu',
  },
  {
    id: '3521150009',
    districtId: '3521150',
    name: 'Walikukun',
  },
  {
    id: '3521150010',
    districtId: '3521150',
    name: 'Widodaren',
  },
  {
    id: '3521150011',
    districtId: '3521150',
    name: 'Gendingan',
  },
  {
    id: '3521150012',
    districtId: '3521150',
    name: 'Kauman',
  },
  {
    id: '3521160001',
    districtId: '3521160',
    name: 'Tambak Boyo',
  },
  {
    id: '3521160002',
    districtId: '3521160',
    name: 'Pakah',
  },
  {
    id: '3521160003',
    districtId: '3521160',
    name: 'Kedungharjo',
  },
  {
    id: '3521160004',
    districtId: '3521160',
    name: 'Mantingan',
  },
  {
    id: '3521160005',
    districtId: '3521160',
    name: 'Sambirejo',
  },
  {
    id: '3521160006',
    districtId: '3521160',
    name: 'Pengkol',
  },
  {
    id: '3521160007',
    districtId: '3521160',
    name: 'Jatimulyo',
  },
  {
    id: '3521170002',
    districtId: '3521170',
    name: 'Sekarjati',
  },
  {
    id: '3521170003',
    districtId: '3521170',
    name: 'Bangunrejo',
  },
  {
    id: '3521170004',
    districtId: '3521170',
    name: 'Sri Wedari',
  },
  {
    id: '3521170006',
    districtId: '3521170',
    name: 'Pandean',
  },
  {
    id: '3521170007',
    districtId: '3521170',
    name: 'Karang Anyar',
  },
  {
    id: '3521170008',
    districtId: '3521170',
    name: 'Gembol',
  },
  {
    id: '3522010001',
    districtId: '3522010',
    name: 'Ngelo',
  },
  {
    id: '3522010002',
    districtId: '3522010',
    name: 'Kalangan',
  },
  {
    id: '3522010003',
    districtId: '3522010',
    name: 'Margomulyo',
  },
  {
    id: '3522010004',
    districtId: '3522010',
    name: 'Sumberejo',
  },
  {
    id: '3522010005',
    districtId: '3522010',
    name: 'Meduri',
  },
  {
    id: '3522020001',
    districtId: '3522020',
    name: 'Luwihaji',
  },
  {
    id: '3522020002',
    districtId: '3522020',
    name: 'Sugih Waras',
  },
  {
    id: '3522020003',
    districtId: '3522020',
    name: 'Sumberagung',
  },
  {
    id: '3522020004',
    districtId: '3522020',
    name: 'Mojorejo',
  },
  {
    id: '3522020005',
    districtId: '3522020',
    name: 'Ngraho',
  },
  {
    id: '3522020006',
    districtId: '3522020',
    name: 'Blimbing Gede',
  },
  {
    id: '3522020007',
    districtId: '3522020',
    name: 'Jumok',
  },
  {
    id: '3522020008',
    districtId: '3522020',
    name: 'Nganti',
  },
  {
    id: '3522020009',
    districtId: '3522020',
    name: 'Pandan',
  },
  {
    id: '3522020010',
    districtId: '3522020',
    name: 'Tanggungan',
  },
  {
    id: '3522020011',
    districtId: '3522020',
    name: 'Kalirejo',
  },
  {
    id: '3522020012',
    districtId: '3522020',
    name: 'Tapelan',
  },
  {
    id: '3522020013',
    districtId: '3522020',
    name: 'Sumberarum',
  },
  {
    id: '3522020014',
    districtId: '3522020',
    name: 'Payaman',
  },
  {
    id: '3522020015',
    districtId: '3522020',
    name: 'Bancer',
  },
  {
    id: '3522030001',
    districtId: '3522030',
    name: 'Jatimulyo',
  },
  {
    id: '3522030002',
    districtId: '3522030',
    name: 'Napis',
  },
  {
    id: '3522030003',
    districtId: '3522030',
    name: 'Ngrancang',
  },
  {
    id: '3522030004',
    districtId: '3522030',
    name: 'Turi',
  },
  {
    id: '3522030005',
    districtId: '3522030',
    name: 'Mulyorejo',
  },
  {
    id: '3522030006',
    districtId: '3522030',
    name: 'Kacangan',
  },
  {
    id: '3522030007',
    districtId: '3522030',
    name: 'Sendangrejo',
  },
  {
    id: '3522030008',
    districtId: '3522030',
    name: 'Dolokgede',
  },
  {
    id: '3522030009',
    districtId: '3522030',
    name: 'Maling Mati',
  },
  {
    id: '3522030010',
    districtId: '3522030',
    name: 'Tambak Rejo',
  },
  {
    id: '3522030011',
    districtId: '3522030',
    name: 'Bakalan',
  },
  {
    id: '3522030012',
    districtId: '3522030',
    name: 'Jawik',
  },
  {
    id: '3522030013',
    districtId: '3522030',
    name: 'Sukorejo',
  },
  {
    id: '3522030014',
    districtId: '3522030',
    name: 'Gading',
  },
  {
    id: '3522030015',
    districtId: '3522030',
    name: 'Pengkol',
  },
  {
    id: '3522030016',
    districtId: '3522030',
    name: 'Tanjung',
  },
  {
    id: '3522030017',
    districtId: '3522030',
    name: 'Gamongan',
  },
  {
    id: '3522030018',
    districtId: '3522030',
    name: 'Kalisumber',
  },
  {
    id: '3522040007',
    districtId: '3522040',
    name: 'Nglampin',
  },
  {
    id: '3522040008',
    districtId: '3522040',
    name: 'Karangmangu',
  },
  {
    id: '3522040009',
    districtId: '3522040',
    name: 'Ngambon',
  },
  {
    id: '3522040010',
    districtId: '3522040',
    name: 'Sengon',
  },
  {
    id: '3522040011',
    districtId: '3522040',
    name: 'Bondol',
  },
  {
    id: '3522041001',
    districtId: '3522041',
    name: 'Miyono',
  },
  {
    id: '3522041002',
    districtId: '3522041',
    name: 'Sekar',
  },
  {
    id: '3522041003',
    districtId: '3522041',
    name: 'Klino',
  },
  {
    id: '3522041004',
    districtId: '3522041',
    name: 'Deling',
  },
  {
    id: '3522041005',
    districtId: '3522041',
    name: 'Bareng',
  },
  {
    id: '3522041006',
    districtId: '3522041',
    name: 'Bobol',
  },
  {
    id: '3522050008',
    districtId: '3522050',
    name: 'Bubulan',
  },
  {
    id: '3522050009',
    districtId: '3522050',
    name: 'Cancung',
  },
  {
    id: '3522050011',
    districtId: '3522050',
    name: 'Sumber Bendo',
  },
  {
    id: '3522050012',
    districtId: '3522050',
    name: 'Ngorogunung',
  },
  {
    id: '3522051001',
    districtId: '3522051',
    name: 'Krondonan',
  },
  {
    id: '3522051002',
    districtId: '3522051',
    name: 'Sambongrejo',
  },
  {
    id: '3522051003',
    districtId: '3522051',
    name: 'Pajeng',
  },
  {
    id: '3522051004',
    districtId: '3522051',
    name: 'Gondang',
  },
  {
    id: '3522051005',
    districtId: '3522051',
    name: 'Jari',
  },
  {
    id: '3522051006',
    districtId: '3522051',
    name: 'Sengaten',
  },
  {
    id: '3522051007',
    districtId: '3522051',
    name: 'Pragelan',
  },
  {
    id: '3522060002',
    districtId: '3522060',
    name: 'Soko',
  },
  {
    id: '3522060003',
    districtId: '3522060',
    name: 'Papringan',
  },
  {
    id: '3522060004',
    districtId: '3522060',
    name: 'Kedungsari',
  },
  {
    id: '3522060005',
    districtId: '3522060',
    name: 'Bakulan',
  },
  {
    id: '3522060006',
    districtId: '3522060',
    name: 'Temayang',
  },
  {
    id: '3522060007',
    districtId: '3522060',
    name: 'Pandantoyo',
  },
  {
    id: '3522060009',
    districtId: '3522060',
    name: 'Jono',
  },
  {
    id: '3522060011',
    districtId: '3522060',
    name: 'Pancur',
  },
  {
    id: '3522060012',
    districtId: '3522060',
    name: 'Buntalan',
  },
  {
    id: '3522070002',
    districtId: '3522070',
    name: 'Bareng',
  },
  {
    id: '3522070003',
    districtId: '3522070',
    name: 'Alasgung',
  },
  {
    id: '3522070004',
    districtId: '3522070',
    name: 'Panunggalan',
  },
  {
    id: '3522070005',
    districtId: '3522070',
    name: 'Wedoro',
  },
  {
    id: '3522070007',
    districtId: '3522070',
    name: 'Siwalan',
  },
  {
    id: '3522070008',
    districtId: '3522070',
    name: 'Glagahan',
  },
  {
    id: '3522070009',
    districtId: '3522070',
    name: 'Panemon',
  },
  {
    id: '3522070010',
    districtId: '3522070',
    name: 'Sugihwaras',
  },
  {
    id: '3522070011',
    districtId: '3522070',
    name: 'Trate',
  },
  {
    id: '3522070012',
    districtId: '3522070',
    name: 'Nglajang',
  },
  {
    id: '3522070013',
    districtId: '3522070',
    name: 'Kedungdowo',
  },
  {
    id: '3522070014',
    districtId: '3522070',
    name: 'Glagah Wangi',
  },
  {
    id: '3522070015',
    districtId: '3522070',
    name: 'Jatitengah',
  },
  {
    id: '3522070016',
    districtId: '3522070',
    name: 'Balongrejo',
  },
  {
    id: '3522070017',
    districtId: '3522070',
    name: 'Genjor',
  },
  {
    id: '3522080001',
    districtId: '3522080',
    name: 'Babad',
  },
  {
    id: '3522080002',
    districtId: '3522080',
    name: 'Pejok',
  },
  {
    id: '3522080003',
    districtId: '3522080',
    name: 'Dayukidul',
  },
  {
    id: '3522080004',
    districtId: '3522080',
    name: 'Panjang',
  },
  {
    id: '3522080005',
    districtId: '3522080',
    name: 'Tondomulo',
  },
  {
    id: '3522080006',
    districtId: '3522080',
    name: 'Kesongo',
  },
  {
    id: '3522080008',
    districtId: '3522080',
    name: 'Mlideg',
  },
  {
    id: '3522080009',
    districtId: '3522080',
    name: 'Tumbrasanom',
  },
  {
    id: '3522080010',
    districtId: '3522080',
    name: 'Kedungadem',
  },
  {
    id: '3522080012',
    districtId: '3522080',
    name: 'Kepoh Kidul',
  },
  {
    id: '3522080014',
    districtId: '3522080',
    name: 'Kedungrejo',
  },
  {
    id: '3522080015',
    districtId: '3522080',
    name: 'Megale',
  },
  {
    id: '3522080016',
    districtId: '3522080',
    name: 'Sidorejo',
  },
  {
    id: '3522080017',
    districtId: '3522080',
    name: 'Drokilo',
  },
  {
    id: '3522080018',
    districtId: '3522080',
    name: 'Mojorejo',
  },
  {
    id: '3522080019',
    districtId: '3522080',
    name: 'Jamberejo',
  },
  {
    id: '3522080020',
    districtId: '3522080',
    name: 'Sidomulyo',
  },
  {
    id: '3522080021',
    districtId: '3522080',
    name: 'Tlogoagung',
  },
  {
    id: '3522080022',
    districtId: '3522080',
    name: 'Ngrandu',
  },
  {
    id: '3522080023',
    districtId: '3522080',
    name: 'Balongcabe',
  },
  {
    id: '3522090001',
    districtId: '3522090',
    name: 'Pejok',
  },
  {
    id: '3522090002',
    districtId: '3522090',
    name: 'Cengkir',
  },
  {
    id: '3522090003',
    districtId: '3522090',
    name: 'Kepoh',
  },
  {
    id: '3522090004',
    districtId: '3522090',
    name: 'Sidomukti',
  },
  {
    id: '3522090005',
    districtId: '3522090',
    name: 'Simorejo',
  },
  {
    id: '3522090006',
    districtId: '3522090',
    name: 'Brangkal',
  },
  {
    id: '3522090007',
    districtId: '3522090',
    name: 'Balongdowo',
  },
  {
    id: '3522090008',
    districtId: '3522090',
    name: 'Mojosari',
  },
  {
    id: '3522090010',
    districtId: '3522090',
    name: 'Krangkong',
  },
  {
    id: '3522090011',
    districtId: '3522090',
    name: 'Jipo',
  },
  {
    id: '3522090012',
    districtId: '3522090',
    name: 'Bumirejo',
  },
  {
    id: '3522090013',
    districtId: '3522090',
    name: 'Woro',
  },
  {
    id: '3522090014',
    districtId: '3522090',
    name: 'Sumberagung',
  },
  {
    id: '3522090015',
    districtId: '3522090',
    name: 'Turigede',
  },
  {
    id: '3522090016',
    districtId: '3522090',
    name: 'Sumberoto',
  },
  {
    id: '3522090017',
    districtId: '3522090',
    name: 'Pohwates',
  },
  {
    id: '3522090018',
    districtId: '3522090',
    name: 'Bayemgede',
  },
  {
    id: '3522090019',
    districtId: '3522090',
    name: 'Tlogorejo',
  },
  {
    id: '3522090023',
    districtId: '3522090',
    name: 'Ngranggon Anyar',
  },
  {
    id: '3522090024',
    districtId: '3522090',
    name: 'Karangan',
  },
  {
    id: '3522090025',
    districtId: '3522090',
    name: 'Sugihwaras',
  },
  {
    id: '3522100001',
    districtId: '3522100',
    name: 'Banjaranyar',
  },
  {
    id: '3522100002',
    districtId: '3522100',
    name: 'Ngemplak',
  },
  {
    id: '3522100003',
    districtId: '3522100',
    name: 'Sraturejo',
  },
  {
    id: '3522100004',
    districtId: '3522100',
    name: 'Blongsong',
  },
  {
    id: '3522100005',
    districtId: '3522100',
    name: 'Baureno',
  },
  {
    id: '3522100006',
    districtId: '3522100',
    name: 'Trojalu',
  },
  {
    id: '3522100007',
    districtId: '3522100',
    name: 'Tulungagung',
  },
  {
    id: '3522100008',
    districtId: '3522100',
    name: 'Selorejo',
  },
  {
    id: '3522100009',
    districtId: '3522100',
    name: 'Tlogoagung',
  },
  {
    id: '3522100010',
    districtId: '3522100',
    name: 'Sumuragung',
  },
  {
    id: '3522100011',
    districtId: '3522100',
    name: 'Gajah',
  },
  {
    id: '3522100012',
    districtId: '3522100',
    name: 'Gunungsari',
  },
  {
    id: '3522100013',
    districtId: '3522100',
    name: 'Kalisari',
  },
  {
    id: '3522100014',
    districtId: '3522100',
    name: 'Tanggungan',
  },
  {
    id: '3522100015',
    districtId: '3522100',
    name: 'Lebaksari',
  },
  {
    id: '3522100016',
    districtId: '3522100',
    name: 'Bumiayu',
  },
  {
    id: '3522100017',
    districtId: '3522100',
    name: 'Kauman',
  },
  {
    id: '3522100018',
    districtId: '3522100',
    name: 'Pasinan',
  },
  {
    id: '3522100019',
    districtId: '3522100',
    name: 'Banjaran',
  },
  {
    id: '3522100020',
    districtId: '3522100',
    name: 'Drajat',
  },
  {
    id: '3522100021',
    districtId: '3522100',
    name: 'Sembunglor',
  },
  {
    id: '3522100022',
    districtId: '3522100',
    name: 'Pomahan',
  },
  {
    id: '3522100023',
    districtId: '3522100',
    name: 'Karangdayu',
  },
  {
    id: '3522100024',
    districtId: '3522100',
    name: 'Kadungrejo',
  },
  {
    id: '3522100025',
    districtId: '3522100',
    name: 'Pucangarum',
  },
  {
    id: '3522110001',
    districtId: '3522110',
    name: 'Sarangan',
  },
  {
    id: '3522110002',
    districtId: '3522110',
    name: 'Tejo',
  },
  {
    id: '3522110004',
    districtId: '3522110',
    name: 'Samberan',
  },
  {
    id: '3522110005',
    districtId: '3522110',
    name: 'Nglarangan',
  },
  {
    id: '3522110006',
    districtId: '3522110',
    name: 'Sroyo',
  },
  {
    id: '3522110007',
    districtId: '3522110',
    name: 'Bakung',
  },
  {
    id: '3522110008',
    districtId: '3522110',
    name: 'Palembon',
  },
  {
    id: '3522110009',
    districtId: '3522110',
    name: 'Simbatan',
  },
  {
    id: '3522110010',
    districtId: '3522110',
    name: 'Cangakan',
  },
  {
    id: '3522110011',
    districtId: '3522110',
    name: 'Kabalan',
  },
  {
    id: '3522110012',
    districtId: '3522110',
    name: 'Piyak',
  },
  {
    id: '3522110013',
    districtId: '3522110',
    name: 'Caruban',
  },
  {
    id: '3522110016',
    districtId: '3522110',
    name: 'Simorejo',
  },
  {
    id: '3522110017',
    districtId: '3522110',
    name: 'Sumberwangi',
  },
  {
    id: '3522110018',
    districtId: '3522110',
    name: 'Tambahrejo',
  },
  {
    id: '3522110019',
    districtId: '3522110',
    name: 'Kanor',
  },
  {
    id: '3522110020',
    districtId: '3522110',
    name: 'Prigi',
  },
  {
    id: '3522110022',
    districtId: '3522110',
    name: 'Kedungprimpen',
  },
  {
    id: '3522110023',
    districtId: '3522110',
    name: 'Gedongarum',
  },
  {
    id: '3522110024',
    districtId: '3522110',
    name: 'Pilang',
  },
  {
    id: '3522110025',
    districtId: '3522110',
    name: 'Semambung',
  },
  {
    id: '3522120001',
    districtId: '3522120',
    name: 'Tlogohaji',
  },
  {
    id: '3522120002',
    districtId: '3522120',
    name: 'Ngampal',
  },
  {
    id: '3522120003',
    districtId: '3522120',
    name: 'Kedungrejo',
  },
  {
    id: '3522120004',
    districtId: '3522120',
    name: 'Mlinjeng',
  },
  {
    id: '3522120005',
    districtId: '3522120',
    name: 'Sumberharjo',
  },
  {
    id: '3522120006',
    districtId: '3522120',
    name: 'Banjarjo',
  },
  {
    id: '3522120007',
    districtId: '3522120',
    name: 'Kayulemah',
  },
  {
    id: '3522120009',
    districtId: '3522120',
    name: 'Wotan',
  },
  {
    id: '3522120010',
    districtId: '3522120',
    name: 'Sambongrejo',
  },
  {
    id: '3522120011',
    districtId: '3522120',
    name: 'Sendangagung',
  },
  {
    id: '3522120013',
    districtId: '3522120',
    name: 'Pekuwon',
  },
  {
    id: '3522120014',
    districtId: '3522120',
    name: 'Karangdowo',
  },
  {
    id: '3522120015',
    districtId: '3522120',
    name: 'Pejambon',
  },
  {
    id: '3522120016',
    districtId: '3522120',
    name: 'Tulungrejo',
  },
  {
    id: '3522120017',
    districtId: '3522120',
    name: 'Karang Dinoyo',
  },
  {
    id: '3522120018',
    districtId: '3522120',
    name: 'Butoh',
  },
  {
    id: '3522120019',
    districtId: '3522120',
    name: 'Margoagung',
  },
  {
    id: '3522120020',
    districtId: '3522120',
    name: 'Jatigede',
  },
  {
    id: '3522120021',
    districtId: '3522120',
    name: 'Bogangin',
  },
  {
    id: '3522120022',
    districtId: '3522120',
    name: 'Sumuragung',
  },
  {
    id: '3522120023',
    districtId: '3522120',
    name: 'Sumberrejo',
  },
  {
    id: '3522120024',
    districtId: '3522120',
    name: 'Talun',
  },
  {
    id: '3522120025',
    districtId: '3522120',
    name: 'Prayungan',
  },
  {
    id: '3522130001',
    districtId: '3522130',
    name: 'Sidobandung',
  },
  {
    id: '3522130002',
    districtId: '3522130',
    name: 'Mayangkawis',
  },
  {
    id: '3522130004',
    districtId: '3522130',
    name: 'Poh Bogo',
  },
  {
    id: '3522130005',
    districtId: '3522130',
    name: 'Penganten',
  },
  {
    id: '3522130006',
    districtId: '3522130',
    name: 'Bulaklo',
  },
  {
    id: '3522130008',
    districtId: '3522130',
    name: 'Kemamang',
  },
  {
    id: '3522130009',
    districtId: '3522130',
    name: 'Ngadiluhur',
  },
  {
    id: '3522130010',
    districtId: '3522130',
    name: 'Kabunan',
  },
  {
    id: '3522130011',
    districtId: '3522130',
    name: 'Suwaloh',
  },
  {
    id: '3522130012',
    districtId: '3522130',
    name: 'Sobontoro',
  },
  {
    id: '3522130013',
    districtId: '3522130',
    name: 'Balenrejo',
  },
  {
    id: '3522130014',
    districtId: '3522130',
    name: 'Margomulyo',
  },
  {
    id: '3522130015',
    districtId: '3522130',
    name: 'Kedungbondo',
  },
  {
    id: '3522130016',
    districtId: '3522130',
    name: 'Pilang Gede',
  },
  {
    id: '3522130017',
    districtId: '3522130',
    name: 'Kedungdowo',
  },
  {
    id: '3522130018',
    districtId: '3522130',
    name: 'Lengkong',
  },
  {
    id: '3522130019',
    districtId: '3522130',
    name: 'Prambatan',
  },
  {
    id: '3522130020',
    districtId: '3522130',
    name: 'Mulyoagung',
  },
  {
    id: '3522130021',
    districtId: '3522130',
    name: 'Sekaran',
  },
  {
    id: '3522130022',
    districtId: '3522130',
    name: 'Mulyorejo',
  },
  {
    id: '3522130023',
    districtId: '3522130',
    name: 'Sarirejo',
  },
  {
    id: '3522140001',
    districtId: '3522140',
    name: 'Kalicilik',
  },
  {
    id: '3522140002',
    districtId: '3522140',
    name: 'Semawot',
  },
  {
    id: '3522140004',
    districtId: '3522140',
    name: 'Tegalkodo',
  },
  {
    id: '3522140005',
    districtId: '3522140',
    name: 'Sitiaji',
  },
  {
    id: '3522140006',
    districtId: '3522140',
    name: 'Purwoasri',
  },
  {
    id: '3522140007',
    districtId: '3522140',
    name: 'Pacing',
  },
  {
    id: '3522140008',
    districtId: '3522140',
    name: 'Duyungan',
  },
  {
    id: '3522140010',
    districtId: '3522140',
    name: 'Semen Kidul',
  },
  {
    id: '3522140011',
    districtId: '3522140',
    name: 'Sukosewu',
  },
  {
    id: '3522140012',
    districtId: '3522140',
    name: 'Sumberejo Kidul',
  },
  {
    id: '3522140013',
    districtId: '3522140',
    name: 'Sidorejo',
  },
  {
    id: '3522140014',
    districtId: '3522140',
    name: 'Sidodadi',
  },
  {
    id: '3522150001',
    districtId: '3522150',
    name: 'Bendo',
  },
  {
    id: '3522150002',
    districtId: '3522150',
    name: 'Kumpul Rejo',
  },
  {
    id: '3522150003',
    districtId: '3522150',
    name: 'Padang Mentoyo',
  },
  {
    id: '3522150004',
    districtId: '3522150',
    name: 'Tapelan',
  },
  {
    id: '3522150005',
    districtId: '3522150',
    name: 'Bangilan',
  },
  {
    id: '3522150007',
    districtId: '3522150',
    name: 'Tanjung Harjo',
  },
  {
    id: '3522150008',
    districtId: '3522150',
    name: 'Wedi',
  },
  {
    id: '3522150009',
    districtId: '3522150',
    name: 'Kalianyar',
  },
  {
    id: '3522150010',
    districtId: '3522150',
    name: 'Ngampel',
  },
  {
    id: '3522150011',
    districtId: '3522150',
    name: 'Sambiroto',
  },
  {
    id: '3522150012',
    districtId: '3522150',
    name: 'Tikusan',
  },
  {
    id: '3522150013',
    districtId: '3522150',
    name: 'Sukowati',
  },
  {
    id: '3522150014',
    districtId: '3522150',
    name: 'Klampok',
  },
  {
    id: '3522150015',
    districtId: '3522150',
    name: 'Mojodeso',
  },
  {
    id: '3522150016',
    districtId: '3522150',
    name: 'Plesungan',
  },
  {
    id: '3522150017',
    districtId: '3522150',
    name: 'Kedaton',
  },
  {
    id: '3522150018',
    districtId: '3522150',
    name: 'Kapas',
  },
  {
    id: '3522150019',
    districtId: '3522150',
    name: 'Semen Pinggir',
  },
  {
    id: '3522150020',
    districtId: '3522150',
    name: 'Bogo',
  },
  {
    id: '3522150021',
    districtId: '3522150',
    name: 'Bakalan',
  },
  {
    id: '3522160001',
    districtId: '3522160',
    name: 'Jetak',
  },
  {
    id: '3522160002',
    districtId: '3522160',
    name: 'Pacul',
  },
  {
    id: '3522160003',
    districtId: '3522160',
    name: 'Sukorejo',
  },
  {
    id: '3522160004',
    districtId: '3522160',
    name: 'Sumbang',
  },
  {
    id: '3522160005',
    districtId: '3522160',
    name: 'Klangon',
  },
  {
    id: '3522160006',
    districtId: '3522160',
    name: 'Kepatihan',
  },
  {
    id: '3522160007',
    districtId: '3522160',
    name: 'Mojo Kampung',
  },
  {
    id: '3522160008',
    districtId: '3522160',
    name: 'Kadipaten',
  },
  {
    id: '3522160009',
    districtId: '3522160',
    name: 'Ngrowo',
  },
  {
    id: '3522160010',
    districtId: '3522160',
    name: 'Karang Pacar',
  },
  {
    id: '3522160011',
    districtId: '3522160',
    name: 'Campurjo',
  },
  {
    id: '3522160012',
    districtId: '3522160',
    name: 'Semanding',
  },
  {
    id: '3522160013',
    districtId: '3522160',
    name: 'Kalirejo',
  },
  {
    id: '3522160014',
    districtId: '3522160',
    name: 'Mulyoagung',
  },
  {
    id: '3522160015',
    districtId: '3522160',
    name: 'Banjarejo',
  },
  {
    id: '3522160016',
    districtId: '3522160',
    name: 'Ledok Wetan',
  },
  {
    id: '3522160017',
    districtId: '3522160',
    name: 'Kauman',
  },
  {
    id: '3522160018',
    districtId: '3522160',
    name: 'Ledok Kulon',
  },
  {
    id: '3522170001',
    districtId: '3522170',
    name: 'Kandangan',
  },
  {
    id: '3522170002',
    districtId: '3522170',
    name: 'Sumbang Timun',
  },
  {
    id: '3522170003',
    districtId: '3522170',
    name: 'Kanten',
  },
  {
    id: '3522170004',
    districtId: '3522170',
    name: 'Pagerwesi',
  },
  {
    id: '3522170005',
    districtId: '3522170',
    name: 'Padang',
  },
  {
    id: '3522170006',
    districtId: '3522170',
    name: 'Sumberrejo',
  },
  {
    id: '3522170007',
    districtId: '3522170',
    name: 'Mori',
  },
  {
    id: '3522170008',
    districtId: '3522170',
    name: 'Tulungrejo',
  },
  {
    id: '3522170010',
    districtId: '3522170',
    name: 'Guyangan',
  },
  {
    id: '3522170011',
    districtId: '3522170',
    name: 'Sranak',
  },
  {
    id: '3522170012',
    districtId: '3522170',
    name: 'Banjarsari',
  },
  {
    id: '3522180002',
    districtId: '3522180',
    name: 'Dander',
  },
  {
    id: '3522180003',
    districtId: '3522180',
    name: 'Growok',
  },
  {
    id: '3522180004',
    districtId: '3522180',
    name: 'Sumber Arum',
  },
  {
    id: '3522180005',
    districtId: '3522180',
    name: 'Kunci',
  },
  {
    id: '3522180006',
    districtId: '3522180',
    name: 'Jatiblimbing',
  },
  {
    id: '3522180007',
    districtId: '3522180',
    name: 'Ngraseh',
  },
  {
    id: '3522180008',
    districtId: '3522180',
    name: 'Mojoranu',
  },
  {
    id: '3522180009',
    districtId: '3522180',
    name: 'Sumodikaran',
  },
  {
    id: '3522180010',
    districtId: '3522180',
    name: 'Sendangrejo',
  },
  {
    id: '3522180011',
    districtId: '3522180',
    name: 'Karangsono',
  },
  {
    id: '3522180012',
    districtId: '3522180',
    name: 'Sumber Agung',
  },
  {
    id: '3522180013',
    districtId: '3522180',
    name: 'Ngumpak Dalem',
  },
  {
    id: '3522180014',
    districtId: '3522180',
    name: 'Sumber Tlaseh',
  },
  {
    id: '3522180015',
    districtId: '3522180',
    name: 'Ngulanan',
  },
  {
    id: '3522180016',
    districtId: '3522180',
    name: 'Ngablak',
  },
  {
    id: '3522190002',
    districtId: '3522190',
    name: 'Trenggulunan',
  },
  {
    id: '3522190003',
    districtId: '3522190',
    name: 'Butoh',
  },
  {
    id: '3522190004',
    districtId: '3522190',
    name: 'Kolong',
  },
  {
    id: '3522190005',
    districtId: '3522190',
    name: 'Mediyunan',
  },
  {
    id: '3522190006',
    districtId: '3522190',
    name: 'Ngadiluwih',
  },
  {
    id: '3522190007',
    districtId: '3522190',
    name: 'Sendangharjo',
  },
  {
    id: '3522190008',
    districtId: '3522190',
    name: 'Ngasem',
  },
  {
    id: '3522190009',
    districtId: '3522190',
    name: 'Bandungrejo',
  },
  {
    id: '3522190010',
    districtId: '3522190',
    name: 'Dukohkidul',
  },
  {
    id: '3522190011',
    districtId: '3522190',
    name: 'Sambong',
  },
  {
    id: '3522190012',
    districtId: '3522190',
    name: 'Ngantru',
  },
  {
    id: '3522190014',
    districtId: '3522190',
    name: 'Wadang',
  },
  {
    id: '3522190015',
    districtId: '3522190',
    name: 'Jampet',
  },
  {
    id: '3522190017',
    districtId: '3522190',
    name: 'Bareng',
  },
  {
    id: '3522191002',
    districtId: '3522191',
    name: 'Ngraho',
  },
  {
    id: '3522191004',
    districtId: '3522191',
    name: 'Manukan',
  },
  {
    id: '3522191006',
    districtId: '3522191',
    name: 'Katur',
  },
  {
    id: '3522191018',
    districtId: '3522191',
    name: 'Gayam',
  },
  {
    id: '3522191019',
    districtId: '3522191',
    name: 'Mojodelik',
  },
  {
    id: '3522191020',
    districtId: '3522191',
    name: 'Bonorejo',
  },
  {
    id: '3522191021',
    districtId: '3522191',
    name: 'Brabowan',
  },
  {
    id: '3522191022',
    districtId: '3522191',
    name: 'Begadon',
  },
  {
    id: '3522191023',
    districtId: '3522191',
    name: 'Ringintunggal',
  },
  {
    id: '3522200007',
    districtId: '3522200',
    name: 'Sumengko',
  },
  {
    id: '3522200008',
    districtId: '3522200',
    name: 'Mlaten',
  },
  {
    id: '3522200009',
    districtId: '3522200',
    name: 'Talok',
  },
  {
    id: '3522200010',
    districtId: '3522200',
    name: 'Brenggolo',
  },
  {
    id: '3522200011',
    districtId: '3522200',
    name: 'Grebegan',
  },
  {
    id: '3522200012',
    districtId: '3522200',
    name: 'Wotan Ngare',
  },
  {
    id: '3522200013',
    districtId: '3522200',
    name: 'Kalitidu',
  },
  {
    id: '3522200014',
    districtId: '3522200',
    name: 'Panjunan',
  },
  {
    id: '3522200015',
    districtId: '3522200',
    name: 'Mayanggeneng',
  },
  {
    id: '3522200016',
    districtId: '3522200',
    name: 'Mayangrejo',
  },
  {
    id: '3522200017',
    districtId: '3522200',
    name: 'Pilangsari',
  },
  {
    id: '3522200018',
    districtId: '3522200',
    name: 'Mojosari',
  },
  {
    id: '3522200019',
    districtId: '3522200',
    name: 'Pungpungan',
  },
  {
    id: '3522200020',
    districtId: '3522200',
    name: 'Ngujo',
  },
  {
    id: '3522200021',
    districtId: '3522200',
    name: 'Ngringinrejo',
  },
  {
    id: '3522200022',
    districtId: '3522200',
    name: 'Mojo',
  },
  {
    id: '3522200023',
    districtId: '3522200',
    name: 'Leran',
  },
  {
    id: '3522200024',
    districtId: '3522200',
    name: 'Sukoharjo',
  },
  {
    id: '3522210001',
    districtId: '3522210',
    name: 'Dukuh Lor',
  },
  {
    id: '3522210002',
    districtId: '3522210',
    name: 'Kacangan',
  },
  {
    id: '3522210003',
    districtId: '3522210',
    name: 'Kemiri',
  },
  {
    id: '3522210004',
    districtId: '3522210',
    name: 'Petak',
  },
  {
    id: '3522210005',
    districtId: '3522210',
    name: 'Kliteh',
  },
  {
    id: '3522210006',
    districtId: '3522210',
    name: 'Sudah',
  },
  {
    id: '3522210008',
    districtId: '3522210',
    name: 'Tambakromo',
  },
  {
    id: '3522210009',
    districtId: '3522210',
    name: 'Sumberejo',
  },
  {
    id: '3522210010',
    districtId: '3522210',
    name: 'Tinawun',
  },
  {
    id: '3522210011',
    districtId: '3522210',
    name: 'Banaran',
  },
  {
    id: '3522210012',
    districtId: '3522210',
    name: 'Kedungrejo',
  },
  {
    id: '3522210013',
    districtId: '3522210',
    name: 'Ketileng',
  },
  {
    id: '3522210015',
    districtId: '3522210',
    name: 'Malo',
  },
  {
    id: '3522210016',
    districtId: '3522210',
    name: 'Sukorejo',
  },
  {
    id: '3522210018',
    districtId: '3522210',
    name: 'Semlaran',
  },
  {
    id: '3522210019',
    districtId: '3522210',
    name: 'Tanggir',
  },
  {
    id: '3522210020',
    districtId: '3522210',
    name: 'Tulungagung',
  },
  {
    id: '3522220001',
    districtId: '3522220',
    name: 'Kaliombo',
  },
  {
    id: '3522220004',
    districtId: '3522220',
    name: 'Tlatah',
  },
  {
    id: '3522220005',
    districtId: '3522220',
    name: 'Tinumpuk',
  },
  {
    id: '3522220006',
    districtId: '3522220',
    name: 'Kuniran',
  },
  {
    id: '3522220007',
    districtId: '3522220',
    name: 'Donan',
  },
  {
    id: '3522220008',
    districtId: '3522220',
    name: 'Gapluk',
  },
  {
    id: '3522220010',
    districtId: '3522220',
    name: 'Sedahkidul',
  },
  {
    id: '3522220011',
    districtId: '3522220',
    name: 'Pojok',
  },
  {
    id: '3522220012',
    districtId: '3522220',
    name: 'Purwosari',
  },
  {
    id: '3522230001',
    districtId: '3522230',
    name: 'Tebon',
  },
  {
    id: '3522230002',
    districtId: '3522230',
    name: 'Prangi',
  },
  {
    id: '3522230003',
    districtId: '3522230',
    name: 'Purworejo',
  },
  {
    id: '3522230005',
    districtId: '3522230',
    name: 'Sonorejo',
  },
  {
    id: '3522230006',
    districtId: '3522230',
    name: 'Ngradin',
  },
  {
    id: '3522230008',
    districtId: '3522230',
    name: 'Kebunagung',
  },
  {
    id: '3522230009',
    districtId: '3522230',
    name: 'Banjarjo',
  },
  {
    id: '3522230011',
    districtId: '3522230',
    name: 'Ngasinan',
  },
  {
    id: '3522230012',
    districtId: '3522230',
    name: 'Cendono',
  },
  {
    id: '3522230013',
    districtId: '3522230',
    name: 'Sidorejo',
  },
  {
    id: '3522230015',
    districtId: '3522230',
    name: 'Padangan',
  },
  {
    id: '3522230016',
    districtId: '3522230',
    name: 'Dengok',
  },
  {
    id: '3522240001',
    districtId: '3522240',
    name: 'Batokan',
  },
  {
    id: '3522240003',
    districtId: '3522240',
    name: 'Tembeling',
  },
  {
    id: '3522240004',
    districtId: '3522240',
    name: 'Sidomukti',
  },
  {
    id: '3522240005',
    districtId: '3522240',
    name: 'Besah',
  },
  {
    id: '3522240006',
    districtId: '3522240',
    name: 'Sambeng',
  },
  {
    id: '3522240007',
    districtId: '3522240',
    name: 'Ngaglik',
  },
  {
    id: '3522240008',
    districtId: '3522240',
    name: 'Kasiman',
  },
  {
    id: '3522240009',
    districtId: '3522240',
    name: 'Sekaran',
  },
  {
    id: '3522240010',
    districtId: '3522240',
    name: 'Tambakmerak',
  },
  {
    id: '3522241001',
    districtId: '3522241',
    name: 'Kawengan',
  },
  {
    id: '3522241002',
    districtId: '3522241',
    name: 'Wonocolo',
  },
  {
    id: '3522241003',
    districtId: '3522241',
    name: 'Hargomulyo',
  },
  {
    id: '3522241004',
    districtId: '3522241',
    name: 'Kedewan',
  },
  {
    id: '3522241005',
    districtId: '3522241',
    name: 'Beji',
  },
  {
    id: '3523010001',
    districtId: '3523010',
    name: 'Sokogunung',
  },
  {
    id: '3523010002',
    districtId: '3523010',
    name: 'Jamprong',
  },
  {
    id: '3523010003',
    districtId: '3523010',
    name: 'Bendonglateng',
  },
  {
    id: '3523010004',
    districtId: '3523010',
    name: 'Sidorejo',
  },
  {
    id: '3523010005',
    districtId: '3523010',
    name: 'Sokogrenjeng',
  },
  {
    id: '3523010006',
    districtId: '3523010',
    name: 'Sidohasri',
  },
  {
    id: '3523010007',
    districtId: '3523010',
    name: 'Sidomukti',
  },
  {
    id: '3523010008',
    districtId: '3523010',
    name: 'Tawaran',
  },
  {
    id: '3523010009',
    districtId: '3523010',
    name: 'Jlodro',
  },
  {
    id: '3523020001',
    districtId: '3523020',
    name: 'Klakeh',
  },
  {
    id: '3523020002',
    districtId: '3523020',
    name: 'Bate',
  },
  {
    id: '3523020003',
    districtId: '3523020',
    name: 'Kablukan',
  },
  {
    id: '3523020004',
    districtId: '3523020',
    name: 'Ngrojo',
  },
  {
    id: '3523020006',
    districtId: '3523020',
    name: 'Sidokumpul',
  },
  {
    id: '3523020007',
    districtId: '3523020',
    name: 'Sidotentrem',
  },
  {
    id: '3523020008',
    districtId: '3523020',
    name: 'Bangilan',
  },
  {
    id: '3523020009',
    districtId: '3523020',
    name: 'Kedunghardjo',
  },
  {
    id: '3523020010',
    districtId: '3523020',
    name: 'Kedungmulyo',
  },
  {
    id: '3523020011',
    districtId: '3523020',
    name: 'Banjarworo',
  },
  {
    id: '3523020012',
    districtId: '3523020',
    name: 'Sidodadi',
  },
  {
    id: '3523020013',
    districtId: '3523020',
    name: 'Kedungjambangan',
  },
  {
    id: '3523020014',
    districtId: '3523020',
    name: 'Kumpulrejo',
  },
  {
    id: '3523030001',
    districtId: '3523030',
    name: 'Banyuurip',
  },
  {
    id: '3523030002',
    districtId: '3523030',
    name: 'Wonosari',
  },
  {
    id: '3523030003',
    districtId: '3523030',
    name: 'Katerban',
  },
  {
    id: '3523030004',
    districtId: '3523030',
    name: 'Rayung',
  },
  {
    id: '3523030005',
    districtId: '3523030',
    name: 'Sidoharjo',
  },
  {
    id: '3523030006',
    districtId: '3523030',
    name: 'Wanglu Wetan',
  },
  {
    id: '3523030007',
    districtId: '3523030',
    name: 'Wanglu Kulon',
  },
  {
    id: '3523030008',
    districtId: '3523030',
    name: 'Leran',
  },
  {
    id: '3523030009',
    districtId: '3523030',
    name: 'Kaligede',
  },
  {
    id: '3523030010',
    districtId: '3523030',
    name: 'Jatisari',
  },
  {
    id: '3523030011',
    districtId: '3523030',
    name: 'Medalem',
  },
  {
    id: '3523030012',
    districtId: '3523030',
    name: 'Sendang',
  },
  {
    id: '3523040001',
    districtId: '3523040',
    name: 'Binangun',
  },
  {
    id: '3523040002',
    districtId: '3523040',
    name: 'Saringembat',
  },
  {
    id: '3523040003',
    districtId: '3523040',
    name: 'Kedungjambe',
  },
  {
    id: '3523040004',
    districtId: '3523040',
    name: 'Tunggulrejo',
  },
  {
    id: '3523040005',
    districtId: '3523040',
    name: 'Tanjungrejo',
  },
  {
    id: '3523040006',
    districtId: '3523040',
    name: 'Lajo Kidul',
  },
  {
    id: '3523040007',
    districtId: '3523040',
    name: 'Tanggir',
  },
  {
    id: '3523040008',
    districtId: '3523040',
    name: 'Mergosari',
  },
  {
    id: '3523040009',
    districtId: '3523040',
    name: 'Mulyorejo',
  },
  {
    id: '3523040010',
    districtId: '3523040',
    name: 'Tingkis',
  },
  {
    id: '3523040011',
    districtId: '3523040',
    name: 'Mulyoagung',
  },
  {
    id: '3523040012',
    districtId: '3523040',
    name: 'Lajo Lor',
  },
  {
    id: '3523050001',
    districtId: '3523050',
    name: 'Manjung',
  },
  {
    id: '3523050002',
    districtId: '3523050',
    name: 'Tanggulangin',
  },
  {
    id: '3523050004',
    districtId: '3523050',
    name: 'Bringin',
  },
  {
    id: '3523050005',
    districtId: '3523050',
    name: 'Maindu',
  },
  {
    id: '3523050006',
    districtId: '3523050',
    name: 'Jetak',
  },
  {
    id: '3523050007',
    districtId: '3523050',
    name: 'Talun',
  },
  {
    id: '3523050008',
    districtId: '3523050',
    name: 'Pucangan',
  },
  {
    id: '3523050009',
    districtId: '3523050',
    name: 'Pakel',
  },
  {
    id: '3523050010',
    districtId: '3523050',
    name: 'Montongsekar',
  },
  {
    id: '3523050011',
    districtId: '3523050',
    name: 'Talangkembar',
  },
  {
    id: '3523050012',
    districtId: '3523050',
    name: 'Nguluhan',
  },
  {
    id: '3523050013',
    districtId: '3523050',
    name: 'Guwoterus',
  },
  {
    id: '3523060001',
    districtId: '3523060',
    name: 'Kemlaten',
  },
  {
    id: '3523060002',
    districtId: '3523060',
    name: 'Mergoasri',
  },
  {
    id: '3523060003',
    districtId: '3523060',
    name: 'Kumpulrejo',
  },
  {
    id: '3523060004',
    districtId: '3523060',
    name: 'Cengkong',
  },
  {
    id: '3523060005',
    districtId: '3523060',
    name: 'Brangkal',
  },
  {
    id: '3523060006',
    districtId: '3523060',
    name: 'Mergorejo',
  },
  {
    id: '3523060007',
    districtId: '3523060',
    name: 'Selogabus',
  },
  {
    id: '3523060008',
    districtId: '3523060',
    name: 'Sendangrejo',
  },
  {
    id: '3523060009',
    districtId: '3523060',
    name: 'Mojomalang',
  },
  {
    id: '3523060010',
    districtId: '3523060',
    name: 'Sugihwaras',
  },
  {
    id: '3523060011',
    districtId: '3523060',
    name: 'Suciharjo',
  },
  {
    id: '3523060012',
    districtId: '3523060',
    name: 'Pacing',
  },
  {
    id: '3523060013',
    districtId: '3523060',
    name: 'Parangbatu',
  },
  {
    id: '3523060014',
    districtId: '3523060',
    name: 'Sukorejo',
  },
  {
    id: '3523060016',
    districtId: '3523060',
    name: 'Ngawun',
  },
  {
    id: '3523060017',
    districtId: '3523060',
    name: 'Wukirharjo',
  },
  {
    id: '3523060018',
    districtId: '3523060',
    name: 'Dagangan',
  },
  {
    id: '3523070001',
    districtId: '3523070',
    name: 'Menilo',
  },
  {
    id: '3523070002',
    districtId: '3523070',
    name: 'Simo',
  },
  {
    id: '3523070003',
    districtId: '3523070',
    name: 'Kendalrejo',
  },
  {
    id: '3523070004',
    districtId: '3523070',
    name: 'Mojoagung',
  },
  {
    id: '3523070005',
    districtId: '3523070',
    name: 'Pandanwangi',
  },
  {
    id: '3523070006',
    districtId: '3523070',
    name: 'Glagahsari',
  },
  {
    id: '3523070007',
    districtId: '3523070',
    name: 'Kenongosari',
  },
  {
    id: '3523070008',
    districtId: '3523070',
    name: 'Sandingrowo',
  },
  {
    id: '3523070009',
    districtId: '3523070',
    name: 'Rahayu',
  },
  {
    id: '3523070010',
    districtId: '3523070',
    name: 'Sokosari',
  },
  {
    id: '3523070011',
    districtId: '3523070',
    name: 'Bangunrejo',
  },
  {
    id: '3523070012',
    districtId: '3523070',
    name: 'Mentoro',
  },
  {
    id: '3523070013',
    districtId: '3523070',
    name: 'Pandanagung',
  },
  {
    id: '3523070014',
    districtId: '3523070',
    name: 'Prambontergayang',
  },
  {
    id: '3523070015',
    districtId: '3523070',
    name: 'Jati',
  },
  {
    id: '3523070016',
    districtId: '3523070',
    name: 'Cekalang',
  },
  {
    id: '3523070018',
    districtId: '3523070',
    name: 'Wadung',
  },
  {
    id: '3523070019',
    districtId: '3523070',
    name: 'Klumpit',
  },
  {
    id: '3523070020',
    districtId: '3523070',
    name: 'Jegulo',
  },
  {
    id: '3523070021',
    districtId: '3523070',
    name: 'Sumurcinde',
  },
  {
    id: '3523070022',
    districtId: '3523070',
    name: 'Nguruan',
  },
  {
    id: '3523070023',
    districtId: '3523070',
    name: 'Gununganyar',
  },
  {
    id: '3523080001',
    districtId: '3523080',
    name: 'Kebonagung',
  },
  {
    id: '3523080002',
    districtId: '3523080',
    name: 'Bulurejo',
  },
  {
    id: '3523080003',
    districtId: '3523080',
    name: 'Karangtinoto',
  },
  {
    id: '3523080004',
    districtId: '3523080',
    name: 'Tambakrejo',
  },
  {
    id: '3523080005',
    districtId: '3523080',
    name: 'Kanorejo',
  },
  {
    id: '3523080006',
    districtId: '3523080',
    name: 'Ngadirejo',
  },
  {
    id: '3523080007',
    districtId: '3523080',
    name: 'Sumberejo',
  },
  {
    id: '3523080008',
    districtId: '3523080',
    name: 'Campurejo',
  },
  {
    id: '3523080009',
    districtId: '3523080',
    name: 'Banjararum',
  },
  {
    id: '3523080010',
    districtId: '3523080',
    name: 'Prambon Wetan',
  },
  {
    id: '3523080011',
    districtId: '3523080',
    name: 'Banjaragung',
  },
  {
    id: '3523080012',
    districtId: '3523080',
    name: 'Punggulrejo',
  },
  {
    id: '3523080016',
    districtId: '3523080',
    name: 'Sawahan',
  },
  {
    id: '3523080017',
    districtId: '3523080',
    name: 'Maibit',
  },
  {
    id: '3523080018',
    districtId: '3523080',
    name: 'Pekuwon',
  },
  {
    id: '3523081001',
    districtId: '3523081',
    name: 'Ngarum',
  },
  {
    id: '3523081003',
    districtId: '3523081',
    name: 'Banyubang',
  },
  {
    id: '3523081004',
    districtId: '3523081',
    name: 'Grabagan',
  },
  {
    id: '3523081005',
    districtId: '3523081',
    name: 'Waleran',
  },
  {
    id: '3523081006',
    districtId: '3523081',
    name: 'Gesikan',
  },
  {
    id: '3523081007',
    districtId: '3523081',
    name: 'Ngandong',
  },
  {
    id: '3523081008',
    districtId: '3523081',
    name: 'Dahor',
  },
  {
    id: '3523081009',
    districtId: '3523081',
    name: 'Dermawuhardjo',
  },
  {
    id: '3523081011',
    districtId: '3523081',
    name: 'Pakis',
  },
  {
    id: '3523090002',
    districtId: '3523090',
    name: 'Kesamben',
  },
  {
    id: '3523090003',
    districtId: '3523090',
    name: 'Kepohagung',
  },
  {
    id: '3523090004',
    districtId: '3523090',
    name: 'Kedungrojo',
  },
  {
    id: '3523090005',
    districtId: '3523090',
    name: 'Cangkring',
  },
  {
    id: '3523090006',
    districtId: '3523090',
    name: 'Sembungrejo',
  },
  {
    id: '3523090007',
    districtId: '3523090',
    name: 'Plandirejo',
  },
  {
    id: '3523090008',
    districtId: '3523090',
    name: 'Bandungrejo',
  },
  {
    id: '3523090009',
    districtId: '3523090',
    name: 'Klotok',
  },
  {
    id: '3523090010',
    districtId: '3523090',
    name: 'Kebomlati',
  },
  {
    id: '3523090011',
    districtId: '3523090',
    name: 'Kedungsoko',
  },
  {
    id: '3523090012',
    districtId: '3523090',
    name: 'Penidon',
  },
  {
    id: '3523090013',
    districtId: '3523090',
    name: 'Magersari',
  },
  {
    id: '3523090014',
    districtId: '3523090',
    name: 'Jatimulyo',
  },
  {
    id: '3523090015',
    districtId: '3523090',
    name: 'Plumpang',
  },
  {
    id: '3523090016',
    districtId: '3523090',
    name: 'Sumurjalak',
  },
  {
    id: '3523090017',
    districtId: '3523090',
    name: 'Ngrayung',
  },
  {
    id: '3523090018',
    districtId: '3523090',
    name: 'Sumberagung',
  },
  {
    id: '3523100001',
    districtId: '3523100',
    name: 'Patihan',
  },
  {
    id: '3523100002',
    districtId: '3523100',
    name: 'Ngadipuro',
  },
  {
    id: '3523100003',
    districtId: '3523100',
    name: 'Ngadirejo',
  },
  {
    id: '3523100005',
    districtId: '3523100',
    name: 'Widang',
  },
  {
    id: '3523100006',
    districtId: '3523100',
    name: 'Compreng',
  },
  {
    id: '3523100007',
    districtId: '3523100',
    name: 'Banjar',
  },
  {
    id: '3523100008',
    districtId: '3523100',
    name: 'Tegalsari',
  },
  {
    id: '3523100009',
    districtId: '3523100',
    name: 'Kedungharjo',
  },
  {
    id: '3523100010',
    districtId: '3523100',
    name: 'Tegalrejo',
  },
  {
    id: '3523100011',
    districtId: '3523100',
    name: 'Simorejo',
  },
  {
    id: '3523100013',
    districtId: '3523100',
    name: 'Minohorejo',
  },
  {
    id: '3523100014',
    districtId: '3523100',
    name: 'Sumberejo',
  },
  {
    id: '3523100015',
    districtId: '3523100',
    name: 'Mlangi',
  },
  {
    id: '3523110001',
    districtId: '3523110',
    name: 'Ngimbang',
  },
  {
    id: '3523110002',
    districtId: '3523110',
    name: 'Wangun',
  },
  {
    id: '3523110003',
    districtId: '3523110',
    name: 'Ketambul',
  },
  {
    id: '3523110004',
    districtId: '3523110',
    name: 'Cepokorejo',
  },
  {
    id: '3523110005',
    districtId: '3523110',
    name: 'Pliwetan',
  },
  {
    id: '3523110006',
    districtId: '3523110',
    name: 'Karangagung',
  },
  {
    id: '3523110007',
    districtId: '3523110',
    name: 'Leran Wetan',
  },
  {
    id: '3523110008',
    districtId: '3523110',
    name: 'Leran Kulon',
  },
  {
    id: '3523110009',
    districtId: '3523110',
    name: 'Glodog',
  },
  {
    id: '3523110010',
    districtId: '3523110',
    name: 'Palang',
  },
  {
    id: '3523110011',
    districtId: '3523110',
    name: 'Gesikharjo',
  },
  {
    id: '3523110012',
    districtId: '3523110',
    name: 'Pucangan',
  },
  {
    id: '3523110013',
    districtId: '3523110',
    name: 'Cendoro',
  },
  {
    id: '3523110014',
    districtId: '3523110',
    name: 'Dawung',
  },
  {
    id: '3523110015',
    districtId: '3523110',
    name: 'Tegalbang',
  },
  {
    id: '3523110017',
    districtId: '3523110',
    name: 'Kradenan',
  },
  {
    id: '3523110018',
    districtId: '3523110',
    name: 'Tasikmadu',
  },
  {
    id: '3523110019',
    districtId: '3523110',
    name: 'Panyuran',
  },
  {
    id: '3523120003',
    districtId: '3523120',
    name: 'Ngino',
  },
  {
    id: '3523120005',
    districtId: '3523120',
    name: 'Bektiharjo',
  },
  {
    id: '3523120006',
    districtId: '3523120',
    name: 'Sambongrejo',
  },
  {
    id: '3523120007',
    districtId: '3523120',
    name: 'Genaharjo',
  },
  {
    id: '3523120008',
    districtId: '3523120',
    name: 'Gesing',
  },
  {
    id: '3523120009',
    districtId: '3523120',
    name: 'Tunah',
  },
  {
    id: '3523120010',
    districtId: '3523120',
    name: 'Kowang',
  },
  {
    id: '3523120011',
    districtId: '3523120',
    name: 'Penambangan',
  },
  {
    id: '3523120012',
    districtId: '3523120',
    name: 'Semanding',
  },
  {
    id: '3523120013',
    districtId: '3523120',
    name: 'Prunggahan Wetan',
  },
  {
    id: '3523120014',
    districtId: '3523120',
    name: 'Prunggahan Kulon',
  },
  {
    id: '3523120015',
    districtId: '3523120',
    name: 'Jadi',
  },
  {
    id: '3523120016',
    districtId: '3523120',
    name: 'Boto',
  },
  {
    id: '3523120017',
    districtId: '3523120',
    name: 'Tegalagung',
  },
  {
    id: '3523120018',
    districtId: '3523120',
    name: 'Bejagung',
  },
  {
    id: '3523120019',
    districtId: '3523120',
    name: 'Gedongombo',
  },
  {
    id: '3523120020',
    districtId: '3523120',
    name: 'Karang',
  },
  {
    id: '3523130002',
    districtId: '3523130',
    name: 'Sugiharjo',
  },
  {
    id: '3523130003',
    districtId: '3523130',
    name: 'Kembangbilo',
  },
  {
    id: '3523130004',
    districtId: '3523130',
    name: 'Mondokan',
  },
  {
    id: '3523130005',
    districtId: '3523130',
    name: 'Perbon',
  },
  {
    id: '3523130006',
    districtId: '3523130',
    name: 'Latsari',
  },
  {
    id: '3523130007',
    districtId: '3523130',
    name: 'Sidorejo',
  },
  {
    id: '3523130008',
    districtId: '3523130',
    name: 'Doromukti',
  },
  {
    id: '3523130009',
    districtId: '3523130',
    name: 'Kebonsari',
  },
  {
    id: '3523130010',
    districtId: '3523130',
    name: 'Sukolilo',
  },
  {
    id: '3523130011',
    districtId: '3523130',
    name: 'Baturetno',
  },
  {
    id: '3523130012',
    districtId: '3523130',
    name: 'Sendangharjo',
  },
  {
    id: '3523130013',
    districtId: '3523130',
    name: 'Kutorejo',
  },
  {
    id: '3523130014',
    districtId: '3523130',
    name: 'Sidomulyo',
  },
  {
    id: '3523130015',
    districtId: '3523130',
    name: 'Ronggomulyo',
  },
  {
    id: '3523130016',
    districtId: '3523130',
    name: 'Kingking',
  },
  {
    id: '3523130017',
    districtId: '3523130',
    name: 'Karangsari',
  },
  {
    id: '3523140001',
    districtId: '3523140',
    name: 'Karangasem',
  },
  {
    id: '3523140002',
    districtId: '3523140',
    name: 'Socorejo',
  },
  {
    id: '3523140003',
    districtId: '3523140',
    name: 'Temaji',
  },
  {
    id: '3523140004',
    districtId: '3523140',
    name: 'Purworejo',
  },
  {
    id: '3523140005',
    districtId: '3523140',
    name: 'Tasikharjo',
  },
  {
    id: '3523140007',
    districtId: '3523140',
    name: 'Mentoso',
  },
  {
    id: '3523140008',
    districtId: '3523140',
    name: 'Rawasan',
  },
  {
    id: '3523140010',
    districtId: '3523140',
    name: 'Wadung',
  },
  {
    id: '3523140011',
    districtId: '3523140',
    name: 'Kaliuntu',
  },
  {
    id: '3523140012',
    districtId: '3523140',
    name: 'Beji',
  },
  {
    id: '3523140013',
    districtId: '3523140',
    name: 'Suwalan',
  },
  {
    id: '3523140014',
    districtId: '3523140',
    name: 'Jenggolo',
  },
  {
    id: '3523140015',
    districtId: '3523140',
    name: 'Sekardadi',
  },
  {
    id: '3523140017',
    districtId: '3523140',
    name: 'Sugihwaras',
  },
  {
    id: '3523150001',
    districtId: '3523150',
    name: 'Kapu',
  },
  {
    id: '3523150002',
    districtId: '3523150',
    name: 'Tegalrejo',
  },
  {
    id: '3523150003',
    districtId: '3523150',
    name: 'Tahulu',
  },
  {
    id: '3523150004',
    districtId: '3523150',
    name: 'Mandirejo',
  },
  {
    id: '3523150005',
    districtId: '3523150',
    name: 'Bogorejo',
  },
  {
    id: '3523150006',
    districtId: '3523150',
    name: 'Sumberejo',
  },
  {
    id: '3523150007',
    districtId: '3523150',
    name: 'Sendanghaji',
  },
  {
    id: '3523150008',
    districtId: '3523150',
    name: 'Sambonggede',
  },
  {
    id: '3523150010',
    districtId: '3523150',
    name: 'Tuwiri Wetan',
  },
  {
    id: '3523150011',
    districtId: '3523150',
    name: 'Tuwiri Kulon',
  },
  {
    id: '3523150012',
    districtId: '3523150',
    name: 'Borehbangle',
  },
  {
    id: '3523150013',
    districtId: '3523150',
    name: 'Senori',
  },
  {
    id: '3523150014',
    districtId: '3523150',
    name: 'Sembungrejo',
  },
  {
    id: '3523150015',
    districtId: '3523150',
    name: 'Pongpongan',
  },
  {
    id: '3523150016',
    districtId: '3523150',
    name: 'Temandang',
  },
  {
    id: '3523150017',
    districtId: '3523150',
    name: 'Tlogowaru',
  },
  {
    id: '3523150018',
    districtId: '3523150',
    name: 'Tobo',
  },
  {
    id: '3523150019',
    districtId: '3523150',
    name: 'Sugihan',
  },
  {
    id: '3523160002',
    districtId: '3523160',
    name: 'Wolutengah',
  },
  {
    id: '3523160003',
    districtId: '3523160',
    name: 'Trantang',
  },
  {
    id: '3523160004',
    districtId: '3523160',
    name: 'Sidonganti',
  },
  {
    id: '3523160005',
    districtId: '3523160',
    name: 'Tengger Wetan',
  },
  {
    id: '3523160006',
    districtId: '3523160',
    name: 'Hargoretno',
  },
  {
    id: '3523160007',
    districtId: '3523160',
    name: 'Temayang',
  },
  {
    id: '3523160008',
    districtId: '3523160',
    name: 'Padasan',
  },
  {
    id: '3523160009',
    districtId: '3523160',
    name: 'Karanglo',
  },
  {
    id: '3523160010',
    districtId: '3523160',
    name: 'Sumberarum',
  },
  {
    id: '3523160011',
    districtId: '3523160',
    name: 'Margomulyo',
  },
  {
    id: '3523160012',
    districtId: '3523160',
    name: 'Jarorejo',
  },
  {
    id: '3523160013',
    districtId: '3523160',
    name: 'Margorejo',
  },
  {
    id: '3523160014',
    districtId: '3523160',
    name: 'Gaji',
  },
  {
    id: '3523160015',
    districtId: '3523160',
    name: 'Kedungrejo',
  },
  {
    id: '3523160016',
    districtId: '3523160',
    name: 'Kasiman',
  },
  {
    id: '3523160017',
    districtId: '3523160',
    name: 'Mliwang',
  },
  {
    id: '3523170001',
    districtId: '3523170',
    name: 'Ngulahan',
  },
  {
    id: '3523170002',
    districtId: '3523170',
    name: 'Dikir',
  },
  {
    id: '3523170003',
    districtId: '3523170',
    name: 'Mander',
  },
  {
    id: '3523170004',
    districtId: '3523170',
    name: 'Plajan',
  },
  {
    id: '3523170005',
    districtId: '3523170',
    name: 'Belikanget',
  },
  {
    id: '3523170006',
    districtId: '3523170',
    name: 'Cokrowati',
  },
  {
    id: '3523170007',
    districtId: '3523170',
    name: 'Sotang',
  },
  {
    id: '3523170008',
    districtId: '3523170',
    name: 'Pulogede',
  },
  {
    id: '3523170009',
    districtId: '3523170',
    name: 'Gadon',
  },
  {
    id: '3523170010',
    districtId: '3523170',
    name: 'Pabeyan',
  },
  {
    id: '3523170011',
    districtId: '3523170',
    name: 'Tambakboyo',
  },
  {
    id: '3523170013',
    districtId: '3523170',
    name: 'Dasin',
  },
  {
    id: '3523170014',
    districtId: '3523170',
    name: 'Kenanti',
  },
  {
    id: '3523170015',
    districtId: '3523170',
    name: 'Sobontoro',
  },
  {
    id: '3523170016',
    districtId: '3523170',
    name: 'Sawir',
  },
  {
    id: '3523170017',
    districtId: '3523170',
    name: 'Merkawang',
  },
  {
    id: '3523170018',
    districtId: '3523170',
    name: 'Glondonggede',
  },
  {
    id: '3523180001',
    districtId: '3523180',
    name: 'Karangtengah',
  },
  {
    id: '3523180002',
    districtId: '3523180',
    name: 'Jombok',
  },
  {
    id: '3523180003',
    districtId: '3523180',
    name: 'Wotsogo',
  },
  {
    id: '3523180004',
    districtId: '3523180',
    name: 'Sidomulyo',
  },
  {
    id: '3523180005',
    districtId: '3523180',
    name: 'Jatiklabang',
  },
  {
    id: '3523180006',
    districtId: '3523180',
    name: 'Dingil',
  },
  {
    id: '3523180007',
    districtId: '3523180',
    name: 'Demit',
  },
  {
    id: '3523180008',
    districtId: '3523180',
    name: 'Sugihan',
  },
  {
    id: '3523180009',
    districtId: '3523180',
    name: 'Sadang',
  },
  {
    id: '3523180010',
    districtId: '3523180',
    name: 'Bader',
  },
  {
    id: '3523180011',
    districtId: '3523180',
    name: 'Paseyan',
  },
  {
    id: '3523180012',
    districtId: '3523180',
    name: 'Kebonharjo',
  },
  {
    id: '3523180013',
    districtId: '3523180',
    name: 'Wangi',
  },
  {
    id: '3523180014',
    districtId: '3523180',
    name: 'Ketodan',
  },
  {
    id: '3523180015',
    districtId: '3523180',
    name: 'Besowo',
  },
  {
    id: '3523180016',
    districtId: '3523180',
    name: 'Ngepon',
  },
  {
    id: '3523180017',
    districtId: '3523180',
    name: 'Kedungmakam',
  },
  {
    id: '3523180018',
    districtId: '3523180',
    name: 'Sekaran',
  },
  {
    id: '3523190001',
    districtId: '3523190',
    name: 'Jatisari',
  },
  {
    id: '3523190002',
    districtId: '3523190',
    name: 'Kayen',
  },
  {
    id: '3523190003',
    districtId: '3523190',
    name: 'Sukoharjo',
  },
  {
    id: '3523190004',
    districtId: '3523190',
    name: 'Sidomulyo',
  },
  {
    id: '3523190005',
    districtId: '3523190',
    name: 'Cingklung',
  },
  {
    id: '3523190006',
    districtId: '3523190',
    name: 'Margosuko',
  },
  {
    id: '3523190007',
    districtId: '3523190',
    name: 'Ngampelrejo',
  },
  {
    id: '3523190008',
    districtId: '3523190',
    name: 'Pugoh',
  },
  {
    id: '3523190009',
    districtId: '3523190',
    name: 'Karangrejo',
  },
  {
    id: '3523190010',
    districtId: '3523190',
    name: 'Sumberan',
  },
  {
    id: '3523190011',
    districtId: '3523190',
    name: 'Siding',
  },
  {
    id: '3523190012',
    districtId: '3523190',
    name: 'Tengger Kulon',
  },
  {
    id: '3523190013',
    districtId: '3523190',
    name: 'Ngujuran',
  },
  {
    id: '3523190014',
    districtId: '3523190',
    name: 'Tlogoagung',
  },
  {
    id: '3523190015',
    districtId: '3523190',
    name: 'Latsari',
  },
  {
    id: '3523190016',
    districtId: '3523190',
    name: 'Sukolilo',
  },
  {
    id: '3523190017',
    districtId: '3523190',
    name: 'Bulujowo',
  },
  {
    id: '3523190018',
    districtId: '3523190',
    name: 'Bulumeduro',
  },
  {
    id: '3523190019',
    districtId: '3523190',
    name: 'Banjarejo',
  },
  {
    id: '3523190020',
    districtId: '3523190',
    name: 'Tergambang',
  },
  {
    id: '3523190021',
    districtId: '3523190',
    name: 'Sembungin',
  },
  {
    id: '3523190022',
    districtId: '3523190',
    name: 'Boncong',
  },
  {
    id: '3523190023',
    districtId: '3523190',
    name: 'Bogorejo',
  },
  {
    id: '3523190024',
    districtId: '3523190',
    name: 'Bancar',
  },
  {
    id: '3524010003',
    districtId: '3524010',
    name: 'Banggle',
  },
  {
    id: '3524010004',
    districtId: '3524010',
    name: 'Mragel',
  },
  {
    id: '3524010005',
    districtId: '3524010',
    name: 'Sukorame',
  },
  {
    id: '3524010006',
    districtId: '3524010',
    name: 'Sewor',
  },
  {
    id: '3524010007',
    districtId: '3524010',
    name: 'Kedungrejo',
  },
  {
    id: '3524010008',
    districtId: '3524010',
    name: 'Wedoro',
  },
  {
    id: '3524010009',
    districtId: '3524010',
    name: 'Pendowokumpul',
  },
  {
    id: '3524020001',
    districtId: '3524020',
    name: 'Banjargondang',
  },
  {
    id: '3524020002',
    districtId: '3524020',
    name: 'Cangkring',
  },
  {
    id: '3524020003',
    districtId: '3524020',
    name: 'Kuwurejo',
  },
  {
    id: '3524020004',
    districtId: '3524020',
    name: 'Songowareng',
  },
  {
    id: '3524020005',
    districtId: '3524020',
    name: 'Sumberbanjar',
  },
  {
    id: '3524020006',
    districtId: '3524020',
    name: 'Primpen',
  },
  {
    id: '3524020007',
    districtId: '3524020',
    name: 'Bronjong',
  },
  {
    id: '3524020009',
    districtId: '3524020',
    name: 'Talunrejo',
  },
  {
    id: '3524030001',
    districtId: '3524030',
    name: 'Kedungmentawar',
  },
  {
    id: '3524030002',
    districtId: '3524030',
    name: 'Ganggantingan',
  },
  {
    id: '3524030003',
    districtId: '3524030',
    name: 'Gebangangkrik',
  },
  {
    id: '3524030005',
    districtId: '3524030',
    name: 'Mendogo',
  },
  {
    id: '3524030006',
    districtId: '3524030',
    name: 'Durikedungjero',
  },
  {
    id: '3524030007',
    districtId: '3524030',
    name: 'Lamongrejo',
  },
  {
    id: '3524030008',
    districtId: '3524030',
    name: 'Lawak',
  },
  {
    id: '3524030009',
    districtId: '3524030',
    name: 'Purwokerto',
  },
  {
    id: '3524030010',
    districtId: '3524030',
    name: 'Ngasemlemahbang',
  },
  {
    id: '3524030012',
    districtId: '3524030',
    name: 'Slaharwotan',
  },
  {
    id: '3524030013',
    districtId: '3524030',
    name: 'Kakatpenjalin',
  },
  {
    id: '3524030014',
    districtId: '3524030',
    name: 'Drujugurit',
  },
  {
    id: '3524030015',
    districtId: '3524030',
    name: 'Munungrejo',
  },
  {
    id: '3524030016',
    districtId: '3524030',
    name: 'Ngimbang',
  },
  {
    id: '3524030017',
    districtId: '3524030',
    name: 'Sendangrejo',
  },
  {
    id: '3524030018',
    districtId: '3524030',
    name: 'Girik',
  },
  {
    id: '3524030019',
    districtId: '3524030',
    name: 'Tlemang',
  },
  {
    id: '3524040001',
    districtId: '3524040',
    name: 'Wateswinangun',
  },
  {
    id: '3524040002',
    districtId: '3524040',
    name: 'Garung',
  },
  {
    id: '3524040003',
    districtId: '3524040',
    name: 'Jatipandak',
  },
  {
    id: '3524040004',
    districtId: '3524040',
    name: 'Pamotan',
  },
  {
    id: '3524040005',
    districtId: '3524040',
    name: 'Selorejo',
  },
  {
    id: '3524040006',
    districtId: '3524040',
    name: 'Kreteranggon',
  },
  {
    id: '3524040007',
    districtId: '3524040',
    name: 'Barurejo',
  },
  {
    id: '3524040008',
    districtId: '3524040',
    name: 'Candisari',
  },
  {
    id: '3524040009',
    districtId: '3524040',
    name: 'Kedungwangi',
  },
  {
    id: '3524040010',
    districtId: '3524040',
    name: 'Tenggiring',
  },
  {
    id: '3524040011',
    districtId: '3524040',
    name: 'Semampirejo',
  },
  {
    id: '3524040012',
    districtId: '3524040',
    name: 'Sidokumpul',
  },
  {
    id: '3524040013',
    districtId: '3524040',
    name: 'Pasarlegi',
  },
  {
    id: '3524040014',
    districtId: '3524040',
    name: 'Sumbersari',
  },
  {
    id: '3524040015',
    districtId: '3524040',
    name: 'Pataan',
  },
  {
    id: '3524040016',
    districtId: '3524040',
    name: 'Ardirejo',
  },
  {
    id: '3524040017',
    districtId: '3524040',
    name: 'Nogojatisari',
  },
  {
    id: '3524040018',
    districtId: '3524040',
    name: 'Gempolmanis',
  },
  {
    id: '3524040019',
    districtId: '3524040',
    name: 'Kedungbanjar',
  },
  {
    id: '3524040020',
    districtId: '3524040',
    name: 'Wudi',
  },
  {
    id: '3524040021',
    districtId: '3524040',
    name: 'Wonorejo',
  },
  {
    id: '3524040022',
    districtId: '3524040',
    name: 'Sekidang',
  },
  {
    id: '3524050001',
    districtId: '3524050',
    name: 'Sumberdadi',
  },
  {
    id: '3524050003',
    districtId: '3524050',
    name: 'Kedungsoko',
  },
  {
    id: '3524050004',
    districtId: '3524050',
    name: 'Sidomulyo',
  },
  {
    id: '3524050005',
    districtId: '3524050',
    name: 'Sukosari',
  },
  {
    id: '3524050006',
    districtId: '3524050',
    name: 'Mojosari',
  },
  {
    id: '3524050008',
    districtId: '3524050',
    name: 'Plabuhanrejo',
  },
  {
    id: '3524050010',
    districtId: '3524050',
    name: 'Sumberagung',
  },
  {
    id: '3524050011',
    districtId: '3524050',
    name: 'Mantup',
  },
  {
    id: '3524050013',
    districtId: '3524050',
    name: 'Sumberbendo',
  },
  {
    id: '3524050014',
    districtId: '3524050',
    name: 'Tunggunjagir',
  },
  {
    id: '3524050015',
    districtId: '3524050',
    name: 'Sukobendu',
  },
  {
    id: '3524060001',
    districtId: '3524060',
    name: 'Moronyamplung',
  },
  {
    id: '3524060002',
    districtId: '3524060',
    name: 'Dumpiagung',
  },
  {
    id: '3524060003',
    districtId: '3524060',
    name: 'Katemas',
  },
  {
    id: '3524060004',
    districtId: '3524060',
    name: 'Gintungan',
  },
  {
    id: '3524060005',
    districtId: '3524060',
    name: 'Pelang',
  },
  {
    id: '3524060007',
    districtId: '3524060',
    name: 'Maor',
  },
  {
    id: '3524060008',
    districtId: '3524060',
    name: 'Randubener',
  },
  {
    id: '3524060009',
    districtId: '3524060',
    name: 'Kaliwates',
  },
  {
    id: '3524060010',
    districtId: '3524060',
    name: 'Tlogoagung',
  },
  {
    id: '3524060011',
    districtId: '3524060',
    name: 'Kedungmegarih',
  },
  {
    id: '3524060012',
    districtId: '3524060',
    name: 'Kembangbahu',
  },
  {
    id: '3524060013',
    districtId: '3524060',
    name: 'Lopang',
  },
  {
    id: '3524060014',
    districtId: '3524060',
    name: 'Mangkujajar',
  },
  {
    id: '3524060015',
    districtId: '3524060',
    name: 'Kedungasri',
  },
  {
    id: '3524060016',
    districtId: '3524060',
    name: 'Doyomulyo',
  },
  {
    id: '3524060017',
    districtId: '3524060',
    name: 'Sidomukti',
  },
  {
    id: '3524060018',
    districtId: '3524060',
    name: 'Sukosongo',
  },
  {
    id: '3524070001',
    districtId: '3524070',
    name: 'Kalitengah',
  },
  {
    id: '3524070002',
    districtId: '3524070',
    name: 'Sidorejo',
  },
  {
    id: '3524070003',
    districtId: '3524070',
    name: 'Gondang Lor',
  },
  {
    id: '3524070004',
    districtId: '3524070',
    name: 'Deketagung',
  },
  {
    id: '3524070005',
    districtId: '3524070',
    name: 'Daliwangun',
  },
  {
    id: '3524070006',
    districtId: '3524070',
    name: 'Lawanganagung',
  },
  {
    id: '3524070007',
    districtId: '3524070',
    name: 'German',
  },
  {
    id: '3524070008',
    districtId: '3524070',
    name: 'Kalipang',
  },
  {
    id: '3524070009',
    districtId: '3524070',
    name: 'Karangsambigalih',
  },
  {
    id: '3524070010',
    districtId: '3524070',
    name: 'Kedungbanjar',
  },
  {
    id: '3524070011',
    districtId: '3524070',
    name: 'Bakalrejo',
  },
  {
    id: '3524070013',
    districtId: '3524070',
    name: 'Sugio',
  },
  {
    id: '3524070014',
    districtId: '3524070',
    name: 'Sekarbagus',
  },
  {
    id: '3524070015',
    districtId: '3524070',
    name: 'Jubel Kidul',
  },
  {
    id: '3524070016',
    districtId: '3524070',
    name: 'Jubel Lor',
  },
  {
    id: '3524070017',
    districtId: '3524070',
    name: 'Lebakadi',
  },
  {
    id: '3524070018',
    districtId: '3524070',
    name: 'Pangkatrejo',
  },
  {
    id: '3524070019',
    districtId: '3524070',
    name: 'Bedingin',
  },
  {
    id: '3524070020',
    districtId: '3524070',
    name: 'Kedungdadi',
  },
  {
    id: '3524070021',
    districtId: '3524070',
    name: 'Sidobogem',
  },
  {
    id: '3524080001',
    districtId: '3524080',
    name: 'Dradah Blumbang',
  },
  {
    id: '3524080002',
    districtId: '3524080',
    name: 'Mlati',
  },
  {
    id: '3524080003',
    districtId: '3524080',
    name: 'Tenggerejo',
  },
  {
    id: '3524080005',
    districtId: '3524080',
    name: 'Majenang',
  },
  {
    id: '3524080006',
    districtId: '3524080',
    name: 'Mekanderejo',
  },
  {
    id: '3524080007',
    districtId: '3524080',
    name: 'Kedungpring',
  },
  {
    id: '3524080008',
    districtId: '3524080',
    name: 'Kandangrejo',
  },
  {
    id: '3524080009',
    districtId: '3524080',
    name: 'Warungering',
  },
  {
    id: '3524080010',
    districtId: '3524080',
    name: 'Kalen',
  },
  {
    id: '3524080011',
    districtId: '3524080',
    name: 'Mojodadi',
  },
  {
    id: '3524080012',
    districtId: '3524080',
    name: 'Jatidrojok',
  },
  {
    id: '3524080013',
    districtId: '3524080',
    name: 'Tlanak',
  },
  {
    id: '3524080014',
    districtId: '3524080',
    name: 'Sidobangun',
  },
  {
    id: '3524080015',
    districtId: '3524080',
    name: 'Blawirejo',
  },
  {
    id: '3524080016',
    districtId: '3524080',
    name: 'Sidomlangean',
  },
  {
    id: '3524080017',
    districtId: '3524080',
    name: 'Maindu',
  },
  {
    id: '3524080018',
    districtId: '3524080',
    name: 'Banjarrejo',
  },
  {
    id: '3524080019',
    districtId: '3524080',
    name: 'Karangcangkring',
  },
  {
    id: '3524080020',
    districtId: '3524080',
    name: 'Sukomalo',
  },
  {
    id: '3524080021',
    districtId: '3524080',
    name: 'Sumengko',
  },
  {
    id: '3524080022',
    districtId: '3524080',
    name: 'Kradenanrejo',
  },
  {
    id: '3524080023',
    districtId: '3524080',
    name: 'Gunungrejo',
  },
  {
    id: '3524090003',
    districtId: '3524090',
    name: 'Sambangrejo',
  },
  {
    id: '3524090004',
    districtId: '3524090',
    name: 'Medalem',
  },
  {
    id: '3524090005',
    districtId: '3524090',
    name: 'Kedungpengaron',
  },
  {
    id: '3524090006',
    districtId: '3524090',
    name: 'Sumberagung',
  },
  {
    id: '3524090007',
    districtId: '3524090',
    name: 'Mojorejo',
  },
  {
    id: '3524090009',
    districtId: '3524090',
    name: 'Yungyang',
  },
  {
    id: '3524090010',
    districtId: '3524090',
    name: 'Sidodowo',
  },
  {
    id: '3524090011',
    districtId: '3524090',
    name: 'Jatipayak',
  },
  {
    id: '3524090012',
    districtId: '3524090',
    name: 'Kedungwaras',
  },
  {
    id: '3524090013',
    districtId: '3524090',
    name: 'Sidomulyo',
  },
  {
    id: '3524090014',
    districtId: '3524090',
    name: 'Kacangan',
  },
  {
    id: '3524090015',
    districtId: '3524090',
    name: 'Sambungrejo',
  },
  {
    id: '3524090016',
    districtId: '3524090',
    name: 'Kedungrejo',
  },
  {
    id: '3524090017',
    districtId: '3524090',
    name: 'Nguwok',
  },
  {
    id: '3524100001',
    districtId: '3524100',
    name: 'Banaran',
  },
  {
    id: '3524100002',
    districtId: '3524100',
    name: 'Karangkembang',
  },
  {
    id: '3524100003',
    districtId: '3524100',
    name: 'Pucakwangi',
  },
  {
    id: '3524100004',
    districtId: '3524100',
    name: 'Gendong Kulon',
  },
  {
    id: '3524100005',
    districtId: '3524100',
    name: 'Kuripan',
  },
  {
    id: '3524100006',
    districtId: '3524100',
    name: 'Bulumargi',
  },
  {
    id: '3524100007',
    districtId: '3524100',
    name: 'Sambangan',
  },
  {
    id: '3524100008',
    districtId: '3524100',
    name: 'Keyongan',
  },
  {
    id: '3524100009',
    districtId: '3524100',
    name: 'Patihan',
  },
  {
    id: '3524100010',
    districtId: '3524100',
    name: 'Datinawong',
  },
  {
    id: '3524100012',
    districtId: '3524100',
    name: 'Plaosan',
  },
  {
    id: '3524100013',
    districtId: '3524100',
    name: 'Sogo',
  },
  {
    id: '3524100014',
    districtId: '3524100',
    name: 'Babat',
  },
  {
    id: '3524100015',
    districtId: '3524100',
    name: 'Bedahan',
  },
  {
    id: '3524100016',
    districtId: '3524100',
    name: 'Truni',
  },
  {
    id: '3524100017',
    districtId: '3524100',
    name: 'Trepan',
  },
  {
    id: '3524100018',
    districtId: '3524100',
    name: 'Kebalanpelang',
  },
  {
    id: '3524100019',
    districtId: '3524100',
    name: 'Gembong',
  },
  {
    id: '3524100020',
    districtId: '3524100',
    name: 'Kebalandono',
  },
  {
    id: '3524100021',
    districtId: '3524100',
    name: 'Moropelang',
  },
  {
    id: '3524100022',
    districtId: '3524100',
    name: 'Tritunggal',
  },
  {
    id: '3524100023',
    districtId: '3524100',
    name: 'Kebonagung',
  },
  {
    id: '3524110001',
    districtId: '3524110',
    name: 'Gempolpading',
  },
  {
    id: '3524110002',
    districtId: '3524110',
    name: 'Wanar',
  },
  {
    id: '3524110004',
    districtId: '3524110',
    name: 'Kesambi',
  },
  {
    id: '3524110005',
    districtId: '3524110',
    name: 'Warukulon',
  },
  {
    id: '3524110006',
    districtId: '3524110',
    name: 'Kedali',
  },
  {
    id: '3524110007',
    districtId: '3524110',
    name: 'Sumberjo',
  },
  {
    id: '3524110008',
    districtId: '3524110',
    name: 'Tanggungan',
  },
  {
    id: '3524110009',
    districtId: '3524110',
    name: 'Karangtinggil',
  },
  {
    id: '3524110010',
    districtId: '3524110',
    name: 'Waruwetan',
  },
  {
    id: '3524110011',
    districtId: '3524110',
    name: 'Plososetro',
  },
  {
    id: '3524110012',
    districtId: '3524110',
    name: 'Paji',
  },
  {
    id: '3524110013',
    districtId: '3524110',
    name: 'Babatkumpul',
  },
  {
    id: '3524110015',
    districtId: '3524110',
    name: 'Ngambeg',
  },
  {
    id: '3524110016',
    districtId: '3524110',
    name: 'Padenganploso',
  },
  {
    id: '3524110017',
    districtId: '3524110',
    name: 'Bugoharjo',
  },
  {
    id: '3524120001',
    districtId: '3524120',
    name: 'Siwalanrejo',
  },
  {
    id: '3524120002',
    districtId: '3524120',
    name: 'Sumberagung',
  },
  {
    id: '3524120003',
    districtId: '3524120',
    name: 'Gedangan',
  },
  {
    id: '3524120004',
    districtId: '3524120',
    name: 'Baturono',
  },
  {
    id: '3524120005',
    districtId: '3524120',
    name: 'Banjarejo',
  },
  {
    id: '3524120006',
    districtId: '3524120',
    name: 'Sumberaji',
  },
  {
    id: '3524120007',
    districtId: '3524120',
    name: 'Kadungrembug',
  },
  {
    id: '3524120008',
    districtId: '3524120',
    name: 'Menongo',
  },
  {
    id: '3524120009',
    districtId: '3524120',
    name: 'Balungtawun',
  },
  {
    id: '3524120010',
    districtId: '3524120',
    name: 'Sugihrejo',
  },
  {
    id: '3524120011',
    districtId: '3524120',
    name: 'Bandungsari',
  },
  {
    id: '3524120012',
    districtId: '3524120',
    name: 'Plumpang',
  },
  {
    id: '3524120013',
    districtId: '3524120',
    name: 'Tlogorejo',
  },
  {
    id: '3524120014',
    districtId: '3524120',
    name: 'Surabayan',
  },
  {
    id: '3524120015',
    districtId: '3524120',
    name: 'Sidogembul',
  },
  {
    id: '3524120016',
    districtId: '3524120',
    name: 'Sukodadi',
  },
  {
    id: '3524120017',
    districtId: '3524120',
    name: 'Kebonsari',
  },
  {
    id: '3524120018',
    districtId: '3524120',
    name: 'Sukolilo',
  },
  {
    id: '3524120019',
    districtId: '3524120',
    name: 'Pajangan',
  },
  {
    id: '3524120020',
    districtId: '3524120',
    name: 'Madulegi',
  },
  {
    id: '3524130001',
    districtId: '3524130',
    name: 'Rancang Kencono',
  },
  {
    id: '3524130002',
    districtId: '3524130',
    name: 'Wajik',
  },
  {
    id: '3524130003',
    districtId: '3524130',
    name: 'Kramat',
  },
  {
    id: '3524130004',
    districtId: '3524130',
    name: 'Sidomukti',
  },
  {
    id: '3524130005',
    districtId: '3524130',
    name: 'Tlogoanyar',
  },
  {
    id: '3524130006',
    districtId: '3524130',
    name: 'Sidoharjo',
  },
  {
    id: '3524130007',
    districtId: '3524130',
    name: 'Sumberjo',
  },
  {
    id: '3524130008',
    districtId: '3524130',
    name: 'Sendangrejo',
  },
  {
    id: '3524130010',
    districtId: '3524130',
    name: 'Tanjung',
  },
  {
    id: '3524130011',
    districtId: '3524130',
    name: 'Pangkatrejo',
  },
  {
    id: '3524130012',
    districtId: '3524130',
    name: 'Karanglangit',
  },
  {
    id: '3524130013',
    districtId: '3524130',
    name: 'Plosowahyu',
  },
  {
    id: '3524130014',
    districtId: '3524130',
    name: 'Made',
  },
  {
    id: '3524130015',
    districtId: '3524130',
    name: 'Sukomulyo',
  },
  {
    id: '3524130016',
    districtId: '3524130',
    name: 'Sukorejo',
  },
  {
    id: '3524130017',
    districtId: '3524130',
    name: 'Tumenggungan',
  },
  {
    id: '3524130018',
    districtId: '3524130',
    name: 'Jetis',
  },
  {
    id: '3524130019',
    districtId: '3524130',
    name: 'Banjarmendalan',
  },
  {
    id: '3524130020',
    districtId: '3524130',
    name: 'Sidokumpul',
  },
  {
    id: '3524140001',
    districtId: '3524140',
    name: 'Kelorarum',
  },
  {
    id: '3524140002',
    districtId: '3524140',
    name: 'Soko',
  },
  {
    id: '3524140003',
    districtId: '3524140',
    name: 'Balongwangi',
  },
  {
    id: '3524140004',
    districtId: '3524140',
    name: 'Wonokromo',
  },
  {
    id: '3524140005',
    districtId: '3524140',
    name: 'Takeranklating',
  },
  {
    id: '3524140006',
    districtId: '3524140',
    name: 'Botoputih',
  },
  {
    id: '3524140013',
    districtId: '3524140',
    name: 'Dukuhagung',
  },
  {
    id: '3524140014',
    districtId: '3524140',
    name: 'Pengumbulanadi',
  },
  {
    id: '3524140015',
    districtId: '3524140',
    name: 'Bakalanpule',
  },
  {
    id: '3524140016',
    districtId: '3524140',
    name: 'Guminingrejo',
  },
  {
    id: '3524140017',
    districtId: '3524140',
    name: 'Jotosanur',
  },
  {
    id: '3524140018',
    districtId: '3524140',
    name: 'Jatirejo',
  },
  {
    id: '3524140019',
    districtId: '3524140',
    name: 'Tambakrigadung',
  },
  {
    id: '3524141002',
    districtId: '3524141',
    name: 'Dermolemahbang',
  },
  {
    id: '3524141003',
    districtId: '3524141',
    name: 'Gempoltukmloko',
  },
  {
    id: '3524141004',
    districtId: '3524141',
    name: 'Sarirejo',
  },
  {
    id: '3524141005',
    districtId: '3524141',
    name: 'Tambakmenjangan',
  },
  {
    id: '3524141006',
    districtId: '3524141',
    name: 'Sumberjo',
  },
  {
    id: '3524141007',
    districtId: '3524141',
    name: 'Simbatan',
  },
  {
    id: '3524141008',
    districtId: '3524141',
    name: 'Canggah',
  },
  {
    id: '3524150001',
    districtId: '3524150',
    name: 'Deket Kulon',
  },
  {
    id: '3524150002',
    districtId: '3524150',
    name: 'Deket Wetan',
  },
  {
    id: '3524150003',
    districtId: '3524150',
    name: 'Rejosari',
  },
  {
    id: '3524150004',
    districtId: '3524150',
    name: 'Pandanpancur',
  },
  {
    id: '3524150005',
    districtId: '3524150',
    name: 'Plosobuden',
  },
  {
    id: '3524150006',
    districtId: '3524150',
    name: 'Srirande',
  },
  {
    id: '3524150007',
    districtId: '3524150',
    name: 'Rejotengah',
  },
  {
    id: '3524150008',
    districtId: '3524150',
    name: 'Sidobinangun',
  },
  {
    id: '3524150009',
    districtId: '3524150',
    name: 'Sugihwaras',
  },
  {
    id: '3524150010',
    districtId: '3524150',
    name: 'Sidorejo',
  },
  {
    id: '3524150011',
    districtId: '3524150',
    name: 'Dlanggu',
  },
  {
    id: '3524150012',
    districtId: '3524150',
    name: 'Dinoyo',
  },
  {
    id: '3524150013',
    districtId: '3524150',
    name: 'Babatagung',
  },
  {
    id: '3524150014',
    districtId: '3524150',
    name: 'Tukkerto',
  },
  {
    id: '3524150015',
    districtId: '3524150',
    name: 'Weduni',
  },
  {
    id: '3524150016',
    districtId: '3524150',
    name: 'Sidomulyo',
  },
  {
    id: '3524150017',
    districtId: '3524150',
    name: 'Laladan',
  },
  {
    id: '3524160001',
    districtId: '3524160',
    name: 'Kentong',
  },
  {
    id: '3524160002',
    districtId: '3524160',
    name: 'Wangen',
  },
  {
    id: '3524160003',
    districtId: '3524160',
    name: 'Bangkok',
  },
  {
    id: '3524160005',
    districtId: '3524160',
    name: 'Dukuhtunggal',
  },
  {
    id: '3524160006',
    districtId: '3524160',
    name: 'Bapuhbandung',
  },
  {
    id: '3524160007',
    districtId: '3524160',
    name: 'Tanggungprigel',
  },
  {
    id: '3524160008',
    districtId: '3524160',
    name: 'Sudangan',
  },
  {
    id: '3524160009',
    districtId: '3524160',
    name: 'Karangagung',
  },
  {
    id: '3524160010',
    districtId: '3524160',
    name: 'Duduk Lor',
  },
  {
    id: '3524160011',
    districtId: '3524160',
    name: 'Medang',
  },
  {
    id: '3524160012',
    districtId: '3524160',
    name: 'Mendogo',
  },
  {
    id: '3524160013',
    districtId: '3524160',
    name: 'Began',
  },
  {
    id: '3524160014',
    districtId: '3524160',
    name: 'Menganti',
  },
  {
    id: '3524160015',
    districtId: '3524160',
    name: 'Rayunggumuk',
  },
  {
    id: '3524160016',
    districtId: '3524160',
    name: 'Gempolpendowo',
  },
  {
    id: '3524160017',
    districtId: '3524160',
    name: 'Soko',
  },
  {
    id: '3524160018',
    districtId: '3524160',
    name: 'Morocalan',
  },
  {
    id: '3524160019',
    districtId: '3524160',
    name: 'Pasi',
  },
  {
    id: '3524160020',
    districtId: '3524160',
    name: 'Margoanyar',
  },
  {
    id: '3524160021',
    districtId: '3524160',
    name: 'Glagah',
  },
  {
    id: '3524160022',
    districtId: '3524160',
    name: 'Bapuh Baru',
  },
  {
    id: '3524160023',
    districtId: '3524160',
    name: 'Jatirenggo',
  },
  {
    id: '3524160024',
    districtId: '3524160',
    name: 'Konang',
  },
  {
    id: '3524160025',
    districtId: '3524160',
    name: 'Wonorejo',
  },
  {
    id: '3524160026',
    districtId: '3524160',
    name: 'Panggang',
  },
  {
    id: '3524160027',
    districtId: '3524160',
    name: 'Wedoro',
  },
  {
    id: '3524160028',
    districtId: '3524160',
    name: 'Karangturi',
  },
  {
    id: '3524170001',
    districtId: '3524170',
    name: 'Somowinangun',
  },
  {
    id: '3524170002',
    districtId: '3524170',
    name: 'Karanganom',
  },
  {
    id: '3524170003',
    districtId: '3524170',
    name: 'Ketapangtelu',
  },
  {
    id: '3524170004',
    districtId: '3524170',
    name: 'Blawi',
  },
  {
    id: '3524170005',
    districtId: '3524170',
    name: 'Baranggayam',
  },
  {
    id: '3524170006',
    districtId: '3524170',
    name: 'Pendowolimo',
  },
  {
    id: '3524170007',
    districtId: '3524170',
    name: 'Priyoso',
  },
  {
    id: '3524170008',
    districtId: '3524170',
    name: 'Kuro',
  },
  {
    id: '3524170009',
    districtId: '3524170',
    name: 'Gawerejo',
  },
  {
    id: '3524170010',
    districtId: '3524170',
    name: 'Windu',
  },
  {
    id: '3524170011',
    districtId: '3524170',
    name: 'Karangbinangun',
  },
  {
    id: '3524170012',
    districtId: '3524170',
    name: 'Bogobabadan',
  },
  {
    id: '3524170013',
    districtId: '3524170',
    name: 'Watangpanjang',
  },
  {
    id: '3524170014',
    districtId: '3524170',
    name: 'Sambopinggir',
  },
  {
    id: '3524170015',
    districtId: '3524170',
    name: 'Putatbangah',
  },
  {
    id: '3524170016',
    districtId: '3524170',
    name: 'Banyuurip',
  },
  {
    id: '3524170017',
    districtId: '3524170',
    name: 'Banjarejo',
  },
  {
    id: '3524170018',
    districtId: '3524170',
    name: 'Palangan',
  },
  {
    id: '3524170019',
    districtId: '3524170',
    name: 'Mayong',
  },
  {
    id: '3524170020',
    districtId: '3524170',
    name: 'Sukorejo',
  },
  {
    id: '3524170021',
    districtId: '3524170',
    name: 'Waruk',
  },
  {
    id: '3524180001',
    districtId: '3524180',
    name: 'Sukoanyar',
  },
  {
    id: '3524180002',
    districtId: '3524180',
    name: 'Sukorejo',
  },
  {
    id: '3524180003',
    districtId: '3524180',
    name: 'Tawangrejo',
  },
  {
    id: '3524180004',
    districtId: '3524180',
    name: 'Tambakploso',
  },
  {
    id: '3524180005',
    districtId: '3524180',
    name: 'Balun',
  },
  {
    id: '3524180006',
    districtId: '3524180',
    name: 'Gedongboyountung',
  },
  {
    id: '3524180007',
    districtId: '3524180',
    name: 'Ngujungrejo',
  },
  {
    id: '3524180008',
    districtId: '3524180',
    name: 'Bambang',
  },
  {
    id: '3524180009',
    districtId: '3524180',
    name: 'Kemlagigede',
  },
  {
    id: '3524180010',
    districtId: '3524180',
    name: 'Turi',
  },
  {
    id: '3524180012',
    districtId: '3524180',
    name: 'Wangunrejo',
  },
  {
    id: '3524180014',
    districtId: '3524180',
    name: 'Badurame',
  },
  {
    id: '3524180015',
    districtId: '3524180',
    name: 'Karangwedoro',
  },
  {
    id: '3524180016',
    districtId: '3524180',
    name: 'Putatkumpul',
  },
  {
    id: '3524180017',
    districtId: '3524180',
    name: 'Kemlaggi Lor',
  },
  {
    id: '3524180018',
    districtId: '3524180',
    name: 'Pomahanjanggan',
  },
  {
    id: '3524180019',
    districtId: '3524180',
    name: 'Kepudibener',
  },
  {
    id: '3524190001',
    districtId: '3524190',
    name: 'Pucangro',
  },
  {
    id: '3524190002',
    districtId: '3524190',
    name: 'Pucangtelu',
  },
  {
    id: '3524190003',
    districtId: '3524190',
    name: 'Somosari',
  },
  {
    id: '3524190004',
    districtId: '3524190',
    name: 'Jelakcatur',
  },
  {
    id: '3524190005',
    districtId: '3524190',
    name: 'Tiwet',
  },
  {
    id: '3524190006',
    districtId: '3524190',
    name: 'Blajo',
  },
  {
    id: '3524190007',
    districtId: '3524190',
    name: 'Gambuhan',
  },
  {
    id: '3524190008',
    districtId: '3524190',
    name: 'Bojoasri',
  },
  {
    id: '3524190009',
    districtId: '3524190',
    name: 'Cluring',
  },
  {
    id: '3524190010',
    districtId: '3524190',
    name: 'Lukrejo',
  },
  {
    id: '3524190011',
    districtId: '3524190',
    name: 'Mungli',
  },
  {
    id: '3524190012',
    districtId: '3524190',
    name: 'Dibe',
  },
  {
    id: '3524190013',
    districtId: '3524190',
    name: 'Pengangsalan',
  },
  {
    id: '3524190014',
    districtId: '3524190',
    name: 'Butungan',
  },
  {
    id: '3524190015',
    districtId: '3524190',
    name: 'Kalitengah',
  },
  {
    id: '3524190016',
    districtId: '3524190',
    name: 'Kediren',
  },
  {
    id: '3524190017',
    districtId: '3524190',
    name: 'Kuluran',
  },
  {
    id: '3524190018',
    districtId: '3524190',
    name: 'Canditunggal',
  },
  {
    id: '3524190019',
    districtId: '3524190',
    name: 'Sugihwaras',
  },
  {
    id: '3524190020',
    districtId: '3524190',
    name: 'Tunjungmekar',
  },
  {
    id: '3524200001',
    districtId: '3524200',
    name: 'Banjarmadu',
  },
  {
    id: '3524200002',
    districtId: '3524200',
    name: 'Kalanganyar',
  },
  {
    id: '3524200003',
    districtId: '3524200',
    name: 'Sungelebak',
  },
  {
    id: '3524200004',
    districtId: '3524200',
    name: 'Kendalkemlagi',
  },
  {
    id: '3524200005',
    districtId: '3524200',
    name: 'Mertani',
  },
  {
    id: '3524200006',
    districtId: '3524200',
    name: 'Karanggeneng',
  },
  {
    id: '3524200007',
    districtId: '3524200',
    name: 'Sumberwudi',
  },
  {
    id: '3524200008',
    districtId: '3524200',
    name: 'Karangwungu',
  },
  {
    id: '3524200009',
    districtId: '3524200',
    name: 'Jagran',
  },
  {
    id: '3524200010',
    districtId: '3524200',
    name: 'Kawistolegi',
  },
  {
    id: '3524200011',
    districtId: '3524200',
    name: 'Sonoadi',
  },
  {
    id: '3524200012',
    districtId: '3524200',
    name: 'Latukan',
  },
  {
    id: '3524200013',
    districtId: '3524200',
    name: 'Bantengputih',
  },
  {
    id: '3524200014',
    districtId: '3524200',
    name: 'Guci',
  },
  {
    id: '3524200015',
    districtId: '3524200',
    name: 'Kaligerman',
  },
  {
    id: '3524200016',
    districtId: '3524200',
    name: 'Karangrejo',
  },
  {
    id: '3524200017',
    districtId: '3524200',
    name: 'Tracal',
  },
  {
    id: '3524200018',
    districtId: '3524200',
    name: 'Prijekngablag',
  },
  {
    id: '3524210002',
    districtId: '3524210',
    name: 'Kebalan Kulon',
  },
  {
    id: '3524210003',
    districtId: '3524210',
    name: 'Kudikan',
  },
  {
    id: '3524210004',
    districtId: '3524210',
    name: 'Manyar',
  },
  {
    id: '3524210005',
    districtId: '3524210',
    name: 'Trosono',
  },
  {
    id: '3524210006',
    districtId: '3524210',
    name: 'Latek',
  },
  {
    id: '3524210007',
    districtId: '3524210',
    name: 'Miru',
  },
  {
    id: '3524210010',
    districtId: '3524210',
    name: 'Siman',
  },
  {
    id: '3524210011',
    districtId: '3524210',
    name: 'Kembangan',
  },
  {
    id: '3524210012',
    districtId: '3524210',
    name: 'Karang',
  },
  {
    id: '3524210014',
    districtId: '3524210',
    name: 'Porodeso',
  },
  {
    id: '3524210015',
    districtId: '3524210',
    name: 'Moro',
  },
  {
    id: '3524210016',
    districtId: '3524210',
    name: 'Sekaran',
  },
  {
    id: '3524210017',
    districtId: '3524210',
    name: 'Jugo',
  },
  {
    id: '3524210018',
    districtId: '3524210',
    name: 'Ngarum',
  },
  {
    id: '3524210019',
    districtId: '3524210',
    name: 'Titik',
  },
  {
    id: '3524210020',
    districtId: '3524210',
    name: 'Kendal',
  },
  {
    id: '3524210021',
    districtId: '3524210',
    name: 'Keting',
  },
  {
    id: '3524220001',
    districtId: '3524220',
    name: 'Duriwetan',
  },
  {
    id: '3524220002',
    districtId: '3524220',
    name: 'Taji',
  },
  {
    id: '3524220004',
    districtId: '3524220',
    name: 'Siwuran',
  },
  {
    id: '3524220005',
    districtId: '3524220',
    name: 'Klagensrampat',
  },
  {
    id: '3524220006',
    districtId: '3524220',
    name: 'Pangean',
  },
  {
    id: '3524220007',
    districtId: '3524220',
    name: 'Gumantuk',
  },
  {
    id: '3524220008',
    districtId: '3524220',
    name: 'Ngayung',
  },
  {
    id: '3524220009',
    districtId: '3524220',
    name: 'Maduran',
  },
  {
    id: '3524220010',
    districtId: '3524220',
    name: 'Jangkungsomo',
  },
  {
    id: '3524220011',
    districtId: '3524220',
    name: 'Parengan',
  },
  {
    id: '3524220012',
    districtId: '3524220',
    name: 'Pangkatrejo',
  },
  {
    id: '3524220013',
    districtId: '3524220',
    name: 'Pringgoboyo',
  },
  {
    id: '3524220014',
    districtId: '3524220',
    name: 'Kanugrahan',
  },
  {
    id: '3524220015',
    districtId: '3524220',
    name: 'Turi',
  },
  {
    id: '3524220016',
    districtId: '3524220',
    name: 'Gedangan',
  },
  {
    id: '3524220017',
    districtId: '3524220',
    name: 'Blumbang',
  },
  {
    id: '3524230001',
    districtId: '3524230',
    name: 'Duri Kulon',
  },
  {
    id: '3524230002',
    districtId: '3524230',
    name: 'Centini',
  },
  {
    id: '3524230004',
    districtId: '3524230',
    name: 'Pesanggrahan',
  },
  {
    id: '3524230005',
    districtId: '3524230',
    name: 'Jabung',
  },
  {
    id: '3524230006',
    districtId: '3524230',
    name: 'Dateng',
  },
  {
    id: '3524230007',
    districtId: '3524230',
    name: 'Gelap',
  },
  {
    id: '3524230008',
    districtId: '3524230',
    name: 'Mojo Asem',
  },
  {
    id: '3524230009',
    districtId: '3524230',
    name: 'Siser',
  },
  {
    id: '3524230010',
    districtId: '3524230',
    name: 'Bulutigo',
  },
  {
    id: '3524230011',
    districtId: '3524230',
    name: 'Pelangwot',
  },
  {
    id: '3524230012',
    districtId: '3524230',
    name: 'Laren',
  },
  {
    id: '3524230013',
    districtId: '3524230',
    name: 'Gampang Sejati',
  },
  {
    id: '3524230014',
    districtId: '3524230',
    name: 'Taman Prijek',
  },
  {
    id: '3524230015',
    districtId: '3524230',
    name: 'Karangtawar',
  },
  {
    id: '3524230016',
    districtId: '3524230',
    name: 'Tejoasri',
  },
  {
    id: '3524230017',
    districtId: '3524230',
    name: 'Godog',
  },
  {
    id: '3524230018',
    districtId: '3524230',
    name: 'Bulubrangsi',
  },
  {
    id: '3524230019',
    districtId: '3524230',
    name: 'Karangwungu Lor',
  },
  {
    id: '3524230020',
    districtId: '3524230',
    name: 'Brangsi',
  },
  {
    id: '3524240001',
    districtId: '3524240',
    name: 'Dadapan',
  },
  {
    id: '3524240003',
    districtId: '3524240',
    name: 'Sugihan',
  },
  {
    id: '3524240005',
    districtId: '3524240',
    name: 'Payaman',
  },
  {
    id: '3524240006',
    districtId: '3524240',
    name: 'Solokuro',
  },
  {
    id: '3524240007',
    districtId: '3524240',
    name: 'Takerharjo',
  },
  {
    id: '3524240008',
    districtId: '3524240',
    name: 'Banyubang',
  },
  {
    id: '3524240009',
    districtId: '3524240',
    name: 'Dagan',
  },
  {
    id: '3524240010',
    districtId: '3524240',
    name: 'Bluri',
  },
  {
    id: '3524250001',
    districtId: '3524250',
    name: 'Blimbing',
  },
  {
    id: '3524250002',
    districtId: '3524250',
    name: 'Kandangsemangkon',
  },
  {
    id: '3524250003',
    districtId: '3524250',
    name: 'Paciran',
  },
  {
    id: '3524250004',
    districtId: '3524250',
    name: 'Sumurgayam',
  },
  {
    id: '3524250005',
    districtId: '3524250',
    name: 'Sendangagung',
  },
  {
    id: '3524250006',
    districtId: '3524250',
    name: 'Sendangduwur',
  },
  {
    id: '3524250008',
    districtId: '3524250',
    name: 'Kranji',
  },
  {
    id: '3524250009',
    districtId: '3524250',
    name: 'Drajat',
  },
  {
    id: '3524250010',
    districtId: '3524250',
    name: 'Banjarwati',
  },
  {
    id: '3524250011',
    districtId: '3524250',
    name: 'Kemantren',
  },
  {
    id: '3524250012',
    districtId: '3524250',
    name: 'Sidokelar',
  },
  {
    id: '3524250013',
    districtId: '3524250',
    name: 'Tlogosadang',
  },
  {
    id: '3524250014',
    districtId: '3524250',
    name: 'Paloh',
  },
  {
    id: '3524250016',
    districtId: '3524250',
    name: 'Sidokumpul',
  },
  {
    id: '3524250017',
    districtId: '3524250',
    name: 'Warulor',
  },
  {
    id: '3524260001',
    districtId: '3524260',
    name: 'Lembor',
  },
  {
    id: '3524260002',
    districtId: '3524260',
    name: 'Tlogoretno',
  },
  {
    id: '3524260003',
    districtId: '3524260',
    name: 'Sidomukti',
  },
  {
    id: '3524260004',
    districtId: '3524260',
    name: 'Lohgung',
  },
  {
    id: '3524260005',
    districtId: '3524260',
    name: 'Labuhan',
  },
  {
    id: '3524260006',
    districtId: '3524260',
    name: 'Brengkok',
  },
  {
    id: '3524260007',
    districtId: '3524260',
    name: 'Sendangharjo',
  },
  {
    id: '3524260008',
    districtId: '3524260',
    name: 'Sedayulawas',
  },
  {
    id: '3524260009',
    districtId: '3524260',
    name: 'Sumberagung',
  },
  {
    id: '3524260010',
    districtId: '3524260',
    name: 'Brondong',
  },
  {
    id: '3525010001',
    districtId: '3525010',
    name: 'Kedunganyar',
  },
  {
    id: '3525010002',
    districtId: '3525010',
    name: 'Sumberame',
  },
  {
    id: '3525010003',
    districtId: '3525010',
    name: 'Wringinanom',
  },
  {
    id: '3525010004',
    districtId: '3525010',
    name: 'Lebanisuko',
  },
  {
    id: '3525010005',
    districtId: '3525010',
    name: 'Lebaniwaras',
  },
  {
    id: '3525010006',
    districtId: '3525010',
    name: 'Sumengko',
  },
  {
    id: '3525010007',
    districtId: '3525010',
    name: 'Pasinan Lemahputih',
  },
  {
    id: '3525010008',
    districtId: '3525010',
    name: 'Watestanjung',
  },
  {
    id: '3525010009',
    districtId: '3525010',
    name: 'Pedagangan',
  },
  {
    id: '3525010011',
    districtId: '3525010',
    name: 'Sumberwaru',
  },
  {
    id: '3525010012',
    districtId: '3525010',
    name: 'Kepuhklagen',
  },
  {
    id: '3525010014',
    districtId: '3525010',
    name: 'Mondoluku',
  },
  {
    id: '3525010015',
    districtId: '3525010',
    name: 'Kesambenkulon',
  },
  {
    id: '3525010016',
    districtId: '3525010',
    name: 'Soko',
  },
  {
    id: '3525020001',
    districtId: '3525020',
    name: 'Krikilan',
  },
  {
    id: '3525020002',
    districtId: '3525020',
    name: 'Driyorejo',
  },
  {
    id: '3525020003',
    districtId: '3525020',
    name: 'Cangkir',
  },
  {
    id: '3525020004',
    districtId: '3525020',
    name: 'Bambe',
  },
  {
    id: '3525020006',
    districtId: '3525020',
    name: 'Tenaru',
  },
  {
    id: '3525020007',
    districtId: '3525020',
    name: 'Petiken',
  },
  {
    id: '3525020008',
    districtId: '3525020',
    name: 'Kesambenwetan',
  },
  {
    id: '3525020010',
    districtId: '3525020',
    name: 'Tanjungan',
  },
  {
    id: '3525020011',
    districtId: '3525020',
    name: 'Banjaran',
  },
  {
    id: '3525020012',
    districtId: '3525020',
    name: 'Karangandong',
  },
  {
    id: '3525020013',
    districtId: '3525020',
    name: 'Mojosarirejo',
  },
  {
    id: '3525020014',
    districtId: '3525020',
    name: 'Wedoroanom',
  },
  {
    id: '3525020015',
    districtId: '3525020',
    name: 'Randegansari',
  },
  {
    id: '3525020016',
    districtId: '3525020',
    name: 'Gadung',
  },
  {
    id: '3525030001',
    districtId: '3525030',
    name: 'Mojowuku',
  },
  {
    id: '3525030002',
    districtId: '3525030',
    name: 'Sidoraharjo',
  },
  {
    id: '3525030003',
    districtId: '3525030',
    name: 'Slempit',
  },
  {
    id: '3525030004',
    districtId: '3525030',
    name: 'Belahanrejo',
  },
  {
    id: '3525030005',
    districtId: '3525030',
    name: 'Menunggal',
  },
  {
    id: '3525030006',
    districtId: '3525030',
    name: 'Banyuurip',
  },
  {
    id: '3525030008',
    districtId: '3525030',
    name: 'Kedamean',
  },
  {
    id: '3525030009',
    districtId: '3525030',
    name: 'Tanjung',
  },
  {
    id: '3525030010',
    districtId: '3525030',
    name: 'Katimoho',
  },
  {
    id: '3525030011',
    districtId: '3525030',
    name: 'Turirejo',
  },
  {
    id: '3525030013',
    districtId: '3525030',
    name: 'Glindah',
  },
  {
    id: '3525030014',
    districtId: '3525030',
    name: 'Lampah',
  },
  {
    id: '3525040001',
    districtId: '3525040',
    name: 'Pranti',
  },
  {
    id: '3525040002',
    districtId: '3525040',
    name: 'Bringkang',
  },
  {
    id: '3525040003',
    districtId: '3525040',
    name: 'Mojotengah',
  },
  {
    id: '3525040004',
    districtId: '3525040',
    name: 'Menganti',
  },
  {
    id: '3525040005',
    districtId: '3525040',
    name: 'Hulaan',
  },
  {
    id: '3525040006',
    districtId: '3525040',
    name: 'Sidowungu',
  },
  {
    id: '3525040007',
    districtId: '3525040',
    name: 'Setro',
  },
  {
    id: '3525040008',
    districtId: '3525040',
    name: 'Laban',
  },
  {
    id: '3525040009',
    districtId: '3525040',
    name: 'Pengalangan',
  },
  {
    id: '3525040010',
    districtId: '3525040',
    name: 'Randupadangan',
  },
  {
    id: '3525040011',
    districtId: '3525040',
    name: 'Drancang',
  },
  {
    id: '3525040012',
    districtId: '3525040',
    name: 'Pelemwatu',
  },
  {
    id: '3525040013',
    districtId: '3525040',
    name: 'Sidojangkung',
  },
  {
    id: '3525040014',
    districtId: '3525040',
    name: 'Domas',
  },
  {
    id: '3525040015',
    districtId: '3525040',
    name: 'Gadingwatu',
  },
  {
    id: '3525040016',
    districtId: '3525040',
    name: 'Beton',
  },
  {
    id: '3525040017',
    districtId: '3525040',
    name: 'Putat Lor',
  },
  {
    id: '3525040018',
    districtId: '3525040',
    name: 'Boteng',
  },
  {
    id: '3525040019',
    districtId: '3525040',
    name: 'Boboh',
  },
  {
    id: '3525040020',
    districtId: '3525040',
    name: 'Gempolkurung',
  },
  {
    id: '3525040021',
    districtId: '3525040',
    name: 'Kepatihan',
  },
  {
    id: '3525040022',
    districtId: '3525040',
    name: 'Hendrosari',
  },
  {
    id: '3525050001',
    districtId: '3525050',
    name: 'Dadapkuning',
  },
  {
    id: '3525050003',
    districtId: '3525050',
    name: 'Sukoanyar',
  },
  {
    id: '3525050004',
    districtId: '3525050',
    name: 'Morowudi',
  },
  {
    id: '3525050005',
    districtId: '3525050',
    name: 'Guranganyar',
  },
  {
    id: '3525050006',
    districtId: '3525050',
    name: 'Dampaan',
  },
  {
    id: '3525050007',
    districtId: '3525050',
    name: 'Dooro',
  },
  {
    id: '3525050008',
    districtId: '3525050',
    name: 'Lengkong',
  },
  {
    id: '3525050009',
    districtId: '3525050',
    name: 'Kandangan',
  },
  {
    id: '3525050011',
    districtId: '3525050',
    name: 'Ngabetan',
  },
  {
    id: '3525050012',
    districtId: '3525050',
    name: 'Betiting',
  },
  {
    id: '3525050013',
    districtId: '3525050',
    name: 'Ikerikergeger',
  },
  {
    id: '3525050014',
    districtId: '3525050',
    name: 'Cerme Kidul',
  },
  {
    id: '3525050015',
    districtId: '3525050',
    name: 'Pandu',
  },
  {
    id: '3525050016',
    districtId: '3525050',
    name: 'Jono',
  },
  {
    id: '3525050017',
    districtId: '3525050',
    name: 'Tambakberas',
  },
  {
    id: '3525050018',
    districtId: '3525050',
    name: 'Cerme Lor',
  },
  {
    id: '3525050019',
    districtId: '3525050',
    name: 'Cagakagung',
  },
  {
    id: '3525050020',
    districtId: '3525050',
    name: 'Semampir',
  },
  {
    id: '3525050021',
    districtId: '3525050',
    name: 'Kambingan',
  },
  {
    id: '3525050022',
    districtId: '3525050',
    name: 'Wedani',
  },
  {
    id: '3525050023',
    districtId: '3525050',
    name: 'Gedangkulut',
  },
  {
    id: '3525050024',
    districtId: '3525050',
    name: 'Padeg',
  },
  {
    id: '3525050025',
    districtId: '3525050',
    name: 'Banjarsari',
  },
  {
    id: '3525060001',
    districtId: '3525060',
    name: 'Lundo',
  },
  {
    id: '3525060002',
    districtId: '3525060',
    name: 'Balongtunjung',
  },
  {
    id: '3525060003',
    districtId: '3525060',
    name: 'Balongmojo',
  },
  {
    id: '3525060004',
    districtId: '3525060',
    name: 'Bulangkulon',
  },
  {
    id: '3525060005',
    districtId: '3525060',
    name: 'Sedapurklagen',
  },
  {
    id: '3525060006',
    districtId: '3525060',
    name: 'Deliksumber',
  },
  {
    id: '3525060008',
    districtId: '3525060',
    name: 'Munggugianti',
  },
  {
    id: '3525060009',
    districtId: '3525060',
    name: 'Bengkelolor',
  },
  {
    id: '3525060010',
    districtId: '3525060',
    name: 'Gluranploso',
  },
  {
    id: '3525060011',
    districtId: '3525060',
    name: 'Bulurejo',
  },
  {
    id: '3525060012',
    districtId: '3525060',
    name: 'Dermo',
  },
  {
    id: '3525060013',
    districtId: '3525060',
    name: 'Kedungsekar',
  },
  {
    id: '3525060014',
    districtId: '3525060',
    name: 'Klampok',
  },
  {
    id: '3525060015',
    districtId: '3525060',
    name: 'Sirnoboyo',
  },
  {
    id: '3525060016',
    districtId: '3525060',
    name: 'Kalipadang',
  },
  {
    id: '3525060017',
    districtId: '3525060',
    name: 'Karangankidul',
  },
  {
    id: '3525060018',
    districtId: '3525060',
    name: 'Munggugebang',
  },
  {
    id: '3525060019',
    districtId: '3525060',
    name: 'Banter',
  },
  {
    id: '3525060020',
    districtId: '3525060',
    name: 'Metatu',
  },
  {
    id: '3525060021',
    districtId: '3525060',
    name: 'Jogodalu',
  },
  {
    id: '3525060022',
    districtId: '3525060',
    name: 'Punduttrate',
  },
  {
    id: '3525060023',
    districtId: '3525060',
    name: 'Jatirembe',
  },
  {
    id: '3525070001',
    districtId: '3525070',
    name: 'Jombangdelik',
  },
  {
    id: '3525070002',
    districtId: '3525070',
    name: 'Brangkal',
  },
  {
    id: '3525070003',
    districtId: '3525070',
    name: 'Ngampel',
  },
  {
    id: '3525070004',
    districtId: '3525070',
    name: 'Tanahlandean',
  },
  {
    id: '3525070005',
    districtId: '3525070',
    name: 'Dapet',
  },
  {
    id: '3525070006',
    districtId: '3525070',
    name: 'Wonorejo',
  },
  {
    id: '3525070007',
    districtId: '3525070',
    name: 'Sekarputih',
  },
  {
    id: '3525070008',
    districtId: '3525070',
    name: 'Wotansari',
  },
  {
    id: '3525070009',
    districtId: '3525070',
    name: 'Banjaragung',
  },
  {
    id: '3525070010',
    districtId: '3525070',
    name: 'Karangsemanding',
  },
  {
    id: '3525070011',
    districtId: '3525070',
    name: 'Wahas',
  },
  {
    id: '3525070012',
    districtId: '3525070',
    name: 'Bandungsekaran',
  },
  {
    id: '3525070013',
    districtId: '3525070',
    name: 'Mojogede',
  },
  {
    id: '3525070014',
    districtId: '3525070',
    name: 'Kedungpring',
  },
  {
    id: '3525070016',
    districtId: '3525070',
    name: 'Balongpanggang',
  },
  {
    id: '3525070018',
    districtId: '3525070',
    name: 'Babatan',
  },
  {
    id: '3525070019',
    districtId: '3525070',
    name: 'Pacuh',
  },
  {
    id: '3525070020',
    districtId: '3525070',
    name: 'Tenggor',
  },
  {
    id: '3525070021',
    districtId: '3525070',
    name: 'Dohoagung',
  },
  {
    id: '3525070022',
    districtId: '3525070',
    name: 'Pinggir',
  },
  {
    id: '3525070023',
    districtId: '3525070',
    name: 'Klotok',
  },
  {
    id: '3525070024',
    districtId: '3525070',
    name: 'Ganggang',
  },
  {
    id: '3525070025',
    districtId: '3525070',
    name: 'Ngasin',
  },
  {
    id: '3525080001',
    districtId: '3525080',
    name: 'Kandangan',
  },
  {
    id: '3525080002',
    districtId: '3525080',
    name: 'Tumapel',
  },
  {
    id: '3525080003',
    districtId: '3525080',
    name: 'Panjunan',
  },
  {
    id: '3525080004',
    districtId: '3525080',
    name: 'Tambakrejo',
  },
  {
    id: '3525080005',
    districtId: '3525080',
    name: 'Setrohadi',
  },
  {
    id: '3525080006',
    districtId: '3525080',
    name: 'Sumengko',
  },
  {
    id: '3525080008',
    districtId: '3525080',
    name: 'Sumari',
  },
  {
    id: '3525080009',
    districtId: '3525080',
    name: 'Tirem',
  },
  {
    id: '3525080010',
    districtId: '3525080',
    name: 'Ambeng Ambeng Watangrejo',
  },
  {
    id: '3525080011',
    districtId: '3525080',
    name: 'Tebaloan',
  },
  {
    id: '3525080012',
    districtId: '3525080',
    name: 'Samirplapan',
  },
  {
    id: '3525080013',
    districtId: '3525080',
    name: 'Duduksampeyan',
  },
  {
    id: '3525080014',
    districtId: '3525080',
    name: 'Petisbenem',
  },
  {
    id: '3525080015',
    districtId: '3525080',
    name: 'Palebon',
  },
  {
    id: '3525080016',
    districtId: '3525080',
    name: 'Glanggang',
  },
  {
    id: '3525080017',
    districtId: '3525080',
    name: 'Pandanan',
  },
  {
    id: '3525080018',
    districtId: '3525080',
    name: 'Bendungan',
  },
  {
    id: '3525080019',
    districtId: '3525080',
    name: 'Wadak Lor',
  },
  {
    id: '3525080020',
    districtId: '3525080',
    name: 'Wadak Kidul',
  },
  {
    id: '3525080021',
    districtId: '3525080',
    name: 'Kawistowindu',
  },
  {
    id: '3525080022',
    districtId: '3525080',
    name: 'Kemudi',
  },
  {
    id: '3525080023',
    districtId: '3525080',
    name: 'Kramat',
  },
  {
    id: '3525090001',
    districtId: '3525090',
    name: 'Kedanyang',
  },
  {
    id: '3525090002',
    districtId: '3525090',
    name: 'Prambangan',
  },
  {
    id: '3525090003',
    districtId: '3525090',
    name: 'Gulomantung',
  },
  {
    id: '3525090004',
    districtId: '3525090',
    name: 'Sukorejo',
  },
  {
    id: '3525090005',
    districtId: '3525090',
    name: 'Segoromadu',
  },
  {
    id: '3525090006',
    districtId: '3525090',
    name: 'Tenggulunan',
  },
  {
    id: '3525090007',
    districtId: '3525090',
    name: 'Karangkering',
  },
  {
    id: '3525090008',
    districtId: '3525090',
    name: 'Indro',
  },
  {
    id: '3525090009',
    districtId: '3525090',
    name: 'Singosari',
  },
  {
    id: '3525090010',
    districtId: '3525090',
    name: 'Sidomoro',
  },
  {
    id: '3525090011',
    districtId: '3525090',
    name: 'Gending',
  },
  {
    id: '3525090012',
    districtId: '3525090',
    name: 'Ngargosari',
  },
  {
    id: '3525090013',
    districtId: '3525090',
    name: 'Kawisanyar',
  },
  {
    id: '3525090014',
    districtId: '3525090',
    name: 'Sidomukti',
  },
  {
    id: '3525090015',
    districtId: '3525090',
    name: 'Giri',
  },
  {
    id: '3525090016',
    districtId: '3525090',
    name: 'Klangonan',
  },
  {
    id: '3525090017',
    districtId: '3525090',
    name: 'Sekarkurung',
  },
  {
    id: '3525090018',
    districtId: '3525090',
    name: 'Kembangan',
  },
  {
    id: '3525090019',
    districtId: '3525090',
    name: 'Dahanrejo',
  },
  {
    id: '3525090020',
    districtId: '3525090',
    name: 'Randuagung',
  },
  {
    id: '3525090021',
    districtId: '3525090',
    name: 'Kebomas',
  },
  {
    id: '3525100001',
    districtId: '3525100',
    name: 'Ngipik',
  },
  {
    id: '3525100002',
    districtId: '3525100',
    name: 'Tlogopatut',
  },
  {
    id: '3525100003',
    districtId: '3525100',
    name: 'Sidokumpul',
  },
  {
    id: '3525100004',
    districtId: '3525100',
    name: 'Kramatinggil',
  },
  {
    id: '3525100005',
    districtId: '3525100',
    name: 'Sidorukun',
  },
  {
    id: '3525100006',
    districtId: '3525100',
    name: 'Pulopancikan',
  },
  {
    id: '3525100007',
    districtId: '3525100',
    name: 'Gapurosukolilo',
  },
  {
    id: '3525100008',
    districtId: '3525100',
    name: 'Tlogobendung',
  },
  {
    id: '3525100009',
    districtId: '3525100',
    name: 'Pekauman',
  },
  {
    id: '3525100010',
    districtId: '3525100',
    name: 'Sukorame',
  },
  {
    id: '3525100011',
    districtId: '3525100',
    name: 'Karangturi',
  },
  {
    id: '3525100012',
    districtId: '3525100',
    name: 'Trate',
  },
  {
    id: '3525100013',
    districtId: '3525100',
    name: 'Karangpoh',
  },
  {
    id: '3525100014',
    districtId: '3525100',
    name: 'Bedilan',
  },
  {
    id: '3525100015',
    districtId: '3525100',
    name: 'Kebungson',
  },
  {
    id: '3525100016',
    districtId: '3525100',
    name: 'Pekelingan',
  },
  {
    id: '3525100017',
    districtId: '3525100',
    name: 'Kemuteran',
  },
  {
    id: '3525100018',
    districtId: '3525100',
    name: 'Sukodono',
  },
  {
    id: '3525100019',
    districtId: '3525100',
    name: 'Kroman',
  },
  {
    id: '3525100021',
    districtId: '3525100',
    name: 'Tlogopojok',
  },
  {
    id: '3525110001',
    districtId: '3525110',
    name: 'Tebalo',
  },
  {
    id: '3525110002',
    districtId: '3525110',
    name: 'Suci',
  },
  {
    id: '3525110003',
    districtId: '3525110',
    name: 'Yosowilangun',
  },
  {
    id: '3525110004',
    districtId: '3525110',
    name: 'Roomo',
  },
  {
    id: '3525110005',
    districtId: '3525110',
    name: 'Sukomulyo',
  },
  {
    id: '3525110006',
    districtId: '3525110',
    name: 'Pongangan',
  },
  {
    id: '3525110007',
    districtId: '3525110',
    name: 'Peganden',
  },
  {
    id: '3525110008',
    districtId: '3525110',
    name: 'Banjarsari',
  },
  {
    id: '3525110009',
    districtId: '3525110',
    name: 'Leran',
  },
  {
    id: '3525110010',
    districtId: '3525110',
    name: 'Manyarejo',
  },
  {
    id: '3525110011',
    districtId: '3525110',
    name: 'Manyarsidomukti',
  },
  {
    id: '3525110012',
    districtId: '3525110',
    name: 'Manyarsidorukun',
  },
  {
    id: '3525110013',
    districtId: '3525110',
    name: 'Banyuwangi',
  },
  {
    id: '3525110014',
    districtId: '3525110',
    name: 'Karangrejo',
  },
  {
    id: '3525110015',
    districtId: '3525110',
    name: 'Sembayat',
  },
  {
    id: '3525110016',
    districtId: '3525110',
    name: 'Betoyoguci',
  },
  {
    id: '3525110017',
    districtId: '3525110',
    name: 'Betoyokauman',
  },
  {
    id: '3525110018',
    districtId: '3525110',
    name: 'Sumberejo',
  },
  {
    id: '3525110019',
    districtId: '3525110',
    name: 'Tanggulrejo',
  },
  {
    id: '3525110020',
    districtId: '3525110',
    name: 'Gumeno',
  },
  {
    id: '3525110021',
    districtId: '3525110',
    name: 'Ngampel',
  },
  {
    id: '3525110022',
    districtId: '3525110',
    name: 'Pejangganan',
  },
  {
    id: '3525110023',
    districtId: '3525110',
    name: 'Morobakung',
  },
  {
    id: '3525120001',
    districtId: '3525120',
    name: 'Sidomukti',
  },
  {
    id: '3525120002',
    districtId: '3525120',
    name: 'Mojopurogede',
  },
  {
    id: '3525120003',
    districtId: '3525120',
    name: 'Mojopuro Wetan',
  },
  {
    id: '3525120004',
    districtId: '3525120',
    name: 'Melirang',
  },
  {
    id: '3525120005',
    districtId: '3525120',
    name: 'Sidorejo',
  },
  {
    id: '3525120006',
    districtId: '3525120',
    name: 'Masangan',
  },
  {
    id: '3525120007',
    districtId: '3525120',
    name: 'Sukowati',
  },
  {
    id: '3525120008',
    districtId: '3525120',
    name: 'Bungah',
  },
  {
    id: '3525120009',
    districtId: '3525120',
    name: 'Sukorejo',
  },
  {
    id: '3525120010',
    districtId: '3525120',
    name: 'Bedanten',
  },
  {
    id: '3525120011',
    districtId: '3525120',
    name: 'Watuagung',
  },
  {
    id: '3525120012',
    districtId: '3525120',
    name: 'Kramat',
  },
  {
    id: '3525120013',
    districtId: '3525120',
    name: 'Tajung Widoro',
  },
  {
    id: '3525120014',
    districtId: '3525120',
    name: 'Sungonlegowo',
  },
  {
    id: '3525120015',
    districtId: '3525120',
    name: 'Indrodelik',
  },
  {
    id: '3525120016',
    districtId: '3525120',
    name: 'Kisik',
  },
  {
    id: '3525120017',
    districtId: '3525120',
    name: 'Abar-Abir',
  },
  {
    id: '3525120018',
    districtId: '3525120',
    name: 'Sidokumpul',
  },
  {
    id: '3525120019',
    districtId: '3525120',
    name: 'Raciwetan',
  },
  {
    id: '3525120020',
    districtId: '3525120',
    name: 'Pegundan',
  },
  {
    id: '3525120021',
    districtId: '3525120',
    name: 'Kemangi',
  },
  {
    id: '3525130001',
    districtId: '3525130',
    name: 'Sukorejo',
  },
  {
    id: '3525130002',
    districtId: '3525130',
    name: 'Lasem',
  },
  {
    id: '3525130003',
    districtId: '3525130',
    name: 'Kertosono',
  },
  {
    id: '3525130004',
    districtId: '3525130',
    name: 'Racikulon',
  },
  {
    id: '3525130005',
    districtId: '3525130',
    name: 'Racitengah',
  },
  {
    id: '3525130006',
    districtId: '3525130',
    name: 'Ngawen',
  },
  {
    id: '3525130007',
    districtId: '3525130',
    name: 'Randuboto',
  },
  {
    id: '3525130008',
    districtId: '3525130',
    name: 'Mojoasem',
  },
  {
    id: '3525130009',
    districtId: '3525130',
    name: 'Asempapak',
  },
  {
    id: '3525130010',
    districtId: '3525130',
    name: 'Mriyunan',
  },
  {
    id: '3525130011',
    districtId: '3525130',
    name: 'Sidomulyo',
  },
  {
    id: '3525130012',
    districtId: '3525130',
    name: 'Purwodadi',
  },
  {
    id: '3525130013',
    districtId: '3525130',
    name: 'Bunderan',
  },
  {
    id: '3525130014',
    districtId: '3525130',
    name: 'Kauman',
  },
  {
    id: '3525130016',
    districtId: '3525130',
    name: 'Sedagaran',
  },
  {
    id: '3525130017',
    districtId: '3525130',
    name: 'Srowo',
  },
  {
    id: '3525130018',
    districtId: '3525130',
    name: 'Golokan',
  },
  {
    id: '3525130019',
    districtId: '3525130',
    name: 'Sambipondok',
  },
  {
    id: '3525130020',
    districtId: '3525130',
    name: 'Wadeng',
  },
  {
    id: '3525130021',
    districtId: '3525130',
    name: 'Gedangan',
  },
  {
    id: '3525140001',
    districtId: '3525140',
    name: 'Sawo',
  },
  {
    id: '3525140002',
    districtId: '3525140',
    name: 'Karangcangkring',
  },
  {
    id: '3525140003',
    districtId: '3525140',
    name: 'Gedongkedoan',
  },
  {
    id: '3525140004',
    districtId: '3525140',
    name: 'Bulangan',
  },
  {
    id: '3525140005',
    districtId: '3525140',
    name: 'Wonokerto',
  },
  {
    id: '3525140006',
    districtId: '3525140',
    name: 'Bangeran',
  },
  {
    id: '3525140007',
    districtId: '3525140',
    name: 'Tiremenggal',
  },
  {
    id: '3525140008',
    districtId: '3525140',
    name: 'Lowayu',
  },
  {
    id: '3525140009',
    districtId: '3525140',
    name: 'Petiyin Tunggal',
  },
  {
    id: '3525140011',
    districtId: '3525140',
    name: 'Dukuh Kembar',
  },
  {
    id: '3525140012',
    districtId: '3525140',
    name: 'Madumulyorejo',
  },
  {
    id: '3525140013',
    districtId: '3525140',
    name: 'Mentaras',
  },
  {
    id: '3525140014',
    districtId: '3525140',
    name: 'Mojopetung',
  },
  {
    id: '3525140015',
    districtId: '3525140',
    name: 'Baron',
  },
  {
    id: '3525140017',
    districtId: '3525140',
    name: 'Ima An',
  },
  {
    id: '3525140018',
    districtId: '3525140',
    name: 'Sekargadung',
  },
  {
    id: '3525140019',
    districtId: '3525140',
    name: 'Babakbawo',
  },
  {
    id: '3525140020',
    districtId: '3525140',
    name: 'Babaksari',
  },
  {
    id: '3525140021',
    districtId: '3525140',
    name: 'Sambogunung',
  },
  {
    id: '3525140022',
    districtId: '3525140',
    name: 'Kalirejo',
  },
  {
    id: '3525140023',
    districtId: '3525140',
    name: 'Sembungan Kidul',
  },
  {
    id: '3525140024',
    districtId: '3525140',
    name: 'Sembung Anyar',
  },
  {
    id: '3525140025',
    districtId: '3525140',
    name: 'Dukunanyar',
  },
  {
    id: '3525140026',
    districtId: '3525140',
    name: 'Padang Bandung',
  },
  {
    id: '3525150002',
    districtId: '3525150',
    name: 'Serah',
  },
  {
    id: '3525150003',
    districtId: '3525150',
    name: 'Sukodono',
  },
  {
    id: '3525150005',
    districtId: '3525150',
    name: 'Wotan',
  },
  {
    id: '3525150006',
    districtId: '3525150',
    name: 'Doudo',
  },
  {
    id: '3525150007',
    districtId: '3525150',
    name: 'Surowiti',
  },
  {
    id: '3525150008',
    districtId: '3525150',
    name: 'Siwalan',
  },
  {
    id: '3525150009',
    districtId: '3525150',
    name: 'Ketanen',
  },
  {
    id: '3525150010',
    districtId: '3525150',
    name: 'Pantenan',
  },
  {
    id: '3525150012',
    districtId: '3525150',
    name: 'Dalegan',
  },
  {
    id: '3525150013',
    districtId: '3525150',
    name: 'Campurejo',
  },
  {
    id: '3525150014',
    districtId: '3525150',
    name: 'Banyutengah',
  },
  {
    id: '3525160001',
    districtId: '3525160',
    name: 'Sekapuk',
  },
  {
    id: '3525160002',
    districtId: '3525160',
    name: 'Bolo',
  },
  {
    id: '3525160003',
    districtId: '3525160',
    name: 'Glatik',
  },
  {
    id: '3525160004',
    districtId: '3525160',
    name: 'Tanjangawan',
  },
  {
    id: '3525160005',
    districtId: '3525160',
    name: 'Ketapang Lor',
  },
  {
    id: '3525160006',
    districtId: '3525160',
    name: 'Karangrejo',
  },
  {
    id: '3525160007',
    districtId: '3525160',
    name: 'Kebonagung',
  },
  {
    id: '3525160008',
    districtId: '3525160',
    name: 'Gosari',
  },
  {
    id: '3525160009',
    districtId: '3525160',
    name: 'Cangaan',
  },
  {
    id: '3525160010',
    districtId: '3525160',
    name: 'Ngemboh',
  },
  {
    id: '3525160011',
    districtId: '3525160',
    name: 'Banyuurip',
  },
  {
    id: '3525160012',
    districtId: '3525160',
    name: 'Pangkah Kulon',
  },
  {
    id: '3525160013',
    districtId: '3525160',
    name: 'Pangkah Wetan',
  },
  {
    id: '3525170001',
    districtId: '3525170',
    name: 'Kumalasa',
  },
  {
    id: '3525170002',
    districtId: '3525170',
    name: 'Lebak',
  },
  {
    id: '3525170003',
    districtId: '3525170',
    name: 'Bululanjang',
  },
  {
    id: '3525170004',
    districtId: '3525170',
    name: 'Sungai Teluk',
  },
  {
    id: '3525170005',
    districtId: '3525170',
    name: 'Kotakusuma',
  },
  {
    id: '3525170006',
    districtId: '3525170',
    name: 'Sawahmulya',
  },
  {
    id: '3525170007',
    districtId: '3525170',
    name: 'Sungairujing',
  },
  {
    id: '3525170008',
    districtId: '3525170',
    name: 'Daun',
  },
  {
    id: '3525170009',
    districtId: '3525170',
    name: 'Sidogedungbatu',
  },
  {
    id: '3525170010',
    districtId: '3525170',
    name: 'Kebontelukdalam',
  },
  {
    id: '3525170011',
    districtId: '3525170',
    name: 'Balikterus',
  },
  {
    id: '3525170013',
    districtId: '3525170',
    name: 'Patarselamat',
  },
  {
    id: '3525170014',
    districtId: '3525170',
    name: 'Pudakittimur',
  },
  {
    id: '3525170015',
    districtId: '3525170',
    name: 'Pudakitbarat',
  },
  {
    id: '3525170016',
    districtId: '3525170',
    name: 'Suwari',
  },
  {
    id: '3525170017',
    districtId: '3525170',
    name: 'Dekatagung',
  },
  {
    id: '3525180001',
    districtId: '3525180',
    name: 'Teluk Jatidawang',
  },
  {
    id: '3525180002',
    districtId: '3525180',
    name: 'Gelam',
  },
  {
    id: '3525180003',
    districtId: '3525180',
    name: 'Sukaoneng',
  },
  {
    id: '3525180004',
    districtId: '3525180',
    name: 'Kelompanggubug',
  },
  {
    id: '3525180005',
    districtId: '3525180',
    name: 'Sukalela',
  },
  {
    id: '3525180006',
    districtId: '3525180',
    name: 'Pekalongan',
  },
  {
    id: '3525180007',
    districtId: '3525180',
    name: 'Tambak',
  },
  {
    id: '3525180009',
    districtId: '3525180',
    name: 'Tanjungori',
  },
  {
    id: '3525180010',
    districtId: '3525180',
    name: 'Paromaan',
  },
  {
    id: '3525180011',
    districtId: '3525180',
    name: 'Diponggo',
  },
  {
    id: '3525180013',
    districtId: '3525180',
    name: 'Kepuh Legundi',
  },
  {
    id: '3526010001',
    districtId: '3526010',
    name: 'Tajungan',
  },
  {
    id: '3526010002',
    districtId: '3526010',
    name: 'Gili Barat',
  },
  {
    id: '3526010003',
    districtId: '3526010',
    name: 'Banyu Ajuh',
  },
  {
    id: '3526010004',
    districtId: '3526010',
    name: 'Kamal',
  },
  {
    id: '3526010005',
    districtId: '3526010',
    name: 'Tanjung Jati',
  },
  {
    id: '3526010007',
    districtId: '3526010',
    name: 'Gili Timur',
  },
  {
    id: '3526010008',
    districtId: '3526010',
    name: 'Gili Anyar',
  },
  {
    id: '3526010009',
    districtId: '3526010',
    name: 'Tellang',
  },
  {
    id: '3526010010',
    districtId: '3526010',
    name: 'Pendabah',
  },
  {
    id: '3526020002',
    districtId: '3526020',
    name: 'Pangpong',
  },
  {
    id: '3526020003',
    districtId: '3526020',
    name: 'Sukolilo Barat',
  },
  {
    id: '3526020004',
    districtId: '3526020',
    name: 'Sukolilo Timur',
  },
  {
    id: '3526020005',
    districtId: '3526020',
    name: 'Bunajih',
  },
  {
    id: '3526020006',
    districtId: '3526020',
    name: 'Bringin',
  },
  {
    id: '3526020007',
    districtId: '3526020',
    name: "Ba'Engas",
  },
  {
    id: '3526020008',
    districtId: '3526020',
    name: 'Morkepek',
  },
  {
    id: '3526020009',
    districtId: '3526020',
    name: 'Labang',
  },
  {
    id: '3526020010',
    districtId: '3526020',
    name: 'Jukong',
  },
  {
    id: '3526020011',
    districtId: '3526020',
    name: 'Sendang Laok',
  },
  {
    id: '3526020012',
    districtId: '3526020',
    name: 'Sendang Dajah',
  },
  {
    id: '3526020013',
    districtId: '3526020',
    name: 'Petapan',
  },
  {
    id: '3526030002',
    districtId: '3526030',
    name: 'Kwanyar Barat',
  },
  {
    id: '3526030003',
    districtId: '3526030',
    name: 'Pasanggrahan',
  },
  {
    id: '3526030004',
    districtId: '3526030',
    name: 'Karanganyar',
  },
  {
    id: '3526030005',
    districtId: '3526030',
    name: 'Batah Barat',
  },
  {
    id: '3526030006',
    districtId: '3526030',
    name: 'Batah Timur',
  },
  {
    id: '3526030008',
    districtId: '3526030',
    name: 'Pandanan',
  },
  {
    id: '3526030009',
    districtId: '3526030',
    name: 'Karang Entang',
  },
  {
    id: '3526030010',
    districtId: '3526030',
    name: 'Janteh',
  },
  {
    id: '3526030012',
    districtId: '3526030',
    name: 'Ketetang',
  },
  {
    id: '3526030013',
    districtId: '3526030',
    name: 'Morombuh',
  },
  {
    id: '3526030014',
    districtId: '3526030',
    name: 'Sumur Kuning',
  },
  {
    id: '3526030015',
    districtId: '3526030',
    name: 'Paoran',
  },
  {
    id: '3526040001',
    districtId: '3526040',
    name: 'Pangpajung',
  },
  {
    id: '3526040002',
    districtId: '3526040',
    name: 'Patereman',
  },
  {
    id: '3526040003',
    districtId: '3526040',
    name: 'Kolla',
  },
  {
    id: '3526040004',
    districtId: '3526040',
    name: 'Paeng',
  },
  {
    id: '3526040005',
    districtId: '3526040',
    name: 'Neroh',
  },
  {
    id: '3526040006',
    districtId: '3526040',
    name: 'Serabi Timur',
  },
  {
    id: '3526040007',
    districtId: '3526040',
    name: 'Serabi Barat',
  },
  {
    id: '3526040008',
    districtId: '3526040',
    name: 'Patengteng',
  },
  {
    id: '3526040009',
    districtId: '3526040',
    name: 'Langpanggang',
  },
  {
    id: '3526040010',
    districtId: '3526040',
    name: 'Suwaan',
  },
  {
    id: '3526040011',
    districtId: '3526040',
    name: 'Modung',
  },
  {
    id: '3526040012',
    districtId: '3526040',
    name: 'Brakas Dajah',
  },
  {
    id: '3526040013',
    districtId: '3526040',
    name: 'Karanganyar',
  },
  {
    id: '3526040014',
    districtId: '3526040',
    name: 'Manggaan',
  },
  {
    id: '3526040015',
    districtId: '3526040',
    name: 'Glisgis',
  },
  {
    id: '3526040016',
    districtId: '3526040',
    name: 'Pakong',
  },
  {
    id: '3526040017',
    districtId: '3526040',
    name: 'Alaskokon',
  },
  {
    id: '3526050001',
    districtId: '3526050',
    name: 'Gigir',
  },
  {
    id: '3526050002',
    districtId: '3526050',
    name: "Ko'Olan",
  },
  {
    id: '3526050003',
    districtId: '3526050',
    name: 'Pangeran Gedungan',
  },
  {
    id: '3526050004',
    districtId: '3526050',
    name: 'Panjalinan',
  },
  {
    id: '3526050005',
    districtId: '3526050',
    name: 'Rosep',
  },
  {
    id: '3526050006',
    districtId: '3526050',
    name: 'Kampao',
  },
  {
    id: '3526050007',
    districtId: '3526050',
    name: 'Lombang Laok',
  },
  {
    id: '3526050008',
    districtId: '3526050',
    name: 'Lombang Daya',
  },
  {
    id: '3526050009',
    districtId: '3526050',
    name: 'Karpote',
  },
  {
    id: '3526050010',
    districtId: '3526050',
    name: 'Blegaoloh',
  },
  {
    id: '3526050011',
    districtId: '3526050',
    name: 'Karang Gayam',
  },
  {
    id: '3526050012',
    districtId: '3526050',
    name: 'Lomaer',
  },
  {
    id: '3526050013',
    districtId: '3526050',
    name: 'Bates',
  },
  {
    id: '3526050014',
    districtId: '3526050',
    name: 'Karang Panasan',
  },
  {
    id: '3526050015',
    districtId: '3526050',
    name: 'Karangnangka',
  },
  {
    id: '3526050016',
    districtId: '3526050',
    name: 'Blega',
  },
  {
    id: '3526050017',
    districtId: '3526050',
    name: 'Nyor Manis',
  },
  {
    id: '3526050018',
    districtId: '3526050',
    name: 'Alasraja',
  },
  {
    id: '3526050019',
    districtId: '3526050',
    name: 'Kajan',
  },
  {
    id: '3526060001',
    districtId: '3526060',
    name: 'Galis Dajah',
  },
  {
    id: '3526060002',
    districtId: '3526060',
    name: 'Durin Barat',
  },
  {
    id: '3526060003',
    districtId: '3526060',
    name: 'Kanegarah',
  },
  {
    id: '3526060004',
    districtId: '3526060',
    name: 'Batokaban',
  },
  {
    id: '3526060005',
    districtId: '3526060',
    name: 'Durin Timur',
  },
  {
    id: '3526060006',
    districtId: '3526060',
    name: 'Pakes',
  },
  {
    id: '3526060007',
    districtId: '3526060',
    name: 'Bandung',
  },
  {
    id: '3526060008',
    districtId: '3526060',
    name: 'Konang',
  },
  {
    id: '3526060009',
    districtId: '3526060',
    name: 'Senasen',
  },
  {
    id: '3526060010',
    districtId: '3526060',
    name: 'Campor',
  },
  {
    id: '3526060011',
    districtId: '3526060',
    name: 'Sambiyan',
  },
  {
    id: '3526060012',
    districtId: '3526060',
    name: 'Cangkarman',
  },
  {
    id: '3526070001',
    districtId: '3526070',
    name: 'Pekadan',
  },
  {
    id: '3526070002',
    districtId: '3526070',
    name: 'Kajuanak',
  },
  {
    id: '3526070003',
    districtId: '3526070',
    name: 'Paterongan',
  },
  {
    id: '3526070004',
    districtId: '3526070',
    name: 'Galis',
  },
  {
    id: '3526070005',
    districtId: '3526070',
    name: "Paka'An Laok",
  },
  {
    id: '3526070006',
    districtId: '3526070',
    name: 'Kranggan Timur',
  },
  {
    id: '3526070007',
    districtId: '3526070',
    name: 'Separah',
  },
  {
    id: '3526070008',
    districtId: '3526070',
    name: "Paka'An Daya",
  },
  {
    id: '3526070009',
    districtId: '3526070',
    name: 'Longkek',
  },
  {
    id: '3526070010',
    districtId: '3526070',
    name: 'Banyubunih',
  },
  {
    id: '3526070011',
    districtId: '3526070',
    name: 'Daleman',
  },
  {
    id: '3526070012',
    districtId: '3526070',
    name: 'Tellok',
  },
  {
    id: '3526070013',
    districtId: '3526070',
    name: 'Blateran',
  },
  {
    id: '3526070015',
    districtId: '3526070',
    name: 'Tlagah',
  },
  {
    id: '3526070016',
    districtId: '3526070',
    name: 'Lantek Timur',
  },
  {
    id: '3526070017',
    districtId: '3526070',
    name: 'Lantek Barat',
  },
  {
    id: '3526070018',
    districtId: '3526070',
    name: 'Banjar',
  },
  {
    id: '3526070019',
    districtId: '3526070',
    name: 'Bangpendah',
  },
  {
    id: '3526070020',
    districtId: '3526070',
    name: 'Sadah',
  },
  {
    id: '3526070021',
    districtId: '3526070',
    name: 'Sorpa',
  },
  {
    id: '3526080001',
    districtId: '3526080',
    name: 'Pacentan',
  },
  {
    id: '3526080002',
    districtId: '3526080',
    name: 'Baipajung',
  },
  {
    id: '3526080003',
    districtId: '3526080',
    name: 'Tanah Merah Laok',
  },
  {
    id: '3526080004',
    districtId: '3526080',
    name: 'Kranggan Barat',
  },
  {
    id: '3526080005',
    districtId: '3526080',
    name: 'Pangeleyan',
  },
  {
    id: '3526080006',
    districtId: '3526080',
    name: 'Padurungan',
  },
  {
    id: '3526080007',
    districtId: '3526080',
    name: 'Petrah',
  },
  {
    id: '3526080008',
    districtId: '3526080',
    name: 'Tanah Merah Dajah',
  },
  {
    id: '3526080009',
    districtId: '3526080',
    name: 'Dumajah',
  },
  {
    id: '3526080010',
    districtId: '3526080',
    name: 'Patemon',
  },
  {
    id: '3526080011',
    districtId: '3526080',
    name: 'Tlomar',
  },
  {
    id: '3526080012',
    districtId: '3526080',
    name: 'Kendaban',
  },
  {
    id: '3526080013',
    districtId: '3526080',
    name: 'Jangkar',
  },
  {
    id: '3526080014',
    districtId: '3526080',
    name: 'Pettong',
  },
  {
    id: '3526080015',
    districtId: '3526080',
    name: 'Landak',
  },
  {
    id: '3526080016',
    districtId: '3526080',
    name: 'Rongdurin',
  },
  {
    id: '3526080017',
    districtId: '3526080',
    name: 'Batangan',
  },
  {
    id: '3526080018',
    districtId: '3526080',
    name: 'Dlambah Dajah',
  },
  {
    id: '3526080019',
    districtId: '3526080',
    name: 'Dlamba Laok',
  },
  {
    id: '3526080020',
    districtId: '3526080',
    name: 'Mrecah',
  },
  {
    id: '3526080021',
    districtId: '3526080',
    name: 'Buddan',
  },
  {
    id: '3526080022',
    districtId: '3526080',
    name: 'Poter',
  },
  {
    id: '3526080023',
    districtId: '3526080',
    name: 'Basanah',
  },
  {
    id: '3526090001',
    districtId: '3526090',
    name: 'Alang Alang',
  },
  {
    id: '3526090002',
    districtId: '3526090',
    name: 'Kemoneng',
  },
  {
    id: '3526090003',
    districtId: '3526090',
    name: 'Soket Laok',
  },
  {
    id: '3526090004',
    districtId: '3526090',
    name: 'Bajeman',
  },
  {
    id: '3526090005',
    districtId: '3526090',
    name: 'Tambin',
  },
  {
    id: '3526090006',
    districtId: '3526090',
    name: 'Soket Daya',
  },
  {
    id: '3526090008',
    districtId: '3526090',
    name: 'Jaah',
  },
  {
    id: '3526090009',
    districtId: '3526090',
    name: 'Bancang',
  },
  {
    id: '3526090010',
    districtId: '3526090',
    name: 'Masaran',
  },
  {
    id: '3526090011',
    districtId: '3526090',
    name: 'Pacangan',
  },
  {
    id: '3526090012',
    districtId: '3526090',
    name: 'Pocong',
  },
  {
    id: '3526090013',
    districtId: '3526090',
    name: 'Tragah',
  },
  {
    id: '3526090014',
    districtId: '3526090',
    name: 'Karang Leman',
  },
  {
    id: '3526090015',
    districtId: '3526090',
    name: 'Dukotambin',
  },
  {
    id: '3526090016',
    districtId: '3526090',
    name: 'Jaddung',
  },
  {
    id: '3526090017',
    districtId: '3526090',
    name: 'Banyu Bese',
  },
  {
    id: '3526090018',
    districtId: '3526090',
    name: 'Pamorah',
  },
  {
    id: '3526100001',
    districtId: '3526100',
    name: 'Junganyar',
  },
  {
    id: '3526100002',
    districtId: '3526100',
    name: 'Socah',
  },
  {
    id: '3526100004',
    districtId: '3526100',
    name: 'Jaddih',
  },
  {
    id: '3526100005',
    districtId: '3526100',
    name: 'Sanggra Agung',
  },
  {
    id: '3526100006',
    districtId: '3526100',
    name: 'Parseh',
  },
  {
    id: '3526100007',
    districtId: '3526100',
    name: 'Bilaporah',
  },
  {
    id: '3526100008',
    districtId: '3526100',
    name: 'Keleyan',
  },
  {
    id: '3526100009',
    districtId: '3526100',
    name: 'Petaonan',
  },
  {
    id: '3526100010',
    districtId: '3526100',
    name: 'Dakiring',
  },
  {
    id: '3526100011',
    districtId: '3526100',
    name: 'Pernajuh',
  },
  {
    id: '3526110001',
    districtId: '3526110',
    name: 'Ujung Piring',
  },
  {
    id: '3526110002',
    districtId: '3526110',
    name: 'Sembilangan',
  },
  {
    id: '3526110003',
    districtId: '3526110',
    name: 'Kramat',
  },
  {
    id: '3526110004',
    districtId: '3526110',
    name: 'Mertajasah',
  },
  {
    id: '3526110005',
    districtId: '3526110',
    name: 'Mlajah',
  },
  {
    id: '3526110006',
    districtId: '3526110',
    name: 'Kemayoran',
  },
  {
    id: '3526110007',
    districtId: '3526110',
    name: 'Pangeranan',
  },
  {
    id: '3526110008',
    districtId: '3526110',
    name: 'Demangan',
  },
  {
    id: '3526110009',
    districtId: '3526110',
    name: 'Kraton',
  },
  {
    id: '3526110010',
    districtId: '3526110',
    name: 'Pejagan',
  },
  {
    id: '3526110011',
    districtId: '3526110',
    name: 'Bancaran',
  },
  {
    id: '3526110012',
    districtId: '3526110',
    name: 'Sabiyan',
  },
  {
    id: '3526110013',
    districtId: '3526110',
    name: 'Gebang',
  },
  {
    id: '3526120001',
    districtId: '3526120',
    name: 'Jambu',
  },
  {
    id: '3526120002',
    districtId: '3526120',
    name: 'Langkap',
  },
  {
    id: '3526120004',
    districtId: '3526120',
    name: 'Benangkah',
  },
  {
    id: '3526120005',
    districtId: '3526120',
    name: 'Alas Kembang',
  },
  {
    id: '3526120006',
    districtId: '3526120',
    name: 'Binoh',
  },
  {
    id: '3526120008',
    districtId: '3526120',
    name: 'Pangolangan',
  },
  {
    id: '3526120009',
    districtId: '3526120',
    name: 'Sobih',
  },
  {
    id: '3526120010',
    districtId: '3526120',
    name: 'Tonjung',
  },
  {
    id: '3526120011',
    districtId: '3526120',
    name: 'Kapor',
  },
  {
    id: '3526120012',
    districtId: '3526120',
    name: 'Arok',
  },
  {
    id: '3526130001',
    districtId: '3526130',
    name: 'Pandan Lanjang',
  },
  {
    id: '3526130002',
    districtId: '3526130',
    name: 'Batonaong',
  },
  {
    id: '3526130003',
    districtId: '3526130',
    name: 'Glagga',
  },
  {
    id: '3526130004',
    districtId: '3526130',
    name: 'Ombul',
  },
  {
    id: '3526130005',
    districtId: '3526130',
    name: 'Balung',
  },
  {
    id: '3526130006',
    districtId: '3526130',
    name: 'Lajing',
  },
  {
    id: '3526130008',
    districtId: '3526130',
    name: 'Arosbaya',
  },
  {
    id: '3526130009',
    districtId: '3526130',
    name: 'Karang Duwak',
  },
  {
    id: '3526130011',
    districtId: '3526130',
    name: 'Mangkon',
  },
  {
    id: '3526130013',
    districtId: '3526130',
    name: 'Cendagah',
  },
  {
    id: '3526130014',
    districtId: '3526130',
    name: 'Karang Pao',
  },
  {
    id: '3526130015',
    districtId: '3526130',
    name: 'Makam Agung',
  },
  {
    id: '3526130016',
    districtId: '3526130',
    name: 'Plakaran',
  },
  {
    id: '3526130017',
    districtId: '3526130',
    name: 'Buduran',
  },
  {
    id: '3526130018',
    districtId: '3526130',
    name: 'Tambegan',
  },
  {
    id: '3526140001',
    districtId: '3526140',
    name: 'Togubang',
  },
  {
    id: '3526140002',
    districtId: '3526140',
    name: 'Lerpak',
  },
  {
    id: '3526140004',
    districtId: '3526140',
    name: 'Batobella',
  },
  {
    id: '3526140005',
    districtId: '3526140',
    name: 'Tegerpriyah',
  },
  {
    id: '3526140006',
    districtId: '3526140',
    name: 'Campor',
  },
  {
    id: '3526140007',
    districtId: '3526140',
    name: 'Kompol',
  },
  {
    id: '3526140008',
    districtId: '3526140',
    name: 'Kampak',
  },
  {
    id: '3526140009',
    districtId: '3526140',
    name: 'Kombangan',
  },
  {
    id: '3526140010',
    districtId: '3526140',
    name: 'Dabung',
  },
  {
    id: '3526140011',
    districtId: '3526140',
    name: 'Katol Barat',
  },
  {
    id: '3526140012',
    districtId: '3526140',
    name: 'Banyoneng Laok',
  },
  {
    id: '3526140013',
    districtId: '3526140',
    name: 'Banyoneng Dajah',
  },
  {
    id: '3526150002',
    districtId: '3526150',
    name: 'Amparaan',
  },
  {
    id: '3526150003',
    districtId: '3526150',
    name: 'Kokop',
  },
  {
    id: '3526150004',
    districtId: '3526150',
    name: 'Tlokoh',
  },
  {
    id: '3526150005',
    districtId: '3526150',
    name: 'Durjan',
  },
  {
    id: '3526150006',
    districtId: '3526150',
    name: "Mano'An",
  },
  {
    id: '3526150007',
    districtId: '3526150',
    name: 'Mandung',
  },
  {
    id: '3526150008',
    districtId: '3526150',
    name: 'Bandang Laok',
  },
  {
    id: '3526150009',
    districtId: '3526150',
    name: 'Tramok',
  },
  {
    id: '3526150010',
    districtId: '3526150',
    name: 'Katol Timur',
  },
  {
    id: '3526150011',
    districtId: '3526150',
    name: 'Banda Soleh',
  },
  {
    id: '3526150012',
    districtId: '3526150',
    name: 'Dupok',
  },
  {
    id: '3526150013',
    districtId: '3526150',
    name: 'Batokorogan',
  },
  {
    id: '3526160001',
    districtId: '3526160',
    name: 'Planggiran',
  },
  {
    id: '3526160002',
    districtId: '3526160',
    name: 'Tagungguh',
  },
  {
    id: '3526160003',
    districtId: '3526160',
    name: 'Bandang Daya',
  },
  {
    id: '3526160005',
    districtId: '3526160',
    name: 'Larangan Timur',
  },
  {
    id: '3526160006',
    districtId: '3526160',
    name: 'Tambak Pocok',
  },
  {
    id: '3526160007',
    districtId: '3526160',
    name: 'Bumi Anyar',
  },
  {
    id: '3526160008',
    districtId: '3526160',
    name: 'Paseseh',
  },
  {
    id: '3526160009',
    districtId: '3526160',
    name: 'Telaga Biru',
  },
  {
    id: '3526160010',
    districtId: '3526160',
    name: 'Tanjung Bumi',
  },
  {
    id: '3526160011',
    districtId: '3526160',
    name: 'Macajah',
  },
  {
    id: '3526160012',
    districtId: '3526160',
    name: 'Tlangoh',
  },
  {
    id: '3526160013',
    districtId: '3526160',
    name: 'Banyu Sangkah',
  },
  {
    id: '3526160014',
    districtId: '3526160',
    name: 'Aengtabar',
  },
  {
    id: '3526170001',
    districtId: '3526170',
    name: 'Klapayan',
  },
  {
    id: '3526170002',
    districtId: '3526170',
    name: 'Bangsereh',
  },
  {
    id: '3526170004',
    districtId: '3526170',
    name: 'Saplasah',
  },
  {
    id: '3526170005',
    districtId: '3526170',
    name: 'Gunelap',
  },
  {
    id: '3526170006',
    districtId: '3526170',
    name: 'Tanagura Timur',
  },
  {
    id: '3526170007',
    districtId: '3526170',
    name: 'Tanagura Barat',
  },
  {
    id: '3526170008',
    districtId: '3526170',
    name: 'Banyior',
  },
  {
    id: '3526170009',
    districtId: '3526170',
    name: 'Klabetan',
  },
  {
    id: '3526170010',
    districtId: '3526170',
    name: 'Gangseyan',
  },
  {
    id: '3526170011',
    districtId: '3526170',
    name: 'Maneron',
  },
  {
    id: '3526170013',
    districtId: '3526170',
    name: 'Prancak',
  },
  {
    id: '3526170014',
    districtId: '3526170',
    name: 'Labuhan',
  },
  {
    id: '3526170015',
    districtId: '3526170',
    name: 'Lembung Paseser',
  },
  {
    id: '3526180001',
    districtId: '3526180',
    name: 'Tolbuk',
  },
  {
    id: '3526180002',
    districtId: '3526180',
    name: "Ra'As",
  },
  {
    id: '3526180003',
    districtId: '3526180',
    name: 'Muarah',
  },
  {
    id: '3526180004',
    districtId: '3526180',
    name: 'Polongan',
  },
  {
    id: '3526180005',
    districtId: '3526180',
    name: 'Karang Asem',
  },
  {
    id: '3526180006',
    districtId: '3526180',
    name: 'Bantean',
  },
  {
    id: '3526180007',
    districtId: '3526180',
    name: 'Bragang',
  },
  {
    id: '3526180008',
    districtId: '3526180',
    name: 'Lergunong',
  },
  {
    id: '3526180009',
    districtId: '3526180',
    name: 'Panyaksagan',
  },
  {
    id: '3526180010',
    districtId: '3526180',
    name: 'Larangan Glintong',
  },
  {
    id: '3526180011',
    districtId: '3526180',
    name: 'Manonggal',
  },
  {
    id: '3526180012',
    districtId: '3526180',
    name: 'Larangan Sorjan',
  },
  {
    id: '3526180013',
    districtId: '3526180',
    name: 'Tenggun Daya',
  },
  {
    id: '3526180015',
    districtId: '3526180',
    name: 'Trogan',
  },
  {
    id: '3526180016',
    districtId: '3526180',
    name: "Ko'Ol",
  },
  {
    id: '3526180017',
    districtId: '3526180',
    name: 'Tobaddung',
  },
  {
    id: '3526180018',
    districtId: '3526180',
    name: 'Mrandung',
  },
  {
    id: '3526180019',
    districtId: '3526180',
    name: 'Buluk Agung',
  },
  {
    id: '3526180020',
    districtId: '3526180',
    name: 'Bator',
  },
  {
    id: '3526180021',
    districtId: '3526180',
    name: 'Klampis Barat',
  },
  {
    id: '3526180022',
    districtId: '3526180',
    name: 'Klampis Timur',
  },
  {
    id: '3527010001',
    districtId: '3527010',
    name: 'Noreh',
  },
  {
    id: '3527010002',
    districtId: '3527010',
    name: 'Labuhan',
  },
  {
    id: '3527010003',
    districtId: '3527010',
    name: 'Taman',
  },
  {
    id: '3527010005',
    districtId: '3527010',
    name: 'Disanah',
  },
  {
    id: '3527010006',
    districtId: '3527010',
    name: 'Marparan',
  },
  {
    id: '3527010007',
    districtId: '3527010',
    name: 'Klobur',
  },
  {
    id: '3527010008',
    districtId: '3527010',
    name: 'Labang',
  },
  {
    id: '3527010009',
    districtId: '3527010',
    name: 'Bundah',
  },
  {
    id: '3527010010',
    districtId: '3527010',
    name: 'Bangsah',
  },
  {
    id: '3527010011',
    districtId: '3527010',
    name: 'Plasah',
  },
  {
    id: '3527010012',
    districtId: '3527010',
    name: 'Junok',
  },
  {
    id: '3527020007',
    districtId: '3527020',
    name: 'Dulang',
  },
  {
    id: '3527020008',
    districtId: '3527020',
    name: 'Patarongan',
  },
  {
    id: '3527020009',
    districtId: '3527020',
    name: 'Pangongsean',
  },
  {
    id: '3527020010',
    districtId: '3527020',
    name: 'Krampon',
  },
  {
    id: '3527020011',
    districtId: '3527020',
    name: 'Bringin Nonggal',
  },
  {
    id: '3527020012',
    districtId: '3527020',
    name: 'Torjun',
  },
  {
    id: '3527020013',
    districtId: '3527020',
    name: 'Patapan',
  },
  {
    id: '3527020014',
    districtId: '3527020',
    name: 'Jeruk Porot',
  },
  {
    id: '3527020015',
    districtId: '3527020',
    name: 'Kodak',
  },
  {
    id: '3527020016',
    districtId: '3527020',
    name: 'Kanjar',
  },
  {
    id: '3527020017',
    districtId: '3527020',
    name: 'Kara',
  },
  {
    id: '3527020018',
    districtId: '3527020',
    name: 'Tana Mera',
  },
  {
    id: '3527021001',
    districtId: '3527021',
    name: 'Pangarengan',
  },
  {
    id: '3527021002',
    districtId: '3527021',
    name: 'Apaan',
  },
  {
    id: '3527021004',
    districtId: '3527021',
    name: 'Panyerangan',
  },
  {
    id: '3527021005',
    districtId: '3527021',
    name: 'Pacanggaan',
  },
  {
    id: '3527021006',
    districtId: '3527021',
    name: 'Ragung',
  },
  {
    id: '3527030001',
    districtId: '3527030',
    name: 'Pulau Mandangin',
  },
  {
    id: '3527030002',
    districtId: '3527030',
    name: 'Aeng Sareh',
  },
  {
    id: '3527030003',
    districtId: '3527030',
    name: 'Polagan',
  },
  {
    id: '3527030004',
    districtId: '3527030',
    name: 'Banyuanyar',
  },
  {
    id: '3527030005',
    districtId: '3527030',
    name: 'Gunung Maddah',
  },
  {
    id: '3527030006',
    districtId: '3527030',
    name: 'Rong Tengah',
  },
  {
    id: '3527030007',
    districtId: '3527030',
    name: 'Karang Dalem',
  },
  {
    id: '3527030008',
    districtId: '3527030',
    name: 'Gunung Sekar',
  },
  {
    id: '3527030009',
    districtId: '3527030',
    name: 'Dalpenang',
  },
  {
    id: '3527030010',
    districtId: '3527030',
    name: 'Paseyan',
  },
  {
    id: '3527030011',
    districtId: '3527030',
    name: 'Panggung',
  },
  {
    id: '3527030012',
    districtId: '3527030',
    name: 'Baruh',
  },
  {
    id: '3527030013',
    districtId: '3527030',
    name: 'Taman Sareh',
  },
  {
    id: '3527030014',
    districtId: '3527030',
    name: 'Pekalongan',
  },
  {
    id: '3527030015',
    districtId: '3527030',
    name: 'Tanggumong',
  },
  {
    id: '3527030016',
    districtId: '3527030',
    name: 'Kamoning',
  },
  {
    id: '3527030017',
    districtId: '3527030',
    name: 'Banyumas',
  },
  {
    id: '3527030018',
    districtId: '3527030',
    name: 'Pangelen',
  },
  {
    id: '3527040001',
    districtId: '3527040',
    name: 'Taddan',
  },
  {
    id: '3527040002',
    districtId: '3527040',
    name: 'Banjar Talela',
  },
  {
    id: '3527040003',
    districtId: '3527040',
    name: 'Tambaan',
  },
  {
    id: '3527040004',
    districtId: '3527040',
    name: 'Prajjan',
  },
  {
    id: '3527040005',
    districtId: '3527040',
    name: 'Dharma Camplong',
  },
  {
    id: '3527040006',
    districtId: '3527040',
    name: 'Batu Karang',
  },
  {
    id: '3527040007',
    districtId: '3527040',
    name: 'Sejati',
  },
  {
    id: '3527040008',
    districtId: '3527040',
    name: 'Dharma Tanjung',
  },
  {
    id: '3527040009',
    districtId: '3527040',
    name: 'Rabasan',
  },
  {
    id: '3527040010',
    districtId: '3527040',
    name: 'Banjar Tabulu',
  },
  {
    id: '3527040011',
    districtId: '3527040',
    name: 'Anggersek',
  },
  {
    id: '3527040012',
    districtId: '3527040',
    name: 'Madupat',
  },
  {
    id: '3527040013',
    districtId: '3527040',
    name: 'Pamolaan',
  },
  {
    id: '3527040014',
    districtId: '3527040',
    name: 'Plampaan',
  },
  {
    id: '3527050001',
    districtId: '3527050',
    name: 'Kebun Sareh',
  },
  {
    id: '3527050002',
    districtId: '3527050',
    name: 'Karang Nangger',
  },
  {
    id: '3527050003',
    districtId: '3527050',
    name: 'Napolaok',
  },
  {
    id: '3527050004',
    districtId: '3527050',
    name: 'Astapah',
  },
  {
    id: '3527050005',
    districtId: '3527050',
    name: 'Gersempal',
  },
  {
    id: '3527050007',
    districtId: '3527050',
    name: 'Madulang',
  },
  {
    id: '3527050008',
    districtId: '3527050',
    name: 'Kamondung',
  },
  {
    id: '3527050009',
    districtId: '3527050',
    name: 'Tambak',
  },
  {
    id: '3527050010',
    districtId: '3527050',
    name: 'Temoran',
  },
  {
    id: '3527050011',
    districtId: '3527050',
    name: 'Omben',
  },
  {
    id: '3527050012',
    districtId: '3527050',
    name: 'Sogiyan',
  },
  {
    id: '3527050013',
    districtId: '3527050',
    name: 'Napo Daya',
  },
  {
    id: '3527050014',
    districtId: '3527050',
    name: 'Jrangoan',
  },
  {
    id: '3527050015',
    districtId: '3527050',
    name: 'Angsokah',
  },
  {
    id: '3527050016',
    districtId: '3527050',
    name: 'Rapalaok',
  },
  {
    id: '3527050017',
    districtId: '3527050',
    name: 'Rongdalem',
  },
  {
    id: '3527050018',
    districtId: '3527050',
    name: 'Pandan',
  },
  {
    id: '3527050019',
    districtId: '3527050',
    name: 'Rapa Daya',
  },
  {
    id: '3527050020',
    districtId: '3527050',
    name: 'Karang Gayam',
  },
  {
    id: '3527060001',
    districtId: '3527060',
    name: 'Kramat',
  },
  {
    id: '3527060002',
    districtId: '3527060',
    name: 'Komis',
  },
  {
    id: '3527060003',
    districtId: '3527060',
    name: 'Banyukapah',
  },
  {
    id: '3527060004',
    districtId: '3527060',
    name: 'Rabasan',
  },
  {
    id: '3527060005',
    districtId: '3527060',
    name: 'Rohayu',
  },
  {
    id: '3527060006',
    districtId: '3527060',
    name: 'Muktesareh',
  },
  {
    id: '3527060007',
    districtId: '3527060',
    name: 'Bajrasokah',
  },
  {
    id: '3527060008',
    districtId: '3527060',
    name: 'Nyeloh',
  },
  {
    id: '3527060009',
    districtId: '3527060',
    name: 'Banjar',
  },
  {
    id: '3527060010',
    districtId: '3527060',
    name: 'Ombul',
  },
  {
    id: '3527060011',
    districtId: '3527060',
    name: 'Pajeruan',
  },
  {
    id: '3527060013',
    districtId: '3527060',
    name: 'Batoporo Barat',
  },
  {
    id: '3527060014',
    districtId: '3527060',
    name: 'Batoporo Timur',
  },
  {
    id: '3527060016',
    districtId: '3527060',
    name: 'Daleman',
  },
  {
    id: '3527060017',
    districtId: '3527060',
    name: 'Pasarenan',
  },
  {
    id: '3527060018',
    districtId: '3527060',
    name: 'Palenggiyan',
  },
  {
    id: '3527070001',
    districtId: '3527070',
    name: 'Margantoko',
  },
  {
    id: '3527070002',
    districtId: '3527070',
    name: 'Asem Nonggal',
  },
  {
    id: '3527070003',
    districtId: '3527070',
    name: 'Majangan',
  },
  {
    id: '3527070004',
    districtId: '3527070',
    name: 'Kalangan Prao',
  },
  {
    id: '3527070005',
    districtId: '3527070',
    name: 'Asem Raja',
  },
  {
    id: '3527070006',
    districtId: '3527070',
    name: 'Plakaran',
  },
  {
    id: '3527070008',
    districtId: '3527070',
    name: 'Bancelok',
  },
  {
    id: '3527070009',
    districtId: '3527070',
    name: 'Mlaka',
  },
  {
    id: '3527070010',
    districtId: '3527070',
    name: 'Jungkarang',
  },
  {
    id: '3527070011',
    districtId: '3527070',
    name: 'Kotah',
  },
  {
    id: '3527070012',
    districtId: '3527070',
    name: 'Jrengik',
  },
  {
    id: '3527070013',
    districtId: '3527070',
    name: 'Taman',
  },
  {
    id: '3527070014',
    districtId: '3527070',
    name: 'Panyepen',
  },
  {
    id: '3527080001',
    districtId: '3527080',
    name: 'Batorasang',
  },
  {
    id: '3527080002',
    districtId: '3527080',
    name: 'Karang Anyar',
  },
  {
    id: '3527080003',
    districtId: '3527080',
    name: 'Samaran',
  },
  {
    id: '3527080004',
    districtId: '3527080',
    name: 'Beringin',
  },
  {
    id: '3527080005',
    districtId: '3527080',
    name: 'Mambulu Barat',
  },
  {
    id: '3527080006',
    districtId: '3527080',
    name: 'Barung Gagah',
  },
  {
    id: '3527080007',
    districtId: '3527080',
    name: 'Tambelangan',
  },
  {
    id: '3527080008',
    districtId: '3527080',
    name: 'Somber',
  },
  {
    id: '3527080009',
    districtId: '3527080',
    name: 'Banjar Billah',
  },
  {
    id: '3527080010',
    districtId: '3527080',
    name: 'Birem',
  },
  {
    id: '3527090001',
    districtId: '3527090',
    name: 'Olor',
  },
  {
    id: '3527090002',
    districtId: '3527090',
    name: 'Planggaran Barat',
  },
  {
    id: '3527090003',
    districtId: '3527090',
    name: 'Planggaran Timur',
  },
  {
    id: '3527090004',
    districtId: '3527090',
    name: 'Tolang',
  },
  {
    id: '3527090005',
    districtId: '3527090',
    name: 'Lar Lar',
  },
  {
    id: '3527090006',
    districtId: '3527090',
    name: 'Tlagah',
  },
  {
    id: '3527090007',
    districtId: '3527090',
    name: 'Nagasareh',
  },
  {
    id: '3527090008',
    districtId: '3527090',
    name: 'Tapaan',
  },
  {
    id: '3527090009',
    districtId: '3527090',
    name: 'Terosan',
  },
  {
    id: '3527090010',
    districtId: '3527090',
    name: 'Asem Jaran',
  },
  {
    id: '3527090011',
    districtId: '3527090',
    name: 'Kembang Jeruk',
  },
  {
    id: '3527090012',
    districtId: '3527090',
    name: 'Morbatoh',
  },
  {
    id: '3527090013',
    districtId: '3527090',
    name: 'Montor',
  },
  {
    id: '3527090014',
    districtId: '3527090',
    name: 'Tebanah',
  },
  {
    id: '3527090015',
    districtId: '3527090',
    name: 'Nepa',
  },
  {
    id: '3527090016',
    districtId: '3527090',
    name: 'Batioh',
  },
  {
    id: '3527090017',
    districtId: '3527090',
    name: 'Masaran',
  },
  {
    id: '3527090018',
    districtId: '3527090',
    name: 'Banyuates',
  },
  {
    id: '3527090019',
    districtId: '3527090',
    name: 'Jatra Timur',
  },
  {
    id: '3527090020',
    districtId: '3527090',
    name: 'Trapang',
  },
  {
    id: '3527100001',
    districtId: '3527100',
    name: 'Bapelle',
  },
  {
    id: '3527100010',
    districtId: '3527100',
    name: 'Robatal',
  },
  {
    id: '3527100011',
    districtId: '3527100',
    name: 'Sawah Tengah',
  },
  {
    id: '3527100012',
    districtId: '3527100',
    name: 'Torjunan',
  },
  {
    id: '3527100013',
    districtId: '3527100',
    name: 'Tragih',
  },
  {
    id: '3527100015',
    districtId: '3527100',
    name: 'Gunung Rancak',
  },
  {
    id: '3527100016',
    districtId: '3527100',
    name: 'Pandiyangan',
  },
  {
    id: '3527101001',
    districtId: '3527101',
    name: 'Bluuran',
  },
  {
    id: '3527101002',
    districtId: '3527101',
    name: 'Tlambah',
  },
  {
    id: '3527101003',
    districtId: '3527101',
    name: 'Gunung Kesan',
  },
  {
    id: '3527101004',
    districtId: '3527101',
    name: 'Karang Penang Onjur',
  },
  {
    id: '3527101005',
    districtId: '3527101',
    name: 'Bulmatet',
  },
  {
    id: '3527101006',
    districtId: '3527101',
    name: 'Poreh',
  },
  {
    id: '3527101007',
    districtId: '3527101',
    name: 'Karang Penang Oloh',
  },
  {
    id: '3527110001',
    districtId: '3527110',
    name: 'Paopale Laok',
  },
  {
    id: '3527110002',
    districtId: '3527110',
    name: 'Bunten Barat',
  },
  {
    id: '3527110003',
    districtId: '3527110',
    name: 'Bunten Timur',
  },
  {
    id: '3527110004',
    districtId: '3527110',
    name: 'Pancor',
  },
  {
    id: '3527110005',
    districtId: '3527110',
    name: 'Karang Anyar',
  },
  {
    id: '3527110006',
    districtId: '3527110',
    name: 'Pangereman',
  },
  {
    id: '3527110007',
    districtId: '3527110',
    name: 'Bira Barat',
  },
  {
    id: '3527110008',
    districtId: '3527110',
    name: 'Ketapang Timur',
  },
  {
    id: '3527110009',
    districtId: '3527110',
    name: 'Ketapang Daya',
  },
  {
    id: '3527110010',
    districtId: '3527110',
    name: 'Ketapang Laok',
  },
  {
    id: '3527110011',
    districtId: '3527110',
    name: 'Ketapang Barat',
  },
  {
    id: '3527110012',
    districtId: '3527110',
    name: 'Paopale Daya',
  },
  {
    id: '3527110013',
    districtId: '3527110',
    name: 'Rabiyan',
  },
  {
    id: '3527110014',
    districtId: '3527110',
    name: 'Banyusokah',
  },
  {
    id: '3527120001',
    districtId: '3527120',
    name: 'Tobai Barat',
  },
  {
    id: '3527120002',
    districtId: '3527120',
    name: 'Tobai Tengah',
  },
  {
    id: '3527120003',
    districtId: '3527120',
    name: 'Tobai Timur',
  },
  {
    id: '3527120004',
    districtId: '3527120',
    name: 'Bira Tengah',
  },
  {
    id: '3527120005',
    districtId: '3527120',
    name: 'Bira Timur',
  },
  {
    id: '3527120006',
    districtId: '3527120',
    name: 'Sokobanah Laok',
  },
  {
    id: '3527120007',
    districtId: '3527120',
    name: 'Tamberu Laok',
  },
  {
    id: '3527120008',
    districtId: '3527120',
    name: 'Tamberu Daya',
  },
  {
    id: '3527120009',
    districtId: '3527120',
    name: 'Sokobanah Tengah',
  },
  {
    id: '3527120010',
    districtId: '3527120',
    name: 'Sokobanah Daya',
  },
  {
    id: '3527120011',
    districtId: '3527120',
    name: 'Tamberu Barat',
  },
  {
    id: '3527120012',
    districtId: '3527120',
    name: 'Tamberu Timur',
  },
  {
    id: '3528010001',
    districtId: '3528010',
    name: 'Dabuan',
  },
  {
    id: '3528010002',
    districtId: '3528010',
    name: 'Terrak',
  },
  {
    id: '3528010003',
    districtId: '3528010',
    name: 'Mangngar',
  },
  {
    id: '3528010004',
    districtId: '3528010',
    name: 'Bandaran',
  },
  {
    id: '3528010005',
    districtId: '3528010',
    name: 'Kramat',
  },
  {
    id: '3528010006',
    districtId: '3528010',
    name: 'Ambat',
  },
  {
    id: '3528010007',
    districtId: '3528010',
    name: 'Tlanakan',
  },
  {
    id: '3528010008',
    districtId: '3528010',
    name: 'Branta Pasisir',
  },
  {
    id: '3528010009',
    districtId: '3528010',
    name: 'Branta Tinggi',
  },
  {
    id: '3528010010',
    districtId: '3528010',
    name: 'Tlesa',
  },
  {
    id: '3528010011',
    districtId: '3528010',
    name: 'Larangan Tokol',
  },
  {
    id: '3528010013',
    districtId: '3528010',
    name: 'Panglegur',
  },
  {
    id: '3528010016',
    districtId: '3528010',
    name: 'Larangan Slampar',
  },
  {
    id: '3528010017',
    districtId: '3528010',
    name: "Taro'An",
  },
  {
    id: '3528020001',
    districtId: '3528020',
    name: 'Baddurih',
  },
  {
    id: '3528020002',
    districtId: '3528020',
    name: 'Pagagan',
  },
  {
    id: '3528020003',
    districtId: '3528020',
    name: 'Majungan',
  },
  {
    id: '3528020004',
    districtId: '3528020',
    name: 'Padelegan',
  },
  {
    id: '3528020005',
    districtId: '3528020',
    name: 'Tanjung',
  },
  {
    id: '3528020006',
    districtId: '3528020',
    name: 'Pademawu Timur',
  },
  {
    id: '3528020007',
    districtId: '3528020',
    name: 'Jarin',
  },
  {
    id: '3528020009',
    districtId: '3528020',
    name: "Sopa'Ah",
  },
  {
    id: '3528020010',
    districtId: '3528020',
    name: 'Buddih',
  },
  {
    id: '3528020012',
    districtId: '3528020',
    name: 'Sumedangan',
  },
  {
    id: '3528020013',
    districtId: '3528020',
    name: 'Pademawu Barat',
  },
  {
    id: '3528020015',
    districtId: '3528020',
    name: 'Dasok',
  },
  {
    id: '3528020016',
    districtId: '3528020',
    name: 'Murtajih',
  },
  {
    id: '3528020018',
    districtId: '3528020',
    name: 'Barurambat Timur',
  },
  {
    id: '3528020019',
    districtId: '3528020',
    name: 'Lawangan Daya',
  },
  {
    id: '3528020020',
    districtId: '3528020',
    name: 'Buddagan',
  },
  {
    id: '3528020021',
    districtId: '3528020',
    name: 'Tambung',
  },
  {
    id: '3528020022',
    districtId: '3528020',
    name: 'Sentol',
  },
  {
    id: '3528030001',
    districtId: '3528030',
    name: 'Konang',
  },
  {
    id: '3528030002',
    districtId: '3528030',
    name: 'Pandan',
  },
  {
    id: '3528030004',
    districtId: '3528030',
    name: 'Galis',
  },
  {
    id: '3528030005',
    districtId: '3528030',
    name: 'Bulay',
  },
  {
    id: '3528030006',
    districtId: '3528030',
    name: 'Tobungan',
  },
  {
    id: '3528030007',
    districtId: '3528030',
    name: 'Pagendingan',
  },
  {
    id: '3528030008',
    districtId: '3528030',
    name: 'Ponteh',
  },
  {
    id: '3528030009',
    districtId: '3528030',
    name: 'Polagan',
  },
  {
    id: '3528030010',
    districtId: '3528030',
    name: 'Artodung',
  },
  {
    id: '3528040001',
    districtId: '3528040',
    name: 'Peltong',
  },
  {
    id: '3528040002',
    districtId: '3528040',
    name: 'Trasak',
  },
  {
    id: '3528040003',
    districtId: '3528040',
    name: 'Tentenan Barat',
  },
  {
    id: '3528040004',
    districtId: '3528040',
    name: 'Tentenan Timur',
  },
  {
    id: '3528040005',
    districtId: '3528040',
    name: 'Grujugan',
  },
  {
    id: '3528040006',
    districtId: '3528040',
    name: 'Blumbungan',
  },
  {
    id: '3528040007',
    districtId: '3528040',
    name: 'Larangan Luar',
  },
  {
    id: '3528040008',
    districtId: '3528040',
    name: 'Larangan Dalam',
  },
  {
    id: '3528040009',
    districtId: '3528040',
    name: 'Panaguan',
  },
  {
    id: '3528040010',
    districtId: '3528040',
    name: 'Montok',
  },
  {
    id: '3528040011',
    districtId: '3528040',
    name: 'Kaduara Barat',
  },
  {
    id: '3528040012',
    districtId: '3528040',
    name: 'Lancar',
  },
  {
    id: '3528040013',
    districtId: '3528040',
    name: 'Taraban',
  },
  {
    id: '3528040014',
    districtId: '3528040',
    name: 'Dukuh Timur',
  },
  {
    id: '3528050001',
    districtId: '3528050',
    name: 'Tejah Barat',
  },
  {
    id: '3528050002',
    districtId: '3528050',
    name: 'Tejah Timur',
  },
  {
    id: '3528050003',
    districtId: '3528050',
    name: 'Jalmak',
  },
  {
    id: '3528050004',
    districtId: '3528050',
    name: 'Laden',
  },
  {
    id: '3528050005',
    districtId: '3528050',
    name: 'Panempan',
  },
  {
    id: '3528050006',
    districtId: '3528050',
    name: 'Kangenan',
  },
  {
    id: '3528050007',
    districtId: '3528050',
    name: 'Patemon',
  },
  {
    id: '3528050008',
    districtId: '3528050',
    name: 'Barurambat Kota',
  },
  {
    id: '3528050009',
    districtId: '3528050',
    name: 'Parteker',
  },
  {
    id: '3528050010',
    districtId: '3528050',
    name: 'Jungcangcang',
  },
  {
    id: '3528050012',
    districtId: '3528050',
    name: 'Nylabu Laok',
  },
  {
    id: '3528050013',
    districtId: '3528050',
    name: 'Nylabu Daya',
  },
  {
    id: '3528050014',
    districtId: '3528050',
    name: 'Bugih',
  },
  {
    id: '3528050015',
    districtId: '3528050',
    name: 'Gladak Anyar',
  },
  {
    id: '3528050016',
    districtId: '3528050',
    name: 'Kolpajung',
  },
  {
    id: '3528050017',
    districtId: '3528050',
    name: 'Kowel',
  },
  {
    id: '3528050018',
    districtId: '3528050',
    name: 'Toronan',
  },
  {
    id: '3528060001',
    districtId: '3528060',
    name: "Gro'Om",
  },
  {
    id: '3528060002',
    districtId: '3528060',
    name: 'Batukalangan',
  },
  {
    id: '3528060003',
    districtId: '3528060',
    name: 'Candiburung',
  },
  {
    id: '3528060004',
    districtId: '3528060',
    name: 'Toket',
  },
  {
    id: '3528060005',
    districtId: '3528060',
    name: 'Karanganyar',
  },
  {
    id: '3528060006',
    districtId: '3528060',
    name: 'Samiran',
  },
  {
    id: '3528060007',
    districtId: '3528060',
    name: 'Pangtonggal',
  },
  {
    id: '3528060008',
    districtId: '3528060',
    name: 'Srambah',
  },
  {
    id: '3528060009',
    districtId: '3528060',
    name: 'Badung',
  },
  {
    id: '3528060010',
    districtId: '3528060',
    name: 'Tattangoh',
  },
  {
    id: '3528060011',
    districtId: '3528060',
    name: 'Pangbatok',
  },
  {
    id: '3528060012',
    districtId: '3528060',
    name: 'Panaguan',
  },
  {
    id: '3528060013',
    districtId: '3528060',
    name: 'Campor',
  },
  {
    id: '3528060014',
    districtId: '3528060',
    name: 'Jambringin',
  },
  {
    id: '3528060015',
    districtId: '3528060',
    name: 'Proppo',
  },
  {
    id: '3528060016',
    districtId: '3528060',
    name: 'Mapper',
  },
  {
    id: '3528060017',
    districtId: '3528060',
    name: 'Panglemah',
  },
  {
    id: '3528060018',
    districtId: '3528060',
    name: "Billa'An",
  },
  {
    id: '3528060019',
    districtId: '3528060',
    name: 'Tlangoh',
  },
  {
    id: '3528060020',
    districtId: '3528060',
    name: 'Kodik',
  },
  {
    id: '3528060022',
    districtId: '3528060',
    name: 'Samatan',
  },
  {
    id: '3528060023',
    districtId: '3528060',
    name: 'Klampar',
  },
  {
    id: '3528060024',
    districtId: '3528060',
    name: 'Rang Perang Laok',
  },
  {
    id: '3528060025',
    districtId: '3528060',
    name: 'Pangurayan',
  },
  {
    id: '3528060026',
    districtId: '3528060',
    name: 'Banyubulu',
  },
  {
    id: '3528060027',
    districtId: '3528060',
    name: 'Rang Perang Daya',
  },
  {
    id: '3528070001',
    districtId: '3528070',
    name: 'Banyupelle',
  },
  {
    id: '3528070003',
    districtId: '3528070',
    name: 'Angsanah',
  },
  {
    id: '3528070004',
    districtId: '3528070',
    name: 'Akkor',
  },
  {
    id: '3528070005',
    districtId: '3528070',
    name: 'Larangan Badung',
  },
  {
    id: '3528070006',
    districtId: '3528070',
    name: 'Panaan',
  },
  {
    id: '3528070007',
    districtId: '3528070',
    name: 'Potoan Laok',
  },
  {
    id: '3528070008',
    districtId: '3528070',
    name: 'Potoan Daja',
  },
  {
    id: '3528070009',
    districtId: '3528070',
    name: 'Kacok',
  },
  {
    id: '3528070010',
    districtId: '3528070',
    name: 'Rombuh',
  },
  {
    id: '3528070011',
    districtId: '3528070',
    name: 'Palengaan Laok',
  },
  {
    id: '3528070012',
    districtId: '3528070',
    name: 'Palengaan Daja',
  },
  {
    id: '3528080001',
    districtId: '3528080',
    name: 'Plakpak',
  },
  {
    id: '3528080002',
    districtId: '3528080',
    name: 'Bulangan Haji',
  },
  {
    id: '3528080003',
    districtId: '3528080',
    name: 'Talagah',
  },
  {
    id: '3528080004',
    districtId: '3528080',
    name: 'Bulangan Timur',
  },
  {
    id: '3528080005',
    districtId: '3528080',
    name: 'Bulangan Branta',
  },
  {
    id: '3528080006',
    districtId: '3528080',
    name: 'Bulangan Barat',
  },
  {
    id: '3528080007',
    districtId: '3528080',
    name: 'Palesanggar',
  },
  {
    id: '3528080008',
    districtId: '3528080',
    name: 'Pegantenan',
  },
  {
    id: '3528080009',
    districtId: '3528080',
    name: 'Tebul Timur',
  },
  {
    id: '3528080010',
    districtId: '3528080',
    name: 'Tebul Barat',
  },
  {
    id: '3528080011',
    districtId: '3528080',
    name: 'Ambender',
  },
  {
    id: '3528080012',
    districtId: '3528080',
    name: 'Pasanggar',
  },
  {
    id: '3528080013',
    districtId: '3528080',
    name: 'Tanjung',
  },
  {
    id: '3528090001',
    districtId: '3528090',
    name: 'Pamaroh',
  },
  {
    id: '3528090002',
    districtId: '3528090',
    name: 'Pamoroh',
  },
  {
    id: '3528090003',
    districtId: '3528090',
    name: 'Bangkes',
  },
  {
    id: '3528090004',
    districtId: '3528090',
    name: 'Kadur',
  },
  {
    id: '3528090005',
    districtId: '3528090',
    name: 'Bungbaruh',
  },
  {
    id: '3528090006',
    districtId: '3528090',
    name: 'Sokolelah',
  },
  {
    id: '3528090007',
    districtId: '3528090',
    name: 'Gagah',
  },
  {
    id: '3528090008',
    districtId: '3528090',
    name: 'Kertagena Laok',
  },
  {
    id: '3528090009',
    districtId: '3528090',
    name: 'Kertagena Tengah',
  },
  {
    id: '3528090010',
    districtId: '3528090',
    name: 'Kertagena Daya',
  },
  {
    id: '3528100001',
    districtId: '3528100',
    name: 'Bicorong',
  },
  {
    id: '3528100002',
    districtId: '3528100',
    name: 'Klompang Barat',
  },
  {
    id: '3528100003',
    districtId: '3528100',
    name: 'Klompang Timur',
  },
  {
    id: '3528100004',
    districtId: '3528100',
    name: 'Bajang',
  },
  {
    id: '3528100006',
    districtId: '3528100',
    name: 'Banban',
  },
  {
    id: '3528100007',
    districtId: '3528100',
    name: 'Somalang',
  },
  {
    id: '3528100008',
    districtId: '3528100',
    name: 'Palalang',
  },
  {
    id: '3528100010',
    districtId: '3528100',
    name: 'Pakong',
  },
  {
    id: '3528100011',
    districtId: '3528100',
    name: 'Bandungan',
  },
  {
    id: '3528110001',
    districtId: '3528110',
    name: 'Sumber Waru',
  },
  {
    id: '3528110002',
    districtId: '3528110',
    name: 'Bajur',
  },
  {
    id: '3528110003',
    districtId: '3528110',
    name: 'Ragang',
  },
  {
    id: '3528110004',
    districtId: '3528110',
    name: 'Tampojung Tenggina',
  },
  {
    id: '3528110005',
    districtId: '3528110',
    name: 'Tampojung Tengah',
  },
  {
    id: '3528110006',
    districtId: '3528110',
    name: 'Tampojung Guwa',
  },
  {
    id: '3528110007',
    districtId: '3528110',
    name: 'Tampojung Pregi',
  },
  {
    id: '3528110008',
    districtId: '3528110',
    name: 'Sana Laok',
  },
  {
    id: '3528110009',
    districtId: '3528110',
    name: 'Waru Timur',
  },
  {
    id: '3528110010',
    districtId: '3528110',
    name: 'Waru Barat',
  },
  {
    id: '3528110011',
    districtId: '3528110',
    name: 'Tlontoares',
  },
  {
    id: '3528110012',
    districtId: '3528110',
    name: 'Tegangser Laok',
  },
  {
    id: '3528120001',
    districtId: '3528120',
    name: 'Pangerreman',
  },
  {
    id: '3528120002',
    districtId: '3528120',
    name: 'Bujur Barat',
  },
  {
    id: '3528120003',
    districtId: '3528120',
    name: 'Bujur Tengah',
  },
  {
    id: '3528120004',
    districtId: '3528120',
    name: 'Bujur Timur',
  },
  {
    id: '3528120005',
    districtId: '3528120',
    name: 'Ponjanan Timur',
  },
  {
    id: '3528120006',
    districtId: '3528120',
    name: 'Ponjanan Barat',
  },
  {
    id: '3528120007',
    districtId: '3528120',
    name: 'Lesong Laok',
  },
  {
    id: '3528120008',
    districtId: '3528120',
    name: 'Bangsereh',
  },
  {
    id: '3528120009',
    districtId: '3528120',
    name: 'Blaban',
  },
  {
    id: '3528120010',
    districtId: '3528120',
    name: 'Tamberu',
  },
  {
    id: '3528120011',
    districtId: '3528120',
    name: 'Batubintang',
  },
  {
    id: '3528120012',
    districtId: '3528120',
    name: 'Lesong Daja',
  },
  {
    id: '3528120013',
    districtId: '3528120',
    name: 'Kapong',
  },
  {
    id: '3528130001',
    districtId: '3528130',
    name: 'Sana Tengah',
  },
  {
    id: '3528130002',
    districtId: '3528130',
    name: 'Sana Daja',
  },
  {
    id: '3528130003',
    districtId: '3528130',
    name: 'Dempo Barat',
  },
  {
    id: '3528130004',
    districtId: '3528130',
    name: 'Dempo Timur',
  },
  {
    id: '3528130005',
    districtId: '3528130',
    name: 'Bindang',
  },
  {
    id: '3528130006',
    districtId: '3528130',
    name: 'Batukerbuy',
  },
  {
    id: '3528130007',
    districtId: '3528130',
    name: 'Tlontoraja',
  },
  {
    id: '3528130008',
    districtId: '3528130',
    name: 'Tagangser Daja',
  },
  {
    id: '3528130009',
    districtId: '3528130',
    name: 'Sotabar',
  },
  {
    id: '3529010001',
    districtId: '3529010',
    name: 'Kaduara Timur',
  },
  {
    id: '3529010002',
    districtId: '3529010',
    name: 'Sendang',
  },
  {
    id: '3529010003',
    districtId: '3529010',
    name: 'Rombasan',
  },
  {
    id: '3529010004',
    districtId: '3529010',
    name: 'Sentol Laok',
  },
  {
    id: '3529010005',
    districtId: '3529010',
    name: 'Larangan Pereng',
  },
  {
    id: '3529010006',
    districtId: '3529010',
    name: 'Sentol Daya',
  },
  {
    id: '3529010007',
    districtId: '3529010',
    name: 'Pakamban Daya',
  },
  {
    id: '3529010008',
    districtId: '3529010',
    name: 'Pakamban Laok',
  },
  {
    id: '3529010009',
    districtId: '3529010',
    name: 'Jaddung',
  },
  {
    id: '3529010010',
    districtId: '3529010',
    name: 'Pragaan Laok',
  },
  {
    id: '3529010011',
    districtId: '3529010',
    name: 'Pragaan Daya',
  },
  {
    id: '3529010012',
    districtId: '3529010',
    name: 'Prenduan',
  },
  {
    id: '3529010013',
    districtId: '3529010',
    name: 'Aengpanas',
  },
  {
    id: '3529010014',
    districtId: '3529010',
    name: 'Karduluk',
  },
  {
    id: '3529020001',
    districtId: '3529020',
    name: 'Gulukmanjung',
  },
  {
    id: '3529020002',
    districtId: '3529020',
    name: 'Kapedi',
  },
  {
    id: '3529020003',
    districtId: '3529020',
    name: 'Pakandangan Barat',
  },
  {
    id: '3529020004',
    districtId: '3529020',
    name: 'Pakandangan Tengah',
  },
  {
    id: '3529020005',
    districtId: '3529020',
    name: 'Pakandangan Sangra',
  },
  {
    id: '3529020006',
    districtId: '3529020',
    name: 'Aengdake',
  },
  {
    id: '3529020007',
    districtId: '3529020',
    name: 'Aengbaja Kenek',
  },
  {
    id: '3529020008',
    districtId: '3529020',
    name: 'Bluto',
  },
  {
    id: '3529020009',
    districtId: '3529020',
    name: 'Lobuk',
  },
  {
    id: '3529020010',
    districtId: '3529020',
    name: 'Bungbungan',
  },
  {
    id: '3529020011',
    districtId: '3529020',
    name: 'Masaran',
  },
  {
    id: '3529020012',
    districtId: '3529020',
    name: 'Palongan',
  },
  {
    id: '3529020013',
    districtId: '3529020',
    name: 'Aengbaja Raja',
  },
  {
    id: '3529020014',
    districtId: '3529020',
    name: 'Karang Cempaka',
  },
  {
    id: '3529020015',
    districtId: '3529020',
    name: 'Sera Timur',
  },
  {
    id: '3529020016',
    districtId: '3529020',
    name: 'Sera Tengah',
  },
  {
    id: '3529020017',
    districtId: '3529020',
    name: 'Sera Barat',
  },
  {
    id: '3529020018',
    districtId: '3529020',
    name: 'Gilang',
  },
  {
    id: '3529020019',
    districtId: '3529020',
    name: 'Errabu',
  },
  {
    id: '3529020020',
    districtId: '3529020',
    name: 'Ging Ging',
  },
  {
    id: '3529030001',
    districtId: '3529030',
    name: 'Aengtongtong',
  },
  {
    id: '3529030003',
    districtId: '3529030',
    name: 'Saronggi',
  },
  {
    id: '3529030004',
    districtId: '3529030',
    name: 'Tanah Merah',
  },
  {
    id: '3529030005',
    districtId: '3529030',
    name: 'Langsar',
  },
  {
    id: '3529030006',
    districtId: '3529030',
    name: 'Pagarbatu',
  },
  {
    id: '3529030007',
    districtId: '3529030',
    name: 'Tanjung',
  },
  {
    id: '3529030008',
    districtId: '3529030',
    name: 'Kebundadap Timur',
  },
  {
    id: '3529030009',
    districtId: '3529030',
    name: 'Kebundadap Barat',
  },
  {
    id: '3529030010',
    districtId: '3529030',
    name: 'Saroka',
  },
  {
    id: '3529030011',
    districtId: '3529030',
    name: 'Nambakor',
  },
  {
    id: '3529030012',
    districtId: '3529030',
    name: 'Muangan',
  },
  {
    id: '3529030013',
    districtId: '3529030',
    name: 'Talang',
  },
  {
    id: '3529030014',
    districtId: '3529030',
    name: 'Kambingan Timur',
  },
  {
    id: '3529040001',
    districtId: '3529040',
    name: 'Galis',
  },
  {
    id: '3529040002',
    districtId: '3529040',
    name: 'Gedugan',
  },
  {
    id: '3529040003',
    districtId: '3529040',
    name: 'Bringsang',
  },
  {
    id: '3529040004',
    districtId: '3529040',
    name: 'Aenganyar',
  },
  {
    id: '3529040005',
    districtId: '3529040',
    name: 'Lombang',
  },
  {
    id: '3529040006',
    districtId: '3529040',
    name: 'Jate',
  },
  {
    id: '3529040007',
    districtId: '3529040',
    name: 'Banbaru',
  },
  {
    id: '3529040008',
    districtId: '3529040',
    name: 'Banmaleng',
  },
  {
    id: '3529050001',
    districtId: '3529050',
    name: 'Padike',
  },
  {
    id: '3529050002',
    districtId: '3529050',
    name: 'Cabbiya',
  },
  {
    id: '3529050003',
    districtId: '3529050',
    name: 'Essang',
  },
  {
    id: '3529050004',
    districtId: '3529050',
    name: 'Kombang',
  },
  {
    id: '3529050005',
    districtId: '3529050',
    name: 'Poteran',
  },
  {
    id: '3529050006',
    districtId: '3529050',
    name: 'Palasa',
  },
  {
    id: '3529050007',
    districtId: '3529050',
    name: 'Gapurana',
  },
  {
    id: '3529050008',
    districtId: '3529050',
    name: 'Talango',
  },
  {
    id: '3529060001',
    districtId: '3529060',
    name: 'Pinggirpapas',
  },
  {
    id: '3529060002',
    districtId: '3529060',
    name: 'Karang Anyar',
  },
  {
    id: '3529060003',
    districtId: '3529060',
    name: 'Marengan Laok',
  },
  {
    id: '3529060004',
    districtId: '3529060',
    name: 'Kertasada',
  },
  {
    id: '3529060005',
    districtId: '3529060',
    name: "Kalimo'Ok",
  },
  {
    id: '3529060006',
    districtId: '3529060',
    name: 'Kalianget Barat',
  },
  {
    id: '3529060007',
    districtId: '3529060',
    name: 'Kalianget Timur',
  },
  {
    id: '3529070005',
    districtId: '3529070',
    name: 'Kolor',
  },
  {
    id: '3529070006',
    districtId: '3529070',
    name: 'Pabian',
  },
  {
    id: '3529070007',
    districtId: '3529070',
    name: 'Marengan Daya',
  },
  {
    id: '3529070008',
    districtId: '3529070',
    name: 'Kacongan',
  },
  {
    id: '3529070009',
    districtId: '3529070',
    name: 'Paberasan',
  },
  {
    id: '3529070010',
    districtId: '3529070',
    name: 'Parsanga',
  },
  {
    id: '3529070011',
    districtId: '3529070',
    name: 'Bangkal',
  },
  {
    id: '3529070012',
    districtId: '3529070',
    name: 'Pangarangan',
  },
  {
    id: '3529070013',
    districtId: '3529070',
    name: 'Kepanjin',
  },
  {
    id: '3529070014',
    districtId: '3529070',
    name: 'Pajagalan',
  },
  {
    id: '3529070015',
    districtId: '3529070',
    name: 'Bangselok',
  },
  {
    id: '3529070016',
    districtId: '3529070',
    name: 'Karangduak',
  },
  {
    id: '3529070017',
    districtId: '3529070',
    name: 'Pandian',
  },
  {
    id: '3529070018',
    districtId: '3529070',
    name: 'Pamolokan',
  },
  {
    id: '3529070019',
    districtId: '3529070',
    name: 'Kebunan',
  },
  {
    id: '3529070020',
    districtId: '3529070',
    name: 'Kebunagung',
  },
  {
    id: '3529071001',
    districtId: '3529071',
    name: 'Patean',
  },
  {
    id: '3529071002',
    districtId: '3529071',
    name: 'Babalan',
  },
  {
    id: '3529071003',
    districtId: '3529071',
    name: 'Gedungan',
  },
  {
    id: '3529071005',
    districtId: '3529071',
    name: 'Batuan',
  },
  {
    id: '3529071006',
    districtId: '3529071',
    name: 'Torbang',
  },
  {
    id: '3529080001',
    districtId: '3529080',
    name: 'Bilapora Reba',
  },
  {
    id: '3529080002',
    districtId: '3529080',
    name: 'Moncek Barat',
  },
  {
    id: '3529080003',
    districtId: '3529080',
    name: 'Moncek Tengah',
  },
  {
    id: '3529080004',
    districtId: '3529080',
    name: 'Moncek Timur',
  },
  {
    id: '3529080005',
    districtId: '3529080',
    name: 'Banaresep Barat',
  },
  {
    id: '3529080006',
    districtId: '3529080',
    name: 'Lembung Barat',
  },
  {
    id: '3529080007',
    districtId: '3529080',
    name: 'Lembung Timur',
  },
  {
    id: '3529080008',
    districtId: '3529080',
    name: 'Banaresep Timur',
  },
  {
    id: '3529080009',
    districtId: '3529080',
    name: 'Kambingan Barat',
  },
  {
    id: '3529080010',
    districtId: '3529080',
    name: 'Tarogan',
  },
  {
    id: '3529080011',
    districtId: '3529080',
    name: 'Poreh',
  },
  {
    id: '3529080012',
    districtId: '3529080',
    name: 'Cangkreng',
  },
  {
    id: '3529080013',
    districtId: '3529080',
    name: 'Medelan',
  },
  {
    id: '3529080014',
    districtId: '3529080',
    name: 'Sendir',
  },
  {
    id: '3529080015',
    districtId: '3529080',
    name: 'Daramesta',
  },
  {
    id: '3529080016',
    districtId: '3529080',
    name: 'Jambu',
  },
  {
    id: '3529080017',
    districtId: '3529080',
    name: 'Ellak Daya',
  },
  {
    id: '3529080018',
    districtId: '3529080',
    name: 'Ellak Laok',
  },
  {
    id: '3529080019',
    districtId: '3529080',
    name: 'Lenteng Timur',
  },
  {
    id: '3529080020',
    districtId: '3529080',
    name: 'Lenteng Barat',
  },
  {
    id: '3529090001',
    districtId: '3529090',
    name: 'Ketawang Parebaan',
  },
  {
    id: '3529090002',
    districtId: '3529090',
    name: 'Bataal Barat',
  },
  {
    id: '3529090003',
    districtId: '3529090',
    name: 'Bataal Timur',
  },
  {
    id: '3529090004',
    districtId: '3529090',
    name: 'Rombiya Barat',
  },
  {
    id: '3529090005',
    districtId: '3529090',
    name: 'Rombiya Timur',
  },
  {
    id: '3529090006',
    districtId: '3529090',
    name: 'Talaga',
  },
  {
    id: '3529090007',
    districtId: '3529090',
    name: 'Bilapora Barat',
  },
  {
    id: '3529090008',
    districtId: '3529090',
    name: 'Bilapora Timur',
  },
  {
    id: '3529090009',
    districtId: '3529090',
    name: 'Ganding',
  },
  {
    id: '3529090010',
    districtId: '3529090',
    name: 'Gadu Timur',
  },
  {
    id: '3529090011',
    districtId: '3529090',
    name: 'Gadu Barat',
  },
  {
    id: '3529090012',
    districtId: '3529090',
    name: 'Ketawang Larangan',
  },
  {
    id: '3529090013',
    districtId: '3529090',
    name: 'Ketawang Daleman',
  },
  {
    id: '3529090014',
    districtId: '3529090',
    name: 'Ketawang Karay',
  },
  {
    id: '3529100001',
    districtId: '3529100',
    name: 'Bakeyong',
  },
  {
    id: '3529100002',
    districtId: '3529100',
    name: 'Payudan Dundang',
  },
  {
    id: '3529100003',
    districtId: '3529100',
    name: 'Pordapor',
  },
  {
    id: '3529100005',
    districtId: '3529100',
    name: 'Ketawang Laok',
  },
  {
    id: '3529100006',
    districtId: '3529100',
    name: 'Pananggungan',
  },
  {
    id: '3529100007',
    districtId: '3529100',
    name: 'Bragung',
  },
  {
    id: '3529100008',
    districtId: '3529100',
    name: 'Tambuko',
  },
  {
    id: '3529100009',
    districtId: '3529100',
    name: 'Payudan Nangger',
  },
  {
    id: '3529100010',
    districtId: '3529100',
    name: 'Payudan Daleman',
  },
  {
    id: '3529100011',
    districtId: '3529100',
    name: 'Payudan Karangsokon',
  },
  {
    id: '3529100012',
    districtId: '3529100',
    name: 'Batuampar',
  },
  {
    id: '3529110001',
    districtId: '3529110',
    name: 'Montorna',
  },
  {
    id: '3529110002',
    districtId: '3529110',
    name: 'Prancak',
  },
  {
    id: '3529110003',
    districtId: '3529110',
    name: 'Campaka',
  },
  {
    id: '3529110004',
    districtId: '3529110',
    name: 'Rajun',
  },
  {
    id: '3529110005',
    districtId: '3529110',
    name: 'Lebeng Timur',
  },
  {
    id: '3529110006',
    districtId: '3529110',
    name: 'Lebeng Barat',
  },
  {
    id: '3529110007',
    districtId: '3529110',
    name: 'Soddara',
  },
  {
    id: '3529110008',
    districtId: '3529110',
    name: 'Pasongsongan',
  },
  {
    id: '3529110009',
    districtId: '3529110',
    name: 'Panaongan',
  },
  {
    id: '3529110010',
    districtId: '3529110',
    name: 'Padangdangan',
  },
  {
    id: '3529120001',
    districtId: '3529120',
    name: 'Ambunten Barat',
  },
  {
    id: '3529120002',
    districtId: '3529120',
    name: 'Ambunten Tengah',
  },
  {
    id: '3529120003',
    districtId: '3529120',
    name: 'Ambunten Timur',
  },
  {
    id: '3529120004',
    districtId: '3529120',
    name: 'Tambaagung Barat',
  },
  {
    id: '3529120005',
    districtId: '3529120',
    name: 'Tambaagung Tengah',
  },
  {
    id: '3529120006',
    districtId: '3529120',
    name: 'Tambaagung Ares',
  },
  {
    id: '3529120007',
    districtId: '3529120',
    name: 'Sogian',
  },
  {
    id: '3529120009',
    districtId: '3529120',
    name: 'Tambaagung Timur',
  },
  {
    id: '3529120010',
    districtId: '3529120',
    name: 'Bukabu',
  },
  {
    id: '3529120011',
    districtId: '3529120',
    name: 'Campor Barat',
  },
  {
    id: '3529120012',
    districtId: '3529120',
    name: 'Campor Timur',
  },
  {
    id: '3529120013',
    districtId: '3529120',
    name: 'Beluk Ares',
  },
  {
    id: '3529120015',
    districtId: '3529120',
    name: 'Beluk Raja',
  },
  {
    id: '3529130001',
    districtId: '3529130',
    name: 'Basoka',
  },
  {
    id: '3529130002',
    districtId: '3529130',
    name: 'Mandala',
  },
  {
    id: '3529130003',
    districtId: '3529130',
    name: 'Karangnangka',
  },
  {
    id: '3529130004',
    districtId: '3529130',
    name: 'Pakondang',
  },
  {
    id: '3529130005',
    districtId: '3529130',
    name: 'Matanair',
  },
  {
    id: '3529130006',
    districtId: '3529130',
    name: 'Tambaksari',
  },
  {
    id: '3529130007',
    districtId: '3529130',
    name: 'Bana Sare',
  },
  {
    id: '3529130008',
    districtId: '3529130',
    name: 'Bunbarat',
  },
  {
    id: '3529130009',
    districtId: '3529130',
    name: 'Kalebengan',
  },
  {
    id: '3529130010',
    districtId: '3529130',
    name: 'Rubaru',
  },
  {
    id: '3529130011',
    districtId: '3529130',
    name: 'Duko',
  },
  {
    id: '3529140001',
    districtId: '3529140',
    name: 'Batubelah Barat',
  },
  {
    id: '3529140002',
    districtId: '3529140',
    name: 'Batubelah Timur',
  },
  {
    id: '3529140004',
    districtId: '3529140',
    name: 'Bates',
  },
  {
    id: '3529140005',
    districtId: '3529140',
    name: 'Bringin',
  },
  {
    id: '3529140006',
    districtId: '3529140',
    name: 'Jelbudan',
  },
  {
    id: '3529140007',
    districtId: '3529140',
    name: 'Nyapar',
  },
  {
    id: '3529140008',
    districtId: '3529140',
    name: 'Mantajun',
  },
  {
    id: '3529140009',
    districtId: '3529140',
    name: 'Dasuk Laok',
  },
  {
    id: '3529140010',
    districtId: '3529140',
    name: 'Dasuk Timur',
  },
  {
    id: '3529140011',
    districtId: '3529140',
    name: 'Dasuk Barat',
  },
  {
    id: '3529140012',
    districtId: '3529140',
    name: 'Kerta Timur',
  },
  {
    id: '3529140013',
    districtId: '3529140',
    name: 'Kerta Barat',
  },
  {
    id: '3529140014',
    districtId: '3529140',
    name: 'Semaan',
  },
  {
    id: '3529140015',
    districtId: '3529140',
    name: 'Slopeng',
  },
  {
    id: '3529150001',
    districtId: '3529150',
    name: 'Kasengan',
  },
  {
    id: '3529150002',
    districtId: '3529150',
    name: 'Lalangon',
  },
  {
    id: '3529150003',
    districtId: '3529150',
    name: 'Tenonan',
  },
  {
    id: '3529150004',
    districtId: '3529150',
    name: 'Lanjuk',
  },
  {
    id: '3529150005',
    districtId: '3529150',
    name: 'Gadding',
  },
  {
    id: '3529150006',
    districtId: '3529150',
    name: 'Giring',
  },
  {
    id: '3529150007',
    districtId: '3529150',
    name: 'Gunung Kembar',
  },
  {
    id: '3529150008',
    districtId: '3529150',
    name: "Jaba'An",
  },
  {
    id: '3529150009',
    districtId: '3529150',
    name: 'Manding Laok',
  },
  {
    id: '3529150010',
    districtId: '3529150',
    name: 'Manding Daya',
  },
  {
    id: '3529150011',
    districtId: '3529150',
    name: 'Manding Timur',
  },
  {
    id: '3529160001',
    districtId: '3529160',
    name: 'Larangan Barma',
  },
  {
    id: '3529160002',
    districtId: '3529160',
    name: 'Batuputih Laok',
  },
  {
    id: '3529160003',
    districtId: '3529160',
    name: 'Batuputih Kenek',
  },
  {
    id: '3529160004',
    districtId: '3529160',
    name: 'Aengmerah',
  },
  {
    id: '3529160005',
    districtId: '3529160',
    name: 'Tengedan',
  },
  {
    id: '3529160006',
    districtId: '3529160',
    name: 'Juruan Laok',
  },
  {
    id: '3529160007',
    districtId: '3529160',
    name: 'Juruan Daya',
  },
  {
    id: '3529160008',
    districtId: '3529160',
    name: 'Badur',
  },
  {
    id: '3529160009',
    districtId: '3529160',
    name: 'Gedang Gedang',
  },
  {
    id: '3529160010',
    districtId: '3529160',
    name: 'Batuputih Daya',
  },
  {
    id: '3529160011',
    districtId: '3529160',
    name: 'Bantelan',
  },
  {
    id: '3529160012',
    districtId: '3529160',
    name: 'Larangan Kerta',
  },
  {
    id: '3529160013',
    districtId: '3529160',
    name: 'Bulaan',
  },
  {
    id: '3529160014',
    districtId: '3529160',
    name: 'Sergang',
  },
  {
    id: '3529170001',
    districtId: '3529170',
    name: 'Poja',
  },
  {
    id: '3529170002',
    districtId: '3529170',
    name: 'Beraji',
  },
  {
    id: '3529170003',
    districtId: '3529170',
    name: 'Karang Budi',
  },
  {
    id: '3529170004',
    districtId: '3529170',
    name: 'Baban',
  },
  {
    id: '3529170005',
    districtId: '3529170',
    name: 'Batudinding',
  },
  {
    id: '3529170006',
    districtId: '3529170',
    name: 'Banjar Barat',
  },
  {
    id: '3529170007',
    districtId: '3529170',
    name: 'Banjar Timur',
  },
  {
    id: '3529170008',
    districtId: '3529170',
    name: 'Palokloan',
  },
  {
    id: '3529170009',
    districtId: '3529170',
    name: 'Panagan',
  },
  {
    id: '3529170010',
    districtId: '3529170',
    name: 'Gapura Barat',
  },
  {
    id: '3529170011',
    districtId: '3529170',
    name: 'Gersik Putih',
  },
  {
    id: '3529170012',
    districtId: '3529170',
    name: 'Gapura Tengah',
  },
  {
    id: '3529170013',
    districtId: '3529170',
    name: 'Mandala',
  },
  {
    id: '3529170014',
    districtId: '3529170',
    name: 'Gapura Timur',
  },
  {
    id: '3529170015',
    districtId: '3529170',
    name: 'Andulang',
  },
  {
    id: '3529170016',
    districtId: '3529170',
    name: 'Longos',
  },
  {
    id: '3529170017',
    districtId: '3529170',
    name: 'Grujugan',
  },
  {
    id: '3529180001',
    districtId: '3529180',
    name: 'Tamedung',
  },
  {
    id: '3529180002',
    districtId: '3529180',
    name: 'Batangbatang Laok',
  },
  {
    id: '3529180003',
    districtId: '3529180',
    name: 'Totosan',
  },
  {
    id: '3529180004',
    districtId: '3529180',
    name: 'Banuaju Barat',
  },
  {
    id: '3529180005',
    districtId: '3529180',
    name: 'Banuaju Timur',
  },
  {
    id: '3529180006',
    districtId: '3529180',
    name: 'Jenangger',
  },
  {
    id: '3529180007',
    districtId: '3529180',
    name: 'Nyabakan Timur',
  },
  {
    id: '3529180008',
    districtId: '3529180',
    name: 'Lombang',
  },
  {
    id: '3529180009',
    districtId: '3529180',
    name: 'Bilangan',
  },
  {
    id: '3529180010',
    districtId: '3529180',
    name: 'Dapenda',
  },
  {
    id: '3529180011',
    districtId: '3529180',
    name: 'Legung Timur',
  },
  {
    id: '3529180012',
    districtId: '3529180',
    name: 'Legung Barat',
  },
  {
    id: '3529180013',
    districtId: '3529180',
    name: 'Jangkong',
  },
  {
    id: '3529180014',
    districtId: '3529180',
    name: 'Nyabakan Barat',
  },
  {
    id: '3529180015',
    districtId: '3529180',
    name: 'Batangbatang Daya',
  },
  {
    id: '3529180016',
    districtId: '3529180',
    name: 'Kolpo',
  },
  {
    id: '3529190001',
    districtId: '3529190',
    name: 'Jadung',
  },
  {
    id: '3529190002',
    districtId: '3529190',
    name: 'Romben Barat',
  },
  {
    id: '3529190003',
    districtId: '3529190',
    name: 'Romben Rana',
  },
  {
    id: '3529190004',
    districtId: '3529190',
    name: 'Romben Guna',
  },
  {
    id: '3529190005',
    districtId: '3529190',
    name: 'Bicabi',
  },
  {
    id: '3529190007',
    districtId: '3529190',
    name: 'Lapa Laok',
  },
  {
    id: '3529190008',
    districtId: '3529190',
    name: 'Lapa Daya',
  },
  {
    id: '3529190009',
    districtId: '3529190',
    name: 'Lapa Taman',
  },
  {
    id: '3529190010',
    districtId: '3529190',
    name: 'Bungin Bungin',
  },
  {
    id: '3529190011',
    districtId: '3529190',
    name: 'Bunpenang',
  },
  {
    id: '3529190012',
    districtId: '3529190',
    name: 'Tamansare',
  },
  {
    id: '3529190013',
    districtId: '3529190',
    name: 'Candi',
  },
  {
    id: '3529190014',
    districtId: '3529190',
    name: 'Bancamara',
  },
  {
    id: '3529190015',
    districtId: '3529190',
    name: 'Banraas',
  },
  {
    id: '3529200001',
    districtId: '3529200',
    name: 'Sokarame Paseser',
  },
  {
    id: '3529200002',
    districtId: '3529200',
    name: 'Sokarame Timur',
  },
  {
    id: '3529200003',
    districtId: '3529200',
    name: 'Tanahmerah',
  },
  {
    id: '3529200004',
    districtId: '3529200',
    name: 'Somber',
  },
  {
    id: '3529200005',
    districtId: '3529200',
    name: 'Sonok',
  },
  {
    id: '3529200006',
    districtId: '3529200',
    name: 'Nonggunong',
  },
  {
    id: '3529200007',
    districtId: '3529200',
    name: 'Rosong',
  },
  {
    id: '3529200008',
    districtId: '3529200',
    name: 'Talaga',
  },
  {
    id: '3529210001',
    districtId: '3529210',
    name: 'Gayam',
  },
  {
    id: '3529210002',
    districtId: '3529210',
    name: 'Jambuir',
  },
  {
    id: '3529210003',
    districtId: '3529210',
    name: 'Pancor',
  },
  {
    id: '3529210004',
    districtId: '3529210',
    name: 'Prambanan',
  },
  {
    id: '3529210005',
    districtId: '3529210',
    name: 'Gendang Timur',
  },
  {
    id: '3529210006',
    districtId: '3529210',
    name: 'Karangtengah',
  },
  {
    id: '3529210007',
    districtId: '3529210',
    name: 'Nyamplong',
  },
  {
    id: '3529210008',
    districtId: '3529210',
    name: 'Gendang Barat',
  },
  {
    id: '3529210009',
    districtId: '3529210',
    name: 'Kalowang',
  },
  {
    id: '3529210010',
    districtId: '3529210',
    name: 'Tarebung',
  },
  {
    id: '3529220001',
    districtId: '3529220',
    name: 'Ketupat',
  },
  {
    id: '3529220002',
    districtId: '3529220',
    name: 'Jungkat',
  },
  {
    id: '3529220003',
    districtId: '3529220',
    name: 'Karopoh',
  },
  {
    id: '3529220004',
    districtId: '3529220',
    name: 'Karangnangka',
  },
  {
    id: '3529220005',
    districtId: '3529220',
    name: 'Alasmalang',
  },
  {
    id: '3529220006',
    districtId: '3529220',
    name: 'Poteran',
  },
  {
    id: '3529220007',
    districtId: '3529220',
    name: 'Brakas',
  },
  {
    id: '3529220008',
    districtId: '3529220',
    name: 'Tonduk',
  },
  {
    id: '3529220009',
    districtId: '3529220',
    name: 'Guwa Guwa',
  },
  {
    id: '3529230001',
    districtId: '3529230',
    name: 'Sabuntan',
  },
  {
    id: '3529230002',
    districtId: '3529230',
    name: 'Paliat',
  },
  {
    id: '3529230003',
    districtId: '3529230',
    name: 'Sapeken',
  },
  {
    id: '3529230004',
    districtId: '3529230',
    name: 'Sasiil',
  },
  {
    id: '3529230005',
    districtId: '3529230',
    name: 'Sepanjang',
  },
  {
    id: '3529230006',
    districtId: '3529230',
    name: 'Tanjungkiaok',
  },
  {
    id: '3529230007',
    districtId: '3529230',
    name: 'Pagerungan Kecil',
  },
  {
    id: '3529230008',
    districtId: '3529230',
    name: 'Pagerungan Besar',
  },
  {
    id: '3529230009',
    districtId: '3529230',
    name: 'Sakala',
  },
  {
    id: '3529230010',
    districtId: '3529230',
    name: 'Sadulang',
  },
  {
    id: '3529230011',
    districtId: '3529230',
    name: 'Saur Saebus',
  },
  {
    id: '3529240001',
    districtId: '3529240',
    name: 'Buddi',
  },
  {
    id: '3529240002',
    districtId: '3529240',
    name: 'Gelaman',
  },
  {
    id: '3529240003',
    districtId: '3529240',
    name: 'Pajanangger',
  },
  {
    id: '3529240010',
    districtId: '3529240',
    name: 'Sawahsumur',
  },
  {
    id: '3529240011',
    districtId: '3529240',
    name: 'Paseraman',
  },
  {
    id: '3529240012',
    districtId: '3529240',
    name: 'Kalinganyar',
  },
  {
    id: '3529240013',
    districtId: '3529240',
    name: 'Arjasa',
  },
  {
    id: '3529240014',
    districtId: '3529240',
    name: 'Duko',
  },
  {
    id: '3529240015',
    districtId: '3529240',
    name: 'Kolo Kolo',
  },
  {
    id: '3529240016',
    districtId: '3529240',
    name: 'Angkatan',
  },
  {
    id: '3529240017',
    districtId: '3529240',
    name: 'Kalisangka',
  },
  {
    id: '3529240018',
    districtId: '3529240',
    name: 'Laok Jangjang',
  },
  {
    id: '3529240019',
    districtId: '3529240',
    name: 'Bilis Bilis',
  },
  {
    id: '3529240020',
    districtId: '3529240',
    name: 'Sumbernangka',
  },
  {
    id: '3529240021',
    districtId: '3529240',
    name: 'Kalikatak',
  },
  {
    id: '3529240022',
    districtId: '3529240',
    name: 'Angon Angon',
  },
  {
    id: '3529240023',
    districtId: '3529240',
    name: 'Sambakati',
  },
  {
    id: '3529240024',
    districtId: '3529240',
    name: 'Pandeman',
  },
  {
    id: '3529240025',
    districtId: '3529240',
    name: 'Pabian',
  },
  {
    id: '3529241001',
    districtId: '3529241',
    name: 'Saobi',
  },
  {
    id: '3529241002',
    districtId: '3529241',
    name: 'Kangayan',
  },
  {
    id: '3529241003',
    districtId: '3529241',
    name: 'Toerjek',
  },
  {
    id: '3529241004',
    districtId: '3529241',
    name: 'Cangkramaan',
  },
  {
    id: '3529241005',
    districtId: '3529241',
    name: 'Tembayangan',
  },
  {
    id: '3529241006',
    districtId: '3529241',
    name: 'Batuputih',
  },
  {
    id: '3529241007',
    districtId: '3529241',
    name: 'Daandung',
  },
  {
    id: '3529241008',
    districtId: '3529241',
    name: 'Timur Janjang',
  },
  {
    id: '3529241009',
    districtId: '3529241',
    name: 'Jukong Jukong',
  },
  {
    id: '3529250001',
    districtId: '3529250',
    name: 'Massalima',
  },
  {
    id: '3529250002',
    districtId: '3529250',
    name: 'Sukajeruk',
  },
  {
    id: '3529250003',
    districtId: '3529250',
    name: 'Karamian',
  },
  {
    id: '3529250004',
    districtId: '3529250',
    name: 'Masakambing',
  },
  {
    id: '3571010001',
    districtId: '3571010',
    name: 'Pojok',
  },
  {
    id: '3571010002',
    districtId: '3571010',
    name: 'Campurejo',
  },
  {
    id: '3571010003',
    districtId: '3571010',
    name: 'Tamanan',
  },
  {
    id: '3571010004',
    districtId: '3571010',
    name: 'Banjarmlati',
  },
  {
    id: '3571010005',
    districtId: '3571010',
    name: 'Bandar Kidul',
  },
  {
    id: '3571010006',
    districtId: '3571010',
    name: 'Lirboyo',
  },
  {
    id: '3571010007',
    districtId: '3571010',
    name: 'Bandar Lor',
  },
  {
    id: '3571010008',
    districtId: '3571010',
    name: 'Mojoroto',
  },
  {
    id: '3571010009',
    districtId: '3571010',
    name: 'Sukorame',
  },
  {
    id: '3571010011',
    districtId: '3571010',
    name: 'Ngampel',
  },
  {
    id: '3571010012',
    districtId: '3571010',
    name: 'Gayam',
  },
  {
    id: '3571010013',
    districtId: '3571010',
    name: 'Mrican',
  },
  {
    id: '3571010014',
    districtId: '3571010',
    name: 'Dermo',
  },
  {
    id: '3571020001',
    districtId: '3571020',
    name: 'Manisrenggo',
  },
  {
    id: '3571020002',
    districtId: '3571020',
    name: 'Rejomulyo',
  },
  {
    id: '3571020003',
    districtId: '3571020',
    name: 'Ngronggo',
  },
  {
    id: '3571020004',
    districtId: '3571020',
    name: 'Kaliombo',
  },
  {
    id: '3571020005',
    districtId: '3571020',
    name: 'Kampung Dalem',
  },
  {
    id: '3571020006',
    districtId: '3571020',
    name: 'Setono Pande',
  },
  {
    id: '3571020007',
    districtId: '3571020',
    name: 'Ringin Anom',
  },
  {
    id: '3571020008',
    districtId: '3571020',
    name: 'Pakelan',
  },
  {
    id: '3571020009',
    districtId: '3571020',
    name: 'Setono Gedong',
  },
  {
    id: '3571020010',
    districtId: '3571020',
    name: 'Kemasan',
  },
  {
    id: '3571020011',
    districtId: '3571020',
    name: 'Jagalan',
  },
  {
    id: '3571020012',
    districtId: '3571020',
    name: 'Banjaran',
  },
  {
    id: '3571020013',
    districtId: '3571020',
    name: 'Ngadirejo',
  },
  {
    id: '3571020014',
    districtId: '3571020',
    name: 'Dandangan',
  },
  {
    id: '3571020015',
    districtId: '3571020',
    name: 'Balowerti',
  },
  {
    id: '3571020016',
    districtId: '3571020',
    name: 'Pocanan',
  },
  {
    id: '3571020017',
    districtId: '3571020',
    name: 'Semampir',
  },
  {
    id: '3571030001',
    districtId: '3571030',
    name: 'Blabak',
  },
  {
    id: '3571030002',
    districtId: '3571030',
    name: 'Bawang',
  },
  {
    id: '3571030004',
    districtId: '3571030',
    name: 'Tosaren',
  },
  {
    id: '3571030005',
    districtId: '3571030',
    name: 'Banaran',
  },
  {
    id: '3571030006',
    districtId: '3571030',
    name: 'Ngletih',
  },
  {
    id: '3571030007',
    districtId: '3571030',
    name: 'Tempurejo',
  },
  {
    id: '3571030008',
    districtId: '3571030',
    name: 'Ketami',
  },
  {
    id: '3571030009',
    districtId: '3571030',
    name: 'Pesantren',
  },
  {
    id: '3571030010',
    districtId: '3571030',
    name: 'Bangsal',
  },
  {
    id: '3571030011',
    districtId: '3571030',
    name: 'Burengan',
  },
  {
    id: '3571030012',
    districtId: '3571030',
    name: 'Tinalan',
  },
  {
    id: '3571030013',
    districtId: '3571030',
    name: 'Pakunden',
  },
  {
    id: '3571030014',
    districtId: '3571030',
    name: 'Singonegaran',
  },
  {
    id: '3571030015',
    districtId: '3571030',
    name: 'Jamsaren',
  },
  {
    id: '3572010002',
    districtId: '3572010',
    name: 'Karangsari',
  },
  {
    id: '3572010003',
    districtId: '3572010',
    name: 'Turi',
  },
  {
    id: '3572010004',
    districtId: '3572010',
    name: 'Blitar',
  },
  {
    id: '3572010005',
    districtId: '3572010',
    name: 'Sukorejo',
  },
  {
    id: '3572010006',
    districtId: '3572010',
    name: 'Pakunden',
  },
  {
    id: '3572010007',
    districtId: '3572010',
    name: 'Tanjungsari',
  },
  {
    id: '3572020001',
    districtId: '3572020',
    name: 'Kepanjenkidul',
  },
  {
    id: '3572020002',
    districtId: '3572020',
    name: 'Kepanjenlor',
  },
  {
    id: '3572020003',
    districtId: '3572020',
    name: 'Kauman',
  },
  {
    id: '3572020004',
    districtId: '3572020',
    name: 'Bendo',
  },
  {
    id: '3572020005',
    districtId: '3572020',
    name: 'Tanggung',
  },
  {
    id: '3572020007',
    districtId: '3572020',
    name: 'Ngadirejo',
  },
  {
    id: '3572030001',
    districtId: '3572030',
    name: 'Rembang',
  },
  {
    id: '3572030002',
    districtId: '3572030',
    name: 'Klampok',
  },
  {
    id: '3572030003',
    districtId: '3572030',
    name: 'Plosokerep',
  },
  {
    id: '3572030004',
    districtId: '3572030',
    name: 'Karangtengah',
  },
  {
    id: '3572030005',
    districtId: '3572030',
    name: 'Sananwetan',
  },
  {
    id: '3572030006',
    districtId: '3572030',
    name: 'Bendogerit',
  },
  {
    id: '3572030007',
    districtId: '3572030',
    name: 'Gedog',
  },
  {
    id: '3573010001',
    districtId: '3573010',
    name: 'Arjowinangun',
  },
  {
    id: '3573010002',
    districtId: '3573010',
    name: 'Tlogowaru',
  },
  {
    id: '3573010003',
    districtId: '3573010',
    name: 'Wonokoyo',
  },
  {
    id: '3573010004',
    districtId: '3573010',
    name: 'Bumiayu',
  },
  {
    id: '3573010005',
    districtId: '3573010',
    name: 'Buring',
  },
  {
    id: '3573010006',
    districtId: '3573010',
    name: 'Mergosono',
  },
  {
    id: '3573010007',
    districtId: '3573010',
    name: 'Kotalama',
  },
  {
    id: '3573010008',
    districtId: '3573010',
    name: 'Kedungkandang',
  },
  {
    id: '3573010009',
    districtId: '3573010',
    name: 'Sawojajar',
  },
  {
    id: '3573010010',
    districtId: '3573010',
    name: 'Madyopuro',
  },
  {
    id: '3573010011',
    districtId: '3573010',
    name: 'Lesanpuro',
  },
  {
    id: '3573010012',
    districtId: '3573010',
    name: 'Cemorokandang',
  },
  {
    id: '3573020001',
    districtId: '3573020',
    name: 'Kebonsari',
  },
  {
    id: '3573020002',
    districtId: '3573020',
    name: 'Gadang',
  },
  {
    id: '3573020003',
    districtId: '3573020',
    name: 'Ciptomulyo',
  },
  {
    id: '3573020005',
    districtId: '3573020',
    name: 'Bandungrejosari',
  },
  {
    id: '3573020006',
    districtId: '3573020',
    name: 'Bakalan Krajan',
  },
  {
    id: '3573020007',
    districtId: '3573020',
    name: 'Mulyorejo',
  },
  {
    id: '3573020008',
    districtId: '3573020',
    name: 'Bandulan',
  },
  {
    id: '3573020009',
    districtId: '3573020',
    name: 'Tanjungrejo',
  },
  {
    id: '3573020010',
    districtId: '3573020',
    name: 'Pisang Candi',
  },
  {
    id: '3573020011',
    districtId: '3573020',
    name: 'Karang Besuki',
  },
  {
    id: '3573030001',
    districtId: '3573030',
    name: 'Kasin',
  },
  {
    id: '3573030002',
    districtId: '3573030',
    name: 'Sukoharjo',
  },
  {
    id: '3573030003',
    districtId: '3573030',
    name: 'Kidul Dalem',
  },
  {
    id: '3573030004',
    districtId: '3573030',
    name: 'Kauman',
  },
  {
    id: '3573030005',
    districtId: '3573030',
    name: 'Bareng',
  },
  {
    id: '3573030006',
    districtId: '3573030',
    name: 'Gadingkasri',
  },
  {
    id: '3573030007',
    districtId: '3573030',
    name: 'Oro Oro Dowo',
  },
  {
    id: '3573030008',
    districtId: '3573030',
    name: 'Klojen',
  },
  {
    id: '3573030009',
    districtId: '3573030',
    name: 'Rampal Celaket',
  },
  {
    id: '3573030010',
    districtId: '3573030',
    name: 'Samaan',
  },
  {
    id: '3573030011',
    districtId: '3573030',
    name: 'Penanggungan',
  },
  {
    id: '3573040001',
    districtId: '3573040',
    name: 'Jodipan',
  },
  {
    id: '3573040002',
    districtId: '3573040',
    name: 'Polehan',
  },
  {
    id: '3573040003',
    districtId: '3573040',
    name: 'Kesatrian',
  },
  {
    id: '3573040004',
    districtId: '3573040',
    name: 'Bunulrejo',
  },
  {
    id: '3573040005',
    districtId: '3573040',
    name: 'Purwantoro',
  },
  {
    id: '3573040006',
    districtId: '3573040',
    name: 'Pandanwangi',
  },
  {
    id: '3573040007',
    districtId: '3573040',
    name: 'Blimbing',
  },
  {
    id: '3573040008',
    districtId: '3573040',
    name: 'Purwodadi',
  },
  {
    id: '3573040009',
    districtId: '3573040',
    name: 'Polowijen',
  },
  {
    id: '3573040010',
    districtId: '3573040',
    name: 'Arjosari',
  },
  {
    id: '3573040011',
    districtId: '3573040',
    name: 'Balearjosari',
  },
  {
    id: '3573050001',
    districtId: '3573050',
    name: 'Merjosari',
  },
  {
    id: '3573050002',
    districtId: '3573050',
    name: 'Dinoyo',
  },
  {
    id: '3573050003',
    districtId: '3573050',
    name: 'Sumbersari',
  },
  {
    id: '3573050004',
    districtId: '3573050',
    name: 'Ketawanggede',
  },
  {
    id: '3573050005',
    districtId: '3573050',
    name: 'Jatimulyo',
  },
  {
    id: '3573050006',
    districtId: '3573050',
    name: 'Lowokwaru',
  },
  {
    id: '3573050007',
    districtId: '3573050',
    name: 'Tulusrejo',
  },
  {
    id: '3573050008',
    districtId: '3573050',
    name: 'Mojolangu',
  },
  {
    id: '3573050009',
    districtId: '3573050',
    name: 'Tunjungsekar',
  },
  {
    id: '3573050010',
    districtId: '3573050',
    name: 'Tasikmadu',
  },
  {
    id: '3573050012',
    districtId: '3573050',
    name: 'Tlogomas',
  },
  {
    id: '3574010001',
    districtId: '3574010',
    name: 'Triwung Kidul',
  },
  {
    id: '3574010002',
    districtId: '3574010',
    name: 'Kademangan',
  },
  {
    id: '3574010003',
    districtId: '3574010',
    name: 'Pohsangit Kidul',
  },
  {
    id: '3574010007',
    districtId: '3574010',
    name: 'Pilang',
  },
  {
    id: '3574010008',
    districtId: '3574010',
    name: 'Triwung Lor',
  },
  {
    id: '3574010009',
    districtId: '3574010',
    name: 'Ketapang',
  },
  {
    id: '3574011001',
    districtId: '3574011',
    name: 'Sumber Wetan',
  },
  {
    id: '3574011002',
    districtId: '3574011',
    name: 'Kareng Lor',
  },
  {
    id: '3574011003',
    districtId: '3574011',
    name: 'Kedopok',
  },
  {
    id: '3574011004',
    districtId: '3574011',
    name: 'Jrebeng Kulon',
  },
  {
    id: '3574011005',
    districtId: '3574011',
    name: 'Jrebeng Wetan',
  },
  {
    id: '3574011006',
    districtId: '3574011',
    name: 'Jrebeng Lor',
  },
  {
    id: '3574020001',
    districtId: '3574020',
    name: 'Wonoasih',
  },
  {
    id: '3574020002',
    districtId: '3574020',
    name: 'Jrebeng Kidul',
  },
  {
    id: '3574020003',
    districtId: '3574020',
    name: 'Pakistaji',
  },
  {
    id: '3574020004',
    districtId: '3574020',
    name: 'Kedunggaleng',
  },
  {
    id: '3574020005',
    districtId: '3574020',
    name: 'Kedungasem',
  },
  {
    id: '3574020006',
    districtId: '3574020',
    name: 'Sumbertaman',
  },
  {
    id: '3574030005',
    districtId: '3574030',
    name: 'Wiroborang',
  },
  {
    id: '3574030006',
    districtId: '3574030',
    name: 'Jati',
  },
  {
    id: '3574030009',
    districtId: '3574030',
    name: 'Sukabumi',
  },
  {
    id: '3574030010',
    districtId: '3574030',
    name: 'Mangunharjo',
  },
  {
    id: '3574030011',
    districtId: '3574030',
    name: 'Mayangan',
  },
  {
    id: '3574031001',
    districtId: '3574031',
    name: 'Curahgrinting',
  },
  {
    id: '3574031002',
    districtId: '3574031',
    name: 'Kanigaran',
  },
  {
    id: '3574031003',
    districtId: '3574031',
    name: 'Kebonsari Wetan',
  },
  {
    id: '3574031004',
    districtId: '3574031',
    name: 'Sukoharjo',
  },
  {
    id: '3574031005',
    districtId: '3574031',
    name: 'Kebonsari Kulon',
  },
  {
    id: '3574031006',
    districtId: '3574031',
    name: 'Tisnonegaran',
  },
  {
    id: '3575010001',
    districtId: '3575010',
    name: 'Krapyakrejo',
  },
  {
    id: '3575010002',
    districtId: '3575010',
    name: 'Bukir',
  },
  {
    id: '3575010003',
    districtId: '3575010',
    name: 'Sebani',
  },
  {
    id: '3575010004',
    districtId: '3575010',
    name: 'Gentong',
  },
  {
    id: '3575010008',
    districtId: '3575010',
    name: 'Gadingrejo',
  },
  {
    id: '3575010009',
    districtId: '3575010',
    name: 'Petahunan',
  },
  {
    id: '3575010010',
    districtId: '3575010',
    name: 'Randusari',
  },
  {
    id: '3575010011',
    districtId: '3575010',
    name: 'Karangketug',
  },
  {
    id: '3575020001',
    districtId: '3575020',
    name: 'Pohjentrek',
  },
  {
    id: '3575020002',
    districtId: '3575020',
    name: 'Wirogunan',
  },
  {
    id: '3575020003',
    districtId: '3575020',
    name: 'Tembokrejo',
  },
  {
    id: '3575020004',
    districtId: '3575020',
    name: 'Purutrejo',
  },
  {
    id: '3575020005',
    districtId: '3575020',
    name: 'Kebonagung',
  },
  {
    id: '3575020006',
    districtId: '3575020',
    name: 'Purworejo',
  },
  {
    id: '3575020007',
    districtId: '3575020',
    name: 'Sekargadung',
  },
  {
    id: '3575030002',
    districtId: '3575030',
    name: 'Bakalan',
  },
  {
    id: '3575030003',
    districtId: '3575030',
    name: 'Krampyangan',
  },
  {
    id: '3575030004',
    districtId: '3575030',
    name: 'Blandongan',
  },
  {
    id: '3575030006',
    districtId: '3575030',
    name: 'Bugulkidul',
  },
  {
    id: '3575030011',
    districtId: '3575030',
    name: 'Tapaan',
  },
  {
    id: '3575031001',
    districtId: '3575031',
    name: 'Petamanan',
  },
  {
    id: '3575031003',
    districtId: '3575031',
    name: 'Bugullor',
  },
  {
    id: '3575031004',
    districtId: '3575031',
    name: 'Kandangsapi',
  },
  {
    id: '3575031005',
    districtId: '3575031',
    name: 'Bangilan',
  },
  {
    id: '3575031006',
    districtId: '3575031',
    name: 'Kebonsari',
  },
  {
    id: '3575031007',
    districtId: '3575031',
    name: 'Karanganyar',
  },
  {
    id: '3575031008',
    districtId: '3575031',
    name: 'Trajeng',
  },
  {
    id: '3575031009',
    districtId: '3575031',
    name: 'Mayangan',
  },
  {
    id: '3575031010',
    districtId: '3575031',
    name: 'Mandaranrejo',
  },
  {
    id: '3575031011',
    districtId: '3575031',
    name: 'Panggungrejo',
  },
  {
    id: '3575031012',
    districtId: '3575031',
    name: 'Ngemplakrejo',
  },
  {
    id: '3575031013',
    districtId: '3575031',
    name: 'Tambaan',
  },
  {
    id: '3576010001',
    districtId: '3576010',
    name: 'Surodinawan',
  },
  {
    id: '3576010004',
    districtId: '3576010',
    name: 'Prajurit Kulon',
  },
  {
    id: '3576010005',
    districtId: '3576010',
    name: 'Blooto',
  },
  {
    id: '3576010006',
    districtId: '3576010',
    name: 'Mentikan',
  },
  {
    id: '3576010007',
    districtId: '3576010',
    name: 'Kauman',
  },
  {
    id: '3576010008',
    districtId: '3576010',
    name: 'Pulorejo',
  },
  {
    id: '3576020002',
    districtId: '3576020',
    name: 'Gunung Gedangan',
  },
  {
    id: '3576020004',
    districtId: '3576020',
    name: 'Balongsari',
  },
  {
    id: '3576020008',
    districtId: '3576020',
    name: 'Gedongan',
  },
  {
    id: '3576020009',
    districtId: '3576020',
    name: 'Magersari',
  },
  {
    id: '3576020010',
    districtId: '3576020',
    name: 'Wates',
  },
  {
    id: '3576021001',
    districtId: '3576021',
    name: 'Kranggan',
  },
  {
    id: '3576021002',
    districtId: '3576021',
    name: 'Meri',
  },
  {
    id: '3576021003',
    districtId: '3576021',
    name: 'Jagalan',
  },
  {
    id: '3576021004',
    districtId: '3576021',
    name: 'Miji',
  },
  {
    id: '3576021005',
    districtId: '3576021',
    name: 'Sentanan',
  },
  {
    id: '3576021006',
    districtId: '3576021',
    name: 'Purwotengah',
  },
  {
    id: '3577010001',
    districtId: '3577010',
    name: 'Nambangan Kidul',
  },
  {
    id: '3577010002',
    districtId: '3577010',
    name: 'Nambangan Lor',
  },
  {
    id: '3577010003',
    districtId: '3577010',
    name: 'Manguharjo',
  },
  {
    id: '3577010004',
    districtId: '3577010',
    name: 'Pangongangan',
  },
  {
    id: '3577010005',
    districtId: '3577010',
    name: 'Winongo',
  },
  {
    id: '3577010006',
    districtId: '3577010',
    name: 'Madiun Lor',
  },
  {
    id: '3577010007',
    districtId: '3577010',
    name: 'Patihan',
  },
  {
    id: '3577010008',
    districtId: '3577010',
    name: 'Ngegong',
  },
  {
    id: '3577010009',
    districtId: '3577010',
    name: 'Sogaten',
  },
  {
    id: '3577020001',
    districtId: '3577020',
    name: 'Josenan',
  },
  {
    id: '3577020003',
    districtId: '3577020',
    name: 'Demangan',
  },
  {
    id: '3577020004',
    districtId: '3577020',
    name: 'Banjarejo',
  },
  {
    id: '3577020005',
    districtId: '3577020',
    name: 'Pandean',
  },
  {
    id: '3577020006',
    districtId: '3577020',
    name: 'Kejuron',
  },
  {
    id: '3577020007',
    districtId: '3577020',
    name: 'Taman',
  },
  {
    id: '3577020008',
    districtId: '3577020',
    name: 'Mojorejo',
  },
  {
    id: '3577020009',
    districtId: '3577020',
    name: 'Manisrejo',
  },
  {
    id: '3577030001',
    districtId: '3577030',
    name: 'Kartoharjo',
  },
  {
    id: '3577030002',
    districtId: '3577030',
    name: 'Oro Oro Ombo',
  },
  {
    id: '3577030004',
    districtId: '3577030',
    name: 'Kanigoro',
  },
  {
    id: '3577030005',
    districtId: '3577030',
    name: 'Pilangbango',
  },
  {
    id: '3577030006',
    districtId: '3577030',
    name: 'Rejomulyo',
  },
  {
    id: '3577030007',
    districtId: '3577030',
    name: 'Sukosari',
  },
  {
    id: '3577030008',
    districtId: '3577030',
    name: 'Tawangrejo',
  },
  {
    id: '3578010001',
    districtId: '3578010',
    name: 'Warugunung',
  },
  {
    id: '3578010002',
    districtId: '3578010',
    name: 'Karang Pilang',
  },
  {
    id: '3578010003',
    districtId: '3578010',
    name: 'Kebraon',
  },
  {
    id: '3578020001',
    districtId: '3578020',
    name: 'Pagesangan',
  },
  {
    id: '3578020002',
    districtId: '3578020',
    name: 'Kebonsari',
  },
  {
    id: '3578020003',
    districtId: '3578020',
    name: 'Jambangan',
  },
  {
    id: '3578020004',
    districtId: '3578020',
    name: 'Karah',
  },
  {
    id: '3578030001',
    districtId: '3578030',
    name: 'Dukuh Menanggal',
  },
  {
    id: '3578030002',
    districtId: '3578030',
    name: 'Menanggal',
  },
  {
    id: '3578030003',
    districtId: '3578030',
    name: 'Gayungan',
  },
  {
    id: '3578030004',
    districtId: '3578030',
    name: 'Ketintang',
  },
  {
    id: '3578040001',
    districtId: '3578040',
    name: 'Siwalankerto',
  },
  {
    id: '3578040002',
    districtId: '3578040',
    name: 'Jemur Wonosari',
  },
  {
    id: '3578040003',
    districtId: '3578040',
    name: 'Margorejo',
  },
  {
    id: '3578040004',
    districtId: '3578040',
    name: 'Bendul Merisi',
  },
  {
    id: '3578040005',
    districtId: '3578040',
    name: 'Sidosermo',
  },
  {
    id: '3578050001',
    districtId: '3578050',
    name: 'Kutisari',
  },
  {
    id: '3578050002',
    districtId: '3578050',
    name: 'Kendangsari',
  },
  {
    id: '3578050003',
    districtId: '3578050',
    name: 'Tenggilis Mejoyo',
  },
  {
    id: '3578050005',
    districtId: '3578050',
    name: 'Panjang Jiwo',
  },
  {
    id: '3578060001',
    districtId: '3578060',
    name: 'Rungkut Menanggal',
  },
  {
    id: '3578060002',
    districtId: '3578060',
    name: 'Rungkut Tengah',
  },
  {
    id: '3578060003',
    districtId: '3578060',
    name: 'Gunung Anyar',
  },
  {
    id: '3578060004',
    districtId: '3578060',
    name: 'Gunung Anyar Tambak',
  },
  {
    id: '3578070001',
    districtId: '3578070',
    name: 'Rungkut Kidul',
  },
  {
    id: '3578070002',
    districtId: '3578070',
    name: 'Medokan Ayu',
  },
  {
    id: '3578070003',
    districtId: '3578070',
    name: 'Wonorejo',
  },
  {
    id: '3578070004',
    districtId: '3578070',
    name: 'Penjaringan Sari',
  },
  {
    id: '3578070005',
    districtId: '3578070',
    name: 'Kedung Baruk',
  },
  {
    id: '3578070006',
    districtId: '3578070',
    name: 'Kali Rungkut',
  },
  {
    id: '3578080001',
    districtId: '3578080',
    name: 'Ngiden Jangkungan',
  },
  {
    id: '3578080002',
    districtId: '3578080',
    name: 'Semolowaru',
  },
  {
    id: '3578080003',
    districtId: '3578080',
    name: 'Medokan Semampir',
  },
  {
    id: '3578080004',
    districtId: '3578080',
    name: 'Keputih',
  },
  {
    id: '3578080005',
    districtId: '3578080',
    name: 'Gebang Putih',
  },
  {
    id: '3578080006',
    districtId: '3578080',
    name: 'Klampis Ngasem',
  },
  {
    id: '3578080007',
    districtId: '3578080',
    name: 'Menur Pumpungan',
  },
  {
    id: '3578090001',
    districtId: '3578090',
    name: 'Manyar Sabrangan',
  },
  {
    id: '3578090002',
    districtId: '3578090',
    name: 'Mulyorejo',
  },
  {
    id: '3578090003',
    districtId: '3578090',
    name: 'Kejawen Putih Tambak',
  },
  {
    id: '3578090004',
    districtId: '3578090',
    name: 'Kalisari',
  },
  {
    id: '3578090005',
    districtId: '3578090',
    name: 'Dukuh Sutorejo',
  },
  {
    id: '3578090006',
    districtId: '3578090',
    name: 'Kalijudan',
  },
  {
    id: '3578100001',
    districtId: '3578100',
    name: 'Baratajaya',
  },
  {
    id: '3578100002',
    districtId: '3578100',
    name: 'Pucang Sewu',
  },
  {
    id: '3578100003',
    districtId: '3578100',
    name: 'Kertajaya',
  },
  {
    id: '3578100005',
    districtId: '3578100',
    name: 'Airlangga',
  },
  {
    id: '3578100006',
    districtId: '3578100',
    name: 'Mojo',
  },
  {
    id: '3578110001',
    districtId: '3578110',
    name: 'Sawunggaling',
  },
  {
    id: '3578110002',
    districtId: '3578110',
    name: 'Wonokromo',
  },
  {
    id: '3578110003',
    districtId: '3578110',
    name: 'Jagir',
  },
  {
    id: '3578110004',
    districtId: '3578110',
    name: 'Ngagelrejo',
  },
  {
    id: '3578110005',
    districtId: '3578110',
    name: 'Ngagel',
  },
  {
    id: '3578110006',
    districtId: '3578110',
    name: 'Darmo',
  },
  {
    id: '3578120001',
    districtId: '3578120',
    name: 'Gunungsari',
  },
  {
    id: '3578120002',
    districtId: '3578120',
    name: 'Dukuh Pakis',
  },
  {
    id: '3578120003',
    districtId: '3578120',
    name: 'Pradahkali Kendal',
  },
  {
    id: '3578120004',
    districtId: '3578120',
    name: 'Dukuh Kupang',
  },
  {
    id: '3578130001',
    districtId: '3578130',
    name: 'Balas Klumprik',
  },
  {
    id: '3578130002',
    districtId: '3578130',
    name: 'Babatan',
  },
  {
    id: '3578130003',
    districtId: '3578130',
    name: 'Wiyung',
  },
  {
    id: '3578130004',
    districtId: '3578130',
    name: 'Jajar Tunggal',
  },
  {
    id: '3578140001',
    districtId: '3578140',
    name: 'Bangkingan',
  },
  {
    id: '3578140003',
    districtId: '3578140',
    name: 'Lidah Wetan',
  },
  {
    id: '3578140004',
    districtId: '3578140',
    name: 'Lidah Kulon',
  },
  {
    id: '3578140006',
    districtId: '3578140',
    name: 'Lakarsantri',
  },
  {
    id: '3578141001',
    districtId: '3578141',
    name: 'Made',
  },
  {
    id: '3578141002',
    districtId: '3578141',
    name: 'Bringin',
  },
  {
    id: '3578141003',
    districtId: '3578141',
    name: 'Sambikerep',
  },
  {
    id: '3578141004',
    districtId: '3578141',
    name: 'Lontar',
  },
  {
    id: '3578150006',
    districtId: '3578150',
    name: 'Karangpoh',
  },
  {
    id: '3578150007',
    districtId: '3578150',
    name: 'Balongsari',
  },
  {
    id: '3578150009',
    districtId: '3578150',
    name: 'Manukan Wetan',
  },
  {
    id: '3578150010',
    districtId: '3578150',
    name: 'Manukan Kulon',
  },
  {
    id: '3578150011',
    districtId: '3578150',
    name: 'Banjar Sugihan',
  },
  {
    id: '3578150013',
    districtId: '3578150',
    name: 'Tandes',
  },
  {
    id: '3578160001',
    districtId: '3578160',
    name: 'Putat Gede',
  },
  {
    id: '3578160002',
    districtId: '3578160',
    name: 'Sono Kwijenan',
  },
  {
    id: '3578160003',
    districtId: '3578160',
    name: 'Simomulyo',
  },
  {
    id: '3578160004',
    districtId: '3578160',
    name: 'Suko Manunggal',
  },
  {
    id: '3578160005',
    districtId: '3578160',
    name: 'Tanjungsari',
  },
  {
    id: '3578160006',
    districtId: '3578160',
    name: 'Simomulyo Baru',
  },
  {
    id: '3578170001',
    districtId: '3578170',
    name: 'Pakis',
  },
  {
    id: '3578170002',
    districtId: '3578170',
    name: 'Putat Jaya',
  },
  {
    id: '3578170003',
    districtId: '3578170',
    name: 'Banyu Urip',
  },
  {
    id: '3578170004',
    districtId: '3578170',
    name: 'Kupang Krajan',
  },
  {
    id: '3578170005',
    districtId: '3578170',
    name: 'Petemon',
  },
  {
    id: '3578170006',
    districtId: '3578170',
    name: 'Sawahan',
  },
  {
    id: '3578180001',
    districtId: '3578180',
    name: 'Keputran',
  },
  {
    id: '3578180002',
    districtId: '3578180',
    name: 'Dr. Sutomo',
  },
  {
    id: '3578180003',
    districtId: '3578180',
    name: 'Tegalsari',
  },
  {
    id: '3578180004',
    districtId: '3578180',
    name: 'Wonorejo',
  },
  {
    id: '3578180005',
    districtId: '3578180',
    name: 'Kedungdoro',
  },
  {
    id: '3578190001',
    districtId: '3578190',
    name: 'Embong Kaliasin',
  },
  {
    id: '3578190002',
    districtId: '3578190',
    name: 'Ketabang',
  },
  {
    id: '3578190005',
    districtId: '3578190',
    name: 'Kapasari',
  },
  {
    id: '3578200001',
    districtId: '3578200',
    name: 'Pacar Keling',
  },
  {
    id: '3578200002',
    districtId: '3578200',
    name: 'Pacar Kembang',
  },
  {
    id: '3578200003',
    districtId: '3578200',
    name: 'Ploso',
  },
  {
    id: '3578200004',
    districtId: '3578200',
    name: 'Tambaksari',
  },
  {
    id: '3578200005',
    districtId: '3578200',
    name: 'Rangkah',
  },
  {
    id: '3578200006',
    districtId: '3578200',
    name: 'Gading',
  },
  {
    id: '3578200007',
    districtId: '3578200',
    name: 'Kapasmadya Baru',
  },
  {
    id: '3578200008',
    districtId: '3578200',
    name: 'Dukuh Setro',
  },
  {
    id: '3578210005',
    districtId: '3578210',
    name: 'Tanah Kali Kedinding',
  },
  {
    id: '3578210006',
    districtId: '3578210',
    name: 'Sidotopo Wetan',
  },
  {
    id: '3578210007',
    districtId: '3578210',
    name: 'Bulak Banteng',
  },
  {
    id: '3578210008',
    districtId: '3578210',
    name: 'Tambak Wedi',
  },
  {
    id: '3578211003',
    districtId: '3578211',
    name: 'Kenjeran',
  },
  {
    id: '3578211004',
    districtId: '3578211',
    name: 'Bulak',
  },
  {
    id: '3578211005',
    districtId: '3578211',
    name: 'Kedung Cowek',
  },
  {
    id: '3578211006',
    districtId: '3578211',
    name: 'Sukolilo Baru',
  },
  {
    id: '3578220001',
    districtId: '3578220',
    name: 'Kapasan',
  },
  {
    id: '3578220002',
    districtId: '3578220',
    name: 'Tambakrejo',
  },
  {
    id: '3578220003',
    districtId: '3578220',
    name: 'Simokerto',
  },
  {
    id: '3578220004',
    districtId: '3578220',
    name: 'Sidodadi',
  },
  {
    id: '3578220005',
    districtId: '3578220',
    name: 'Simolawang',
  },
  {
    id: '3578230001',
    districtId: '3578230',
    name: 'Ampel',
  },
  {
    id: '3578230002',
    districtId: '3578230',
    name: 'Sidotopo',
  },
  {
    id: '3578230003',
    districtId: '3578230',
    name: 'Pegirian',
  },
  {
    id: '3578230004',
    districtId: '3578230',
    name: 'Wonokusumo',
  },
  {
    id: '3578240001',
    districtId: '3578240',
    name: 'Bongkaran',
  },
  {
    id: '3578240002',
    districtId: '3578240',
    name: 'Nyamplungan',
  },
  {
    id: '3578240003',
    districtId: '3578240',
    name: 'Krembangan Utara',
  },
  {
    id: '3578240004',
    districtId: '3578240',
    name: 'Perak Timur',
  },
  {
    id: '3578240005',
    districtId: '3578240',
    name: 'Perak Utara',
  },
  {
    id: '3578250001',
    districtId: '3578250',
    name: 'Tembok Dukuh',
  },
  {
    id: '3578250002',
    districtId: '3578250',
    name: 'Bubutan',
  },
  {
    id: '3578250003',
    districtId: '3578250',
    name: 'Alon-Alon Contong',
  },
  {
    id: '3578250004',
    districtId: '3578250',
    name: 'Gundih',
  },
  {
    id: '3578250005',
    districtId: '3578250',
    name: 'Jepara',
  },
  {
    id: '3578260001',
    districtId: '3578260',
    name: 'Dupak',
  },
  {
    id: '3578260002',
    districtId: '3578260',
    name: 'Morokrembangan',
  },
  {
    id: '3578260003',
    districtId: '3578260',
    name: 'Perak Barat',
  },
  {
    id: '3578260004',
    districtId: '3578260',
    name: 'Kemayoran',
  },
  {
    id: '3578260005',
    districtId: '3578260',
    name: 'Krembangan Selatan',
  },
  {
    id: '3578270003',
    districtId: '3578270',
    name: 'Asemrowo',
  },
  {
    id: '3578270006',
    districtId: '3578270',
    name: 'Genting Kalianak',
  },
  {
    id: '3578270007',
    districtId: '3578270',
    name: 'Tambak Sarioso',
  },
  {
    id: '3578280004',
    districtId: '3578280',
    name: 'Sememi',
  },
  {
    id: '3578280006',
    districtId: '3578280',
    name: 'Kandangan',
  },
  {
    id: '3578280007',
    districtId: '3578280',
    name: 'Tambak Oso Wilangon',
  },
  {
    id: '3578280008',
    districtId: '3578280',
    name: 'Romokalisari',
  },
  {
    id: '3578281001',
    districtId: '3578281',
    name: 'Babat Jerawat',
  },
  {
    id: '3578281002',
    districtId: '3578281',
    name: 'Pakal',
  },
  {
    id: '3578281003',
    districtId: '3578281',
    name: 'Benowo',
  },
  {
    id: '3578281004',
    districtId: '3578281',
    name: 'Sumberrejo',
  },
  {
    id: '3579010001',
    districtId: '3579010',
    name: 'Oro-Oro Ombo',
  },
  {
    id: '3579010002',
    districtId: '3579010',
    name: 'Temas',
  },
  {
    id: '3579010003',
    districtId: '3579010',
    name: 'Sisir',
  },
  {
    id: '3579010004',
    districtId: '3579010',
    name: 'Ngaglik',
  },
  {
    id: '3579010005',
    districtId: '3579010',
    name: 'Pesanggrahan',
  },
  {
    id: '3579010006',
    districtId: '3579010',
    name: 'Songgokerto',
  },
  {
    id: '3579010007',
    districtId: '3579010',
    name: 'Sumberejo',
  },
  {
    id: '3579010008',
    districtId: '3579010',
    name: 'Sidomulyo',
  },
  {
    id: '3579020002',
    districtId: '3579020',
    name: 'Junrejo',
  },
  {
    id: '3579020003',
    districtId: '3579020',
    name: 'Mojorejo',
  },
  {
    id: '3579020004',
    districtId: '3579020',
    name: 'Torongrejo',
  },
  {
    id: '3579020005',
    districtId: '3579020',
    name: 'Beji',
  },
  {
    id: '3579020007',
    districtId: '3579020',
    name: 'Dadaprejo',
  },
  {
    id: '3579030001',
    districtId: '3579030',
    name: 'Pandanrejo',
  },
  {
    id: '3579030002',
    districtId: '3579030',
    name: 'Bumiaji',
  },
  {
    id: '3579030003',
    districtId: '3579030',
    name: 'Bulukerto',
  },
  {
    id: '3579030004',
    districtId: '3579030',
    name: 'Gunungsari',
  },
  {
    id: '3579030006',
    districtId: '3579030',
    name: 'Tulungrejo',
  },
  {
    id: '3579030007',
    districtId: '3579030',
    name: 'Sumbergondo',
  },
  {
    id: '3579030008',
    districtId: '3579030',
    name: 'Giripurno',
  },
  {
    id: '3579030009',
    districtId: '3579030',
    name: 'Sumber Brantas',
  },
  {
    id: '3601010001',
    districtId: '3601010',
    name: 'Ujungjaya',
  },
  {
    id: '3601010002',
    districtId: '3601010',
    name: 'Tamanjaya',
  },
  {
    id: '3601010003',
    districtId: '3601010',
    name: 'Cigorondong',
  },
  {
    id: '3601010004',
    districtId: '3601010',
    name: 'Tunggaljaya',
  },
  {
    id: '3601010005',
    districtId: '3601010',
    name: 'Kertamukti',
  },
  {
    id: '3601010006',
    districtId: '3601010',
    name: 'Kertajaya',
  },
  {
    id: '3601010007',
    districtId: '3601010',
    name: 'Sumberjaya',
  },
  {
    id: '3601020001',
    districtId: '3601020',
    name: 'Rancapinang',
  },
  {
    id: '3601020002',
    districtId: '3601020',
    name: 'Cibadak',
  },
  {
    id: '3601020003',
    districtId: '3601020',
    name: 'Batuhideung',
  },
  {
    id: '3601020005',
    districtId: '3601020',
    name: 'Kramatjaya',
  },
  {
    id: '3601020006',
    districtId: '3601020',
    name: 'Mangkualam',
  },
  {
    id: '3601020007',
    districtId: '3601020',
    name: 'Padasuka',
  },
  {
    id: '3601020008',
    districtId: '3601020',
    name: 'Ciburial',
  },
  {
    id: '3601020009',
    districtId: '3601020',
    name: 'Waringinkurung',
  },
  {
    id: '3601020010',
    districtId: '3601020',
    name: 'Cijaralang',
  },
  {
    id: '3601020011',
    districtId: '3601020',
    name: 'Cimanggu',
  },
  {
    id: '3601020012',
    districtId: '3601020',
    name: 'Tangkilsari',
  },
  {
    id: '3601030011',
    districtId: '3601030',
    name: 'Sukajadi',
  },
  {
    id: '3601030012',
    districtId: '3601030',
    name: 'Sudimanik',
  },
  {
    id: '3601030013',
    districtId: '3601030',
    name: 'Sorongan',
  },
  {
    id: '3601030015',
    districtId: '3601030',
    name: 'Cihanjuang',
  },
  {
    id: '3601030016',
    districtId: '3601030',
    name: 'Cibingbin',
  },
  {
    id: '3601030017',
    districtId: '3601030',
    name: 'Cibaliung',
  },
  {
    id: '3601030019',
    districtId: '3601030',
    name: 'Mahendra',
  },
  {
    id: '3601031001',
    districtId: '3601031',
    name: 'Citeluk',
  },
  {
    id: '3601031002',
    districtId: '3601031',
    name: 'Sindangkerta',
  },
  {
    id: '3601031003',
    districtId: '3601031',
    name: 'Kiarajangkung',
  },
  {
    id: '3601031004',
    districtId: '3601031',
    name: 'Kutakarang',
  },
  {
    id: '3601031005',
    districtId: '3601031',
    name: 'Cikiruh',
  },
  {
    id: '3601031006',
    districtId: '3601031',
    name: 'Malangnengah',
  },
  {
    id: '3601031007',
    districtId: '3601031',
    name: 'Cikadu',
  },
  {
    id: '3601031008',
    districtId: '3601031',
    name: 'Manglid',
  },
  {
    id: '3601031009',
    districtId: '3601031',
    name: 'Kiarapayung',
  },
  {
    id: '3601031010',
    districtId: '3601031',
    name: 'Cikalong',
  },
  {
    id: '3601040001',
    districtId: '3601040',
    name: 'Tanjungan',
  },
  {
    id: '3601040002',
    districtId: '3601040',
    name: 'Cikiruhwetan',
  },
  {
    id: '3601040003',
    districtId: '3601040',
    name: 'Sukawaris',
  },
  {
    id: '3601040004',
    districtId: '3601040',
    name: 'Sumurbatu',
  },
  {
    id: '3601040005',
    districtId: '3601040',
    name: 'Umbulan',
  },
  {
    id: '3601040006',
    districtId: '3601040',
    name: 'Sukamulya',
  },
  {
    id: '3601040007',
    districtId: '3601040',
    name: 'Parungkokosan',
  },
  {
    id: '3601040008',
    districtId: '3601040',
    name: 'Nanggala',
  },
  {
    id: '3601040009',
    districtId: '3601040',
    name: 'Rancaseneng',
  },
  {
    id: '3601040010',
    districtId: '3601040',
    name: 'Sukaseneng',
  },
  {
    id: '3601040011',
    districtId: '3601040',
    name: 'Cikeusik',
  },
  {
    id: '3601040012',
    districtId: '3601040',
    name: 'Leuwibalang',
  },
  {
    id: '3601040013',
    districtId: '3601040',
    name: 'Curugciung',
  },
  {
    id: '3601040014',
    districtId: '3601040',
    name: 'Cikadongdong',
  },
  {
    id: '3601050001',
    districtId: '3601050',
    name: 'Banyuasih',
  },
  {
    id: '3601050002',
    districtId: '3601050',
    name: 'Karangbolong',
  },
  {
    id: '3601050003',
    districtId: '3601050',
    name: 'Karyabuana',
  },
  {
    id: '3601050004',
    districtId: '3601050',
    name: 'Katumbiri',
  },
  {
    id: '3601050005',
    districtId: '3601050',
    name: 'Waringinjaya',
  },
  {
    id: '3601050006',
    districtId: '3601050',
    name: 'Sinarjaya',
  },
  {
    id: '3601050007',
    districtId: '3601050',
    name: 'Ciseureuheun',
  },
  {
    id: '3601050009',
    districtId: '3601050',
    name: 'Cigeulis',
  },
  {
    id: '3601050010',
    districtId: '3601050',
    name: 'Tarumanagara',
  },
  {
    id: '3601060007',
    districtId: '3601060',
    name: 'Mekarjaya',
  },
  {
    id: '3601060008',
    districtId: '3601060',
    name: 'Gombong',
  },
  {
    id: '3601060009',
    districtId: '3601060',
    name: 'Panimbangjaya',
  },
  {
    id: '3601060010',
    districtId: '3601060',
    name: 'Mekarsari',
  },
  {
    id: '3601060011',
    districtId: '3601060',
    name: 'Citeureup',
  },
  {
    id: '3601060012',
    districtId: '3601060',
    name: 'Tanjungjaya',
  },
  {
    id: '3601061001',
    districtId: '3601061',
    name: 'Cimanis',
  },
  {
    id: '3601061002',
    districtId: '3601061',
    name: 'Pangkalan',
  },
  {
    id: '3601061003',
    districtId: '3601061',
    name: 'Sobang',
  },
  {
    id: '3601061004',
    districtId: '3601061',
    name: 'Kutamekar',
  },
  {
    id: '3601061005',
    districtId: '3601061',
    name: 'Bojen',
  },
  {
    id: '3601061006',
    districtId: '3601061',
    name: 'Kertaraharja',
  },
  {
    id: '3601061007',
    districtId: '3601061',
    name: 'Teluklada',
  },
  {
    id: '3601061008',
    districtId: '3601061',
    name: 'Bojenwetan',
  },
  {
    id: '3601070003',
    districtId: '3601070',
    name: 'Lebak',
  },
  {
    id: '3601070004',
    districtId: '3601070',
    name: 'Gunungbatu',
  },
  {
    id: '3601070005',
    districtId: '3601070',
    name: 'Panacaran',
  },
  {
    id: '3601070006',
    districtId: '3601070',
    name: 'Curuglanglang',
  },
  {
    id: '3601070008',
    districtId: '3601070',
    name: 'Cibitung',
  },
  {
    id: '3601070018',
    districtId: '3601070',
    name: 'Kotadukuh',
  },
  {
    id: '3601070019',
    districtId: '3601070',
    name: 'Pasanggrahan',
  },
  {
    id: '3601070020',
    districtId: '3601070',
    name: 'Sukasaba',
  },
  {
    id: '3601071001',
    districtId: '3601071',
    name: 'Cipinang',
  },
  {
    id: '3601071002',
    districtId: '3601071',
    name: 'Kadubadak',
  },
  {
    id: '3601071004',
    districtId: '3601071',
    name: 'Cikayas',
  },
  {
    id: '3601071005',
    districtId: '3601071',
    name: 'Sumurlaban',
  },
  {
    id: '3601071006',
    districtId: '3601071',
    name: 'Padamulya',
  },
  {
    id: '3601071007',
    districtId: '3601071',
    name: 'Padaherang',
  },
  {
    id: '3601071008',
    districtId: '3601071',
    name: 'Karangsari',
  },
  {
    id: '3601071009',
    districtId: '3601071',
    name: 'Angsana',
  },
  {
    id: '3601071010',
    districtId: '3601071',
    name: 'Kramatmanik',
  },
  {
    id: '3601072001',
    districtId: '3601072',
    name: 'Pasirloa',
  },
  {
    id: '3601072002',
    districtId: '3601072',
    name: 'Bojongmanik',
  },
  {
    id: '3601072003',
    districtId: '3601072',
    name: 'Campakawarna',
  },
  {
    id: '3601072004',
    districtId: '3601072',
    name: 'Ciodeng',
  },
  {
    id: '3601072005',
    districtId: '3601072',
    name: 'Pasirtenjo',
  },
  {
    id: '3601072006',
    districtId: '3601072',
    name: 'Sindangresmi',
  },
  {
    id: '3601072007',
    districtId: '3601072',
    name: 'Pasirlancar',
  },
  {
    id: '3601072008',
    districtId: '3601072',
    name: 'Pasirdurung',
  },
  {
    id: '3601072009',
    districtId: '3601072',
    name: 'Kadumalati',
  },
  {
    id: '3601080001',
    districtId: '3601080',
    name: 'Ciherang',
  },
  {
    id: '3601080002',
    districtId: '3601080',
    name: 'Kolelet',
  },
  {
    id: '3601080003',
    districtId: '3601080',
    name: 'Cililitan',
  },
  {
    id: '3601080004',
    districtId: '3601080',
    name: 'Kadupandak',
  },
  {
    id: '3601080005',
    districtId: '3601080',
    name: 'Bungurcopong',
  },
  {
    id: '3601080006',
    districtId: '3601080',
    name: 'Pasirsedang',
  },
  {
    id: '3601080007',
    districtId: '3601080',
    name: 'Pasirpanjang',
  },
  {
    id: '3601080008',
    districtId: '3601080',
    name: 'Kadubera',
  },
  {
    id: '3601080009',
    districtId: '3601080',
    name: 'Ganggaeng',
  },
  {
    id: '3601090002',
    districtId: '3601090',
    name: 'Mekarsari',
  },
  {
    id: '3601090003',
    districtId: '3601090',
    name: 'Cijakan',
  },
  {
    id: '3601090004',
    districtId: '3601090',
    name: 'Citumenggung',
  },
  {
    id: '3601090005',
    districtId: '3601090',
    name: 'Cahayamekar',
  },
  {
    id: '3601090006',
    districtId: '3601090',
    name: 'Bojong',
  },
  {
    id: '3601090007',
    districtId: '3601090',
    name: 'Banyumas',
  },
  {
    id: '3601090008',
    districtId: '3601090',
    name: 'Manggungjaya',
  },
  {
    id: '3601100005',
    districtId: '3601100',
    name: 'Sukalangu',
  },
  {
    id: '3601100006',
    districtId: '3601100',
    name: 'Langensari',
  },
  {
    id: '3601100008',
    districtId: '3601100',
    name: 'Majau',
  },
  {
    id: '3601100009',
    districtId: '3601100',
    name: 'Medalsari',
  },
  {
    id: '3601100010',
    districtId: '3601100',
    name: 'Sodong',
  },
  {
    id: '3601100011',
    districtId: '3601100',
    name: 'Mekarwangi',
  },
  {
    id: '3601100012',
    districtId: '3601100',
    name: 'Ciandur',
  },
  {
    id: '3601100013',
    districtId: '3601100',
    name: 'Saketi',
  },
  {
    id: '3601100014',
    districtId: '3601100',
    name: 'Kadudampit',
  },
  {
    id: '3601100015',
    districtId: '3601100',
    name: 'Girijaya',
  },
  {
    id: '3601100016',
    districtId: '3601100',
    name: 'Wanagiri',
  },
  {
    id: '3601100017',
    districtId: '3601100',
    name: 'Parigi',
  },
  {
    id: '3601100018',
    districtId: '3601100',
    name: 'Talagasari',
  },
  {
    id: '3601100019',
    districtId: '3601100',
    name: 'Sindanghayu',
  },
  {
    id: '3601101001',
    districtId: '3601101',
    name: 'Kondangjaya',
  },
  {
    id: '3601101002',
    districtId: '3601101',
    name: 'Kubangkondang',
  },
  {
    id: '3601101003',
    districtId: '3601101',
    name: 'Cisereh',
  },
  {
    id: '3601101004',
    districtId: '3601101',
    name: 'Cibarani',
  },
  {
    id: '3601101005',
    districtId: '3601101',
    name: 'Rawasari',
  },
  {
    id: '3601101006',
    districtId: '3601101',
    name: 'Pasireurih',
  },
  {
    id: '3601101007',
    districtId: '3601101',
    name: 'Kaduronyok',
  },
  {
    id: '3601101008',
    districtId: '3601101',
    name: 'Ciherangjaya',
  },
  {
    id: '3601101009',
    districtId: '3601101',
    name: 'Palembang',
  },
  {
    id: '3601110020',
    districtId: '3601110',
    name: 'Tegalpapak',
  },
  {
    id: '3601110021',
    districtId: '3601110',
    name: 'Margagiri',
  },
  {
    id: '3601110022',
    districtId: '3601110',
    name: 'Bama',
  },
  {
    id: '3601110023',
    districtId: '3601110',
    name: 'Pagelaran',
  },
  {
    id: '3601110024',
    districtId: '3601110',
    name: 'Sukadame',
  },
  {
    id: '3601110025',
    districtId: '3601110',
    name: 'Bulagor',
  },
  {
    id: '3601110026',
    districtId: '3601110',
    name: 'Surakarta',
  },
  {
    id: '3601110027',
    districtId: '3601110',
    name: 'Harapankarya',
  },
  {
    id: '3601110029',
    districtId: '3601110',
    name: 'Montor',
  },
  {
    id: '3601110030',
    districtId: '3601110',
    name: 'Kartasana',
  },
  {
    id: '3601110031',
    districtId: '3601110',
    name: 'Senangsari',
  },
  {
    id: '3601110032',
    districtId: '3601110',
    name: 'Sindanglaya',
  },
  {
    id: '3601110033',
    districtId: '3601110',
    name: 'Margasana',
  },
  {
    id: '3601111009',
    districtId: '3601111',
    name: 'Pasirgadung',
  },
  {
    id: '3601111010',
    districtId: '3601111',
    name: 'Patia',
  },
  {
    id: '3601111011',
    districtId: '3601111',
    name: 'Babakankeusik',
  },
  {
    id: '3601111012',
    districtId: '3601111',
    name: 'Cimoyan',
  },
  {
    id: '3601111013',
    districtId: '3601111',
    name: 'Idaman',
  },
  {
    id: '3601111014',
    districtId: '3601111',
    name: 'Ciawi',
  },
  {
    id: '3601111015',
    districtId: '3601111',
    name: 'Surianeun',
  },
  {
    id: '3601111016',
    districtId: '3601111',
    name: 'Rahayu',
  },
  {
    id: '3601111017',
    districtId: '3601111',
    name: 'Simpangtiga',
  },
  {
    id: '3601112001',
    districtId: '3601112',
    name: 'Seuseupan',
  },
  {
    id: '3601112002',
    districtId: '3601112',
    name: 'Karyasari',
  },
  {
    id: '3601112003',
    districtId: '3601112',
    name: 'Pasirkadu',
  },
  {
    id: '3601112004',
    districtId: '3601112',
    name: 'Perdana',
  },
  {
    id: '3601112005',
    districtId: '3601112',
    name: 'Sukaresmi',
  },
  {
    id: '3601112006',
    districtId: '3601112',
    name: 'Kubangkampil',
  },
  {
    id: '3601112007',
    districtId: '3601112',
    name: 'Sidamukti',
  },
  {
    id: '3601112008',
    districtId: '3601112',
    name: 'Cibungur',
  },
  {
    id: '3601112010',
    districtId: '3601112',
    name: 'Cikuya',
  },
  {
    id: '3601120001',
    districtId: '3601120',
    name: 'Cigondang',
  },
  {
    id: '3601120002',
    districtId: '3601120',
    name: 'Sukamaju',
  },
  {
    id: '3601120003',
    districtId: '3601120',
    name: 'Rancateureup',
  },
  {
    id: '3601120004',
    districtId: '3601120',
    name: 'Kalanganyar',
  },
  {
    id: '3601120005',
    districtId: '3601120',
    name: 'Labuan',
  },
  {
    id: '3601120007',
    districtId: '3601120',
    name: 'Banyumekar',
  },
  {
    id: '3601120008',
    districtId: '3601120',
    name: 'Banyubiru',
  },
  {
    id: '3601120009',
    districtId: '3601120',
    name: 'Caringin',
  },
  {
    id: '3601121001',
    districtId: '3601121',
    name: 'Pejamben',
  },
  {
    id: '3601121002',
    districtId: '3601121',
    name: 'Banjarmasin',
  },
  {
    id: '3601121003',
    districtId: '3601121',
    name: 'Tembong',
  },
  {
    id: '3601121004',
    districtId: '3601121',
    name: 'Sindanglaut',
  },
  {
    id: '3601121005',
    districtId: '3601121',
    name: 'Carita',
  },
  {
    id: '3601121006',
    districtId: '3601121',
    name: 'Sukajadi',
  },
  {
    id: '3601121007',
    districtId: '3601121',
    name: 'Sukarame',
  },
  {
    id: '3601121008',
    districtId: '3601121',
    name: 'Sukanagara',
  },
  {
    id: '3601121009',
    districtId: '3601121',
    name: 'Kawoyang',
  },
  {
    id: '3601121010',
    districtId: '3601121',
    name: 'Cinoyong',
  },
  {
    id: '3601130007',
    districtId: '3601130',
    name: 'Banyuresmi',
  },
  {
    id: '3601130008',
    districtId: '3601130',
    name: 'Salapraya',
  },
  {
    id: '3601130009',
    districtId: '3601130',
    name: 'Pamarayan',
  },
  {
    id: '3601130010',
    districtId: '3601130',
    name: 'Sampangbitung',
  },
  {
    id: '3601130011',
    districtId: '3601130',
    name: 'Jiput',
  },
  {
    id: '3601130012',
    districtId: '3601130',
    name: 'Sukacai',
  },
  {
    id: '3601130013',
    districtId: '3601130',
    name: 'Tenjolahang',
  },
  {
    id: '3601130014',
    districtId: '3601130',
    name: 'Babadsari',
  },
  {
    id: '3601130015',
    districtId: '3601130',
    name: 'Janaka',
  },
  {
    id: '3601130016',
    districtId: '3601130',
    name: 'Sukamanah',
  },
  {
    id: '3601130018',
    districtId: '3601130',
    name: 'Sikulan',
  },
  {
    id: '3601130019',
    districtId: '3601130',
    name: 'Citaman',
  },
  {
    id: '3601130020',
    districtId: '3601130',
    name: 'Jayamekar',
  },
  {
    id: '3601131001',
    districtId: '3601131',
    name: 'Karyautama',
  },
  {
    id: '3601131002',
    districtId: '3601131',
    name: 'Tegal',
  },
  {
    id: '3601131003',
    districtId: '3601131',
    name: 'Cipicung',
  },
  {
    id: '3601131004',
    districtId: '3601131',
    name: 'Karyasari',
  },
  {
    id: '3601131005',
    districtId: '3601131',
    name: 'Dahu',
  },
  {
    id: '3601131006',
    districtId: '3601131',
    name: 'Babakanlor',
  },
  {
    id: '3601131007',
    districtId: '3601131',
    name: 'Mekarjaya',
  },
  {
    id: '3601131008',
    districtId: '3601131',
    name: 'Padahayu',
  },
  {
    id: '3601131009',
    districtId: '3601131',
    name: 'Bangkuyung',
  },
  {
    id: '3601131010',
    districtId: '3601131',
    name: 'Cening',
  },
  {
    id: '3601140003',
    districtId: '3601140',
    name: 'Alaswangi',
  },
  {
    id: '3601140004',
    districtId: '3601140',
    name: 'Tegalwangi',
  },
  {
    id: '3601140006',
    districtId: '3601140',
    name: 'Kananga',
  },
  {
    id: '3601140007',
    districtId: '3601140',
    name: 'Cilabanbulan',
  },
  {
    id: '3601140008',
    districtId: '3601140',
    name: 'Sindangkarya',
  },
  {
    id: '3601140009',
    districtId: '3601140',
    name: 'Cigandeng',
  },
  {
    id: '3601140010',
    districtId: '3601140',
    name: 'Purwaraja',
  },
  {
    id: '3601140013',
    districtId: '3601140',
    name: 'Kadupayung',
  },
  {
    id: '3601140014',
    districtId: '3601140',
    name: 'Sukamanah',
  },
  {
    id: '3601140015',
    districtId: '3601140',
    name: 'Ramaya',
  },
  {
    id: '3601141001',
    districtId: '3601141',
    name: 'Banjarnegara',
  },
  {
    id: '3601141002',
    districtId: '3601141',
    name: 'Kaduhejo',
  },
  {
    id: '3601141003',
    districtId: '3601141',
    name: 'Koranji',
  },
  {
    id: '3601141004',
    districtId: '3601141',
    name: 'Sanghiangdengdek',
  },
  {
    id: '3601141005',
    districtId: '3601141',
    name: 'Cilentung',
  },
  {
    id: '3601141006',
    districtId: '3601141',
    name: 'Karyawangi',
  },
  {
    id: '3601141007',
    districtId: '3601141',
    name: 'Banjarwangi',
  },
  {
    id: '3601141008',
    districtId: '3601141',
    name: 'Sukasari',
  },
  {
    id: '3601141009',
    districtId: '3601141',
    name: 'Sukaraja',
  },
  {
    id: '3601150001',
    districtId: '3601150',
    name: 'Pandat',
  },
  {
    id: '3601150002',
    districtId: '3601150',
    name: 'Cikoneng',
  },
  {
    id: '3601150003',
    districtId: '3601150',
    name: 'Giripawana',
  },
  {
    id: '3601150004',
    districtId: '3601150',
    name: 'Nembol',
  },
  {
    id: '3601150005',
    districtId: '3601150',
    name: 'Gunungsari',
  },
  {
    id: '3601150006',
    districtId: '3601150',
    name: 'Kurungkambing',
  },
  {
    id: '3601150007',
    districtId: '3601150',
    name: 'Mandalasari',
  },
  {
    id: '3601150008',
    districtId: '3601150',
    name: 'Mandalawangi',
  },
  {
    id: '3601150009',
    districtId: '3601150',
    name: 'Pari',
  },
  {
    id: '3601150010',
    districtId: '3601150',
    name: 'Sinarjaya',
  },
  {
    id: '3601150011',
    districtId: '3601150',
    name: 'Sirnagalih',
  },
  {
    id: '3601150012',
    districtId: '3601150',
    name: 'Curuglemo',
  },
  {
    id: '3601150013',
    districtId: '3601150',
    name: 'Panjangjaya',
  },
  {
    id: '3601150014',
    districtId: '3601150',
    name: 'Cikumbueun',
  },
  {
    id: '3601150015',
    districtId: '3601150',
    name: 'Ramea',
  },
  {
    id: '3601160008',
    districtId: '3601160',
    name: 'Kadudodol',
  },
  {
    id: '3601160009',
    districtId: '3601160',
    name: 'Gunungdatar',
  },
  {
    id: '3601160011',
    districtId: '3601160',
    name: 'Sekong',
  },
  {
    id: '3601160019',
    districtId: '3601160',
    name: 'Cimanuk',
  },
  {
    id: '3601160020',
    districtId: '3601160',
    name: 'Batubantar',
  },
  {
    id: '3601160021',
    districtId: '3601160',
    name: 'Rocek',
  },
  {
    id: '3601160022',
    districtId: '3601160',
    name: 'Kadumadang',
  },
  {
    id: '3601160023',
    districtId: '3601160',
    name: 'Dalembalar',
  },
  {
    id: '3601160024',
    districtId: '3601160',
    name: 'Kupahandap',
  },
  {
    id: '3601160025',
    districtId: '3601160',
    name: 'Kadubungbang',
  },
  {
    id: '3601161001',
    districtId: '3601161',
    name: 'Cikadueun',
  },
  {
    id: '3601161002',
    districtId: '3601161',
    name: 'Koncang',
  },
  {
    id: '3601161003',
    districtId: '3601161',
    name: 'Pasirmae',
  },
  {
    id: '3601161004',
    districtId: '3601161',
    name: 'Parumasan',
  },
  {
    id: '3601161005',
    districtId: '3601161',
    name: 'Kadugadung',
  },
  {
    id: '3601161006',
    districtId: '3601161',
    name: 'Palanyar',
  },
  {
    id: '3601161007',
    districtId: '3601161',
    name: 'Baturanjang',
  },
  {
    id: '3601161008',
    districtId: '3601161',
    name: 'Kalanggunung',
  },
  {
    id: '3601161009',
    districtId: '3601161',
    name: 'Curugbarang',
  },
  {
    id: '3601161010',
    districtId: '3601161',
    name: 'Pasireurih',
  },
  {
    id: '3601170004',
    districtId: '3601170',
    name: 'Cibeureum',
  },
  {
    id: '3601170005',
    districtId: '3601170',
    name: 'Cibodas',
  },
  {
    id: '3601170007',
    districtId: '3601170',
    name: 'Kadulimus',
  },
  {
    id: '3601170008',
    districtId: '3601170',
    name: 'Bandung',
  },
  {
    id: '3601170009',
    districtId: '3601170',
    name: 'Kadumaneuh',
  },
  {
    id: '3601170010',
    districtId: '3601170',
    name: 'Citalahab',
  },
  {
    id: '3601170011',
    districtId: '3601170',
    name: 'Pasirawi',
  },
  {
    id: '3601170012',
    districtId: '3601170',
    name: 'Mogana',
  },
  {
    id: '3601170013',
    districtId: '3601170',
    name: 'Kadubale',
  },
  {
    id: '3601170014',
    districtId: '3601170',
    name: 'Banjar',
  },
  {
    id: '3601170015',
    districtId: '3601170',
    name: 'Gunungputri',
  },
  {
    id: '3601171001',
    districtId: '3601171',
    name: 'Banjarsari',
  },
  {
    id: '3601171002',
    districtId: '3601171',
    name: 'Sukamanah',
  },
  {
    id: '3601171003',
    districtId: '3601171',
    name: 'Palurahan',
  },
  {
    id: '3601171004',
    districtId: '3601171',
    name: 'Kadugemblo',
  },
  {
    id: '3601171005',
    districtId: '3601171',
    name: 'Sukasari',
  },
  {
    id: '3601171006',
    districtId: '3601171',
    name: 'Mandalasari',
  },
  {
    id: '3601171007',
    districtId: '3601171',
    name: 'Saninten',
  },
  {
    id: '3601171008',
    districtId: '3601171',
    name: 'Bayumundu',
  },
  {
    id: '3601171009',
    districtId: '3601171',
    name: 'Campaka',
  },
  {
    id: '3601171010',
    districtId: '3601171',
    name: 'Ciputri',
  },
  {
    id: '3601172001',
    districtId: '3601172',
    name: 'Rancabugel',
  },
  {
    id: '3601172002',
    districtId: '3601172',
    name: 'Wirasinga',
  },
  {
    id: '3601172003',
    districtId: '3601172',
    name: 'Pareang',
  },
  {
    id: '3601172004',
    districtId: '3601172',
    name: 'Kadubelang',
  },
  {
    id: '3601172005',
    districtId: '3601172',
    name: 'Mekarjaya',
  },
  {
    id: '3601172006',
    districtId: '3601172',
    name: 'Kadujangkung',
  },
  {
    id: '3601172007',
    districtId: '3601172',
    name: 'Medong',
  },
  {
    id: '3601172008',
    districtId: '3601172',
    name: 'Sukamulya',
  },
  {
    id: '3601180003',
    districtId: '3601180',
    name: 'Kadomas',
  },
  {
    id: '3601180004',
    districtId: '3601180',
    name: 'Babakan Kalanganyar',
  },
  {
    id: '3601180005',
    districtId: '3601180',
    name: 'Kabayan',
  },
  {
    id: '3601180006',
    districtId: '3601180',
    name: 'Pandeglang',
  },
  {
    id: '3601181001',
    districtId: '3601181',
    name: 'Sukaratu',
  },
  {
    id: '3601181002',
    districtId: '3601181',
    name: 'Karaton',
  },
  {
    id: '3601181003',
    districtId: '3601181',
    name: 'Cilaja',
  },
  {
    id: '3601181004',
    districtId: '3601181',
    name: 'Saruni',
  },
  {
    id: '3601181005',
    districtId: '3601181',
    name: 'Pagerbatu',
  },
  {
    id: '3601190017',
    districtId: '3601190',
    name: 'Cikentrung',
  },
  {
    id: '3601190018',
    districtId: '3601190',
    name: 'Kaungcaang',
  },
  {
    id: '3601190019',
    districtId: '3601190',
    name: 'Ciinjuk',
  },
  {
    id: '3601190020',
    districtId: '3601190',
    name: 'Cadasari',
  },
  {
    id: '3601190021',
    districtId: '3601190',
    name: 'Tapos',
  },
  {
    id: '3601190022',
    districtId: '3601190',
    name: 'Tanagara',
  },
  {
    id: '3601190023',
    districtId: '3601190',
    name: 'Kurungdahu',
  },
  {
    id: '3601190024',
    districtId: '3601190',
    name: 'Pasirpeuteuy',
  },
  {
    id: '3601190025',
    districtId: '3601190',
    name: 'Kaduengang',
  },
  {
    id: '3601190026',
    districtId: '3601190',
    name: 'Kaduela',
  },
  {
    id: '3601190027',
    districtId: '3601190',
    name: 'Koranji',
  },
  {
    id: '3601191005',
    districtId: '3601191',
    name: 'Kadumerak',
  },
  {
    id: '3601191006',
    districtId: '3601191',
    name: 'Pagadungan',
  },
  {
    id: '3601191007',
    districtId: '3601191',
    name: 'Cigadung',
  },
  {
    id: '3601192001',
    districtId: '3601192',
    name: 'Pasirjaksa',
  },
  {
    id: '3601192002',
    districtId: '3601192',
    name: 'Bangkonol',
  },
  {
    id: '3601192003',
    districtId: '3601192',
    name: 'Tegalongok',
  },
  {
    id: '3601192004',
    districtId: '3601192',
    name: 'Pasirkarag',
  },
  {
    id: '3601192005',
    districtId: '3601192',
    name: 'Paniis',
  },
  {
    id: '3601192006',
    districtId: '3601192',
    name: 'Setrajaya',
  },
  {
    id: '3601192007',
    districtId: '3601192',
    name: 'Karangsetra',
  },
  {
    id: '3601192008',
    districtId: '3601192',
    name: 'Pakuluran',
  },
  {
    id: '3601192009',
    districtId: '3601192',
    name: 'Koroncong',
  },
  {
    id: '3601192010',
    districtId: '3601192',
    name: 'Gerendong',
  },
  {
    id: '3601192011',
    districtId: '3601192',
    name: 'Awilega',
  },
  {
    id: '3601192012',
    districtId: '3601192',
    name: 'Sukajaya',
  },
  {
    id: '3602010004',
    districtId: '3602010',
    name: 'Sukamanah',
  },
  {
    id: '3602010005',
    districtId: '3602010',
    name: 'Malingping Selatan',
  },
  {
    id: '3602010006',
    districtId: '3602010',
    name: 'Cilangkahan',
  },
  {
    id: '3602010007',
    districtId: '3602010',
    name: 'Pagelaran',
  },
  {
    id: '3602010008',
    districtId: '3602010',
    name: 'Kersaratu',
  },
  {
    id: '3602010009',
    districtId: '3602010',
    name: 'Sukaraja',
  },
  {
    id: '3602010010',
    districtId: '3602010',
    name: 'Kadujajar',
  },
  {
    id: '3602010011',
    districtId: '3602010',
    name: 'Malingping Utara',
  },
  {
    id: '3602010012',
    districtId: '3602010',
    name: 'Rahong',
  },
  {
    id: '3602010013',
    districtId: '3602010',
    name: 'Sanghiang',
  },
  {
    id: '3602010014',
    districtId: '3602010',
    name: 'Bolang',
  },
  {
    id: '3602010023',
    districtId: '3602010',
    name: 'Sumber Waras',
  },
  {
    id: '3602010024',
    districtId: '3602010',
    name: 'Cipeundeuy',
  },
  {
    id: '3602010025',
    districtId: '3602010',
    name: 'Senanghati',
  },
  {
    id: '3602011001',
    districtId: '3602011',
    name: 'Muara',
  },
  {
    id: '3602011002',
    districtId: '3602011',
    name: 'Wanasalam',
  },
  {
    id: '3602011003',
    districtId: '3602011',
    name: 'Sukatani',
  },
  {
    id: '3602011004',
    districtId: '3602011',
    name: 'Cikeusik',
  },
  {
    id: '3602011005',
    districtId: '3602011',
    name: 'Bejod',
  },
  {
    id: '3602011006',
    districtId: '3602011',
    name: 'Cipedang',
  },
  {
    id: '3602011007',
    districtId: '3602011',
    name: 'Cisarap',
  },
  {
    id: '3602011008',
    districtId: '3602011',
    name: 'Parungsari',
  },
  {
    id: '3602011009',
    districtId: '3602011',
    name: 'Cipeucang',
  },
  {
    id: '3602011010',
    districtId: '3602011',
    name: 'Parungpanjang',
  },
  {
    id: '3602011011',
    districtId: '3602011',
    name: 'Ketapang',
  },
  {
    id: '3602011012',
    districtId: '3602011',
    name: 'Cilangkap',
  },
  {
    id: '3602011013',
    districtId: '3602011',
    name: 'Karang Pamindangan',
  },
  {
    id: '3602020006',
    districtId: '3602020',
    name: 'Situregen',
  },
  {
    id: '3602020007',
    districtId: '3602020',
    name: 'Sukajadi',
  },
  {
    id: '3602020008',
    districtId: '3602020',
    name: 'Hegarmanah',
  },
  {
    id: '3602020009',
    districtId: '3602020',
    name: 'Panggarangan',
  },
  {
    id: '3602020010',
    districtId: '3602020',
    name: 'Mekarjaya',
  },
  {
    id: '3602020011',
    districtId: '3602020',
    name: 'Sindangratu',
  },
  {
    id: '3602020012',
    districtId: '3602020',
    name: 'Cimandiri',
  },
  {
    id: '3602020017',
    districtId: '3602020',
    name: 'Sogong',
  },
  {
    id: '3602020018',
    districtId: '3602020',
    name: 'Jatake',
  },
  {
    id: '3602020019',
    districtId: '3602020',
    name: 'Cibarengkok',
  },
  {
    id: '3602021001',
    districtId: '3602021',
    name: 'Pondokpanjang',
  },
  {
    id: '3602021002',
    districtId: '3602021',
    name: 'Ciparahu',
  },
  {
    id: '3602021003',
    districtId: '3602021',
    name: 'Cihara',
  },
  {
    id: '3602021004',
    districtId: '3602021',
    name: 'Karangkamulyan',
  },
  {
    id: '3602021005',
    districtId: '3602021',
    name: 'Panyaungan',
  },
  {
    id: '3602021006',
    districtId: '3602021',
    name: 'Mekarsari',
  },
  {
    id: '3602021007',
    districtId: '3602021',
    name: 'Lebak Peundeuy',
  },
  {
    id: '3602021008',
    districtId: '3602021',
    name: 'Citepuseun',
  },
  {
    id: '3602021009',
    districtId: '3602021',
    name: 'Barunai',
  },
  {
    id: '3602030001',
    districtId: '3602030',
    name: 'Bayah Barat',
  },
  {
    id: '3602030002',
    districtId: '3602030',
    name: 'Darmasari',
  },
  {
    id: '3602030003',
    districtId: '3602030',
    name: 'Sawarna',
  },
  {
    id: '3602030011',
    districtId: '3602030',
    name: 'Cidikit',
  },
  {
    id: '3602030012',
    districtId: '3602030',
    name: 'Bayah Timur',
  },
  {
    id: '3602030013',
    districtId: '3602030',
    name: 'Cimancak',
  },
  {
    id: '3602030014',
    districtId: '3602030',
    name: 'Suwakan',
  },
  {
    id: '3602030015',
    districtId: '3602030',
    name: 'Pasirgombong',
  },
  {
    id: '3602030016',
    districtId: '3602030',
    name: 'Cisuren',
  },
  {
    id: '3602030017',
    districtId: '3602030',
    name: 'Pamubulan',
  },
  {
    id: '3602030018',
    districtId: '3602030',
    name: 'Sawarna Timur',
  },
  {
    id: '3602031001',
    districtId: '3602031',
    name: 'Cibareno',
  },
  {
    id: '3602031002',
    districtId: '3602031',
    name: 'Cilograng',
  },
  {
    id: '3602031003',
    districtId: '3602031',
    name: 'Lebaktipar',
  },
  {
    id: '3602031004',
    districtId: '3602031',
    name: 'Cikatomas',
  },
  {
    id: '3602031005',
    districtId: '3602031',
    name: 'Cijengkol',
  },
  {
    id: '3602031006',
    districtId: '3602031',
    name: 'Pasirbungur',
  },
  {
    id: '3602031007',
    districtId: '3602031',
    name: 'Cikamunding',
  },
  {
    id: '3602031008',
    districtId: '3602031',
    name: 'Girimukti',
  },
  {
    id: '3602031009',
    districtId: '3602031',
    name: 'Cireundeu',
  },
  {
    id: '3602031010',
    districtId: '3602031',
    name: 'Gunungbatu',
  },
  {
    id: '3602040001',
    districtId: '3602040',
    name: 'Cikotok',
  },
  {
    id: '3602040002',
    districtId: '3602040',
    name: 'Cibeber',
  },
  {
    id: '3602040003',
    districtId: '3602040',
    name: 'Warungbanten',
  },
  {
    id: '3602040004',
    districtId: '3602040',
    name: 'Neglasari',
  },
  {
    id: '3602040005',
    districtId: '3602040',
    name: 'Mekarsari',
  },
  {
    id: '3602040007',
    districtId: '3602040',
    name: 'Cikadu',
  },
  {
    id: '3602040008',
    districtId: '3602040',
    name: 'Kujangjaya',
  },
  {
    id: '3602040009',
    districtId: '3602040',
    name: 'Cisungsang',
  },
  {
    id: '3602040010',
    districtId: '3602040',
    name: 'Hegarmanah',
  },
  {
    id: '3602040011',
    districtId: '3602040',
    name: 'Cihambali',
  },
  {
    id: '3602040012',
    districtId: '3602040',
    name: 'Sukamulya',
  },
  {
    id: '3602040013',
    districtId: '3602040',
    name: 'Citorek Tengah',
  },
  {
    id: '3602040014',
    districtId: '3602040',
    name: 'Citorek Timur',
  },
  {
    id: '3602040015',
    districtId: '3602040',
    name: 'Citorek Kidul',
  },
  {
    id: '3602040016',
    districtId: '3602040',
    name: 'Kujangsari',
  },
  {
    id: '3602040017',
    districtId: '3602040',
    name: 'Situmulya',
  },
  {
    id: '3602040018',
    districtId: '3602040',
    name: 'Sinargalih',
  },
  {
    id: '3602040019',
    districtId: '3602040',
    name: 'Wanasari',
  },
  {
    id: '3602040020',
    districtId: '3602040',
    name: 'Gunung Wangun',
  },
  {
    id: '3602040021',
    districtId: '3602040',
    name: 'Citorek Barat',
  },
  {
    id: '3602040022',
    districtId: '3602040',
    name: 'Ciherang',
  },
  {
    id: '3602040023',
    districtId: '3602040',
    name: 'Citorek Sabrang',
  },
  {
    id: '3602050001',
    districtId: '3602050',
    name: 'Kandangsapi',
  },
  {
    id: '3602050002',
    districtId: '3602050',
    name: 'Cihujan',
  },
  {
    id: '3602050003',
    districtId: '3602050',
    name: 'Ciapus',
  },
  {
    id: '3602050005',
    districtId: '3602050',
    name: 'Cijaku',
  },
  {
    id: '3602050006',
    districtId: '3602050',
    name: 'Mekarjaya',
  },
  {
    id: '3602050007',
    districtId: '3602050',
    name: 'Cipalabuh',
  },
  {
    id: '3602050008',
    districtId: '3602050',
    name: 'Cibeureum',
  },
  {
    id: '3602050009',
    districtId: '3602050',
    name: 'Cimenga',
  },
  {
    id: '3602050010',
    districtId: '3602050',
    name: 'Sukasenang',
  },
  {
    id: '3602050011',
    districtId: '3602050',
    name: 'Kapunduhan',
  },
  {
    id: '3602051001',
    districtId: '3602051',
    name: 'Peucangpari',
  },
  {
    id: '3602051002',
    districtId: '3602051',
    name: 'Cibungur',
  },
  {
    id: '3602051003',
    districtId: '3602051',
    name: 'Cikaret',
  },
  {
    id: '3602051004',
    districtId: '3602051',
    name: 'Cikadongdong',
  },
  {
    id: '3602051005',
    districtId: '3602051',
    name: 'Cikaratuan',
  },
  {
    id: '3602051006',
    districtId: '3602051',
    name: 'Mugijaya',
  },
  {
    id: '3602051007',
    districtId: '3602051',
    name: 'Cigemblong',
  },
  {
    id: '3602051008',
    districtId: '3602051',
    name: 'Cikate',
  },
  {
    id: '3602051009',
    districtId: '3602051',
    name: 'Wangunjaya',
  },
  {
    id: '3602060001',
    districtId: '3602060',
    name: 'Kertaraharja',
  },
  {
    id: '3602060002',
    districtId: '3602060',
    name: 'Kerta',
  },
  {
    id: '3602060003',
    districtId: '3602060',
    name: 'Bojongjuruh',
  },
  {
    id: '3602060004',
    districtId: '3602060',
    name: 'Lebakkeusik',
  },
  {
    id: '3602060005',
    districtId: '3602060',
    name: 'Leuwiipuh',
  },
  {
    id: '3602060006',
    districtId: '3602060',
    name: 'Tamansari',
  },
  {
    id: '3602060007',
    districtId: '3602060',
    name: 'Cilegong Ilir',
  },
  {
    id: '3602060008',
    districtId: '3602060',
    name: 'Cisampih',
  },
  {
    id: '3602060009',
    districtId: '3602060',
    name: 'Jalupang Girang',
  },
  {
    id: '3602060010',
    districtId: '3602060',
    name: 'Cidahu',
  },
  {
    id: '3602060011',
    districtId: '3602060',
    name: 'Keusik',
  },
  {
    id: '3602060012',
    districtId: '3602060',
    name: 'Ciruji',
  },
  {
    id: '3602060013',
    districtId: '3602060',
    name: 'Cibaturkeusik',
  },
  {
    id: '3602060014',
    districtId: '3602060',
    name: 'Bendungan',
  },
  {
    id: '3602060015',
    districtId: '3602060',
    name: 'Kumpay',
  },
  {
    id: '3602060016',
    districtId: '3602060',
    name: 'Gunungsari',
  },
  {
    id: '3602060017',
    districtId: '3602060',
    name: 'Kaduhauk',
  },
  {
    id: '3602060018',
    districtId: '3602060',
    name: 'Labanjaya',
  },
  {
    id: '3602060019',
    districtId: '3602060',
    name: 'Umbuljaya',
  },
  {
    id: '3602060020',
    districtId: '3602060',
    name: 'Kertarahayu',
  },
  {
    id: '3602070001',
    districtId: '3602070',
    name: 'Mekarjaya',
  },
  {
    id: '3602070002',
    districtId: '3602070',
    name: 'Pasindangan',
  },
  {
    id: '3602070003',
    districtId: '3602070',
    name: 'Kujangsari',
  },
  {
    id: '3602070004',
    districtId: '3602070',
    name: 'Parungkujang',
  },
  {
    id: '3602070005',
    districtId: '3602070',
    name: 'Cikareo',
  },
  {
    id: '3602070006',
    districtId: '3602070',
    name: 'Cileles',
  },
  {
    id: '3602070007',
    districtId: '3602070',
    name: 'Margamulya',
  },
  {
    id: '3602070008',
    districtId: '3602070',
    name: 'Cipadang',
  },
  {
    id: '3602070009',
    districtId: '3602070',
    name: 'Daroyon',
  },
  {
    id: '3602070010',
    districtId: '3602070',
    name: 'Prabugantungan',
  },
  {
    id: '3602070012',
    districtId: '3602070',
    name: 'Banjarsari',
  },
  {
    id: '3602080002',
    districtId: '3602080',
    name: 'Cimanyangray',
  },
  {
    id: '3602080003',
    districtId: '3602080',
    name: 'Keramatjaya',
  },
  {
    id: '3602080004',
    districtId: '3602080',
    name: 'Bulakan',
  },
  {
    id: '3602080005',
    districtId: '3602080',
    name: 'Cicaringin',
  },
  {
    id: '3602080006',
    districtId: '3602080',
    name: 'Ciakar',
  },
  {
    id: '3602080007',
    districtId: '3602080',
    name: 'Cisampang',
  },
  {
    id: '3602080008',
    districtId: '3602080',
    name: 'Bojong Koneng',
  },
  {
    id: '3602080009',
    districtId: '3602080',
    name: 'Ciginggang',
  },
  {
    id: '3602080010',
    districtId: '3602080',
    name: 'Gunung Kencana',
  },
  {
    id: '3602080011',
    districtId: '3602080',
    name: 'Sukanegara',
  },
  {
    id: '3602080012',
    districtId: '3602080',
    name: 'Tanjungsari Indah',
  },
  {
    id: '3602090007',
    districtId: '3602090',
    name: 'Keboncau',
  },
  {
    id: '3602090008',
    districtId: '3602090',
    name: 'Cimayang',
  },
  {
    id: '3602090009',
    districtId: '3602090',
    name: 'Parakanbeusi',
  },
  {
    id: '3602090010',
    districtId: '3602090',
    name: 'Bojongmanik',
  },
  {
    id: '3602090011',
    districtId: '3602090',
    name: 'Mekarmanik',
  },
  {
    id: '3602090014',
    districtId: '3602090',
    name: 'Kadurahayu',
  },
  {
    id: '3602090015',
    districtId: '3602090',
    name: 'Harjawana',
  },
  {
    id: '3602090016',
    districtId: '3602090',
    name: 'Mekar Rahayu',
  },
  {
    id: '3602090017',
    districtId: '3602090',
    name: 'Pasir Bitung',
  },
  {
    id: '3602091001',
    districtId: '3602091',
    name: 'Parakanlima',
  },
  {
    id: '3602091002',
    districtId: '3602091',
    name: 'Kadudamas',
  },
  {
    id: '3602091003',
    districtId: '3602091',
    name: 'Datarcae',
  },
  {
    id: '3602091004',
    districtId: '3602091',
    name: 'Karoya',
  },
  {
    id: '3602091005',
    districtId: '3602091',
    name: 'Nangerang',
  },
  {
    id: '3602091006',
    districtId: '3602091',
    name: 'Cirinten',
  },
  {
    id: '3602091007',
    districtId: '3602091',
    name: 'Karangnunggal',
  },
  {
    id: '3602091008',
    districtId: '3602091',
    name: 'Cempaka',
  },
  {
    id: '3602091009',
    districtId: '3602091',
    name: 'Badur',
  },
  {
    id: '3602091010',
    districtId: '3602091',
    name: 'Cibarani',
  },
  {
    id: '3602100001',
    districtId: '3602100',
    name: 'Kanekes',
  },
  {
    id: '3602100002',
    districtId: '3602100',
    name: 'Nayagati',
  },
  {
    id: '3602100003',
    districtId: '3602100',
    name: 'Bojong Menteng',
  },
  {
    id: '3602100004',
    districtId: '3602100',
    name: 'Cisimeut',
  },
  {
    id: '3602100005',
    districtId: '3602100',
    name: 'Margawangi',
  },
  {
    id: '3602100006',
    districtId: '3602100',
    name: 'Sangkanwangi',
  },
  {
    id: '3602100007',
    districtId: '3602100',
    name: 'Jalupang Mulya',
  },
  {
    id: '3602100008',
    districtId: '3602100',
    name: 'Leuwidamar',
  },
  {
    id: '3602100009',
    districtId: '3602100',
    name: 'Cibungur',
  },
  {
    id: '3602100010',
    districtId: '3602100',
    name: 'Lebak Parahiang',
  },
  {
    id: '3602100011',
    districtId: '3602100',
    name: 'Wantisari',
  },
  {
    id: '3602100012',
    districtId: '3602100',
    name: 'Cisimeut Raya',
  },
  {
    id: '3602110010',
    districtId: '3602110',
    name: 'Pasireurih',
  },
  {
    id: '3602110011',
    districtId: '3602110',
    name: 'Pasirnangka',
  },
  {
    id: '3602110012',
    districtId: '3602110',
    name: 'Cikarang',
  },
  {
    id: '3602110013',
    districtId: '3602110',
    name: 'Ciminyak',
  },
  {
    id: '3602110014',
    districtId: '3602110',
    name: 'Leuwicoo',
  },
  {
    id: '3602110015',
    districtId: '3602110',
    name: 'Muncang',
  },
  {
    id: '3602110016',
    districtId: '3602110',
    name: 'Sukanagara',
  },
  {
    id: '3602110017',
    districtId: '3602110',
    name: 'Sindangwangi',
  },
  {
    id: '3602110018',
    districtId: '3602110',
    name: 'Jagaraksa',
  },
  {
    id: '3602110019',
    districtId: '3602110',
    name: 'Tanjungwangi',
  },
  {
    id: '3602110020',
    districtId: '3602110',
    name: 'Mekarwangi',
  },
  {
    id: '3602110021',
    districtId: '3602110',
    name: 'Giri Jagabaya',
  },
  {
    id: '3602111001',
    districtId: '3602111',
    name: 'Sinarjaya',
  },
  {
    id: '3602111002',
    districtId: '3602111',
    name: 'Cirompang',
  },
  {
    id: '3602111003',
    districtId: '3602111',
    name: 'Sukamaju',
  },
  {
    id: '3602111004',
    districtId: '3602111',
    name: 'Majasari',
  },
  {
    id: '3602111005',
    districtId: '3602111',
    name: 'Ciparasi',
  },
  {
    id: '3602111006',
    districtId: '3602111',
    name: 'Sindanglaya',
  },
  {
    id: '3602111007',
    districtId: '3602111',
    name: 'Sobang',
  },
  {
    id: '3602111008',
    districtId: '3602111',
    name: 'Sukajaya',
  },
  {
    id: '3602111009',
    districtId: '3602111',
    name: 'Hariang',
  },
  {
    id: '3602111010',
    districtId: '3602111',
    name: 'Sukaresmi',
  },
  {
    id: '3602120006',
    districtId: '3602120',
    name: 'Pasirhaur',
  },
  {
    id: '3602120007',
    districtId: '3602120',
    name: 'Girilaya',
  },
  {
    id: '3602120008',
    districtId: '3602120',
    name: 'Jayapura',
  },
  {
    id: '3602120009',
    districtId: '3602120',
    name: 'Giriharja',
  },
  {
    id: '3602120010',
    districtId: '3602120',
    name: 'Bintangsari',
  },
  {
    id: '3602120011',
    districtId: '3602120',
    name: 'Cipanas',
  },
  {
    id: '3602120013',
    districtId: '3602120',
    name: 'Luhurjaya',
  },
  {
    id: '3602120014',
    districtId: '3602120',
    name: 'Sipayung',
  },
  {
    id: '3602120015',
    districtId: '3602120',
    name: 'Bintangresmi',
  },
  {
    id: '3602120016',
    districtId: '3602120',
    name: 'Malangsari',
  },
  {
    id: '3602120017',
    districtId: '3602120',
    name: 'Sukasari',
  },
  {
    id: '3602120018',
    districtId: '3602120',
    name: 'Haurgajrug',
  },
  {
    id: '3602120019',
    districtId: '3602120',
    name: 'Talagahiang',
  },
  {
    id: '3602120020',
    districtId: '3602120',
    name: 'Harumsari',
  },
  {
    id: '3602121001',
    districtId: '3602121',
    name: 'Lebakgedong',
  },
  {
    id: '3602121002',
    districtId: '3602121',
    name: 'Lebaksitu',
  },
  {
    id: '3602121003',
    districtId: '3602121',
    name: 'Ciladaeun',
  },
  {
    id: '3602121004',
    districtId: '3602121',
    name: 'Banjarsari',
  },
  {
    id: '3602121005',
    districtId: '3602121',
    name: 'Lebaksangka',
  },
  {
    id: '3602121006',
    districtId: '3602121',
    name: 'Banjar Irigasi',
  },
  {
    id: '3602130001',
    districtId: '3602130',
    name: 'Maraya',
  },
  {
    id: '3602130002',
    districtId: '3602130',
    name: 'Margaluyu',
  },
  {
    id: '3602130003',
    districtId: '3602130',
    name: 'Sukamarga',
  },
  {
    id: '3602130004',
    districtId: '3602130',
    name: 'Sindangsari',
  },
  {
    id: '3602130005',
    districtId: '3602130',
    name: 'Sajiramekar',
  },
  {
    id: '3602130006',
    districtId: '3602130',
    name: 'Sajira',
  },
  {
    id: '3602130007',
    districtId: '3602130',
    name: 'Sukarame',
  },
  {
    id: '3602130008',
    districtId: '3602130',
    name: 'Calungbungur',
  },
  {
    id: '3602130009',
    districtId: '3602130',
    name: 'Sukajaya',
  },
  {
    id: '3602130010',
    districtId: '3602130',
    name: 'Paja',
  },
  {
    id: '3602130011',
    districtId: '3602130',
    name: 'Mekarsari',
  },
  {
    id: '3602130012',
    districtId: '3602130',
    name: 'Pajagan',
  },
  {
    id: '3602130013',
    districtId: '3602130',
    name: 'Parungsari',
  },
  {
    id: '3602130014',
    districtId: '3602130',
    name: 'Bungur Mekar',
  },
  {
    id: '3602130015',
    districtId: '3602130',
    name: 'Ciuyah',
  },
  {
    id: '3602140001',
    districtId: '3602140',
    name: 'Sarageni',
  },
  {
    id: '3602140002',
    districtId: '3602140',
    name: 'Jayasari',
  },
  {
    id: '3602140003',
    districtId: '3602140',
    name: 'Margatirta',
  },
  {
    id: '3602140004',
    districtId: '3602140',
    name: 'Gunung Anten',
  },
  {
    id: '3602140005',
    districtId: '3602140',
    name: 'Sangkan Manik',
  },
  {
    id: '3602140006',
    districtId: '3602140',
    name: 'Sudamanik',
  },
  {
    id: '3602140007',
    districtId: '3602140',
    name: 'Girimukti',
  },
  {
    id: '3602140008',
    districtId: '3602140',
    name: 'Jayamanik',
  },
  {
    id: '3602140009',
    districtId: '3602140',
    name: 'Margaluyu',
  },
  {
    id: '3602140010',
    districtId: '3602140',
    name: 'Sangiang Jaya',
  },
  {
    id: '3602140011',
    districtId: '3602140',
    name: 'Tambak',
  },
  {
    id: '3602140012',
    districtId: '3602140',
    name: 'Marga Jaya',
  },
  {
    id: '3602140013',
    districtId: '3602140',
    name: 'Cimarga',
  },
  {
    id: '3602140014',
    districtId: '3602140',
    name: 'Mekar Jaya',
  },
  {
    id: '3602140015',
    districtId: '3602140',
    name: 'Inten Jaya',
  },
  {
    id: '3602140016',
    districtId: '3602140',
    name: 'Karya Jaya',
  },
  {
    id: '3602140017',
    districtId: '3602140',
    name: 'Mekarmulya',
  },
  {
    id: '3602150001',
    districtId: '3602150',
    name: 'Anggalan',
  },
  {
    id: '3602150002',
    districtId: '3602150',
    name: 'Muaradua',
  },
  {
    id: '3602150003',
    districtId: '3602150',
    name: 'Muncangkopong',
  },
  {
    id: '3602150004',
    districtId: '3602150',
    name: 'Taman Jaya',
  },
  {
    id: '3602150005',
    districtId: '3602150',
    name: 'Curugpanjang',
  },
  {
    id: '3602150006',
    districtId: '3602150',
    name: 'Cikulur',
  },
  {
    id: '3602150007',
    districtId: '3602150',
    name: 'Cigoong Selatan',
  },
  {
    id: '3602150008',
    districtId: '3602150',
    name: 'Cigoong Utara',
  },
  {
    id: '3602150009',
    districtId: '3602150',
    name: 'Sumurbandung',
  },
  {
    id: '3602150010',
    districtId: '3602150',
    name: 'Sukaharja',
  },
  {
    id: '3602150011',
    districtId: '3602150',
    name: 'Sukadaya',
  },
  {
    id: '3602150012',
    districtId: '3602150',
    name: 'Parage',
  },
  {
    id: '3602150013',
    districtId: '3602150',
    name: 'Pasir Gintung',
  },
  {
    id: '3602160001',
    districtId: '3602160',
    name: 'Pasirtangkil',
  },
  {
    id: '3602160002',
    districtId: '3602160',
    name: 'Sukarendah',
  },
  {
    id: '3602160003',
    districtId: '3602160',
    name: 'Selaraja',
  },
  {
    id: '3602160004',
    districtId: '3602160',
    name: 'Warunggunung',
  },
  {
    id: '3602160005',
    districtId: '3602160',
    name: 'Cibuah',
  },
  {
    id: '3602160006',
    districtId: '3602160',
    name: 'Baros',
  },
  {
    id: '3602160007',
    districtId: '3602160',
    name: 'Sindangsari',
  },
  {
    id: '3602160008',
    districtId: '3602160',
    name: 'Banjarsari',
  },
  {
    id: '3602160009',
    districtId: '3602160',
    name: 'Cempaka',
  },
  {
    id: '3602160010',
    districtId: '3602160',
    name: 'Padasuka',
  },
  {
    id: '3602160011',
    districtId: '3602160',
    name: 'Sukaraja',
  },
  {
    id: '3602160012',
    districtId: '3602160',
    name: 'Jagabaya',
  },
  {
    id: '3602170001',
    districtId: '3602170',
    name: 'Tambakbaya',
  },
  {
    id: '3602170002',
    districtId: '3602170',
    name: 'Bojongleles',
  },
  {
    id: '3602170003',
    districtId: '3602170',
    name: 'Kaduagung Timur',
  },
  {
    id: '3602170004',
    districtId: '3602170',
    name: 'Kaduagung Barat',
  },
  {
    id: '3602170005',
    districtId: '3602170',
    name: 'Malabar',
  },
  {
    id: '3602170006',
    districtId: '3602170',
    name: 'Pasar Keong',
  },
  {
    id: '3602170007',
    districtId: '3602170',
    name: 'Cibadak',
  },
  {
    id: '3602170008',
    districtId: '3602170',
    name: 'Panancangan',
  },
  {
    id: '3602170009',
    districtId: '3602170',
    name: 'Asem',
  },
  {
    id: '3602170010',
    districtId: '3602170',
    name: 'Cisangu',
  },
  {
    id: '3602170011',
    districtId: '3602170',
    name: 'Bojongcae',
  },
  {
    id: '3602170012',
    districtId: '3602170',
    name: 'Kaduagung Tengah',
  },
  {
    id: '3602170013',
    districtId: '3602170',
    name: 'Mekar Agung',
  },
  {
    id: '3602170014',
    districtId: '3602170',
    name: 'Asem Margaluyu',
  },
  {
    id: '3602170015',
    districtId: '3602170',
    name: 'Cimenteng Jaya',
  },
  {
    id: '3602180007',
    districtId: '3602180',
    name: 'Pasir Tanjung',
  },
  {
    id: '3602180008',
    districtId: '3602180',
    name: 'Rangkasbitung Timur',
  },
  {
    id: '3602180009',
    districtId: '3602180',
    name: 'Rangkasbitung Barat',
  },
  {
    id: '3602180010',
    districtId: '3602180',
    name: 'Muara Ciujung Timur',
  },
  {
    id: '3602180011',
    districtId: '3602180',
    name: 'Jatimulya',
  },
  {
    id: '3602180012',
    districtId: '3602180',
    name: 'Cimangeungteung',
  },
  {
    id: '3602180013',
    districtId: '3602180',
    name: 'Citeras',
  },
  {
    id: '3602180014',
    districtId: '3602180',
    name: 'Mekarsari',
  },
  {
    id: '3602180015',
    districtId: '3602180',
    name: 'Nameng',
  },
  {
    id: '3602180016',
    districtId: '3602180',
    name: 'Kolelet Wetan',
  },
  {
    id: '3602180017',
    districtId: '3602180',
    name: 'Sukamanah',
  },
  {
    id: '3602180018',
    districtId: '3602180',
    name: 'Pabuaran',
  },
  {
    id: '3602180019',
    districtId: '3602180',
    name: 'Cijoro Pasir',
  },
  {
    id: '3602180020',
    districtId: '3602180',
    name: 'Cijoro Lebak',
  },
  {
    id: '3602180021',
    districtId: '3602180',
    name: 'Muara Ciujung Barat',
  },
  {
    id: '3602180022',
    districtId: '3602180',
    name: 'Narimbang Mulia',
  },
  {
    id: '3602181001',
    districtId: '3602181',
    name: 'Cilangkap',
  },
  {
    id: '3602181002',
    districtId: '3602181',
    name: 'Pasir Kupa',
  },
  {
    id: '3602181003',
    districtId: '3602181',
    name: 'Aweh',
  },
  {
    id: '3602181004',
    districtId: '3602181',
    name: 'Sukamekarsari',
  },
  {
    id: '3602181005',
    districtId: '3602181',
    name: 'Kalanganyar',
  },
  {
    id: '3602181006',
    districtId: '3602181',
    name: 'Sangiang Tanjung',
  },
  {
    id: '3602181007',
    districtId: '3602181',
    name: 'Cikatapis',
  },
  {
    id: '3602190008',
    districtId: '3602190',
    name: 'Cilangkap',
  },
  {
    id: '3602190009',
    districtId: '3602190',
    name: 'Pasir Kecapi',
  },
  {
    id: '3602190012',
    districtId: '3602190',
    name: 'Mekarsari',
  },
  {
    id: '3602190013',
    districtId: '3602190',
    name: 'Sangiang',
  },
  {
    id: '3602190014',
    districtId: '3602190',
    name: 'Tanjung Sari',
  },
  {
    id: '3602190015',
    districtId: '3602190',
    name: 'Maja',
  },
  {
    id: '3602190016',
    districtId: '3602190',
    name: 'Curug Badak',
  },
  {
    id: '3602190017',
    districtId: '3602190',
    name: 'Pasir Kembang',
  },
  {
    id: '3602190018',
    districtId: '3602190',
    name: 'Padasuka',
  },
  {
    id: '3602190019',
    districtId: '3602190',
    name: 'Gubugancibeureum',
  },
  {
    id: '3602190020',
    districtId: '3602190',
    name: 'Binong',
  },
  {
    id: '3602190021',
    districtId: '3602190',
    name: 'Sindangmulya',
  },
  {
    id: '3602190022',
    districtId: '3602190',
    name: 'Buyut Mekar',
  },
  {
    id: '3602190023',
    districtId: '3602190',
    name: 'Maja Baru',
  },
  {
    id: '3602191001',
    districtId: '3602191',
    name: 'Guradog',
  },
  {
    id: '3602191002',
    districtId: '3602191',
    name: 'Candi',
  },
  {
    id: '3602191003',
    districtId: '3602191',
    name: 'Sekarwangi',
  },
  {
    id: '3602191004',
    districtId: '3602191',
    name: 'Curugbitung',
  },
  {
    id: '3602191005',
    districtId: '3602191',
    name: 'Ciburuy',
  },
  {
    id: '3602191006',
    districtId: '3602191',
    name: 'Mayak',
  },
  {
    id: '3602191007',
    districtId: '3602191',
    name: 'Cilayang',
  },
  {
    id: '3602191008',
    districtId: '3602191',
    name: 'Cipining',
  },
  {
    id: '3602191009',
    districtId: '3602191',
    name: 'Cidadap',
  },
  {
    id: '3602191010',
    districtId: '3602191',
    name: 'Lebakasih',
  },
  {
    id: '3603010008',
    districtId: '3603010',
    name: 'Jeung Jing',
  },
  {
    id: '3603010009',
    districtId: '3603010',
    name: 'Cisoka',
  },
  {
    id: '3603010010',
    districtId: '3603010',
    name: 'Sukatani',
  },
  {
    id: '3603010011',
    districtId: '3603010',
    name: 'Cempaka',
  },
  {
    id: '3603010012',
    districtId: '3603010',
    name: 'Karangharja',
  },
  {
    id: '3603010013',
    districtId: '3603010',
    name: 'Carenang',
  },
  {
    id: '3603010014',
    districtId: '3603010',
    name: 'Bojongloa',
  },
  {
    id: '3603010015',
    districtId: '3603010',
    name: 'Caringin',
  },
  {
    id: '3603010016',
    districtId: '3603010',
    name: 'Selapajang',
  },
  {
    id: '3603010017',
    districtId: '3603010',
    name: 'Cibugel',
  },
  {
    id: '3603011001',
    districtId: '3603011',
    name: 'Cikasungka',
  },
  {
    id: '3603011002',
    districtId: '3603011',
    name: 'Cikuya',
  },
  {
    id: '3603011003',
    districtId: '3603011',
    name: 'Cikareo',
  },
  {
    id: '3603011004',
    districtId: '3603011',
    name: 'Cireundeu',
  },
  {
    id: '3603011005',
    districtId: '3603011',
    name: 'Solear',
  },
  {
    id: '3603011006',
    districtId: '3603011',
    name: 'Pasanggrahan',
  },
  {
    id: '3603020001',
    districtId: '3603020',
    name: 'Cileles',
  },
  {
    id: '3603020002',
    districtId: '3603020',
    name: 'Bantar Panjang',
  },
  {
    id: '3603020003',
    districtId: '3603020',
    name: 'Sodong',
  },
  {
    id: '3603020004',
    districtId: '3603020',
    name: 'Tapos',
  },
  {
    id: '3603020013',
    districtId: '3603020',
    name: 'Marga Sari',
  },
  {
    id: '3603020014',
    districtId: '3603020',
    name: 'Kadu Agung',
  },
  {
    id: '3603020015',
    districtId: '3603020',
    name: 'Mata Gara',
  },
  {
    id: '3603020016',
    districtId: '3603020',
    name: 'Tigaraksa',
  },
  {
    id: '3603020018',
    districtId: '3603020',
    name: 'Tegalsari',
  },
  {
    id: '3603020019',
    districtId: '3603020',
    name: 'Pematang',
  },
  {
    id: '3603020020',
    districtId: '3603020',
    name: 'Pasir Nangka',
  },
  {
    id: '3603020021',
    districtId: '3603020',
    name: 'Cisereh',
  },
  {
    id: '3603020022',
    districtId: '3603020',
    name: 'Pasir Bolang',
  },
  {
    id: '3603021001',
    districtId: '3603021',
    name: 'Mekarsari',
  },
  {
    id: '3603021002',
    districtId: '3603021',
    name: 'Daru',
  },
  {
    id: '3603021003',
    districtId: '3603021',
    name: 'Suka Manah',
  },
  {
    id: '3603021004',
    districtId: '3603021',
    name: 'Taban',
  },
  {
    id: '3603021005',
    districtId: '3603021',
    name: 'Ancol Pasir',
  },
  {
    id: '3603021006',
    districtId: '3603021',
    name: 'Rancabuaya',
  },
  {
    id: '3603021007',
    districtId: '3603021',
    name: 'Tiparraya',
  },
  {
    id: '3603021008',
    districtId: '3603021',
    name: 'Jambe',
  },
  {
    id: '3603021010',
    districtId: '3603021',
    name: 'Pasir Barat',
  },
  {
    id: '3603030001',
    districtId: '3603030',
    name: 'Budi Mulya',
  },
  {
    id: '3603030002',
    districtId: '3603030',
    name: 'Bojong',
  },
  {
    id: '3603030003',
    districtId: '3603030',
    name: 'Suka Mulya',
  },
  {
    id: '3603030004',
    districtId: '3603030',
    name: 'Cikupa',
  },
  {
    id: '3603030006',
    districtId: '3603030',
    name: 'Bitung Jaya',
  },
  {
    id: '3603030008',
    districtId: '3603030',
    name: 'Suka Damai',
  },
  {
    id: '3603030009',
    districtId: '3603030',
    name: 'Pasir Jaya',
  },
  {
    id: '3603030010',
    districtId: '3603030',
    name: 'Pasir Gadung',
  },
  {
    id: '3603030011',
    districtId: '3603030',
    name: 'Talaga Sari',
  },
  {
    id: '3603030012',
    districtId: '3603030',
    name: 'Talaga',
  },
  {
    id: '3603030013',
    districtId: '3603030',
    name: 'Suka Nagara',
  },
  {
    id: '3603030014',
    districtId: '3603030',
    name: 'Cibadak',
  },
  {
    id: '3603040001',
    districtId: '3603040',
    name: 'Ranca Iyuh',
  },
  {
    id: '3603040002',
    districtId: '3603040',
    name: 'Mekar Jaya',
  },
  {
    id: '3603040003',
    districtId: '3603040',
    name: 'Ranca Kalapa',
  },
  {
    id: '3603040004',
    districtId: '3603040',
    name: 'Panongan',
  },
  {
    id: '3603040005',
    districtId: '3603040',
    name: 'Serdang Kulon',
  },
  {
    id: '3603040006',
    districtId: '3603040',
    name: 'Ciakar',
  },
  {
    id: '3603040007',
    districtId: '3603040',
    name: 'Mekar Bakti',
  },
  {
    id: '3603040008',
    districtId: '3603040',
    name: 'Peusar',
  },
  {
    id: '3603050001',
    districtId: '3603050',
    name: 'Curug Kulon',
  },
  {
    id: '3603050002',
    districtId: '3603050',
    name: 'Curug Wetan',
  },
  {
    id: '3603050003',
    districtId: '3603050',
    name: 'Suka Bakti',
  },
  {
    id: '3603050004',
    districtId: '3603050',
    name: 'Cukang Galih',
  },
  {
    id: '3603050005',
    districtId: '3603050',
    name: 'Kadu Jaya',
  },
  {
    id: '3603050006',
    districtId: '3603050',
    name: 'Kadu',
  },
  {
    id: '3603050007',
    districtId: '3603050',
    name: 'Binong',
  },
  {
    id: '3603051001',
    districtId: '3603051',
    name: 'Bojong Nangka',
  },
  {
    id: '3603051002',
    districtId: '3603051',
    name: 'Curug Sangereng',
  },
  {
    id: '3603051003',
    districtId: '3603051',
    name: 'Pakulonan Barat',
  },
  {
    id: '3603051004',
    districtId: '3603051',
    name: 'Kelapa Dua',
  },
  {
    id: '3603051005',
    districtId: '3603051',
    name: 'Bencongan Indah',
  },
  {
    id: '3603051006',
    districtId: '3603051',
    name: 'Bencongan',
  },
  {
    id: '3603060001',
    districtId: '3603060',
    name: 'Ciangir',
  },
  {
    id: '3603060002',
    districtId: '3603060',
    name: 'Babat',
  },
  {
    id: '3603060003',
    districtId: '3603060',
    name: 'Bojong Kamal',
  },
  {
    id: '3603060004',
    districtId: '3603060',
    name: 'Cirarab',
  },
  {
    id: '3603060005',
    districtId: '3603060',
    name: 'Caringin',
  },
  {
    id: '3603060006',
    districtId: '3603060',
    name: 'Babakan',
  },
  {
    id: '3603060007',
    districtId: '3603060',
    name: 'Kamuning',
  },
  {
    id: '3603060008',
    districtId: '3603060',
    name: 'Pala Sari',
  },
  {
    id: '3603060009',
    districtId: '3603060',
    name: 'Serdang Wetan',
  },
  {
    id: '3603060010',
    districtId: '3603060',
    name: 'Rancagong',
  },
  {
    id: '3603060011',
    districtId: '3603060',
    name: 'Legok',
  },
  {
    id: '3603070001',
    districtId: '3603070',
    name: 'Karang Tengah',
  },
  {
    id: '3603070002',
    districtId: '3603070',
    name: 'Malang Nengah',
  },
  {
    id: '3603070003',
    districtId: '3603070',
    name: 'Jatake',
  },
  {
    id: '3603070004',
    districtId: '3603070',
    name: 'Kadu Sirung',
  },
  {
    id: '3603070005',
    districtId: '3603070',
    name: 'Situ Gadung',
  },
  {
    id: '3603070006',
    districtId: '3603070',
    name: 'Pagedangan',
  },
  {
    id: '3603070007',
    districtId: '3603070',
    name: 'Cicalengka',
  },
  {
    id: '3603070008',
    districtId: '3603070',
    name: 'Lengkong Kulon',
  },
  {
    id: '3603070009',
    districtId: '3603070',
    name: 'Cijantra',
  },
  {
    id: '3603070010',
    districtId: '3603070',
    name: 'Medang',
  },
  {
    id: '3603070012',
    districtId: '3603070',
    name: 'Cihuni',
  },
  {
    id: '3603081001',
    districtId: '3603081',
    name: 'Mekarwangi',
  },
  {
    id: '3603081002',
    districtId: '3603081',
    name: 'Dangdang',
  },
  {
    id: '3603081003',
    districtId: '3603081',
    name: 'Suradita',
  },
  {
    id: '3603081004',
    districtId: '3603081',
    name: 'Cisauk',
  },
  {
    id: '3603081005',
    districtId: '3603081',
    name: 'Sampora',
  },
  {
    id: '3603081006',
    districtId: '3603081',
    name: 'Cibogo',
  },
  {
    id: '3603120004',
    districtId: '3603120',
    name: 'Sukaasih',
  },
  {
    id: '3603120005',
    districtId: '3603120',
    name: 'Pasar Kemis',
  },
  {
    id: '3603120006',
    districtId: '3603120',
    name: 'Sukamantri',
  },
  {
    id: '3603120007',
    districtId: '3603120',
    name: 'Kuta Jaya',
  },
  {
    id: '3603120008',
    districtId: '3603120',
    name: 'Gelam Jaya',
  },
  {
    id: '3603120009',
    districtId: '3603120',
    name: 'Kuta Baru',
  },
  {
    id: '3603120010',
    districtId: '3603120',
    name: 'Kuta Bumi',
  },
  {
    id: '3603120011',
    districtId: '3603120',
    name: 'Pangadegan',
  },
  {
    id: '3603120012',
    districtId: '3603120',
    name: 'Sindang Sari',
  },
  {
    id: '3603121001',
    districtId: '3603121',
    name: 'Wana Kerta',
  },
  {
    id: '3603121002',
    districtId: '3603121',
    name: 'Suka Harja',
  },
  {
    id: '3603121003',
    districtId: '3603121',
    name: 'Sindang Panon',
  },
  {
    id: '3603121004',
    districtId: '3603121',
    name: 'Sindang Jaya',
  },
  {
    id: '3603121005',
    districtId: '3603121',
    name: 'Sindang Asih',
  },
  {
    id: '3603121006',
    districtId: '3603121',
    name: 'Sindang Sono',
  },
  {
    id: '3603121007',
    districtId: '3603121',
    name: 'Badak Anom',
  },
  {
    id: '3603130001',
    districtId: '3603130',
    name: 'Gembong',
  },
  {
    id: '3603130002',
    districtId: '3603130',
    name: 'Cangkudu',
  },
  {
    id: '3603130004',
    districtId: '3603130',
    name: 'Sentul Jaya',
  },
  {
    id: '3603130005',
    districtId: '3603130',
    name: 'Talagasari',
  },
  {
    id: '3603130006',
    districtId: '3603130',
    name: 'Bala Raja',
  },
  {
    id: '3603130007',
    districtId: '3603130',
    name: 'Tobat',
  },
  {
    id: '3603130008',
    districtId: '3603130',
    name: 'Suka Murni',
  },
  {
    id: '3603130015',
    districtId: '3603130',
    name: 'Saga',
  },
  {
    id: '3603131001',
    districtId: '3603131',
    name: 'Jayanti',
  },
  {
    id: '3603131002',
    districtId: '3603131',
    name: 'Pasir Muncang',
  },
  {
    id: '3603131003',
    districtId: '3603131',
    name: 'Sumur Bandung',
  },
  {
    id: '3603131004',
    districtId: '3603131',
    name: 'Cikande',
  },
  {
    id: '3603131005',
    districtId: '3603131',
    name: 'Pasir Gintung',
  },
  {
    id: '3603131006',
    districtId: '3603131',
    name: 'Pangkat',
  },
  {
    id: '3603131007',
    districtId: '3603131',
    name: 'Dang Deur',
  },
  {
    id: '3603131008',
    districtId: '3603131',
    name: 'Pabuaran',
  },
  {
    id: '3603132001',
    districtId: '3603132',
    name: 'Kubang',
  },
  {
    id: '3603132002',
    districtId: '3603132',
    name: 'Parahu',
  },
  {
    id: '3603132003',
    districtId: '3603132',
    name: 'Suka Mulya',
  },
  {
    id: '3603132004',
    districtId: '3603132',
    name: 'Kali Asin',
  },
  {
    id: '3603132005',
    districtId: '3603132',
    name: 'Merak',
  },
  {
    id: '3603132006',
    districtId: '3603132',
    name: 'Bunar',
  },
  {
    id: '3603132007',
    districtId: '3603132',
    name: 'Benda',
  },
  {
    id: '3603132008',
    districtId: '3603132',
    name: 'Buni Ayu',
  },
  {
    id: '3603140001',
    districtId: '3603140',
    name: 'Koper',
  },
  {
    id: '3603140002',
    districtId: '3603140',
    name: 'Pasir Ampo',
  },
  {
    id: '3603140003',
    districtId: '3603140',
    name: 'Patra Sana',
  },
  {
    id: '3603140005',
    districtId: '3603140',
    name: 'Talok',
  },
  {
    id: '3603140006',
    districtId: '3603140',
    name: 'Jengkol',
  },
  {
    id: '3603140007',
    districtId: '3603140',
    name: 'Kemuning',
  },
  {
    id: '3603140008',
    districtId: '3603140',
    name: 'Ranca Ilat',
  },
  {
    id: '3603141001',
    districtId: '3603141',
    name: 'Kanda Wati',
  },
  {
    id: '3603141002',
    districtId: '3603141',
    name: 'Cibetok',
  },
  {
    id: '3603141003',
    districtId: '3603141',
    name: 'Tamiang',
  },
  {
    id: '3603141004',
    districtId: '3603141',
    name: 'Cipaeh',
  },
  {
    id: '3603141006',
    districtId: '3603141',
    name: 'Onyam',
  },
  {
    id: '3603141007',
    districtId: '3603141',
    name: 'Gunung Kaler',
  },
  {
    id: '3603141008',
    districtId: '3603141',
    name: 'Sidoko',
  },
  {
    id: '3603141009',
    districtId: '3603141',
    name: 'Ranca Gede',
  },
  {
    id: '3603150003',
    districtId: '3603150',
    name: 'Bakung',
  },
  {
    id: '3603150004',
    districtId: '3603150',
    name: 'Pasir',
  },
  {
    id: '3603150005',
    districtId: '3603150',
    name: 'Cirumpak',
  },
  {
    id: '3603150006',
    districtId: '3603150',
    name: 'Pagedangan Udik',
  },
  {
    id: '3603150007',
    districtId: '3603150',
    name: 'Pasilian',
  },
  {
    id: '3603150008',
    districtId: '3603150',
    name: 'Pagenjahan',
  },
  {
    id: '3603150017',
    districtId: '3603150',
    name: 'Kronjo',
  },
  {
    id: '3603150018',
    districtId: '3603150',
    name: 'Pagedangan Ilir',
  },
  {
    id: '3603151001',
    districtId: '3603151',
    name: 'Ganda Ria',
  },
  {
    id: '3603151002',
    districtId: '3603151',
    name: 'Kosambi Dalam',
  },
  {
    id: '3603151004',
    districtId: '3603151',
    name: 'Mekar Baru',
  },
  {
    id: '3603151005',
    districtId: '3603151',
    name: 'Waliwis',
  },
  {
    id: '3603151006',
    districtId: '3603151',
    name: 'Cijeruk',
  },
  {
    id: '3603151007',
    districtId: '3603151',
    name: 'Kedaung',
  },
  {
    id: '3603151008',
    districtId: '3603151',
    name: 'Jenggot',
  },
  {
    id: '3603160007',
    districtId: '3603160',
    name: 'Gunung Sari',
  },
  {
    id: '3603160008',
    districtId: '3603160',
    name: 'Sasak',
  },
  {
    id: '3603160009',
    districtId: '3603160',
    name: 'Kedung Dalem',
  },
  {
    id: '3603160010',
    districtId: '3603160',
    name: 'Tegal Kunir Kidul',
  },
  {
    id: '3603160011',
    districtId: '3603160',
    name: 'Jati Waringin',
  },
  {
    id: '3603160019',
    districtId: '3603160',
    name: 'Tegal Kunir Lor',
  },
  {
    id: '3603160020',
    districtId: '3603160',
    name: 'Banyu Asih',
  },
  {
    id: '3603160021',
    districtId: '3603160',
    name: 'Mauk Timur',
  },
  {
    id: '3603160022',
    districtId: '3603160',
    name: 'Mauk Barat',
  },
  {
    id: '3603160023',
    districtId: '3603160',
    name: 'Ketapang',
  },
  {
    id: '3603160024',
    districtId: '3603160',
    name: 'Marga Mulya',
  },
  {
    id: '3603160025',
    districtId: '3603160',
    name: 'Tanjung Anom',
  },
  {
    id: '3603161001',
    districtId: '3603161',
    name: 'Legok Sukamaju',
  },
  {
    id: '3603161002',
    districtId: '3603161',
    name: 'Ranca Labuh',
  },
  {
    id: '3603161003',
    districtId: '3603161',
    name: 'Kemiri',
  },
  {
    id: '3603161005',
    districtId: '3603161',
    name: 'Patra Manggala',
  },
  {
    id: '3603161006',
    districtId: '3603161',
    name: 'Karang Anyar',
  },
  {
    id: '3603161007',
    districtId: '3603161',
    name: 'Lontar',
  },
  {
    id: '3603162001',
    districtId: '3603162',
    name: 'Buaran Jati',
  },
  {
    id: '3603162002',
    districtId: '3603162',
    name: 'Gintung',
  },
  {
    id: '3603162003',
    districtId: '3603162',
    name: 'Kosambi',
  },
  {
    id: '3603162004',
    districtId: '3603162',
    name: 'Mekar Kondang',
  },
  {
    id: '3603162005',
    districtId: '3603162',
    name: 'Pekayon',
  },
  {
    id: '3603162006',
    districtId: '3603162',
    name: 'Sukadiri',
  },
  {
    id: '3603162007',
    districtId: '3603162',
    name: 'Rawa Kidang',
  },
  {
    id: '3603162008',
    districtId: '3603162',
    name: 'Karang Serang',
  },
  {
    id: '3603170002',
    districtId: '3603170',
    name: 'Jambu Karya',
  },
  {
    id: '3603170003',
    districtId: '3603170',
    name: 'Daon',
  },
  {
    id: '3603170004',
    districtId: '3603170',
    name: 'Suka Tani',
  },
  {
    id: '3603170005',
    districtId: '3603170',
    name: 'Mekarsari',
  },
  {
    id: '3603170006',
    districtId: '3603170',
    name: 'Suka Sari',
  },
  {
    id: '3603170007',
    districtId: '3603170',
    name: 'Rajegmulya',
  },
  {
    id: '3603170008',
    districtId: '3603170',
    name: 'Rajeg',
  },
  {
    id: '3603170009',
    districtId: '3603170',
    name: 'Suka Manah',
  },
  {
    id: '3603170010',
    districtId: '3603170',
    name: 'Pangarengan',
  },
  {
    id: '3603170011',
    districtId: '3603170',
    name: 'Ranca Bango',
  },
  {
    id: '3603170012',
    districtId: '3603170',
    name: 'Lembang Sari',
  },
  {
    id: '3603170013',
    districtId: '3603170',
    name: 'Tanjakan',
  },
  {
    id: '3603170014',
    districtId: '3603170',
    name: 'Tanjakan Mekar',
  },
  {
    id: '3603180001',
    districtId: '3603180',
    name: 'Mekar Jaya',
  },
  {
    id: '3603180002',
    districtId: '3603180',
    name: 'Karet',
  },
  {
    id: '3603180007',
    districtId: '3603180',
    name: 'Pondok Jaya',
  },
  {
    id: '3603180008',
    districtId: '3603180',
    name: 'Sepatan',
  },
  {
    id: '3603180009',
    districtId: '3603180',
    name: 'Pisangan Jaya',
  },
  {
    id: '3603180010',
    districtId: '3603180',
    name: 'Sarakan',
  },
  {
    id: '3603180011',
    districtId: '3603180',
    name: 'Kayu Bongkok',
  },
  {
    id: '3603180012',
    districtId: '3603180',
    name: 'Kayu Agung',
  },
  {
    id: '3603181001',
    districtId: '3603181',
    name: 'Lebak Wangi',
  },
  {
    id: '3603181002',
    districtId: '3603181',
    name: 'Kedaung Barat',
  },
  {
    id: '3603181003',
    districtId: '3603181',
    name: 'Jati Mulya',
  },
  {
    id: '3603181004',
    districtId: '3603181',
    name: 'Tanah Merah',
  },
  {
    id: '3603181005',
    districtId: '3603181',
    name: 'Sangiang',
  },
  {
    id: '3603181006',
    districtId: '3603181',
    name: 'Gempol Sari',
  },
  {
    id: '3603181007',
    districtId: '3603181',
    name: 'Pondok Kelor',
  },
  {
    id: '3603181008',
    districtId: '3603181',
    name: 'Kampung Kelor',
  },
  {
    id: '3603190001',
    districtId: '3603190',
    name: 'Bunisari',
  },
  {
    id: '3603190002',
    districtId: '3603190',
    name: 'Rawa Boni',
  },
  {
    id: '3603190003',
    districtId: '3603190',
    name: 'Kiara Payung',
  },
  {
    id: '3603190004',
    districtId: '3603190',
    name: 'Gaga',
  },
  {
    id: '3603190005',
    districtId: '3603190',
    name: 'Laksana',
  },
  {
    id: '3603190006',
    districtId: '3603190',
    name: 'Buaran Bambu',
  },
  {
    id: '3603190007',
    districtId: '3603190',
    name: 'Paku Haji',
  },
  {
    id: '3603190008',
    districtId: '3603190',
    name: 'Paku Alam',
  },
  {
    id: '3603190009',
    districtId: '3603190',
    name: 'Buaran Mangga',
  },
  {
    id: '3603190010',
    districtId: '3603190',
    name: 'Surya Bahari',
  },
  {
    id: '3603190011',
    districtId: '3603190',
    name: 'Sukawali',
  },
  {
    id: '3603190012',
    districtId: '3603190',
    name: 'Kramat',
  },
  {
    id: '3603190013',
    districtId: '3603190',
    name: 'Kalibaru',
  },
  {
    id: '3603190014',
    districtId: '3603190',
    name: 'Kohod',
  },
  {
    id: '3603200001',
    districtId: '3603200',
    name: 'Bojong Renged',
  },
  {
    id: '3603200002',
    districtId: '3603200',
    name: 'Kebon Cau',
  },
  {
    id: '3603200003',
    districtId: '3603200',
    name: 'Teluk Naga',
  },
  {
    id: '3603200004',
    districtId: '3603200',
    name: 'Babakan Asem',
  },
  {
    id: '3603200005',
    districtId: '3603200',
    name: 'Kampung Melayu Timur',
  },
  {
    id: '3603200006',
    districtId: '3603200',
    name: 'Kampung Melayu Barat',
  },
  {
    id: '3603200007',
    districtId: '3603200',
    name: 'Kampung Besar',
  },
  {
    id: '3603200008',
    districtId: '3603200',
    name: 'L E M O',
  },
  {
    id: '3603200009',
    districtId: '3603200',
    name: 'Tegal Angus',
  },
  {
    id: '3603200010',
    districtId: '3603200',
    name: 'Pangkalan',
  },
  {
    id: '3603200011',
    districtId: '3603200',
    name: 'Tanjung Burung',
  },
  {
    id: '3603200012',
    districtId: '3603200',
    name: 'Tanjung Pasir',
  },
  {
    id: '3603200013',
    districtId: '3603200',
    name: 'Muara',
  },
  {
    id: '3603210001',
    districtId: '3603210',
    name: 'Rawa Rengas',
  },
  {
    id: '3603210002',
    districtId: '3603210',
    name: 'Rawa Burung',
  },
  {
    id: '3603210003',
    districtId: '3603210',
    name: 'Belimbing',
  },
  {
    id: '3603210004',
    districtId: '3603210',
    name: 'Jatimulya',
  },
  {
    id: '3603210005',
    districtId: '3603210',
    name: 'D A D A P',
  },
  {
    id: '3603210006',
    districtId: '3603210',
    name: 'Kosambi Timur',
  },
  {
    id: '3603210007',
    districtId: '3603210',
    name: 'Kosambi Barat',
  },
  {
    id: '3603210008',
    districtId: '3603210',
    name: 'Cengklong',
  },
  {
    id: '3603210009',
    districtId: '3603210',
    name: 'Salembaran Jati',
  },
  {
    id: '3603210010',
    districtId: '3603210',
    name: 'Salembaran',
  },
  {
    id: '3604010001',
    districtId: '3604010',
    name: 'Umbul Tanjung',
  },
  {
    id: '3604010002',
    districtId: '3604010',
    name: 'Pasauran',
  },
  {
    id: '3604010003',
    districtId: '3604010',
    name: 'Bantarwangi',
  },
  {
    id: '3604010004',
    districtId: '3604010',
    name: 'Bantarwaru',
  },
  {
    id: '3604010005',
    districtId: '3604010',
    name: 'Bulakan',
  },
  {
    id: '3604010006',
    districtId: '3604010',
    name: 'Karang Suraga',
  },
  {
    id: '3604010007',
    districtId: '3604010',
    name: 'Cinangka',
  },
  {
    id: '3604010008',
    districtId: '3604010',
    name: 'Kubang Baros',
  },
  {
    id: '3604010009',
    districtId: '3604010',
    name: 'Rancasanggal',
  },
  {
    id: '3604010010',
    districtId: '3604010',
    name: 'Cikolelet',
  },
  {
    id: '3604010011',
    districtId: '3604010',
    name: 'Mekarsari',
  },
  {
    id: '3604010012',
    districtId: '3604010',
    name: 'Sindanglaya',
  },
  {
    id: '3604010013',
    districtId: '3604010',
    name: 'Kamasan',
  },
  {
    id: '3604010014',
    districtId: '3604010',
    name: 'Baros Jaya',
  },
  {
    id: '3604020001',
    districtId: '3604020',
    name: 'Cibojong',
  },
  {
    id: '3604020002',
    districtId: '3604020',
    name: 'Kramatlaban',
  },
  {
    id: '3604020003',
    districtId: '3604020',
    name: 'Kadubeureum',
  },
  {
    id: '3604020004',
    districtId: '3604020',
    name: 'Padarincang',
  },
  {
    id: '3604020006',
    districtId: '3604020',
    name: 'Kalumpang',
  },
  {
    id: '3604020007',
    districtId: '3604020',
    name: 'Citasuk',
  },
  {
    id: '3604020008',
    districtId: '3604020',
    name: 'Batukuwung',
  },
  {
    id: '3604020009',
    districtId: '3604020',
    name: 'Curug Goong',
  },
  {
    id: '3604020010',
    districtId: '3604020',
    name: 'Cisaat',
  },
  {
    id: '3604020011',
    districtId: '3604020',
    name: 'Cipayung',
  },
  {
    id: '3604020012',
    districtId: '3604020',
    name: 'Ciomas',
  },
  {
    id: '3604020013',
    districtId: '3604020',
    name: 'Barugbug',
  },
  {
    id: '3604020014',
    districtId: '3604020',
    name: 'Kadukempong',
  },
  {
    id: '3604030002',
    districtId: '3604030',
    name: 'Cisitu',
  },
  {
    id: '3604030003',
    districtId: '3604030',
    name: 'Siketug',
  },
  {
    id: '3604030004',
    districtId: '3604030',
    name: 'Lebak',
  },
  {
    id: '3604030005',
    districtId: '3604030',
    name: 'Citaman',
  },
  {
    id: '3604030006',
    districtId: '3604030',
    name: 'Pondok Kahuru',
  },
  {
    id: '3604030007',
    districtId: '3604030',
    name: 'Sukadana',
  },
  {
    id: '3604030008',
    districtId: '3604030',
    name: 'Sukabares',
  },
  {
    id: '3604030009',
    districtId: '3604030',
    name: 'Sukarena',
  },
  {
    id: '3604030010',
    districtId: '3604030',
    name: 'Cemplang',
  },
  {
    id: '3604030011',
    districtId: '3604030',
    name: 'Panyaungan Jaya',
  },
  {
    id: '3604040001',
    districtId: '3604040',
    name: 'Tanjungsari',
  },
  {
    id: '3604040002',
    districtId: '3604040',
    name: 'Kadubeureum',
  },
  {
    id: '3604040003',
    districtId: '3604040',
    name: 'Pasanggrahan',
  },
  {
    id: '3604040004',
    districtId: '3604040',
    name: 'Pabuaran',
  },
  {
    id: '3604040005',
    districtId: '3604040',
    name: 'Pancanegara',
  },
  {
    id: '3604040006',
    districtId: '3604040',
    name: 'Sindangheula',
  },
  {
    id: '3604040007',
    districtId: '3604040',
    name: 'Sindangsari',
  },
  {
    id: '3604040008',
    districtId: '3604040',
    name: 'Talaga Warna',
  },
  {
    id: '3604041001',
    districtId: '3604041',
    name: 'Ciherang',
  },
  {
    id: '3604041002',
    districtId: '3604041',
    name: 'Gunungsari',
  },
  {
    id: '3604041003',
    districtId: '3604041',
    name: 'Tamiang',
  },
  {
    id: '3604041004',
    districtId: '3604041',
    name: 'Sukalaba',
  },
  {
    id: '3604041005',
    districtId: '3604041',
    name: 'Kadu Agung',
  },
  {
    id: '3604041007',
    districtId: '3604041',
    name: 'Curug Sulanjana',
  },
  {
    id: '3604050001',
    districtId: '3604050',
    name: 'Sukacai',
  },
  {
    id: '3604050002',
    districtId: '3604050',
    name: 'Sukamenak',
  },
  {
    id: '3604050003',
    districtId: '3604050',
    name: 'Tejamari',
  },
  {
    id: '3604050004',
    districtId: '3604050',
    name: 'Panyirapan',
  },
  {
    id: '3604050005',
    districtId: '3604050',
    name: 'Tamansari',
  },
  {
    id: '3604050006',
    districtId: '3604050',
    name: 'Sindangmandi',
  },
  {
    id: '3604050007',
    districtId: '3604050',
    name: 'Curug Agung',
  },
  {
    id: '3604050008',
    districtId: '3604050',
    name: 'Sukamanah',
  },
  {
    id: '3604050009',
    districtId: '3604050',
    name: 'Padasuka',
  },
  {
    id: '3604050010',
    districtId: '3604050',
    name: 'Sinarmukti',
  },
  {
    id: '3604050011',
    districtId: '3604050',
    name: 'Sidamukti',
  },
  {
    id: '3604050012',
    districtId: '3604050',
    name: 'Baros',
  },
  {
    id: '3604050013',
    districtId: '3604050',
    name: 'Cisalam',
  },
  {
    id: '3604050014',
    districtId: '3604050',
    name: 'Suka Indah',
  },
  {
    id: '3604060009',
    districtId: '3604060',
    name: 'Kadugenep',
  },
  {
    id: '3604060010',
    districtId: '3604060',
    name: 'Padasuka',
  },
  {
    id: '3604060011',
    districtId: '3604060',
    name: 'Sanding',
  },
  {
    id: '3604060012',
    districtId: '3604060',
    name: 'Sindangsari',
  },
  {
    id: '3604060013',
    districtId: '3604060',
    name: 'Cireundeu',
  },
  {
    id: '3604060014',
    districtId: '3604060',
    name: 'Cirangkong',
  },
  {
    id: '3604060015',
    districtId: '3604060',
    name: 'Tambiluk',
  },
  {
    id: '3604060016',
    districtId: '3604060',
    name: 'Mekarbaru',
  },
  {
    id: '3604060017',
    districtId: '3604060',
    name: 'Petir',
  },
  {
    id: '3604060018',
    districtId: '3604060',
    name: 'Nagara Padang',
  },
  {
    id: '3604060019',
    districtId: '3604060',
    name: 'Kampung Baru',
  },
  {
    id: '3604060020',
    districtId: '3604060',
    name: 'Seuat',
  },
  {
    id: '3604060021',
    districtId: '3604060',
    name: 'Seuat Jaya',
  },
  {
    id: '3604060022',
    districtId: '3604060',
    name: 'Kubang Jaya',
  },
  {
    id: '3604060023',
    districtId: '3604060',
    name: 'Bojong Nangka',
  },
  {
    id: '3604061001',
    districtId: '3604061',
    name: 'Panunggulan',
  },
  {
    id: '3604061002',
    districtId: '3604061',
    name: 'Sukasari',
  },
  {
    id: '3604061003',
    districtId: '3604061',
    name: 'Bojong Menteng',
  },
  {
    id: '3604061004',
    districtId: '3604061',
    name: 'Kamuning',
  },
  {
    id: '3604061005',
    districtId: '3604061',
    name: 'Bojong Pandan',
  },
  {
    id: '3604061006',
    districtId: '3604061',
    name: 'Bojong Catang',
  },
  {
    id: '3604061007',
    districtId: '3604061',
    name: 'Malanggah',
  },
  {
    id: '3604061008',
    districtId: '3604061',
    name: 'Tunjung Jaya',
  },
  {
    id: '3604061009',
    districtId: '3604061',
    name: 'Pancaregang',
  },
  {
    id: '3604080001',
    districtId: '3604080',
    name: 'Panyabrangan',
  },
  {
    id: '3604080002',
    districtId: '3604080',
    name: 'Dahu',
  },
  {
    id: '3604080003',
    districtId: '3604080',
    name: 'Bantar Panjang',
  },
  {
    id: '3604080004',
    districtId: '3604080',
    name: 'Katulisan',
  },
  {
    id: '3604080005',
    districtId: '3604080',
    name: 'Panosogan',
  },
  {
    id: '3604080006',
    districtId: '3604080',
    name: 'Cikeusal',
  },
  {
    id: '3604080007',
    districtId: '3604080',
    name: 'Sukamaju',
  },
  {
    id: '3604080008',
    districtId: '3604080',
    name: 'Harundang',
  },
  {
    id: '3604080009',
    districtId: '3604080',
    name: 'Gandayasa',
  },
  {
    id: '3604080010',
    districtId: '3604080',
    name: 'Mongpok',
  },
  {
    id: '3604080011',
    districtId: '3604080',
    name: 'Sukarame',
  },
  {
    id: '3604080012',
    districtId: '3604080',
    name: 'Cilayang',
  },
  {
    id: '3604080013',
    districtId: '3604080',
    name: 'Sukaratu',
  },
  {
    id: '3604080014',
    districtId: '3604080',
    name: 'Sukamenak',
  },
  {
    id: '3604080015',
    districtId: '3604080',
    name: 'Cimaung',
  },
  {
    id: '3604080016',
    districtId: '3604080',
    name: 'Sukaraja',
  },
  {
    id: '3604080017',
    districtId: '3604080',
    name: 'Cilayang Guha',
  },
  {
    id: '3604090001',
    districtId: '3604090',
    name: 'Wirana',
  },
  {
    id: '3604090002',
    districtId: '3604090',
    name: 'Sangiang',
  },
  {
    id: '3604090003',
    districtId: '3604090',
    name: 'Damping',
  },
  {
    id: '3604090004',
    districtId: '3604090',
    name: 'Kebon Cau',
  },
  {
    id: '3604090005',
    districtId: '3604090',
    name: 'Pudar',
  },
  {
    id: '3604090006',
    districtId: '3604090',
    name: 'Binong',
  },
  {
    id: '3604090007',
    districtId: '3604090',
    name: 'Pamarayan',
  },
  {
    id: '3604090008',
    districtId: '3604090',
    name: 'Kampung Baru',
  },
  {
    id: '3604090010',
    districtId: '3604090',
    name: 'Pasirlimus',
  },
  {
    id: '3604090011',
    districtId: '3604090',
    name: 'Pasir Kembang',
  },
  {
    id: '3604091001',
    districtId: '3604091',
    name: 'Pangawinan',
  },
  {
    id: '3604091002',
    districtId: '3604091',
    name: 'Mander',
  },
  {
    id: '3604091003',
    districtId: '3604091',
    name: 'Panamping',
  },
  {
    id: '3604091004',
    districtId: '3604091',
    name: 'Bandung',
  },
  {
    id: '3604091005',
    districtId: '3604091',
    name: 'Malabar',
  },
  {
    id: '3604091006',
    districtId: '3604091',
    name: 'Blokang',
  },
  {
    id: '3604091007',
    districtId: '3604091',
    name: 'Babakan',
  },
  {
    id: '3604091008',
    districtId: '3604091',
    name: 'Pringwulung',
  },
  {
    id: '3604100001',
    districtId: '3604100',
    name: 'Pagintungan',
  },
  {
    id: '3604100002',
    districtId: '3604100',
    name: 'Cemplang',
  },
  {
    id: '3604100003',
    districtId: '3604100',
    name: 'Bojot',
  },
  {
    id: '3604100004',
    districtId: '3604100',
    name: 'Jawilan',
  },
  {
    id: '3604100005',
    districtId: '3604100',
    name: 'Pasirbuyut',
  },
  {
    id: '3604100006',
    districtId: '3604100',
    name: 'Majasari',
  },
  {
    id: '3604100007',
    districtId: '3604100',
    name: 'Parakan',
  },
  {
    id: '3604100008',
    districtId: '3604100',
    name: 'Kareo',
  },
  {
    id: '3604100009',
    districtId: '3604100',
    name: 'Junti',
  },
  {
    id: '3604110001',
    districtId: '3604110',
    name: 'Nanggung',
  },
  {
    id: '3604110002',
    districtId: '3604110',
    name: 'Kopo',
  },
  {
    id: '3604110003',
    districtId: '3604110',
    name: 'Mekarbaru',
  },
  {
    id: '3604110004',
    districtId: '3604110',
    name: 'Garut',
  },
  {
    id: '3604110005',
    districtId: '3604110',
    name: 'Rancasumur',
  },
  {
    id: '3604110006',
    districtId: '3604110',
    name: 'Cidahu',
  },
  {
    id: '3604110007',
    districtId: '3604110',
    name: 'Nyompok',
  },
  {
    id: '3604110008',
    districtId: '3604110',
    name: 'Carenang Udik',
  },
  {
    id: '3604110009',
    districtId: '3604110',
    name: 'Babakan Jaya',
  },
  {
    id: '3604110010',
    districtId: '3604110',
    name: 'Gabus',
  },
  {
    id: '3604120001',
    districtId: '3604120',
    name: 'Nambo Udik',
  },
  {
    id: '3604120002',
    districtId: '3604120',
    name: 'Situterate',
  },
  {
    id: '3604120003',
    districtId: '3604120',
    name: 'Cikande',
  },
  {
    id: '3604120004',
    districtId: '3604120',
    name: 'Leuwilimus',
  },
  {
    id: '3604120005',
    districtId: '3604120',
    name: 'Parigi',
  },
  {
    id: '3604120006',
    districtId: '3604120',
    name: 'Songgom Jaya',
  },
  {
    id: '3604120007',
    districtId: '3604120',
    name: 'Koper',
  },
  {
    id: '3604120008',
    districtId: '3604120',
    name: 'Kamurang',
  },
  {
    id: '3604120009',
    districtId: '3604120',
    name: 'Bakung',
  },
  {
    id: '3604120010',
    districtId: '3604120',
    name: 'Gembor Udik',
  },
  {
    id: '3604120011',
    districtId: '3604120',
    name: 'Julang',
  },
  {
    id: '3604120013',
    districtId: '3604120',
    name: 'Sukatani',
  },
  {
    id: '3604120014',
    districtId: '3604120',
    name: 'Cikande Permai',
  },
  {
    id: '3604121001',
    districtId: '3604121',
    name: 'Nagara',
  },
  {
    id: '3604121002',
    districtId: '3604121',
    name: 'Cijeruk',
  },
  {
    id: '3604121003',
    districtId: '3604121',
    name: 'Barengkok',
  },
  {
    id: '3604121004',
    districtId: '3604121',
    name: 'Nambo Ilir',
  },
  {
    id: '3604121005',
    districtId: '3604121',
    name: 'Kibin',
  },
  {
    id: '3604121006',
    districtId: '3604121',
    name: 'Tambak',
  },
  {
    id: '3604121007',
    districtId: '3604121',
    name: 'Ciagel',
  },
  {
    id: '3604121008',
    districtId: '3604121',
    name: 'Ketos',
  },
  {
    id: '3604121009',
    districtId: '3604121',
    name: 'Sukamaju',
  },
  {
    id: '3604130001',
    districtId: '3604130',
    name: 'Silebu',
  },
  {
    id: '3604130002',
    districtId: '3604130',
    name: 'Sukajadi',
  },
  {
    id: '3604130003',
    districtId: '3604130',
    name: 'Pematang',
  },
  {
    id: '3604130004',
    districtId: '3604130',
    name: 'Kramatjati',
  },
  {
    id: '3604130006',
    districtId: '3604130',
    name: 'Undar Andir',
  },
  {
    id: '3604130007',
    districtId: '3604130',
    name: 'Kendayakan',
  },
  {
    id: '3604130008',
    districtId: '3604130',
    name: 'Cisait',
  },
  {
    id: '3604130010',
    districtId: '3604130',
    name: 'Kragilan',
  },
  {
    id: '3604130011',
    districtId: '3604130',
    name: 'Tegalmaja',
  },
  {
    id: '3604130012',
    districtId: '3604130',
    name: 'Jeruktipis',
  },
  {
    id: '3604180001',
    districtId: '3604180',
    name: 'Sasahan',
  },
  {
    id: '3604180002',
    districtId: '3604180',
    name: 'Cokopsulanjana',
  },
  {
    id: '3604180003',
    districtId: '3604180',
    name: 'Telaga Luhur',
  },
  {
    id: '3604180004',
    districtId: '3604180',
    name: 'Binangun',
  },
  {
    id: '3604180005',
    districtId: '3604180',
    name: 'Kemuning',
  },
  {
    id: '3604180006',
    districtId: '3604180',
    name: 'Sukabares',
  },
  {
    id: '3604180007',
    districtId: '3604180',
    name: 'Sambilawang',
  },
  {
    id: '3604180008',
    districtId: '3604180',
    name: 'Melati',
  },
  {
    id: '3604180009',
    districtId: '3604180',
    name: 'Sampir',
  },
  {
    id: '3604180010',
    districtId: '3604180',
    name: 'Waringinkurung',
  },
  {
    id: '3604180011',
    districtId: '3604180',
    name: 'Sukadalem',
  },
  {
    id: '3604190001',
    districtId: '3604190',
    name: 'Cikedung',
  },
  {
    id: '3604190002',
    districtId: '3604190',
    name: 'Ciwarna',
  },
  {
    id: '3604190003',
    districtId: '3604190',
    name: 'Angsana',
  },
  {
    id: '3604190004',
    districtId: '3604190',
    name: 'Talaga',
  },
  {
    id: '3604190005',
    districtId: '3604190',
    name: 'Balekambang',
  },
  {
    id: '3604190006',
    districtId: '3604190',
    name: 'Labuhan',
  },
  {
    id: '3604190007',
    districtId: '3604190',
    name: 'Sangiang',
  },
  {
    id: '3604190008',
    districtId: '3604190',
    name: 'Pasirwaru',
  },
  {
    id: '3604190009',
    districtId: '3604190',
    name: 'Waringin',
  },
  {
    id: '3604190010',
    districtId: '3604190',
    name: 'Mancak',
  },
  {
    id: '3604190011',
    districtId: '3604190',
    name: 'Sigedong',
  },
  {
    id: '3604190012',
    districtId: '3604190',
    name: 'Batukuda',
  },
  {
    id: '3604190013',
    districtId: '3604190',
    name: 'Winong',
  },
  {
    id: '3604190014',
    districtId: '3604190',
    name: 'Bale Kencana',
  },
  {
    id: '3604200001',
    districtId: '3604200',
    name: 'Bandulu',
  },
  {
    id: '3604200002',
    districtId: '3604200',
    name: 'Sindangmandi',
  },
  {
    id: '3604200003',
    districtId: '3604200',
    name: 'Banjarsari',
  },
  {
    id: '3604200004',
    districtId: '3604200',
    name: 'Bunihara',
  },
  {
    id: '3604200005',
    districtId: '3604200',
    name: 'Tanjungmanis',
  },
  {
    id: '3604200006',
    districtId: '3604200',
    name: 'Cikoneng',
  },
  {
    id: '3604200007',
    districtId: '3604200',
    name: 'Anyar',
  },
  {
    id: '3604200008',
    districtId: '3604200',
    name: 'Kosambi Ronyok',
  },
  {
    id: '3604200009',
    districtId: '3604200',
    name: 'Sindangkarya',
  },
  {
    id: '3604200010',
    districtId: '3604200',
    name: 'Mekarsari',
  },
  {
    id: '3604200011',
    districtId: '3604200',
    name: 'Tambang Ayam',
  },
  {
    id: '3604200012',
    districtId: '3604200',
    name: 'Grogol Indah',
  },
  {
    id: '3604210001',
    districtId: '3604210',
    name: 'Wanakarta',
  },
  {
    id: '3604210002',
    districtId: '3604210',
    name: 'Kertasana',
  },
  {
    id: '3604210003',
    districtId: '3604210',
    name: 'Mangkunegara',
  },
  {
    id: '3604210004',
    districtId: '3604210',
    name: 'Karangkepuh',
  },
  {
    id: '3604210005',
    districtId: '3604210',
    name: 'Lambangsari',
  },
  {
    id: '3604210006',
    districtId: '3604210',
    name: 'Bojonegara',
  },
  {
    id: '3604210007',
    districtId: '3604210',
    name: 'Margagiri',
  },
  {
    id: '3604210008',
    districtId: '3604210',
    name: 'Ukirsari',
  },
  {
    id: '3604210009',
    districtId: '3604210',
    name: 'Pakuncen',
  },
  {
    id: '3604210010',
    districtId: '3604210',
    name: 'Pengarengan',
  },
  {
    id: '3604210011',
    districtId: '3604210',
    name: 'Mekar  Jaya',
  },
  {
    id: '3604211001',
    districtId: '3604211',
    name: 'Argawana',
  },
  {
    id: '3604211002',
    districtId: '3604211',
    name: 'Banyuwangi',
  },
  {
    id: '3604211003',
    districtId: '3604211',
    name: 'Margasari',
  },
  {
    id: '3604211004',
    districtId: '3604211',
    name: 'Puloampel',
  },
  {
    id: '3604211005',
    districtId: '3604211',
    name: 'Sumuranja',
  },
  {
    id: '3604211006',
    districtId: '3604211',
    name: 'Kedung Soka',
  },
  {
    id: '3604211007',
    districtId: '3604211',
    name: 'Mangunreja',
  },
  {
    id: '3604211008',
    districtId: '3604211',
    name: 'Salira',
  },
  {
    id: '3604211009',
    districtId: '3604211',
    name: 'Pulo Panjang',
  },
  {
    id: '3604220001',
    districtId: '3604220',
    name: 'Lebakwana',
  },
  {
    id: '3604220002',
    districtId: '3604220',
    name: 'Pelamunan',
  },
  {
    id: '3604220003',
    districtId: '3604220',
    name: 'Margasana',
  },
  {
    id: '3604220004',
    districtId: '3604220',
    name: 'Kramatwatu',
  },
  {
    id: '3604220005',
    districtId: '3604220',
    name: 'Pejaten',
  },
  {
    id: '3604220006',
    districtId: '3604220',
    name: 'Wanayasa',
  },
  {
    id: '3604220007',
    districtId: '3604220',
    name: 'Harjatani',
  },
  {
    id: '3604220008',
    districtId: '3604220',
    name: 'Serdang',
  },
  {
    id: '3604220009',
    districtId: '3604220',
    name: 'Toyomerto',
  },
  {
    id: '3604220010',
    districtId: '3604220',
    name: 'Pegadingan',
  },
  {
    id: '3604220011',
    districtId: '3604220',
    name: 'Pamengkang',
  },
  {
    id: '3604220012',
    districtId: '3604220',
    name: 'Tonjong',
  },
  {
    id: '3604220013',
    districtId: '3604220',
    name: 'Terate',
  },
  {
    id: '3604220014',
    districtId: '3604220',
    name: 'Teluk Terate',
  },
  {
    id: '3604220015',
    districtId: '3604220',
    name: 'Margatani',
  },
  {
    id: '3604240001',
    districtId: '3604240',
    name: 'Citerep',
  },
  {
    id: '3604240002',
    districtId: '3604240',
    name: 'Ranjeng',
  },
  {
    id: '3604240003',
    districtId: '3604240',
    name: 'Ciruas',
  },
  {
    id: '3604240004',
    districtId: '3604240',
    name: 'Kadikaran',
  },
  {
    id: '3604240005',
    districtId: '3604240',
    name: 'Singamerta',
  },
  {
    id: '3604240006',
    districtId: '3604240',
    name: 'Pulo',
  },
  {
    id: '3604240008',
    districtId: '3604240',
    name: 'Gosara',
  },
  {
    id: '3604240009',
    districtId: '3604240',
    name: 'Kepandean',
  },
  {
    id: '3604240010',
    districtId: '3604240',
    name: 'Pamong',
  },
  {
    id: '3604240011',
    districtId: '3604240',
    name: 'Cigelam',
  },
  {
    id: '3604240012',
    districtId: '3604240',
    name: 'Penggalang',
  },
  {
    id: '3604240013',
    districtId: '3604240',
    name: 'Bumijaya',
  },
  {
    id: '3604240015',
    districtId: '3604240',
    name: 'Keserangan',
  },
  {
    id: '3604240016',
    districtId: '3604240',
    name: 'Beberan',
  },
  {
    id: '3604240017',
    districtId: '3604240',
    name: 'Pelawad',
  },
  {
    id: '3604250001',
    districtId: '3604250',
    name: 'Sukajaya',
  },
  {
    id: '3604250002',
    districtId: '3604250',
    name: 'Sukanegara',
  },
  {
    id: '3604250007',
    districtId: '3604250',
    name: 'Kalapian',
  },
  {
    id: '3604250008',
    districtId: '3604250',
    name: 'Keserangan',
  },
  {
    id: '3604250009',
    districtId: '3604250',
    name: 'Pulo Kencana',
  },
  {
    id: '3604250010',
    districtId: '3604250',
    name: 'Linduk',
  },
  {
    id: '3604250011',
    districtId: '3604250',
    name: 'Kubang Puji',
  },
  {
    id: '3604250012',
    districtId: '3604250',
    name: 'Singarajan',
  },
  {
    id: '3604250013',
    districtId: '3604250',
    name: 'Pontang',
  },
  {
    id: '3604250014',
    districtId: '3604250',
    name: 'Wanayasa',
  },
  {
    id: '3604250015',
    districtId: '3604250',
    name: 'Domas',
  },
  {
    id: '3604251001',
    districtId: '3604251',
    name: 'Kebonratu',
  },
  {
    id: '3604251002',
    districtId: '3604251',
    name: 'Terasbendung',
  },
  {
    id: '3604251003',
    districtId: '3604251',
    name: 'Kamaruton',
  },
  {
    id: '3604251004',
    districtId: '3604251',
    name: 'Purwadadi',
  },
  {
    id: '3604251005',
    districtId: '3604251',
    name: 'Lebakwangi',
  },
  {
    id: '3604251006',
    districtId: '3604251',
    name: 'Tirem',
  },
  {
    id: '3604251007',
    districtId: '3604251',
    name: 'Lebak Kepuh',
  },
  {
    id: '3604251008',
    districtId: '3604251',
    name: 'Kencana Harapan',
  },
  {
    id: '3604251009',
    districtId: '3604251',
    name: 'Bolang',
  },
  {
    id: '3604251010',
    districtId: '3604251',
    name: 'Pegandikan',
  },
  {
    id: '3604260008',
    districtId: '3604260',
    name: 'Mandaya',
  },
  {
    id: '3604260009',
    districtId: '3604260',
    name: 'Teras',
  },
  {
    id: '3604260010',
    districtId: '3604260',
    name: 'Walikukun',
  },
  {
    id: '3604260011',
    districtId: '3604260',
    name: 'Panenjoan',
  },
  {
    id: '3604260012',
    districtId: '3604260',
    name: 'Mekarsari',
  },
  {
    id: '3604260013',
    districtId: '3604260',
    name: 'Pamanuk',
  },
  {
    id: '3604260014',
    districtId: '3604260',
    name: 'Carenang',
  },
  {
    id: '3604260015',
    districtId: '3604260',
    name: 'Ragasmesigit',
  },
  {
    id: '3604261001',
    districtId: '3604261',
    name: 'Gembor',
  },
  {
    id: '3604261003',
    districtId: '3604261',
    name: 'Cakung',
  },
  {
    id: '3604261004',
    districtId: '3604261',
    name: 'Lamaran',
  },
  {
    id: '3604261005',
    districtId: '3604261',
    name: 'Warakas',
  },
  {
    id: '3604261006',
    districtId: '3604261',
    name: 'Binuang',
  },
  {
    id: '3604261007',
    districtId: '3604261',
    name: 'Sukamampir',
  },
  {
    id: '3604270010',
    districtId: '3604270',
    name: 'Tengkurak',
  },
  {
    id: '3604270011',
    districtId: '3604270',
    name: 'Tirtayasa',
  },
  {
    id: '3604270012',
    districtId: '3604270',
    name: 'Laban',
  },
  {
    id: '3604270014',
    districtId: '3604270',
    name: 'Samparwadi',
  },
  {
    id: '3604270016',
    districtId: '3604270',
    name: 'Kebon',
  },
  {
    id: '3604270017',
    districtId: '3604270',
    name: 'Kebuyutan',
  },
  {
    id: '3604270018',
    districtId: '3604270',
    name: 'Kemanisan',
  },
  {
    id: '3604270019',
    districtId: '3604270',
    name: 'Pontang Legon',
  },
  {
    id: '3604270020',
    districtId: '3604270',
    name: 'Susukan',
  },
  {
    id: '3604270021',
    districtId: '3604270',
    name: 'Alang Alang',
  },
  {
    id: '3604270022',
    districtId: '3604270',
    name: 'Lontar',
  },
  {
    id: '3604270023',
    districtId: '3604270',
    name: 'Wargasara',
  },
  {
    id: '3604271001',
    districtId: '3604271',
    name: 'Siremen',
  },
  {
    id: '3604271002',
    districtId: '3604271',
    name: 'Cibodas',
  },
  {
    id: '3604271004',
    districtId: '3604271',
    name: 'Lempuyang',
  },
  {
    id: '3604271006',
    districtId: '3604271',
    name: 'Sukamanah',
  },
  {
    id: '3604271007',
    districtId: '3604271',
    name: 'Tanara',
  },
  {
    id: '3604271008',
    districtId: '3604271',
    name: 'Pedaleman',
  },
  {
    id: '3604271009',
    districtId: '3604271',
    name: 'Tenjo Ayu',
  },
  {
    id: '3671010001',
    districtId: '3671010',
    name: 'Tajur',
  },
  {
    id: '3671010002',
    districtId: '3671010',
    name: 'Parung Serab',
  },
  {
    id: '3671010003',
    districtId: '3671010',
    name: 'Paninggilan',
  },
  {
    id: '3671010012',
    districtId: '3671010',
    name: 'Paninggilan Utara',
  },
  {
    id: '3671010013',
    districtId: '3671010',
    name: 'Sudimara Selatan',
  },
  {
    id: '3671010014',
    districtId: '3671010',
    name: 'Sudimara Barat',
  },
  {
    id: '3671010015',
    districtId: '3671010',
    name: 'Sudimara Jaya',
  },
  {
    id: '3671010016',
    districtId: '3671010',
    name: 'Sudimara Timur',
  },
  {
    id: '3671011001',
    districtId: '3671011',
    name: 'Larangan Selatan',
  },
  {
    id: '3671011002',
    districtId: '3671011',
    name: 'Gaga',
  },
  {
    id: '3671011003',
    districtId: '3671011',
    name: 'Cipadu Jaya',
  },
  {
    id: '3671011004',
    districtId: '3671011',
    name: 'Kereo Selatan',
  },
  {
    id: '3671011005',
    districtId: '3671011',
    name: 'Cipadu',
  },
  {
    id: '3671011006',
    districtId: '3671011',
    name: 'Kereo',
  },
  {
    id: '3671011007',
    districtId: '3671011',
    name: 'Larangan Indah',
  },
  {
    id: '3671011008',
    districtId: '3671011',
    name: 'Larangan Utara',
  },
  {
    id: '3671012001',
    districtId: '3671012',
    name: 'Pedurenan',
  },
  {
    id: '3671012002',
    districtId: '3671012',
    name: 'Pondok Pucung',
  },
  {
    id: '3671012003',
    districtId: '3671012',
    name: 'Karang Tengah',
  },
  {
    id: '3671012004',
    districtId: '3671012',
    name: 'Karang Timur',
  },
  {
    id: '3671012005',
    districtId: '3671012',
    name: 'Karang Mulya',
  },
  {
    id: '3671012006',
    districtId: '3671012',
    name: 'Parung Jaya',
  },
  {
    id: '3671012007',
    districtId: '3671012',
    name: 'Pondok Bahar',
  },
  {
    id: '3671020012',
    districtId: '3671020',
    name: 'Poris Plawad Indah',
  },
  {
    id: '3671020013',
    districtId: '3671020',
    name: 'Cipondoh',
  },
  {
    id: '3671020014',
    districtId: '3671020',
    name: 'Kenanga',
  },
  {
    id: '3671020015',
    districtId: '3671020',
    name: 'Gondrong',
  },
  {
    id: '3671020016',
    districtId: '3671020',
    name: 'Petir',
  },
  {
    id: '3671020017',
    districtId: '3671020',
    name: 'Ketapang',
  },
  {
    id: '3671020018',
    districtId: '3671020',
    name: 'Cipondoh Indah',
  },
  {
    id: '3671020019',
    districtId: '3671020',
    name: 'Cipondoh Makmur',
  },
  {
    id: '3671020020',
    districtId: '3671020',
    name: 'Poris Plawad Utara',
  },
  {
    id: '3671020021',
    districtId: '3671020',
    name: 'Poris Plawad',
  },
  {
    id: '3671021001',
    districtId: '3671021',
    name: 'Panunggangan Utara',
  },
  {
    id: '3671021002',
    districtId: '3671021',
    name: 'Panunggangan',
  },
  {
    id: '3671021003',
    districtId: '3671021',
    name: 'Panunggangan Timur',
  },
  {
    id: '3671021004',
    districtId: '3671021',
    name: 'Kunciran',
  },
  {
    id: '3671021005',
    districtId: '3671021',
    name: 'Kunciran Indah',
  },
  {
    id: '3671021006',
    districtId: '3671021',
    name: 'Sudimara Pinang',
  },
  {
    id: '3671021007',
    districtId: '3671021',
    name: 'Pinang',
  },
  {
    id: '3671021008',
    districtId: '3671021',
    name: 'Neroktog',
  },
  {
    id: '3671021009',
    districtId: '3671021',
    name: 'Kunciran Jaya',
  },
  {
    id: '3671021010',
    districtId: '3671021',
    name: 'Pakojan',
  },
  {
    id: '3671021011',
    districtId: '3671021',
    name: 'Cipete',
  },
  {
    id: '3671030004',
    districtId: '3671030',
    name: 'Cikokol',
  },
  {
    id: '3671030005',
    districtId: '3671030',
    name: 'Kelapa Indah',
  },
  {
    id: '3671030006',
    districtId: '3671030',
    name: 'Babakan',
  },
  {
    id: '3671030014',
    districtId: '3671030',
    name: 'Sukasari',
  },
  {
    id: '3671030015',
    districtId: '3671030',
    name: 'Buaran Indah',
  },
  {
    id: '3671030016',
    districtId: '3671030',
    name: 'Tanah Tinggi',
  },
  {
    id: '3671030017',
    districtId: '3671030',
    name: 'Sukaasih',
  },
  {
    id: '3671030018',
    districtId: '3671030',
    name: 'Sukarasa',
  },
  {
    id: '3671031001',
    districtId: '3671031',
    name: 'Karawaci Baru',
  },
  {
    id: '3671031002',
    districtId: '3671031',
    name: 'Nusajaya',
  },
  {
    id: '3671031003',
    districtId: '3671031',
    name: 'Bojongjaya',
  },
  {
    id: '3671031004',
    districtId: '3671031',
    name: 'Karawaci',
  },
  {
    id: '3671031005',
    districtId: '3671031',
    name: 'Cimone Jaya',
  },
  {
    id: '3671031006',
    districtId: '3671031',
    name: 'Cimone',
  },
  {
    id: '3671031008',
    districtId: '3671031',
    name: 'Margasari',
  },
  {
    id: '3671031009',
    districtId: '3671031',
    name: 'Pabuaran',
  },
  {
    id: '3671031010',
    districtId: '3671031',
    name: 'Sukajadi',
  },
  {
    id: '3671031012',
    districtId: '3671031',
    name: 'Koangjaya',
  },
  {
    id: '3671031013',
    districtId: '3671031',
    name: 'Pasarbaru',
  },
  {
    id: '3671031014',
    districtId: '3671031',
    name: 'Sumur Pacing',
  },
  {
    id: '3671031015',
    districtId: '3671031',
    name: 'Pabuaran Tumpeng',
  },
  {
    id: '3671031016',
    districtId: '3671031',
    name: 'Nambojaya',
  },
  {
    id: '3671040001',
    districtId: '3671040',
    name: 'Manis Jaya',
  },
  {
    id: '3671040002',
    districtId: '3671040',
    name: 'Jatake',
  },
  {
    id: '3671040003',
    districtId: '3671040',
    name: 'Gandasari',
  },
  {
    id: '3671040010',
    districtId: '3671040',
    name: 'Kroncong',
  },
  {
    id: '3671040011',
    districtId: '3671040',
    name: 'Alam Jaya',
  },
  {
    id: '3671040012',
    districtId: '3671040',
    name: 'Pasir Jaya',
  },
  {
    id: '3671041001',
    districtId: '3671041',
    name: 'Panunggangan Barat',
  },
  {
    id: '3671041002',
    districtId: '3671041',
    name: 'Cibodasari',
  },
  {
    id: '3671041003',
    districtId: '3671041',
    name: 'Cibodas Baru',
  },
  {
    id: '3671041004',
    districtId: '3671041',
    name: 'Cibodas',
  },
  {
    id: '3671041005',
    districtId: '3671041',
    name: 'Uwung Jaya',
  },
  {
    id: '3671041006',
    districtId: '3671041',
    name: 'Jatiuwung',
  },
  {
    id: '3671042001',
    districtId: '3671042',
    name: 'Gembor',
  },
  {
    id: '3671042002',
    districtId: '3671042',
    name: 'Gebang Raya',
  },
  {
    id: '3671042003',
    districtId: '3671042',
    name: 'Sangiang Jaya',
  },
  {
    id: '3671042004',
    districtId: '3671042',
    name: 'Periuk',
  },
  {
    id: '3671042005',
    districtId: '3671042',
    name: 'Periuk Jaya',
  },
  {
    id: '3671050001',
    districtId: '3671050',
    name: 'Porisgaga Baru',
  },
  {
    id: '3671050002',
    districtId: '3671050',
    name: 'Poris Jaya',
  },
  {
    id: '3671050003',
    districtId: '3671050',
    name: 'Porisgaga',
  },
  {
    id: '3671050004',
    districtId: '3671050',
    name: 'Kebon Besar',
  },
  {
    id: '3671050005',
    districtId: '3671050',
    name: 'Batuceper',
  },
  {
    id: '3671050006',
    districtId: '3671050',
    name: 'Batujaya',
  },
  {
    id: '3671050007',
    districtId: '3671050',
    name: 'Batusari',
  },
  {
    id: '3671051001',
    districtId: '3671051',
    name: 'Karang Anyar',
  },
  {
    id: '3671051002',
    districtId: '3671051',
    name: 'Karang Sari',
  },
  {
    id: '3671051003',
    districtId: '3671051',
    name: 'Neglasari',
  },
  {
    id: '3671051004',
    districtId: '3671051',
    name: 'Mekarsari',
  },
  {
    id: '3671051005',
    districtId: '3671051',
    name: 'Kedaung Baru',
  },
  {
    id: '3671051006',
    districtId: '3671051',
    name: 'Kedaung Wetan',
  },
  {
    id: '3671051007',
    districtId: '3671051',
    name: 'Selapajang Jaya',
  },
  {
    id: '3671060002',
    districtId: '3671060',
    name: 'Jurumudi Baru',
  },
  {
    id: '3671060003',
    districtId: '3671060',
    name: 'Jurumudi',
  },
  {
    id: '3671060004',
    districtId: '3671060',
    name: 'Pajang',
  },
  {
    id: '3671060005',
    districtId: '3671060',
    name: 'Benda',
  },
  {
    id: '3672010001',
    districtId: '3672010',
    name: 'Gunungsugih',
  },
  {
    id: '3672010003',
    districtId: '3672010',
    name: 'Randakari',
  },
  {
    id: '3672010004',
    districtId: '3672010',
    name: 'Tegalratu',
  },
  {
    id: '3672010005',
    districtId: '3672010',
    name: 'Banjar Negara',
  },
  {
    id: '3672010013',
    districtId: '3672010',
    name: 'Kubangsari',
  },
  {
    id: '3672011006',
    districtId: '3672011',
    name: 'Deringo',
  },
  {
    id: '3672011007',
    districtId: '3672011',
    name: 'Lebakdenok',
  },
  {
    id: '3672011008',
    districtId: '3672011',
    name: 'Tamanbaru',
  },
  {
    id: '3672011009',
    districtId: '3672011',
    name: 'Citangkil',
  },
  {
    id: '3672011010',
    districtId: '3672011',
    name: 'Kebonsari',
  },
  {
    id: '3672011011',
    districtId: '3672011',
    name: 'Warnasari',
  },
  {
    id: '3672011012',
    districtId: '3672011',
    name: 'Samangraya',
  },
  {
    id: '3672020011',
    districtId: '3672020',
    name: 'Mekarsari',
  },
  {
    id: '3672020012',
    districtId: '3672020',
    name: 'Tamansari',
  },
  {
    id: '3672020013',
    districtId: '3672020',
    name: 'Lebak Gede',
  },
  {
    id: '3672020014',
    districtId: '3672020',
    name: 'Suralaya',
  },
  {
    id: '3672021001',
    districtId: '3672021',
    name: 'Ramanuju',
  },
  {
    id: '3672021002',
    districtId: '3672021',
    name: 'Kebondalem',
  },
  {
    id: '3672021003',
    districtId: '3672021',
    name: 'Purwakarta',
  },
  {
    id: '3672021004',
    districtId: '3672021',
    name: 'Tegal Bunder',
  },
  {
    id: '3672021005',
    districtId: '3672021',
    name: 'Pabean',
  },
  {
    id: '3672021006',
    districtId: '3672021',
    name: 'Kotabumi',
  },
  {
    id: '3672022007',
    districtId: '3672022',
    name: 'Kotasari',
  },
  {
    id: '3672022008',
    districtId: '3672022',
    name: 'Grogol',
  },
  {
    id: '3672022009',
    districtId: '3672022',
    name: 'Rawa Arum',
  },
  {
    id: '3672030001',
    districtId: '3672030',
    name: 'Bagendung',
  },
  {
    id: '3672030002',
    districtId: '3672030',
    name: 'Ciwedus',
  },
  {
    id: '3672030003',
    districtId: '3672030',
    name: 'Bendungan',
  },
  {
    id: '3672030004',
    districtId: '3672030',
    name: 'Ciwaduk',
  },
  {
    id: '3672030005',
    districtId: '3672030',
    name: 'Ketileng',
  },
  {
    id: '3672031001',
    districtId: '3672031',
    name: 'Jombang Wetan',
  },
  {
    id: '3672031002',
    districtId: '3672031',
    name: 'Masigit',
  },
  {
    id: '3672031003',
    districtId: '3672031',
    name: 'Panggung Rawi',
  },
  {
    id: '3672031004',
    districtId: '3672031',
    name: 'Gedong Dalem',
  },
  {
    id: '3672031005',
    districtId: '3672031',
    name: 'Sukmajaya',
  },
  {
    id: '3672040001',
    districtId: '3672040',
    name: 'Bulakan',
  },
  {
    id: '3672040002',
    districtId: '3672040',
    name: 'Cikerai',
  },
  {
    id: '3672040003',
    districtId: '3672040',
    name: 'Kalitimbang',
  },
  {
    id: '3672040004',
    districtId: '3672040',
    name: 'Karangasem',
  },
  {
    id: '3672040005',
    districtId: '3672040',
    name: 'Cibeber',
  },
  {
    id: '3672040006',
    districtId: '3672040',
    name: 'Kedaleman',
  },
  {
    id: '3673010001',
    districtId: '3673010',
    name: 'Kamanisan',
  },
  {
    id: '3673010002',
    districtId: '3673010',
    name: 'Pancalaksana',
  },
  {
    id: '3673010003',
    districtId: '3673010',
    name: 'Tinggar',
  },
  {
    id: '3673010004',
    districtId: '3673010',
    name: 'Cipete',
  },
  {
    id: '3673010005',
    districtId: '3673010',
    name: 'Curugmanis',
  },
  {
    id: '3673010006',
    districtId: '3673010',
    name: 'Sukalaksana',
  },
  {
    id: '3673010007',
    districtId: '3673010',
    name: 'Sukawana',
  },
  {
    id: '3673010009',
    districtId: '3673010',
    name: 'Sukajaya',
  },
  {
    id: '3673010010',
    districtId: '3673010',
    name: 'Cilaku',
  },
  {
    id: '3673020001',
    districtId: '3673020',
    name: 'Nyapah',
  },
  {
    id: '3673020002',
    districtId: '3673020',
    name: 'Lebakwangi',
  },
  {
    id: '3673020003',
    districtId: '3673020',
    name: 'Cigoong',
  },
  {
    id: '3673020004',
    districtId: '3673020',
    name: 'Tegalsari',
  },
  {
    id: '3673020005',
    districtId: '3673020',
    name: 'Pasuluhan',
  },
  {
    id: '3673020006',
    districtId: '3673020',
    name: 'Pabuaran',
  },
  {
    id: '3673020007',
    districtId: '3673020',
    name: 'Walantaka',
  },
  {
    id: '3673020008',
    districtId: '3673020',
    name: 'Pengampelan',
  },
  {
    id: '3673020009',
    districtId: '3673020',
    name: 'Pipitan',
  },
  {
    id: '3673020010',
    districtId: '3673020',
    name: 'Kiara',
  },
  {
    id: '3673020011',
    districtId: '3673020',
    name: 'Pageragung',
  },
  {
    id: '3673020012',
    districtId: '3673020',
    name: 'Kalodran',
  },
  {
    id: '3673020014',
    districtId: '3673020',
    name: 'Teritih',
  },
  {
    id: '3673030001',
    districtId: '3673030',
    name: 'Gelam',
  },
  {
    id: '3673030002',
    districtId: '3673030',
    name: 'Dalung',
  },
  {
    id: '3673030003',
    districtId: '3673030',
    name: 'Tembong',
  },
  {
    id: '3673030004',
    districtId: '3673030',
    name: 'Karundang',
  },
  {
    id: '3673030005',
    districtId: '3673030',
    name: 'Cipocok Jaya',
  },
  {
    id: '3673030006',
    districtId: '3673030',
    name: 'Banjarsari',
  },
  {
    id: '3673030007',
    districtId: '3673030',
    name: 'Banjaragung',
  },
  {
    id: '3673030008',
    districtId: '3673030',
    name: 'Panancangan',
  },
  {
    id: '3673040001',
    districtId: '3673040',
    name: 'Serang',
  },
  {
    id: '3673040002',
    districtId: '3673040',
    name: 'Cipare',
  },
  {
    id: '3673040004',
    districtId: '3673040',
    name: 'Cimuncang',
  },
  {
    id: '3673040005',
    districtId: '3673040',
    name: 'Kotabaru',
  },
  {
    id: '3673040006',
    districtId: '3673040',
    name: 'Lontarbaru',
  },
  {
    id: '3673040007',
    districtId: '3673040',
    name: 'Kagungan',
  },
  {
    id: '3673040008',
    districtId: '3673040',
    name: 'Lopang',
  },
  {
    id: '3673040010',
    districtId: '3673040',
    name: 'Kaligandu',
  },
  {
    id: '3673040011',
    districtId: '3673040',
    name: 'Terondol',
  },
  {
    id: '3673040012',
    districtId: '3673040',
    name: 'Sukawana',
  },
  {
    id: '3673050001',
    districtId: '3673050',
    name: 'Cilowong',
  },
  {
    id: '3673050002',
    districtId: '3673050',
    name: 'Sayar',
  },
  {
    id: '3673050003',
    districtId: '3673050',
    name: 'Sepang',
  },
  {
    id: '3673050004',
    districtId: '3673050',
    name: 'Pancur',
  },
  {
    id: '3673050005',
    districtId: '3673050',
    name: 'Kalang Anyar',
  },
  {
    id: '3673050006',
    districtId: '3673050',
    name: 'Kuranji',
  },
  {
    id: '3673050007',
    districtId: '3673050',
    name: 'Panggungjati',
  },
  {
    id: '3673050008',
    districtId: '3673050',
    name: 'Drangong',
  },
  {
    id: '3673050009',
    districtId: '3673050',
    name: 'Taktakan',
  },
  {
    id: '3673050010',
    districtId: '3673050',
    name: 'Umbul Tengah',
  },
  {
    id: '3673050011',
    districtId: '3673050',
    name: 'Lialang',
  },
  {
    id: '3673050012',
    districtId: '3673050',
    name: 'Tamanbaru',
  },
  {
    id: '3673050013',
    districtId: '3673050',
    name: 'Cibendung',
  },
  {
    id: '3673060001',
    districtId: '3673060',
    name: 'Kasemen',
  },
  {
    id: '3673060002',
    districtId: '3673060',
    name: 'Warung Jaud',
  },
  {
    id: '3673060003',
    districtId: '3673060',
    name: 'Mesjid Priyayi',
  },
  {
    id: '3673060006',
    districtId: '3673060',
    name: 'Sawah Luhur',
  },
  {
    id: '3673060007',
    districtId: '3673060',
    name: 'Kilasah',
  },
  {
    id: '3673060008',
    districtId: '3673060',
    name: 'Margaluyu',
  },
  {
    id: '3673060009',
    districtId: '3673060',
    name: 'Kasunyatan',
  },
  {
    id: '3673060010',
    districtId: '3673060',
    name: 'Banten',
  },
  {
    id: '3674010001',
    districtId: '3674010',
    name: 'Kranggan',
  },
  {
    id: '3674010003',
    districtId: '3674010',
    name: 'Kademangan',
  },
  {
    id: '3674010005',
    districtId: '3674010',
    name: 'Babakan',
  },
  {
    id: '3674010006',
    districtId: '3674010',
    name: 'Bakti Jaya',
  },
  {
    id: '3674020009',
    districtId: '3674020',
    name: 'Buaran',
  },
  {
    id: '3674020010',
    districtId: '3674020',
    name: 'Ciater',
  },
  {
    id: '3674020011',
    districtId: '3674020',
    name: 'Rawa Mekar Jaya',
  },
  {
    id: '3674020012',
    districtId: '3674020',
    name: 'Rawa Buntu',
  },
  {
    id: '3674020013',
    districtId: '3674020',
    name: 'Serpong',
  },
  {
    id: '3674020018',
    districtId: '3674020',
    name: 'Cilenggang',
  },
  {
    id: '3674020019',
    districtId: '3674020',
    name: 'Lengkong Gudang',
  },
  {
    id: '3674020020',
    districtId: '3674020',
    name: 'Lengkong Gudang Timur',
  },
  {
    id: '3674020021',
    districtId: '3674020',
    name: 'Lengkong Wetan',
  },
  {
    id: '3674030001',
    districtId: '3674030',
    name: 'Pondok Benda',
  },
  {
    id: '3674030002',
    districtId: '3674030',
    name: 'Pamulang Barat',
  },
  {
    id: '3674030003',
    districtId: '3674030',
    name: 'Pamulang Timur',
  },
  {
    id: '3674030004',
    districtId: '3674030',
    name: 'Pondok Cabe Udik',
  },
  {
    id: '3674030005',
    districtId: '3674030',
    name: 'Pondok Cabe Ilir',
  },
  {
    id: '3674030006',
    districtId: '3674030',
    name: 'Kedaung',
  },
  {
    id: '3674030007',
    districtId: '3674030',
    name: 'Bambu Apus',
  },
  {
    id: '3674030008',
    districtId: '3674030',
    name: 'Benda Baru',
  },
  {
    id: '3674040001',
    districtId: '3674040',
    name: 'Sarua',
  },
  {
    id: '3674040002',
    districtId: '3674040',
    name: 'Jombang',
  },
  {
    id: '3674040003',
    districtId: '3674040',
    name: 'Sawah Baru',
  },
  {
    id: '3674040004',
    districtId: '3674040',
    name: 'Sarua Indah',
  },
  {
    id: '3674040005',
    districtId: '3674040',
    name: 'Sawah',
  },
  {
    id: '3674040006',
    districtId: '3674040',
    name: 'Ciputat',
  },
  {
    id: '3674040007',
    districtId: '3674040',
    name: 'Cipayung',
  },
  {
    id: '3674050001',
    districtId: '3674050',
    name: 'Pisangan',
  },
  {
    id: '3674050002',
    districtId: '3674050',
    name: 'Cireundeu',
  },
  {
    id: '3674050003',
    districtId: '3674050',
    name: 'Cempaka Putih',
  },
  {
    id: '3674050004',
    districtId: '3674050',
    name: 'Rempoa',
  },
  {
    id: '3674050005',
    districtId: '3674050',
    name: 'Rengas',
  },
  {
    id: '3674050006',
    districtId: '3674050',
    name: 'Pondok Ranji',
  },
  {
    id: '3674060001',
    districtId: '3674060',
    name: 'Perigi Baru',
  },
  {
    id: '3674060002',
    districtId: '3674060',
    name: 'Pondok Kacang Barat',
  },
  {
    id: '3674060003',
    districtId: '3674060',
    name: 'Pondok Kacang Timur',
  },
  {
    id: '3674060004',
    districtId: '3674060',
    name: 'Perigi',
  },
  {
    id: '3674060005',
    districtId: '3674060',
    name: 'Pondok Pucung',
  },
  {
    id: '3674060006',
    districtId: '3674060',
    name: 'Pondok Jaya',
  },
  {
    id: '3674060007',
    districtId: '3674060',
    name: 'Pondok Aren',
  },
  {
    id: '3674060008',
    districtId: '3674060',
    name: 'Jurang Manggu Barat',
  },
  {
    id: '3674060009',
    districtId: '3674060',
    name: 'Jurang Manggu Timur',
  },
  {
    id: '3674060010',
    districtId: '3674060',
    name: 'Pondok Karya',
  },
  {
    id: '3674060011',
    districtId: '3674060',
    name: 'Pondok Betung',
  },
  {
    id: '3674070001',
    districtId: '3674070',
    name: 'Lengkong Karya',
  },
  {
    id: '3674070002',
    districtId: '3674070',
    name: 'Jelupang',
  },
  {
    id: '3674070003',
    districtId: '3674070',
    name: 'Pondok Jagung',
  },
  {
    id: '3674070004',
    districtId: '3674070',
    name: 'Pondok Jagung Timur',
  },
  {
    id: '3674070005',
    districtId: '3674070',
    name: 'Pakulonan',
  },
  {
    id: '3674070006',
    districtId: '3674070',
    name: 'Paku Alam',
  },
  {
    id: '3674070007',
    districtId: '3674070',
    name: 'Paku Jaya',
  },
  {
    id: '5101010001',
    districtId: '5101010',
    name: 'Gilimanuk',
  },
  {
    id: '5101010002',
    districtId: '5101010',
    name: 'Melaya',
  },
  {
    id: '5101010003',
    districtId: '5101010',
    name: 'Candikusuma',
  },
  {
    id: '5101010005',
    districtId: '5101010',
    name: 'Tukadaya',
  },
  {
    id: '5101010006',
    districtId: '5101010',
    name: 'Manistutu',
  },
  {
    id: '5101010007',
    districtId: '5101010',
    name: 'Warnasari',
  },
  {
    id: '5101010008',
    districtId: '5101010',
    name: 'Nusa Sari',
  },
  {
    id: '5101010009',
    districtId: '5101010',
    name: 'Ekasari',
  },
  {
    id: '5101010010',
    districtId: '5101010',
    name: 'Blimbingsari',
  },
  {
    id: '5101020002',
    districtId: '5101020',
    name: 'Tegal Badeng Barat',
  },
  {
    id: '5101020003',
    districtId: '5101020',
    name: 'Tegal Badeng Timur',
  },
  {
    id: '5101020004',
    districtId: '5101020',
    name: 'Pengambengan',
  },
  {
    id: '5101020012',
    districtId: '5101020',
    name: 'Loloan Barat',
  },
  {
    id: '5101020013',
    districtId: '5101020',
    name: 'Lelateng',
  },
  {
    id: '5101020014',
    districtId: '5101020',
    name: 'Banjar Tengah',
  },
  {
    id: '5101020015',
    districtId: '5101020',
    name: 'Baluk',
  },
  {
    id: '5101020016',
    districtId: '5101020',
    name: 'Banyubiru',
  },
  {
    id: '5101020017',
    districtId: '5101020',
    name: 'Kaliakah',
  },
  {
    id: '5101020018',
    districtId: '5101020',
    name: 'Berangbang',
  },
  {
    id: '5101020019',
    districtId: '5101020',
    name: 'Baler Bale Agung',
  },
  {
    id: '5101021001',
    districtId: '5101021',
    name: 'Perancak',
  },
  {
    id: '5101021002',
    districtId: '5101021',
    name: 'Air Kuning',
  },
  {
    id: '5101021003',
    districtId: '5101021',
    name: 'Yeh Kuning',
  },
  {
    id: '5101021005',
    districtId: '5101021',
    name: 'Sangkaragung',
  },
  {
    id: '5101021006',
    districtId: '5101021',
    name: 'Dauhwaru',
  },
  {
    id: '5101021007',
    districtId: '5101021',
    name: 'Loloan Timur',
  },
  {
    id: '5101021009',
    districtId: '5101021',
    name: 'Batuagung',
  },
  {
    id: '5101021010',
    districtId: '5101021',
    name: 'Dangin Tukadaya',
  },
  {
    id: '5101030001',
    districtId: '5101030',
    name: 'Mendoyo Dauh Tukad',
  },
  {
    id: '5101030002',
    districtId: '5101030',
    name: 'Mendoyo Dangin Tukad',
  },
  {
    id: '5101030003',
    districtId: '5101030',
    name: 'Pohsanten',
  },
  {
    id: '5101030005',
    districtId: '5101030',
    name: 'Delod Berawah',
  },
  {
    id: '5101030006',
    districtId: '5101030',
    name: 'Tegal Cangkring',
  },
  {
    id: '5101030007',
    districtId: '5101030',
    name: 'Penyaringan',
  },
  {
    id: '5101030008',
    districtId: '5101030',
    name: 'Yeh Embang Kauh',
  },
  {
    id: '5101030009',
    districtId: '5101030',
    name: 'Yeh Embang',
  },
  {
    id: '5101030010',
    districtId: '5101030',
    name: 'Yeh Embang Kangin',
  },
  {
    id: '5101040001',
    districtId: '5101040',
    name: 'Medewi',
  },
  {
    id: '5101040002',
    districtId: '5101040',
    name: 'Pulukan',
  },
  {
    id: '5101040003',
    districtId: '5101040',
    name: 'Pekutatan',
  },
  {
    id: '5101040004',
    districtId: '5101040',
    name: 'Pangyangan',
  },
  {
    id: '5101040005',
    districtId: '5101040',
    name: 'Gumbrih',
  },
  {
    id: '5101040006',
    districtId: '5101040',
    name: 'Pengeragoan',
  },
  {
    id: '5101040007',
    districtId: '5101040',
    name: 'Asahduren',
  },
  {
    id: '5101040008',
    districtId: '5101040',
    name: 'Manggissari',
  },
  {
    id: '5102010002',
    districtId: '5102010',
    name: 'Antap',
  },
  {
    id: '5102010004',
    districtId: '5102010',
    name: 'Bajera',
  },
  {
    id: '5102010006',
    districtId: '5102010',
    name: 'Serampingan',
  },
  {
    id: '5102010014',
    districtId: '5102010',
    name: 'Selemadeg',
  },
  {
    id: '5102010015',
    districtId: '5102010',
    name: 'Pupuan Sawah',
  },
  {
    id: '5102010018',
    districtId: '5102010',
    name: 'Wanagiri',
  },
  {
    id: '5102010024',
    districtId: '5102010',
    name: 'Wanagiri Kauh',
  },
  {
    id: '5102010025',
    districtId: '5102010',
    name: 'Manikyang',
  },
  {
    id: '5102010026',
    districtId: '5102010',
    name: 'Bajera Utara',
  },
  {
    id: '5102011001',
    districtId: '5102011',
    name: 'Tegal Mengkeb',
  },
  {
    id: '5102011002',
    districtId: '5102011',
    name: 'Beraban',
  },
  {
    id: '5102011003',
    districtId: '5102011',
    name: 'Tangguntiti',
  },
  {
    id: '5102011004',
    districtId: '5102011',
    name: 'Mambang',
  },
  {
    id: '5102011005',
    districtId: '5102011',
    name: 'Bantas',
  },
  {
    id: '5102011006',
    districtId: '5102011',
    name: 'Megati',
  },
  {
    id: '5102011007',
    districtId: '5102011',
    name: 'Gadungan',
  },
  {
    id: '5102011008',
    districtId: '5102011',
    name: 'Gunung Salak',
  },
  {
    id: '5102011009',
    districtId: '5102011',
    name: 'Dalang',
  },
  {
    id: '5102011010',
    districtId: '5102011',
    name: 'Gadung Sari',
  },
  {
    id: '5102012001',
    districtId: '5102012',
    name: 'Lalang Linggah',
  },
  {
    id: '5102012002',
    districtId: '5102012',
    name: 'Antosari',
  },
  {
    id: '5102012003',
    districtId: '5102012',
    name: 'Tiying Gading',
  },
  {
    id: '5102012005',
    districtId: '5102012',
    name: 'Lumbung Kauh',
  },
  {
    id: '5102012007',
    districtId: '5102012',
    name: 'Mundeh Kangin',
  },
  {
    id: '5102012008',
    districtId: '5102012',
    name: 'Angkah',
  },
  {
    id: '5102012009',
    districtId: '5102012',
    name: 'Mundeh Kauh',
  },
  {
    id: '5102012010',
    districtId: '5102012',
    name: 'Selabih',
  },
  {
    id: '5102012011',
    districtId: '5102012',
    name: 'Bengkel Sari',
  },
  {
    id: '5102020001',
    districtId: '5102020',
    name: 'Tibubiyu',
  },
  {
    id: '5102020002',
    districtId: '5102020',
    name: 'Kelating',
  },
  {
    id: '5102020003',
    districtId: '5102020',
    name: 'Penarukan',
  },
  {
    id: '5102020004',
    districtId: '5102020',
    name: 'Belumbang',
  },
  {
    id: '5102020005',
    districtId: '5102020',
    name: 'Tista',
  },
  {
    id: '5102020006',
    districtId: '5102020',
    name: 'Kerambitan',
  },
  {
    id: '5102020007',
    districtId: '5102020',
    name: 'Pangkung Karung',
  },
  {
    id: '5102020009',
    districtId: '5102020',
    name: 'Baturiti',
  },
  {
    id: '5102020010',
    districtId: '5102020',
    name: 'Meliling',
  },
  {
    id: '5102020012',
    districtId: '5102020',
    name: 'Samsam',
  },
  {
    id: '5102020013',
    districtId: '5102020',
    name: 'Batuaji',
  },
  {
    id: '5102020014',
    districtId: '5102020',
    name: 'Kesiut',
  },
  {
    id: '5102020015',
    districtId: '5102020',
    name: 'Timpag',
  },
  {
    id: '5102030001',
    districtId: '5102030',
    name: 'Sudimara',
  },
  {
    id: '5102030002',
    districtId: '5102030',
    name: 'Bongan',
  },
  {
    id: '5102030004',
    districtId: '5102030',
    name: 'Dauh Peken',
  },
  {
    id: '5102030005',
    districtId: '5102030',
    name: 'Delod Peken',
  },
  {
    id: '5102030006',
    districtId: '5102030',
    name: 'Dajan Peken',
  },
  {
    id: '5102030007',
    districtId: '5102030',
    name: 'Subamia',
  },
  {
    id: '5102030008',
    districtId: '5102030',
    name: 'Denbantas',
  },
  {
    id: '5102030009',
    districtId: '5102030',
    name: 'Buahan',
  },
  {
    id: '5102030011',
    districtId: '5102030',
    name: 'Wanasari',
  },
  {
    id: '5102030012',
    districtId: '5102030',
    name: 'Sesandan',
  },
  {
    id: '5102040001',
    districtId: '5102040',
    name: 'Pangkung Tibah',
  },
  {
    id: '5102040002',
    districtId: '5102040',
    name: 'Belalang',
  },
  {
    id: '5102040003',
    districtId: '5102040',
    name: 'Beraban',
  },
  {
    id: '5102040004',
    districtId: '5102040',
    name: 'Buwit',
  },
  {
    id: '5102040005',
    districtId: '5102040',
    name: 'Cepaka',
  },
  {
    id: '5102040006',
    districtId: '5102040',
    name: 'Kaba-Kaba',
  },
  {
    id: '5102040007',
    districtId: '5102040',
    name: 'Pandak Gede',
  },
  {
    id: '5102040009',
    districtId: '5102040',
    name: 'Pejaten',
  },
  {
    id: '5102040010',
    districtId: '5102040',
    name: 'Nyitdah',
  },
  {
    id: '5102040011',
    districtId: '5102040',
    name: 'Pandak Bandung',
  },
  {
    id: '5102040012',
    districtId: '5102040',
    name: 'Nyambu',
  },
  {
    id: '5102040013',
    districtId: '5102040',
    name: 'Kediri',
  },
  {
    id: '5102040014',
    districtId: '5102040',
    name: 'Abian Tuwung',
  },
  {
    id: '5102040015',
    districtId: '5102040',
    name: 'Banjar Anyar',
  },
  {
    id: '5102050001',
    districtId: '5102050',
    name: 'Tegaljadi',
  },
  {
    id: '5102050003',
    districtId: '5102050',
    name: 'Beringkit Belayu',
  },
  {
    id: '5102050004',
    districtId: '5102050',
    name: 'Peken Belayu',
  },
  {
    id: '5102050005',
    districtId: '5102050',
    name: 'Batannyuh',
  },
  {
    id: '5102050007',
    districtId: '5102050',
    name: 'Caubelayu',
  },
  {
    id: '5102050008',
    districtId: '5102050',
    name: 'Selanbawak',
  },
  {
    id: '5102050009',
    districtId: '5102050',
    name: 'Marga',
  },
  {
    id: '5102050010',
    districtId: '5102050',
    name: 'Petiga',
  },
  {
    id: '5102050011',
    districtId: '5102050',
    name: 'Tua',
  },
  {
    id: '5102050012',
    districtId: '5102050',
    name: 'Payangan',
  },
  {
    id: '5102050013',
    districtId: '5102050',
    name: 'Dauh Puri',
  },
  {
    id: '5102050014',
    districtId: '5102050',
    name: 'Dajan Puri',
  },
  {
    id: '5102050016',
    districtId: '5102050',
    name: 'Baru',
  },
  {
    id: '5102060001',
    districtId: '5102060',
    name: 'Perean',
  },
  {
    id: '5102060002',
    districtId: '5102060',
    name: 'Perean Tengah',
  },
  {
    id: '5102060003',
    districtId: '5102060',
    name: 'Perean Kangin',
  },
  {
    id: '5102060005',
    districtId: '5102060',
    name: 'Mekarsari',
  },
  {
    id: '5102060006',
    districtId: '5102060',
    name: 'Apuan',
  },
  {
    id: '5102060007',
    districtId: '5102060',
    name: 'Angseri',
  },
  {
    id: '5102060008',
    districtId: '5102060',
    name: 'Bangli',
  },
  {
    id: '5102060009',
    districtId: '5102060',
    name: 'Baturiti',
  },
  {
    id: '5102060010',
    districtId: '5102060',
    name: 'Batunya',
  },
  {
    id: '5102060011',
    districtId: '5102060',
    name: 'Antapan',
  },
  {
    id: '5102060012',
    districtId: '5102060',
    name: 'Candikuning',
  },
  {
    id: '5102070001',
    districtId: '5102070',
    name: 'Rejasa',
  },
  {
    id: '5102070003',
    districtId: '5102070',
    name: 'Riang Gede',
  },
  {
    id: '5102070004',
    districtId: '5102070',
    name: 'Buruan',
  },
  {
    id: '5102070005',
    districtId: '5102070',
    name: 'Tajen',
  },
  {
    id: '5102070006',
    districtId: '5102070',
    name: 'Pitra',
  },
  {
    id: '5102070007',
    districtId: '5102070',
    name: 'Penatahan',
  },
  {
    id: '5102070008',
    districtId: '5102070',
    name: 'Tengkudak',
  },
  {
    id: '5102070011',
    districtId: '5102070',
    name: 'Biaung',
  },
  {
    id: '5102070012',
    districtId: '5102070',
    name: 'Babahan',
  },
  {
    id: '5102070013',
    districtId: '5102070',
    name: 'Senganan',
  },
  {
    id: '5102070014',
    districtId: '5102070',
    name: 'Jatiluwih',
  },
  {
    id: '5102070015',
    districtId: '5102070',
    name: 'Wongaya Gede',
  },
  {
    id: '5102070016',
    districtId: '5102070',
    name: 'Pesagi',
  },
  {
    id: '5102070017',
    districtId: '5102070',
    name: 'Tegalinggah',
  },
  {
    id: '5102070018',
    districtId: '5102070',
    name: 'Sangketan',
  },
  {
    id: '5102080001',
    districtId: '5102080',
    name: 'Belatungan',
  },
  {
    id: '5102080002',
    districtId: '5102080',
    name: 'Kebon Padangan',
  },
  {
    id: '5102080003',
    districtId: '5102080',
    name: 'Belimbing',
  },
  {
    id: '5102080004',
    districtId: '5102080',
    name: 'Sanda',
  },
  {
    id: '5102080005',
    districtId: '5102080',
    name: 'Batungsel',
  },
  {
    id: '5102080006',
    districtId: '5102080',
    name: 'Pujungan',
  },
  {
    id: '5102080007',
    districtId: '5102080',
    name: 'Pajahan',
  },
  {
    id: '5102080009',
    districtId: '5102080',
    name: 'Pupuan',
  },
  {
    id: '5102080010',
    districtId: '5102080',
    name: 'Bantiran',
  },
  {
    id: '5102080011',
    districtId: '5102080',
    name: 'Padangan',
  },
  {
    id: '5102080012',
    districtId: '5102080',
    name: 'Jelijih Punggang',
  },
  {
    id: '5102080013',
    districtId: '5102080',
    name: 'Karya Sari',
  },
  {
    id: '5102080014',
    districtId: '5102080',
    name: 'Sai',
  },
  {
    id: '5103010001',
    districtId: '5103010',
    name: 'Pecatu',
  },
  {
    id: '5103010002',
    districtId: '5103010',
    name: 'Ungasan',
  },
  {
    id: '5103010004',
    districtId: '5103010',
    name: 'Benoa',
  },
  {
    id: '5103010005',
    districtId: '5103010',
    name: 'Tanjung Benoa',
  },
  {
    id: '5103010006',
    districtId: '5103010',
    name: 'Jimbaran',
  },
  {
    id: '5103020001',
    districtId: '5103020',
    name: 'Kedonganan',
  },
  {
    id: '5103020002',
    districtId: '5103020',
    name: 'Tuban',
  },
  {
    id: '5103020003',
    districtId: '5103020',
    name: 'Kuta',
  },
  {
    id: '5103020004',
    districtId: '5103020',
    name: 'Legian',
  },
  {
    id: '5103020005',
    districtId: '5103020',
    name: 'Seminyak',
  },
  {
    id: '5103030001',
    districtId: '5103030',
    name: 'Kerobokan Kelod',
  },
  {
    id: '5103030002',
    districtId: '5103030',
    name: 'Kerobokan',
  },
  {
    id: '5103030003',
    districtId: '5103030',
    name: 'Kerobokan Kaja',
  },
  {
    id: '5103030004',
    districtId: '5103030',
    name: 'Tibubeneng',
  },
  {
    id: '5103030005',
    districtId: '5103030',
    name: 'Canggu',
  },
  {
    id: '5103030006',
    districtId: '5103030',
    name: 'Dalung',
  },
  {
    id: '5103040001',
    districtId: '5103040',
    name: 'Cemagi',
  },
  {
    id: '5103040003',
    districtId: '5103040',
    name: 'Pererenan',
  },
  {
    id: '5103040004',
    districtId: '5103040',
    name: 'Tumbak Bayuh',
  },
  {
    id: '5103040006',
    districtId: '5103040',
    name: 'Abianbase',
  },
  {
    id: '5103040007',
    districtId: '5103040',
    name: 'Sempidi',
  },
  {
    id: '5103040008',
    districtId: '5103040',
    name: 'Sading',
  },
  {
    id: '5103040010',
    districtId: '5103040',
    name: 'Kapal',
  },
  {
    id: '5103040011',
    districtId: '5103040',
    name: 'Kekeran',
  },
  {
    id: '5103040012',
    districtId: '5103040',
    name: 'Mengwitani',
  },
  {
    id: '5103040013',
    districtId: '5103040',
    name: 'Mengwi',
  },
  {
    id: '5103040014',
    districtId: '5103040',
    name: 'Gulingan',
  },
  {
    id: '5103040015',
    districtId: '5103040',
    name: 'Penarungan',
  },
  {
    id: '5103040016',
    districtId: '5103040',
    name: 'Baha',
  },
  {
    id: '5103040017',
    districtId: '5103040',
    name: 'Werdi Bhuwana',
  },
  {
    id: '5103040018',
    districtId: '5103040',
    name: 'Sobangan',
  },
  {
    id: '5103050001',
    districtId: '5103050',
    name: 'Darmasaba',
  },
  {
    id: '5103050002',
    districtId: '5103050',
    name: 'Sibang Gede',
  },
  {
    id: '5103050003',
    districtId: '5103050',
    name: 'Jagapati',
  },
  {
    id: '5103050004',
    districtId: '5103050',
    name: 'Angantaka',
  },
  {
    id: '5103050005',
    districtId: '5103050',
    name: 'Sedang',
  },
  {
    id: '5103050006',
    districtId: '5103050',
    name: 'Sibang Kaja',
  },
  {
    id: '5103050007',
    districtId: '5103050',
    name: 'Mekar Bhuana',
  },
  {
    id: '5103050008',
    districtId: '5103050',
    name: 'Mambal',
  },
  {
    id: '5103050009',
    districtId: '5103050',
    name: 'Abiansemal',
  },
  {
    id: '5103050010',
    districtId: '5103050',
    name: 'Dauh Yeh Cani',
  },
  {
    id: '5103050011',
    districtId: '5103050',
    name: 'Ayunan',
  },
  {
    id: '5103050012',
    districtId: '5103050',
    name: 'Blahkiuh',
  },
  {
    id: '5103050014',
    districtId: '5103050',
    name: 'Bongkasa',
  },
  {
    id: '5103050015',
    districtId: '5103050',
    name: 'Taman',
  },
  {
    id: '5103050016',
    districtId: '5103050',
    name: 'Selat',
  },
  {
    id: '5103050017',
    districtId: '5103050',
    name: 'Sangeh',
  },
  {
    id: '5103050018',
    districtId: '5103050',
    name: 'Bongkasa Pertiwi',
  },
  {
    id: '5103060001',
    districtId: '5103060',
    name: 'Carangsari',
  },
  {
    id: '5103060002',
    districtId: '5103060',
    name: 'Getasan',
  },
  {
    id: '5103060003',
    districtId: '5103060',
    name: 'Pangsan',
  },
  {
    id: '5103060004',
    districtId: '5103060',
    name: 'Petang',
  },
  {
    id: '5103060005',
    districtId: '5103060',
    name: 'Sulangai',
  },
  {
    id: '5103060006',
    districtId: '5103060',
    name: 'Pelaga',
  },
  {
    id: '5103060007',
    districtId: '5103060',
    name: 'Belok/Sidan',
  },
  {
    id: '5104010001',
    districtId: '5104010',
    name: 'Batubulan',
  },
  {
    id: '5104010002',
    districtId: '5104010',
    name: 'Batubulan Kangin',
  },
  {
    id: '5104010004',
    districtId: '5104010',
    name: 'Guwang',
  },
  {
    id: '5104010005',
    districtId: '5104010',
    name: 'Sukawati',
  },
  {
    id: '5104010007',
    districtId: '5104010',
    name: 'Singapadu',
  },
  {
    id: '5104010008',
    districtId: '5104010',
    name: 'Singapadu Tengah',
  },
  {
    id: '5104010009',
    districtId: '5104010',
    name: 'Singapadu Kaler',
  },
  {
    id: '5104010010',
    districtId: '5104010',
    name: 'Batuan',
  },
  {
    id: '5104010011',
    districtId: '5104010',
    name: 'Batuan Kaler',
  },
  {
    id: '5104020001',
    districtId: '5104020',
    name: 'Saba',
  },
  {
    id: '5104020002',
    districtId: '5104020',
    name: 'Pering',
  },
  {
    id: '5104020003',
    districtId: '5104020',
    name: 'Keramas',
  },
  {
    id: '5104020004',
    districtId: '5104020',
    name: 'Medahan',
  },
  {
    id: '5104020005',
    districtId: '5104020',
    name: 'Bona',
  },
  {
    id: '5104020006',
    districtId: '5104020',
    name: 'Belega',
  },
  {
    id: '5104020007',
    districtId: '5104020',
    name: 'Blahbatuh',
  },
  {
    id: '5104020008',
    districtId: '5104020',
    name: 'Buruan',
  },
  {
    id: '5104030001',
    districtId: '5104030',
    name: 'Lebih',
  },
  {
    id: '5104030002',
    districtId: '5104030',
    name: 'Tulikup',
  },
  {
    id: '5104030003',
    districtId: '5104030',
    name: 'Temesi',
  },
  {
    id: '5104030004',
    districtId: '5104030',
    name: 'Sidan',
  },
  {
    id: '5104030005',
    districtId: '5104030',
    name: 'Samplangan',
  },
  {
    id: '5104030006',
    districtId: '5104030',
    name: 'Serongga',
  },
  {
    id: '5104030007',
    districtId: '5104030',
    name: 'Abianbase',
  },
  {
    id: '5104030008',
    districtId: '5104030',
    name: 'Gianyar',
  },
  {
    id: '5104030010',
    districtId: '5104030',
    name: 'Bitera',
  },
  {
    id: '5104030011',
    districtId: '5104030',
    name: 'Bakbakan',
  },
  {
    id: '5104030012',
    districtId: '5104030',
    name: 'Siangan',
  },
  {
    id: '5104030013',
    districtId: '5104030',
    name: 'Suwat',
  },
  {
    id: '5104030014',
    districtId: '5104030',
    name: 'Petak',
  },
  {
    id: '5104030015',
    districtId: '5104030',
    name: 'Petak Kaja',
  },
  {
    id: '5104030016',
    districtId: '5104030',
    name: 'Sumita',
  },
  {
    id: '5104030017',
    districtId: '5104030',
    name: 'Tegal Tugu',
  },
  {
    id: '5104040001',
    districtId: '5104040',
    name: 'Pejeng Kawan',
  },
  {
    id: '5104040003',
    districtId: '5104040',
    name: 'Pejeng Kelod',
  },
  {
    id: '5104040004',
    districtId: '5104040',
    name: 'Pejeng Kangin',
  },
  {
    id: '5104040005',
    districtId: '5104040',
    name: 'Pejeng Kaja',
  },
  {
    id: '5104040006',
    districtId: '5104040',
    name: 'Sanding',
  },
  {
    id: '5104040007',
    districtId: '5104040',
    name: 'Tampaksiring',
  },
  {
    id: '5104040008',
    districtId: '5104040',
    name: 'Manukaya',
  },
  {
    id: '5104050001',
    districtId: '5104050',
    name: 'Singekerta',
  },
  {
    id: '5104050002',
    districtId: '5104050',
    name: 'Lodtunduh',
  },
  {
    id: '5104050003',
    districtId: '5104050',
    name: 'Mas',
  },
  {
    id: '5104050004',
    districtId: '5104050',
    name: 'Peliatan',
  },
  {
    id: '5104050007',
    districtId: '5104050',
    name: 'Sayan',
  },
  {
    id: '5104050008',
    districtId: '5104050',
    name: 'Kedewatan',
  },
  {
    id: '5104060001',
    districtId: '5104060',
    name: 'Keliki',
  },
  {
    id: '5104060002',
    districtId: '5104060',
    name: 'Tegallalang',
  },
  {
    id: '5104060003',
    districtId: '5104060',
    name: 'Kenderan',
  },
  {
    id: '5104060004',
    districtId: '5104060',
    name: 'Kedisan',
  },
  {
    id: '5104060005',
    districtId: '5104060',
    name: 'Pupuan',
  },
  {
    id: '5104060006',
    districtId: '5104060',
    name: 'Sebatu',
  },
  {
    id: '5104060007',
    districtId: '5104060',
    name: 'Taro',
  },
  {
    id: '5104070001',
    districtId: '5104070',
    name: 'Melinggih Kelod',
  },
  {
    id: '5104070002',
    districtId: '5104070',
    name: 'Melinggih',
  },
  {
    id: '5104070003',
    districtId: '5104070',
    name: 'Kelusa',
  },
  {
    id: '5104070004',
    districtId: '5104070',
    name: 'Beresela',
  },
  {
    id: '5104070005',
    districtId: '5104070',
    name: 'Bukian',
  },
  {
    id: '5104070007',
    districtId: '5104070',
    name: 'Buahan',
  },
  {
    id: '5104070008',
    districtId: '5104070',
    name: 'Buahan Kaja',
  },
  {
    id: '5104070009',
    districtId: '5104070',
    name: 'Kerta',
  },
  {
    id: '5105010001',
    districtId: '5105010',
    name: 'Sakti',
  },
  {
    id: '5105010002',
    districtId: '5105010',
    name: 'Bunga Mekar',
  },
  {
    id: '5105010003',
    districtId: '5105010',
    name: 'Batumadeg',
  },
  {
    id: '5105010005',
    districtId: '5105010',
    name: 'Batukandik',
  },
  {
    id: '5105010006',
    districtId: '5105010',
    name: 'Sekartaji',
  },
  {
    id: '5105010007',
    districtId: '5105010',
    name: 'Tanglad',
  },
  {
    id: '5105010008',
    districtId: '5105010',
    name: 'Pejukutan',
  },
  {
    id: '5105010009',
    districtId: '5105010',
    name: 'Suana',
  },
  {
    id: '5105010010',
    districtId: '5105010',
    name: 'Batununggul',
  },
  {
    id: '5105010011',
    districtId: '5105010',
    name: 'Kutampi',
  },
  {
    id: '5105010012',
    districtId: '5105010',
    name: 'Kutampi Kaler',
  },
  {
    id: '5105010014',
    districtId: '5105010',
    name: 'Kampung Toyapakeh',
  },
  {
    id: '5105010015',
    districtId: '5105010',
    name: 'Lembongan',
  },
  {
    id: '5105010016',
    districtId: '5105010',
    name: 'Jungutbatu',
  },
  {
    id: '5105020001',
    districtId: '5105020',
    name: 'Negari',
  },
  {
    id: '5105020002',
    districtId: '5105020',
    name: 'Takmung',
  },
  {
    id: '5105020003',
    districtId: '5105020',
    name: 'Banjarangkan',
  },
  {
    id: '5105020004',
    districtId: '5105020',
    name: 'Tusan',
  },
  {
    id: '5105020005',
    districtId: '5105020',
    name: 'Bakas',
  },
  {
    id: '5105020006',
    districtId: '5105020',
    name: 'Getakan',
  },
  {
    id: '5105020007',
    districtId: '5105020',
    name: 'Tihingan',
  },
  {
    id: '5105020008',
    districtId: '5105020',
    name: 'Aan',
  },
  {
    id: '5105020009',
    districtId: '5105020',
    name: 'Nyalian',
  },
  {
    id: '5105020010',
    districtId: '5105020',
    name: 'Bungbungan',
  },
  {
    id: '5105020011',
    districtId: '5105020',
    name: 'Timuhun',
  },
  {
    id: '5105020012',
    districtId: '5105020',
    name: 'Nyanglan',
  },
  {
    id: '5105020013',
    districtId: '5105020',
    name: 'Tohpati',
  },
  {
    id: '5105030001',
    districtId: '5105030',
    name: 'Satra',
  },
  {
    id: '5105030002',
    districtId: '5105030',
    name: 'Tojan',
  },
  {
    id: '5105030004',
    districtId: '5105030',
    name: 'Kampung Gelgel',
  },
  {
    id: '5105030005',
    districtId: '5105030',
    name: 'Jumpai',
  },
  {
    id: '5105030006',
    districtId: '5105030',
    name: 'Tangkas',
  },
  {
    id: '5105030007',
    districtId: '5105030',
    name: 'Kamasan',
  },
  {
    id: '5105030008',
    districtId: '5105030',
    name: 'Semarapura Kelod',
  },
  {
    id: '5105030009',
    districtId: '5105030',
    name: 'Semarapura Kelod Kangin',
  },
  {
    id: '5105030010',
    districtId: '5105030',
    name: 'Semarapura Kangin',
  },
  {
    id: '5105030011',
    districtId: '5105030',
    name: 'Semarapura Tengah',
  },
  {
    id: '5105030012',
    districtId: '5105030',
    name: 'Semarapura Kauh',
  },
  {
    id: '5105030013',
    districtId: '5105030',
    name: 'Semarapura Kaja',
  },
  {
    id: '5105030014',
    districtId: '5105030',
    name: 'Akah',
  },
  {
    id: '5105030015',
    districtId: '5105030',
    name: 'Manduang',
  },
  {
    id: '5105030016',
    districtId: '5105030',
    name: 'Selat',
  },
  {
    id: '5105030017',
    districtId: '5105030',
    name: 'Tegak',
  },
  {
    id: '5105030018',
    districtId: '5105030',
    name: 'Selisihan',
  },
  {
    id: '5105040001',
    districtId: '5105040',
    name: 'Kusamba',
  },
  {
    id: '5105040002',
    districtId: '5105040',
    name: 'Kampung Kusamba',
  },
  {
    id: '5105040003',
    districtId: '5105040',
    name: 'Pesinggahan',
  },
  {
    id: '5105040004',
    districtId: '5105040',
    name: 'Dawan Klod',
  },
  {
    id: '5105040005',
    districtId: '5105040',
    name: 'Gunaksa',
  },
  {
    id: '5105040006',
    districtId: '5105040',
    name: 'Sampalan Klod',
  },
  {
    id: '5105040007',
    districtId: '5105040',
    name: 'Sampalan Tengah',
  },
  {
    id: '5105040008',
    districtId: '5105040',
    name: 'Sulang',
  },
  {
    id: '5105040009',
    districtId: '5105040',
    name: 'Paksebali',
  },
  {
    id: '5105040010',
    districtId: '5105040',
    name: 'Dawan Kaler',
  },
  {
    id: '5105040011',
    districtId: '5105040',
    name: 'Pikat',
  },
  {
    id: '5105040012',
    districtId: '5105040',
    name: 'Besan',
  },
  {
    id: '5106010001',
    districtId: '5106010',
    name: 'Apuan',
  },
  {
    id: '5106010002',
    districtId: '5106010',
    name: 'Abuan',
  },
  {
    id: '5106010003',
    districtId: '5106010',
    name: 'Demulih',
  },
  {
    id: '5106010005',
    districtId: '5106010',
    name: 'Sulahan',
  },
  {
    id: '5106010006',
    districtId: '5106010',
    name: 'Tiga',
  },
  {
    id: '5106010007',
    districtId: '5106010',
    name: 'Penglumbaran',
  },
  {
    id: '5106010008',
    districtId: '5106010',
    name: 'Selat',
  },
  {
    id: '5106010009',
    districtId: '5106010',
    name: 'Pengiangan',
  },
  {
    id: '5106020001',
    districtId: '5106020',
    name: 'Bunutin',
  },
  {
    id: '5106020002',
    districtId: '5106020',
    name: 'Taman Bali',
  },
  {
    id: '5106020003',
    districtId: '5106020',
    name: 'Bebalang',
  },
  {
    id: '5106020004',
    districtId: '5106020',
    name: 'Kawan',
  },
  {
    id: '5106020005',
    districtId: '5106020',
    name: 'Cempaga',
  },
  {
    id: '5106020007',
    districtId: '5106020',
    name: 'Kayubihi',
  },
  {
    id: '5106020008',
    districtId: '5106020',
    name: 'Pengotan',
  },
  {
    id: '5106020009',
    districtId: '5106020',
    name: 'Landih',
  },
  {
    id: '5106030003',
    districtId: '5106030',
    name: 'Yangapi',
  },
  {
    id: '5106030004',
    districtId: '5106030',
    name: 'Undisan',
  },
  {
    id: '5106030005',
    districtId: '5106030',
    name: 'Bangbang',
  },
  {
    id: '5106030006',
    districtId: '5106030',
    name: 'Peninjoan',
  },
  {
    id: '5106040001',
    districtId: '5106040',
    name: 'Mengani',
  },
  {
    id: '5106040002',
    districtId: '5106040',
    name: 'Binyan',
  },
  {
    id: '5106040003',
    districtId: '5106040',
    name: 'Ulian',
  },
  {
    id: '5106040004',
    districtId: '5106040',
    name: 'Bunutin',
  },
  {
    id: '5106040005',
    districtId: '5106040',
    name: 'Langgahan',
  },
  {
    id: '5106040006',
    districtId: '5106040',
    name: 'Lembean',
  },
  {
    id: '5106040007',
    districtId: '5106040',
    name: 'Bayungcerik',
  },
  {
    id: '5106040008',
    districtId: '5106040',
    name: 'Mangguh',
  },
  {
    id: '5106040009',
    districtId: '5106040',
    name: 'Belancan',
  },
  {
    id: '5106040010',
    districtId: '5106040',
    name: 'Katung',
  },
  {
    id: '5106040011',
    districtId: '5106040',
    name: 'Banua',
  },
  {
    id: '5106040012',
    districtId: '5106040',
    name: 'Abuan',
  },
  {
    id: '5106040013',
    districtId: '5106040',
    name: 'Bonyoh',
  },
  {
    id: '5106040014',
    districtId: '5106040',
    name: 'Sekaan',
  },
  {
    id: '5106040015',
    districtId: '5106040',
    name: 'Bayung Gede',
  },
  {
    id: '5106040016',
    districtId: '5106040',
    name: 'Sekardadi',
  },
  {
    id: '5106040017',
    districtId: '5106040',
    name: 'Kedisan',
  },
  {
    id: '5106040018',
    districtId: '5106040',
    name: 'Buahan',
  },
  {
    id: '5106040020',
    districtId: '5106040',
    name: 'Abang Batu Dinding',
  },
  {
    id: '5106040021',
    districtId: '5106040',
    name: 'Abang Songan',
  },
  {
    id: '5106040022',
    districtId: '5106040',
    name: 'Terunyan',
  },
  {
    id: '5106040023',
    districtId: '5106040',
    name: 'Songan B',
  },
  {
    id: '5106040024',
    districtId: '5106040',
    name: 'Songan A',
  },
  {
    id: '5106040025',
    districtId: '5106040',
    name: 'Batur Selatan',
  },
  {
    id: '5106040026',
    districtId: '5106040',
    name: 'Batur Tengah',
  },
  {
    id: '5106040027',
    districtId: '5106040',
    name: 'Batur Utara',
  },
  {
    id: '5106040028',
    districtId: '5106040',
    name: 'Kintamani',
  },
  {
    id: '5106040029',
    districtId: '5106040',
    name: 'Serahi',
  },
  {
    id: '5106040030',
    districtId: '5106040',
    name: 'Manikliyu',
  },
  {
    id: '5106040031',
    districtId: '5106040',
    name: 'Awan',
  },
  {
    id: '5106040032',
    districtId: '5106040',
    name: 'Belantih',
  },
  {
    id: '5106040033',
    districtId: '5106040',
    name: 'Gunungbau',
  },
  {
    id: '5106040034',
    districtId: '5106040',
    name: 'Belanga',
  },
  {
    id: '5106040035',
    districtId: '5106040',
    name: 'Batukaang',
  },
  {
    id: '5106040036',
    districtId: '5106040',
    name: 'Catur',
  },
  {
    id: '5106040037',
    districtId: '5106040',
    name: 'Pengejaran',
  },
  {
    id: '5106040038',
    districtId: '5106040',
    name: 'Satra',
  },
  {
    id: '5106040040',
    districtId: '5106040',
    name: 'Dausa',
  },
  {
    id: '5106040041',
    districtId: '5106040',
    name: 'Daup',
  },
  {
    id: '5106040042',
    districtId: '5106040',
    name: 'Bantang',
  },
  {
    id: '5106040044',
    districtId: '5106040',
    name: 'Sukawana',
  },
  {
    id: '5106040045',
    districtId: '5106040',
    name: 'Subaya',
  },
  {
    id: '5106040046',
    districtId: '5106040',
    name: 'Siyakin',
  },
  {
    id: '5106040047',
    districtId: '5106040',
    name: 'Pinggan',
  },
  {
    id: '5106040048',
    districtId: '5106040',
    name: 'Belandingan',
  },
  {
    id: '5107010001',
    districtId: '5107010',
    name: 'Pesaban',
  },
  {
    id: '5107010002',
    districtId: '5107010',
    name: 'Nongan',
  },
  {
    id: '5107010003',
    districtId: '5107010',
    name: 'Rendang',
  },
  {
    id: '5107010004',
    districtId: '5107010',
    name: 'Menanga',
  },
  {
    id: '5107010005',
    districtId: '5107010',
    name: 'Besakih',
  },
  {
    id: '5107010006',
    districtId: '5107010',
    name: 'Pempatan',
  },
  {
    id: '5107020001',
    districtId: '5107020',
    name: 'Tangkup',
  },
  {
    id: '5107020002',
    districtId: '5107020',
    name: 'Talibeng',
  },
  {
    id: '5107020003',
    districtId: '5107020',
    name: 'Telaga Tawang',
  },
  {
    id: '5107020004',
    districtId: '5107020',
    name: 'Sidemen',
  },
  {
    id: '5107020005',
    districtId: '5107020',
    name: 'Sindu Wati',
  },
  {
    id: '5107020006',
    districtId: '5107020',
    name: 'Sangkan Gunung',
  },
  {
    id: '5107020007',
    districtId: '5107020',
    name: 'Loka Sari',
  },
  {
    id: '5107020008',
    districtId: '5107020',
    name: 'Kertha Buana',
  },
  {
    id: '5107020009',
    districtId: '5107020',
    name: 'Tri Eka Buana',
  },
  {
    id: '5107020010',
    districtId: '5107020',
    name: 'Wisma Kerta',
  },
  {
    id: '5107030001',
    districtId: '5107030',
    name: 'Antiga',
  },
  {
    id: '5107030002',
    districtId: '5107030',
    name: 'Gegelang',
  },
  {
    id: '5107030003',
    districtId: '5107030',
    name: 'Padangbai',
  },
  {
    id: '5107030004',
    districtId: '5107030',
    name: 'Ulakan',
  },
  {
    id: '5107030005',
    districtId: '5107030',
    name: 'Manggis',
  },
  {
    id: '5107030007',
    districtId: '5107030',
    name: 'Ngis',
  },
  {
    id: '5107030009',
    districtId: '5107030',
    name: 'Tenganan',
  },
  {
    id: '5107030010',
    districtId: '5107030',
    name: 'Antiga Kelod',
  },
  {
    id: '5107030011',
    districtId: '5107030',
    name: 'Sengkidu',
  },
  {
    id: '5107030012',
    districtId: '5107030',
    name: 'Pesedahan',
  },
  {
    id: '5107040002',
    districtId: '5107040',
    name: 'Pertima',
  },
  {
    id: '5107040003',
    districtId: '5107040',
    name: 'Subagan',
  },
  {
    id: '5107040004',
    districtId: '5107040',
    name: 'Padang Kerta',
  },
  {
    id: '5107040005',
    districtId: '5107040',
    name: 'Karangasem',
  },
  {
    id: '5107040007',
    districtId: '5107040',
    name: 'Tegallinggah',
  },
  {
    id: '5107040008',
    districtId: '5107040',
    name: 'Bukit',
  },
  {
    id: '5107040009',
    districtId: '5107040',
    name: 'Seraya Barat',
  },
  {
    id: '5107040010',
    districtId: '5107040',
    name: 'Seraya',
  },
  {
    id: '5107040011',
    districtId: '5107040',
    name: 'Seraya Timur',
  },
  {
    id: '5107050001',
    districtId: '5107050',
    name: 'Ababi',
  },
  {
    id: '5107050002',
    districtId: '5107050',
    name: 'Tiyingtali',
  },
  {
    id: '5107050003',
    districtId: '5107050',
    name: 'Abang',
  },
  {
    id: '5107050004',
    districtId: '5107050',
    name: 'Pidpid',
  },
  {
    id: '5107050005',
    districtId: '5107050',
    name: 'Nawakerti',
  },
  {
    id: '5107050006',
    districtId: '5107050',
    name: 'Kesimpar',
  },
  {
    id: '5107050007',
    districtId: '5107050',
    name: 'Tista',
  },
  {
    id: '5107050008',
    districtId: '5107050',
    name: 'Kerta Mandala',
  },
  {
    id: '5107050009',
    districtId: '5107050',
    name: 'Culik',
  },
  {
    id: '5107050010',
    districtId: '5107050',
    name: 'Datah',
  },
  {
    id: '5107050011',
    districtId: '5107050',
    name: 'Laba Sari',
  },
  {
    id: '5107050012',
    districtId: '5107050',
    name: 'Purwakerti',
  },
  {
    id: '5107050013',
    districtId: '5107050',
    name: 'Bunutan',
  },
  {
    id: '5107050014',
    districtId: '5107050',
    name: 'Tri Buana',
  },
  {
    id: '5107060001',
    districtId: '5107060',
    name: 'Sibetan',
  },
  {
    id: '5107060002',
    districtId: '5107060',
    name: 'Bebandem',
  },
  {
    id: '5107060003',
    districtId: '5107060',
    name: 'Bungaya',
  },
  {
    id: '5107060004',
    districtId: '5107060',
    name: 'Bungaya Kangin',
  },
  {
    id: '5107060005',
    districtId: '5107060',
    name: 'Budakeling',
  },
  {
    id: '5107060006',
    districtId: '5107060',
    name: 'Bhuana Giri',
  },
  {
    id: '5107060007',
    districtId: '5107060',
    name: 'Jungutan',
  },
  {
    id: '5107060008',
    districtId: '5107060',
    name: 'Macang',
  },
  {
    id: '5107070001',
    districtId: '5107070',
    name: 'Muncan',
  },
  {
    id: '5107070002',
    districtId: '5107070',
    name: 'Pering Sari',
  },
  {
    id: '5107070003',
    districtId: '5107070',
    name: 'Selat',
  },
  {
    id: '5107070004',
    districtId: '5107070',
    name: 'Duda',
  },
  {
    id: '5107070005',
    districtId: '5107070',
    name: 'Duda Timur',
  },
  {
    id: '5107070006',
    districtId: '5107070',
    name: 'Duda Utara',
  },
  {
    id: '5107070007',
    districtId: '5107070',
    name: 'Sebudi',
  },
  {
    id: '5107070008',
    districtId: '5107070',
    name: 'Amerta Bhuana',
  },
  {
    id: '5107080001',
    districtId: '5107080',
    name: 'Ban',
  },
  {
    id: '5107080003',
    districtId: '5107080',
    name: 'Tulamben',
  },
  {
    id: '5107080005',
    districtId: '5107080',
    name: 'Baturinggit',
  },
  {
    id: '5107080006',
    districtId: '5107080',
    name: 'Sukadana',
  },
  {
    id: '5107080007',
    districtId: '5107080',
    name: 'Tianyar',
  },
  {
    id: '5107080008',
    districtId: '5107080',
    name: 'Tianyar Tengah',
  },
  {
    id: '5107080009',
    districtId: '5107080',
    name: 'Tianyar Barat',
  },
  {
    id: '5108010001',
    districtId: '5108010',
    name: 'Sumber Klampok',
  },
  {
    id: '5108010002',
    districtId: '5108010',
    name: 'Pejarakan',
  },
  {
    id: '5108010003',
    districtId: '5108010',
    name: 'Sumberkima',
  },
  {
    id: '5108010004',
    districtId: '5108010',
    name: 'Pemuteran',
  },
  {
    id: '5108010005',
    districtId: '5108010',
    name: 'Banyupoh',
  },
  {
    id: '5108010006',
    districtId: '5108010',
    name: 'Penyabangan',
  },
  {
    id: '5108010007',
    districtId: '5108010',
    name: 'Musi',
  },
  {
    id: '5108010008',
    districtId: '5108010',
    name: 'Sanggalangit',
  },
  {
    id: '5108010009',
    districtId: '5108010',
    name: 'Gerokgak',
  },
  {
    id: '5108010010',
    districtId: '5108010',
    name: 'Patas',
  },
  {
    id: '5108010011',
    districtId: '5108010',
    name: 'Pengulon',
  },
  {
    id: '5108010012',
    districtId: '5108010',
    name: 'Tinga Tinga',
  },
  {
    id: '5108010013',
    districtId: '5108010',
    name: 'Celukan Bawang',
  },
  {
    id: '5108010014',
    districtId: '5108010',
    name: 'Tukad Sumaga',
  },
  {
    id: '5108020001',
    districtId: '5108020',
    name: 'Unggahan',
  },
  {
    id: '5108020002',
    districtId: '5108020',
    name: 'Gunungsari',
  },
  {
    id: '5108020003',
    districtId: '5108020',
    name: 'Munduk Bestala',
  },
  {
    id: '5108020004',
    districtId: '5108020',
    name: 'Bestala',
  },
  {
    id: '5108020005',
    districtId: '5108020',
    name: 'Mayong',
  },
  {
    id: '5108020006',
    districtId: '5108020',
    name: 'Rangdu',
  },
  {
    id: '5108020007',
    districtId: '5108020',
    name: 'Ularan',
  },
  {
    id: '5108020008',
    districtId: '5108020',
    name: 'Ringdikit',
  },
  {
    id: '5108020009',
    districtId: '5108020',
    name: 'Joanyar',
  },
  {
    id: '5108020010',
    districtId: '5108020',
    name: 'Kalianget',
  },
  {
    id: '5108020011',
    districtId: '5108020',
    name: 'Tangguwisia',
  },
  {
    id: '5108020012',
    districtId: '5108020',
    name: 'Sulanyah',
  },
  {
    id: '5108020013',
    districtId: '5108020',
    name: 'Bubunan',
  },
  {
    id: '5108020014',
    districtId: '5108020',
    name: 'Seririt',
  },
  {
    id: '5108020015',
    districtId: '5108020',
    name: 'Pengastulan',
  },
  {
    id: '5108020016',
    districtId: '5108020',
    name: 'Patemon',
  },
  {
    id: '5108020017',
    districtId: '5108020',
    name: 'Lokapaksa',
  },
  {
    id: '5108020018',
    districtId: '5108020',
    name: 'Umeanyar',
  },
  {
    id: '5108020019',
    districtId: '5108020',
    name: 'Banjar Asem',
  },
  {
    id: '5108020020',
    districtId: '5108020',
    name: 'Kalisada',
  },
  {
    id: '5108020021',
    districtId: '5108020',
    name: 'Pangkungparuk',
  },
  {
    id: '5108030001',
    districtId: '5108030',
    name: 'Sepang Kelod',
  },
  {
    id: '5108030002',
    districtId: '5108030',
    name: 'Tista',
  },
  {
    id: '5108030003',
    districtId: '5108030',
    name: 'Bongancina',
  },
  {
    id: '5108030004',
    districtId: '5108030',
    name: 'Pucaksari',
  },
  {
    id: '5108030005',
    districtId: '5108030',
    name: 'Sepang',
  },
  {
    id: '5108030006',
    districtId: '5108030',
    name: 'Telaga',
  },
  {
    id: '5108030007',
    districtId: '5108030',
    name: 'Titab',
  },
  {
    id: '5108030008',
    districtId: '5108030',
    name: 'Kekeran',
  },
  {
    id: '5108030009',
    districtId: '5108030',
    name: 'Busungbiu',
  },
  {
    id: '5108030010',
    districtId: '5108030',
    name: 'Pelapuan',
  },
  {
    id: '5108030012',
    districtId: '5108030',
    name: 'Tinggarsari',
  },
  {
    id: '5108030013',
    districtId: '5108030',
    name: 'Kedis',
  },
  {
    id: '5108030015',
    districtId: '5108030',
    name: 'Umejero',
  },
  {
    id: '5108040001',
    districtId: '5108040',
    name: 'Banyuatis',
  },
  {
    id: '5108040002',
    districtId: '5108040',
    name: 'Gesing',
  },
  {
    id: '5108040004',
    districtId: '5108040',
    name: 'Gobleg',
  },
  {
    id: '5108040005',
    districtId: '5108040',
    name: 'Kayuputih',
  },
  {
    id: '5108040006',
    districtId: '5108040',
    name: 'Tirtasari',
  },
  {
    id: '5108040007',
    districtId: '5108040',
    name: 'Banyusri',
  },
  {
    id: '5108040008',
    districtId: '5108040',
    name: 'Pedawa',
  },
  {
    id: '5108040009',
    districtId: '5108040',
    name: 'Tigawasa',
  },
  {
    id: '5108040010',
    districtId: '5108040',
    name: 'Cempaga',
  },
  {
    id: '5108040011',
    districtId: '5108040',
    name: 'Sidetapa',
  },
  {
    id: '5108040012',
    districtId: '5108040',
    name: 'Tampekan',
  },
  {
    id: '5108040013',
    districtId: '5108040',
    name: 'Banjar Tegeha',
  },
  {
    id: '5108040014',
    districtId: '5108040',
    name: 'Banjar',
  },
  {
    id: '5108040015',
    districtId: '5108040',
    name: 'Dencarik',
  },
  {
    id: '5108040017',
    districtId: '5108040',
    name: 'Kaliasem',
  },
  {
    id: '5108050001',
    districtId: '5108050',
    name: 'Pancasari',
  },
  {
    id: '5108050002',
    districtId: '5108050',
    name: 'Wanagiri',
  },
  {
    id: '5108050003',
    districtId: '5108050',
    name: 'Ambengan',
  },
  {
    id: '5108050004',
    districtId: '5108050',
    name: 'Gitgit',
  },
  {
    id: '5108050005',
    districtId: '5108050',
    name: 'Pegayaman',
  },
  {
    id: '5108050006',
    districtId: '5108050',
    name: 'Silangjana',
  },
  {
    id: '5108050007',
    districtId: '5108050',
    name: 'Pegadungan',
  },
  {
    id: '5108050008',
    districtId: '5108050',
    name: 'Padangbulia',
  },
  {
    id: '5108050009',
    districtId: '5108050',
    name: 'Sukasada',
  },
  {
    id: '5108050010',
    districtId: '5108050',
    name: 'Sambangan',
  },
  {
    id: '5108050011',
    districtId: '5108050',
    name: 'Panji',
  },
  {
    id: '5108050012',
    districtId: '5108050',
    name: 'Panji Anom',
  },
  {
    id: '5108050013',
    districtId: '5108050',
    name: 'Tegal Linggah',
  },
  {
    id: '5108050014',
    districtId: '5108050',
    name: 'Selat',
  },
  {
    id: '5108050015',
    districtId: '5108050',
    name: 'Kayuputih',
  },
  {
    id: '5108060001',
    districtId: '5108060',
    name: 'Kalibukbuk',
  },
  {
    id: '5108060002',
    districtId: '5108060',
    name: 'Anturan',
  },
  {
    id: '5108060003',
    districtId: '5108060',
    name: 'Tukadmungga',
  },
  {
    id: '5108060004',
    districtId: '5108060',
    name: 'Pemaron',
  },
  {
    id: '5108060005',
    districtId: '5108060',
    name: 'Baktiseraga',
  },
  {
    id: '5108060006',
    districtId: '5108060',
    name: 'Banyuasri',
  },
  {
    id: '5108060007',
    districtId: '5108060',
    name: 'Banjar Tegal',
  },
  {
    id: '5108060008',
    districtId: '5108060',
    name: 'Paket Agung',
  },
  {
    id: '5108060009',
    districtId: '5108060',
    name: 'Beratan',
  },
  {
    id: '5108060010',
    districtId: '5108060',
    name: 'Liligundi',
  },
  {
    id: '5108060011',
    districtId: '5108060',
    name: 'Kampung Singaraja',
  },
  {
    id: '5108060012',
    districtId: '5108060',
    name: 'Kendran',
  },
  {
    id: '5108060013',
    districtId: '5108060',
    name: 'Astina',
  },
  {
    id: '5108060014',
    districtId: '5108060',
    name: 'Banjar Jawa',
  },
  {
    id: '5108060015',
    districtId: '5108060',
    name: 'Banjar Bali',
  },
  {
    id: '5108060016',
    districtId: '5108060',
    name: 'Kampung Kajanan',
  },
  {
    id: '5108060017',
    districtId: '5108060',
    name: 'Kaliuntu',
  },
  {
    id: '5108060018',
    districtId: '5108060',
    name: 'Kampung Anyar',
  },
  {
    id: '5108060019',
    districtId: '5108060',
    name: 'Kampung Bugis',
  },
  {
    id: '5108060020',
    districtId: '5108060',
    name: 'Kampung Baru',
  },
  {
    id: '5108060021',
    districtId: '5108060',
    name: 'Banyuning',
  },
  {
    id: '5108060022',
    districtId: '5108060',
    name: 'Penarukan',
  },
  {
    id: '5108060023',
    districtId: '5108060',
    name: 'Jinengdalem',
  },
  {
    id: '5108060024',
    districtId: '5108060',
    name: 'Penglatan',
  },
  {
    id: '5108060025',
    districtId: '5108060',
    name: 'Petandakan',
  },
  {
    id: '5108060026',
    districtId: '5108060',
    name: 'Sari Mekar',
  },
  {
    id: '5108060027',
    districtId: '5108060',
    name: 'Nagasepaha',
  },
  {
    id: '5108060028',
    districtId: '5108060',
    name: 'Alasangker',
  },
  {
    id: '5108060029',
    districtId: '5108060',
    name: 'Poh Bergong',
  },
  {
    id: '5108070001',
    districtId: '5108070',
    name: 'Lemukih',
  },
  {
    id: '5108070002',
    districtId: '5108070',
    name: 'Galungan',
  },
  {
    id: '5108070004',
    districtId: '5108070',
    name: 'Bebetin',
  },
  {
    id: '5108070005',
    districtId: '5108070',
    name: 'Sudaji',
  },
  {
    id: '5108070006',
    districtId: '5108070',
    name: 'Sawan',
  },
  {
    id: '5108070007',
    districtId: '5108070',
    name: 'Menyali',
  },
  {
    id: '5108070009',
    districtId: '5108070',
    name: 'Jagaraga',
  },
  {
    id: '5108070010',
    districtId: '5108070',
    name: 'Sinabun',
  },
  {
    id: '5108070011',
    districtId: '5108070',
    name: 'Kerobokan',
  },
  {
    id: '5108070012',
    districtId: '5108070',
    name: 'Sangsit',
  },
  {
    id: '5108070013',
    districtId: '5108070',
    name: 'Bungkulan',
  },
  {
    id: '5108070014',
    districtId: '5108070',
    name: 'Giri Emas',
  },
  {
    id: '5108080001',
    districtId: '5108080',
    name: 'Tambakan',
  },
  {
    id: '5108080002',
    districtId: '5108080',
    name: 'Pakisan',
  },
  {
    id: '5108080003',
    districtId: '5108080',
    name: 'Bontihing',
  },
  {
    id: '5108080004',
    districtId: '5108080',
    name: 'Tajun',
  },
  {
    id: '5108080006',
    districtId: '5108080',
    name: 'Depeha',
  },
  {
    id: '5108080007',
    districtId: '5108080',
    name: 'Bulian',
  },
  {
    id: '5108080008',
    districtId: '5108080',
    name: 'Tamblang',
  },
  {
    id: '5108080009',
    districtId: '5108080',
    name: 'Bila',
  },
  {
    id: '5108080010',
    districtId: '5108080',
    name: 'Bengkala',
  },
  {
    id: '5108080011',
    districtId: '5108080',
    name: 'Kubutambahan',
  },
  {
    id: '5108080012',
    districtId: '5108080',
    name: 'Bukti',
  },
  {
    id: '5108080013',
    districtId: '5108080',
    name: 'Mengening',
  },
  {
    id: '5108090001',
    districtId: '5108090',
    name: 'Sembiran',
  },
  {
    id: '5108090002',
    districtId: '5108090',
    name: 'Pacung',
  },
  {
    id: '5108090003',
    districtId: '5108090',
    name: 'Julah',
  },
  {
    id: '5108090004',
    districtId: '5108090',
    name: 'Bondalem',
  },
  {
    id: '5108090005',
    districtId: '5108090',
    name: 'Madenan',
  },
  {
    id: '5108090006',
    districtId: '5108090',
    name: 'Tejakula',
  },
  {
    id: '5108090008',
    districtId: '5108090',
    name: 'Penuktukan',
  },
  {
    id: '5108090009',
    districtId: '5108090',
    name: 'Sambirenteng',
  },
  {
    id: '5108090010',
    districtId: '5108090',
    name: 'Tembok',
  },
  {
    id: '5171010001',
    districtId: '5171010',
    name: 'Pemogan',
  },
  {
    id: '5171010002',
    districtId: '5171010',
    name: 'Pedungan',
  },
  {
    id: '5171010003',
    districtId: '5171010',
    name: 'Sesetan',
  },
  {
    id: '5171010004',
    districtId: '5171010',
    name: 'Serangan',
  },
  {
    id: '5171010005',
    districtId: '5171010',
    name: 'Sidakarya',
  },
  {
    id: '5171010006',
    districtId: '5171010',
    name: 'Panjer',
  },
  {
    id: '5171010007',
    districtId: '5171010',
    name: 'Renon',
  },
  {
    id: '5171010008',
    districtId: '5171010',
    name: 'Sanur Kauh',
  },
  {
    id: '5171010009',
    districtId: '5171010',
    name: 'Sanur',
  },
  {
    id: '5171010010',
    districtId: '5171010',
    name: 'Sanur Kaja',
  },
  {
    id: '5171020001',
    districtId: '5171020',
    name: 'Dangin Puri Klod',
  },
  {
    id: '5171020002',
    districtId: '5171020',
    name: 'Sumerta Kelod',
  },
  {
    id: '5171020003',
    districtId: '5171020',
    name: 'Kesiman',
  },
  {
    id: '5171020004',
    districtId: '5171020',
    name: 'Kesiman Petilan',
  },
  {
    id: '5171020005',
    districtId: '5171020',
    name: 'Kesiman Kertalangu',
  },
  {
    id: '5171020006',
    districtId: '5171020',
    name: 'Sumerta',
  },
  {
    id: '5171020007',
    districtId: '5171020',
    name: 'Sumerta Kaja',
  },
  {
    id: '5171020008',
    districtId: '5171020',
    name: 'Sumerta Kauh',
  },
  {
    id: '5171020010',
    districtId: '5171020',
    name: 'Dangin Puri',
  },
  {
    id: '5171020014',
    districtId: '5171020',
    name: 'Penatih',
  },
  {
    id: '5171020015',
    districtId: '5171020',
    name: 'Penatih Dangin Puri',
  },
  {
    id: '5171030001',
    districtId: '5171030',
    name: 'Padangsambian Klod',
  },
  {
    id: '5171030002',
    districtId: '5171030',
    name: 'Pemecutan Klod',
  },
  {
    id: '5171030003',
    districtId: '5171030',
    name: 'Dauh Puri Kauh',
  },
  {
    id: '5171030004',
    districtId: '5171030',
    name: 'Dauh Puri Klod',
  },
  {
    id: '5171030005',
    districtId: '5171030',
    name: 'Dauh Puri',
  },
  {
    id: '5171030006',
    districtId: '5171030',
    name: 'Dauh Puri Kangin',
  },
  {
    id: '5171030007',
    districtId: '5171030',
    name: 'Pemecutan',
  },
  {
    id: '5171030008',
    districtId: '5171030',
    name: 'Tegal Harum',
  },
  {
    id: '5171030009',
    districtId: '5171030',
    name: 'Tegal Kertha',
  },
  {
    id: '5171030010',
    districtId: '5171030',
    name: 'Padangsambian',
  },
  {
    id: '5171030011',
    districtId: '5171030',
    name: 'Padangsambian Kaja',
  },
  {
    id: '5171031001',
    districtId: '5171031',
    name: 'Pemecutan Kaja',
  },
  {
    id: '5171031002',
    districtId: '5171031',
    name: 'Dauh Puri Kaja',
  },
  {
    id: '5171031003',
    districtId: '5171031',
    name: 'Dangin Puri Kauh',
  },
  {
    id: '5171031004',
    districtId: '5171031',
    name: 'Dangin Puri Kaja',
  },
  {
    id: '5171031005',
    districtId: '5171031',
    name: 'Dangin Puri Kangin',
  },
  {
    id: '5171031006',
    districtId: '5171031',
    name: 'Tonja',
  },
  {
    id: '5171031007',
    districtId: '5171031',
    name: 'Peguyangan',
  },
  {
    id: '5171031009',
    districtId: '5171031',
    name: 'Ubung  Kaja',
  },
  {
    id: '5171031010',
    districtId: '5171031',
    name: 'Peguyangan Kaja',
  },
  {
    id: '5171031011',
    districtId: '5171031',
    name: 'Peguyangan Kangin',
  },
  {
    id: '5201010001',
    districtId: '5201010',
    name: 'Pelangan',
  },
  {
    id: '5201010002',
    districtId: '5201010',
    name: 'Sekotong Barat',
  },
  {
    id: '5201010003',
    districtId: '5201010',
    name: 'Buwun Mas',
  },
  {
    id: '5201010004',
    districtId: '5201010',
    name: 'Sekotong Tengah',
  },
  {
    id: '5201010005',
    districtId: '5201010',
    name: 'Kedaro',
  },
  {
    id: '5201010006',
    districtId: '5201010',
    name: 'Batu Putih',
  },
  {
    id: '5201010007',
    districtId: '5201010',
    name: 'Cendi Manik',
  },
  {
    id: '5201010008',
    districtId: '5201010',
    name: 'Gili Gede Indah',
  },
  {
    id: '5201010011',
    districtId: '5201010',
    name: 'Taman Baru',
  },
  {
    id: '5201011001',
    districtId: '5201011',
    name: 'Mareje',
  },
  {
    id: '5201011002',
    districtId: '5201011',
    name: 'Sekotong Timur',
  },
  {
    id: '5201011003',
    districtId: '5201011',
    name: 'Lembar',
  },
  {
    id: '5201011004',
    districtId: '5201011',
    name: 'Jembatan Kembar',
  },
  {
    id: '5201011005',
    districtId: '5201011',
    name: 'Labuan Tereng',
  },
  {
    id: '5201011006',
    districtId: '5201011',
    name: 'Mareje Timur',
  },
  {
    id: '5201011007',
    districtId: '5201011',
    name: 'Lembar Selatan',
  },
  {
    id: '5201011008',
    districtId: '5201011',
    name: 'Jembatan Gantung',
  },
  {
    id: '5201011009',
    districtId: '5201011',
    name: 'Jembatan Kembar Timur',
  },
  {
    id: '5201011010',
    districtId: '5201011',
    name: 'Eyat Mayang',
  },
  {
    id: '5201020003',
    districtId: '5201020',
    name: 'Banyu Urip',
  },
  {
    id: '5201020004',
    districtId: '5201020',
    name: 'Dasan Geres',
  },
  {
    id: '5201020005',
    districtId: '5201020',
    name: 'Babussalam',
  },
  {
    id: '5201020006',
    districtId: '5201020',
    name: 'Dasan Tapen',
  },
  {
    id: '5201020009',
    districtId: '5201020',
    name: 'Kebunayu',
  },
  {
    id: '5201020010',
    districtId: '5201020',
    name: 'Gapuk',
  },
  {
    id: '5201020011',
    districtId: '5201020',
    name: 'Suka Makmur',
  },
  {
    id: '5201020012',
    districtId: '5201020',
    name: 'Tempos',
  },
  {
    id: '5201020013',
    districtId: '5201020',
    name: 'Gerung Selatan',
  },
  {
    id: '5201020014',
    districtId: '5201020',
    name: 'Gerung Utara',
  },
  {
    id: '5201020015',
    districtId: '5201020',
    name: 'Mesanggok',
  },
  {
    id: '5201020016',
    districtId: '5201020',
    name: 'Giri Tembesi',
  },
  {
    id: '5201020017',
    districtId: '5201020',
    name: 'Taman Ayu',
  },
  {
    id: '5201030001',
    districtId: '5201030',
    name: 'Kuranji',
  },
  {
    id: '5201030002',
    districtId: '5201030',
    name: 'Perampuan',
  },
  {
    id: '5201030003',
    districtId: '5201030',
    name: 'Karang Bongkot',
  },
  {
    id: '5201030004',
    districtId: '5201030',
    name: 'Terong Tawah',
  },
  {
    id: '5201030005',
    districtId: '5201030',
    name: 'Bajur',
  },
  {
    id: '5201030006',
    districtId: '5201030',
    name: 'Telaga Waru',
  },
  {
    id: '5201030007',
    districtId: '5201030',
    name: 'Bagik Polak',
  },
  {
    id: '5201030010',
    districtId: '5201030',
    name: 'Labu Api',
  },
  {
    id: '5201030011',
    districtId: '5201030',
    name: 'Kuranji Dalang',
  },
  {
    id: '5201030012',
    districtId: '5201030',
    name: 'Bagik Polak Barat',
  },
  {
    id: '5201040005',
    districtId: '5201040',
    name: 'Jagaraga Indah',
  },
  {
    id: '5201040006',
    districtId: '5201040',
    name: 'Montong Are',
  },
  {
    id: '5201040007',
    districtId: '5201040',
    name: 'Kediri',
  },
  {
    id: '5201040008',
    districtId: '5201040',
    name: 'Gelogor',
  },
  {
    id: '5201040009',
    districtId: '5201040',
    name: 'Rumak',
  },
  {
    id: '5201040010',
    districtId: '5201040',
    name: 'Banyumulek',
  },
  {
    id: '5201040011',
    districtId: '5201040',
    name: 'Ombe Baru',
  },
  {
    id: '5201040012',
    districtId: '5201040',
    name: 'Dasan Baru',
  },
  {
    id: '5201040013',
    districtId: '5201040',
    name: 'Kediri Selatan',
  },
  {
    id: '5201041001',
    districtId: '5201041',
    name: 'Kuripan Selatan',
  },
  {
    id: '5201041002',
    districtId: '5201041',
    name: 'Kuripan',
  },
  {
    id: '5201041003',
    districtId: '5201041',
    name: 'Kuripan Utara',
  },
  {
    id: '5201041004',
    districtId: '5201041',
    name: 'Jagaraga',
  },
  {
    id: '5201041005',
    districtId: '5201041',
    name: 'Giri Sasak',
  },
  {
    id: '5201041006',
    districtId: '5201041',
    name: 'Kuripan Timur',
  },
  {
    id: '5201050002',
    districtId: '5201050',
    name: 'Badrain',
  },
  {
    id: '5201050003',
    districtId: '5201050',
    name: 'Batu Kuta',
  },
  {
    id: '5201050004',
    districtId: '5201050',
    name: 'Tanak Beak',
  },
  {
    id: '5201050005',
    districtId: '5201050',
    name: 'Peresak',
  },
  {
    id: '5201050007',
    districtId: '5201050',
    name: 'Sedau',
  },
  {
    id: '5201050008',
    districtId: '5201050',
    name: 'Lebah Sempage',
  },
  {
    id: '5201050009',
    districtId: '5201050',
    name: 'Sesaot',
  },
  {
    id: '5201050010',
    districtId: '5201050',
    name: 'Suranadi',
  },
  {
    id: '5201050011',
    districtId: '5201050',
    name: 'Selat',
  },
  {
    id: '5201050012',
    districtId: '5201050',
    name: 'Nyur Lembang',
  },
  {
    id: '5201050013',
    districtId: '5201050',
    name: 'Lembuak',
  },
  {
    id: '5201050014',
    districtId: '5201050',
    name: 'Dasan Tereng',
  },
  {
    id: '5201050015',
    districtId: '5201050',
    name: 'Krama Jaya',
  },
  {
    id: '5201050016',
    districtId: '5201050',
    name: 'Gerimax Indah',
  },
  {
    id: '5201050017',
    districtId: '5201050',
    name: 'Narmada',
  },
  {
    id: '5201050018',
    districtId: '5201050',
    name: 'Golong',
  },
  {
    id: '5201050019',
    districtId: '5201050',
    name: 'Pakuan',
  },
  {
    id: '5201050020',
    districtId: '5201050',
    name: 'Buwun Sejati',
  },
  {
    id: '5201050021',
    districtId: '5201050',
    name: 'Mekar Sari',
  },
  {
    id: '5201051001',
    districtId: '5201051',
    name: 'Peteluan Indah',
  },
  {
    id: '5201051002',
    districtId: '5201051',
    name: 'Lingsar',
  },
  {
    id: '5201051003',
    districtId: '5201051',
    name: 'Batu Kumbung',
  },
  {
    id: '5201051004',
    districtId: '5201051',
    name: 'Batu Mekar',
  },
  {
    id: '5201051005',
    districtId: '5201051',
    name: 'Karang Bayan',
  },
  {
    id: '5201051006',
    districtId: '5201051',
    name: 'Langko',
  },
  {
    id: '5201051007',
    districtId: '5201051',
    name: 'Sigerongan',
  },
  {
    id: '5201051008',
    districtId: '5201051',
    name: 'Duman',
  },
  {
    id: '5201051009',
    districtId: '5201051',
    name: 'Dasan Geria',
  },
  {
    id: '5201051011',
    districtId: '5201051',
    name: 'Giri Madia',
  },
  {
    id: '5201051012',
    districtId: '5201051',
    name: 'Gegelang',
  },
  {
    id: '5201051013',
    districtId: '5201051',
    name: 'Gontoran',
  },
  {
    id: '5201051014',
    districtId: '5201051',
    name: 'Saribaye',
  },
  {
    id: '5201060001',
    districtId: '5201060',
    name: 'Jati Sela',
  },
  {
    id: '5201060002',
    districtId: '5201060',
    name: 'Sesela',
  },
  {
    id: '5201060003',
    districtId: '5201060',
    name: 'Midang',
  },
  {
    id: '5201060004',
    districtId: '5201060',
    name: 'Kekeri',
  },
  {
    id: '5201060005',
    districtId: '5201060',
    name: 'Penimbung',
  },
  {
    id: '5201060006',
    districtId: '5201060',
    name: 'Mambalan',
  },
  {
    id: '5201060007',
    districtId: '5201060',
    name: 'Dopang',
  },
  {
    id: '5201060008',
    districtId: '5201060',
    name: 'Taman Sari',
  },
  {
    id: '5201060009',
    districtId: '5201060',
    name: 'Gunung Sari',
  },
  {
    id: '5201060014',
    districtId: '5201060',
    name: 'Kekait',
  },
  {
    id: '5201060015',
    districtId: '5201060',
    name: 'Mekar Sari',
  },
  {
    id: '5201060016',
    districtId: '5201060',
    name: 'Guntur Macan',
  },
  {
    id: '5201060017',
    districtId: '5201060',
    name: 'Gelangsar',
  },
  {
    id: '5201060018',
    districtId: '5201060',
    name: 'Ranjok',
  },
  {
    id: '5201060019',
    districtId: '5201060',
    name: 'Bukit Tinggi',
  },
  {
    id: '5201060020',
    districtId: '5201060',
    name: 'Jeringo',
  },
  {
    id: '5201061001',
    districtId: '5201061',
    name: 'Sandik',
  },
  {
    id: '5201061002',
    districtId: '5201061',
    name: 'Meninting',
  },
  {
    id: '5201061003',
    districtId: '5201061',
    name: 'Batu Layar',
  },
  {
    id: '5201061004',
    districtId: '5201061',
    name: 'Lembah Sari',
  },
  {
    id: '5201061006',
    districtId: '5201061',
    name: 'Senggigi',
  },
  {
    id: '5201061007',
    districtId: '5201061',
    name: 'Batu Layar Barat',
  },
  {
    id: '5201061008',
    districtId: '5201061',
    name: 'Bengkaung',
  },
  {
    id: '5201061009',
    districtId: '5201061',
    name: 'Pusuk Lestari',
  },
  {
    id: '5202010002',
    districtId: '5202010',
    name: 'Selong Belanak',
  },
  {
    id: '5202010003',
    districtId: '5202010',
    name: 'Mekar Sari',
  },
  {
    id: '5202010004',
    districtId: '5202010',
    name: 'Banyu Urip',
  },
  {
    id: '5202010005',
    districtId: '5202010',
    name: 'Kateng',
  },
  {
    id: '5202010006',
    districtId: '5202010',
    name: 'Mangkung',
  },
  {
    id: '5202010007',
    districtId: '5202010',
    name: 'Bondir',
  },
  {
    id: '5202010013',
    districtId: '5202010',
    name: 'Setanggor',
  },
  {
    id: '5202010014',
    districtId: '5202010',
    name: 'Penujak',
  },
  {
    id: '5202010015',
    districtId: '5202010',
    name: 'Batujai',
  },
  {
    id: '5202010016',
    districtId: '5202010',
    name: 'Tanak Rarang',
  },
  {
    id: '5202011001',
    districtId: '5202011',
    name: 'Montong Sapah',
  },
  {
    id: '5202011002',
    districtId: '5202011',
    name: 'Kabul',
  },
  {
    id: '5202011003',
    districtId: '5202011',
    name: 'Pelambik',
  },
  {
    id: '5202011004',
    districtId: '5202011',
    name: 'Ranggagata',
  },
  {
    id: '5202011005',
    districtId: '5202011',
    name: 'Ungga',
  },
  {
    id: '5202011006',
    districtId: '5202011',
    name: 'Darek',
  },
  {
    id: '5202011007',
    districtId: '5202011',
    name: 'Batu Jangkih',
  },
  {
    id: '5202011008',
    districtId: '5202011',
    name: 'Montong Ajan',
  },
  {
    id: '5202011009',
    districtId: '5202011',
    name: 'Pandan Indah',
  },
  {
    id: '5202011010',
    districtId: '5202011',
    name: 'Serage',
  },
  {
    id: '5202020001',
    districtId: '5202020',
    name: 'Tumpak',
  },
  {
    id: '5202020002',
    districtId: '5202020',
    name: 'Prabu',
  },
  {
    id: '5202020003',
    districtId: '5202020',
    name: 'Kuta',
  },
  {
    id: '5202020004',
    districtId: '5202020',
    name: 'Rembitan',
  },
  {
    id: '5202020005',
    districtId: '5202020',
    name: 'Sukadana',
  },
  {
    id: '5202020006',
    districtId: '5202020',
    name: 'Mertak',
  },
  {
    id: '5202020007',
    districtId: '5202020',
    name: 'Pengengat',
  },
  {
    id: '5202020008',
    districtId: '5202020',
    name: 'Teruwai',
  },
  {
    id: '5202020009',
    districtId: '5202020',
    name: 'Gapura',
  },
  {
    id: '5202020010',
    districtId: '5202020',
    name: 'Kawo',
  },
  {
    id: '5202020011',
    districtId: '5202020',
    name: 'Segale Anyar',
  },
  {
    id: '5202020012',
    districtId: '5202020',
    name: 'Sengkol',
  },
  {
    id: '5202020014',
    districtId: '5202020',
    name: 'Ketara',
  },
  {
    id: '5202020015',
    districtId: '5202020',
    name: 'Tanak Awu',
  },
  {
    id: '5202020016',
    districtId: '5202020',
    name: 'Bangket Parak',
  },
  {
    id: '5202030001',
    districtId: '5202030',
    name: 'Kidang',
  },
  {
    id: '5202030002',
    districtId: '5202030',
    name: 'Bilelando',
  },
  {
    id: '5202030003',
    districtId: '5202030',
    name: 'Semoyang',
  },
  {
    id: '5202030004',
    districtId: '5202030',
    name: 'Ganti',
  },
  {
    id: '5202030005',
    districtId: '5202030',
    name: 'Beleka',
  },
  {
    id: '5202030006',
    districtId: '5202030',
    name: 'Sengkerang',
  },
  {
    id: '5202030007',
    districtId: '5202030',
    name: 'Landah',
  },
  {
    id: '5202030008',
    districtId: '5202030',
    name: 'Marong',
  },
  {
    id: '5202030010',
    districtId: '5202030',
    name: 'Sukaraja',
  },
  {
    id: '5202040001',
    districtId: '5202040',
    name: 'Loang Maka',
  },
  {
    id: '5202040002',
    districtId: '5202040',
    name: 'Langko',
  },
  {
    id: '5202040003',
    districtId: '5202040',
    name: 'Selebung Rembiga',
  },
  {
    id: '5202040004',
    districtId: '5202040',
    name: 'Bakan',
  },
  {
    id: '5202040005',
    districtId: '5202040',
    name: 'Durian',
  },
  {
    id: '5202040007',
    districtId: '5202040',
    name: 'Janapria',
  },
  {
    id: '5202040008',
    districtId: '5202040',
    name: 'Saba',
  },
  {
    id: '5202040009',
    districtId: '5202040',
    name: 'Lekor',
  },
  {
    id: '5202040010',
    districtId: '5202040',
    name: 'Kerembong',
  },
  {
    id: '5202040011',
    districtId: '5202040',
    name: 'Jango',
  },
  {
    id: '5202040012',
    districtId: '5202040',
    name: 'Setuta',
  },
  {
    id: '5202050001',
    districtId: '5202050',
    name: 'Muncan',
  },
  {
    id: '5202050002',
    districtId: '5202050',
    name: 'Monggas',
  },
  {
    id: '5202050003',
    districtId: '5202050',
    name: 'Darmaji',
  },
  {
    id: '5202050004',
    districtId: '5202050',
    name: 'Dasan Baru',
  },
  {
    id: '5202050005',
    districtId: '5202050',
    name: 'Kopang Rembiga',
  },
  {
    id: '5202050006',
    districtId: '5202050',
    name: 'Montong Gamang',
  },
  {
    id: '5202050007',
    districtId: '5202050',
    name: 'Lendang Ara',
  },
  {
    id: '5202050008',
    districtId: '5202050',
    name: 'Bebuaq',
  },
  {
    id: '5202050009',
    districtId: '5202050',
    name: 'Waja Geseng',
  },
  {
    id: '5202050010',
    districtId: '5202050',
    name: 'Semparu',
  },
  {
    id: '5202050011',
    districtId: '5202050',
    name: 'Aik Bual',
  },
  {
    id: '5202060001',
    districtId: '5202060',
    name: 'Panjisari',
  },
  {
    id: '5202060004',
    districtId: '5202060',
    name: 'Praya',
  },
  {
    id: '5202060005',
    districtId: '5202060',
    name: 'Prapen',
  },
  {
    id: '5202060006',
    districtId: '5202060',
    name: 'Tiwugalih',
  },
  {
    id: '5202060009',
    districtId: '5202060',
    name: 'Semayan',
  },
  {
    id: '5202060018',
    districtId: '5202060',
    name: 'Bunut Baok',
  },
  {
    id: '5202060020',
    districtId: '5202060',
    name: 'Gonjak',
  },
  {
    id: '5202060021',
    districtId: '5202060',
    name: 'Jago',
  },
  {
    id: '5202060022',
    districtId: '5202060',
    name: 'Aik Mual',
  },
  {
    id: '5202060023',
    districtId: '5202060',
    name: 'Mertak Tombok',
  },
  {
    id: '5202060024',
    districtId: '5202060',
    name: 'Montong Terep',
  },
  {
    id: '5202060025',
    districtId: '5202060',
    name: 'Mekar Damai',
  },
  {
    id: '5202061001',
    districtId: '5202061',
    name: 'Jontlak',
  },
  {
    id: '5202061002',
    districtId: '5202061',
    name: 'Gerantung',
  },
  {
    id: '5202061003',
    districtId: '5202061',
    name: 'Sasake',
  },
  {
    id: '5202061004',
    districtId: '5202061',
    name: 'Lajut',
  },
  {
    id: '5202061005',
    districtId: '5202061',
    name: 'Batunyala',
  },
  {
    id: '5202061006',
    districtId: '5202061',
    name: 'Pejanggik',
  },
  {
    id: '5202061008',
    districtId: '5202061',
    name: 'Beraim',
  },
  {
    id: '5202061009',
    districtId: '5202061',
    name: 'Pengadang',
  },
  {
    id: '5202061010',
    districtId: '5202061',
    name: 'Jurang Jaler',
  },
  {
    id: '5202061011',
    districtId: '5202061',
    name: 'Dakung',
  },
  {
    id: '5202061012',
    districtId: '5202061',
    name: 'Prai Meke',
  },
  {
    id: '5202070001',
    districtId: '5202070',
    name: 'Labulia',
  },
  {
    id: '5202070002',
    districtId: '5202070',
    name: 'Sukarara',
  },
  {
    id: '5202070005',
    districtId: '5202070',
    name: 'Barejulat',
  },
  {
    id: '5202070006',
    districtId: '5202070',
    name: 'Bunkate',
  },
  {
    id: '5202070007',
    districtId: '5202070',
    name: 'Nyerot',
  },
  {
    id: '5202070008',
    districtId: '5202070',
    name: 'Batutulis',
  },
  {
    id: '5202070009',
    districtId: '5202070',
    name: 'Jelantik',
  },
  {
    id: '5202070011',
    districtId: '5202070',
    name: 'Bonjeruk',
  },
  {
    id: '5202070012',
    districtId: '5202070',
    name: 'Perina',
  },
  {
    id: '5202080001',
    districtId: '5202080',
    name: 'Bilebante',
  },
  {
    id: '5202080002',
    districtId: '5202080',
    name: 'Bagu',
  },
  {
    id: '5202080003',
    districtId: '5202080',
    name: 'Sintung',
  },
  {
    id: '5202080004',
    districtId: '5202080',
    name: 'Pringgarata',
  },
  {
    id: '5202080005',
    districtId: '5202080',
    name: 'Murbaya',
  },
  {
    id: '5202080006',
    districtId: '5202080',
    name: 'Sepakek',
  },
  {
    id: '5202080009',
    districtId: '5202080',
    name: 'Arjangka',
  },
  {
    id: '5202080010',
    districtId: '5202080',
    name: 'Taman Indah',
  },
  {
    id: '5202080011',
    districtId: '5202080',
    name: 'Sisik',
  },
  {
    id: '5202090002',
    districtId: '5202090',
    name: 'Pagutan',
  },
  {
    id: '5202090003',
    districtId: '5202090',
    name: 'Barabali',
  },
  {
    id: '5202090004',
    districtId: '5202090',
    name: 'Bujak',
  },
  {
    id: '5202090005',
    districtId: '5202090',
    name: 'Peresak',
  },
  {
    id: '5202090006',
    districtId: '5202090',
    name: 'Mantang',
  },
  {
    id: '5202090007',
    districtId: '5202090',
    name: 'Aik Dareq',
  },
  {
    id: '5202090009',
    districtId: '5202090',
    name: 'Tampak Siring',
  },
  {
    id: '5202090010',
    districtId: '5202090',
    name: 'Mekar Bersatu',
  },
  {
    id: '5202091001',
    districtId: '5202091',
    name: 'Mas-Mas',
  },
  {
    id: '5202091002',
    districtId: '5202091',
    name: 'Aik Bukaq',
  },
  {
    id: '5202091003',
    districtId: '5202091',
    name: 'Setiling',
  },
  {
    id: '5202091004',
    districtId: '5202091',
    name: 'Aik Berik',
  },
  {
    id: '5202091005',
    districtId: '5202091',
    name: 'Teratak',
  },
  {
    id: '5202091006',
    districtId: '5202091',
    name: 'Lantan',
  },
  {
    id: '5202091007',
    districtId: '5202091',
    name: 'Tanak Beaq',
  },
  {
    id: '5202091008',
    districtId: '5202091',
    name: 'Karang Sidemen',
  },
  {
    id: '5203010005',
    districtId: '5203010',
    name: 'Tanjung Luar',
  },
  {
    id: '5203010006',
    districtId: '5203010',
    name: 'Pijot',
  },
  {
    id: '5203010007',
    districtId: '5203010',
    name: 'Selebung Ketangga',
  },
  {
    id: '5203010008',
    districtId: '5203010',
    name: 'Sepit',
  },
  {
    id: '5203010009',
    districtId: '5203010',
    name: 'Keruak',
  },
  {
    id: '5203010010',
    districtId: '5203010',
    name: 'Batu Putik',
  },
  {
    id: '5203010011',
    districtId: '5203010',
    name: 'Senyiur',
  },
  {
    id: '5203010012',
    districtId: '5203010',
    name: 'Ketapang Raya',
  },
  {
    id: '5203010013',
    districtId: '5203010',
    name: 'Pijot Utara',
  },
  {
    id: '5203010014',
    districtId: '5203010',
    name: 'Ketangga Jeraing',
  },
  {
    id: '5203010015',
    districtId: '5203010',
    name: 'Mendana Raya',
  },
  {
    id: '5203010016',
    districtId: '5203010',
    name: 'Setungkep Lingsar',
  },
  {
    id: '5203010017',
    districtId: '5203010',
    name: 'Danerase',
  },
  {
    id: '5203010018',
    districtId: '5203010',
    name: 'Montong Belae',
  },
  {
    id: '5203010019',
    districtId: '5203010',
    name: 'Pulau Maringkik',
  },
  {
    id: '5203011001',
    districtId: '5203011',
    name: 'Batunampar',
  },
  {
    id: '5203011002',
    districtId: '5203011',
    name: 'Sukaraja',
  },
  {
    id: '5203011003',
    districtId: '5203011',
    name: 'Jerowaru',
  },
  {
    id: '5203011004',
    districtId: '5203011',
    name: 'Pemongkong',
  },
  {
    id: '5203011005',
    districtId: '5203011',
    name: 'Pandan Wangi',
  },
  {
    id: '5203011006',
    districtId: '5203011',
    name: 'Sekaroh',
  },
  {
    id: '5203011007',
    districtId: '5203011',
    name: 'Wakan',
  },
  {
    id: '5203011008',
    districtId: '5203011',
    name: 'Ekas Buana',
  },
  {
    id: '5203011009',
    districtId: '5203011',
    name: 'Kwang Rundun',
  },
  {
    id: '5203011010',
    districtId: '5203011',
    name: 'Batu Nampar Selatan',
  },
  {
    id: '5203011012',
    districtId: '5203011',
    name: 'Sukadamai',
  },
  {
    id: '5203011013',
    districtId: '5203011',
    name: 'Sepapan',
  },
  {
    id: '5203011014',
    districtId: '5203011',
    name: 'Seriwe',
  },
  {
    id: '5203011015',
    districtId: '5203011',
    name: 'Paremas',
  },
  {
    id: '5203020001',
    districtId: '5203020',
    name: 'Suangi',
  },
  {
    id: '5203020012',
    districtId: '5203020',
    name: 'Sakra',
  },
  {
    id: '5203020013',
    districtId: '5203020',
    name: 'Kabar',
  },
  {
    id: '5203020016',
    districtId: '5203020',
    name: 'Sakra Selatan',
  },
  {
    id: '5203020017',
    districtId: '5203020',
    name: 'Rumbuk Timur',
  },
  {
    id: '5203020018',
    districtId: '5203020',
    name: 'Suangi Timur',
  },
  {
    id: '5203020019',
    districtId: '5203020',
    name: 'Moyot',
  },
  {
    id: '5203020020',
    districtId: '5203020',
    name: 'Songak',
  },
  {
    id: '5203020021',
    districtId: '5203020',
    name: 'Peresak',
  },
  {
    id: '5203020022',
    districtId: '5203020',
    name: 'Kuang Baru',
  },
  {
    id: '5203021001',
    districtId: '5203021',
    name: 'Sukarara',
  },
  {
    id: '5203021002',
    districtId: '5203021',
    name: 'Gunung Rajak',
  },
  {
    id: '5203021003',
    districtId: '5203021',
    name: 'Rensing',
  },
  {
    id: '5203021004',
    districtId: '5203021',
    name: 'Bungtiang',
  },
  {
    id: '5203021005',
    districtId: '5203021',
    name: 'Pengkelakmas',
  },
  {
    id: '5203021006',
    districtId: '5203021',
    name: 'Borok Toyang',
  },
  {
    id: '5203021007',
    districtId: '5203021',
    name: 'Pejaring',
  },
  {
    id: '5203021008',
    districtId: '5203021',
    name: 'Montong Beter',
  },
  {
    id: '5203021010',
    districtId: '5203021',
    name: 'Rensing Raya',
  },
  {
    id: '5203021011',
    districtId: '5203021',
    name: 'Pematung',
  },
  {
    id: '5203021012',
    districtId: '5203021',
    name: 'Jero Gunung',
  },
  {
    id: '5203021013',
    districtId: '5203021',
    name: 'Boyemare',
  },
  {
    id: '5203021014',
    districtId: '5203021',
    name: 'Gadung Mas',
  },
  {
    id: '5203021015',
    districtId: '5203021',
    name: 'Tanak Kaken',
  },
  {
    id: '5203021016',
    districtId: '5203021',
    name: 'Rensing Bat',
  },
  {
    id: '5203021017',
    districtId: '5203021',
    name: 'Kembang Are Sampai',
  },
  {
    id: '5203021018',
    districtId: '5203021',
    name: 'Gerisak Semanggleng',
  },
  {
    id: '5203022001',
    districtId: '5203022',
    name: 'Gelanggang',
  },
  {
    id: '5203022002',
    districtId: '5203022',
    name: 'Surabaya',
  },
  {
    id: '5203022003',
    districtId: '5203022',
    name: 'Lepak',
  },
  {
    id: '5203022005',
    districtId: '5203022',
    name: 'Montongtangi',
  },
  {
    id: '5203022007',
    districtId: '5203022',
    name: 'Lepak Timur',
  },
  {
    id: '5203022008',
    districtId: '5203022',
    name: 'Surabaya Utara',
  },
  {
    id: '5203022009',
    districtId: '5203022',
    name: 'Gereneng Timur',
  },
  {
    id: '5203022010',
    districtId: '5203022',
    name: 'Lenting',
  },
  {
    id: '5203030001',
    districtId: '5203030',
    name: 'Jenggik',
  },
  {
    id: '5203030002',
    districtId: '5203030',
    name: 'Rarang',
  },
  {
    id: '5203030003',
    districtId: '5203030',
    name: 'Suradadi',
  },
  {
    id: '5203030004',
    districtId: '5203030',
    name: 'Santong',
  },
  {
    id: '5203030005',
    districtId: '5203030',
    name: 'Terara',
  },
  {
    id: '5203030006',
    districtId: '5203030',
    name: 'Sukadana',
  },
  {
    id: '5203030007',
    districtId: '5203030',
    name: 'Rarang Selatan',
  },
  {
    id: '5203030008',
    districtId: '5203030',
    name: 'Lando',
  },
  {
    id: '5203030009',
    districtId: '5203030',
    name: 'Rarang Tengah',
  },
  {
    id: '5203030010',
    districtId: '5203030',
    name: 'Leming',
  },
  {
    id: '5203030011',
    districtId: '5203030',
    name: 'Selagik',
  },
  {
    id: '5203030012',
    districtId: '5203030',
    name: 'Embung Raja',
  },
  {
    id: '5203030013',
    districtId: '5203030',
    name: 'Kalianyar',
  },
  {
    id: '5203030014',
    districtId: '5203030',
    name: 'Embung Kandong',
  },
  {
    id: '5203030015',
    districtId: '5203030',
    name: 'Rarang Batas',
  },
  {
    id: '5203030016',
    districtId: '5203030',
    name: 'Pandan Duri',
  },
  {
    id: '5203031002',
    districtId: '5203031',
    name: 'Kilang',
  },
  {
    id: '5203031003',
    districtId: '5203031',
    name: 'Montong Betok',
  },
  {
    id: '5203031004',
    districtId: '5203031',
    name: 'Pringgajurang',
  },
  {
    id: '5203031005',
    districtId: '5203031',
    name: 'Perian',
  },
  {
    id: '5203031006',
    districtId: '5203031',
    name: 'Jenggik Utara',
  },
  {
    id: '5203031007',
    districtId: '5203031',
    name: 'Pesanggrahan',
  },
  {
    id: '5203031008',
    districtId: '5203031',
    name: 'Pringgajurang Utara',
  },
  {
    id: '5203031009',
    districtId: '5203031',
    name: 'Lendang Belo',
  },
  {
    id: '5203040001',
    districtId: '5203040',
    name: 'Semaya',
  },
  {
    id: '5203040002',
    districtId: '5203040',
    name: 'Sikur',
  },
  {
    id: '5203040003',
    districtId: '5203040',
    name: 'Montongbaan',
  },
  {
    id: '5203040004',
    districtId: '5203040',
    name: 'Loyok',
  },
  {
    id: '5203040005',
    districtId: '5203040',
    name: 'Kotaraja',
  },
  {
    id: '5203040006',
    districtId: '5203040',
    name: 'Tetebatu',
  },
  {
    id: '5203040007',
    districtId: '5203040',
    name: 'Kembang Kuning',
  },
  {
    id: '5203040008',
    districtId: '5203040',
    name: 'Montongbaan Selatan',
  },
  {
    id: '5203040009',
    districtId: '5203040',
    name: 'Gelora',
  },
  {
    id: '5203040010',
    districtId: '5203040',
    name: 'Darma Sari',
  },
  {
    id: '5203040011',
    districtId: '5203040',
    name: 'Tetebatu Selatan',
  },
  {
    id: '5203040012',
    districtId: '5203040',
    name: 'Jeruk Manis',
  },
  {
    id: '5203040013',
    districtId: '5203040',
    name: 'Sikur Selatan',
  },
  {
    id: '5203040014',
    districtId: '5203040',
    name: 'Sikur Barat',
  },
  {
    id: '5203050001',
    districtId: '5203050',
    name: 'Kesik',
  },
  {
    id: '5203050002',
    districtId: '5203050',
    name: 'Paok Motong',
  },
  {
    id: '5203050003',
    districtId: '5203050',
    name: 'Masbagik Selatan',
  },
  {
    id: '5203050004',
    districtId: '5203050',
    name: 'Masbagik Timur',
  },
  {
    id: '5203050007',
    districtId: '5203050',
    name: 'Masbagik Utara',
  },
  {
    id: '5203050008',
    districtId: '5203050',
    name: 'Danger',
  },
  {
    id: '5203050009',
    districtId: '5203050',
    name: 'Lendang Nangka',
  },
  {
    id: '5203050010',
    districtId: '5203050',
    name: 'Masbagik Utara Baru',
  },
  {
    id: '5203050011',
    districtId: '5203050',
    name: 'Lendang Nangka Utara',
  },
  {
    id: '5203050012',
    districtId: '5203050',
    name: 'Kumbang',
  },
  {
    id: '5203051002',
    districtId: '5203051',
    name: 'Pringgasela',
  },
  {
    id: '5203051003',
    districtId: '5203051',
    name: 'Jurit',
  },
  {
    id: '5203051004',
    districtId: '5203051',
    name: 'Pengadangan',
  },
  {
    id: '5203051005',
    districtId: '5203051',
    name: 'Aikdewa',
  },
  {
    id: '5203051006',
    districtId: '5203051',
    name: 'Jurit Baru',
  },
  {
    id: '5203051007',
    districtId: '5203051',
    name: 'Pringgasela Selatan',
  },
  {
    id: '5203051008',
    districtId: '5203051',
    name: 'Pengadangan Barat',
  },
  {
    id: '5203051009',
    districtId: '5203051',
    name: 'Pringgasela Timur',
  },
  {
    id: '5203051010',
    districtId: '5203051',
    name: 'Timbanuh',
  },
  {
    id: '5203060001',
    districtId: '5203060',
    name: 'Setanggor',
  },
  {
    id: '5203060002',
    districtId: '5203060',
    name: 'Jantuk',
  },
  {
    id: '5203060003',
    districtId: '5203060',
    name: 'Padamara',
  },
  {
    id: '5203060004',
    districtId: '5203060',
    name: 'Dasan Lekong',
  },
  {
    id: '5203060005',
    districtId: '5203060',
    name: 'Sukamulia',
  },
  {
    id: '5203060006',
    districtId: '5203060',
    name: 'Sukamulia Timur',
  },
  {
    id: '5203060007',
    districtId: '5203060',
    name: 'Paok Pampang',
  },
  {
    id: '5203060008',
    districtId: '5203060',
    name: 'Setanggor Selatan',
  },
  {
    id: '5203060009',
    districtId: '5203060',
    name: 'Nyiur Tebel',
  },
  {
    id: '5203061001',
    districtId: '5203061',
    name: 'Anjani',
  },
  {
    id: '5203061002',
    districtId: '5203061',
    name: 'Tebaban',
  },
  {
    id: '5203061003',
    districtId: '5203061',
    name: 'Kerongkong',
  },
  {
    id: '5203061004',
    districtId: '5203061',
    name: 'Bagik Payung',
  },
  {
    id: '5203061005',
    districtId: '5203061',
    name: 'Suralaga',
  },
  {
    id: '5203061006',
    districtId: '5203061',
    name: 'Bagik Payung Selatan',
  },
  {
    id: '5203061007',
    districtId: '5203061',
    name: 'Gerung Permai',
  },
  {
    id: '5203061008',
    districtId: '5203061',
    name: 'Dasan Borok',
  },
  {
    id: '5203061009',
    districtId: '5203061',
    name: 'Tumbuh Mulia',
  },
  {
    id: '5203061010',
    districtId: '5203061',
    name: 'Gapuk',
  },
  {
    id: '5203061011',
    districtId: '5203061',
    name: 'Bintang Rinjani',
  },
  {
    id: '5203061012',
    districtId: '5203061',
    name: 'Paok Lombok',
  },
  {
    id: '5203061013',
    districtId: '5203061',
    name: 'Dames Damai',
  },
  {
    id: '5203061014',
    districtId: '5203061',
    name: 'Waringin',
  },
  {
    id: '5203061015',
    districtId: '5203061',
    name: 'Bagikpayung Timur',
  },
  {
    id: '5203070005',
    districtId: '5203070',
    name: 'Kelayu Jorong',
  },
  {
    id: '5203070006',
    districtId: '5203070',
    name: 'Kembang Sari',
  },
  {
    id: '5203070007',
    districtId: '5203070',
    name: 'Majidi',
  },
  {
    id: '5203070008',
    districtId: '5203070',
    name: 'Rakam',
  },
  {
    id: '5203070009',
    districtId: '5203070',
    name: 'Pancor',
  },
  {
    id: '5203070010',
    districtId: '5203070',
    name: 'Sekarteja',
  },
  {
    id: '5203070011',
    districtId: '5203070',
    name: 'Sandubaya',
  },
  {
    id: '5203070012',
    districtId: '5203070',
    name: 'Khusus Kota Selong',
  },
  {
    id: '5203070013',
    districtId: '5203070',
    name: 'Kelayu Selatan',
  },
  {
    id: '5203070014',
    districtId: '5203070',
    name: 'Kelayu Utara',
  },
  {
    id: '5203070015',
    districtId: '5203070',
    name: 'Denggen Timur',
  },
  {
    id: '5203071001',
    districtId: '5203071',
    name: 'Penedagandor',
  },
  {
    id: '5203071002',
    districtId: '5203071',
    name: 'Labuhan Haji',
  },
  {
    id: '5203071003',
    districtId: '5203071',
    name: 'Teros',
  },
  {
    id: '5203071004',
    districtId: '5203071',
    name: 'Tanjung',
  },
  {
    id: '5203071005',
    districtId: '5203071',
    name: 'Surya Wangi',
  },
  {
    id: '5203071006',
    districtId: '5203071',
    name: 'Ijobalit',
  },
  {
    id: '5203071007',
    districtId: '5203071',
    name: 'Korleko',
  },
  {
    id: '5203071008',
    districtId: '5203071',
    name: 'Kerta Sari',
  },
  {
    id: '5203071009',
    districtId: '5203071',
    name: 'Banjar Sari',
  },
  {
    id: '5203071010',
    districtId: '5203071',
    name: 'Tirtanadi',
  },
  {
    id: '5203071011',
    districtId: '5203071',
    name: 'Korleko Selatan',
  },
  {
    id: '5203080001',
    districtId: '5203080',
    name: 'Bagik Papan',
  },
  {
    id: '5203080002',
    districtId: '5203080',
    name: 'Apitaik',
  },
  {
    id: '5203080004',
    districtId: '5203080',
    name: 'Pohgading',
  },
  {
    id: '5203080005',
    districtId: '5203080',
    name: 'Batuyang',
  },
  {
    id: '5203080006',
    districtId: '5203080',
    name: 'Pringgabaya',
  },
  {
    id: '5203080013',
    districtId: '5203080',
    name: 'Labuhan Lombok',
  },
  {
    id: '5203080014',
    districtId: '5203080',
    name: 'Teko',
  },
  {
    id: '5203080015',
    districtId: '5203080',
    name: 'Pohgading Timur',
  },
  {
    id: '5203080016',
    districtId: '5203080',
    name: 'Pringgabaya Utara',
  },
  {
    id: '5203080017',
    districtId: '5203080',
    name: 'Tanak Gadang',
  },
  {
    id: '5203080018',
    districtId: '5203080',
    name: 'Anggaraksa',
  },
  {
    id: '5203080019',
    districtId: '5203080',
    name: 'Gunung Malang',
  },
  {
    id: '5203080020',
    districtId: '5203080',
    name: 'Seruni Mumbul',
  },
  {
    id: '5203080021',
    districtId: '5203080',
    name: 'Telaga Waru',
  },
  {
    id: '5203081001',
    districtId: '5203081',
    name: 'Suela',
  },
  {
    id: '5203081002',
    districtId: '5203081',
    name: 'Ketangga',
  },
  {
    id: '5203081003',
    districtId: '5203081',
    name: 'Selaparang',
  },
  {
    id: '5203081004',
    districtId: '5203081',
    name: 'Suntalangu',
  },
  {
    id: '5203081005',
    districtId: '5203081',
    name: 'Sapit',
  },
  {
    id: '5203081006',
    districtId: '5203081',
    name: 'Perigi',
  },
  {
    id: '5203081007',
    districtId: '5203081',
    name: 'Mekar Sari',
  },
  {
    id: '5203081008',
    districtId: '5203081',
    name: 'Puncak Jeringo',
  },
  {
    id: '5203090001',
    districtId: '5203090',
    name: 'Lenek Daya',
  },
  {
    id: '5203090003',
    districtId: '5203090',
    name: 'Lenek Lauq',
  },
  {
    id: '5203090004',
    districtId: '5203090',
    name: 'Kalijaga',
  },
  {
    id: '5203090008',
    districtId: '5203090',
    name: 'Kembang Kerang',
  },
  {
    id: '5203090009',
    districtId: '5203090',
    name: 'Aikmel',
  },
  {
    id: '5203090010',
    districtId: '5203090',
    name: 'Aikmel Utara',
  },
  {
    id: '5203090011',
    districtId: '5203090',
    name: 'Kalijaga Selatan',
  },
  {
    id: '5203090012',
    districtId: '5203090',
    name: 'Kalijaga Timur',
  },
  {
    id: '5203090013',
    districtId: '5203090',
    name: 'Lenek Baru',
  },
  {
    id: '5203090014',
    districtId: '5203090',
    name: 'Kembang Kerang Daya',
  },
  {
    id: '5203090015',
    districtId: '5203090',
    name: 'Aikmel Barat',
  },
  {
    id: '5203090016',
    districtId: '5203090',
    name: 'Lenek Pesiraman',
  },
  {
    id: '5203090017',
    districtId: '5203090',
    name: 'Toya',
  },
  {
    id: '5203090018',
    districtId: '5203090',
    name: 'Lenek Ramban Biak',
  },
  {
    id: '5203090019',
    districtId: '5203090',
    name: 'Lenek Kali Bambang',
  },
  {
    id: '5203090020',
    districtId: '5203090',
    name: 'Kalijaga Tengah',
  },
  {
    id: '5203090021',
    districtId: '5203090',
    name: 'Bagik Nyaka Santri',
  },
  {
    id: '5203090022',
    districtId: '5203090',
    name: 'Aik Prapa',
  },
  {
    id: '5203090023',
    districtId: '5203090',
    name: 'Sukarema',
  },
  {
    id: '5203090024',
    districtId: '5203090',
    name: 'Kalijaga Baru',
  },
  {
    id: '5203090026',
    districtId: '5203090',
    name: 'Keroya',
  },
  {
    id: '5203090027',
    districtId: '5203090',
    name: 'Aikmel Timur',
  },
  {
    id: '5203091001',
    districtId: '5203091',
    name: 'Mamben Lauq',
  },
  {
    id: '5203091002',
    districtId: '5203091',
    name: 'Mamben Daya',
  },
  {
    id: '5203091003',
    districtId: '5203091',
    name: 'Wanasaba',
  },
  {
    id: '5203091004',
    districtId: '5203091',
    name: 'Karang Baru',
  },
  {
    id: '5203091005',
    districtId: '5203091',
    name: 'Bebidas',
  },
  {
    id: '5203091006',
    districtId: '5203091',
    name: 'Tembeng Putik',
  },
  {
    id: '5203091007',
    districtId: '5203091',
    name: 'Wanasaba Lauk',
  },
  {
    id: '5203091008',
    districtId: '5203091',
    name: 'Mamben Baru',
  },
  {
    id: '5203091009',
    districtId: '5203091',
    name: 'Beriri Jarak',
  },
  {
    id: '5203091010',
    districtId: '5203091',
    name: 'Bandok',
  },
  {
    id: '5203091011',
    districtId: '5203091',
    name: 'Wanasaba Daya',
  },
  {
    id: '5203091012',
    districtId: '5203091',
    name: 'Otak Rarangan',
  },
  {
    id: '5203091013',
    districtId: '5203091',
    name: 'Jineng',
  },
  {
    id: '5203091014',
    districtId: '5203091',
    name: 'Karang Baru Timur',
  },
  {
    id: '5203092001',
    districtId: '5203092',
    name: 'Sembalun Bumbung',
  },
  {
    id: '5203092002',
    districtId: '5203092',
    name: 'Sembalun Lawang',
  },
  {
    id: '5203092003',
    districtId: '5203092',
    name: 'Sajang',
  },
  {
    id: '5203092004',
    districtId: '5203092',
    name: 'Bilok Petung',
  },
  {
    id: '5203092005',
    districtId: '5203092',
    name: 'Sembalun',
  },
  {
    id: '5203092006',
    districtId: '5203092',
    name: 'Sembalun Timba Gading',
  },
  {
    id: '5203100001',
    districtId: '5203100',
    name: 'Sambelia',
  },
  {
    id: '5203100002',
    districtId: '5203100',
    name: 'Belanting',
  },
  {
    id: '5203100003',
    districtId: '5203100',
    name: 'Obel Obel',
  },
  {
    id: '5203100004',
    districtId: '5203100',
    name: 'Sugian',
  },
  {
    id: '5203100005',
    districtId: '5203100',
    name: 'Labuhan Pandan',
  },
  {
    id: '5203100006',
    districtId: '5203100',
    name: 'Dara Kunci',
  },
  {
    id: '5203100007',
    districtId: '5203100',
    name: 'Bagik Manis',
  },
  {
    id: '5203100008',
    districtId: '5203100',
    name: 'Dadap',
  },
  {
    id: '5203100009',
    districtId: '5203100',
    name: 'Madayin',
  },
  {
    id: '5203100010',
    districtId: '5203100',
    name: 'Senanggalih',
  },
  {
    id: '5203100011',
    districtId: '5203100',
    name: 'Padak Guar',
  },
  {
    id: '5204020001',
    districtId: '5204020',
    name: 'Pada Suka',
  },
  {
    id: '5204020002',
    districtId: '5204020',
    name: 'Suka Maju',
  },
  {
    id: '5204020003',
    districtId: '5204020',
    name: 'Lunyuk Ode',
  },
  {
    id: '5204020004',
    districtId: '5204020',
    name: 'Lunyuk Rea',
  },
  {
    id: '5204020005',
    districtId: '5204020',
    name: 'Jamu',
  },
  {
    id: '5204020009',
    districtId: '5204020',
    name: 'Emang Lestari',
  },
  {
    id: '5204020011',
    districtId: '5204020',
    name: 'UPT Brang Lamar',
  },
  {
    id: '5204021001',
    districtId: '5204021',
    name: 'Mungkin',
  },
  {
    id: '5204021002',
    districtId: '5204021',
    name: 'Kelawis',
  },
  {
    id: '5204021003',
    districtId: '5204021',
    name: 'Sebeok',
  },
  {
    id: '5204021004',
    districtId: '5204021',
    name: 'Senawang',
  },
  {
    id: '5204050006',
    districtId: '5204050',
    name: 'Luar',
  },
  {
    id: '5204050007',
    districtId: '5204050',
    name: 'Baru',
  },
  {
    id: '5204050008',
    districtId: '5204050',
    name: 'Kalimango',
  },
  {
    id: '5204050009',
    districtId: '5204050',
    name: 'Juranalas',
  },
  {
    id: '5204050010',
    districtId: '5204050',
    name: 'Dalam',
  },
  {
    id: '5204050011',
    districtId: '5204050',
    name: 'Pulau Bungin',
  },
  {
    id: '5204050013',
    districtId: '5204050',
    name: 'Marenteh',
  },
  {
    id: '5204050019',
    districtId: '5204050',
    name: 'Labuhan Alas',
  },
  {
    id: '5204051001',
    districtId: '5204051',
    name: 'Mapin Rea',
  },
  {
    id: '5204051002',
    districtId: '5204051',
    name: 'Mapin Kebak',
  },
  {
    id: '5204051003',
    districtId: '5204051',
    name: 'Labuan Mapin',
  },
  {
    id: '5204051004',
    districtId: '5204051',
    name: 'Lekong',
  },
  {
    id: '5204051005',
    districtId: '5204051',
    name: 'Gontar',
  },
  {
    id: '5204051006',
    districtId: '5204051',
    name: 'Usar Mapin',
  },
  {
    id: '5204051007',
    districtId: '5204051',
    name: 'Gontar Baru',
  },
  {
    id: '5204051008',
    districtId: '5204051',
    name: 'Mapin Beru',
  },
  {
    id: '5204052001',
    districtId: '5204052',
    name: 'Pulau Kaung',
  },
  {
    id: '5204052002',
    districtId: '5204052',
    name: 'Tarusa',
  },
  {
    id: '5204052003',
    districtId: '5204052',
    name: 'Juru Mapin',
  },
  {
    id: '5204052004',
    districtId: '5204052',
    name: 'Kalabeso',
  },
  {
    id: '5204052005',
    districtId: '5204052',
    name: 'Labuhan Burung',
  },
  {
    id: '5204052006',
    districtId: '5204052',
    name: 'Buin Baru',
  },
  {
    id: '5204061001',
    districtId: '5204061',
    name: 'Stowe Brang',
  },
  {
    id: '5204061002',
    districtId: '5204061',
    name: 'Tengah',
  },
  {
    id: '5204061003',
    districtId: '5204061',
    name: 'Sabedo',
  },
  {
    id: '5204061004',
    districtId: '5204061',
    name: 'Motong',
  },
  {
    id: '5204061005',
    districtId: '5204061',
    name: 'Orong Bawa',
  },
  {
    id: '5204061006',
    districtId: '5204061',
    name: 'Labuan Bajo',
  },
  {
    id: '5204061007',
    districtId: '5204061',
    name: 'Pukat',
  },
  {
    id: '5204061008',
    districtId: '5204061',
    name: 'Jorok',
  },
  {
    id: '5204061009',
    districtId: '5204061',
    name: 'Bale Brang',
  },
  {
    id: '5204062001',
    districtId: '5204062',
    name: 'Sampe',
  },
  {
    id: '5204062004',
    districtId: '5204062',
    name: 'Rhee Loka',
  },
  {
    id: '5204070001',
    districtId: '5204070',
    name: 'Baturotok',
  },
  {
    id: '5204070002',
    districtId: '5204070',
    name: 'Tangkan Pulit',
  },
  {
    id: '5204070003',
    districtId: '5204070',
    name: 'Bao Desa',
  },
  {
    id: '5204070004',
    districtId: '5204070',
    name: 'Tepal',
  },
  {
    id: '5204070005',
    districtId: '5204070',
    name: 'Batudulang',
  },
  {
    id: '5204080010',
    districtId: '5204080',
    name: 'Samapuin',
  },
  {
    id: '5204080011',
    districtId: '5204080',
    name: 'Brang Bara',
  },
  {
    id: '5204080012',
    districtId: '5204080',
    name: 'Pekat',
  },
  {
    id: '5204080014',
    districtId: '5204080',
    name: 'Bugis',
  },
  {
    id: '5204080015',
    districtId: '5204080',
    name: 'Uma Sima',
  },
  {
    id: '5204080016',
    districtId: '5204080',
    name: 'Brang Biji',
  },
  {
    id: '5204081001',
    districtId: '5204081',
    name: 'Labuhan Badas',
  },
  {
    id: '5204081002',
    districtId: '5204081',
    name: 'Karang Dima',
  },
  {
    id: '5204081003',
    districtId: '5204081',
    name: 'Labuan Sumbawa',
  },
  {
    id: '5204081004',
    districtId: '5204081',
    name: 'Labuan Aji',
  },
  {
    id: '5204081005',
    districtId: '5204081',
    name: 'Sebotok',
  },
  {
    id: '5204081006',
    districtId: '5204081',
    name: 'Bajo Medang',
  },
  {
    id: '5204081007',
    districtId: '5204081',
    name: 'Bugis Medang',
  },
  {
    id: '5204082001',
    districtId: '5204082',
    name: 'Pelat',
  },
  {
    id: '5204082003',
    districtId: '5204082',
    name: 'Boak',
  },
  {
    id: '5204082004',
    districtId: '5204082',
    name: 'Pungka',
  },
  {
    id: '5204082005',
    districtId: '5204082',
    name: 'Jorok',
  },
  {
    id: '5204082006',
    districtId: '5204082',
    name: 'Kerato',
  },
  {
    id: '5204082007',
    districtId: '5204082',
    name: 'Uma Beringin',
  },
  {
    id: '5204082008',
    districtId: '5204082',
    name: 'Nijang',
  },
  {
    id: '5204090001',
    districtId: '5204090',
    name: 'Serading',
  },
  {
    id: '5204090002',
    districtId: '5204090',
    name: 'Kakiang',
  },
  {
    id: '5204090003',
    districtId: '5204090',
    name: 'Moyo',
  },
  {
    id: '5204090004',
    districtId: '5204090',
    name: 'Poto',
  },
  {
    id: '5204090005',
    districtId: '5204090',
    name: 'Berare',
  },
  {
    id: '5204090010',
    districtId: '5204090',
    name: 'Olat Rawa',
  },
  {
    id: '5204090011',
    districtId: '5204090',
    name: 'Batu Bangka',
  },
  {
    id: '5204090013',
    districtId: '5204090',
    name: 'Moyo Mekar',
  },
  {
    id: '5204090014',
    districtId: '5204090',
    name: 'Lab Ijuk',
  },
  {
    id: '5204091002',
    districtId: '5204091',
    name: 'Pungkit',
  },
  {
    id: '5204091003',
    districtId: '5204091',
    name: 'Kukin',
  },
  {
    id: '5204091004',
    districtId: '5204091',
    name: 'Baru Tahan',
  },
  {
    id: '5204091005',
    districtId: '5204091',
    name: 'Penyaring',
  },
  {
    id: '5204091006',
    districtId: '5204091',
    name: 'Songkar',
  },
  {
    id: '5204100002',
    districtId: '5204100',
    name: 'Semamung',
  },
  {
    id: '5204100003',
    districtId: '5204100',
    name: 'Sebasang',
  },
  {
    id: '5204100004',
    districtId: '5204100',
    name: 'Batutering',
  },
  {
    id: '5204100005',
    districtId: '5204100',
    name: 'Batubulan',
  },
  {
    id: '5204100006',
    districtId: '5204100',
    name: 'Mokong',
  },
  {
    id: '5204100009',
    districtId: '5204100',
    name: 'Lito',
  },
  {
    id: '5204100010',
    districtId: '5204100',
    name: 'Marga Karya',
  },
  {
    id: '5204100011',
    districtId: '5204100',
    name: 'Berang Rea',
  },
  {
    id: '5204100012',
    districtId: '5204100',
    name: 'Maman',
  },
  {
    id: '5204110002',
    districtId: '5204110',
    name: 'Lebangkar',
  },
  {
    id: '5204110003',
    districtId: '5204110',
    name: 'Lebin',
  },
  {
    id: '5204110008',
    districtId: '5204110',
    name: 'Lawin',
  },
  {
    id: '5204110010',
    districtId: '5204110',
    name: 'Ropang',
  },
  {
    id: '5204110011',
    districtId: '5204110',
    name: 'Ranan',
  },
  {
    id: '5204111001',
    districtId: '5204111',
    name: 'Ledang',
  },
  {
    id: '5204111002',
    districtId: '5204111',
    name: 'Tatebal',
  },
  {
    id: '5204111003',
    districtId: '5204111',
    name: 'Lenangguar',
  },
  {
    id: '5204111004',
    districtId: '5204111',
    name: 'Telaga',
  },
  {
    id: '5204112002',
    districtId: '5204112',
    name: 'Ai Mual',
  },
  {
    id: '5204112003',
    districtId: '5204112',
    name: 'Lantung',
  },
  {
    id: '5204112004',
    districtId: '5204112',
    name: 'Padesa',
  },
  {
    id: '5204121001',
    districtId: '5204121',
    name: 'Lape',
  },
  {
    id: '5204121003',
    districtId: '5204121',
    name: 'Labuan Kuris',
  },
  {
    id: '5204121004',
    districtId: '5204121',
    name: 'Hijrah',
  },
  {
    id: '5204122001',
    districtId: '5204122',
    name: 'Pungkit',
  },
  {
    id: '5204122002',
    districtId: '5204122',
    name: 'Lopok',
  },
  {
    id: '5204122003',
    districtId: '5204122',
    name: 'Lopok Beru',
  },
  {
    id: '5204122004',
    districtId: '5204122',
    name: 'Langam',
  },
  {
    id: '5204122005',
    districtId: '5204122',
    name: 'Berora',
  },
  {
    id: '5204122006',
    districtId: '5204122',
    name: 'Mama',
  },
  {
    id: '5204122007',
    districtId: '5204122',
    name: 'Tatede',
  },
  {
    id: '5204130006',
    districtId: '5204130',
    name: 'Sepakat',
  },
  {
    id: '5204130007',
    districtId: '5204130',
    name: 'Sp I Prode',
  },
  {
    id: '5204130008',
    districtId: '5204130',
    name: 'Sp II Prode',
  },
  {
    id: '5204130009',
    districtId: '5204130',
    name: 'Plampang',
  },
  {
    id: '5204130010',
    districtId: '5204130',
    name: 'Sepayung',
  },
  {
    id: '5204130011',
    districtId: '5204130',
    name: 'Teluk Santong',
  },
  {
    id: '5204130015',
    districtId: '5204130',
    name: 'Sp III Prode',
  },
  {
    id: '5204130017',
    districtId: '5204130',
    name: 'Brang Kolong',
  },
  {
    id: '5204130018',
    districtId: '5204130',
    name: 'Selante',
  },
  {
    id: '5204130019',
    districtId: '5204130',
    name: 'Usar',
  },
  {
    id: '5204131001',
    districtId: '5204131',
    name: 'Jaya Makmur',
  },
  {
    id: '5204131002',
    districtId: '5204131',
    name: 'Sekokat',
  },
  {
    id: '5204131003',
    districtId: '5204131',
    name: 'Suka Damai',
  },
  {
    id: '5204131004',
    districtId: '5204131',
    name: 'Labangka',
  },
  {
    id: '5204131005',
    districtId: '5204131',
    name: 'Suka Mulya',
  },
  {
    id: '5204132001',
    districtId: '5204132',
    name: 'Maronge',
  },
  {
    id: '5204132002',
    districtId: '5204132',
    name: 'Labuhan Sangoro',
  },
  {
    id: '5204132003',
    districtId: '5204132',
    name: 'Simu',
  },
  {
    id: '5204132004',
    districtId: '5204132',
    name: 'Pemasar',
  },
  {
    id: '5204140001',
    districtId: '5204140',
    name: 'Boal',
  },
  {
    id: '5204140002',
    districtId: '5204140',
    name: 'Empang Atas',
  },
  {
    id: '5204140003',
    districtId: '5204140',
    name: 'Jotang',
  },
  {
    id: '5204140005',
    districtId: '5204140',
    name: 'Ongko',
  },
  {
    id: '5204140007',
    districtId: '5204140',
    name: 'Empang Bawah',
  },
  {
    id: '5204140011',
    districtId: '5204140',
    name: 'Lamenta',
  },
  {
    id: '5204140013',
    districtId: '5204140',
    name: 'Gapit',
  },
  {
    id: '5204140014',
    districtId: '5204140',
    name: 'Pamanto',
  },
  {
    id: '5204140015',
    districtId: '5204140',
    name: 'Jotang Beru',
  },
  {
    id: '5204140016',
    districtId: '5204140',
    name: 'Bunga Eja',
  },
  {
    id: '5204141001',
    districtId: '5204141',
    name: 'Labuan Bontong',
  },
  {
    id: '5204141002',
    districtId: '5204141',
    name: 'Labuan Aji',
  },
  {
    id: '5204141003',
    districtId: '5204141',
    name: 'Bantulanteh',
  },
  {
    id: '5204141004',
    districtId: '5204141',
    name: 'Labuan Jambu',
  },
  {
    id: '5204141005',
    districtId: '5204141',
    name: "Tolo' Oi",
  },
  {
    id: '5204141006',
    districtId: '5204141',
    name: 'Mata',
  },
  {
    id: '5204141007',
    districtId: '5204141',
    name: 'Banda',
  },
  {
    id: '5204141008',
    districtId: '5204141',
    name: 'Pidang',
  },
  {
    id: '5205010002',
    districtId: '5205010',
    name: 'Daha',
  },
  {
    id: '5205010003',
    districtId: '5205010',
    name: 'Rasabou',
  },
  {
    id: '5205010004',
    districtId: '5205010',
    name: 'Cempi Jaya',
  },
  {
    id: '5205010005',
    districtId: '5205010',
    name: 'Adu',
  },
  {
    id: '5205010006',
    districtId: '5205010',
    name: 'Sawe',
  },
  {
    id: '5205010007',
    districtId: '5205010',
    name: 'Persiapan Jala',
  },
  {
    id: '5205010008',
    districtId: '5205010',
    name: 'Marada',
  },
  {
    id: '5205011001',
    districtId: '5205011',
    name: 'Jambu',
  },
  {
    id: '5205011003',
    districtId: '5205011',
    name: 'UPT Woko',
  },
  {
    id: '5205011004',
    districtId: '5205011',
    name: 'Ranggo',
  },
  {
    id: '5205011005',
    districtId: '5205011',
    name: 'Lepadi',
  },
  {
    id: '5205011006',
    districtId: '5205011',
    name: 'Temba Lae',
  },
  {
    id: '5205020001',
    districtId: '5205020',
    name: 'Mbawi',
  },
  {
    id: '5205020002',
    districtId: '5205020',
    name: 'Dorebara',
  },
  {
    id: '5205020004',
    districtId: '5205020',
    name: 'Kandai Satu',
  },
  {
    id: '5205020005',
    districtId: '5205020',
    name: 'Karijawa',
  },
  {
    id: '5205020006',
    districtId: '5205020',
    name: 'Potu',
  },
  {
    id: '5205020007',
    districtId: '5205020',
    name: 'Bada',
  },
  {
    id: '5205020008',
    districtId: '5205020',
    name: 'Bali',
  },
  {
    id: '5205020009',
    districtId: '5205020',
    name: 'Dorotangga',
  },
  {
    id: '5205020010',
    districtId: '5205020',
    name: 'Oo',
  },
  {
    id: '5205020011',
    districtId: '5205020',
    name: 'Katua',
  },
  {
    id: '5205020012',
    districtId: '5205020',
    name: 'Karamabura',
  },
  {
    id: '5205020013',
    districtId: '5205020',
    name: 'Kareke',
  },
  {
    id: '5205020014',
    districtId: '5205020',
    name: 'Mangge Nae',
  },
  {
    id: '5205020015',
    districtId: '5205020',
    name: 'Mangge Asi',
  },
  {
    id: '5205020016',
    districtId: '5205020',
    name: 'Persiapan Sorisakolo',
  },
  {
    id: '5205030001',
    districtId: '5205030',
    name: 'Riwo',
  },
  {
    id: '5205030002',
    districtId: '5205030',
    name: 'Madaprama',
  },
  {
    id: '5205030003',
    districtId: '5205030',
    name: 'Bara',
  },
  {
    id: '5205030004',
    districtId: '5205030',
    name: 'Nowa',
  },
  {
    id: '5205030005',
    districtId: '5205030',
    name: 'Wawonduru',
  },
  {
    id: '5205030006',
    districtId: '5205030',
    name: 'Matua',
  },
  {
    id: '5205030007',
    districtId: '5205030',
    name: 'Montabaru',
  },
  {
    id: '5205030008',
    districtId: '5205030',
    name: 'Kandai Dua',
  },
  {
    id: '5205030009',
    districtId: '5205030',
    name: 'Simpasai',
  },
  {
    id: '5205030010',
    districtId: '5205030',
    name: 'Saneo',
  },
  {
    id: '5205030012',
    districtId: '5205030',
    name: 'Bakajaya',
  },
  {
    id: '5205030013',
    districtId: '5205030',
    name: 'Persiapan Rababaka',
  },
  {
    id: '5205030014',
    districtId: '5205030',
    name: 'Serakapi',
  },
  {
    id: '5205040002',
    districtId: '5205040',
    name: 'Taropo',
  },
  {
    id: '5205040003',
    districtId: '5205040',
    name: 'Kramat',
  },
  {
    id: '5205040004',
    districtId: '5205040',
    name: 'Malaju',
  },
  {
    id: '5205040005',
    districtId: '5205040',
    name: 'Lasi',
  },
  {
    id: '5205040006',
    districtId: '5205040',
    name: 'K I W U',
  },
  {
    id: '5205050009',
    districtId: '5205050',
    name: "Ta'A",
  },
  {
    id: '5205050010',
    districtId: '5205050',
    name: 'Kempo',
  },
  {
    id: '5205050011',
    districtId: '5205050',
    name: 'Soro',
  },
  {
    id: '5205050012',
    districtId: '5205050',
    name: 'Konte',
  },
  {
    id: '5205050013',
    districtId: '5205050',
    name: 'So Nggajah',
  },
  {
    id: '5205050014',
    districtId: '5205050',
    name: 'Tolo Kalo',
  },
  {
    id: '5205050015',
    districtId: '5205050',
    name: 'Doro Kobo',
  },
  {
    id: '5205050016',
    districtId: '5205050',
    name: 'Persiapan Soro Barat',
  },
  {
    id: '5205051001',
    districtId: '5205051',
    name: 'Kwangko',
  },
  {
    id: '5205051002',
    districtId: '5205051',
    name: 'Nangatumpu',
  },
  {
    id: '5205051003',
    districtId: '5205051',
    name: 'Banggo',
  },
  {
    id: '5205051004',
    districtId: '5205051',
    name: 'Soriutu',
  },
  {
    id: '5205051005',
    districtId: '5205051',
    name: 'Doromelo',
  },
  {
    id: '5205051006',
    districtId: '5205051',
    name: 'Lanci Jaya',
  },
  {
    id: '5205051007',
    districtId: '5205051',
    name: 'Nusa Jaya',
  },
  {
    id: '5205051008',
    districtId: '5205051',
    name: 'Suka Damai',
  },
  {
    id: '5205051009',
    districtId: '5205051',
    name: 'Tanju',
  },
  {
    id: '5205051010',
    districtId: '5205051',
    name: 'Kampas Meci',
  },
  {
    id: '5205051011',
    districtId: '5205051',
    name: 'Persiapan Teka Sire',
  },
  {
    id: '5205051012',
    districtId: '5205051',
    name: 'Persiapan Anamina',
  },
  {
    id: '5205060001',
    districtId: '5205060',
    name: 'Doropeti',
  },
  {
    id: '5205060002',
    districtId: '5205060',
    name: 'Beringin Jaya',
  },
  {
    id: '5205060003',
    districtId: '5205060',
    name: 'Pekat',
  },
  {
    id: '5205060004',
    districtId: '5205060',
    name: 'Sorinomo',
  },
  {
    id: '5205060005',
    districtId: '5205060',
    name: 'Tambora',
  },
  {
    id: '5205060006',
    districtId: '5205060',
    name: 'Kadindi',
  },
  {
    id: '5205060007',
    districtId: '5205060',
    name: 'Nangamiro',
  },
  {
    id: '5205060008',
    districtId: '5205060',
    name: 'Calabai',
  },
  {
    id: '5205060009',
    districtId: '5205060',
    name: 'UPT Nangakara',
  },
  {
    id: '5205060010',
    districtId: '5205060',
    name: 'Kadindi Barat',
  },
  {
    id: '5205060011',
    districtId: '5205060',
    name: 'Persiapan Sori Tatanga',
  },
  {
    id: '5205060012',
    districtId: '5205060',
    name: 'Persiapan Karombo',
  },
  {
    id: '5206010005',
    districtId: '5206010',
    name: 'Tolotangga',
  },
  {
    id: '5206010006',
    districtId: '5206010',
    name: 'Sondo',
  },
  {
    id: '5206010007',
    districtId: '5206010',
    name: 'Simpasai',
  },
  {
    id: '5206010008',
    districtId: '5206010',
    name: 'Sie',
  },
  {
    id: '5206010009',
    districtId: '5206010',
    name: 'Tangga',
  },
  {
    id: '5206010010',
    districtId: '5206010',
    name: 'Monta',
  },
  {
    id: '5206010012',
    districtId: '5206010',
    name: 'Baralau',
  },
  {
    id: '5206010014',
    districtId: '5206010',
    name: 'Tolouwi',
  },
  {
    id: '5206010015',
    districtId: '5206010',
    name: 'Willamaci',
  },
  {
    id: '5206010016',
    districtId: '5206010',
    name: 'Pela',
  },
  {
    id: '5206010017',
    districtId: '5206010',
    name: 'Tangga Baru',
  },
  {
    id: '5206010018',
    districtId: '5206010',
    name: 'Nontotera',
  },
  {
    id: '5206010019',
    districtId: '5206010',
    name: 'Waro',
  },
  {
    id: '5206011002',
    districtId: '5206011',
    name: 'Paradowane',
  },
  {
    id: '5206011003',
    districtId: '5206011',
    name: 'Kuta',
  },
  {
    id: '5206011004',
    districtId: '5206011',
    name: 'Paradorato',
  },
  {
    id: '5206011005',
    districtId: '5206011',
    name: 'Kanca',
  },
  {
    id: '5206020004',
    districtId: '5206020',
    name: 'Sanolo',
  },
  {
    id: '5206020005',
    districtId: '5206020',
    name: 'Sondosia',
  },
  {
    id: '5206020006',
    districtId: '5206020',
    name: 'Bontokape',
  },
  {
    id: '5206020007',
    districtId: '5206020',
    name: 'Timu',
  },
  {
    id: '5206020013',
    districtId: '5206020',
    name: 'Tambe',
  },
  {
    id: '5206020014',
    districtId: '5206020',
    name: 'Rasabou',
  },
  {
    id: '5206020015',
    districtId: '5206020',
    name: 'Rato',
  },
  {
    id: '5206020016',
    districtId: '5206020',
    name: 'Kananga',
  },
  {
    id: '5206020019',
    districtId: '5206020',
    name: 'Rada',
  },
  {
    id: '5206020020',
    districtId: '5206020',
    name: 'Darussalam',
  },
  {
    id: '5206020021',
    districtId: '5206020',
    name: 'Kara',
  },
  {
    id: '5206021001',
    districtId: '5206021',
    name: 'Woro',
  },
  {
    id: '5206021002',
    districtId: '5206021',
    name: 'Campa',
  },
  {
    id: '5206021003',
    districtId: '5206021',
    name: 'Mpuri',
  },
  {
    id: '5206021004',
    districtId: '5206021',
    name: 'Dena',
  },
  {
    id: '5206021005',
    districtId: '5206021',
    name: 'Rade',
  },
  {
    id: '5206021006',
    districtId: '5206021',
    name: 'Monggo',
  },
  {
    id: '5206021007',
    districtId: '5206021',
    name: 'Ndano',
  },
  {
    id: '5206021008',
    districtId: '5206021',
    name: 'Tonda',
  },
  {
    id: '5206021010',
    districtId: '5206021',
    name: 'Bolo',
  },
  {
    id: '5206021011',
    districtId: '5206021',
    name: 'Mada Wau',
  },
  {
    id: '5206021012',
    districtId: '5206021',
    name: 'Ncandi',
  },
  {
    id: '5206030001',
    districtId: '5206030',
    name: 'Keli',
  },
  {
    id: '5206030002',
    districtId: '5206030',
    name: 'Tenga',
  },
  {
    id: '5206030003',
    districtId: '5206030',
    name: 'Naru',
  },
  {
    id: '5206030004',
    districtId: '5206030',
    name: 'Nisa',
  },
  {
    id: '5206030006',
    districtId: '5206030',
    name: 'Rabakodo',
  },
  {
    id: '5206030007',
    districtId: '5206030',
    name: 'Samili',
  },
  {
    id: '5206030008',
    districtId: '5206030',
    name: 'Kalampa',
  },
  {
    id: '5206030009',
    districtId: '5206030',
    name: 'Risa',
  },
  {
    id: '5206030010',
    districtId: '5206030',
    name: 'Pandai',
  },
  {
    id: '5206030011',
    districtId: '5206030',
    name: 'Donggobolo',
  },
  {
    id: '5206030012',
    districtId: '5206030',
    name: 'Dadibou',
  },
  {
    id: '5206030013',
    districtId: '5206030',
    name: 'Talabiu',
  },
  {
    id: '5206030014',
    districtId: '5206030',
    name: 'Wadu Wani',
  },
  {
    id: '5206030015',
    districtId: '5206030',
    name: 'Penapali',
  },
  {
    id: '5206040005',
    districtId: '5206040',
    name: 'Ncera',
  },
  {
    id: '5206040006',
    districtId: '5206040',
    name: 'Lido',
  },
  {
    id: '5206040007',
    districtId: '5206040',
    name: 'Ngali',
  },
  {
    id: '5206040008',
    districtId: '5206040',
    name: 'Renda',
  },
  {
    id: '5206040018',
    districtId: '5206040',
    name: 'Soki',
  },
  {
    id: '5206040019',
    districtId: '5206040',
    name: 'Roka',
  },
  {
    id: '5206040020',
    districtId: '5206040',
    name: 'Diha',
  },
  {
    id: '5206041001',
    districtId: '5206041',
    name: 'Belo',
  },
  {
    id: '5206041002',
    districtId: '5206041',
    name: 'Roi',
  },
  {
    id: '5206041003',
    districtId: '5206041',
    name: 'Dore',
  },
  {
    id: '5206041004',
    districtId: '5206041',
    name: 'Nata',
  },
  {
    id: '5206041005',
    districtId: '5206041',
    name: 'Ntonggu',
  },
  {
    id: '5206041007',
    districtId: '5206041',
    name: 'Tonggondoa',
  },
  {
    id: '5206041008',
    districtId: '5206041',
    name: 'Tonggorisa',
  },
  {
    id: '5206041009',
    districtId: '5206041',
    name: 'Panda',
  },
  {
    id: '5206041010',
    districtId: '5206041',
    name: 'Ragi',
  },
  {
    id: '5206041011',
    districtId: '5206041',
    name: 'Padolo',
  },
  {
    id: '5206050011',
    districtId: '5206050',
    name: 'Tarlawi',
  },
  {
    id: '5206050012',
    districtId: '5206050',
    name: 'Raba',
  },
  {
    id: '5206050013',
    districtId: '5206050',
    name: 'Pesa',
  },
  {
    id: '5206050015',
    districtId: '5206050',
    name: 'Ntori',
  },
  {
    id: '5206050016',
    districtId: '5206050',
    name: 'Maria',
  },
  {
    id: '5206050018',
    districtId: '5206050',
    name: 'Kambilo',
  },
  {
    id: '5206050019',
    districtId: '5206050',
    name: 'Kombo',
  },
  {
    id: '5206050020',
    districtId: '5206050',
    name: 'Maria Utara',
  },
  {
    id: '5206050021',
    districtId: '5206050',
    name: 'Riamau',
  },
  {
    id: '5206051002',
    districtId: '5206051',
    name: 'Laju',
  },
  {
    id: '5206051004',
    districtId: '5206051',
    name: "Doro O'O",
  },
  {
    id: '5206051006',
    districtId: '5206051',
    name: 'Waworada',
  },
  {
    id: '5206051007',
    districtId: '5206051',
    name: 'Kawuwu',
  },
  {
    id: '5206051008',
    districtId: '5206051',
    name: 'Karumbu',
  },
  {
    id: '5206051009',
    districtId: '5206051',
    name: 'Kalodu',
  },
  {
    id: '5206051011',
    districtId: '5206051',
    name: 'Kangga',
  },
  {
    id: '5206051012',
    districtId: '5206051',
    name: 'Karampi',
  },
  {
    id: '5206051013',
    districtId: '5206051',
    name: 'Wadu Ruka',
  },
  {
    id: '5206051015',
    districtId: '5206051',
    name: 'Rompo',
  },
  {
    id: '5206051016',
    districtId: '5206051',
    name: 'Sambane',
  },
  {
    id: '5206051017',
    districtId: '5206051',
    name: 'Sarae Ruma',
  },
  {
    id: '5206052001',
    districtId: '5206052',
    name: 'Sambori',
  },
  {
    id: '5206052002',
    districtId: '5206052',
    name: 'Kaboro',
  },
  {
    id: '5206052003',
    districtId: '5206052',
    name: 'Kuta',
  },
  {
    id: '5206052004',
    districtId: '5206052',
    name: 'Teta',
  },
  {
    id: '5206052005',
    districtId: '5206052',
    name: 'Kaowa',
  },
  {
    id: '5206052006',
    districtId: '5206052',
    name: 'Londu',
  },
  {
    id: '5206060008',
    districtId: '5206060',
    name: 'Sari',
  },
  {
    id: '5206060009',
    districtId: '5206060',
    name: 'Boke',
  },
  {
    id: '5206060010',
    districtId: '5206060',
    name: 'Jia',
  },
  {
    id: '5206060012',
    districtId: '5206060',
    name: 'Naru',
  },
  {
    id: '5206060014',
    districtId: '5206060',
    name: 'Bajopulau',
  },
  {
    id: '5206060015',
    districtId: '5206060',
    name: 'Bugis',
  },
  {
    id: '5206060016',
    districtId: '5206060',
    name: 'Rasabou',
  },
  {
    id: '5206060017',
    districtId: '5206060',
    name: 'Nae',
  },
  {
    id: '5206060018',
    districtId: '5206060',
    name: 'Parangina',
  },
  {
    id: '5206060019',
    districtId: '5206060',
    name: 'Raioi',
  },
  {
    id: '5206060020',
    districtId: '5206060',
    name: 'Sangia',
  },
  {
    id: '5206060021',
    districtId: '5206060',
    name: 'Kowo',
  },
  {
    id: '5206060023',
    districtId: '5206060',
    name: 'Poja',
  },
  {
    id: '5206060024',
    districtId: '5206060',
    name: 'Tanah Putih',
  },
  {
    id: '5206060025',
    districtId: '5206060',
    name: 'Naru Barat',
  },
  {
    id: '5206060026',
    districtId: '5206060',
    name: 'Lamere',
  },
  {
    id: '5206060027',
    districtId: '5206060',
    name: 'Oi Maci',
  },
  {
    id: '5206061001',
    districtId: '5206061',
    name: 'Mangge',
  },
  {
    id: '5206061002',
    districtId: '5206061',
    name: 'Kaleo',
  },
  {
    id: '5206061003',
    districtId: '5206061',
    name: 'Simpasai',
  },
  {
    id: '5206061004',
    districtId: '5206061',
    name: 'Soro',
  },
  {
    id: '5206061005',
    districtId: '5206061',
    name: 'Lanta',
  },
  {
    id: '5206061006',
    districtId: '5206061',
    name: 'Rato',
  },
  {
    id: '5206061007',
    districtId: '5206061',
    name: 'Sumi',
  },
  {
    id: '5206061009',
    districtId: '5206061',
    name: 'Lambu',
  },
  {
    id: '5206061010',
    districtId: '5206061',
    name: 'Hidirasa',
  },
  {
    id: '5206061012',
    districtId: '5206061',
    name: 'Melayu',
  },
  {
    id: '5206061013',
    districtId: '5206061',
    name: 'Lanta Barat',
  },
  {
    id: '5206061014',
    districtId: '5206061',
    name: 'Monta Baru',
  },
  {
    id: '5206061015',
    districtId: '5206061',
    name: 'Sangga',
  },
  {
    id: '5206070002',
    districtId: '5206070',
    name: 'Ntoke',
  },
  {
    id: '5206070003',
    districtId: '5206070',
    name: 'Pai',
  },
  {
    id: '5206070004',
    districtId: '5206070',
    name: 'Bala',
  },
  {
    id: '5206070005',
    districtId: '5206070',
    name: 'Oitui',
  },
  {
    id: '5206070006',
    districtId: '5206070',
    name: 'Tawali',
  },
  {
    id: '5206070007',
    districtId: '5206070',
    name: 'Sangiang',
  },
  {
    id: '5206070008',
    districtId: '5206070',
    name: 'Hidirasa',
  },
  {
    id: '5206070009',
    districtId: '5206070',
    name: 'Nunggi',
  },
  {
    id: '5206070010',
    districtId: '5206070',
    name: 'Wora',
  },
  {
    id: '5206070015',
    districtId: '5206070',
    name: 'Tadewa',
  },
  {
    id: '5206070016',
    districtId: '5206070',
    name: 'Nanga Wera',
  },
  {
    id: '5206070017',
    districtId: '5206070',
    name: 'Kalajena',
  },
  {
    id: '5206070018',
    districtId: '5206070',
    name: 'Ranggasolo',
  },
  {
    id: '5206070019',
    districtId: '5206070',
    name: 'Mandala',
  },
  {
    id: '5206071001',
    districtId: '5206071',
    name: 'Rite',
  },
  {
    id: '5206071002',
    districtId: '5206071',
    name: 'Talapiti',
  },
  {
    id: '5206071003',
    districtId: '5206071',
    name: 'Tolowata',
  },
  {
    id: '5206071004',
    districtId: '5206071',
    name: 'Nipa',
  },
  {
    id: '5206071005',
    districtId: '5206071',
    name: 'Mawu',
  },
  {
    id: '5206071006',
    districtId: '5206071',
    name: 'Kole',
  },
  {
    id: '5206080001',
    districtId: '5206080',
    name: 'Rora',
  },
  {
    id: '5206080002',
    districtId: '5206080',
    name: 'Palama',
  },
  {
    id: '5206080003',
    districtId: '5206080',
    name: 'Mbawa',
  },
  {
    id: '5206080004',
    districtId: '5206080',
    name: "O'O",
  },
  {
    id: '5206080005',
    districtId: '5206080',
    name: 'Doridungga',
  },
  {
    id: '5206080008',
    districtId: '5206080',
    name: 'Kala',
  },
  {
    id: '5206080012',
    districtId: '5206080',
    name: 'Bumi Pajo',
  },
  {
    id: '5206080013',
    districtId: '5206080',
    name: 'Mpili',
  },
  {
    id: '5206080014',
    districtId: '5206080',
    name: 'Ndano Nae',
  },
  {
    id: '5206081001',
    districtId: '5206081',
    name: 'Bajo',
  },
  {
    id: '5206081002',
    districtId: '5206081',
    name: 'Punti',
  },
  {
    id: '5206081003',
    districtId: '5206081',
    name: 'Wadukopa',
  },
  {
    id: '5206081004',
    districtId: '5206081',
    name: 'Kananta',
  },
  {
    id: '5206081005',
    districtId: '5206081',
    name: 'Sai',
  },
  {
    id: '5206081006',
    districtId: '5206081',
    name: 'Sampungu',
  },
  {
    id: '5206081007',
    districtId: '5206081',
    name: 'Lewintana',
  },
  {
    id: '5206090004',
    districtId: '5206090',
    name: 'Oi Saro',
  },
  {
    id: '5206090005',
    districtId: '5206090',
    name: 'Piong',
  },
  {
    id: '5206090006',
    districtId: '5206090',
    name: 'Boro',
  },
  {
    id: '5206090007',
    districtId: '5206090',
    name: 'Kore',
  },
  {
    id: '5206090008',
    districtId: '5206090',
    name: 'Taloko',
  },
  {
    id: '5206090009',
    districtId: '5206090',
    name: 'Sandue',
  },
  {
    id: '5206091001',
    districtId: '5206091',
    name: 'Labuhan Kananga',
  },
  {
    id: '5206091002',
    districtId: '5206091',
    name: 'Kawinda Nae',
  },
  {
    id: '5206091003',
    districtId: '5206091',
    name: 'Oi Panihi',
  },
  {
    id: '5206091004',
    districtId: '5206091',
    name: 'Kawinda Toi',
  },
  {
    id: '5206091005',
    districtId: '5206091',
    name: 'Rasabou',
  },
  {
    id: '5206091009',
    districtId: '5206091',
    name: 'Oi Bura',
  },
  {
    id: '5206091010',
    districtId: '5206091',
    name: 'UPT Sori Panihi Sp5',
  },
  {
    id: '5206091011',
    districtId: '5206091',
    name: 'Oi Katupa',
  },
  {
    id: '5206091012',
    districtId: '5206091',
    name: 'UPT Sori Panihi II Sp 6',
  },
  {
    id: '5207010001',
    districtId: '5207010',
    name: 'Sekongkang Bawah',
  },
  {
    id: '5207010002',
    districtId: '5207010',
    name: 'Sekongkang Atas',
  },
  {
    id: '5207010003',
    districtId: '5207010',
    name: 'Tongo',
  },
  {
    id: '5207010004',
    districtId: '5207010',
    name: 'Ai Kangkung',
  },
  {
    id: '5207010005',
    districtId: '5207010',
    name: 'Tatar',
  },
  {
    id: '5207010006',
    districtId: '5207010',
    name: 'Talonang Baru',
  },
  {
    id: '5207010007',
    districtId: '5207010',
    name: 'Kemuning',
  },
  {
    id: '5207010008',
    districtId: '5207010',
    name: 'UPT Tongo II Sp.2',
  },
  {
    id: '5207020002',
    districtId: '5207020',
    name: 'Belo',
  },
  {
    id: '5207020004',
    districtId: '5207020',
    name: 'Goa',
  },
  {
    id: '5207020006',
    districtId: '5207020',
    name: 'Dasan Anyar',
  },
  {
    id: '5207021001',
    districtId: '5207021',
    name: 'Maluk',
  },
  {
    id: '5207021003',
    districtId: '5207021',
    name: 'Bukit Damai',
  },
  {
    id: '5207021004',
    districtId: '5207021',
    name: 'Mantun',
  },
  {
    id: '5207021005',
    districtId: '5207021',
    name: 'Pasir Putih',
  },
  {
    id: '5207030003',
    districtId: '5207030',
    name: 'Lalar Liang',
  },
  {
    id: '5207030004',
    districtId: '5207030',
    name: 'Labuan Lalar',
  },
  {
    id: '5207030005',
    districtId: '5207030',
    name: 'Kuang',
  },
  {
    id: '5207030006',
    districtId: '5207030',
    name: 'Labuan Kertasari',
  },
  {
    id: '5207030007',
    districtId: '5207030',
    name: 'Bugis',
  },
  {
    id: '5207030008',
    districtId: '5207030',
    name: 'Dalam',
  },
  {
    id: '5207030009',
    districtId: '5207030',
    name: 'Menala',
  },
  {
    id: '5207030010',
    districtId: '5207030',
    name: 'Sampir',
  },
  {
    id: '5207030011',
    districtId: '5207030',
    name: 'Seloto',
  },
  {
    id: '5207030012',
    districtId: '5207030',
    name: 'Tamekan',
  },
  {
    id: '5207030013',
    districtId: '5207030',
    name: 'Banjar',
  },
  {
    id: '5207030014',
    districtId: '5207030',
    name: 'Batu Putih',
  },
  {
    id: '5207030015',
    districtId: '5207030',
    name: 'Telaga Bertong',
  },
  {
    id: '5207030016',
    districtId: '5207030',
    name: 'Sermong',
  },
  {
    id: '5207030017',
    districtId: '5207030',
    name: 'Arab Kenangan',
  },
  {
    id: '5207031001',
    districtId: '5207031',
    name: 'Kalimantong',
  },
  {
    id: '5207031002',
    districtId: '5207031',
    name: 'Mura',
  },
  {
    id: '5207031003',
    districtId: '5207031',
    name: 'Lampok',
  },
  {
    id: '5207031004',
    districtId: '5207031',
    name: 'Manemeng',
  },
  {
    id: '5207031005',
    districtId: '5207031',
    name: 'Mujahiddin',
  },
  {
    id: '5207031006',
    districtId: '5207031',
    name: 'Mataiyang',
  },
  {
    id: '5207040001',
    districtId: '5207040',
    name: 'Sapugara Bree',
  },
  {
    id: '5207040002',
    districtId: '5207040',
    name: 'Desa Beru',
  },
  {
    id: '5207040003',
    districtId: '5207040',
    name: 'Tepas',
  },
  {
    id: '5207040004',
    districtId: '5207040',
    name: 'Bangkat Monteh',
  },
  {
    id: '5207040005',
    districtId: '5207040',
    name: 'Seminar Salit',
  },
  {
    id: '5207040006',
    districtId: '5207040',
    name: 'Tepas Sepakat',
  },
  {
    id: '5207040007',
    districtId: '5207040',
    name: 'Moteng',
  },
  {
    id: '5207040008',
    districtId: '5207040',
    name: 'Lamuntet',
  },
  {
    id: '5207040009',
    districtId: '5207040',
    name: 'Rarak Rongis',
  },
  {
    id: '5207050002',
    districtId: '5207050',
    name: 'Kelanir',
  },
  {
    id: '5207050003',
    districtId: '5207050',
    name: 'Meraran',
  },
  {
    id: '5207050004',
    districtId: '5207050',
    name: 'Air Suning',
  },
  {
    id: '5207050006',
    districtId: '5207050',
    name: 'Tapir',
  },
  {
    id: '5207050007',
    districtId: '5207050',
    name: 'Seteluk Atas',
  },
  {
    id: '5207050008',
    districtId: '5207050',
    name: 'Seteluk Tengah',
  },
  {
    id: '5207050009',
    districtId: '5207050',
    name: 'Lamusung',
  },
  {
    id: '5207050010',
    districtId: '5207050',
    name: 'Loka',
  },
  {
    id: '5207050011',
    districtId: '5207050',
    name: 'Seran',
  },
  {
    id: '5207051001',
    districtId: '5207051',
    name: 'Senayan',
  },
  {
    id: '5207051002',
    districtId: '5207051',
    name: 'Mantar',
  },
  {
    id: '5207051003',
    districtId: '5207051',
    name: 'Kiantar',
  },
  {
    id: '5207051004',
    districtId: '5207051',
    name: 'Poto Tano',
  },
  {
    id: '5207051005',
    districtId: '5207051',
    name: 'UPT Tambak Sari',
  },
  {
    id: '5207051006',
    districtId: '5207051',
    name: 'Tua Nanga',
  },
  {
    id: '5207051007',
    districtId: '5207051',
    name: 'Tebo',
  },
  {
    id: '5207051008',
    districtId: '5207051',
    name: 'Kokar Lian',
  },
  {
    id: '5208010001',
    districtId: '5208010',
    name: 'Malaka',
  },
  {
    id: '5208010002',
    districtId: '5208010',
    name: 'Pemenang Barat',
  },
  {
    id: '5208010003',
    districtId: '5208010',
    name: 'Pemenang Timur',
  },
  {
    id: '5208010004',
    districtId: '5208010',
    name: 'Gili Indah',
  },
  {
    id: '5208020001',
    districtId: '5208020',
    name: 'Sigar Penjalin',
  },
  {
    id: '5208020002',
    districtId: '5208020',
    name: 'Teniga',
  },
  {
    id: '5208020003',
    districtId: '5208020',
    name: 'Tegal Maja',
  },
  {
    id: '5208020004',
    districtId: '5208020',
    name: 'Jenggala',
  },
  {
    id: '5208020005',
    districtId: '5208020',
    name: 'Tanjung',
  },
  {
    id: '5208020006',
    districtId: '5208020',
    name: 'Sokong',
  },
  {
    id: '5208020007',
    districtId: '5208020',
    name: 'Medana',
  },
  {
    id: '5208030002',
    districtId: '5208030',
    name: 'Gondang',
  },
  {
    id: '5208030003',
    districtId: '5208030',
    name: 'Genggelang',
  },
  {
    id: '5208030005',
    districtId: '5208030',
    name: 'Sambik Bangkol',
  },
  {
    id: '5208040001',
    districtId: '5208040',
    name: 'Santong',
  },
  {
    id: '5208040002',
    districtId: '5208040',
    name: 'Pendua',
  },
  {
    id: '5208040003',
    districtId: '5208040',
    name: 'Kayangan',
  },
  {
    id: '5208040004',
    districtId: '5208040',
    name: 'Dangiang',
  },
  {
    id: '5208040005',
    districtId: '5208040',
    name: 'Sesait',
  },
  {
    id: '5208040006',
    districtId: '5208040',
    name: 'Gumantar',
  },
  {
    id: '5208040008',
    districtId: '5208040',
    name: 'Salut',
  },
  {
    id: '5208050001',
    districtId: '5208050',
    name: 'Mumbul Sari',
  },
  {
    id: '5208050002',
    districtId: '5208050',
    name: 'Akar Akar',
  },
  {
    id: '5208050003',
    districtId: '5208050',
    name: 'Sukadana',
  },
  {
    id: '5208050004',
    districtId: '5208050',
    name: 'Anyar',
  },
  {
    id: '5208050005',
    districtId: '5208050',
    name: 'Senaru',
  },
  {
    id: '5208050006',
    districtId: '5208050',
    name: 'Bayan',
  },
  {
    id: '5208050007',
    districtId: '5208050',
    name: 'Karang Bajo',
  },
  {
    id: '5208050008',
    districtId: '5208050',
    name: 'Loloan',
  },
  {
    id: '5208050009',
    districtId: '5208050',
    name: 'Sambik Elen',
  },
  {
    id: '5271010004',
    districtId: '5271010',
    name: 'Ampenan Selatan',
  },
  {
    id: '5271010005',
    districtId: '5271010',
    name: 'Ampenan Tengah',
  },
  {
    id: '5271010007',
    districtId: '5271010',
    name: 'Ampenan Utara',
  },
  {
    id: '5271010008',
    districtId: '5271010',
    name: 'Banjar',
  },
  {
    id: '5271010009',
    districtId: '5271010',
    name: 'Taman Sari',
  },
  {
    id: '5271010010',
    districtId: '5271010',
    name: 'Kebon Sari',
  },
  {
    id: '5271010011',
    districtId: '5271010',
    name: 'Pejarakan Karya',
  },
  {
    id: '5271010012',
    districtId: '5271010',
    name: 'Bintaro',
  },
  {
    id: '5271010013',
    districtId: '5271010',
    name: 'Dayan Peken',
  },
  {
    id: '5271011001',
    districtId: '5271011',
    name: 'Jempong Baru',
  },
  {
    id: '5271011002',
    districtId: '5271011',
    name: 'Tanjung Karang',
  },
  {
    id: '5271011003',
    districtId: '5271011',
    name: 'Karang Pule',
  },
  {
    id: '5271011004',
    districtId: '5271011',
    name: 'Tanjung Karang Permai',
  },
  {
    id: '5271011005',
    districtId: '5271011',
    name: 'Kekalik Jaya',
  },
  {
    id: '5271020001',
    districtId: '5271020',
    name: 'Pagesangan',
  },
  {
    id: '5271020002',
    districtId: '5271020',
    name: 'Mataram Timur',
  },
  {
    id: '5271020003',
    districtId: '5271020',
    name: 'Pagesangan Barat',
  },
  {
    id: '5271020004',
    districtId: '5271020',
    name: 'Pagesangan Timur',
  },
  {
    id: '5271020005',
    districtId: '5271020',
    name: 'Pejanggik',
  },
  {
    id: '5271020006',
    districtId: '5271020',
    name: 'Punia',
  },
  {
    id: '5271020007',
    districtId: '5271020',
    name: 'Pagutan',
  },
  {
    id: '5271020008',
    districtId: '5271020',
    name: 'Pagutan Barat',
  },
  {
    id: '5271020009',
    districtId: '5271020',
    name: 'Pagutan Timur',
  },
  {
    id: '5271021001',
    districtId: '5271021',
    name: 'Dasan Agung Baru',
  },
  {
    id: '5271021002',
    districtId: '5271021',
    name: 'Gomong',
  },
  {
    id: '5271021003',
    districtId: '5271021',
    name: 'Dasan Agung',
  },
  {
    id: '5271021004',
    districtId: '5271021',
    name: 'Mataram Barat',
  },
  {
    id: '5271021005',
    districtId: '5271021',
    name: 'Monjok Barat',
  },
  {
    id: '5271021006',
    districtId: '5271021',
    name: 'Karang Baru',
  },
  {
    id: '5271021007',
    districtId: '5271021',
    name: 'Rembiga',
  },
  {
    id: '5271021008',
    districtId: '5271021',
    name: 'Monjok Timur',
  },
  {
    id: '5271021009',
    districtId: '5271021',
    name: 'Monjok',
  },
  {
    id: '5271030004',
    districtId: '5271030',
    name: 'Cakranegara Selatan',
  },
  {
    id: '5271030005',
    districtId: '5271030',
    name: 'Cakranegara Barat',
  },
  {
    id: '5271030006',
    districtId: '5271030',
    name: 'Cakranegara Timur',
  },
  {
    id: '5271030007',
    districtId: '5271030',
    name: 'Cakranegara Utara',
  },
  {
    id: '5271030009',
    districtId: '5271030',
    name: 'Sayang Sayang',
  },
  {
    id: '5271030010',
    districtId: '5271030',
    name: 'Cakranegara Selatan Baru',
  },
  {
    id: '5271030011',
    districtId: '5271030',
    name: 'Cilinaya',
  },
  {
    id: '5271030012',
    districtId: '5271030',
    name: 'Sapta Marga',
  },
  {
    id: '5271030013',
    districtId: '5271030',
    name: 'Mayura',
  },
  {
    id: '5271030014',
    districtId: '5271030',
    name: 'Karang Taliwang',
  },
  {
    id: '5271031001',
    districtId: '5271031',
    name: 'Dasan Cermen',
  },
  {
    id: '5271031002',
    districtId: '5271031',
    name: 'Abian Tubuh Baru',
  },
  {
    id: '5271031003',
    districtId: '5271031',
    name: 'Babakan',
  },
  {
    id: '5271031004',
    districtId: '5271031',
    name: 'Turida',
  },
  {
    id: '5271031005',
    districtId: '5271031',
    name: 'Mandalika',
  },
  {
    id: '5271031006',
    districtId: '5271031',
    name: 'Bertais',
  },
  {
    id: '5271031007',
    districtId: '5271031',
    name: 'Selagalas',
  },
  {
    id: '5272010004',
    districtId: '5272010',
    name: 'Paruga',
  },
  {
    id: '5272010005',
    districtId: '5272010',
    name: 'Tanjung',
  },
  {
    id: '5272010006',
    districtId: '5272010',
    name: 'Sarae',
  },
  {
    id: '5272010007',
    districtId: '5272010',
    name: 'Nae',
  },
  {
    id: '5272010009',
    districtId: '5272010',
    name: 'Dara',
  },
  {
    id: '5272010010',
    districtId: '5272010',
    name: 'Pane',
  },
  {
    id: '5272011001',
    districtId: '5272011',
    name: 'Sambinae',
  },
  {
    id: '5272011002',
    districtId: '5272011',
    name: 'Panggi',
  },
  {
    id: '5272011003',
    districtId: '5272011',
    name: 'Mande',
  },
  {
    id: '5272011004',
    districtId: '5272011',
    name: 'Sadia',
  },
  {
    id: '5272011005',
    districtId: '5272011',
    name: 'Manggemaci',
  },
  {
    id: '5272011006',
    districtId: '5272011',
    name: 'Monggonao',
  },
  {
    id: '5272011007',
    districtId: '5272011',
    name: 'Lewirato',
  },
  {
    id: '5272011008',
    districtId: '5272011',
    name: 'Penatoi',
  },
  {
    id: '5272011009',
    districtId: '5272011',
    name: 'Santi',
  },
  {
    id: '5272011010',
    districtId: '5272011',
    name: 'Matakando',
  },
  {
    id: '5272020001',
    districtId: '5272020',
    name: 'Lampe',
  },
  {
    id: '5272020002',
    districtId: '5272020',
    name: 'Dodu',
  },
  {
    id: '5272020003',
    districtId: '5272020',
    name: 'Nungga',
  },
  {
    id: '5272020014',
    districtId: '5272020',
    name: "Oi Fo'O",
  },
  {
    id: '5272020015',
    districtId: '5272020',
    name: 'Kodo',
  },
  {
    id: '5272020016',
    districtId: '5272020',
    name: 'Lelamase',
  },
  {
    id: '5272021001',
    districtId: '5272021',
    name: 'Nitu',
  },
  {
    id: '5272021002',
    districtId: '5272021',
    name: 'Rontu',
  },
  {
    id: '5272021003',
    districtId: '5272021',
    name: 'Rabangodu Selatan',
  },
  {
    id: '5272021004',
    districtId: '5272021',
    name: 'Rabangodu Utara',
  },
  {
    id: '5272021005',
    districtId: '5272021',
    name: 'Penaraga',
  },
  {
    id: '5272021006',
    districtId: '5272021',
    name: 'Rabadompu Barat',
  },
  {
    id: '5272021007',
    districtId: '5272021',
    name: 'Rabadompu Timur',
  },
  {
    id: '5272021008',
    districtId: '5272021',
    name: 'Kendo',
  },
  {
    id: '5272021009',
    districtId: '5272021',
    name: 'Penanae',
  },
  {
    id: '5272021010',
    districtId: '5272021',
    name: 'Rite',
  },
  {
    id: '5272021011',
    districtId: '5272021',
    name: 'Ntobo',
  },
  {
    id: '5272030001',
    districtId: '5272030',
    name: 'Melayu',
  },
  {
    id: '5272030002',
    districtId: '5272030',
    name: 'Jatiwangi',
  },
  {
    id: '5272030003',
    districtId: '5272030',
    name: 'Jatibaru',
  },
  {
    id: '5272030004',
    districtId: '5272030',
    name: 'Kolo',
  },
  {
    id: '5301021005',
    districtId: '5301021',
    name: 'Welibo',
  },
  {
    id: '5301021006',
    districtId: '5301021',
    name: 'Patiala Bawa',
  },
  {
    id: '5301021007',
    districtId: '5301021',
    name: 'Laboya Bawa',
  },
  {
    id: '5301021008',
    districtId: '5301021',
    name: 'Watu Karere',
  },
  {
    id: '5301021009',
    districtId: '5301021',
    name: 'Kabu Karudi',
  },
  {
    id: '5301021010',
    districtId: '5301021',
    name: 'Laboya Dete',
  },
  {
    id: '5301021011',
    districtId: '5301021',
    name: 'Sodana',
  },
  {
    id: '5301021012',
    districtId: '5301021',
    name: 'Rajaka',
  },
  {
    id: '5301021013',
    districtId: '5301021',
    name: 'Ringu Rara',
  },
  {
    id: '5301021014',
    districtId: '5301021',
    name: 'Bodo Hula',
  },
  {
    id: '5301021015',
    districtId: '5301021',
    name: 'Pala Moko',
  },
  {
    id: '5301022001',
    districtId: '5301022',
    name: 'Hoba Wawi',
  },
  {
    id: '5301022002',
    districtId: '5301022',
    name: 'Rua',
  },
  {
    id: '5301022003',
    districtId: '5301022',
    name: 'Pahola',
  },
  {
    id: '5301022004',
    districtId: '5301022',
    name: 'Wai Hura',
  },
  {
    id: '5301022005',
    districtId: '5301022',
    name: 'Bali Loku',
  },
  {
    id: '5301022006',
    districtId: '5301022',
    name: 'Hupu Mada',
  },
  {
    id: '5301022007',
    districtId: '5301022',
    name: 'Katiku Loku',
  },
  {
    id: '5301022008',
    districtId: '5301022',
    name: 'Tara Manu',
  },
  {
    id: '5301022009',
    districtId: '5301022',
    name: 'Prai Bakul',
  },
  {
    id: '5301022010',
    districtId: '5301022',
    name: 'Mamodu',
  },
  {
    id: '5301022011',
    districtId: '5301022',
    name: 'Rewa Rara',
  },
  {
    id: '5301022012',
    districtId: '5301022',
    name: 'Ana Wolu',
  },
  {
    id: '5301022013',
    districtId: '5301022',
    name: 'Wei Mangoma',
  },
  {
    id: '5301022014',
    districtId: '5301022',
    name: 'Pari Rara',
  },
  {
    id: '5301023001',
    districtId: '5301023',
    name: 'Wetana',
  },
  {
    id: '5301023002',
    districtId: '5301023',
    name: 'Gaura',
  },
  {
    id: '5301023003',
    districtId: '5301023',
    name: 'Patiala Dete',
  },
  {
    id: '5301023004',
    districtId: '5301023',
    name: 'Harona Kala',
  },
  {
    id: '5301050001',
    districtId: '5301050',
    name: 'Dede Kadu',
  },
  {
    id: '5301050002',
    districtId: '5301050',
    name: 'Wee Karou',
  },
  {
    id: '5301050003',
    districtId: '5301050',
    name: 'Soba Wawi',
  },
  {
    id: '5301050005',
    districtId: '5301050',
    name: 'Bera Dolu',
  },
  {
    id: '5301050006',
    districtId: '5301050',
    name: 'Doka Kaka',
  },
  {
    id: '5301050007',
    districtId: '5301050',
    name: 'Tana Rara',
  },
  {
    id: '5301050008',
    districtId: '5301050',
    name: 'Bali Ledo',
  },
  {
    id: '5301050009',
    districtId: '5301050',
    name: 'Loda Pare',
  },
  {
    id: '5301050010',
    districtId: '5301050',
    name: 'Wee Dabo',
  },
  {
    id: '5301050011',
    districtId: '5301050',
    name: 'Dira Tana',
  },
  {
    id: '5301050012',
    districtId: '5301050',
    name: 'Ubu Raya',
  },
  {
    id: '5301050013',
    districtId: '5301050',
    name: 'Tema Tana',
  },
  {
    id: '5301050014',
    districtId: '5301050',
    name: 'Manola',
  },
  {
    id: '5301060002',
    districtId: '5301060',
    name: 'Wailiang',
  },
  {
    id: '5301060003',
    districtId: '5301060',
    name: 'Maliti',
  },
  {
    id: '5301060004',
    districtId: '5301060',
    name: 'Komerda',
  },
  {
    id: '5301060005',
    districtId: '5301060',
    name: 'Kampung Baru',
  },
  {
    id: '5301060006',
    districtId: '5301060',
    name: 'Kampung Sawah',
  },
  {
    id: '5301060007',
    districtId: '5301060',
    name: 'Kodaka',
  },
  {
    id: '5301060008',
    districtId: '5301060',
    name: 'Lapale',
  },
  {
    id: '5301060009',
    districtId: '5301060',
    name: 'Tebara',
  },
  {
    id: '5301060010',
    districtId: '5301060',
    name: 'Kalembu Kuni',
  },
  {
    id: '5301060011',
    districtId: '5301060',
    name: 'Soba Rade',
  },
  {
    id: '5301060012',
    districtId: '5301060',
    name: 'Pada Eweta',
  },
  {
    id: '5301060013',
    districtId: '5301060',
    name: 'Modu Waimaringu',
  },
  {
    id: '5301060014',
    districtId: '5301060',
    name: 'Puu Mawo',
  },
  {
    id: '5301072001',
    districtId: '5301072',
    name: 'Loko Ry',
  },
  {
    id: '5301072002',
    districtId: '5301072',
    name: 'Lolo Wano',
  },
  {
    id: '5301072003',
    districtId: '5301072',
    name: 'Ngadu Pada',
  },
  {
    id: '5301072004',
    districtId: '5301072',
    name: 'Malata',
  },
  {
    id: '5301072005',
    districtId: '5301072',
    name: 'Lingu Lango',
  },
  {
    id: '5301072006',
    districtId: '5301072',
    name: 'Manu Kuku',
  },
  {
    id: '5301072007',
    districtId: '5301072',
    name: 'Wee Patola',
  },
  {
    id: '5301072008',
    districtId: '5301072',
    name: 'Kareka Nduku',
  },
  {
    id: '5301072009',
    districtId: '5301072',
    name: 'Wanokaza',
  },
  {
    id: '5301072010',
    districtId: '5301072',
    name: 'Bondo Tera',
  },
  {
    id: '5301072011',
    districtId: '5301072',
    name: 'Zala Kadu',
  },
  {
    id: '5301072012',
    districtId: '5301072',
    name: 'Lolo Tana',
  },
  {
    id: '5301072013',
    districtId: '5301072',
    name: 'Kareka Nduku Utara',
  },
  {
    id: '5301072014',
    districtId: '5301072',
    name: 'Kareka Nduku Selatan',
  },
  {
    id: '5301072015',
    districtId: '5301072',
    name: 'Manu Mada',
  },
  {
    id: '5301072016',
    districtId: '5301072',
    name: 'Elu Loda',
  },
  {
    id: '5301072017',
    districtId: '5301072',
    name: 'Kalebu Ana Kaka',
  },
  {
    id: '5301072018',
    districtId: '5301072',
    name: 'Tarona',
  },
  {
    id: '5302010009',
    districtId: '5302010',
    name: 'Kondamara',
  },
  {
    id: '5302010010',
    districtId: '5302010',
    name: 'Lewapaku',
  },
  {
    id: '5302010011',
    districtId: '5302010',
    name: 'Tanarara',
  },
  {
    id: '5302010014',
    districtId: '5302010',
    name: 'Kambata Wundut',
  },
  {
    id: '5302010015',
    districtId: '5302010',
    name: 'Rakawatu',
  },
  {
    id: '5302010017',
    districtId: '5302010',
    name: 'Kambu Hapang',
  },
  {
    id: '5302010018',
    districtId: '5302010',
    name: 'Matawai Pawali',
  },
  {
    id: '5302010019',
    districtId: '5302010',
    name: 'Bidi Hunga',
  },
  {
    id: '5302011005',
    districtId: '5302011',
    name: 'Pulu Panjang',
  },
  {
    id: '5302011006',
    districtId: '5302011',
    name: 'Makamenggit',
  },
  {
    id: '5302011007',
    districtId: '5302011',
    name: 'Prai Karang',
  },
  {
    id: '5302011008',
    districtId: '5302011',
    name: 'Prai Paha',
  },
  {
    id: '5302011009',
    districtId: '5302011',
    name: 'Prai Hambili',
  },
  {
    id: '5302011010',
    districtId: '5302011',
    name: 'Tandula Jangga',
  },
  {
    id: '5302011011',
    districtId: '5302011',
    name: 'Tanatuku',
  },
  {
    id: '5302011013',
    districtId: '5302011',
    name: 'Ngadu Langgi',
  },
  {
    id: '5302012001',
    districtId: '5302012',
    name: 'Watumbelar',
  },
  {
    id: '5302012002',
    districtId: '5302012',
    name: 'Umamanu',
  },
  {
    id: '5302012003',
    districtId: '5302012',
    name: 'Kangeli',
  },
  {
    id: '5302012004',
    districtId: '5302012',
    name: 'Lai Hawu',
  },
  {
    id: '5302012005',
    districtId: '5302012',
    name: 'Mondu Lambi',
  },
  {
    id: '5302012006',
    districtId: '5302012',
    name: 'Bidi Praing',
  },
  {
    id: '5302013001',
    districtId: '5302013',
    name: 'Prai Bakul',
  },
  {
    id: '5302013002',
    districtId: '5302013',
    name: 'Lai Lara',
  },
  {
    id: '5302013003',
    districtId: '5302013',
    name: 'Kombapari',
  },
  {
    id: '5302013004',
    districtId: '5302013',
    name: 'Mandahu',
  },
  {
    id: '5302013005',
    districtId: '5302013',
    name: 'Matawai Amahu',
  },
  {
    id: '5302020001',
    districtId: '5302020',
    name: 'Tarimbang',
  },
  {
    id: '5302020002',
    districtId: '5302020',
    name: 'Tapil',
  },
  {
    id: '5302020003',
    districtId: '5302020',
    name: 'Billa',
  },
  {
    id: '5302020004',
    districtId: '5302020',
    name: 'Praing Kareha',
  },
  {
    id: '5302020010',
    districtId: '5302020',
    name: 'Waikanabu',
  },
  {
    id: '5302020011',
    districtId: '5302020',
    name: 'Karita',
  },
  {
    id: '5302020013',
    districtId: '5302020',
    name: 'Wudi Pandak',
  },
  {
    id: '5302020014',
    districtId: '5302020',
    name: 'Pindu Hurani',
  },
  {
    id: '5302020015',
    districtId: '5302020',
    name: 'Kuki Talu',
  },
  {
    id: '5302020016',
    districtId: '5302020',
    name: 'Bangga Watu',
  },
  {
    id: '5302021001',
    districtId: '5302021',
    name: 'Wahang',
  },
  {
    id: '5302021002',
    districtId: '5302021',
    name: 'Tawui',
  },
  {
    id: '5302021003',
    districtId: '5302021',
    name: 'Lailunggi',
  },
  {
    id: '5302021004',
    districtId: '5302021',
    name: 'Wangga Bewa',
  },
  {
    id: '5302021005',
    districtId: '5302021',
    name: 'Ramuk',
  },
  {
    id: '5302021006',
    districtId: '5302021',
    name: 'Maha Niwa',
  },
  {
    id: '5302030010',
    districtId: '5302030',
    name: 'Kananggar',
  },
  {
    id: '5302030011',
    districtId: '5302030',
    name: 'Karera Jangga',
  },
  {
    id: '5302030018',
    districtId: '5302030',
    name: 'Mehang Mata',
  },
  {
    id: '5302030020',
    districtId: '5302030',
    name: 'Prai Mbana',
  },
  {
    id: '5302030021',
    districtId: '5302030',
    name: 'Pabera Manera',
  },
  {
    id: '5302030025',
    districtId: '5302030',
    name: 'Winu Muru',
  },
  {
    id: '5302030026',
    districtId: '5302030',
    name: 'Lai Taku',
  },
  {
    id: '5302031001',
    districtId: '5302031',
    name: 'Prai Salura',
  },
  {
    id: '5302031002',
    districtId: '5302031',
    name: 'Praimadita',
  },
  {
    id: '5302031003',
    districtId: '5302031',
    name: 'Nggongi',
  },
  {
    id: '5302031004',
    districtId: '5302031',
    name: 'Tandula Jangga',
  },
  {
    id: '5302031005',
    districtId: '5302031',
    name: 'Nangga',
  },
  {
    id: '5302031010',
    districtId: '5302031',
    name: 'Jangga Mangu',
  },
  {
    id: '5302031012',
    districtId: '5302031',
    name: 'Ananjaki',
  },
  {
    id: '5302032001',
    districtId: '5302032',
    name: 'Karipi',
  },
  {
    id: '5302032002',
    districtId: '5302032',
    name: 'Wanggameti',
  },
  {
    id: '5302032003',
    districtId: '5302032',
    name: 'Katikuwai',
  },
  {
    id: '5302032004',
    districtId: '5302032',
    name: 'Katikutana',
  },
  {
    id: '5302032005',
    districtId: '5302032',
    name: 'Prai Bokul',
  },
  {
    id: '5302032006',
    districtId: '5302032',
    name: 'Katiku Luku',
  },
  {
    id: '5302033001',
    districtId: '5302033',
    name: 'Mau Ramba',
  },
  {
    id: '5302033002',
    districtId: '5302033',
    name: 'Kambata Bundung',
  },
  {
    id: '5302033003',
    districtId: '5302033',
    name: 'Kamanggih',
  },
  {
    id: '5302033004',
    districtId: '5302033',
    name: 'Kataka',
  },
  {
    id: '5302033005',
    districtId: '5302033',
    name: 'Matawai Maringu',
  },
  {
    id: '5302033006',
    districtId: '5302033',
    name: 'Matawai Katingga',
  },
  {
    id: '5302033007',
    districtId: '5302033',
    name: 'Kotak Kawau',
  },
  {
    id: '5302033008',
    districtId: '5302033',
    name: 'Lai Mbonga',
  },
  {
    id: '5302033009',
    districtId: '5302033',
    name: 'Meo Rumba',
  },
  {
    id: '5302034001',
    districtId: '5302034',
    name: 'Patamawai',
  },
  {
    id: '5302034002',
    districtId: '5302034',
    name: 'La Hiru',
  },
  {
    id: '5302034003',
    districtId: '5302034',
    name: 'Wairara',
  },
  {
    id: '5302034004',
    districtId: '5302034',
    name: 'Prai Kalala',
  },
  {
    id: '5302034005',
    districtId: '5302034',
    name: 'Lulundilu',
  },
  {
    id: '5302034006',
    districtId: '5302034',
    name: 'Haray',
  },
  {
    id: '5302035001',
    districtId: '5302035',
    name: 'Prai Witu',
  },
  {
    id: '5302035002',
    districtId: '5302035',
    name: 'Kakaha',
  },
  {
    id: '5302035003',
    districtId: '5302035',
    name: 'Hamba Wutang',
  },
  {
    id: '5302035004',
    districtId: '5302035',
    name: 'Kabanda',
  },
  {
    id: '5302035005',
    districtId: '5302035',
    name: 'Prau Raming',
  },
  {
    id: '5302040010',
    districtId: '5302040',
    name: 'Kuruwaki',
  },
  {
    id: '5302040011',
    districtId: '5302040',
    name: 'Pamburu',
  },
  {
    id: '5302040012',
    districtId: '5302040',
    name: 'Kaliuda',
  },
  {
    id: '5302040013',
    districtId: '5302040',
    name: 'Tanamanang',
  },
  {
    id: '5302040014',
    districtId: '5302040',
    name: 'Tamma',
  },
  {
    id: '5302040015',
    districtId: '5302040',
    name: 'Lambakara',
  },
  {
    id: '5302040017',
    districtId: '5302040',
    name: 'Palanggai',
  },
  {
    id: '5302041002',
    districtId: '5302041',
    name: 'Lainjanji',
  },
  {
    id: '5302041003',
    districtId: '5302041',
    name: 'La Tena',
  },
  {
    id: '5302041004',
    districtId: '5302041',
    name: 'Lai Pandak',
  },
  {
    id: '5302041005',
    districtId: '5302041',
    name: 'Lumbu Manggit',
  },
  {
    id: '5302041006',
    districtId: '5302041',
    name: 'Paranda',
  },
  {
    id: '5302041007',
    districtId: '5302041',
    name: 'Hadakamali',
  },
  {
    id: '5302041008',
    districtId: '5302041',
    name: 'W U L A',
  },
  {
    id: '5302051001',
    districtId: '5302051',
    name: 'Tamburi',
  },
  {
    id: '5302051002',
    districtId: '5302051',
    name: 'Lai Lanjang',
  },
  {
    id: '5302051003',
    districtId: '5302051',
    name: 'Hanggaroru',
  },
  {
    id: '5302051004',
    districtId: '5302051',
    name: 'Kabaru',
  },
  {
    id: '5302051005',
    districtId: '5302051',
    name: 'Heikatapu',
  },
  {
    id: '5302051006',
    districtId: '5302051',
    name: 'Tanaraing',
  },
  {
    id: '5302051007',
    districtId: '5302051',
    name: 'Rindi',
  },
  {
    id: '5302051008',
    districtId: '5302051',
    name: 'Kayuri',
  },
  {
    id: '5302052003',
    districtId: '5302052',
    name: 'Lairuru',
  },
  {
    id: '5302052004',
    districtId: '5302052',
    name: 'Watu Puda',
  },
  {
    id: '5302052005',
    districtId: '5302052',
    name: 'Umalulu',
  },
  {
    id: '5302052013',
    districtId: '5302052',
    name: 'Lumbukore',
  },
  {
    id: '5302052014',
    districtId: '5302052',
    name: 'Watu Hadang',
  },
  {
    id: '5302052015',
    districtId: '5302052',
    name: 'Mutunggeding',
  },
  {
    id: '5302052016',
    districtId: '5302052',
    name: 'Matawai Atu',
  },
  {
    id: '5302052017',
    districtId: '5302052',
    name: 'Patawang',
  },
  {
    id: '5302052018',
    districtId: '5302052',
    name: 'Wanga',
  },
  {
    id: '5302052019',
    districtId: '5302052',
    name: 'Ngaru Kanoru',
  },
  {
    id: '5302060005',
    districtId: '5302060',
    name: 'Kambata Tana',
  },
  {
    id: '5302060007',
    districtId: '5302060',
    name: 'Mau Bokul',
  },
  {
    id: '5302060009',
    districtId: '5302060',
    name: 'Kadumbul',
  },
  {
    id: '5302060010',
    districtId: '5302060',
    name: 'Palakahembi',
  },
  {
    id: '5302060011',
    districtId: '5302060',
    name: 'Watumbaka',
  },
  {
    id: '5302060012',
    districtId: '5302060',
    name: 'Kawangu',
  },
  {
    id: '5302060015',
    districtId: '5302060',
    name: 'Laindeha',
  },
  {
    id: '5302061001',
    districtId: '5302061',
    name: 'Waimbidi',
  },
  {
    id: '5302061002',
    districtId: '5302061',
    name: 'Luku Wingir',
  },
  {
    id: '5302061003',
    districtId: '5302061',
    name: 'Marada Mundi',
  },
  {
    id: '5302061004',
    districtId: '5302061',
    name: 'Maidang',
  },
  {
    id: '5302061005',
    districtId: '5302061',
    name: 'Lai Meta',
  },
  {
    id: '5302061006',
    districtId: '5302061',
    name: 'Mahu Bokul',
  },
  {
    id: '5302070008',
    districtId: '5302070',
    name: 'Kamalaputi',
  },
  {
    id: '5302070009',
    districtId: '5302070',
    name: 'Matawai',
  },
  {
    id: '5302070010',
    districtId: '5302070',
    name: 'Hambala',
  },
  {
    id: '5302070011',
    districtId: '5302070',
    name: 'Kambajawa',
  },
  {
    id: '5302070012',
    districtId: '5302070',
    name: 'Mbatakapidu',
  },
  {
    id: '5302070013',
    districtId: '5302070',
    name: 'Pambotanjara',
  },
  {
    id: '5302070014',
    districtId: '5302070',
    name: 'Luku Kamaru',
  },
  {
    id: '5302071001',
    districtId: '5302071',
    name: 'Kiritana',
  },
  {
    id: '5302071002',
    districtId: '5302071',
    name: 'Malumbi',
  },
  {
    id: '5302071003',
    districtId: '5302071',
    name: 'Lambanapu',
  },
  {
    id: '5302071004',
    districtId: '5302071',
    name: 'Mauliru',
  },
  {
    id: '5302071005',
    districtId: '5302071',
    name: 'Mau Hau',
  },
  {
    id: '5302071006',
    districtId: '5302071',
    name: 'Kambaniru',
  },
  {
    id: '5302071007',
    districtId: '5302071',
    name: 'Prailiu',
  },
  {
    id: '5302071008',
    districtId: '5302071',
    name: 'Wangga',
  },
  {
    id: '5302080007',
    districtId: '5302080',
    name: 'Rambangaru',
  },
  {
    id: '5302080008',
    districtId: '5302080',
    name: 'Prai Bakul',
  },
  {
    id: '5302080009',
    districtId: '5302080',
    name: 'Mbatapuhu',
  },
  {
    id: '5302080010',
    districtId: '5302080',
    name: 'Wunga',
  },
  {
    id: '5302080011',
    districtId: '5302080',
    name: 'N A P U',
  },
  {
    id: '5302080012',
    districtId: '5302080',
    name: 'Kadahang',
  },
  {
    id: '5302080013',
    districtId: '5302080',
    name: 'Kalamba',
  },
  {
    id: '5302081001',
    districtId: '5302081',
    name: 'Ndapayami',
  },
  {
    id: '5302081003',
    districtId: '5302081',
    name: 'Kuta',
  },
  {
    id: '5302081004',
    districtId: '5302081',
    name: 'Hamba Praing',
  },
  {
    id: '5302081005',
    districtId: '5302081',
    name: 'Mondu',
  },
  {
    id: '5303100005',
    districtId: '5303100',
    name: 'Bokonusan',
  },
  {
    id: '5303100006',
    districtId: '5303100',
    name: 'Otan',
  },
  {
    id: '5303100007',
    districtId: '5303100',
    name: 'Uitao',
  },
  {
    id: '5303100008',
    districtId: '5303100',
    name: 'Huilelot',
  },
  {
    id: '5303100009',
    districtId: '5303100',
    name: 'Uiasa',
  },
  {
    id: '5303100010',
    districtId: '5303100',
    name: 'Hansisi',
  },
  {
    id: '5303100011',
    districtId: '5303100',
    name: 'Batuinan',
  },
  {
    id: '5303100012',
    districtId: '5303100',
    name: 'Letbaun',
  },
  {
    id: '5303101001',
    districtId: '5303101',
    name: 'Naikean',
  },
  {
    id: '5303101002',
    districtId: '5303101',
    name: 'Akle',
  },
  {
    id: '5303101003',
    districtId: '5303101',
    name: 'Uitiuh Ana',
  },
  {
    id: '5303101004',
    districtId: '5303101',
    name: 'Onansila',
  },
  {
    id: '5303101005',
    districtId: '5303101',
    name: 'Uitiuhtuan',
  },
  {
    id: '5303101006',
    districtId: '5303101',
    name: 'Uiboa',
  },
  {
    id: '5303110001',
    districtId: '5303110',
    name: 'Tablolong',
  },
  {
    id: '5303110002',
    districtId: '5303110',
    name: 'Lifuleo',
  },
  {
    id: '5303110003',
    districtId: '5303110',
    name: 'Tesabela',
  },
  {
    id: '5303110004',
    districtId: '5303110',
    name: 'Sumlili',
  },
  {
    id: '5303110005',
    districtId: '5303110',
    name: 'Oemat Nunu',
  },
  {
    id: '5303110006',
    districtId: '5303110',
    name: 'Kuanheum',
  },
  {
    id: '5303110007',
    districtId: '5303110',
    name: 'Bolok',
  },
  {
    id: '5303110008',
    districtId: '5303110',
    name: 'Nitneo',
  },
  {
    id: '5303110009',
    districtId: '5303110',
    name: 'Batakte',
  },
  {
    id: '5303110010',
    districtId: '5303110',
    name: 'Manulai I',
  },
  {
    id: '5303110011',
    districtId: '5303110',
    name: 'Oenesu',
  },
  {
    id: '5303110012',
    districtId: '5303110',
    name: 'Oenaek',
  },
  {
    id: '5303111001',
    districtId: '5303111',
    name: 'Bone',
  },
  {
    id: '5303111002',
    districtId: '5303111',
    name: 'Taloetan',
  },
  {
    id: '5303111003',
    districtId: '5303111',
    name: 'Usapisonbai',
  },
  {
    id: '5303111004',
    districtId: '5303111',
    name: 'Oepaha',
  },
  {
    id: '5303111005',
    districtId: '5303111',
    name: 'Tasikona',
  },
  {
    id: '5303111006',
    districtId: '5303111',
    name: 'Oenif',
  },
  {
    id: '5303111007',
    districtId: '5303111',
    name: 'Oemasi',
  },
  {
    id: '5303111008',
    districtId: '5303111',
    name: 'Oelomin',
  },
  {
    id: '5303111010',
    districtId: '5303111',
    name: 'Oben',
  },
  {
    id: '5303111011',
    districtId: '5303111',
    name: 'Besmarak',
  },
  {
    id: '5303120008',
    districtId: '5303120',
    name: 'Oelnasi',
  },
  {
    id: '5303120009',
    districtId: '5303120',
    name: 'Oelpuah',
  },
  {
    id: '5303120010',
    districtId: '5303120',
    name: 'Oebelo',
  },
  {
    id: '5303120011',
    districtId: '5303120',
    name: 'Noelbaki',
  },
  {
    id: '5303120012',
    districtId: '5303120',
    name: 'Tarus',
  },
  {
    id: '5303120013',
    districtId: '5303120',
    name: 'Penfui Timur',
  },
  {
    id: '5303120014',
    districtId: '5303120',
    name: 'Tanah Merah',
  },
  {
    id: '5303120015',
    districtId: '5303120',
    name: 'Mata Air',
  },
  {
    id: '5303121001',
    districtId: '5303121',
    name: 'Oeletsala',
  },
  {
    id: '5303121002',
    districtId: '5303121',
    name: 'Kuaklalo',
  },
  {
    id: '5303121003',
    districtId: '5303121',
    name: 'Bokong',
  },
  {
    id: '5303121004',
    districtId: '5303121',
    name: 'Baumata Timur',
  },
  {
    id: '5303121005',
    districtId: '5303121',
    name: 'Oeltua',
  },
  {
    id: '5303121006',
    districtId: '5303121',
    name: 'Baumata',
  },
  {
    id: '5303121007',
    districtId: '5303121',
    name: 'Baumata Barat',
  },
  {
    id: '5303121008',
    districtId: '5303121',
    name: 'Baumata Utara',
  },
  {
    id: '5303130012',
    districtId: '5303130',
    name: 'Oesena',
  },
  {
    id: '5303130013',
    districtId: '5303130',
    name: 'Nonbes',
  },
  {
    id: '5303130014',
    districtId: '5303130',
    name: 'Kotabes',
  },
  {
    id: '5303130015',
    districtId: '5303130',
    name: 'Ponain',
  },
  {
    id: '5303130016',
    districtId: '5303130',
    name: 'Tesbatan',
  },
  {
    id: '5303130019',
    districtId: '5303130',
    name: 'Apren',
  },
  {
    id: '5303130020',
    districtId: '5303130',
    name: 'Oenoni',
  },
  {
    id: '5303130021',
    districtId: '5303130',
    name: 'Tesbatan II',
  },
  {
    id: '5303130022',
    districtId: '5303130',
    name: 'Oenoni II',
  },
  {
    id: '5303131001',
    districtId: '5303131',
    name: 'Nekbaun',
  },
  {
    id: '5303131002',
    districtId: '5303131',
    name: 'Merbaun',
  },
  {
    id: '5303131003',
    districtId: '5303131',
    name: 'Erbaun',
  },
  {
    id: '5303131004',
    districtId: '5303131',
    name: 'Teunbaun',
  },
  {
    id: '5303131005',
    districtId: '5303131',
    name: 'Tunbaun',
  },
  {
    id: '5303131006',
    districtId: '5303131',
    name: 'Soba',
  },
  {
    id: '5303131007',
    districtId: '5303131',
    name: 'Niukbaun',
  },
  {
    id: '5303131008',
    districtId: '5303131',
    name: 'Toobaun',
  },
  {
    id: '5303132001',
    districtId: '5303132',
    name: 'Sahraen',
  },
  {
    id: '5303132002',
    districtId: '5303132',
    name: 'Retraen',
  },
  {
    id: '5303132003',
    districtId: '5303132',
    name: 'Buraen',
  },
  {
    id: '5303132005',
    districtId: '5303132',
    name: 'Sonraen',
  },
  {
    id: '5303133001',
    districtId: '5303133',
    name: 'Pakubaun',
  },
  {
    id: '5303133002',
    districtId: '5303133',
    name: 'Oebesi',
  },
  {
    id: '5303133003',
    districtId: '5303133',
    name: 'Rabeka',
  },
  {
    id: '5303133004',
    districtId: '5303133',
    name: 'Enoraen',
  },
  {
    id: '5303140001',
    districtId: '5303140',
    name: 'Oefafi',
  },
  {
    id: '5303140002',
    districtId: '5303140',
    name: 'Tuatuka',
  },
  {
    id: '5303140016',
    districtId: '5303140',
    name: 'Pukdale',
  },
  {
    id: '5303140017',
    districtId: '5303140',
    name: 'Oesao',
  },
  {
    id: '5303140018',
    districtId: '5303140',
    name: 'Naibonat',
  },
  {
    id: '5303140020',
    districtId: '5303140',
    name: 'Babau',
  },
  {
    id: '5303140021',
    districtId: '5303140',
    name: 'Merdeka',
  },
  {
    id: '5303140022',
    districtId: '5303140',
    name: 'Tuapukan',
  },
  {
    id: '5303140023',
    districtId: '5303140',
    name: 'Manusak',
  },
  {
    id: '5303140024',
    districtId: '5303140',
    name: 'Oesao II',
  },
  {
    id: '5303140025',
    districtId: '5303140',
    name: 'Oelatimo',
  },
  {
    id: '5303140026',
    districtId: '5303140',
    name: 'Tanah Putih',
  },
  {
    id: '5303141001',
    districtId: '5303141',
    name: 'Pathau',
  },
  {
    id: '5303141003',
    districtId: '5303141',
    name: 'Oemolo',
  },
  {
    id: '5303141004',
    districtId: '5303141',
    name: 'Oemofa',
  },
  {
    id: '5303141005',
    districtId: '5303141',
    name: 'Seki',
  },
  {
    id: '5303141006',
    districtId: '5303141',
    name: 'Nunmafo',
  },
  {
    id: '5303141007',
    districtId: '5303141',
    name: 'Oenunutono',
  },
  {
    id: '5303141008',
    districtId: '5303141',
    name: 'Oeniko',
  },
  {
    id: '5303141009',
    districtId: '5303141',
    name: 'Enolanan',
  },
  {
    id: '5303141010',
    districtId: '5303141',
    name: 'Oenaunu',
  },
  {
    id: '5303142001',
    districtId: '5303142',
    name: 'Kuanheum',
  },
  {
    id: '5303142002',
    districtId: '5303142',
    name: 'Fatuknutu',
  },
  {
    id: '5303142003',
    districtId: '5303142',
    name: 'Kairane',
  },
  {
    id: '5303142004',
    districtId: '5303142',
    name: 'Niunbaun',
  },
  {
    id: '5303142005',
    districtId: '5303142',
    name: 'Raknamo',
  },
  {
    id: '5303142006',
    districtId: '5303142',
    name: 'Fatuteta',
  },
  {
    id: '5303142007',
    districtId: '5303142',
    name: 'Oefeto',
  },
  {
    id: '5303150001',
    districtId: '5303150',
    name: 'Sulamu',
  },
  {
    id: '5303150002',
    districtId: '5303150',
    name: 'Pitai',
  },
  {
    id: '5303150003',
    districtId: '5303150',
    name: 'Pariti',
  },
  {
    id: '5303150004',
    districtId: '5303150',
    name: 'Oeteta',
  },
  {
    id: '5303150005',
    districtId: '5303150',
    name: 'Bipolo',
  },
  {
    id: '5303150006',
    districtId: '5303150',
    name: 'Pantulan',
  },
  {
    id: '5303150007',
    districtId: '5303150',
    name: 'Pantai Beringin',
  },
  {
    id: '5303160005',
    districtId: '5303160',
    name: 'Camplong II',
  },
  {
    id: '5303160006',
    districtId: '5303160',
    name: 'Camplong I',
  },
  {
    id: '5303160007',
    districtId: '5303160',
    name: 'Naunu',
  },
  {
    id: '5303160008',
    districtId: '5303160',
    name: 'Oebola',
  },
  {
    id: '5303160009',
    districtId: '5303160',
    name: 'Sillu',
  },
  {
    id: '5303160010',
    districtId: '5303160',
    name: 'Ekateta',
  },
  {
    id: '5303160011',
    districtId: '5303160',
    name: 'Tolnaku',
  },
  {
    id: '5303160012',
    districtId: '5303160',
    name: 'Kuimasi',
  },
  {
    id: '5303160013',
    districtId: '5303160',
    name: 'Oebola Dalam',
  },
  {
    id: '5303160014',
    districtId: '5303160',
    name: 'Kiuoni',
  },
  {
    id: '5303161001',
    districtId: '5303161',
    name: 'Nunsaen',
  },
  {
    id: '5303161002',
    districtId: '5303161',
    name: 'Oelbiteno',
  },
  {
    id: '5303161003',
    districtId: '5303161',
    name: 'Passi',
  },
  {
    id: '5303161004',
    districtId: '5303161',
    name: 'Nonbaun',
  },
  {
    id: '5303162001',
    districtId: '5303162',
    name: 'Kalali',
  },
  {
    id: '5303162002',
    districtId: '5303162',
    name: 'Poto',
  },
  {
    id: '5303162003',
    districtId: '5303162',
    name: 'Naitae',
  },
  {
    id: '5303162004',
    districtId: '5303162',
    name: 'Nuataus',
  },
  {
    id: '5303162005',
    districtId: '5303162',
    name: 'Tuakau',
  },
  {
    id: '5303170001',
    districtId: '5303170',
    name: 'Takari',
  },
  {
    id: '5303170002',
    districtId: '5303170',
    name: 'Noelmina',
  },
  {
    id: '5303170005',
    districtId: '5303170',
    name: 'Kauniki',
  },
  {
    id: '5303170006',
    districtId: '5303170',
    name: 'Oelnaineno',
  },
  {
    id: '5303170007',
    districtId: '5303170',
    name: 'Tanini',
  },
  {
    id: '5303170008',
    districtId: '5303170',
    name: 'Oesusu',
  },
  {
    id: '5303170009',
    districtId: '5303170',
    name: 'Tuapanaf',
  },
  {
    id: '5303170010',
    districtId: '5303170',
    name: 'Fatukona',
  },
  {
    id: '5303180001',
    districtId: '5303180',
    name: 'Fatusuki',
  },
  {
    id: '5303180002',
    districtId: '5303180',
    name: 'Fatumetan',
  },
  {
    id: '5303180003',
    districtId: '5303180',
    name: 'Ohaem I',
  },
  {
    id: '5303180008',
    districtId: '5303180',
    name: 'Leloboko',
  },
  {
    id: '5303180009',
    districtId: '5303180',
    name: 'Lelogama',
  },
  {
    id: '5303180010',
    districtId: '5303180',
    name: 'Oelbanu',
  },
  {
    id: '5303180011',
    districtId: '5303180',
    name: 'Ohaem II',
  },
  {
    id: '5303181001',
    districtId: '5303181',
    name: 'Manubelon',
  },
  {
    id: '5303181002',
    districtId: '5303181',
    name: 'Nefoneut',
  },
  {
    id: '5303181003',
    districtId: '5303181',
    name: 'Letkole',
  },
  {
    id: '5303181004',
    districtId: '5303181',
    name: 'Bioba Barutaen',
  },
  {
    id: '5303182001',
    districtId: '5303182',
    name: 'Fatumonas',
  },
  {
    id: '5303182002',
    districtId: '5303182',
    name: 'Binafun',
  },
  {
    id: '5303182003',
    districtId: '5303182',
    name: 'Bonmuti',
  },
  {
    id: '5303182004',
    districtId: '5303182',
    name: 'Bitobe',
  },
  {
    id: '5303190007',
    districtId: '5303190',
    name: 'Afoan',
  },
  {
    id: '5303190008',
    districtId: '5303190',
    name: 'Naikliu',
  },
  {
    id: '5303190009',
    districtId: '5303190',
    name: 'Fatunaus',
  },
  {
    id: '5303190010',
    districtId: '5303190',
    name: 'Kolabe',
  },
  {
    id: '5303190011',
    districtId: '5303190',
    name: 'Bakuin',
  },
  {
    id: '5303190016',
    districtId: '5303190',
    name: 'Lilmus',
  },
  {
    id: '5303191001',
    districtId: '5303191',
    name: 'Saukibe',
  },
  {
    id: '5303191002',
    districtId: '5303191',
    name: 'Faumes',
  },
  {
    id: '5303191003',
    districtId: '5303191',
    name: 'Timau',
  },
  {
    id: '5303191004',
    districtId: '5303191',
    name: 'Honuk',
  },
  {
    id: '5303191005',
    districtId: '5303191',
    name: 'Oelfatu',
  },
  {
    id: '5303191006',
    districtId: '5303191',
    name: 'Soliu',
  },
  {
    id: '5303192001',
    districtId: '5303192',
    name: 'Nunuanah',
  },
  {
    id: '5303192002',
    districtId: '5303192',
    name: 'Kifu',
  },
  {
    id: '5303192003',
    districtId: '5303192',
    name: 'Netemnanu Selatan',
  },
  {
    id: '5303192004',
    districtId: '5303192',
    name: 'Netemnanu Utara',
  },
  {
    id: '5303192005',
    districtId: '5303192',
    name: 'Netemnanu',
  },
  {
    id: '5304010003',
    districtId: '5304010',
    name: 'Leloboko',
  },
  {
    id: '5304010004',
    districtId: '5304010',
    name: 'Nefokoko',
  },
  {
    id: '5304010005',
    districtId: '5304010',
    name: 'Lelobatan',
  },
  {
    id: '5304010006',
    districtId: '5304010',
    name: 'Netpala',
  },
  {
    id: '5304010007',
    districtId: '5304010',
    name: 'Obesi',
  },
  {
    id: '5304010008',
    districtId: '5304010',
    name: 'Eon Besi',
  },
  {
    id: '5304010009',
    districtId: '5304010',
    name: 'Bosen',
  },
  {
    id: '5304010010',
    districtId: '5304010',
    name: 'Sebot',
  },
  {
    id: '5304010011',
    districtId: '5304010',
    name: 'Ajaobaki',
  },
  {
    id: '5304010012',
    districtId: '5304010',
    name: 'Bijaepunu',
  },
  {
    id: '5304010014',
    districtId: '5304010',
    name: 'Halme',
  },
  {
    id: '5304010016',
    districtId: '5304010',
    name: 'Tunua',
  },
  {
    id: '5304010017',
    districtId: '5304010',
    name: 'Fatukoto',
  },
  {
    id: '5304010018',
    districtId: '5304010',
    name: 'Iusmollo',
  },
  {
    id: '5304010019',
    districtId: '5304010',
    name: 'Kokfeu',
  },
  {
    id: '5304010020',
    districtId: '5304010',
    name: 'Tomanat',
  },
  {
    id: '5304010021',
    districtId: '5304010',
    name: 'Tofen',
  },
  {
    id: '5304010022',
    districtId: '5304010',
    name: 'Taiftob',
  },
  {
    id: '5304011004',
    districtId: '5304011',
    name: 'Fatumnasi',
  },
  {
    id: '5304011007',
    districtId: '5304011',
    name: 'Nenas',
  },
  {
    id: '5304011008',
    districtId: '5304011',
    name: 'Nuapin',
  },
  {
    id: '5304011009',
    districtId: '5304011',
    name: 'Kuanoel',
  },
  {
    id: '5304011010',
    districtId: '5304011',
    name: 'Mutis',
  },
  {
    id: '5304012001',
    districtId: '5304012',
    name: 'Tobu',
  },
  {
    id: '5304012004',
    districtId: '5304012',
    name: 'Bonleu',
  },
  {
    id: '5304012005',
    districtId: '5304012',
    name: 'Huetalan',
  },
  {
    id: '5304012006',
    districtId: '5304012',
    name: 'Pubasu',
  },
  {
    id: '5304012007',
    districtId: '5304012',
    name: 'Bestobe',
  },
  {
    id: '5304012008',
    districtId: '5304012',
    name: 'Saubalan',
  },
  {
    id: '5304013001',
    districtId: '5304013',
    name: 'Noebesi',
  },
  {
    id: '5304013002',
    districtId: '5304013',
    name: 'Liliana',
  },
  {
    id: '5304013003',
    districtId: '5304013',
    name: 'Nunbena',
  },
  {
    id: '5304013004',
    districtId: '5304013',
    name: 'Taneotop',
  },
  {
    id: '5304013005',
    districtId: '5304013',
    name: 'Fetomone',
  },
  {
    id: '5304020004',
    districtId: '5304020',
    name: 'Tuasene',
  },
  {
    id: '5304020005',
    districtId: '5304020',
    name: 'Biloto',
  },
  {
    id: '5304020006',
    districtId: '5304020',
    name: 'Bisene',
  },
  {
    id: '5304020007',
    districtId: '5304020',
    name: 'Bikekneno',
  },
  {
    id: '5304020008',
    districtId: '5304020',
    name: 'Kesetnana',
  },
  {
    id: '5304020009',
    districtId: '5304020',
    name: 'Oinlasi',
  },
  {
    id: '5304020010',
    districtId: '5304020',
    name: 'Klani/Noinbila',
  },
  {
    id: '5304021001',
    districtId: '5304021',
    name: 'Laob',
  },
  {
    id: '5304021002',
    districtId: '5304021',
    name: 'Konbaki',
  },
  {
    id: '5304021003',
    districtId: '5304021',
    name: 'Puna',
  },
  {
    id: '5304021004',
    districtId: '5304021',
    name: 'Loli',
  },
  {
    id: '5304021005',
    districtId: '5304021',
    name: 'Mnesatbubak',
  },
  {
    id: '5304021006',
    districtId: '5304021',
    name: 'Bijeli',
  },
  {
    id: '5304021007',
    districtId: '5304021',
    name: 'Usapimnasi',
  },
  {
    id: '5304021008',
    districtId: '5304021',
    name: 'Fatumnutu',
  },
  {
    id: '5304021009',
    districtId: '5304021',
    name: 'Oelnunuh',
  },
  {
    id: '5304021010',
    districtId: '5304021',
    name: 'Balu',
  },
  {
    id: '5304021011',
    districtId: '5304021',
    name: 'Sainoni',
  },
  {
    id: '5304022001',
    districtId: '5304022',
    name: 'Besana',
  },
  {
    id: '5304022002',
    districtId: '5304022',
    name: 'Fatukoko',
  },
  {
    id: '5304022003',
    districtId: '5304022',
    name: 'Koa',
  },
  {
    id: '5304022004',
    districtId: '5304022',
    name: 'Salbait',
  },
  {
    id: '5304022005',
    districtId: '5304022',
    name: 'Oeuban',
  },
  {
    id: '5304023001',
    districtId: '5304023',
    name: 'Binaus',
  },
  {
    id: '5304023002',
    districtId: '5304023',
    name: 'Oelbubuk',
  },
  {
    id: '5304023003',
    districtId: '5304023',
    name: 'Kualeu',
  },
  {
    id: '5304023004',
    districtId: '5304023',
    name: 'Neke Mani Feto',
  },
  {
    id: '5304023005',
    districtId: '5304023',
    name: 'Oelekam',
  },
  {
    id: '5304023006',
    districtId: '5304023',
    name: 'Pika',
  },
  {
    id: '5304030001',
    districtId: '5304030',
    name: 'Cendana',
  },
  {
    id: '5304030002',
    districtId: '5304030',
    name: "So'E",
  },
  {
    id: '5304030003',
    districtId: '5304030',
    name: 'Oebesa',
  },
  {
    id: '5304030004',
    districtId: '5304030',
    name: 'Kobekamusa',
  },
  {
    id: '5304030006',
    districtId: '5304030',
    name: 'Oekefan',
  },
  {
    id: '5304030007',
    districtId: '5304030',
    name: 'Taubneno',
  },
  {
    id: '5304030008',
    districtId: '5304030',
    name: 'Kampung Baru',
  },
  {
    id: '5304030009',
    districtId: '5304030',
    name: 'Karang Siri',
  },
  {
    id: '5304030010',
    districtId: '5304030',
    name: 'Nonohonis',
  },
  {
    id: '5304030011',
    districtId: '5304030',
    name: 'Kota Baru',
  },
  {
    id: '5304030012',
    districtId: '5304030',
    name: 'Kuatae',
  },
  {
    id: '5304030013',
    districtId: '5304030',
    name: 'Noemeto',
  },
  {
    id: '5304040009',
    districtId: '5304040',
    name: 'Haumenibaki',
  },
  {
    id: '5304040010',
    districtId: '5304040',
    name: 'Mnelalete',
  },
  {
    id: '5304040013',
    districtId: '5304040',
    name: 'Tublopo/Meometan',
  },
  {
    id: '5304040014',
    districtId: '5304040',
    name: 'Nusa',
  },
  {
    id: '5304040015',
    districtId: '5304040',
    name: 'Nifukani',
  },
  {
    id: '5304041001',
    districtId: '5304041',
    name: 'Oebobo',
  },
  {
    id: '5304041002',
    districtId: '5304041',
    name: 'Tuppan',
  },
  {
    id: '5304041003',
    districtId: '5304041',
    name: 'Boentuka',
  },
  {
    id: '5304041004',
    districtId: '5304041',
    name: 'Oehala',
  },
  {
    id: '5304041005',
    districtId: '5304041',
    name: 'Tuakole',
  },
  {
    id: '5304041006',
    districtId: '5304041',
    name: 'Hane',
  },
  {
    id: '5304042001',
    districtId: '5304042',
    name: 'Lakat',
  },
  {
    id: '5304042003',
    districtId: '5304042',
    name: 'Tetaf',
  },
  {
    id: '5304042004',
    districtId: '5304042',
    name: 'Enoneontes',
  },
  {
    id: '5304042005',
    districtId: '5304042',
    name: 'Naukae',
  },
  {
    id: '5304042006',
    districtId: '5304042',
    name: 'Oof',
  },
  {
    id: '5304042007',
    districtId: '5304042',
    name: 'Tubmonas',
  },
  {
    id: '5304042008',
    districtId: '5304042',
    name: 'Oe Ue',
  },
  {
    id: '5304050001',
    districtId: '5304050',
    name: 'Pollo',
  },
  {
    id: '5304050002',
    districtId: '5304050',
    name: 'Bena',
  },
  {
    id: '5304050003',
    districtId: '5304050',
    name: 'Oebelo',
  },
  {
    id: '5304050008',
    districtId: '5304050',
    name: 'Noemuke',
  },
  {
    id: '5304050009',
    districtId: '5304050',
    name: 'Oekiu',
  },
  {
    id: '5304050010',
    districtId: '5304050',
    name: 'Batnun',
  },
  {
    id: '5304050011',
    districtId: '5304050',
    name: 'Kiubaat',
  },
  {
    id: '5304050012',
    districtId: '5304050',
    name: 'Linamnutu',
  },
  {
    id: '5304050013',
    districtId: '5304050',
    name: 'Mio',
  },
  {
    id: '5304050019',
    districtId: '5304050',
    name: 'Eno Netten',
  },
  {
    id: '5304051001',
    districtId: '5304051',
    name: 'Oe Ekam',
  },
  {
    id: '5304051002',
    districtId: '5304051',
    name: 'Teas',
  },
  {
    id: '5304051003',
    districtId: '5304051',
    name: 'Oepliki',
  },
  {
    id: '5304051004',
    districtId: '5304051',
    name: 'Naip',
  },
  {
    id: '5304051005',
    districtId: '5304051',
    name: 'Fatutnana',
  },
  {
    id: '5304051006',
    districtId: '5304051',
    name: 'Oebaki',
  },
  {
    id: '5304051007',
    districtId: '5304051',
    name: 'Eno Nabuasa',
  },
  {
    id: '5304060004',
    districtId: '5304060',
    name: 'Kusi',
  },
  {
    id: '5304060005',
    districtId: '5304060',
    name: 'Kuanfatu',
  },
  {
    id: '5304060007',
    districtId: '5304060',
    name: 'Basmuti',
  },
  {
    id: '5304060008',
    districtId: '5304060',
    name: 'Kakan',
  },
  {
    id: '5304060009',
    districtId: '5304060',
    name: 'Lasi',
  },
  {
    id: '5304060010',
    districtId: '5304060',
    name: 'Olais',
  },
  {
    id: '5304060011',
    districtId: '5304060',
    name: 'Kusi Utara',
  },
  {
    id: '5304060012',
    districtId: '5304060',
    name: 'Kelle Tunan',
  },
  {
    id: '5304060013',
    districtId: '5304060',
    name: 'Taupi',
  },
  {
    id: '5304060014',
    districtId: '5304060',
    name: 'Oebo',
  },
  {
    id: '5304060015',
    districtId: '5304060',
    name: 'Oehan',
  },
  {
    id: '5304060016',
    districtId: '5304060',
    name: 'Noebeba',
  },
  {
    id: '5304061001',
    districtId: '5304061',
    name: 'Toineke',
  },
  {
    id: '5304061002',
    districtId: '5304061',
    name: 'Tuafanu',
  },
  {
    id: '5304061003',
    districtId: '5304061',
    name: 'Kiufatu',
  },
  {
    id: '5304061004',
    districtId: '5304061',
    name: 'Kualin',
  },
  {
    id: '5304061005',
    districtId: '5304061',
    name: 'Oni',
  },
  {
    id: '5304061006',
    districtId: '5304061',
    name: 'Tuapakas',
  },
  {
    id: '5304061008',
    districtId: '5304061',
    name: 'Oemaman',
  },
  {
    id: '5304070011',
    districtId: '5304070',
    name: 'Maunum Niki Niki',
  },
  {
    id: '5304070012',
    districtId: '5304070',
    name: 'Taebesa',
  },
  {
    id: '5304070013',
    districtId: '5304070',
    name: 'Nakfunu',
  },
  {
    id: '5304070014',
    districtId: '5304070',
    name: 'Oeekam',
  },
  {
    id: '5304070015',
    districtId: '5304070',
    name: 'Baki',
  },
  {
    id: '5304070017',
    districtId: '5304070',
    name: 'Noebesa',
  },
  {
    id: '5304070018',
    districtId: '5304070',
    name: 'Nobi Nobi',
  },
  {
    id: '5304070019',
    districtId: '5304070',
    name: 'Niki Niki',
  },
  {
    id: '5304070020',
    districtId: '5304070',
    name: 'Bone',
  },
  {
    id: '5304070022',
    districtId: '5304070',
    name: 'Sopo',
  },
  {
    id: '5304071001',
    districtId: '5304071',
    name: 'Kolbano',
  },
  {
    id: '5304071002',
    districtId: '5304071',
    name: 'Noesiu',
  },
  {
    id: '5304071003',
    districtId: '5304071',
    name: 'Pene Selatan',
  },
  {
    id: '5304071004',
    districtId: '5304071',
    name: 'Oetuke',
  },
  {
    id: '5304071005',
    districtId: '5304071',
    name: 'Babuin',
  },
  {
    id: '5304071006',
    districtId: '5304071',
    name: 'Oeleu',
  },
  {
    id: '5304071007',
    districtId: '5304071',
    name: 'Sei',
  },
  {
    id: '5304071008',
    districtId: '5304071',
    name: 'Nununamat',
  },
  {
    id: '5304071009',
    districtId: '5304071',
    name: 'Pana',
  },
  {
    id: '5304071010',
    districtId: '5304071',
    name: 'Haunobenak',
  },
  {
    id: '5304071011',
    districtId: '5304071',
    name: 'Ofu',
  },
  {
    id: '5304071012',
    districtId: '5304071',
    name: 'Spaha',
  },
  {
    id: '5304072002',
    districtId: '5304072',
    name: 'Pene Utara',
  },
  {
    id: '5304072003',
    districtId: '5304072',
    name: 'Noe Noni',
  },
  {
    id: '5304072004',
    districtId: '5304072',
    name: 'Hoi',
  },
  {
    id: '5304072005',
    districtId: '5304072',
    name: 'Niki Niki Un',
  },
  {
    id: '5304072006',
    districtId: '5304072',
    name: 'Oenino',
  },
  {
    id: '5304072007',
    districtId: '5304072',
    name: 'Abi',
  },
  {
    id: '5304080004',
    districtId: '5304080',
    name: 'Mauleum',
  },
  {
    id: '5304080005',
    districtId: '5304080',
    name: 'Oelet',
  },
  {
    id: '5304080006',
    districtId: '5304080',
    name: 'Oe Ekam',
  },
  {
    id: '5304080007',
    districtId: '5304080',
    name: 'Pisan',
  },
  {
    id: '5304080008',
    districtId: '5304080',
    name: 'Mnelaanen',
  },
  {
    id: '5304080010',
    districtId: '5304080',
    name: 'Nifukiu',
  },
  {
    id: '5304080012',
    districtId: '5304080',
    name: 'Billa',
  },
  {
    id: '5304080016',
    districtId: '5304080',
    name: 'Sini',
  },
  {
    id: '5304080018',
    districtId: '5304080',
    name: 'Tliu',
  },
  {
    id: '5304081001',
    districtId: '5304081',
    name: 'Sillu',
  },
  {
    id: '5304081002',
    districtId: '5304081',
    name: 'Oeleon',
  },
  {
    id: '5304081003',
    districtId: '5304081',
    name: 'Kaeneno',
  },
  {
    id: '5304081004',
    districtId: '5304081',
    name: 'Nunuhakniti',
  },
  {
    id: '5304081006',
    districtId: '5304081',
    name: 'Bileon',
  },
  {
    id: '5304081007',
    districtId: '5304081',
    name: 'Tunis',
  },
  {
    id: '5304082001',
    districtId: '5304082',
    name: 'Fatukopa',
  },
  {
    id: '5304082002',
    districtId: '5304082',
    name: 'Besnam',
  },
  {
    id: '5304082003',
    districtId: '5304082',
    name: 'Taebone',
  },
  {
    id: '5304082005',
    districtId: '5304082',
    name: 'Nifulinah',
  },
  {
    id: '5304082006',
    districtId: '5304082',
    name: 'Elo',
  },
  {
    id: '5304082007',
    districtId: '5304082',
    name: 'Kiki',
  },
  {
    id: '5304090006',
    districtId: '5304090',
    name: 'Fatu Ulan',
  },
  {
    id: '5304090007',
    districtId: '5304090',
    name: 'Tesi Ayofanu',
  },
  {
    id: '5304090010',
    districtId: '5304090',
    name: 'Boti',
  },
  {
    id: '5304090011',
    districtId: '5304090',
    name: 'Oenai',
  },
  {
    id: '5304090012',
    districtId: '5304090',
    name: 'Oinlasi',
  },
  {
    id: '5304090013',
    districtId: '5304090',
    name: 'Napi',
  },
  {
    id: '5304090014',
    districtId: '5304090',
    name: 'Fallas',
  },
  {
    id: '5304090015',
    districtId: '5304090',
    name: 'Pili',
  },
  {
    id: '5304090016',
    districtId: '5304090',
    name: 'Enonapi',
  },
  {
    id: '5304090017',
    districtId: '5304090',
    name: 'Naileu',
  },
  {
    id: '5304090018',
    districtId: '5304090',
    name: 'Fatukusi',
  },
  {
    id: '5304091001',
    districtId: '5304091',
    name: "Kot'Olin",
  },
  {
    id: '5304091002',
    districtId: '5304091',
    name: 'Nunbena',
  },
  {
    id: '5304091003',
    districtId: '5304091',
    name: 'Fatuat',
  },
  {
    id: '5304091004',
    districtId: '5304091',
    name: 'Hoibeti',
  },
  {
    id: '5304091005',
    districtId: '5304091',
    name: 'Nualunat',
  },
  {
    id: '5304091006',
    districtId: '5304091',
    name: 'Panite',
  },
  {
    id: '5304091007',
    districtId: '5304091',
    name: "O'Obibi",
  },
  {
    id: '5304091008',
    districtId: '5304091',
    name: 'Binenok',
  },
  {
    id: '5304100001',
    districtId: '5304100',
    name: 'Oinlasi',
  },
  {
    id: '5304100002',
    districtId: '5304100',
    name: 'Kokoi',
  },
  {
    id: '5304100003',
    districtId: '5304100',
    name: 'Fatulunu',
  },
  {
    id: '5304100012',
    districtId: '5304100',
    name: 'Kualeu',
  },
  {
    id: '5304100014',
    districtId: '5304100',
    name: 'Anin',
  },
  {
    id: '5304100015',
    districtId: '5304100',
    name: 'Toi',
  },
  {
    id: '5304100017',
    districtId: '5304100',
    name: 'Lanu',
  },
  {
    id: '5304100025',
    districtId: '5304100',
    name: 'Nifuleo',
  },
  {
    id: '5304100032',
    districtId: '5304100',
    name: 'Fae',
  },
  {
    id: '5304100033',
    districtId: '5304100',
    name: 'Netutnana',
  },
  {
    id: '5304101003',
    districtId: '5304101',
    name: 'Sabun',
  },
  {
    id: '5304101004',
    districtId: '5304101',
    name: 'Nano',
  },
  {
    id: '5304101005',
    districtId: '5304101',
    name: 'Boking',
  },
  {
    id: '5304101006',
    districtId: '5304101',
    name: 'Leonmeni',
  },
  {
    id: '5304101012',
    districtId: '5304101',
    name: 'Meusin',
  },
  {
    id: '5304101013',
    districtId: '5304101',
    name: 'Baus',
  },
  {
    id: '5304101014',
    districtId: '5304101',
    name: 'Fatu Manufui',
  },
  {
    id: '5304102001',
    districtId: '5304102',
    name: 'Op',
  },
  {
    id: '5304102002',
    districtId: '5304102',
    name: 'Saenam',
  },
  {
    id: '5304102003',
    districtId: '5304102',
    name: 'Sahan',
  },
  {
    id: '5304102004',
    districtId: '5304102',
    name: 'Nenoat',
  },
  {
    id: '5304102005',
    districtId: '5304102',
    name: 'Nunkolo',
  },
  {
    id: '5304102006',
    districtId: '5304102',
    name: 'Hoineno',
  },
  {
    id: '5304102007',
    districtId: '5304102',
    name: 'Fat',
  },
  {
    id: '5304102009',
    districtId: '5304102',
    name: 'Haumeni',
  },
  {
    id: '5304103001',
    districtId: '5304103',
    name: 'Suni',
  },
  {
    id: '5304103002',
    districtId: '5304103',
    name: 'Noebana',
  },
  {
    id: '5304103003',
    districtId: '5304103',
    name: 'Fatumnasi',
  },
  {
    id: '5304103004',
    districtId: '5304103',
    name: 'Mella',
  },
  {
    id: '5304103005',
    districtId: '5304103',
    name: 'Mnela Petu',
  },
  {
    id: '5304104001',
    districtId: '5304104',
    name: 'Nenotes',
  },
  {
    id: '5304104002',
    districtId: '5304104',
    name: 'Santian',
  },
  {
    id: '5304104003',
    districtId: '5304104',
    name: 'Poli',
  },
  {
    id: '5304104004',
    districtId: '5304104',
    name: 'Manufui',
  },
  {
    id: '5304104005',
    districtId: '5304104',
    name: 'Naifatu',
  },
  {
    id: '5304110004',
    districtId: '5304110',
    name: 'Lilo',
  },
  {
    id: '5304110005',
    districtId: '5304110',
    name: 'Tauanas',
  },
  {
    id: '5304110006',
    districtId: '5304110',
    name: 'Fatilo',
  },
  {
    id: '5304110007',
    districtId: '5304110',
    name: 'Nasi',
  },
  {
    id: '5304110008',
    districtId: '5304110',
    name: 'Snok',
  },
  {
    id: '5304110010',
    districtId: '5304110',
    name: 'Fatuoni',
  },
  {
    id: '5304110011',
    districtId: '5304110',
    name: 'Sono',
  },
  {
    id: '5304110012',
    districtId: '5304110',
    name: 'Muna',
  },
  {
    id: '5304111001',
    districtId: '5304111',
    name: 'Oeleu',
  },
  {
    id: '5304111002',
    districtId: '5304111',
    name: 'Skinu',
  },
  {
    id: '5304111003',
    districtId: '5304111',
    name: 'Toianas',
  },
  {
    id: '5304111004',
    districtId: '5304111',
    name: 'Sambet',
  },
  {
    id: '5304111005',
    districtId: '5304111',
    name: 'Bokong',
  },
  {
    id: '5304111006',
    districtId: '5304111',
    name: 'Tuataum',
  },
  {
    id: '5304111007',
    districtId: '5304111',
    name: 'Lobus',
  },
  {
    id: '5304111008',
    districtId: '5304111',
    name: 'Mili',
  },
  {
    id: '5304111009',
    districtId: '5304111',
    name: 'Noeolin',
  },
  {
    id: '5304112001',
    districtId: '5304112',
    name: 'Lotas',
  },
  {
    id: '5304112002',
    districtId: '5304112',
    name: 'Sabnala',
  },
  {
    id: '5304112003',
    districtId: '5304112',
    name: 'Kol Oto',
  },
  {
    id: '5304112004',
    districtId: '5304112',
    name: 'Obaki',
  },
  {
    id: '5304112005',
    districtId: '5304112',
    name: 'Benahe',
  },
  {
    id: '5304112006',
    districtId: '5304112',
    name: 'Niti',
  },
  {
    id: '5305010001',
    districtId: '5305010',
    name: 'Noepesu',
  },
  {
    id: '5305010002',
    districtId: '5305010',
    name: 'Fatuneno',
  },
  {
    id: '5305010003',
    districtId: '5305010',
    name: 'Eban',
  },
  {
    id: '5305010004',
    districtId: '5305010',
    name: 'Sallu',
  },
  {
    id: '5305010005',
    districtId: '5305010',
    name: 'Suanae',
  },
  {
    id: '5305010006',
    districtId: '5305010',
    name: 'Lemon',
  },
  {
    id: '5305010007',
    districtId: '5305010',
    name: 'Fatunisuan',
  },
  {
    id: '5305010008',
    districtId: '5305010',
    name: 'Haulasi',
  },
  {
    id: '5305010020',
    districtId: '5305010',
    name: 'Noeltoko',
  },
  {
    id: '5305010021',
    districtId: '5305010',
    name: 'Fatutasu',
  },
  {
    id: '5305010022',
    districtId: '5305010',
    name: 'Manusasi',
  },
  {
    id: '5305010023',
    districtId: '5305010',
    name: 'Saenam',
  },
  {
    id: '5305010024',
    districtId: '5305010',
    name: 'Satab',
  },
  {
    id: '5305011001',
    districtId: '5305011',
    name: 'Tuabatan',
  },
  {
    id: '5305011002',
    districtId: '5305011',
    name: 'Akomi',
  },
  {
    id: '5305011003',
    districtId: '5305011',
    name: 'Bijaepasu',
  },
  {
    id: '5305011004',
    districtId: '5305011',
    name: 'Noenasi',
  },
  {
    id: '5305011005',
    districtId: '5305011',
    name: 'Nian',
  },
  {
    id: '5305011006',
    districtId: '5305011',
    name: 'Tuabatan Barat',
  },
  {
    id: '5305012001',
    districtId: '5305012',
    name: 'Oelneke',
  },
  {
    id: '5305012002',
    districtId: '5305012',
    name: 'Oetulu',
  },
  {
    id: '5305012003',
    districtId: '5305012',
    name: 'Ainan',
  },
  {
    id: '5305012004',
    districtId: '5305012',
    name: 'Oeolo',
  },
  {
    id: '5305012005',
    districtId: '5305012',
    name: 'Bisafe',
  },
  {
    id: '5305012006',
    districtId: '5305012',
    name: 'Batnes',
  },
  {
    id: '5305013001',
    districtId: '5305013',
    name: 'Tasinifu',
  },
  {
    id: '5305013002',
    districtId: '5305013',
    name: 'Naekake A',
  },
  {
    id: '5305013003',
    districtId: '5305013',
    name: 'Naekake B',
  },
  {
    id: '5305013004',
    districtId: '5305013',
    name: 'Noelelo',
  },
  {
    id: '5305020032',
    districtId: '5305020',
    name: 'Oesena',
  },
  {
    id: '5305020033',
    districtId: '5305020',
    name: 'Taekas',
  },
  {
    id: '5305020034',
    districtId: '5305020',
    name: 'Femnasi',
  },
  {
    id: '5305020035',
    districtId: '5305020',
    name: 'Jak',
  },
  {
    id: '5305020036',
    districtId: '5305020',
    name: 'Tunoe',
  },
  {
    id: '5305020038',
    districtId: '5305020',
    name: 'Bokon',
  },
  {
    id: '5305020039',
    districtId: '5305020',
    name: 'Kaenbaun',
  },
  {
    id: '5305020040',
    districtId: '5305020',
    name: 'Fatusene',
  },
  {
    id: '5305020041',
    districtId: '5305020',
    name: 'Amol',
  },
  {
    id: '5305020051',
    districtId: '5305020',
    name: 'Bitefa',
  },
  {
    id: '5305021001',
    districtId: '5305021',
    name: 'Kiuola',
  },
  {
    id: '5305021002',
    districtId: '5305021',
    name: 'S E O',
  },
  {
    id: '5305021003',
    districtId: '5305021',
    name: 'Noebaun',
  },
  {
    id: '5305021004',
    districtId: '5305021',
    name: 'Popnam',
  },
  {
    id: '5305021008',
    districtId: '5305021',
    name: 'Nibaaf',
  },
  {
    id: '5305021010',
    districtId: '5305021',
    name: 'Oenak',
  },
  {
    id: '5305021011',
    districtId: '5305021',
    name: 'Nifuboke',
  },
  {
    id: '5305021012',
    districtId: '5305021',
    name: 'Bijeli',
  },
  {
    id: '5305021013',
    districtId: '5305021',
    name: 'Noemuti',
  },
  {
    id: '5305021014',
    districtId: '5305021',
    name: 'Fatumuti',
  },
  {
    id: '5305021015',
    districtId: '5305021',
    name: 'Banfanu',
  },
  {
    id: '5305021016',
    districtId: '5305021',
    name: 'Oeperigi',
  },
  {
    id: '5305022001',
    districtId: '5305022',
    name: 'Maurisu',
  },
  {
    id: '5305022002',
    districtId: '5305022',
    name: 'Naiola',
  },
  {
    id: '5305022003',
    districtId: '5305022',
    name: 'Oetalus',
  },
  {
    id: '5305022004',
    districtId: '5305022',
    name: 'Oelami',
  },
  {
    id: '5305022005',
    districtId: '5305022',
    name: 'Kiusili',
  },
  {
    id: '5305022006',
    districtId: '5305022',
    name: 'Maurisu Utara',
  },
  {
    id: '5305022007',
    districtId: '5305022',
    name: 'Maurisu Selatan',
  },
  {
    id: '5305022008',
    districtId: '5305022',
    name: 'Tublopo',
  },
  {
    id: '5305022009',
    districtId: '5305022',
    name: 'Maurisu Tengah',
  },
  {
    id: '5305022010',
    districtId: '5305022',
    name: 'Naiola Timur',
  },
  {
    id: '5305023001',
    districtId: '5305023',
    name: 'Nimasi',
  },
  {
    id: '5305023002',
    districtId: '5305023',
    name: 'Kuanek',
  },
  {
    id: '5305023004',
    districtId: '5305023',
    name: 'Oelbonak',
  },
  {
    id: '5305023005',
    districtId: '5305023',
    name: 'Oenenu',
  },
  {
    id: '5305023006',
    districtId: '5305023',
    name: 'Oenino',
  },
  {
    id: '5305023007',
    districtId: '5305023',
    name: 'Oenenu Utara',
  },
  {
    id: '5305023008',
    districtId: '5305023',
    name: 'Oenenu Selatan',
  },
  {
    id: '5305023009',
    districtId: '5305023',
    name: 'Sono',
  },
  {
    id: '5305024001',
    districtId: '5305024',
    name: 'Nilulat',
  },
  {
    id: '5305024003',
    districtId: '5305024',
    name: "Haumeni 'Ana",
  },
  {
    id: '5305024004',
    districtId: '5305024',
    name: 'Sunkaen',
  },
  {
    id: '5305024005',
    districtId: '5305024',
    name: 'Nainaban',
  },
  {
    id: '5305024006',
    districtId: '5305024',
    name: 'Inbate',
  },
  {
    id: '5305025001',
    districtId: '5305025',
    name: 'Faennake',
  },
  {
    id: '5305025002',
    districtId: '5305025',
    name: 'Baas',
  },
  {
    id: '5305025003',
    districtId: '5305025',
    name: 'Haumeni',
  },
  {
    id: '5305025004',
    districtId: '5305025',
    name: 'Napan',
  },
  {
    id: '5305025006',
    districtId: '5305025',
    name: 'Sainoni',
  },
  {
    id: '5305025007',
    districtId: '5305025',
    name: 'Banain',
  },
  {
    id: '5305025008',
    districtId: '5305025',
    name: 'Banain B',
  },
  {
    id: '5305025009',
    districtId: '5305025',
    name: 'Banain C',
  },
  {
    id: '5305026001',
    districtId: '5305026',
    name: 'Sunsea',
  },
  {
    id: '5305026002',
    districtId: '5305026',
    name: 'Bakitolas',
  },
  {
    id: '5305026004',
    districtId: '5305026',
    name: 'Manamas',
  },
  {
    id: '5305027001',
    districtId: '5305027',
    name: 'Naob',
  },
  {
    id: '5305027002',
    districtId: '5305027',
    name: 'Haekto',
  },
  {
    id: '5305027003',
    districtId: '5305027',
    name: 'Manikin',
  },
  {
    id: '5305027004',
    districtId: '5305027',
    name: 'Kuaken',
  },
  {
    id: '5305030001',
    districtId: '5305030',
    name: 'Maubeli',
  },
  {
    id: '5305030002',
    districtId: '5305030',
    name: 'Sasi',
  },
  {
    id: '5305030005',
    districtId: '5305030',
    name: 'Kefamenanu Selatan',
  },
  {
    id: '5305030006',
    districtId: '5305030',
    name: 'Benpasi',
  },
  {
    id: '5305030007',
    districtId: '5305030',
    name: 'Bansone',
  },
  {
    id: '5305030008',
    districtId: '5305030',
    name: 'Kefamenanu Tengah',
  },
  {
    id: '5305030009',
    districtId: '5305030',
    name: 'Aplasi',
  },
  {
    id: '5305030010',
    districtId: '5305030',
    name: 'Kefamenanu Utara',
  },
  {
    id: '5305040006',
    districtId: '5305040',
    name: 'Nansean',
  },
  {
    id: '5305040007',
    districtId: '5305040',
    name: 'Susulaku',
  },
  {
    id: '5305040008',
    districtId: '5305040',
    name: 'Ainiut',
  },
  {
    id: '5305040009',
    districtId: '5305040',
    name: 'Loeram',
  },
  {
    id: '5305040010',
    districtId: '5305040',
    name: 'Oinbit',
  },
  {
    id: '5305040011',
    districtId: '5305040',
    name: 'Nunmafo',
  },
  {
    id: '5305040012',
    districtId: '5305040',
    name: 'Manunain  A',
  },
  {
    id: '5305040013',
    districtId: '5305040',
    name: 'Manunain  B',
  },
  {
    id: '5305040014',
    districtId: '5305040',
    name: 'Tapenpah',
  },
  {
    id: '5305040015',
    districtId: '5305040',
    name: 'Sekon',
  },
  {
    id: '5305040027',
    districtId: '5305040',
    name: 'Susulaku B',
  },
  {
    id: '5305040030',
    districtId: '5305040',
    name: 'Fatoin',
  },
  {
    id: '5305040031',
    districtId: '5305040',
    name: 'Nansean Timur',
  },
  {
    id: '5305040032',
    districtId: '5305040',
    name: 'Bitauni',
  },
  {
    id: '5305040033',
    districtId: '5305040',
    name: 'Fatuana',
  },
  {
    id: '5305040034',
    districtId: '5305040',
    name: 'Botof',
  },
  {
    id: '5305041006',
    districtId: '5305041',
    name: 'Humusu A',
  },
  {
    id: '5305041007',
    districtId: '5305041',
    name: 'Fatumtasa',
  },
  {
    id: '5305041009',
    districtId: '5305041',
    name: 'Oesoko',
  },
  {
    id: '5305042002',
    districtId: '5305042',
    name: 'Lapeom',
  },
  {
    id: '5305042003',
    districtId: '5305042',
    name: 'Usapinonot',
  },
  {
    id: '5305042004',
    districtId: '5305042',
    name: 'Atmen',
  },
  {
    id: '5305042005',
    districtId: '5305042',
    name: 'Letneo',
  },
  {
    id: '5305042006',
    districtId: '5305042',
    name: 'Banae',
  },
  {
    id: '5305042007',
    districtId: '5305042',
    name: 'Desa Admen',
  },
  {
    id: '5305042008',
    districtId: '5305042',
    name: 'Subun Bestobe',
  },
  {
    id: '5305042009',
    districtId: '5305042',
    name: 'Subun Tualele',
  },
  {
    id: '5305042010',
    districtId: '5305042',
    name: 'Nifunenas',
  },
  {
    id: '5305042011',
    districtId: '5305042',
    name: 'Oabikase',
  },
  {
    id: '5305042012',
    districtId: '5305042',
    name: 'Letneo Selatan',
  },
  {
    id: '5305043001',
    districtId: '5305043',
    name: 'Lanaus',
  },
  {
    id: '5305043002',
    districtId: '5305043',
    name: 'Letmafo',
  },
  {
    id: '5305043003',
    districtId: '5305043',
    name: 'Maubesi',
  },
  {
    id: '5305043004',
    districtId: '5305043',
    name: 'Tainsala',
  },
  {
    id: '5305043005',
    districtId: '5305043',
    name: 'Sone',
  },
  {
    id: '5305043006',
    districtId: '5305043',
    name: 'Oehalo',
  },
  {
    id: '5305043007',
    districtId: '5305043',
    name: 'Letmafo Timur',
  },
  {
    id: '5305044001',
    districtId: '5305044',
    name: 'Oenain',
  },
  {
    id: '5305044002',
    districtId: '5305044',
    name: 'Fafinesu B',
  },
  {
    id: '5305044003',
    districtId: '5305044',
    name: 'Fafinesu A',
  },
  {
    id: '5305044004',
    districtId: '5305044',
    name: 'Fafinesu C',
  },
  {
    id: '5305044005',
    districtId: '5305044',
    name: 'Banuan',
  },
  {
    id: '5305044006',
    districtId: '5305044',
    name: 'Fafinesu',
  },
  {
    id: '5305050001',
    districtId: '5305050',
    name: 'Pantae',
  },
  {
    id: '5305050002',
    districtId: '5305050',
    name: 'Oenaem',
  },
  {
    id: '5305050003',
    districtId: '5305050',
    name: 'Upfaon',
  },
  {
    id: '5305050007',
    districtId: '5305050',
    name: 'Tautpah',
  },
  {
    id: '5305050010',
    districtId: '5305050',
    name: 'Tokbesi',
  },
  {
    id: '5305050012',
    districtId: '5305050',
    name: 'Sainiup',
  },
  {
    id: '5305050013',
    districtId: '5305050',
    name: 'Tunbaen',
  },
  {
    id: '5305051001',
    districtId: '5305051',
    name: "T'Eba",
  },
  {
    id: '5305051002',
    districtId: '5305051',
    name: 'Oerinbesi',
  },
  {
    id: '5305051003',
    districtId: '5305051',
    name: 'Oekopa',
  },
  {
    id: '5305051004',
    districtId: '5305051',
    name: "T'Eba Timur",
  },
  {
    id: '5305052002',
    districtId: '5305052',
    name: 'Luniup',
  },
  {
    id: '5305052003',
    districtId: '5305052',
    name: 'Matabesi',
  },
  {
    id: '5305052004',
    districtId: '5305052',
    name: 'Kaubele',
  },
  {
    id: '5305052005',
    districtId: '5305052',
    name: 'Oepuah',
  },
  {
    id: '5305052006',
    districtId: '5305052',
    name: 'Oepuah Utara',
  },
  {
    id: '5305052007',
    districtId: '5305052',
    name: 'Oepuah Selatan',
  },
  {
    id: '5305060004',
    districtId: '5305060',
    name: 'Sapaen',
  },
  {
    id: '5305060005',
    districtId: '5305060',
    name: 'Taunbaen',
  },
  {
    id: '5305060006',
    districtId: '5305060',
    name: 'Tualene',
  },
  {
    id: '5305060007',
    districtId: '5305060',
    name: 'Biloe',
  },
  {
    id: '5305060008',
    districtId: '5305060',
    name: 'Hauteas',
  },
  {
    id: '5305060009',
    districtId: '5305060',
    name: 'Boronubaen',
  },
  {
    id: '5305060010',
    districtId: '5305060',
    name: 'Lokomea',
  },
  {
    id: '5305060011',
    districtId: '5305060',
    name: 'Taunbaen Timur',
  },
  {
    id: '5305060012',
    districtId: '5305060',
    name: 'Hauteas Barat',
  },
  {
    id: '5305060013',
    districtId: '5305060',
    name: 'Boronubaen Timur',
  },
  {
    id: '5305061001',
    districtId: '5305061',
    name: 'Sifaniha',
  },
  {
    id: '5305061002',
    districtId: '5305061',
    name: 'Motadik',
  },
  {
    id: '5305061003',
    districtId: '5305061',
    name: 'Nonatbatan',
  },
  {
    id: '5305061004',
    districtId: '5305061',
    name: 'Tuamese',
  },
  {
    id: '5305061005',
    districtId: '5305061',
    name: 'Maukabatan',
  },
  {
    id: '5305061006',
    districtId: '5305061',
    name: 'Kotafoun',
  },
  {
    id: '5305061007',
    districtId: '5305061',
    name: 'Ponu',
  },
  {
    id: '5305061008',
    districtId: '5305061',
    name: 'Oemanu',
  },
  {
    id: '5305061009',
    districtId: '5305061',
    name: 'Nifutasi',
  },
  {
    id: '5305062001',
    districtId: '5305062',
    name: 'Manumean',
  },
  {
    id: '5305062002',
    districtId: '5305062',
    name: 'Kuluan',
  },
  {
    id: '5305062003',
    districtId: '5305062',
    name: 'Naku',
  },
  {
    id: '5305062004',
    districtId: '5305062',
    name: 'Makun',
  },
  {
    id: '5305062005',
    districtId: '5305062',
    name: 'Birunatun',
  },
  {
    id: '5306032001',
    districtId: '5306032',
    name: 'Tasain',
  },
  {
    id: '5306032003',
    districtId: '5306032',
    name: 'Renrua',
  },
  {
    id: '5306032004',
    districtId: '5306032',
    name: 'Mandeu Raimanus',
  },
  {
    id: '5306032005',
    districtId: '5306032',
    name: 'Faturika',
  },
  {
    id: '5306032006',
    districtId: '5306032',
    name: 'Rafae',
  },
  {
    id: '5306032007',
    districtId: '5306032',
    name: 'Duakoran',
  },
  {
    id: '5306032008',
    districtId: '5306032',
    name: 'Mandeu',
  },
  {
    id: '5306032009',
    districtId: '5306032',
    name: 'Leuntolu',
  },
  {
    id: '5306050001',
    districtId: '5306050',
    name: 'Rinbesihat',
  },
  {
    id: '5306050002',
    districtId: '5306050',
    name: 'Naitimu',
  },
  {
    id: '5306050004',
    districtId: '5306050',
    name: 'Lawalutolus',
  },
  {
    id: '5306050008',
    districtId: '5306050',
    name: 'Lookeu',
  },
  {
    id: '5306050009',
    districtId: '5306050',
    name: 'Derok Faturene',
  },
  {
    id: '5306050010',
    districtId: '5306050',
    name: 'Bakustulama',
  },
  {
    id: '5306050011',
    districtId: '5306050',
    name: 'Naekasa',
  },
  {
    id: '5306050012',
    districtId: '5306050',
    name: 'Tukuneno',
  },
  {
    id: '5306051001',
    districtId: '5306051',
    name: 'Fatukety',
  },
  {
    id: '5306051002',
    districtId: '5306051',
    name: 'Kabuna',
  },
  {
    id: '5306051003',
    districtId: '5306051',
    name: 'Kenebibi',
  },
  {
    id: '5306051004',
    districtId: '5306051',
    name: 'Jenilu',
  },
  {
    id: '5306051005',
    districtId: '5306051',
    name: 'Leosama',
  },
  {
    id: '5306051006',
    districtId: '5306051',
    name: 'Dualaus',
  },
  {
    id: '5306052001',
    districtId: '5306052',
    name: 'Dubesi',
  },
  {
    id: '5306052002',
    districtId: '5306052',
    name: 'Nanaet',
  },
  {
    id: '5306052003',
    districtId: '5306052',
    name: 'Fohoeka',
  },
  {
    id: '5306052004',
    districtId: '5306052',
    name: 'Nanaenoe',
  },
  {
    id: '5306060005',
    districtId: '5306060',
    name: 'Fatubenao',
  },
  {
    id: '5306060006',
    districtId: '5306060',
    name: 'Atambua',
  },
  {
    id: '5306060011',
    districtId: '5306060',
    name: 'Manumutin',
  },
  {
    id: '5306060012',
    districtId: '5306060',
    name: 'Tenukiik',
  },
  {
    id: '5306061001',
    districtId: '5306061',
    name: 'Beirafu',
  },
  {
    id: '5306061002',
    districtId: '5306061',
    name: 'Berdao',
  },
  {
    id: '5306061003',
    districtId: '5306061',
    name: 'Tulamalae',
  },
  {
    id: '5306061004',
    districtId: '5306061',
    name: 'Umanen',
  },
  {
    id: '5306062001',
    districtId: '5306062',
    name: 'Fatukbot',
  },
  {
    id: '5306062002',
    districtId: '5306062',
    name: 'Lidak',
  },
  {
    id: '5306062003',
    districtId: '5306062',
    name: 'Manuaman',
  },
  {
    id: '5306062004',
    districtId: '5306062',
    name: 'Rinbesi',
  },
  {
    id: '5306070001',
    districtId: '5306070',
    name: "Fatuba'A",
  },
  {
    id: '5306070002',
    districtId: '5306070',
    name: 'Dafala',
  },
  {
    id: '5306070003',
    districtId: '5306070',
    name: 'Takirin',
  },
  {
    id: '5306070004',
    districtId: '5306070',
    name: 'Manleten',
  },
  {
    id: '5306070005',
    districtId: '5306070',
    name: 'Umaklaran',
  },
  {
    id: '5306070006',
    districtId: '5306070',
    name: 'Tulakadi',
  },
  {
    id: '5306070007',
    districtId: '5306070',
    name: 'Silawan',
  },
  {
    id: '5306070008',
    districtId: '5306070',
    name: 'S A D I',
  },
  {
    id: '5306070009',
    districtId: '5306070',
    name: 'Sarabau',
  },
  {
    id: '5306070010',
    districtId: '5306070',
    name: 'Bauho',
  },
  {
    id: '5306070017',
    districtId: '5306070',
    name: 'Halimodok',
  },
  {
    id: '5306070018',
    districtId: '5306070',
    name: 'Tialai',
  },
  {
    id: '5306071001',
    districtId: '5306071',
    name: 'Asumanu',
  },
  {
    id: '5306071002',
    districtId: '5306071',
    name: 'Tohe',
  },
  {
    id: '5306071003',
    districtId: '5306071',
    name: 'Raifatus',
  },
  {
    id: '5306071004',
    districtId: '5306071',
    name: 'Aitoun',
  },
  {
    id: '5306071005',
    districtId: '5306071',
    name: 'Maumutin',
  },
  {
    id: '5306071006',
    districtId: '5306071',
    name: 'Tohe Leten',
  },
  {
    id: '5306072001',
    districtId: '5306072',
    name: 'Lasiolat',
  },
  {
    id: '5306072002',
    districtId: '5306072',
    name: 'Maneikun',
  },
  {
    id: '5306072003',
    districtId: '5306072',
    name: 'Fatulotu',
  },
  {
    id: '5306072004',
    districtId: '5306072',
    name: 'Lakanmau',
  },
  {
    id: '5306072005',
    districtId: '5306072',
    name: 'Raiulun',
  },
  {
    id: '5306072006',
    districtId: '5306072',
    name: 'Dualasi',
  },
  {
    id: '5306072007',
    districtId: '5306072',
    name: 'Baudaok',
  },
  {
    id: '5306080007',
    districtId: '5306080',
    name: 'Maudemu',
  },
  {
    id: '5306080008',
    districtId: '5306080',
    name: 'Dirun',
  },
  {
    id: '5306080009',
    districtId: '5306080',
    name: 'Leowalu',
  },
  {
    id: '5306080010',
    districtId: '5306080',
    name: 'Duarato',
  },
  {
    id: '5306080012',
    districtId: '5306080',
    name: 'Kewar',
  },
  {
    id: '5306080013',
    districtId: '5306080',
    name: 'Mahuitas',
  },
  {
    id: '5306080014',
    districtId: '5306080',
    name: 'Makir',
  },
  {
    id: '5306080015',
    districtId: '5306080',
    name: 'Lamak Senulu',
  },
  {
    id: '5306081001',
    districtId: '5306081',
    name: 'Debululik',
  },
  {
    id: '5306081002',
    districtId: '5306081',
    name: 'Lutha Rato',
  },
  {
    id: '5306081004',
    districtId: '5306081',
    name: 'Lakmaras',
  },
  {
    id: '5306081005',
    districtId: '5306081',
    name: 'Nualain',
  },
  {
    id: '5306081006',
    districtId: '5306081',
    name: 'Ekin',
  },
  {
    id: '5306081007',
    districtId: '5306081',
    name: 'Loonuna',
  },
  {
    id: '5306081008',
    districtId: '5306081',
    name: 'Sisi Fatuberal',
  },
  {
    id: '5307010026',
    districtId: '5307010',
    name: 'Baolang',
  },
  {
    id: '5307010033',
    districtId: '5307010',
    name: 'Bandar',
  },
  {
    id: '5307010034',
    districtId: '5307010',
    name: 'Madar',
  },
  {
    id: '5307010035',
    districtId: '5307010',
    name: 'Bouweli',
  },
  {
    id: '5307010040',
    districtId: '5307010',
    name: 'Munaseli',
  },
  {
    id: '5307010041',
    districtId: '5307010',
    name: 'Helandohi',
  },
  {
    id: '5307010042',
    districtId: '5307010',
    name: 'B A N A',
  },
  {
    id: '5307010043',
    districtId: '5307010',
    name: 'Pandai',
  },
  {
    id: '5307010044',
    districtId: '5307010',
    name: 'Bukitmas',
  },
  {
    id: '5307010045',
    districtId: '5307010',
    name: 'Wailawar',
  },
  {
    id: '5307010046',
    districtId: '5307010',
    name: 'Kabir',
  },
  {
    id: '5307011008',
    districtId: '5307011',
    name: 'Kalondama',
  },
  {
    id: '5307011010',
    districtId: '5307011',
    name: 'Blang Merang',
  },
  {
    id: '5307011011',
    districtId: '5307011',
    name: 'Baraler',
  },
  {
    id: '5307011012',
    districtId: '5307011',
    name: 'Baranusa',
  },
  {
    id: '5307011013',
    districtId: '5307011',
    name: 'Piring Sina',
  },
  {
    id: '5307011014',
    districtId: '5307011',
    name: 'Illu',
  },
  {
    id: '5307012002',
    districtId: '5307012',
    name: 'Lalafang',
  },
  {
    id: '5307012004',
    districtId: '5307012',
    name: 'Kaleb',
  },
  {
    id: '5307012005',
    districtId: '5307012',
    name: 'Bunga Bali',
  },
  {
    id: '5307012006',
    districtId: '5307012',
    name: 'Kaera',
  },
  {
    id: '5307012007',
    districtId: '5307012',
    name: 'Lekom',
  },
  {
    id: '5307012008',
    districtId: '5307012',
    name: 'Mawar',
  },
  {
    id: '5307012009',
    districtId: '5307012',
    name: 'Ombay',
  },
  {
    id: '5307012010',
    districtId: '5307012',
    name: 'Merdeka',
  },
  {
    id: '5307012011',
    districtId: '5307012',
    name: 'Batu',
  },
  {
    id: '5307013001',
    districtId: '5307013',
    name: 'Marisa',
  },
  {
    id: '5307013002',
    districtId: '5307013',
    name: 'Allumang',
  },
  {
    id: '5307013003',
    districtId: '5307013',
    name: 'Kayang',
  },
  {
    id: '5307013004',
    districtId: '5307013',
    name: 'Lamma',
  },
  {
    id: '5307013005',
    districtId: '5307013',
    name: 'Beang Onong',
  },
  {
    id: '5307013006',
    districtId: '5307013',
    name: 'Kalondama Barat',
  },
  {
    id: '5307013007',
    districtId: '5307013',
    name: 'Kalondama Tengah',
  },
  {
    id: '5307014003',
    districtId: '5307014',
    name: 'Delaki',
  },
  {
    id: '5307014004',
    districtId: '5307014',
    name: 'Mauta',
  },
  {
    id: '5307014005',
    districtId: '5307014',
    name: 'Eka Jaya',
  },
  {
    id: '5307014006',
    districtId: '5307014',
    name: 'Aramaba',
  },
  {
    id: '5307014007',
    districtId: '5307014',
    name: 'Toang',
  },
  {
    id: '5307014008',
    districtId: '5307014',
    name: 'Tamakh',
  },
  {
    id: '5307014009',
    districtId: '5307014',
    name: 'Muriabang',
  },
  {
    id: '5307014010',
    districtId: '5307014',
    name: 'Bagang',
  },
  {
    id: '5307020001',
    districtId: '5307020',
    name: 'Halerman',
  },
  {
    id: '5307020002',
    districtId: '5307020',
    name: 'Margeta',
  },
  {
    id: '5307020003',
    districtId: '5307020',
    name: 'Manatang',
  },
  {
    id: '5307020004',
    districtId: '5307020',
    name: 'Tribur',
  },
  {
    id: '5307020005',
    districtId: '5307020',
    name: 'Kuifana',
  },
  {
    id: '5307020006',
    districtId: '5307020',
    name: 'Wakapsir',
  },
  {
    id: '5307020007',
    districtId: '5307020',
    name: 'Wakapsir Timur',
  },
  {
    id: '5307020015',
    districtId: '5307020',
    name: 'Kafelulang',
  },
  {
    id: '5307020016',
    districtId: '5307020',
    name: 'Pintu Mas',
  },
  {
    id: '5307020017',
    districtId: '5307020',
    name: 'Orgen',
  },
  {
    id: '5307020018',
    districtId: '5307020',
    name: 'Probur',
  },
  {
    id: '5307020019',
    districtId: '5307020',
    name: 'Probur Utara',
  },
  {
    id: '5307020020',
    districtId: '5307020',
    name: 'Wolwal Barat',
  },
  {
    id: '5307020021',
    districtId: '5307020',
    name: 'Wolwal Selatan',
  },
  {
    id: '5307020022',
    districtId: '5307020',
    name: 'Wolwal Tengah',
  },
  {
    id: '5307020023',
    districtId: '5307020',
    name: 'Wolwal',
  },
  {
    id: '5307020024',
    districtId: '5307020',
    name: 'Moru',
  },
  {
    id: '5307020025',
    districtId: '5307020',
    name: 'Moramam',
  },
  {
    id: '5307020026',
    districtId: '5307020',
    name: 'Morba',
  },
  {
    id: '5307020027',
    districtId: '5307020',
    name: 'Pailelang',
  },
  {
    id: '5307021001',
    districtId: '5307021',
    name: 'Lakatuli',
  },
  {
    id: '5307021002',
    districtId: '5307021',
    name: 'Mataru Selatan',
  },
  {
    id: '5307021003',
    districtId: '5307021',
    name: 'Kamaifui',
  },
  {
    id: '5307021004',
    districtId: '5307021',
    name: 'Taman Mataru',
  },
  {
    id: '5307021005',
    districtId: '5307021',
    name: 'Mataru Timur',
  },
  {
    id: '5307021006',
    districtId: '5307021',
    name: 'Mataru Utara',
  },
  {
    id: '5307021007',
    districtId: '5307021',
    name: 'Mataru Barat',
  },
  {
    id: '5307030001',
    districtId: '5307030',
    name: 'Padang Alang',
  },
  {
    id: '5307030002',
    districtId: '5307030',
    name: 'Maikang',
  },
  {
    id: '5307030003',
    districtId: '5307030',
    name: 'Sidabui',
  },
  {
    id: '5307030004',
    districtId: '5307030',
    name: 'Kiraman',
  },
  {
    id: '5307030005',
    districtId: '5307030',
    name: 'Kuneman',
  },
  {
    id: '5307030006',
    districtId: '5307030',
    name: 'Lella',
  },
  {
    id: '5307030007',
    districtId: '5307030',
    name: 'Manmas',
  },
  {
    id: '5307030008',
    districtId: '5307030',
    name: 'Silaipui',
  },
  {
    id: '5307030009',
    districtId: '5307030',
    name: 'Tamanapui',
  },
  {
    id: '5307030010',
    districtId: '5307030',
    name: 'Kelaisi Timur',
  },
  {
    id: '5307030011',
    districtId: '5307030',
    name: 'S U B O',
  },
  {
    id: '5307030012',
    districtId: '5307030',
    name: 'Kelaisi Tengah',
  },
  {
    id: '5307030013',
    districtId: '5307030',
    name: 'Kelaisi Barat',
  },
  {
    id: '5307030014',
    districtId: '5307030',
    name: 'Malaipea',
  },
  {
    id: '5307040004',
    districtId: '5307040',
    name: 'Elok',
  },
  {
    id: '5307040005',
    districtId: '5307040',
    name: 'Maritaing',
  },
  {
    id: '5307040006',
    districtId: '5307040',
    name: 'Kolana Selatan',
  },
  {
    id: '5307040007',
    districtId: '5307040',
    name: 'Kolana Utara',
  },
  {
    id: '5307040008',
    districtId: '5307040',
    name: 'Mausamang',
  },
  {
    id: '5307040009',
    districtId: '5307040',
    name: 'Tanglapui Timur',
  },
  {
    id: '5307040010',
    districtId: '5307040',
    name: 'Tanglapui',
  },
  {
    id: '5307040011',
    districtId: '5307040',
    name: 'Belemana',
  },
  {
    id: '5307040012',
    districtId: '5307040',
    name: 'Padang Panjang',
  },
  {
    id: '5307040022',
    districtId: '5307040',
    name: 'Maukuru',
  },
  {
    id: '5307041001',
    districtId: '5307041',
    name: 'Pido',
  },
  {
    id: '5307041002',
    districtId: '5307041',
    name: 'Lippang',
  },
  {
    id: '5307041003',
    districtId: '5307041',
    name: 'Kenarimbala',
  },
  {
    id: '5307041004',
    districtId: '5307041',
    name: 'Nailang',
  },
  {
    id: '5307041005',
    districtId: '5307041',
    name: 'Waisika',
  },
  {
    id: '5307041006',
    districtId: '5307041',
    name: 'Kamot',
  },
  {
    id: '5307041007',
    districtId: '5307041',
    name: 'Air Mancur',
  },
  {
    id: '5307041008',
    districtId: '5307041',
    name: 'Taramana',
  },
  {
    id: '5307042001',
    districtId: '5307042',
    name: 'Langkuru',
  },
  {
    id: '5307042002',
    districtId: '5307042',
    name: 'Kailesa',
  },
  {
    id: '5307042003',
    districtId: '5307042',
    name: 'Purnama',
  },
  {
    id: '5307042004',
    districtId: '5307042',
    name: 'Langkuru Utara',
  },
  {
    id: '5307050001',
    districtId: '5307050',
    name: 'Teluk Kenari',
  },
  {
    id: '5307050002',
    districtId: '5307050',
    name: 'Kalabahi Barat',
  },
  {
    id: '5307050003',
    districtId: '5307050',
    name: 'Adang Buom',
  },
  {
    id: '5307050004',
    districtId: '5307050',
    name: 'Binongko',
  },
  {
    id: '5307050005',
    districtId: '5307050',
    name: 'Motongbang',
  },
  {
    id: '5307050006',
    districtId: '5307050',
    name: 'Kalabahi Kota',
  },
  {
    id: '5307050007',
    districtId: '5307050',
    name: 'Wetabua',
  },
  {
    id: '5307050008',
    districtId: '5307050',
    name: 'Nusa Kenari',
  },
  {
    id: '5307050009',
    districtId: '5307050',
    name: 'Lendola',
  },
  {
    id: '5307050010',
    districtId: '5307050',
    name: 'Air Kenari',
  },
  {
    id: '5307050011',
    districtId: '5307050',
    name: 'Kalabahi Tengah',
  },
  {
    id: '5307050012',
    districtId: '5307050',
    name: 'Kalabahi Timur',
  },
  {
    id: '5307050013',
    districtId: '5307050',
    name: 'Mutiara',
  },
  {
    id: '5307050017',
    districtId: '5307050',
    name: 'Welai Timur',
  },
  {
    id: '5307050020',
    districtId: '5307050',
    name: 'Welai Barat',
  },
  {
    id: '5307050021',
    districtId: '5307050',
    name: 'Fanating',
  },
  {
    id: '5307051001',
    districtId: '5307051',
    name: 'Lawahing',
  },
  {
    id: '5307051002',
    districtId: '5307051',
    name: 'Kopidil',
  },
  {
    id: '5307051003',
    districtId: '5307051',
    name: 'Kabola',
  },
  {
    id: '5307051004',
    districtId: '5307051',
    name: 'Pante Deera',
  },
  {
    id: '5307051005',
    districtId: '5307051',
    name: 'Alila Timur',
  },
  {
    id: '5307060007',
    districtId: '5307060',
    name: 'Alor Kecil',
  },
  {
    id: '5307060008',
    districtId: '5307060',
    name: 'Lefokisu',
  },
  {
    id: '5307060009',
    districtId: '5307060',
    name: 'Ampera',
  },
  {
    id: '5307060010',
    districtId: '5307060',
    name: 'Lewalu',
  },
  {
    id: '5307060011',
    districtId: '5307060',
    name: 'Bampalola',
  },
  {
    id: '5307060012',
    districtId: '5307060',
    name: 'Dulolong Barat',
  },
  {
    id: '5307060013',
    districtId: '5307060',
    name: 'Dulolong',
  },
  {
    id: '5307060014',
    districtId: '5307060',
    name: 'Hulnani',
  },
  {
    id: '5307060015',
    districtId: '5307060',
    name: 'Alor Besar',
  },
  {
    id: '5307060016',
    districtId: '5307060',
    name: 'Ternate Selatan',
  },
  {
    id: '5307060017',
    districtId: '5307060',
    name: 'Ternate',
  },
  {
    id: '5307060018',
    districtId: '5307060',
    name: 'Pulau Buaya',
  },
  {
    id: '5307060019',
    districtId: '5307060',
    name: "O'Amate",
  },
  {
    id: '5307060020',
    districtId: '5307060',
    name: 'Aimoli',
  },
  {
    id: '5307060021',
    districtId: '5307060',
    name: 'Alaang',
  },
  {
    id: '5307060022',
    districtId: '5307060',
    name: 'Adang',
  },
  {
    id: '5307060023',
    districtId: '5307060',
    name: 'Alila',
  },
  {
    id: '5307060024',
    districtId: '5307060',
    name: 'Otvai',
  },
  {
    id: '5307060025',
    districtId: '5307060',
    name: 'Alila Selatan',
  },
  {
    id: '5307061001',
    districtId: '5307061',
    name: 'Alim Mebung',
  },
  {
    id: '5307061003',
    districtId: '5307061',
    name: 'Manetwati',
  },
  {
    id: '5307061010',
    districtId: '5307061',
    name: 'Lembur Tengah',
  },
  {
    id: '5307061011',
    districtId: '5307061',
    name: 'Lakwati',
  },
  {
    id: '5307061012',
    districtId: '5307061',
    name: 'Fuisama',
  },
  {
    id: '5307061013',
    districtId: '5307061',
    name: 'Nurbenlelang',
  },
  {
    id: '5307061014',
    districtId: '5307061',
    name: 'Lembur Barat',
  },
  {
    id: '5307061015',
    districtId: '5307061',
    name: 'Fungafeng',
  },
  {
    id: '5307061016',
    districtId: '5307061',
    name: 'Likuwatang',
  },
  {
    id: '5307061017',
    districtId: '5307061',
    name: 'Kafakbeka',
  },
  {
    id: '5307061018',
    districtId: '5307061',
    name: 'Dapitau',
  },
  {
    id: '5307061019',
    districtId: '5307061',
    name: 'Welai Selatan',
  },
  {
    id: '5307061020',
    districtId: '5307061',
    name: 'Tominuku',
  },
  {
    id: '5307062001',
    districtId: '5307062',
    name: 'Pura Barat',
  },
  {
    id: '5307062002',
    districtId: '5307062',
    name: 'Pura Selatan',
  },
  {
    id: '5307062003',
    districtId: '5307062',
    name: 'Maru',
  },
  {
    id: '5307062004',
    districtId: '5307062',
    name: 'Pura Timur',
  },
  {
    id: '5307062005',
    districtId: '5307062',
    name: 'Pura',
  },
  {
    id: '5307062006',
    districtId: '5307062',
    name: 'Pura Utara',
  },
  {
    id: '5307063001',
    districtId: '5307063',
    name: 'Talwai',
  },
  {
    id: '5307063002',
    districtId: '5307063',
    name: 'Waimi',
  },
  {
    id: '5307063003',
    districtId: '5307063',
    name: 'T A S I',
  },
  {
    id: '5307063005',
    districtId: '5307063',
    name: 'Lembur Timur',
  },
  {
    id: '5307063006',
    districtId: '5307063',
    name: 'Luba',
  },
  {
    id: '5308010001',
    districtId: '5308010',
    name: 'Pasir Putih',
  },
  {
    id: '5308010002',
    districtId: '5308010',
    name: 'Lolong',
  },
  {
    id: '5308010003',
    districtId: '5308010',
    name: 'Babokerong',
  },
  {
    id: '5308010004',
    districtId: '5308010',
    name: 'Duawutun',
  },
  {
    id: '5308010005',
    districtId: '5308010',
    name: 'Wuakerong',
  },
  {
    id: '5308010006',
    districtId: '5308010',
    name: 'Penikene',
  },
  {
    id: '5308010007',
    districtId: '5308010',
    name: 'Atawai',
  },
  {
    id: '5308010008',
    districtId: '5308010',
    name: 'Lusiduawutun',
  },
  {
    id: '5308010016',
    districtId: '5308010',
    name: 'Belabaja',
  },
  {
    id: '5308010017',
    districtId: '5308010',
    name: 'Labalimut',
  },
  {
    id: '5308010018',
    districtId: '5308010',
    name: 'Ile Boli',
  },
  {
    id: '5308010019',
    districtId: '5308010',
    name: 'Baobolak',
  },
  {
    id: '5308010020',
    districtId: '5308010',
    name: 'Tewaowutung',
  },
  {
    id: '5308010021',
    districtId: '5308010',
    name: 'Bolibean',
  },
  {
    id: '5308010022',
    districtId: '5308010',
    name: 'Ria Bao',
  },
  {
    id: '5308010023',
    districtId: '5308010',
    name: 'Idalolong',
  },
  {
    id: '5308010024',
    districtId: '5308010',
    name: 'Warawatung',
  },
  {
    id: '5308010025',
    districtId: '5308010',
    name: 'Liwulagang',
  },
  {
    id: '5308011001',
    districtId: '5308011',
    name: 'Lelata',
  },
  {
    id: '5308011002',
    districtId: '5308011',
    name: 'Lamalera A',
  },
  {
    id: '5308011003',
    districtId: '5308011',
    name: 'Lamalera B',
  },
  {
    id: '5308011004',
    districtId: '5308011',
    name: 'Imulolong',
  },
  {
    id: '5308011005',
    districtId: '5308011',
    name: 'Puor',
  },
  {
    id: '5308011006',
    districtId: '5308011',
    name: 'Belobao',
  },
  {
    id: '5308011007',
    districtId: '5308011',
    name: 'Wulandoni',
  },
  {
    id: '5308011008',
    districtId: '5308011',
    name: 'Pantai Harapan',
  },
  {
    id: '5308011009',
    districtId: '5308011',
    name: 'Atakera',
  },
  {
    id: '5308011010',
    districtId: '5308011',
    name: 'Leworaja',
  },
  {
    id: '5308011011',
    districtId: '5308011',
    name: 'Alap Atadei',
  },
  {
    id: '5308011012',
    districtId: '5308011',
    name: 'Posiwatu',
  },
  {
    id: '5308011013',
    districtId: '5308011',
    name: 'Tapobali',
  },
  {
    id: '5308011014',
    districtId: '5308011',
    name: 'Puor B',
  },
  {
    id: '5308011015',
    districtId: '5308011',
    name: 'Ataili',
  },
  {
    id: '5308020004',
    districtId: '5308020',
    name: 'Lusilame',
  },
  {
    id: '5308020007',
    districtId: '5308020',
    name: 'Dulir',
  },
  {
    id: '5308020009',
    districtId: '5308020',
    name: 'Atakore',
  },
  {
    id: '5308020010',
    districtId: '5308020',
    name: 'Nubahaeraka',
  },
  {
    id: '5308020011',
    districtId: '5308020',
    name: 'Lebaata',
  },
  {
    id: '5308020012',
    districtId: '5308020',
    name: 'Ile Kerbau',
  },
  {
    id: '5308020013',
    districtId: '5308020',
    name: 'Dori Pewut',
  },
  {
    id: '5308020014',
    districtId: '5308020',
    name: 'Ile Kimok',
  },
  {
    id: '5308020015',
    districtId: '5308020',
    name: 'Tubuk Rajan',
  },
  {
    id: '5308020016',
    districtId: '5308020',
    name: 'Katakeja',
  },
  {
    id: '5308020017',
    districtId: '5308020',
    name: 'Nuba Atalojo',
  },
  {
    id: '5308020018',
    districtId: '5308020',
    name: 'Nogo Doni',
  },
  {
    id: '5308020021',
    districtId: '5308020',
    name: 'Lewogroma',
  },
  {
    id: '5308020022',
    districtId: '5308020',
    name: 'Nubaboli',
  },
  {
    id: '5308030001',
    districtId: '5308030',
    name: 'Kolontobo',
  },
  {
    id: '5308030002',
    districtId: '5308030',
    name: 'Laranwuntun',
  },
  {
    id: '5308030003',
    districtId: '5308030',
    name: 'Muruona',
  },
  {
    id: '5308030004',
    districtId: '5308030',
    name: 'Watodiri',
  },
  {
    id: '5308030013',
    districtId: '5308030',
    name: 'Napasabok',
  },
  {
    id: '5308030014',
    districtId: '5308030',
    name: 'Bungamuda',
  },
  {
    id: '5308030015',
    districtId: '5308030',
    name: 'Amakaka',
  },
  {
    id: '5308030016',
    districtId: '5308030',
    name: 'Tanjung Batu',
  },
  {
    id: '5308030017',
    districtId: '5308030',
    name: 'Petuntawa',
  },
  {
    id: '5308030018',
    districtId: '5308030',
    name: 'Waowala',
  },
  {
    id: '5308030019',
    districtId: '5308030',
    name: 'Tagawiti',
  },
  {
    id: '5308030020',
    districtId: '5308030',
    name: 'Dulitukan',
  },
  {
    id: '5308030021',
    districtId: '5308030',
    name: 'Kolipadan',
  },
  {
    id: '5308030022',
    districtId: '5308030',
    name: 'Palilolon',
  },
  {
    id: '5308030023',
    districtId: '5308030',
    name: 'Lamawara',
  },
  {
    id: '5308030024',
    districtId: '5308030',
    name: 'Beutaran',
  },
  {
    id: '5308030025',
    districtId: '5308030',
    name: 'Riangbao',
  },
  {
    id: '5308031001',
    districtId: '5308031',
    name: 'Todanara',
  },
  {
    id: '5308031002',
    districtId: '5308031',
    name: 'Jontona',
  },
  {
    id: '5308031003',
    districtId: '5308031',
    name: 'Lamawolo',
  },
  {
    id: '5308031004',
    districtId: '5308031',
    name: 'Lamatokan',
  },
  {
    id: '5308031005',
    districtId: '5308031',
    name: 'Lamaau',
  },
  {
    id: '5308031006',
    districtId: '5308031',
    name: 'Aulesa',
  },
  {
    id: '5308031007',
    districtId: '5308031',
    name: 'Waimatan',
  },
  {
    id: '5308031008',
    districtId: '5308031',
    name: 'Lamagute',
  },
  {
    id: '5308031009',
    districtId: '5308031',
    name: 'Bao Lali Duli',
  },
  {
    id: '5308040001',
    districtId: '5308040',
    name: 'Lamatuka',
  },
  {
    id: '5308040002',
    districtId: '5308040',
    name: 'Baopana',
  },
  {
    id: '5308040003',
    districtId: '5308040',
    name: 'Merdeka',
  },
  {
    id: '5308040004',
    districtId: '5308040',
    name: 'Hadakewa',
  },
  {
    id: '5308040005',
    districtId: '5308040',
    name: 'Lerahinga',
  },
  {
    id: '5308040006',
    districtId: '5308040',
    name: 'Waienga',
  },
  {
    id: '5308040007',
    districtId: '5308040',
    name: 'Tapobaran',
  },
  {
    id: '5308040008',
    districtId: '5308040',
    name: 'Dikesare',
  },
  {
    id: '5308040009',
    districtId: '5308040',
    name: 'Lamadale',
  },
  {
    id: '5308040010',
    districtId: '5308040',
    name: 'Lewoeleng',
  },
  {
    id: '5308040011',
    districtId: '5308040',
    name: 'Lodotodokowa',
  },
  {
    id: '5308040012',
    districtId: '5308040',
    name: 'Seranggorang',
  },
  {
    id: '5308040013',
    districtId: '5308040',
    name: 'Balurebong',
  },
  {
    id: '5308040014',
    districtId: '5308040',
    name: 'Lamalela',
  },
  {
    id: '5308040015',
    districtId: '5308040',
    name: 'Tapolangu',
  },
  {
    id: '5308040016',
    districtId: '5308040',
    name: 'Banitobo',
  },
  {
    id: '5308040017',
    districtId: '5308040',
    name: 'Atakowa',
  },
  {
    id: '5308050001',
    districtId: '5308050',
    name: 'Belobatang',
  },
  {
    id: '5308050002',
    districtId: '5308050',
    name: 'Udak Melomata',
  },
  {
    id: '5308050003',
    districtId: '5308050',
    name: 'Baolangu',
  },
  {
    id: '5308050004',
    districtId: '5308050',
    name: 'Nuba Mado',
  },
  {
    id: '5308050005',
    districtId: '5308050',
    name: 'Paobokol',
  },
  {
    id: '5308050006',
    districtId: '5308050',
    name: 'Watokobu',
  },
  {
    id: '5308050007',
    districtId: '5308050',
    name: 'Waijarang',
  },
  {
    id: '5308050008',
    districtId: '5308050',
    name: 'Lewoleba Barat',
  },
  {
    id: '5308050009',
    districtId: '5308050',
    name: 'Lewoleba Utara',
  },
  {
    id: '5308050010',
    districtId: '5308050',
    name: 'Lewoleba',
  },
  {
    id: '5308050011',
    districtId: '5308050',
    name: 'Lewoleba Tengah',
  },
  {
    id: '5308050012',
    districtId: '5308050',
    name: 'Lewoleba Timur',
  },
  {
    id: '5308050013',
    districtId: '5308050',
    name: 'Liteulumado',
  },
  {
    id: '5308050014',
    districtId: '5308050',
    name: 'Pada',
  },
  {
    id: '5308050015',
    districtId: '5308050',
    name: 'Bakalerek',
  },
  {
    id: '5308050016',
    districtId: '5308050',
    name: 'Lewoleba Selatan',
  },
  {
    id: '5308050017',
    districtId: '5308050',
    name: 'Selandoro',
  },
  {
    id: '5308050018',
    districtId: '5308050',
    name: 'Bour',
  },
  {
    id: '5308060001',
    districtId: '5308060',
    name: 'Nilanapo',
  },
  {
    id: '5308060002',
    districtId: '5308060',
    name: 'Leubatang',
  },
  {
    id: '5308060003',
    districtId: '5308060',
    name: 'Walangsawah',
  },
  {
    id: '5308060004',
    districtId: '5308060',
    name: 'Peusawah',
  },
  {
    id: '5308060005',
    districtId: '5308060',
    name: 'Mahal',
  },
  {
    id: '5308060006',
    districtId: '5308060',
    name: 'Mahal II',
  },
  {
    id: '5308060007',
    districtId: '5308060',
    name: 'Normal',
  },
  {
    id: '5308060008',
    districtId: '5308060',
    name: 'Leudanung',
  },
  {
    id: '5308060009',
    districtId: '5308060',
    name: 'Leuwayang',
  },
  {
    id: '5308060010',
    districtId: '5308060',
    name: 'Roma',
  },
  {
    id: '5308060011',
    districtId: '5308060',
    name: 'Hoelea II',
  },
  {
    id: '5308060012',
    districtId: '5308060',
    name: 'Hoelea',
  },
  {
    id: '5308060013',
    districtId: '5308060',
    name: 'Dolulolong',
  },
  {
    id: '5308060014',
    districtId: '5308060',
    name: 'Hingalamamengi',
  },
  {
    id: '5308060015',
    districtId: '5308060',
    name: 'Meluwiting',
  },
  {
    id: '5308060016',
    districtId: '5308060',
    name: 'Aramengi',
  },
  {
    id: '5308060017',
    districtId: '5308060',
    name: 'Balauring',
  },
  {
    id: '5308060018',
    districtId: '5308060',
    name: 'Lebewala',
  },
  {
    id: '5308060019',
    districtId: '5308060',
    name: 'Wailolong',
  },
  {
    id: '5308060020',
    districtId: '5308060',
    name: 'Wowong',
  },
  {
    id: '5308060021',
    districtId: '5308060',
    name: 'Normal I',
  },
  {
    id: '5308060022',
    districtId: '5308060',
    name: 'Meluwiting I',
  },
  {
    id: '5308070001',
    districtId: '5308070',
    name: 'Panama',
  },
  {
    id: '5308070002',
    districtId: '5308070',
    name: 'Bean',
  },
  {
    id: '5308070003',
    districtId: '5308070',
    name: 'Benihading',
  },
  {
    id: '5308070004',
    districtId: '5308070',
    name: 'Benihading II',
  },
  {
    id: '5308070005',
    districtId: '5308070',
    name: 'Atulaleng',
  },
  {
    id: '5308070006',
    districtId: '5308070',
    name: 'Tubung Walang',
  },
  {
    id: '5308070007',
    districtId: '5308070',
    name: 'Roho',
  },
  {
    id: '5308070008',
    districtId: '5308070',
    name: 'Loyobohor',
  },
  {
    id: '5308070009',
    districtId: '5308070',
    name: 'Leuburi',
  },
  {
    id: '5308070010',
    districtId: '5308070',
    name: 'Tobotani',
  },
  {
    id: '5308070011',
    districtId: '5308070',
    name: 'Kalikur Wl',
  },
  {
    id: '5308070012',
    districtId: '5308070',
    name: 'Kaohua',
  },
  {
    id: '5308070013',
    districtId: '5308070',
    name: 'Umaleu',
  },
  {
    id: '5308070014',
    districtId: '5308070',
    name: 'Buriwutung',
  },
  {
    id: '5308070015',
    districtId: '5308070',
    name: 'Mampir',
  },
  {
    id: '5308070016',
    districtId: '5308070',
    name: 'Leuwohung',
  },
  {
    id: '5308070017',
    districtId: '5308070',
    name: 'Bareng',
  },
  {
    id: '5308070018',
    districtId: '5308070',
    name: 'Kalikur',
  },
  {
    id: '5308070019',
    districtId: '5308070',
    name: 'Rumang',
  },
  {
    id: '5308070020',
    districtId: '5308070',
    name: 'Atu Walupang',
  },
  {
    id: '5309010001',
    districtId: '5309010',
    name: 'Ojan Detun',
  },
  {
    id: '5309010002',
    districtId: '5309010',
    name: 'Hewa',
  },
  {
    id: '5309010003',
    districtId: '5309010',
    name: 'Pantai Oa',
  },
  {
    id: '5309010004',
    districtId: '5309010',
    name: 'Waiula',
  },
  {
    id: '5309010009',
    districtId: '5309010',
    name: 'Nawokote',
  },
  {
    id: '5309010010',
    districtId: '5309010',
    name: 'Boru Kedang',
  },
  {
    id: '5309010011',
    districtId: '5309010',
    name: 'Boru',
  },
  {
    id: '5309010012',
    districtId: '5309010',
    name: 'Hokeng Jaya',
  },
  {
    id: '5309010014',
    districtId: '5309010',
    name: 'Pululera',
  },
  {
    id: '5309010015',
    districtId: '5309010',
    name: 'Nileknoheng',
  },
  {
    id: '5309010016',
    districtId: '5309010',
    name: 'Klatanlo',
  },
  {
    id: '5309011001',
    districtId: '5309011',
    name: 'Adabang',
  },
  {
    id: '5309011002',
    districtId: '5309011',
    name: 'Kobasoma',
  },
  {
    id: '5309011003',
    districtId: '5309011',
    name: 'Tenawahang',
  },
  {
    id: '5309011004',
    districtId: '5309011',
    name: 'Konga',
  },
  {
    id: '5309011005',
    districtId: '5309011',
    name: 'Ile Gerong',
  },
  {
    id: '5309011006',
    districtId: '5309011',
    name: 'Lewolaga',
  },
  {
    id: '5309011007',
    districtId: '5309011',
    name: 'Lewoingu',
  },
  {
    id: '5309011008',
    districtId: '5309011',
    name: 'Tuakepa',
  },
  {
    id: '5309011009',
    districtId: '5309011',
    name: 'Leraboleng',
  },
  {
    id: '5309011010',
    districtId: '5309011',
    name: 'Watowara',
  },
  {
    id: '5309011011',
    districtId: '5309011',
    name: 'Serinuho',
  },
  {
    id: '5309011012',
    districtId: '5309011',
    name: 'Dun Tana Lewoingu',
  },
  {
    id: '5309011013',
    districtId: '5309011',
    name: 'Bokang Wolomatang',
  },
  {
    id: '5309011014',
    districtId: '5309011',
    name: 'Duli Jaya',
  },
  {
    id: '5309012001',
    districtId: '5309012',
    name: 'Riangbaring',
  },
  {
    id: '5309012002',
    districtId: '5309012',
    name: 'Lewoawang',
  },
  {
    id: '5309012003',
    districtId: '5309012',
    name: 'Lewotobi',
  },
  {
    id: '5309012004',
    districtId: '5309012',
    name: 'Nurabelen',
  },
  {
    id: '5309012005',
    districtId: '5309012',
    name: 'Nobo',
  },
  {
    id: '5309012006',
    districtId: '5309012',
    name: 'Riang Rita',
  },
  {
    id: '5309012007',
    districtId: '5309012',
    name: 'Dulipali',
  },
  {
    id: '5309020008',
    districtId: '5309020',
    name: 'Kolaka',
  },
  {
    id: '5309020009',
    districtId: '5309020',
    name: 'Lewobunga',
  },
  {
    id: '5309020010',
    districtId: '5309020',
    name: 'Sinamalaka',
  },
  {
    id: '5309020011',
    districtId: '5309020',
    name: 'Ratu Lodong',
  },
  {
    id: '5309020012',
    districtId: '5309020',
    name: 'Sina Hadigala',
  },
  {
    id: '5309020013',
    districtId: '5309020',
    name: 'Bandona',
  },
  {
    id: '5309020014',
    districtId: '5309020',
    name: 'Bahinga',
  },
  {
    id: '5309020015',
    districtId: '5309020',
    name: 'Waibao',
  },
  {
    id: '5309020016',
    districtId: '5309020',
    name: 'Nusanipa',
  },
  {
    id: '5309020017',
    districtId: '5309020',
    name: 'Lamatutu',
  },
  {
    id: '5309020018',
    districtId: '5309020',
    name: 'Laton Liwo',
  },
  {
    id: '5309020019',
    districtId: '5309020',
    name: 'Patisirawalang',
  },
  {
    id: '5309020020',
    districtId: '5309020',
    name: 'Gekeng Deran',
  },
  {
    id: '5309020021',
    districtId: '5309020',
    name: 'Aran Sina',
  },
  {
    id: '5309020022',
    districtId: '5309020',
    name: 'Lamanabi',
  },
  {
    id: '5309020023',
    districtId: '5309020',
    name: 'Laton Liwo II',
  },
  {
    id: '5309021001',
    districtId: '5309021',
    name: 'Lewobele',
  },
  {
    id: '5309021002',
    districtId: '5309021',
    name: 'Ile Padung',
  },
  {
    id: '5309021003',
    districtId: '5309021',
    name: 'Bantala',
  },
  {
    id: '5309021004',
    districtId: '5309021',
    name: 'Riangkotek',
  },
  {
    id: '5309021005',
    districtId: '5309021',
    name: 'Sinar Hading',
  },
  {
    id: '5309021006',
    districtId: '5309021',
    name: 'Painapang',
  },
  {
    id: '5309021007',
    districtId: '5309021',
    name: 'Baluk Hering',
  },
  {
    id: '5309030007',
    districtId: '5309030',
    name: 'Mokantarak',
  },
  {
    id: '5309030010',
    districtId: '5309030',
    name: 'Lamawalang',
  },
  {
    id: '5309030011',
    districtId: '5309030',
    name: 'Waibalun',
  },
  {
    id: '5309030012',
    districtId: '5309030',
    name: 'Lewolere',
  },
  {
    id: '5309030013',
    districtId: '5309030',
    name: 'Pantai Besar',
  },
  {
    id: '5309030014',
    districtId: '5309030',
    name: 'Larantuka',
  },
  {
    id: '5309030015',
    districtId: '5309030',
    name: 'Balela',
  },
  {
    id: '5309030016',
    districtId: '5309030',
    name: 'Pohon Sirih',
  },
  {
    id: '5309030017',
    districtId: '5309030',
    name: 'Lohayong',
  },
  {
    id: '5309030018',
    districtId: '5309030',
    name: 'Lokea',
  },
  {
    id: '5309030019',
    districtId: '5309030',
    name: 'Postoh',
  },
  {
    id: '5309030020',
    districtId: '5309030',
    name: 'Amagarapati',
  },
  {
    id: '5309030021',
    districtId: '5309030',
    name: 'Ekasapta',
  },
  {
    id: '5309030022',
    districtId: '5309030',
    name: 'Puken Tobi Wangi Bao',
  },
  {
    id: '5309030023',
    districtId: '5309030',
    name: 'Sarotari',
  },
  {
    id: '5309030024',
    districtId: '5309030',
    name: 'Weri',
  },
  {
    id: '5309030025',
    districtId: '5309030',
    name: 'Pohon Bao',
  },
  {
    id: '5309030026',
    districtId: '5309030',
    name: 'Waihali',
  },
  {
    id: '5309030027',
    districtId: '5309030',
    name: 'Sarotari Tengah',
  },
  {
    id: '5309030028',
    districtId: '5309030',
    name: 'Sarotari Timur',
  },
  {
    id: '5309031001',
    districtId: '5309031',
    name: 'Lewoloba',
  },
  {
    id: '5309031002',
    districtId: '5309031',
    name: 'Wailolong',
  },
  {
    id: '5309031003',
    districtId: '5309031',
    name: 'Riang Kemie',
  },
  {
    id: '5309031004',
    districtId: '5309031',
    name: 'Lewohala',
  },
  {
    id: '5309031005',
    districtId: '5309031',
    name: 'Halakodanuan',
  },
  {
    id: '5309031006',
    districtId: '5309031',
    name: 'Watotutu',
  },
  {
    id: '5309031007',
    districtId: '5309031',
    name: 'Mudakeputu',
  },
  {
    id: '5309031008',
    districtId: '5309031',
    name: 'Tiwatobi',
  },
  {
    id: '5309032001',
    districtId: '5309032',
    name: 'Lamika',
  },
  {
    id: '5309032002',
    districtId: '5309032',
    name: 'Kawalelo',
  },
  {
    id: '5309032003',
    districtId: '5309032',
    name: 'Watotika Ile',
  },
  {
    id: '5309032004',
    districtId: '5309032',
    name: 'Lewokluok',
  },
  {
    id: '5309032005',
    districtId: '5309032',
    name: 'Blepanawa',
  },
  {
    id: '5309032006',
    districtId: '5309032',
    name: 'Bama',
  },
  {
    id: '5309032007',
    districtId: '5309032',
    name: 'Lewomuda',
  },
  {
    id: '5309040001',
    districtId: '5309040',
    name: 'Tanah Lein',
  },
  {
    id: '5309040002',
    districtId: '5309040',
    name: 'Lamaole',
  },
  {
    id: '5309040003',
    districtId: '5309040',
    name: 'Lewotanah Ole',
  },
  {
    id: '5309040004',
    districtId: '5309040',
    name: 'Lamawohong',
  },
  {
    id: '5309040005',
    districtId: '5309040',
    name: 'Kalelu',
  },
  {
    id: '5309040010',
    districtId: '5309040',
    name: 'Karawatung',
  },
  {
    id: '5309040011',
    districtId: '5309040',
    name: 'Ongalereng',
  },
  {
    id: '5309040012',
    districtId: '5309040',
    name: 'Pamakayo',
  },
  {
    id: '5309040013',
    districtId: '5309040',
    name: 'Balaweling I',
  },
  {
    id: '5309040014',
    districtId: '5309040',
    name: 'Balaweling II',
  },
  {
    id: '5309040015',
    districtId: '5309040',
    name: 'Dani Wato',
  },
  {
    id: '5309040016',
    districtId: '5309040',
    name: 'Nurhalolon',
  },
  {
    id: '5309040017',
    districtId: '5309040',
    name: 'Ritaebang',
  },
  {
    id: '5309040018',
    districtId: '5309040',
    name: 'Titehena',
  },
  {
    id: '5309040019',
    districtId: '5309040',
    name: 'Lewonama',
  },
  {
    id: '5309041001',
    districtId: '5309041',
    name: 'Sulengwaseng',
  },
  {
    id: '5309041003',
    districtId: '5309041',
    name: 'Lemanu',
  },
  {
    id: '5309041004',
    districtId: '5309041',
    name: 'Kalike',
  },
  {
    id: '5309041005',
    districtId: '5309041',
    name: 'Kalike Aimatan',
  },
  {
    id: '5309041006',
    districtId: '5309041',
    name: 'Lewograran',
  },
  {
    id: '5309041007',
    districtId: '5309041',
    name: 'Bubu Atagamu',
  },
  {
    id: '5309050003',
    districtId: '5309050',
    name: 'Watanhura II',
  },
  {
    id: '5309050004',
    districtId: '5309050',
    name: 'Watanhura',
  },
  {
    id: '5309050005',
    districtId: '5309050',
    name: 'Lebao',
  },
  {
    id: '5309050006',
    districtId: '5309050',
    name: 'Liwo',
  },
  {
    id: '5309050007',
    districtId: '5309050',
    name: 'Lamawai',
  },
  {
    id: '5309050008',
    districtId: '5309050',
    name: 'Watohari',
  },
  {
    id: '5309050009',
    districtId: '5309050',
    name: 'Tanah Werang',
  },
  {
    id: '5309050010',
    districtId: '5309050',
    name: 'Motonwutun',
  },
  {
    id: '5309050011',
    districtId: '5309050',
    name: 'Watobuku',
  },
  {
    id: '5309050012',
    districtId: '5309050',
    name: 'Labelen',
  },
  {
    id: '5309050013',
    districtId: '5309050',
    name: 'Kawuta',
  },
  {
    id: '5309050014',
    districtId: '5309050',
    name: 'Menanga',
  },
  {
    id: '5309050015',
    districtId: '5309050',
    name: 'Lewogeka',
  },
  {
    id: '5309050016',
    districtId: '5309050',
    name: 'Lohayong',
  },
  {
    id: '5309050017',
    districtId: '5309050',
    name: 'Lohayong II',
  },
  {
    id: '5309050018',
    districtId: '5309050',
    name: 'Wulublolong',
  },
  {
    id: '5309050019',
    districtId: '5309050',
    name: 'Lewohedo',
  },
  {
    id: '5309060011',
    districtId: '5309060',
    name: 'Bugalima',
  },
  {
    id: '5309060012',
    districtId: '5309060',
    name: 'Kima Kamak',
  },
  {
    id: '5309060013',
    districtId: '5309060',
    name: 'Ilepati',
  },
  {
    id: '5309060017',
    districtId: '5309060',
    name: 'Danibao',
  },
  {
    id: '5309060018',
    districtId: '5309060',
    name: 'Pajinian',
  },
  {
    id: '5309060020',
    districtId: '5309060',
    name: 'Waiwadan',
  },
  {
    id: '5309060021',
    districtId: '5309060',
    name: 'Tonuwotan',
  },
  {
    id: '5309060022',
    districtId: '5309060',
    name: 'Bukit Seburi',
  },
  {
    id: '5309060023',
    districtId: '5309060',
    name: 'Bukit Seburi II',
  },
  {
    id: '5309060027',
    districtId: '5309060',
    name: 'Homa',
  },
  {
    id: '5309060028',
    districtId: '5309060',
    name: 'Duwanur',
  },
  {
    id: '5309060040',
    districtId: '5309060',
    name: 'Nimun Dani Bao',
  },
  {
    id: '5309060041',
    districtId: '5309060',
    name: 'Wato Baya',
  },
  {
    id: '5309060042',
    districtId: '5309060',
    name: 'Wai Tukan',
  },
  {
    id: '5309060043',
    districtId: '5309060',
    name: 'Riang Padu',
  },
  {
    id: '5309060044',
    districtId: '5309060',
    name: 'Woloklibang',
  },
  {
    id: '5309061001',
    districtId: '5309061',
    name: 'Wailebe',
  },
  {
    id: '5309061002',
    districtId: '5309061',
    name: 'Tobilota',
  },
  {
    id: '5309061003',
    districtId: '5309061',
    name: 'Wotanulumado',
  },
  {
    id: '5309061004',
    districtId: '5309061',
    name: 'Tanah Tukan',
  },
  {
    id: '5309061005',
    districtId: '5309061',
    name: 'Samasoge',
  },
  {
    id: '5309061006',
    districtId: '5309061',
    name: 'Nayubaya',
  },
  {
    id: '5309061007',
    districtId: '5309061',
    name: 'Oyangbarang',
  },
  {
    id: '5309061008',
    districtId: '5309061',
    name: 'Kawela',
  },
  {
    id: '5309061009',
    districtId: '5309061',
    name: 'Bliko',
  },
  {
    id: '5309061010',
    districtId: '5309061',
    name: 'Klukengnuking',
  },
  {
    id: '5309061011',
    districtId: '5309061',
    name: 'Pandai',
  },
  {
    id: '5309061012',
    districtId: '5309061',
    name: 'Demondein',
  },
  {
    id: '5309062001',
    districtId: '5309062',
    name: 'Kokotobo',
  },
  {
    id: '5309062002',
    districtId: '5309062',
    name: 'Baya',
  },
  {
    id: '5309062003',
    districtId: '5309062',
    name: 'Lewobele',
  },
  {
    id: '5309062004',
    districtId: '5309062',
    name: 'Horowura',
  },
  {
    id: '5309062005',
    districtId: '5309062',
    name: 'Lite',
  },
  {
    id: '5309062006',
    districtId: '5309062',
    name: 'Kenotan',
  },
  {
    id: '5309062007',
    districtId: '5309062',
    name: 'Nubalema',
  },
  {
    id: '5309062008',
    districtId: '5309062',
    name: 'Bidara',
  },
  {
    id: '5309062009',
    districtId: '5309062',
    name: 'Wewit',
  },
  {
    id: '5309062010',
    districtId: '5309062',
    name: 'Lewopao',
  },
  {
    id: '5309062011',
    districtId: '5309062',
    name: 'Hoko Horowura',
  },
  {
    id: '5309062012',
    districtId: '5309062',
    name: 'Oe Sayang',
  },
  {
    id: '5309062013',
    districtId: '5309062',
    name: 'Nubalema Dua',
  },
  {
    id: '5309070001',
    districtId: '5309070',
    name: 'Bloto',
  },
  {
    id: '5309070002',
    districtId: '5309070',
    name: 'Terong',
  },
  {
    id: '5309070003',
    districtId: '5309070',
    name: 'Dawataa',
  },
  {
    id: '5309070004',
    districtId: '5309070',
    name: 'Bilal',
  },
  {
    id: '5309070005',
    districtId: '5309070',
    name: 'Ipiebang',
  },
  {
    id: '5309070006',
    districtId: '5309070',
    name: 'Lamahala Jaya',
  },
  {
    id: '5309070007',
    districtId: '5309070',
    name: 'Waiwerang Kota',
  },
  {
    id: '5309070008',
    districtId: '5309070',
    name: 'Waiburak',
  },
  {
    id: '5309070009',
    districtId: '5309070',
    name: 'Narasaosina',
  },
  {
    id: '5309070010',
    districtId: '5309070',
    name: 'Lewobunga',
  },
  {
    id: '5309070011',
    districtId: '5309070',
    name: 'Lamalota',
  },
  {
    id: '5309070012',
    districtId: '5309070',
    name: 'Kiwang Ona',
  },
  {
    id: '5309070013',
    districtId: '5309070',
    name: 'Karinglamalouk',
  },
  {
    id: '5309070014',
    districtId: '5309070',
    name: 'Tuawolo',
  },
  {
    id: '5309070015',
    districtId: '5309070',
    name: 'Lamatewelu',
  },
  {
    id: '5309070056',
    districtId: '5309070',
    name: 'Tapobali',
  },
  {
    id: '5309070058',
    districtId: '5309070',
    name: 'Kwaelaga Lamawato',
  },
  {
    id: '5309070059',
    districtId: '5309070',
    name: 'Gelong',
  },
  {
    id: '5309070060',
    districtId: '5309070',
    name: 'Lelen Bala',
  },
  {
    id: '5309070061',
    districtId: '5309070',
    name: 'Saosina',
  },
  {
    id: '5309071001',
    districtId: '5309071',
    name: 'Lewo Keleng',
  },
  {
    id: '5309071002',
    districtId: '5309071',
    name: 'Bedalewun',
  },
  {
    id: '5309071003',
    districtId: '5309071',
    name: 'Nihaone',
  },
  {
    id: '5309071004',
    districtId: '5309071',
    name: 'Bungalawan',
  },
  {
    id: '5309071005',
    districtId: '5309071',
    name: 'Lewobelolong',
  },
  {
    id: '5309071006',
    districtId: '5309071',
    name: 'Lamawolo',
  },
  {
    id: '5309071007',
    districtId: '5309071',
    name: 'Helanlangowuyo',
  },
  {
    id: '5309071008',
    districtId: '5309071',
    name: 'Lewopao',
  },
  {
    id: '5309071009',
    districtId: '5309071',
    name: 'Harubala',
  },
  {
    id: '5309071010',
    districtId: '5309071',
    name: 'Nelelamadiken',
  },
  {
    id: '5309071011',
    districtId: '5309071',
    name: 'Boleng',
  },
  {
    id: '5309071012',
    districtId: '5309071',
    name: 'Gayak',
  },
  {
    id: '5309071013',
    districtId: '5309071',
    name: 'Neleblolong',
  },
  {
    id: '5309071014',
    districtId: '5309071',
    name: 'Nele Lamawangi',
  },
  {
    id: '5309071015',
    districtId: '5309071',
    name: 'Duablolong',
  },
  {
    id: '5309071016',
    districtId: '5309071',
    name: 'Lamabayung',
  },
  {
    id: '5309071017',
    districtId: '5309071',
    name: 'Lewat',
  },
  {
    id: '5309071018',
    districtId: '5309071',
    name: 'Dokeng',
  },
  {
    id: '5309071019',
    districtId: '5309071',
    name: 'Bajuntaa',
  },
  {
    id: '5309071020',
    districtId: '5309071',
    name: 'Nobo',
  },
  {
    id: '5309071021',
    districtId: '5309071',
    name: 'Nele Lamawangi II',
  },
  {
    id: '5309072001',
    districtId: '5309072',
    name: 'Watololong',
  },
  {
    id: '5309072002',
    districtId: '5309072',
    name: 'Tuwagoetobi',
  },
  {
    id: '5309072003',
    districtId: '5309072',
    name: 'Riangduli',
  },
  {
    id: '5309072004',
    districtId: '5309072',
    name: 'Pledo',
  },
  {
    id: '5309072005',
    districtId: '5309072',
    name: 'Watoone',
  },
  {
    id: '5309072006',
    districtId: '5309072',
    name: 'Weranggere',
  },
  {
    id: '5309072007',
    districtId: '5309072',
    name: 'Oringbele',
  },
  {
    id: '5309072008',
    districtId: '5309072',
    name: 'Waiwuring',
  },
  {
    id: '5309072009',
    districtId: '5309072',
    name: 'Tobitika',
  },
  {
    id: '5309072010',
    districtId: '5309072',
    name: 'Sandosi',
  },
  {
    id: '5309072011',
    districtId: '5309072',
    name: 'Balaweling',
  },
  {
    id: '5309072012',
    districtId: '5309072',
    name: 'Lamablawa',
  },
  {
    id: '5309072013',
    districtId: '5309072',
    name: 'Lewopulo',
  },
  {
    id: '5309072014',
    districtId: '5309072',
    name: 'Lamaleka',
  },
  {
    id: '5309072015',
    districtId: '5309072',
    name: 'Baobage',
  },
  {
    id: '5309072016',
    districtId: '5309072',
    name: 'Balaweling Noten',
  },
  {
    id: '5309073001',
    districtId: '5309073',
    name: 'Horinara',
  },
  {
    id: '5309073002',
    districtId: '5309073',
    name: 'Nisakarang',
  },
  {
    id: '5309073003',
    districtId: '5309073',
    name: 'Muda',
  },
  {
    id: '5309073004',
    districtId: '5309073',
    name: 'Sukutokan',
  },
  {
    id: '5309073005',
    districtId: '5309073',
    name: 'Lamapaha',
  },
  {
    id: '5309073006',
    districtId: '5309073',
    name: 'Hinga',
  },
  {
    id: '5309073007',
    districtId: '5309073',
    name: 'Redontena',
  },
  {
    id: '5309073008',
    districtId: '5309073',
    name: 'Adobala',
  },
  {
    id: '5309073009',
    districtId: '5309073',
    name: 'Pepak Kelu',
  },
  {
    id: '5309073010',
    districtId: '5309073',
    name: 'Lamabunga',
  },
  {
    id: '5309073011',
    districtId: '5309073',
    name: 'Mangaaleng',
  },
  {
    id: '5309073019',
    districtId: '5309073',
    name: 'Keluwain',
  },
  {
    id: '5309074001',
    districtId: '5309074',
    name: 'Tikatukang',
  },
  {
    id: '5309074002',
    districtId: '5309074',
    name: 'Lamahoda',
  },
  {
    id: '5309074003',
    districtId: '5309074',
    name: 'Kolilanang',
  },
  {
    id: '5309074004',
    districtId: '5309074',
    name: 'Sagu',
  },
  {
    id: '5309074005',
    districtId: '5309074',
    name: 'Adonara',
  },
  {
    id: '5309074006',
    districtId: '5309074',
    name: 'Nisa Nulan',
  },
  {
    id: '5309074007',
    districtId: '5309074',
    name: 'Koli Masang',
  },
  {
    id: '5309074008',
    districtId: '5309074',
    name: 'Kolipetung',
  },
  {
    id: '5310010001',
    districtId: '5310010',
    name: 'Wolowiro',
  },
  {
    id: '5310010002',
    districtId: '5310010',
    name: 'Mauloo',
  },
  {
    id: '5310010004',
    districtId: '5310010',
    name: 'Paga',
  },
  {
    id: '5310010008',
    districtId: '5310010',
    name: 'Lenandareta',
  },
  {
    id: '5310010015',
    districtId: '5310010',
    name: 'Masebewa',
  },
  {
    id: '5310010016',
    districtId: '5310010',
    name: 'Wolorega',
  },
  {
    id: '5310010017',
    districtId: '5310010',
    name: 'Wolowona',
  },
  {
    id: '5310011001',
    districtId: '5310011',
    name: 'Korobhera',
  },
  {
    id: '5310011002',
    districtId: '5310011',
    name: 'Dobo',
  },
  {
    id: '5310011003',
    districtId: '5310011',
    name: 'Bhera',
  },
  {
    id: '5310011004',
    districtId: '5310011',
    name: 'Wolodhesa',
  },
  {
    id: '5310011005',
    districtId: '5310011',
    name: 'Gera',
  },
  {
    id: '5310011006',
    districtId: '5310011',
    name: 'Liakutu',
  },
  {
    id: '5310011007',
    districtId: '5310011',
    name: 'Parabubu',
  },
  {
    id: '5310011008',
    districtId: '5310011',
    name: 'Dobo Nua Puu',
  },
  {
    id: '5310011009',
    districtId: '5310011',
    name: 'Kowi',
  },
  {
    id: '5310011010',
    districtId: '5310011',
    name: 'Napu Gera',
  },
  {
    id: '5310012009',
    districtId: '5310012',
    name: 'Bu Selatan',
  },
  {
    id: '5310012010',
    districtId: '5310012',
    name: 'Detubinga',
  },
  {
    id: '5310012011',
    districtId: '5310012',
    name: 'Bu Utara',
  },
  {
    id: '5310012012',
    districtId: '5310012',
    name: 'Bu Watuweti',
  },
  {
    id: '5310012013',
    districtId: '5310012',
    name: 'Loke',
  },
  {
    id: '5310012014',
    districtId: '5310012',
    name: 'Renggarasi',
  },
  {
    id: '5310012018',
    districtId: '5310012',
    name: 'Poma',
  },
  {
    id: '5310012021',
    districtId: '5310012',
    name: 'Tuwa',
  },
  {
    id: '5310020001',
    districtId: '5310020',
    name: 'Kolidetung',
  },
  {
    id: '5310020002',
    districtId: '5310020',
    name: 'Korowuwu',
  },
  {
    id: '5310020003',
    districtId: '5310020',
    name: 'Hepang',
  },
  {
    id: '5310020004',
    districtId: '5310020',
    name: 'Lela',
  },
  {
    id: '5310020005',
    districtId: '5310020',
    name: 'Watutedang',
  },
  {
    id: '5310020006',
    districtId: '5310020',
    name: 'Sikka',
  },
  {
    id: '5310020007',
    districtId: '5310020',
    name: 'Iligai',
  },
  {
    id: '5310020008',
    districtId: '5310020',
    name: 'Baopaat',
  },
  {
    id: '5310030001',
    districtId: '5310030',
    name: 'Hokor',
  },
  {
    id: '5310030002',
    districtId: '5310030',
    name: 'Wolonwalu',
  },
  {
    id: '5310030003',
    districtId: '5310030',
    name: 'Wolokoli',
  },
  {
    id: '5310030004',
    districtId: '5310030',
    name: 'Bola',
  },
  {
    id: '5310030005',
    districtId: '5310030',
    name: 'Umauta',
  },
  {
    id: '5310030006',
    districtId: '5310030',
    name: 'Ipir',
  },
  {
    id: '5310031007',
    districtId: '5310031',
    name: 'Wolomotong',
  },
  {
    id: '5310031008',
    districtId: '5310031',
    name: 'Kloangpopot',
  },
  {
    id: '5310031009',
    districtId: '5310031',
    name: 'Watumerak',
  },
  {
    id: '5310031010',
    districtId: '5310031',
    name: 'Wogalirit',
  },
  {
    id: '5310031011',
    districtId: '5310031',
    name: 'Waihawa',
  },
  {
    id: '5310031012',
    districtId: '5310031',
    name: 'Nen Bura',
  },
  {
    id: '5310031016',
    districtId: '5310031',
    name: 'Wolonterang',
  },
  {
    id: '5310032013',
    districtId: '5310032',
    name: 'Natakoli',
  },
  {
    id: '5310032014',
    districtId: '5310032',
    name: 'Hebing',
  },
  {
    id: '5310032015',
    districtId: '5310032',
    name: 'Hale',
  },
  {
    id: '5310032017',
    districtId: '5310032',
    name: 'Egon Gahar',
  },
  {
    id: '5310040010',
    districtId: '5310040',
    name: 'Nangahale',
  },
  {
    id: '5310040015',
    districtId: '5310040',
    name: 'Talibura',
  },
  {
    id: '5310040016',
    districtId: '5310040',
    name: 'Darat Gunung',
  },
  {
    id: '5310040017',
    districtId: '5310040',
    name: 'Darat Pantai',
  },
  {
    id: '5310040019',
    districtId: '5310040',
    name: 'Hikong',
  },
  {
    id: '5310040020',
    districtId: '5310040',
    name: 'Kringa',
  },
  {
    id: '5310040021',
    districtId: '5310040',
    name: 'Ojang',
  },
  {
    id: '5310040022',
    districtId: '5310040',
    name: 'Wailamung',
  },
  {
    id: '5310040023',
    districtId: '5310040',
    name: 'Lewomada',
  },
  {
    id: '5310040026',
    districtId: '5310040',
    name: 'Timutawa',
  },
  {
    id: '5310040027',
    districtId: '5310040',
    name: 'Baang Koor',
  },
  {
    id: '5310041001',
    districtId: '5310041',
    name: 'Pogon',
  },
  {
    id: '5310041002',
    districtId: '5310041',
    name: 'Aibura',
  },
  {
    id: '5310041003',
    districtId: '5310041',
    name: 'Wairbleler',
  },
  {
    id: '5310041004',
    districtId: '5310041',
    name: 'Hoder',
  },
  {
    id: '5310041005',
    districtId: '5310041',
    name: 'Egon',
  },
  {
    id: '5310041006',
    districtId: '5310041',
    name: 'Nangatobong',
  },
  {
    id: '5310041007',
    districtId: '5310041',
    name: 'Wairterang',
  },
  {
    id: '5310041008',
    districtId: '5310041',
    name: 'Watudiran',
  },
  {
    id: '5310042011',
    districtId: '5310042',
    name: 'Natarmage',
  },
  {
    id: '5310042012',
    districtId: '5310042',
    name: 'Pruda',
  },
  {
    id: '5310042013',
    districtId: '5310042',
    name: 'Werang',
  },
  {
    id: '5310042014',
    districtId: '5310042',
    name: 'Tanarawa',
  },
  {
    id: '5310042024',
    districtId: '5310042',
    name: 'Ilinmedo',
  },
  {
    id: '5310042025',
    districtId: '5310042',
    name: 'Tua Bao',
  },
  {
    id: '5310050005',
    districtId: '5310050',
    name: 'Umagera',
  },
  {
    id: '5310050006',
    districtId: '5310050',
    name: 'Ian Tena',
  },
  {
    id: '5310050007',
    districtId: '5310050',
    name: 'Kopong',
  },
  {
    id: '5310050008',
    districtId: '5310050',
    name: 'Seusina',
  },
  {
    id: '5310050014',
    districtId: '5310050',
    name: 'Namangkewa',
  },
  {
    id: '5310050022',
    districtId: '5310050',
    name: 'Waiara',
  },
  {
    id: '5310050023',
    districtId: '5310050',
    name: 'Geliting',
  },
  {
    id: '5310050024',
    districtId: '5310050',
    name: 'Wairkoja',
  },
  {
    id: '5310051009',
    districtId: '5310051',
    name: 'Hewokloang',
  },
  {
    id: '5310051010',
    districtId: '5310051',
    name: 'Heopuat',
  },
  {
    id: '5310051011',
    districtId: '5310051',
    name: 'Wolomapa',
  },
  {
    id: '5310051012',
    districtId: '5310051',
    name: 'Rubit',
  },
  {
    id: '5310051013',
    districtId: '5310051',
    name: 'Kajowair',
  },
  {
    id: '5310051020',
    districtId: '5310051',
    name: 'Baomekot',
  },
  {
    id: '5310051021',
    districtId: '5310051',
    name: 'Munerana',
  },
  {
    id: '5310052001',
    districtId: '5310052',
    name: 'Tekaiku',
  },
  {
    id: '5310052003',
    districtId: '5310052',
    name: 'Blatatatin',
  },
  {
    id: '5310052004',
    districtId: '5310052',
    name: 'Kokowahor',
  },
  {
    id: '5310052015',
    districtId: '5310052',
    name: 'Watumilok',
  },
  {
    id: '5310052016',
    districtId: '5310052',
    name: 'Tanaduen',
  },
  {
    id: '5310052017',
    districtId: '5310052',
    name: 'Watuliwung',
  },
  {
    id: '5310052018',
    districtId: '5310052',
    name: 'Habi',
  },
  {
    id: '5310052019',
    districtId: '5310052',
    name: 'Langir',
  },
  {
    id: '5310061001',
    districtId: '5310061',
    name: 'Nitunglea',
  },
  {
    id: '5310061002',
    districtId: '5310061',
    name: 'Lidi',
  },
  {
    id: '5310061003',
    districtId: '5310061',
    name: 'Reruwairere',
  },
  {
    id: '5310061004',
    districtId: '5310061',
    name: 'Maluriwu',
  },
  {
    id: '5310061005',
    districtId: '5310061',
    name: 'Kesokoja',
  },
  {
    id: '5310061006',
    districtId: '5310061',
    name: 'Ladolaka',
  },
  {
    id: '5310061007',
    districtId: '5310061',
    name: 'Tuanggeo',
  },
  {
    id: '5310061008',
    districtId: '5310061',
    name: 'Rokirole',
  },
  {
    id: '5310062001',
    districtId: '5310062',
    name: 'Koting C',
  },
  {
    id: '5310062002',
    districtId: '5310062',
    name: 'Koting D',
  },
  {
    id: '5310062003',
    districtId: '5310062',
    name: 'Paubekor',
  },
  {
    id: '5310062004',
    districtId: '5310062',
    name: 'Koting B',
  },
  {
    id: '5310062005',
    districtId: '5310062',
    name: 'Koting A',
  },
  {
    id: '5310062006',
    districtId: '5310062',
    name: 'Ribang',
  },
  {
    id: '5310063002',
    districtId: '5310063',
    name: 'Nelle Lorang',
  },
  {
    id: '5310063003',
    districtId: '5310063',
    name: 'Manubura',
  },
  {
    id: '5310063004',
    districtId: '5310063',
    name: 'Nelle Barat',
  },
  {
    id: '5310070001',
    districtId: '5310070',
    name: 'Tilang',
  },
  {
    id: '5310070002',
    districtId: '5310070',
    name: 'Lusitada',
  },
  {
    id: '5310070003',
    districtId: '5310070',
    name: 'Bloro',
  },
  {
    id: '5310070005',
    districtId: '5310070',
    name: 'Nita',
  },
  {
    id: '5310070006',
    districtId: '5310070',
    name: 'Takaplager',
  },
  {
    id: '5310070007',
    districtId: '5310070',
    name: 'Nitakloang',
  },
  {
    id: '5310070008',
    districtId: '5310070',
    name: 'Wuliwutik',
  },
  {
    id: '5310070009',
    districtId: '5310070',
    name: 'Ladogahar',
  },
  {
    id: '5310070010',
    districtId: '5310070',
    name: 'Riit',
  },
  {
    id: '5310070011',
    districtId: '5310070',
    name: 'Nirangkliung',
  },
  {
    id: '5310070015',
    districtId: '5310070',
    name: 'Mahebora',
  },
  {
    id: '5310071001',
    districtId: '5310071',
    name: 'Kolisia',
  },
  {
    id: '5310071002',
    districtId: '5310071',
    name: 'Magepanda',
  },
  {
    id: '5310071003',
    districtId: '5310071',
    name: 'Reroroja',
  },
  {
    id: '5310071004',
    districtId: '5310071',
    name: 'Kolisia B',
  },
  {
    id: '5310071005',
    districtId: '5310071',
    name: 'Done',
  },
  {
    id: '5310080005',
    districtId: '5310080',
    name: 'Kota Uneng',
  },
  {
    id: '5310080006',
    districtId: '5310080',
    name: 'Nangalimang',
  },
  {
    id: '5310080007',
    districtId: '5310080',
    name: 'Madawat',
  },
  {
    id: '5310080008',
    districtId: '5310080',
    name: 'Kabor',
  },
  {
    id: '5310080009',
    districtId: '5310080',
    name: 'Pemana',
  },
  {
    id: '5310080010',
    districtId: '5310080',
    name: 'Gunung Sari',
  },
  {
    id: '5310080011',
    districtId: '5310080',
    name: 'Samparong',
  },
  {
    id: '5310081001',
    districtId: '5310081',
    name: 'Wuring',
  },
  {
    id: '5310081002',
    districtId: '5310081',
    name: 'Hewuli',
  },
  {
    id: '5310081003',
    districtId: '5310081',
    name: 'Wailiti',
  },
  {
    id: '5310081004',
    districtId: '5310081',
    name: 'Wolomarang',
  },
  {
    id: '5310082009',
    districtId: '5310082',
    name: 'Kota Baru',
  },
  {
    id: '5310082011',
    districtId: '5310082',
    name: 'Nangameting',
  },
  {
    id: '5310082012',
    districtId: '5310082',
    name: 'Wairotang',
  },
  {
    id: '5310082013',
    districtId: '5310082',
    name: 'Waioti',
  },
  {
    id: '5310082014',
    districtId: '5310082',
    name: 'Watugong',
  },
  {
    id: '5310082015',
    districtId: '5310082',
    name: 'Kojadoi',
  },
  {
    id: '5310082016',
    districtId: '5310082',
    name: 'Kojagete',
  },
  {
    id: '5310082017',
    districtId: '5310082',
    name: 'Parumaan',
  },
  {
    id: '5310082018',
    districtId: '5310082',
    name: 'Lepolima',
  },
  {
    id: '5311010001',
    districtId: '5311010',
    name: 'Ondorea',
  },
  {
    id: '5311010002',
    districtId: '5311010',
    name: 'Kel. Ndorurea',
  },
  {
    id: '5311010003',
    districtId: '5311010',
    name: 'Zozozea',
  },
  {
    id: '5311010004',
    districtId: '5311010',
    name: 'Nggorea',
  },
  {
    id: '5311010005',
    districtId: '5311010',
    name: 'Raporendu',
  },
  {
    id: '5311010006',
    districtId: '5311010',
    name: 'Rapowawo',
  },
  {
    id: '5311010007',
    districtId: '5311010',
    name: 'Bheramari',
  },
  {
    id: '5311010008',
    districtId: '5311010',
    name: 'Kerirea',
  },
  {
    id: '5311010009',
    districtId: '5311010',
    name: 'Tendarea',
  },
  {
    id: '5311010010',
    districtId: '5311010',
    name: 'Watumite',
  },
  {
    id: '5311010011',
    districtId: '5311010',
    name: 'Tendambepa',
  },
  {
    id: '5311010012',
    districtId: '5311010',
    name: 'Ondorea Barat',
  },
  {
    id: '5311010013',
    districtId: '5311010',
    name: 'Tiwe Rea',
  },
  {
    id: '5311010014',
    districtId: '5311010',
    name: 'Ndorurea I',
  },
  {
    id: '5311010015',
    districtId: '5311010',
    name: 'Ndeturea',
  },
  {
    id: '5311010016',
    districtId: '5311010',
    name: 'Sanggarhorho',
  },
  {
    id: '5311010017',
    districtId: '5311010',
    name: 'Penggajawa',
  },
  {
    id: '5311010018',
    districtId: '5311010',
    name: 'Jegharangga',
  },
  {
    id: '5311010019',
    districtId: '5311010',
    name: 'Uzu Zozo',
  },
  {
    id: '5311010020',
    districtId: '5311010',
    name: 'Embuzozo',
  },
  {
    id: '5311010021',
    districtId: '5311010',
    name: 'Anaraja',
  },
  {
    id: '5311010022',
    districtId: '5311010',
    name: 'Kekandere',
  },
  {
    id: '5311010023',
    districtId: '5311010',
    name: 'Tanazozo',
  },
  {
    id: '5311010024',
    districtId: '5311010',
    name: 'Jemburea',
  },
  {
    id: '5311010025',
    districtId: '5311010',
    name: 'Timbazia',
  },
  {
    id: '5311010026',
    districtId: '5311010',
    name: 'Romarea',
  },
  {
    id: '5311010027',
    districtId: '5311010',
    name: 'Mbobhenga',
  },
  {
    id: '5311010028',
    districtId: '5311010',
    name: 'Malawaru',
  },
  {
    id: '5311010029',
    districtId: '5311010',
    name: 'Tenda Ondo',
  },
  {
    id: '5311011001',
    districtId: '5311011',
    name: 'Ndoriwoy',
  },
  {
    id: '5311011002',
    districtId: '5311011',
    name: 'Rendoraterua',
  },
  {
    id: '5311011003',
    districtId: '5311011',
    name: 'Paderape',
  },
  {
    id: '5311011004',
    districtId: '5311011',
    name: 'Aejeti',
  },
  {
    id: '5311011005',
    districtId: '5311011',
    name: 'Puutara',
  },
  {
    id: '5311011006',
    districtId: '5311011',
    name: 'Rorurangga',
  },
  {
    id: '5311011007',
    districtId: '5311011',
    name: 'Redorori',
  },
  {
    id: '5311011008',
    districtId: '5311011',
    name: 'Kazo Kapo',
  },
  {
    id: '5311011009',
    districtId: '5311011',
    name: 'Renga Menge',
  },
  {
    id: '5311012001',
    districtId: '5311012',
    name: 'Kebirangga Selatan',
  },
  {
    id: '5311012002',
    districtId: '5311012',
    name: 'Kamubheka',
  },
  {
    id: '5311012003',
    districtId: '5311012',
    name: 'Kebirangga',
  },
  {
    id: '5311012004',
    districtId: '5311012',
    name: 'Boafeo',
  },
  {
    id: '5311012005',
    districtId: '5311012',
    name: 'Magekapa',
  },
  {
    id: '5311012006',
    districtId: '5311012',
    name: 'Nabe',
  },
  {
    id: '5311012007',
    districtId: '5311012',
    name: 'Kobaleba',
  },
  {
    id: '5311012008',
    districtId: '5311012',
    name: 'Mundinggasa',
  },
  {
    id: '5311012009',
    districtId: '5311012',
    name: 'Kolikapa',
  },
  {
    id: '5311012010',
    districtId: '5311012',
    name: 'Kebirangga Tengah',
  },
  {
    id: '5311012011',
    districtId: '5311012',
    name: 'Natanangge',
  },
  {
    id: '5311020004',
    districtId: '5311020',
    name: 'Ndetundora I',
  },
  {
    id: '5311020005',
    districtId: '5311020',
    name: 'Randotonda',
  },
  {
    id: '5311020006',
    districtId: '5311020',
    name: 'Raburia',
  },
  {
    id: '5311020007',
    districtId: '5311020',
    name: 'Tomberabu I',
  },
  {
    id: '5311020008',
    districtId: '5311020',
    name: 'Tomberabu II',
  },
  {
    id: '5311020009',
    districtId: '5311020',
    name: 'Tinabani',
  },
  {
    id: '5311020010',
    districtId: '5311020',
    name: 'Wologai',
  },
  {
    id: '5311020011',
    districtId: '5311020',
    name: 'Mbotutenda',
  },
  {
    id: '5311020012',
    districtId: '5311020',
    name: 'Jamokeasa',
  },
  {
    id: '5311020013',
    districtId: '5311020',
    name: 'Ndetundora II',
  },
  {
    id: '5311020014',
    districtId: '5311020',
    name: 'Emburia',
  },
  {
    id: '5311020015',
    districtId: '5311020',
    name: 'Riaraja',
  },
  {
    id: '5311020016',
    districtId: '5311020',
    name: 'Wolokaro',
  },
  {
    id: '5311020017',
    districtId: '5311020',
    name: 'Rukuramba',
  },
  {
    id: '5311020018',
    districtId: '5311020',
    name: 'Nakuramba',
  },
  {
    id: '5311020019',
    districtId: '5311020',
    name: 'Ndetundora III',
  },
  {
    id: '5311020020',
    districtId: '5311020',
    name: 'Tonggopapa',
  },
  {
    id: '5311020021',
    districtId: '5311020',
    name: 'Uzuramba',
  },
  {
    id: '5311020022',
    districtId: '5311020',
    name: 'Randorama',
  },
  {
    id: '5311020023',
    districtId: '5311020',
    name: 'Tendambonggi',
  },
  {
    id: '5311020024',
    districtId: '5311020',
    name: 'Wologai Dua',
  },
  {
    id: '5311020025',
    districtId: '5311020',
    name: 'Worhopapa',
  },
  {
    id: '5311020026',
    districtId: '5311020',
    name: 'Nuaja',
  },
  {
    id: '5311020027',
    districtId: '5311020',
    name: 'Embu Ngena',
  },
  {
    id: '5311020029',
    districtId: '5311020',
    name: 'Wawonato',
  },
  {
    id: '5311020030',
    districtId: '5311020',
    name: 'Jejaraja',
  },
  {
    id: '5311020031',
    districtId: '5311020',
    name: 'Wajakea Jaya',
  },
  {
    id: '5311020032',
    districtId: '5311020',
    name: 'Nemboramba',
  },
  {
    id: '5311020033',
    districtId: '5311020',
    name: 'Ranoramba',
  },
  {
    id: '5311020034',
    districtId: '5311020',
    name: 'Peozakaramba',
  },
  {
    id: '5311020035',
    districtId: '5311020',
    name: 'Uzuramba Barat',
  },
  {
    id: '5311030001',
    districtId: '5311030',
    name: 'Kel. Paupanda',
  },
  {
    id: '5311030002',
    districtId: '5311030',
    name: 'Kel. Rukunlima',
  },
  {
    id: '5311030003',
    districtId: '5311030',
    name: 'Kel. Mbongawani',
  },
  {
    id: '5311030004',
    districtId: '5311030',
    name: 'Kel. Tetandara',
  },
  {
    id: '5311030005',
    districtId: '5311030',
    name: 'Kel. Tanjung',
  },
  {
    id: '5311031001',
    districtId: '5311031',
    name: 'Kel. Mautapaga',
  },
  {
    id: '5311031002',
    districtId: '5311031',
    name: 'Kel. Rewarangga',
  },
  {
    id: '5311031003',
    districtId: '5311031',
    name: 'Kedebodu',
  },
  {
    id: '5311031004',
    districtId: '5311031',
    name: 'Ndungga',
  },
  {
    id: '5311031005',
    districtId: '5311031',
    name: 'Tiwutewa',
  },
  {
    id: '5311031006',
    districtId: '5311031',
    name: 'Kel. Rewarangga Selatan',
  },
  {
    id: '5311032001',
    districtId: '5311032',
    name: 'Kel. Potulando',
  },
  {
    id: '5311032002',
    districtId: '5311032',
    name: 'Kel. Onekore',
  },
  {
    id: '5311032003',
    districtId: '5311032',
    name: 'Kel. Kelimutu',
  },
  {
    id: '5311032004',
    districtId: '5311032',
    name: 'Kel. Paupire',
  },
  {
    id: '5311033001',
    districtId: '5311033',
    name: 'Kel. Kotaraja',
  },
  {
    id: '5311033002',
    districtId: '5311033',
    name: 'Kel. Kotaratu',
  },
  {
    id: '5311033003',
    districtId: '5311033',
    name: 'Kel. Roworena',
  },
  {
    id: '5311033004',
    districtId: '5311033',
    name: 'Gheoghoma',
  },
  {
    id: '5311033005',
    districtId: '5311033',
    name: 'Borokanda',
  },
  {
    id: '5311033006',
    districtId: '5311033',
    name: 'Watusipi',
  },
  {
    id: '5311033007',
    districtId: '5311033',
    name: 'Kel. Roworena Barat',
  },
  {
    id: '5311033008',
    districtId: '5311033',
    name: 'Mbomba',
  },
  {
    id: '5311033009',
    districtId: '5311033',
    name: 'Embundoa',
  },
  {
    id: '5311033010',
    districtId: '5311033',
    name: 'Raterua',
  },
  {
    id: '5311040001',
    districtId: '5311040',
    name: 'Nanganesa',
  },
  {
    id: '5311040002',
    districtId: '5311040',
    name: 'Kel. Onelako',
  },
  {
    id: '5311040003',
    districtId: '5311040',
    name: 'Manulondo',
  },
  {
    id: '5311040004',
    districtId: '5311040',
    name: 'Wolotopo',
  },
  {
    id: '5311040005',
    districtId: '5311040',
    name: 'Wolotopo Timur',
  },
  {
    id: '5311040006',
    districtId: '5311040',
    name: 'Ngalupolo',
  },
  {
    id: '5311040007',
    districtId: '5311040',
    name: 'Kekasewa',
  },
  {
    id: '5311040008',
    districtId: '5311040',
    name: 'Nila',
  },
  {
    id: '5311040009',
    districtId: '5311040',
    name: 'Ngaluroga',
  },
  {
    id: '5311040014',
    districtId: '5311040',
    name: 'Puutuga',
  },
  {
    id: '5311040015',
    districtId: '5311040',
    name: 'Kel. Lokoboko',
  },
  {
    id: '5311040017',
    districtId: '5311040',
    name: 'Reka',
  },
  {
    id: '5311040018',
    districtId: '5311040',
    name: 'Wolokota',
  },
  {
    id: '5311040019',
    districtId: '5311040',
    name: 'Kelikiku',
  },
  {
    id: '5311041001',
    districtId: '5311041',
    name: 'Kurulimbu',
  },
  {
    id: '5311041002',
    districtId: '5311041',
    name: 'Sokoria',
  },
  {
    id: '5311041003',
    districtId: '5311041',
    name: 'Demulaka',
  },
  {
    id: '5311041004',
    districtId: '5311041',
    name: 'Roga',
  },
  {
    id: '5311041005',
    districtId: '5311041',
    name: 'Kurulimbu Selatan',
  },
  {
    id: '5311041006',
    districtId: '5311041',
    name: 'Ngguwa',
  },
  {
    id: '5311041007',
    districtId: '5311041',
    name: 'Sokoria Selatan',
  },
  {
    id: '5311050005',
    districtId: '5311050',
    name: 'Mbuliwaralau Utara',
  },
  {
    id: '5311050006',
    districtId: '5311050',
    name: 'Mbuliwaralau',
  },
  {
    id: '5311050015',
    districtId: '5311050',
    name: 'Wolosoko',
  },
  {
    id: '5311050016',
    districtId: '5311050',
    name: 'Bokasape Timur',
  },
  {
    id: '5311050017',
    districtId: '5311050',
    name: 'Bokasape',
  },
  {
    id: '5311050018',
    districtId: '5311050',
    name: 'Wolokoli',
  },
  {
    id: '5311050019',
    districtId: '5311050',
    name: 'Jopu',
  },
  {
    id: '5311050024',
    districtId: '5311050',
    name: 'Mbuliloo',
  },
  {
    id: '5311050025',
    districtId: '5311050',
    name: 'Rindiwawo',
  },
  {
    id: '5311050026',
    districtId: '5311050',
    name: 'Lisedetu',
  },
  {
    id: '5311050027',
    districtId: '5311050',
    name: 'Nualise',
  },
  {
    id: '5311050033',
    districtId: '5311050',
    name: 'Liselowobora',
  },
  {
    id: '5311050036',
    districtId: '5311050',
    name: 'Likanaka',
  },
  {
    id: '5311050037',
    districtId: '5311050',
    name: 'Nakambara',
  },
  {
    id: '5311050038',
    districtId: '5311050',
    name: 'Niramesi',
  },
  {
    id: '5311050039',
    districtId: '5311050',
    name: 'Tana Loo',
  },
  {
    id: '5311050040',
    districtId: '5311050',
    name: 'Lise Puu',
  },
  {
    id: '5311051001',
    districtId: '5311051',
    name: 'Nuamuli',
  },
  {
    id: '5311051002',
    districtId: '5311051',
    name: 'Nggela',
  },
  {
    id: '5311051003',
    districtId: '5311051',
    name: 'Pora',
  },
  {
    id: '5311051004',
    districtId: '5311051',
    name: 'Kel. Wolojita',
  },
  {
    id: '5311051005',
    districtId: '5311051',
    name: 'Tenda',
  },
  {
    id: '5311051006',
    districtId: '5311051',
    name: 'Wiwipemo',
  },
  {
    id: '5311052001',
    districtId: '5311052',
    name: 'Hobatuwa',
  },
  {
    id: '5311052002',
    districtId: '5311052',
    name: 'Kel. Watuneso',
  },
  {
    id: '5311052003',
    districtId: '5311052',
    name: 'Wolosambi',
  },
  {
    id: '5311052004',
    districtId: '5311052',
    name: 'Liabeke',
  },
  {
    id: '5311052005',
    districtId: '5311052',
    name: 'Wololele A',
  },
  {
    id: '5311052006',
    districtId: '5311052',
    name: 'Detupera',
  },
  {
    id: '5311052007',
    districtId: '5311052',
    name: 'Woloaro',
  },
  {
    id: '5311052008',
    districtId: '5311052',
    name: 'Fatamari',
  },
  {
    id: '5311052009',
    districtId: '5311052',
    name: 'Tanaroga',
  },
  {
    id: '5311052010',
    districtId: '5311052',
    name: 'Mbewawora',
  },
  {
    id: '5311052011',
    districtId: '5311052',
    name: 'Ranggatalo',
  },
  {
    id: '5311052012',
    districtId: '5311052',
    name: 'Nualima',
  },
  {
    id: '5311052013',
    districtId: '5311052',
    name: 'Bu Tanalagu',
  },
  {
    id: '5311053001',
    districtId: '5311053',
    name: 'Pemo',
  },
  {
    id: '5311053002',
    districtId: '5311053',
    name: 'Woloara',
  },
  {
    id: '5311053003',
    districtId: '5311053',
    name: 'Koanara',
  },
  {
    id: '5311053004',
    districtId: '5311053',
    name: 'Nuamuri',
  },
  {
    id: '5311053005',
    districtId: '5311053',
    name: 'Nuamuri Barat',
  },
  {
    id: '5311053006',
    districtId: '5311053',
    name: 'Nduaria',
  },
  {
    id: '5311053009',
    districtId: '5311053',
    name: 'Waturaka',
  },
  {
    id: '5311053010',
    districtId: '5311053',
    name: 'Detuena',
  },
  {
    id: '5311053011',
    districtId: '5311053',
    name: 'Wolokelo',
  },
  {
    id: '5311054001',
    districtId: '5311054',
    name: 'Serandori',
  },
  {
    id: '5311054002',
    districtId: '5311054',
    name: 'Maubasa',
  },
  {
    id: '5311054003',
    districtId: '5311054',
    name: 'Maubasa Timur',
  },
  {
    id: '5311054004',
    districtId: '5311054',
    name: 'Wonda',
  },
  {
    id: '5311054005',
    districtId: '5311054',
    name: 'Kelisamba',
  },
  {
    id: '5311054006',
    districtId: '5311054',
    name: 'Maubasa Barat',
  },
  {
    id: '5311054007',
    districtId: '5311054',
    name: 'Lunggaria',
  },
  {
    id: '5311054008',
    districtId: '5311054',
    name: 'Aebara',
  },
  {
    id: '5311054009',
    districtId: '5311054',
    name: 'Ratemangga',
  },
  {
    id: '5311054010',
    districtId: '5311054',
    name: 'Mole',
  },
  {
    id: '5311060016',
    districtId: '5311060',
    name: 'Ranokolo Selatan',
  },
  {
    id: '5311060017',
    districtId: '5311060',
    name: 'Ranokolo',
  },
  {
    id: '5311060018',
    districtId: '5311060',
    name: 'Keliwumbu',
  },
  {
    id: '5311060019',
    districtId: '5311060',
    name: 'Mausambi',
  },
  {
    id: '5311060020',
    districtId: '5311060',
    name: 'Maurole',
  },
  {
    id: '5311060021',
    districtId: '5311060',
    name: 'Watukamba',
  },
  {
    id: '5311060022',
    districtId: '5311060',
    name: 'Aewora',
  },
  {
    id: '5311060023',
    districtId: '5311060',
    name: 'Otogedu',
  },
  {
    id: '5311060025',
    districtId: '5311060',
    name: 'Woloau',
  },
  {
    id: '5311060026',
    districtId: '5311060',
    name: 'Uludala',
  },
  {
    id: '5311060027',
    districtId: '5311060',
    name: 'Niranusa',
  },
  {
    id: '5311060028',
    districtId: '5311060',
    name: 'Ngalukoja',
  },
  {
    id: '5311061005',
    districtId: '5311061',
    name: 'Hangalande',
  },
  {
    id: '5311061006',
    districtId: '5311061',
    name: 'Tou Timur',
  },
  {
    id: '5311061007',
    districtId: '5311061',
    name: 'Tou',
  },
  {
    id: '5311061008',
    districtId: '5311061',
    name: 'Niopanda',
  },
  {
    id: '5311061009',
    districtId: '5311061',
    name: 'Loboniki',
  },
  {
    id: '5311061010',
    districtId: '5311061',
    name: 'Ndondo',
  },
  {
    id: '5311061011',
    districtId: '5311061',
    name: 'Kotabaru',
  },
  {
    id: '5311061012',
    districtId: '5311061',
    name: 'Liselande',
  },
  {
    id: '5311061013',
    districtId: '5311061',
    name: 'Tou Barat',
  },
  {
    id: '5311061014',
    districtId: '5311061',
    name: 'Rangalaka',
  },
  {
    id: '5311061015',
    districtId: '5311061',
    name: 'Pise',
  },
  {
    id: '5311061016',
    districtId: '5311061',
    name: 'Nuanaga',
  },
  {
    id: '5311061017',
    districtId: '5311061',
    name: 'Neotonda',
  },
  {
    id: '5311062001',
    districtId: '5311062',
    name: 'Wolomuku',
  },
  {
    id: '5311062002',
    districtId: '5311062',
    name: 'Detumbewa',
  },
  {
    id: '5311062003',
    districtId: '5311062',
    name: 'Nggesa',
  },
  {
    id: '5311062004',
    districtId: '5311062',
    name: 'Detukeli',
  },
  {
    id: '5311062005',
    districtId: '5311062',
    name: 'Kebesani',
  },
  {
    id: '5311062006',
    districtId: '5311062',
    name: 'Kanganara',
  },
  {
    id: '5311062008',
    districtId: '5311062',
    name: 'Nida',
  },
  {
    id: '5311062009',
    districtId: '5311062',
    name: 'Watunggere',
  },
  {
    id: '5311062010',
    districtId: '5311062',
    name: 'Maurole Selatan',
  },
  {
    id: '5311062012',
    districtId: '5311062',
    name: 'Nggesa Biri',
  },
  {
    id: '5311062013',
    districtId: '5311062',
    name: 'Watunggere Marilonga',
  },
  {
    id: '5311062014',
    districtId: '5311062',
    name: 'Jeo Dua',
  },
  {
    id: '5311063001',
    districtId: '5311063',
    name: 'Wologai Timur',
  },
  {
    id: '5311063002',
    districtId: '5311063',
    name: 'Nggumbelaka',
  },
  {
    id: '5311063005',
    districtId: '5311063',
    name: 'Ndenggarongge',
  },
  {
    id: '5311063006',
    districtId: '5311063',
    name: 'Tanalangi',
  },
  {
    id: '5311063007',
    districtId: '5311063',
    name: 'Taniwoda',
  },
  {
    id: '5311063008',
    districtId: '5311063',
    name: 'Detuara',
  },
  {
    id: '5311063009',
    districtId: '5311063',
    name: 'Tiwusora',
  },
  {
    id: '5311063010',
    districtId: '5311063',
    name: 'Ndikosapu',
  },
  {
    id: '5311063011',
    districtId: '5311063',
    name: 'Kuru Sare',
  },
  {
    id: '5311063012',
    districtId: '5311063',
    name: 'Mukureku Saate',
  },
  {
    id: '5311063013',
    districtId: '5311063',
    name: 'Lisekuru',
  },
  {
    id: '5311063014',
    districtId: '5311063',
    name: 'Rutujeja',
  },
  {
    id: '5311070019',
    districtId: '5311070',
    name: 'Nuaone',
  },
  {
    id: '5311070020',
    districtId: '5311070',
    name: 'Ranga',
  },
  {
    id: '5311070021',
    districtId: '5311070',
    name: 'Wolomage',
  },
  {
    id: '5311070022',
    districtId: '5311070',
    name: 'Golulada',
  },
  {
    id: '5311070023',
    districtId: '5311070',
    name: 'Rateroru',
  },
  {
    id: '5311070024',
    districtId: '5311070',
    name: 'Dile',
  },
  {
    id: '5311070025',
    districtId: '5311070',
    name: 'Roa',
  },
  {
    id: '5311070026',
    districtId: '5311070',
    name: 'Wolotolo',
  },
  {
    id: '5311070027',
    districtId: '5311070',
    name: 'Wolotolo Tengah',
  },
  {
    id: '5311070028',
    districtId: '5311070',
    name: 'Randoria',
  },
  {
    id: '5311070029',
    districtId: '5311070',
    name: 'Wolomasi',
  },
  {
    id: '5311070030',
    districtId: '5311070',
    name: 'Saga',
  },
  {
    id: '5311070031',
    districtId: '5311070',
    name: 'Ndito',
  },
  {
    id: '5311070032',
    districtId: '5311070',
    name: 'Niowula',
  },
  {
    id: '5311070033',
    districtId: '5311070',
    name: 'Wolofeo',
  },
  {
    id: '5311070034',
    districtId: '5311070',
    name: 'Sipijena',
  },
  {
    id: '5311070035',
    districtId: '5311070',
    name: 'Detusoko Barat',
  },
  {
    id: '5311070036',
    districtId: '5311070',
    name: 'Kel. Detusoko',
  },
  {
    id: '5311070037',
    districtId: '5311070',
    name: 'Wologai',
  },
  {
    id: '5311070038',
    districtId: '5311070',
    name: 'Wologai Tengah',
  },
  {
    id: '5311070041',
    districtId: '5311070',
    name: 'Turunalu',
  },
  {
    id: '5311071001',
    districtId: '5311071',
    name: 'Mbotulaka',
  },
  {
    id: '5311071002',
    districtId: '5311071',
    name: 'Mautenda Barat',
  },
  {
    id: '5311071003',
    districtId: '5311071',
    name: 'Ratewati',
  },
  {
    id: '5311071004',
    districtId: '5311071',
    name: 'Mukusaki',
  },
  {
    id: '5311071005',
    districtId: '5311071',
    name: 'Aemuri',
  },
  {
    id: '5311071006',
    districtId: '5311071',
    name: 'Ekoae',
  },
  {
    id: '5311071007',
    districtId: '5311071',
    name: 'Wewaria',
  },
  {
    id: '5311071008',
    districtId: '5311071',
    name: 'Mautenda',
  },
  {
    id: '5311071009',
    districtId: '5311071',
    name: 'Fataatu',
  },
  {
    id: '5311071010',
    districtId: '5311071',
    name: 'Fataatu Timur',
  },
  {
    id: '5311071011',
    districtId: '5311071',
    name: 'Nuangenda',
  },
  {
    id: '5311071012',
    districtId: '5311071',
    name: 'Welamosa',
  },
  {
    id: '5311071013',
    districtId: '5311071',
    name: 'Tanali',
  },
  {
    id: '5311071014',
    districtId: '5311071',
    name: 'Detubela',
  },
  {
    id: '5311071015',
    districtId: '5311071',
    name: 'Numba',
  },
  {
    id: '5311071016',
    districtId: '5311071',
    name: 'Kelitembu',
  },
  {
    id: '5311071017',
    districtId: '5311071',
    name: 'Aelipo',
  },
  {
    id: '5311071018',
    districtId: '5311071',
    name: 'Ratewati Selatan',
  },
  {
    id: '5311071019',
    districtId: '5311071',
    name: 'Waka',
  },
  {
    id: '5311071020',
    districtId: '5311071',
    name: 'Wolooja',
  },
  {
    id: '5311071021',
    districtId: '5311071',
    name: 'Ekolea',
  },
  {
    id: '5311071022',
    districtId: '5311071',
    name: 'Ae Ndoko',
  },
  {
    id: '5312010014',
    districtId: '5312010',
    name: 'Foa',
  },
  {
    id: '5312010015',
    districtId: '5312010',
    name: 'Aimere Timur',
  },
  {
    id: '5312010016',
    districtId: '5312010',
    name: 'Aimere',
  },
  {
    id: '5312010017',
    districtId: '5312010',
    name: 'Keligejo',
  },
  {
    id: '5312010018',
    districtId: '5312010',
    name: 'Heawea',
  },
  {
    id: '5312010019',
    districtId: '5312010',
    name: 'Lekogoko',
  },
  {
    id: '5312010020',
    districtId: '5312010',
    name: 'Legelapu',
  },
  {
    id: '5312010021',
    districtId: '5312010',
    name: 'Binawali',
  },
  {
    id: '5312010022',
    districtId: '5312010',
    name: 'Kila',
  },
  {
    id: '5312010023',
    districtId: '5312010',
    name: 'Waesae',
  },
  {
    id: '5312011001',
    districtId: '5312011',
    name: 'Dariwali',
  },
  {
    id: '5312011002',
    districtId: '5312011',
    name: 'Naruwolo',
  },
  {
    id: '5312011003',
    districtId: '5312011',
    name: 'Tiworiwu',
  },
  {
    id: '5312011004',
    districtId: '5312011',
    name: 'Watumanu',
  },
  {
    id: '5312011005',
    districtId: '5312011',
    name: 'Nenowea',
  },
  {
    id: '5312011007',
    districtId: '5312011',
    name: 'Naruwolo I',
  },
  {
    id: '5312011008',
    districtId: '5312011',
    name: 'Naruwolo II',
  },
  {
    id: '5312011009',
    districtId: '5312011',
    name: 'Dariwali I',
  },
  {
    id: '5312011010',
    districtId: '5312011',
    name: 'Nio Lewa',
  },
  {
    id: '5312011011',
    districtId: '5312011',
    name: 'Tiworiwu I',
  },
  {
    id: '5312011012',
    districtId: '5312011',
    name: 'Tiworiwu II',
  },
  {
    id: '5312011013',
    districtId: '5312011',
    name: 'Batajawa',
  },
  {
    id: '5312012001',
    districtId: '5312012',
    name: 'Paupaga',
  },
  {
    id: '5312012002',
    districtId: '5312012',
    name: 'Sebowuli',
  },
  {
    id: '5312012003',
    districtId: '5312012',
    name: 'Inerie',
  },
  {
    id: '5312012004',
    districtId: '5312012',
    name: 'Warupele II',
  },
  {
    id: '5312012005',
    districtId: '5312012',
    name: 'Warupele I',
  },
  {
    id: '5312012006',
    districtId: '5312012',
    name: 'Kelitei',
  },
  {
    id: '5312012007',
    districtId: '5312012',
    name: 'Manubhara',
  },
  {
    id: '5312012008',
    districtId: '5312012',
    name: 'Tiwurana',
  },
  {
    id: '5312012009',
    districtId: '5312012',
    name: 'Waebela',
  },
  {
    id: '5312012010',
    districtId: '5312012',
    name: 'Legeriwu',
  },
  {
    id: '5312020001',
    districtId: '5312020',
    name: 'Bajawa',
  },
  {
    id: '5312020002',
    districtId: '5312020',
    name: 'Faobata',
  },
  {
    id: '5312020003',
    districtId: '5312020',
    name: 'Tanalodu',
  },
  {
    id: '5312020004',
    districtId: '5312020',
    name: 'Kisanata',
  },
  {
    id: '5312020005',
    districtId: '5312020',
    name: 'Jawameze',
  },
  {
    id: '5312020006',
    districtId: '5312020',
    name: 'Trikora',
  },
  {
    id: '5312020008',
    districtId: '5312020',
    name: 'Lebijaga',
  },
  {
    id: '5312020010',
    districtId: '5312020',
    name: 'Beja',
  },
  {
    id: '5312020011',
    districtId: '5312020',
    name: 'Bomari',
  },
  {
    id: '5312020012',
    districtId: '5312020',
    name: 'Ubedolumolo',
  },
  {
    id: '5312020013',
    districtId: '5312020',
    name: 'Beiwali',
  },
  {
    id: '5312020014',
    districtId: '5312020',
    name: 'Wawowae',
  },
  {
    id: '5312020015',
    districtId: '5312020',
    name: 'Naru',
  },
  {
    id: '5312020016',
    districtId: '5312020',
    name: 'Borani',
  },
  {
    id: '5312020017',
    districtId: '5312020',
    name: 'Langagedha',
  },
  {
    id: '5312020018',
    districtId: '5312020',
    name: 'Pape',
  },
  {
    id: '5312020019',
    districtId: '5312020',
    name: 'Bowali',
  },
  {
    id: '5312020020',
    districtId: '5312020',
    name: 'Ngoranale',
  },
  {
    id: '5312020021',
    districtId: '5312020',
    name: 'Bela',
  },
  {
    id: '5312020022',
    districtId: '5312020',
    name: 'Ubedolumolo I',
  },
  {
    id: '5312030007',
    districtId: '5312030',
    name: 'Sarasedu',
  },
  {
    id: '5312030008',
    districtId: '5312030',
    name: 'Malanuza',
  },
  {
    id: '5312030009',
    districtId: '5312030',
    name: 'Todabelu',
  },
  {
    id: '5312030010',
    districtId: '5312030',
    name: 'Ratogesa',
  },
  {
    id: '5312030011',
    districtId: '5312030',
    name: 'Dadawea',
  },
  {
    id: '5312030012',
    districtId: '5312030',
    name: 'Were I',
  },
  {
    id: '5312030013',
    districtId: '5312030',
    name: 'Radabata',
  },
  {
    id: '5312030019',
    districtId: '5312030',
    name: 'Mataloko',
  },
  {
    id: '5312030020',
    districtId: '5312030',
    name: 'Sangadeto',
  },
  {
    id: '5312030027',
    districtId: '5312030',
    name: 'Were IV',
  },
  {
    id: '5312030030',
    districtId: '5312030',
    name: 'Sarasedu I',
  },
  {
    id: '5312030031',
    districtId: '5312030',
    name: 'Malanuza I',
  },
  {
    id: '5312030033',
    districtId: '5312030',
    name: 'Eko Roka',
  },
  {
    id: '5312030034',
    districtId: '5312030',
    name: 'Wae Ia',
  },
  {
    id: '5312031001',
    districtId: '5312031',
    name: 'Bawarani',
  },
  {
    id: '5312031002',
    districtId: '5312031',
    name: 'Wogowela',
  },
  {
    id: '5312031003',
    districtId: '5312031',
    name: 'Watusipi',
  },
  {
    id: '5312031004',
    districtId: '5312031',
    name: 'Boba',
  },
  {
    id: '5312031005',
    districtId: '5312031',
    name: 'Boba I',
  },
  {
    id: '5312031006',
    districtId: '5312031',
    name: 'Were II',
  },
  {
    id: '5312031007',
    districtId: '5312031',
    name: 'Were III',
  },
  {
    id: '5312031008',
    districtId: '5312031',
    name: 'Kezewea',
  },
  {
    id: '5312031009',
    districtId: '5312031',
    name: 'Nirmala',
  },
  {
    id: '5312031010',
    districtId: '5312031',
    name: 'Takatunga',
  },
  {
    id: '5312031011',
    districtId: '5312031',
    name: 'Sadha',
  },
  {
    id: '5312031012',
    districtId: '5312031',
    name: 'Radamasa',
  },
  {
    id: '5312032001',
    districtId: '5312032',
    name: 'Bea Pawe',
  },
  {
    id: '5312032002',
    districtId: '5312032',
    name: 'Watunay',
  },
  {
    id: '5312032003',
    districtId: '5312032',
    name: 'Rakateda I',
  },
  {
    id: '5312032004',
    districtId: '5312032',
    name: 'Rakateda II',
  },
  {
    id: '5312032005',
    districtId: '5312032',
    name: 'Dizi Gedha',
  },
  {
    id: '5312032006',
    districtId: '5312032',
    name: 'Sobo',
  },
  {
    id: '5312032007',
    districtId: '5312032',
    name: 'Sobo I',
  },
  {
    id: '5312032008',
    districtId: '5312032',
    name: 'Rakalaba',
  },
  {
    id: '5312032009',
    districtId: '5312032',
    name: 'Mangulewa',
  },
  {
    id: '5312032010',
    districtId: '5312032',
    name: 'Turekisa',
  },
  {
    id: '5312070006',
    districtId: '5312070',
    name: 'Waewea',
  },
  {
    id: '5312070007',
    districtId: '5312070',
    name: 'Uluwae',
  },
  {
    id: '5312070008',
    districtId: '5312070',
    name: 'Inelika',
  },
  {
    id: '5312070017',
    districtId: '5312070',
    name: 'Wololika',
  },
  {
    id: '5312070018',
    districtId: '5312070',
    name: 'Inegena',
  },
  {
    id: '5312070019',
    districtId: '5312070',
    name: 'Watukapu',
  },
  {
    id: '5312070020',
    districtId: '5312070',
    name: 'Nabelena',
  },
  {
    id: '5312070021',
    districtId: '5312070',
    name: 'Uluwae I',
  },
  {
    id: '5312070022',
    districtId: '5312070',
    name: 'Uluwae II',
  },
  {
    id: '5312070023',
    districtId: '5312070',
    name: 'Genamere',
  },
  {
    id: '5312070024',
    districtId: '5312070',
    name: 'Tura Muri',
  },
  {
    id: '5312071001',
    districtId: '5312071',
    name: 'Tarawaja',
  },
  {
    id: '5312071002',
    districtId: '5312071',
    name: 'Loa',
  },
  {
    id: '5312071003',
    districtId: '5312071',
    name: 'Mengeruda',
  },
  {
    id: '5312071004',
    districtId: '5312071',
    name: 'Piga',
  },
  {
    id: '5312071005',
    districtId: '5312071',
    name: 'Masu',
  },
  {
    id: '5312071006',
    districtId: '5312071',
    name: 'Seso',
  },
  {
    id: '5312071007',
    districtId: '5312071',
    name: 'Waepana',
  },
  {
    id: '5312071008',
    districtId: '5312071',
    name: 'Masu Kedhi',
  },
  {
    id: '5312071009',
    districtId: '5312071',
    name: 'Ngabheo',
  },
  {
    id: '5312071010',
    districtId: '5312071',
    name: 'Libunio',
  },
  {
    id: '5312071011',
    districtId: '5312071',
    name: 'Meli Waru',
  },
  {
    id: '5312071012',
    districtId: '5312071',
    name: 'Tarawali',
  },
  {
    id: '5312071013',
    districtId: '5312071',
    name: 'Bogoboa',
  },
  {
    id: '5312071014',
    districtId: '5312071',
    name: 'Piga I',
  },
  {
    id: '5312080006',
    districtId: '5312080',
    name: 'Taen Terong',
  },
  {
    id: '5312080007',
    districtId: '5312080',
    name: 'Rawangkalo',
  },
  {
    id: '5312080008',
    districtId: '5312080',
    name: 'Wangka',
  },
  {
    id: '5312080010',
    districtId: '5312080',
    name: 'Lengkosambi',
  },
  {
    id: '5312080011',
    districtId: '5312080',
    name: 'Tadho',
  },
  {
    id: '5312080012',
    districtId: '5312080',
    name: 'Benteng Tengah',
  },
  {
    id: '5312080013',
    districtId: '5312080',
    name: 'Nangamese',
  },
  {
    id: '5312080014',
    districtId: '5312080',
    name: 'Latung',
  },
  {
    id: '5312080015',
    districtId: '5312080',
    name: 'Sambinasi',
  },
  {
    id: '5312080016',
    districtId: '5312080',
    name: 'Wangka Selatan',
  },
  {
    id: '5312080017',
    districtId: '5312080',
    name: 'Lengkosambi Timur',
  },
  {
    id: '5312080018',
    districtId: '5312080',
    name: 'Lengkosambi Barat',
  },
  {
    id: '5312080019',
    districtId: '5312080',
    name: 'Taen Terong I',
  },
  {
    id: '5312080020',
    districtId: '5312080',
    name: 'Taen Terong II',
  },
  {
    id: '5312080021',
    districtId: '5312080',
    name: 'Lengkosambi Utara',
  },
  {
    id: '5312080022',
    districtId: '5312080',
    name: 'Sambinasi Barat',
  },
  {
    id: '5312081001',
    districtId: '5312081',
    name: 'Wolomeze',
  },
  {
    id: '5312081002',
    districtId: '5312081',
    name: 'Ria',
  },
  {
    id: '5312081003',
    districtId: '5312081',
    name: 'Lanamai',
  },
  {
    id: '5312081004',
    districtId: '5312081',
    name: 'Benteng Tawa',
  },
  {
    id: '5312081005',
    districtId: '5312081',
    name: 'Ngara',
  },
  {
    id: '5312081006',
    districtId: '5312081',
    name: 'Ria I',
  },
  {
    id: '5312081007',
    districtId: '5312081',
    name: 'Wolomeze I',
  },
  {
    id: '5312081008',
    districtId: '5312081',
    name: 'Lanamai I',
  },
  {
    id: '5312081009',
    districtId: '5312081',
    name: 'Benteng Tawa I',
  },
  {
    id: '5312081010',
    districtId: '5312081',
    name: 'Wolomeze II',
  },
  {
    id: '5312082001',
    districtId: '5312082',
    name: 'Turaloa',
  },
  {
    id: '5312082002',
    districtId: '5312082',
    name: 'Mainai',
  },
  {
    id: '5312082003',
    districtId: '5312082',
    name: 'Denatana',
  },
  {
    id: '5312082004',
    districtId: '5312082',
    name: 'Nginamanu',
  },
  {
    id: '5312082005',
    districtId: '5312082',
    name: 'Nginamanu Selatan',
  },
  {
    id: '5312082006',
    districtId: '5312082',
    name: 'Nginamanu Barat',
  },
  {
    id: '5312082008',
    districtId: '5312082',
    name: 'Denatana Timur',
  },
  {
    id: '5313040009',
    districtId: '5313040',
    name: 'Tal',
  },
  {
    id: '5313040010',
    districtId: '5313040',
    name: 'Paka',
  },
  {
    id: '5313040012',
    districtId: '5313040',
    name: 'Langgo',
  },
  {
    id: '5313040013',
    districtId: '5313040',
    name: 'Tado',
  },
  {
    id: '5313040014',
    districtId: '5313040',
    name: 'Koak',
  },
  {
    id: '5313040015',
    districtId: '5313040',
    name: 'Lungar',
  },
  {
    id: '5313040016',
    districtId: '5313040',
    name: 'Golo Muntas',
  },
  {
    id: '5313040017',
    districtId: '5313040',
    name: 'Gara',
  },
  {
    id: '5313040018',
    districtId: '5313040',
    name: 'Wae Ajang',
  },
  {
    id: '5313040019',
    districtId: '5313040',
    name: 'Wewo',
  },
  {
    id: '5313040020',
    districtId: '5313040',
    name: 'Mocok',
  },
  {
    id: '5313040022',
    districtId: '5313040',
    name: 'Ponggeok',
  },
  {
    id: '5313040028',
    districtId: '5313040',
    name: 'Papang',
  },
  {
    id: '5313040029',
    districtId: '5313040',
    name: 'Pongkor',
  },
  {
    id: '5313040034',
    districtId: '5313040',
    name: 'Ngkaer',
  },
  {
    id: '5313040035',
    districtId: '5313040',
    name: 'Golo Lambo',
  },
  {
    id: '5313040036',
    districtId: '5313040',
    name: 'Jaong',
  },
  {
    id: '5313040037',
    districtId: '5313040',
    name: 'Iteng',
  },
  {
    id: '5313040038',
    districtId: '5313040',
    name: 'Satar Loung',
  },
  {
    id: '5313040039',
    districtId: '5313040',
    name: 'Ulu Belang',
  },
  {
    id: '5313040040',
    districtId: '5313040',
    name: 'Lolang',
  },
  {
    id: '5313041001',
    districtId: '5313041',
    name: 'Borik',
  },
  {
    id: '5313041002',
    districtId: '5313041',
    name: 'Satar Ruwuk',
  },
  {
    id: '5313041003',
    districtId: '5313041',
    name: 'Nuca Molas',
  },
  {
    id: '5313041004',
    districtId: '5313041',
    name: 'Satar Lenda',
  },
  {
    id: '5313041005',
    districtId: '5313041',
    name: 'Satar Luju',
  },
  {
    id: '5313041006',
    districtId: '5313041',
    name: 'Ceka Luju',
  },
  {
    id: '5313041007',
    districtId: '5313041',
    name: 'Terong',
  },
  {
    id: '5313041008',
    districtId: '5313041',
    name: 'Hilihintir',
  },
  {
    id: '5313041009',
    districtId: '5313041',
    name: 'Bea Kondo',
  },
  {
    id: '5313041010',
    districtId: '5313041',
    name: 'Golo Ropong',
  },
  {
    id: '5313041021',
    districtId: '5313041',
    name: 'Wongka',
  },
  {
    id: '5313041022',
    districtId: '5313041',
    name: 'Cambir Leca',
  },
  {
    id: '5313042001',
    districtId: '5313042',
    name: 'Renda',
  },
  {
    id: '5313042002',
    districtId: '5313042',
    name: 'Todo',
  },
  {
    id: '5313042004',
    districtId: '5313042',
    name: 'Popo',
  },
  {
    id: '5313042005',
    districtId: '5313042',
    name: 'Lia',
  },
  {
    id: '5313042006',
    districtId: '5313042',
    name: 'Kole',
  },
  {
    id: '5313042007',
    districtId: '5313042',
    name: 'Ling',
  },
  {
    id: '5313042008',
    districtId: '5313042',
    name: 'Nao',
  },
  {
    id: '5313042009',
    districtId: '5313042',
    name: 'Cireng',
  },
  {
    id: '5313042010',
    districtId: '5313042',
    name: 'Ruang',
  },
  {
    id: '5313042011',
    districtId: '5313042',
    name: 'Mata Wae',
  },
  {
    id: '5313110001',
    districtId: '5313110',
    name: 'Golo Dukal',
  },
  {
    id: '5313110002',
    districtId: '5313110',
    name: 'Pau',
  },
  {
    id: '5313110003',
    districtId: '5313110',
    name: 'Waso',
  },
  {
    id: '5313110004',
    districtId: '5313110',
    name: 'Watu',
  },
  {
    id: '5313110005',
    districtId: '5313110',
    name: 'Tenda',
  },
  {
    id: '5313110006',
    districtId: '5313110',
    name: 'Carep',
  },
  {
    id: '5313110007',
    districtId: '5313110',
    name: 'Mbaumuku',
  },
  {
    id: '5313110008',
    districtId: '5313110',
    name: 'Karot',
  },
  {
    id: '5313110009',
    districtId: '5313110',
    name: 'Pitak',
  },
  {
    id: '5313110010',
    districtId: '5313110',
    name: 'Lawir',
  },
  {
    id: '5313110011',
    districtId: '5313110',
    name: 'Wali',
  },
  {
    id: '5313110012',
    districtId: '5313110',
    name: 'Bangka Leda',
  },
  {
    id: '5313110013',
    districtId: '5313110',
    name: 'Rowang',
  },
  {
    id: '5313110014',
    districtId: '5313110',
    name: 'Bangka Nekang',
  },
  {
    id: '5313110015',
    districtId: '5313110',
    name: 'Poco Mal',
  },
  {
    id: '5313110016',
    districtId: '5313110',
    name: 'Satar Tacik',
  },
  {
    id: '5313110017',
    districtId: '5313110',
    name: 'Laci Carep',
  },
  {
    id: '5313110018',
    districtId: '5313110',
    name: 'Compang Carep',
  },
  {
    id: '5313110019',
    districtId: '5313110',
    name: 'Tadong',
  },
  {
    id: '5313110020',
    districtId: '5313110',
    name: 'Compang Tuke',
  },
  {
    id: '5313120004',
    districtId: '5313120',
    name: 'Bulan',
  },
  {
    id: '5313120005',
    districtId: '5313120',
    name: 'Pong Lao',
  },
  {
    id: '5313120006',
    districtId: '5313120',
    name: 'Cumbi',
  },
  {
    id: '5313120007',
    districtId: '5313120',
    name: 'Poco Likang',
  },
  {
    id: '5313120008',
    districtId: '5313120',
    name: 'Pong Murung',
  },
  {
    id: '5313120009',
    districtId: '5313120',
    name: 'Pong Leko',
  },
  {
    id: '5313120011',
    districtId: '5313120',
    name: 'Belang Turi',
  },
  {
    id: '5313120012',
    districtId: '5313120',
    name: 'Goloworok',
  },
  {
    id: '5313120014',
    districtId: '5313120',
    name: 'Wae Belang',
  },
  {
    id: '5313120015',
    districtId: '5313120',
    name: 'Rai',
  },
  {
    id: '5313120017',
    districtId: '5313120',
    name: 'Kakor',
  },
  {
    id: '5313120018',
    districtId: '5313120',
    name: 'Beo Rahong',
  },
  {
    id: '5313120029',
    districtId: '5313120',
    name: 'Bangka Lao',
  },
  {
    id: '5313120030',
    districtId: '5313120',
    name: 'Compang Dalo',
  },
  {
    id: '5313120031',
    districtId: '5313120',
    name: 'Compang Namut',
  },
  {
    id: '5313120032',
    districtId: '5313120',
    name: 'Compang Lale',
  },
  {
    id: '5313120033',
    districtId: '5313120',
    name: 'Bea Kakor',
  },
  {
    id: '5313121001',
    districtId: '5313121',
    name: 'Lalong',
  },
  {
    id: '5313121002',
    districtId: '5313121',
    name: 'Bangka Kenda',
  },
  {
    id: '5313121004',
    districtId: '5313121',
    name: 'Bangka Jong',
  },
  {
    id: '5313121005',
    districtId: '5313121',
    name: 'Wae Rii',
  },
  {
    id: '5313121006',
    districtId: '5313121',
    name: 'Longko',
  },
  {
    id: '5313121007',
    districtId: '5313121',
    name: 'Ranaka',
  },
  {
    id: '5313121008',
    districtId: '5313121',
    name: 'Golo Mendo',
  },
  {
    id: '5313121009',
    districtId: '5313121',
    name: 'Golo Cador',
  },
  {
    id: '5313121010',
    districtId: '5313121',
    name: 'Compang Ndehes',
  },
  {
    id: '5313121011',
    districtId: '5313121',
    name: 'Poco',
  },
  {
    id: '5313121012',
    districtId: '5313121',
    name: 'Satar Ngkeling',
  },
  {
    id: '5313121013',
    districtId: '5313121',
    name: 'Golo Wua',
  },
  {
    id: '5313121014',
    districtId: '5313121',
    name: 'Golo Watu',
  },
  {
    id: '5313121015',
    districtId: '5313121',
    name: 'Ranggi',
  },
  {
    id: '5313121016',
    districtId: '5313121',
    name: 'Wae Mulu',
  },
  {
    id: '5313121017',
    districtId: '5313121',
    name: 'Benteng Poco',
  },
  {
    id: '5313122001',
    districtId: '5313122',
    name: 'Urang',
  },
  {
    id: '5313122002',
    districtId: '5313122',
    name: 'Ketang',
  },
  {
    id: '5313122003',
    districtId: '5313122',
    name: 'Bangka Lelak',
  },
  {
    id: '5313122004',
    districtId: '5313122',
    name: 'Gelong',
  },
  {
    id: '5313122005',
    districtId: '5313122',
    name: 'Pong Umpu',
  },
  {
    id: '5313122006',
    districtId: '5313122',
    name: 'Ndiwar',
  },
  {
    id: '5313122007',
    districtId: '5313122',
    name: 'Nati',
  },
  {
    id: '5313122008',
    districtId: '5313122',
    name: 'Bangka Dese',
  },
  {
    id: '5313122009',
    districtId: '5313122',
    name: 'Lentang',
  },
  {
    id: '5313122010',
    districtId: '5313122',
    name: 'Bangka Tonggur',
  },
  {
    id: '5313123001',
    districtId: '5313123',
    name: 'Pong Lengor',
  },
  {
    id: '5313123002',
    districtId: '5313123',
    name: 'Dimpong',
  },
  {
    id: '5313123004',
    districtId: '5313123',
    name: 'Golo Langkok',
  },
  {
    id: '5313123005',
    districtId: '5313123',
    name: 'Compang Dari',
  },
  {
    id: '5313123006',
    districtId: '5313123',
    name: 'Liang Bua',
  },
  {
    id: '5313123007',
    districtId: '5313123',
    name: 'Bangka Ajang',
  },
  {
    id: '5313123008',
    districtId: '5313123',
    name: 'Buar',
  },
  {
    id: '5313123009',
    districtId: '5313123',
    name: 'Benteng Tubi',
  },
  {
    id: '5313123010',
    districtId: '5313123',
    name: 'Manong',
  },
  {
    id: '5313123011',
    districtId: '5313123',
    name: 'Bangka Ruang',
  },
  {
    id: '5313123012',
    districtId: '5313123',
    name: 'Wae Mantang',
  },
  {
    id: '5313130003',
    districtId: '5313130',
    name: 'Wudi',
  },
  {
    id: '5313130004',
    districtId: '5313130',
    name: 'Rado',
  },
  {
    id: '5313130006',
    districtId: '5313130',
    name: 'Barang',
  },
  {
    id: '5313130007',
    districtId: '5313130',
    name: 'Pinggang',
  },
  {
    id: '5313130008',
    districtId: '5313130',
    name: 'Golo',
  },
  {
    id: '5313130009',
    districtId: '5313130',
    name: 'Pagal',
  },
  {
    id: '5313130012',
    districtId: '5313130',
    name: 'Gapong',
  },
  {
    id: '5313130013',
    districtId: '5313130',
    name: 'Perak',
  },
  {
    id: '5313130014',
    districtId: '5313130',
    name: 'Bea Mese',
  },
  {
    id: '5313130015',
    districtId: '5313130',
    name: 'Lando',
  },
  {
    id: '5313130016',
    districtId: '5313130',
    name: 'Langkas',
  },
  {
    id: '5313130017',
    districtId: '5313130',
    name: 'Kentol',
  },
  {
    id: '5313130021',
    districtId: '5313130',
    name: 'Riung',
  },
  {
    id: '5313130022',
    districtId: '5313130',
    name: 'Ladur',
  },
  {
    id: '5313130027',
    districtId: '5313130',
    name: 'Golo Ncuang',
  },
  {
    id: '5313131002',
    districtId: '5313131',
    name: 'Lenda',
  },
  {
    id: '5313131003',
    districtId: '5313131',
    name: 'Compang Cibal',
  },
  {
    id: '5313131004',
    districtId: '5313131',
    name: 'Bangka Ara',
  },
  {
    id: '5313131005',
    districtId: '5313131',
    name: 'Wae Codi',
  },
  {
    id: '5313131006',
    districtId: '5313131',
    name: 'Timbu',
  },
  {
    id: '5313131007',
    districtId: '5313131',
    name: 'Golo Woi',
  },
  {
    id: '5313131008',
    districtId: '5313131',
    name: 'Wae Renca',
  },
  {
    id: '5313131009',
    districtId: '5313131',
    name: 'Latung',
  },
  {
    id: '5313131010',
    districtId: '5313131',
    name: 'Golo Lanak',
  },
  {
    id: '5313140007',
    districtId: '5313140',
    name: 'Watu Tango',
  },
  {
    id: '5313140008',
    districtId: '5313140',
    name: 'Bajak',
  },
  {
    id: '5313140009',
    districtId: '5313140',
    name: 'Ruis',
  },
  {
    id: '5313140010',
    districtId: '5313140',
    name: 'Mata Air',
  },
  {
    id: '5313140011',
    districtId: '5313140',
    name: 'Salama',
  },
  {
    id: '5313140012',
    districtId: '5313140',
    name: 'Reo',
  },
  {
    id: '5313140013',
    districtId: '5313140',
    name: 'Baru',
  },
  {
    id: '5313140014',
    districtId: '5313140',
    name: 'Wangkung',
  },
  {
    id: '5313140015',
    districtId: '5313140',
    name: 'Robek',
  },
  {
    id: '5313140016',
    districtId: '5313140',
    name: 'Watu Baur',
  },
  {
    id: '5313141001',
    districtId: '5313141',
    name: 'Nggalak',
  },
  {
    id: '5313141002',
    districtId: '5313141',
    name: 'Lante',
  },
  {
    id: '5313141003',
    districtId: '5313141',
    name: 'Sambi',
  },
  {
    id: '5313141004',
    districtId: '5313141',
    name: 'Loce',
  },
  {
    id: '5313141005',
    districtId: '5313141',
    name: 'Torong Koe',
  },
  {
    id: '5313141006',
    districtId: '5313141',
    name: 'Rura',
  },
  {
    id: '5313141007',
    districtId: '5313141',
    name: 'Toe',
  },
  {
    id: '5313141008',
    districtId: '5313141',
    name: 'Wae Kajong',
  },
  {
    id: '5313141009',
    districtId: '5313141',
    name: 'Para Lando',
  },
  {
    id: '5313141010',
    districtId: '5313141',
    name: 'Lemarang',
  },
  {
    id: '5314010005',
    districtId: '5314010',
    name: 'Oeseli',
  },
  {
    id: '5314010006',
    districtId: '5314010',
    name: 'Oebou',
  },
  {
    id: '5314010007',
    districtId: '5314010',
    name: 'Lalukoen',
  },
  {
    id: '5314010008',
    districtId: '5314010',
    name: 'Oeteffu',
  },
  {
    id: '5314010009',
    districtId: '5314010',
    name: 'Oehandi',
  },
  {
    id: '5314010010',
    districtId: '5314010',
    name: 'Meoain',
  },
  {
    id: '5314010011',
    districtId: '5314010',
    name: 'Oebaffok',
  },
  {
    id: '5314010012',
    districtId: '5314010',
    name: 'Batutua',
  },
  {
    id: '5314010013',
    districtId: '5314010',
    name: 'Dolasi',
  },
  {
    id: '5314010014',
    districtId: '5314010',
    name: 'Lekik',
  },
  {
    id: '5314010015',
    districtId: '5314010',
    name: 'Oebatu',
  },
  {
    id: '5314010016',
    districtId: '5314010',
    name: 'Mbokak',
  },
  {
    id: '5314010017',
    districtId: '5314010',
    name: 'Oelasin',
  },
  {
    id: '5314010018',
    districtId: '5314010',
    name: 'Landu',
  },
  {
    id: '5314020003',
    districtId: '5314020',
    name: 'Lidor',
  },
  {
    id: '5314020004',
    districtId: '5314020',
    name: 'Temas',
  },
  {
    id: '5314020005',
    districtId: '5314020',
    name: 'Modosinal',
  },
  {
    id: '5314020006',
    districtId: '5314020',
    name: 'Busalangga',
  },
  {
    id: '5314020007',
    districtId: '5314020',
    name: 'Oetutulu',
  },
  {
    id: '5314020008',
    districtId: '5314020',
    name: 'Daudolu',
  },
  {
    id: '5314020009',
    districtId: '5314020',
    name: 'Netenaen',
  },
  {
    id: '5314020010',
    districtId: '5314020',
    name: 'Ingguinak',
  },
  {
    id: '5314020011',
    districtId: '5314020',
    name: 'Oelua',
  },
  {
    id: '5314020012',
    districtId: '5314020',
    name: 'Tolama',
  },
  {
    id: '5314020013',
    districtId: '5314020',
    name: 'Oebela',
  },
  {
    id: '5314020014',
    districtId: '5314020',
    name: 'Boni',
  },
  {
    id: '5314020015',
    districtId: '5314020',
    name: 'Tualima',
  },
  {
    id: '5314030001',
    districtId: '5314030',
    name: 'Kuli',
  },
  {
    id: '5314030002',
    districtId: '5314030',
    name: 'Suelain',
  },
  {
    id: '5314030003',
    districtId: '5314030',
    name: 'Bebalain',
  },
  {
    id: '5314030004',
    districtId: '5314030',
    name: 'Kolobolon',
  },
  {
    id: '5314030005',
    districtId: '5314030',
    name: 'Oematamboli',
  },
  {
    id: '5314030006',
    districtId: '5314030',
    name: 'Helebeik',
  },
  {
    id: '5314030007',
    districtId: '5314030',
    name: 'Oelunggu',
  },
  {
    id: '5314030008',
    districtId: '5314030',
    name: 'Mokdale',
  },
  {
    id: '5314030009',
    districtId: '5314030',
    name: 'Sanggaoen',
  },
  {
    id: '5314030010',
    districtId: '5314030',
    name: 'Holoama',
  },
  {
    id: '5314030011',
    districtId: '5314030',
    name: 'Tuanatuk',
  },
  {
    id: '5314030012',
    districtId: '5314030',
    name: 'Baadale',
  },
  {
    id: '5314030013',
    districtId: '5314030',
    name: 'Namodale',
  },
  {
    id: '5314030014',
    districtId: '5314030',
    name: 'Metina',
  },
  {
    id: '5314040006',
    districtId: '5314040',
    name: 'Lidabesi',
  },
  {
    id: '5314040007',
    districtId: '5314040',
    name: 'Limakoli',
  },
  {
    id: '5314040008',
    districtId: '5314040',
    name: 'Suebela',
  },
  {
    id: '5314040009',
    districtId: '5314040',
    name: 'Nggodimeda',
  },
  {
    id: '5314040010',
    districtId: '5314040',
    name: 'Lidamanu',
  },
  {
    id: '5314040011',
    districtId: '5314040',
    name: 'Maubesi',
  },
  {
    id: '5314040012',
    districtId: '5314040',
    name: 'Onotali',
  },
  {
    id: '5314041001',
    districtId: '5314041',
    name: 'Inaoe',
  },
  {
    id: '5314041002',
    districtId: '5314041',
    name: 'Dodaek',
  },
  {
    id: '5314041003',
    districtId: '5314041',
    name: 'Tebole',
  },
  {
    id: '5314041004',
    districtId: '5314041',
    name: 'Daleholu',
  },
  {
    id: '5314050001',
    districtId: '5314050',
    name: 'Nusakdale',
  },
  {
    id: '5314050002',
    districtId: '5314050',
    name: 'Batulilok',
  },
  {
    id: '5314050004',
    districtId: '5314050',
    name: 'Sonimanu',
  },
  {
    id: '5314050005',
    districtId: '5314050',
    name: 'Oebau',
  },
  {
    id: '5314050006',
    districtId: '5314050',
    name: 'Oeledo',
  },
  {
    id: '5314050007',
    districtId: '5314050',
    name: 'Keoen',
  },
  {
    id: '5314050008',
    districtId: '5314050',
    name: 'Edalode',
  },
  {
    id: '5314050009',
    districtId: '5314050',
    name: 'Olafulihaa',
  },
  {
    id: '5314050010',
    districtId: '5314050',
    name: 'Tunganamo',
  },
  {
    id: '5314050011',
    districtId: '5314050',
    name: 'Tesabela',
  },
  {
    id: '5314060001',
    districtId: '5314060',
    name: 'Lakamola',
  },
  {
    id: '5314060003',
    districtId: '5314060',
    name: 'Faifua',
  },
  {
    id: '5314060004',
    districtId: '5314060',
    name: 'Hundi Hopo',
  },
  {
    id: '5314060005',
    districtId: '5314060',
    name: 'Londalusi',
  },
  {
    id: '5314060006',
    districtId: '5314060',
    name: 'Serubeba',
  },
  {
    id: '5314060007',
    districtId: '5314060',
    name: 'Matasio',
  },
  {
    id: '5314061001',
    districtId: '5314061',
    name: 'Bolatena',
  },
  {
    id: '5314061002',
    districtId: '5314061',
    name: 'Sotimori',
  },
  {
    id: '5314061003',
    districtId: '5314061',
    name: 'Daiama',
  },
  {
    id: '5314061004',
    districtId: '5314061',
    name: 'Lifuleo',
  },
  {
    id: '5314061005',
    districtId: '5314061',
    name: 'Daurendale',
  },
  {
    id: '5314061006',
    districtId: '5314061',
    name: 'Pukuafu',
  },
  {
    id: '5314070001',
    districtId: '5314070',
    name: 'Oenggaut',
  },
  {
    id: '5314070002',
    districtId: '5314070',
    name: 'Nemberala',
  },
  {
    id: '5314070003',
    districtId: '5314070',
    name: 'Sedeoen',
  },
  {
    id: '5314070004',
    districtId: '5314070',
    name: 'Boa',
  },
  {
    id: '5314070005',
    districtId: '5314070',
    name: 'Oenitas',
  },
  {
    id: '5314070006',
    districtId: '5314070',
    name: 'Oelolot',
  },
  {
    id: '5314070007',
    districtId: '5314070',
    name: 'Mbueain',
  },
  {
    id: '5314071001',
    districtId: '5314071',
    name: 'Ndao Nuse',
  },
  {
    id: '5314071002',
    districtId: '5314071',
    name: 'Mbiu Lombo',
  },
  {
    id: '5314071003',
    districtId: '5314071',
    name: 'Mbali Lendeiki',
  },
  {
    id: '5314071004',
    districtId: '5314071',
    name: 'Anarae',
  },
  {
    id: '5315010001',
    districtId: '5315010',
    name: 'Komodo',
  },
  {
    id: '5315010002',
    districtId: '5315010',
    name: 'Papa Garang',
  },
  {
    id: '5315010003',
    districtId: '5315010',
    name: 'Pasir Panjang',
  },
  {
    id: '5315010004',
    districtId: '5315010',
    name: 'Golo Mori',
  },
  {
    id: '5315010005',
    districtId: '5315010',
    name: 'Warloka',
  },
  {
    id: '5315010006',
    districtId: '5315010',
    name: 'Tiwu Nampar',
  },
  {
    id: '5315010007',
    districtId: '5315010',
    name: 'Golo Pongkor',
  },
  {
    id: '5315010008',
    districtId: '5315010',
    name: 'Macang Tanggar',
  },
  {
    id: '5315010009',
    districtId: '5315010',
    name: 'Pasir Putih',
  },
  {
    id: '5315010010',
    districtId: '5315010',
    name: 'Goron Talo',
  },
  {
    id: '5315010011',
    districtId: '5315010',
    name: 'Golo Bilas',
  },
  {
    id: '5315010012',
    districtId: '5315010',
    name: 'Nggorang',
  },
  {
    id: '5315010013',
    districtId: '5315010',
    name: 'Watu Nggelek',
  },
  {
    id: '5315010023',
    districtId: '5315010',
    name: 'Wae Kelambu',
  },
  {
    id: '5315010024',
    districtId: '5315010',
    name: 'Batu Cermin',
  },
  {
    id: '5315010025',
    districtId: '5315010',
    name: 'Labuan Bajo',
  },
  {
    id: '5315010026',
    districtId: '5315010',
    name: 'Pantar',
  },
  {
    id: '5315010027',
    districtId: '5315010',
    name: 'Seraya Maranu',
  },
  {
    id: '5315010028',
    districtId: '5315010',
    name: 'Compang Longgo',
  },
  {
    id: '5315011001',
    districtId: '5315011',
    name: 'Pota Wangka',
  },
  {
    id: '5315011002',
    districtId: '5315011',
    name: 'Golo Ketak',
  },
  {
    id: '5315011003',
    districtId: '5315011',
    name: 'Mbuit',
  },
  {
    id: '5315011004',
    districtId: '5315011',
    name: 'Golo Lujang',
  },
  {
    id: '5315011005',
    districtId: '5315011',
    name: 'Sepang',
  },
  {
    id: '5315011006',
    districtId: '5315011',
    name: 'Golo Sepang',
  },
  {
    id: '5315011007',
    districtId: '5315011',
    name: 'Tanjung Pontianak',
  },
  {
    id: '5315011008',
    districtId: '5315011',
    name: 'Batu Tiga',
  },
  {
    id: '5315011009',
    districtId: '5315011',
    name: 'Tanjung Boleng',
  },
  {
    id: '5315011010',
    districtId: '5315011',
    name: 'Golo Nobo',
  },
  {
    id: '5315011011',
    districtId: '5315011',
    name: 'Beo Sepang',
  },
  {
    id: '5315020001',
    districtId: '5315020',
    name: 'Mata Wae',
  },
  {
    id: '5315020002',
    districtId: '5315020',
    name: 'Wae Sano',
  },
  {
    id: '5315020003',
    districtId: '5315020',
    name: 'Sano Nggoang',
  },
  {
    id: '5315020004',
    districtId: '5315020',
    name: 'Golo Sengang',
  },
  {
    id: '5315020005',
    districtId: '5315020',
    name: 'Golo Mbu',
  },
  {
    id: '5315020006',
    districtId: '5315020',
    name: 'Golo Manting',
  },
  {
    id: '5315020007',
    districtId: '5315020',
    name: 'Golo Ndaring',
  },
  {
    id: '5315020008',
    districtId: '5315020',
    name: 'Golo Kempo',
  },
  {
    id: '5315020009',
    districtId: '5315020',
    name: 'Nampar Macing',
  },
  {
    id: '5315020010',
    districtId: '5315020',
    name: 'Golo Leleng',
  },
  {
    id: '5315020019',
    districtId: '5315020',
    name: 'Wae Lolos',
  },
  {
    id: '5315020020',
    districtId: '5315020',
    name: 'Pulau Nuncung',
  },
  {
    id: '5315020021',
    districtId: '5315020',
    name: 'Golo Kondeng',
  },
  {
    id: '5315020022',
    districtId: '5315020',
    name: 'Watu Panggal',
  },
  {
    id: '5315020023',
    districtId: '5315020',
    name: 'Poco Golo Kempo',
  },
  {
    id: '5315021001',
    districtId: '5315021',
    name: 'Liang Ndara',
  },
  {
    id: '5315021002',
    districtId: '5315021',
    name: 'Tondong Belang',
  },
  {
    id: '5315021003',
    districtId: '5315021',
    name: 'Cunca Lolos',
  },
  {
    id: '5315021004',
    districtId: '5315021',
    name: 'Golo Damu',
  },
  {
    id: '5315021005',
    districtId: '5315021',
    name: 'Golo Desat',
  },
  {
    id: '5315021006',
    districtId: '5315021',
    name: 'Kempo',
  },
  {
    id: '5315021007',
    districtId: '5315021',
    name: 'Golo Tantong',
  },
  {
    id: '5315021008',
    districtId: '5315021',
    name: 'Wae Jare',
  },
  {
    id: '5315021009',
    districtId: '5315021',
    name: 'Watu Wangka',
  },
  {
    id: '5315021010',
    districtId: '5315021',
    name: 'Golo Sembea',
  },
  {
    id: '5315021011',
    districtId: '5315021',
    name: 'Golo Ndoal',
  },
  {
    id: '5315021012',
    districtId: '5315021',
    name: 'Tiwu Riwung',
  },
  {
    id: '5315021013',
    districtId: '5315021',
    name: 'Cunca Wulang',
  },
  {
    id: '5315021014',
    districtId: '5315021',
    name: 'Compang Liang Ndara',
  },
  {
    id: '5315021015',
    districtId: '5315021',
    name: 'Watu Galang',
  },
  {
    id: '5315030011',
    districtId: '5315030',
    name: 'Tangge',
  },
  {
    id: '5315030012',
    districtId: '5315030',
    name: 'Siru',
  },
  {
    id: '5315030013',
    districtId: '5315030',
    name: 'Wae Wako',
  },
  {
    id: '5315030014',
    districtId: '5315030',
    name: 'Poco Rutang',
  },
  {
    id: '5315030015',
    districtId: '5315030',
    name: 'Daleng',
  },
  {
    id: '5315030016',
    districtId: '5315030',
    name: 'Pong Majok',
  },
  {
    id: '5315030017',
    districtId: '5315030',
    name: 'Ngancar',
  },
  {
    id: '5315030018',
    districtId: '5315030',
    name: 'Ponto Ara',
  },
  {
    id: '5315030019',
    districtId: '5315030',
    name: 'Wae Bangka',
  },
  {
    id: '5315030020',
    districtId: '5315030',
    name: 'Wae Kanta',
  },
  {
    id: '5315030021',
    districtId: '5315030',
    name: 'Pondo',
  },
  {
    id: '5315030022',
    districtId: '5315030',
    name: 'Poco Dedeng',
  },
  {
    id: '5315030023',
    districtId: '5315030',
    name: 'Golo Ndeweng',
  },
  {
    id: '5315030024',
    districtId: '5315030',
    name: 'Liang Sola',
  },
  {
    id: '5315030025',
    districtId: '5315030',
    name: 'Wae Mowol',
  },
  {
    id: '5315031001',
    districtId: '5315031',
    name: 'Galang',
  },
  {
    id: '5315031002',
    districtId: '5315031',
    name: 'Pong Welak',
  },
  {
    id: '5315031003',
    districtId: '5315031',
    name: 'Rehak',
  },
  {
    id: '5315031004',
    districtId: '5315031',
    name: 'Orong',
  },
  {
    id: '5315031006',
    districtId: '5315031',
    name: 'Lale',
  },
  {
    id: '5315031007',
    districtId: '5315031',
    name: 'Golo Ronggot',
  },
  {
    id: '5315031008',
    districtId: '5315031',
    name: 'Watu Umpu',
  },
  {
    id: '5315031009',
    districtId: '5315031',
    name: 'Dunta',
  },
  {
    id: '5315031010',
    districtId: '5315031',
    name: 'Semang',
  },
  {
    id: '5315031011',
    districtId: '5315031',
    name: 'Pengka',
  },
  {
    id: '5315031012',
    districtId: '5315031',
    name: 'Racang Welak',
  },
  {
    id: '5315031013',
    districtId: '5315031',
    name: 'Robo',
  },
  {
    id: '5315031014',
    districtId: '5315031',
    name: 'Wewa',
  },
  {
    id: '5315031015',
    districtId: '5315031',
    name: 'Golo Ndari',
  },
  {
    id: '5315031016',
    districtId: '5315031',
    name: 'Sewar',
  },
  {
    id: '5315032001',
    districtId: '5315032',
    name: 'Nanga Bere',
  },
  {
    id: '5315032002',
    districtId: '5315032',
    name: 'Benteng Dewa',
  },
  {
    id: '5315032003',
    districtId: '5315032',
    name: 'Nanga Lili',
  },
  {
    id: '5315032004',
    districtId: '5315032',
    name: 'Repi',
  },
  {
    id: '5315032005',
    districtId: '5315032',
    name: 'Watu Waja',
  },
  {
    id: '5315032007',
    districtId: '5315032',
    name: 'Munting',
  },
  {
    id: '5315032008',
    districtId: '5315032',
    name: 'Lalong',
  },
  {
    id: '5315032009',
    districtId: '5315032',
    name: 'Kakor',
  },
  {
    id: '5315032010',
    districtId: '5315032',
    name: 'Wae Mose',
  },
  {
    id: '5315032011',
    districtId: '5315032',
    name: 'Watu Tiri',
  },
  {
    id: '5315032012',
    districtId: '5315032',
    name: 'Benteng Tado',
  },
  {
    id: '5315032013',
    districtId: '5315032',
    name: 'Watu Rambung',
  },
  {
    id: '5315032014',
    districtId: '5315032',
    name: 'Lendong',
  },
  {
    id: '5315032015',
    districtId: '5315032',
    name: 'Modo',
  },
  {
    id: '5315040001',
    districtId: '5315040',
    name: 'Golo Wedong',
  },
  {
    id: '5315040002',
    districtId: '5315040',
    name: 'Ranggu',
  },
  {
    id: '5315040003',
    districtId: '5315040',
    name: 'Golo Ruu',
  },
  {
    id: '5315040005',
    districtId: '5315040',
    name: 'Compang Suka',
  },
  {
    id: '5315040006',
    districtId: '5315040',
    name: 'Nantal',
  },
  {
    id: '5315040007',
    districtId: '5315040',
    name: 'Coal',
  },
  {
    id: '5315040008',
    districtId: '5315040',
    name: 'Sama',
  },
  {
    id: '5315040010',
    districtId: '5315040',
    name: 'Lawi',
  },
  {
    id: '5315040016',
    districtId: '5315040',
    name: 'Pangga',
  },
  {
    id: '5315040017',
    districtId: '5315040',
    name: 'Kolang',
  },
  {
    id: '5315040019',
    districtId: '5315040',
    name: 'Golo Lewe',
  },
  {
    id: '5315040021',
    districtId: '5315040',
    name: 'Golo Riwu',
  },
  {
    id: '5315040022',
    districtId: '5315040',
    name: 'Compang Kules',
  },
  {
    id: '5315040023',
    districtId: '5315040',
    name: 'Golo Pua',
  },
  {
    id: '5315040024',
    districtId: '5315040',
    name: 'Suka Kiong',
  },
  {
    id: '5315040025',
    districtId: '5315040',
    name: 'Bangka Lewat',
  },
  {
    id: '5315040026',
    districtId: '5315040',
    name: 'Sompang Kolang',
  },
  {
    id: '5315040027',
    districtId: '5315040',
    name: 'Wajur',
  },
  {
    id: '5315041001',
    districtId: '5315041',
    name: 'Waning',
  },
  {
    id: '5315041002',
    districtId: '5315041',
    name: 'Ndoso',
  },
  {
    id: '5315041003',
    districtId: '5315041',
    name: 'Momol',
  },
  {
    id: '5315041004',
    districtId: '5315041',
    name: 'Kasong',
  },
  {
    id: '5315041005',
    districtId: '5315041',
    name: 'Raka',
  },
  {
    id: '5315041006',
    districtId: '5315041',
    name: 'Tentang',
  },
  {
    id: '5315041007',
    districtId: '5315041',
    name: 'Pong Narang',
  },
  {
    id: '5315041008',
    districtId: '5315041',
    name: 'Wae Buka',
  },
  {
    id: '5315041010',
    districtId: '5315041',
    name: 'Golo Poleng',
  },
  {
    id: '5315041011',
    districtId: '5315041',
    name: 'Pateng Lesu',
  },
  {
    id: '5315041012',
    districtId: '5315041',
    name: 'Tehong',
  },
  {
    id: '5315041013',
    districtId: '5315041',
    name: 'Golo Bore',
  },
  {
    id: '5315041014',
    districtId: '5315041',
    name: 'Golo Rua',
  },
  {
    id: '5315041015',
    districtId: '5315041',
    name: 'Golo Keli',
  },
  {
    id: '5315050001',
    districtId: '5315050',
    name: 'Loha',
  },
  {
    id: '5315050002',
    districtId: '5315050',
    name: 'Compang',
  },
  {
    id: '5315050003',
    districtId: '5315050',
    name: 'Golo Lajang',
  },
  {
    id: '5315050004',
    districtId: '5315050',
    name: 'Pacar',
  },
  {
    id: '5315050005',
    districtId: '5315050',
    name: 'Kombo',
  },
  {
    id: '5315050006',
    districtId: '5315050',
    name: 'Wontong',
  },
  {
    id: '5315050007',
    districtId: '5315050',
    name: 'Rego',
  },
  {
    id: '5315050008',
    districtId: '5315050',
    name: 'Nggilat',
  },
  {
    id: '5315050009',
    districtId: '5315050',
    name: 'Mbakung',
  },
  {
    id: '5315050010',
    districtId: '5315050',
    name: 'Bari',
  },
  {
    id: '5315050011',
    districtId: '5315050',
    name: 'Rokap',
  },
  {
    id: '5315050012',
    districtId: '5315050',
    name: 'Raba',
  },
  {
    id: '5315050013',
    districtId: '5315050',
    name: 'Nanga Kantor',
  },
  {
    id: '5315050014',
    districtId: '5315050',
    name: 'Benteng Ndope',
  },
  {
    id: '5315050015',
    districtId: '5315050',
    name: 'Waka',
  },
  {
    id: '5315050016',
    districtId: '5315050',
    name: 'Pong Kolong',
  },
  {
    id: '5315050017',
    districtId: '5315050',
    name: 'Golo Lajang Barat',
  },
  {
    id: '5315050018',
    districtId: '5315050',
    name: 'Romang',
  },
  {
    id: '5315050019',
    districtId: '5315050',
    name: 'Manong',
  },
  {
    id: '5315050020',
    districtId: '5315050',
    name: 'Kombo Tengah',
  },
  {
    id: '5315050021',
    districtId: '5315050',
    name: 'Kombo Selatan',
  },
  {
    id: '5315050022',
    districtId: '5315050',
    name: 'Watu Baru',
  },
  {
    id: '5315050023',
    districtId: '5315050',
    name: 'Lewat',
  },
  {
    id: '5315050024',
    districtId: '5315050',
    name: 'Watu Manggar',
  },
  {
    id: '5315050025',
    districtId: '5315050',
    name: 'Sarae Naru',
  },
  {
    id: '5315050026',
    districtId: '5315050',
    name: 'Nanga Kantor Barat',
  },
  {
    id: '5316010008',
    districtId: '5316010',
    name: 'Anakalang',
  },
  {
    id: '5316010009',
    districtId: '5316010',
    name: 'Makata Keri',
  },
  {
    id: '5316010010',
    districtId: '5316010',
    name: 'Umbu Riri',
  },
  {
    id: '5316010011',
    districtId: '5316010',
    name: 'Mata Woga',
  },
  {
    id: '5316010012',
    districtId: '5316010',
    name: 'Kabela Wuntu',
  },
  {
    id: '5316010013',
    districtId: '5316010',
    name: 'Dewa Jara',
  },
  {
    id: '5316010014',
    districtId: '5316010',
    name: 'Mata Redi',
  },
  {
    id: '5316011001',
    districtId: '5316011',
    name: 'Wai Manu',
  },
  {
    id: '5316011002',
    districtId: '5316011',
    name: 'Manurara',
  },
  {
    id: '5316011003',
    districtId: '5316011',
    name: 'Dameka',
  },
  {
    id: '5316011004',
    districtId: '5316011',
    name: 'Wai Lawa',
  },
  {
    id: '5316011005',
    districtId: '5316011',
    name: 'Malinjak',
  },
  {
    id: '5316011006',
    districtId: '5316011',
    name: 'Tana Modu',
  },
  {
    id: '5316011007',
    districtId: '5316011',
    name: 'Konda Maloba',
  },
  {
    id: '5316011008',
    districtId: '5316011',
    name: 'Dasa Elu',
  },
  {
    id: '5316011009',
    districtId: '5316011',
    name: 'Oka Wacu',
  },
  {
    id: '5316020001',
    districtId: '5316020',
    name: 'Umbu Langgang',
  },
  {
    id: '5316020002',
    districtId: '5316020',
    name: 'Umbu Pabal',
  },
  {
    id: '5316020003',
    districtId: '5316020',
    name: 'Umbu Mamijuk',
  },
  {
    id: '5316020004',
    districtId: '5316020',
    name: 'Wai Rasa',
  },
  {
    id: '5316020005',
    districtId: '5316020',
    name: 'Umbu Kawolu',
  },
  {
    id: '5316020006',
    districtId: '5316020',
    name: 'Anajiaka',
  },
  {
    id: '5316020007',
    districtId: '5316020',
    name: 'Pondok',
  },
  {
    id: '5316020008',
    districtId: '5316020',
    name: 'Maderi',
  },
  {
    id: '5316020009',
    districtId: '5316020',
    name: 'Prai Madeta',
  },
  {
    id: '5316020010',
    districtId: '5316020',
    name: 'Sambali Loku',
  },
  {
    id: '5316020011',
    districtId: '5316020',
    name: 'Wangga Waiyengu',
  },
  {
    id: '5316020012',
    districtId: '5316020',
    name: 'Umbu Pabal Selatan',
  },
  {
    id: '5316020013',
    districtId: '5316020',
    name: 'Umbu Jodu',
  },
  {
    id: '5316020014',
    districtId: '5316020',
    name: 'Anapalu',
  },
  {
    id: '5316020015',
    districtId: '5316020',
    name: 'Daha Elu',
  },
  {
    id: '5316020016',
    districtId: '5316020',
    name: 'Dewa Tana',
  },
  {
    id: '5316020017',
    districtId: '5316020',
    name: 'Holur Kambata',
  },
  {
    id: '5316020018',
    districtId: '5316020',
    name: 'Mata Waikajawi',
  },
  {
    id: '5316030001',
    districtId: '5316030',
    name: 'Mbilur Pangadu',
  },
  {
    id: '5316030002',
    districtId: '5316030',
    name: 'Prai Karoku Jangga',
  },
  {
    id: '5316030003',
    districtId: '5316030',
    name: 'Padira Tana',
  },
  {
    id: '5316030004',
    districtId: '5316030',
    name: 'Soru',
  },
  {
    id: '5316030005',
    districtId: '5316030',
    name: 'Weluk Prai Memang',
  },
  {
    id: '5316030006',
    districtId: '5316030',
    name: 'Maradesa',
  },
  {
    id: '5316030007',
    districtId: '5316030',
    name: 'Bolubokat',
  },
  {
    id: '5316030008',
    districtId: '5316030',
    name: 'Bolubokat Utara',
  },
  {
    id: '5316030009',
    districtId: '5316030',
    name: 'Lenang',
  },
  {
    id: '5316030010',
    districtId: '5316030',
    name: 'Ngadu Mbolu',
  },
  {
    id: '5316030011',
    districtId: '5316030',
    name: 'Tana Mbanas',
  },
  {
    id: '5316030012',
    districtId: '5316030',
    name: 'Maradesa Timur',
  },
  {
    id: '5316030013',
    districtId: '5316030',
    name: 'Maradesa Selatan',
  },
  {
    id: '5316030014',
    districtId: '5316030',
    name: 'Tana Mbanas Selatan',
  },
  {
    id: '5316030015',
    districtId: '5316030',
    name: 'Tana Mbanas Barat',
  },
  {
    id: '5316030016',
    districtId: '5316030',
    name: 'Ngadu Olu',
  },
  {
    id: '5316030017',
    districtId: '5316030',
    name: 'Lenang Selatan',
  },
  {
    id: '5316030018',
    districtId: '5316030',
    name: 'Bolubokat Barat',
  },
  {
    id: '5316040001',
    districtId: '5316040',
    name: 'Wee Luri',
  },
  {
    id: '5316040002',
    districtId: '5316040',
    name: 'Wendewa Barat',
  },
  {
    id: '5316040003',
    districtId: '5316040',
    name: 'Ole Ate',
  },
  {
    id: '5316040004',
    districtId: '5316040',
    name: 'Cendana',
  },
  {
    id: '5316040005',
    districtId: '5316040',
    name: 'Wendewa Selatan',
  },
  {
    id: '5316040006',
    districtId: '5316040',
    name: 'Wendewa Utara',
  },
  {
    id: '5316040007',
    districtId: '5316040',
    name: 'Manu Wolu',
  },
  {
    id: '5316040008',
    districtId: '5316040',
    name: 'Wendewa Timur',
  },
  {
    id: '5316040009',
    districtId: '5316040',
    name: 'Watu Asa',
  },
  {
    id: '5316040010',
    districtId: '5316040',
    name: 'Bondo Sulla',
  },
  {
    id: '5316040011',
    districtId: '5316040',
    name: 'Susu Wendewa',
  },
  {
    id: '5316040012',
    districtId: '5316040',
    name: 'Ole Dewa',
  },
  {
    id: '5316040013',
    districtId: '5316040',
    name: 'Cendana Barat',
  },
  {
    id: '5317010007',
    districtId: '5317010',
    name: 'Umbu Ngedo',
  },
  {
    id: '5317010008',
    districtId: '5317010',
    name: 'Walla Ndimu',
  },
  {
    id: '5317010009',
    districtId: '5317010',
    name: 'Mata Kapore',
  },
  {
    id: '5317010010',
    districtId: '5317010',
    name: 'Wai Kadada',
  },
  {
    id: '5317010011',
    districtId: '5317010',
    name: 'Lete Loko',
  },
  {
    id: '5317010012',
    districtId: '5317010',
    name: 'Dinjo',
  },
  {
    id: '5317010013',
    districtId: '5317010',
    name: 'Rada Loko',
  },
  {
    id: '5317010014',
    districtId: '5317010',
    name: 'Waipaddi',
  },
  {
    id: '5317010015',
    districtId: '5317010',
    name: 'Delu Depa',
  },
  {
    id: '5317010016',
    districtId: '5317010',
    name: 'Merakehe',
  },
  {
    id: '5317010017',
    districtId: '5317010',
    name: 'Waikaninyo',
  },
  {
    id: '5317010018',
    districtId: '5317010',
    name: 'Ana Gogka',
  },
  {
    id: '5317010019',
    districtId: '5317010',
    name: 'Maliti Bondo Ate',
  },
  {
    id: '5317010020',
    districtId: '5317010',
    name: 'Ana Lewe',
  },
  {
    id: '5317010021',
    districtId: '5317010',
    name: 'Bondo Balla',
  },
  {
    id: '5317011001',
    districtId: '5317011',
    name: 'Kahale',
  },
  {
    id: '5317011002',
    districtId: '5317011',
    name: 'Panenggo Ede',
  },
  {
    id: '5317011003',
    districtId: '5317011',
    name: 'Wai Karara',
  },
  {
    id: '5317011004',
    districtId: '5317011',
    name: 'Wailangira',
  },
  {
    id: '5317011005',
    districtId: '5317011',
    name: 'Wai Ha',
  },
  {
    id: '5317011006',
    districtId: '5317011',
    name: 'Wainyapu',
  },
  {
    id: '5317011007',
    districtId: '5317011',
    name: 'Karang Indah',
  },
  {
    id: '5317011008',
    districtId: '5317011',
    name: 'Rada Malando',
  },
  {
    id: '5317011009',
    districtId: '5317011',
    name: 'Waimaringi',
  },
  {
    id: '5317011010',
    districtId: '5317011',
    name: 'Tana Mete',
  },
  {
    id: '5317011011',
    districtId: '5317011',
    name: 'Waimakaha',
  },
  {
    id: '5317011012',
    districtId: '5317011',
    name: 'Manu Toghi',
  },
  {
    id: '5317011013',
    districtId: '5317011',
    name: 'Loko Tali',
  },
  {
    id: '5317011014',
    districtId: '5317011',
    name: 'Waipakolo',
  },
  {
    id: '5317020001',
    districtId: '5317020',
    name: 'Kapaka Madeta',
  },
  {
    id: '5317020002',
    districtId: '5317020',
    name: 'Koki',
  },
  {
    id: '5317020003',
    districtId: '5317020',
    name: 'Hamonggo Lele',
  },
  {
    id: '5317020004',
    districtId: '5317020',
    name: 'Bondo Kodi',
  },
  {
    id: '5317020005',
    districtId: '5317020',
    name: 'Pero Batang',
  },
  {
    id: '5317020006',
    districtId: '5317020',
    name: 'Wura Homba',
  },
  {
    id: '5317020007',
    districtId: '5317020',
    name: 'Ate Dalo',
  },
  {
    id: '5317020008',
    districtId: '5317020',
    name: 'Homba Rande',
  },
  {
    id: '5317020009',
    districtId: '5317020',
    name: 'Kawango Hari',
  },
  {
    id: '5317020010',
    districtId: '5317020',
    name: 'Mali Iha',
  },
  {
    id: '5317020011',
    districtId: '5317020',
    name: 'Onggol',
  },
  {
    id: '5317020012',
    districtId: '5317020',
    name: 'Pero Konda',
  },
  {
    id: '5317020013',
    districtId: '5317020',
    name: 'Tanjung Karoso',
  },
  {
    id: '5317020014',
    districtId: '5317020',
    name: 'Watu Wona',
  },
  {
    id: '5317020015',
    districtId: '5317020',
    name: 'Ana Engge',
  },
  {
    id: '5317020016',
    districtId: '5317020',
    name: 'Kadoki Horo',
  },
  {
    id: '5317020017',
    districtId: '5317020',
    name: 'Homba Rica',
  },
  {
    id: '5317020018',
    districtId: '5317020',
    name: 'Ana Kaka',
  },
  {
    id: '5317020019',
    districtId: '5317020',
    name: 'Ole Ate',
  },
  {
    id: '5317030001',
    districtId: '5317030',
    name: 'Hoha Wungo',
  },
  {
    id: '5317030002',
    districtId: '5317030',
    name: 'Homba Karipit',
  },
  {
    id: '5317030003',
    districtId: '5317030',
    name: 'Waila Bubur',
  },
  {
    id: '5317030004',
    districtId: '5317030',
    name: 'Noha',
  },
  {
    id: '5317030005',
    districtId: '5317030',
    name: 'Wai Holo',
  },
  {
    id: '5317030006',
    districtId: '5317030',
    name: 'Kori',
  },
  {
    id: '5317030007',
    districtId: '5317030',
    name: 'Kalena Rongo',
  },
  {
    id: '5317030008',
    districtId: '5317030',
    name: 'Mangga Nipi',
  },
  {
    id: '5317030009',
    districtId: '5317030',
    name: 'Kendu Wela',
  },
  {
    id: '5317030010',
    districtId: '5317030',
    name: 'Bila Cenge',
  },
  {
    id: '5317030011',
    districtId: '5317030',
    name: 'Bukambero',
  },
  {
    id: '5317030013',
    districtId: '5317030',
    name: 'Waitaru',
  },
  {
    id: '5317030014',
    districtId: '5317030',
    name: 'Homba Pare',
  },
  {
    id: '5317030015',
    districtId: '5317030',
    name: 'Kadaghu Tana',
  },
  {
    id: '5317030016',
    districtId: '5317030',
    name: 'Hameli Ate',
  },
  {
    id: '5317030017',
    districtId: '5317030',
    name: 'Kadu Eta',
  },
  {
    id: '5317030018',
    districtId: '5317030',
    name: 'Magho Linyo',
  },
  {
    id: '5317030019',
    districtId: '5317030',
    name: 'Wee Wella',
  },
  {
    id: '5317030020',
    districtId: '5317030',
    name: 'Nangga Mutu',
  },
  {
    id: '5317030021',
    districtId: '5317030',
    name: 'Limbu Kembe',
  },
  {
    id: '5317030022',
    districtId: '5317030',
    name: 'Moro Manduyo',
  },
  {
    id: '5317040001',
    districtId: '5317040',
    name: 'Buru Kaghu',
  },
  {
    id: '5317040002',
    districtId: '5317040',
    name: 'Denduka',
  },
  {
    id: '5317040003',
    districtId: '5317040',
    name: 'Bondo Bela',
  },
  {
    id: '5317040004',
    districtId: '5317040',
    name: 'Delo',
  },
  {
    id: '5317040005',
    districtId: '5317040',
    name: 'Tena Teke',
  },
  {
    id: '5317040006',
    districtId: '5317040',
    name: 'Bondo Ukka',
  },
  {
    id: '5317040007',
    districtId: '5317040',
    name: 'Buru Deilo',
  },
  {
    id: '5317040008',
    districtId: '5317040',
    name: 'Weri Lolo',
  },
  {
    id: '5317040009',
    districtId: '5317040',
    name: 'Milla Ate',
  },
  {
    id: '5317040010',
    districtId: '5317040',
    name: 'Rita Baru',
  },
  {
    id: '5317040011',
    districtId: '5317040',
    name: 'Mandungo',
  },
  {
    id: '5317040012',
    districtId: '5317040',
    name: 'Umbu Wangu',
  },
  {
    id: '5317040013',
    districtId: '5317040',
    name: 'Wee Wulla',
  },
  {
    id: '5317040014',
    districtId: '5317040',
    name: 'Wee Baghe',
  },
  {
    id: '5317050001',
    districtId: '5317050',
    name: 'Raba Engge',
  },
  {
    id: '5317050002',
    districtId: '5317050',
    name: 'Kalembu Tilu',
  },
  {
    id: '5317050003',
    districtId: '5317050',
    name: 'Wee Kombaka',
  },
  {
    id: '5317050004',
    districtId: '5317050',
    name: 'Menne Ate',
  },
  {
    id: '5317050005',
    districtId: '5317050',
    name: 'Wali Ate',
  },
  {
    id: '5317050006',
    districtId: '5317050',
    name: 'Kalembu Weri',
  },
  {
    id: '5317050007',
    districtId: '5317050',
    name: 'Kabali Dana',
  },
  {
    id: '5317050008',
    districtId: '5317050',
    name: 'Watu Lambara',
  },
  {
    id: '5317050009',
    districtId: '5317050',
    name: 'Waimangura',
  },
  {
    id: '5317050011',
    districtId: '5317050',
    name: 'Reda Pada',
  },
  {
    id: '5317050012',
    districtId: '5317050',
    name: 'Marokota',
  },
  {
    id: '5317050015',
    districtId: '5317050',
    name: 'Kalembu Kanaika',
  },
  {
    id: '5317050016',
    districtId: '5317050',
    name: 'Wee Kura',
  },
  {
    id: '5317050017',
    districtId: '5317050',
    name: 'Laga Lete',
  },
  {
    id: '5317050018',
    districtId: '5317050',
    name: 'Tawo Rara',
  },
  {
    id: '5317050019',
    districtId: '5317050',
    name: 'Lua Koba',
  },
  {
    id: '5317050020',
    districtId: '5317050',
    name: 'Kalaki Kambe',
  },
  {
    id: '5317050021',
    districtId: '5317050',
    name: 'Sangu Ate',
  },
  {
    id: '5317050022',
    districtId: '5317050',
    name: 'Pero',
  },
  {
    id: '5317050023',
    districtId: '5317050',
    name: 'Lolo Ole',
  },
  {
    id: '5317060001',
    districtId: '5317060',
    name: 'Dangga Mango',
  },
  {
    id: '5317060002',
    districtId: '5317060',
    name: 'Dikira',
  },
  {
    id: '5317060003',
    districtId: '5317060',
    name: 'Pada Ewata',
  },
  {
    id: '5317060004',
    districtId: '5317060',
    name: 'Mareda Kalada',
  },
  {
    id: '5317060005',
    districtId: '5317060',
    name: 'Tema Tana',
  },
  {
    id: '5317060007',
    districtId: '5317060',
    name: 'Kalembu Ndara Mane',
  },
  {
    id: '5317060017',
    districtId: '5317060',
    name: 'Weelimbu',
  },
  {
    id: '5317060018',
    districtId: '5317060',
    name: 'Letekamouna',
  },
  {
    id: '5317060019',
    districtId: '5317060',
    name: 'Mata Pyawu',
  },
  {
    id: '5317060020',
    districtId: '5317060',
    name: 'Wee Lima',
  },
  {
    id: '5317060021',
    districtId: '5317060',
    name: 'Kadi Wone',
  },
  {
    id: '5317060022',
    districtId: '5317060',
    name: 'Maliti Dari',
  },
  {
    id: '5317060023',
    districtId: '5317060',
    name: 'Dede Pada',
  },
  {
    id: '5317060024',
    districtId: '5317060',
    name: 'Kadi Wano',
  },
  {
    id: '5317060025',
    districtId: '5317060',
    name: 'Nyura Lele',
  },
  {
    id: '5317060026',
    districtId: '5317060',
    name: 'Mawo Dana',
  },
  {
    id: '5317060027',
    districtId: '5317060',
    name: 'Mainda Ole',
  },
  {
    id: '5317060028',
    districtId: '5317060',
    name: 'Lele Maya',
  },
  {
    id: '5317060029',
    districtId: '5317060',
    name: 'Mata Wee Lima',
  },
  {
    id: '5317061001',
    districtId: '5317061',
    name: 'Omba Rade',
  },
  {
    id: '5317061002',
    districtId: '5317061',
    name: 'Eka Pata',
  },
  {
    id: '5317061003',
    districtId: '5317061',
    name: 'Wee Rame',
  },
  {
    id: '5317061004',
    districtId: '5317061',
    name: 'Wee Kokora',
  },
  {
    id: '5317061005',
    districtId: '5317061',
    name: 'Kali Ngara',
  },
  {
    id: '5317061006',
    districtId: '5317061',
    name: 'Lombu',
  },
  {
    id: '5317061007',
    districtId: '5317061',
    name: 'Kanelu',
  },
  {
    id: '5317061008',
    districtId: '5317061',
    name: 'Tanggaba',
  },
  {
    id: '5317061009',
    districtId: '5317061',
    name: 'Wee Patando',
  },
  {
    id: '5317061010',
    districtId: '5317061',
    name: 'Bolora',
  },
  {
    id: '5317061011',
    districtId: '5317061',
    name: 'Kadi Roma',
  },
  {
    id: '5317061012',
    districtId: '5317061',
    name: 'Bondo Delo',
  },
  {
    id: '5317061013',
    districtId: '5317061',
    name: 'Tarra Mata',
  },
  {
    id: '5317061014',
    districtId: '5317061',
    name: 'Mata Wee Karoro',
  },
  {
    id: '5317061015',
    districtId: '5317061',
    name: 'Gollu Sapi',
  },
  {
    id: '5317061016',
    districtId: '5317061',
    name: 'Mata Lombu',
  },
  {
    id: '5317061017',
    districtId: '5317061',
    name: 'Limbu Watu',
  },
  {
    id: '5317061018',
    districtId: '5317061',
    name: 'Mareda Wuni',
  },
  {
    id: '5317061019',
    districtId: '5317061',
    name: 'Lete Wungana',
  },
  {
    id: '5317061020',
    districtId: '5317061',
    name: 'Kiku Booko',
  },
  {
    id: '5317070001',
    districtId: '5317070',
    name: 'Wano Talla',
  },
  {
    id: '5317070002',
    districtId: '5317070',
    name: 'Wee Paboba',
  },
  {
    id: '5317070003',
    districtId: '5317070',
    name: 'Mataloko',
  },
  {
    id: '5317070004',
    districtId: '5317070',
    name: 'Puu Potto',
  },
  {
    id: '5317070005',
    districtId: '5317070',
    name: 'Wee Namba',
  },
  {
    id: '5317070006',
    districtId: '5317070',
    name: 'Mali Mada',
  },
  {
    id: '5317070007',
    districtId: '5317070',
    name: 'Mawo Maliti',
  },
  {
    id: '5317070008',
    districtId: '5317070',
    name: 'Jela Manu',
  },
  {
    id: '5317070009',
    districtId: '5317070',
    name: 'Bodo Ponda',
  },
  {
    id: '5317070010',
    districtId: '5317070',
    name: 'Pandua Tana',
  },
  {
    id: '5317070011',
    districtId: '5317070',
    name: 'Odi Paurata',
  },
  {
    id: '5317070012',
    districtId: '5317070',
    name: 'Reda Wano',
  },
  {
    id: '5317080007',
    districtId: '5317080',
    name: 'Ramma Dana',
  },
  {
    id: '5317080008',
    districtId: '5317080',
    name: 'Karuni',
  },
  {
    id: '5317080009',
    districtId: '5317080',
    name: 'Totok',
  },
  {
    id: '5317080010',
    districtId: '5317080',
    name: 'Wee Manada',
  },
  {
    id: '5317080011',
    districtId: '5317080',
    name: 'Lete Konda',
  },
  {
    id: '5317080012',
    districtId: '5317080',
    name: 'Bondo Boghila',
  },
  {
    id: '5317080013',
    districtId: '5317080',
    name: 'Wee Kambala',
  },
  {
    id: '5317080014',
    districtId: '5317080',
    name: 'Payola Umbu',
  },
  {
    id: '5317080015',
    districtId: '5317080',
    name: 'Pogo Tena',
  },
  {
    id: '5317080016',
    districtId: '5317080',
    name: 'Loka Kalada',
  },
  {
    id: '5317080017',
    districtId: '5317080',
    name: 'Lete Konda Selatan',
  },
  {
    id: '5317081001',
    districtId: '5317081',
    name: 'Wee Londa',
  },
  {
    id: '5317081002',
    districtId: '5317081',
    name: 'Langga Lero',
  },
  {
    id: '5317081003',
    districtId: '5317081',
    name: 'Wee Tobula',
  },
  {
    id: '5317081004',
    districtId: '5317081',
    name: 'Kalena Wano',
  },
  {
    id: '5317081005',
    districtId: '5317081',
    name: 'Radamata',
  },
  {
    id: '5317081006',
    districtId: '5317081',
    name: 'Wee Pangali',
  },
  {
    id: '5317081007',
    districtId: '5317081',
    name: 'Kalembu Kaha',
  },
  {
    id: '5317081008',
    districtId: '5317081',
    name: 'Wee Renna',
  },
  {
    id: '5317081009',
    districtId: '5317081',
    name: 'Watu Kawula',
  },
  {
    id: '5317081010',
    districtId: '5317081',
    name: 'Kadi Pada',
  },
  {
    id: '5318010001',
    districtId: '5318010',
    name: 'Aewoe',
  },
  {
    id: '5318010002',
    districtId: '5318010',
    name: 'Bela',
  },
  {
    id: '5318010003',
    districtId: '5318010',
    name: 'Wolokisa',
  },
  {
    id: '5318010004',
    districtId: '5318010',
    name: 'Wuliwalo',
  },
  {
    id: '5318010005',
    districtId: '5318010',
    name: 'Maukeli',
  },
  {
    id: '5318010006',
    districtId: '5318010',
    name: 'Lokalaba',
  },
  {
    id: '5318010007',
    districtId: '5318010',
    name: 'Wolotelu',
  },
  {
    id: '5318010008',
    districtId: '5318010',
    name: 'Mauponggo',
  },
  {
    id: '5318010009',
    districtId: '5318010',
    name: 'Sawu',
  },
  {
    id: '5318010010',
    districtId: '5318010',
    name: 'Jawapogo',
  },
  {
    id: '5318010011',
    districtId: '5318010',
    name: 'Lajawajo',
  },
  {
    id: '5318010012',
    districtId: '5318010',
    name: 'Ululoga',
  },
  {
    id: '5318010013',
    districtId: '5318010',
    name: 'Lodaolo',
  },
  {
    id: '5318010014',
    districtId: '5318010',
    name: 'Woloede',
  },
  {
    id: '5318010015',
    districtId: '5318010',
    name: 'Woewolo',
  },
  {
    id: '5318010016',
    districtId: '5318010',
    name: 'Selalejo',
  },
  {
    id: '5318010017',
    districtId: '5318010',
    name: 'Ua',
  },
  {
    id: '5318010018',
    districtId: '5318010',
    name: 'Keliwatulewa',
  },
  {
    id: '5318010019',
    districtId: '5318010',
    name: 'Kotagana',
  },
  {
    id: '5318010020',
    districtId: '5318010',
    name: 'Wololelu',
  },
  {
    id: '5318010021',
    districtId: '5318010',
    name: 'Selalejo Timur',
  },
  {
    id: '5318020001',
    districtId: '5318020',
    name: 'Mbaenuamuri',
  },
  {
    id: '5318020002',
    districtId: '5318020',
    name: 'Witurombaua',
  },
  {
    id: '5318020003',
    districtId: '5318020',
    name: 'Kotawuji Timur',
  },
  {
    id: '5318020004',
    districtId: '5318020',
    name: 'Kotawuji Barat',
  },
  {
    id: '5318020005',
    districtId: '5318020',
    name: 'Udiworowatu',
  },
  {
    id: '5318020006',
    districtId: '5318020',
    name: 'Pautola',
  },
  {
    id: '5318020007',
    districtId: '5318020',
    name: 'Ladolima',
  },
  {
    id: '5318020008',
    districtId: '5318020',
    name: 'Kotadirumali',
  },
  {
    id: '5318020009',
    districtId: '5318020',
    name: 'Keli',
  },
  {
    id: '5318020010',
    districtId: '5318020',
    name: 'Lewangera',
  },
  {
    id: '5318020011',
    districtId: '5318020',
    name: 'Wajo',
  },
  {
    id: '5318020012',
    districtId: '5318020',
    name: 'Ngera',
  },
  {
    id: '5318020013',
    districtId: '5318020',
    name: 'Ladolima Timur',
  },
  {
    id: '5318020014',
    districtId: '5318020',
    name: 'Ladolima Utara',
  },
  {
    id: '5318020015',
    districtId: '5318020',
    name: 'Paumali',
  },
  {
    id: '5318020016',
    districtId: '5318020',
    name: 'Wajo Timur',
  },
  {
    id: '5318030002',
    districtId: '5318030',
    name: 'Podenura',
  },
  {
    id: '5318030003',
    districtId: '5318030',
    name: 'Tonggo',
  },
  {
    id: '5318030004',
    districtId: '5318030',
    name: 'Riti',
  },
  {
    id: '5318030007',
    districtId: '5318030',
    name: 'Wokodekororo',
  },
  {
    id: '5318030008',
    districtId: '5318030',
    name: 'Degalea',
  },
  {
    id: '5318030009',
    districtId: '5318030',
    name: 'Kotakeo',
  },
  {
    id: '5318030010',
    districtId: '5318030',
    name: 'Pagomogo',
  },
  {
    id: '5318030011',
    districtId: '5318030',
    name: 'Nangaroro',
  },
  {
    id: '5318030012',
    districtId: '5318030',
    name: 'Nataute',
  },
  {
    id: '5318030013',
    districtId: '5318030',
    name: 'Utetoto',
  },
  {
    id: '5318030014',
    districtId: '5318030',
    name: 'Bidoa',
  },
  {
    id: '5318030016',
    districtId: '5318030',
    name: 'Woedoa',
  },
  {
    id: '5318030018',
    districtId: '5318030',
    name: 'Woewutu',
  },
  {
    id: '5318030019',
    districtId: '5318030',
    name: 'Wokowoe',
  },
  {
    id: '5318030020',
    districtId: '5318030',
    name: 'Kotakeo I',
  },
  {
    id: '5318030021',
    districtId: '5318030',
    name: 'Kotakeo II',
  },
  {
    id: '5318030022',
    districtId: '5318030',
    name: 'Odaute',
  },
  {
    id: '5318040001',
    districtId: '5318040',
    name: 'Rowa',
  },
  {
    id: '5318040002',
    districtId: '5318040',
    name: 'Solo',
  },
  {
    id: '5318040003',
    districtId: '5318040',
    name: 'Kelewae',
  },
  {
    id: '5318040005',
    districtId: '5318040',
    name: 'Nagesapadhi',
  },
  {
    id: '5318040006',
    districtId: '5318040',
    name: 'Rigi',
  },
  {
    id: '5318040007',
    districtId: '5318040',
    name: 'Olakile',
  },
  {
    id: '5318040008',
    districtId: '5318040',
    name: 'Natanage',
  },
  {
    id: '5318040009',
    districtId: '5318040',
    name: 'Nageoga',
  },
  {
    id: '5318040010',
    districtId: '5318040',
    name: 'Wolopogo',
  },
  {
    id: '5318040011',
    districtId: '5318040',
    name: 'Rega',
  },
  {
    id: '5318040012',
    districtId: '5318040',
    name: 'Mulakoli',
  },
  {
    id: '5318040013',
    districtId: '5318040',
    name: 'Kelimado',
  },
  {
    id: '5318040014',
    districtId: '5318040',
    name: 'Wea Au',
  },
  {
    id: '5318040015',
    districtId: '5318040',
    name: 'Raja',
  },
  {
    id: '5318040016',
    districtId: '5318040',
    name: 'Wolowea',
  },
  {
    id: '5318040017',
    districtId: '5318040',
    name: 'Ratongamobo',
  },
  {
    id: '5318040018',
    districtId: '5318040',
    name: 'Dhereisa',
  },
  {
    id: '5318040019',
    districtId: '5318040',
    name: 'Gerodhere',
  },
  {
    id: '5318040020',
    districtId: '5318040',
    name: 'Nagerawe',
  },
  {
    id: '5318040021',
    districtId: '5318040',
    name: 'Focolodorawe',
  },
  {
    id: '5318040022',
    districtId: '5318040',
    name: 'Alorawe',
  },
  {
    id: '5318040023',
    districtId: '5318040',
    name: 'Natanage Timur',
  },
  {
    id: '5318040024',
    districtId: '5318040',
    name: 'Raja Timur',
  },
  {
    id: '5318040025',
    districtId: '5318040',
    name: 'Raja Selatan',
  },
  {
    id: '5318040026',
    districtId: '5318040',
    name: 'Wolowea Barat',
  },
  {
    id: '5318040027',
    districtId: '5318040',
    name: 'Wolowea Timur',
  },
  {
    id: '5318050001',
    districtId: '5318050',
    name: 'Rendutenoe',
  },
  {
    id: '5318050002',
    districtId: '5318050',
    name: 'Langedhawe',
  },
  {
    id: '5318050003',
    districtId: '5318050',
    name: 'Tengatiba',
  },
  {
    id: '5318050004',
    districtId: '5318050',
    name: 'Renduwawo',
  },
  {
    id: '5318050005',
    districtId: '5318050',
    name: 'Rendu Butowe',
  },
  {
    id: '5318050006',
    districtId: '5318050',
    name: 'Wajomara',
  },
  {
    id: '5318050007',
    districtId: '5318050',
    name: 'Rendututubadha',
  },
  {
    id: '5318060001',
    districtId: '5318060',
    name: 'Tedamude',
  },
  {
    id: '5318060002',
    districtId: '5318060',
    name: 'Tedakisa',
  },
  {
    id: '5318060003',
    districtId: '5318060',
    name: 'Dhawe',
  },
  {
    id: '5318060009',
    districtId: '5318060',
    name: 'Labolewa',
  },
  {
    id: '5318060010',
    districtId: '5318060',
    name: 'Olaia',
  },
  {
    id: '5318060011',
    districtId: '5318060',
    name: 'Ngegedhawe',
  },
  {
    id: '5318060012',
    districtId: '5318060',
    name: 'Lape',
  },
  {
    id: '5318060013',
    districtId: '5318060',
    name: 'Danga',
  },
  {
    id: '5318060014',
    districtId: '5318060',
    name: 'Nggolo Mbay',
  },
  {
    id: '5318060015',
    districtId: '5318060',
    name: 'Towak',
  },
  {
    id: '5318060016',
    districtId: '5318060',
    name: 'Nggolonio',
  },
  {
    id: '5318060017',
    districtId: '5318060',
    name: 'Waekokak',
  },
  {
    id: '5318060018',
    districtId: '5318060',
    name: 'Mbay II',
  },
  {
    id: '5318060019',
    districtId: '5318060',
    name: 'Mbay I',
  },
  {
    id: '5318060020',
    districtId: '5318060',
    name: 'Tonggu Rambang',
  },
  {
    id: '5318060021',
    districtId: '5318060',
    name: 'Marapokot',
  },
  {
    id: '5318060022',
    districtId: '5318060',
    name: 'Nangadhero',
  },
  {
    id: '5318060023',
    districtId: '5318060',
    name: 'Aeramo',
  },
  {
    id: '5318070001',
    districtId: '5318070',
    name: 'Anakoli',
  },
  {
    id: '5318070002',
    districtId: '5318070',
    name: 'Natatoto',
  },
  {
    id: '5318070003',
    districtId: '5318070',
    name: 'Totomala',
  },
  {
    id: '5318070004',
    districtId: '5318070',
    name: 'Tendatoto',
  },
  {
    id: '5318070005',
    districtId: '5318070',
    name: 'Tenda Kinde',
  },
  {
    id: '5319010003',
    districtId: '5319010',
    name: 'Nanga Labang',
  },
  {
    id: '5319010004',
    districtId: '5319010',
    name: 'Golo Kantar',
  },
  {
    id: '5319010005',
    districtId: '5319010',
    name: 'Rana Loba',
  },
  {
    id: '5319010006',
    districtId: '5319010',
    name: 'Kota Ndora',
  },
  {
    id: '5319010007',
    districtId: '5319010',
    name: 'Rana Masak',
  },
  {
    id: '5319010008',
    districtId: '5319010',
    name: 'Ngampang Mas',
  },
  {
    id: '5319010009',
    districtId: '5319010',
    name: 'Benteng Raja',
  },
  {
    id: '5319010010',
    districtId: '5319010',
    name: 'Benteng Riwu',
  },
  {
    id: '5319010011',
    districtId: '5319010',
    name: 'Poco Rii',
  },
  {
    id: '5319010012',
    districtId: '5319010',
    name: 'Golo Lalong',
  },
  {
    id: '5319010013',
    districtId: '5319010',
    name: 'Gurung Liwut',
  },
  {
    id: '5319010025',
    districtId: '5319010',
    name: 'Compang Ndejing',
  },
  {
    id: '5319010026',
    districtId: '5319010',
    name: 'Bangka Kantar',
  },
  {
    id: '5319010027',
    districtId: '5319010',
    name: 'Satar Peot',
  },
  {
    id: '5319010028',
    districtId: '5319010',
    name: 'Balus Permai',
  },
  {
    id: '5319010029',
    districtId: '5319010',
    name: 'Compang Tenda',
  },
  {
    id: '5319010030',
    districtId: '5319010',
    name: 'Waling',
  },
  {
    id: '5319010031',
    districtId: '5319010',
    name: 'Golo Leda',
  },
  {
    id: '5319011001',
    districtId: '5319011',
    name: 'Bea Ngencung',
  },
  {
    id: '5319011002',
    districtId: '5319011',
    name: 'Satar Lahing',
  },
  {
    id: '5319011003',
    districtId: '5319011',
    name: 'Golo Meleng',
  },
  {
    id: '5319011004',
    districtId: '5319011',
    name: 'Golo Rutuk',
  },
  {
    id: '5319011005',
    districtId: '5319011',
    name: 'Golo Loni',
  },
  {
    id: '5319011006',
    districtId: '5319011',
    name: 'Sita',
  },
  {
    id: '5319011007',
    districtId: '5319011',
    name: 'Torok Golo',
  },
  {
    id: '5319011008',
    districtId: '5319011',
    name: 'Golo Ros',
  },
  {
    id: '5319011009',
    districtId: '5319011',
    name: 'Sano Lokom',
  },
  {
    id: '5319011010',
    districtId: '5319011',
    name: 'Rondo Woing',
  },
  {
    id: '5319011011',
    districtId: '5319011',
    name: 'Lidi',
  },
  {
    id: '5319011012',
    districtId: '5319011',
    name: 'Satar Lenda',
  },
  {
    id: '5319011013',
    districtId: '5319011',
    name: 'Lalang',
  },
  {
    id: '5319011014',
    districtId: '5319011',
    name: 'Wae Nggori',
  },
  {
    id: '5319011015',
    districtId: '5319011',
    name: 'Compang Kantar',
  },
  {
    id: '5319011016',
    districtId: '5319011',
    name: 'Bangka Kempo',
  },
  {
    id: '5319011017',
    districtId: '5319011',
    name: 'Compang Teber',
  },
  {
    id: '5319011018',
    districtId: '5319011',
    name: 'Compang Loni',
  },
  {
    id: '5319011019',
    districtId: '5319011',
    name: 'Compang Kempo',
  },
  {
    id: '5319011020',
    districtId: '5319011',
    name: 'Watu Mori',
  },
  {
    id: '5319011021',
    districtId: '5319011',
    name: 'Bangka Masa',
  },
  {
    id: '5319020001',
    districtId: '5319020',
    name: 'Tanah Rata',
  },
  {
    id: '5319020002',
    districtId: '5319020',
    name: 'Bamo',
  },
  {
    id: '5319020003',
    districtId: '5319020',
    name: 'Rongga Koe',
  },
  {
    id: '5319020004',
    districtId: '5319020',
    name: 'Komba',
  },
  {
    id: '5319020005',
    districtId: '5319020',
    name: 'Watu Nggene',
  },
  {
    id: '5319020007',
    districtId: '5319020',
    name: 'Rana Kolong',
  },
  {
    id: '5319020008',
    districtId: '5319020',
    name: 'Mbengan',
  },
  {
    id: '5319020010',
    districtId: '5319020',
    name: 'Ruan',
  },
  {
    id: '5319020011',
    districtId: '5319020',
    name: 'Pong Ruan',
  },
  {
    id: '5319020012',
    districtId: '5319020',
    name: 'Golo Tolang',
  },
  {
    id: '5319020013',
    districtId: '5319020',
    name: 'Paan Leleng',
  },
  {
    id: '5319020014',
    districtId: '5319020',
    name: 'Mokel',
  },
  {
    id: '5319020015',
    districtId: '5319020',
    name: 'Golomeni',
  },
  {
    id: '5319020016',
    districtId: '5319020',
    name: 'Rana Mbeling',
  },
  {
    id: '5319020017',
    districtId: '5319020',
    name: 'Golo Nderu',
  },
  {
    id: '5319020018',
    districtId: '5319020',
    name: 'Gunung Baru',
  },
  {
    id: '5319020019',
    districtId: '5319020',
    name: 'Golon Dele',
  },
  {
    id: '5319020020',
    districtId: '5319020',
    name: 'Mokel Morid',
  },
  {
    id: '5319020021',
    districtId: '5319020',
    name: 'Rana Mbata',
  },
  {
    id: '5319020022',
    districtId: '5319020',
    name: 'Watu Pari',
  },
  {
    id: '5319030010',
    districtId: '5319030',
    name: 'Golo Munde',
  },
  {
    id: '5319030012',
    districtId: '5319030',
    name: 'Tiwu Kondo',
  },
  {
    id: '5319030013',
    districtId: '5319030',
    name: 'Rana Gapang',
  },
  {
    id: '5319030014',
    districtId: '5319030',
    name: 'Haju Ngendong',
  },
  {
    id: '5319030015',
    districtId: '5319030',
    name: 'Lengko Namut',
  },
  {
    id: '5319030016',
    districtId: '5319030',
    name: 'Sisir',
  },
  {
    id: '5319030017',
    districtId: '5319030',
    name: 'Rana Kulan',
  },
  {
    id: '5319030018',
    districtId: '5319030',
    name: 'Biting',
  },
  {
    id: '5319030019',
    districtId: '5319030',
    name: 'Golo Lebo',
  },
  {
    id: '5319030020',
    districtId: '5319030',
    name: 'Legur Lai',
  },
  {
    id: '5319030021',
    districtId: '5319030',
    name: 'Golo Lijun',
  },
  {
    id: '5319030026',
    districtId: '5319030',
    name: 'Wae Lokom',
  },
  {
    id: '5319030027',
    districtId: '5319030',
    name: 'Compang Teo',
  },
  {
    id: '5319030028',
    districtId: '5319030',
    name: 'Compang Soba',
  },
  {
    id: '5319030029',
    districtId: '5319030',
    name: 'Kaju Wangi',
  },
  {
    id: '5319031001',
    districtId: '5319031',
    name: 'Golo Wuas',
  },
  {
    id: '5319031002',
    districtId: '5319031',
    name: 'Sipi',
  },
  {
    id: '5319031003',
    districtId: '5319031',
    name: 'Paan Waru',
  },
  {
    id: '5319031004',
    districtId: '5319031',
    name: 'Nanga Meje',
  },
  {
    id: '5319031005',
    districtId: '5319031',
    name: 'Langgasai',
  },
  {
    id: '5319031006',
    districtId: '5319031',
    name: 'Sangan Kalo',
  },
  {
    id: '5319031007',
    districtId: '5319031',
    name: 'Golo Linus',
  },
  {
    id: '5319031008',
    districtId: '5319031',
    name: 'Gising',
  },
  {
    id: '5319031009',
    districtId: '5319031',
    name: 'Teno Mese',
  },
  {
    id: '5319031010',
    districtId: '5319031',
    name: 'Lempang Paji',
  },
  {
    id: '5319031011',
    districtId: '5319031',
    name: "Nanga Pu'Un",
  },
  {
    id: '5319031012',
    districtId: '5319031',
    name: 'Mosi Ngaran',
  },
  {
    id: '5319031013',
    districtId: '5319031',
    name: 'Wae Rasan',
  },
  {
    id: '5319031014',
    districtId: '5319031',
    name: 'Benteng Pau',
  },
  {
    id: '5319040001',
    districtId: '5319040',
    name: 'Compang Congkar',
  },
  {
    id: '5319040002',
    districtId: '5319040',
    name: 'Rana Mese',
  },
  {
    id: '5319040003',
    districtId: '5319040',
    name: 'Satar Nawang',
  },
  {
    id: '5319040004',
    districtId: '5319040',
    name: 'Golo Ngawan',
  },
  {
    id: '5319040005',
    districtId: '5319040',
    name: 'Buti',
  },
  {
    id: '5319040006',
    districtId: '5319040',
    name: 'Golo Wangkung',
  },
  {
    id: '5319040007',
    districtId: '5319040',
    name: 'Lada Mese',
  },
  {
    id: '5319040008',
    districtId: '5319040',
    name: 'Nanga Baras',
  },
  {
    id: '5319040009',
    districtId: '5319040',
    name: 'Nanga Mbaling',
  },
  {
    id: '5319040010',
    districtId: '5319040',
    name: 'Pota',
  },
  {
    id: '5319040011',
    districtId: '5319040',
    name: 'Nanga Mbaur',
  },
  {
    id: '5319040012',
    districtId: '5319040',
    name: 'Compang Lawi',
  },
  {
    id: '5319040013',
    districtId: '5319040',
    name: 'Wea',
  },
  {
    id: '5319040014',
    districtId: '5319040',
    name: 'Golo Pari',
  },
  {
    id: '5319040015',
    districtId: '5319040',
    name: 'Golo Wangkung Barat',
  },
  {
    id: '5319040016',
    districtId: '5319040',
    name: 'Golo Wangkung Utara',
  },
  {
    id: '5319040017',
    districtId: '5319040',
    name: 'Kembang Mekar',
  },
  {
    id: '5319040018',
    districtId: '5319040',
    name: 'Wela Lada',
  },
  {
    id: '5319040019',
    districtId: '5319040',
    name: 'Ulung Baras',
  },
  {
    id: '5319040020',
    districtId: '5319040',
    name: 'Nampar Sepang',
  },
  {
    id: '5319050001',
    districtId: '5319050',
    name: 'Golo Lobos',
  },
  {
    id: '5319050002',
    districtId: '5319050',
    name: 'Bangka Kuleng',
  },
  {
    id: '5319050003',
    districtId: '5319050',
    name: 'Mando Sawu',
  },
  {
    id: '5319050004',
    districtId: '5319050',
    name: 'Bangka Pau',
  },
  {
    id: '5319050005',
    districtId: '5319050',
    name: 'Nggalak Leleng',
  },
  {
    id: '5319050006',
    districtId: '5319050',
    name: 'Golo Nderu',
  },
  {
    id: '5319050007',
    districtId: '5319050',
    name: 'Pocolia',
  },
  {
    id: '5319050016',
    districtId: '5319050',
    name: 'Gurung Turi',
  },
  {
    id: '5319050017',
    districtId: '5319050',
    name: 'Compang Laho',
  },
  {
    id: '5319050018',
    districtId: '5319050',
    name: 'Bea Waek',
  },
  {
    id: '5319050019',
    districtId: '5319050',
    name: 'Satar Tesem',
  },
  {
    id: '5319050020',
    districtId: '5319050',
    name: 'Lenang',
  },
  {
    id: '5319050021',
    districtId: '5319050',
    name: 'Pocong',
  },
  {
    id: '5319050025',
    districtId: '5319050',
    name: 'Watu Lanur',
  },
  {
    id: '5319050026',
    districtId: '5319050',
    name: 'Leong',
  },
  {
    id: '5319050027',
    districtId: '5319050',
    name: 'Melo',
  },
  {
    id: '5319050028',
    districtId: '5319050',
    name: 'Golo Ndari',
  },
  {
    id: '5319050029',
    districtId: '5319050',
    name: 'Compang Wesang',
  },
  {
    id: '5319050030',
    districtId: '5319050',
    name: 'Bangka Leleng',
  },
  {
    id: '5319050031',
    districtId: '5319050',
    name: 'Lento',
  },
  {
    id: '5319050036',
    districtId: '5319050',
    name: 'Golo Rengket',
  },
  {
    id: '5319050037',
    districtId: '5319050',
    name: 'Golo Wune',
  },
  {
    id: '5319050038',
    districtId: '5319050',
    name: 'Deno',
  },
  {
    id: '5319050041',
    districtId: '5319050',
    name: 'Compang Weluk',
  },
  {
    id: '5319051001',
    districtId: '5319051',
    name: 'Rende Nao',
  },
  {
    id: '5319051002',
    districtId: '5319051',
    name: 'Ulu Wae',
  },
  {
    id: '5319051003',
    districtId: '5319051',
    name: 'Ngkiong Dora',
  },
  {
    id: '5319051004',
    districtId: '5319051',
    name: 'Wangkar Weli',
  },
  {
    id: '5319051005',
    districtId: '5319051',
    name: 'Rengkam',
  },
  {
    id: '5319051006',
    districtId: '5319051',
    name: 'Golo Lero',
  },
  {
    id: '5319051007',
    districtId: '5319051',
    name: 'Tango Molas',
  },
  {
    id: '5319051008',
    districtId: '5319051',
    name: 'Arus',
  },
  {
    id: '5319051009',
    districtId: '5319051',
    name: 'Watu Arus',
  },
  {
    id: '5319051010',
    districtId: '5319051',
    name: 'Benteng Rampas',
  },
  {
    id: '5319051011',
    districtId: '5319051',
    name: 'Compang Wunis',
  },
  {
    id: '5319051012',
    districtId: '5319051',
    name: 'Wejang Mali',
  },
  {
    id: '5319051013',
    districtId: '5319051',
    name: 'Colol',
  },
  {
    id: '5319051014',
    districtId: '5319051',
    name: 'Urung Dora',
  },
  {
    id: '5319051015',
    districtId: '5319051',
    name: 'Compang Raci',
  },
  {
    id: '5319051016',
    districtId: '5319051',
    name: 'Bangka Arus',
  },
  {
    id: '5319051017',
    districtId: '5319051',
    name: 'Benteng Wunis',
  },
  {
    id: '5319051018',
    districtId: '5319051',
    name: 'Wejang Mawe',
  },
  {
    id: '5319060001',
    districtId: '5319060',
    name: 'Tengkulawar',
  },
  {
    id: '5319060002',
    districtId: '5319060',
    name: 'Compang Necak',
  },
  {
    id: '5319060003',
    districtId: '5319060',
    name: 'Compang Mekar',
  },
  {
    id: '5319060004',
    districtId: '5319060',
    name: 'Tengku Leda',
  },
  {
    id: '5319060005',
    districtId: '5319060',
    name: 'Compang Deru',
  },
  {
    id: '5319060006',
    districtId: '5319060',
    name: 'Goreng Meni',
  },
  {
    id: '5319060007',
    districtId: '5319060',
    name: 'Golo Munga',
  },
  {
    id: '5319060008',
    districtId: '5319060',
    name: 'Golo Rentung',
  },
  {
    id: '5319060009',
    districtId: '5319060',
    name: 'Golo Lembur',
  },
  {
    id: '5319060010',
    districtId: '5319060',
    name: 'Golo Nimbung',
  },
  {
    id: '5319060012',
    districtId: '5319060',
    name: 'Golo Mangung',
  },
  {
    id: '5319060013',
    districtId: '5319060',
    name: 'Satar Padut',
  },
  {
    id: '5319060014',
    districtId: '5319060',
    name: 'Nampar Tabang',
  },
  {
    id: '5319060015',
    districtId: '5319060',
    name: 'Liang Deruk',
  },
  {
    id: '5319060016',
    districtId: '5319060',
    name: 'Satar Punda',
  },
  {
    id: '5319060017',
    districtId: '5319060',
    name: 'Lamba Keli',
  },
  {
    id: '5319060018',
    districtId: '5319060',
    name: 'Goreng Meni Utara',
  },
  {
    id: '5319060019',
    districtId: '5319060',
    name: 'Golo Munga Barat',
  },
  {
    id: '5319060020',
    districtId: '5319060',
    name: 'Golo Paleng',
  },
  {
    id: '5319060021',
    districtId: '5319060',
    name: 'Haju Wangi',
  },
  {
    id: '5319060022',
    districtId: '5319060',
    name: 'Golo Wontong',
  },
  {
    id: '5319060023',
    districtId: '5319060',
    name: 'Satar Kampas',
  },
  {
    id: '5319060024',
    districtId: '5319060',
    name: 'Satar Punda Barat',
  },
  {
    id: '5320010001',
    districtId: '5320010',
    name: 'Kolorae',
  },
  {
    id: '5320010002',
    districtId: '5320010',
    name: 'Bolua',
  },
  {
    id: '5320010005',
    districtId: '5320010',
    name: 'Ballu',
  },
  {
    id: '5320020001',
    districtId: '5320020',
    name: 'Lobohede',
  },
  {
    id: '5320020002',
    districtId: '5320020',
    name: 'Ramedue',
  },
  {
    id: '5320020003',
    districtId: '5320020',
    name: 'Ledeae',
  },
  {
    id: '5320020004',
    districtId: '5320020',
    name: 'Gurimonearu',
  },
  {
    id: '5320020005',
    districtId: '5320020',
    name: 'Lederaga',
  },
  {
    id: '5320020006',
    districtId: '5320020',
    name: 'Molie',
  },
  {
    id: '5320020007',
    districtId: '5320020',
    name: 'Daieko',
  },
  {
    id: '5320020008',
    districtId: '5320020',
    name: 'Tanajawa',
  },
  {
    id: '5320020009',
    districtId: '5320020',
    name: 'Pedarro',
  },
  {
    id: '5320020010',
    districtId: '5320020',
    name: 'Wadumeddi',
  },
  {
    id: '5320030001',
    districtId: '5320030',
    name: 'Dainao',
  },
  {
    id: '5320030002',
    districtId: '5320030',
    name: 'Waduwala',
  },
  {
    id: '5320030003',
    districtId: '5320030',
    name: 'Raerobo',
  },
  {
    id: '5320030004',
    districtId: '5320030',
    name: 'Mehona',
  },
  {
    id: '5320030005',
    districtId: '5320030',
    name: 'Eikare',
  },
  {
    id: '5320030007',
    districtId: '5320030',
    name: 'Loborui',
  },
  {
    id: '5320030008',
    districtId: '5320030',
    name: 'Eilogo',
  },
  {
    id: '5320030009',
    districtId: '5320030',
    name: 'Halapaji',
  },
  {
    id: '5320030010',
    districtId: '5320030',
    name: 'Kotahawu',
  },
  {
    id: '5320030011',
    districtId: '5320030',
    name: 'Ledetalo',
  },
  {
    id: '5320040001',
    districtId: '5320040',
    name: 'Teriwu',
  },
  {
    id: '5320040002',
    districtId: '5320040',
    name: 'Raenalulu',
  },
  {
    id: '5320040004',
    districtId: '5320040',
    name: 'Titinalede',
  },
  {
    id: '5320040005',
    districtId: '5320040',
    name: 'Raemude',
  },
  {
    id: '5320040006',
    districtId: '5320040',
    name: 'Raenyale',
  },
  {
    id: '5320040007',
    districtId: '5320040',
    name: 'Raekore',
  },
  {
    id: '5320040008',
    districtId: '5320040',
    name: 'Nadawawi',
  },
  {
    id: '5320040009',
    districtId: '5320040',
    name: 'Delo',
  },
  {
    id: '5320040010',
    districtId: '5320040',
    name: 'Menia',
  },
  {
    id: '5320040011',
    districtId: '5320040',
    name: 'Raeloro',
  },
  {
    id: '5320040012',
    districtId: '5320040',
    name: 'Roboaba',
  },
  {
    id: '5320040013',
    districtId: '5320040',
    name: 'Mebba',
  },
  {
    id: '5320040014',
    districtId: '5320040',
    name: 'Raemadia',
  },
  {
    id: '5320040015',
    districtId: '5320040',
    name: 'Ledeana',
  },
  {
    id: '5320040016',
    districtId: '5320040',
    name: 'Jadu',
  },
  {
    id: '5320040017',
    districtId: '5320040',
    name: 'Ledekepaka',
  },
  {
    id: '5320040018',
    districtId: '5320040',
    name: 'Raedewa',
  },
  {
    id: '5320050001',
    districtId: '5320050',
    name: 'Bebae',
  },
  {
    id: '5320050002',
    districtId: '5320050',
    name: 'Tada',
  },
  {
    id: '5320050003',
    districtId: '5320050',
    name: 'Matei',
  },
  {
    id: '5320050004',
    districtId: '5320050',
    name: 'Eimmadake',
  },
  {
    id: '5320050005',
    districtId: '5320050',
    name: 'Loboaju',
  },
  {
    id: '5320050006',
    districtId: '5320050',
    name: 'Jiwuwu',
  },
  {
    id: '5320050007',
    districtId: '5320050',
    name: 'Eilode',
  },
  {
    id: '5320050008',
    districtId: '5320050',
    name: 'Eimau',
  },
  {
    id: '5320060001',
    districtId: '5320060',
    name: 'Huwaga',
  },
  {
    id: '5320060002',
    districtId: '5320060',
    name: 'Lobodei',
  },
  {
    id: '5320060003',
    districtId: '5320060',
    name: 'Eiada',
  },
  {
    id: '5320060005',
    districtId: '5320060',
    name: 'Bolou',
  },
  {
    id: '5320060006',
    districtId: '5320060',
    name: 'Limaggu',
  },
  {
    id: '5320060007',
    districtId: '5320060',
    name: 'Loborai',
  },
  {
    id: '5320060008',
    districtId: '5320060',
    name: 'Bodae',
  },
  {
    id: '5320060009',
    districtId: '5320060',
    name: 'Kujiratu',
  },
  {
    id: '5320060010',
    districtId: '5320060',
    name: 'Keliha',
  },
  {
    id: '5321010001',
    districtId: '5321010',
    name: 'Lamea',
  },
  {
    id: '5321010002',
    districtId: '5321010',
    name: 'Alkani',
  },
  {
    id: '5321010004',
    districtId: '5321010',
    name: 'Seserai',
  },
  {
    id: '5321010005',
    districtId: '5321010',
    name: 'Lorotolus',
  },
  {
    id: '5321010006',
    districtId: '5321010',
    name: 'Biris',
  },
  {
    id: '5321010008',
    districtId: '5321010',
    name: 'Weoe',
  },
  {
    id: '5321010009',
    districtId: '5321010',
    name: 'Badarai',
  },
  {
    id: '5321010010',
    districtId: '5321010',
    name: 'Webriamata',
  },
  {
    id: '5321010011',
    districtId: '5321010',
    name: 'Rabasa Biris',
  },
  {
    id: '5321010012',
    districtId: '5321010',
    name: 'Halibasar',
  },
  {
    id: '5321020001',
    districtId: '5321020',
    name: 'Rabasa',
  },
  {
    id: '5321020002',
    districtId: '5321020',
    name: 'Rabasa Haerain',
  },
  {
    id: '5321020003',
    districtId: '5321020',
    name: 'Loofoun',
  },
  {
    id: '5321020004',
    districtId: '5321020',
    name: 'Raimataus',
  },
  {
    id: '5321020005',
    districtId: '5321020',
    name: 'Rabasahain',
  },
  {
    id: '5321020006',
    districtId: '5321020',
    name: 'Umalor',
  },
  {
    id: '5321020007',
    districtId: '5321020',
    name: 'Umatoos',
  },
  {
    id: '5321020008',
    districtId: '5321020',
    name: 'Motaain',
  },
  {
    id: '5321020009',
    districtId: '5321020',
    name: 'Oan Mane',
  },
  {
    id: '5321020010',
    districtId: '5321020',
    name: 'Fafoe',
  },
  {
    id: '5321020011',
    districtId: '5321020',
    name: 'Sikun',
  },
  {
    id: '5321020012',
    districtId: '5321020',
    name: 'Lasaen',
  },
  {
    id: '5321020013',
    districtId: '5321020',
    name: 'Besikama',
  },
  {
    id: '5321020014',
    districtId: '5321020',
    name: 'Maktihan',
  },
  {
    id: '5321020015',
    districtId: '5321020',
    name: 'Naas',
  },
  {
    id: '5321020016',
    districtId: '5321020',
    name: 'Motaulun',
  },
  {
    id: '5321030001',
    districtId: '5321030',
    name: 'Taaba',
  },
  {
    id: '5321030002',
    districtId: '5321030',
    name: 'Leunklot',
  },
  {
    id: '5321030003',
    districtId: '5321030',
    name: 'Umalawain',
  },
  {
    id: '5321030004',
    districtId: '5321030',
    name: 'Bonetasea',
  },
  {
    id: '5321030005',
    districtId: '5321030',
    name: 'Hauklaran',
  },
  {
    id: '5321030006',
    districtId: '5321030',
    name: 'Lakulo',
  },
  {
    id: '5321030007',
    districtId: '5321030',
    name: 'Kleseleon',
  },
  {
    id: '5321030008',
    districtId: '5321030',
    name: 'Laleten',
  },
  {
    id: '5321030010',
    districtId: '5321030',
    name: 'Haitimuk',
  },
  {
    id: '5321030011',
    districtId: '5321030',
    name: 'Angkaes',
  },
  {
    id: '5321030012',
    districtId: '5321030',
    name: 'Wederok',
  },
  {
    id: '5321030013',
    districtId: '5321030',
    name: 'Lamudur',
  },
  {
    id: '5321030014',
    districtId: '5321030',
    name: 'Forekmodok',
  },
  {
    id: '5321040001',
    districtId: '5321040',
    name: 'Saenama',
  },
  {
    id: '5321040002',
    districtId: '5321040',
    name: 'Raisamane',
  },
  {
    id: '5321040003',
    districtId: '5321040',
    name: 'Wekmidar',
  },
  {
    id: '5321040005',
    districtId: '5321040',
    name: 'Lotas',
  },
  {
    id: '5321040006',
    districtId: '5321040',
    name: 'Naiusu',
  },
  {
    id: '5321040007',
    districtId: '5321040',
    name: 'Nanin',
  },
  {
    id: '5321040009',
    districtId: '5321040',
    name: 'Weain',
  },
  {
    id: '5321040010',
    districtId: '5321040',
    name: 'Biudukfoho',
  },
  {
    id: '5321040011',
    districtId: '5321040',
    name: 'Nabutaek',
  },
  {
    id: '5321040012',
    districtId: '5321040',
    name: 'Niti',
  },
  {
    id: '5321040013',
    districtId: '5321040',
    name: 'Tafuli I',
  },
  {
    id: '5321040014',
    districtId: '5321040',
    name: 'B O E N',
  },
  {
    id: '5321040016',
    districtId: '5321040',
    name: 'Tafuli',
  },
  {
    id: '5321040017',
    districtId: '5321040',
    name: 'N A E  T',
  },
  {
    id: '5321040018',
    districtId: '5321040',
    name: 'Wekmurak',
  },
  {
    id: '5321040019',
    districtId: '5321040',
    name: 'Alala',
  },
  {
    id: '5321040020',
    districtId: '5321040',
    name: 'Nanebot',
  },
  {
    id: '5321050001',
    districtId: '5321050',
    name: 'Fatoin',
  },
  {
    id: '5321050002',
    districtId: '5321050',
    name: 'Bani Bani',
  },
  {
    id: '5321050003',
    districtId: '5321050',
    name: 'Tunmat',
  },
  {
    id: '5321050004',
    districtId: '5321050',
    name: 'Ikan Tunabeis',
  },
  {
    id: '5321050006',
    districtId: '5321050',
    name: 'Tunabesi',
  },
  {
    id: '5321050007',
    districtId: '5321050',
    name: 'Biau',
  },
  {
    id: '5321060001',
    districtId: '5321060',
    name: 'Manumutin Silole',
  },
  {
    id: '5321060002',
    districtId: '5321060',
    name: 'Fatuaruin',
  },
  {
    id: '5321060003',
    districtId: '5321060',
    name: 'Builaran',
  },
  {
    id: '5321060004',
    districtId: '5321060',
    name: 'Naibone',
  },
  {
    id: '5321060005',
    districtId: '5321060',
    name: 'Beaneno',
  },
  {
    id: '5321060006',
    districtId: '5321060',
    name: 'Manulea',
  },
  {
    id: '5321060007',
    districtId: '5321060',
    name: 'Umutnana',
  },
  {
    id: '5321060008',
    districtId: '5321060',
    name: 'As Manulea',
  },
  {
    id: '5321060009',
    districtId: '5321060',
    name: 'Naisau',
  },
  {
    id: '5321070001',
    districtId: '5321070',
    name: 'Barene',
  },
  {
    id: '5321070002',
    districtId: '5321070',
    name: 'Kakaniuk',
  },
  {
    id: '5321070003',
    districtId: '5321070',
    name: 'Bakiruk',
  },
  {
    id: '5321070004',
    districtId: '5321070',
    name: 'Wehali',
  },
  {
    id: '5321070005',
    districtId: '5321070',
    name: 'Umanenlawalu',
  },
  {
    id: '5321070006',
    districtId: '5321070',
    name: 'Bereliku',
  },
  {
    id: '5321070007',
    districtId: '5321070',
    name: 'Naimana',
  },
  {
    id: '5321070008',
    districtId: '5321070',
    name: 'Fahiluka',
  },
  {
    id: '5321070009',
    districtId: '5321070',
    name: 'Lawalu',
  },
  {
    id: '5321070010',
    districtId: '5321070',
    name: 'Railor Tahak',
  },
  {
    id: '5321070011',
    districtId: '5321070',
    name: 'Suai',
  },
  {
    id: '5321070013',
    districtId: '5321070',
    name: 'Umakatahan',
  },
  {
    id: '5321070014',
    districtId: '5321070',
    name: 'UPT Harekakae',
  },
  {
    id: '5321070015',
    districtId: '5321070',
    name: 'Kamanasa',
  },
  {
    id: '5321070016',
    districtId: '5321070',
    name: 'Barada',
  },
  {
    id: '5321070017',
    districtId: '5321070',
    name: 'Kateri',
  },
  {
    id: '5321080001',
    districtId: '5321080',
    name: 'Babotin Selatan',
  },
  {
    id: '5321080002',
    districtId: '5321080',
    name: 'Babotin',
  },
  {
    id: '5321080003',
    districtId: '5321080',
    name: 'Babotin Maemina',
  },
  {
    id: '5321080004',
    districtId: '5321080',
    name: 'Takarai',
  },
  {
    id: '5321080005',
    districtId: '5321080',
    name: 'Kereana',
  },
  {
    id: '5321090002',
    districtId: '5321090',
    name: 'Uabau',
  },
  {
    id: '5321090003',
    districtId: '5321090',
    name: 'Bonibais',
  },
  {
    id: '5321090004',
    districtId: '5321090',
    name: 'Naekekusa',
  },
  {
    id: '5321090005',
    districtId: '5321090',
    name: 'Oenaek',
  },
  {
    id: '5321090006',
    districtId: '5321090',
    name: 'Kapitanmeo',
  },
  {
    id: '5321090007',
    districtId: '5321090',
    name: 'Tniumanu',
  },
  {
    id: '5321090008',
    districtId: '5321090',
    name: 'Tesa',
  },
  {
    id: '5321090009',
    districtId: '5321090',
    name: 'Meotroy',
  },
  {
    id: '5321100001',
    districtId: '5321100',
    name: 'Numponi',
  },
  {
    id: '5321100002',
    districtId: '5321100',
    name: 'Sanleo',
  },
  {
    id: '5321100003',
    districtId: '5321100',
    name: 'Dirma',
  },
  {
    id: '5321100004',
    districtId: '5321100',
    name: 'Wemeda',
  },
  {
    id: '5321100005',
    districtId: '5321100',
    name: 'Raiulun',
  },
  {
    id: '5321100006',
    districtId: '5321100',
    name: 'Kusa',
  },
  {
    id: '5321110001',
    districtId: '5321110',
    name: 'Lakekun Barat',
  },
  {
    id: '5321110002',
    districtId: '5321110',
    name: 'Lakekun',
  },
  {
    id: '5321110003',
    districtId: '5321110',
    name: 'Lakekun Utara',
  },
  {
    id: '5321110004',
    districtId: '5321110',
    name: 'Litamali',
  },
  {
    id: '5321110005',
    districtId: '5321110',
    name: 'Rainawe',
  },
  {
    id: '5321110006',
    districtId: '5321110',
    name: 'S I S I',
  },
  {
    id: '5321110007',
    districtId: '5321110',
    name: 'Babulu Selatan',
  },
  {
    id: '5321110008',
    districtId: '5321110',
    name: 'Babulu',
  },
  {
    id: '5321120001',
    districtId: '5321120',
    name: 'Alas Selatan',
  },
  {
    id: '5321120002',
    districtId: '5321120',
    name: 'Alas',
  },
  {
    id: '5321120003',
    districtId: '5321120',
    name: 'Kotabiru',
  },
  {
    id: '5321120004',
    districtId: '5321120',
    name: 'Alas Utara',
  },
  {
    id: '5371010001',
    districtId: '5371010',
    name: 'Naioni',
  },
  {
    id: '5371010002',
    districtId: '5371010',
    name: 'Manulai II',
  },
  {
    id: '5371010003',
    districtId: '5371010',
    name: 'Batuplat',
  },
  {
    id: '5371010004',
    districtId: '5371010',
    name: 'Alak',
  },
  {
    id: '5371010005',
    districtId: '5371010',
    name: 'Manutapen',
  },
  {
    id: '5371010006',
    districtId: '5371010',
    name: 'Mantasi',
  },
  {
    id: '5371010007',
    districtId: '5371010',
    name: 'Fatufeto',
  },
  {
    id: '5371010008',
    districtId: '5371010',
    name: 'Nunhila',
  },
  {
    id: '5371010009',
    districtId: '5371010',
    name: 'Nunbaun Delha',
  },
  {
    id: '5371010010',
    districtId: '5371010',
    name: 'Nunbaun Sabu',
  },
  {
    id: '5371010011',
    districtId: '5371010',
    name: 'Namosain',
  },
  {
    id: '5371010012',
    districtId: '5371010',
    name: 'Penkase-Oeleta',
  },
  {
    id: '5371020001',
    districtId: '5371020',
    name: 'Fatukoa',
  },
  {
    id: '5371020002',
    districtId: '5371020',
    name: 'Sikumana',
  },
  {
    id: '5371020003',
    districtId: '5371020',
    name: 'Bello',
  },
  {
    id: '5371020004',
    districtId: '5371020',
    name: 'Kolhua',
  },
  {
    id: '5371020005',
    districtId: '5371020',
    name: 'Penfui',
  },
  {
    id: '5371020006',
    districtId: '5371020',
    name: 'Naimata',
  },
  {
    id: '5371020007',
    districtId: '5371020',
    name: 'Maulafa',
  },
  {
    id: '5371020008',
    districtId: '5371020',
    name: 'Oepura',
  },
  {
    id: '5371020009',
    districtId: '5371020',
    name: 'Naikolan',
  },
  {
    id: '5371030008',
    districtId: '5371030',
    name: 'Oetete',
  },
  {
    id: '5371030009',
    districtId: '5371030',
    name: 'Oebobo',
  },
  {
    id: '5371030010',
    districtId: '5371030',
    name: 'Fatululi',
  },
  {
    id: '5371030011',
    districtId: '5371030',
    name: 'Oebufu',
  },
  {
    id: '5371030012',
    districtId: '5371030',
    name: 'Tuak Daun Merah',
  },
  {
    id: '5371030013',
    districtId: '5371030',
    name: 'Kayu Putih',
  },
  {
    id: '5371030014',
    districtId: '5371030',
    name: 'Liliba',
  },
  {
    id: '5371031001',
    districtId: '5371031',
    name: 'Bakunase',
  },
  {
    id: '5371031002',
    districtId: '5371031',
    name: 'Bakunase II',
  },
  {
    id: '5371031003',
    districtId: '5371031',
    name: 'Air Nona',
  },
  {
    id: '5371031004',
    districtId: '5371031',
    name: 'Naikoten I',
  },
  {
    id: '5371031005',
    districtId: '5371031',
    name: 'Naikoten II',
  },
  {
    id: '5371031006',
    districtId: '5371031',
    name: 'Kuanino',
  },
  {
    id: '5371031008',
    districtId: '5371031',
    name: 'Fontein',
  },
  {
    id: '5371040011',
    districtId: '5371040',
    name: 'Kelapa Lima',
  },
  {
    id: '5371040012',
    districtId: '5371040',
    name: 'Oesapa',
  },
  {
    id: '5371040013',
    districtId: '5371040',
    name: 'Oesapa Barat',
  },
  {
    id: '5371040014',
    districtId: '5371040',
    name: 'Oesapa Selatan',
  },
  {
    id: '5371040015',
    districtId: '5371040',
    name: 'Lasiana',
  },
  {
    id: '5371041001',
    districtId: '5371041',
    name: 'Air Mata',
  },
  {
    id: '5371041002',
    districtId: '5371041',
    name: 'Lahilai Bissi Kopan',
  },
  {
    id: '5371041003',
    districtId: '5371041',
    name: 'Bonipoi',
  },
  {
    id: '5371041004',
    districtId: '5371041',
    name: 'Merdeka',
  },
  {
    id: '5371041005',
    districtId: '5371041',
    name: 'Solor',
  },
  {
    id: '5371041006',
    districtId: '5371041',
    name: 'Todekisar',
  },
  {
    id: '5371041007',
    districtId: '5371041',
    name: 'Oeba',
  },
  {
    id: '5371041008',
    districtId: '5371041',
    name: 'Fatubesi',
  },
  {
    id: '5371041009',
    districtId: '5371041',
    name: 'Nefonaek',
  },
  {
    id: '5371041010',
    districtId: '5371041',
    name: 'Pasir Panjang',
  },
  {
    id: '6101010001',
    districtId: '6101010',
    name: 'Semelagi Besar',
  },
  {
    id: '6101010002',
    districtId: '6101010',
    name: 'Sungai Daun',
  },
  {
    id: '6101010003',
    districtId: '6101010',
    name: 'Sungai Rusa',
  },
  {
    id: '6101010004',
    districtId: '6101010',
    name: 'Pangkalan Bemban',
  },
  {
    id: '6101010005',
    districtId: '6101010',
    name: 'Sungai Nyirih',
  },
  {
    id: '6101010006',
    districtId: '6101010',
    name: 'Kuala',
  },
  {
    id: '6101010007',
    districtId: '6101010',
    name: 'Parit Baru',
  },
  {
    id: '6101010008',
    districtId: '6101010',
    name: 'Twi Mentibar',
  },
  {
    id: '6101010009',
    districtId: '6101010',
    name: 'Bentunai',
  },
  {
    id: '6101010010',
    districtId: '6101010',
    name: 'Parit Kongsi',
  },
  {
    id: '6101010011',
    districtId: '6101010',
    name: 'Gayung Bersambut',
  },
  {
    id: '6101011001',
    districtId: '6101011',
    name: 'Gelik',
  },
  {
    id: '6101011002',
    districtId: '6101011',
    name: 'Seranggam',
  },
  {
    id: '6101011003',
    districtId: '6101011',
    name: 'Selakau Tua',
  },
  {
    id: '6101011004',
    districtId: '6101011',
    name: 'Buduk Sempadang',
  },
  {
    id: '6101020011',
    districtId: '6101020',
    name: 'Perapakan',
  },
  {
    id: '6101020013',
    districtId: '6101020',
    name: 'Harapan',
  },
  {
    id: '6101020014',
    districtId: '6101020',
    name: 'Penjajap',
  },
  {
    id: '6101020015',
    districtId: '6101020',
    name: 'Pemangkat Kota',
  },
  {
    id: '6101020016',
    districtId: '6101020',
    name: 'Sebatuan',
  },
  {
    id: '6101020017',
    districtId: '6101020',
    name: 'Gugah Sejahtera',
  },
  {
    id: '6101020018',
    districtId: '6101020',
    name: 'Lonam',
  },
  {
    id: '6101021001',
    districtId: '6101021',
    name: 'Seburing',
  },
  {
    id: '6101021002',
    districtId: '6101021',
    name: 'Sepadu',
  },
  {
    id: '6101021003',
    districtId: '6101021',
    name: 'Sepinggan',
  },
  {
    id: '6101021004',
    districtId: '6101021',
    name: 'Semparuk',
  },
  {
    id: '6101021005',
    districtId: '6101021',
    name: 'Singaraya',
  },
  {
    id: '6101022001',
    districtId: '6101022',
    name: 'Parit Baru',
  },
  {
    id: '6101022002',
    districtId: '6101022',
    name: 'Salatiga',
  },
  {
    id: '6101022003',
    districtId: '6101022',
    name: 'Sungai Toman',
  },
  {
    id: '6101022005',
    districtId: '6101022',
    name: 'Serunai',
  },
  {
    id: '6101030001',
    districtId: '6101030',
    name: 'Seret Ayon',
  },
  {
    id: '6101030002',
    districtId: '6101030',
    name: 'Maribas',
  },
  {
    id: '6101030003',
    districtId: '6101030',
    name: 'Batu Makjage',
  },
  {
    id: '6101030004',
    districtId: '6101030',
    name: 'Bukit Segoler',
  },
  {
    id: '6101030005',
    districtId: '6101030',
    name: 'Serindang',
  },
  {
    id: '6101030006',
    districtId: '6101030',
    name: 'Matang Labung',
  },
  {
    id: '6101030007',
    districtId: '6101030',
    name: 'Mak Tangguk',
  },
  {
    id: '6101030008',
    districtId: '6101030',
    name: 'Segedong',
  },
  {
    id: '6101030009',
    districtId: '6101030',
    name: 'Pusaka',
  },
  {
    id: '6101030011',
    districtId: '6101030',
    name: 'Sungai Kelambu',
  },
  {
    id: '6101030013',
    districtId: '6101030',
    name: 'Pangkalan Kongsi',
  },
  {
    id: '6101030014',
    districtId: '6101030',
    name: 'Dungun Perapakan',
  },
  {
    id: '6101030015',
    districtId: '6101030',
    name: 'Tebas Sungai',
  },
  {
    id: '6101030016',
    districtId: '6101030',
    name: 'Sejiram',
  },
  {
    id: '6101030017',
    districtId: '6101030',
    name: 'Seberkat',
  },
  {
    id: '6101030018',
    districtId: '6101030',
    name: 'Sempalai',
  },
  {
    id: '6101030020',
    districtId: '6101030',
    name: 'Mak Rampai',
  },
  {
    id: '6101030021',
    districtId: '6101030',
    name: 'Tebas Kuala',
  },
  {
    id: '6101030022',
    districtId: '6101030',
    name: 'Mekar Sekuntum',
  },
  {
    id: '6101030023',
    districtId: '6101030',
    name: 'Segarau Parit',
  },
  {
    id: '6101031001',
    districtId: '6101031',
    name: 'Matang Segarau',
  },
  {
    id: '6101031002',
    districtId: '6101031',
    name: 'Rambayan',
  },
  {
    id: '6101031003',
    districtId: '6101031',
    name: 'Sari Makmur',
  },
  {
    id: '6101031004',
    districtId: '6101031',
    name: 'Tekarang',
  },
  {
    id: '6101031005',
    districtId: '6101031',
    name: 'Sempadian',
  },
  {
    id: '6101031006',
    districtId: '6101031',
    name: 'Cepala',
  },
  {
    id: '6101031007',
    districtId: '6101031',
    name: 'Merubong',
  },
  {
    id: '6101040019',
    districtId: '6101040',
    name: 'Sei Rambah',
  },
  {
    id: '6101040020',
    districtId: '6101040',
    name: 'Gapura',
  },
  {
    id: '6101040021',
    districtId: '6101040',
    name: 'Kartiasa',
  },
  {
    id: '6101040022',
    districtId: '6101040',
    name: 'Saing Rambi',
  },
  {
    id: '6101040023',
    districtId: '6101040',
    name: 'Lumbang',
  },
  {
    id: '6101040024',
    districtId: '6101040',
    name: 'Durian',
  },
  {
    id: '6101040025',
    districtId: '6101040',
    name: 'Pasar Melayu',
  },
  {
    id: '6101040026',
    districtId: '6101040',
    name: 'Pendawan',
  },
  {
    id: '6101040027',
    districtId: '6101040',
    name: 'Tanjung Bugis',
  },
  {
    id: '6101040028',
    districtId: '6101040',
    name: 'Lubuk Dagang',
  },
  {
    id: '6101040029',
    districtId: '6101040',
    name: 'Dalam Kaum',
  },
  {
    id: '6101040030',
    districtId: '6101040',
    name: 'Tanjung Mekar',
  },
  {
    id: '6101040031',
    districtId: '6101040',
    name: 'Tumuk Manggis',
  },
  {
    id: '6101040032',
    districtId: '6101040',
    name: 'Jagur',
  },
  {
    id: '6101040033',
    districtId: '6101040',
    name: 'Lorong',
  },
  {
    id: '6101040034',
    districtId: '6101040',
    name: 'Sebayan',
  },
  {
    id: '6101040035',
    districtId: '6101040',
    name: 'Sumber Harapan',
  },
  {
    id: '6101040040',
    districtId: '6101040',
    name: 'Semangau',
  },
  {
    id: '6101041001',
    districtId: '6101041',
    name: 'Tebuah Elok',
  },
  {
    id: '6101041002',
    districtId: '6101041',
    name: 'Mensade',
  },
  {
    id: '6101041003',
    districtId: '6101041',
    name: 'Sei Sapak',
  },
  {
    id: '6101041004',
    districtId: '6101041',
    name: 'Sempurna',
  },
  {
    id: '6101041005',
    districtId: '6101041',
    name: 'Bukit Mulya',
  },
  {
    id: '6101041006',
    districtId: '6101041',
    name: 'Sei Deden',
  },
  {
    id: '6101041007',
    districtId: '6101041',
    name: 'Sabung',
  },
  {
    id: '6101041008',
    districtId: '6101041',
    name: 'Mukti Raharja',
  },
  {
    id: '6101041009',
    districtId: '6101041',
    name: 'Karaban Jaya',
  },
  {
    id: '6101041010',
    districtId: '6101041',
    name: 'Balai Gemuruh',
  },
  {
    id: '6101041011',
    districtId: '6101041',
    name: 'Madak',
  },
  {
    id: '6101042001',
    districtId: '6101042',
    name: 'Sebawi',
  },
  {
    id: '6101042002',
    districtId: '6101042',
    name: 'Sempelai Sebedang',
  },
  {
    id: '6101042003',
    districtId: '6101042',
    name: 'Sepuk Tanjung',
  },
  {
    id: '6101042004',
    districtId: '6101042',
    name: 'Sebangun',
  },
  {
    id: '6101042005',
    districtId: '6101042',
    name: 'Tempatan',
  },
  {
    id: '6101042006',
    districtId: '6101042',
    name: 'Tebing Batu',
  },
  {
    id: '6101042007',
    districtId: '6101042',
    name: 'Semanjang',
  },
  {
    id: '6101043001',
    districtId: '6101043',
    name: 'Jirak',
  },
  {
    id: '6101043002',
    districtId: '6101043',
    name: 'Tengguli',
  },
  {
    id: '6101043003',
    districtId: '6101043',
    name: 'Mekar Jaya',
  },
  {
    id: '6101043004',
    districtId: '6101043',
    name: 'Beringin',
  },
  {
    id: '6101050010',
    districtId: '6101050',
    name: 'Dungun Laut',
  },
  {
    id: '6101050011',
    districtId: '6101050',
    name: 'Sentebang',
  },
  {
    id: '6101050012',
    districtId: '6101050',
    name: 'Sei Nyirih',
  },
  {
    id: '6101050013',
    districtId: '6101050',
    name: 'Bakau',
  },
  {
    id: '6101050014',
    districtId: '6101050',
    name: 'Parit Setia',
  },
  {
    id: '6101050015',
    districtId: '6101050',
    name: 'Pelimpaan',
  },
  {
    id: '6101050016',
    districtId: '6101050',
    name: 'Sarang Burung Kuala',
  },
  {
    id: '6101050017',
    districtId: '6101050',
    name: 'Sarang Burung Usrat',
  },
  {
    id: '6101050018',
    districtId: '6101050',
    name: 'Sarang Burung Kolam',
  },
  {
    id: '6101050019',
    districtId: '6101050',
    name: 'Sei Nilam',
  },
  {
    id: '6101050020',
    districtId: '6101050',
    name: 'Sarang Burung Danau',
  },
  {
    id: '6101050021',
    districtId: '6101050',
    name: 'Lambau',
  },
  {
    id: '6101050022',
    districtId: '6101050',
    name: 'Mutus Darussalam',
  },
  {
    id: '6101051001',
    districtId: '6101051',
    name: 'Jawai Laut',
  },
  {
    id: '6101051002',
    districtId: '6101051',
    name: 'Jelu Air',
  },
  {
    id: '6101051003',
    districtId: '6101051',
    name: 'Sarilaba B',
  },
  {
    id: '6101051004',
    districtId: '6101051',
    name: 'Semperiuk B',
  },
  {
    id: '6101051005',
    districtId: '6101051',
    name: 'Sabaran',
  },
  {
    id: '6101051006',
    districtId: '6101051',
    name: 'Semperiuk A',
  },
  {
    id: '6101051007',
    districtId: '6101051',
    name: 'Sarilaba A',
  },
  {
    id: '6101051008',
    districtId: '6101051',
    name: 'Matang Terap',
  },
  {
    id: '6101051009',
    districtId: '6101051',
    name: 'Suah Api',
  },
  {
    id: '6101060001',
    districtId: '6101060',
    name: 'Teluk Kaseh',
  },
  {
    id: '6101060002',
    districtId: '6101060',
    name: 'Sengawang',
  },
  {
    id: '6101060003',
    districtId: '6101060',
    name: 'Sungai Baru',
  },
  {
    id: '6101060004',
    districtId: '6101060',
    name: 'Berlimang',
  },
  {
    id: '6101060005',
    districtId: '6101060',
    name: 'Puringan',
  },
  {
    id: '6101060006',
    districtId: '6101060',
    name: 'Kubangga',
  },
  {
    id: '6101060007',
    districtId: '6101060',
    name: 'Tambatan',
  },
  {
    id: '6101060008',
    districtId: '6101060',
    name: 'Lela',
  },
  {
    id: '6101060009',
    districtId: '6101060',
    name: 'Sungai Kumpai',
  },
  {
    id: '6101060010',
    districtId: '6101060',
    name: 'Sekura',
  },
  {
    id: '6101060011',
    districtId: '6101060',
    name: 'Sepadu',
  },
  {
    id: '6101060012',
    districtId: '6101060',
    name: 'Tanjung Keracut',
  },
  {
    id: '6101060013',
    districtId: '6101060',
    name: 'Sebagu',
  },
  {
    id: '6101060019',
    districtId: '6101060',
    name: 'Kuala Pangkalan Keramat',
  },
  {
    id: '6101060020',
    districtId: '6101060',
    name: 'Mekar Sekuntum',
  },
  {
    id: '6101060021',
    districtId: '6101060',
    name: 'Teluk Kembang',
  },
  {
    id: '6101060022',
    districtId: '6101060',
    name: 'Sungai Serabek',
  },
  {
    id: '6101060023',
    districtId: '6101060',
    name: 'Pedada',
  },
  {
    id: '6101060024',
    districtId: '6101060',
    name: 'Tri Mandayan',
  },
  {
    id: '6101060025',
    districtId: '6101060',
    name: 'Sayang Sedayu',
  },
  {
    id: '6101060026',
    districtId: '6101060',
    name: 'Samustida',
  },
  {
    id: '6101060027',
    districtId: '6101060',
    name: 'Pipit Teja',
  },
  {
    id: '6101060035',
    districtId: '6101060',
    name: 'Mulia',
  },
  {
    id: '6101060036',
    districtId: '6101060',
    name: 'Matang Segantar',
  },
  {
    id: '6101060037',
    districtId: '6101060',
    name: 'Sabing',
  },
  {
    id: '6101061001',
    districtId: '6101061',
    name: 'Ratu Sepudak',
  },
  {
    id: '6101061002',
    districtId: '6101061',
    name: 'Sungai Palah',
  },
  {
    id: '6101061003',
    districtId: '6101061',
    name: 'Sagu',
  },
  {
    id: '6101061004',
    districtId: '6101061',
    name: 'Tempapan Kuala',
  },
  {
    id: '6101061005',
    districtId: '6101061',
    name: 'Galing',
  },
  {
    id: '6101061006',
    districtId: '6101061',
    name: 'Tempapan Hulu',
  },
  {
    id: '6101061007',
    districtId: '6101061',
    name: 'Tri Kembang',
  },
  {
    id: '6101061008',
    districtId: '6101061',
    name: 'Tri Gaduh',
  },
  {
    id: '6101061009',
    districtId: '6101061',
    name: 'Sijang',
  },
  {
    id: '6101061010',
    districtId: '6101061',
    name: 'Teluk Pandan',
  },
  {
    id: '6101062001',
    districtId: '6101062',
    name: 'Semata',
  },
  {
    id: '6101062002',
    districtId: '6101062',
    name: 'Tangaran',
  },
  {
    id: '6101062003',
    districtId: '6101062',
    name: 'Merpati',
  },
  {
    id: '6101062004',
    districtId: '6101062',
    name: 'Simpang Empat',
  },
  {
    id: '6101062005',
    districtId: '6101062',
    name: 'Pancur',
  },
  {
    id: '6101062006',
    districtId: '6101062',
    name: 'Arung Parak',
  },
  {
    id: '6101062007',
    districtId: '6101062',
    name: 'Merabuan',
  },
  {
    id: '6101062008',
    districtId: '6101062',
    name: 'Arung Medang',
  },
  {
    id: '6101070001',
    districtId: '6101070',
    name: 'Sepantai',
  },
  {
    id: '6101070002',
    districtId: '6101070',
    name: 'Semanga',
  },
  {
    id: '6101070003',
    districtId: '6101070',
    name: 'Perigi Limus',
  },
  {
    id: '6101070005',
    districtId: '6101070',
    name: 'Sendoyan',
  },
  {
    id: '6101070006',
    districtId: '6101070',
    name: 'Perigi Landu',
  },
  {
    id: '6101070007',
    districtId: '6101070',
    name: 'Parit Raja',
  },
  {
    id: '6101070008',
    districtId: '6101070',
    name: 'Piantus',
  },
  {
    id: '6101070010',
    districtId: '6101070',
    name: 'Setalik',
  },
  {
    id: '6101070011',
    districtId: '6101070',
    name: 'Penakalan',
  },
  {
    id: '6101080001',
    districtId: '6101080',
    name: "Sebunga'",
  },
  {
    id: '6101080002',
    districtId: '6101080',
    name: "Kaliau'",
  },
  {
    id: '6101080003',
    districtId: '6101080',
    name: 'Sanatab',
  },
  {
    id: '6101080004',
    districtId: '6101080',
    name: 'Santaban',
  },
  {
    id: '6101080005',
    districtId: '6101080',
    name: 'Sei Bening',
  },
  {
    id: '6101090001',
    districtId: '6101090',
    name: 'Kalimantan',
  },
  {
    id: '6101090002',
    districtId: '6101090',
    name: 'Matang Danau',
  },
  {
    id: '6101090003',
    districtId: '6101090',
    name: 'Tanah Hitam',
  },
  {
    id: '6101090004',
    districtId: '6101090',
    name: 'Malek',
  },
  {
    id: '6101090005',
    districtId: '6101090',
    name: 'Nibung',
  },
  {
    id: '6101090007',
    districtId: '6101090',
    name: 'Temajuk',
  },
  {
    id: '6101090008',
    districtId: '6101090',
    name: 'Mentibar',
  },
  {
    id: '6102010001',
    districtId: '6102010',
    name: 'Sungai Duri',
  },
  {
    id: '6102010002',
    districtId: '6102010',
    name: 'Sungai Jaga A',
  },
  {
    id: '6102010003',
    districtId: '6102010',
    name: 'Sungai Jaga B',
  },
  {
    id: '6102010006',
    districtId: '6102010',
    name: 'Sungai Pangkalan I',
  },
  {
    id: '6102010007',
    districtId: '6102010',
    name: 'Sungai Pangkalan II',
  },
  {
    id: '6102011001',
    districtId: '6102011',
    name: 'Capkala',
  },
  {
    id: '6102011002',
    districtId: '6102011',
    name: 'Sebandut',
  },
  {
    id: '6102011003',
    districtId: '6102011',
    name: 'Aris',
  },
  {
    id: '6102011004',
    districtId: '6102011',
    name: 'Mandor',
  },
  {
    id: '6102011005',
    districtId: '6102011',
    name: 'Setanduk',
  },
  {
    id: '6102011006',
    districtId: '6102011',
    name: 'Pawangi',
  },
  {
    id: '6102012001',
    districtId: '6102012',
    name: 'Rukmajaya',
  },
  {
    id: '6102012002',
    districtId: '6102012',
    name: 'Sungai Keran',
  },
  {
    id: '6102012003',
    districtId: '6102012',
    name: 'Sungai Raya',
  },
  {
    id: '6102012004',
    districtId: '6102012',
    name: 'Karimunting',
  },
  {
    id: '6102012005',
    districtId: '6102012',
    name: 'Pulau Lemukutan',
  },
  {
    id: '6102030004',
    districtId: '6102030',
    name: 'Sabau',
  },
  {
    id: '6102030005',
    districtId: '6102030',
    name: 'Tumiang',
  },
  {
    id: '6102030006',
    districtId: '6102030',
    name: 'Pastijaya',
  },
  {
    id: '6102030007',
    districtId: '6102030',
    name: 'Babane',
  },
  {
    id: '6102030008',
    districtId: '6102030',
    name: 'Bukit Serayan',
  },
  {
    id: '6102030009',
    districtId: '6102030',
    name: 'Marunsu',
  },
  {
    id: '6102030010',
    districtId: '6102030',
    name: 'Samalantan',
  },
  {
    id: '6102031001',
    districtId: '6102031',
    name: 'Goa Boma',
  },
  {
    id: '6102031002',
    districtId: '6102031',
    name: 'Monterado',
  },
  {
    id: '6102031003',
    districtId: '6102031',
    name: 'Serindu',
  },
  {
    id: '6102031004',
    districtId: '6102031',
    name: 'Beringin Baru',
  },
  {
    id: '6102031005',
    districtId: '6102031',
    name: 'Gerantung',
  },
  {
    id: '6102031007',
    districtId: '6102031',
    name: 'Jahandung',
  },
  {
    id: '6102031008',
    districtId: '6102031',
    name: 'Siaga',
  },
  {
    id: '6102031009',
    districtId: '6102031',
    name: 'Nek Ginap',
  },
  {
    id: '6102031011',
    districtId: '6102031',
    name: 'Sendoreng',
  },
  {
    id: '6102031012',
    districtId: '6102031',
    name: 'Rantau',
  },
  {
    id: '6102031013',
    districtId: '6102031',
    name: 'Mekar Baru',
  },
  {
    id: '6102032001',
    districtId: '6102032',
    name: 'Godang Damar',
  },
  {
    id: '6102032002',
    districtId: '6102032',
    name: 'Kinande',
  },
  {
    id: '6102032003',
    districtId: '6102032',
    name: 'Tempapan',
  },
  {
    id: '6102032004',
    districtId: '6102032',
    name: 'Papan Uduk',
  },
  {
    id: '6102032005',
    districtId: '6102032',
    name: 'Papan Tembawang',
  },
  {
    id: '6102032006',
    districtId: '6102032',
    name: 'Lembah Bawang',
  },
  {
    id: '6102032007',
    districtId: '6102032',
    name: 'Sakataru',
  },
  {
    id: '6102032008',
    districtId: '6102032',
    name: 'Janyat',
  },
  {
    id: '6102040008',
    districtId: '6102040',
    name: 'Bhakti Mulya',
  },
  {
    id: '6102040009',
    districtId: '6102040',
    name: 'Tirta Kencana',
  },
  {
    id: '6102040014',
    districtId: '6102040',
    name: 'Bumi Emas',
  },
  {
    id: '6102040015',
    districtId: '6102040',
    name: 'Bani Amas',
  },
  {
    id: '6102040017',
    districtId: '6102040',
    name: 'Setia Budi',
  },
  {
    id: '6102040018',
    districtId: '6102040',
    name: 'Sebalo',
  },
  {
    id: '6102041001',
    districtId: '6102041',
    name: 'Bangun Sari',
  },
  {
    id: '6102041002',
    districtId: '6102041',
    name: 'Setia Jaya',
  },
  {
    id: '6102041004',
    districtId: '6102041',
    name: 'Sumber Karya',
  },
  {
    id: '6102041007',
    districtId: '6102041',
    name: 'Dharma Bhakti',
  },
  {
    id: '6102041010',
    districtId: '6102041',
    name: 'Lulang',
  },
  {
    id: '6102041011',
    districtId: '6102041',
    name: 'Teriak',
  },
  {
    id: '6102041012',
    districtId: '6102041',
    name: 'Temiasio',
  },
  {
    id: '6102041013',
    districtId: '6102041',
    name: 'Bana',
  },
  {
    id: '6102041014',
    districtId: '6102041',
    name: 'Tubajur',
  },
  {
    id: '6102041015',
    districtId: '6102041',
    name: 'Ampar Benteng',
  },
  {
    id: '6102041016',
    districtId: '6102041',
    name: 'Tanjung',
  },
  {
    id: '6102041017',
    districtId: '6102041',
    name: 'Telidik',
  },
  {
    id: '6102041018',
    districtId: '6102041',
    name: 'Sekaruh',
  },
  {
    id: '6102041020',
    districtId: '6102041',
    name: 'Sebetung Menyala',
  },
  {
    id: '6102041021',
    districtId: '6102041',
    name: 'Malo Jelayan',
  },
  {
    id: '6102042001',
    districtId: '6102042',
    name: 'Karya Bhakti',
  },
  {
    id: '6102042002',
    districtId: '6102042',
    name: 'Suka Maju',
  },
  {
    id: '6102042003',
    districtId: '6102042',
    name: 'Suka Bangun',
  },
  {
    id: '6102042004',
    districtId: '6102042',
    name: 'Cipta Karya',
  },
  {
    id: '6102050006',
    districtId: '6102050',
    name: 'Serangkat',
  },
  {
    id: '6102050008',
    districtId: '6102050',
    name: 'Lesabela',
  },
  {
    id: '6102050009',
    districtId: '6102050',
    name: 'Rodaya',
  },
  {
    id: '6102050011',
    districtId: '6102050',
    name: 'Sidai',
  },
  {
    id: '6102050016',
    districtId: '6102050',
    name: 'Lomba Karya',
  },
  {
    id: '6102050017',
    districtId: '6102050',
    name: 'Dayung',
  },
  {
    id: '6102050018',
    districtId: '6102050',
    name: 'Jesape',
  },
  {
    id: '6102050019',
    districtId: '6102050',
    name: 'Suka Jaya',
  },
  {
    id: '6102050020',
    districtId: '6102050',
    name: 'Semangat',
  },
  {
    id: '6102050021',
    districtId: '6102050',
    name: 'Tebuah Marong',
  },
  {
    id: '6102050022',
    districtId: '6102050',
    name: 'Suka Damai',
  },
  {
    id: '6102051001',
    districtId: '6102051',
    name: 'Nangka',
  },
  {
    id: '6102051002',
    districtId: '6102051',
    name: 'Muhi Bersatu',
  },
  {
    id: '6102051003',
    districtId: '6102051',
    name: 'Cempaka Putih',
  },
  {
    id: '6102051004',
    districtId: '6102051',
    name: 'Suka Maju',
  },
  {
    id: '6102051005',
    districtId: '6102051',
    name: 'Kiung',
  },
  {
    id: '6102051006',
    districtId: '6102051',
    name: 'Suti Semarang',
  },
  {
    id: '6102051007',
    districtId: '6102051',
    name: 'Tapen',
  },
  {
    id: '6102051008',
    districtId: '6102051',
    name: 'Kelayu',
  },
  {
    id: '6102052001',
    districtId: '6102052',
    name: 'Seren Selimbau',
  },
  {
    id: '6102052002',
    districtId: '6102052',
    name: 'Tiga Berkat',
  },
  {
    id: '6102052003',
    districtId: '6102052',
    name: 'Magmagan Karya',
  },
  {
    id: '6102052004',
    districtId: '6102052',
    name: 'Belimbing',
  },
  {
    id: '6102052005',
    districtId: '6102052',
    name: 'Lamolda',
  },
  {
    id: '6102060005',
    districtId: '6102060',
    name: 'Bange',
  },
  {
    id: '6102060006',
    districtId: '6102060',
    name: 'Lembang',
  },
  {
    id: '6102060007',
    districtId: '6102060',
    name: 'Sango',
  },
  {
    id: '6102060008',
    districtId: '6102060',
    name: 'Gua',
  },
  {
    id: '6102060009',
    districtId: '6102060',
    name: 'Danti',
  },
  {
    id: '6102061001',
    districtId: '6102061',
    name: 'Bengkilu',
  },
  {
    id: '6102061002',
    districtId: '6102061',
    name: 'Pisak',
  },
  {
    id: '6102061003',
    districtId: '6102061',
    name: 'Kamuh',
  },
  {
    id: '6102061004',
    districtId: '6102061',
    name: 'Sinar Tebudak',
  },
  {
    id: '6102070001',
    districtId: '6102070',
    name: 'Sahan',
  },
  {
    id: '6102070002',
    districtId: '6102070',
    name: 'Bengkawan',
  },
  {
    id: '6102070003',
    districtId: '6102070',
    name: 'Seluas',
  },
  {
    id: '6102070004',
    districtId: '6102070',
    name: 'Sentangau Jaya',
  },
  {
    id: '6102070005',
    districtId: '6102070',
    name: 'Mayak',
  },
  {
    id: '6102070006',
    districtId: '6102070',
    name: 'Kalon',
  },
  {
    id: '6102080004',
    districtId: '6102080',
    name: 'Jagoi',
  },
  {
    id: '6102080005',
    districtId: '6102080',
    name: 'Kumba',
  },
  {
    id: '6102080007',
    districtId: '6102080',
    name: 'Sinar Baru',
  },
  {
    id: '6102080008',
    districtId: '6102080',
    name: 'Gersik',
  },
  {
    id: '6102080009',
    districtId: '6102080',
    name: 'Semunying Jaya',
  },
  {
    id: '6102080010',
    districtId: '6102080',
    name: 'Jagoi Sekida',
  },
  {
    id: '6102081001',
    districtId: '6102081',
    name: 'Tamong',
  },
  {
    id: '6102081002',
    districtId: '6102081',
    name: 'Tawang',
  },
  {
    id: '6102081003',
    districtId: '6102081',
    name: 'Sungkung I',
  },
  {
    id: '6102081004',
    districtId: '6102081',
    name: 'Sungkung II',
  },
  {
    id: '6102081005',
    districtId: '6102081',
    name: 'Sungkung III',
  },
  {
    id: '6102081006',
    districtId: '6102081',
    name: 'Siding',
  },
  {
    id: '6102081007',
    districtId: '6102081',
    name: 'Tangguh',
  },
  {
    id: '6102081008',
    districtId: '6102081',
    name: 'Hlibuie',
  },
  {
    id: '6103020001',
    districtId: '6103020',
    name: 'Rantau Panjang',
  },
  {
    id: '6103020002',
    districtId: '6103020',
    name: 'Sei Segak',
  },
  {
    id: '6103020003',
    districtId: '6103020',
    name: 'Sebangki',
  },
  {
    id: '6103020004',
    districtId: '6103020',
    name: 'Kumpang Tengah',
  },
  {
    id: '6103020007',
    districtId: '6103020',
    name: 'Agak',
  },
  {
    id: '6103030001',
    districtId: '6103030',
    name: 'Pak Mayam',
  },
  {
    id: '6103030007',
    districtId: '6103030',
    name: 'Sebirang',
  },
  {
    id: '6103030008',
    districtId: '6103030',
    name: 'Amboyo Selatan',
  },
  {
    id: '6103030009',
    districtId: '6103030',
    name: 'Temiang Sawi',
  },
  {
    id: '6103030014',
    districtId: '6103030',
    name: 'Tebedak',
  },
  {
    id: '6103030015',
    districtId: '6103030',
    name: 'Hilir Tengah',
  },
  {
    id: '6103030016',
    districtId: '6103030',
    name: 'Hilir Kantor',
  },
  {
    id: '6103030017',
    districtId: '6103030',
    name: 'Amboyo Inti',
  },
  {
    id: '6103030018',
    districtId: '6103030',
    name: 'Amboyo Utara',
  },
  {
    id: '6103030019',
    districtId: '6103030',
    name: 'Raja',
  },
  {
    id: '6103030025',
    districtId: '6103030',
    name: 'Engkadu',
  },
  {
    id: '6103030026',
    districtId: '6103030',
    name: 'Ambarang',
  },
  {
    id: '6103030027',
    districtId: '6103030',
    name: 'Rasan',
  },
  {
    id: '6103030028',
    districtId: '6103030',
    name: 'Sengai Keli',
  },
  {
    id: '6103030029',
    districtId: '6103030',
    name: 'Penyaho Dangku',
  },
  {
    id: '6103030030',
    districtId: '6103030',
    name: 'Antan Rayan',
  },
  {
    id: '6103030031',
    districtId: '6103030',
    name: 'Amang',
  },
  {
    id: '6103031001',
    districtId: '6103031',
    name: 'Dara Itam I',
  },
  {
    id: '6103031002',
    districtId: '6103031',
    name: 'Balai Peluntan',
  },
  {
    id: '6103031003',
    districtId: '6103031',
    name: 'Angan Tembawang',
  },
  {
    id: '6103031004',
    districtId: '6103031',
    name: 'Kayu Ara',
  },
  {
    id: '6103031005',
    districtId: '6103031',
    name: 'Pawis Hilir',
  },
  {
    id: '6103031006',
    districtId: '6103031',
    name: 'Tubang Raeng',
  },
  {
    id: '6103031007',
    districtId: '6103031',
    name: 'Jelimpo',
  },
  {
    id: '6103031008',
    districtId: '6103031',
    name: 'Mandor Kiru',
  },
  {
    id: '6103031009',
    districtId: '6103031',
    name: 'Nyiin',
  },
  {
    id: '6103031010',
    districtId: '6103031',
    name: 'Papung',
  },
  {
    id: '6103031011',
    districtId: '6103031',
    name: 'Sekais',
  },
  {
    id: '6103031012',
    districtId: '6103031',
    name: 'Temahar',
  },
  {
    id: '6103031013',
    districtId: '6103031',
    name: 'Kersik Belantian',
  },
  {
    id: '6103040001',
    districtId: '6103040',
    name: 'Tonang',
  },
  {
    id: '6103040002',
    districtId: '6103040',
    name: 'Andeng',
  },
  {
    id: '6103040003',
    districtId: '6103040',
    name: 'Gombang',
  },
  {
    id: '6103040004',
    districtId: '6103040',
    name: 'Pahauman',
  },
  {
    id: '6103040005',
    districtId: '6103040',
    name: 'Sidas',
  },
  {
    id: '6103040006',
    districtId: '6103040',
    name: 'Keranji Mancal',
  },
  {
    id: '6103040007',
    districtId: '6103040',
    name: 'Banying',
  },
  {
    id: '6103040008',
    districtId: '6103040',
    name: 'Rabak',
  },
  {
    id: '6103040009',
    districtId: '6103040',
    name: 'Sebatih',
  },
  {
    id: '6103040010',
    districtId: '6103040',
    name: 'Saham',
  },
  {
    id: '6103040011',
    districtId: '6103040',
    name: 'Aur Sampuk',
  },
  {
    id: '6103040012',
    districtId: '6103040',
    name: 'Senakin',
  },
  {
    id: '6103040013',
    districtId: '6103040',
    name: 'Paloan',
  },
  {
    id: '6103040014',
    districtId: '6103040',
    name: 'Keranji Paidang',
  },
  {
    id: '6103050001',
    districtId: '6103050',
    name: 'Ngarak',
  },
  {
    id: '6103050002',
    districtId: '6103050',
    name: 'Kayu Tanam',
  },
  {
    id: '6103050003',
    districtId: '6103050',
    name: 'Sala Tiga',
  },
  {
    id: '6103050004',
    districtId: '6103050',
    name: 'Simpang Kasturi',
  },
  {
    id: '6103050005',
    districtId: '6103050',
    name: 'Mandor',
  },
  {
    id: '6103050006',
    districtId: '6103050',
    name: 'Pongok',
  },
  {
    id: '6103050007',
    districtId: '6103050',
    name: 'Kayu Ara',
  },
  {
    id: '6103050009',
    districtId: '6103050',
    name: 'Kerohok',
  },
  {
    id: '6103050010',
    districtId: '6103050',
    name: 'Bebatung',
  },
  {
    id: '6103050012',
    districtId: '6103050',
    name: 'Manggang',
  },
  {
    id: '6103050013',
    districtId: '6103050',
    name: 'Sekilap',
  },
  {
    id: '6103050014',
    districtId: '6103050',
    name: 'Keramas',
  },
  {
    id: '6103050015',
    districtId: '6103050',
    name: 'Sebadu',
  },
  {
    id: '6103050016',
    districtId: '6103050',
    name: 'Semenok',
  },
  {
    id: '6103050017',
    districtId: '6103050',
    name: 'Mengkunyit',
  },
  {
    id: '6103060001',
    districtId: '6103060',
    name: 'Lamoanak',
  },
  {
    id: '6103060002',
    districtId: '6103060',
    name: 'Bengkawe',
  },
  {
    id: '6103060003',
    districtId: '6103060',
    name: 'Menjalin',
  },
  {
    id: '6103060004',
    districtId: '6103060',
    name: 'Sepahat',
  },
  {
    id: '6103060005',
    districtId: '6103060',
    name: 'Raba',
  },
  {
    id: '6103060006',
    districtId: '6103060',
    name: 'Nangka',
  },
  {
    id: '6103060008',
    districtId: '6103060',
    name: 'Tempoak',
  },
  {
    id: '6103070007',
    districtId: '6103070',
    name: 'Sampuro',
  },
  {
    id: '6103070009',
    districtId: '6103070',
    name: 'Sei Laki',
  },
  {
    id: '6103070010',
    districtId: '6103070',
    name: 'Karangan',
  },
  {
    id: '6103070011',
    districtId: '6103070',
    name: 'Garu',
  },
  {
    id: '6103070012',
    districtId: '6103070',
    name: 'Babatn',
  },
  {
    id: '6103070013',
    districtId: '6103070',
    name: 'Pahokng',
  },
  {
    id: '6103070014',
    districtId: '6103070',
    name: 'Mentonyek',
  },
  {
    id: '6103070015',
    districtId: '6103070',
    name: 'Sailo',
  },
  {
    id: '6103070016',
    districtId: '6103070',
    name: 'S A L A A S',
  },
  {
    id: '6103070017',
    districtId: '6103070',
    name: 'Tiang Tanjung',
  },
  {
    id: '6103070018',
    districtId: '6103070',
    name: 'Tunang',
  },
  {
    id: '6103070019',
    districtId: '6103070',
    name: 'Bilayuk',
  },
  {
    id: '6103070020',
    districtId: '6103070',
    name: 'Sabaka',
  },
  {
    id: '6103070021',
    districtId: '6103070',
    name: 'Ansolok',
  },
  {
    id: '6103070022',
    districtId: '6103070',
    name: 'Caokng',
  },
  {
    id: '6103070023',
    districtId: '6103070',
    name: 'Parigi',
  },
  {
    id: '6103070024',
    districtId: '6103070',
    name: 'Salumang',
  },
  {
    id: '6103071001',
    districtId: '6103071',
    name: 'Pakumbang',
  },
  {
    id: '6103071002',
    districtId: '6103071',
    name: 'Tapakng',
  },
  {
    id: '6103071003',
    districtId: '6103071',
    name: 'Amawakng',
  },
  {
    id: '6103071004',
    districtId: '6103071',
    name: 'Galar',
  },
  {
    id: '6103071005',
    districtId: '6103071',
    name: 'Sompak',
  },
  {
    id: '6103071006',
    districtId: '6103071',
    name: 'Lingkonong',
  },
  {
    id: '6103071007',
    districtId: '6103071',
    name: 'Pauh',
  },
  {
    id: '6103080001',
    districtId: '6103080',
    name: 'Ladangan',
  },
  {
    id: '6103080002',
    districtId: '6103080',
    name: 'Ongkol Padang',
  },
  {
    id: '6103080003',
    districtId: '6103080',
    name: 'Ta As',
  },
  {
    id: '6103080004',
    districtId: '6103080',
    name: 'Mamek',
  },
  {
    id: '6103080005',
    districtId: '6103080',
    name: 'Anik Dingir',
  },
  {
    id: '6103080006',
    districtId: '6103080',
    name: 'Sei Lubang',
  },
  {
    id: '6103080007',
    districtId: '6103080',
    name: 'Tolok',
  },
  {
    id: '6103080008',
    districtId: '6103080',
    name: 'Bagak',
  },
  {
    id: '6103080009',
    districtId: '6103080',
    name: 'Darit',
  },
  {
    id: '6103080010',
    districtId: '6103080',
    name: 'Kayuara',
  },
  {
    id: '6103080011',
    districtId: '6103080',
    name: 'Ansang',
  },
  {
    id: '6103080012',
    districtId: '6103080',
    name: 'Angkaras',
  },
  {
    id: '6103080017',
    districtId: '6103080',
    name: 'Songga',
  },
  {
    id: '6103080018',
    districtId: '6103080',
    name: 'Lintah Betung',
  },
  {
    id: '6103080019',
    districtId: '6103080',
    name: 'Sidan',
  },
  {
    id: '6103080020',
    districtId: '6103080',
    name: 'Berinang Mayun',
  },
  {
    id: '6103081001',
    districtId: '6103081',
    name: 'Gamang',
  },
  {
    id: '6103081002',
    districtId: '6103081',
    name: 'Ringo Lojok',
  },
  {
    id: '6103081003',
    districtId: '6103081',
    name: 'Tembawang Bale',
  },
  {
    id: '6103081004',
    districtId: '6103081',
    name: 'Padang Pio',
  },
  {
    id: '6103081005',
    districtId: '6103081',
    name: 'Kampet',
  },
  {
    id: '6103081006',
    districtId: '6103081',
    name: 'Semade',
  },
  {
    id: '6103081007',
    districtId: '6103081',
    name: 'Untang',
  },
  {
    id: '6103090001',
    districtId: '6103090',
    name: 'Kelampai Setolo',
  },
  {
    id: '6103090002',
    districtId: '6103090',
    name: 'Meranti',
  },
  {
    id: '6103090003',
    districtId: '6103090',
    name: 'Ampadi',
  },
  {
    id: '6103090004',
    districtId: '6103090',
    name: 'Selange',
  },
  {
    id: '6103090005',
    districtId: '6103090',
    name: 'Moro Betung',
  },
  {
    id: '6103090006',
    districtId: '6103090',
    name: 'Tahu',
  },
  {
    id: '6103100002',
    districtId: '6103100',
    name: 'Kedama',
  },
  {
    id: '6103100003',
    districtId: '6103100',
    name: 'Tanjung Balai',
  },
  {
    id: '6103100004',
    districtId: '6103100',
    name: 'Kuala Behe',
  },
  {
    id: '6103100005',
    districtId: '6103100',
    name: 'Paku Raya',
  },
  {
    id: '6103100006',
    districtId: '6103100',
    name: 'Nyayum',
  },
  {
    id: '6103100007',
    districtId: '6103100',
    name: 'Semedang',
  },
  {
    id: '6103100009',
    districtId: '6103100',
    name: 'Permiit',
  },
  {
    id: '6103100010',
    districtId: '6103100',
    name: 'Angkanyar',
  },
  {
    id: '6103100011',
    districtId: '6103100',
    name: 'Bengawan Ampar',
  },
  {
    id: '6103100012',
    districtId: '6103100',
    name: 'Sejowet',
  },
  {
    id: '6103110001',
    districtId: '6103110',
    name: 'Parek',
  },
  {
    id: '6103110003',
    districtId: '6103110',
    name: 'Engkadik Pade',
  },
  {
    id: '6103110004',
    districtId: '6103110',
    name: 'Semuntik',
  },
  {
    id: '6103110005',
    districtId: '6103110',
    name: 'Sekendal',
  },
  {
    id: '6103110006',
    districtId: '6103110',
    name: 'Sepangah',
  },
  {
    id: '6103110007',
    districtId: '6103110',
    name: 'Serimbu',
  },
  {
    id: '6103110008',
    districtId: '6103110',
    name: 'Jambu Tembawang',
  },
  {
    id: '6103110009',
    districtId: '6103110',
    name: 'Dange Aji',
  },
  {
    id: '6103110010',
    districtId: '6103110',
    name: 'Bentiang Madomang',
  },
  {
    id: '6103110011',
    districtId: '6103110',
    name: 'Tengon',
  },
  {
    id: '6103110012',
    districtId: '6103110',
    name: 'Sempatung Lawek',
  },
  {
    id: '6103110013',
    districtId: '6103110',
    name: 'Engkangin',
  },
  {
    id: '6103110014',
    districtId: '6103110',
    name: 'Merayuh',
  },
  {
    id: '6103110015',
    districtId: '6103110',
    name: 'Nyari',
  },
  {
    id: '6103110016',
    districtId: '6103110',
    name: 'Temoyok',
  },
  {
    id: '6104080001',
    districtId: '6104080',
    name: 'Sei Nipah',
  },
  {
    id: '6104080002',
    districtId: '6104080',
    name: 'Jungkat',
  },
  {
    id: '6104080003',
    districtId: '6104080',
    name: 'Wajo Hilir',
  },
  {
    id: '6104080004',
    districtId: '6104080',
    name: 'Wajo Hulu',
  },
  {
    id: '6104080006',
    districtId: '6104080',
    name: 'Peniti Luar',
  },
  {
    id: '6104081001',
    districtId: '6104081',
    name: 'Peniti Dalam I',
  },
  {
    id: '6104081002',
    districtId: '6104081',
    name: 'Sei Burung',
  },
  {
    id: '6104081003',
    districtId: '6104081',
    name: 'Sei Purun Besar',
  },
  {
    id: '6104081004',
    districtId: '6104081',
    name: 'Parit Bugis',
  },
  {
    id: '6104081005',
    districtId: '6104081',
    name: 'Peniti Besar',
  },
  {
    id: '6104081006',
    districtId: '6104081',
    name: 'Peniti Dalam II',
  },
  {
    id: '6104090001',
    districtId: '6104090',
    name: 'Sei.Purun Kecil',
  },
  {
    id: '6104090003',
    districtId: '6104090',
    name: 'Peniraman',
  },
  {
    id: '6104090004',
    districtId: '6104090',
    name: 'Nusapati',
  },
  {
    id: '6104090005',
    districtId: '6104090',
    name: 'Galang',
  },
  {
    id: '6104090008',
    districtId: '6104090',
    name: 'Sungai Rasau',
  },
  {
    id: '6104090009',
    districtId: '6104090',
    name: 'Sungai Pinyuh',
  },
  {
    id: '6104090010',
    districtId: '6104090',
    name: 'Sungai Batang',
  },
  {
    id: '6104090011',
    districtId: '6104090',
    name: 'Sei Bakau Besar Laut',
  },
  {
    id: '6104090012',
    districtId: '6104090',
    name: 'Sei Bakau Besar Darat',
  },
  {
    id: '6104091002',
    districtId: '6104091',
    name: 'Anjungan Melancar',
  },
  {
    id: '6104091003',
    districtId: '6104091',
    name: 'Anjungan Dalam',
  },
  {
    id: '6104091004',
    districtId: '6104091',
    name: 'Pak Bulu',
  },
  {
    id: '6104091005',
    districtId: '6104091',
    name: 'Dema',
  },
  {
    id: '6104091006',
    districtId: '6104091',
    name: 'Kepayang',
  },
  {
    id: '6104100001',
    districtId: '6104100',
    name: 'Tanjung',
  },
  {
    id: '6104100002',
    districtId: '6104100',
    name: 'Kuala Secapah',
  },
  {
    id: '6104100007',
    districtId: '6104100',
    name: 'Tengah',
  },
  {
    id: '6104100008',
    districtId: '6104100',
    name: 'Terusan',
  },
  {
    id: '6104100012',
    districtId: '6104100',
    name: 'P A S I R',
  },
  {
    id: '6104100013',
    districtId: '6104100',
    name: 'Penibung',
  },
  {
    id: '6104100014',
    districtId: '6104100',
    name: 'Sengkubang',
  },
  {
    id: '6104100015',
    districtId: '6104100',
    name: 'Malikian',
  },
  {
    id: '6104101001',
    districtId: '6104101',
    name: 'Pasir Wan Salim',
  },
  {
    id: '6104101002',
    districtId: '6104101',
    name: 'Sungai Bakau Kecil',
  },
  {
    id: '6104101003',
    districtId: '6104101',
    name: 'Pasir Panjang',
  },
  {
    id: '6104101004',
    districtId: '6104101',
    name: 'Pasir Palembang',
  },
  {
    id: '6104101005',
    districtId: '6104101',
    name: 'Pulau Pedalaman',
  },
  {
    id: '6104101006',
    districtId: '6104101',
    name: 'Antibar',
  },
  {
    id: '6104101007',
    districtId: '6104101',
    name: 'Sejegi',
  },
  {
    id: '6104101008',
    districtId: '6104101',
    name: 'Parit Banjar',
  },
  {
    id: '6104110002',
    districtId: '6104110',
    name: 'Semparong Parit Raden',
  },
  {
    id: '6104110003',
    districtId: '6104110',
    name: 'Mendalok',
  },
  {
    id: '6104110004',
    districtId: '6104110',
    name: 'Sei Dungun',
  },
  {
    id: '6104110005',
    districtId: '6104110',
    name: 'Sei Limau',
  },
  {
    id: '6104110006',
    districtId: '6104110',
    name: 'Sei Kunyit Laut',
  },
  {
    id: '6104110007',
    districtId: '6104110',
    name: 'Sei Kunyit Dalam',
  },
  {
    id: '6104110008',
    districtId: '6104110',
    name: 'Sungai Kunyit Hulu',
  },
  {
    id: '6104110009',
    districtId: '6104110',
    name: 'Bukit Batu',
  },
  {
    id: '6104110010',
    districtId: '6104110',
    name: 'Sei Bundung Laut',
  },
  {
    id: '6104110011',
    districtId: '6104110',
    name: 'Sei Duri I',
  },
  {
    id: '6104110012',
    districtId: '6104110',
    name: 'Sei Duri II',
  },
  {
    id: '6104120002',
    districtId: '6104120',
    name: 'Sembora',
  },
  {
    id: '6104120003',
    districtId: '6104120',
    name: 'Benuang',
  },
  {
    id: '6104120004',
    districtId: '6104120',
    name: 'Pakutan',
  },
  {
    id: '6104120005',
    districtId: '6104120',
    name: 'Sepang',
  },
  {
    id: '6104120006',
    districtId: '6104120',
    name: 'Pak Laheng',
  },
  {
    id: '6104120007',
    districtId: '6104120',
    name: 'Terap',
  },
  {
    id: '6104120008',
    districtId: '6104120',
    name: 'Kecurit',
  },
  {
    id: '6104120009',
    districtId: '6104120',
    name: 'Toho Ilir',
  },
  {
    id: '6104121002',
    districtId: '6104121',
    name: 'Sekabuk',
  },
  {
    id: '6104121004',
    districtId: '6104121',
    name: 'Amawang',
  },
  {
    id: '6104121005',
    districtId: '6104121',
    name: 'Ansiap',
  },
  {
    id: '6104121006',
    districtId: '6104121',
    name: 'Suak Berangan',
  },
  {
    id: '6105010001',
    districtId: '6105010',
    name: 'Bagan Asam',
  },
  {
    id: '6105010002',
    districtId: '6105010',
    name: 'Teraju Barat',
  },
  {
    id: '6105010003',
    districtId: '6105010',
    name: 'Kampung Baru',
  },
  {
    id: '6105010005',
    districtId: '6105010',
    name: 'Sansat',
  },
  {
    id: '6105010006',
    districtId: '6105010',
    name: 'Balai Belungai',
  },
  {
    id: '6105010007',
    districtId: '6105010',
    name: 'Belungai Dalam',
  },
  {
    id: '6105020001',
    districtId: '6105020',
    name: 'Baru Lombak',
  },
  {
    id: '6105020002',
    districtId: '6105020',
    name: 'Kunyil',
  },
  {
    id: '6105020003',
    districtId: '6105020',
    name: 'Pampang Dua',
  },
  {
    id: '6105020004',
    districtId: '6105020',
    name: 'Harapan Makmur',
  },
  {
    id: '6105020005',
    districtId: '6105020',
    name: 'Sungai Kembayau',
  },
  {
    id: '6105020006',
    districtId: '6105020',
    name: 'Kuala Rosan',
  },
  {
    id: '6105020007',
    districtId: '6105020',
    name: 'Kuala Buayan',
  },
  {
    id: '6105020008',
    districtId: '6105020',
    name: 'Bakti Jaya',
  },
  {
    id: '6105020009',
    districtId: '6105020',
    name: 'Cupang',
  },
  {
    id: '6105020010',
    districtId: '6105020',
    name: 'Mukti Jaya',
  },
  {
    id: '6105020011',
    districtId: '6105020',
    name: 'Lalang',
  },
  {
    id: '6105020012',
    districtId: '6105020',
    name: 'Enggadai',
  },
  {
    id: '6105020013',
    districtId: '6105020',
    name: 'Meranggau',
  },
  {
    id: '6105020014',
    districtId: '6105020',
    name: 'Balai Tinggi',
  },
  {
    id: '6105020015',
    districtId: '6105020',
    name: 'Meliau Hilir',
  },
  {
    id: '6105020016',
    districtId: '6105020',
    name: 'Meliau Hulu',
  },
  {
    id: '6105020017',
    districtId: '6105020',
    name: 'Sungai Mayam',
  },
  {
    id: '6105020018',
    districtId: '6105020',
    name: 'Melobok',
  },
  {
    id: '6105020019',
    districtId: '6105020',
    name: 'Melawi Makmur',
  },
  {
    id: '6105060001',
    districtId: '6105060',
    name: 'Penyalimau Jaya',
  },
  {
    id: '6105060002',
    districtId: '6105060',
    name: 'Penyalimau',
  },
  {
    id: '6105060003',
    districtId: '6105060',
    name: 'Rambin',
  },
  {
    id: '6105060004',
    districtId: '6105060',
    name: 'Nanga Biang',
  },
  {
    id: '6105060005',
    districtId: '6105060',
    name: 'Lintang Pelaman',
  },
  {
    id: '6105060006',
    districtId: '6105060',
    name: 'Sei Alai',
  },
  {
    id: '6105060007',
    districtId: '6105060',
    name: 'Semerangkai',
  },
  {
    id: '6105060008',
    districtId: '6105060',
    name: 'Sungai Batu',
  },
  {
    id: '6105060009',
    districtId: '6105060',
    name: 'Sungai Muntik',
  },
  {
    id: '6105060010',
    districtId: '6105060',
    name: 'Lintang Kapuas',
  },
  {
    id: '6105060011',
    districtId: '6105060',
    name: 'Belangin',
  },
  {
    id: '6105060012',
    districtId: '6105060',
    name: 'Penyeladi',
  },
  {
    id: '6105060013',
    districtId: '6105060',
    name: 'Tanjung Kapuas',
  },
  {
    id: '6105060014',
    districtId: '6105060',
    name: 'Tanjung Sekayam',
  },
  {
    id: '6105060015',
    districtId: '6105060',
    name: 'Ilir Kota',
  },
  {
    id: '6105060016',
    districtId: '6105060',
    name: 'Beringin',
  },
  {
    id: '6105060018',
    districtId: '6105060',
    name: 'Lape',
  },
  {
    id: '6105060019',
    districtId: '6105060',
    name: 'Sei Mawang',
  },
  {
    id: '6105060020',
    districtId: '6105060',
    name: 'Sei Sengkuang',
  },
  {
    id: '6105060021',
    districtId: '6105060',
    name: 'Pana',
  },
  {
    id: '6105060022',
    districtId: '6105060',
    name: 'Mangkiang',
  },
  {
    id: '6105060023',
    districtId: '6105060',
    name: 'Entakai',
  },
  {
    id: '6105060024',
    districtId: '6105060',
    name: 'Kambong',
  },
  {
    id: '6105060025',
    districtId: '6105060',
    name: 'Tapang Dulang',
  },
  {
    id: '6105060026',
    districtId: '6105060',
    name: 'Botuh Lintang',
  },
  {
    id: '6105070001',
    districtId: '6105070',
    name: 'Inggis',
  },
  {
    id: '6105070002',
    districtId: '6105070',
    name: 'Semanggis Raya',
  },
  {
    id: '6105070003',
    districtId: '6105070',
    name: 'Semuntai',
  },
  {
    id: '6105070005',
    districtId: '6105070',
    name: 'Engkode',
  },
  {
    id: '6105070006',
    districtId: '6105070',
    name: 'Sei Mawang',
  },
  {
    id: '6105070007',
    districtId: '6105070',
    name: 'Trimulya',
  },
  {
    id: '6105070008',
    districtId: '6105070',
    name: 'Layak Omang',
  },
  {
    id: '6105070009',
    districtId: '6105070',
    name: 'Serambai Jaya',
  },
  {
    id: '6105120001',
    districtId: '6105120',
    name: 'Terati',
  },
  {
    id: '6105120002',
    districtId: '6105120',
    name: 'Selampung',
  },
  {
    id: '6105120003',
    districtId: '6105120',
    name: 'Sape',
  },
  {
    id: '6105120004',
    districtId: '6105120',
    name: 'Semirau',
  },
  {
    id: '6105120005',
    districtId: '6105120',
    name: 'Balai Sebut',
  },
  {
    id: '6105120006',
    districtId: '6105120',
    name: 'Semombat',
  },
  {
    id: '6105120007',
    districtId: '6105120',
    name: 'Empiyang',
  },
  {
    id: '6105120008',
    districtId: '6105120',
    name: 'Jangkang',
  },
  {
    id: '6105120009',
    districtId: '6105120',
    name: 'Tanggung',
  },
  {
    id: '6105120010',
    districtId: '6105120',
    name: 'Pisang',
  },
  {
    id: '6105120011',
    districtId: '6105120',
    name: 'Ketori',
  },
  {
    id: '6105130002',
    districtId: '6105130',
    name: 'Bahta',
  },
  {
    id: '6105130003',
    districtId: '6105130',
    name: 'Tunggul Boyok',
  },
  {
    id: '6105130004',
    districtId: '6105130',
    name: 'Sami',
  },
  {
    id: '6105130005',
    districtId: '6105130',
    name: 'Empodis',
  },
  {
    id: '6105130006',
    districtId: '6105130',
    name: 'Bonti',
  },
  {
    id: '6105130007',
    districtId: '6105130',
    name: 'Kampuh',
  },
  {
    id: '6105130008',
    districtId: '6105130',
    name: 'Bantai',
  },
  {
    id: '6105130009',
    districtId: '6105130',
    name: 'Majel',
  },
  {
    id: '6105140001',
    districtId: '6105140',
    name: 'Marita',
  },
  {
    id: '6105140002',
    districtId: '6105140',
    name: 'Embala',
  },
  {
    id: '6105140003',
    districtId: '6105140',
    name: 'Pandu Raya',
  },
  {
    id: '6105140004',
    districtId: '6105140',
    name: 'Maju Karya',
  },
  {
    id: '6105140005',
    districtId: '6105140',
    name: 'Gunam',
  },
  {
    id: '6105140006',
    districtId: '6105140',
    name: 'Suka Grundi',
  },
  {
    id: '6105140007',
    districtId: '6105140',
    name: 'Suka Mulya',
  },
  {
    id: '6105140008',
    districtId: '6105140',
    name: 'Palem Jaya',
  },
  {
    id: '6105140009',
    districtId: '6105140',
    name: 'Pusat Damai',
  },
  {
    id: '6105140010',
    districtId: '6105140',
    name: 'Sebara',
  },
  {
    id: '6105140011',
    districtId: '6105140',
    name: 'Hibun',
  },
  {
    id: '6105140012',
    districtId: '6105140',
    name: 'Rahayu',
  },
  {
    id: '6105140013',
    districtId: '6105140',
    name: 'Marigin Jaya',
  },
  {
    id: '6105140014',
    districtId: '6105140',
    name: 'Dosan',
  },
  {
    id: '6105150001',
    districtId: '6105150',
    name: 'Lalang',
  },
  {
    id: '6105150002',
    districtId: '6105150',
    name: 'Kawat',
  },
  {
    id: '6105150003',
    districtId: '6105150',
    name: 'Pulau Tayan Utara',
  },
  {
    id: '6105150004',
    districtId: '6105150',
    name: 'Pedalaman',
  },
  {
    id: '6105150005',
    districtId: '6105150',
    name: 'Tanjung Bunut',
  },
  {
    id: '6105150006',
    districtId: '6105150',
    name: 'Sebemban',
  },
  {
    id: '6105150007',
    districtId: '6105150',
    name: 'Beginjan',
  },
  {
    id: '6105150008',
    districtId: '6105150',
    name: 'Sungai Jaman',
  },
  {
    id: '6105150009',
    districtId: '6105150',
    name: 'Emberas',
  },
  {
    id: '6105150010',
    districtId: '6105150',
    name: 'Melugai',
  },
  {
    id: '6105150011',
    districtId: '6105150',
    name: 'Cempedak',
  },
  {
    id: '6105150012',
    districtId: '6105150',
    name: 'Sejotang',
  },
  {
    id: '6105150013',
    districtId: '6105150',
    name: 'Subah',
  },
  {
    id: '6105150014',
    districtId: '6105150',
    name: 'Tebang Benua',
  },
  {
    id: '6105150015',
    districtId: '6105150',
    name: 'Balai Ingin',
  },
  {
    id: '6105160001',
    districtId: '6105160',
    name: 'Semoncol',
  },
  {
    id: '6105160002',
    districtId: '6105160',
    name: 'Mak Kawing',
  },
  {
    id: '6105160004',
    districtId: '6105160',
    name: 'Bulu Bala',
  },
  {
    id: '6105160005',
    districtId: '6105160',
    name: 'Temiang Taba',
  },
  {
    id: '6105160006',
    districtId: '6105160',
    name: 'Senyabang',
  },
  {
    id: '6105160007',
    districtId: '6105160',
    name: 'Kebadu',
  },
  {
    id: '6105160008',
    districtId: '6105160',
    name: 'Hilir',
  },
  {
    id: '6105160009',
    districtId: '6105160',
    name: 'Temiang Mali',
  },
  {
    id: '6105160010',
    districtId: '6105160',
    name: 'Tae',
  },
  {
    id: '6105160011',
    districtId: '6105160',
    name: 'Padi Kaye',
  },
  {
    id: '6105160012',
    districtId: '6105160',
    name: 'Empirang Ujung',
  },
  {
    id: '6105170001',
    districtId: '6105170',
    name: 'Menyabo',
  },
  {
    id: '6105170002',
    districtId: '6105170',
    name: 'Binjai',
  },
  {
    id: '6105170003',
    districtId: '6105170',
    name: 'Pandan Sembuat',
  },
  {
    id: '6105170004',
    districtId: '6105170',
    name: 'Kedakas',
  },
  {
    id: '6105170005',
    districtId: '6105170',
    name: 'Sosok',
  },
  {
    id: '6105170006',
    districtId: '6105170',
    name: 'Peruan Dalam',
  },
  {
    id: '6105170007',
    districtId: '6105170',
    name: 'Mandong',
  },
  {
    id: '6105170008',
    districtId: '6105170',
    name: 'Janjang',
  },
  {
    id: '6105170009',
    districtId: '6105170',
    name: 'Riyai',
  },
  {
    id: '6105170010',
    districtId: '6105170',
    name: 'Berakak',
  },
  {
    id: '6105170011',
    districtId: '6105170',
    name: 'Engkasan',
  },
  {
    id: '6105180002',
    districtId: '6105180',
    name: 'Kelompu',
  },
  {
    id: '6105180003',
    districtId: '6105180',
    name: 'Tanap',
  },
  {
    id: '6105180004',
    districtId: '6105180',
    name: 'Mobui',
  },
  {
    id: '6105180005',
    districtId: '6105180',
    name: 'Sejuah',
  },
  {
    id: '6105180006',
    districtId: '6105180',
    name: 'Tanjung Merpati',
  },
  {
    id: '6105180007',
    districtId: '6105180',
    name: 'Sebongkuh',
  },
  {
    id: '6105180008',
    districtId: '6105180',
    name: 'Kuala Dua',
  },
  {
    id: '6105180009',
    districtId: '6105180',
    name: 'Tunggal Bhakti',
  },
  {
    id: '6105180010',
    districtId: '6105180',
    name: 'Semayang',
  },
  {
    id: '6105180011',
    districtId: '6105180',
    name: 'Tanjung Bunga',
  },
  {
    id: '6105190001',
    districtId: '6105190',
    name: 'Sei Ilai',
  },
  {
    id: '6105190002',
    districtId: '6105190',
    name: 'Bereng Berkawat',
  },
  {
    id: '6105190003',
    districtId: '6105190',
    name: 'Kasromego',
  },
  {
    id: '6105190004',
    districtId: '6105190',
    name: 'Thang Raya',
  },
  {
    id: '6105190005',
    districtId: '6105190',
    name: 'Mawang Muda',
  },
  {
    id: '6105200001',
    districtId: '6105200',
    name: 'Empoto',
  },
  {
    id: '6105200002',
    districtId: '6105200',
    name: 'Idas',
  },
  {
    id: '6105200003',
    districtId: '6105200',
    name: 'Sei Dangin',
  },
  {
    id: '6105200004',
    districtId: '6105200',
    name: 'Semongan',
  },
  {
    id: '6105200005',
    districtId: '6105200',
    name: 'Noyan',
  },
  {
    id: '6105210001',
    districtId: '6105210',
    name: 'Sotok',
  },
  {
    id: '6105210002',
    districtId: '6105210',
    name: 'Pengadang',
  },
  {
    id: '6105210003',
    districtId: '6105210',
    name: 'Kenaman',
  },
  {
    id: '6105210004',
    districtId: '6105210',
    name: 'Raut Muara',
  },
  {
    id: '6105210005',
    districtId: '6105210',
    name: 'Engkahan',
  },
  {
    id: '6105210006',
    districtId: '6105210',
    name: 'Balai Karangan',
  },
  {
    id: '6105210007',
    districtId: '6105210',
    name: 'Bungkang',
  },
  {
    id: '6105210008',
    districtId: '6105210',
    name: 'Lubuk Sabuk',
  },
  {
    id: '6105210009',
    districtId: '6105210',
    name: 'Malenggang',
  },
  {
    id: '6105210010',
    districtId: '6105210',
    name: 'Sei Tekam',
  },
  {
    id: '6105220001',
    districtId: '6105220',
    name: 'Nekan',
  },
  {
    id: '6105220002',
    districtId: '6105220',
    name: 'Semanget',
  },
  {
    id: '6105220003',
    districtId: '6105220',
    name: 'Entikong',
  },
  {
    id: '6105220004',
    districtId: '6105220',
    name: 'Palapasang',
  },
  {
    id: '6105220005',
    districtId: '6105220',
    name: 'Suruh Tembawang',
  },
  {
    id: '6106010001',
    districtId: '6106010',
    name: 'Air Hitam Besar',
  },
  {
    id: '6106010002',
    districtId: '6106010',
    name: 'Kendawangan Kanan',
  },
  {
    id: '6106010003',
    districtId: '6106010',
    name: 'Bangkal Serai',
  },
  {
    id: '6106010004',
    districtId: '6106010',
    name: 'Banjar Sari',
  },
  {
    id: '6106010005',
    districtId: '6106010',
    name: 'Kendawangan Kiri',
  },
  {
    id: '6106010006',
    districtId: '6106010',
    name: 'Pangkalan Batu',
  },
  {
    id: '6106010007',
    districtId: '6106010',
    name: 'Suka Harapan',
  },
  {
    id: '6106010008',
    districtId: '6106010',
    name: 'Suka Damai',
  },
  {
    id: '6106010009',
    districtId: '6106010',
    name: 'Selimatan Jaya',
  },
  {
    id: '6106010010',
    districtId: '6106010',
    name: 'Danau Buntar',
  },
  {
    id: '6106010011',
    districtId: '6106010',
    name: 'Mekar Utama',
  },
  {
    id: '6106010012',
    districtId: '6106010',
    name: 'Pembedilan',
  },
  {
    id: '6106010013',
    districtId: '6106010',
    name: 'Air Hitam Hulu',
  },
  {
    id: '6106010014',
    districtId: '6106010',
    name: 'Natai Kuini',
  },
  {
    id: '6106010015',
    districtId: '6106010',
    name: 'Keramat Jaya',
  },
  {
    id: '6106010016',
    districtId: '6106010',
    name: 'Seriam',
  },
  {
    id: '6106010017',
    districtId: '6106010',
    name: 'Kedondong',
  },
  {
    id: '6106010018',
    districtId: '6106010',
    name: 'Sungai Jelayan',
  },
  {
    id: '6106010019',
    districtId: '6106010',
    name: 'Air Tarap',
  },
  {
    id: '6106020001',
    districtId: '6106020',
    name: 'Suka Ramai',
  },
  {
    id: '6106020002',
    districtId: '6106020',
    name: 'Manis Mata',
  },
  {
    id: '6106020003',
    districtId: '6106020',
    name: 'Suak Burung',
  },
  {
    id: '6106020004',
    districtId: '6106020',
    name: 'Air Dekakah',
  },
  {
    id: '6106020005',
    districtId: '6106020',
    name: 'Silat',
  },
  {
    id: '6106020006',
    districtId: '6106020',
    name: 'Terusan',
  },
  {
    id: '6106020007',
    districtId: '6106020',
    name: 'Kemuning',
  },
  {
    id: '6106020008',
    districtId: '6106020',
    name: 'Kelampai',
  },
  {
    id: '6106020009',
    districtId: '6106020',
    name: 'Bukit Gajah',
  },
  {
    id: '6106020010',
    districtId: '6106020',
    name: 'Lembah Mukti',
  },
  {
    id: '6106020011',
    districtId: '6106020',
    name: 'Asam Besar',
  },
  {
    id: '6106020012',
    districtId: '6106020',
    name: 'Batu Sedau',
  },
  {
    id: '6106020013',
    districtId: '6106020',
    name: 'Jambi',
  },
  {
    id: '6106020014',
    districtId: '6106020',
    name: 'Seguling',
  },
  {
    id: '6106020015',
    districtId: '6106020',
    name: 'Kalimantan',
  },
  {
    id: '6106020016',
    districtId: '6106020',
    name: 'Pelempangan',
  },
  {
    id: '6106020017',
    districtId: '6106020',
    name: 'Sengkuang Merabong',
  },
  {
    id: '6106020018',
    districtId: '6106020',
    name: 'Pakit Selaba',
  },
  {
    id: '6106020019',
    districtId: '6106020',
    name: 'Sungai Buluh',
  },
  {
    id: '6106020020',
    districtId: '6106020',
    name: 'Mekar Jaya',
  },
  {
    id: '6106020021',
    districtId: '6106020',
    name: 'Ratu Elok',
  },
  {
    id: '6106020022',
    districtId: '6106020',
    name: 'Tribun Jaya',
  },
  {
    id: '6106030009',
    districtId: '6106030',
    name: 'Karya Baru',
  },
  {
    id: '6106030016',
    districtId: '6106030',
    name: 'Runjai Jaya',
  },
  {
    id: '6106030017',
    districtId: '6106030',
    name: 'Suka Karya',
  },
  {
    id: '6106030018',
    districtId: '6106030',
    name: 'Belaban',
  },
  {
    id: '6106030019',
    districtId: '6106030',
    name: 'Randai',
  },
  {
    id: '6106030020',
    districtId: '6106030',
    name: 'Riam Batu Gading',
  },
  {
    id: '6106030021',
    districtId: '6106030',
    name: 'Batu Payung Dua',
  },
  {
    id: '6106030022',
    districtId: '6106030',
    name: 'Bantan Sari',
  },
  {
    id: '6106030023',
    districtId: '6106030',
    name: 'Pelanjau Jaya',
  },
  {
    id: '6106030024',
    districtId: '6106030',
    name: 'Rangkung',
  },
  {
    id: '6106031001',
    districtId: '6106031',
    name: 'Sukasari',
  },
  {
    id: '6106031002',
    districtId: '6106031',
    name: 'Sukaraja',
  },
  {
    id: '6106031003',
    districtId: '6106031',
    name: 'Bukit Kelambing',
  },
  {
    id: '6106031004',
    districtId: '6106031',
    name: 'Muntai',
  },
  {
    id: '6106031005',
    districtId: '6106031',
    name: 'Sukaharja',
  },
  {
    id: '6106031006',
    districtId: '6106031',
    name: 'Sukamulya',
  },
  {
    id: '6106031007',
    districtId: '6106031',
    name: 'Tanah Hitam',
  },
  {
    id: '6106031008',
    districtId: '6106031',
    name: 'Pantai Ketikal',
  },
  {
    id: '6106032001',
    districtId: '6106032',
    name: 'Membuluh Baru',
  },
  {
    id: '6106032002',
    districtId: '6106032',
    name: 'Gahang',
  },
  {
    id: '6106032003',
    districtId: '6106032',
    name: 'Air Upas',
  },
  {
    id: '6106032004',
    districtId: '6106032',
    name: 'Air Durian Jaya',
  },
  {
    id: '6106032005',
    districtId: '6106032',
    name: 'Sari Bekayas',
  },
  {
    id: '6106032006',
    districtId: '6106032',
    name: 'Banda Sari',
  },
  {
    id: '6106032007',
    districtId: '6106032',
    name: 'Sukaria',
  },
  {
    id: '6106032008',
    districtId: '6106032',
    name: 'Harapan Baru',
  },
  {
    id: '6106032009',
    districtId: '6106032',
    name: 'Mekar Jaya',
  },
  {
    id: '6106040001',
    districtId: '6106040',
    name: 'Biku Sarana',
  },
  {
    id: '6106040002',
    districtId: '6106040',
    name: 'Penyarang',
  },
  {
    id: '6106040003',
    districtId: '6106040',
    name: 'Periangan',
  },
  {
    id: '6106040004',
    districtId: '6106040',
    name: 'Tanggerang',
  },
  {
    id: '6106040005',
    districtId: '6106040',
    name: 'Kesuma Jaya',
  },
  {
    id: '6106040006',
    districtId: '6106040',
    name: 'Semantun',
  },
  {
    id: '6106040007',
    districtId: '6106040',
    name: 'Riam Danau Kanan',
  },
  {
    id: '6106040008',
    districtId: '6106040',
    name: 'Limpang',
  },
  {
    id: '6106040009',
    districtId: '6106040',
    name: 'Pasir Mayang',
  },
  {
    id: '6106040010',
    districtId: '6106040',
    name: 'Tebing Berseri',
  },
  {
    id: '6106040011',
    districtId: '6106040',
    name: 'Rangga Intan',
  },
  {
    id: '6106040012',
    districtId: '6106040',
    name: 'Deranuk',
  },
  {
    id: '6106040013',
    districtId: '6106040',
    name: 'Pangkalan Suka',
  },
  {
    id: '6106040014',
    districtId: '6106040',
    name: 'Teluk Runjai',
  },
  {
    id: '6106040015',
    districtId: '6106040',
    name: 'Asam Jelai',
  },
  {
    id: '6106040016',
    districtId: '6106040',
    name: 'Air Dua',
  },
  {
    id: '6106040017',
    districtId: '6106040',
    name: 'Sidahari',
  },
  {
    id: '6106040018',
    districtId: '6106040',
    name: 'Karang Dangin',
  },
  {
    id: '6106040019',
    districtId: '6106040',
    name: 'Kusik Batu Lapu',
  },
  {
    id: '6106040020',
    districtId: '6106040',
    name: 'Perigi',
  },
  {
    id: '6106040021',
    districtId: '6106040',
    name: 'Bayam Raya',
  },
  {
    id: '6106040022',
    districtId: '6106040',
    name: 'Pangkalan Paket',
  },
  {
    id: '6106050001',
    districtId: '6106050',
    name: 'Nanga Kelampai',
  },
  {
    id: '6106050002',
    districtId: '6106050',
    name: 'Pemuatan Jaya',
  },
  {
    id: '6106050003',
    districtId: '6106050',
    name: 'Kalimas Baru',
  },
  {
    id: '6106050004',
    districtId: '6106050',
    name: 'Belaban Tujuh',
  },
  {
    id: '6106050005',
    districtId: '6106050',
    name: 'Mahawa',
  },
  {
    id: '6106050006',
    districtId: '6106050',
    name: 'Serengkah',
  },
  {
    id: '6106050007',
    districtId: '6106050',
    name: 'Natai Panjang',
  },
  {
    id: '6106050008',
    districtId: '6106050',
    name: 'Tumbang Titi',
  },
  {
    id: '6106050009',
    districtId: '6106050',
    name: 'Batu Tajam',
  },
  {
    id: '6106050010',
    districtId: '6106050',
    name: 'Sengkaharak',
  },
  {
    id: '6106050022',
    districtId: '6106050',
    name: 'Segar Wangi',
  },
  {
    id: '6106050023',
    districtId: '6106050',
    name: 'Petebang Jaya',
  },
  {
    id: '6106050024',
    districtId: '6106050',
    name: 'Aur Gading',
  },
  {
    id: '6106050025',
    districtId: '6106050',
    name: 'Beringin Rayo',
  },
  {
    id: '6106050026',
    districtId: '6106050',
    name: 'Titi Baru',
  },
  {
    id: '6106050027',
    districtId: '6106050',
    name: 'Tanjung Beulang',
  },
  {
    id: '6106050028',
    districtId: '6106050',
    name: 'Batu Beransah',
  },
  {
    id: '6106050029',
    districtId: '6106050',
    name: 'Serengkah Kanan',
  },
  {
    id: '6106050030',
    districtId: '6106050',
    name: 'Sepauhan Jaya',
  },
  {
    id: '6106050031',
    districtId: '6106050',
    name: 'Jungkal',
  },
  {
    id: '6106050032',
    districtId: '6106050',
    name: 'Jelayan',
  },
  {
    id: '6106050033',
    districtId: '6106050',
    name: 'Suka Damai',
  },
  {
    id: '6106050034',
    districtId: '6106050',
    name: 'Tanjung Maloi',
  },
  {
    id: '6106050035',
    districtId: '6106050',
    name: 'Pengatapan Raya',
  },
  {
    id: '6106050036',
    districtId: '6106050',
    name: 'Sepuring Indah',
  },
  {
    id: '6106051001',
    districtId: '6106051',
    name: 'Lalang Panjang',
  },
  {
    id: '6106051002',
    districtId: '6106051',
    name: 'Pebihingan',
  },
  {
    id: '6106051003',
    districtId: '6106051',
    name: 'Semayok Baru',
  },
  {
    id: '6106051004',
    districtId: '6106051',
    name: 'Muara Gerunggang',
  },
  {
    id: '6106051005',
    districtId: '6106051',
    name: 'Usaha Baru',
  },
  {
    id: '6106051006',
    districtId: '6106051',
    name: 'Kerta Baru',
  },
  {
    id: '6106051007',
    districtId: '6106051',
    name: 'Muara Semayok',
  },
  {
    id: '6106052002',
    districtId: '6106052',
    name: 'Suka Mulya',
  },
  {
    id: '6106052003',
    districtId: '6106052',
    name: 'Sungai Melayu Baru',
  },
  {
    id: '6106052004',
    districtId: '6106052',
    name: 'Beringin Jaya',
  },
  {
    id: '6106052005',
    districtId: '6106052',
    name: 'Piansak',
  },
  {
    id: '6106052006',
    districtId: '6106052',
    name: 'Jairan Jaya',
  },
  {
    id: '6106052007',
    districtId: '6106052',
    name: 'Karya Mukti',
  },
  {
    id: '6106052008',
    districtId: '6106052',
    name: 'Sungai Melayu Jaya',
  },
  {
    id: '6106052009',
    districtId: '6106052',
    name: 'Sei Melayu',
  },
  {
    id: '6106052010',
    districtId: '6106052',
    name: 'Mekar Jaya',
  },
  {
    id: '6106052011',
    districtId: '6106052',
    name: 'Makmur Abadi',
  },
  {
    id: '6106060001',
    districtId: '6106060',
    name: 'Sungai Nanjung',
  },
  {
    id: '6106060002',
    districtId: '6106060',
    name: 'Pesaguan Kanan',
  },
  {
    id: '6106060003',
    districtId: '6106060',
    name: 'Pesaguan Kiri',
  },
  {
    id: '6106060004',
    districtId: '6106060',
    name: 'Sungai Bakau',
  },
  {
    id: '6106060005',
    districtId: '6106060',
    name: 'Pematang Gadung',
  },
  {
    id: '6106060006',
    districtId: '6106060',
    name: 'Sungai Besar',
  },
  {
    id: '6106060007',
    districtId: '6106060',
    name: 'Sungai Pelang',
  },
  {
    id: '6106060008',
    districtId: '6106060',
    name: 'Sungai Jawi',
  },
  {
    id: '6106060009',
    districtId: '6106060',
    name: 'Kemuning Biutak',
  },
  {
    id: '6106060010',
    districtId: '6106060',
    name: 'Harapan Baru',
  },
  {
    id: '6106060011',
    districtId: '6106060',
    name: 'Pagar Mentimun',
  },
  {
    id: '6106061001',
    districtId: '6106061',
    name: 'Padang',
  },
  {
    id: '6106061002',
    districtId: '6106061',
    name: 'Tuan Tuan',
  },
  {
    id: '6106061003',
    districtId: '6106061',
    name: 'Negeri Baru',
  },
  {
    id: '6106061004',
    districtId: '6106061',
    name: 'Mulia Kerta',
  },
  {
    id: '6106061005',
    districtId: '6106061',
    name: 'Sungai Kinjil',
  },
  {
    id: '6106061006',
    districtId: '6106061',
    name: 'Kauman',
  },
  {
    id: '6106061007',
    districtId: '6106061',
    name: 'Baru',
  },
  {
    id: '6106061008',
    districtId: '6106061',
    name: 'Suka Baru',
  },
  {
    id: '6106061009',
    districtId: '6106061',
    name: 'Banjar',
  },
  {
    id: '6106061010',
    districtId: '6106061',
    name: 'Mekar Sari',
  },
  {
    id: '6106061011',
    districtId: '6106061',
    name: 'Kinjil Pesisir',
  },
  {
    id: '6106070012',
    districtId: '6106070',
    name: 'Sungai Putri',
  },
  {
    id: '6106070014',
    districtId: '6106070',
    name: 'Tanjung Baik Budi',
  },
  {
    id: '6106070015',
    districtId: '6106070',
    name: 'Kuala Tolak',
  },
  {
    id: '6106070016',
    districtId: '6106070',
    name: 'Kuala Satong',
  },
  {
    id: '6106070017',
    districtId: '6106070',
    name: 'Laman Satong',
  },
  {
    id: '6106071001',
    districtId: '6106071',
    name: 'Kantor',
  },
  {
    id: '6106071002',
    districtId: '6106071',
    name: 'Mulia Baru',
  },
  {
    id: '6106071003',
    districtId: '6106071',
    name: 'Tengah',
  },
  {
    id: '6106071004',
    districtId: '6106071',
    name: 'Sampit',
  },
  {
    id: '6106071005',
    districtId: '6106071',
    name: 'Sukaharja',
  },
  {
    id: '6106071006',
    districtId: '6106071',
    name: 'Kali Nilam',
  },
  {
    id: '6106071007',
    districtId: '6106071',
    name: 'Sukabangun',
  },
  {
    id: '6106071008',
    districtId: '6106071',
    name: 'Paya Kumang',
  },
  {
    id: '6106071009',
    districtId: '6106071',
    name: 'Sukabangun Dalam',
  },
  {
    id: '6106072001',
    districtId: '6106072',
    name: 'Sungai Awan Kanan',
  },
  {
    id: '6106072002',
    districtId: '6106072',
    name: 'Sungai Awan Kiri',
  },
  {
    id: '6106072003',
    districtId: '6106072',
    name: 'Tempurukan',
  },
  {
    id: '6106072004',
    districtId: '6106072',
    name: 'Tanjung Pura',
  },
  {
    id: '6106072005',
    districtId: '6106072',
    name: 'Ulak Medang',
  },
  {
    id: '6106072006',
    districtId: '6106072',
    name: 'Mayak',
  },
  {
    id: '6106072007',
    districtId: '6106072',
    name: 'Tanjung Pasar',
  },
  {
    id: '6106072008',
    districtId: '6106072',
    name: 'Suka Maju',
  },
  {
    id: '6106090001',
    districtId: '6106090',
    name: 'Sungai Kelik',
  },
  {
    id: '6106090002',
    districtId: '6106090',
    name: 'Lembah Hijau II',
  },
  {
    id: '6106090003',
    districtId: '6106090',
    name: 'Lembah Hijau I',
  },
  {
    id: '6106090004',
    districtId: '6106090',
    name: 'Nanga Tayap',
  },
  {
    id: '6106090005',
    districtId: '6106090',
    name: 'Siantau Raya',
  },
  {
    id: '6106090006',
    districtId: '6106090',
    name: 'Batumas',
  },
  {
    id: '6106090008',
    districtId: '6106090',
    name: 'Pangkalan Suka',
  },
  {
    id: '6106090009',
    districtId: '6106090',
    name: 'Pangkalan Telok',
  },
  {
    id: '6106090010',
    districtId: '6106090',
    name: 'Sebadak Raya',
  },
  {
    id: '6106090011',
    districtId: '6106090',
    name: 'Simpang Tiga Sembelangaan',
  },
  {
    id: '6106090012',
    districtId: '6106090',
    name: 'Mensubang',
  },
  {
    id: '6106090013',
    districtId: '6106090',
    name: 'Tajok Kayong',
  },
  {
    id: '6106090014',
    districtId: '6106090',
    name: 'Kayong Utara',
  },
  {
    id: '6106090015',
    districtId: '6106090',
    name: 'Kayong Hulu',
  },
  {
    id: '6106090016',
    districtId: '6106090',
    name: 'Sepakat Jaya',
  },
  {
    id: '6106090017',
    districtId: '6106090',
    name: 'Cegolak',
  },
  {
    id: '6106090018',
    districtId: '6106090',
    name: 'Pateh Benteng',
  },
  {
    id: '6106090019',
    districtId: '6106090',
    name: 'Tanjung Medan',
  },
  {
    id: '6106090020',
    districtId: '6106090',
    name: 'Kayung Tuhe',
  },
  {
    id: '6106100001',
    districtId: '6106100',
    name: 'Penjawaan',
  },
  {
    id: '6106100002',
    districtId: '6106100',
    name: 'Sandai',
  },
  {
    id: '6106100003',
    districtId: '6106100',
    name: 'Muara Jekak',
  },
  {
    id: '6106100004',
    districtId: '6106100',
    name: 'Petai Patah',
  },
  {
    id: '6106100005',
    districtId: '6106100',
    name: 'Randau Jungkal',
  },
  {
    id: '6106100009',
    districtId: '6106100',
    name: 'Randau',
  },
  {
    id: '6106100011',
    districtId: '6106100',
    name: 'Sandai Kiri',
  },
  {
    id: '6106100012',
    districtId: '6106100',
    name: 'Demit',
  },
  {
    id: '6106100013',
    districtId: '6106100',
    name: 'Jago Bersatu',
  },
  {
    id: '6106100014',
    districtId: '6106100',
    name: 'Pendamar Indah',
  },
  {
    id: '6106100015',
    districtId: '6106100',
    name: 'Merimbang Jaya',
  },
  {
    id: '6106100016',
    districtId: '6106100',
    name: 'Alam Pakuan',
  },
  {
    id: '6106100017',
    districtId: '6106100',
    name: 'Istana',
  },
  {
    id: '6106101002',
    districtId: '6106101',
    name: 'Senduruhan',
  },
  {
    id: '6106101003',
    districtId: '6106101',
    name: 'Cinta Manis',
  },
  {
    id: '6106101004',
    districtId: '6106101',
    name: 'Beginci Darat',
  },
  {
    id: '6106101005',
    districtId: '6106101',
    name: 'Benua Krio',
  },
  {
    id: '6106101006',
    districtId: '6106101',
    name: 'Riam Dadap',
  },
  {
    id: '6106101008',
    districtId: '6106101',
    name: 'Batu Lapis',
  },
  {
    id: '6106101009',
    districtId: '6106101',
    name: 'Krio Hulu',
  },
  {
    id: '6106101010',
    districtId: '6106101',
    name: 'Kenyabur',
  },
  {
    id: '6106101011',
    districtId: '6106101',
    name: 'Sunge Bengaras',
  },
  {
    id: '6106101012',
    districtId: '6106101',
    name: 'Lubuk Kakap',
  },
  {
    id: '6106110001',
    districtId: '6106110',
    name: 'Sempurna',
  },
  {
    id: '6106110002',
    districtId: '6106110',
    name: 'Riam Bunut',
  },
  {
    id: '6106110003',
    districtId: '6106110',
    name: 'Bengaras',
  },
  {
    id: '6106110004',
    districtId: '6106110',
    name: 'Sukaramai',
  },
  {
    id: '6106110005',
    districtId: '6106110',
    name: 'Sepotong',
  },
  {
    id: '6106110006',
    districtId: '6106110',
    name: 'Tanjung Beringin',
  },
  {
    id: '6106110007',
    districtId: '6106110',
    name: 'Bayunsari',
  },
  {
    id: '6106110008',
    districtId: '6106110',
    name: 'Harapan Baru',
  },
  {
    id: '6106110009',
    districtId: '6106110',
    name: 'Randau Limat',
  },
  {
    id: '6106110010',
    districtId: '6106110',
    name: 'Tanjung Maju',
  },
  {
    id: '6106110011',
    districtId: '6106110',
    name: 'Sungai Daka',
  },
  {
    id: '6106110012',
    districtId: '6106110',
    name: 'Mekar Harapan',
  },
  {
    id: '6106110013',
    districtId: '6106110',
    name: 'Sinar Kuri',
  },
  {
    id: '6106110014',
    districtId: '6106110',
    name: 'Teluk Bayur',
  },
  {
    id: '6106110015',
    districtId: '6106110',
    name: 'Selangkut Raya',
  },
  {
    id: '6106110016',
    districtId: '6106110',
    name: 'Lanjut Mekar Sari',
  },
  {
    id: '6106110017',
    districtId: '6106110',
    name: 'Kepari',
  },
  {
    id: '6106110018',
    districtId: '6106110',
    name: 'Teluk Mutiara',
  },
  {
    id: '6106110019',
    districtId: '6106110',
    name: 'Merabu Jaya',
  },
  {
    id: '6106120004',
    districtId: '6106120',
    name: 'Kualan Hilir',
  },
  {
    id: '6106120005',
    districtId: '6106120',
    name: 'Sekucing Labai',
  },
  {
    id: '6106120006',
    districtId: '6106120',
    name: 'Balai Pinang',
  },
  {
    id: '6106120007',
    districtId: '6106120',
    name: 'Semandang Kiri',
  },
  {
    id: '6106120008',
    districtId: '6106120',
    name: 'Semandang Hulu',
  },
  {
    id: '6106120009',
    districtId: '6106120',
    name: 'Merawa',
  },
  {
    id: '6106120010',
    districtId: '6106120',
    name: 'Kualan Tengah',
  },
  {
    id: '6106120011',
    districtId: '6106120',
    name: 'Kualan Hulu',
  },
  {
    id: '6106120012',
    districtId: '6106120',
    name: 'Paoh Concong',
  },
  {
    id: '6106120013',
    districtId: '6106120',
    name: 'Legong',
  },
  {
    id: '6106120014',
    districtId: '6106120',
    name: 'Kenanga',
  },
  {
    id: '6106120015',
    districtId: '6106120',
    name: 'Sekucing Kualan',
  },
  {
    id: '6106120016',
    districtId: '6106120',
    name: 'Balai Pinang Hulu',
  },
  {
    id: '6106120017',
    districtId: '6106120',
    name: 'Labai Hilir',
  },
  {
    id: '6106120018',
    districtId: '6106120',
    name: 'Botuh Bosi',
  },
  {
    id: '6106121001',
    districtId: '6106121',
    name: 'Mekar Raya',
  },
  {
    id: '6106121002',
    districtId: '6106121',
    name: 'Gema',
  },
  {
    id: '6106121003',
    districtId: '6106121',
    name: 'Semandang Kanan',
  },
  {
    id: '6106121004',
    districtId: '6106121',
    name: 'Kampar Sebomban',
  },
  {
    id: '6106121005',
    districtId: '6106121',
    name: 'Batu Daya',
  },
  {
    id: '6106121006',
    districtId: '6106121',
    name: 'Kamora',
  },
  {
    id: '6107060001',
    districtId: '6107060',
    name: 'Baras Nabun',
  },
  {
    id: '6107060003',
    districtId: '6107060',
    name: 'Nanga Riyoi',
  },
  {
    id: '6107060004',
    districtId: '6107060',
    name: 'Buntut Ponte',
  },
  {
    id: '6107060005',
    districtId: '6107060',
    name: 'Nanga Segulang',
  },
  {
    id: '6107060006',
    districtId: '6107060',
    name: 'Nanga Mentatai',
  },
  {
    id: '6107060007',
    districtId: '6107060',
    name: 'Nanga Serawai',
  },
  {
    id: '6107060008',
    districtId: '6107060',
    name: 'Bedaha',
  },
  {
    id: '6107060009',
    districtId: '6107060',
    name: 'Begori',
  },
  {
    id: '6107060010',
    districtId: '6107060',
    name: 'Pagar Lebata',
  },
  {
    id: '6107060011',
    districtId: '6107060',
    name: 'Tontang',
  },
  {
    id: '6107060012',
    districtId: '6107060',
    name: 'Karya Jaya',
  },
  {
    id: '6107060013',
    districtId: '6107060',
    name: 'Tanjung Raya',
  },
  {
    id: '6107060014',
    districtId: '6107060',
    name: 'Tahai Permai',
  },
  {
    id: '6107060015',
    districtId: '6107060',
    name: 'Merako Jaya',
  },
  {
    id: '6107060016',
    districtId: '6107060',
    name: 'Sawang Senghiang',
  },
  {
    id: '6107060017',
    districtId: '6107060',
    name: 'Tunas Harapan',
  },
  {
    id: '6107060018',
    districtId: '6107060',
    name: 'Teluk Harapan',
  },
  {
    id: '6107060019',
    districtId: '6107060',
    name: 'Gurung Senghiang',
  },
  {
    id: '6107060020',
    districtId: '6107060',
    name: 'Tanjung Harapan',
  },
  {
    id: '6107060021',
    districtId: '6107060',
    name: 'Rantau Malam',
  },
  {
    id: '6107060022',
    districtId: '6107060',
    name: 'Mentajoi',
  },
  {
    id: '6107060023',
    districtId: '6107060',
    name: 'Nanga Bihe',
  },
  {
    id: '6107060024',
    districtId: '6107060',
    name: 'Nanga Tekungai',
  },
  {
    id: '6107060025',
    districtId: '6107060',
    name: 'Talian Sahabung',
  },
  {
    id: '6107060026',
    districtId: '6107060',
    name: 'Batu Ketebung',
  },
  {
    id: '6107060027',
    districtId: '6107060',
    name: 'Muara Kota',
  },
  {
    id: '6107060028',
    districtId: '6107060',
    name: 'Mekar Sari',
  },
  {
    id: '6107060029',
    districtId: '6107060',
    name: 'Tanjung Baru',
  },
  {
    id: '6107060030',
    districtId: '6107060',
    name: 'Nusa Tujuh',
  },
  {
    id: '6107060031',
    districtId: '6107060',
    name: 'Nanga Ruhan',
  },
  {
    id: '6107060032',
    districtId: '6107060',
    name: 'Meroboi',
  },
  {
    id: '6107060033',
    districtId: '6107060',
    name: 'Panekasan',
  },
  {
    id: '6107060034',
    districtId: '6107060',
    name: 'Tamakung',
  },
  {
    id: '6107060035',
    districtId: '6107060',
    name: 'Limbur Bernaung Lestari',
  },
  {
    id: '6107060036',
    districtId: '6107060',
    name: 'Mensulung Bio',
  },
  {
    id: '6107060037',
    districtId: '6107060',
    name: 'Sabhang Landan',
  },
  {
    id: '6107060038',
    districtId: '6107060',
    name: 'Nanga Tangoi',
  },
  {
    id: '6107070001',
    districtId: '6107070',
    name: 'Buntut Sabon',
  },
  {
    id: '6107070002',
    districtId: '6107070',
    name: 'Nanga Menakon',
  },
  {
    id: '6107070003',
    districtId: '6107070',
    name: 'Nanga Kesange',
  },
  {
    id: '6107070004',
    districtId: '6107070',
    name: 'Nanga Kemangai',
  },
  {
    id: '6107070005',
    districtId: '6107070',
    name: 'Nanga Ambalau',
  },
  {
    id: '6107070006',
    districtId: '6107070',
    name: 'Nanga Sake',
  },
  {
    id: '6107070007',
    districtId: '6107070',
    name: 'Tanjung Andan',
  },
  {
    id: '6107070008',
    districtId: '6107070',
    name: 'Buntut Pimpin',
  },
  {
    id: '6107070009',
    districtId: '6107070',
    name: 'Kepala Jungai',
  },
  {
    id: '6107070010',
    districtId: '6107070',
    name: 'Nanga Keremue',
  },
  {
    id: '6107070011',
    districtId: '6107070',
    name: 'Nanga Menantak',
  },
  {
    id: '6107070013',
    districtId: '6107070',
    name: 'Nanga Sakai',
  },
  {
    id: '6107070014',
    districtId: '6107070',
    name: 'Nanga Mentomoi',
  },
  {
    id: '6107070015',
    districtId: '6107070',
    name: 'Sungai Tambun',
  },
  {
    id: '6107070016',
    districtId: '6107070',
    name: 'Riam Sabon',
  },
  {
    id: '6107070017',
    districtId: '6107070',
    name: 'Nanga Ukai',
  },
  {
    id: '6107070018',
    districtId: '6107070',
    name: 'Mensuang',
  },
  {
    id: '6107070019',
    districtId: '6107070',
    name: 'Dahtah Bungai',
  },
  {
    id: '6107070020',
    districtId: '6107070',
    name: 'Lunjan Tingang',
  },
  {
    id: '6107070021',
    districtId: '6107070',
    name: 'Bukit Tinggi',
  },
  {
    id: '6107070022',
    districtId: '6107070',
    name: 'Bukai Tukun',
  },
  {
    id: '6107070023',
    districtId: '6107070',
    name: 'Nusa Koring',
  },
  {
    id: '6107070024',
    districtId: '6107070',
    name: 'Purut Beribit',
  },
  {
    id: '6107070025',
    districtId: '6107070',
    name: 'Pulo Sabhang',
  },
  {
    id: '6107070026',
    districtId: '6107070',
    name: 'Patih Jepara',
  },
  {
    id: '6107070027',
    districtId: '6107070',
    name: 'Korong Daso',
  },
  {
    id: '6107070028',
    districtId: '6107070',
    name: 'Luting Mingan',
  },
  {
    id: '6107070029',
    districtId: '6107070',
    name: 'Kolangan Juoi',
  },
  {
    id: '6107070030',
    districtId: '6107070',
    name: 'Nanga Rade',
  },
  {
    id: '6107070031',
    districtId: '6107070',
    name: 'Jengkarang',
  },
  {
    id: '6107070033',
    districtId: '6107070',
    name: 'Nanga Pahangan',
  },
  {
    id: '6107080001',
    districtId: '6107080',
    name: 'Nanga Payak',
  },
  {
    id: '6107080002',
    districtId: '6107080',
    name: 'Tanjung Bunga',
  },
  {
    id: '6107080003',
    districtId: '6107080',
    name: 'Nanga Tebidah',
  },
  {
    id: '6107080004',
    districtId: '6107080',
    name: 'Entogong',
  },
  {
    id: '6107080005',
    districtId: '6107080',
    name: 'Nanga Tonggoi',
  },
  {
    id: '6107080006',
    districtId: '6107080',
    name: 'Tanjung Lalau',
  },
  {
    id: '6107080007',
    districtId: '6107080',
    name: 'Lintang Tambuk',
  },
  {
    id: '6107080008',
    districtId: '6107080',
    name: 'Nanga Masau',
  },
  {
    id: '6107080009',
    districtId: '6107080',
    name: 'Nanga Abai',
  },
  {
    id: '6107080010',
    districtId: '6107080',
    name: 'Nanga Ungai',
  },
  {
    id: '6107080011',
    districtId: '6107080',
    name: 'Nanga Toran',
  },
  {
    id: '6107080012',
    districtId: '6107080',
    name: 'Riam Panjang',
  },
  {
    id: '6107080013',
    districtId: '6107080',
    name: 'Nanga Laar',
  },
  {
    id: '6107080014',
    districtId: '6107080',
    name: 'Riam Muntik',
  },
  {
    id: '6107080015',
    districtId: '6107080',
    name: 'Merahau Permai',
  },
  {
    id: '6107080016',
    districtId: '6107080',
    name: 'Emponyang',
  },
  {
    id: '6107080017',
    districtId: '6107080',
    name: 'Landau Bara',
  },
  {
    id: '6107080018',
    districtId: '6107080',
    name: 'Topan Nanga',
  },
  {
    id: '6107080019',
    districtId: '6107080',
    name: 'Mapan Jaya',
  },
  {
    id: '6107080020',
    districtId: '6107080',
    name: 'Tonak Goneh',
  },
  {
    id: '6107080021',
    districtId: '6107080',
    name: 'Empakan',
  },
  {
    id: '6107080022',
    districtId: '6107080',
    name: 'Tanah Merah',
  },
  {
    id: '6107080023',
    districtId: '6107080',
    name: 'Merah Arai',
  },
  {
    id: '6107080024',
    districtId: '6107080',
    name: 'Tapang Manua',
  },
  {
    id: '6107080025',
    districtId: '6107080',
    name: 'Nangkak Lestari',
  },
  {
    id: '6107080026',
    districtId: '6107080',
    name: 'Nanga Oran',
  },
  {
    id: '6107080027',
    districtId: '6107080',
    name: 'Buluh Merindu',
  },
  {
    id: '6107080028',
    districtId: '6107080',
    name: 'Kerapuk Jaya',
  },
  {
    id: '6107080029',
    districtId: '6107080',
    name: 'Tanjung Miru',
  },
  {
    id: '6107080030',
    districtId: '6107080',
    name: 'Nanga Tampang',
  },
  {
    id: '6107080031',
    districtId: '6107080',
    name: 'Kebarau',
  },
  {
    id: '6107110001',
    districtId: '6107110',
    name: 'Nanga Pari',
  },
  {
    id: '6107110002',
    districtId: '6107110',
    name: 'Bernayau',
  },
  {
    id: '6107110003',
    districtId: '6107110',
    name: 'Sinar Pekayau',
  },
  {
    id: '6107110004',
    districtId: '6107110',
    name: 'Sekubang',
  },
  {
    id: '6107110005',
    districtId: '6107110',
    name: 'Nanga Libau',
  },
  {
    id: '6107110006',
    districtId: '6107110',
    name: 'Sekujam Timbai',
  },
  {
    id: '6107110007',
    districtId: '6107110',
    name: 'Semuntai',
  },
  {
    id: '6107110008',
    districtId: '6107110',
    name: 'Sirang Setambang',
  },
  {
    id: '6107110009',
    districtId: '6107110',
    name: 'Mait Hilir',
  },
  {
    id: '6107110010',
    districtId: '6107110',
    name: 'Lengkenat',
  },
  {
    id: '6107110011',
    districtId: '6107110',
    name: 'Manis Raya',
  },
  {
    id: '6107110012',
    districtId: '6107110',
    name: 'Kenyauk',
  },
  {
    id: '6107110013',
    districtId: '6107110',
    name: 'Nanga Sepauk',
  },
  {
    id: '6107110014',
    districtId: '6107110',
    name: 'Tanjung Ria',
  },
  {
    id: '6107110015',
    districtId: '6107110',
    name: 'Temiang Kapuas',
  },
  {
    id: '6107110016',
    districtId: '6107110',
    name: 'Ensabang',
  },
  {
    id: '6107110017',
    districtId: '6107110',
    name: 'Buluh Kuning',
  },
  {
    id: '6107110018',
    districtId: '6107110',
    name: 'Temawang Muntai',
  },
  {
    id: '6107110019',
    districtId: '6107110',
    name: 'Tawang Sari',
  },
  {
    id: '6107110020',
    districtId: '6107110',
    name: 'Gernis Jaya',
  },
  {
    id: '6107110021',
    districtId: '6107110',
    name: 'Paoh Benua',
  },
  {
    id: '6107110022',
    districtId: '6107110',
    name: 'Bedayan',
  },
  {
    id: '6107110023',
    districtId: '6107110',
    name: 'Tanjung Hulu',
  },
  {
    id: '6107110024',
    districtId: '6107110',
    name: 'Sungai Raya',
  },
  {
    id: '6107110025',
    districtId: '6107110',
    name: 'Landau Panjang',
  },
  {
    id: '6107110026',
    districtId: '6107110',
    name: 'Bangun',
  },
  {
    id: '6107110027',
    districtId: '6107110',
    name: 'Sukau Bersatu',
  },
  {
    id: '6107110028',
    districtId: '6107110',
    name: 'Kemantan',
  },
  {
    id: '6107110029',
    districtId: '6107110',
    name: 'Peninsung',
  },
  {
    id: '6107110031',
    districtId: '6107110',
    name: 'Temawang Bulai',
  },
  {
    id: '6107110032',
    districtId: '6107110',
    name: 'Sungai Segak',
  },
  {
    id: '6107110033',
    districtId: '6107110',
    name: 'Tanjung Balai',
  },
  {
    id: '6107110034',
    districtId: '6107110',
    name: 'Sinar Harapan',
  },
  {
    id: '6107110035',
    districtId: '6107110',
    name: 'Riam Kempadik',
  },
  {
    id: '6107110036',
    districtId: '6107110',
    name: 'Nanga Layung',
  },
  {
    id: '6107110037',
    districtId: '6107110',
    name: 'Limau Bakti',
  },
  {
    id: '6107110038',
    districtId: '6107110',
    name: 'Tanjung Mawang',
  },
  {
    id: '6107110039',
    districtId: '6107110',
    name: 'Bungkong Baru',
  },
  {
    id: '6107110040',
    districtId: '6107110',
    name: 'Sungai Jaung',
  },
  {
    id: '6107120001',
    districtId: '6107120',
    name: 'Benua Kencana',
  },
  {
    id: '6107120002',
    districtId: '6107120',
    name: 'Merti Jaya',
  },
  {
    id: '6107120003',
    districtId: '6107120',
    name: 'Gurung Mali',
  },
  {
    id: '6107120004',
    districtId: '6107120',
    name: 'Kuala Tiga',
  },
  {
    id: '6107120005',
    districtId: '6107120',
    name: 'Pulau Jaya',
  },
  {
    id: '6107120006',
    districtId: '6107120',
    name: 'Pangkal Baru',
  },
  {
    id: '6107120007',
    districtId: '6107120',
    name: 'Tinum Baru',
  },
  {
    id: '6107120008',
    districtId: '6107120',
    name: 'Benua Baru',
  },
  {
    id: '6107120009',
    districtId: '6107120',
    name: 'Kenyabur Baru',
  },
  {
    id: '6107120010',
    districtId: '6107120',
    name: 'Pagal Baru',
  },
  {
    id: '6107120011',
    districtId: '6107120',
    name: 'Repak Sari',
  },
  {
    id: '6107120012',
    districtId: '6107120',
    name: 'Mengkurat Baru',
  },
  {
    id: '6107120013',
    districtId: '6107120',
    name: 'Paribang Baru',
  },
  {
    id: '6107120014',
    districtId: '6107120',
    name: 'Suka Jaya',
  },
  {
    id: '6107120015',
    districtId: '6107120',
    name: 'Balai Harapan',
  },
  {
    id: '6107120016',
    districtId: '6107120',
    name: 'Nanga Tempunak',
  },
  {
    id: '6107120017',
    districtId: '6107120',
    name: 'Tanjung Perada',
  },
  {
    id: '6107120018',
    districtId: '6107120',
    name: 'Mensiap Baru',
  },
  {
    id: '6107120019',
    districtId: '6107120',
    name: 'Riam Batu',
  },
  {
    id: '6107120020',
    districtId: '6107120',
    name: 'Sungai Buluh',
  },
  {
    id: '6107120021',
    districtId: '6107120',
    name: 'Jaya Mentari',
  },
  {
    id: '6107120022',
    districtId: '6107120',
    name: 'Kupan Jaya',
  },
  {
    id: '6107120023',
    districtId: '6107120',
    name: 'Pudau Bersatu',
  },
  {
    id: '6107120024',
    districtId: '6107120',
    name: 'Tempunak Kapuas',
  },
  {
    id: '6107120025',
    districtId: '6107120',
    name: 'Pekulai Bersatu',
  },
  {
    id: '6107120026',
    districtId: '6107120',
    name: 'Mensiap Jaya',
  },
  {
    id: '6107130001',
    districtId: '6107130',
    name: 'Penjernang',
  },
  {
    id: '6107130002',
    districtId: '6107130',
    name: 'Sarai',
  },
  {
    id: '6107130003',
    districtId: '6107130',
    name: 'Melayang Sari',
  },
  {
    id: '6107130004',
    districtId: '6107130',
    name: 'Lebak Ubah',
  },
  {
    id: '6107130005',
    districtId: '6107130',
    name: 'Rarai',
  },
  {
    id: '6107130006',
    districtId: '6107130',
    name: 'Bonet Lama',
  },
  {
    id: '6107130007',
    districtId: '6107130',
    name: 'Bonet Engkabang',
  },
  {
    id: '6107130008',
    districtId: '6107130',
    name: 'Baya Betong',
  },
  {
    id: '6107130009',
    districtId: '6107130',
    name: 'Nobal',
  },
  {
    id: '6107130010',
    districtId: '6107130',
    name: 'Solam Raya',
  },
  {
    id: '6107130011',
    districtId: '6107130',
    name: 'Merarai Dua',
  },
  {
    id: '6107130012',
    districtId: '6107130',
    name: 'Perembang',
  },
  {
    id: '6107130013',
    districtId: '6107130',
    name: 'Bancoh',
  },
  {
    id: '6107130014',
    districtId: '6107130',
    name: 'Gurung Kempadik',
  },
  {
    id: '6107130015',
    districtId: '6107130',
    name: 'Kajang Baru',
  },
  {
    id: '6107130016',
    districtId: '6107130',
    name: 'Merarai Satu',
  },
  {
    id: '6107130017',
    districtId: '6107130',
    name: 'Manter',
  },
  {
    id: '6107130018',
    districtId: '6107130',
    name: 'Ransi Dakan',
  },
  {
    id: '6107130019',
    districtId: '6107130',
    name: 'Sungai Ukoi',
  },
  {
    id: '6107130020',
    districtId: '6107130',
    name: 'Penjernang Hulu',
  },
  {
    id: '6107130021',
    districtId: '6107130',
    name: 'Riam Kijang',
  },
  {
    id: '6107130022',
    districtId: '6107130',
    name: 'Baya Mulya',
  },
  {
    id: '6107130023',
    districtId: '6107130',
    name: 'Laman Raya',
  },
  {
    id: '6107130024',
    districtId: '6107130',
    name: 'Sabang Surai',
  },
  {
    id: '6107130025',
    districtId: '6107130',
    name: 'Balai Agung',
  },
  {
    id: '6107130026',
    districtId: '6107130',
    name: 'Kunyai',
  },
  {
    id: '6107140002',
    districtId: '6107140',
    name: 'Mungguk Bantok',
  },
  {
    id: '6107140003',
    districtId: '6107140',
    name: 'Tanjung Puri',
  },
  {
    id: '6107140004',
    districtId: '6107140',
    name: 'Baning Kota',
  },
  {
    id: '6107140005',
    districtId: '6107140',
    name: 'Ladang',
  },
  {
    id: '6107140006',
    districtId: '6107140',
    name: 'Kapuas Kanan Hulu',
  },
  {
    id: '6107140007',
    districtId: '6107140',
    name: 'Kapuas Kanan Hilir',
  },
  {
    id: '6107140008',
    districtId: '6107140',
    name: 'Kapuas Kiri Hilir',
  },
  {
    id: '6107140009',
    districtId: '6107140',
    name: 'Kapuas Kiri Hulu',
  },
  {
    id: '6107140010',
    districtId: '6107140',
    name: 'Teluk Kelansam',
  },
  {
    id: '6107140011',
    districtId: '6107140',
    name: 'Sungai Ana',
  },
  {
    id: '6107140012',
    districtId: '6107140',
    name: 'Marti Guna',
  },
  {
    id: '6107140013',
    districtId: '6107140',
    name: 'Tanjung Kelansam',
  },
  {
    id: '6107140014',
    districtId: '6107140',
    name: 'Anggah Jaya',
  },
  {
    id: '6107140015',
    districtId: '6107140',
    name: 'Lalang Baru',
  },
  {
    id: '6107140016',
    districtId: '6107140',
    name: 'Tebing Raya',
  },
  {
    id: '6107140017',
    districtId: '6107140',
    name: 'Mail Jempong',
  },
  {
    id: '6107140018',
    districtId: '6107140',
    name: 'Jerora Satu',
  },
  {
    id: '6107140019',
    districtId: '6107140',
    name: 'Kebiau Baru',
  },
  {
    id: '6107140020',
    districtId: '6107140',
    name: 'Akcaya',
  },
  {
    id: '6107140021',
    districtId: '6107140',
    name: 'Alai',
  },
  {
    id: '6107140022',
    districtId: '6107140',
    name: 'Ulak Jaya',
  },
  {
    id: '6107140023',
    districtId: '6107140',
    name: 'Menyumbung Tengah',
  },
  {
    id: '6107140024',
    districtId: '6107140',
    name: 'Batu Lalau',
  },
  {
    id: '6107140025',
    districtId: '6107140',
    name: 'Mekar Jaya',
  },
  {
    id: '6107140026',
    districtId: '6107140',
    name: 'Sengkuang',
  },
  {
    id: '6107140027',
    districtId: '6107140',
    name: 'Rawa Mambok',
  },
  {
    id: '6107140028',
    districtId: '6107140',
    name: 'Mengkurai',
  },
  {
    id: '6107140029',
    districtId: '6107140',
    name: 'Kedabang',
  },
  {
    id: '6107150001',
    districtId: '6107150',
    name: 'Lundang Baru',
  },
  {
    id: '6107150002',
    districtId: '6107150',
    name: 'Gandis',
  },
  {
    id: '6107150003',
    districtId: '6107150',
    name: 'Sungai Mali',
  },
  {
    id: '6107150004',
    districtId: '6107150',
    name: 'Nanga Dedai',
  },
  {
    id: '6107150005',
    districtId: '6107150',
    name: 'Penyak Lalang',
  },
  {
    id: '6107150006',
    districtId: '6107150',
    name: 'Pengkadan Sungai Rupa',
  },
  {
    id: '6107150007',
    districtId: '6107150',
    name: 'Kumpang',
  },
  {
    id: '6107150008',
    districtId: '6107150',
    name: 'Baras',
  },
  {
    id: '6107150009',
    districtId: '6107150',
    name: 'Riguk',
  },
  {
    id: '6107150010',
    districtId: '6107150',
    name: 'Pengkadan Baru',
  },
  {
    id: '6107150011',
    districtId: '6107150',
    name: 'Nanga Jetak',
  },
  {
    id: '6107150012',
    districtId: '6107150',
    name: 'Taok',
  },
  {
    id: '6107150013',
    districtId: '6107150',
    name: 'Empaci',
  },
  {
    id: '6107150014',
    districtId: '6107150',
    name: 'Mangat Baru',
  },
  {
    id: '6107150015',
    districtId: '6107150',
    name: 'Emparu',
  },
  {
    id: '6107150016',
    districtId: '6107150',
    name: 'Menaung Baru',
  },
  {
    id: '6107150017',
    districtId: '6107150',
    name: 'Umin Jaya',
  },
  {
    id: '6107150018',
    districtId: '6107150',
    name: 'Merempit Baru',
  },
  {
    id: '6107150019',
    districtId: '6107150',
    name: 'Dedai Kanan',
  },
  {
    id: '6107150020',
    districtId: '6107150',
    name: 'Sungai Tapang',
  },
  {
    id: '6107150021',
    districtId: '6107150',
    name: 'Gandis Hulu',
  },
  {
    id: '6107150022',
    districtId: '6107150',
    name: 'Hulu Dedai',
  },
  {
    id: '6107150023',
    districtId: '6107150',
    name: 'Apin Baru',
  },
  {
    id: '6107150024',
    districtId: '6107150',
    name: 'Jangkang',
  },
  {
    id: '6107150025',
    districtId: '6107150',
    name: 'Belinyuk Sibau',
  },
  {
    id: '6107150026',
    districtId: '6107150',
    name: 'Mengkirai Jaya',
  },
  {
    id: '6107150027',
    districtId: '6107150',
    name: 'Terusan',
  },
  {
    id: '6107150028',
    districtId: '6107150',
    name: 'Tanjung',
  },
  {
    id: '6107150029',
    districtId: '6107150',
    name: 'Batu Landung',
  },
  {
    id: '6107150030',
    districtId: '6107150',
    name: 'Samak',
  },
  {
    id: '6107150031',
    districtId: '6107150',
    name: 'Manyam',
  },
  {
    id: '6107160001',
    districtId: '6107160',
    name: 'Natai Tebedak',
  },
  {
    id: '6107160002',
    districtId: '6107160',
    name: 'Jambu',
  },
  {
    id: '6107160003',
    districtId: '6107160',
    name: 'Nanga Mau',
  },
  {
    id: '6107160004',
    districtId: '6107160',
    name: 'Mentunai',
  },
  {
    id: '6107160006',
    districtId: '6107160',
    name: 'Nyangkom',
  },
  {
    id: '6107160007',
    districtId: '6107160',
    name: 'Nanga Tikan',
  },
  {
    id: '6107160008',
    districtId: '6107160',
    name: 'Kerapa Sepan',
  },
  {
    id: '6107160009',
    districtId: '6107160',
    name: 'Pelaik',
  },
  {
    id: '6107160010',
    districtId: '6107160',
    name: 'Tertung Mau',
  },
  {
    id: '6107160011',
    districtId: '6107160',
    name: 'P A K A K',
  },
  {
    id: '6107160012',
    districtId: '6107160',
    name: 'Melingkat',
  },
  {
    id: '6107160013',
    districtId: '6107160',
    name: 'Sungai Buaya',
  },
  {
    id: '6107160014',
    districtId: '6107160',
    name: 'Sungai Sintang',
  },
  {
    id: '6107160015',
    districtId: '6107160',
    name: 'Sungai Garong',
  },
  {
    id: '6107160016',
    districtId: '6107160',
    name: 'Paoh Desa',
  },
  {
    id: '6107160017',
    districtId: '6107160',
    name: 'Jaya Sakti',
  },
  {
    id: '6107160018',
    districtId: '6107160',
    name: 'Mekar Mandiri',
  },
  {
    id: '6107160019',
    districtId: '6107160',
    name: 'Landau Beringin',
  },
  {
    id: '6107160020',
    districtId: '6107160',
    name: 'Karya Baru',
  },
  {
    id: '6107160021',
    districtId: '6107160',
    name: 'Bukit Segaloh',
  },
  {
    id: '6107160022',
    districtId: '6107160',
    name: 'Engkerangan',
  },
  {
    id: '6107160023',
    districtId: '6107160',
    name: 'Lalang Inggar',
  },
  {
    id: '6107160024',
    districtId: '6107160',
    name: 'Linggam Permai',
  },
  {
    id: '6107160025',
    districtId: '6107160',
    name: 'Sungai Menuang',
  },
  {
    id: '6107160026',
    districtId: '6107160',
    name: 'Natai Lesung',
  },
  {
    id: '6107160027',
    districtId: '6107160',
    name: 'Begendang Mal',
  },
  {
    id: '6107160028',
    districtId: '6107160',
    name: 'Sungai Ranap',
  },
  {
    id: '6107160029',
    districtId: '6107160',
    name: 'Nanga Lengkong Bindu',
  },
  {
    id: '6107160030',
    districtId: '6107160',
    name: 'Nanga Lidau',
  },
  {
    id: '6107160031',
    districtId: '6107160',
    name: 'Mengkirai',
  },
  {
    id: '6107160032',
    districtId: '6107160',
    name: 'Tanjung Keliling',
  },
  {
    id: '6107160033',
    districtId: '6107160',
    name: 'Buluk Jegara',
  },
  {
    id: '6107160034',
    districtId: '6107160',
    name: 'Buluk Panjang',
  },
  {
    id: '6107160035',
    districtId: '6107160',
    name: 'Tanjung Putar',
  },
  {
    id: '6107160036',
    districtId: '6107160',
    name: 'Sungai Emang',
  },
  {
    id: '6107160037',
    districtId: '6107160',
    name: 'Sungai Meraya',
  },
  {
    id: '6107160038',
    districtId: '6107160',
    name: 'Kempas Raya',
  },
  {
    id: '6107160039',
    districtId: '6107160',
    name: 'Ipoh Emang',
  },
  {
    id: '6107160040',
    districtId: '6107160',
    name: 'Sungai Pengga',
  },
  {
    id: '6107160041',
    districtId: '6107160',
    name: 'Batu Netak',
  },
  {
    id: '6107160042',
    districtId: '6107160',
    name: 'Neran Baya',
  },
  {
    id: '6107160043',
    districtId: '6107160',
    name: 'Monbai Begununk',
  },
  {
    id: '6107170001',
    districtId: '6107170',
    name: 'Kebong',
  },
  {
    id: '6107170002',
    districtId: '6107170',
    name: 'Merpak',
  },
  {
    id: '6107170003',
    districtId: '6107170',
    name: 'Nanga Lebang',
  },
  {
    id: '6107170004',
    districtId: '6107170',
    name: 'Sungai Maram',
  },
  {
    id: '6107170005',
    districtId: '6107170',
    name: 'Ensaid Panjang',
  },
  {
    id: '6107170006',
    districtId: '6107170',
    name: 'Baning Panjang',
  },
  {
    id: '6107170007',
    districtId: '6107170',
    name: 'Pelimping',
  },
  {
    id: '6107170008',
    districtId: '6107170',
    name: 'Sepan Lebang',
  },
  {
    id: '6107170009',
    districtId: '6107170',
    name: 'Sungai Pukat',
  },
  {
    id: '6107170010',
    districtId: '6107170',
    name: 'Bengkuang',
  },
  {
    id: '6107170011',
    districtId: '6107170',
    name: 'Gemba Raya',
  },
  {
    id: '6107170012',
    districtId: '6107170',
    name: 'Karya Jaya Bhakti',
  },
  {
    id: '6107170013',
    districtId: '6107170',
    name: 'Mandiri Jaya',
  },
  {
    id: '6107170014',
    districtId: '6107170',
    name: 'Landau Kodam',
  },
  {
    id: '6107170015',
    districtId: '6107170',
    name: 'Sungai Labi',
  },
  {
    id: '6107170016',
    districtId: '6107170',
    name: 'Sungai Lais',
  },
  {
    id: '6107170017',
    districtId: '6107170',
    name: 'Kelam Sejahtera',
  },
  {
    id: '6107180001',
    districtId: '6107180',
    name: 'Telaga Satu',
  },
  {
    id: '6107180002',
    districtId: '6107180',
    name: 'Telaga Dua',
  },
  {
    id: '6107180003',
    districtId: '6107180',
    name: 'Binjai Hilir',
  },
  {
    id: '6107180004',
    districtId: '6107180',
    name: 'Dak Jaya',
  },
  {
    id: '6107180005',
    districtId: '6107180',
    name: 'Ampar Bedang',
  },
  {
    id: '6107180006',
    districtId: '6107180',
    name: 'Mensiku',
  },
  {
    id: '6107180007',
    districtId: '6107180',
    name: 'Binjai Hulu',
  },
  {
    id: '6107180008',
    districtId: '6107180',
    name: 'Sungai Risap',
  },
  {
    id: '6107180009',
    districtId: '6107180',
    name: 'Empaka Kabiau Raya',
  },
  {
    id: '6107180010',
    districtId: '6107180',
    name: 'Sungai Risap Mensiku Bersatu',
  },
  {
    id: '6107180011',
    districtId: '6107180',
    name: 'Simba Jaya',
  },
  {
    id: '6107190001',
    districtId: '6107190',
    name: 'Semuntai',
  },
  {
    id: '6107190002',
    districtId: '6107190',
    name: 'Nanga Sejirak',
  },
  {
    id: '6107190004',
    districtId: '6107190',
    name: 'Nanga Ketungau',
  },
  {
    id: '6107190005',
    districtId: '6107190',
    name: 'Kenuak',
  },
  {
    id: '6107190006',
    districtId: '6107190',
    name: 'Sungai Deras',
  },
  {
    id: '6107190007',
    districtId: '6107190',
    name: 'Nanga Merkak',
  },
  {
    id: '6107190008',
    districtId: '6107190',
    name: 'Sungai Mali',
  },
  {
    id: '6107190009',
    districtId: '6107190',
    name: 'Air Nyuruk',
  },
  {
    id: '6107190010',
    districtId: '6107190',
    name: 'Semajau Mekar',
  },
  {
    id: '6107190011',
    districtId: '6107190',
    name: 'Baung Sengatap',
  },
  {
    id: '6107190012',
    districtId: '6107190',
    name: 'Tanjung Baung',
  },
  {
    id: '6107190013',
    districtId: '6107190',
    name: 'Senibung',
  },
  {
    id: '6107190014',
    districtId: '6107190',
    name: 'Beluh Mulyo',
  },
  {
    id: '6107190015',
    districtId: '6107190',
    name: 'Batu Ampar',
  },
  {
    id: '6107190016',
    districtId: '6107190',
    name: 'Bukit Sidin Permai',
  },
  {
    id: '6107190017',
    districtId: '6107190',
    name: 'Betung Permai',
  },
  {
    id: '6107190018',
    districtId: '6107190',
    name: 'Jentawang Hilir',
  },
  {
    id: '6107190019',
    districtId: '6107190',
    name: 'Batu Nyadi',
  },
  {
    id: '6107190020',
    districtId: '6107190',
    name: 'Ratu Damai',
  },
  {
    id: '6107190021',
    districtId: '6107190',
    name: 'Lepung Pantak',
  },
  {
    id: '6107190022',
    districtId: '6107190',
    name: 'Pampang Dua',
  },
  {
    id: '6107190023',
    districtId: '6107190',
    name: 'Mungguk Kepala',
  },
  {
    id: '6107190024',
    districtId: '6107190',
    name: 'Maung',
  },
  {
    id: '6107200001',
    districtId: '6107200',
    name: 'Bagelang Jaya',
  },
  {
    id: '6107200002',
    districtId: '6107200',
    name: 'Sumber Sari',
  },
  {
    id: '6107200003',
    districtId: '6107200',
    name: 'Panggi Agung',
  },
  {
    id: '6107200004',
    districtId: '6107200',
    name: 'Kerta Sari',
  },
  {
    id: '6107200005',
    districtId: '6107200',
    name: 'Argomulyo',
  },
  {
    id: '6107200006',
    districtId: '6107200',
    name: 'Tirta Karya',
  },
  {
    id: '6107200007',
    districtId: '6107200',
    name: 'Panding Jaya',
  },
  {
    id: '6107200008',
    districtId: '6107200',
    name: 'Tanjung Sari',
  },
  {
    id: '6107200009',
    districtId: '6107200',
    name: 'Wirayuda',
  },
  {
    id: '6107200010',
    districtId: '6107200',
    name: 'Swadaya',
  },
  {
    id: '6107200011',
    districtId: '6107200',
    name: 'Margahayu',
  },
  {
    id: '6107200012',
    districtId: '6107200',
    name: 'Gut Jaya Bakti',
  },
  {
    id: '6107200013',
    districtId: '6107200',
    name: 'Wana Bakti',
  },
  {
    id: '6107200014',
    districtId: '6107200',
    name: 'Landau Buaya',
  },
  {
    id: '6107200015',
    districtId: '6107200',
    name: 'Kayu Dujung',
  },
  {
    id: '6107200016',
    districtId: '6107200',
    name: 'Senangan Kecil',
  },
  {
    id: '6107200017',
    districtId: '6107200',
    name: 'Sungai Areh',
  },
  {
    id: '6107200018',
    districtId: '6107200',
    name: 'Mungguk Gelombang',
  },
  {
    id: '6107200019',
    districtId: '6107200',
    name: 'Mungguk Lawang',
  },
  {
    id: '6107200020',
    districtId: '6107200',
    name: 'Nanga Kelapan',
  },
  {
    id: '6107200021',
    districtId: '6107200',
    name: 'Panggi Ruguk',
  },
  {
    id: '6107200022',
    districtId: '6107200',
    name: 'Bakti Senabung',
  },
  {
    id: '6107200023',
    districtId: '6107200',
    name: 'Engkitan',
  },
  {
    id: '6107200024',
    districtId: '6107200',
    name: 'Landau Temiang',
  },
  {
    id: '6107200025',
    districtId: '6107200',
    name: 'Padung Kumang',
  },
  {
    id: '6107200026',
    districtId: '6107200',
    name: 'Radin Jaya',
  },
  {
    id: '6107200027',
    districtId: '6107200',
    name: 'Senangan Jaya',
  },
  {
    id: '6107200028',
    districtId: '6107200',
    name: 'Kubu Berangan',
  },
  {
    id: '6107200029',
    districtId: '6107200',
    name: 'Semareh',
  },
  {
    id: '6107210001',
    districtId: '6107210',
    name: 'Sungai Seria',
  },
  {
    id: '6107210002',
    districtId: '6107210',
    name: 'Sepiluk',
  },
  {
    id: '6107210003',
    districtId: '6107210',
    name: 'Sebadak',
  },
  {
    id: '6107210004',
    districtId: '6107210',
    name: 'Empura',
  },
  {
    id: '6107210005',
    districtId: '6107210',
    name: 'Suak Medang',
  },
  {
    id: '6107210006',
    districtId: '6107210',
    name: 'Nanga Bayan',
  },
  {
    id: '6107210007',
    districtId: '6107210',
    name: 'Jasa',
  },
  {
    id: '6107210008',
    districtId: '6107210',
    name: 'Senaning',
  },
  {
    id: '6107210009',
    districtId: '6107210',
    name: 'Rasau',
  },
  {
    id: '6107210010',
    districtId: '6107210',
    name: 'Sungai Bugau',
  },
  {
    id: '6107210011',
    districtId: '6107210',
    name: 'Nanga Bugau',
  },
  {
    id: '6107210012',
    districtId: '6107210',
    name: 'Empunak Tapang Keladan',
  },
  {
    id: '6107210013',
    districtId: '6107210',
    name: 'Sebetung Paluk',
  },
  {
    id: '6107210014',
    districtId: '6107210',
    name: 'Muakan Petinggi',
  },
  {
    id: '6107210015',
    districtId: '6107210',
    name: 'Nanga Sebawang',
  },
  {
    id: '6107210016',
    districtId: '6107210',
    name: 'Sekaih',
  },
  {
    id: '6107210017',
    districtId: '6107210',
    name: 'Bekuan Luyang',
  },
  {
    id: '6107210018',
    districtId: '6107210',
    name: 'Sungai Pisau',
  },
  {
    id: '6107210019',
    districtId: '6107210',
    name: 'Mungguk Entawak',
  },
  {
    id: '6107210020',
    districtId: '6107210',
    name: 'Embalih',
  },
  {
    id: '6107210022',
    districtId: '6107210',
    name: 'Riam Sejawak',
  },
  {
    id: '6107210024',
    districtId: '6107210',
    name: 'Sungai Kelik',
  },
  {
    id: '6107210025',
    districtId: '6107210',
    name: 'Idai',
  },
  {
    id: '6107210026',
    districtId: '6107210',
    name: 'Sungai Mawang',
  },
  {
    id: '6107210027',
    districtId: '6107210',
    name: 'Ujung Kempas',
  },
  {
    id: '6107210028',
    districtId: '6107210',
    name: 'Neraci Jaya',
  },
  {
    id: '6107210029',
    districtId: '6107210',
    name: 'Sejawak',
  },
  {
    id: '6108010001',
    districtId: '6108010',
    name: 'Bongkong',
  },
  {
    id: '6108010002',
    districtId: '6108010',
    name: 'Nanga Nuar',
  },
  {
    id: '6108010004',
    districtId: '6108010',
    name: 'Sungai Sena',
  },
  {
    id: '6108010005',
    districtId: '6108010',
    name: 'Miau Merah',
  },
  {
    id: '6108010006',
    districtId: '6108010',
    name: 'Pangeran',
  },
  {
    id: '6108010007',
    districtId: '6108010',
    name: 'Baru',
  },
  {
    id: '6108010008',
    districtId: '6108010',
    name: 'Perigi',
  },
  {
    id: '6108010009',
    districtId: '6108010',
    name: 'Penai',
  },
  {
    id: '6108010011',
    districtId: '6108010',
    name: 'Sentabai',
  },
  {
    id: '6108010012',
    districtId: '6108010',
    name: 'Rumbih',
  },
  {
    id: '6108010013',
    districtId: '6108010',
    name: 'Bukit Penai',
  },
  {
    id: '6108020001',
    districtId: '6108020',
    name: 'Nanga Ngeri',
  },
  {
    id: '6108020002',
    districtId: '6108020',
    name: 'Landau Badai',
  },
  {
    id: '6108020003',
    districtId: '6108020',
    name: 'Nanga Lungu',
  },
  {
    id: '6108020004',
    districtId: '6108020',
    name: 'Nanga Luan',
  },
  {
    id: '6108020005',
    districtId: '6108020',
    name: 'Belimbing',
  },
  {
    id: '6108020006',
    districtId: '6108020',
    name: 'Nanga Dangkan I',
  },
  {
    id: '6108020007',
    districtId: '6108020',
    name: 'Riam Tapang',
  },
  {
    id: '6108020008',
    districtId: '6108020',
    name: 'Nanga Dangkan II',
  },
  {
    id: '6108020009',
    districtId: '6108020',
    name: 'Lebak Najah',
  },
  {
    id: '6108020011',
    districtId: '6108020',
    name: 'Landau Rantau',
  },
  {
    id: '6108020012',
    districtId: '6108020',
    name: 'Entabi',
  },
  {
    id: '6108020013',
    districtId: '6108020',
    name: 'Selangkai',
  },
  {
    id: '6108020014',
    districtId: '6108020',
    name: 'Selimu',
  },
  {
    id: '6108030001',
    districtId: '6108030',
    name: 'Parang',
  },
  {
    id: '6108030002',
    districtId: '6108030',
    name: 'Lubuk Antuk',
  },
  {
    id: '6108030003',
    districtId: '6108030',
    name: 'Nanga Tepuai',
  },
  {
    id: '6108030004',
    districtId: '6108030',
    name: 'Landau Kumpang',
  },
  {
    id: '6108030005',
    districtId: '6108030',
    name: 'Nanga Yen',
  },
  {
    id: '6108030006',
    districtId: '6108030',
    name: 'Beringin',
  },
  {
    id: '6108030007',
    districtId: '6108030',
    name: 'Bugang',
  },
  {
    id: '6108030008',
    districtId: '6108030',
    name: 'Mentawit',
  },
  {
    id: '6108030009',
    districtId: '6108030',
    name: 'Tani Makmur',
  },
  {
    id: '6108030010',
    districtId: '6108030',
    name: 'Simpang Senara',
  },
  {
    id: '6108030011',
    districtId: '6108030',
    name: 'Kelakar',
  },
  {
    id: '6108030012',
    districtId: '6108030',
    name: 'Sejahtera Mandiri',
  },
  {
    id: '6108030014',
    districtId: '6108030',
    name: 'Tunas Muda',
  },
  {
    id: '6108030015',
    districtId: '6108030',
    name: 'Karya Mandiri',
  },
  {
    id: '6108040001',
    districtId: '6108040',
    name: 'Nanga Dua',
  },
  {
    id: '6108040002',
    districtId: '6108040',
    name: 'Selaup',
  },
  {
    id: '6108040003',
    districtId: '6108040',
    name: 'Nanga Semangut',
  },
  {
    id: '6108040005',
    districtId: '6108040',
    name: 'Nanga Suruk',
  },
  {
    id: '6108040006',
    districtId: '6108040',
    name: 'Riam Piyang',
  },
  {
    id: '6108040007',
    districtId: '6108040',
    name: 'Nanga Payang',
  },
  {
    id: '6108040008',
    districtId: '6108040',
    name: 'Batu Tiga',
  },
  {
    id: '6108040009',
    districtId: '6108040',
    name: 'Semangut Utara',
  },
  {
    id: '6108040010',
    districtId: '6108040',
    name: 'Segitak',
  },
  {
    id: '6108040011',
    districtId: '6108040',
    name: 'Nanga Kelibang',
  },
  {
    id: '6108040012',
    districtId: '6108040',
    name: 'Sungai Besar',
  },
  {
    id: '6108040013',
    districtId: '6108040',
    name: 'Bakung Permai',
  },
  {
    id: '6108040014',
    districtId: '6108040',
    name: 'Beringin',
  },
  {
    id: '6108040015',
    districtId: '6108040',
    name: 'Pantas Bersatu',
  },
  {
    id: '6108050001',
    districtId: '6108050',
    name: 'Tanjung',
  },
  {
    id: '6108050002',
    districtId: '6108050',
    name: 'Kepala Gurung',
  },
  {
    id: '6108050003',
    districtId: '6108050',
    name: 'Suka Maju',
  },
  {
    id: '6108050004',
    districtId: '6108050',
    name: 'Tekalong',
  },
  {
    id: '6108050005',
    districtId: '6108050',
    name: 'Nanga Mentebah',
  },
  {
    id: '6108050006',
    districtId: '6108050',
    name: 'Tanjung Intan',
  },
  {
    id: '6108050007',
    districtId: '6108050',
    name: 'Tangai Jaya',
  },
  {
    id: '6108050008',
    districtId: '6108050',
    name: 'Menaren',
  },
  {
    id: '6108060001',
    districtId: '6108060',
    name: 'Nanga Manday',
  },
  {
    id: '6108060005',
    districtId: '6108060',
    name: 'Bika',
  },
  {
    id: '6108060006',
    districtId: '6108060',
    name: 'Teluk Sindur',
  },
  {
    id: '6108060008',
    districtId: '6108060',
    name: 'Penyeluang',
  },
  {
    id: '6108060011',
    districtId: '6108060',
    name: 'Jongkong Manday',
  },
  {
    id: '6108060012',
    districtId: '6108060',
    name: 'Melapi Manday',
  },
  {
    id: '6108060013',
    districtId: '6108060',
    name: 'Bika Hulu',
  },
  {
    id: '6108070001',
    districtId: '6108070',
    name: 'Nanga Raun',
  },
  {
    id: '6108070002',
    districtId: '6108070',
    name: 'Bahenap',
  },
  {
    id: '6108070003',
    districtId: '6108070',
    name: 'Nanga Lebangan',
  },
  {
    id: '6108070004',
    districtId: '6108070',
    name: 'Nanga Sebintang',
  },
  {
    id: '6108070005',
    districtId: '6108070',
    name: 'Nanga Kalis',
  },
  {
    id: '6108070006',
    districtId: '6108070',
    name: 'Nanga Danau',
  },
  {
    id: '6108070007',
    districtId: '6108070',
    name: 'Nanga Tubuk',
  },
  {
    id: '6108070008',
    districtId: '6108070',
    name: 'Rantau Kalis',
  },
  {
    id: '6108070009',
    districtId: '6108070',
    name: 'Kensuray',
  },
  {
    id: '6108070010',
    districtId: '6108070',
    name: 'Kalis Raya',
  },
  {
    id: '6108070011',
    districtId: '6108070',
    name: 'Tekudak',
  },
  {
    id: '6108070012',
    districtId: '6108070',
    name: 'Semerantau',
  },
  {
    id: '6108070013',
    districtId: '6108070',
    name: "Tapang Da'An",
  },
  {
    id: '6108070014',
    districtId: '6108070',
    name: 'Segiam',
  },
  {
    id: '6108070015',
    districtId: '6108070',
    name: 'Payungan',
  },
  {
    id: '6108070016',
    districtId: '6108070',
    name: 'Ribang Kadeng',
  },
  {
    id: '6108070017',
    districtId: '6108070',
    name: 'Rantau Bumbun',
  },
  {
    id: '6108080001',
    districtId: '6108080',
    name: 'Sungai Uluk',
  },
  {
    id: '6108080002',
    districtId: '6108080',
    name: 'Jaras',
  },
  {
    id: '6108080003',
    districtId: '6108080',
    name: 'Kedamin Hilir',
  },
  {
    id: '6108080004',
    districtId: '6108080',
    name: 'Kedamin Hulu',
  },
  {
    id: '6108080005',
    districtId: '6108080',
    name: 'Melapi',
  },
  {
    id: '6108080006',
    districtId: '6108080',
    name: 'Tanjung Jati',
  },
  {
    id: '6108080007',
    districtId: '6108080',
    name: 'Kedamin Darat',
  },
  {
    id: '6108080008',
    districtId: '6108080',
    name: 'Sayut/Siyut',
  },
  {
    id: '6108080009',
    districtId: '6108080',
    name: 'Suka Maju',
  },
  {
    id: '6108080010',
    districtId: '6108080',
    name: 'Cempaka Baru',
  },
  {
    id: '6108080011',
    districtId: '6108080',
    name: 'Beringin Jaya',
  },
  {
    id: '6108080012',
    districtId: '6108080',
    name: 'Bungan Jaya',
  },
  {
    id: '6108080013',
    districtId: '6108080',
    name: 'Tanjung Lokang',
  },
  {
    id: '6108080014',
    districtId: '6108080',
    name: 'Urang Unsa',
  },
  {
    id: '6108080015',
    districtId: '6108080',
    name: 'Kereho',
  },
  {
    id: '6108080016',
    districtId: '6108080',
    name: "Ingko' Tambe",
  },
  {
    id: '6108090001',
    districtId: '6108090',
    name: 'Nanga Embaloh',
  },
  {
    id: '6108090002',
    districtId: '6108090',
    name: 'Keliling Semulung',
  },
  {
    id: '6108090006',
    districtId: '6108090',
    name: 'Lawik',
  },
  {
    id: '6108090007',
    districtId: '6108090',
    name: 'Nanga Lauk',
  },
  {
    id: '6108090008',
    districtId: '6108090',
    name: 'Nanga Palin',
  },
  {
    id: '6108090009',
    districtId: '6108090',
    name: 'Kirin Nangka',
  },
  {
    id: '6108090010',
    districtId: '6108090',
    name: 'Pala Pintas',
  },
  {
    id: '6108090011',
    districtId: '6108090',
    name: 'Ujung Bayur',
  },
  {
    id: '6108090012',
    districtId: '6108090',
    name: 'Belatung',
  },
  {
    id: '6108100002',
    districtId: '6108100',
    name: 'Nanga Tuan',
  },
  {
    id: '6108100004',
    districtId: '6108100',
    name: 'Bunut Hilir',
  },
  {
    id: '6108100005',
    districtId: '6108100',
    name: 'Teluk Aur',
  },
  {
    id: '6108100006',
    districtId: '6108100',
    name: 'Ujung Pandang',
  },
  {
    id: '6108100007',
    districtId: '6108100',
    name: 'Empangau',
  },
  {
    id: '6108100008',
    districtId: '6108100',
    name: 'Tembang',
  },
  {
    id: '6108100009',
    districtId: '6108100',
    name: 'Bunut Tengah',
  },
  {
    id: '6108100010',
    districtId: '6108100',
    name: 'Entibab',
  },
  {
    id: '6108100011',
    districtId: '6108100',
    name: 'Kapuas Raya',
  },
  {
    id: '6108100012',
    districtId: '6108100',
    name: 'Empangau Hilir',
  },
  {
    id: '6108110001',
    districtId: '6108110',
    name: 'Sri Wangi',
  },
  {
    id: '6108110002',
    districtId: '6108110',
    name: 'Nanga Sangan',
  },
  {
    id: '6108110003',
    districtId: '6108110',
    name: 'Riam Mengelai',
  },
  {
    id: '6108110004',
    districtId: '6108110',
    name: 'Boyan Tanjung',
  },
  {
    id: '6108110005',
    districtId: '6108110',
    name: 'Nanga Danau',
  },
  {
    id: '6108110006',
    districtId: '6108110',
    name: 'Nanga Boyan',
  },
  {
    id: '6108110007',
    districtId: '6108110',
    name: 'Nanga Betung',
  },
  {
    id: '6108110008',
    districtId: '6108110',
    name: 'Mujan',
  },
  {
    id: '6108110009',
    districtId: '6108110',
    name: 'Nanga Jemah',
  },
  {
    id: '6108110010',
    districtId: '6108110',
    name: 'Tubang Jaya',
  },
  {
    id: '6108110011',
    districtId: '6108110',
    name: 'Karya Maju',
  },
  {
    id: '6108110012',
    districtId: '6108110',
    name: 'Landau Mentail',
  },
  {
    id: '6108110013',
    districtId: '6108110',
    name: 'Delintas Karya',
  },
  {
    id: '6108110015',
    districtId: '6108110',
    name: 'Nanga Ret',
  },
  {
    id: '6108110016',
    districtId: '6108110',
    name: 'Pemawan',
  },
  {
    id: '6108120001',
    districtId: '6108120',
    name: 'Permata',
  },
  {
    id: '6108120002',
    districtId: '6108120',
    name: 'Marta Dana',
  },
  {
    id: '6108120003',
    districtId: '6108120',
    name: 'Riam Panjang',
  },
  {
    id: '6108120004',
    districtId: '6108120',
    name: 'Buak Limbang',
  },
  {
    id: '6108120005',
    districtId: '6108120',
    name: 'Mawan',
  },
  {
    id: '6108120006',
    districtId: '6108120',
    name: 'Kerangan Panjang',
  },
  {
    id: '6108120007',
    districtId: '6108120',
    name: 'Hulu Pengkadan',
  },
  {
    id: '6108120008',
    districtId: '6108120',
    name: 'Pinang Laka',
  },
  {
    id: '6108120009',
    districtId: '6108120',
    name: 'Sasan',
  },
  {
    id: '6108120010',
    districtId: '6108120',
    name: 'Pengkadan Hilir',
  },
  {
    id: '6108120011',
    districtId: '6108120',
    name: 'Sira Jaya',
  },
  {
    id: '6108130001',
    districtId: '6108130',
    name: 'Temenang',
  },
  {
    id: '6108130002',
    districtId: '6108130',
    name: 'Jongkong Kanan',
  },
  {
    id: '6108130003',
    districtId: '6108130',
    name: 'Jongkong Pasar',
  },
  {
    id: '6108130004',
    districtId: '6108130',
    name: 'Jongkong Kiri Hilir',
  },
  {
    id: '6108130005',
    districtId: '6108130',
    name: 'Jongkong Kiri Hulu',
  },
  {
    id: '6108130006',
    districtId: '6108130',
    name: 'Ujung Said',
  },
  {
    id: '6108130007',
    districtId: '6108130',
    name: 'Ujung Jambu',
  },
  {
    id: '6108130008',
    districtId: '6108130',
    name: 'Bontai',
  },
  {
    id: '6108130009',
    districtId: '6108130',
    name: 'Jongkong Kiri Tengah',
  },
  {
    id: '6108130010',
    districtId: '6108130',
    name: 'Jongkong Tanjung',
  },
  {
    id: '6108130011',
    districtId: '6108130',
    name: 'Kandung Suli',
  },
  {
    id: '6108130012',
    districtId: '6108130',
    name: 'Penepian Raya',
  },
  {
    id: '6108130013',
    districtId: '6108130',
    name: 'Karya Baru',
  },
  {
    id: '6108130014',
    districtId: '6108130',
    name: 'Nanga Serian',
  },
  {
    id: '6108140001',
    districtId: '6108140',
    name: 'Benuis',
  },
  {
    id: '6108140002',
    districtId: '6108140',
    name: 'Gerayau',
  },
  {
    id: '6108140003',
    districtId: '6108140',
    name: 'Engkerengas',
  },
  {
    id: '6108140004',
    districtId: '6108140',
    name: 'Piasak',
  },
  {
    id: '6108140005',
    districtId: '6108140',
    name: 'Nibung',
  },
  {
    id: '6108140006',
    districtId: '6108140',
    name: 'Dalam',
  },
  {
    id: '6108140007',
    districtId: '6108140',
    name: 'Gudang Hulu',
  },
  {
    id: '6108140008',
    districtId: '6108140',
    name: 'Gudang Hilir',
  },
  {
    id: '6108140009',
    districtId: '6108140',
    name: 'Titian Kuala',
  },
  {
    id: '6108140010',
    districtId: '6108140',
    name: 'Sekubah',
  },
  {
    id: '6108140011',
    districtId: '6108140',
    name: 'Mekar Permai',
  },
  {
    id: '6108140012',
    districtId: '6108140',
    name: 'Sekulat',
  },
  {
    id: '6108140013',
    districtId: '6108140',
    name: 'Nanga Leboyan',
  },
  {
    id: '6108140014',
    districtId: '6108140',
    name: 'Vega',
  },
  {
    id: '6108140015',
    districtId: '6108140',
    name: 'Mawan',
  },
  {
    id: '6108140016',
    districtId: '6108140',
    name: 'Semalah',
  },
  {
    id: '6108140017',
    districtId: '6108140',
    name: 'Tempurau',
  },
  {
    id: '6108150001',
    districtId: '6108150',
    name: 'Jongkong Hulu',
  },
  {
    id: '6108150002',
    districtId: '6108150',
    name: 'Kerengas',
  },
  {
    id: '6108150003',
    districtId: '6108150',
    name: 'Mensusai',
  },
  {
    id: '6108150004',
    districtId: '6108150',
    name: 'Mantan',
  },
  {
    id: '6108150005',
    districtId: '6108150',
    name: 'Nanga Suhaid',
  },
  {
    id: '6108150006',
    districtId: '6108150',
    name: 'Madang Permai',
  },
  {
    id: '6108150007',
    districtId: '6108150',
    name: 'Tanjung',
  },
  {
    id: '6108150008',
    districtId: '6108150',
    name: 'Laut Tawang',
  },
  {
    id: '6108150010',
    districtId: '6108150',
    name: 'Menapar',
  },
  {
    id: '6108150011',
    districtId: '6108150',
    name: 'Lubuk Pengail',
  },
  {
    id: '6108150012',
    districtId: '6108150',
    name: 'Tanjung Harapan',
  },
  {
    id: '6108160001',
    districtId: '6108160',
    name: 'Ranyai',
  },
  {
    id: '6108160002',
    districtId: '6108160',
    name: 'Sejiram',
  },
  {
    id: '6108160003',
    districtId: '6108160',
    name: 'Beluis Harum',
  },
  {
    id: '6108160005',
    districtId: '6108160',
    name: 'Bati',
  },
  {
    id: '6108160006',
    districtId: '6108160',
    name: 'Seneban',
  },
  {
    id: '6108160007',
    districtId: '6108160',
    name: 'Belikai',
  },
  {
    id: '6108160008',
    districtId: '6108160',
    name: 'Pala Kota',
  },
  {
    id: '6108160009',
    districtId: '6108160',
    name: 'Emperiang',
  },
  {
    id: '6108160010',
    districtId: '6108160',
    name: 'Nanga Lot',
  },
  {
    id: '6108160011',
    districtId: '6108160',
    name: 'Tanjung Keliling',
  },
  {
    id: '6108160012',
    districtId: '6108160',
    name: 'Tajum Mada',
  },
  {
    id: '6108160013',
    districtId: '6108160',
    name: 'Jerenjang',
  },
  {
    id: '6108160014',
    districtId: '6108160',
    name: 'Bekuan',
  },
  {
    id: '6108160015',
    districtId: '6108160',
    name: 'Nanga Pala',
  },
  {
    id: '6108170001',
    districtId: '6108170',
    name: 'Nanga Seberuang',
  },
  {
    id: '6108170002',
    districtId: '6108170',
    name: 'Kenerak',
  },
  {
    id: '6108170003',
    districtId: '6108170',
    name: 'Semitau Hulu',
  },
  {
    id: '6108170004',
    districtId: '6108170',
    name: 'Kenepai Komplek',
  },
  {
    id: '6108170005',
    districtId: '6108170',
    name: 'Entipan',
  },
  {
    id: '6108170006',
    districtId: '6108170',
    name: 'Semitau Hilir',
  },
  {
    id: '6108170007',
    districtId: '6108170',
    name: 'Nanga Kenepai',
  },
  {
    id: '6108170008',
    districtId: '6108170',
    name: 'Tua',
  },
  {
    id: '6108170009',
    districtId: '6108170',
    name: 'Nanga Lemedak',
  },
  {
    id: '6108170010',
    districtId: '6108170',
    name: 'Marsedan Raya',
  },
  {
    id: '6108170011',
    districtId: '6108170',
    name: 'Padung Kumang',
  },
  {
    id: '6108170012',
    districtId: '6108170',
    name: 'Sekedau',
  },
  {
    id: '6108180001',
    districtId: '6108180',
    name: 'Keling Panggau',
  },
  {
    id: '6108180002',
    districtId: '6108180',
    name: 'Bajau Andai',
  },
  {
    id: '6108180003',
    districtId: '6108180',
    name: 'Tintin Peninjau',
  },
  {
    id: '6108180004',
    districtId: '6108180',
    name: 'Nanga Kantuk',
  },
  {
    id: '6108180005',
    districtId: '6108180',
    name: 'Kumang Jaya',
  },
  {
    id: '6108180006',
    districtId: '6108180',
    name: 'Laja Sandang',
  },
  {
    id: '6108190002',
    districtId: '6108190',
    name: 'Sungai Antu',
  },
  {
    id: '6108190003',
    districtId: '6108190',
    name: 'Merakai Panjang',
  },
  {
    id: '6108190004',
    districtId: '6108190',
    name: 'Kantuk Asam',
  },
  {
    id: '6108190005',
    districtId: '6108190',
    name: 'Kantuk Bunut',
  },
  {
    id: '6108190006',
    districtId: '6108190',
    name: 'Sungai Mawang',
  },
  {
    id: '6108190007',
    districtId: '6108190',
    name: 'Langau',
  },
  {
    id: '6108200001',
    districtId: '6108200',
    name: 'Pulau Majang',
  },
  {
    id: '6108200002',
    districtId: '6108200',
    name: 'Kekurak',
  },
  {
    id: '6108200003',
    districtId: '6108200',
    name: 'Semuntik',
  },
  {
    id: '6108200004',
    districtId: '6108200',
    name: 'Janting',
  },
  {
    id: '6108200005',
    districtId: '6108200',
    name: 'Seriang',
  },
  {
    id: '6108200006',
    districtId: '6108200',
    name: 'Badau',
  },
  {
    id: '6108200007',
    districtId: '6108200',
    name: 'Sebindang',
  },
  {
    id: '6108200008',
    districtId: '6108200',
    name: 'Tinting Seligi',
  },
  {
    id: '6108200009',
    districtId: '6108200',
    name: 'Tajum',
  },
  {
    id: '6108210001',
    districtId: '6108210',
    name: 'Setulang',
  },
  {
    id: '6108210002',
    districtId: '6108210',
    name: 'Sepandan',
  },
  {
    id: '6108210003',
    districtId: '6108210',
    name: 'Melemba',
  },
  {
    id: '6108210004',
    districtId: '6108210',
    name: 'Sungai Ajung',
  },
  {
    id: '6108210005',
    districtId: '6108210',
    name: 'Sungai Abau',
  },
  {
    id: '6108210006',
    districtId: '6108210',
    name: 'Labian',
  },
  {
    id: '6108210007',
    districtId: '6108210',
    name: 'Mensiau',
  },
  {
    id: '6108210008',
    districtId: '6108210',
    name: 'Sungai Senunuk',
  },
  {
    id: '6108210009',
    districtId: '6108210',
    name: 'Lanjak Deras',
  },
  {
    id: '6108210010',
    districtId: '6108210',
    name: 'Labian Iraang',
  },
  {
    id: '6108220001',
    districtId: '6108220',
    name: 'Pulau Manak',
  },
  {
    id: '6108220002',
    districtId: '6108220',
    name: 'Benua Martinus',
  },
  {
    id: '6108220003',
    districtId: '6108220',
    name: 'Benua Ujung',
  },
  {
    id: '6108220004',
    districtId: '6108220',
    name: 'Saujung Giling Manik',
  },
  {
    id: '6108220005',
    districtId: '6108220',
    name: 'Ulak Pauk',
  },
  {
    id: '6108220006',
    districtId: '6108220',
    name: 'Rantau Prapat',
  },
  {
    id: '6108220007',
    districtId: '6108220',
    name: 'Langan Baru',
  },
  {
    id: '6108220008',
    districtId: '6108220',
    name: 'Menua Sadap',
  },
  {
    id: '6108220009',
    districtId: '6108220',
    name: 'Batu Lintang',
  },
  {
    id: '6108220010',
    districtId: '6108220',
    name: 'Tamao',
  },
  {
    id: '6108230001',
    districtId: '6108230',
    name: 'Hilir Kantor',
  },
  {
    id: '6108230002',
    districtId: '6108230',
    name: 'Putussibau Kota',
  },
  {
    id: '6108230003',
    districtId: '6108230',
    name: 'Pala Pulau',
  },
  {
    id: '6108230005',
    districtId: '6108230',
    name: 'Sibau Hilir',
  },
  {
    id: '6108230006',
    districtId: '6108230',
    name: 'Padua Mendalam',
  },
  {
    id: '6108230007',
    districtId: '6108230',
    name: 'Datah Dian',
  },
  {
    id: '6108230008',
    districtId: '6108230',
    name: 'Sibau Hulu',
  },
  {
    id: '6108230009',
    districtId: '6108230',
    name: 'Nanga Sambus',
  },
  {
    id: '6108230010',
    districtId: '6108230',
    name: 'Ariung Mandalam',
  },
  {
    id: '6108230011',
    districtId: '6108230',
    name: 'Tanjung Karang',
  },
  {
    id: '6108230012',
    districtId: '6108230',
    name: 'Nanga Awin',
  },
  {
    id: '6108230013',
    districtId: '6108230',
    name: 'Tanjung Beruang',
  },
  {
    id: '6108230014',
    districtId: '6108230',
    name: 'Banua Tengah',
  },
  {
    id: '6108230015',
    districtId: '6108230',
    name: 'Nanga Nyabau',
  },
  {
    id: '6108230016',
    districtId: '6108230',
    name: 'Seluan',
  },
  {
    id: '6108230017',
    districtId: '6108230',
    name: 'Sungai Uluk Palin',
  },
  {
    id: '6108230018',
    districtId: '6108230',
    name: 'Tanjung Lasa',
  },
  {
    id: '6108230019',
    districtId: '6108230',
    name: 'Lauk',
  },
  {
    id: '6108230020',
    districtId: '6108230',
    name: 'Jangkang',
  },
  {
    id: '6109010001',
    districtId: '6109010',
    name: 'Landau Apin',
  },
  {
    id: '6109010002',
    districtId: '6109010',
    name: 'Teluk Kebau',
  },
  {
    id: '6109010003',
    districtId: '6109010',
    name: 'Lembah Beringin',
  },
  {
    id: '6109010004',
    districtId: '6109010',
    name: 'Karang Betung',
  },
  {
    id: '6109010005',
    districtId: '6109010',
    name: 'Sebabas',
  },
  {
    id: '6109010006',
    districtId: '6109010',
    name: 'Nanga Suri',
  },
  {
    id: '6109010007',
    districtId: '6109010',
    name: 'Nanga Mahap',
  },
  {
    id: '6109010008',
    districtId: '6109010',
    name: 'Batu Pahat',
  },
  {
    id: '6109010009',
    districtId: '6109010',
    name: 'Landau Kumpai',
  },
  {
    id: '6109010010',
    districtId: '6109010',
    name: 'Tembaga',
  },
  {
    id: '6109010011',
    districtId: '6109010',
    name: 'Cenayan',
  },
  {
    id: '6109010013',
    districtId: '6109010',
    name: 'Tamang',
  },
  {
    id: '6109020001',
    districtId: '6109020',
    name: 'Nanga Engkulun',
  },
  {
    id: '6109020002',
    districtId: '6109020',
    name: 'Nanga Koman',
  },
  {
    id: '6109020003',
    districtId: '6109020',
    name: 'Nanga Mongko',
  },
  {
    id: '6109020004',
    districtId: '6109020',
    name: 'Lubuk Tajau',
  },
  {
    id: '6109020005',
    districtId: '6109020',
    name: 'Pantok',
  },
  {
    id: '6109020006',
    districtId: '6109020',
    name: 'Meragun',
  },
  {
    id: '6109020007',
    districtId: '6109020',
    name: 'Rirang Jati',
  },
  {
    id: '6109020008',
    districtId: '6109020',
    name: 'Nanga Taman',
  },
  {
    id: '6109020009',
    districtId: '6109020',
    name: 'Senangak',
  },
  {
    id: '6109020010',
    districtId: '6109020',
    name: 'Sungai Lawak',
  },
  {
    id: '6109020011',
    districtId: '6109020',
    name: 'Nanga Kiungkang',
  },
  {
    id: '6109020012',
    districtId: '6109020',
    name: 'Tapang Tingang',
  },
  {
    id: '6109020013',
    districtId: '6109020',
    name: 'Nanga Mentukak',
  },
  {
    id: '6109030001',
    districtId: '6109030',
    name: 'Sekonau',
  },
  {
    id: '6109030002',
    districtId: '6109030',
    name: 'Cupang Gading',
  },
  {
    id: '6109030003',
    districtId: '6109030',
    name: 'Nanga Biaban',
  },
  {
    id: '6109030004',
    districtId: '6109030',
    name: 'Mondi',
  },
  {
    id: '6109030005',
    districtId: '6109030',
    name: 'Tapang Perodah',
  },
  {
    id: '6109030006',
    districtId: '6109030',
    name: 'Sungai Sambang',
  },
  {
    id: '6109030007',
    districtId: '6109030',
    name: 'Rawak Hilir',
  },
  {
    id: '6109030008',
    districtId: '6109030',
    name: 'Rawak Hulu',
  },
  {
    id: '6109030009',
    districtId: '6109030',
    name: 'Tinting Boyok',
  },
  {
    id: '6109030010',
    districtId: '6109030',
    name: 'Perongkan',
  },
  {
    id: '6109030011',
    districtId: '6109030',
    name: 'Nanga Manterap',
  },
  {
    id: '6109030012',
    districtId: '6109030',
    name: 'Boti',
  },
  {
    id: '6109030013',
    districtId: '6109030',
    name: 'Setawar',
  },
  {
    id: '6109030014',
    districtId: '6109030',
    name: 'Nanga Pemubuh',
  },
  {
    id: '6109030015',
    districtId: '6109030',
    name: 'Sunsong',
  },
  {
    id: '6109040001',
    districtId: '6109040',
    name: 'Peniti',
  },
  {
    id: '6109040002',
    districtId: '6109040',
    name: 'Sungai Ringin',
  },
  {
    id: '6109040004',
    districtId: '6109040',
    name: 'Gonis Tekam',
  },
  {
    id: '6109040005',
    districtId: '6109040',
    name: 'Engkersik',
  },
  {
    id: '6109040006',
    districtId: '6109040',
    name: 'Tapang Semadak',
  },
  {
    id: '6109040007',
    districtId: '6109040',
    name: 'Seraras',
  },
  {
    id: '6109040008',
    districtId: '6109040',
    name: 'Merapi',
  },
  {
    id: '6109040009',
    districtId: '6109040',
    name: 'Tanjung',
  },
  {
    id: '6109040010',
    districtId: '6109040',
    name: 'Seberang Kapuas',
  },
  {
    id: '6109040011',
    districtId: '6109040',
    name: 'Sungai Kunyit',
  },
  {
    id: '6109040012',
    districtId: '6109040',
    name: 'Semabi',
  },
  {
    id: '6109040013',
    districtId: '6109040',
    name: 'Landau Kodah',
  },
  {
    id: '6109040014',
    districtId: '6109040',
    name: 'Timpuk',
  },
  {
    id: '6109040015',
    districtId: '6109040',
    name: 'Ensalang',
  },
  {
    id: '6109040016',
    districtId: '6109040',
    name: 'Selalong',
  },
  {
    id: '6109040017',
    districtId: '6109040',
    name: 'Bokak Sebumbun',
  },
  {
    id: '6109050001',
    districtId: '6109050',
    name: 'Sungai Ayak I',
  },
  {
    id: '6109050002',
    districtId: '6109050',
    name: 'Sungai Ayak III',
  },
  {
    id: '6109050003',
    districtId: '6109050',
    name: 'Entabuk',
  },
  {
    id: '6109050004',
    districtId: '6109050',
    name: 'Tapang Pulau',
  },
  {
    id: '6109050005',
    districtId: '6109050',
    name: 'Merbang',
  },
  {
    id: '6109050006',
    districtId: '6109050',
    name: 'Kumpang Bis',
  },
  {
    id: '6109050007',
    districtId: '6109050',
    name: 'Menawai Tekam',
  },
  {
    id: '6109050008',
    districtId: '6109050',
    name: 'Semadu',
  },
  {
    id: '6109050009',
    districtId: '6109050',
    name: 'Empajak',
  },
  {
    id: '6109060001',
    districtId: '6109060',
    name: 'Belitang Satu',
  },
  {
    id: '6109060002',
    districtId: '6109060',
    name: 'Belitang Dua',
  },
  {
    id: '6109060003',
    districtId: '6109060',
    name: 'Padak',
  },
  {
    id: '6109060005',
    districtId: '6109060',
    name: 'Nanga Ansar',
  },
  {
    id: '6109060006',
    districtId: '6109060',
    name: 'Manua Prama',
  },
  {
    id: '6109060007',
    districtId: '6109060',
    name: 'Maboh Permai',
  },
  {
    id: '6109070001',
    districtId: '6109070',
    name: 'Kumpang Ilong',
  },
  {
    id: '6109070002',
    districtId: '6109070',
    name: 'Ijok',
  },
  {
    id: '6109070003',
    districtId: '6109070',
    name: 'Balai Sepuak',
  },
  {
    id: '6109070004',
    districtId: '6109070',
    name: 'Tabuk Hulu',
  },
  {
    id: '6109070005',
    districtId: '6109070',
    name: 'Batuk Mulau',
  },
  {
    id: '6109070006',
    districtId: '6109070',
    name: 'Sei Tapah',
  },
  {
    id: '6109070007',
    districtId: '6109070',
    name: 'Seburuk Satu',
  },
  {
    id: '6109070009',
    districtId: '6109070',
    name: 'Paket Mulau',
  },
  {
    id: '6109070010',
    districtId: '6109070',
    name: 'Mengaret',
  },
  {
    id: '6109070011',
    districtId: '6109070',
    name: 'Terduk Dampak',
  },
  {
    id: '6109070012',
    districtId: '6109070',
    name: 'Sei Antu Hulu',
  },
  {
    id: '6109070013',
    districtId: '6109070',
    name: 'Bukit Rambat',
  },
  {
    id: '6110010001',
    districtId: '6110010',
    name: 'Nanga Ora',
  },
  {
    id: '6110010002',
    districtId: '6110010',
    name: 'Nanga Libas',
  },
  {
    id: '6110010003',
    districtId: '6110010',
    name: 'Gelata',
  },
  {
    id: '6110010004',
    districtId: '6110010',
    name: 'Nanga Betangai',
  },
  {
    id: '6110010005',
    districtId: '6110010',
    name: 'Keluing Taja',
  },
  {
    id: '6110010006',
    districtId: '6110010',
    name: 'Sijau',
  },
  {
    id: '6110010007',
    districtId: '6110010',
    name: 'Tanjung Sokan',
  },
  {
    id: '6110010008',
    districtId: '6110010',
    name: 'Nanga Sokan',
  },
  {
    id: '6110010009',
    districtId: '6110010',
    name: 'Penyengkuang',
  },
  {
    id: '6110010010',
    districtId: '6110010',
    name: 'Nanga Tangkit',
  },
  {
    id: '6110010011',
    districtId: '6110010',
    name: 'Landau Kabu',
  },
  {
    id: '6110010012',
    districtId: '6110010',
    name: 'Melana',
  },
  {
    id: '6110010013',
    districtId: '6110010',
    name: 'Tanjung Mahung',
  },
  {
    id: '6110010014',
    districtId: '6110010',
    name: 'Telaga Raya',
  },
  {
    id: '6110010015',
    districtId: '6110010',
    name: 'Teluk Pongkal',
  },
  {
    id: '6110010016',
    districtId: '6110010',
    name: 'Muara Tanjung',
  },
  {
    id: '6110010017',
    districtId: '6110010',
    name: 'Nanga Potai',
  },
  {
    id: '6110010018',
    districtId: '6110010',
    name: 'Sepakat',
  },
  {
    id: '6110020003',
    districtId: '6110020',
    name: 'Madong Raya',
  },
  {
    id: '6110020004',
    districtId: '6110020',
    name: 'Loka Jaya',
  },
  {
    id: '6110020005',
    districtId: '6110020',
    name: 'Batu Begigi',
  },
  {
    id: '6110020006',
    districtId: '6110020',
    name: 'Bina Karya',
  },
  {
    id: '6110020007',
    districtId: '6110020',
    name: 'Bina Jaya',
  },
  {
    id: '6110020008',
    districtId: '6110020',
    name: 'Suka Maju',
  },
  {
    id: '6110020012',
    districtId: '6110020',
    name: 'Bata Luar',
  },
  {
    id: '6110020013',
    districtId: '6110020',
    name: 'Keranjik',
  },
  {
    id: '6110020014',
    districtId: '6110020',
    name: 'Pelita Kenaya',
  },
  {
    id: '6110020015',
    districtId: '6110020',
    name: 'Maris Permai',
  },
  {
    id: '6110020016',
    districtId: '6110020',
    name: 'Tanjung Beringin Raya',
  },
  {
    id: '6110020017',
    districtId: '6110020',
    name: 'Tanjung Gunung',
  },
  {
    id: '6110021001',
    districtId: '6110021',
    name: 'Togan Baru',
  },
  {
    id: '6110021002',
    districtId: '6110021',
    name: 'Ganjang',
  },
  {
    id: '6110021003',
    districtId: '6110021',
    name: 'Durian Jaya',
  },
  {
    id: '6110021004',
    districtId: '6110021',
    name: 'Pelita Jaya',
  },
  {
    id: '6110021005',
    districtId: '6110021',
    name: 'Bukit Raya',
  },
  {
    id: '6110021006',
    districtId: '6110021',
    name: 'Ulak Muid',
  },
  {
    id: '6110021007',
    districtId: '6110021',
    name: 'Lintah Taum',
  },
  {
    id: '6110021008',
    districtId: '6110021',
    name: 'Laja',
  },
  {
    id: '6110021009',
    districtId: '6110021',
    name: 'Harapan Jaya',
  },
  {
    id: '6110021010',
    districtId: '6110021',
    name: 'Keluas Hulu',
  },
  {
    id: '6110030001',
    districtId: '6110030',
    name: 'Madya Raya',
  },
  {
    id: '6110030002',
    districtId: '6110030',
    name: 'Landau Sadak',
  },
  {
    id: '6110030003',
    districtId: '6110030',
    name: 'Pekawai',
  },
  {
    id: '6110030004',
    districtId: '6110030',
    name: 'Mekar Pelita',
  },
  {
    id: '6110030005',
    districtId: '6110030',
    name: 'Nanga Sayan',
  },
  {
    id: '6110030006',
    districtId: '6110030',
    name: 'Kerangan Purun',
  },
  {
    id: '6110030007',
    districtId: '6110030',
    name: 'Bora',
  },
  {
    id: '6110030008',
    districtId: '6110030',
    name: 'Nanga Kompi',
  },
  {
    id: '6110030009',
    districtId: '6110030',
    name: 'Nanga Mancur',
  },
  {
    id: '6110030010',
    districtId: '6110030',
    name: 'Tumbak Raya',
  },
  {
    id: '6110030011',
    districtId: '6110030',
    name: 'Nanga Raku',
  },
  {
    id: '6110030012',
    districtId: '6110030',
    name: 'Meta Bersatu',
  },
  {
    id: '6110030013',
    districtId: '6110030',
    name: 'Nanga Kasai',
  },
  {
    id: '6110030014',
    districtId: '6110030',
    name: 'Siling Permai',
  },
  {
    id: '6110030015',
    districtId: '6110030',
    name: 'Lingkar Indah',
  },
  {
    id: '6110030016',
    districtId: '6110030',
    name: 'Sayan Jaya',
  },
  {
    id: '6110030017',
    districtId: '6110030',
    name: 'Nanga Pak',
  },
  {
    id: '6110030018',
    districtId: '6110030',
    name: 'Berobai Permai',
  },
  {
    id: '6110040001',
    districtId: '6110040',
    name: 'Balai Agas',
  },
  {
    id: '6110040003',
    districtId: '6110040',
    name: 'Langan',
  },
  {
    id: '6110040006',
    districtId: '6110040',
    name: 'Nusa Kenyikap',
  },
  {
    id: '6110040009',
    districtId: '6110040',
    name: 'Upit',
  },
  {
    id: '6110040010',
    districtId: '6110040',
    name: 'Batu Ampar',
  },
  {
    id: '6110040011',
    districtId: '6110040',
    name: 'Pemuar',
  },
  {
    id: '6110040012',
    districtId: '6110040',
    name: 'Batu Buil',
  },
  {
    id: '6110040015',
    districtId: '6110040',
    name: 'Belonsat',
  },
  {
    id: '6110040016',
    districtId: '6110040',
    name: 'Batu Nanta',
  },
  {
    id: '6110040017',
    districtId: '6110040',
    name: 'Laman Bukit',
  },
  {
    id: '6110040018',
    districtId: '6110040',
    name: 'Nanga Pau',
  },
  {
    id: '6110040019',
    districtId: '6110040',
    name: 'Nanga Entebah',
  },
  {
    id: '6110040020',
    districtId: '6110040',
    name: 'Tekaban',
  },
  {
    id: '6110040021',
    districtId: '6110040',
    name: 'Labang',
  },
  {
    id: '6110040022',
    districtId: '6110040',
    name: 'Nanga Menunuk',
  },
  {
    id: '6110040023',
    districtId: '6110040',
    name: 'Sepan Tonak',
  },
  {
    id: '6110041001',
    districtId: '6110041',
    name: 'Nanga Raya',
  },
  {
    id: '6110041002',
    districtId: '6110041',
    name: 'Kayu Bunga',
  },
  {
    id: '6110041003',
    districtId: '6110041',
    name: 'Nanga Keberak',
  },
  {
    id: '6110041004',
    districtId: '6110041',
    name: 'Piawas',
  },
  {
    id: '6110041005',
    districtId: '6110041',
    name: 'Junjung Permai',
  },
  {
    id: '6110041006',
    districtId: '6110041',
    name: 'Nanga Tikan',
  },
  {
    id: '6110041007',
    districtId: '6110041',
    name: 'Tiong Keranjik',
  },
  {
    id: '6110041008',
    districtId: '6110041',
    name: 'Beloyang',
  },
  {
    id: '6110050008',
    districtId: '6110050',
    name: 'Nanga Kebebu',
  },
  {
    id: '6110050010',
    districtId: '6110050',
    name: 'Poring',
  },
  {
    id: '6110050011',
    districtId: '6110050',
    name: 'Tanjung Sari',
  },
  {
    id: '6110050012',
    districtId: '6110050',
    name: 'Tembawang Panjang',
  },
  {
    id: '6110050013',
    districtId: '6110050',
    name: 'Paal',
  },
  {
    id: '6110050014',
    districtId: '6110050',
    name: 'Tanjung Niaga',
  },
  {
    id: '6110050015',
    districtId: '6110050',
    name: 'Sido Mulyo',
  },
  {
    id: '6110050016',
    districtId: '6110050',
    name: 'B A R U',
  },
  {
    id: '6110050021',
    districtId: '6110050',
    name: 'Nanga Kayan',
  },
  {
    id: '6110050023',
    districtId: '6110050',
    name: 'Nusa Pandau',
  },
  {
    id: '6110050024',
    districtId: '6110050',
    name: 'Tebing Karangan',
  },
  {
    id: '6110050025',
    districtId: '6110050',
    name: 'Kelakik',
  },
  {
    id: '6110050026',
    districtId: '6110050',
    name: 'Semadin Lengkong',
  },
  {
    id: '6110050027',
    districtId: '6110050',
    name: 'Tanjung Lay',
  },
  {
    id: '6110050028',
    districtId: '6110050',
    name: 'Labai Mandiri',
  },
  {
    id: '6110050029',
    districtId: '6110050',
    name: 'Kenual',
  },
  {
    id: '6110050030',
    districtId: '6110050',
    name: 'Tanjung Tengang',
  },
  {
    id: '6110051001',
    districtId: '6110051',
    name: 'Nanga Pintas',
  },
  {
    id: '6110051002',
    districtId: '6110051',
    name: 'Mandau Baru',
  },
  {
    id: '6110051003',
    districtId: '6110051',
    name: 'Nanga Kelawai',
  },
  {
    id: '6110051004',
    districtId: '6110051',
    name: 'Senempak',
  },
  {
    id: '6110051005',
    districtId: '6110051',
    name: 'Landau Garong',
  },
  {
    id: '6110051006',
    districtId: '6110051',
    name: 'Sungai Bakah',
  },
  {
    id: '6110051007',
    districtId: '6110051',
    name: 'Nyanggai',
  },
  {
    id: '6110051008',
    districtId: '6110051',
    name: 'Bayur Raya',
  },
  {
    id: '6110051009',
    districtId: '6110051',
    name: 'Bina Jaya',
  },
  {
    id: '6110051010',
    districtId: '6110051',
    name: 'Pelinggang',
  },
  {
    id: '6110051011',
    districtId: '6110051',
    name: 'Manggala',
  },
  {
    id: '6110051012',
    districtId: '6110051',
    name: 'Landau Tubun',
  },
  {
    id: '6110052001',
    districtId: '6110052',
    name: 'Sungai Pinang',
  },
  {
    id: '6110052002',
    districtId: '6110052',
    name: 'Engkurai',
  },
  {
    id: '6110052003',
    districtId: '6110052',
    name: 'Merpak',
  },
  {
    id: '6110052004',
    districtId: '6110052',
    name: 'Nanga Man',
  },
  {
    id: '6110052005',
    districtId: '6110052',
    name: 'Merah Arai',
  },
  {
    id: '6110052006',
    districtId: '6110052',
    name: 'Tanjung Arak',
  },
  {
    id: '6110052007',
    districtId: '6110052',
    name: 'Tanjung Paoh',
  },
  {
    id: '6110052008',
    districtId: '6110052',
    name: 'Tekelak',
  },
  {
    id: '6110052009',
    districtId: '6110052',
    name: 'Melawi Kiri Hilir',
  },
  {
    id: '6110052010',
    districtId: '6110052',
    name: 'Kompas Raya',
  },
  {
    id: '6110052011',
    districtId: '6110052',
    name: 'Manding',
  },
  {
    id: '6110052012',
    districtId: '6110052',
    name: 'Natai Panjang',
  },
  {
    id: '6110052013',
    districtId: '6110052',
    name: 'Sungai Raya',
  },
  {
    id: '6110052014',
    districtId: '6110052',
    name: 'Nanga Belimbing',
  },
  {
    id: '6110052015',
    districtId: '6110052',
    name: 'Suka Damai',
  },
  {
    id: '6110052016',
    districtId: '6110052',
    name: 'Tengkajau',
  },
  {
    id: '6110052017',
    districtId: '6110052',
    name: 'Senibung',
  },
  {
    id: '6110052018',
    districtId: '6110052',
    name: 'Melamut Bersatu',
  },
  {
    id: '6110052019',
    districtId: '6110052',
    name: 'Kayan Semapau',
  },
  {
    id: '6110060002',
    districtId: '6110060',
    name: 'Kerangan Kora',
  },
  {
    id: '6110060003',
    districtId: '6110060',
    name: 'Nanga Kempangai',
  },
  {
    id: '6110060004',
    districtId: '6110060',
    name: 'Nanga Nyuruh',
  },
  {
    id: '6110060005',
    districtId: '6110060',
    name: 'Nanga Kalan',
  },
  {
    id: '6110060006',
    districtId: '6110060',
    name: 'Nanga Ella Hilir',
  },
  {
    id: '6110060007',
    districtId: '6110060',
    name: 'Nanga Nuak',
  },
  {
    id: '6110060008',
    districtId: '6110060',
    name: 'Lengkong Nyadom',
  },
  {
    id: '6110060009',
    districtId: '6110060',
    name: 'Jabai',
  },
  {
    id: '6110060010',
    districtId: '6110060',
    name: 'Sungai Labuk',
  },
  {
    id: '6110060011',
    districtId: '6110060',
    name: 'Perembang Nyuruh',
  },
  {
    id: '6110060012',
    districtId: '6110060',
    name: 'Kahiya',
  },
  {
    id: '6110060013',
    districtId: '6110060',
    name: 'Bemban Permai',
  },
  {
    id: '6110060014',
    districtId: '6110060',
    name: 'Pelempai Jaya',
  },
  {
    id: '6110060015',
    districtId: '6110060',
    name: 'Popai',
  },
  {
    id: '6110060016',
    districtId: '6110060',
    name: 'Domet Permai',
  },
  {
    id: '6110060017',
    districtId: '6110060',
    name: 'Nyanggau',
  },
  {
    id: '6110060018',
    districtId: '6110060',
    name: 'Sungai Mentoba',
  },
  {
    id: '6110060019',
    districtId: '6110060',
    name: 'Natai Compa',
  },
  {
    id: '6110070001',
    districtId: '6110070',
    name: 'Nanga Siyai',
  },
  {
    id: '6110070002',
    districtId: '6110070',
    name: 'Laman Mumbung',
  },
  {
    id: '6110070003',
    districtId: '6110070',
    name: 'Mawang Mentatai',
  },
  {
    id: '6110070004',
    districtId: '6110070',
    name: 'Melona',
  },
  {
    id: '6110070005',
    districtId: '6110070',
    name: 'Menukung Kota',
  },
  {
    id: '6110070006',
    districtId: '6110070',
    name: 'Nanga Ella Hulu',
  },
  {
    id: '6110070007',
    districtId: '6110070',
    name: 'Tanjung Beringin',
  },
  {
    id: '6110070008',
    districtId: '6110070',
    name: 'Landau Leban',
  },
  {
    id: '6110070009',
    districtId: '6110070',
    name: 'Sungai Sampuk',
  },
  {
    id: '6110070010',
    districtId: '6110070',
    name: 'Belaban Ella',
  },
  {
    id: '6110070011',
    districtId: '6110070',
    name: 'Sungai Sampak',
  },
  {
    id: '6110070012',
    districtId: '6110070',
    name: 'Nusa Poring',
  },
  {
    id: '6110070013',
    districtId: '6110070',
    name: 'Batu Onap',
  },
  {
    id: '6110070014',
    districtId: '6110070',
    name: 'Batu Badak',
  },
  {
    id: '6110070015',
    districtId: '6110070',
    name: 'Lihai',
  },
  {
    id: '6110070016',
    districtId: '6110070',
    name: 'Nanga Keruab',
  },
  {
    id: '6110070017',
    districtId: '6110070',
    name: 'Pelaik Keruab',
  },
  {
    id: '6110070018',
    districtId: '6110070',
    name: 'Oyah',
  },
  {
    id: '6110070019',
    districtId: '6110070',
    name: 'Batas Nangka',
  },
  {
    id: '6111010002',
    districtId: '6111010',
    name: 'Dusun Besar',
  },
  {
    id: '6111010003',
    districtId: '6111010',
    name: 'Tanjung Satai',
  },
  {
    id: '6111010004',
    districtId: '6111010',
    name: 'Dusun Kecil',
  },
  {
    id: '6111010005',
    districtId: '6111010',
    name: 'Kemboja',
  },
  {
    id: '6111010006',
    districtId: '6111010',
    name: 'Satai Lestari',
  },
  {
    id: '6111011001',
    districtId: '6111011',
    name: 'Betok Jaya',
  },
  {
    id: '6111011002',
    districtId: '6111011',
    name: 'Padang',
  },
  {
    id: '6111011003',
    districtId: '6111011',
    name: 'Pelapis',
  },
  {
    id: '6111020001',
    districtId: '6111020',
    name: 'Simpang Tiga',
  },
  {
    id: '6111020002',
    districtId: '6111020',
    name: 'Sejahtera',
  },
  {
    id: '6111020003',
    districtId: '6111020',
    name: 'Pangkalan Buton',
  },
  {
    id: '6111020004',
    districtId: '6111020',
    name: 'Sutra',
  },
  {
    id: '6111020005',
    districtId: '6111020',
    name: 'Benawai Agung',
  },
  {
    id: '6111020006',
    districtId: '6111020',
    name: 'Harapan Mulia',
  },
  {
    id: '6111020007',
    districtId: '6111020',
    name: 'Sedahan Jaya',
  },
  {
    id: '6111020008',
    districtId: '6111020',
    name: 'Gunung Sembilan',
  },
  {
    id: '6111020009',
    districtId: '6111020',
    name: 'Pampang Harapan',
  },
  {
    id: '6111020010',
    districtId: '6111020',
    name: 'Riam Berasapjaya',
  },
  {
    id: '6111030001',
    districtId: '6111030',
    name: 'Padu Banjar',
  },
  {
    id: '6111030002',
    districtId: '6111030',
    name: 'Pulau Kumbang',
  },
  {
    id: '6111030003',
    districtId: '6111030',
    name: 'Pemangkat',
  },
  {
    id: '6111030004',
    districtId: '6111030',
    name: 'Nipah Kuning',
  },
  {
    id: '6111030005',
    districtId: '6111030',
    name: 'Rantau Panjang',
  },
  {
    id: '6111030006',
    districtId: '6111030',
    name: 'Penjalaan',
  },
  {
    id: '6111030007',
    districtId: '6111030',
    name: 'Teluk Melanau',
  },
  {
    id: '6111030008',
    districtId: '6111030',
    name: 'Sungai Mata-Mata',
  },
  {
    id: '6111030009',
    districtId: '6111030',
    name: 'Batu Barat',
  },
  {
    id: '6111030010',
    districtId: '6111030',
    name: 'Matan Jaya',
  },
  {
    id: '6111030011',
    districtId: '6111030',
    name: 'Lubuk Batu',
  },
  {
    id: '6111030012',
    districtId: '6111030',
    name: 'Medan Jaya',
  },
  {
    id: '6111040001',
    districtId: '6111040',
    name: 'Sungai Paduan',
  },
  {
    id: '6111040002',
    districtId: '6111040',
    name: 'Alur Bandung',
  },
  {
    id: '6111040003',
    districtId: '6111040',
    name: 'Teluk Batang',
  },
  {
    id: '6111040004',
    districtId: '6111040',
    name: 'Mas Bangun',
  },
  {
    id: '6111040005',
    districtId: '6111040',
    name: 'Banyu Abang',
  },
  {
    id: '6111040006',
    districtId: '6111040',
    name: 'Teluk Batang Utara',
  },
  {
    id: '6111040007',
    districtId: '6111040',
    name: 'Teluk Batang Selatan',
  },
  {
    id: '6111050001',
    districtId: '6111050',
    name: 'Podo Rukun',
  },
  {
    id: '6111050002',
    districtId: '6111050',
    name: 'Wonorejo',
  },
  {
    id: '6111050003',
    districtId: '6111050',
    name: 'Seponti Jaya',
  },
  {
    id: '6111050004',
    districtId: '6111050',
    name: 'Telaga Arum',
  },
  {
    id: '6111050005',
    districtId: '6111050',
    name: 'Sungai Sepeti',
  },
  {
    id: '6111050006',
    districtId: '6111050',
    name: 'Durian Sebatang',
  },
  {
    id: '6112010001',
    districtId: '6112010',
    name: 'Tanjung Harapan',
  },
  {
    id: '6112010002',
    districtId: '6112010',
    name: 'Ambarawa',
  },
  {
    id: '6112010003',
    districtId: '6112010',
    name: 'Sungai Jawi',
  },
  {
    id: '6112010004',
    districtId: '6112010',
    name: 'Sungai Besar',
  },
  {
    id: '6112010005',
    districtId: '6112010',
    name: 'Tasik Malaya',
  },
  {
    id: '6112010006',
    districtId: '6112010',
    name: 'Padang Tikar I',
  },
  {
    id: '6112010007',
    districtId: '6112010',
    name: 'Padang Tikar II',
  },
  {
    id: '6112010008',
    districtId: '6112010',
    name: 'Nipah Panjang',
  },
  {
    id: '6112010009',
    districtId: '6112010',
    name: 'Teluk Nibung',
  },
  {
    id: '6112010010',
    districtId: '6112010',
    name: 'Batu Ampar',
  },
  {
    id: '6112010011',
    districtId: '6112010',
    name: 'UPT Sei Kerawang',
  },
  {
    id: '6112010012',
    districtId: '6112010',
    name: 'Sumber Agung',
  },
  {
    id: '6112010013',
    districtId: '6112010',
    name: 'Muara Tiga',
  },
  {
    id: '6112010014',
    districtId: '6112010',
    name: 'Tanjung Beringin',
  },
  {
    id: '6112010015',
    districtId: '6112010',
    name: 'Medan Mas',
  },
  {
    id: '6112020001',
    districtId: '6112020',
    name: 'Sungai Dungun',
  },
  {
    id: '6112020002',
    districtId: '6112020',
    name: 'Terentang Hulu',
  },
  {
    id: '6112020003',
    districtId: '6112020',
    name: 'Teluk Bayur',
  },
  {
    id: '6112020004',
    districtId: '6112020',
    name: 'Teluk Empening',
  },
  {
    id: '6112020005',
    districtId: '6112020',
    name: 'Terentang Hilir',
  },
  {
    id: '6112020006',
    districtId: '6112020',
    name: 'Sungai Radak I',
  },
  {
    id: '6112020007',
    districtId: '6112020',
    name: 'Sungai Radak II',
  },
  {
    id: '6112020008',
    districtId: '6112020',
    name: 'Permata',
  },
  {
    id: '6112020009',
    districtId: '6112020',
    name: 'Betuah',
  },
  {
    id: '6112020010',
    districtId: '6112020',
    name: 'Radak Baru',
  },
  {
    id: '6112030001',
    districtId: '6112030',
    name: 'Dabung',
  },
  {
    id: '6112030003',
    districtId: '6112030',
    name: 'Sungai Terus',
  },
  {
    id: '6112030004',
    districtId: '6112030',
    name: 'Teluk Nangka',
  },
  {
    id: '6112030005',
    districtId: '6112030',
    name: 'Jangkang I',
  },
  {
    id: '6112030006',
    districtId: '6112030',
    name: 'Jangkang II',
  },
  {
    id: '6112030007',
    districtId: '6112030',
    name: 'Pinang Dalam',
  },
  {
    id: '6112030008',
    districtId: '6112030',
    name: 'Kampung Baru',
  },
  {
    id: '6112030009',
    districtId: '6112030',
    name: 'Olak Olak Kubu',
  },
  {
    id: '6112030010',
    districtId: '6112030',
    name: 'Pelita Jaya',
  },
  {
    id: '6112030011',
    districtId: '6112030',
    name: 'Seruat III',
  },
  {
    id: '6112030012',
    districtId: '6112030',
    name: 'Seruat II',
  },
  {
    id: '6112030013',
    districtId: '6112030',
    name: 'Sungai Selamat',
  },
  {
    id: '6112030014',
    districtId: '6112030',
    name: 'Ambawang',
  },
  {
    id: '6112030015',
    districtId: '6112030',
    name: 'Air Putih',
  },
  {
    id: '6112030016',
    districtId: '6112030',
    name: 'Pinang Luar',
  },
  {
    id: '6112030017',
    districtId: '6112030',
    name: 'Sei Bemban',
  },
  {
    id: '6112030018',
    districtId: '6112030',
    name: 'Sepakat Baru',
  },
  {
    id: '6112030019',
    districtId: '6112030',
    name: 'Mengkalang',
  },
  {
    id: '6112030020',
    districtId: '6112030',
    name: 'Mengkalang Jambu',
  },
  {
    id: '6112040001',
    districtId: '6112040',
    name: 'Sei Nibung',
  },
  {
    id: '6112040002',
    districtId: '6112040',
    name: 'Seruat I',
  },
  {
    id: '6112040003',
    districtId: '6112040',
    name: 'Kuala Karang',
  },
  {
    id: '6112040004',
    districtId: '6112040',
    name: 'Tanjung Bunga',
  },
  {
    id: '6112040005',
    districtId: '6112040',
    name: 'Teluk Gelam',
  },
  {
    id: '6112040006',
    districtId: '6112040',
    name: 'Selat Remis',
  },
  {
    id: '6112040007',
    districtId: '6112040',
    name: 'Teluk Pakedai Hulu',
  },
  {
    id: '6112040008',
    districtId: '6112040',
    name: 'Teluk Pakedai II',
  },
  {
    id: '6112040009',
    districtId: '6112040',
    name: 'Teluk Pakedai I',
  },
  {
    id: '6112040010',
    districtId: '6112040',
    name: 'Pasir Putih',
  },
  {
    id: '6112040011',
    districtId: '6112040',
    name: 'Madura',
  },
  {
    id: '6112040012',
    districtId: '6112040',
    name: 'Sei Deras',
  },
  {
    id: '6112040013',
    districtId: '6112040',
    name: 'Arus Deras',
  },
  {
    id: '6112040014',
    districtId: '6112040',
    name: 'Sungai Nipah',
  },
  {
    id: '6112050001',
    districtId: '6112050',
    name: 'Sepuk Laut',
  },
  {
    id: '6112050002',
    districtId: '6112050',
    name: 'Punggur Besar',
  },
  {
    id: '6112050003',
    districtId: '6112050',
    name: 'Punggur Kecil',
  },
  {
    id: '6112050004',
    districtId: '6112050',
    name: 'Kalimas',
  },
  {
    id: '6112050005',
    districtId: '6112050',
    name: 'Tanjung Saleh',
  },
  {
    id: '6112050006',
    districtId: '6112050',
    name: 'Sungai Belidak',
  },
  {
    id: '6112050007',
    districtId: '6112050',
    name: 'Sungai Kakap',
  },
  {
    id: '6112050008',
    districtId: '6112050',
    name: 'Sungai Itik',
  },
  {
    id: '6112050009',
    districtId: '6112050',
    name: 'Pal.IX',
  },
  {
    id: '6112050010',
    districtId: '6112050',
    name: 'Sungai Rengas',
  },
  {
    id: '6112050011',
    districtId: '6112050',
    name: 'Jeruju Besar',
  },
  {
    id: '6112050012',
    districtId: '6112050',
    name: 'Sungai Kupah',
  },
  {
    id: '6112050013',
    districtId: '6112050',
    name: 'Punggur Kapuas',
  },
  {
    id: '6112060001',
    districtId: '6112060',
    name: 'Rasau Jaya Umum',
  },
  {
    id: '6112060002',
    districtId: '6112060',
    name: 'Bintang  Mas',
  },
  {
    id: '6112060003',
    districtId: '6112060',
    name: 'Rasau Jaya III',
  },
  {
    id: '6112060004',
    districtId: '6112060',
    name: 'Rasau Jaya I',
  },
  {
    id: '6112060005',
    districtId: '6112060',
    name: 'Rasau Jaya II',
  },
  {
    id: '6112060006',
    districtId: '6112060',
    name: 'Pematang Tujuh',
  },
  {
    id: '6112070001',
    districtId: '6112070',
    name: 'Sungai Raya',
  },
  {
    id: '6112070002',
    districtId: '6112070',
    name: 'Kapur',
  },
  {
    id: '6112070003',
    districtId: '6112070',
    name: 'Arang Limbung',
  },
  {
    id: '6112070004',
    districtId: '6112070',
    name: 'Kuala Dua',
  },
  {
    id: '6112070005',
    districtId: '6112070',
    name: 'Sungai Ambangah',
  },
  {
    id: '6112070006',
    districtId: '6112070',
    name: 'Tebang Kacang',
  },
  {
    id: '6112070007',
    districtId: '6112070',
    name: 'Sungai Bulan',
  },
  {
    id: '6112070008',
    districtId: '6112070',
    name: 'Sungai Asam',
  },
  {
    id: '6112070009',
    districtId: '6112070',
    name: 'Pulau Limbung',
  },
  {
    id: '6112070010',
    districtId: '6112070',
    name: 'Gunung Tamang',
  },
  {
    id: '6112070011',
    districtId: '6112070',
    name: 'Limbung',
  },
  {
    id: '6112070012',
    districtId: '6112070',
    name: 'Teluk Kapuas',
  },
  {
    id: '6112070013',
    districtId: '6112070',
    name: 'Madu Sari',
  },
  {
    id: '6112070014',
    districtId: '6112070',
    name: 'Mekar Sari',
  },
  {
    id: '6112070015',
    districtId: '6112070',
    name: 'Mekar Baru',
  },
  {
    id: '6112070016',
    districtId: '6112070',
    name: 'Sungai Raya Dalam',
  },
  {
    id: '6112070017',
    districtId: '6112070',
    name: 'Parit Baru',
  },
  {
    id: '6112070018',
    districtId: '6112070',
    name: 'Pulau Jambu',
  },
  {
    id: '6112070019',
    districtId: '6112070',
    name: 'Kali Bandung',
  },
  {
    id: '6112070020',
    districtId: '6112070',
    name: 'Muara Baru',
  },
  {
    id: '6112080001',
    districtId: '6112080',
    name: 'Durian',
  },
  {
    id: '6112080002',
    districtId: '6112080',
    name: 'Simpang Kanan',
  },
  {
    id: '6112080004',
    districtId: '6112080',
    name: 'Bengkarek',
  },
  {
    id: '6112080005',
    districtId: '6112080',
    name: 'Pasak Piang',
  },
  {
    id: '6112080006',
    districtId: '6112080',
    name: 'Pasak',
  },
  {
    id: '6112080007',
    districtId: '6112080',
    name: 'Panca Roba',
  },
  {
    id: '6112080008',
    districtId: '6112080',
    name: 'Lingga',
  },
  {
    id: '6112080009',
    districtId: '6112080',
    name: 'Korek',
  },
  {
    id: '6112080010',
    districtId: '6112080',
    name: 'Jawa Tengah',
  },
  {
    id: '6112080011',
    districtId: '6112080',
    name: 'Ambawang Kuala',
  },
  {
    id: '6112080012',
    districtId: '6112080',
    name: 'Mega Timur',
  },
  {
    id: '6112080013',
    districtId: '6112080',
    name: 'Teluk Bakung',
  },
  {
    id: '6112080014',
    districtId: '6112080',
    name: 'Ampera Raya',
  },
  {
    id: '6112080015',
    districtId: '6112080',
    name: 'Sungai Malaya',
  },
  {
    id: '6112090001',
    districtId: '6112090',
    name: 'Kuala Mandor A',
  },
  {
    id: '6112090002',
    districtId: '6112090',
    name: 'Kuala Mandor-B',
  },
  {
    id: '6112090003',
    districtId: '6112090',
    name: 'Sungai Enau',
  },
  {
    id: '6112090004',
    districtId: '6112090',
    name: 'Kubu Padi',
  },
  {
    id: '6112090005',
    districtId: '6112090',
    name: 'Retok',
  },
  {
    id: '6171010002',
    districtId: '6171010',
    name: 'Benua Melayu Laut',
  },
  {
    id: '6171010003',
    districtId: '6171010',
    name: 'Benua Melayu Darat',
  },
  {
    id: '6171010004',
    districtId: '6171010',
    name: 'Parit Tokaya',
  },
  {
    id: '6171010005',
    districtId: '6171010',
    name: 'Akcaya',
  },
  {
    id: '6171010006',
    districtId: '6171010',
    name: 'Kota Baru',
  },
  {
    id: '6171011001',
    districtId: '6171011',
    name: 'Bangka Belitung Laut',
  },
  {
    id: '6171011002',
    districtId: '6171011',
    name: 'Bangka Belitung Darat',
  },
  {
    id: '6171011003',
    districtId: '6171011',
    name: 'Bansir Laut',
  },
  {
    id: '6171011004',
    districtId: '6171011',
    name: 'Bansir Darat',
  },
  {
    id: '6171020001',
    districtId: '6171020',
    name: 'Parit Mayor',
  },
  {
    id: '6171020002',
    districtId: '6171020',
    name: 'Banjar Serasan',
  },
  {
    id: '6171020003',
    districtId: '6171020',
    name: 'Saigon',
  },
  {
    id: '6171020004',
    districtId: '6171020',
    name: 'Tanjung Hulu',
  },
  {
    id: '6171020005',
    districtId: '6171020',
    name: 'Tanjung Hilir',
  },
  {
    id: '6171020006',
    districtId: '6171020',
    name: 'Dalam Bugis',
  },
  {
    id: '6171020007',
    districtId: '6171020',
    name: 'Tambelan Sampit',
  },
  {
    id: '6171030001',
    districtId: '6171030',
    name: 'Pal Lima',
  },
  {
    id: '6171030006',
    districtId: '6171030',
    name: 'Sungai Jawi Dalam',
  },
  {
    id: '6171030007',
    districtId: '6171030',
    name: 'Sungai Jawi Luar',
  },
  {
    id: '6171030008',
    districtId: '6171030',
    name: 'Sungai Beliung',
  },
  {
    id: '6171031001',
    districtId: '6171031',
    name: 'Sungai Bangkong',
  },
  {
    id: '6171031002',
    districtId: '6171031',
    name: 'Darat Sekip',
  },
  {
    id: '6171031003',
    districtId: '6171031',
    name: 'Tengah',
  },
  {
    id: '6171031004',
    districtId: '6171031',
    name: 'Mariana',
  },
  {
    id: '6171031005',
    districtId: '6171031',
    name: 'Sungai Jawi',
  },
  {
    id: '6171040001',
    districtId: '6171040',
    name: 'Batu Layang',
  },
  {
    id: '6171040002',
    districtId: '6171040',
    name: 'Siantan Hilir',
  },
  {
    id: '6171040003',
    districtId: '6171040',
    name: 'Siantan Tengah',
  },
  {
    id: '6171040004',
    districtId: '6171040',
    name: 'Siantan Hulu',
  },
  {
    id: '6172010001',
    districtId: '6172010',
    name: 'Sedau',
  },
  {
    id: '6172010002',
    districtId: '6172010',
    name: 'Sijangkung',
  },
  {
    id: '6172010003',
    districtId: '6172010',
    name: 'Pangmilang',
  },
  {
    id: '6172010004',
    districtId: '6172010',
    name: 'Sagatani',
  },
  {
    id: '6172020001',
    districtId: '6172020',
    name: 'Pajintan',
  },
  {
    id: '6172020002',
    districtId: '6172020',
    name: 'Sanggau Kulor',
  },
  {
    id: '6172020003',
    districtId: '6172020',
    name: 'Bagak Sahwa',
  },
  {
    id: '6172020004',
    districtId: '6172020',
    name: 'Nyarungkop',
  },
  {
    id: '6172020005',
    districtId: '6172020',
    name: 'Mayasopa',
  },
  {
    id: '6172030001',
    districtId: '6172030',
    name: 'Sei Garam Hilir',
  },
  {
    id: '6172030002',
    districtId: '6172030',
    name: 'Naram',
  },
  {
    id: '6172030003',
    districtId: '6172030',
    name: 'Sei Bulan',
  },
  {
    id: '6172030004',
    districtId: '6172030',
    name: 'Sei Rasau',
  },
  {
    id: '6172030005',
    districtId: '6172030',
    name: 'Setapuk Kecil',
  },
  {
    id: '6172030006',
    districtId: '6172030',
    name: 'Setapuk Besar',
  },
  {
    id: '6172030007',
    districtId: '6172030',
    name: 'Semelagi Kecil',
  },
  {
    id: '6172040001',
    districtId: '6172040',
    name: 'Pasiran',
  },
  {
    id: '6172040002',
    districtId: '6172040',
    name: 'Melayu',
  },
  {
    id: '6172040003',
    districtId: '6172040',
    name: 'Tengah',
  },
  {
    id: '6172040004',
    districtId: '6172040',
    name: 'Kuala',
  },
  {
    id: '6172050001',
    districtId: '6172050',
    name: 'Roban',
  },
  {
    id: '6172050002',
    districtId: '6172050',
    name: 'Condong',
  },
  {
    id: '6172050003',
    districtId: '6172050',
    name: 'Sekip Lama',
  },
  {
    id: '6172050004',
    districtId: '6172050',
    name: 'Jawa',
  },
  {
    id: '6172050005',
    districtId: '6172050',
    name: 'Bukit Batu',
  },
  {
    id: '6172050006',
    districtId: '6172050',
    name: 'Sei Wie',
  },
  {
    id: '6201040001',
    districtId: '6201040',
    name: 'Babual Baboti',
  },
  {
    id: '6201040002',
    districtId: '6201040',
    name: 'Tempayung',
  },
  {
    id: '6201040003',
    districtId: '6201040',
    name: 'Sakabulin',
  },
  {
    id: '6201040004',
    districtId: '6201040',
    name: 'Kinjil',
  },
  {
    id: '6201040005',
    districtId: '6201040',
    name: 'Kota Waringin Hilir',
  },
  {
    id: '6201040006',
    districtId: '6201040',
    name: 'Riam Durian',
  },
  {
    id: '6201040007',
    districtId: '6201040',
    name: 'Dawak',
  },
  {
    id: '6201040008',
    districtId: '6201040',
    name: 'Kotawaringin Hulu',
  },
  {
    id: '6201040009',
    districtId: '6201040',
    name: 'Lalang',
  },
  {
    id: '6201040011',
    districtId: '6201040',
    name: 'Kondang',
  },
  {
    id: '6201040012',
    districtId: '6201040',
    name: 'Sukamulya',
  },
  {
    id: '6201040013',
    districtId: '6201040',
    name: 'Sukajaya',
  },
  {
    id: '6201040015',
    districtId: '6201040',
    name: 'Suka Makmur',
  },
  {
    id: '6201040018',
    districtId: '6201040',
    name: 'Ipuh Bangun Jaya',
  },
  {
    id: '6201040019',
    districtId: '6201040',
    name: 'Sumber Mukti',
  },
  {
    id: '6201040020',
    districtId: '6201040',
    name: 'Palih Baru',
  },
  {
    id: '6201050001',
    districtId: '6201050',
    name: 'Tanjung Putri',
  },
  {
    id: '6201050002',
    districtId: '6201050',
    name: 'Kumpai Batu Bawah',
  },
  {
    id: '6201050003',
    districtId: '6201050',
    name: 'Kumpai Batu Atas',
  },
  {
    id: '6201050004',
    districtId: '6201050',
    name: 'Pasir Panjang',
  },
  {
    id: '6201050005',
    districtId: '6201050',
    name: 'Mendawai',
  },
  {
    id: '6201050006',
    districtId: '6201050',
    name: 'Mendawai Seberang',
  },
  {
    id: '6201050007',
    districtId: '6201050',
    name: 'Raja',
  },
  {
    id: '6201050008',
    districtId: '6201050',
    name: 'Sidorejo',
  },
  {
    id: '6201050009',
    districtId: '6201050',
    name: 'Madurejo',
  },
  {
    id: '6201050010',
    districtId: '6201050',
    name: 'Baru',
  },
  {
    id: '6201050011',
    districtId: '6201050',
    name: 'Raja Seberang',
  },
  {
    id: '6201050012',
    districtId: '6201050',
    name: 'Rangda',
  },
  {
    id: '6201050013',
    districtId: '6201050',
    name: 'Kenambui',
  },
  {
    id: '6201050015',
    districtId: '6201050',
    name: 'Umpang',
  },
  {
    id: '6201050016',
    districtId: '6201050',
    name: 'Natai Raya',
  },
  {
    id: '6201050017',
    districtId: '6201050',
    name: 'Medangsari',
  },
  {
    id: '6201050018',
    districtId: '6201050',
    name: 'Natai Baru',
  },
  {
    id: '6201050019',
    districtId: '6201050',
    name: 'Tanjung Terantang',
  },
  {
    id: '6201060001',
    districtId: '6201060',
    name: 'Sungai Cabang',
  },
  {
    id: '6201060002',
    districtId: '6201060',
    name: 'Teluk Pulai',
  },
  {
    id: '6201060003',
    districtId: '6201060',
    name: 'Sungai Sekonyer',
  },
  {
    id: '6201060005',
    districtId: '6201060',
    name: 'Sungai Bakau',
  },
  {
    id: '6201060006',
    districtId: '6201060',
    name: 'Teluk Bogam',
  },
  {
    id: '6201060007',
    districtId: '6201060',
    name: 'Keraya',
  },
  {
    id: '6201060008',
    districtId: '6201060',
    name: 'Sebuai',
  },
  {
    id: '6201060009',
    districtId: '6201060',
    name: 'Sungai Kapitan',
  },
  {
    id: '6201060010',
    districtId: '6201060',
    name: 'Kumai Hilir',
  },
  {
    id: '6201060011',
    districtId: '6201060',
    name: 'Batu Belaman',
  },
  {
    id: '6201060012',
    districtId: '6201060',
    name: 'Sungai Tendang',
  },
  {
    id: '6201060013',
    districtId: '6201060',
    name: 'Candi',
  },
  {
    id: '6201060014',
    districtId: '6201060',
    name: 'Kumai Hulu',
  },
  {
    id: '6201060015',
    districtId: '6201060',
    name: 'Sungai Bedaun',
  },
  {
    id: '6201060016',
    districtId: '6201060',
    name: 'Sabuai Timur',
  },
  {
    id: '6201060031',
    districtId: '6201060',
    name: 'Bumi Harjo',
  },
  {
    id: '6201060032',
    districtId: '6201060',
    name: 'Pangkalan Satu',
  },
  {
    id: '6201061001',
    districtId: '6201061',
    name: 'Pangkalan Banteng',
  },
  {
    id: '6201061002',
    districtId: '6201061',
    name: 'Mulya Jadi',
  },
  {
    id: '6201061003',
    districtId: '6201061',
    name: 'Amin Jaya',
  },
  {
    id: '6201061004',
    districtId: '6201061',
    name: 'Natai Kerbau',
  },
  {
    id: '6201061005',
    districtId: '6201061',
    name: 'Karangmulya',
  },
  {
    id: '6201061006',
    districtId: '6201061',
    name: 'Marga Mulya',
  },
  {
    id: '6201061007',
    districtId: '6201061',
    name: 'Arga Mulya',
  },
  {
    id: '6201061008',
    districtId: '6201061',
    name: 'Kebun Agung',
  },
  {
    id: '6201061009',
    districtId: '6201061',
    name: 'Sido Mulyo',
  },
  {
    id: '6201061010',
    districtId: '6201061',
    name: 'Simpang Berambai',
  },
  {
    id: '6201061011',
    districtId: '6201061',
    name: 'Sungai Hijau',
  },
  {
    id: '6201061012',
    districtId: '6201061',
    name: 'Sungai Bengkuang',
  },
  {
    id: '6201061013',
    districtId: '6201061',
    name: 'Sungai Kuning',
  },
  {
    id: '6201061014',
    districtId: '6201061',
    name: 'Sungai Pakit',
  },
  {
    id: '6201061015',
    districtId: '6201061',
    name: 'Berambai Makmur',
  },
  {
    id: '6201061016',
    districtId: '6201061',
    name: 'Karang Sari',
  },
  {
    id: '6201061017',
    districtId: '6201061',
    name: 'Sungai Pulau',
  },
  {
    id: '6201062001',
    districtId: '6201062',
    name: 'Purbasari',
  },
  {
    id: '6201062002',
    districtId: '6201062',
    name: 'Sungai Rangit Jaya',
  },
  {
    id: '6201062003',
    districtId: '6201062',
    name: 'Sumber Agung',
  },
  {
    id: '6201062004',
    districtId: '6201062',
    name: 'Lada Mandala Jaya',
  },
  {
    id: '6201062005',
    districtId: '6201062',
    name: 'Makarti Jaya',
  },
  {
    id: '6201062006',
    districtId: '6201062',
    name: 'Pandu Senjaya',
  },
  {
    id: '6201062007',
    districtId: '6201062',
    name: 'Pangkalan Tiga',
  },
  {
    id: '6201062008',
    districtId: '6201062',
    name: 'Kadipi Atas',
  },
  {
    id: '6201062009',
    districtId: '6201062',
    name: 'Pangkalan Dewa',
  },
  {
    id: '6201062010',
    districtId: '6201062',
    name: 'Pangkalan Durin',
  },
  {
    id: '6201062011',
    districtId: '6201062',
    name: 'Sungai Melawen',
  },
  {
    id: '6201070001',
    districtId: '6201070',
    name: 'Nanga Mua',
  },
  {
    id: '6201070002',
    districtId: '6201070',
    name: 'Pangkut',
  },
  {
    id: '6201070003',
    districtId: '6201070',
    name: 'Sukarami',
  },
  {
    id: '6201070004',
    districtId: '6201070',
    name: 'Gandis',
  },
  {
    id: '6201070005',
    districtId: '6201070',
    name: 'Kerabu',
  },
  {
    id: '6201070006',
    districtId: '6201070',
    name: 'Sambi',
  },
  {
    id: '6201070007',
    districtId: '6201070',
    name: 'Penyombaan',
  },
  {
    id: '6201070008',
    districtId: '6201070',
    name: 'Pandau',
  },
  {
    id: '6201070009',
    districtId: '6201070',
    name: 'Riam',
  },
  {
    id: '6201070010',
    districtId: '6201070',
    name: 'Penahan',
  },
  {
    id: '6201070011',
    districtId: '6201070',
    name: 'Sungai Dau',
  },
  {
    id: '6202020005',
    districtId: '6202020',
    name: 'Sabamban',
  },
  {
    id: '6202020006',
    districtId: '6202020',
    name: 'Samuda Besar',
  },
  {
    id: '6202020007',
    districtId: '6202020',
    name: 'Samuda Kecil',
  },
  {
    id: '6202020008',
    districtId: '6202020',
    name: 'Samuda Kota',
  },
  {
    id: '6202020009',
    districtId: '6202020',
    name: 'Basirih Hilir',
  },
  {
    id: '6202020010',
    districtId: '6202020',
    name: 'Jaya Kelapa',
  },
  {
    id: '6202020011',
    districtId: '6202020',
    name: 'Basirih Hulu',
  },
  {
    id: '6202020012',
    districtId: '6202020',
    name: 'Jaya Karet',
  },
  {
    id: '6202020013',
    districtId: '6202020',
    name: 'Sei Ijum Raya',
  },
  {
    id: '6202020014',
    districtId: '6202020',
    name: 'Handil Sohor',
  },
  {
    id: '6202021001',
    districtId: '6202021',
    name: 'Ujung Pandaran',
  },
  {
    id: '6202021002',
    districtId: '6202021',
    name: 'Lampuyang',
  },
  {
    id: '6202021003',
    districtId: '6202021',
    name: 'Basawang',
  },
  {
    id: '6202021004',
    districtId: '6202021',
    name: 'Parebok',
  },
  {
    id: '6202021005',
    districtId: '6202021',
    name: 'Kuin Permai',
  },
  {
    id: '6202021006',
    districtId: '6202021',
    name: 'Regei Lestari',
  },
  {
    id: '6202050001',
    districtId: '6202050',
    name: 'Satiruk',
  },
  {
    id: '6202050002',
    districtId: '6202050',
    name: 'Bapinang Hilir Laut',
  },
  {
    id: '6202050003',
    districtId: '6202050',
    name: 'Bapinang Hilir',
  },
  {
    id: '6202050004',
    districtId: '6202050',
    name: 'Bapinang Hulu',
  },
  {
    id: '6202050005',
    districtId: '6202050',
    name: 'Makarti Jaya',
  },
  {
    id: '6202050006',
    districtId: '6202050',
    name: 'Rawa Sari',
  },
  {
    id: '6202050007',
    districtId: '6202050',
    name: 'Babirah',
  },
  {
    id: '6202050008',
    districtId: '6202050',
    name: 'Hanaut',
  },
  {
    id: '6202050009',
    districtId: '6202050',
    name: 'Serambut',
  },
  {
    id: '6202050010',
    districtId: '6202050',
    name: 'Babaung',
  },
  {
    id: '6202050011',
    districtId: '6202050',
    name: 'Bantian',
  },
  {
    id: '6202050012',
    districtId: '6202050',
    name: 'Hantipan',
  },
  {
    id: '6202050013',
    districtId: '6202050',
    name: 'Penyaguan',
  },
  {
    id: '6202050014',
    districtId: '6202050',
    name: 'Bamadu',
  },
  {
    id: '6202060001',
    districtId: '6202060',
    name: 'Pelangsian',
  },
  {
    id: '6202060003',
    districtId: '6202060',
    name: 'Ketapang',
  },
  {
    id: '6202060004',
    districtId: '6202060',
    name: 'Mentawa Baru Hilir',
  },
  {
    id: '6202060005',
    districtId: '6202060',
    name: 'Mentawa Baru Hulu',
  },
  {
    id: '6202060006',
    districtId: '6202060',
    name: 'Sawahan',
  },
  {
    id: '6202060007',
    districtId: '6202060',
    name: 'Bapeang',
  },
  {
    id: '6202060008',
    districtId: '6202060',
    name: 'Eka Bahurui',
  },
  {
    id: '6202060009',
    districtId: '6202060',
    name: 'Pasir Putih',
  },
  {
    id: '6202060010',
    districtId: '6202060',
    name: 'Telaga Baru',
  },
  {
    id: '6202060011',
    districtId: '6202060',
    name: 'Bengkuang Makmur',
  },
  {
    id: '6202060012',
    districtId: '6202060',
    name: 'Bapanggang Raya',
  },
  {
    id: '6202061001',
    districtId: '6202061',
    name: 'Mentaya Seberang',
  },
  {
    id: '6202061002',
    districtId: '6202061',
    name: 'Batuah',
  },
  {
    id: '6202061003',
    districtId: '6202061',
    name: 'Terantang Hilir',
  },
  {
    id: '6202061004',
    districtId: '6202061',
    name: 'Terantang',
  },
  {
    id: '6202061005',
    districtId: '6202061',
    name: 'Ganepo',
  },
  {
    id: '6202061006',
    districtId: '6202061',
    name: 'Seragam Jaya',
  },
  {
    id: '6202070001',
    districtId: '6202070',
    name: 'Pondok Damar',
  },
  {
    id: '6202070002',
    districtId: '6202070',
    name: 'Natai Baru',
  },
  {
    id: '6202070003',
    districtId: '6202070',
    name: 'Bagendang Tengah',
  },
  {
    id: '6202070004',
    districtId: '6202070',
    name: 'Bagendang Hilir',
  },
  {
    id: '6202070005',
    districtId: '6202070',
    name: 'Bagendang Hulu',
  },
  {
    id: '6202070006',
    districtId: '6202070',
    name: 'Sumber Makmur',
  },
  {
    id: '6202070007',
    districtId: '6202070',
    name: 'Bagendang Hilir Permai',
  },
  {
    id: '6202110005',
    districtId: '6202110',
    name: 'Palangan',
  },
  {
    id: '6202110006',
    districtId: '6202110',
    name: 'Hanjalipan',
  },
  {
    id: '6202110007',
    districtId: '6202110',
    name: 'Simpur',
  },
  {
    id: '6202110008',
    districtId: '6202110',
    name: 'Pamalian',
  },
  {
    id: '6202110009',
    districtId: '6202110',
    name: 'Camba',
  },
  {
    id: '6202110010',
    districtId: '6202110',
    name: 'Kandan',
  },
  {
    id: '6202110011',
    districtId: '6202110',
    name: 'Kota Besi Hulu',
  },
  {
    id: '6202110012',
    districtId: '6202110',
    name: 'Kota Besi Hilir',
  },
  {
    id: '6202110014',
    districtId: '6202110',
    name: 'Bajarum',
  },
  {
    id: '6202110015',
    districtId: '6202110',
    name: 'Rasau Tumbuh',
  },
  {
    id: '6202110016',
    districtId: '6202110',
    name: 'Soren',
  },
  {
    id: '6202111001',
    districtId: '6202111',
    name: 'Sebabi',
  },
  {
    id: '6202111002',
    districtId: '6202111',
    name: 'Tanah Putih',
  },
  {
    id: '6202111003',
    districtId: '6202111',
    name: 'Sumber Makmur',
  },
  {
    id: '6202111004',
    districtId: '6202111',
    name: 'Kenyala',
  },
  {
    id: '6202111005',
    districtId: '6202111',
    name: 'Biru Maju',
  },
  {
    id: '6202111006',
    districtId: '6202111',
    name: 'Penyang',
  },
  {
    id: '6202120001',
    districtId: '6202120',
    name: 'Baamang Hilir',
  },
  {
    id: '6202120002',
    districtId: '6202120',
    name: 'Baamang Tengah',
  },
  {
    id: '6202120003',
    districtId: '6202120',
    name: 'Baamang Hulu',
  },
  {
    id: '6202120006',
    districtId: '6202120',
    name: 'Tinduk',
  },
  {
    id: '6202120007',
    districtId: '6202120',
    name: 'Baamang Barat',
  },
  {
    id: '6202120008',
    districtId: '6202120',
    name: 'Tanah Mas',
  },
  {
    id: '6202190002',
    districtId: '6202190',
    name: 'Sungai Paring',
  },
  {
    id: '6202190003',
    districtId: '6202190',
    name: 'Cempaka Mulia Barat',
  },
  {
    id: '6202190004',
    districtId: '6202190',
    name: 'Cempaka Mulia Timur',
  },
  {
    id: '6202190005',
    districtId: '6202190',
    name: 'Jemaras',
  },
  {
    id: '6202190006',
    districtId: '6202190',
    name: 'Lubuk Ranggan',
  },
  {
    id: '6202190007',
    districtId: '6202190',
    name: 'Patai',
  },
  {
    id: '6202191001',
    districtId: '6202191',
    name: 'Parit',
  },
  {
    id: '6202191002',
    districtId: '6202191',
    name: 'Pelantaran',
  },
  {
    id: '6202191003',
    districtId: '6202191',
    name: 'Keruing',
  },
  {
    id: '6202191004',
    districtId: '6202191',
    name: 'Pantai Harapan',
  },
  {
    id: '6202191006',
    districtId: '6202191',
    name: 'Tumbang Koling',
  },
  {
    id: '6202191007',
    districtId: '6202191',
    name: 'Sudan',
  },
  {
    id: '6202191008',
    districtId: '6202191',
    name: 'Bukit Batu',
  },
  {
    id: '6202191009',
    districtId: '6202191',
    name: 'Bukit Raya',
  },
  {
    id: '6202191010',
    districtId: '6202191',
    name: 'Sungai Ubar Mandiri',
  },
  {
    id: '6202191011',
    districtId: '6202191',
    name: 'Selucing',
  },
  {
    id: '6202200001',
    districtId: '6202200',
    name: 'Tehang',
  },
  {
    id: '6202200002',
    districtId: '6202200',
    name: 'Kabuau',
  },
  {
    id: '6202200003',
    districtId: '6202200',
    name: 'Parenggean',
  },
  {
    id: '6202200004',
    districtId: '6202200',
    name: 'Sari Harapan',
  },
  {
    id: '6202200005',
    districtId: '6202200',
    name: 'Mekar Jaya',
  },
  {
    id: '6202200006',
    districtId: '6202200',
    name: 'Karang Tunggal',
  },
  {
    id: '6202200007',
    districtId: '6202200',
    name: 'Karang Sari',
  },
  {
    id: '6202200008',
    districtId: '6202200',
    name: 'Sumber Makmur',
  },
  {
    id: '6202200009',
    districtId: '6202200',
    name: 'Bandar Agung',
  },
  {
    id: '6202200010',
    districtId: '6202200',
    name: 'Baringin Tunggal Jaya',
  },
  {
    id: '6202200011',
    districtId: '6202200',
    name: 'Barunang Miri',
  },
  {
    id: '6202200021',
    districtId: '6202200',
    name: 'Bajarau',
  },
  {
    id: '6202200024',
    districtId: '6202200',
    name: 'Bukit Harapan',
  },
  {
    id: '6202200025',
    districtId: '6202200',
    name: 'Menjalin',
  },
  {
    id: '6202200026',
    districtId: '6202200',
    name: 'Karya Bersama',
  },
  {
    id: '6202201001',
    districtId: '6202201',
    name: 'Jati Waringin',
  },
  {
    id: '6202201002',
    districtId: '6202201',
    name: 'Cempaka Putih',
  },
  {
    id: '6202201004',
    districtId: '6202201',
    name: 'Tumbang Mujam',
  },
  {
    id: '6202201005',
    districtId: '6202201',
    name: 'Bukit Makmur',
  },
  {
    id: '6202201006',
    districtId: '6202201',
    name: 'Wonosari',
  },
  {
    id: '6202201007',
    districtId: '6202201',
    name: 'Merah',
  },
  {
    id: '6202201008',
    districtId: '6202201',
    name: 'Damar Makmur',
  },
  {
    id: '6202201009',
    districtId: '6202201',
    name: 'Mekar Sari',
  },
  {
    id: '6202201010',
    districtId: '6202201',
    name: 'Luwuk Sampun',
  },
  {
    id: '6202201011',
    districtId: '6202201',
    name: 'Tanjung Jorong',
  },
  {
    id: '6202210001',
    districtId: '6202210',
    name: 'Tangar',
  },
  {
    id: '6202210002',
    districtId: '6202210',
    name: 'Baampah',
  },
  {
    id: '6202210003',
    districtId: '6202210',
    name: 'Kawan Batu',
  },
  {
    id: '6202210004',
    districtId: '6202210',
    name: 'Tanjung Batur',
  },
  {
    id: '6202210005',
    districtId: '6202210',
    name: 'Penda Durian',
  },
  {
    id: '6202210006',
    districtId: '6202210',
    name: 'Pahirangan',
  },
  {
    id: '6202210007',
    districtId: '6202210',
    name: 'Sationg',
  },
  {
    id: '6202210008',
    districtId: '6202210',
    name: 'Santilik',
  },
  {
    id: '6202210009',
    districtId: '6202210',
    name: 'Tangka Robah',
  },
  {
    id: '6202210010',
    districtId: '6202210',
    name: 'Pemantang',
  },
  {
    id: '6202210011',
    districtId: '6202210',
    name: 'Tumbang Sapiri',
  },
  {
    id: '6202210012',
    districtId: '6202210',
    name: 'Kuala Kuayan',
  },
  {
    id: '6202210014',
    districtId: '6202210',
    name: 'Bawan',
  },
  {
    id: '6202210015',
    districtId: '6202210',
    name: 'Tanjung Jariangau',
  },
  {
    id: '6202210031',
    districtId: '6202210',
    name: 'Kapuk',
  },
  {
    id: '6202210032',
    districtId: '6202210',
    name: 'Pantap',
  },
  {
    id: '6202211001',
    districtId: '6202211',
    name: 'Tumbang Tilap',
  },
  {
    id: '6202211002',
    districtId: '6202211',
    name: 'Tumbang Kaminting',
  },
  {
    id: '6202211003',
    districtId: '6202211',
    name: 'Tanah Haluan',
  },
  {
    id: '6202211004',
    districtId: '6202211',
    name: 'Tumbang Penyahuan',
  },
  {
    id: '6202211005',
    districtId: '6202211',
    name: 'Tumbang Sapia',
  },
  {
    id: '6202211006',
    districtId: '6202211',
    name: 'Tumbang Getas',
  },
  {
    id: '6202211007',
    districtId: '6202211',
    name: 'Tumbang Turung',
  },
  {
    id: '6202211008',
    districtId: '6202211',
    name: 'Tumbang Batu',
  },
  {
    id: '6202211009',
    districtId: '6202211',
    name: 'Lunuk Bagantung',
  },
  {
    id: '6202211010',
    districtId: '6202211',
    name: 'Tumbang Tawan',
  },
  {
    id: '6202211011',
    districtId: '6202211',
    name: 'Tumbang Saluang',
  },
  {
    id: '6202211012',
    districtId: '6202211',
    name: 'Tewei Hara',
  },
  {
    id: '6202211013',
    districtId: '6202211',
    name: 'Tumbang Payang',
  },
  {
    id: '6202211014',
    districtId: '6202211',
    name: 'Tumbang Kania',
  },
  {
    id: '6202230013',
    districtId: '6202230',
    name: 'Tumbang Sepayang',
  },
  {
    id: '6202230014',
    districtId: '6202230',
    name: 'Gunung Makmur',
  },
  {
    id: '6202230015',
    districtId: '6202230',
    name: 'Sungai Hanya',
  },
  {
    id: '6202230017',
    districtId: '6202230',
    name: 'Mulya Agung',
  },
  {
    id: '6202230018',
    districtId: '6202230',
    name: 'Bhakti Karya',
  },
  {
    id: '6202230019',
    districtId: '6202230',
    name: 'Waringin Agung',
  },
  {
    id: '6202230020',
    districtId: '6202230',
    name: 'Tumbang Kalang',
  },
  {
    id: '6202230021',
    districtId: '6202230',
    name: 'Tumbang Manya',
  },
  {
    id: '6202230025',
    districtId: '6202230',
    name: 'Kuluk Telawang',
  },
  {
    id: '6202230026',
    districtId: '6202230',
    name: 'Sungai Puring',
  },
  {
    id: '6202230027',
    districtId: '6202230',
    name: 'Tumbang Ngahan',
  },
  {
    id: '6202230028',
    districtId: '6202230',
    name: 'Tumbang Ramei',
  },
  {
    id: '6202230029',
    districtId: '6202230',
    name: 'Tumbang Hejan',
  },
  {
    id: '6202230030',
    districtId: '6202230',
    name: 'Buntut Nusa',
  },
  {
    id: '6202230031',
    districtId: '6202230',
    name: 'Tumbang Gagu',
  },
  {
    id: '6202231001',
    districtId: '6202231',
    name: 'Tukang Langit',
  },
  {
    id: '6202231002',
    districtId: '6202231',
    name: 'Buana Mustika',
  },
  {
    id: '6202231003',
    districtId: '6202231',
    name: 'Tanjung Harapan',
  },
  {
    id: '6202231004',
    districtId: '6202231',
    name: 'Tumbang Sangai',
  },
  {
    id: '6202231005',
    districtId: '6202231',
    name: 'Beringin Agung',
  },
  {
    id: '6202231006',
    districtId: '6202231',
    name: 'Rantau Katang',
  },
  {
    id: '6202231007',
    districtId: '6202231',
    name: 'Tumbang Mangkup',
  },
  {
    id: '6202231008',
    districtId: '6202231',
    name: 'Agung Mulya',
  },
  {
    id: '6202231009',
    districtId: '6202231',
    name: 'Rantau Tampang',
  },
  {
    id: '6202231010',
    districtId: '6202231',
    name: 'Luwuk Kuwan',
  },
  {
    id: '6202231011',
    districtId: '6202231',
    name: 'Batu Agung',
  },
  {
    id: '6202231012',
    districtId: '6202231',
    name: 'Tumbang Bajanei',
  },
  {
    id: '6202231013',
    districtId: '6202231',
    name: 'Tumbang Boloi',
  },
  {
    id: '6202231014',
    districtId: '6202231',
    name: 'Tri Buana',
  },
  {
    id: '6202231015',
    districtId: '6202231',
    name: 'Bukit Indah',
  },
  {
    id: '6202231016',
    districtId: '6202231',
    name: 'Tumbang Puan',
  },
  {
    id: '6202231017',
    districtId: '6202231',
    name: 'Rantau Sawang',
  },
  {
    id: '6202231018',
    districtId: '6202231',
    name: 'Rantau Suang',
  },
  {
    id: '6203020001',
    districtId: '6203020',
    name: 'Batanjung',
  },
  {
    id: '6203020002',
    districtId: '6203020',
    name: 'Cemara Labat',
  },
  {
    id: '6203020003',
    districtId: '6203020',
    name: 'Palampai',
  },
  {
    id: '6203020004',
    districtId: '6203020',
    name: 'Sungai Teras',
  },
  {
    id: '6203020005',
    districtId: '6203020',
    name: 'Lupak Dalam',
  },
  {
    id: '6203020006',
    districtId: '6203020',
    name: 'Tamban Baru Selatan',
  },
  {
    id: '6203020011',
    districtId: '6203020',
    name: 'Tamban Lupak',
  },
  {
    id: '6203020012',
    districtId: '6203020',
    name: 'Simpang Bunga Tanjung',
  },
  {
    id: '6203020013',
    districtId: '6203020',
    name: 'Baranggau',
  },
  {
    id: '6203020014',
    districtId: '6203020',
    name: 'Lupak Timur',
  },
  {
    id: '6203020015',
    districtId: '6203020',
    name: 'Pematang',
  },
  {
    id: '6203020016',
    districtId: '6203020',
    name: 'Wargo Mulyo',
  },
  {
    id: '6203020017',
    districtId: '6203020',
    name: 'Sei Bakut',
  },
  {
    id: '6203021001',
    districtId: '6203021',
    name: 'Bandar Raya',
  },
  {
    id: '6203021002',
    districtId: '6203021',
    name: 'Tamban Baru Mekar',
  },
  {
    id: '6203021003',
    districtId: '6203021',
    name: 'Tamban Baru Timur',
  },
  {
    id: '6203021004',
    districtId: '6203021',
    name: 'Tamban Baru Tengah',
  },
  {
    id: '6203021005',
    districtId: '6203021',
    name: 'Sidorejo',
  },
  {
    id: '6203021006',
    districtId: '6203021',
    name: 'Warna Sari',
  },
  {
    id: '6203021007',
    districtId: '6203021',
    name: 'Sido Mulyo',
  },
  {
    id: '6203021008',
    districtId: '6203021',
    name: 'Bandar Mekar',
  },
  {
    id: '6203021009',
    districtId: '6203021',
    name: 'Tamban Makmur',
  },
  {
    id: '6203021010',
    districtId: '6203021',
    name: 'Tamban Jaya',
  },
  {
    id: '6203030001',
    districtId: '6203030',
    name: 'Anjir Serapat Timur',
  },
  {
    id: '6203030002',
    districtId: '6203030',
    name: 'Anjir Serapat Tengah',
  },
  {
    id: '6203030003',
    districtId: '6203030',
    name: 'Anjir Serapat Barat',
  },
  {
    id: '6203030004',
    districtId: '6203030',
    name: 'Anjir Serapat Baru',
  },
  {
    id: '6203030005',
    districtId: '6203030',
    name: 'Anjir Mambulau Timur',
  },
  {
    id: '6203030006',
    districtId: '6203030',
    name: 'Anjir Mambulau Tengah',
  },
  {
    id: '6203030007',
    districtId: '6203030',
    name: 'Anjir Mambulau Barat',
  },
  {
    id: '6203040010',
    districtId: '6203040',
    name: 'Murung Keramat',
  },
  {
    id: '6203040011',
    districtId: '6203040',
    name: 'Selat Hilir',
  },
  {
    id: '6203040012',
    districtId: '6203040',
    name: 'Selat Tengah',
  },
  {
    id: '6203040013',
    districtId: '6203040',
    name: 'Selat Hulu',
  },
  {
    id: '6203040014',
    districtId: '6203040',
    name: 'Selat Dalam',
  },
  {
    id: '6203040015',
    districtId: '6203040',
    name: 'Pulau Telo',
  },
  {
    id: '6203040016',
    districtId: '6203040',
    name: 'Panamas',
  },
  {
    id: '6203040017',
    districtId: '6203040',
    name: 'Selat Barat',
  },
  {
    id: '6203040018',
    districtId: '6203040',
    name: 'Selat Utara',
  },
  {
    id: '6203040019',
    districtId: '6203040',
    name: 'Pulau Telo Baru',
  },
  {
    id: '6203041001',
    districtId: '6203041',
    name: 'Terusan Raya Hulu',
  },
  {
    id: '6203041002',
    districtId: '6203041',
    name: 'Terusan Mulya',
  },
  {
    id: '6203041003',
    districtId: '6203041',
    name: 'Terusan Karya',
  },
  {
    id: '6203041004',
    districtId: '6203041',
    name: 'Terusan Makmur',
  },
  {
    id: '6203041005',
    districtId: '6203041',
    name: 'Terusan Raya Barat',
  },
  {
    id: '6203041006',
    districtId: '6203041',
    name: 'Terusan Baguntan Raya',
  },
  {
    id: '6203041007',
    districtId: '6203041',
    name: 'Terusan Raya',
  },
  {
    id: '6203041008',
    districtId: '6203041',
    name: 'Bamban Raya',
  },
  {
    id: '6203041009',
    districtId: '6203041',
    name: 'Sei Jangkit',
  },
  {
    id: '6203041010',
    districtId: '6203041',
    name: 'Tamban Luar',
  },
  {
    id: '6203041011',
    districtId: '6203041',
    name: 'Bangun Harjo',
  },
  {
    id: '6203041012',
    districtId: '6203041',
    name: 'Pulau Kupang',
  },
  {
    id: '6203041013',
    districtId: '6203041',
    name: 'Sei Lunuk',
  },
  {
    id: '6203041014',
    districtId: '6203041',
    name: 'Pulau Mambulau',
  },
  {
    id: '6203041015',
    districtId: '6203041',
    name: 'Budi Mufakat',
  },
  {
    id: '6203070001',
    districtId: '6203070',
    name: 'Pangkalan Rekan',
  },
  {
    id: '6203070002',
    districtId: '6203070',
    name: 'Basarang',
  },
  {
    id: '6203070003',
    districtId: '6203070',
    name: 'Maluen',
  },
  {
    id: '6203070004',
    districtId: '6203070',
    name: 'Basungkai',
  },
  {
    id: '6203070005',
    districtId: '6203070',
    name: 'Lunuk Ramba',
  },
  {
    id: '6203070006',
    districtId: '6203070',
    name: 'Batuah',
  },
  {
    id: '6203070007',
    districtId: '6203070',
    name: 'Tambun Raya',
  },
  {
    id: '6203070008',
    districtId: '6203070',
    name: 'Pangkalan Sari',
  },
  {
    id: '6203070009',
    districtId: '6203070',
    name: 'Bungai Jaya',
  },
  {
    id: '6203070010',
    districtId: '6203070',
    name: 'Basarang Jaya',
  },
  {
    id: '6203070011',
    districtId: '6203070',
    name: 'Panarung',
  },
  {
    id: '6203070012',
    districtId: '6203070',
    name: 'Tarung Manuah',
  },
  {
    id: '6203070013',
    districtId: '6203070',
    name: 'Batu Nindan',
  },
  {
    id: '6203070014',
    districtId: '6203070',
    name: 'Naning',
  },
  {
    id: '6203080001',
    districtId: '6203080',
    name: 'Mambulau',
  },
  {
    id: '6203080002',
    districtId: '6203080',
    name: 'Hampatung',
  },
  {
    id: '6203080003',
    districtId: '6203080',
    name: 'Dahirang',
  },
  {
    id: '6203080004',
    districtId: '6203080',
    name: 'Barimba',
  },
  {
    id: '6203080005',
    districtId: '6203080',
    name: 'Sei Pasah',
  },
  {
    id: '6203080006',
    districtId: '6203080',
    name: 'Bakungin',
  },
  {
    id: '6203080007',
    districtId: '6203080',
    name: 'Sei Asam',
  },
  {
    id: '6203080008',
    districtId: '6203080',
    name: 'Saka Batur',
  },
  {
    id: '6203090001',
    districtId: '6203090',
    name: 'Teluk Palinget',
  },
  {
    id: '6203090002',
    districtId: '6203090',
    name: 'Sakalagun',
  },
  {
    id: '6203090003',
    districtId: '6203090',
    name: 'Narahan',
  },
  {
    id: '6203090004',
    districtId: '6203090',
    name: 'Bunga Mawar',
  },
  {
    id: '6203090005',
    districtId: '6203090',
    name: 'Palangkai',
  },
  {
    id: '6203090006',
    districtId: '6203090',
    name: 'Sei Tatas',
  },
  {
    id: '6203090007',
    districtId: '6203090',
    name: 'Handiwung',
  },
  {
    id: '6203090008',
    districtId: '6203090',
    name: 'Anjir Palambang',
  },
  {
    id: '6203090009',
    districtId: '6203090',
    name: 'Sei Tatas Hilir',
  },
  {
    id: '6203090010',
    districtId: '6203090',
    name: 'Mawar Mekar',
  },
  {
    id: '6203090011',
    districtId: '6203090',
    name: 'Narahan Baru',
  },
  {
    id: '6203090012',
    districtId: '6203090',
    name: 'Banama',
  },
  {
    id: '6203100001',
    districtId: '6203100',
    name: 'Palingkau Baru',
  },
  {
    id: '6203100002',
    districtId: '6203100',
    name: 'Palingkau Jaya',
  },
  {
    id: '6203100003',
    districtId: '6203100',
    name: 'Palingkau Lama',
  },
  {
    id: '6203100004',
    districtId: '6203100',
    name: 'Palingkau Asri',
  },
  {
    id: '6203100005',
    districtId: '6203100',
    name: 'Palingkau Sejahtera',
  },
  {
    id: '6203100006',
    districtId: '6203100',
    name: 'Tajepan',
  },
  {
    id: '6203100007',
    districtId: '6203100',
    name: 'Mampai',
  },
  {
    id: '6203100008',
    districtId: '6203100',
    name: 'Muara Dadahup',
  },
  {
    id: '6203100014',
    districtId: '6203100',
    name: 'Saka Binjai',
  },
  {
    id: '6203100024',
    districtId: '6203100',
    name: 'Bumi Rahayu',
  },
  {
    id: '6203100025',
    districtId: '6203100',
    name: 'Manggala Permai',
  },
  {
    id: '6203100026',
    districtId: '6203100',
    name: 'Belawang',
  },
  {
    id: '6203100027',
    districtId: '6203100',
    name: 'Suka Reja',
  },
  {
    id: '6203100028',
    districtId: '6203100',
    name: 'Suka Mukti',
  },
  {
    id: '6203100029',
    districtId: '6203100',
    name: 'Palangkau Lama',
  },
  {
    id: '6203100030',
    districtId: '6203100',
    name: 'Bina Sejahtera',
  },
  {
    id: '6203100031',
    districtId: '6203100',
    name: 'Palangkau Baru',
  },
  {
    id: '6203100032',
    districtId: '6203100',
    name: 'Bina Karya',
  },
  {
    id: '6203100033',
    districtId: '6203100',
    name: 'Bina Mekar',
  },
  {
    id: '6203100034',
    districtId: '6203100',
    name: 'Rawa Subur',
  },
  {
    id: '6203100035',
    districtId: '6203100',
    name: 'Sumber Mulya',
  },
  {
    id: '6203100036',
    districtId: '6203100',
    name: 'Karya Bersama',
  },
  {
    id: '6203100037',
    districtId: '6203100',
    name: 'Talekung Punai',
  },
  {
    id: '6203101001',
    districtId: '6203101',
    name: 'Menteng Karya',
  },
  {
    id: '6203101002',
    districtId: '6203101',
    name: 'Dadahup Raya',
  },
  {
    id: '6203101003',
    districtId: '6203101',
    name: 'Sumber Alaska',
  },
  {
    id: '6203101004',
    districtId: '6203101',
    name: 'UPT Dadahup F2',
  },
  {
    id: '6203101005',
    districtId: '6203101',
    name: 'UPT Dadahup F5',
  },
  {
    id: '6203101006',
    districtId: '6203101',
    name: 'Dadahup',
  },
  {
    id: '6203101007',
    districtId: '6203101',
    name: 'Petak Batuah',
  },
  {
    id: '6203101008',
    districtId: '6203101',
    name: 'Harapan Baru',
  },
  {
    id: '6203101009',
    districtId: '6203101',
    name: 'Bentuk Jaya',
  },
  {
    id: '6203101010',
    districtId: '6203101',
    name: 'Bina Jaya',
  },
  {
    id: '6203101011',
    districtId: '6203101',
    name: 'Manuntung',
  },
  {
    id: '6203101012',
    districtId: '6203101',
    name: 'Sumber Agung',
  },
  {
    id: '6203101013',
    districtId: '6203101',
    name: 'Tanjung Harapan',
  },
  {
    id: '6203101014',
    districtId: '6203101',
    name: 'Kahuripan Permai',
  },
  {
    id: '6203101015',
    districtId: '6203101',
    name: 'Tambak Bajai',
  },
  {
    id: '6203110001',
    districtId: '6203110',
    name: 'Sei Kayu',
  },
  {
    id: '6203110002',
    districtId: '6203110',
    name: 'Saka Mangkahai',
  },
  {
    id: '6203110003',
    districtId: '6203110',
    name: 'Mandomai',
  },
  {
    id: '6203110004',
    districtId: '6203110',
    name: 'Anjir Kalampan',
  },
  {
    id: '6203110005',
    districtId: '6203110',
    name: 'Pantai',
  },
  {
    id: '6203110006',
    districtId: '6203110',
    name: 'Saka Tamiang',
  },
  {
    id: '6203110007',
    districtId: '6203110',
    name: 'Penda Ketapi',
  },
  {
    id: '6203110008',
    districtId: '6203110',
    name: 'Teluk Hiri',
  },
  {
    id: '6203110009',
    districtId: '6203110',
    name: 'Sei Dusun',
  },
  {
    id: '6203110010',
    districtId: '6203110',
    name: 'Basuta Raya',
  },
  {
    id: '6203110011',
    districtId: '6203110',
    name: 'Sei Pitung',
  },
  {
    id: '6203110012',
    districtId: '6203110',
    name: 'Maju Bersama',
  },
  {
    id: '6203150001',
    districtId: '6203150',
    name: 'Manusup',
  },
  {
    id: '6203150002',
    districtId: '6203150',
    name: 'Lamunti Permai',
  },
  {
    id: '6203150003',
    districtId: '6203150',
    name: 'Harapan Jaya',
  },
  {
    id: '6203150004',
    districtId: '6203150',
    name: 'Sari Makmur',
  },
  {
    id: '6203150005',
    districtId: '6203150',
    name: 'Sei Kapar',
  },
  {
    id: '6203150006',
    districtId: '6203150',
    name: 'Tarantang',
  },
  {
    id: '6203150007',
    districtId: '6203150',
    name: 'Lamunti',
  },
  {
    id: '6203150008',
    districtId: '6203150',
    name: 'Manyahi',
  },
  {
    id: '6203150009',
    districtId: '6203150',
    name: 'Warga Mulya',
  },
  {
    id: '6203150010',
    districtId: '6203150',
    name: 'Sekata Bangun',
  },
  {
    id: '6203150011',
    districtId: '6203150',
    name: 'Suka Maju',
  },
  {
    id: '6203150013',
    districtId: '6203150',
    name: 'Pulau Kaladan',
  },
  {
    id: '6203150014',
    districtId: '6203150',
    name: 'Sekata Makmur',
  },
  {
    id: '6203150015',
    districtId: '6203150',
    name: 'Kaladan Jaya',
  },
  {
    id: '6203150016',
    districtId: '6203150',
    name: 'Lamunti Baru',
  },
  {
    id: '6203150017',
    districtId: '6203150',
    name: 'Sriwidadi',
  },
  {
    id: '6203150018',
    districtId: '6203150',
    name: 'Sumber Makmur',
  },
  {
    id: '6203150019',
    districtId: '6203150',
    name: 'Mantangai Hilir',
  },
  {
    id: '6203150020',
    districtId: '6203150',
    name: 'Rantau Jaya',
  },
  {
    id: '6203150021',
    districtId: '6203150',
    name: 'Sidomulyo',
  },
  {
    id: '6203150022',
    districtId: '6203150',
    name: 'Mantangai Tengah',
  },
  {
    id: '6203150023',
    districtId: '6203150',
    name: 'Mantangai Hulu',
  },
  {
    id: '6203150024',
    districtId: '6203150',
    name: 'Kalumpang',
  },
  {
    id: '6203150025',
    districtId: '6203150',
    name: 'Sei Ahas',
  },
  {
    id: '6203150026',
    districtId: '6203150',
    name: 'Katunjung',
  },
  {
    id: '6203150027',
    districtId: '6203150',
    name: 'Lahei Mangkutup',
  },
  {
    id: '6203150028',
    districtId: '6203150',
    name: 'Tumbang Muroi',
  },
  {
    id: '6203150029',
    districtId: '6203150',
    name: 'Danau Rawah',
  },
  {
    id: '6203150030',
    districtId: '6203150',
    name: 'Katimpun',
  },
  {
    id: '6203150031',
    districtId: '6203150',
    name: 'Manusup Hilir',
  },
  {
    id: '6203150032',
    districtId: '6203150',
    name: 'Muroi Raya',
  },
  {
    id: '6203150033',
    districtId: '6203150',
    name: 'Humbang Raya',
  },
  {
    id: '6203150034',
    districtId: '6203150',
    name: 'Tabore',
  },
  {
    id: '6203150035',
    districtId: '6203150',
    name: 'Sei Gita',
  },
  {
    id: '6203150036',
    districtId: '6203150',
    name: 'Bukit Batu',
  },
  {
    id: '6203150037',
    districtId: '6203150',
    name: 'Sei Gawing',
  },
  {
    id: '6203150038',
    districtId: '6203150',
    name: 'Tumbang Mangkutup',
  },
  {
    id: '6203150039',
    districtId: '6203150',
    name: 'Lapetan',
  },
  {
    id: '6203160001',
    districtId: '6203160',
    name: 'Petak Puti',
  },
  {
    id: '6203160002',
    districtId: '6203160',
    name: 'Aruk',
  },
  {
    id: '6203160003',
    districtId: '6203160',
    name: 'Lawang Kajang',
  },
  {
    id: '6203160004',
    districtId: '6203160',
    name: 'Timpah',
  },
  {
    id: '6203160005',
    districtId: '6203160',
    name: 'Lungku Layang',
  },
  {
    id: '6203160006',
    districtId: '6203160',
    name: 'Danau Pantau',
  },
  {
    id: '6203160007',
    districtId: '6203160',
    name: 'Lawang Kamah',
  },
  {
    id: '6203160008',
    districtId: '6203160',
    name: 'Tumbang Randang',
  },
  {
    id: '6203160009',
    districtId: '6203160',
    name: 'Batapah',
  },
  {
    id: '6203170001',
    districtId: '6203170',
    name: 'Masaran',
  },
  {
    id: '6203170002',
    districtId: '6203170',
    name: 'Kayu Bulan',
  },
  {
    id: '6203170003',
    districtId: '6203170',
    name: 'Kota Baru',
  },
  {
    id: '6203170004',
    districtId: '6203170',
    name: 'Penda Muntei',
  },
  {
    id: '6203170005',
    districtId: '6203170',
    name: 'Tapen',
  },
  {
    id: '6203170006',
    districtId: '6203170',
    name: 'Pujon',
  },
  {
    id: '6203170007',
    districtId: '6203170',
    name: 'Marapit',
  },
  {
    id: '6203170008',
    districtId: '6203170',
    name: 'Manis',
  },
  {
    id: '6203170009',
    districtId: '6203170',
    name: 'Bajuh',
  },
  {
    id: '6203170011',
    districtId: '6203170',
    name: 'Karukus',
  },
  {
    id: '6203170018',
    districtId: '6203170',
    name: 'Barunang',
  },
  {
    id: '6203170019',
    districtId: '6203170',
    name: 'Buhut Jaya',
  },
  {
    id: '6203171001',
    districtId: '6203171',
    name: 'Dandang',
  },
  {
    id: '6203171002',
    districtId: '6203171',
    name: 'Balai Banjang',
  },
  {
    id: '6203171003',
    districtId: '6203171',
    name: 'Jangkang',
  },
  {
    id: '6203171004',
    districtId: '6203171',
    name: 'Kaburan',
  },
  {
    id: '6203171005',
    districtId: '6203171',
    name: 'Sei Ringin',
  },
  {
    id: '6203171006',
    districtId: '6203171',
    name: 'Hurung Kampin',
  },
  {
    id: '6203171007',
    districtId: '6203171',
    name: 'Tumbang Tukun',
  },
  {
    id: '6203171008',
    districtId: '6203171',
    name: 'Tumbang Diring',
  },
  {
    id: '6203171009',
    districtId: '6203171',
    name: 'Batu Sambung',
  },
  {
    id: '6203171010',
    districtId: '6203171',
    name: 'Tumbang Nusa',
  },
  {
    id: '6203180001',
    districtId: '6203180',
    name: 'Supang',
  },
  {
    id: '6203180002',
    districtId: '6203180',
    name: 'Hurung Tabengan',
  },
  {
    id: '6203180003',
    districtId: '6203180',
    name: 'Rahung Bungai',
  },
  {
    id: '6203180004',
    districtId: '6203180',
    name: 'Tangirang',
  },
  {
    id: '6203180005',
    districtId: '6203180',
    name: 'Sei Hanyu',
  },
  {
    id: '6203180006',
    districtId: '6203180',
    name: 'Bulau Ngandung',
  },
  {
    id: '6203180007',
    districtId: '6203180',
    name: 'Tumbang Puruh',
  },
  {
    id: '6203180008',
    districtId: '6203180',
    name: 'Katanjung',
  },
  {
    id: '6203180009',
    districtId: '6203180',
    name: 'Hurung Tampang',
  },
  {
    id: '6203180010',
    districtId: '6203180',
    name: 'Baronang II',
  },
  {
    id: '6203180013',
    districtId: '6203180',
    name: 'Dirung Koram',
  },
  {
    id: '6203180018',
    districtId: '6203180',
    name: 'Jakatan Pari',
  },
  {
    id: '6203180019',
    districtId: '6203180',
    name: 'Tumbang Sirat',
  },
  {
    id: '6203180020',
    districtId: '6203180',
    name: 'Mampai Jaya',
  },
  {
    id: '6203181001',
    districtId: '6203181',
    name: 'Masaha',
  },
  {
    id: '6203181002',
    districtId: '6203181',
    name: 'Sei Pinang',
  },
  {
    id: '6203181003',
    districtId: '6203181',
    name: 'Tanjung Rendan',
  },
  {
    id: '6203181004',
    districtId: '6203181',
    name: 'Tumbang Tihis',
  },
  {
    id: '6203181005',
    districtId: '6203181',
    name: 'Lawang Tamang',
  },
  {
    id: '6203181006',
    districtId: '6203181',
    name: 'Karetau Manta`A',
  },
  {
    id: '6203181007',
    districtId: '6203181',
    name: 'Tumbang Manyarung',
  },
  {
    id: '6203181008',
    districtId: '6203181',
    name: 'Tumbang Bokoi',
  },
  {
    id: '6203181009',
    districtId: '6203181',
    name: 'Jakatan Masaha',
  },
  {
    id: '6203181010',
    districtId: '6203181',
    name: 'Masupa Ria',
  },
  {
    id: '6204010003',
    districtId: '6204010',
    name: 'Tabatan Jaya',
  },
  {
    id: '6204010004',
    districtId: '6204010',
    name: 'Sukakarya',
  },
  {
    id: '6204010005',
    districtId: '6204010',
    name: 'Tampulang',
  },
  {
    id: '6204010006',
    districtId: '6204010',
    name: 'Rantau Bahuang',
  },
  {
    id: '6204010007',
    districtId: '6204010',
    name: 'Rantau Kujang',
  },
  {
    id: '6204010008',
    districtId: '6204010',
    name: 'Rangga Ilung',
  },
  {
    id: '6204010009',
    districtId: '6204010',
    name: 'Tabatan',
  },
  {
    id: '6204020001',
    districtId: '6204020',
    name: 'Sungai Jaya',
  },
  {
    id: '6204020002',
    districtId: '6204020',
    name: 'Mahajandau',
  },
  {
    id: '6204020003',
    districtId: '6204020',
    name: 'Mengkatip',
  },
  {
    id: '6204020004',
    districtId: '6204020',
    name: 'Kalanis',
  },
  {
    id: '6204020005',
    districtId: '6204020',
    name: 'Lehai',
  },
  {
    id: '6204020006',
    districtId: '6204020',
    name: 'Damparan',
  },
  {
    id: '6204020007',
    districtId: '6204020',
    name: 'Teluk Timbau',
  },
  {
    id: '6204020008',
    districtId: '6204020',
    name: 'Batilap',
  },
  {
    id: '6204020009',
    districtId: '6204020',
    name: 'Batampang',
  },
  {
    id: '6204020010',
    districtId: '6204020',
    name: 'Mangkatir',
  },
  {
    id: '6204030001',
    districtId: '6204030',
    name: 'Salat Baru',
  },
  {
    id: '6204030002',
    districtId: '6204030',
    name: 'Bangkuang',
  },
  {
    id: '6204030004',
    districtId: '6204030',
    name: 'Janggi',
  },
  {
    id: '6204030005',
    districtId: '6204030',
    name: 'Babai',
  },
  {
    id: '6204030006',
    districtId: '6204030',
    name: 'Malitin',
  },
  {
    id: '6204030007',
    districtId: '6204030',
    name: 'Muara Arai',
  },
  {
    id: '6204030008',
    districtId: '6204030',
    name: 'Talio',
  },
  {
    id: '6204030009',
    districtId: '6204030',
    name: 'Tampijak',
  },
  {
    id: '6204030010',
    districtId: '6204030',
    name: 'Bintang Kurung',
  },
  {
    id: '6204030011',
    districtId: '6204030',
    name: 'Teluk Sampudau',
  },
  {
    id: '6204040001',
    districtId: '6204040',
    name: 'Muara Talang',
  },
  {
    id: '6204040002',
    districtId: '6204040',
    name: 'Teluk Telaga',
  },
  {
    id: '6204040003',
    districtId: '6204040',
    name: 'Baru',
  },
  {
    id: '6204040004',
    districtId: '6204040',
    name: 'Danau Sadar',
  },
  {
    id: '6204040005',
    districtId: '6204040',
    name: 'Jelapat',
  },
  {
    id: '6204040006',
    districtId: '6204040',
    name: 'Hilir Sper',
  },
  {
    id: '6204040007',
    districtId: '6204040',
    name: 'Danau Ganting',
  },
  {
    id: '6204040008',
    districtId: '6204040',
    name: 'Mangaris',
  },
  {
    id: '6204040009',
    districtId: '6204040',
    name: 'Dangka',
  },
  {
    id: '6204040010',
    districtId: '6204040',
    name: 'Tetei Lanan',
  },
  {
    id: '6204040011',
    districtId: '6204040',
    name: 'Pamangka',
  },
  {
    id: '6204040012',
    districtId: '6204040',
    name: 'Sababilah',
  },
  {
    id: '6204040013',
    districtId: '6204040',
    name: 'Pamait',
  },
  {
    id: '6204040014',
    districtId: '6204040',
    name: 'Buntok Kota',
  },
  {
    id: '6204040015',
    districtId: '6204040',
    name: 'Muara Ripung',
  },
  {
    id: '6204040016',
    districtId: '6204040',
    name: 'Mabuan',
  },
  {
    id: '6204040017',
    districtId: '6204040',
    name: 'Murung Paken',
  },
  {
    id: '6204040018',
    districtId: '6204040',
    name: 'Madara',
  },
  {
    id: '6204040019',
    districtId: '6204040',
    name: 'Kalahien',
  },
  {
    id: '6204040021',
    districtId: '6204040',
    name: 'Sanggu',
  },
  {
    id: '6204040022',
    districtId: '6204040',
    name: 'Telang Andrau',
  },
  {
    id: '6204040023',
    districtId: '6204040',
    name: 'Penda Asam',
  },
  {
    id: '6204040024',
    districtId: '6204040',
    name: 'Pararapak',
  },
  {
    id: '6204040025',
    districtId: '6204040',
    name: 'Teluk Mampun',
  },
  {
    id: '6204040026',
    districtId: '6204040',
    name: 'Tanjung Jawa',
  },
  {
    id: '6204040027',
    districtId: '6204040',
    name: 'Danau Masura',
  },
  {
    id: '6204050001',
    districtId: '6204050',
    name: 'Pendang',
  },
  {
    id: '6204050002',
    districtId: '6204050',
    name: 'Majundre',
  },
  {
    id: '6204050003',
    districtId: '6204050',
    name: 'Sungai Telang',
  },
  {
    id: '6204050004',
    districtId: '6204050',
    name: 'Talekoi',
  },
  {
    id: '6204050005',
    districtId: '6204050',
    name: 'Bundar',
  },
  {
    id: '6204050006',
    districtId: '6204050',
    name: 'Marawan Lama',
  },
  {
    id: '6204050007',
    districtId: '6204050',
    name: 'Marawan Baru',
  },
  {
    id: '6204050008',
    districtId: '6204050',
    name: 'Reong',
  },
  {
    id: '6204050009',
    districtId: '6204050',
    name: 'Maruga',
  },
  {
    id: '6204050010',
    districtId: '6204050',
    name: 'Hingan',
  },
  {
    id: '6204050011',
    districtId: '6204050',
    name: 'Danau Bambure',
  },
  {
    id: '6204050012',
    districtId: '6204050',
    name: 'Tamparak',
  },
  {
    id: '6204050013',
    districtId: '6204050',
    name: 'Bantai Bambure',
  },
  {
    id: '6204050014',
    districtId: '6204050',
    name: 'Rampa Mea',
  },
  {
    id: '6204050015',
    districtId: '6204050',
    name: 'Hulu Tampang',
  },
  {
    id: '6204050016',
    districtId: '6204050',
    name: 'Panarukan',
  },
  {
    id: '6204050017',
    districtId: '6204050',
    name: 'Tarusan',
  },
  {
    id: '6204050018',
    districtId: '6204050',
    name: 'Gunung Rantau',
  },
  {
    id: '6204050019',
    districtId: '6204050',
    name: 'Tamparak Layung',
  },
  {
    id: '6204060001',
    districtId: '6204060',
    name: 'Baruang',
  },
  {
    id: '6204060002',
    districtId: '6204060',
    name: 'Wungkur Baru',
  },
  {
    id: '6204060003',
    districtId: '6204060',
    name: 'Kayumban',
  },
  {
    id: '6204060004',
    districtId: '6204060',
    name: 'Tabak Kanilan',
  },
  {
    id: '6204060005',
    districtId: '6204060',
    name: 'Sarimbuah',
  },
  {
    id: '6204060006',
    districtId: '6204060',
    name: 'Ruhing Raya',
  },
  {
    id: '6204060007',
    districtId: '6204060',
    name: 'Muka Haji',
  },
  {
    id: '6204060008',
    districtId: '6204060',
    name: 'Sire',
  },
  {
    id: '6204060009',
    districtId: '6204060',
    name: 'Gagutur',
  },
  {
    id: '6204060010',
    districtId: '6204060',
    name: 'Marga Jaya',
  },
  {
    id: '6204060011',
    districtId: '6204060',
    name: 'Ugang Sayu',
  },
  {
    id: '6204060012',
    districtId: '6204060',
    name: 'Bipak Kali',
  },
  {
    id: '6204060013',
    districtId: '6204060',
    name: 'Muara Singan',
  },
  {
    id: '6204060014',
    districtId: '6204060',
    name: 'Patas I',
  },
  {
    id: '6204060015',
    districtId: '6204060',
    name: 'Patas II',
  },
  {
    id: '6204060016',
    districtId: '6204060',
    name: 'Bintang Ara',
  },
  {
    id: '6204060017',
    districtId: '6204060',
    name: 'Malungai Raya',
  },
  {
    id: '6204060018',
    districtId: '6204060',
    name: 'Palu Rejo',
  },
  {
    id: '6204060019',
    districtId: '6204060',
    name: 'Wayun',
  },
  {
    id: '6204060020',
    districtId: '6204060',
    name: 'Sei Paken',
  },
  {
    id: '6204060021',
    districtId: '6204060',
    name: 'Ngurit',
  },
  {
    id: '6205010001',
    districtId: '6205010',
    name: 'Pepas',
  },
  {
    id: '6205010002',
    districtId: '6205010',
    name: 'Tumpung Laung II',
  },
  {
    id: '6205010003',
    districtId: '6205010',
    name: 'Tumpung Laung I',
  },
  {
    id: '6205010004',
    districtId: '6205010',
    name: 'Montallat I',
  },
  {
    id: '6205010005',
    districtId: '6205010',
    name: 'Montallat II',
  },
  {
    id: '6205010006',
    districtId: '6205010',
    name: 'Sikan',
  },
  {
    id: '6205010007',
    districtId: '6205010',
    name: 'Rubei',
  },
  {
    id: '6205010008',
    districtId: '6205010',
    name: 'Ruji',
  },
  {
    id: '6205010009',
    districtId: '6205010',
    name: 'Paring Lahung',
  },
  {
    id: '6205010010',
    districtId: '6205010',
    name: 'Kamawen',
  },
  {
    id: '6205020001',
    districtId: '6205020',
    name: 'Malungai',
  },
  {
    id: '6205020002',
    districtId: '6205020',
    name: 'Rarawa',
  },
  {
    id: '6205020003',
    districtId: '6205020',
    name: 'Ketapang',
  },
  {
    id: '6205020004',
    districtId: '6205020',
    name: 'Walur',
  },
  {
    id: '6205020005',
    districtId: '6205020',
    name: 'Baliti',
  },
  {
    id: '6205020006',
    districtId: '6205020',
    name: 'Majangkan',
  },
  {
    id: '6205020007',
    districtId: '6205020',
    name: 'Kandui',
  },
  {
    id: '6205020008',
    districtId: '6205020',
    name: 'Payang Ara',
  },
  {
    id: '6205020009',
    districtId: '6205020',
    name: 'Jaman',
  },
  {
    id: '6205020010',
    districtId: '6205020',
    name: 'Pelari',
  },
  {
    id: '6205020011',
    districtId: '6205020',
    name: 'Sangkurang',
  },
  {
    id: '6205020012',
    districtId: '6205020',
    name: 'Siwau',
  },
  {
    id: '6205020013',
    districtId: '6205020',
    name: 'Tongka',
  },
  {
    id: '6205020014',
    districtId: '6205020',
    name: 'Batu Raya I',
  },
  {
    id: '6205020015',
    districtId: '6205020',
    name: 'Baturaya II',
  },
  {
    id: '6205020016',
    districtId: '6205020',
    name: 'Tapen Raya',
  },
  {
    id: '6205030001',
    districtId: '6205030',
    name: 'Muara Mea',
  },
  {
    id: '6205030002',
    districtId: '6205030',
    name: 'Lawarang',
  },
  {
    id: '6205030003',
    districtId: '6205030',
    name: 'Lampeong II',
  },
  {
    id: '6205030004',
    districtId: '6205030',
    name: 'Lampeong I',
  },
  {
    id: '6205030005',
    districtId: '6205030',
    name: 'Berong',
  },
  {
    id: '6205030006',
    districtId: '6205030',
    name: 'Baok',
  },
  {
    id: '6205030007',
    districtId: '6205030',
    name: 'Payang',
  },
  {
    id: '6205030008',
    districtId: '6205030',
    name: 'Linon Besi II',
  },
  {
    id: '6205030009',
    districtId: '6205030',
    name: 'Tanjung Harapan',
  },
  {
    id: '6205030010',
    districtId: '6205030',
    name: 'Linon Besi I',
  },
  {
    id: '6205030011',
    districtId: '6205030',
    name: 'Tambaba',
  },
  {
    id: '6205040001',
    districtId: '6205040',
    name: 'Liju',
  },
  {
    id: '6205040002',
    districtId: '6205040',
    name: 'Sampirang I',
  },
  {
    id: '6205040003',
    districtId: '6205040',
    name: 'Sampirang II',
  },
  {
    id: '6205040004',
    districtId: '6205040',
    name: 'Benangin 3',
  },
  {
    id: '6205040005',
    districtId: '6205040',
    name: 'Benangin 2',
  },
  {
    id: '6205040006',
    districtId: '6205040',
    name: 'Benangin I',
  },
  {
    id: '6205040007',
    districtId: '6205040',
    name: 'Benangin 5',
  },
  {
    id: '6205040008',
    districtId: '6205040',
    name: 'Muara Wakat',
  },
  {
    id: '6205040012',
    districtId: '6205040',
    name: 'Mampuak I',
  },
  {
    id: '6205040013',
    districtId: '6205040',
    name: 'Jamut',
  },
  {
    id: '6205040014',
    districtId: '6205040',
    name: 'Sei Liju',
  },
  {
    id: '6205040015',
    districtId: '6205040',
    name: 'Mampuak II',
  },
  {
    id: '6205050001',
    districtId: '6205050',
    name: 'Lemo I',
  },
  {
    id: '6205050010',
    districtId: '6205050',
    name: 'Lemo II',
  },
  {
    id: '6205050012',
    districtId: '6205050',
    name: 'Lanjas',
  },
  {
    id: '6205050013',
    districtId: '6205050',
    name: 'Melayu',
  },
  {
    id: '6205050017',
    districtId: '6205050',
    name: 'Rimba Sari',
  },
  {
    id: '6205050018',
    districtId: '6205050',
    name: 'Sei Rahayu I',
  },
  {
    id: '6205050022',
    districtId: '6205050',
    name: 'Sei Rahayu II',
  },
  {
    id: '6205050023',
    districtId: '6205050',
    name: 'Beringin Raya',
  },
  {
    id: '6205050027',
    districtId: '6205050',
    name: 'Datai Nirui',
  },
  {
    id: '6205051001',
    districtId: '6205051',
    name: 'Jingah',
  },
  {
    id: '6205051002',
    districtId: '6205051',
    name: 'Jambu',
  },
  {
    id: '6205051003',
    districtId: '6205051',
    name: 'Liang Naga',
  },
  {
    id: '6205051004',
    districtId: '6205051',
    name: 'Sabuh',
  },
  {
    id: '6205051005',
    districtId: '6205051',
    name: 'Hajak',
  },
  {
    id: '6205051006',
    districtId: '6205051',
    name: 'Malawaken',
  },
  {
    id: '6205051007',
    districtId: '6205051',
    name: 'Sikui',
  },
  {
    id: '6205051008',
    districtId: '6205051',
    name: 'Panaen',
  },
  {
    id: '6205051009',
    districtId: '6205051',
    name: 'Liang Buah',
  },
  {
    id: '6205051010',
    districtId: '6205051',
    name: 'Gandring',
  },
  {
    id: '6205052001',
    districtId: '6205052',
    name: 'Trahean',
  },
  {
    id: '6205052002',
    districtId: '6205052',
    name: 'Trinsing',
  },
  {
    id: '6205052003',
    districtId: '6205052',
    name: 'Bintang Ninggi I',
  },
  {
    id: '6205052004',
    districtId: '6205052',
    name: 'Bintang Ninggi II',
  },
  {
    id: '6205052005',
    districtId: '6205052',
    name: 'Butong',
  },
  {
    id: '6205052006',
    districtId: '6205052',
    name: 'Buntok Baru',
  },
  {
    id: '6205052007',
    districtId: '6205052',
    name: 'Bukit Sawit',
  },
  {
    id: '6205052008',
    districtId: '6205052',
    name: 'Tawan Jaya',
  },
  {
    id: '6205052009',
    districtId: '6205052',
    name: 'Pandran Raya',
  },
  {
    id: '6205052010',
    districtId: '6205052',
    name: 'Pandran Permai',
  },
  {
    id: '6205060011',
    districtId: '6205060',
    name: 'Ipu',
  },
  {
    id: '6205060012',
    districtId: '6205060',
    name: 'Lahei II',
  },
  {
    id: '6205060013',
    districtId: '6205060',
    name: 'Lahei I',
  },
  {
    id: '6205060014',
    districtId: '6205060',
    name: 'Juju Baru',
  },
  {
    id: '6205060015',
    districtId: '6205060',
    name: 'Muara Bakah',
  },
  {
    id: '6205060018',
    districtId: '6205060',
    name: 'Muara Inu',
  },
  {
    id: '6205060019',
    districtId: '6205060',
    name: 'Bengahon',
  },
  {
    id: '6205060020',
    districtId: '6205060',
    name: 'Rahaden',
  },
  {
    id: '6205060021',
    districtId: '6205060',
    name: 'Muara Pari',
  },
  {
    id: '6205060022',
    districtId: '6205060',
    name: 'Karendan',
  },
  {
    id: '6205060023',
    districtId: '6205060',
    name: 'Haragandang',
  },
  {
    id: '6205061001',
    districtId: '6205061',
    name: 'Nihan Hilir',
  },
  {
    id: '6205061002',
    districtId: '6205061',
    name: 'Nihan Hulu',
  },
  {
    id: '6205061003',
    districtId: '6205061',
    name: 'Luwe Hilir',
  },
  {
    id: '6205061005',
    districtId: '6205061',
    name: 'Jangkang Baru',
  },
  {
    id: '6205061006',
    districtId: '6205061',
    name: 'Jangkang Lama',
  },
  {
    id: '6205061007',
    districtId: '6205061',
    name: 'Papar Pujung',
  },
  {
    id: '6205061008',
    districtId: '6205061',
    name: 'Teluk Malewai',
  },
  {
    id: '6205061009',
    districtId: '6205061',
    name: 'Benao Hilir',
  },
  {
    id: '6205061010',
    districtId: '6205061',
    name: 'Benao Hulu',
  },
  {
    id: '6205061011',
    districtId: '6205061',
    name: 'Karamuan',
  },
  {
    id: '6206010001',
    districtId: '6206010',
    name: 'Kuala Jelai',
  },
  {
    id: '6206010002',
    districtId: '6206010',
    name: 'Sungai Baru',
  },
  {
    id: '6206010003',
    districtId: '6206010',
    name: 'Sungai Bundung',
  },
  {
    id: '6206010004',
    districtId: '6206010',
    name: 'Sungai Raja',
  },
  {
    id: '6206010006',
    districtId: '6206010',
    name: 'Pulau Nibung',
  },
  {
    id: '6206011001',
    districtId: '6206011',
    name: 'Sungai Damar',
  },
  {
    id: '6206011002',
    districtId: '6206011',
    name: 'Sungai Tabuk',
  },
  {
    id: '6206011003',
    districtId: '6206011',
    name: 'Sungai Cabang Barat',
  },
  {
    id: '6206011004',
    districtId: '6206011',
    name: 'Sungai Pasir',
  },
  {
    id: '6206020001',
    districtId: '6206020',
    name: 'Mendawai',
  },
  {
    id: '6206020002',
    districtId: '6206020',
    name: 'Natai Sedawak',
  },
  {
    id: '6206020004',
    districtId: '6206020',
    name: 'Padang',
  },
  {
    id: '6206020005',
    districtId: '6206020',
    name: 'Karta Mulia',
  },
  {
    id: '6206020006',
    districtId: '6206020',
    name: 'Sukaraja',
  },
  {
    id: '6206020007',
    districtId: '6206020',
    name: 'Pangkalan Muntai',
  },
  {
    id: '6206020008',
    districtId: '6206020',
    name: 'Petarikan',
  },
  {
    id: '6206030001',
    districtId: '6206030',
    name: 'Jihing',
  },
  {
    id: '6206030002',
    districtId: '6206030',
    name: 'Air Dua',
  },
  {
    id: '6206030003',
    districtId: '6206030',
    name: 'Bukit Sungkai',
  },
  {
    id: '6206030004',
    districtId: '6206030',
    name: 'Lupu Peruca',
  },
  {
    id: '6206030005',
    districtId: '6206030',
    name: 'Sekuningan Baru',
  },
  {
    id: '6206030006',
    districtId: '6206030',
    name: 'Balai Riam',
  },
  {
    id: '6206030007',
    districtId: '6206030',
    name: 'Bangun Jaya',
  },
  {
    id: '6206030009',
    districtId: '6206030',
    name: 'Pempaning',
  },
  {
    id: '6206031001',
    districtId: '6206031',
    name: 'Natai Kondang',
  },
  {
    id: '6206031002',
    districtId: '6206031',
    name: 'Ajang',
  },
  {
    id: '6206031003',
    districtId: '6206031',
    name: 'Laman Baru',
  },
  {
    id: '6206031004',
    districtId: '6206031',
    name: 'Kenawan',
  },
  {
    id: '6206031005',
    districtId: '6206031',
    name: 'Semantun',
  },
  {
    id: '6206031006',
    districtId: '6206031',
    name: 'Sembikuan',
  },
  {
    id: '6206031007',
    districtId: '6206031',
    name: 'Nibung Terjun',
  },
  {
    id: '6207010001',
    districtId: '6207010',
    name: 'Batu Kotam',
  },
  {
    id: '6207010003',
    districtId: '6207010',
    name: 'Guci',
  },
  {
    id: '6207010004',
    districtId: '6207010',
    name: 'Kujan',
  },
  {
    id: '6207010005',
    districtId: '6207010',
    name: 'Nanga Bulik',
  },
  {
    id: '6207010006',
    districtId: '6207010',
    name: 'Bumi Agung',
  },
  {
    id: '6207010007',
    districtId: '6207010',
    name: 'Sumber Mulya',
  },
  {
    id: '6207010008',
    districtId: '6207010',
    name: 'Bukit Indah',
  },
  {
    id: '6207010009',
    districtId: '6207010',
    name: 'Arga Mulya',
  },
  {
    id: '6207010011',
    districtId: '6207010',
    name: 'Sungai Mentawa',
  },
  {
    id: '6207010012',
    districtId: '6207010',
    name: 'Beruta',
  },
  {
    id: '6207010013',
    districtId: '6207010',
    name: 'Tamiang',
  },
  {
    id: '6207010014',
    districtId: '6207010',
    name: 'Perigi Raya',
  },
  {
    id: '6207010015',
    districtId: '6207010',
    name: 'Nanga Pamalontian',
  },
  {
    id: '6207011001',
    districtId: '6207011',
    name: 'Mekar Mulya',
  },
  {
    id: '6207011002',
    districtId: '6207011',
    name: 'Jangkar Prima',
  },
  {
    id: '6207011003',
    districtId: '6207011',
    name: 'Purworejo',
  },
  {
    id: '6207011004',
    districtId: '6207011',
    name: 'Wonorejo',
  },
  {
    id: '6207011005',
    districtId: '6207011',
    name: 'Tri Tunggal',
  },
  {
    id: '6207011006',
    districtId: '6207011',
    name: 'Bina Bhakti',
  },
  {
    id: '6207011007',
    districtId: '6207011',
    name: 'Hambawang',
  },
  {
    id: '6207011008',
    districtId: '6207011',
    name: 'Rimba Jaya',
  },
  {
    id: '6207012001',
    districtId: '6207012',
    name: 'Bukit Makmur',
  },
  {
    id: '6207012002',
    districtId: '6207012',
    name: 'Bukit Raya',
  },
  {
    id: '6207012003',
    districtId: '6207012',
    name: 'Sumber Jaya',
  },
  {
    id: '6207012004',
    districtId: '6207012',
    name: 'Bukit Harum',
  },
  {
    id: '6207012005',
    districtId: '6207012',
    name: 'Melata',
  },
  {
    id: '6207012006',
    districtId: '6207012',
    name: 'Mukti Manunggal',
  },
  {
    id: '6207012007',
    districtId: '6207012',
    name: 'Modang Mas',
  },
  {
    id: '6207012008',
    districtId: '6207012',
    name: 'Nanuah',
  },
  {
    id: '6207012009',
    districtId: '6207012',
    name: 'Topalan',
  },
  {
    id: '6207012010',
    districtId: '6207012',
    name: 'Batu Ampar',
  },
  {
    id: '6207012011',
    districtId: '6207012',
    name: 'Lubuk Hiju',
  },
  {
    id: '6207013001',
    districtId: '6207013',
    name: 'Bukit Jaya',
  },
  {
    id: '6207013002',
    districtId: '6207013',
    name: 'Sukamaju',
  },
  {
    id: '6207013003',
    districtId: '6207013',
    name: 'Nanga Palikodan',
  },
  {
    id: '6207013005',
    districtId: '6207013',
    name: 'Nanga Koring',
  },
  {
    id: '6207013006',
    districtId: '6207013',
    name: 'Nuangan',
  },
  {
    id: '6207013007',
    districtId: '6207013',
    name: 'Toka',
  },
  {
    id: '6207013008',
    districtId: '6207013',
    name: 'Sepondam',
  },
  {
    id: '6207013009',
    districtId: '6207013',
    name: 'Pedongatan',
  },
  {
    id: '6207013010',
    districtId: '6207013',
    name: 'Merambang',
  },
  {
    id: '6207013011',
    districtId: '6207013',
    name: 'Batu Tunggal',
  },
  {
    id: '6207013012',
    districtId: '6207013',
    name: 'Nanga Kemujan',
  },
  {
    id: '6207020001',
    districtId: '6207020',
    name: 'Cuhai',
  },
  {
    id: '6207020002',
    districtId: '6207020',
    name: 'Kawa',
  },
  {
    id: '6207020003',
    districtId: '6207020',
    name: 'Panopa',
  },
  {
    id: '6207020004',
    districtId: '6207020',
    name: 'Suja',
  },
  {
    id: '6207020005',
    districtId: '6207020',
    name: 'Sekoban',
  },
  {
    id: '6207020006',
    districtId: '6207020',
    name: 'Bakonsu',
  },
  {
    id: '6207020010',
    districtId: '6207020',
    name: 'Tapin Bini',
  },
  {
    id: '6207020011',
    districtId: '6207020',
    name: 'Karang Taba',
  },
  {
    id: '6207020012',
    districtId: '6207020',
    name: 'Tanjung Beringin',
  },
  {
    id: '6207020013',
    districtId: '6207020',
    name: 'Sungai Tuat',
  },
  {
    id: '6207020014',
    districtId: '6207020',
    name: 'Samujaya',
  },
  {
    id: '6207021001',
    districtId: '6207021',
    name: 'Nanga Belantikan',
  },
  {
    id: '6207021002',
    districtId: '6207021',
    name: 'Sungai Buluh',
  },
  {
    id: '6207021003',
    districtId: '6207021',
    name: 'Tangga Batu',
  },
  {
    id: '6207021004',
    districtId: '6207021',
    name: 'Balibi',
  },
  {
    id: '6207021005',
    districtId: '6207021',
    name: 'Bayat',
  },
  {
    id: '6207021006',
    districtId: '6207021',
    name: 'Karang Besi',
  },
  {
    id: '6207021007',
    districtId: '6207021',
    name: 'Benuatan',
  },
  {
    id: '6207021008',
    districtId: '6207021',
    name: 'Kahingai',
  },
  {
    id: '6207021009',
    districtId: '6207021',
    name: 'Nanga Matu',
  },
  {
    id: '6207021010',
    districtId: '6207021',
    name: 'Petarikan',
  },
  {
    id: '6207021011',
    districtId: '6207021',
    name: 'Bintang Mengalih',
  },
  {
    id: '6207021012',
    districtId: '6207021',
    name: 'Sumber Cahaya',
  },
  {
    id: '6207030004',
    districtId: '6207030',
    name: 'Riam Penahan',
  },
  {
    id: '6207030005',
    districtId: '6207030',
    name: 'Sepoyu',
  },
  {
    id: '6207030009',
    districtId: '6207030',
    name: 'Riam Tinggi',
  },
  {
    id: '6207030010',
    districtId: '6207030',
    name: 'Landau Kantu',
  },
  {
    id: '6207030011',
    districtId: '6207030',
    name: 'Nyalang',
  },
  {
    id: '6207030012',
    districtId: '6207030',
    name: 'Lopus',
  },
  {
    id: '6207030014',
    districtId: '6207030',
    name: 'Sekombulan',
  },
  {
    id: '6207030015',
    districtId: '6207030',
    name: 'Kudangan',
  },
  {
    id: '6207030016',
    districtId: '6207030',
    name: 'Penyombaan',
  },
  {
    id: '6207030017',
    districtId: '6207030',
    name: 'Hulu Jojabo',
  },
  {
    id: '6207031001',
    districtId: '6207031',
    name: 'Batu Tambun',
  },
  {
    id: '6207031002',
    districtId: '6207031',
    name: 'Kinipan',
  },
  {
    id: '6207031003',
    districtId: '6207031',
    name: 'Ginih',
  },
  {
    id: '6207031004',
    districtId: '6207031',
    name: 'Benakitan',
  },
  {
    id: '6207031005',
    districtId: '6207031',
    name: 'Liku',
  },
  {
    id: '6207031006',
    districtId: '6207031',
    name: 'Mengkalang',
  },
  {
    id: '6207031007',
    districtId: '6207031',
    name: 'Karang Mas',
  },
  {
    id: '6207031008',
    districtId: '6207031',
    name: 'Kina',
  },
  {
    id: '6207031009',
    districtId: '6207031',
    name: 'Jemuat',
  },
  {
    id: '6208010001',
    districtId: '6208010',
    name: 'Sungai Perlu',
  },
  {
    id: '6208010002',
    districtId: '6208010',
    name: 'Kuala Pembuang Dua',
  },
  {
    id: '6208010005',
    districtId: '6208010',
    name: 'Kuala Pembuang Satu',
  },
  {
    id: '6208010006',
    districtId: '6208010',
    name: 'Pematang Limau',
  },
  {
    id: '6208010007',
    districtId: '6208010',
    name: 'Tanjung Rangas',
  },
  {
    id: '6208010008',
    districtId: '6208010',
    name: 'Muara Dua',
  },
  {
    id: '6208010009',
    districtId: '6208010',
    name: 'Jahitan',
  },
  {
    id: '6208010010',
    districtId: '6208010',
    name: 'Baung',
  },
  {
    id: '6208010016',
    districtId: '6208010',
    name: 'Sungai Undang',
  },
  {
    id: '6208010017',
    districtId: '6208010',
    name: 'Persil Raya',
  },
  {
    id: '6208011001',
    districtId: '6208011',
    name: 'Pematang Panjang',
  },
  {
    id: '6208011002',
    districtId: '6208011',
    name: 'Sungai Bakau',
  },
  {
    id: '6208011003',
    districtId: '6208011',
    name: 'Kartika Bhakti',
  },
  {
    id: '6208011004',
    districtId: '6208011',
    name: 'Bangun Harja',
  },
  {
    id: '6208011005',
    districtId: '6208011',
    name: 'Halimaung Jaya',
  },
  {
    id: '6208011006',
    districtId: '6208011',
    name: 'Mekar Indah',
  },
  {
    id: '6208020001',
    districtId: '6208020',
    name: 'Telaga Pulang',
  },
  {
    id: '6208020002',
    districtId: '6208020',
    name: 'Sembuluh II',
  },
  {
    id: '6208020003',
    districtId: '6208020',
    name: 'Cempaka Baru',
  },
  {
    id: '6208020004',
    districtId: '6208020',
    name: 'Palingkau',
  },
  {
    id: '6208020005',
    districtId: '6208020',
    name: 'Ulak Batu',
  },
  {
    id: '6208020006',
    districtId: '6208020',
    name: 'Paren',
  },
  {
    id: '6208020007',
    districtId: '6208020',
    name: 'Banua Usang',
  },
  {
    id: '6208020008',
    districtId: '6208020',
    name: 'Sembuluh I',
  },
  {
    id: '6208021001',
    districtId: '6208021',
    name: 'Tabiku',
  },
  {
    id: '6208021002',
    districtId: '6208021',
    name: 'Bangkal',
  },
  {
    id: '6208021003',
    districtId: '6208021',
    name: 'Lanpasa',
  },
  {
    id: '6208021004',
    districtId: '6208021',
    name: 'Terawan',
  },
  {
    id: '6208021005',
    districtId: '6208021',
    name: 'Salunuk',
  },
  {
    id: '6208030001',
    districtId: '6208030',
    name: 'Tanjung Hanau',
  },
  {
    id: '6208030002',
    districtId: '6208030',
    name: 'Parang Batang',
  },
  {
    id: '6208030003',
    districtId: '6208030',
    name: 'Bahaur',
  },
  {
    id: '6208030004',
    districtId: '6208030',
    name: 'Pembuang Hulu I',
  },
  {
    id: '6208030005',
    districtId: '6208030',
    name: 'Pembuang Hulu II',
  },
  {
    id: '6208030006',
    districtId: '6208030',
    name: 'Derangga',
  },
  {
    id: '6208030012',
    districtId: '6208030',
    name: 'Paring Raya',
  },
  {
    id: '6208031001',
    districtId: '6208031',
    name: 'Asam Baru',
  },
  {
    id: '6208031002',
    districtId: '6208031',
    name: 'Rungau Raya',
  },
  {
    id: '6208031003',
    districtId: '6208031',
    name: 'Tanjung Hara',
  },
  {
    id: '6208031004',
    districtId: '6208031',
    name: 'Tanjung Paring',
  },
  {
    id: '6208031005',
    districtId: '6208031',
    name: 'Panimba Raya',
  },
  {
    id: '6208031006',
    districtId: '6208031',
    name: 'Tanjung Rangas II',
  },
  {
    id: '6208040003',
    districtId: '6208040',
    name: 'Bumi Jaya',
  },
  {
    id: '6208040004',
    districtId: '6208040',
    name: 'Sukorejo',
  },
  {
    id: '6208040008',
    districtId: '6208040',
    name: 'Suka Maju',
  },
  {
    id: '6208040009',
    districtId: '6208040',
    name: 'Suka Makmur',
  },
  {
    id: '6208040011',
    districtId: '6208040',
    name: 'Suka Jaya',
  },
  {
    id: '6208040012',
    districtId: '6208040',
    name: 'Batu Agung',
  },
  {
    id: '6208040015',
    districtId: '6208040',
    name: 'Panca Jaya',
  },
  {
    id: '6208040016',
    districtId: '6208040',
    name: 'Ringin Agung',
  },
  {
    id: '6208040018',
    districtId: '6208040',
    name: 'Gantung Pengayuh',
  },
  {
    id: '6208040019',
    districtId: '6208040',
    name: 'Teluk Bayur',
  },
  {
    id: '6208040020',
    districtId: '6208040',
    name: 'Suka Mandang',
  },
  {
    id: '6208040021',
    districtId: '6208040',
    name: 'Ayawan',
  },
  {
    id: '6208040022',
    districtId: '6208040',
    name: 'Mugi Panyuhu',
  },
  {
    id: '6208040023',
    districtId: '6208040',
    name: 'Bukit Buluh',
  },
  {
    id: '6208040024',
    districtId: '6208040',
    name: 'Tumbang Bai',
  },
  {
    id: '6208040025',
    districtId: '6208040',
    name: 'Durian Tunggal',
  },
  {
    id: '6208040026',
    districtId: '6208040',
    name: 'Rantau Pulut',
  },
  {
    id: '6208040027',
    districtId: '6208040',
    name: 'Penyumpa',
  },
  {
    id: '6208040028',
    districtId: '6208040',
    name: 'Pangke',
  },
  {
    id: '6208040029',
    districtId: '6208040',
    name: 'Tangga Batu',
  },
  {
    id: '6208041001',
    districtId: '6208041',
    name: 'Sebabi',
  },
  {
    id: '6208041002',
    districtId: '6208041',
    name: 'Sandul',
  },
  {
    id: '6208041003',
    districtId: '6208041',
    name: 'Suka Mulya',
  },
  {
    id: '6208041004',
    districtId: '6208041',
    name: 'Kalang',
  },
  {
    id: '6208041005',
    districtId: '6208041',
    name: 'Durian Kait',
  },
  {
    id: '6208041006',
    districtId: '6208041',
    name: 'Sahabu',
  },
  {
    id: '6208041007',
    districtId: '6208041',
    name: 'Wana Tirta',
  },
  {
    id: '6208041008',
    districtId: '6208041',
    name: 'Batu Manangis',
  },
  {
    id: '6208041009',
    districtId: '6208041',
    name: 'Derawa',
  },
  {
    id: '6208050008',
    districtId: '6208050',
    name: 'Marandang',
  },
  {
    id: '6208050009',
    districtId: '6208050',
    name: 'Tumbang Suei',
  },
  {
    id: '6208050010',
    districtId: '6208050',
    name: 'Tumbang Manjul',
  },
  {
    id: '6208050011',
    districtId: '6208050',
    name: 'Mojang Baru',
  },
  {
    id: '6208050012',
    districtId: '6208050',
    name: 'Rantau Panjang',
  },
  {
    id: '6208050013',
    districtId: '6208050',
    name: 'Mongoh Juoi',
  },
  {
    id: '6208050014',
    districtId: '6208050',
    name: 'Tusuk Belawan',
  },
  {
    id: '6208050015',
    districtId: '6208050',
    name: 'Tumbang Kalam',
  },
  {
    id: '6208050016',
    districtId: '6208050',
    name: 'Tumbang Bahan',
  },
  {
    id: '6208050017',
    districtId: '6208050',
    name: 'Tumbang Darap',
  },
  {
    id: '6208050019',
    districtId: '6208050',
    name: 'Tumbang Kasai',
  },
  {
    id: '6208050020',
    districtId: '6208050',
    name: 'Tumbang Setawai',
  },
  {
    id: '6208050021',
    districtId: '6208050',
    name: 'Sepundu Hantu',
  },
  {
    id: '6208050022',
    districtId: '6208050',
    name: 'Tumbang Kubang',
  },
  {
    id: '6208050023',
    districtId: '6208050',
    name: 'Tumbang Sepan',
  },
  {
    id: '6208050024',
    districtId: '6208050',
    name: 'Riam Batang',
  },
  {
    id: '6208050025',
    districtId: '6208050',
    name: 'Tumbang Laku',
  },
  {
    id: '6208050026',
    districtId: '6208050',
    name: 'Buntut Sapau',
  },
  {
    id: '6208050027',
    districtId: '6208050',
    name: 'Tumbang Taberau',
  },
  {
    id: '6208050028',
    districtId: '6208050',
    name: 'Tanjung Paku',
  },
  {
    id: '6208051001',
    districtId: '6208051',
    name: 'Tumbang Magin',
  },
  {
    id: '6208051002',
    districtId: '6208051',
    name: 'Tumbang Setoli',
  },
  {
    id: '6208051003',
    districtId: '6208051',
    name: 'Tumbang Hentas',
  },
  {
    id: '6208051004',
    districtId: '6208051',
    name: 'Tumbang Langkai',
  },
  {
    id: '6208051005',
    districtId: '6208051',
    name: 'Tanjung Tukal',
  },
  {
    id: '6208051006',
    districtId: '6208051',
    name: 'Rangkang Munduk',
  },
  {
    id: '6208051007',
    districtId: '6208051',
    name: 'Tumbang Salau',
  },
  {
    id: '6208051008',
    districtId: '6208051',
    name: 'Rantau Betung',
  },
  {
    id: '6208051009',
    districtId: '6208051',
    name: 'Tumbang Gugup',
  },
  {
    id: '6209010001',
    districtId: '6209010',
    name: 'Pegatan Hilir',
  },
  {
    id: '6209010002',
    districtId: '6209010',
    name: 'Pegatan Hulu',
  },
  {
    id: '6209010003',
    districtId: '6209010',
    name: 'Jaya Makmur',
  },
  {
    id: '6209010004',
    districtId: '6209010',
    name: 'Subur Indah',
  },
  {
    id: '6209010005',
    districtId: '6209010',
    name: 'Keramat',
  },
  {
    id: '6209010006',
    districtId: '6209010',
    name: 'Singam Raya',
  },
  {
    id: '6209010007',
    districtId: '6209010',
    name: 'Bangun Jaya',
  },
  {
    id: '6209010008',
    districtId: '6209010',
    name: 'Kampung Tengah',
  },
  {
    id: '6209010009',
    districtId: '6209010',
    name: 'Kampung Baru',
  },
  {
    id: '6209010010',
    districtId: '6209010',
    name: 'Setia Mulia',
  },
  {
    id: '6209010011',
    districtId: '6209010',
    name: 'Sebangau Jaya',
  },
  {
    id: '6209010012',
    districtId: '6209010',
    name: 'Sungai Kaki',
  },
  {
    id: '6209010013',
    districtId: '6209010',
    name: 'Selat Baning',
  },
  {
    id: '6209010014',
    districtId: '6209010',
    name: 'Makmur Utama',
  },
  {
    id: '6209010015',
    districtId: '6209010',
    name: 'Bumi Subur',
  },
  {
    id: '6209010016',
    districtId: '6209010',
    name: 'Bakung Raya',
  },
  {
    id: '6209020002',
    districtId: '6209020',
    name: 'Mendawai',
  },
  {
    id: '6209020003',
    districtId: '6209020',
    name: 'Kampung Melayu',
  },
  {
    id: '6209020004',
    districtId: '6209020',
    name: 'Tewang Kampung',
  },
  {
    id: '6209020005',
    districtId: '6209020',
    name: 'Mekar Tani',
  },
  {
    id: '6209020006',
    districtId: '6209020',
    name: 'Perigi',
  },
  {
    id: '6209020007',
    districtId: '6209020',
    name: 'Tumbang Bulan',
  },
  {
    id: '6209030001',
    districtId: '6209030',
    name: 'Galinggang',
  },
  {
    id: '6209030002',
    districtId: '6209030',
    name: 'Tampelas',
  },
  {
    id: '6209030003',
    districtId: '6209030',
    name: 'Telaga',
  },
  {
    id: '6209030004',
    districtId: '6209030',
    name: 'Parupuk',
  },
  {
    id: '6209030005',
    districtId: '6209030',
    name: 'Karuing',
  },
  {
    id: '6209030006',
    districtId: '6209030',
    name: 'Jahanjang',
  },
  {
    id: '6209030007',
    districtId: '6209030',
    name: 'Tumbang Runen',
  },
  {
    id: '6209030008',
    districtId: '6209030',
    name: 'Baun Bango',
  },
  {
    id: '6209030009',
    districtId: '6209030',
    name: 'Asem Kumbang',
  },
  {
    id: '6209040001',
    districtId: '6209040',
    name: 'Talingke',
  },
  {
    id: '6209040002',
    districtId: '6209040',
    name: 'Hiyang Bana',
  },
  {
    id: '6209040003',
    districtId: '6209040',
    name: 'Petak Bahandang',
  },
  {
    id: '6209040004',
    districtId: '6209040',
    name: 'Handiwung',
  },
  {
    id: '6209040005',
    districtId: '6209040',
    name: 'Tumbang Panggo',
  },
  {
    id: '6209040006',
    districtId: '6209040',
    name: 'Tewang Tampang',
  },
  {
    id: '6209040007',
    districtId: '6209040',
    name: 'Luwuk Kanan',
  },
  {
    id: '6209040008',
    districtId: '6209040',
    name: 'Luwuk Kiri',
  },
  {
    id: '6209050001',
    districtId: '6209050',
    name: 'Tewang Kadamba',
  },
  {
    id: '6209050002',
    districtId: '6209050',
    name: 'Tumbang Liting',
  },
  {
    id: '6209050003',
    districtId: '6209050',
    name: 'Kasongan Baru',
  },
  {
    id: '6209050004',
    districtId: '6209050',
    name: 'Kasongan Lama',
  },
  {
    id: '6209050005',
    districtId: '6209050',
    name: 'Talian Kereng',
  },
  {
    id: '6209050006',
    districtId: '6209050',
    name: 'Banut Kalanaman',
  },
  {
    id: '6209050007',
    districtId: '6209050',
    name: 'Telangkah',
  },
  {
    id: '6209050008',
    districtId: '6209050',
    name: 'Hampalit',
  },
  {
    id: '6209060001',
    districtId: '6209060',
    name: 'Tewang Beringin',
  },
  {
    id: '6209060002',
    districtId: '6209060',
    name: 'Hapalam',
  },
  {
    id: '6209060003',
    districtId: '6209060',
    name: 'Tewang Rangas',
  },
  {
    id: '6209060004',
    districtId: '6209060',
    name: 'Bangkuang',
  },
  {
    id: '6209060005',
    districtId: '6209060',
    name: 'Tarusan Danum',
  },
  {
    id: '6209060006',
    districtId: '6209060',
    name: 'Pendahara',
  },
  {
    id: '6209060007',
    districtId: '6209060',
    name: 'Tumbang Terusan',
  },
  {
    id: '6209060008',
    districtId: '6209060',
    name: 'Karya Unggang',
  },
  {
    id: '6209060009',
    districtId: '6209060',
    name: 'Tewang Rangkang',
  },
  {
    id: '6209060010',
    districtId: '6209060',
    name: 'Tewang Manyangen',
  },
  {
    id: '6209070001',
    districtId: '6209070',
    name: 'Tewang Papari',
  },
  {
    id: '6209070002',
    districtId: '6209070',
    name: 'Tewang Darayu',
  },
  {
    id: '6209070003',
    districtId: '6209070',
    name: 'Buntut Bali',
  },
  {
    id: '6209070004',
    districtId: '6209070',
    name: 'Kuluk Bali',
  },
  {
    id: '6209070005',
    districtId: '6209070',
    name: 'Manduing Taheta',
  },
  {
    id: '6209070006',
    districtId: '6209070',
    name: 'Manduing Lama',
  },
  {
    id: '6209070007',
    districtId: '6209070',
    name: 'Tumbang Banjang',
  },
  {
    id: '6209070008',
    districtId: '6209070',
    name: 'Tumbang Lawang',
  },
  {
    id: '6209070009',
    districtId: '6209070',
    name: 'Dahian Tunggal',
  },
  {
    id: '6209070010',
    districtId: '6209070',
    name: 'Tewang Karangan',
  },
  {
    id: '6209070011',
    districtId: '6209070',
    name: 'Tumbang Tungku',
  },
  {
    id: '6209070012',
    districtId: '6209070',
    name: 'Geragu',
  },
  {
    id: '6209070013',
    districtId: '6209070',
    name: 'Tumbang Tanjung',
  },
  {
    id: '6209070014',
    districtId: '6209070',
    name: 'Tura',
  },
  {
    id: '6209080001',
    districtId: '6209080',
    name: 'Mirah Kalanaman',
  },
  {
    id: '6209080002',
    districtId: '6209080',
    name: 'Tumbang Lahang',
  },
  {
    id: '6209080003',
    districtId: '6209080',
    name: 'Tewang Panjang',
  },
  {
    id: '6209080004',
    districtId: '6209080',
    name: 'Petak Puti',
  },
  {
    id: '6209080005',
    districtId: '6209080',
    name: 'Telok',
  },
  {
    id: '6209080006',
    districtId: '6209080',
    name: 'Samba Danum',
  },
  {
    id: '6209080007',
    districtId: '6209080',
    name: 'Samba Bakumpai',
  },
  {
    id: '6209080008',
    districtId: '6209080',
    name: 'Samba Katung',
  },
  {
    id: '6209080009',
    districtId: '6209080',
    name: 'Samba Kahayan',
  },
  {
    id: '6209080010',
    districtId: '6209080',
    name: 'Napu Sahur',
  },
  {
    id: '6209080011',
    districtId: '6209080',
    name: 'Batu Badinding',
  },
  {
    id: '6209080012',
    districtId: '6209080',
    name: 'Rantau Asem',
  },
  {
    id: '6209080013',
    districtId: '6209080',
    name: 'Tumbang Kalamei',
  },
  {
    id: '6209080014',
    districtId: '6209080',
    name: 'Tumbang Marak',
  },
  {
    id: '6209080015',
    districtId: '6209080',
    name: 'Tumbang Hangei',
  },
  {
    id: '6209080016',
    districtId: '6209080',
    name: 'Tumbang Pariyei',
  },
  {
    id: '6209090002',
    districtId: '6209090',
    name: 'Tumbang Labehu',
  },
  {
    id: '6209090003',
    districtId: '6209090',
    name: 'Tumbang Kaman',
  },
  {
    id: '6209090004',
    districtId: '6209090',
    name: 'Tumbang Manggo',
  },
  {
    id: '6209090005',
    districtId: '6209090',
    name: 'Kamanto',
  },
  {
    id: '6209090006',
    districtId: '6209090',
    name: 'Kuluk Habuhus',
  },
  {
    id: '6209090007',
    districtId: '6209090',
    name: 'Tumbang Kanei',
  },
  {
    id: '6209090008',
    districtId: '6209090',
    name: 'Tumbang Taranei',
  },
  {
    id: '6209090009',
    districtId: '6209090',
    name: 'Tumbang Pangka',
  },
  {
    id: '6209090010',
    districtId: '6209090',
    name: 'Tumbang Atei',
  },
  {
    id: '6209090011',
    districtId: '6209090',
    name: 'Tumbang Kawei',
  },
  {
    id: '6209090012',
    districtId: '6209090',
    name: 'Tumbang Mangara',
  },
  {
    id: '6209090020',
    districtId: '6209090',
    name: 'Daya Manunggal',
  },
  {
    id: '6209090021',
    districtId: '6209090',
    name: 'Rantau Bangkiang',
  },
  {
    id: '6209091001',
    districtId: '6209091',
    name: 'Tumbang Baraoi',
  },
  {
    id: '6209091002',
    districtId: '6209091',
    name: 'Batu Tukan',
  },
  {
    id: '6209091003',
    districtId: '6209091',
    name: 'Tumbang Tangoi',
  },
  {
    id: '6209091004',
    districtId: '6209091',
    name: 'Tumbang Jala',
  },
  {
    id: '6209091005',
    districtId: '6209091',
    name: 'Batu Badak',
  },
  {
    id: '6209091006',
    districtId: '6209091',
    name: 'Nusa Kutau',
  },
  {
    id: '6209091007',
    districtId: '6209091',
    name: 'Tumbang Habangoi',
  },
  {
    id: '6209100001',
    districtId: '6209100',
    name: 'Tumbang Mandurei',
  },
  {
    id: '6209100002',
    districtId: '6209100',
    name: 'Tumbang Paku',
  },
  {
    id: '6209100005',
    districtId: '6209100',
    name: 'Rangan Surai',
  },
  {
    id: '6209100006',
    districtId: '6209100',
    name: 'Tumbang Hiran',
  },
  {
    id: '6209100007',
    districtId: '6209100',
    name: 'Tumbang Pahanei',
  },
  {
    id: '6209100008',
    districtId: '6209100',
    name: 'Tumbang Dakei',
  },
  {
    id: '6209100009',
    districtId: '6209100',
    name: 'Rangan Burih',
  },
  {
    id: '6209100010',
    districtId: '6209100',
    name: 'Tumbang Bemban',
  },
  {
    id: '6209100011',
    districtId: '6209100',
    name: 'Tumbang Lambi',
  },
  {
    id: '6209100012',
    districtId: '6209100',
    name: 'Rangan Tangko',
  },
  {
    id: '6209100013',
    districtId: '6209100',
    name: 'Tumbang Taei',
  },
  {
    id: '6209100014',
    districtId: '6209100',
    name: 'Tumbang Malaman',
  },
  {
    id: '6209100015',
    districtId: '6209100',
    name: 'Sebaung',
  },
  {
    id: '6209100016',
    districtId: '6209100',
    name: 'Tumbang Tundu',
  },
  {
    id: '6209100017',
    districtId: '6209100',
    name: 'Tumbang Tabulus',
  },
  {
    id: '6209100018',
    districtId: '6209100',
    name: 'Batu Panahan',
  },
  {
    id: '6209110001',
    districtId: '6209110',
    name: 'Rangan Ranjing',
  },
  {
    id: '6209110002',
    districtId: '6209110',
    name: 'Tumbang Labaning',
  },
  {
    id: '6209110003',
    districtId: '6209110',
    name: 'Batu Bango',
  },
  {
    id: '6209110004',
    districtId: '6209110',
    name: 'Penda Tangaring Lama',
  },
  {
    id: '6209110005',
    districtId: '6209110',
    name: 'Penda Tangaring Baru',
  },
  {
    id: '6209110006',
    districtId: '6209110',
    name: 'Tumbang Hangei II',
  },
  {
    id: '6209110007',
    districtId: '6209110',
    name: 'Tumbang Jiga',
  },
  {
    id: '6209110008',
    districtId: '6209110',
    name: 'Tumbang Senamang',
  },
  {
    id: '6209110009',
    districtId: '6209110',
    name: 'Tumbang Kabayan',
  },
  {
    id: '6209110010',
    districtId: '6209110',
    name: 'Tumbang Mangketai',
  },
  {
    id: '6209110011',
    districtId: '6209110',
    name: 'Tumbang Manangei',
  },
  {
    id: '6209110012',
    districtId: '6209110',
    name: 'Tumbang Sabetung',
  },
  {
    id: '6209110013',
    districtId: '6209110',
    name: 'Tumbang Mahop',
  },
  {
    id: '6209110014',
    districtId: '6209110',
    name: 'Sei Nanjan',
  },
  {
    id: '6209110016',
    districtId: '6209110',
    name: 'Rantau Bahai',
  },
  {
    id: '6209110018',
    districtId: '6209110',
    name: 'Rantau Puka',
  },
  {
    id: '6209110020',
    districtId: '6209110',
    name: 'Telok Tampang',
  },
  {
    id: '6209110023',
    districtId: '6209110',
    name: 'Tumbang Salaman',
  },
  {
    id: '6209110025',
    districtId: '6209110',
    name: 'Tumbang Kuai',
  },
  {
    id: '6209110027',
    districtId: '6209110',
    name: 'Kuluk Sapangi',
  },
  {
    id: '6209110029',
    districtId: '6209110',
    name: 'Dehes Asem',
  },
  {
    id: '6209110031',
    districtId: '6209110',
    name: 'Rangan Kawit',
  },
  {
    id: '6209110033',
    districtId: '6209110',
    name: 'Kiham Batang',
  },
  {
    id: '6209111001',
    districtId: '6209111',
    name: 'Tumbang Kataei',
  },
  {
    id: '6209111002',
    districtId: '6209111',
    name: 'Tumbang Dahuei',
  },
  {
    id: '6209111003',
    districtId: '6209111',
    name: 'Rantau Pandan',
  },
  {
    id: '6209111004',
    districtId: '6209111',
    name: 'Tumbang Gaei',
  },
  {
    id: '6209111005',
    districtId: '6209111',
    name: 'Penda Nange',
  },
  {
    id: '6209111006',
    districtId: '6209111',
    name: 'Rangan Rondan',
  },
  {
    id: '6209111007',
    districtId: '6209111',
    name: 'Rangan Bahekang',
  },
  {
    id: '6209111008',
    districtId: '6209111',
    name: 'Tumbang Kajamei',
  },
  {
    id: '6209111009',
    districtId: '6209111',
    name: 'Tumbang Karuei',
  },
  {
    id: '6209111010',
    districtId: '6209111',
    name: 'Tanjung Batik',
  },
  {
    id: '6209111011',
    districtId: '6209111',
    name: 'Tumbang Kaburai',
  },
  {
    id: '6210010001',
    districtId: '6210010',
    name: 'Cemantan',
  },
  {
    id: '6210010002',
    districtId: '6210010',
    name: 'Papuyu III Sei Pudak',
  },
  {
    id: '6210010003',
    districtId: '6210010',
    name: 'Kiapak',
  },
  {
    id: '6210010004',
    districtId: '6210010',
    name: 'Papuyu II Sei Barunai',
  },
  {
    id: '6210010005',
    districtId: '6210010',
    name: 'Papuyu I Sei Pasanan',
  },
  {
    id: '6210010006',
    districtId: '6210010',
    name: 'Sei Rungun',
  },
  {
    id: '6210010007',
    districtId: '6210010',
    name: 'Bahaur Hilir',
  },
  {
    id: '6210010008',
    districtId: '6210010',
    name: 'Bahaur Tengah',
  },
  {
    id: '6210010009',
    districtId: '6210010',
    name: 'Bahaur Hulu',
  },
  {
    id: '6210010010',
    districtId: '6210010',
    name: 'Tanjung Perawan',
  },
  {
    id: '6210010011',
    districtId: '6210010',
    name: 'Bahaur Batu Raya',
  },
  {
    id: '6210010012',
    districtId: '6210010',
    name: 'Bahaur Hulu Permai',
  },
  {
    id: '6210010013',
    districtId: '6210010',
    name: 'Bahaur Basantan',
  },
  {
    id: '6210011001',
    districtId: '6210011',
    name: 'Paduran Sebangau',
  },
  {
    id: '6210011002',
    districtId: '6210011',
    name: 'Paduran Mulya',
  },
  {
    id: '6210011003',
    districtId: '6210011',
    name: 'Mekar Jaya',
  },
  {
    id: '6210011004',
    districtId: '6210011',
    name: 'Sebangau Permai',
  },
  {
    id: '6210011005',
    districtId: '6210011',
    name: 'Sebangau Jaya',
  },
  {
    id: '6210011006',
    districtId: '6210011',
    name: 'Sebangau Mulya',
  },
  {
    id: '6210011007',
    districtId: '6210011',
    name: 'Sei Bakau',
  },
  {
    id: '6210011008',
    districtId: '6210011',
    name: 'Sei Hambawang',
  },
  {
    id: '6210020001',
    districtId: '6210020',
    name: 'Dandang',
  },
  {
    id: '6210020002',
    districtId: '6210020',
    name: 'Talio',
  },
  {
    id: '6210020003',
    districtId: '6210020',
    name: 'Gadabung',
  },
  {
    id: '6210020004',
    districtId: '6210020',
    name: 'Belanti Siam',
  },
  {
    id: '6210020005',
    districtId: '6210020',
    name: 'Pangkoh Hilir',
  },
  {
    id: '6210020006',
    districtId: '6210020',
    name: 'Talio Muara',
  },
  {
    id: '6210020007',
    districtId: '6210020',
    name: 'Talio Hulu',
  },
  {
    id: '6210020008',
    districtId: '6210020',
    name: 'Pangkoh Sari',
  },
  {
    id: '6210020009',
    districtId: '6210020',
    name: 'Kantan Muara',
  },
  {
    id: '6210020010',
    districtId: '6210020',
    name: 'Pangkoh Hulu',
  },
  {
    id: '6210020011',
    districtId: '6210020',
    name: 'Sanggang',
  },
  {
    id: '6210020012',
    districtId: '6210020',
    name: 'Pantik',
  },
  {
    id: '6210020013',
    districtId: '6210020',
    name: 'Mulyasari',
  },
  {
    id: '6210020014',
    districtId: '6210020',
    name: 'Kantan Dalam',
  },
  {
    id: '6210020015',
    districtId: '6210020',
    name: 'Kantan Atas',
  },
  {
    id: '6210020016',
    districtId: '6210020',
    name: 'Karya Bersama',
  },
  {
    id: '6210030001',
    districtId: '6210030',
    name: 'Gandang',
  },
  {
    id: '6210030002',
    districtId: '6210030',
    name: 'Garantung',
  },
  {
    id: '6210030003',
    districtId: '6210030',
    name: 'Maliku Baru',
  },
  {
    id: '6210030004',
    districtId: '6210030',
    name: 'Badirih',
  },
  {
    id: '6210030005',
    districtId: '6210030',
    name: 'Tahai Jaya',
  },
  {
    id: '6210030006',
    districtId: '6210030',
    name: 'Tahai Baru',
  },
  {
    id: '6210030007',
    districtId: '6210030',
    name: 'Kanamit',
  },
  {
    id: '6210030008',
    districtId: '6210030',
    name: 'Purwodadi',
  },
  {
    id: '6210030009',
    districtId: '6210030',
    name: 'Wono Agung',
  },
  {
    id: '6210030010',
    districtId: '6210030',
    name: 'Kanamit Barat',
  },
  {
    id: '6210030011',
    districtId: '6210030',
    name: 'Sei Baru Tewu',
  },
  {
    id: '6210030012',
    districtId: '6210030',
    name: 'Sidodadi',
  },
  {
    id: '6210030013',
    districtId: '6210030',
    name: 'Kanamit Jaya',
  },
  {
    id: '6210030014',
    districtId: '6210030',
    name: 'Gandang Barat',
  },
  {
    id: '6210030015',
    districtId: '6210030',
    name: 'Maliku Mulya',
  },
  {
    id: '6210040001',
    districtId: '6210040',
    name: 'Buntoi',
  },
  {
    id: '6210040002',
    districtId: '6210040',
    name: 'Mintin',
  },
  {
    id: '6210040003',
    districtId: '6210040',
    name: 'Mantaren II',
  },
  {
    id: '6210040004',
    districtId: '6210040',
    name: 'Mantaren I',
  },
  {
    id: '6210040005',
    districtId: '6210040',
    name: 'Pulang Pisau',
  },
  {
    id: '6210040006',
    districtId: '6210040',
    name: 'Anjir Pulang Pisau',
  },
  {
    id: '6210040007',
    districtId: '6210040',
    name: 'Gohong',
  },
  {
    id: '6210040008',
    districtId: '6210040',
    name: 'Kalawa',
  },
  {
    id: '6210040009',
    districtId: '6210040',
    name: 'Hanjak Maju',
  },
  {
    id: '6210041001',
    districtId: '6210041',
    name: 'Garung',
  },
  {
    id: '6210041002',
    districtId: '6210041',
    name: 'Henda',
  },
  {
    id: '6210041003',
    districtId: '6210041',
    name: 'Simpur',
  },
  {
    id: '6210041004',
    districtId: '6210041',
    name: 'Sakakajang',
  },
  {
    id: '6210041005',
    districtId: '6210041',
    name: 'Jabiren',
  },
  {
    id: '6210041006',
    districtId: '6210041',
    name: 'Pilang',
  },
  {
    id: '6210041007',
    districtId: '6210041',
    name: 'Tumbang Nusa',
  },
  {
    id: '6210041008',
    districtId: '6210041',
    name: 'Tanjung Taruna',
  },
  {
    id: '6210050001',
    districtId: '6210050',
    name: 'Tanjung Sanggalang',
  },
  {
    id: '6210050002',
    districtId: '6210050',
    name: 'Penda Barania',
  },
  {
    id: '6210050003',
    districtId: '6210050',
    name: 'Bukit Rawi',
  },
  {
    id: '6210050005',
    districtId: '6210050',
    name: 'Sigi',
  },
  {
    id: '6210050006',
    districtId: '6210050',
    name: 'Petuk Liti',
  },
  {
    id: '6210050007',
    districtId: '6210050',
    name: 'Bukit Liti',
  },
  {
    id: '6210050008',
    districtId: '6210050',
    name: 'Bahu Palawa',
  },
  {
    id: '6210050009',
    districtId: '6210050',
    name: 'Pamarunan',
  },
  {
    id: '6210050010',
    districtId: '6210050',
    name: 'Balukon',
  },
  {
    id: '6210050011',
    districtId: '6210050',
    name: 'Bukit Bamba',
  },
  {
    id: '6210050012',
    districtId: '6210050',
    name: 'Tahawa',
  },
  {
    id: '6210050013',
    districtId: '6210050',
    name: 'Parahangan',
  },
  {
    id: '6210050014',
    districtId: '6210050',
    name: 'Bereng Rambang',
  },
  {
    id: '6210060001',
    districtId: '6210060',
    name: 'Manen Paduran',
  },
  {
    id: '6210060002',
    districtId: '6210060',
    name: 'Manen Kaleka',
  },
  {
    id: '6210060003',
    districtId: '6210060',
    name: 'Lawang Uru',
  },
  {
    id: '6210060005',
    districtId: '6210060',
    name: 'Hanua',
  },
  {
    id: '6210060006',
    districtId: '6210060',
    name: 'Ramang',
  },
  {
    id: '6210060007',
    districtId: '6210060',
    name: 'Tambak',
  },
  {
    id: '6210060008',
    districtId: '6210060',
    name: 'Pahawan',
  },
  {
    id: '6210060009',
    districtId: '6210060',
    name: 'Goha',
  },
  {
    id: '6210060010',
    districtId: '6210060',
    name: 'Bawan',
  },
  {
    id: '6210060011',
    districtId: '6210060',
    name: 'Tumbang Tarusan',
  },
  {
    id: '6210060012',
    districtId: '6210060',
    name: 'Pandawei',
  },
  {
    id: '6210060013',
    districtId: '6210060',
    name: 'Pangi',
  },
  {
    id: '6210060014',
    districtId: '6210060',
    name: 'Tangkahen',
  },
  {
    id: '6210060015',
    districtId: '6210060',
    name: 'Kasali Baru',
  },
  {
    id: '6211010001',
    districtId: '6211010',
    name: 'Takaras',
  },
  {
    id: '6211010003',
    districtId: '6211010',
    name: 'Fajar Harapan',
  },
  {
    id: '6211010005',
    districtId: '6211010',
    name: 'Bangun Sari',
  },
  {
    id: '6211010006',
    districtId: '6211010',
    name: 'Belawan Mulya',
  },
  {
    id: '6211010007',
    districtId: '6211010',
    name: 'Bereng Belawan',
  },
  {
    id: '6211010008',
    districtId: '6211010',
    name: 'Tumbang Sepan',
  },
  {
    id: '6211010009',
    districtId: '6211010',
    name: 'Tumbang Talaken',
  },
  {
    id: '6211010010',
    districtId: '6211010',
    name: 'Tangki Dahuyan',
  },
  {
    id: '6211010011',
    districtId: '6211010',
    name: 'Tumbang Jalemu',
  },
  {
    id: '6211010012',
    districtId: '6211010',
    name: 'Taringen',
  },
  {
    id: '6211010013',
    districtId: '6211010',
    name: 'Gohong',
  },
  {
    id: '6211011001',
    districtId: '6211011',
    name: 'Tumbang Samui',
  },
  {
    id: '6211011002',
    districtId: '6211011',
    name: 'Tumbang Oroi',
  },
  {
    id: '6211011003',
    districtId: '6211011',
    name: 'Luwuk Tukau',
  },
  {
    id: '6211011004',
    districtId: '6211011',
    name: 'Tehang',
  },
  {
    id: '6211011005',
    districtId: '6211011',
    name: 'Tumbang Mantuhe',
  },
  {
    id: '6211011006',
    districtId: '6211011',
    name: 'Putat Durei',
  },
  {
    id: '6211020001',
    districtId: '6211020',
    name: 'Parempei',
  },
  {
    id: '6211020002',
    districtId: '6211020',
    name: 'Talangkah',
  },
  {
    id: '6211020003',
    districtId: '6211020',
    name: 'Luwuk Langkuas',
  },
  {
    id: '6211020004',
    districtId: '6211020',
    name: 'Tumbang Kajuei',
  },
  {
    id: '6211020005',
    districtId: '6211020',
    name: 'Luwuk Kantor',
  },
  {
    id: '6211020006',
    districtId: '6211020',
    name: 'Tumbang Bunut',
  },
  {
    id: '6211020008',
    districtId: '6211020',
    name: 'Tumbang Jutuh',
  },
  {
    id: '6211020009',
    districtId: '6211020',
    name: 'Linau',
  },
  {
    id: '6211020010',
    districtId: '6211020',
    name: 'Tumbang Baringei',
  },
  {
    id: '6211020011',
    districtId: '6211020',
    name: 'Tumbang Malahoi',
  },
  {
    id: '6211020015',
    districtId: '6211020',
    name: 'Jakatan Raya',
  },
  {
    id: '6211020016',
    districtId: '6211020',
    name: 'Bereng Baru',
  },
  {
    id: '6211020017',
    districtId: '6211020',
    name: 'Bereng Malaka',
  },
  {
    id: '6211020020',
    districtId: '6211020',
    name: 'Karya  Bakti',
  },
  {
    id: '6211021001',
    districtId: '6211021',
    name: 'Jangkit',
  },
  {
    id: '6211021003',
    districtId: '6211021',
    name: 'Tumbang Lapan',
  },
  {
    id: '6211021004',
    districtId: '6211021',
    name: 'Sangal',
  },
  {
    id: '6211021006',
    districtId: '6211021',
    name: 'Batu Puter',
  },
  {
    id: '6211021007',
    districtId: '6211021',
    name: 'Tumbang Rahuyan',
  },
  {
    id: '6211021008',
    districtId: '6211021',
    name: 'Hantapang',
  },
  {
    id: '6211021009',
    districtId: '6211021',
    name: 'Tumbang Mujai',
  },
  {
    id: '6211021010',
    districtId: '6211021',
    name: 'Sei Antai',
  },
  {
    id: '6211021011',
    districtId: '6211021',
    name: 'Tumbang Tuwe',
  },
  {
    id: '6211022001',
    districtId: '6211022',
    name: 'Hujung Pata',
  },
  {
    id: '6211022002',
    districtId: '6211022',
    name: 'Tumbang Jalemu Kajuei',
  },
  {
    id: '6211022003',
    districtId: '6211022',
    name: 'Jalemu  Raya',
  },
  {
    id: '6211022004',
    districtId: '6211022',
    name: 'Jalemu Masulan',
  },
  {
    id: '6211022005',
    districtId: '6211022',
    name: 'Tajah Antang Raya',
  },
  {
    id: '6211022006',
    districtId: '6211022',
    name: 'Rabambang',
  },
  {
    id: '6211022007',
    districtId: '6211022',
    name: 'Mangkawuk',
  },
  {
    id: '6211022008',
    districtId: '6211022',
    name: 'Tumbang Kuayan',
  },
  {
    id: '6211022009',
    districtId: '6211022',
    name: 'Tumbang Langgah',
  },
  {
    id: '6211022010',
    districtId: '6211022',
    name: 'Tusang  Raya',
  },
  {
    id: '6211022011',
    districtId: '6211022',
    name: 'Tumbang Bahanei',
  },
  {
    id: '6211030001',
    districtId: '6211030',
    name: 'Pematang Limau',
  },
  {
    id: '6211030002',
    districtId: '6211030',
    name: 'Tampelas',
  },
  {
    id: '6211030003',
    districtId: '6211030',
    name: 'Sepang Kota',
  },
  {
    id: '6211030004',
    districtId: '6211030',
    name: 'Sepang Simin',
  },
  {
    id: '6211030005',
    districtId: '6211030',
    name: 'Tewai Baru',
  },
  {
    id: '6211030006',
    districtId: '6211030',
    name: 'Tanjung Karitak',
  },
  {
    id: '6211030007',
    districtId: '6211030',
    name: 'Rabauh',
  },
  {
    id: '6211031002',
    districtId: '6211031',
    name: 'Tumbang Empas',
  },
  {
    id: '6211031003',
    districtId: '6211031',
    name: 'Rangan Tate',
  },
  {
    id: '6211031004',
    districtId: '6211031',
    name: 'Kampuri',
  },
  {
    id: '6211031005',
    districtId: '6211031',
    name: 'Tumbang Danau',
  },
  {
    id: '6211031006',
    districtId: '6211031',
    name: 'Dahian Tambuk',
  },
  {
    id: '6211040001',
    districtId: '6211040',
    name: 'Pilang Munduk',
  },
  {
    id: '6211040002',
    districtId: '6211040',
    name: 'Tumbang Hakau',
  },
  {
    id: '6211040004',
    districtId: '6211040',
    name: 'Tumbang Tariak',
  },
  {
    id: '6211040005',
    districtId: '6211040',
    name: 'Tumbang Miwan',
  },
  {
    id: '6211040006',
    districtId: '6211040',
    name: 'Tewang Pajangan',
  },
  {
    id: '6211040007',
    districtId: '6211040',
    name: 'Tumbang Lampahung',
  },
  {
    id: '6211040008',
    districtId: '6211040',
    name: 'Teluk Nyatu',
  },
  {
    id: '6211040009',
    districtId: '6211040',
    name: 'Tanjung Riu',
  },
  {
    id: '6211040010',
    districtId: '6211040',
    name: 'Petak Bahandang',
  },
  {
    id: '6211040011',
    districtId: '6211040',
    name: 'Tampang Tumbang Anjir',
  },
  {
    id: '6211040012',
    districtId: '6211040',
    name: 'Kuala Kurun',
  },
  {
    id: '6211040013',
    districtId: '6211040',
    name: 'Tumbang Tambirah',
  },
  {
    id: '6211040014',
    districtId: '6211040',
    name: 'Tumbang Manyangan',
  },
  {
    id: '6211040015',
    districtId: '6211040',
    name: 'Penda Pilang',
  },
  {
    id: '6211050001',
    districtId: '6211050',
    name: 'Sarerangan',
  },
  {
    id: '6211050002',
    districtId: '6211050',
    name: 'Tumbang Pajangei',
  },
  {
    id: '6211050003',
    districtId: '6211050',
    name: 'Sumur Mas',
  },
  {
    id: '6211050004',
    districtId: '6211050',
    name: 'Tewah',
  },
  {
    id: '6211050005',
    districtId: '6211050',
    name: 'Kasintu',
  },
  {
    id: '6211050006',
    districtId: '6211050',
    name: 'Upon Batu',
  },
  {
    id: '6211050007',
    districtId: '6211050',
    name: 'Batu Nyiwuh',
  },
  {
    id: '6211050008',
    districtId: '6211050',
    name: 'Tumbang Habaon',
  },
  {
    id: '6211050009',
    districtId: '6211050',
    name: 'Tanjung Untung',
  },
  {
    id: '6211050010',
    districtId: '6211050',
    name: 'Sandung Tambun',
  },
  {
    id: '6211050011',
    districtId: '6211050',
    name: 'Sei Riang',
  },
  {
    id: '6211050012',
    districtId: '6211050',
    name: 'Batu  Nyapau',
  },
  {
    id: '6211050013',
    districtId: '6211050',
    name: 'Rangan Mihing',
  },
  {
    id: '6211050014',
    districtId: '6211050',
    name: 'Teluk Lawah',
  },
  {
    id: '6211050015',
    districtId: '6211050',
    name: 'Taja Urap',
  },
  {
    id: '6211050016',
    districtId: '6211050',
    name: 'Karason',
  },
  {
    id: '6211060005',
    districtId: '6211060',
    name: 'Tumbang Hamputung',
  },
  {
    id: '6211060006',
    districtId: '6211060',
    name: 'Batu Tangkui',
  },
  {
    id: '6211060007',
    districtId: '6211060',
    name: 'Tumbang Pasangon',
  },
  {
    id: '6211060008',
    districtId: '6211060',
    name: 'Tumbang Miri',
  },
  {
    id: '6211060009',
    districtId: '6211060',
    name: 'Dandang',
  },
  {
    id: '6211060010',
    districtId: '6211060',
    name: 'Penda Rangas',
  },
  {
    id: '6211060011',
    districtId: '6211060',
    name: 'Tumbang Tajungan',
  },
  {
    id: '6211060012',
    districtId: '6211060',
    name: 'Tumbang Takaoi',
  },
  {
    id: '6211060015',
    districtId: '6211060',
    name: 'Tumbang Korik',
  },
  {
    id: '6211060016',
    districtId: '6211060',
    name: 'Tumbang Sian',
  },
  {
    id: '6211060019',
    districtId: '6211060',
    name: 'Tumbang Ponyoi',
  },
  {
    id: '6211060020',
    districtId: '6211060',
    name: 'Teluk Kenduri',
  },
  {
    id: '6211061001',
    districtId: '6211061',
    name: 'Lawang Kanji',
  },
  {
    id: '6211061002',
    districtId: '6211061',
    name: 'Tumbang Maraya',
  },
  {
    id: '6211061003',
    districtId: '6211061',
    name: 'Tumbang Posu',
  },
  {
    id: '6211061004',
    districtId: '6211061',
    name: 'Tumbang Marikoi',
  },
  {
    id: '6211061005',
    districtId: '6211061',
    name: 'Karetau Rambangun',
  },
  {
    id: '6211061006',
    districtId: '6211061',
    name: 'Tumbang Anoi',
  },
  {
    id: '6211061007',
    districtId: '6211061',
    name: 'Karetau Sarian',
  },
  {
    id: '6211061008',
    districtId: '6211061',
    name: 'Tumbang Mahuroi',
  },
  {
    id: '6211062001',
    districtId: '6211062',
    name: 'Tumbang Lapan',
  },
  {
    id: '6211062002',
    districtId: '6211062',
    name: 'Tumbang Siruk',
  },
  {
    id: '6211062003',
    districtId: '6211062',
    name: 'Tumbang Napoi',
  },
  {
    id: '6211062004',
    districtId: '6211062',
    name: 'Buntoi',
  },
  {
    id: '6211062005',
    districtId: '6211062',
    name: 'Tumbang Koroi',
  },
  {
    id: '6211062006',
    districtId: '6211062',
    name: 'Mangkuhung',
  },
  {
    id: '6211062007',
    districtId: '6211062',
    name: 'Tumbang Manyoi',
  },
  {
    id: '6211062008',
    districtId: '6211062',
    name: 'Tumbang Masukih',
  },
  {
    id: '6211062009',
    districtId: '6211062',
    name: 'Rangan Hiran',
  },
  {
    id: '6211062010',
    districtId: '6211062',
    name: 'Harowu',
  },
  {
    id: '6211062011',
    districtId: '6211062',
    name: 'Tumbang Hatung',
  },
  {
    id: '6212010001',
    districtId: '6212010',
    name: 'Taniran',
  },
  {
    id: '6212010002',
    districtId: '6212010',
    name: 'Kandris',
  },
  {
    id: '6212010003',
    districtId: '6212010',
    name: 'Banyu Landas',
  },
  {
    id: '6212010004',
    districtId: '6212010',
    name: 'Bagok',
  },
  {
    id: '6212010005',
    districtId: '6212010',
    name: 'Bamban',
  },
  {
    id: '6212010006',
    districtId: '6212010',
    name: 'Tewah Pupuh',
  },
  {
    id: '6212010007',
    districtId: '6212010',
    name: 'Gudang Seng',
  },
  {
    id: '6212020001',
    districtId: '6212020',
    name: 'Pulau Patai',
  },
  {
    id: '6212020002',
    districtId: '6212020',
    name: 'Sarapat (Ex Harara)',
  },
  {
    id: '6212020003',
    districtId: '6212020',
    name: 'Magantis',
  },
  {
    id: '6212020004',
    districtId: '6212020',
    name: 'Jaar',
  },
  {
    id: '6212020005',
    districtId: '6212020',
    name: 'Matabu',
  },
  {
    id: '6212020006',
    districtId: '6212020',
    name: 'Tamiang Layang',
  },
  {
    id: '6212020007',
    districtId: '6212020',
    name: 'Jaweten',
  },
  {
    id: '6212020008',
    districtId: '6212020',
    name: 'Haringen',
  },
  {
    id: '6212020009',
    districtId: '6212020',
    name: 'Dorong',
  },
  {
    id: '6212020010',
    districtId: '6212020',
    name: 'Didi',
  },
  {
    id: '6212020011',
    districtId: '6212020',
    name: 'Karang Langit',
  },
  {
    id: '6212020012',
    districtId: '6212020',
    name: 'Harara',
  },
  {
    id: '6212020013',
    districtId: '6212020',
    name: 'Mangkarap',
  },
  {
    id: '6212020014',
    districtId: '6212020',
    name: 'Matarah',
  },
  {
    id: '6212020015',
    districtId: '6212020',
    name: 'Gumpa',
  },
  {
    id: '6212020016',
    districtId: '6212020',
    name: 'Maragut',
  },
  {
    id: '6212021001',
    districtId: '6212021',
    name: 'Telang',
  },
  {
    id: '6212021003',
    districtId: '6212021',
    name: 'Balawa',
  },
  {
    id: '6212021004',
    districtId: '6212021',
    name: 'Maipe',
  },
  {
    id: '6212021005',
    districtId: '6212021',
    name: 'Telang Baru',
  },
  {
    id: '6212021006',
    districtId: '6212021',
    name: 'Juru Banu',
  },
  {
    id: '6212021007',
    districtId: '6212021',
    name: 'Tampu Langit',
  },
  {
    id: '6212021008',
    districtId: '6212021',
    name: 'Siong',
  },
  {
    id: '6212021009',
    districtId: '6212021',
    name: 'Kalinapu',
  },
  {
    id: '6212030001',
    districtId: '6212030',
    name: 'Janah Jari',
  },
  {
    id: '6212030002',
    districtId: '6212030',
    name: 'Bangkirayen',
  },
  {
    id: '6212030003',
    districtId: '6212030',
    name: 'Tangkan',
  },
  {
    id: '6212030004',
    districtId: '6212030',
    name: 'Ampari',
  },
  {
    id: '6212030005',
    districtId: '6212030',
    name: 'Wungkur Nanakan',
  },
  {
    id: '6212030006',
    districtId: '6212030',
    name: 'Hayaping',
  },
  {
    id: '6212030007',
    districtId: '6212030',
    name: 'Biwan',
  },
  {
    id: '6212030008',
    districtId: '6212030',
    name: 'Apar Batu',
  },
  {
    id: '6212030009',
    districtId: '6212030',
    name: 'Pianggu',
  },
  {
    id: '6212030010',
    districtId: '6212030',
    name: 'Danau',
  },
  {
    id: '6212030011',
    districtId: '6212030',
    name: 'Janah Mansiwui',
  },
  {
    id: '6212040001',
    districtId: '6212040',
    name: 'Pulau Padang',
  },
  {
    id: '6212040002',
    districtId: '6212040',
    name: 'Ramania',
  },
  {
    id: '6212040003',
    districtId: '6212040',
    name: 'Kambitin',
  },
  {
    id: '6212040004',
    districtId: '6212040',
    name: 'Bentot',
  },
  {
    id: '6212040005',
    districtId: '6212040',
    name: 'Ampari Bora',
  },
  {
    id: '6212040006',
    districtId: '6212040',
    name: 'Kotam',
  },
  {
    id: '6212040007',
    districtId: '6212040',
    name: 'Betang Nalong',
  },
  {
    id: '6212040008',
    districtId: '6212040',
    name: 'Mawani',
  },
  {
    id: '6212040009',
    districtId: '6212040',
    name: 'Jango',
  },
  {
    id: '6212040010',
    districtId: '6212040',
    name: 'Lalap',
  },
  {
    id: '6212050004',
    districtId: '6212050',
    name: 'Saing',
  },
  {
    id: '6212050005',
    districtId: '6212050',
    name: 'Rodok',
  },
  {
    id: '6212050006',
    districtId: '6212050',
    name: 'Ampah Dua',
  },
  {
    id: '6212050007',
    districtId: '6212050',
    name: 'Putai',
  },
  {
    id: '6212050008',
    districtId: '6212050',
    name: 'Ampah Kota',
  },
  {
    id: '6212050009',
    districtId: '6212050',
    name: 'Netampin',
  },
  {
    id: '6212050010',
    districtId: '6212050',
    name: 'Sumber Garunggung',
  },
  {
    id: '6212050011',
    districtId: '6212050',
    name: 'Muara Awang',
  },
  {
    id: '6212051002',
    districtId: '6212051',
    name: 'Baruyan',
  },
  {
    id: '6212051003',
    districtId: '6212051',
    name: 'Lenggang',
  },
  {
    id: '6212051004',
    districtId: '6212051',
    name: 'Puri',
  },
  {
    id: '6212051005',
    districtId: '6212051',
    name: 'Batuah',
  },
  {
    id: '6212051006',
    districtId: '6212051',
    name: 'Turan Amis',
  },
  {
    id: '6212051007',
    districtId: '6212051',
    name: 'Tangkum',
  },
  {
    id: '6212051008',
    districtId: '6212051',
    name: 'Sibung',
  },
  {
    id: '6212051009',
    districtId: '6212051',
    name: 'Malintut',
  },
  {
    id: '6212052001',
    districtId: '6212052',
    name: 'Tampa',
  },
  {
    id: '6212052002',
    districtId: '6212052',
    name: 'Runggu Raya',
  },
  {
    id: '6212052003',
    districtId: '6212052',
    name: 'Patung',
  },
  {
    id: '6212052004',
    districtId: '6212052',
    name: 'Kalamus',
  },
  {
    id: '6212052005',
    districtId: '6212052',
    name: 'Simpang Bingkuang',
  },
  {
    id: '6212052006',
    districtId: '6212052',
    name: 'Kupang Baru',
  },
  {
    id: '6212052007',
    districtId: '6212052',
    name: 'Luau Jawuk',
  },
  {
    id: '6212052008',
    districtId: '6212052',
    name: 'Tarinsing',
  },
  {
    id: '6212052009',
    districtId: '6212052',
    name: 'Bantai Napu',
  },
  {
    id: '6212052010',
    districtId: '6212052',
    name: 'Pangkan',
  },
  {
    id: '6212052011',
    districtId: '6212052',
    name: 'Gandrung',
  },
  {
    id: '6212052012',
    districtId: '6212052',
    name: 'Paku Beto',
  },
  {
    id: '6212053001',
    districtId: '6212053',
    name: 'Dayu',
  },
  {
    id: '6212053002',
    districtId: '6212053',
    name: 'Wuran',
  },
  {
    id: '6212053003',
    districtId: '6212053',
    name: 'Ipu Mea',
  },
  {
    id: '6212053004',
    districtId: '6212053',
    name: 'Simpang Naneng',
  },
  {
    id: '6212053005',
    districtId: '6212053',
    name: 'Lagan',
  },
  {
    id: '6212053006',
    districtId: '6212053',
    name: 'Putut Tawuluh',
  },
  {
    id: '6212053007',
    districtId: '6212053',
    name: 'Kandris',
  },
  {
    id: '6212060001',
    districtId: '6212060',
    name: 'Muara Palantau',
  },
  {
    id: '6212060002',
    districtId: '6212060',
    name: 'Ketab',
  },
  {
    id: '6212060003',
    districtId: '6212060',
    name: 'Kupang Bersih',
  },
  {
    id: '6212060004',
    districtId: '6212060',
    name: 'Tuyau',
  },
  {
    id: '6212060005',
    districtId: '6212060',
    name: 'Pinang Tunggal',
  },
  {
    id: '6212060006',
    districtId: '6212060',
    name: 'Nagaleah',
  },
  {
    id: '6212060007',
    districtId: '6212060',
    name: 'Lampeong',
  },
  {
    id: '6212060008',
    districtId: '6212060',
    name: 'Bararawa',
  },
  {
    id: '6212060009',
    districtId: '6212060',
    name: 'Bambulung',
  },
  {
    id: '6212060010',
    districtId: '6212060',
    name: 'Lebo',
  },
  {
    id: '6212060013',
    districtId: '6212060',
    name: 'Sumberejo',
  },
  {
    id: '6213010001',
    districtId: '6213010',
    name: 'Sungai Lobang',
  },
  {
    id: '6213010002',
    districtId: '6213010',
    name: 'Sungai Gula',
  },
  {
    id: '6213010003',
    districtId: '6213010',
    name: 'Sungai Batang',
  },
  {
    id: '6213010004',
    districtId: '6213010',
    name: 'Tumbang Salio',
  },
  {
    id: '6213010005',
    districtId: '6213010',
    name: 'Muara Bakanon',
  },
  {
    id: '6213010006',
    districtId: '6213010',
    name: 'Purnama',
  },
  {
    id: '6213010007',
    districtId: '6213010',
    name: 'Tumbang Lahung',
  },
  {
    id: '6213010008',
    districtId: '6213010',
    name: 'Muara Babuat',
  },
  {
    id: '6213010009',
    districtId: '6213010',
    name: 'Juking Supan',
  },
  {
    id: '6213010010',
    districtId: '6213010',
    name: 'Beratu',
  },
  {
    id: '6213010011',
    districtId: '6213010',
    name: 'Pantai Laga',
  },
  {
    id: '6213010018',
    districtId: '6213010',
    name: 'Sei Bakanon',
  },
  {
    id: '6213011001',
    districtId: '6213011',
    name: 'Batu Mirau',
  },
  {
    id: '6213011002',
    districtId: '6213011',
    name: 'Tumbang Bantian',
  },
  {
    id: '6213011003',
    districtId: '6213011',
    name: 'Tumbang Saan',
  },
  {
    id: '6213011004',
    districtId: '6213011',
    name: 'Tumbang Kolon',
  },
  {
    id: '6213011005',
    districtId: '6213011',
    name: 'Tambelum',
  },
  {
    id: '6213011006',
    districtId: '6213011',
    name: 'Tumbang Apat',
  },
  {
    id: '6213020001',
    districtId: '6213020',
    name: 'Dirung',
  },
  {
    id: '6213020002',
    districtId: '6213020',
    name: 'Malasan',
  },
  {
    id: '6213020003',
    districtId: '6213020',
    name: 'Batu Putih',
  },
  {
    id: '6213020004',
    districtId: '6213020',
    name: 'Mangkahui',
  },
  {
    id: '6213020005',
    districtId: '6213020',
    name: "Panu'Ut",
  },
  {
    id: '6213020006',
    districtId: '6213020',
    name: 'Muara Untu',
  },
  {
    id: '6213020007',
    districtId: '6213020',
    name: 'Muara Jaan',
  },
  {
    id: '6213020008',
    districtId: '6213020',
    name: 'Bahitom',
  },
  {
    id: '6213020009',
    districtId: '6213020',
    name: 'Danau Usung',
  },
  {
    id: '6213020010',
    districtId: '6213020',
    name: 'Juking Pajang',
  },
  {
    id: '6213020011',
    districtId: '6213020',
    name: 'Beriwit',
  },
  {
    id: '6213020012',
    districtId: '6213020',
    name: 'Puruk Cahu',
  },
  {
    id: '6213020013',
    districtId: '6213020',
    name: 'Muara Sumpoi',
  },
  {
    id: '6213020014',
    districtId: '6213020',
    name: 'Muara Bumban',
  },
  {
    id: '6213020015',
    districtId: '6213020',
    name: 'Penyang',
  },
  {
    id: '6213030001',
    districtId: '6213030',
    name: 'Batu Tuhup',
  },
  {
    id: '6213030002',
    districtId: '6213030',
    name: 'Tumbang Bahan',
  },
  {
    id: '6213030003',
    districtId: '6213030',
    name: 'Muara Laung I',
  },
  {
    id: '6213030004',
    districtId: '6213030',
    name: 'Muara Laung II',
  },
  {
    id: '6213030005',
    districtId: '6213030',
    name: 'Beras Belange',
  },
  {
    id: '6213030006',
    districtId: '6213030',
    name: 'Muara Tuhup',
  },
  {
    id: '6213030011',
    districtId: '6213030',
    name: 'Biha',
  },
  {
    id: '6213030012',
    districtId: '6213030',
    name: 'Dirung Pundu',
  },
  {
    id: '6213030013',
    districtId: '6213030',
    name: 'Pelaci',
  },
  {
    id: '6213030016',
    districtId: '6213030',
    name: 'Dirung Pinang',
  },
  {
    id: '6213030017',
    districtId: '6213030',
    name: 'Muara Tupuh',
  },
  {
    id: '6213030022',
    districtId: '6213030',
    name: 'Tawai Haui',
  },
  {
    id: '6213030023',
    districtId: '6213030',
    name: 'Lakutan',
  },
  {
    id: '6213030024',
    districtId: '6213030',
    name: 'Tumbang Bana',
  },
  {
    id: '6213030025',
    districtId: '6213030',
    name: 'Narui',
  },
  {
    id: '6213030026',
    districtId: '6213030',
    name: 'Muara Maruwei I',
  },
  {
    id: '6213030027',
    districtId: '6213030',
    name: 'Muara Maruwei II',
  },
  {
    id: '6213030028',
    districtId: '6213030',
    name: 'Penda Siron',
  },
  {
    id: '6213030029',
    districtId: '6213030',
    name: 'Batu Bua II',
  },
  {
    id: '6213030030',
    districtId: '6213030',
    name: 'Batu Bua I',
  },
  {
    id: '6213030031',
    districtId: '6213030',
    name: 'Tahujan Laung',
  },
  {
    id: '6213030032',
    districtId: '6213030',
    name: 'Kalang Duhung',
  },
  {
    id: '6213030033',
    districtId: '6213030',
    name: 'Beralang',
  },
  {
    id: '6213030034',
    districtId: '6213030',
    name: 'Tumbang Bondang',
  },
  {
    id: '6213030035',
    districtId: '6213030',
    name: 'Tumbang Tonduk',
  },
  {
    id: '6213030036',
    districtId: '6213030',
    name: 'Batu Karang',
  },
  {
    id: '6213031001',
    districtId: '6213031',
    name: 'Makunjung',
  },
  {
    id: '6213031002',
    districtId: '6213031',
    name: 'Cinta Budiman',
  },
  {
    id: '6213031003',
    districtId: '6213031',
    name: 'Bumban Tuhup',
  },
  {
    id: '6213031004',
    districtId: '6213031',
    name: 'Dirung Sararong',
  },
  {
    id: '6213031005',
    districtId: '6213031',
    name: 'Kohong',
  },
  {
    id: '6213031006',
    districtId: '6213031',
    name: 'Liang Nyaling',
  },
  {
    id: '6213031007',
    districtId: '6213031',
    name: 'Tumbang Masalo',
  },
  {
    id: '6213031008',
    districtId: '6213031',
    name: 'Tumbang Bauh',
  },
  {
    id: '6213031009',
    districtId: '6213031',
    name: 'Hingan Tokung',
  },
  {
    id: '6213031010',
    districtId: '6213031',
    name: 'Batu Tojah',
  },
  {
    id: '6213031011',
    districtId: '6213031',
    name: 'Tumbang Baloi',
  },
  {
    id: '6213040007',
    districtId: '6213040',
    name: 'Sungai Lunuk',
  },
  {
    id: '6213040008',
    districtId: '6213040',
    name: 'Tino Talih',
  },
  {
    id: '6213040009',
    districtId: '6213040',
    name: 'Olong Nango',
  },
  {
    id: '6213040010',
    districtId: '6213040',
    name: 'Dirung Bakung',
  },
  {
    id: '6213040011',
    districtId: '6213040',
    name: 'Tabulang',
  },
  {
    id: '6213040012',
    districtId: '6213040',
    name: 'Mahanyan',
  },
  {
    id: '6213040013',
    districtId: '6213040',
    name: 'Olong Dojou',
  },
  {
    id: '6213040014',
    districtId: '6213040',
    name: 'Olong Siron',
  },
  {
    id: '6213040015',
    districtId: '6213040',
    name: 'Konut',
  },
  {
    id: '6213040016',
    districtId: '6213040',
    name: 'Belawan',
  },
  {
    id: '6213040017',
    districtId: '6213040',
    name: 'Mangkolisoi',
  },
  {
    id: '6213040018',
    districtId: '6213040',
    name: 'Kalang Kaluh',
  },
  {
    id: '6213040019',
    districtId: '6213040',
    name: 'Mantiat Pari',
  },
  {
    id: '6213040020',
    districtId: '6213040',
    name: 'Olong Ulu',
  },
  {
    id: '6213040021',
    districtId: '6213040',
    name: 'Saripoi',
  },
  {
    id: '6213040022',
    districtId: '6213040',
    name: 'Puruk Batu',
  },
  {
    id: '6213040023',
    districtId: '6213040',
    name: 'Doan Arung',
  },
  {
    id: '6213040024',
    districtId: '6213040',
    name: 'Cangkang',
  },
  {
    id: '6213040026',
    districtId: '6213040',
    name: 'Kolam',
  },
  {
    id: '6213040027',
    districtId: '6213040',
    name: 'Nonokaliwon',
  },
  {
    id: '6213040028',
    districtId: '6213040',
    name: 'Saruhung',
  },
  {
    id: '6213040029',
    districtId: '6213040',
    name: 'Olong Soloi',
  },
  {
    id: '6213040030',
    districtId: '6213040',
    name: 'Tokung',
  },
  {
    id: '6213040031',
    districtId: '6213040',
    name: 'Olong Balo',
  },
  {
    id: '6213040032',
    districtId: '6213040',
    name: 'Karali',
  },
  {
    id: '6213040033',
    districtId: '6213040',
    name: 'Osom Tompok',
  },
  {
    id: '6213041001',
    districtId: '6213041',
    name: 'Oreng',
  },
  {
    id: '6213041002',
    districtId: '6213041',
    name: 'Olong Muro',
  },
  {
    id: '6213041003',
    districtId: '6213041',
    name: 'Olong Hanangan',
  },
  {
    id: '6213041004',
    districtId: '6213041',
    name: 'Dirung Lingkin',
  },
  {
    id: '6213041005',
    districtId: '6213041',
    name: 'Datah Kotou',
  },
  {
    id: '6213041006',
    districtId: '6213041',
    name: 'Tahujan Ontu',
  },
  {
    id: '6213050001',
    districtId: '6213050',
    name: 'Kalapeh Baru',
  },
  {
    id: '6213050002',
    districtId: '6213050',
    name: 'Tumbang Masao',
  },
  {
    id: '6213050003',
    districtId: '6213050',
    name: 'Batu Makap',
  },
  {
    id: '6213050004',
    districtId: '6213050',
    name: 'Tumbang Kunyi',
  },
  {
    id: '6213050005',
    districtId: '6213050',
    name: 'Olong Liko',
  },
  {
    id: '6213050006',
    districtId: '6213050',
    name: 'Teluk Jolo',
  },
  {
    id: '6213050007',
    districtId: '6213050',
    name: 'Laas Baru',
  },
  {
    id: '6213050008',
    districtId: '6213050',
    name: 'Tumbang Tuan',
  },
  {
    id: '6213050019',
    districtId: '6213050',
    name: 'Tumbang Mulut',
  },
  {
    id: '6213051001',
    districtId: '6213051',
    name: 'Muara Joloi I',
  },
  {
    id: '6213051002',
    districtId: '6213051',
    name: 'Muara Joloi II',
  },
  {
    id: '6213051003',
    districtId: '6213051',
    name: 'Parahau',
  },
  {
    id: '6213051004',
    districtId: '6213051',
    name: 'Tumbang Naan',
  },
  {
    id: '6213051005',
    districtId: '6213051',
    name: 'Tumbang Tohan',
  },
  {
    id: '6213051006',
    districtId: '6213051',
    name: 'Tumbang Jojang',
  },
  {
    id: '6213051007',
    districtId: '6213051',
    name: 'Takajung',
  },
  {
    id: '6213052001',
    districtId: '6213052',
    name: 'Tumbang Olong',
  },
  {
    id: '6213052002',
    districtId: '6213052',
    name: 'Tumbang Olong II',
  },
  {
    id: '6213052003',
    districtId: '6213052',
    name: 'Kalasin',
  },
  {
    id: '6213052004',
    districtId: '6213052',
    name: 'Tumbang Tujang',
  },
  {
    id: '6213052005',
    districtId: '6213052',
    name: 'Tumbang Tupus',
  },
  {
    id: '6271010004',
    districtId: '6271010',
    name: 'Pahandut',
  },
  {
    id: '6271010005',
    districtId: '6271010',
    name: 'Panarung',
  },
  {
    id: '6271010006',
    districtId: '6271010',
    name: 'Langkai',
  },
  {
    id: '6271010009',
    districtId: '6271010',
    name: 'Tumbang Rungan',
  },
  {
    id: '6271010010',
    districtId: '6271010',
    name: 'Tanjung Pinang',
  },
  {
    id: '6271010011',
    districtId: '6271010',
    name: 'Pahandut Seberang',
  },
  {
    id: '6271011001',
    districtId: '6271011',
    name: 'Kereng Bangkirai',
  },
  {
    id: '6271011002',
    districtId: '6271011',
    name: 'Sabaru',
  },
  {
    id: '6271011003',
    districtId: '6271011',
    name: 'Kalampangan',
  },
  {
    id: '6271011004',
    districtId: '6271011',
    name: 'Kameloh Baru',
  },
  {
    id: '6271011006',
    districtId: '6271011',
    name: 'Danau Tundai',
  },
  {
    id: '6271012002',
    districtId: '6271012',
    name: 'Palangka',
  },
  {
    id: '6271012003',
    districtId: '6271012',
    name: 'Bukit Tunggal',
  },
  {
    id: '6271012004',
    districtId: '6271012',
    name: 'Petuk Katimpun',
  },
  {
    id: '6271020001',
    districtId: '6271020',
    name: 'Marang',
  },
  {
    id: '6271020002',
    districtId: '6271020',
    name: 'Tumbang Tahai',
  },
  {
    id: '6271020003',
    districtId: '6271020',
    name: 'Banturung',
  },
  {
    id: '6271020004',
    districtId: '6271020',
    name: 'Tangkiling',
  },
  {
    id: '6271020005',
    districtId: '6271020',
    name: 'Sei Gohong',
  },
  {
    id: '6271020006',
    districtId: '6271020',
    name: 'Kanarakan',
  },
  {
    id: '6271020007',
    districtId: '6271020',
    name: 'Habaring Hurung',
  },
  {
    id: '6271021001',
    districtId: '6271021',
    name: 'Petuk Bukit',
  },
  {
    id: '6271021002',
    districtId: '6271021',
    name: 'Pager',
  },
  {
    id: '6271021003',
    districtId: '6271021',
    name: 'Panjehang',
  },
  {
    id: '6271021004',
    districtId: '6271021',
    name: 'Gaung Baru',
  },
  {
    id: '6271021005',
    districtId: '6271021',
    name: 'Petuk Barunai',
  },
  {
    id: '6271021006',
    districtId: '6271021',
    name: 'Mungku Baru',
  },
  {
    id: '6271021007',
    districtId: '6271021',
    name: 'Bukit Sua',
  },
  {
    id: '6301010001',
    districtId: '6301010',
    name: 'Batakan',
  },
  {
    id: '6301010002',
    districtId: '6301010',
    name: 'Tanjung Dewa',
  },
  {
    id: '6301010003',
    districtId: '6301010',
    name: 'Kandangan Lama',
  },
  {
    id: '6301010004',
    districtId: '6301010',
    name: 'Batu Tungku',
  },
  {
    id: '6301010005',
    districtId: '6301010',
    name: 'Kuringkit',
  },
  {
    id: '6301010006',
    districtId: '6301010',
    name: 'Bumi Asih',
  },
  {
    id: '6301010007',
    districtId: '6301010',
    name: 'Batu Mulya',
  },
  {
    id: '6301010008',
    districtId: '6301010',
    name: 'Suka Ramah',
  },
  {
    id: '6301010009',
    districtId: '6301010',
    name: 'Panyipatan',
  },
  {
    id: '6301010010',
    districtId: '6301010',
    name: 'Kandangan Baru',
  },
  {
    id: '6301020001',
    districtId: '6301020',
    name: 'Kuala Tambangan',
  },
  {
    id: '6301020002',
    districtId: '6301020',
    name: 'Telaga Langsat',
  },
  {
    id: '6301020003',
    districtId: '6301020',
    name: 'Takisung',
  },
  {
    id: '6301020004',
    districtId: '6301020',
    name: 'Gunung Makmur',
  },
  {
    id: '6301020005',
    districtId: '6301020',
    name: 'Sumber Makmur',
  },
  {
    id: '6301020006',
    districtId: '6301020',
    name: 'Benua Tengah',
  },
  {
    id: '6301020007',
    districtId: '6301020',
    name: 'Benua Lawas',
  },
  {
    id: '6301020008',
    districtId: '6301020',
    name: 'Ranggang',
  },
  {
    id: '6301020009',
    districtId: '6301020',
    name: 'Batilai',
  },
  {
    id: '6301020010',
    districtId: '6301020',
    name: 'Ranggang Dalam',
  },
  {
    id: '6301020011',
    districtId: '6301020',
    name: 'Pegatan Besar',
  },
  {
    id: '6301020012',
    districtId: '6301020',
    name: 'Tabanio',
  },
  {
    id: '6301030001',
    districtId: '6301030',
    name: 'Sungai Bakau',
  },
  {
    id: '6301030002',
    districtId: '6301030',
    name: 'Raden',
  },
  {
    id: '6301030003',
    districtId: '6301030',
    name: 'Maluka Baulin',
  },
  {
    id: '6301030004',
    districtId: '6301030',
    name: 'Bawah Layung',
  },
  {
    id: '6301030005',
    districtId: '6301030',
    name: 'Tambak Karya',
  },
  {
    id: '6301030006',
    districtId: '6301030',
    name: 'Padang Luas',
  },
  {
    id: '6301030007',
    districtId: '6301030',
    name: 'Tambak Sarinah',
  },
  {
    id: '6301030008',
    districtId: '6301030',
    name: 'Sarikandi',
  },
  {
    id: '6301030009',
    districtId: '6301030',
    name: 'Handil Negara',
  },
  {
    id: '6301030010',
    districtId: '6301030',
    name: 'Kali Besar',
  },
  {
    id: '6301030013',
    districtId: '6301030',
    name: 'Kurau',
  },
  {
    id: '6301031001',
    districtId: '6301031',
    name: 'Pantai Harapan',
  },
  {
    id: '6301031002',
    districtId: '6301031',
    name: 'Sungai Rasau',
  },
  {
    id: '6301031003',
    districtId: '6301031',
    name: 'Handil Maluka',
  },
  {
    id: '6301031004',
    districtId: '6301031',
    name: 'Handil Labuan Amas',
  },
  {
    id: '6301031005',
    districtId: '6301031',
    name: 'Handil Suruk',
  },
  {
    id: '6301031006',
    districtId: '6301031',
    name: 'Handil Gayam',
  },
  {
    id: '6301031007',
    districtId: '6301031',
    name: 'Kurau Utara',
  },
  {
    id: '6301031008',
    districtId: '6301031',
    name: 'Bumi Harapan',
  },
  {
    id: '6301031009',
    districtId: '6301031',
    name: 'Handil Babirik',
  },
  {
    id: '6301031010',
    districtId: '6301031',
    name: 'Handil Birayang Bawah',
  },
  {
    id: '6301031011',
    districtId: '6301031',
    name: 'Handil Birayang Atas',
  },
  {
    id: '6301040001',
    districtId: '6301040',
    name: 'Benua Raya',
  },
  {
    id: '6301040002',
    districtId: '6301040',
    name: 'Bati Bati',
  },
  {
    id: '6301040003',
    districtId: '6301040',
    name: 'Padang',
  },
  {
    id: '6301040005',
    districtId: '6301040',
    name: 'Ujung Baru',
  },
  {
    id: '6301040006',
    districtId: '6301040',
    name: 'Nusa Indah',
  },
  {
    id: '6301040007',
    districtId: '6301040',
    name: 'Kait Kait',
  },
  {
    id: '6301040008',
    districtId: '6301040',
    name: 'Kait-Kait Baru',
  },
  {
    id: '6301040009',
    districtId: '6301040',
    name: 'Bentok Darat',
  },
  {
    id: '6301040010',
    districtId: '6301040',
    name: 'Banyu Irang',
  },
  {
    id: '6301040011',
    districtId: '6301040',
    name: 'Bentok Kampung',
  },
  {
    id: '6301040012',
    districtId: '6301040',
    name: 'Sambangan',
  },
  {
    id: '6301040013',
    districtId: '6301040',
    name: 'Liang Anggang',
  },
  {
    id: '6301040014',
    districtId: '6301040',
    name: 'Pandahan',
  },
  {
    id: '6301050001',
    districtId: '6301050',
    name: 'Bingkulu',
  },
  {
    id: '6301050002',
    districtId: '6301050',
    name: 'Kayu Abang',
  },
  {
    id: '6301050004',
    districtId: '6301050',
    name: 'Gunung Raja',
  },
  {
    id: '6301050005',
    districtId: '6301050',
    name: 'Pulau Sari',
  },
  {
    id: '6301050006',
    districtId: '6301050',
    name: 'Tambang Ulang',
  },
  {
    id: '6301050007',
    districtId: '6301050',
    name: 'Sungai Jelai',
  },
  {
    id: '6301050008',
    districtId: '6301050',
    name: 'Sungai Pinang',
  },
  {
    id: '6301050009',
    districtId: '6301050',
    name: 'Martadah',
  },
  {
    id: '6301050010',
    districtId: '6301050',
    name: 'Martadah Baru',
  },
  {
    id: '6301060001',
    districtId: '6301060',
    name: 'Sungai Riam',
  },
  {
    id: '6301060002',
    districtId: '6301060',
    name: 'Kampung Baru',
  },
  {
    id: '6301060003',
    districtId: '6301060',
    name: 'Sumber Mulia',
  },
  {
    id: '6301060004',
    districtId: '6301060',
    name: 'Tampang',
  },
  {
    id: '6301060005',
    districtId: '6301060',
    name: 'Sarang Halang',
  },
  {
    id: '6301060006',
    districtId: '6301060',
    name: 'Bumi Jaya',
  },
  {
    id: '6301060014',
    districtId: '6301060',
    name: 'Atu Atu',
  },
  {
    id: '6301060015',
    districtId: '6301060',
    name: 'Angsau',
  },
  {
    id: '6301060016',
    districtId: '6301060',
    name: 'Pelaihari',
  },
  {
    id: '6301060017',
    districtId: '6301060',
    name: 'Karang Taruna',
  },
  {
    id: '6301060018',
    districtId: '6301060',
    name: 'Telaga',
  },
  {
    id: '6301060019',
    districtId: '6301060',
    name: 'Guntung Besar',
  },
  {
    id: '6301060020',
    districtId: '6301060',
    name: 'Panjaratan',
  },
  {
    id: '6301060021',
    districtId: '6301060',
    name: 'Tungkaran',
  },
  {
    id: '6301060022',
    districtId: '6301060',
    name: 'Panggung',
  },
  {
    id: '6301060023',
    districtId: '6301060',
    name: 'Pabahanan',
  },
  {
    id: '6301060026',
    districtId: '6301060',
    name: 'Ambungan',
  },
  {
    id: '6301060027',
    districtId: '6301060',
    name: 'Panggung Baru',
  },
  {
    id: '6301060028',
    districtId: '6301060',
    name: 'Ujung Batu',
  },
  {
    id: '6301060029',
    districtId: '6301060',
    name: 'Pemuda (Desa Persiapan)',
  },
  {
    id: '6301061001',
    districtId: '6301061',
    name: 'Tirta Jaya',
  },
  {
    id: '6301061002',
    districtId: '6301061',
    name: 'Galam',
  },
  {
    id: '6301061003',
    districtId: '6301061',
    name: 'Pamalongan',
  },
  {
    id: '6301061004',
    districtId: '6301061',
    name: 'Ketapang',
  },
  {
    id: '6301061005',
    districtId: '6301061',
    name: 'Kunyit',
  },
  {
    id: '6301061006',
    districtId: '6301061',
    name: 'Bajuin',
  },
  {
    id: '6301061007',
    districtId: '6301061',
    name: 'Sungai Bakar',
  },
  {
    id: '6301061008',
    districtId: '6301061',
    name: 'Tanjung',
  },
  {
    id: '6301061009',
    districtId: '6301061',
    name: 'Tebing Siring',
  },
  {
    id: '6301070001',
    districtId: '6301070',
    name: 'Tajau Pecah',
  },
  {
    id: '6301070002',
    districtId: '6301070',
    name: 'Jilatan',
  },
  {
    id: '6301070003',
    districtId: '6301070',
    name: 'Jilatan Alur',
  },
  {
    id: '6301070004',
    districtId: '6301070',
    name: 'Ambawang',
  },
  {
    id: '6301070005',
    districtId: '6301070',
    name: 'Durian Bungkuk',
  },
  {
    id: '6301070006',
    districtId: '6301070',
    name: 'Tajau Mulia',
  },
  {
    id: '6301070007',
    districtId: '6301070',
    name: 'Gunung Mas',
  },
  {
    id: '6301070008',
    districtId: '6301070',
    name: 'Batu Ampar',
  },
  {
    id: '6301070009',
    districtId: '6301070',
    name: 'Damar Lima',
  },
  {
    id: '6301070010',
    districtId: '6301070',
    name: 'Damit',
  },
  {
    id: '6301070011',
    districtId: '6301070',
    name: 'Damit Hulu',
  },
  {
    id: '6301070012',
    districtId: '6301070',
    name: 'Pantai Linuh',
  },
  {
    id: '6301070014',
    districtId: '6301070',
    name: 'Gunung Melati',
  },
  {
    id: '6301080001',
    districtId: '6301080',
    name: 'Sabuhur',
  },
  {
    id: '6301080002',
    districtId: '6301080',
    name: 'Swarangan',
  },
  {
    id: '6301080003',
    districtId: '6301080',
    name: 'Alur',
  },
  {
    id: '6301080004',
    districtId: '6301080',
    name: 'Jorong',
  },
  {
    id: '6301080005',
    districtId: '6301080',
    name: 'Karang Rejo',
  },
  {
    id: '6301080006',
    districtId: '6301080',
    name: 'Muara Asam Asam',
  },
  {
    id: '6301080007',
    districtId: '6301080',
    name: 'Asam Jaya',
  },
  {
    id: '6301080008',
    districtId: '6301080',
    name: 'Asri Mulia',
  },
  {
    id: '6301080009',
    districtId: '6301080',
    name: 'Asam Asam',
  },
  {
    id: '6301080010',
    districtId: '6301080',
    name: 'Batalang',
  },
  {
    id: '6301080011',
    districtId: '6301080',
    name: 'Simpang Empat Sungai Baru',
  },
  {
    id: '6301090001',
    districtId: '6301090',
    name: 'Pandansari',
  },
  {
    id: '6301090002',
    districtId: '6301090',
    name: 'Salaman',
  },
  {
    id: '6301090003',
    districtId: '6301090',
    name: 'Kintapura',
  },
  {
    id: '6301090004',
    districtId: '6301090',
    name: 'Pasir Putih',
  },
  {
    id: '6301090005',
    districtId: '6301090',
    name: 'Kintap Kecil',
  },
  {
    id: '6301090006',
    districtId: '6301090',
    name: 'Kintap',
  },
  {
    id: '6301090007',
    districtId: '6301090',
    name: 'Muara Kintap',
  },
  {
    id: '6301090008',
    districtId: '6301090',
    name: 'Bukit Mulia',
  },
  {
    id: '6301090009',
    districtId: '6301090',
    name: 'Sumber Jaya',
  },
  {
    id: '6301090010',
    districtId: '6301090',
    name: 'Kebun Raya',
  },
  {
    id: '6301090011',
    districtId: '6301090',
    name: 'Mekar Sari',
  },
  {
    id: '6301090012',
    districtId: '6301090',
    name: 'Sebamban Baru',
  },
  {
    id: '6301090013',
    districtId: '6301090',
    name: 'Sungai Cuka',
  },
  {
    id: '6301090014',
    districtId: '6301090',
    name: 'Riam Adungan',
  },
  {
    id: '6302010001',
    districtId: '6302010',
    name: 'Labuan Barat',
  },
  {
    id: '6302010002',
    districtId: '6302010',
    name: 'Teluk Sungai',
  },
  {
    id: '6302010003',
    districtId: '6302010',
    name: 'Maradapan',
  },
  {
    id: '6302010004',
    districtId: '6302010',
    name: 'Tengah',
  },
  {
    id: '6302010005',
    districtId: '6302010',
    name: 'Tanjung Nyiur',
  },
  {
    id: '6302020008',
    districtId: '6302020',
    name: 'Lontar Selatan',
  },
  {
    id: '6302020009',
    districtId: '6302020',
    name: 'Lontar Utara',
  },
  {
    id: '6302020012',
    districtId: '6302020',
    name: 'Lontar Timur',
  },
  {
    id: '6302020014',
    districtId: '6302020',
    name: 'Tapian Balai',
  },
  {
    id: '6302020015',
    districtId: '6302020',
    name: 'Sebanti',
  },
  {
    id: '6302020017',
    districtId: '6302020',
    name: 'Sepagar',
  },
  {
    id: '6302020018',
    districtId: '6302020',
    name: 'Sumber Sari ( UPT. Sepagar I)',
  },
  {
    id: '6302020019',
    districtId: '6302020',
    name: 'Subur Makmur (UPT. Sepagar II)',
  },
  {
    id: '6302020020',
    districtId: '6302020',
    name: 'Terangkih',
  },
  {
    id: '6302020021',
    districtId: '6302020',
    name: 'Semaras',
  },
  {
    id: '6302021001',
    districtId: '6302021',
    name: 'Tanjung Kunyit',
  },
  {
    id: '6302021002',
    districtId: '6302021',
    name: 'Tanjung Tengah',
  },
  {
    id: '6302021003',
    districtId: '6302021',
    name: 'Teluk Tamiang',
  },
  {
    id: '6302021004',
    districtId: '6302021',
    name: 'Gosong Panjang',
  },
  {
    id: '6302021005',
    districtId: '6302021',
    name: 'Kampung Baru',
  },
  {
    id: '6302021006',
    districtId: '6302021',
    name: 'Tanjung Sungkai',
  },
  {
    id: '6302021007',
    districtId: '6302021',
    name: 'Tanjung Pelayar',
  },
  {
    id: '6302021008',
    districtId: '6302021',
    name: 'Banda Raya',
  },
  {
    id: '6302021009',
    districtId: '6302021',
    name: 'Tata Mekar',
  },
  {
    id: '6302021010',
    districtId: '6302021',
    name: 'Bangun Rejo',
  },
  {
    id: '6302030009',
    districtId: '6302030',
    name: 'Teluk Sirih',
  },
  {
    id: '6302030010',
    districtId: '6302030',
    name: 'Sungai Bulan',
  },
  {
    id: '6302030011',
    districtId: '6302030',
    name: 'Sungai Bahim',
  },
  {
    id: '6302030012',
    districtId: '6302030',
    name: 'Alle Alle',
  },
  {
    id: '6302030013',
    districtId: '6302030',
    name: 'Tanjung Seloka',
  },
  {
    id: '6302030014',
    districtId: '6302030',
    name: 'Tanjung Serudung',
  },
  {
    id: '6302030015',
    districtId: '6302030',
    name: 'Labuan Mas',
  },
  {
    id: '6302030016',
    districtId: '6302030',
    name: 'Tanjung Seloka Utara',
  },
  {
    id: '6302031001',
    districtId: '6302031',
    name: 'Pulau Kerayaan',
  },
  {
    id: '6302031002',
    districtId: '6302031',
    name: 'Kerayaan Utara',
  },
  {
    id: '6302031003',
    districtId: '6302031',
    name: 'Pulau Kerumputan',
  },
  {
    id: '6302031004',
    districtId: '6302031',
    name: 'Pulau Kerasian',
  },
  {
    id: '6302031005',
    districtId: '6302031',
    name: 'Teluk Kemuning',
  },
  {
    id: '6302031006',
    districtId: '6302031',
    name: 'Teluk Aru',
  },
  {
    id: '6302031007',
    districtId: '6302031',
    name: 'Tanjung Lalak Selatan',
  },
  {
    id: '6302031008',
    districtId: '6302031',
    name: 'Tanjung Lalak Utara',
  },
  {
    id: '6302031009',
    districtId: '6302031',
    name: 'Oka-Oka',
  },
  {
    id: '6302040001',
    districtId: '6302040',
    name: 'Tanjung Pengharapan',
  },
  {
    id: '6302040002',
    districtId: '6302040',
    name: 'Batu Tunau',
  },
  {
    id: '6302040003',
    districtId: '6302040',
    name: 'Sejakah',
  },
  {
    id: '6302040004',
    districtId: '6302040',
    name: 'Bekambit',
  },
  {
    id: '6302040005',
    districtId: '6302040',
    name: 'Bekambit Asri',
  },
  {
    id: '6302040007',
    districtId: '6302040',
    name: 'Langkang Baru',
  },
  {
    id: '6302040008',
    districtId: '6302040',
    name: 'Karang Sari Indah',
  },
  {
    id: '6302040009',
    districtId: '6302040',
    name: 'Sungai Limau',
  },
  {
    id: '6302040010',
    districtId: '6302040',
    name: 'Langkang Lama',
  },
  {
    id: '6302040011',
    districtId: '6302040',
    name: 'Kulipak',
  },
  {
    id: '6302040012',
    districtId: '6302040',
    name: 'Berangas',
  },
  {
    id: '6302040013',
    districtId: '6302040',
    name: 'Teluk Mesjid',
  },
  {
    id: '6302040014',
    districtId: '6302040',
    name: 'Teluk Gosong',
  },
  {
    id: '6302050001',
    districtId: '6302050',
    name: 'Sekapung',
  },
  {
    id: '6302050002',
    districtId: '6302050',
    name: 'Kanibungan',
  },
  {
    id: '6302050003',
    districtId: '6302050',
    name: 'Mandin',
  },
  {
    id: '6302050004',
    districtId: '6302050',
    name: 'Belambus',
  },
  {
    id: '6302050005',
    districtId: '6302050',
    name: 'Sarakaman',
  },
  {
    id: '6302050006',
    districtId: '6302050',
    name: 'Sungai Bali',
  },
  {
    id: '6302050007',
    districtId: '6302050',
    name: 'Rampa',
  },
  {
    id: '6302060007',
    districtId: '6302060',
    name: 'Megasari',
  },
  {
    id: '6302060008',
    districtId: '6302060',
    name: 'Sebelimbingan',
  },
  {
    id: '6302060009',
    districtId: '6302060',
    name: 'Gunung Sari',
  },
  {
    id: '6302060010',
    districtId: '6302060',
    name: 'Stagen',
  },
  {
    id: '6302060011',
    districtId: '6302060',
    name: 'Gunung Ulin',
  },
  {
    id: '6302060012',
    districtId: '6302060',
    name: 'Sungai Taib',
  },
  {
    id: '6302060013',
    districtId: '6302060',
    name: 'Semayap',
  },
  {
    id: '6302060014',
    districtId: '6302060',
    name: 'Dirgahayu',
  },
  {
    id: '6302060015',
    districtId: '6302060',
    name: 'Baharu Selatan',
  },
  {
    id: '6302060016',
    districtId: '6302060',
    name: 'Kotabaru Hulu',
  },
  {
    id: '6302060017',
    districtId: '6302060',
    name: 'Rampa',
  },
  {
    id: '6302060018',
    districtId: '6302060',
    name: 'Sebatung',
  },
  {
    id: '6302060019',
    districtId: '6302060',
    name: 'Kotabaru Tengah',
  },
  {
    id: '6302060020',
    districtId: '6302060',
    name: 'Kotabaru Hilir',
  },
  {
    id: '6302060021',
    districtId: '6302060',
    name: 'Hilir Muara',
  },
  {
    id: '6302060022',
    districtId: '6302060',
    name: 'Batuah',
  },
  {
    id: '6302060023',
    districtId: '6302060',
    name: 'Baharu Utara',
  },
  {
    id: '6302060024',
    districtId: '6302060',
    name: 'Tirawan',
  },
  {
    id: '6302060025',
    districtId: '6302060',
    name: 'Gedambaan',
  },
  {
    id: '6302060026',
    districtId: '6302060',
    name: 'Sarang Tiung',
  },
  {
    id: '6302060027',
    districtId: '6302060',
    name: 'Sigam',
  },
  {
    id: '6302061001',
    districtId: '6302061',
    name: 'Semisir',
  },
  {
    id: '6302061002',
    districtId: '6302061',
    name: 'Sungai Pasir',
  },
  {
    id: '6302061003',
    districtId: '6302061',
    name: 'Salino',
  },
  {
    id: '6302061004',
    districtId: '6302061',
    name: 'Mekar Pura',
  },
  {
    id: '6302061005',
    districtId: '6302061',
    name: 'Selaru',
  },
  {
    id: '6302061006',
    districtId: '6302061',
    name: 'Sungup Kanan',
  },
  {
    id: '6302061007',
    districtId: '6302061',
    name: 'Pantai Baru',
  },
  {
    id: '6302120009',
    districtId: '6302120',
    name: 'Suka Maju',
  },
  {
    id: '6302120010',
    districtId: '6302120',
    name: 'Pantai',
  },
  {
    id: '6302120011',
    districtId: '6302120',
    name: 'Tanjung Pangga',
  },
  {
    id: '6302120012',
    districtId: '6302120',
    name: 'Pembelancanan',
  },
  {
    id: '6302120013',
    districtId: '6302120',
    name: 'Bumi Asih',
  },
  {
    id: '6302120014',
    districtId: '6302120',
    name: 'Sungai Nipah',
  },
  {
    id: '6302120015',
    districtId: '6302120',
    name: 'Pantai Baru',
  },
  {
    id: '6302120016',
    districtId: '6302120',
    name: 'Sangking Baru',
  },
  {
    id: '6302120017',
    districtId: '6302120',
    name: 'Sungai Kupang Jaya',
  },
  {
    id: '6302121001',
    districtId: '6302121',
    name: 'Tarjun',
  },
  {
    id: '6302121002',
    districtId: '6302121',
    name: 'Mandala',
  },
  {
    id: '6302121003',
    districtId: '6302121',
    name: 'Langadai',
  },
  {
    id: '6302121004',
    districtId: '6302121',
    name: 'Pelaju Baru',
  },
  {
    id: '6302121005',
    districtId: '6302121',
    name: 'Serongga',
  },
  {
    id: '6302121006',
    districtId: '6302121',
    name: 'Tegal Rejo',
  },
  {
    id: '6302121007',
    districtId: '6302121',
    name: 'Telaga Sari',
  },
  {
    id: '6302121008',
    districtId: '6302121',
    name: 'Pulau Panci',
  },
  {
    id: '6302121009',
    districtId: '6302121',
    name: 'Sahapi',
  },
  {
    id: '6302130001',
    districtId: '6302130',
    name: 'Mangkirana',
  },
  {
    id: '6302130002',
    districtId: '6302130',
    name: 'Cantung Kiri Hilir',
  },
  {
    id: '6302130003',
    districtId: '6302130',
    name: 'Banua Lawas',
  },
  {
    id: '6302130004',
    districtId: '6302130',
    name: 'Sidomulyo',
  },
  {
    id: '6302130005',
    districtId: '6302130',
    name: 'Karang Payau',
  },
  {
    id: '6302130006',
    districtId: '6302130',
    name: 'Sungai Kupang',
  },
  {
    id: '6302130007',
    districtId: '6302130',
    name: 'Bangkalan Melayu',
  },
  {
    id: '6302130008',
    districtId: '6302130',
    name: 'Karang Liwar',
  },
  {
    id: '6302130009',
    districtId: '6302130',
    name: 'Bangkalan Dayak',
  },
  {
    id: '6302130010',
    districtId: '6302130',
    name: 'Laburan',
  },
  {
    id: '6302140001',
    districtId: '6302140',
    name: 'Cantung Kiri Hulu',
  },
  {
    id: '6302140002',
    districtId: '6302140',
    name: 'Lalapin',
  },
  {
    id: '6302140003',
    districtId: '6302140',
    name: 'Hampang',
  },
  {
    id: '6302140004',
    districtId: '6302140',
    name: 'Cantung Kanan',
  },
  {
    id: '6302140005',
    districtId: '6302140',
    name: 'Limbur',
  },
  {
    id: '6302140006',
    districtId: '6302140',
    name: 'Peramasan 2x Sanga',
  },
  {
    id: '6302140007',
    districtId: '6302140',
    name: 'Muara Ore',
  },
  {
    id: '6302140008',
    districtId: '6302140',
    name: 'Hulu Sampanahan',
  },
  {
    id: '6302140009',
    districtId: '6302140',
    name: 'Limbungan',
  },
  {
    id: '6302150001',
    districtId: '6302150',
    name: 'Gendang Timburu',
  },
  {
    id: '6302150004',
    districtId: '6302150',
    name: 'Manunggul Lama',
  },
  {
    id: '6302150005',
    districtId: '6302150',
    name: 'Manunggul Baru',
  },
  {
    id: '6302150006',
    districtId: '6302150',
    name: 'Rantau Buda',
  },
  {
    id: '6302150007',
    districtId: '6302150',
    name: 'Rantau Jaya',
  },
  {
    id: '6302150008',
    districtId: '6302150',
    name: 'Terombong Sari',
  },
  {
    id: '6302150009',
    districtId: '6302150',
    name: 'Buluh Kuning',
  },
  {
    id: '6302160001',
    districtId: '6302160',
    name: 'Tanjung Batu',
  },
  {
    id: '6302160002',
    districtId: '6302160',
    name: 'Sungai Pinang',
  },
  {
    id: '6302160003',
    districtId: '6302160',
    name: 'Sungai Punggawa',
  },
  {
    id: '6302160004',
    districtId: '6302160',
    name: 'Tanjung Selayar',
  },
  {
    id: '6302160005',
    districtId: '6302160',
    name: 'Senakin',
  },
  {
    id: '6302160006',
    districtId: '6302160',
    name: 'Senakin Seberang',
  },
  {
    id: '6302160007',
    districtId: '6302160',
    name: 'Tanah Rata',
  },
  {
    id: '6302160008',
    districtId: '6302160',
    name: 'Sebuli',
  },
  {
    id: '6302160009',
    districtId: '6302160',
    name: 'Sembilang',
  },
  {
    id: '6302160010',
    districtId: '6302160',
    name: 'Tamiang Bakung',
  },
  {
    id: '6302160011',
    districtId: '6302160',
    name: 'Tebing Tinggi',
  },
  {
    id: '6302160012',
    districtId: '6302160',
    name: 'Sang Sang',
  },
  {
    id: '6302160013',
    districtId: '6302160',
    name: 'Geronggang',
  },
  {
    id: '6302161001',
    districtId: '6302161',
    name: 'Batang Kulur',
  },
  {
    id: '6302161002',
    districtId: '6302161',
    name: 'Bungkukan',
  },
  {
    id: '6302161003',
    districtId: '6302161',
    name: 'Siayuh',
  },
  {
    id: '6302161004',
    districtId: '6302161',
    name: 'Tanjung Sari',
  },
  {
    id: '6302161005',
    districtId: '6302161',
    name: 'Magalau Hilir',
  },
  {
    id: '6302161006',
    districtId: '6302161',
    name: 'Magalau Hulu',
  },
  {
    id: '6302170001',
    districtId: '6302170',
    name: 'Sungai Hanyar',
  },
  {
    id: '6302170002',
    districtId: '6302170',
    name: 'Pudi',
  },
  {
    id: '6302170003',
    districtId: '6302170',
    name: 'Sungai Seluang',
  },
  {
    id: '6302170004',
    districtId: '6302170',
    name: 'Mangga',
  },
  {
    id: '6302170005',
    districtId: '6302170',
    name: 'Pudi Seberang',
  },
  {
    id: '6302170006',
    districtId: '6302170',
    name: 'Sulangkit',
  },
  {
    id: '6302170007',
    districtId: '6302170',
    name: 'Wilas',
  },
  {
    id: '6302180001',
    districtId: '6302180',
    name: 'Sekandis',
  },
  {
    id: '6302180002',
    districtId: '6302180',
    name: 'Sukadana',
  },
  {
    id: '6302180003',
    districtId: '6302180',
    name: 'Gunung Calang',
  },
  {
    id: '6302180004',
    districtId: '6302180',
    name: 'Talusi',
  },
  {
    id: '6302180005',
    districtId: '6302180',
    name: 'Sakalimau',
  },
  {
    id: '6302180006',
    districtId: '6302180',
    name: 'Mulyodadi',
  },
  {
    id: '6302180007',
    districtId: '6302180',
    name: 'Tanjung Samalantakan',
  },
  {
    id: '6302180008',
    districtId: '6302180',
    name: 'Saka Doyan',
  },
  {
    id: '6302180009',
    districtId: '6302180',
    name: 'Rampacengal',
  },
  {
    id: '6302180011',
    districtId: '6302180',
    name: 'Pondok Labu',
  },
  {
    id: '6302190001',
    districtId: '6302190',
    name: 'Sepapah',
  },
  {
    id: '6302190002',
    districtId: '6302190',
    name: 'Banjarsari',
  },
  {
    id: '6302190003',
    districtId: '6302190',
    name: 'Sungai Betung',
  },
  {
    id: '6302190004',
    districtId: '6302190',
    name: 'Sampanahan Hilir',
  },
  {
    id: '6302190005',
    districtId: '6302190',
    name: 'Sukamaju',
  },
  {
    id: '6302190006',
    districtId: '6302190',
    name: 'Sampanahan',
  },
  {
    id: '6302190007',
    districtId: '6302190',
    name: 'Gunung Batu Besar',
  },
  {
    id: '6302190008',
    districtId: '6302190',
    name: 'Basuang',
  },
  {
    id: '6302190009',
    districtId: '6302190',
    name: 'Papaan',
  },
  {
    id: '6302190010',
    districtId: '6302190',
    name: 'Rampa Manunggul',
  },
  {
    id: '6302200005',
    districtId: '6302200',
    name: 'Bepara',
  },
  {
    id: '6302200006',
    districtId: '6302200',
    name: 'Bakau',
  },
  {
    id: '6302200007',
    districtId: '6302200',
    name: 'Kalian',
  },
  {
    id: '6302200008',
    districtId: '6302200',
    name: 'Binturung',
  },
  {
    id: '6302200009',
    districtId: '6302200',
    name: 'Harapan Baru',
  },
  {
    id: '6302200010',
    districtId: '6302200',
    name: 'Tamiyang',
  },
  {
    id: '6302200011',
    districtId: '6302200',
    name: 'Lintang Jaya',
  },
  {
    id: '6302200012',
    districtId: '6302200',
    name: 'Mulyo Harjo',
  },
  {
    id: '6302200013',
    districtId: '6302200',
    name: 'Wonorejo',
  },
  {
    id: '6302200014',
    districtId: '6302200',
    name: 'Pamukan Indah',
  },
  {
    id: '6302200015',
    districtId: '6302200',
    name: 'Balamea',
  },
  {
    id: '6302200017',
    districtId: '6302200',
    name: 'Sekayu Baru',
  },
  {
    id: '6302201001',
    districtId: '6302201',
    name: 'Sengayam',
  },
  {
    id: '6302201002',
    districtId: '6302201',
    name: 'Marga Jaya',
  },
  {
    id: '6302201003',
    districtId: '6302201',
    name: 'Mayang Sari',
  },
  {
    id: '6302201004',
    districtId: '6302201',
    name: 'Mangka',
  },
  {
    id: '6302201005',
    districtId: '6302201',
    name: 'Batuah',
  },
  {
    id: '6303010001',
    districtId: '6303010',
    name: 'Sungai Musang',
  },
  {
    id: '6303010002',
    districtId: '6303010',
    name: 'Bakambat',
  },
  {
    id: '6303010014',
    districtId: '6303010',
    name: 'Labat Muara',
  },
  {
    id: '6303010015',
    districtId: '6303010',
    name: 'Tanipah',
  },
  {
    id: '6303010018',
    districtId: '6303010',
    name: 'Bunipah',
  },
  {
    id: '6303010019',
    districtId: '6303010',
    name: 'Simpang Warga Dalam',
  },
  {
    id: '6303010020',
    districtId: '6303010',
    name: 'Pulantan',
  },
  {
    id: '6303010021',
    districtId: '6303010',
    name: 'Aluh-Aluh Besar',
  },
  {
    id: '6303010022',
    districtId: '6303010',
    name: 'Simpang Warga',
  },
  {
    id: '6303010023',
    districtId: '6303010',
    name: 'Balimau',
  },
  {
    id: '6303010024',
    districtId: '6303010',
    name: 'Aluh Aluh Kecil',
  },
  {
    id: '6303010025',
    districtId: '6303010',
    name: 'Aluh Aluh Kecil Muara',
  },
  {
    id: '6303010026',
    districtId: '6303010',
    name: 'Podok',
  },
  {
    id: '6303010027',
    districtId: '6303010',
    name: 'Terapu',
  },
  {
    id: '6303010028',
    districtId: '6303010',
    name: 'Kuin Besar',
  },
  {
    id: '6303010029',
    districtId: '6303010',
    name: 'Handil Bujur',
  },
  {
    id: '6303010030',
    districtId: '6303010',
    name: 'Handil Baru',
  },
  {
    id: '6303010031',
    districtId: '6303010',
    name: 'Kuin Kecil',
  },
  {
    id: '6303011001',
    districtId: '6303011',
    name: 'Pindahan Baru',
  },
  {
    id: '6303011002',
    districtId: '6303011',
    name: 'Haur Kuning',
  },
  {
    id: '6303011003',
    districtId: '6303011',
    name: 'Selat Makmur',
  },
  {
    id: '6303011004',
    districtId: '6303011',
    name: 'Kampung Baru',
  },
  {
    id: '6303011005',
    districtId: '6303011',
    name: 'Tambak Padi',
  },
  {
    id: '6303011006',
    districtId: '6303011',
    name: 'Lawahan',
  },
  {
    id: '6303011007',
    districtId: '6303011',
    name: 'Babirik',
  },
  {
    id: '6303011008',
    districtId: '6303011',
    name: 'Jambu Raya',
  },
  {
    id: '6303011009',
    districtId: '6303011',
    name: 'Handil Purai',
  },
  {
    id: '6303011010',
    districtId: '6303011',
    name: 'Muara Halayung',
  },
  {
    id: '6303011011',
    districtId: '6303011',
    name: 'Jambu Burung',
  },
  {
    id: '6303011012',
    districtId: '6303011',
    name: 'Rumpiang',
  },
  {
    id: '6303020001',
    districtId: '6303020',
    name: 'Sungai Kupang',
  },
  {
    id: '6303020002',
    districtId: '6303020',
    name: 'Keladan Baru',
  },
  {
    id: '6303020004',
    districtId: '6303020',
    name: 'Guntung Papuyu',
  },
  {
    id: '6303020005',
    districtId: '6303020',
    name: 'Makmur',
  },
  {
    id: '6303020006',
    districtId: '6303020',
    name: 'Tambak Sirang Darat',
  },
  {
    id: '6303020007',
    districtId: '6303020',
    name: 'Tambak Sirang Baru',
  },
  {
    id: '6303020008',
    districtId: '6303020',
    name: 'Tambak Sirang Laut',
  },
  {
    id: '6303020009',
    districtId: '6303020',
    name: 'Malintang',
  },
  {
    id: '6303020010',
    districtId: '6303020',
    name: 'Malintang Baru',
  },
  {
    id: '6303020011',
    districtId: '6303020',
    name: 'Kayu Bawang',
  },
  {
    id: '6303020012',
    districtId: '6303020',
    name: 'Gambut',
  },
  {
    id: '6303020013',
    districtId: '6303020',
    name: 'Banyu Hirang',
  },
  {
    id: '6303020014',
    districtId: '6303020',
    name: 'Gambut Barat',
  },
  {
    id: '6303030014',
    districtId: '6303030',
    name: 'Tatah Pemangkih Laut',
  },
  {
    id: '6303030015',
    districtId: '6303030',
    name: 'Tatah Belayung Baru',
  },
  {
    id: '6303030016',
    districtId: '6303030',
    name: 'Pasar Kemis',
  },
  {
    id: '6303030017',
    districtId: '6303030',
    name: 'Banua Hanyar',
  },
  {
    id: '6303030018',
    districtId: '6303030',
    name: 'Mekar Raya',
  },
  {
    id: '6303030019',
    districtId: '6303030',
    name: 'Sungai Lakum',
  },
  {
    id: '6303030020',
    districtId: '6303030',
    name: 'Mandar Sari',
  },
  {
    id: '6303030021',
    districtId: '6303030',
    name: 'Manarap Baru',
  },
  {
    id: '6303030022',
    districtId: '6303030',
    name: 'Manarap Tengah',
  },
  {
    id: '6303030023',
    districtId: '6303030',
    name: 'Manarap Lama',
  },
  {
    id: '6303030024',
    districtId: '6303030',
    name: 'Simpang Empat',
  },
  {
    id: '6303030025',
    districtId: '6303030',
    name: 'Kertak Hanyar II',
  },
  {
    id: '6303030026',
    districtId: '6303030',
    name: 'Kertak Hanyar I',
  },
  {
    id: '6303031001',
    districtId: '6303031',
    name: 'Tatah Bangkal',
  },
  {
    id: '6303031002',
    districtId: '6303031',
    name: 'Tatah Bangkaltengah',
  },
  {
    id: '6303031003',
    districtId: '6303031',
    name: 'Layap Baru',
  },
  {
    id: '6303031004',
    districtId: '6303031',
    name: 'Tampang Awang',
  },
  {
    id: '6303031005',
    districtId: '6303031',
    name: 'Tatah Pemangkih Darat',
  },
  {
    id: '6303031006',
    districtId: '6303031',
    name: 'Pemangkih Baru',
  },
  {
    id: '6303031007',
    districtId: '6303031',
    name: 'Jaruju Laut',
  },
  {
    id: '6303031008',
    districtId: '6303031',
    name: 'Tatah Jaruju',
  },
  {
    id: '6303031009',
    districtId: '6303031',
    name: 'Tatah Pemangkih Tengah',
  },
  {
    id: '6303031010',
    districtId: '6303031',
    name: 'Taibah Raya',
  },
  {
    id: '6303031011',
    districtId: '6303031',
    name: 'Tatah Layap',
  },
  {
    id: '6303031012',
    districtId: '6303031',
    name: 'Mekar Sari',
  },
  {
    id: '6303031013',
    districtId: '6303031',
    name: 'Pandan Sari',
  },
  {
    id: '6303040001',
    districtId: '6303040',
    name: 'Sungai Lulut',
  },
  {
    id: '6303040002',
    districtId: '6303040',
    name: 'Gudang Hirang',
  },
  {
    id: '6303040003',
    districtId: '6303040',
    name: 'Pematang Panjang',
  },
  {
    id: '6303040004',
    districtId: '6303040',
    name: 'Gudang Tengah',
  },
  {
    id: '6303040005',
    districtId: '6303040',
    name: 'Abumbun Jaya',
  },
  {
    id: '6303040006',
    districtId: '6303040',
    name: 'Sungai Tabuk Kota',
  },
  {
    id: '6303040007',
    districtId: '6303040',
    name: 'Sungai Tabuk Keramat',
  },
  {
    id: '6303040008',
    districtId: '6303040',
    name: 'Pemakuan',
  },
  {
    id: '6303040009',
    districtId: '6303040',
    name: 'Sungai Pinang Lama',
  },
  {
    id: '6303040010',
    districtId: '6303040',
    name: 'Lok Baintan',
  },
  {
    id: '6303040011',
    districtId: '6303040',
    name: 'Sungai Bakung',
  },
  {
    id: '6303040012',
    districtId: '6303040',
    name: 'Sungai Tandipah',
  },
  {
    id: '6303040013',
    districtId: '6303040',
    name: 'Paku Alam',
  },
  {
    id: '6303040014',
    districtId: '6303040',
    name: 'Lok Baintan Dalam',
  },
  {
    id: '6303040015',
    districtId: '6303040',
    name: 'Sungai Pinang Baru',
  },
  {
    id: '6303040016',
    districtId: '6303040',
    name: 'Pembantanan',
  },
  {
    id: '6303040017',
    districtId: '6303040',
    name: 'Lokbuntar',
  },
  {
    id: '6303040018',
    districtId: '6303040',
    name: 'Pejambuan',
  },
  {
    id: '6303040019',
    districtId: '6303040',
    name: 'Sungai Bangkal',
  },
  {
    id: '6303040020',
    districtId: '6303040',
    name: 'Keliling Benteng Ilir',
  },
  {
    id: '6303040021',
    districtId: '6303040',
    name: 'Tajau Landung',
  },
  {
    id: '6303050001',
    districtId: '6303050',
    name: 'Cindai Alus',
  },
  {
    id: '6303050002',
    districtId: '6303050',
    name: 'Sungai Sipai',
  },
  {
    id: '6303050003',
    districtId: '6303050',
    name: 'Sungai Paring',
  },
  {
    id: '6303050004',
    districtId: '6303050',
    name: 'Jawa',
  },
  {
    id: '6303050005',
    districtId: '6303050',
    name: 'Tanjung Rema Darat',
  },
  {
    id: '6303050006',
    districtId: '6303050',
    name: 'Indra Sari',
  },
  {
    id: '6303050007',
    districtId: '6303050',
    name: 'Labuan Tabu',
  },
  {
    id: '6303050008',
    districtId: '6303050',
    name: 'Bincau',
  },
  {
    id: '6303050009',
    districtId: '6303050',
    name: 'Tambak Baru',
  },
  {
    id: '6303050010',
    districtId: '6303050',
    name: 'Bincau Muara',
  },
  {
    id: '6303050011',
    districtId: '6303050',
    name: 'Tunggul Irang',
  },
  {
    id: '6303050012',
    districtId: '6303050',
    name: 'Tunggul Irang Ulu',
  },
  {
    id: '6303050013',
    districtId: '6303050',
    name: 'Tanjung Rema',
  },
  {
    id: '6303050014',
    districtId: '6303050',
    name: 'Jawa Laut',
  },
  {
    id: '6303050015',
    districtId: '6303050',
    name: 'Tunggul Irang Ilir',
  },
  {
    id: '6303050016',
    districtId: '6303050',
    name: 'Murung Keraton',
  },
  {
    id: '6303050017',
    districtId: '6303050',
    name: 'Keraton',
  },
  {
    id: '6303050018',
    districtId: '6303050',
    name: 'Pasayangan Utara',
  },
  {
    id: '6303050019',
    districtId: '6303050',
    name: 'Pasayangan Selatan',
  },
  {
    id: '6303050020',
    districtId: '6303050',
    name: 'Pasayangan Barat',
  },
  {
    id: '6303050021',
    districtId: '6303050',
    name: 'Pesayangan',
  },
  {
    id: '6303050023',
    districtId: '6303050',
    name: 'Murung Kenanga',
  },
  {
    id: '6303050027',
    districtId: '6303050',
    name: 'Tambak Baru Ilir',
  },
  {
    id: '6303050028',
    districtId: '6303050',
    name: 'Tambak Baru Ulu',
  },
  {
    id: '6303050037',
    districtId: '6303050',
    name: 'Tungkaran',
  },
  {
    id: '6303051001',
    districtId: '6303051',
    name: 'Antasan Senor Ilir',
  },
  {
    id: '6303051002',
    districtId: '6303051',
    name: 'Antasan Senor',
  },
  {
    id: '6303051003',
    districtId: '6303051',
    name: 'Tambak Anyar Ilir',
  },
  {
    id: '6303051004',
    districtId: '6303051',
    name: 'Tambak Anyar',
  },
  {
    id: '6303051005',
    districtId: '6303051',
    name: 'Tambak Anyar Ulu',
  },
  {
    id: '6303051006',
    districtId: '6303051',
    name: 'Pematang Baru',
  },
  {
    id: '6303051007',
    districtId: '6303051',
    name: 'Melayu Ulu',
  },
  {
    id: '6303051008',
    districtId: '6303051',
    name: 'Mekar',
  },
  {
    id: '6303051009',
    districtId: '6303051',
    name: 'Pekauman Ulu',
  },
  {
    id: '6303051010',
    districtId: '6303051',
    name: 'Pekauman',
  },
  {
    id: '6303051011',
    districtId: '6303051',
    name: 'Pekauman Dalam',
  },
  {
    id: '6303051012',
    districtId: '6303051',
    name: 'Keramat Baru',
  },
  {
    id: '6303051013',
    districtId: '6303051',
    name: 'Keramat',
  },
  {
    id: '6303051014',
    districtId: '6303051',
    name: 'Melayu Tengah',
  },
  {
    id: '6303051015',
    districtId: '6303051',
    name: 'Melayu Ilir',
  },
  {
    id: '6303051016',
    districtId: '6303051',
    name: 'Dalam Pagar Ulu',
  },
  {
    id: '6303051017',
    districtId: '6303051',
    name: 'Akar Baru',
  },
  {
    id: '6303051018',
    districtId: '6303051',
    name: 'Akar Bagantung Ulu',
  },
  {
    id: '6303051019',
    districtId: '6303051',
    name: 'Dalam Pagar',
  },
  {
    id: '6303051020',
    districtId: '6303051',
    name: 'Sungai Kitano',
  },
  {
    id: '6303052001',
    districtId: '6303052',
    name: 'Penggalaman',
  },
  {
    id: '6303052002',
    districtId: '6303052',
    name: 'Sungai Batang',
  },
  {
    id: '6303052003',
    districtId: '6303052',
    name: 'Telok Selong Ulu',
  },
  {
    id: '6303052004',
    districtId: '6303052',
    name: 'Telok Selong',
  },
  {
    id: '6303052005',
    districtId: '6303052',
    name: 'Tangkas',
  },
  {
    id: '6303052006',
    districtId: '6303052',
    name: 'Sungai Batang Ilir',
  },
  {
    id: '6303052007',
    districtId: '6303052',
    name: 'Sungai Rangas Ulu',
  },
  {
    id: '6303052008',
    districtId: '6303052',
    name: 'Sungai Rangas Hambuku',
  },
  {
    id: '6303052009',
    districtId: '6303052',
    name: 'Sungai Rangas Tengah',
  },
  {
    id: '6303052010',
    districtId: '6303052',
    name: 'Sungai Rangas',
  },
  {
    id: '6303052011',
    districtId: '6303052',
    name: 'Keliling Benteng Ulu',
  },
  {
    id: '6303052012',
    districtId: '6303052',
    name: 'Keliling Benteng Tengah',
  },
  {
    id: '6303052013',
    districtId: '6303052',
    name: 'Antasan Sutun',
  },
  {
    id: '6303060001',
    districtId: '6303060',
    name: 'Pingaran Ilir',
  },
  {
    id: '6303060002',
    districtId: '6303060',
    name: 'Pingaran Ulu',
  },
  {
    id: '6303060003',
    districtId: '6303060',
    name: 'Banua Anyar Danau Salak',
  },
  {
    id: '6303060004',
    districtId: '6303060',
    name: 'Astambul Seberang',
  },
  {
    id: '6303060005',
    districtId: '6303060',
    name: 'Astambul',
  },
  {
    id: '6303060006',
    districtId: '6303060',
    name: 'Jati',
  },
  {
    id: '6303060007',
    districtId: '6303060',
    name: 'Danau Salak',
  },
  {
    id: '6303060008',
    districtId: '6303060',
    name: 'Pasar Jati',
  },
  {
    id: '6303060009',
    districtId: '6303060',
    name: 'Sungai Alat',
  },
  {
    id: '6303060010',
    districtId: '6303060',
    name: 'Sungai Tuan Ulu',
  },
  {
    id: '6303060011',
    districtId: '6303060',
    name: 'Sungai Tuan Ilir',
  },
  {
    id: '6303060012',
    districtId: '6303060',
    name: 'Benua Anyar',
  },
  {
    id: '6303060013',
    districtId: '6303060',
    name: 'Tambangan',
  },
  {
    id: '6303060014',
    districtId: '6303060',
    name: 'Kelampaian Ilir',
  },
  {
    id: '6303060015',
    districtId: '6303060',
    name: 'Munggu Raya',
  },
  {
    id: '6303060016',
    districtId: '6303060',
    name: 'Kalampayan',
  },
  {
    id: '6303060017',
    districtId: '6303060',
    name: 'Kalampayan Ulu',
  },
  {
    id: '6303060018',
    districtId: '6303060',
    name: 'Limamar',
  },
  {
    id: '6303060019',
    districtId: '6303060',
    name: 'Lokgabang',
  },
  {
    id: '6303060020',
    districtId: '6303060',
    name: 'Kaliukan',
  },
  {
    id: '6303060021',
    districtId: '6303060',
    name: 'Tambak Danau',
  },
  {
    id: '6303060022',
    districtId: '6303060',
    name: 'Pematang Hambawang',
  },
  {
    id: '6303070001',
    districtId: '6303070',
    name: 'Kiram',
  },
  {
    id: '6303070002',
    districtId: '6303070',
    name: 'Mandi Angin Barat',
  },
  {
    id: '6303070003',
    districtId: '6303070',
    name: 'Mandi Angin Timur',
  },
  {
    id: '6303070004',
    districtId: '6303070',
    name: 'Awang Bangkal Barat',
  },
  {
    id: '6303070005',
    districtId: '6303070',
    name: 'Awang Bangkal Timur',
  },
  {
    id: '6303070006',
    districtId: '6303070',
    name: 'Mandi Kapau Timur',
  },
  {
    id: '6303070007',
    districtId: '6303070',
    name: 'Mandi Kapau Barat',
  },
  {
    id: '6303070008',
    districtId: '6303070',
    name: 'Pulau Nyiur',
  },
  {
    id: '6303070009',
    districtId: '6303070',
    name: 'Sungai Asam',
  },
  {
    id: '6303070010',
    districtId: '6303070',
    name: 'Sungai Alang',
  },
  {
    id: '6303070011',
    districtId: '6303070',
    name: 'Sungai Landas',
  },
  {
    id: '6303070012',
    districtId: '6303070',
    name: 'Padang Panjang',
  },
  {
    id: '6303070013',
    districtId: '6303070',
    name: 'Penyambaran',
  },
  {
    id: '6303070014',
    districtId: '6303070',
    name: 'Lihung',
  },
  {
    id: '6303070015',
    districtId: '6303070',
    name: 'Karang Intan',
  },
  {
    id: '6303070016',
    districtId: '6303070',
    name: 'Pasar Lama',
  },
  {
    id: '6303070017',
    districtId: '6303070',
    name: 'Pandak Daun',
  },
  {
    id: '6303070018',
    districtId: '6303070',
    name: 'Jingah Habang Ulu',
  },
  {
    id: '6303070019',
    districtId: '6303070',
    name: 'Jingah Habang Ilir',
  },
  {
    id: '6303070020',
    districtId: '6303070',
    name: 'Sungai Arfat',
  },
  {
    id: '6303070021',
    districtId: '6303070',
    name: 'Mali Mali',
  },
  {
    id: '6303070022',
    districtId: '6303070',
    name: 'Loktangga',
  },
  {
    id: '6303070023',
    districtId: '6303070',
    name: 'Sungai Besar',
  },
  {
    id: '6303070024',
    districtId: '6303070',
    name: "Bi'Ih",
  },
  {
    id: '6303070025',
    districtId: '6303070',
    name: 'Balau',
  },
  {
    id: '6303070026',
    districtId: '6303070',
    name: 'Abirau',
  },
  {
    id: '6303080001',
    districtId: '6303080',
    name: 'Belangian',
  },
  {
    id: '6303080002',
    districtId: '6303080',
    name: 'Paau',
  },
  {
    id: '6303080003',
    districtId: '6303080',
    name: 'Kalaan',
  },
  {
    id: '6303080004',
    districtId: '6303080',
    name: 'Tiwingan Baru',
  },
  {
    id: '6303080005',
    districtId: '6303080',
    name: 'Aranio',
  },
  {
    id: '6303080006',
    districtId: '6303080',
    name: 'Tiwingan Lama',
  },
  {
    id: '6303080007',
    districtId: '6303080',
    name: 'Benua Riam',
  },
  {
    id: '6303080008',
    districtId: '6303080',
    name: 'Artain',
  },
  {
    id: '6303080009',
    districtId: '6303080',
    name: 'Bunglai',
  },
  {
    id: '6303080010',
    districtId: '6303080',
    name: 'Apuai',
  },
  {
    id: '6303080011',
    districtId: '6303080',
    name: 'Rantau Bujur',
  },
  {
    id: '6303080012',
    districtId: '6303080',
    name: 'Rantau Balai',
  },
  {
    id: '6303090001',
    districtId: '6303090',
    name: 'Hakim Makmur',
  },
  {
    id: '6303090002',
    districtId: '6303090',
    name: 'Kahelaan',
  },
  {
    id: '6303090003',
    districtId: '6303090',
    name: 'Sumber Baru',
  },
  {
    id: '6303090004',
    districtId: '6303090',
    name: 'Sumber Harapan',
  },
  {
    id: '6303090005',
    districtId: '6303090',
    name: 'Kupang Rejo',
  },
  {
    id: '6303090006',
    districtId: '6303090',
    name: 'Sungai Pinang',
  },
  {
    id: '6303090007',
    districtId: '6303090',
    name: 'Pakutik',
  },
  {
    id: '6303090008',
    districtId: '6303090',
    name: 'Rantau Nangka',
  },
  {
    id: '6303090009',
    districtId: '6303090',
    name: 'Rantau Bakula',
  },
  {
    id: '6303090010',
    districtId: '6303090',
    name: 'Belimbing Lama',
  },
  {
    id: '6303090011',
    districtId: '6303090',
    name: 'Belimbing Baru',
  },
  {
    id: '6303091001',
    districtId: '6303091',
    name: 'Angkipih',
  },
  {
    id: '6303091002',
    districtId: '6303091',
    name: 'Remo',
  },
  {
    id: '6303091003',
    districtId: '6303091',
    name: 'Paramasan Bawah',
  },
  {
    id: '6303091004',
    districtId: '6303091',
    name: 'Paramasan Atas',
  },
  {
    id: '6303100001',
    districtId: '6303100',
    name: 'Maniapun',
  },
  {
    id: '6303100002',
    districtId: '6303100',
    name: 'Lobang Baru',
  },
  {
    id: '6303100003',
    districtId: '6303100',
    name: 'Loktunggul',
  },
  {
    id: '6303100004',
    districtId: '6303100',
    name: 'Kertak Empat',
  },
  {
    id: '6303100005',
    districtId: '6303100',
    name: 'Pengaron',
  },
  {
    id: '6303100007',
    districtId: '6303100',
    name: 'Lumpangi',
  },
  {
    id: '6303100008',
    districtId: '6303100',
    name: 'Ati`Im',
  },
  {
    id: '6303100009',
    districtId: '6303100',
    name: 'Alimukim',
  },
  {
    id: '6303100010',
    districtId: '6303100',
    name: 'Antaraku',
  },
  {
    id: '6303100011',
    districtId: '6303100',
    name: 'Panyiuran',
  },
  {
    id: '6303100014',
    districtId: '6303100',
    name: 'Mangkauk',
  },
  {
    id: '6303101001',
    districtId: '6303101',
    name: 'Madurejo',
  },
  {
    id: '6303101002',
    districtId: '6303101',
    name: 'Batu Tanam',
  },
  {
    id: '6303101003',
    districtId: '6303101',
    name: 'Gunung Batu',
  },
  {
    id: '6303101004',
    districtId: '6303101',
    name: 'Baliangin',
  },
  {
    id: '6303101005',
    districtId: '6303101',
    name: 'Batang Banyu',
  },
  {
    id: '6303101006',
    districtId: '6303101',
    name: 'Sungai Lurus',
  },
  {
    id: '6303101007',
    districtId: '6303101',
    name: 'Pasar Baru',
  },
  {
    id: '6303110001',
    districtId: '6303110',
    name: 'Baru',
  },
  {
    id: '6303110002',
    districtId: '6303110',
    name: 'Gunung Ulin',
  },
  {
    id: '6303110003',
    districtId: '6303110',
    name: 'Sungai Jati',
  },
  {
    id: '6303110004',
    districtId: '6303110',
    name: 'Takuti',
  },
  {
    id: '6303110005',
    districtId: '6303110',
    name: 'Tanah Abang',
  },
  {
    id: '6303110006',
    districtId: '6303110',
    name: 'Bawahan Pasar',
  },
  {
    id: '6303110007',
    districtId: '6303110',
    name: 'Surian',
  },
  {
    id: '6303110008',
    districtId: '6303110',
    name: 'Pematang Danau',
  },
  {
    id: '6303110009',
    districtId: '6303110',
    name: 'Pasiraman',
  },
  {
    id: '6303110010',
    districtId: '6303110',
    name: 'Bawahan Selan',
  },
  {
    id: '6303110011',
    districtId: '6303110',
    name: 'Bawahan Seberang',
  },
  {
    id: '6303110012',
    districtId: '6303110',
    name: 'Mangka Lawat',
  },
  {
    id: '6303110013',
    districtId: '6303110',
    name: 'Mataraman',
  },
  {
    id: '6303110014',
    districtId: '6303110',
    name: 'Simpang Tiga',
  },
  {
    id: '6303110015',
    districtId: '6303110',
    name: 'Lok Tamu',
  },
  {
    id: '6303120001',
    districtId: '6303120',
    name: 'Tanah Intan',
  },
  {
    id: '6303120002',
    districtId: '6303120',
    name: 'Sungai Tabuk',
  },
  {
    id: '6303120003',
    districtId: '6303120',
    name: 'Lokcantung',
  },
  {
    id: '6303120004',
    districtId: '6303120',
    name: 'Cabi',
  },
  {
    id: '6303120005',
    districtId: '6303120',
    name: 'Simpang Empat',
  },
  {
    id: '6303120006',
    districtId: '6303120',
    name: 'Sungai Raya',
  },
  {
    id: '6303120007',
    districtId: '6303120',
    name: 'Lawiran',
  },
  {
    id: '6303120008',
    districtId: '6303120',
    name: 'Sungai Langsat',
  },
  {
    id: '6303120009',
    districtId: '6303120',
    name: 'Paring Tali',
  },
  {
    id: '6303120010',
    districtId: '6303120',
    name: 'Batu Balian',
  },
  {
    id: '6303120011',
    districtId: '6303120',
    name: 'Sungkai',
  },
  {
    id: '6303120012',
    districtId: '6303120',
    name: 'Pasar Lama',
  },
  {
    id: '6303120013',
    districtId: '6303120',
    name: 'Sungkai Baru',
  },
  {
    id: '6303120014',
    districtId: '6303120',
    name: 'Berkat Mulya',
  },
  {
    id: '6303120015',
    districtId: '6303120',
    name: 'Paku',
  },
  {
    id: '6303120016',
    districtId: '6303120',
    name: 'Keramat Mina',
  },
  {
    id: '6303120017',
    districtId: '6303120',
    name: 'Cinta Puri',
  },
  {
    id: '6303120018',
    districtId: '6303120',
    name: 'Surian',
  },
  {
    id: '6303120019',
    districtId: '6303120',
    name: 'Simpang Lima',
  },
  {
    id: '6303120020',
    districtId: '6303120',
    name: 'Sindang Jaya',
  },
  {
    id: '6303120021',
    districtId: '6303120',
    name: 'Karya Makmur',
  },
  {
    id: '6303120022',
    districtId: '6303120',
    name: 'Makmur Karya',
  },
  {
    id: '6303120023',
    districtId: '6303120',
    name: 'Alalak Padang',
  },
  {
    id: '6303120024',
    districtId: '6303120',
    name: 'Benua Anyar',
  },
  {
    id: '6303120025',
    districtId: '6303120',
    name: 'Garis Hanyar',
  },
  {
    id: '6303120030',
    districtId: '6303120',
    name: 'Sumber Sari',
  },
  {
    id: '6303121001',
    districtId: '6303121',
    name: 'Telaga Baru',
  },
  {
    id: '6303121002',
    districtId: '6303121',
    name: 'Loktanah',
  },
  {
    id: '6303121003',
    districtId: '6303121',
    name: 'Rantau Bujur',
  },
  {
    id: '6303121004',
    districtId: '6303121',
    name: 'Rampah',
  },
  {
    id: '6304010001',
    districtId: '6304010',
    name: 'Kuala Lupak',
  },
  {
    id: '6304010002',
    districtId: '6304010',
    name: 'Sungai Telan Besar',
  },
  {
    id: '6304010003',
    districtId: '6304010',
    name: 'Sungai Telan Kecil',
  },
  {
    id: '6304010004',
    districtId: '6304010',
    name: 'Sungai Telan Muara',
  },
  {
    id: '6304010005',
    districtId: '6304010',
    name: 'Tabunganen Muara',
  },
  {
    id: '6304010006',
    districtId: '6304010',
    name: 'Tabunganen Kecil',
  },
  {
    id: '6304010007',
    districtId: '6304010',
    name: 'Tabunganen Tengah',
  },
  {
    id: '6304010008',
    districtId: '6304010',
    name: 'Karya Baru',
  },
  {
    id: '6304010009',
    districtId: '6304010',
    name: 'Tabunganen Pemurus',
  },
  {
    id: '6304010010',
    districtId: '6304010',
    name: 'Tanggul Rejo',
  },
  {
    id: '6304010011',
    districtId: '6304010',
    name: 'Beringin Kencana',
  },
  {
    id: '6304010012',
    districtId: '6304010',
    name: 'Sungai Teras Dalam',
  },
  {
    id: '6304010013',
    districtId: '6304010',
    name: 'Sungai Teras Luar',
  },
  {
    id: '6304010014',
    districtId: '6304010',
    name: 'Sungai Jingah Besar',
  },
  {
    id: '6304020001',
    districtId: '6304020',
    name: 'Sekata Baru',
  },
  {
    id: '6304020002',
    districtId: '6304020',
    name: 'Damsari',
  },
  {
    id: '6304020003',
    districtId: '6304020',
    name: 'Purwosari II',
  },
  {
    id: '6304020004',
    districtId: '6304020',
    name: 'Sidorejo',
  },
  {
    id: '6304020005',
    districtId: '6304020',
    name: 'Koanda',
  },
  {
    id: '6304020006',
    districtId: '6304020',
    name: 'Purwosari Baru',
  },
  {
    id: '6304020007',
    districtId: '6304020',
    name: 'Tamban Sari Baru',
  },
  {
    id: '6304020008',
    districtId: '6304020',
    name: 'Purwosari I',
  },
  {
    id: '6304020009',
    districtId: '6304020',
    name: 'Tamban Bangun',
  },
  {
    id: '6304020010',
    districtId: '6304020',
    name: 'Tamban Bangun Baru',
  },
  {
    id: '6304020011',
    districtId: '6304020',
    name: 'Tamban Muara Baru',
  },
  {
    id: '6304020012',
    districtId: '6304020',
    name: 'Tamban Muara',
  },
  {
    id: '6304020013',
    districtId: '6304020',
    name: 'Tamban Kecil',
  },
  {
    id: '6304020014',
    districtId: '6304020',
    name: 'Tinggiran II',
  },
  {
    id: '6304020015',
    districtId: '6304020',
    name: 'Jelapat I',
  },
  {
    id: '6304020016',
    districtId: '6304020',
    name: 'Jelapat Baru',
  },
  {
    id: '6304030001',
    districtId: '6304030',
    name: 'Tamban Raya',
  },
  {
    id: '6304030002',
    districtId: '6304030',
    name: 'Tamban Raya Baru',
  },
  {
    id: '6304030003',
    districtId: '6304030',
    name: 'Karang Mekar',
  },
  {
    id: '6304030004',
    districtId: '6304030',
    name: 'Indah Sari',
  },
  {
    id: '6304030005',
    districtId: '6304030',
    name: 'Mekar Sari',
  },
  {
    id: '6304030006',
    districtId: '6304030',
    name: 'Tinggiran Darat',
  },
  {
    id: '6304030007',
    districtId: '6304030',
    name: 'Jelapat II',
  },
  {
    id: '6304030008',
    districtId: '6304030',
    name: 'Tinggiran Tengah',
  },
  {
    id: '6304030009',
    districtId: '6304030',
    name: 'Tinggiran Baru',
  },
  {
    id: '6304040001',
    districtId: '6304040',
    name: 'Pandan Sari',
  },
  {
    id: '6304040002',
    districtId: '6304040',
    name: 'Andaman',
  },
  {
    id: '6304040003',
    districtId: '6304040',
    name: 'Andaman II',
  },
  {
    id: '6304040004',
    districtId: '6304040',
    name: 'Anjir Seberang Pasar II',
  },
  {
    id: '6304040005',
    districtId: '6304040',
    name: 'Anjir Seberang Pasar',
  },
  {
    id: '6304040006',
    districtId: '6304040',
    name: 'Anjir Pasar Lama',
  },
  {
    id: '6304040007',
    districtId: '6304040',
    name: 'Anjir Pasar Kota II',
  },
  {
    id: '6304040008',
    districtId: '6304040',
    name: 'Anjir Pasar Kota',
  },
  {
    id: '6304040009',
    districtId: '6304040',
    name: 'Barunai Baru',
  },
  {
    id: '6304040010',
    districtId: '6304040',
    name: 'Hilir Mesjid',
  },
  {
    id: '6304040011',
    districtId: '6304040',
    name: 'Banyiur',
  },
  {
    id: '6304040012',
    districtId: '6304040',
    name: 'Danau Karya',
  },
  {
    id: '6304040013',
    districtId: '6304040',
    name: 'Mentaren',
  },
  {
    id: '6304040014',
    districtId: '6304040',
    name: 'Gandaria',
  },
  {
    id: '6304040015',
    districtId: '6304040',
    name: 'Gandaraya',
  },
  {
    id: '6304050001',
    districtId: '6304050',
    name: 'Anjir Serapat Baru I',
  },
  {
    id: '6304050002',
    districtId: '6304050',
    name: 'Anjir Serapat Baru',
  },
  {
    id: '6304050003',
    districtId: '6304050',
    name: 'Sepakat Bersama',
  },
  {
    id: '6304050004',
    districtId: '6304050',
    name: 'Anjir Serapat Lama',
  },
  {
    id: '6304050005',
    districtId: '6304050',
    name: 'Anjir Serapat Muara',
  },
  {
    id: '6304050006',
    districtId: '6304050',
    name: 'Anjir Serapat Muara I',
  },
  {
    id: '6304050007',
    districtId: '6304050',
    name: 'Marabahan Baru',
  },
  {
    id: '6304050008',
    districtId: '6304050',
    name: 'Anjir Muara Kota',
  },
  {
    id: '6304050009',
    districtId: '6304050',
    name: 'Patih Muhur',
  },
  {
    id: '6304050010',
    districtId: '6304050',
    name: 'Anjir Muara Kota Tengah',
  },
  {
    id: '6304050011',
    districtId: '6304050',
    name: 'Beringin Jaya',
  },
  {
    id: '6304050012',
    districtId: '6304050',
    name: 'Anjir Muara Lama',
  },
  {
    id: '6304050013',
    districtId: '6304050',
    name: 'Sungai Punggu Baru',
  },
  {
    id: '6304050014',
    districtId: '6304050',
    name: 'Patih Muhur Baru',
  },
  {
    id: '6304050015',
    districtId: '6304050',
    name: 'Sungai Punggu',
  },
  {
    id: '6304060001',
    districtId: '6304060',
    name: 'Pulau Sugara',
  },
  {
    id: '6304060002',
    districtId: '6304060',
    name: 'Pulau Sewangi',
  },
  {
    id: '6304060003',
    districtId: '6304060',
    name: 'Pulau Alalak',
  },
  {
    id: '6304060004',
    districtId: '6304060',
    name: 'Semangat Karya',
  },
  {
    id: '6304060005',
    districtId: '6304060',
    name: 'Semangat Bakti',
  },
  {
    id: '6304060006',
    districtId: '6304060',
    name: 'Semangat Dalam',
  },
  {
    id: '6304060007',
    districtId: '6304060',
    name: 'Handil Bakti',
  },
  {
    id: '6304060008',
    districtId: '6304060',
    name: 'Tatah Mesjid',
  },
  {
    id: '6304060009',
    districtId: '6304060',
    name: 'Berangas Timur',
  },
  {
    id: '6304060010',
    districtId: '6304060',
    name: 'Berangas',
  },
  {
    id: '6304060011',
    districtId: '6304060',
    name: 'Berangas Barat',
  },
  {
    id: '6304060012',
    districtId: '6304060',
    name: 'Sungai Lumbah',
  },
  {
    id: '6304060013',
    districtId: '6304060',
    name: 'Beringin',
  },
  {
    id: '6304060014',
    districtId: '6304060',
    name: 'Sungai Pitung',
  },
  {
    id: '6304060015',
    districtId: '6304060',
    name: 'Belandean Muara',
  },
  {
    id: '6304060016',
    districtId: '6304060',
    name: 'Belandean',
  },
  {
    id: '6304060017',
    districtId: '6304060',
    name: 'Panca Karya',
  },
  {
    id: '6304060018',
    districtId: '6304060',
    name: 'Tanjung Harapan',
  },
  {
    id: '6304070001',
    districtId: '6304070',
    name: 'Lok Rawa',
  },
  {
    id: '6304070002',
    districtId: '6304070',
    name: 'Terantang',
  },
  {
    id: '6304070003',
    districtId: '6304070',
    name: 'Sungai Ramania',
  },
  {
    id: '6304070004',
    districtId: '6304070',
    name: 'Puntik Luar',
  },
  {
    id: '6304070005',
    districtId: '6304070',
    name: 'Puntik Tengah',
  },
  {
    id: '6304070006',
    districtId: '6304070',
    name: 'Puntik Dalam',
  },
  {
    id: '6304070007',
    districtId: '6304070',
    name: 'Karang Indah',
  },
  {
    id: '6304070008',
    districtId: '6304070',
    name: 'Karang Bunga',
  },
  {
    id: '6304070009',
    districtId: '6304070',
    name: 'Tabing Rimbah',
  },
  {
    id: '6304070010',
    districtId: '6304070',
    name: 'Bangkit Baru',
  },
  {
    id: '6304070011',
    districtId: '6304070',
    name: 'Tanipah',
  },
  {
    id: '6304070012',
    districtId: '6304070',
    name: 'Tatah Alayung',
  },
  {
    id: '6304070013',
    districtId: '6304070',
    name: 'Antasan Segara',
  },
  {
    id: '6304070014',
    districtId: '6304070',
    name: 'Pantai Hambawang',
  },
  {
    id: '6304071001',
    districtId: '6304071',
    name: 'Cahaya Baru',
  },
  {
    id: '6304071002',
    districtId: '6304071',
    name: 'Sampurna',
  },
  {
    id: '6304071003',
    districtId: '6304071',
    name: 'Bahandang',
  },
  {
    id: '6304071004',
    districtId: '6304071',
    name: 'Jejangkit Muara',
  },
  {
    id: '6304071005',
    districtId: '6304071',
    name: 'Jejangkit Pasar',
  },
  {
    id: '6304071006',
    districtId: '6304071',
    name: 'Jejangkit Barat',
  },
  {
    id: '6304071007',
    districtId: '6304071',
    name: 'Jejangkit Timur',
  },
  {
    id: '6304080001',
    districtId: '6304080',
    name: 'Rangga Surya',
  },
  {
    id: '6304080002',
    districtId: '6304080',
    name: 'Karang Buah',
  },
  {
    id: '6304080003',
    districtId: '6304080',
    name: 'Karang Dukuh',
  },
  {
    id: '6304080004',
    districtId: '6304080',
    name: 'Samuda',
  },
  {
    id: '6304080005',
    districtId: '6304080',
    name: 'Murung Keramat',
  },
  {
    id: '6304080006',
    districtId: '6304080',
    name: 'Sungai Seluang Pasar',
  },
  {
    id: '6304080007',
    districtId: '6304080',
    name: 'Sungai Seluang',
  },
  {
    id: '6304080008',
    districtId: '6304080',
    name: 'Binaan Baru',
  },
  {
    id: '6304080009',
    districtId: '6304080',
    name: 'Belawang',
  },
  {
    id: '6304080010',
    districtId: '6304080',
    name: 'Parimata',
  },
  {
    id: '6304080011',
    districtId: '6304080',
    name: 'Patih Salera',
  },
  {
    id: '6304080012',
    districtId: '6304080',
    name: 'Bambangin',
  },
  {
    id: '6304080013',
    districtId: '6304080',
    name: 'Sukaramai',
  },
  {
    id: '6304090001',
    districtId: '6304090',
    name: 'Tumih',
  },
  {
    id: '6304090002',
    districtId: '6304090',
    name: 'Roham Raya',
  },
  {
    id: '6304090003',
    districtId: '6304090',
    name: 'Belawang Kolam Kiri',
  },
  {
    id: '6304090004',
    districtId: '6304090',
    name: 'Babat Raya',
  },
  {
    id: '6304090005',
    districtId: '6304090',
    name: 'Belawang Kolam Kanan',
  },
  {
    id: '6304090006',
    districtId: '6304090',
    name: 'Sido Mulyo',
  },
  {
    id: '6304090007',
    districtId: '6304090',
    name: 'Kolam Makmur',
  },
  {
    id: '6304090008',
    districtId: '6304090',
    name: 'Simpang Jaya',
  },
  {
    id: '6304090009',
    districtId: '6304090',
    name: 'Waringin Kencana',
  },
  {
    id: '6304090010',
    districtId: '6304090',
    name: 'Pinang Habang',
  },
  {
    id: '6304090011',
    districtId: '6304090',
    name: 'Surya Kanta',
  },
  {
    id: '6304090012',
    districtId: '6304090',
    name: 'Sumber Rahayu',
  },
  {
    id: '6304090013',
    districtId: '6304090',
    name: 'Dwi Pasari',
  },
  {
    id: '6304100001',
    districtId: '6304100',
    name: 'Handil Barabai',
  },
  {
    id: '6304100002',
    districtId: '6304100',
    name: 'Sungai Kali',
  },
  {
    id: '6304100003',
    districtId: '6304100',
    name: 'Bagagap',
  },
  {
    id: '6304100004',
    districtId: '6304100',
    name: 'Barambai',
  },
  {
    id: '6304100005',
    districtId: '6304100',
    name: 'Karya Baru',
  },
  {
    id: '6304100006',
    districtId: '6304100',
    name: 'Karya Tani',
  },
  {
    id: '6304100007',
    districtId: '6304100',
    name: 'Barambai Kolam Kiri',
  },
  {
    id: '6304100008',
    districtId: '6304100',
    name: 'Barambai Kolam Kanan',
  },
  {
    id: '6304100009',
    districtId: '6304100',
    name: 'Pendalaman',
  },
  {
    id: '6304100010',
    districtId: '6304100',
    name: 'Pendalaman Baru',
  },
  {
    id: '6304100011',
    districtId: '6304100',
    name: 'Kolam Kiri Dalam',
  },
  {
    id: '6304110001',
    districtId: '6304110',
    name: 'Sungai Pantai',
  },
  {
    id: '6304110002',
    districtId: '6304110',
    name: 'Pindahan Baru',
  },
  {
    id: '6304110003',
    districtId: '6304110',
    name: 'Danda Jaya',
  },
  {
    id: '6304110004',
    districtId: '6304110',
    name: 'Sungai Gampa Asahi',
  },
  {
    id: '6304110005',
    districtId: '6304110',
    name: 'Sungai Bamban',
  },
  {
    id: '6304110006',
    districtId: '6304110',
    name: 'Sungai Gampa',
  },
  {
    id: '6304110007',
    districtId: '6304110',
    name: 'Sungai Sahurai',
  },
  {
    id: '6304110008',
    districtId: '6304110',
    name: 'Simpang Arja',
  },
  {
    id: '6304110009',
    districtId: '6304110',
    name: 'Sinar Baru',
  },
  {
    id: '6304120001',
    districtId: '6304120',
    name: 'Sungai Rasau',
  },
  {
    id: '6304120002',
    districtId: '6304120',
    name: 'Sungai Tunjang',
  },
  {
    id: '6304120003',
    districtId: '6304120',
    name: 'Simpang Nungki',
  },
  {
    id: '6304120004',
    districtId: '6304120',
    name: 'Sawahan',
  },
  {
    id: '6304120005',
    districtId: '6304120',
    name: 'Bantuil',
  },
  {
    id: '6304120006',
    districtId: '6304120',
    name: 'Badandan',
  },
  {
    id: '6304120007',
    districtId: '6304120',
    name: 'Sungai Raya',
  },
  {
    id: '6304120008',
    districtId: '6304120',
    name: 'Sungai Kambat',
  },
  {
    id: '6304130001',
    districtId: '6304130',
    name: 'Batik',
  },
  {
    id: '6304130002',
    districtId: '6304130',
    name: 'Lepasan',
  },
  {
    id: '6304130003',
    districtId: '6304130',
    name: 'Bahalayung',
  },
  {
    id: '6304130004',
    districtId: '6304130',
    name: 'Benua Anyar',
  },
  {
    id: '6304130005',
    districtId: '6304130',
    name: 'Murung Raya',
  },
  {
    id: '6304130006',
    districtId: '6304130',
    name: 'Sungai Lirik',
  },
  {
    id: '6304130007',
    districtId: '6304130',
    name: 'Banitan',
  },
  {
    id: '6304130008',
    districtId: '6304130',
    name: 'Palingkau',
  },
  {
    id: '6304130009',
    districtId: '6304130',
    name: 'Balukung',
  },
  {
    id: '6304140001',
    districtId: '6304140',
    name: 'Bagus',
  },
  {
    id: '6304140002',
    districtId: '6304140',
    name: 'Baliuk',
  },
  {
    id: '6304140004',
    districtId: '6304140',
    name: 'Marabahan Kota',
  },
  {
    id: '6304140006',
    districtId: '6304140',
    name: 'Antar Baru',
  },
  {
    id: '6304140007',
    districtId: '6304140',
    name: 'Antar Raya',
  },
  {
    id: '6304140008',
    districtId: '6304140',
    name: 'Antar Jaya',
  },
  {
    id: '6304140009',
    districtId: '6304140',
    name: 'Sido Makmur',
  },
  {
    id: '6304140010',
    districtId: '6304140',
    name: 'Karya Maju',
  },
  {
    id: '6304150001',
    districtId: '6304150',
    name: 'Pantang Baru',
  },
  {
    id: '6304150002',
    districtId: '6304150',
    name: 'Pantang Raya',
  },
  {
    id: '6304150003',
    districtId: '6304150',
    name: 'Bandar Karya',
  },
  {
    id: '6304150004',
    districtId: '6304150',
    name: 'Tabukan Raya',
  },
  {
    id: '6304150005',
    districtId: '6304150',
    name: 'Karya Indah',
  },
  {
    id: '6304150006',
    districtId: '6304150',
    name: 'Karya Jadi',
  },
  {
    id: '6304150007',
    districtId: '6304150',
    name: 'Karya Makmur',
  },
  {
    id: '6304150008',
    districtId: '6304150',
    name: 'Teluk Tamba',
  },
  {
    id: '6304150009',
    districtId: '6304150',
    name: 'Tamba Jaya',
  },
  {
    id: '6304150010',
    districtId: '6304150',
    name: 'Rantau Bamban',
  },
  {
    id: '6304150011',
    districtId: '6304150',
    name: 'Muara Pulau',
  },
  {
    id: '6304160001',
    districtId: '6304160',
    name: 'Jambu Baru',
  },
  {
    id: '6304160002',
    districtId: '6304160',
    name: 'Jambu',
  },
  {
    id: '6304160003',
    districtId: '6304160',
    name: 'Kabuau',
  },
  {
    id: '6304160004',
    districtId: '6304160',
    name: 'Asia Baru',
  },
  {
    id: '6304160005',
    districtId: '6304160',
    name: 'Jarenang',
  },
  {
    id: '6304160006',
    districtId: '6304160',
    name: 'Kuripan',
  },
  {
    id: '6304160007',
    districtId: '6304160',
    name: 'Rimbun Tulang',
  },
  {
    id: '6304160008',
    districtId: '6304160',
    name: 'Tabatan',
  },
  {
    id: '6304160009',
    districtId: '6304160',
    name: 'Tabatan Baru',
  },
  {
    id: '6305010001',
    districtId: '6305010',
    name: 'Tungkap',
  },
  {
    id: '6305010002',
    districtId: '6305010',
    name: 'A Yani Pura',
  },
  {
    id: '6305010003',
    districtId: '6305010',
    name: 'Gunung Batu',
  },
  {
    id: '6305010012',
    districtId: '6305010',
    name: 'Padang Sari',
  },
  {
    id: '6305010013',
    districtId: '6305010',
    name: 'Pualam Sari',
  },
  {
    id: '6305010014',
    districtId: '6305010',
    name: 'Binuang',
  },
  {
    id: '6305010015',
    districtId: '6305010',
    name: 'Pulau Pinang',
  },
  {
    id: '6305010016',
    districtId: '6305010',
    name: 'Pulau Pinang Utara',
  },
  {
    id: '6305010017',
    districtId: '6305010',
    name: 'Raya Belanti',
  },
  {
    id: '6305010018',
    districtId: '6305010',
    name: 'Karangan Putih',
  },
  {
    id: '6305010019',
    districtId: '6305010',
    name: 'Mekar Sari',
  },
  {
    id: '6305011001',
    districtId: '6305011',
    name: 'Matang Batas',
  },
  {
    id: '6305011002',
    districtId: '6305011',
    name: 'Burakai',
  },
  {
    id: '6305011003',
    districtId: '6305011',
    name: 'Hatungun',
  },
  {
    id: '6305011004',
    districtId: '6305011',
    name: 'Tarungin',
  },
  {
    id: '6305011005',
    districtId: '6305011',
    name: 'Bagak',
  },
  {
    id: '6305011006',
    districtId: '6305011',
    name: 'Asam Randah',
  },
  {
    id: '6305011007',
    districtId: '6305011',
    name: 'Batu Hapu',
  },
  {
    id: '6305011008',
    districtId: '6305011',
    name: 'Kambang Kuning',
  },
  {
    id: '6305020001',
    districtId: '6305020',
    name: 'Tatakan',
  },
  {
    id: '6305020005',
    districtId: '6305020',
    name: 'Suato Tatakan',
  },
  {
    id: '6305020006',
    districtId: '6305020',
    name: 'Tandui',
  },
  {
    id: '6305020007',
    districtId: '6305020',
    name: 'Lawahan',
  },
  {
    id: '6305020008',
    districtId: '6305020',
    name: 'Rumintin',
  },
  {
    id: '6305020012',
    districtId: '6305020',
    name: 'Sawang',
  },
  {
    id: '6305020013',
    districtId: '6305020',
    name: 'Tambarangan',
  },
  {
    id: '6305020014',
    districtId: '6305020',
    name: 'Cempaka',
  },
  {
    id: '6305020015',
    districtId: '6305020',
    name: 'Timbaan',
  },
  {
    id: '6305020016',
    districtId: '6305020',
    name: 'Harapan Masa',
  },
  {
    id: '6305020017',
    districtId: '6305020',
    name: 'Hatiwin',
  },
  {
    id: '6305021001',
    districtId: '6305021',
    name: 'Kambang Habang Baru',
  },
  {
    id: '6305021002',
    districtId: '6305021',
    name: 'Kambang Habang Lama',
  },
  {
    id: '6305021003',
    districtId: '6305021',
    name: 'Suato Lama',
  },
  {
    id: '6305021004',
    districtId: '6305021',
    name: 'Pantai Cabe',
  },
  {
    id: '6305021005',
    districtId: '6305021',
    name: 'Suato Baru',
  },
  {
    id: '6305021006',
    districtId: '6305021',
    name: 'Salam Babaris',
  },
  {
    id: '6305030001',
    districtId: '6305030',
    name: 'Sukaramai',
  },
  {
    id: '6305030002',
    districtId: '6305030',
    name: 'Pandulangan',
  },
  {
    id: '6305030003',
    districtId: '6305030',
    name: 'Labung',
  },
  {
    id: '6305030004',
    districtId: '6305030',
    name: 'Tirik',
  },
  {
    id: '6305030005',
    districtId: '6305030',
    name: 'Mandurian',
  },
  {
    id: '6305030006',
    districtId: '6305030',
    name: 'Mandurian Hilir',
  },
  {
    id: '6305030007',
    districtId: '6305030',
    name: 'Pematang Karangan Hulu',
  },
  {
    id: '6305030008',
    districtId: '6305030',
    name: 'Andhika',
  },
  {
    id: '6305030009',
    districtId: '6305030',
    name: 'Sungai Bahalang',
  },
  {
    id: '6305030010',
    districtId: '6305030',
    name: 'Pematang Karangan',
  },
  {
    id: '6305030011',
    districtId: '6305030',
    name: 'Papagan Makmur',
  },
  {
    id: '6305030012',
    districtId: '6305030',
    name: 'Serawi',
  },
  {
    id: '6305030013',
    districtId: '6305030',
    name: 'Batang Lantik',
  },
  {
    id: '6305030014',
    districtId: '6305030',
    name: 'Kepayang',
  },
  {
    id: '6305030015',
    districtId: '6305030',
    name: 'Pandahan',
  },
  {
    id: '6305030016',
    districtId: '6305030',
    name: 'Pematang Karangan Hilir',
  },
  {
    id: '6305030017',
    districtId: '6305030',
    name: 'Hiyung',
  },
  {
    id: '6305040001',
    districtId: '6305040',
    name: 'Paring Guling',
  },
  {
    id: '6305040002',
    districtId: '6305040',
    name: 'Rantau Bujur',
  },
  {
    id: '6305040003',
    districtId: '6305040',
    name: 'Hangui',
  },
  {
    id: '6305040004',
    districtId: '6305040',
    name: 'Linuh',
  },
  {
    id: '6305040005',
    districtId: '6305040',
    name: 'Kalumpang',
  },
  {
    id: '6305040006',
    districtId: '6305040',
    name: 'Shabah',
  },
  {
    id: '6305040007',
    districtId: '6305040',
    name: 'Timbung',
  },
  {
    id: '6305040009',
    districtId: '6305040',
    name: 'Banua Padang',
  },
  {
    id: '6305040010',
    districtId: '6305040',
    name: 'Banua Padang Hilir',
  },
  {
    id: '6305040012',
    districtId: '6305040',
    name: 'Bungur Baru',
  },
  {
    id: '6305050001',
    districtId: '6305050',
    name: 'Baramban',
  },
  {
    id: '6305050002',
    districtId: '6305050',
    name: 'Miawa',
  },
  {
    id: '6305050003',
    districtId: '6305050',
    name: "Buni'In Jaya",
  },
  {
    id: '6305050004',
    districtId: '6305050',
    name: 'Batu Ampar',
  },
  {
    id: '6305050005',
    districtId: '6305050',
    name: 'Pipitak Jaya',
  },
  {
    id: '6305050006',
    districtId: '6305050',
    name: 'Harakit',
  },
  {
    id: '6305050007',
    districtId: '6305050',
    name: 'Batung',
  },
  {
    id: '6305050008',
    districtId: '6305050',
    name: 'Balawaian',
  },
  {
    id: '6305060001',
    districtId: '6305060',
    name: 'Ayunan Papan',
  },
  {
    id: '6305060002',
    districtId: '6305060',
    name: 'Bitahan Baru',
  },
  {
    id: '6305060003',
    districtId: '6305060',
    name: 'Bitahan',
  },
  {
    id: '6305060004',
    districtId: '6305060',
    name: 'Binderang',
  },
  {
    id: '6305060005',
    districtId: '6305060',
    name: 'Lokpaikat',
  },
  {
    id: '6305060006',
    districtId: '6305060',
    name: 'Budi Mulya',
  },
  {
    id: '6305060007',
    districtId: '6305060',
    name: 'Puncak Harapan',
  },
  {
    id: '6305060008',
    districtId: '6305060',
    name: 'Bataratat',
  },
  {
    id: '6305060009',
    districtId: '6305060',
    name: 'Parandakan',
  },
  {
    id: '6305070001',
    districtId: '6305070',
    name: 'Antasari Hilir',
  },
  {
    id: '6305070002',
    districtId: '6305070',
    name: 'Antasari',
  },
  {
    id: '6305070003',
    districtId: '6305070',
    name: 'Kupang',
  },
  {
    id: '6305070004',
    districtId: '6305070',
    name: 'Rangda Malingkung',
  },
  {
    id: '6305070005',
    districtId: '6305070',
    name: 'Rantau Kiwa',
  },
  {
    id: '6305070006',
    districtId: '6305070',
    name: 'Perintis Raya',
  },
  {
    id: '6305070007',
    districtId: '6305070',
    name: 'Rantau Kanan',
  },
  {
    id: '6305070008',
    districtId: '6305070',
    name: 'Banua Halat Kiri',
  },
  {
    id: '6305070009',
    districtId: '6305070',
    name: 'Lumbu Raya',
  },
  {
    id: '6305070010',
    districtId: '6305070',
    name: 'Keramat',
  },
  {
    id: '6305070011',
    districtId: '6305070',
    name: 'Banua Halat Kanan',
  },
  {
    id: '6305070012',
    districtId: '6305070',
    name: 'Jingah Babaris',
  },
  {
    id: '6305070013',
    districtId: '6305070',
    name: 'Kakaran',
  },
  {
    id: '6305070014',
    districtId: '6305070',
    name: 'Badaun',
  },
  {
    id: '6305070015',
    districtId: '6305070',
    name: 'Banua Hanyar Hulu',
  },
  {
    id: '6305070016',
    districtId: '6305070',
    name: 'Banua Hanyar',
  },
  {
    id: '6305080001',
    districtId: '6305080',
    name: 'Parigi Kacil',
  },
  {
    id: '6305080002',
    districtId: '6305080',
    name: 'Parigi',
  },
  {
    id: '6305080003',
    districtId: '6305080',
    name: 'Bakarangan',
  },
  {
    id: '6305080004',
    districtId: '6305080',
    name: 'Paul',
  },
  {
    id: '6305080005',
    districtId: '6305080',
    name: 'Waringin',
  },
  {
    id: '6305080006',
    districtId: '6305080',
    name: 'Tangkawang Baru',
  },
  {
    id: '6305080007',
    districtId: '6305080',
    name: 'Tangkawang',
  },
  {
    id: '6305080008',
    districtId: '6305080',
    name: 'Gadung Karamat',
  },
  {
    id: '6305080009',
    districtId: '6305080',
    name: 'Ketapang',
  },
  {
    id: '6305080011',
    districtId: '6305080',
    name: 'Gadung',
  },
  {
    id: '6305080012',
    districtId: '6305080',
    name: 'Masta',
  },
  {
    id: '6305090001',
    districtId: '6305090',
    name: 'Sungai Rutas',
  },
  {
    id: '6305090002',
    districtId: '6305090',
    name: 'Sungai Rutas Hulu',
  },
  {
    id: '6305090003',
    districtId: '6305090',
    name: 'Pabaungan Hulu',
  },
  {
    id: '6305090004',
    districtId: '6305090',
    name: 'Pabaungan Pantai',
  },
  {
    id: '6305090005',
    districtId: '6305090',
    name: 'Pabaungan Hilir',
  },
  {
    id: '6305090006',
    districtId: '6305090',
    name: 'Marampiau',
  },
  {
    id: '6305090007',
    districtId: '6305090',
    name: 'Marampiau Hilir',
  },
  {
    id: '6305090008',
    districtId: '6305090',
    name: 'Baringin',
  },
  {
    id: '6305090009',
    districtId: '6305090',
    name: 'Baringin B',
  },
  {
    id: '6305090010',
    districtId: '6305090',
    name: 'Margasari Hulu',
  },
  {
    id: '6305090011',
    districtId: '6305090',
    name: 'Candi Laras',
  },
  {
    id: '6305090012',
    districtId: '6305090',
    name: 'Baulin',
  },
  {
    id: '6305100001',
    districtId: '6305100',
    name: 'Kaladan',
  },
  {
    id: '6305100002',
    districtId: '6305100',
    name: 'Sungai Salai Hilir',
  },
  {
    id: '6305100003',
    districtId: '6305100',
    name: 'Sungai Salai',
  },
  {
    id: '6305100004',
    districtId: '6305100',
    name: 'Sungai Puting',
  },
  {
    id: '6305100005',
    districtId: '6305100',
    name: 'Pariok',
  },
  {
    id: '6305100006',
    districtId: '6305100',
    name: 'Margasari Ilir',
  },
  {
    id: '6305100007',
    districtId: '6305100',
    name: 'Batalas',
  },
  {
    id: '6305100008',
    districtId: '6305100',
    name: 'Teluk Haur',
  },
  {
    id: '6305100009',
    districtId: '6305100',
    name: 'Rawana',
  },
  {
    id: '6305100010',
    districtId: '6305100',
    name: 'Rawana Hulu',
  },
  {
    id: '6305100011',
    districtId: '6305100',
    name: 'Buas Buas Hilir',
  },
  {
    id: '6305100012',
    districtId: '6305100',
    name: 'Buas Buas',
  },
  {
    id: '6305100013',
    districtId: '6305100',
    name: 'Sawaja',
  },
  {
    id: '6306010001',
    districtId: '6306010',
    name: 'Malutu',
  },
  {
    id: '6306010005',
    districtId: '6306010',
    name: 'Malilingin',
  },
  {
    id: '6306010006',
    districtId: '6306010',
    name: 'Batu Laki',
  },
  {
    id: '6306010009',
    districtId: '6306010',
    name: 'Jalatang',
  },
  {
    id: '6306010011',
    districtId: '6306010',
    name: 'Batu Bini',
  },
  {
    id: '6306010012',
    districtId: '6306010',
    name: 'Durian Rabung',
  },
  {
    id: '6306010015',
    districtId: '6306010',
    name: 'Pahampangan',
  },
  {
    id: '6306010016',
    districtId: '6306010',
    name: 'Jambu Hulu',
  },
  {
    id: '6306010018',
    districtId: '6306010',
    name: 'Padang Batung',
  },
  {
    id: '6306010020',
    districtId: '6306010',
    name: 'Mawangi',
  },
  {
    id: '6306010024',
    districtId: '6306010',
    name: 'Jembatan Merah',
  },
  {
    id: '6306010026',
    districtId: '6306010',
    name: 'Kaliring',
  },
  {
    id: '6306010027',
    districtId: '6306010',
    name: 'Madang',
  },
  {
    id: '6306010028',
    districtId: '6306010',
    name: 'Karang Jawa',
  },
  {
    id: '6306010029',
    districtId: '6306010',
    name: 'Karang Jawa Muka',
  },
  {
    id: '6306010030',
    districtId: '6306010',
    name: 'Tabihi',
  },
  {
    id: '6306010034',
    districtId: '6306010',
    name: 'Pandulangan',
  },
  {
    id: '6306020002',
    districtId: '6306020',
    name: 'Halunuk',
  },
  {
    id: '6306020003',
    districtId: '6306020',
    name: 'Panggungan',
  },
  {
    id: '6306020004',
    districtId: '6306020',
    name: 'Lumpangi',
  },
  {
    id: '6306020005',
    districtId: '6306020',
    name: 'Malinau',
  },
  {
    id: '6306020006',
    districtId: '6306020',
    name: 'Hulu Banyu',
  },
  {
    id: '6306020007',
    districtId: '6306020',
    name: 'Tumingki',
  },
  {
    id: '6306020008',
    districtId: '6306020',
    name: 'Kamawakan',
  },
  {
    id: '6306020009',
    districtId: '6306020',
    name: 'Lok Lahung',
  },
  {
    id: '6306020010',
    districtId: '6306020',
    name: 'Loksado',
  },
  {
    id: '6306020012',
    districtId: '6306020',
    name: 'Muara Ulang',
  },
  {
    id: '6306020013',
    districtId: '6306020',
    name: 'Haratai',
  },
  {
    id: '6306030001',
    districtId: '6306030',
    name: 'Ambutun',
  },
  {
    id: '6306030003',
    districtId: '6306030',
    name: 'Lok Binuang',
  },
  {
    id: '6306030004',
    districtId: '6306030',
    name: 'Telaga Langsat',
  },
  {
    id: '6306030005',
    districtId: '6306030',
    name: 'Mandala',
  },
  {
    id: '6306030008',
    districtId: '6306030',
    name: 'Pakuan Timur',
  },
  {
    id: '6306030010',
    districtId: '6306030',
    name: 'Pandulangan',
  },
  {
    id: '6306030011',
    districtId: '6306030',
    name: 'Longawang',
  },
  {
    id: '6306030012',
    districtId: '6306030',
    name: 'Gumbil',
  },
  {
    id: '6306030014',
    districtId: '6306030',
    name: 'Hamak',
  },
  {
    id: '6306030015',
    districtId: '6306030',
    name: 'Hamak Timur',
  },
  {
    id: '6306030016',
    districtId: '6306030',
    name: 'Hamak Utara',
  },
  {
    id: '6306040002',
    districtId: '6306040',
    name: 'Telaga Sili Sili',
  },
  {
    id: '6306040004',
    districtId: '6306040',
    name: 'Taniran Selatan',
  },
  {
    id: '6306040008',
    districtId: '6306040',
    name: 'Taniran Kubah',
  },
  {
    id: '6306040009',
    districtId: '6306040',
    name: 'Bakarung',
  },
  {
    id: '6306040011',
    districtId: '6306040',
    name: 'Angkinang Selatan',
  },
  {
    id: '6306040014',
    districtId: '6306040',
    name: 'Tawia',
  },
  {
    id: '6306040016',
    districtId: '6306040',
    name: 'Kayu Abang',
  },
  {
    id: '6306040018',
    districtId: '6306040',
    name: 'Angkinang',
  },
  {
    id: '6306040020',
    districtId: '6306040',
    name: 'Bamban Selatan',
  },
  {
    id: '6306040022',
    districtId: '6306040',
    name: 'Bamban',
  },
  {
    id: '6306040023',
    districtId: '6306040',
    name: 'Bamban Utara',
  },
  {
    id: '6306050002',
    districtId: '6306050',
    name: 'Jambu Hilir',
  },
  {
    id: '6306050004',
    districtId: '6306050',
    name: 'Tibung Raya',
  },
  {
    id: '6306050005',
    districtId: '6306050',
    name: 'Amawang Kanan',
  },
  {
    id: '6306050006',
    districtId: '6306050',
    name: 'Sungai Paring',
  },
  {
    id: '6306050008',
    districtId: '6306050',
    name: 'Amawang Kiri',
  },
  {
    id: '6306050009',
    districtId: '6306050',
    name: 'Bariang',
  },
  {
    id: '6306050010',
    districtId: '6306050',
    name: 'Amawang Kiri Muka',
  },
  {
    id: '6306050011',
    districtId: '6306050',
    name: 'Kandangan Barat',
  },
  {
    id: '6306050012',
    districtId: '6306050',
    name: 'Kandangan Kota',
  },
  {
    id: '6306050013',
    districtId: '6306050',
    name: 'Kandangan Utara',
  },
  {
    id: '6306050014',
    districtId: '6306050',
    name: 'Gambah Luar Muka',
  },
  {
    id: '6306050016',
    districtId: '6306050',
    name: 'Gambah Luar',
  },
  {
    id: '6306050018',
    districtId: '6306050',
    name: 'Gambah Dalam',
  },
  {
    id: '6306050021',
    districtId: '6306050',
    name: 'Gambah Dalam Barat',
  },
  {
    id: '6306050023',
    districtId: '6306050',
    name: 'Lungau',
  },
  {
    id: '6306050025',
    districtId: '6306050',
    name: 'Sungai Kupang',
  },
  {
    id: '6306050027',
    districtId: '6306050',
    name: 'Bangkau',
  },
  {
    id: '6306050029',
    districtId: '6306050',
    name: 'Baluti',
  },
  {
    id: '6306060001',
    districtId: '6306060',
    name: 'Bumi Barkat',
  },
  {
    id: '6306060004',
    districtId: '6306060',
    name: 'Ida Manggala',
  },
  {
    id: '6306060005',
    districtId: '6306060',
    name: 'Batang Kulur Tengah',
  },
  {
    id: '6306060006',
    districtId: '6306060',
    name: 'Batang Kulur Kanan',
  },
  {
    id: '6306060010',
    districtId: '6306060',
    name: 'Tamiyang',
  },
  {
    id: '6306060012',
    districtId: '6306060',
    name: 'Asam',
  },
  {
    id: '6306060013',
    districtId: '6306060',
    name: 'Baru',
  },
  {
    id: '6306060014',
    districtId: '6306060',
    name: 'Sungai Kali',
  },
  {
    id: '6306060015',
    districtId: '6306060',
    name: 'Batang Kulur Kiri',
  },
  {
    id: '6306060016',
    districtId: '6306060',
    name: 'Hariti',
  },
  {
    id: '6306060017',
    districtId: '6306060',
    name: 'Sungai Raya Selatan',
  },
  {
    id: '6306060020',
    districtId: '6306060',
    name: 'Paring Agung',
  },
  {
    id: '6306060021',
    districtId: '6306060',
    name: 'Sarang Halang',
  },
  {
    id: '6306060022',
    districtId: '6306060',
    name: 'Sungai Raya Utara',
  },
  {
    id: '6306060025',
    districtId: '6306060',
    name: 'Tanah Bangkang',
  },
  {
    id: '6306060027',
    districtId: '6306060',
    name: 'Karasikan',
  },
  {
    id: '6306060028',
    districtId: '6306060',
    name: 'Hamalau',
  },
  {
    id: '6306060030',
    districtId: '6306060',
    name: 'Telaga Bidadari',
  },
  {
    id: '6306070009',
    districtId: '6306070',
    name: 'Wasah Hulu',
  },
  {
    id: '6306070010',
    districtId: '6306070',
    name: 'Wasah Tengah',
  },
  {
    id: '6306070011',
    districtId: '6306070',
    name: 'Wasah Hilir',
  },
  {
    id: '6306070012',
    districtId: '6306070',
    name: 'Simpur',
  },
  {
    id: '6306070014',
    districtId: '6306070',
    name: 'Tebing Tinggi',
  },
  {
    id: '6306070015',
    districtId: '6306070',
    name: 'Garunggang',
  },
  {
    id: '6306070018',
    districtId: '6306070',
    name: 'Amparaya',
  },
  {
    id: '6306070019',
    districtId: '6306070',
    name: 'Panjampang Bahagia',
  },
  {
    id: '6306070021',
    districtId: '6306070',
    name: 'Ulin',
  },
  {
    id: '6306070022',
    districtId: '6306070',
    name: 'Pantai Ulin',
  },
  {
    id: '6306070025',
    districtId: '6306070',
    name: 'Kapuh',
  },
  {
    id: '6306080001',
    districtId: '6306080',
    name: 'Balimau',
  },
  {
    id: '6306080002',
    districtId: '6306080',
    name: 'Karang Paci',
  },
  {
    id: '6306080003',
    districtId: '6306080',
    name: 'Bago Tanggul',
  },
  {
    id: '6306080004',
    districtId: '6306080',
    name: 'Karang Bulan',
  },
  {
    id: '6306080005',
    districtId: '6306080',
    name: 'Balanti',
  },
  {
    id: '6306080006',
    districtId: '6306080',
    name: 'Kalumpang',
  },
  {
    id: '6306080008',
    districtId: '6306080',
    name: 'Tambingkar',
  },
  {
    id: '6306080009',
    districtId: '6306080',
    name: 'Sirih',
  },
  {
    id: '6306080010',
    districtId: '6306080',
    name: 'Sirih Hulu',
  },
  {
    id: '6306090001',
    districtId: '6306090',
    name: 'Muning Dalam',
  },
  {
    id: '6306090002',
    districtId: '6306090',
    name: 'Muning Baru',
  },
  {
    id: '6306090003',
    districtId: '6306090',
    name: 'Muning Tengah',
  },
  {
    id: '6306090011',
    districtId: '6306090',
    name: 'Samuda',
  },
  {
    id: '6306090012',
    districtId: '6306090',
    name: 'Banua Hanyar',
  },
  {
    id: '6306090013',
    districtId: '6306090',
    name: 'Parigi',
  },
  {
    id: '6306090014',
    districtId: '6306090',
    name: 'Baruh Jaya',
  },
  {
    id: '6306090015',
    districtId: '6306090',
    name: 'Tambangan',
  },
  {
    id: '6306090016',
    districtId: '6306090',
    name: 'Habirau Tengah',
  },
  {
    id: '6306090017',
    districtId: '6306090',
    name: 'Habirau',
  },
  {
    id: '6306090018',
    districtId: '6306090',
    name: 'Sungai Pinang',
  },
  {
    id: '6306090019',
    districtId: '6306090',
    name: 'Tumbukan Banyu',
  },
  {
    id: '6306090020',
    districtId: '6306090',
    name: 'Banjar Baru',
  },
  {
    id: '6306090021',
    districtId: '6306090',
    name: 'Bayanan',
  },
  {
    id: '6306090022',
    districtId: '6306090',
    name: 'Pandan Sari',
  },
  {
    id: '6306090023',
    districtId: '6306090',
    name: 'Pihanin Raya',
  },
  {
    id: '6306091001',
    districtId: '6306091',
    name: 'Bajayau Lama',
  },
  {
    id: '6306091002',
    districtId: '6306091',
    name: 'Tanjung Selor',
  },
  {
    id: '6306091003',
    districtId: '6306091',
    name: 'Badaun',
  },
  {
    id: '6306091004',
    districtId: '6306091',
    name: 'Bajayau Tengah',
  },
  {
    id: '6306091005',
    districtId: '6306091',
    name: 'Bajayau',
  },
  {
    id: '6306091006',
    districtId: '6306091',
    name: 'Baru',
  },
  {
    id: '6306091007',
    districtId: '6306091',
    name: 'Siang Gantung',
  },
  {
    id: '6306100001',
    districtId: '6306100',
    name: 'Pakapuran Kecil',
  },
  {
    id: '6306100002',
    districtId: '6306100',
    name: 'Panggandingan',
  },
  {
    id: '6306100003',
    districtId: '6306100',
    name: 'Tambak Bitin',
  },
  {
    id: '6306100004',
    districtId: '6306100',
    name: 'Sungai Mandala',
  },
  {
    id: '6306100005',
    districtId: '6306100',
    name: 'Mandala Murung Mesjid',
  },
  {
    id: '6306100006',
    districtId: '6306100',
    name: 'Sungai Garuda',
  },
  {
    id: '6306100007',
    districtId: '6306100',
    name: 'Belah Paikat',
  },
  {
    id: '6306100008',
    districtId: '6306100',
    name: 'Baruh Kembang',
  },
  {
    id: '6306100010',
    districtId: '6306100',
    name: 'Pakan Dalam',
  },
  {
    id: '6306100011',
    districtId: '6306100',
    name: 'Paramaian',
  },
  {
    id: '6306100012',
    districtId: '6306100',
    name: 'Taluk Haur',
  },
  {
    id: '6306100013',
    districtId: '6306100',
    name: 'Pasungkan',
  },
  {
    id: '6306100014',
    districtId: '6306100',
    name: 'Pandak Daun',
  },
  {
    id: '6306100015',
    districtId: '6306100',
    name: 'Teluk Labak',
  },
  {
    id: '6306100016',
    districtId: '6306100',
    name: 'Murung Raya',
  },
  {
    id: '6306100019',
    districtId: '6306100',
    name: 'Hamayung',
  },
  {
    id: '6306100020',
    districtId: '6306100',
    name: 'Hamayung Utara',
  },
  {
    id: '6306100021',
    districtId: '6306100',
    name: 'Paharangan',
  },
  {
    id: '6306100023',
    districtId: '6306100',
    name: 'Hakurung',
  },
  {
    id: '6307010001',
    districtId: '6307010',
    name: 'Pangambau Hilir Luar',
  },
  {
    id: '6307010003',
    districtId: '6307010',
    name: 'Pengambau Hilir Dalam',
  },
  {
    id: '6307010004',
    districtId: '6307010',
    name: 'Tabat Padang',
  },
  {
    id: '6307010005',
    districtId: '6307010',
    name: 'Lokbuntar',
  },
  {
    id: '6307010007',
    districtId: '6307010',
    name: 'Pengambau Hulu',
  },
  {
    id: '6307010009',
    districtId: '6307010',
    name: 'Sungai Harang',
  },
  {
    id: '6307010012',
    districtId: '6307010',
    name: 'Batu Panggung',
  },
  {
    id: '6307010014',
    districtId: '6307010',
    name: 'Hapulang',
  },
  {
    id: '6307010015',
    districtId: '6307010',
    name: 'Mangunang',
  },
  {
    id: '6307010016',
    districtId: '6307010',
    name: 'Mangunang Seberang',
  },
  {
    id: '6307010019',
    districtId: '6307010',
    name: 'Haruyan Seberang',
  },
  {
    id: '6307010021',
    districtId: '6307010',
    name: 'Haruyan',
  },
  {
    id: '6307010022',
    districtId: '6307010',
    name: 'Andang',
  },
  {
    id: '6307010024',
    districtId: '6307010',
    name: 'Teluk Mesjid',
  },
  {
    id: '6307010028',
    districtId: '6307010',
    name: 'Barikin',
  },
  {
    id: '6307010030',
    districtId: '6307010',
    name: 'Panggung',
  },
  {
    id: '6307010032',
    districtId: '6307010',
    name: 'Pandanu',
  },
  {
    id: '6307020005',
    districtId: '6307020',
    name: 'Murung A',
  },
  {
    id: '6307020009',
    districtId: '6307020',
    name: 'Pagat',
  },
  {
    id: '6307020010',
    districtId: '6307020',
    name: 'Haliau',
  },
  {
    id: '6307020011',
    districtId: '6307020',
    name: 'Baru',
  },
  {
    id: '6307020013',
    districtId: '6307020',
    name: 'Aluan Mati',
  },
  {
    id: '6307020015',
    districtId: '6307020',
    name: 'Aluan Sumur',
  },
  {
    id: '6307020017',
    districtId: '6307020',
    name: 'Kali Baru',
  },
  {
    id: '6307020018',
    districtId: '6307020',
    name: 'Layuh',
  },
  {
    id: '6307020020',
    districtId: '6307020',
    name: 'Kahakan',
  },
  {
    id: '6307020024',
    districtId: '6307020',
    name: 'Bakti',
  },
  {
    id: '6307020026',
    districtId: '6307020',
    name: 'Aluan Besar',
  },
  {
    id: '6307020028',
    districtId: '6307020',
    name: 'Paya Besar',
  },
  {
    id: '6307020029',
    districtId: '6307020',
    name: 'Pantai Batung',
  },
  {
    id: '6307020030',
    districtId: '6307020',
    name: 'Aluan',
  },
  {
    id: '6307030002',
    districtId: '6307030',
    name: 'Kindingan',
  },
  {
    id: '6307030003',
    districtId: '6307030',
    name: 'Haruyan Dayak',
  },
  {
    id: '6307030007',
    districtId: '6307030',
    name: 'Tilahan',
  },
  {
    id: '6307030008',
    districtId: '6307030',
    name: 'Pasting',
  },
  {
    id: '6307030009',
    districtId: '6307030',
    name: 'Batu Tunggal',
  },
  {
    id: '6307030010',
    districtId: '6307030',
    name: 'Bulayak',
  },
  {
    id: '6307030017',
    districtId: '6307030',
    name: 'Datar Ajab',
  },
  {
    id: '6307030018',
    districtId: '6307030',
    name: 'Alat',
  },
  {
    id: '6307030020',
    districtId: '6307030',
    name: 'Hantakan',
  },
  {
    id: '6307030021',
    districtId: '6307030',
    name: 'Hinas Kanan',
  },
  {
    id: '6307030022',
    districtId: '6307030',
    name: 'Patikalain',
  },
  {
    id: '6307040018',
    districtId: '6307040',
    name: 'Tanah Habang',
  },
  {
    id: '6307040021',
    districtId: '6307040',
    name: 'Cukan Lipai',
  },
  {
    id: '6307040024',
    districtId: '6307040',
    name: 'Paya',
  },
  {
    id: '6307040026',
    districtId: '6307040',
    name: 'Kias',
  },
  {
    id: '6307040028',
    districtId: '6307040',
    name: 'Kapar',
  },
  {
    id: '6307040029',
    districtId: '6307040',
    name: 'Tembuk Bahalang',
  },
  {
    id: '6307040030',
    districtId: '6307040',
    name: 'Banua Rantau',
  },
  {
    id: '6307040031',
    districtId: '6307040',
    name: 'Lok Besar',
  },
  {
    id: '6307040034',
    districtId: '6307040',
    name: 'Birayang Timur',
  },
  {
    id: '6307040035',
    districtId: '6307040',
    name: 'Birayang',
  },
  {
    id: '6307040037',
    districtId: '6307040',
    name: 'Limbar',
  },
  {
    id: '6307040038',
    districtId: '6307040',
    name: 'Mahela',
  },
  {
    id: '6307040040',
    districtId: '6307040',
    name: 'Birayang Surapati',
  },
  {
    id: '6307040043',
    districtId: '6307040',
    name: 'Wawai',
  },
  {
    id: '6307040047',
    districtId: '6307040',
    name: 'Wawai Gardu',
  },
  {
    id: '6307040049',
    districtId: '6307040',
    name: 'Anduhum',
  },
  {
    id: '6307040052',
    districtId: '6307040',
    name: 'Labuhan',
  },
  {
    id: '6307040053',
    districtId: '6307040',
    name: 'Rangas',
  },
  {
    id: '6307041002',
    districtId: '6307041',
    name: 'Hinas Kiri',
  },
  {
    id: '6307041003',
    districtId: '6307041',
    name: 'Atiran',
  },
  {
    id: '6307041004',
    districtId: '6307041',
    name: 'Muara Hungi',
  },
  {
    id: '6307041005',
    districtId: '6307041',
    name: 'Pembakulan',
  },
  {
    id: '6307041006',
    districtId: '6307041',
    name: 'Nateh',
  },
  {
    id: '6307041007',
    districtId: '6307041',
    name: 'Batu Tangga',
  },
  {
    id: '6307041008',
    districtId: '6307041',
    name: 'Tandilang',
  },
  {
    id: '6307041009',
    districtId: '6307041',
    name: 'Batu Perahu',
  },
  {
    id: '6307041010',
    districtId: '6307041',
    name: 'Aing Bantai',
  },
  {
    id: '6307041011',
    districtId: '6307041',
    name: 'Datar Batung',
  },
  {
    id: '6307050002',
    districtId: '6307050',
    name: 'Pajukungan',
  },
  {
    id: '6307050004',
    districtId: '6307050',
    name: 'Bukat',
  },
  {
    id: '6307050005',
    districtId: '6307050',
    name: 'Barabai Barat',
  },
  {
    id: '6307050006',
    districtId: '6307050',
    name: 'Barabai Utara',
  },
  {
    id: '6307050007',
    districtId: '6307050',
    name: 'Barabai Selatan',
  },
  {
    id: '6307050008',
    districtId: '6307050',
    name: 'Barabai Darat',
  },
  {
    id: '6307050009',
    districtId: '6307050',
    name: 'Benawa Tengah',
  },
  {
    id: '6307050010',
    districtId: '6307050',
    name: 'Kayu Bawang',
  },
  {
    id: '6307050013',
    districtId: '6307050',
    name: 'Awang Besar',
  },
  {
    id: '6307050014',
    districtId: '6307050',
    name: 'Gambah',
  },
  {
    id: '6307050016',
    districtId: '6307050',
    name: 'Mandingin',
  },
  {
    id: '6307050018',
    districtId: '6307050',
    name: 'Barabai Timur',
  },
  {
    id: '6307050020',
    districtId: '6307050',
    name: 'Banua Binjai',
  },
  {
    id: '6307050021',
    districtId: '6307050',
    name: 'Banua Budi',
  },
  {
    id: '6307050023',
    districtId: '6307050',
    name: 'Babai',
  },
  {
    id: '6307050025',
    districtId: '6307050',
    name: 'Banua Jingah',
  },
  {
    id: '6307050028',
    districtId: '6307050',
    name: 'Bakapas',
  },
  {
    id: '6307050029',
    districtId: '6307050',
    name: 'Ayuang',
  },
  {
    id: '6307060002',
    districtId: '6307060',
    name: 'Panggang Marak',
  },
  {
    id: '6307060004',
    districtId: '6307060',
    name: 'Mundar',
  },
  {
    id: '6307060007',
    districtId: '6307060',
    name: 'Tabudarat Hilir',
  },
  {
    id: '6307060008',
    districtId: '6307060',
    name: 'Baru',
  },
  {
    id: '6307060010',
    districtId: '6307060',
    name: 'Jamil',
  },
  {
    id: '6307060011',
    districtId: '6307060',
    name: 'Tabudarat Hulu',
  },
  {
    id: '6307060013',
    districtId: '6307060',
    name: 'Pantai Hambawang Barat',
  },
  {
    id: '6307060014',
    districtId: '6307060',
    name: 'Pantai Hambawang Timur',
  },
  {
    id: '6307060017',
    districtId: '6307060',
    name: 'Benua Kepayang',
  },
  {
    id: '6307060019',
    districtId: '6307060',
    name: 'Sungai Jaranih',
  },
  {
    id: '6307060021',
    districtId: '6307060',
    name: 'Batang Bahalang',
  },
  {
    id: '6307060022',
    districtId: '6307060',
    name: 'Taal',
  },
  {
    id: '6307060024',
    districtId: '6307060',
    name: 'Murung Taal',
  },
  {
    id: '6307060027',
    districtId: '6307060',
    name: 'Sungai Rangas',
  },
  {
    id: '6307060029',
    districtId: '6307060',
    name: 'Durian Gantang',
  },
  {
    id: '6307060032',
    districtId: '6307060',
    name: 'Guha',
  },
  {
    id: '6307060033',
    districtId: '6307060',
    name: 'Bangkal',
  },
  {
    id: '6307060035',
    districtId: '6307060',
    name: 'Taras Padang',
  },
  {
    id: '6307070001',
    districtId: '6307070',
    name: 'Pahalatan',
  },
  {
    id: '6307070003',
    districtId: '6307070',
    name: 'Perumahan',
  },
  {
    id: '6307070004',
    districtId: '6307070',
    name: 'Kadundung',
  },
  {
    id: '6307070006',
    districtId: '6307070',
    name: 'Kasarangan',
  },
  {
    id: '6307070007',
    districtId: '6307070',
    name: 'Pemangkih Seberang',
  },
  {
    id: '6307070010',
    districtId: '6307070',
    name: 'Tabat',
  },
  {
    id: '6307070013',
    districtId: '6307070',
    name: 'Mantaas',
  },
  {
    id: '6307070015',
    districtId: '6307070',
    name: 'Rantau Bujur',
  },
  {
    id: '6307070017',
    districtId: '6307070',
    name: 'Binjai Pirua',
  },
  {
    id: '6307070019',
    districtId: '6307070',
    name: 'Binjai Pemangkih',
  },
  {
    id: '6307070023',
    districtId: '6307070',
    name: 'Pemangkih',
  },
  {
    id: '6307070026',
    districtId: '6307070',
    name: 'Rantau Keminting',
  },
  {
    id: '6307070027',
    districtId: '6307070',
    name: 'Banua Kupang',
  },
  {
    id: '6307070031',
    districtId: '6307070',
    name: 'Sungai Buluh',
  },
  {
    id: '6307070033',
    districtId: '6307070',
    name: 'Samhurang',
  },
  {
    id: '6307080001',
    districtId: '6307080',
    name: 'Masiraan',
  },
  {
    id: '6307080003',
    districtId: '6307080',
    name: 'Jaranih',
  },
  {
    id: '6307080004',
    districtId: '6307080',
    name: 'Banua Hanyar',
  },
  {
    id: '6307080006',
    districtId: '6307080',
    name: 'Banua Asam',
  },
  {
    id: '6307080009',
    districtId: '6307080',
    name: 'Matang Ginalun',
  },
  {
    id: '6307080010',
    districtId: '6307080',
    name: 'Hulu Rasau',
  },
  {
    id: '6307080011',
    districtId: '6307080',
    name: 'Banua Supanggal',
  },
  {
    id: '6307080014',
    districtId: '6307080',
    name: 'Mahang Putat',
  },
  {
    id: '6307080016',
    districtId: '6307080',
    name: 'Mahang Sei Hanyar',
  },
  {
    id: '6307080017',
    districtId: '6307080',
    name: 'Mahang Matang Landung',
  },
  {
    id: '6307080021',
    districtId: '6307080',
    name: 'Buluan',
  },
  {
    id: '6307080022',
    districtId: '6307080',
    name: 'Pandawan',
  },
  {
    id: '6307080023',
    districtId: '6307080',
    name: 'Banua Batung',
  },
  {
    id: '6307080025',
    districtId: '6307080',
    name: 'Jatuh',
  },
  {
    id: '6307080027',
    districtId: '6307080',
    name: 'Hilir Banua',
  },
  {
    id: '6307080028',
    districtId: '6307080',
    name: 'Kambat Selatan',
  },
  {
    id: '6307080030',
    districtId: '6307080',
    name: 'Walatung',
  },
  {
    id: '6307080033',
    districtId: '6307080',
    name: 'Kayu Rabah',
  },
  {
    id: '6307080037',
    districtId: '6307080',
    name: 'Setiap',
  },
  {
    id: '6307080039',
    districtId: '6307080',
    name: 'Kambat Utara',
  },
  {
    id: '6307080042',
    districtId: '6307080',
    name: 'Palajau',
  },
  {
    id: '6307090003',
    districtId: '6307090',
    name: 'Sumanggi',
  },
  {
    id: '6307090007',
    districtId: '6307090',
    name: 'Ilung Pasar Lama',
  },
  {
    id: '6307090009',
    districtId: '6307090',
    name: 'Dangu',
  },
  {
    id: '6307090011',
    districtId: '6307090',
    name: 'Hapingin',
  },
  {
    id: '6307090012',
    districtId: '6307090',
    name: 'Ilung',
  },
  {
    id: '6307090013',
    districtId: '6307090',
    name: 'Ilung Tengah',
  },
  {
    id: '6307090014',
    districtId: '6307090',
    name: 'Sumanggi Seberang',
  },
  {
    id: '6307090016',
    districtId: '6307090',
    name: 'Awang Baru',
  },
  {
    id: '6307090018',
    districtId: '6307090',
    name: 'Awang',
  },
  {
    id: '6307090019',
    districtId: '6307090',
    name: 'Maringgit',
  },
  {
    id: '6307090020',
    districtId: '6307090',
    name: 'Labunganak',
  },
  {
    id: '6307090033',
    districtId: '6307090',
    name: 'Muara Rintis',
  },
  {
    id: '6307090035',
    districtId: '6307090',
    name: 'Telang',
  },
  {
    id: '6307090036',
    districtId: '6307090',
    name: 'Haur Gading',
  },
  {
    id: '6307091001',
    districtId: '6307091',
    name: 'Limpasu',
  },
  {
    id: '6307091002',
    districtId: '6307091',
    name: 'Kabang',
  },
  {
    id: '6307091003',
    districtId: '6307091',
    name: 'Tapuk',
  },
  {
    id: '6307091004',
    districtId: '6307091',
    name: 'Pauh',
  },
  {
    id: '6307091005',
    districtId: '6307091',
    name: 'Hawang',
  },
  {
    id: '6307091006',
    districtId: '6307091',
    name: 'Karatungan',
  },
  {
    id: '6307091007',
    districtId: '6307091',
    name: 'Abung',
  },
  {
    id: '6307091008',
    districtId: '6307091',
    name: 'Abung Surapati',
  },
  {
    id: '6307091009',
    districtId: '6307091',
    name: 'Karau',
  },
  {
    id: '6308010006',
    districtId: '6308010',
    name: 'Sungai Namang',
  },
  {
    id: '6308010007',
    districtId: '6308010',
    name: 'Sungai Panangah',
  },
  {
    id: '6308010008',
    districtId: '6308010',
    name: 'Sarang Burung',
  },
  {
    id: '6308010009',
    districtId: '6308010',
    name: 'Telaga Mas',
  },
  {
    id: '6308010010',
    districtId: '6308010',
    name: 'Manarap Hulu',
  },
  {
    id: '6308010011',
    districtId: '6308010',
    name: 'Manarap',
  },
  {
    id: '6308010012',
    districtId: '6308010',
    name: 'Long Kong',
  },
  {
    id: '6308010013',
    districtId: '6308010',
    name: 'Bitin',
  },
  {
    id: '6308010014',
    districtId: '6308010',
    name: 'Baru',
  },
  {
    id: '6308010015',
    districtId: '6308010',
    name: 'Teluk Mesjid',
  },
  {
    id: '6308010016',
    districtId: '6308010',
    name: 'Darussalam',
  },
  {
    id: '6308010017',
    districtId: '6308010',
    name: 'Palukahan',
  },
  {
    id: '6308010018',
    districtId: '6308010',
    name: 'Pandamaan',
  },
  {
    id: '6308010019',
    districtId: '6308010',
    name: 'Danau Panggang',
  },
  {
    id: '6308010020',
    districtId: '6308010',
    name: 'Pararain',
  },
  {
    id: '6308010021',
    districtId: '6308010',
    name: 'Rintisan',
  },
  {
    id: '6308011001',
    districtId: '6308011',
    name: 'Paminggir',
  },
  {
    id: '6308011002',
    districtId: '6308011',
    name: 'Paminggir Seberang',
  },
  {
    id: '6308011003',
    districtId: '6308011',
    name: 'Ambahai',
  },
  {
    id: '6308011004',
    districtId: '6308011',
    name: 'Sapala',
  },
  {
    id: '6308011005',
    districtId: '6308011',
    name: 'Bararawa',
  },
  {
    id: '6308011006',
    districtId: '6308011',
    name: 'Pal Batu',
  },
  {
    id: '6308011007',
    districtId: '6308011',
    name: 'Tampakang',
  },
  {
    id: '6308020001',
    districtId: '6308020',
    name: 'Murung Kupang',
  },
  {
    id: '6308020002',
    districtId: '6308020',
    name: 'Babirik Hilir',
  },
  {
    id: '6308020003',
    districtId: '6308020',
    name: 'Babirik Hulu',
  },
  {
    id: '6308020004',
    districtId: '6308020',
    name: 'Sungai Janjam',
  },
  {
    id: '6308020005',
    districtId: '6308020',
    name: 'Sungai Durait Hilir',
  },
  {
    id: '6308020006',
    districtId: '6308020',
    name: 'Sungai Durait Tengah',
  },
  {
    id: '6308020007',
    districtId: '6308020',
    name: 'Sungai Durait Hulu',
  },
  {
    id: '6308020008',
    districtId: '6308020',
    name: 'Hambuku Lima',
  },
  {
    id: '6308020009',
    districtId: '6308020',
    name: 'Hambuku Baru',
  },
  {
    id: '6308020010',
    districtId: '6308020',
    name: 'Hambuku Hilir',
  },
  {
    id: '6308020011',
    districtId: '6308020',
    name: 'Murung Panti Hulu',
  },
  {
    id: '6308020012',
    districtId: '6308020',
    name: 'Murung Panti Hilir',
  },
  {
    id: '6308020013',
    districtId: '6308020',
    name: 'Teluk Limbung',
  },
  {
    id: '6308020014',
    districtId: '6308020',
    name: 'Sungai Papuyu',
  },
  {
    id: '6308020015',
    districtId: '6308020',
    name: 'Kalumpang Luar',
  },
  {
    id: '6308020016',
    districtId: '6308020',
    name: 'Kalumpang Dalam',
  },
  {
    id: '6308020017',
    districtId: '6308020',
    name: 'Sungai Luang Hilir',
  },
  {
    id: '6308020018',
    districtId: '6308020',
    name: 'Parupukan',
  },
  {
    id: '6308020019',
    districtId: '6308020',
    name: 'Sungai Nyiur',
  },
  {
    id: '6308020020',
    districtId: '6308020',
    name: 'Sungai Luang Hulu',
  },
  {
    id: '6308020021',
    districtId: '6308020',
    name: 'Sungai Dalam',
  },
  {
    id: '6308020022',
    districtId: '6308020',
    name: 'Pajukungan Hilir',
  },
  {
    id: '6308020023',
    districtId: '6308020',
    name: 'Pajukungan Hulu',
  },
  {
    id: '6308030001',
    districtId: '6308030',
    name: 'Rantau Karau Hilir',
  },
  {
    id: '6308030002',
    districtId: '6308030',
    name: 'Pondok Babaris',
  },
  {
    id: '6308030003',
    districtId: '6308030',
    name: 'Murung Asam',
  },
  {
    id: '6308030004',
    districtId: '6308030',
    name: 'Banyu Tajun Dalam',
  },
  {
    id: '6308030005',
    districtId: '6308030',
    name: 'Tapus Dalam',
  },
  {
    id: '6308030006',
    districtId: '6308030',
    name: 'Banyu Tajun Hulu',
  },
  {
    id: '6308030007',
    districtId: '6308030',
    name: 'Sungai Kuini',
  },
  {
    id: '6308030008',
    districtId: '6308030',
    name: 'Banyu Tajun Pangkalan',
  },
  {
    id: '6308030009',
    districtId: '6308030',
    name: 'Pangkalan Sari',
  },
  {
    id: '6308030010',
    districtId: '6308030',
    name: 'Jalan Lurus',
  },
  {
    id: '6308030011',
    districtId: '6308030',
    name: 'Teluk Mesjid',
  },
  {
    id: '6308030012',
    districtId: '6308030',
    name: 'Banyu Tajun Hilir',
  },
  {
    id: '6308030013',
    districtId: '6308030',
    name: 'Tatah Laban',
  },
  {
    id: '6308030014',
    districtId: '6308030',
    name: 'Rantau Karau Hulu',
  },
  {
    id: '6308030015',
    districtId: '6308030',
    name: 'Rantau Karau Tengah',
  },
  {
    id: '6308030016',
    districtId: '6308030',
    name: 'Rantau Karau Raya',
  },
  {
    id: '6308030017',
    districtId: '6308030',
    name: 'Teluk Sinar',
  },
  {
    id: '6308030018',
    districtId: '6308030',
    name: 'Hambuku Tengah',
  },
  {
    id: '6308030019',
    districtId: '6308030',
    name: 'Hambuku Pasar',
  },
  {
    id: '6308030020',
    districtId: '6308030',
    name: 'Hambuku Raya',
  },
  {
    id: '6308030021',
    districtId: '6308030',
    name: 'Hambuku Hulu',
  },
  {
    id: '6308030022',
    districtId: '6308030',
    name: 'Tambalang',
  },
  {
    id: '6308030023',
    districtId: '6308030',
    name: 'Tambalang Tengah',
  },
  {
    id: '6308030024',
    districtId: '6308030',
    name: 'Tambalang Kecil',
  },
  {
    id: '6308030026',
    districtId: '6308030',
    name: 'Sungai Pandan Hulu',
  },
  {
    id: '6308030027',
    districtId: '6308030',
    name: 'Sungai Pandan Tengah',
  },
  {
    id: '6308030028',
    districtId: '6308030',
    name: 'Sungai Pandan Hilir',
  },
  {
    id: '6308030029',
    districtId: '6308030',
    name: 'Sungai Sandung',
  },
  {
    id: '6308030030',
    districtId: '6308030',
    name: 'Sungai Pinang',
  },
  {
    id: '6308030031',
    districtId: '6308030',
    name: 'Pandulangan',
  },
  {
    id: '6308030040',
    districtId: '6308030',
    name: 'Putat Atas',
  },
  {
    id: '6308030041',
    districtId: '6308030',
    name: 'Padang Bangkal',
  },
  {
    id: '6308031001',
    districtId: '6308031',
    name: 'Tambalang Raya',
  },
  {
    id: '6308031002',
    districtId: '6308031',
    name: 'Rantau Bujur Hilir',
  },
  {
    id: '6308031003',
    districtId: '6308031',
    name: 'Teluk Cati',
  },
  {
    id: '6308031004',
    districtId: '6308031',
    name: 'Galagah',
  },
  {
    id: '6308031005',
    districtId: '6308031',
    name: 'Galagah Hulu',
  },
  {
    id: '6308031006',
    districtId: '6308031',
    name: 'Nelayan',
  },
  {
    id: '6308031007',
    districtId: '6308031',
    name: 'Sungai Tabukan',
  },
  {
    id: '6308031008',
    districtId: '6308031',
    name: 'Pematang Benteng',
  },
  {
    id: '6308031009',
    districtId: '6308031',
    name: 'Pematang Benteng Hilir',
  },
  {
    id: '6308031010',
    districtId: '6308031',
    name: 'Pasar Sabtu',
  },
  {
    id: '6308031011',
    districtId: '6308031',
    name: 'Hilir Mesjid',
  },
  {
    id: '6308031012',
    districtId: '6308031',
    name: 'Gampa Raya',
  },
  {
    id: '6308031013',
    districtId: '6308031',
    name: 'Banua Hanyar',
  },
  {
    id: '6308031014',
    districtId: '6308031',
    name: 'Sungai Haji',
  },
  {
    id: '6308031015',
    districtId: '6308031',
    name: 'Rantau Bujur Hulu',
  },
  {
    id: '6308031016',
    districtId: '6308031',
    name: 'Rantau Bujur Tengah',
  },
  {
    id: '6308031017',
    districtId: '6308031',
    name: 'Rantau Bujur Darat',
  },
  {
    id: '6308040001',
    districtId: '6308040',
    name: 'Keramat',
  },
  {
    id: '6308040002',
    districtId: '6308040',
    name: 'Panyiuran',
  },
  {
    id: '6308040003',
    districtId: '6308040',
    name: 'Cempaka',
  },
  {
    id: '6308040004',
    districtId: '6308040',
    name: 'Ilir Mesjid',
  },
  {
    id: '6308040006',
    districtId: '6308040',
    name: 'Jarang Kuantan',
  },
  {
    id: '6308040007',
    districtId: '6308040',
    name: 'Kota Raja',
  },
  {
    id: '6308040008',
    districtId: '6308040',
    name: 'Jumba',
  },
  {
    id: '6308040009',
    districtId: '6308040',
    name: 'Teluk Paring',
  },
  {
    id: '6308040010',
    districtId: '6308040',
    name: 'Teluk Baru',
  },
  {
    id: '6308040011',
    districtId: '6308040',
    name: 'Cangkering',
  },
  {
    id: '6308040012',
    districtId: '6308040',
    name: 'Simpang Empat',
  },
  {
    id: '6308040013',
    districtId: '6308040',
    name: 'Rukam Hulu',
  },
  {
    id: '6308040014',
    districtId: '6308040',
    name: 'Rukam Hilir',
  },
  {
    id: '6308040015',
    districtId: '6308040',
    name: 'Kutai Kecil',
  },
  {
    id: '6308040016',
    districtId: '6308040',
    name: 'Padang Darat',
  },
  {
    id: '6308040017',
    districtId: '6308040',
    name: 'Telaga Hanyar',
  },
  {
    id: '6308040018',
    districtId: '6308040',
    name: 'Murung Sari',
  },
  {
    id: '6308040019',
    districtId: '6308040',
    name: 'Mamar',
  },
  {
    id: '6308040020',
    districtId: '6308040',
    name: 'Teluk Sari',
  },
  {
    id: '6308040021',
    districtId: '6308040',
    name: 'Telaga Sari',
  },
  {
    id: '6308040022',
    districtId: '6308040',
    name: 'Simpang Tiga',
  },
  {
    id: '6308040023',
    districtId: '6308040',
    name: 'Harusan Telaga',
  },
  {
    id: '6308040024',
    districtId: '6308040',
    name: 'Telaga Silaba',
  },
  {
    id: '6308040025',
    districtId: '6308040',
    name: 'Banyu Hirang',
  },
  {
    id: '6308040026',
    districtId: '6308040',
    name: 'Pulau Tambak',
  },
  {
    id: '6308040027',
    districtId: '6308040',
    name: 'Kayakah',
  },
  {
    id: '6308040028',
    districtId: '6308040',
    name: 'Bajawit',
  },
  {
    id: '6308040029',
    districtId: '6308040',
    name: 'Padang Tanggul',
  },
  {
    id: '6308040030',
    districtId: '6308040',
    name: 'Murung Panggang',
  },
  {
    id: '6308050001',
    districtId: '6308050',
    name: 'Danau Caramin',
  },
  {
    id: '6308050002',
    districtId: '6308050',
    name: 'Pinang Kara',
  },
  {
    id: '6308050003',
    districtId: '6308050',
    name: 'Pinang Habang',
  },
  {
    id: '6308050004',
    districtId: '6308050',
    name: 'Tapus',
  },
  {
    id: '6308050005',
    districtId: '6308050',
    name: 'Mawar Sari',
  },
  {
    id: '6308050006',
    districtId: '6308050',
    name: 'Datu Kuning',
  },
  {
    id: '6308050007',
    districtId: '6308050',
    name: 'Muara Tapus',
  },
  {
    id: '6308050008',
    districtId: '6308050',
    name: 'Rantawan',
  },
  {
    id: '6308050009',
    districtId: '6308050',
    name: 'Kandang Halang',
  },
  {
    id: '6308050010',
    districtId: '6308050',
    name: 'Pasar Senin',
  },
  {
    id: '6308050011',
    districtId: '6308050',
    name: 'Kembang Kuning',
  },
  {
    id: '6308050012',
    districtId: '6308050',
    name: 'Kota Raden Hilir',
  },
  {
    id: '6308050013',
    districtId: '6308050',
    name: 'Kota Raden',
  },
  {
    id: '6308050014',
    districtId: '6308050',
    name: 'Kebun Sari',
  },
  {
    id: '6308050015',
    districtId: '6308050',
    name: 'Sungai Karias',
  },
  {
    id: '6308050016',
    districtId: '6308050',
    name: 'Hulu Pasar',
  },
  {
    id: '6308050017',
    districtId: '6308050',
    name: 'Tambalangan',
  },
  {
    id: '6308050018',
    districtId: '6308050',
    name: 'Tangga Ulin Hulu',
  },
  {
    id: '6308050019',
    districtId: '6308050',
    name: 'Tangga Ulin Hilir',
  },
  {
    id: '6308050020',
    districtId: '6308050',
    name: 'Antasari',
  },
  {
    id: '6308050021',
    districtId: '6308050',
    name: 'Murung Sari',
  },
  {
    id: '6308050022',
    districtId: '6308050',
    name: 'Paliwara',
  },
  {
    id: '6308050023',
    districtId: '6308050',
    name: 'Palampitan Hulu',
  },
  {
    id: '6308050024',
    districtId: '6308050',
    name: 'Palampitan Hilir',
  },
  {
    id: '6308050025',
    districtId: '6308050',
    name: 'Sungai Malang',
  },
  {
    id: '6308050026',
    districtId: '6308050',
    name: 'Tigarun',
  },
  {
    id: '6308050027',
    districtId: '6308050',
    name: 'Sungai Baring',
  },
  {
    id: '6308050028',
    districtId: '6308050',
    name: 'Harus',
  },
  {
    id: '6308050029',
    districtId: '6308050',
    name: 'Harusan',
  },
  {
    id: '6308060001',
    districtId: '6308060',
    name: 'Pawalutan',
  },
  {
    id: '6308060002',
    districtId: '6308060',
    name: 'Banjang',
  },
  {
    id: '6308060003',
    districtId: '6308060',
    name: 'Beringin',
  },
  {
    id: '6308060004',
    districtId: '6308060',
    name: 'Kalintamui',
  },
  {
    id: '6308060005',
    districtId: '6308060',
    name: 'Palanjungan Sari',
  },
  {
    id: '6308060006',
    districtId: '6308060',
    name: 'Kaludan Besar',
  },
  {
    id: '6308060007',
    districtId: '6308060',
    name: 'Kaludan Kecil',
  },
  {
    id: '6308060008',
    districtId: '6308060',
    name: 'Rantau Bujur',
  },
  {
    id: '6308060009',
    districtId: '6308060',
    name: 'Karias Dalam',
  },
  {
    id: '6308060010',
    districtId: '6308060',
    name: 'Sungai Bahadangan',
  },
  {
    id: '6308060011',
    districtId: '6308060',
    name: 'Lok Bangkai',
  },
  {
    id: '6308060012',
    districtId: '6308060',
    name: 'Patarikan',
  },
  {
    id: '6308060014',
    districtId: '6308060',
    name: 'Pandulangan',
  },
  {
    id: '6308060015',
    districtId: '6308060',
    name: 'Garunggang',
  },
  {
    id: '6308060016',
    districtId: '6308060',
    name: 'Danau Terate',
  },
  {
    id: '6308060017',
    districtId: '6308060',
    name: 'Baruh Tabing',
  },
  {
    id: '6308060018',
    districtId: '6308060',
    name: 'Teluk Sarikat',
  },
  {
    id: '6308060019',
    districtId: '6308060',
    name: 'Murung Padang',
  },
  {
    id: '6308060020',
    districtId: '6308060',
    name: 'Pulau Damar',
  },
  {
    id: '6308070004',
    districtId: '6308070',
    name: 'Pamintangan',
  },
  {
    id: '6308070005',
    districtId: '6308070',
    name: 'Pakacangan',
  },
  {
    id: '6308070006',
    districtId: '6308070',
    name: 'Cakeru',
  },
  {
    id: '6308070007',
    districtId: '6308070',
    name: 'Pakapuran',
  },
  {
    id: '6308070008',
    districtId: '6308070',
    name: 'Panangkalaan',
  },
  {
    id: '6308070017',
    districtId: '6308070',
    name: 'Panangkalaan Hulu',
  },
  {
    id: '6308070018',
    districtId: '6308070',
    name: 'Padang Basar Hilir',
  },
  {
    id: '6308070019',
    districtId: '6308070',
    name: 'Padang Basar',
  },
  {
    id: '6308070020',
    districtId: '6308070',
    name: 'Murung Karangan',
  },
  {
    id: '6308070021',
    districtId: '6308070',
    name: 'Panangian',
  },
  {
    id: '6308070022',
    districtId: '6308070',
    name: 'Kamayahan',
  },
  {
    id: '6308070023',
    districtId: '6308070',
    name: 'Teluk Daun',
  },
  {
    id: '6308070024',
    districtId: '6308070',
    name: 'Kuangan',
  },
  {
    id: '6308070025',
    districtId: '6308070',
    name: 'Sungai Turak',
  },
  {
    id: '6308070026',
    districtId: '6308070',
    name: 'Telaga Bamban',
  },
  {
    id: '6308070027',
    districtId: '6308070',
    name: 'Tabalong Mati',
  },
  {
    id: '6308070035',
    districtId: '6308070',
    name: 'Sungai Turak Dalam',
  },
  {
    id: '6308070036',
    districtId: '6308070',
    name: 'Muara Baruh',
  },
  {
    id: '6308070037',
    districtId: '6308070',
    name: 'Panyaungan',
  },
  {
    id: '6308070038',
    districtId: '6308070',
    name: 'Pandawanan',
  },
  {
    id: '6308070039',
    districtId: '6308070',
    name: 'Pimping',
  },
  {
    id: '6308070040',
    districtId: '6308070',
    name: 'Padang Luar',
  },
  {
    id: '6308070041',
    districtId: '6308070',
    name: 'Air Tawar',
  },
  {
    id: '6308070042',
    districtId: '6308070',
    name: 'Tayur',
  },
  {
    id: '6308070044',
    districtId: '6308070',
    name: 'Tabing Liring',
  },
  {
    id: '6308071001',
    districtId: '6308071',
    name: 'Palimbangan Gusti',
  },
  {
    id: '6308071002',
    districtId: '6308071',
    name: 'Palimbangan',
  },
  {
    id: '6308071003',
    districtId: '6308071',
    name: 'Bayur',
  },
  {
    id: '6308071004',
    districtId: '6308071',
    name: 'Loksuga',
  },
  {
    id: '6308071005',
    districtId: '6308071',
    name: 'Palimbangan Sari',
  },
  {
    id: '6308071006',
    districtId: '6308071',
    name: 'Jingah Bujur',
  },
  {
    id: '6308071007',
    districtId: '6308071',
    name: 'Tambak Sari Panji',
  },
  {
    id: '6308071008',
    districtId: '6308071',
    name: 'Pulantani',
  },
  {
    id: '6308071009',
    districtId: '6308071',
    name: 'Haur Gading',
  },
  {
    id: '6308071010',
    districtId: '6308071',
    name: 'Sungai Limas',
  },
  {
    id: '6308071011',
    districtId: '6308071',
    name: 'Pihaung',
  },
  {
    id: '6308071012',
    districtId: '6308071',
    name: 'Keramat',
  },
  {
    id: '6308071013',
    districtId: '6308071',
    name: 'Teluk Haur',
  },
  {
    id: '6308071014',
    districtId: '6308071',
    name: 'Waringin',
  },
  {
    id: '6308071015',
    districtId: '6308071',
    name: 'Sungai Binuang',
  },
  {
    id: '6308071016',
    districtId: '6308071',
    name: 'Panawakan',
  },
  {
    id: '6308071017',
    districtId: '6308071',
    name: 'Tangkawang',
  },
  {
    id: '6308071018',
    districtId: '6308071',
    name: 'Tuhuran',
  },
  {
    id: '6309010001',
    districtId: '6309010',
    name: 'Hapalah',
  },
  {
    id: '6309010003',
    districtId: '6309010',
    name: 'Batang Banyu',
  },
  {
    id: '6309010004',
    districtId: '6309010',
    name: 'Sungai Durian',
  },
  {
    id: '6309010006',
    districtId: '6309010',
    name: 'Pematang',
  },
  {
    id: '6309010008',
    districtId: '6309010',
    name: 'Hariang',
  },
  {
    id: '6309010010',
    districtId: '6309010',
    name: 'Bungin',
  },
  {
    id: '6309010011',
    districtId: '6309010',
    name: 'Bangkiling',
  },
  {
    id: '6309010012',
    districtId: '6309010',
    name: 'Bangkiling Raya',
  },
  {
    id: '6309010016',
    districtId: '6309010',
    name: 'Banua Lawas',
  },
  {
    id: '6309010021',
    districtId: '6309010',
    name: 'Habau',
  },
  {
    id: '6309010022',
    districtId: '6309010',
    name: 'Banua Rantau',
  },
  {
    id: '6309010024',
    districtId: '6309010',
    name: 'Habau Hulu',
  },
  {
    id: '6309010025',
    districtId: '6309010',
    name: 'Purai',
  },
  {
    id: '6309010026',
    districtId: '6309010',
    name: 'Talan',
  },
  {
    id: '6309010027',
    districtId: '6309010',
    name: 'Sungai Anyar',
  },
  {
    id: '6309020003',
    districtId: '6309020',
    name: 'Pampanan',
  },
  {
    id: '6309020004',
    districtId: '6309020',
    name: 'Tamunti',
  },
  {
    id: '6309020005',
    districtId: '6309020',
    name: 'Pugaan',
  },
  {
    id: '6309020006',
    districtId: '6309020',
    name: 'Halangan',
  },
  {
    id: '6309020007',
    districtId: '6309020',
    name: 'Sungai Rukam I',
  },
  {
    id: '6309020008',
    districtId: '6309020',
    name: 'Sungai Rukam II',
  },
  {
    id: '6309020009',
    districtId: '6309020',
    name: 'Jirak',
  },
  {
    id: '6309030001',
    districtId: '6309030',
    name: 'Telaga Itar',
  },
  {
    id: '6309030004',
    districtId: '6309030',
    name: 'Pudak Setegal',
  },
  {
    id: '6309030007',
    districtId: '6309030',
    name: 'Bahungin',
  },
  {
    id: '6309030008',
    districtId: '6309030',
    name: 'Takulat',
  },
  {
    id: '6309030009',
    districtId: '6309030',
    name: 'Pulau',
  },
  {
    id: '6309030010',
    districtId: '6309030',
    name: 'Masintan',
  },
  {
    id: '6309030011',
    districtId: '6309030',
    name: 'Paliat',
  },
  {
    id: '6309030013',
    districtId: '6309030',
    name: 'Sungai Buluh',
  },
  {
    id: '6309030015',
    districtId: '6309030',
    name: 'Binturu',
  },
  {
    id: '6309030016',
    districtId: '6309030',
    name: 'Karangan Putih',
  },
  {
    id: '6309030017',
    districtId: '6309030',
    name: 'Pasar Panas',
  },
  {
    id: '6309030018',
    districtId: '6309030',
    name: 'Ampukung',
  },
  {
    id: '6309040001',
    districtId: '6309040',
    name: 'Madang',
  },
  {
    id: '6309040002',
    districtId: '6309040',
    name: 'Padangin',
  },
  {
    id: '6309040003',
    districtId: '6309040',
    name: 'Harus',
  },
  {
    id: '6309040004',
    districtId: '6309040',
    name: 'Tantaringin',
  },
  {
    id: '6309040005',
    districtId: '6309040',
    name: 'Manduin',
  },
  {
    id: '6309040006',
    districtId: '6309040',
    name: 'Mantuil',
  },
  {
    id: '6309040007',
    districtId: '6309040',
    name: 'Murung Karangan',
  },
  {
    id: '6309050001',
    districtId: '6309050',
    name: 'Walangkir',
  },
  {
    id: '6309050002',
    districtId: '6309050',
    name: "Pulau Ku'U",
  },
  {
    id: '6309050003',
    districtId: '6309050',
    name: 'Tamiyang',
  },
  {
    id: '6309050004',
    districtId: '6309050',
    name: 'Warukin',
  },
  {
    id: '6309050005',
    districtId: '6309050',
    name: 'Padang Panjang',
  },
  {
    id: '6309050007',
    districtId: '6309050',
    name: 'Barimbun',
  },
  {
    id: '6309050010',
    districtId: '6309050',
    name: 'Padangin',
  },
  {
    id: '6309050011',
    districtId: '6309050',
    name: 'Luk Bayur',
  },
  {
    id: '6309050014',
    districtId: '6309050',
    name: 'Mangkusip',
  },
  {
    id: '6309050015',
    districtId: '6309050',
    name: 'Tanta',
  },
  {
    id: '6309050017',
    districtId: '6309050',
    name: 'Tanta Hulu',
  },
  {
    id: '6309050019',
    districtId: '6309050',
    name: 'Puain Kanan',
  },
  {
    id: '6309050020',
    districtId: '6309050',
    name: 'Pamarangan Kanan',
  },
  {
    id: '6309050022',
    districtId: '6309050',
    name: 'Murung Baru',
  },
  {
    id: '6309060002',
    districtId: '6309060',
    name: 'Banyu Tajun',
  },
  {
    id: '6309060003',
    districtId: '6309060',
    name: 'Sungai Pimping',
  },
  {
    id: '6309060004',
    districtId: '6309060',
    name: 'Pamarangan Kiwa',
  },
  {
    id: '6309060006',
    districtId: '6309060',
    name: 'Puain Kiwa',
  },
  {
    id: '6309060007',
    districtId: '6309060',
    name: 'Jangkung',
  },
  {
    id: '6309060008',
    districtId: '6309060',
    name: 'Tanjung',
  },
  {
    id: '6309060009',
    districtId: '6309060',
    name: 'Agung',
  },
  {
    id: '6309060011',
    districtId: '6309060',
    name: 'Kambitin',
  },
  {
    id: '6309060012',
    districtId: '6309060',
    name: 'Hikun',
  },
  {
    id: '6309060014',
    districtId: '6309060',
    name: 'Kambitin Raya',
  },
  {
    id: '6309060015',
    districtId: '6309060',
    name: 'Wayau',
  },
  {
    id: '6309060017',
    districtId: '6309060',
    name: 'Juai',
  },
  {
    id: '6309060019',
    districtId: '6309060',
    name: 'Garunggung',
  },
  {
    id: '6309060020',
    districtId: '6309060',
    name: 'Kitang',
  },
  {
    id: '6309060021',
    districtId: '6309060',
    name: 'Mahe Seberang',
  },
  {
    id: '6309070001',
    districtId: '6309070',
    name: 'Sulingan',
  },
  {
    id: '6309070002',
    districtId: '6309070',
    name: 'Pembataan',
  },
  {
    id: '6309070003',
    districtId: '6309070',
    name: 'Mabuun',
  },
  {
    id: '6309070004',
    districtId: '6309070',
    name: 'Maburai',
  },
  {
    id: '6309070005',
    districtId: '6309070',
    name: 'Belimbing Raya',
  },
  {
    id: '6309070006',
    districtId: '6309070',
    name: 'Belimbing',
  },
  {
    id: '6309070007',
    districtId: '6309070',
    name: 'Kapar',
  },
  {
    id: '6309070009',
    districtId: '6309070',
    name: 'Masukau',
  },
  {
    id: '6309070012',
    districtId: '6309070',
    name: 'Kasiau',
  },
  {
    id: '6309070013',
    districtId: '6309070',
    name: 'Kasiau Raya',
  },
  {
    id: '6309080002',
    districtId: '6309080',
    name: 'Lok Batu',
  },
  {
    id: '6309080003',
    districtId: '6309080',
    name: 'Kembang Kuning',
  },
  {
    id: '6309080004',
    districtId: '6309080',
    name: 'Seradang',
  },
  {
    id: '6309080006',
    districtId: '6309080',
    name: 'Halong',
  },
  {
    id: '6309080010',
    districtId: '6309080',
    name: 'Catur Karya',
  },
  {
    id: '6309080012',
    districtId: '6309080',
    name: 'Mahe Pasar',
  },
  {
    id: '6309080016',
    districtId: '6309080',
    name: 'Suriyan',
  },
  {
    id: '6309080027',
    districtId: '6309080',
    name: 'Hayup',
  },
  {
    id: '6309080030',
    districtId: '6309080',
    name: 'Bongkang',
  },
  {
    id: '6309080031',
    districtId: '6309080',
    name: 'Wirang',
  },
  {
    id: '6309080035',
    districtId: '6309080',
    name: 'Nawin',
  },
  {
    id: '6309080036',
    districtId: '6309080',
    name: 'Marindi',
  },
  {
    id: '6309081001',
    districtId: '6309081',
    name: 'Waling',
  },
  {
    id: '6309081002',
    districtId: '6309081',
    name: 'Usih',
  },
  {
    id: '6309081003',
    districtId: '6309081',
    name: 'Bintang Ara',
  },
  {
    id: '6309081004',
    districtId: '6309081',
    name: 'Argo Mulyo',
  },
  {
    id: '6309081006',
    districtId: '6309081',
    name: 'Panaan',
  },
  {
    id: '6309081007',
    districtId: '6309081',
    name: 'Hegar Manah',
  },
  {
    id: '6309081008',
    districtId: '6309081',
    name: 'Dambung Raya',
  },
  {
    id: '6309081009',
    districtId: '6309081',
    name: 'Bumi Makmur',
  },
  {
    id: '6309090001',
    districtId: '6309090',
    name: 'Masingai II',
  },
  {
    id: '6309090002',
    districtId: '6309090',
    name: 'Masingai I',
  },
  {
    id: '6309090003',
    districtId: '6309090',
    name: 'Bilas',
  },
  {
    id: '6309090005',
    districtId: '6309090',
    name: 'Kaong',
  },
  {
    id: '6309090007',
    districtId: '6309090',
    name: 'Pangelak',
  },
  {
    id: '6309090010',
    districtId: '6309090',
    name: 'Kinarum',
  },
  {
    id: '6309100001',
    districtId: '6309100',
    name: 'Ribang',
  },
  {
    id: '6309100002',
    districtId: '6309100',
    name: 'Kupang Nunding',
  },
  {
    id: '6309100003',
    districtId: '6309100',
    name: 'Mangkupum',
  },
  {
    id: '6309100004',
    districtId: '6309100',
    name: 'Kampung Baru',
  },
  {
    id: '6309100005',
    districtId: '6309100',
    name: 'Pelapi',
  },
  {
    id: '6309100006',
    districtId: '6309100',
    name: 'Pasar Batu',
  },
  {
    id: '6309100007',
    districtId: '6309100',
    name: 'Simpung Layung',
  },
  {
    id: '6309100008',
    districtId: '6309100',
    name: 'Uwie',
  },
  {
    id: '6309100010',
    districtId: '6309100',
    name: 'Muara Uya',
  },
  {
    id: '6309100011',
    districtId: '6309100',
    name: 'Lumbang',
  },
  {
    id: '6309100014',
    districtId: '6309100',
    name: 'Santuun',
  },
  {
    id: '6309100015',
    districtId: '6309100',
    name: 'Binjai',
  },
  {
    id: '6309100016',
    districtId: '6309100',
    name: 'Salikung',
  },
  {
    id: '6309100017',
    districtId: '6309100',
    name: 'Sungai Kumap',
  },
  {
    id: '6309110001',
    districtId: '6309110',
    name: 'Namun',
  },
  {
    id: '6309110002',
    districtId: '6309110',
    name: 'Muang',
  },
  {
    id: '6309110003',
    districtId: '6309110',
    name: 'Teratau',
  },
  {
    id: '6309110004',
    districtId: '6309110',
    name: 'Purui',
  },
  {
    id: '6309110005',
    districtId: '6309110',
    name: 'Nalui',
  },
  {
    id: '6309110006',
    districtId: '6309110',
    name: 'Jaro',
  },
  {
    id: '6309110007',
    districtId: '6309110',
    name: 'Garagata',
  },
  {
    id: '6309110008',
    districtId: '6309110',
    name: 'Solan',
  },
  {
    id: '6309110009',
    districtId: '6309110',
    name: 'Lano',
  },
  {
    id: '6310010002',
    districtId: '6310010',
    name: 'Pulau Salak',
  },
  {
    id: '6310010003',
    districtId: '6310010',
    name: 'Beringin',
  },
  {
    id: '6310010004',
    districtId: '6310010',
    name: 'Baru Gelang',
  },
  {
    id: '6310010005',
    districtId: '6310010',
    name: 'Sei Lembu',
  },
  {
    id: '6310010007',
    districtId: '6310010',
    name: 'Wiritasi',
  },
  {
    id: '6310010008',
    districtId: '6310010',
    name: 'Batuah',
  },
  {
    id: '6310010009',
    districtId: '6310010',
    name: 'Pagar Ruyung',
  },
  {
    id: '6310010010',
    districtId: '6310010',
    name: 'Pasar Baru',
  },
  {
    id: '6310010011',
    districtId: '6310010',
    name: 'Juku Eja',
  },
  {
    id: '6310010012',
    districtId: '6310010',
    name: 'Pejala',
  },
  {
    id: '6310010013',
    districtId: '6310010',
    name: 'Kota Pagatan',
  },
  {
    id: '6310010014',
    districtId: '6310010',
    name: 'Pulau Satu',
  },
  {
    id: '6310010015',
    districtId: '6310010',
    name: 'Kampung Baru',
  },
  {
    id: '6310010016',
    districtId: '6310010',
    name: 'Penyolongan',
  },
  {
    id: '6310010017',
    districtId: '6310010',
    name: 'Tanette',
  },
  {
    id: '6310010018',
    districtId: '6310010',
    name: 'Muara Pagatan Tengah',
  },
  {
    id: '6310010019',
    districtId: '6310010',
    name: 'Muara Pagatan',
  },
  {
    id: '6310010021',
    districtId: '6310010',
    name: 'Api Api',
  },
  {
    id: '6310010022',
    districtId: '6310010',
    name: 'Rantau Panjang Hilir',
  },
  {
    id: '6310010023',
    districtId: '6310010',
    name: 'Pakatellu',
  },
  {
    id: '6310010024',
    districtId: '6310010',
    name: 'Rantau Panjang Hulu',
  },
  {
    id: '6310010025',
    districtId: '6310010',
    name: 'Mudalang',
  },
  {
    id: '6310010026',
    districtId: '6310010',
    name: 'Manurung',
  },
  {
    id: '6310010027',
    districtId: '6310010',
    name: 'Batarang',
  },
  {
    id: '6310010028',
    districtId: '6310010',
    name: 'Mekar Jaya',
  },
  {
    id: '6310010029',
    districtId: '6310010',
    name: 'Pulau Tanjung',
  },
  {
    id: '6310010030',
    districtId: '6310010',
    name: 'Salimuran',
  },
  {
    id: '6310010031',
    districtId: '6310010',
    name: 'UPT. Karya Bhakti',
  },
  {
    id: '6310010032',
    districtId: '6310010',
    name: 'Satiung',
  },
  {
    id: '6310010033',
    districtId: '6310010',
    name: 'Saring Sei Binjai',
  },
  {
    id: '6310010034',
    districtId: '6310010',
    name: 'Saring Sei Bubu',
  },
  {
    id: '6310010035',
    districtId: '6310010',
    name: 'Serdangan',
  },
  {
    id: '6310020001',
    districtId: '6310020',
    name: 'Sebamban Baru',
  },
  {
    id: '6310020002',
    districtId: '6310020',
    name: 'Sebamban Lama',
  },
  {
    id: '6310020003',
    districtId: '6310020',
    name: 'Dwi Marga Utama',
  },
  {
    id: '6310020004',
    districtId: '6310020',
    name: 'Sungai Dua Laut',
  },
  {
    id: '6310020005',
    districtId: '6310020',
    name: 'Sungai Loban',
  },
  {
    id: '6310020006',
    districtId: '6310020',
    name: 'Marga Mulya',
  },
  {
    id: '6310020007',
    districtId: '6310020',
    name: 'Sari Mulya',
  },
  {
    id: '6310020008',
    districtId: '6310020',
    name: 'Tri Mulya',
  },
  {
    id: '6310020009',
    districtId: '6310020',
    name: 'Kerta Buana',
  },
  {
    id: '6310020010',
    districtId: '6310020',
    name: 'Tri Martani',
  },
  {
    id: '6310020011',
    districtId: '6310020',
    name: 'Batu Meranti',
  },
  {
    id: '6310020012',
    districtId: '6310020',
    name: 'Sari Utama',
  },
  {
    id: '6310020013',
    districtId: '6310020',
    name: 'Damar Indah',
  },
  {
    id: '6310020014',
    districtId: '6310020',
    name: 'Sumber Sari',
  },
  {
    id: '6310020015',
    districtId: '6310020',
    name: 'Biduri Bersujud',
  },
  {
    id: '6310020016',
    districtId: '6310020',
    name: 'Wanasari',
  },
  {
    id: '6310020017',
    districtId: '6310020',
    name: 'Sumber Makmur',
  },
  {
    id: '6310030001',
    districtId: '6310030',
    name: 'Sungai Cuka',
  },
  {
    id: '6310030002',
    districtId: '6310030',
    name: 'Sejahtera Mulia',
  },
  {
    id: '6310030003',
    districtId: '6310030',
    name: 'Jombang',
  },
  {
    id: '6310030004',
    districtId: '6310030',
    name: 'Sungai Danau',
  },
  {
    id: '6310030005',
    districtId: '6310030',
    name: 'Satui Timur',
  },
  {
    id: '6310030007',
    districtId: '6310030',
    name: 'Satui Barat',
  },
  {
    id: '6310030008',
    districtId: '6310030',
    name: 'Setarap',
  },
  {
    id: '6310030016',
    districtId: '6310030',
    name: 'Tegal Sari',
  },
  {
    id: '6310030017',
    districtId: '6310030',
    name: 'Sekapuk',
  },
  {
    id: '6310030018',
    districtId: '6310030',
    name: 'Sumber Makmur',
  },
  {
    id: '6310030019',
    districtId: '6310030',
    name: 'Wono Rejo',
  },
  {
    id: '6310030020',
    districtId: '6310030',
    name: 'Sumber Arum',
  },
  {
    id: '6310030021',
    districtId: '6310030',
    name: 'Makmur Mulia',
  },
  {
    id: '6310030022',
    districtId: '6310030',
    name: 'Al Kautsar',
  },
  {
    id: '6310030025',
    districtId: '6310030',
    name: 'Sinar Bulan',
  },
  {
    id: '6310030026',
    districtId: '6310030',
    name: 'Pendamaran Jaya',
  },
  {
    id: '6310031001',
    districtId: '6310031',
    name: 'Sumber Baru',
  },
  {
    id: '6310031002',
    districtId: '6310031',
    name: 'Angsana',
  },
  {
    id: '6310031003',
    districtId: '6310031',
    name: 'Bunati',
  },
  {
    id: '6310031004',
    districtId: '6310031',
    name: 'Karang Indah',
  },
  {
    id: '6310031005',
    districtId: '6310031',
    name: 'Banjar Sari',
  },
  {
    id: '6310031006',
    districtId: '6310031',
    name: 'Bayan Sari',
  },
  {
    id: '6310031007',
    districtId: '6310031',
    name: 'Purwodadi',
  },
  {
    id: '6310031008',
    districtId: '6310031',
    name: 'Makmur',
  },
  {
    id: '6310031009',
    districtId: '6310031',
    name: 'Mekar Jaya',
  },
  {
    id: '6310040005',
    districtId: '6310040',
    name: 'Bakarangan',
  },
  {
    id: '6310040006',
    districtId: '6310040',
    name: 'Karang Mulya',
  },
  {
    id: '6310040007',
    districtId: '6310040',
    name: 'Harapan Jaya',
  },
  {
    id: '6310040008',
    districtId: '6310040',
    name: 'Lasung',
  },
  {
    id: '6310040009',
    districtId: '6310040',
    name: 'Sungai Rukam',
  },
  {
    id: '6310040010',
    districtId: '6310040',
    name: 'Manuntung',
  },
  {
    id: '6310040011',
    districtId: '6310040',
    name: 'Anjir Baru',
  },
  {
    id: '6310040012',
    districtId: '6310040',
    name: 'Binawara',
  },
  {
    id: '6310040013',
    districtId: '6310040',
    name: 'Pacakan',
  },
  {
    id: '6310040014',
    districtId: '6310040',
    name: 'Wonorejo',
  },
  {
    id: '6310040015',
    districtId: '6310040',
    name: 'Karang Sari',
  },
  {
    id: '6310040016',
    districtId: '6310040',
    name: 'Tibarau Panjang',
  },
  {
    id: '6310040017',
    districtId: '6310040',
    name: 'Tapus',
  },
  {
    id: '6310040018',
    districtId: '6310040',
    name: 'Darasan Binjai',
  },
  {
    id: '6310040020',
    districtId: '6310040',
    name: 'Teluk Kepayang',
  },
  {
    id: '6310040021',
    districtId: '6310040',
    name: "Hati'If",
  },
  {
    id: '6310040022',
    districtId: '6310040',
    name: 'Mangkalapi',
  },
  {
    id: '6310040023',
    districtId: '6310040',
    name: 'Tamunih',
  },
  {
    id: '6310040024',
    districtId: '6310040',
    name: 'Batu Bulan',
  },
  {
    id: '6310040025',
    districtId: '6310040',
    name: 'Dadap Kusan Raya',
  },
  {
    id: '6310041001',
    districtId: '6310041',
    name: 'Indra Loka Jaya',
  },
  {
    id: '6310041002',
    districtId: '6310041',
    name: 'Karang Intan',
  },
  {
    id: '6310041003',
    districtId: '6310041',
    name: 'Mustika',
  },
  {
    id: '6310041004',
    districtId: '6310041',
    name: 'Giri Mulya',
  },
  {
    id: '6310041005',
    districtId: '6310041',
    name: 'Kuranji',
  },
  {
    id: '6310041006',
    districtId: '6310041',
    name: 'Waringin Tunggal',
  },
  {
    id: '6310041007',
    districtId: '6310041',
    name: 'Ringkit',
  },
  {
    id: '6310050001',
    districtId: '6310050',
    name: 'Segumbang',
  },
  {
    id: '6310050002',
    districtId: '6310050',
    name: 'Gunung Tinggi',
  },
  {
    id: '6310050003',
    districtId: '6310050',
    name: 'Kersik Putih',
  },
  {
    id: '6310050004',
    districtId: '6310050',
    name: 'Batulicin',
  },
  {
    id: '6310050006',
    districtId: '6310050',
    name: 'Maju Makmur',
  },
  {
    id: '6310050007',
    districtId: '6310050',
    name: 'Danau Indah',
  },
  {
    id: '6310050008',
    districtId: '6310050',
    name: 'Polewali Marajae',
  },
  {
    id: '6310050009',
    districtId: '6310050',
    name: 'Maju Bersama',
  },
  {
    id: '6310050010',
    districtId: '6310050',
    name: 'Sukamaju',
  },
  {
    id: '6310051001',
    districtId: '6310051',
    name: 'Rejo Winangun',
  },
  {
    id: '6310051002',
    districtId: '6310051',
    name: 'Pematang Ulin',
  },
  {
    id: '6310051003',
    districtId: '6310051',
    name: 'Karang Bintang',
  },
  {
    id: '6310051004',
    districtId: '6310051',
    name: 'Batulicin Irigasi',
  },
  {
    id: '6310051005',
    districtId: '6310051',
    name: 'Pandan Sari',
  },
  {
    id: '6310051006',
    districtId: '6310051',
    name: 'Sela Selilau',
  },
  {
    id: '6310051007',
    districtId: '6310051',
    name: 'Manunggal',
  },
  {
    id: '6310051008',
    districtId: '6310051',
    name: 'Maju Sejahtera',
  },
  {
    id: '6310051009',
    districtId: '6310051',
    name: 'Sumber Wangi',
  },
  {
    id: '6310051010',
    districtId: '6310051',
    name: 'Madu Retno',
  },
  {
    id: '6310051011',
    districtId: '6310051',
    name: 'Karang Rejo',
  },
  {
    id: '6310052001',
    districtId: '6310052',
    name: 'Kampung Baru',
  },
  {
    id: '6310052002',
    districtId: '6310052',
    name: 'Tungkaran Pangeran',
  },
  {
    id: '6310052003',
    districtId: '6310052',
    name: 'Sari Gadung',
  },
  {
    id: '6310052004',
    districtId: '6310052',
    name: 'Sungai Dua',
  },
  {
    id: '6310052005',
    districtId: '6310052',
    name: 'Mekar Sari',
  },
  {
    id: '6310052006',
    districtId: '6310052',
    name: 'Batu Ampar',
  },
  {
    id: '6310052007',
    districtId: '6310052',
    name: 'Gunung Besar',
  },
  {
    id: '6310052008',
    districtId: '6310052',
    name: 'Pulau Panjang',
  },
  {
    id: '6310052009',
    districtId: '6310052',
    name: 'Baroqah',
  },
  {
    id: '6310052010',
    districtId: '6310052',
    name: 'Sejahtera',
  },
  {
    id: '6310052012',
    districtId: '6310052',
    name: 'Gunung Antasari',
  },
  {
    id: '6310053001',
    districtId: '6310053',
    name: 'Mantewe',
  },
  {
    id: '6310053002',
    districtId: '6310053',
    name: 'Maju Mulyo',
  },
  {
    id: '6310053003',
    districtId: '6310053',
    name: 'Sidomulyo',
  },
  {
    id: '6310053004',
    districtId: '6310053',
    name: 'Sari Mulya',
  },
  {
    id: '6310053005',
    districtId: '6310053',
    name: 'Bulu Rejo',
  },
  {
    id: '6310053006',
    districtId: '6310053',
    name: 'Sukadamai',
  },
  {
    id: '6310053007',
    districtId: '6310053',
    name: 'Sepakat',
  },
  {
    id: '6310053008',
    districtId: '6310053',
    name: 'Dukuh Rejo',
  },
  {
    id: '6310053009',
    districtId: '6310053',
    name: 'Rejosari',
  },
  {
    id: '6310053010',
    districtId: '6310053',
    name: 'Emil Baru',
  },
  {
    id: '6310053011',
    districtId: '6310053',
    name: 'Mantawakan Mulia',
  },
  {
    id: '6310053013',
    districtId: '6310053',
    name: 'Gunung Raya',
  },
  {
    id: '6311010001',
    districtId: '6311010',
    name: 'Teluk Karya',
  },
  {
    id: '6311010002',
    districtId: '6311010',
    name: 'Matang Lurus',
  },
  {
    id: '6311010003',
    districtId: '6311010',
    name: 'Pimping',
  },
  {
    id: '6311010004',
    districtId: '6311010',
    name: 'Tanah Habang Kiri',
  },
  {
    id: '6311010005',
    districtId: '6311010',
    name: 'Tanah Habang Kanan',
  },
  {
    id: '6311010006',
    districtId: '6311010',
    name: 'Kandang Jaya',
  },
  {
    id: '6311010007',
    districtId: '6311010',
    name: 'Jimamun',
  },
  {
    id: '6311010008',
    districtId: '6311010',
    name: 'Panaitan',
  },
  {
    id: '6311010009',
    districtId: '6311010',
    name: 'Tampang',
  },
  {
    id: '6311010010',
    districtId: '6311010',
    name: 'Lok Panginangan',
  },
  {
    id: '6311010011',
    districtId: '6311010',
    name: 'Lampihong Selatan',
  },
  {
    id: '6311010012',
    districtId: '6311010',
    name: 'Sungai Tabuk',
  },
  {
    id: '6311010013',
    districtId: '6311010',
    name: 'Lampihong Kanan',
  },
  {
    id: '6311010014',
    districtId: '6311010',
    name: 'Batu Merah',
  },
  {
    id: '6311010015',
    districtId: '6311010',
    name: 'Simpang Tiga',
  },
  {
    id: '6311010016',
    districtId: '6311010',
    name: 'Hilir Pasar',
  },
  {
    id: '6311010017',
    districtId: '6311010',
    name: 'Mundar',
  },
  {
    id: '6311010018',
    districtId: '6311010',
    name: 'Matang Hanau',
  },
  {
    id: '6311010019',
    districtId: '6311010',
    name: 'Lampihong Kiri',
  },
  {
    id: '6311010020',
    districtId: '6311010',
    name: 'Sungai Awang',
  },
  {
    id: '6311010021',
    districtId: '6311010',
    name: 'Pupuyuan',
  },
  {
    id: '6311010022',
    districtId: '6311010',
    name: 'Lajar',
  },
  {
    id: '6311010023',
    districtId: '6311010',
    name: 'Kupang',
  },
  {
    id: '6311010024',
    districtId: '6311010',
    name: 'Lok Hamawang',
  },
  {
    id: '6311010025',
    districtId: '6311010',
    name: 'Kusambi Hilir',
  },
  {
    id: '6311010026',
    districtId: '6311010',
    name: 'Kusambi Hulu',
  },
  {
    id: '6311010027',
    districtId: '6311010',
    name: 'Jungkal',
  },
  {
    id: '6311020001',
    districtId: '6311020',
    name: 'Gunung Manau',
  },
  {
    id: '6311020002',
    districtId: '6311020',
    name: 'Tariwin',
  },
  {
    id: '6311020003',
    districtId: '6311020',
    name: 'Lok Batu',
  },
  {
    id: '6311020004',
    districtId: '6311020',
    name: 'Bakung',
  },
  {
    id: '6311020005',
    districtId: '6311020',
    name: 'Karuh',
  },
  {
    id: '6311020007',
    districtId: '6311020',
    name: 'Pelajau',
  },
  {
    id: '6311020008',
    districtId: '6311020',
    name: 'Kasai',
  },
  {
    id: '6311020009',
    districtId: '6311020',
    name: 'Hamparaya',
  },
  {
    id: '6311020010',
    districtId: '6311020',
    name: 'Timbun Tulang',
  },
  {
    id: '6311020011',
    districtId: '6311020',
    name: 'Teluk Mesjid',
  },
  {
    id: '6311020012',
    districtId: '6311020',
    name: 'Batu Mandi',
  },
  {
    id: '6311020014',
    districtId: '6311020',
    name: 'Riwa',
  },
  {
    id: '6311020015',
    districtId: '6311020',
    name: 'Guha',
  },
  {
    id: '6311020016',
    districtId: '6311020',
    name: 'Mantimin',
  },
  {
    id: '6311020017',
    districtId: '6311020',
    name: 'Banua Hanyar',
  },
  {
    id: '6311020018',
    districtId: '6311020',
    name: 'Mampari',
  },
  {
    id: '6311030001',
    districtId: '6311030',
    name: 'Nungka',
  },
  {
    id: '6311030002',
    districtId: '6311030',
    name: 'Tundakan',
  },
  {
    id: '6311030003',
    districtId: '6311030',
    name: 'Ambakiyang',
  },
  {
    id: '6311030004',
    districtId: '6311030',
    name: 'Piyait',
  },
  {
    id: '6311030005',
    districtId: '6311030',
    name: 'Baramban',
  },
  {
    id: '6311030006',
    districtId: '6311030',
    name: 'Bihara',
  },
  {
    id: '6311030007',
    districtId: '6311030',
    name: 'Bihara Hilir',
  },
  {
    id: '6311030008',
    districtId: '6311030',
    name: 'Muara Jaya',
  },
  {
    id: '6311030009',
    districtId: '6311030',
    name: 'Pematang',
  },
  {
    id: '6311030010',
    districtId: '6311030',
    name: 'Sungai Pumpung',
  },
  {
    id: '6311030011',
    districtId: '6311030',
    name: 'Merah',
  },
  {
    id: '6311030012',
    districtId: '6311030',
    name: 'Kedondong',
  },
  {
    id: '6311030013',
    districtId: '6311030',
    name: 'Pulantan',
  },
  {
    id: '6311030014',
    districtId: '6311030',
    name: 'Putat Basiun',
  },
  {
    id: '6311030015',
    districtId: '6311030',
    name: 'Awayan',
  },
  {
    id: '6311030016',
    districtId: '6311030',
    name: 'Awayan Hilir',
  },
  {
    id: '6311030017',
    districtId: '6311030',
    name: 'Badalungga Hilir',
  },
  {
    id: '6311030018',
    districtId: '6311030',
    name: 'Badalungga',
  },
  {
    id: '6311030019',
    districtId: '6311030',
    name: 'Sikontan',
  },
  {
    id: '6311030020',
    districtId: '6311030',
    name: 'Tundi',
  },
  {
    id: '6311030021',
    districtId: '6311030',
    name: 'Pudak',
  },
  {
    id: '6311030022',
    districtId: '6311030',
    name: 'Baru',
  },
  {
    id: '6311030023',
    districtId: '6311030',
    name: 'Tangalin',
  },
  {
    id: '6311031003',
    districtId: '6311031',
    name: 'Auh',
  },
  {
    id: '6311031004',
    districtId: '6311031',
    name: 'Dayak Pitap',
  },
  {
    id: '6311031005',
    districtId: '6311031',
    name: 'Langkap',
  },
  {
    id: '6311031006',
    districtId: '6311031',
    name: 'Mayanau',
  },
  {
    id: '6311031007',
    districtId: '6311031',
    name: 'Simpang Bumbuan',
  },
  {
    id: '6311031008',
    districtId: '6311031',
    name: 'Simpang Nadung',
  },
  {
    id: '6311031009',
    districtId: '6311031',
    name: 'Gunung Batu',
  },
  {
    id: '6311031010',
    districtId: '6311031',
    name: 'Tebing Tinggi',
  },
  {
    id: '6311031011',
    districtId: '6311031',
    name: 'Ajung',
  },
  {
    id: '6311031012',
    districtId: '6311031',
    name: 'Kambiyain',
  },
  {
    id: '6311040001',
    districtId: '6311040',
    name: 'Lamida',
  },
  {
    id: '6311040002',
    districtId: '6311040',
    name: 'Lok Batung',
  },
  {
    id: '6311040003',
    districtId: '6311040',
    name: 'Babayau',
  },
  {
    id: '6311040004',
    districtId: '6311040',
    name: 'Paran',
  },
  {
    id: '6311040005',
    districtId: '6311040',
    name: 'Mangkayahu',
  },
  {
    id: '6311040006',
    districtId: '6311040',
    name: 'Balang',
  },
  {
    id: '6311040007',
    districtId: '6311040',
    name: 'Murung Ilung',
  },
  {
    id: '6311040008',
    districtId: '6311040',
    name: 'Hujan Mas',
  },
  {
    id: '6311040009',
    districtId: '6311040',
    name: 'Kalahiang',
  },
  {
    id: '6311040010',
    districtId: '6311040',
    name: 'Layap',
  },
  {
    id: '6311040013',
    districtId: '6311040',
    name: 'Paringin Kota',
  },
  {
    id: '6311040014',
    districtId: '6311040',
    name: 'Paringin Timur',
  },
  {
    id: '6311040016',
    districtId: '6311040',
    name: 'Balida',
  },
  {
    id: '6311040018',
    districtId: '6311040',
    name: 'Lasung Batu',
  },
  {
    id: '6311040019',
    districtId: '6311040',
    name: 'Sungai Katapi',
  },
  {
    id: '6311040020',
    districtId: '6311040',
    name: 'Dahai',
  },
  {
    id: '6311041001',
    districtId: '6311041',
    name: 'Murung Jambu',
  },
  {
    id: '6311041002',
    districtId: '6311041',
    name: 'Halubau',
  },
  {
    id: '6311041004',
    districtId: '6311041',
    name: 'Panggung',
  },
  {
    id: '6311041005',
    districtId: '6311041',
    name: 'Inan',
  },
  {
    id: '6311041006',
    districtId: '6311041',
    name: 'Murung Abuin',
  },
  {
    id: '6311041007',
    districtId: '6311041',
    name: 'Baruh Bahinu Dalam',
  },
  {
    id: '6311041008',
    districtId: '6311041',
    name: 'Binjai',
  },
  {
    id: '6311041009',
    districtId: '6311041',
    name: 'Telaga Purun',
  },
  {
    id: '6311041010',
    districtId: '6311041',
    name: 'Galombang',
  },
  {
    id: '6311041011',
    districtId: '6311041',
    name: 'Maradap',
  },
  {
    id: '6311041012',
    districtId: '6311041',
    name: 'Baruh Bahinu Luar',
  },
  {
    id: '6311041015',
    districtId: '6311041',
    name: 'Bungin',
  },
  {
    id: '6311041016',
    districtId: '6311041',
    name: 'Lingsir',
  },
  {
    id: '6311041017',
    districtId: '6311041',
    name: 'Halubau Utara',
  },
  {
    id: '6311041018',
    districtId: '6311041',
    name: 'Tarangan',
  },
  {
    id: '6311041019',
    districtId: '6311041',
    name: 'Batu Piring',
  },
  {
    id: '6311050001',
    districtId: '6311050',
    name: 'Pamurus',
  },
  {
    id: '6311050002',
    districtId: '6311050',
    name: 'Gulinggang',
  },
  {
    id: '6311050003',
    districtId: '6311050',
    name: 'Sungai Batung',
  },
  {
    id: '6311050004',
    districtId: '6311050',
    name: 'Tawahan',
  },
  {
    id: '6311050005',
    districtId: '6311050',
    name: 'Tigarun',
  },
  {
    id: '6311050006',
    districtId: '6311050',
    name: 'Panimbaan',
  },
  {
    id: '6311050007',
    districtId: '6311050',
    name: 'Galumbang',
  },
  {
    id: '6311050008',
    districtId: '6311050',
    name: 'Juai',
  },
  {
    id: '6311050009',
    districtId: '6311050',
    name: 'Teluk Bayur',
  },
  {
    id: '6311050010',
    districtId: '6311050',
    name: 'Mungkur Uyam',
  },
  {
    id: '6311050011',
    districtId: '6311050',
    name: 'Sirap',
  },
  {
    id: '6311050012',
    districtId: '6311050',
    name: 'Hamarung',
  },
  {
    id: '6311050013',
    districtId: '6311050',
    name: 'Hukai',
  },
  {
    id: '6311050014',
    districtId: '6311050',
    name: 'Muara Ninian',
  },
  {
    id: '6311050015',
    districtId: '6311050',
    name: 'Marias',
  },
  {
    id: '6311050016',
    districtId: '6311050',
    name: 'Buntu Karau',
  },
  {
    id: '6311050017',
    districtId: '6311050',
    name: 'Wonorejo',
  },
  {
    id: '6311050018',
    districtId: '6311050',
    name: 'Sumber Rejeki',
  },
  {
    id: '6311050019',
    districtId: '6311050',
    name: 'Bata',
  },
  {
    id: '6311050020',
    districtId: '6311050',
    name: 'Mihu',
  },
  {
    id: '6311050021',
    districtId: '6311050',
    name: 'Lalayau',
  },
  {
    id: '6311060001',
    districtId: '6311060',
    name: 'Binuang Santang',
  },
  {
    id: '6311060002',
    districtId: '6311060',
    name: 'Marajai',
  },
  {
    id: '6311060003',
    districtId: '6311060',
    name: 'Mauya',
  },
  {
    id: '6311060004',
    districtId: '6311060',
    name: 'Mantuyan',
  },
  {
    id: '6311060005',
    districtId: '6311060',
    name: 'Tabuan',
  },
  {
    id: '6311060006',
    districtId: '6311060',
    name: 'Buntut Pilanduk',
  },
  {
    id: '6311060008',
    districtId: '6311060',
    name: 'Mamantang',
  },
  {
    id: '6311060009',
    districtId: '6311060',
    name: 'Kapul',
  },
  {
    id: '6311060010',
    districtId: '6311060',
    name: 'Halong',
  },
  {
    id: '6311060011',
    districtId: '6311060',
    name: 'Binjai Punggal',
  },
  {
    id: '6311060012',
    districtId: '6311060',
    name: 'Baruh Panyambaran',
  },
  {
    id: '6311060013',
    districtId: '6311060',
    name: 'Binju',
  },
  {
    id: '6311060014',
    districtId: '6311060',
    name: 'Bangkal',
  },
  {
    id: '6311060015',
    districtId: '6311060',
    name: 'Suryatama',
  },
  {
    id: '6311060016',
    districtId: '6311060',
    name: "Ha'Uwai",
  },
  {
    id: '6311060017',
    districtId: '6311060',
    name: 'Karya',
  },
  {
    id: '6311060019',
    districtId: '6311060',
    name: 'Gunung Riut',
  },
  {
    id: '6311060020',
    districtId: '6311060',
    name: 'Liyu',
  },
  {
    id: '6311060021',
    districtId: '6311060',
    name: 'Aniungan',
  },
  {
    id: '6311060022',
    districtId: '6311060',
    name: 'Mamigang',
  },
  {
    id: '6311060023',
    districtId: '6311060',
    name: 'Padang Raya',
  },
  {
    id: '6311060024',
    districtId: '6311060',
    name: 'Sumber Agung',
  },
  {
    id: '6371010001',
    districtId: '6371010',
    name: 'Mantuil',
  },
  {
    id: '6371010003',
    districtId: '6371010',
    name: 'Kelayan Selatan',
  },
  {
    id: '6371010004',
    districtId: '6371010',
    name: 'Kelayan Timur',
  },
  {
    id: '6371010005',
    districtId: '6371010',
    name: 'Tanjung Pagar',
  },
  {
    id: '6371010006',
    districtId: '6371010',
    name: 'Pemurus Dalam',
  },
  {
    id: '6371010008',
    districtId: '6371010',
    name: 'Pemurus Baru',
  },
  {
    id: '6371010009',
    districtId: '6371010',
    name: 'Murung Raya',
  },
  {
    id: '6371010010',
    districtId: '6371010',
    name: 'Kelayan Dalam',
  },
  {
    id: '6371010011',
    districtId: '6371010',
    name: 'Kelayan Tengah',
  },
  {
    id: '6371010012',
    districtId: '6371010',
    name: 'Pekauman',
  },
  {
    id: '6371010013',
    districtId: '6371010',
    name: 'Kelayan Barat',
  },
  {
    id: '6371010014',
    districtId: '6371010',
    name: 'Basirih Selatan',
  },
  {
    id: '6371020001',
    districtId: '6371020',
    name: 'Pekapuran Raya',
  },
  {
    id: '6371020002',
    districtId: '6371020',
    name: 'Karang Mekar',
  },
  {
    id: '6371020003',
    districtId: '6371020',
    name: 'Kebun Bunga',
  },
  {
    id: '6371020004',
    districtId: '6371020',
    name: 'Sungai Lulut',
  },
  {
    id: '6371020005',
    districtId: '6371020',
    name: 'Kuripan',
  },
  {
    id: '6371020011',
    districtId: '6371020',
    name: 'Sungai Bilu',
  },
  {
    id: '6371020012',
    districtId: '6371020',
    name: 'Pengambangan',
  },
  {
    id: '6371020013',
    districtId: '6371020',
    name: 'Benua Anyar',
  },
  {
    id: '6371020014',
    districtId: '6371020',
    name: 'Pemurus Luar',
  },
  {
    id: '6371030001',
    districtId: '6371030',
    name: 'Teluk Tiram',
  },
  {
    id: '6371030002',
    districtId: '6371030',
    name: 'Telawang',
  },
  {
    id: '6371030008',
    districtId: '6371030',
    name: 'Telaga Biru',
  },
  {
    id: '6371030009',
    districtId: '6371030',
    name: 'Pelambuan',
  },
  {
    id: '6371030010',
    districtId: '6371030',
    name: 'Belitung Selatan',
  },
  {
    id: '6371030011',
    districtId: '6371030',
    name: 'Belitung Utara',
  },
  {
    id: '6371030013',
    districtId: '6371030',
    name: 'Basirih',
  },
  {
    id: '6371030014',
    districtId: '6371030',
    name: 'Kuin Cerucuk',
  },
  {
    id: '6371030015',
    districtId: '6371030',
    name: 'Kuin Selatan',
  },
  {
    id: '6371031001',
    districtId: '6371031',
    name: 'Kelayan Luar',
  },
  {
    id: '6371031002',
    districtId: '6371031',
    name: 'Kertak Baru Ilir',
  },
  {
    id: '6371031003',
    districtId: '6371031',
    name: 'Mawar',
  },
  {
    id: '6371031004',
    districtId: '6371031',
    name: 'Teluk Dalam',
  },
  {
    id: '6371031005',
    districtId: '6371031',
    name: 'Kertak Baru Ulu',
  },
  {
    id: '6371031006',
    districtId: '6371031',
    name: 'Pekapuran Laut',
  },
  {
    id: '6371031007',
    districtId: '6371031',
    name: 'Sungai Baru',
  },
  {
    id: '6371031008',
    districtId: '6371031',
    name: 'Gadang',
  },
  {
    id: '6371031009',
    districtId: '6371031',
    name: 'Antasan Besar',
  },
  {
    id: '6371031010',
    districtId: '6371031',
    name: 'Pasar Lama',
  },
  {
    id: '6371031011',
    districtId: '6371031',
    name: 'Seberang Mesjid',
  },
  {
    id: '6371031012',
    districtId: '6371031',
    name: 'Melayu',
  },
  {
    id: '6371040003',
    districtId: '6371040',
    name: 'Kuin Utara',
  },
  {
    id: '6371040004',
    districtId: '6371040',
    name: 'Pangeran',
  },
  {
    id: '6371040005',
    districtId: '6371040',
    name: 'Sungai Miai',
  },
  {
    id: '6371040006',
    districtId: '6371040',
    name: 'Antasan Kecil Timur',
  },
  {
    id: '6371040007',
    districtId: '6371040',
    name: 'Surgi Mufti',
  },
  {
    id: '6371040008',
    districtId: '6371040',
    name: 'Sungai Jingah',
  },
  {
    id: '6371040009',
    districtId: '6371040',
    name: 'Alalak Utara',
  },
  {
    id: '6371040010',
    districtId: '6371040',
    name: 'Alalak Selatan',
  },
  {
    id: '6371040011',
    districtId: '6371040',
    name: 'Alalak Tengah',
  },
  {
    id: '6371040012',
    districtId: '6371040',
    name: 'Sungai Andai',
  },
  {
    id: '6372010003',
    districtId: '6372010',
    name: 'Landasan Ulin Timur',
  },
  {
    id: '6372010004',
    districtId: '6372010',
    name: 'Guntung Payung',
  },
  {
    id: '6372010006',
    districtId: '6372010',
    name: 'Syamsudin Noor',
  },
  {
    id: '6372010007',
    districtId: '6372010',
    name: 'Guntungmanggis',
  },
  {
    id: '6372011001',
    districtId: '6372011',
    name: 'Landasan Ulin Tengah',
  },
  {
    id: '6372011002',
    districtId: '6372011',
    name: 'Landasan Ulin Utara',
  },
  {
    id: '6372011003',
    districtId: '6372011',
    name: 'Landasan Ulin Barat',
  },
  {
    id: '6372011004',
    districtId: '6372011',
    name: 'Landasan Ulin Selatan',
  },
  {
    id: '6372020001',
    districtId: '6372020',
    name: 'Palam',
  },
  {
    id: '6372020002',
    districtId: '6372020',
    name: 'Bangkal',
  },
  {
    id: '6372020003',
    districtId: '6372020',
    name: 'Sungai Tiung',
  },
  {
    id: '6372020004',
    districtId: '6372020',
    name: 'Cempaka',
  },
  {
    id: '6372031001',
    districtId: '6372031',
    name: 'Loktabat Utara',
  },
  {
    id: '6372031002',
    districtId: '6372031',
    name: 'Mentaos',
  },
  {
    id: '6372031003',
    districtId: '6372031',
    name: 'Komet',
  },
  {
    id: '6372031004',
    districtId: '6372031',
    name: 'Sungai Ulin',
  },
  {
    id: '6372032001',
    districtId: '6372032',
    name: 'Loktabat Selatan',
  },
  {
    id: '6372032002',
    districtId: '6372032',
    name: 'Kemuning',
  },
  {
    id: '6372032003',
    districtId: '6372032',
    name: 'Guntung Paikat',
  },
  {
    id: '6372032004',
    districtId: '6372032',
    name: 'Sungai Besar',
  },
  {
    id: '6401010009',
    districtId: '6401010',
    name: 'Samurangau',
  },
  {
    id: '6401010010',
    districtId: '6401010',
    name: 'Busui',
  },
  {
    id: '6401010011',
    districtId: '6401010',
    name: 'Batu Kajang',
  },
  {
    id: '6401010012',
    districtId: '6401010',
    name: 'Legai',
  },
  {
    id: '6401010013',
    districtId: '6401010',
    name: 'Sungai Terik',
  },
  {
    id: '6401010014',
    districtId: '6401010',
    name: 'Kasungai',
  },
  {
    id: '6401010015',
    districtId: '6401010',
    name: 'Rantau Buta',
  },
  {
    id: '6401010016',
    districtId: '6401010',
    name: 'Rantau Layung',
  },
  {
    id: '6401010017',
    districtId: '6401010',
    name: 'Songka',
  },
  {
    id: '6401011001',
    districtId: '6401011',
    name: 'Tanjung Pinang',
  },
  {
    id: '6401011002',
    districtId: '6401011',
    name: 'Rantau Atas',
  },
  {
    id: '6401011003',
    districtId: '6401011',
    name: 'Libur Dinding',
  },
  {
    id: '6401011004',
    districtId: '6401011',
    name: 'Luan/Dilibinti',
  },
  {
    id: '6401011005',
    districtId: '6401011',
    name: 'Suweto',
  },
  {
    id: '6401011007',
    districtId: '6401011',
    name: 'Biu',
  },
  {
    id: '6401011008',
    districtId: '6401011',
    name: 'Rantau Bintungan',
  },
  {
    id: '6401011009',
    districtId: '6401011',
    name: 'Muara Andeh',
  },
  {
    id: '6401021001',
    districtId: '6401021',
    name: 'Kerang',
  },
  {
    id: '6401021002',
    districtId: '6401021',
    name: 'Tempakan',
  },
  {
    id: '6401021004',
    districtId: '6401021',
    name: 'Lomu',
  },
  {
    id: '6401021005',
    districtId: '6401021',
    name: 'Segendang',
  },
  {
    id: '6401021006',
    districtId: '6401021',
    name: 'Riwang',
  },
  {
    id: '6401021007',
    districtId: '6401021',
    name: 'Langgai',
  },
  {
    id: '6401021008',
    districtId: '6401021',
    name: 'Petangis',
  },
  {
    id: '6401021009',
    districtId: '6401021',
    name: 'Kerang Dayo',
  },
  {
    id: '6401021010',
    districtId: '6401021',
    name: 'Saing Prupuk',
  },
  {
    id: '6401021011',
    districtId: '6401021',
    name: 'Bai Jaya',
  },
  {
    id: '6401021012',
    districtId: '6401021',
    name: 'Pengguren Jaya',
  },
  {
    id: '6401021013',
    districtId: '6401021',
    name: 'Tebru Paser Damai',
  },
  {
    id: '6401022001',
    districtId: '6401022',
    name: 'Tunes Keladen',
  },
  {
    id: '6401022002',
    districtId: '6401022',
    name: 'Tanjung Aru',
  },
  {
    id: '6401022003',
    districtId: '6401022',
    name: 'Labuangkalo',
  },
  {
    id: '6401022004',
    districtId: '6401022',
    name: 'Selengot',
  },
  {
    id: '6401022005',
    districtId: '6401022',
    name: 'Lori',
  },
  {
    id: '6401022006',
    districtId: '6401022',
    name: 'Random',
  },
  {
    id: '6401022007',
    districtId: '6401022',
    name: 'Senipah',
  },
  {
    id: '6401030002',
    districtId: '6401030',
    name: 'Bekoso',
  },
  {
    id: '6401030003',
    districtId: '6401030',
    name: 'Damit',
  },
  {
    id: '6401030004',
    districtId: '6401030',
    name: 'Sangkuriman',
  },
  {
    id: '6401030005',
    districtId: '6401030',
    name: 'Suatang',
  },
  {
    id: '6401030006',
    districtId: '6401030',
    name: 'Keresik Bura',
  },
  {
    id: '6401030007',
    districtId: '6401030',
    name: 'Pasir Belengkong',
  },
  {
    id: '6401030008',
    districtId: '6401030',
    name: 'Seniung Jaya',
  },
  {
    id: '6401030009',
    districtId: '6401030',
    name: 'Suliliran Baru',
  },
  {
    id: '6401030010',
    districtId: '6401030',
    name: 'Suliliran',
  },
  {
    id: '6401030011',
    districtId: '6401030',
    name: 'Laburan Baru',
  },
  {
    id: '6401030012',
    districtId: '6401030',
    name: 'Laburan',
  },
  {
    id: '6401030013',
    districtId: '6401030',
    name: 'Olong Pinang',
  },
  {
    id: '6401030014',
    districtId: '6401030',
    name: 'Sunge Batu',
  },
  {
    id: '6401030015',
    districtId: '6401030',
    name: 'Suatang Keteban',
  },
  {
    id: '6401040001',
    districtId: '6401040',
    name: 'Janju',
  },
  {
    id: '6401040002',
    districtId: '6401040',
    name: 'Sempulang',
  },
  {
    id: '6401040003',
    districtId: '6401040',
    name: 'Tepian Batang',
  },
  {
    id: '6401040004',
    districtId: '6401040',
    name: 'Tanah Grogot',
  },
  {
    id: '6401040005',
    districtId: '6401040',
    name: 'Tanah Periuk',
  },
  {
    id: '6401040006',
    districtId: '6401040',
    name: 'Pepara',
  },
  {
    id: '6401040007',
    districtId: '6401040',
    name: 'Sungai Tuak',
  },
  {
    id: '6401040008',
    districtId: '6401040',
    name: 'Rantau Panjang',
  },
  {
    id: '6401040009',
    districtId: '6401040',
    name: 'Jone',
  },
  {
    id: '6401040010',
    districtId: '6401040',
    name: 'Padang Pengrapat',
  },
  {
    id: '6401040011',
    districtId: '6401040',
    name: 'Muara Pasir',
  },
  {
    id: '6401040012',
    districtId: '6401040',
    name: 'Prepat',
  },
  {
    id: '6401040013',
    districtId: '6401040',
    name: 'Pulau Rantau',
  },
  {
    id: '6401040014',
    districtId: '6401040',
    name: 'Sungai Langir',
  },
  {
    id: '6401040015',
    districtId: '6401040',
    name: 'Tapis',
  },
  {
    id: '6401040016',
    districtId: '6401040',
    name: 'Senaken',
  },
  {
    id: '6401050001',
    districtId: '6401050',
    name: 'Lolo',
  },
  {
    id: '6401050002',
    districtId: '6401050',
    name: 'Kuaro',
  },
  {
    id: '6401050003',
    districtId: '6401050',
    name: 'Pondong Baru',
  },
  {
    id: '6401050004',
    districtId: '6401050',
    name: 'Rangan',
  },
  {
    id: '6401050005',
    districtId: '6401050',
    name: 'Modang',
  },
  {
    id: '6401050006',
    districtId: '6401050',
    name: 'Pasir Mayang',
  },
  {
    id: '6401050007',
    districtId: '6401050',
    name: 'Sandeley',
  },
  {
    id: '6401050008',
    districtId: '6401050',
    name: 'Kerta Bumi',
  },
  {
    id: '6401050009',
    districtId: '6401050',
    name: 'Padang Jaya',
  },
  {
    id: '6401050010',
    districtId: '6401050',
    name: 'Harapan Baru',
  },
  {
    id: '6401050011',
    districtId: '6401050',
    name: 'Kendarom',
  },
  {
    id: '6401050012',
    districtId: '6401050',
    name: 'Klempang Sari',
  },
  {
    id: '6401050013',
    districtId: '6401050',
    name: 'Keluang Paser Jaya',
  },
  {
    id: '6401060001',
    districtId: '6401060',
    name: 'Samuntai',
  },
  {
    id: '6401060002',
    districtId: '6401060',
    name: 'Lombok',
  },
  {
    id: '6401060003',
    districtId: '6401060',
    name: 'Sawit Jaya',
  },
  {
    id: '6401060004',
    districtId: '6401060',
    name: 'Pait',
  },
  {
    id: '6401060005',
    districtId: '6401060',
    name: 'Tajur',
  },
  {
    id: '6401060006',
    districtId: '6401060',
    name: 'Muara Adang',
  },
  {
    id: '6401060007',
    districtId: '6401060',
    name: 'Teluk Waru',
  },
  {
    id: '6401060008',
    districtId: '6401060',
    name: 'Bukit Seloka',
  },
  {
    id: '6401060009',
    districtId: '6401060',
    name: 'Krayan Makmur',
  },
  {
    id: '6401060010',
    districtId: '6401060',
    name: 'Krayan Sentosa',
  },
  {
    id: '6401060011',
    districtId: '6401060',
    name: 'Krayan Jaya',
  },
  {
    id: '6401060012',
    districtId: '6401060',
    name: 'Jemparing',
  },
  {
    id: '6401060013',
    districtId: '6401060',
    name: 'Kayungo',
  },
  {
    id: '6401060014',
    districtId: '6401060',
    name: 'Krayan Bahagia',
  },
  {
    id: '6401060015',
    districtId: '6401060',
    name: 'Long Ikis',
  },
  {
    id: '6401060016',
    districtId: '6401060',
    name: 'Olung',
  },
  {
    id: '6401060017',
    districtId: '6401060',
    name: 'Kayungo Sari',
  },
  {
    id: '6401060018',
    districtId: '6401060',
    name: 'Kerta Bhakti',
  },
  {
    id: '6401060019',
    districtId: '6401060',
    name: 'Sekurou Jaya',
  },
  {
    id: '6401060020',
    districtId: '6401060',
    name: 'Long Gelang',
  },
  {
    id: '6401060021',
    districtId: '6401060',
    name: 'Tiwei',
  },
  {
    id: '6401060022',
    districtId: '6401060',
    name: 'Belimbing',
  },
  {
    id: '6401060023',
    districtId: '6401060',
    name: 'Adang Jaya',
  },
  {
    id: '6401060024',
    districtId: '6401060',
    name: 'Tajer Mulya',
  },
  {
    id: '6401060026',
    districtId: '6401060',
    name: 'Atang Pait',
  },
  {
    id: '6401070001',
    districtId: '6401070',
    name: 'Muara Langon',
  },
  {
    id: '6401070002',
    districtId: '6401070',
    name: 'Muara Komam',
  },
  {
    id: '6401070003',
    districtId: '6401070',
    name: 'Batu Butok',
  },
  {
    id: '6401070004',
    districtId: '6401070',
    name: 'Uko',
  },
  {
    id: '6401070005',
    districtId: '6401070',
    name: 'Muara Kuaro',
  },
  {
    id: '6401070006',
    districtId: '6401070',
    name: 'Prayon',
  },
  {
    id: '6401070007',
    districtId: '6401070',
    name: 'Binangon',
  },
  {
    id: '6401070008',
    districtId: '6401070',
    name: 'Lusan',
  },
  {
    id: '6401070009',
    districtId: '6401070',
    name: 'Muara Payang',
  },
  {
    id: '6401070010',
    districtId: '6401070',
    name: 'Long Sayo',
  },
  {
    id: '6401070011',
    districtId: '6401070',
    name: 'Swan Slutung',
  },
  {
    id: '6401070012',
    districtId: '6401070',
    name: 'Sekuan Makmur',
  },
  {
    id: '6401070013',
    districtId: '6401070',
    name: 'Selerong',
  },
  {
    id: '6401080001',
    districtId: '6401080',
    name: 'Muara Telake',
  },
  {
    id: '6401080002',
    districtId: '6401080',
    name: 'Sebakung',
  },
  {
    id: '6401080003',
    districtId: '6401080',
    name: 'Sebakung Taka',
  },
  {
    id: '6401080004',
    districtId: '6401080',
    name: 'Sebakung Makmur',
  },
  {
    id: '6401080005',
    districtId: '6401080',
    name: 'Muara Adang II',
  },
  {
    id: '6401080006',
    districtId: '6401080',
    name: 'Long Kali',
  },
  {
    id: '6401080007',
    districtId: '6401080',
    name: 'Bente/Tualan',
  },
  {
    id: '6401080008',
    districtId: '6401080',
    name: 'Mendik',
  },
  {
    id: '6401080009',
    districtId: '6401080',
    name: 'Mendik Makmur',
  },
  {
    id: '6401080010',
    districtId: '6401080',
    name: 'Mendik Bhakti',
  },
  {
    id: '6401080011',
    districtId: '6401080',
    name: 'Mendik Karya',
  },
  {
    id: '6401080013',
    districtId: '6401080',
    name: 'Muara Pias',
  },
  {
    id: '6401080014',
    districtId: '6401080',
    name: 'Muara Toyu',
  },
  {
    id: '6401080015',
    districtId: '6401080',
    name: 'Perkuwin',
  },
  {
    id: '6401080016',
    districtId: '6401080',
    name: 'Pinang Jatus',
  },
  {
    id: '6401080017',
    districtId: '6401080',
    name: 'Muara Lambakan',
  },
  {
    id: '6401080018',
    districtId: '6401080',
    name: 'Kepala Telake',
  },
  {
    id: '6401080019',
    districtId: '6401080',
    name: 'Maruat',
  },
  {
    id: '6401080020',
    districtId: '6401080',
    name: 'Petiku',
  },
  {
    id: '6401080021',
    districtId: '6401080',
    name: 'Makmur Jaya',
  },
  {
    id: '6401080022',
    districtId: '6401080',
    name: 'Putang',
  },
  {
    id: '6401080023',
    districtId: '6401080',
    name: 'Gunung Putar',
  },
  {
    id: '6402010002',
    districtId: '6402010',
    name: 'Tanjung Soke',
  },
  {
    id: '6402010003',
    districtId: '6402010',
    name: 'Pereng Talik',
  },
  {
    id: '6402010004',
    districtId: '6402010',
    name: 'Deraya',
  },
  {
    id: '6402010006',
    districtId: '6402010',
    name: 'Muara Siram',
  },
  {
    id: '6402010007',
    districtId: '6402010',
    name: 'Siram Makmur',
  },
  {
    id: '6402010008',
    districtId: '6402010',
    name: 'Siram Jaya',
  },
  {
    id: '6402010009',
    districtId: '6402010',
    name: 'Resak',
  },
  {
    id: '6402010010',
    districtId: '6402010',
    name: 'Tanjung Sari',
  },
  {
    id: '6402010011',
    districtId: '6402010',
    name: 'Jambuk Makmur',
  },
  {
    id: '6402010012',
    districtId: '6402010',
    name: 'Bukit Harapan',
  },
  {
    id: '6402010013',
    districtId: '6402010',
    name: 'Jambuk',
  },
  {
    id: '6402010014',
    districtId: '6402010',
    name: 'Muara Gusik',
  },
  {
    id: '6402010015',
    districtId: '6402010',
    name: 'Penawai',
  },
  {
    id: '6402010016',
    districtId: '6402010',
    name: 'Muara Kedang',
  },
  {
    id: '6402020001',
    districtId: '6402020',
    name: 'Pentat',
  },
  {
    id: '6402020002',
    districtId: '6402020',
    name: 'Bekokong Makmur',
  },
  {
    id: '6402020003',
    districtId: '6402020',
    name: 'Pulai Lanting',
  },
  {
    id: '6402020004',
    districtId: '6402020',
    name: 'Tanjung Jan',
  },
  {
    id: '6402020005',
    districtId: '6402020',
    name: 'Tanjung Isuy',
  },
  {
    id: '6402020006',
    districtId: '6402020',
    name: 'Muara Nayan',
  },
  {
    id: '6402020007',
    districtId: '6402020',
    name: 'Lembonah',
  },
  {
    id: '6402020008',
    districtId: '6402020',
    name: 'Mancong',
  },
  {
    id: '6402020009',
    districtId: '6402020',
    name: 'Perigiq',
  },
  {
    id: '6402020010',
    districtId: '6402020',
    name: 'Tanjung Jone',
  },
  {
    id: '6402020011',
    districtId: '6402020',
    name: 'Muara Ohong',
  },
  {
    id: '6402020012',
    districtId: '6402020',
    name: 'Muara Tae',
  },
  {
    id: '6402030001',
    districtId: '6402030',
    name: 'Loa Deras',
  },
  {
    id: '6402030002',
    districtId: '6402030',
    name: 'Minta',
  },
  {
    id: '6402030003',
    districtId: '6402030',
    name: 'Penyinggahan Ilir',
  },
  {
    id: '6402030004',
    districtId: '6402030',
    name: 'Tanjung Haur',
  },
  {
    id: '6402030005',
    districtId: '6402030',
    name: 'Penyinggahan Ulu',
  },
  {
    id: '6402030006',
    districtId: '6402030',
    name: 'Bakung',
  },
  {
    id: '6402040016',
    districtId: '6402040',
    name: 'Dasaq',
  },
  {
    id: '6402040017',
    districtId: '6402040',
    name: 'Jerang Dayak',
  },
  {
    id: '6402040019',
    districtId: '6402040',
    name: 'Jerang Melayu',
  },
  {
    id: '6402040020',
    districtId: '6402040',
    name: 'Tanjung Laong',
  },
  {
    id: '6402040021',
    districtId: '6402040',
    name: 'Teluk Tempudau',
  },
  {
    id: '6402040022',
    districtId: '6402040',
    name: 'Muara Baroh',
  },
  {
    id: '6402040023',
    districtId: '6402040',
    name: 'Sebelang',
  },
  {
    id: '6402040024',
    districtId: '6402040',
    name: 'Tepian Ulaq',
  },
  {
    id: '6402040025',
    districtId: '6402040',
    name: 'Tanjung Pagar',
  },
  {
    id: '6402040029',
    districtId: '6402040',
    name: 'Gunung Bayan',
  },
  {
    id: '6402040030',
    districtId: '6402040',
    name: 'Muara Beloan',
  },
  {
    id: '6402041001',
    districtId: '6402041',
    name: 'Lendian Liang Nayuk',
  },
  {
    id: '6402041002',
    districtId: '6402041',
    name: 'Kendisiq',
  },
  {
    id: '6402041003',
    districtId: '6402041',
    name: 'Penawang',
  },
  {
    id: '6402041004',
    districtId: '6402041',
    name: 'Rikong',
  },
  {
    id: '6402041005',
    districtId: '6402041',
    name: 'Kiaq',
  },
  {
    id: '6402041006',
    districtId: '6402041',
    name: 'Tendiq',
  },
  {
    id: '6402041007',
    districtId: '6402041',
    name: 'Kenyanyan',
  },
  {
    id: '6402041009',
    districtId: '6402041',
    name: 'Bentas',
  },
  {
    id: '6402041010',
    districtId: '6402041',
    name: 'Muara Kelawit',
  },
  {
    id: '6402041012',
    districtId: '6402041',
    name: 'Sansang',
  },
  {
    id: '6402041013',
    districtId: '6402041',
    name: 'Kaliq',
  },
  {
    id: '6402041014',
    districtId: '6402041',
    name: 'Tana Mea',
  },
  {
    id: '6402041015',
    districtId: '6402041',
    name: 'Tebisaq',
  },
  {
    id: '6402041016',
    districtId: '6402041',
    name: 'Muara Ponaq',
  },
  {
    id: '6402050010',
    districtId: '6402050',
    name: 'Muara Begai',
  },
  {
    id: '6402050011',
    districtId: '6402050',
    name: 'Lotaq',
  },
  {
    id: '6402050012',
    districtId: '6402050',
    name: 'Payang',
  },
  {
    id: '6402050013',
    districtId: '6402050',
    name: 'Cempedas',
  },
  {
    id: '6402050014',
    districtId: '6402050',
    name: 'Dingin',
  },
  {
    id: '6402050015',
    districtId: '6402050',
    name: 'Muara Lawa',
  },
  {
    id: '6402050016',
    districtId: '6402050',
    name: 'Lambing',
  },
  {
    id: '6402050017',
    districtId: '6402050',
    name: 'Benggeris',
  },
  {
    id: '6402051002',
    districtId: '6402051',
    name: 'Randa Empas',
  },
  {
    id: '6402051004',
    districtId: '6402051',
    name: 'Sambung',
  },
  {
    id: '6402051005',
    districtId: '6402051',
    name: 'Jelmu Sibak',
  },
  {
    id: '6402051006',
    districtId: '6402051',
    name: 'Anan Jaya',
  },
  {
    id: '6402051007',
    districtId: '6402051',
    name: 'Suakong',
  },
  {
    id: '6402051008',
    districtId: '6402051',
    name: 'Dilang Puti',
  },
  {
    id: '6402051009',
    districtId: '6402051',
    name: 'Penarung',
  },
  {
    id: '6402060001',
    districtId: '6402060',
    name: 'Besik',
  },
  {
    id: '6402060002',
    districtId: '6402060',
    name: 'Bermai',
  },
  {
    id: '6402060003',
    districtId: '6402060',
    name: 'Muara Nilik',
  },
  {
    id: '6402060004',
    districtId: '6402060',
    name: 'Mantar',
  },
  {
    id: '6402060005',
    districtId: '6402060',
    name: 'Muara Bomboy',
  },
  {
    id: '6402060006',
    districtId: '6402060',
    name: 'Damai Seberang',
  },
  {
    id: '6402060007',
    districtId: '6402060',
    name: 'Mendika',
  },
  {
    id: '6402060008',
    districtId: '6402060',
    name: 'Damai Kota',
  },
  {
    id: '6402060009',
    districtId: '6402060',
    name: 'Lumpat Dahuq',
  },
  {
    id: '6402060010',
    districtId: '6402060',
    name: 'Muara Tokong',
  },
  {
    id: '6402060011',
    districtId: '6402060',
    name: 'Jengan Danum',
  },
  {
    id: '6402060012',
    districtId: '6402060',
    name: 'Keay',
  },
  {
    id: '6402060013',
    districtId: '6402060',
    name: 'Tepulang',
  },
  {
    id: '6402060015',
    districtId: '6402060',
    name: 'Muara Nyahing',
  },
  {
    id: '6402060016',
    districtId: '6402060',
    name: 'Sempatn',
  },
  {
    id: '6402060017',
    districtId: '6402060',
    name: 'Kelian',
  },
  {
    id: '6402061001',
    districtId: '6402061',
    name: 'Dempar',
  },
  {
    id: '6402061002',
    districtId: '6402061',
    name: 'Sentalar',
  },
  {
    id: '6402061003',
    districtId: '6402061',
    name: 'Jontai',
  },
  {
    id: '6402061004',
    districtId: '6402061',
    name: 'Temula',
  },
  {
    id: '6402061005',
    districtId: '6402061',
    name: 'Terajuk',
  },
  {
    id: '6402061006',
    districtId: '6402061',
    name: 'Sembuan',
  },
  {
    id: '6402061007',
    districtId: '6402061',
    name: 'Lakan Bilem',
  },
  {
    id: '6402061008',
    districtId: '6402061',
    name: 'Intu Lingau',
  },
  {
    id: '6402061010',
    districtId: '6402061',
    name: 'Awai',
  },
  {
    id: '6402070001',
    districtId: '6402070',
    name: 'Engkuni Pasek',
  },
  {
    id: '6402070002',
    districtId: '6402070',
    name: 'Mencimai',
  },
  {
    id: '6402070003',
    districtId: '6402070',
    name: 'Rejo Basuki',
  },
  {
    id: '6402070004',
    districtId: '6402070',
    name: 'Sumber Sari',
  },
  {
    id: '6402070005',
    districtId: '6402070',
    name: 'Barong Tongkok',
  },
  {
    id: '6402070006',
    districtId: '6402070',
    name: 'Pepas Eheng',
  },
  {
    id: '6402070008',
    districtId: '6402070',
    name: 'Juhan Asa',
  },
  {
    id: '6402070009',
    districtId: '6402070',
    name: 'Asa',
  },
  {
    id: '6402070010',
    districtId: '6402070',
    name: 'Juaq Asa',
  },
  {
    id: '6402070011',
    districtId: '6402070',
    name: 'Ombau Asa',
  },
  {
    id: '6402070012',
    districtId: '6402070',
    name: 'Ngenyan Asa',
  },
  {
    id: '6402070013',
    districtId: '6402070',
    name: 'Gemuhan Asa',
  },
  {
    id: '6402070014',
    districtId: '6402070',
    name: 'Geleo Baru',
  },
  {
    id: '6402070015',
    districtId: '6402070',
    name: 'Geleo Asa',
  },
  {
    id: '6402070016',
    districtId: '6402070',
    name: 'Ongko Asa',
  },
  {
    id: '6402070017',
    districtId: '6402070',
    name: 'Pepas Asa',
  },
  {
    id: '6402070024',
    districtId: '6402070',
    name: 'Muara Asa',
  },
  {
    id: '6402070025',
    districtId: '6402070',
    name: 'Sendawar',
  },
  {
    id: '6402070026',
    districtId: '6402070',
    name: 'Balok Asa',
  },
  {
    id: '6402070027',
    districtId: '6402070',
    name: 'Simpang Raya',
  },
  {
    id: '6402070028',
    districtId: '6402070',
    name: 'Belempung Ulaq',
  },
  {
    id: '6402071001',
    districtId: '6402071',
    name: 'Melapeh Baru',
  },
  {
    id: '6402071002',
    districtId: '6402071',
    name: 'Bigung Baru',
  },
  {
    id: '6402071003',
    districtId: '6402071',
    name: 'Purwodadi',
  },
  {
    id: '6402071004',
    districtId: '6402071',
    name: 'Linggang Bigung',
  },
  {
    id: '6402071005',
    districtId: '6402071',
    name: 'Bangun Sari',
  },
  {
    id: '6402071006',
    districtId: '6402071',
    name: 'Linggang Amer',
  },
  {
    id: '6402071007',
    districtId: '6402071',
    name: 'Linggang Mapan',
  },
  {
    id: '6402071008',
    districtId: '6402071',
    name: 'Linggang Melapeh',
  },
  {
    id: '6402071010',
    districtId: '6402071',
    name: 'Linggang Kebut',
  },
  {
    id: '6402071011',
    districtId: '6402071',
    name: 'Linggang Mencelew',
  },
  {
    id: '6402080001',
    districtId: '6402080',
    name: 'Empas',
  },
  {
    id: '6402080002',
    districtId: '6402080',
    name: 'Empakuq',
  },
  {
    id: '6402080003',
    districtId: '6402080',
    name: 'Muara Bunyut',
  },
  {
    id: '6402080006',
    districtId: '6402080',
    name: 'Melak Ilir',
  },
  {
    id: '6402080014',
    districtId: '6402080',
    name: 'Melak Ulu',
  },
  {
    id: '6402080020',
    districtId: '6402080',
    name: 'Muara Benangaq',
  },
  {
    id: '6402081001',
    districtId: '6402081',
    name: 'Sumber Rejo',
  },
  {
    id: '6402081002',
    districtId: '6402081',
    name: 'Sekolaq Darat',
  },
  {
    id: '6402081003',
    districtId: '6402081',
    name: 'Sri Mulyo',
  },
  {
    id: '6402081004',
    districtId: '6402081',
    name: 'Sekolaq Joleq',
  },
  {
    id: '6402081005',
    districtId: '6402081',
    name: 'Sumber Bangun',
  },
  {
    id: '6402081006',
    districtId: '6402081',
    name: 'Sekolaq Oday',
  },
  {
    id: '6402081007',
    districtId: '6402081',
    name: 'Sekolaq Muliaq',
  },
  {
    id: '6402082001',
    districtId: '6402082',
    name: 'Gadur',
  },
  {
    id: '6402082002',
    districtId: '6402082',
    name: 'Sakaq Tada',
  },
  {
    id: '6402082004',
    districtId: '6402082',
    name: 'Sakaq Lotoq',
  },
  {
    id: '6402082005',
    districtId: '6402082',
    name: 'Karangan',
  },
  {
    id: '6402082006',
    districtId: '6402082',
    name: 'Kelumpang',
  },
  {
    id: '6402082007',
    districtId: '6402082',
    name: 'Merayaq',
  },
  {
    id: '6402082008',
    districtId: '6402082',
    name: 'Linggang Marimun',
  },
  {
    id: '6402082009',
    districtId: '6402082',
    name: 'Muara Batuq',
  },
  {
    id: '6402082010',
    districtId: '6402082',
    name: 'Gunung Rampah',
  },
  {
    id: '6402082011',
    districtId: '6402082',
    name: 'Rambayan',
  },
  {
    id: '6402082012',
    districtId: '6402082',
    name: 'Muara Jawaq',
  },
  {
    id: '6402082013',
    districtId: '6402082',
    name: 'Abit',
  },
  {
    id: '6402082014',
    districtId: '6402082',
    name: 'Jengan',
  },
  {
    id: '6402082015',
    districtId: '6402082',
    name: 'Muara Kalaq',
  },
  {
    id: '6402082016',
    districtId: '6402082',
    name: 'Tondoh',
  },
  {
    id: '6402090011',
    districtId: '6402090',
    name: 'Anah',
  },
  {
    id: '6402090013',
    districtId: '6402090',
    name: 'Muara Leban',
  },
  {
    id: '6402090014',
    districtId: '6402090',
    name: 'Longiram Seberang',
  },
  {
    id: '6402090015',
    districtId: '6402090',
    name: 'Long Iram Ilir',
  },
  {
    id: '6402090016',
    districtId: '6402090',
    name: 'Long Iram Kota',
  },
  {
    id: '6402090017',
    districtId: '6402090',
    name: 'Long Iram Bayan',
  },
  {
    id: '6402090018',
    districtId: '6402090',
    name: 'Suko Mulyo',
  },
  {
    id: '6402090019',
    districtId: '6402090',
    name: 'Long Daliq',
  },
  {
    id: '6402090020',
    districtId: '6402090',
    name: 'Keliway',
  },
  {
    id: '6402090021',
    districtId: '6402090',
    name: 'Ujoh Halang',
  },
  {
    id: '6402090022',
    districtId: '6402090',
    name: 'Kalian Luar',
  },
  {
    id: '6402091001',
    districtId: '6402091',
    name: 'Purworejo',
  },
  {
    id: '6402091002',
    districtId: '6402091',
    name: 'Kelubaq',
  },
  {
    id: '6402091003',
    districtId: '6402091',
    name: 'Tering Seberang',
  },
  {
    id: '6402091004',
    districtId: '6402091',
    name: 'Tering Lama',
  },
  {
    id: '6402091005',
    districtId: '6402091',
    name: 'Tering Baru',
  },
  {
    id: '6402091009',
    districtId: '6402091',
    name: 'Muara Mujan',
  },
  {
    id: '6402091010',
    districtId: '6402091',
    name: 'Kalian Dalam',
  },
  {
    id: '6402091011',
    districtId: '6402091',
    name: 'Muyup Ilir',
  },
  {
    id: '6402091012',
    districtId: '6402091',
    name: 'Muyut Aket',
  },
  {
    id: '6402091013',
    districtId: '6402091',
    name: 'Gabung Baru',
  },
  {
    id: '6402091014',
    districtId: '6402091',
    name: 'Banjarejo',
  },
  {
    id: '6402091015',
    districtId: '6402091',
    name: 'Tering Lama Ulu',
  },
  {
    id: '6403010001',
    districtId: '6403010',
    name: 'Sei Merdeka',
  },
  {
    id: '6403010002',
    districtId: '6403010',
    name: 'Salok Api Darat',
  },
  {
    id: '6403010003',
    districtId: '6403010',
    name: 'Tani Bakti',
  },
  {
    id: '6403010004',
    districtId: '6403010',
    name: 'Salok Api Laut',
  },
  {
    id: '6403010005',
    districtId: '6403010',
    name: 'Ambarawang Darat',
  },
  {
    id: '6403010006',
    districtId: '6403010',
    name: 'Argosari',
  },
  {
    id: '6403010007',
    districtId: '6403010',
    name: 'Ambarawang Laut',
  },
  {
    id: '6403010008',
    districtId: '6403010',
    name: 'Margomulyo',
  },
  {
    id: '6403010009',
    districtId: '6403010',
    name: 'Karya Jaya',
  },
  {
    id: '6403010010',
    districtId: '6403010',
    name: 'Tanjung Harapan',
  },
  {
    id: '6403010011',
    districtId: '6403010',
    name: 'Wonotirto',
  },
  {
    id: '6403010012',
    districtId: '6403010',
    name: 'Sungai Seluang',
  },
  {
    id: '6403010013',
    districtId: '6403010',
    name: 'Bukit Raya',
  },
  {
    id: '6403010014',
    districtId: '6403010',
    name: 'Beringin Agung',
  },
  {
    id: '6403010015',
    districtId: '6403010',
    name: 'Samboja Kuala',
  },
  {
    id: '6403010016',
    districtId: '6403010',
    name: 'Sanipah',
  },
  {
    id: '6403010017',
    districtId: '6403010',
    name: 'Handil Baru',
  },
  {
    id: '6403010018',
    districtId: '6403010',
    name: 'Muara Sembilang',
  },
  {
    id: '6403010019',
    districtId: '6403010',
    name: 'Bukit Merdeka',
  },
  {
    id: '6403010020',
    districtId: '6403010',
    name: 'Karya Merdeka',
  },
  {
    id: '6403010021',
    districtId: '6403010',
    name: 'Teluk Pemedas',
  },
  {
    id: '6403010022',
    districtId: '6403010',
    name: 'Kampung Lama',
  },
  {
    id: '6403010023',
    districtId: '6403010',
    name: 'Handil Baru Darat',
  },
  {
    id: '6403020001',
    districtId: '6403020',
    name: 'Teluk Dalam',
  },
  {
    id: '6403020002',
    districtId: '6403020',
    name: 'Muara Jawa Ilir',
  },
  {
    id: '6403020003',
    districtId: '6403020',
    name: 'Muara Jawa Tengah',
  },
  {
    id: '6403020004',
    districtId: '6403020',
    name: 'Muara Jawa Ulu',
  },
  {
    id: '6403020005',
    districtId: '6403020',
    name: 'Dondang',
  },
  {
    id: '6403020006',
    districtId: '6403020',
    name: 'Tamapole',
  },
  {
    id: '6403020007',
    districtId: '6403020',
    name: 'Muara Kembang',
  },
  {
    id: '6403020008',
    districtId: '6403020',
    name: 'Muara Jawa Pesisir',
  },
  {
    id: '6403030001',
    districtId: '6403030',
    name: 'Jawa',
  },
  {
    id: '6403030002',
    districtId: '6403030',
    name: 'Sanga Sanga Dalam',
  },
  {
    id: '6403030003',
    districtId: '6403030',
    name: 'Pendingin',
  },
  {
    id: '6403030004',
    districtId: '6403030',
    name: 'Sarijaya',
  },
  {
    id: '6403030005',
    districtId: '6403030',
    name: 'Sanga Sanga Muara',
  },
  {
    id: '6403040001',
    districtId: '6403040',
    name: 'Batuah',
  },
  {
    id: '6403040002',
    districtId: '6403040',
    name: 'Tani Bakti',
  },
  {
    id: '6403040003',
    districtId: '6403040',
    name: 'Purwajaya',
  },
  {
    id: '6403040004',
    districtId: '6403040',
    name: 'Loa Janan Ulu',
  },
  {
    id: '6403040005',
    districtId: '6403040',
    name: 'Loa Duri Ulu',
  },
  {
    id: '6403040006',
    districtId: '6403040',
    name: 'Bakungan',
  },
  {
    id: '6403040007',
    districtId: '6403040',
    name: 'Loa Duri Ilir',
  },
  {
    id: '6403040008',
    districtId: '6403040',
    name: 'Tani Harapan',
  },
  {
    id: '6403050001',
    districtId: '6403050',
    name: 'Jonggon Desa',
  },
  {
    id: '6403050002',
    districtId: '6403050',
    name: 'Sungai Payang',
  },
  {
    id: '6403050003',
    districtId: '6403050',
    name: 'Jembayan',
  },
  {
    id: '6403050004',
    districtId: '6403050',
    name: 'Ponoragan',
  },
  {
    id: '6403050005',
    districtId: '6403050',
    name: 'Loh Sumber',
  },
  {
    id: '6403050006',
    districtId: '6403050',
    name: 'Loa Kulu Kota',
  },
  {
    id: '6403050007',
    districtId: '6403050',
    name: 'Rempanga',
  },
  {
    id: '6403050008',
    districtId: '6403050',
    name: 'Jonggon Jaya',
  },
  {
    id: '6403050009',
    districtId: '6403050',
    name: 'Margahayu',
  },
  {
    id: '6403050010',
    districtId: '6403050',
    name: 'Lung Anai',
  },
  {
    id: '6403050011',
    districtId: '6403050',
    name: 'Jembayan Tengah',
  },
  {
    id: '6403050012',
    districtId: '6403050',
    name: 'Jembayan Dalam',
  },
  {
    id: '6403050013',
    districtId: '6403050',
    name: 'Sepakat',
  },
  {
    id: '6403050014',
    districtId: '6403050',
    name: 'Jongkang',
  },
  {
    id: '6403050015',
    districtId: '6403050',
    name: 'Sumber Sari',
  },
  {
    id: '6403060001',
    districtId: '6403060',
    name: 'Perian',
  },
  {
    id: '6403060002',
    districtId: '6403060',
    name: 'Muara Leka',
  },
  {
    id: '6403060003',
    districtId: '6403060',
    name: 'Muara Aloh',
  },
  {
    id: '6403060004',
    districtId: '6403060',
    name: 'Jantur',
  },
  {
    id: '6403060005',
    districtId: '6403060',
    name: 'Batuq',
  },
  {
    id: '6403060006',
    districtId: '6403060',
    name: 'Rebaq Rinding',
  },
  {
    id: '6403060007',
    districtId: '6403060',
    name: 'Muara Muntai Ulu',
  },
  {
    id: '6403060008',
    districtId: '6403060',
    name: 'Muara Muntai Ilir',
  },
  {
    id: '6403060009',
    districtId: '6403060',
    name: 'Kayu Batu',
  },
  {
    id: '6403060010',
    districtId: '6403060',
    name: 'Jantur Selatan',
  },
  {
    id: '6403060011',
    districtId: '6403060',
    name: 'Tanjung Batuq Harapan',
  },
  {
    id: '6403060012',
    districtId: '6403060',
    name: 'Pulau Harapan',
  },
  {
    id: '6403060013',
    districtId: '6403060',
    name: 'Jantur Baru',
  },
  {
    id: '6403070001',
    districtId: '6403070',
    name: 'Lebak Cilong',
  },
  {
    id: '6403070002',
    districtId: '6403070',
    name: 'Lebak Mantan',
  },
  {
    id: '6403070003',
    districtId: '6403070',
    name: 'Muara Wis',
  },
  {
    id: '6403070004',
    districtId: '6403070',
    name: 'Sebemban',
  },
  {
    id: '6403070005',
    districtId: '6403070',
    name: 'Melintang',
  },
  {
    id: '6403070006',
    districtId: '6403070',
    name: 'Enggelam',
  },
  {
    id: '6403070007',
    districtId: '6403070',
    name: 'Muara Enggelam',
  },
  {
    id: '6403080001',
    districtId: '6403080',
    name: 'Kota Bangun III',
  },
  {
    id: '6403080002',
    districtId: '6403080',
    name: 'Kota Bangun II',
  },
  {
    id: '6403080003',
    districtId: '6403080',
    name: 'Kota Bangun I',
  },
  {
    id: '6403080004',
    districtId: '6403080',
    name: 'Wonosari',
  },
  {
    id: '6403080005',
    districtId: '6403080',
    name: 'Kedang Ipil',
  },
  {
    id: '6403080006',
    districtId: '6403080',
    name: 'Benua Baru',
  },
  {
    id: '6403080007',
    districtId: '6403080',
    name: 'Sedulang',
  },
  {
    id: '6403080008',
    districtId: '6403080',
    name: 'Sukabumi',
  },
  {
    id: '6403080009',
    districtId: '6403080',
    name: 'Sarinadi',
  },
  {
    id: '6403080010',
    districtId: '6403080',
    name: 'Sumber Sari',
  },
  {
    id: '6403080011',
    districtId: '6403080',
    name: 'Kota Bangun Ulu',
  },
  {
    id: '6403080012',
    districtId: '6403080',
    name: 'Loleng',
  },
  {
    id: '6403080013',
    districtId: '6403080',
    name: 'Liang Ilir',
  },
  {
    id: '6403080014',
    districtId: '6403080',
    name: 'Kota Bangun Ilir',
  },
  {
    id: '6403080015',
    districtId: '6403080',
    name: 'Pela',
  },
  {
    id: '6403080016',
    districtId: '6403080',
    name: 'Muhuran',
  },
  {
    id: '6403080017',
    districtId: '6403080',
    name: 'Kota Bangun Seberang',
  },
  {
    id: '6403080018',
    districtId: '6403080',
    name: 'Kedang Murung',
  },
  {
    id: '6403080019',
    districtId: '6403080',
    name: 'Liang Ulu',
  },
  {
    id: '6403080020',
    districtId: '6403080',
    name: 'Sebelimbingan',
  },
  {
    id: '6403080021',
    districtId: '6403080',
    name: 'Sangkuliman',
  },
  {
    id: '6403090001',
    districtId: '6403090',
    name: 'Jahab',
  },
  {
    id: '6403090002',
    districtId: '6403090',
    name: 'Bukit Biru',
  },
  {
    id: '6403090003',
    districtId: '6403090',
    name: 'Timbau',
  },
  {
    id: '6403090004',
    districtId: '6403090',
    name: 'Melayu',
  },
  {
    id: '6403090005',
    districtId: '6403090',
    name: 'Loa Ipuh',
  },
  {
    id: '6403090006',
    districtId: '6403090',
    name: 'Maluhu',
  },
  {
    id: '6403090007',
    districtId: '6403090',
    name: 'Panji',
  },
  {
    id: '6403090008',
    districtId: '6403090',
    name: 'Sukarame',
  },
  {
    id: '6403090009',
    districtId: '6403090',
    name: 'Baru',
  },
  {
    id: '6403090010',
    districtId: '6403090',
    name: 'Mangkurawang',
  },
  {
    id: '6403090011',
    districtId: '6403090',
    name: 'Loa Tebu',
  },
  {
    id: '6403090012',
    districtId: '6403090',
    name: 'Rapak Lambur',
  },
  {
    id: '6403090013',
    districtId: '6403090',
    name: 'Loa Ipuh Darat',
  },
  {
    id: '6403090014',
    districtId: '6403090',
    name: 'Bendang Raya',
  },
  {
    id: '6403100001',
    districtId: '6403100',
    name: 'Selerong',
  },
  {
    id: '6403100002',
    districtId: '6403100',
    name: 'Tanjung Harapan',
  },
  {
    id: '6403100003',
    districtId: '6403100',
    name: 'Beloro',
  },
  {
    id: '6403100005',
    districtId: '6403100',
    name: 'Manunggal Daya',
  },
  {
    id: '6403100006',
    districtId: '6403100',
    name: 'Sumber Sari',
  },
  {
    id: '6403100007',
    districtId: '6403100',
    name: 'Sebulu Ilir',
  },
  {
    id: '6403100008',
    districtId: '6403100',
    name: 'Segihan',
  },
  {
    id: '6403100009',
    districtId: '6403100',
    name: 'Giri Agung',
  },
  {
    id: '6403100010',
    districtId: '6403100',
    name: 'Senoni',
  },
  {
    id: '6403100011',
    districtId: '6403100',
    name: 'Sebulu Modern',
  },
  {
    id: '6403100012',
    districtId: '6403100',
    name: 'Lekaq Kidau',
  },
  {
    id: '6403100013',
    districtId: '6403100',
    name: 'Sanggulan',
  },
  {
    id: '6403100014',
    districtId: '6403100',
    name: 'Mekar Jaya',
  },
  {
    id: '6403110001',
    districtId: '6403110',
    name: 'Loa Lepu',
  },
  {
    id: '6403110002',
    districtId: '6403110',
    name: 'Teluk Dalam',
  },
  {
    id: '6403110003',
    districtId: '6403110',
    name: 'Perjiwa',
  },
  {
    id: '6403110004',
    districtId: '6403110',
    name: 'Loa Raya',
  },
  {
    id: '6403110005',
    districtId: '6403110',
    name: 'Loa Ulung',
  },
  {
    id: '6403110006',
    districtId: '6403110',
    name: 'Embalut',
  },
  {
    id: '6403110007',
    districtId: '6403110',
    name: 'Bukit Raya',
  },
  {
    id: '6403110008',
    districtId: '6403110',
    name: 'Manunggal Jaya',
  },
  {
    id: '6403110009',
    districtId: '6403110',
    name: 'Bangun Rejo',
  },
  {
    id: '6403110010',
    districtId: '6403110',
    name: 'Kerta Buana',
  },
  {
    id: '6403110011',
    districtId: '6403110',
    name: 'Separi',
  },
  {
    id: '6403110012',
    districtId: '6403110',
    name: 'Bukit Pariaman',
  },
  {
    id: '6403110013',
    districtId: '6403110',
    name: 'Buana Jaya',
  },
  {
    id: '6403110014',
    districtId: '6403110',
    name: 'Mulawarman',
  },
  {
    id: '6403110015',
    districtId: '6403110',
    name: 'Loa Pari',
  },
  {
    id: '6403110016',
    districtId: '6403110',
    name: 'Sukamaju',
  },
  {
    id: '6403110017',
    districtId: '6403110',
    name: 'Tanjung Batu',
  },
  {
    id: '6403110018',
    districtId: '6403110',
    name: 'Karang Tunggal',
  },
  {
    id: '6403120001',
    districtId: '6403120',
    name: 'Sepatin',
  },
  {
    id: '6403120002',
    districtId: '6403120',
    name: 'Muara Pantuan',
  },
  {
    id: '6403120003',
    districtId: '6403120',
    name: 'Tani Baru',
  },
  {
    id: '6403120004',
    districtId: '6403120',
    name: 'Kutai Lama',
  },
  {
    id: '6403120005',
    districtId: '6403120',
    name: 'Anggana',
  },
  {
    id: '6403120006',
    districtId: '6403120',
    name: 'Sungai Meriam',
  },
  {
    id: '6403120007',
    districtId: '6403120',
    name: 'Sidomulyo',
  },
  {
    id: '6403120008',
    districtId: '6403120',
    name: 'Handil Terusan',
  },
  {
    id: '6403130001',
    districtId: '6403130',
    name: 'Seliki',
  },
  {
    id: '6403130002',
    districtId: '6403130',
    name: 'Salo Palai',
  },
  {
    id: '6403130003',
    districtId: '6403130',
    name: 'Muara Badak Ulu',
  },
  {
    id: '6403130004',
    districtId: '6403130',
    name: 'Muara Badak Ilir',
  },
  {
    id: '6403130005',
    districtId: '6403130',
    name: 'Tanjung Limau',
  },
  {
    id: '6403130006',
    districtId: '6403130',
    name: 'Tanah Datar',
  },
  {
    id: '6403130007',
    districtId: '6403130',
    name: 'Badak Baru',
  },
  {
    id: '6403130008',
    districtId: '6403130',
    name: 'Suka Damai',
  },
  {
    id: '6403130009',
    districtId: '6403130',
    name: 'Gas Alam Badak Satu',
  },
  {
    id: '6403130010',
    districtId: '6403130',
    name: 'Batu-Batu',
  },
  {
    id: '6403130011',
    districtId: '6403130',
    name: 'Badak Mekar',
  },
  {
    id: '6403130012',
    districtId: '6403130',
    name: 'Salo Cella',
  },
  {
    id: '6403130013',
    districtId: '6403130',
    name: 'Sungai Bawang',
  },
  {
    id: '6403140001',
    districtId: '6403140',
    name: 'Perangat Baru',
  },
  {
    id: '6403140002',
    districtId: '6403140',
    name: 'Bunga Putih',
  },
  {
    id: '6403140003',
    districtId: '6403140',
    name: 'Perangat Selatan',
  },
  {
    id: '6403140004',
    districtId: '6403140',
    name: 'Makarti',
  },
  {
    id: '6403140005',
    districtId: '6403140',
    name: 'Sebuntal',
  },
  {
    id: '6403140006',
    districtId: '6403140',
    name: 'Kersik',
  },
  {
    id: '6403140007',
    districtId: '6403140',
    name: 'Santan Ilir',
  },
  {
    id: '6403140008',
    districtId: '6403140',
    name: 'Santan Tengah',
  },
  {
    id: '6403140009',
    districtId: '6403140',
    name: 'Santan Ulu',
  },
  {
    id: '6403140010',
    districtId: '6403140',
    name: 'Sambera Baru',
  },
  {
    id: '6403140011',
    districtId: '6403140',
    name: 'Semangkok',
  },
  {
    id: '6403150001',
    districtId: '6403150',
    name: 'Benua Puhun',
  },
  {
    id: '6403150002',
    districtId: '6403150',
    name: 'Teratak',
  },
  {
    id: '6403150003',
    districtId: '6403150',
    name: 'Bunga Jadi',
  },
  {
    id: '6403150004',
    districtId: '6403150',
    name: 'Panca Jaya',
  },
  {
    id: '6403150005',
    districtId: '6403150',
    name: 'Sido Mukti',
  },
  {
    id: '6403150006',
    districtId: '6403150',
    name: 'Sabintulung',
  },
  {
    id: '6403150007',
    districtId: '6403150',
    name: 'Rantau Hempang',
  },
  {
    id: '6403150009',
    districtId: '6403150',
    name: 'Muara Kaman Ilir',
  },
  {
    id: '6403150010',
    districtId: '6403150',
    name: 'Muara Kaman Ulu',
  },
  {
    id: '6403150011',
    districtId: '6403150',
    name: 'Tunjungan',
  },
  {
    id: '6403150012',
    districtId: '6403150',
    name: 'Muara Siran',
  },
  {
    id: '6403150013',
    districtId: '6403150',
    name: 'Sedulang',
  },
  {
    id: '6403150014',
    districtId: '6403150',
    name: 'Menamang Kiri',
  },
  {
    id: '6403150015',
    districtId: '6403150',
    name: 'Menamang Kanan',
  },
  {
    id: '6403150016',
    districtId: '6403150',
    name: 'Lebaho Ulaq',
  },
  {
    id: '6403150017',
    districtId: '6403150',
    name: 'Kupang Baru',
  },
  {
    id: '6403150018',
    districtId: '6403150',
    name: 'Puan Cepak',
  },
  {
    id: '6403150019',
    districtId: '6403150',
    name: 'Bukit Jering',
  },
  {
    id: '6403150020',
    districtId: '6403150',
    name: 'Liang Buaya',
  },
  {
    id: '6403150021',
    districtId: '6403150',
    name: 'Cipari Makmur',
  },
  {
    id: '6403160001',
    districtId: '6403160',
    name: 'Semayang',
  },
  {
    id: '6403160002',
    districtId: '6403160',
    name: 'Tubuhan',
  },
  {
    id: '6403160003',
    districtId: '6403160',
    name: 'Teluk Muda',
  },
  {
    id: '6403160004',
    districtId: '6403160',
    name: 'Tuana Tuha',
  },
  {
    id: '6403160005',
    districtId: '6403160',
    name: 'Kahala',
  },
  {
    id: '6403160006',
    districtId: '6403160',
    name: 'Teluk Bingkai',
  },
  {
    id: '6403160007',
    districtId: '6403160',
    name: 'Lamin Pulut',
  },
  {
    id: '6403160008',
    districtId: '6403160',
    name: 'Lamin Telihan',
  },
  {
    id: '6403160009',
    districtId: '6403160',
    name: 'Kahala Ilir',
  },
  {
    id: '6403170001',
    districtId: '6403170',
    name: 'Genting Tanah',
  },
  {
    id: '6403170002',
    districtId: '6403170',
    name: 'Loa Sakoh',
  },
  {
    id: '6403170003',
    districtId: '6403170',
    name: 'Hambau',
  },
  {
    id: '6403170004',
    districtId: '6403170',
    name: 'Kembang Janggut',
  },
  {
    id: '6403170005',
    districtId: '6403170',
    name: 'Kelekat',
  },
  {
    id: '6403170006',
    districtId: '6403170',
    name: 'Pulau Pinang',
  },
  {
    id: '6403170007',
    districtId: '6403170',
    name: 'Long Beleh Haloq',
  },
  {
    id: '6403170008',
    districtId: '6403170',
    name: 'Long Beleh Modang',
  },
  {
    id: '6403170009',
    districtId: '6403170',
    name: 'Bukit Layang',
  },
  {
    id: '6403170010',
    districtId: '6403170',
    name: 'Muai',
  },
  {
    id: '6403170011',
    districtId: '6403170',
    name: 'Perdana',
  },
  {
    id: '6403180001',
    districtId: '6403180',
    name: 'Gunung Sari',
  },
  {
    id: '6403180002',
    districtId: '6403180',
    name: 'Long Lalang',
  },
  {
    id: '6403180003',
    districtId: '6403180',
    name: 'Muara Ritan',
  },
  {
    id: '6403180004',
    districtId: '6403180',
    name: 'Ritan Baru',
  },
  {
    id: '6403180006',
    districtId: '6403180',
    name: 'Umaq Dian',
  },
  {
    id: '6403180007',
    districtId: '6403180',
    name: 'Muara Pedohon',
  },
  {
    id: '6403180008',
    districtId: '6403180',
    name: 'Umaq Tukung',
  },
  {
    id: '6403180009',
    districtId: '6403180',
    name: 'Kampung Baru',
  },
  {
    id: '6403180010',
    districtId: '6403180',
    name: 'Bila Talang',
  },
  {
    id: '6403180011',
    districtId: '6403180',
    name: 'Umaq Bekuai',
  },
  {
    id: '6403180012',
    districtId: '6403180',
    name: 'Sidomulyo',
  },
  {
    id: '6403180013',
    districtId: '6403180',
    name: 'Muara Tiq',
  },
  {
    id: '6403180014',
    districtId: '6403180',
    name: 'Tabang Lama',
  },
  {
    id: '6403180015',
    districtId: '6403180',
    name: 'Muara Salung',
  },
  {
    id: '6403180016',
    districtId: '6403180',
    name: 'Muara Kebaq',
  },
  {
    id: '6403180017',
    districtId: '6403180',
    name: 'Muara Belinau',
  },
  {
    id: '6403180018',
    districtId: '6403180',
    name: 'Muara Tuboq',
  },
  {
    id: '6403180019',
    districtId: '6403180',
    name: 'Tukung Ritan',
  },
  {
    id: '6404010001',
    districtId: '6404010',
    name: 'Senyiur',
  },
  {
    id: '6404010002',
    districtId: '6404010',
    name: 'Kelinjau Ilir',
  },
  {
    id: '6404010003',
    districtId: '6404010',
    name: 'Kelinjau Ulu',
  },
  {
    id: '6404010004',
    districtId: '6404010',
    name: 'Long Nah',
  },
  {
    id: '6404010005',
    districtId: '6404010',
    name: 'Gemar Baru',
  },
  {
    id: '6404010006',
    districtId: '6404010',
    name: 'Long Tesak',
  },
  {
    id: '6404010007',
    districtId: '6404010',
    name: 'Long Poq Baru',
  },
  {
    id: '6404010008',
    districtId: '6404010',
    name: 'Muara Dun',
  },
  {
    id: '6404011001',
    districtId: '6404011',
    name: 'Long Bentuk',
  },
  {
    id: '6404011002',
    districtId: '6404011',
    name: 'Long Pejeng',
  },
  {
    id: '6404011003',
    districtId: '6404011',
    name: 'Mekar Baru',
  },
  {
    id: '6404011004',
    districtId: '6404011',
    name: 'Long Lees',
  },
  {
    id: '6404011005',
    districtId: '6404011',
    name: 'Long Nyelong',
  },
  {
    id: '6404011006',
    districtId: '6404011',
    name: 'Rantau Sentosa',
  },
  {
    id: '6404012001',
    districtId: '6404012',
    name: 'Mukti Utama',
  },
  {
    id: '6404012002',
    districtId: '6404012',
    name: 'Sumber Sari',
  },
  {
    id: '6404012003',
    districtId: '6404012',
    name: 'Segoy Makmur',
  },
  {
    id: '6404012004',
    districtId: '6404012',
    name: 'Sika Makmur',
  },
  {
    id: '6404012005',
    districtId: '6404012',
    name: 'Melan',
  },
  {
    id: '6404012006',
    districtId: '6404012',
    name: 'Tanah Abang',
  },
  {
    id: '6404012007',
    districtId: '6404012',
    name: 'Sumber Agung',
  },
  {
    id: '6404020002',
    districtId: '6404020',
    name: 'Diaq Lay',
  },
  {
    id: '6404020003',
    districtId: '6404020',
    name: 'Dabeq',
  },
  {
    id: '6404020004',
    districtId: '6404020',
    name: 'Jak Luay',
  },
  {
    id: '6404020005',
    districtId: '6404020',
    name: 'Muara Wahau',
  },
  {
    id: '6404020006',
    districtId: '6404020',
    name: 'Nehesliah Bing',
  },
  {
    id: '6404020007',
    districtId: '6404020',
    name: 'Karya Bakti',
  },
  {
    id: '6404020008',
    districtId: '6404020',
    name: 'Wahau Baru',
  },
  {
    id: '6404020009',
    districtId: '6404020',
    name: 'Wana Sari',
  },
  {
    id: '6404020010',
    districtId: '6404020',
    name: 'Long Wehea',
  },
  {
    id: '6404021001',
    districtId: '6404021',
    name: 'Long Noran',
  },
  {
    id: '6404021002',
    districtId: '6404021',
    name: 'Long Segar',
  },
  {
    id: '6404021003',
    districtId: '6404021',
    name: 'Juk Ayak',
  },
  {
    id: '6404021004',
    districtId: '6404021',
    name: 'Marah Haloq',
  },
  {
    id: '6404021005',
    districtId: '6404021',
    name: 'Lung Melah',
  },
  {
    id: '6404021006',
    districtId: '6404021',
    name: 'Muara Pantun',
  },
  {
    id: '6404021007',
    districtId: '6404021',
    name: 'Rantau Panjang',
  },
  {
    id: '6404022001',
    districtId: '6404022',
    name: 'Sidomulyo',
  },
  {
    id: '6404022002',
    districtId: '6404022',
    name: 'Sri Pantun',
  },
  {
    id: '6404022003',
    districtId: '6404022',
    name: 'Kongbeng Indah',
  },
  {
    id: '6404022004',
    districtId: '6404022',
    name: 'Suka Maju',
  },
  {
    id: '6404022005',
    districtId: '6404022',
    name: 'Marga Mulia',
  },
  {
    id: '6404022006',
    districtId: '6404022',
    name: 'Makmur Jaya',
  },
  {
    id: '6404022007',
    districtId: '6404022',
    name: 'Miau Baru',
  },
  {
    id: '6404030001',
    districtId: '6404030',
    name: 'Senambah',
  },
  {
    id: '6404030002',
    districtId: '6404030',
    name: 'Ngayau',
  },
  {
    id: '6404030003',
    districtId: '6404030',
    name: 'Muara Bengkal Ilir',
  },
  {
    id: '6404030004',
    districtId: '6404030',
    name: 'Muara Bengkal Ulu',
  },
  {
    id: '6404030005',
    districtId: '6404030',
    name: 'Benua Baru',
  },
  {
    id: '6404030006',
    districtId: '6404030',
    name: 'Batu Balai',
  },
  {
    id: '6404030007',
    districtId: '6404030',
    name: 'Mulupan',
  },
  {
    id: '6404031001',
    districtId: '6404031',
    name: 'Beno Harapan',
  },
  {
    id: '6404031002',
    districtId: '6404031',
    name: 'Mugi Rahayu',
  },
  {
    id: '6404031003',
    districtId: '6404031',
    name: 'Mawai Indah',
  },
  {
    id: '6404031004',
    districtId: '6404031',
    name: 'Himba Lestari',
  },
  {
    id: '6404031005',
    districtId: '6404031',
    name: 'Batu Timbau',
  },
  {
    id: '6404031006',
    districtId: '6404031',
    name: 'Telaga',
  },
  {
    id: '6404040012',
    districtId: '6404040',
    name: 'Sangatta Utara',
  },
  {
    id: '6404040016',
    districtId: '6404040',
    name: 'Teluk Lingga',
  },
  {
    id: '6404040017',
    districtId: '6404040',
    name: 'Singa Gembara',
  },
  {
    id: '6404040018',
    districtId: '6404040',
    name: 'Swarga Bara',
  },
  {
    id: '6404041001',
    districtId: '6404041',
    name: 'Sepaso',
  },
  {
    id: '6404041002',
    districtId: '6404041',
    name: 'Tepian Langsat',
  },
  {
    id: '6404041003',
    districtId: '6404041',
    name: 'Tebangan Lembak',
  },
  {
    id: '6404041004',
    districtId: '6404041',
    name: 'Keraitan',
  },
  {
    id: '6404041005',
    districtId: '6404041',
    name: 'Sekerat',
  },
  {
    id: '6404041006',
    districtId: '6404041',
    name: 'Muara Bengalon',
  },
  {
    id: '6404041007',
    districtId: '6404041',
    name: 'Sepaso Timur',
  },
  {
    id: '6404041008',
    districtId: '6404041',
    name: 'Sepaso Selatan',
  },
  {
    id: '6404041009',
    districtId: '6404041',
    name: 'Tepian Baru',
  },
  {
    id: '6404041010',
    districtId: '6404041',
    name: 'Tepian Indah',
  },
  {
    id: '6404041011',
    districtId: '6404041',
    name: 'Sepaso Barat',
  },
  {
    id: '6404042001',
    districtId: '6404042',
    name: 'Teluk Pandan',
  },
  {
    id: '6404042002',
    districtId: '6404042',
    name: 'Suka Damai',
  },
  {
    id: '6404042003',
    districtId: '6404042',
    name: 'Suka Rahmat',
  },
  {
    id: '6404042004',
    districtId: '6404042',
    name: 'Danau Redan',
  },
  {
    id: '6404042005',
    districtId: '6404042',
    name: 'Martadinata',
  },
  {
    id: '6404042006',
    districtId: '6404042',
    name: 'Kandolo',
  },
  {
    id: '6404043001',
    districtId: '6404043',
    name: 'Sangkima',
  },
  {
    id: '6404043002',
    districtId: '6404043',
    name: 'Sangatta Selatan',
  },
  {
    id: '6404043003',
    districtId: '6404043',
    name: 'Singa Geweh',
  },
  {
    id: '6404043004',
    districtId: '6404043',
    name: 'Teluk Singkama',
  },
  {
    id: '6404044001',
    districtId: '6404044',
    name: 'Rantau Makmur',
  },
  {
    id: '6404044002',
    districtId: '6404044',
    name: 'Mukti Jaya',
  },
  {
    id: '6404044003',
    districtId: '6404044',
    name: 'Tanjung Labu',
  },
  {
    id: '6404044004',
    districtId: '6404044',
    name: 'Kebon Agung',
  },
  {
    id: '6404044005',
    districtId: '6404044',
    name: 'Manunggal Jaya',
  },
  {
    id: '6404044006',
    districtId: '6404044',
    name: 'Tepian Makmur',
  },
  {
    id: '6404044007',
    districtId: '6404044',
    name: 'Pulung Sari',
  },
  {
    id: '6404044008',
    districtId: '6404044',
    name: 'Margo Mulyo',
  },
  {
    id: '6404050001',
    districtId: '6404050',
    name: 'Kerayaan',
  },
  {
    id: '6404050002',
    districtId: '6404050',
    name: 'Benua Baru Ilir',
  },
  {
    id: '6404050003',
    districtId: '6404050',
    name: 'Sempayau',
  },
  {
    id: '6404050004',
    districtId: '6404050',
    name: 'Tepian Terap',
  },
  {
    id: '6404050005',
    districtId: '6404050',
    name: 'Pelawan',
  },
  {
    id: '6404050006',
    districtId: '6404050',
    name: 'Mandu Dalam',
  },
  {
    id: '6404050007',
    districtId: '6404050',
    name: 'Saka',
  },
  {
    id: '6404050008',
    districtId: '6404050',
    name: 'Peridan',
  },
  {
    id: '6404050009',
    districtId: '6404050',
    name: 'Tanjung Manis',
  },
  {
    id: '6404050010',
    districtId: '6404050',
    name: 'Maloy',
  },
  {
    id: '6404050011',
    districtId: '6404050',
    name: 'Benua Baru Ulu',
  },
  {
    id: '6404050012',
    districtId: '6404050',
    name: 'Kolek',
  },
  {
    id: '6404050013',
    districtId: '6404050',
    name: 'Pulau Miang',
  },
  {
    id: '6404050015',
    districtId: '6404050',
    name: 'Mandu Pantai Sejahtera',
  },
  {
    id: '6404051001',
    districtId: '6404051',
    name: 'Kaliorang',
  },
  {
    id: '6404051002',
    districtId: '6404051',
    name: 'Bukit Harapan',
  },
  {
    id: '6404051003',
    districtId: '6404051',
    name: 'Bukit Makmur',
  },
  {
    id: '6404051004',
    districtId: '6404051',
    name: 'Bangun Jaya',
  },
  {
    id: '6404051005',
    districtId: '6404051',
    name: 'Citra Manunggal Jaya',
  },
  {
    id: '6404051006',
    districtId: '6404051',
    name: 'Bumi Sejahtera',
  },
  {
    id: '6404051007',
    districtId: '6404051',
    name: 'Selangkau',
  },
  {
    id: '6404052001',
    districtId: '6404052',
    name: 'Susuk Luar',
  },
  {
    id: '6404052002',
    districtId: '6404052',
    name: 'Susuk Dalam',
  },
  {
    id: '6404052003',
    districtId: '6404052',
    name: 'Marukangan',
  },
  {
    id: '6404052004',
    districtId: '6404052',
    name: 'Manubar',
  },
  {
    id: '6404052005',
    districtId: '6404052',
    name: 'Tadoan',
  },
  {
    id: '6404052006',
    districtId: '6404052',
    name: 'Sandaran',
  },
  {
    id: '6404052007',
    districtId: '6404052',
    name: 'Tanjung Mangkalihat',
  },
  {
    id: '6404053001',
    districtId: '6404053',
    name: 'Cipta Graha',
  },
  {
    id: '6404053002',
    districtId: '6404053',
    name: 'Bumi Jaya',
  },
  {
    id: '6404053003',
    districtId: '6404053',
    name: 'Bumi Rapak',
  },
  {
    id: '6404053004',
    districtId: '6404053',
    name: 'Bumi Etam',
  },
  {
    id: '6404053005',
    districtId: '6404053',
    name: 'Mata Air',
  },
  {
    id: '6404053006',
    districtId: '6404053',
    name: 'Bukit Permata',
  },
  {
    id: '6404053007',
    districtId: '6404053',
    name: 'Kadungan Jaya',
  },
  {
    id: '6404053008',
    districtId: '6404053',
    name: 'Pengadan Baru',
  },
  {
    id: '6404054001',
    districtId: '6404054',
    name: 'Pengadan',
  },
  {
    id: '6404054002',
    districtId: '6404054',
    name: 'Baay',
  },
  {
    id: '6404054003',
    districtId: '6404054',
    name: 'Karangan Dalam',
  },
  {
    id: '6404054004',
    districtId: '6404054',
    name: 'Batu Lepoq',
  },
  {
    id: '6404054005',
    districtId: '6404054',
    name: 'Mukti Lestari',
  },
  {
    id: '6404054006',
    districtId: '6404054',
    name: 'Karangan Hilir',
  },
  {
    id: '6404054007',
    districtId: '6404054',
    name: 'Karangan Seberang',
  },
  {
    id: '6405010001',
    districtId: '6405010',
    name: 'Merapun',
  },
  {
    id: '6405010002',
    districtId: '6405010',
    name: 'Merabu',
  },
  {
    id: '6405010003',
    districtId: '6405010',
    name: 'Mapulu',
  },
  {
    id: '6405010004',
    districtId: '6405010',
    name: 'Panaan',
  },
  {
    id: '6405010005',
    districtId: '6405010',
    name: 'Merasa',
  },
  {
    id: '6405010006',
    districtId: '6405010',
    name: 'Muara Lesan',
  },
  {
    id: '6405010007',
    districtId: '6405010',
    name: 'Lesan Dayak',
  },
  {
    id: '6405010008',
    districtId: '6405010',
    name: 'Sido Bangen',
  },
  {
    id: '6405010009',
    districtId: '6405010',
    name: 'Long Beliu',
  },
  {
    id: '6405010010',
    districtId: '6405010',
    name: 'Long Duhung',
  },
  {
    id: '6405010011',
    districtId: '6405010',
    name: 'Long Keluh',
  },
  {
    id: '6405010012',
    districtId: '6405010',
    name: 'Long Pelay',
  },
  {
    id: '6405010013',
    districtId: '6405010',
    name: 'Long Lamcin',
  },
  {
    id: '6405010014',
    districtId: '6405010',
    name: 'Long Sului',
  },
  {
    id: '6405020003',
    districtId: '6405020',
    name: 'Campur Sari',
  },
  {
    id: '6405020004',
    districtId: '6405020',
    name: 'Bumi Jaya',
  },
  {
    id: '6405020006',
    districtId: '6405020',
    name: 'Tunggal Bumi',
  },
  {
    id: '6405020007',
    districtId: '6405020',
    name: 'Dumaring',
  },
  {
    id: '6405020008',
    districtId: '6405020',
    name: 'Suka Murya',
  },
  {
    id: '6405020009',
    districtId: '6405020',
    name: 'Purna Sari Jaya',
  },
  {
    id: '6405020010',
    districtId: '6405020',
    name: 'Sumber Mulia',
  },
  {
    id: '6405020011',
    districtId: '6405020',
    name: 'Eka Sapta',
  },
  {
    id: '6405020012',
    districtId: '6405020',
    name: 'Talisayan',
  },
  {
    id: '6405020013',
    districtId: '6405020',
    name: 'Capuak',
  },
  {
    id: '6405021004',
    districtId: '6405021',
    name: 'Tabalar Muara',
  },
  {
    id: '6405021005',
    districtId: '6405021',
    name: 'Harapan Maju',
  },
  {
    id: '6405021006',
    districtId: '6405021',
    name: 'Tabalar Ulu',
  },
  {
    id: '6405021007',
    districtId: '6405021',
    name: 'Tubaan',
  },
  {
    id: '6405021009',
    districtId: '6405021',
    name: 'Radak/Buyung-Buyung',
  },
  {
    id: '6405030001',
    districtId: '6405030',
    name: 'Teluk Sumbang',
  },
  {
    id: '6405030002',
    districtId: '6405030',
    name: 'Biduk-Biduk',
  },
  {
    id: '6405030003',
    districtId: '6405030',
    name: 'Pantai Harapan',
  },
  {
    id: '6405030004',
    districtId: '6405030',
    name: 'Tanjung Perepat',
  },
  {
    id: '6405030005',
    districtId: '6405030',
    name: 'Giring-Giring',
  },
  {
    id: '6405030006',
    districtId: '6405030',
    name: 'Teluk Sulaiman',
  },
  {
    id: '6405040001',
    districtId: '6405040',
    name: 'Pegat',
  },
  {
    id: '6405040002',
    districtId: '6405040',
    name: 'Teluk Semanting',
  },
  {
    id: '6405040003',
    districtId: '6405040',
    name: 'Tanjung Batu',
  },
  {
    id: '6405040004',
    districtId: '6405040',
    name: 'Pulau Derawan',
  },
  {
    id: '6405040005',
    districtId: '6405040',
    name: 'Kasai',
  },
  {
    id: '6405041001',
    districtId: '6405041',
    name: 'Maratua Payung-Payung',
  },
  {
    id: '6405041002',
    districtId: '6405041',
    name: 'Maratua Bohesilian',
  },
  {
    id: '6405041003',
    districtId: '6405041',
    name: 'Maratua Teluk Alulu',
  },
  {
    id: '6405041004',
    districtId: '6405041',
    name: 'Maratua Teluk Harapan',
  },
  {
    id: '6405050001',
    districtId: '6405050',
    name: 'Long Lanuk',
  },
  {
    id: '6405050002',
    districtId: '6405050',
    name: 'Tumbit Dayak',
  },
  {
    id: '6405050004',
    districtId: '6405050',
    name: 'Inaran',
  },
  {
    id: '6405050005',
    districtId: '6405050',
    name: 'Pegat Bukur',
  },
  {
    id: '6405050006',
    districtId: '6405050',
    name: 'Rantau Panjang',
  },
  {
    id: '6405050007',
    districtId: '6405050',
    name: 'Sambaliung',
  },
  {
    id: '6405050008',
    districtId: '6405050',
    name: 'Bebanir',
  },
  {
    id: '6405050009',
    districtId: '6405050',
    name: 'Gurimbang',
  },
  {
    id: '6405050010',
    districtId: '6405050',
    name: 'Tanjung Perangat',
  },
  {
    id: '6405050011',
    districtId: '6405050',
    name: 'Sukan Tengah',
  },
  {
    id: '6405050012',
    districtId: '6405050',
    name: 'Suaran',
  },
  {
    id: '6405050013',
    districtId: '6405050',
    name: 'Pesayan',
  },
  {
    id: '6405050014',
    districtId: '6405050',
    name: 'Pilanjau',
  },
  {
    id: '6405050015',
    districtId: '6405050',
    name: 'Bena Baru',
  },
  {
    id: '6405060003',
    districtId: '6405060',
    name: 'Sungai Bedungun',
  },
  {
    id: '6405060004',
    districtId: '6405060',
    name: 'Tanjung Redeb',
  },
  {
    id: '6405060005',
    districtId: '6405060',
    name: 'Bugis',
  },
  {
    id: '6405060006',
    districtId: '6405060',
    name: 'Gunung Panjang',
  },
  {
    id: '6405060007',
    districtId: '6405060',
    name: 'Karang Ambun',
  },
  {
    id: '6405060008',
    districtId: '6405060',
    name: 'Gayam',
  },
  {
    id: '6405070004',
    districtId: '6405070',
    name: 'Tasuk',
  },
  {
    id: '6405070005',
    districtId: '6405070',
    name: 'Birang',
  },
  {
    id: '6405070006',
    districtId: '6405070',
    name: 'Gunung Tabur',
  },
  {
    id: '6405070007',
    districtId: '6405070',
    name: 'Maluang',
  },
  {
    id: '6405070008',
    districtId: '6405070',
    name: 'Samburakat',
  },
  {
    id: '6405070009',
    districtId: '6405070',
    name: 'Sambakungan',
  },
  {
    id: '6405070010',
    districtId: '6405070',
    name: 'Melati Jaya',
  },
  {
    id: '6405070011',
    districtId: '6405070',
    name: 'Merancang Ulu',
  },
  {
    id: '6405070012',
    districtId: '6405070',
    name: 'Pulau Besing',
  },
  {
    id: '6405070013',
    districtId: '6405070',
    name: 'Merancang Ilir',
  },
  {
    id: '6405070015',
    districtId: '6405070',
    name: 'Batu-Batu',
  },
  {
    id: '6405080001',
    districtId: '6405080',
    name: 'Punan Mahkam',
  },
  {
    id: '6405080002',
    districtId: '6405080',
    name: 'Long Laay',
  },
  {
    id: '6405080003',
    districtId: '6405080',
    name: 'Punan Segah',
  },
  {
    id: '6405080004',
    districtId: '6405080',
    name: 'Long Ayap',
  },
  {
    id: '6405080005',
    districtId: '6405080',
    name: 'Long Ayan',
  },
  {
    id: '6405080006',
    districtId: '6405080',
    name: 'Punan Malinau',
  },
  {
    id: '6405080007',
    districtId: '6405080',
    name: 'Gunung Sari',
  },
  {
    id: '6405080008',
    districtId: '6405080',
    name: 'Harapan Jaya',
  },
  {
    id: '6405080009',
    districtId: '6405080',
    name: 'Bukit Makmur',
  },
  {
    id: '6405080010',
    districtId: '6405080',
    name: 'Pandan Sari',
  },
  {
    id: '6405080011',
    districtId: '6405080',
    name: 'Tepian Buah',
  },
  {
    id: '6405080012',
    districtId: '6405080',
    name: 'Siduung Indah',
  },
  {
    id: '6405080013',
    districtId: '6405080',
    name: 'Batu Rajang',
  },
  {
    id: '6405090001',
    districtId: '6405090',
    name: 'Teluk Bayur',
  },
  {
    id: '6405090002',
    districtId: '6405090',
    name: 'Rinding',
  },
  {
    id: '6405090003',
    districtId: '6405090',
    name: 'Labanan Makarti',
  },
  {
    id: '6405090004',
    districtId: '6405090',
    name: 'Labanan Makmur',
  },
  {
    id: '6405090005',
    districtId: '6405090',
    name: 'Labanan Jaya',
  },
  {
    id: '6405090006',
    districtId: '6405090',
    name: 'Tumbit Melayu',
  },
  {
    id: '6405100001',
    districtId: '6405100',
    name: 'Kayu Indah',
  },
  {
    id: '6405100002',
    districtId: '6405100',
    name: 'Sumber Agung',
  },
  {
    id: '6405100003',
    districtId: '6405100',
    name: 'Tembudan',
  },
  {
    id: '6405100004',
    districtId: '6405100',
    name: 'Batu Putih',
  },
  {
    id: '6405100005',
    districtId: '6405100',
    name: 'Lobang Kelatak',
  },
  {
    id: '6405100006',
    districtId: '6405100',
    name: 'Ampen Medang',
  },
  {
    id: '6405100007',
    districtId: '6405100',
    name: 'Bali Kukup',
  },
  {
    id: '6405110001',
    districtId: '6405110',
    name: 'Biatan Bapinang',
  },
  {
    id: '6405110002',
    districtId: '6405110',
    name: 'Biatan Baru',
  },
  {
    id: '6405110003',
    districtId: '6405110',
    name: 'Bukit Makmur Jaya',
  },
  {
    id: '6405110004',
    districtId: '6405110',
    name: 'Manunggal Jaya',
  },
  {
    id: '6405110005',
    districtId: '6405110',
    name: 'Biatan Lempake',
  },
  {
    id: '6405110006',
    districtId: '6405110',
    name: 'Biatan Ulu',
  },
  {
    id: '6405110007',
    districtId: '6405110',
    name: 'Karangan',
  },
  {
    id: '6405110008',
    districtId: '6405110',
    name: 'Biatan Ilir',
  },
  {
    id: '6409010001',
    districtId: '6409010',
    name: 'Gunung Makmur',
  },
  {
    id: '6409010002',
    districtId: '6409010',
    name: 'Gunung Intan',
  },
  {
    id: '6409010003',
    districtId: '6409010',
    name: 'Sumber Sari',
  },
  {
    id: '6409010004',
    districtId: '6409010',
    name: 'Sri Raharja',
  },
  {
    id: '6409010005',
    districtId: '6409010',
    name: 'Rawa Mulia',
  },
  {
    id: '6409010006',
    districtId: '6409010',
    name: 'Sebakung Jaya',
  },
  {
    id: '6409010007',
    districtId: '6409010',
    name: 'Babulu Laut',
  },
  {
    id: '6409010008',
    districtId: '6409010',
    name: 'Babulu Darat',
  },
  {
    id: '6409010009',
    districtId: '6409010',
    name: 'Labangka',
  },
  {
    id: '6409010010',
    districtId: '6409010',
    name: 'Rintik',
  },
  {
    id: '6409010011',
    districtId: '6409010',
    name: 'Gunung Mulia',
  },
  {
    id: '6409010012',
    districtId: '6409010',
    name: 'Labangka Barat',
  },
  {
    id: '6409020001',
    districtId: '6409020',
    name: 'Api Api',
  },
  {
    id: '6409020003',
    districtId: '6409020',
    name: 'Waru',
  },
  {
    id: '6409020004',
    districtId: '6409020',
    name: 'Bangun Mulya',
  },
  {
    id: '6409030001',
    districtId: '6409030',
    name: 'Tanjung Tengah',
  },
  {
    id: '6409030002',
    districtId: '6409030',
    name: 'Saloloang',
  },
  {
    id: '6409030004',
    districtId: '6409030',
    name: 'Giri Mukti',
  },
  {
    id: '6409030005',
    districtId: '6409030',
    name: 'Lawe Lawe',
  },
  {
    id: '6409030006',
    districtId: '6409030',
    name: 'Pejala',
  },
  {
    id: '6409030007',
    districtId: '6409030',
    name: 'Kampung Baru',
  },
  {
    id: '6409030009',
    districtId: '6409030',
    name: 'Sungai Parit',
  },
  {
    id: '6409030010',
    districtId: '6409030',
    name: 'Nipah Nipah',
  },
  {
    id: '6409030011',
    districtId: '6409030',
    name: 'Nenang',
  },
  {
    id: '6409030013',
    districtId: '6409030',
    name: 'Penajam',
  },
  {
    id: '6409030014',
    districtId: '6409030',
    name: 'Bulu Minung',
  },
  {
    id: '6409030015',
    districtId: '6409030',
    name: 'Sotek',
  },
  {
    id: '6409030016',
    districtId: '6409030',
    name: 'Sepan',
  },
  {
    id: '6409030017',
    districtId: '6409030',
    name: 'Riko',
  },
  {
    id: '6409030018',
    districtId: '6409030',
    name: 'Pantai Lango',
  },
  {
    id: '6409030019',
    districtId: '6409030',
    name: 'Gersik',
  },
  {
    id: '6409030020',
    districtId: '6409030',
    name: 'Jenebora',
  },
  {
    id: '6409030021',
    districtId: '6409030',
    name: 'Bukit Subur',
  },
  {
    id: '6409030022',
    districtId: '6409030',
    name: 'Sidorejo',
  },
  {
    id: '6409030023',
    districtId: '6409030',
    name: 'Giripurwa',
  },
  {
    id: '6409040001',
    districtId: '6409040',
    name: 'Maridan',
  },
  {
    id: '6409040002',
    districtId: '6409040',
    name: 'Mentawir',
  },
  {
    id: '6409040003',
    districtId: '6409040',
    name: 'Pemaluan',
  },
  {
    id: '6409040004',
    districtId: '6409040',
    name: 'Bumi Harapan',
  },
  {
    id: '6409040005',
    districtId: '6409040',
    name: 'Wonosari',
  },
  {
    id: '6409040006',
    districtId: '6409040',
    name: 'Semoi Dua',
  },
  {
    id: '6409040007',
    districtId: '6409040',
    name: 'Argo Mulyo',
  },
  {
    id: '6409040008',
    districtId: '6409040',
    name: 'Suko Mulyo',
  },
  {
    id: '6409040009',
    districtId: '6409040',
    name: 'Tengin Baru',
  },
  {
    id: '6409040010',
    districtId: '6409040',
    name: 'Sukaraja',
  },
  {
    id: '6409040011',
    districtId: '6409040',
    name: 'Bukit Raya',
  },
  {
    id: '6409040012',
    districtId: '6409040',
    name: 'Sepaku',
  },
  {
    id: '6409040013',
    districtId: '6409040',
    name: 'Karang Jinawi',
  },
  {
    id: '6409040014',
    districtId: '6409040',
    name: 'Telemow',
  },
  {
    id: '6409040015',
    districtId: '6409040',
    name: 'Binuang',
  },
  {
    id: '6411010001',
    districtId: '6411010',
    name: 'Nyaribungan',
  },
  {
    id: '6411010002',
    districtId: '6411010',
    name: 'Long Gelawang',
  },
  {
    id: '6411010003',
    districtId: '6411010',
    name: 'Danum Paroi',
  },
  {
    id: '6411010004',
    districtId: '6411010',
    name: 'Muara Ratah',
  },
  {
    id: '6411010005',
    districtId: '6411010',
    name: 'Laham',
  },
  {
    id: '6411020001',
    districtId: '6411020',
    name: 'Lutan',
  },
  {
    id: '6411020002',
    districtId: '6411020',
    name: 'Memahak Teboq',
  },
  {
    id: '6411020003',
    districtId: '6411020',
    name: 'Sirau',
  },
  {
    id: '6411020004',
    districtId: '6411020',
    name: 'Mata Libaq',
  },
  {
    id: '6411020005',
    districtId: '6411020',
    name: 'Datah Bilang Ilir',
  },
  {
    id: '6411020006',
    districtId: '6411020',
    name: 'Datah Bilang Ulu',
  },
  {
    id: '6411020007',
    districtId: '6411020',
    name: 'Datah Bilang Baru',
  },
  {
    id: '6411020008',
    districtId: '6411020',
    name: 'Long Hubung',
  },
  {
    id: '6411020009',
    districtId: '6411020',
    name: 'Wana Pariq',
  },
  {
    id: '6411020010',
    districtId: '6411020',
    name: 'Tri Pariq Makmur',
  },
  {
    id: '6411020011',
    districtId: '6411020',
    name: 'Long Hubung Ulu',
  },
  {
    id: '6411030001',
    districtId: '6411030',
    name: 'Long Hurai',
  },
  {
    id: '6411030002',
    districtId: '6411030',
    name: 'Rukun Damai',
  },
  {
    id: '6411030003',
    districtId: '6411030',
    name: 'Long Merah',
  },
  {
    id: '6411030004',
    districtId: '6411030',
    name: 'Mamahak Ilir',
  },
  {
    id: '6411030005',
    districtId: '6411030',
    name: 'Mamahak Ulu',
  },
  {
    id: '6411030006',
    districtId: '6411030',
    name: 'Long Melaham',
  },
  {
    id: '6411030007',
    districtId: '6411030',
    name: 'Ujoh Bilang',
  },
  {
    id: '6411030008',
    districtId: '6411030',
    name: 'Batu Majang',
  },
  {
    id: '6411030009',
    districtId: '6411030',
    name: 'Batoq Kelo',
  },
  {
    id: '6411030010',
    districtId: '6411030',
    name: 'Long Bagun Ulu',
  },
  {
    id: '6411030011',
    districtId: '6411030',
    name: 'Long Bagun Ilir',
  },
  {
    id: '6411040001',
    districtId: '6411040',
    name: 'Delang Kerohong',
  },
  {
    id: '6411040002',
    districtId: '6411040',
    name: 'Long Lunuk Baru',
  },
  {
    id: '6411040003',
    districtId: '6411040',
    name: 'Long Lunuk',
  },
  {
    id: '6411040004',
    districtId: '6411040',
    name: 'Naha Aruq',
  },
  {
    id: '6411040005',
    districtId: '6411040',
    name: 'Long Pahangai Dua',
  },
  {
    id: '6411040006',
    districtId: '6411040',
    name: 'Long Tuyoq',
  },
  {
    id: '6411040007',
    districtId: '6411040',
    name: 'Liu Mulang',
  },
  {
    id: '6411040008',
    districtId: '6411040',
    name: 'Long Pahangai Satu',
  },
  {
    id: '6411040009',
    districtId: '6411040',
    name: 'Datah Naha',
  },
  {
    id: '6411040010',
    districtId: '6411040',
    name: 'Long Isun',
  },
  {
    id: '6411040011',
    districtId: '6411040',
    name: 'Lirung Ubing',
  },
  {
    id: '6411040012',
    districtId: '6411040',
    name: 'Long Pakaq',
  },
  {
    id: '6411040013',
    districtId: '6411040',
    name: 'Long Pakaq Baru',
  },
  {
    id: '6411050001',
    districtId: '6411050',
    name: 'Naha Tifab',
  },
  {
    id: '6411050002',
    districtId: '6411050',
    name: 'Noha Silat',
  },
  {
    id: '6411050003',
    districtId: '6411050',
    name: 'Long Penaneh Dua',
  },
  {
    id: '6411050004',
    districtId: '6411050',
    name: 'Tiong Ohang',
  },
  {
    id: '6411050005',
    districtId: '6411050',
    name: 'Naha Buan',
  },
  {
    id: '6411050006',
    districtId: '6411050',
    name: "Tiong Bu'U",
  },
  {
    id: '6411050007',
    districtId: '6411050',
    name: 'Long Penaneh Satu',
  },
  {
    id: '6411050008',
    districtId: '6411050',
    name: 'Long Penaneh Tiga',
  },
  {
    id: '6411050009',
    districtId: '6411050',
    name: 'Long Keriok',
  },
  {
    id: '6411050010',
    districtId: '6411050',
    name: 'Long Apari',
  },
  {
    id: '6471010006',
    districtId: '6471010',
    name: 'Gunung Bahagia',
  },
  {
    id: '6471010007',
    districtId: '6471010',
    name: 'Sepinggan',
  },
  {
    id: '6471010008',
    districtId: '6471010',
    name: 'Damai Baru',
  },
  {
    id: '6471010009',
    districtId: '6471010',
    name: 'Damai Bahagia',
  },
  {
    id: '6471010010',
    districtId: '6471010',
    name: 'Sungai Nangka',
  },
  {
    id: '6471010011',
    districtId: '6471010',
    name: 'Sepinggan Raya',
  },
  {
    id: '6471010012',
    districtId: '6471010',
    name: 'Sepinggan Baru',
  },
  {
    id: '6471011001',
    districtId: '6471011',
    name: 'Prapatan',
  },
  {
    id: '6471011002',
    districtId: '6471011',
    name: 'Telaga Sari',
  },
  {
    id: '6471011003',
    districtId: '6471011',
    name: 'Klandasan Ulu',
  },
  {
    id: '6471011004',
    districtId: '6471011',
    name: 'Klandasan Ilir',
  },
  {
    id: '6471011005',
    districtId: '6471011',
    name: 'Damai',
  },
  {
    id: '6471020001',
    districtId: '6471020',
    name: 'Manggar',
  },
  {
    id: '6471020002',
    districtId: '6471020',
    name: 'Manggar Baru',
  },
  {
    id: '6471020003',
    districtId: '6471020',
    name: 'Lemaru',
  },
  {
    id: '6471020004',
    districtId: '6471020',
    name: 'Teritip',
  },
  {
    id: '6471030001',
    districtId: '6471030',
    name: 'Muara Rapak',
  },
  {
    id: '6471030002',
    districtId: '6471030',
    name: 'Gunung Samarinda',
  },
  {
    id: '6471030003',
    districtId: '6471030',
    name: 'Batu Ampar',
  },
  {
    id: '6471030004',
    districtId: '6471030',
    name: 'Karang Joang',
  },
  {
    id: '6471030005',
    districtId: '6471030',
    name: 'Gunung Samarinda Baru',
  },
  {
    id: '6471030006',
    districtId: '6471030',
    name: 'Graha Indah',
  },
  {
    id: '6471040001',
    districtId: '6471040',
    name: 'Gunung Sari Ilir',
  },
  {
    id: '6471040002',
    districtId: '6471040',
    name: 'Gunung Sari Ulu',
  },
  {
    id: '6471040003',
    districtId: '6471040',
    name: 'Mekar Sari',
  },
  {
    id: '6471040004',
    districtId: '6471040',
    name: 'Karang Rejo',
  },
  {
    id: '6471040005',
    districtId: '6471040',
    name: 'Sumber Rejo',
  },
  {
    id: '6471040006',
    districtId: '6471040',
    name: 'Karang Jati',
  },
  {
    id: '6471050001',
    districtId: '6471050',
    name: 'Baru Tengah',
  },
  {
    id: '6471050002',
    districtId: '6471050',
    name: 'Marga Sari',
  },
  {
    id: '6471050003',
    districtId: '6471050',
    name: 'Baru Ilir',
  },
  {
    id: '6471050004',
    districtId: '6471050',
    name: 'Margo Mulyo',
  },
  {
    id: '6471050005',
    districtId: '6471050',
    name: 'Baru Ulu',
  },
  {
    id: '6471050006',
    districtId: '6471050',
    name: 'Kariangau',
  },
  {
    id: '6472010001',
    districtId: '6472010',
    name: 'Simpang Pasir',
  },
  {
    id: '6472010002',
    districtId: '6472010',
    name: 'Handil Bakti',
  },
  {
    id: '6472010003',
    districtId: '6472010',
    name: 'Bantuas',
  },
  {
    id: '6472010004',
    districtId: '6472010',
    name: 'Bukuan',
  },
  {
    id: '6472010005',
    districtId: '6472010',
    name: 'Rawa Makmur',
  },
  {
    id: '6472020006',
    districtId: '6472020',
    name: 'Selili',
  },
  {
    id: '6472020007',
    districtId: '6472020',
    name: 'Sungai Dama',
  },
  {
    id: '6472020008',
    districtId: '6472020',
    name: 'Sidodamai',
  },
  {
    id: '6472020009',
    districtId: '6472020',
    name: 'Sidomulyo',
  },
  {
    id: '6472020014',
    districtId: '6472020',
    name: 'Pelita',
  },
  {
    id: '6472021001',
    districtId: '6472021',
    name: 'Bugis',
  },
  {
    id: '6472021002',
    districtId: '6472021',
    name: 'Pasar Pagi',
  },
  {
    id: '6472021003',
    districtId: '6472021',
    name: 'Pelabuhan',
  },
  {
    id: '6472021004',
    districtId: '6472021',
    name: 'Sungai Pinang Luar',
  },
  {
    id: '6472021005',
    districtId: '6472021',
    name: 'Karang Mumus',
  },
  {
    id: '6472022001',
    districtId: '6472022',
    name: 'Pulau Atas',
  },
  {
    id: '6472022002',
    districtId: '6472022',
    name: 'Sindang Sari',
  },
  {
    id: '6472022003',
    districtId: '6472022',
    name: 'Makroman',
  },
  {
    id: '6472022004',
    districtId: '6472022',
    name: 'Sambutan',
  },
  {
    id: '6472022005',
    districtId: '6472022',
    name: 'Sungai Kapih',
  },
  {
    id: '6472030001',
    districtId: '6472030',
    name: 'Mesjid',
  },
  {
    id: '6472030002',
    districtId: '6472030',
    name: 'Baqa',
  },
  {
    id: '6472030005',
    districtId: '6472030',
    name: 'Sungai Keledang',
  },
  {
    id: '6472030006',
    districtId: '6472030',
    name: 'Mangkupalas',
  },
  {
    id: '6472030007',
    districtId: '6472030',
    name: 'Tenun Samarinda',
  },
  {
    id: '6472030008',
    districtId: '6472030',
    name: 'Gunung Panjang',
  },
  {
    id: '6472031001',
    districtId: '6472031',
    name: 'Sengkotek',
  },
  {
    id: '6472031002',
    districtId: '6472031',
    name: 'Simpang Tiga',
  },
  {
    id: '6472031003',
    districtId: '6472031',
    name: 'Tani Aman',
  },
  {
    id: '6472031004',
    districtId: '6472031',
    name: 'Harapan Baru',
  },
  {
    id: '6472031005',
    districtId: '6472031',
    name: 'Rapak Dalam',
  },
  {
    id: '6472040001',
    districtId: '6472040',
    name: 'Loa Buah',
  },
  {
    id: '6472040002',
    districtId: '6472040',
    name: 'Loa Bakung',
  },
  {
    id: '6472040003',
    districtId: '6472040',
    name: 'Karang Asam Ulu',
  },
  {
    id: '6472040004',
    districtId: '6472040',
    name: 'Teluk Lerong Ulu',
  },
  {
    id: '6472040005',
    districtId: '6472040',
    name: 'Lok Bahu',
  },
  {
    id: '6472040006',
    districtId: '6472040',
    name: 'Karang Asam Ilir',
  },
  {
    id: '6472040007',
    districtId: '6472040',
    name: 'Karang Anyar',
  },
  {
    id: '6472050001',
    districtId: '6472050',
    name: 'Teluk Lerong Ilir',
  },
  {
    id: '6472050002',
    districtId: '6472050',
    name: 'Jawa',
  },
  {
    id: '6472050004',
    districtId: '6472050',
    name: 'Dadi Mulya',
  },
  {
    id: '6472050005',
    districtId: '6472050',
    name: 'Sidodadi',
  },
  {
    id: '6472050006',
    districtId: '6472050',
    name: 'Gunung Kelua',
  },
  {
    id: '6472050007',
    districtId: '6472050',
    name: 'Air Hitam',
  },
  {
    id: '6472050008',
    districtId: '6472050',
    name: 'Air Putih',
  },
  {
    id: '6472050009',
    districtId: '6472050',
    name: 'Bukit Pinang',
  },
  {
    id: '6472060004',
    districtId: '6472060',
    name: 'Lempake',
  },
  {
    id: '6472060005',
    districtId: '6472060',
    name: 'Sempaja Selatan',
  },
  {
    id: '6472060006',
    districtId: '6472060',
    name: 'Sungai Siring',
  },
  {
    id: '6472060010',
    districtId: '6472060',
    name: 'Tanah Merah',
  },
  {
    id: '6472060011',
    districtId: '6472060',
    name: 'Sempaja Utara',
  },
  {
    id: '6472060012',
    districtId: '6472060',
    name: 'Sempaja Timur',
  },
  {
    id: '6472060013',
    districtId: '6472060',
    name: 'Sempaja Barat',
  },
  {
    id: '6472060014',
    districtId: '6472060',
    name: 'Budaya Pampang',
  },
  {
    id: '6472061001',
    districtId: '6472061',
    name: 'Temindung Permai',
  },
  {
    id: '6472061002',
    districtId: '6472061',
    name: 'Bandara',
  },
  {
    id: '6472061003',
    districtId: '6472061',
    name: 'Sungai Pinang Dalam',
  },
  {
    id: '6472061004',
    districtId: '6472061',
    name: 'Mugirejo',
  },
  {
    id: '6472061005',
    districtId: '6472061',
    name: 'Gunung Lingai',
  },
  {
    id: '6474010001',
    districtId: '6474010',
    name: 'Bontang Lestari',
  },
  {
    id: '6474010002',
    districtId: '6474010',
    name: 'Satimpo',
  },
  {
    id: '6474010003',
    districtId: '6474010',
    name: 'Berebas Pantai',
  },
  {
    id: '6474010004',
    districtId: '6474010',
    name: 'Berebas Tengah',
  },
  {
    id: '6474010005',
    districtId: '6474010',
    name: 'Tanjung Laut',
  },
  {
    id: '6474010006',
    districtId: '6474010',
    name: 'Tanjung Laut Indah',
  },
  {
    id: '6474020001',
    districtId: '6474020',
    name: 'Bontang Kuala',
  },
  {
    id: '6474020002',
    districtId: '6474020',
    name: 'Bontang Baru',
  },
  {
    id: '6474020003',
    districtId: '6474020',
    name: 'Api-Api',
  },
  {
    id: '6474020004',
    districtId: '6474020',
    name: 'Gunung Lai',
  },
  {
    id: '6474020005',
    districtId: '6474020',
    name: 'Lok Tuan',
  },
  {
    id: '6474030001',
    districtId: '6474030',
    name: 'Kanaan',
  },
  {
    id: '6474030002',
    districtId: '6474030',
    name: 'Gunung Telihan',
  },
  {
    id: '6474030003',
    districtId: '6474030',
    name: 'Belimbing',
  },
  {
    id: '6501010001',
    districtId: '6501010',
    name: 'Mahak Baru',
  },
  {
    id: '6501010002',
    districtId: '6501010',
    name: 'Dumu Mahak',
  },
  {
    id: '6501010003',
    districtId: '6501010',
    name: 'Long Top',
  },
  {
    id: '6501010004',
    districtId: '6501010',
    name: 'Data Baru',
  },
  {
    id: '6501010005',
    districtId: '6501010',
    name: 'Long Lebusan',
  },
  {
    id: '6501010006',
    districtId: '6501010',
    name: 'Agung Baru',
  },
  {
    id: '6501020001',
    districtId: '6501020',
    name: 'Long Ampung',
  },
  {
    id: '6501020002',
    districtId: '6501020',
    name: 'Long Sungai Barang',
  },
  {
    id: '6501020003',
    districtId: '6501020',
    name: 'Lidung Payau',
  },
  {
    id: '6501020004',
    districtId: '6501020',
    name: 'Long Uro',
  },
  {
    id: '6501020005',
    districtId: '6501020',
    name: 'Metulang',
  },
  {
    id: '6501030001',
    districtId: '6501030',
    name: 'Long Temuyat',
  },
  {
    id: '6501030002',
    districtId: '6501030',
    name: 'Nawang Baru',
  },
  {
    id: '6501030003',
    districtId: '6501030',
    name: 'Long Betaoh',
  },
  {
    id: '6501030004',
    districtId: '6501030',
    name: 'Long Nawang',
  },
  {
    id: '6501030005',
    districtId: '6501030',
    name: 'Long Payau',
  },
  {
    id: '6501040002',
    districtId: '6501040',
    name: 'Sungai Anai',
  },
  {
    id: '6501040003',
    districtId: '6501040',
    name: 'Long Pipa',
  },
  {
    id: '6501040004',
    districtId: '6501040',
    name: 'Long Sule',
  },
  {
    id: '6501040005',
    districtId: '6501040',
    name: 'Data Dian',
  },
  {
    id: '6501050001',
    districtId: '6501050',
    name: 'Long Belaka Pitau',
  },
  {
    id: '6501050002',
    districtId: '6501050',
    name: 'Long Masahan',
  },
  {
    id: '6501050003',
    districtId: '6501050',
    name: 'Long Pua',
  },
  {
    id: '6501050004',
    districtId: '6501050',
    name: 'Long Ketaman',
  },
  {
    id: '6501050005',
    districtId: '6501050',
    name: 'Long Aran',
  },
  {
    id: '6501050006',
    districtId: '6501050',
    name: 'Long Lame',
  },
  {
    id: '6501050007',
    districtId: '6501050',
    name: 'Long Pujungan',
  },
  {
    id: '6501050008',
    districtId: '6501050',
    name: 'Long Paliran',
  },
  {
    id: '6501050009',
    districtId: '6501050',
    name: 'Long Bena',
  },
  {
    id: '6501060001',
    districtId: '6501060',
    name: 'Long Uli',
  },
  {
    id: '6501060002',
    districtId: '6501060',
    name: 'Long Tebulo',
  },
  {
    id: '6501060003',
    districtId: '6501060',
    name: 'Long Alango',
  },
  {
    id: '6501060004',
    districtId: '6501060',
    name: 'Long Atua/Long Kemuat',
  },
  {
    id: '6501060005',
    districtId: '6501060',
    name: 'Long Berini',
  },
  {
    id: '6501060006',
    districtId: '6501060',
    name: 'Apau Ping',
  },
  {
    id: '6501070001',
    districtId: '6501070',
    name: 'Long Pada',
  },
  {
    id: '6501070002',
    districtId: '6501070',
    name: 'Long Nyau',
  },
  {
    id: '6501070003',
    districtId: '6501070',
    name: 'Long Titi',
  },
  {
    id: '6501070004',
    districtId: '6501070',
    name: 'Long Ranau',
  },
  {
    id: '6501070005',
    districtId: '6501070',
    name: 'Rian Tubu',
  },
  {
    id: '6501080001',
    districtId: '6501080',
    name: 'Long Jalan',
  },
  {
    id: '6501080002',
    districtId: '6501080',
    name: 'Tanjung Nanga',
  },
  {
    id: '6501080003',
    districtId: '6501080',
    name: 'Nahakramo Baru',
  },
  {
    id: '6501080005',
    districtId: '6501080',
    name: 'Long Lake',
  },
  {
    id: '6501080006',
    districtId: '6501080',
    name: 'Halanga',
  },
  {
    id: '6501080007',
    districtId: '6501080',
    name: 'Punan Mirau',
  },
  {
    id: '6501080008',
    districtId: '6501080',
    name: 'Long Rat',
  },
  {
    id: '6501090001',
    districtId: '6501090',
    name: 'Langap',
  },
  {
    id: '6501090002',
    districtId: '6501090',
    name: 'Laban Nyarit',
  },
  {
    id: '6501090003',
    districtId: '6501090',
    name: 'Nunuk Tanah Kibang',
  },
  {
    id: '6501090004',
    districtId: '6501090',
    name: 'Sengayan',
  },
  {
    id: '6501090005',
    districtId: '6501090',
    name: 'Pelencau',
  },
  {
    id: '6501090006',
    districtId: '6501090',
    name: 'Bila Bekayuk',
  },
  {
    id: '6501090007',
    districtId: '6501090',
    name: 'Long Loreh',
  },
  {
    id: '6501090008',
    districtId: '6501090',
    name: 'Paya Seturan',
  },
  {
    id: '6501090009',
    districtId: '6501090',
    name: 'Punan Rian',
  },
  {
    id: '6501100001',
    districtId: '6501100',
    name: 'Long Adiu',
  },
  {
    id: '6501100002',
    districtId: '6501100',
    name: 'Punan Gong Solok',
  },
  {
    id: '6501100003',
    districtId: '6501100',
    name: 'Batu Kajang',
  },
  {
    id: '6501100004',
    districtId: '6501100',
    name: 'Gong Solok',
  },
  {
    id: '6501100005',
    districtId: '6501100',
    name: 'Punan Long Adiu',
  },
  {
    id: '6501100006',
    districtId: '6501100',
    name: 'Punan Setarap',
  },
  {
    id: '6501100007',
    districtId: '6501100',
    name: 'Setarap',
  },
  {
    id: '6501100008',
    districtId: '6501100',
    name: 'Setulang',
  },
  {
    id: '6501110001',
    districtId: '6501110',
    name: 'Harapan Maju',
  },
  {
    id: '6501110002',
    districtId: '6501110',
    name: 'Paking',
  },
  {
    id: '6501110003',
    districtId: '6501110',
    name: 'Long Liku',
  },
  {
    id: '6501110004',
    districtId: '6501110',
    name: 'Mentarang Baru',
  },
  {
    id: '6501110005',
    districtId: '6501110',
    name: 'Long Bisai',
  },
  {
    id: '6501110006',
    districtId: '6501110',
    name: 'Long Gafid',
  },
  {
    id: '6501110007',
    districtId: '6501110',
    name: 'Temalang',
  },
  {
    id: '6501110008',
    districtId: '6501110',
    name: 'Lidung Kemenci',
  },
  {
    id: '6501110009',
    districtId: '6501110',
    name: 'Pulau Sapi',
  },
  {
    id: '6501120001',
    districtId: '6501120',
    name: 'Semamu',
  },
  {
    id: '6501120002',
    districtId: '6501120',
    name: 'Long Berang',
  },
  {
    id: '6501120003',
    districtId: '6501120',
    name: 'Long Simau',
  },
  {
    id: '6501120004',
    districtId: '6501120',
    name: 'Long Pala',
  },
  {
    id: '6501120005',
    districtId: '6501120',
    name: 'Long Mekatip',
  },
  {
    id: '6501120006',
    districtId: '6501120',
    name: 'Long Kebinu',
  },
  {
    id: '6501120007',
    districtId: '6501120',
    name: 'Long Sulit',
  },
  {
    id: '6501130001',
    districtId: '6501130',
    name: 'Sembuak Warod',
  },
  {
    id: '6501130002',
    districtId: '6501130',
    name: 'Luso',
  },
  {
    id: '6501130004',
    districtId: '6501130',
    name: 'Kaliamok',
  },
  {
    id: '6501130005',
    districtId: '6501130',
    name: 'Malinau Seberang',
  },
  {
    id: '6501130006',
    districtId: '6501130',
    name: 'Lubok Manis',
  },
  {
    id: '6501130007',
    districtId: '6501130',
    name: 'Semengaris',
  },
  {
    id: '6501130008',
    districtId: '6501130',
    name: 'Kelapis',
  },
  {
    id: '6501130009',
    districtId: '6501130',
    name: 'Belayan',
  },
  {
    id: '6501130010',
    districtId: '6501130',
    name: 'Putat',
  },
  {
    id: '6501130011',
    districtId: '6501130',
    name: 'Salap',
  },
  {
    id: '6501140001',
    districtId: '6501140',
    name: 'Punan Bengalun',
  },
  {
    id: '6501140002',
    districtId: '6501140',
    name: 'Sesua',
  },
  {
    id: '6501140003',
    districtId: '6501140',
    name: 'Sempayang',
  },
  {
    id: '6501140004',
    districtId: '6501140',
    name: 'Kuala Lapang',
  },
  {
    id: '6501140005',
    districtId: '6501140',
    name: 'Tanjung Lapang',
  },
  {
    id: '6501140006',
    districtId: '6501140',
    name: 'Taras',
  },
  {
    id: '6501140007',
    districtId: '6501140',
    name: 'Long Kenipe',
  },
  {
    id: '6501140008',
    districtId: '6501140',
    name: 'Sentaban',
  },
  {
    id: '6501140009',
    districtId: '6501140',
    name: 'Long Bila',
  },
  {
    id: '6501150001',
    districtId: '6501150',
    name: 'Batu Lidung',
  },
  {
    id: '6501150002',
    districtId: '6501150',
    name: 'Tanjung Keranjang',
  },
  {
    id: '6501150003',
    districtId: '6501150',
    name: 'Malinau Hilir',
  },
  {
    id: '6501150004',
    districtId: '6501150',
    name: 'Malinau Kota',
  },
  {
    id: '6501150005',
    districtId: '6501150',
    name: 'Pelita Kanaan',
  },
  {
    id: '6501150006',
    districtId: '6501150',
    name: 'Malinau Hulu',
  },
  {
    id: '6502010001',
    districtId: '6502010',
    name: 'Long Lejuh',
  },
  {
    id: '6502010002',
    districtId: '6502010',
    name: 'Long Peleban',
  },
  {
    id: '6502010003',
    districtId: '6502010',
    name: 'Long Yiin/Pelaah',
  },
  {
    id: '6502010004',
    districtId: '6502010',
    name: 'Long Buang',
  },
  {
    id: '6502010005',
    districtId: '6502010',
    name: 'Long Lian',
  },
  {
    id: '6502010006',
    districtId: '6502010',
    name: 'Muara Pengean',
  },
  {
    id: '6502010007',
    districtId: '6502010',
    name: 'Long Peso',
  },
  {
    id: '6502010008',
    districtId: '6502010',
    name: 'Long Bia',
  },
  {
    id: '6502010009',
    districtId: '6502010',
    name: 'Lepak Aru',
  },
  {
    id: '6502010010',
    districtId: '6502010',
    name: 'Long Lasan',
  },
  {
    id: '6502020001',
    districtId: '6502020',
    name: 'Naha Aya',
  },
  {
    id: '6502020002',
    districtId: '6502020',
    name: 'Long Telenjau',
  },
  {
    id: '6502020003',
    districtId: '6502020',
    name: 'Long Bang Hulu',
  },
  {
    id: '6502020004',
    districtId: '6502020',
    name: 'Long Bang',
  },
  {
    id: '6502020005',
    districtId: '6502020',
    name: 'Long Tungu',
  },
  {
    id: '6502020006',
    districtId: '6502020',
    name: 'Long Lembu',
  },
  {
    id: '6502030001',
    districtId: '6502030',
    name: 'Long Beluah',
  },
  {
    id: '6502030002',
    districtId: '6502030',
    name: 'Long Sam',
  },
  {
    id: '6502030003',
    districtId: '6502030',
    name: 'Long Pari',
  },
  {
    id: '6502030004',
    districtId: '6502030',
    name: 'Mara Satu',
  },
  {
    id: '6502030005',
    districtId: '6502030',
    name: 'Mara Hilir',
  },
  {
    id: '6502040001',
    districtId: '6502040',
    name: 'Antutan',
  },
  {
    id: '6502040002',
    districtId: '6502040',
    name: 'Pejalin',
  },
  {
    id: '6502040003',
    districtId: '6502040',
    name: 'Tanjung Palas Hulu',
  },
  {
    id: '6502040004',
    districtId: '6502040',
    name: 'Tanjung Palas Tengah',
  },
  {
    id: '6502040005',
    districtId: '6502040',
    name: 'Karang Anyar',
  },
  {
    id: '6502040006',
    districtId: '6502040',
    name: 'Gunung Putih/Kr. Jenawi',
  },
  {
    id: '6502040007',
    districtId: '6502040',
    name: 'Tanjung Palas Hilir',
  },
  {
    id: '6502040008',
    districtId: '6502040',
    name: 'Teras Baru',
  },
  {
    id: '6502040009',
    districtId: '6502040',
    name: 'Teras Nawang',
  },
  {
    id: '6502050001',
    districtId: '6502050',
    name: 'Gunung Seriang',
  },
  {
    id: '6502050002',
    districtId: '6502050',
    name: 'Tanjung Selor Hulu',
  },
  {
    id: '6502050003',
    districtId: '6502050',
    name: 'Jelarai Selor',
  },
  {
    id: '6502050004',
    districtId: '6502050',
    name: 'Gunung Sari',
  },
  {
    id: '6502050005',
    districtId: '6502050',
    name: 'Bumi Rahayu',
  },
  {
    id: '6502050006',
    districtId: '6502050',
    name: 'Apung',
  },
  {
    id: '6502050007',
    districtId: '6502050',
    name: 'Tengkapak',
  },
  {
    id: '6502050008',
    districtId: '6502050',
    name: 'Tanjung Selor Timur',
  },
  {
    id: '6502050009',
    districtId: '6502050',
    name: 'Tanjung Selor Hilir',
  },
  {
    id: '6502060001',
    districtId: '6502060',
    name: 'Mangku Padi',
  },
  {
    id: '6502060002',
    districtId: '6502060',
    name: 'Tanah Kuning',
  },
  {
    id: '6502060003',
    districtId: '6502060',
    name: 'Binai',
  },
  {
    id: '6502060004',
    districtId: '6502060',
    name: 'Sajau',
  },
  {
    id: '6502060005',
    districtId: '6502060',
    name: 'Pura Sajau',
  },
  {
    id: '6502060006',
    districtId: '6502060',
    name: 'Sajau Hilir',
  },
  {
    id: '6502060007',
    districtId: '6502060',
    name: 'Wono Mulyo',
  },
  {
    id: '6502060008',
    districtId: '6502060',
    name: 'Tanjung Agung',
  },
  {
    id: '6502070001',
    districtId: '6502070',
    name: 'Tanjung Buka',
  },
  {
    id: '6502070002',
    districtId: '6502070',
    name: 'Salim Batu',
  },
  {
    id: '6502070003',
    districtId: '6502070',
    name: 'Silva Rahayu',
  },
  {
    id: '6502080001',
    districtId: '6502080',
    name: 'Pimping',
  },
  {
    id: '6502080002',
    districtId: '6502080',
    name: 'Kelubir',
  },
  {
    id: '6502080003',
    districtId: '6502080',
    name: 'Karang Agung',
  },
  {
    id: '6502080004',
    districtId: '6502080',
    name: 'Ruhui Rahayu',
  },
  {
    id: '6502080005',
    districtId: '6502080',
    name: 'Panca Agung',
  },
  {
    id: '6502080006',
    districtId: '6502080',
    name: 'Ardi Mulya',
  },
  {
    id: '6502090001',
    districtId: '6502090',
    name: 'Ujang',
  },
  {
    id: '6502090002',
    districtId: '6502090',
    name: 'Tenggiling',
  },
  {
    id: '6502090003',
    districtId: '6502090',
    name: 'Terindak',
  },
  {
    id: '6502090004',
    districtId: '6502090',
    name: 'Pungit',
  },
  {
    id: '6502090005',
    districtId: '6502090',
    name: 'Sekatak Bengara',
  },
  {
    id: '6502090006',
    districtId: '6502090',
    name: 'Pentian',
  },
  {
    id: '6502090007',
    districtId: '6502090',
    name: 'Ambalat',
  },
  {
    id: '6502090008',
    districtId: '6502090',
    name: 'Kendari',
  },
  {
    id: '6502090009',
    districtId: '6502090',
    name: 'Kelincawan',
  },
  {
    id: '6502090010',
    districtId: '6502090',
    name: 'Bunau',
  },
  {
    id: '6502090011',
    districtId: '6502090',
    name: 'Anjar Arip',
  },
  {
    id: '6502090012',
    districtId: '6502090',
    name: 'Paru Abang',
  },
  {
    id: '6502090013',
    districtId: '6502090',
    name: 'Kelising',
  },
  {
    id: '6502090014',
    districtId: '6502090',
    name: 'Bekiliu',
  },
  {
    id: '6502090015',
    districtId: '6502090',
    name: 'Punan Dulau',
  },
  {
    id: '6502090016',
    districtId: '6502090',
    name: 'Bambang',
  },
  {
    id: '6502090017',
    districtId: '6502090',
    name: 'Kelembunan',
  },
  {
    id: '6502090018',
    districtId: '6502090',
    name: 'Maritam',
  },
  {
    id: '6502090020',
    districtId: '6502090',
    name: 'Keriting',
  },
  {
    id: '6502090021',
    districtId: '6502090',
    name: 'Sekatak Buji',
  },
  {
    id: '6502090022',
    districtId: '6502090',
    name: 'Liagu',
  },
  {
    id: '6502100001',
    districtId: '6502100',
    name: 'Bunyu Barat',
  },
  {
    id: '6502100002',
    districtId: '6502100',
    name: 'Bunyu Selatan',
  },
  {
    id: '6502100003',
    districtId: '6502100',
    name: 'Bunyu Timur',
  },
  {
    id: '6503010001',
    districtId: '6503010',
    name: 'Balayan Ari',
  },
  {
    id: '6503010003',
    districtId: '6503010',
    name: 'Rian',
  },
  {
    id: '6503010004',
    districtId: '6503010',
    name: 'Kapuak',
  },
  {
    id: '6503010005',
    districtId: '6503010',
    name: 'Rian Rayo',
  },
  {
    id: '6503010006',
    districtId: '6503010',
    name: 'Sapari',
  },
  {
    id: '6503020002',
    districtId: '6503020',
    name: 'Limbu Sedulun',
  },
  {
    id: '6503020003',
    districtId: '6503020',
    name: 'Gunawan',
  },
  {
    id: '6503020004',
    districtId: '6503020',
    name: 'Tideng Pale',
  },
  {
    id: '6503020005',
    districtId: '6503020',
    name: 'Tideng Pale Timur',
  },
  {
    id: '6503020006',
    districtId: '6503020',
    name: 'Sebidai',
  },
  {
    id: '6503020007',
    districtId: '6503020',
    name: 'Sebawang',
  },
  {
    id: '6503030001',
    districtId: '6503030',
    name: 'Mendupo',
  },
  {
    id: '6503030002',
    districtId: '6503030',
    name: 'Periuk',
  },
  {
    id: '6503030003',
    districtId: '6503030',
    name: 'Bebakung',
  },
  {
    id: '6503030004',
    districtId: '6503030',
    name: 'Kujau',
  },
  {
    id: '6503030005',
    districtId: '6503030',
    name: 'Maning',
  },
  {
    id: '6503030006',
    districtId: '6503030',
    name: 'Buang Baru',
  },
  {
    id: '6503040001',
    districtId: '6503040',
    name: 'Seludau',
  },
  {
    id: '6503040002',
    districtId: '6503040',
    name: 'Sesayap',
  },
  {
    id: '6503040003',
    districtId: '6503040',
    name: 'Sepala Dalung',
  },
  {
    id: '6503040004',
    districtId: '6503040',
    name: 'Bandan Bikis',
  },
  {
    id: '6503040005',
    districtId: '6503040',
    name: 'Bebatu',
  },
  {
    id: '6503040006',
    districtId: '6503040',
    name: 'Sengkong',
  },
  {
    id: '6503040008',
    districtId: '6503040',
    name: 'Sesayap Selor',
  },
  {
    id: '6503050001',
    districtId: '6503050',
    name: 'Tanah Merah',
  },
  {
    id: '6503050002',
    districtId: '6503050',
    name: 'Sambungan',
  },
  {
    id: '6503050003',
    districtId: '6503050',
    name: 'Tengku Dacing',
  },
  {
    id: '6503050004',
    districtId: '6503050',
    name: 'Tanah Merah Barat',
  },
  {
    id: '6503050005',
    districtId: '6503050',
    name: 'Sambungan Selatan',
  },
  {
    id: '6504010001',
    districtId: '6504010',
    name: 'Long Pasia',
  },
  {
    id: '6504010002',
    districtId: '6504010',
    name: 'Liang Lunuk',
  },
  {
    id: '6504010003',
    districtId: '6504010',
    name: 'Pa Ibang',
  },
  {
    id: '6504010004',
    districtId: '6504010',
    name: 'Pa Amai',
  },
  {
    id: '6504010005',
    districtId: '6504010',
    name: 'Pa Kaber',
  },
  {
    id: '6504010006',
    districtId: '6504010',
    name: 'Pa Tera',
  },
  {
    id: '6504010007',
    districtId: '6504010',
    name: 'Pa Sing',
  },
  {
    id: '6504010008',
    districtId: '6504010',
    name: 'Long Budung',
  },
  {
    id: '6504010009',
    districtId: '6504010',
    name: 'Pa Dalan',
  },
  {
    id: '6504010010',
    districtId: '6504010',
    name: 'Pa Urang',
  },
  {
    id: '6504010011',
    districtId: '6504010',
    name: 'Long Birar',
  },
  {
    id: '6504010012',
    districtId: '6504010',
    name: 'Pa Upan',
  },
  {
    id: '6504010017',
    districtId: '6504010',
    name: 'Long Pupung',
  },
  {
    id: '6504011001',
    districtId: '6504011',
    name: 'Tang Paye',
  },
  {
    id: '6504011002',
    districtId: '6504011',
    name: 'Long Kelupan',
  },
  {
    id: '6504011003',
    districtId: '6504011',
    name: 'Long Rungan',
  },
  {
    id: '6504011004',
    districtId: '6504011',
    name: 'Pa Milau',
  },
  {
    id: '6504011005',
    districtId: '6504011',
    name: 'Pa Yalau',
  },
  {
    id: '6504011006',
    districtId: '6504011',
    name: 'Long Mutan',
  },
  {
    id: '6504011007',
    districtId: '6504011',
    name: 'Tang Badui',
  },
  {
    id: '6504011008',
    districtId: '6504011',
    name: 'Long Padi',
  },
  {
    id: '6504011009',
    districtId: '6504011',
    name: 'Long Rian',
  },
  {
    id: '6504011010',
    districtId: '6504011',
    name: 'Ba Liku',
  },
  {
    id: '6504011011',
    districtId: '6504011',
    name: 'Binuang',
  },
  {
    id: '6504020009',
    districtId: '6504020',
    name: 'Pa Matung',
  },
  {
    id: '6504020010',
    districtId: '6504020',
    name: 'Pa Putuk',
  },
  {
    id: '6504020011',
    districtId: '6504020',
    name: 'Cinglat',
  },
  {
    id: '6504020020',
    districtId: '6504020',
    name: 'Pa Padi',
  },
  {
    id: '6504020021',
    districtId: '6504020',
    name: 'Liang Biadung',
  },
  {
    id: '6504020022',
    districtId: '6504020',
    name: 'Wa Laya',
  },
  {
    id: '6504020023',
    districtId: '6504020',
    name: 'Long Matung',
  },
  {
    id: '6504020024',
    districtId: '6504020',
    name: 'Long Rupan',
  },
  {
    id: '6504020025',
    districtId: '6504020',
    name: 'Long Katung',
  },
  {
    id: '6504020028',
    districtId: '6504020',
    name: 'Pa Terutun',
  },
  {
    id: '6504020029',
    districtId: '6504020',
    name: 'Long Bawan',
  },
  {
    id: '6504020033',
    districtId: '6504020',
    name: 'Pa Rupai',
  },
  {
    id: '6504020035',
    districtId: '6504020',
    name: 'Long Nawang',
  },
  {
    id: '6504020040',
    districtId: '6504020',
    name: 'Buduk Kinangan',
  },
  {
    id: '6504020041',
    districtId: '6504020',
    name: 'Wa Yanud',
  },
  {
    id: '6504020053',
    districtId: '6504020',
    name: 'Pa Sire',
  },
  {
    id: '6504020057',
    districtId: '6504020',
    name: 'Pa Nado',
  },
  {
    id: '6504020058',
    districtId: '6504020',
    name: 'Liang Tuer',
  },
  {
    id: '6504020059',
    districtId: '6504020',
    name: 'Long Api',
  },
  {
    id: '6504020060',
    districtId: '6504020',
    name: 'Ba Sikor',
  },
  {
    id: '6504020061',
    districtId: '6504020',
    name: 'Long Berayang',
  },
  {
    id: '6504020063',
    districtId: '6504020',
    name: 'Liang Butan',
  },
  {
    id: '6504021001',
    districtId: '6504021',
    name: 'Kampung Baru',
  },
  {
    id: '6504021002',
    districtId: '6504021',
    name: 'Long Umung',
  },
  {
    id: '6504021003',
    districtId: '6504021',
    name: 'Pa Kebuan',
  },
  {
    id: '6504021004',
    districtId: '6504021',
    name: 'Pa Betung',
  },
  {
    id: '6504021005',
    districtId: '6504021',
    name: 'Bungayan',
  },
  {
    id: '6504021006',
    districtId: '6504021',
    name: 'Wa Yagung',
  },
  {
    id: '6504021007',
    districtId: '6504021',
    name: 'Pa Melade',
  },
  {
    id: '6504021008',
    districtId: '6504021',
    name: 'Long Sepayang',
  },
  {
    id: '6504021009',
    districtId: '6504021',
    name: 'Pa Umung',
  },
  {
    id: '6504021010',
    districtId: '6504021',
    name: 'Pa Pawan',
  },
  {
    id: '6504021011',
    districtId: '6504021',
    name: 'Long Nuat',
  },
  {
    id: '6504021012',
    districtId: '6504021',
    name: 'Long Tenem',
  },
  {
    id: '6504021013',
    districtId: '6504021',
    name: 'Pa Lidung',
  },
  {
    id: '6504021014',
    districtId: '6504021',
    name: 'Pa Rangeb',
  },
  {
    id: '6504021015',
    districtId: '6504021',
    name: 'Pa Raye',
  },
  {
    id: '6504021016',
    districtId: '6504021',
    name: 'Pa Pala',
  },
  {
    id: '6504021017',
    districtId: '6504021',
    name: 'Sinar Baru',
  },
  {
    id: '6504022001',
    districtId: '6504022',
    name: 'Pa Inan',
  },
  {
    id: '6504022002',
    districtId: '6504022',
    name: 'Pa Mulak',
  },
  {
    id: '6504022003',
    districtId: '6504022',
    name: 'Long Mangan',
  },
  {
    id: '6504022004',
    districtId: '6504022',
    name: 'Long Kabid',
  },
  {
    id: '6504022005',
    districtId: '6504022',
    name: 'Pa Butal',
  },
  {
    id: '6504022006',
    districtId: '6504022',
    name: 'Pa Urud',
  },
  {
    id: '6504022007',
    districtId: '6504022',
    name: 'Pa Kemut',
  },
  {
    id: '6504022009',
    districtId: '6504022',
    name: 'Long Tugul',
  },
  {
    id: '6504022010',
    districtId: '6504022',
    name: 'Long Puak',
  },
  {
    id: '6504022012',
    districtId: '6504022',
    name: 'Pa Delung',
  },
  {
    id: '6504022013',
    districtId: '6504022',
    name: 'Pa Kidang',
  },
  {
    id: '6504022014',
    districtId: '6504022',
    name: 'Lembada',
  },
  {
    id: '6504022015',
    districtId: '6504022',
    name: 'Liang Turan',
  },
  {
    id: '6504022016',
    districtId: '6504022',
    name: 'Liang Alig',
  },
  {
    id: '6504022017',
    districtId: '6504022',
    name: 'Pa Payak',
  },
  {
    id: '6504022018',
    districtId: '6504022',
    name: 'Pa Mering',
  },
  {
    id: '6504022019',
    districtId: '6504022',
    name: 'Lepatar',
  },
  {
    id: '6504022020',
    districtId: '6504022',
    name: 'Liang Bua',
  },
  {
    id: '6504022021',
    districtId: '6504022',
    name: 'Pa Pirit',
  },
  {
    id: '6504022022',
    districtId: '6504022',
    name: 'Ma Libu',
  },
  {
    id: '6504022023',
    districtId: '6504022',
    name: 'Pa Lutut',
  },
  {
    id: '6504022025',
    districtId: '6504022',
    name: 'Pa Pani',
  },
  {
    id: '6504030001',
    districtId: '6504030',
    name: 'Payang',
  },
  {
    id: '6504030002',
    districtId: '6504030',
    name: 'Suyadon',
  },
  {
    id: '6504030003',
    districtId: '6504030',
    name: 'Tukulon',
  },
  {
    id: '6504030004',
    districtId: '6504030',
    name: 'Bulu Mengelom',
  },
  {
    id: '6504030005',
    districtId: '6504030',
    name: 'Batung',
  },
  {
    id: '6504030006',
    districtId: '6504030',
    name: 'Ubel Sulok',
  },
  {
    id: '6504030007',
    districtId: '6504030',
    name: 'Ubel Alung',
  },
  {
    id: '6504030008',
    districtId: '6504030',
    name: 'Nan Sapan',
  },
  {
    id: '6504030009',
    districtId: '6504030',
    name: 'Sedalit',
  },
  {
    id: '6504030010',
    districtId: '6504030',
    name: 'Tambalang Hilir',
  },
  {
    id: '6504030011',
    districtId: '6504030',
    name: 'Paluan',
  },
  {
    id: '6504030013',
    districtId: '6504030',
    name: 'Long Bulu',
  },
  {
    id: '6504030014',
    districtId: '6504030',
    name: 'Kalam Buku',
  },
  {
    id: '6504030015',
    districtId: '6504030',
    name: 'Tadungus',
  },
  {
    id: '6504030016',
    districtId: '6504030',
    name: 'Semata',
  },
  {
    id: '6504030017',
    districtId: '6504030',
    name: 'Linsayung',
  },
  {
    id: '6504030018',
    districtId: '6504030',
    name: 'Salan',
  },
  {
    id: '6504030019',
    districtId: '6504030',
    name: 'Sungoi',
  },
  {
    id: '6504030020',
    districtId: '6504030',
    name: 'Sinampala I',
  },
  {
    id: '6504030021',
    districtId: '6504030',
    name: 'Samunti',
  },
  {
    id: '6504030022',
    districtId: '6504030',
    name: 'Sinampala II',
  },
  {
    id: '6504030023',
    districtId: '6504030',
    name: 'Limpakon',
  },
  {
    id: '6504030024',
    districtId: '6504030',
    name: 'Labuk',
  },
  {
    id: '6504030025',
    districtId: '6504030',
    name: 'Sumentobol',
  },
  {
    id: '6504030026',
    districtId: '6504030',
    name: 'Sanal',
  },
  {
    id: '6504030027',
    districtId: '6504030',
    name: 'Tumatalas',
  },
  {
    id: '6504030028',
    districtId: '6504030',
    name: 'Nantukidan',
  },
  {
    id: '6504030029',
    districtId: '6504030',
    name: 'Labang',
  },
  {
    id: '6504030030',
    districtId: '6504030',
    name: 'Sumantipal',
  },
  {
    id: '6504030031',
    districtId: '6504030',
    name: 'Ngawol',
  },
  {
    id: '6504030032',
    districtId: '6504030',
    name: 'Bulu Laun Hilir',
  },
  {
    id: '6504030033',
    districtId: '6504030',
    name: 'Lagas',
  },
  {
    id: '6504030034',
    districtId: '6504030',
    name: 'Tantalujuk',
  },
  {
    id: '6504030035',
    districtId: '6504030',
    name: 'Panas',
  },
  {
    id: '6504030036',
    districtId: '6504030',
    name: 'Kuyo',
  },
  {
    id: '6504030037',
    districtId: '6504030',
    name: 'Bokok',
  },
  {
    id: '6504030038',
    districtId: '6504030',
    name: 'Tambalang Hulu',
  },
  {
    id: '6504030039',
    districtId: '6504030',
    name: 'Langgason',
  },
  {
    id: '6504030040',
    districtId: '6504030',
    name: 'Sibalu',
  },
  {
    id: '6504030041',
    districtId: '6504030',
    name: 'Mamasin',
  },
  {
    id: '6504030042',
    districtId: '6504030',
    name: 'Duyan',
  },
  {
    id: '6504030043',
    districtId: '6504030',
    name: 'Tau Lumbis',
  },
  {
    id: '6504030044',
    districtId: '6504030',
    name: 'Kabungalor',
  },
  {
    id: '6504030045',
    districtId: '6504030',
    name: 'Tetagas',
  },
  {
    id: '6504030046',
    districtId: '6504030',
    name: 'Bulu Laun Hulu',
  },
  {
    id: '6504030047',
    districtId: '6504030',
    name: 'Tantu Libing',
  },
  {
    id: '6504030048',
    districtId: '6504030',
    name: 'Kalisun',
  },
  {
    id: '6504030049',
    districtId: '6504030',
    name: 'Lepaga',
  },
  {
    id: '6504040001',
    districtId: '6504040',
    name: 'Sangkup',
  },
  {
    id: '6504040002',
    districtId: '6504040',
    name: 'Pa Loo',
  },
  {
    id: '6504040003',
    districtId: '6504040',
    name: 'Libang',
  },
  {
    id: '6504040004',
    districtId: '6504040',
    name: 'Kalampising',
  },
  {
    id: '6504040005',
    districtId: '6504040',
    name: 'Sedongon',
  },
  {
    id: '6504040006',
    districtId: '6504040',
    name: 'Mansalong',
  },
  {
    id: '6504040007',
    districtId: '6504040',
    name: 'Deralon',
  },
  {
    id: '6504040008',
    districtId: '6504040',
    name: 'Siawang',
  },
  {
    id: '6504040009',
    districtId: '6504040',
    name: 'Semalat',
  },
  {
    id: '6504040010',
    districtId: '6504040',
    name: 'Dubulon',
  },
  {
    id: '6504040011',
    districtId: '6504040',
    name: 'Pa Lemumut',
  },
  {
    id: '6504040012',
    districtId: '6504040',
    name: 'Saludan',
  },
  {
    id: '6504040013',
    districtId: '6504040',
    name: 'Sumalumung',
  },
  {
    id: '6504040014',
    districtId: '6504040',
    name: 'Tanjung Hilir',
  },
  {
    id: '6504040015',
    districtId: '6504040',
    name: 'Tanjung Hulu',
  },
  {
    id: '6504040016',
    districtId: '6504040',
    name: 'Bulan Bulan',
  },
  {
    id: '6504040017',
    districtId: '6504040',
    name: 'Liang',
  },
  {
    id: '6504040018',
    districtId: '6504040',
    name: 'Sapuyan',
  },
  {
    id: '6504040019',
    districtId: '6504040',
    name: 'Nainsid',
  },
  {
    id: '6504040020',
    districtId: '6504040',
    name: 'Likos',
  },
  {
    id: '6504040022',
    districtId: '6504040',
    name: 'Sasibu',
  },
  {
    id: '6504040023',
    districtId: '6504040',
    name: 'Taluan',
  },
  {
    id: '6504040024',
    districtId: '6504040',
    name: 'Pulu Bulawan',
  },
  {
    id: '6504040025',
    districtId: '6504040',
    name: 'Lintong',
  },
  {
    id: '6504040026',
    districtId: '6504040',
    name: 'Patal I',
  },
  {
    id: '6504040027',
    districtId: '6504040',
    name: 'Patal II',
  },
  {
    id: '6504040028',
    districtId: '6504040',
    name: 'Podong',
  },
  {
    id: '6504050001',
    districtId: '6504050',
    name: 'Liuk Bulu',
  },
  {
    id: '6504050002',
    districtId: '6504050',
    name: 'Binanun',
  },
  {
    id: '6504050003',
    districtId: '6504050',
    name: 'Pulau Keras',
  },
  {
    id: '6504050004',
    districtId: '6504050',
    name: 'Sabuluan',
  },
  {
    id: '6504050005',
    districtId: '6504050',
    name: 'Tulang',
  },
  {
    id: '6504050006',
    districtId: '6504050',
    name: 'Saduman',
  },
  {
    id: '6504050007',
    districtId: '6504050',
    name: 'Pagaluyon',
  },
  {
    id: '6504050008',
    districtId: '6504050',
    name: 'Mambulu',
  },
  {
    id: '6504050009',
    districtId: '6504050',
    name: 'Katul',
  },
  {
    id: '6504050010',
    districtId: '6504050',
    name: 'Lubok Buat',
  },
  {
    id: '6504060001',
    districtId: '6504060',
    name: 'Butas Bagu',
  },
  {
    id: '6504060002',
    districtId: '6504060',
    name: 'Labuk',
  },
  {
    id: '6504060003',
    districtId: '6504060',
    name: 'Pagar',
  },
  {
    id: '6504060005',
    districtId: '6504060',
    name: 'Manuk Bungkul',
  },
  {
    id: '6504060006',
    districtId: '6504060',
    name: 'Atap',
  },
  {
    id: '6504060007',
    districtId: '6504060',
    name: 'Lubakan',
  },
  {
    id: '6504060008',
    districtId: '6504060',
    name: 'Tagul',
  },
  {
    id: '6504060009',
    districtId: '6504060',
    name: 'Plaju',
  },
  {
    id: '6504060010',
    districtId: '6504060',
    name: 'Tepian',
  },
  {
    id: '6504070001',
    districtId: '6504070',
    name: 'Sujau',
  },
  {
    id: '6504070003',
    districtId: '6504070',
    name: 'Melasu Baru',
  },
  {
    id: '6504070004',
    districtId: '6504070',
    name: 'Bebanas',
  },
  {
    id: '6504070005',
    districtId: '6504070',
    name: 'Tetaban',
  },
  {
    id: '6504070006',
    districtId: '6504070',
    name: 'Kunyit',
  },
  {
    id: '6504070007',
    districtId: '6504070',
    name: 'Kekayap',
  },
  {
    id: '6504070008',
    districtId: '6504070',
    name: 'Apas',
  },
  {
    id: '6504070009',
    districtId: '6504070',
    name: 'Harapan',
  },
  {
    id: '6504070010',
    districtId: '6504070',
    name: 'Pembeliangan',
  },
  {
    id: '6504080001',
    districtId: '6504080',
    name: 'Belatikan',
  },
  {
    id: '6504080002',
    districtId: '6504080',
    name: 'Naputi',
  },
  {
    id: '6504080003',
    districtId: '6504080',
    name: 'Tau Baru',
  },
  {
    id: '6504080004',
    districtId: '6504080',
    name: 'Tinampak II',
  },
  {
    id: '6504080005',
    districtId: '6504080',
    name: 'Tinampak I',
  },
  {
    id: '6504080006',
    districtId: '6504080',
    name: 'Salang',
  },
  {
    id: '6504080007',
    districtId: '6504080',
    name: 'Tembalang',
  },
  {
    id: '6504080008',
    districtId: '6504080',
    name: 'Kalun Sayan',
  },
  {
    id: '6504080009',
    districtId: '6504080',
    name: 'Sekikilan',
  },
  {
    id: '6504080010',
    districtId: '6504080',
    name: 'Semunad',
  },
  {
    id: '6504080011',
    districtId: '6504080',
    name: 'Sanur',
  },
  {
    id: '6504080012',
    districtId: '6504080',
    name: 'Makmur',
  },
  {
    id: '6504090001',
    districtId: '6504090',
    name: 'Tabur Lestari',
  },
  {
    id: '6504090002',
    districtId: '6504090',
    name: 'Samaenre Semaja',
  },
  {
    id: '6504090003',
    districtId: '6504090',
    name: 'Sri Nanti',
  },
  {
    id: '6504090004',
    districtId: '6504090',
    name: 'Sekaduyan Taka',
  },
  {
    id: '6504100001',
    districtId: '6504100',
    name: 'Nunukan Barat',
  },
  {
    id: '6504100002',
    districtId: '6504100',
    name: 'Binusan',
  },
  {
    id: '6504100003',
    districtId: '6504100',
    name: 'Nunukan Tengah',
  },
  {
    id: '6504100004',
    districtId: '6504100',
    name: 'Nunukan Timur',
  },
  {
    id: '6504100005',
    districtId: '6504100',
    name: 'Nunukan Utara',
  },
  {
    id: '6504110001',
    districtId: '6504110',
    name: 'Tanjung Harapan',
  },
  {
    id: '6504110002',
    districtId: '6504110',
    name: 'Mansapa',
  },
  {
    id: '6504110003',
    districtId: '6504110',
    name: 'Nunukan Selatan',
  },
  {
    id: '6504110004',
    districtId: '6504110',
    name: 'Selisun',
  },
  {
    id: '6504120001',
    districtId: '6504120',
    name: 'Bambangan',
  },
  {
    id: '6504120002',
    districtId: '6504120',
    name: 'Liang Bunyu',
  },
  {
    id: '6504120003',
    districtId: '6504120',
    name: 'Binalawan',
  },
  {
    id: '6504120004',
    districtId: '6504120',
    name: 'Setabu',
  },
  {
    id: '6504130001',
    districtId: '6504130',
    name: 'Balansiku',
  },
  {
    id: '6504130002',
    districtId: '6504130',
    name: 'Tanjung Karang',
  },
  {
    id: '6504130003',
    districtId: '6504130',
    name: 'Sei Manurung',
  },
  {
    id: '6504130004',
    districtId: '6504130',
    name: 'Padaidi',
  },
  {
    id: '6504140001',
    districtId: '6504140',
    name: 'Sungai Nyamuk',
  },
  {
    id: '6504140002',
    districtId: '6504140',
    name: 'Tanjung Harapan',
  },
  {
    id: '6504140003',
    districtId: '6504140',
    name: 'Bukit Aru Indah',
  },
  {
    id: '6504140004',
    districtId: '6504140',
    name: 'Tanjung Aru',
  },
  {
    id: '6504150001',
    districtId: '6504150',
    name: 'Sungai Limau',
  },
  {
    id: '6504150002',
    districtId: '6504150',
    name: 'Maspul',
  },
  {
    id: '6504150003',
    districtId: '6504150',
    name: 'Aji Kuning',
  },
  {
    id: '6504150004',
    districtId: '6504150',
    name: 'Bukit Harapan',
  },
  {
    id: '6504160001',
    districtId: '6504160',
    name: 'Lapri',
  },
  {
    id: '6504160002',
    districtId: '6504160',
    name: 'Pancang',
  },
  {
    id: '6504160003',
    districtId: '6504160',
    name: 'Seberang',
  },
  {
    id: '6571010001',
    districtId: '6571010',
    name: 'Mamburungan',
  },
  {
    id: '6571010002',
    districtId: '6571010',
    name: 'Mamburungan Timur',
  },
  {
    id: '6571010003',
    districtId: '6571010',
    name: 'Pantai Amal',
  },
  {
    id: '6571010004',
    districtId: '6571010',
    name: 'Kampung Enam',
  },
  {
    id: '6571010005',
    districtId: '6571010',
    name: 'Kampung Empat',
  },
  {
    id: '6571010006',
    districtId: '6571010',
    name: 'Gunung Lingkas',
  },
  {
    id: '6571010007',
    districtId: '6571010',
    name: 'Lingkas Ujung',
  },
  {
    id: '6571020001',
    districtId: '6571020',
    name: 'Selumit Pantai',
  },
  {
    id: '6571020002',
    districtId: '6571020',
    name: 'Selumit',
  },
  {
    id: '6571020003',
    districtId: '6571020',
    name: 'Sebengkok',
  },
  {
    id: '6571020004',
    districtId: '6571020',
    name: 'Pamusian',
  },
  {
    id: '6571020005',
    districtId: '6571020',
    name: 'Kampung Satu Skip',
  },
  {
    id: '6571030001',
    districtId: '6571030',
    name: 'Karang Rejo',
  },
  {
    id: '6571030002',
    districtId: '6571030',
    name: 'Karang Balik',
  },
  {
    id: '6571030003',
    districtId: '6571030',
    name: 'Karang Anyar',
  },
  {
    id: '6571030004',
    districtId: '6571030',
    name: 'Karang Anyar Pantai',
  },
  {
    id: '6571030005',
    districtId: '6571030',
    name: 'Karang Harapan',
  },
  {
    id: '6571040001',
    districtId: '6571040',
    name: 'Juata Permai',
  },
  {
    id: '6571040002',
    districtId: '6571040',
    name: 'Juata Kerikil',
  },
  {
    id: '6571040003',
    districtId: '6571040',
    name: 'Juata Laut',
  },
  {
    id: '7101021001',
    districtId: '7101021',
    name: 'Toraut',
  },
  {
    id: '7101021002',
    districtId: '7101021',
    name: 'Matayangan',
  },
  {
    id: '7101021003',
    districtId: '7101021',
    name: 'Uuwan',
  },
  {
    id: '7101021004',
    districtId: '7101021',
    name: 'Ikhwan',
  },
  {
    id: '7101021005',
    districtId: '7101021',
    name: 'Doloduo',
  },
  {
    id: '7101021006',
    districtId: '7101021',
    name: 'Mekaruo',
  },
  {
    id: '7101021007',
    districtId: '7101021',
    name: 'Wangga Baru',
  },
  {
    id: '7101021008',
    districtId: '7101021',
    name: 'Toraut Utara',
  },
  {
    id: '7101021009',
    districtId: '7101021',
    name: 'Doloduo I',
  },
  {
    id: '7101021010',
    districtId: '7101021',
    name: 'Doloduo II',
  },
  {
    id: '7101021011',
    districtId: '7101021',
    name: 'Doloduo III',
  },
  {
    id: '7101021012',
    districtId: '7101021',
    name: 'Toraut Tengah',
  },
  {
    id: '7101022001',
    districtId: '7101022',
    name: 'Tumokang Baru',
  },
  {
    id: '7101022002',
    districtId: '7101022',
    name: 'Mopugad Utara',
  },
  {
    id: '7101022003',
    districtId: '7101022',
    name: 'Mopugad Selatan',
  },
  {
    id: '7101022004',
    districtId: '7101022',
    name: 'Mopuya Utara',
  },
  {
    id: '7101022005',
    districtId: '7101022',
    name: 'Mopuya Selatan',
  },
  {
    id: '7101022006',
    districtId: '7101022',
    name: 'Dondomon',
  },
  {
    id: '7101022014',
    districtId: '7101022',
    name: 'Mopugad Selatan I',
  },
  {
    id: '7101022015',
    districtId: '7101022',
    name: 'Mopugad Utara II',
  },
  {
    id: '7101022016',
    districtId: '7101022',
    name: 'Mopugad Utara I',
  },
  {
    id: '7101022017',
    districtId: '7101022',
    name: 'Tumokang Timur',
  },
  {
    id: '7101022018',
    districtId: '7101022',
    name: 'Mopuya Utara I',
  },
  {
    id: '7101022019',
    districtId: '7101022',
    name: 'Mopuya Utara II',
  },
  {
    id: '7101022020',
    districtId: '7101022',
    name: 'Mopuya Selatan I',
  },
  {
    id: '7101022021',
    districtId: '7101022',
    name: 'Mopuya Selatan II',
  },
  {
    id: '7101022022',
    districtId: '7101022',
    name: 'Dondomon Utara',
  },
  {
    id: '7101022023',
    districtId: '7101022',
    name: 'Dondomon Selatan',
  },
  {
    id: '7101023001',
    districtId: '7101023',
    name: 'Tonom',
  },
  {
    id: '7101023002',
    districtId: '7101023',
    name: 'Mogoyunggung',
  },
  {
    id: '7101023003',
    districtId: '7101023',
    name: 'Imandi',
  },
  {
    id: '7101023004',
    districtId: '7101023',
    name: 'Pinonobatuan',
  },
  {
    id: '7101023005',
    districtId: '7101023',
    name: 'Modomang',
  },
  {
    id: '7101023006',
    districtId: '7101023',
    name: 'Dumoga',
  },
  {
    id: '7101023007',
    districtId: '7101023',
    name: 'Kembang Mertha',
  },
  {
    id: '7101023017',
    districtId: '7101023',
    name: 'Dumoga II',
  },
  {
    id: '7101023018',
    districtId: '7101023',
    name: 'Pinonobatuan Barat',
  },
  {
    id: '7101023019',
    districtId: '7101023',
    name: 'Mogoyunggung II',
  },
  {
    id: '7101023020',
    districtId: '7101023',
    name: 'Mogoyunggung I',
  },
  {
    id: '7101023021',
    districtId: '7101023',
    name: 'Amertha Sari',
  },
  {
    id: '7101023022',
    districtId: '7101023',
    name: 'Amertha Buana',
  },
  {
    id: '7101023023',
    districtId: '7101023',
    name: 'Kembang Sari',
  },
  {
    id: '7101023024',
    districtId: '7101023',
    name: 'Dumoga Empat',
  },
  {
    id: '7101023025',
    districtId: '7101023',
    name: 'Dumoga Tiga',
  },
  {
    id: '7101024001',
    districtId: '7101024',
    name: 'Kosio',
  },
  {
    id: '7101024002',
    districtId: '7101024',
    name: 'Kinomaligan',
  },
  {
    id: '7101024003',
    districtId: '7101024',
    name: 'Ibolian',
  },
  {
    id: '7101024004',
    districtId: '7101024',
    name: 'Ibolian I',
  },
  {
    id: '7101024005',
    districtId: '7101024',
    name: 'Werdhi Agung',
  },
  {
    id: '7101024006',
    districtId: '7101024',
    name: 'Werdhi Agung Timur',
  },
  {
    id: '7101024007',
    districtId: '7101024',
    name: 'Werdhi Agung Utara',
  },
  {
    id: '7101024008',
    districtId: '7101024',
    name: 'Werdhi Agung Selatan',
  },
  {
    id: '7101024009',
    districtId: '7101024',
    name: 'Kosio Timur',
  },
  {
    id: '7101024010',
    districtId: '7101024',
    name: 'Kosio Barat',
  },
  {
    id: '7101025001',
    districtId: '7101025',
    name: 'Tapadaka I',
  },
  {
    id: '7101025002',
    districtId: '7101025',
    name: 'Tapadaka Utara',
  },
  {
    id: '7101025004',
    districtId: '7101025',
    name: 'Konarom',
  },
  {
    id: '7101025007',
    districtId: '7101025',
    name: 'Osion',
  },
  {
    id: '7101025008',
    districtId: '7101025',
    name: 'Dumara',
  },
  {
    id: '7101025009',
    districtId: '7101025',
    name: 'Ikuna',
  },
  {
    id: '7101025010',
    districtId: '7101025',
    name: 'Bonawang',
  },
  {
    id: '7101025011',
    districtId: '7101025',
    name: 'Tapadaka Timur',
  },
  {
    id: '7101025012',
    districtId: '7101025',
    name: 'Konarom Utara',
  },
  {
    id: '7101025013',
    districtId: '7101025',
    name: 'Konarom Barat',
  },
  {
    id: '7101026001',
    districtId: '7101026',
    name: 'Siniyung',
  },
  {
    id: '7101026002',
    districtId: '7101026',
    name: 'Siniyung I',
  },
  {
    id: '7101026003',
    districtId: '7101026',
    name: 'Bumbungon',
  },
  {
    id: '7101026004',
    districtId: '7101026',
    name: 'Serasi',
  },
  {
    id: '7101026005',
    districtId: '7101026',
    name: 'Mototabian',
  },
  {
    id: '7101026006',
    districtId: '7101026',
    name: 'Ponompiaan',
  },
  {
    id: '7101026007',
    districtId: '7101026',
    name: 'Pusian',
  },
  {
    id: '7101026008',
    districtId: '7101026',
    name: 'Kanaan',
  },
  {
    id: '7101026009',
    districtId: '7101026',
    name: 'Toruakat',
  },
  {
    id: '7101026010',
    districtId: '7101026',
    name: 'Dumoga I',
  },
  {
    id: '7101026011',
    districtId: '7101026',
    name: 'Pusian Barat',
  },
  {
    id: '7101026012',
    districtId: '7101026',
    name: 'Pusian Selatan',
  },
  {
    id: '7101060001',
    districtId: '7101060',
    name: 'Mopusi',
  },
  {
    id: '7101060002',
    districtId: '7101060',
    name: 'Matali Baru',
  },
  {
    id: '7101060003',
    districtId: '7101060',
    name: 'Bakan',
  },
  {
    id: '7101060004',
    districtId: '7101060',
    name: 'Tanoyan Selatan',
  },
  {
    id: '7101060005',
    districtId: '7101060',
    name: 'Tanoyan Utara',
  },
  {
    id: '7101060006',
    districtId: '7101060',
    name: 'Lolayan',
  },
  {
    id: '7101060007',
    districtId: '7101060',
    name: 'Tungoi II',
  },
  {
    id: '7101060008',
    districtId: '7101060',
    name: 'Tungoi I',
  },
  {
    id: '7101060009',
    districtId: '7101060',
    name: 'Tapa Aog',
  },
  {
    id: '7101060010',
    districtId: '7101060',
    name: 'Abak',
  },
  {
    id: '7101060011',
    districtId: '7101060',
    name: 'Bombanon',
  },
  {
    id: '7101060012',
    districtId: '7101060',
    name: 'Mopait',
  },
  {
    id: '7101060013',
    districtId: '7101060',
    name: 'Kopandakan II',
  },
  {
    id: '7101060014',
    districtId: '7101060',
    name: 'Mengkang',
  },
  {
    id: '7101081001',
    districtId: '7101081',
    name: 'Muntoi',
  },
  {
    id: '7101081002',
    districtId: '7101081',
    name: 'Inuai',
  },
  {
    id: '7101081003',
    districtId: '7101081',
    name: 'Poyuyanan',
  },
  {
    id: '7101081004',
    districtId: '7101081',
    name: 'Lobong',
  },
  {
    id: '7101081005',
    districtId: '7101081',
    name: 'Passi',
  },
  {
    id: '7101081006',
    districtId: '7101081',
    name: 'Wangga',
  },
  {
    id: '7101081007',
    districtId: '7101081',
    name: 'Otam',
  },
  {
    id: '7101081009',
    districtId: '7101081',
    name: 'Bintau',
  },
  {
    id: '7101081010',
    districtId: '7101081',
    name: 'Passi II',
  },
  {
    id: '7101081011',
    districtId: '7101081',
    name: 'Muntoi Timur',
  },
  {
    id: '7101081012',
    districtId: '7101081',
    name: 'Wangga I',
  },
  {
    id: '7101081013',
    districtId: '7101081',
    name: '0tam Barat',
  },
  {
    id: '7101082003',
    districtId: '7101082',
    name: 'Pangian',
  },
  {
    id: '7101082004',
    districtId: '7101082',
    name: 'Poopo',
  },
  {
    id: '7101082006',
    districtId: '7101082',
    name: 'Manembo',
  },
  {
    id: '7101082007',
    districtId: '7101082',
    name: 'Sinsingon',
  },
  {
    id: '7101082008',
    districtId: '7101082',
    name: 'Mobuya',
  },
  {
    id: '7101082009',
    districtId: '7101082',
    name: 'Insil',
  },
  {
    id: '7101082010',
    districtId: '7101082',
    name: 'Insil Baru',
  },
  {
    id: '7101082011',
    districtId: '7101082',
    name: 'Pangian Tengah',
  },
  {
    id: '7101082012',
    districtId: '7101082',
    name: 'Pangian Barat',
  },
  {
    id: '7101082013',
    districtId: '7101082',
    name: 'Poopo Barat',
  },
  {
    id: '7101082014',
    districtId: '7101082',
    name: 'Poopo Selatan',
  },
  {
    id: '7101082015',
    districtId: '7101082',
    name: 'Sinsingon Barat',
  },
  {
    id: '7101082016',
    districtId: '7101082',
    name: 'Sinsingon Timur',
  },
  {
    id: '7101083001',
    districtId: '7101083',
    name: 'Bilalang III',
  },
  {
    id: '7101083002',
    districtId: '7101083',
    name: 'Bilalang IV',
  },
  {
    id: '7101083003',
    districtId: '7101083',
    name: 'Tuduaog Baru',
  },
  {
    id: '7101083004',
    districtId: '7101083',
    name: 'Tuduaog',
  },
  {
    id: '7101083005',
    districtId: '7101083',
    name: 'Kolingangaan',
  },
  {
    id: '7101083006',
    districtId: '7101083',
    name: 'Bilalang III Utara',
  },
  {
    id: '7101083007',
    districtId: '7101083',
    name: 'Bilalang Baru',
  },
  {
    id: '7101083008',
    districtId: '7101083',
    name: 'Apado',
  },
  {
    id: '7101090001',
    districtId: '7101090',
    name: 'Mariri Dua',
  },
  {
    id: '7101090002',
    districtId: '7101090',
    name: 'Mariri Lama',
  },
  {
    id: '7101090003',
    districtId: '7101090',
    name: 'Mariri Baru',
  },
  {
    id: '7101090004',
    districtId: '7101090',
    name: 'Nonapan Dua',
  },
  {
    id: '7101090005',
    districtId: '7101090',
    name: 'Nonapan Satu',
  },
  {
    id: '7101090006',
    districtId: '7101090',
    name: 'Wineru',
  },
  {
    id: '7101090007',
    districtId: '7101090',
    name: 'Gogaluman',
  },
  {
    id: '7101090008',
    districtId: '7101090',
    name: 'Tiberias',
  },
  {
    id: '7101090009',
    districtId: '7101090',
    name: 'Poigar II',
  },
  {
    id: '7101090010',
    districtId: '7101090',
    name: 'Poigar',
  },
  {
    id: '7101090011',
    districtId: '7101090',
    name: 'Poigar III',
  },
  {
    id: '7101090012',
    districtId: '7101090',
    name: 'Pomoman',
  },
  {
    id: '7101090013',
    districtId: '7101090',
    name: 'Nanasi',
  },
  {
    id: '7101090014',
    districtId: '7101090',
    name: 'Mondatong',
  },
  {
    id: '7101090015',
    districtId: '7101090',
    name: 'Mariri I',
  },
  {
    id: '7101090016',
    districtId: '7101090',
    name: 'Nonapan Baru',
  },
  {
    id: '7101090017',
    districtId: '7101090',
    name: 'Nanasi Timur',
  },
  {
    id: '7101090018',
    districtId: '7101090',
    name: 'Tanjung Mariri',
  },
  {
    id: '7101090019',
    districtId: '7101090',
    name: 'Nonapan',
  },
  {
    id: '7101090020',
    districtId: '7101090',
    name: 'Mondatong Baru',
  },
  {
    id: '7101100001',
    districtId: '7101100',
    name: 'Komangaan',
  },
  {
    id: '7101100002',
    districtId: '7101100',
    name: 'Solimandungan Dua',
  },
  {
    id: '7101100003',
    districtId: '7101100',
    name: 'Solimandungan Satu',
  },
  {
    id: '7101100004',
    districtId: '7101100',
    name: 'Bangomolunow',
  },
  {
    id: '7101100005',
    districtId: '7101100',
    name: 'Langagon',
  },
  {
    id: '7101100006',
    districtId: '7101100',
    name: 'Inobonto Satu',
  },
  {
    id: '7101100007',
    districtId: '7101100',
    name: 'Inobonto Dua',
  },
  {
    id: '7101100008',
    districtId: '7101100',
    name: 'Inobonto',
  },
  {
    id: '7101100009',
    districtId: '7101100',
    name: 'Solimandungan Baru',
  },
  {
    id: '7101100010',
    districtId: '7101100',
    name: 'Langagon II',
  },
  {
    id: '7101100011',
    districtId: '7101100',
    name: 'Langagon I',
  },
  {
    id: '7101101001',
    districtId: '7101101',
    name: 'Ambang II',
  },
  {
    id: '7101101002',
    districtId: '7101101',
    name: 'Ambang I',
  },
  {
    id: '7101101003',
    districtId: '7101101',
    name: 'Tadoy',
  },
  {
    id: '7101101004',
    districtId: '7101101',
    name: 'Tadoy I',
  },
  {
    id: '7101101005',
    districtId: '7101101',
    name: 'Bolaang',
  },
  {
    id: '7101101006',
    districtId: '7101101',
    name: 'Bantik',
  },
  {
    id: '7101101007',
    districtId: '7101101',
    name: 'Lolan',
  },
  {
    id: '7101101008',
    districtId: '7101101',
    name: 'Bolaang I',
  },
  {
    id: '7101101009',
    districtId: '7101101',
    name: 'Lolan II',
  },
  {
    id: '7101110002',
    districtId: '7101110',
    name: 'Buntalo',
  },
  {
    id: '7101110003',
    districtId: '7101110',
    name: 'Totabuan',
  },
  {
    id: '7101110004',
    districtId: '7101110',
    name: 'Solog',
  },
  {
    id: '7101110005',
    districtId: '7101110',
    name: 'Tandu',
  },
  {
    id: '7101110006',
    districtId: '7101110',
    name: 'Tuyat',
  },
  {
    id: '7101110007',
    districtId: '7101110',
    name: 'Lalow',
  },
  {
    id: '7101110008',
    districtId: '7101110',
    name: 'Lolak',
  },
  {
    id: '7101110009',
    districtId: '7101110',
    name: 'Motabang',
  },
  {
    id: '7101110010',
    districtId: '7101110',
    name: 'Mongkoinit',
  },
  {
    id: '7101110011',
    districtId: '7101110',
    name: 'Pinogaluman',
  },
  {
    id: '7101110012',
    districtId: '7101110',
    name: 'Baturapa',
  },
  {
    id: '7101110013',
    districtId: '7101110',
    name: 'Labuhan Uki',
  },
  {
    id: '7101110014',
    districtId: '7101110',
    name: 'Sauk',
  },
  {
    id: '7101110015',
    districtId: '7101110',
    name: 'Pindol',
  },
  {
    id: '7101110016',
    districtId: '7101110',
    name: 'Pindolili',
  },
  {
    id: '7101110017',
    districtId: '7101110',
    name: 'Lolak Tombolango',
  },
  {
    id: '7101110018',
    districtId: '7101110',
    name: 'Lolak II',
  },
  {
    id: '7101110019',
    districtId: '7101110',
    name: 'Baturapa II',
  },
  {
    id: '7101110020',
    districtId: '7101110',
    name: 'Buntalo Timur',
  },
  {
    id: '7101110021',
    districtId: '7101110',
    name: 'Buntalo Selatan',
  },
  {
    id: '7101110022',
    districtId: '7101110',
    name: 'Diat',
  },
  {
    id: '7101110023',
    districtId: '7101110',
    name: 'Pinogaluman Timur',
  },
  {
    id: '7101110024',
    districtId: '7101110',
    name: 'Padang Lalow',
  },
  {
    id: '7101110025',
    districtId: '7101110',
    name: 'Dulangon',
  },
  {
    id: '7101110026',
    districtId: '7101110',
    name: 'Mongkoinit Barat',
  },
  {
    id: '7101120008',
    districtId: '7101120',
    name: 'Pangi',
  },
  {
    id: '7101120009',
    districtId: '7101120',
    name: 'Domisil Moonow',
  },
  {
    id: '7101120010',
    districtId: '7101120',
    name: 'Maelang',
  },
  {
    id: '7101120011',
    districtId: '7101120',
    name: 'Lolanan',
  },
  {
    id: '7101120012',
    districtId: '7101120',
    name: 'Bolangat',
  },
  {
    id: '7101120013',
    districtId: '7101120',
    name: 'Babo',
  },
  {
    id: '7101120014',
    districtId: '7101120',
    name: 'Ayong',
  },
  {
    id: '7101120015',
    districtId: '7101120',
    name: 'Cempaka',
  },
  {
    id: '7101120018',
    districtId: '7101120',
    name: 'Batu Merah',
  },
  {
    id: '7101120019',
    districtId: '7101120',
    name: 'Pasir Putih',
  },
  {
    id: '7101120020',
    districtId: '7101120',
    name: 'Bolangat Timur',
  },
  {
    id: '7101120021',
    districtId: '7101120',
    name: 'Pangi Timur',
  },
  {
    id: '7102091007',
    districtId: '7102091',
    name: 'Wolaang',
  },
  {
    id: '7102091008',
    districtId: '7102091',
    name: 'Waleure',
  },
  {
    id: '7102091009',
    districtId: '7102091',
    name: 'Amongena Dua',
  },
  {
    id: '7102091010',
    districtId: '7102091',
    name: 'Amongena Satu',
  },
  {
    id: '7102091011',
    districtId: '7102091',
    name: 'Karondoran',
  },
  {
    id: '7102091012',
    districtId: '7102091',
    name: 'Sumarayar',
  },
  {
    id: '7102091013',
    districtId: '7102091',
    name: 'Amongena III',
  },
  {
    id: '7102092003',
    districtId: '7102092',
    name: 'Tounelet',
  },
  {
    id: '7102092004',
    districtId: '7102092',
    name: 'Koyawas',
  },
  {
    id: '7102092005',
    districtId: '7102092',
    name: 'Walewangko',
  },
  {
    id: '7102092006',
    districtId: '7102092',
    name: 'Noongan',
  },
  {
    id: '7102092007',
    districtId: '7102092',
    name: 'Raringis',
  },
  {
    id: '7102092008',
    districtId: '7102092',
    name: 'Ampreng',
  },
  {
    id: '7102092009',
    districtId: '7102092',
    name: 'Paslaten',
  },
  {
    id: '7102092010',
    districtId: '7102092',
    name: 'Kopiwangker',
  },
  {
    id: '7102092011',
    districtId: '7102092',
    name: 'Lowian',
  },
  {
    id: '7102092014',
    districtId: '7102092',
    name: 'Tumaratas',
  },
  {
    id: '7102092015',
    districtId: '7102092',
    name: 'Tumaratas Dua',
  },
  {
    id: '7102092016',
    districtId: '7102092',
    name: 'Noongan Dua',
  },
  {
    id: '7102092017',
    districtId: '7102092',
    name: 'Noongan Tiga',
  },
  {
    id: '7102092018',
    districtId: '7102092',
    name: 'Raranon',
  },
  {
    id: '7102092019',
    districtId: '7102092',
    name: 'Raringis Selatan',
  },
  {
    id: '7102092020',
    districtId: '7102092',
    name: 'Raringis Utara',
  },
  {
    id: '7102093001',
    districtId: '7102093',
    name: 'Rumbia',
  },
  {
    id: '7102093002',
    districtId: '7102093',
    name: 'Temboan',
  },
  {
    id: '7102093003',
    districtId: '7102093',
    name: 'Palamba',
  },
  {
    id: '7102093004',
    districtId: '7102093',
    name: 'Atep',
  },
  {
    id: '7102093005',
    districtId: '7102093',
    name: 'Manembo',
  },
  {
    id: '7102093006',
    districtId: '7102093',
    name: 'Winebetan',
  },
  {
    id: '7102093007',
    districtId: '7102093',
    name: 'Kaayuran Atas',
  },
  {
    id: '7102093008',
    districtId: '7102093',
    name: 'Kaayuran Bawah',
  },
  {
    id: '7102093009',
    districtId: '7102093',
    name: 'Kawatak',
  },
  {
    id: '7102093010',
    districtId: '7102093',
    name: 'Atep Satu',
  },
  {
    id: '7102094001',
    districtId: '7102094',
    name: 'Walantakan',
  },
  {
    id: '7102094002',
    districtId: '7102094',
    name: 'Taraitak',
  },
  {
    id: '7102094003',
    districtId: '7102094',
    name: 'Toraget',
  },
  {
    id: '7102094004',
    districtId: '7102094',
    name: 'Karumenga',
  },
  {
    id: '7102094005',
    districtId: '7102094',
    name: 'Tempang',
  },
  {
    id: '7102094006',
    districtId: '7102094',
    name: 'Tempang Dua',
  },
  {
    id: '7102094007',
    districtId: '7102094',
    name: 'Tempang Tiga',
  },
  {
    id: '7102094008',
    districtId: '7102094',
    name: 'Taraitak I',
  },
  {
    id: '7102110004',
    districtId: '7102110',
    name: 'Kamanga',
  },
  {
    id: '7102110006',
    districtId: '7102110',
    name: 'Liba',
  },
  {
    id: '7102110007',
    districtId: '7102110',
    name: 'Sendangan II',
  },
  {
    id: '7102110008',
    districtId: '7102110',
    name: 'Talikuran',
  },
  {
    id: '7102110010',
    districtId: '7102110',
    name: 'Tempok',
  },
  {
    id: '7102110011',
    districtId: '7102110',
    name: 'Tolok',
  },
  {
    id: '7102110013',
    districtId: '7102110',
    name: 'Kamanga Satu',
  },
  {
    id: '7102110018',
    districtId: '7102110',
    name: 'Tempok Selatan',
  },
  {
    id: '7102110019',
    districtId: '7102110',
    name: 'Tolok Satu',
  },
  {
    id: '7102111001',
    districtId: '7102111',
    name: 'Pinabetengan',
  },
  {
    id: '7102111002',
    districtId: '7102111',
    name: 'Tonsewer',
  },
  {
    id: '7102111003',
    districtId: '7102111',
    name: 'Touure',
  },
  {
    id: '7102111004',
    districtId: '7102111',
    name: 'Tompaso Dua',
  },
  {
    id: '7102111005',
    districtId: '7102111',
    name: 'Pinabetengan Utara',
  },
  {
    id: '7102111006',
    districtId: '7102111',
    name: 'Tonsewer Selatan',
  },
  {
    id: '7102111007',
    districtId: '7102111',
    name: 'Touure Dua',
  },
  {
    id: '7102111008',
    districtId: '7102111',
    name: 'Pinabetengan Selatan',
  },
  {
    id: '7102111009',
    districtId: '7102111',
    name: 'Tompaso II Utara',
  },
  {
    id: '7102111010',
    districtId: '7102111',
    name: 'Pinaesaan',
  },
  {
    id: '7102120010',
    districtId: '7102120',
    name: 'Sendangan Tengah',
  },
  {
    id: '7102120012',
    districtId: '7102120',
    name: 'Kinali',
  },
  {
    id: '7102120013',
    districtId: '7102120',
    name: 'Tondegesan',
  },
  {
    id: '7102120015',
    districtId: '7102120',
    name: 'Kanonang Tiga',
  },
  {
    id: '7102120025',
    districtId: '7102120',
    name: 'Sendangan Selatan',
  },
  {
    id: '7102120026',
    districtId: '7102120',
    name: 'Sendangan',
  },
  {
    id: '7102120027',
    districtId: '7102120',
    name: 'Uner Satu',
  },
  {
    id: '7102120028',
    districtId: '7102120',
    name: 'Kinali Satu',
  },
  {
    id: '7102120029',
    districtId: '7102120',
    name: 'Tondegesan Satu',
  },
  {
    id: '7102120030',
    districtId: '7102120',
    name: 'Tondegesan Dua',
  },
  {
    id: '7102121001',
    districtId: '7102121',
    name: 'Ranolambot',
  },
  {
    id: '7102121002',
    districtId: '7102121',
    name: 'Tombasian Atas',
  },
  {
    id: '7102121003',
    districtId: '7102121',
    name: 'Kanonang Dua',
  },
  {
    id: '7102121004',
    districtId: '7102121',
    name: 'Kanonang Empat',
  },
  {
    id: '7102121005',
    districtId: '7102121',
    name: 'Kanonang Lima',
  },
  {
    id: '7102121006',
    districtId: '7102121',
    name: 'Kanonang Satu',
  },
  {
    id: '7102121007',
    districtId: '7102121',
    name: 'Tombasian Atas Satu',
  },
  {
    id: '7102121008',
    districtId: '7102121',
    name: 'Tombasian Bawah',
  },
  {
    id: '7102121009',
    districtId: '7102121',
    name: 'Kayuuwi Satu',
  },
  {
    id: '7102121010',
    districtId: '7102121',
    name: 'Kayuuwi',
  },
  {
    id: '7102122001',
    districtId: '7102122',
    name: 'Talikuran Barat',
  },
  {
    id: '7102122002',
    districtId: '7102122',
    name: 'Talikuran',
  },
  {
    id: '7102122003',
    districtId: '7102122',
    name: 'Talikuran Utara',
  },
  {
    id: '7102122004',
    districtId: '7102122',
    name: 'Kiawa Satu',
  },
  {
    id: '7102122005',
    districtId: '7102122',
    name: 'Kiawa Satu Barat',
  },
  {
    id: '7102122006',
    districtId: '7102122',
    name: 'Kiawa Satu Utara',
  },
  {
    id: '7102122007',
    districtId: '7102122',
    name: 'Kiawa Dua',
  },
  {
    id: '7102122008',
    districtId: '7102122',
    name: 'Kiawa Dua Barat',
  },
  {
    id: '7102122009',
    districtId: '7102122',
    name: 'Kiawa Dua Timur',
  },
  {
    id: '7102130001',
    districtId: '7102130',
    name: 'Timbukar',
  },
  {
    id: '7102130002',
    districtId: '7102130',
    name: 'Tincep',
  },
  {
    id: '7102130003',
    districtId: '7102130',
    name: 'Kauneran',
  },
  {
    id: '7102130004',
    districtId: '7102130',
    name: 'Sendangan',
  },
  {
    id: '7102130005',
    districtId: '7102130',
    name: 'Kolongan Atas',
  },
  {
    id: '7102130006',
    districtId: '7102130',
    name: 'Leilem',
  },
  {
    id: '7102130007',
    districtId: '7102130',
    name: 'Tounelet',
  },
  {
    id: '7102130008',
    districtId: '7102130',
    name: 'Talikuran',
  },
  {
    id: '7102130009',
    districtId: '7102130',
    name: 'Rambunan',
  },
  {
    id: '7102130010',
    districtId: '7102130',
    name: 'Sawangan',
  },
  {
    id: '7102130011',
    districtId: '7102130',
    name: 'Kolongan Atas Dua',
  },
  {
    id: '7102130012',
    districtId: '7102130',
    name: 'Leilem Dua',
  },
  {
    id: '7102130013',
    districtId: '7102130',
    name: 'Leilem Tiga',
  },
  {
    id: '7102130014',
    districtId: '7102130',
    name: 'Kauneran Satu',
  },
  {
    id: '7102130015',
    districtId: '7102130',
    name: 'Sendangan I',
  },
  {
    id: '7102130016',
    districtId: '7102130',
    name: 'Kolongan Atas I',
  },
  {
    id: '7102130017',
    districtId: '7102130',
    name: 'Tounelet Satu',
  },
  {
    id: '7102130018',
    districtId: '7102130',
    name: 'Talikuran Satu',
  },
  {
    id: '7102130019',
    districtId: '7102130',
    name: 'Rambunan Amian',
  },
  {
    id: '7102160001',
    districtId: '7102160',
    name: 'Pinasungkulan',
  },
  {
    id: '7102160003',
    districtId: '7102160',
    name: 'Teling',
  },
  {
    id: '7102160004',
    districtId: '7102160',
    name: 'Poopoh',
  },
  {
    id: '7102160005',
    districtId: '7102160',
    name: 'Ranowangko',
  },
  {
    id: '7102160010',
    districtId: '7102160',
    name: 'Sarani Matani',
  },
  {
    id: '7102160011',
    districtId: '7102160',
    name: 'Borgo',
  },
  {
    id: '7102160012',
    districtId: '7102160',
    name: 'Tambala',
  },
  {
    id: '7102160014',
    districtId: '7102160',
    name: 'Mokupa',
  },
  {
    id: '7102161001',
    districtId: '7102161',
    name: 'Ranotongkor',
  },
  {
    id: '7102161002',
    districtId: '7102161',
    name: 'Lolah Satu',
  },
  {
    id: '7102161003',
    districtId: '7102161',
    name: 'Lolah Dua',
  },
  {
    id: '7102161004',
    districtId: '7102161',
    name: 'Lemoh',
  },
  {
    id: '7102161005',
    districtId: '7102161',
    name: 'Lemoh Timur',
  },
  {
    id: '7102161006',
    districtId: '7102161',
    name: 'Lemoh Barat',
  },
  {
    id: '7102161007',
    districtId: '7102161',
    name: 'Ranotongkor Timur',
  },
  {
    id: '7102161008',
    districtId: '7102161',
    name: 'Lolah Tiga',
  },
  {
    id: '7102161009',
    districtId: '7102161',
    name: 'Lolah',
  },
  {
    id: '7102161010',
    districtId: '7102161',
    name: 'Lemoh Uner',
  },
  {
    id: '7102170002',
    districtId: '7102170',
    name: 'Warembungan',
  },
  {
    id: '7102170003',
    districtId: '7102170',
    name: 'Pineleng Dua',
  },
  {
    id: '7102170004',
    districtId: '7102170',
    name: 'Kali',
  },
  {
    id: '7102170011',
    districtId: '7102170',
    name: 'Pineleng Satu',
  },
  {
    id: '7102170012',
    districtId: '7102170',
    name: 'Sea',
  },
  {
    id: '7102170018',
    districtId: '7102170',
    name: 'Sea I',
  },
  {
    id: '7102170019',
    districtId: '7102170',
    name: 'Sea II',
  },
  {
    id: '7102170020',
    districtId: '7102170',
    name: 'Winangun Atas',
  },
  {
    id: '7102170027',
    districtId: '7102170',
    name: 'Sea Mitra',
  },
  {
    id: '7102170028',
    districtId: '7102170',
    name: 'Sea Tumpengan',
  },
  {
    id: '7102170029',
    districtId: '7102170',
    name: 'Pineleng Dua Indah',
  },
  {
    id: '7102170030',
    districtId: '7102170',
    name: 'Lotta',
  },
  {
    id: '7102170031',
    districtId: '7102170',
    name: 'Pineleng Satu Timur',
  },
  {
    id: '7102170032',
    districtId: '7102170',
    name: 'Kali Selatan',
  },
  {
    id: '7102171001',
    districtId: '7102171',
    name: 'Kembes Dua',
  },
  {
    id: '7102171002',
    districtId: '7102171',
    name: 'Kembes Satu',
  },
  {
    id: '7102171003',
    districtId: '7102171',
    name: 'Tombuluan',
  },
  {
    id: '7102171004',
    districtId: '7102171',
    name: 'Kamangta',
  },
  {
    id: '7102171005',
    districtId: '7102171',
    name: 'Sawangan',
  },
  {
    id: '7102171006',
    districtId: '7102171',
    name: 'Koka',
  },
  {
    id: '7102171007',
    districtId: '7102171',
    name: 'Suluan',
  },
  {
    id: '7102171008',
    districtId: '7102171',
    name: 'Rumengkor',
  },
  {
    id: '7102171009',
    districtId: '7102171',
    name: 'Tikela',
  },
  {
    id: '7102171010',
    districtId: '7102171',
    name: 'Rumengkor Satu',
  },
  {
    id: '7102171011',
    districtId: '7102171',
    name: 'Rumengkor Dua',
  },
  {
    id: '7102172001',
    districtId: '7102172',
    name: 'Agotey',
  },
  {
    id: '7102172002',
    districtId: '7102172',
    name: 'Koha',
  },
  {
    id: '7102172003',
    districtId: '7102172',
    name: 'Tateli Weru',
  },
  {
    id: '7102172004',
    districtId: '7102172',
    name: 'Tateli',
  },
  {
    id: '7102172005',
    districtId: '7102172',
    name: 'Kalasey Dua',
  },
  {
    id: '7102172006',
    districtId: '7102172',
    name: 'Kalasey Satu',
  },
  {
    id: '7102172007',
    districtId: '7102172',
    name: 'Tateli Satu',
  },
  {
    id: '7102172008',
    districtId: '7102172',
    name: 'Tateli Dua',
  },
  {
    id: '7102172009',
    districtId: '7102172',
    name: 'Tateli Tiga',
  },
  {
    id: '7102172010',
    districtId: '7102172',
    name: 'Koha Timur',
  },
  {
    id: '7102172011',
    districtId: '7102172',
    name: 'Koha Barat',
  },
  {
    id: '7102172012',
    districtId: '7102172',
    name: 'Koha Selatan',
  },
  {
    id: '7102190007',
    districtId: '7102190',
    name: 'Masarang',
  },
  {
    id: '7102190009',
    districtId: '7102190',
    name: 'Roong',
  },
  {
    id: '7102190010',
    districtId: '7102190',
    name: 'Rinegetan',
  },
  {
    id: '7102190011',
    districtId: '7102190',
    name: 'Tounkuramber',
  },
  {
    id: '7102190012',
    districtId: '7102190',
    name: 'Wawalintouan',
  },
  {
    id: '7102190013',
    districtId: '7102190',
    name: 'Rerewokan',
  },
  {
    id: '7102190014',
    districtId: '7102190',
    name: 'Watulambot',
  },
  {
    id: '7102191001',
    districtId: '7102191',
    name: 'Urongo',
  },
  {
    id: '7102191002',
    districtId: '7102191',
    name: 'Peleloan',
  },
  {
    id: '7102191003',
    districtId: '7102191',
    name: 'Tounsaru',
  },
  {
    id: '7102191004',
    districtId: '7102191',
    name: 'Koya',
  },
  {
    id: '7102191005',
    districtId: '7102191',
    name: 'Tataaran Satu',
  },
  {
    id: '7102191006',
    districtId: '7102191',
    name: 'Tataaran Patar',
  },
  {
    id: '7102191007',
    districtId: '7102191',
    name: 'Tataaran Dua',
  },
  {
    id: '7102191008',
    districtId: '7102191',
    name: 'Maesa Unima',
  },
  {
    id: '7102200001',
    districtId: '7102200',
    name: 'Pulutan',
  },
  {
    id: '7102200002',
    districtId: '7102200',
    name: 'Sinuian',
  },
  {
    id: '7102200003',
    districtId: '7102200',
    name: 'Kaima',
  },
  {
    id: '7102200004',
    districtId: '7102200',
    name: 'Parepey',
  },
  {
    id: '7102200005',
    districtId: '7102200',
    name: 'Kasuratan',
  },
  {
    id: '7102200006',
    districtId: '7102200',
    name: 'Sendangan',
  },
  {
    id: '7102200007',
    districtId: '7102200',
    name: 'Timu',
  },
  {
    id: '7102200008',
    districtId: '7102200',
    name: 'Tampusu',
  },
  {
    id: '7102200009',
    districtId: '7102200',
    name: 'Talikuran',
  },
  {
    id: '7102200010',
    districtId: '7102200',
    name: 'Paslaten',
  },
  {
    id: '7102200011',
    districtId: '7102200',
    name: 'Leleko',
  },
  {
    id: '7102210004',
    districtId: '7102210',
    name: 'Kayuwatu',
  },
  {
    id: '7102210005',
    districtId: '7102210',
    name: 'Wineru',
  },
  {
    id: '7102210006',
    districtId: '7102210',
    name: 'Rinondor',
  },
  {
    id: '7102210014',
    districtId: '7102210',
    name: 'Tounelet',
  },
  {
    id: '7102210015',
    districtId: '7102210',
    name: 'Talikuran',
  },
  {
    id: '7102210016',
    districtId: '7102210',
    name: 'Pahaleten',
  },
  {
    id: '7102210017',
    districtId: '7102210',
    name: 'Sendangan',
  },
  {
    id: '7102210018',
    districtId: '7102210',
    name: 'Paslaten',
  },
  {
    id: '7102210019',
    districtId: '7102210',
    name: 'Kaweng',
  },
  {
    id: '7102210020',
    districtId: '7102210',
    name: 'Toulimembet',
  },
  {
    id: '7102210021',
    districtId: '7102210',
    name: 'Mahembang',
  },
  {
    id: '7102210022',
    districtId: '7102210',
    name: 'Tumpaan',
  },
  {
    id: '7102210023',
    districtId: '7102210',
    name: 'Makalelon',
  },
  {
    id: '7102211001',
    districtId: '7102211',
    name: 'Bukittinggi',
  },
  {
    id: '7102211002',
    districtId: '7102211',
    name: 'Wailang',
  },
  {
    id: '7102211003',
    districtId: '7102211',
    name: 'Simbel',
  },
  {
    id: '7102211004',
    districtId: '7102211',
    name: 'Touliang',
  },
  {
    id: '7102211005',
    districtId: '7102211',
    name: 'Wasian',
  },
  {
    id: '7102211006',
    districtId: '7102211',
    name: 'Kalawiran',
  },
  {
    id: '7102211007',
    districtId: '7102211',
    name: 'Panasen',
  },
  {
    id: '7102211008',
    districtId: '7102211',
    name: 'Totolan',
  },
  {
    id: '7102211009',
    districtId: '7102211',
    name: 'Tountimomor',
  },
  {
    id: '7102211010',
    districtId: '7102211',
    name: 'Passo',
  },
  {
    id: '7102220001',
    districtId: '7102220',
    name: 'Kaleosan',
  },
  {
    id: '7102220002',
    districtId: '7102220',
    name: 'Karor',
  },
  {
    id: '7102220003',
    districtId: '7102220',
    name: 'Watulaney',
  },
  {
    id: '7102220004',
    districtId: '7102220',
    name: 'Kayuroya',
  },
  {
    id: '7102220005',
    districtId: '7102220',
    name: 'Atep Oki',
  },
  {
    id: '7102220006',
    districtId: '7102220',
    name: 'Kapataran',
  },
  {
    id: '7102220007',
    districtId: '7102220',
    name: 'Seretan',
  },
  {
    id: '7102220008',
    districtId: '7102220',
    name: 'Parentek',
  },
  {
    id: '7102220009',
    districtId: '7102220',
    name: 'Kapataran Satu',
  },
  {
    id: '7102220010',
    districtId: '7102220',
    name: 'Seretan Timu',
  },
  {
    id: '7102220011',
    districtId: '7102220',
    name: 'Watulaney Amian',
  },
  {
    id: '7102230001',
    districtId: '7102230',
    name: 'Telap',
  },
  {
    id: '7102230002',
    districtId: '7102230',
    name: 'Watumea',
  },
  {
    id: '7102230003',
    districtId: '7102230',
    name: 'Eris',
  },
  {
    id: '7102230004',
    districtId: '7102230',
    name: 'Maumbi',
  },
  {
    id: '7102230005',
    districtId: '7102230',
    name: 'Tandengan',
  },
  {
    id: '7102230006',
    districtId: '7102230',
    name: 'Ranomerut',
  },
  {
    id: '7102230007',
    districtId: '7102230',
    name: 'Touliang Oki',
  },
  {
    id: '7102230008',
    districtId: '7102230',
    name: 'Tandengan Satu',
  },
  {
    id: '7102240001',
    districtId: '7102240',
    name: 'Tulap',
  },
  {
    id: '7102240002',
    districtId: '7102240',
    name: 'Kayu Besi',
  },
  {
    id: '7102240003',
    districtId: '7102240',
    name: 'Lalumpe',
  },
  {
    id: '7102240004',
    districtId: '7102240',
    name: 'Ranowangko Dua',
  },
  {
    id: '7102240005',
    districtId: '7102240',
    name: 'Kombi',
  },
  {
    id: '7102240006',
    districtId: '7102240',
    name: 'Sawangan',
  },
  {
    id: '7102240007',
    districtId: '7102240',
    name: 'Kolongan',
  },
  {
    id: '7102240009',
    districtId: '7102240',
    name: 'Makalisung',
  },
  {
    id: '7102240010',
    districtId: '7102240',
    name: 'Kalawiran',
  },
  {
    id: '7102240011',
    districtId: '7102240',
    name: 'Kinaleosan',
  },
  {
    id: '7102240012',
    districtId: '7102240',
    name: 'Kolongan Satu',
  },
  {
    id: '7102240013',
    districtId: '7102240',
    name: 'Rerer Satu',
  },
  {
    id: '7102250001',
    districtId: '7102250',
    name: 'Toulour',
  },
  {
    id: '7102250002',
    districtId: '7102250',
    name: 'Kiniar',
  },
  {
    id: '7102250003',
    districtId: '7102250',
    name: 'Taler',
  },
  {
    id: '7102250004',
    districtId: '7102250',
    name: 'Liningaan',
  },
  {
    id: '7102250005',
    districtId: '7102250',
    name: 'Katinggolan',
  },
  {
    id: '7102250006',
    districtId: '7102250',
    name: 'Kendis',
  },
  {
    id: '7102250007',
    districtId: '7102250',
    name: 'Wengkol',
  },
  {
    id: '7102250008',
    districtId: '7102250',
    name: 'Ranowangko',
  },
  {
    id: '7102250009',
    districtId: '7102250',
    name: 'Luaan',
  },
  {
    id: '7102250013',
    districtId: '7102250',
    name: 'Papakelan',
  },
  {
    id: '7102250014',
    districtId: '7102250',
    name: 'Makalonsouw',
  },
  {
    id: '7102251001',
    districtId: '7102251',
    name: 'Sumalangka',
  },
  {
    id: '7102251002',
    districtId: '7102251',
    name: 'Sasaran',
  },
  {
    id: '7102251003',
    districtId: '7102251',
    name: 'Kembuan',
  },
  {
    id: '7102251004',
    districtId: '7102251',
    name: 'Tonsea Lama',
  },
  {
    id: '7102251005',
    districtId: '7102251',
    name: 'Kampung Jawa',
  },
  {
    id: '7102251006',
    districtId: '7102251',
    name: 'Wulauan',
  },
  {
    id: '7102251007',
    districtId: '7102251',
    name: 'Marawas',
  },
  {
    id: '7102251008',
    districtId: '7102251',
    name: 'Kembuan Satu',
  },
  {
    id: '7103040005',
    districtId: '7103040',
    name: 'Bebalang',
  },
  {
    id: '7103040006',
    districtId: '7103040',
    name: 'Batunderang',
  },
  {
    id: '7103040007',
    districtId: '7103040',
    name: 'Ngalipaeng Dua',
  },
  {
    id: '7103040008',
    districtId: '7103040',
    name: 'Ngalipaeng Satu',
  },
  {
    id: '7103040009',
    districtId: '7103040',
    name: 'Sowaeng',
  },
  {
    id: '7103040010',
    districtId: '7103040',
    name: 'Lapango',
  },
  {
    id: '7103040011',
    districtId: '7103040',
    name: 'Laine',
  },
  {
    id: '7103040012',
    districtId: '7103040',
    name: 'Kaluwatu',
  },
  {
    id: '7103040013',
    districtId: '7103040',
    name: 'Mawira',
  },
  {
    id: '7103040014',
    districtId: '7103040',
    name: 'Lapepahe',
  },
  {
    id: '7103040015',
    districtId: '7103040',
    name: 'Pindang',
  },
  {
    id: '7103040016',
    districtId: '7103040',
    name: 'Lehimi Tariang',
  },
  {
    id: '7103040017',
    districtId: '7103040',
    name: 'Lapango I',
  },
  {
    id: '7103041001',
    districtId: '7103041',
    name: 'Para',
  },
  {
    id: '7103041002',
    districtId: '7103041',
    name: 'Mahengetang',
  },
  {
    id: '7103041003',
    districtId: '7103041',
    name: 'Kahakitang',
  },
  {
    id: '7103041004',
    districtId: '7103041',
    name: 'Kalama',
  },
  {
    id: '7103041005',
    districtId: '7103041',
    name: 'Dalako Bembanahe',
  },
  {
    id: '7103041006',
    districtId: '7103041',
    name: 'Taleko Batusaiki',
  },
  {
    id: '7103041007',
    districtId: '7103041',
    name: 'Para I',
  },
  {
    id: '7103050001',
    districtId: '7103050',
    name: 'Mahumu',
  },
  {
    id: '7103050002',
    districtId: '7103050',
    name: 'Makalekuhe',
  },
  {
    id: '7103050004',
    districtId: '7103050',
    name: 'Kalinda',
  },
  {
    id: '7103050005',
    districtId: '7103050',
    name: 'Pananaru',
  },
  {
    id: '7103050006',
    districtId: '7103050',
    name: 'Dagho',
  },
  {
    id: '7103050007',
    districtId: '7103050',
    name: 'Menggawa I',
  },
  {
    id: '7103050008',
    districtId: '7103050',
    name: 'Pokol',
  },
  {
    id: '7103050009',
    districtId: '7103050',
    name: 'Balane',
  },
  {
    id: '7103050010',
    districtId: '7103050',
    name: 'Binala',
  },
  {
    id: '7103050011',
    districtId: '7103050',
    name: 'Nagha Satu',
  },
  {
    id: '7103050012',
    districtId: '7103050',
    name: 'Nagha Dua',
  },
  {
    id: '7103050013',
    districtId: '7103050',
    name: 'Ulungpeliang',
  },
  {
    id: '7103050014',
    districtId: '7103050',
    name: 'Lelipang',
  },
  {
    id: '7103050015',
    districtId: '7103050',
    name: 'Menggawa II',
  },
  {
    id: '7103050016',
    districtId: '7103050',
    name: 'Kalama Darat',
  },
  {
    id: '7103050017',
    districtId: '7103050',
    name: 'Mahumu I',
  },
  {
    id: '7103050018',
    districtId: '7103050',
    name: 'Mahumu II',
  },
  {
    id: '7103050019',
    districtId: '7103050',
    name: 'Kalinda I',
  },
  {
    id: '7103050020',
    districtId: '7103050',
    name: 'Hesang',
  },
  {
    id: '7103060006',
    districtId: '7103060',
    name: 'Mandoi',
  },
  {
    id: '7103060008',
    districtId: '7103060',
    name: 'Malamenggu',
  },
  {
    id: '7103060009',
    districtId: '7103060',
    name: 'Birahi',
  },
  {
    id: '7103060010',
    districtId: '7103060',
    name: 'Binebas',
  },
  {
    id: '7103060012',
    districtId: '7103060',
    name: 'Palareng',
  },
  {
    id: '7103060013',
    districtId: '7103060',
    name: 'Batuwingkung',
  },
  {
    id: '7103060014',
    districtId: '7103060',
    name: 'Lesabe',
  },
  {
    id: '7103060016',
    districtId: '7103060',
    name: 'Simueng',
  },
  {
    id: '7103060017',
    districtId: '7103060',
    name: 'Bukide',
  },
  {
    id: '7103060018',
    districtId: '7103060',
    name: 'Laotongan',
  },
  {
    id: '7103060019',
    districtId: '7103060',
    name: 'Bulo',
  },
  {
    id: '7103060020',
    districtId: '7103060',
    name: 'Lesabe I',
  },
  {
    id: '7103060021',
    districtId: '7103060',
    name: 'Kalagheng',
  },
  {
    id: '7103061002',
    districtId: '7103061',
    name: 'Tambung',
  },
  {
    id: '7103061004',
    districtId: '7103061',
    name: 'Salurang',
  },
  {
    id: '7103061005',
    districtId: '7103061',
    name: 'Hangke',
  },
  {
    id: '7103061006',
    districtId: '7103061',
    name: 'Bowone',
  },
  {
    id: '7103061007',
    districtId: '7103061',
    name: 'Beeng Laut',
  },
  {
    id: '7103061008',
    districtId: '7103061',
    name: 'Tenda',
  },
  {
    id: '7103061009',
    districtId: '7103061',
    name: 'Aha Patung',
  },
  {
    id: '7103062001',
    districtId: '7103062',
    name: 'Pintareng',
  },
  {
    id: '7103062002',
    districtId: '7103062',
    name: 'Basauh',
  },
  {
    id: '7103062003',
    districtId: '7103062',
    name: 'Tumalede',
  },
  {
    id: '7103062004',
    districtId: '7103062',
    name: 'Dalokaweng',
  },
  {
    id: '7103062005',
    districtId: '7103062',
    name: 'Sampakang',
  },
  {
    id: '7103062006',
    districtId: '7103062',
    name: 'Malisade',
  },
  {
    id: '7103070001',
    districtId: '7103070',
    name: 'Bowongkali',
  },
  {
    id: '7103070002',
    districtId: '7103070',
    name: 'Kulur II',
  },
  {
    id: '7103070003',
    districtId: '7103070',
    name: 'Kulur I',
  },
  {
    id: '7103070004',
    districtId: '7103070',
    name: 'Bira',
  },
  {
    id: '7103070005',
    districtId: '7103070',
    name: 'Kuma',
  },
  {
    id: '7103070006',
    districtId: '7103070',
    name: 'Bungalawang',
  },
  {
    id: '7103070007',
    districtId: '7103070',
    name: 'Miulu',
  },
  {
    id: '7103070009',
    districtId: '7103070',
    name: 'Talengen',
  },
  {
    id: '7103070010',
    districtId: '7103070',
    name: 'Biru',
  },
  {
    id: '7103070011',
    districtId: '7103070',
    name: 'Rendingan',
  },
  {
    id: '7103070012',
    districtId: '7103070',
    name: 'Tariangbaru',
  },
  {
    id: '7103070013',
    districtId: '7103070',
    name: 'Sensong',
  },
  {
    id: '7103070014',
    districtId: '7103070',
    name: 'Palahanaeng',
  },
  {
    id: '7103070015',
    districtId: '7103070',
    name: 'Timbelang',
  },
  {
    id: '7103070016',
    districtId: '7103070',
    name: 'Palelangen',
  },
  {
    id: '7103070017',
    districtId: '7103070',
    name: 'Malueng',
  },
  {
    id: '7103070018',
    districtId: '7103070',
    name: 'Kuma I',
  },
  {
    id: '7103080001',
    districtId: '7103080',
    name: 'Barangkalang',
  },
  {
    id: '7103080002',
    districtId: '7103080',
    name: 'Belengang',
  },
  {
    id: '7103080003',
    districtId: '7103080',
    name: 'Lebo',
  },
  {
    id: '7103080004',
    districtId: '7103080',
    name: 'Sesiwung',
  },
  {
    id: '7103080005',
    districtId: '7103080',
    name: 'Kauhis',
  },
  {
    id: '7103080006',
    districtId: '7103080',
    name: 'Karatung II',
  },
  {
    id: '7103080007',
    districtId: '7103080',
    name: 'Karatung I',
  },
  {
    id: '7103080008',
    districtId: '7103080',
    name: 'Mala',
  },
  {
    id: '7103080009',
    districtId: '7103080',
    name: 'Manumpitaeng',
  },
  {
    id: '7103080010',
    districtId: '7103080',
    name: 'Taloarane',
  },
  {
    id: '7103080011',
    districtId: '7103080',
    name: 'Barangka',
  },
  {
    id: '7103080012',
    districtId: '7103080',
    name: 'Nahepese',
  },
  {
    id: '7103080013',
    districtId: '7103080',
    name: 'Tawoali',
  },
  {
    id: '7103080014',
    districtId: '7103080',
    name: 'Hiung',
  },
  {
    id: '7103080015',
    districtId: '7103080',
    name: 'Bakalaeng',
  },
  {
    id: '7103080016',
    districtId: '7103080',
    name: 'Pinebentengan',
  },
  {
    id: '7103080017',
    districtId: '7103080',
    name: 'Taloarane I',
  },
  {
    id: '7103080018',
    districtId: '7103080',
    name: 'Bengka',
  },
  {
    id: '7103090007',
    districtId: '7103090',
    name: 'Sawang Bendar',
  },
  {
    id: '7103090008',
    districtId: '7103090',
    name: 'Apeng Sembeka',
  },
  {
    id: '7103090009',
    districtId: '7103090',
    name: 'Mahena',
  },
  {
    id: '7103090010',
    districtId: '7103090',
    name: 'Soataloara L',
  },
  {
    id: '7103090011',
    districtId: '7103090',
    name: 'Soataloara Ll',
  },
  {
    id: '7103090012',
    districtId: '7103090',
    name: 'Bungalawang',
  },
  {
    id: '7103090013',
    districtId: '7103090',
    name: 'Manente',
  },
  {
    id: '7103090014',
    districtId: '7103090',
    name: 'Santiago',
  },
  {
    id: '7103091001',
    districtId: '7103091',
    name: 'Lesa',
  },
  {
    id: '7103091002',
    districtId: '7103091',
    name: 'Batulewehe',
  },
  {
    id: '7103091003',
    districtId: '7103091',
    name: 'Tidore',
  },
  {
    id: '7103091004',
    districtId: '7103091',
    name: 'Tona I',
  },
  {
    id: '7103091006',
    districtId: '7103091',
    name: 'Enengpahembang',
  },
  {
    id: '7103091007',
    districtId: '7103091',
    name: 'Tapuang',
  },
  {
    id: '7103091008',
    districtId: '7103091',
    name: 'Tona II',
  },
  {
    id: '7103092001',
    districtId: '7103092',
    name: 'Pananekeng',
  },
  {
    id: '7103092002',
    districtId: '7103092',
    name: 'Angges',
  },
  {
    id: '7103092003',
    districtId: '7103092',
    name: 'Mitung',
  },
  {
    id: '7103092004',
    districtId: '7103092',
    name: 'Beha',
  },
  {
    id: '7103092005',
    districtId: '7103092',
    name: 'Akembawi',
  },
  {
    id: '7103092006',
    districtId: '7103092',
    name: 'Beha Baru',
  },
  {
    id: '7103100001',
    districtId: '7103100',
    name: 'Lenganeng',
  },
  {
    id: '7103100002',
    districtId: '7103100',
    name: 'Tarolang',
  },
  {
    id: '7103100003',
    districtId: '7103100',
    name: 'Tola',
  },
  {
    id: '7103100004',
    districtId: '7103100',
    name: 'Bowongkulu',
  },
  {
    id: '7103100005',
    districtId: '7103100',
    name: 'Petta',
  },
  {
    id: '7103100006',
    districtId: '7103100',
    name: 'Bengketang',
  },
  {
    id: '7103100007',
    districtId: '7103100',
    name: 'Kalurae',
  },
  {
    id: '7103100008',
    districtId: '7103100',
    name: 'Utaurano',
  },
  {
    id: '7103100009',
    districtId: '7103100',
    name: 'Nahasahabe',
  },
  {
    id: '7103100010',
    districtId: '7103100',
    name: 'Beha',
  },
  {
    id: '7103100011',
    districtId: '7103100',
    name: 'Kalekube',
  },
  {
    id: '7103100012',
    districtId: '7103100',
    name: 'Mala',
  },
  {
    id: '7103100013',
    districtId: '7103100',
    name: 'Bahu',
  },
  {
    id: '7103100014',
    districtId: '7103100',
    name: 'Kalasuge',
  },
  {
    id: '7103100020',
    districtId: '7103100',
    name: 'Moade',
  },
  {
    id: '7103100021',
    districtId: '7103100',
    name: 'Petta Timur',
  },
  {
    id: '7103100022',
    districtId: '7103100',
    name: 'Petta Selatan',
  },
  {
    id: '7103100023',
    districtId: '7103100',
    name: 'Petta Barat',
  },
  {
    id: '7103100024',
    districtId: '7103100',
    name: 'Likuang',
  },
  {
    id: '7103100025',
    districtId: '7103100',
    name: 'Raku',
  },
  {
    id: '7103100026',
    districtId: '7103100',
    name: 'Kalekube I',
  },
  {
    id: '7103100027',
    districtId: '7103100',
    name: 'Bowongkulu I',
  },
  {
    id: '7103100028',
    districtId: '7103100',
    name: 'Naha I',
  },
  {
    id: '7103101001',
    districtId: '7103101',
    name: 'Nusa',
  },
  {
    id: '7103101002',
    districtId: '7103101',
    name: 'Nanedakele',
  },
  {
    id: '7103101003',
    districtId: '7103101',
    name: 'Bukide',
  },
  {
    id: '7103101004',
    districtId: '7103101',
    name: 'Bukide Timur',
  },
  {
    id: '7103101005',
    districtId: '7103101',
    name: 'Nanusa',
  },
  {
    id: '7103102001',
    districtId: '7103102',
    name: 'Kawio',
  },
  {
    id: '7103102002',
    districtId: '7103102',
    name: 'Marore',
  },
  {
    id: '7103102003',
    districtId: '7103102',
    name: 'Matutuang',
  },
  {
    id: '7103110001',
    districtId: '7103110',
    name: 'Kendahe Dua',
  },
  {
    id: '7103110002',
    districtId: '7103110',
    name: 'Kendahe Satu',
  },
  {
    id: '7103110003',
    districtId: '7103110',
    name: 'Talawid',
  },
  {
    id: '7103110004',
    districtId: '7103110',
    name: 'Tarianglama',
  },
  {
    id: '7103110005',
    districtId: '7103110',
    name: 'Pempalaraeng',
  },
  {
    id: '7103110006',
    districtId: '7103110',
    name: 'Mohongsawang',
  },
  {
    id: '7103110007',
    districtId: '7103110',
    name: 'Lipaeng',
  },
  {
    id: '7103110008',
    districtId: '7103110',
    name: 'Kawaluso',
  },
  {
    id: '7104010001',
    districtId: '7104010',
    name: 'Pangeran',
  },
  {
    id: '7104010007',
    districtId: '7104010',
    name: 'Pantuge',
  },
  {
    id: '7104010008',
    districtId: '7104010',
    name: 'Kabaruan',
  },
  {
    id: '7104010009',
    districtId: '7104010',
    name: 'Mangaran',
  },
  {
    id: '7104010010',
    districtId: '7104010',
    name: 'Kordakel',
  },
  {
    id: '7104010012',
    districtId: '7104010',
    name: 'Rarange',
  },
  {
    id: '7104010013',
    districtId: '7104010',
    name: 'Taduna',
  },
  {
    id: '7104010014',
    districtId: '7104010',
    name: 'Kabaruan Timur',
  },
  {
    id: '7104010015',
    districtId: '7104010',
    name: 'Pantuge Barat',
  },
  {
    id: '7104010016',
    districtId: '7104010',
    name: 'Bulude Selatan',
  },
  {
    id: '7104010017',
    districtId: '7104010',
    name: 'Panulan',
  },
  {
    id: '7104011002',
    districtId: '7104011',
    name: 'Taduwale',
  },
  {
    id: '7104011003',
    districtId: '7104011',
    name: 'Damau',
  },
  {
    id: '7104011004',
    districtId: '7104011',
    name: 'Akas',
  },
  {
    id: '7104011005',
    districtId: '7104011',
    name: 'Birang',
  },
  {
    id: '7104011006',
    districtId: '7104011',
    name: 'Ighik',
  },
  {
    id: '7104011007',
    districtId: '7104011',
    name: 'Damau Bawone',
  },
  {
    id: '7104011008',
    districtId: '7104011',
    name: 'Akas Balane',
  },
  {
    id: '7104020005',
    districtId: '7104020',
    name: 'Lirung',
  },
  {
    id: '7104020008',
    districtId: '7104020',
    name: 'Musi',
  },
  {
    id: '7104020011',
    districtId: '7104020',
    name: 'Lirung I',
  },
  {
    id: '7104020012',
    districtId: '7104020',
    name: 'Talolang',
  },
  {
    id: '7104020014',
    districtId: '7104020',
    name: 'Lirung Matane',
  },
  {
    id: '7104020019',
    districtId: '7104020',
    name: 'Sereh I',
  },
  {
    id: '7104021001',
    districtId: '7104021',
    name: 'Bitunuris',
  },
  {
    id: '7104021002',
    districtId: '7104021',
    name: 'Salibabu',
  },
  {
    id: '7104021003',
    districtId: '7104021',
    name: 'Balang',
  },
  {
    id: '7104021004',
    districtId: '7104021',
    name: 'Salibabu Utara',
  },
  {
    id: '7104021005',
    districtId: '7104021',
    name: 'Dalum',
  },
  {
    id: '7104021006',
    districtId: '7104021',
    name: 'Bitunuris Selatan',
  },
  {
    id: '7104022001',
    districtId: '7104022',
    name: 'Alude',
  },
  {
    id: '7104022002',
    districtId: '7104022',
    name: 'Kalongan',
  },
  {
    id: '7104022003',
    districtId: '7104022',
    name: 'Kalongan Selatan',
  },
  {
    id: '7104022004',
    districtId: '7104022',
    name: 'Kalongan Utara',
  },
  {
    id: '7104022005',
    districtId: '7104022',
    name: 'Musi I',
  },
  {
    id: '7104023001',
    districtId: '7104023',
    name: 'Moronge Selatan',
  },
  {
    id: '7104023002',
    districtId: '7104023',
    name: 'Moronge Selatan I',
  },
  {
    id: '7104023003',
    districtId: '7104023',
    name: 'Moronge Selatan II',
  },
  {
    id: '7104023004',
    districtId: '7104023',
    name: 'Moronge',
  },
  {
    id: '7104023005',
    districtId: '7104023',
    name: 'Moronge I',
  },
  {
    id: '7104023006',
    districtId: '7104023',
    name: 'Moronge II',
  },
  {
    id: '7104030001',
    districtId: '7104030',
    name: 'Melonguane',
  },
  {
    id: '7104030002',
    districtId: '7104030',
    name: 'Mala',
  },
  {
    id: '7104030003',
    districtId: '7104030',
    name: 'Sawang',
  },
  {
    id: '7104030004',
    districtId: '7104030',
    name: 'Tarun',
  },
  {
    id: '7104030005',
    districtId: '7104030',
    name: 'Kiama',
  },
  {
    id: '7104030008',
    districtId: '7104030',
    name: 'Ambela',
  },
  {
    id: '7104030010',
    districtId: '7104030',
    name: 'Melonguane Barat',
  },
  {
    id: '7104030011',
    districtId: '7104030',
    name: 'Melonguane Timur',
  },
  {
    id: '7104030012',
    districtId: '7104030',
    name: 'Kiama Barat',
  },
  {
    id: '7104030013',
    districtId: '7104030',
    name: 'Tarun Selatan',
  },
  {
    id: '7104030015',
    districtId: '7104030',
    name: 'Mala Timur',
  },
  {
    id: '7104030016',
    districtId: '7104030',
    name: 'Sawang Utara',
  },
  {
    id: '7104030017',
    districtId: '7104030',
    name: 'Maredaren Kiama',
  },
  {
    id: '7104031002',
    districtId: '7104031',
    name: 'Tule Utara',
  },
  {
    id: '7104031003',
    districtId: '7104031',
    name: 'Tule Tengah',
  },
  {
    id: '7104031004',
    districtId: '7104031',
    name: 'Bawombaru',
  },
  {
    id: '7104031005',
    districtId: '7104031',
    name: 'Bawombaru Tengah',
  },
  {
    id: '7104031006',
    districtId: '7104031',
    name: 'Bawombaru Utara',
  },
  {
    id: '7104040006',
    districtId: '7104040',
    name: 'Beo',
  },
  {
    id: '7104040007',
    districtId: '7104040',
    name: 'Bantik',
  },
  {
    id: '7104040012',
    districtId: '7104040',
    name: 'Bantik Lama',
  },
  {
    id: '7104040013',
    districtId: '7104040',
    name: 'Beo Barat',
  },
  {
    id: '7104040014',
    districtId: '7104040',
    name: 'Beo Timur',
  },
  {
    id: '7104041001',
    districtId: '7104041',
    name: 'Makatara',
  },
  {
    id: '7104041002',
    districtId: '7104041',
    name: 'Makatara Timur',
  },
  {
    id: '7104041003',
    districtId: '7104041',
    name: 'Lobbo',
  },
  {
    id: '7104041004',
    districtId: '7104041',
    name: 'Lobbo I',
  },
  {
    id: '7104041005',
    districtId: '7104041',
    name: 'Rae',
  },
  {
    id: '7104041006',
    districtId: '7104041',
    name: 'Rae Selatan',
  },
  {
    id: '7104041007',
    districtId: '7104041',
    name: 'Awit',
  },
  {
    id: '7104041008',
    districtId: '7104041',
    name: 'Awit Selatan',
  },
  {
    id: '7104042001',
    districtId: '7104042',
    name: 'Pampalu',
  },
  {
    id: '7104042002',
    districtId: '7104042',
    name: 'Russoh',
  },
  {
    id: '7104042003',
    districtId: '7104042',
    name: 'Niampak',
  },
  {
    id: '7104042004',
    districtId: '7104042',
    name: 'Niampak Utara',
  },
  {
    id: '7104042005',
    districtId: '7104042',
    name: 'Tarohan',
  },
  {
    id: '7104042006',
    districtId: '7104042',
    name: 'Tarohan Selatan',
  },
  {
    id: '7104042007',
    districtId: '7104042',
    name: 'Matahit',
  },
  {
    id: '7104050005',
    districtId: '7104050',
    name: 'Rainis',
  },
  {
    id: '7104050006',
    districtId: '7104050',
    name: 'Bantane',
  },
  {
    id: '7104050007',
    districtId: '7104050',
    name: 'Tabang',
  },
  {
    id: '7104050008',
    districtId: '7104050',
    name: 'Alo',
  },
  {
    id: '7104050009',
    districtId: '7104050',
    name: 'Alo Utara',
  },
  {
    id: '7104050010',
    districtId: '7104050',
    name: 'Perangen',
  },
  {
    id: '7104050011',
    districtId: '7104050',
    name: 'Nunu Utara',
  },
  {
    id: '7104050012',
    districtId: '7104050',
    name: 'Rainis Batu Penga',
  },
  {
    id: '7104050013',
    districtId: '7104050',
    name: 'Bantane Utara',
  },
  {
    id: '7104050014',
    districtId: '7104050',
    name: 'Tabang Barat',
  },
  {
    id: '7104051001',
    districtId: '7104051',
    name: 'Tuabatu',
  },
  {
    id: '7104051002',
    districtId: '7104051',
    name: 'Binalang',
  },
  {
    id: '7104051003',
    districtId: '7104051',
    name: 'Riung',
  },
  {
    id: '7104051004',
    districtId: '7104051',
    name: 'Dapalan',
  },
  {
    id: '7104051005',
    districtId: '7104051',
    name: 'Amat',
  },
  {
    id: '7104051006',
    districtId: '7104051',
    name: 'Ganalo',
  },
  {
    id: '7104051007',
    districtId: '7104051',
    name: 'Dapihe',
  },
  {
    id: '7104051008',
    districtId: '7104051',
    name: 'Tuabatu Barat',
  },
  {
    id: '7104051009',
    districtId: '7104051',
    name: 'Binalang Selatan',
  },
  {
    id: '7104051010',
    districtId: '7104051',
    name: 'Riung Utara',
  },
  {
    id: '7104051011',
    districtId: '7104051',
    name: 'Amat Selatan',
  },
  {
    id: '7104052001',
    districtId: '7104052',
    name: 'Pulutan',
  },
  {
    id: '7104052002',
    districtId: '7104052',
    name: 'Pulutan Utara',
  },
  {
    id: '7104052003',
    districtId: '7104052',
    name: 'Pulutan Selatan',
  },
  {
    id: '7104052004',
    districtId: '7104052',
    name: 'Daran',
  },
  {
    id: '7104052005',
    districtId: '7104052',
    name: 'Daran Utara',
  },
  {
    id: '7104060006',
    districtId: '7104060',
    name: 'Essang',
  },
  {
    id: '7104060007',
    districtId: '7104060',
    name: 'Lalue',
  },
  {
    id: '7104060009',
    districtId: '7104060',
    name: 'Essang Selatan',
  },
  {
    id: '7104060010',
    districtId: '7104060',
    name: 'Lalue Tengah',
  },
  {
    id: '7104060011',
    districtId: '7104060',
    name: 'Lalue Utara',
  },
  {
    id: '7104060012',
    districtId: '7104060',
    name: 'Bulude Selatan',
  },
  {
    id: '7104060016',
    districtId: '7104060',
    name: 'Maririk',
  },
  {
    id: '7104061001',
    districtId: '7104061',
    name: 'Sambuara',
  },
  {
    id: '7104061002',
    districtId: '7104061',
    name: 'Sambuara Satu',
  },
  {
    id: '7104061003',
    districtId: '7104061',
    name: 'Ensem I',
  },
  {
    id: '7104061004',
    districtId: '7104061',
    name: 'Ensem Timur',
  },
  {
    id: '7104061005',
    districtId: '7104061',
    name: 'Batumbalango',
  },
  {
    id: '7104061006',
    districtId: '7104061',
    name: 'Ambia',
  },
  {
    id: '7104061007',
    districtId: '7104061',
    name: 'Ambia Utara',
  },
  {
    id: '7104061008',
    districtId: '7104061',
    name: 'Kuma',
  },
  {
    id: '7104061009',
    districtId: '7104061',
    name: 'Kuma Selatan',
  },
  {
    id: '7104070001',
    districtId: '7104070',
    name: 'Mamahan',
  },
  {
    id: '7104070002',
    districtId: '7104070',
    name: 'Bambung',
  },
  {
    id: '7104070003',
    districtId: '7104070',
    name: 'Taturan',
  },
  {
    id: '7104070005',
    districtId: '7104070',
    name: 'Arangkaa',
  },
  {
    id: '7104070006',
    districtId: '7104070',
    name: 'Malat',
  },
  {
    id: '7104070007',
    districtId: '7104070',
    name: 'Apan',
  },
  {
    id: '7104070008',
    districtId: '7104070',
    name: 'Taruan',
  },
  {
    id: '7104070009',
    districtId: '7104070',
    name: 'Bannada',
  },
  {
    id: '7104070010',
    districtId: '7104070',
    name: 'Lahu',
  },
  {
    id: '7104070011',
    districtId: '7104070',
    name: 'Mamahan Barat',
  },
  {
    id: '7104070012',
    districtId: '7104070',
    name: 'Bambung Timur',
  },
  {
    id: '7104070013',
    districtId: '7104070',
    name: 'Gemeh Raamata',
  },
  {
    id: '7104070014',
    districtId: '7104070',
    name: 'Gemeh Wantane',
  },
  {
    id: '7104070015',
    districtId: '7104070',
    name: 'Malat Utara',
  },
  {
    id: '7104080001',
    districtId: '7104080',
    name: 'Kakorotan',
  },
  {
    id: '7104080002',
    districtId: '7104080',
    name: 'Marampit',
  },
  {
    id: '7104080003',
    districtId: '7104080',
    name: 'Laluhe',
  },
  {
    id: '7104080004',
    districtId: '7104080',
    name: 'Dampulis',
  },
  {
    id: '7104080005',
    districtId: '7104080',
    name: 'Karatung',
  },
  {
    id: '7104080007',
    districtId: '7104080',
    name: 'Marampit Timur',
  },
  {
    id: '7104080008',
    districtId: '7104080',
    name: 'Dampulis Selatan',
  },
  {
    id: '7104080009',
    districtId: '7104080',
    name: 'Karatung Tengah',
  },
  {
    id: '7104080010',
    districtId: '7104080',
    name: 'Karatung Selatan',
  },
  {
    id: '7104081001',
    districtId: '7104081',
    name: 'Miangas',
  },
  {
    id: '7105010001',
    districtId: '7105010',
    name: 'Sinisir',
  },
  {
    id: '7105010002',
    districtId: '7105010',
    name: 'Kakenturan',
  },
  {
    id: '7105010003',
    districtId: '7105010',
    name: 'Linelean',
  },
  {
    id: '7105010004',
    districtId: '7105010',
    name: 'Pinasungkulan',
  },
  {
    id: '7105010005',
    districtId: '7105010',
    name: 'Makaaruyen',
  },
  {
    id: '7105010006',
    districtId: '7105010',
    name: 'Palelon',
  },
  {
    id: '7105010007',
    districtId: '7105010',
    name: 'Wulurmaatus',
  },
  {
    id: '7105010008',
    districtId: '7105010',
    name: 'Mokobang',
  },
  {
    id: '7105010009',
    districtId: '7105010',
    name: 'Kakenturan Barat',
  },
  {
    id: '7105010010',
    districtId: '7105010',
    name: 'Pinasungkulan Utara',
  },
  {
    id: '7105020009',
    districtId: '7105020',
    name: 'Raraatean',
  },
  {
    id: '7105020010',
    districtId: '7105020',
    name: 'Sion',
  },
  {
    id: '7105020011',
    districtId: '7105020',
    name: 'Tompaso Baru Dua',
  },
  {
    id: '7105020012',
    districtId: '7105020',
    name: 'Kinalawiran',
  },
  {
    id: '7105020013',
    districtId: '7105020',
    name: 'Tompaso Baru Satu',
  },
  {
    id: '7105020014',
    districtId: '7105020',
    name: 'Pinaesaan',
  },
  {
    id: '7105020015',
    districtId: '7105020',
    name: 'Torout',
  },
  {
    id: '7105020016',
    districtId: '7105020',
    name: 'Lindangan',
  },
  {
    id: '7105020017',
    districtId: '7105020',
    name: 'Karowa',
  },
  {
    id: '7105020018',
    districtId: '7105020',
    name: 'Liandok',
  },
  {
    id: '7105021001',
    districtId: '7105021',
    name: 'Tambelang',
  },
  {
    id: '7105021002',
    districtId: '7105021',
    name: 'Kinamang',
  },
  {
    id: '7105021003',
    districtId: '7105021',
    name: 'Liningaan',
  },
  {
    id: '7105021004',
    districtId: '7105021',
    name: 'Bojonegoro',
  },
  {
    id: '7105021005',
    districtId: '7105021',
    name: 'Kinaweruan',
  },
  {
    id: '7105021006',
    districtId: '7105021',
    name: 'Tumani',
  },
  {
    id: '7105021007',
    districtId: '7105021',
    name: 'Lowian',
  },
  {
    id: '7105021008',
    districtId: '7105021',
    name: 'Temboan',
  },
  {
    id: '7105021009',
    districtId: '7105021',
    name: 'Kinamang Satu',
  },
  {
    id: '7105021010',
    districtId: '7105021',
    name: 'Tumani Utara',
  },
  {
    id: '7105021011',
    districtId: '7105021',
    name: 'Tumani Selatan',
  },
  {
    id: '7105021012',
    districtId: '7105021',
    name: 'Lowian Satu',
  },
  {
    id: '7105070002',
    districtId: '7105070',
    name: 'Poopo',
  },
  {
    id: '7105070003',
    districtId: '7105070',
    name: 'Ranoiapo',
  },
  {
    id: '7105070004',
    districtId: '7105070',
    name: 'Pontak',
  },
  {
    id: '7105070005',
    districtId: '7105070',
    name: 'Mopolo',
  },
  {
    id: '7105070006',
    districtId: '7105070',
    name: 'Powalutan',
  },
  {
    id: '7105070007',
    districtId: '7105070',
    name: 'Beringin',
  },
  {
    id: '7105070009',
    districtId: '7105070',
    name: 'Lompad',
  },
  {
    id: '7105070010',
    districtId: '7105070',
    name: 'Lompad Baru',
  },
  {
    id: '7105070011',
    districtId: '7105070',
    name: 'Pontak Satu',
  },
  {
    id: '7105070012',
    districtId: '7105070',
    name: 'Poopo Barat',
  },
  {
    id: '7105070013',
    districtId: '7105070',
    name: 'Poopo Utara',
  },
  {
    id: '7105070014',
    districtId: '7105070',
    name: 'Mopolo Esa',
  },
  {
    id: '7105080008',
    districtId: '7105080',
    name: 'Lalumpe',
  },
  {
    id: '7105080009',
    districtId: '7105080',
    name: 'Raanan Lama',
  },
  {
    id: '7105080010',
    districtId: '7105080',
    name: 'Motoling Dua',
  },
  {
    id: '7105080011',
    districtId: '7105080',
    name: 'Motoling Satu',
  },
  {
    id: '7105080012',
    districtId: '7105080',
    name: 'Motoling Mawale',
  },
  {
    id: '7105080013',
    districtId: '7105080',
    name: 'Motoling',
  },
  {
    id: '7105080014',
    districtId: '7105080',
    name: 'Picuan Baru',
  },
  {
    id: '7105081001',
    districtId: '7105081',
    name: 'Malola I',
  },
  {
    id: '7105081002',
    districtId: '7105081',
    name: 'Malola',
  },
  {
    id: '7105081003',
    districtId: '7105081',
    name: 'Makasili',
  },
  {
    id: '7105081004',
    districtId: '7105081',
    name: 'Kumelembuai Atas',
  },
  {
    id: '7105081005',
    districtId: '7105081',
    name: 'Kumelembuai',
  },
  {
    id: '7105081006',
    districtId: '7105081',
    name: 'Kumelembuai I',
  },
  {
    id: '7105081012',
    districtId: '7105081',
    name: 'Kumelembuai II',
  },
  {
    id: '7105081013',
    districtId: '7105081',
    name: 'Lolombulan Makasili',
  },
  {
    id: '7105082001',
    districtId: '7105082',
    name: 'Toyopon',
  },
  {
    id: '7105082002',
    districtId: '7105082',
    name: 'Keroit',
  },
  {
    id: '7105082003',
    districtId: '7105082',
    name: 'Raanan Baru I',
  },
  {
    id: '7105082004',
    districtId: '7105082',
    name: 'Raanan Baru',
  },
  {
    id: '7105082005',
    districtId: '7105082',
    name: 'Raanan Baru II',
  },
  {
    id: '7105082006',
    districtId: '7105082',
    name: 'Tondei Satu',
  },
  {
    id: '7105082007',
    districtId: '7105082',
    name: 'Tondei',
  },
  {
    id: '7105082008',
    districtId: '7105082',
    name: 'Tondei Dua',
  },
  {
    id: '7105083001',
    districtId: '7105083',
    name: 'Picuan',
  },
  {
    id: '7105083002',
    districtId: '7105083',
    name: 'Picuan Satu',
  },
  {
    id: '7105083003',
    districtId: '7105083',
    name: 'Wanga',
  },
  {
    id: '7105083004',
    districtId: '7105083',
    name: 'Wanga  Amongena',
  },
  {
    id: '7105083005',
    districtId: '7105083',
    name: 'Tokin',
  },
  {
    id: '7105083006',
    districtId: '7105083',
    name: 'Tokin Baru',
  },
  {
    id: '7105083007',
    districtId: '7105083',
    name: 'Karimbow Talikuran',
  },
  {
    id: '7105083008',
    districtId: '7105083',
    name: 'Karimbow',
  },
  {
    id: '7105090001',
    districtId: '7105090',
    name: 'Durian',
  },
  {
    id: '7105090002',
    districtId: '7105090',
    name: 'Poigar II',
  },
  {
    id: '7105090003',
    districtId: '7105090',
    name: 'Poigar I',
  },
  {
    id: '7105090004',
    districtId: '7105090',
    name: 'Tanamon',
  },
  {
    id: '7105090005',
    districtId: '7105090',
    name: 'Aergale',
  },
  {
    id: '7105090006',
    districtId: '7105090',
    name: 'Ongkaw II',
  },
  {
    id: '7105090007',
    districtId: '7105090',
    name: 'Ongkaw I',
  },
  {
    id: '7105090008',
    districtId: '7105090',
    name: 'Tiniawangko',
  },
  {
    id: '7105090009',
    districtId: '7105090',
    name: 'Boyong Pante',
  },
  {
    id: '7105090010',
    districtId: '7105090',
    name: 'Blongko',
  },
  {
    id: '7105090011',
    districtId: '7105090',
    name: 'Tanamon Utara',
  },
  {
    id: '7105090012',
    districtId: '7105090',
    name: 'Ongkaw Tiga',
  },
  {
    id: '7105090013',
    districtId: '7105090',
    name: 'Boyong Pante Dua',
  },
  {
    id: '7105100011',
    districtId: '7105100',
    name: 'Boyong Atas',
  },
  {
    id: '7105100012',
    districtId: '7105100',
    name: 'Pakuure III',
  },
  {
    id: '7105100013',
    districtId: '7105100',
    name: 'Pakuure II',
  },
  {
    id: '7105100014',
    districtId: '7105100',
    name: 'Pakuure I',
  },
  {
    id: '7105100015',
    districtId: '7105100',
    name: 'Sapa',
  },
  {
    id: '7105100016',
    districtId: '7105100',
    name: 'Pakuweru',
  },
  {
    id: '7105100017',
    districtId: '7105100',
    name: 'Tenga',
  },
  {
    id: '7105100018',
    districtId: '7105100',
    name: 'Radey',
  },
  {
    id: '7105100019',
    districtId: '7105100',
    name: 'Tawaang',
  },
  {
    id: '7105100024',
    districtId: '7105100',
    name: 'Molinow',
  },
  {
    id: '7105100025',
    districtId: '7105100',
    name: 'Pakuure Tinanian',
  },
  {
    id: '7105100026',
    districtId: '7105100',
    name: 'Pakuure Kinamang',
  },
  {
    id: '7105100027',
    districtId: '7105100',
    name: 'Pakuure',
  },
  {
    id: '7105100028',
    districtId: '7105100',
    name: 'Pakuweru Utara',
  },
  {
    id: '7105100029',
    districtId: '7105100',
    name: 'Sapa Barat',
  },
  {
    id: '7105100030',
    districtId: '7105100',
    name: 'Sapa Timur',
  },
  {
    id: '7105100031',
    districtId: '7105100',
    name: 'Tawaang Timur',
  },
  {
    id: '7105100032',
    districtId: '7105100',
    name: 'Tawaang Barat',
  },
  {
    id: '7105111001',
    districtId: '7105111',
    name: 'Buyungon',
  },
  {
    id: '7105111002',
    districtId: '7105111',
    name: 'Ranoyapo',
  },
  {
    id: '7105111003',
    districtId: '7105111',
    name: 'Uwuran Satu',
  },
  {
    id: '7105111004',
    districtId: '7105111',
    name: 'Uwuran Dua',
  },
  {
    id: '7105111006',
    districtId: '7105111',
    name: 'Ranoketang Tua',
  },
  {
    id: '7105111007',
    districtId: '7105111',
    name: 'Bitung',
  },
  {
    id: '7105111008',
    districtId: '7105111',
    name: 'Kilometer Tiga',
  },
  {
    id: '7105112001',
    districtId: '7105112',
    name: 'Pondos',
  },
  {
    id: '7105112002',
    districtId: '7105112',
    name: 'Elusan',
  },
  {
    id: '7105112003',
    districtId: '7105112',
    name: 'Tewasen',
  },
  {
    id: '7105112005',
    districtId: '7105112',
    name: 'Kapitu',
  },
  {
    id: '7105112006',
    districtId: '7105112',
    name: 'Kawangkoan Bawah',
  },
  {
    id: '7105112007',
    districtId: '7105112',
    name: 'Rumoong Bawah',
  },
  {
    id: '7105112008',
    districtId: '7105112',
    name: 'Desa Rumoong Bawah',
  },
  {
    id: '7105112009',
    districtId: '7105112',
    name: 'Wakan',
  },
  {
    id: '7105112010',
    districtId: '7105112',
    name: 'Teep Trans',
  },
  {
    id: '7105113001',
    districtId: '7105113',
    name: 'Ranomea',
  },
  {
    id: '7105113002',
    districtId: '7105113',
    name: 'Pondang',
  },
  {
    id: '7105113003',
    districtId: '7105113',
    name: 'Pinaling',
  },
  {
    id: '7105113004',
    districtId: '7105113',
    name: 'Kota Menara',
  },
  {
    id: '7105113005',
    districtId: '7105113',
    name: 'Maliku',
  },
  {
    id: '7105113006',
    districtId: '7105113',
    name: 'Ritey',
  },
  {
    id: '7105113007',
    districtId: '7105113',
    name: 'Malenos Baru',
  },
  {
    id: '7105113008',
    districtId: '7105113',
    name: 'Lopana',
  },
  {
    id: '7105113009',
    districtId: '7105113',
    name: 'Lopana Satu',
  },
  {
    id: '7105113010',
    districtId: '7105113',
    name: 'Maliku Satu',
  },
  {
    id: '7105120001',
    districtId: '7105120',
    name: 'Kaneyan',
  },
  {
    id: '7105120002',
    districtId: '7105120',
    name: 'Koreng',
  },
  {
    id: '7105120003',
    districtId: '7105120',
    name: 'Tumaluntung',
  },
  {
    id: '7105120004',
    districtId: '7105120',
    name: 'Lansot',
  },
  {
    id: '7105120005',
    districtId: '7105120',
    name: 'Rumoong Atas',
  },
  {
    id: '7105120007',
    districtId: '7105120',
    name: 'Pinamorongan',
  },
  {
    id: '7105120010',
    districtId: '7105120',
    name: 'Wiau Lapi',
  },
  {
    id: '7105120014',
    districtId: '7105120',
    name: 'Rumoong Atas Dua',
  },
  {
    id: '7105120015',
    districtId: '7105120',
    name: 'Tumaluntung Satu',
  },
  {
    id: '7105120016',
    districtId: '7105120',
    name: 'Wuwuk Barat',
  },
  {
    id: '7105120017',
    districtId: '7105120',
    name: 'Wiau Lapi Barat',
  },
  {
    id: '7105120018',
    districtId: '7105120',
    name: 'Lansot Timur',
  },
  {
    id: '7105121001',
    districtId: '7105121',
    name: 'Kapoya',
  },
  {
    id: '7105121002',
    districtId: '7105121',
    name: 'Pinapalangkow',
  },
  {
    id: '7105121003',
    districtId: '7105121',
    name: 'Suluun Dua',
  },
  {
    id: '7105121004',
    districtId: '7105121',
    name: 'Suluun Empat',
  },
  {
    id: '7105121005',
    districtId: '7105121',
    name: 'Suluun Satu',
  },
  {
    id: '7105121006',
    districtId: '7105121',
    name: 'Suluun Tiga',
  },
  {
    id: '7105121007',
    districtId: '7105121',
    name: 'Talaitad',
  },
  {
    id: '7105121008',
    districtId: '7105121',
    name: 'Kapoya Satu',
  },
  {
    id: '7105121009',
    districtId: '7105121',
    name: 'Talaitad Utara',
  },
  {
    id: '7105130001',
    districtId: '7105130',
    name: 'Tumpaan',
  },
  {
    id: '7105130002',
    districtId: '7105130',
    name: 'Tumpaan Satu',
  },
  {
    id: '7105130003',
    districtId: '7105130',
    name: 'Matani',
  },
  {
    id: '7105130004',
    districtId: '7105130',
    name: 'Popontolen',
  },
  {
    id: '7105130005',
    districtId: '7105130',
    name: 'Lelema',
  },
  {
    id: '7105130006',
    districtId: '7105130',
    name: 'Tangkuney',
  },
  {
    id: '7105130008',
    districtId: '7105130',
    name: 'Tumpaan Baru',
  },
  {
    id: '7105130009',
    districtId: '7105130',
    name: 'Tumpaan Dua',
  },
  {
    id: '7105130010',
    districtId: '7105130',
    name: 'Matani Satu',
  },
  {
    id: '7105131002',
    districtId: '7105131',
    name: 'Paslaten',
  },
  {
    id: '7105131003',
    districtId: '7105131',
    name: 'Bajo',
  },
  {
    id: '7105131004',
    districtId: '7105131',
    name: 'Popareng',
  },
  {
    id: '7105131005',
    districtId: '7105131',
    name: 'Wawontulap',
  },
  {
    id: '7105131006',
    districtId: '7105131',
    name: 'Wawona',
  },
  {
    id: '7105131007',
    districtId: '7105131',
    name: 'Sondaken',
  },
  {
    id: '7105131008',
    districtId: '7105131',
    name: 'Rap-Rap',
  },
  {
    id: '7105131009',
    districtId: '7105131',
    name: 'Pungkol',
  },
  {
    id: '7105131010',
    districtId: '7105131',
    name: 'Paslaten Satu',
  },
  {
    id: '7105131011',
    districtId: '7105131',
    name: 'Arakan',
  },
  {
    id: '7106010001',
    districtId: '7106010',
    name: 'Makalisung',
  },
  {
    id: '7106010002',
    districtId: '7106010',
    name: 'Waleo',
  },
  {
    id: '7106010003',
    districtId: '7106010',
    name: 'Lilang',
  },
  {
    id: '7106010004',
    districtId: '7106010',
    name: 'Lansot',
  },
  {
    id: '7106010005',
    districtId: '7106010',
    name: 'Kema Tiga',
  },
  {
    id: '7106010006',
    districtId: '7106010',
    name: 'Kema Dua',
  },
  {
    id: '7106010007',
    districtId: '7106010',
    name: 'Kema Satu',
  },
  {
    id: '7106010008',
    districtId: '7106010',
    name: 'Tontalete',
  },
  {
    id: '7106010009',
    districtId: '7106010',
    name: 'Tontelete Rok Rok',
  },
  {
    id: '7106010010',
    districtId: '7106010',
    name: 'Waleo Dua',
  },
  {
    id: '7106020008',
    districtId: '7106020',
    name: 'Watudambo',
  },
  {
    id: '7106020010',
    districtId: '7106020',
    name: 'Kauditan Dua',
  },
  {
    id: '7106020011',
    districtId: '7106020',
    name: 'Kauditan Satu',
  },
  {
    id: '7106020012',
    districtId: '7106020',
    name: 'Kawilei',
  },
  {
    id: '7106020013',
    districtId: '7106020',
    name: 'Treman',
  },
  {
    id: '7106020014',
    districtId: '7106020',
    name: 'Kaima',
  },
  {
    id: '7106020015',
    districtId: '7106020',
    name: 'Karegesan',
  },
  {
    id: '7106020016',
    districtId: '7106020',
    name: 'Kaasar',
  },
  {
    id: '7106020017',
    districtId: '7106020',
    name: 'Lembean',
  },
  {
    id: '7106020018',
    districtId: '7106020',
    name: 'Paslaten',
  },
  {
    id: '7106020019',
    districtId: '7106020',
    name: 'Tumaluntung',
  },
  {
    id: '7106020020',
    districtId: '7106020',
    name: 'Watudambo Dua',
  },
  {
    id: '7106030004',
    districtId: '7106030',
    name: 'Tanggari',
  },
  {
    id: '7106030006',
    districtId: '7106030',
    name: 'Sampiri',
  },
  {
    id: '7106030007',
    districtId: '7106030',
    name: 'Sawangan',
  },
  {
    id: '7106030008',
    districtId: '7106030',
    name: 'Airmadidi Bawah',
  },
  {
    id: '7106030009',
    districtId: '7106030',
    name: 'Airmadidi Atas',
  },
  {
    id: '7106030010',
    districtId: '7106030',
    name: 'Sarongsong Satu',
  },
  {
    id: '7106030011',
    districtId: '7106030',
    name: 'Sarongsong Dua',
  },
  {
    id: '7106030012',
    districtId: '7106030',
    name: 'Rap-Rap',
  },
  {
    id: '7106040001',
    districtId: '7106040',
    name: 'Suwaan',
  },
  {
    id: '7106040002',
    districtId: '7106040',
    name: 'Kolongan',
  },
  {
    id: '7106040003',
    districtId: '7106040',
    name: 'Kawangkoan',
  },
  {
    id: '7106040004',
    districtId: '7106040',
    name: 'Kaleosan',
  },
  {
    id: '7106040005',
    districtId: '7106040',
    name: 'Kuwil',
  },
  {
    id: '7106040006',
    districtId: '7106040',
    name: 'Watutumou',
  },
  {
    id: '7106040007',
    districtId: '7106040',
    name: 'Maumbi',
  },
  {
    id: '7106040008',
    districtId: '7106040',
    name: 'Kolongan Tetempangan',
  },
  {
    id: '7106040009',
    districtId: '7106040',
    name: 'Kawangkoan Baru',
  },
  {
    id: '7106040010',
    districtId: '7106040',
    name: 'Kalawat',
  },
  {
    id: '7106040011',
    districtId: '7106040',
    name: 'Watutumou II',
  },
  {
    id: '7106040012',
    districtId: '7106040',
    name: 'Watutumou III',
  },
  {
    id: '7106050002',
    districtId: '7106050',
    name: 'Matungkas',
  },
  {
    id: '7106050003',
    districtId: '7106050',
    name: 'Laikit',
  },
  {
    id: '7106050004',
    districtId: '7106050',
    name: 'Dimembe',
  },
  {
    id: '7106050005',
    districtId: '7106050',
    name: 'Klabat',
  },
  {
    id: '7106050006',
    districtId: '7106050',
    name: 'Warukapas',
  },
  {
    id: '7106050011',
    districtId: '7106050',
    name: 'Tatelu Satu',
  },
  {
    id: '7106050012',
    districtId: '7106050',
    name: 'Pinilih',
  },
  {
    id: '7106050013',
    districtId: '7106050',
    name: 'Tatelu Rondor',
  },
  {
    id: '7106050014',
    districtId: '7106050',
    name: 'Wasian',
  },
  {
    id: '7106050015',
    districtId: '7106050',
    name: 'Lumpias',
  },
  {
    id: '7106051001',
    districtId: '7106051',
    name: 'Talawaan',
  },
  {
    id: '7106051002',
    districtId: '7106051',
    name: 'Tumbohon',
  },
  {
    id: '7106051003',
    districtId: '7106051',
    name: 'Kolongan',
  },
  {
    id: '7106051004',
    districtId: '7106051',
    name: 'Mapanget',
  },
  {
    id: '7106051005',
    districtId: '7106051',
    name: 'Winetin',
  },
  {
    id: '7106051006',
    districtId: '7106051',
    name: 'Patokaan',
  },
  {
    id: '7106051007',
    districtId: '7106051',
    name: 'Wusa',
  },
  {
    id: '7106051008',
    districtId: '7106051',
    name: 'Warisa',
  },
  {
    id: '7106051009',
    districtId: '7106051',
    name: 'Teep Warisa',
  },
  {
    id: '7106051010',
    districtId: '7106051',
    name: 'Paniki Atas',
  },
  {
    id: '7106051011',
    districtId: '7106051',
    name: 'Warisa Kampung Baru',
  },
  {
    id: '7106051012',
    districtId: '7106051',
    name: 'Paniki Baru',
  },
  {
    id: '7106060001',
    districtId: '7106060',
    name: 'Tiwoho',
  },
  {
    id: '7106060002',
    districtId: '7106060',
    name: 'Wori',
  },
  {
    id: '7106060003',
    districtId: '7106060',
    name: 'Kima Bajo',
  },
  {
    id: '7106060004',
    districtId: '7106060',
    name: 'Minaesa',
  },
  {
    id: '7106060005',
    districtId: '7106060',
    name: 'Talawaan Bantik',
  },
  {
    id: '7106060006',
    districtId: '7106060',
    name: 'Talawaan Atas',
  },
  {
    id: '7106060007',
    districtId: '7106060',
    name: 'Budo',
  },
  {
    id: '7106060008',
    districtId: '7106060',
    name: 'Darunu',
  },
  {
    id: '7106060009',
    districtId: '7106060',
    name: 'Bulo',
  },
  {
    id: '7106060010',
    districtId: '7106060',
    name: 'Ponto',
  },
  {
    id: '7106060011',
    districtId: '7106060',
    name: 'Lansa',
  },
  {
    id: '7106060012',
    districtId: '7106060',
    name: 'Lantung',
  },
  {
    id: '7106060014',
    districtId: '7106060',
    name: 'Mantehage I',
  },
  {
    id: '7106060015',
    districtId: '7106060',
    name: 'Mantehage III',
  },
  {
    id: '7106060016',
    districtId: '7106060',
    name: 'Mantehage',
  },
  {
    id: '7106060017',
    districtId: '7106060',
    name: 'Mantehage II',
  },
  {
    id: '7106060018',
    districtId: '7106060',
    name: 'Nain',
  },
  {
    id: '7106060019',
    districtId: '7106060',
    name: 'Tatampi',
  },
  {
    id: '7106060020',
    districtId: '7106060',
    name: 'Nain Satu',
  },
  {
    id: '7106070001',
    districtId: '7106070',
    name: 'Palaes',
  },
  {
    id: '7106070002',
    districtId: '7106070',
    name: 'Maliambao',
  },
  {
    id: '7106070003',
    districtId: '7106070',
    name: 'Termaal',
  },
  {
    id: '7106070004',
    districtId: '7106070',
    name: 'Jayakarsa',
  },
  {
    id: '7106070005',
    districtId: '7106070',
    name: 'Paputungan',
  },
  {
    id: '7106070006',
    districtId: '7106070',
    name: 'Tanah Putih',
  },
  {
    id: '7106070007',
    districtId: '7106070',
    name: 'Sonsilo',
  },
  {
    id: '7106070008',
    districtId: '7106070',
    name: 'Tarabitan',
  },
  {
    id: '7106070010',
    districtId: '7106070',
    name: 'Bahoi',
  },
  {
    id: '7106070013',
    districtId: '7106070',
    name: 'Gangga Satu',
  },
  {
    id: '7106070014',
    districtId: '7106070',
    name: 'Gangga Dua',
  },
  {
    id: '7106070015',
    districtId: '7106070',
    name: 'Aer Banua',
  },
  {
    id: '7106070016',
    districtId: '7106070',
    name: 'Talise',
  },
  {
    id: '7106070017',
    districtId: '7106070',
    name: 'Kinabuhutan',
  },
  {
    id: '7106070018',
    districtId: '7106070',
    name: 'Tambun',
  },
  {
    id: '7106070019',
    districtId: '7106070',
    name: 'Wawunian',
  },
  {
    id: '7106070020',
    districtId: '7106070',
    name: 'Bulutui',
  },
  {
    id: '7106080008',
    districtId: '7106080',
    name: 'Sarawet',
  },
  {
    id: '7106080009',
    districtId: '7106080',
    name: 'Likupang Dua',
  },
  {
    id: '7106080010',
    districtId: '7106080',
    name: 'Likupang Satu',
  },
  {
    id: '7106080011',
    districtId: '7106080',
    name: 'Wineru',
  },
  {
    id: '7106080012',
    districtId: '7106080',
    name: 'Maen',
  },
  {
    id: '7106080013',
    districtId: '7106080',
    name: 'Winuri',
  },
  {
    id: '7106080014',
    districtId: '7106080',
    name: 'Pinenek',
  },
  {
    id: '7106080015',
    districtId: '7106080',
    name: 'Rinondoran',
  },
  {
    id: '7106080016',
    districtId: '7106080',
    name: 'Kalinaun',
  },
  {
    id: '7106080017',
    districtId: '7106080',
    name: 'Marinsow',
  },
  {
    id: '7106080018',
    districtId: '7106080',
    name: 'Pulisan',
  },
  {
    id: '7106080019',
    districtId: '7106080',
    name: 'Lihunu',
  },
  {
    id: '7106080020',
    districtId: '7106080',
    name: 'Kahuku',
  },
  {
    id: '7106080021',
    districtId: '7106080',
    name: 'Libas',
  },
  {
    id: '7106080022',
    districtId: '7106080',
    name: 'Likupang Kampung Ambong',
  },
  {
    id: '7106080024',
    districtId: '7106080',
    name: 'Kinunang',
  },
  {
    id: '7106081001',
    districtId: '7106081',
    name: 'Wangurer',
  },
  {
    id: '7106081002',
    districtId: '7106081',
    name: 'Kaweruan',
  },
  {
    id: '7106081003',
    districtId: '7106081',
    name: 'Kokoleh Dua',
  },
  {
    id: '7106081004',
    districtId: '7106081',
    name: 'Kokoleh Satu',
  },
  {
    id: '7106081005',
    districtId: '7106081',
    name: 'Paslaten',
  },
  {
    id: '7106081006',
    districtId: '7106081',
    name: 'Batu',
  },
  {
    id: '7106081007',
    districtId: '7106081',
    name: 'Werot',
  },
  {
    id: '7107010001',
    districtId: '7107010',
    name: 'Sangtombolang',
  },
  {
    id: '7107010002',
    districtId: '7107010',
    name: 'Sampiro',
  },
  {
    id: '7107010003',
    districtId: '7107010',
    name: 'Sangkub I',
  },
  {
    id: '7107010004',
    districtId: '7107010',
    name: 'Sangkub II',
  },
  {
    id: '7107010005',
    districtId: '7107010',
    name: 'Sangkub III',
  },
  {
    id: '7107010006',
    districtId: '7107010',
    name: 'Tombolango',
  },
  {
    id: '7107010007',
    districtId: '7107010',
    name: 'Busisingo',
  },
  {
    id: '7107010008',
    districtId: '7107010',
    name: 'Pangkusa',
  },
  {
    id: '7107010009',
    districtId: '7107010',
    name: 'Sidodadi',
  },
  {
    id: '7107010010',
    districtId: '7107010',
    name: 'Busisingo Utara',
  },
  {
    id: '7107010011',
    districtId: '7107010',
    name: 'Sangkub IV',
  },
  {
    id: '7107010012',
    districtId: '7107010',
    name: 'Apeng Sembeka',
  },
  {
    id: '7107010013',
    districtId: '7107010',
    name: 'Sangkub Timur',
  },
  {
    id: '7107010014',
    districtId: '7107010',
    name: 'Monompia',
  },
  {
    id: '7107010015',
    districtId: '7107010',
    name: 'Suka Makmur',
  },
  {
    id: '7107010016',
    districtId: '7107010',
    name: 'Mokusato',
  },
  {
    id: '7107020001',
    districtId: '7107020',
    name: 'Mome',
  },
  {
    id: '7107020003',
    districtId: '7107020',
    name: 'Pimpi',
  },
  {
    id: '7107020004',
    districtId: '7107020',
    name: 'Bunia',
  },
  {
    id: '7107020005',
    districtId: '7107020',
    name: 'Kopi',
  },
  {
    id: '7107020006',
    districtId: '7107020',
    name: 'Bintauna Pante',
  },
  {
    id: '7107020007',
    districtId: '7107020',
    name: 'Minanga',
  },
  {
    id: '7107020008',
    districtId: '7107020',
    name: 'Batulintik',
  },
  {
    id: '7107020009',
    districtId: '7107020',
    name: 'Bintauna',
  },
  {
    id: '7107020010',
    districtId: '7107020',
    name: 'Talaga',
  },
  {
    id: '7107020011',
    districtId: '7107020',
    name: "Voa'A",
  },
  {
    id: '7107020012',
    districtId: '7107020',
    name: 'Padang',
  },
  {
    id: '7107020013',
    districtId: '7107020',
    name: 'Kuhanga',
  },
  {
    id: '7107020014',
    districtId: '7107020',
    name: 'Bunong',
  },
  {
    id: '7107020015',
    districtId: '7107020',
    name: 'Padang Barat',
  },
  {
    id: '7107020016',
    districtId: '7107020',
    name: 'Vahuta',
  },
  {
    id: '7107030001',
    districtId: '7107030',
    name: 'Mokoditek I',
  },
  {
    id: '7107030002',
    districtId: '7107030',
    name: 'Mokoditek',
  },
  {
    id: '7107030003',
    districtId: '7107030',
    name: 'Nunuka',
  },
  {
    id: '7107030004',
    districtId: '7107030',
    name: 'Saleo',
  },
  {
    id: '7107030005',
    districtId: '7107030',
    name: 'Binuanga',
  },
  {
    id: '7107030006',
    districtId: '7107030',
    name: 'Bohabak IV',
  },
  {
    id: '7107030007',
    districtId: '7107030',
    name: 'Bohabak II',
  },
  {
    id: '7107030008',
    districtId: '7107030',
    name: 'Bohabak I',
  },
  {
    id: '7107030009',
    districtId: '7107030',
    name: 'Bohabak III',
  },
  {
    id: '7107030010',
    districtId: '7107030',
    name: 'Binjeita',
  },
  {
    id: '7107030011',
    districtId: '7107030',
    name: 'Binjeita I',
  },
  {
    id: '7107030012',
    districtId: '7107030',
    name: 'Binjeita II',
  },
  {
    id: '7107030013',
    districtId: '7107030',
    name: 'Biontong',
  },
  {
    id: '7107030014',
    districtId: '7107030',
    name: 'Biontong II',
  },
  {
    id: '7107030015',
    districtId: '7107030',
    name: 'Biontong I',
  },
  {
    id: '7107030016',
    districtId: '7107030',
    name: 'Saleo I',
  },
  {
    id: '7107030017',
    districtId: '7107030',
    name: 'Nagara',
  },
  {
    id: '7107030018',
    districtId: '7107030',
    name: 'Tanjung Labuo',
  },
  {
    id: '7107030019',
    districtId: '7107030',
    name: 'Binuni',
  },
  {
    id: '7107030020',
    districtId: '7107030',
    name: 'Lipu Bogu',
  },
  {
    id: '7107040001',
    districtId: '7107040',
    name: 'Paku',
  },
  {
    id: '7107040002',
    districtId: '7107040',
    name: 'Ollot II',
  },
  {
    id: '7107040003',
    districtId: '7107040',
    name: 'Ollot',
  },
  {
    id: '7107040004',
    districtId: '7107040',
    name: 'Ollot I',
  },
  {
    id: '7107040005',
    districtId: '7107040',
    name: 'Sonuo',
  },
  {
    id: '7107040006',
    districtId: '7107040',
    name: 'Wakat',
  },
  {
    id: '7107040007',
    districtId: '7107040',
    name: 'Tote',
  },
  {
    id: '7107040008',
    districtId: '7107040',
    name: 'Iyok',
  },
  {
    id: '7107040009',
    districtId: '7107040',
    name: 'Langi',
  },
  {
    id: '7107040010',
    districtId: '7107040',
    name: 'Jambu Sarang',
  },
  {
    id: '7107040011',
    districtId: '7107040',
    name: 'Talaga Tumoagu',
  },
  {
    id: '7107040012',
    districtId: '7107040',
    name: 'Bolang Itang',
  },
  {
    id: '7107040013',
    districtId: '7107040',
    name: 'Bolang Itang I',
  },
  {
    id: '7107040014',
    districtId: '7107040',
    name: 'Bolang Itang II',
  },
  {
    id: '7107040015',
    districtId: '7107040',
    name: 'Talaga',
  },
  {
    id: '7107040016',
    districtId: '7107040',
    name: 'Paku Selatan',
  },
  {
    id: '7107040017',
    districtId: '7107040',
    name: 'Keimanga',
  },
  {
    id: '7107040018',
    districtId: '7107040',
    name: 'Tanjung Buaya',
  },
  {
    id: '7107050001',
    districtId: '7107050',
    name: 'Komus Dua',
  },
  {
    id: '7107050002',
    districtId: '7107050',
    name: 'Solo',
  },
  {
    id: '7107050003',
    districtId: '7107050',
    name: 'Inomunga',
  },
  {
    id: '7107050004',
    districtId: '7107050',
    name: 'Boroko',
  },
  {
    id: '7107050005',
    districtId: '7107050',
    name: 'Boroko Timur',
  },
  {
    id: '7107050006',
    districtId: '7107050',
    name: 'Bigo',
  },
  {
    id: '7107050007',
    districtId: '7107050',
    name: 'Kuala',
  },
  {
    id: '7107050008',
    districtId: '7107050',
    name: 'Pontak',
  },
  {
    id: '7107050009',
    districtId: '7107050',
    name: 'Kuala Utara',
  },
  {
    id: '7107050010',
    districtId: '7107050',
    name: 'Komus Dua Timur',
  },
  {
    id: '7107050011',
    districtId: '7107050',
    name: 'Inomunga Utara',
  },
  {
    id: '7107050012',
    districtId: '7107050',
    name: 'Bigo Selatan',
  },
  {
    id: '7107050013',
    districtId: '7107050',
    name: 'Soligir',
  },
  {
    id: '7107050014',
    districtId: '7107050',
    name: 'Boroko Utara',
  },
  {
    id: '7107050015',
    districtId: '7107050',
    name: 'Gihang',
  },
  {
    id: '7107060001',
    districtId: '7107060',
    name: 'Busato',
  },
  {
    id: '7107060002',
    districtId: '7107060',
    name: 'Kayuogu',
  },
  {
    id: '7107060003',
    districtId: '7107060',
    name: 'Batu Bantayo',
  },
  {
    id: '7107060004',
    districtId: '7107060',
    name: 'Tontulow',
  },
  {
    id: '7107060005',
    districtId: '7107060',
    name: 'Tombulang',
  },
  {
    id: '7107060006',
    districtId: '7107060',
    name: 'Buko',
  },
  {
    id: '7107060007',
    districtId: '7107060',
    name: 'Buko Selatan',
  },
  {
    id: '7107060008',
    districtId: '7107060',
    name: 'Dalapuli',
  },
  {
    id: '7107060009',
    districtId: '7107060',
    name: 'Batutajam',
  },
  {
    id: '7107060010',
    districtId: '7107060',
    name: 'Dengi',
  },
  {
    id: '7107060012',
    districtId: '7107060',
    name: 'Komus I',
  },
  {
    id: '7107060013',
    districtId: '7107060',
    name: 'Tanjung Sidupa',
  },
  {
    id: '7107060014',
    districtId: '7107060',
    name: 'Tontulow Utara',
  },
  {
    id: '7107060015',
    districtId: '7107060',
    name: 'Buko Utara',
  },
  {
    id: '7107060016',
    districtId: '7107060',
    name: 'Dalapuli Barat',
  },
  {
    id: '7107060017',
    districtId: '7107060',
    name: 'Dalapuli Timur',
  },
  {
    id: '7107060018',
    districtId: '7107060',
    name: 'Tombulang Timur',
  },
  {
    id: '7107060019',
    districtId: '7107060',
    name: 'Tombulang Pantai',
  },
  {
    id: '7107060020',
    districtId: '7107060',
    name: 'Duini',
  },
  {
    id: '7107060021',
    districtId: '7107060',
    name: 'Tuntung Timur',
  },
  {
    id: '7107060022',
    districtId: '7107060',
    name: 'Padango',
  },
  {
    id: '7108010001',
    districtId: '7108010',
    name: 'Buang',
  },
  {
    id: '7108010002',
    districtId: '7108010',
    name: 'Lamanggo',
  },
  {
    id: '7108010003',
    districtId: '7108010',
    name: 'Dalinsaheng',
  },
  {
    id: '7108010004',
    districtId: '7108010',
    name: 'Karungo',
  },
  {
    id: '7108010005',
    districtId: '7108010',
    name: 'Tope',
  },
  {
    id: '7108020001',
    districtId: '7108020',
    name: 'Humbia',
  },
  {
    id: '7108020002',
    districtId: '7108020',
    name: 'Kisihang',
  },
  {
    id: '7108020003',
    districtId: '7108020',
    name: 'Birakiama',
  },
  {
    id: '7108020004',
    districtId: '7108020',
    name: 'Buha',
  },
  {
    id: '7108020005',
    districtId: '7108020',
    name: 'Batumawira',
  },
  {
    id: '7108020006',
    districtId: '7108020',
    name: 'Birarikei',
  },
  {
    id: '7108030005',
    districtId: '7108030',
    name: 'Laingpatehi',
  },
  {
    id: '7108030007',
    districtId: '7108030',
    name: 'Bahoi',
  },
  {
    id: '7108030008',
    districtId: '7108030',
    name: 'Mahangiang',
  },
  {
    id: '7108030009',
    districtId: '7108030',
    name: 'Tulusan',
  },
  {
    id: '7108030010',
    districtId: '7108030',
    name: 'Haasi',
  },
  {
    id: '7108030021',
    districtId: '7108030',
    name: 'Boto',
  },
  {
    id: '7108030022',
    districtId: '7108030',
    name: 'Balehumara',
  },
  {
    id: '7108030023',
    districtId: '7108030',
    name: 'Lesah',
  },
  {
    id: '7108030025',
    districtId: '7108030',
    name: 'Mohonsawang',
  },
  {
    id: '7108030026',
    districtId: '7108030',
    name: 'Apengsala',
  },
  {
    id: '7108030027',
    districtId: '7108030',
    name: 'Lesah Rende',
  },
  {
    id: '7108030028',
    districtId: '7108030',
    name: 'Barangkaa Pehe',
  },
  {
    id: '7108030029',
    districtId: '7108030',
    name: 'Pahiama',
  },
  {
    id: '7108040003',
    districtId: '7108040',
    name: 'Bulangan',
  },
  {
    id: '7108040004',
    districtId: '7108040',
    name: 'Minanga',
  },
  {
    id: '7108040005',
    districtId: '7108040',
    name: 'W O',
  },
  {
    id: '7108040006',
    districtId: '7108040',
    name: 'Bawoleu',
  },
  {
    id: '7108040007',
    districtId: '7108040',
    name: 'Lumbo',
  },
  {
    id: '7108040008',
    districtId: '7108040',
    name: 'Bawo',
  },
  {
    id: '7108050001',
    districtId: '7108050',
    name: 'Tanaki',
  },
  {
    id: '7108050002',
    districtId: '7108050',
    name: 'Kapeta',
  },
  {
    id: '7108050003',
    districtId: '7108050',
    name: 'Talawid',
  },
  {
    id: '7108050004',
    districtId: '7108050',
    name: 'Makoa/Mekar Sari',
  },
  {
    id: '7108050005',
    districtId: '7108050',
    name: 'Laghaeng',
  },
  {
    id: '7108050006',
    districtId: '7108050',
    name: 'Batusenggo',
  },
  {
    id: '7108050007',
    districtId: '7108050',
    name: 'Mahuneni',
  },
  {
    id: '7108060001',
    districtId: '7108060',
    name: 'Tapile',
  },
  {
    id: '7108060002',
    districtId: '7108060',
    name: 'Buhias',
  },
  {
    id: '7108060003',
    districtId: '7108060',
    name: 'Balirangen',
  },
  {
    id: '7108060004',
    districtId: '7108060',
    name: 'Biau',
  },
  {
    id: '7108060005',
    districtId: '7108060',
    name: 'Bandil',
  },
  {
    id: '7108060006',
    districtId: '7108060',
    name: 'Sawang',
  },
  {
    id: '7108060007',
    districtId: '7108060',
    name: 'Pangirolong',
  },
  {
    id: '7108060008',
    districtId: '7108060',
    name: 'Mala',
  },
  {
    id: '7108060009',
    districtId: '7108060',
    name: 'Binalu',
  },
  {
    id: '7108060010',
    districtId: '7108060',
    name: 'Kalihiang',
  },
  {
    id: '7108060011',
    districtId: '7108060',
    name: 'Lahopang',
  },
  {
    id: '7108060012',
    districtId: '7108060',
    name: 'Pahepa',
  },
  {
    id: '7108060013',
    districtId: '7108060',
    name: 'Matole',
  },
  {
    id: '7108060014',
    districtId: '7108060',
    name: 'Biau Seha',
  },
  {
    id: '7108070006',
    districtId: '7108070',
    name: 'Pelingsawang',
  },
  {
    id: '7108070007',
    districtId: '7108070',
    name: 'Peling',
  },
  {
    id: '7108070008',
    districtId: '7108070',
    name: 'Paseng',
  },
  {
    id: '7108070009',
    districtId: '7108070',
    name: 'Paniki',
  },
  {
    id: '7108070013',
    districtId: '7108070',
    name: 'Ondong',
  },
  {
    id: '7108070014',
    districtId: '7108070',
    name: 'Kanawong',
  },
  {
    id: '7108070015',
    districtId: '7108070',
    name: 'Lehi',
  },
  {
    id: '7108070022',
    districtId: '7108070',
    name: 'Makalehi',
  },
  {
    id: '7108070023',
    districtId: '7108070',
    name: 'Bumbiha',
  },
  {
    id: '7108070025',
    districtId: '7108070',
    name: 'Makalehi Timur',
  },
  {
    id: '7108070026',
    districtId: '7108070',
    name: 'Makalehi Utara',
  },
  {
    id: '7108080001',
    districtId: '7108080',
    name: 'Lai',
  },
  {
    id: '7108080002',
    districtId: '7108080',
    name: 'Salili',
  },
  {
    id: '7108080003',
    districtId: '7108080',
    name: 'Beong',
  },
  {
    id: '7108080004',
    districtId: '7108080',
    name: 'Dompase',
  },
  {
    id: '7108090009',
    districtId: '7108090',
    name: 'Bahu',
  },
  {
    id: '7108090010',
    districtId: '7108090',
    name: 'Akesimbeka',
  },
  {
    id: '7108090011',
    districtId: '7108090',
    name: 'Bebali',
  },
  {
    id: '7108090012',
    districtId: '7108090',
    name: 'Tarorane',
  },
  {
    id: '7108090013',
    districtId: '7108090',
    name: 'Tatehadeng',
  },
  {
    id: '7108090014',
    districtId: '7108090',
    name: 'Dame',
  },
  {
    id: '7108090015',
    districtId: '7108090',
    name: 'Karalung',
  },
  {
    id: '7108090016',
    districtId: '7108090',
    name: 'Buise',
  },
  {
    id: '7108090017',
    districtId: '7108090',
    name: 'Kanang',
  },
  {
    id: '7108090018',
    districtId: '7108090',
    name: 'Lia',
  },
  {
    id: '7108090019',
    districtId: '7108090',
    name: 'Deahe',
  },
  {
    id: '7108090020',
    districtId: '7108090',
    name: 'Apelawo',
  },
  {
    id: '7108090021',
    districtId: '7108090',
    name: 'Bukide',
  },
  {
    id: '7108090022',
    districtId: '7108090',
    name: 'Dame I',
  },
  {
    id: '7108090023',
    districtId: '7108090',
    name: 'Karalung I',
  },
  {
    id: '7108090024',
    districtId: '7108090',
    name: 'Lia I',
  },
  {
    id: '7108100001',
    districtId: '7108100',
    name: 'Kinali',
  },
  {
    id: '7108100002',
    districtId: '7108100',
    name: 'Hiung',
  },
  {
    id: '7108100003',
    districtId: '7108100',
    name: 'Kiawang',
  },
  {
    id: '7108100004',
    districtId: '7108100',
    name: 'Kawahang',
  },
  {
    id: '7108100005',
    districtId: '7108100',
    name: 'Batubulan',
  },
  {
    id: '7108100006',
    districtId: '7108100',
    name: 'Nameng',
  },
  {
    id: '7108100007',
    districtId: '7108100',
    name: 'Mini',
  },
  {
    id: '7108100008',
    districtId: '7108100',
    name: 'Winangun',
  },
  {
    id: '7109010001',
    districtId: '7109010',
    name: 'Ratatotok Timur',
  },
  {
    id: '7109010002',
    districtId: '7109010',
    name: 'Ratatotok Dua',
  },
  {
    id: '7109010003',
    districtId: '7109010',
    name: 'Ratatotok Satu',
  },
  {
    id: '7109010004',
    districtId: '7109010',
    name: 'Ratatotok Selatan',
  },
  {
    id: '7109010005',
    districtId: '7109010',
    name: 'Soyowan',
  },
  {
    id: '7109010006',
    districtId: '7109010',
    name: 'Moreah',
  },
  {
    id: '7109010007',
    districtId: '7109010',
    name: 'Moreah Satu',
  },
  {
    id: '7109010008',
    districtId: '7109010',
    name: 'Basaan',
  },
  {
    id: '7109010009',
    districtId: '7109010',
    name: 'Basaan Satu',
  },
  {
    id: '7109010010',
    districtId: '7109010',
    name: 'Ratatotok Muara',
  },
  {
    id: '7109010011',
    districtId: '7109010',
    name: 'Ratatotok Tengah',
  },
  {
    id: '7109010012',
    districtId: '7109010',
    name: 'Ratatotok',
  },
  {
    id: '7109010013',
    districtId: '7109010',
    name: 'Ratatotok Utara',
  },
  {
    id: '7109010014',
    districtId: '7109010',
    name: 'Ratatotok Tenggara',
  },
  {
    id: '7109010015',
    districtId: '7109010',
    name: 'Basaan Dua',
  },
  {
    id: '7109020001',
    districtId: '7109020',
    name: 'Minanga',
  },
  {
    id: '7109020002',
    districtId: '7109020',
    name: 'Minanga Satu',
  },
  {
    id: '7109020003',
    districtId: '7109020',
    name: 'Makalu',
  },
  {
    id: '7109020004',
    districtId: '7109020',
    name: 'Tumbak',
  },
  {
    id: '7109020005',
    districtId: '7109020',
    name: 'Tatengesan',
  },
  {
    id: '7109020006',
    districtId: '7109020',
    name: 'Bentenan',
  },
  {
    id: '7109020007',
    districtId: '7109020',
    name: 'Wiau',
  },
  {
    id: '7109020008',
    districtId: '7109020',
    name: 'Bentenan Indah',
  },
  {
    id: '7109020009',
    districtId: '7109020',
    name: 'Minanga Timur',
  },
  {
    id: '7109020010',
    districtId: '7109020',
    name: 'Minanga Dua',
  },
  {
    id: '7109020011',
    districtId: '7109020',
    name: 'Minanga Tiga',
  },
  {
    id: '7109020012',
    districtId: '7109020',
    name: 'Makalu Selatan',
  },
  {
    id: '7109020013',
    districtId: '7109020',
    name: 'Tumbak Madani',
  },
  {
    id: '7109020014',
    districtId: '7109020',
    name: 'Tatengesan Satu',
  },
  {
    id: '7109020015',
    districtId: '7109020',
    name: 'Bentenan Satu',
  },
  {
    id: '7109030010',
    districtId: '7109030',
    name: 'Mangkit',
  },
  {
    id: '7109030011',
    districtId: '7109030',
    name: 'Beringin',
  },
  {
    id: '7109030012',
    districtId: '7109030',
    name: 'Borgo',
  },
  {
    id: '7109030013',
    districtId: '7109030',
    name: 'Belang',
  },
  {
    id: '7109030015',
    districtId: '7109030',
    name: 'Tababo',
  },
  {
    id: '7109030016',
    districtId: '7109030',
    name: 'Watuliney',
  },
  {
    id: '7109030017',
    districtId: '7109030',
    name: 'Molompar',
  },
  {
    id: '7109030018',
    districtId: '7109030',
    name: 'Buku Utara',
  },
  {
    id: '7109030019',
    districtId: '7109030',
    name: 'Buku Selatan',
  },
  {
    id: '7109030020',
    districtId: '7109030',
    name: 'Borgo Satu',
  },
  {
    id: '7109030021',
    districtId: '7109030',
    name: 'Ponosakan Belang',
  },
  {
    id: '7109030022',
    districtId: '7109030',
    name: 'Buku Tengah',
  },
  {
    id: '7109030023',
    districtId: '7109030',
    name: 'Tababo Selatan',
  },
  {
    id: '7109030024',
    districtId: '7109030',
    name: 'Watuliney Tengah',
  },
  {
    id: '7109030025',
    districtId: '7109030',
    name: 'Watuliney Indah',
  },
  {
    id: '7109030026',
    districtId: '7109030',
    name: 'Molompar Utara',
  },
  {
    id: '7109030027',
    districtId: '7109030',
    name: 'Molompar Timur',
  },
  {
    id: '7109030028',
    districtId: '7109030',
    name: 'Ponosakan Indah',
  },
  {
    id: '7109030029',
    districtId: '7109030',
    name: 'Buku Tenggara',
  },
  {
    id: '7109040006',
    districtId: '7109040',
    name: 'Rasi',
  },
  {
    id: '7109040007',
    districtId: '7109040',
    name: 'Tosuraya',
  },
  {
    id: '7109040008',
    districtId: '7109040',
    name: 'Lowu Satu',
  },
  {
    id: '7109040009',
    districtId: '7109040',
    name: 'Lowu Dua',
  },
  {
    id: '7109040010',
    districtId: '7109040',
    name: 'Wawali',
  },
  {
    id: '7109040016',
    districtId: '7109040',
    name: 'Rasi Satu',
  },
  {
    id: '7109040017',
    districtId: '7109040',
    name: 'Tosuraya Barat',
  },
  {
    id: '7109040018',
    districtId: '7109040',
    name: 'Tosuraya Selatan',
  },
  {
    id: '7109040019',
    districtId: '7109040',
    name: 'Lowu Utara',
  },
  {
    id: '7109040020',
    districtId: '7109040',
    name: 'Nataan',
  },
  {
    id: '7109040021',
    districtId: '7109040',
    name: 'Wawali Pasan',
  },
  {
    id: '7109041001',
    districtId: '7109041',
    name: 'Poniki',
  },
  {
    id: '7109041002',
    districtId: '7109041',
    name: 'Maulit',
  },
  {
    id: '7109041003',
    districtId: '7109041',
    name: 'Towuntu',
  },
  {
    id: '7109041004',
    districtId: '7109041',
    name: 'Towuntu Barat',
  },
  {
    id: '7109041005',
    districtId: '7109041',
    name: 'Towuntu Timur',
  },
  {
    id: '7109041006',
    districtId: '7109041',
    name: 'Tolombukan',
  },
  {
    id: '7109041007',
    districtId: '7109041',
    name: 'Tolombukan Barat',
  },
  {
    id: '7109041008',
    districtId: '7109041',
    name: 'Tolombukan Satu',
  },
  {
    id: '7109041009',
    districtId: '7109041',
    name: 'Liwutung',
  },
  {
    id: '7109041010',
    districtId: '7109041',
    name: 'Liwutung Satu',
  },
  {
    id: '7109041011',
    districtId: '7109041',
    name: 'Liwutung Dua',
  },
  {
    id: '7109042001',
    districtId: '7109042',
    name: 'Wioy',
  },
  {
    id: '7109042002',
    districtId: '7109042',
    name: 'Wioy Satu',
  },
  {
    id: '7109042003',
    districtId: '7109042',
    name: 'Wioy Dua',
  },
  {
    id: '7109042004',
    districtId: '7109042',
    name: 'Wioy Tiga',
  },
  {
    id: '7109042005',
    districtId: '7109042',
    name: 'Wioy Timur',
  },
  {
    id: '7109042006',
    districtId: '7109042',
    name: 'Wongkai',
  },
  {
    id: '7109042007',
    districtId: '7109042',
    name: 'Wongkai Satu',
  },
  {
    id: '7109042008',
    districtId: '7109042',
    name: 'Pangu',
  },
  {
    id: '7109042009',
    districtId: '7109042',
    name: 'Pangu Satu',
  },
  {
    id: '7109042010',
    districtId: '7109042',
    name: 'Pangu Dua',
  },
  {
    id: '7109050003',
    districtId: '7109050',
    name: 'Tonsawang',
  },
  {
    id: '7109050009',
    districtId: '7109050',
    name: 'Tombatu Satu',
  },
  {
    id: '7109050015',
    districtId: '7109050',
    name: 'Kali',
  },
  {
    id: '7109050029',
    districtId: '7109050',
    name: 'Tombatu',
  },
  {
    id: '7109050030',
    districtId: '7109050',
    name: 'Betelen Satu',
  },
  {
    id: '7109050031',
    districtId: '7109050',
    name: 'Kali Oki',
  },
  {
    id: '7109050032',
    districtId: '7109050',
    name: 'Tonsawang Satu',
  },
  {
    id: '7109050033',
    districtId: '7109050',
    name: 'Tombatu Tiga Timur',
  },
  {
    id: '7109050034',
    districtId: '7109050',
    name: 'Tombatu Tiga Selatan',
  },
  {
    id: '7109050035',
    districtId: '7109050',
    name: 'Pisa',
  },
  {
    id: '7109051001',
    districtId: '7109051',
    name: 'Molompar Satu',
  },
  {
    id: '7109051002',
    districtId: '7109051',
    name: 'Molompar',
  },
  {
    id: '7109051003',
    districtId: '7109051',
    name: 'Molompar Atas',
  },
  {
    id: '7109051004',
    districtId: '7109051',
    name: 'Molompar Dua',
  },
  {
    id: '7109051005',
    districtId: '7109051',
    name: 'Molompar Dua Utara',
  },
  {
    id: '7109051006',
    districtId: '7109051',
    name: 'Molompar Dua Selatan',
  },
  {
    id: '7109051007',
    districtId: '7109051',
    name: 'Esandom',
  },
  {
    id: '7109051008',
    districtId: '7109051',
    name: 'Esandom Satu',
  },
  {
    id: '7109051009',
    districtId: '7109051',
    name: 'Esandom Dua',
  },
  {
    id: '7109051011',
    districtId: '7109051',
    name: 'Mundung Satu',
  },
  {
    id: '7109052001',
    districtId: '7109052',
    name: 'Kuyanga',
  },
  {
    id: '7109052002',
    districtId: '7109052',
    name: 'Kuyanga Satu',
  },
  {
    id: '7109052003',
    districtId: '7109052',
    name: 'Tombatu Dua',
  },
  {
    id: '7109052004',
    districtId: '7109052',
    name: 'Tombatu Dua Utara',
  },
  {
    id: '7109052005',
    districtId: '7109052',
    name: 'Tombatu Dua Barat',
  },
  {
    id: '7109052006',
    districtId: '7109052',
    name: 'Tombatu Dua Tengah',
  },
  {
    id: '7109052007',
    districtId: '7109052',
    name: 'Tombatu Tiga',
  },
  {
    id: '7109052008',
    districtId: '7109052',
    name: 'Tombatu Tiga Tengah',
  },
  {
    id: '7109052009',
    districtId: '7109052',
    name: 'Winorangian',
  },
  {
    id: '7109052010',
    districtId: '7109052',
    name: 'Winorangian Satu',
  },
  {
    id: '7109060009',
    districtId: '7109060',
    name: 'Ranoketang Atas',
  },
  {
    id: '7109060010',
    districtId: '7109060',
    name: 'Toundanou',
  },
  {
    id: '7109060011',
    districtId: '7109060',
    name: 'Lobu Dua',
  },
  {
    id: '7109060012',
    districtId: '7109060',
    name: 'Lobu Satu',
  },
  {
    id: '7109060015',
    districtId: '7109060',
    name: 'Toundanou Satu',
  },
  {
    id: '7109060018',
    districtId: '7109060',
    name: 'Ranoketang Atas Satu',
  },
  {
    id: '7109060019',
    districtId: '7109060',
    name: 'Toundanou Atas',
  },
  {
    id: '7109060020',
    districtId: '7109060',
    name: 'Lobu',
  },
  {
    id: '7109060021',
    districtId: '7109060',
    name: 'Lobu Kota',
  },
  {
    id: '7109060022',
    districtId: '7109060',
    name: 'Lobu Atas',
  },
  {
    id: '7109061001',
    districtId: '7109061',
    name: 'Lowantag',
  },
  {
    id: '7109061002',
    districtId: '7109061',
    name: 'Banga',
  },
  {
    id: '7109061003',
    districtId: '7109061',
    name: 'Suhuyon',
  },
  {
    id: '7109061004',
    districtId: '7109061',
    name: 'Tambelang',
  },
  {
    id: '7109061005',
    districtId: '7109061',
    name: 'Bunag',
  },
  {
    id: '7109061006',
    districtId: '7109061',
    name: 'Ranoako',
  },
  {
    id: '7109061007',
    districtId: '7109061',
    name: 'Kalait',
  },
  {
    id: '7109061008',
    districtId: '7109061',
    name: 'Kalait Satu',
  },
  {
    id: '7109061009',
    districtId: '7109061',
    name: 'Kalait Dua',
  },
  {
    id: '7109061010',
    districtId: '7109061',
    name: 'Kalait Tiga',
  },
  {
    id: '7109062001',
    districtId: '7109062',
    name: 'Silian Dua',
  },
  {
    id: '7109062002',
    districtId: '7109062',
    name: 'Silian Tengah',
  },
  {
    id: '7109062003',
    districtId: '7109062',
    name: 'Silian Kota',
  },
  {
    id: '7109062004',
    districtId: '7109062',
    name: 'Silian Satu',
  },
  {
    id: '7109062005',
    districtId: '7109062',
    name: 'Silian Selatan',
  },
  {
    id: '7109062006',
    districtId: '7109062',
    name: 'Silian Tiga',
  },
  {
    id: '7109062007',
    districtId: '7109062',
    name: 'Silian Barat',
  },
  {
    id: '7109062008',
    districtId: '7109062',
    name: 'Silian',
  },
  {
    id: '7109062009',
    districtId: '7109062',
    name: 'Silian Utara',
  },
  {
    id: '7109062010',
    districtId: '7109062',
    name: 'Silian Timur',
  },
  {
    id: '7110010001',
    districtId: '7110010',
    name: 'Lion',
  },
  {
    id: '7110010002',
    districtId: '7110010',
    name: 'Saibuah',
  },
  {
    id: '7110010003',
    districtId: '7110010',
    name: 'Meyambanga',
  },
  {
    id: '7110010004',
    districtId: '7110010',
    name: 'Tonala',
  },
  {
    id: '7110010005',
    districtId: '7110010',
    name: 'Manggadaa',
  },
  {
    id: '7110010006',
    districtId: '7110010',
    name: 'Momalia II',
  },
  {
    id: '7110010007',
    districtId: '7110010',
    name: 'Momalia  I',
  },
  {
    id: '7110010008',
    districtId: '7110010',
    name: 'Pilolahunga',
  },
  {
    id: '7110010009',
    districtId: '7110010',
    name: 'Luwoo',
  },
  {
    id: '7110010010',
    districtId: '7110010',
    name: 'Sakti',
  },
  {
    id: '7110010011',
    districtId: '7110010',
    name: 'Sinombayuga',
  },
  {
    id: '7110010016',
    districtId: '7110010',
    name: 'Iloheluma',
  },
  {
    id: '7110010020',
    districtId: '7110010',
    name: 'Molosipat',
  },
  {
    id: '7110010021',
    districtId: '7110010',
    name: 'Meyambanga Timur',
  },
  {
    id: '7110010022',
    districtId: '7110010',
    name: 'Momalia Tiga',
  },
  {
    id: '7110010023',
    districtId: '7110010',
    name: 'Inosota',
  },
  {
    id: '7110011001',
    districtId: '7110011',
    name: 'Milangodaa Barat',
  },
  {
    id: '7110011002',
    districtId: '7110011',
    name: 'Milangodaa',
  },
  {
    id: '7110011003',
    districtId: '7110011',
    name: 'Tolutu',
  },
  {
    id: '7110011004',
    districtId: '7110011',
    name: 'Botuliodu',
  },
  {
    id: '7110011005',
    districtId: '7110011',
    name: 'Nunuka Raya',
  },
  {
    id: '7110011006',
    districtId: '7110011',
    name: 'Pakuku Jaya',
  },
  {
    id: '7110011007',
    districtId: '7110011',
    name: 'Milangodaa Utara',
  },
  {
    id: '7110020008',
    districtId: '7110020',
    name: 'Tangagah',
  },
  {
    id: '7110020009',
    districtId: '7110020',
    name: 'Dudepo',
  },
  {
    id: '7110020010',
    districtId: '7110020',
    name: 'Pinolantungan',
  },
  {
    id: '7110020011',
    districtId: '7110020',
    name: 'Salongo',
  },
  {
    id: '7110020012',
    districtId: '7110020',
    name: 'Soguo',
  },
  {
    id: '7110020013',
    districtId: '7110020',
    name: 'Toluaya',
  },
  {
    id: '7110020014',
    districtId: '7110020',
    name: 'Molibagu',
  },
  {
    id: '7110020015',
    districtId: '7110020',
    name: 'Popodu',
  },
  {
    id: '7110020016',
    districtId: '7110020',
    name: 'Sondana',
  },
  {
    id: '7110020017',
    districtId: '7110020',
    name: 'Tolondadu II',
  },
  {
    id: '7110020018',
    districtId: '7110020',
    name: 'Tolondadu I',
  },
  {
    id: '7110020019',
    districtId: '7110020',
    name: 'Tolondadu',
  },
  {
    id: '7110020020',
    districtId: '7110020',
    name: 'Tabilaa',
  },
  {
    id: '7110020022',
    districtId: '7110020',
    name: 'Pintadia',
  },
  {
    id: '7110020023',
    districtId: '7110020',
    name: 'Salongo Timur',
  },
  {
    id: '7110020025',
    districtId: '7110020',
    name: 'Salongo Barat',
  },
  {
    id: '7110020028',
    districtId: '7110020',
    name: 'Dudepo Barat',
  },
  {
    id: '7110021001',
    districtId: '7110021',
    name: 'Pangia',
  },
  {
    id: '7110021002',
    districtId: '7110021',
    name: 'Soputa',
  },
  {
    id: '7110021003',
    districtId: '7110021',
    name: 'Sinandaka',
  },
  {
    id: '7110021004',
    districtId: '7110021',
    name: 'Bakida',
  },
  {
    id: '7110021005',
    districtId: '7110021',
    name: 'Duminanga',
  },
  {
    id: '7110021006',
    districtId: '7110021',
    name: 'Biniha',
  },
  {
    id: '7110021007',
    districtId: '7110021',
    name: 'Biniha Timur',
  },
  {
    id: '7110021008',
    districtId: '7110021',
    name: 'Motolohu',
  },
  {
    id: '7110021009',
    districtId: '7110021',
    name: 'Trans Patoa',
  },
  {
    id: '7110021010',
    districtId: '7110021',
    name: 'Biniha Selatan',
  },
  {
    id: '7110021011',
    districtId: '7110021',
    name: 'Halabolu',
  },
  {
    id: '7110030001',
    districtId: '7110030',
    name: 'Linawan',
  },
  {
    id: '7110030002',
    districtId: '7110030',
    name: 'Linawan I',
  },
  {
    id: '7110030004',
    districtId: '7110030',
    name: 'Ilomata',
  },
  {
    id: '7110030005',
    districtId: '7110030',
    name: 'Pinolosian Selatan',
  },
  {
    id: '7110030006',
    districtId: '7110030',
    name: 'Pinolosian',
  },
  {
    id: '7110030007',
    districtId: '7110030',
    name: 'Tolotoyon',
  },
  {
    id: '7110030008',
    districtId: '7110030',
    name: 'Kombot',
  },
  {
    id: '7110030009',
    districtId: '7110030',
    name: 'Lungkap',
  },
  {
    id: '7110030010',
    districtId: '7110030',
    name: 'Kombot Timur',
  },
  {
    id: '7110040001',
    districtId: '7110040',
    name: 'Mataindo',
  },
  {
    id: '7110040002',
    districtId: '7110040',
    name: 'Torosik',
  },
  {
    id: '7110040003',
    districtId: '7110040',
    name: 'Adow Selatan',
  },
  {
    id: '7110040004',
    districtId: '7110040',
    name: 'Adow',
  },
  {
    id: '7110040005',
    districtId: '7110040',
    name: 'Tobayagan',
  },
  {
    id: '7110040006',
    districtId: '7110040',
    name: 'Deaga',
  },
  {
    id: '7110040007',
    districtId: '7110040',
    name: 'Tobayagan Selatan',
  },
  {
    id: '7110040008',
    districtId: '7110040',
    name: 'Mataindo Utara',
  },
  {
    id: '7110050001',
    districtId: '7110050',
    name: 'Motandoi',
  },
  {
    id: '7110050002',
    districtId: '7110050',
    name: 'Dumagin B',
  },
  {
    id: '7110050003',
    districtId: '7110050',
    name: 'Dumagin A',
  },
  {
    id: '7110050004',
    districtId: '7110050',
    name: 'Dayow',
  },
  {
    id: '7110050005',
    districtId: '7110050',
    name: 'Pidung',
  },
  {
    id: '7110050006',
    districtId: '7110050',
    name: 'Onggunoi',
  },
  {
    id: '7110050007',
    districtId: '7110050',
    name: 'Modisi',
  },
  {
    id: '7110050008',
    districtId: '7110050',
    name: 'Posilagon',
  },
  {
    id: '7110050009',
    districtId: '7110050',
    name: 'Iligon',
  },
  {
    id: '7110050010',
    districtId: '7110050',
    name: 'Motandoi Selatan',
  },
  {
    id: '7110050011',
    districtId: '7110050',
    name: 'Perjuangan',
  },
  {
    id: '7110050012',
    districtId: '7110050',
    name: 'Onggunoi Selatan',
  },
  {
    id: '7111010001',
    districtId: '7111010',
    name: 'Jiko Belanga',
  },
  {
    id: '7111010002',
    districtId: '7111010',
    name: 'Matabulu',
  },
  {
    id: '7111010003',
    districtId: '7111010',
    name: 'Loyow',
  },
  {
    id: '7111010004',
    districtId: '7111010',
    name: 'Iyok',
  },
  {
    id: '7111010005',
    districtId: '7111010',
    name: 'Nuangan',
  },
  {
    id: '7111010006',
    districtId: '7111010',
    name: 'Nuangan I',
  },
  {
    id: '7111010007',
    districtId: '7111010',
    name: 'Idumun',
  },
  {
    id: '7111010009',
    districtId: '7111010',
    name: 'B A I',
  },
  {
    id: '7111010016',
    districtId: '7111010',
    name: 'Matabulu Timur',
  },
  {
    id: '7111010020',
    districtId: '7111010',
    name: 'Nuangan Selatan',
  },
  {
    id: '7111010021',
    districtId: '7111010',
    name: 'Nuangan Barat',
  },
  {
    id: '7111011001',
    districtId: '7111011',
    name: 'Jiko',
  },
  {
    id: '7111011002',
    districtId: '7111011',
    name: 'Jiko Utara',
  },
  {
    id: '7111011003',
    districtId: '7111011',
    name: 'Molobog Barat',
  },
  {
    id: '7111011004',
    districtId: '7111011',
    name: 'Molobog',
  },
  {
    id: '7111011005',
    districtId: '7111011',
    name: 'Atoga',
  },
  {
    id: '7111011006',
    districtId: '7111011',
    name: 'Atoga Timur',
  },
  {
    id: '7111011007',
    districtId: '7111011',
    name: 'Motongkad Selatan',
  },
  {
    id: '7111011008',
    districtId: '7111011',
    name: 'Motongkad',
  },
  {
    id: '7111011009',
    districtId: '7111011',
    name: 'Motongkad Tengah',
  },
  {
    id: '7111011010',
    districtId: '7111011',
    name: 'Motongkad Utara',
  },
  {
    id: '7111020001',
    districtId: '7111020',
    name: 'Dodap',
  },
  {
    id: '7111020002',
    districtId: '7111020',
    name: 'Dodap Pantai',
  },
  {
    id: '7111020003',
    districtId: '7111020',
    name: 'Togid',
  },
  {
    id: '7111020004',
    districtId: '7111020',
    name: 'Tutuyan II',
  },
  {
    id: '7111020005',
    districtId: '7111020',
    name: 'Tutuyan',
  },
  {
    id: '7111020006',
    districtId: '7111020',
    name: 'Tutuyan III',
  },
  {
    id: '7111020007',
    districtId: '7111020',
    name: 'Tombolikat Selatan',
  },
  {
    id: '7111020008',
    districtId: '7111020',
    name: 'Tombolikat',
  },
  {
    id: '7111020009',
    districtId: '7111020',
    name: 'Kayumoyondi',
  },
  {
    id: '7111020010',
    districtId: '7111020',
    name: 'Dodap Mikasa',
  },
  {
    id: '7111030001',
    districtId: '7111030',
    name: 'Paret',
  },
  {
    id: '7111030002',
    districtId: '7111030',
    name: 'Kotabunan',
  },
  {
    id: '7111030003',
    districtId: '7111030',
    name: 'Bukaka',
  },
  {
    id: '7111030004',
    districtId: '7111030',
    name: 'Bulawan',
  },
  {
    id: '7111030005',
    districtId: '7111030',
    name: 'Buyat',
  },
  {
    id: '7111030006',
    districtId: '7111030',
    name: 'Buyat I',
  },
  {
    id: '7111030007',
    districtId: '7111030',
    name: 'Buyat II',
  },
  {
    id: '7111030008',
    districtId: '7111030',
    name: 'Buyat Barat',
  },
  {
    id: '7111030009',
    districtId: '7111030',
    name: 'Buyat Selatan',
  },
  {
    id: '7111030010',
    districtId: '7111030',
    name: 'Buyat Tengah',
  },
  {
    id: '7111030011',
    districtId: '7111030',
    name: 'Bulawan I',
  },
  {
    id: '7111030012',
    districtId: '7111030',
    name: 'Bulawan II',
  },
  {
    id: '7111030013',
    districtId: '7111030',
    name: 'Kotabunan Selatan',
  },
  {
    id: '7111030014',
    districtId: '7111030',
    name: 'Kotabunan Barat',
  },
  {
    id: '7111030015',
    districtId: '7111030',
    name: 'Paret Timur',
  },
  {
    id: '7111040001',
    districtId: '7111040',
    name: 'Modayag II',
  },
  {
    id: '7111040002',
    districtId: '7111040',
    name: 'Modayag',
  },
  {
    id: '7111040003',
    districtId: '7111040',
    name: 'Modayag III',
  },
  {
    id: '7111040004',
    districtId: '7111040',
    name: 'Tobongon',
  },
  {
    id: '7111040005',
    districtId: '7111040',
    name: 'Badaro',
  },
  {
    id: '7111040006',
    districtId: '7111040',
    name: 'Lanut',
  },
  {
    id: '7111040007',
    districtId: '7111040',
    name: 'Buyandi',
  },
  {
    id: '7111040008',
    districtId: '7111040',
    name: 'Purworejo',
  },
  {
    id: '7111040009',
    districtId: '7111040',
    name: 'Purworejo Tengah',
  },
  {
    id: '7111040010',
    districtId: '7111040',
    name: 'Purworejo Timur',
  },
  {
    id: '7111040011',
    districtId: '7111040',
    name: 'Liberia Timur',
  },
  {
    id: '7111040012',
    districtId: '7111040',
    name: 'Liberia',
  },
  {
    id: '7111040018',
    districtId: '7111040',
    name: 'Candi Rejo',
  },
  {
    id: '7111040023',
    districtId: '7111040',
    name: 'Sumber Rejo',
  },
  {
    id: '7111041001',
    districtId: '7111041',
    name: 'Moat',
  },
  {
    id: '7111041002',
    districtId: '7111041',
    name: 'Bongkudai Selatan',
  },
  {
    id: '7111041003',
    districtId: '7111041',
    name: 'Bongkudai Baru',
  },
  {
    id: '7111041004',
    districtId: '7111041',
    name: 'Bongkudai Utara',
  },
  {
    id: '7111041005',
    districtId: '7111041',
    name: 'Bongkudai Timur',
  },
  {
    id: '7111041006',
    districtId: '7111041',
    name: 'Guaan',
  },
  {
    id: '7111041007',
    districtId: '7111041',
    name: 'Mototompiaan',
  },
  {
    id: '7111041008',
    districtId: '7111041',
    name: 'Mokitompia',
  },
  {
    id: '7111041009',
    districtId: '7111041',
    name: 'Kokapoy',
  },
  {
    id: '7111041010',
    districtId: '7111041',
    name: 'Kokapoy Timur',
  },
  {
    id: '7111050001',
    districtId: '7111050',
    name: 'Moyongkota Baru',
  },
  {
    id: '7111050002',
    districtId: '7111050',
    name: 'Moyongkota',
  },
  {
    id: '7111050003',
    districtId: '7111050',
    name: 'Bangunan Wuwuk',
  },
  {
    id: '7111050004',
    districtId: '7111050',
    name: 'Bongkudai Barat',
  },
  {
    id: '7111050005',
    districtId: '7111050',
    name: 'Bongkudai',
  },
  {
    id: '7111050006',
    districtId: '7111050',
    name: 'Pinonobatuan',
  },
  {
    id: '7111050007',
    districtId: '7111050',
    name: 'Moonow',
  },
  {
    id: '7111050008',
    districtId: '7111050',
    name: 'Inaton',
  },
  {
    id: '7111050009',
    districtId: '7111050',
    name: 'Bangunan Wuwuk Timur',
  },
  {
    id: '7111050010',
    districtId: '7111050',
    name: 'Tangaton',
  },
  {
    id: '7171010001',
    districtId: '7171010',
    name: 'Malalayang II',
  },
  {
    id: '7171010002',
    districtId: '7171010',
    name: 'Malalayang I',
  },
  {
    id: '7171010004',
    districtId: '7171010',
    name: 'Bahu',
  },
  {
    id: '7171010005',
    districtId: '7171010',
    name: 'Kleak',
  },
  {
    id: '7171010006',
    districtId: '7171010',
    name: 'Malalayang I Timur',
  },
  {
    id: '7171010007',
    districtId: '7171010',
    name: 'Malalayang I Barat',
  },
  {
    id: '7171010008',
    districtId: '7171010',
    name: 'Winangun I',
  },
  {
    id: '7171010009',
    districtId: '7171010',
    name: 'Winangun II',
  },
  {
    id: '7171010010',
    districtId: '7171010',
    name: 'Batu Kota',
  },
  {
    id: '7171020004',
    districtId: '7171020',
    name: 'Ranotana',
  },
  {
    id: '7171020006',
    districtId: '7171020',
    name: 'Sario Kota Baru',
  },
  {
    id: '7171020007',
    districtId: '7171020',
    name: 'Sario',
  },
  {
    id: '7171020008',
    districtId: '7171020',
    name: 'Sario Tumpaan',
  },
  {
    id: '7171020009',
    districtId: '7171020',
    name: 'Sario Utara',
  },
  {
    id: '7171020011',
    districtId: '7171020',
    name: 'Titiwungen Selatan',
  },
  {
    id: '7171020012',
    districtId: '7171020',
    name: 'Titiwungen Utara',
  },
  {
    id: '7171021001',
    districtId: '7171021',
    name: 'Karombasan Utara',
  },
  {
    id: '7171021002',
    districtId: '7171021',
    name: 'Karombasan Selatan',
  },
  {
    id: '7171021003',
    districtId: '7171021',
    name: 'Ranotana Weru',
  },
  {
    id: '7171021004',
    districtId: '7171021',
    name: 'Pakowa',
  },
  {
    id: '7171021005',
    districtId: '7171021',
    name: 'Bumi Nyiur',
  },
  {
    id: '7171021006',
    districtId: '7171021',
    name: 'Teling Atas',
  },
  {
    id: '7171021007',
    districtId: '7171021',
    name: 'Wanea',
  },
  {
    id: '7171021008',
    districtId: '7171021',
    name: 'Tanjung Batu',
  },
  {
    id: '7171021009',
    districtId: '7171021',
    name: 'Tingkulu',
  },
  {
    id: '7171030001',
    districtId: '7171030',
    name: 'Bumi Beringin',
  },
  {
    id: '7171030002',
    districtId: '7171030',
    name: 'Teling Bawah',
  },
  {
    id: '7171030010',
    districtId: '7171030',
    name: 'Tikala Kumaraka',
  },
  {
    id: '7171030011',
    districtId: '7171030',
    name: 'Mahakeret Barat',
  },
  {
    id: '7171030012',
    districtId: '7171030',
    name: 'Mahakeret Timur',
  },
  {
    id: '7171030013',
    districtId: '7171030',
    name: 'Wenang Utara',
  },
  {
    id: '7171030014',
    districtId: '7171030',
    name: 'Wenang Selatan',
  },
  {
    id: '7171030015',
    districtId: '7171030',
    name: 'Lawangirung',
  },
  {
    id: '7171030016',
    districtId: '7171030',
    name: 'Komo Luar',
  },
  {
    id: '7171030017',
    districtId: '7171030',
    name: 'Pinaesaan',
  },
  {
    id: '7171030018',
    districtId: '7171030',
    name: 'Istiqlal',
  },
  {
    id: '7171030019',
    districtId: '7171030',
    name: 'Calaca',
  },
  {
    id: '7171031001',
    districtId: '7171031',
    name: 'Banjer',
  },
  {
    id: '7171031002',
    districtId: '7171031',
    name: 'Tikala Baru',
  },
  {
    id: '7171031003',
    districtId: '7171031',
    name: 'Paal IV',
  },
  {
    id: '7171031004',
    districtId: '7171031',
    name: 'Taas',
  },
  {
    id: '7171031009',
    districtId: '7171031',
    name: 'Tikala Ares',
  },
  {
    id: '7171032001',
    districtId: '7171032',
    name: 'Ranomuut',
  },
  {
    id: '7171032002',
    districtId: '7171032',
    name: 'Perkamil',
  },
  {
    id: '7171032003',
    districtId: '7171032',
    name: 'Malendeng',
  },
  {
    id: '7171032004',
    districtId: '7171032',
    name: 'Dendengan Dalam',
  },
  {
    id: '7171032005',
    districtId: '7171032',
    name: 'Dendengan Luar',
  },
  {
    id: '7171032006',
    districtId: '7171032',
    name: 'Paal Dua',
  },
  {
    id: '7171032007',
    districtId: '7171032',
    name: 'Kairagi Weru',
  },
  {
    id: '7171040002',
    districtId: '7171040',
    name: 'Kairagi Satu',
  },
  {
    id: '7171040003',
    districtId: '7171040',
    name: 'Kairagi Dua',
  },
  {
    id: '7171040004',
    districtId: '7171040',
    name: 'Paniki Bawah',
  },
  {
    id: '7171040005',
    districtId: '7171040',
    name: 'Paniki Dua',
  },
  {
    id: '7171040006',
    districtId: '7171040',
    name: 'Lapangan',
  },
  {
    id: '7171040007',
    districtId: '7171040',
    name: 'Mapanget Barat',
  },
  {
    id: '7171040008',
    districtId: '7171040',
    name: 'Kima Atas',
  },
  {
    id: '7171040009',
    districtId: '7171040',
    name: 'Bengkol',
  },
  {
    id: '7171040010',
    districtId: '7171040',
    name: 'Buha',
  },
  {
    id: '7171040012',
    districtId: '7171040',
    name: 'Paniki Satu',
  },
  {
    id: '7171051001',
    districtId: '7171051',
    name: 'Karame',
  },
  {
    id: '7171051002',
    districtId: '7171051',
    name: 'Ketang Baru',
  },
  {
    id: '7171051003',
    districtId: '7171051',
    name: 'Wawonasa',
  },
  {
    id: '7171051004',
    districtId: '7171051',
    name: 'Ternate Baru',
  },
  {
    id: '7171051005',
    districtId: '7171051',
    name: 'Ternate Tanjung',
  },
  {
    id: '7171051006',
    districtId: '7171051',
    name: 'Kombos Barat',
  },
  {
    id: '7171051007',
    districtId: '7171051',
    name: 'Kombos Timur',
  },
  {
    id: '7171051008',
    districtId: '7171051',
    name: 'Singkil Satu',
  },
  {
    id: '7171051009',
    districtId: '7171051',
    name: 'Singkil Dua',
  },
  {
    id: '7171052001',
    districtId: '7171052',
    name: 'Sindulang Satu',
  },
  {
    id: '7171052002',
    districtId: '7171052',
    name: 'Kampung Islam',
  },
  {
    id: '7171052003',
    districtId: '7171052',
    name: 'Sindulang Dua',
  },
  {
    id: '7171052004',
    districtId: '7171052',
    name: 'Bitung Karang Ria',
  },
  {
    id: '7171052005',
    districtId: '7171052',
    name: 'Maasing',
  },
  {
    id: '7171052006',
    districtId: '7171052',
    name: 'Tuminting',
  },
  {
    id: '7171052007',
    districtId: '7171052',
    name: 'Mahawu',
  },
  {
    id: '7171052008',
    districtId: '7171052',
    name: 'Sumompo',
  },
  {
    id: '7171052009',
    districtId: '7171052',
    name: 'Tumumpa Satu',
  },
  {
    id: '7171052010',
    districtId: '7171052',
    name: 'Tumumpa Dua',
  },
  {
    id: '7171053001',
    districtId: '7171053',
    name: 'Bailang',
  },
  {
    id: '7171053002',
    districtId: '7171053',
    name: 'Molas',
  },
  {
    id: '7171053003',
    districtId: '7171053',
    name: 'Meras',
  },
  {
    id: '7171053004',
    districtId: '7171053',
    name: 'Tongkeina',
  },
  {
    id: '7171053005',
    districtId: '7171053',
    name: 'Pandu',
  },
  {
    id: '7171054001',
    districtId: '7171054',
    name: 'Bunaken',
  },
  {
    id: '7171054002',
    districtId: '7171054',
    name: 'Alung Banua',
  },
  {
    id: '7171054003',
    districtId: '7171054',
    name: 'Manado Tua Satu',
  },
  {
    id: '7171054004',
    districtId: '7171054',
    name: 'Manado Tua Dua',
  },
  {
    id: '7172010008',
    districtId: '7172010',
    name: 'Paceda',
  },
  {
    id: '7172010009',
    districtId: '7172010',
    name: 'Madidir Unet',
  },
  {
    id: '7172010010',
    districtId: '7172010',
    name: 'Madidir Ure',
  },
  {
    id: '7172010011',
    districtId: '7172010',
    name: 'Madidir Weru',
  },
  {
    id: '7172010012',
    districtId: '7172010',
    name: 'Kadoodan',
  },
  {
    id: '7172010015',
    districtId: '7172010',
    name: 'Wangurer Barat',
  },
  {
    id: '7172010016',
    districtId: '7172010',
    name: 'Wangurer Timur',
  },
  {
    id: '7172010017',
    districtId: '7172010',
    name: 'Wangurer Utara',
  },
  {
    id: '7172011001',
    districtId: '7172011',
    name: 'Tanjung Merah',
  },
  {
    id: '7172011002',
    districtId: '7172011',
    name: 'Sagerat',
  },
  {
    id: '7172011003',
    districtId: '7172011',
    name: 'Manembo Nembo Atas',
  },
  {
    id: '7172011004',
    districtId: '7172011',
    name: 'Manembo Nembo',
  },
  {
    id: '7172011011',
    districtId: '7172011',
    name: 'Sagerat Weru Satu',
  },
  {
    id: '7172011012',
    districtId: '7172011',
    name: 'Sagerat Weru Dua',
  },
  {
    id: '7172011013',
    districtId: '7172011',
    name: 'Tendeki',
  },
  {
    id: '7172011014',
    districtId: '7172011',
    name: 'Manembo-Nembo Tengah',
  },
  {
    id: '7172012001',
    districtId: '7172012',
    name: 'Girian Weru Satu',
  },
  {
    id: '7172012002',
    districtId: '7172012',
    name: 'Girian Bawah',
  },
  {
    id: '7172012003',
    districtId: '7172012',
    name: 'Wangurer',
  },
  {
    id: '7172012004',
    districtId: '7172012',
    name: 'Girian Indah',
  },
  {
    id: '7172012005',
    districtId: '7172012',
    name: 'Girian Weru Dua',
  },
  {
    id: '7172012006',
    districtId: '7172012',
    name: 'Girian Atas',
  },
  {
    id: '7172012007',
    districtId: '7172012',
    name: 'Girian Permai',
  },
  {
    id: '7172021001',
    districtId: '7172021',
    name: 'Pasirpanjang',
  },
  {
    id: '7172021002',
    districtId: '7172021',
    name: 'Paudean',
  },
  {
    id: '7172021003',
    districtId: '7172021',
    name: 'Batulubang',
  },
  {
    id: '7172021004',
    districtId: '7172021',
    name: 'Dorbolaang',
  },
  {
    id: '7172021005',
    districtId: '7172021',
    name: 'Pancuran',
  },
  {
    id: '7172021006',
    districtId: '7172021',
    name: 'Papusungan',
  },
  {
    id: '7172021007',
    districtId: '7172021',
    name: 'Kelapa Dua',
  },
  {
    id: '7172022001',
    districtId: '7172022',
    name: 'Mawali',
  },
  {
    id: '7172022002',
    districtId: '7172022',
    name: 'Pintukota',
  },
  {
    id: '7172022003',
    districtId: '7172022',
    name: 'Batukota',
  },
  {
    id: '7172022004',
    districtId: '7172022',
    name: 'Gunung Woka',
  },
  {
    id: '7172022005',
    districtId: '7172022',
    name: 'Posokan',
  },
  {
    id: '7172022006',
    districtId: '7172022',
    name: 'Motto',
  },
  {
    id: '7172022007',
    districtId: '7172022',
    name: 'Lirang',
  },
  {
    id: '7172022009',
    districtId: '7172022',
    name: 'Binuang',
  },
  {
    id: '7172022010',
    districtId: '7172022',
    name: 'Kareko',
  },
  {
    id: '7172030006',
    districtId: '7172030',
    name: 'Aertembaga Satu',
  },
  {
    id: '7172030007',
    districtId: '7172030',
    name: 'Tandu Rusa',
  },
  {
    id: '7172030008',
    districtId: '7172030',
    name: 'Makawidey',
  },
  {
    id: '7172030009',
    districtId: '7172030',
    name: 'Pinangunian',
  },
  {
    id: '7172030012',
    districtId: '7172030',
    name: 'Peteten Satu',
  },
  {
    id: '7172030013',
    districtId: '7172030',
    name: 'Peteten Dua',
  },
  {
    id: '7172030014',
    districtId: '7172030',
    name: 'Winenet Satu',
  },
  {
    id: '7172030015',
    districtId: '7172030',
    name: 'Winenet Dua',
  },
  {
    id: '7172030016',
    districtId: '7172030',
    name: 'Kasawari',
  },
  {
    id: '7172030017',
    districtId: '7172030',
    name: 'Aertembaga Dua',
  },
  {
    id: '7172031001',
    districtId: '7172031',
    name: 'Pakadoodan',
  },
  {
    id: '7172031002',
    districtId: '7172031',
    name: 'Bitung Barat Satu',
  },
  {
    id: '7172031003',
    districtId: '7172031',
    name: 'Bitung Barat Dua',
  },
  {
    id: '7172031004',
    districtId: '7172031',
    name: 'Kakenturan Satu',
  },
  {
    id: '7172031005',
    districtId: '7172031',
    name: 'Kakenturan Dua',
  },
  {
    id: '7172031006',
    districtId: '7172031',
    name: 'Bitung Tengah',
  },
  {
    id: '7172031007',
    districtId: '7172031',
    name: 'Bitung Timur',
  },
  {
    id: '7172031008',
    districtId: '7172031',
    name: 'Pateten Tiga',
  },
  {
    id: '7172040001',
    districtId: '7172040',
    name: 'Kumersot',
  },
  {
    id: '7172040003',
    districtId: '7172040',
    name: 'Pinokalan',
  },
  {
    id: '7172040004',
    districtId: '7172040',
    name: 'Tewaan',
  },
  {
    id: '7172040005',
    districtId: '7172040',
    name: 'Danowudu',
  },
  {
    id: '7172040006',
    districtId: '7172040',
    name: 'Dua Sudara',
  },
  {
    id: '7172040007',
    districtId: '7172040',
    name: 'Apela Dua',
  },
  {
    id: '7172040008',
    districtId: '7172040',
    name: 'Apela Satu',
  },
  {
    id: '7172040009',
    districtId: '7172040',
    name: 'Karondoran',
  },
  {
    id: '7172040010',
    districtId: '7172040',
    name: 'Pinasungkulan',
  },
  {
    id: '7172040012',
    districtId: '7172040',
    name: 'Batu Putih Atas',
  },
  {
    id: '7172040013',
    districtId: '7172040',
    name: 'Batu Putih  Bawah',
  },
  {
    id: '7173010001',
    districtId: '7173010',
    name: 'Tondangow',
  },
  {
    id: '7173010002',
    districtId: '7173010',
    name: 'Pangolombian',
  },
  {
    id: '7173010003',
    districtId: '7173010',
    name: 'Lahendong',
  },
  {
    id: '7173010004',
    districtId: '7173010',
    name: 'Pinaras',
  },
  {
    id: '7173010005',
    districtId: '7173010',
    name: 'Kampung Jawa',
  },
  {
    id: '7173010006',
    districtId: '7173010',
    name: 'Tumatangtang',
  },
  {
    id: '7173010007',
    districtId: '7173010',
    name: 'Lansot',
  },
  {
    id: '7173010008',
    districtId: '7173010',
    name: 'Uluindano',
  },
  {
    id: '7173010009',
    districtId: '7173010',
    name: 'Walian',
  },
  {
    id: '7173010010',
    districtId: '7173010',
    name: 'Walian Satu',
  },
  {
    id: '7173010011',
    districtId: '7173010',
    name: 'Walian Dua',
  },
  {
    id: '7173010012',
    districtId: '7173010',
    name: 'Tumatangtang Satu',
  },
  {
    id: '7173020001',
    districtId: '7173020',
    name: 'Matani Tiga',
  },
  {
    id: '7173020002',
    districtId: '7173020',
    name: 'Matani Dua',
  },
  {
    id: '7173020003',
    districtId: '7173020',
    name: 'Matani Satu',
  },
  {
    id: '7173020005',
    districtId: '7173020',
    name: 'Kolongan',
  },
  {
    id: '7173020011',
    districtId: '7173020',
    name: 'Kamasi',
  },
  {
    id: '7173020016',
    districtId: '7173020',
    name: 'Talete Satu',
  },
  {
    id: '7173020017',
    districtId: '7173020',
    name: 'Talete Dua',
  },
  {
    id: '7173020018',
    districtId: '7173020',
    name: 'Kolongan Satu',
  },
  {
    id: '7173020019',
    districtId: '7173020',
    name: 'Kamasi Satu',
  },
  {
    id: '7173021001',
    districtId: '7173021',
    name: 'Paslaten Dua',
  },
  {
    id: '7173021002',
    districtId: '7173021',
    name: 'Paslaten Satu',
  },
  {
    id: '7173021003',
    districtId: '7173021',
    name: 'Rurukan',
  },
  {
    id: '7173021004',
    districtId: '7173021',
    name: 'Rurukan Satu',
  },
  {
    id: '7173021005',
    districtId: '7173021',
    name: 'Kumelembuai',
  },
  {
    id: '7173022001',
    districtId: '7173022',
    name: 'Woloan Satu',
  },
  {
    id: '7173022002',
    districtId: '7173022',
    name: 'Woloan Dua',
  },
  {
    id: '7173022003',
    districtId: '7173022',
    name: 'Woloan Tiga',
  },
  {
    id: '7173022004',
    districtId: '7173022',
    name: 'Taratara Satu',
  },
  {
    id: '7173022005',
    districtId: '7173022',
    name: 'Taratara Dua',
  },
  {
    id: '7173022006',
    districtId: '7173022',
    name: 'Woloan Satu Utara',
  },
  {
    id: '7173022007',
    districtId: '7173022',
    name: 'Taratara',
  },
  {
    id: '7173022008',
    districtId: '7173022',
    name: 'Taratara Tiga',
  },
  {
    id: '7173030001',
    districtId: '7173030',
    name: 'Kayawu',
  },
  {
    id: '7173030002',
    districtId: '7173030',
    name: 'Wailan',
  },
  {
    id: '7173030003',
    districtId: '7173030',
    name: 'Kakaskasen Tiga',
  },
  {
    id: '7173030004',
    districtId: '7173030',
    name: 'Kakaskasen Dua',
  },
  {
    id: '7173030005',
    districtId: '7173030',
    name: 'Kakaskasen Satu',
  },
  {
    id: '7173030006',
    districtId: '7173030',
    name: 'Kinilow',
  },
  {
    id: '7173030007',
    districtId: '7173030',
    name: 'Tinoor Satu',
  },
  {
    id: '7173030008',
    districtId: '7173030',
    name: 'Tinoor Dua',
  },
  {
    id: '7173030009',
    districtId: '7173030',
    name: 'Kinilow Satu',
  },
  {
    id: '7173030010',
    districtId: '7173030',
    name: 'Kakaskasen',
  },
  {
    id: '7174010001',
    districtId: '7174010',
    name: 'Kopandakan  I',
  },
  {
    id: '7174010002',
    districtId: '7174010',
    name: 'Bungko',
  },
  {
    id: '7174010003',
    districtId: '7174010',
    name: 'Tabang',
  },
  {
    id: '7174010004',
    districtId: '7174010',
    name: 'Poyowa Besar I',
  },
  {
    id: '7174010005',
    districtId: '7174010',
    name: 'Poyowa Besar II',
  },
  {
    id: '7174010006',
    districtId: '7174010',
    name: 'Pobundayan',
  },
  {
    id: '7174010007',
    districtId: '7174010',
    name: 'Motoboi Kecil',
  },
  {
    id: '7174010008',
    districtId: '7174010',
    name: 'Mongondow',
  },
  {
    id: '7174010009',
    districtId: '7174010',
    name: 'Poyowa Kecil',
  },
  {
    id: '7174020001',
    districtId: '7174020',
    name: 'Matali',
  },
  {
    id: '7174020002',
    districtId: '7174020',
    name: 'Motoboi Besar',
  },
  {
    id: '7174020003',
    districtId: '7174020',
    name: 'Kobo Kecil',
  },
  {
    id: '7174020004',
    districtId: '7174020',
    name: 'Moyag',
  },
  {
    id: '7174020005',
    districtId: '7174020',
    name: 'Kobo Besar',
  },
  {
    id: '7174020006',
    districtId: '7174020',
    name: 'Tumobuy',
  },
  {
    id: '7174020007',
    districtId: '7174020',
    name: 'Sinindian',
  },
  {
    id: '7174020008',
    districtId: '7174020',
    name: 'Kotabangon',
  },
  {
    id: '7174020009',
    districtId: '7174020',
    name: 'Moyag Tampoan',
  },
  {
    id: '7174020010',
    districtId: '7174020',
    name: 'Moyag Todulan',
  },
  {
    id: '7174030001',
    districtId: '7174030',
    name: 'Mongkonai',
  },
  {
    id: '7174030002',
    districtId: '7174030',
    name: 'Molinow',
  },
  {
    id: '7174030003',
    districtId: '7174030',
    name: 'Mogolaing',
  },
  {
    id: '7174030004',
    districtId: '7174030',
    name: 'Gogagoman',
  },
  {
    id: '7174030005',
    districtId: '7174030',
    name: 'Kotamobagu',
  },
  {
    id: '7174030006',
    districtId: '7174030',
    name: 'Mongkonai Barat',
  },
  {
    id: '7174040001',
    districtId: '7174040',
    name: 'Upai',
  },
  {
    id: '7174040002',
    districtId: '7174040',
    name: 'Genggulang',
  },
  {
    id: '7174040003',
    districtId: '7174040',
    name: 'Biga',
  },
  {
    id: '7174040004',
    districtId: '7174040',
    name: 'Sia',
  },
  {
    id: '7174040005',
    districtId: '7174040',
    name: 'Pontodon',
  },
  {
    id: '7174040006',
    districtId: '7174040',
    name: 'Bilalang II',
  },
  {
    id: '7174040007',
    districtId: '7174040',
    name: 'Bilalang I',
  },
  {
    id: '7174040008',
    districtId: '7174040',
    name: 'Pontodon Timur',
  },
  {
    id: '7201030007',
    districtId: '7201030',
    name: 'Sobonon',
  },
  {
    id: '7201030008',
    districtId: '7201030',
    name: 'Bolonan',
  },
  {
    id: '7201030009',
    districtId: '7201030',
    name: 'Sakay',
  },
  {
    id: '7201030010',
    districtId: '7201030',
    name: 'Sambiut',
  },
  {
    id: '7201030011',
    districtId: '7201030',
    name: 'Tone',
  },
  {
    id: '7201030012',
    districtId: '7201030',
    name: 'Abason',
  },
  {
    id: '7201030013',
    districtId: '7201030',
    name: 'Salangano',
  },
  {
    id: '7201030014',
    districtId: '7201030',
    name: 'Batang Babasal',
  },
  {
    id: '7201030015',
    districtId: '7201030',
    name: 'Sampaka',
  },
  {
    id: '7201030016',
    districtId: '7201030',
    name: 'Lopito',
  },
  {
    id: '7201030017',
    districtId: '7201030',
    name: 'Kombutokan',
  },
  {
    id: '7201031001',
    districtId: '7201031',
    name: 'Tonuson',
  },
  {
    id: '7201031002',
    districtId: '7201031',
    name: 'Tobungku',
  },
  {
    id: '7201031003',
    districtId: '7201031',
    name: 'Nulion',
  },
  {
    id: '7201031005',
    districtId: '7201031',
    name: 'Kalumbatan',
  },
  {
    id: '7201031006',
    districtId: '7201031',
    name: 'Kanali',
  },
  {
    id: '7201031007',
    districtId: '7201031',
    name: 'Mata',
  },
  {
    id: '7201031008',
    districtId: '7201031',
    name: 'Lobuton',
  },
  {
    id: '7201040009',
    districtId: '7201040',
    name: 'Manggalai',
  },
  {
    id: '7201040010',
    districtId: '7201040',
    name: 'Ambelang',
  },
  {
    id: '7201040011',
    districtId: '7201040',
    name: 'Saiyong',
  },
  {
    id: '7201040012',
    districtId: '7201040',
    name: 'Tompudau',
  },
  {
    id: '7201040014',
    districtId: '7201040',
    name: 'Baka',
  },
  {
    id: '7201040015',
    districtId: '7201040',
    name: 'Bongganan',
  },
  {
    id: '7201040016',
    districtId: '7201040',
    name: 'Salakan',
  },
  {
    id: '7201040020',
    districtId: '7201040',
    name: 'Kautu',
  },
  {
    id: '7201040021',
    districtId: '7201040',
    name: 'Bakalan',
  },
  {
    id: '7201040022',
    districtId: '7201040',
    name: 'Bulungkobit',
  },
  {
    id: '7201040023',
    districtId: '7201040',
    name: 'Bungin',
  },
  {
    id: '7201041001',
    districtId: '7201041',
    name: 'Paisumosoni',
  },
  {
    id: '7201041002',
    districtId: '7201041',
    name: 'Tobing',
  },
  {
    id: '7201041003',
    districtId: '7201041',
    name: 'Tobungin',
  },
  {
    id: '7201041004',
    districtId: '7201041',
    name: 'Mansamat B',
  },
  {
    id: '7201041005',
    districtId: '7201041',
    name: 'Mansamat A',
  },
  {
    id: '7201041006',
    districtId: '7201041',
    name: 'Kampung Baru',
  },
  {
    id: '7201041007',
    districtId: '7201041',
    name: 'Tinangkung',
  },
  {
    id: '7201041008',
    districtId: '7201041',
    name: 'Gansal',
  },
  {
    id: '7201041009',
    districtId: '7201041',
    name: 'Bobu',
  },
  {
    id: '7201042001',
    districtId: '7201042',
    name: 'Palam',
  },
  {
    id: '7201042002',
    districtId: '7201042',
    name: 'Luk Sagu',
  },
  {
    id: '7201042003',
    districtId: '7201042',
    name: 'Tatakalai',
  },
  {
    id: '7201042004',
    districtId: '7201042',
    name: 'Ponding-Ponding',
  },
  {
    id: '7201042005',
    districtId: '7201042',
    name: 'Lalong',
  },
  {
    id: '7201042006',
    districtId: '7201042',
    name: 'Bampanga',
  },
  {
    id: '7201050001',
    districtId: '7201050',
    name: 'Mamulusan',
  },
  {
    id: '7201050002',
    districtId: '7201050',
    name: 'Kinandal',
  },
  {
    id: '7201050003',
    districtId: '7201050',
    name: 'Tomboniki',
  },
  {
    id: '7201050006',
    districtId: '7201050',
    name: 'Okumel',
  },
  {
    id: '7201050007',
    districtId: '7201050',
    name: 'Popidolon',
  },
  {
    id: '7201050008',
    districtId: '7201050',
    name: 'Tangkop',
  },
  {
    id: '7201050009',
    districtId: '7201050',
    name: 'Binuntuli',
  },
  {
    id: '7201050010',
    districtId: '7201050',
    name: 'Saleati',
  },
  {
    id: '7201050011',
    districtId: '7201050',
    name: 'Bajo',
  },
  {
    id: '7201050012',
    districtId: '7201050',
    name: 'Liang',
  },
  {
    id: '7201050014',
    districtId: '7201050',
    name: 'Balayon',
  },
  {
    id: '7201050015',
    districtId: '7201050',
    name: 'Basosol',
  },
  {
    id: '7201050016',
    districtId: '7201050',
    name: 'Boyomoute',
  },
  {
    id: '7201050019',
    districtId: '7201050',
    name: 'Apal',
  },
  {
    id: '7201050020',
    districtId: '7201050',
    name: 'Selekan',
  },
  {
    id: '7201050021',
    districtId: '7201050',
    name: 'Loolong',
  },
  {
    id: '7201051001',
    districtId: '7201051',
    name: 'Tolulos',
  },
  {
    id: '7201051002',
    districtId: '7201051',
    name: 'Popisi',
  },
  {
    id: '7201051003',
    districtId: '7201051',
    name: 'Labibi',
  },
  {
    id: '7201051005',
    districtId: '7201051',
    name: 'Tombos',
  },
  {
    id: '7201051006',
    districtId: '7201051',
    name: 'Alakasing',
  },
  {
    id: '7201051007',
    districtId: '7201051',
    name: 'Patukuki',
  },
  {
    id: '7201051008',
    districtId: '7201051',
    name: 'Koyobunga',
  },
  {
    id: '7201051009',
    districtId: '7201051',
    name: 'Kolak',
  },
  {
    id: '7201051010',
    districtId: '7201051',
    name: 'Balombong',
  },
  {
    id: '7201051011',
    districtId: '7201051',
    name: 'Tunggaling',
  },
  {
    id: '7201060001',
    districtId: '7201060',
    name: 'Tolo',
  },
  {
    id: '7201060002',
    districtId: '7201060',
    name: 'Lalanday',
  },
  {
    id: '7201060003',
    districtId: '7201060',
    name: 'Montomisan',
  },
  {
    id: '7201060004',
    districtId: '7201060',
    name: 'Sosom',
  },
  {
    id: '7201060005',
    districtId: '7201060',
    name: 'Alul',
  },
  {
    id: '7201060006',
    districtId: '7201060',
    name: 'Bulagi Satu',
  },
  {
    id: '7201060007',
    districtId: '7201060',
    name: 'Bulagi Dua',
  },
  {
    id: '7201060008',
    districtId: '7201060',
    name: 'Boloy',
  },
  {
    id: '7201060010',
    districtId: '7201060',
    name: 'Oluno',
  },
  {
    id: '7201060011',
    districtId: '7201060',
    name: 'Sumondung',
  },
  {
    id: '7201060012',
    districtId: '7201060',
    name: 'Peling Seasa',
  },
  {
    id: '7201060013',
    districtId: '7201060',
    name: 'Komba-Komba',
  },
  {
    id: '7201060014',
    districtId: '7201060',
    name: 'Kambal',
  },
  {
    id: '7201060015',
    districtId: '7201060',
    name: 'Toolon',
  },
  {
    id: '7201060016',
    districtId: '7201060',
    name: 'Kayubet',
  },
  {
    id: '7201061001',
    districtId: '7201061',
    name: 'Bone Puso',
  },
  {
    id: '7201061002',
    districtId: '7201061',
    name: 'Pandaluk',
  },
  {
    id: '7201061003',
    districtId: '7201061',
    name: 'Palabatu Dua',
  },
  {
    id: '7201061004',
    districtId: '7201061',
    name: 'Tatarandang',
  },
  {
    id: '7201061006',
    districtId: '7201061',
    name: 'Osan',
  },
  {
    id: '7201061007',
    districtId: '7201061',
    name: 'Balalon',
  },
  {
    id: '7201061008',
    districtId: '7201061',
    name: 'Sabelak',
  },
  {
    id: '7201061009',
    districtId: '7201061',
    name: 'Suit',
  },
  {
    id: '7201061010',
    districtId: '7201061',
    name: 'Toi-Toi',
  },
  {
    id: '7201061011',
    districtId: '7201061',
    name: 'Lolantang',
  },
  {
    id: '7201061012',
    districtId: '7201061',
    name: 'Palabatu Satu',
  },
  {
    id: '7201061013',
    districtId: '7201061',
    name: 'Mangais',
  },
  {
    id: '7201061015',
    districtId: '7201061',
    name: 'Babang',
  },
  {
    id: '7201061016',
    districtId: '7201061',
    name: 'Momotan',
  },
  {
    id: '7201061017',
    districtId: '7201061',
    name: 'Labotakandi',
  },
  {
    id: '7201061018',
    districtId: '7201061',
    name: 'Alasan Nggolobuton',
  },
  {
    id: '7201061019',
    districtId: '7201061',
    name: 'Boluni',
  },
  {
    id: '7201061020',
    districtId: '7201061',
    name: 'Pipilogot Paipaisu',
  },
  {
    id: '7201062001',
    districtId: '7201062',
    name: 'Bangunemo',
  },
  {
    id: '7201062002',
    districtId: '7201062',
    name: 'Paisuluno',
  },
  {
    id: '7201062003',
    districtId: '7201062',
    name: 'Montop',
  },
  {
    id: '7201062004',
    districtId: '7201062',
    name: 'Bolubung',
  },
  {
    id: '7201062005',
    districtId: '7201062',
    name: 'Bakalinga',
  },
  {
    id: '7201062006',
    districtId: '7201062',
    name: 'Sambulangan',
  },
  {
    id: '7201062007',
    districtId: '7201062',
    name: 'Koyobunga',
  },
  {
    id: '7201062008',
    districtId: '7201062',
    name: 'Sabang',
  },
  {
    id: '7201062009',
    districtId: '7201062',
    name: 'Ombuli',
  },
  {
    id: '7201062010',
    districtId: '7201062',
    name: 'Luk Panenteng',
  },
  {
    id: '7201062011',
    districtId: '7201062',
    name: 'Minanga',
  },
  {
    id: '7201062012',
    districtId: '7201062',
    name: 'Mandok',
  },
  {
    id: '7201070008',
    districtId: '7201070',
    name: 'Paisubatu',
  },
  {
    id: '7201070009',
    districtId: '7201070',
    name: 'Batangono',
  },
  {
    id: '7201070010',
    districtId: '7201070',
    name: 'Lalengan',
  },
  {
    id: '7201070011',
    districtId: '7201070',
    name: 'Peling Lalomo',
  },
  {
    id: '7201070012',
    districtId: '7201070',
    name: 'Labasiano',
  },
  {
    id: '7201070013',
    districtId: '7201070',
    name: 'Tataba',
  },
  {
    id: '7201070014',
    districtId: '7201070',
    name: 'Malanggong',
  },
  {
    id: '7201070015',
    districtId: '7201070',
    name: 'Leme-Leme Bungin',
  },
  {
    id: '7201070016',
    districtId: '7201070',
    name: 'Leme-Leme Darat',
  },
  {
    id: '7201070017',
    districtId: '7201070',
    name: 'Talas-Talas',
  },
  {
    id: '7201070018',
    districtId: '7201070',
    name: 'Okulo Potil',
  },
  {
    id: '7201070019',
    districtId: '7201070',
    name: 'Olusi',
  },
  {
    id: '7201070020',
    districtId: '7201070',
    name: 'Tatendeng',
  },
  {
    id: '7201071001',
    districtId: '7201071',
    name: 'Kambani',
  },
  {
    id: '7201071002',
    districtId: '7201071',
    name: 'Tatabau',
  },
  {
    id: '7201071003',
    districtId: '7201071',
    name: 'Buko',
  },
  {
    id: '7201071004',
    districtId: '7201071',
    name: 'Palapat',
  },
  {
    id: '7201071005',
    districtId: '7201071',
    name: 'Lumbi-Lumbia',
  },
  {
    id: '7201071006',
    districtId: '7201071',
    name: 'Labangun',
  },
  {
    id: '7201071007',
    districtId: '7201071',
    name: 'Seano',
  },
  {
    id: '7201071008',
    districtId: '7201071',
    name: 'Apal',
  },
  {
    id: '7201071009',
    districtId: '7201071',
    name: 'Lelang Matamaling',
  },
  {
    id: '7201071010',
    districtId: '7201071',
    name: 'Landonan Bebeau',
  },
  {
    id: '7201071011',
    districtId: '7201071',
    name: 'Sapelang',
  },
  {
    id: '7202010015',
    districtId: '7202010',
    name: 'Tohiti Sari',
  },
  {
    id: '7202010017',
    districtId: '7202010',
    name: 'Piondo',
  },
  {
    id: '7202010018',
    districtId: '7202010',
    name: 'Bukit Jaya',
  },
  {
    id: '7202010019',
    districtId: '7202010',
    name: 'Tolisu',
  },
  {
    id: '7202010020',
    districtId: '7202010',
    name: 'Tirta Kencana',
  },
  {
    id: '7202010021',
    districtId: '7202010',
    name: 'Tirta Sari',
  },
  {
    id: '7202010022',
    districtId: '7202010',
    name: 'Sentral Sari',
  },
  {
    id: '7202010023',
    districtId: '7202010',
    name: 'Cendanapura',
  },
  {
    id: '7202010024',
    districtId: '7202010',
    name: 'Singkoyo',
  },
  {
    id: '7202010026',
    districtId: '7202010',
    name: 'Rusa Kencana',
  },
  {
    id: '7202010037',
    districtId: '7202010',
    name: 'Samalore',
  },
  {
    id: '7202010038',
    districtId: '7202010',
    name: 'Ue Mea',
  },
  {
    id: '7202010039',
    districtId: '7202010',
    name: 'Sindang Baru',
  },
  {
    id: '7202010041',
    districtId: '7202010',
    name: 'Mansahang',
  },
  {
    id: '7202010042',
    districtId: '7202010',
    name: 'Saribuana',
  },
  {
    id: '7202010043',
    districtId: '7202010',
    name: 'Mekar Kencana',
  },
  {
    id: '7202010044',
    districtId: '7202010',
    name: 'Marga Kencana',
  },
  {
    id: '7202010045',
    districtId: '7202010',
    name: 'Sentral Timur',
  },
  {
    id: '7202010046',
    districtId: '7202010',
    name: 'Cendana',
  },
  {
    id: '7202010047',
    districtId: '7202010',
    name: 'Jaya Kencana',
  },
  {
    id: '7202010048',
    districtId: '7202010',
    name: 'Tanah Abang',
  },
  {
    id: '7202010055',
    districtId: '7202010',
    name: 'Mulya Sari',
  },
  {
    id: '7202010056',
    districtId: '7202010',
    name: 'Tirta Jaya',
  },
  {
    id: '7202010057',
    districtId: '7202010',
    name: 'Sidomukti',
  },
  {
    id: '7202011001',
    districtId: '7202011',
    name: 'Lembah Kramat',
  },
  {
    id: '7202011002',
    districtId: '7202011',
    name: 'Gunung Kramat',
  },
  {
    id: '7202011003',
    districtId: '7202011',
    name: 'Rata',
  },
  {
    id: '7202011004',
    districtId: '7202011',
    name: 'Bone Bae',
  },
  {
    id: '7202011005',
    districtId: '7202011',
    name: 'Pasir Lamba',
  },
  {
    id: '7202011006',
    districtId: '7202011',
    name: 'Mantawa',
  },
  {
    id: '7202011007',
    districtId: '7202011',
    name: 'Karya Makmur',
  },
  {
    id: '7202011008',
    districtId: '7202011',
    name: 'Makapa',
  },
  {
    id: '7202011009',
    districtId: '7202011',
    name: 'Bumi Harapan',
  },
  {
    id: '7202011010',
    districtId: '7202011',
    name: 'Bukit Makarti',
  },
  {
    id: '7202011011',
    districtId: '7202011',
    name: 'Sindang Sari',
  },
  {
    id: '7202011012',
    districtId: '7202011',
    name: 'Kami Wangi',
  },
  {
    id: '7202011013',
    districtId: '7202011',
    name: 'Dongin',
  },
  {
    id: '7202011014',
    districtId: '7202011',
    name: 'Pandan Wangi',
  },
  {
    id: '7202011015',
    districtId: '7202011',
    name: 'Uwelolu',
  },
  {
    id: '7202011016',
    districtId: '7202011',
    name: 'Mekar Sari',
  },
  {
    id: '7202011017',
    districtId: '7202011',
    name: 'Mekar Jaya',
  },
  {
    id: '7202012001',
    districtId: '7202012',
    name: 'Minakarya',
  },
  {
    id: '7202012002',
    districtId: '7202012',
    name: 'Minahaki',
  },
  {
    id: '7202012003',
    districtId: '7202012',
    name: 'Bumiharjo',
  },
  {
    id: '7202012004',
    districtId: '7202012',
    name: 'Sidoharjo',
  },
  {
    id: '7202012005',
    districtId: '7202012',
    name: 'Argakencana',
  },
  {
    id: '7202012006',
    districtId: '7202012',
    name: 'Mulyoharjo',
  },
  {
    id: '7202012007',
    districtId: '7202012',
    name: 'Slametharjo',
  },
  {
    id: '7202012008',
    districtId: '7202012',
    name: 'Toili',
  },
  {
    id: '7202012009',
    districtId: '7202012',
    name: 'Saluan',
  },
  {
    id: '7202012010',
    districtId: '7202012',
    name: 'Moilong',
  },
  {
    id: '7202012011',
    districtId: '7202012',
    name: 'Karya Jaya',
  },
  {
    id: '7202012012',
    districtId: '7202012',
    name: 'Sumber Harjo',
  },
  {
    id: '7202012013',
    districtId: '7202012',
    name: 'Karang Anyar',
  },
  {
    id: '7202012014',
    districtId: '7202012',
    name: 'Sidomakmur',
  },
  {
    id: '7202012015',
    districtId: '7202012',
    name: 'Argo Mulya',
  },
  {
    id: '7202012016',
    districtId: '7202012',
    name: 'Tou',
  },
  {
    id: '7202020008',
    districtId: '7202020',
    name: 'Kayowa',
  },
  {
    id: '7202020009',
    districtId: '7202020',
    name: 'Nonong',
  },
  {
    id: '7202020010',
    districtId: '7202020',
    name: 'Sisipan',
  },
  {
    id: '7202020011',
    districtId: '7202020',
    name: 'Ondo-Ondolu I',
  },
  {
    id: '7202020012',
    districtId: '7202020',
    name: 'Ondo Ondolu',
  },
  {
    id: '7202020013',
    districtId: '7202020',
    name: 'Tolando',
  },
  {
    id: '7202020014',
    districtId: '7202020',
    name: 'Batui',
  },
  {
    id: '7202020015',
    districtId: '7202020',
    name: 'Bugis',
  },
  {
    id: '7202020016',
    districtId: '7202020',
    name: 'Balantang',
  },
  {
    id: '7202020017',
    districtId: '7202020',
    name: 'Lamo',
  },
  {
    id: '7202020018',
    districtId: '7202020',
    name: 'Honbola',
  },
  {
    id: '7202020019',
    districtId: '7202020',
    name: 'Uso',
  },
  {
    id: '7202020023',
    districtId: '7202020',
    name: 'Bakung',
  },
  {
    id: '7202021001',
    districtId: '7202021',
    name: 'Sinorang',
  },
  {
    id: '7202021002',
    districtId: '7202021',
    name: 'Sukamaju',
  },
  {
    id: '7202021003',
    districtId: '7202021',
    name: 'Maleo Jaya',
  },
  {
    id: '7202021004',
    districtId: '7202021',
    name: 'Masungkang',
  },
  {
    id: '7202021005',
    districtId: '7202021',
    name: 'Sukamaju I',
  },
  {
    id: '7202021006',
    districtId: '7202021',
    name: 'Bone Balantak',
  },
  {
    id: '7202021007',
    districtId: '7202021',
    name: 'Masing',
  },
  {
    id: '7202021008',
    districtId: '7202021',
    name: 'Gori-Gori',
  },
  {
    id: '7202021009',
    districtId: '7202021',
    name: 'Paisubololi',
  },
  {
    id: '7202021010',
    districtId: '7202021',
    name: 'Ombolu',
  },
  {
    id: '7202030018',
    districtId: '7202030',
    name: 'Laonggo',
  },
  {
    id: '7202030020',
    districtId: '7202030',
    name: 'Bohotokong',
  },
  {
    id: '7202030021',
    districtId: '7202030',
    name: 'Bunta Satu',
  },
  {
    id: '7202030022',
    districtId: '7202030',
    name: 'Dondo Soboli',
  },
  {
    id: '7202030030',
    districtId: '7202030',
    name: 'Hion',
  },
  {
    id: '7202030031',
    districtId: '7202030',
    name: 'Tombongan Ulos',
  },
  {
    id: '7202030032',
    districtId: '7202030',
    name: 'Bunta Dua',
  },
  {
    id: '7202030033',
    districtId: '7202030',
    name: 'Pongian',
  },
  {
    id: '7202030034',
    districtId: '7202030',
    name: 'Nanga-Nangaon',
  },
  {
    id: '7202030036',
    districtId: '7202030',
    name: 'Toima',
  },
  {
    id: '7202030037',
    districtId: '7202030',
    name: 'Matabas',
  },
  {
    id: '7202030038',
    districtId: '7202030',
    name: 'Huhak',
  },
  {
    id: '7202030039',
    districtId: '7202030',
    name: 'Lontio',
  },
  {
    id: '7202030041',
    districtId: '7202030',
    name: 'Balanga',
  },
  {
    id: '7202030042',
    districtId: '7202030',
    name: 'Longgolian',
  },
  {
    id: '7202030043',
    districtId: '7202030',
    name: 'Salabenda',
  },
  {
    id: '7202030044',
    districtId: '7202030',
    name: 'Polo',
  },
  {
    id: '7202030045',
    districtId: '7202030',
    name: 'Kalumbangan',
  },
  {
    id: '7202030046',
    districtId: '7202030',
    name: 'Demangan Jaya',
  },
  {
    id: '7202030048',
    districtId: '7202030',
    name: 'Kalaka',
  },
  {
    id: '7202030049',
    districtId: '7202030',
    name: 'Koili',
  },
  {
    id: '7202031001',
    districtId: '7202031',
    name: 'Bangketa',
  },
  {
    id: '7202031002',
    districtId: '7202031',
    name: 'Tobelombang',
  },
  {
    id: '7202031003',
    districtId: '7202031',
    name: 'Balaang',
  },
  {
    id: '7202031004',
    districtId: '7202031',
    name: 'Damai Makmur',
  },
  {
    id: '7202031005',
    districtId: '7202031',
    name: 'Sumber Agung',
  },
  {
    id: '7202031006',
    districtId: '7202031',
    name: 'Jaya Makmur',
  },
  {
    id: '7202031007',
    districtId: '7202031',
    name: 'Mantan B',
  },
  {
    id: '7202031008',
    districtId: '7202031',
    name: 'Tomeang',
  },
  {
    id: '7202031009',
    districtId: '7202031',
    name: 'Pibombo',
  },
  {
    id: '7202031010',
    districtId: '7202031',
    name: 'Pakowa Bunta',
  },
  {
    id: '7202031011',
    districtId: '7202031',
    name: 'Petak',
  },
  {
    id: '7202031012',
    districtId: '7202031',
    name: 'Bolobungkang',
  },
  {
    id: '7202031013',
    districtId: '7202031',
    name: 'Saiti',
  },
  {
    id: '7202031014',
    districtId: '7202031',
    name: 'Binohu',
  },
  {
    id: '7202031015',
    districtId: '7202031',
    name: 'Bella',
  },
  {
    id: '7202031016',
    districtId: '7202031',
    name: 'Batu Hitam',
  },
  {
    id: '7202031017',
    districtId: '7202031',
    name: 'Kabua Bua',
  },
  {
    id: '7202031018',
    districtId: '7202031',
    name: 'Pulodalagan',
  },
  {
    id: '7202031019',
    districtId: '7202031',
    name: 'Obok Balingara',
  },
  {
    id: '7202032001',
    districtId: '7202032',
    name: 'Sumber Mulya',
  },
  {
    id: '7202032002',
    districtId: '7202032',
    name: 'Simpang Dua',
  },
  {
    id: '7202032003',
    districtId: '7202032',
    name: 'Simpang Satu',
  },
  {
    id: '7202032004',
    districtId: '7202032',
    name: 'Beringin Jaya',
  },
  {
    id: '7202032005',
    districtId: '7202032',
    name: 'Mantan A',
  },
  {
    id: '7202032006',
    districtId: '7202032',
    name: 'Dowiwi',
  },
  {
    id: '7202032007',
    districtId: '7202032',
    name: 'Rantau Jaya',
  },
  {
    id: '7202032008',
    districtId: '7202032',
    name: 'Doda Bunta',
  },
  {
    id: '7202032009',
    districtId: '7202032',
    name: 'Gonohop',
  },
  {
    id: '7202032010',
    districtId: '7202032',
    name: 'Koninis',
  },
  {
    id: '7202032011',
    districtId: '7202032',
    name: 'Dwipa Karya',
  },
  {
    id: '7202032012',
    districtId: '7202032',
    name: 'Lokait',
  },
  {
    id: '7202040001',
    districtId: '7202040',
    name: 'Babang Buyangge',
  },
  {
    id: '7202040002',
    districtId: '7202040',
    name: 'Kalolos',
  },
  {
    id: '7202040003',
    districtId: '7202040',
    name: 'Tangkiang',
  },
  {
    id: '7202040004',
    districtId: '7202040',
    name: 'Padang',
  },
  {
    id: '7202040005',
    districtId: '7202040',
    name: 'Manyula',
  },
  {
    id: '7202040006',
    districtId: '7202040',
    name: 'Uling',
  },
  {
    id: '7202040007',
    districtId: '7202040',
    name: 'Kintom',
  },
  {
    id: '7202040008',
    districtId: '7202040',
    name: 'Samadoya',
  },
  {
    id: '7202040009',
    districtId: '7202040',
    name: 'Dimpalon',
  },
  {
    id: '7202040010',
    districtId: '7202040',
    name: 'Solan',
  },
  {
    id: '7202040011',
    districtId: '7202040',
    name: 'Mendono',
  },
  {
    id: '7202040015',
    districtId: '7202040',
    name: 'Solan Baru',
  },
  {
    id: '7202040017',
    districtId: '7202040',
    name: 'Mondonun',
  },
  {
    id: '7202040019',
    districtId: '7202040',
    name: 'Dimpalon Baru',
  },
  {
    id: '7202050008',
    districtId: '7202050',
    name: 'Tontouan',
  },
  {
    id: '7202050010',
    districtId: '7202050',
    name: 'Baru',
  },
  {
    id: '7202050011',
    districtId: '7202050',
    name: 'Soho',
  },
  {
    id: '7202050012',
    districtId: '7202050',
    name: 'Bungin',
  },
  {
    id: '7202050013',
    districtId: '7202050',
    name: 'Lumpoknyo',
  },
  {
    id: '7202050023',
    districtId: '7202050',
    name: 'Karaton',
  },
  {
    id: '7202050026',
    districtId: '7202050',
    name: 'Bungin Timur',
  },
  {
    id: '7202050027',
    districtId: '7202050',
    name: 'Mangkio Baru',
  },
  {
    id: '7202051001',
    districtId: '7202051',
    name: 'Boitan',
  },
  {
    id: '7202051002',
    districtId: '7202051',
    name: 'Bantayan',
  },
  {
    id: '7202051003',
    districtId: '7202051',
    name: 'Baya',
  },
  {
    id: '7202051004',
    districtId: '7202051',
    name: 'Uwedikan',
  },
  {
    id: '7202051005',
    districtId: '7202051',
    name: 'Hunduhon',
  },
  {
    id: '7202051006',
    districtId: '7202051',
    name: 'Pohi',
  },
  {
    id: '7202051007',
    districtId: '7202051',
    name: 'Kayutanyo',
  },
  {
    id: '7202051008',
    districtId: '7202051',
    name: 'Lauwon',
  },
  {
    id: '7202051009',
    districtId: '7202051',
    name: 'Molino',
  },
  {
    id: '7202051010',
    districtId: '7202051',
    name: 'Louk',
  },
  {
    id: '7202051011',
    districtId: '7202051',
    name: 'Lontos',
  },
  {
    id: '7202051012',
    districtId: '7202051',
    name: 'Indang Sari',
  },
  {
    id: '7202051013',
    districtId: '7202051',
    name: 'Bukit Mulya',
  },
  {
    id: '7202052001',
    districtId: '7202052',
    name: 'Kilongan',
  },
  {
    id: '7202052002',
    districtId: '7202052',
    name: 'Bumi Beringin',
  },
  {
    id: '7202052003',
    districtId: '7202052',
    name: 'Boyou',
  },
  {
    id: '7202052004',
    districtId: '7202052',
    name: 'Biak',
  },
  {
    id: '7202052005',
    districtId: '7202052',
    name: 'Bunga',
  },
  {
    id: '7202052006',
    districtId: '7202052',
    name: 'Kamumu',
  },
  {
    id: '7202052007',
    districtId: '7202052',
    name: 'Salodik',
  },
  {
    id: '7202052008',
    districtId: '7202052',
    name: 'Awu',
  },
  {
    id: '7202052009',
    districtId: '7202052',
    name: 'Kilongan Permai',
  },
  {
    id: '7202052011',
    districtId: '7202052',
    name: 'Buon Mandiri',
  },
  {
    id: '7202053002',
    districtId: '7202053',
    name: 'Maahas',
  },
  {
    id: '7202053003',
    districtId: '7202053',
    name: 'Simpong',
  },
  {
    id: '7202053004',
    districtId: '7202053',
    name: 'Hanga-Hanga',
  },
  {
    id: '7202053005',
    districtId: '7202053',
    name: 'Tanjung Tuwis',
  },
  {
    id: '7202053006',
    districtId: '7202053',
    name: 'Bukit Mambual',
  },
  {
    id: '7202053007',
    districtId: '7202053',
    name: 'Tombang Permai',
  },
  {
    id: '7202053008',
    districtId: '7202053',
    name: 'Kompo',
  },
  {
    id: '7202053009',
    districtId: '7202053',
    name: 'Jole',
  },
  {
    id: '7202053010',
    districtId: '7202053',
    name: 'Hanga-Hanga Permai',
  },
  {
    id: '7202054001',
    districtId: '7202054',
    name: 'Nambo Padang',
  },
  {
    id: '7202054002',
    districtId: '7202054',
    name: 'Nambo Lempek',
  },
  {
    id: '7202054003',
    districtId: '7202054',
    name: 'Koyoan',
  },
  {
    id: '7202054004',
    districtId: '7202054',
    name: 'Nambo Bosaa',
  },
  {
    id: '7202054005',
    districtId: '7202054',
    name: 'Nambo Lempek Baru',
  },
  {
    id: '7202054006',
    districtId: '7202054',
    name: 'Koyoan Permai',
  },
  {
    id: '7202054007',
    districtId: '7202054',
    name: 'Lontio',
  },
  {
    id: '7202054008',
    districtId: '7202054',
    name: 'Lontio Baru',
  },
  {
    id: '7202054009',
    districtId: '7202054',
    name: 'Padungnyo',
  },
  {
    id: '7202054010',
    districtId: '7202054',
    name: 'Sayambongin',
  },
  {
    id: '7202060001',
    districtId: '7202060',
    name: 'Baloa Doda',
  },
  {
    id: '7202060002',
    districtId: '7202060',
    name: 'Asaan',
  },
  {
    id: '7202060011',
    districtId: '7202060',
    name: 'Pakowa',
  },
  {
    id: '7202060012',
    districtId: '7202060',
    name: 'Lamo',
  },
  {
    id: '7202060013',
    districtId: '7202060',
    name: 'Nain',
  },
  {
    id: '7202060014',
    districtId: '7202060',
    name: 'Pinapuan',
  },
  {
    id: '7202060015',
    districtId: '7202060',
    name: 'Sinampangnyo',
  },
  {
    id: '7202060016',
    districtId: '7202060',
    name: 'Hohudongan',
  },
  {
    id: '7202060017',
    districtId: '7202060',
    name: 'Tongkonunuk',
  },
  {
    id: '7202060018',
    districtId: '7202060',
    name: 'Jaya Bakti',
  },
  {
    id: '7202060019',
    districtId: '7202060',
    name: 'Pagimana',
  },
  {
    id: '7202060020',
    districtId: '7202060',
    name: 'Basabungan',
  },
  {
    id: '7202060021',
    districtId: '7202060',
    name: 'Pisou',
  },
  {
    id: '7202060022',
    districtId: '7202060',
    name: 'Lambangan',
  },
  {
    id: '7202060023',
    districtId: '7202060',
    name: 'Sepak',
  },
  {
    id: '7202060024',
    districtId: '7202060',
    name: 'Taloyon',
  },
  {
    id: '7202060025',
    districtId: '7202060',
    name: 'Uwedaka',
  },
  {
    id: '7202060026',
    districtId: '7202060',
    name: 'Tintingan',
  },
  {
    id: '7202060027',
    districtId: '7202060',
    name: 'Bungawon',
  },
  {
    id: '7202060028',
    districtId: '7202060',
    name: 'Huhak',
  },
  {
    id: '7202060029',
    districtId: '7202060',
    name: 'Poh',
  },
  {
    id: '7202060030',
    districtId: '7202060',
    name: 'Toipan',
  },
  {
    id: '7202060031',
    districtId: '7202060',
    name: 'Siuna',
  },
  {
    id: '7202060032',
    districtId: '7202060',
    name: 'Bajo Poat',
  },
  {
    id: '7202060033',
    districtId: '7202060',
    name: 'Balai Gondi',
  },
  {
    id: '7202060034',
    districtId: '7202060',
    name: 'Tampe',
  },
  {
    id: '7202060035',
    districtId: '7202060',
    name: 'Gomuo',
  },
  {
    id: '7202060037',
    districtId: '7202060',
    name: 'Samma Jatem',
  },
  {
    id: '7202060038',
    districtId: '7202060',
    name: 'Bondat',
  },
  {
    id: '7202060041',
    districtId: '7202060',
    name: 'Ampera',
  },
  {
    id: '7202060043',
    districtId: '7202060',
    name: 'Tombang',
  },
  {
    id: '7202060044',
    districtId: '7202060',
    name: 'Dongkalan',
  },
  {
    id: '7202061002',
    districtId: '7202061',
    name: 'Tikupon',
  },
  {
    id: '7202061003',
    districtId: '7202061',
    name: 'Mayayap',
  },
  {
    id: '7202061004',
    districtId: '7202061',
    name: 'Sumber Wangi',
  },
  {
    id: '7202061005',
    districtId: '7202061',
    name: 'Toiba',
  },
  {
    id: '7202061006',
    districtId: '7202061',
    name: 'Lembah Tompotika',
  },
  {
    id: '7202061007',
    districtId: '7202061',
    name: 'Longkoga Barat',
  },
  {
    id: '7202061008',
    districtId: '7202061',
    name: 'Longkoga Timur',
  },
  {
    id: '7202061009',
    districtId: '7202061',
    name: 'Bualemo B',
  },
  {
    id: '7202061010',
    districtId: '7202061',
    name: 'Sampaka',
  },
  {
    id: '7202061011',
    districtId: '7202061',
    name: 'Bualemo A',
  },
  {
    id: '7202061012',
    districtId: '7202061',
    name: 'Malik',
  },
  {
    id: '7202061013',
    districtId: '7202061',
    name: 'Binsil K',
  },
  {
    id: '7202061014',
    districtId: '7202061',
    name: 'Binsil Padang',
  },
  {
    id: '7202061015',
    districtId: '7202061',
    name: 'Bima Karya',
  },
  {
    id: '7202061016',
    districtId: '7202061',
    name: 'Taima',
  },
  {
    id: '7202061017',
    districtId: '7202061',
    name: 'Nipa Kalemoan',
  },
  {
    id: '7202061018',
    districtId: '7202061',
    name: 'Dwi Karya',
  },
  {
    id: '7202061019',
    districtId: '7202061',
    name: 'Lembah Makmur',
  },
  {
    id: '7202061020',
    districtId: '7202061',
    name: 'Malik Makmur',
  },
  {
    id: '7202061021',
    districtId: '7202061',
    name: 'Salipi',
  },
  {
    id: '7202062001',
    districtId: '7202062',
    name: 'Bahingin',
  },
  {
    id: '7202062002',
    districtId: '7202062',
    name: 'Balean',
  },
  {
    id: '7202062003',
    districtId: '7202062',
    name: 'Uha-Uhangon',
  },
  {
    id: '7202062004',
    districtId: '7202062',
    name: 'Kadodi',
  },
  {
    id: '7202062005',
    districtId: '7202062',
    name: 'Niubulan',
  },
  {
    id: '7202062006',
    districtId: '7202062',
    name: 'Lobu',
  },
  {
    id: '7202062007',
    districtId: '7202062',
    name: 'Bolobungkang',
  },
  {
    id: '7202062008',
    districtId: '7202062',
    name: 'Uwedaka-Daka',
  },
  {
    id: '7202062009',
    districtId: '7202062',
    name: 'Dolom',
  },
  {
    id: '7202062010',
    districtId: '7202062',
    name: 'Lambuli',
  },
  {
    id: '7202070009',
    districtId: '7202070',
    name: 'Nipa',
  },
  {
    id: '7202070010',
    districtId: '7202070',
    name: 'Kagitakan',
  },
  {
    id: '7202070011',
    districtId: '7202070',
    name: 'Sirom',
  },
  {
    id: '7202070012',
    districtId: '7202070',
    name: 'Poroan',
  },
  {
    id: '7202070013',
    districtId: '7202070',
    name: 'Bonebobakal',
  },
  {
    id: '7202070014',
    districtId: '7202070',
    name: 'Lomba',
  },
  {
    id: '7202070016',
    districtId: '7202070',
    name: 'Baruga',
  },
  {
    id: '7202070017',
    districtId: '7202070',
    name: 'Kota Baru',
  },
  {
    id: '7202070020',
    districtId: '7202070',
    name: 'Tinonda',
  },
  {
    id: '7202070021',
    districtId: '7202070',
    name: 'Labotan',
  },
  {
    id: '7202070023',
    districtId: '7202070',
    name: 'Bahari Makmur',
  },
  {
    id: '7202070024',
    districtId: '7202070',
    name: 'Kota Raya',
  },
  {
    id: '7202071001',
    districtId: '7202071',
    name: 'Tangeban',
  },
  {
    id: '7202071002',
    districtId: '7202071',
    name: 'Taugi',
  },
  {
    id: '7202071003',
    districtId: '7202071',
    name: 'Kospa Dwata Karya',
  },
  {
    id: '7202071004',
    districtId: '7202071',
    name: 'Simpangan',
  },
  {
    id: '7202071006',
    districtId: '7202071',
    name: 'Minangandala',
  },
  {
    id: '7202071007',
    districtId: '7202071',
    name: 'Purwo Agung',
  },
  {
    id: '7202071008',
    districtId: '7202071',
    name: 'Kembang Merta',
  },
  {
    id: '7202071009',
    districtId: '7202071',
    name: 'Tompotika Makmur',
  },
  {
    id: '7202071011',
    districtId: '7202071',
    name: 'Duata Karya',
  },
  {
    id: '7202071012',
    districtId: '7202071',
    name: 'Cemerlang',
  },
  {
    id: '7202071013',
    districtId: '7202071',
    name: 'Padangon',
  },
  {
    id: '7202071014',
    districtId: '7202071',
    name: 'Ranga-Ranga',
  },
  {
    id: '7202072001',
    districtId: '7202072',
    name: 'Lonas',
  },
  {
    id: '7202072002',
    districtId: '7202072',
    name: 'Boras',
  },
  {
    id: '7202072003',
    districtId: '7202072',
    name: 'Sulubombong',
  },
  {
    id: '7202072004',
    districtId: '7202072',
    name: 'Bollo',
  },
  {
    id: '7202072005',
    districtId: '7202072',
    name: 'Bombanon',
  },
  {
    id: '7202072006',
    districtId: '7202072',
    name: 'Binotik',
  },
  {
    id: '7202072007',
    districtId: '7202072',
    name: 'Sobol',
  },
  {
    id: '7202072008',
    districtId: '7202072',
    name: 'Pondan',
  },
  {
    id: '7202072009',
    districtId: '7202072',
    name: 'Garuga',
  },
  {
    id: '7202072010',
    districtId: '7202072',
    name: 'Sobol Baru',
  },
  {
    id: '7202080012',
    districtId: '7202080',
    name: 'Talima A',
  },
  {
    id: '7202080013',
    districtId: '7202080',
    name: 'Talima B',
  },
  {
    id: '7202080014',
    districtId: '7202080',
    name: 'Dolom',
  },
  {
    id: '7202080015',
    districtId: '7202080',
    name: 'Kiloma',
  },
  {
    id: '7202080016',
    districtId: '7202080',
    name: 'Rau',
  },
  {
    id: '7202080017',
    districtId: '7202080',
    name: 'Tanotu',
  },
  {
    id: '7202080018',
    districtId: '7202080',
    name: 'Padang',
  },
  {
    id: '7202080019',
    districtId: '7202080',
    name: 'Mamping',
  },
  {
    id: '7202080020',
    districtId: '7202080',
    name: 'Balantak',
  },
  {
    id: '7202080021',
    districtId: '7202080',
    name: 'Luok',
  },
  {
    id: '7202080027',
    districtId: '7202080',
    name: 'Boloak',
  },
  {
    id: '7202080030',
    districtId: '7202080',
    name: 'Dale- Dale',
  },
  {
    id: '7202080031',
    districtId: '7202080',
    name: 'Talang Batu',
  },
  {
    id: '7202081001',
    districtId: '7202081',
    name: 'Tombos',
  },
  {
    id: '7202081002',
    districtId: '7202081',
    name: 'Tintingon',
  },
  {
    id: '7202081003',
    districtId: '7202081',
    name: 'Booy',
  },
  {
    id: '7202081005',
    districtId: '7202081',
    name: 'Dondo',
  },
  {
    id: '7202081006',
    districtId: '7202081',
    name: 'Resarna',
  },
  {
    id: '7202081007',
    districtId: '7202081',
    name: 'Giwang',
  },
  {
    id: '7202081008',
    districtId: '7202081',
    name: 'Gorontalo',
  },
  {
    id: '7202081009',
    districtId: '7202081',
    name: 'Tongke',
  },
  {
    id: '7202081010',
    districtId: '7202081',
    name: 'Poyang',
  },
  {
    id: '7202081011',
    districtId: '7202081',
    name: 'Tanggawas',
  },
  {
    id: '7202082001',
    districtId: '7202082',
    name: 'Kampangar',
  },
  {
    id: '7202082003',
    districtId: '7202082',
    name: 'Ondoliang',
  },
  {
    id: '7202082004',
    districtId: '7202082',
    name: 'Batusimpang',
  },
  {
    id: '7202082005',
    districtId: '7202082',
    name: 'Pangkalaseang',
  },
  {
    id: '7202082006',
    districtId: '7202082',
    name: 'Pangkalaseang Baru',
  },
  {
    id: '7202082007',
    districtId: '7202082',
    name: 'Kuntang',
  },
  {
    id: '7202082008',
    districtId: '7202082',
    name: 'Toweer',
  },
  {
    id: '7202082009',
    districtId: '7202082',
    name: 'Batu Mandi',
  },
  {
    id: '7202082010',
    districtId: '7202082',
    name: 'Pulau Dua',
  },
  {
    id: '7203010001',
    districtId: '7203010',
    name: 'Padei Laut',
  },
  {
    id: '7203010002',
    districtId: '7203010',
    name: 'Ulunambo',
  },
  {
    id: '7203010003',
    districtId: '7203010',
    name: 'Kofalagadi',
  },
  {
    id: '7203010004',
    districtId: '7203010',
    name: 'Torukuno',
  },
  {
    id: '7203010005',
    districtId: '7203010',
    name: 'Terebino',
  },
  {
    id: '7203010006',
    districtId: '7203010',
    name: 'Ngapaea',
  },
  {
    id: '7203010007',
    districtId: '7203010',
    name: 'Morompaitonga',
  },
  {
    id: '7203010008',
    districtId: '7203010',
    name: 'Padalaa',
  },
  {
    id: '7203010009',
    districtId: '7203010',
    name: 'Padei Darat',
  },
  {
    id: '7203010010',
    districtId: '7203010',
    name: 'Masadian',
  },
  {
    id: '7203010011',
    districtId: '7203010',
    name: 'Samarengga',
  },
  {
    id: '7203010012',
    districtId: '7203010',
    name: 'Pulau Tiga',
  },
  {
    id: '7203010013',
    districtId: '7203010',
    name: 'Matano',
  },
  {
    id: '7203010014',
    districtId: '7203010',
    name: 'Matarape',
  },
  {
    id: '7203010015',
    districtId: '7203010',
    name: 'Buranga',
  },
  {
    id: '7203010016',
    districtId: '7203010',
    name: 'Ulunipa',
  },
  {
    id: '7203010017',
    districtId: '7203010',
    name: 'Wawongkolono',
  },
  {
    id: '7203010018',
    districtId: '7203010',
    name: 'Dongkalang',
  },
  {
    id: '7203010019',
    districtId: '7203010',
    name: 'Tanjung Harapan',
  },
  {
    id: '7203010020',
    districtId: '7203010',
    name: 'Tafagapi',
  },
  {
    id: '7203010021',
    districtId: '7203010',
    name: 'Pulau Tengah',
  },
  {
    id: '7203010022',
    districtId: '7203010',
    name: 'Tanjung Tiram',
  },
  {
    id: '7203010023',
    districtId: '7203010',
    name: 'Mbokitta',
  },
  {
    id: '7203010024',
    districtId: '7203010',
    name: 'Tanona',
  },
  {
    id: '7203020001',
    districtId: '7203020',
    name: 'Sainoa',
  },
  {
    id: '7203020002',
    districtId: '7203020',
    name: 'Polewali',
  },
  {
    id: '7203020003',
    districtId: '7203020',
    name: 'Pulau Dua',
  },
  {
    id: '7203020005',
    districtId: '7203020',
    name: 'Jawi Jawi',
  },
  {
    id: '7203020006',
    districtId: '7203020',
    name: 'Buton',
  },
  {
    id: '7203020007',
    districtId: '7203020',
    name: 'Koburu',
  },
  {
    id: '7203020008',
    districtId: '7203020',
    name: 'Bungingkela',
  },
  {
    id: '7203020009',
    districtId: '7203020',
    name: 'Lokombulo',
  },
  {
    id: '7203020010',
    districtId: '7203020',
    name: 'Paku',
  },
  {
    id: '7203020011',
    districtId: '7203020',
    name: 'Bakala',
  },
  {
    id: '7203020012',
    districtId: '7203020',
    name: 'Buajangka',
  },
  {
    id: '7203020013',
    districtId: '7203020',
    name: 'Kaleroang',
  },
  {
    id: '7203020014',
    districtId: '7203020',
    name: 'Waru Waru',
  },
  {
    id: '7203020015',
    districtId: '7203020',
    name: 'Padabale',
  },
  {
    id: '7203020016',
    districtId: '7203020',
    name: 'Pado Pado',
  },
  {
    id: '7203020017',
    districtId: '7203020',
    name: 'Pulau Bapa',
  },
  {
    id: '7203020018',
    districtId: '7203020',
    name: 'Lalemo',
  },
  {
    id: '7203020019',
    districtId: '7203020',
    name: 'Lamontoli',
  },
  {
    id: '7203020029',
    districtId: '7203020',
    name: 'Bungintende',
  },
  {
    id: '7203020030',
    districtId: '7203020',
    name: 'Boelimau',
  },
  {
    id: '7203020031',
    districtId: '7203020',
    name: 'Panimbawang',
  },
  {
    id: '7203020032',
    districtId: '7203020',
    name: "Po'O",
  },
  {
    id: '7203020033',
    districtId: '7203020',
    name: 'Umbele Lama',
  },
  {
    id: '7203020034',
    districtId: '7203020',
    name: 'Pulau Dua Darat',
  },
  {
    id: '7203020035',
    districtId: '7203020',
    name: 'Poaro',
  },
  {
    id: '7203021002',
    districtId: '7203021',
    name: 'Padabaho',
  },
  {
    id: '7203021003',
    districtId: '7203021',
    name: 'Makarti Jaya',
  },
  {
    id: '7203021004',
    districtId: '7203021',
    name: 'Labota',
  },
  {
    id: '7203021005',
    districtId: '7203021',
    name: 'Fatufia',
  },
  {
    id: '7203021006',
    districtId: '7203021',
    name: 'Keurea',
  },
  {
    id: '7203021007',
    districtId: '7203021',
    name: 'Bahomakmur',
  },
  {
    id: '7203021008',
    districtId: '7203021',
    name: 'Bahodopi',
  },
  {
    id: '7203021009',
    districtId: '7203021',
    name: 'Lalampu',
  },
  {
    id: '7203021010',
    districtId: '7203021',
    name: 'Siumbatu',
  },
  {
    id: '7203021011',
    districtId: '7203021',
    name: 'Dampala',
  },
  {
    id: '7203022001',
    districtId: '7203022',
    name: 'Were Ea',
  },
  {
    id: '7203022002',
    districtId: '7203022',
    name: 'Sambalagi',
  },
  {
    id: '7203022003',
    districtId: '7203022',
    name: 'Laroenai',
  },
  {
    id: '7203022005',
    districtId: '7203022',
    name: 'Torete',
  },
  {
    id: '7203022006',
    districtId: '7203022',
    name: 'Lafeu',
  },
  {
    id: '7203022007',
    districtId: '7203022',
    name: 'Tanda Oleo',
  },
  {
    id: '7203022008',
    districtId: '7203022',
    name: 'One Ete',
  },
  {
    id: '7203022009',
    districtId: '7203022',
    name: 'Tangofa',
  },
  {
    id: '7203030011',
    districtId: '7203030',
    name: 'Puungkoilu',
  },
  {
    id: '7203030012',
    districtId: '7203030',
    name: 'Bahontobungku',
  },
  {
    id: '7203030013',
    districtId: '7203030',
    name: 'Tofuti',
  },
  {
    id: '7203030014',
    districtId: '7203030',
    name: 'Sakita',
  },
  {
    id: '7203030015',
    districtId: '7203030',
    name: 'Mendui',
  },
  {
    id: '7203030016',
    districtId: '7203030',
    name: 'Tofoiso',
  },
  {
    id: '7203030017',
    districtId: '7203030',
    name: 'Marsaoleh',
  },
  {
    id: '7203030018',
    districtId: '7203030',
    name: 'Lamberea',
  },
  {
    id: '7203030019',
    districtId: '7203030',
    name: 'Bungi',
  },
  {
    id: '7203030020',
    districtId: '7203030',
    name: 'Matano',
  },
  {
    id: '7203030021',
    districtId: '7203030',
    name: 'Matansala',
  },
  {
    id: '7203030022',
    districtId: '7203030',
    name: 'Bahoruru',
  },
  {
    id: '7203030023',
    districtId: '7203030',
    name: 'Ipi',
  },
  {
    id: '7203030025',
    districtId: '7203030',
    name: 'Bahomohoni',
  },
  {
    id: '7203030026',
    districtId: '7203030',
    name: 'Bahomoleo',
  },
  {
    id: '7203030027',
    districtId: '7203030',
    name: 'Bahomante',
  },
  {
    id: '7203030028',
    districtId: '7203030',
    name: 'Lanona',
  },
  {
    id: '7203030029',
    districtId: '7203030',
    name: 'Tudua',
  },
  {
    id: '7203031001',
    districtId: '7203031',
    name: 'Onepute Jaya',
  },
  {
    id: '7203031002',
    districtId: '7203031',
    name: 'Bahomotefe',
  },
  {
    id: '7203031003',
    districtId: '7203031',
    name: 'Bahomoahi',
  },
  {
    id: '7203031005',
    districtId: '7203031',
    name: 'Kolono',
  },
  {
    id: '7203031006',
    districtId: '7203031',
    name: 'Geresa',
  },
  {
    id: '7203031007',
    districtId: '7203031',
    name: 'Laroue',
  },
  {
    id: '7203031008',
    districtId: '7203031',
    name: 'Nambo',
  },
  {
    id: '7203031009',
    districtId: '7203031',
    name: 'Unsongi',
  },
  {
    id: '7203031010',
    districtId: '7203031',
    name: 'Lahuafu',
  },
  {
    id: '7203040001',
    districtId: '7203040',
    name: 'Bahoea Reko  Reko',
  },
  {
    id: '7203040002',
    districtId: '7203040',
    name: 'Wosu',
  },
  {
    id: '7203040003',
    districtId: '7203040',
    name: 'Larobenu',
  },
  {
    id: '7203040004',
    districtId: '7203040',
    name: 'Umpanga',
  },
  {
    id: '7203040005',
    districtId: '7203040',
    name: 'Tofogaro',
  },
  {
    id: '7203040006',
    districtId: '7203040',
    name: 'Tondo',
  },
  {
    id: '7203040007',
    districtId: '7203040',
    name: 'Ambunu',
  },
  {
    id: '7203040008',
    districtId: '7203040',
    name: 'Marga Mulya',
  },
  {
    id: '7203040009',
    districtId: '7203040',
    name: 'Uedago',
  },
  {
    id: '7203040010',
    districtId: '7203040',
    name: 'Wata',
  },
  {
    id: '7203041001',
    districtId: '7203041',
    name: 'Parilangke',
  },
  {
    id: '7203041002',
    districtId: '7203041',
    name: 'Beringin Jaya',
  },
  {
    id: '7203041003',
    districtId: '7203041',
    name: 'Bahonsuai',
  },
  {
    id: '7203041004',
    districtId: '7203041',
    name: 'Samarenda',
  },
  {
    id: '7203041005',
    districtId: '7203041',
    name: 'Atananga',
  },
  {
    id: '7203041006',
    districtId: '7203041',
    name: 'Lambelu',
  },
  {
    id: '7203041007',
    districtId: '7203041',
    name: 'Limbo Makmur',
  },
  {
    id: '7203041008',
    districtId: '7203041',
    name: 'Pebatae',
  },
  {
    id: '7203041009',
    districtId: '7203041',
    name: 'Karaupa',
  },
  {
    id: '7203041011',
    districtId: '7203041',
    name: 'Harapan Jaya',
  },
  {
    id: '7203041012',
    districtId: '7203041',
    name: 'Pebotoa',
  },
  {
    id: '7203041013',
    districtId: '7203041',
    name: 'Lasampi',
  },
  {
    id: '7203042001',
    districtId: '7203042',
    name: 'Puntari Makmur',
  },
  {
    id: '7203042002',
    districtId: '7203042',
    name: 'Sampeantaba',
  },
  {
    id: '7203042003',
    districtId: '7203042',
    name: 'Lantula Jaya',
  },
  {
    id: '7203042004',
    districtId: '7203042',
    name: 'Bumi Harapan',
  },
  {
    id: '7203042005',
    districtId: '7203042',
    name: 'Emea',
  },
  {
    id: '7203042006',
    districtId: '7203042',
    name: 'Moahino',
  },
  {
    id: '7203042007',
    districtId: '7203042',
    name: 'Ungkaya',
  },
  {
    id: '7203042008',
    districtId: '7203042',
    name: 'Solonsa Jaya',
  },
  {
    id: '7203042009',
    districtId: '7203042',
    name: 'Solonsa',
  },
  {
    id: '7204010001',
    districtId: '7204010',
    name: 'Mayoa',
  },
  {
    id: '7204010002',
    districtId: '7204010',
    name: 'Maya Sari',
  },
  {
    id: '7204010013',
    districtId: '7204010',
    name: 'Panda Jaya',
  },
  {
    id: '7204010014',
    districtId: '7204010',
    name: 'Maya Jaya',
  },
  {
    id: '7204010015',
    districtId: '7204010',
    name: 'Pandayora',
  },
  {
    id: '7204010016',
    districtId: '7204010',
    name: 'Bangun Jaya',
  },
  {
    id: '7204010017',
    districtId: '7204010',
    name: 'Pendolo',
  },
  {
    id: '7204010018',
    districtId: '7204010',
    name: 'Boe',
  },
  {
    id: '7204010019',
    districtId: '7204010',
    name: 'Bancea',
  },
  {
    id: '7204010020',
    districtId: '7204010',
    name: 'Panjo',
  },
  {
    id: '7204010021',
    districtId: '7204010',
    name: 'Pasir Putih',
  },
  {
    id: '7204011001',
    districtId: '7204011',
    name: 'Taipa',
  },
  {
    id: '7204011002',
    districtId: '7204011',
    name: 'Meko',
  },
  {
    id: '7204011003',
    districtId: '7204011',
    name: 'Salukaia',
  },
  {
    id: '7204011004',
    districtId: '7204011',
    name: 'Uranosari',
  },
  {
    id: '7204011005',
    districtId: '7204011',
    name: 'Toinasa',
  },
  {
    id: '7204011006',
    districtId: '7204011',
    name: 'Owini',
  },
  {
    id: '7204012001',
    districtId: '7204012',
    name: 'Barati',
  },
  {
    id: '7204012002',
    districtId: '7204012',
    name: 'Salindu',
  },
  {
    id: '7204012003',
    districtId: '7204012',
    name: 'Singkona',
  },
  {
    id: '7204012004',
    districtId: '7204012',
    name: 'Tolambo',
  },
  {
    id: '7204012005',
    districtId: '7204012',
    name: 'Tindoli',
  },
  {
    id: '7204012006',
    districtId: '7204012',
    name: 'Tokilo',
  },
  {
    id: '7204012007',
    districtId: '7204012',
    name: 'Korobono',
  },
  {
    id: '7204012008',
    districtId: '7204012',
    name: 'Amporiwo',
  },
  {
    id: '7204012009',
    districtId: '7204012',
    name: 'Wayura',
  },
  {
    id: '7204020005',
    districtId: '7204020',
    name: 'Gintu',
  },
  {
    id: '7204020007',
    districtId: '7204020',
    name: 'Badangkaia',
  },
  {
    id: '7204020008',
    districtId: '7204020',
    name: 'Bakekau',
  },
  {
    id: '7204020009',
    districtId: '7204020',
    name: 'Bulili',
  },
  {
    id: '7204020010',
    districtId: '7204020',
    name: 'Bewa',
  },
  {
    id: '7204020011',
    districtId: '7204020',
    name: 'Pada',
  },
  {
    id: '7204020014',
    districtId: '7204020',
    name: 'Bomba',
  },
  {
    id: '7204021001',
    districtId: '7204021',
    name: 'Tuare',
  },
  {
    id: '7204021002',
    districtId: '7204021',
    name: 'Tomehipi',
  },
  {
    id: '7204021003',
    districtId: '7204021',
    name: 'Kageroa',
  },
  {
    id: '7204021004',
    districtId: '7204021',
    name: 'Lengkeka',
  },
  {
    id: '7204021005',
    districtId: '7204021',
    name: 'Kolori',
  },
  {
    id: '7204021006',
    districtId: '7204021',
    name: 'Lelio',
  },
  {
    id: '7204030002',
    districtId: '7204030',
    name: 'Tonusu',
  },
  {
    id: '7204030003',
    districtId: '7204030',
    name: 'Mayakeli',
  },
  {
    id: '7204030004',
    districtId: '7204030',
    name: 'Buyumpondoli',
  },
  {
    id: '7204030005',
    districtId: '7204030',
    name: 'Pamona',
  },
  {
    id: '7204030008',
    districtId: '7204030',
    name: 'Tentena',
  },
  {
    id: '7204030009',
    districtId: '7204030',
    name: 'Sangele',
  },
  {
    id: '7204030010',
    districtId: '7204030',
    name: 'Peura',
  },
  {
    id: '7204030011',
    districtId: '7204030',
    name: 'Dulumai',
  },
  {
    id: '7204030030',
    districtId: '7204030',
    name: 'Leboni',
  },
  {
    id: '7204030031',
    districtId: '7204030',
    name: 'Soe',
  },
  {
    id: '7204030032',
    districtId: '7204030',
    name: 'Wera',
  },
  {
    id: '7204031001',
    districtId: '7204031',
    name: 'Masewe',
  },
  {
    id: '7204031002',
    districtId: '7204031',
    name: 'Pancasila I',
  },
  {
    id: '7204031003',
    districtId: '7204031',
    name: 'Olumokunde',
  },
  {
    id: '7204031004',
    districtId: '7204031',
    name: 'Kamba',
  },
  {
    id: '7204031005',
    districtId: '7204031',
    name: 'Petiro',
  },
  {
    id: '7204031006',
    districtId: '7204031',
    name: 'Taripa',
  },
  {
    id: '7204031007',
    districtId: '7204031',
    name: 'Tiu',
  },
  {
    id: '7204031008',
    districtId: '7204031',
    name: 'Poleganyara',
  },
  {
    id: '7204031009',
    districtId: '7204031',
    name: 'Ompo Didiri',
  },
  {
    id: '7204031010',
    districtId: '7204031',
    name: 'Kelei',
  },
  {
    id: '7204031011',
    districtId: '7204031',
    name: 'Matialemba',
  },
  {
    id: '7204031012',
    districtId: '7204031',
    name: 'Kancuu',
  },
  {
    id: '7204031013',
    districtId: '7204031',
    name: 'Magapu',
  },
  {
    id: '7204032001',
    districtId: '7204032',
    name: 'Petirodongi',
  },
  {
    id: '7204032002',
    districtId: '7204032',
    name: 'Tendeadongi',
  },
  {
    id: '7204032003',
    districtId: '7204032',
    name: 'Sawidago',
  },
  {
    id: '7204032004',
    districtId: '7204032',
    name: 'Saojo',
  },
  {
    id: '7204032005',
    districtId: '7204032',
    name: 'Uelincu',
  },
  {
    id: '7204032006',
    districtId: '7204032',
    name: 'Sulewana',
  },
  {
    id: '7204032007',
    districtId: '7204032',
    name: 'Lena',
  },
  {
    id: '7204032008',
    districtId: '7204032',
    name: 'Sangira',
  },
  {
    id: '7204032010',
    districtId: '7204032',
    name: 'Panjoka',
  },
  {
    id: '7204040009',
    districtId: '7204040',
    name: 'Dodolo',
  },
  {
    id: '7204040017',
    districtId: '7204040',
    name: 'Kaduwaa',
  },
  {
    id: '7204040018',
    districtId: '7204040',
    name: 'Alitupu',
  },
  {
    id: '7204040019',
    districtId: '7204040',
    name: 'Wuasa',
  },
  {
    id: '7204040020',
    districtId: '7204040',
    name: 'Watumaeta',
  },
  {
    id: '7204040021',
    districtId: '7204040',
    name: 'Sedoa',
  },
  {
    id: '7204040022',
    districtId: '7204040',
    name: 'Bumi Banyusari',
  },
  {
    id: '7204041001',
    districtId: '7204041',
    name: 'Hanggira',
  },
  {
    id: '7204041003',
    districtId: '7204041',
    name: 'Doda',
  },
  {
    id: '7204041004',
    districtId: '7204041',
    name: 'Bariri',
  },
  {
    id: '7204041005',
    districtId: '7204041',
    name: 'Torire',
  },
  {
    id: '7204041006',
    districtId: '7204041',
    name: 'Rompo',
  },
  {
    id: '7204041007',
    districtId: '7204041',
    name: 'Baliura',
  },
  {
    id: '7204041008',
    districtId: '7204041',
    name: 'Katu',
  },
  {
    id: '7204042001',
    districtId: '7204042',
    name: 'Tamadue',
  },
  {
    id: '7204042002',
    districtId: '7204042',
    name: 'Maholo',
  },
  {
    id: '7204042003',
    districtId: '7204042',
    name: 'Winowanga',
  },
  {
    id: '7204042004',
    districtId: '7204042',
    name: 'Mekar Sari',
  },
  {
    id: '7204042005',
    districtId: '7204042',
    name: 'Kalemago',
  },
  {
    id: '7204043001',
    districtId: '7204043',
    name: 'Talabosa',
  },
  {
    id: '7204043003',
    districtId: '7204043',
    name: 'Watutau',
  },
  {
    id: '7204043004',
    districtId: '7204043',
    name: 'Siliwanga',
  },
  {
    id: '7204043005',
    districtId: '7204043',
    name: 'Wanga',
  },
  {
    id: '7204050001',
    districtId: '7204050',
    name: 'Betania',
  },
  {
    id: '7204050002',
    districtId: '7204050',
    name: 'Toini',
  },
  {
    id: '7204050003',
    districtId: '7204050',
    name: 'Mapane',
  },
  {
    id: '7204050004',
    districtId: '7204050',
    name: 'Bega',
  },
  {
    id: '7204050005',
    districtId: '7204050',
    name: 'Kasiguncu',
  },
  {
    id: '7204050006',
    districtId: '7204050',
    name: 'Masamba',
  },
  {
    id: '7204050007',
    districtId: '7204050',
    name: 'Saatu',
  },
  {
    id: '7204050008',
    districtId: '7204050',
    name: 'Pinedapa',
  },
  {
    id: '7204050009',
    districtId: '7204050',
    name: 'Masani',
  },
  {
    id: '7204050010',
    districtId: '7204050',
    name: 'Tokorondo',
  },
  {
    id: '7204050011',
    districtId: '7204050',
    name: 'Tiwaa',
  },
  {
    id: '7204050012',
    districtId: '7204050',
    name: 'Lanto Jaya',
  },
  {
    id: '7204050013',
    districtId: '7204050',
    name: 'Lape',
  },
  {
    id: '7204050014',
    districtId: '7204050',
    name: 'Towu',
  },
  {
    id: '7204050015',
    districtId: '7204050',
    name: 'Tabalu',
  },
  {
    id: '7204050016',
    districtId: '7204050',
    name: 'Ueralulu',
  },
  {
    id: '7204051001',
    districtId: '7204051',
    name: 'Sangginora',
  },
  {
    id: '7204051002',
    districtId: '7204051',
    name: 'Dewua',
  },
  {
    id: '7204051003',
    districtId: '7204051',
    name: 'Malitu',
  },
  {
    id: '7204051004',
    districtId: '7204051',
    name: 'Tangkura',
  },
  {
    id: '7204051005',
    districtId: '7204051',
    name: 'Patiwunga',
  },
  {
    id: '7204051006',
    districtId: '7204051',
    name: 'Padalembara',
  },
  {
    id: '7204051007',
    districtId: '7204051',
    name: 'Betalemba',
  },
  {
    id: '7204051008',
    districtId: '7204051',
    name: 'Pantangolemba',
  },
  {
    id: '7204051009',
    districtId: '7204051',
    name: 'Taunca',
  },
  {
    id: '7204052001',
    districtId: '7204052',
    name: 'Kilo',
  },
  {
    id: '7204052002',
    districtId: '7204052',
    name: 'Tri Mulya',
  },
  {
    id: '7204052003',
    districtId: '7204052',
    name: 'Kawende',
  },
  {
    id: '7204052004',
    districtId: '7204052',
    name: 'Kalora',
  },
  {
    id: '7204052005',
    districtId: '7204052',
    name: 'Tambarana',
  },
  {
    id: '7204052006',
    districtId: '7204052',
    name: 'Bakti Agung',
  },
  {
    id: '7204052007',
    districtId: '7204052',
    name: 'Tumora',
  },
  {
    id: '7204052009',
    districtId: '7204052',
    name: 'Tobe',
  },
  {
    id: '7204052010',
    districtId: '7204052',
    name: 'Maranda',
  },
  {
    id: '7204060001',
    districtId: '7204060',
    name: 'Tampemadoro',
  },
  {
    id: '7204060002',
    districtId: '7204060',
    name: 'Pandiri',
  },
  {
    id: '7204060003',
    districtId: '7204060',
    name: 'Watuawu',
  },
  {
    id: '7204060004',
    districtId: '7204060',
    name: 'Tambaro',
  },
  {
    id: '7204060005',
    districtId: '7204060',
    name: 'Sintuwulemba',
  },
  {
    id: '7204060006',
    districtId: '7204060',
    name: 'Tagolu',
  },
  {
    id: '7204060007',
    districtId: '7204060',
    name: 'Maliwuko',
  },
  {
    id: '7204060008',
    districtId: '7204060',
    name: 'Silanca',
  },
  {
    id: '7204060010',
    districtId: '7204060',
    name: 'Bategencu',
  },
  {
    id: '7204060011',
    districtId: '7204060',
    name: 'Toyado',
  },
  {
    id: '7204060012',
    districtId: '7204060',
    name: 'Tongko',
  },
  {
    id: '7204060013',
    districtId: '7204060',
    name: 'Malei',
  },
  {
    id: '7204060014',
    districtId: '7204060',
    name: 'Labuan',
  },
  {
    id: '7204060015',
    districtId: '7204060',
    name: 'Ratoombu',
  },
  {
    id: '7204060016',
    districtId: '7204060',
    name: 'Labuadago',
  },
  {
    id: '7204070006',
    districtId: '7204070',
    name: 'Gebang Rejo',
  },
  {
    id: '7204070007',
    districtId: '7204070',
    name: 'Moengko',
  },
  {
    id: '7204070008',
    districtId: '7204070',
    name: 'Moengko Baru',
  },
  {
    id: '7204070009',
    districtId: '7204070',
    name: 'Kayamanya',
  },
  {
    id: '7204070010',
    districtId: '7204070',
    name: 'Gebangrejo Timur',
  },
  {
    id: '7204070011',
    districtId: '7204070',
    name: 'Gebangrejo Barat',
  },
  {
    id: '7204070012',
    districtId: '7204070',
    name: 'Kayamanya Sentral',
  },
  {
    id: '7204071001',
    districtId: '7204071',
    name: 'Bonesompe',
  },
  {
    id: '7204071002',
    districtId: '7204071',
    name: 'Kasintuwu',
  },
  {
    id: '7204071003',
    districtId: '7204071',
    name: 'Lombugia',
  },
  {
    id: '7204071004',
    districtId: '7204071',
    name: 'Lawanga',
  },
  {
    id: '7204071005',
    districtId: '7204071',
    name: 'Tegal Rejo',
  },
  {
    id: '7204071006',
    districtId: '7204071',
    name: 'Madale',
  },
  {
    id: '7204071007',
    districtId: '7204071',
    name: 'Lawanga Tawongan',
  },
  {
    id: '7204072001',
    districtId: '7204072',
    name: 'Lembomawo',
  },
  {
    id: '7204072002',
    districtId: '7204072',
    name: 'Ranononcu',
  },
  {
    id: '7204072003',
    districtId: '7204072',
    name: 'Kawua',
  },
  {
    id: '7204072004',
    districtId: '7204072',
    name: 'Bukit Bambu',
  },
  {
    id: '7204072005',
    districtId: '7204072',
    name: 'Sayo',
  },
  {
    id: '7205041001',
    districtId: '7205041',
    name: 'Towiora',
  },
  {
    id: '7205041002',
    districtId: '7205041',
    name: 'Minti Makmur',
  },
  {
    id: '7205041003',
    districtId: '7205041',
    name: 'Polanto Jaya',
  },
  {
    id: '7205041004',
    districtId: '7205041',
    name: 'Tinauka',
  },
  {
    id: '7205041005',
    districtId: '7205041',
    name: 'Lalundu',
  },
  {
    id: '7205041006',
    districtId: '7205041',
    name: 'Polando Jaya',
  },
  {
    id: '7205041007',
    districtId: '7205041',
    name: 'Rio Mukti',
  },
  {
    id: '7205041008',
    districtId: '7205041',
    name: 'Panca Mukti',
  },
  {
    id: '7205041009',
    districtId: '7205041',
    name: 'Pantolobete',
  },
  {
    id: '7205041010',
    districtId: '7205041',
    name: 'Bonemarawa',
  },
  {
    id: '7205041011',
    districtId: '7205041',
    name: 'Pakava',
  },
  {
    id: '7205041012',
    districtId: '7205041',
    name: 'Ngovi',
  },
  {
    id: '7205041013',
    districtId: '7205041',
    name: 'Bukit Indah',
  },
  {
    id: '7205041014',
    districtId: '7205041',
    name: 'Mbulawa',
  },
  {
    id: '7205051001',
    districtId: '7205051',
    name: 'Palintuma',
  },
  {
    id: '7205051002',
    districtId: '7205051',
    name: 'Gimpubia',
  },
  {
    id: '7205051003',
    districtId: '7205051',
    name: 'Bambakanini',
  },
  {
    id: '7205051004',
    districtId: '7205051',
    name: 'Dangaraa',
  },
  {
    id: '7205051005',
    districtId: '7205051',
    name: 'Tamodo',
  },
  {
    id: '7205051006',
    districtId: '7205051',
    name: 'Bambakaenu',
  },
  {
    id: '7205051007',
    districtId: '7205051',
    name: 'Karovia',
  },
  {
    id: '7205051008',
    districtId: '7205051',
    name: 'Kanagalongga',
  },
  {
    id: '7205051009',
    districtId: '7205051',
    name: 'Tavanggeli',
  },
  {
    id: '7205080013',
    districtId: '7205080',
    name: 'Loli Oge',
  },
  {
    id: '7205080014',
    districtId: '7205080',
    name: 'Loli Tasiburi',
  },
  {
    id: '7205080020',
    districtId: '7205080',
    name: 'Kabonga Besar',
  },
  {
    id: '7205080021',
    districtId: '7205080',
    name: 'Ganti',
  },
  {
    id: '7205080022',
    districtId: '7205080',
    name: 'Gunung Bale',
  },
  {
    id: '7205080023',
    districtId: '7205080',
    name: 'Kabonga Kecil',
  },
  {
    id: '7205080024',
    districtId: '7205080',
    name: 'Tanjung Batu',
  },
  {
    id: '7205080025',
    districtId: '7205080',
    name: 'Maleni',
  },
  {
    id: '7205080026',
    districtId: '7205080',
    name: 'Boya',
  },
  {
    id: '7205080027',
    districtId: '7205080',
    name: 'Labuan Bajo',
  },
  {
    id: '7205080028',
    districtId: '7205080',
    name: 'Boneoge',
  },
  {
    id: '7205080029',
    districtId: '7205080',
    name: 'Loli Pesua',
  },
  {
    id: '7205080030',
    districtId: '7205080',
    name: 'Loli Dondo',
  },
  {
    id: '7205080031',
    districtId: '7205080',
    name: 'Loli Saluran',
  },
  {
    id: '7205081002',
    districtId: '7205081',
    name: 'Salumpaku',
  },
  {
    id: '7205081003',
    districtId: '7205081',
    name: 'Watatu',
  },
  {
    id: '7205081004',
    districtId: '7205081',
    name: 'Surumana',
  },
  {
    id: '7205081005',
    districtId: '7205081',
    name: 'Lalombi',
  },
  {
    id: '7205081006',
    districtId: '7205081',
    name: 'Bambarimi',
  },
  {
    id: '7205081007',
    districtId: '7205081',
    name: 'Tanahmea',
  },
  {
    id: '7205081008',
    districtId: '7205081',
    name: 'Salungkaenu',
  },
  {
    id: '7205081009',
    districtId: '7205081',
    name: 'Lumbumamara',
  },
  {
    id: '7205081010',
    districtId: '7205081',
    name: 'Tolongano',
  },
  {
    id: '7205081011',
    districtId: '7205081',
    name: 'Tosale',
  },
  {
    id: '7205081012',
    districtId: '7205081',
    name: 'Lumbutarombo',
  },
  {
    id: '7205081013',
    districtId: '7205081',
    name: 'Malino',
  },
  {
    id: '7205081014',
    districtId: '7205081',
    name: 'Ongulara',
  },
  {
    id: '7205081015',
    districtId: '7205081',
    name: 'Lumbulama',
  },
  {
    id: '7205081016',
    districtId: '7205081',
    name: 'Salusumpu',
  },
  {
    id: '7205081017',
    districtId: '7205081',
    name: 'Sarombaya',
  },
  {
    id: '7205081018',
    districtId: '7205081',
    name: 'Lembasada',
  },
  {
    id: '7205081019',
    districtId: '7205081',
    name: 'Tanahmpulu',
  },
  {
    id: '7205082001',
    districtId: '7205082',
    name: 'Powelua',
  },
  {
    id: '7205082002',
    districtId: '7205082',
    name: 'Lumbudolo',
  },
  {
    id: '7205082003',
    districtId: '7205082',
    name: 'Salubomba',
  },
  {
    id: '7205082004',
    districtId: '7205082',
    name: 'Towale',
  },
  {
    id: '7205082005',
    districtId: '7205082',
    name: 'Limboro',
  },
  {
    id: '7205082006',
    districtId: '7205082',
    name: 'Kola-Kola',
  },
  {
    id: '7205082007',
    districtId: '7205082',
    name: 'Mekar Baru',
  },
  {
    id: '7205082008',
    districtId: '7205082',
    name: 'Lampo',
  },
  {
    id: '7205090007',
    districtId: '7205090',
    name: 'Labuan Lelea',
  },
  {
    id: '7205090008',
    districtId: '7205090',
    name: 'Labuan Kungguma',
  },
  {
    id: '7205090009',
    districtId: '7205090',
    name: 'Labuan Panimba',
  },
  {
    id: '7205090010',
    districtId: '7205090',
    name: 'Labuan',
  },
  {
    id: '7205090011',
    districtId: '7205090',
    name: 'Labuan Salumbone',
  },
  {
    id: '7205090012',
    districtId: '7205090',
    name: 'Labuan Toposo',
  },
  {
    id: '7205090013',
    districtId: '7205090',
    name: 'Labuan Lumbubaka',
  },
  {
    id: '7205091001',
    districtId: '7205091',
    name: 'Bale',
  },
  {
    id: '7205091002',
    districtId: '7205091',
    name: 'Guntarano',
  },
  {
    id: '7205091003',
    districtId: '7205091',
    name: 'Nupa Bomba',
  },
  {
    id: '7205091004',
    districtId: '7205091',
    name: 'Wombo',
  },
  {
    id: '7205091005',
    districtId: '7205091',
    name: 'Wani I',
  },
  {
    id: '7205091006',
    districtId: '7205091',
    name: 'Wani II',
  },
  {
    id: '7205091007',
    districtId: '7205091',
    name: 'Wombo Panau',
  },
  {
    id: '7205091008',
    districtId: '7205091',
    name: 'Wombo Kalonggo',
  },
  {
    id: '7205091009',
    districtId: '7205091',
    name: 'Wani III',
  },
  {
    id: '7205091010',
    districtId: '7205091',
    name: 'Wani Lumbumpetigo',
  },
  {
    id: '7205100001',
    districtId: '7205100',
    name: 'Dalaka',
  },
  {
    id: '7205100002',
    districtId: '7205100',
    name: 'Lero',
  },
  {
    id: '7205100003',
    districtId: '7205100',
    name: 'Toaya',
  },
  {
    id: '7205100004',
    districtId: '7205100',
    name: 'Sumari',
  },
  {
    id: '7205100005',
    districtId: '7205100',
    name: 'Taripa',
  },
  {
    id: '7205100006',
    districtId: '7205100',
    name: 'Masaingi',
  },
  {
    id: '7205100007',
    districtId: '7205100',
    name: 'Marana',
  },
  {
    id: '7205100016',
    districtId: '7205100',
    name: 'Lero Tatari',
  },
  {
    id: '7205100017',
    districtId: '7205100',
    name: 'Toaya Vunta',
  },
  {
    id: '7205100018',
    districtId: '7205100',
    name: 'Kumbasa',
  },
  {
    id: '7205100020',
    districtId: '7205100',
    name: 'Amal',
  },
  {
    id: '7205100021',
    districtId: '7205100',
    name: 'Kavaya',
  },
  {
    id: '7205101001',
    districtId: '7205101',
    name: 'Tibo',
  },
  {
    id: '7205101002',
    districtId: '7205101',
    name: 'Saloya',
  },
  {
    id: '7205101003',
    districtId: '7205101',
    name: 'Kaliburu',
  },
  {
    id: '7205101004',
    districtId: '7205101',
    name: 'Batusuya',
  },
  {
    id: '7205101005',
    districtId: '7205101',
    name: "Batusuya Go'O",
  },
  {
    id: '7205101006',
    districtId: '7205101',
    name: 'Kaliburu Kata',
  },
  {
    id: '7205102001',
    districtId: '7205102',
    name: 'Tamarenja',
  },
  {
    id: '7205102002',
    districtId: '7205102',
    name: 'Oti',
  },
  {
    id: '7205102003',
    districtId: '7205102',
    name: 'Alindau',
  },
  {
    id: '7205102004',
    districtId: '7205102',
    name: 'Sikara Tobata',
  },
  {
    id: '7205102005',
    districtId: '7205102',
    name: 'Sipeso',
  },
  {
    id: '7205102006',
    districtId: '7205102',
    name: 'Sindosa',
  },
  {
    id: '7205120001',
    districtId: '7205120',
    name: 'Ombo',
  },
  {
    id: '7205120002',
    districtId: '7205120',
    name: 'Tondo S',
  },
  {
    id: '7205120003',
    districtId: '7205120',
    name: 'Jono Oge',
  },
  {
    id: '7205120004',
    districtId: '7205120',
    name: 'Dampal',
  },
  {
    id: '7205120005',
    districtId: '7205120',
    name: 'Sipi',
  },
  {
    id: '7205120006',
    districtId: '7205120',
    name: 'Tanjung Padang',
  },
  {
    id: '7205120007',
    districtId: '7205120',
    name: 'Balentuma',
  },
  {
    id: '7205120008',
    districtId: '7205120',
    name: 'Sibado',
  },
  {
    id: '7205120009',
    districtId: '7205120',
    name: 'Tompe',
  },
  {
    id: '7205120010',
    districtId: '7205120',
    name: 'Lompio',
  },
  {
    id: '7205120012',
    districtId: '7205120',
    name: 'Lende Tovea',
  },
  {
    id: '7205120014',
    districtId: '7205120',
    name: 'Ujumbou',
  },
  {
    id: '7205130001',
    districtId: '7205130',
    name: 'Lombonga',
  },
  {
    id: '7205130008',
    districtId: '7205130',
    name: 'Labean',
  },
  {
    id: '7205130009',
    districtId: '7205130',
    name: 'Meli',
  },
  {
    id: '7205130010',
    districtId: '7205130',
    name: 'Tambu',
  },
  {
    id: '7205130011',
    districtId: '7205130',
    name: 'Siweli',
  },
  {
    id: '7205130012',
    districtId: '7205130',
    name: 'Sibualong',
  },
  {
    id: '7205130013',
    districtId: '7205130',
    name: 'Sibayu',
  },
  {
    id: '7205130015',
    districtId: '7205130',
    name: 'Malino',
  },
  {
    id: '7205130016',
    districtId: '7205130',
    name: 'Mapane Tambu',
  },
  {
    id: '7205130017',
    districtId: '7205130',
    name: 'Tovia Tambu',
  },
  {
    id: '7205130018',
    districtId: '7205130',
    name: 'Simagaya',
  },
  {
    id: '7205130019',
    districtId: '7205130',
    name: 'Sipure',
  },
  {
    id: '7205130020',
    districtId: '7205130',
    name: 'Kampung Baru Sibayu',
  },
  {
    id: '7205131001',
    districtId: '7205131',
    name: 'Walandano',
  },
  {
    id: '7205131002',
    districtId: '7205131',
    name: 'Malei',
  },
  {
    id: '7205131003',
    districtId: '7205131',
    name: 'Kamonji',
  },
  {
    id: '7205131004',
    districtId: '7205131',
    name: 'Ketong',
  },
  {
    id: '7205131005',
    districtId: '7205131',
    name: 'Manimbaya',
  },
  {
    id: '7205131006',
    districtId: '7205131',
    name: 'Rano B',
  },
  {
    id: '7205131007',
    districtId: '7205131',
    name: 'Pomolulu',
  },
  {
    id: '7205131008',
    districtId: '7205131',
    name: 'Palau',
  },
  {
    id: '7205140001',
    districtId: '7205140',
    name: 'Kambayang',
  },
  {
    id: '7205140002',
    districtId: '7205140',
    name: 'Budimukti',
  },
  {
    id: '7205140003',
    districtId: '7205140',
    name: 'Talaga',
  },
  {
    id: '7205140004',
    districtId: '7205140',
    name: 'Sabang',
  },
  {
    id: '7205140005',
    districtId: '7205140',
    name: 'Sioyong',
  },
  {
    id: '7205140006',
    districtId: '7205140',
    name: 'Karyamukti',
  },
  {
    id: '7205140007',
    districtId: '7205140',
    name: 'Panii',
  },
  {
    id: '7205140008',
    districtId: '7205140',
    name: 'Ponggerang',
  },
  {
    id: '7205140009',
    districtId: '7205140',
    name: 'Malonas',
  },
  {
    id: '7205140010',
    districtId: '7205140',
    name: 'Rerang',
  },
  {
    id: '7205140011',
    districtId: '7205140',
    name: 'Lemba Mukti',
  },
  {
    id: '7205140012',
    districtId: '7205140',
    name: 'Parisan Agung',
  },
  {
    id: '7205140014',
    districtId: '7205140',
    name: 'Long',
  },
  {
    id: '7205160001',
    districtId: '7205160',
    name: 'Pangalasiang',
  },
  {
    id: '7205160002',
    districtId: '7205160',
    name: 'Bukit Harapan',
  },
  {
    id: '7205160003',
    districtId: '7205160',
    name: 'Tonggolobibi',
  },
  {
    id: '7205160004',
    districtId: '7205160',
    name: 'Samalili',
  },
  {
    id: '7205160005',
    districtId: '7205160',
    name: 'Siboang',
  },
  {
    id: '7205160006',
    districtId: '7205160',
    name: 'Siwalempu',
  },
  {
    id: '7205160007',
    districtId: '7205160',
    name: 'Balukang',
  },
  {
    id: '7205160008',
    districtId: '7205160',
    name: 'Bou',
  },
  {
    id: '7205160013',
    districtId: '7205160',
    name: 'Balukang II',
  },
  {
    id: '7205161001',
    districtId: '7205161',
    name: 'Pesik',
  },
  {
    id: '7205161003',
    districtId: '7205161',
    name: 'Ogoamas II',
  },
  {
    id: '7205161004',
    districtId: '7205161',
    name: 'Ogoamas I',
  },
  {
    id: '7205161005',
    districtId: '7205161',
    name: 'Bengkoli',
  },
  {
    id: '7206010001',
    districtId: '7206010',
    name: 'Kombo',
  },
  {
    id: '7206010002',
    districtId: '7206010',
    name: 'Tampiala',
  },
  {
    id: '7206010003',
    districtId: '7206010',
    name: 'Soni',
  },
  {
    id: '7206010004',
    districtId: '7206010',
    name: 'Bangkir',
  },
  {
    id: '7206010005',
    districtId: '7206010',
    name: 'Dongko',
  },
  {
    id: '7206010006',
    districtId: '7206010',
    name: 'Mimbala',
  },
  {
    id: '7206010007',
    districtId: '7206010',
    name: 'Abbajareng',
  },
  {
    id: '7206010008',
    districtId: '7206010',
    name: 'Paddumpu',
  },
  {
    id: '7206010011',
    districtId: '7206010',
    name: 'Pallakawe',
  },
  {
    id: '7206010012',
    districtId: '7206010',
    name: 'Simuntu',
  },
  {
    id: '7206010013',
    districtId: '7206010',
    name: 'Lemba Harapan',
  },
  {
    id: '7206020001',
    districtId: '7206020',
    name: 'Kabinuang',
  },
  {
    id: '7206020002',
    districtId: '7206020',
    name: 'Ogotua',
  },
  {
    id: '7206020003',
    districtId: '7206020',
    name: 'Bambapula',
  },
  {
    id: '7206020004',
    districtId: '7206020',
    name: 'Malambigu',
  },
  {
    id: '7206020005',
    districtId: '7206020',
    name: 'Tompoh',
  },
  {
    id: '7206020006',
    districtId: '7206020',
    name: 'Banagan',
  },
  {
    id: '7206020007',
    districtId: '7206020',
    name: 'Simatang Tanjung',
  },
  {
    id: '7206020008',
    districtId: '7206020',
    name: 'Simatang Utara',
  },
  {
    id: '7206020010',
    districtId: '7206020',
    name: 'Ogolali',
  },
  {
    id: '7206020011',
    districtId: '7206020',
    name: 'Balaroa',
  },
  {
    id: '7206020012',
    districtId: '7206020',
    name: 'Stadong',
  },
  {
    id: '7206030001',
    districtId: '7206030',
    name: 'Luok Manipi',
  },
  {
    id: '7206030002',
    districtId: '7206030',
    name: 'Salumbia',
  },
  {
    id: '7206030003',
    districtId: '7206030',
    name: 'Bambapun',
  },
  {
    id: '7206030004',
    districtId: '7206030',
    name: 'Ogowele',
  },
  {
    id: '7206030005',
    districtId: '7206030',
    name: 'Lais',
  },
  {
    id: '7206030006',
    districtId: '7206030',
    name: 'Ogogasang',
  },
  {
    id: '7206030007',
    districtId: '7206030',
    name: 'Malomba',
  },
  {
    id: '7206030009',
    districtId: '7206030',
    name: 'Ogogili',
  },
  {
    id: '7206030010',
    districtId: '7206030',
    name: 'Tinabogan',
  },
  {
    id: '7206030011',
    districtId: '7206030',
    name: 'Malulu',
  },
  {
    id: '7206030012',
    districtId: '7206030',
    name: 'Malala',
  },
  {
    id: '7206030013',
    districtId: '7206030',
    name: 'Anggasan',
  },
  {
    id: '7206030014',
    districtId: '7206030',
    name: 'Betengon',
  },
  {
    id: '7206030015',
    districtId: '7206030',
    name: 'Pangkung',
  },
  {
    id: '7206030016',
    districtId: '7206030',
    name: 'Labuo',
  },
  {
    id: '7206030017',
    districtId: '7206030',
    name: 'Ogowele Buga',
  },
  {
    id: '7206031001',
    districtId: '7206031',
    name: 'Buga',
  },
  {
    id: '7206031002',
    districtId: '7206031',
    name: 'Batuilo',
  },
  {
    id: '7206031003',
    districtId: '7206031',
    name: 'Bambalaga',
  },
  {
    id: '7206031004',
    districtId: '7206031',
    name: 'Kamalu',
  },
  {
    id: '7206031005',
    districtId: '7206031',
    name: 'Muara Besar',
  },
  {
    id: '7206031006',
    districtId: '7206031',
    name: 'Bilo',
  },
  {
    id: '7206031007',
    districtId: '7206031',
    name: 'Pagaitan',
  },
  {
    id: '7206031008',
    districtId: '7206031',
    name: 'Labuan Lobo',
  },
  {
    id: '7206031009',
    districtId: '7206031',
    name: 'Sambujan',
  },
  {
    id: '7206031010',
    districtId: '7206031',
    name: 'Pulias',
  },
  {
    id: '7206031011',
    districtId: '7206031',
    name: 'Kabetan',
  },
  {
    id: '7206032001',
    districtId: '7206032',
    name: 'Labonu',
  },
  {
    id: '7206032002',
    districtId: '7206032',
    name: 'Sibaluton',
  },
  {
    id: '7206032003',
    districtId: '7206032',
    name: 'Kayulompa',
  },
  {
    id: '7206032004',
    districtId: '7206032',
    name: 'Silondou',
  },
  {
    id: '7206032005',
    districtId: '7206032',
    name: 'Kinapasan',
  },
  {
    id: '7206032006',
    districtId: '7206032',
    name: 'Ogosipat',
  },
  {
    id: '7206032007',
    districtId: '7206032',
    name: 'Konkomos',
  },
  {
    id: '7206032008',
    districtId: '7206032',
    name: 'Galandau',
  },
  {
    id: '7206032009',
    districtId: '7206032',
    name: 'Marisa',
  },
  {
    id: '7206032010',
    districtId: '7206032',
    name: 'Basi',
  },
  {
    id: '7206040012',
    districtId: '7206040',
    name: 'Dadakitan',
  },
  {
    id: '7206040014',
    districtId: '7206040',
    name: 'Panasakan',
  },
  {
    id: '7206040015',
    districtId: '7206040',
    name: 'Sidoarjo',
  },
  {
    id: '7206040016',
    districtId: '7206040',
    name: 'Baru',
  },
  {
    id: '7206040017',
    districtId: '7206040',
    name: 'Nalu',
  },
  {
    id: '7206040018',
    districtId: '7206040',
    name: 'Tambun',
  },
  {
    id: '7206040019',
    districtId: '7206040',
    name: 'Buntuna',
  },
  {
    id: '7206040020',
    districtId: '7206040',
    name: 'Lelean Nono',
  },
  {
    id: '7206040021',
    districtId: '7206040',
    name: 'Pangi',
  },
  {
    id: '7206041001',
    districtId: '7206041',
    name: 'Janja',
  },
  {
    id: '7206041002',
    districtId: '7206041',
    name: 'Maibua',
  },
  {
    id: '7206041003',
    districtId: '7206041',
    name: 'Sibea',
  },
  {
    id: '7206041004',
    districtId: '7206041',
    name: 'Muliasari',
  },
  {
    id: '7206041005',
    districtId: '7206041',
    name: 'Oyom',
  },
  {
    id: '7206041006',
    districtId: '7206041',
    name: 'Salugan',
  },
  {
    id: '7206041007',
    districtId: '7206041',
    name: 'Lampasio',
  },
  {
    id: '7206041008',
    districtId: '7206041',
    name: 'Tinading',
  },
  {
    id: '7206041009',
    districtId: '7206041',
    name: 'Ogomatanang',
  },
  {
    id: '7206050001',
    districtId: '7206050',
    name: 'Ogomoli',
  },
  {
    id: '7206050002',
    districtId: '7206050',
    name: 'Sandana',
  },
  {
    id: '7206050003',
    districtId: '7206050',
    name: 'Kalangkangan',
  },
  {
    id: '7206050004',
    districtId: '7206050',
    name: 'Lantapan',
  },
  {
    id: '7206050005',
    districtId: '7206050',
    name: 'Lakatan',
  },
  {
    id: '7206050006',
    districtId: '7206050',
    name: 'Tinigi',
  },
  {
    id: '7206050007',
    districtId: '7206050',
    name: 'Ginunggung',
  },
  {
    id: '7206050008',
    districtId: '7206050',
    name: 'Lalos',
  },
  {
    id: '7206050010',
    districtId: '7206050',
    name: 'Sabang',
  },
  {
    id: '7206050011',
    districtId: '7206050',
    name: 'Bajugan',
  },
  {
    id: '7206050012',
    districtId: '7206050',
    name: 'Aung',
  },
  {
    id: '7206050013',
    districtId: '7206050',
    name: 'Malangga',
  },
  {
    id: '7206050014',
    districtId: '7206050',
    name: 'Kinapasan',
  },
  {
    id: '7206060005',
    districtId: '7206060',
    name: 'Santigi',
  },
  {
    id: '7206060006',
    districtId: '7206060',
    name: 'Laulalang',
  },
  {
    id: '7206060007',
    districtId: '7206060',
    name: 'Salumpaga',
  },
  {
    id: '7206060008',
    districtId: '7206060',
    name: 'Diule',
  },
  {
    id: '7206060009',
    districtId: '7206060',
    name: 'Pinjan',
  },
  {
    id: '7206060010',
    districtId: '7206060',
    name: 'Binontoan',
  },
  {
    id: '7206060011',
    districtId: '7206060',
    name: 'Lakuan Tolitoli',
  },
  {
    id: '7206060012',
    districtId: '7206060',
    name: 'Teluk Jaya',
  },
  {
    id: '7206060013',
    districtId: '7206060',
    name: 'Timbolo',
  },
  {
    id: '7206060014',
    districtId: '7206060',
    name: 'Gio',
  },
  {
    id: '7206061001',
    districtId: '7206061',
    name: 'Galumpang',
  },
  {
    id: '7206061002',
    districtId: '7206061',
    name: 'Dungingis',
  },
  {
    id: '7206061003',
    districtId: '7206061',
    name: 'Kapas',
  },
  {
    id: '7206061004',
    districtId: '7206061',
    name: 'Lingadan',
  },
  {
    id: '7207010009',
    districtId: '7207010',
    name: 'Tuinan',
  },
  {
    id: '7207010010',
    districtId: '7207010',
    name: 'Lakea II',
  },
  {
    id: '7207010011',
    districtId: '7207010',
    name: 'Lakea 1',
  },
  {
    id: '7207010012',
    districtId: '7207010',
    name: 'Lakuan Buol',
  },
  {
    id: '7207010017',
    districtId: '7207010',
    name: 'Bukaan',
  },
  {
    id: '7207010018',
    districtId: '7207010',
    name: 'Ilambe',
  },
  {
    id: '7207011001',
    districtId: '7207011',
    name: 'Bugis',
  },
  {
    id: '7207011002',
    districtId: '7207011',
    name: 'Kulango',
  },
  {
    id: '7207011003',
    districtId: '7207011',
    name: 'Buol',
  },
  {
    id: '7207011004',
    districtId: '7207011',
    name: 'Kali',
  },
  {
    id: '7207011005',
    districtId: '7207011',
    name: 'Leok II',
  },
  {
    id: '7207011006',
    districtId: '7207011',
    name: 'Leok 1',
  },
  {
    id: '7207011007',
    districtId: '7207011',
    name: 'Kumaligon',
  },
  {
    id: '7207012001',
    districtId: '7207012',
    name: 'Lamakan',
  },
  {
    id: '7207012002',
    districtId: '7207012',
    name: 'Busak II',
  },
  {
    id: '7207012003',
    districtId: '7207012',
    name: 'Busak I',
  },
  {
    id: '7207012004',
    districtId: '7207012',
    name: 'Monano',
  },
  {
    id: '7207012005',
    districtId: '7207012',
    name: 'Baruga',
  },
  {
    id: '7207012006',
    districtId: '7207012',
    name: 'Mendaan',
  },
  {
    id: '7207012007',
    districtId: '7207012',
    name: 'Mokupo',
  },
  {
    id: '7207020006',
    districtId: '7207020',
    name: 'Momunu',
  },
  {
    id: '7207020007',
    districtId: '7207020',
    name: 'Taluan',
  },
  {
    id: '7207020008',
    districtId: '7207020',
    name: 'Pinamula',
  },
  {
    id: '7207020009',
    districtId: '7207020',
    name: 'Pujimulyo',
  },
  {
    id: '7207020010',
    districtId: '7207020',
    name: 'Potugu',
  },
  {
    id: '7207020011',
    districtId: '7207020',
    name: 'Tongon',
  },
  {
    id: '7207020012',
    districtId: '7207020',
    name: 'Panimbul',
  },
  {
    id: '7207020013',
    districtId: '7207020',
    name: 'Pomayagon',
  },
  {
    id: '7207020014',
    districtId: '7207020',
    name: 'Guamonial',
  },
  {
    id: '7207020015',
    districtId: '7207020',
    name: 'Lamadong 2',
  },
  {
    id: '7207020016',
    districtId: '7207020',
    name: 'Lamadong 1',
  },
  {
    id: '7207020017',
    districtId: '7207020',
    name: 'Pajeko',
  },
  {
    id: '7207020018',
    districtId: '7207020',
    name: 'Suraya',
  },
  {
    id: '7207020019',
    districtId: '7207020',
    name: 'Wakat',
  },
  {
    id: '7207020021',
    districtId: '7207020',
    name: 'Mangubi',
  },
  {
    id: '7207020022',
    districtId: '7207020',
    name: 'Pinamula Baru',
  },
  {
    id: '7207021001',
    districtId: '7207021',
    name: 'Jatimulyo',
  },
  {
    id: '7207021002',
    districtId: '7207021',
    name: 'Panilan Jaya',
  },
  {
    id: '7207021003',
    districtId: '7207021',
    name: 'Kokobuka',
  },
  {
    id: '7207021004',
    districtId: '7207021',
    name: 'Airterang',
  },
  {
    id: '7207021005',
    districtId: '7207021',
    name: 'Boilan',
  },
  {
    id: '7207021006',
    districtId: '7207021',
    name: 'Lomuli',
  },
  {
    id: '7207021007',
    districtId: '7207021',
    name: 'Balau',
  },
  {
    id: '7207021008',
    districtId: '7207021',
    name: 'Maniala',
  },
  {
    id: '7207021009',
    districtId: '7207021',
    name: 'Monggonit',
  },
  {
    id: '7207030006',
    districtId: '7207030',
    name: 'Poongan',
  },
  {
    id: '7207030007',
    districtId: '7207030',
    name: 'Tayadun',
  },
  {
    id: '7207030008',
    districtId: '7207030',
    name: 'Bongo',
  },
  {
    id: '7207030009',
    districtId: '7207030',
    name: 'Bokat IV',
  },
  {
    id: '7207030010',
    districtId: '7207030',
    name: 'Doulan',
  },
  {
    id: '7207030015',
    districtId: '7207030',
    name: 'Kodolagon',
  },
  {
    id: '7207030016',
    districtId: '7207030',
    name: 'Bokat',
  },
  {
    id: '7207030017',
    districtId: '7207030',
    name: 'Kantanan',
  },
  {
    id: '7207030018',
    districtId: '7207030',
    name: 'Negeri Lama',
  },
  {
    id: '7207030019',
    districtId: '7207030',
    name: 'Tikopo',
  },
  {
    id: '7207030020',
    districtId: '7207030',
    name: 'Duwamayo',
  },
  {
    id: '7207030021',
    districtId: '7207030',
    name: 'Butukan',
  },
  {
    id: '7207030022',
    districtId: '7207030',
    name: 'Tang',
  },
  {
    id: '7207030023',
    districtId: '7207030',
    name: 'Bukamog',
  },
  {
    id: '7207030024',
    districtId: '7207030',
    name: 'Langudon',
  },
  {
    id: '7207031001',
    districtId: '7207031',
    name: 'Unone',
  },
  {
    id: '7207031002',
    districtId: '7207031',
    name: 'Winangun',
  },
  {
    id: '7207031003',
    districtId: '7207031',
    name: 'Rantemaranu',
  },
  {
    id: '7207031004',
    districtId: '7207031',
    name: 'Modo',
  },
  {
    id: '7207031005',
    districtId: '7207031',
    name: 'Mopu',
  },
  {
    id: '7207031006',
    districtId: '7207031',
    name: 'Potangoan',
  },
  {
    id: '7207031007',
    districtId: '7207031',
    name: 'Diat',
  },
  {
    id: '7207031008',
    districtId: '7207031',
    name: 'Biau',
  },
  {
    id: '7207031011',
    districtId: '7207031',
    name: 'Mooyong',
  },
  {
    id: '7207031012',
    districtId: '7207031',
    name: 'Binuang',
  },
  {
    id: '7207031013',
    districtId: '7207031',
    name: 'Bukal',
  },
  {
    id: '7207031014',
    districtId: '7207031',
    name: 'Mulat',
  },
  {
    id: '7207040001',
    districtId: '7207040',
    name: 'Lonu',
  },
  {
    id: '7207040002',
    districtId: '7207040',
    name: 'Bunobogu',
  },
  {
    id: '7207040003',
    districtId: '7207040',
    name: 'Tamit',
  },
  {
    id: '7207040005',
    districtId: '7207040',
    name: 'Konamukan',
  },
  {
    id: '7207040006',
    districtId: '7207040',
    name: 'Ponipingan',
  },
  {
    id: '7207040007',
    districtId: '7207040',
    name: 'Inalatan',
  },
  {
    id: '7207040013',
    districtId: '7207040',
    name: 'Botugolu',
  },
  {
    id: '7207040014',
    districtId: '7207040',
    name: 'Domag Mekar',
  },
  {
    id: '7207040015',
    districtId: '7207040',
    name: 'Pokobo',
  },
  {
    id: '7207040016',
    districtId: '7207040',
    name: 'Bunobogu Selatan',
  },
  {
    id: '7207041001',
    districtId: '7207041',
    name: 'Diapatih',
  },
  {
    id: '7207041002',
    districtId: '7207041',
    name: 'Bulagidun',
  },
  {
    id: '7207041003',
    districtId: '7207041',
    name: 'Labuton',
  },
  {
    id: '7207041004',
    districtId: '7207041',
    name: 'Lokodoka',
  },
  {
    id: '7207041005',
    districtId: '7207041',
    name: 'Taat',
  },
  {
    id: '7207041006',
    districtId: '7207041',
    name: 'Matinan',
  },
  {
    id: '7207041007',
    districtId: '7207041',
    name: 'Lokodidi',
  },
  {
    id: '7207041008',
    districtId: '7207041',
    name: 'Lipubogu',
  },
  {
    id: '7207041009',
    districtId: '7207041',
    name: 'Nandu',
  },
  {
    id: '7207041010',
    districtId: '7207041',
    name: 'Bulagidun Tanjung',
  },
  {
    id: '7207041011',
    districtId: '7207041',
    name: 'Pandangan',
  },
  {
    id: '7207050005',
    districtId: '7207050',
    name: 'Lintidu',
  },
  {
    id: '7207050006',
    districtId: '7207050',
    name: 'Paleleh',
  },
  {
    id: '7207050007',
    districtId: '7207050',
    name: 'Tolau',
  },
  {
    id: '7207050008',
    districtId: '7207050',
    name: 'Kuala Besar',
  },
  {
    id: '7207050009',
    districtId: '7207050',
    name: 'Batu Rata',
  },
  {
    id: '7207050010',
    districtId: '7207050',
    name: 'Talaki',
  },
  {
    id: '7207050011',
    districtId: '7207050',
    name: 'Lilito',
  },
  {
    id: '7207050012',
    districtId: '7207050',
    name: 'Pionoto',
  },
  {
    id: '7207050013',
    districtId: '7207050',
    name: 'Mulangato',
  },
  {
    id: '7207050015',
    districtId: '7207050',
    name: 'Dopalak',
  },
  {
    id: '7207050017',
    districtId: '7207050',
    name: 'Dutuno',
  },
  {
    id: '7207051001',
    districtId: '7207051',
    name: 'Bodi',
  },
  {
    id: '7207051002',
    districtId: '7207051',
    name: 'Tayokan',
  },
  {
    id: '7207051003',
    districtId: '7207051',
    name: 'Harmoni',
  },
  {
    id: '7207051004',
    districtId: '7207051',
    name: 'Lunguto',
  },
  {
    id: '7207051005',
    districtId: '7207051',
    name: 'Timbulon',
  },
  {
    id: '7207051006',
    districtId: '7207051',
    name: 'Oyak',
  },
  {
    id: '7207051007',
    districtId: '7207051',
    name: 'Hulubalang',
  },
  {
    id: '7208010001',
    districtId: '7208010',
    name: 'Maleyali',
  },
  {
    id: '7208010002',
    districtId: '7208010',
    name: 'Sausu Piore',
  },
  {
    id: '7208010003',
    districtId: '7208010',
    name: 'Sausu Torono',
  },
  {
    id: '7208010004',
    districtId: '7208010',
    name: 'Sausu Trans',
  },
  {
    id: '7208010013',
    districtId: '7208010',
    name: 'Pakareme',
  },
  {
    id: '7208010014',
    districtId: '7208010',
    name: 'Sausu Gandasari',
  },
  {
    id: '7208010016',
    districtId: '7208010',
    name: 'Sausu Salubanga',
  },
  {
    id: '7208010017',
    districtId: '7208010',
    name: 'Taliabo',
  },
  {
    id: '7208010018',
    districtId: '7208010',
    name: 'Sausu Tambu',
  },
  {
    id: '7208010019',
    districtId: '7208010',
    name: 'Sausu Auma',
  },
  {
    id: '7208011001',
    districtId: '7208011',
    name: 'Tolai',
  },
  {
    id: '7208011002',
    districtId: '7208011',
    name: 'Purwosari',
  },
  {
    id: '7208011003',
    districtId: '7208011',
    name: 'Torue',
  },
  {
    id: '7208011004',
    districtId: '7208011',
    name: 'Astina',
  },
  {
    id: '7208011005',
    districtId: '7208011',
    name: 'Tanah Lanto',
  },
  {
    id: '7208011006',
    districtId: '7208011',
    name: 'Tolai Barat',
  },
  {
    id: '7208011007',
    districtId: '7208011',
    name: 'Tolai Timur',
  },
  {
    id: '7208012001',
    districtId: '7208012',
    name: 'Suli',
  },
  {
    id: '7208012002',
    districtId: '7208012',
    name: 'Malakosa',
  },
  {
    id: '7208012003',
    districtId: '7208012',
    name: 'Balinggi',
  },
  {
    id: '7208012004',
    districtId: '7208012',
    name: 'Balinggi Jati',
  },
  {
    id: '7208012005',
    districtId: '7208012',
    name: 'Suli Indah',
  },
  {
    id: '7208012006',
    districtId: '7208012',
    name: 'Beraban',
  },
  {
    id: '7208012007',
    districtId: '7208012',
    name: 'Lebagu',
  },
  {
    id: '7208012008',
    districtId: '7208012',
    name: 'Tumpapa Indah',
  },
  {
    id: '7208012009',
    districtId: '7208012',
    name: 'Catur Karya',
  },
  {
    id: '7208020008',
    districtId: '7208020',
    name: 'Olaya',
  },
  {
    id: '7208020011',
    districtId: '7208020',
    name: 'Pombalowo',
  },
  {
    id: '7208020012',
    districtId: '7208020',
    name: 'Mertasari',
  },
  {
    id: '7208020013',
    districtId: '7208020',
    name: 'Maesa',
  },
  {
    id: '7208020014',
    districtId: '7208020',
    name: 'Loji',
  },
  {
    id: '7208020015',
    districtId: '7208020',
    name: 'Masigi',
  },
  {
    id: '7208020016',
    districtId: '7208020',
    name: 'Bantaya',
  },
  {
    id: '7208020017',
    districtId: '7208020',
    name: 'Kampal',
  },
  {
    id: '7208020019',
    districtId: '7208020',
    name: 'Bambalemo',
  },
  {
    id: '7208020020',
    districtId: '7208020',
    name: 'Lebo',
  },
  {
    id: '7208020021',
    districtId: '7208020',
    name: 'Bambalemo Ranomaisi',
  },
  {
    id: '7208021001',
    districtId: '7208021',
    name: 'Tindaki',
  },
  {
    id: '7208021002',
    districtId: '7208021',
    name: 'Nambaru',
  },
  {
    id: '7208021003',
    districtId: '7208021',
    name: 'Sumber Sari',
  },
  {
    id: '7208021004',
    districtId: '7208021',
    name: 'Masari',
  },
  {
    id: '7208021005',
    districtId: '7208021',
    name: 'Dolago',
  },
  {
    id: '7208021006',
    districtId: '7208021',
    name: 'Lemusa',
  },
  {
    id: '7208021007',
    districtId: '7208021',
    name: 'Boyantongo',
  },
  {
    id: '7208021008',
    districtId: '7208021',
    name: 'Olobaru',
  },
  {
    id: '7208021009',
    districtId: '7208021',
    name: 'Gangga',
  },
  {
    id: '7208021010',
    districtId: '7208021',
    name: 'Dolago Padang',
  },
  {
    id: '7208022001',
    districtId: '7208022',
    name: 'Kayuboko',
  },
  {
    id: '7208022002',
    districtId: '7208022',
    name: 'Parigimpuu',
  },
  {
    id: '7208022003',
    districtId: '7208022',
    name: 'Baliara',
  },
  {
    id: '7208022004',
    districtId: '7208022',
    name: 'Air Panas',
  },
  {
    id: '7208022005',
    districtId: '7208022',
    name: 'Jonokalora',
  },
  {
    id: '7208022006',
    districtId: '7208022',
    name: 'Lobu Mandiri',
  },
  {
    id: '7208023004',
    districtId: '7208023',
    name: 'Pangi',
  },
  {
    id: '7208023005',
    districtId: '7208023',
    name: 'Toboli',
  },
  {
    id: '7208023007',
    districtId: '7208023',
    name: 'Avolua',
  },
  {
    id: '7208023009',
    districtId: '7208023',
    name: 'Toboli Barat',
  },
  {
    id: '7208023010',
    districtId: '7208023',
    name: 'Sakinah Jaya',
  },
  {
    id: '7208024001',
    districtId: '7208024',
    name: 'Petapa',
  },
  {
    id: '7208024002',
    districtId: '7208024',
    name: 'Binangga',
  },
  {
    id: '7208024003',
    districtId: '7208024',
    name: 'Pelawa',
  },
  {
    id: '7208024004',
    districtId: '7208024',
    name: 'Matolele',
  },
  {
    id: '7208024005',
    districtId: '7208024',
    name: 'Pelawa Baru',
  },
  {
    id: '7208024006',
    districtId: '7208024',
    name: 'Jononunu',
  },
  {
    id: '7208030005',
    districtId: '7208030',
    name: 'Tolole',
  },
  {
    id: '7208030006',
    districtId: '7208030',
    name: 'Toga',
  },
  {
    id: '7208030007',
    districtId: '7208030',
    name: 'Sidole',
  },
  {
    id: '7208030008',
    districtId: '7208030',
    name: 'Paranggi',
  },
  {
    id: '7208030009',
    districtId: '7208030',
    name: 'Ampibabo',
  },
  {
    id: '7208030010',
    districtId: '7208030',
    name: 'Lemo',
  },
  {
    id: '7208030011',
    districtId: '7208030',
    name: 'Buranga',
  },
  {
    id: '7208030012',
    districtId: '7208030',
    name: 'Tanampedagi',
  },
  {
    id: '7208030013',
    districtId: '7208030',
    name: 'Tombi',
  },
  {
    id: '7208030015',
    districtId: '7208030',
    name: 'Ampibabo Utara',
  },
  {
    id: '7208030016',
    districtId: '7208030',
    name: 'Ogolugus',
  },
  {
    id: '7208030017',
    districtId: '7208030',
    name: 'Lemo Utara',
  },
  {
    id: '7208030018',
    districtId: '7208030',
    name: 'Sidole Barat',
  },
  {
    id: '7208030019',
    districtId: '7208030',
    name: 'Aloo',
  },
  {
    id: '7208030020',
    districtId: '7208030',
    name: 'Ampibabo Timur',
  },
  {
    id: '7208030021',
    districtId: '7208030',
    name: 'Tolole Raya',
  },
  {
    id: '7208030022',
    districtId: '7208030',
    name: 'Sidole Timur',
  },
  {
    id: '7208030023',
    districtId: '7208030',
    name: 'Lemo Tengah',
  },
  {
    id: '7208030024',
    districtId: '7208030',
    name: 'Pangku',
  },
  {
    id: '7208031001',
    districtId: '7208031',
    name: 'Donggulu',
  },
  {
    id: '7208031002',
    districtId: '7208031',
    name: 'Laemanta',
  },
  {
    id: '7208031003',
    districtId: '7208031',
    name: 'Kasimbar',
  },
  {
    id: '7208031004',
    districtId: '7208031',
    name: 'Posona',
  },
  {
    id: '7208031005',
    districtId: '7208031',
    name: 'Kasimbar Selatan',
  },
  {
    id: '7208031006',
    districtId: '7208031',
    name: 'Kasimbar Barat',
  },
  {
    id: '7208031007',
    districtId: '7208031',
    name: 'Silampayang',
  },
  {
    id: '7208031008',
    districtId: '7208031',
    name: 'Tovalo',
  },
  {
    id: '7208031009',
    districtId: '7208031',
    name: 'Donggulu Selatan',
  },
  {
    id: '7208031010',
    districtId: '7208031',
    name: 'Labuhan Donggulu',
  },
  {
    id: '7208031011',
    districtId: '7208031',
    name: 'Kasimbar Palapi',
  },
  {
    id: '7208031012',
    districtId: '7208031',
    name: 'Peningka',
  },
  {
    id: '7208031013',
    districtId: '7208031',
    name: 'Laemanta Utara',
  },
  {
    id: '7208031014',
    districtId: '7208031',
    name: 'Kasimbar Utara',
  },
  {
    id: '7208031015',
    districtId: '7208031',
    name: 'Posona Atas',
  },
  {
    id: '7208031016',
    districtId: '7208031',
    name: 'Ogodopi Kasimbar',
  },
  {
    id: '7208031017',
    districtId: '7208031',
    name: 'Sendana',
  },
  {
    id: '7208031018',
    districtId: '7208031',
    name: 'Sumber Tani',
  },
  {
    id: '7208032001',
    districtId: '7208032',
    name: 'Tomoli',
  },
  {
    id: '7208032002',
    districtId: '7208032',
    name: 'Singura',
  },
  {
    id: '7208032003',
    districtId: '7208032',
    name: 'Toribulu',
  },
  {
    id: '7208032004',
    districtId: '7208032',
    name: 'Sienjo',
  },
  {
    id: '7208032005',
    districtId: '7208032',
    name: 'Pinotu',
  },
  {
    id: '7208032006',
    districtId: '7208032',
    name: 'Tomoli Selatan',
  },
  {
    id: '7208032007',
    districtId: '7208032',
    name: 'Sibalago',
  },
  {
    id: '7208032008',
    districtId: '7208032',
    name: 'Tomoli Utara',
  },
  {
    id: '7208032009',
    districtId: '7208032',
    name: 'Toribulu Selatan',
  },
  {
    id: '7208033001',
    districtId: '7208033',
    name: 'Marantale',
  },
  {
    id: '7208033002',
    districtId: '7208033',
    name: 'Tandaigi',
  },
  {
    id: '7208033003',
    districtId: '7208033',
    name: 'Silanga',
  },
  {
    id: '7208033004',
    districtId: '7208033',
    name: 'Siniu',
  },
  {
    id: '7208033005',
    districtId: '7208033',
    name: 'Towera',
  },
  {
    id: '7208033006',
    districtId: '7208033',
    name: 'Toraranga',
  },
  {
    id: '7208033007',
    districtId: '7208033',
    name: 'Uevolo',
  },
  {
    id: '7208033008',
    districtId: '7208033',
    name: 'Siniu Sayogindano',
  },
  {
    id: '7208033009',
    districtId: '7208033',
    name: 'Silanga Barat',
  },
  {
    id: '7208040008',
    districtId: '7208040',
    name: 'Bainaa',
  },
  {
    id: '7208040009',
    districtId: '7208040',
    name: 'Dongkas',
  },
  {
    id: '7208040010',
    districtId: '7208040',
    name: 'Tinombo',
  },
  {
    id: '7208040011',
    districtId: '7208040',
    name: 'Lombok',
  },
  {
    id: '7208040012',
    districtId: '7208040',
    name: 'Dusunan',
  },
  {
    id: '7208040013',
    districtId: '7208040',
    name: 'Tibu',
  },
  {
    id: '7208040017',
    districtId: '7208040',
    name: 'Bainaa Barat',
  },
  {
    id: '7208040019',
    districtId: '7208040',
    name: 'Ogoalas',
  },
  {
    id: '7208040020',
    districtId: '7208040',
    name: 'Lombok Barat',
  },
  {
    id: '7208040025',
    districtId: '7208040',
    name: 'Silabia',
  },
  {
    id: '7208040026',
    districtId: '7208040',
    name: 'Siavu',
  },
  {
    id: '7208040027',
    districtId: '7208040',
    name: 'Ambason Mekar',
  },
  {
    id: '7208040028',
    districtId: '7208040',
    name: 'Patingke',
  },
  {
    id: '7208040029',
    districtId: '7208040',
    name: 'Dusunan Barat',
  },
  {
    id: '7208040030',
    districtId: '7208040',
    name: 'Taipaobal',
  },
  {
    id: '7208041001',
    districtId: '7208041',
    name: 'Tada',
  },
  {
    id: '7208041002',
    districtId: '7208041',
    name: 'Sinei',
  },
  {
    id: '7208041003',
    districtId: '7208041',
    name: 'Maninili',
  },
  {
    id: '7208041004',
    districtId: '7208041',
    name: 'Sigenti',
  },
  {
    id: '7208041005',
    districtId: '7208041',
    name: 'Malanggo',
  },
  {
    id: '7208041006',
    districtId: '7208041',
    name: 'Silutung',
  },
  {
    id: '7208041007',
    districtId: '7208041',
    name: 'Tada Selatan',
  },
  {
    id: '7208041008',
    districtId: '7208041',
    name: 'Siaga',
  },
  {
    id: '7208041009',
    districtId: '7208041',
    name: 'Sigega Bersehati',
  },
  {
    id: '7208041010',
    districtId: '7208041',
    name: 'Khatulistiwa',
  },
  {
    id: '7208041011',
    districtId: '7208041',
    name: 'Poly',
  },
  {
    id: '7208041012',
    districtId: '7208041',
    name: 'Sigenti Selatan',
  },
  {
    id: '7208041013',
    districtId: '7208041',
    name: 'Tada Timur',
  },
  {
    id: '7208041014',
    districtId: '7208041',
    name: 'Sigenti Barat',
  },
  {
    id: '7208041015',
    districtId: '7208041',
    name: 'Malanggo Pesisir',
  },
  {
    id: '7208041016',
    districtId: '7208041',
    name: 'Tada Utara',
  },
  {
    id: '7208041017',
    districtId: '7208041',
    name: 'Siney Tengah',
  },
  {
    id: '7208041018',
    districtId: '7208041',
    name: 'Maninili Utara',
  },
  {
    id: '7208041019',
    districtId: '7208041',
    name: 'Maninili Barat',
  },
  {
    id: '7208041020',
    districtId: '7208041',
    name: 'Oncone Raya',
  },
  {
    id: '7208042001',
    districtId: '7208042',
    name: 'Lado',
  },
  {
    id: '7208042002',
    districtId: '7208042',
    name: 'Sipayo',
  },
  {
    id: '7208042003',
    districtId: '7208042',
    name: 'Bondoyong',
  },
  {
    id: '7208042004',
    districtId: '7208042',
    name: 'Sidoan Selatan',
  },
  {
    id: '7208042005',
    districtId: '7208042',
    name: 'Sidoan Timur',
  },
  {
    id: '7208042006',
    districtId: '7208042',
    name: 'Sidoan',
  },
  {
    id: '7208042007',
    districtId: '7208042',
    name: 'Sidoan Barat',
  },
  {
    id: '7208042008',
    districtId: '7208042',
    name: 'Ogobagis',
  },
  {
    id: '7208042009',
    districtId: '7208042',
    name: 'Muara Jaya',
  },
  {
    id: '7208042010',
    districtId: '7208042',
    name: 'Bainaa Selatan',
  },
  {
    id: '7208042011',
    districtId: '7208042',
    name: 'Sintuvu Raya',
  },
  {
    id: '7208050007',
    districtId: '7208050',
    name: 'Tingkulang',
  },
  {
    id: '7208050008',
    districtId: '7208050',
    name: 'Tomini',
  },
  {
    id: '7208050009',
    districtId: '7208050',
    name: 'Ogotumubu',
  },
  {
    id: '7208050010',
    districtId: '7208050',
    name: 'Ambesia',
  },
  {
    id: '7208050011',
    districtId: '7208050',
    name: 'Tilung',
  },
  {
    id: '7208050013',
    districtId: '7208050',
    name: 'Biga',
  },
  {
    id: '7208050014',
    districtId: '7208050',
    name: 'Tomini Utara',
  },
  {
    id: '7208050015',
    districtId: '7208050',
    name: 'Tomini Barat',
  },
  {
    id: '7208050016',
    districtId: '7208050',
    name: 'Ambesia Selatan',
  },
  {
    id: '7208050017',
    districtId: '7208050',
    name: 'Supilopong',
  },
  {
    id: '7208050018',
    districtId: '7208050',
    name: 'Ambesia Barat',
  },
  {
    id: '7208050019',
    districtId: '7208050',
    name: 'Ogotumubu Barat',
  },
  {
    id: '7208050020',
    districtId: '7208050',
    name: 'Sipontan',
  },
  {
    id: '7208050021',
    districtId: '7208050',
    name: 'Taaniuge',
  },
  {
    id: '7208051001',
    districtId: '7208051',
    name: 'Mepanga',
  },
  {
    id: '7208051003',
    districtId: '7208051',
    name: 'Kotaraya',
  },
  {
    id: '7208051004',
    districtId: '7208051',
    name: 'Kayu Agung',
  },
  {
    id: '7208051005',
    districtId: '7208051',
    name: 'Bugis',
  },
  {
    id: '7208051006',
    districtId: '7208051',
    name: 'Ogotion',
  },
  {
    id: '7208051007',
    districtId: '7208051',
    name: 'Sumber Agung',
  },
  {
    id: '7208051008',
    districtId: '7208051',
    name: 'Moubang',
  },
  {
    id: '7208051009',
    districtId: '7208051',
    name: 'Ogobayas',
  },
  {
    id: '7208051010',
    districtId: '7208051',
    name: 'Kotaraya Timur',
  },
  {
    id: '7208051011',
    districtId: '7208051',
    name: 'Malalan',
  },
  {
    id: '7208051012',
    districtId: '7208051',
    name: 'Kotaraya Selatan',
  },
  {
    id: '7208051013',
    districtId: '7208051',
    name: 'Maranti',
  },
  {
    id: '7208051014',
    districtId: '7208051',
    name: 'Kotaraya Barat',
  },
  {
    id: '7208051015',
    districtId: '7208051',
    name: 'Ogomolos',
  },
  {
    id: '7208051016',
    districtId: '7208051',
    name: 'Bugis Utara',
  },
  {
    id: '7208051017',
    districtId: '7208051',
    name: 'Gurinda',
  },
  {
    id: '7208051018',
    districtId: '7208051',
    name: 'Kotaraya Tenggara',
  },
  {
    id: '7208052001',
    districtId: '7208052',
    name: 'Bobalo',
  },
  {
    id: '7208052002',
    districtId: '7208052',
    name: 'Eeya',
  },
  {
    id: '7208052003',
    districtId: '7208052',
    name: 'Ulatan',
  },
  {
    id: '7208052004',
    districtId: '7208052',
    name: 'Palasa Tangki',
  },
  {
    id: '7208052005',
    districtId: '7208052',
    name: 'Palasa',
  },
  {
    id: '7208052006',
    districtId: '7208052',
    name: 'Palasa Lambori',
  },
  {
    id: '7208052007',
    districtId: '7208052',
    name: 'Dongkalan',
  },
  {
    id: '7208052008',
    districtId: '7208052',
    name: 'Pebo Unang',
  },
  {
    id: '7208052009',
    districtId: '7208052',
    name: 'Bambasiang',
  },
  {
    id: '7208052010',
    districtId: '7208052',
    name: 'Beau',
  },
  {
    id: '7208052011',
    districtId: '7208052',
    name: 'Ogoansam',
  },
  {
    id: '7208060001',
    districtId: '7208060',
    name: 'Moutong Timur',
  },
  {
    id: '7208060002',
    districtId: '7208060',
    name: 'Moutong Tengah',
  },
  {
    id: '7208060003',
    districtId: '7208060',
    name: 'Moutong Barat',
  },
  {
    id: '7208060004',
    districtId: '7208060',
    name: 'Tuladenggi Pantai',
  },
  {
    id: '7208060006',
    districtId: '7208060',
    name: 'Gio',
  },
  {
    id: '7208060023',
    districtId: '7208060',
    name: 'Lobu',
  },
  {
    id: '7208060024',
    districtId: '7208060',
    name: 'Pandelalap',
  },
  {
    id: '7208060025',
    districtId: '7208060',
    name: 'Sejoli',
  },
  {
    id: '7208060026',
    districtId: '7208060',
    name: 'Boloung Olonggata',
  },
  {
    id: '7208060027',
    districtId: '7208060',
    name: 'Salumpengut',
  },
  {
    id: '7208060028',
    districtId: '7208060',
    name: 'Aedan Raya',
  },
  {
    id: '7208060029',
    districtId: '7208060',
    name: 'Labuan',
  },
  {
    id: '7208060030',
    districtId: '7208060',
    name: 'Salepae',
  },
  {
    id: '7208060031',
    districtId: '7208060',
    name: 'Moutong Utara',
  },
  {
    id: '7208060032',
    districtId: '7208060',
    name: 'Pande',
  },
  {
    id: '7208060033',
    districtId: '7208060',
    name: 'Olonggata',
  },
  {
    id: '7208060034',
    districtId: '7208060',
    name: 'Mbelang-Mbelang',
  },
  {
    id: '7208060035',
    districtId: '7208060',
    name: 'Gio Timur',
  },
  {
    id: '7208060036',
    districtId: '7208060',
    name: 'Gio Barat',
  },
  {
    id: '7208060037',
    districtId: '7208060',
    name: 'Sialopa',
  },
  {
    id: '7208061001',
    districtId: '7208061',
    name: 'Wanagading',
  },
  {
    id: '7208061002',
    districtId: '7208061',
    name: 'Lambunu',
  },
  {
    id: '7208061003',
    districtId: '7208061',
    name: 'Kotanagaya',
  },
  {
    id: '7208061004',
    districtId: '7208061',
    name: 'Margapura',
  },
  {
    id: '7208061005',
    districtId: '7208061',
    name: 'Petuna Sugi',
  },
  {
    id: '7208061016',
    districtId: '7208061',
    name: 'Gunungsari',
  },
  {
    id: '7208061017',
    districtId: '7208061',
    name: 'Siendeng',
  },
  {
    id: '7208061018',
    districtId: '7208061',
    name: 'Lambunu Utara',
  },
  {
    id: '7208061031',
    districtId: '7208061',
    name: 'Tirtanagaya',
  },
  {
    id: '7208061033',
    districtId: '7208061',
    name: 'Anutapura',
  },
  {
    id: '7208061035',
    districtId: '7208061',
    name: 'Lambunu Timur',
  },
  {
    id: '7208061036',
    districtId: '7208061',
    name: 'Bukit Makmur',
  },
  {
    id: '7208061037',
    districtId: '7208061',
    name: 'Ganongol Sari',
  },
  {
    id: '7208061038',
    districtId: '7208061',
    name: 'Ogorandu',
  },
  {
    id: '7208062001',
    districtId: '7208062',
    name: 'Tuladenggi Sibatang',
  },
  {
    id: '7208062002',
    districtId: '7208062',
    name: 'Taopa',
  },
  {
    id: '7208062003',
    districtId: '7208062',
    name: 'Palapi',
  },
  {
    id: '7208062004',
    districtId: '7208062',
    name: 'Nunurantai',
  },
  {
    id: '7208062005',
    districtId: '7208062',
    name: 'Karya Agung',
  },
  {
    id: '7208062006',
    districtId: '7208062',
    name: 'Tompo',
  },
  {
    id: '7208062007',
    districtId: '7208062',
    name: 'Taopa Utara',
  },
  {
    id: '7208062008',
    districtId: '7208062',
    name: 'Taopa Barat',
  },
  {
    id: '7208062009',
    districtId: '7208062',
    name: 'Paria',
  },
  {
    id: '7208062010',
    districtId: '7208062',
    name: 'Bilalea',
  },
  {
    id: '7208062011',
    districtId: '7208062',
    name: 'Karya Abadi',
  },
  {
    id: '7208063001',
    districtId: '7208063',
    name: 'Wanamukti',
  },
  {
    id: '7208063002',
    districtId: '7208063',
    name: 'Sritabaang',
  },
  {
    id: '7208063003',
    districtId: '7208063',
    name: 'Beringin Jaya',
  },
  {
    id: '7208063004',
    districtId: '7208063',
    name: 'Bajo',
  },
  {
    id: '7208063005',
    districtId: '7208063',
    name: 'Bolano',
  },
  {
    id: '7208063006',
    districtId: '7208063',
    name: 'Lembah Bomban',
  },
  {
    id: '7208063007',
    districtId: '7208063',
    name: 'Bolano Barat',
  },
  {
    id: '7208063008',
    districtId: '7208063',
    name: 'Wanamukti Utara',
  },
  {
    id: '7208063009',
    districtId: '7208063',
    name: 'Bolano Tengah',
  },
  {
    id: '7208063010',
    districtId: '7208063',
    name: 'Bolano Utara',
  },
  {
    id: '7208063011',
    districtId: '7208063',
    name: 'Sidomukti',
  },
  {
    id: '7208063012',
    districtId: '7208063',
    name: 'Wanamukti Barat',
  },
  {
    id: '7208063013',
    districtId: '7208063',
    name: 'Sama Bahari',
  },
  {
    id: '7208064001',
    districtId: '7208064',
    name: 'Ongka',
  },
  {
    id: '7208064002',
    districtId: '7208064',
    name: 'Malino',
  },
  {
    id: '7208064003',
    districtId: '7208064',
    name: 'Tinombala',
  },
  {
    id: '7208064004',
    districtId: '7208064',
    name: 'Persatuan Sejati',
  },
  {
    id: '7208064005',
    districtId: '7208064',
    name: 'Santigi',
  },
  {
    id: '7208064006',
    districtId: '7208064',
    name: 'Tabolobolo',
  },
  {
    id: '7208064007',
    districtId: '7208064',
    name: 'Karya Mandiri',
  },
  {
    id: '7208064008',
    districtId: '7208064',
    name: 'Kayu Jati',
  },
  {
    id: '7208064009',
    districtId: '7208064',
    name: 'Bosagon Jaya',
  },
  {
    id: '7208064010',
    districtId: '7208064',
    name: 'Lambanau',
  },
  {
    id: '7208064011',
    districtId: '7208064',
    name: 'Tinombala Jaya',
  },
  {
    id: '7208064012',
    districtId: '7208064',
    name: 'Persatuan Utara',
  },
  {
    id: '7208064013',
    districtId: '7208064',
    name: 'Ongka Trimuspasari',
  },
  {
    id: '7208064014',
    districtId: '7208064',
    name: 'Tinombala Sejati',
  },
  {
    id: '7208064015',
    districtId: '7208064',
    name: 'Tinombala Barat',
  },
  {
    id: '7208064016',
    districtId: '7208064',
    name: 'Padaelo',
  },
  {
    id: '7208064017',
    districtId: '7208064',
    name: 'Ongka Persatuan',
  },
  {
    id: '7209010001',
    districtId: '7209010',
    name: 'Malei Tojo',
  },
  {
    id: '7209010002',
    districtId: '7209010',
    name: 'Matako',
  },
  {
    id: '7209010003',
    districtId: '7209010',
    name: 'Bambalo',
  },
  {
    id: '7209010004',
    districtId: '7209010',
    name: 'Galuga',
  },
  {
    id: '7209010005',
    districtId: '7209010',
    name: 'Toliba',
  },
  {
    id: '7209010006',
    districtId: '7209010',
    name: 'Ujung Tibu',
  },
  {
    id: '7209010007',
    districtId: '7209010',
    name: 'Nggawia',
  },
  {
    id: '7209010008',
    districtId: '7209010',
    name: 'Tombiano',
  },
  {
    id: '7209010009',
    districtId: '7209010',
    name: 'Tatari',
  },
  {
    id: '7209010010',
    districtId: '7209010',
    name: 'Kabalo',
  },
  {
    id: '7209010011',
    districtId: '7209010',
    name: 'Tanamawau',
  },
  {
    id: '7209010012',
    districtId: '7209010',
    name: 'Malewa',
  },
  {
    id: '7209010013',
    districtId: '7209010',
    name: 'Mawomba',
  },
  {
    id: '7209020014',
    districtId: '7209020',
    name: 'Lemoro',
  },
  {
    id: '7209020015',
    districtId: '7209020',
    name: 'Tayawa',
  },
  {
    id: '7209020016',
    districtId: '7209020',
    name: 'Korondoda',
  },
  {
    id: '7209020017',
    districtId: '7209020',
    name: 'Dataran Bugi',
  },
  {
    id: '7209020018',
    districtId: '7209020',
    name: 'Uekuli',
  },
  {
    id: '7209020019',
    districtId: '7209020',
    name: 'Betaua',
  },
  {
    id: '7209020021',
    districtId: '7209020',
    name: 'Sandada',
  },
  {
    id: '7209020022',
    districtId: '7209020',
    name: 'Tojo',
  },
  {
    id: '7209020023',
    districtId: '7209020',
    name: 'Pancuma',
  },
  {
    id: '7209020024',
    districtId: '7209020',
    name: 'Tongku',
  },
  {
    id: '7209020025',
    districtId: '7209020',
    name: 'Podi',
  },
  {
    id: '7209020027',
    districtId: '7209020',
    name: 'Bahari',
  },
  {
    id: '7209020028',
    districtId: '7209020',
    name: 'Banano',
  },
  {
    id: '7209020030',
    districtId: '7209020',
    name: 'Buyuntaripa',
  },
  {
    id: '7209020031',
    districtId: '7209020',
    name: 'Kalemba',
  },
  {
    id: '7209030001',
    districtId: '7209030',
    name: 'Mire',
  },
  {
    id: '7209030002',
    districtId: '7209030',
    name: 'Uematopa',
  },
  {
    id: '7209030003',
    districtId: '7209030',
    name: 'Paranonge',
  },
  {
    id: '7209030004',
    districtId: '7209030',
    name: 'Takibangke',
  },
  {
    id: '7209030005',
    districtId: '7209030',
    name: 'Bonebae I',
  },
  {
    id: '7209030006',
    districtId: '7209030',
    name: 'Watusongu',
  },
  {
    id: '7209030007',
    districtId: '7209030',
    name: 'Uekambuno',
  },
  {
    id: '7209030008',
    districtId: '7209030',
    name: 'Borneang',
  },
  {
    id: '7209030009',
    districtId: '7209030',
    name: 'Bongka Makmur',
  },
  {
    id: '7209030010',
    districtId: '7209030',
    name: 'Rompi',
  },
  {
    id: '7209030011',
    districtId: '7209030',
    name: 'Tobamawu',
  },
  {
    id: '7209030012',
    districtId: '7209030',
    name: 'Bonebae II',
  },
  {
    id: '7209030013',
    districtId: '7209030',
    name: 'Tampanombo',
  },
  {
    id: '7209030014',
    districtId: '7209030',
    name: 'Marowo',
  },
  {
    id: '7209030015',
    districtId: '7209030',
    name: 'Bongkakoi',
  },
  {
    id: '7209030016',
    districtId: '7209030',
    name: 'Cempa',
  },
  {
    id: '7209030017',
    districtId: '7209030',
    name: 'Bonevoto',
  },
  {
    id: '7209030018',
    districtId: '7209030',
    name: 'Kasiala',
  },
  {
    id: '7209040001',
    districtId: '7209040',
    name: 'Pusungi',
  },
  {
    id: '7209040003',
    districtId: '7209040',
    name: 'Tete-A',
  },
  {
    id: '7209040004',
    districtId: '7209040',
    name: 'Uebone',
  },
  {
    id: '7209040005',
    districtId: '7209040',
    name: 'Mantangisi',
  },
  {
    id: '7209040006',
    districtId: '7209040',
    name: 'Bantuga',
  },
  {
    id: '7209040007',
    districtId: '7209040',
    name: 'Urundaka',
  },
  {
    id: '7209040008',
    districtId: '7209040',
    name: 'Borone',
  },
  {
    id: '7209040009',
    districtId: '7209040',
    name: 'Balanggala',
  },
  {
    id: '7209040010',
    districtId: '7209040',
    name: 'Tampabatu',
  },
  {
    id: '7209040011',
    districtId: '7209040',
    name: 'Sabo',
  },
  {
    id: '7209040012',
    districtId: '7209040',
    name: 'Longge',
  },
  {
    id: '7209040013',
    districtId: '7209040',
    name: 'Balingara',
  },
  {
    id: '7209040014',
    districtId: '7209040',
    name: 'Bulan Jaya',
  },
  {
    id: '7209040015',
    districtId: '7209040',
    name: 'Giri Mulyo',
  },
  {
    id: '7209040016',
    districtId: '7209040',
    name: 'Wana Sari',
  },
  {
    id: '7209040017',
    districtId: '7209040',
    name: 'Kajulangko',
  },
  {
    id: '7209040018',
    districtId: '7209040',
    name: 'Uemakuni',
  },
  {
    id: '7209040019',
    districtId: '7209040',
    name: 'Mpoa',
  },
  {
    id: '7209040020',
    districtId: '7209040',
    name: 'Sukamaju',
  },
  {
    id: '7209040021',
    districtId: '7209040',
    name: 'UPT Balingara',
  },
  {
    id: '7209050001',
    districtId: '7209050',
    name: 'Sansarino',
  },
  {
    id: '7209050002',
    districtId: '7209050',
    name: 'Malotong',
  },
  {
    id: '7209050003',
    districtId: '7209050',
    name: 'Bailo',
  },
  {
    id: '7209050004',
    districtId: '7209050',
    name: 'Ampana',
  },
  {
    id: '7209050010',
    districtId: '7209050',
    name: 'Padang Tumbuo',
  },
  {
    id: '7209050012',
    districtId: '7209050',
    name: 'Buntongi',
  },
  {
    id: '7209050013',
    districtId: '7209050',
    name: 'Bonerato',
  },
  {
    id: '7209050014',
    districtId: '7209050',
    name: 'Bailo Baru',
  },
  {
    id: '7209050015',
    districtId: '7209050',
    name: 'Labiabae',
  },
  {
    id: '7209050017',
    districtId: '7209050',
    name: 'Saluaba',
  },
  {
    id: '7209051005',
    districtId: '7209051',
    name: 'Uentanaga Atas',
  },
  {
    id: '7209051006',
    districtId: '7209051',
    name: 'Sumoli',
  },
  {
    id: '7209051007',
    districtId: '7209051',
    name: 'Uentanaga Bawah',
  },
  {
    id: '7209051008',
    districtId: '7209051',
    name: 'Dondo',
  },
  {
    id: '7209051009',
    districtId: '7209051',
    name: 'Labuan',
  },
  {
    id: '7209051011',
    districtId: '7209051',
    name: 'Sabulira Toba',
  },
  {
    id: '7209051016',
    districtId: '7209051',
    name: 'Uemalingku',
  },
  {
    id: '7209051018',
    districtId: '7209051',
    name: 'Patingko',
  },
  {
    id: '7209051019',
    districtId: '7209051',
    name: 'Muara Toba',
  },
  {
    id: '7209051020',
    districtId: '7209051',
    name: 'Dondo Barat',
  },
  {
    id: '7209060005',
    districtId: '7209060',
    name: 'Taningkola',
  },
  {
    id: '7209060006',
    districtId: '7209060',
    name: 'Bambu',
  },
  {
    id: '7209060007',
    districtId: '7209060',
    name: 'Una Una',
  },
  {
    id: '7209060008',
    districtId: '7209060',
    name: 'Lembanya',
  },
  {
    id: '7209060009',
    districtId: '7209060',
    name: 'Wakai',
  },
  {
    id: '7209060010',
    districtId: '7209060',
    name: 'Tanjung Pude',
  },
  {
    id: '7209060015',
    districtId: '7209060',
    name: 'Kavetan',
  },
  {
    id: '7209060016',
    districtId: '7209060',
    name: 'Luangon',
  },
  {
    id: '7209060017',
    districtId: '7209060',
    name: 'Binanguna',
  },
  {
    id: '7209060018',
    districtId: '7209060',
    name: 'Cendana',
  },
  {
    id: '7209060019',
    districtId: '7209060',
    name: 'Tanimpo',
  },
  {
    id: '7209061001',
    districtId: '7209061',
    name: 'Kulingkinari',
  },
  {
    id: '7209061002',
    districtId: '7209061',
    name: 'Molowagu',
  },
  {
    id: '7209061003',
    districtId: '7209061',
    name: 'Bomba',
  },
  {
    id: '7209061004',
    districtId: '7209061',
    name: 'Tumbulawa',
  },
  {
    id: '7209061009',
    districtId: '7209061',
    name: 'Patoyan',
  },
  {
    id: '7209061011',
    districtId: '7209061',
    name: 'Malino',
  },
  {
    id: '7209061012',
    districtId: '7209061',
    name: 'Siatu',
  },
  {
    id: '7209061013',
    districtId: '7209061',
    name: 'Kambutu',
  },
  {
    id: '7209061014',
    districtId: '7209061',
    name: 'Lindo',
  },
  {
    id: '7209070001',
    districtId: '7209070',
    name: 'Kololio',
  },
  {
    id: '7209070002',
    districtId: '7209070',
    name: 'Awo',
  },
  {
    id: '7209070004',
    districtId: '7209070',
    name: 'Lebiti',
  },
  {
    id: '7209070005',
    districtId: '7209070',
    name: 'Pulau Enam',
  },
  {
    id: '7209070006',
    districtId: '7209070',
    name: 'Bungayo',
  },
  {
    id: '7209070008',
    districtId: '7209070',
    name: 'Bangkagi',
  },
  {
    id: '7209070009',
    districtId: '7209070',
    name: 'Tongkabo',
  },
  {
    id: '7209070010',
    districtId: '7209070',
    name: 'Katupat',
  },
  {
    id: '7209070011',
    districtId: '7209070',
    name: 'Lembanato',
  },
  {
    id: '7209070012',
    districtId: '7209070',
    name: 'Tobil',
  },
  {
    id: '7209070013',
    districtId: '7209070',
    name: 'Baulu',
  },
  {
    id: '7209070014',
    districtId: '7209070',
    name: 'Matobiyai',
  },
  {
    id: '7209070015',
    districtId: '7209070',
    name: 'Sampobae',
  },
  {
    id: '7209070016',
    districtId: '7209070',
    name: 'Titirií Popolion',
  },
  {
    id: '7209080006',
    districtId: '7209080',
    name: 'Tiga Pulau',
  },
  {
    id: '7209080007',
    districtId: '7209080',
    name: 'Luok',
  },
  {
    id: '7209080008',
    districtId: '7209080',
    name: 'Popolii',
  },
  {
    id: '7209080009',
    districtId: '7209080',
    name: 'Dolong B',
  },
  {
    id: '7209080011',
    districtId: '7209080',
    name: 'Dolong A',
  },
  {
    id: '7209080012',
    districtId: '7209080',
    name: 'Olilan',
  },
  {
    id: '7209080013',
    districtId: '7209080',
    name: 'Kolami',
  },
  {
    id: '7209080015',
    districtId: '7209080',
    name: 'Loe',
  },
  {
    id: '7209081001',
    districtId: '7209081',
    name: 'Salinggoha',
  },
  {
    id: '7209081002',
    districtId: '7209081',
    name: 'Malapo',
  },
  {
    id: '7209081003',
    districtId: '7209081',
    name: 'Pasokan',
  },
  {
    id: '7209081004',
    districtId: '7209081',
    name: 'Katogop',
  },
  {
    id: '7209081005',
    districtId: '7209081',
    name: 'Kondongan',
  },
  {
    id: '7209081006',
    districtId: '7209081',
    name: 'Biga',
  },
  {
    id: '7209081007',
    districtId: '7209081',
    name: 'Tingki',
  },
  {
    id: '7209081008',
    districtId: '7209081',
    name: 'Tongidon',
  },
  {
    id: '7209082001',
    districtId: '7209082',
    name: 'Kabalutan',
  },
  {
    id: '7209082002',
    districtId: '7209082',
    name: 'Pautu',
  },
  {
    id: '7209082003',
    districtId: '7209082',
    name: 'Kalia',
  },
  {
    id: '7209082004',
    districtId: '7209082',
    name: 'Tumotok',
  },
  {
    id: '7209082005',
    districtId: '7209082',
    name: 'Malenge',
  },
  {
    id: '7209082014',
    districtId: '7209082',
    name: 'Kadoda',
  },
  {
    id: '7210010001',
    districtId: '7210010',
    name: 'Kalamanta',
  },
  {
    id: '7210010002',
    districtId: '7210010',
    name: 'Mamu',
  },
  {
    id: '7210010003',
    districtId: '7210010',
    name: 'Banasu',
  },
  {
    id: '7210010004',
    districtId: '7210010',
    name: 'Mapahi',
  },
  {
    id: '7210010005',
    districtId: '7210010',
    name: 'Peana',
  },
  {
    id: '7210010006',
    districtId: '7210010',
    name: 'Morui',
  },
  {
    id: '7210010007',
    districtId: '7210010',
    name: 'Kantewu',
  },
  {
    id: '7210010008',
    districtId: '7210010',
    name: 'Lawe',
  },
  {
    id: '7210010009',
    districtId: '7210010',
    name: 'Lone Basa',
  },
  {
    id: '7210010010',
    districtId: '7210010',
    name: 'Onu',
  },
  {
    id: '7210010011',
    districtId: '7210010',
    name: 'Koja',
  },
  {
    id: '7210010012',
    districtId: '7210010',
    name: 'Kantewu II',
  },
  {
    id: '7210010013',
    districtId: '7210010',
    name: 'Porelea',
  },
  {
    id: '7210010014',
    districtId: '7210010',
    name: 'Masewo',
  },
  {
    id: '7210010015',
    districtId: '7210010',
    name: 'Tuwo Tanijaya',
  },
  {
    id: '7210010016',
    districtId: '7210010',
    name: 'Pelempea',
  },
  {
    id: '7210010017',
    districtId: '7210010',
    name: 'Puloroa',
  },
  {
    id: '7210010018',
    districtId: '7210010',
    name: 'Morui II',
  },
  {
    id: '7210010019',
    districtId: '7210010',
    name: 'Porelea II',
  },
  {
    id: '7210020001',
    districtId: '7210020',
    name: 'Moa',
  },
  {
    id: '7210020002',
    districtId: '7210020',
    name: 'Pili Makujawa',
  },
  {
    id: '7210020003',
    districtId: '7210020',
    name: 'Lempelero',
  },
  {
    id: '7210020004',
    districtId: '7210020',
    name: 'Gimpu',
  },
  {
    id: '7210020005',
    districtId: '7210020',
    name: 'Tomua',
  },
  {
    id: '7210020006',
    districtId: '7210020',
    name: 'Tompi Bugis',
  },
  {
    id: '7210020007',
    districtId: '7210020',
    name: 'Lawua',
  },
  {
    id: '7210020008',
    districtId: '7210020',
    name: 'Watukilo',
  },
  {
    id: '7210020009',
    districtId: '7210020',
    name: 'Salutome',
  },
  {
    id: '7210020010',
    districtId: '7210020',
    name: "O'O",
  },
  {
    id: '7210020011',
    districtId: '7210020',
    name: 'Palamaki',
  },
  {
    id: '7210020012',
    districtId: '7210020',
    name: 'Wangka',
  },
  {
    id: '7210030001',
    districtId: '7210030',
    name: 'Siwongi',
  },
  {
    id: '7210030002',
    districtId: '7210030',
    name: 'Banggaiba',
  },
  {
    id: '7210030003',
    districtId: '7210030',
    name: 'Rantewulu',
  },
  {
    id: '7210030004',
    districtId: '7210030',
    name: 'Towulu',
  },
  {
    id: '7210030005',
    districtId: '7210030',
    name: 'Winatu',
  },
  {
    id: '7210030006',
    districtId: '7210030',
    name: 'Lonca',
  },
  {
    id: '7210030007',
    districtId: '7210030',
    name: 'Boladangko',
  },
  {
    id: '7210030008',
    districtId: '7210030',
    name: 'Tangkulowi',
  },
  {
    id: '7210030009',
    districtId: '7210030',
    name: 'Salua',
  },
  {
    id: '7210030010',
    districtId: '7210030',
    name: 'Namo',
  },
  {
    id: '7210030011',
    districtId: '7210030',
    name: 'Bolapapu',
  },
  {
    id: '7210030013',
    districtId: '7210030',
    name: 'Mataue',
  },
  {
    id: '7210030014',
    districtId: '7210030',
    name: 'Toro',
  },
  {
    id: '7210030015',
    districtId: '7210030',
    name: 'Poleroa Makuhi',
  },
  {
    id: '7210030016',
    districtId: '7210030',
    name: 'Marena',
  },
  {
    id: '7210040001',
    districtId: '7210040',
    name: "Puro'O",
  },
  {
    id: '7210040002',
    districtId: '7210040',
    name: 'Langko',
  },
  {
    id: '7210040003',
    districtId: '7210040',
    name: 'Tomado',
  },
  {
    id: '7210040004',
    districtId: '7210040',
    name: 'Anca',
  },
  {
    id: '7210040005',
    districtId: '7210040',
    name: 'Olu',
  },
  {
    id: '7210050001',
    districtId: '7210050',
    name: 'Kamarora B',
  },
  {
    id: '7210050002',
    districtId: '7210050',
    name: 'Kamarora A',
  },
  {
    id: '7210050003',
    districtId: '7210050',
    name: 'Kadidia',
  },
  {
    id: '7210050004',
    districtId: '7210050',
    name: 'Sopu',
  },
  {
    id: '7210050005',
    districtId: '7210050',
    name: 'Bulili',
  },
  {
    id: '7210060001',
    districtId: '7210060',
    name: 'Lemban Tongoa',
  },
  {
    id: '7210060002',
    districtId: '7210060',
    name: 'Uenuni',
  },
  {
    id: '7210060003',
    districtId: '7210060',
    name: 'Tongoa',
  },
  {
    id: '7210060004',
    districtId: '7210060',
    name: 'Bahagia',
  },
  {
    id: '7210060005',
    districtId: '7210060',
    name: 'Rahmat',
  },
  {
    id: '7210060006',
    districtId: '7210060',
    name: 'Sejahtera',
  },
  {
    id: '7210060007',
    districtId: '7210060',
    name: 'Sintuwu',
  },
  {
    id: '7210060008',
    districtId: '7210060',
    name: 'Ranteleda',
  },
  {
    id: '7210060009',
    districtId: '7210060',
    name: 'Tanah Harapan',
  },
  {
    id: '7210060010',
    districtId: '7210060',
    name: 'Berdikari',
  },
  {
    id: '7210060011',
    districtId: '7210060',
    name: 'Rejeki',
  },
  {
    id: '7210060012',
    districtId: '7210060',
    name: 'Ampera',
  },
  {
    id: '7210060013',
    districtId: '7210060',
    name: 'Makmur',
  },
  {
    id: '7210060014',
    districtId: '7210060',
    name: 'Petimbe',
  },
  {
    id: '7210060015',
    districtId: '7210060',
    name: 'Kapiroe',
  },
  {
    id: '7210060016',
    districtId: '7210060',
    name: 'Bunga',
  },
  {
    id: '7210060017',
    districtId: '7210060',
    name: 'Bobo',
  },
  {
    id: '7210060018',
    districtId: '7210060',
    name: 'Baku-Bakulu',
  },
  {
    id: '7210060019',
    districtId: '7210060',
    name: 'Sigimpu',
  },
  {
    id: '7210060020',
    districtId: '7210060',
    name: 'Karunia',
  },
  {
    id: '7210060021',
    districtId: '7210060',
    name: 'Ue Rani',
  },
  {
    id: '7210060022',
    districtId: '7210060',
    name: 'Sarumana',
  },
  {
    id: '7210070001',
    districtId: '7210070',
    name: 'Tuwa',
  },
  {
    id: '7210070002',
    districtId: '7210070',
    name: 'Omu',
  },
  {
    id: '7210070003',
    districtId: '7210070',
    name: 'Simoro',
  },
  {
    id: '7210070004',
    districtId: '7210070',
    name: 'Pakuli',
  },
  {
    id: '7210070005',
    districtId: '7210070',
    name: 'Pandere',
  },
  {
    id: '7210070006',
    districtId: '7210070',
    name: 'Kalawara',
  },
  {
    id: '7210070007',
    districtId: '7210070',
    name: 'Pakuli Utara',
  },
  {
    id: '7210080001',
    districtId: '7210080',
    name: 'Bangga',
  },
  {
    id: '7210080002',
    districtId: '7210080',
    name: 'Walatana',
  },
  {
    id: '7210080004',
    districtId: '7210080',
    name: 'Baluase',
  },
  {
    id: '7210080005',
    districtId: '7210080',
    name: 'Rogo',
  },
  {
    id: '7210080007',
    districtId: '7210080',
    name: 'Balongga',
  },
  {
    id: '7210080008',
    districtId: '7210080',
    name: 'Wisolo',
  },
  {
    id: '7210080009',
    districtId: '7210080',
    name: 'Sambo',
  },
  {
    id: '7210080010',
    districtId: '7210080',
    name: 'Jono',
  },
  {
    id: '7210080011',
    districtId: '7210080',
    name: 'Poi',
  },
  {
    id: '7210080012',
    districtId: '7210080',
    name: 'Ramba',
  },
  {
    id: '7210090001',
    districtId: '7210090',
    name: 'Bobo',
  },
  {
    id: '7210090002',
    districtId: '7210090',
    name: 'Mantikole',
  },
  {
    id: '7210090003',
    districtId: '7210090',
    name: 'Pesaku',
  },
  {
    id: '7210090004',
    districtId: '7210090',
    name: 'Balomoa',
  },
  {
    id: '7210090005',
    districtId: '7210090',
    name: 'Rarampadende',
  },
  {
    id: '7210090006',
    districtId: '7210090',
    name: 'Balumpewa',
  },
  {
    id: '7210090007',
    districtId: '7210090',
    name: 'Kaleke',
  },
  {
    id: '7210090009',
    districtId: '7210090',
    name: 'Kalungkutinggu',
  },
  {
    id: '7210090010',
    districtId: '7210090',
    name: 'Sibonu',
  },
  {
    id: '7210090012',
    districtId: '7210090',
    name: 'Balaroa Pewunu',
  },
  {
    id: '7210100001',
    districtId: '7210100',
    name: 'Lambara',
  },
  {
    id: '7210100002',
    districtId: '7210100',
    name: 'Sibalaya Selatan',
  },
  {
    id: '7210100003',
    districtId: '7210100',
    name: 'Sibalaya Utara',
  },
  {
    id: '7210100004',
    districtId: '7210100',
    name: 'Sibowi',
  },
  {
    id: '7210100005',
    districtId: '7210100',
    name: 'Sibalaya Barat',
  },
  {
    id: '7210110001',
    districtId: '7210110',
    name: 'Waturalele',
  },
  {
    id: '7210110002',
    districtId: '7210110',
    name: 'Watubula',
  },
  {
    id: '7210110003',
    districtId: '7210110',
    name: 'Tulo',
  },
  {
    id: '7210110004',
    districtId: '7210110',
    name: 'Soulowe',
  },
  {
    id: '7210110005',
    districtId: '7210110',
    name: 'Karawana',
  },
  {
    id: '7210110006',
    districtId: '7210110',
    name: 'Kota Pulu',
  },
  {
    id: '7210110007',
    districtId: '7210110',
    name: 'Langaleso',
  },
  {
    id: '7210110008',
    districtId: '7210110',
    name: 'Kotarindau',
  },
  {
    id: '7210110009',
    districtId: '7210110',
    name: 'Maku',
  },
  {
    id: '7210110010',
    districtId: '7210110',
    name: 'Potoya',
  },
  {
    id: '7210110011',
    districtId: '7210110',
    name: 'Kabobona',
  },
  {
    id: '7210120001',
    districtId: '7210120',
    name: 'Sidondo II',
  },
  {
    id: '7210120002',
    districtId: '7210120',
    name: 'Sidondo I',
  },
  {
    id: '7210120003',
    districtId: '7210120',
    name: 'Maranata',
  },
  {
    id: '7210120004',
    districtId: '7210120',
    name: 'Bora',
  },
  {
    id: '7210120005',
    districtId: '7210120',
    name: 'Watunonju',
  },
  {
    id: '7210120006',
    districtId: '7210120',
    name: 'Oloboju',
  },
  {
    id: '7210120007',
    districtId: '7210120',
    name: 'Soulowe',
  },
  {
    id: '7210120008',
    districtId: '7210120',
    name: 'Sidera',
  },
  {
    id: '7210120009',
    districtId: '7210120',
    name: 'Jono Oge',
  },
  {
    id: '7210120010',
    districtId: '7210120',
    name: 'Pombewe',
  },
  {
    id: '7210120011',
    districtId: '7210120',
    name: 'Lolu',
  },
  {
    id: '7210120012',
    districtId: '7210120',
    name: 'Kalukubula',
  },
  {
    id: '7210120013',
    districtId: '7210120',
    name: 'Mpanau',
  },
  {
    id: '7210120014',
    districtId: '7210120',
    name: 'Loru',
  },
  {
    id: '7210120015',
    districtId: '7210120',
    name: 'Ngatabaru',
  },
  {
    id: '7210120016',
    districtId: '7210120',
    name: 'Sidondo III',
  },
  {
    id: '7210120017',
    districtId: '7210120',
    name: 'Sidondo IV',
  },
  {
    id: '7210120018',
    districtId: '7210120',
    name: 'UPT Lembah Palu',
  },
  {
    id: '7210130001',
    districtId: '7210130',
    name: 'Lebanu',
  },
  {
    id: '7210130002',
    districtId: '7210130',
    name: 'Bomba',
  },
  {
    id: '7210130003',
    districtId: '7210130',
    name: 'Beka',
  },
  {
    id: '7210130004',
    districtId: '7210130',
    name: 'Sibedi',
  },
  {
    id: '7210130005',
    districtId: '7210130',
    name: 'Padende',
  },
  {
    id: '7210130006',
    districtId: '7210130',
    name: 'Binangga',
  },
  {
    id: '7210130008',
    districtId: '7210130',
    name: 'Tinggede',
  },
  {
    id: '7210130009',
    districtId: '7210130',
    name: 'Baliase',
  },
  {
    id: '7210130010',
    districtId: '7210130',
    name: 'Boyabaliase',
  },
  {
    id: '7210130011',
    districtId: '7210130',
    name: 'Tinggede Selatan',
  },
  {
    id: '7210140001',
    districtId: '7210140',
    name: 'Panesibaja',
  },
  {
    id: '7210140002',
    districtId: '7210140',
    name: 'Wiapore',
  },
  {
    id: '7210140003',
    districtId: '7210140',
    name: 'Ongulero',
  },
  {
    id: '7210140004',
    districtId: '7210140',
    name: 'Soi',
  },
  {
    id: '7210140005',
    districtId: '7210140',
    name: 'Wawugaga',
  },
  {
    id: '7210140006',
    districtId: '7210140',
    name: 'Dombu',
  },
  {
    id: '7210140007',
    districtId: '7210140',
    name: 'Taipanggabe',
  },
  {
    id: '7210140008',
    districtId: '7210140',
    name: 'Wayu',
  },
  {
    id: '7210140009',
    districtId: '7210140',
    name: 'Matantimali',
  },
  {
    id: '7210140010',
    districtId: '7210140',
    name: 'Lewara',
  },
  {
    id: '7210140011',
    districtId: '7210140',
    name: 'Lemosiranindi',
  },
  {
    id: '7210140012',
    districtId: '7210140',
    name: 'Wawujai',
  },
  {
    id: '7210150001',
    districtId: '7210150',
    name: 'Rondingo',
  },
  {
    id: '7210150002',
    districtId: '7210150',
    name: 'Pobolobia',
  },
  {
    id: '7210150003',
    districtId: '7210150',
    name: 'Uwemanje',
  },
  {
    id: '7210150004',
    districtId: '7210150',
    name: 'Porame',
  },
  {
    id: '7210150005',
    districtId: '7210150',
    name: 'Balane',
  },
  {
    id: '7210150006',
    districtId: '7210150',
    name: 'Doda',
  },
  {
    id: '7210150007',
    districtId: '7210150',
    name: 'Daenggune',
  },
  {
    id: '7210150008',
    districtId: '7210150',
    name: 'Kanuna',
  },
  {
    id: '7210150009',
    districtId: '7210150',
    name: 'Kalora',
  },
  {
    id: '7210150010',
    districtId: '7210150',
    name: 'Kayumpia',
  },
  {
    id: '7211010001',
    districtId: '7211010',
    name: 'Togong Sagu',
  },
  {
    id: '7211010002',
    districtId: '7211010',
    name: 'Kanari',
  },
  {
    id: '7211010003',
    districtId: '7211010',
    name: 'Taduno',
  },
  {
    id: '7211010004',
    districtId: '7211010',
    name: 'Lantibung',
  },
  {
    id: '7211010005',
    districtId: '7211010',
    name: 'Lalong',
  },
  {
    id: '7211010006',
    districtId: '7211010',
    name: 'Kalupapi',
  },
  {
    id: '7211010007',
    districtId: '7211010',
    name: 'Bone-Bone',
  },
  {
    id: '7211010008',
    districtId: '7211010',
    name: 'Mbeleang',
  },
  {
    id: '7211010009',
    districtId: '7211010',
    name: 'Tabulang',
  },
  {
    id: '7211010010',
    districtId: '7211010',
    name: 'Bungin Luean',
  },
  {
    id: '7211010011',
    districtId: '7211010',
    name: 'Sasabobok',
  },
  {
    id: '7211010012',
    districtId: '7211010',
    name: 'Dungkean',
  },
  {
    id: '7211020001',
    districtId: '7211020',
    name: 'Bontosi',
  },
  {
    id: '7211020002',
    districtId: '7211020',
    name: 'Liputalas',
  },
  {
    id: '7211020003',
    districtId: '7211020',
    name: 'Lipulalongo',
  },
  {
    id: '7211020004',
    districtId: '7211020',
    name: 'Alasan',
  },
  {
    id: '7211020005',
    districtId: '7211020',
    name: 'Padingkian',
  },
  {
    id: '7211020006',
    districtId: '7211020',
    name: 'Paisulamo',
  },
  {
    id: '7211020007',
    districtId: '7211020',
    name: 'Lalong',
  },
  {
    id: '7211020008',
    districtId: '7211020',
    name: 'Mansalean',
  },
  {
    id: '7211030002',
    districtId: '7211030',
    name: 'Bone Baru',
  },
  {
    id: '7211030003',
    districtId: '7211030',
    name: 'Tolise Tubono',
  },
  {
    id: '7211030004',
    districtId: '7211030',
    name: 'Lokotoy',
  },
  {
    id: '7211030005',
    districtId: '7211030',
    name: 'Popisi',
  },
  {
    id: '7211030006',
    districtId: '7211030',
    name: 'Paisumosoni',
  },
  {
    id: '7211040001',
    districtId: '7211040',
    name: 'Tinakin Laut',
  },
  {
    id: '7211040002',
    districtId: '7211040',
    name: 'Lampa',
  },
  {
    id: '7211040003',
    districtId: '7211040',
    name: 'Lompio',
  },
  {
    id: '7211040004',
    districtId: '7211040',
    name: 'Tano Bonunungan',
  },
  {
    id: '7211040005',
    districtId: '7211040',
    name: 'Dodung',
  },
  {
    id: '7211040006',
    districtId: '7211040',
    name: 'Potil Pololoba',
  },
  {
    id: '7211040007',
    districtId: '7211040',
    name: 'Kokini',
  },
  {
    id: '7211040008',
    districtId: '7211040',
    name: 'Dangkalan',
  },
  {
    id: '7211040009',
    districtId: '7211040',
    name: 'Lambako',
  },
  {
    id: '7211040010',
    districtId: '7211040',
    name: 'Pasir Putih',
  },
  {
    id: '7211050001',
    districtId: '7211050',
    name: 'Monsongan',
  },
  {
    id: '7211050002',
    districtId: '7211050',
    name: 'Pososlalongo',
  },
  {
    id: '7211050003',
    districtId: '7211050',
    name: 'Badumpayan',
  },
  {
    id: '7211050004',
    districtId: '7211050',
    name: 'Tintingo',
  },
  {
    id: '7211050005',
    districtId: '7211050',
    name: 'Adean',
  },
  {
    id: '7211050006',
    districtId: '7211050',
    name: 'Mominit',
  },
  {
    id: '7211050007',
    districtId: '7211050',
    name: 'Timbong',
  },
  {
    id: '7211050008',
    districtId: '7211050',
    name: 'Gong-Gong',
  },
  {
    id: '7211060001',
    districtId: '7211060',
    name: 'Bentean',
  },
  {
    id: '7211060002',
    districtId: '7211060',
    name: 'Tolokibit',
  },
  {
    id: '7211060003',
    districtId: '7211060',
    name: 'Matanga',
  },
  {
    id: '7211060004',
    districtId: '7211060',
    name: 'Labuan Kapelak',
  },
  {
    id: '7211060005',
    districtId: '7211060',
    name: 'Malino',
  },
  {
    id: '7211060006',
    districtId: '7211060',
    name: 'Kelapa Lima',
  },
  {
    id: '7211070001',
    districtId: '7211070',
    name: 'Nggasuang',
  },
  {
    id: '7211070002',
    districtId: '7211070',
    name: 'Toropot',
  },
  {
    id: '7211070003',
    districtId: '7211070',
    name: 'Kokudang',
  },
  {
    id: '7211070004',
    districtId: '7211070',
    name: 'Minanga',
  },
  {
    id: '7211070005',
    districtId: '7211070',
    name: 'Paisubebe',
  },
  {
    id: '7211070006',
    districtId: '7211070',
    name: 'Kaukes',
  },
  {
    id: '7211070007',
    districtId: '7211070',
    name: 'Keak',
  },
  {
    id: '7211070008',
    districtId: '7211070',
    name: 'Bungin',
  },
  {
    id: '7211070009',
    districtId: '7211070',
    name: 'Ndindibung',
  },
  {
    id: '7211070010',
    districtId: '7211070',
    name: 'Bolokut',
  },
  {
    id: '7211070011',
    districtId: '7211070',
    name: 'Mandel',
  },
  {
    id: '7211070012',
    districtId: '7211070',
    name: 'Panapat',
  },
  {
    id: '7211070013',
    districtId: '7211070',
    name: 'Mbuang-Mbuang',
  },
  {
    id: '7211070014',
    districtId: '7211070',
    name: 'Timpaus',
  },
  {
    id: '7211070015',
    districtId: '7211070',
    name: 'Kasuari',
  },
  {
    id: '7211070016',
    districtId: '7211070',
    name: 'Sonit',
  },
  {
    id: '7212010001',
    districtId: '7212010',
    name: 'Kasingoli',
  },
  {
    id: '7212010003',
    districtId: '7212010',
    name: 'Saemba',
  },
  {
    id: '7212010004',
    districtId: '7212010',
    name: 'Saemba Walati',
  },
  {
    id: '7212010005',
    districtId: '7212010',
    name: 'Tomui Karya',
  },
  {
    id: '7212010006',
    districtId: '7212010',
    name: 'Tomata',
  },
  {
    id: '7212010007',
    districtId: '7212010',
    name: 'Pambarea',
  },
  {
    id: '7212010008',
    districtId: '7212010',
    name: 'Londi',
  },
  {
    id: '7212010009',
    districtId: '7212010',
    name: 'Gontara',
  },
  {
    id: '7212010010',
    districtId: '7212010',
    name: 'Taende',
  },
  {
    id: '7212010011',
    districtId: '7212010',
    name: 'Ensa',
  },
  {
    id: '7212010012',
    districtId: '7212010',
    name: 'Lanumor',
  },
  {
    id: '7212010013',
    districtId: '7212010',
    name: 'Peonea',
  },
  {
    id: '7212010014',
    districtId: '7212010',
    name: 'Kolaka',
  },
  {
    id: '7212020001',
    districtId: '7212020',
    name: 'Wawopada',
  },
  {
    id: '7212020002',
    districtId: '7212020',
    name: 'Lembobaru',
  },
  {
    id: '7212020003',
    districtId: '7212020',
    name: "Wara'A",
  },
  {
    id: '7212020004',
    districtId: '7212020',
    name: "Tingkea'O",
  },
  {
    id: '7212020005',
    districtId: '7212020',
    name: 'Korobonde',
  },
  {
    id: '7212020006',
    districtId: '7212020',
    name: 'Mora',
  },
  {
    id: '7212020007',
    districtId: '7212020',
    name: 'Uluanso',
  },
  {
    id: '7212020009',
    districtId: '7212020',
    name: 'Tinompo',
  },
  {
    id: '7212020010',
    districtId: '7212020',
    name: 'Koro Walelo',
  },
  {
    id: '7212020011',
    districtId: '7212020',
    name: 'Kumpi',
  },
  {
    id: '7212020012',
    districtId: '7212020',
    name: 'Korompeeli',
  },
  {
    id: '7212020013',
    districtId: '7212020',
    name: 'Lemboroma',
  },
  {
    id: '7212020014',
    districtId: '7212020',
    name: 'Korowou',
  },
  {
    id: '7212030001',
    districtId: '7212030',
    name: 'Dolupo Karya',
  },
  {
    id: '7212030002',
    districtId: '7212030',
    name: 'Mandula',
  },
  {
    id: '7212030003',
    districtId: '7212030',
    name: 'Lembobelala',
  },
  {
    id: '7212030004',
    districtId: '7212030',
    name: "Po'Ona",
  },
  {
    id: '7212030005',
    districtId: '7212030',
    name: 'Ronta',
  },
  {
    id: '7212030006',
    districtId: '7212030',
    name: 'Bintangor Mukti',
  },
  {
    id: '7212030007',
    districtId: '7212030',
    name: 'Petumbea',
  },
  {
    id: '7212030008',
    districtId: '7212030',
    name: "Pontango'A",
  },
  {
    id: '7212030009',
    districtId: '7212030',
    name: 'Jamor Jaya',
  },
  {
    id: '7212030010',
    districtId: '7212030',
    name: "Pa'Awaru",
  },
  {
    id: '7212040001',
    districtId: '7212040',
    name: 'Molores',
  },
  {
    id: '7212040002',
    districtId: '7212040',
    name: 'Keuno',
  },
  {
    id: '7212040003',
    districtId: '7212040',
    name: 'Mohoni',
  },
  {
    id: '7212040004',
    districtId: '7212040',
    name: 'Peboa',
  },
  {
    id: '7212040005',
    districtId: '7212040',
    name: 'Masara',
  },
  {
    id: '7212040006',
    districtId: '7212040',
    name: 'Molino',
  },
  {
    id: '7212040007',
    districtId: '7212040',
    name: 'Polewali',
  },
  {
    id: '7212040008',
    districtId: '7212040',
    name: 'Towara Pantai',
  },
  {
    id: '7212040009',
    districtId: '7212040',
    name: 'Towara',
  },
  {
    id: '7212040010',
    districtId: '7212040',
    name: 'Bungintimbe',
  },
  {
    id: '7212040011',
    districtId: '7212040',
    name: 'Tompira',
  },
  {
    id: '7212040012',
    districtId: '7212040',
    name: 'Bunta',
  },
  {
    id: '7212050001',
    districtId: '7212050',
    name: 'Koromatantu',
  },
  {
    id: '7212050002',
    districtId: '7212050',
    name: 'Korololama',
  },
  {
    id: '7212050003',
    districtId: '7212050',
    name: 'Korololaki',
  },
  {
    id: '7212050004',
    districtId: '7212050',
    name: 'Koya',
  },
  {
    id: '7212050005',
    districtId: '7212050',
    name: 'Gililana',
  },
  {
    id: '7212050006',
    districtId: '7212050',
    name: 'Tanauge',
  },
  {
    id: '7212050007',
    districtId: '7212050',
    name: 'Kolonodale',
  },
  {
    id: '7212050008',
    districtId: '7212050',
    name: 'Bahontula',
  },
  {
    id: '7212050009',
    districtId: '7212050',
    name: 'Bahoue',
  },
  {
    id: '7212050010',
    districtId: '7212050',
    name: 'Ganda Ganda',
  },
  {
    id: '7212060001',
    districtId: '7212060',
    name: 'Moleono',
  },
  {
    id: '7212060002',
    districtId: '7212060',
    name: 'Onepute',
  },
  {
    id: '7212060003',
    districtId: '7212060',
    name: 'Mondowe',
  },
  {
    id: '7212060004',
    districtId: '7212060',
    name: 'Tadaku Jaya',
  },
  {
    id: '7212060005',
    districtId: '7212060',
    name: 'Sampalowo',
  },
  {
    id: '7212060006',
    districtId: '7212060',
    name: 'Maralee',
  },
  {
    id: '7212060007',
    districtId: '7212060',
    name: 'Togo Mulyo',
  },
  {
    id: '7212060008',
    districtId: '7212060',
    name: 'Tiu',
  },
  {
    id: '7212060009',
    districtId: '7212060',
    name: 'Ulu Laa',
  },
  {
    id: '7212060010',
    districtId: '7212060',
    name: 'Tontowea',
  },
  {
    id: '7212070001',
    districtId: '7212070',
    name: 'Tiwaa',
  },
  {
    id: '7212070002',
    districtId: '7212070',
    name: 'Tabarano',
  },
  {
    id: '7212070003',
    districtId: '7212070',
    name: 'Wawondula',
  },
  {
    id: '7212070004',
    districtId: '7212070',
    name: 'Lembontonara',
  },
  {
    id: '7212070005',
    districtId: '7212070',
    name: 'Tamonjengi',
  },
  {
    id: '7212070006',
    districtId: '7212070',
    name: 'Mayumba',
  },
  {
    id: '7212070008',
    districtId: '7212070',
    name: 'Era',
  },
  {
    id: '7212080001',
    districtId: '7212080',
    name: 'Tamainusi',
  },
  {
    id: '7212080002',
    districtId: '7212080',
    name: 'Panca Makmur',
  },
  {
    id: '7212080003',
    districtId: '7212080',
    name: 'Toddopoli Uebangke',
  },
  {
    id: '7212080004',
    districtId: '7212080',
    name: 'Tandoyondo',
  },
  {
    id: '7212080005',
    districtId: '7212080',
    name: 'Lembah Sumara',
  },
  {
    id: '7212080006',
    districtId: '7212080',
    name: 'Tambayoli',
  },
  {
    id: '7212080007',
    districtId: '7212080',
    name: 'Sumara Jaya',
  },
  {
    id: '7212080008',
    districtId: '7212080',
    name: 'Bau',
  },
  {
    id: '7212080009',
    districtId: '7212080',
    name: 'Malino',
  },
  {
    id: '7212080010',
    districtId: '7212080',
    name: 'Malino Jaya',
  },
  {
    id: '7212090001',
    districtId: '7212090',
    name: 'Tokonanaka',
  },
  {
    id: '7212090002',
    districtId: '7212090',
    name: 'Matube',
  },
  {
    id: '7212090003',
    districtId: '7212090',
    name: 'Taronggo',
  },
  {
    id: '7212090004',
    districtId: '7212090',
    name: 'Posangke',
  },
  {
    id: '7212090005',
    districtId: '7212090',
    name: 'Tokala Atas',
  },
  {
    id: '7212090006',
    districtId: '7212090',
    name: 'Uewajo',
  },
  {
    id: '7212090007',
    districtId: '7212090',
    name: 'Baturube',
  },
  {
    id: '7212090008',
    districtId: '7212090',
    name: 'Pokeang',
  },
  {
    id: '7212090009',
    districtId: '7212090',
    name: 'Woomparigi',
  },
  {
    id: '7212090010',
    districtId: '7212090',
    name: 'Tambarobone',
  },
  {
    id: '7212090011',
    districtId: '7212090',
    name: 'Uemasi',
  },
  {
    id: '7212090012',
    districtId: '7212090',
    name: 'Tirongan Atas',
  },
  {
    id: '7212090013',
    districtId: '7212090',
    name: 'Kalombang',
  },
  {
    id: '7212090014',
    districtId: '7212090',
    name: 'Tirongan Bawah',
  },
  {
    id: '7212090015',
    districtId: '7212090',
    name: 'Siliti',
  },
  {
    id: '7212090016',
    districtId: '7212090',
    name: 'Opo',
  },
  {
    id: '7212090017',
    districtId: '7212090',
    name: 'Tanaku Raya',
  },
  {
    id: '7212090018',
    districtId: '7212090',
    name: 'Lemo',
  },
  {
    id: '7212090019',
    districtId: '7212090',
    name: 'Uempanapa',
  },
  {
    id: '7212090021',
    districtId: '7212090',
    name: 'Boba',
  },
  {
    id: '7212090022',
    districtId: '7212090',
    name: 'Lemowalia',
  },
  {
    id: '7212090023',
    districtId: '7212090',
    name: 'Salubiro',
  },
  {
    id: '7212100001',
    districtId: '7212100',
    name: 'Kolo Atas',
  },
  {
    id: '7212100002',
    districtId: '7212100',
    name: 'Kolo Bawah',
  },
  {
    id: '7212100003',
    districtId: '7212100',
    name: 'Momo',
  },
  {
    id: '7212100004',
    districtId: '7212100',
    name: 'Giri Mulya',
  },
  {
    id: '7212100005',
    districtId: '7212100',
    name: 'Tananagaya',
  },
  {
    id: '7212100006',
    districtId: '7212100',
    name: 'Tana Sumpu',
  },
  {
    id: '7212100007',
    districtId: '7212100',
    name: 'Pandauke',
  },
  {
    id: '7212100008',
    districtId: '7212100',
    name: 'Tambale',
  },
  {
    id: '7212100009',
    districtId: '7212100',
    name: 'Winangabino',
  },
  {
    id: '7212100010',
    districtId: '7212100',
    name: 'Sea',
  },
  {
    id: '7212100011',
    districtId: '7212100',
    name: 'Uepakatu',
  },
  {
    id: '7212100012',
    districtId: '7212100',
    name: 'Parangisi',
  },
  {
    id: '7212100013',
    districtId: '7212100',
    name: 'Lijo',
  },
  {
    id: '7212100014',
    districtId: '7212100',
    name: "Menyo'E",
  },
  {
    id: '7271010004',
    districtId: '7271010',
    name: 'Ujuna',
  },
  {
    id: '7271010005',
    districtId: '7271010',
    name: 'Baru',
  },
  {
    id: '7271010006',
    districtId: '7271010',
    name: 'Siranindi',
  },
  {
    id: '7271010007',
    districtId: '7271010',
    name: 'Kamonji',
  },
  {
    id: '7271010008',
    districtId: '7271010',
    name: 'Balaroa',
  },
  {
    id: '7271011002',
    districtId: '7271011',
    name: 'Pengawu',
  },
  {
    id: '7271011003',
    districtId: '7271011',
    name: 'Palupi',
  },
  {
    id: '7271011004',
    districtId: '7271011',
    name: 'Tawanjuka',
  },
  {
    id: '7271011005',
    districtId: '7271011',
    name: 'Boyaoge',
  },
  {
    id: '7271012001',
    districtId: '7271012',
    name: 'Donggala Kodi',
  },
  {
    id: '7271012002',
    districtId: '7271012',
    name: 'Kabonena',
  },
  {
    id: '7271012003',
    districtId: '7271012',
    name: 'Silae',
  },
  {
    id: '7271012004',
    districtId: '7271012',
    name: 'Tipo',
  },
  {
    id: '7271012005',
    districtId: '7271012',
    name: 'Buluri',
  },
  {
    id: '7271012006',
    districtId: '7271012',
    name: 'Watusampu',
  },
  {
    id: '7271020004',
    districtId: '7271020',
    name: 'Birobuli Selatan',
  },
  {
    id: '7271020005',
    districtId: '7271020',
    name: 'Petobo',
  },
  {
    id: '7271020007',
    districtId: '7271020',
    name: 'Birobuli Utara',
  },
  {
    id: '7271020008',
    districtId: '7271020',
    name: 'Tatura Utara',
  },
  {
    id: '7271020009',
    districtId: '7271020',
    name: 'Tatura Selatan',
  },
  {
    id: '7271030001',
    districtId: '7271030',
    name: 'Besusu Barat',
  },
  {
    id: '7271030002',
    districtId: '7271030',
    name: 'Besusu Tengah',
  },
  {
    id: '7271030003',
    districtId: '7271030',
    name: 'Besusu Timur',
  },
  {
    id: '7271030004',
    districtId: '7271030',
    name: 'Lolu Utara',
  },
  {
    id: '7271030005',
    districtId: '7271030',
    name: 'Lolu Selatan',
  },
  {
    id: '7271031001',
    districtId: '7271031',
    name: 'Talise',
  },
  {
    id: '7271031002',
    districtId: '7271031',
    name: 'Tanamodindi',
  },
  {
    id: '7271031003',
    districtId: '7271031',
    name: 'Lasoani',
  },
  {
    id: '7271031004',
    districtId: '7271031',
    name: 'Kawatuna',
  },
  {
    id: '7271031005',
    districtId: '7271031',
    name: 'Poboya',
  },
  {
    id: '7271031006',
    districtId: '7271031',
    name: 'Tondo',
  },
  {
    id: '7271031007',
    districtId: '7271031',
    name: 'Layana Indah',
  },
  {
    id: '7271031008',
    districtId: '7271031',
    name: 'Talise Valangguni',
  },
  {
    id: '7271040001',
    districtId: '7271040',
    name: 'Mamboro',
  },
  {
    id: '7271040002',
    districtId: '7271040',
    name: 'Taipa',
  },
  {
    id: '7271040003',
    districtId: '7271040',
    name: 'Kayumalue Pajeko',
  },
  {
    id: '7271040004',
    districtId: '7271040',
    name: 'Kayumalue Ngapa',
  },
  {
    id: '7271040009',
    districtId: '7271040',
    name: 'Mamboro Barat',
  },
  {
    id: '7271041001',
    districtId: '7271041',
    name: 'Panau',
  },
  {
    id: '7271041002',
    districtId: '7271041',
    name: 'Lambara',
  },
  {
    id: '7271041003',
    districtId: '7271041',
    name: 'Baiya',
  },
  {
    id: '7271041004',
    districtId: '7271041',
    name: 'Pantoloan',
  },
  {
    id: '7271041005',
    districtId: '7271041',
    name: 'Pantoloan Boya',
  },
  {
    id: '7301010001',
    districtId: '7301010',
    name: 'Komba-Komba',
  },
  {
    id: '7301010002',
    districtId: '7301010',
    name: 'Lambego',
  },
  {
    id: '7301010003',
    districtId: '7301010',
    name: 'Bonerate',
  },
  {
    id: '7301010004',
    districtId: '7301010',
    name: 'Majapahit',
  },
  {
    id: '7301010005',
    districtId: '7301010',
    name: 'Batu Bingkung',
  },
  {
    id: '7301010006',
    districtId: '7301010',
    name: 'Bonea',
  },
  {
    id: '7301010007',
    districtId: '7301010',
    name: 'Sambali',
  },
  {
    id: '7301010008',
    districtId: '7301010',
    name: 'Lamantu',
  },
  {
    id: '7301011001',
    districtId: '7301011',
    name: 'Pulo Madu',
  },
  {
    id: '7301011002',
    districtId: '7301011',
    name: 'Garaupa',
  },
  {
    id: '7301011003',
    districtId: '7301011',
    name: 'Kalaotoa',
  },
  {
    id: '7301011004',
    districtId: '7301011',
    name: 'Lembang Matene',
  },
  {
    id: '7301011005',
    districtId: '7301011',
    name: 'Karumpa',
  },
  {
    id: '7301011006',
    districtId: '7301011',
    name: 'Garaupa Raya',
  },
  {
    id: '7301020001',
    districtId: '7301020',
    name: 'Tanamalala',
  },
  {
    id: '7301020002',
    districtId: '7301020',
    name: 'Kembang Ragi',
  },
  {
    id: '7301020003',
    districtId: '7301020',
    name: 'Labuang Pamajang',
  },
  {
    id: '7301020004',
    districtId: '7301020',
    name: 'Maminasa',
  },
  {
    id: '7301020009',
    districtId: '7301020',
    name: 'Bontosaile',
  },
  {
    id: '7301020010',
    districtId: '7301020',
    name: 'Massungke',
  },
  {
    id: '7301020011',
    districtId: '7301020',
    name: 'Teluk Kampe',
  },
  {
    id: '7301021001',
    districtId: '7301021',
    name: 'Tambuna',
  },
  {
    id: '7301021002',
    districtId: '7301021',
    name: 'Kayuadi',
  },
  {
    id: '7301021003',
    districtId: '7301021',
    name: 'Batang',
  },
  {
    id: '7301021004',
    districtId: '7301021',
    name: 'Nyiur Indah',
  },
  {
    id: '7301021005',
    districtId: '7301021',
    name: 'Jinato',
  },
  {
    id: '7301021006',
    districtId: '7301021',
    name: 'Rajuni',
  },
  {
    id: '7301021007',
    districtId: '7301021',
    name: 'Latondu',
  },
  {
    id: '7301021008',
    districtId: '7301021',
    name: 'Tarupa',
  },
  {
    id: '7301021009',
    districtId: '7301021',
    name: 'Khusus Pasitallu',
  },
  {
    id: '7301022001',
    districtId: '7301022',
    name: 'Lembang Baji',
  },
  {
    id: '7301022002',
    districtId: '7301022',
    name: 'Bontomalling',
  },
  {
    id: '7301022003',
    districtId: '7301022',
    name: 'Bontobulaeng',
  },
  {
    id: '7301022004',
    districtId: '7301022',
    name: 'Bontobaru',
  },
  {
    id: '7301022005',
    districtId: '7301022',
    name: 'Bontojati',
  },
  {
    id: '7301030001',
    districtId: '7301030',
    name: 'Polassi',
  },
  {
    id: '7301030002',
    districtId: '7301030',
    name: 'Tambolongan',
  },
  {
    id: '7301030003',
    districtId: '7301030',
    name: 'Appatanah',
  },
  {
    id: '7301030004',
    districtId: '7301030',
    name: 'Lowa',
  },
  {
    id: '7301030005',
    districtId: '7301030',
    name: 'Lantimbongan',
  },
  {
    id: '7301030006',
    districtId: '7301030',
    name: 'Binanga Sombaiya',
  },
  {
    id: '7301030007',
    districtId: '7301030',
    name: 'Laiyolo',
  },
  {
    id: '7301030008',
    districtId: '7301030',
    name: 'Laiyolo Baru',
  },
  {
    id: '7301030009',
    districtId: '7301030',
    name: 'Harapan',
  },
  {
    id: '7301030010',
    districtId: '7301030',
    name: 'Patikarya',
  },
  {
    id: '7301030011',
    districtId: '7301030',
    name: 'Patilereng',
  },
  {
    id: '7301030012',
    districtId: '7301030',
    name: 'Khusus Bahuluang',
  },
  {
    id: '7301040001',
    districtId: '7301040',
    name: 'Bontoborusu',
  },
  {
    id: '7301040002',
    districtId: '7301040',
    name: 'Bontolebang',
  },
  {
    id: '7301040003',
    districtId: '7301040',
    name: 'Bontosunggu',
  },
  {
    id: '7301040004',
    districtId: '7301040',
    name: 'Bontobangun',
  },
  {
    id: '7301040008',
    districtId: '7301040',
    name: 'Putabangun',
  },
  {
    id: '7301040009',
    districtId: '7301040',
    name: 'Bontotangnga',
  },
  {
    id: '7301040010',
    districtId: '7301040',
    name: 'Kahu-Kahu',
  },
  {
    id: '7301040011',
    districtId: '7301040',
    name: 'Kalepadang',
  },
  {
    id: '7301041001',
    districtId: '7301041',
    name: 'Benteng Selatan',
  },
  {
    id: '7301041003',
    districtId: '7301041',
    name: 'Benteng Utara',
  },
  {
    id: '7301042001',
    districtId: '7301042',
    name: 'Parak',
  },
  {
    id: '7301042002',
    districtId: '7301042',
    name: 'Jambuiya',
  },
  {
    id: '7301042003',
    districtId: '7301042',
    name: 'Bontomarannu',
  },
  {
    id: '7301042004',
    districtId: '7301042',
    name: 'Bonea Timur',
  },
  {
    id: '7301042005',
    districtId: '7301042',
    name: 'Mare Mare',
  },
  {
    id: '7301042006',
    districtId: '7301042',
    name: 'Barugaiya',
  },
  {
    id: '7301042007',
    districtId: '7301042',
    name: 'Polebungin',
  },
  {
    id: '7301042008',
    districtId: '7301042',
    name: 'Bonea Makmur',
  },
  {
    id: '7301042009',
    districtId: '7301042',
    name: 'Bontokoraang',
  },
  {
    id: '7301042010',
    districtId: '7301042',
    name: 'Kaburu',
  },
  {
    id: '7301050006',
    districtId: '7301050',
    name: 'Maharayya',
  },
  {
    id: '7301050007',
    districtId: '7301050',
    name: 'Onto',
  },
  {
    id: '7301050008',
    districtId: '7301050',
    name: 'Batangmata Sapo',
  },
  {
    id: '7301050009',
    districtId: '7301050',
    name: 'Batangmata',
  },
  {
    id: '7301050010',
    districtId: '7301050',
    name: 'Barat Lambongan',
  },
  {
    id: '7301050011',
    districtId: '7301050',
    name: 'Bontonasaluk',
  },
  {
    id: '7301050012',
    districtId: '7301050',
    name: 'Kayu Bauk',
  },
  {
    id: '7301050013',
    districtId: '7301050',
    name: 'Tanete',
  },
  {
    id: '7301050014',
    districtId: '7301050',
    name: 'Pamatata',
  },
  {
    id: '7301050015',
    districtId: '7301050',
    name: 'Bongaiya',
  },
  {
    id: '7301050016',
    districtId: '7301050',
    name: 'Menara Indah',
  },
  {
    id: '7301050017',
    districtId: '7301050',
    name: 'Tamalanrea',
  },
  {
    id: '7301051001',
    districtId: '7301051',
    name: 'Kohala',
  },
  {
    id: '7301051002',
    districtId: '7301051',
    name: 'Bontolempangan',
  },
  {
    id: '7301051003',
    districtId: '7301051',
    name: 'Balang Butung',
  },
  {
    id: '7301051004',
    districtId: '7301051',
    name: 'Lalang Bata',
  },
  {
    id: '7301051005',
    districtId: '7301051',
    name: 'Buki',
  },
  {
    id: '7301051006',
    districtId: '7301051',
    name: 'Mekar Indah',
  },
  {
    id: '7301051007',
    districtId: '7301051',
    name: 'Buki Timur',
  },
  {
    id: '7302010001',
    districtId: '7302010',
    name: 'Mariorennu',
  },
  {
    id: '7302010002',
    districtId: '7302010',
    name: 'Jalanjang',
  },
  {
    id: '7302010003',
    districtId: '7302010',
    name: 'Mattekko',
  },
  {
    id: '7302010004',
    districtId: '7302010',
    name: 'Paenre Lompoe',
  },
  {
    id: '7302010005',
    districtId: '7302010',
    name: 'Bialo',
  },
  {
    id: '7302010006',
    districtId: '7302010',
    name: 'Bonto Macinna',
  },
  {
    id: '7302010007',
    districtId: '7302010',
    name: 'Bontomasila',
  },
  {
    id: '7302010008',
    districtId: '7302010',
    name: 'Padang',
  },
  {
    id: '7302010009',
    districtId: '7302010',
    name: 'Barombong',
  },
  {
    id: '7302010010',
    districtId: '7302010',
    name: 'Bonto Sunggu',
  },
  {
    id: '7302010011',
    districtId: '7302010',
    name: 'Polewali',
  },
  {
    id: '7302010012',
    districtId: '7302010',
    name: 'Palambarae',
  },
  {
    id: '7302010013',
    districtId: '7302010',
    name: 'Bukit Tinggi',
  },
  {
    id: '7302010014',
    districtId: '7302010',
    name: 'Bontonyeleng',
  },
  {
    id: '7302010015',
    districtId: '7302010',
    name: 'Bukit Harapan',
  },
  {
    id: '7302010016',
    districtId: '7302010',
    name: 'Dampang',
  },
  {
    id: '7302010017',
    districtId: '7302010',
    name: 'Bontoraja',
  },
  {
    id: '7302010018',
    districtId: '7302010',
    name: 'Benteng Gantarang',
  },
  {
    id: '7302010019',
    districtId: '7302010',
    name: 'Gattareng',
  },
  {
    id: '7302010020',
    districtId: '7302010',
    name: 'Benteng Malewang',
  },
  {
    id: '7302010021',
    districtId: '7302010',
    name: 'Taccorong',
  },
  {
    id: '7302020001',
    districtId: '7302020',
    name: 'Bintarore',
  },
  {
    id: '7302020002',
    districtId: '7302020',
    name: 'Kasimpureng',
  },
  {
    id: '7302020003',
    districtId: '7302020',
    name: 'Tanah Kongkong',
  },
  {
    id: '7302020004',
    districtId: '7302020',
    name: 'L O K A',
  },
  {
    id: '7302020006',
    districtId: '7302020',
    name: 'Terang-Terang',
  },
  {
    id: '7302020007',
    districtId: '7302020',
    name: 'Caile',
  },
  {
    id: '7302020008',
    districtId: '7302020',
    name: 'Kalumeme',
  },
  {
    id: '7302020009',
    districtId: '7302020',
    name: 'Ela-Ela',
  },
  {
    id: '7302021001',
    districtId: '7302021',
    name: 'Salemba',
  },
  {
    id: '7302021002',
    districtId: '7302021',
    name: 'Dannuang',
  },
  {
    id: '7302021003',
    districtId: '7302021',
    name: 'Manjalling',
  },
  {
    id: '7302021004',
    districtId: '7302021',
    name: 'Padang Loang',
  },
  {
    id: '7302021005',
    districtId: '7302021',
    name: 'Seppang',
  },
  {
    id: '7302021006',
    districtId: '7302021',
    name: 'Bijawang',
  },
  {
    id: '7302021007',
    districtId: '7302021',
    name: 'Lonrong',
  },
  {
    id: '7302021008',
    districtId: '7302021',
    name: 'Balong',
  },
  {
    id: '7302021009',
    districtId: '7302021',
    name: 'Garanta',
  },
  {
    id: '7302021010',
    districtId: '7302021',
    name: 'Manyampa',
  },
  {
    id: '7302021011',
    districtId: '7302021',
    name: 'Balleangin',
  },
  {
    id: '7302021012',
    districtId: '7302021',
    name: 'Tamatto',
  },
  {
    id: '7302021013',
    districtId: '7302021',
    name: 'Paccarammengang',
  },
  {
    id: '7302030001',
    districtId: '7302030',
    name: 'B I R A',
  },
  {
    id: '7302030002',
    districtId: '7302030',
    name: 'Darubiah',
  },
  {
    id: '7302030003',
    districtId: '7302030',
    name: 'Tanah Lemo',
  },
  {
    id: '7302030004',
    districtId: '7302030',
    name: 'A R A',
  },
  {
    id: '7302030005',
    districtId: '7302030',
    name: 'Lembanna',
  },
  {
    id: '7302030006',
    districtId: '7302030',
    name: 'Tanah Beru',
  },
  {
    id: '7302030007',
    districtId: '7302030',
    name: 'Sapolohe',
  },
  {
    id: '7302030008',
    districtId: '7302030',
    name: 'Benjala',
  },
  {
    id: '7302040001',
    districtId: '7302040',
    name: 'Caramming',
  },
  {
    id: '7302040002',
    districtId: '7302040',
    name: 'Pakubalaho',
  },
  {
    id: '7302040003',
    districtId: '7302040',
    name: 'Tritiro',
  },
  {
    id: '7302040004',
    districtId: '7302040',
    name: 'Ekatiro',
  },
  {
    id: '7302040005',
    districtId: '7302040',
    name: 'Buhung Bundang',
  },
  {
    id: '7302040006',
    districtId: '7302040',
    name: 'Dwi Tiro',
  },
  {
    id: '7302040007',
    districtId: '7302040',
    name: 'Bonto Bulaeng',
  },
  {
    id: '7302040008',
    districtId: '7302040',
    name: 'Batang',
  },
  {
    id: '7302040009',
    districtId: '7302040',
    name: 'Tamalanrea',
  },
  {
    id: '7302040010',
    districtId: '7302040',
    name: 'Bonto Tangnga',
  },
  {
    id: '7302040011',
    districtId: '7302040',
    name: 'Bontu Marannu',
  },
  {
    id: '7302040012',
    districtId: '7302040',
    name: 'Bonto Barua',
  },
  {
    id: '7302040013',
    districtId: '7302040',
    name: 'Lamanda',
  },
  {
    id: '7302050001',
    districtId: '7302050',
    name: 'Karassing',
  },
  {
    id: '7302050002',
    districtId: '7302050',
    name: 'Borong',
  },
  {
    id: '7302050003',
    districtId: '7302050',
    name: 'Bonto Kamase',
  },
  {
    id: '7302050004',
    districtId: '7302050',
    name: 'Tanuntung',
  },
  {
    id: '7302050005',
    districtId: '7302050',
    name: 'Singa',
  },
  {
    id: '7302050006',
    districtId: '7302050',
    name: 'Tugondeng',
  },
  {
    id: '7302050007',
    districtId: '7302050',
    name: 'Pataro',
  },
  {
    id: '7302060001',
    districtId: '7302060',
    name: 'Bonto Biraeng',
  },
  {
    id: '7302060002',
    districtId: '7302060',
    name: 'Bontorannu',
  },
  {
    id: '7302060003',
    districtId: '7302060',
    name: 'Lembang',
  },
  {
    id: '7302060004',
    districtId: '7302060',
    name: 'Lembanglohe',
  },
  {
    id: '7302060005',
    districtId: '7302060',
    name: 'Tanah Jaya',
  },
  {
    id: '7302060006',
    districtId: '7302060',
    name: 'Laikang',
  },
  {
    id: '7302060007',
    districtId: '7302060',
    name: 'Pantama',
  },
  {
    id: '7302060008',
    districtId: '7302060',
    name: 'Possi Tanah',
  },
  {
    id: '7302060009',
    districtId: '7302060',
    name: 'Lembanna',
  },
  {
    id: '7302060010',
    districtId: '7302060',
    name: 'Tambangan',
  },
  {
    id: '7302060011',
    districtId: '7302060',
    name: 'Sangkala',
  },
  {
    id: '7302060012',
    districtId: '7302060',
    name: 'Bonto Baji',
  },
  {
    id: '7302060013',
    districtId: '7302060',
    name: 'Pattiroang',
  },
  {
    id: '7302060014',
    districtId: '7302060',
    name: 'Sapanang',
  },
  {
    id: '7302060015',
    districtId: '7302060',
    name: 'Batunilamung',
  },
  {
    id: '7302060016',
    districtId: '7302060',
    name: 'Tanah Towa',
  },
  {
    id: '7302060017',
    districtId: '7302060',
    name: 'Malleleng',
  },
  {
    id: '7302060018',
    districtId: '7302060',
    name: 'Mattoanging',
  },
  {
    id: '7302060019',
    districtId: '7302060',
    name: 'Lolisang',
  },
  {
    id: '7302070001',
    districtId: '7302070',
    name: 'Sapo Bonto',
  },
  {
    id: '7302070002',
    districtId: '7302070',
    name: 'Bonto Bulaeng',
  },
  {
    id: '7302070003',
    districtId: '7302070',
    name: 'Bulo-Bulo',
  },
  {
    id: '7302070004',
    districtId: '7302070',
    name: 'Salassae',
  },
  {
    id: '7302070005',
    districtId: '7302070',
    name: 'Bontomangiring',
  },
  {
    id: '7302070006',
    districtId: '7302070',
    name: 'Jojjolo',
  },
  {
    id: '7302070007',
    districtId: '7302070',
    name: 'Ballasaraja',
  },
  {
    id: '7302070008',
    districtId: '7302070',
    name: 'Tanete',
  },
  {
    id: '7302070009',
    districtId: '7302070',
    name: 'Balang Taroang',
  },
  {
    id: '7302070010',
    districtId: '7302070',
    name: 'Kambuno',
  },
  {
    id: '7302070011',
    districtId: '7302070',
    name: 'Barugae',
  },
  {
    id: '7302070012',
    districtId: '7302070',
    name: 'Balang Pesoang',
  },
  {
    id: '7302070013',
    districtId: '7302070',
    name: 'Jawi - Jawi',
  },
  {
    id: '7302070014',
    districtId: '7302070',
    name: 'Tibona',
  },
  {
    id: '7302070015',
    districtId: '7302070',
    name: 'Bonto Minasa',
  },
  {
    id: '7302070016',
    districtId: '7302070',
    name: 'Batulohe',
  },
  {
    id: '7302070017',
    districtId: '7302070',
    name: 'Baruga Riattang',
  },
  {
    id: '7302080001',
    districtId: '7302080',
    name: 'Tanah Harapan',
  },
  {
    id: '7302080002',
    districtId: '7302080',
    name: 'Bontomanai',
  },
  {
    id: '7302080003',
    districtId: '7302080',
    name: 'Swatani',
  },
  {
    id: '7302080004',
    districtId: '7302080',
    name: 'Karama',
  },
  {
    id: '7302080005',
    districtId: '7302080',
    name: 'Batukaropa',
  },
  {
    id: '7302080006',
    districtId: '7302080',
    name: 'Bulolohe',
  },
  {
    id: '7302080007',
    districtId: '7302080',
    name: 'Bontobangun',
  },
  {
    id: '7302080008',
    districtId: '7302080',
    name: 'Bontoharu',
  },
  {
    id: '7302080009',
    districtId: '7302080',
    name: 'Palampang',
  },
  {
    id: '7302080010',
    districtId: '7302080',
    name: 'Bajiminasa',
  },
  {
    id: '7302080011',
    districtId: '7302080',
    name: 'Anrang',
  },
  {
    id: '7302080012',
    districtId: '7302080',
    name: 'Bonto Matene',
  },
  {
    id: '7302080013',
    districtId: '7302080',
    name: 'Bontolohe',
  },
  {
    id: '7302080014',
    districtId: '7302080',
    name: 'Topanda',
  },
  {
    id: '7302080015',
    districtId: '7302080',
    name: 'Pangalloang',
  },
  {
    id: '7302090001',
    districtId: '7302090',
    name: 'Balibo',
  },
  {
    id: '7302090002',
    districtId: '7302090',
    name: 'Mattirowalie',
  },
  {
    id: '7302090003',
    districtId: '7302090',
    name: 'Benteng Palioi',
  },
  {
    id: '7302090004',
    districtId: '7302090',
    name: 'Garuntungan',
  },
  {
    id: '7302090005',
    districtId: '7302090',
    name: 'Anrihua',
  },
  {
    id: '7302090006',
    districtId: '7302090',
    name: 'Borong Rappoa',
  },
  {
    id: '7302090007',
    districtId: '7302090',
    name: 'Tamaona',
  },
  {
    id: '7302090008',
    districtId: '7302090',
    name: 'Kindang',
  },
  {
    id: '7302090009',
    districtId: '7302090',
    name: 'Oro Gading',
  },
  {
    id: '7302090010',
    districtId: '7302090',
    name: 'Sopa',
  },
  {
    id: '7302090011',
    districtId: '7302090',
    name: 'Somba Palioi',
  },
  {
    id: '7302090012',
    districtId: '7302090',
    name: 'Sipaenre',
  },
  {
    id: '7302090013',
    districtId: '7302090',
    name: 'Kahaya',
  },
  {
    id: '7303010001',
    districtId: '7303010',
    name: 'Bonto Jai',
  },
  {
    id: '7303010002',
    districtId: '7303010',
    name: 'Bonto Manai',
  },
  {
    id: '7303010003',
    districtId: '7303010',
    name: 'Bonto Lebang',
  },
  {
    id: '7303010004',
    districtId: '7303010',
    name: 'Bonto Sunggu',
  },
  {
    id: '7303010005',
    districtId: '7303010',
    name: 'Bonto Rita',
  },
  {
    id: '7303010007',
    districtId: '7303010',
    name: 'Bonto  Atu',
  },
  {
    id: '7303010008',
    districtId: '7303010',
    name: 'Bonto Salluang',
  },
  {
    id: '7303010010',
    districtId: '7303010',
    name: 'Bonto Langkasa',
  },
  {
    id: '7303010011',
    districtId: '7303010',
    name: 'Bonto Cinde',
  },
  {
    id: '7303010012',
    districtId: '7303010',
    name: 'Bonto Loe',
  },
  {
    id: '7303010013',
    districtId: '7303010',
    name: 'Bonto Jaya',
  },
  {
    id: '7303011001',
    districtId: '7303011',
    name: 'Bonto Rannu',
  },
  {
    id: '7303011007',
    districtId: '7303011',
    name: 'Bonto Tallasa',
  },
  {
    id: '7303011008',
    districtId: '7303011',
    name: 'Bonto Daeng',
  },
  {
    id: '7303011009',
    districtId: '7303011',
    name: 'Bonto Tangnga',
  },
  {
    id: '7303011010',
    districtId: '7303011',
    name: 'Bonto Marannu',
  },
  {
    id: '7303011011',
    districtId: '7303011',
    name: 'Bonto Lojong',
  },
  {
    id: '7303012001',
    districtId: '7303012',
    name: 'Bonto Matene',
  },
  {
    id: '7303012002',
    districtId: '7303012',
    name: 'Bonto Tiro',
  },
  {
    id: '7303012003',
    districtId: '7303012',
    name: 'Bonto Majannang',
  },
  {
    id: '7303012004',
    districtId: '7303012',
    name: 'Bonto Karaeng',
  },
  {
    id: '7303012005',
    districtId: '7303012',
    name: 'Bonto Maccini',
  },
  {
    id: '7303012006',
    districtId: '7303012',
    name: 'Bonto Bulaeng',
  },
  {
    id: '7303020001',
    districtId: '7303020',
    name: 'Tappanjeng',
  },
  {
    id: '7303020002',
    districtId: '7303020',
    name: 'Pallantikang',
  },
  {
    id: '7303020003',
    districtId: '7303020',
    name: 'Letta',
  },
  {
    id: '7303020004',
    districtId: '7303020',
    name: 'Mallilingi',
  },
  {
    id: '7303020005',
    districtId: '7303020',
    name: 'Lembang',
  },
  {
    id: '7303020006',
    districtId: '7303020',
    name: 'Lamalaka',
  },
  {
    id: '7303020009',
    districtId: '7303020',
    name: 'Karatuang',
  },
  {
    id: '7303020010',
    districtId: '7303020',
    name: 'Onto',
  },
  {
    id: '7303020018',
    districtId: '7303020',
    name: 'Kayu Loe',
  },
  {
    id: '7303021001',
    districtId: '7303021',
    name: 'Ulugalung',
  },
  {
    id: '7303021002',
    districtId: '7303021',
    name: 'Mamampang',
  },
  {
    id: '7303021003',
    districtId: '7303021',
    name: 'Mappilawing',
  },
  {
    id: '7303021004',
    districtId: '7303021',
    name: 'Lonrong',
  },
  {
    id: '7303021005',
    districtId: '7303021',
    name: 'Barua',
  },
  {
    id: '7303021006',
    districtId: '7303021',
    name: 'Kampala',
  },
  {
    id: '7303021007',
    districtId: '7303021',
    name: "Pa'Bentengan",
  },
  {
    id: '7303021008',
    districtId: '7303021',
    name: 'Parangloe',
  },
  {
    id: '7303021009',
    districtId: '7303021',
    name: "Pa'Bumbungan",
  },
  {
    id: '7303030016',
    districtId: '7303030',
    name: 'Lembang Gantarangkeke',
  },
  {
    id: '7303030017',
    districtId: '7303030',
    name: 'Pattallassang',
  },
  {
    id: '7303030018',
    districtId: '7303030',
    name: 'Bonto-Bontoa',
  },
  {
    id: '7303030019',
    districtId: '7303030',
    name: 'Banyorang',
  },
  {
    id: '7303030020',
    districtId: '7303030',
    name: 'Campaga',
  },
  {
    id: '7303030021',
    districtId: '7303030',
    name: 'Bonto Tappalang',
  },
  {
    id: '7303030022',
    districtId: '7303030',
    name: 'Balumbung',
  },
  {
    id: '7303030024',
    districtId: '7303030',
    name: 'Labbo',
  },
  {
    id: '7303030025',
    districtId: '7303030',
    name: 'Pattaneteang',
  },
  {
    id: '7303031001',
    districtId: '7303031',
    name: 'Rappoa',
  },
  {
    id: '7303031002',
    districtId: '7303031',
    name: 'Biangloe',
  },
  {
    id: '7303031003',
    districtId: '7303031',
    name: 'Lumpangan',
  },
  {
    id: '7303031004',
    districtId: '7303031',
    name: 'Biangkeke',
  },
  {
    id: '7303031005',
    districtId: '7303031',
    name: 'Nipa-Nipa',
  },
  {
    id: '7303031006',
    districtId: '7303031',
    name: "Pa'Jukukang",
  },
  {
    id: '7303031007',
    districtId: '7303031',
    name: 'Borongloe',
  },
  {
    id: '7303031008',
    districtId: '7303031',
    name: 'Papanloe',
  },
  {
    id: '7303031009',
    districtId: '7303031',
    name: 'Baruga',
  },
  {
    id: '7303031021',
    districtId: '7303031',
    name: 'Batukaraeng',
  },
  {
    id: '7303032001',
    districtId: '7303032',
    name: 'Tanahloe',
  },
  {
    id: '7303032002',
    districtId: '7303032',
    name: 'Tombolo',
  },
  {
    id: '7303032003',
    districtId: '7303032',
    name: 'Layoa',
  },
  {
    id: '7303032004',
    districtId: '7303032',
    name: 'Bajiminasa',
  },
  {
    id: '7303032005',
    districtId: '7303032',
    name: 'Kaloling',
  },
  {
    id: '7303032006',
    districtId: '7303032',
    name: 'Gantarangkeke',
  },
  {
    id: '7304010001',
    districtId: '7304010',
    name: 'Mallasoro',
  },
  {
    id: '7304010002',
    districtId: '7304010',
    name: 'Punagaya',
  },
  {
    id: '7304010003',
    districtId: '7304010',
    name: 'Bontorannu',
  },
  {
    id: '7304010004',
    districtId: '7304010',
    name: 'Pantai Bahari',
  },
  {
    id: '7304010005',
    districtId: '7304010',
    name: 'Pallengu',
  },
  {
    id: '7304010006',
    districtId: '7304010',
    name: 'Tombo-Tombolo',
  },
  {
    id: '7304010007',
    districtId: '7304010',
    name: 'Jenetallasa',
  },
  {
    id: '7304010008',
    districtId: '7304010',
    name: 'Kalimporo',
  },
  {
    id: '7304010015',
    districtId: '7304010',
    name: 'Pallantikang',
  },
  {
    id: '7304010016',
    districtId: '7304010',
    name: 'Gunung Silanu',
  },
  {
    id: '7304010017',
    districtId: '7304010',
    name: 'Kapita',
  },
  {
    id: '7304010018',
    districtId: '7304010',
    name: 'Marayoka',
  },
  {
    id: '7304010019',
    districtId: '7304010',
    name: 'Bontomanai',
  },
  {
    id: '7304011001',
    districtId: '7304011',
    name: 'Garassikang',
  },
  {
    id: '7304011002',
    districtId: '7304011',
    name: 'Banrimanurung',
  },
  {
    id: '7304011003',
    districtId: '7304011',
    name: 'Pattiro',
  },
  {
    id: '7304011005',
    districtId: '7304011',
    name: 'Bulujaya',
  },
  {
    id: '7304011006',
    districtId: '7304011',
    name: 'Barana',
  },
  {
    id: '7304011007',
    districtId: '7304011',
    name: 'Beroanging',
  },
  {
    id: '7304011008',
    districtId: '7304011',
    name: 'Pappalluang',
  },
  {
    id: '7304020001',
    districtId: '7304020',
    name: 'Bontosunggu',
  },
  {
    id: '7304020002',
    districtId: '7304020',
    name: 'Bontojai',
  },
  {
    id: '7304020003',
    districtId: '7304020',
    name: 'Borongtala',
  },
  {
    id: '7304020004',
    districtId: '7304020',
    name: 'Turatea Timur',
  },
  {
    id: '7304020005',
    districtId: '7304020',
    name: 'Turatea',
  },
  {
    id: '7304020006',
    districtId: '7304020',
    name: 'Bontotangnga',
  },
  {
    id: '7304020007',
    districtId: '7304020',
    name: 'Manjangloe',
  },
  {
    id: '7304020008',
    districtId: '7304020',
    name: 'Karelayu',
  },
  {
    id: '7304020012',
    districtId: '7304020',
    name: 'Taman Roya',
  },
  {
    id: '7304020013',
    districtId: '7304020',
    name: 'Tonrokassi Timur',
  },
  {
    id: '7304020015',
    districtId: '7304020',
    name: 'Tonrokassi',
  },
  {
    id: '7304020016',
    districtId: '7304020',
    name: 'Tonrokassi Barat',
  },
  {
    id: '7304021001',
    districtId: '7304021',
    name: 'Bulusuka',
  },
  {
    id: '7304021002',
    districtId: '7304021',
    name: 'Maero',
  },
  {
    id: '7304021004',
    districtId: '7304021',
    name: 'Balumbungang',
  },
  {
    id: '7304021005',
    districtId: '7304021',
    name: 'Bangkalaloe',
  },
  {
    id: '7304021006',
    districtId: '7304021',
    name: 'Datara',
  },
  {
    id: '7304021007',
    districtId: '7304021',
    name: 'Baraya',
  },
  {
    id: '7304021008',
    districtId: '7304021',
    name: 'Bontoramba',
  },
  {
    id: '7304021009',
    districtId: '7304021',
    name: 'Batujala',
  },
  {
    id: '7304021010',
    districtId: '7304021',
    name: 'Bulusibatang',
  },
  {
    id: '7304021011',
    districtId: '7304021',
    name: 'Kareloe',
  },
  {
    id: '7304021012',
    districtId: '7304021',
    name: 'Tanammawang',
  },
  {
    id: '7304030001',
    districtId: '7304030',
    name: 'Biringkassi',
  },
  {
    id: '7304030002',
    districtId: '7304030',
    name: 'Pabiringa',
  },
  {
    id: '7304030003',
    districtId: '7304030',
    name: 'Panaikang',
  },
  {
    id: '7304030004',
    districtId: '7304030',
    name: 'Monro-Monro',
  },
  {
    id: '7304030005',
    districtId: '7304030',
    name: 'Sidenre',
  },
  {
    id: '7304030006',
    districtId: '7304030',
    name: 'Empoang Selatan',
  },
  {
    id: '7304030007',
    districtId: '7304030',
    name: 'Empoang',
  },
  {
    id: '7304030008',
    districtId: '7304030',
    name: 'Balang Toa',
  },
  {
    id: '7304030009',
    districtId: '7304030',
    name: 'Balang',
  },
  {
    id: '7304030010',
    districtId: '7304030',
    name: 'Balang Beru',
  },
  {
    id: '7304030011',
    districtId: '7304030',
    name: 'Bontoa',
  },
  {
    id: '7304030012',
    districtId: '7304030',
    name: 'Sapanang',
  },
  {
    id: '7304030013',
    districtId: '7304030',
    name: 'Empoang Utara',
  },
  {
    id: '7304031001',
    districtId: '7304031',
    name: 'Jombe',
  },
  {
    id: '7304031002',
    districtId: '7304031',
    name: 'Kayuloe Barat',
  },
  {
    id: '7304031003',
    districtId: '7304031',
    name: 'Kayuloe Timur',
  },
  {
    id: '7304031004',
    districtId: '7304031',
    name: 'Bungungloe',
  },
  {
    id: '7304031005',
    districtId: '7304031',
    name: 'Bontomatene',
  },
  {
    id: '7304031006',
    districtId: '7304031',
    name: 'Tanjonga',
  },
  {
    id: '7304031007',
    districtId: '7304031',
    name: 'Bululoe',
  },
  {
    id: '7304031008',
    districtId: '7304031',
    name: 'Mangepong',
  },
  {
    id: '7304031009',
    districtId: '7304031',
    name: 'Langkura',
  },
  {
    id: '7304031010',
    districtId: '7304031',
    name: 'Paitana',
  },
  {
    id: '7304031011',
    districtId: '7304031',
    name: 'Pa Rasangang Baru',
  },
  {
    id: '7304040008',
    districtId: '7304040',
    name: 'Camba-Camba',
  },
  {
    id: '7304040009',
    districtId: '7304040',
    name: 'Maccinibaji',
  },
  {
    id: '7304040010',
    districtId: '7304040',
    name: 'Kaluku',
  },
  {
    id: '7304040011',
    districtId: '7304040',
    name: 'Togo-Togo',
  },
  {
    id: '7304040015',
    districtId: '7304040',
    name: 'Bontoraya',
  },
  {
    id: '7304041001',
    districtId: '7304041',
    name: 'Kampala',
  },
  {
    id: '7304041002',
    districtId: '7304041',
    name: 'Bulo-Bulo',
  },
  {
    id: '7304041003',
    districtId: '7304041',
    name: 'Kalumpang Loe',
  },
  {
    id: '7304041004',
    districtId: '7304041',
    name: 'Palajau',
  },
  {
    id: '7304041005',
    districtId: '7304041',
    name: 'Arungkeke',
  },
  {
    id: '7304041006',
    districtId: '7304041',
    name: 'Borong Lamu',
  },
  {
    id: '7304041007',
    districtId: '7304041',
    name: 'Arungkeke Pallantikang',
  },
  {
    id: '7304042001',
    districtId: '7304042',
    name: 'P A O',
  },
  {
    id: '7304042002',
    districtId: '7304042',
    name: 'Bontorappo',
  },
  {
    id: '7304042003',
    districtId: '7304042',
    name: 'Allu Tarowang',
  },
  {
    id: '7304042004',
    districtId: '7304042',
    name: 'Tarowang',
  },
  {
    id: '7304042005',
    districtId: '7304042',
    name: 'Balang Baru',
  },
  {
    id: '7304042006',
    districtId: '7304042',
    name: 'Balang Loe Tarowang',
  },
  {
    id: '7304042007',
    districtId: '7304042',
    name: 'Bonto Ujung',
  },
  {
    id: '7304042008',
    districtId: '7304042',
    name: 'Tino',
  },
  {
    id: '7304050001',
    districtId: '7304050',
    name: 'Tolo',
  },
  {
    id: '7304050002',
    districtId: '7304050',
    name: 'Tolo Barat',
  },
  {
    id: '7304050003',
    districtId: '7304050',
    name: 'Tolo Selatan',
  },
  {
    id: '7304050004',
    districtId: '7304050',
    name: 'Bontolebang',
  },
  {
    id: '7304050005',
    districtId: '7304050',
    name: 'Samataring',
  },
  {
    id: '7304050006',
    districtId: '7304050',
    name: 'Bonto Nompo',
  },
  {
    id: '7304050007',
    districtId: '7304050',
    name: 'Gantarang',
  },
  {
    id: '7304050008',
    districtId: '7304050',
    name: 'Tombo-Tombolo',
  },
  {
    id: '7304050009',
    districtId: '7304050',
    name: 'Tolo Timur',
  },
  {
    id: '7304050010',
    districtId: '7304050',
    name: 'Tolo Utara',
  },
  {
    id: '7304051001',
    districtId: '7304051',
    name: 'Bontomanai',
  },
  {
    id: '7304051002',
    districtId: '7304051',
    name: 'Rumbia',
  },
  {
    id: '7304051003',
    districtId: '7304051',
    name: 'Lebang Manai',
  },
  {
    id: '7304051004',
    districtId: '7304051',
    name: 'Lebang Manai Utara',
  },
  {
    id: '7304051005',
    districtId: '7304051',
    name: 'Pallantikang',
  },
  {
    id: '7304051006',
    districtId: '7304051',
    name: 'Bonto Cini',
  },
  {
    id: '7304051007',
    districtId: '7304051',
    name: 'Bontotiro',
  },
  {
    id: '7304051008',
    districtId: '7304051',
    name: 'Kassi',
  },
  {
    id: '7304051009',
    districtId: '7304051',
    name: 'Loka',
  },
  {
    id: '7304051010',
    districtId: '7304051',
    name: 'Tompobulu',
  },
  {
    id: '7304051012',
    districtId: '7304051',
    name: 'Jenetallasa',
  },
  {
    id: '7305010001',
    districtId: '7305010',
    name: 'Punaga',
  },
  {
    id: '7305010002',
    districtId: '7305010',
    name: 'Laikang',
  },
  {
    id: '7305010003',
    districtId: '7305010',
    name: 'Cikowang',
  },
  {
    id: '7305010004',
    districtId: '7305010',
    name: 'Pattoppakang',
  },
  {
    id: '7305010005',
    districtId: '7305010',
    name: 'Bontoparang',
  },
  {
    id: '7305010006',
    districtId: '7305010',
    name: 'Panyangkalang',
  },
  {
    id: '7305010007',
    districtId: '7305010',
    name: 'Bontomanai',
  },
  {
    id: '7305010008',
    districtId: '7305010',
    name: 'Lakatong',
  },
  {
    id: '7305010009',
    districtId: '7305010',
    name: 'Topejawa',
  },
  {
    id: '7305010010',
    districtId: '7305010',
    name: 'Banggae',
  },
  {
    id: '7305010011',
    districtId: '7305010',
    name: 'Mangadu',
  },
  {
    id: '7305020001',
    districtId: '7305020',
    name: 'Mattirobaji',
  },
  {
    id: '7305020002',
    districtId: '7305020',
    name: 'Maccinibaji',
  },
  {
    id: '7305020003',
    districtId: '7305020',
    name: 'Takalar Kota',
  },
  {
    id: '7305020004',
    districtId: '7305020',
    name: 'Patani',
  },
  {
    id: '7305020005',
    districtId: '7305020',
    name: 'Soreang',
  },
  {
    id: '7305020006',
    districtId: '7305020',
    name: 'Pa Batangan',
  },
  {
    id: '7305020007',
    districtId: '7305020',
    name: 'Rewataya',
  },
  {
    id: '7305020008',
    districtId: '7305020',
    name: 'Tompo Tana',
  },
  {
    id: '7305020009',
    districtId: '7305020',
    name: 'Balangdatu',
  },
  {
    id: '7305021001',
    districtId: '7305021',
    name: 'Laguruda',
  },
  {
    id: '7305021002',
    districtId: '7305021',
    name: 'Sanrobone',
  },
  {
    id: '7305021003',
    districtId: '7305021',
    name: 'Banyuanyara',
  },
  {
    id: '7305021004',
    districtId: '7305021',
    name: 'Paddinging',
  },
  {
    id: '7305021005',
    districtId: '7305021',
    name: 'Ujung Baji',
  },
  {
    id: '7305021006',
    districtId: '7305021',
    name: 'Tonasa',
  },
  {
    id: '7305030003',
    districtId: '7305030',
    name: "Pa'Bundukang",
  },
  {
    id: '7305030005',
    districtId: '7305030',
    name: 'Canrego',
  },
  {
    id: '7305030006',
    districtId: '7305030',
    name: 'Bontokadatto',
  },
  {
    id: '7305030007',
    districtId: '7305030',
    name: 'Bulukunyi',
  },
  {
    id: '7305030008',
    districtId: '7305030',
    name: 'Cakura',
  },
  {
    id: '7305030009',
    districtId: '7305030',
    name: 'Lantang',
  },
  {
    id: '7305030010',
    districtId: '7305030',
    name: 'Moncongkomba',
  },
  {
    id: '7305030011',
    districtId: '7305030',
    name: "Patte'Ne",
  },
  {
    id: '7305030012',
    districtId: '7305030',
    name: 'Rajaya',
  },
  {
    id: '7305030013',
    districtId: '7305030',
    name: 'Su Rulangi',
  },
  {
    id: '7305031001',
    districtId: '7305031',
    name: 'Pattallassang',
  },
  {
    id: '7305031002',
    districtId: '7305031',
    name: 'Pallantikang',
  },
  {
    id: '7305031003',
    districtId: '7305031',
    name: 'Pappa',
  },
  {
    id: '7305031004',
    districtId: '7305031',
    name: 'Maradekaya',
  },
  {
    id: '7305031005',
    districtId: '7305031',
    name: 'Kalabbirang',
  },
  {
    id: '7305031006',
    districtId: '7305031',
    name: 'Sombala Bella',
  },
  {
    id: '7305031007',
    districtId: '7305031',
    name: 'Bajeng',
  },
  {
    id: '7305031008',
    districtId: '7305031',
    name: 'Sabintang',
  },
  {
    id: '7305031009',
    districtId: '7305031',
    name: 'Salaka',
  },
  {
    id: '7305040003',
    districtId: '7305040',
    name: 'Panrannuangku',
  },
  {
    id: '7305040004',
    districtId: '7305040',
    name: 'Mannongkoki',
  },
  {
    id: '7305040005',
    districtId: '7305040',
    name: 'Malewang',
  },
  {
    id: '7305040006',
    districtId: '7305040',
    name: 'Palleko',
  },
  {
    id: '7305040007',
    districtId: '7305040',
    name: 'Mattompodalle',
  },
  {
    id: '7305040008',
    districtId: '7305040',
    name: 'Parang Luara',
  },
  {
    id: '7305040009',
    districtId: '7305040',
    name: "Pa'Rappunganta",
  },
  {
    id: '7305040010',
    districtId: '7305040',
    name: 'Massamaturu',
  },
  {
    id: '7305040011',
    districtId: '7305040',
    name: 'Timbuseng',
  },
  {
    id: '7305040012',
    districtId: '7305040',
    name: "Ko'Mara",
  },
  {
    id: '7305040013',
    districtId: '7305040',
    name: 'Barugaya',
  },
  {
    id: '7305040014',
    districtId: '7305040',
    name: 'Towata',
  },
  {
    id: '7305040015',
    districtId: '7305040',
    name: 'Kampung Beru',
  },
  {
    id: '7305040016',
    districtId: '7305040',
    name: 'Lassang',
  },
  {
    id: '7305040017',
    districtId: '7305040',
    name: 'Parangbado',
  },
  {
    id: '7305040018',
    districtId: '7305040',
    name: 'Lassang Barat',
  },
  {
    id: '7305040019',
    districtId: '7305040',
    name: 'Balangtanaya',
  },
  {
    id: '7305040020',
    districtId: '7305040',
    name: "Kale Ko'Mara",
  },
  {
    id: '7305050001',
    districtId: '7305050',
    name: 'Mangindara',
  },
  {
    id: '7305050002',
    districtId: '7305050',
    name: 'Bonto Marannu',
  },
  {
    id: '7305050003',
    districtId: '7305050',
    name: 'Baramamase',
  },
  {
    id: '7305050004',
    districtId: '7305050',
    name: 'Bonto Kassi',
  },
  {
    id: '7305050005',
    districtId: '7305050',
    name: 'Sawakong',
  },
  {
    id: '7305050006',
    districtId: '7305050',
    name: 'Bentang',
  },
  {
    id: '7305050007',
    districtId: '7305050',
    name: 'Bontokanang',
  },
  {
    id: '7305050015',
    districtId: '7305050',
    name: 'Popo',
  },
  {
    id: '7305050016',
    districtId: '7305050',
    name: 'Tarowang',
  },
  {
    id: '7305050017',
    districtId: '7305050',
    name: 'Kadatong',
  },
  {
    id: '7305050018',
    districtId: '7305050',
    name: 'Kalebentang',
  },
  {
    id: '7305050019',
    districtId: '7305050',
    name: 'Kaluku Bodo',
  },
  {
    id: '7305051001',
    districtId: '7305051',
    name: 'Bontoloe',
  },
  {
    id: '7305051002',
    districtId: '7305051',
    name: 'Kalenna Bontongape',
  },
  {
    id: '7305051003',
    districtId: '7305051',
    name: 'Bontomangape',
  },
  {
    id: '7305051004',
    districtId: '7305051',
    name: 'Parambambe',
  },
  {
    id: '7305051005',
    districtId: '7305051',
    name: 'Pattinoang',
  },
  {
    id: '7305051006',
    districtId: '7305051',
    name: 'Boddia',
  },
  {
    id: '7305051007',
    districtId: '7305051',
    name: 'Parangmata',
  },
  {
    id: '7305051008',
    districtId: '7305051',
    name: 'Galesong Kota',
  },
  {
    id: '7305051009',
    districtId: '7305051',
    name: 'Galesong Baru',
  },
  {
    id: '7305051010',
    districtId: '7305051',
    name: 'Palalakkang',
  },
  {
    id: '7305051011',
    districtId: '7305051',
    name: 'Parasangang Beru',
  },
  {
    id: '7305051012',
    districtId: '7305051',
    name: 'Kalukuang',
  },
  {
    id: '7305051013',
    districtId: '7305051',
    name: 'Mappakalompo',
  },
  {
    id: '7305051014',
    districtId: '7305051',
    name: 'Campagaya',
  },
  {
    id: '7305060003',
    districtId: '7305060',
    name: 'Bonto Sunggu',
  },
  {
    id: '7305060004',
    districtId: '7305060',
    name: 'Tamasaju',
  },
  {
    id: '7305060005',
    districtId: '7305060',
    name: 'Bontolebang',
  },
  {
    id: '7305060006',
    districtId: '7305060',
    name: 'Tamalate',
  },
  {
    id: '7305060007',
    districtId: '7305060',
    name: 'Aeng Batu-Batu',
  },
  {
    id: '7305060008',
    districtId: '7305060',
    name: 'Bonto Lanra',
  },
  {
    id: '7305060009',
    districtId: '7305060',
    name: 'Pakkabba',
  },
  {
    id: '7305060010',
    districtId: '7305060',
    name: 'Aeng Towa',
  },
  {
    id: '7305060011',
    districtId: '7305060',
    name: 'Sampulungan',
  },
  {
    id: '7305060012',
    districtId: '7305060',
    name: 'Bontokaddopepe',
  },
  {
    id: '7306010008',
    districtId: '7306010',
    name: 'Manjapai',
  },
  {
    id: '7306010010',
    districtId: '7306010',
    name: 'Barembeng',
  },
  {
    id: '7306010011',
    districtId: '7306010',
    name: 'Bontolangkasa Selatan',
  },
  {
    id: '7306010012',
    districtId: '7306010',
    name: 'Bontolangkasa Utara',
  },
  {
    id: '7306010013',
    districtId: '7306010',
    name: 'Kalaserena',
  },
  {
    id: '7306010014',
    districtId: '7306010',
    name: 'Tamallayang',
  },
  {
    id: '7306010015',
    districtId: '7306010',
    name: 'Bontonompo',
  },
  {
    id: '7306010016',
    districtId: '7306010',
    name: 'Bontobiraeng Utara',
  },
  {
    id: '7306010017',
    districtId: '7306010',
    name: 'Romanglasa',
  },
  {
    id: '7306010018',
    districtId: '7306010',
    name: 'Kalebarembeng',
  },
  {
    id: '7306010019',
    districtId: '7306010',
    name: 'Katangka',
  },
  {
    id: '7306010020',
    districtId: '7306010',
    name: 'Bategulung',
  },
  {
    id: '7306010021',
    districtId: '7306010',
    name: 'Bontobiraeng Selatan',
  },
  {
    id: '7306010022',
    districtId: '7306010',
    name: 'Bulogading',
  },
  {
    id: '7306011001',
    districtId: '7306011',
    name: 'Salajangki',
  },
  {
    id: '7306011002',
    districtId: '7306011',
    name: 'Bontosunggu',
  },
  {
    id: '7306011003',
    districtId: '7306011',
    name: 'Pabundukang',
  },
  {
    id: '7306011004',
    districtId: '7306011',
    name: 'Tindang',
  },
  {
    id: '7306011005',
    districtId: '7306011',
    name: 'Tanrara',
  },
  {
    id: '7306011006',
    districtId: '7306011',
    name: 'Salajo',
  },
  {
    id: '7306011007',
    districtId: '7306011',
    name: 'Jipang',
  },
  {
    id: '7306011009',
    districtId: '7306011',
    name: 'Sengka',
  },
  {
    id: '7306011010',
    districtId: '7306011',
    name: 'Bontoramba',
  },
  {
    id: '7306020003',
    districtId: '7306020',
    name: 'Tangkebajeng',
  },
  {
    id: '7306020004',
    districtId: '7306020',
    name: 'Panyangkalang',
  },
  {
    id: '7306020005',
    districtId: '7306020',
    name: 'Pabentengan',
  },
  {
    id: '7306020006',
    districtId: '7306020',
    name: 'Maccinibaji',
  },
  {
    id: '7306020007',
    districtId: '7306020',
    name: 'Kalebajeng',
  },
  {
    id: '7306020008',
    districtId: '7306020',
    name: 'Limbung',
  },
  {
    id: '7306020012',
    districtId: '7306020',
    name: 'Bone',
  },
  {
    id: '7306020013',
    districtId: '7306020',
    name: 'Maradekaya',
  },
  {
    id: '7306020014',
    districtId: '7306020',
    name: 'Lempangang',
  },
  {
    id: '7306020015',
    districtId: '7306020',
    name: 'Bontosunggu',
  },
  {
    id: '7306020016',
    districtId: '7306020',
    name: 'Panciro',
  },
  {
    id: '7306020017',
    districtId: '7306020',
    name: 'Paraikate',
  },
  {
    id: '7306020018',
    districtId: '7306020',
    name: 'Mata Allo',
  },
  {
    id: '7306020019',
    districtId: '7306020',
    name: 'Tubajeng',
  },
  {
    id: '7306021001',
    districtId: '7306021',
    name: 'Gentungang',
  },
  {
    id: '7306021002',
    districtId: '7306021',
    name: 'Tanabangka',
  },
  {
    id: '7306021009',
    districtId: '7306021',
    name: 'Borimatangkasa',
  },
  {
    id: '7306021010',
    districtId: '7306021',
    name: 'Mandalle',
  },
  {
    id: '7306021011',
    districtId: '7306021',
    name: 'Manjalling',
  },
  {
    id: '7306021020',
    districtId: '7306021',
    name: 'Kalemandalle',
  },
  {
    id: '7306021021',
    districtId: '7306021',
    name: 'Bontomanai',
  },
  {
    id: '7306030006',
    districtId: '7306030',
    name: 'Jenetallasa',
  },
  {
    id: '7306030007',
    districtId: '7306030',
    name: 'Tetebatu',
  },
  {
    id: '7306030008',
    districtId: '7306030',
    name: 'Pallangga',
  },
  {
    id: '7306030009',
    districtId: '7306030',
    name: 'Bungaejaya',
  },
  {
    id: '7306030010',
    districtId: '7306030',
    name: 'Panakkukang',
  },
  {
    id: '7306030011',
    districtId: '7306030',
    name: 'Julukanaya',
  },
  {
    id: '7306030012',
    districtId: '7306030',
    name: 'Julubori',
  },
  {
    id: '7306030013',
    districtId: '7306030',
    name: 'Julupamai',
  },
  {
    id: '7306030014',
    districtId: '7306030',
    name: 'Bontoramba',
  },
  {
    id: '7306030015',
    districtId: '7306030',
    name: 'Kampili',
  },
  {
    id: '7306030016',
    districtId: '7306030',
    name: 'Toddotoa',
  },
  {
    id: '7306030017',
    districtId: '7306030',
    name: 'Parang Banoa',
  },
  {
    id: '7306030018',
    districtId: '7306030',
    name: 'Pangkabinanga',
  },
  {
    id: '7306030019',
    districtId: '7306030',
    name: 'Bontoala',
  },
  {
    id: '7306030022',
    districtId: '7306030',
    name: 'Mangalli',
  },
  {
    id: '7306030023',
    districtId: '7306030',
    name: 'Taeng',
  },
  {
    id: '7306031001',
    districtId: '7306031',
    name: 'Biringngalla',
  },
  {
    id: '7306031002',
    districtId: '7306031',
    name: 'Moncobalang',
  },
  {
    id: '7306031003',
    districtId: '7306031',
    name: 'Tinggimae',
  },
  {
    id: '7306031004',
    districtId: '7306031',
    name: 'Lembangparang',
  },
  {
    id: '7306031005',
    districtId: '7306031',
    name: 'Kanjilo',
  },
  {
    id: '7306031006',
    districtId: '7306031',
    name: 'Tamanyeleng',
  },
  {
    id: '7306031007',
    districtId: '7306031',
    name: 'Benteng Somba Opu',
  },
  {
    id: '7306040001',
    districtId: '7306040',
    name: 'Pandang Pandang',
  },
  {
    id: '7306040002',
    districtId: '7306040',
    name: 'Sungguminasa',
  },
  {
    id: '7306040003',
    districtId: '7306040',
    name: 'Tompobalang',
  },
  {
    id: '7306040004',
    districtId: '7306040',
    name: 'Batangkaluku',
  },
  {
    id: '7306040005',
    districtId: '7306040',
    name: 'Tamarunang',
  },
  {
    id: '7306040006',
    districtId: '7306040',
    name: 'Bontoramba',
  },
  {
    id: '7306040007',
    districtId: '7306040',
    name: 'Mawang',
  },
  {
    id: '7306040008',
    districtId: '7306040',
    name: 'Romangpolong',
  },
  {
    id: '7306040009',
    districtId: '7306040',
    name: 'Bonto Bontoa',
  },
  {
    id: '7306040010',
    districtId: '7306040',
    name: 'Kalegowa',
  },
  {
    id: '7306040011',
    districtId: '7306040',
    name: 'Katangka',
  },
  {
    id: '7306040012',
    districtId: '7306040',
    name: 'Tombolo',
  },
  {
    id: '7306040013',
    districtId: '7306040',
    name: 'Paccinongan',
  },
  {
    id: '7306040014',
    districtId: '7306040',
    name: 'Samata',
  },
  {
    id: '7306050001',
    districtId: '7306050',
    name: 'Borongloe',
  },
  {
    id: '7306050002',
    districtId: '7306050',
    name: 'Bontomanai',
  },
  {
    id: '7306050003',
    districtId: '7306050',
    name: 'Sokkolia',
  },
  {
    id: '7306050004',
    districtId: '7306050',
    name: 'Pakatto',
  },
  {
    id: '7306050005',
    districtId: '7306050',
    name: 'Nirannuang',
  },
  {
    id: '7306050006',
    districtId: '7306050',
    name: 'Romangloe',
  },
  {
    id: '7306050012',
    districtId: '7306050',
    name: 'Mata Allo',
  },
  {
    id: '7306050016',
    districtId: '7306050',
    name: 'Romanglompoa',
  },
  {
    id: '7306050017',
    districtId: '7306050',
    name: 'Bili-Bili',
  },
  {
    id: '7306051007',
    districtId: '7306051',
    name: 'Timbuseng',
  },
  {
    id: '7306051008',
    districtId: '7306051',
    name: 'Sunggumanai',
  },
  {
    id: '7306051009',
    districtId: '7306051',
    name: 'Pattalassang',
  },
  {
    id: '7306051010',
    districtId: '7306051',
    name: 'Pallantikang',
  },
  {
    id: '7306051011',
    districtId: '7306051',
    name: 'Pacellekang',
  },
  {
    id: '7306051013',
    districtId: '7306051',
    name: "Borong Pa'Lala",
  },
  {
    id: '7306051014',
    districtId: '7306051',
    name: 'Panaikang',
  },
  {
    id: '7306051015',
    districtId: '7306051',
    name: 'Jenemadinging',
  },
  {
    id: '7306060005',
    districtId: '7306060',
    name: 'Lonjoboko',
  },
  {
    id: '7306060006',
    districtId: '7306060',
    name: 'Borisallo',
  },
  {
    id: '7306060007',
    districtId: '7306060',
    name: 'Lanna',
  },
  {
    id: '7306060008',
    districtId: '7306060',
    name: 'Bontoparang',
  },
  {
    id: '7306060009',
    districtId: '7306060',
    name: 'Belapunranga',
  },
  {
    id: '7306060010',
    districtId: '7306060',
    name: 'Bontokassi',
  },
  {
    id: '7306060011',
    districtId: '7306060',
    name: 'Belabori',
  },
  {
    id: '7306061001',
    districtId: '7306061',
    name: 'Pattallikang',
  },
  {
    id: '7306061002',
    districtId: '7306061',
    name: 'Moncongloe',
  },
  {
    id: '7306061003',
    districtId: '7306061',
    name: 'Manuju',
  },
  {
    id: '7306061004',
    districtId: '7306061',
    name: 'Tamalatea',
  },
  {
    id: '7306061010',
    districtId: '7306061',
    name: 'Bilalang',
  },
  {
    id: '7306061011',
    districtId: '7306061',
    name: 'Tassese',
  },
  {
    id: '7306061012',
    districtId: '7306061',
    name: 'Tana Karaeng',
  },
  {
    id: '7306070006',
    districtId: '7306070',
    name: 'Parigi',
  },
  {
    id: '7306070007',
    districtId: '7306070',
    name: 'Bulutana',
  },
  {
    id: '7306070008',
    districtId: '7306070',
    name: 'Malino',
  },
  {
    id: '7306070009',
    districtId: '7306070',
    name: 'Gantarang',
  },
  {
    id: '7306070010',
    districtId: '7306070',
    name: 'Pattapang',
  },
  {
    id: '7306070011',
    districtId: '7306070',
    name: 'Bonto Lerung',
  },
  {
    id: '7306070012',
    districtId: '7306070',
    name: 'Garassi',
  },
  {
    id: '7306071001',
    districtId: '7306071',
    name: 'Kanreapia',
  },
  {
    id: '7306071002',
    districtId: '7306071',
    name: 'Balassuka',
  },
  {
    id: '7306071003',
    districtId: '7306071',
    name: 'Tabbinjai',
  },
  {
    id: '7306071004',
    districtId: '7306071',
    name: 'Mamampang',
  },
  {
    id: '7306071005',
    districtId: '7306071',
    name: 'Tonasa',
  },
  {
    id: '7306071006',
    districtId: '7306071',
    name: 'Tamaona',
  },
  {
    id: '7306071007',
    districtId: '7306071',
    name: 'Pao',
  },
  {
    id: '7306071008',
    districtId: '7306071',
    name: 'Erelembang',
  },
  {
    id: '7306071009',
    districtId: '7306071',
    name: 'Bolaromang',
  },
  {
    id: '7306072001',
    districtId: '7306072',
    name: 'Sicini',
  },
  {
    id: '7306072002',
    districtId: '7306072',
    name: 'Bilanrengi',
  },
  {
    id: '7306072003',
    districtId: '7306072',
    name: 'Manimbahoi',
  },
  {
    id: '7306072004',
    districtId: '7306072',
    name: 'Majannang',
  },
  {
    id: '7306072005',
    districtId: '7306072',
    name: 'Jonjo',
  },
  {
    id: '7306080003',
    districtId: '7306080',
    name: 'Bissoloro',
  },
  {
    id: '7306080004',
    districtId: '7306080',
    name: 'Buakkang',
  },
  {
    id: '7306080005',
    districtId: '7306080',
    name: 'Bontomanai',
  },
  {
    id: '7306080006',
    districtId: '7306080',
    name: 'Sapaya',
  },
  {
    id: '7306080015',
    districtId: '7306080',
    name: 'Rannaloe',
  },
  {
    id: '7306080016',
    districtId: '7306080',
    name: 'Mangempang',
  },
  {
    id: '7306080017',
    districtId: '7306080',
    name: 'Jenebatu',
  },
  {
    id: '7306081007',
    districtId: '7306081',
    name: 'Paladingang',
  },
  {
    id: '7306081008',
    districtId: '7306081',
    name: 'Bontoloe',
  },
  {
    id: '7306081009',
    districtId: '7306081',
    name: 'Lassa Lassa',
  },
  {
    id: '7306081010',
    districtId: '7306081',
    name: 'Bontolempangan',
  },
  {
    id: '7306081011',
    districtId: '7306081',
    name: 'Julumatene',
  },
  {
    id: '7306081012',
    districtId: '7306081',
    name: 'Parang Lampoa',
  },
  {
    id: '7306081013',
    districtId: '7306081',
    name: 'Bontotangnga',
  },
  {
    id: '7306081014',
    districtId: '7306081',
    name: 'Ulujangan',
  },
  {
    id: '7306090005',
    districtId: '7306090',
    name: 'Garing',
  },
  {
    id: '7306090006',
    districtId: '7306090',
    name: 'Bontobuddung',
  },
  {
    id: '7306090007',
    districtId: '7306090',
    name: 'Tanete',
  },
  {
    id: '7306090008',
    districtId: '7306090',
    name: 'Cikoro',
  },
  {
    id: '7306090009',
    districtId: '7306090',
    name: 'Rappolemba',
  },
  {
    id: '7306090010',
    districtId: '7306090',
    name: 'Rappoala',
  },
  {
    id: '7306090011',
    districtId: '7306090',
    name: 'Malakaji',
  },
  {
    id: '7306090012',
    districtId: '7306090',
    name: 'Datara',
  },
  {
    id: '7306091001',
    districtId: '7306091',
    name: 'Berutallasa',
  },
  {
    id: '7306091002',
    districtId: '7306091',
    name: 'Pencong',
  },
  {
    id: '7306091003',
    districtId: '7306091',
    name: 'Parangloe',
  },
  {
    id: '7306091004',
    districtId: '7306091',
    name: 'Lembangloe',
  },
  {
    id: '7306091005',
    districtId: '7306091',
    name: 'Taring',
  },
  {
    id: '7306091006',
    districtId: '7306091',
    name: 'Tonrorita',
  },
  {
    id: '7306091007',
    districtId: '7306091',
    name: 'Borimasunggu',
  },
  {
    id: '7306091008',
    districtId: '7306091',
    name: 'Lauwa',
  },
  {
    id: '7306091009',
    districtId: '7306091',
    name: 'Baturappe',
  },
  {
    id: '7306091010',
    districtId: '7306091',
    name: 'Batumalonro',
  },
  {
    id: '7306091011',
    districtId: '7306091',
    name: 'Julukanaya',
  },
  {
    id: '7307010001',
    districtId: '7307010',
    name: 'Gunung Perak',
  },
  {
    id: '7307010002',
    districtId: '7307010',
    name: 'Balakia',
  },
  {
    id: '7307010003',
    districtId: '7307010',
    name: 'Tassililu',
  },
  {
    id: '7307010004',
    districtId: '7307010',
    name: 'Arabika',
  },
  {
    id: '7307010005',
    districtId: '7307010',
    name: 'Barania',
  },
  {
    id: '7307010006',
    districtId: '7307010',
    name: 'Boto Lempangan',
  },
  {
    id: '7307010007',
    districtId: '7307010',
    name: 'Bonto Salama',
  },
  {
    id: '7307010008',
    districtId: '7307010',
    name: 'Turungan Baji',
  },
  {
    id: '7307010009',
    districtId: '7307010',
    name: 'Terasa',
  },
  {
    id: '7307020001',
    districtId: '7307020',
    name: 'Batu Belerang',
  },
  {
    id: '7307020002',
    districtId: '7307020',
    name: 'Kassi Buleng',
  },
  {
    id: '7307020003',
    districtId: '7307020',
    name: 'Pasir Putih',
  },
  {
    id: '7307020004',
    districtId: '7307020',
    name: 'Bonto Sinala',
  },
  {
    id: '7307020005',
    districtId: '7307020',
    name: 'Biji Nangka',
  },
  {
    id: '7307020006',
    districtId: '7307020',
    name: 'Barambang',
  },
  {
    id: '7307020007',
    districtId: '7307020',
    name: 'Bonto Katute',
  },
  {
    id: '7307020008',
    districtId: '7307020',
    name: 'Bonto Tengnga',
  },
  {
    id: '7307030001',
    districtId: '7307030',
    name: 'Palangka',
  },
  {
    id: '7307030002',
    districtId: '7307030',
    name: 'Sangiasseri',
  },
  {
    id: '7307030003',
    districtId: '7307030',
    name: 'Puncak',
  },
  {
    id: '7307030004',
    districtId: '7307030',
    name: 'Polewali',
  },
  {
    id: '7307030005',
    districtId: '7307030',
    name: 'Songing',
  },
  {
    id: '7307030007',
    districtId: '7307030',
    name: 'Aska',
  },
  {
    id: '7307030008',
    districtId: '7307030',
    name: 'Palae',
  },
  {
    id: '7307030009',
    districtId: '7307030',
    name: 'Talle',
  },
  {
    id: '7307030010',
    districtId: '7307030',
    name: 'Bulu Kamase',
  },
  {
    id: '7307030011',
    districtId: '7307030',
    name: 'Alenangka',
  },
  {
    id: '7307030012',
    districtId: '7307030',
    name: 'Gareccing',
  },
  {
    id: '7307040001',
    districtId: '7307040',
    name: 'Kalobba',
  },
  {
    id: '7307040002',
    districtId: '7307040',
    name: 'Mannanti',
  },
  {
    id: '7307040003',
    districtId: '7307040',
    name: 'Tellu Limpoe',
  },
  {
    id: '7307040004',
    districtId: '7307040',
    name: 'Erabaru',
  },
  {
    id: '7307040005',
    districtId: '7307040',
    name: 'Pattongko',
  },
  {
    id: '7307040006',
    districtId: '7307040',
    name: 'Bua',
  },
  {
    id: '7307040007',
    districtId: '7307040',
    name: 'Sukamaju',
  },
  {
    id: '7307040008',
    districtId: '7307040',
    name: 'Lembang Lohe',
  },
  {
    id: '7307040009',
    districtId: '7307040',
    name: 'Saotengah',
  },
  {
    id: '7307040010',
    districtId: '7307040',
    name: 'Massaile',
  },
  {
    id: '7307040011',
    districtId: '7307040',
    name: 'Samaturue',
  },
  {
    id: '7307050001',
    districtId: '7307050',
    name: 'Biroro',
  },
  {
    id: '7307050002',
    districtId: '7307050',
    name: 'Lasiai',
  },
  {
    id: '7307050003',
    districtId: '7307050',
    name: 'Sanjai',
  },
  {
    id: '7307050004',
    districtId: '7307050',
    name: 'Pasimarannu',
  },
  {
    id: '7307050005',
    districtId: '7307050',
    name: 'Pattalassang',
  },
  {
    id: '7307050006',
    districtId: '7307050',
    name: 'Panaikang',
  },
  {
    id: '7307050007',
    districtId: '7307050',
    name: 'Samataring',
  },
  {
    id: '7307050008',
    districtId: '7307050',
    name: 'Kaloling',
  },
  {
    id: '7307050009',
    districtId: '7307050',
    name: 'Saukang',
  },
  {
    id: '7307050010',
    districtId: '7307050',
    name: 'Kampala',
  },
  {
    id: '7307050011',
    districtId: '7307050',
    name: 'Tongke-Tongke',
  },
  {
    id: '7307050012',
    districtId: '7307050',
    name: 'Salohe',
  },
  {
    id: '7307050013',
    districtId: '7307050',
    name: 'Bongki Lengkese',
  },
  {
    id: '7307060001',
    districtId: '7307060',
    name: 'Kompang',
  },
  {
    id: '7307060002',
    districtId: '7307060',
    name: 'Saotanre',
  },
  {
    id: '7307060003',
    districtId: '7307060',
    name: 'Baru',
  },
  {
    id: '7307060004',
    districtId: '7307060',
    name: 'Saotengnga',
  },
  {
    id: '7307060005',
    districtId: '7307060',
    name: 'Pattongko',
  },
  {
    id: '7307060006',
    districtId: '7307060',
    name: 'Bonto',
  },
  {
    id: '7307060007',
    districtId: '7307060',
    name: 'Saohiring',
  },
  {
    id: '7307060008',
    districtId: '7307060',
    name: 'Kanrung',
  },
  {
    id: '7307060009',
    districtId: '7307060',
    name: 'Samaenre',
  },
  {
    id: '7307060010',
    districtId: '7307060',
    name: 'Mattunreng Tellue',
  },
  {
    id: '7307060011',
    districtId: '7307060',
    name: 'Gantarang',
  },
  {
    id: '7307070001',
    districtId: '7307070',
    name: 'Alewanuae',
  },
  {
    id: '7307070002',
    districtId: '7307070',
    name: 'Biringere',
  },
  {
    id: '7307070003',
    districtId: '7307070',
    name: 'Lamatti Rilau',
  },
  {
    id: '7307070004',
    districtId: '7307070',
    name: 'Bongki',
  },
  {
    id: '7307070005',
    districtId: '7307070',
    name: 'Balangnipa',
  },
  {
    id: '7307070006',
    districtId: '7307070',
    name: 'Lappa',
  },
  {
    id: '7307080001',
    districtId: '7307080',
    name: 'Tompobulu',
  },
  {
    id: '7307080003',
    districtId: '7307080',
    name: 'Duampanuae',
  },
  {
    id: '7307080004',
    districtId: '7307080',
    name: 'Lamatti Riattang',
  },
  {
    id: '7307080005',
    districtId: '7307080',
    name: 'Lamatti Riaja',
  },
  {
    id: '7307080006',
    districtId: '7307080',
    name: 'Lamatti Riawang',
  },
  {
    id: '7307080007',
    districtId: '7307080',
    name: 'Lappa Cinrana',
  },
  {
    id: '7307090001',
    districtId: '7307090',
    name: 'Pulau Buhung Pitue',
  },
  {
    id: '7307090002',
    districtId: '7307090',
    name: 'Pulau Harapan',
  },
  {
    id: '7307090003',
    districtId: '7307090',
    name: 'Pulau Padaelo',
  },
  {
    id: '7307090004',
    districtId: '7307090',
    name: 'Pulau Persatuan',
  },
  {
    id: '7308010006',
    districtId: '7308010',
    name: 'Pattontongan',
  },
  {
    id: '7308010007',
    districtId: '7308010',
    name: 'Baji Mangngai',
  },
  {
    id: '7308010008',
    districtId: '7308010',
    name: 'Tenrigangkae',
  },
  {
    id: '7308010009',
    districtId: '7308010',
    name: 'Bonto Matene',
  },
  {
    id: '7308010010',
    districtId: '7308010',
    name: 'Bontoa',
  },
  {
    id: '7308010011',
    districtId: '7308010',
    name: 'Hasanuddin',
  },
  {
    id: '7308011001',
    districtId: '7308011',
    name: 'Moncongloe Lappara',
  },
  {
    id: '7308011002',
    districtId: '7308011',
    name: 'Moncongloe Bulu',
  },
  {
    id: '7308011003',
    districtId: '7308011',
    name: 'Moncongloe',
  },
  {
    id: '7308011004',
    districtId: '7308011',
    name: 'Bonto Bunga',
  },
  {
    id: '7308011005',
    districtId: '7308011',
    name: 'Bonto Marannu',
  },
  {
    id: '7308020005',
    districtId: '7308020',
    name: 'Pallantikang',
  },
  {
    id: '7308020013',
    districtId: '7308020',
    name: 'Baju Bodoa',
  },
  {
    id: '7308020014',
    districtId: '7308020',
    name: 'Baji Pamai',
  },
  {
    id: '7308020015',
    districtId: '7308020',
    name: 'Bori Kamase',
  },
  {
    id: '7308020019',
    districtId: '7308020',
    name: 'Borimasunggu',
  },
  {
    id: '7308020020',
    districtId: '7308020',
    name: 'Majannang',
  },
  {
    id: '7308020021',
    districtId: '7308020',
    name: 'Mattiro Tasi',
  },
  {
    id: '7308021001',
    districtId: '7308021',
    name: 'Pabentengan',
  },
  {
    id: '7308021002',
    districtId: '7308021',
    name: 'Temappadduae',
  },
  {
    id: '7308021003',
    districtId: '7308021',
    name: 'Marumpa',
  },
  {
    id: '7308021004',
    districtId: '7308021',
    name: 'Tellumpoccoe',
  },
  {
    id: '7308021005',
    districtId: '7308021',
    name: 'Bonto Matene',
  },
  {
    id: '7308021006',
    districtId: '7308021',
    name: "A'Bulosibatang",
  },
  {
    id: '7308021007',
    districtId: '7308021',
    name: 'Nisombalia',
  },
  {
    id: '7308022001',
    districtId: '7308022',
    name: 'Taroada',
  },
  {
    id: '7308022002',
    districtId: '7308022',
    name: 'Adatongeng',
  },
  {
    id: '7308022003',
    districtId: '7308022',
    name: 'Pettuadae',
  },
  {
    id: '7308022004',
    districtId: '7308022',
    name: 'Bori Bellaya',
  },
  {
    id: '7308022005',
    districtId: '7308022',
    name: 'R A Y A',
  },
  {
    id: '7308022006',
    districtId: '7308022',
    name: 'Turikale',
  },
  {
    id: '7308022007',
    districtId: '7308022',
    name: 'Alliritengae',
  },
  {
    id: '7308023001',
    districtId: '7308023',
    name: 'Allepolea',
  },
  {
    id: '7308023002',
    districtId: '7308023',
    name: 'Soreang',
  },
  {
    id: '7308023003',
    districtId: '7308023',
    name: 'Marrannu',
  },
  {
    id: '7308023004',
    districtId: '7308023',
    name: 'Bonto Marannu',
  },
  {
    id: '7308023005',
    districtId: '7308023',
    name: 'Maccini Baji',
  },
  {
    id: '7308023006',
    districtId: '7308023',
    name: 'Mattiro Deceng',
  },
  {
    id: '7308030003',
    districtId: '7308030',
    name: 'Bonto Bahari',
  },
  {
    id: '7308030004',
    districtId: '7308030',
    name: 'Pajukukang',
  },
  {
    id: '7308030005',
    districtId: '7308030',
    name: 'Tunikamaseang',
  },
  {
    id: '7308030006',
    districtId: '7308030',
    name: 'Bontoa',
  },
  {
    id: '7308030007',
    districtId: '7308030',
    name: 'Salenrang',
  },
  {
    id: '7308030008',
    districtId: '7308030',
    name: 'Bonto Lempangan',
  },
  {
    id: '7308030009',
    districtId: '7308030',
    name: 'Minasa Upa',
  },
  {
    id: '7308030010',
    districtId: '7308030',
    name: 'Tupabiring',
  },
  {
    id: '7308030011',
    districtId: '7308030',
    name: 'Ampekale',
  },
  {
    id: '7308040007',
    districtId: '7308040',
    name: 'Kalabbirang',
  },
  {
    id: '7308040008',
    districtId: '7308040',
    name: 'Minasa Baji',
  },
  {
    id: '7308040009',
    districtId: '7308040',
    name: 'Alatengae',
  },
  {
    id: '7308040010',
    districtId: '7308040',
    name: 'Mattoangin',
  },
  {
    id: '7308040011',
    districtId: '7308040',
    name: 'Mangeloreng',
  },
  {
    id: '7308040012',
    districtId: '7308040',
    name: 'Leang-Leang',
  },
  {
    id: '7308040013',
    districtId: '7308040',
    name: 'Tukamasea',
  },
  {
    id: '7308040014',
    districtId: '7308040',
    name: 'Baruga',
  },
  {
    id: '7308041001',
    districtId: '7308041',
    name: 'Bonto Tallasa',
  },
  {
    id: '7308041002',
    districtId: '7308041',
    name: 'Tanete',
  },
  {
    id: '7308041003',
    districtId: '7308041',
    name: 'Simbang',
  },
  {
    id: '7308041004',
    districtId: '7308041',
    name: 'Jenetaesa',
  },
  {
    id: '7308041005',
    districtId: '7308041',
    name: 'Sambueja',
  },
  {
    id: '7308041006',
    districtId: '7308041',
    name: 'Samangki',
  },
  {
    id: '7308050002',
    districtId: '7308050',
    name: 'Purna Karya',
  },
  {
    id: '7308050003',
    districtId: '7308050',
    name: 'Leko Pancing',
  },
  {
    id: '7308050004',
    districtId: '7308050',
    name: 'Kuru Sumange',
  },
  {
    id: '7308050005',
    districtId: '7308050',
    name: 'Sudirman',
  },
  {
    id: '7308050006',
    districtId: '7308050',
    name: 'Damai',
  },
  {
    id: '7308050007',
    districtId: '7308050',
    name: 'Allaere',
  },
  {
    id: '7308050008',
    districtId: '7308050',
    name: 'Borong',
  },
  {
    id: '7308050009',
    districtId: '7308050',
    name: 'Toddo Pulia',
  },
  {
    id: '7308051001',
    districtId: '7308051',
    name: 'Benteng Gajah',
  },
  {
    id: '7308051002',
    districtId: '7308051',
    name: 'Pucak',
  },
  {
    id: '7308051003',
    districtId: '7308051',
    name: 'Tompo Bulu',
  },
  {
    id: '7308051004',
    districtId: '7308051',
    name: 'Toddolimae',
  },
  {
    id: '7308051005',
    districtId: '7308051',
    name: 'Bonto Manai',
  },
  {
    id: '7308051006',
    districtId: '7308051',
    name: 'Bontomatinggi',
  },
  {
    id: '7308051007',
    districtId: '7308051',
    name: 'Bonto Manurung',
  },
  {
    id: '7308051008',
    districtId: '7308051',
    name: 'Bonto Somba',
  },
  {
    id: '7308060008',
    districtId: '7308060',
    name: 'Cenrana',
  },
  {
    id: '7308060009',
    districtId: '7308060',
    name: 'Timpuseng',
  },
  {
    id: '7308060010',
    districtId: '7308060',
    name: 'Pattiro Deceng',
  },
  {
    id: '7308060011',
    districtId: '7308060',
    name: 'Cempaniga',
  },
  {
    id: '7308060012',
    districtId: '7308060',
    name: 'Sawaru',
  },
  {
    id: '7308060014',
    districtId: '7308060',
    name: 'Mario Pulana',
  },
  {
    id: '7308060015',
    districtId: '7308060',
    name: 'Pattanyamang',
  },
  {
    id: '7308061001',
    districtId: '7308061',
    name: 'Labuaja',
  },
  {
    id: '7308061002',
    districtId: '7308061',
    name: 'Lebbotengngae',
  },
  {
    id: '7308061003',
    districtId: '7308061',
    name: 'Laiya',
  },
  {
    id: '7308061004',
    districtId: '7308061',
    name: 'Cenrana Baru',
  },
  {
    id: '7308061005',
    districtId: '7308061',
    name: 'Limam Poccoe',
  },
  {
    id: '7308061006',
    districtId: '7308061',
    name: 'Rompe Gading',
  },
  {
    id: '7308061007',
    districtId: '7308061',
    name: 'Baji Pamai',
  },
  {
    id: '7308070001',
    districtId: '7308070',
    name: 'Padaelo',
  },
  {
    id: '7308070002',
    districtId: '7308070',
    name: 'Barugae',
  },
  {
    id: '7308070004',
    districtId: '7308070',
    name: 'Tellumpanuae',
  },
  {
    id: '7308070005',
    districtId: '7308070',
    name: 'Sabila',
  },
  {
    id: '7308070006',
    districtId: '7308070',
    name: 'Mattampapole',
  },
  {
    id: '7308070007',
    districtId: '7308070',
    name: 'Batu Putih',
  },
  {
    id: '7308070008',
    districtId: '7308070',
    name: 'Uludaya',
  },
  {
    id: '7308070009',
    districtId: '7308070',
    name: 'Samaenre',
  },
  {
    id: '7308070010',
    districtId: '7308070',
    name: 'Gattareng Matinggi',
  },
  {
    id: '7308070011',
    districtId: '7308070',
    name: 'Wanua Waru',
  },
  {
    id: '7309010001',
    districtId: '7309010',
    name: 'Sabalana',
  },
  {
    id: '7309010002',
    districtId: '7309010',
    name: 'Balo Baloang',
  },
  {
    id: '7309010003',
    districtId: '7309010',
    name: 'Sabaru',
  },
  {
    id: '7309010004',
    districtId: '7309010',
    name: 'Sapuka',
  },
  {
    id: '7309010005',
    districtId: '7309010',
    name: 'Tampaang',
  },
  {
    id: '7309010006',
    districtId: '7309010',
    name: 'Sailus',
  },
  {
    id: '7309010007',
    districtId: '7309010',
    name: 'Satanger',
  },
  {
    id: '7309010008',
    districtId: '7309010',
    name: 'Kapoposan Bali',
  },
  {
    id: '7309010009',
    districtId: '7309010',
    name: 'Poleonro',
  },
  {
    id: '7309020001',
    districtId: '7309020',
    name: 'Doang Doangan',
  },
  {
    id: '7309020002',
    districtId: '7309020',
    name: 'Dewakang',
  },
  {
    id: '7309020003',
    districtId: '7309020',
    name: 'Marasende',
  },
  {
    id: '7309020004',
    districtId: '7309020',
    name: 'Kanyurang',
  },
  {
    id: '7309020005',
    districtId: '7309020',
    name: 'Kalu-Kalukuang',
  },
  {
    id: '7309020006',
    districtId: '7309020',
    name: 'Sabaru',
  },
  {
    id: '7309020007',
    districtId: '7309020',
    name: 'Pammantauan Masalima',
  },
  {
    id: '7309030001',
    districtId: '7309030',
    name: 'Mattiro Deceng',
  },
  {
    id: '7309030002',
    districtId: '7309030',
    name: 'Mattiro Sompe',
  },
  {
    id: '7309030003',
    districtId: '7309030',
    name: 'Mattiro Bone',
  },
  {
    id: '7309030004',
    districtId: '7309030',
    name: 'Mattiro Dolangeng',
  },
  {
    id: '7309030012',
    districtId: '7309030',
    name: 'Mattiro Langi',
  },
  {
    id: '7309030013',
    districtId: '7309030',
    name: 'Mattiro Matae',
  },
  {
    id: '7309030014',
    districtId: '7309030',
    name: 'Mattiro Ujung',
  },
  {
    id: '7309030015',
    districtId: '7309030',
    name: 'Mattaro Adae',
  },
  {
    id: '7309030016',
    districtId: '7309030',
    name: 'Mattiro Bintang',
  },
  {
    id: '7309031001',
    districtId: '7309031',
    name: 'Mattiro Bulu',
  },
  {
    id: '7309031002',
    districtId: '7309031',
    name: 'Mattiro Labangeng',
  },
  {
    id: '7309031003',
    districtId: '7309031',
    name: 'Mattiro Uleng',
  },
  {
    id: '7309031004',
    districtId: '7309031',
    name: 'Mattiro Kanja',
  },
  {
    id: '7309031005',
    districtId: '7309031',
    name: 'Mattiro Baji',
  },
  {
    id: '7309031006',
    districtId: '7309031',
    name: 'Mattiro Bombang',
  },
  {
    id: '7309031007',
    districtId: '7309031',
    name: 'Mattiro Walie',
  },
  {
    id: '7309040007',
    districtId: '7309040',
    name: 'Sibatua',
  },
  {
    id: '7309040008',
    districtId: '7309040',
    name: 'Bonto Perak',
  },
  {
    id: '7309040009',
    districtId: '7309040',
    name: 'Anrong Appaka',
  },
  {
    id: '7309040010',
    districtId: '7309040',
    name: 'Tekolabbua',
  },
  {
    id: '7309040011',
    districtId: '7309040',
    name: 'Jagong',
  },
  {
    id: '7309040012',
    districtId: '7309040',
    name: 'Tumampua',
  },
  {
    id: '7309040013',
    districtId: '7309040',
    name: 'Paddoang Doangan',
  },
  {
    id: '7309040016',
    districtId: '7309040',
    name: 'Pabundukang',
  },
  {
    id: '7309040017',
    districtId: '7309040',
    name: 'Mappasaile',
  },
  {
    id: '7309041001',
    districtId: '7309041',
    name: 'Bonto Langkasa',
  },
  {
    id: '7309041002',
    districtId: '7309041',
    name: 'Kabba',
  },
  {
    id: '7309041003',
    districtId: '7309041',
    name: 'Panaikang',
  },
  {
    id: '7309041004',
    districtId: '7309041',
    name: 'Bontokio',
  },
  {
    id: '7309041005',
    districtId: '7309041',
    name: 'Biraeng',
  },
  {
    id: '7309041006',
    districtId: '7309041',
    name: 'Minasatene',
  },
  {
    id: '7309041007',
    districtId: '7309041',
    name: 'Kalabbirang',
  },
  {
    id: '7309041008',
    districtId: '7309041',
    name: 'Bontoa',
  },
  {
    id: '7309050001',
    districtId: '7309050',
    name: 'Kassi',
  },
  {
    id: '7309050002',
    districtId: '7309050',
    name: 'Tonasa',
  },
  {
    id: '7309050003',
    districtId: '7309050',
    name: 'Balocci Baru',
  },
  {
    id: '7309050004',
    districtId: '7309050',
    name: 'Balleangin',
  },
  {
    id: '7309050005',
    districtId: '7309050',
    name: 'Tompo Bulu',
  },
  {
    id: '7309051002',
    districtId: '7309051',
    name: 'Malaka',
  },
  {
    id: '7309051003',
    districtId: '7309051',
    name: 'Bantimurung',
  },
  {
    id: '7309051004',
    districtId: '7309051',
    name: 'Tondongkura',
  },
  {
    id: '7309051005',
    districtId: '7309051',
    name: 'Lanne',
  },
  {
    id: '7309051006',
    districtId: '7309051',
    name: 'Bonto Birao',
  },
  {
    id: '7309060001',
    districtId: '7309060',
    name: 'Boriappaka',
  },
  {
    id: '7309060002',
    districtId: '7309060',
    name: 'Bulu Cindea',
  },
  {
    id: '7309060003',
    districtId: '7309060',
    name: 'Bowong Cindea',
  },
  {
    id: '7309060004',
    districtId: '7309060',
    name: 'Samalewa',
  },
  {
    id: '7309060005',
    districtId: '7309060',
    name: 'Sapanang',
  },
  {
    id: '7309060006',
    districtId: '7309060',
    name: 'Biring Ere',
  },
  {
    id: '7309060007',
    districtId: '7309060',
    name: 'Mangilu',
  },
  {
    id: '7309060009',
    districtId: '7309060',
    name: 'Tabo-Tabo',
  },
  {
    id: '7309070001',
    districtId: '7309070',
    name: 'Borimasunggu',
  },
  {
    id: '7309070002',
    districtId: '7309070',
    name: 'Mangallekana',
  },
  {
    id: '7309070003',
    districtId: '7309070',
    name: 'Batara',
  },
  {
    id: '7309070004',
    districtId: '7309070',
    name: 'Taraweang',
  },
  {
    id: '7309070005',
    districtId: '7309070',
    name: 'Bara Batu',
  },
  {
    id: '7309070006',
    districtId: '7309070',
    name: 'Kassi Loe',
  },
  {
    id: '7309070007',
    districtId: '7309070',
    name: 'Patallassang',
  },
  {
    id: '7309070008',
    districtId: '7309070',
    name: 'Labakkang',
  },
  {
    id: '7309070009',
    districtId: '7309070',
    name: 'Pundata Baji',
  },
  {
    id: '7309070010',
    districtId: '7309070',
    name: 'Bonto Manai',
  },
  {
    id: '7309070011',
    districtId: '7309070',
    name: 'Manakku',
  },
  {
    id: '7309070013',
    districtId: '7309070',
    name: 'Kanaungan',
  },
  {
    id: '7309080001',
    districtId: '7309080',
    name: 'Talaka',
  },
  {
    id: '7309080002',
    districtId: '7309080',
    name: 'Attang Salo',
  },
  {
    id: '7309080003',
    districtId: '7309080',
    name: 'Padang Lampe',
  },
  {
    id: '7309080004',
    districtId: '7309080',
    name: 'Alesipitto',
  },
  {
    id: '7309080005',
    districtId: '7309080',
    name: 'Ma`Rang',
  },
  {
    id: '7309080006',
    districtId: '7309080',
    name: 'Bonto-Bonto',
  },
  {
    id: '7309080007',
    districtId: '7309080',
    name: 'Pitue',
  },
  {
    id: '7309080008',
    districtId: '7309080',
    name: 'Pitu Sunggu',
  },
  {
    id: '7309080009',
    districtId: '7309080',
    name: 'Tamangapa',
  },
  {
    id: '7309080010',
    districtId: '7309080',
    name: 'Punranga',
  },
  {
    id: '7309091001',
    districtId: '7309091',
    name: 'Bonto Matene',
  },
  {
    id: '7309091002',
    districtId: '7309091',
    name: 'Baring',
  },
  {
    id: '7309091003',
    districtId: '7309091',
    name: 'Parenreng',
  },
  {
    id: '7309091004',
    districtId: '7309091',
    name: 'Segeri',
  },
  {
    id: '7309091005',
    districtId: '7309091',
    name: 'Bawasalo',
  },
  {
    id: '7309091006',
    districtId: '7309091',
    name: 'Bone',
  },
  {
    id: '7309092002',
    districtId: '7309092',
    name: 'Manggalung',
  },
  {
    id: '7309092003',
    districtId: '7309092',
    name: 'Boddie',
  },
  {
    id: '7309092004',
    districtId: '7309092',
    name: 'Tamarupa',
  },
  {
    id: '7309092005',
    districtId: '7309092',
    name: 'Coppo Tompong',
  },
  {
    id: '7309092006',
    districtId: '7309092',
    name: 'Mandalle',
  },
  {
    id: '7310010006',
    districtId: '7310010',
    name: 'Mattirowalie',
  },
  {
    id: '7310010008',
    districtId: '7310010',
    name: 'Harapan',
  },
  {
    id: '7310010009',
    districtId: '7310010',
    name: 'Lompo Riaja',
  },
  {
    id: '7310010010',
    districtId: '7310010',
    name: 'Libureng',
  },
  {
    id: '7310010011',
    districtId: '7310010',
    name: 'Kading',
  },
  {
    id: '7310010012',
    districtId: '7310010',
    name: 'Lompo Tengah',
  },
  {
    id: '7310010013',
    districtId: '7310010',
    name: 'Lempang',
  },
  {
    id: '7310011001',
    districtId: '7310011',
    name: 'Bulo-Bulo',
  },
  {
    id: '7310011002',
    districtId: '7310011',
    name: 'Gattareng',
  },
  {
    id: '7310011003',
    districtId: '7310011',
    name: 'Pujananting',
  },
  {
    id: '7310011004',
    districtId: '7310011',
    name: 'Jangan-Jangan',
  },
  {
    id: '7310011005',
    districtId: '7310011',
    name: 'Pattappa',
  },
  {
    id: '7310011006',
    districtId: '7310011',
    name: 'Bacu-Bacu',
  },
  {
    id: '7310011007',
    districtId: '7310011',
    name: 'Mattappawalie',
  },
  {
    id: '7310020001',
    districtId: '7310020',
    name: 'Lasitae',
  },
  {
    id: '7310020002',
    districtId: '7310020',
    name: 'Pancana',
  },
  {
    id: '7310020003',
    districtId: '7310020',
    name: 'Lalabata',
  },
  {
    id: '7310020004',
    districtId: '7310020',
    name: 'Corawali',
  },
  {
    id: '7310020005',
    districtId: '7310020',
    name: 'Pao-Pao',
  },
  {
    id: '7310020006',
    districtId: '7310020',
    name: 'Tellumpanua',
  },
  {
    id: '7310020007',
    districtId: '7310020',
    name: 'Lalolang',
  },
  {
    id: '7310020008',
    districtId: '7310020',
    name: 'Tanete',
  },
  {
    id: '7310020009',
    districtId: '7310020',
    name: 'Lipukasi',
  },
  {
    id: '7310020010',
    districtId: '7310020',
    name: 'Garessi',
  },
  {
    id: '7310030001',
    districtId: '7310030',
    name: 'Sumpang Binangae',
  },
  {
    id: '7310030002',
    districtId: '7310030',
    name: 'Coppo',
  },
  {
    id: '7310030004',
    districtId: '7310030',
    name: 'Anabanua',
  },
  {
    id: '7310030005',
    districtId: '7310030',
    name: 'Palakka',
  },
  {
    id: '7310030006',
    districtId: '7310030',
    name: 'Galung',
  },
  {
    id: '7310030007',
    districtId: '7310030',
    name: 'Tompo',
  },
  {
    id: '7310030009',
    districtId: '7310030',
    name: 'Mangempang',
  },
  {
    id: '7310030010',
    districtId: '7310030',
    name: 'Siawung',
  },
  {
    id: '7310040005',
    districtId: '7310040',
    name: 'Ajakkang',
  },
  {
    id: '7310040006',
    districtId: '7310040',
    name: 'Paccekke',
  },
  {
    id: '7310040007',
    districtId: '7310040',
    name: 'Kiru-Kiru',
  },
  {
    id: '7310040008',
    districtId: '7310040',
    name: 'Mangkoso',
  },
  {
    id: '7310040009',
    districtId: '7310040',
    name: 'Lawallu',
  },
  {
    id: '7310040010',
    districtId: '7310040',
    name: 'Siddo',
  },
  {
    id: '7310040011',
    districtId: '7310040',
    name: 'Batupute',
  },
  {
    id: '7310041001',
    districtId: '7310041',
    name: 'Binuang',
  },
  {
    id: '7310041002',
    districtId: '7310041',
    name: 'Madello',
  },
  {
    id: '7310041003',
    districtId: '7310041',
    name: 'Takkalasi',
  },
  {
    id: '7310041004',
    districtId: '7310041',
    name: 'Kamiri',
  },
  {
    id: '7310041005',
    districtId: '7310041',
    name: 'Lampoko',
  },
  {
    id: '7310041006',
    districtId: '7310041',
    name: 'Balusu',
  },
  {
    id: '7310050001',
    districtId: '7310050',
    name: 'Cilellang',
  },
  {
    id: '7310050002',
    districtId: '7310050',
    name: 'Manuba',
  },
  {
    id: '7310050003',
    districtId: '7310050',
    name: 'Nepo',
  },
  {
    id: '7310050004',
    districtId: '7310050',
    name: 'Palanro',
  },
  {
    id: '7310050005',
    districtId: '7310050',
    name: 'Mallawa',
  },
  {
    id: '7310050006',
    districtId: '7310050',
    name: 'Kupa',
  },
  {
    id: '7310050007',
    districtId: '7310050',
    name: 'Bojo',
  },
  {
    id: '7310050008',
    districtId: '7310050',
    name: 'Bojo Baru',
  },
  {
    id: '7311010001',
    districtId: '7311010',
    name: 'Watangcani',
  },
  {
    id: '7311010002',
    districtId: '7311010',
    name: 'Pattuku',
  },
  {
    id: '7311010003',
    districtId: '7311010',
    name: 'Bontojai',
  },
  {
    id: '7311010004',
    districtId: '7311010',
    name: 'Bulusirua',
  },
  {
    id: '7311010005',
    districtId: '7311010',
    name: 'Bana',
  },
  {
    id: '7311010006',
    districtId: '7311010',
    name: 'Pammusureng',
  },
  {
    id: '7311010007',
    districtId: '7311010',
    name: 'Kahu',
  },
  {
    id: '7311010008',
    districtId: '7311010',
    name: 'Langi',
  },
  {
    id: '7311010009',
    districtId: '7311010',
    name: 'Ere Cinnong',
  },
  {
    id: '7311010010',
    districtId: '7311010',
    name: 'Lamoncong',
  },
  {
    id: '7311010011',
    districtId: '7311010',
    name: 'Mattiro Walie',
  },
  {
    id: '7311020001',
    districtId: '7311020',
    name: 'Cammilo',
  },
  {
    id: '7311020002',
    districtId: '7311020',
    name: 'Lalepo',
  },
  {
    id: '7311020003',
    districtId: '7311020',
    name: 'Pasaka',
  },
  {
    id: '7311020004',
    districtId: '7311020',
    name: 'Mattoanging',
  },
  {
    id: '7311020005',
    districtId: '7311020',
    name: 'Nusa',
  },
  {
    id: '7311020006',
    districtId: '7311020',
    name: 'Arallae',
  },
  {
    id: '7311020007',
    districtId: '7311020',
    name: 'Labuaja',
  },
  {
    id: '7311020008',
    districtId: '7311020',
    name: 'Balle',
  },
  {
    id: '7311020009',
    districtId: '7311020',
    name: 'Palattae',
  },
  {
    id: '7311020010',
    districtId: '7311020',
    name: 'Cakkela',
  },
  {
    id: '7311020011',
    districtId: '7311020',
    name: 'Matajang',
  },
  {
    id: '7311020012',
    districtId: '7311020',
    name: 'Maggenrang',
  },
  {
    id: '7311020013',
    districtId: '7311020',
    name: 'Carima',
  },
  {
    id: '7311020014',
    districtId: '7311020',
    name: 'Biru',
  },
  {
    id: '7311020015',
    districtId: '7311020',
    name: 'Cenranae',
  },
  {
    id: '7311020016',
    districtId: '7311020',
    name: 'Hulo',
  },
  {
    id: '7311020017',
    districtId: '7311020',
    name: 'Palakka',
  },
  {
    id: '7311020018',
    districtId: '7311020',
    name: 'Bonto Padang',
  },
  {
    id: '7311020019',
    districtId: '7311020',
    name: 'Sanrego',
  },
  {
    id: '7311020020',
    districtId: '7311020',
    name: 'Tompong Patu',
  },
  {
    id: '7311030001',
    districtId: '7311030',
    name: 'Raja',
  },
  {
    id: '7311030002',
    districtId: '7311030',
    name: 'Lemo',
  },
  {
    id: '7311030003',
    districtId: '7311030',
    name: 'Abbumpungeng',
  },
  {
    id: '7311030004',
    districtId: '7311030',
    name: 'Buareng',
  },
  {
    id: '7311030005',
    districtId: '7311030',
    name: 'Massangkae',
  },
  {
    id: '7311030006',
    districtId: '7311030',
    name: 'Mallahae',
  },
  {
    id: '7311030007',
    districtId: '7311030',
    name: 'Polewali',
  },
  {
    id: '7311030008',
    districtId: '7311030',
    name: 'Awang Tangka',
  },
  {
    id: '7311030009',
    districtId: '7311030',
    name: 'Padaelo',
  },
  {
    id: '7311030010',
    districtId: '7311030',
    name: 'Gona',
  },
  {
    id: '7311030011',
    districtId: '7311030',
    name: 'Waetuwo',
  },
  {
    id: '7311030012',
    districtId: '7311030',
    name: 'Bulu Tanah',
  },
  {
    id: '7311030013',
    districtId: '7311030',
    name: 'Kalero',
  },
  {
    id: '7311030014',
    districtId: '7311030',
    name: 'Lappa Bosse',
  },
  {
    id: '7311030016',
    districtId: '7311030',
    name: 'Ancu',
  },
  {
    id: '7311030017',
    districtId: '7311030',
    name: 'Angkue',
  },
  {
    id: '7311030018',
    districtId: '7311030',
    name: 'Tarasu',
  },
  {
    id: '7311040002',
    districtId: '7311040',
    name: 'Gattareng',
  },
  {
    id: '7311040003',
    districtId: '7311040',
    name: 'Ulu Balang',
  },
  {
    id: '7311040004',
    districtId: '7311040',
    name: 'Tebba',
  },
  {
    id: '7311040005',
    districtId: '7311040',
    name: 'Mappatoba',
  },
  {
    id: '7311040006',
    districtId: '7311040',
    name: 'Malimongeng',
  },
  {
    id: '7311040007',
    districtId: '7311040',
    name: 'Manera',
  },
  {
    id: '7311040008',
    districtId: '7311040',
    name: 'Pancaitana',
  },
  {
    id: '7311050001',
    districtId: '7311050',
    name: 'Biccoing',
  },
  {
    id: '7311050002',
    districtId: '7311050',
    name: 'Bacu',
  },
  {
    id: '7311050003',
    districtId: '7311050',
    name: 'Muara',
  },
  {
    id: '7311050005',
    districtId: '7311050',
    name: 'Gareccing',
  },
  {
    id: '7311050006',
    districtId: '7311050',
    name: 'Bonepute',
  },
  {
    id: '7311050008',
    districtId: '7311050',
    name: 'Padatuo',
  },
  {
    id: '7311050009',
    districtId: '7311050',
    name: 'Libureng',
  },
  {
    id: '7311050010',
    districtId: '7311050',
    name: 'Samaenre',
  },
  {
    id: '7311050011',
    districtId: '7311050',
    name: 'Rappa',
  },
  {
    id: '7311060001',
    districtId: '7311060',
    name: 'Latellang',
  },
  {
    id: '7311060002',
    districtId: '7311060',
    name: 'Patimpeng',
  },
  {
    id: '7311060003',
    districtId: '7311060',
    name: 'Maddanrengpulu',
  },
  {
    id: '7311060004',
    districtId: '7311060',
    name: 'Batulappa',
  },
  {
    id: '7311060005',
    districtId: '7311060',
    name: 'Masago',
  },
  {
    id: '7311060006',
    districtId: '7311060',
    name: 'Massila',
  },
  {
    id: '7311060007',
    districtId: '7311060',
    name: 'Paccing',
  },
  {
    id: '7311060008',
    districtId: '7311060',
    name: 'Bulu Ulaweng',
  },
  {
    id: '7311060009',
    districtId: '7311060',
    name: 'Talabangi',
  },
  {
    id: '7311060010',
    districtId: '7311060',
    name: 'Pationgi',
  },
  {
    id: '7311070001',
    districtId: '7311070',
    name: 'Baringeng',
  },
  {
    id: '7311070002',
    districtId: '7311070',
    name: 'Tompobulu',
  },
  {
    id: '7311070003',
    districtId: '7311070',
    name: 'Ponre-Ponre',
  },
  {
    id: '7311070004',
    districtId: '7311070',
    name: 'Laburasseng',
  },
  {
    id: '7311070005',
    districtId: '7311070',
    name: 'Tappale',
  },
  {
    id: '7311070006',
    districtId: '7311070',
    name: 'Polewali',
  },
  {
    id: '7311070007',
    districtId: '7311070',
    name: 'Suwa',
  },
  {
    id: '7311070008',
    districtId: '7311070',
    name: 'Pitumpidange',
  },
  {
    id: '7311070009',
    districtId: '7311070',
    name: 'Wanuawaru',
  },
  {
    id: '7311070010',
    districtId: '7311070',
    name: 'Ceppaga',
  },
  {
    id: '7311070011',
    districtId: '7311070',
    name: 'Mattiro Walie',
  },
  {
    id: '7311070012',
    districtId: '7311070',
    name: 'Mario',
  },
  {
    id: '7311070013',
    districtId: '7311070',
    name: 'Poleonro',
  },
  {
    id: '7311070014',
    districtId: '7311070',
    name: 'Tanabatue',
  },
  {
    id: '7311070015',
    districtId: '7311070',
    name: 'Swadaya',
  },
  {
    id: '7311070016',
    districtId: '7311070',
    name: 'Binuang',
  },
  {
    id: '7311070017',
    districtId: '7311070',
    name: 'Mattiro Deceng',
  },
  {
    id: '7311070019',
    districtId: '7311070',
    name: 'Mallinrung',
  },
  {
    id: '7311070020',
    districtId: '7311070',
    name: 'Mattiro Bulu',
  },
  {
    id: '7311080001',
    districtId: '7311080',
    name: 'Lappa Upang',
  },
  {
    id: '7311080002',
    districtId: '7311080',
    name: 'Batu Gading',
  },
  {
    id: '7311080003',
    districtId: '7311080',
    name: 'Lapasa',
  },
  {
    id: '7311080004',
    districtId: '7311080',
    name: 'Karella',
  },
  {
    id: '7311080005',
    districtId: '7311080',
    name: 'Mario',
  },
  {
    id: '7311080006',
    districtId: '7311080',
    name: 'Ujung Salangketo',
  },
  {
    id: '7311080008',
    districtId: '7311080',
    name: 'Tellu Boccoe',
  },
  {
    id: '7311080009',
    districtId: '7311080',
    name: 'Padaelo',
  },
  {
    id: '7311080010',
    districtId: '7311080',
    name: 'Kadai',
  },
  {
    id: '7311080011',
    districtId: '7311080',
    name: 'Tellongeng',
  },
  {
    id: '7311080012',
    districtId: '7311080',
    name: 'Mattampa Walie',
  },
  {
    id: '7311080013',
    districtId: '7311080',
    name: 'Data',
  },
  {
    id: '7311080014',
    districtId: '7311080',
    name: 'Sumaling',
  },
  {
    id: '7311080015',
    districtId: '7311080',
    name: 'Pattiro',
  },
  {
    id: '7311080016',
    districtId: '7311080',
    name: 'Lakukang',
  },
  {
    id: '7311080017',
    districtId: '7311080',
    name: 'Ujung Tanah',
  },
  {
    id: '7311080018',
    districtId: '7311080',
    name: 'Mattiro Walie',
  },
  {
    id: '7311090001',
    districtId: '7311090',
    name: 'Balieng Toa',
  },
  {
    id: '7311090002',
    districtId: '7311090',
    name: 'Pasaka',
  },
  {
    id: '7311090003',
    districtId: '7311090',
    name: 'Bulie',
  },
  {
    id: '7311090005',
    districtId: '7311090',
    name: 'Massenrengpulu',
  },
  {
    id: '7311090006',
    districtId: '7311090',
    name: 'Mabbiring',
  },
  {
    id: '7311090007',
    districtId: '7311090',
    name: 'Mallusetasi',
  },
  {
    id: '7311090008',
    districtId: '7311090',
    name: 'Pattiro Sompe',
  },
  {
    id: '7311090009',
    districtId: '7311090',
    name: 'Pakkasalo',
  },
  {
    id: '7311090010',
    districtId: '7311090',
    name: 'Pattiro Bajo',
  },
  {
    id: '7311090011',
    districtId: '7311090',
    name: 'Maroanging',
  },
  {
    id: '7311090012',
    districtId: '7311090',
    name: 'Cinnong',
  },
  {
    id: '7311090013',
    districtId: '7311090',
    name: 'Polewali',
  },
  {
    id: '7311090014',
    districtId: '7311090',
    name: 'Kalibong',
  },
  {
    id: '7311090015',
    districtId: '7311090',
    name: 'Tadang Palie',
  },
  {
    id: '7311090016',
    districtId: '7311090',
    name: 'Ajang Pulu',
  },
  {
    id: '7311090017',
    districtId: '7311090',
    name: 'Lette Tanah',
  },
  {
    id: '7311090018',
    districtId: '7311090',
    name: 'Pattiro Riolo',
  },
  {
    id: '7311090019',
    districtId: '7311090',
    name: 'Sumpang Minangae',
  },
  {
    id: '7311090020',
    districtId: '7311090',
    name: 'Manajeng',
  },
  {
    id: '7311100001',
    districtId: '7311100',
    name: 'Abbumpungeng',
  },
  {
    id: '7311100002',
    districtId: '7311100',
    name: 'Arasoe',
  },
  {
    id: '7311100003',
    districtId: '7311100',
    name: 'Cinennung',
  },
  {
    id: '7311100004',
    districtId: '7311100',
    name: 'Tanete Harapan',
  },
  {
    id: '7311100005',
    districtId: '7311100',
    name: 'Tanete',
  },
  {
    id: '7311100006',
    districtId: '7311100',
    name: 'Lompu',
  },
  {
    id: '7311100007',
    districtId: '7311100',
    name: 'Kawerang',
  },
  {
    id: '7311100009',
    districtId: '7311100',
    name: 'Ajangpulu',
  },
  {
    id: '7311100010',
    districtId: '7311100',
    name: 'Kanco',
  },
  {
    id: '7311100011',
    districtId: '7311100',
    name: 'Padang Loang',
  },
  {
    id: '7311100012',
    districtId: '7311100',
    name: 'Awo',
  },
  {
    id: '7311110001',
    districtId: '7311110',
    name: 'Cempaniga',
  },
  {
    id: '7311110002',
    districtId: '7311110',
    name: 'Bacu',
  },
  {
    id: '7311110003',
    districtId: '7311110',
    name: 'Cingkang',
  },
  {
    id: '7311110004',
    districtId: '7311110',
    name: 'Congko',
  },
  {
    id: '7311110005',
    districtId: '7311110',
    name: 'Cinnong',
  },
  {
    id: '7311110006',
    districtId: '7311110',
    name: 'Lampoko',
  },
  {
    id: '7311110007',
    districtId: '7311110',
    name: 'Wollangi',
  },
  {
    id: '7311110008',
    districtId: '7311110',
    name: 'Kajaolaliddong',
  },
  {
    id: '7311110009',
    districtId: '7311110',
    name: 'Samaelo',
  },
  {
    id: '7311110010',
    districtId: '7311110',
    name: 'Parippung',
  },
  {
    id: '7311110011',
    districtId: '7311110',
    name: 'Apala',
  },
  {
    id: '7311110012',
    districtId: '7311110',
    name: 'Sugiale',
  },
  {
    id: '7311110013',
    districtId: '7311110',
    name: 'Kampuno',
  },
  {
    id: '7311110014',
    districtId: '7311110',
    name: 'Corawalie',
  },
  {
    id: '7311110015',
    districtId: '7311110',
    name: 'Talungeng',
  },
  {
    id: '7311110016',
    districtId: '7311110',
    name: 'Barebbo',
  },
  {
    id: '7311110017',
    districtId: '7311110',
    name: 'Watu',
  },
  {
    id: '7311110018',
    districtId: '7311110',
    name: 'Kading',
  },
  {
    id: '7311120001',
    districtId: '7311120',
    name: 'Turu Adae',
  },
  {
    id: '7311120002',
    districtId: '7311120',
    name: 'Mappesangka',
  },
  {
    id: '7311120003',
    districtId: '7311120',
    name: 'Salebba',
  },
  {
    id: '7311120004',
    districtId: '7311120',
    name: 'Salampe',
  },
  {
    id: '7311120005',
    districtId: '7311120',
    name: 'Bolli',
  },
  {
    id: '7311120006',
    districtId: '7311120',
    name: 'Pattimpa',
  },
  {
    id: '7311120007',
    districtId: '7311120',
    name: 'Poleonro',
  },
  {
    id: '7311120008',
    districtId: '7311120',
    name: 'Tellu Boccoe',
  },
  {
    id: '7311120009',
    districtId: '7311120',
    name: 'Mattampae',
  },
  {
    id: '7311130001',
    districtId: '7311130',
    name: 'Mattampa Walie',
  },
  {
    id: '7311130002',
    districtId: '7311130',
    name: 'Lili Riattang',
  },
  {
    id: '7311130003',
    districtId: '7311130',
    name: 'Waekeccee',
  },
  {
    id: '7311130004',
    districtId: '7311130',
    name: 'Sengeng Palie',
  },
  {
    id: '7311130005',
    districtId: '7311130',
    name: 'Tonronge',
  },
  {
    id: '7311130006',
    districtId: '7311130',
    name: 'Tenri Pakkua',
  },
  {
    id: '7311130007',
    districtId: '7311130',
    name: 'Pattuku Limpoe',
  },
  {
    id: '7311130008',
    districtId: '7311130',
    name: 'Ujung Lamuru',
  },
  {
    id: '7311130009',
    districtId: '7311130',
    name: 'Patangkai',
  },
  {
    id: '7311140012',
    districtId: '7311140',
    name: 'Turucinnae',
  },
  {
    id: '7311140013',
    districtId: '7311140',
    name: 'Mamminasae',
  },
  {
    id: '7311140014',
    districtId: '7311140',
    name: 'Mattampa Bulu',
  },
  {
    id: '7311140015',
    districtId: '7311140',
    name: 'Barakkae',
  },
  {
    id: '7311140016',
    districtId: '7311140',
    name: 'Massenrenpulu',
  },
  {
    id: '7311140017',
    districtId: '7311140',
    name: 'Mattampa Walie',
  },
  {
    id: '7311140018',
    districtId: '7311140',
    name: 'Poleonro',
  },
  {
    id: '7311140019',
    districtId: '7311140',
    name: 'Lalebata',
  },
  {
    id: '7311140020',
    districtId: '7311140',
    name: 'Sengeng Palie',
  },
  {
    id: '7311140021',
    districtId: '7311140',
    name: 'Padaelo',
  },
  {
    id: '7311140022',
    districtId: '7311140',
    name: 'Seberang',
  },
  {
    id: '7311140023',
    districtId: '7311140',
    name: 'Barugae',
  },
  {
    id: '7311141001',
    districtId: '7311141',
    name: 'Tondong',
  },
  {
    id: '7311141002',
    districtId: '7311141',
    name: 'Bonto Masunggu',
  },
  {
    id: '7311141003',
    districtId: '7311141',
    name: 'Samaenre',
  },
  {
    id: '7311141004',
    districtId: '7311141',
    name: 'Tellangkere',
  },
  {
    id: '7311141005',
    districtId: '7311141',
    name: 'Polewali',
  },
  {
    id: '7311141006',
    districtId: '7311141',
    name: 'Lagori',
  },
  {
    id: '7311141007',
    districtId: '7311141',
    name: 'Gaya Baru',
  },
  {
    id: '7311141008',
    districtId: '7311141',
    name: 'Batu Putih',
  },
  {
    id: '7311141009',
    districtId: '7311141',
    name: 'Tapong',
  },
  {
    id: '7311141010',
    districtId: '7311141',
    name: 'Sadar',
  },
  {
    id: '7311141011',
    districtId: '7311141',
    name: 'Pallawa',
  },
  {
    id: '7311150001',
    districtId: '7311150',
    name: 'Samaenre',
  },
  {
    id: '7311150002',
    districtId: '7311150',
    name: 'Walimpong',
  },
  {
    id: '7311150004',
    districtId: '7311150',
    name: 'Selli',
  },
  {
    id: '7311150005',
    districtId: '7311150',
    name: 'Bulu Allapporenge',
  },
  {
    id: '7311150006',
    districtId: '7311150',
    name: 'Bengo',
  },
  {
    id: '7311150007',
    districtId: '7311150',
    name: 'Mattaro Puli',
  },
  {
    id: '7311150008',
    districtId: '7311150',
    name: 'Mattiro Walie',
  },
  {
    id: '7311150009',
    districtId: '7311150',
    name: 'Liliriawang',
  },
  {
    id: '7311160001',
    districtId: '7311160',
    name: 'Lilina Ajangale',
  },
  {
    id: '7311160002',
    districtId: '7311160',
    name: 'Tadang Palie',
  },
  {
    id: '7311160003',
    districtId: '7311160',
    name: 'Cani Sirenreng',
  },
  {
    id: '7311160004',
    districtId: '7311160',
    name: 'Sappe Walie',
  },
  {
    id: '7311160005',
    districtId: '7311160',
    name: 'Manurunge',
  },
  {
    id: '7311160006',
    districtId: '7311160',
    name: 'Cinnong',
  },
  {
    id: '7311160007',
    districtId: '7311160',
    name: 'Ulaweng Cinnong',
  },
  {
    id: '7311160008',
    districtId: '7311160',
    name: 'Pallawa Rukka',
  },
  {
    id: '7311160009',
    districtId: '7311160',
    name: 'Jompie',
  },
  {
    id: '7311160010',
    districtId: '7311160',
    name: 'Lamakkaraseng',
  },
  {
    id: '7311160011',
    districtId: '7311160',
    name: 'Mula Menree',
  },
  {
    id: '7311160012',
    districtId: '7311160',
    name: 'Galung',
  },
  {
    id: '7311160013',
    districtId: '7311160',
    name: 'Tea Malala',
  },
  {
    id: '7311160014',
    districtId: '7311160',
    name: 'Timusu',
  },
  {
    id: '7311160015',
    districtId: '7311160',
    name: 'Teamusu',
  },
  {
    id: '7311170001',
    districtId: '7311170',
    name: 'Siame',
  },
  {
    id: '7311170002',
    districtId: '7311170',
    name: 'Cinennung',
  },
  {
    id: '7311170003',
    districtId: '7311170',
    name: 'Pasempe',
  },
  {
    id: '7311170004',
    districtId: '7311170',
    name: 'Lemoape',
  },
  {
    id: '7311170005',
    districtId: '7311170',
    name: 'Usa',
  },
  {
    id: '7311170007',
    districtId: '7311170',
    name: 'Mico',
  },
  {
    id: '7311170008',
    districtId: '7311170',
    name: 'Bainang',
  },
  {
    id: '7311170009',
    districtId: '7311170',
    name: 'Passippo',
  },
  {
    id: '7311170010',
    districtId: '7311170',
    name: 'Tanah Tengah',
  },
  {
    id: '7311170011',
    districtId: '7311170',
    name: 'Tirong',
  },
  {
    id: '7311170012',
    districtId: '7311170',
    name: 'Panyili',
  },
  {
    id: '7311170013',
    districtId: '7311170',
    name: 'Mattanete Bua',
  },
  {
    id: '7311170014',
    districtId: '7311170',
    name: 'Maduri',
  },
  {
    id: '7311180001',
    districtId: '7311180',
    name: 'Bulumparee',
  },
  {
    id: '7311180002',
    districtId: '7311180',
    name: 'Carebbu',
  },
  {
    id: '7311180003',
    districtId: '7311180',
    name: 'Abbanuang',
  },
  {
    id: '7311180004',
    districtId: '7311180',
    name: 'Paccing',
  },
  {
    id: '7311180005',
    districtId: '7311180',
    name: 'Maccope',
  },
  {
    id: '7311180006',
    districtId: '7311180',
    name: 'Mallari',
  },
  {
    id: '7311180007',
    districtId: '7311180',
    name: 'Kading',
  },
  {
    id: '7311180008',
    districtId: '7311180',
    name: 'Cakke Bone',
  },
  {
    id: '7311180009',
    districtId: '7311180',
    name: 'Lappo Ase',
  },
  {
    id: '7311180010',
    districtId: '7311180',
    name: 'Cumpiga',
  },
  {
    id: '7311180011',
    districtId: '7311180',
    name: 'Awo Lagading',
  },
  {
    id: '7311180012',
    districtId: '7311180',
    name: 'Jaling',
  },
  {
    id: '7311180013',
    districtId: '7311180',
    name: 'Mappalo Ulaweng',
  },
  {
    id: '7311180014',
    districtId: '7311180',
    name: 'Unra',
  },
  {
    id: '7311180015',
    districtId: '7311180',
    name: 'Kajuara',
  },
  {
    id: '7311180016',
    districtId: '7311180',
    name: 'Cari Gading',
  },
  {
    id: '7311180017',
    districtId: '7311180',
    name: 'Matuju',
  },
  {
    id: '7311180018',
    districtId: '7311180',
    name: 'Lattekko',
  },
  {
    id: '7311190001',
    districtId: '7311190',
    name: 'Padaidi',
  },
  {
    id: '7311190002',
    districtId: '7311190',
    name: 'Tajong',
  },
  {
    id: '7311190003',
    districtId: '7311190',
    name: 'Palongki',
  },
  {
    id: '7311190004',
    districtId: '7311190',
    name: 'Pongka',
  },
  {
    id: '7311190005',
    districtId: '7311190',
    name: 'Ulo',
  },
  {
    id: '7311190006',
    districtId: '7311190',
    name: 'Otting',
  },
  {
    id: '7311190007',
    districtId: '7311190',
    name: 'Lanca',
  },
  {
    id: '7311190008',
    districtId: '7311190',
    name: 'Lappae',
  },
  {
    id: '7311190009',
    districtId: '7311190',
    name: 'Ajjalireng',
  },
  {
    id: '7311190010',
    districtId: '7311190',
    name: 'Sijelling',
  },
  {
    id: '7311190011',
    districtId: '7311190',
    name: 'Lea',
  },
  {
    id: '7311190012',
    districtId: '7311190',
    name: 'Patangnga',
  },
  {
    id: '7311190013',
    districtId: '7311190',
    name: 'Waji',
  },
  {
    id: '7311190014',
    districtId: '7311190',
    name: 'Tokaseng',
  },
  {
    id: '7311190015',
    districtId: '7311190',
    name: 'Itterung',
  },
  {
    id: '7311190016',
    districtId: '7311190',
    name: 'Mattoanging',
  },
  {
    id: '7311190017',
    districtId: '7311190',
    name: 'Lamuru',
  },
  {
    id: '7311200001',
    districtId: '7311200',
    name: 'Amali Riattang',
  },
  {
    id: '7311200002',
    districtId: '7311200',
    name: 'Lili Riattang',
  },
  {
    id: '7311200003',
    districtId: '7311200',
    name: 'Mattaro Purae',
  },
  {
    id: '7311200004',
    districtId: '7311200',
    name: 'Tocinnong',
  },
  {
    id: '7311200005',
    districtId: '7311200',
    name: 'Waempubbue',
  },
  {
    id: '7311200006',
    districtId: '7311200',
    name: 'Waemputtange',
  },
  {
    id: '7311200007',
    districtId: '7311200',
    name: 'Bila',
  },
  {
    id: '7311200008',
    districtId: '7311200',
    name: 'Ulaweng Riaja',
  },
  {
    id: '7311200009',
    districtId: '7311200',
    name: 'Mampotu',
  },
  {
    id: '7311200010',
    districtId: '7311200',
    name: "Ta'Cipong",
  },
  {
    id: '7311200011',
    districtId: '7311200',
    name: 'Wellulang',
  },
  {
    id: '7311200012',
    districtId: '7311200',
    name: 'Ajang Laleng',
  },
  {
    id: '7311200013',
    districtId: '7311200',
    name: 'Tassipi',
  },
  {
    id: '7311200015',
    districtId: '7311200',
    name: 'Laponrong',
  },
  {
    id: '7311210001',
    districtId: '7311210',
    name: 'Manciri',
  },
  {
    id: '7311210002',
    districtId: '7311210',
    name: 'Lebbae',
  },
  {
    id: '7311210003',
    districtId: '7311210',
    name: 'Amessangeng',
  },
  {
    id: '7311210004',
    districtId: '7311210',
    name: 'Leppangeng',
  },
  {
    id: '7311210005',
    districtId: '7311210',
    name: 'Allamungeng Patue',
  },
  {
    id: '7311210006',
    districtId: '7311210',
    name: 'Timurung',
  },
  {
    id: '7311210007',
    districtId: '7311210',
    name: 'Labissa',
  },
  {
    id: '7311210008',
    districtId: '7311210',
    name: 'Opo',
  },
  {
    id: '7311210009',
    districtId: '7311210',
    name: 'Pinceng Pute',
  },
  {
    id: '7311210010',
    districtId: '7311210',
    name: 'Welado',
  },
  {
    id: '7311210011',
    districtId: '7311210',
    name: 'Pompanua',
  },
  {
    id: '7311210012',
    districtId: '7311210',
    name: 'Pompanua Riattang',
  },
  {
    id: '7311210014',
    districtId: '7311210',
    name: 'Pacciro',
  },
  {
    id: '7311220001',
    districtId: '7311220',
    name: 'Praja Maju',
  },
  {
    id: '7311220002',
    districtId: '7311220',
    name: 'Mario',
  },
  {
    id: '7311220003',
    districtId: '7311220',
    name: 'Panyili',
  },
  {
    id: '7311220004',
    districtId: '7311220',
    name: 'Laccori',
  },
  {
    id: '7311220005',
    districtId: '7311220',
    name: 'Pattiro',
  },
  {
    id: '7311220006',
    districtId: '7311220',
    name: 'Tocina',
  },
  {
    id: '7311220007',
    districtId: '7311220',
    name: 'Kampoti',
  },
  {
    id: '7311220008',
    districtId: '7311220',
    name: 'Pakkasalo',
  },
  {
    id: '7311220009',
    districtId: '7311220',
    name: 'Cabbeng',
  },
  {
    id: '7311220012',
    districtId: '7311220',
    name: 'Lallatang',
  },
  {
    id: '7311220013',
    districtId: '7311220',
    name: 'Sanrangeng',
  },
  {
    id: '7311220014',
    districtId: '7311220',
    name: 'Sailong',
  },
  {
    id: '7311220015',
    districtId: '7311220',
    name: 'Watang Padacenga',
  },
  {
    id: '7311220017',
    districtId: '7311220',
    name: 'Unnyi',
  },
  {
    id: '7311220018',
    districtId: '7311220',
    name: 'Uloe',
  },
  {
    id: '7311220019',
    districtId: '7311220',
    name: 'Tawaroe',
  },
  {
    id: '7311220020',
    districtId: '7311220',
    name: 'Matajang',
  },
  {
    id: '7311220021',
    districtId: '7311220',
    name: 'Padacenga',
  },
  {
    id: '7311220022',
    districtId: '7311220',
    name: 'Solo',
  },
  {
    id: '7311230001',
    districtId: '7311230',
    name: 'Watang Ta',
  },
  {
    id: '7311230002',
    districtId: '7311230',
    name: 'Pacubbe',
  },
  {
    id: '7311230003',
    districtId: '7311230',
    name: 'Panyiwi',
  },
  {
    id: '7311230004',
    districtId: '7311230',
    name: 'Pallae',
  },
  {
    id: '7311230005',
    districtId: '7311230',
    name: 'Watu',
  },
  {
    id: '7311230006',
    districtId: '7311230',
    name: 'Naga Uleng',
  },
  {
    id: '7311230007',
    districtId: '7311230',
    name: 'Latonro',
  },
  {
    id: '7311230008',
    districtId: '7311230',
    name: 'Laoni',
  },
  {
    id: '7311230010',
    districtId: '7311230',
    name: 'Pallime',
  },
  {
    id: '7311230011',
    districtId: '7311230',
    name: 'Ajallasse',
  },
  {
    id: '7311230012',
    districtId: '7311230',
    name: 'Cenrana',
  },
  {
    id: '7311230013',
    districtId: '7311230',
    name: 'Awang Cenrana',
  },
  {
    id: '7311230014',
    districtId: '7311230',
    name: 'Lebongnge',
  },
  {
    id: '7311230015',
    districtId: '7311230',
    name: 'Cakkeware',
  },
  {
    id: '7311230016',
    districtId: '7311230',
    name: 'Labotto',
  },
  {
    id: '7311710001',
    districtId: '7311710',
    name: 'Majang',
  },
  {
    id: '7311710002',
    districtId: '7311710',
    name: 'Macege',
  },
  {
    id: '7311710004',
    districtId: '7311710',
    name: 'Macanang',
  },
  {
    id: '7311710005',
    districtId: '7311710',
    name: 'Mattiro Walie',
  },
  {
    id: '7311710007',
    districtId: '7311710',
    name: 'Watang Palakka',
  },
  {
    id: '7311710008',
    districtId: '7311710',
    name: 'Polewali',
  },
  {
    id: '7311720001',
    districtId: '7311720',
    name: 'Biru',
  },
  {
    id: '7311720002',
    districtId: '7311720',
    name: 'Masumpu',
  },
  {
    id: '7311720003',
    districtId: '7311720',
    name: 'Ta',
  },
  {
    id: '7311720004',
    districtId: '7311720',
    name: 'Manurungnge',
  },
  {
    id: '7311720005',
    districtId: '7311720',
    name: 'Watampone',
  },
  {
    id: '7311720006',
    districtId: '7311720',
    name: 'Bukaka',
  },
  {
    id: '7311720007',
    districtId: '7311720',
    name: 'Walennae',
  },
  {
    id: '7311720008',
    districtId: '7311720',
    name: 'Pappolo',
  },
  {
    id: '7311730001',
    districtId: '7311730',
    name: 'Tibojong',
  },
  {
    id: '7311730003',
    districtId: '7311730',
    name: 'Bajoe',
  },
  {
    id: '7311730004',
    districtId: '7311730',
    name: 'Lonrae',
  },
  {
    id: '7311730005',
    districtId: '7311730',
    name: 'Toro',
  },
  {
    id: '7311730006',
    districtId: '7311730',
    name: 'Panyula',
  },
  {
    id: '7311730007',
    districtId: '7311730',
    name: 'Waetuwo',
  },
  {
    id: '7311730008',
    districtId: '7311730',
    name: 'Pallette',
  },
  {
    id: '7312010001',
    districtId: '7312010',
    name: 'Gattareng',
  },
  {
    id: '7312010002',
    districtId: '7312010',
    name: 'Mario Riaja',
  },
  {
    id: '7312010003',
    districtId: '7312010',
    name: 'Watu',
  },
  {
    id: '7312010004',
    districtId: '7312010',
    name: 'Mario Rittengnga',
  },
  {
    id: '7312010005',
    districtId: '7312010',
    name: 'Goarie',
  },
  {
    id: '7312010006',
    districtId: '7312010',
    name: 'Barae',
  },
  {
    id: '7312010007',
    districtId: '7312010',
    name: 'Mario Rilau',
  },
  {
    id: '7312010008',
    districtId: '7312010',
    name: 'Tettikengrarae',
  },
  {
    id: '7312010009',
    districtId: '7312010',
    name: 'Labessi',
  },
  {
    id: '7312010010',
    districtId: '7312010',
    name: 'Congko',
  },
  {
    id: '7312010011',
    districtId: '7312010',
    name: 'Watutoa',
  },
  {
    id: '7312010012',
    districtId: '7312010',
    name: 'Gattareng Toa',
  },
  {
    id: '7312010013',
    districtId: '7312010',
    name: 'Soga',
  },
  {
    id: '7312020002',
    districtId: '7312020',
    name: 'Lalabata Rilau',
  },
  {
    id: '7312020003',
    districtId: '7312020',
    name: 'Botto',
  },
  {
    id: '7312020004',
    districtId: '7312020',
    name: 'Lemba',
  },
  {
    id: '7312020005',
    districtId: '7312020',
    name: 'Bila',
  },
  {
    id: '7312020006',
    districtId: '7312020',
    name: 'Mattabulu',
  },
  {
    id: '7312020007',
    districtId: '7312020',
    name: 'Ompo',
  },
  {
    id: '7312020008',
    districtId: '7312020',
    name: 'Lapajung',
  },
  {
    id: '7312020009',
    districtId: '7312020',
    name: 'Maccile',
  },
  {
    id: '7312020010',
    districtId: '7312020',
    name: 'Salo Karaja',
  },
  {
    id: '7312030001',
    districtId: '7312030',
    name: 'Timusu',
  },
  {
    id: '7312030002',
    districtId: '7312030',
    name: 'Rompegading',
  },
  {
    id: '7312030003',
    districtId: '7312030',
    name: 'Pattojo',
  },
  {
    id: '7312030004',
    districtId: '7312030',
    name: 'Galung',
  },
  {
    id: '7312030005',
    districtId: '7312030',
    name: 'Jennae',
  },
  {
    id: '7312030006',
    districtId: '7312030',
    name: 'Jampu',
  },
  {
    id: '7312030007',
    districtId: '7312030',
    name: 'Barang',
  },
  {
    id: '7312030011',
    districtId: '7312030',
    name: 'Appanang',
  },
  {
    id: '7312031001',
    districtId: '7312031',
    name: 'Belo',
  },
  {
    id: '7312031002',
    districtId: '7312031',
    name: 'Ganra',
  },
  {
    id: '7312031004',
    districtId: '7312031',
    name: 'Lompulle',
  },
  {
    id: '7312032001',
    districtId: '7312032',
    name: 'Kampiri',
  },
  {
    id: '7312032002',
    districtId: '7312032',
    name: 'Citta',
  },
  {
    id: '7312032003',
    districtId: '7312032',
    name: 'Labae',
  },
  {
    id: '7312032004',
    districtId: '7312032',
    name: 'Tinco',
  },
  {
    id: '7312040001',
    districtId: '7312040',
    name: 'Pajalesang',
  },
  {
    id: '7312040002',
    districtId: '7312040',
    name: 'Cabenge',
  },
  {
    id: '7312040003',
    districtId: '7312040',
    name: 'Paroto',
  },
  {
    id: '7312040004',
    districtId: '7312040',
    name: 'Palangiseng',
  },
  {
    id: '7312040005',
    districtId: '7312040',
    name: 'Tetewatu',
  },
  {
    id: '7312040006',
    districtId: '7312040',
    name: 'Abbanuange',
  },
  {
    id: '7312040007',
    districtId: '7312040',
    name: 'Parenring',
  },
  {
    id: '7312040009',
    districtId: '7312040',
    name: 'Masing',
  },
  {
    id: '7312040010',
    districtId: '7312040',
    name: 'Baringeng',
  },
  {
    id: '7312040011',
    districtId: '7312040',
    name: 'Kebo',
  },
  {
    id: '7312040012',
    districtId: '7312040',
    name: 'Macanre',
  },
  {
    id: '7312050002',
    districtId: '7312050',
    name: 'Pising',
  },
  {
    id: '7312050003',
    districtId: '7312050',
    name: 'Labokong',
  },
  {
    id: '7312050004',
    districtId: '7312050',
    name: 'Donri-Donri',
  },
  {
    id: '7312050005',
    districtId: '7312050',
    name: 'Sering',
  },
  {
    id: '7312050006',
    districtId: '7312050',
    name: 'Lalabata Riaja',
  },
  {
    id: '7312050007',
    districtId: '7312050',
    name: 'Tottong',
  },
  {
    id: '7312050008',
    districtId: '7312050',
    name: 'Leworeng',
  },
  {
    id: '7312050009',
    districtId: '7312050',
    name: 'Kessing',
  },
  {
    id: '7312060001',
    districtId: '7312060',
    name: 'Patampanua',
  },
  {
    id: '7312060002',
    districtId: '7312060',
    name: 'Panincong',
  },
  {
    id: '7312060003',
    districtId: '7312060',
    name: 'Tellulimpoe',
  },
  {
    id: '7312060004',
    districtId: '7312060',
    name: 'Attang Salo',
  },
  {
    id: '7312060005',
    districtId: '7312060',
    name: 'Kaca',
  },
  {
    id: '7312060006',
    districtId: '7312060',
    name: 'Limpomajang',
  },
  {
    id: '7312060007',
    districtId: '7312060',
    name: 'Batu-Batu',
  },
  {
    id: '7312060008',
    districtId: '7312060',
    name: 'Manorang Salo',
  },
  {
    id: '7312060009',
    districtId: '7312060',
    name: 'Laringgi',
  },
  {
    id: '7313010001',
    districtId: '7313010',
    name: 'Liu',
  },
  {
    id: '7313010002',
    districtId: '7313010',
    name: 'Tadangpalie',
  },
  {
    id: '7313010003',
    districtId: '7313010',
    name: 'Talotenreng',
  },
  {
    id: '7313010004',
    districtId: '7313010',
    name: 'Walenae',
  },
  {
    id: '7313010005',
    districtId: '7313010',
    name: 'Salotengnga',
  },
  {
    id: '7313010006',
    districtId: '7313010',
    name: 'B I L A',
  },
  {
    id: '7313010007',
    districtId: '7313010',
    name: 'Worongnge',
  },
  {
    id: '7313010008',
    districtId: '7313010',
    name: 'Pallimae',
  },
  {
    id: '7313010009',
    districtId: '7313010',
    name: 'Ugi',
  },
  {
    id: '7313010010',
    districtId: '7313010',
    name: 'Mallusesalo',
  },
  {
    id: '7313010011',
    districtId: '7313010',
    name: 'Sompe',
  },
  {
    id: '7313010012',
    districtId: '7313010',
    name: 'Wage',
  },
  {
    id: '7313010013',
    districtId: '7313010',
    name: 'Pasaka',
  },
  {
    id: '7313010014',
    districtId: '7313010',
    name: 'Ujungpero',
  },
  {
    id: '7313010015',
    districtId: '7313010',
    name: 'Benteng Lompoe',
  },
  {
    id: '7313020001',
    districtId: '7313020',
    name: 'Wiringpalennae',
  },
  {
    id: '7313020002',
    districtId: '7313020',
    name: 'Sitampae',
  },
  {
    id: '7313020003',
    districtId: '7313020',
    name: 'Atakkae',
  },
  {
    id: '7313020004',
    districtId: '7313020',
    name: 'Maddukkelleng',
  },
  {
    id: '7313020005',
    districtId: '7313020',
    name: 'Siengkang',
  },
  {
    id: '7313020006',
    districtId: '7313020',
    name: 'Padduppa',
  },
  {
    id: '7313020007',
    districtId: '7313020',
    name: 'Pattirosompe',
  },
  {
    id: '7313020008',
    districtId: '7313020',
    name: 'Cempalagi',
  },
  {
    id: '7313020009',
    districtId: '7313020',
    name: 'Bulupabbulu',
  },
  {
    id: '7313020010',
    districtId: '7313020',
    name: 'Lapongkoda',
  },
  {
    id: '7313020011',
    districtId: '7313020',
    name: 'Teddaopu',
  },
  {
    id: '7313020012',
    districtId: '7313020',
    name: 'Salomenraleng',
  },
  {
    id: '7313020013',
    districtId: '7313020',
    name: 'Laelo',
  },
  {
    id: '7313020014',
    districtId: '7313020',
    name: 'Watallipue',
  },
  {
    id: '7313020016',
    districtId: '7313020',
    name: 'Mattirotappareng',
  },
  {
    id: '7313030001',
    districtId: '7313030',
    name: 'Tobatang',
  },
  {
    id: '7313030002',
    districtId: '7313030',
    name: 'Wecudai',
  },
  {
    id: '7313030003',
    districtId: '7313030',
    name: 'Lapaukke',
  },
  {
    id: '7313030004',
    districtId: '7313030',
    name: 'Kampiri',
  },
  {
    id: '7313030005',
    districtId: '7313030',
    name: 'Pallawarukka',
  },
  {
    id: '7313030006',
    districtId: '7313030',
    name: 'Watampanua',
  },
  {
    id: '7313030007',
    districtId: '7313030',
    name: 'Cina',
  },
  {
    id: '7313030008',
    districtId: '7313030',
    name: 'Pammana',
  },
  {
    id: '7313030009',
    districtId: '7313030',
    name: 'Simpurusia',
  },
  {
    id: '7313030010',
    districtId: '7313030',
    name: 'Lempa',
  },
  {
    id: '7313030011',
    districtId: '7313030',
    name: 'Patila',
  },
  {
    id: '7313030012',
    districtId: '7313030',
    name: 'Lampulung',
  },
  {
    id: '7313030013',
    districtId: '7313030',
    name: 'Abbanuange',
  },
  {
    id: '7313030014',
    districtId: '7313030',
    name: 'Tadang Palie',
  },
  {
    id: '7313030015',
    districtId: '7313030',
    name: 'Lagosi',
  },
  {
    id: '7313030016',
    districtId: '7313030',
    name: 'Tonrong Tengnga',
  },
  {
    id: '7313040001',
    districtId: '7313040',
    name: 'Balielo',
  },
  {
    id: '7313040002',
    districtId: '7313040',
    name: 'Lempong',
  },
  {
    id: '7313040003',
    districtId: '7313040',
    name: 'Manurung',
  },
  {
    id: '7313040004',
    districtId: '7313040',
    name: 'Bola',
  },
  {
    id: '7313040005',
    districtId: '7313040',
    name: 'Rajamawellang',
  },
  {
    id: '7313040006',
    districtId: '7313040',
    name: 'Ujung Tanah',
  },
  {
    id: '7313040007',
    districtId: '7313040',
    name: 'Solo',
  },
  {
    id: '7313040008',
    districtId: '7313040',
    name: 'Sanreseng Ade',
  },
  {
    id: '7313040009',
    districtId: '7313040',
    name: 'Lattimu',
  },
  {
    id: '7313040010',
    districtId: '7313040',
    name: 'Patangae',
  },
  {
    id: '7313040011',
    districtId: '7313040',
    name: 'Pasir Putih',
  },
  {
    id: '7313050001',
    districtId: '7313050',
    name: 'Ajuraja',
  },
  {
    id: '7313050002',
    districtId: '7313050',
    name: 'Soro',
  },
  {
    id: '7313050003',
    districtId: '7313050',
    name: 'Pantai Timur',
  },
  {
    id: '7313050004',
    districtId: '7313050',
    name: 'Manyili',
  },
  {
    id: '7313050005',
    districtId: '7313050',
    name: 'Lagoari',
  },
  {
    id: '7313050006',
    districtId: '7313050',
    name: 'Botto',
  },
  {
    id: '7313050007',
    districtId: '7313050',
    name: 'Lamarua',
  },
  {
    id: '7313050009',
    districtId: '7313050',
    name: 'Peneki',
  },
  {
    id: '7313050010',
    districtId: '7313050',
    name: 'Bocco',
  },
  {
    id: '7313050011',
    districtId: '7313050',
    name: 'Ceppaga',
  },
  {
    id: '7313050012',
    districtId: '7313050',
    name: 'Aluppang',
  },
  {
    id: '7313050013',
    districtId: '7313050',
    name: 'Parigi',
  },
  {
    id: '7313060009',
    districtId: '7313060',
    name: 'Assorajang',
  },
  {
    id: '7313060010',
    districtId: '7313060',
    name: 'Akkajeng',
  },
  {
    id: '7313060011',
    districtId: '7313060',
    name: 'Minangae',
  },
  {
    id: '7313060014',
    districtId: '7313060',
    name: 'Salobulo',
  },
  {
    id: '7313060015',
    districtId: '7313060',
    name: 'Akkotengeng',
  },
  {
    id: '7313060016',
    districtId: '7313060',
    name: 'Alewadeng',
  },
  {
    id: '7313060017',
    districtId: '7313060',
    name: 'Barangmamase',
  },
  {
    id: '7313060018',
    districtId: '7313060',
    name: 'Sakkoli',
  },
  {
    id: '7313060019',
    districtId: '7313060',
    name: 'Towalida',
  },
  {
    id: '7313061001',
    districtId: '7313061',
    name: 'Penrang',
  },
  {
    id: '7313061002',
    districtId: '7313061',
    name: 'Tadang Palie',
  },
  {
    id: '7313061003',
    districtId: '7313061',
    name: 'Walanga',
  },
  {
    id: '7313061004',
    districtId: '7313061',
    name: 'Temmabarang',
  },
  {
    id: '7313061005',
    districtId: '7313061',
    name: 'Lawesso',
  },
  {
    id: '7313061007',
    districtId: '7313061',
    name: 'Doping',
  },
  {
    id: '7313061008',
    districtId: '7313061',
    name: 'Raddae',
  },
  {
    id: '7313061009',
    districtId: '7313061',
    name: 'Padaelo',
  },
  {
    id: '7313061010',
    districtId: '7313061',
    name: 'Makmur',
  },
  {
    id: '7313070001',
    districtId: '7313070',
    name: 'Tua',
  },
  {
    id: '7313070002',
    districtId: '7313070',
    name: 'Tellu Limpoe',
  },
  {
    id: '7313070003',
    districtId: '7313070',
    name: 'Tosora',
  },
  {
    id: '7313070004',
    districtId: '7313070',
    name: 'Tajo',
  },
  {
    id: '7313070005',
    districtId: '7313070',
    name: 'Cinnong Tabi',
  },
  {
    id: '7313070006',
    districtId: '7313070',
    name: 'Watan Rumpia',
  },
  {
    id: '7313070007',
    districtId: '7313070',
    name: 'Tengnga',
  },
  {
    id: '7313070008',
    districtId: '7313070',
    name: 'Botto Tanre',
  },
  {
    id: '7313070009',
    districtId: '7313070',
    name: 'Rumpia',
  },
  {
    id: '7313070010',
    districtId: '7313070',
    name: 'Limpo Majang',
  },
  {
    id: '7313070011',
    districtId: '7313070',
    name: 'Paria',
  },
  {
    id: '7313070012',
    districtId: '7313070',
    name: 'Uraiang',
  },
  {
    id: '7313070013',
    districtId: '7313070',
    name: 'Macanang',
  },
  {
    id: '7313070014',
    districtId: '7313070',
    name: 'Laerung',
  },
  {
    id: '7313070015',
    districtId: '7313070',
    name: 'L I U',
  },
  {
    id: '7313070016',
    districtId: '7313070',
    name: 'Botto Benteng',
  },
  {
    id: '7313070017',
    districtId: '7313070',
    name: 'Botto Penno',
  },
  {
    id: '7313070018',
    districtId: '7313070',
    name: 'Lamiku',
  },
  {
    id: '7313080001',
    districtId: '7313080',
    name: 'Assorajang',
  },
  {
    id: '7313080002',
    districtId: '7313080',
    name: 'Pakkanna',
  },
  {
    id: '7313080003',
    districtId: '7313080',
    name: 'Wajoriaja',
  },
  {
    id: '7313080004',
    districtId: '7313080',
    name: 'Ujung Baru',
  },
  {
    id: '7313080005',
    districtId: '7313080',
    name: 'Nepo',
  },
  {
    id: '7313080006',
    districtId: '7313080',
    name: 'Pajalele',
  },
  {
    id: '7313080008',
    districtId: '7313080',
    name: 'Mario',
  },
  {
    id: '7313080009',
    districtId: '7313080',
    name: 'Waetuwo',
  },
  {
    id: '7313080010',
    districtId: '7313080',
    name: 'Wewangrewu',
  },
  {
    id: '7313080011',
    districtId: '7313080',
    name: 'Palippu',
  },
  {
    id: '7313080012',
    districtId: '7313080',
    name: 'Tancung',
  },
  {
    id: '7313080013',
    districtId: '7313080',
    name: 'Baru Tancung',
  },
  {
    id: '7313080014',
    districtId: '7313080',
    name: 'Pincengpute',
  },
  {
    id: '7313080015',
    districtId: '7313080',
    name: 'Mappadaelo',
  },
  {
    id: '7313080016',
    districtId: '7313080',
    name: 'Lowa',
  },
  {
    id: '7313080017',
    districtId: '7313080',
    name: 'Mannagae',
  },
  {
    id: '7313080018',
    districtId: '7313080',
    name: 'Inalipue',
  },
  {
    id: '7313080019',
    districtId: '7313080',
    name: 'Tonralipue',
  },
  {
    id: '7313090001',
    districtId: '7313090',
    name: 'Leppangeng',
  },
  {
    id: '7313090002',
    districtId: '7313090',
    name: 'Lautang',
  },
  {
    id: '7313090003',
    districtId: '7313090',
    name: 'Limpo Rilau',
  },
  {
    id: '7313090004',
    districtId: '7313090',
    name: 'Belawa',
  },
  {
    id: '7313090005',
    districtId: '7313090',
    name: 'Macero',
  },
  {
    id: '7313090006',
    districtId: '7313090',
    name: 'Malakke',
  },
  {
    id: '7313090007',
    districtId: '7313090',
    name: 'Ongkoe',
  },
  {
    id: '7313090008',
    districtId: '7313090',
    name: 'Sappa',
  },
  {
    id: '7313100001',
    districtId: '7313100',
    name: 'Tangkoli',
  },
  {
    id: '7313100002',
    districtId: '7313100',
    name: 'Dua Limpoe',
  },
  {
    id: '7313100003',
    districtId: '7313100',
    name: 'Anabanua',
  },
  {
    id: '7313100012',
    districtId: '7313100',
    name: 'Abbanuange',
  },
  {
    id: '7313100013',
    districtId: '7313100',
    name: 'Mattirowalie',
  },
  {
    id: '7313100014',
    districtId: '7313100',
    name: 'Kalola',
  },
  {
    id: '7313100015',
    districtId: '7313100',
    name: 'Sogi',
  },
  {
    id: '7313100016',
    districtId: '7313100',
    name: 'Minanga Tellue',
  },
  {
    id: '7313101001',
    districtId: '7313101',
    name: 'Lamata',
  },
  {
    id: '7313101002',
    districtId: '7313101',
    name: 'Poleonro',
  },
  {
    id: '7313101003',
    districtId: '7313101',
    name: 'Maminasae',
  },
  {
    id: '7313101004',
    districtId: '7313101',
    name: 'Abbatireng',
  },
  {
    id: '7313101005',
    districtId: '7313101',
    name: 'Polewalie',
  },
  {
    id: '7313101006',
    districtId: '7313101',
    name: 'Gilireng',
  },
  {
    id: '7313101007',
    districtId: '7313101',
    name: 'Alausalo',
  },
  {
    id: '7313101008',
    districtId: '7313101',
    name: 'Arajang',
  },
  {
    id: '7313101009',
    districtId: '7313101',
    name: 'Paselloreng',
  },
  {
    id: '7313110001',
    districtId: '7313110',
    name: 'Lalliseng',
  },
  {
    id: '7313110002',
    districtId: '7313110',
    name: 'Pattirolokka',
  },
  {
    id: '7313110003',
    districtId: '7313110',
    name: 'Inrello',
  },
  {
    id: '7313110004',
    districtId: '7313110',
    name: 'Ciromanie',
  },
  {
    id: '7313110005',
    districtId: '7313110',
    name: 'Ballere',
  },
  {
    id: '7313110006',
    districtId: '7313110',
    name: 'Keera',
  },
  {
    id: '7313110007',
    districtId: '7313110',
    name: 'Paojepe',
  },
  {
    id: '7313110008',
    districtId: '7313110',
    name: 'Labawang',
  },
  {
    id: '7313110009',
    districtId: '7313110',
    name: 'Awota',
  },
  {
    id: '7313110010',
    districtId: '7313110',
    name: 'A W O',
  },
  {
    id: '7313120001',
    districtId: '7313120',
    name: 'Simpellu',
  },
  {
    id: '7313120002',
    districtId: '7313120',
    name: 'Lompoloang',
  },
  {
    id: '7313120003',
    districtId: '7313120',
    name: 'Lauwa',
  },
  {
    id: '7313120004',
    districtId: '7313120',
    name: 'Alesilurunge',
  },
  {
    id: '7313120006',
    districtId: '7313120',
    name: 'Tobarakka',
  },
  {
    id: '7313120007',
    districtId: '7313120',
    name: 'Abbanderangnge',
  },
  {
    id: '7313120008',
    districtId: '7313120',
    name: 'Tangkoro',
  },
  {
    id: '7313120009',
    districtId: '7313120',
    name: 'Tanrongi',
  },
  {
    id: '7313120011',
    districtId: '7313120',
    name: 'Siwa',
  },
  {
    id: '7313120012',
    districtId: '7313120',
    name: 'Batu',
  },
  {
    id: '7313120013',
    districtId: '7313120',
    name: 'Tellesang',
  },
  {
    id: '7313120014',
    districtId: '7313120',
    name: 'Marannu',
  },
  {
    id: '7313120015',
    districtId: '7313120',
    name: 'Jauh Pandang',
  },
  {
    id: '7313120016',
    districtId: '7313120',
    name: 'Lacinde',
  },
  {
    id: '7313120017',
    districtId: '7313120',
    name: 'Buriko',
  },
  {
    id: '7313120018',
    districtId: '7313120',
    name: 'Bau - Bau',
  },
  {
    id: '7313120019',
    districtId: '7313120',
    name: 'Ale Lebbae',
  },
  {
    id: '7313120020',
    districtId: '7313120',
    name: 'Bulu Siwa',
  },
  {
    id: '7313120021',
    districtId: '7313120',
    name: 'Botto Tengnga',
  },
  {
    id: '7313120022',
    districtId: '7313120',
    name: 'Kaluku',
  },
  {
    id: '7313120023',
    districtId: '7313120',
    name: 'Mattirowalie',
  },
  {
    id: '7313120024',
    districtId: '7313120',
    name: 'Macolli Loloe',
  },
  {
    id: '7313120025',
    districtId: '7313120',
    name: 'Lompo Bulo',
  },
  {
    id: '7313120026',
    districtId: '7313120',
    name: 'Padang Loang',
  },
  {
    id: '7313120027',
    districtId: '7313120',
    name: 'Kompong',
  },
  {
    id: '7314010001',
    districtId: '7314010',
    name: 'Cenrana',
  },
  {
    id: '7314010002',
    districtId: '7314010',
    name: 'Bapangi',
  },
  {
    id: '7314010003',
    districtId: '7314010',
    name: 'Wanio Timoreng',
  },
  {
    id: '7314010004',
    districtId: '7314010',
    name: 'Wanio',
  },
  {
    id: '7314010005',
    districtId: '7314010',
    name: 'Bilokka',
  },
  {
    id: '7314010006',
    districtId: '7314010',
    name: 'Corawali',
  },
  {
    id: '7314010007',
    districtId: '7314010',
    name: 'Lise',
  },
  {
    id: '7314010008',
    districtId: '7314010',
    name: 'Allesalewoe',
  },
  {
    id: '7314010009',
    districtId: '7314010',
    name: 'Lajonga',
  },
  {
    id: '7314020001',
    districtId: '7314020',
    name: 'Teppo',
  },
  {
    id: '7314020002',
    districtId: '7314020',
    name: 'Massepe',
  },
  {
    id: '7314020004',
    districtId: '7314020',
    name: 'Pajalele',
  },
  {
    id: '7314020005',
    districtId: '7314020',
    name: 'Polewali',
  },
  {
    id: '7314020006',
    districtId: '7314020',
    name: 'Teteaji',
  },
  {
    id: '7314020007',
    districtId: '7314020',
    name: 'Amparita',
  },
  {
    id: '7314020008',
    districtId: '7314020',
    name: 'Baula',
  },
  {
    id: '7314020009',
    districtId: '7314020',
    name: 'Todang Pulu',
  },
  {
    id: '7314020010',
    districtId: '7314020',
    name: 'Arateng',
  },
  {
    id: '7314030001',
    districtId: '7314030',
    name: 'Mattirotasi',
  },
  {
    id: '7314030002',
    districtId: '7314030',
    name: 'Buae',
  },
  {
    id: '7314030003',
    districtId: '7314030',
    name: 'Lainungan',
  },
  {
    id: '7314030004',
    districtId: '7314030',
    name: 'Lawawoi',
  },
  {
    id: '7314030005',
    districtId: '7314030',
    name: 'Bangkai',
  },
  {
    id: '7314030006',
    districtId: '7314030',
    name: 'Uluale',
  },
  {
    id: '7314030007',
    districtId: '7314030',
    name: 'Arawa',
  },
  {
    id: '7314030008',
    districtId: '7314030',
    name: 'Batulappa',
  },
  {
    id: '7314030009',
    districtId: '7314030',
    name: 'Ciro-Ciroe',
  },
  {
    id: '7314030010',
    districtId: '7314030',
    name: 'Carawali',
  },
  {
    id: '7314040001',
    districtId: '7314040',
    name: 'Manisa',
  },
  {
    id: '7314040002',
    districtId: '7314040',
    name: 'Panreng',
  },
  {
    id: '7314040004',
    districtId: '7314040',
    name: 'Baranti',
  },
  {
    id: '7314040005',
    districtId: '7314040',
    name: 'Sipodeceng',
  },
  {
    id: '7314040006',
    districtId: '7314040',
    name: 'Passeno',
  },
  {
    id: '7314040007',
    districtId: '7314040',
    name: 'Duampanua',
  },
  {
    id: '7314040008',
    districtId: '7314040',
    name: 'Tonronge',
  },
  {
    id: '7314040009',
    districtId: '7314040',
    name: 'Tonrong Rijang',
  },
  {
    id: '7314050001',
    districtId: '7314050',
    name: 'Kadidi',
  },
  {
    id: '7314050002',
    districtId: '7314050',
    name: 'Macorawalie',
  },
  {
    id: '7314050003',
    districtId: '7314050',
    name: 'Timoreng Panua',
  },
  {
    id: '7314050004',
    districtId: '7314050',
    name: 'Cipotakari',
  },
  {
    id: '7314050005',
    districtId: '7314050',
    name: 'Bulo',
  },
  {
    id: '7314050006',
    districtId: '7314050',
    name: 'Bulo Wattang',
  },
  {
    id: '7314050007',
    districtId: '7314050',
    name: 'Lalebata',
  },
  {
    id: '7314050008',
    districtId: '7314050',
    name: 'Rappang',
  },
  {
    id: '7314051001',
    districtId: '7314051',
    name: 'Mario',
  },
  {
    id: '7314051002',
    districtId: '7314051',
    name: 'Rijang Panua',
  },
  {
    id: '7314051003',
    districtId: '7314051',
    name: 'Kulo',
  },
  {
    id: '7314051004',
    districtId: '7314051',
    name: 'Abbokongang',
  },
  {
    id: '7314051005',
    districtId: '7314051',
    name: 'Maddenra',
  },
  {
    id: '7314051006',
    districtId: '7314051',
    name: 'Bina Baru',
  },
  {
    id: '7314060001',
    districtId: '7314060',
    name: 'Takkalasi',
  },
  {
    id: '7314060002',
    districtId: '7314060',
    name: 'Allakuang',
  },
  {
    id: '7314060003',
    districtId: '7314060',
    name: 'Tanete',
  },
  {
    id: '7314060004',
    districtId: '7314060',
    name: 'Lautang Benteng',
  },
  {
    id: '7314060005',
    districtId: '7314060',
    name: 'Rijang Pittu',
  },
  {
    id: '7314060006',
    districtId: '7314060',
    name: 'Lakessi',
  },
  {
    id: '7314060007',
    districtId: '7314060',
    name: 'Pangkajene',
  },
  {
    id: '7314060008',
    districtId: '7314060',
    name: 'Wala',
  },
  {
    id: '7314060009',
    districtId: '7314060',
    name: 'Majjelling',
  },
  {
    id: '7314060010',
    districtId: '7314060',
    name: 'Majelling Watang',
  },
  {
    id: '7314060011',
    districtId: '7314060',
    name: 'Sereang',
  },
  {
    id: '7314060012',
    districtId: '7314060',
    name: 'Kanie',
  },
  {
    id: '7314061001',
    districtId: '7314061',
    name: 'Kanyuara',
  },
  {
    id: '7314061002',
    districtId: '7314061',
    name: 'Sidenreng',
  },
  {
    id: '7314061003',
    districtId: '7314061',
    name: 'Empagae',
  },
  {
    id: '7314061004',
    districtId: '7314061',
    name: 'Mojong',
  },
  {
    id: '7314061005',
    districtId: '7314061',
    name: 'Talumae',
  },
  {
    id: '7314061006',
    districtId: '7314061',
    name: 'Aka-Akae',
  },
  {
    id: '7314061007',
    districtId: '7314061',
    name: 'Damai',
  },
  {
    id: '7314061008',
    districtId: '7314061',
    name: 'Talawe',
  },
  {
    id: '7314070001',
    districtId: '7314070',
    name: 'Ponrangae',
  },
  {
    id: '7314070002',
    districtId: '7314070',
    name: 'Lancirang',
  },
  {
    id: '7314070003',
    districtId: '7314070',
    name: 'Sumpang Mango',
  },
  {
    id: '7314070004',
    districtId: '7314070',
    name: 'Lasiwala',
  },
  {
    id: '7314070005',
    districtId: '7314070',
    name: 'Ajubissue',
  },
  {
    id: '7314070006',
    districtId: '7314070',
    name: 'Dongi',
  },
  {
    id: '7314070007',
    districtId: '7314070',
    name: 'Otting',
  },
  {
    id: '7314070008',
    districtId: '7314070',
    name: 'Ana Banna',
  },
  {
    id: '7314070009',
    districtId: '7314070',
    name: 'Bulu Cenrana',
  },
  {
    id: '7314070010',
    districtId: '7314070',
    name: 'Betao',
  },
  {
    id: '7314070014',
    districtId: '7314070',
    name: 'Betao Riase',
  },
  {
    id: '7314070015',
    districtId: '7314070',
    name: 'Kalempang',
  },
  {
    id: '7314080001',
    districtId: '7314080',
    name: 'Padangloang',
  },
  {
    id: '7314080002',
    districtId: '7314080',
    name: 'Padangloang Alau',
  },
  {
    id: '7314080003',
    districtId: '7314080',
    name: 'Salo Mallori',
  },
  {
    id: '7314080004',
    districtId: '7314080',
    name: 'Tanrutedong',
  },
  {
    id: '7314080005',
    districtId: '7314080',
    name: 'Kalosi',
  },
  {
    id: '7314080006',
    districtId: '7314080',
    name: 'Kalosi Alau',
  },
  {
    id: '7314080007',
    districtId: '7314080',
    name: 'Taccimpo',
  },
  {
    id: '7314080008',
    districtId: '7314080',
    name: 'Salobukkang',
  },
  {
    id: '7314080010',
    districtId: '7314080',
    name: 'Bila',
  },
  {
    id: '7314080011',
    districtId: '7314080',
    name: 'Kampale',
  },
  {
    id: '7314081001',
    districtId: '7314081',
    name: 'Bola Bulu',
  },
  {
    id: '7314081002',
    districtId: '7314081',
    name: 'Botto',
  },
  {
    id: '7314081003',
    districtId: '7314081',
    name: 'Bila Riase',
  },
  {
    id: '7314081004',
    districtId: '7314081',
    name: 'Lagading',
  },
  {
    id: '7314081005',
    districtId: '7314081',
    name: 'Batu',
  },
  {
    id: '7314081007',
    districtId: '7314081',
    name: 'Tanatoro',
  },
  {
    id: '7314081008',
    districtId: '7314081',
    name: 'Compong',
  },
  {
    id: '7314081009',
    districtId: '7314081',
    name: 'Leppangeng',
  },
  {
    id: '7314081010',
    districtId: '7314081',
    name: 'Lombo',
  },
  {
    id: '7314081012',
    districtId: '7314081',
    name: 'Buntu Buanging',
  },
  {
    id: '7314081013',
    districtId: '7314081',
    name: 'Belawae',
  },
  {
    id: '7315010001',
    districtId: '7315010',
    name: 'Lero',
  },
  {
    id: '7315010002',
    districtId: '7315010',
    name: 'Ujung Labuang',
  },
  {
    id: '7315010003',
    districtId: '7315010',
    name: 'Wiringtasi',
  },
  {
    id: '7315010004',
    districtId: '7315010',
    name: 'Tasiwalie',
  },
  {
    id: '7315010005',
    districtId: '7315010',
    name: 'Maritengngae',
  },
  {
    id: '7315010006',
    districtId: '7315010',
    name: 'Watang Suppa',
  },
  {
    id: '7315010007',
    districtId: '7315010',
    name: 'Tellumpanua',
  },
  {
    id: '7315010008',
    districtId: '7315010',
    name: 'Wattang Pulu',
  },
  {
    id: '7315010009',
    districtId: '7315010',
    name: 'Polewali',
  },
  {
    id: '7315010010',
    districtId: '7315010',
    name: 'Lotang Salo',
  },
  {
    id: '7315020007',
    districtId: '7315020',
    name: 'Massulowalie',
  },
  {
    id: '7315020009',
    districtId: '7315020',
    name: 'Langa',
  },
  {
    id: '7315020010',
    districtId: '7315020',
    name: 'Pallameang',
  },
  {
    id: '7315020011',
    districtId: '7315020',
    name: 'Mattombong',
  },
  {
    id: '7315020012',
    districtId: '7315020',
    name: 'Patobong',
  },
  {
    id: '7315020013',
    districtId: '7315020',
    name: 'Samaenre',
  },
  {
    id: '7315020014',
    districtId: '7315020',
    name: 'Mattongang Tongang',
  },
  {
    id: '7315020015',
    districtId: '7315020',
    name: 'Mattiro Tasi',
  },
  {
    id: '7315020016',
    districtId: '7315020',
    name: 'Siwolong Polong',
  },
  {
    id: '7315021001',
    districtId: '7315021',
    name: 'Lanrisang',
  },
  {
    id: '7315021002',
    districtId: '7315021',
    name: 'Lerang',
  },
  {
    id: '7315021003',
    districtId: '7315021',
    name: 'Samaulue',
  },
  {
    id: '7315021004',
    districtId: '7315021',
    name: 'Mallongi Longi',
  },
  {
    id: '7315021005',
    districtId: '7315021',
    name: 'Amassangang',
  },
  {
    id: '7315021006',
    districtId: '7315021',
    name: 'Barang Palie',
  },
  {
    id: '7315021007',
    districtId: '7315021',
    name: 'Wae Tuwoe',
  },
  {
    id: '7315030001',
    districtId: '7315030',
    name: 'Makkawaru',
  },
  {
    id: '7315030002',
    districtId: '7315030',
    name: 'Alitta',
  },
  {
    id: '7315030003',
    districtId: '7315030',
    name: 'Pannanrang',
  },
  {
    id: '7315030004',
    districtId: '7315030',
    name: 'Padaidi',
  },
  {
    id: '7315030005',
    districtId: '7315030',
    name: 'Manarang',
  },
  {
    id: '7315030006',
    districtId: '7315030',
    name: 'Padaelo',
  },
  {
    id: '7315030007',
    districtId: '7315030',
    name: 'Padakkalawa',
  },
  {
    id: '7315030008',
    districtId: '7315030',
    name: 'Marannu',
  },
  {
    id: '7315030009',
    districtId: '7315030',
    name: 'Bunga',
  },
  {
    id: '7315040001',
    districtId: '7315040',
    name: 'Siparappe',
  },
  {
    id: '7315040002',
    districtId: '7315040',
    name: 'Salo',
  },
  {
    id: '7315040003',
    districtId: '7315040',
    name: 'Sipatokkong',
  },
  {
    id: '7315040004',
    districtId: '7315040',
    name: 'Penrang',
  },
  {
    id: '7315040005',
    districtId: '7315040',
    name: 'Jaya',
  },
  {
    id: '7315040006',
    districtId: '7315040',
    name: 'Sawitto',
  },
  {
    id: '7315040013',
    districtId: '7315040',
    name: 'Macorawalie',
  },
  {
    id: '7315041001',
    districtId: '7315041',
    name: 'Benteng Sawitto',
  },
  {
    id: '7315041002',
    districtId: '7315041',
    name: 'Laleng Bata',
  },
  {
    id: '7315041003',
    districtId: '7315041',
    name: 'Temmassarangnge',
  },
  {
    id: '7315041004',
    districtId: '7315041',
    name: 'Pacongang',
  },
  {
    id: '7315041005',
    districtId: '7315041',
    name: 'Macinnae',
  },
  {
    id: '7315041006',
    districtId: '7315041',
    name: 'Mamminasae',
  },
  {
    id: '7315042001',
    districtId: '7315042',
    name: 'Pammase',
  },
  {
    id: '7315042002',
    districtId: '7315042',
    name: 'Marawi',
  },
  {
    id: '7315042003',
    districtId: '7315042',
    name: 'Mattiro Deceng',
  },
  {
    id: '7315042004',
    districtId: '7315042',
    name: 'Fakkie',
  },
  {
    id: '7315042005',
    districtId: '7315042',
    name: 'Tiroang',
  },
  {
    id: '7315050001',
    districtId: '7315050',
    name: 'Mattiro Ade',
  },
  {
    id: '7315050002',
    districtId: '7315050',
    name: 'Leppangang',
  },
  {
    id: '7315050003',
    districtId: '7315050',
    name: 'Pincara',
  },
  {
    id: '7315050004',
    districtId: '7315050',
    name: 'Teppo',
  },
  {
    id: '7315050005',
    districtId: '7315050',
    name: 'Tonyamang',
  },
  {
    id: '7315050006',
    districtId: '7315050',
    name: 'Maccirinna',
  },
  {
    id: '7315050007',
    districtId: '7315050',
    name: 'Padangloang',
  },
  {
    id: '7315050008',
    districtId: '7315050',
    name: 'Malimpung',
  },
  {
    id: '7315050009',
    districtId: '7315050',
    name: 'Sipatuo',
  },
  {
    id: '7315050011',
    districtId: '7315050',
    name: 'Masolo',
  },
  {
    id: '7315060001',
    districtId: '7315060',
    name: 'Tadang Palie',
  },
  {
    id: '7315060002',
    districtId: '7315060',
    name: 'Salipolo',
  },
  {
    id: '7315060003',
    districtId: '7315060',
    name: 'Sikkuale',
  },
  {
    id: '7315060004',
    districtId: '7315060',
    name: 'Mattunru Tunrue',
  },
  {
    id: '7315060005',
    districtId: '7315060',
    name: 'Cempa',
  },
  {
    id: '7315060006',
    districtId: '7315060',
    name: 'Tanra Tuo',
  },
  {
    id: '7315060007',
    districtId: '7315060',
    name: 'Mangki',
  },
  {
    id: '7315070001',
    districtId: '7315070',
    name: 'Baba Binanga',
  },
  {
    id: '7315070002',
    districtId: '7315070',
    name: 'Paria',
  },
  {
    id: '7315070003',
    districtId: '7315070',
    name: 'Tatae',
  },
  {
    id: '7315070004',
    districtId: '7315070',
    name: 'Kaliang',
  },
  {
    id: '7315070005',
    districtId: '7315070',
    name: 'Pekkabata',
  },
  {
    id: '7315070006',
    districtId: '7315070',
    name: 'Katomporang',
  },
  {
    id: '7315070007',
    districtId: '7315070',
    name: 'Kaballangang',
  },
  {
    id: '7315070008',
    districtId: '7315070',
    name: 'Massewae',
  },
  {
    id: '7315070011',
    districtId: '7315070',
    name: 'Lampa',
  },
  {
    id: '7315070012',
    districtId: '7315070',
    name: 'Bittoeng',
  },
  {
    id: '7315070013',
    districtId: '7315070',
    name: 'Data',
  },
  {
    id: '7315070014',
    districtId: '7315070',
    name: 'Maroneng',
  },
  {
    id: '7315070015',
    districtId: '7315070',
    name: 'Bungi',
  },
  {
    id: '7315070016',
    districtId: '7315070',
    name: 'Buttu Sawe',
  },
  {
    id: '7315070017',
    districtId: '7315070',
    name: 'Barugae',
  },
  {
    id: '7315071001',
    districtId: '7315071',
    name: 'Tapporang',
  },
  {
    id: '7315071002',
    districtId: '7315071',
    name: 'Kassa',
  },
  {
    id: '7315071003',
    districtId: '7315071',
    name: 'Watang Kassa',
  },
  {
    id: '7315071004',
    districtId: '7315071',
    name: 'Batulappa',
  },
  {
    id: '7315071005',
    districtId: '7315071',
    name: 'Kaseralau',
  },
  {
    id: '7315080001',
    districtId: '7315080',
    name: 'Binanga Karaeng',
  },
  {
    id: '7315080002',
    districtId: '7315080',
    name: 'Sabbang Paru',
  },
  {
    id: '7315080003',
    districtId: '7315080',
    name: 'Tadokkong',
  },
  {
    id: '7315080004',
    districtId: '7315080',
    name: 'Pakeng',
  },
  {
    id: '7315080005',
    districtId: '7315080',
    name: 'Rajang',
  },
  {
    id: '7315080006',
    districtId: '7315080',
    name: 'Letta',
  },
  {
    id: '7315080008',
    districtId: '7315080',
    name: 'Kariango',
  },
  {
    id: '7315080009',
    districtId: '7315080',
    name: 'Ulusaddang',
  },
  {
    id: '7315080011',
    districtId: '7315080',
    name: 'Benteng Paremba',
  },
  {
    id: '7315080012',
    districtId: '7315080',
    name: 'Sali Sali',
  },
  {
    id: '7315080013',
    districtId: '7315080',
    name: 'Suppirang',
  },
  {
    id: '7315080014',
    districtId: '7315080',
    name: 'Lembang Mesakada',
  },
  {
    id: '7315080015',
    districtId: '7315080',
    name: 'Basseang',
  },
  {
    id: '7315080016',
    districtId: '7315080',
    name: 'Pangaparang',
  },
  {
    id: '7315080017',
    districtId: '7315080',
    name: 'Bakaru',
  },
  {
    id: '7316010001',
    districtId: '7316010',
    name: 'Patondon Salu',
  },
  {
    id: '7316010002',
    districtId: '7316010',
    name: 'Salo Dua',
  },
  {
    id: '7316010003',
    districtId: '7316010',
    name: 'Boiya',
  },
  {
    id: '7316010005',
    districtId: '7316010',
    name: 'Bangkala',
  },
  {
    id: '7316010006',
    districtId: '7316010',
    name: 'Mengkawani',
  },
  {
    id: '7316010007',
    districtId: '7316010',
    name: 'Boto Malangga',
  },
  {
    id: '7316010008',
    districtId: '7316010',
    name: 'Batu Mila',
  },
  {
    id: '7316010009',
    districtId: '7316010',
    name: 'Puncak Harapan',
  },
  {
    id: '7316010010',
    districtId: '7316010',
    name: 'Tapong',
  },
  {
    id: '7316010013',
    districtId: '7316010',
    name: 'Palakka',
  },
  {
    id: '7316010014',
    districtId: '7316010',
    name: 'Pasang',
  },
  {
    id: '7316010015',
    districtId: '7316010',
    name: 'Baringin',
  },
  {
    id: '7316010016',
    districtId: '7316010',
    name: 'Lebani',
  },
  {
    id: '7316010017',
    districtId: '7316010',
    name: 'Matajang',
  },
  {
    id: '7316010018',
    districtId: '7316010',
    name: 'Limbuang',
  },
  {
    id: '7316010019',
    districtId: '7316010',
    name: 'Ongko',
  },
  {
    id: '7316010020',
    districtId: '7316010',
    name: 'Pariwang',
  },
  {
    id: '7316010021',
    districtId: '7316010',
    name: 'Kaluppang',
  },
  {
    id: '7316010022',
    districtId: '7316010',
    name: 'Paladdang',
  },
  {
    id: '7316010023',
    districtId: '7316010',
    name: 'Labuku',
  },
  {
    id: '7316010024',
    districtId: '7316010',
    name: 'Tanete',
  },
  {
    id: '7316011002',
    districtId: '7316011',
    name: 'Tallang Rilau',
  },
  {
    id: '7316011005',
    districtId: '7316011',
    name: 'Bulo',
  },
  {
    id: '7316011006',
    districtId: '7316011',
    name: 'Baruka',
  },
  {
    id: '7316011007',
    districtId: '7316011',
    name: 'Bungin',
  },
  {
    id: '7316011008',
    districtId: '7316011',
    name: 'Sawito',
  },
  {
    id: '7316011009',
    districtId: '7316011',
    name: 'Banua',
  },
  {
    id: '7316020008',
    districtId: '7316020',
    name: 'Leoran',
  },
  {
    id: '7316020009',
    districtId: '7316020',
    name: 'Galonta',
  },
  {
    id: '7316020010',
    districtId: '7316020',
    name: 'Juppandang',
  },
  {
    id: '7316020011',
    districtId: '7316020',
    name: 'Lewaja',
  },
  {
    id: '7316020012',
    districtId: '7316020',
    name: 'Ranga',
  },
  {
    id: '7316020013',
    districtId: '7316020',
    name: 'Kaluppini',
  },
  {
    id: '7316020014',
    districtId: '7316020',
    name: 'Tobalu',
  },
  {
    id: '7316020015',
    districtId: '7316020',
    name: 'Tokkonan',
  },
  {
    id: '7316020017',
    districtId: '7316020',
    name: 'Karueng',
  },
  {
    id: '7316020018',
    districtId: '7316020',
    name: 'Cemba',
  },
  {
    id: '7316020019',
    districtId: '7316020',
    name: 'Tungka',
  },
  {
    id: '7316020020',
    districtId: '7316020',
    name: 'Temban',
  },
  {
    id: '7316020021',
    districtId: '7316020',
    name: 'Buttu Batu',
  },
  {
    id: '7316020022',
    districtId: '7316020',
    name: 'Tallu Bamba',
  },
  {
    id: '7316020023',
    districtId: '7316020',
    name: 'Tuara',
  },
  {
    id: '7316020024',
    districtId: '7316020',
    name: 'Lembang',
  },
  {
    id: '7316020025',
    districtId: '7316020',
    name: 'Rosoan',
  },
  {
    id: '7316021001',
    districtId: '7316021',
    name: 'Malalin',
  },
  {
    id: '7316021002',
    districtId: '7316021',
    name: 'Karrang',
  },
  {
    id: '7316021003',
    districtId: '7316021',
    name: 'Taulan',
  },
  {
    id: '7316021004',
    districtId: '7316021',
    name: 'Pundilemo',
  },
  {
    id: '7316021005',
    districtId: '7316021',
    name: 'Cendana',
  },
  {
    id: '7316021006',
    districtId: '7316021',
    name: 'Lebang',
  },
  {
    id: '7316021007',
    districtId: '7316021',
    name: 'Pinang',
  },
  {
    id: '7316030001',
    districtId: '7316030',
    name: 'Kadingeh',
  },
  {
    id: '7316030007',
    districtId: '7316030',
    name: 'Janggurara',
  },
  {
    id: '7316030008',
    districtId: '7316030',
    name: 'Banti',
  },
  {
    id: '7316030009',
    districtId: '7316030',
    name: 'Perangian',
  },
  {
    id: '7316030010',
    districtId: '7316030',
    name: 'Parinding',
  },
  {
    id: '7316030011',
    districtId: '7316030',
    name: 'Tomenawa',
  },
  {
    id: '7316030012',
    districtId: '7316030',
    name: 'Baraka',
  },
  {
    id: '7316030014',
    districtId: '7316030',
    name: 'Bontongan',
  },
  {
    id: '7316030017',
    districtId: '7316030',
    name: 'Pepandungan',
  },
  {
    id: '7316030018',
    districtId: '7316030',
    name: 'Kendenan',
  },
  {
    id: '7316030019',
    districtId: '7316030',
    name: 'Salukanan',
  },
  {
    id: '7316030020',
    districtId: '7316030',
    name: 'Tiro Wali',
  },
  {
    id: '7316030021',
    districtId: '7316030',
    name: 'Pandung Batu',
  },
  {
    id: '7316030022',
    districtId: '7316030',
    name: 'Balla',
  },
  {
    id: '7316030023',
    districtId: '7316030',
    name: 'Bone Bone',
  },
  {
    id: '7316031002',
    districtId: '7316031',
    name: 'Ledan',
  },
  {
    id: '7316031003',
    districtId: '7316031',
    name: 'Potok Ullin',
  },
  {
    id: '7316031004',
    districtId: '7316031',
    name: 'Eran Batu',
  },
  {
    id: '7316031005',
    districtId: '7316031',
    name: 'Langda',
  },
  {
    id: '7316031006',
    districtId: '7316031',
    name: 'Pasui',
  },
  {
    id: '7316031015',
    districtId: '7316031',
    name: 'Buntu Mondong',
  },
  {
    id: '7316031016',
    districtId: '7316031',
    name: 'Latimojong',
  },
  {
    id: '7316040001',
    districtId: '7316040',
    name: 'Tindallun',
  },
  {
    id: '7316040002',
    districtId: '7316040',
    name: 'Bamba Puang',
  },
  {
    id: '7316040003',
    districtId: '7316040',
    name: 'Tanete',
  },
  {
    id: '7316040007',
    districtId: '7316040',
    name: 'Lakawan',
  },
  {
    id: '7316040008',
    districtId: '7316040',
    name: 'Siambo',
  },
  {
    id: '7316040009',
    districtId: '7316040',
    name: 'Singki',
  },
  {
    id: '7316040010',
    districtId: '7316040',
    name: 'Mataran',
  },
  {
    id: '7316040011',
    districtId: '7316040',
    name: 'Pekalobean',
  },
  {
    id: '7316040012',
    districtId: '7316040',
    name: 'Bubun Lamba',
  },
  {
    id: '7316040013',
    districtId: '7316040',
    name: 'Salu Dewata',
  },
  {
    id: '7316040014',
    districtId: '7316040',
    name: 'Mampu',
  },
  {
    id: '7316040015',
    districtId: '7316040',
    name: 'Batu Noni',
  },
  {
    id: '7316040016',
    districtId: '7316040',
    name: 'Saruran',
  },
  {
    id: '7316040017',
    districtId: '7316040',
    name: 'Tampo',
  },
  {
    id: '7316040018',
    districtId: '7316040',
    name: 'Mandatte',
  },
  {
    id: '7316041001',
    districtId: '7316041',
    name: 'Tangru',
  },
  {
    id: '7316041005',
    districtId: '7316041',
    name: 'Tallung Tondok',
  },
  {
    id: '7316041006',
    districtId: '7316041',
    name: 'Kolai',
  },
  {
    id: '7316041007',
    districtId: '7316041',
    name: 'Bonto',
  },
  {
    id: '7316041008',
    districtId: '7316041',
    name: 'Malua',
  },
  {
    id: '7316041009',
    districtId: '7316041',
    name: 'Rante Mario',
  },
  {
    id: '7316041010',
    districtId: '7316041',
    name: 'Dulang',
  },
  {
    id: '7316041011',
    districtId: '7316041',
    name: 'Buntu Batuan',
  },
  {
    id: '7316050003',
    districtId: '7316050',
    name: 'Mata Allo',
  },
  {
    id: '7316050004',
    districtId: '7316050',
    name: 'Kalosi',
  },
  {
    id: '7316050015',
    districtId: '7316050',
    name: 'Kambiolangi',
  },
  {
    id: '7316050016',
    districtId: '7316050',
    name: 'Buntu Sugi',
  },
  {
    id: '7316050017',
    districtId: '7316050',
    name: 'Sumillan',
  },
  {
    id: '7316050024',
    districtId: '7316050',
    name: 'Pana',
  },
  {
    id: '7316050027',
    districtId: '7316050',
    name: 'Bolang',
  },
  {
    id: '7316050028',
    districtId: '7316050',
    name: 'Taulo',
  },
  {
    id: '7316051003',
    districtId: '7316051',
    name: 'Mekkalak',
  },
  {
    id: '7316051004',
    districtId: '7316051',
    name: 'Buntu Pema',
  },
  {
    id: '7316051005',
    districtId: '7316051',
    name: 'Tallungura',
  },
  {
    id: '7316051006',
    districtId: '7316051',
    name: 'Sanglepongan',
  },
  {
    id: '7316051007',
    districtId: '7316051',
    name: 'Parombean',
  },
  {
    id: '7316051008',
    districtId: '7316051',
    name: 'Curio',
  },
  {
    id: '7316051009',
    districtId: '7316051',
    name: 'Pabaloran',
  },
  {
    id: '7316051010',
    districtId: '7316051',
    name: 'Buntu Barana',
  },
  {
    id: '7316051011',
    districtId: '7316051',
    name: 'Salassa',
  },
  {
    id: '7316051012',
    districtId: '7316051',
    name: 'Sumbang',
  },
  {
    id: '7316051013',
    districtId: '7316051',
    name: 'Mandalan',
  },
  {
    id: '7316052001',
    districtId: '7316052',
    name: 'Buntu Sarong',
  },
  {
    id: '7316052002',
    districtId: '7316052',
    name: 'Masalle',
  },
  {
    id: '7316052018',
    districtId: '7316052',
    name: 'Rampunan',
  },
  {
    id: '7316052019',
    districtId: '7316052',
    name: 'Mundan',
  },
  {
    id: '7316052020',
    districtId: '7316052',
    name: 'Tongkonan Basse',
  },
  {
    id: '7316052021',
    districtId: '7316052',
    name: 'Batu Kede',
  },
  {
    id: '7316053001',
    districtId: '7316053',
    name: 'Baroko',
  },
  {
    id: '7316053002',
    districtId: '7316053',
    name: 'Tongko',
  },
  {
    id: '7316053003',
    districtId: '7316053',
    name: 'Patongloan',
  },
  {
    id: '7316053004',
    districtId: '7316053',
    name: 'Benteng Alla Utara',
  },
  {
    id: '7316053005',
    districtId: '7316053',
    name: 'Benteng Alla',
  },
  {
    id: '7317010010',
    districtId: '7317010',
    name: 'Riwang',
  },
  {
    id: '7317010011',
    districtId: '7317010',
    name: 'Rante Belu',
  },
  {
    id: '7317010012',
    districtId: '7317010',
    name: 'Buntu Matabbing',
  },
  {
    id: '7317010013',
    districtId: '7317010',
    name: 'Komba',
  },
  {
    id: '7317010014',
    districtId: '7317010',
    name: 'Bilante',
  },
  {
    id: '7317010015',
    districtId: '7317010',
    name: 'Binturu',
  },
  {
    id: '7317010016',
    districtId: '7317010',
    name: 'Bukit Sutra',
  },
  {
    id: '7317010017',
    districtId: '7317010',
    name: 'Rante Alang',
  },
  {
    id: '7317010018',
    districtId: '7317010',
    name: 'Lumaring',
  },
  {
    id: '7317010019',
    districtId: '7317010',
    name: 'Larompong',
  },
  {
    id: '7317010020',
    districtId: '7317010',
    name: 'Riwang Selatan',
  },
  {
    id: '7317010021',
    districtId: '7317010',
    name: 'Buntu Pasik',
  },
  {
    id: '7317010022',
    districtId: '7317010',
    name: 'Komba Selatan',
  },
  {
    id: '7317011001',
    districtId: '7317011',
    name: "La'Loa",
  },
  {
    id: '7317011002',
    districtId: '7317011',
    name: 'Batu Lappa',
  },
  {
    id: '7317011003',
    districtId: '7317011',
    name: 'Bonepute',
  },
  {
    id: '7317011004',
    districtId: '7317011',
    name: "Tembo'E",
  },
  {
    id: '7317011005',
    districtId: '7317011',
    name: 'Salusana',
  },
  {
    id: '7317011006',
    districtId: '7317011',
    name: 'Dadeko',
  },
  {
    id: '7317011007',
    districtId: '7317011',
    name: 'Sampano',
  },
  {
    id: '7317011008',
    districtId: '7317011',
    name: 'Malewong',
  },
  {
    id: '7317011009',
    districtId: '7317011',
    name: 'Babang',
  },
  {
    id: '7317011010',
    districtId: '7317011',
    name: 'Gandang Batu',
  },
  {
    id: '7317020006',
    districtId: '7317020',
    name: 'Tawondu',
  },
  {
    id: '7317020007',
    districtId: '7317020',
    name: 'Murante',
  },
  {
    id: '7317020008',
    districtId: '7317020',
    name: 'Suli',
  },
  {
    id: '7317020009',
    districtId: '7317020',
    name: 'Buntu Kunyi',
  },
  {
    id: '7317020010',
    districtId: '7317020',
    name: 'Lempopacci',
  },
  {
    id: '7317020011',
    districtId: '7317020',
    name: 'Botta',
  },
  {
    id: '7317020012',
    districtId: '7317020',
    name: 'Padang Lambe',
  },
  {
    id: '7317020013',
    districtId: '7317020',
    name: 'Cakkeawo',
  },
  {
    id: '7317020014',
    districtId: '7317020',
    name: 'Malela',
  },
  {
    id: '7317020015',
    districtId: '7317020',
    name: 'Cimpu',
  },
  {
    id: '7317020016',
    districtId: '7317020',
    name: 'Kasiwiang',
  },
  {
    id: '7317020017',
    districtId: '7317020',
    name: 'Papakaju',
  },
  {
    id: '7317020018',
    districtId: '7317020',
    name: 'Cimpu Utara',
  },
  {
    id: '7317021001',
    districtId: '7317021',
    name: 'Poringan',
  },
  {
    id: '7317021002',
    districtId: '7317021',
    name: 'Kaili',
  },
  {
    id: '7317021003',
    districtId: '7317021',
    name: 'Salubua',
  },
  {
    id: '7317021004',
    districtId: '7317021',
    name: 'Lindajang',
  },
  {
    id: '7317021005',
    districtId: '7317021',
    name: 'Buntu Barana',
  },
  {
    id: '7317021006',
    districtId: '7317021',
    name: 'Kaladi Darussalam',
  },
  {
    id: '7317021007',
    districtId: '7317021',
    name: 'Muhajirin',
  },
  {
    id: '7317021008',
    districtId: '7317021',
    name: 'Tallang',
  },
  {
    id: '7317030001',
    districtId: '7317030',
    name: 'Balubu',
  },
  {
    id: '7317030002',
    districtId: '7317030',
    name: 'Pasamai',
  },
  {
    id: '7317030003',
    districtId: '7317030',
    name: 'Senga Selatan',
  },
  {
    id: '7317030004',
    districtId: '7317030',
    name: 'Senga',
  },
  {
    id: '7317030005',
    districtId: '7317030',
    name: 'Belopa',
  },
  {
    id: '7317030006',
    districtId: '7317030',
    name: 'Balo- Balo',
  },
  {
    id: '7317030007',
    districtId: '7317030',
    name: 'Kurrusumanga',
  },
  {
    id: '7317030019',
    districtId: '7317030',
    name: 'Tanamanai',
  },
  {
    id: '7317030020',
    districtId: '7317030',
    name: 'Tampumia Radda',
  },
  {
    id: '7317031001',
    districtId: '7317031',
    name: 'Tabbaja',
  },
  {
    id: '7317031002',
    districtId: '7317031',
    name: 'Libukang',
  },
  {
    id: '7317031003',
    districtId: '7317031',
    name: 'Kamanre',
  },
  {
    id: '7317031004',
    districtId: '7317031',
    name: 'Cilallang',
  },
  {
    id: '7317031005',
    districtId: '7317031',
    name: 'Wara',
  },
  {
    id: '7317031006',
    districtId: '7317031',
    name: 'Salu Paremang',
  },
  {
    id: '7317031007',
    districtId: '7317031',
    name: 'Bunga Eja',
  },
  {
    id: '7317031008',
    districtId: '7317031',
    name: 'Saluparemang Selatan',
  },
  {
    id: '7317032001',
    districtId: '7317032',
    name: 'Lebani',
  },
  {
    id: '7317032002',
    districtId: '7317032',
    name: 'Pammanu',
  },
  {
    id: '7317032003',
    districtId: '7317032',
    name: 'Lamunre',
  },
  {
    id: '7317032004',
    districtId: '7317032',
    name: 'Lauwa',
  },
  {
    id: '7317032005',
    districtId: '7317032',
    name: 'Paconne',
  },
  {
    id: '7317032006',
    districtId: '7317032',
    name: 'Seppong',
  },
  {
    id: '7317032007',
    districtId: '7317032',
    name: 'Sabe',
  },
  {
    id: '7317032008',
    districtId: '7317032',
    name: 'Lamunre Tengah',
  },
  {
    id: '7317040004',
    districtId: '7317040',
    name: 'Tallang Bulawang',
  },
  {
    id: '7317040005',
    districtId: '7317040',
    name: 'Balla',
  },
  {
    id: '7317040006',
    districtId: '7317040',
    name: 'Sampa',
  },
  {
    id: '7317040007',
    districtId: '7317040',
    name: 'Bajo',
  },
  {
    id: '7317040008',
    districtId: '7317040',
    name: 'Rumaju',
  },
  {
    id: '7317040009',
    districtId: '7317040',
    name: 'Saga',
  },
  {
    id: '7317040010',
    districtId: '7317040',
    name: 'Jambu',
  },
  {
    id: '7317040011',
    districtId: '7317040',
    name: 'Pangi',
  },
  {
    id: '7317040012',
    districtId: '7317040',
    name: 'Sumabu',
  },
  {
    id: '7317040013',
    districtId: '7317040',
    name: 'Samulang',
  },
  {
    id: '7317040014',
    districtId: '7317040',
    name: 'Buntu Babang',
  },
  {
    id: '7317040015',
    districtId: '7317040',
    name: 'Langkiddi',
  },
  {
    id: '7317041001',
    districtId: '7317041',
    name: 'Saronda',
  },
  {
    id: '7317041002',
    districtId: '7317041',
    name: 'Tumbu Bara',
  },
  {
    id: '7317041003',
    districtId: '7317041',
    name: 'Sampeang',
  },
  {
    id: '7317041004',
    districtId: '7317041',
    name: 'Kadong-Kadong',
  },
  {
    id: '7317041005',
    districtId: '7317041',
    name: 'Marinding',
  },
  {
    id: '7317041006',
    districtId: '7317041',
    name: 'Tetekang',
  },
  {
    id: '7317041007',
    districtId: '7317041',
    name: 'Bonelemo',
  },
  {
    id: '7317041008',
    districtId: '7317041',
    name: 'Bonelemo Barat',
  },
  {
    id: '7317041009',
    districtId: '7317041',
    name: 'Bonelemo Utara',
  },
  {
    id: '7317050011',
    districtId: '7317050',
    name: 'Bolu',
  },
  {
    id: '7317050012',
    districtId: '7317050',
    name: 'Lange',
  },
  {
    id: '7317050013',
    districtId: '7317050',
    name: 'Andulan',
  },
  {
    id: '7317050014',
    districtId: '7317050',
    name: 'Sinaji',
  },
  {
    id: '7317050015',
    districtId: '7317050',
    name: 'Kanna',
  },
  {
    id: '7317050016',
    districtId: '7317050',
    name: 'Ledan',
  },
  {
    id: '7317050017',
    districtId: '7317050',
    name: 'Lissaga',
  },
  {
    id: '7317050018',
    districtId: '7317050',
    name: "To'Long",
  },
  {
    id: '7317050019',
    districtId: '7317050',
    name: 'Tabi',
  },
  {
    id: '7317050020',
    districtId: '7317050',
    name: 'Kanna Utara',
  },
  {
    id: '7317050021',
    districtId: '7317050',
    name: 'Buntu Batu',
  },
  {
    id: '7317050023',
    districtId: '7317050',
    name: 'Mappetajang',
  },
  {
    id: '7317051001',
    districtId: '7317051',
    name: 'Lambanan',
  },
  {
    id: '7317051002',
    districtId: '7317051',
    name: 'Buntu Sarek',
  },
  {
    id: '7317051003',
    districtId: '7317051',
    name: 'Pajang',
  },
  {
    id: '7317051004',
    districtId: '7317051',
    name: 'Kadundung',
  },
  {
    id: '7317051005',
    districtId: '7317051',
    name: 'Tobaru',
  },
  {
    id: '7317051006',
    districtId: '7317051',
    name: 'Ulusalu',
  },
  {
    id: '7317051007',
    districtId: '7317051',
    name: 'Boneposi',
  },
  {
    id: '7317051008',
    districtId: '7317051',
    name: 'Rante Balla',
  },
  {
    id: '7317051009',
    districtId: '7317051',
    name: 'Pangi',
  },
  {
    id: '7317051010',
    districtId: '7317051',
    name: 'Tabang',
  },
  {
    id: '7317051011',
    districtId: '7317051',
    name: 'Tibussan',
  },
  {
    id: '7317051012',
    districtId: '7317051',
    name: 'Tolajuk',
  },
  {
    id: '7317052001',
    districtId: '7317052',
    name: 'Tasangtongkonan',
  },
  {
    id: '7317052002',
    districtId: '7317052',
    name: 'Buntu Tallang',
  },
  {
    id: '7317052003',
    districtId: '7317052',
    name: 'Dampan',
  },
  {
    id: '7317052005',
    districtId: '7317052',
    name: 'Pantilang',
  },
  {
    id: '7317052006',
    districtId: '7317052',
    name: 'Maindo',
  },
  {
    id: '7317052007',
    districtId: '7317052',
    name: 'Salu Bua',
  },
  {
    id: '7317052008',
    districtId: '7317052',
    name: 'Uraso',
  },
  {
    id: '7317052009',
    districtId: '7317052',
    name: 'Karatuan',
  },
  {
    id: '7317052010',
    districtId: '7317052',
    name: 'Bonglo',
  },
  {
    id: '7317052011',
    districtId: '7317052',
    name: 'Barana',
  },
  {
    id: '7317052012',
    districtId: '7317052',
    name: "Ta'Ba",
  },
  {
    id: '7317060001',
    districtId: '7317060',
    name: 'Balutan',
  },
  {
    id: '7317060002',
    districtId: '7317060',
    name: 'Padang Tuju',
  },
  {
    id: '7317060003',
    districtId: '7317060',
    name: 'Noling',
  },
  {
    id: '7317060004',
    districtId: '7317060',
    name: 'Padang Kamburi',
  },
  {
    id: '7317060013',
    districtId: '7317060',
    name: 'Buntu Batu',
  },
  {
    id: '7317060021',
    districtId: '7317060',
    name: 'Tanjong',
  },
  {
    id: '7317060022',
    districtId: '7317060',
    name: "Padang Ma'Bud",
  },
  {
    id: '7317060023',
    districtId: '7317060',
    name: 'Malenggang',
  },
  {
    id: '7317060024',
    districtId: '7317060',
    name: 'Tampumia',
  },
  {
    id: '7317060025',
    districtId: '7317060',
    name: 'Salu Induk',
  },
  {
    id: '7317061009',
    districtId: '7317061',
    name: 'Padang Subur',
  },
  {
    id: '7317061010',
    districtId: '7317061',
    name: 'Padang Sappa',
  },
  {
    id: '7317061011',
    districtId: '7317061',
    name: 'Tumale',
  },
  {
    id: '7317061013',
    districtId: '7317061',
    name: 'Muladimeng',
  },
  {
    id: '7317061014',
    districtId: '7317061',
    name: 'Buntu Kamiri',
  },
  {
    id: '7317061015',
    districtId: '7317061',
    name: 'Buntu Nanna',
  },
  {
    id: '7317061016',
    districtId: '7317061',
    name: 'Tirowali',
  },
  {
    id: '7317061017',
    districtId: '7317061',
    name: 'Mario',
  },
  {
    id: '7317061018',
    districtId: '7317061',
    name: 'Tampa',
  },
  {
    id: '7317061019',
    districtId: '7317061',
    name: 'Parekaju',
  },
  {
    id: '7317062001',
    districtId: '7317062',
    name: 'Paccerakang',
  },
  {
    id: '7317062002',
    districtId: '7317062',
    name: 'Pattedong',
  },
  {
    id: '7317062003',
    districtId: '7317062',
    name: "To'Balo",
  },
  {
    id: '7317062004',
    districtId: '7317062',
    name: 'Jenne Maeja',
  },
  {
    id: '7317062005',
    districtId: '7317062',
    name: 'Lampuara',
  },
  {
    id: '7317062006',
    districtId: '7317062',
    name: 'Bakti',
  },
  {
    id: '7317062007',
    districtId: '7317062',
    name: 'Olang',
  },
  {
    id: '7317062008',
    districtId: '7317062',
    name: 'Buntu Karya',
  },
  {
    id: '7317062012',
    districtId: '7317062',
    name: 'Bassiang',
  },
  {
    id: '7317062013',
    districtId: '7317062',
    name: 'Tarramatekkeng',
  },
  {
    id: '7317062014',
    districtId: '7317062',
    name: 'Pattedong Selatan',
  },
  {
    id: '7317062015',
    districtId: '7317062',
    name: "To'Bia",
  },
  {
    id: '7317062016',
    districtId: '7317062',
    name: 'Bassiang Timur',
  },
  {
    id: '7317070001',
    districtId: '7317070',
    name: 'Lare-Lare',
  },
  {
    id: '7317070002',
    districtId: '7317070',
    name: 'Karang-Karangan',
  },
  {
    id: '7317070003',
    districtId: '7317070',
    name: 'Lengkong',
  },
  {
    id: '7317070004',
    districtId: '7317070',
    name: 'Raja',
  },
  {
    id: '7317070005',
    districtId: '7317070',
    name: 'Pammesakang',
  },
  {
    id: '7317070007',
    districtId: '7317070',
    name: 'Bukit Harapan',
  },
  {
    id: '7317070008',
    districtId: '7317070',
    name: 'Posi',
  },
  {
    id: '7317070009',
    districtId: '7317070',
    name: 'Tiromanda',
  },
  {
    id: '7317070010',
    districtId: '7317070',
    name: 'Tana Rigella',
  },
  {
    id: '7317070011',
    districtId: '7317070',
    name: 'Sakti',
  },
  {
    id: '7317070012',
    districtId: '7317070',
    name: 'Barowa',
  },
  {
    id: '7317070013',
    districtId: '7317070',
    name: 'Padang Kalua',
  },
  {
    id: '7317070014',
    districtId: '7317070',
    name: 'Toddopuli',
  },
  {
    id: '7317070015',
    districtId: '7317070',
    name: 'Pabbaresseng',
  },
  {
    id: '7317080002',
    districtId: '7317080',
    name: 'Tombang',
  },
  {
    id: '7317080003',
    districtId: '7317080',
    name: 'Baramamase',
  },
  {
    id: '7317080015',
    districtId: '7317080',
    name: 'Harapan',
  },
  {
    id: '7317080017',
    districtId: '7317080',
    name: 'Saragi',
  },
  {
    id: '7317080018',
    districtId: '7317080',
    name: 'Bulo',
  },
  {
    id: '7317080019',
    districtId: '7317080',
    name: 'Lalong',
  },
  {
    id: '7317080020',
    districtId: '7317080',
    name: 'Walenrang',
  },
  {
    id: '7317080021',
    districtId: '7317080',
    name: 'Batusitanduk',
  },
  {
    id: '7317080022',
    districtId: '7317080',
    name: 'Kalibamamase',
  },
  {
    id: '7317081001',
    districtId: '7317081',
    name: 'Tabah',
  },
  {
    id: '7317081002',
    districtId: '7317081',
    name: 'Lamasi Pantai',
  },
  {
    id: '7317081003',
    districtId: '7317081',
    name: 'Seba-Seba',
  },
  {
    id: '7317081004',
    districtId: '7317081',
    name: 'Kendekan',
  },
  {
    id: '7317081005',
    districtId: '7317081',
    name: 'Sukadamai',
  },
  {
    id: '7317081006',
    districtId: '7317081',
    name: 'Rante Damai',
  },
  {
    id: '7317081007',
    districtId: '7317081',
    name: 'Pangalli',
  },
  {
    id: '7317081008',
    districtId: '7317081',
    name: 'Tanete',
  },
  {
    id: '7317090006',
    districtId: '7317090',
    name: 'Padang Kalua',
  },
  {
    id: '7317090007',
    districtId: '7317090',
    name: 'Wiwitan',
  },
  {
    id: '7317090008',
    districtId: '7317090',
    name: 'Lamasi',
  },
  {
    id: '7317090013',
    districtId: '7317090',
    name: 'Salu Jambu',
  },
  {
    id: '7317090014',
    districtId: '7317090',
    name: 'Awo Gading',
  },
  {
    id: '7317090015',
    districtId: '7317090',
    name: 'Setiarejo',
  },
  {
    id: '7317090016',
    districtId: '7317090',
    name: "Se'Pon",
  },
  {
    id: '7317090017',
    districtId: '7317090',
    name: 'Pongsamelung',
  },
  {
    id: '7317090018',
    districtId: '7317090',
    name: "To'Pongo",
  },
  {
    id: '7317090019',
    districtId: '7317090',
    name: 'Wiwitan Timur',
  },
  {
    id: '7317091001',
    districtId: '7317091',
    name: 'Sangtandung',
  },
  {
    id: '7317091002',
    districtId: '7317091',
    name: 'Bolong',
  },
  {
    id: '7317091003',
    districtId: '7317091',
    name: 'Bosso',
  },
  {
    id: '7317091004',
    districtId: '7317091',
    name: 'Buntu Awo',
  },
  {
    id: '7317091005',
    districtId: '7317091',
    name: 'Marabuana',
  },
  {
    id: '7317091006',
    districtId: '7317091',
    name: 'Salulino',
  },
  {
    id: '7317091007',
    districtId: '7317091',
    name: 'Salutubu',
  },
  {
    id: '7317091008',
    districtId: '7317091',
    name: 'Pongko',
  },
  {
    id: '7317091009',
    districtId: '7317091',
    name: 'Siteba',
  },
  {
    id: '7317091010',
    districtId: '7317091',
    name: 'Limbong',
  },
  {
    id: '7317091011',
    districtId: '7317091',
    name: 'Bosso Timur',
  },
  {
    id: '7317092001',
    districtId: '7317092',
    name: 'Ilan Batu',
  },
  {
    id: '7317092002',
    districtId: '7317092',
    name: 'Ilan Batu Uru',
  },
  {
    id: '7317092004',
    districtId: '7317092',
    name: 'Lempe Pasang',
  },
  {
    id: '7317092005',
    districtId: '7317092',
    name: 'Lamasi Hulu',
  },
  {
    id: '7317092006',
    districtId: '7317092',
    name: 'Lewandi',
  },
  {
    id: '7317093001',
    districtId: '7317093',
    name: 'Pompengan Pantai',
  },
  {
    id: '7317093002',
    districtId: '7317093',
    name: 'Pompengan',
  },
  {
    id: '7317093003',
    districtId: '7317093',
    name: 'Bulolondong',
  },
  {
    id: '7317093004',
    districtId: '7317093',
    name: 'Pelalan',
  },
  {
    id: '7317093005',
    districtId: '7317093',
    name: "To'Lemo",
  },
  {
    id: '7317093006',
    districtId: '7317093',
    name: 'Salu Pao',
  },
  {
    id: '7317093007',
    districtId: '7317093',
    name: 'Seriti',
  },
  {
    id: '7317093008',
    districtId: '7317093',
    name: 'Pompengan Tengah',
  },
  {
    id: '7317093009',
    districtId: '7317093',
    name: 'Pompengan Utara',
  },
  {
    id: '7318010015',
    districtId: '7318010',
    name: 'Lembang Mappa',
  },
  {
    id: '7318010025',
    districtId: '7318010',
    name: 'Lembang Bau',
  },
  {
    id: '7318010027',
    districtId: '7318010',
    name: 'Lembang Bua Kayu',
  },
  {
    id: '7318010029',
    districtId: '7318010',
    name: 'Lembang Poton',
  },
  {
    id: '7318010030',
    districtId: '7318010',
    name: 'Kelurahan  Ratte Buttu',
  },
  {
    id: '7318010031',
    districtId: '7318010',
    name: 'Lembang Bau Selatan',
  },
  {
    id: '7318011004',
    districtId: '7318011',
    name: 'Lembang Simbuang',
  },
  {
    id: '7318011005',
    districtId: '7318011',
    name: 'Kelurahan Sima',
  },
  {
    id: '7318011006',
    districtId: '7318011',
    name: 'Lembang Pong Bembe',
  },
  {
    id: '7318011010',
    districtId: '7318011',
    name: 'Lembang Simbuang Batuallu',
  },
  {
    id: '7318011011',
    districtId: '7318011',
    name: 'Lembang Makkado',
  },
  {
    id: '7318011012',
    districtId: '7318011',
    name: 'Lembang Puang Bembe Mesakada',
  },
  {
    id: '7318012001',
    districtId: '7318012',
    name: 'Lembang Rano',
  },
  {
    id: '7318012002',
    districtId: '7318012',
    name: 'Lembang Rumandan',
  },
  {
    id: '7318012003',
    districtId: '7318012',
    name: 'Lembang Rano Timur',
  },
  {
    id: '7318012004',
    districtId: '7318012',
    name: 'Lembang Rano Tengah',
  },
  {
    id: '7318012005',
    districtId: '7318012',
    name: 'Lembang Rano Utara',
  },
  {
    id: '7318013001',
    districtId: '7318013',
    name: 'Lembang Butang',
  },
  {
    id: '7318013002',
    districtId: '7318013',
    name: 'Lembang Miallo',
  },
  {
    id: '7318013003',
    districtId: '7318013',
    name: 'Lembang Tanete',
  },
  {
    id: '7318013004',
    districtId: '7318013',
    name: 'Kelurahan Kondodewata',
  },
  {
    id: '7318013005',
    districtId: '7318013',
    name: 'Lembang Sangpeparikan',
  },
  {
    id: '7318013006',
    districtId: '7318013',
    name: 'Lembang Dewata',
  },
  {
    id: '7318020010',
    districtId: '7318020',
    name: 'Uluway',
  },
  {
    id: '7318020011',
    districtId: '7318020',
    name: 'Uluway Barat',
  },
  {
    id: '7318020019',
    districtId: '7318020',
    name: 'Lembang Gasing',
  },
  {
    id: '7318020023',
    districtId: '7318020',
    name: 'Lembang Marinding',
  },
  {
    id: '7318020024',
    districtId: '7318020',
    name: "Lembang Ke'Pe Tinoring",
  },
  {
    id: '7318020025',
    districtId: '7318020',
    name: 'Lembang Randanan',
  },
  {
    id: '7318020030',
    districtId: '7318020',
    name: 'Kelurahan Tampo',
  },
  {
    id: '7318020032',
    districtId: '7318020',
    name: 'Lembang Simbuang',
  },
  {
    id: '7318020034',
    districtId: '7318020',
    name: 'Kelurahan Lemo',
  },
  {
    id: '7318020035',
    districtId: '7318020',
    name: 'Kelurahan Tengan',
  },
  {
    id: '7318020037',
    districtId: '7318020',
    name: 'Lembang Rantedada',
  },
  {
    id: '7318020038',
    districtId: '7318020',
    name: "Lembang Pa'Tengko",
  },
  {
    id: '7318020040',
    districtId: '7318020',
    name: 'Kelurahan  Rante Kalua',
  },
  {
    id: '7318020041',
    districtId: '7318020',
    name: 'Lembang Buntu Tangti',
  },
  {
    id: '7318020042',
    districtId: '7318020',
    name: 'Lembang Buntu Datu',
  },
  {
    id: '7318020043',
    districtId: '7318020',
    name: 'Lembang Palipu',
  },
  {
    id: '7318020044',
    districtId: '7318020',
    name: 'Lembang Pakala',
  },
  {
    id: '7318021001',
    districtId: '7318021',
    name: 'Kelurahan Benteng Ambeso',
  },
  {
    id: '7318021002',
    districtId: '7318021',
    name: 'Lembang Kaduaja',
  },
  {
    id: '7318021003',
    districtId: '7318021',
    name: 'Lembang Gandang Batu',
  },
  {
    id: '7318021004',
    districtId: '7318021',
    name: 'Lembang Garassik',
  },
  {
    id: '7318021005',
    districtId: '7318021',
    name: 'Kelurahan Salubarani',
  },
  {
    id: '7318021006',
    districtId: '7318021',
    name: 'Lembang Banteng Deata',
  },
  {
    id: '7318021007',
    districtId: '7318021',
    name: 'Lembang Buntu Limbong',
  },
  {
    id: '7318021008',
    districtId: '7318021',
    name: 'Lembang Buntu Tabang',
  },
  {
    id: '7318021009',
    districtId: '7318021',
    name: 'Lembang Sillanan',
  },
  {
    id: '7318021010',
    districtId: '7318021',
    name: 'Lembang Pemanukan',
  },
  {
    id: '7318021011',
    districtId: '7318021',
    name: 'Lembang Perindingan',
  },
  {
    id: '7318021012',
    districtId: '7318021',
    name: 'Kelurahan Mebali',
  },
  {
    id: '7318030013',
    districtId: '7318030',
    name: 'Lembang Kaero',
  },
  {
    id: '7318030019',
    districtId: '7318030',
    name: 'Lembang Bulian Massabu',
  },
  {
    id: '7318030023',
    districtId: '7318030',
    name: 'Kelurahan Tongko Sarapung',
  },
  {
    id: '7318030024',
    districtId: '7318030',
    name: 'Kelurahan Buntu Masakke',
  },
  {
    id: '7318030029',
    districtId: '7318030',
    name: 'Lembang Turunan',
  },
  {
    id: '7318031001',
    districtId: '7318031',
    name: 'Lembang Batualu Selatan',
  },
  {
    id: '7318031002',
    districtId: '7318031',
    name: 'Lembang Batualu',
  },
  {
    id: '7318031003',
    districtId: '7318031',
    name: 'Kelurahan Rante Alang',
  },
  {
    id: '7318031004',
    districtId: '7318031',
    name: 'Lembang Tokesan',
  },
  {
    id: '7318031005',
    districtId: '7318031',
    name: 'Lembang Raru Sibunuan',
  },
  {
    id: '7318032001',
    districtId: '7318032',
    name: "Lembang Rante La'Bi Kambisa",
  },
  {
    id: '7318032002',
    districtId: '7318032',
    name: 'Lembang Leatung Matallo',
  },
  {
    id: '7318032003',
    districtId: '7318032',
    name: 'Kelurahan  Leatung',
  },
  {
    id: '7318032004',
    districtId: '7318032',
    name: 'Lembang Salu Allo',
  },
  {
    id: '7318032005',
    districtId: '7318032',
    name: 'Kelurahan Bebo',
  },
  {
    id: '7318032006',
    districtId: '7318032',
    name: 'Lembang Tumbang Datu',
  },
  {
    id: '7318040012',
    districtId: '7318040',
    name: 'Kelurahan Manggau',
  },
  {
    id: '7318040015',
    districtId: '7318040',
    name: 'Kelurahan Bombongan',
  },
  {
    id: '7318040019',
    districtId: '7318040',
    name: 'Kelurahan Batu Papan',
  },
  {
    id: '7318040020',
    districtId: '7318040',
    name: 'Kelurahan Tarongko',
  },
  {
    id: '7318040022',
    districtId: '7318040',
    name: 'Kelurahan Pantan',
  },
  {
    id: '7318040030',
    districtId: '7318040',
    name: 'Kelurahan Ariang',
  },
  {
    id: '7318040031',
    districtId: '7318040',
    name: 'Kelurahan Lamunan',
  },
  {
    id: '7318040032',
    districtId: '7318040',
    name: 'Kelurahan Tondon Mamulu',
  },
  {
    id: '7318040033',
    districtId: '7318040',
    name: 'Kelurahan Rante',
  },
  {
    id: '7318040034',
    districtId: '7318040',
    name: 'Kelurahan Buntu Burake',
  },
  {
    id: '7318040035',
    districtId: '7318040',
    name: 'Kelurahan Kamali Pentalluan',
  },
  {
    id: '7318040036',
    districtId: '7318040',
    name: 'Kelurahan Botang',
  },
  {
    id: '7318040037',
    districtId: '7318040',
    name: 'Kelurahan Tampo Makale',
  },
  {
    id: '7318040038',
    districtId: '7318040',
    name: 'Lembang Lea',
  },
  {
    id: '7318040039',
    districtId: '7318040',
    name: 'Kelurahan Lapandan',
  },
  {
    id: '7318041001',
    districtId: '7318041',
    name: "Lembang  Pa'Buaran",
  },
  {
    id: '7318041002',
    districtId: '7318041',
    name: 'Lembang Randan Batu',
  },
  {
    id: '7318041003',
    districtId: '7318041',
    name: 'Kelurahan Tiromanda',
  },
  {
    id: '7318041004',
    districtId: '7318041',
    name: 'Kelurahan Tosapan',
  },
  {
    id: '7318041005',
    districtId: '7318041',
    name: "Lembang Bo'Ne Buntu Sisong",
  },
  {
    id: '7318041006',
    districtId: '7318041',
    name: 'Lembang Patekke',
  },
  {
    id: '7318041007',
    districtId: '7318041',
    name: 'Kelurahan Sandabalik',
  },
  {
    id: '7318041008',
    districtId: '7318041',
    name: 'Kelurahan Pasang',
  },
  {
    id: '7318042001',
    districtId: '7318042',
    name: 'Kelurahan Tambunan',
  },
  {
    id: '7318042002',
    districtId: '7318042',
    name: 'Kelurahan Bungin',
  },
  {
    id: '7318042003',
    districtId: '7318042',
    name: 'Kelurahan Lion Tondok Iring',
  },
  {
    id: '7318042004',
    districtId: '7318042',
    name: 'Kelurahan Sarira',
  },
  {
    id: '7318042005',
    districtId: '7318042',
    name: 'Kelurahan  Lemo',
  },
  {
    id: '7318050019',
    districtId: '7318050',
    name: 'Kelurahan Pattan Ulusalu',
  },
  {
    id: '7318050030',
    districtId: '7318050',
    name: 'Lembang Salutandung',
  },
  {
    id: '7318050046',
    districtId: '7318050',
    name: 'Lembang Ratte Talonge',
  },
  {
    id: '7318050047',
    districtId: '7318050',
    name: "Lembang Sa'Tandung",
  },
  {
    id: '7318050049',
    districtId: '7318050',
    name: 'Lembang Salu',
  },
  {
    id: '7318050050',
    districtId: '7318050',
    name: 'Lembang Batu Tiaka',
  },
  {
    id: '7318050051',
    districtId: '7318050',
    name: 'Lembang Rea Tulaklangi',
  },
  {
    id: '7318050052',
    districtId: '7318050',
    name: "Lembang Ra'Bung",
  },
  {
    id: '7318050053',
    districtId: '7318050',
    name: 'Lembang Salu Boronan',
  },
  {
    id: '7318051001',
    districtId: '7318051',
    name: 'Lembang Pali',
  },
  {
    id: '7318051002',
    districtId: '7318051',
    name: "Lembang Se'Seng",
  },
  {
    id: '7318051003',
    districtId: '7318051',
    name: 'Kelurahan Bittuang',
  },
  {
    id: '7318051004',
    districtId: '7318051',
    name: 'Lembang  Tiroan',
  },
  {
    id: '7318051005',
    districtId: '7318051',
    name: 'Lembang Bau',
  },
  {
    id: '7318051006',
    districtId: '7318051',
    name: 'Lembang Rembo Rembo',
  },
  {
    id: '7318051007',
    districtId: '7318051',
    name: 'Lembang Burasia',
  },
  {
    id: '7318051008',
    districtId: '7318051',
    name: 'Lembang Buttu Limbong',
  },
  {
    id: '7318051009',
    districtId: '7318051',
    name: 'Lembang Kole Palian',
  },
  {
    id: '7318051010',
    districtId: '7318051',
    name: 'Lembang Balla',
  },
  {
    id: '7318051011',
    districtId: '7318051',
    name: 'Lembang Patongloan',
  },
  {
    id: '7318051012',
    districtId: '7318051',
    name: 'Lembang Sasak',
  },
  {
    id: '7318051013',
    districtId: '7318051',
    name: "Lembang Le'Tek",
  },
  {
    id: '7318051014',
    districtId: '7318051',
    name: 'Lembang Sandana',
  },
  {
    id: '7318051015',
    districtId: '7318051',
    name: "Lembang Kandua'",
  },
  {
    id: '7318052001',
    districtId: '7318052',
    name: 'Kelurahan Talion',
  },
  {
    id: '7318052002',
    districtId: '7318052',
    name: 'Lembang Limbong',
  },
  {
    id: '7318052003',
    districtId: '7318052',
    name: 'Lembang Sarapeang',
  },
  {
    id: '7318052004',
    districtId: '7318052',
    name: 'Lembang Banga',
  },
  {
    id: '7318052005',
    districtId: '7318052',
    name: 'Lembang Buri',
  },
  {
    id: '7318052006',
    districtId: '7318052',
    name: 'Kelurahan  Rembon',
  },
  {
    id: '7318052007',
    districtId: '7318052',
    name: 'Lembang Ullin',
  },
  {
    id: '7318052008',
    districtId: '7318052',
    name: 'Lembang Maroson',
  },
  {
    id: '7318052009',
    districtId: '7318052',
    name: 'Lembang Palesan',
  },
  {
    id: '7318052010',
    districtId: '7318052',
    name: 'Lembang Kayu Osing',
  },
  {
    id: '7318052011',
    districtId: '7318052',
    name: 'Lembang Batu Sura',
  },
  {
    id: '7318052012',
    districtId: '7318052',
    name: 'Lembang To  Pao',
  },
  {
    id: '7318052013',
    districtId: '7318052',
    name: 'Lembang Bua Tarung',
  },
  {
    id: '7318053001',
    districtId: '7318053',
    name: 'Lembang Belau',
  },
  {
    id: '7318053002',
    districtId: '7318053',
    name: 'Lembang Paku',
  },
  {
    id: '7318053003',
    districtId: '7318053',
    name: 'Lembang Sese Salu',
  },
  {
    id: '7318053004',
    districtId: '7318053',
    name: 'Lembang Ratte',
  },
  {
    id: '7318053005',
    districtId: '7318053',
    name: 'Lembang Pondingao',
  },
  {
    id: '7318053006',
    districtId: '7318053',
    name: 'Lembang Belau Utara',
  },
  {
    id: '7318053007',
    districtId: '7318053',
    name: 'Lembang Paliorong',
  },
  {
    id: '7318053008',
    districtId: '7318053',
    name: 'Lembang Kadundung',
  },
  {
    id: '7318054001',
    districtId: '7318054',
    name: 'Lembang Balepe',
  },
  {
    id: '7318054002',
    districtId: '7318054',
    name: 'Lembang Leppan',
  },
  {
    id: '7318054003',
    districtId: '7318054',
    name: 'Kelurahan Malimbong',
  },
  {
    id: '7318054004',
    districtId: '7318054',
    name: 'Lembang Lemomenduruk',
  },
  {
    id: '7318054005',
    districtId: '7318054',
    name: 'Lebang Kole Sawangan',
  },
  {
    id: '7318054006',
    districtId: '7318054',
    name: 'Lebang Kole Barebatu',
  },
  {
    id: '7318061001',
    districtId: '7318061',
    name: 'Kelurahan Tapparan',
  },
  {
    id: '7318061002',
    districtId: '7318061',
    name: 'Kelurahan Rantetayo',
  },
  {
    id: '7318061003',
    districtId: '7318061',
    name: 'Lembang Madandan',
  },
  {
    id: '7318061009',
    districtId: '7318061',
    name: 'Lembang Tapparan Utara',
  },
  {
    id: '7318061010',
    districtId: '7318061',
    name: 'Kelurahan Padang Iring',
  },
  {
    id: '7318061011',
    districtId: '7318061',
    name: 'Lembang Tonglo',
  },
  {
    id: '7318067001',
    districtId: '7318067',
    name: 'Lembang Bambalu',
  },
  {
    id: '7318067002',
    districtId: '7318067',
    name: 'Lembang Lipungan Tanete',
  },
  {
    id: '7318067003',
    districtId: '7318067',
    name: 'Kelurahan Rante Kurra',
  },
  {
    id: '7318067004',
    districtId: '7318067',
    name: 'Lembang Rante Limbong',
  },
  {
    id: '7318067005',
    districtId: '7318067',
    name: 'Lembang Limbong Sangpolo',
  },
  {
    id: '7318067006',
    districtId: '7318067',
    name: 'Lembang Moroson',
  },
  {
    id: '7322010001',
    districtId: '7322010',
    name: 'Tandung',
  },
  {
    id: '7322010002',
    districtId: '7322010',
    name: 'Kalotok',
  },
  {
    id: '7322010003',
    districtId: '7322010',
    name: 'Pompaniki',
  },
  {
    id: '7322010004',
    districtId: '7322010',
    name: 'Mari-Mari',
  },
  {
    id: '7322010005',
    districtId: '7322010',
    name: 'Bone Subur',
  },
  {
    id: '7322010006',
    districtId: '7322010',
    name: 'Tete Uri',
  },
  {
    id: '7322010007',
    districtId: '7322010',
    name: 'Batu Alang',
  },
  {
    id: '7322010008',
    districtId: '7322010',
    name: 'Kampung Baru',
  },
  {
    id: '7322010009',
    districtId: '7322010',
    name: 'Dandang',
  },
  {
    id: '7322010010',
    districtId: '7322010',
    name: 'Buangin',
  },
  {
    id: '7322010011',
    districtId: '7322010',
    name: 'Pararra',
  },
  {
    id: '7322010012',
    districtId: '7322010',
    name: 'Terpedo Jaya',
  },
  {
    id: '7322010013',
    districtId: '7322010',
    name: 'Buntu Terpedo',
  },
  {
    id: '7322010014',
    districtId: '7322010',
    name: 'Tulak Tallu',
  },
  {
    id: '7322010015',
    districtId: '7322010',
    name: 'Bakka',
  },
  {
    id: '7322010016',
    districtId: '7322010',
    name: 'Pengkendekan',
  },
  {
    id: '7322010017',
    districtId: '7322010',
    name: 'Marobo',
  },
  {
    id: '7322010018',
    districtId: '7322010',
    name: 'Sabbang',
  },
  {
    id: '7322010019',
    districtId: '7322010',
    name: 'Salama',
  },
  {
    id: '7322010020',
    districtId: '7322010',
    name: 'Malimbu',
  },
  {
    id: '7322020001',
    districtId: '7322020',
    name: 'Lawewe',
  },
  {
    id: '7322020002',
    districtId: '7322020',
    name: 'Lembang-Lembang',
  },
  {
    id: '7322020003',
    districtId: '7322020',
    name: 'Beringin Jaya',
  },
  {
    id: '7322020004',
    districtId: '7322020',
    name: 'Mukti Jaya',
  },
  {
    id: '7322020005',
    districtId: '7322020',
    name: 'Mukti Tama',
  },
  {
    id: '7322020006',
    districtId: '7322020',
    name: 'Mario',
  },
  {
    id: '7322020007',
    districtId: '7322020',
    name: 'Polewali',
  },
  {
    id: '7322020008',
    districtId: '7322020',
    name: 'Palandan',
  },
  {
    id: '7322020009',
    districtId: '7322020',
    name: 'Bumi Harapan',
  },
  {
    id: '7322020010',
    districtId: '7322020',
    name: 'Marannu',
  },
  {
    id: '7322020011',
    districtId: '7322020',
    name: 'Lara',
  },
  {
    id: '7322020012',
    districtId: '7322020',
    name: 'Mekar Sari Jaya',
  },
  {
    id: '7322020013',
    districtId: '7322020',
    name: 'Tarobok',
  },
  {
    id: '7322020014',
    districtId: '7322020',
    name: 'Salulemo',
  },
  {
    id: '7322020015',
    districtId: '7322020',
    name: 'Kariango',
  },
  {
    id: '7322020016',
    districtId: '7322020',
    name: 'Radda',
  },
  {
    id: '7322020017',
    districtId: '7322020',
    name: 'Meli',
  },
  {
    id: '7322020018',
    districtId: '7322020',
    name: 'Baebunta',
  },
  {
    id: '7322020019',
    districtId: '7322020',
    name: 'UPT Buso',
  },
  {
    id: '7322020020',
    districtId: '7322020',
    name: 'Sassa',
  },
  {
    id: '7322020021',
    districtId: '7322020',
    name: 'Salassa',
  },
  {
    id: '7322020022',
    districtId: '7322020',
    name: 'Sumpira',
  },
  {
    id: '7322030006',
    districtId: '7322030',
    name: 'Pattimang',
  },
  {
    id: '7322030007',
    districtId: '7322030',
    name: 'Malangke',
  },
  {
    id: '7322030008',
    districtId: '7322030',
    name: 'Pince Pute',
  },
  {
    id: '7322030009',
    districtId: '7322030',
    name: 'Tokke',
  },
  {
    id: '7322030011',
    districtId: '7322030',
    name: 'Takkalala',
  },
  {
    id: '7322030012',
    districtId: '7322030',
    name: 'Salekoe',
  },
  {
    id: '7322030013',
    districtId: '7322030',
    name: 'Ladongi',
  },
  {
    id: '7322030014',
    districtId: '7322030',
    name: 'Tolada',
  },
  {
    id: '7322030015',
    districtId: '7322030',
    name: 'Petta Landung',
  },
  {
    id: '7322030016',
    districtId: '7322030',
    name: 'Girikusuma',
  },
  {
    id: '7322030025',
    districtId: '7322030',
    name: 'Tandung',
  },
  {
    id: '7322030026',
    districtId: '7322030',
    name: 'Pute Mata',
  },
  {
    id: '7322030027',
    districtId: '7322030',
    name: 'Tingkara',
  },
  {
    id: '7322031001',
    districtId: '7322031',
    name: 'Pombakka',
  },
  {
    id: '7322031002',
    districtId: '7322031',
    name: 'Waelawi',
  },
  {
    id: '7322031003',
    districtId: '7322031',
    name: 'Pengkajoang',
  },
  {
    id: '7322031004',
    districtId: '7322031',
    name: 'Pao',
  },
  {
    id: '7322031005',
    districtId: '7322031',
    name: 'Waetuo',
  },
  {
    id: '7322031006',
    districtId: '7322031',
    name: 'Arusu',
  },
  {
    id: '7322031007',
    districtId: '7322031',
    name: 'Pembuniang',
  },
  {
    id: '7322031008',
    districtId: '7322031',
    name: 'Cenning',
  },
  {
    id: '7322031009',
    districtId: '7322031',
    name: 'Wara',
  },
  {
    id: '7322031010',
    districtId: '7322031',
    name: 'Limbong Wara',
  },
  {
    id: '7322031011',
    districtId: '7322031',
    name: 'Kalitata',
  },
  {
    id: '7322031012',
    districtId: '7322031',
    name: 'Polejiwa',
  },
  {
    id: '7322031013',
    districtId: '7322031',
    name: 'Baku-Baku',
  },
  {
    id: '7322040002',
    districtId: '7322040',
    name: 'Lino',
  },
  {
    id: '7322040003',
    districtId: '7322040',
    name: 'Paomacang',
  },
  {
    id: '7322040004',
    districtId: '7322040',
    name: 'Wonokerto',
  },
  {
    id: '7322040005',
    districtId: '7322040',
    name: 'Sumber Baru',
  },
  {
    id: '7322040006',
    districtId: '7322040',
    name: 'Banyuwangi',
  },
  {
    id: '7322040007',
    districtId: '7322040',
    name: 'Rawamangun',
  },
  {
    id: '7322040008',
    districtId: '7322040',
    name: 'Mulyorejo',
  },
  {
    id: '7322040009',
    districtId: '7322040',
    name: 'Tolangi',
  },
  {
    id: '7322040010',
    districtId: '7322040',
    name: 'Sidoraharjo',
  },
  {
    id: '7322040011',
    districtId: '7322040',
    name: 'Sukamukti',
  },
  {
    id: '7322040012',
    districtId: '7322040',
    name: 'Sukaharapan',
  },
  {
    id: '7322040013',
    districtId: '7322040',
    name: 'Sukadamai',
  },
  {
    id: '7322040014',
    districtId: '7322040',
    name: 'Mulyasari',
  },
  {
    id: '7322040015',
    districtId: '7322040',
    name: 'Wonosari',
  },
  {
    id: '7322040016',
    districtId: '7322040',
    name: 'Sukamaju',
  },
  {
    id: '7322040017',
    districtId: '7322040',
    name: 'Salulemo',
  },
  {
    id: '7322040018',
    districtId: '7322040',
    name: 'Saptamarga',
  },
  {
    id: '7322040019',
    districtId: '7322040',
    name: 'Kaluku',
  },
  {
    id: '7322040020',
    districtId: '7322040',
    name: 'Tulung Sari',
  },
  {
    id: '7322040021',
    districtId: '7322040',
    name: 'Katulungan',
  },
  {
    id: '7322040022',
    districtId: '7322040',
    name: 'Tulung Indah',
  },
  {
    id: '7322040023',
    districtId: '7322040',
    name: 'Tamboke',
  },
  {
    id: '7322040024',
    districtId: '7322040',
    name: 'Minanga Tallu',
  },
  {
    id: '7322040025',
    districtId: '7322040',
    name: 'Lampuawa',
  },
  {
    id: '7322040026',
    districtId: '7322040',
    name: 'UPT. Pongkase',
  },
  {
    id: '7322050001',
    districtId: '7322050',
    name: 'Pongko',
  },
  {
    id: '7322050002',
    districtId: '7322050',
    name: 'Batang Tongka',
  },
  {
    id: '7322050003',
    districtId: '7322050',
    name: 'Tamuku',
  },
  {
    id: '7322050014',
    districtId: '7322050',
    name: 'Sidomukti',
  },
  {
    id: '7322050015',
    districtId: '7322050',
    name: 'Banyu Urip',
  },
  {
    id: '7322050016',
    districtId: '7322050',
    name: 'Sukaraya',
  },
  {
    id: '7322050017',
    districtId: '7322050',
    name: 'Muktisari',
  },
  {
    id: '7322050018',
    districtId: '7322050',
    name: 'Patoloan',
  },
  {
    id: '7322050019',
    districtId: '7322050',
    name: 'Bone Bone',
  },
  {
    id: '7322050020',
    districtId: '7322050',
    name: 'Bantimurung',
  },
  {
    id: '7322050021',
    districtId: '7322050',
    name: 'UPT Bantimurung',
  },
  {
    id: '7322050022',
    districtId: '7322050',
    name: 'Sadar',
  },
  {
    id: '7322051004',
    districtId: '7322051',
    name: 'Rampoang',
  },
  {
    id: '7322051005',
    districtId: '7322051',
    name: 'Karondang',
  },
  {
    id: '7322051007',
    districtId: '7322051',
    name: 'Poreang',
  },
  {
    id: '7322051008',
    districtId: '7322051',
    name: 'Bungadidi',
  },
  {
    id: '7322051009',
    districtId: '7322051',
    name: 'Bungapati',
  },
  {
    id: '7322051010',
    districtId: '7322051',
    name: 'Sumberdadi',
  },
  {
    id: '7322051011',
    districtId: '7322051',
    name: 'Sidobinangun',
  },
  {
    id: '7322051012',
    districtId: '7322051',
    name: 'Patila',
  },
  {
    id: '7322051013',
    districtId: '7322051',
    name: 'Sidomakmur',
  },
  {
    id: '7322120013',
    districtId: '7322120',
    name: 'Rompu',
  },
  {
    id: '7322120014',
    districtId: '7322120',
    name: 'Torada',
  },
  {
    id: '7322120015',
    districtId: '7322120',
    name: 'Pongo',
  },
  {
    id: '7322120016',
    districtId: '7322120',
    name: 'Pombakka',
  },
  {
    id: '7322120017',
    districtId: '7322120',
    name: 'Lapapa',
  },
  {
    id: '7322120018',
    districtId: '7322120',
    name: 'Laba',
  },
  {
    id: '7322120019',
    districtId: '7322120',
    name: 'Kappuna',
  },
  {
    id: '7322120020',
    districtId: '7322120',
    name: 'Bone',
  },
  {
    id: '7322120021',
    districtId: '7322120',
    name: 'Baloli',
  },
  {
    id: '7322120022',
    districtId: '7322120',
    name: 'Kamiri',
  },
  {
    id: '7322120023',
    districtId: '7322120',
    name: 'Kasimbong',
  },
  {
    id: '7322120024',
    districtId: '7322120',
    name: 'Pandak',
  },
  {
    id: '7322120025',
    districtId: '7322120',
    name: 'Baliase',
  },
  {
    id: '7322120026',
    districtId: '7322120',
    name: 'Masamba',
  },
  {
    id: '7322120030',
    districtId: '7322120',
    name: 'Sepakat',
  },
  {
    id: '7322120031',
    districtId: '7322120',
    name: 'Pincara',
  },
  {
    id: '7322120032',
    districtId: '7322120',
    name: 'Lantang Tallang',
  },
  {
    id: '7322120033',
    districtId: '7322120',
    name: 'Sumillin',
  },
  {
    id: '7322120034',
    districtId: '7322120',
    name: 'L E R O',
  },
  {
    id: '7322120035',
    districtId: '7322120',
    name: 'UPT Maipi',
  },
  {
    id: '7322120036',
    districtId: '7322120',
    name: 'UPT. Sepakat',
  },
  {
    id: '7322120037',
    districtId: '7322120',
    name: 'UPT Lantang Tallang',
  },
  {
    id: '7322121001',
    districtId: '7322121',
    name: 'Ujung Mattajang',
  },
  {
    id: '7322121002',
    districtId: '7322121',
    name: 'Mangalle',
  },
  {
    id: '7322121003',
    districtId: '7322121',
    name: 'Sumber Wangi',
  },
  {
    id: '7322121004',
    districtId: '7322121',
    name: 'Sumber Harum',
  },
  {
    id: '7322121005',
    districtId: '7322121',
    name: 'Hasanah',
  },
  {
    id: '7322121006',
    districtId: '7322121',
    name: 'Mekar Jaya',
  },
  {
    id: '7322121007',
    districtId: '7322121',
    name: 'Cendana Putih',
  },
  {
    id: '7322121008',
    districtId: '7322121',
    name: 'Cendana Putih Satu',
  },
  {
    id: '7322121009',
    districtId: '7322121',
    name: 'Kapidi',
  },
  {
    id: '7322121010',
    districtId: '7322121',
    name: 'Cendana Putih Dua',
  },
  {
    id: '7322121011',
    districtId: '7322121',
    name: 'Tarra Tallu',
  },
  {
    id: '7322121013',
    districtId: '7322121',
    name: 'Uraso',
  },
  {
    id: '7322121014',
    districtId: '7322121',
    name: 'Harapan',
  },
  {
    id: '7322121015',
    districtId: '7322121',
    name: 'Mappedeceng',
  },
  {
    id: '7322122001',
    districtId: '7322122',
    name: 'Tedeboe',
  },
  {
    id: '7322122002',
    districtId: '7322122',
    name: 'Rampi',
  },
  {
    id: '7322122003',
    districtId: '7322122',
    name: 'Dodolo',
  },
  {
    id: '7322122004',
    districtId: '7322122',
    name: 'Onondoa',
  },
  {
    id: '7322122005',
    districtId: '7322122',
    name: 'Sulaku',
  },
  {
    id: '7322122006',
    districtId: '7322122',
    name: 'Leboni',
  },
  {
    id: '7322130001',
    districtId: '7322130',
    name: 'Marampa',
  },
  {
    id: '7322130002',
    districtId: '7322130',
    name: 'Limbong',
  },
  {
    id: '7322130003',
    districtId: '7322130',
    name: 'Pengkendekan',
  },
  {
    id: '7322130004',
    districtId: '7322130',
    name: 'Komba',
  },
  {
    id: '7322130005',
    districtId: '7322130',
    name: 'Kanandede',
  },
  {
    id: '7322130006',
    districtId: '7322130',
    name: 'Minanga',
  },
  {
    id: '7322130007',
    districtId: '7322130',
    name: 'Rinding Allo',
  },
  {
    id: '7322131001',
    districtId: '7322131',
    name: 'Tirobali',
  },
  {
    id: '7322131002',
    districtId: '7322131',
    name: 'Malimongan',
  },
  {
    id: '7322131003',
    districtId: '7322131',
    name: 'Beroppa',
  },
  {
    id: '7322131004',
    districtId: '7322131',
    name: 'Tanama Kaleang',
  },
  {
    id: '7322131005',
    districtId: '7322131',
    name: 'Embonatana',
  },
  {
    id: '7322131006',
    districtId: '7322131',
    name: 'Lodang',
  },
  {
    id: '7322131007',
    districtId: '7322131',
    name: 'Padang Raya',
  },
  {
    id: '7322131008',
    districtId: '7322131',
    name: 'Padang Balua',
  },
  {
    id: '7322131009',
    districtId: '7322131',
    name: 'Taloto',
  },
  {
    id: '7322131010',
    districtId: '7322131',
    name: 'Marante',
  },
  {
    id: '7322131011',
    districtId: '7322131',
    name: 'Hono',
  },
  {
    id: '7322131012',
    districtId: '7322131',
    name: 'Hoyane',
  },
  {
    id: '7325010001',
    districtId: '7325010',
    name: 'Lauwo',
  },
  {
    id: '7325010002',
    districtId: '7325010',
    name: 'Lagego',
  },
  {
    id: '7325010003',
    districtId: '7325010',
    name: 'Burau',
  },
  {
    id: '7325010005',
    districtId: '7325010',
    name: 'Jalajja',
  },
  {
    id: '7325010006',
    districtId: '7325010',
    name: 'Mabonta',
  },
  {
    id: '7325010007',
    districtId: '7325010',
    name: 'Laro',
  },
  {
    id: '7325010008',
    districtId: '7325010',
    name: 'Lewonu',
  },
  {
    id: '7325010009',
    districtId: '7325010',
    name: 'Lanosi',
  },
  {
    id: '7325010010',
    districtId: '7325010',
    name: 'Bonepute',
  },
  {
    id: '7325010012',
    districtId: '7325010',
    name: 'Lambarese',
  },
  {
    id: '7325010013',
    districtId: '7325010',
    name: 'Cendana',
  },
  {
    id: '7325010014',
    districtId: '7325010',
    name: 'Batu Putih',
  },
  {
    id: '7325010015',
    districtId: '7325010',
    name: 'Burau Pantai',
  },
  {
    id: '7325010016',
    districtId: '7325010',
    name: 'Kalatiri',
  },
  {
    id: '7325010017',
    districtId: '7325010',
    name: 'Lambara Harapan',
  },
  {
    id: '7325010018',
    districtId: '7325010',
    name: 'Asana',
  },
  {
    id: '7325020001',
    districtId: '7325020',
    name: 'Lera',
  },
  {
    id: '7325020002',
    districtId: '7325020',
    name: 'Bawalipu',
  },
  {
    id: '7325020003',
    districtId: '7325020',
    name: 'Lampenai',
  },
  {
    id: '7325020004',
    districtId: '7325020',
    name: 'Bahari',
  },
  {
    id: '7325020005',
    districtId: '7325020',
    name: 'Kalaena',
  },
  {
    id: '7325020006',
    districtId: '7325020',
    name: 'Korombua',
  },
  {
    id: '7325020007',
    districtId: '7325020',
    name: 'Kanawatu',
  },
  {
    id: '7325020008',
    districtId: '7325020',
    name: 'Maramba',
  },
  {
    id: '7325020009',
    districtId: '7325020',
    name: 'Tarengge',
  },
  {
    id: '7325020010',
    districtId: '7325020',
    name: 'Cendana Hijau',
  },
  {
    id: '7325020011',
    districtId: '7325020',
    name: 'Balo Balo',
  },
  {
    id: '7325020012',
    districtId: '7325020',
    name: 'Pepuro Barat',
  },
  {
    id: '7325020013',
    districtId: '7325020',
    name: 'Rinjani',
  },
  {
    id: '7325020014',
    districtId: '7325020',
    name: 'Madani',
  },
  {
    id: '7325020015',
    districtId: '7325020',
    name: 'Tarengge Timur',
  },
  {
    id: '7325020016',
    districtId: '7325020',
    name: 'Tabaroge',
  },
  {
    id: '7325030001',
    districtId: '7325030',
    name: 'Tadulako',
  },
  {
    id: '7325030002',
    districtId: '7325030',
    name: 'Bangun Karya',
  },
  {
    id: '7325030008',
    districtId: '7325030',
    name: 'Lestari',
  },
  {
    id: '7325030009',
    districtId: '7325030',
    name: 'Bayondo',
  },
  {
    id: '7325030010',
    districtId: '7325030',
    name: 'Beringin Jaya',
  },
  {
    id: '7325030011',
    districtId: '7325030',
    name: 'Mandiri',
  },
  {
    id: '7325030012',
    districtId: '7325030',
    name: 'Sumber Alam',
  },
  {
    id: '7325030013',
    districtId: '7325030',
    name: 'Ujung Baru',
  },
  {
    id: '7325030014',
    districtId: '7325030',
    name: 'Kalpataru',
  },
  {
    id: '7325030015',
    districtId: '7325030',
    name: 'Tomoni',
  },
  {
    id: '7325030016',
    districtId: '7325030',
    name: 'Bangun Jaya',
  },
  {
    id: '7325030017',
    districtId: '7325030',
    name: 'Mulyasri',
  },
  {
    id: '7325030018',
    districtId: '7325030',
    name: 'Rante Mario',
  },
  {
    id: '7325031003',
    districtId: '7325031',
    name: 'Manunggal',
  },
  {
    id: '7325031004',
    districtId: '7325031',
    name: 'Alam Buana',
  },
  {
    id: '7325031005',
    districtId: '7325031',
    name: 'Cendana Hitam',
  },
  {
    id: '7325031006',
    districtId: '7325031',
    name: 'Kertaraharjo',
  },
  {
    id: '7325031007',
    districtId: '7325031',
    name: 'Margomulyo',
  },
  {
    id: '7325031018',
    districtId: '7325031',
    name: 'Purwosari',
  },
  {
    id: '7325031019',
    districtId: '7325031',
    name: 'Patengko',
  },
  {
    id: '7325031020',
    districtId: '7325031',
    name: 'Cendana Hitam Timur',
  },
  {
    id: '7325040001',
    districtId: '7325040',
    name: 'Maliwowo',
  },
  {
    id: '7325040002',
    districtId: '7325040',
    name: 'Tampinna',
  },
  {
    id: '7325040003',
    districtId: '7325040',
    name: 'Lamaeto',
  },
  {
    id: '7325040004',
    districtId: '7325040',
    name: 'Solo',
  },
  {
    id: '7325040005',
    districtId: '7325040',
    name: 'Tawakua',
  },
  {
    id: '7325040006',
    districtId: '7325040',
    name: 'Balirejo',
  },
  {
    id: '7325040007',
    districtId: '7325040',
    name: 'Mantadulu',
  },
  {
    id: '7325040008',
    districtId: '7325040',
    name: 'Taripa',
  },
  {
    id: '7325040009',
    districtId: '7325040',
    name: 'Watangpanua',
  },
  {
    id: '7325040010',
    districtId: '7325040',
    name: 'Wanasari',
  },
  {
    id: '7325050001',
    districtId: '7325050',
    name: 'Harapan',
  },
  {
    id: '7325050002',
    districtId: '7325050',
    name: 'Pongkeru',
  },
  {
    id: '7325050003',
    districtId: '7325050',
    name: 'Laskap',
  },
  {
    id: '7325050004',
    districtId: '7325050',
    name: 'Puncak Indah',
  },
  {
    id: '7325050006',
    districtId: '7325050',
    name: 'Malili',
  },
  {
    id: '7325050007',
    districtId: '7325050',
    name: 'Wewangriu',
  },
  {
    id: '7325050008',
    districtId: '7325050',
    name: 'Balantang',
  },
  {
    id: '7325050009',
    districtId: '7325050',
    name: 'Baruga',
  },
  {
    id: '7325050011',
    districtId: '7325050',
    name: 'Atue',
  },
  {
    id: '7325050012',
    districtId: '7325050',
    name: 'Manurung',
  },
  {
    id: '7325050013',
    districtId: '7325050',
    name: 'Lakawali',
  },
  {
    id: '7325050018',
    districtId: '7325050',
    name: 'Tarabbi',
  },
  {
    id: '7325050020',
    districtId: '7325050',
    name: 'Pasi Pasi',
  },
  {
    id: '7325050021',
    districtId: '7325050',
    name: 'Lakawali Pantai',
  },
  {
    id: '7325060001',
    districtId: '7325060',
    name: 'Tokalimbo',
  },
  {
    id: '7325060002',
    districtId: '7325060',
    name: 'Bantilang',
  },
  {
    id: '7325060003',
    districtId: '7325060',
    name: 'Loeha',
  },
  {
    id: '7325060004',
    districtId: '7325060',
    name: 'Timampu',
  },
  {
    id: '7325060005',
    districtId: '7325060',
    name: 'Langkea Raya',
  },
  {
    id: '7325060006',
    districtId: '7325060',
    name: 'Baruga',
  },
  {
    id: '7325060007',
    districtId: '7325060',
    name: 'Lioka',
  },
  {
    id: '7325060008',
    districtId: '7325060',
    name: 'Wawondula',
  },
  {
    id: '7325060009',
    districtId: '7325060',
    name: 'Pekaloa',
  },
  {
    id: '7325060010',
    districtId: '7325060',
    name: 'Asuli',
  },
  {
    id: '7325060011',
    districtId: '7325060',
    name: 'Mahalona',
  },
  {
    id: '7325060013',
    districtId: '7325060',
    name: 'Masiku',
  },
  {
    id: '7325060014',
    districtId: '7325060',
    name: 'Rante Angin',
  },
  {
    id: '7325060017',
    districtId: '7325060',
    name: 'Matompi',
  },
  {
    id: '7325060018',
    districtId: '7325060',
    name: 'Tole',
  },
  {
    id: '7325060019',
    districtId: '7325060',
    name: 'Buangin',
  },
  {
    id: '7325060020',
    districtId: '7325060',
    name: 'Libukan Mandiri',
  },
  {
    id: '7325060021',
    districtId: '7325060',
    name: 'Kalosi',
  },
  {
    id: '7325060022',
    districtId: '7325060',
    name: 'UPT Sp 4 Mahalona',
  },
  {
    id: '7325070014',
    districtId: '7325070',
    name: 'Soroako',
  },
  {
    id: '7325070015',
    districtId: '7325070',
    name: 'Nikkel',
  },
  {
    id: '7325070016',
    districtId: '7325070',
    name: 'Magani',
  },
  {
    id: '7325070021',
    districtId: '7325070',
    name: 'Matano',
  },
  {
    id: '7325070022',
    districtId: '7325070',
    name: 'Nuha',
  },
  {
    id: '7325071001',
    districtId: '7325071',
    name: 'Balambano',
  },
  {
    id: '7325071002',
    districtId: '7325071',
    name: 'Tabarano',
  },
  {
    id: '7325071018',
    districtId: '7325071',
    name: 'Wasuponda',
  },
  {
    id: '7325071019',
    districtId: '7325071',
    name: 'Kawata',
  },
  {
    id: '7325071020',
    districtId: '7325071',
    name: 'Parumpanai',
  },
  {
    id: '7325080001',
    districtId: '7325080',
    name: 'Balai Kembang',
  },
  {
    id: '7325080002',
    districtId: '7325080',
    name: 'Manggala',
  },
  {
    id: '7325080006',
    districtId: '7325080',
    name: 'Wonorejo',
  },
  {
    id: '7325080007',
    districtId: '7325080',
    name: 'Maleku',
  },
  {
    id: '7325080008',
    districtId: '7325080',
    name: 'Panca Karsa',
  },
  {
    id: '7325080009',
    districtId: '7325080',
    name: 'Margolembo',
  },
  {
    id: '7325080010',
    districtId: '7325080',
    name: 'Kasintuwu',
  },
  {
    id: '7325080011',
    districtId: '7325080',
    name: 'Teromu',
  },
  {
    id: '7325080012',
    districtId: '7325080',
    name: 'Wonorejo Timur',
  },
  {
    id: '7325080013',
    districtId: '7325080',
    name: 'Sindu Agung',
  },
  {
    id: '7325080014',
    districtId: '7325080',
    name: 'Koroncia',
  },
  {
    id: '7325081004',
    districtId: '7325081',
    name: 'Argomulyo',
  },
  {
    id: '7325081005',
    districtId: '7325081',
    name: 'Sumber Agung',
  },
  {
    id: '7325081012',
    districtId: '7325081',
    name: 'Pertasi Kencana',
  },
  {
    id: '7325081013',
    districtId: '7325081',
    name: 'Kalaena Kiri',
  },
  {
    id: '7325081014',
    districtId: '7325081',
    name: 'Non Blok',
  },
  {
    id: '7325081015',
    districtId: '7325081',
    name: 'Sumber Makmur',
  },
  {
    id: '7325081016',
    districtId: '7325081',
    name: 'Mekar Sari',
  },
  {
    id: '7326010001',
    districtId: '7326010',
    name: 'Lembang Tombang Langda',
  },
  {
    id: '7326010002',
    districtId: '7326010',
    name: 'Lembang  Langda',
  },
  {
    id: '7326010003',
    districtId: '7326010',
    name: 'Lembang Nonongan Selatan',
  },
  {
    id: '7326010004',
    districtId: '7326010',
    name: 'Lembang Marante',
  },
  {
    id: '7326010005',
    districtId: '7326010',
    name: 'Lembang Salu Sopai',
  },
  {
    id: '7326010006',
    districtId: '7326010',
    name: 'Lembang Salu Sarre',
  },
  {
    id: '7326010007',
    districtId: '7326010',
    name: 'Lembang Salu',
  },
  {
    id: '7326010008',
    districtId: '7326010',
    name: 'Kelurahan Nonongan Utara',
  },
  {
    id: '7326020001',
    districtId: '7326020',
    name: 'Lembang Sangbua',
  },
  {
    id: '7326020002',
    districtId: '7326020',
    name: 'Lembang Todongkon',
  },
  {
    id: '7326020003',
    districtId: '7326020',
    name: 'Lembang Angin-Angin',
  },
  {
    id: '7326020004',
    districtId: '7326020',
    name: 'Lembang Tallu Lolo',
  },
  {
    id: '7326020005',
    districtId: '7326020',
    name: 'Lembang Rindingbatu',
  },
  {
    id: '7326020006',
    districtId: '7326020',
    name: "Kelurahan Ba'Tan",
  },
  {
    id: '7326020007',
    districtId: '7326020',
    name: "Kelurahan Panta'Nakan Lolo",
  },
  {
    id: '7326030001',
    districtId: '7326030',
    name: 'Lembang Tallung Penanian',
  },
  {
    id: '7326030002',
    districtId: '7326030',
    name: "Lembang Pata'  Padang",
  },
  {
    id: '7326030003',
    districtId: '7326030',
    name: "Kelurahan Pa'Paelean",
  },
  {
    id: '7326030004',
    districtId: '7326030',
    name: "Lembang Buntu La'Bo",
  },
  {
    id: '7326030005',
    districtId: '7326030',
    name: "Lembang Tandung La'Bo",
  },
  {
    id: '7326030006',
    districtId: '7326030',
    name: "Lembang La'Bo",
  },
  {
    id: '7326040001',
    districtId: '7326040',
    name: 'Lembang Sapan KUA-KUA',
  },
  {
    id: '7326040002',
    districtId: '7326040',
    name: "Lembang  Misa Ba'Bana",
  },
  {
    id: '7326040003',
    districtId: '7326040',
    name: 'Lembang Rinding Kila Balabatu',
  },
  {
    id: '7326040004',
    districtId: '7326040',
    name: 'Kelurahan Tongkonan Basse',
  },
  {
    id: '7326040005',
    districtId: '7326040',
    name: 'Lembang Issong Kalua',
  },
  {
    id: '7326040006',
    districtId: '7326040',
    name: "Kelurahan Tallang Sura'",
  },
  {
    id: '7326050001',
    districtId: '7326050',
    name: 'Lembang Rante Bua Sanggalangi',
  },
  {
    id: '7326050002',
    districtId: '7326050',
    name: 'Lembang Rante Bua Samalu',
  },
  {
    id: '7326050003',
    districtId: '7326050',
    name: 'Lembang Rante Bua',
  },
  {
    id: '7326050004',
    districtId: '7326050',
    name: 'Kelurahan Buangin',
  },
  {
    id: '7326050005',
    districtId: '7326050',
    name: 'Kelurahan Bokin',
  },
  {
    id: '7326050006',
    districtId: '7326050',
    name: 'Lembang Makkuan Pare',
  },
  {
    id: '7326050007',
    districtId: '7326050',
    name: 'Lembang Pitung Penanian',
  },
  {
    id: '7326060001',
    districtId: '7326060',
    name: 'Lembang Rante',
  },
  {
    id: '7326060002',
    districtId: '7326060',
    name: 'Lembang Karre Penannian',
  },
  {
    id: '7326060003',
    districtId: '7326060',
    name: 'Lembang Karre Limbong',
  },
  {
    id: '7326060004',
    districtId: '7326060',
    name: 'Lembang Nanna Nanggala',
  },
  {
    id: '7326060005',
    districtId: '7326060',
    name: 'Lembang Basokan',
  },
  {
    id: '7326060006',
    districtId: '7326060',
    name: 'Lembang Nanggala',
  },
  {
    id: '7326060007',
    districtId: '7326060',
    name: 'Kelurahan Nanggala Sangpiak Salu',
  },
  {
    id: '7326060008',
    districtId: '7326060',
    name: 'Lembang Tandung Nanggala',
  },
  {
    id: '7326060009',
    districtId: '7326060',
    name: 'Lembang Lilikira',
  },
  {
    id: '7326070001',
    districtId: '7326070',
    name: 'Lembang Tondon',
  },
  {
    id: '7326070002',
    districtId: '7326070',
    name: 'Lembang Tondon Matallo',
  },
  {
    id: '7326070003',
    districtId: '7326070',
    name: 'Lembang Tondon Langi',
  },
  {
    id: '7326070004',
    districtId: '7326070',
    name: "Lembang Tondon Siba'Ta",
  },
  {
    id: '7326080001',
    districtId: '7326080',
    name: 'Kelurahan Tampo Tallunglipu',
  },
  {
    id: '7326080002',
    districtId: '7326080',
    name: 'Kelurahan Tagari Tallung Lipu',
  },
  {
    id: '7326080003',
    districtId: '7326080',
    name: 'Kelurahan Rante Paku Tallunglipu',
  },
  {
    id: '7326080004',
    districtId: '7326080',
    name: 'Kelurahan Tallunglipu Matallo',
  },
  {
    id: '7326080005',
    districtId: '7326080',
    name: 'Kelurahan Tallung Lipu',
  },
  {
    id: '7326080006',
    districtId: '7326080',
    name: 'Kelurahan Tantanan Tallunglipu',
  },
  {
    id: '7326080007',
    districtId: '7326080',
    name: 'Lembang Buntu Tallunglipu',
  },
  {
    id: '7326090001',
    districtId: '7326090',
    name: 'Lembang Saloso',
  },
  {
    id: '7326090002',
    districtId: '7326090',
    name: 'Kelurahan Limbong',
  },
  {
    id: '7326090003',
    districtId: '7326090',
    name: 'Kelurahan Mentiro Tiku',
  },
  {
    id: '7326090004',
    districtId: '7326090',
    name: 'Kelurahan Laang Tanduk',
  },
  {
    id: '7326090005',
    districtId: '7326090',
    name: 'Kelurahan Singki',
  },
  {
    id: '7326090006',
    districtId: '7326090',
    name: 'Kelurahan Karassik',
  },
  {
    id: '7326090007',
    districtId: '7326090',
    name: 'Kelurahan Rantepao',
  },
  {
    id: '7326090008',
    districtId: '7326090',
    name: 'Kelurahan Rante Pasele',
  },
  {
    id: '7326090009',
    districtId: '7326090',
    name: 'Kelurahan Pasele',
  },
  {
    id: '7326090010',
    districtId: '7326090',
    name: 'Kelurahan Malango',
  },
  {
    id: '7326090011',
    districtId: '7326090',
    name: 'Kelurahan Penanian',
  },
  {
    id: '7326100001',
    districtId: '7326100',
    name: 'Kelurahan Buntu Barana',
  },
  {
    id: '7326100002',
    districtId: '7326100',
    name: 'Kelurahan Tikala',
  },
  {
    id: '7326100003',
    districtId: '7326100',
    name: 'Lembang Sereale',
  },
  {
    id: '7326100004',
    districtId: '7326100',
    name: 'Lembang Buntu Batu',
  },
  {
    id: '7326100005',
    districtId: '7326100',
    name: 'Lembang Embatau',
  },
  {
    id: '7326100006',
    districtId: '7326100',
    name: "Lembang Benteng Ka'Do To'Ria",
  },
  {
    id: '7326100007',
    districtId: '7326100',
    name: 'Lembang Pangden',
  },
  {
    id: '7326110001',
    districtId: '7326110',
    name: 'Lembang Buntu Lobo',
  },
  {
    id: '7326110002',
    districtId: '7326110',
    name: "Lembang Parinding'",
  },
  {
    id: '7326110003',
    districtId: '7326110',
    name: 'Kelurahan Deri',
  },
  {
    id: '7326110004',
    districtId: '7326110',
    name: 'Lembang Bori Rantatelok',
  },
  {
    id: '7326110005',
    districtId: '7326110',
    name: 'Kelurahan Bori',
  },
  {
    id: '7326110006',
    districtId: '7326110',
    name: 'Lembang Bori Lombongan',
  },
  {
    id: '7326110007',
    districtId: '7326110',
    name: 'Kelurahan Pangli Selatan',
  },
  {
    id: '7326110008',
    districtId: '7326110',
    name: 'Kelurahan Pangli',
  },
  {
    id: '7326110009',
    districtId: '7326110',
    name: "Kelurahan Palawa'",
  },
  {
    id: '7326120001',
    districtId: '7326120',
    name: 'Lembang Palangi',
  },
  {
    id: '7326120002',
    districtId: '7326120',
    name: 'Lembang Karua',
  },
  {
    id: '7326120003',
    districtId: '7326120',
    name: "Lembang Lilikira Ao'Gading",
  },
  {
    id: '7326120004',
    districtId: '7326120',
    name: 'Lembang Awak Kawasik',
  },
  {
    id: '7326120005',
    districtId: '7326120',
    name: 'Kelurahan Tagari',
  },
  {
    id: '7326120006',
    districtId: '7326120',
    name: 'Kelurahan  Balusu',
  },
  {
    id: '7326120007',
    districtId: '7326120',
    name: 'Lembang Balusu Bangun Lipu',
  },
  {
    id: '7326130001',
    districtId: '7326130',
    name: "Lembang Sa'Dan Andulan",
  },
  {
    id: '7326130002',
    districtId: '7326130',
    name: "Lembang Sa'Dan Tiro Allo",
  },
  {
    id: '7326130003',
    districtId: '7326130',
    name: "Kelurahan Sa'Dan Matalo",
  },
  {
    id: '7326130004',
    districtId: '7326130',
    name: 'Lembang Sangkaropi',
  },
  {
    id: '7326130005',
    districtId: '7326130',
    name: 'Kelurahan Sa Dan Malimbong',
  },
  {
    id: '7326130006',
    districtId: '7326130',
    name: 'Lembang Sadan Pabulian',
  },
  {
    id: '7326130007',
    districtId: '7326130',
    name: 'Lembang Sadan Ballo Pasange',
  },
  {
    id: '7326130008',
    districtId: '7326130',
    name: "Lembang Sa'Dan Liku Lambe",
  },
  {
    id: '7326130009',
    districtId: '7326130',
    name: 'Lembang Sadan Pesondongan',
  },
  {
    id: '7326130010',
    districtId: '7326130',
    name: 'Lembang Sadan Ulusalu',
  },
  {
    id: '7326140001',
    districtId: '7326140',
    name: 'Lembang Toyasa Akung',
  },
  {
    id: '7326140002',
    districtId: '7326140',
    name: 'Lembang Batu Limbong',
  },
  {
    id: '7326140003',
    districtId: '7326140',
    name: 'Lembang Bangkele Kila',
  },
  {
    id: '7326140004',
    districtId: '7326140',
    name: 'Lembang Tampan Bonga',
  },
  {
    id: '7326150001',
    districtId: '7326150',
    name: 'Lembang Tonga Riu',
  },
  {
    id: '7326150002',
    districtId: '7326150',
    name: 'Lembang Landorundun',
  },
  {
    id: '7326150003',
    districtId: '7326150',
    name: 'Lembang  Suloara',
  },
  {
    id: '7326150004',
    districtId: '7326150',
    name: 'Lembang Sesean Matallo',
  },
  {
    id: '7326150005',
    districtId: '7326150',
    name: 'Lembang Lempo',
  },
  {
    id: '7326160001',
    districtId: '7326160',
    name: 'Lembang Benteng Mamullu',
  },
  {
    id: '7326160002',
    districtId: '7326160',
    name: 'Lembang Kapala Pitu',
  },
  {
    id: '7326160003',
    districtId: '7326160',
    name: 'Lembang Kantun Poya',
  },
  {
    id: '7326160004',
    districtId: '7326160',
    name: "Lembang Benteng Ka'Do",
  },
  {
    id: '7326160005',
    districtId: '7326160',
    name: "Lembang Sikuku'",
  },
  {
    id: '7326160006',
    districtId: '7326160',
    name: 'Lembang Polo Padang',
  },
  {
    id: '7326170001',
    districtId: '7326170',
    name: 'Lembang Kapoloang',
  },
  {
    id: '7326170002',
    districtId: '7326170',
    name: 'Lembang Piongan',
  },
  {
    id: '7326170003',
    districtId: '7326170',
    name: 'Kelurahan Pasang',
  },
  {
    id: '7326170004',
    districtId: '7326170',
    name: 'Lembang Dende',
  },
  {
    id: '7326170005',
    districtId: '7326170',
    name: 'Lembang Paku',
  },
  {
    id: '7326170006',
    districtId: '7326170',
    name: "Lembang Ma'Dong",
  },
  {
    id: '7326170007',
    districtId: '7326170',
    name: 'Lembang Buntu Tagari',
  },
  {
    id: '7326170008',
    districtId: '7326170',
    name: 'Lembang Parindingan',
  },
  {
    id: '7326180001',
    districtId: '7326180',
    name: 'Lembang Batu Lotong',
  },
  {
    id: '7326180002',
    districtId: '7326180',
    name: 'Lembang Awan',
  },
  {
    id: '7326180003',
    districtId: '7326180',
    name: 'Lembang Londong Biang',
  },
  {
    id: '7326180004',
    districtId: '7326180',
    name: 'Lembang Buntu Karua',
  },
  {
    id: '7326190001',
    districtId: '7326190',
    name: 'Lembang Buntu Batu',
  },
  {
    id: '7326190002',
    districtId: '7326190',
    name: 'Kelurahan Pangala',
  },
  {
    id: '7326190003',
    districtId: '7326190',
    name: 'Lembang Ampang Batu',
  },
  {
    id: '7326190004',
    districtId: '7326190',
    name: 'Kelurahan Pangala Utara',
  },
  {
    id: '7326190005',
    districtId: '7326190',
    name: "Lembang Mai'Ting",
  },
  {
    id: '7326190006',
    districtId: '7326190',
    name: "Lembang Lo'Ko' Uru Tanete Batu",
  },
  {
    id: '7326190007',
    districtId: '7326190',
    name: 'Lembang Rinding Allo',
  },
  {
    id: '7326190009',
    districtId: '7326190',
    name: 'Lembang Bulu Langkan',
  },
  {
    id: '7326190010',
    districtId: '7326190',
    name: 'Lembang Lempo Poton',
  },
  {
    id: '7326200001',
    districtId: '7326200',
    name: 'Lembang Parandangan',
  },
  {
    id: '7326200002',
    districtId: '7326200',
    name: 'Lembang Buntu Minanga',
  },
  {
    id: '7326200003',
    districtId: '7326200',
    name: 'Lembang Sarambu',
  },
  {
    id: '7326200004',
    districtId: '7326200',
    name: 'Kelurahan Sapan',
  },
  {
    id: '7326200005',
    districtId: '7326200',
    name: 'Lembang Ratte Uma',
  },
  {
    id: '7326200006',
    districtId: '7326200',
    name: 'Lembang Pulu-Pulu',
  },
  {
    id: '7326200007',
    districtId: '7326200',
    name: 'Lembang Pengkaroan Manuk',
  },
  {
    id: '7326200008',
    districtId: '7326200',
    name: 'Lembang Batu Busa',
  },
  {
    id: '7326200009',
    districtId: '7326200',
    name: "Lembang Roroan Barra'-Barra'",
  },
  {
    id: '7326200010',
    districtId: '7326200',
    name: 'Lembang Pangkung Batu',
  },
  {
    id: '7326200011',
    districtId: '7326200',
    name: 'Lembang Ponglu',
  },
  {
    id: '7326200012',
    districtId: '7326200',
    name: 'Lembang Paonganan',
  },
  {
    id: '7326200013',
    districtId: '7326200',
    name: 'Lembang Talimbangan',
  },
  {
    id: '7326210001',
    districtId: '7326210',
    name: 'Kelurahan Baruppu Selatan',
  },
  {
    id: '7326210002',
    districtId: '7326210',
    name: 'Lembang Baruppu Benteng Batu',
  },
  {
    id: '7326210003',
    districtId: '7326210',
    name: 'Lembang Baruppu Utara',
  },
  {
    id: '7326210004',
    districtId: '7326210',
    name: 'Lembang Baruppu Parodo',
  },
  {
    id: '7371010001',
    districtId: '7371010',
    name: 'Bontorannu',
  },
  {
    id: '7371010002',
    districtId: '7371010',
    name: 'Tamarunang',
  },
  {
    id: '7371010003',
    districtId: '7371010',
    name: 'Mattoangin',
  },
  {
    id: '7371010004',
    districtId: '7371010',
    name: 'Kampung Buyang',
  },
  {
    id: '7371010005',
    districtId: '7371010',
    name: 'Mariso',
  },
  {
    id: '7371010007',
    districtId: '7371010',
    name: 'Mario',
  },
  {
    id: '7371010008',
    districtId: '7371010',
    name: 'Panambungan',
  },
  {
    id: '7371010009',
    districtId: '7371010',
    name: 'Kunjung Mae',
  },
  {
    id: '7371020001',
    districtId: '7371020',
    name: 'Tamparang Keke',
  },
  {
    id: '7371020002',
    districtId: '7371020',
    name: 'Sambung Jawa',
  },
  {
    id: '7371020003',
    districtId: '7371020',
    name: 'Karang Anyar',
  },
  {
    id: '7371020004',
    districtId: '7371020',
    name: 'Baji Mappakasunggu',
  },
  {
    id: '7371020005',
    districtId: '7371020',
    name: "Pa'Batang",
  },
  {
    id: '7371020006',
    districtId: '7371020',
    name: 'Parang',
  },
  {
    id: '7371020007',
    districtId: '7371020',
    name: 'Bonto Lebang',
  },
  {
    id: '7371020008',
    districtId: '7371020',
    name: 'Mamajang Dalam',
  },
  {
    id: '7371020009',
    districtId: '7371020',
    name: 'Labuang Baji',
  },
  {
    id: '7371020010',
    districtId: '7371020',
    name: 'Bonto Biraeng',
  },
  {
    id: '7371020011',
    districtId: '7371020',
    name: 'Mandala',
  },
  {
    id: '7371020012',
    districtId: '7371020',
    name: 'Maricaya Selatan',
  },
  {
    id: '7371020013',
    districtId: '7371020',
    name: 'Mamajang Luar',
  },
  {
    id: '7371030001',
    districtId: '7371030',
    name: 'Barombong',
  },
  {
    id: '7371030002',
    districtId: '7371030',
    name: 'Tanjung Merdeka',
  },
  {
    id: '7371030003',
    districtId: '7371030',
    name: 'Maccini Sombala',
  },
  {
    id: '7371030004',
    districtId: '7371030',
    name: 'Balang Baru',
  },
  {
    id: '7371030005',
    districtId: '7371030',
    name: 'Jongaya',
  },
  {
    id: '7371030006',
    districtId: '7371030',
    name: 'Bongaya',
  },
  {
    id: '7371030007',
    districtId: '7371030',
    name: "Pa'Baeng-Baeng",
  },
  {
    id: '7371030008',
    districtId: '7371030',
    name: 'Mannuruki',
  },
  {
    id: '7371030009',
    districtId: '7371030',
    name: 'Parang Tambung',
  },
  {
    id: '7371030010',
    districtId: '7371030',
    name: 'Mangasa',
  },
  {
    id: '7371030011',
    districtId: '7371030',
    name: 'Bonto Duri',
  },
  {
    id: '7371031001',
    districtId: '7371031',
    name: 'Gunung Sari',
  },
  {
    id: '7371031002',
    districtId: '7371031',
    name: 'Karunrung',
  },
  {
    id: '7371031003',
    districtId: '7371031',
    name: 'Mappala',
  },
  {
    id: '7371031004',
    districtId: '7371031',
    name: 'Kassi-Kassi',
  },
  {
    id: '7371031005',
    districtId: '7371031',
    name: 'Bonto Makkio',
  },
  {
    id: '7371031006',
    districtId: '7371031',
    name: 'Tidung',
  },
  {
    id: '7371031007',
    districtId: '7371031',
    name: 'Banta-Bantaeng',
  },
  {
    id: '7371031008',
    districtId: '7371031',
    name: 'Buakana',
  },
  {
    id: '7371031009',
    districtId: '7371031',
    name: 'Rappocini',
  },
  {
    id: '7371031010',
    districtId: '7371031',
    name: 'Ballaparang',
  },
  {
    id: '7371031011',
    districtId: '7371031',
    name: 'Minasa Upa',
  },
  {
    id: '7371040001',
    districtId: '7371040',
    name: 'Maricaya',
  },
  {
    id: '7371040002',
    districtId: '7371040',
    name: 'Maricaya Baru',
  },
  {
    id: '7371040003',
    districtId: '7371040',
    name: 'Maradekaya Selatan',
  },
  {
    id: '7371040004',
    districtId: '7371040',
    name: 'Bara-Baraya Selatan',
  },
  {
    id: '7371040005',
    districtId: '7371040',
    name: 'Bara-Baraya',
  },
  {
    id: '7371040006',
    districtId: '7371040',
    name: 'Maradekaya',
  },
  {
    id: '7371040007',
    districtId: '7371040',
    name: 'Maradekaya Utara',
  },
  {
    id: '7371040008',
    districtId: '7371040',
    name: 'Bara-Baraya Utara',
  },
  {
    id: '7371040009',
    districtId: '7371040',
    name: 'Bara-Baraya Timur',
  },
  {
    id: '7371040010',
    districtId: '7371040',
    name: 'Maccini Parang',
  },
  {
    id: '7371040011',
    districtId: '7371040',
    name: 'Maccini',
  },
  {
    id: '7371040012',
    districtId: '7371040',
    name: 'Maccini Gusung',
  },
  {
    id: '7371040013',
    districtId: '7371040',
    name: 'Barana',
  },
  {
    id: '7371040014',
    districtId: '7371040',
    name: 'Lariang Bangi',
  },
  {
    id: '7371050001',
    districtId: '7371050',
    name: 'Lae - Lae',
  },
  {
    id: '7371050002',
    districtId: '7371050',
    name: 'Losari',
  },
  {
    id: '7371050003',
    districtId: '7371050',
    name: 'Mangkura',
  },
  {
    id: '7371050004',
    districtId: '7371050',
    name: 'Pisang Selatan',
  },
  {
    id: '7371050005',
    districtId: '7371050',
    name: 'Lajangiru',
  },
  {
    id: '7371050006',
    districtId: '7371050',
    name: 'Sawerigading',
  },
  {
    id: '7371050007',
    districtId: '7371050',
    name: 'Maloku',
  },
  {
    id: '7371050008',
    districtId: '7371050',
    name: 'Bulogading',
  },
  {
    id: '7371050009',
    districtId: '7371050',
    name: 'Baru',
  },
  {
    id: '7371050010',
    districtId: '7371050',
    name: 'Pisang Utara',
  },
  {
    id: '7371060001',
    districtId: '7371060',
    name: 'Pattunuang',
  },
  {
    id: '7371060003',
    districtId: '7371060',
    name: 'Melayu Baru',
  },
  {
    id: '7371060004',
    districtId: '7371060',
    name: 'Melayu',
  },
  {
    id: '7371060006',
    districtId: '7371060',
    name: 'Mampu',
  },
  {
    id: '7371060007',
    districtId: '7371060',
    name: 'Malimongan',
  },
  {
    id: '7371060008',
    districtId: '7371060',
    name: 'Malimongan Tua',
  },
  {
    id: '7371070001',
    districtId: '7371070',
    name: 'Gaddong',
  },
  {
    id: '7371070002',
    districtId: '7371070',
    name: 'Wajo Baru',
  },
  {
    id: '7371070003',
    districtId: '7371070',
    name: 'Tompo Balang',
  },
  {
    id: '7371070004',
    districtId: '7371070',
    name: 'Malimongan Baru',
  },
  {
    id: '7371070005',
    districtId: '7371070',
    name: 'Timungan Lompoa',
  },
  {
    id: '7371070006',
    districtId: '7371070',
    name: 'Baraya',
  },
  {
    id: '7371070007',
    districtId: '7371070',
    name: 'Bontoala',
  },
  {
    id: '7371070008',
    districtId: '7371070',
    name: 'Bontoala Parang',
  },
  {
    id: '7371070009',
    districtId: '7371070',
    name: 'Bontoala Tua',
  },
  {
    id: '7371070010',
    districtId: '7371070',
    name: 'Bunga Ejaya',
  },
  {
    id: '7371070011',
    districtId: '7371070',
    name: 'Layang',
  },
  {
    id: '7371070012',
    districtId: '7371070',
    name: 'Parang Layang',
  },
  {
    id: '7371080004',
    districtId: '7371080',
    name: 'Ujung Tanah',
  },
  {
    id: '7371080005',
    districtId: '7371080',
    name: 'Tamalabba',
  },
  {
    id: '7371080006',
    districtId: '7371080',
    name: 'Tabaringan',
  },
  {
    id: '7371080007',
    districtId: '7371080',
    name: 'Totaka',
  },
  {
    id: '7371080008',
    districtId: '7371080',
    name: 'Pattingalloang',
  },
  {
    id: '7371080010',
    districtId: '7371080',
    name: 'Pattingalloang Baru',
  },
  {
    id: '7371080011',
    districtId: '7371080',
    name: 'Camba Berua',
  },
  {
    id: '7371080012',
    districtId: '7371080',
    name: 'Cambaya',
  },
  {
    id: '7371081001',
    districtId: '7371081',
    name: 'Kodingareng',
  },
  {
    id: '7371081002',
    districtId: '7371081',
    name: 'Barrang Caddi',
  },
  {
    id: '7371081003',
    districtId: '7371081',
    name: 'Barrang Lompo',
  },
  {
    id: '7371090001',
    districtId: '7371090',
    name: 'Bunga Eja Beru',
  },
  {
    id: '7371090002',
    districtId: '7371090',
    name: 'Lembo',
  },
  {
    id: '7371090003',
    districtId: '7371090',
    name: 'Kalukuang',
  },
  {
    id: '7371090004',
    districtId: '7371090',
    name: "La'Latang",
  },
  {
    id: '7371090005',
    districtId: '7371090',
    name: 'Rappojawa',
  },
  {
    id: '7371090006',
    districtId: '7371090',
    name: 'Tammua',
  },
  {
    id: '7371090007',
    districtId: '7371090',
    name: 'Rappokalling',
  },
  {
    id: '7371090008',
    districtId: '7371090',
    name: 'Wala-Walaya',
  },
  {
    id: '7371090009',
    districtId: '7371090',
    name: 'Ujung Pandang Baru',
  },
  {
    id: '7371090010',
    districtId: '7371090',
    name: 'Suwangga',
  },
  {
    id: '7371090011',
    districtId: '7371090',
    name: 'Pannampu',
  },
  {
    id: '7371090012',
    districtId: '7371090',
    name: 'Kaluku Bodoa',
  },
  {
    id: '7371090013',
    districtId: '7371090',
    name: 'Buloa',
  },
  {
    id: '7371090014',
    districtId: '7371090',
    name: 'Tallo',
  },
  {
    id: '7371090015',
    districtId: '7371090',
    name: 'Lakkang',
  },
  {
    id: '7371100007',
    districtId: '7371100',
    name: 'Paropo',
  },
  {
    id: '7371100008',
    districtId: '7371100',
    name: 'Karampuang',
  },
  {
    id: '7371100009',
    districtId: '7371100',
    name: 'Pandang',
  },
  {
    id: '7371100010',
    districtId: '7371100',
    name: 'Masale',
  },
  {
    id: '7371100011',
    districtId: '7371100',
    name: 'Tamamaung',
  },
  {
    id: '7371100012',
    districtId: '7371100',
    name: 'Karuwisi',
  },
  {
    id: '7371100013',
    districtId: '7371100',
    name: 'Sinri Jala',
  },
  {
    id: '7371100014',
    districtId: '7371100',
    name: 'Karuwisi Utara',
  },
  {
    id: '7371100015',
    districtId: '7371100',
    name: 'Pampang',
  },
  {
    id: '7371100016',
    districtId: '7371100',
    name: 'Panaikang',
  },
  {
    id: '7371100017',
    districtId: '7371100',
    name: 'Tello Baru',
  },
  {
    id: '7371101001',
    districtId: '7371101',
    name: 'Borong',
  },
  {
    id: '7371101002',
    districtId: '7371101',
    name: 'Bangkala',
  },
  {
    id: '7371101003',
    districtId: '7371101',
    name: 'Tamangapa',
  },
  {
    id: '7371101004',
    districtId: '7371101',
    name: 'Manggala',
  },
  {
    id: '7371101005',
    districtId: '7371101',
    name: 'Antang',
  },
  {
    id: '7371101006',
    districtId: '7371101',
    name: 'Batua',
  },
  {
    id: '7371101007',
    districtId: '7371101',
    name: 'Bitowa',
  },
  {
    id: '7371101008',
    districtId: '7371101',
    name: 'Biring Romang',
  },
  {
    id: '7371110004',
    districtId: '7371110',
    name: 'Paccerakang',
  },
  {
    id: '7371110005',
    districtId: '7371110',
    name: 'Daya',
  },
  {
    id: '7371110009',
    districtId: '7371110',
    name: 'P A I',
  },
  {
    id: '7371110010',
    districtId: '7371110',
    name: 'Sudiang Raya',
  },
  {
    id: '7371110011',
    districtId: '7371110',
    name: 'Sudiang',
  },
  {
    id: '7371110012',
    districtId: '7371110',
    name: 'Bulurokeng',
  },
  {
    id: '7371110013',
    districtId: '7371110',
    name: 'Untia',
  },
  {
    id: '7371110014',
    districtId: '7371110',
    name: 'Berua',
  },
  {
    id: '7371110015',
    districtId: '7371110',
    name: 'Katimbang',
  },
  {
    id: '7371110016',
    districtId: '7371110',
    name: 'Bakung',
  },
  {
    id: '7371110017',
    districtId: '7371110',
    name: 'Laikang',
  },
  {
    id: '7371111001',
    districtId: '7371111',
    name: 'Tamalanrea Indah',
  },
  {
    id: '7371111002',
    districtId: '7371111',
    name: 'Tamalanrea Jaya',
  },
  {
    id: '7371111003',
    districtId: '7371111',
    name: 'Tamalanrea',
  },
  {
    id: '7371111004',
    districtId: '7371111',
    name: 'Kapasa',
  },
  {
    id: '7371111005',
    districtId: '7371111',
    name: 'Parang Loe',
  },
  {
    id: '7371111006',
    districtId: '7371111',
    name: 'Bira',
  },
  {
    id: '7371111008',
    districtId: '7371111',
    name: 'Kapasa Raya',
  },
  {
    id: '7372010002',
    districtId: '7372010',
    name: 'Watang Bacukiki',
  },
  {
    id: '7372010003',
    districtId: '7372010',
    name: 'Lemoe',
  },
  {
    id: '7372010004',
    districtId: '7372010',
    name: 'Lompoe',
  },
  {
    id: '7372010005',
    districtId: '7372010',
    name: 'Galung Maloang',
  },
  {
    id: '7372011002',
    districtId: '7372011',
    name: 'Bumi Harapan',
  },
  {
    id: '7372011003',
    districtId: '7372011',
    name: 'Sumpang Minangae',
  },
  {
    id: '7372011004',
    districtId: '7372011',
    name: 'Cappagalung',
  },
  {
    id: '7372011005',
    districtId: '7372011',
    name: 'Tiro Sompe',
  },
  {
    id: '7372011006',
    districtId: '7372011',
    name: 'Kampung Baru',
  },
  {
    id: '7372020001',
    districtId: '7372020',
    name: 'Labukkang',
  },
  {
    id: '7372020002',
    districtId: '7372020',
    name: 'Mallusetasi',
  },
  {
    id: '7372020003',
    districtId: '7372020',
    name: 'Ujung Sabbang',
  },
  {
    id: '7372020005',
    districtId: '7372020',
    name: 'Lapadde',
  },
  {
    id: '7372030001',
    districtId: '7372030',
    name: 'Kampung Pisang',
  },
  {
    id: '7372030002',
    districtId: '7372030',
    name: 'Lakessi',
  },
  {
    id: '7372030003',
    districtId: '7372030',
    name: 'Ujung Baru',
  },
  {
    id: '7372030004',
    districtId: '7372030',
    name: 'Ujung Lare',
  },
  {
    id: '7372030005',
    districtId: '7372030',
    name: 'Bukit Indah',
  },
  {
    id: '7372030006',
    districtId: '7372030',
    name: 'Watang Soreang',
  },
  {
    id: '7372030007',
    districtId: '7372030',
    name: 'Bukit Harapan',
  },
  {
    id: '7373010002',
    districtId: '7373010',
    name: 'Sampoddo',
  },
  {
    id: '7373010003',
    districtId: '7373010',
    name: 'Songka',
  },
  {
    id: '7373010004',
    districtId: '7373010',
    name: 'Takkalala',
  },
  {
    id: '7373010005',
    districtId: '7373010',
    name: 'Binturu',
  },
  {
    id: '7373011001',
    districtId: '7373011',
    name: 'Purangi',
  },
  {
    id: '7373011005',
    districtId: '7373011',
    name: 'Mawa',
  },
  {
    id: '7373011006',
    districtId: '7373011',
    name: 'Peta',
  },
  {
    id: '7373011007',
    districtId: '7373011',
    name: 'Sendana',
  },
  {
    id: '7373020003',
    districtId: '7373020',
    name: 'Amassangan',
  },
  {
    id: '7373020004',
    districtId: '7373020',
    name: 'Tompotikka',
  },
  {
    id: '7373020005',
    districtId: '7373020',
    name: 'Lagaligo',
  },
  {
    id: '7373020006',
    districtId: '7373020',
    name: 'Boting',
  },
  {
    id: '7373020007',
    districtId: '7373020',
    name: 'Dangerakko',
  },
  {
    id: '7373020008',
    districtId: '7373020',
    name: 'Pajalesang',
  },
  {
    id: '7373021002',
    districtId: '7373021',
    name: 'Surutanga',
  },
  {
    id: '7373021003',
    districtId: '7373021',
    name: 'Pontap',
  },
  {
    id: '7373021004',
    districtId: '7373021',
    name: 'Salekoe',
  },
  {
    id: '7373021005',
    districtId: '7373021',
    name: 'Salotellue',
  },
  {
    id: '7373021006',
    districtId: '7373021',
    name: 'Malatunrung',
  },
  {
    id: '7373021007',
    districtId: '7373021',
    name: 'Ponjalae',
  },
  {
    id: '7373022008',
    districtId: '7373022',
    name: 'Mungkajang',
  },
  {
    id: '7373022009',
    districtId: '7373022',
    name: 'Murante',
  },
  {
    id: '7373022010',
    districtId: '7373022',
    name: 'Latuppa',
  },
  {
    id: '7373022011',
    districtId: '7373022',
    name: 'Kambo',
  },
  {
    id: '7373030001',
    districtId: '7373030',
    name: 'Sabbamparu',
  },
  {
    id: '7373030002',
    districtId: '7373030',
    name: 'Batupasi',
  },
  {
    id: '7373030004',
    districtId: '7373030',
    name: 'Salobulo',
  },
  {
    id: '7373030005',
    districtId: '7373030',
    name: 'Penggoli',
  },
  {
    id: '7373030006',
    districtId: '7373030',
    name: 'Luminda',
  },
  {
    id: '7373030007',
    districtId: '7373030',
    name: 'Pattene',
  },
  {
    id: '7373031006',
    districtId: '7373031',
    name: 'Rampoang',
  },
  {
    id: '7373031007',
    districtId: '7373031',
    name: 'Temmalebba',
  },
  {
    id: '7373031008',
    districtId: '7373031',
    name: 'Balandai',
  },
  {
    id: '7373031009',
    districtId: '7373031',
    name: "To'Bulung",
  },
  {
    id: '7373031010',
    districtId: '7373031',
    name: 'Buntu Datu',
  },
  {
    id: '7373040002',
    districtId: '7373040',
    name: 'Mancani',
  },
  {
    id: '7373040003',
    districtId: '7373040',
    name: 'Salubattang',
  },
  {
    id: '7373040004',
    districtId: '7373040',
    name: 'Maroangin',
  },
  {
    id: '7373040005',
    districtId: '7373040',
    name: 'Jaya',
  },
  {
    id: '7373040006',
    districtId: '7373040',
    name: 'Sumarambu',
  },
  {
    id: '7373040007',
    districtId: '7373040',
    name: 'Batu Walenrang',
  },
  {
    id: '7373040008',
    districtId: '7373040',
    name: 'Pentojangan',
  },
  {
    id: '7373041001',
    districtId: '7373041',
    name: 'Battang',
  },
  {
    id: '7373041007',
    districtId: '7373041',
    name: 'Tomarundung',
  },
  {
    id: '7373041008',
    districtId: '7373041',
    name: 'Battang Barat',
  },
  {
    id: '7373041009',
    districtId: '7373041',
    name: 'Lebang',
  },
  {
    id: '7373041010',
    districtId: '7373041',
    name: 'Padang Lambe',
  },
  {
    id: '7401050016',
    districtId: '7401050',
    name: 'Wasuamba',
  },
  {
    id: '7401050019',
    districtId: '7401050',
    name: 'Bonelalo',
  },
  {
    id: '7401050020',
    districtId: '7401050',
    name: 'Lasembangi',
  },
  {
    id: '7401050021',
    districtId: '7401050',
    name: 'Kamaru',
  },
  {
    id: '7401050022',
    districtId: '7401050',
    name: 'Suandala',
  },
  {
    id: '7401050023',
    districtId: '7401050',
    name: 'Lawele',
  },
  {
    id: '7401050024',
    districtId: '7401050',
    name: 'Kakenauwe',
  },
  {
    id: '7401050025',
    districtId: '7401050',
    name: 'Waoleona',
  },
  {
    id: '7401050026',
    districtId: '7401050',
    name: 'Wagari',
  },
  {
    id: '7401050027',
    districtId: '7401050',
    name: 'Sribatara',
  },
  {
    id: '7401050028',
    districtId: '7401050',
    name: 'Togo Mangura',
  },
  {
    id: '7401050029',
    districtId: '7401050',
    name: 'Wasambaa',
  },
  {
    id: '7401050030',
    districtId: '7401050',
    name: 'Talaga Baru',
  },
  {
    id: '7401050031',
    districtId: '7401050',
    name: 'Nambo',
  },
  {
    id: '7401051008',
    districtId: '7401051',
    name: 'Ambuau Indah',
  },
  {
    id: '7401051009',
    districtId: '7401051',
    name: 'Mopaano',
  },
  {
    id: '7401051010',
    districtId: '7401051',
    name: 'Umalaoge',
  },
  {
    id: '7401051011',
    districtId: '7401051',
    name: 'Kinapani Makmur',
  },
  {
    id: '7401051012',
    districtId: '7401051',
    name: 'Lasalimu',
  },
  {
    id: '7401051013',
    districtId: '7401051',
    name: 'Siomanuru',
  },
  {
    id: '7401051014',
    districtId: '7401051',
    name: 'Siontapina',
  },
  {
    id: '7401051015',
    districtId: '7401051',
    name: 'Wajah Jaya',
  },
  {
    id: '7401051016',
    districtId: '7401051',
    name: 'Mulya Jaya',
  },
  {
    id: '7401051017',
    districtId: '7401051',
    name: 'Harapan Jaya',
  },
  {
    id: '7401051018',
    districtId: '7401051',
    name: 'Sangia Arano',
  },
  {
    id: '7401051019',
    districtId: '7401051',
    name: 'Mega Bahari',
  },
  {
    id: '7401051020',
    districtId: '7401051',
    name: 'Sumber Agung',
  },
  {
    id: '7401051021',
    districtId: '7401051',
    name: 'Ambuau Togo',
  },
  {
    id: '7401051022',
    districtId: '7401051',
    name: 'Balimu',
  },
  {
    id: '7401051023',
    districtId: '7401051',
    name: 'Rejo Sari',
  },
  {
    id: '7401052001',
    districtId: '7401052',
    name: 'Walompo',
  },
  {
    id: '7401052002',
    districtId: '7401052',
    name: 'Matanauwe',
  },
  {
    id: '7401052003',
    districtId: '7401052',
    name: 'Sampuabalo',
  },
  {
    id: '7401052004',
    districtId: '7401052',
    name: 'Kuraa',
  },
  {
    id: '7401052005',
    districtId: '7401052',
    name: 'Kumbewaha',
  },
  {
    id: '7401052006',
    districtId: '7401052',
    name: 'Sumber Sari',
  },
  {
    id: '7401052007',
    districtId: '7401052',
    name: 'Labuandiri',
  },
  {
    id: '7401052008',
    districtId: '7401052',
    name: 'Karya',
  },
  {
    id: '7401052009',
    districtId: '7401052',
    name: 'Manuru',
  },
  {
    id: '7401052010',
    districtId: '7401052',
    name: 'Bahari Makmur',
  },
  {
    id: '7401052011',
    districtId: '7401052',
    name: 'Gunung Jaya',
  },
  {
    id: '7401060006',
    districtId: '7401060',
    name: 'Kondowa',
  },
  {
    id: '7401060007',
    districtId: '7401060',
    name: 'Dongkala',
  },
  {
    id: '7401060008',
    districtId: '7401060',
    name: 'Holimombo',
  },
  {
    id: '7401060009',
    districtId: '7401060',
    name: 'Takimpo',
  },
  {
    id: '7401060010',
    districtId: '7401060',
    name: 'Kombeli',
  },
  {
    id: '7401060011',
    districtId: '7401060',
    name: 'Awainulu',
  },
  {
    id: '7401060012',
    districtId: '7401060',
    name: 'Laburunci',
  },
  {
    id: '7401060013',
    districtId: '7401060',
    name: 'Banabungi',
  },
  {
    id: '7401060014',
    districtId: '7401060',
    name: 'Kambula Mbulana',
  },
  {
    id: '7401060015',
    districtId: '7401060',
    name: 'Pasar Wajo',
  },
  {
    id: '7401060016',
    districtId: '7401060',
    name: 'Saragi',
  },
  {
    id: '7401060017',
    districtId: '7401060',
    name: 'Kaongkeokea',
  },
  {
    id: '7401060018',
    districtId: '7401060',
    name: 'Waangu-Angu',
  },
  {
    id: '7401060019',
    districtId: '7401060',
    name: 'Warinta',
  },
  {
    id: '7401060020',
    districtId: '7401060',
    name: 'Lapodi',
  },
  {
    id: '7401060021',
    districtId: '7401060',
    name: 'Wakoko',
  },
  {
    id: '7401060022',
    districtId: '7401060',
    name: 'Wasaga',
  },
  {
    id: '7401060023',
    districtId: '7401060',
    name: 'Kancinaa',
  },
  {
    id: '7401060024',
    districtId: '7401060',
    name: 'Winning',
  },
  {
    id: '7401060029',
    districtId: '7401060',
    name: 'Holimombo Jaya',
  },
  {
    id: '7401060030',
    districtId: '7401060',
    name: 'Kabawokole',
  },
  {
    id: '7401060031',
    districtId: '7401060',
    name: 'Mantowu',
  },
  {
    id: '7401061025',
    districtId: '7401061',
    name: 'Kaumbu',
  },
  {
    id: '7401061026',
    districtId: '7401061',
    name: 'Wolowa',
  },
  {
    id: '7401061027',
    districtId: '7401061',
    name: 'Matawia',
  },
  {
    id: '7401061028',
    districtId: '7401061',
    name: 'Wolowa Baru',
  },
  {
    id: '7401061029',
    districtId: '7401061',
    name: 'Sukamaju',
  },
  {
    id: '7401061030',
    districtId: '7401061',
    name: 'Galanti',
  },
  {
    id: '7401061031',
    districtId: '7401061',
    name: 'Bungi',
  },
  {
    id: '7401062001',
    districtId: '7401062',
    name: 'Wasuemba',
  },
  {
    id: '7401062002',
    districtId: '7401062',
    name: 'Wabula',
  },
  {
    id: '7401062003',
    districtId: '7401062',
    name: 'Wasampela',
  },
  {
    id: '7401062004',
    districtId: '7401062',
    name: 'Holimombo',
  },
  {
    id: '7401062005',
    districtId: '7401062',
    name: 'Koholimombona',
  },
  {
    id: '7401062006',
    districtId: '7401062',
    name: 'Wabula 1',
  },
  {
    id: '7401062007',
    districtId: '7401062',
    name: 'Bajo Bahari',
  },
  {
    id: '7401110001',
    districtId: '7401110',
    name: 'Barangka',
  },
  {
    id: '7401110002',
    districtId: '7401110',
    name: 'Wakalambe',
  },
  {
    id: '7401110003',
    districtId: '7401110',
    name: 'Boneatiro',
  },
  {
    id: '7401110004',
    districtId: '7401110',
    name: 'Lambusango',
  },
  {
    id: '7401110005',
    districtId: '7401110',
    name: 'Watumotobe',
  },
  {
    id: '7401110006',
    districtId: '7401110',
    name: 'Waondo Wolio',
  },
  {
    id: '7401110007',
    districtId: '7401110',
    name: 'Wakangka',
  },
  {
    id: '7401110008',
    districtId: '7401110',
    name: 'Tuangila',
  },
  {
    id: '7401110009',
    districtId: '7401110',
    name: 'Bukit Asri',
  },
  {
    id: '7401110010',
    districtId: '7401110',
    name: 'Todanga',
  },
  {
    id: '7401110011',
    districtId: '7401110',
    name: 'Lambusango Timur',
  },
  {
    id: '7401110012',
    districtId: '7401110',
    name: 'Kamelanta',
  },
  {
    id: '7401110013',
    districtId: '7401110',
    name: 'Mabulugo',
  },
  {
    id: '7401110014',
    districtId: '7401110',
    name: 'Wambulu',
  },
  {
    id: '7401110015',
    districtId: '7401110',
    name: 'Wakuli',
  },
  {
    id: '7401110016',
    districtId: '7401110',
    name: 'Tumada',
  },
  {
    id: '7401110017',
    districtId: '7401110',
    name: 'Boneatiro Barat',
  },
  {
    id: '7402010006',
    districtId: '7402010',
    name: 'Oeno Kandoli',
  },
  {
    id: '7402010007',
    districtId: '7402010',
    name: 'Matano Oe',
  },
  {
    id: '7402010008',
    districtId: '7402010',
    name: 'Walengkabhola',
  },
  {
    id: '7402010011',
    districtId: '7402010',
    name: 'Lamorende',
  },
  {
    id: '7402010012',
    districtId: '7402010',
    name: 'Laano Sandana',
  },
  {
    id: '7402010013',
    districtId: '7402010',
    name: 'Fongkaniwa',
  },
  {
    id: '7402010014',
    districtId: '7402010',
    name: 'Tombula',
  },
  {
    id: '7402010015',
    districtId: '7402010',
    name: 'Danagoa',
  },
  {
    id: '7402010016',
    districtId: '7402010',
    name: 'Laghontoghe',
  },
  {
    id: '7402010017',
    districtId: '7402010',
    name: 'Kontumolepe',
  },
  {
    id: '7402010018',
    districtId: '7402010',
    name: 'Lakologou',
  },
  {
    id: '7402010019',
    districtId: '7402010',
    name: 'Up. Wuna',
  },
  {
    id: '7402010020',
    districtId: '7402010',
    name: 'Laloya',
  },
  {
    id: '7402010021',
    districtId: '7402010',
    name: 'Tongkuno',
  },
  {
    id: '7402011001',
    districtId: '7402011',
    name: 'Kulidawa',
  },
  {
    id: '7402011002',
    districtId: '7402011',
    name: 'Waale-Ale',
  },
  {
    id: '7402011003',
    districtId: '7402011',
    name: 'Labasa',
  },
  {
    id: '7402011004',
    districtId: '7402011',
    name: 'Katumpu',
  },
  {
    id: '7402011005',
    districtId: '7402011',
    name: 'Oe Waungka',
  },
  {
    id: '7402011006',
    districtId: '7402011',
    name: 'Lianosa',
  },
  {
    id: '7402011007',
    districtId: '7402011',
    name: 'Labasa Selatan',
  },
  {
    id: '7402011008',
    districtId: '7402011',
    name: 'Waale-Ale Barat',
  },
  {
    id: '7402020010',
    districtId: '7402020',
    name: 'Warambe',
  },
  {
    id: '7402020011',
    districtId: '7402020',
    name: 'Walambeno Wite',
  },
  {
    id: '7402020012',
    districtId: '7402020',
    name: 'Wakumoro',
  },
  {
    id: '7402020013',
    districtId: '7402020',
    name: 'Kosundano',
  },
  {
    id: '7402020014',
    districtId: '7402020',
    name: 'Kolasa',
  },
  {
    id: '7402020015',
    districtId: '7402020',
    name: 'Parigi',
  },
  {
    id: '7402020016',
    districtId: '7402020',
    name: 'Wasolangka',
  },
  {
    id: '7402020017',
    districtId: '7402020',
    name: 'Wapuale',
  },
  {
    id: '7402020018',
    districtId: '7402020',
    name: 'Labulu-Bulu',
  },
  {
    id: '7402020019',
    districtId: '7402020',
    name: 'Latampu',
  },
  {
    id: '7402020020',
    districtId: '7402020',
    name: 'Laiba',
  },
  {
    id: '7402020021',
    districtId: '7402020',
    name: 'Katapi',
  },
  {
    id: '7402020022',
    districtId: '7402020',
    name: 'Latongku',
  },
  {
    id: '7402020023',
    districtId: '7402020',
    name: 'Labalia',
  },
  {
    id: '7402020024',
    districtId: '7402020',
    name: 'Latandi Wuna',
  },
  {
    id: '7402021006',
    districtId: '7402021',
    name: 'Bone Tondo',
  },
  {
    id: '7402021007',
    districtId: '7402021',
    name: 'Bone Lolibu',
  },
  {
    id: '7402021008',
    districtId: '7402021',
    name: 'Bhone Kainsetala',
  },
  {
    id: '7402021011',
    districtId: '7402021',
    name: 'Matombura',
  },
  {
    id: '7402021012',
    districtId: '7402021',
    name: 'Oelongko',
  },
  {
    id: '7402021013',
    districtId: '7402021',
    name: 'Matombura Kanini',
  },
  {
    id: '7402021014',
    districtId: '7402021',
    name: 'Oengkalogha',
  },
  {
    id: '7402022001',
    districtId: '7402022',
    name: 'Pasikuta',
  },
  {
    id: '7402022002',
    districtId: '7402022',
    name: 'Tapi-Tapi',
  },
  {
    id: '7402022003',
    districtId: '7402022',
    name: 'Marobo',
  },
  {
    id: '7402022004',
    districtId: '7402022',
    name: 'Wadolao',
  },
  {
    id: '7402022005',
    districtId: '7402022',
    name: 'Poaroha',
  },
  {
    id: '7402022006',
    districtId: '7402022',
    name: 'Toroh Bunging',
  },
  {
    id: '7402022007',
    districtId: '7402022',
    name: 'Kasasino Sara',
  },
  {
    id: '7402030001',
    districtId: '7402030',
    name: 'Kawite Wite',
  },
  {
    id: '7402030002',
    districtId: '7402030',
    name: 'Lamanu',
  },
  {
    id: '7402030003',
    districtId: '7402030',
    name: 'Wantiworo',
  },
  {
    id: '7402030004',
    districtId: '7402030',
    name: 'Kasaka',
  },
  {
    id: '7402030005',
    districtId: '7402030',
    name: 'Lamaeo',
  },
  {
    id: '7402030006',
    districtId: '7402030',
    name: 'Kontumere',
  },
  {
    id: '7402030007',
    districtId: '7402030',
    name: 'Kambawuna',
  },
  {
    id: '7402030008',
    districtId: '7402030',
    name: 'Laimpi',
  },
  {
    id: '7402030010',
    districtId: '7402030',
    name: 'R A N G K A',
  },
  {
    id: '7402030019',
    districtId: '7402030',
    name: 'Bea',
  },
  {
    id: '7402030020',
    districtId: '7402030',
    name: 'Sukamaju',
  },
  {
    id: '7402031001',
    districtId: '7402031',
    name: 'Komba-Komba',
  },
  {
    id: '7402031002',
    districtId: '7402031',
    name: 'Oensuli',
  },
  {
    id: '7402031003',
    districtId: '7402031',
    name: 'Kabangka',
  },
  {
    id: '7402031004',
    districtId: '7402031',
    name: 'Sarimulyo',
  },
  {
    id: '7402031005',
    districtId: '7402031',
    name: 'Wakobalu Agung',
  },
  {
    id: '7402031006',
    districtId: '7402031',
    name: 'Wansugi',
  },
  {
    id: '7402031007',
    districtId: '7402031',
    name: 'Wataliku',
  },
  {
    id: '7402031008',
    districtId: '7402031',
    name: 'Lakandito',
  },
  {
    id: '7402031009',
    districtId: '7402031',
    name: 'Lupia',
  },
  {
    id: '7402031010',
    districtId: '7402031',
    name: 'Lapili Bangka',
  },
  {
    id: '7402032001',
    districtId: '7402032',
    name: 'Laghorio',
  },
  {
    id: '7402032002',
    districtId: '7402032',
    name: 'Kafoo-Foo',
  },
  {
    id: '7402032003',
    districtId: '7402032',
    name: 'Kontukowuna',
  },
  {
    id: '7402032004',
    districtId: '7402032',
    name: 'Bahutara',
  },
  {
    id: '7402032005',
    districtId: '7402032',
    name: 'Kilambibito',
  },
  {
    id: '7402032006',
    districtId: '7402032',
    name: 'Karoo',
  },
  {
    id: '7402061001',
    districtId: '7402061',
    name: 'Liabalano',
  },
  {
    id: '7402061002',
    districtId: '7402061',
    name: 'Kontunaga',
  },
  {
    id: '7402061003',
    districtId: '7402061',
    name: 'Maabhodo',
  },
  {
    id: '7402061004',
    districtId: '7402061',
    name: 'Masalili',
  },
  {
    id: '7402061005',
    districtId: '7402061',
    name: 'Bungi',
  },
  {
    id: '7402061010',
    districtId: '7402061',
    name: 'Lapodidi',
  },
  {
    id: '7402061011',
    districtId: '7402061',
    name: 'Saungkaghito',
  },
  {
    id: '7402062001',
    districtId: '7402062',
    name: 'Labaha',
  },
  {
    id: '7402062002',
    districtId: '7402062',
    name: 'Watopute',
  },
  {
    id: '7402062003',
    districtId: '7402062',
    name: 'Bangkali',
  },
  {
    id: '7402062004',
    districtId: '7402062',
    name: 'Bhangkali Barat',
  },
  {
    id: '7402062005',
    districtId: '7402062',
    name: 'Dana',
  },
  {
    id: '7402062006',
    districtId: '7402062',
    name: 'Lakapodo',
  },
  {
    id: '7402062007',
    districtId: '7402062',
    name: 'Wakadia',
  },
  {
    id: '7402062008',
    districtId: '7402062',
    name: 'Matarawa',
  },
  {
    id: '7402062009',
    districtId: '7402062',
    name: 'Wali',
  },
  {
    id: '7402062010',
    districtId: '7402062',
    name: 'Dana Timur',
  },
  {
    id: '7402062011',
    districtId: '7402062',
    name: 'Wakadia Barat',
  },
  {
    id: '7402070018',
    districtId: '7402070',
    name: 'Raha I',
  },
  {
    id: '7402070019',
    districtId: '7402070',
    name: 'Laende',
  },
  {
    id: '7402070020',
    districtId: '7402070',
    name: 'Foo Kuni',
  },
  {
    id: '7402070021',
    districtId: '7402070',
    name: 'Watonea',
  },
  {
    id: '7402070022',
    districtId: '7402070',
    name: 'Raha  II',
  },
  {
    id: '7402070024',
    districtId: '7402070',
    name: 'Wamponiki',
  },
  {
    id: '7402070025',
    districtId: '7402070',
    name: 'Raha III',
  },
  {
    id: '7402071001',
    districtId: '7402071',
    name: 'Liangkobori',
  },
  {
    id: '7402071002',
    districtId: '7402071',
    name: 'Maabholu',
  },
  {
    id: '7402071003',
    districtId: '7402071',
    name: 'Kondongia',
  },
  {
    id: '7402071004',
    districtId: '7402071',
    name: 'Waara',
  },
  {
    id: '7402071005',
    districtId: '7402071',
    name: 'Mantobua',
  },
  {
    id: '7402071006',
    districtId: '7402071',
    name: 'Korihi',
  },
  {
    id: '7402071007',
    districtId: '7402071',
    name: 'Lakarinta',
  },
  {
    id: '7402071008',
    districtId: '7402071',
    name: 'Lohia',
  },
  {
    id: '7402071009',
    districtId: '7402071',
    name: 'Loghiya',
  },
  {
    id: '7402071010',
    districtId: '7402071',
    name: 'Lawela',
  },
  {
    id: '7402071011',
    districtId: '7402071',
    name: 'Kondongia Barat',
  },
  {
    id: '7402071012',
    districtId: '7402071',
    name: 'Mantobua Barat',
  },
  {
    id: '7402072001',
    districtId: '7402072',
    name: 'Banggai',
  },
  {
    id: '7402072002',
    districtId: '7402072',
    name: 'Lasunapa',
  },
  {
    id: '7402072003',
    districtId: '7402072',
    name: 'Ghonsume',
  },
  {
    id: '7402072004',
    districtId: '7402072',
    name: 'Wapunto',
  },
  {
    id: '7402072005',
    districtId: '7402072',
    name: 'Ghone Bhalano',
  },
  {
    id: '7402072006',
    districtId: '7402072',
    name: 'Lagasa',
  },
  {
    id: '7402072007',
    districtId: '7402072',
    name: 'Palangga',
  },
  {
    id: '7402072008',
    districtId: '7402072',
    name: 'Longkida',
  },
  {
    id: '7402072009',
    districtId: '7402072',
    name: 'Wabahara',
  },
  {
    id: '7402073001',
    districtId: '7402073',
    name: 'Wawesa',
  },
  {
    id: '7402073002',
    districtId: '7402073',
    name: 'Laiworu',
  },
  {
    id: '7402073003',
    districtId: '7402073',
    name: 'Wakorambu',
  },
  {
    id: '7402073004',
    districtId: '7402073',
    name: 'Sidodadi',
  },
  {
    id: '7402080008',
    districtId: '7402080',
    name: 'Lambiku',
  },
  {
    id: '7402080009',
    districtId: '7402080',
    name: 'Pentiro',
  },
  {
    id: '7402080010',
    districtId: '7402080',
    name: 'Napabalano',
  },
  {
    id: '7402080011',
    districtId: '7402080',
    name: 'Tampo',
  },
  {
    id: '7402080012',
    districtId: '7402080',
    name: 'Napalakura',
  },
  {
    id: '7402080013',
    districtId: '7402080',
    name: 'Langkumapo',
  },
  {
    id: '7402080014',
    districtId: '7402080',
    name: 'Mekar Sama',
  },
  {
    id: '7402081001',
    districtId: '7402081',
    name: 'Bangun Sari',
  },
  {
    id: '7402081002',
    districtId: '7402081',
    name: 'Lasalepa',
  },
  {
    id: '7402081003',
    districtId: '7402081',
    name: 'Parida',
  },
  {
    id: '7402081004',
    districtId: '7402081',
    name: 'Labunti',
  },
  {
    id: '7402081005',
    districtId: '7402081',
    name: 'Bonea',
  },
  {
    id: '7402081006',
    districtId: '7402081',
    name: 'Labone',
  },
  {
    id: '7402081007',
    districtId: '7402081',
    name: 'Kombungo',
  },
  {
    id: '7402081008',
    districtId: '7402081',
    name: 'Roda',
  },
  {
    id: '7402083001',
    districtId: '7402083',
    name: 'Renda',
  },
  {
    id: '7402083002',
    districtId: '7402083',
    name: 'Bhontu-Bhontu',
  },
  {
    id: '7402083003',
    districtId: '7402083',
    name: 'M O A S I',
  },
  {
    id: '7402083004',
    districtId: '7402083',
    name: 'Lakarama',
  },
  {
    id: '7402083005',
    districtId: '7402083',
    name: 'Wangkolabu',
  },
  {
    id: '7402083006',
    districtId: '7402083',
    name: 'Bontu-Bontu Barat',
  },
  {
    id: '7402083007',
    districtId: '7402083',
    name: 'Tanjung Harapan',
  },
  {
    id: '7402083008',
    districtId: '7402083',
    name: 'Tangkalalo',
  },
  {
    id: '7402090009',
    districtId: '7402090',
    name: 'Wakorumba',
  },
  {
    id: '7402090011',
    districtId: '7402090',
    name: 'Bhakealu',
  },
  {
    id: '7402090012',
    districtId: '7402090',
    name: 'Labunia(Pure)',
  },
  {
    id: '7402090013',
    districtId: '7402090',
    name: 'Wambona',
  },
  {
    id: '7402090015',
    districtId: '7402090',
    name: 'Wandiri',
  },
  {
    id: '7402090016',
    districtId: '7402090',
    name: 'Tolaku',
  },
  {
    id: '7402091001',
    districtId: '7402091',
    name: 'Liwumetingki',
  },
  {
    id: '7402091002',
    districtId: '7402091',
    name: 'Kamosope',
  },
  {
    id: '7402091007',
    districtId: '7402091',
    name: 'Pola',
  },
  {
    id: '7402091008',
    districtId: '7402091',
    name: 'Kogholifano',
  },
  {
    id: '7402091009',
    districtId: '7402091',
    name: 'Labulawa',
  },
  {
    id: '7402091011',
    districtId: '7402091',
    name: 'Wangguali',
  },
  {
    id: '7402092001',
    districtId: '7402092',
    name: 'Kolese',
  },
  {
    id: '7402092002',
    districtId: '7402092',
    name: 'Mata Indaha',
  },
  {
    id: '7402092003',
    districtId: '7402092',
    name: 'Lambelu',
  },
  {
    id: '7402092004',
    districtId: '7402092',
    name: 'Tampunabale',
  },
  {
    id: '7402092005',
    districtId: '7402092',
    name: 'Maatampe',
  },
  {
    id: '7402092006',
    districtId: '7402092',
    name: 'Lantogalalo',
  },
  {
    id: '7402111004',
    districtId: '7402111',
    name: 'Pohorua',
  },
  {
    id: '7402111005',
    districtId: '7402111',
    name: 'Lapole',
  },
  {
    id: '7402111006',
    districtId: '7402111',
    name: 'Maligano',
  },
  {
    id: '7402111007',
    districtId: '7402111',
    name: 'Raimuna',
  },
  {
    id: '7402111008',
    districtId: '7402111',
    name: 'Latompa',
  },
  {
    id: '7402111009',
    districtId: '7402111',
    name: 'Langkoroni',
  },
  {
    id: '7402111010',
    districtId: '7402111',
    name: 'UPT Langkoroni',
  },
  {
    id: '7402112001',
    districtId: '7402112',
    name: 'Baluara',
  },
  {
    id: '7402112002',
    districtId: '7402112',
    name: 'Moolo',
  },
  {
    id: '7402112003',
    districtId: '7402112',
    name: 'Lanobake',
  },
  {
    id: '7402112004',
    districtId: '7402112',
    name: 'Bone-Bone',
  },
  {
    id: '7402112005',
    districtId: '7402112',
    name: 'Tangkeno',
  },
  {
    id: '7403090010',
    districtId: '7403090',
    name: 'Waworaha',
  },
  {
    id: '7403090011',
    districtId: '7403090',
    name: 'Soropia',
  },
  {
    id: '7403090012',
    districtId: '7403090',
    name: 'Sawapudo',
  },
  {
    id: '7403090013',
    districtId: '7403090',
    name: 'Atowatu',
  },
  {
    id: '7403090014',
    districtId: '7403090',
    name: 'Toronipa',
  },
  {
    id: '7403090015',
    districtId: '7403090',
    name: 'Bokori',
  },
  {
    id: '7403090016',
    districtId: '7403090',
    name: 'Mekar',
  },
  {
    id: '7403090017',
    districtId: '7403090',
    name: 'Bajo Indah',
  },
  {
    id: '7403090018',
    districtId: '7403090',
    name: 'Tapulaga',
  },
  {
    id: '7403090019',
    districtId: '7403090',
    name: 'Sorue Jaya',
  },
  {
    id: '7403090020',
    districtId: '7403090',
    name: 'Saponda',
  },
  {
    id: '7403090023',
    districtId: '7403090',
    name: 'Telaga Biru',
  },
  {
    id: '7403090024',
    districtId: '7403090',
    name: 'Bajoe',
  },
  {
    id: '7403090026',
    districtId: '7403090',
    name: 'Saponda Laut',
  },
  {
    id: '7403091001',
    districtId: '7403091',
    name: 'Batu Gong',
  },
  {
    id: '7403091002',
    districtId: '7403091',
    name: 'Watunggarandu',
  },
  {
    id: '7403091003',
    districtId: '7403091',
    name: 'Toola  Wawo',
  },
  {
    id: '7403091004',
    districtId: '7403091',
    name: 'Lalonggasumeeto',
  },
  {
    id: '7403091005',
    districtId: '7403091',
    name: 'Bumi Indah',
  },
  {
    id: '7403091006',
    districtId: '7403091',
    name: 'Puuwonua',
  },
  {
    id: '7403091007',
    districtId: '7403091',
    name: 'Lalomboda',
  },
  {
    id: '7403091008',
    districtId: '7403091',
    name: 'Rapambinopaka',
  },
  {
    id: '7403091009',
    districtId: '7403091',
    name: 'Nii Tanasa',
  },
  {
    id: '7403091010',
    districtId: '7403091',
    name: 'Toli-Toli',
  },
  {
    id: '7403091011',
    districtId: '7403091',
    name: 'Wawobungi',
  },
  {
    id: '7403100010',
    districtId: '7403100',
    name: 'Baini',
  },
  {
    id: '7403100011',
    districtId: '7403100',
    name: 'Konggamea',
  },
  {
    id: '7403100012',
    districtId: '7403100',
    name: 'Pohara',
  },
  {
    id: '7403100013',
    districtId: '7403100',
    name: 'Andepali',
  },
  {
    id: '7403100014',
    districtId: '7403100',
    name: 'Wawolimbue',
  },
  {
    id: '7403100015',
    districtId: '7403100',
    name: 'Sampara',
  },
  {
    id: '7403100016',
    districtId: '7403100',
    name: 'Andadowi',
  },
  {
    id: '7403100017',
    districtId: '7403100',
    name: 'Polua',
  },
  {
    id: '7403100018',
    districtId: '7403100',
    name: 'Rawua',
  },
  {
    id: '7403100019',
    districtId: '7403100',
    name: 'Bao-Bao',
  },
  {
    id: '7403100020',
    districtId: '7403100',
    name: 'P U U L O R O',
  },
  {
    id: '7403100021',
    districtId: '7403100',
    name: 'Bondoala',
  },
  {
    id: '7403100022',
    districtId: '7403100',
    name: 'Andaroa',
  },
  {
    id: '7403100023',
    districtId: '7403100',
    name: 'Totombe Jaya',
  },
  {
    id: '7403101010',
    districtId: '7403101',
    name: 'Pebunooha Dalam',
  },
  {
    id: '7403101011',
    districtId: '7403101',
    name: 'Pebunooha',
  },
  {
    id: '7403101012',
    districtId: '7403101',
    name: 'Rumbia',
  },
  {
    id: '7403101013',
    districtId: '7403101',
    name: 'Diolo',
  },
  {
    id: '7403101014',
    districtId: '7403101',
    name: 'L A O S U',
  },
  {
    id: '7403101015',
    districtId: '7403101',
    name: 'Lalonggaluku',
  },
  {
    id: '7403101026',
    districtId: '7403101',
    name: 'Rambu Kongga',
  },
  {
    id: '7403101027',
    districtId: '7403101',
    name: 'Laosu Jaya',
  },
  {
    id: '7403101028',
    districtId: '7403101',
    name: 'Lalonggaluku Timur',
  },
  {
    id: '7403102001',
    districtId: '7403102',
    name: 'Ulu Pohara',
  },
  {
    id: '7403102002',
    districtId: '7403102',
    name: 'Amosilu',
  },
  {
    id: '7403102003',
    districtId: '7403102',
    name: 'Ranomolua',
  },
  {
    id: '7403102004',
    districtId: '7403102',
    name: 'Lawonua',
  },
  {
    id: '7403102005',
    districtId: '7403102',
    name: 'Asunde',
  },
  {
    id: '7403102006',
    districtId: '7403102',
    name: 'Andomesinggo',
  },
  {
    id: '7403102008',
    districtId: '7403102',
    name: 'Onembute',
  },
  {
    id: '7403102009',
    districtId: '7403102',
    name: 'Labela',
  },
  {
    id: '7403102010',
    districtId: '7403102',
    name: 'Silea',
  },
  {
    id: '7403102011',
    districtId: '7403102',
    name: 'Laloumera',
  },
  {
    id: '7403102012',
    districtId: '7403102',
    name: 'Puulowaru',
  },
  {
    id: '7403102013',
    districtId: '7403102',
    name: 'Puundoho',
  },
  {
    id: '7403102014',
    districtId: '7403102',
    name: 'Puunggaluku',
  },
  {
    id: '7403102015',
    districtId: '7403102',
    name: 'Waworaha',
  },
  {
    id: '7403102016',
    districtId: '7403102',
    name: 'Watumolomba',
  },
  {
    id: '7403103001',
    districtId: '7403103',
    name: 'Lamendora',
  },
  {
    id: '7403103002',
    districtId: '7403103',
    name: 'Kapoi Ala',
  },
  {
    id: '7403103003',
    districtId: '7403103',
    name: 'Sambaraasi',
  },
  {
    id: '7403103004',
    districtId: '7403103',
    name: 'Labotoy',
  },
  {
    id: '7403103005',
    districtId: '7403103',
    name: 'Pereoa',
  },
  {
    id: '7403103006',
    districtId: '7403103',
    name: 'Lalimbue',
  },
  {
    id: '7403103007',
    districtId: '7403103',
    name: 'Muara Sampara',
  },
  {
    id: '7403103008',
    districtId: '7403103',
    name: 'Ulu Lalimbue',
  },
  {
    id: '7403103009',
    districtId: '7403103',
    name: 'Lalimbue Jaya',
  },
  {
    id: '7403103010',
    districtId: '7403103',
    name: 'Tani Indah',
  },
  {
    id: '7403103011',
    districtId: '7403103',
    name: 'Tombawatu',
  },
  {
    id: '7403103012',
    districtId: '7403103',
    name: 'Kapoiala Baru',
  },
  {
    id: '7403103013',
    districtId: '7403103',
    name: 'Labotoy Jaya',
  },
  {
    id: '7403103014',
    districtId: '7403103',
    name: 'Lalonggomuno',
  },
  {
    id: '7403103015',
    districtId: '7403103',
    name: 'Labota',
  },
  {
    id: '7403104001',
    districtId: '7403104',
    name: 'Anggalomoare Jaya',
  },
  {
    id: '7403104002',
    districtId: '7403104',
    name: 'Anggalomoare',
  },
  {
    id: '7403104003',
    districtId: '7403104',
    name: 'Lasoso',
  },
  {
    id: '7403104004',
    districtId: '7403104',
    name: 'Lakomea',
  },
  {
    id: '7403104005',
    districtId: '7403104',
    name: 'Abelisawah',
  },
  {
    id: '7403104006',
    districtId: '7403104',
    name: 'Puusawah',
  },
  {
    id: '7403104007',
    districtId: '7403104',
    name: 'Andobeu Jaya',
  },
  {
    id: '7403104008',
    districtId: '7403104',
    name: 'Galu',
  },
  {
    id: '7403104009',
    districtId: '7403104',
    name: 'Puusangi',
  },
  {
    id: '7403104010',
    districtId: '7403104',
    name: 'Tabanggele',
  },
  {
    id: '7403105001',
    districtId: '7403105',
    name: 'Mendikonu',
  },
  {
    id: '7403105002',
    districtId: '7403105',
    name: 'Wonua Morini',
  },
  {
    id: '7403105004',
    districtId: '7403105',
    name: 'P A K U',
  },
  {
    id: '7403105006',
    districtId: '7403105',
    name: 'Morosi',
  },
  {
    id: '7403105007',
    districtId: '7403105',
    name: 'Porara',
  },
  {
    id: '7403105008',
    districtId: '7403105',
    name: 'Tanggobu',
  },
  {
    id: '7403105009',
    districtId: '7403105',
    name: 'Paku Jaya',
  },
  {
    id: '7403105010',
    districtId: '7403105',
    name: 'Tondowatu',
  },
  {
    id: '7403130045',
    districtId: '7403130',
    name: 'Tanggobu',
  },
  {
    id: '7403130046',
    districtId: '7403130',
    name: 'Meraka',
  },
  {
    id: '7403130047',
    districtId: '7403130',
    name: 'Waworaha',
  },
  {
    id: '7403130048',
    districtId: '7403130',
    name: 'Awuliti',
  },
  {
    id: '7403130049',
    districtId: '7403130',
    name: 'Amberi',
  },
  {
    id: '7403130055',
    districtId: '7403130',
    name: 'Lambuya',
  },
  {
    id: '7403130056',
    districtId: '7403130',
    name: 'Asaki',
  },
  {
    id: '7403130059',
    districtId: '7403130',
    name: 'Watarema',
  },
  {
    id: '7403130060',
    districtId: '7403130',
    name: 'Wonuahoa',
  },
  {
    id: '7403130061',
    districtId: '7403130',
    name: 'Tetembomua',
  },
  {
    id: '7403131001',
    districtId: '7403131',
    name: 'Baruga',
  },
  {
    id: '7403131002',
    districtId: '7403131',
    name: 'Langgomea',
  },
  {
    id: '7403131003',
    districtId: '7403131',
    name: 'Matahoalu',
  },
  {
    id: '7403131004',
    districtId: '7403131',
    name: 'Tawarotebota',
  },
  {
    id: '7403131005',
    districtId: '7403131',
    name: 'Tawamelewe',
  },
  {
    id: '7403131006',
    districtId: '7403131',
    name: 'Uepai',
  },
  {
    id: '7403131007',
    districtId: '7403131',
    name: 'Ameroro',
  },
  {
    id: '7403131008',
    districtId: '7403131',
    name: 'Amaroa',
  },
  {
    id: '7403131009',
    districtId: '7403131',
    name: 'R A W U A',
  },
  {
    id: '7403131010',
    districtId: '7403131',
    name: 'Anggopiu',
  },
  {
    id: '7403131011',
    districtId: '7403131',
    name: 'Olo-Oloho',
  },
  {
    id: '7403131012',
    districtId: '7403131',
    name: 'Humboto',
  },
  {
    id: '7403131013',
    districtId: '7403131',
    name: 'Kasaeda',
  },
  {
    id: '7403131014',
    districtId: '7403131',
    name: 'Tanggondipo',
  },
  {
    id: '7403131015',
    districtId: '7403131',
    name: 'Tamesandi',
  },
  {
    id: '7403131016',
    districtId: '7403131',
    name: 'Moorehe',
  },
  {
    id: '7403131017',
    districtId: '7403131',
    name: 'Anggawo',
  },
  {
    id: '7403131018',
    districtId: '7403131',
    name: 'Puuroda Jaya',
  },
  {
    id: '7403131019',
    districtId: '7403131',
    name: 'Panggulawu',
  },
  {
    id: '7403132001',
    districtId: '7403132',
    name: 'Puriala',
  },
  {
    id: '7403132002',
    districtId: '7403132',
    name: 'Poanaha',
  },
  {
    id: '7403132003',
    districtId: '7403132',
    name: 'Ahuawali',
  },
  {
    id: '7403132004',
    districtId: '7403132',
    name: 'Watandehoa',
  },
  {
    id: '7403132005',
    districtId: '7403132',
    name: 'Sonai',
  },
  {
    id: '7403132006',
    districtId: '7403132',
    name: 'Watusa',
  },
  {
    id: '7403132007',
    districtId: '7403132',
    name: 'Wonua Morome',
  },
  {
    id: '7403132008',
    districtId: '7403132',
    name: 'Puusangi',
  },
  {
    id: '7403132009',
    districtId: '7403132',
    name: 'Lalonggatu',
  },
  {
    id: '7403132010',
    districtId: '7403132',
    name: 'Tetewatu',
  },
  {
    id: '7403132011',
    districtId: '7403132',
    name: 'Mokaleleo',
  },
  {
    id: '7403132012',
    districtId: '7403132',
    name: 'Unggulino',
  },
  {
    id: '7403132013',
    districtId: '7403132',
    name: 'Tetehaka',
  },
  {
    id: '7403132014',
    districtId: '7403132',
    name: 'Puuhopa',
  },
  {
    id: '7403132015',
    districtId: '7403132',
    name: 'Lalo Onaha',
  },
  {
    id: '7403132016',
    districtId: '7403132',
    name: 'Wawo Sanggula',
  },
  {
    id: '7403133001',
    districtId: '7403133',
    name: 'Trimulya',
  },
  {
    id: '7403133002',
    districtId: '7403133',
    name: 'Napoosi',
  },
  {
    id: '7403133003',
    districtId: '7403133',
    name: 'Kasumeia',
  },
  {
    id: '7403133004',
    districtId: '7403133',
    name: 'Ulu Onembute',
  },
  {
    id: '7403133005',
    districtId: '7403133',
    name: 'Onembute',
  },
  {
    id: '7403133006',
    districtId: '7403133',
    name: 'Kumapo',
  },
  {
    id: '7403133007',
    districtId: '7403133',
    name: 'Suka Maju (Ulu Meraka)',
  },
  {
    id: '7403133008',
    districtId: '7403133',
    name: 'Tawa Pandere',
  },
  {
    id: '7403133009',
    districtId: '7403133',
    name: 'Silea',
  },
  {
    id: '7403133010',
    districtId: '7403133',
    name: 'Mataiwoi',
  },
  {
    id: '7403133011',
    districtId: '7403133',
    name: 'Ana Onembute',
  },
  {
    id: '7403133012',
    districtId: '7403133',
    name: 'Anggaloosi',
  },
  {
    id: '7403140003',
    districtId: '7403140',
    name: 'Belatu',
  },
  {
    id: '7403140004',
    districtId: '7403140',
    name: 'Ahuawatu',
  },
  {
    id: '7403140005',
    districtId: '7403140',
    name: 'Ambu Ulanu',
  },
  {
    id: '7403140022',
    districtId: '7403140',
    name: 'Puumbinisi',
  },
  {
    id: '7403140023',
    districtId: '7403140',
    name: 'Hongoa',
  },
  {
    id: '7403140024',
    districtId: '7403140',
    name: 'Mumun Dowu',
  },
  {
    id: '7403140025',
    districtId: '7403140',
    name: 'Pondidaha',
  },
  {
    id: '7403140026',
    districtId: '7403140',
    name: 'Amesiu',
  },
  {
    id: '7403140027',
    districtId: '7403140',
    name: 'Wawolemo',
  },
  {
    id: '7403140028',
    districtId: '7403140',
    name: 'Tirawuta',
  },
  {
    id: '7403140029',
    districtId: '7403140',
    name: 'Laloika',
  },
  {
    id: '7403140030',
    districtId: '7403140',
    name: 'Lalonggotomi',
  },
  {
    id: '7403140031',
    districtId: '7403140',
    name: 'Sulemandara',
  },
  {
    id: '7403140032',
    districtId: '7403140',
    name: 'Lalodangge',
  },
  {
    id: '7403140033',
    districtId: '7403140',
    name: 'Wonua Mandara',
  },
  {
    id: '7403140034',
    districtId: '7403140',
    name: 'Wawolahambuti',
  },
  {
    id: '7403140035',
    districtId: '7403140',
    name: 'Lahunggumbi',
  },
  {
    id: '7403140036',
    districtId: '7403140',
    name: 'Wonua Monapa',
  },
  {
    id: '7403141001',
    districtId: '7403141',
    name: 'Dawi-Dawi',
  },
  {
    id: '7403141002',
    districtId: '7403141',
    name: 'Anggoro',
  },
  {
    id: '7403141003',
    districtId: '7403141',
    name: 'Bendewuta',
  },
  {
    id: '7403141004',
    districtId: '7403141',
    name: 'Wawosolo',
  },
  {
    id: '7403141005',
    districtId: '7403141',
    name: 'Puuduria',
  },
  {
    id: '7403141006',
    districtId: '7403141',
    name: 'Duria Asi',
  },
  {
    id: '7403141015',
    districtId: '7403141',
    name: 'Wawonggole',
  },
  {
    id: '7403141016',
    districtId: '7403141',
    name: 'Lalohao',
  },
  {
    id: '7403141017',
    districtId: '7403141',
    name: 'Wawoone',
  },
  {
    id: '7403141018',
    districtId: '7403141',
    name: 'Wukusao',
  },
  {
    id: '7403141021',
    districtId: '7403141',
    name: 'Lalousu',
  },
  {
    id: '7403141022',
    districtId: '7403141',
    name: 'Tetemotaha',
  },
  {
    id: '7403141025',
    districtId: '7403141',
    name: 'Polandangi',
  },
  {
    id: '7403141026',
    districtId: '7403141',
    name: 'Tawarolondo',
  },
  {
    id: '7403141029',
    districtId: '7403141',
    name: 'Langgonawe',
  },
  {
    id: '7403142001',
    districtId: '7403142',
    name: 'Mata Bura',
  },
  {
    id: '7403142002',
    districtId: '7403142',
    name: 'Wawohine',
  },
  {
    id: '7403142003',
    districtId: '7403142',
    name: 'Dunggua',
  },
  {
    id: '7403142004',
    districtId: '7403142',
    name: 'Benua',
  },
  {
    id: '7403142005',
    districtId: '7403142',
    name: 'Mendikonu',
  },
  {
    id: '7403142006',
    districtId: '7403142',
    name: 'Amendete',
  },
  {
    id: '7403142007',
    districtId: '7403142',
    name: 'Lalonona',
  },
  {
    id: '7403142008',
    districtId: '7403142',
    name: 'Amonggedo Baru',
  },
  {
    id: '7403142009',
    districtId: '7403142',
    name: 'Watulawu',
  },
  {
    id: '7403142010',
    districtId: '7403142',
    name: 'Anahinunu',
  },
  {
    id: '7403142011',
    districtId: '7403142',
    name: 'Puasana',
  },
  {
    id: '7403142012',
    districtId: '7403142',
    name: 'Ulu Benua',
  },
  {
    id: '7403142013',
    districtId: '7403142',
    name: 'Amonggedo',
  },
  {
    id: '7403142014',
    districtId: '7403142',
    name: 'Mataiwoi',
  },
  {
    id: '7403142015',
    districtId: '7403142',
    name: 'Lalombonda',
  },
  {
    id: '7403143001',
    districtId: '7403143',
    name: 'Linonggasai',
  },
  {
    id: '7403143002',
    districtId: '7403143',
    name: 'Teteona',
  },
  {
    id: '7403143003',
    districtId: '7403143',
    name: 'Ambuwiu',
  },
  {
    id: '7403143004',
    districtId: '7403143',
    name: 'Tobimeita',
  },
  {
    id: '7403143005',
    districtId: '7403143',
    name: 'Baruga',
  },
  {
    id: '7403143006',
    districtId: '7403143',
    name: 'Angadola',
  },
  {
    id: '7403143007',
    districtId: '7403143',
    name: 'Puday',
  },
  {
    id: '7403143008',
    districtId: '7403143',
    name: 'Lambangi',
  },
  {
    id: '7403143009',
    districtId: '7403143',
    name: 'Lahututu',
  },
  {
    id: '7403143010',
    districtId: '7403143',
    name: 'Lamokuni',
  },
  {
    id: '7403143011',
    districtId: '7403143',
    name: 'Ranotundobu',
  },
  {
    id: '7403143012',
    districtId: '7403143',
    name: 'Kasukia',
  },
  {
    id: '7403143013',
    districtId: '7403143',
    name: 'Wonggeduku',
  },
  {
    id: '7403143014',
    districtId: '7403143',
    name: 'Waturai',
  },
  {
    id: '7403143015',
    districtId: '7403143',
    name: 'Tetewonua',
  },
  {
    id: '7403143016',
    districtId: '7403143',
    name: 'Puumbuta',
  },
  {
    id: '7403150004',
    districtId: '7403150',
    name: 'Puusinauwi',
  },
  {
    id: '7403150009',
    districtId: '7403150',
    name: 'Ranoeya',
  },
  {
    id: '7403150010',
    districtId: '7403150',
    name: 'Nohu Nohu',
  },
  {
    id: '7403150011',
    districtId: '7403150',
    name: 'Kasupute',
  },
  {
    id: '7403150012',
    districtId: '7403150',
    name: 'Hopa-Hopa',
  },
  {
    id: '7403150013',
    districtId: '7403150',
    name: 'Wawotobi',
  },
  {
    id: '7403150014',
    districtId: '7403150',
    name: 'Bose Bose',
  },
  {
    id: '7403150015',
    districtId: '7403150',
    name: 'Lalosabila',
  },
  {
    id: '7403150016',
    districtId: '7403150',
    name: 'Inalahi',
  },
  {
    id: '7403150017',
    districtId: '7403150',
    name: 'Inolobu',
  },
  {
    id: '7403150018',
    districtId: '7403150',
    name: 'Kulahi',
  },
  {
    id: '7403150019',
    districtId: '7403150',
    name: 'Palarahi',
  },
  {
    id: '7403150027',
    districtId: '7403150',
    name: 'Kasumewuho',
  },
  {
    id: '7403151001',
    districtId: '7403151',
    name: 'Lamelay',
  },
  {
    id: '7403151003',
    districtId: '7403151',
    name: 'Ahuhu',
  },
  {
    id: '7403151004',
    districtId: '7403151',
    name: 'Larowiu',
  },
  {
    id: '7403151005',
    districtId: '7403151',
    name: 'Woerahi',
  },
  {
    id: '7403151006',
    districtId: '7403151',
    name: 'Tudameaso',
  },
  {
    id: '7403151007',
    districtId: '7403151',
    name: 'Ahuloa',
  },
  {
    id: '7403151008',
    districtId: '7403151',
    name: 'Sambasule',
  },
  {
    id: '7403151009',
    districtId: '7403151',
    name: 'Lalopisi',
  },
  {
    id: '7403152001',
    districtId: '7403152',
    name: 'Konawe',
  },
  {
    id: '7403152002',
    districtId: '7403152',
    name: 'Tudaone',
  },
  {
    id: '7403152003',
    districtId: '7403152',
    name: 'Bungguosu',
  },
  {
    id: '7403152004',
    districtId: '7403152',
    name: 'Tawanga',
  },
  {
    id: '7403152005',
    districtId: '7403152',
    name: 'Sanggona',
  },
  {
    id: '7403152006',
    districtId: '7403152',
    name: 'Hudoa',
  },
  {
    id: '7403152007',
    districtId: '7403152',
    name: 'Uelawu',
  },
  {
    id: '7403152008',
    districtId: '7403152',
    name: 'Mokowu',
  },
  {
    id: '7403152010',
    districtId: '7403152',
    name: 'Wonua Mbae',
  },
  {
    id: '7403152011',
    districtId: '7403152',
    name: 'Asoniwowo',
  },
  {
    id: '7403152012',
    districtId: '7403152',
    name: 'Puuwonua',
  },
  {
    id: '7403153001',
    districtId: '7403153',
    name: 'Karandu',
  },
  {
    id: '7403153002',
    districtId: '7403153',
    name: 'Nario Indah',
  },
  {
    id: '7403153003',
    districtId: '7403153',
    name: 'Korumba',
  },
  {
    id: '7403153004',
    districtId: '7403153',
    name: 'Analahumbuti',
  },
  {
    id: '7403153005',
    districtId: '7403153',
    name: 'Anggotoa',
  },
  {
    id: '7403153006',
    districtId: '7403153',
    name: 'Kukuluri',
  },
  {
    id: '7403170001',
    districtId: '7403170',
    name: 'Puunaaha',
  },
  {
    id: '7403170002',
    districtId: '7403170',
    name: 'Tumpas',
  },
  {
    id: '7403170003',
    districtId: '7403170',
    name: 'Arombu',
  },
  {
    id: '7403170004',
    districtId: '7403170',
    name: 'Latoma',
  },
  {
    id: '7403170005',
    districtId: '7403170',
    name: 'Ambekairi',
  },
  {
    id: '7403170006',
    districtId: '7403170',
    name: 'Tuoy',
  },
  {
    id: '7403170007',
    districtId: '7403170',
    name: 'Asinua',
  },
  {
    id: '7403170012',
    districtId: '7403170',
    name: 'Unaaha',
  },
  {
    id: '7403170013',
    districtId: '7403170',
    name: 'Wawonggole',
  },
  {
    id: '7403170014',
    districtId: '7403170',
    name: 'Inolobunggadue',
  },
  {
    id: '7403170015',
    districtId: '7403170',
    name: 'Tobeu',
  },
  {
    id: '7403170016',
    districtId: '7403170',
    name: 'Asambu',
  },
  {
    id: '7403171001',
    districtId: '7403171',
    name: 'Lawulo',
  },
  {
    id: '7403171002',
    districtId: '7403171',
    name: 'Unaasi',
  },
  {
    id: '7403171003',
    districtId: '7403171',
    name: 'Parauna',
  },
  {
    id: '7403171004',
    districtId: '7403171',
    name: 'Anggaberi',
  },
  {
    id: '7403171005',
    districtId: '7403171',
    name: 'Andabia',
  },
  {
    id: '7403171006',
    districtId: '7403171',
    name: 'Lerehoma',
  },
  {
    id: '7403171007',
    districtId: '7403171',
    name: 'Wunduongohi',
  },
  {
    id: '7403171008',
    districtId: '7403171',
    name: 'Toriki',
  },
  {
    id: '7403180012',
    districtId: '7403180',
    name: 'Kumapo',
  },
  {
    id: '7403180013',
    districtId: '7403180',
    name: 'Walay',
  },
  {
    id: '7403180014',
    districtId: '7403180',
    name: 'Epeea',
  },
  {
    id: '7403180015',
    districtId: '7403180',
    name: 'Unaasi Jaya',
  },
  {
    id: '7403180016',
    districtId: '7403180',
    name: 'Sambeani',
  },
  {
    id: '7403180017',
    districtId: '7403180',
    name: 'Punggaluku',
  },
  {
    id: '7403180018',
    districtId: '7403180',
    name: 'Abuki',
  },
  {
    id: '7403180025',
    districtId: '7403180',
    name: 'Asolu',
  },
  {
    id: '7403180035',
    districtId: '7403180',
    name: 'Padangguni Utama',
  },
  {
    id: '7403180042',
    districtId: '7403180',
    name: 'Arubia',
  },
  {
    id: '7403180043',
    districtId: '7403180',
    name: 'Kasuwura',
  },
  {
    id: '7403180044',
    districtId: '7403180',
    name: 'Anggoro',
  },
  {
    id: '7403181001',
    districtId: '7403181',
    name: 'Ambekaeri Utama',
  },
  {
    id: '7403181002',
    districtId: '7403181',
    name: 'Latoma Jaya',
  },
  {
    id: '7403181003',
    districtId: '7403181',
    name: 'Waworaha',
  },
  {
    id: '7403181004',
    districtId: '7403181',
    name: 'Lalowata',
  },
  {
    id: '7403181005',
    districtId: '7403181',
    name: 'Andoluto',
  },
  {
    id: '7403181006',
    districtId: '7403181',
    name: 'Wowalatoma',
  },
  {
    id: '7403181007',
    districtId: '7403181',
    name: 'Amboniki',
  },
  {
    id: '7403181008',
    districtId: '7403181',
    name: 'Pinole',
  },
  {
    id: '7403181009',
    districtId: '7403181',
    name: 'Titowa',
  },
  {
    id: '7403181010',
    districtId: '7403181',
    name: 'Nesowi',
  },
  {
    id: '7403181011',
    districtId: '7403181',
    name: 'Angonga',
  },
  {
    id: '7403181012',
    districtId: '7403181',
    name: 'Ambesaua',
  },
  {
    id: '7403181013',
    districtId: '7403181',
    name: 'Watutinawu',
  },
  {
    id: '7403181014',
    districtId: '7403181',
    name: 'Puulemo',
  },
  {
    id: '7403181015',
    districtId: '7403181',
    name: 'Nesowi Utama',
  },
  {
    id: '7403181016',
    districtId: '7403181',
    name: 'Napooha',
  },
  {
    id: '7403182001',
    districtId: '7403182',
    name: 'Puosu',
  },
  {
    id: '7403182002',
    districtId: '7403182',
    name: 'Sendang Mulyasari',
  },
  {
    id: '7403182003',
    districtId: '7403182',
    name: 'Mekar Sari',
  },
  {
    id: '7403182004',
    districtId: '7403182',
    name: 'Mataiwoi',
  },
  {
    id: '7403182005',
    districtId: '7403182',
    name: 'Tongauna',
  },
  {
    id: '7403182006',
    districtId: '7403182',
    name: 'Asao',
  },
  {
    id: '7403182011',
    districtId: '7403182',
    name: 'Lalonggowuna',
  },
  {
    id: '7403182013',
    districtId: '7403182',
    name: 'Momea',
  },
  {
    id: '7403182015',
    districtId: '7403182',
    name: 'Ambepulu',
  },
  {
    id: '7403182016',
    districtId: '7403182',
    name: 'Andeposandu',
  },
  {
    id: '7403183001',
    districtId: '7403183',
    name: 'Lasada',
  },
  {
    id: '7403183002',
    districtId: '7403183',
    name: 'Awua Jaya',
  },
  {
    id: '7403183004',
    districtId: '7403183',
    name: 'Asinua Jaya',
  },
  {
    id: '7403183005',
    districtId: '7403183',
    name: 'Ambondia',
  },
  {
    id: '7403183006',
    districtId: '7403183',
    name: 'Angohi',
  },
  {
    id: '7403183007',
    districtId: '7403183',
    name: 'Awua Sari',
  },
  {
    id: '7403183008',
    districtId: '7403183',
    name: 'Asipako',
  },
  {
    id: '7403183009',
    districtId: '7403183',
    name: 'UPT Asinua Jaya',
  },
  {
    id: '7403184001',
    districtId: '7403184',
    name: 'Atodopi',
  },
  {
    id: '7403184002',
    districtId: '7403184',
    name: 'Matahori',
  },
  {
    id: '7403184003',
    districtId: '7403184',
    name: 'Sambaosu',
  },
  {
    id: '7403184004',
    districtId: '7403184',
    name: 'Matanggorai',
  },
  {
    id: '7403184005',
    districtId: '7403184',
    name: 'Alosika',
  },
  {
    id: '7403184006',
    districtId: '7403184',
    name: 'Mekar Jaya',
  },
  {
    id: '7403184007',
    districtId: '7403184',
    name: 'Langgea',
  },
  {
    id: '7403184008',
    districtId: '7403184',
    name: 'Aleuti',
  },
  {
    id: '7403184009',
    districtId: '7403184',
    name: 'Garuda',
  },
  {
    id: '7403184010',
    districtId: '7403184',
    name: 'Padangguni',
  },
  {
    id: '7403184011',
    districtId: '7403184',
    name: 'Padang Mekar',
  },
  {
    id: '7403185001',
    districtId: '7403185',
    name: 'Andalambe',
  },
  {
    id: '7403185002',
    districtId: '7403185',
    name: 'Waworoda Jaya',
  },
  {
    id: '7403185003',
    districtId: '7403185',
    name: 'Sanuanggamo',
  },
  {
    id: '7403185004',
    districtId: '7403185',
    name: 'Olo Onua',
  },
  {
    id: '7403185005',
    districtId: '7403185',
    name: 'Puudombi',
  },
  {
    id: '7403185006',
    districtId: '7403185',
    name: 'Oluaao',
  },
  {
    id: '7403185007',
    districtId: '7403185',
    name: 'Anggohu',
  },
  {
    id: '7403185008',
    districtId: '7403185',
    name: 'Ambopi',
  },
  {
    id: '7403185009',
    districtId: '7403185',
    name: 'Barowila',
  },
  {
    id: '7403185010',
    districtId: '7403185',
    name: 'Nambeaboru',
  },
  {
    id: '7403193001',
    districtId: '7403193',
    name: 'Walandawe',
  },
  {
    id: '7403193002',
    districtId: '7403193',
    name: 'Routa',
  },
  {
    id: '7403193003',
    districtId: '7403193',
    name: 'Tirawonua',
  },
  {
    id: '7403193004',
    districtId: '7403193',
    name: 'Parudongka',
  },
  {
    id: '7403193006',
    districtId: '7403193',
    name: 'Puuwiwirano',
  },
  {
    id: '7403193007',
    districtId: '7403193',
    name: 'Lalomerui',
  },
  {
    id: '7403193008',
    districtId: '7403193',
    name: 'Tanggola',
  },
  {
    id: '7404010004',
    districtId: '7404010',
    name: 'Longgosipi',
  },
  {
    id: '7404010006',
    districtId: '7404010',
    name: 'Lamunde',
  },
  {
    id: '7404010007',
    districtId: '7404010',
    name: 'Watubangga',
  },
  {
    id: '7404010008',
    districtId: '7404010',
    name: 'Tandebura',
  },
  {
    id: '7404010009',
    districtId: '7404010',
    name: 'Sumber Rejeki',
  },
  {
    id: '7404010010',
    districtId: '7404010',
    name: 'Peoho',
  },
  {
    id: '7404010011',
    districtId: '7404010',
    name: 'Kukutio',
  },
  {
    id: '7404010013',
    districtId: '7404010',
    name: 'Kastura',
  },
  {
    id: '7404010017',
    districtId: '7404010',
    name: 'Wolulu',
  },
  {
    id: '7404010018',
    districtId: '7404010',
    name: 'Mataosu',
  },
  {
    id: '7404010020',
    districtId: '7404010',
    name: 'Polenga',
  },
  {
    id: '7404010021',
    districtId: '7404010',
    name: 'Gunung Sari',
  },
  {
    id: '7404010022',
    districtId: '7404010',
    name: 'Ranoteta',
  },
  {
    id: '7404010023',
    districtId: '7404010',
    name: 'Mataosu Ujung',
  },
  {
    id: '7404011001',
    districtId: '7404011',
    name: 'Tondowolio',
  },
  {
    id: '7404011002',
    districtId: '7404011',
    name: 'Popalia',
  },
  {
    id: '7404011003',
    districtId: '7404011',
    name: 'Anaiwoi',
  },
  {
    id: '7404011004',
    districtId: '7404011',
    name: 'Tanggetada',
  },
  {
    id: '7404011005',
    districtId: '7404011',
    name: 'Petudua',
  },
  {
    id: '7404011006',
    districtId: '7404011',
    name: 'Rahanggada',
  },
  {
    id: '7404011007',
    districtId: '7404011',
    name: 'Pewisoa Jaya',
  },
  {
    id: '7404011008',
    districtId: '7404011',
    name: 'Lalonggolosua',
  },
  {
    id: '7404011009',
    districtId: '7404011',
    name: 'Lamedai',
  },
  {
    id: '7404011010',
    districtId: '7404011',
    name: 'Palewai',
  },
  {
    id: '7404011011',
    districtId: '7404011',
    name: 'Oneeha',
  },
  {
    id: '7404011012',
    districtId: '7404011',
    name: 'Puundaipa',
  },
  {
    id: '7404011013',
    districtId: '7404011',
    name: 'Lamoiko',
  },
  {
    id: '7404011014',
    districtId: '7404011',
    name: 'Tinggo',
  },
  {
    id: '7404012001',
    districtId: '7404012',
    name: 'Toari',
  },
  {
    id: '7404012002',
    districtId: '7404012',
    name: 'Lakito',
  },
  {
    id: '7404012003',
    districtId: '7404012',
    name: 'Ranomentaa',
  },
  {
    id: '7404012004',
    districtId: '7404012',
    name: 'Wowoli',
  },
  {
    id: '7404012005',
    districtId: '7404012',
    name: 'Anawua',
  },
  {
    id: '7404012006',
    districtId: '7404012',
    name: 'Rano Jaya',
  },
  {
    id: '7404012007',
    districtId: '7404012',
    name: 'Horongkuli',
  },
  {
    id: '7404012008',
    districtId: '7404012',
    name: 'Wonua Raya',
  },
  {
    id: '7404012009',
    districtId: '7404012',
    name: 'Rahabite',
  },
  {
    id: '7404012010',
    districtId: '7404012',
    name: 'Rano Sangia',
  },
  {
    id: '7404013001',
    districtId: '7404013',
    name: 'Puudongi',
  },
  {
    id: '7404013002',
    districtId: '7404013',
    name: 'Tanggeau',
  },
  {
    id: '7404013003',
    districtId: '7404013',
    name: 'Plasma Jaya',
  },
  {
    id: '7404013004',
    districtId: '7404013',
    name: 'Polinggona',
  },
  {
    id: '7404013005',
    districtId: '7404013',
    name: 'Wulonggere',
  },
  {
    id: '7404013006',
    districtId: '7404013',
    name: 'Pondouwaee',
  },
  {
    id: '7404013007',
    districtId: '7404013',
    name: 'Lamondape',
  },
  {
    id: '7404020001',
    districtId: '7404020',
    name: 'Oko Oko',
  },
  {
    id: '7404020002',
    districtId: '7404020',
    name: 'Sopura',
  },
  {
    id: '7404020003',
    districtId: '7404020',
    name: 'Hakatutobu',
  },
  {
    id: '7404020004',
    districtId: '7404020',
    name: 'Tambea',
  },
  {
    id: '7404020005',
    districtId: '7404020',
    name: 'Pomalaa',
  },
  {
    id: '7404020006',
    districtId: '7404020',
    name: 'Kumoro',
  },
  {
    id: '7404020007',
    districtId: '7404020',
    name: 'Dawi-Dawi',
  },
  {
    id: '7404020008',
    districtId: '7404020',
    name: 'Tonggoni',
  },
  {
    id: '7404020009',
    districtId: '7404020',
    name: 'Totobo',
  },
  {
    id: '7404020010',
    districtId: '7404020',
    name: 'Pelambua',
  },
  {
    id: '7404020011',
    districtId: '7404020',
    name: 'Pesouha',
  },
  {
    id: '7404020012',
    districtId: '7404020',
    name: 'Huko Huko',
  },
  {
    id: '7404030007',
    districtId: '7404030',
    name: 'Towua I',
  },
  {
    id: '7404030011',
    districtId: '7404030',
    name: 'Ngapa',
  },
  {
    id: '7404030013',
    districtId: '7404030',
    name: 'Sabiano',
  },
  {
    id: '7404030014',
    districtId: '7404030',
    name: 'Una Mendaa',
  },
  {
    id: '7404030015',
    districtId: '7404030',
    name: 'Lamekongga',
  },
  {
    id: '7404030016',
    districtId: '7404030',
    name: 'Silea',
  },
  {
    id: '7404030017',
    districtId: '7404030',
    name: 'Kowioha',
  },
  {
    id: '7404030018',
    districtId: '7404030',
    name: 'Tikonu',
  },
  {
    id: '7404030019',
    districtId: '7404030',
    name: 'Wundulako',
  },
  {
    id: '7404030020',
    districtId: '7404030',
    name: '19 Nopember',
  },
  {
    id: '7404031001',
    districtId: '7404031',
    name: 'Longori',
  },
  {
    id: '7404031002',
    districtId: '7404031',
    name: 'Puundoho',
  },
  {
    id: '7404031003',
    districtId: '7404031',
    name: 'Puulemo',
  },
  {
    id: '7404031004',
    districtId: '7404031',
    name: 'Baula',
  },
  {
    id: '7404031005',
    districtId: '7404031',
    name: 'Puubenua',
  },
  {
    id: '7404031006',
    districtId: '7404031',
    name: 'Puubunga',
  },
  {
    id: '7404031007',
    districtId: '7404031',
    name: 'Puuroda',
  },
  {
    id: '7404031008',
    districtId: '7404031',
    name: 'Pewutaa',
  },
  {
    id: '7404031009',
    districtId: '7404031',
    name: 'Watalara',
  },
  {
    id: '7404031010',
    districtId: '7404031',
    name: 'Ulu Baula',
  },
  {
    id: '7404060008',
    districtId: '7404060',
    name: 'Watuliandu',
  },
  {
    id: '7404060009',
    districtId: '7404060',
    name: 'Lamokato',
  },
  {
    id: '7404060010',
    districtId: '7404060',
    name: 'Laloeha',
  },
  {
    id: '7404060011',
    districtId: '7404060',
    name: 'Tahoa',
  },
  {
    id: '7404060012',
    districtId: '7404060',
    name: 'Balandete',
  },
  {
    id: '7404060013',
    districtId: '7404060',
    name: 'Lalombaa',
  },
  {
    id: '7404060014',
    districtId: '7404060',
    name: 'Sabilambo',
  },
  {
    id: '7404061001',
    districtId: '7404061',
    name: 'Induha',
  },
  {
    id: '7404061002',
    districtId: '7404061',
    name: 'Ulunggolaka',
  },
  {
    id: '7404061003',
    districtId: '7404061',
    name: 'Mangolo',
  },
  {
    id: '7404061004',
    districtId: '7404061',
    name: 'Kolakaasih',
  },
  {
    id: '7404061005',
    districtId: '7404061',
    name: 'Sea',
  },
  {
    id: '7404061006',
    districtId: '7404061',
    name: 'Latambaga',
  },
  {
    id: '7404061007',
    districtId: '7404061',
    name: 'Sakuli',
  },
  {
    id: '7404070010',
    districtId: '7404070',
    name: 'Donggala',
  },
  {
    id: '7404070011',
    districtId: '7404070',
    name: 'Ulu Lapao-Pao',
  },
  {
    id: '7404070012',
    districtId: '7404070',
    name: 'Lapao-Pao',
  },
  {
    id: '7404070013',
    districtId: '7404070',
    name: 'Tolowe Ponre Waru',
  },
  {
    id: '7404070014',
    districtId: '7404070',
    name: 'Langgomali',
  },
  {
    id: '7404070015',
    districtId: '7404070',
    name: 'Ulu Wolo',
  },
  {
    id: '7404070016',
    districtId: '7404070',
    name: 'Wolo',
  },
  {
    id: '7404070017',
    districtId: '7404070',
    name: 'Lalonaha',
  },
  {
    id: '7404070018',
    districtId: '7404070',
    name: 'L A N A',
  },
  {
    id: '7404070024',
    districtId: '7404070',
    name: 'Muara Lapao Pao',
  },
  {
    id: '7404070025',
    districtId: '7404070',
    name: 'Lalonggopi',
  },
  {
    id: '7404070027',
    districtId: '7404070',
    name: 'Samaenre',
  },
  {
    id: '7404070028',
    districtId: '7404070',
    name: 'Iwoimapuro',
  },
  {
    id: '7404070029',
    districtId: '7404070',
    name: 'Ulu Rina',
  },
  {
    id: '7404071001',
    districtId: '7404071',
    name: 'Lawulo',
  },
  {
    id: '7404071002',
    districtId: '7404071',
    name: 'Sani Sani',
  },
  {
    id: '7404071003',
    districtId: '7404071',
    name: 'Kaloloa',
  },
  {
    id: '7404071004',
    districtId: '7404071',
    name: 'Konaweha',
  },
  {
    id: '7404071005',
    districtId: '7404071',
    name: 'A W A',
  },
  {
    id: '7404071006',
    districtId: '7404071',
    name: 'Lambolemo',
  },
  {
    id: '7404071007',
    districtId: '7404071',
    name: 'Tamboli',
  },
  {
    id: '7404071008',
    districtId: '7404071',
    name: 'Tosiba',
  },
  {
    id: '7404071009',
    districtId: '7404071',
    name: 'Amomutu',
  },
  {
    id: '7404071010',
    districtId: '7404071',
    name: 'Malaha',
  },
  {
    id: '7404071011',
    districtId: '7404071',
    name: 'Latuo',
  },
  {
    id: '7404071012',
    districtId: '7404071',
    name: 'Wowa Tamboli',
  },
  {
    id: '7404071013',
    districtId: '7404071',
    name: 'Tonganapo',
  },
  {
    id: '7404071014',
    districtId: '7404071',
    name: 'Ulu Konaweha',
  },
  {
    id: '7404071015',
    districtId: '7404071',
    name: 'Puutamboli',
  },
  {
    id: '7404071016',
    districtId: '7404071',
    name: 'Puu Lawulo',
  },
  {
    id: '7404071017',
    districtId: '7404071',
    name: 'Liku',
  },
  {
    id: '7404071018',
    districtId: '7404071',
    name: 'Meura',
  },
  {
    id: '7404071019',
    districtId: '7404071',
    name: 'Ulaweng',
  },
  {
    id: '7404072001',
    districtId: '7404072',
    name: 'Ulu Kalo',
  },
  {
    id: '7404072002',
    districtId: '7404072',
    name: 'Iwoimendaa',
  },
  {
    id: '7404072003',
    districtId: '7404072',
    name: 'Lasiroku',
  },
  {
    id: '7404072004',
    districtId: '7404072',
    name: 'Ladahai',
  },
  {
    id: '7404072005',
    districtId: '7404072',
    name: 'Tamborasi',
  },
  {
    id: '7404072006',
    districtId: '7404072',
    name: 'Lambopini',
  },
  {
    id: '7404072007',
    districtId: '7404072',
    name: 'Wonua Laku',
  },
  {
    id: '7404072008',
    districtId: '7404072',
    name: 'Landoula',
  },
  {
    id: '7404072009',
    districtId: '7404072',
    name: 'Watumelewe',
  },
  {
    id: '7404072010',
    districtId: '7404072',
    name: 'Lawolia',
  },
  {
    id: '7405010001',
    districtId: '7405010',
    name: 'Lanowulu',
  },
  {
    id: '7405010002',
    districtId: '7405010',
    name: 'Roraya',
  },
  {
    id: '7405010005',
    districtId: '7405010',
    name: 'Telutu Jaya',
  },
  {
    id: '7405010006',
    districtId: '7405010',
    name: 'Lapoa',
  },
  {
    id: '7405010007',
    districtId: '7405010',
    name: 'Asingi',
  },
  {
    id: '7405010008',
    districtId: '7405010',
    name: 'Ngapaaha',
  },
  {
    id: '7405010009',
    districtId: '7405010',
    name: 'Tinanggea',
  },
  {
    id: '7405010010',
    districtId: '7405010',
    name: 'Bungin Permai',
  },
  {
    id: '7405010011',
    districtId: '7405010',
    name: 'Torokeku',
  },
  {
    id: '7405010012',
    districtId: '7405010',
    name: 'Lapulu',
  },
  {
    id: '7405010013',
    districtId: '7405010',
    name: 'Wadonggo',
  },
  {
    id: '7405010014',
    districtId: '7405010',
    name: 'Watumelewe',
  },
  {
    id: '7405010015',
    districtId: '7405010',
    name: 'Moolo Indah',
  },
  {
    id: '7405010016',
    districtId: '7405010',
    name: 'Lalonggasu',
  },
  {
    id: '7405010017',
    districtId: '7405010',
    name: 'Palo Tawo',
  },
  {
    id: '7405010038',
    districtId: '7405010',
    name: 'Lalowatu',
  },
  {
    id: '7405010039',
    districtId: '7405010',
    name: 'Rapea',
  },
  {
    id: '7405010040',
    districtId: '7405010',
    name: 'Tatangge',
  },
  {
    id: '7405010041',
    districtId: '7405010',
    name: 'Bomba-Bomba',
  },
  {
    id: '7405010042',
    districtId: '7405010',
    name: 'Ponggosi',
  },
  {
    id: '7405010043',
    districtId: '7405010',
    name: 'Matandahi',
  },
  {
    id: '7405010044',
    districtId: '7405010',
    name: 'Matambawi',
  },
  {
    id: '7405010045',
    districtId: '7405010',
    name: 'Akuni',
  },
  {
    id: '7405010046',
    districtId: '7405010',
    name: 'Wundumbolo',
  },
  {
    id: '7405010047',
    districtId: '7405010',
    name: 'Lasuai',
  },
  {
    id: '7405011001',
    districtId: '7405011',
    name: 'Lalembuu Jaya',
  },
  {
    id: '7405011002',
    districtId: '7405011',
    name: 'Meronga Raya',
  },
  {
    id: '7405011003',
    districtId: '7405011',
    name: 'Puunangga',
  },
  {
    id: '7405011004',
    districtId: '7405011',
    name: 'Atari Indah',
  },
  {
    id: '7405011005',
    districtId: '7405011',
    name: 'Atari Jaya',
  },
  {
    id: '7405011006',
    districtId: '7405011',
    name: 'Lambodi Jaya',
  },
  {
    id: '7405011007',
    districtId: '7405011',
    name: 'Potuho Jaya',
  },
  {
    id: '7405011008',
    districtId: '7405011',
    name: 'Makupa Jaya',
  },
  {
    id: '7405011009',
    districtId: '7405011',
    name: 'Sumber Jaya',
  },
  {
    id: '7405011010',
    districtId: '7405011',
    name: 'Lambandia',
  },
  {
    id: '7405011011',
    districtId: '7405011',
    name: 'Teteinea Jaya',
  },
  {
    id: '7405011012',
    districtId: '7405011',
    name: 'Suka Mukti',
  },
  {
    id: '7405011013',
    districtId: '7405011',
    name: 'Kapuwila',
  },
  {
    id: '7405011014',
    districtId: '7405011',
    name: 'Puurema Subur',
  },
  {
    id: '7405011015',
    districtId: '7405011',
    name: 'Mandoke',
  },
  {
    id: '7405011016',
    districtId: '7405011',
    name: 'Moreo',
  },
  {
    id: '7405011017',
    districtId: '7405011',
    name: 'Tombeleu',
  },
  {
    id: '7405011018',
    districtId: '7405011',
    name: 'Padaleu',
  },
  {
    id: '7405011019',
    districtId: '7405011',
    name: 'Lalo Uwesamba',
  },
  {
    id: '7405020001',
    districtId: '7405020',
    name: 'Lalobao',
  },
  {
    id: '7405020002',
    districtId: '7405020',
    name: 'Wunduwatu',
  },
  {
    id: '7405020003',
    districtId: '7405020',
    name: 'Bumi Raya',
  },
  {
    id: '7405020012',
    districtId: '7405020',
    name: 'Lalonggombu',
  },
  {
    id: '7405020013',
    districtId: '7405020',
    name: 'Andoolo',
  },
  {
    id: '7405020014',
    districtId: '7405020',
    name: 'Alangga',
  },
  {
    id: '7405020015',
    districtId: '7405020',
    name: 'Potoro',
  },
  {
    id: '7405020016',
    districtId: '7405020',
    name: 'Alengge Agung',
  },
  {
    id: '7405020031',
    districtId: '7405020',
    name: 'Puunggapu Indah',
  },
  {
    id: '7405020033',
    districtId: '7405020',
    name: 'Ataku',
  },
  {
    id: '7405021001',
    districtId: '7405021',
    name: 'Pelandia',
  },
  {
    id: '7405021002',
    districtId: '7405021',
    name: 'Puudaria Jaya',
  },
  {
    id: '7405021003',
    districtId: '7405021',
    name: 'Raha Menda Jaya',
  },
  {
    id: '7405021005',
    districtId: '7405021',
    name: 'Andoolo Utama',
  },
  {
    id: '7405021006',
    districtId: '7405021',
    name: 'Silea Jaya',
  },
  {
    id: '7405021007',
    districtId: '7405021',
    name: 'Tirta Martani',
  },
  {
    id: '7405021008',
    districtId: '7405021',
    name: 'Tetenggolasa',
  },
  {
    id: '7405021009',
    districtId: '7405021',
    name: 'Asembu Mulya',
  },
  {
    id: '7405021010',
    districtId: '7405021',
    name: 'Awalo',
  },
  {
    id: '7405021011',
    districtId: '7405021',
    name: 'Adaka Jaya',
  },
  {
    id: '7405021012',
    districtId: '7405021',
    name: 'Anggokoti',
  },
  {
    id: '7405021013',
    districtId: '7405021',
    name: 'UPT Adayu Indah',
  },
  {
    id: '7405021015',
    districtId: '7405021',
    name: 'Wonua Maroa',
  },
  {
    id: '7405021016',
    districtId: '7405021',
    name: 'Ranooha Lestari',
  },
  {
    id: '7405022001',
    districtId: '7405022',
    name: 'Bima Maroa',
  },
  {
    id: '7405022002',
    districtId: '7405022',
    name: 'Wawobende',
  },
  {
    id: '7405022003',
    districtId: '7405022',
    name: 'Lapoa Indah',
  },
  {
    id: '7405022004',
    districtId: '7405022',
    name: 'Puundoho',
  },
  {
    id: '7405022005',
    districtId: '7405022',
    name: 'Mataiwoi',
  },
  {
    id: '7405022006',
    districtId: '7405022',
    name: 'Papawu',
  },
  {
    id: '7405022007',
    districtId: '7405022',
    name: 'Anese',
  },
  {
    id: '7405022008',
    districtId: '7405022',
    name: 'Bekenggasu Indah',
  },
  {
    id: '7405022009',
    districtId: '7405022',
    name: 'Mate Upe',
  },
  {
    id: '7405022010',
    districtId: '7405022',
    name: 'Watu Mokala',
  },
  {
    id: '7405030011',
    districtId: '7405030',
    name: 'Mekar Sari',
  },
  {
    id: '7405030012',
    districtId: '7405030',
    name: 'Wawouru',
  },
  {
    id: '7405030013',
    districtId: '7405030',
    name: 'Waworaha',
  },
  {
    id: '7405030014',
    districtId: '7405030',
    name: 'Alakaya',
  },
  {
    id: '7405030015',
    districtId: '7405030',
    name: 'Aosole',
  },
  {
    id: '7405030016',
    districtId: '7405030',
    name: 'Anggondara',
  },
  {
    id: '7405030017',
    districtId: '7405030',
    name: 'Onembute',
  },
  {
    id: '7405030018',
    districtId: '7405030',
    name: 'Eewa',
  },
  {
    id: '7405030019',
    districtId: '7405030',
    name: 'Watumerembe',
  },
  {
    id: '7405030020',
    districtId: '7405030',
    name: 'Wawonggura',
  },
  {
    id: '7405030021',
    districtId: '7405030',
    name: 'Kiaea',
  },
  {
    id: '7405030022',
    districtId: '7405030',
    name: 'Palangga',
  },
  {
    id: '7405030030',
    districtId: '7405030',
    name: 'Kapu Jaya',
  },
  {
    id: '7405030032',
    districtId: '7405030',
    name: 'Watudemba',
  },
  {
    id: '7405030033',
    districtId: '7405030',
    name: 'Sanggi-Sanggi',
  },
  {
    id: '7405030034',
    districtId: '7405030',
    name: 'Wonua Morini',
  },
  {
    id: '7405031001',
    districtId: '7405031',
    name: 'Lakara',
  },
  {
    id: '7405031002',
    districtId: '7405031',
    name: 'Ulu Lakara',
  },
  {
    id: '7405031003',
    districtId: '7405031',
    name: 'Waturapa',
  },
  {
    id: '7405031004',
    districtId: '7405031',
    name: 'Lalowua',
  },
  {
    id: '7405031005',
    districtId: '7405031',
    name: 'Koeono',
  },
  {
    id: '7405031006',
    districtId: '7405031',
    name: 'Amondo',
  },
  {
    id: '7405031007',
    districtId: '7405031',
    name: 'Watumbohoti',
  },
  {
    id: '7405031008',
    districtId: '7405031',
    name: 'Parasi',
  },
  {
    id: '7405031009',
    districtId: '7405031',
    name: 'Mondoe',
  },
  {
    id: '7405031010',
    districtId: '7405031',
    name: 'Wawo Wonua',
  },
  {
    id: '7405032001',
    districtId: '7405032',
    name: 'Tolihe',
  },
  {
    id: '7405032002',
    districtId: '7405032',
    name: 'Sambahule',
  },
  {
    id: '7405032003',
    districtId: '7405032',
    name: 'B A I T O',
  },
  {
    id: '7405032004',
    districtId: '7405032',
    name: 'Wonua Raya',
  },
  {
    id: '7405032005',
    districtId: '7405032',
    name: 'Mekar Jaya',
  },
  {
    id: '7405032006',
    districtId: '7405032',
    name: 'Amasara',
  },
  {
    id: '7405032007',
    districtId: '7405032',
    name: 'Matabubu',
  },
  {
    id: '7405032008',
    districtId: '7405032',
    name: 'Ahuangguluri',
  },
  {
    id: '7405040017',
    districtId: '7405040',
    name: 'Lalonggombu',
  },
  {
    id: '7405040018',
    districtId: '7405040',
    name: 'Aoreo',
  },
  {
    id: '7405040019',
    districtId: '7405040',
    name: 'Watumeeto',
  },
  {
    id: '7405040020',
    districtId: '7405040',
    name: 'Pangan Jaya',
  },
  {
    id: '7405040021',
    districtId: '7405040',
    name: 'Pamandati',
  },
  {
    id: '7405040022',
    districtId: '7405040',
    name: 'Kaindi',
  },
  {
    id: '7405040023',
    districtId: '7405040',
    name: 'Lainea',
  },
  {
    id: '7405040024',
    districtId: '7405040',
    name: 'Matabubu Jaya',
  },
  {
    id: '7405040025',
    districtId: '7405040',
    name: 'Molinese',
  },
  {
    id: '7405040026',
    districtId: '7405040',
    name: 'Polewali',
  },
  {
    id: '7405040027',
    districtId: '7405040',
    name: 'Bangun Jaya',
  },
  {
    id: '7405040028',
    districtId: '7405040',
    name: 'Kalo-Kalo',
  },
  {
    id: '7405040029',
    districtId: '7405040',
    name: 'Ngapa Jaya',
  },
  {
    id: '7405041001',
    districtId: '7405041',
    name: 'Torobulu',
  },
  {
    id: '7405041002',
    districtId: '7405041',
    name: 'Wonua Kongga',
  },
  {
    id: '7405041003',
    districtId: '7405041',
    name: 'Labokeo',
  },
  {
    id: '7405041004',
    districtId: '7405041',
    name: 'Anggoroboti',
  },
  {
    id: '7405041005',
    districtId: '7405041',
    name: 'Laeya',
  },
  {
    id: '7405041006',
    districtId: '7405041',
    name: 'Aepodu',
  },
  {
    id: '7405041007',
    districtId: '7405041',
    name: 'Rambu-Rambu',
  },
  {
    id: '7405041008',
    districtId: '7405041',
    name: 'Ambakumina',
  },
  {
    id: '7405041009',
    districtId: '7405041',
    name: 'Ombu-Ombu Jaya',
  },
  {
    id: '7405041010',
    districtId: '7405041',
    name: 'Lamong Jaya',
  },
  {
    id: '7405041011',
    districtId: '7405041',
    name: 'Lerepako',
  },
  {
    id: '7405041012',
    districtId: '7405041',
    name: 'Punggaluku',
  },
  {
    id: '7405041013',
    districtId: '7405041',
    name: 'Anduna',
  },
  {
    id: '7405041014',
    districtId: '7405041',
    name: 'Ambalodangge',
  },
  {
    id: '7405041015',
    districtId: '7405041',
    name: 'Lambakara',
  },
  {
    id: '7405041016',
    districtId: '7405041',
    name: 'Ambesea',
  },
  {
    id: '7405041017',
    districtId: '7405041',
    name: 'Puuwulo',
  },
  {
    id: '7405050001',
    districtId: '7405050',
    name: 'Puupi',
  },
  {
    id: '7405050002',
    districtId: '7405050',
    name: 'Tiraosu',
  },
  {
    id: '7405050003',
    districtId: '7405050',
    name: 'Waworano',
  },
  {
    id: '7405050004',
    districtId: '7405050',
    name: 'Matandahi',
  },
  {
    id: '7405050005',
    districtId: '7405050',
    name: 'Mataiwoi',
  },
  {
    id: '7405050006',
    districtId: '7405050',
    name: 'Andinete',
  },
  {
    id: '7405050007',
    districtId: '7405050',
    name: 'Langgowala',
  },
  {
    id: '7405050008',
    districtId: '7405050',
    name: 'Wawoosu',
  },
  {
    id: '7405050009',
    districtId: '7405050',
    name: 'Sawah',
  },
  {
    id: '7405050010',
    districtId: '7405050',
    name: 'Kolono',
  },
  {
    id: '7405050011',
    districtId: '7405050',
    name: 'Mondoe Jaya',
  },
  {
    id: '7405050012',
    districtId: '7405050',
    name: 'Ulusena Jaya',
  },
  {
    id: '7405050013',
    districtId: '7405050',
    name: 'Lamotau',
  },
  {
    id: '7405050014',
    districtId: '7405050',
    name: 'Awunio',
  },
  {
    id: '7405050015',
    districtId: '7405050',
    name: 'Meletumbo',
  },
  {
    id: '7405050016',
    districtId: '7405050',
    name: 'Roda',
  },
  {
    id: '7405050017',
    districtId: '7405050',
    name: 'Lamapu',
  },
  {
    id: '7405050028',
    districtId: '7405050',
    name: 'Silea',
  },
  {
    id: '7405050029',
    districtId: '7405050',
    name: 'Alosi',
  },
  {
    id: '7405050030',
    districtId: '7405050',
    name: 'Sarandua',
  },
  {
    id: '7405050031',
    districtId: '7405050',
    name: 'Puudongi',
  },
  {
    id: '7405051001',
    districtId: '7405051',
    name: 'Rambu-Rambu',
  },
  {
    id: '7405051002',
    districtId: '7405051',
    name: 'Lambangi',
  },
  {
    id: '7405051003',
    districtId: '7405051',
    name: 'Tumbu-Tumbu Jaya',
  },
  {
    id: '7405051004',
    districtId: '7405051',
    name: 'Ngapawali',
  },
  {
    id: '7405051005',
    districtId: '7405051',
    name: 'Batu Putih',
  },
  {
    id: '7405051006',
    districtId: '7405051',
    name: 'Rumba-Rumba',
  },
  {
    id: '7405051007',
    districtId: '7405051',
    name: 'Ampera',
  },
  {
    id: '7405051008',
    districtId: '7405051',
    name: 'Amolengu',
  },
  {
    id: '7405051010',
    districtId: '7405051',
    name: 'Langgapulu',
  },
  {
    id: '7405060001',
    districtId: '7405060',
    name: 'Laonti',
  },
  {
    id: '7405060002',
    districtId: '7405060',
    name: 'Puundirangga',
  },
  {
    id: '7405060003',
    districtId: '7405060',
    name: 'Kondono',
  },
  {
    id: '7405060004',
    districtId: '7405060',
    name: 'Lawisata',
  },
  {
    id: '7405060005',
    districtId: '7405060',
    name: 'Batu Jaya / Watundolu',
  },
  {
    id: '7405060006',
    districtId: '7405060',
    name: 'Namu',
  },
  {
    id: '7405060007',
    districtId: '7405060',
    name: 'Malaringgi',
  },
  {
    id: '7405060009',
    districtId: '7405060',
    name: 'Sangi-Sangi',
  },
  {
    id: '7405060010',
    districtId: '7405060',
    name: 'Ulu Sawa',
  },
  {
    id: '7405060011',
    districtId: '7405060',
    name: 'Cempedak',
  },
  {
    id: '7405060012',
    districtId: '7405060',
    name: 'Woru Woru',
  },
  {
    id: '7405060013',
    districtId: '7405060',
    name: 'Tambeanga',
  },
  {
    id: '7405060014',
    districtId: '7405060',
    name: 'Labotaone',
  },
  {
    id: '7405060015',
    districtId: '7405060',
    name: 'Labuan Beropa',
  },
  {
    id: '7405060016',
    districtId: '7405060',
    name: 'Peo Indah',
  },
  {
    id: '7405060017',
    districtId: '7405060',
    name: 'Tambolosu',
  },
  {
    id: '7405060018',
    districtId: '7405060',
    name: 'Wandaeha',
  },
  {
    id: '7405060019',
    districtId: '7405060',
    name: 'Rumbi Rumbia',
  },
  {
    id: '7405060020',
    districtId: '7405060',
    name: 'Matabondu',
  },
  {
    id: '7405070001',
    districtId: '7405070',
    name: 'Bakutaru',
  },
  {
    id: '7405070002',
    districtId: '7405070',
    name: 'Pudaria Jaya',
  },
  {
    id: '7405070003',
    districtId: '7405070',
    name: 'Sumber Sari',
  },
  {
    id: '7405070004',
    districtId: '7405070',
    name: 'Ulusena',
  },
  {
    id: '7405070022',
    districtId: '7405070',
    name: 'Wawosunggu',
  },
  {
    id: '7405070023',
    districtId: '7405070',
    name: 'Penambea Barata',
  },
  {
    id: '7405070024',
    districtId: '7405070',
    name: 'Lapuko',
  },
  {
    id: '7405070025',
    districtId: '7405070',
    name: 'Lamboo',
  },
  {
    id: '7405070026',
    districtId: '7405070',
    name: 'Landipo',
  },
  {
    id: '7405070027',
    districtId: '7405070',
    name: 'Lakomea',
  },
  {
    id: '7405070028',
    districtId: '7405070',
    name: 'Marga Cinta',
  },
  {
    id: '7405070029',
    districtId: '7405070',
    name: 'Moramo',
  },
  {
    id: '7405070030',
    districtId: '7405070',
    name: 'Tambosupa',
  },
  {
    id: '7405070031',
    districtId: '7405070',
    name: 'Amohola',
  },
  {
    id: '7405070040',
    districtId: '7405070',
    name: 'Wawondengi',
  },
  {
    id: '7405070041',
    districtId: '7405070',
    name: 'Ranooha Jaya',
  },
  {
    id: '7405070044',
    districtId: '7405070',
    name: 'Selabangga',
  },
  {
    id: '7405070045',
    districtId: '7405070',
    name: 'Watu Porambaa',
  },
  {
    id: '7405070046',
    districtId: '7405070',
    name: 'Wonua Jaya',
  },
  {
    id: '7405070047',
    districtId: '7405070',
    name: 'Bisikori',
  },
  {
    id: '7405070048',
    districtId: '7405070',
    name: 'UPT. Puuduria',
  },
  {
    id: '7405071032',
    districtId: '7405071',
    name: 'Lamokula',
  },
  {
    id: '7405071033',
    districtId: '7405071',
    name: 'Mekar Jaya',
  },
  {
    id: '7405071034',
    districtId: '7405071',
    name: 'Sanggula',
  },
  {
    id: '7405071035',
    districtId: '7405071',
    name: 'Lombuea',
  },
  {
    id: '7405071036',
    districtId: '7405071',
    name: 'Wawatu',
  },
  {
    id: '7405071037',
    districtId: '7405071',
    name: 'Tanjung Tiram',
  },
  {
    id: '7405071038',
    districtId: '7405071',
    name: 'Lalowaru',
  },
  {
    id: '7405071039',
    districtId: '7405071',
    name: 'Puasana',
  },
  {
    id: '7405071042',
    districtId: '7405071',
    name: 'Mata Lamokula',
  },
  {
    id: '7405071043',
    districtId: '7405071',
    name: 'Mata Wawatu',
  },
  {
    id: '7405080005',
    districtId: '7405080',
    name: 'T A N E A',
  },
  {
    id: '7405080006',
    districtId: '7405080',
    name: 'Amohalo',
  },
  {
    id: '7405080007',
    districtId: '7405080',
    name: 'Masagena',
  },
  {
    id: '7405080008',
    districtId: '7405080',
    name: 'Cialam Jaya',
  },
  {
    id: '7405080009',
    districtId: '7405080',
    name: 'Lawoila',
  },
  {
    id: '7405080010',
    districtId: '7405080',
    name: 'Wonua',
  },
  {
    id: '7405080011',
    districtId: '7405080',
    name: 'Pambulaa Jaya',
  },
  {
    id: '7405080012',
    districtId: '7405080',
    name: 'Ambololi',
  },
  {
    id: '7405080013',
    districtId: '7405080',
    name: 'Lambusa',
  },
  {
    id: '7405080014',
    districtId: '7405080',
    name: 'Lebo Jaya',
  },
  {
    id: '7405080015',
    districtId: '7405080',
    name: 'Konda',
  },
  {
    id: '7405080016',
    districtId: '7405080',
    name: 'Alebo',
  },
  {
    id: '7405080017',
    districtId: '7405080',
    name: 'Morome',
  },
  {
    id: '7405080018',
    districtId: '7405080',
    name: 'Lamomea',
  },
  {
    id: '7405080019',
    districtId: '7405080',
    name: 'Puosu Jaya',
  },
  {
    id: '7405080020',
    districtId: '7405080',
    name: 'Lalowiu',
  },
  {
    id: '7405080021',
    districtId: '7405080',
    name: 'Konda Satu',
  },
  {
    id: '7405081001',
    districtId: '7405081',
    name: 'Lelekaa',
  },
  {
    id: '7405081002',
    districtId: '7405081',
    name: 'Amoito Jaya',
  },
  {
    id: '7405081003',
    districtId: '7405081',
    name: 'Aoma',
  },
  {
    id: '7405081004',
    districtId: '7405081',
    name: 'Wolasi',
  },
  {
    id: '7405081005',
    districtId: '7405081',
    name: 'Ranowila',
  },
  {
    id: '7405081006',
    districtId: '7405081',
    name: 'Aunupe',
  },
  {
    id: '7405081007',
    districtId: '7405081',
    name: 'Ambesokoa',
  },
  {
    id: '7405081008',
    districtId: '7405081',
    name: 'Mata Wolasi',
  },
  {
    id: '7405090002',
    districtId: '7405090',
    name: 'Boro-Boro R',
  },
  {
    id: '7405090003',
    districtId: '7405090',
    name: 'Rambu-Rambu Jaya',
  },
  {
    id: '7405090005',
    districtId: '7405090',
    name: 'Amoito',
  },
  {
    id: '7405090008',
    districtId: '7405090',
    name: 'Ambaipua',
  },
  {
    id: '7405090009',
    districtId: '7405090',
    name: 'Onewila',
  },
  {
    id: '7405090010',
    districtId: '7405090',
    name: 'Ranooha',
  },
  {
    id: '7405090011',
    districtId: '7405090',
    name: 'Ranomeeto',
  },
  {
    id: '7405090012',
    districtId: '7405090',
    name: 'Kota Bangun',
  },
  {
    id: '7405090013',
    districtId: '7405090',
    name: 'Langgea',
  },
  {
    id: '7405090019',
    districtId: '7405090',
    name: 'Duduria',
  },
  {
    id: '7405090020',
    districtId: '7405090',
    name: 'Laikaaha',
  },
  {
    id: '7405090021',
    districtId: '7405090',
    name: 'Amoito Siama',
  },
  {
    id: '7405091001',
    districtId: '7405091',
    name: 'Amokuni',
  },
  {
    id: '7405091002',
    districtId: '7405091',
    name: 'Sindang Kasih',
  },
  {
    id: '7405091003',
    districtId: '7405091',
    name: 'Jati Bali',
  },
  {
    id: '7405091004',
    districtId: '7405091',
    name: 'Abeko',
  },
  {
    id: '7405091005',
    districtId: '7405091',
    name: 'Lameuru',
  },
  {
    id: '7405091006',
    districtId: '7405091',
    name: 'Opaasi',
  },
  {
    id: '7405091007',
    districtId: '7405091',
    name: 'Boro-Boro Lameuru',
  },
  {
    id: '7405091008',
    districtId: '7405091',
    name: 'Tunduno',
  },
  {
    id: '7405091009',
    districtId: '7405091',
    name: 'Laikandonga',
  },
  {
    id: '7405100007',
    districtId: '7405100',
    name: 'Endanga',
  },
  {
    id: '7405100008',
    districtId: '7405100',
    name: 'Amotowo',
  },
  {
    id: '7405100009',
    districtId: '7405100',
    name: 'Landono',
  },
  {
    id: '7405100010',
    districtId: '7405100',
    name: 'Arongo',
  },
  {
    id: '7405100011',
    districtId: '7405100',
    name: 'Tridana Mulya',
  },
  {
    id: '7405100012',
    districtId: '7405100',
    name: 'Lalonggapu',
  },
  {
    id: '7405100013',
    districtId: '7405100',
    name: 'Wata Benua',
  },
  {
    id: '7405100014',
    districtId: '7405100',
    name: 'Abenggi',
  },
  {
    id: '7405100015',
    districtId: '7405100',
    name: 'Landono II',
  },
  {
    id: '7405100033',
    districtId: '7405100',
    name: 'Wonua Sangia',
  },
  {
    id: '7405100035',
    districtId: '7405100',
    name: 'Morini Mulya',
  },
  {
    id: '7405100036',
    districtId: '7405100',
    name: 'Lakomea',
  },
  {
    id: '7405100043',
    districtId: '7405100',
    name: 'UPT Arongo',
  },
  {
    id: '7405101001',
    districtId: '7405101',
    name: 'Wuura',
  },
  {
    id: '7405101002',
    districtId: '7405101',
    name: 'Lamolori',
  },
  {
    id: '7405101003',
    districtId: '7405101',
    name: 'Rakawuta',
  },
  {
    id: '7405101004',
    districtId: '7405101',
    name: 'Toluwonua',
  },
  {
    id: '7405101005',
    districtId: '7405101',
    name: 'Mowila',
  },
  {
    id: '7405101006',
    districtId: '7405101',
    name: 'Pudahoa',
  },
  {
    id: '7405101007',
    districtId: '7405101',
    name: 'Puwehuko',
  },
  {
    id: '7405101008',
    districtId: '7405101',
    name: 'Kondoano',
  },
  {
    id: '7405101009',
    districtId: '7405101',
    name: 'Mulya Sari',
  },
  {
    id: '7405101010',
    districtId: '7405101',
    name: 'Monapa',
  },
  {
    id: '7405101011',
    districtId: '7405101',
    name: 'Rano Mbayasa',
  },
  {
    id: '7405101012',
    districtId: '7405101',
    name: 'Punggulahi',
  },
  {
    id: '7405101013',
    districtId: '7405101',
    name: 'Rano Aopa',
  },
  {
    id: '7405101014',
    districtId: '7405101',
    name: 'Lalosingi',
  },
  {
    id: '7405101015',
    districtId: '7405101',
    name: 'Mataiwoi',
  },
  {
    id: '7405101016',
    districtId: '7405101',
    name: 'Wonua Kongga',
  },
  {
    id: '7405101017',
    districtId: '7405101',
    name: 'Lamebara',
  },
  {
    id: '7405101018',
    districtId: '7405101',
    name: 'Wonua Sari',
  },
  {
    id: '7405101019',
    districtId: '7405101',
    name: 'Tetesingi',
  },
  {
    id: '7405101020',
    districtId: '7405101',
    name: 'Wonua Monapa',
  },
  {
    id: '7405102001',
    districtId: '7405102',
    name: 'Koronua',
  },
  {
    id: '7405102002',
    districtId: '7405102',
    name: 'Watu-Watu',
  },
  {
    id: '7405102003',
    districtId: '7405102',
    name: 'Ulu Sabulakoa',
  },
  {
    id: '7405102004',
    districtId: '7405102',
    name: 'Wonua Morini',
  },
  {
    id: '7405102005',
    districtId: '7405102',
    name: 'Wonua Koa',
  },
  {
    id: '7405102006',
    districtId: '7405102',
    name: 'Sabulakoa',
  },
  {
    id: '7405102007',
    districtId: '7405102',
    name: 'Talumbinga Jaya',
  },
  {
    id: '7405102008',
    districtId: '7405102',
    name: 'Tetenggabo',
  },
  {
    id: '7405102009',
    districtId: '7405102',
    name: 'Asaria',
  },
  {
    id: '7405102010',
    districtId: '7405102',
    name: 'Wawobende',
  },
  {
    id: '7405110016',
    districtId: '7405110',
    name: 'Pudambu',
  },
  {
    id: '7405110017',
    districtId: '7405110',
    name: 'Matabondu',
  },
  {
    id: '7405110018',
    districtId: '7405110',
    name: 'Angata',
  },
  {
    id: '7405110019',
    districtId: '7405110',
    name: 'Mataiwoi',
  },
  {
    id: '7405110020',
    districtId: '7405110',
    name: 'Kosebo',
  },
  {
    id: '7405110021',
    districtId: '7405110',
    name: 'Motaha',
  },
  {
    id: '7405110022',
    districtId: '7405110',
    name: 'Aopa',
  },
  {
    id: '7405110023',
    districtId: '7405110',
    name: 'Pewutaa',
  },
  {
    id: '7405110024',
    districtId: '7405110',
    name: 'Lamoen',
  },
  {
    id: '7405110025',
    districtId: '7405110',
    name: 'Puusanggula',
  },
  {
    id: '7405110026',
    districtId: '7405110',
    name: 'Puao',
  },
  {
    id: '7405110027',
    districtId: '7405110',
    name: 'Sandei',
  },
  {
    id: '7405110028',
    districtId: '7405110',
    name: 'Teteasa',
  },
  {
    id: '7405110029',
    districtId: '7405110',
    name: 'Simbangu',
  },
  {
    id: '7405110030',
    districtId: '7405110',
    name: 'Lamooso',
  },
  {
    id: '7405110031',
    districtId: '7405110',
    name: 'Puuroe',
  },
  {
    id: '7405110032',
    districtId: '7405110',
    name: 'Sandarsi Jaya',
  },
  {
    id: '7405110033',
    districtId: '7405110',
    name: 'Lamoeri',
  },
  {
    id: '7405110034',
    districtId: '7405110',
    name: 'Puunggoni',
  },
  {
    id: '7405110035',
    districtId: '7405110',
    name: 'Landabaro',
  },
  {
    id: '7405110036',
    districtId: '7405110',
    name: 'Puulipu',
  },
  {
    id: '7405110037',
    districtId: '7405110',
    name: 'Boloso',
  },
  {
    id: '7405110038',
    districtId: '7405110',
    name: 'Mokoau',
  },
  {
    id: '7405110040',
    districtId: '7405110',
    name: 'Langgea Indah',
  },
  {
    id: '7405111001',
    districtId: '7405111',
    name: 'Puunggawu Kawu',
  },
  {
    id: '7405111002',
    districtId: '7405111',
    name: 'Palowewu',
  },
  {
    id: '7405111003',
    districtId: '7405111',
    name: 'Benua',
  },
  {
    id: '7405111004',
    districtId: '7405111',
    name: 'Horodopi',
  },
  {
    id: '7405111005',
    districtId: '7405111',
    name: 'Benua Utama',
  },
  {
    id: '7405111006',
    districtId: '7405111',
    name: 'Puosu',
  },
  {
    id: '7405111007',
    districtId: '7405111',
    name: 'Lamara',
  },
  {
    id: '7405111008',
    districtId: '7405111',
    name: 'Uelawa',
  },
  {
    id: '7405111010',
    districtId: '7405111',
    name: 'Waworaha',
  },
  {
    id: '7405111011',
    districtId: '7405111',
    name: 'Puuwehuko',
  },
  {
    id: '7405111012',
    districtId: '7405111',
    name: 'Tetehaka',
  },
  {
    id: '7405111014',
    districtId: '7405111',
    name: 'Awalo Jaya',
  },
  {
    id: '7405111015',
    districtId: '7405111',
    name: 'Kosambi',
  },
  {
    id: '7405112001',
    districtId: '7405112',
    name: 'Lambandia',
  },
  {
    id: '7405112003',
    districtId: '7405112',
    name: 'Tombekuku',
  },
  {
    id: '7405112004',
    districtId: '7405112',
    name: 'Iwoi Mendoro',
  },
  {
    id: '7405112005',
    districtId: '7405112',
    name: 'Epeesi',
  },
  {
    id: '7405112006',
    districtId: '7405112',
    name: 'Basala',
  },
  {
    id: '7405112007',
    districtId: '7405112',
    name: 'Lipu Masagena',
  },
  {
    id: '7405112008',
    districtId: '7405112',
    name: 'Polo-Pololi',
  },
  {
    id: '7405112010',
    districtId: '7405112',
    name: 'Teporombua',
  },
  {
    id: '7406010001',
    districtId: '7406010',
    name: 'Tirongkotua',
  },
  {
    id: '7406010002',
    districtId: '7406010',
    name: 'Rahadopi',
  },
  {
    id: '7406010003',
    districtId: '7406010',
    name: 'Teomokole',
  },
  {
    id: '7406010004',
    districtId: '7406010',
    name: 'Rahampuu',
  },
  {
    id: '7406011001',
    districtId: '7406011',
    name: 'Tedubara',
  },
  {
    id: '7406011002',
    districtId: '7406011',
    name: 'Eemokolo',
  },
  {
    id: '7406011003',
    districtId: '7406011',
    name: 'Sangia Makmur',
  },
  {
    id: '7406011004',
    districtId: '7406011',
    name: 'Wumbulasa',
  },
  {
    id: '7406011005',
    districtId: '7406011',
    name: 'Mapila',
  },
  {
    id: '7406011006',
    districtId: '7406011',
    name: 'Larolanu (Sp3)',
  },
  {
    id: '7406012001',
    districtId: '7406012',
    name: 'Pongkalaero',
  },
  {
    id: '7406012002',
    districtId: '7406012',
    name: 'Batuawu',
  },
  {
    id: '7406012003',
    districtId: '7406012',
    name: 'Langkema',
  },
  {
    id: '7406013001',
    districtId: '7406013',
    name: 'Sikeli',
  },
  {
    id: '7406013002',
    districtId: '7406013',
    name: 'Baliara',
  },
  {
    id: '7406013003',
    districtId: '7406013',
    name: 'Rahantari',
  },
  {
    id: '7406013004',
    districtId: '7406013',
    name: 'Baliara Kepulauan',
  },
  {
    id: '7406013005',
    districtId: '7406013',
    name: 'Baliara Selatan',
  },
  {
    id: '7406020001',
    districtId: '7406020',
    name: 'Wumbuburo',
  },
  {
    id: '7406020002',
    districtId: '7406020',
    name: 'Dongkala',
  },
  {
    id: '7406020003',
    districtId: '7406020',
    name: 'Balo',
  },
  {
    id: '7406020004',
    districtId: '7406020',
    name: 'Toli-Toli',
  },
  {
    id: '7406020005',
    districtId: '7406020',
    name: 'Tapuhaka',
  },
  {
    id: '7406020006',
    districtId: '7406020',
    name: 'Bungi-Bungi',
  },
  {
    id: '7406020007',
    districtId: '7406020',
    name: 'Lambale',
  },
  {
    id: '7406021001',
    districtId: '7406021',
    name: 'Tangkeno',
  },
  {
    id: '7406021002',
    districtId: '7406021',
    name: 'Enano',
  },
  {
    id: '7406021003',
    districtId: '7406021',
    name: 'Ulungkura',
  },
  {
    id: '7406021004',
    districtId: '7406021',
    name: 'Lengora',
  },
  {
    id: '7406021005',
    districtId: '7406021',
    name: 'Lengora Selatan',
  },
  {
    id: '7406021006',
    districtId: '7406021',
    name: 'Lengora Pantai',
  },
  {
    id: '7406021007',
    districtId: '7406021',
    name: 'Lamonggi',
  },
  {
    id: '7406021008',
    districtId: '7406021',
    name: 'UPT Lengora Pantai',
  },
  {
    id: '7406030001',
    districtId: '7406030',
    name: 'Kasipute',
  },
  {
    id: '7406030002',
    districtId: '7406030',
    name: 'Lantowonua',
  },
  {
    id: '7406030003',
    districtId: '7406030',
    name: 'Doule',
  },
  {
    id: '7406030004',
    districtId: '7406030',
    name: 'Lampopala',
  },
  {
    id: '7406030005',
    districtId: '7406030',
    name: 'Lameroro',
  },
  {
    id: '7406031001',
    districtId: '7406031',
    name: 'Liano',
  },
  {
    id: '7406031002',
    districtId: '7406031',
    name: 'Pomontoro',
  },
  {
    id: '7406031003',
    districtId: '7406031',
    name: 'Hambawa',
  },
  {
    id: '7406031004',
    districtId: '7406031',
    name: 'Pulau Tambako',
  },
  {
    id: '7406031005',
    districtId: '7406031',
    name: 'Lora',
  },
  {
    id: '7406031006',
    districtId: '7406031',
    name: 'Toli-Toli',
  },
  {
    id: '7406031007',
    districtId: '7406031',
    name: 'Batu Sempe Indah',
  },
  {
    id: '7406031008',
    districtId: '7406031',
    name: 'Laloa',
  },
  {
    id: '7406031009',
    districtId: '7406031',
    name: 'Mawar',
  },
  {
    id: '7406031010',
    districtId: '7406031',
    name: 'Tajuncu',
  },
  {
    id: '7406031011',
    districtId: '7406031',
    name: 'Puu Waeya',
  },
  {
    id: '7406032001',
    districtId: '7406032',
    name: 'Masaloka',
  },
  {
    id: '7406032002',
    districtId: '7406032',
    name: 'Masaloka Timur',
  },
  {
    id: '7406032003',
    districtId: '7406032',
    name: 'Masaloka Barat',
  },
  {
    id: '7406032004',
    districtId: '7406032',
    name: 'Masaloka Selatan',
  },
  {
    id: '7406032005',
    districtId: '7406032',
    name: 'Batu Lamburi',
  },
  {
    id: '7406033001',
    districtId: '7406033',
    name: 'Lampata',
  },
  {
    id: '7406033002',
    districtId: '7406033',
    name: 'Tapuhahi',
  },
  {
    id: '7406033003',
    districtId: '7406033',
    name: 'Lauru',
  },
  {
    id: '7406033004',
    districtId: '7406033',
    name: 'Kampung Baru',
  },
  {
    id: '7406033005',
    districtId: '7406033',
    name: 'Po Ea',
  },
  {
    id: '7406040001',
    districtId: '7406040',
    name: 'Rau-Rau',
  },
  {
    id: '7406040002',
    districtId: '7406040',
    name: 'Pangkuri',
  },
  {
    id: '7406040003',
    districtId: '7406040',
    name: 'Lakomea',
  },
  {
    id: '7406040004',
    districtId: '7406040',
    name: 'Taubonto',
  },
  {
    id: '7406040005',
    districtId: '7406040',
    name: 'Rarowatu',
  },
  {
    id: '7406040006',
    districtId: '7406040',
    name: 'Ladumpi',
  },
  {
    id: '7406040007',
    districtId: '7406040',
    name: 'Lampeantani',
  },
  {
    id: '7406040008',
    districtId: '7406040',
    name: 'Watu Kalangkari',
  },
  {
    id: '7406040009',
    districtId: '7406040',
    name: 'Tahi Ite',
  },
  {
    id: '7406041001',
    districtId: '7406041',
    name: 'Lantowua',
  },
  {
    id: '7406041002',
    districtId: '7406041',
    name: 'Watu Mentade',
  },
  {
    id: '7406041003',
    districtId: '7406041',
    name: 'Hukaea',
  },
  {
    id: '7406041004',
    districtId: '7406041',
    name: 'Tunas Baru',
  },
  {
    id: '7406041006',
    districtId: '7406041',
    name: 'Aneka Marga',
  },
  {
    id: '7406041007',
    districtId: '7406041',
    name: 'Marga Jaya',
  },
  {
    id: '7406041008',
    districtId: '7406041',
    name: 'Wumbubangka',
  },
  {
    id: '7406042001',
    districtId: '7406042',
    name: 'Kolombi Mata Usu',
  },
  {
    id: '7406042002',
    districtId: '7406042',
    name: 'Morengke',
  },
  {
    id: '7406042003',
    districtId: '7406042',
    name: 'Totole',
  },
  {
    id: '7406042004',
    districtId: '7406042',
    name: 'Wia-Wia',
  },
  {
    id: '7406042005',
    districtId: '7406042',
    name: 'Lamuru',
  },
  {
    id: '7406043001',
    districtId: '7406043',
    name: 'Lantari',
  },
  {
    id: '7406043002',
    districtId: '7406043',
    name: 'Passare Apua',
  },
  {
    id: '7406043003',
    districtId: '7406043',
    name: 'Anugerah',
  },
  {
    id: '7406043004',
    districtId: '7406043',
    name: 'Lomba Kasih',
  },
  {
    id: '7406043005',
    districtId: '7406043',
    name: 'Langkowala',
  },
  {
    id: '7406043006',
    districtId: '7406043',
    name: 'Rarongkeu',
  },
  {
    id: '7406043007',
    districtId: '7406043',
    name: 'Kalaero',
  },
  {
    id: '7406043008',
    districtId: '7406043',
    name: 'Watu-Watu',
  },
  {
    id: '7406043009',
    districtId: '7406043',
    name: 'Tinabite',
  },
  {
    id: '7406050003',
    districtId: '7406050',
    name: 'Teppoe',
  },
  {
    id: '7406050004',
    districtId: '7406050',
    name: 'Bambaea',
  },
  {
    id: '7406050009',
    districtId: '7406050',
    name: 'Mambo',
  },
  {
    id: '7406050012',
    districtId: '7406050',
    name: 'Biru',
  },
  {
    id: '7406050016',
    districtId: '7406050',
    name: 'Puulemo',
  },
  {
    id: '7406051001',
    districtId: '7406051',
    name: 'Rompu Rompu',
  },
  {
    id: '7406051002',
    districtId: '7406051',
    name: 'Toburi',
  },
  {
    id: '7406051003',
    districtId: '7406051',
    name: 'Tampawulu',
  },
  {
    id: '7406051004',
    districtId: '7406051',
    name: 'Tanah Poleang',
  },
  {
    id: '7406051005',
    districtId: '7406051',
    name: 'Karya Baru',
  },
  {
    id: '7406051006',
    districtId: '7406051',
    name: 'Lawatu Ea',
  },
  {
    id: '7406051007',
    districtId: '7406051',
    name: 'Pusu Ea',
  },
  {
    id: '7406051008',
    districtId: '7406051',
    name: 'Wambarema',
  },
  {
    id: '7406052001',
    districtId: '7406052',
    name: 'Batu Putih',
  },
  {
    id: '7406052002',
    districtId: '7406052',
    name: 'Waemputang',
  },
  {
    id: '7406052003',
    districtId: '7406052',
    name: 'Kalibaru',
  },
  {
    id: '7406052004',
    districtId: '7406052',
    name: 'Akacipong',
  },
  {
    id: '7406052005',
    districtId: '7406052',
    name: 'Laea',
  },
  {
    id: '7406053001',
    districtId: '7406053',
    name: 'Larete',
  },
  {
    id: '7406053002',
    districtId: '7406053',
    name: 'Terapung',
  },
  {
    id: '7406053003',
    districtId: '7406053',
    name: 'Lemo',
  },
  {
    id: '7406053004',
    districtId: '7406053',
    name: 'Lamoare',
  },
  {
    id: '7406053005',
    districtId: '7406053',
    name: 'Rambaha',
  },
  {
    id: '7406060001',
    districtId: '7406060',
    name: 'Boeara',
  },
  {
    id: '7406060002',
    districtId: '7406060',
    name: 'Pukurumba',
  },
  {
    id: '7406060003',
    districtId: '7406060',
    name: 'Kastarib',
  },
  {
    id: '7406060004',
    districtId: '7406060',
    name: 'Barangga',
  },
  {
    id: '7406060005',
    districtId: '7406060',
    name: 'Boepinang',
  },
  {
    id: '7406060006',
    districtId: '7406060',
    name: 'Pallimae',
  },
  {
    id: '7406060007',
    districtId: '7406060',
    name: 'Salosa',
  },
  {
    id: '7406060008',
    districtId: '7406060',
    name: 'Boepinang Barat',
  },
  {
    id: '7406060009',
    districtId: '7406060',
    name: 'Kasabolo',
  },
  {
    id: '7406060010',
    districtId: '7406060',
    name: 'Mattirowalie',
  },
  {
    id: '7406061001',
    districtId: '7406061',
    name: 'Toari Bombana',
  },
  {
    id: '7406061002',
    districtId: '7406061',
    name: 'Timbala',
  },
  {
    id: '7406061003',
    districtId: '7406061',
    name: 'Ranokomea',
  },
  {
    id: '7406061004',
    districtId: '7406061',
    name: 'Rakadua',
  },
  {
    id: '7406061005',
    districtId: '7406061',
    name: 'Lameo-Meong',
  },
  {
    id: '7406061006',
    districtId: '7406061',
    name: 'Babamolingku',
  },
  {
    id: '7406061007',
    districtId: '7406061',
    name: 'Balasari',
  },
  {
    id: '7406061008',
    districtId: '7406061',
    name: 'Pabiring',
  },
  {
    id: '7406061009',
    districtId: '7406061',
    name: 'Bulu Manai',
  },
  {
    id: '7406061010',
    districtId: '7406061',
    name: 'Matabundu',
  },
  {
    id: '7406061011',
    districtId: '7406061',
    name: 'Analere',
  },
  {
    id: '7406062001',
    districtId: '7406062',
    name: 'Tontonunu',
  },
  {
    id: '7406062002',
    districtId: '7406062',
    name: 'Watu Melomba',
  },
  {
    id: '7406062003',
    districtId: '7406062',
    name: 'Tongkoseng',
  },
  {
    id: '7406062004',
    districtId: '7406062',
    name: 'Puu Wonua',
  },
  {
    id: '7406062005',
    districtId: '7406062',
    name: 'Tetehaka',
  },
  {
    id: '7406063001',
    districtId: '7406063',
    name: 'Labo Ea',
  },
  {
    id: '7406063002',
    districtId: '7406063',
    name: 'Paria',
  },
  {
    id: '7406063003',
    districtId: '7406063',
    name: 'Mulaeno',
  },
  {
    id: '7406063004',
    districtId: '7406063',
    name: 'Poleonro',
  },
  {
    id: '7407010001',
    districtId: '7407010',
    name: 'Taipabu',
  },
  {
    id: '7407010006',
    districtId: '7407010',
    name: 'Wali',
  },
  {
    id: '7407010007',
    districtId: '7407010',
    name: 'Lagongga',
  },
  {
    id: '7407010008',
    districtId: '7407010',
    name: 'Kampo-Kampo',
  },
  {
    id: '7407010009',
    districtId: '7407010',
    name: 'Palahidu',
  },
  {
    id: '7407010010',
    districtId: '7407010',
    name: 'Makoro',
  },
  {
    id: '7407010011',
    districtId: '7407010',
    name: 'Palahidu Barat',
  },
  {
    id: '7407010012',
    districtId: '7407010',
    name: 'Rukuwa',
  },
  {
    id: '7407010013',
    districtId: '7407010',
    name: 'Jaya Makmur',
  },
  {
    id: '7407011001',
    districtId: '7407011',
    name: 'Sowa',
  },
  {
    id: '7407011002',
    districtId: '7407011',
    name: 'Popalia',
  },
  {
    id: '7407011003',
    districtId: '7407011',
    name: 'Oihu',
  },
  {
    id: '7407011004',
    districtId: '7407011',
    name: 'Waloindi',
  },
  {
    id: '7407011005',
    districtId: '7407011',
    name: 'Haka',
  },
  {
    id: '7407020001',
    districtId: '7407020',
    name: 'Waitii Barat',
  },
  {
    id: '7407020002',
    districtId: '7407020',
    name: 'Waitii',
  },
  {
    id: '7407020003',
    districtId: '7407020',
    name: 'Lamanggau',
  },
  {
    id: '7407020013',
    districtId: '7407020',
    name: 'Patua',
  },
  {
    id: '7407020014',
    districtId: '7407020',
    name: 'Onemay',
  },
  {
    id: '7407020015',
    districtId: '7407020',
    name: 'Waha',
  },
  {
    id: '7407020016',
    districtId: '7407020',
    name: 'Runduma',
  },
  {
    id: '7407020017',
    districtId: '7407020',
    name: 'Teemoane',
  },
  {
    id: '7407020018',
    districtId: '7407020',
    name: 'Kollo Soha',
  },
  {
    id: '7407020019',
    districtId: '7407020',
    name: 'Patua II',
  },
  {
    id: '7407021004',
    districtId: '7407021',
    name: 'Patipelong',
  },
  {
    id: '7407021005',
    districtId: '7407021',
    name: 'Tongano Barat',
  },
  {
    id: '7407021006',
    districtId: '7407021',
    name: 'Bahari',
  },
  {
    id: '7407021007',
    districtId: '7407021',
    name: 'Tongano Timur',
  },
  {
    id: '7407021008',
    districtId: '7407021',
    name: 'Timu',
  },
  {
    id: '7407021010',
    districtId: '7407021',
    name: 'Kulati',
  },
  {
    id: '7407021011',
    districtId: '7407021',
    name: 'Wawotimu',
  },
  {
    id: '7407021012',
    districtId: '7407021',
    name: 'Kahianga',
  },
  {
    id: '7407030001',
    districtId: '7407030',
    name: 'Horuo',
  },
  {
    id: '7407030002',
    districtId: '7407030',
    name: 'Sombano',
  },
  {
    id: '7407030003',
    districtId: '7407030',
    name: 'Lau-Lua',
  },
  {
    id: '7407030004',
    districtId: '7407030',
    name: 'Samabahari',
  },
  {
    id: '7407030005',
    districtId: '7407030',
    name: 'Ambeua',
  },
  {
    id: '7407030006',
    districtId: '7407030',
    name: 'Lagiwae',
  },
  {
    id: '7407030007',
    districtId: '7407030',
    name: 'Ollo',
  },
  {
    id: '7407030008',
    districtId: '7407030',
    name: 'Buranga',
  },
  {
    id: '7407030009',
    districtId: '7407030',
    name: 'Balasuna',
  },
  {
    id: '7407030010',
    districtId: '7407030',
    name: 'Mantigola Makmur',
  },
  {
    id: '7407030011',
    districtId: '7407030',
    name: 'Balasuna Selatan',
  },
  {
    id: '7407030012',
    districtId: '7407030',
    name: 'Ollo Selatan',
  },
  {
    id: '7407030013',
    districtId: '7407030',
    name: 'Waduri',
  },
  {
    id: '7407030014',
    districtId: '7407030',
    name: 'Lefuto',
  },
  {
    id: '7407030015',
    districtId: '7407030',
    name: 'Ambeua Raya',
  },
  {
    id: '7407030016',
    districtId: '7407030',
    name: 'Kalimas',
  },
  {
    id: '7407031010',
    districtId: '7407031',
    name: 'Tampara',
  },
  {
    id: '7407031011',
    districtId: '7407031',
    name: 'Kaswari',
  },
  {
    id: '7407031012',
    districtId: '7407031',
    name: 'Pajam',
  },
  {
    id: '7407031013',
    districtId: '7407031',
    name: 'Sandi',
  },
  {
    id: '7407031014',
    districtId: '7407031',
    name: 'Langge',
  },
  {
    id: '7407031015',
    districtId: '7407031',
    name: 'Tanomeha',
  },
  {
    id: '7407031016',
    districtId: '7407031',
    name: 'Lentea',
  },
  {
    id: '7407031017',
    districtId: '7407031',
    name: 'Darawa',
  },
  {
    id: '7407031018',
    districtId: '7407031',
    name: 'Peropa',
  },
  {
    id: '7407031019',
    districtId: '7407031',
    name: 'Tanjung',
  },
  {
    id: '7407040013',
    districtId: '7407040',
    name: 'Pongo',
  },
  {
    id: '7407040014',
    districtId: '7407040',
    name: 'Maleko',
  },
  {
    id: '7407040015',
    districtId: '7407040',
    name: 'Longa',
  },
  {
    id: '7407040016',
    districtId: '7407040',
    name: 'Tindoi',
  },
  {
    id: '7407040017',
    districtId: '7407040',
    name: 'Wanci',
  },
  {
    id: '7407040018',
    districtId: '7407040',
    name: 'Wandoka',
  },
  {
    id: '7407040019',
    districtId: '7407040',
    name: 'Sombu',
  },
  {
    id: '7407040020',
    districtId: '7407040',
    name: 'Waha',
  },
  {
    id: '7407040021',
    districtId: '7407040',
    name: 'Waetuno',
  },
  {
    id: '7407040022',
    districtId: '7407040',
    name: 'Pada Raya Makmur',
  },
  {
    id: '7407040023',
    districtId: '7407040',
    name: 'Waelumu',
  },
  {
    id: '7407040024',
    districtId: '7407040',
    name: 'Patuno',
  },
  {
    id: '7407040025',
    districtId: '7407040',
    name: 'Wandoka Utara',
  },
  {
    id: '7407040026',
    districtId: '7407040',
    name: 'Wandoka Selatan',
  },
  {
    id: '7407040027',
    districtId: '7407040',
    name: 'Waginopo',
  },
  {
    id: '7407040028',
    districtId: '7407040',
    name: 'Tindoi Timur',
  },
  {
    id: '7407040029',
    districtId: '7407040',
    name: 'Posalu',
  },
  {
    id: '7407040030',
    districtId: '7407040',
    name: 'Koroe Onawa',
  },
  {
    id: '7407040031',
    districtId: '7407040',
    name: 'Wapia Pia',
  },
  {
    id: '7407040032',
    districtId: '7407040',
    name: 'Pookambua',
  },
  {
    id: '7407050001',
    districtId: '7407050',
    name: 'Kapota',
  },
  {
    id: '7407050002',
    districtId: '7407050',
    name: 'Kabita',
  },
  {
    id: '7407050003',
    districtId: '7407050',
    name: 'Liya Mawi',
  },
  {
    id: '7407050004',
    districtId: '7407050',
    name: 'Liya Togo',
  },
  {
    id: '7407050005',
    districtId: '7407050',
    name: 'Matahora',
  },
  {
    id: '7407050006',
    districtId: '7407050',
    name: 'Wungka',
  },
  {
    id: '7407050007',
    districtId: '7407050',
    name: 'Numana',
  },
  {
    id: '7407050008',
    districtId: '7407050',
    name: 'Mola Selatan',
  },
  {
    id: '7407050009',
    districtId: '7407050',
    name: 'Mola Utara',
  },
  {
    id: '7407050010',
    districtId: '7407050',
    name: 'Mandati I',
  },
  {
    id: '7407050011',
    districtId: '7407050',
    name: 'Komala',
  },
  {
    id: '7407050012',
    districtId: '7407050',
    name: 'Mandati II',
  },
  {
    id: '7407050013',
    districtId: '7407050',
    name: 'Kapota Utara',
  },
  {
    id: '7407050014',
    districtId: '7407050',
    name: 'Kabita Togo',
  },
  {
    id: '7407050015',
    districtId: '7407050',
    name: 'Mandati III',
  },
  {
    id: '7407050016',
    districtId: '7407050',
    name: 'Liya One Melangka',
  },
  {
    id: '7407050017',
    districtId: '7407050',
    name: 'Wisata Kolo',
  },
  {
    id: '7407050018',
    districtId: '7407050',
    name: 'Mola Samaturu',
  },
  {
    id: '7407050019',
    districtId: '7407050',
    name: 'Mola Bahari',
  },
  {
    id: '7407050020',
    districtId: '7407050',
    name: 'Mola Nelayan Bakti',
  },
  {
    id: '7407050021',
    districtId: '7407050',
    name: 'Liya Bahari Indah',
  },
  {
    id: '7408010005',
    districtId: '7408010',
    name: 'Rante Baru',
  },
  {
    id: '7408010006',
    districtId: '7408010',
    name: 'Ranteangin',
  },
  {
    id: '7408010007',
    districtId: '7408010',
    name: 'Pohu',
  },
  {
    id: '7408010008',
    districtId: '7408010',
    name: 'Torotuo',
  },
  {
    id: '7408010016',
    districtId: '7408010',
    name: 'Lawekara',
  },
  {
    id: '7408010017',
    districtId: '7408010',
    name: 'Landolia',
  },
  {
    id: '7408010018',
    districtId: '7408010',
    name: 'Maroko',
  },
  {
    id: '7408011001',
    districtId: '7408011',
    name: 'Lapasi-Pasi',
  },
  {
    id: '7408011002',
    districtId: '7408011',
    name: 'Lambai',
  },
  {
    id: '7408011003',
    districtId: '7408011',
    name: 'Latawaro',
  },
  {
    id: '7408011004',
    districtId: '7408011',
    name: 'Raoda',
  },
  {
    id: '7408011005',
    districtId: '7408011',
    name: 'Woise',
  },
  {
    id: '7408011006',
    districtId: '7408011',
    name: 'Woitombo',
  },
  {
    id: '7408011007',
    districtId: '7408011',
    name: 'Tebongeano',
  },
  {
    id: '7408012001',
    districtId: '7408012',
    name: 'Walasiho',
  },
  {
    id: '7408012002',
    districtId: '7408012',
    name: 'Wawo',
  },
  {
    id: '7408012003',
    districtId: '7408012',
    name: 'Puumbolo',
  },
  {
    id: '7408012004',
    districtId: '7408012',
    name: 'Tinukari',
  },
  {
    id: '7408012005',
    districtId: '7408012',
    name: 'Salurengko',
  },
  {
    id: '7408012006',
    districtId: '7408012',
    name: 'Uluwawo',
  },
  {
    id: '7408012007',
    districtId: '7408012',
    name: 'Latawe',
  },
  {
    id: '7408020012',
    districtId: '7408020',
    name: 'Sulaho',
  },
  {
    id: '7408020013',
    districtId: '7408020',
    name: 'Totallang',
  },
  {
    id: '7408020014',
    districtId: '7408020',
    name: 'Pitulua',
  },
  {
    id: '7408020015',
    districtId: '7408020',
    name: 'Rante Limbong',
  },
  {
    id: '7408020016',
    districtId: '7408020',
    name: 'Tojabi',
  },
  {
    id: '7408020017',
    districtId: '7408020',
    name: 'Lasusua',
  },
  {
    id: '7408020018',
    districtId: '7408020',
    name: 'Watuliu',
  },
  {
    id: '7408020019',
    districtId: '7408020',
    name: 'Ponggiha',
  },
  {
    id: '7408020026',
    districtId: '7408020',
    name: 'Patowonua',
  },
  {
    id: '7408020027',
    districtId: '7408020',
    name: 'Babussalam',
  },
  {
    id: '7408020028',
    districtId: '7408020',
    name: 'Batuganda Permai',
  },
  {
    id: '7408020029',
    districtId: '7408020',
    name: 'Puncak Monapa',
  },
  {
    id: '7408021001',
    districtId: '7408021',
    name: 'Ujung Tobaku',
  },
  {
    id: '7408021002',
    districtId: '7408021',
    name: 'Katoi',
  },
  {
    id: '7408021003',
    districtId: '7408021',
    name: 'Simbula',
  },
  {
    id: '7408021004',
    districtId: '7408021',
    name: 'Maruge',
  },
  {
    id: '7408021005',
    districtId: '7408021',
    name: 'Lanipa-Nipa',
  },
  {
    id: '7408021006',
    districtId: '7408021',
    name: 'Lambuno',
  },
  {
    id: '7408030001',
    districtId: '7408030',
    name: 'Kalu Kaluku',
  },
  {
    id: '7408030002',
    districtId: '7408030',
    name: 'Awo',
  },
  {
    id: '7408030003',
    districtId: '7408030',
    name: 'Lametuna',
  },
  {
    id: '7408030004',
    districtId: '7408030',
    name: 'Mala Mala',
  },
  {
    id: '7408030005',
    districtId: '7408030',
    name: 'Jabal Nur',
  },
  {
    id: '7408030006',
    districtId: '7408030',
    name: 'Koroha',
  },
  {
    id: '7408030007',
    districtId: '7408030',
    name: 'Jabal Kubis',
  },
  {
    id: '7408030008',
    districtId: '7408030',
    name: 'Kamisi',
  },
  {
    id: '7408030009',
    districtId: '7408030',
    name: 'Meeto',
  },
  {
    id: '7408030014',
    districtId: '7408030',
    name: 'Sawangaoha',
  },
  {
    id: '7408030017',
    districtId: '7408030',
    name: 'Delang-Delang',
  },
  {
    id: '7408030018',
    districtId: '7408030',
    name: 'Ainani Tajriani',
  },
  {
    id: '7408031001',
    districtId: '7408031',
    name: 'Mattiro Bulu',
  },
  {
    id: '7408031002',
    districtId: '7408031',
    name: 'Lawadia',
  },
  {
    id: '7408031003',
    districtId: '7408031',
    name: 'Watumea',
  },
  {
    id: '7408031004',
    districtId: '7408031',
    name: 'Tiwu',
  },
  {
    id: '7408031005',
    districtId: '7408031',
    name: 'Tahibua',
  },
  {
    id: '7408031006',
    districtId: '7408031',
    name: 'Lapolu',
  },
  {
    id: '7408031007',
    districtId: '7408031',
    name: 'Tanggeao',
  },
  {
    id: '7408040003',
    districtId: '7408040',
    name: 'Ngapa',
  },
  {
    id: '7408040004',
    districtId: '7408040',
    name: 'Tadoumera',
  },
  {
    id: '7408040005',
    districtId: '7408040',
    name: 'Lapai',
  },
  {
    id: '7408040006',
    districtId: '7408040',
    name: 'Koreiha',
  },
  {
    id: '7408040007',
    districtId: '7408040',
    name: 'Lawolatu',
  },
  {
    id: '7408040011',
    districtId: '7408040',
    name: 'Puurau',
  },
  {
    id: '7408040014',
    districtId: '7408040',
    name: 'Parutellang',
  },
  {
    id: '7408040015',
    districtId: '7408040',
    name: 'Watu Mutaha',
  },
  {
    id: '7408040016',
    districtId: '7408040',
    name: 'Beringin',
  },
  {
    id: '7408040017',
    districtId: '7408040',
    name: 'Padaelo',
  },
  {
    id: '7408040018',
    districtId: '7408040',
    name: 'Nimbuneha',
  },
  {
    id: '7408040019',
    districtId: '7408040',
    name: 'Mataiwoi',
  },
  {
    id: '7408041001',
    districtId: '7408041',
    name: 'Sapoiha',
  },
  {
    id: '7408041002',
    districtId: '7408041',
    name: 'Watunohu',
  },
  {
    id: '7408041003',
    districtId: '7408041',
    name: 'Lahabaru',
  },
  {
    id: '7408041004',
    districtId: '7408041',
    name: 'Sarona',
  },
  {
    id: '7408041005',
    districtId: '7408041',
    name: 'Tambuha',
  },
  {
    id: '7408041007',
    districtId: '7408041',
    name: 'Samaturu',
  },
  {
    id: '7408041008',
    districtId: '7408041',
    name: 'Lelehao',
  },
  {
    id: '7408050012',
    districtId: '7408050',
    name: 'Lalombundi',
  },
  {
    id: '7408050013',
    districtId: '7408050',
    name: 'Toaha',
  },
  {
    id: '7408050014',
    districtId: '7408050',
    name: 'Kasumeeto',
  },
  {
    id: '7408050015',
    districtId: '7408050',
    name: 'Kosali',
  },
  {
    id: '7408050016',
    districtId: '7408050',
    name: 'Mikuasi',
  },
  {
    id: '7408050017',
    districtId: '7408050',
    name: 'Olo Oloho',
  },
  {
    id: '7408050028',
    districtId: '7408050',
    name: 'Kondara',
  },
  {
    id: '7408050035',
    districtId: '7408050',
    name: 'Sipakainge',
  },
  {
    id: '7408050036',
    districtId: '7408050',
    name: 'Seuwwa',
  },
  {
    id: '7408050037',
    districtId: '7408050',
    name: 'Alipato',
  },
  {
    id: '7408050038',
    districtId: '7408050',
    name: 'Lalume',
  },
  {
    id: '7408051001',
    districtId: '7408051',
    name: 'Teposua',
  },
  {
    id: '7408051002',
    districtId: '7408051',
    name: 'Pakue',
  },
  {
    id: '7408051003',
    districtId: '7408051',
    name: 'Mataleuno',
  },
  {
    id: '7408051004',
    districtId: '7408051',
    name: 'Puundoho',
  },
  {
    id: '7408051005',
    districtId: '7408051',
    name: 'Lawata',
  },
  {
    id: '7408051006',
    districtId: '7408051',
    name: 'Amowe',
  },
  {
    id: '7408051007',
    districtId: '7408051',
    name: 'Kalo',
  },
  {
    id: '7408051008',
    districtId: '7408051',
    name: 'Salu Dongka',
  },
  {
    id: '7408051009',
    districtId: '7408051',
    name: 'Lengkong Batu',
  },
  {
    id: '7408052001',
    districtId: '7408052',
    name: 'Pasampang',
  },
  {
    id: '7408052002',
    districtId: '7408052',
    name: 'Labipi',
  },
  {
    id: '7408052003',
    districtId: '7408052',
    name: 'Lanipa',
  },
  {
    id: '7408052004',
    districtId: '7408052',
    name: 'Majapahit',
  },
  {
    id: '7408052005',
    districtId: '7408052',
    name: 'Latali',
  },
  {
    id: '7408052006',
    districtId: '7408052',
    name: 'Terengga',
  },
  {
    id: '7408052007',
    districtId: '7408052',
    name: 'Powalaa',
  },
  {
    id: '7408052008',
    districtId: '7408052',
    name: "To'Lemo",
  },
  {
    id: '7408052009',
    districtId: '7408052',
    name: 'Salulotong',
  },
  {
    id: '7408052010',
    districtId: '7408052',
    name: 'Kalahunde',
  },
  {
    id: '7408060001',
    districtId: '7408060',
    name: 'Latowu',
  },
  {
    id: '7408060002',
    districtId: '7408060',
    name: 'Batu Api',
  },
  {
    id: '7408060003',
    districtId: '7408060',
    name: 'Bukit Tinggi',
  },
  {
    id: '7408060004',
    districtId: '7408060',
    name: 'Batu Putih',
  },
  {
    id: '7408060006',
    districtId: '7408060',
    name: 'Mosiku',
  },
  {
    id: '7408060007',
    districtId: '7408060',
    name: 'Lelewawo',
  },
  {
    id: '7408060015',
    districtId: '7408060',
    name: 'Paru Lampe',
  },
  {
    id: '7408060016',
    districtId: '7408060',
    name: 'Bukit Baru',
  },
  {
    id: '7408060017',
    districtId: '7408060',
    name: 'Puncak Harapan',
  },
  {
    id: '7408060018',
    districtId: '7408060',
    name: 'Makkuaseng',
  },
  {
    id: '7408060019',
    districtId: '7408060',
    name: 'Tetebawo',
  },
  {
    id: '7408061001',
    districtId: '7408061',
    name: 'Tobela',
  },
  {
    id: '7408061002',
    districtId: '7408061',
    name: 'Tangga Ruru',
  },
  {
    id: '7408061003',
    districtId: '7408061',
    name: 'Porehu',
  },
  {
    id: '7408061004',
    districtId: '7408061',
    name: 'Ponggi',
  },
  {
    id: '7408061005',
    districtId: '7408061',
    name: 'Larui',
  },
  {
    id: '7408061006',
    districtId: '7408061',
    name: 'Bangsala',
  },
  {
    id: '7408061007',
    districtId: '7408061',
    name: 'Sarambu',
  },
  {
    id: '7408061008',
    districtId: '7408061',
    name: 'Tinuna',
  },
  {
    id: '7408062001',
    districtId: '7408062',
    name: 'Lawaki Jaya',
  },
  {
    id: '7408062002',
    districtId: '7408062',
    name: 'Patikala',
  },
  {
    id: '7408062003',
    districtId: '7408062',
    name: 'Tolala',
  },
  {
    id: '7408062004',
    districtId: '7408062',
    name: 'Bahari',
  },
  {
    id: '7408062006',
    districtId: '7408062',
    name: 'Loka',
  },
  {
    id: '7409100009',
    districtId: '7409100',
    name: 'Bonegunu(Kioko)',
  },
  {
    id: '7409100010',
    districtId: '7409100',
    name: 'Laanoipi',
  },
  {
    id: '7409100011',
    districtId: '7409100',
    name: 'Waode Kalowo',
  },
  {
    id: '7409100012',
    districtId: '7409100',
    name: 'Buranga',
  },
  {
    id: '7409100013',
    districtId: '7409100',
    name: 'Een Sumala',
  },
  {
    id: '7409100014',
    districtId: '7409100',
    name: 'Waode Angkalo',
  },
  {
    id: '7409100015',
    districtId: '7409100',
    name: 'Gunung Sari',
  },
  {
    id: '7409100016',
    districtId: '7409100',
    name: 'Ronta',
  },
  {
    id: '7409100017',
    districtId: '7409100',
    name: 'Koepisino',
  },
  {
    id: '7409100018',
    districtId: '7409100',
    name: 'Langere',
  },
  {
    id: '7409100019',
    districtId: '7409100',
    name: 'Koboruno',
  },
  {
    id: '7409100020',
    districtId: '7409100',
    name: 'Damai Laborona',
  },
  {
    id: '7409100021',
    districtId: '7409100',
    name: 'Totombuli',
  },
  {
    id: '7409100022',
    districtId: '7409100',
    name: 'Ngapaea',
  },
  {
    id: '7409100023',
    districtId: '7409100',
    name: 'Rante Gola',
  },
  {
    id: '7409101001',
    districtId: '7409101',
    name: 'M A T A',
  },
  {
    id: '7409101002',
    districtId: '7409101',
    name: 'Konde',
  },
  {
    id: '7409101003',
    districtId: '7409101',
    name: 'Lagundi',
  },
  {
    id: '7409101004',
    districtId: '7409101',
    name: 'Pongkowulu',
  },
  {
    id: '7409101005',
    districtId: '7409101',
    name: 'Kambowa',
  },
  {
    id: '7409101006',
    districtId: '7409101',
    name: 'Morindino',
  },
  {
    id: '7409101007',
    districtId: '7409101',
    name: 'Lahumoko(Tri Mulya)',
  },
  {
    id: '7409101010',
    districtId: '7409101',
    name: 'Baluara',
  },
  {
    id: '7409101011',
    districtId: '7409101',
    name: 'Bubu Barat',
  },
  {
    id: '7409110010',
    districtId: '7409110',
    name: 'Matalagi',
  },
  {
    id: '7409110011',
    districtId: '7409110',
    name: 'Laeya',
  },
  {
    id: '7409110012',
    districtId: '7409110',
    name: 'Labaraga',
  },
  {
    id: '7409110013',
    districtId: '7409110',
    name: 'Lasiwa',
  },
  {
    id: '7409110014',
    districtId: '7409110',
    name: 'Labuan Bajo',
  },
  {
    id: '7409110015',
    districtId: '7409110',
    name: 'Labuan Wolio',
  },
  {
    id: '7409110016',
    districtId: '7409110',
    name: 'Labuan',
  },
  {
    id: '7409110017',
    districtId: '7409110',
    name: 'Wantulasi',
  },
  {
    id: '7409110018',
    districtId: '7409110',
    name: 'Laba Jaya',
  },
  {
    id: '7409110019',
    districtId: '7409110',
    name: 'Sumampeno',
  },
  {
    id: '7409110020',
    districtId: '7409110',
    name: 'Labuko',
  },
  {
    id: '7409110021',
    districtId: '7409110',
    name: 'Wamorapa',
  },
  {
    id: '7409110022',
    districtId: '7409110',
    name: 'Oengkapala',
  },
  {
    id: '7409110023',
    districtId: '7409110',
    name: 'UPT Laeya',
  },
  {
    id: '7409120001',
    districtId: '7409120',
    name: 'Bonelipu',
  },
  {
    id: '7409120002',
    districtId: '7409120',
    name: 'Lemo',
  },
  {
    id: '7409120003',
    districtId: '7409120',
    name: 'R O M B O',
  },
  {
    id: '7409120004',
    districtId: '7409120',
    name: 'Linsowu',
  },
  {
    id: '7409120005',
    districtId: '7409120',
    name: 'Lakonea',
  },
  {
    id: '7409120006',
    districtId: '7409120',
    name: 'Lipu',
  },
  {
    id: '7409120007',
    districtId: '7409120',
    name: 'Bangkudu',
  },
  {
    id: '7409120008',
    districtId: '7409120',
    name: 'L O J I',
  },
  {
    id: '7409120009',
    districtId: '7409120',
    name: 'Kalibu',
  },
  {
    id: '7409120010',
    districtId: '7409120',
    name: 'Eelahaji',
  },
  {
    id: '7409120011',
    districtId: '7409120',
    name: 'Jampaka',
  },
  {
    id: '7409120012',
    districtId: '7409120',
    name: 'Tomoahi',
  },
  {
    id: '7409120017',
    districtId: '7409120',
    name: 'Waculaea',
  },
  {
    id: '7409120018',
    districtId: '7409120',
    name: 'Tri Wacu-Wacu',
  },
  {
    id: '7409120019',
    districtId: '7409120',
    name: 'Malalanda',
  },
  {
    id: '7409120020',
    districtId: '7409120',
    name: 'Lantagi',
  },
  {
    id: '7409120021',
    districtId: '7409120',
    name: 'Lemo Ea',
  },
  {
    id: '7409120022',
    districtId: '7409120',
    name: 'Wasalabose',
  },
  {
    id: '7409120023',
    districtId: '7409120',
    name: 'Banu-Banua Jaya',
  },
  {
    id: '7409120024',
    districtId: '7409120',
    name: 'Wandaka',
  },
  {
    id: '7409120025',
    districtId: '7409120',
    name: 'Saraea',
  },
  {
    id: '7409120026',
    districtId: '7409120',
    name: 'Kadacua',
  },
  {
    id: '7409120027',
    districtId: '7409120',
    name: 'Laangke',
  },
  {
    id: '7409121001',
    districtId: '7409121',
    name: 'Rahmat Baru',
  },
  {
    id: '7409121002',
    districtId: '7409121',
    name: 'Soloy Agung',
  },
  {
    id: '7409121003',
    districtId: '7409121',
    name: 'Kotawo',
  },
  {
    id: '7409121004',
    districtId: '7409121',
    name: 'Bumi Lapero',
  },
  {
    id: '7409121005',
    districtId: '7409121',
    name: 'Dampala Jaya',
  },
  {
    id: '7409121006',
    districtId: '7409121',
    name: 'Kasulatombi',
  },
  {
    id: '7409121007',
    districtId: '7409121',
    name: 'Karya Bakti',
  },
  {
    id: '7409121008',
    districtId: '7409121',
    name: 'Marga Karya',
  },
  {
    id: '7409121009',
    districtId: '7409121',
    name: 'Lauki',
  },
  {
    id: '7409121010',
    districtId: '7409121',
    name: 'Lambale',
  },
  {
    id: '7409121011',
    districtId: '7409121',
    name: 'Mekar Jaya',
  },
  {
    id: '7409121012',
    districtId: '7409121',
    name: 'Labulanda',
  },
  {
    id: '7409121013',
    districtId: '7409121',
    name: 'Lapandewa',
  },
  {
    id: '7409121015',
    districtId: '7409121',
    name: 'Karya Mulia',
  },
  {
    id: '7409122001',
    districtId: '7409122',
    name: 'Ulunambo',
  },
  {
    id: '7409122002',
    districtId: '7409122',
    name: 'Waode Buri',
  },
  {
    id: '7409122003',
    districtId: '7409122',
    name: 'Lelamo',
  },
  {
    id: '7409122004',
    districtId: '7409122',
    name: 'Peteteaa',
  },
  {
    id: '7409122005',
    districtId: '7409122',
    name: 'Pebaoa',
  },
  {
    id: '7409122006',
    districtId: '7409122',
    name: 'Lanosangia',
  },
  {
    id: '7409122007',
    districtId: '7409122',
    name: 'Lamoahi',
  },
  {
    id: '7409122008',
    districtId: '7409122',
    name: 'Torumbia',
  },
  {
    id: '7409122009',
    districtId: '7409122',
    name: 'Kurolabu',
  },
  {
    id: '7409122010',
    districtId: '7409122',
    name: 'Eerinere',
  },
  {
    id: '7409122011',
    districtId: '7409122',
    name: 'Wamboule',
  },
  {
    id: '7409122013',
    districtId: '7409122',
    name: 'Labelete',
  },
  {
    id: '7409122014',
    districtId: '7409122',
    name: 'Wowonga Jaya',
  },
  {
    id: '7409122015',
    districtId: '7409122',
    name: 'Bira',
  },
  {
    id: '7410010006',
    districtId: '7410010',
    name: 'Kokapi',
  },
  {
    id: '7410010007',
    districtId: '7410010',
    name: 'Matanggonawe',
  },
  {
    id: '7410010008',
    districtId: '7410010',
    name: 'Pudonggala',
  },
  {
    id: '7410010009',
    districtId: '7410010',
    name: 'Tongauna',
  },
  {
    id: '7410010010',
    districtId: '7410010',
    name: 'Sawa',
  },
  {
    id: '7410010011',
    districtId: '7410010',
    name: 'Laimeo',
  },
  {
    id: '7410010012',
    districtId: '7410010',
    name: 'Lalembo',
  },
  {
    id: '7410010013',
    districtId: '7410010',
    name: 'Puupi',
  },
  {
    id: '7410010030',
    districtId: '7410010',
    name: 'Puudonggala Utama',
  },
  {
    id: '7410010031',
    districtId: '7410010',
    name: 'Ulusawa',
  },
  {
    id: '7410010032',
    districtId: '7410010',
    name: 'Pekaroa',
  },
  {
    id: '7410010033',
    districtId: '7410010',
    name: 'Panggulawu',
  },
  {
    id: '7410010034',
    districtId: '7410010',
    name: 'Tundungano',
  },
  {
    id: '7410010035',
    districtId: '7410010',
    name: 'Tanjung Laimeo',
  },
  {
    id: '7410011001',
    districtId: '7410011',
    name: 'Tondowatu',
  },
  {
    id: '7410011002',
    districtId: '7410011',
    name: 'Kapolano',
  },
  {
    id: '7410011003',
    districtId: '7410011',
    name: 'Tobimeita',
  },
  {
    id: '7410011004',
    districtId: '7410011',
    name: 'Poni-Poniki',
  },
  {
    id: '7410011005',
    districtId: '7410011',
    name: 'Matandahi',
  },
  {
    id: '7410011006',
    districtId: '7410011',
    name: 'Banggina',
  },
  {
    id: '7410011007',
    districtId: '7410011',
    name: 'Lambuluo',
  },
  {
    id: '7410011008',
    districtId: '7410011',
    name: 'Motui',
  },
  {
    id: '7410011009',
    districtId: '7410011',
    name: 'Puuwonggia',
  },
  {
    id: '7410011010',
    districtId: '7410011',
    name: 'Wawoluri',
  },
  {
    id: '7410011011',
    districtId: '7410011',
    name: 'UPT. Tondowatu',
  },
  {
    id: '7410011013',
    districtId: '7410011',
    name: 'Sama Subur',
  },
  {
    id: '7410011014',
    districtId: '7410011',
    name: 'Ranombupulu',
  },
  {
    id: '7410011015',
    districtId: '7410011',
    name: 'Sambasule',
  },
  {
    id: '7410020001',
    districtId: '7410020',
    name: 'Tongalino',
  },
  {
    id: '7410020002',
    districtId: '7410020',
    name: 'Taipa',
  },
  {
    id: '7410020003',
    districtId: '7410020',
    name: 'Puusiambu',
  },
  {
    id: '7410020004',
    districtId: '7410020',
    name: 'Bungguosu',
  },
  {
    id: '7410020005',
    districtId: '7410020',
    name: 'Lembo',
  },
  {
    id: '7410020006',
    districtId: '7410020',
    name: 'Pasir Putih',
  },
  {
    id: '7410020007',
    districtId: '7410020',
    name: 'Padaleu',
  },
  {
    id: '7410020008',
    districtId: '7410020',
    name: 'Puulemo',
  },
  {
    id: '7410020009',
    districtId: '7410020',
    name: 'Alo-Alo',
  },
  {
    id: '7410020010',
    districtId: '7410020',
    name: 'Lapulu',
  },
  {
    id: '7410020011',
    districtId: '7410020',
    name: 'Laramo',
  },
  {
    id: '7410020012',
    districtId: '7410020',
    name: 'Watu Wulaa',
  },
  {
    id: '7410030027',
    districtId: '7410030',
    name: 'Abola',
  },
  {
    id: '7410030028',
    districtId: '7410030',
    name: 'Belalo',
  },
  {
    id: '7410030029',
    districtId: '7410030',
    name: 'Andeo',
  },
  {
    id: '7410030030',
    districtId: '7410030',
    name: 'Matapila',
  },
  {
    id: '7410030031',
    districtId: '7410030',
    name: 'Lametono',
  },
  {
    id: '7410030032',
    districtId: '7410030',
    name: 'Andumowu',
  },
  {
    id: '7410030033',
    districtId: '7410030',
    name: 'Basule',
  },
  {
    id: '7410030034',
    districtId: '7410030',
    name: 'T I N O B U',
  },
  {
    id: '7410030035',
    districtId: '7410030',
    name: 'Waworaha',
  },
  {
    id: '7410030036',
    districtId: '7410030',
    name: 'Otole',
  },
  {
    id: '7410030037',
    districtId: '7410030',
    name: 'Watukila',
  },
  {
    id: '7410030048',
    districtId: '7410030',
    name: 'Larodangge',
  },
  {
    id: '7410030053',
    districtId: '7410030',
    name: 'Tetelupai',
  },
  {
    id: '7410030054',
    districtId: '7410030',
    name: 'Lalowaru',
  },
  {
    id: '7410030055',
    districtId: '7410030',
    name: 'Muara Tinobu',
  },
  {
    id: '7410031001',
    districtId: '7410031',
    name: 'Tanjung Bunga',
  },
  {
    id: '7410031002',
    districtId: '7410031',
    name: 'Kampobunga',
  },
  {
    id: '7410031003',
    districtId: '7410031',
    name: 'Lemobajo',
  },
  {
    id: '7410031004',
    districtId: '7410031',
    name: 'Wawolesea',
  },
  {
    id: '7410031005',
    districtId: '7410031',
    name: 'Toreo',
  },
  {
    id: '7410031006',
    districtId: '7410031',
    name: 'Barasanga',
  },
  {
    id: '7410031007',
    districtId: '7410031',
    name: 'Otipulu',
  },
  {
    id: '7410031008',
    districtId: '7410031',
    name: 'Kampoh Cina',
  },
  {
    id: '7410031009',
    districtId: '7410031',
    name: 'Tokowuta',
  },
  {
    id: '7410032001',
    districtId: '7410032',
    name: 'Boenaga',
  },
  {
    id: '7410032002',
    districtId: '7410032',
    name: 'Waturambaha',
  },
  {
    id: '7410032003',
    districtId: '7410032',
    name: 'Labengi',
  },
  {
    id: '7410032004',
    districtId: '7410032',
    name: 'Morombo',
  },
  {
    id: '7410032005',
    districtId: '7410032',
    name: 'Tapunopaka',
  },
  {
    id: '7410032006',
    districtId: '7410032',
    name: 'Boedingi',
  },
  {
    id: '7410040001',
    districtId: '7410040',
    name: 'Mataiwoi',
  },
  {
    id: '7410040002',
    districtId: '7410040',
    name: 'Bandaeha',
  },
  {
    id: '7410040003',
    districtId: '7410040',
    name: 'Molawe',
  },
  {
    id: '7410040004',
    districtId: '7410040',
    name: 'Awila',
  },
  {
    id: '7410040005',
    districtId: '7410040',
    name: 'Mowundo',
  },
  {
    id: '7410040006',
    districtId: '7410040',
    name: 'Mandiodo',
  },
  {
    id: '7410040007',
    districtId: '7410040',
    name: 'Tapunggaya',
  },
  {
    id: '7410040008',
    districtId: '7410040',
    name: 'Awila Puncak',
  },
  {
    id: '7410040009',
    districtId: '7410040',
    name: 'Tapuemea',
  },
  {
    id: '7410050008',
    districtId: '7410050',
    name: 'Wanggudu',
  },
  {
    id: '7410050009',
    districtId: '7410050',
    name: 'Tangguluri',
  },
  {
    id: '7410050010',
    districtId: '7410050',
    name: 'Wunduhaka',
  },
  {
    id: '7410050011',
    districtId: '7410050',
    name: 'Wanggudu Raya',
  },
  {
    id: '7410050012',
    districtId: '7410050',
    name: 'Walalindu',
  },
  {
    id: '7410050013',
    districtId: '7410050',
    name: 'Tapuwatu',
  },
  {
    id: '7410050014',
    districtId: '7410050',
    name: 'Walasolo',
  },
  {
    id: '7410050015',
    districtId: '7410050',
    name: 'A S E R A',
  },
  {
    id: '7410050016',
    districtId: '7410050',
    name: 'Amorome',
  },
  {
    id: '7410050017',
    districtId: '7410050',
    name: 'Asemi Nunulai',
  },
  {
    id: '7410050018',
    districtId: '7410050',
    name: 'Wawolimbue',
  },
  {
    id: '7410050049',
    districtId: '7410050',
    name: 'Longeo Utama',
  },
  {
    id: '7410050050',
    districtId: '7410050',
    name: 'Puunggomosi',
  },
  {
    id: '7410050051',
    districtId: '7410050',
    name: 'Puuwanggudu',
  },
  {
    id: '7410050052',
    districtId: '7410050',
    name: 'Kota Mulia',
  },
  {
    id: '7410050053',
    districtId: '7410050',
    name: 'Amorome Utama',
  },
  {
    id: '7410050054',
    districtId: '7410050',
    name: 'Oheo Trans',
  },
  {
    id: '7410050055',
    districtId: '7410050',
    name: 'Ala Wanggudu',
  },
  {
    id: '7410050056',
    districtId: '7410050',
    name: 'Andedao',
  },
  {
    id: '7410051001',
    districtId: '7410051',
    name: 'Banggarema',
  },
  {
    id: '7410051002',
    districtId: '7410051',
    name: 'Lahimbua',
  },
  {
    id: '7410051003',
    districtId: '7410051',
    name: 'Lamondowo',
  },
  {
    id: '7410051004',
    districtId: '7410051',
    name: 'Andowia',
  },
  {
    id: '7410051005',
    districtId: '7410051',
    name: 'Puusuli',
  },
  {
    id: '7410051006',
    districtId: '7410051',
    name: 'Laronanga',
  },
  {
    id: '7410051007',
    districtId: '7410051',
    name: 'Labungga',
  },
  {
    id: '7410051008',
    districtId: '7410051',
    name: 'Puuwonua',
  },
  {
    id: '7410051009',
    districtId: '7410051',
    name: 'Anggolohipo',
  },
  {
    id: '7410051010',
    districtId: '7410051',
    name: 'Larobende',
  },
  {
    id: '7410051012',
    districtId: '7410051',
    name: 'Lambudoni',
  },
  {
    id: '7410051013',
    districtId: '7410051',
    name: 'Mata Iwoi',
  },
  {
    id: '7410051021',
    districtId: '7410051',
    name: 'Amolame',
  },
  {
    id: '7410051022',
    districtId: '7410051',
    name: 'Waworate',
  },
  {
    id: '7410051023',
    districtId: '7410051',
    name: 'Ambake',
  },
  {
    id: '7410052001',
    districtId: '7410052',
    name: 'Laroonaha',
  },
  {
    id: '7410052002',
    districtId: '7410052',
    name: 'Bandaeha',
  },
  {
    id: '7410052003',
    districtId: '7410052',
    name: 'Kota Maju',
  },
  {
    id: '7410052004',
    districtId: '7410052',
    name: 'Lameoru',
  },
  {
    id: '7410052005',
    districtId: '7410052',
    name: 'Landawe',
  },
  {
    id: '7410052006',
    districtId: '7410052',
    name: 'Walandawe',
  },
  {
    id: '7410052007',
    districtId: '7410052',
    name: 'Wiwirano',
  },
  {
    id: '7410052008',
    districtId: '7410052',
    name: 'Mopute',
  },
  {
    id: '7410052009',
    districtId: '7410052',
    name: 'Todoloiyo',
  },
  {
    id: '7410052010',
    districtId: '7410052',
    name: 'Puuhialu',
  },
  {
    id: '7410052011',
    districtId: '7410052',
    name: 'Linomoiyo',
  },
  {
    id: '7410052012',
    districtId: '7410052',
    name: 'Bende Wuta',
  },
  {
    id: '7410052013',
    districtId: '7410052',
    name: 'Todoloiyo Trans',
  },
  {
    id: '7410052014',
    districtId: '7410052',
    name: 'Sambandete',
  },
  {
    id: '7410052015',
    districtId: '7410052',
    name: 'Paka Indah',
  },
  {
    id: '7410052016',
    districtId: '7410052',
    name: 'Tinondo',
  },
  {
    id: '7410052017',
    districtId: '7410052',
    name: 'Horoe',
  },
  {
    id: '7410060001',
    districtId: '7410060',
    name: 'Sari Mukti (UPT.Hialu IV)',
  },
  {
    id: '7410060002',
    districtId: '7410060',
    name: 'Langgi Kima (UPT.Hialu III)',
  },
  {
    id: '7410060003',
    districtId: '7410060',
    name: 'Molore',
  },
  {
    id: '7410060004',
    districtId: '7410060',
    name: 'Lameruru',
  },
  {
    id: '7410060005',
    districtId: '7410060',
    name: 'UPT.Morombo/Tobimeita',
  },
  {
    id: '7410060006',
    districtId: '7410060',
    name: 'Pariama',
  },
  {
    id: '7410060007',
    districtId: '7410060',
    name: 'Polora Indah',
  },
  {
    id: '7410060008',
    districtId: '7410060',
    name: 'Alenggo',
  },
  {
    id: '7410060009',
    districtId: '7410060',
    name: 'Mekar Jaya',
  },
  {
    id: '7410060010',
    districtId: '7410060',
    name: 'Molore Pantai',
  },
  {
    id: '7410060011',
    districtId: '7410060',
    name: 'Ngapainia',
  },
  {
    id: '7410060012',
    districtId: '7410060',
    name: 'Morombo Pantai',
  },
  {
    id: '7410070003',
    districtId: '7410070',
    name: 'Wawoheo',
  },
  {
    id: '7410070005',
    districtId: '7410070',
    name: 'Lamonae',
  },
  {
    id: '7410070006',
    districtId: '7410070',
    name: 'Padalere',
  },
  {
    id: '7410070007',
    districtId: '7410070',
    name: 'Culambatu (UPT.Lamonae III)',
  },
  {
    id: '7410070008',
    districtId: '7410070',
    name: 'Lamparinga (UPT Padalere)',
  },
  {
    id: '7410070009',
    districtId: '7410070',
    name: 'Tetewatu',
  },
  {
    id: '7410070018',
    districtId: '7410070',
    name: 'Wacu Malewe',
  },
  {
    id: '7410070019',
    districtId: '7410070',
    name: 'Lamonae Utama',
  },
  {
    id: '7410070020',
    districtId: '7410070',
    name: 'Mata Osole',
  },
  {
    id: '7410070021',
    districtId: '7410070',
    name: 'Lalomerui',
  },
  {
    id: '7410070022',
    districtId: '7410070',
    name: 'Pondoa',
  },
  {
    id: '7410070023',
    districtId: '7410070',
    name: 'Wawontoaho',
  },
  {
    id: '7410070025',
    districtId: '7410070',
    name: 'Padalere Utama',
  },
  {
    id: '7410070029',
    districtId: '7410070',
    name: 'Larompana',
  },
  {
    id: '7410070030',
    districtId: '7410070',
    name: 'Wacu Pinodo',
  },
  {
    id: '7410070031',
    districtId: '7410070',
    name: 'UPT Padalere Utama',
  },
  {
    id: '7410070032',
    districtId: '7410070',
    name: 'Hialu',
  },
  {
    id: '7410071001',
    districtId: '7410071',
    name: 'Hialu Utama (UPT. Hialu II)',
  },
  {
    id: '7410071002',
    districtId: '7410071',
    name: 'Mata Banua (UPT Lamonae I)',
  },
  {
    id: '7410071003',
    districtId: '7410071',
    name: 'Kuratao',
  },
  {
    id: '7410071004',
    districtId: '7410071',
    name: 'Landawe Utama',
  },
  {
    id: '7410071005',
    districtId: '7410071',
    name: 'Polo Polora',
  },
  {
    id: '7410071006',
    districtId: '7410071',
    name: 'Kolosua',
  },
  {
    id: '7410071007',
    districtId: '7410071',
    name: 'Tambakua',
  },
  {
    id: '7410071008',
    districtId: '7410071',
    name: 'Landiwo',
  },
  {
    id: '7410071009',
    districtId: '7410071',
    name: 'Lahumoso',
  },
  {
    id: '7410071010',
    districtId: '7410071',
    name: 'Matabaho',
  },
  {
    id: '7411010001',
    districtId: '7411010',
    name: 'Iwoi Mea Jaya',
  },
  {
    id: '7411010002',
    districtId: '7411010',
    name: 'Pekorea',
  },
  {
    id: '7411010003',
    districtId: '7411010',
    name: 'Taore',
  },
  {
    id: '7411010004',
    districtId: '7411010',
    name: 'Awiu',
  },
  {
    id: '7411010005',
    districtId: '7411010',
    name: 'Watuoha',
  },
  {
    id: '7411010006',
    districtId: '7411010',
    name: 'Iwoimenggura',
  },
  {
    id: '7411010007',
    districtId: '7411010',
    name: 'Ulundoro',
  },
  {
    id: '7411010008',
    districtId: '7411010',
    name: 'Aere',
  },
  {
    id: '7411010009',
    districtId: '7411010',
    name: 'Rubia',
  },
  {
    id: '7411010010',
    districtId: '7411010',
    name: 'Aladadio',
  },
  {
    id: '7411010011',
    districtId: '7411010',
    name: 'Tinete',
  },
  {
    id: '7411020001',
    districtId: '7411020',
    name: 'Penanggootu',
  },
  {
    id: '7411020002',
    districtId: '7411020',
    name: 'Mondoke',
  },
  {
    id: '7411020003',
    districtId: '7411020',
    name: 'Mokupa',
  },
  {
    id: '7411020004',
    districtId: '7411020',
    name: 'Onemanu',
  },
  {
    id: '7411020005',
    districtId: '7411020',
    name: 'Bou',
  },
  {
    id: '7411020006',
    districtId: '7411020',
    name: 'Lowa',
  },
  {
    id: '7411020007',
    districtId: '7411020',
    name: 'Lere Jaya',
  },
  {
    id: '7411020008',
    districtId: '7411020',
    name: 'Atolanu',
  },
  {
    id: '7411020009',
    districtId: '7411020',
    name: 'Inotu',
  },
  {
    id: '7411020010',
    districtId: '7411020',
    name: 'Penanggo Jaya',
  },
  {
    id: '7411020011',
    districtId: '7411020',
    name: 'Lambandia',
  },
  {
    id: '7411020012',
    districtId: '7411020',
    name: 'Penanggoosi',
  },
  {
    id: '7411020013',
    districtId: '7411020',
    name: 'Wonuambuteo',
  },
  {
    id: '7411020014',
    districtId: '7411020',
    name: 'Lalolera',
  },
  {
    id: '7411020015',
    districtId: '7411020',
    name: 'Pomburea',
  },
  {
    id: '7411030001',
    districtId: '7411030',
    name: 'Wundubite',
  },
  {
    id: '7411030002',
    districtId: '7411030',
    name: 'Puundokulo',
  },
  {
    id: '7411030003',
    districtId: '7411030',
    name: 'Hakambololi',
  },
  {
    id: '7411030004',
    districtId: '7411030',
    name: 'Andowengga',
  },
  {
    id: '7411030005',
    districtId: '7411030',
    name: 'Taosu',
  },
  {
    id: '7411030006',
    districtId: '7411030',
    name: 'Pangi-Pangi',
  },
  {
    id: '7411030007',
    districtId: '7411030',
    name: 'Poli Polia',
  },
  {
    id: '7411030008',
    districtId: '7411030',
    name: 'Inotu Mewao',
  },
  {
    id: '7411030009',
    districtId: '7411030',
    name: 'Tokai',
  },
  {
    id: '7411030010',
    districtId: '7411030',
    name: 'Wia-Wia',
  },
  {
    id: '7411030011',
    districtId: '7411030',
    name: 'Polemaju Jaya',
  },
  {
    id: '7411030012',
    districtId: '7411030',
    name: 'Polenga Jaya',
  },
  {
    id: '7411040001',
    districtId: '7411040',
    name: 'Lalokateba',
  },
  {
    id: '7411040002',
    districtId: '7411040',
    name: 'Lamosila',
  },
  {
    id: '7411040003',
    districtId: '7411040',
    name: 'Anambada',
  },
  {
    id: '7411040004',
    districtId: '7411040',
    name: 'Lembah Subur',
  },
  {
    id: '7411040005',
    districtId: '7411040',
    name: 'Talinduka',
  },
  {
    id: '7411040006',
    districtId: '7411040',
    name: 'Gunung Jaya',
  },
  {
    id: '7411040007',
    districtId: '7411040',
    name: 'Mulia Jaya',
  },
  {
    id: '7411040008',
    districtId: '7411040',
    name: 'Mekar Jaya',
  },
  {
    id: '7411040009',
    districtId: '7411040',
    name: 'Tetembuta',
  },
  {
    id: '7411040010',
    districtId: '7411040',
    name: 'Dangia',
  },
  {
    id: '7411040011',
    districtId: '7411040',
    name: 'Wande',
  },
  {
    id: '7411040012',
    districtId: '7411040',
    name: 'Tetewua',
  },
  {
    id: '7411050001',
    districtId: '7411050',
    name: 'Raraa',
  },
  {
    id: '7411050002',
    districtId: '7411050',
    name: 'Welala',
  },
  {
    id: '7411050003',
    districtId: '7411050',
    name: 'Atula',
  },
  {
    id: '7411050004',
    districtId: '7411050',
    name: 'Pombeyoha',
  },
  {
    id: '7411050005',
    districtId: '7411050',
    name: 'Wungguloko',
  },
  {
    id: '7411050006',
    districtId: '7411050',
    name: 'Ladongi Jaya',
  },
  {
    id: '7411050007',
    districtId: '7411050',
    name: 'Tongandiu',
  },
  {
    id: '7411050008',
    districtId: '7411050',
    name: 'Lalowosula',
  },
  {
    id: '7411050009',
    districtId: '7411050',
    name: 'Putemata',
  },
  {
    id: '7411050010',
    districtId: '7411050',
    name: 'Anggaloosi',
  },
  {
    id: '7411060001',
    districtId: '7411060',
    name: 'Teposua',
  },
  {
    id: '7411060002',
    districtId: '7411060',
    name: 'Mataiwoi',
  },
  {
    id: '7411060003',
    districtId: '7411060',
    name: 'Lamoare',
  },
  {
    id: '7411060004',
    districtId: '7411060',
    name: 'Tinomu',
  },
  {
    id: '7411060005',
    districtId: '7411060',
    name: 'Iwoikondo',
  },
  {
    id: '7411060006',
    districtId: '7411060',
    name: 'Peatoa',
  },
  {
    id: '7411060007',
    districtId: '7411060',
    name: 'Lalowura',
  },
  {
    id: '7411060008',
    districtId: '7411060',
    name: 'Loea',
  },
  {
    id: '7411060009',
    districtId: '7411060',
    name: 'Simbalai',
  },
  {
    id: '7411070001',
    districtId: '7411070',
    name: 'Lalingato',
  },
  {
    id: '7411070002',
    districtId: '7411070',
    name: 'Simbune',
  },
  {
    id: '7411070003',
    districtId: '7411070',
    name: 'Poni Poniki',
  },
  {
    id: '7411070004',
    districtId: '7411070',
    name: 'Tirawuta',
  },
  {
    id: '7411070005',
    districtId: '7411070',
    name: 'Tasahea',
  },
  {
    id: '7411070006',
    districtId: '7411070',
    name: 'Tababu',
  },
  {
    id: '7411070007',
    districtId: '7411070',
    name: 'Rate-Rate',
  },
  {
    id: '7411070008',
    districtId: '7411070',
    name: 'Orawa',
  },
  {
    id: '7411070009',
    districtId: '7411070',
    name: 'Loka',
  },
  {
    id: '7411070010',
    districtId: '7411070',
    name: 'Matabondu',
  },
  {
    id: '7411070011',
    districtId: '7411070',
    name: 'Woiha',
  },
  {
    id: '7411070012',
    districtId: '7411070',
    name: 'Lara',
  },
  {
    id: '7411070013',
    districtId: '7411070',
    name: 'Roko-Roko',
  },
  {
    id: '7411070014',
    districtId: '7411070',
    name: 'Tawainalu',
  },
  {
    id: '7411070015',
    districtId: '7411070',
    name: 'Karemotingge',
  },
  {
    id: '7411070016',
    districtId: '7411070',
    name: 'Tumbudadio',
  },
  {
    id: '7411080001',
    districtId: '7411080',
    name: 'Wesalo',
  },
  {
    id: '7411080002',
    districtId: '7411080',
    name: 'Lalolae',
  },
  {
    id: '7411080003',
    districtId: '7411080',
    name: 'Keisio',
  },
  {
    id: '7411080004',
    districtId: '7411080',
    name: 'Lalosingi',
  },
  {
    id: '7411080005',
    districtId: '7411080',
    name: 'Talodo',
  },
  {
    id: '7411090001',
    districtId: '7411090',
    name: 'Horodopi',
  },
  {
    id: '7411090002',
    districtId: '7411090',
    name: 'Watupute',
  },
  {
    id: '7411090003',
    districtId: '7411090',
    name: 'Lapangisi',
  },
  {
    id: '7411090004',
    districtId: '7411090',
    name: 'Inebenggi',
  },
  {
    id: '7411090005',
    districtId: '7411090',
    name: 'Sabi-Sabila',
  },
  {
    id: '7411090006',
    districtId: '7411090',
    name: 'Woitombo',
  },
  {
    id: '7411090007',
    districtId: '7411090',
    name: 'Lambotua',
  },
  {
    id: '7411090008',
    districtId: '7411090',
    name: 'Puuosu',
  },
  {
    id: '7411090009',
    districtId: '7411090',
    name: 'Nelombu',
  },
  {
    id: '7411090010',
    districtId: '7411090',
    name: 'Ulu Mowewe',
  },
  {
    id: '7411100001',
    districtId: '7411100',
    name: 'Weamo',
  },
  {
    id: '7411100002',
    districtId: '7411100',
    name: 'Tinengi',
  },
  {
    id: '7411100003',
    districtId: '7411100',
    name: 'Lamunde',
  },
  {
    id: '7411100004',
    districtId: '7411100',
    name: 'Talata',
  },
  {
    id: '7411100005',
    districtId: '7411100',
    name: 'Iwoimea',
  },
  {
    id: '7411100006',
    districtId: '7411100',
    name: 'Tawarombadaka',
  },
  {
    id: '7411100007',
    districtId: '7411100',
    name: 'Solewatu',
  },
  {
    id: '7411100008',
    districtId: '7411100',
    name: 'Tawa-Tawaro',
  },
  {
    id: '7411100009',
    districtId: '7411100',
    name: 'Ambapa',
  },
  {
    id: '7411100010',
    districtId: '7411100',
    name: 'Tutuwi',
  },
  {
    id: '7411100011',
    districtId: '7411100',
    name: 'Singgere',
  },
  {
    id: '7411100012',
    districtId: '7411100',
    name: 'Ameroro',
  },
  {
    id: '7411110001',
    districtId: '7411110',
    name: 'Aukora',
  },
  {
    id: '7411110003',
    districtId: '7411110',
    name: 'Tondowatu',
  },
  {
    id: '7411110004',
    districtId: '7411110',
    name: 'Sanggona',
  },
  {
    id: '7411110005',
    districtId: '7411110',
    name: 'Lalombai',
  },
  {
    id: '7411110006',
    districtId: '7411110',
    name: 'Undolo',
  },
  {
    id: '7411110007',
    districtId: '7411110',
    name: 'Tawanga',
  },
  {
    id: '7411110008',
    districtId: '7411110',
    name: 'Amololu',
  },
  {
    id: '7411110009',
    districtId: '7411110',
    name: 'Amokuni',
  },
  {
    id: '7411110010',
    districtId: '7411110',
    name: 'Pehanggo',
  },
  {
    id: '7411120001',
    districtId: '7411120',
    name: 'Silui',
  },
  {
    id: '7411120002',
    districtId: '7411120',
    name: 'Konawendepiha',
  },
  {
    id: '7411120003',
    districtId: '7411120',
    name: 'Porabua',
  },
  {
    id: '7411120004',
    districtId: '7411120',
    name: 'Wesinggote',
  },
  {
    id: '7411120005',
    districtId: '7411120',
    name: 'Ueesi',
  },
  {
    id: '7411120006',
    districtId: '7411120',
    name: 'Watumendonga',
  },
  {
    id: '7411120007',
    districtId: '7411120',
    name: 'Ahilulu',
  },
  {
    id: '7411120008',
    districtId: '7411120',
    name: 'Alaaha',
  },
  {
    id: '7411120009',
    districtId: '7411120',
    name: 'Liku Walanapo',
  },
  {
    id: '7411120010',
    districtId: '7411120',
    name: 'Puurau',
  },
  {
    id: '7411120011',
    districtId: '7411120',
    name: 'Tongauna',
  },
  {
    id: '7412010001',
    districtId: '7412010',
    name: 'Teporoko',
  },
  {
    id: '7412010002',
    districtId: '7412010',
    name: 'Roko-Roko',
  },
  {
    id: '7412010003',
    districtId: '7412010',
    name: 'Dompo-Dompo Jaya',
  },
  {
    id: '7412010004',
    districtId: '7412010',
    name: 'Sukarela',
  },
  {
    id: '7412010005',
    districtId: '7412010',
    name: 'Nambo Jaya',
  },
  {
    id: '7412010006',
    districtId: '7412010',
    name: 'Sainoa Indah',
  },
  {
    id: '7412010007',
    districtId: '7412010',
    name: 'Sinaulu Jaya',
  },
  {
    id: '7412010008',
    districtId: '7412010',
    name: 'Mosolo',
  },
  {
    id: '7412010009',
    districtId: '7412010',
    name: 'Wunse Jaya',
  },
  {
    id: '7412010010',
    districtId: '7412010',
    name: 'Tondongitu',
  },
  {
    id: '7412010011',
    districtId: '7412010',
    name: 'Polara',
  },
  {
    id: '7412010012',
    districtId: '7412010',
    name: 'Sinar Masolo',
  },
  {
    id: '7412010013',
    districtId: '7412010',
    name: 'Bahaba',
  },
  {
    id: '7412010014',
    districtId: '7412010',
    name: 'Waturai',
  },
  {
    id: '7412010015',
    districtId: '7412010',
    name: 'Kekea',
  },
  {
    id: '7412020001',
    districtId: '7412020',
    name: 'Wakadawu',
  },
  {
    id: '7412020003',
    districtId: '7412020',
    name: 'Tekonea',
  },
  {
    id: '7412020004',
    districtId: '7412020',
    name: 'Lapulu',
  },
  {
    id: '7412020006',
    districtId: '7412020',
    name: 'Laiwo Jaya',
  },
  {
    id: '7412020007',
    districtId: '7412020',
    name: 'Desa Munse',
  },
  {
    id: '7412020008',
    districtId: '7412020',
    name: 'Lebo',
  },
  {
    id: '7412020009',
    districtId: '7412020',
    name: 'Nanga',
  },
  {
    id: '7412020010',
    districtId: '7412020',
    name: 'Butuea',
  },
  {
    id: '7412020011',
    districtId: '7412020',
    name: 'Lembono',
  },
  {
    id: '7412020012',
    districtId: '7412020',
    name: 'Saburano',
  },
  {
    id: '7412030001',
    districtId: '7412030',
    name: 'Puurau',
  },
  {
    id: '7412030002',
    districtId: '7412030',
    name: 'Mata Dimba',
  },
  {
    id: '7412030003',
    districtId: '7412030',
    name: 'Dimba',
  },
  {
    id: '7412030004',
    districtId: '7412030',
    name: 'Patande',
  },
  {
    id: '7412030005',
    districtId: '7412030',
    name: 'Ladianta',
  },
  {
    id: '7412030006',
    districtId: '7412030',
    name: 'Tangkombuno',
  },
  {
    id: '7412030007',
    districtId: '7412030',
    name: 'Baho Bubu',
  },
  {
    id: '7412030008',
    districtId: '7412030',
    name: 'Noko',
  },
  {
    id: '7412030009',
    districtId: '7412030',
    name: 'Bangun Mekar',
  },
  {
    id: '7412030010',
    districtId: '7412030',
    name: 'Watuondo',
  },
  {
    id: '7412040001',
    districtId: '7412040',
    name: 'Mata Iwoi',
  },
  {
    id: '7412040002',
    districtId: '7412040',
    name: 'Waworope',
  },
  {
    id: '7412040003',
    districtId: '7412040',
    name: 'Dongkalaea',
  },
  {
    id: '7412040004',
    districtId: '7412040',
    name: 'Labeau',
  },
  {
    id: '7412040005',
    districtId: '7412040',
    name: 'Wawobeau',
  },
  {
    id: '7412040006',
    districtId: '7412040',
    name: 'Tombaone',
  },
  {
    id: '7412040007',
    districtId: '7412040',
    name: 'Labisa',
  },
  {
    id: '7412040008',
    districtId: '7412040',
    name: 'Lansilowo',
  },
  {
    id: '7412040009',
    districtId: '7412040',
    name: 'Tombaone Utama',
  },
  {
    id: '7412040010',
    districtId: '7412040',
    name: 'Palingi Barat',
  },
  {
    id: '7412040011',
    districtId: '7412040',
    name: 'Palingi',
  },
  {
    id: '7412040012',
    districtId: '7412040',
    name: 'Mata Bubu',
  },
  {
    id: '7412040013',
    districtId: '7412040',
    name: 'Mawa',
  },
  {
    id: '7412040014',
    districtId: '7412040',
    name: 'Mataburanga',
  },
  {
    id: '7412040016',
    districtId: '7412040',
    name: 'Tapumbatu',
  },
  {
    id: '7412040017',
    districtId: '7412040',
    name: 'Palingi Timur',
  },
  {
    id: '7412040018',
    districtId: '7412040',
    name: 'Tongalere',
  },
  {
    id: '7412040019',
    districtId: '7412040',
    name: 'Tomburano',
  },
  {
    id: '7412040020',
    districtId: '7412040',
    name: 'Sawah Indah',
  },
  {
    id: '7412040021',
    districtId: '7412040',
    name: 'Tepolawa',
  },
  {
    id: '7412050001',
    districtId: '7412050',
    name: 'Lawey',
  },
  {
    id: '7412050002',
    districtId: '7412050',
    name: 'Puuwatu',
  },
  {
    id: '7412050003',
    districtId: '7412050',
    name: 'Wawouso',
  },
  {
    id: '7412050004',
    districtId: '7412050',
    name: 'Wawouso Baru',
  },
  {
    id: '7412050005',
    districtId: '7412050',
    name: 'Baku-Baku',
  },
  {
    id: '7412050006',
    districtId: '7412050',
    name: 'Bobolio',
  },
  {
    id: '7412050007',
    districtId: '7412050',
    name: 'Sawaea',
  },
  {
    id: '7412050008',
    districtId: '7412050',
    name: 'Sawapatani',
  },
  {
    id: '7412050009',
    districtId: '7412050',
    name: 'Wungkolo',
  },
  {
    id: '7412050010',
    districtId: '7412050',
    name: 'Langara Jaya',
  },
  {
    id: '7412050011',
    districtId: '7412050',
    name: 'Wawoone',
  },
  {
    id: '7412060001',
    districtId: '7412060',
    name: 'Rawa Indah',
  },
  {
    id: '7412060002',
    districtId: '7412060',
    name: 'Lampeapi',
  },
  {
    id: '7412060004',
    districtId: '7412060',
    name: 'Lampeapi Baru',
  },
  {
    id: '7412060005',
    districtId: '7412060',
    name: 'Lamongupa',
  },
  {
    id: '7412060006',
    districtId: '7412060',
    name: 'Mekar Sari',
  },
  {
    id: '7412060007',
    districtId: '7412060',
    name: 'Wawoindah',
  },
  {
    id: '7412060008',
    districtId: '7412060',
    name: 'UPT. Batumea/Tumbu-Tumbu Jaya',
  },
  {
    id: '7412060009',
    districtId: '7412060',
    name: 'Morobea',
  },
  {
    id: '7412060010',
    districtId: '7412060',
    name: 'Batumea',
  },
  {
    id: '7412060011',
    districtId: '7412060',
    name: 'Baho Pulu Wulu',
  },
  {
    id: '7412060012',
    districtId: '7412060',
    name: 'Puurau',
  },
  {
    id: '7412070001',
    districtId: '7412070',
    name: 'Bukit Permai',
  },
  {
    id: '7412070002',
    districtId: '7412070',
    name: 'Mata Baho',
  },
  {
    id: '7412070003',
    districtId: '7412070',
    name: 'Lamoluo',
  },
  {
    id: '7412070004',
    districtId: '7412070',
    name: 'Mata Langara',
  },
  {
    id: '7412070005',
    districtId: '7412070',
    name: 'Langara Iwawo',
  },
  {
    id: '7412070006',
    districtId: '7412070',
    name: 'Langara Laut',
  },
  {
    id: '7412070007',
    districtId: '7412070',
    name: 'Langara Indah',
  },
  {
    id: '7412070008',
    districtId: '7412070',
    name: 'Langara Bajo',
  },
  {
    id: '7412070009',
    districtId: '7412070',
    name: 'Wawobili',
  },
  {
    id: '7412070010',
    districtId: '7412070',
    name: 'Wawolaa',
  },
  {
    id: '7412070011',
    districtId: '7412070',
    name: 'Lanowatu',
  },
  {
    id: '7412070012',
    districtId: '7412070',
    name: 'Pasir Putih',
  },
  {
    id: '7413010016',
    districtId: '7413010',
    name: 'Sido Makmur',
  },
  {
    id: '7413010017',
    districtId: '7413010',
    name: 'Wulanga Jaya',
  },
  {
    id: '7413010018',
    districtId: '7413010',
    name: 'Wandoke',
  },
  {
    id: '7413010019',
    districtId: '7413010',
    name: 'Tiworo',
  },
  {
    id: '7413010020',
    districtId: '7413010',
    name: 'Laworo',
  },
  {
    id: '7413010021',
    districtId: '7413010',
    name: 'Waturempe',
  },
  {
    id: '7413010022',
    districtId: '7413010',
    name: 'Waumere',
  },
  {
    id: '7413010026',
    districtId: '7413010',
    name: 'Lasama',
  },
  {
    id: '7413010027',
    districtId: '7413010',
    name: 'Katela',
  },
  {
    id: '7413020001',
    districtId: '7413020',
    name: 'G A L A',
  },
  {
    id: '7413020002',
    districtId: '7413020',
    name: 'Bangko',
  },
  {
    id: '7413020008',
    districtId: '7413020',
    name: 'Abadi Jaya',
  },
  {
    id: '7413020009',
    districtId: '7413020',
    name: 'Pajala',
  },
  {
    id: '7413020010',
    districtId: '7413020',
    name: 'Maginti',
  },
  {
    id: '7413020011',
    districtId: '7413020',
    name: 'Kangkunawe',
  },
  {
    id: '7413020012',
    districtId: '7413020',
    name: 'Pasipadangan',
  },
  {
    id: '7413020013',
    districtId: '7413020',
    name: 'Kembar Maminasa',
  },
  {
    id: '7413030001',
    districtId: '7413030',
    name: 'Wanseriwu',
  },
  {
    id: '7413030002',
    districtId: '7413030',
    name: 'Langku-Langku',
  },
  {
    id: '7413030003',
    districtId: '7413030',
    name: 'Mekar Jaya',
  },
  {
    id: '7413030004',
    districtId: '7413030',
    name: 'Wapae',
  },
  {
    id: '7413030005',
    districtId: '7413030',
    name: 'Labokolo',
  },
  {
    id: '7413030011',
    districtId: '7413030',
    name: 'Lakabu',
  },
  {
    id: '7413030012',
    districtId: '7413030',
    name: 'Momuntu',
  },
  {
    id: '7413030024',
    districtId: '7413030',
    name: 'Suka Damai',
  },
  {
    id: '7413040001',
    districtId: '7413040',
    name: 'Barakkah',
  },
  {
    id: '7413040002',
    districtId: '7413040',
    name: 'Sangia Tiworo',
  },
  {
    id: '7413040003',
    districtId: '7413040',
    name: 'Kasimpa Jaya',
  },
  {
    id: '7413040004',
    districtId: '7413040',
    name: 'Katangana',
  },
  {
    id: '7413040005',
    districtId: '7413040',
    name: 'Parura Jaya',
  },
  {
    id: '7413050001',
    districtId: '7413050',
    name: 'Tondasi',
  },
  {
    id: '7413050002',
    districtId: '7413050',
    name: 'Santiri',
  },
  {
    id: '7413050003',
    districtId: '7413050',
    name: 'Tasipi',
  },
  {
    id: '7413050004',
    districtId: '7413050',
    name: 'Bero',
  },
  {
    id: '7413050005',
    districtId: '7413050',
    name: 'Mandike',
  },
  {
    id: '7413050006',
    districtId: '7413050',
    name: 'Santigi',
  },
  {
    id: '7413050007',
    districtId: '7413050',
    name: 'Tiga',
  },
  {
    id: '7413060008',
    districtId: '7413060',
    name: 'Latompe',
  },
  {
    id: '7413060009',
    districtId: '7413060',
    name: 'Lalemba',
  },
  {
    id: '7413060010',
    districtId: '7413060',
    name: 'Wamelai(Lambubalano)',
  },
  {
    id: '7413060011',
    districtId: '7413060',
    name: 'Lapadaku',
  },
  {
    id: '7413060012',
    districtId: '7413060',
    name: 'Madampi',
  },
  {
    id: '7413060013',
    districtId: '7413060',
    name: 'Lagadi',
  },
  {
    id: '7413060015',
    districtId: '7413060',
    name: 'Latugho',
  },
  {
    id: '7413060033',
    districtId: '7413060',
    name: 'Watumela',
  },
  {
    id: '7413070001',
    districtId: '7413070',
    name: 'Lawada Jaya',
  },
  {
    id: '7413070002',
    districtId: '7413070',
    name: 'Lakalamba',
  },
  {
    id: '7413070003',
    districtId: '7413070',
    name: 'Marobea',
  },
  {
    id: '7413070004',
    districtId: '7413070',
    name: 'Ondoke',
  },
  {
    id: '7413070011',
    districtId: '7413070',
    name: 'Nihi',
  },
  {
    id: '7413070014',
    districtId: '7413070',
    name: 'Kampobalano',
  },
  {
    id: '7413070015',
    districtId: '7413070',
    name: 'Lombu Jaya',
  },
  {
    id: '7413070016',
    districtId: '7413070',
    name: 'Waukuni',
  },
  {
    id: '7413070017',
    districtId: '7413070',
    name: 'Maperaha',
  },
  {
    id: '7413070018',
    districtId: '7413070',
    name: 'Wakoila',
  },
  {
    id: '7413080001',
    districtId: '7413080',
    name: 'Barangka',
  },
  {
    id: '7413080002',
    districtId: '7413080',
    name: 'Sawerigadi',
  },
  {
    id: '7413080003',
    districtId: '7413080',
    name: 'Bungkolo',
  },
  {
    id: '7413080004',
    districtId: '7413080',
    name: 'Lapolea',
  },
  {
    id: '7413080005',
    districtId: '7413080',
    name: 'Walelei',
  },
  {
    id: '7413080006',
    districtId: '7413080',
    name: 'Waulai',
  },
  {
    id: '7413080007',
    districtId: '7413080',
    name: 'Lafinde',
  },
  {
    id: '7413080008',
    districtId: '7413080',
    name: 'W U N A',
  },
  {
    id: '7413090001',
    districtId: '7413090',
    name: 'Kampani',
  },
  {
    id: '7413090002',
    districtId: '7413090',
    name: 'Lindo',
  },
  {
    id: '7413090003',
    districtId: '7413090',
    name: 'Katobu',
  },
  {
    id: '7413090004',
    districtId: '7413090',
    name: 'Lailangga',
  },
  {
    id: '7413090005',
    districtId: '7413090',
    name: 'Lasosodo',
  },
  {
    id: '7413090006',
    districtId: '7413090',
    name: 'Wakontu',
  },
  {
    id: '7413090007',
    districtId: '7413090',
    name: 'Lakanaha',
  },
  {
    id: '7413100014',
    districtId: '7413100',
    name: 'Kusambi',
  },
  {
    id: '7413100015',
    districtId: '7413100',
    name: 'Konawe',
  },
  {
    id: '7413100016',
    districtId: '7413100',
    name: 'Guali',
  },
  {
    id: '7413100017',
    districtId: '7413100',
    name: 'Lapokainse',
  },
  {
    id: '7413100018',
    districtId: '7413100',
    name: 'Lemoambo',
  },
  {
    id: '7413100019',
    districtId: '7413100',
    name: 'Kasakamu',
  },
  {
    id: '7413100020',
    districtId: '7413100',
    name: 'Lakawoghe',
  },
  {
    id: '7413100021',
    districtId: '7413100',
    name: 'Bakeramba',
  },
  {
    id: '7413100022',
    districtId: '7413100',
    name: 'Tanjung Pinang',
  },
  {
    id: '7413100023',
    districtId: '7413100',
    name: 'Sida Mangura',
  },
  {
    id: '7413110001',
    districtId: '7413110',
    name: 'Masara',
  },
  {
    id: '7413110002',
    districtId: '7413110',
    name: 'Lahaji',
  },
  {
    id: '7413110003',
    districtId: '7413110',
    name: 'Umba',
  },
  {
    id: '7413110004',
    districtId: '7413110',
    name: 'Kombikuno',
  },
  {
    id: '7413110005',
    districtId: '7413110',
    name: 'Tangkumaho',
  },
  {
    id: '7413110006',
    districtId: '7413110',
    name: 'Latawe',
  },
  {
    id: '7414010001',
    districtId: '7414010',
    name: 'Kokoe',
  },
  {
    id: '7414010002',
    districtId: '7414010',
    name: 'Talaga Besar',
  },
  {
    id: '7414010003',
    districtId: '7414010',
    name: 'Talaga II',
  },
  {
    id: '7414010004',
    districtId: '7414010',
    name: 'Talaga I',
  },
  {
    id: '7414010006',
    districtId: '7414010',
    name: 'Liwu Lompona',
  },
  {
    id: '7414010007',
    districtId: '7414010',
    name: 'Pangilia',
  },
  {
    id: '7414020001',
    districtId: '7414020',
    name: 'Wakambangura',
  },
  {
    id: '7414020002',
    districtId: '7414020',
    name: 'Kance Bungi',
  },
  {
    id: '7414020003',
    districtId: '7414020',
    name: 'Gumamano',
  },
  {
    id: '7414020006',
    districtId: '7414020',
    name: 'Matara',
  },
  {
    id: '7414020007',
    districtId: '7414020',
    name: 'Wasilomata I',
  },
  {
    id: '7414020008',
    districtId: '7414020',
    name: 'Wasilomata II',
  },
  {
    id: '7414020009',
    districtId: '7414020',
    name: 'Napa',
  },
  {
    id: '7414020010',
    districtId: '7414020',
    name: 'Balobone',
  },
  {
    id: '7414020011',
    districtId: '7414020',
    name: 'Watolo',
  },
  {
    id: '7414020012',
    districtId: '7414020',
    name: 'Mawasangka',
  },
  {
    id: '7414020013',
    districtId: '7414020',
    name: 'Oengkolaki',
  },
  {
    id: '7414020014',
    districtId: '7414020',
    name: 'Banga',
  },
  {
    id: '7414020027',
    districtId: '7414020',
    name: 'Polindu',
  },
  {
    id: '7414020028',
    districtId: '7414020',
    name: 'Tanailandu',
  },
  {
    id: '7414020029',
    districtId: '7414020',
    name: 'Kanapa Napa',
  },
  {
    id: '7414020030',
    districtId: '7414020',
    name: 'Terapung',
  },
  {
    id: '7414020031',
    districtId: '7414020',
    name: 'Dahiango',
  },
  {
    id: '7414020032',
    districtId: '7414020',
    name: 'Wakambangura II',
  },
  {
    id: '7414020033',
    districtId: '7414020',
    name: 'Air Bajo',
  },
  {
    id: '7414030004',
    districtId: '7414030',
    name: 'Watorumbe',
  },
  {
    id: '7414030005',
    districtId: '7414030',
    name: 'Morikana',
  },
  {
    id: '7414030015',
    districtId: '7414030',
    name: 'Lantongau',
  },
  {
    id: '7414030016',
    districtId: '7414030',
    name: 'Lakorua',
  },
  {
    id: '7414030017',
    districtId: '7414030',
    name: 'Lanto',
  },
  {
    id: '7414030018',
    districtId: '7414030',
    name: 'Lalibo',
  },
  {
    id: '7414030026',
    districtId: '7414030',
    name: 'Langkomu',
  },
  {
    id: '7414030027',
    districtId: '7414030',
    name: 'Watorumbe Bata',
  },
  {
    id: '7414030028',
    districtId: '7414030',
    name: 'Katukobari',
  },
  {
    id: '7414040001',
    districtId: '7414040',
    name: 'Lagili',
  },
  {
    id: '7414040002',
    districtId: '7414040',
    name: 'Wambuloli',
  },
  {
    id: '7414040003',
    districtId: '7414040',
    name: 'Bone Marambe',
  },
  {
    id: '7414040004',
    districtId: '7414040',
    name: 'Lasori',
  },
  {
    id: '7414040005',
    districtId: '7414040',
    name: 'Inulu',
  },
  {
    id: '7414040006',
    districtId: '7414040',
    name: 'Wantopi',
  },
  {
    id: '7414040007',
    districtId: '7414040',
    name: 'Bungi',
  },
  {
    id: '7414040008',
    districtId: '7414040',
    name: 'Batubanawa',
  },
  {
    id: '7414050001',
    districtId: '7414050',
    name: 'Madongka',
  },
  {
    id: '7414050002',
    districtId: '7414050',
    name: 'Waara',
  },
  {
    id: '7414050003',
    districtId: '7414050',
    name: 'Boneoge',
  },
  {
    id: '7414050004',
    districtId: '7414050',
    name: 'Nepa Mekar',
  },
  {
    id: '7414050005',
    districtId: '7414050',
    name: 'Gu Timur',
  },
  {
    id: '7414050006',
    districtId: '7414050',
    name: 'Lakudo',
  },
  {
    id: '7414050007',
    districtId: '7414050',
    name: 'Matawine',
  },
  {
    id: '7414050008',
    districtId: '7414050',
    name: 'Mone',
  },
  {
    id: '7414050009',
    districtId: '7414050',
    name: 'Moko',
  },
  {
    id: '7414050010',
    districtId: '7414050',
    name: 'Wajogu',
  },
  {
    id: '7414050012',
    districtId: '7414050',
    name: 'Lolibu',
  },
  {
    id: '7414050013',
    districtId: '7414050',
    name: 'Wongko Lakudo',
  },
  {
    id: '7414050014',
    districtId: '7414050',
    name: 'One Waara',
  },
  {
    id: '7414050015',
    districtId: '7414050',
    name: 'Teluk Lasongko',
  },
  {
    id: '7414060001',
    districtId: '7414060',
    name: 'Wadiabero',
  },
  {
    id: '7414060002',
    districtId: '7414060',
    name: 'Kolowa',
  },
  {
    id: '7414060008',
    districtId: '7414060',
    name: 'Rahia',
  },
  {
    id: '7414060009',
    districtId: '7414060',
    name: 'Wakea Kea',
  },
  {
    id: '7414060010',
    districtId: '7414060',
    name: 'Waliko',
  },
  {
    id: '7414060011',
    districtId: '7414060',
    name: 'Bombonawulu',
  },
  {
    id: '7414060012',
    districtId: '7414060',
    name: 'Walando',
  },
  {
    id: '7414060013',
    districtId: '7414060',
    name: 'Watulea',
  },
  {
    id: '7414060014',
    districtId: '7414060',
    name: 'Lakapera',
  },
  {
    id: '7414060015',
    districtId: '7414060',
    name: 'Bantea',
  },
  {
    id: '7414060016',
    districtId: '7414060',
    name: 'Kamama Nekar',
  },
  {
    id: '7414060017',
    districtId: '7414060',
    name: 'Lowu-Lowu',
  },
  {
    id: '7414070003',
    districtId: '7414070',
    name: 'Baruta Lestari',
  },
  {
    id: '7414070004',
    districtId: '7414070',
    name: 'Tolandona Matanaeo',
  },
  {
    id: '7414070005',
    districtId: '7414070',
    name: 'Doda Bahari',
  },
  {
    id: '7414070006',
    districtId: '7414070',
    name: 'Baruta Analaki',
  },
  {
    id: '7414070007',
    districtId: '7414070',
    name: 'Baruta',
  },
  {
    id: '7414070008',
    districtId: '7414070',
    name: 'Tolandona',
  },
  {
    id: '7415010001',
    districtId: '7415010',
    name: 'Batu Atas Liwu',
  },
  {
    id: '7415010002',
    districtId: '7415010',
    name: 'Batuatas Barat',
  },
  {
    id: '7415010003',
    districtId: '7415010',
    name: 'Tolando Jaya',
  },
  {
    id: '7415010004',
    districtId: '7415010',
    name: 'Batuatas Timur',
  },
  {
    id: '7415010005',
    districtId: '7415010',
    name: 'Wacuala',
  },
  {
    id: '7415010006',
    districtId: '7415010',
    name: 'Taduasa',
  },
  {
    id: '7415010007',
    districtId: '7415010',
    name: 'Wambongi',
  },
  {
    id: '7415020012',
    districtId: '7415020',
    name: 'Lapandewa Makmur',
  },
  {
    id: '7415020014',
    districtId: '7415020',
    name: 'Gayabaru',
  },
  {
    id: '7415020015',
    districtId: '7415020',
    name: 'Burangasi Rumbia',
  },
  {
    id: '7415020016',
    districtId: '7415020',
    name: 'Burangasi',
  },
  {
    id: '7415020017',
    districtId: '7415020',
    name: 'Lapandewa',
  },
  {
    id: '7415020018',
    districtId: '7415020',
    name: 'Lapandewa Kaindea',
  },
  {
    id: '7415020019',
    districtId: '7415020',
    name: 'Lapandewa Jaya',
  },
  {
    id: '7415030006',
    districtId: '7415030',
    name: 'Bangun',
  },
  {
    id: '7415030007',
    districtId: '7415030',
    name: 'Wawoangi',
  },
  {
    id: '7415030008',
    districtId: '7415030',
    name: 'Katilombu',
  },
  {
    id: '7415030009',
    districtId: '7415030',
    name: 'Jayabakti',
  },
  {
    id: '7415030010',
    districtId: '7415030',
    name: 'Tira',
  },
  {
    id: '7415030011',
    districtId: '7415030',
    name: 'Bahari',
  },
  {
    id: '7415030013',
    districtId: '7415030',
    name: 'Gerak Makmur',
  },
  {
    id: '7415030020',
    districtId: '7415030',
    name: 'Todombulu',
  },
  {
    id: '7415030021',
    districtId: '7415030',
    name: 'Sandang Pangan',
  },
  {
    id: '7415030022',
    districtId: '7415030',
    name: 'Hendea',
  },
  {
    id: '7415030023',
    districtId: '7415030',
    name: 'Lipumangau',
  },
  {
    id: '7415030024',
    districtId: '7415030',
    name: 'Watiginanda',
  },
  {
    id: '7415030025',
    districtId: '7415030',
    name: 'Bahari II',
  },
  {
    id: '7415030026',
    districtId: '7415030',
    name: 'Bahari III',
  },
  {
    id: '7415030027',
    districtId: '7415030',
    name: 'Windu Makmur',
  },
  {
    id: '7415040009',
    districtId: '7415040',
    name: 'Pogalampa',
  },
  {
    id: '7415040010',
    districtId: '7415040',
    name: 'Bola',
  },
  {
    id: '7415040011',
    districtId: '7415040',
    name: 'Majapahit',
  },
  {
    id: '7415040012',
    districtId: '7415040',
    name: 'Masiri',
  },
  {
    id: '7415040013',
    districtId: '7415040',
    name: 'Laompo',
  },
  {
    id: '7415040014',
    districtId: '7415040',
    name: 'Busoa',
  },
  {
    id: '7415040015',
    districtId: '7415040',
    name: 'Lawela',
  },
  {
    id: '7415040016',
    districtId: '7415040',
    name: 'Lampanairi',
  },
  {
    id: '7415040017',
    districtId: '7415040',
    name: 'Lawela Selatan',
  },
  {
    id: '7415040018',
    districtId: '7415040',
    name: 'Lakambau',
  },
  {
    id: '7415040019',
    districtId: '7415040',
    name: 'Molagina',
  },
  {
    id: '7415040020',
    districtId: '7415040',
    name: 'Bandar Batauga',
  },
  {
    id: '7415050001',
    districtId: '7415050',
    name: 'Lalole',
  },
  {
    id: '7415050002',
    districtId: '7415050',
    name: 'Molona',
  },
  {
    id: '7415050003',
    districtId: '7415050',
    name: 'Mbanua',
  },
  {
    id: '7415050004',
    districtId: '7415050',
    name: 'Watuampara',
  },
  {
    id: '7415050005',
    districtId: '7415050',
    name: 'Katampe',
  },
  {
    id: '7415050006',
    districtId: '7415050',
    name: 'Lamaninggara',
  },
  {
    id: '7415050007',
    districtId: '7415050',
    name: 'Kamoali',
  },
  {
    id: '7415050008',
    districtId: '7415050',
    name: 'Mokobeau',
  },
  {
    id: '7415060005',
    districtId: '7415060',
    name: 'Biwinapada',
  },
  {
    id: '7415060006',
    districtId: '7415060',
    name: 'Kaimbulawa',
  },
  {
    id: '7415060007',
    districtId: '7415060',
    name: 'Wakinamboro',
  },
  {
    id: '7415060008',
    districtId: '7415060',
    name: 'Tongali',
  },
  {
    id: '7415060009',
    districtId: '7415060',
    name: 'Lontoi',
  },
  {
    id: '7415060010',
    districtId: '7415060',
    name: 'Karae',
  },
  {
    id: '7415060011',
    districtId: '7415060',
    name: 'Batu Awu',
  },
  {
    id: '7415060012',
    districtId: '7415060',
    name: 'Nggula-Nggula',
  },
  {
    id: '7415060013',
    districtId: '7415060',
    name: 'Waindawula',
  },
  {
    id: '7415060014',
    districtId: '7415060',
    name: 'Lapara',
  },
  {
    id: '7415070001',
    districtId: '7415070',
    name: 'Waonu',
  },
  {
    id: '7415070002',
    districtId: '7415070',
    name: 'Kapoa',
  },
  {
    id: '7415070003',
    districtId: '7415070',
    name: 'Kaofe',
  },
  {
    id: '7415070004',
    districtId: '7415070',
    name: 'Uwemaasi',
  },
  {
    id: '7415070005',
    districtId: '7415070',
    name: 'Lipu',
  },
  {
    id: '7415070006',
    districtId: '7415070',
    name: 'Banabungi',
  },
  {
    id: '7415070007',
    districtId: '7415070',
    name: 'Kapoa Barat',
  },
  {
    id: '7415070008',
    districtId: '7415070',
    name: 'Mawambunga',
  },
  {
    id: '7415070009',
    districtId: '7415070',
    name: 'Marawali',
  },
  {
    id: '7415070010',
    districtId: '7415070',
    name: 'Banabungi Selatan',
  },
  {
    id: '7471010011',
    districtId: '7471010',
    name: 'Mandonga',
  },
  {
    id: '7471010012',
    districtId: '7471010',
    name: 'Korumba',
  },
  {
    id: '7471010013',
    districtId: '7471010',
    name: 'Anggilowu',
  },
  {
    id: '7471010014',
    districtId: '7471010',
    name: 'Alolama',
  },
  {
    id: '7471010015',
    districtId: '7471010',
    name: 'Wawombalata',
  },
  {
    id: '7471010016',
    districtId: '7471010',
    name: 'Labibia',
  },
  {
    id: '7471011001',
    districtId: '7471011',
    name: 'Baruga',
  },
  {
    id: '7471011002',
    districtId: '7471011',
    name: 'Lepo-Lepo',
  },
  {
    id: '7471011007',
    districtId: '7471011',
    name: 'Watubangga',
  },
  {
    id: '7471011013',
    districtId: '7471011',
    name: 'Wundudopi',
  },
  {
    id: '7471012007',
    districtId: '7471012',
    name: 'Puuwatu',
  },
  {
    id: '7471012008',
    districtId: '7471012',
    name: 'Watulondo',
  },
  {
    id: '7471012009',
    districtId: '7471012',
    name: 'Punggolaka',
  },
  {
    id: '7471012010',
    districtId: '7471012',
    name: 'Tobuuha',
  },
  {
    id: '7471012017',
    districtId: '7471012',
    name: 'Lalodati',
  },
  {
    id: '7471012018',
    districtId: '7471012',
    name: 'Abeli Dalam',
  },
  {
    id: '7471013006',
    districtId: '7471013',
    name: 'Kadia',
  },
  {
    id: '7471013009',
    districtId: '7471013',
    name: 'Anaiwoi',
  },
  {
    id: '7471013010',
    districtId: '7471013',
    name: 'Wowawanggu',
  },
  {
    id: '7471013012',
    districtId: '7471013',
    name: 'Pondambea',
  },
  {
    id: '7471014003',
    districtId: '7471014',
    name: 'Bonggoeya',
  },
  {
    id: '7471014004',
    districtId: '7471014',
    name: 'Wua-Wua',
  },
  {
    id: '7471014008',
    districtId: '7471014',
    name: 'Mataiwoi',
  },
  {
    id: '7471014011',
    districtId: '7471014',
    name: 'Anawai',
  },
  {
    id: '7471020003',
    districtId: '7471020',
    name: 'Anduonohu',
  },
  {
    id: '7471020004',
    districtId: '7471020',
    name: 'Rahandouna',
  },
  {
    id: '7471020005',
    districtId: '7471020',
    name: 'Anggoeya',
  },
  {
    id: '7471020007',
    districtId: '7471020',
    name: 'Matabubu',
  },
  {
    id: '7471020008',
    districtId: '7471020',
    name: 'Wundumbatu',
  },
  {
    id: '7471021001',
    districtId: '7471021',
    name: 'Benua Nirae',
  },
  {
    id: '7471021002',
    districtId: '7471021',
    name: 'Pudai',
  },
  {
    id: '7471021004',
    districtId: '7471021',
    name: 'Lapulu',
  },
  {
    id: '7471021005',
    districtId: '7471021',
    name: 'Abeli',
  },
  {
    id: '7471021006',
    districtId: '7471021',
    name: 'Anggolomelai',
  },
  {
    id: '7471021008',
    districtId: '7471021',
    name: 'Poasia',
  },
  {
    id: '7471021009',
    districtId: '7471021',
    name: 'Talia',
  },
  {
    id: '7471022001',
    districtId: '7471022',
    name: 'Mokoau',
  },
  {
    id: '7471022002',
    districtId: '7471022',
    name: 'Kambu',
  },
  {
    id: '7471022003',
    districtId: '7471022',
    name: 'Padaleu',
  },
  {
    id: '7471022004',
    districtId: '7471022',
    name: 'Lalolara',
  },
  {
    id: '7471023001',
    districtId: '7471023',
    name: 'Tobimeita',
  },
  {
    id: '7471023002',
    districtId: '7471023',
    name: 'Petoaha',
  },
  {
    id: '7471023003',
    districtId: '7471023',
    name: 'Nambo',
  },
  {
    id: '7471023004',
    districtId: '7471023',
    name: 'Sambuli',
  },
  {
    id: '7471023005',
    districtId: '7471023',
    name: 'Tondonggeu',
  },
  {
    id: '7471023006',
    districtId: '7471023',
    name: 'Bungkutoko',
  },
  {
    id: '7471030009',
    districtId: '7471030',
    name: 'Kandai',
  },
  {
    id: '7471030010',
    districtId: '7471030',
    name: 'Gunung Jati',
  },
  {
    id: '7471030011',
    districtId: '7471030',
    name: 'Kendari Caddi',
  },
  {
    id: '7471030012',
    districtId: '7471030',
    name: 'Kessilampe',
  },
  {
    id: '7471030013',
    districtId: '7471030',
    name: 'Kampung Salo',
  },
  {
    id: '7471030014',
    districtId: '7471030',
    name: 'Mangga Dua',
  },
  {
    id: '7471030015',
    districtId: '7471030',
    name: 'Mata',
  },
  {
    id: '7471030016',
    districtId: '7471030',
    name: 'Purirano',
  },
  {
    id: '7471030017',
    districtId: '7471030',
    name: 'Jati Mekar',
  },
  {
    id: '7471031001',
    districtId: '7471031',
    name: 'Kemaraya',
  },
  {
    id: '7471031002',
    districtId: '7471031',
    name: 'Watu-Watu',
  },
  {
    id: '7471031003',
    districtId: '7471031',
    name: 'Tipulu',
  },
  {
    id: '7471031004',
    districtId: '7471031',
    name: 'Punggaloba',
  },
  {
    id: '7471031005',
    districtId: '7471031',
    name: 'Benu-Benua',
  },
  {
    id: '7471031006',
    districtId: '7471031',
    name: 'Sodohoa',
  },
  {
    id: '7471031007',
    districtId: '7471031',
    name: 'Sanua',
  },
  {
    id: '7471031008',
    districtId: '7471031',
    name: 'Dapu-Dapura',
  },
  {
    id: '7471031009',
    districtId: '7471031',
    name: 'Lahundape',
  },
  {
    id: '7472010001',
    districtId: '7472010',
    name: 'Sulaa',
  },
  {
    id: '7472010002',
    districtId: '7472010',
    name: 'Waborobo',
  },
  {
    id: '7472010008',
    districtId: '7472010',
    name: 'Lipu',
  },
  {
    id: '7472010009',
    districtId: '7472010',
    name: 'Katobengke',
  },
  {
    id: '7472010010',
    districtId: '7472010',
    name: 'Labalawa',
  },
  {
    id: '7472011001',
    districtId: '7472011',
    name: 'Baadia',
  },
  {
    id: '7472011002',
    districtId: '7472011',
    name: 'Melai',
  },
  {
    id: '7472011003',
    districtId: '7472011',
    name: 'Wajo',
  },
  {
    id: '7472011004',
    districtId: '7472011',
    name: 'Lamangga',
  },
  {
    id: '7472011005',
    districtId: '7472011',
    name: 'Tanganapada',
  },
  {
    id: '7472012001',
    districtId: '7472012',
    name: 'Bone-Bone',
  },
  {
    id: '7472012002',
    districtId: '7472012',
    name: 'Tarafu',
  },
  {
    id: '7472012003',
    districtId: '7472012',
    name: 'Wameo',
  },
  {
    id: '7472012004',
    districtId: '7472012',
    name: 'Kaobula',
  },
  {
    id: '7472012005',
    districtId: '7472012',
    name: 'Lanto',
  },
  {
    id: '7472012006',
    districtId: '7472012',
    name: 'Nganganaumala',
  },
  {
    id: '7472020001',
    districtId: '7472020',
    name: 'Bataraguru',
  },
  {
    id: '7472020002',
    districtId: '7472020',
    name: 'Tomba',
  },
  {
    id: '7472020003',
    districtId: '7472020',
    name: 'Wale',
  },
  {
    id: '7472020004',
    districtId: '7472020',
    name: 'Batulo',
  },
  {
    id: '7472020005',
    districtId: '7472020',
    name: 'Wangkanapi',
  },
  {
    id: '7472020007',
    districtId: '7472020',
    name: 'Bukit Wolio Indah',
  },
  {
    id: '7472020008',
    districtId: '7472020',
    name: 'Kadolo Katapi',
  },
  {
    id: '7472021001',
    districtId: '7472021',
    name: 'Kadolomoko',
  },
  {
    id: '7472021002',
    districtId: '7472021',
    name: 'Waruruma',
  },
  {
    id: '7472021003',
    districtId: '7472021',
    name: 'Lakologou',
  },
  {
    id: '7472021004',
    districtId: '7472021',
    name: 'Liwuto',
  },
  {
    id: '7472021005',
    districtId: '7472021',
    name: 'Sukanayo',
  },
  {
    id: '7472021006',
    districtId: '7472021',
    name: 'Kadolo',
  },
  {
    id: '7472030001',
    districtId: '7472030',
    name: 'Kaisabu Baru',
  },
  {
    id: '7472030002',
    districtId: '7472030',
    name: 'Karya Baru',
  },
  {
    id: '7472030003',
    districtId: '7472030',
    name: 'Bugi',
  },
  {
    id: '7472030004',
    districtId: '7472030',
    name: 'Gonda Baru',
  },
  {
    id: '7472040004',
    districtId: '7472040',
    name: 'Liabuku',
  },
  {
    id: '7472040005',
    districtId: '7472040',
    name: 'Ngkari-Ngkari',
  },
  {
    id: '7472040006',
    districtId: '7472040',
    name: 'Kampeonaho',
  },
  {
    id: '7472040008',
    districtId: '7472040',
    name: 'Waliabuku',
  },
  {
    id: '7472040010',
    districtId: '7472040',
    name: 'Tampuna',
  },
  {
    id: '7472041001',
    districtId: '7472041',
    name: 'Kolese',
  },
  {
    id: '7472041002',
    districtId: '7472041',
    name: 'Lowu-Lowu',
  },
  {
    id: '7472041003',
    districtId: '7472041',
    name: 'Kalia-Lia',
  },
  {
    id: '7472041004',
    districtId: '7472041',
    name: 'Kantalai',
  },
  {
    id: '7472041005',
    districtId: '7472041',
    name: 'Palabusa',
  },
  {
    id: '7501031001',
    districtId: '7501031',
    name: 'Mananggu',
  },
  {
    id: '7501031002',
    districtId: '7501031',
    name: 'Tabulo',
  },
  {
    id: '7501031003',
    districtId: '7501031',
    name: 'Bendungan',
  },
  {
    id: '7501031004',
    districtId: '7501031',
    name: 'Kaaruyan',
  },
  {
    id: '7501031005',
    districtId: '7501031',
    name: 'Salilama',
  },
  {
    id: '7501031006',
    districtId: '7501031',
    name: 'Buti',
  },
  {
    id: '7501031007',
    districtId: '7501031',
    name: 'Pontolo',
  },
  {
    id: '7501031008',
    districtId: '7501031',
    name: 'Keramat',
  },
  {
    id: '7501031009',
    districtId: '7501031',
    name: 'Tabulo Selatan',
  },
  {
    id: '7501040007',
    districtId: '7501040',
    name: 'Lamu',
  },
  {
    id: '7501040008',
    districtId: '7501040',
    name: 'Bajo',
  },
  {
    id: '7501040009',
    districtId: '7501040',
    name: 'Pentadu Barat',
  },
  {
    id: '7501040010',
    districtId: '7501040',
    name: 'Modelomo',
  },
  {
    id: '7501040011',
    districtId: '7501040',
    name: 'Hungayonaa',
  },
  {
    id: '7501040012',
    districtId: '7501040',
    name: 'Ayuhulalo',
  },
  {
    id: '7501040013',
    districtId: '7501040',
    name: 'Piloliyanga',
  },
  {
    id: '7501040014',
    districtId: '7501040',
    name: 'Limbato',
  },
  {
    id: '7501040015',
    districtId: '7501040',
    name: 'Mohungo',
  },
  {
    id: '7501040016',
    districtId: '7501040',
    name: 'Pentadu Timur',
  },
  {
    id: '7501040017',
    districtId: '7501040',
    name: 'Lahumbo',
  },
  {
    id: '7501040018',
    districtId: '7501040',
    name: 'Tenilo',
  },
  {
    id: '7501041001',
    districtId: '7501041',
    name: 'Dulupi',
  },
  {
    id: '7501041002',
    districtId: '7501041',
    name: 'Pangi',
  },
  {
    id: '7501041003',
    districtId: '7501041',
    name: 'Tangga Jaya',
  },
  {
    id: '7501041004',
    districtId: '7501041',
    name: 'Polohungo',
  },
  {
    id: '7501041005',
    districtId: '7501041',
    name: 'Kotaraja',
  },
  {
    id: '7501041006',
    districtId: '7501041',
    name: 'Tabongo',
  },
  {
    id: '7501041007',
    districtId: '7501041',
    name: 'Tanah Putih',
  },
  {
    id: '7501041008',
    districtId: '7501041',
    name: 'Tangga Barito',
  },
  {
    id: '7501042001',
    districtId: '7501042',
    name: 'Bolihutuo',
  },
  {
    id: '7501042002',
    districtId: '7501042',
    name: 'Tapadaa',
  },
  {
    id: '7501042003',
    districtId: '7501042',
    name: 'Rumbia',
  },
  {
    id: '7501042004',
    districtId: '7501042',
    name: 'Hutamonu',
  },
  {
    id: '7501042005',
    districtId: '7501042',
    name: 'Botumoito',
  },
  {
    id: '7501042006',
    districtId: '7501042',
    name: 'Tutulo',
  },
  {
    id: '7501042007',
    districtId: '7501042',
    name: 'Patoameme',
  },
  {
    id: '7501042008',
    districtId: '7501042',
    name: 'Potanga',
  },
  {
    id: '7501042009',
    districtId: '7501042',
    name: 'Dulangeya',
  },
  {
    id: '7501050004',
    districtId: '7501050',
    name: 'Tangkobu',
  },
  {
    id: '7501050005',
    districtId: '7501050',
    name: 'Molombulahe',
  },
  {
    id: '7501050006',
    districtId: '7501050',
    name: 'Wonggahu',
  },
  {
    id: '7501050007',
    districtId: '7501050',
    name: 'Saripi',
  },
  {
    id: '7501050008',
    districtId: '7501050',
    name: 'Bongo Nol',
  },
  {
    id: '7501050009',
    districtId: '7501050',
    name: 'Sumber Jaya',
  },
  {
    id: '7501050011',
    districtId: '7501050',
    name: 'Mutiara',
  },
  {
    id: '7501050017',
    districtId: '7501050',
    name: 'Karya Murni',
  },
  {
    id: '7501050018',
    districtId: '7501050',
    name: 'Girisa',
  },
  {
    id: '7501050021',
    districtId: '7501050',
    name: 'Kuala Lumpur',
  },
  {
    id: '7501050022',
    districtId: '7501050',
    name: 'Tenilo',
  },
  {
    id: '7501050023',
    districtId: '7501050',
    name: 'Mustika',
  },
  {
    id: '7501050024',
    districtId: '7501050',
    name: 'Huwongo',
  },
  {
    id: '7501050025',
    districtId: '7501050',
    name: 'Bongo Tua',
  },
  {
    id: '7501050026',
    districtId: '7501050',
    name: 'Rejonegoro',
  },
  {
    id: '7501050027',
    districtId: '7501050',
    name: 'Balate Jaya',
  },
  {
    id: '7501050028',
    districtId: '7501050',
    name: 'Hulawa',
  },
  {
    id: '7501050029',
    districtId: '7501050',
    name: 'Diloato',
  },
  {
    id: '7501050030',
    districtId: '7501050',
    name: 'Permata',
  },
  {
    id: '7501050031',
    districtId: '7501050',
    name: 'Batu Kramat',
  },
  {
    id: '7501050032',
    districtId: '7501050',
    name: 'Sosial',
  },
  {
    id: '7501050033',
    districtId: '7501050',
    name: 'Bualo',
  },
  {
    id: '7501051001',
    districtId: '7501051',
    name: 'Mekar Jaya',
  },
  {
    id: '7501051002',
    districtId: '7501051',
    name: 'Harapan',
  },
  {
    id: '7501051003',
    districtId: '7501051',
    name: 'Suka Maju',
  },
  {
    id: '7501051004',
    districtId: '7501051',
    name: 'Makmur',
  },
  {
    id: '7501051005',
    districtId: '7501051',
    name: 'Sejahtera',
  },
  {
    id: '7501051006',
    districtId: '7501051',
    name: 'Pangea',
  },
  {
    id: '7501051007',
    districtId: '7501051',
    name: 'Jati Mulya',
  },
  {
    id: '7501051008',
    districtId: '7501051',
    name: 'Tri Rukun',
  },
  {
    id: '7501051009',
    districtId: '7501051',
    name: 'Raharja',
  },
  {
    id: '7501051010',
    districtId: '7501051',
    name: 'Dimito',
  },
  {
    id: '7501051011',
    districtId: '7501051',
    name: 'Suka Mulia',
  },
  {
    id: '7501051012',
    districtId: '7501051',
    name: 'Sari Tani',
  },
  {
    id: '7501051013',
    districtId: '7501051',
    name: 'Tanjung Harapan',
  },
  {
    id: '7501051014',
    districtId: '7501051',
    name: 'Dulohupa',
  },
  {
    id: '7501052001',
    districtId: '7501052',
    name: 'Limbatihu',
  },
  {
    id: '7501052002',
    districtId: '7501052',
    name: 'Bubaa',
  },
  {
    id: '7501052003',
    districtId: '7501052',
    name: 'Lito',
  },
  {
    id: '7501052004',
    districtId: '7501052',
    name: 'Bukit Karya',
  },
  {
    id: '7501052005',
    districtId: '7501052',
    name: 'Apitalawu',
  },
  {
    id: '7501052006',
    districtId: '7501052',
    name: 'Olibu',
  },
  {
    id: '7501052007',
    districtId: '7501052',
    name: 'Towayu',
  },
  {
    id: '7501052008',
    districtId: '7501052',
    name: 'Bangga',
  },
  {
    id: '7502010006',
    districtId: '7502010',
    name: 'Lamu',
  },
  {
    id: '7502010007',
    districtId: '7502010',
    name: 'Tontayuo',
  },
  {
    id: '7502010008',
    districtId: '7502010',
    name: 'Biluhu Timur',
  },
  {
    id: '7502010009',
    districtId: '7502010',
    name: 'Kayubulan',
  },
  {
    id: '7502010010',
    districtId: '7502010',
    name: 'Lopo',
  },
  {
    id: '7502010011',
    districtId: '7502010',
    name: 'Bongo',
  },
  {
    id: '7502010013',
    districtId: '7502010',
    name: "Olimoo'O",
  },
  {
    id: '7502010014',
    districtId: '7502010',
    name: 'Langgula',
  },
  {
    id: '7502010015',
    districtId: '7502010',
    name: 'Buhudaa',
  },
  {
    id: '7502011001',
    districtId: '7502011',
    name: 'Huwongo',
  },
  {
    id: '7502011002',
    districtId: '7502011',
    name: 'Biluhu Barat',
  },
  {
    id: '7502011003',
    districtId: '7502011',
    name: 'Lobuto',
  },
  {
    id: '7502011004',
    districtId: '7502011',
    name: 'Luluo',
  },
  {
    id: '7502011005',
    districtId: '7502011',
    name: 'Biluhu Tengah',
  },
  {
    id: '7502011006',
    districtId: '7502011',
    name: 'Lobuto Timur',
  },
  {
    id: '7502011007',
    districtId: '7502011',
    name: 'Olimeyala',
  },
  {
    id: '7502011008',
    districtId: '7502011',
    name: "Botubolu'O",
  },
  {
    id: '7502020019',
    districtId: '7502020',
    name: 'Payunga',
  },
  {
    id: '7502020021',
    districtId: '7502020',
    name: 'Bua',
  },
  {
    id: '7502020022',
    districtId: '7502020',
    name: 'Iluta',
  },
  {
    id: '7502020025',
    districtId: '7502020',
    name: 'Barakati',
  },
  {
    id: '7502020026',
    districtId: '7502020',
    name: 'Dunggala',
  },
  {
    id: '7502020027',
    districtId: '7502020',
    name: 'Ilohungayo',
  },
  {
    id: '7502020028',
    districtId: '7502020',
    name: 'Pilobuhuta',
  },
  {
    id: '7502021001',
    districtId: '7502021',
    name: 'Molanihu',
  },
  {
    id: '7502021002',
    districtId: '7502021',
    name: 'Batulayar',
  },
  {
    id: '7502021003',
    districtId: '7502021',
    name: 'Molas',
  },
  {
    id: '7502021004',
    districtId: '7502021',
    name: 'Tohupo',
  },
  {
    id: '7502021005',
    districtId: '7502021',
    name: 'Molopatodu',
  },
  {
    id: '7502021006',
    districtId: '7502021',
    name: 'Upomela',
  },
  {
    id: '7502021007',
    districtId: '7502021',
    name: 'Dulamayo',
  },
  {
    id: '7502021014',
    districtId: '7502021',
    name: 'Otopade',
  },
  {
    id: '7502021015',
    districtId: '7502021',
    name: 'Batu Loreng',
  },
  {
    id: '7502021016',
    districtId: '7502021',
    name: 'Bongohulawa',
  },
  {
    id: '7502021017',
    districtId: '7502021',
    name: 'Huntulohulawa',
  },
  {
    id: '7502021020',
    districtId: '7502021',
    name: 'Liyodu',
  },
  {
    id: '7502021021',
    districtId: '7502021',
    name: 'Kayumerah',
  },
  {
    id: '7502021022',
    districtId: '7502021',
    name: 'Owalanga',
  },
  {
    id: '7502021025',
    districtId: '7502021',
    name: 'Liyoto',
  },
  {
    id: '7502022001',
    districtId: '7502022',
    name: 'Tabongo Barat',
  },
  {
    id: '7502022002',
    districtId: '7502022',
    name: 'Limehe Barat',
  },
  {
    id: '7502022003',
    districtId: '7502022',
    name: 'Ilomangga',
  },
  {
    id: '7502022004',
    districtId: '7502022',
    name: 'Tabongo Timur',
  },
  {
    id: '7502022005',
    districtId: '7502022',
    name: 'Limehe Timur',
  },
  {
    id: '7502022006',
    districtId: '7502022',
    name: 'Motinelo',
  },
  {
    id: '7502022007',
    districtId: '7502022',
    name: 'Moahudu',
  },
  {
    id: '7502022008',
    districtId: '7502022',
    name: 'Teratai',
  },
  {
    id: '7502022009',
    districtId: '7502022',
    name: 'Limehu',
  },
  {
    id: '7502023001',
    districtId: '7502023',
    name: 'Momala',
  },
  {
    id: '7502023002',
    districtId: '7502023',
    name: 'Ambara',
  },
  {
    id: '7502023003',
    districtId: '7502023',
    name: 'Ayuhula',
  },
  {
    id: '7502023004',
    districtId: '7502023',
    name: 'Botubulowe',
  },
  {
    id: '7502023005',
    districtId: '7502023',
    name: 'Dungaliyo',
  },
  {
    id: '7502023006',
    districtId: '7502023',
    name: 'Pilolalenga',
  },
  {
    id: '7502023007',
    districtId: '7502023',
    name: 'Kaliyoso',
  },
  {
    id: '7502023008',
    districtId: '7502023',
    name: 'Pangadaa',
  },
  {
    id: '7502023009',
    districtId: '7502023',
    name: 'Bongomeme',
  },
  {
    id: '7502023010',
    districtId: '7502023',
    name: 'Duwanga',
  },
  {
    id: '7502030004',
    districtId: '7502030',
    name: 'Ilomata',
  },
  {
    id: '7502030005',
    districtId: '7502030',
    name: 'Molowahu',
  },
  {
    id: '7502030006',
    districtId: '7502030',
    name: 'Dunggala',
  },
  {
    id: '7502030007',
    districtId: '7502030',
    name: 'Reksonegoro',
  },
  {
    id: '7502030008',
    districtId: '7502030',
    name: 'Tolotio',
  },
  {
    id: '7502030009',
    districtId: '7502030',
    name: 'Isimu Selatan',
  },
  {
    id: '7502030010',
    districtId: '7502030',
    name: 'Datahu',
  },
  {
    id: '7502030016',
    districtId: '7502030',
    name: 'Iloponu',
  },
  {
    id: '7502030018',
    districtId: '7502030',
    name: 'Isimu Utara',
  },
  {
    id: '7502030019',
    districtId: '7502030',
    name: 'Labanu',
  },
  {
    id: '7502030021',
    districtId: '7502030',
    name: 'Motilango',
  },
  {
    id: '7502030022',
    districtId: '7502030',
    name: 'Balahu',
  },
  {
    id: '7502030023',
    districtId: '7502030',
    name: 'Botumoputi',
  },
  {
    id: '7502030024',
    districtId: '7502030',
    name: 'Isimu Raya',
  },
  {
    id: '7502030025',
    districtId: '7502030',
    name: 'Ulobua',
  },
  {
    id: '7502031001',
    districtId: '7502031',
    name: 'Mulyonegoro',
  },
  {
    id: '7502031002',
    districtId: '7502031',
    name: 'Bakti',
  },
  {
    id: '7502031003',
    districtId: '7502031',
    name: 'Pulubala',
  },
  {
    id: '7502031004',
    districtId: '7502031',
    name: 'Tridarma',
  },
  {
    id: '7502031005',
    districtId: '7502031',
    name: 'Pongongaila',
  },
  {
    id: '7502031006',
    districtId: '7502031',
    name: 'Puncak',
  },
  {
    id: '7502031007',
    districtId: '7502031',
    name: 'Molamahu',
  },
  {
    id: '7502031008',
    districtId: '7502031',
    name: 'Molalahu',
  },
  {
    id: '7502031009',
    districtId: '7502031',
    name: 'Toydito',
  },
  {
    id: '7502031010',
    districtId: '7502031',
    name: 'Ayumolingo',
  },
  {
    id: '7502031011',
    districtId: '7502031',
    name: 'Bukit Aren',
  },
  {
    id: '7502031012',
    districtId: '7502031',
    name: 'UPT Ayumolingo',
  },
  {
    id: '7502031013',
    districtId: '7502031',
    name: 'UPT Puncak',
  },
  {
    id: '7502040007',
    districtId: '7502040',
    name: 'Parungi',
  },
  {
    id: '7502040008',
    districtId: '7502040',
    name: 'Sido Mulyo',
  },
  {
    id: '7502040009',
    districtId: '7502040',
    name: 'Sidodadi',
  },
  {
    id: '7502040016',
    districtId: '7502040',
    name: 'Diloniyohu',
  },
  {
    id: '7502040017',
    districtId: '7502040',
    name: 'Motoduto',
  },
  {
    id: '7502040018',
    districtId: '7502040',
    name: 'Potanga',
  },
  {
    id: '7502040020',
    districtId: '7502040',
    name: 'Bandung Rejo',
  },
  {
    id: '7502040021',
    districtId: '7502040',
    name: 'Iloheluma',
  },
  {
    id: '7502040022',
    districtId: '7502040',
    name: 'Monggolito',
  },
  {
    id: '7502040023',
    districtId: '7502040',
    name: 'Dulohupa',
  },
  {
    id: '7502040024',
    districtId: '7502040',
    name: 'Sidomulyo Selatan',
  },
  {
    id: '7502040025',
    districtId: '7502040',
    name: 'Bongongoayu',
  },
  {
    id: '7502040026',
    districtId: '7502040',
    name: 'Tolite',
  },
  {
    id: '7502041001',
    districtId: '7502041',
    name: 'Talumopatu',
  },
  {
    id: '7502041002',
    districtId: '7502041',
    name: 'Sido Mukti',
  },
  {
    id: '7502041003',
    districtId: '7502041',
    name: 'Karya Mukti',
  },
  {
    id: '7502041004',
    districtId: '7502041',
    name: 'Satria',
  },
  {
    id: '7502041005',
    districtId: '7502041',
    name: 'Paris',
  },
  {
    id: '7502041006',
    districtId: '7502041',
    name: 'Helumo',
  },
  {
    id: '7502041007',
    districtId: '7502041',
    name: 'Pilomonu',
  },
  {
    id: '7502041008',
    districtId: '7502041',
    name: 'Huyula',
  },
  {
    id: '7502041009',
    districtId: '7502041',
    name: 'Payu',
  },
  {
    id: '7502041010',
    districtId: '7502041',
    name: 'Suka Maju',
  },
  {
    id: '7502042001',
    districtId: '7502042',
    name: 'Gandasari',
  },
  {
    id: '7502042002',
    districtId: '7502042',
    name: 'Sukamakmur',
  },
  {
    id: '7502042003',
    districtId: '7502042',
    name: 'Molohu',
  },
  {
    id: '7502042004',
    districtId: '7502042',
    name: 'Lakeya',
  },
  {
    id: '7502042007',
    districtId: '7502042',
    name: 'Polohungo',
  },
  {
    id: '7502042008',
    districtId: '7502042',
    name: 'Bina Jaya',
  },
  {
    id: '7502042009',
    districtId: '7502042',
    name: 'Tamaila',
  },
  {
    id: '7502042010',
    districtId: '7502042',
    name: 'Sidoarjo',
  },
  {
    id: '7502042013',
    districtId: '7502042',
    name: 'Sukamakmur Utara',
  },
  {
    id: '7502042014',
    districtId: '7502042',
    name: 'Margomulya',
  },
  {
    id: '7502042015',
    districtId: '7502042',
    name: 'Makmur Abadi',
  },
  {
    id: '7502042016',
    districtId: '7502042',
    name: 'Gandaria',
  },
  {
    id: '7502042017',
    districtId: '7502042',
    name: 'Ombulo Tango',
  },
  {
    id: '7502042018',
    districtId: '7502042',
    name: 'Tamaila Utara',
  },
  {
    id: '7502042019',
    districtId: '7502042',
    name: 'Himalaya',
  },
  {
    id: '7502043001',
    districtId: '7502043',
    name: 'Bululi',
  },
  {
    id: '7502043002',
    districtId: '7502043',
    name: 'Mohiyolo',
  },
  {
    id: '7502043003',
    districtId: '7502043',
    name: 'Karya Indah',
  },
  {
    id: '7502043004',
    districtId: '7502043',
    name: 'Pangahu',
  },
  {
    id: '7502043005',
    districtId: '7502043',
    name: 'Tiohu',
  },
  {
    id: '7502043006',
    districtId: '7502043',
    name: 'Prima',
  },
  {
    id: '7502043007',
    districtId: '7502043',
    name: 'Karya Baru',
  },
  {
    id: '7502043008',
    districtId: '7502043',
    name: 'Bontula',
  },
  {
    id: '7502043009',
    districtId: '7502043',
    name: 'Bihe',
  },
  {
    id: '7502043010',
    districtId: '7502043',
    name: 'Olimohulo',
  },
  {
    id: '7502044001',
    districtId: '7502044',
    name: 'Bilato',
  },
  {
    id: '7502044002',
    districtId: '7502044',
    name: 'Ilomata',
  },
  {
    id: '7502044004',
    districtId: '7502044',
    name: 'Taulaa',
  },
  {
    id: '7502044005',
    districtId: '7502044',
    name: 'Juriya',
  },
  {
    id: '7502044006',
    districtId: '7502044',
    name: 'Bumela',
  },
  {
    id: '7502044007',
    districtId: '7502044',
    name: 'Totopo',
  },
  {
    id: '7502044008',
    districtId: '7502044',
    name: 'Suka Damai',
  },
  {
    id: '7502044009',
    districtId: '7502044',
    name: 'Lamahu',
  },
  {
    id: '7502044010',
    districtId: '7502044',
    name: 'Musyawarah',
  },
  {
    id: '7502070005',
    districtId: '7502070',
    name: 'Tenilo',
  },
  {
    id: '7502070006',
    districtId: '7502070',
    name: 'Bolihuangga',
  },
  {
    id: '7502070007',
    districtId: '7502070',
    name: 'Hunggaluwa',
  },
  {
    id: '7502070008',
    districtId: '7502070',
    name: 'Kayubulan',
  },
  {
    id: '7502070009',
    districtId: '7502070',
    name: 'Hepuhulawa',
  },
  {
    id: '7502070010',
    districtId: '7502070',
    name: 'Dutulanaa',
  },
  {
    id: '7502070011',
    districtId: '7502070',
    name: 'Hutuo',
  },
  {
    id: '7502070012',
    districtId: '7502070',
    name: 'Bulota',
  },
  {
    id: '7502070013',
    districtId: '7502070',
    name: 'Malahu',
  },
  {
    id: '7502070014',
    districtId: '7502070',
    name: 'Biyonga',
  },
  {
    id: '7502070015',
    districtId: '7502070',
    name: 'Bongohulawa',
  },
  {
    id: '7502070016',
    districtId: '7502070',
    name: 'Kayumerah',
  },
  {
    id: '7502070017',
    districtId: '7502070',
    name: 'Polohungo',
  },
  {
    id: '7502070018',
    districtId: '7502070',
    name: 'Tilihuwa',
  },
  {
    id: '7502071001',
    districtId: '7502071',
    name: 'Padengo',
  },
  {
    id: '7502071002',
    districtId: '7502071',
    name: 'Hutabohu',
  },
  {
    id: '7502071003',
    districtId: '7502071',
    name: 'Yoosonegoro',
  },
  {
    id: '7502071004',
    districtId: '7502071',
    name: 'Tunggulo',
  },
  {
    id: '7502071005',
    districtId: '7502071',
    name: 'Pone',
  },
  {
    id: '7502071006',
    districtId: '7502071',
    name: 'Huidu',
  },
  {
    id: '7502071007',
    districtId: '7502071',
    name: 'Ombulo',
  },
  {
    id: '7502071008',
    districtId: '7502071',
    name: 'Daenaa',
  },
  {
    id: '7502071009',
    districtId: '7502071',
    name: 'Huidu Utara',
  },
  {
    id: '7502071010',
    districtId: '7502071',
    name: 'Haya-Haya',
  },
  {
    id: '7502080011',
    districtId: '7502080',
    name: 'Bulila',
  },
  {
    id: '7502080014',
    districtId: '7502080',
    name: 'Mongolato',
  },
  {
    id: '7502080016',
    districtId: '7502080',
    name: 'Hulawa',
  },
  {
    id: '7502080017',
    districtId: '7502080',
    name: 'Pilohayanga',
  },
  {
    id: '7502080027',
    districtId: '7502080',
    name: 'Dulamayo Selatan',
  },
  {
    id: '7502080028',
    districtId: '7502080',
    name: 'Dulamayo Barat',
  },
  {
    id: '7502080029',
    districtId: '7502080',
    name: 'Pilohayanga Barat',
  },
  {
    id: '7502080030',
    districtId: '7502080',
    name: 'Doluhupa',
  },
  {
    id: '7502081001',
    districtId: '7502081',
    name: 'Lupoyo',
  },
  {
    id: '7502081002',
    districtId: '7502081',
    name: 'Pantungo',
  },
  {
    id: '7502081003',
    districtId: '7502081',
    name: 'Dumati',
  },
  {
    id: '7502081004',
    districtId: '7502081',
    name: 'Tuladenggi',
  },
  {
    id: '7502081005',
    districtId: '7502081',
    name: 'Ulapato.A',
  },
  {
    id: '7502081006',
    districtId: '7502081',
    name: 'Pentadio Timur',
  },
  {
    id: '7502081007',
    districtId: '7502081',
    name: 'Pentadio Barat',
  },
  {
    id: '7502081008',
    districtId: '7502081',
    name: 'Talumelito',
  },
  {
    id: '7502081009',
    districtId: '7502081',
    name: 'Ulapato.B',
  },
  {
    id: '7502081010',
    districtId: '7502081',
    name: 'Dulamayo Utara',
  },
  {
    id: '7502081011',
    districtId: '7502081',
    name: 'Modellidu',
  },
  {
    id: '7502081012',
    districtId: '7502081',
    name: 'Tinelo',
  },
  {
    id: '7502081013',
    districtId: '7502081',
    name: 'Timuato',
  },
  {
    id: '7502081014',
    districtId: '7502081',
    name: 'Tapaluluo',
  },
  {
    id: '7502081015',
    districtId: '7502081',
    name: 'Tonala',
  },
  {
    id: '7502082001',
    districtId: '7502082',
    name: 'Tualango',
  },
  {
    id: '7502082002',
    districtId: '7502082',
    name: 'Dulomo',
  },
  {
    id: '7502082003',
    districtId: '7502082',
    name: 'Tilote',
  },
  {
    id: '7502082004',
    districtId: '7502082',
    name: 'Tabumela',
  },
  {
    id: '7502082005',
    districtId: '7502082',
    name: 'Ilotidea',
  },
  {
    id: '7502082006',
    districtId: '7502082',
    name: 'Lauwonu',
  },
  {
    id: '7502082007',
    districtId: '7502082',
    name: 'Tenggela',
  },
  {
    id: '7502082008',
    districtId: '7502082',
    name: 'Tinelo',
  },
  {
    id: '7502083001',
    districtId: '7502083',
    name: 'Hutadaa',
  },
  {
    id: '7502083003',
    districtId: '7502083',
    name: 'Luwoo',
  },
  {
    id: '7502083004',
    districtId: '7502083',
    name: 'Bunggalo',
  },
  {
    id: '7502083005',
    districtId: '7502083',
    name: 'Bulota',
  },
  {
    id: '7503010003',
    districtId: '7503010',
    name: 'Torosiaje',
  },
  {
    id: '7503010004',
    districtId: '7503010',
    name: 'Popayato',
  },
  {
    id: '7503010005',
    districtId: '7503010',
    name: 'Telaga',
  },
  {
    id: '7503010019',
    districtId: '7503010',
    name: 'Torosiaje Jaya',
  },
  {
    id: '7503010021',
    districtId: '7503010',
    name: 'Bukit Tingki',
  },
  {
    id: '7503010023',
    districtId: '7503010',
    name: 'Trikora',
  },
  {
    id: '7503010024',
    districtId: '7503010',
    name: 'Telaga Biru',
  },
  {
    id: '7503010025',
    districtId: '7503010',
    name: 'Dambalo',
  },
  {
    id: '7503010026',
    districtId: '7503010',
    name: 'Bumi Bahari',
  },
  {
    id: '7503010027',
    districtId: '7503010',
    name: 'Tunas Harapan',
  },
  {
    id: '7503011001',
    districtId: '7503011',
    name: 'Molosipat',
  },
  {
    id: '7503011002',
    districtId: '7503011',
    name: 'Dudewulo',
  },
  {
    id: '7503011003',
    districtId: '7503011',
    name: 'Tunas Jaya',
  },
  {
    id: '7503011004',
    districtId: '7503011',
    name: 'Padengo',
  },
  {
    id: '7503011005',
    districtId: '7503011',
    name: 'Molosipat Utara',
  },
  {
    id: '7503011006',
    districtId: '7503011',
    name: 'Persatuan',
  },
  {
    id: '7503011007',
    districtId: '7503011',
    name: 'Butungale',
  },
  {
    id: '7503012001',
    districtId: '7503012',
    name: 'Tahele',
  },
  {
    id: '7503012002',
    districtId: '7503012',
    name: 'Bunto',
  },
  {
    id: '7503012003',
    districtId: '7503012',
    name: 'Londoun',
  },
  {
    id: '7503012004',
    districtId: '7503012',
    name: 'Milangodaa',
  },
  {
    id: '7503012005',
    districtId: '7503012',
    name: 'Marisa',
  },
  {
    id: '7503012006',
    districtId: '7503012',
    name: 'Maleo',
  },
  {
    id: '7503012007',
    districtId: '7503012',
    name: 'Kelapa Lima',
  },
  {
    id: '7503020001',
    districtId: '7503020',
    name: 'Lomuli',
  },
  {
    id: '7503020002',
    districtId: '7503020',
    name: 'Lemito',
  },
  {
    id: '7503020003',
    districtId: '7503020',
    name: 'Wonggarasi Barat',
  },
  {
    id: '7503020008',
    districtId: '7503020',
    name: 'Kenari',
  },
  {
    id: '7503020009',
    districtId: '7503020',
    name: 'Lemito Utara',
  },
  {
    id: '7503020010',
    districtId: '7503020',
    name: 'Wonggarasi Tengah',
  },
  {
    id: '7503020011',
    districtId: '7503020',
    name: 'Suka Damai',
  },
  {
    id: '7503020012',
    districtId: '7503020',
    name: 'Balobalonge',
  },
  {
    id: '7503021001',
    districtId: '7503021',
    name: 'Wonggarasi Timur',
  },
  {
    id: '7503021002',
    districtId: '7503021',
    name: 'Bukit Harapan',
  },
  {
    id: '7503021003',
    districtId: '7503021',
    name: 'Bohusami',
  },
  {
    id: '7503021004',
    districtId: '7503021',
    name: 'Lembah Permai',
  },
  {
    id: '7503021005',
    districtId: '7503021',
    name: 'Limbula',
  },
  {
    id: '7503021006',
    districtId: '7503021',
    name: 'Tuweya',
  },
  {
    id: '7503021007',
    districtId: '7503021',
    name: 'Yipilo',
  },
  {
    id: '7503030005',
    districtId: '7503030',
    name: 'Marisa Selatan',
  },
  {
    id: '7503030006',
    districtId: '7503030',
    name: 'Pohuwato',
  },
  {
    id: '7503030007',
    districtId: '7503030',
    name: 'Marisa Utara',
  },
  {
    id: '7503030008',
    districtId: '7503030',
    name: 'Teratai',
  },
  {
    id: '7503030019',
    districtId: '7503030',
    name: 'Botubilotahu Indah',
  },
  {
    id: '7503030020',
    districtId: '7503030',
    name: 'Palopo',
  },
  {
    id: '7503030021',
    districtId: '7503030',
    name: 'Pohuwato Timur',
  },
  {
    id: '7503030022',
    districtId: '7503030',
    name: 'Bulangita',
  },
  {
    id: '7503031001',
    districtId: '7503031',
    name: 'Ilo Heluma',
  },
  {
    id: '7503031002',
    districtId: '7503031',
    name: 'Balayo',
  },
  {
    id: '7503031003',
    districtId: '7503031',
    name: 'Manawa',
  },
  {
    id: '7503031004',
    districtId: '7503031',
    name: 'Suka Makmur',
  },
  {
    id: '7503031005',
    districtId: '7503031',
    name: 'Dudepo',
  },
  {
    id: '7503031006',
    districtId: '7503031',
    name: 'Dulomo',
  },
  {
    id: '7503032001',
    districtId: '7503032',
    name: 'Buntulia Utara',
  },
  {
    id: '7503032002',
    districtId: '7503032',
    name: 'Taluduyunu',
  },
  {
    id: '7503032003',
    districtId: '7503032',
    name: 'Hulawa',
  },
  {
    id: '7503032004',
    districtId: '7503032',
    name: 'Buntulia Tengah',
  },
  {
    id: '7503032005',
    districtId: '7503032',
    name: 'Karya Indah',
  },
  {
    id: '7503032006',
    districtId: '7503032',
    name: 'Sipatana',
  },
  {
    id: '7503032007',
    districtId: '7503032',
    name: 'Taluduyunu Utara',
  },
  {
    id: '7503033001',
    districtId: '7503033',
    name: 'Duhiadaa',
  },
  {
    id: '7503033002',
    districtId: '7503033',
    name: 'Bulili',
  },
  {
    id: '7503033003',
    districtId: '7503033',
    name: 'Buntulia Selatan',
  },
  {
    id: '7503033005',
    districtId: '7503033',
    name: 'Mekar Jaya',
  },
  {
    id: '7503033006',
    districtId: '7503033',
    name: 'Buntulia Barat',
  },
  {
    id: '7503033007',
    districtId: '7503033',
    name: 'Padengo',
  },
  {
    id: '7503033008',
    districtId: '7503033',
    name: 'Buntulia Jaya',
  },
  {
    id: '7503033009',
    districtId: '7503033',
    name: 'Mootilango',
  },
  {
    id: '7503040001',
    districtId: '7503040',
    name: 'Sidorukun',
  },
  {
    id: '7503040002',
    districtId: '7503040',
    name: 'Motolohu',
  },
  {
    id: '7503040003',
    districtId: '7503040',
    name: 'Huyula',
  },
  {
    id: '7503040004',
    districtId: '7503040',
    name: 'Imbodu',
  },
  {
    id: '7503040005',
    districtId: '7503040',
    name: 'Manunggal Karya',
  },
  {
    id: '7503040006',
    districtId: '7503040',
    name: 'Sari Murni',
  },
  {
    id: '7503040013',
    districtId: '7503040',
    name: 'Patuhu',
  },
  {
    id: '7503040014',
    districtId: '7503040',
    name: 'Ayula',
  },
  {
    id: '7503040015',
    districtId: '7503040',
    name: 'Omayuwa',
  },
  {
    id: '7503040016',
    districtId: '7503040',
    name: 'Banuroja',
  },
  {
    id: '7503040017',
    districtId: '7503040',
    name: 'Pelambane',
  },
  {
    id: '7503040018',
    districtId: '7503040',
    name: 'Motolohu Selatan',
  },
  {
    id: '7503040019',
    districtId: '7503040',
    name: 'Siduwonge',
  },
  {
    id: '7503041001',
    districtId: '7503041',
    name: 'Malango',
  },
  {
    id: '7503041002',
    districtId: '7503041',
    name: 'Panca Karsa I',
  },
  {
    id: '7503041003',
    districtId: '7503041',
    name: 'Panca Karsa II',
  },
  {
    id: '7503041004',
    districtId: '7503041',
    name: 'Kalimas',
  },
  {
    id: '7503041005',
    districtId: '7503041',
    name: 'Mekarti Jaya',
  },
  {
    id: '7503041006',
    districtId: '7503041',
    name: 'Puncak Jaya',
  },
  {
    id: '7503041007',
    districtId: '7503041',
    name: 'Tirto Asri',
  },
  {
    id: '7503050001',
    districtId: '7503050',
    name: 'Libuo',
  },
  {
    id: '7503050002',
    districtId: '7503050',
    name: 'Pentadu',
  },
  {
    id: '7503050003',
    districtId: '7503050',
    name: 'Siduan',
  },
  {
    id: '7503050004',
    districtId: '7503050',
    name: 'Bunuyo',
  },
  {
    id: '7503050005',
    districtId: '7503050',
    name: 'Sipayo',
  },
  {
    id: '7503050006',
    districtId: '7503050',
    name: 'Soginti',
  },
  {
    id: '7503050010',
    districtId: '7503050',
    name: 'Maleo',
  },
  {
    id: '7503050011',
    districtId: '7503050',
    name: 'Bumbulan',
  },
  {
    id: '7503050012',
    districtId: '7503050',
    name: 'Buhu Jaya',
  },
  {
    id: '7503050013',
    districtId: '7503050',
    name: 'Molamahu',
  },
  {
    id: '7503050014',
    districtId: '7503050',
    name: 'Kemiri',
  },
  {
    id: '7503051001',
    districtId: '7503051',
    name: 'Popaya',
  },
  {
    id: '7503051002',
    districtId: '7503051',
    name: 'Padengo',
  },
  {
    id: '7503051003',
    districtId: '7503051',
    name: 'Karangetang',
  },
  {
    id: '7503051004',
    districtId: '7503051',
    name: 'Karya Baru',
  },
  {
    id: '7503051005',
    districtId: '7503051',
    name: 'Huta Moputi',
  },
  {
    id: '7504010006',
    districtId: '7504010',
    name: 'Talulobutu',
  },
  {
    id: '7504010007',
    districtId: '7504010',
    name: 'Talumopatu',
  },
  {
    id: '7504010008',
    districtId: '7504010',
    name: 'Dunggala',
  },
  {
    id: '7504010010',
    districtId: '7504010',
    name: 'Langge',
  },
  {
    id: '7504010011',
    districtId: '7504010',
    name: 'Talulobutu Selatan',
  },
  {
    id: '7504010012',
    districtId: '7504010',
    name: 'Kramat',
  },
  {
    id: '7504010013',
    districtId: '7504010',
    name: 'Meranti',
  },
  {
    id: '7504011005',
    districtId: '7504011',
    name: 'Bandungan',
  },
  {
    id: '7504011011',
    districtId: '7504011',
    name: 'Boidu',
  },
  {
    id: '7504011012',
    districtId: '7504011',
    name: 'Tupa',
  },
  {
    id: '7504011013',
    districtId: '7504011',
    name: 'Longalo',
  },
  {
    id: '7504011016',
    districtId: '7504011',
    name: 'Tuloa',
  },
  {
    id: '7504011019',
    districtId: '7504011',
    name: 'Lomaya',
  },
  {
    id: '7504011020',
    districtId: '7504011',
    name: 'Kopi',
  },
  {
    id: '7504011021',
    districtId: '7504011',
    name: 'Bunuo',
  },
  {
    id: '7504011022',
    districtId: '7504011',
    name: 'Suka Damai',
  },
  {
    id: '7504012001',
    districtId: '7504012',
    name: 'Ayula Selatan',
  },
  {
    id: '7504012002',
    districtId: '7504012',
    name: 'Huntu Selatan',
  },
  {
    id: '7504012003',
    districtId: '7504012',
    name: 'Huntu Utara',
  },
  {
    id: '7504012004',
    districtId: '7504012',
    name: 'Ayula Utara',
  },
  {
    id: '7504012005',
    districtId: '7504012',
    name: 'Ayula Tilango',
  },
  {
    id: '7504012006',
    districtId: '7504012',
    name: 'Lamahu',
  },
  {
    id: '7504012007',
    districtId: '7504012',
    name: 'Huntu Barat',
  },
  {
    id: '7504012008',
    districtId: '7504012',
    name: 'Ayula Timur',
  },
  {
    id: '7504012009',
    districtId: '7504012',
    name: 'Sejahtera',
  },
  {
    id: '7504012010',
    districtId: '7504012',
    name: 'Tinelo Ayula',
  },
  {
    id: '7504013001',
    districtId: '7504013',
    name: 'Bulotalangi',
  },
  {
    id: '7504013002',
    districtId: '7504013',
    name: 'Bulotalangi Barat',
  },
  {
    id: '7504013003',
    districtId: '7504013',
    name: 'Bulotalangi Timur',
  },
  {
    id: '7504013004',
    districtId: '7504013',
    name: 'Toluwaya',
  },
  {
    id: '7504013005',
    districtId: '7504013',
    name: 'Popodu',
  },
  {
    id: '7504014001',
    districtId: '7504014',
    name: 'Owata',
  },
  {
    id: '7504014002',
    districtId: '7504014',
    name: 'Mongiilo',
  },
  {
    id: '7504014003',
    districtId: '7504014',
    name: 'Mongilo Utara',
  },
  {
    id: '7504014004',
    districtId: '7504014',
    name: 'Pilolaheya',
  },
  {
    id: '7504014005',
    districtId: '7504014',
    name: 'Ilomata',
  },
  {
    id: '7504014006',
    districtId: '7504014',
    name: 'Suka Makmur',
  },
  {
    id: '7504020006',
    districtId: '7504020',
    name: 'Dutohe',
  },
  {
    id: '7504020007',
    districtId: '7504020',
    name: 'Tanggilingo',
  },
  {
    id: '7504020008',
    districtId: '7504020',
    name: 'Padengo',
  },
  {
    id: '7504020009',
    districtId: '7504020',
    name: 'Oluhuta',
  },
  {
    id: '7504020010',
    districtId: '7504020',
    name: 'Tumbihe',
  },
  {
    id: '7504020011',
    districtId: '7504020',
    name: 'Pauwo',
  },
  {
    id: '7504020012',
    districtId: '7504020',
    name: 'Toto Selatan',
  },
  {
    id: '7504020016',
    districtId: '7504020',
    name: 'Poowo',
  },
  {
    id: '7504020017',
    districtId: '7504020',
    name: 'Talango',
  },
  {
    id: '7504020018',
    districtId: '7504020',
    name: 'Poowo Barat',
  },
  {
    id: '7504020019',
    districtId: '7504020',
    name: 'Dutohe Barat',
  },
  {
    id: '7504020020',
    districtId: '7504020',
    name: 'Oluhuta Utara',
  },
  {
    id: '7504021001',
    districtId: '7504021',
    name: 'Buata',
  },
  {
    id: '7504021002',
    districtId: '7504021',
    name: 'Luwohu',
  },
  {
    id: '7504021003',
    districtId: '7504021',
    name: 'Timbuolo',
  },
  {
    id: '7504021004',
    districtId: '7504021',
    name: 'Panggulo',
  },
  {
    id: '7504021006',
    districtId: '7504021',
    name: 'Timbuolo Timur',
  },
  {
    id: '7504021007',
    districtId: '7504021',
    name: 'Tanah Putih',
  },
  {
    id: '7504021008',
    districtId: '7504021',
    name: 'Timbuolo Tengah',
  },
  {
    id: '7504021009',
    districtId: '7504021',
    name: 'Panggulo Barat',
  },
  {
    id: '7504021010',
    districtId: '7504021',
    name: 'Sukma',
  },
  {
    id: '7504022013',
    districtId: '7504022',
    name: 'Toto Utara',
  },
  {
    id: '7504022014',
    districtId: '7504022',
    name: 'Tamboo',
  },
  {
    id: '7504022015',
    districtId: '7504022',
    name: 'Bongoime',
  },
  {
    id: '7504022017',
    districtId: '7504022',
    name: 'Bongopini',
  },
  {
    id: '7504022018',
    districtId: '7504022',
    name: 'Moutong',
  },
  {
    id: '7504022019',
    districtId: '7504022',
    name: 'Tunggulo',
  },
  {
    id: '7504022020',
    districtId: '7504022',
    name: 'Lonuo',
  },
  {
    id: '7504022021',
    districtId: '7504022',
    name: 'Motilango',
  },
  {
    id: '7504022022',
    districtId: '7504022',
    name: 'Iloheluma',
  },
  {
    id: '7504022023',
    districtId: '7504022',
    name: 'Permata',
  },
  {
    id: '7504022025',
    districtId: '7504022',
    name: 'Tunggulo Selatan',
  },
  {
    id: '7504022026',
    districtId: '7504022',
    name: 'Berlian',
  },
  {
    id: '7504022027',
    districtId: '7504022',
    name: 'Bongohulawa',
  },
  {
    id: '7504030011',
    districtId: '7504030',
    name: 'Tingkohubu',
  },
  {
    id: '7504030012',
    districtId: '7504030',
    name: 'Boludawa',
  },
  {
    id: '7504030014',
    districtId: '7504030',
    name: 'Huluduotamo',
  },
  {
    id: '7504030019',
    districtId: '7504030',
    name: 'Bubeya',
  },
  {
    id: '7504030020',
    districtId: '7504030',
    name: 'Bube Baru',
  },
  {
    id: '7504030022',
    districtId: '7504030',
    name: 'Tinelo',
  },
  {
    id: '7504030023',
    districtId: '7504030',
    name: 'Ulanta',
  },
  {
    id: '7504030024',
    districtId: '7504030',
    name: 'Tingkohubu Timur',
  },
  {
    id: '7504030025',
    districtId: '7504030',
    name: 'Helumo',
  },
  {
    id: '7504031001',
    districtId: '7504031',
    name: 'Bulontala',
  },
  {
    id: '7504031002',
    districtId: '7504031',
    name: 'Libungo',
  },
  {
    id: '7504031003',
    districtId: '7504031',
    name: 'Molintogupo',
  },
  {
    id: '7504031004',
    districtId: '7504031',
    name: 'Bonedaa',
  },
  {
    id: '7504031005',
    districtId: '7504031',
    name: 'Bondawuna',
  },
  {
    id: '7504031006',
    districtId: '7504031',
    name: 'Bulontala Timur',
  },
  {
    id: '7504031007',
    districtId: '7504031',
    name: 'Pancuran',
  },
  {
    id: '7504031008',
    districtId: '7504031',
    name: 'Bonda Raya',
  },
  {
    id: '7504032002',
    districtId: '7504032',
    name: 'Tulabolo',
  },
  {
    id: '7504032003',
    districtId: '7504032',
    name: 'Dumbayabulan',
  },
  {
    id: '7504032004',
    districtId: '7504032',
    name: 'Tilangobula',
  },
  {
    id: '7504032006',
    districtId: '7504032',
    name: 'Tulabolo Timur',
  },
  {
    id: '7504032009',
    districtId: '7504032',
    name: 'Tulabolo Barat',
  },
  {
    id: '7504032010',
    districtId: '7504032',
    name: 'Poduoma',
  },
  {
    id: '7504032011',
    districtId: '7504032',
    name: 'Panggulo',
  },
  {
    id: '7504032012',
    districtId: '7504032',
    name: 'Tinemba',
  },
  {
    id: '7504032013',
    districtId: '7504032',
    name: 'Pangi',
  },
  {
    id: '7504033001',
    districtId: '7504033',
    name: 'Lompotoo',
  },
  {
    id: '7504033002',
    districtId: '7504033',
    name: 'Lombongo',
  },
  {
    id: '7504033003',
    districtId: '7504033',
    name: 'Duano',
  },
  {
    id: '7504033004',
    districtId: '7504033',
    name: 'Tolomato',
  },
  {
    id: '7504033005',
    districtId: '7504033',
    name: 'Alale',
  },
  {
    id: '7504033006',
    districtId: '7504033',
    name: 'Tapadaa',
  },
  {
    id: '7504034001',
    districtId: '7504034',
    name: 'Bangio',
  },
  {
    id: '7504034002',
    districtId: '7504034',
    name: 'Pinogu Permai',
  },
  {
    id: '7504034003',
    districtId: '7504034',
    name: 'Tilonggibila',
  },
  {
    id: '7504034004',
    districtId: '7504034',
    name: 'Pinogu',
  },
  {
    id: '7504034005',
    districtId: '7504034',
    name: 'Dataran Hijau',
  },
  {
    id: '7504040003',
    districtId: '7504040',
    name: 'Tolotio',
  },
  {
    id: '7504040004',
    districtId: '7504040',
    name: 'Tamboo',
  },
  {
    id: '7504040005',
    districtId: '7504040',
    name: 'Bilungala',
  },
  {
    id: '7504040006',
    districtId: '7504040',
    name: 'Tongo',
  },
  {
    id: '7504040007',
    districtId: '7504040',
    name: 'Uabanga',
  },
  {
    id: '7504040008',
    districtId: '7504040',
    name: 'Bilungala Utara',
  },
  {
    id: '7504040009',
    districtId: '7504040',
    name: 'Tihu',
  },
  {
    id: '7504040010',
    districtId: '7504040',
    name: 'Lembah Hijau',
  },
  {
    id: '7504040011',
    districtId: '7504040',
    name: 'Tunas Jaya',
  },
  {
    id: '7504040012',
    districtId: '7504040',
    name: 'Ombulo Hijau',
  },
  {
    id: '7504040013',
    districtId: '7504040',
    name: 'Batu Hijau',
  },
  {
    id: '7504040014',
    districtId: '7504040',
    name: 'Kamiri',
  },
  {
    id: '7504040015',
    districtId: '7504040',
    name: 'Pelita Hijau',
  },
  {
    id: '7504041001',
    districtId: '7504041',
    name: 'Huangobotu',
  },
  {
    id: '7504041002',
    districtId: '7504041',
    name: 'Molotabu',
  },
  {
    id: '7504041003',
    districtId: '7504041',
    name: 'Oluhuta',
  },
  {
    id: '7504041004',
    districtId: '7504041',
    name: 'Botubarani',
  },
  {
    id: '7504041005',
    districtId: '7504041',
    name: 'Biluango',
  },
  {
    id: '7504041006',
    districtId: '7504041',
    name: 'Modelomo',
  },
  {
    id: '7504041007',
    districtId: '7504041',
    name: 'Botutonuo',
  },
  {
    id: '7504041008',
    districtId: '7504041',
    name: 'Olele',
  },
  {
    id: '7504041009',
    districtId: '7504041',
    name: 'Bintalahe',
  },
  {
    id: '7504042010',
    districtId: '7504042',
    name: 'Inomata',
  },
  {
    id: '7504042011',
    districtId: '7504042',
    name: 'Tombulilato',
  },
  {
    id: '7504042014',
    districtId: '7504042',
    name: 'Mootinelo',
  },
  {
    id: '7504042015',
    districtId: '7504042',
    name: 'Mootayu',
  },
  {
    id: '7504042016',
    districtId: '7504042',
    name: 'Pelita Jaya',
  },
  {
    id: '7504042017',
    districtId: '7504042',
    name: 'Laut Biru',
  },
  {
    id: '7504042018',
    districtId: '7504042',
    name: 'Alo',
  },
  {
    id: '7504042019',
    districtId: '7504042',
    name: 'Moopiya',
  },
  {
    id: '7504042020',
    districtId: '7504042',
    name: 'Bunga',
  },
  {
    id: '7504042021',
    districtId: '7504042',
    name: 'Mootawa',
  },
  {
    id: '7504043012',
    districtId: '7504043',
    name: 'Monano',
  },
  {
    id: '7504043013',
    districtId: '7504043',
    name: 'Sogitia',
  },
  {
    id: '7504043014',
    districtId: '7504043',
    name: 'Taludaa',
  },
  {
    id: '7504043015',
    districtId: '7504043',
    name: 'Bilolantunga',
  },
  {
    id: '7504043016',
    districtId: '7504043',
    name: 'Moodulio',
  },
  {
    id: '7504043017',
    districtId: '7504043',
    name: 'Inogaluma',
  },
  {
    id: '7504043018',
    districtId: '7504043',
    name: 'Tumbuh Mekar',
  },
  {
    id: '7504043019',
    districtId: '7504043',
    name: 'Molamahu',
  },
  {
    id: '7504043020',
    districtId: '7504043',
    name: 'Ilohuuwa',
  },
  {
    id: '7504043021',
    districtId: '7504043',
    name: 'Masiaga',
  },
  {
    id: '7504043022',
    districtId: '7504043',
    name: 'Muara Bone',
  },
  {
    id: '7504043023',
    districtId: '7504043',
    name: 'Waluhu',
  },
  {
    id: '7504043024',
    districtId: '7504043',
    name: 'Cendana Putih',
  },
  {
    id: '7504043025',
    districtId: '7504043',
    name: 'Permata',
  },
  {
    id: '7504044001',
    districtId: '7504044',
    name: 'Kaidundu',
  },
  {
    id: '7504044002',
    districtId: '7504044',
    name: 'Mamungaa',
  },
  {
    id: '7504044003',
    districtId: '7504044',
    name: 'Kaidundu Barat',
  },
  {
    id: '7504044004',
    districtId: '7504044',
    name: 'Mopuya',
  },
  {
    id: '7504044005',
    districtId: '7504044',
    name: 'Pinomontiga',
  },
  {
    id: '7504044006',
    districtId: '7504044',
    name: 'Dunggilata',
  },
  {
    id: '7504044007',
    districtId: '7504044',
    name: 'Mamungaa Timur',
  },
  {
    id: '7504044008',
    districtId: '7504044',
    name: 'Bukit Hijau',
  },
  {
    id: '7504044009',
    districtId: '7504044',
    name: 'Patoa',
  },
  {
    id: '7505010005',
    districtId: '7505010',
    name: 'Imana',
  },
  {
    id: '7505010006',
    districtId: '7505010',
    name: 'Ilomata',
  },
  {
    id: '7505010007',
    districtId: '7505010',
    name: 'Bintana',
  },
  {
    id: '7505010008',
    districtId: '7505010',
    name: 'Monggupo',
  },
  {
    id: '7505010009',
    districtId: '7505010',
    name: 'Kota Jin',
  },
  {
    id: '7505010010',
    districtId: '7505010',
    name: 'Pinontoyonga',
  },
  {
    id: '7505010011',
    districtId: '7505010',
    name: 'Buata',
  },
  {
    id: '7505010012',
    districtId: '7505010',
    name: 'Wapalo',
  },
  {
    id: '7505010013',
    districtId: '7505010',
    name: 'Iloheluma',
  },
  {
    id: '7505010014',
    districtId: '7505010',
    name: 'Sigaso',
  },
  {
    id: '7505010015',
    districtId: '7505010',
    name: 'Oluhuta',
  },
  {
    id: '7505010016',
    districtId: '7505010',
    name: 'Kotajin Utara',
  },
  {
    id: '7505010017',
    districtId: '7505010',
    name: 'Tombulilato',
  },
  {
    id: '7505010018',
    districtId: '7505010',
    name: 'Posono',
  },
  {
    id: '7505011001',
    districtId: '7505011',
    name: 'Ipilo',
  },
  {
    id: '7505011002',
    districtId: '7505011',
    name: 'Molonggota',
  },
  {
    id: '7505011003',
    districtId: '7505011',
    name: 'Gentuma',
  },
  {
    id: '7505011004',
    districtId: '7505011',
    name: 'Dumolodo',
  },
  {
    id: '7505011012',
    districtId: '7505011',
    name: 'Langke',
  },
  {
    id: '7505011013',
    districtId: '7505011',
    name: 'Durian',
  },
  {
    id: '7505011014',
    districtId: '7505011',
    name: 'Motomingo',
  },
  {
    id: '7505011015',
    districtId: '7505011',
    name: 'Bohusami',
  },
  {
    id: '7505011016',
    districtId: '7505011',
    name: 'Ketapang',
  },
  {
    id: '7505011017',
    districtId: '7505011',
    name: 'Pasalae',
  },
  {
    id: '7505011018',
    districtId: '7505011',
    name: 'Nanati Jaya',
  },
  {
    id: '7505020008',
    districtId: '7505020',
    name: 'Pontolo',
  },
  {
    id: '7505020009',
    districtId: '7505020',
    name: 'Molingkapoto',
  },
  {
    id: '7505020010',
    districtId: '7505020',
    name: 'Mootinelo',
  },
  {
    id: '7505020011',
    districtId: '7505020',
    name: 'Leboto',
  },
  {
    id: '7505020012',
    districtId: '7505020',
    name: 'Bualemo',
  },
  {
    id: '7505020013',
    districtId: '7505020',
    name: 'Posso',
  },
  {
    id: '7505020014',
    districtId: '7505020',
    name: 'Bulalo',
  },
  {
    id: '7505020015',
    districtId: '7505020',
    name: 'Titidu',
  },
  {
    id: '7505020016',
    districtId: '7505020',
    name: 'Moluo',
  },
  {
    id: '7505020021',
    districtId: '7505020',
    name: 'Ombulodata',
  },
  {
    id: '7505020022',
    districtId: '7505020',
    name: 'Pontolo Atas',
  },
  {
    id: '7505020023',
    districtId: '7505020',
    name: 'Botuwombato',
  },
  {
    id: '7505020024',
    districtId: '7505020',
    name: 'Molingkapoto Selatan',
  },
  {
    id: '7505020025',
    districtId: '7505020',
    name: 'Botungobungo',
  },
  {
    id: '7505020026',
    districtId: '7505020',
    name: 'Alata Karya',
  },
  {
    id: '7505020027',
    districtId: '7505020',
    name: 'Masuru',
  },
  {
    id: '7505020028',
    districtId: '7505020',
    name: 'Cisadane',
  },
  {
    id: '7505020029',
    districtId: '7505020',
    name: 'Katialada',
  },
  {
    id: '7505021001',
    districtId: '7505021',
    name: 'Dambalo',
  },
  {
    id: '7505021002',
    districtId: '7505021',
    name: 'Molantadu',
  },
  {
    id: '7505021003',
    districtId: '7505021',
    name: 'Tanjung Karang',
  },
  {
    id: '7505021004',
    districtId: '7505021',
    name: 'Jembatan Merah',
  },
  {
    id: '7505021005',
    districtId: '7505021',
    name: 'Leyao',
  },
  {
    id: '7505021006',
    districtId: '7505021',
    name: 'Milango',
  },
  {
    id: '7505021007',
    districtId: '7505021',
    name: 'Bubode',
  },
  {
    id: '7505021008',
    districtId: '7505021',
    name: 'Bulango Raya',
  },
  {
    id: '7505021009',
    districtId: '7505021',
    name: 'Huidu Melito',
  },
  {
    id: '7505021010',
    districtId: '7505021',
    name: 'Mutiara Laut',
  },
  {
    id: '7505022001',
    districtId: '7505022',
    name: 'Ponelo',
  },
  {
    id: '7505022002',
    districtId: '7505022',
    name: 'Otiola',
  },
  {
    id: '7505022003',
    districtId: '7505022',
    name: 'Tihengo',
  },
  {
    id: '7505022004',
    districtId: '7505022',
    name: 'Malambe',
  },
  {
    id: '7505030004',
    districtId: '7505030',
    name: 'Tolango',
  },
  {
    id: '7505030005',
    districtId: '7505030',
    name: 'Ilangata',
  },
  {
    id: '7505030006',
    districtId: '7505030',
    name: 'Popalo',
  },
  {
    id: '7505030007',
    districtId: '7505030',
    name: 'Tolongio',
  },
  {
    id: '7505030008',
    districtId: '7505030',
    name: 'Dudepo',
  },
  {
    id: '7505030010',
    districtId: '7505030',
    name: 'Motilango',
  },
  {
    id: '7505030016',
    districtId: '7505030',
    name: 'Iloheluma',
  },
  {
    id: '7505030017',
    districtId: '7505030',
    name: 'Ibarat',
  },
  {
    id: '7505030018',
    districtId: '7505030',
    name: 'Datahu',
  },
  {
    id: '7505030019',
    districtId: '7505030',
    name: 'Putiana',
  },
  {
    id: '7505030020',
    districtId: '7505030',
    name: 'Hiyalooile',
  },
  {
    id: '7505030021',
    districtId: '7505030',
    name: 'Ilodulunga',
  },
  {
    id: '7505030022',
    districtId: '7505030',
    name: 'Langge',
  },
  {
    id: '7505030023',
    districtId: '7505030',
    name: 'Tutuwoto',
  },
  {
    id: '7505030025',
    districtId: '7505030',
    name: 'Helumo',
  },
  {
    id: '7505031002',
    districtId: '7505031',
    name: 'Monano',
  },
  {
    id: '7505031003',
    districtId: '7505031',
    name: 'Tudi',
  },
  {
    id: '7505031004',
    districtId: '7505031',
    name: 'Monas',
  },
  {
    id: '7505031005',
    districtId: '7505031',
    name: 'Tolitehuyu',
  },
  {
    id: '7505031006',
    districtId: '7505031',
    name: 'Zuriyati',
  },
  {
    id: '7505031007',
    districtId: '7505031',
    name: 'Mokonowu',
  },
  {
    id: '7505031008',
    districtId: '7505031',
    name: 'Pilohulata',
  },
  {
    id: '7505031009',
    districtId: '7505031',
    name: 'Garapia',
  },
  {
    id: '7505031010',
    districtId: '7505031',
    name: 'Sogu',
  },
  {
    id: '7505040009',
    districtId: '7505040',
    name: 'Buloila',
  },
  {
    id: '7505040010',
    districtId: '7505040',
    name: 'Bulontio Barat',
  },
  {
    id: '7505040011',
    districtId: '7505040',
    name: 'Bulontio Timur',
  },
  {
    id: '7505040016',
    districtId: '7505040',
    name: 'Kikia',
  },
  {
    id: '7505040017',
    districtId: '7505040',
    name: 'Kasia',
  },
  {
    id: '7505040019',
    districtId: '7505040',
    name: 'Lelato',
  },
  {
    id: '7505040020',
    districtId: '7505040',
    name: 'Tumba',
  },
  {
    id: '7505040021',
    districtId: '7505040',
    name: 'Mebongo',
  },
  {
    id: '7505040022',
    districtId: '7505040',
    name: 'Pulohenti',
  },
  {
    id: '7505040023',
    districtId: '7505040',
    name: 'Hutakalo',
  },
  {
    id: '7505040028',
    districtId: '7505040',
    name: 'Puncak Mandiri',
  },
  {
    id: '7505041002',
    districtId: '7505041',
    name: 'Buladu',
  },
  {
    id: '7505041003',
    districtId: '7505041',
    name: 'Deme II',
  },
  {
    id: '7505041004',
    districtId: '7505041',
    name: 'Deme I',
  },
  {
    id: '7505041005',
    districtId: '7505041',
    name: 'Dulukapa',
  },
  {
    id: '7505041006',
    districtId: '7505041',
    name: 'Bubalango',
  },
  {
    id: '7505041007',
    districtId: '7505041',
    name: 'Hulawa',
  },
  {
    id: '7505041008',
    districtId: '7505041',
    name: 'Koluwoka',
  },
  {
    id: '7505041009',
    districtId: '7505041',
    name: 'Buluwatu',
  },
  {
    id: '7505041010',
    districtId: '7505041',
    name: 'Motihelumo',
  },
  {
    id: '7505050001',
    districtId: '7505050',
    name: 'Limbato',
  },
  {
    id: '7505050002',
    districtId: '7505050',
    name: 'Papualangi',
  },
  {
    id: '7505050003',
    districtId: '7505050',
    name: 'Tolinggula Ulu',
  },
  {
    id: '7505050004',
    districtId: '7505050',
    name: 'Tolinggula Tengah',
  },
  {
    id: '7505050005',
    districtId: '7505050',
    name: 'Tolinggula Pantai',
  },
  {
    id: '7505050008',
    districtId: '7505050',
    name: 'Cempaka Putih',
  },
  {
    id: '7505050009',
    districtId: '7505050',
    name: 'Molangga',
  },
  {
    id: '7505050012',
    districtId: '7505050',
    name: 'Ilotunggula',
  },
  {
    id: '7505050013',
    districtId: '7505050',
    name: 'Tolite Jaya',
  },
  {
    id: '7505050017',
    districtId: '7505050',
    name: 'Ilomangga',
  },
  {
    id: '7505051001',
    districtId: '7505051',
    name: 'Biau',
  },
  {
    id: '7505051002',
    districtId: '7505051',
    name: 'Potanga',
  },
  {
    id: '7505051003',
    districtId: '7505051',
    name: 'Windu',
  },
  {
    id: '7505051004',
    districtId: '7505051',
    name: 'Didingga',
  },
  {
    id: '7505051005',
    districtId: '7505051',
    name: 'Omuto',
  },
  {
    id: '7505051006',
    districtId: '7505051',
    name: 'Luhuto',
  },
  {
    id: '7505051007',
    districtId: '7505051',
    name: 'Bohulo',
  },
  {
    id: '7505051008',
    districtId: '7505051',
    name: 'Topi',
  },
  {
    id: '7505051009',
    districtId: '7505051',
    name: 'Bualo',
  },
  {
    id: '7505051010',
    districtId: '7505051',
    name: 'Sembihingan',
  },
  {
    id: '7571010001',
    districtId: '7571010',
    name: 'Dembe I',
  },
  {
    id: '7571010002',
    districtId: '7571010',
    name: 'Lekobalo',
  },
  {
    id: '7571010003',
    districtId: '7571010',
    name: 'Pilolodaa',
  },
  {
    id: '7571010004',
    districtId: '7571010',
    name: 'Buliide',
  },
  {
    id: '7571010005',
    districtId: '7571010',
    name: 'Tenilo',
  },
  {
    id: '7571010006',
    districtId: '7571010',
    name: 'Molosipat W',
  },
  {
    id: '7571010008',
    districtId: '7571010',
    name: 'Buladu',
  },
  {
    id: '7571011001',
    districtId: '7571011',
    name: 'Tuladenggi',
  },
  {
    id: '7571011002',
    districtId: '7571011',
    name: 'Libuo',
  },
  {
    id: '7571011003',
    districtId: '7571011',
    name: 'Tomulabutao',
  },
  {
    id: '7571011004',
    districtId: '7571011',
    name: 'Huangobotu',
  },
  {
    id: '7571011005',
    districtId: '7571011',
    name: 'Tomulabutao Selatan',
  },
  {
    id: '7571020010',
    districtId: '7571020',
    name: 'Biawu',
  },
  {
    id: '7571020011',
    districtId: '7571020',
    name: 'Biawao',
  },
  {
    id: '7571020018',
    districtId: '7571020',
    name: 'Limba B',
  },
  {
    id: '7571020019',
    districtId: '7571020',
    name: 'Limba U Satu',
  },
  {
    id: '7571020020',
    districtId: '7571020',
    name: 'Limba U Dua',
  },
  {
    id: '7571021006',
    districtId: '7571021',
    name: 'Padebuolo',
  },
  {
    id: '7571021007',
    districtId: '7571021',
    name: 'Ipilo',
  },
  {
    id: '7571021008',
    districtId: '7571021',
    name: 'Tamalate',
  },
  {
    id: '7571021009',
    districtId: '7571021',
    name: 'Moodu',
  },
  {
    id: '7571021010',
    districtId: '7571021',
    name: 'Heledulaa Selatan',
  },
  {
    id: '7571021011',
    districtId: '7571021',
    name: 'Heledulaa',
  },
  {
    id: '7571022001',
    districtId: '7571022',
    name: 'Tanjung Kramat',
  },
  {
    id: '7571022002',
    districtId: '7571022',
    name: 'Pohe',
  },
  {
    id: '7571022003',
    districtId: '7571022',
    name: 'Tenda',
  },
  {
    id: '7571022004',
    districtId: '7571022',
    name: 'Siendeng',
  },
  {
    id: '7571022005',
    districtId: '7571022',
    name: 'Donggala',
  },
  {
    id: '7571023001',
    districtId: '7571023',
    name: 'Leato Selatan',
  },
  {
    id: '7571023002',
    districtId: '7571023',
    name: 'Leato Utara',
  },
  {
    id: '7571023003',
    districtId: '7571023',
    name: 'Talumolo',
  },
  {
    id: '7571023004',
    districtId: '7571023',
    name: 'Botu',
  },
  {
    id: '7571023005',
    districtId: '7571023',
    name: 'Bugis',
  },
  {
    id: '7571030003',
    districtId: '7571030',
    name: 'Dembe II',
  },
  {
    id: '7571030004',
    districtId: '7571030',
    name: 'Wongkaditi',
  },
  {
    id: '7571030005',
    districtId: '7571030',
    name: 'Wongkaditi Barat',
  },
  {
    id: '7571030011',
    districtId: '7571030',
    name: 'Dulomo Selatan',
  },
  {
    id: '7571030012',
    districtId: '7571030',
    name: 'Dulomo',
  },
  {
    id: '7571030015',
    districtId: '7571030',
    name: 'Dembe Jaya',
  },
  {
    id: '7571031001',
    districtId: '7571031',
    name: 'Wumialo',
  },
  {
    id: '7571031002',
    districtId: '7571031',
    name: 'Dulalowo',
  },
  {
    id: '7571031003',
    districtId: '7571031',
    name: 'Liluwo',
  },
  {
    id: '7571031004',
    districtId: '7571031',
    name: 'Pulubala',
  },
  {
    id: '7571031005',
    districtId: '7571031',
    name: 'Paguyaman',
  },
  {
    id: '7571031006',
    districtId: '7571031',
    name: 'Dulalowo Timur',
  },
  {
    id: '7571032001',
    districtId: '7571032',
    name: 'Tapa',
  },
  {
    id: '7571032002',
    districtId: '7571032',
    name: 'Molosipat U',
  },
  {
    id: '7571032003',
    districtId: '7571032',
    name: 'Tanggikiki',
  },
  {
    id: '7571032004',
    districtId: '7571032',
    name: 'Bulotada Timur',
  },
  {
    id: '7571032005',
    districtId: '7571032',
    name: 'Bulotadaa',
  },
  {
    id: '7601010001',
    districtId: '7601010',
    name: 'Totoli',
  },
  {
    id: '7601010002',
    districtId: '7601010',
    name: 'Baru',
  },
  {
    id: '7601010003',
    districtId: '7601010',
    name: 'Pangali-Ali',
  },
  {
    id: '7601010004',
    districtId: '7601010',
    name: 'Banggae',
  },
  {
    id: '7601010005',
    districtId: '7601010',
    name: 'Rangas',
  },
  {
    id: '7601010006',
    districtId: '7601010',
    name: 'Palipi Soreang',
  },
  {
    id: '7601010007',
    districtId: '7601010',
    name: 'Pamboborang',
  },
  {
    id: '7601010008',
    districtId: '7601010',
    name: 'Galung',
  },
  {
    id: '7601011001',
    districtId: '7601011',
    name: 'Baurung',
  },
  {
    id: '7601011002',
    districtId: '7601011',
    name: 'Labuang',
  },
  {
    id: '7601011003',
    districtId: '7601011',
    name: 'Tande',
  },
  {
    id: '7601011004',
    districtId: '7601011',
    name: 'Baruga',
  },
  {
    id: '7601011005',
    districtId: '7601011',
    name: 'Baruga Dua',
  },
  {
    id: '7601011006',
    districtId: '7601011',
    name: 'Lembang',
  },
  {
    id: '7601011007',
    districtId: '7601011',
    name: 'Labuang Utara',
  },
  {
    id: '7601011008',
    districtId: '7601011',
    name: 'Tande Timur',
  },
  {
    id: '7601011009',
    districtId: '7601011',
    name: 'Buttu Baruga',
  },
  {
    id: '7601020001',
    districtId: '7601020',
    name: 'Bonde',
  },
  {
    id: '7601020002',
    districtId: '7601020',
    name: 'Bababulo',
  },
  {
    id: '7601020003',
    districtId: '7601020',
    name: 'Simbang',
  },
  {
    id: '7601020004',
    districtId: '7601020',
    name: 'Lalampanua',
  },
  {
    id: '7601020006',
    districtId: '7601020',
    name: 'Adolang',
  },
  {
    id: '7601020007',
    districtId: '7601020',
    name: 'Sirindu',
  },
  {
    id: '7601020008',
    districtId: '7601020',
    name: 'Bonde Utara',
  },
  {
    id: '7601020009',
    districtId: '7601020',
    name: 'Bababulo Utara',
  },
  {
    id: '7601020010',
    districtId: '7601020',
    name: 'Buttu Pamboang',
  },
  {
    id: '7601020011',
    districtId: '7601020',
    name: 'Tinambung',
  },
  {
    id: '7601020012',
    districtId: '7601020',
    name: 'Banua Adolang',
  },
  {
    id: '7601020013',
    districtId: '7601020',
    name: 'Adolang Dua',
  },
  {
    id: '7601020014',
    districtId: '7601020',
    name: 'Pesuloang',
  },
  {
    id: '7601020015',
    districtId: '7601020',
    name: 'Balombong',
  },
  {
    id: '7601030001',
    districtId: '7601030',
    name: 'Mosso Dua',
  },
  {
    id: '7601030002',
    districtId: '7601030',
    name: 'Mosso',
  },
  {
    id: '7601030003',
    districtId: '7601030',
    name: 'Puttada',
  },
  {
    id: '7601030004',
    districtId: '7601030',
    name: 'Sendana',
  },
  {
    id: '7601030005',
    districtId: '7601030',
    name: 'Tallum Banua',
  },
  {
    id: '7601030011',
    districtId: '7601030',
    name: 'Pundau',
  },
  {
    id: '7601030012',
    districtId: '7601030',
    name: 'Bukit Samang',
  },
  {
    id: '7601030013',
    districtId: '7601030',
    name: 'Limbua',
  },
  {
    id: '7601030014',
    districtId: '7601030',
    name: 'Lalatedong',
  },
  {
    id: '7601030015',
    districtId: '7601030',
    name: 'Paminggalan',
  },
  {
    id: '7601030016',
    districtId: '7601030',
    name: 'Totolisi Sendana',
  },
  {
    id: '7601030017',
    districtId: '7601030',
    name: 'Banua Sendana',
  },
  {
    id: '7601030018',
    districtId: '7601030',
    name: 'Tallu Banua Utara',
  },
  {
    id: '7601030019',
    districtId: '7601030',
    name: 'Limboro Rambu-Rambu',
  },
  {
    id: '7601030020',
    districtId: '7601030',
    name: 'Leppangan',
  },
  {
    id: '7601030021',
    districtId: '7601030',
    name: 'Binanga',
  },
  {
    id: '7601031002',
    districtId: '7601031',
    name: 'Tallambalao',
  },
  {
    id: '7601031003',
    districtId: '7601031',
    name: 'Tammerodo',
  },
  {
    id: '7601031004',
    districtId: '7601031',
    name: 'Seppong',
  },
  {
    id: '7601031005',
    districtId: '7601031',
    name: 'Ulidang',
  },
  {
    id: '7601031006',
    districtId: '7601031',
    name: 'Tammerodo Utara',
  },
  {
    id: '7601031007',
    districtId: '7601031',
    name: 'Manyamba',
  },
  {
    id: '7601031008',
    districtId: '7601031',
    name: 'Awo',
  },
  {
    id: '7601033002',
    districtId: '7601033',
    name: 'Onang',
  },
  {
    id: '7601033003',
    districtId: '7601033',
    name: 'Onang Utara',
  },
  {
    id: '7601033004',
    districtId: '7601033',
    name: 'Tubo Selatan',
  },
  {
    id: '7601033005',
    districtId: '7601033',
    name: 'Tubo',
  },
  {
    id: '7601033006',
    districtId: '7601033',
    name: 'Bonde-Bonde',
  },
  {
    id: '7601033007',
    districtId: '7601033',
    name: 'Tubo Tengah',
  },
  {
    id: '7601033008',
    districtId: '7601033',
    name: 'Tubo Poang',
  },
  {
    id: '7601040006',
    districtId: '7601040',
    name: 'Malunda',
  },
  {
    id: '7601040007',
    districtId: '7601040',
    name: 'Lombong',
  },
  {
    id: '7601040008',
    districtId: '7601040',
    name: 'Bambangan',
  },
  {
    id: '7601040009',
    districtId: '7601040',
    name: 'Mekkatta',
  },
  {
    id: '7601040010',
    districtId: '7601040',
    name: 'Maliaya',
  },
  {
    id: '7601040011',
    districtId: '7601040',
    name: 'Lombang',
  },
  {
    id: '7601040012',
    districtId: '7601040',
    name: 'Lamungang Batu',
  },
  {
    id: '7601040013',
    districtId: '7601040',
    name: 'Kayuangin',
  },
  {
    id: '7601040014',
    districtId: '7601040',
    name: 'Lombong Timur',
  },
  {
    id: '7601040015',
    districtId: '7601040',
    name: 'Salutahongan',
  },
  {
    id: '7601040016',
    districtId: '7601040',
    name: 'Mekkatta Selatan',
  },
  {
    id: '7601040017',
    districtId: '7601040',
    name: 'Lombang Timur',
  },
  {
    id: '7601041001',
    districtId: '7601041',
    name: 'Ulumanda',
  },
  {
    id: '7601041002',
    districtId: '7601041',
    name: 'Sambabo',
  },
  {
    id: '7601041003',
    districtId: '7601041',
    name: 'Tandeallo',
  },
  {
    id: '7601041005',
    districtId: '7601041',
    name: 'Kabiraan',
  },
  {
    id: '7601041006',
    districtId: '7601041',
    name: 'Popenga',
  },
  {
    id: '7601041007',
    districtId: '7601041',
    name: 'Salutambung',
  },
  {
    id: '7601041008',
    districtId: '7601041',
    name: 'Panggalo',
  },
  {
    id: '7601041009',
    districtId: '7601041',
    name: 'Sulai',
  },
  {
    id: '7602010001',
    districtId: '7602010',
    name: 'Tandung',
  },
  {
    id: '7602010002',
    districtId: '7602010',
    name: 'Sepa Batu',
  },
  {
    id: '7602010003',
    districtId: '7602010',
    name: 'Tangnga-Tangnga',
  },
  {
    id: '7602010004',
    districtId: '7602010',
    name: 'Karama',
  },
  {
    id: '7602010014',
    districtId: '7602010',
    name: 'Batulaya',
  },
  {
    id: '7602010018',
    districtId: '7602010',
    name: 'Tinambung',
  },
  {
    id: '7602010019',
    districtId: '7602010',
    name: 'Lekopadis',
  },
  {
    id: '7602010021',
    districtId: '7602010',
    name: 'Galung Lombok',
  },
  {
    id: '7602011001',
    districtId: '7602011',
    name: 'Balanipa',
  },
  {
    id: '7602011002',
    districtId: '7602011',
    name: 'Tammangalle',
  },
  {
    id: '7602011003',
    districtId: '7602011',
    name: 'Galung Tulu',
  },
  {
    id: '7602011004',
    districtId: '7602011',
    name: 'Sabang Subik',
  },
  {
    id: '7602011005',
    districtId: '7602011',
    name: 'Pambusuang',
  },
  {
    id: '7602011006',
    districtId: '7602011',
    name: 'Bala',
  },
  {
    id: '7602011007',
    districtId: '7602011',
    name: 'Lego',
  },
  {
    id: '7602011008',
    districtId: '7602011',
    name: 'Lambanan',
  },
  {
    id: '7602011009',
    districtId: '7602011',
    name: 'Mosso',
  },
  {
    id: '7602011010',
    districtId: '7602011',
    name: 'Tammajarra',
  },
  {
    id: '7602011011',
    districtId: '7602011',
    name: 'Pallis',
  },
  {
    id: '7602012001',
    districtId: '7602012',
    name: 'Renggeang',
  },
  {
    id: '7602012002',
    districtId: '7602012',
    name: 'Tandasura',
  },
  {
    id: '7602012003',
    districtId: '7602012',
    name: 'Tangan Baru',
  },
  {
    id: '7602012004',
    districtId: '7602012',
    name: 'Lembang Lembang',
  },
  {
    id: '7602012005',
    districtId: '7602012',
    name: 'Limboro',
  },
  {
    id: '7602012006',
    districtId: '7602012',
    name: 'Samasundu',
  },
  {
    id: '7602012007',
    districtId: '7602012',
    name: 'Napo',
  },
  {
    id: '7602012008',
    districtId: '7602012',
    name: 'Salarri',
  },
  {
    id: '7602012009',
    districtId: '7602012',
    name: 'Todang Todang',
  },
  {
    id: '7602012010',
    districtId: '7602012',
    name: 'Pendulangan',
  },
  {
    id: '7602012011',
    districtId: '7602012',
    name: 'Palece',
  },
  {
    id: '7602020006',
    districtId: '7602020',
    name: 'Taramanu',
  },
  {
    id: '7602020007',
    districtId: '7602020',
    name: 'Ambopadang',
  },
  {
    id: '7602020008',
    districtId: '7602020',
    name: 'Tubbi',
  },
  {
    id: '7602020009',
    districtId: '7602020',
    name: 'Ratte',
  },
  {
    id: '7602020010',
    districtId: '7602020',
    name: 'Besoangin',
  },
  {
    id: '7602020011',
    districtId: '7602020',
    name: 'Piriang Tapiko',
  },
  {
    id: '7602020012',
    districtId: '7602020',
    name: 'Pollewani',
  },
  {
    id: '7602020013',
    districtId: '7602020',
    name: 'Poda',
  },
  {
    id: '7602020014',
    districtId: '7602020',
    name: 'Besoangin Utara',
  },
  {
    id: '7602020015',
    districtId: '7602020',
    name: 'Arabua',
  },
  {
    id: '7602020016',
    districtId: '7602020',
    name: 'Taramanu Tua',
  },
  {
    id: '7602020017',
    districtId: '7602020',
    name: 'Taloba',
  },
  {
    id: '7602021001',
    districtId: '7602021',
    name: 'Saragian',
  },
  {
    id: '7602021002',
    districtId: '7602021',
    name: 'Mombi',
  },
  {
    id: '7602021003',
    districtId: '7602021',
    name: 'Petoosang',
  },
  {
    id: '7602021004',
    districtId: '7602021',
    name: 'Kalumammang',
  },
  {
    id: '7602021005',
    districtId: '7602021',
    name: 'Pao Pao',
  },
  {
    id: '7602021006',
    districtId: '7602021',
    name: 'Pupuuring',
  },
  {
    id: '7602021007',
    districtId: '7602021',
    name: 'Sayoang',
  },
  {
    id: '7602021008',
    districtId: '7602021',
    name: 'Alu',
  },
  {
    id: '7602030001',
    districtId: '7602030',
    name: 'Laliko',
  },
  {
    id: '7602030002',
    districtId: '7602030',
    name: 'Lapeo',
  },
  {
    id: '7602030004',
    districtId: '7602030',
    name: 'Suruang',
  },
  {
    id: '7602030005',
    districtId: '7602030',
    name: 'Pappang',
  },
  {
    id: '7602030006',
    districtId: '7602030',
    name: 'Bonde',
  },
  {
    id: '7602030007',
    districtId: '7602030',
    name: 'Parappe',
  },
  {
    id: '7602030008',
    districtId: '7602030',
    name: 'Panyampa',
  },
  {
    id: '7602030009',
    districtId: '7602030',
    name: 'Lemo',
  },
  {
    id: '7602030010',
    districtId: '7602030',
    name: 'Katumbangan',
  },
  {
    id: '7602030011',
    districtId: '7602030',
    name: 'Lampoko',
  },
  {
    id: '7602030012',
    districtId: '7602030',
    name: 'Ongko',
  },
  {
    id: '7602030013',
    districtId: '7602030',
    name: 'Sumarang',
  },
  {
    id: '7602030016',
    districtId: '7602030',
    name: 'B O T T O',
  },
  {
    id: '7602030017',
    districtId: '7602030',
    name: 'Lagi Agi',
  },
  {
    id: '7602030018',
    districtId: '7602030',
    name: 'Padang',
  },
  {
    id: '7602030019',
    districtId: '7602030',
    name: 'Gattungan',
  },
  {
    id: '7602030020',
    districtId: '7602030',
    name: 'Padang Timur',
  },
  {
    id: '7602031001',
    districtId: '7602031',
    name: 'Sambali-Wali',
  },
  {
    id: '7602031002',
    districtId: '7602031',
    name: 'Tenggelan',
  },
  {
    id: '7602031003',
    districtId: '7602031',
    name: 'Baru',
  },
  {
    id: '7602031004',
    districtId: '7602031',
    name: 'Mapilli Barat',
  },
  {
    id: '7602031005',
    districtId: '7602031',
    name: 'Luyo',
  },
  {
    id: '7602031006',
    districtId: '7602031',
    name: 'M A M B U',
  },
  {
    id: '7602031007',
    districtId: '7602031',
    name: 'Pussui',
  },
  {
    id: '7602031008',
    districtId: '7602031',
    name: 'Batupanga',
  },
  {
    id: '7602031009',
    districtId: '7602031',
    name: 'Batupanga Daala',
  },
  {
    id: '7602031010',
    districtId: '7602031',
    name: 'Puccadi',
  },
  {
    id: '7602031011',
    districtId: '7602031',
    name: 'Pussui Barat',
  },
  {
    id: '7602040001',
    districtId: '7602040',
    name: 'Tumpiling',
  },
  {
    id: '7602040003',
    districtId: '7602040',
    name: 'Nepo',
  },
  {
    id: '7602040004',
    districtId: '7602040',
    name: 'Kebunsari',
  },
  {
    id: '7602040005',
    districtId: '7602040',
    name: 'Arjosari',
  },
  {
    id: '7602040006',
    districtId: '7602040',
    name: 'Bumiayu',
  },
  {
    id: '7602040007',
    districtId: '7602040',
    name: 'Bumi Mulyo',
  },
  {
    id: '7602040008',
    districtId: '7602040',
    name: 'Sidorejo',
  },
  {
    id: '7602040009',
    districtId: '7602040',
    name: 'Sidodadi',
  },
  {
    id: '7602040010',
    districtId: '7602040',
    name: 'Campurjo',
  },
  {
    id: '7602040014',
    districtId: '7602040',
    name: 'Sumberjo',
  },
  {
    id: '7602040015',
    districtId: '7602040',
    name: 'Sugih Waras',
  },
  {
    id: '7602040016',
    districtId: '7602040',
    name: 'Banua Baru',
  },
  {
    id: '7602040021',
    districtId: '7602040',
    name: 'Bakka-Bakka',
  },
  {
    id: '7602040022',
    districtId: '7602040',
    name: 'Galeso',
  },
  {
    id: '7602041002',
    districtId: '7602041',
    name: 'Rumpa',
  },
  {
    id: '7602041003',
    districtId: '7602041',
    name: 'Ugi Baru',
  },
  {
    id: '7602041004',
    districtId: '7602041',
    name: 'Bonne-Bonne',
  },
  {
    id: '7602041005',
    districtId: '7602041',
    name: 'Mapilli',
  },
  {
    id: '7602041006',
    districtId: '7602041',
    name: 'Kurma',
  },
  {
    id: '7602041007',
    districtId: '7602041',
    name: 'Rappang Barat',
  },
  {
    id: '7602041008',
    districtId: '7602041',
    name: 'Beroangin',
  },
  {
    id: '7602041009',
    districtId: '7602041',
    name: 'Segerang',
  },
  {
    id: '7602041010',
    districtId: '7602041',
    name: 'Bonra',
  },
  {
    id: '7602041011',
    districtId: '7602041',
    name: 'Sattoko',
  },
  {
    id: '7602041012',
    districtId: '7602041',
    name: 'Landi Kanusuang',
  },
  {
    id: '7602042002',
    districtId: '7602042',
    name: 'Rappang',
  },
  {
    id: '7602042003',
    districtId: '7602042',
    name: 'Dakka',
  },
  {
    id: '7602042004',
    districtId: '7602042',
    name: 'Pelitakan',
  },
  {
    id: '7602042005',
    districtId: '7602042',
    name: 'Tapango',
  },
  {
    id: '7602042006',
    districtId: '7602042',
    name: 'Tapango Barat',
  },
  {
    id: '7602042007',
    districtId: '7602042',
    name: 'Batu',
  },
  {
    id: '7602042008',
    districtId: '7602042',
    name: 'Palatta',
  },
  {
    id: '7602042009',
    districtId: '7602042',
    name: 'Riso',
  },
  {
    id: '7602042010',
    districtId: '7602042',
    name: 'Kurrak',
  },
  {
    id: '7602042011',
    districtId: '7602042',
    name: 'Tutula',
  },
  {
    id: '7602042012',
    districtId: '7602042',
    name: 'Jambu Malea',
  },
  {
    id: '7602042013',
    districtId: '7602042',
    name: 'Banato Rejo',
  },
  {
    id: '7602042014',
    districtId: '7602042',
    name: 'Kalimbua',
  },
  {
    id: '7602043002',
    districtId: '7602043',
    name: 'Patampanua',
  },
  {
    id: '7602043003',
    districtId: '7602043',
    name: 'Matakali',
  },
  {
    id: '7602043004',
    districtId: '7602043',
    name: 'Tonro Lima',
  },
  {
    id: '7602043005',
    districtId: '7602043',
    name: 'Indumakkombong',
  },
  {
    id: '7602043006',
    districtId: '7602043',
    name: 'Barumbung',
  },
  {
    id: '7602043007',
    districtId: '7602043',
    name: 'Pasiang',
  },
  {
    id: '7602043008',
    districtId: '7602043',
    name: 'Bunga Bunga',
  },
  {
    id: '7602044001',
    districtId: '7602044',
    name: 'Pulliwa',
  },
  {
    id: '7602044002',
    districtId: '7602044',
    name: 'Daala Timur',
  },
  {
    id: '7602044003',
    districtId: '7602044',
    name: 'B U L O',
  },
  {
    id: '7602044004',
    districtId: '7602044',
    name: 'Karombang',
  },
  {
    id: '7602044005',
    districtId: '7602044',
    name: 'Patambanua',
  },
  {
    id: '7602044006',
    districtId: '7602044',
    name: 'Lenggo',
  },
  {
    id: '7602044007',
    districtId: '7602044',
    name: 'Sepporraki',
  },
  {
    id: '7602044008',
    districtId: '7602044',
    name: 'Ihing',
  },
  {
    id: '7602044010',
    districtId: '7602044',
    name: 'Sabura',
  },
  {
    id: '7602050001',
    districtId: '7602050',
    name: 'Darma',
  },
  {
    id: '7602050002',
    districtId: '7602050',
    name: 'Manding',
  },
  {
    id: '7602050003',
    districtId: '7602050',
    name: 'Madatte',
  },
  {
    id: '7602050004',
    districtId: '7602050',
    name: 'Pekkabata',
  },
  {
    id: '7602050005',
    districtId: '7602050',
    name: 'Takatidung',
  },
  {
    id: '7602050006',
    districtId: '7602050',
    name: 'Lantora',
  },
  {
    id: '7602050007',
    districtId: '7602050',
    name: 'Sulewatang',
  },
  {
    id: '7602050008',
    districtId: '7602050',
    name: 'Wattang',
  },
  {
    id: '7602050009',
    districtId: '7602050',
    name: 'Polewali',
  },
  {
    id: '7602051001',
    districtId: '7602051',
    name: 'Tonyaman',
  },
  {
    id: '7602051002',
    districtId: '7602051',
    name: 'Amassangan',
  },
  {
    id: '7602051003',
    districtId: '7602051',
    name: 'Mirring',
  },
  {
    id: '7602051004',
    districtId: '7602051',
    name: 'Paku',
  },
  {
    id: '7602051005',
    districtId: '7602051',
    name: 'Batetangnga',
  },
  {
    id: '7602051006',
    districtId: '7602051',
    name: 'Kuajang',
  },
  {
    id: '7602051007',
    districtId: '7602051',
    name: 'Mammi',
  },
  {
    id: '7602051008',
    districtId: '7602051',
    name: 'Kaleok',
  },
  {
    id: '7602051009',
    districtId: '7602051',
    name: 'Rea',
  },
  {
    id: '7602051010',
    districtId: '7602051',
    name: 'Amola',
  },
  {
    id: '7602052002',
    districtId: '7602052',
    name: 'Anreapi',
  },
  {
    id: '7602052003',
    districtId: '7602052',
    name: 'Kelapa Dua',
  },
  {
    id: '7602052004',
    districtId: '7602052',
    name: 'Pappandangan',
  },
  {
    id: '7602052005',
    districtId: '7602052',
    name: 'Duampanua',
  },
  {
    id: '7602052006',
    districtId: '7602052',
    name: 'Kunyi',
  },
  {
    id: '7602061001',
    districtId: '7602061',
    name: 'Lilli',
  },
  {
    id: '7602061002',
    districtId: '7602061',
    name: 'Tapua',
  },
  {
    id: '7602061003',
    districtId: '7602061',
    name: 'Matangnga',
  },
  {
    id: '7602061004',
    districtId: '7602061',
    name: 'Rangoan',
  },
  {
    id: '7602061005',
    districtId: '7602061',
    name: "Ba'Pa Tapua",
  },
  {
    id: '7602061006',
    districtId: '7602061',
    name: 'Mambu Tapua',
  },
  {
    id: '7602061007',
    districtId: '7602061',
    name: 'Katimbang',
  },
  {
    id: '7603010001',
    districtId: '7603010',
    name: 'Sibanawa',
  },
  {
    id: '7603010002',
    districtId: '7603010',
    name: 'Batanguru',
  },
  {
    id: '7603010003',
    districtId: '7603010',
    name: 'Tabone',
  },
  {
    id: '7603010004',
    districtId: '7603010',
    name: 'Tadisi',
  },
  {
    id: '7603010005',
    districtId: '7603010',
    name: 'Sasakan',
  },
  {
    id: '7603010006',
    districtId: '7603010',
    name: 'Sumarorong',
  },
  {
    id: '7603010007',
    districtId: '7603010',
    name: 'Banea',
  },
  {
    id: '7603010008',
    districtId: '7603010',
    name: 'Salubalo',
  },
  {
    id: '7603010009',
    districtId: '7603010',
    name: 'Batanguru Timur',
  },
  {
    id: '7603010010',
    districtId: '7603010',
    name: 'Rante Kamase',
  },
  {
    id: '7603020001',
    districtId: '7603020',
    name: 'Messawa',
  },
  {
    id: '7603020002',
    districtId: '7603020',
    name: 'Rippung',
  },
  {
    id: '7603020003',
    districtId: '7603020',
    name: 'Makuang',
  },
  {
    id: '7603020004',
    districtId: '7603020',
    name: 'Sepang',
  },
  {
    id: '7603020005',
    districtId: '7603020',
    name: 'Malimbong',
  },
  {
    id: '7603020006',
    districtId: '7603020',
    name: 'Matande',
  },
  {
    id: '7603020007',
    districtId: '7603020',
    name: 'Sipai',
  },
  {
    id: '7603020008',
    districtId: '7603020',
    name: "Pasapa' Mambu",
  },
  {
    id: '7603020009',
    districtId: '7603020',
    name: 'Tanete Batu',
  },
  {
    id: '7603030001',
    districtId: '7603030',
    name: 'Pana',
  },
  {
    id: '7603030002',
    districtId: '7603030',
    name: 'Manipi',
  },
  {
    id: '7603030003',
    districtId: '7603030',
    name: 'Mamullu',
  },
  {
    id: '7603030004',
    districtId: '7603030',
    name: 'Ulusalu',
  },
  {
    id: '7603030005',
    districtId: '7603030',
    name: 'Sapan',
  },
  {
    id: '7603030006',
    districtId: '7603030',
    name: 'Datu Baringan',
  },
  {
    id: '7603030007',
    districtId: '7603030',
    name: 'Panura',
  },
  {
    id: '7603030008',
    districtId: '7603030',
    name: 'Tallang Bulawan',
  },
  {
    id: '7603030009',
    districtId: '7603030',
    name: 'Karaka',
  },
  {
    id: '7603030010',
    districtId: '7603030',
    name: 'Weri',
  },
  {
    id: '7603030011',
    districtId: '7603030',
    name: 'Ulusalu Indah',
  },
  {
    id: '7603030012',
    districtId: '7603030',
    name: 'Salutambun',
  },
  {
    id: '7603030013',
    districtId: '7603030',
    name: 'Saloan',
  },
  {
    id: '7603031001',
    districtId: '7603031',
    name: 'Nosu',
  },
  {
    id: '7603031002',
    districtId: '7603031',
    name: 'Masewe',
  },
  {
    id: '7603031003',
    districtId: '7603031',
    name: 'Batu Papan',
  },
  {
    id: '7603031004',
    districtId: '7603031',
    name: 'Minanga',
  },
  {
    id: '7603031005',
    districtId: '7603031',
    name: 'Siwi',
  },
  {
    id: '7603031006',
    districtId: '7603031',
    name: 'Minanga Timur',
  },
  {
    id: '7603031007',
    districtId: '7603031',
    name: 'Parinding',
  },
  {
    id: '7603040001',
    districtId: '7603040',
    name: 'Tabang',
  },
  {
    id: '7603040002',
    districtId: '7603040',
    name: 'Tabang Barat',
  },
  {
    id: '7603040003',
    districtId: '7603040',
    name: "Tado' Kalua",
  },
  {
    id: '7603040004',
    districtId: '7603040',
    name: 'Masuppu',
  },
  {
    id: '7603040005',
    districtId: '7603040',
    name: 'Bakadisura',
  },
  {
    id: '7603040006',
    districtId: '7603040',
    name: "Kalama'",
  },
  {
    id: '7603040007',
    districtId: '7603040',
    name: 'Salukona',
  },
  {
    id: '7603050001',
    districtId: '7603050',
    name: 'Mamasa',
  },
  {
    id: '7603050002',
    districtId: '7603050',
    name: 'Osango',
  },
  {
    id: '7603050003',
    districtId: '7603050',
    name: 'Rambu Saratu',
  },
  {
    id: '7603050004',
    districtId: '7603050',
    name: 'Lambanan',
  },
  {
    id: '7603050005',
    districtId: '7603050',
    name: 'Lembangna Salulo',
  },
  {
    id: '7603050006',
    districtId: '7603050',
    name: 'Taupe',
  },
  {
    id: '7603050007',
    districtId: '7603050',
    name: 'Buntubuda',
  },
  {
    id: '7603050008',
    districtId: '7603050',
    name: 'Tondok Bakaru',
  },
  {
    id: '7603050009',
    districtId: '7603050',
    name: 'Pebassian',
  },
  {
    id: '7603050010',
    districtId: '7603050',
    name: 'Mambulilling',
  },
  {
    id: '7603050011',
    districtId: '7603050',
    name: 'Bombong Lambe',
  },
  {
    id: '7603050012',
    districtId: '7603050',
    name: 'Bubun Batu',
  },
  {
    id: '7603060001',
    districtId: '7603060',
    name: 'Mesakada',
  },
  {
    id: '7603060002',
    districtId: '7603060',
    name: 'Tamalantik',
  },
  {
    id: '7603060003',
    districtId: '7603060',
    name: 'Bala Batu',
  },
  {
    id: '7603060004',
    districtId: '7603060',
    name: 'Malabo',
  },
  {
    id: '7603060005',
    districtId: '7603060',
    name: 'Minake',
  },
  {
    id: '7603060006',
    districtId: '7603060',
    name: 'Mannababa',
  },
  {
    id: '7603060007',
    districtId: '7603060',
    name: 'Parondo Bulawan',
  },
  {
    id: '7603060008',
    districtId: '7603060',
    name: 'Sindagamanik',
  },
  {
    id: '7603060009',
    districtId: '7603060',
    name: 'Kanan',
  },
  {
    id: '7603060010',
    districtId: '7603060',
    name: 'Pambe',
  },
  {
    id: '7603060011',
    districtId: '7603060',
    name: 'Salurano',
  },
  {
    id: '7603060012',
    districtId: '7603060',
    name: 'Talimbung',
  },
  {
    id: '7603061001',
    districtId: '7603061',
    name: 'Balla',
  },
  {
    id: '7603061002',
    districtId: '7603061',
    name: 'Balla Satanetean',
  },
  {
    id: '7603061003',
    districtId: '7603061',
    name: 'Balla Barat',
  },
  {
    id: '7603061004',
    districtId: '7603061',
    name: 'Pidara',
  },
  {
    id: '7603061005',
    districtId: '7603061',
    name: "Balla Tumuka'",
  },
  {
    id: '7603061006',
    districtId: '7603061',
    name: 'Bambapuang',
  },
  {
    id: '7603061007',
    districtId: '7603061',
    name: 'Sepakuan',
  },
  {
    id: '7603061008',
    districtId: '7603061',
    name: 'Balla Timur',
  },
  {
    id: '7603070001',
    districtId: '7603070',
    name: 'Rantepuang',
  },
  {
    id: '7603070002',
    districtId: '7603070',
    name: 'Melangkena Padang',
  },
  {
    id: '7603070003',
    districtId: '7603070',
    name: 'Paladan',
  },
  {
    id: '7603070004',
    districtId: '7603070',
    name: 'Satanetean',
  },
  {
    id: '7603070005',
    districtId: '7603070',
    name: 'Orobua Selatan',
  },
  {
    id: '7603070006',
    districtId: '7603070',
    name: 'Orobua',
  },
  {
    id: '7603070007',
    districtId: '7603070',
    name: 'Orobua Timur',
  },
  {
    id: '7603070008',
    districtId: '7603070',
    name: "Lisuan Ada'",
  },
  {
    id: '7603070013',
    districtId: '7603070',
    name: 'Malimbong',
  },
  {
    id: '7603070014',
    districtId: '7603070',
    name: 'Marampan Orobua',
  },
  {
    id: '7603071001',
    districtId: '7603071',
    name: 'Tawalian Timur',
  },
  {
    id: '7603071002',
    districtId: '7603071',
    name: 'Kariango',
  },
  {
    id: '7603071003',
    districtId: '7603071',
    name: 'Tawalian',
  },
  {
    id: '7603071004',
    districtId: '7603071',
    name: 'Rantetangnga',
  },
  {
    id: '7603080001',
    districtId: '7603080',
    name: 'Mambi',
  },
  {
    id: '7603080002',
    districtId: '7603080',
    name: 'Talippuki',
  },
  {
    id: '7603080004',
    districtId: '7603080',
    name: 'Rantebulahan',
  },
  {
    id: '7603080006',
    districtId: '7603080',
    name: 'Sondong Lajuk',
  },
  {
    id: '7603080010',
    districtId: '7603080',
    name: 'Salubanua',
  },
  {
    id: '7603080011',
    districtId: '7603080',
    name: 'Tapalinna',
  },
  {
    id: '7603080012',
    districtId: '7603080',
    name: 'Pammoseang',
  },
  {
    id: '7603080013',
    districtId: '7603080',
    name: 'Salumakak',
  },
  {
    id: '7603080014',
    districtId: '7603080',
    name: 'Bujungmanurung',
  },
  {
    id: '7603080016',
    districtId: '7603080',
    name: 'Sendana',
  },
  {
    id: '7603080027',
    districtId: '7603080',
    name: 'Indo Banua',
  },
  {
    id: '7603080028',
    districtId: '7603080',
    name: "Salualo'",
  },
  {
    id: '7603080029',
    districtId: '7603080',
    name: 'Saludurian',
  },
  {
    id: '7603081001',
    districtId: '7603081',
    name: 'Bambang',
  },
  {
    id: '7603081002',
    districtId: '7603081',
    name: 'Bambang Timur',
  },
  {
    id: '7603081003',
    districtId: '7603081',
    name: 'Rantelemo',
  },
  {
    id: '7603081004',
    districtId: '7603081',
    name: 'Ulumambi',
  },
  {
    id: '7603081005',
    districtId: '7603081',
    name: 'Saludengen',
  },
  {
    id: '7603081006',
    districtId: '7603081',
    name: 'Minanga',
  },
  {
    id: '7603081007',
    districtId: '7603081',
    name: 'Sikamase',
  },
  {
    id: '7603081008',
    districtId: '7603081',
    name: 'Lembangmokallang',
  },
  {
    id: '7603081009',
    districtId: '7603081',
    name: 'Masoso',
  },
  {
    id: '7603081010',
    districtId: '7603081',
    name: 'Saluassing',
  },
  {
    id: '7603081011',
    districtId: '7603081',
    name: 'Salubulo',
  },
  {
    id: '7603081012',
    districtId: '7603081',
    name: 'Salukadi',
  },
  {
    id: '7603081013',
    districtId: '7603081',
    name: 'Salukepopo',
  },
  {
    id: '7603081014',
    districtId: '7603081',
    name: 'Ulumambi Barat',
  },
  {
    id: '7603081015',
    districtId: '7603081',
    name: 'Limbadebata',
  },
  {
    id: '7603081016',
    districtId: '7603081',
    name: 'Tanete Tomba',
  },
  {
    id: '7603081017',
    districtId: '7603081',
    name: 'Salutabang',
  },
  {
    id: '7603081018',
    districtId: '7603081',
    name: 'Salururu',
  },
  {
    id: '7603081019',
    districtId: '7603081',
    name: 'Rantetarima',
  },
  {
    id: '7603081020',
    districtId: '7603081',
    name: 'Balatana',
  },
  {
    id: '7603082001',
    districtId: '7603082',
    name: 'Salumokanan',
  },
  {
    id: '7603082002',
    districtId: '7603082',
    name: 'Leko',
  },
  {
    id: '7603082003',
    districtId: '7603082',
    name: 'Buangin',
  },
  {
    id: '7603082004',
    districtId: '7603082',
    name: 'Salumokanan Barat',
  },
  {
    id: '7603082005',
    districtId: '7603082',
    name: 'Salumokanan Utara',
  },
  {
    id: '7603082006',
    districtId: '7603082',
    name: 'Bambang Buda',
  },
  {
    id: '7603082007',
    districtId: '7603082',
    name: 'Kirak',
  },
  {
    id: '7603082008',
    districtId: '7603082',
    name: 'Sampale',
  },
  {
    id: '7603083001',
    districtId: '7603083',
    name: 'Botteng',
  },
  {
    id: '7603083002',
    districtId: '7603083',
    name: 'Passembuk',
  },
  {
    id: '7603083003',
    districtId: '7603083',
    name: 'Salukonta',
  },
  {
    id: '7603083004',
    districtId: '7603083',
    name: 'Leko Sukamaju',
  },
  {
    id: '7603083005',
    districtId: '7603083',
    name: 'Mesakada',
  },
  {
    id: '7603083006',
    districtId: '7603083',
    name: 'Mehalaan',
  },
  {
    id: '7603083007',
    districtId: '7603083',
    name: 'Mehalaan Barat',
  },
  {
    id: '7603083008',
    districtId: '7603083',
    name: 'Saluahok',
  },
  {
    id: '7603083009',
    districtId: '7603083',
    name: 'Kondo',
  },
  {
    id: '7603083010',
    districtId: '7603083',
    name: 'Ulumea',
  },
  {
    id: '7603083011',
    districtId: '7603083',
    name: 'Salubalo',
  },
  {
    id: '7603090001',
    districtId: '7603090',
    name: 'Aralle',
  },
  {
    id: '7603090003',
    districtId: '7603090',
    name: 'Ralleanak',
  },
  {
    id: '7603090004',
    districtId: '7603090',
    name: 'Panetean',
  },
  {
    id: '7603090005',
    districtId: '7603090',
    name: 'Uhailanu',
  },
  {
    id: '7603090007',
    districtId: '7603090',
    name: 'Aralle Utara',
  },
  {
    id: '7603090009',
    districtId: '7603090',
    name: 'Uhaidao',
  },
  {
    id: '7603090010',
    districtId: '7603090',
    name: 'Baruru',
  },
  {
    id: '7603090015',
    districtId: '7603090',
    name: 'Ralleanak Utara',
  },
  {
    id: '7603090016',
    districtId: '7603090',
    name: 'Pammoseang Pangga',
  },
  {
    id: '7603090017',
    districtId: '7603090',
    name: 'Aralle Selatan',
  },
  {
    id: '7603090018',
    districtId: '7603090',
    name: 'Hahangan',
  },
  {
    id: '7603090019',
    districtId: '7603090',
    name: 'Kalabe',
  },
  {
    id: '7603091001',
    districtId: '7603091',
    name: 'Aralle Timur',
  },
  {
    id: '7603091002',
    districtId: '7603091',
    name: 'Salutambun Timur',
  },
  {
    id: '7603091003',
    districtId: '7603091',
    name: 'Salutambun',
  },
  {
    id: '7603091004',
    districtId: '7603091',
    name: 'Kebanga',
  },
  {
    id: '7603091005',
    districtId: '7603091',
    name: 'Salutambun Barat',
  },
  {
    id: '7603091006',
    districtId: '7603091',
    name: 'Kabae',
  },
  {
    id: '7603091007',
    districtId: '7603091',
    name: 'Salurinduk',
  },
  {
    id: '7603091008',
    districtId: '7603091',
    name: 'Penatangan',
  },
  {
    id: '7603091009',
    districtId: '7603091',
    name: 'Buntu Malangka',
  },
  {
    id: '7603091010',
    districtId: '7603091',
    name: 'Ranteberang',
  },
  {
    id: '7603091011',
    districtId: '7603091',
    name: 'Taora',
  },
  {
    id: '7603100001',
    districtId: '7603100',
    name: 'Lakahang',
  },
  {
    id: '7603100002',
    districtId: '7603100',
    name: 'Periangan',
  },
  {
    id: '7603100003',
    districtId: '7603100',
    name: 'Malatiro',
  },
  {
    id: '7603100004',
    districtId: '7603100',
    name: 'Tabulahan',
  },
  {
    id: '7603100005',
    districtId: '7603100',
    name: 'Saluleang',
  },
  {
    id: '7603100007',
    districtId: '7603100',
    name: 'Tampak Kurra',
  },
  {
    id: '7603100008',
    districtId: '7603100',
    name: 'Gandang Dewata',
  },
  {
    id: '7603100009',
    districtId: '7603100',
    name: 'Burana',
  },
  {
    id: '7603100010',
    districtId: '7603100',
    name: 'Salubakka',
  },
  {
    id: '7603100011',
    districtId: '7603100',
    name: 'Pangandaran',
  },
  {
    id: '7603100012',
    districtId: '7603100',
    name: 'Lakahang Utama',
  },
  {
    id: '7603100013',
    districtId: '7603100',
    name: 'Talopak',
  },
  {
    id: '7603100014',
    districtId: '7603100',
    name: 'Timoro',
  },
  {
    id: '7604010001',
    districtId: '7604010',
    name: 'Kasambang',
  },
  {
    id: '7604010002',
    districtId: '7604010',
    name: 'Bela',
  },
  {
    id: '7604010003',
    districtId: '7604010',
    name: 'Galung',
  },
  {
    id: '7604010004',
    districtId: '7604010',
    name: 'Orobatu',
  },
  {
    id: '7604010005',
    districtId: '7604010',
    name: 'Takandeang',
  },
  {
    id: '7604010006',
    districtId: '7604010',
    name: 'Taan',
  },
  {
    id: '7604010007',
    districtId: '7604010',
    name: 'Kopeang',
  },
  {
    id: '7604010008',
    districtId: '7604010',
    name: 'Rantedoda',
  },
  {
    id: '7604010009',
    districtId: '7604010',
    name: 'Tampalang',
  },
  {
    id: '7604010010',
    districtId: '7604010',
    name: 'Dayanginna',
  },
  {
    id: '7604011001',
    districtId: '7604011',
    name: "Pasa'Bu",
  },
  {
    id: '7604011002',
    districtId: '7604011',
    name: 'Dungkait',
  },
  {
    id: '7604011003',
    districtId: '7604011',
    name: 'Labuang Rano',
  },
  {
    id: '7604011004',
    districtId: '7604011',
    name: 'Lebani',
  },
  {
    id: '7604011005',
    districtId: '7604011',
    name: 'Tanete Pao',
  },
  {
    id: '7604011006',
    districtId: '7604011',
    name: 'Ahu',
  },
  {
    id: '7604011007',
    districtId: '7604011',
    name: 'Pangasaan',
  },
  {
    id: '7604020003',
    districtId: '7604020',
    name: 'Binanga',
  },
  {
    id: '7604020004',
    districtId: '7604020',
    name: 'Mamunyu',
  },
  {
    id: '7604020005',
    districtId: '7604020',
    name: 'Tadui',
  },
  {
    id: '7604020006',
    districtId: '7604020',
    name: 'Bambu',
  },
  {
    id: '7604020007',
    districtId: '7604020',
    name: 'Karampuang',
  },
  {
    id: '7604020008',
    districtId: '7604020',
    name: 'Rimuku',
  },
  {
    id: '7604020009',
    districtId: '7604020',
    name: 'Karema',
  },
  {
    id: '7604020010',
    districtId: '7604020',
    name: 'Batu Panu',
  },
  {
    id: '7604022001',
    districtId: '7604022',
    name: 'Botteng',
  },
  {
    id: '7604022002',
    districtId: '7604022',
    name: 'Salletto',
  },
  {
    id: '7604022003',
    districtId: '7604022',
    name: 'Simboro',
  },
  {
    id: '7604022004',
    districtId: '7604022',
    name: 'Rangas',
  },
  {
    id: '7604022005',
    districtId: '7604022',
    name: 'Sumare',
  },
  {
    id: '7604022006',
    districtId: '7604022',
    name: 'Botteng Utara',
  },
  {
    id: '7604022007',
    districtId: '7604022',
    name: 'Tapandullu',
  },
  {
    id: '7604022009',
    districtId: '7604022',
    name: 'Pati`DI',
  },
  {
    id: '7604023001',
    districtId: '7604023',
    name: 'Balabalakang',
  },
  {
    id: '7604023002',
    districtId: '7604023',
    name: 'Balabalakang Timur',
  },
  {
    id: '7604030001',
    districtId: '7604030',
    name: 'Bebanga',
  },
  {
    id: '7604030002',
    districtId: '7604030',
    name: 'Sinyonyoi',
  },
  {
    id: '7604030003',
    districtId: '7604030',
    name: 'K E A N G',
  },
  {
    id: '7604030004',
    districtId: '7604030',
    name: 'Sondoang',
  },
  {
    id: '7604030005',
    districtId: '7604030',
    name: 'Kalukku',
  },
  {
    id: '7604030007',
    districtId: '7604030',
    name: 'Kabuloang',
  },
  {
    id: '7604030008',
    districtId: '7604030',
    name: 'Belang-Belang',
  },
  {
    id: '7604030009',
    districtId: '7604030',
    name: 'Pokkang',
  },
  {
    id: '7604030010',
    districtId: '7604030',
    name: 'Guliling',
  },
  {
    id: '7604030011',
    districtId: '7604030',
    name: 'Uhaimate',
  },
  {
    id: '7604030012',
    districtId: '7604030',
    name: 'Kalukku Barat',
  },
  {
    id: '7604030013',
    districtId: '7604030',
    name: 'Pammulukang',
  },
  {
    id: '7604030014',
    districtId: '7604030',
    name: 'Sinyonyoi Selatan',
  },
  {
    id: '7604031001',
    districtId: '7604031',
    name: 'Papalang',
  },
  {
    id: '7604031002',
    districtId: '7604031',
    name: 'Topore',
  },
  {
    id: '7604031003',
    districtId: '7604031',
    name: 'Sukadamai',
  },
  {
    id: '7604031004',
    districtId: '7604031',
    name: 'Salokayu I',
  },
  {
    id: '7604031005',
    districtId: '7604031',
    name: 'T O A B O',
  },
  {
    id: '7604031006',
    districtId: '7604031',
    name: 'Bonda',
  },
  {
    id: '7604031007',
    districtId: '7604031',
    name: 'Boda-Boda',
  },
  {
    id: '7604031008',
    districtId: '7604031',
    name: 'Batu Ampa',
  },
  {
    id: '7604031009',
    districtId: '7604031',
    name: 'Sisango',
  },
  {
    id: '7604032001',
    districtId: '7604032',
    name: 'Salubarana',
  },
  {
    id: '7604032002',
    districtId: '7604032',
    name: 'Kalonding',
  },
  {
    id: '7604032003',
    districtId: '7604032',
    name: 'Tanambuah',
  },
  {
    id: '7604032005',
    districtId: '7604032',
    name: 'Tarailu',
  },
  {
    id: '7604032006',
    districtId: '7604032',
    name: 'Sampaga',
  },
  {
    id: '7604032007',
    districtId: '7604032',
    name: 'Losso',
  },
  {
    id: '7604033001',
    districtId: '7604033',
    name: 'Tamemongga',
  },
  {
    id: '7604033002',
    districtId: '7604033',
    name: 'Tommo',
  },
  {
    id: '7604033003',
    districtId: '7604033',
    name: 'Buana Sakti',
  },
  {
    id: '7604033004',
    districtId: '7604033',
    name: 'Campaloga',
  },
  {
    id: '7604033005',
    districtId: '7604033',
    name: 'Rante Mario',
  },
  {
    id: '7604033006',
    districtId: '7604033',
    name: 'Tammejarra',
  },
  {
    id: '7604033007',
    districtId: '7604033',
    name: 'Malino',
  },
  {
    id: '7604033008',
    districtId: '7604033',
    name: 'Kakullasan',
  },
  {
    id: '7604033009',
    districtId: '7604033',
    name: 'Leling',
  },
  {
    id: '7604033010',
    districtId: '7604033',
    name: 'Kalepu',
  },
  {
    id: '7604033011',
    districtId: '7604033',
    name: 'Saludengen',
  },
  {
    id: '7604033012',
    districtId: '7604033',
    name: 'Sandana',
  },
  {
    id: '7604033013',
    districtId: '7604033',
    name: 'Leling Barat',
  },
  {
    id: '7604033014',
    districtId: '7604033',
    name: 'Leling Utara',
  },
  {
    id: '7604040001',
    districtId: '7604040',
    name: 'Kalumpang',
  },
  {
    id: '7604040002',
    districtId: '7604040',
    name: 'Karataun',
  },
  {
    id: '7604040003',
    districtId: '7604040',
    name: 'Siraun',
  },
  {
    id: '7604040004',
    districtId: '7604040',
    name: 'Karama',
  },
  {
    id: '7604040005',
    districtId: '7604040',
    name: 'Tumonga',
  },
  {
    id: '7604040007',
    districtId: '7604040',
    name: 'Salumakki',
  },
  {
    id: '7604040008',
    districtId: '7604040',
    name: 'Polio',
  },
  {
    id: '7604040009',
    districtId: '7604040',
    name: 'Limbong',
  },
  {
    id: '7604040010',
    districtId: '7604040',
    name: 'Sandapang',
  },
  {
    id: '7604040011',
    districtId: '7604040',
    name: 'Kondo Bulo',
  },
  {
    id: '7604040012',
    districtId: '7604040',
    name: 'Makkaliki',
  },
  {
    id: '7604040013',
    districtId: '7604040',
    name: "Lasa'",
  },
  {
    id: '7604040014',
    districtId: '7604040',
    name: 'Batu Makkada',
  },
  {
    id: '7604041001',
    districtId: '7604041',
    name: 'Buttu Ada',
  },
  {
    id: '7604041002',
    districtId: '7604041',
    name: 'Bonehau',
  },
  {
    id: '7604041003',
    districtId: '7604041',
    name: 'Salutiwo',
  },
  {
    id: '7604041005',
    districtId: '7604041',
    name: 'Lumika',
  },
  {
    id: '7604041007',
    districtId: '7604041',
    name: 'Tamalea',
  },
  {
    id: '7604041008',
    districtId: '7604041',
    name: 'Mappu',
  },
  {
    id: '7604041009',
    districtId: '7604041',
    name: 'Banuada',
  },
  {
    id: '7604041010',
    districtId: '7604041',
    name: 'Hinua',
  },
  {
    id: '7604041011',
    districtId: '7604041',
    name: 'Kinantang',
  },
  {
    id: '7605010003',
    districtId: '7605010',
    name: 'Sarudu',
  },
  {
    id: '7605010004',
    districtId: '7605010',
    name: 'Kumasari',
  },
  {
    id: '7605010007',
    districtId: '7605010',
    name: 'Bulu Mario',
  },
  {
    id: '7605010011',
    districtId: '7605010',
    name: 'Patika',
  },
  {
    id: '7605010012',
    districtId: '7605010',
    name: 'Doda',
  },
  {
    id: '7605011001',
    districtId: '7605011',
    name: 'Benggaulu',
  },
  {
    id: '7605011002',
    districtId: '7605011',
    name: 'Bulu Bonggu',
  },
  {
    id: '7605011003',
    districtId: '7605011',
    name: 'Tirta Buana',
  },
  {
    id: '7605011004',
    districtId: '7605011',
    name: 'Sarasa',
  },
  {
    id: '7605011005',
    districtId: '7605011',
    name: 'Dapurang',
  },
  {
    id: '7605012001',
    districtId: '7605012',
    name: 'Tammarunang',
  },
  {
    id: '7605012002',
    districtId: '7605012',
    name: 'Saptanajaya',
  },
  {
    id: '7605012003',
    districtId: '7605012',
    name: 'Taranggi',
  },
  {
    id: '7605012004',
    districtId: '7605012',
    name: 'Sipakainga',
  },
  {
    id: '7605020001',
    districtId: '7605020',
    name: 'Baras',
  },
  {
    id: '7605020002',
    districtId: '7605020',
    name: 'Balanti',
  },
  {
    id: '7605020003',
    districtId: '7605020',
    name: 'Motu',
  },
  {
    id: '7605020012',
    districtId: '7605020',
    name: 'Bulu Parigi',
  },
  {
    id: '7605020013',
    districtId: '7605020',
    name: 'Towoni',
  },
  {
    id: '7605020014',
    districtId: '7605020',
    name: 'Kasano',
  },
  {
    id: '7605021001',
    districtId: '7605021',
    name: 'Karave',
  },
  {
    id: '7605021002',
    districtId: '7605021',
    name: 'Lilimori',
  },
  {
    id: '7605021003',
    districtId: '7605021',
    name: 'Bukit Harapan',
  },
  {
    id: '7605021004',
    districtId: '7605021',
    name: 'Ompi',
  },
  {
    id: '7605021005',
    districtId: '7605021',
    name: 'Sumber Sari',
  },
  {
    id: '7605021006',
    districtId: '7605021',
    name: 'Lelejae',
  },
  {
    id: '7605021007',
    districtId: '7605021',
    name: 'Kasta Buana',
  },
  {
    id: '7605022001',
    districtId: '7605022',
    name: 'Bajawali',
  },
  {
    id: '7605022002',
    districtId: '7605022',
    name: 'Singgani',
  },
  {
    id: '7605022003',
    districtId: '7605022',
    name: 'Parabu',
  },
  {
    id: '7605022004',
    districtId: '7605022',
    name: 'Kenangan',
  },
  {
    id: '7605022006',
    districtId: '7605022',
    name: 'Bambakoro',
  },
  {
    id: '7605022007',
    districtId: '7605022',
    name: 'Batu Matoru',
  },
  {
    id: '7605030023',
    districtId: '7605030',
    name: 'Pasangkayu',
  },
  {
    id: '7605030024',
    districtId: '7605030',
    name: 'Martajaya',
  },
  {
    id: '7605030031',
    districtId: '7605030',
    name: 'Pakawa',
  },
  {
    id: '7605030037',
    districtId: '7605030',
    name: 'Karya Bersama',
  },
  {
    id: '7605030038',
    districtId: '7605030',
    name: 'Ako',
  },
  {
    id: '7605030039',
    districtId: '7605030',
    name: 'Gunung Sari',
  },
  {
    id: '7605031001',
    districtId: '7605031',
    name: 'Lariang',
  },
  {
    id: '7605031002',
    districtId: '7605031',
    name: 'Jengeng Raya',
  },
  {
    id: '7605031003',
    districtId: '7605031',
    name: 'Tikke',
  },
  {
    id: '7605031004',
    districtId: '7605031',
    name: 'Makmur Jaya',
  },
  {
    id: '7605031005',
    districtId: '7605031',
    name: 'Pajalele',
  },
  {
    id: '7605032001',
    districtId: '7605032',
    name: 'Martasari',
  },
  {
    id: '7605032002',
    districtId: '7605032',
    name: 'Malei',
  },
  {
    id: '7605032003',
    districtId: '7605032',
    name: 'Pedanda',
  },
  {
    id: '7605032004',
    districtId: '7605032',
    name: 'Batu Oge',
  },
  {
    id: '7605040001',
    districtId: '7605040',
    name: 'Polewali',
  },
  {
    id: '7605040002',
    districtId: '7605040',
    name: 'Bambalamotu',
  },
  {
    id: '7605040003',
    districtId: '7605040',
    name: 'Randomayang',
  },
  {
    id: '7605040007',
    districtId: '7605040',
    name: 'Pangiang',
  },
  {
    id: '7605040008',
    districtId: '7605040',
    name: 'Kalola',
  },
  {
    id: '7605040009',
    districtId: '7605040',
    name: 'Wulai',
  },
  {
    id: '7605041001',
    districtId: '7605041',
    name: 'Kasoloang',
  },
  {
    id: '7605041002',
    districtId: '7605041',
    name: 'Kaluku Nangka',
  },
  {
    id: '7605041003',
    districtId: '7605041',
    name: 'Bambaira',
  },
  {
    id: '7605041004',
    districtId: '7605041',
    name: 'Tampaure',
  },
  {
    id: '7605042001',
    districtId: '7605042',
    name: 'Maponu',
  },
  {
    id: '7605042002',
    districtId: '7605042',
    name: 'Letawa',
  },
  {
    id: '7605042003',
    districtId: '7605042',
    name: 'Sarjo',
  },
  {
    id: '7605042004',
    districtId: '7605042',
    name: 'Sarude',
  },
  {
    id: '7606010001',
    districtId: '7606010',
    name: 'Pangale',
  },
  {
    id: '7606010002',
    districtId: '7606010',
    name: 'Lemo-Lemo',
  },
  {
    id: '7606010003',
    districtId: '7606010',
    name: 'Polopangale',
  },
  {
    id: '7606010004',
    districtId: '7606010',
    name: 'Sartanamaju',
  },
  {
    id: '7606010005',
    districtId: '7606010',
    name: 'Kombiling',
  },
  {
    id: '7606010006',
    districtId: '7606010',
    name: 'Lamba-Lamba',
  },
  {
    id: '7606010007',
    districtId: '7606010',
    name: 'Polocamba',
  },
  {
    id: '7606010008',
    districtId: '7606010',
    name: 'Polo Lereng',
  },
  {
    id: '7606010009',
    districtId: '7606010',
    name: 'K U O',
  },
  {
    id: '7606020002',
    districtId: '7606020',
    name: 'Salumanurung',
  },
  {
    id: '7606020003',
    districtId: '7606020',
    name: 'Barakkang',
  },
  {
    id: '7606020004',
    districtId: '7606020',
    name: 'Tinali',
  },
  {
    id: '7606020005',
    districtId: '7606020',
    name: 'Salogatta',
  },
  {
    id: '7606020006',
    districtId: '7606020',
    name: 'K I R E',
  },
  {
    id: '7606020007',
    districtId: '7606020',
    name: 'Babana',
  },
  {
    id: '7606020008',
    districtId: '7606020',
    name: 'Pontanakayang',
  },
  {
    id: '7606020009',
    districtId: '7606020',
    name: 'Lembah Hada',
  },
  {
    id: '7606020010',
    districtId: '7606020',
    name: 'Bojo',
  },
  {
    id: '7606020011',
    districtId: '7606020',
    name: 'Pasappa',
  },
  {
    id: '7606030001',
    districtId: '7606030',
    name: 'Sulobaja',
  },
  {
    id: '7606030002',
    districtId: '7606030',
    name: 'Bambadaru',
  },
  {
    id: '7606030003',
    districtId: '7606030',
    name: 'Salo Adak',
  },
  {
    id: '7606030004',
    districtId: '7606030',
    name: 'Sejati',
  },
  {
    id: '7606030005',
    districtId: '7606030',
    name: 'Batu Parigi',
  },
  {
    id: '7606030006',
    districtId: '7606030',
    name: 'Palongan',
  },
  {
    id: '7606030007',
    districtId: '7606030',
    name: 'Mahahe',
  },
  {
    id: '7606030008',
    districtId: '7606030',
    name: 'Tobadak',
  },
  {
    id: '7606040001',
    districtId: '7606040',
    name: 'Budong-Budong',
  },
  {
    id: '7606040002',
    districtId: '7606040',
    name: 'Pangalloang',
  },
  {
    id: '7606040003',
    districtId: '7606040',
    name: 'Topoyo',
  },
  {
    id: '7606040004',
    districtId: '7606040',
    name: 'Paraili',
  },
  {
    id: '7606040005',
    districtId: '7606040',
    name: 'K A B U B U',
  },
  {
    id: '7606040007',
    districtId: '7606040',
    name: 'Sinabatta',
  },
  {
    id: '7606040008',
    districtId: '7606040',
    name: 'Waeputeh',
  },
  {
    id: '7606040009',
    districtId: '7606040',
    name: 'Tappilina',
  },
  {
    id: '7606040010',
    districtId: '7606040',
    name: 'Salupangkang IV',
  },
  {
    id: '7606040011',
    districtId: '7606040',
    name: 'Bambamanurung',
  },
  {
    id: '7606040012',
    districtId: '7606040',
    name: 'Salupangkang',
  },
  {
    id: '7606040013',
    districtId: '7606040',
    name: 'Tangkou',
  },
  {
    id: '7606040014',
    districtId: '7606040',
    name: 'Tabolang',
  },
  {
    id: '7606040015',
    districtId: '7606040',
    name: 'Salulekbo',
  },
  {
    id: '7606050001',
    districtId: '7606050',
    name: 'Kambunong',
  },
  {
    id: '7606050002',
    districtId: '7606050',
    name: 'Tasokko',
  },
  {
    id: '7606050003',
    districtId: '7606050',
    name: 'Salubiru',
  },
  {
    id: '7606050004',
    districtId: '7606050',
    name: 'L A R A',
  },
  {
    id: '7606050005',
    districtId: '7606050',
    name: 'Sukamaju',
  },
  {
    id: '7606050006',
    districtId: '7606050',
    name: 'Lembah Hopo',
  },
  {
    id: '7606050007',
    districtId: '7606050',
    name: 'UPT Lara III',
  },
  {
    id: '7606050008',
    districtId: '7606050',
    name: 'Karossa',
  },
  {
    id: '7606050009',
    districtId: '7606050',
    name: 'Kayucalla',
  },
  {
    id: '7606050010',
    districtId: '7606050',
    name: 'Kadaila',
  },
  {
    id: '7606050011',
    districtId: '7606050',
    name: 'Benggaulu',
  },
  {
    id: '7606050012',
    districtId: '7606050',
    name: 'Mora IV',
  },
  {
    id: '7606050013',
    districtId: '7606050',
    name: 'Sanjango',
  },
  {
    id: '8101040001',
    districtId: '8101040',
    name: 'Lermatang',
  },
  {
    id: '8101040002',
    districtId: '8101040',
    name: 'Latdalam',
  },
  {
    id: '8101040009',
    districtId: '8101040',
    name: 'Saumlaki',
  },
  {
    id: '8101040010',
    districtId: '8101040',
    name: 'Olilit',
  },
  {
    id: '8101040011',
    districtId: '8101040',
    name: 'Sifnana',
  },
  {
    id: '8101040012',
    districtId: '8101040',
    name: 'Lauran',
  },
  {
    id: '8101040013',
    districtId: '8101040',
    name: 'Kabiarat Raya',
  },
  {
    id: '8101040014',
    districtId: '8101040',
    name: 'Ilngei',
  },
  {
    id: '8101040015',
    districtId: '8101040',
    name: 'Wowonda',
  },
  {
    id: '8101040016',
    districtId: '8101040',
    name: 'Matakus',
  },
  {
    id: '8101040017',
    districtId: '8101040',
    name: 'Bomaki',
  },
  {
    id: '8101041002',
    districtId: '8101041',
    name: 'Lorulun',
  },
  {
    id: '8101041005',
    districtId: '8101041',
    name: 'Amdasa',
  },
  {
    id: '8101041006',
    districtId: '8101041',
    name: 'Sangliat Dol',
  },
  {
    id: '8101041007',
    districtId: '8101041',
    name: 'Sangliat Krawain',
  },
  {
    id: '8101041008',
    districtId: '8101041',
    name: 'Arui Bab',
  },
  {
    id: '8101041009',
    districtId: '8101041',
    name: 'Arui Das',
  },
  {
    id: '8101041010',
    districtId: '8101041',
    name: 'Atubul Da',
  },
  {
    id: '8101041011',
    districtId: '8101041',
    name: 'Atubul Dol',
  },
  {
    id: '8101042003',
    districtId: '8101042',
    name: 'Batu Putih',
  },
  {
    id: '8101042004',
    districtId: '8101042',
    name: 'Wermatang',
  },
  {
    id: '8101042005',
    districtId: '8101042',
    name: 'Makatian',
  },
  {
    id: '8101042006',
    districtId: '8101042',
    name: 'Weratan',
  },
  {
    id: '8101042007',
    districtId: '8101042',
    name: 'Themin',
  },
  {
    id: '8101042009',
    districtId: '8101042',
    name: 'Rumah Salut',
  },
  {
    id: '8101042010',
    districtId: '8101042',
    name: 'Kamatubun',
  },
  {
    id: '8101042011',
    districtId: '8101042',
    name: 'Marantutul',
  },
  {
    id: '8101043001',
    districtId: '8101043',
    name: 'Werain',
  },
  {
    id: '8101043002',
    districtId: '8101043',
    name: 'Fursui',
  },
  {
    id: '8101043003',
    districtId: '8101043',
    name: 'Lingat',
  },
  {
    id: '8101043004',
    districtId: '8101043',
    name: 'Kandar',
  },
  {
    id: '8101043005',
    districtId: '8101043',
    name: 'Namtabung',
  },
  {
    id: '8101043006',
    districtId: '8101043',
    name: 'Adaut',
  },
  {
    id: '8101043007',
    districtId: '8101043',
    name: 'Eliasa',
  },
  {
    id: '8101050022',
    districtId: '8101050',
    name: 'Lelingluan',
  },
  {
    id: '8101050023',
    districtId: '8101050',
    name: 'Ritabel',
  },
  {
    id: '8101050024',
    districtId: '8101050',
    name: 'Ridool',
  },
  {
    id: '8101050025',
    districtId: '8101050',
    name: 'Waitidal',
  },
  {
    id: '8101050026',
    districtId: '8101050',
    name: 'Keliober',
  },
  {
    id: '8101050027',
    districtId: '8101050',
    name: 'Lamdesar Timur',
  },
  {
    id: '8101050028',
    districtId: '8101050',
    name: 'Lamdesar Barat',
  },
  {
    id: '8101050029',
    districtId: '8101050',
    name: 'Kelaan',
  },
  {
    id: '8101051001',
    districtId: '8101051',
    name: 'Romean',
  },
  {
    id: '8101051003',
    districtId: '8101051',
    name: 'Awear',
  },
  {
    id: '8101051004',
    districtId: '8101051',
    name: 'Sofyanin',
  },
  {
    id: '8101051005',
    districtId: '8101051',
    name: 'Walerang',
  },
  {
    id: '8101051006',
    districtId: '8101051',
    name: 'Adodo Fordata',
  },
  {
    id: '8101052001',
    districtId: '8101052',
    name: 'Kilon',
  },
  {
    id: '8101052002',
    districtId: '8101052',
    name: 'Abat',
  },
  {
    id: '8101052003',
    districtId: '8101052',
    name: 'Labobar',
  },
  {
    id: '8101052004',
    districtId: '8101052',
    name: 'Wunlah',
  },
  {
    id: '8101052005',
    districtId: '8101052',
    name: 'Karatat',
  },
  {
    id: '8101052006',
    districtId: '8101052',
    name: 'Awear Rumngeur',
  },
  {
    id: '8101052007',
    districtId: '8101052',
    name: 'Watmasa',
  },
  {
    id: '8101052013',
    districtId: '8101052',
    name: 'Lingada',
  },
  {
    id: '8101052014',
    districtId: '8101052',
    name: 'Teineman',
  },
  {
    id: '8101052015',
    districtId: '8101052',
    name: 'Wabar',
  },
  {
    id: '8101052016',
    districtId: '8101052',
    name: 'Romnus',
  },
  {
    id: '8101053001',
    districtId: '8101053',
    name: 'Waturu',
  },
  {
    id: '8101053002',
    districtId: '8101053',
    name: 'Tutukembong',
  },
  {
    id: '8101053003',
    districtId: '8101053',
    name: 'Manglusi',
  },
  {
    id: '8101053004',
    districtId: '8101053',
    name: 'Arma',
  },
  {
    id: '8101053005',
    districtId: '8101053',
    name: 'Watmuri',
  },
  {
    id: '8101054001',
    districtId: '8101054',
    name: 'Lorwembun',
  },
  {
    id: '8101054002',
    districtId: '8101054',
    name: 'Alusi Batjas',
  },
  {
    id: '8101054003',
    districtId: '8101054',
    name: 'Alusi Tamrian',
  },
  {
    id: '8101054004',
    districtId: '8101054',
    name: 'Alusi Buuk Jalin',
  },
  {
    id: '8101054005',
    districtId: '8101054',
    name: 'Alusi Kelaan',
  },
  {
    id: '8101054006',
    districtId: '8101054',
    name: 'Alusi Krawain',
  },
  {
    id: '8101054008',
    districtId: '8101054',
    name: 'Kilmasa',
  },
  {
    id: '8101054009',
    districtId: '8101054',
    name: 'Lumasebu',
  },
  {
    id: '8101054010',
    districtId: '8101054',
    name: 'Meyano Bab',
  },
  {
    id: '8101054011',
    districtId: '8101054',
    name: 'Meyano Das',
  },
  {
    id: '8101055001',
    districtId: '8101055',
    name: 'Nurkat',
  },
  {
    id: '8101055002',
    districtId: '8101055',
    name: 'Tutunametal',
  },
  {
    id: '8101055003',
    districtId: '8101055',
    name: 'Wulmasa',
  },
  {
    id: '8101055004',
    districtId: '8101055',
    name: 'Wadankau',
  },
  {
    id: '8101055005',
    districtId: '8101055',
    name: 'Adodomolo',
  },
  {
    id: '8102010025',
    districtId: '8102010',
    name: 'Ngabub',
  },
  {
    id: '8102010026',
    districtId: '8102010',
    name: 'Ibra',
  },
  {
    id: '8102010030',
    districtId: '8102010',
    name: 'Sathean',
  },
  {
    id: '8102010035',
    districtId: '8102010',
    name: 'Faan',
  },
  {
    id: '8102010036',
    districtId: '8102010',
    name: 'Ohoingur',
  },
  {
    id: '8102010037',
    districtId: '8102010',
    name: 'Kel. Ohoijang Watdek',
  },
  {
    id: '8102010038',
    districtId: '8102010',
    name: 'Kolser',
  },
  {
    id: '8102010039',
    districtId: '8102010',
    name: 'Kelanit',
  },
  {
    id: '8102010042',
    districtId: '8102010',
    name: 'Ohoidertawun',
  },
  {
    id: '8102010043',
    districtId: '8102010',
    name: 'Letman',
  },
  {
    id: '8102010044',
    districtId: '8102010',
    name: 'Wearlilir',
  },
  {
    id: '8102010045',
    districtId: '8102010',
    name: 'Loon',
  },
  {
    id: '8102010046',
    districtId: '8102010',
    name: 'Dudunwahan',
  },
  {
    id: '8102010047',
    districtId: '8102010',
    name: 'Ohoider Atas',
  },
  {
    id: '8102010048',
    districtId: '8102010',
    name: 'Sitniohoi',
  },
  {
    id: '8102010049',
    districtId: '8102010',
    name: 'Watdek',
  },
  {
    id: '8102010050',
    districtId: '8102010',
    name: 'Ohoijang',
  },
  {
    id: '8102012001',
    districtId: '8102012',
    name: 'Ohoidertutu',
  },
  {
    id: '8102012002',
    districtId: '8102012',
    name: 'Madwaer',
  },
  {
    id: '8102012003',
    districtId: '8102012',
    name: 'Somlain',
  },
  {
    id: '8102012004',
    districtId: '8102012',
    name: 'Ohoiren',
  },
  {
    id: '8102012005',
    districtId: '8102012',
    name: 'Ohoira',
  },
  {
    id: '8102012006',
    districtId: '8102012',
    name: 'Ur Pulau',
  },
  {
    id: '8102012007',
    districtId: '8102012',
    name: 'Tanimbar Kei',
  },
  {
    id: '8102012008',
    districtId: '8102012',
    name: 'Warbal',
  },
  {
    id: '8102012009',
    districtId: '8102012',
    name: 'Ohoidertom',
  },
  {
    id: '8102012010',
    districtId: '8102012',
    name: 'Yatwav',
  },
  {
    id: '8102013007',
    districtId: '8102013',
    name: 'Mastur',
  },
  {
    id: '8102013008',
    districtId: '8102013',
    name: 'Ohoinol',
  },
  {
    id: '8102013009',
    districtId: '8102013',
    name: 'Wain',
  },
  {
    id: '8102013010',
    districtId: '8102013',
    name: 'Abean',
  },
  {
    id: '8102013011',
    districtId: '8102013',
    name: 'Raat',
  },
  {
    id: '8102013012',
    districtId: '8102013',
    name: 'Rumat',
  },
  {
    id: '8102013013',
    districtId: '8102013',
    name: 'Rewav',
  },
  {
    id: '8102013014',
    districtId: '8102013',
    name: 'Mastur Baru',
  },
  {
    id: '8102013015',
    districtId: '8102013',
    name: 'Ohoilus',
  },
  {
    id: '8102013018',
    districtId: '8102013',
    name: 'Semawi',
  },
  {
    id: '8102013019',
    districtId: '8102013',
    name: 'Iso',
  },
  {
    id: '8102013020',
    districtId: '8102013',
    name: 'Wain Baru',
  },
  {
    id: '8102013021',
    districtId: '8102013',
    name: 'Disuk',
  },
  {
    id: '8102013022',
    districtId: '8102013',
    name: 'Marfun',
  },
  {
    id: '8102013023',
    districtId: '8102013',
    name: 'Yafawun',
  },
  {
    id: '8102013024',
    districtId: '8102013',
    name: 'Watngon',
  },
  {
    id: '8102014001',
    districtId: '8102014',
    name: 'Warwut',
  },
  {
    id: '8102014002',
    districtId: '8102014',
    name: 'Wab',
  },
  {
    id: '8102014003',
    districtId: '8102014',
    name: 'Arso',
  },
  {
    id: '8102014004',
    districtId: '8102014',
    name: 'Watngil',
  },
  {
    id: '8102014005',
    districtId: '8102014',
    name: 'Ohoibadar',
  },
  {
    id: '8102014007',
    districtId: '8102014',
    name: 'Letvuan',
  },
  {
    id: '8102014008',
    districtId: '8102014',
    name: 'Tetoat',
  },
  {
    id: '8102014009',
    districtId: '8102014',
    name: 'Ngursit',
  },
  {
    id: '8102014010',
    districtId: '8102014',
    name: 'Madwat',
  },
  {
    id: '8102014011',
    districtId: '8102014',
    name: 'Wirin',
  },
  {
    id: '8102014012',
    districtId: '8102014',
    name: 'Dian Pulau',
  },
  {
    id: '8102014013',
    districtId: '8102014',
    name: 'Dian Darat',
  },
  {
    id: '8102015001',
    districtId: '8102015',
    name: 'Rumadian',
  },
  {
    id: '8102015003',
    districtId: '8102015',
    name: 'Namar',
  },
  {
    id: '8102015004',
    districtId: '8102015',
    name: 'Lairngangas',
  },
  {
    id: '8102015005',
    districtId: '8102015',
    name: 'Selayar',
  },
  {
    id: '8102015006',
    districtId: '8102015',
    name: 'Ngayub',
  },
  {
    id: '8102015007',
    districtId: '8102015',
    name: 'Ohoiluk',
  },
  {
    id: '8102015008',
    districtId: '8102015',
    name: 'Ngilngof',
  },
  {
    id: '8102015009',
    districtId: '8102015',
    name: 'Ohoililir',
  },
  {
    id: '8102016001',
    districtId: '8102016',
    name: 'Ohoiseb',
  },
  {
    id: '8102016002',
    districtId: '8102016',
    name: 'Sare',
  },
  {
    id: '8102016004',
    districtId: '8102016',
    name: 'Mar',
  },
  {
    id: '8102016005',
    districtId: '8102016',
    name: 'Danar Ternate',
  },
  {
    id: '8102016006',
    districtId: '8102016',
    name: 'Lumefar',
  },
  {
    id: '8102016007',
    districtId: '8102016',
    name: 'Ngursoin',
  },
  {
    id: '8102016008',
    districtId: '8102016',
    name: 'Elaar Lamagorang',
  },
  {
    id: '8102016009',
    districtId: '8102016',
    name: 'Elaar Let',
  },
  {
    id: '8102016011',
    districtId: '8102016',
    name: 'Garara',
  },
  {
    id: '8102020015',
    districtId: '8102020',
    name: 'Ohoiwait',
  },
  {
    id: '8102020016',
    districtId: '8102020',
    name: 'Ohoiel',
  },
  {
    id: '8102020017',
    districtId: '8102020',
    name: 'Werka',
  },
  {
    id: '8102020018',
    districtId: '8102020',
    name: 'Ler Ohoilim',
  },
  {
    id: '8102020019',
    districtId: '8102020',
    name: 'Rahareng',
  },
  {
    id: '8102020020',
    districtId: '8102020',
    name: 'Waur',
  },
  {
    id: '8102020021',
    districtId: '8102020',
    name: 'Ngefuit',
  },
  {
    id: '8102020022',
    districtId: '8102020',
    name: 'Waurtahait',
  },
  {
    id: '8102020023',
    districtId: '8102020',
    name: 'Yamtel',
  },
  {
    id: '8102020024',
    districtId: '8102020',
    name: 'Ohoinangan',
  },
  {
    id: '8102020025',
    districtId: '8102020',
    name: 'Elat',
  },
  {
    id: '8102020027',
    districtId: '8102020',
    name: 'Ohoilim',
  },
  {
    id: '8102020028',
    districtId: '8102020',
    name: 'Fako',
  },
  {
    id: '8102020029',
    districtId: '8102020',
    name: 'Reyamru',
  },
  {
    id: '8102020030',
    districtId: '8102020',
    name: 'Elralang',
  },
  {
    id: '8102020042',
    districtId: '8102020',
    name: 'Watuar',
  },
  {
    id: '8102020043',
    districtId: '8102020',
    name: 'Mataholat',
  },
  {
    id: '8102020044',
    districtId: '8102020',
    name: 'Harangur',
  },
  {
    id: '8102020045',
    districtId: '8102020',
    name: 'Udar',
  },
  {
    id: '8102020046',
    districtId: '8102020',
    name: 'Daftel',
  },
  {
    id: '8102020047',
    districtId: '8102020',
    name: 'Karkarit',
  },
  {
    id: '8102020048',
    districtId: '8102020',
    name: 'Rahareng Atas',
  },
  {
    id: '8102020049',
    districtId: '8102020',
    name: 'Wulurat',
  },
  {
    id: '8102020050',
    districtId: '8102020',
    name: 'Ngefuit Atas',
  },
  {
    id: '8102020051',
    districtId: '8102020',
    name: 'Nabaheng',
  },
  {
    id: '8102020052',
    districtId: '8102020',
    name: 'Ohoiwang',
  },
  {
    id: '8102020053',
    districtId: '8102020',
    name: 'Fangamas',
  },
  {
    id: '8102020054',
    districtId: '8102020',
    name: 'Ohoinangan Atas',
  },
  {
    id: '8102020055',
    districtId: '8102020',
    name: 'Wakol',
  },
  {
    id: '8102020057',
    districtId: '8102020',
    name: 'Soinrat',
  },
  {
    id: '8102020058',
    districtId: '8102020',
    name: 'Wermaf',
  },
  {
    id: '8102020059',
    districtId: '8102020',
    name: 'Bombay',
  },
  {
    id: '8102020060',
    districtId: '8102020',
    name: 'Watsin',
  },
  {
    id: '8102020061',
    districtId: '8102020',
    name: 'Sirbante',
  },
  {
    id: '8102020062',
    districtId: '8102020',
    name: 'Ngat',
  },
  {
    id: '8102021001',
    districtId: '8102021',
    name: 'Kilwair',
  },
  {
    id: '8102021002',
    districtId: '8102021',
    name: 'Hollat',
  },
  {
    id: '8102021003',
    districtId: '8102021',
    name: 'Ohoifau',
  },
  {
    id: '8102021004',
    districtId: '8102021',
    name: 'Watlar',
  },
  {
    id: '8102021005',
    districtId: '8102021',
    name: 'Banda Eli',
  },
  {
    id: '8102021006',
    districtId: '8102021',
    name: 'Renfaan',
  },
  {
    id: '8102021007',
    districtId: '8102021',
    name: 'Langgiar Haar',
  },
  {
    id: '8102021008',
    districtId: '8102021',
    name: 'Haar Ohoimel',
  },
  {
    id: '8102021009',
    districtId: '8102021',
    name: 'Ohoiraut',
  },
  {
    id: '8102021010',
    districtId: '8102021',
    name: 'Ohoiwirin',
  },
  {
    id: '8102021011',
    districtId: '8102021',
    name: 'Tuburngil',
  },
  {
    id: '8102021012',
    districtId: '8102021',
    name: 'Yamtimur',
  },
  {
    id: '8102021013',
    districtId: '8102021',
    name: 'Hollat Solair',
  },
  {
    id: '8102021014',
    districtId: '8102021',
    name: 'Hoko',
  },
  {
    id: '8102021015',
    districtId: '8102021',
    name: 'Hollay',
  },
  {
    id: '8102021016',
    districtId: '8102021',
    name: 'Ohoifaruan',
  },
  {
    id: '8102021017',
    districtId: '8102021',
    name: 'Banda Efruan',
  },
  {
    id: '8102021018',
    districtId: '8102021',
    name: 'Banda Suku Tiga Puluh',
  },
  {
    id: '8102021019',
    districtId: '8102021',
    name: 'Tuburlay',
  },
  {
    id: '8102021020',
    districtId: '8102021',
    name: 'Renfaan Islam',
  },
  {
    id: '8102021021',
    districtId: '8102021',
    name: 'Renfaan Gpm',
  },
  {
    id: '8102021022',
    districtId: '8102021',
    name: 'Fanwav',
  },
  {
    id: '8102021024',
    districtId: '8102021',
    name: 'Ohoimajang',
  },
  {
    id: '8102021025',
    districtId: '8102021',
    name: 'Haar Renrahantel',
  },
  {
    id: '8102021026',
    districtId: '8102021',
    name: 'Haar Ohoimur Gpm',
  },
  {
    id: '8102021027',
    districtId: '8102021',
    name: 'Haar Ohoimur RK',
  },
  {
    id: '8102021028',
    districtId: '8102021',
    name: 'Haar Ohoiwait',
  },
  {
    id: '8102021029',
    districtId: '8102021',
    name: 'Haar Wassar',
  },
  {
    id: '8102021030',
    districtId: '8102021',
    name: 'Soin',
  },
  {
    id: '8102022004',
    districtId: '8102022',
    name: 'Kilwat',
  },
  {
    id: '8102022007',
    districtId: '8102022',
    name: 'Tamangil Nuhuyanat',
  },
  {
    id: '8102022008',
    districtId: '8102022',
    name: 'Sather',
  },
  {
    id: '8102022009',
    districtId: '8102022',
    name: 'Tutrean',
  },
  {
    id: '8102022010',
    districtId: '8102022',
    name: 'Weduar',
  },
  {
    id: '8102022011',
    districtId: '8102022',
    name: 'Tamangil Nuhuten',
  },
  {
    id: '8102022012',
    districtId: '8102022',
    name: 'Larat',
  },
  {
    id: '8102022013',
    districtId: '8102022',
    name: 'Nerong',
  },
  {
    id: '8102022014',
    districtId: '8102022',
    name: 'Ohoirenan',
  },
  {
    id: '8102022015',
    districtId: '8102022',
    name: 'Soindat',
  },
  {
    id: '8102023001',
    districtId: '8102023',
    name: 'Weer Ohoinam',
  },
  {
    id: '8102023002',
    districtId: '8102023',
    name: 'Weer Ohoiker',
  },
  {
    id: '8102023003',
    districtId: '8102023',
    name: 'Weer Frawav',
  },
  {
    id: '8102023004',
    districtId: '8102023',
    name: 'Faa',
  },
  {
    id: '8102023005',
    districtId: '8102023',
    name: 'Dangarat',
  },
  {
    id: '8102023006',
    districtId: '8102023',
    name: 'Ohoituf',
  },
  {
    id: '8102023007',
    districtId: '8102023',
    name: 'Hangur',
  },
  {
    id: '8102023008',
    districtId: '8102023',
    name: 'Ngurwalek',
  },
  {
    id: '8102023009',
    districtId: '8102023',
    name: 'Uwat',
  },
  {
    id: '8102023010',
    districtId: '8102023',
    name: 'Uwat Wear',
  },
  {
    id: '8102023011',
    districtId: '8102023',
    name: 'Uwat Reyaan',
  },
  {
    id: '8102023012',
    districtId: '8102023',
    name: 'Mun Ohoitadium',
  },
  {
    id: '8102023013',
    districtId: '8102023',
    name: 'Mun Werfan',
  },
  {
    id: '8102023014',
    districtId: '8102023',
    name: 'Mun Ohoiir',
  },
  {
    id: '8102023015',
    districtId: '8102023',
    name: 'Mun Esoy',
  },
  {
    id: '8102023016',
    districtId: '8102023',
    name: 'Mun Kahar',
  },
  {
    id: '8102023017',
    districtId: '8102023',
    name: 'Mun Ngurditwain',
  },
  {
    id: '8102023018',
    districtId: '8102023',
    name: 'Ad Wearaur',
  },
  {
    id: '8102023019',
    districtId: '8102023',
    name: 'Ad Ngurwul',
  },
  {
    id: '8102023020',
    districtId: '8102023',
    name: 'Ad Ohoiwaf',
  },
  {
    id: '8102023021',
    districtId: '8102023',
    name: 'Lar',
  },
  {
    id: '8102023022',
    districtId: '8102023',
    name: 'Hoor Islam',
  },
  {
    id: '8102023023',
    districtId: '8102023',
    name: 'Hoor Kristen',
  },
  {
    id: '8102023024',
    districtId: '8102023',
    name: 'Waer',
  },
  {
    id: '8102023025',
    districtId: '8102023',
    name: 'Waerat',
  },
  {
    id: '8102024001',
    districtId: '8102024',
    name: 'Weduar Feer',
  },
  {
    id: '8102024002',
    districtId: '8102024',
    name: 'Rahangiar',
  },
  {
    id: '8102024003',
    districtId: '8102024',
    name: 'Uat',
  },
  {
    id: '8102024004',
    districtId: '8102024',
    name: 'Ngan',
  },
  {
    id: '8102024005',
    districtId: '8102024',
    name: 'Ohoilean',
  },
  {
    id: '8102024006',
    districtId: '8102024',
    name: 'Wafol',
  },
  {
    id: '8102024007',
    districtId: '8102024',
    name: 'Watkidat',
  },
  {
    id: '8102024009',
    districtId: '8102024',
    name: 'Rerean',
  },
  {
    id: '8102024010',
    districtId: '8102024',
    name: 'Ngurko',
  },
  {
    id: '8102024011',
    districtId: '8102024',
    name: 'Hako',
  },
  {
    id: '8102024012',
    districtId: '8102024',
    name: 'Ngafan',
  },
  {
    id: '8102024013',
    districtId: '8102024',
    name: 'Hoat',
  },
  {
    id: '8103010001',
    districtId: '8103010',
    name: 'Pulau Rhun',
  },
  {
    id: '8103010002',
    districtId: '8103010',
    name: 'Pulau Ay',
  },
  {
    id: '8103010003',
    districtId: '8103010',
    name: 'Lonthoir',
  },
  {
    id: '8103010004',
    districtId: '8103010',
    name: 'Pulau Hatta',
  },
  {
    id: '8103010005',
    districtId: '8103010',
    name: 'Selamon',
  },
  {
    id: '8103010006',
    districtId: '8103010',
    name: 'Kampung Baru',
  },
  {
    id: '8103010007',
    districtId: '8103010',
    name: 'Dwiwarna',
  },
  {
    id: '8103010008',
    districtId: '8103010',
    name: 'Rajawali',
  },
  {
    id: '8103010009',
    districtId: '8103010',
    name: 'Merdeka',
  },
  {
    id: '8103010010',
    districtId: '8103010',
    name: 'Nusantara',
  },
  {
    id: '8103010011',
    districtId: '8103010',
    name: 'Waer',
  },
  {
    id: '8103010012',
    districtId: '8103010',
    name: 'Tanah Rata',
  },
  {
    id: '8103010013',
    districtId: '8103010',
    name: 'Uring Tutra',
  },
  {
    id: '8103010014',
    districtId: '8103010',
    name: 'Lautang',
  },
  {
    id: '8103010015',
    districtId: '8103010',
    name: 'Walling Spanciby',
  },
  {
    id: '8103010016',
    districtId: '8103010',
    name: 'Boiyauw',
  },
  {
    id: '8103010018',
    districtId: '8103010',
    name: 'Combir Kasestoren',
  },
  {
    id: '8103040001',
    districtId: '8103040',
    name: 'Salamahu',
  },
  {
    id: '8103040002',
    districtId: '8103040',
    name: 'Haya',
  },
  {
    id: '8103040003',
    districtId: '8103040',
    name: 'Tehoru',
  },
  {
    id: '8103040004',
    districtId: '8103040',
    name: 'Saunulu',
  },
  {
    id: '8103040005',
    districtId: '8103040',
    name: 'Yaputih',
  },
  {
    id: '8103040006',
    districtId: '8103040',
    name: 'Piliana',
  },
  {
    id: '8103040007',
    districtId: '8103040',
    name: 'Hatu',
  },
  {
    id: '8103040008',
    districtId: '8103040',
    name: 'Hatumete',
  },
  {
    id: '8103040009',
    districtId: '8103040',
    name: 'Mosso',
  },
  {
    id: '8103040010',
    districtId: '8103040',
    name: 'Telutih Baru',
  },
  {
    id: '8103041001',
    districtId: '8103041',
    name: 'Wolu',
  },
  {
    id: '8103041002',
    districtId: '8103041',
    name: 'Lafa',
  },
  {
    id: '8103041003',
    districtId: '8103041',
    name: 'Tehua',
  },
  {
    id: '8103041004',
    districtId: '8103041',
    name: 'Maneoratu',
  },
  {
    id: '8103041005',
    districtId: '8103041',
    name: 'Laimu',
  },
  {
    id: '8103041006',
    districtId: '8103041',
    name: 'Hunisi',
  },
  {
    id: '8103041007',
    districtId: '8103041',
    name: 'Yamalatu',
  },
  {
    id: '8103041008',
    districtId: '8103041',
    name: 'Laha',
  },
  {
    id: '8103041009',
    districtId: '8103041',
    name: 'Laha Kaba',
  },
  {
    id: '8103041010',
    districtId: '8103041',
    name: 'Ulahahan',
  },
  {
    id: '8103050009',
    districtId: '8103050',
    name: 'Banda Baru',
  },
  {
    id: '8103050010',
    districtId: '8103050',
    name: 'Yafila',
  },
  {
    id: '8103050011',
    districtId: '8103050',
    name: 'Hollo',
  },
  {
    id: '8103050012',
    districtId: '8103050',
    name: 'Makariki',
  },
  {
    id: '8103050013',
    districtId: '8103050',
    name: 'Sehati',
  },
  {
    id: '8103050014',
    districtId: '8103050',
    name: 'Haruru',
  },
  {
    id: '8103050020',
    districtId: '8103050',
    name: 'Amahai',
  },
  {
    id: '8103050021',
    districtId: '8103050',
    name: 'Soahuku',
  },
  {
    id: '8103050022',
    districtId: '8103050',
    name: 'Rutah',
  },
  {
    id: '8103050023',
    districtId: '8103050',
    name: 'Sepa',
  },
  {
    id: '8103050024',
    districtId: '8103050',
    name: 'Tamilouw',
  },
  {
    id: '8103050025',
    districtId: '8103050',
    name: 'Nua Nea',
  },
  {
    id: '8103050026',
    districtId: '8103050',
    name: 'Yainuelo',
  },
  {
    id: '8103050028',
    districtId: '8103050',
    name: 'Hatuhenu',
  },
  {
    id: '8103051001',
    districtId: '8103051',
    name: 'Letwaru',
  },
  {
    id: '8103051002',
    districtId: '8103051',
    name: 'Lesane',
  },
  {
    id: '8103051003',
    districtId: '8103051',
    name: 'Ampera',
  },
  {
    id: '8103051004',
    districtId: '8103051',
    name: 'Namaelo',
  },
  {
    id: '8103051005',
    districtId: '8103051',
    name: 'Namasina',
  },
  {
    id: '8103052004',
    districtId: '8103052',
    name: 'Sahulau',
  },
  {
    id: '8103052005',
    districtId: '8103052',
    name: 'Liang',
  },
  {
    id: '8103052006',
    districtId: '8103052',
    name: 'Tananahu',
  },
  {
    id: '8103052007',
    districtId: '8103052',
    name: 'Waraka',
  },
  {
    id: '8103060001',
    districtId: '8103060',
    name: 'Usliapan',
  },
  {
    id: '8103060002',
    districtId: '8103060',
    name: 'Kuralele',
  },
  {
    id: '8103060003',
    districtId: '8103060',
    name: 'Kokroman',
  },
  {
    id: '8103060004',
    districtId: '8103060',
    name: 'Messa',
  },
  {
    id: '8103060005',
    districtId: '8103060',
    name: 'Ameth',
  },
  {
    id: '8103060007',
    districtId: '8103060',
    name: 'Sifluru',
  },
  {
    id: '8103060008',
    districtId: '8103060',
    name: 'Wotay',
  },
  {
    id: '8103060009',
    districtId: '8103060',
    name: 'Issu',
  },
  {
    id: '8103060010',
    districtId: '8103060',
    name: 'Watludan',
  },
  {
    id: '8103060011',
    districtId: '8103060',
    name: 'Trana',
  },
  {
    id: '8103060012',
    districtId: '8103060',
    name: 'Jerili',
  },
  {
    id: '8103060014',
    districtId: '8103060',
    name: 'Layeni',
  },
  {
    id: '8103060015',
    districtId: '8103060',
    name: 'UPT Tonetanah',
  },
  {
    id: '8103060016',
    districtId: '8103060',
    name: 'Waru',
  },
  {
    id: '8103060017',
    districtId: '8103060',
    name: 'Nakupia',
  },
  {
    id: '8103080012',
    districtId: '8103080',
    name: 'Saparua',
  },
  {
    id: '8103080013',
    districtId: '8103080',
    name: 'Tiouw',
  },
  {
    id: '8103080014',
    districtId: '8103080',
    name: 'Paperu',
  },
  {
    id: '8103080015',
    districtId: '8103080',
    name: 'Booi',
  },
  {
    id: '8103080016',
    districtId: '8103080',
    name: 'Haria',
  },
  {
    id: '8103080017',
    districtId: '8103080',
    name: 'Porto',
  },
  {
    id: '8103081001',
    districtId: '8103081',
    name: 'Titawaai',
  },
  {
    id: '8103081002',
    districtId: '8103081',
    name: 'Abubu',
  },
  {
    id: '8103081003',
    districtId: '8103081',
    name: 'Akoon',
  },
  {
    id: '8103081004',
    districtId: '8103081',
    name: 'Ameth',
  },
  {
    id: '8103081005',
    districtId: '8103081',
    name: 'Nalahia',
  },
  {
    id: '8103081006',
    districtId: '8103081',
    name: 'Sila',
  },
  {
    id: '8103081007',
    districtId: '8103081',
    name: 'Leinitu',
  },
  {
    id: '8103082001',
    districtId: '8103082',
    name: 'Ouw',
  },
  {
    id: '8103082002',
    districtId: '8103082',
    name: 'Ullath',
  },
  {
    id: '8103082003',
    districtId: '8103082',
    name: 'Siri Sori',
  },
  {
    id: '8103082004',
    districtId: '8103082',
    name: 'Siri-Sori Amalatu',
  },
  {
    id: '8103082005',
    districtId: '8103082',
    name: 'Tuhaha',
  },
  {
    id: '8103082006',
    districtId: '8103082',
    name: 'Ihamahu',
  },
  {
    id: '8103082007',
    districtId: '8103082',
    name: 'Iha',
  },
  {
    id: '8103082008',
    districtId: '8103082',
    name: 'Nolloth',
  },
  {
    id: '8103082009',
    districtId: '8103082',
    name: 'Itawaka',
  },
  {
    id: '8103082010',
    districtId: '8103082',
    name: 'Mahu',
  },
  {
    id: '8103090001',
    districtId: '8103090',
    name: 'Haruku',
  },
  {
    id: '8103090002',
    districtId: '8103090',
    name: 'Oma',
  },
  {
    id: '8103090003',
    districtId: '8103090',
    name: 'Wassu',
  },
  {
    id: '8103090004',
    districtId: '8103090',
    name: 'Aboru',
  },
  {
    id: '8103090005',
    districtId: '8103090',
    name: 'Hulaliu',
  },
  {
    id: '8103090006',
    districtId: '8103090',
    name: 'Kariu',
  },
  {
    id: '8103090007',
    districtId: '8103090',
    name: 'Pelauw',
  },
  {
    id: '8103090008',
    districtId: '8103090',
    name: 'Kailolo',
  },
  {
    id: '8103090009',
    districtId: '8103090',
    name: 'Kabauw',
  },
  {
    id: '8103090010',
    districtId: '8103090',
    name: 'Rohomoni',
  },
  {
    id: '8103090011',
    districtId: '8103090',
    name: 'Sameth',
  },
  {
    id: '8103100001',
    districtId: '8103100',
    name: 'Suli',
  },
  {
    id: '8103100002',
    districtId: '8103100',
    name: 'Tial',
  },
  {
    id: '8103100003',
    districtId: '8103100',
    name: 'Tengah-Tengah',
  },
  {
    id: '8103100005',
    districtId: '8103100',
    name: 'Waai',
  },
  {
    id: '8103100006',
    districtId: '8103100',
    name: 'Liang',
  },
  {
    id: '8103110004',
    districtId: '8103110',
    name: 'Assilulu',
  },
  {
    id: '8103110008',
    districtId: '8103110',
    name: 'Negeri Lima',
  },
  {
    id: '8103110009',
    districtId: '8103110',
    name: 'Seith',
  },
  {
    id: '8103110010',
    districtId: '8103110',
    name: 'Kaitetu',
  },
  {
    id: '8103110011',
    districtId: '8103110',
    name: 'Hila',
  },
  {
    id: '8103110012',
    districtId: '8103110',
    name: 'Wakal',
  },
  {
    id: '8103110013',
    districtId: '8103110',
    name: 'Hitulama',
  },
  {
    id: '8103110014',
    districtId: '8103110',
    name: 'Hitumesing',
  },
  {
    id: '8103110015',
    districtId: '8103110',
    name: 'Mamala',
  },
  {
    id: '8103110016',
    districtId: '8103110',
    name: 'Morella',
  },
  {
    id: '8103111001',
    districtId: '8103111',
    name: 'Larike',
  },
  {
    id: '8103111002',
    districtId: '8103111',
    name: 'Wakasihu',
  },
  {
    id: '8103111003',
    districtId: '8103111',
    name: 'Allang',
  },
  {
    id: '8103111004',
    districtId: '8103111',
    name: 'Lilibooy',
  },
  {
    id: '8103111005',
    districtId: '8103111',
    name: 'Hatu',
  },
  {
    id: '8103140009',
    districtId: '8103140',
    name: 'Huaulu',
  },
  {
    id: '8103140010',
    districtId: '8103140',
    name: 'Sawai',
  },
  {
    id: '8103140011',
    districtId: '8103140',
    name: 'Manusela',
  },
  {
    id: '8103140012',
    districtId: '8103140',
    name: 'Kanike',
  },
  {
    id: '8103140013',
    districtId: '8103140',
    name: 'Roho',
  },
  {
    id: '8103140014',
    districtId: '8103140',
    name: 'Rumahsokat',
  },
  {
    id: '8103140015',
    districtId: '8103140',
    name: 'Wahai',
  },
  {
    id: '8103140016',
    districtId: '8103140',
    name: 'Air Besar',
  },
  {
    id: '8103140017',
    districtId: '8103140',
    name: 'Pasahari',
  },
  {
    id: '8103140018',
    districtId: '8103140',
    name: 'Kaloa',
  },
  {
    id: '8103140039',
    districtId: '8103140',
    name: 'Malaku',
  },
  {
    id: '8103140041',
    districtId: '8103140',
    name: 'Besi',
  },
  {
    id: '8103140042',
    districtId: '8103140',
    name: 'Maraina',
  },
  {
    id: '8103140043',
    districtId: '8103140',
    name: 'Solea',
  },
  {
    id: '8103140044',
    districtId: '8103140',
    name: 'Siatele',
  },
  {
    id: '8103140045',
    districtId: '8103140',
    name: 'Elemata',
  },
  {
    id: '8103140046',
    districtId: '8103140',
    name: 'Hatuolo',
  },
  {
    id: '8103140047',
    districtId: '8103140',
    name: 'Masihulan',
  },
  {
    id: '8103140048',
    districtId: '8103140',
    name: 'Oping',
  },
  {
    id: '8103140049',
    districtId: '8103140',
    name: 'Olong',
  },
  {
    id: '8103141001',
    districtId: '8103141',
    name: 'Warasiwa',
  },
  {
    id: '8103141002',
    districtId: '8103141',
    name: 'Rumahwey',
  },
  {
    id: '8103141003',
    districtId: '8103141',
    name: 'Lisabata Timur',
  },
  {
    id: '8103141004',
    districtId: '8103141',
    name: 'Latea',
  },
  {
    id: '8103141005',
    districtId: '8103141',
    name: 'Gale-Gale',
  },
  {
    id: '8103141006',
    districtId: '8103141',
    name: 'Labuan',
  },
  {
    id: '8103141007',
    districtId: '8103141',
    name: 'Pasanea',
  },
  {
    id: '8103141008',
    districtId: '8103141',
    name: 'Karlutukara',
  },
  {
    id: '8103141009',
    districtId: '8103141',
    name: 'Paa',
  },
  {
    id: '8103141010',
    districtId: '8103141',
    name: 'Wailulu',
  },
  {
    id: '8103141011',
    districtId: '8103141',
    name: 'Horale',
  },
  {
    id: '8103141012',
    districtId: '8103141',
    name: 'Saleman',
  },
  {
    id: '8103141013',
    districtId: '8103141',
    name: 'Herlau Pauni',
  },
  {
    id: '8103142001',
    districtId: '8103142',
    name: 'Kobi',
  },
  {
    id: '8103142002',
    districtId: '8103142',
    name: 'Kobimukti',
  },
  {
    id: '8103142003',
    districtId: '8103142',
    name: 'Maneo Rendah',
  },
  {
    id: '8103142004',
    districtId: '8103142',
    name: 'Leaway',
  },
  {
    id: '8103142005',
    districtId: '8103142',
    name: 'Samal',
  },
  {
    id: '8103142006',
    districtId: '8103142',
    name: 'Waitonipa',
  },
  {
    id: '8103142007',
    districtId: '8103142',
    name: 'Morokai',
  },
  {
    id: '8103142008',
    districtId: '8103142',
    name: 'Waimusi',
  },
  {
    id: '8103142009',
    districtId: '8103142',
    name: 'Wai Asih',
  },
  {
    id: '8103142010',
    districtId: '8103142',
    name: 'Marasahua',
  },
  {
    id: '8103142011',
    districtId: '8103142',
    name: 'Sariputih',
  },
  {
    id: '8103142012',
    districtId: '8103142',
    name: 'Kabauhari',
  },
  {
    id: '8103143001',
    districtId: '8103143',
    name: 'Tihuana',
  },
  {
    id: '8103143002',
    districtId: '8103143',
    name: 'Kobisonta',
  },
  {
    id: '8103143003',
    districtId: '8103143',
    name: 'Seti',
  },
  {
    id: '8103143004',
    districtId: '8103143',
    name: 'Wailoping',
  },
  {
    id: '8103143005',
    districtId: '8103143',
    name: 'Waitila',
  },
  {
    id: '8103143006',
    districtId: '8103143',
    name: 'Waiputih',
  },
  {
    id: '8103143007',
    districtId: '8103143',
    name: 'Aketernate',
  },
  {
    id: '8103143008',
    districtId: '8103143',
    name: 'Tanah Merah',
  },
  {
    id: '8103143009',
    districtId: '8103143',
    name: 'Namto',
  },
  {
    id: '8103143010',
    districtId: '8103143',
    name: 'Waimusal',
  },
  {
    id: '8103143011',
    districtId: '8103143',
    name: 'Loping Mulyo',
  },
  {
    id: '8103143012',
    districtId: '8103143',
    name: 'Wonosari',
  },
  {
    id: '8104020001',
    districtId: '8104020',
    name: 'Jamilu',
  },
  {
    id: '8104020002',
    districtId: '8104020',
    name: 'Sanleko',
  },
  {
    id: '8104020003',
    districtId: '8104020',
    name: 'Siahoni',
  },
  {
    id: '8104020004',
    districtId: '8104020',
    name: 'Namlea',
  },
  {
    id: '8104020005',
    districtId: '8104020',
    name: 'Lala',
  },
  {
    id: '8104020006',
    districtId: '8104020',
    name: 'Karang Jaya',
  },
  {
    id: '8104020012',
    districtId: '8104020',
    name: 'Batu Boy',
  },
  {
    id: '8104021014',
    districtId: '8104021',
    name: 'Waenetat',
  },
  {
    id: '8104021017',
    districtId: '8104021',
    name: 'Waekasar',
  },
  {
    id: '8104021018',
    districtId: '8104021',
    name: 'Waekerta',
  },
  {
    id: '8104021019',
    districtId: '8104021',
    name: 'Savanajaya',
  },
  {
    id: '8104021020',
    districtId: '8104021',
    name: 'Waetele',
  },
  {
    id: '8104021024',
    districtId: '8104021',
    name: 'Wanareja',
  },
  {
    id: '8104021032',
    districtId: '8104021',
    name: 'Gogrea',
  },
  {
    id: '8104022001',
    districtId: '8104022',
    name: 'Waepoti',
  },
  {
    id: '8104022002',
    districtId: '8104022',
    name: 'Waprea',
  },
  {
    id: '8104022003',
    districtId: '8104022',
    name: 'Wailihang',
  },
  {
    id: '8104022004',
    districtId: '8104022',
    name: 'Hatawano',
  },
  {
    id: '8104022005',
    districtId: '8104022',
    name: 'Namsina',
  },
  {
    id: '8104022006',
    districtId: '8104022',
    name: 'Samalagi',
  },
  {
    id: '8104022007',
    districtId: '8104022',
    name: 'Waeura',
  },
  {
    id: '8104022008',
    districtId: '8104022',
    name: 'Waplau',
  },
  {
    id: '8104022009',
    districtId: '8104022',
    name: 'Lamahang',
  },
  {
    id: '8104022010',
    districtId: '8104022',
    name: 'Skikilale',
  },
  {
    id: '8104023001',
    districtId: '8104023',
    name: 'Ilath',
  },
  {
    id: '8104023002',
    districtId: '8104023',
    name: 'Waemorat',
  },
  {
    id: '8104023003',
    districtId: '8104023',
    name: 'Batu Jungku',
  },
  {
    id: '8104023004',
    districtId: '8104023',
    name: 'Pela',
  },
  {
    id: '8104023006',
    districtId: '8104023',
    name: 'Namlea Ilath',
  },
  {
    id: '8104024001',
    districtId: '8104024',
    name: 'Kaki Air',
  },
  {
    id: '8104024002',
    districtId: '8104024',
    name: 'Kayeli',
  },
  {
    id: '8104024003',
    districtId: '8104024',
    name: 'Masarete',
  },
  {
    id: '8104024004',
    districtId: '8104024',
    name: 'Waelapia',
  },
  {
    id: '8104024005',
    districtId: '8104024',
    name: 'Seith',
  },
  {
    id: '8104025001',
    districtId: '8104025',
    name: 'Waflan',
  },
  {
    id: '8104025002',
    districtId: '8104025',
    name: 'Waetina',
  },
  {
    id: '8104025003',
    districtId: '8104025',
    name: 'Waehata',
  },
  {
    id: '8104025004',
    districtId: '8104025',
    name: 'Waeleman',
  },
  {
    id: '8104025005',
    districtId: '8104025',
    name: 'Waelo',
  },
  {
    id: '8104025006',
    districtId: '8104025',
    name: 'Basalale',
  },
  {
    id: '8104025007',
    districtId: '8104025',
    name: 'Parbulu',
  },
  {
    id: '8104025008',
    districtId: '8104025',
    name: 'Widit',
  },
  {
    id: '8104025009',
    districtId: '8104025',
    name: 'Debowae',
  },
  {
    id: '8104025010',
    districtId: '8104025',
    name: 'Dava',
  },
  {
    id: '8104025011',
    districtId: '8104025',
    name: 'UPT Wamsait',
  },
  {
    id: '8104026001',
    districtId: '8104026',
    name: 'Nafrua',
  },
  {
    id: '8104026002',
    districtId: '8104026',
    name: 'Wapsalit',
  },
  {
    id: '8104026004',
    districtId: '8104026',
    name: 'Grandeng',
  },
  {
    id: '8104026005',
    districtId: '8104026',
    name: 'Waegeren',
  },
  {
    id: '8104026006',
    districtId: '8104026',
    name: 'Tifu',
  },
  {
    id: '8104026007',
    districtId: '8104026',
    name: 'Wanakarta',
  },
  {
    id: '8104026008',
    districtId: '8104026',
    name: 'Wabloy',
  },
  {
    id: '8104026009',
    districtId: '8104026',
    name: 'Kubalahin',
  },
  {
    id: '8104026010',
    districtId: '8104026',
    name: 'Ohilahin',
  },
  {
    id: '8104027001',
    districtId: '8104027',
    name: 'Waeperang',
  },
  {
    id: '8104027002',
    districtId: '8104027',
    name: 'Sawa',
  },
  {
    id: '8104027003',
    districtId: '8104027',
    name: 'Waimiting',
  },
  {
    id: '8104027004',
    districtId: '8104027',
    name: 'Jikumerasa',
  },
  {
    id: '8104030001',
    districtId: '8104030',
    name: 'Bara',
  },
  {
    id: '8104030002',
    districtId: '8104030',
    name: 'Tanjung Karang',
  },
  {
    id: '8104030003',
    districtId: '8104030',
    name: 'Air Buaya',
  },
  {
    id: '8104030004',
    districtId: '8104030',
    name: 'Waimangit',
  },
  {
    id: '8104030005',
    districtId: '8104030',
    name: 'Waipure',
  },
  {
    id: '8104030009',
    districtId: '8104030',
    name: 'Selwadu',
  },
  {
    id: '8104030019',
    districtId: '8104030',
    name: 'Kampung Baru',
  },
  {
    id: '8104030020',
    districtId: '8104030',
    name: 'Wasbaka',
  },
  {
    id: '8104030021',
    districtId: '8104030',
    name: 'Batlale',
  },
  {
    id: '8104030022',
    districtId: '8104030',
    name: 'Awilinan',
  },
  {
    id: '8104031001',
    districtId: '8104031',
    name: 'Waemite',
  },
  {
    id: '8104031002',
    districtId: '8104031',
    name: 'Waereman',
  },
  {
    id: '8104031003',
    districtId: '8104031',
    name: 'Wasi',
  },
  {
    id: '8104031004',
    districtId: '8104031',
    name: 'Wamana Baru',
  },
  {
    id: '8104031005',
    districtId: '8104031',
    name: 'Waelanalana',
  },
  {
    id: '8104031006',
    districtId: '8104031',
    name: 'Raheriat',
  },
  {
    id: '8104031007',
    districtId: '8104031',
    name: 'Lemanpoli',
  },
  {
    id: '8104031008',
    districtId: '8104031',
    name: 'Waidanga',
  },
  {
    id: '8104031009',
    districtId: '8104031',
    name: 'Balbalu',
  },
  {
    id: '8104031010',
    districtId: '8104031',
    name: 'Wamlana',
  },
  {
    id: '8104031011',
    districtId: '8104031',
    name: 'Waspait',
  },
  {
    id: '8104031012',
    districtId: '8104031',
    name: 'Waikose',
  },
  {
    id: '8104031013',
    districtId: '8104031',
    name: 'Wainibe',
  },
  {
    id: '8105010006',
    districtId: '8105010',
    name: 'Popjetur',
  },
  {
    id: '8105010008',
    districtId: '8105010',
    name: 'Ngaibor',
  },
  {
    id: '8105010009',
    districtId: '8105010',
    name: 'Fatural',
  },
  {
    id: '8105010010',
    districtId: '8105010',
    name: 'Gaimar',
  },
  {
    id: '8105010011',
    districtId: '8105010',
    name: 'Jelia',
  },
  {
    id: '8105010015',
    districtId: '8105010',
    name: 'Doka Barat',
  },
  {
    id: '8105010016',
    districtId: '8105010',
    name: 'Doka Timur',
  },
  {
    id: '8105010017',
    districtId: '8105010',
    name: 'Laininir',
  },
  {
    id: '8105010018',
    districtId: '8105010',
    name: 'Marafenfen',
  },
  {
    id: '8105010019',
    districtId: '8105010',
    name: 'Ngaiguli',
  },
  {
    id: '8105010020',
    districtId: '8105010',
    name: 'Feruni',
  },
  {
    id: '8105010021',
    districtId: '8105010',
    name: 'Kalar Kalar',
  },
  {
    id: '8105010022',
    districtId: '8105010',
    name: 'Kabalukin',
  },
  {
    id: '8105010023',
    districtId: '8105010',
    name: 'Jerol',
  },
  {
    id: '8105010024',
    districtId: '8105010',
    name: 'Lor Lor',
  },
  {
    id: '8105011001',
    districtId: '8105011',
    name: 'Batugoyang',
  },
  {
    id: '8105011002',
    districtId: '8105011',
    name: 'Salarem',
  },
  {
    id: '8105011003',
    districtId: '8105011',
    name: 'Meror',
  },
  {
    id: '8105011004',
    districtId: '8105011',
    name: 'Siya',
  },
  {
    id: '8105011006',
    districtId: '8105011',
    name: 'Dosimar',
  },
  {
    id: '8105011007',
    districtId: '8105011',
    name: 'Karey',
  },
  {
    id: '8105011008',
    districtId: '8105011',
    name: 'Jorang',
  },
  {
    id: '8105011009',
    districtId: '8105011',
    name: 'Gomarmeti',
  },
  {
    id: '8105011012',
    districtId: '8105011',
    name: 'Gomarsungai',
  },
  {
    id: '8105012001',
    districtId: '8105012',
    name: 'Tabarfane',
  },
  {
    id: '8105012002',
    districtId: '8105012',
    name: 'Rebi',
  },
  {
    id: '8105012004',
    districtId: '8105012',
    name: 'Hokmar',
  },
  {
    id: '8105012005',
    districtId: '8105012',
    name: 'Juring',
  },
  {
    id: '8105012006',
    districtId: '8105012',
    name: 'Erersin',
  },
  {
    id: '8105012007',
    districtId: '8105012',
    name: 'Maekor',
  },
  {
    id: '8105020007',
    districtId: '8105020',
    name: 'Kobadangar',
  },
  {
    id: '8105020008',
    districtId: '8105020',
    name: 'Kobaseltimur',
  },
  {
    id: '8105020009',
    districtId: '8105020',
    name: 'Kobaselfara',
  },
  {
    id: '8105020010',
    districtId: '8105020',
    name: 'Fatlabata',
  },
  {
    id: '8105020011',
    districtId: '8105020',
    name: 'Murai',
  },
  {
    id: '8105020012',
    districtId: '8105020',
    name: 'Manjau',
  },
  {
    id: '8105020013',
    districtId: '8105020',
    name: 'Lorang',
  },
  {
    id: '8105020014',
    districtId: '8105020',
    name: 'Gardakau',
  },
  {
    id: '8105020016',
    districtId: '8105020',
    name: 'Maijuring',
  },
  {
    id: '8105020017',
    districtId: '8105020',
    name: 'Selilau',
  },
  {
    id: '8105020018',
    districtId: '8105020',
    name: 'Benjina',
  },
  {
    id: '8105020019',
    districtId: '8105020',
    name: 'Papakula',
  },
  {
    id: '8105020020',
    districtId: '8105020',
    name: 'Irloy',
  },
  {
    id: '8105020021',
    districtId: '8105020',
    name: 'Kwarbola',
  },
  {
    id: '8105020032',
    districtId: '8105020',
    name: 'Algadang',
  },
  {
    id: '8105020033',
    districtId: '8105020',
    name: 'Namara',
  },
  {
    id: '8105020034',
    districtId: '8105020',
    name: 'Gulili',
  },
  {
    id: '8105020035',
    districtId: '8105020',
    name: 'Jirlay',
  },
  {
    id: '8105020039',
    districtId: '8105020',
    name: 'Wakua',
  },
  {
    id: '8105020040',
    districtId: '8105020',
    name: 'Maririmar',
  },
  {
    id: '8105020041',
    districtId: '8105020',
    name: 'Tanah Miring',
  },
  {
    id: '8105020042',
    districtId: '8105020',
    name: 'Selibatabata',
  },
  {
    id: '8105021001',
    districtId: '8105021',
    name: 'Ponom',
  },
  {
    id: '8105021002',
    districtId: '8105021',
    name: 'Wailay',
  },
  {
    id: '8105021003',
    districtId: '8105021',
    name: 'Kaiwabar',
  },
  {
    id: '8105021004',
    districtId: '8105021',
    name: 'Basada',
  },
  {
    id: '8105021005',
    districtId: '8105021',
    name: 'Kobror',
  },
  {
    id: '8105021006',
    districtId: '8105021',
    name: 'Warjukur',
  },
  {
    id: '8105021007',
    districtId: '8105021',
    name: 'Lola',
  },
  {
    id: '8105021008',
    districtId: '8105021',
    name: 'Mariri',
  },
  {
    id: '8105021009',
    districtId: '8105021',
    name: 'Warloy',
  },
  {
    id: '8105021010',
    districtId: '8105021',
    name: 'Koijabi',
  },
  {
    id: '8105021011',
    districtId: '8105021',
    name: 'Balatan',
  },
  {
    id: '8105021012',
    districtId: '8105021',
    name: 'Dosinamalau',
  },
  {
    id: '8105021013',
    districtId: '8105021',
    name: 'Karawai',
  },
  {
    id: '8105022001',
    districtId: '8105022',
    name: 'Apara',
  },
  {
    id: '8105022002',
    districtId: '8105022',
    name: 'Longgar',
  },
  {
    id: '8105022004',
    districtId: '8105022',
    name: 'Mesiang',
  },
  {
    id: '8105022005',
    districtId: '8105022',
    name: 'Gomo Gomo',
  },
  {
    id: '8105022006',
    districtId: '8105022',
    name: 'Jambu Air',
  },
  {
    id: '8105022007',
    districtId: '8105022',
    name: 'Warabal',
  },
  {
    id: '8105030073',
    districtId: '8105030',
    name: 'Napar',
  },
  {
    id: '8105030074',
    districtId: '8105030',
    name: 'Kobraur',
  },
  {
    id: '8105030075',
    districtId: '8105030',
    name: 'Lau Lau',
  },
  {
    id: '8105030089',
    districtId: '8105030',
    name: 'Tunguwatu',
  },
  {
    id: '8105030090',
    districtId: '8105030',
    name: 'Jabulenga',
  },
  {
    id: '8105030092',
    districtId: '8105030',
    name: 'Gorar',
  },
  {
    id: '8105030093',
    districtId: '8105030',
    name: 'Karangguli',
  },
  {
    id: '8105030094',
    districtId: '8105030',
    name: 'Durjela',
  },
  {
    id: '8105030095',
    districtId: '8105030',
    name: 'Wangel',
  },
  {
    id: '8105030096',
    districtId: '8105030',
    name: 'Galay Dubu',
  },
  {
    id: '8105030097',
    districtId: '8105030',
    name: 'Siwalima',
  },
  {
    id: '8105030098',
    districtId: '8105030',
    name: 'Wokam',
  },
  {
    id: '8105030099',
    districtId: '8105030',
    name: 'Samang',
  },
  {
    id: '8105030100',
    districtId: '8105030',
    name: 'Ujir',
  },
  {
    id: '8105031001',
    districtId: '8105031',
    name: 'Warialau',
  },
  {
    id: '8105031014',
    districtId: '8105031',
    name: 'Selmona',
  },
  {
    id: '8105031015',
    districtId: '8105031',
    name: 'Masidang',
  },
  {
    id: '8105031016',
    districtId: '8105031',
    name: 'Kolamar',
  },
  {
    id: '8105031017',
    districtId: '8105031',
    name: 'Marlasi',
  },
  {
    id: '8105031018',
    districtId: '8105031',
    name: 'Foket',
  },
  {
    id: '8105031020',
    districtId: '8105031',
    name: 'Wahayum',
  },
  {
    id: '8105031021',
    districtId: '8105031',
    name: 'Jerwatu',
  },
  {
    id: '8105031023',
    districtId: '8105031',
    name: 'Wahangulangula',
  },
  {
    id: '8105031024',
    districtId: '8105031',
    name: 'Kaibolafin',
  },
  {
    id: '8105031025',
    districtId: '8105031',
    name: 'Tasinwaha',
  },
  {
    id: '8105031026',
    districtId: '8105031',
    name: 'Kabufin',
  },
  {
    id: '8105032001',
    districtId: '8105032',
    name: 'Batuley',
  },
  {
    id: '8105032002',
    districtId: '8105032',
    name: 'Kabalsiang',
  },
  {
    id: '8105032003',
    districtId: '8105032',
    name: 'Benjuring',
  },
  {
    id: '8105032005',
    districtId: '8105032',
    name: 'Waria',
  },
  {
    id: '8105032007',
    districtId: '8105032',
    name: 'Jursiang',
  },
  {
    id: '8105032008',
    districtId: '8105032',
    name: 'Kompane',
  },
  {
    id: '8105032009',
    districtId: '8105032',
    name: 'Kobamar',
  },
  {
    id: '8105033001',
    districtId: '8105033',
    name: 'Waifual',
  },
  {
    id: '8105033002',
    districtId: '8105033',
    name: 'Wafan',
  },
  {
    id: '8105033003',
    districtId: '8105033',
    name: 'Langhalau',
  },
  {
    id: '8105033004',
    districtId: '8105033',
    name: 'Gomsey',
  },
  {
    id: '8105033005',
    districtId: '8105033',
    name: 'Leiting',
  },
  {
    id: '8105033006',
    districtId: '8105033',
    name: 'Berdefan',
  },
  {
    id: '8105033007',
    districtId: '8105033',
    name: 'Mohongsel',
  },
  {
    id: '8105033008',
    districtId: '8105033',
    name: 'Kolaha',
  },
  {
    id: '8105033009',
    districtId: '8105033',
    name: 'Goda Goda',
  },
  {
    id: '8106010008',
    districtId: '8106010',
    name: 'Tahalupu',
  },
  {
    id: '8106010009',
    districtId: '8106010',
    name: 'Sole',
  },
  {
    id: '8106010010',
    districtId: '8106010',
    name: 'Waesala',
  },
  {
    id: '8106010011',
    districtId: '8106010',
    name: 'Buano Selatan',
  },
  {
    id: '8106010012',
    districtId: '8106010',
    name: 'Buano Utara',
  },
  {
    id: '8106010013',
    districtId: '8106010',
    name: 'Tonu Jaya',
  },
  {
    id: '8106010014',
    districtId: '8106010',
    name: 'Alang Asaude',
  },
  {
    id: '8106011001',
    districtId: '8106011',
    name: 'Tuniwara',
  },
  {
    id: '8106011002',
    districtId: '8106011',
    name: 'Buano Hatuputih',
  },
  {
    id: '8106011003',
    districtId: '8106011',
    name: 'Tumalehu Barat',
  },
  {
    id: '8106011004',
    districtId: '8106011',
    name: 'Tumalehu Timur',
  },
  {
    id: '8106011005',
    districtId: '8106011',
    name: 'Kelang Asaude',
  },
  {
    id: '8106011006',
    districtId: '8106011',
    name: 'Masawoi',
  },
  {
    id: '8106011007',
    districtId: '8106011',
    name: 'Luhutuban',
  },
  {
    id: '8106020015',
    districtId: '8106020',
    name: 'Kaibobu',
  },
  {
    id: '8106020017',
    districtId: '8106020',
    name: 'Lumoli',
  },
  {
    id: '8106020018',
    districtId: '8106020',
    name: 'Morekau',
  },
  {
    id: '8106020019',
    districtId: '8106020',
    name: 'Neniari',
  },
  {
    id: '8106020020',
    districtId: '8106020',
    name: 'Piru',
  },
  {
    id: '8106020021',
    districtId: '8106020',
    name: 'Negeri Kawa',
  },
  {
    id: '8106021002',
    districtId: '8106021',
    name: 'Iha',
  },
  {
    id: '8106021004',
    districtId: '8106021',
    name: 'Lokki',
  },
  {
    id: '8106021005',
    districtId: '8106021',
    name: 'Ariate',
  },
  {
    id: '8106030001',
    districtId: '8106030',
    name: 'Kairatu',
  },
  {
    id: '8106030002',
    districtId: '8106030',
    name: 'Seruawan',
  },
  {
    id: '8106030003',
    districtId: '8106030',
    name: 'Kamarian',
  },
  {
    id: '8106030020',
    districtId: '8106030',
    name: 'Waimital',
  },
  {
    id: '8106030021',
    districtId: '8106030',
    name: 'Hatusua',
  },
  {
    id: '8106030028',
    districtId: '8106030',
    name: 'Uraur',
  },
  {
    id: '8106030029',
    districtId: '8106030',
    name: 'Waipirit',
  },
  {
    id: '8106031001',
    districtId: '8106031',
    name: 'Waisarisa',
  },
  {
    id: '8106031002',
    districtId: '8106031',
    name: 'Kamal',
  },
  {
    id: '8106031004',
    districtId: '8106031',
    name: 'Waesamu',
  },
  {
    id: '8106031005',
    districtId: '8106031',
    name: 'Waihatu',
  },
  {
    id: '8106031006',
    districtId: '8106031',
    name: 'Lohiatala',
  },
  {
    id: '8106032002',
    districtId: '8106032',
    name: 'Honitetu',
  },
  {
    id: '8106032003',
    districtId: '8106032',
    name: 'Hukuanakota',
  },
  {
    id: '8106032004',
    districtId: '8106032',
    name: 'Rambatu',
  },
  {
    id: '8106032005',
    districtId: '8106032',
    name: 'Manusa',
  },
  {
    id: '8106033001',
    districtId: '8106033',
    name: 'Tihulale',
  },
  {
    id: '8106033002',
    districtId: '8106033',
    name: 'Rumahkay',
  },
  {
    id: '8106033003',
    districtId: '8106033',
    name: 'Latu',
  },
  {
    id: '8106033004',
    districtId: '8106033',
    name: 'Tomalehu',
  },
  {
    id: '8106033005',
    districtId: '8106033',
    name: 'Hualoy',
  },
  {
    id: '8106033006',
    districtId: '8106033',
    name: 'Seriholo',
  },
  {
    id: '8106033007',
    districtId: '8106033',
    name: 'Tala',
  },
  {
    id: '8106034001',
    districtId: '8106034',
    name: 'Sumeith Pasinaro',
  },
  {
    id: '8106034002',
    districtId: '8106034',
    name: 'Ahiolo Abio',
  },
  {
    id: '8106034003',
    districtId: '8106034',
    name: 'Watui',
  },
  {
    id: '8106034004',
    districtId: '8106034',
    name: 'Huku Kecil',
  },
  {
    id: '8106034005',
    districtId: '8106034',
    name: 'Sanahu',
  },
  {
    id: '8106034006',
    districtId: '8106034',
    name: 'Wasia',
  },
  {
    id: '8106034007',
    districtId: '8106034',
    name: 'Elpaputih',
  },
  {
    id: '8106040001',
    districtId: '8106040',
    name: 'Rumahsoal',
  },
  {
    id: '8106040002',
    districtId: '8106040',
    name: 'Lohia Sapalewa',
  },
  {
    id: '8106040003',
    districtId: '8106040',
    name: 'Laturake',
  },
  {
    id: '8106040004',
    districtId: '8106040',
    name: 'Buria',
  },
  {
    id: '8106040005',
    districtId: '8106040',
    name: 'Riring',
  },
  {
    id: '8106040006',
    districtId: '8106040',
    name: 'Niniari',
  },
  {
    id: '8106040007',
    districtId: '8106040',
    name: 'Mornaten',
  },
  {
    id: '8106040008',
    districtId: '8106040',
    name: 'Nikulukan',
  },
  {
    id: '8106040009',
    districtId: '8106040',
    name: 'Niwelehu',
  },
  {
    id: '8106040010',
    districtId: '8106040',
    name: 'Nuniali',
  },
  {
    id: '8106040011',
    districtId: '8106040',
    name: 'Lisabata',
  },
  {
    id: '8106040012',
    districtId: '8106040',
    name: 'Wakolo',
  },
  {
    id: '8106040013',
    districtId: '8106040',
    name: 'Patahuwe',
  },
  {
    id: '8106040014',
    districtId: '8106040',
    name: 'Taniwel',
  },
  {
    id: '8106040017',
    districtId: '8106040',
    name: 'Kasie',
  },
  {
    id: '8106040018',
    districtId: '8106040',
    name: 'Nukuhay',
  },
  {
    id: '8106040019',
    districtId: '8106040',
    name: 'Pasinalo',
  },
  {
    id: '8106041001',
    districtId: '8106041',
    name: 'Souhuwe',
  },
  {
    id: '8106041002',
    districtId: '8106041',
    name: 'Maloang',
  },
  {
    id: '8106041003',
    districtId: '8106041',
    name: 'Lumahlatal',
  },
  {
    id: '8106041004',
    districtId: '8106041',
    name: 'Hatunuru',
  },
  {
    id: '8106041005',
    districtId: '8106041',
    name: 'Matapa',
  },
  {
    id: '8106041006',
    districtId: '8106041',
    name: 'Seakasale',
  },
  {
    id: '8106041007',
    districtId: '8106041',
    name: 'Makububuy',
  },
  {
    id: '8106041008',
    districtId: '8106041',
    name: 'Sukaraja',
  },
  {
    id: '8106041009',
    districtId: '8106041',
    name: 'Lumapelu',
  },
  {
    id: '8106041010',
    districtId: '8106041',
    name: 'Uwen Pantai',
  },
  {
    id: '8106041011',
    districtId: '8106041',
    name: 'Tounussa',
  },
  {
    id: '8106041012',
    districtId: '8106041',
    name: 'Musihuwey',
  },
  {
    id: '8106041013',
    districtId: '8106041',
    name: 'Solea',
  },
  {
    id: '8106041014',
    districtId: '8106041',
    name: 'Waraloin',
  },
  {
    id: '8106041015',
    districtId: '8106041',
    name: 'Walakone',
  },
  {
    id: '8107010010',
    districtId: '8107010',
    name: 'Amarsekaru',
  },
  {
    id: '8107010013',
    districtId: '8107010',
    name: 'Mida',
  },
  {
    id: '8107010015',
    districtId: '8107010',
    name: 'Dai',
  },
  {
    id: '8107010018',
    districtId: '8107010',
    name: 'Ondor',
  },
  {
    id: '8107010019',
    districtId: '8107010',
    name: 'Kataloka',
  },
  {
    id: '8107010024',
    districtId: '8107010',
    name: 'Loko',
  },
  {
    id: '8107010025',
    districtId: '8107010',
    name: 'Sera',
  },
  {
    id: '8107010032',
    districtId: '8107010',
    name: 'Ilili',
  },
  {
    id: '8107010033',
    districtId: '8107010',
    name: 'Kelibingan',
  },
  {
    id: '8107010034',
    districtId: '8107010',
    name: 'Rumeon',
  },
  {
    id: '8107010035',
    districtId: '8107010',
    name: 'Kulugowa',
  },
  {
    id: '8107010037',
    districtId: '8107010',
    name: 'Namalean',
  },
  {
    id: '8107010038',
    districtId: '8107010',
    name: 'Arewan',
  },
  {
    id: '8107010039',
    districtId: '8107010',
    name: 'Kaforing',
  },
  {
    id: '8107010040',
    districtId: '8107010',
    name: 'Kilalir Kilwouw',
  },
  {
    id: '8107010041',
    districtId: '8107010',
    name: 'Kilotak',
  },
  {
    id: '8107010042',
    districtId: '8107010',
    name: 'Kilean',
  },
  {
    id: '8107010043',
    districtId: '8107010',
    name: 'Dulak',
  },
  {
    id: '8107010044',
    districtId: '8107010',
    name: 'Dada Kataloka',
  },
  {
    id: '8107010045',
    districtId: '8107010',
    name: 'Aroa Kataloka',
  },
  {
    id: '8107010046',
    districtId: '8107010',
    name: 'Sikaru Kataloka',
  },
  {
    id: '8107010047',
    districtId: '8107010',
    name: 'Usun Kataloka',
  },
  {
    id: '8107010048',
    districtId: '8107010',
    name: 'Buan Kataloka',
  },
  {
    id: '8107010049',
    districtId: '8107010',
    name: 'Rumanama Kotawouw Kataloka',
  },
  {
    id: '8107011002',
    districtId: '8107011',
    name: 'Tamher Warat',
  },
  {
    id: '8107011003',
    districtId: '8107011',
    name: 'Kelangan',
  },
  {
    id: '8107011004',
    districtId: '8107011',
    name: 'Tamher Timur',
  },
  {
    id: '8107011005',
    districtId: '8107011',
    name: 'Amar Laut',
  },
  {
    id: '8107011006',
    districtId: '8107011',
    name: 'Utta',
  },
  {
    id: '8107011007',
    districtId: '8107011',
    name: 'Lahema',
  },
  {
    id: '8107011008',
    districtId: '8107011',
    name: 'Effa',
  },
  {
    id: '8107011009',
    districtId: '8107011',
    name: 'Ilili',
  },
  {
    id: '8107011010',
    districtId: '8107011',
    name: 'Tanah Baru',
  },
  {
    id: '8107011011',
    districtId: '8107011',
    name: 'Guliar',
  },
  {
    id: '8107011021',
    districtId: '8107011',
    name: 'Keldor',
  },
  {
    id: '8107011022',
    districtId: '8107011',
    name: 'Wunnin Eldedora',
  },
  {
    id: '8107011023',
    districtId: '8107011',
    name: 'Karlomin',
  },
  {
    id: '8107011024',
    districtId: '8107011',
    name: 'Otademan',
  },
  {
    id: '8107011025',
    districtId: '8107011',
    name: 'Ruma Durun',
  },
  {
    id: '8107011026',
    districtId: '8107011',
    name: 'Tana Soa',
  },
  {
    id: '8107011027',
    districtId: '8107011',
    name: 'Kilbutak',
  },
  {
    id: '8107011028',
    districtId: '8107011',
    name: 'Kurwara',
  },
  {
    id: '8107012001',
    districtId: '8107012',
    name: 'Kilwouw',
  },
  {
    id: '8107012002',
    districtId: '8107012',
    name: 'Mamur',
  },
  {
    id: '8107012003',
    districtId: '8107012',
    name: 'Kampung Baru',
  },
  {
    id: '8107012004',
    districtId: '8107012',
    name: 'Kampung Tenga Wermaf',
  },
  {
    id: '8107012005',
    districtId: '8107012',
    name: 'Kartutin Kartenga',
  },
  {
    id: '8107012006',
    districtId: '8107012',
    name: 'Karlokin',
  },
  {
    id: '8107012008',
    districtId: '8107012',
    name: 'Kampung Jawa',
  },
  {
    id: '8107012009',
    districtId: '8107012',
    name: 'Teor',
  },
  {
    id: '8107012010',
    districtId: '8107012',
    name: 'Duryar Rumoy',
  },
  {
    id: '8107013001',
    districtId: '8107013',
    name: 'Tunas Ilur',
  },
  {
    id: '8107013002',
    districtId: '8107013',
    name: 'Sagey',
  },
  {
    id: '8107013003',
    districtId: '8107013',
    name: 'Armada',
  },
  {
    id: '8107013004',
    districtId: '8107013',
    name: 'Amarwawatu',
  },
  {
    id: '8107013005',
    districtId: '8107013',
    name: 'Waisalan',
  },
  {
    id: '8107013006',
    districtId: '8107013',
    name: 'Basarin',
  },
  {
    id: '8107013007',
    districtId: '8107013',
    name: 'Goha',
  },
  {
    id: '8107013008',
    districtId: '8107013',
    name: 'Kota Siri',
  },
  {
    id: '8107013009',
    districtId: '8107013',
    name: 'Kilkoda',
  },
  {
    id: '8107013010',
    districtId: '8107013',
    name: 'Bas',
  },
  {
    id: '8107013011',
    districtId: '8107013',
    name: 'Tuha',
  },
  {
    id: '8107013012',
    districtId: '8107013',
    name: 'Aran',
  },
  {
    id: '8107013013',
    districtId: '8107013',
    name: 'Miran',
  },
  {
    id: '8107013014',
    districtId: '8107013',
    name: 'Rarat',
  },
  {
    id: '8107013015',
    districtId: '8107013',
    name: 'Tinaru',
  },
  {
    id: '8107013016',
    districtId: '8107013',
    name: 'Adar',
  },
  {
    id: '8107013017',
    districtId: '8107013',
    name: 'Kiltufa',
  },
  {
    id: '8107013018',
    districtId: '8107013',
    name: 'Etaralu',
  },
  {
    id: '8107013019',
    districtId: '8107013',
    name: 'Miran Manaban',
  },
  {
    id: '8107013020',
    districtId: '8107013',
    name: 'Miran Rumuar',
  },
  {
    id: '8107013021',
    districtId: '8107013',
    name: 'Miran Kilian Manaban',
  },
  {
    id: '8107013022',
    districtId: '8107013',
    name: 'Miran Keledar',
  },
  {
    id: '8107013023',
    districtId: '8107013',
    name: 'Miran Gota',
  },
  {
    id: '8107014001',
    districtId: '8107014',
    name: 'Lalasa',
  },
  {
    id: '8107014002',
    districtId: '8107014',
    name: 'P. Panjang',
  },
  {
    id: '8107014003',
    districtId: '8107014',
    name: 'Argam',
  },
  {
    id: '8107014005',
    districtId: '8107014',
    name: 'Basaranggi',
  },
  {
    id: '8107014006',
    districtId: '8107014',
    name: 'Magat',
  },
  {
    id: '8107020021',
    districtId: '8107020',
    name: 'Kiltai',
  },
  {
    id: '8107020022',
    districtId: '8107020',
    name: 'Kilwaru',
  },
  {
    id: '8107020025',
    districtId: '8107020',
    name: 'Keffing',
  },
  {
    id: '8107020040',
    districtId: '8107020',
    name: 'Kilfura',
  },
  {
    id: '8107020041',
    districtId: '8107020',
    name: 'Kwamor Besar Witau',
  },
  {
    id: '8107020042',
    districtId: '8107020',
    name: 'Kwamor Besar Ena',
  },
  {
    id: '8107020043',
    districtId: '8107020',
    name: 'Kwamor Kecil Mata Wawa',
  },
  {
    id: '8107020044',
    districtId: '8107020',
    name: 'Kwamor Kecil Mata Ata',
  },
  {
    id: '8107020045',
    districtId: '8107020',
    name: 'Guli-Guli',
  },
  {
    id: '8107020046',
    districtId: '8107020',
    name: 'Manggis',
  },
  {
    id: '8107020047',
    districtId: '8107020',
    name: 'Ainena',
  },
  {
    id: '8107020048',
    districtId: '8107020',
    name: 'Mugusinis',
  },
  {
    id: '8107020049',
    districtId: '8107020',
    name: 'Akat Fadedo',
  },
  {
    id: '8107021001',
    districtId: '8107021',
    name: 'Danama',
  },
  {
    id: '8107021002',
    districtId: '8107021',
    name: 'Kilmoy',
  },
  {
    id: '8107021003',
    districtId: '8107021',
    name: 'Kilbat',
  },
  {
    id: '8107021004',
    districtId: '8107021',
    name: 'Sesar',
  },
  {
    id: '8107021005',
    districtId: '8107021',
    name: 'Airkasar',
  },
  {
    id: '8107021006',
    districtId: '8107021',
    name: 'Waras-Waras',
  },
  {
    id: '8107021007',
    districtId: '8107021',
    name: 'Gah',
  },
  {
    id: '8107021008',
    districtId: '8107021',
    name: 'Walang Tenga',
  },
  {
    id: '8107021009',
    districtId: '8107021',
    name: 'Bati Kilwouw',
  },
  {
    id: '8107021010',
    districtId: '8107021',
    name: 'Taruy',
  },
  {
    id: '8107021011',
    districtId: '8107021',
    name: 'Kufar',
  },
  {
    id: '8107022001',
    districtId: '8107022',
    name: 'Selor',
  },
  {
    id: '8107022002',
    districtId: '8107022',
    name: 'Kilmury',
  },
  {
    id: '8107022003',
    districtId: '8107022',
    name: 'Kilbon Kway',
  },
  {
    id: '8107022004',
    districtId: '8107022',
    name: 'Nekan',
  },
  {
    id: '8107022005',
    districtId: '8107022',
    name: 'Afang Kota',
  },
  {
    id: '8107022006',
    districtId: '8107022',
    name: 'Afang Defol',
  },
  {
    id: '8107022007',
    districtId: '8107022',
    name: 'Kumelang',
  },
  {
    id: '8107022009',
    districtId: '8107022',
    name: 'Kamar',
  },
  {
    id: '8107022010',
    districtId: '8107022',
    name: 'Gunak',
  },
  {
    id: '8107022011',
    districtId: '8107022',
    name: 'Sumbawa',
  },
  {
    id: '8107022012',
    districtId: '8107022',
    name: 'Mising',
  },
  {
    id: '8107022013',
    districtId: '8107022',
    name: 'Taa',
  },
  {
    id: '8107022014',
    districtId: '8107022',
    name: 'Bitorik',
  },
  {
    id: '8107023001',
    districtId: '8107023',
    name: 'Air Nanang',
  },
  {
    id: '8107023002',
    districtId: '8107023',
    name: 'Kwaos',
  },
  {
    id: '8107023004',
    districtId: '8107023',
    name: 'Liantasik',
  },
  {
    id: '8107023005',
    districtId: '8107023',
    name: 'Keta',
  },
  {
    id: '8107023006',
    districtId: '8107023',
    name: 'Keta Rumadan',
  },
  {
    id: '8107023007',
    districtId: '8107023',
    name: 'Kianlaut',
  },
  {
    id: '8107023008',
    districtId: '8107023',
    name: 'Salagor Kota',
  },
  {
    id: '8107023009',
    districtId: '8107023',
    name: 'Salagor Air',
  },
  {
    id: '8107023010',
    districtId: '8107023',
    name: 'Aruan Gaur',
  },
  {
    id: '8107024001',
    districtId: '8107024',
    name: 'Kiandarat',
  },
  {
    id: '8107024002',
    districtId: '8107024',
    name: 'Artafela',
  },
  {
    id: '8107024003',
    districtId: '8107024',
    name: 'Rumoga',
  },
  {
    id: '8107024004',
    districtId: '8107024',
    name: 'Angar',
  },
  {
    id: '8107024005',
    districtId: '8107024',
    name: 'Watu-Watu',
  },
  {
    id: '8107024006',
    districtId: '8107024',
    name: 'Kelaba',
  },
  {
    id: '8107024007',
    districtId: '8107024',
    name: 'Kilga Kilwouw',
  },
  {
    id: '8107024008',
    districtId: '8107024',
    name: 'Kilga Watubau',
  },
  {
    id: '8107024009',
    districtId: '8107024',
    name: 'Rumfakar',
  },
  {
    id: '8107024010',
    districtId: '8107024',
    name: 'Kileser',
  },
  {
    id: '8107030007',
    districtId: '8107030',
    name: 'Bemo',
  },
  {
    id: '8107030008',
    districtId: '8107030',
    name: 'Werinama',
  },
  {
    id: '8107030009',
    districtId: '8107030',
    name: 'Hatumeten',
  },
  {
    id: '8107030010',
    districtId: '8107030',
    name: 'Batuasa',
  },
  {
    id: '8107030017',
    districtId: '8107030',
    name: 'Tobo',
  },
  {
    id: '8107030018',
    districtId: '8107030',
    name: 'Osong',
  },
  {
    id: '8107030019',
    districtId: '8107030',
    name: 'Gusalaut',
  },
  {
    id: '8107030021',
    districtId: '8107030',
    name: 'Bemo Perak',
  },
  {
    id: '8107030022',
    districtId: '8107030',
    name: 'Funa Naiyaba',
  },
  {
    id: '8107031001',
    districtId: '8107031',
    name: 'Dihil',
  },
  {
    id: '8107031002',
    districtId: '8107031',
    name: 'Liliama',
  },
  {
    id: '8107031003',
    districtId: '8107031',
    name: 'Polin',
  },
  {
    id: '8107031004',
    districtId: '8107031',
    name: 'Tunsai',
  },
  {
    id: '8107031005',
    districtId: '8107031',
    name: 'Lapela',
  },
  {
    id: '8107031006',
    districtId: '8107031',
    name: 'Nayet',
  },
  {
    id: '8107031007',
    districtId: '8107031',
    name: 'Elnusa',
  },
  {
    id: '8107031008',
    districtId: '8107031',
    name: 'Atiahu',
  },
  {
    id: '8107031009',
    districtId: '8107031',
    name: 'Adabai',
  },
  {
    id: '8107031010',
    districtId: '8107031',
    name: 'Naiwel Ahinulin',
  },
  {
    id: '8107031011',
    districtId: '8107031',
    name: 'Abuleta',
  },
  {
    id: '8107031012',
    districtId: '8107031',
    name: 'Sabuai',
  },
  {
    id: '8107040005',
    districtId: '8107040',
    name: 'Salas',
  },
  {
    id: '8107040006',
    districtId: '8107040',
    name: 'Bula',
  },
  {
    id: '8107040017',
    districtId: '8107040',
    name: 'Bula Air Fattolo',
  },
  {
    id: '8107040018',
    districtId: '8107040',
    name: 'Sesar',
  },
  {
    id: '8107040019',
    districtId: '8107040',
    name: 'Englas',
  },
  {
    id: '8107040024',
    districtId: '8107040',
    name: 'Lemumir',
  },
  {
    id: '8107040025',
    districtId: '8107040',
    name: 'Fattolo',
  },
  {
    id: '8107040026',
    districtId: '8107040',
    name: 'Tansi Ambon',
  },
  {
    id: '8107040027',
    districtId: '8107040',
    name: 'Kampung Wailola',
  },
  {
    id: '8107040028',
    districtId: '8107040',
    name: 'Kampung Gorom',
  },
  {
    id: '8107041001',
    districtId: '8107041',
    name: 'Hote',
  },
  {
    id: '8107041002',
    districtId: '8107041',
    name: 'Silohan',
  },
  {
    id: '8107041003',
    districtId: '8107041',
    name: 'Rukun Jaya',
  },
  {
    id: '8107041004',
    districtId: '8107041',
    name: 'Jembatan Basah',
  },
  {
    id: '8107041005',
    districtId: '8107041',
    name: 'Sumber Agung',
  },
  {
    id: '8107041006',
    districtId: '8107041',
    name: 'Benggoi',
  },
  {
    id: '8107041007',
    districtId: '8107041',
    name: 'Jakarta Baru',
  },
  {
    id: '8107041008',
    districtId: '8107041',
    name: 'Waiketam Baru',
  },
  {
    id: '8107041009',
    districtId: '8107041',
    name: 'Waimatakabu',
  },
  {
    id: '8107041010',
    districtId: '8107041',
    name: 'Waisamet',
  },
  {
    id: '8107041011',
    districtId: '8107041',
    name: 'Aki Jaya',
  },
  {
    id: '8107041012',
    districtId: '8107041',
    name: 'Banggoi Pancorang',
  },
  {
    id: '8107041013',
    districtId: '8107041',
    name: 'Dreamland Hills',
  },
  {
    id: '8107042001',
    districtId: '8107042',
    name: 'Tubir Masiwang',
  },
  {
    id: '8107042002',
    districtId: '8107042',
    name: 'Waru',
  },
  {
    id: '8107042003',
    districtId: '8107042',
    name: 'Karay',
  },
  {
    id: '8107042004',
    districtId: '8107042',
    name: 'Nama Lena',
  },
  {
    id: '8107042005',
    districtId: '8107042',
    name: 'Nama Andan',
  },
  {
    id: '8107042006',
    districtId: '8107042',
    name: 'Belis',
  },
  {
    id: '8107042007',
    districtId: '8107042',
    name: 'Solang',
  },
  {
    id: '8107042008',
    districtId: '8107042',
    name: 'Kampung Baru',
  },
  {
    id: '8107042009',
    districtId: '8107042',
    name: 'Dawang',
  },
  {
    id: '8107042010',
    districtId: '8107042',
    name: 'Madak',
  },
  {
    id: '8107042011',
    districtId: '8107042',
    name: 'Boinfia',
  },
  {
    id: '8108010001',
    districtId: '8108010',
    name: 'Arnau',
  },
  {
    id: '8108010002',
    districtId: '8108010',
    name: 'Hiay',
  },
  {
    id: '8108010003',
    districtId: '8108010',
    name: 'Ilwaki',
  },
  {
    id: '8108010004',
    districtId: '8108010',
    name: 'Ilputih',
  },
  {
    id: '8108010005',
    districtId: '8108010',
    name: 'Mahuan',
  },
  {
    id: '8108010006',
    districtId: '8108010',
    name: 'Masapun',
  },
  {
    id: '8108011002',
    districtId: '8108011',
    name: 'Karbubu',
  },
  {
    id: '8108011003',
    districtId: '8108011',
    name: 'Klishatu',
  },
  {
    id: '8108011004',
    districtId: '8108011',
    name: 'Ilmamau',
  },
  {
    id: '8108011005',
    districtId: '8108011',
    name: 'Telemar',
  },
  {
    id: '8108012001',
    districtId: '8108012',
    name: 'Eray',
  },
  {
    id: '8108012002',
    districtId: '8108012',
    name: 'Nabar',
  },
  {
    id: '8108012003',
    districtId: '8108012',
    name: 'Esulit',
  },
  {
    id: '8108012004',
    districtId: '8108012',
    name: 'Naumatang',
  },
  {
    id: '8108012005',
    districtId: '8108012',
    name: 'Lurang',
  },
  {
    id: '8108012006',
    districtId: '8108012',
    name: 'Uhak',
  },
  {
    id: '8108013001',
    districtId: '8108013',
    name: 'Moning',
  },
  {
    id: '8108013002',
    districtId: '8108013',
    name: 'Tomliapat',
  },
  {
    id: '8108013003',
    districtId: '8108013',
    name: 'Ilpokil',
  },
  {
    id: '8108013004',
    districtId: '8108013',
    name: 'Kohoilin',
  },
  {
    id: '8108013005',
    districtId: '8108013',
    name: 'Ilway',
  },
  {
    id: '8108013006',
    districtId: '8108013',
    name: 'Arwala',
  },
  {
    id: '8108020001',
    districtId: '8108020',
    name: 'Lekloor',
  },
  {
    id: '8108020002',
    districtId: '8108020',
    name: 'Oirata Barat',
  },
  {
    id: '8108020003',
    districtId: '8108020',
    name: 'Oirata Timur',
  },
  {
    id: '8108020004',
    districtId: '8108020',
    name: 'Abusur',
  },
  {
    id: '8108020005',
    districtId: '8108020',
    name: 'Kota Lama',
  },
  {
    id: '8108020006',
    districtId: '8108020',
    name: 'Wonreli',
  },
  {
    id: '8108021001',
    districtId: '8108021',
    name: 'Nomaha',
  },
  {
    id: '8108021002',
    districtId: '8108021',
    name: 'Pur- Pura',
  },
  {
    id: '8108021003',
    districtId: '8108021',
    name: 'Lebelau',
  },
  {
    id: '8108022002',
    districtId: '8108022',
    name: 'Hila',
  },
  {
    id: '8108022003',
    districtId: '8108022',
    name: 'Solath',
  },
  {
    id: '8108030001',
    districtId: '8108030',
    name: 'Nuwewang',
  },
  {
    id: '8108030002',
    districtId: '8108030',
    name: 'Tomra',
  },
  {
    id: '8108030003',
    districtId: '8108030',
    name: 'Tutuwaru',
  },
  {
    id: '8108030006',
    districtId: '8108030',
    name: 'Batumiau',
  },
  {
    id: '8108030007',
    districtId: '8108030',
    name: 'Laitutun',
  },
  {
    id: '8108041001',
    districtId: '8108041',
    name: 'Wakarleli',
  },
  {
    id: '8108041002',
    districtId: '8108041',
    name: 'Kaiwatu',
  },
  {
    id: '8108041003',
    districtId: '8108041',
    name: 'Patti',
  },
  {
    id: '8108041004',
    districtId: '8108041',
    name: 'Werwaru',
  },
  {
    id: '8108041005',
    districtId: '8108041',
    name: 'Klis',
  },
  {
    id: '8108041006',
    districtId: '8108041',
    name: 'Tounwawan',
  },
  {
    id: '8108041007',
    districtId: '8108041',
    name: 'Moain',
  },
  {
    id: '8108041008',
    districtId: '8108041',
    name: 'Kelurahan Tiakur',
  },
  {
    id: '8108042001',
    districtId: '8108042',
    name: 'Letoda',
  },
  {
    id: '8108042003',
    districtId: '8108042',
    name: 'Sera',
  },
  {
    id: '8108042004',
    districtId: '8108042',
    name: 'Yamluli',
  },
  {
    id: '8108042005',
    districtId: '8108042',
    name: 'Lolotwara',
  },
  {
    id: '8108050002',
    districtId: '8108050',
    name: 'Batumerah',
  },
  {
    id: '8108050003',
    districtId: '8108050',
    name: 'Kuay Melu',
  },
  {
    id: '8108050005',
    districtId: '8108050',
    name: 'Bebar Timur',
  },
  {
    id: '8108050006',
    districtId: '8108050',
    name: 'Ilih',
  },
  {
    id: '8108050007',
    districtId: '8108050',
    name: 'Kehli',
  },
  {
    id: '8108060001',
    districtId: '8108060',
    name: 'Luang Barat',
  },
  {
    id: '8108060002',
    districtId: '8108060',
    name: 'Luang Timur',
  },
  {
    id: '8108060003',
    districtId: '8108060',
    name: 'Elo',
  },
  {
    id: '8108060004',
    districtId: '8108060',
    name: 'Romkisar',
  },
  {
    id: '8108060005',
    districtId: '8108060',
    name: 'Lelang',
  },
  {
    id: '8108060006',
    districtId: '8108060',
    name: 'Romdara',
  },
  {
    id: '8108060007',
    districtId: '8108060',
    name: 'Mahaleta',
  },
  {
    id: '8108060008',
    districtId: '8108060',
    name: 'Rotnama',
  },
  {
    id: '8108060009',
    districtId: '8108060',
    name: 'Batu Gajah',
  },
  {
    id: '8108060010',
    districtId: '8108060',
    name: 'Pupioliora',
  },
  {
    id: '8108060011',
    districtId: '8108060',
    name: 'Regoha',
  },
  {
    id: '8108070001',
    districtId: '8108070',
    name: 'Tela',
  },
  {
    id: '8108070002',
    districtId: '8108070',
    name: 'Imroing',
  },
  {
    id: '8108070003',
    districtId: '8108070',
    name: 'Tepa',
  },
  {
    id: '8108070004',
    districtId: '8108070',
    name: 'Letsiara',
  },
  {
    id: '8108070005',
    districtId: '8108070',
    name: 'Manuwui',
  },
  {
    id: '8108070006',
    districtId: '8108070',
    name: 'Hertuti',
  },
  {
    id: '8108070007',
    districtId: '8108070',
    name: 'Lewah',
  },
  {
    id: '8108070008',
    districtId: '8108070',
    name: 'Sinairusi',
  },
  {
    id: '8108070009',
    districtId: '8108070',
    name: 'Yaltubung',
  },
  {
    id: '8108071001',
    districtId: '8108071',
    name: 'Pota Besar',
  },
  {
    id: '8108071002',
    districtId: '8108071',
    name: 'Pota Kecil',
  },
  {
    id: '8108071004',
    districtId: '8108071',
    name: 'Wasarili',
  },
  {
    id: '8108071005',
    districtId: '8108071',
    name: 'Rumah Lewang Besar',
  },
  {
    id: '8108071006',
    districtId: '8108071',
    name: 'Herley/ Hoka',
  },
  {
    id: '8108071007',
    districtId: '8108071',
    name: 'Rumah Lewang Kecil',
  },
  {
    id: '8108071008',
    districtId: '8108071',
    name: 'Nusiata',
  },
  {
    id: '8108080001',
    districtId: '8108080',
    name: 'Empalwas',
  },
  {
    id: '8108080002',
    districtId: '8108080',
    name: 'Tutuwawang',
  },
  {
    id: '8108080003',
    districtId: '8108080',
    name: 'Manuari',
  },
  {
    id: '8108080004',
    districtId: '8108080',
    name: 'Analutur',
  },
  {
    id: '8108080005',
    districtId: '8108080',
    name: 'Ahanari',
  },
  {
    id: '8108080006',
    districtId: '8108080',
    name: 'Wakpapapi',
  },
  {
    id: '8108080007',
    districtId: '8108080',
    name: 'Kokwari',
  },
  {
    id: '8108080009',
    districtId: '8108080',
    name: 'Kroing',
  },
  {
    id: '8108080010',
    districtId: '8108080',
    name: 'Yatoke',
  },
  {
    id: '8108080011',
    districtId: '8108080',
    name: 'Nakarhamto',
  },
  {
    id: '8108081001',
    districtId: '8108081',
    name: 'Babyotang',
  },
  {
    id: '8108081002',
    districtId: '8108081',
    name: 'Iblatmuntah',
  },
  {
    id: '8108081003',
    districtId: '8108081',
    name: 'Lawawang',
  },
  {
    id: '8108081004',
    districtId: '8108081',
    name: 'Telalora/Letoda',
  },
  {
    id: '8108081005',
    districtId: '8108081',
    name: 'Ilbutung',
  },
  {
    id: '8108081006',
    districtId: '8108081',
    name: 'Nura',
  },
  {
    id: '8108081007',
    districtId: '8108081',
    name: 'Latalola Besar',
  },
  {
    id: '8108081008',
    districtId: '8108081',
    name: 'Marsela',
  },
  {
    id: '8108081009',
    districtId: '8108081',
    name: 'Serili',
  },
  {
    id: '8108081010',
    districtId: '8108081',
    name: 'Latalola Kecil',
  },
  {
    id: '8108081011',
    districtId: '8108081',
    name: 'Bululora',
  },
  {
    id: '8108082001',
    districtId: '8108082',
    name: 'Ilmarang',
  },
  {
    id: '8108082002',
    districtId: '8108082',
    name: 'Welora',
  },
  {
    id: '8108082003',
    districtId: '8108082',
    name: 'Letmasa',
  },
  {
    id: '8108082004',
    districtId: '8108082',
    name: 'Watuwey',
  },
  {
    id: '8108082005',
    districtId: '8108082',
    name: 'Wairatan',
  },
  {
    id: '8108082006',
    districtId: '8108082',
    name: 'Nurnyaman',
  },
  {
    id: '8109010001',
    districtId: '8109010',
    name: 'Walbele',
  },
  {
    id: '8109010002',
    districtId: '8109010',
    name: 'Waepandan',
  },
  {
    id: '8109010003',
    districtId: '8109010',
    name: 'Fogi',
  },
  {
    id: '8109010004',
    districtId: '8109010',
    name: 'Pasir Putih',
  },
  {
    id: '8109010005',
    districtId: '8109010',
    name: 'Biloro',
  },
  {
    id: '8109010006',
    districtId: '8109010',
    name: 'Nanali',
  },
  {
    id: '8109010007',
    districtId: '8109010',
    name: 'Waekeka',
  },
  {
    id: '8109010008',
    districtId: '8109010',
    name: 'Balpetu',
  },
  {
    id: '8109010009',
    districtId: '8109010',
    name: 'Sekat',
  },
  {
    id: '8109010010',
    districtId: '8109010',
    name: 'Air Ternate',
  },
  {
    id: '8109010011',
    districtId: '8109010',
    name: 'Batu Layar',
  },
  {
    id: '8109010012',
    districtId: '8109010',
    name: 'Siopot',
  },
  {
    id: '8109010014',
    districtId: '8109010',
    name: 'Bala Bala',
  },
  {
    id: '8109010015',
    districtId: '8109010',
    name: 'Waeha',
  },
  {
    id: '8109010016',
    districtId: '8109010',
    name: 'Waehotong',
  },
  {
    id: '8109020001',
    districtId: '8109020',
    name: 'Waemulang',
  },
  {
    id: '8109020002',
    districtId: '8109020',
    name: 'Waeturen',
  },
  {
    id: '8109020003',
    districtId: '8109020',
    name: 'Waehaka',
  },
  {
    id: '8109020004',
    districtId: '8109020',
    name: 'Waemala',
  },
  {
    id: '8109020005',
    districtId: '8109020',
    name: 'Ewiri',
  },
  {
    id: '8109020006',
    districtId: '8109020',
    name: 'Tifu',
  },
  {
    id: '8109020007',
    districtId: '8109020',
    name: 'Mepa',
  },
  {
    id: '8109020008',
    districtId: '8109020',
    name: 'Leksula',
  },
  {
    id: '8109020009',
    districtId: '8109020',
    name: 'Nalbessy',
  },
  {
    id: '8109020010',
    districtId: '8109020',
    name: 'Kase',
  },
  {
    id: '8109020015',
    districtId: '8109020',
    name: 'Slealale',
  },
  {
    id: '8109020017',
    districtId: '8109020',
    name: 'Neath',
  },
  {
    id: '8109020018',
    districtId: '8109020',
    name: 'Liang',
  },
  {
    id: '8109020021',
    districtId: '8109020',
    name: 'Walun Helat',
  },
  {
    id: '8109020022',
    districtId: '8109020',
    name: 'Grahwaen',
  },
  {
    id: '8109020024',
    districtId: '8109020',
    name: 'Waewali',
  },
  {
    id: '8109020025',
    districtId: '8109020',
    name: 'Waha Olon',
  },
  {
    id: '8109020029',
    districtId: '8109020',
    name: 'Waenama Olon',
  },
  {
    id: '8109021001',
    districtId: '8109021',
    name: 'Mngeswaen',
  },
  {
    id: '8109021002',
    districtId: '8109021',
    name: 'Waeraman',
  },
  {
    id: '8109021003',
    districtId: '8109021',
    name: 'Waelo',
  },
  {
    id: '8109021004',
    districtId: '8109021',
    name: 'Fakal',
  },
  {
    id: '8109021005',
    districtId: '8109021',
    name: 'Nusarua',
  },
  {
    id: '8109021007',
    districtId: '8109021',
    name: 'Waekatin',
  },
  {
    id: '8109021008',
    districtId: '8109021',
    name: 'Batu Karang',
  },
  {
    id: '8109021009',
    districtId: '8109021',
    name: 'Trukat',
  },
  {
    id: '8109021010',
    districtId: '8109021',
    name: 'Waeeken',
  },
  {
    id: '8109021011',
    districtId: '8109021',
    name: 'Siwatlahin',
  },
  {
    id: '8109030001',
    districtId: '8109030',
    name: 'Wamkana',
  },
  {
    id: '8109030002',
    districtId: '8109030',
    name: 'Waenalut',
  },
  {
    id: '8109030003',
    districtId: '8109030',
    name: 'Lektama',
  },
  {
    id: '8109030004',
    districtId: '8109030',
    name: 'Fatmite',
  },
  {
    id: '8109030007',
    districtId: '8109030',
    name: 'Oki  Lama',
  },
  {
    id: '8109030008',
    districtId: '8109030',
    name: 'Oki Baru',
  },
  {
    id: '8109030009',
    districtId: '8109030',
    name: 'Labuang',
  },
  {
    id: '8109030010',
    districtId: '8109030',
    name: 'Wali',
  },
  {
    id: '8109030011',
    districtId: '8109030',
    name: 'Batu Tulis',
  },
  {
    id: '8109030012',
    districtId: '8109030',
    name: 'Waefusi',
  },
  {
    id: '8109030013',
    districtId: '8109030',
    name: 'Kamlanglale',
  },
  {
    id: '8109030014',
    districtId: '8109030',
    name: 'Namrinat',
  },
  {
    id: '8109030015',
    districtId: '8109030',
    name: 'Waenono',
  },
  {
    id: '8109030016',
    districtId: '8109030',
    name: 'Tikbari',
  },
  {
    id: '8109030017',
    districtId: '8109030',
    name: 'Masnana',
  },
  {
    id: '8109040001',
    districtId: '8109040',
    name: 'Pohon Batu',
  },
  {
    id: '8109040002',
    districtId: '8109040',
    name: 'Wamsisi',
  },
  {
    id: '8109040003',
    districtId: '8109040',
    name: 'Waelikut',
  },
  {
    id: '8109040004',
    districtId: '8109040',
    name: 'Simi',
  },
  {
    id: '8109040005',
    districtId: '8109040',
    name: 'Lena',
  },
  {
    id: '8109040006',
    districtId: '8109040',
    name: 'Waesili',
  },
  {
    id: '8109040007',
    districtId: '8109040',
    name: 'Waetawa',
  },
  {
    id: '8109040008',
    districtId: '8109040',
    name: 'Waeteba',
  },
  {
    id: '8109040009',
    districtId: '8109040',
    name: 'Hote',
  },
  {
    id: '8109040010',
    districtId: '8109040',
    name: 'Waemasing',
  },
  {
    id: '8109040011',
    districtId: '8109040',
    name: 'Batu Kasa',
  },
  {
    id: '8109050001',
    districtId: '8109050',
    name: 'Siwar',
  },
  {
    id: '8109050002',
    districtId: '8109050',
    name: 'Selasi',
  },
  {
    id: '8109050003',
    districtId: '8109050',
    name: 'Elara',
  },
  {
    id: '8109050004',
    districtId: '8109050',
    name: 'Lumoy',
  },
  {
    id: '8109050005',
    districtId: '8109050',
    name: 'Masawoy',
  },
  {
    id: '8109050006',
    districtId: '8109050',
    name: 'Ulima',
  },
  {
    id: '8109050007',
    districtId: '8109050',
    name: 'Kampung Baru',
  },
  {
    id: '8171010001',
    districtId: '8171010',
    name: 'Latuhalat',
  },
  {
    id: '8171010002',
    districtId: '8171010',
    name: 'Seilale',
  },
  {
    id: '8171010003',
    districtId: '8171010',
    name: 'Nusaniwe',
  },
  {
    id: '8171010004',
    districtId: '8171010',
    name: 'Amahusu',
  },
  {
    id: '8171010005',
    districtId: '8171010',
    name: 'Kel Nusaniwe',
  },
  {
    id: '8171010007',
    districtId: '8171010',
    name: 'Kel Wainitu',
  },
  {
    id: '8171010008',
    districtId: '8171010',
    name: 'Kel Kudamati',
  },
  {
    id: '8171010009',
    districtId: '8171010',
    name: 'Urimesing',
  },
  {
    id: '8171010010',
    districtId: '8171010',
    name: 'Kel Mangga Dua',
  },
  {
    id: '8171010011',
    districtId: '8171010',
    name: 'Kel Urimesing',
  },
  {
    id: '8171010012',
    districtId: '8171010',
    name: 'Kel Waihaong',
  },
  {
    id: '8171010013',
    districtId: '8171010',
    name: 'Kel Silale',
  },
  {
    id: '8171020006',
    districtId: '8171020',
    name: 'Soya',
  },
  {
    id: '8171020007',
    districtId: '8171020',
    name: 'Waihoka',
  },
  {
    id: '8171020008',
    districtId: '8171020',
    name: 'Kel Karang Panjang',
  },
  {
    id: '8171020009',
    districtId: '8171020',
    name: 'Kel Batu Meja',
  },
  {
    id: '8171020010',
    districtId: '8171020',
    name: 'Kel Batu Gaja',
  },
  {
    id: '8171020011',
    districtId: '8171020',
    name: 'Kel Ahusen',
  },
  {
    id: '8171020012',
    districtId: '8171020',
    name: 'Kel Honipopu',
  },
  {
    id: '8171020013',
    districtId: '8171020',
    name: 'Uritetu',
  },
  {
    id: '8171020014',
    districtId: '8171020',
    name: 'Kel Rijali',
  },
  {
    id: '8171020015',
    districtId: '8171020',
    name: 'Kel Amantelu',
  },
  {
    id: '8171020016',
    districtId: '8171020',
    name: 'Batu Merah',
  },
  {
    id: '8171020017',
    districtId: '8171020',
    name: 'Pandan Kasturi',
  },
  {
    id: '8171020018',
    districtId: '8171020',
    name: 'Hative Kecil',
  },
  {
    id: '8171020019',
    districtId: '8171020',
    name: 'Galala',
  },
  {
    id: '8171021001',
    districtId: '8171021',
    name: 'Naku',
  },
  {
    id: '8171021002',
    districtId: '8171021',
    name: 'Kilang',
  },
  {
    id: '8171021003',
    districtId: '8171021',
    name: 'Hukurila',
  },
  {
    id: '8171021004',
    districtId: '8171021',
    name: 'Ema',
  },
  {
    id: '8171021005',
    districtId: '8171021',
    name: 'Hatalae',
  },
  {
    id: '8171021006',
    districtId: '8171021',
    name: 'Hutumuri',
  },
  {
    id: '8171021007',
    districtId: '8171021',
    name: 'Rutong',
  },
  {
    id: '8171021008',
    districtId: '8171021',
    name: 'Leahari',
  },
  {
    id: '8171030009',
    districtId: '8171030',
    name: 'Waiheru',
  },
  {
    id: '8171030010',
    districtId: '8171030',
    name: 'Nania',
  },
  {
    id: '8171030011',
    districtId: '8171030',
    name: 'Negeri Lama',
  },
  {
    id: '8171030012',
    districtId: '8171030',
    name: 'Passo',
  },
  {
    id: '8171030013',
    districtId: '8171030',
    name: 'Lateri',
  },
  {
    id: '8171030014',
    districtId: '8171030',
    name: 'Halong',
  },
  {
    id: '8171030015',
    districtId: '8171030',
    name: 'Latta',
  },
  {
    id: '8171031001',
    districtId: '8171031',
    name: 'Laha',
  },
  {
    id: '8171031002',
    districtId: '8171031',
    name: 'Tawiri',
  },
  {
    id: '8171031003',
    districtId: '8171031',
    name: 'Hative Besar',
  },
  {
    id: '8171031004',
    districtId: '8171031',
    name: 'Waiyame',
  },
  {
    id: '8171031005',
    districtId: '8171031',
    name: 'Rumah Tiga',
  },
  {
    id: '8171031006',
    districtId: '8171031',
    name: 'Tihu',
  },
  {
    id: '8171031007',
    districtId: '8171031',
    name: 'Poka',
  },
  {
    id: '8171031008',
    districtId: '8171031',
    name: 'Hunuth/Durian Patah',
  },
  {
    id: '8172010001',
    districtId: '8172010',
    name: 'Tubyal',
  },
  {
    id: '8172010002',
    districtId: '8172010',
    name: 'Finualen',
  },
  {
    id: '8172010003',
    districtId: '8172010',
    name: 'Lokwirin',
  },
  {
    id: '8172010004',
    districtId: '8172010',
    name: 'Kaimear',
  },
  {
    id: '8172010005',
    districtId: '8172010',
    name: 'Sermaf',
  },
  {
    id: '8172011001',
    districtId: '8172011',
    name: 'Kanara',
  },
  {
    id: '8172011002',
    districtId: '8172011',
    name: 'Warkar',
  },
  {
    id: '8172011003',
    districtId: '8172011',
    name: 'Yapas',
  },
  {
    id: '8172011004',
    districtId: '8172011',
    name: 'Romoin',
  },
  {
    id: '8172011005',
    districtId: '8172011',
    name: 'Hirit',
  },
  {
    id: '8172011006',
    districtId: '8172011',
    name: 'Mangur Niela',
  },
  {
    id: '8172011007',
    districtId: '8172011',
    name: 'Tiflean',
  },
  {
    id: '8172020001',
    districtId: '8172020',
    name: 'Tayando Langgiar',
  },
  {
    id: '8172020002',
    districtId: '8172020',
    name: 'Tayando Ohoiel',
  },
  {
    id: '8172020003',
    districtId: '8172020',
    name: 'Tayando Yamru',
  },
  {
    id: '8172020004',
    districtId: '8172020',
    name: 'Tayando Yamtel',
  },
  {
    id: '8172020005',
    districtId: '8172020',
    name: 'Tam Ngurhir',
  },
  {
    id: '8172030001',
    districtId: '8172030',
    name: 'Fiditan',
  },
  {
    id: '8172030002',
    districtId: '8172030',
    name: 'Ngadi',
  },
  {
    id: '8172030003',
    districtId: '8172030',
    name: 'Labetawi',
  },
  {
    id: '8172030004',
    districtId: '8172030',
    name: 'Tamedan',
  },
  {
    id: '8172030005',
    districtId: '8172030',
    name: 'Ohoitahit',
  },
  {
    id: '8172030006',
    districtId: '8172030',
    name: 'Ohoitel',
  },
  {
    id: '8172030007',
    districtId: '8172030',
    name: 'Dullah Darat',
  },
  {
    id: '8172030008',
    districtId: '8172030',
    name: 'Dullah Laut',
  },
  {
    id: '8172040001',
    districtId: '8172040',
    name: 'Taar',
  },
  {
    id: '8172040002',
    districtId: '8172040',
    name: 'Kel. Ketsoblak',
  },
  {
    id: '8172040003',
    districtId: '8172040',
    name: 'Tual',
  },
  {
    id: '8172040004',
    districtId: '8172040',
    name: 'Kel. Masrum',
  },
  {
    id: '8172040005',
    districtId: '8172040',
    name: 'Kel. Lodar El',
  },
  {
    id: '8201090015',
    districtId: '8201090',
    name: 'Buku Bualawa',
  },
  {
    id: '8201090016',
    districtId: '8201090',
    name: 'Tauro',
  },
  {
    id: '8201090017',
    districtId: '8201090',
    name: 'Matui',
  },
  {
    id: '8201090018',
    districtId: '8201090',
    name: 'Tuada',
  },
  {
    id: '8201090019',
    districtId: '8201090',
    name: 'Todowongi',
  },
  {
    id: '8201090020',
    districtId: '8201090',
    name: 'Bukumatiti',
  },
  {
    id: '8201090021',
    districtId: '8201090',
    name: 'Porniti',
  },
  {
    id: '8201090022',
    districtId: '8201090',
    name: 'Gamlamo',
  },
  {
    id: '8201090023',
    districtId: '8201090',
    name: 'Gufasa',
  },
  {
    id: '8201090024',
    districtId: '8201090',
    name: 'Guaemaadu',
  },
  {
    id: '8201090025',
    districtId: '8201090',
    name: 'Galala',
  },
  {
    id: '8201090026',
    districtId: '8201090',
    name: 'Bobanehena',
  },
  {
    id: '8201090027',
    districtId: '8201090',
    name: 'Saria',
  },
  {
    id: '8201090028',
    districtId: '8201090',
    name: 'Payo',
  },
  {
    id: '8201090029',
    districtId: '8201090',
    name: 'Bobo',
  },
  {
    id: '8201090030',
    districtId: '8201090',
    name: 'Idamdehe',
  },
  {
    id: '8201090031',
    districtId: '8201090',
    name: 'Idamdehe Gamsungi',
  },
  {
    id: '8201090032',
    districtId: '8201090',
    name: 'Jalan Baru',
  },
  {
    id: '8201090033',
    districtId: '8201090',
    name: 'Marimabati',
  },
  {
    id: '8201090034',
    districtId: '8201090',
    name: 'Gamtala',
  },
  {
    id: '8201090035',
    districtId: '8201090',
    name: 'Soakonora',
  },
  {
    id: '8201090036',
    districtId: '8201090',
    name: 'Lolori',
  },
  {
    id: '8201090037',
    districtId: '8201090',
    name: 'Taboso',
  },
  {
    id: '8201090038',
    districtId: '8201090',
    name: 'Hoku Hoku Kie',
  },
  {
    id: '8201090039',
    districtId: '8201090',
    name: 'Acango',
  },
  {
    id: '8201090041',
    districtId: '8201090',
    name: 'Akediri',
  },
  {
    id: '8201090048',
    districtId: '8201090',
    name: 'Guaeria',
  },
  {
    id: '8201090049',
    districtId: '8201090',
    name: 'Hatebicara',
  },
  {
    id: '8201090050',
    districtId: '8201090',
    name: 'Bukumaadu',
  },
  {
    id: '8201090051',
    districtId: '8201090',
    name: 'Ulo',
  },
  {
    id: '8201090052',
    districtId: '8201090',
    name: 'Pateng',
  },
  {
    id: '8201090053',
    districtId: '8201090',
    name: 'Bobojiko',
  },
  {
    id: '8201090054',
    districtId: '8201090',
    name: 'Kuripasai',
  },
  {
    id: '8201091001',
    districtId: '8201091',
    name: 'Rioribati',
  },
  {
    id: '8201091002',
    districtId: '8201091',
    name: 'Toniku',
  },
  {
    id: '8201091004',
    districtId: '8201091',
    name: 'Dodinga',
  },
  {
    id: '8201091005',
    districtId: '8201091',
    name: 'Akelaha',
  },
  {
    id: '8201091006',
    districtId: '8201091',
    name: 'Akeara',
  },
  {
    id: '8201091007',
    districtId: '8201091',
    name: 'Tuguraci',
  },
  {
    id: '8201091008',
    districtId: '8201091',
    name: 'Biamaahi',
  },
  {
    id: '8201091009',
    districtId: '8201091',
    name: 'Ake Jailolo',
  },
  {
    id: '8201091010',
    districtId: '8201091',
    name: 'Sidangoli Dehe',
  },
  {
    id: '8201091011',
    districtId: '8201091',
    name: 'Sidangoli Gam',
  },
  {
    id: '8201091012',
    districtId: '8201091',
    name: 'Domato',
  },
  {
    id: '8201091013',
    districtId: '8201091',
    name: 'Gamlenge',
  },
  {
    id: '8201091014',
    districtId: '8201091',
    name: 'Tataleka',
  },
  {
    id: '8201091015',
    districtId: '8201091',
    name: 'Tabadamai',
  },
  {
    id: '8201091016',
    districtId: '8201091',
    name: 'Braha',
  },
  {
    id: '8201091017',
    districtId: '8201091',
    name: 'Bangkit Rahmat',
  },
  {
    id: '8201091018',
    districtId: '8201091',
    name: 'Moiso',
  },
  {
    id: '8201091019',
    districtId: '8201091',
    name: 'Suka Damai',
  },
  {
    id: '8201091020',
    districtId: '8201091',
    name: 'Hijrah',
  },
  {
    id: '8201091021',
    districtId: '8201091',
    name: 'Bobane Dano',
  },
  {
    id: '8201091022',
    districtId: '8201091',
    name: 'Ratem',
  },
  {
    id: '8201100001',
    districtId: '8201100',
    name: 'Lako Akelamo',
  },
  {
    id: '8201100003',
    districtId: '8201100',
    name: 'Tacim',
  },
  {
    id: '8201100004',
    districtId: '8201100',
    name: 'Taruba',
  },
  {
    id: '8201100005',
    districtId: '8201100',
    name: 'Balisoan',
  },
  {
    id: '8201100006',
    districtId: '8201100',
    name: 'Golo',
  },
  {
    id: '8201100014',
    districtId: '8201100',
    name: 'Taraudu',
  },
  {
    id: '8201100016',
    districtId: '8201100',
    name: 'Tacici',
  },
  {
    id: '8201100017',
    districtId: '8201100',
    name: 'Worat Worat',
  },
  {
    id: '8201100018',
    districtId: '8201100',
    name: 'Todahe',
  },
  {
    id: '8201100019',
    districtId: '8201100',
    name: 'Peot',
  },
  {
    id: '8201100026',
    districtId: '8201100',
    name: 'Sasur',
  },
  {
    id: '8201100029',
    districtId: '8201100',
    name: 'Goro Goro',
  },
  {
    id: '8201100030',
    districtId: '8201100',
    name: 'Lako Akediri',
  },
  {
    id: '8201100031',
    districtId: '8201100',
    name: 'Jarakore',
  },
  {
    id: '8201100032',
    districtId: '8201100',
    name: 'Ropu Tengah Balu',
  },
  {
    id: '8201100033',
    districtId: '8201100',
    name: 'Balisoan Utara',
  },
  {
    id: '8201100035',
    districtId: '8201100',
    name: 'Sasur Pantai',
  },
  {
    id: '8201101001',
    districtId: '8201101',
    name: 'Idam Gamlamo',
  },
  {
    id: '8201101002',
    districtId: '8201101',
    name: 'Loce',
  },
  {
    id: '8201101003',
    districtId: '8201101',
    name: 'Gamomeng',
  },
  {
    id: '8201101004',
    districtId: '8201101',
    name: 'Akelamo',
  },
  {
    id: '8201101005',
    districtId: '8201101',
    name: 'Taraudu Kusu',
  },
  {
    id: '8201101006',
    districtId: '8201101',
    name: 'Awer',
  },
  {
    id: '8201101007',
    districtId: '8201101',
    name: 'Aketola',
  },
  {
    id: '8201101008',
    districtId: '8201101',
    name: 'Tibobo',
  },
  {
    id: '8201101009',
    districtId: '8201101',
    name: 'Hoku Hoku Gam',
  },
  {
    id: '8201101010',
    districtId: '8201101',
    name: 'Gamnyial',
  },
  {
    id: '8201101011',
    districtId: '8201101',
    name: 'Campaka',
  },
  {
    id: '8201101012',
    districtId: '8201101',
    name: 'Ngaon',
  },
  {
    id: '8201101013',
    districtId: '8201101',
    name: 'Gamsungi',
  },
  {
    id: '8201101014',
    districtId: '8201101',
    name: 'Taba Campaka',
  },
  {
    id: '8201101015',
    districtId: '8201101',
    name: 'Goal',
  },
  {
    id: '8201101016',
    districtId: '8201101',
    name: 'Golago Kusuma',
  },
  {
    id: '8201101017',
    districtId: '8201101',
    name: 'Sidodadi',
  },
  {
    id: '8201101018',
    districtId: '8201101',
    name: 'Air Panas',
  },
  {
    id: '8201130012',
    districtId: '8201130',
    name: 'Togola Wayoli',
  },
  {
    id: '8201130013',
    districtId: '8201130',
    name: 'Togola Sangir',
  },
  {
    id: '8201130014',
    districtId: '8201130',
    name: 'Tahafo',
  },
  {
    id: '8201130015',
    districtId: '8201130',
    name: 'Kie Ici',
  },
  {
    id: '8201130016',
    districtId: '8201130',
    name: 'Maritango',
  },
  {
    id: '8201130017',
    districtId: '8201130',
    name: 'Tongute Goin',
  },
  {
    id: '8201130018',
    districtId: '8201130',
    name: 'Akesibu',
  },
  {
    id: '8201130019',
    districtId: '8201130',
    name: 'Tongute Sungi',
  },
  {
    id: '8201130020',
    districtId: '8201130',
    name: 'Tongute Ternate',
  },
  {
    id: '8201130021',
    districtId: '8201130',
    name: 'Tobaol',
  },
  {
    id: '8201130022',
    districtId: '8201130',
    name: 'Gam Ici',
  },
  {
    id: '8201130023',
    districtId: '8201130',
    name: 'Gam Lamo',
  },
  {
    id: '8201130037',
    districtId: '8201130',
    name: 'Naga',
  },
  {
    id: '8201130038',
    districtId: '8201130',
    name: 'Tongute Ternate Asal',
  },
  {
    id: '8201130039',
    districtId: '8201130',
    name: 'Kampung Baru',
  },
  {
    id: '8201130040',
    districtId: '8201130',
    name: 'Soana Masungi',
  },
  {
    id: '8201130041',
    districtId: '8201130',
    name: 'Akeboso',
  },
  {
    id: '8201131001',
    districtId: '8201131',
    name: 'Tabobol',
  },
  {
    id: '8201131002',
    districtId: '8201131',
    name: 'Tosoa',
  },
  {
    id: '8201131003',
    districtId: '8201131',
    name: 'Baru',
  },
  {
    id: '8201131004',
    districtId: '8201131',
    name: 'Adu',
  },
  {
    id: '8201131005',
    districtId: '8201131',
    name: 'Nanas',
  },
  {
    id: '8201131006',
    districtId: '8201131',
    name: 'Ngawet',
  },
  {
    id: '8201131008',
    districtId: '8201131',
    name: 'Gamsungi',
  },
  {
    id: '8201131009',
    districtId: '8201131',
    name: 'Bataka',
  },
  {
    id: '8201131010',
    districtId: '8201131',
    name: 'Talaga',
  },
  {
    id: '8201131011',
    districtId: '8201131',
    name: 'Tobelos',
  },
  {
    id: '8201131012',
    districtId: '8201131',
    name: 'Gamkonora',
  },
  {
    id: '8201131013',
    districtId: '8201131',
    name: 'Sarau',
  },
  {
    id: '8201131014',
    districtId: '8201131',
    name: 'Tuguaer',
  },
  {
    id: '8201131015',
    districtId: '8201131',
    name: 'Ngalo Ngalo',
  },
  {
    id: '8201131016',
    districtId: '8201131',
    name: 'Gamsida',
  },
  {
    id: '8201132001',
    districtId: '8201132',
    name: 'Podol',
  },
  {
    id: '8201132002',
    districtId: '8201132',
    name: 'Tengowango',
  },
  {
    id: '8201132003',
    districtId: '8201132',
    name: 'Togowo',
  },
  {
    id: '8201132004',
    districtId: '8201132',
    name: 'Duono',
  },
  {
    id: '8201132005',
    districtId: '8201132',
    name: 'Goin',
  },
  {
    id: '8201132006',
    districtId: '8201132',
    name: 'Sangaji Nyeku',
  },
  {
    id: '8201132007',
    districtId: '8201132',
    name: 'Tuguis',
  },
  {
    id: '8201132008',
    districtId: '8201132',
    name: 'Todoke',
  },
  {
    id: '8201132009',
    districtId: '8201132',
    name: 'Togoreba Sungi',
  },
  {
    id: '8201132010',
    districtId: '8201132',
    name: 'Borona',
  },
  {
    id: '8201132011',
    districtId: '8201132',
    name: 'Tolisaor',
  },
  {
    id: '8201132012',
    districtId: '8201132',
    name: 'Pasalulu',
  },
  {
    id: '8201132013',
    districtId: '8201132',
    name: 'Togoreba Tua',
  },
  {
    id: '8201132014',
    districtId: '8201132',
    name: 'Tukuoko',
  },
  {
    id: '8201132015',
    districtId: '8201132',
    name: 'Soasangaji',
  },
  {
    id: '8201132016',
    districtId: '8201132',
    name: 'Aru Jaya',
  },
  {
    id: '8201140001',
    districtId: '8201140',
    name: 'Totala',
  },
  {
    id: '8201140002',
    districtId: '8201140',
    name: 'Tolofuo',
  },
  {
    id: '8201140003',
    districtId: '8201140',
    name: 'Tuguis',
  },
  {
    id: '8201140004',
    districtId: '8201140',
    name: 'Soa-Sio',
  },
  {
    id: '8201140005',
    districtId: '8201140',
    name: 'Kedi',
  },
  {
    id: '8201140006',
    districtId: '8201140',
    name: 'Tasye',
  },
  {
    id: '8201140007',
    districtId: '8201140',
    name: 'Laba Besar',
  },
  {
    id: '8201140008',
    districtId: '8201140',
    name: 'Laba Kecil',
  },
  {
    id: '8201140009',
    districtId: '8201140',
    name: 'Jano',
  },
  {
    id: '8201140010',
    districtId: '8201140',
    name: 'Bakun',
  },
  {
    id: '8201140011',
    districtId: '8201140',
    name: 'Buo',
  },
  {
    id: '8201140012',
    districtId: '8201140',
    name: 'Bakun Pantai',
  },
  {
    id: '8201140013',
    districtId: '8201140',
    name: 'Barataku',
  },
  {
    id: '8201140014',
    districtId: '8201140',
    name: 'Gamkahe',
  },
  {
    id: '8201140015',
    districtId: '8201140',
    name: 'Pumadada',
  },
  {
    id: '8201140016',
    districtId: '8201140',
    name: 'Baja',
  },
  {
    id: '8201140017',
    districtId: '8201140',
    name: 'Bosala',
  },
  {
    id: '8201140019',
    districtId: '8201140',
    name: 'Jangailulu',
  },
  {
    id: '8201140020',
    districtId: '8201140',
    name: 'Tosomolo',
  },
  {
    id: '8201140021',
    districtId: '8201140',
    name: 'Salu',
  },
  {
    id: '8201140022',
    districtId: '8201140',
    name: 'Kahatola',
  },
  {
    id: '8201140023',
    districtId: '8201140',
    name: 'UPT. Trans Jano',
  },
  {
    id: '8201140024',
    districtId: '8201140',
    name: 'Totala Jaya',
  },
  {
    id: '8201140025',
    districtId: '8201140',
    name: 'Tomodo',
  },
  {
    id: '8201140026',
    districtId: '8201140',
    name: 'Linggua',
  },
  {
    id: '8201140027',
    districtId: '8201140',
    name: 'Bantoli',
  },
  {
    id: '8201140028',
    districtId: '8201140',
    name: 'Aruku',
  },
  {
    id: '8201140029',
    districtId: '8201140',
    name: 'Bilote',
  },
  {
    id: '8202030006',
    districtId: '8202030',
    name: 'Nusliko',
  },
  {
    id: '8202030019',
    districtId: '8202030',
    name: 'Nurweda',
  },
  {
    id: '8202030020',
    districtId: '8202030',
    name: 'Fidi Jaya',
  },
  {
    id: '8202030021',
    districtId: '8202030',
    name: 'Sidanga',
  },
  {
    id: '8202030022',
    districtId: '8202030',
    name: 'Wedana',
  },
  {
    id: '8202030023',
    districtId: '8202030',
    name: 'Goeng',
  },
  {
    id: '8202031001',
    districtId: '8202031',
    name: 'Kluting Jaya',
  },
  {
    id: '8202031002',
    districtId: '8202031',
    name: 'Wairoro Indah',
  },
  {
    id: '8202031003',
    districtId: '8202031',
    name: 'Tiloppe',
  },
  {
    id: '8202031004',
    districtId: '8202031',
    name: 'Sosowomo',
  },
  {
    id: '8202031005',
    districtId: '8202031',
    name: 'Loleo',
  },
  {
    id: '8202031006',
    districtId: '8202031',
    name: 'Sumber Sari',
  },
  {
    id: '8202031007',
    districtId: '8202031',
    name: 'Lembah Asri',
  },
  {
    id: '8202031008',
    districtId: '8202031',
    name: 'Air Salobar',
  },
  {
    id: '8202032001',
    districtId: '8202032',
    name: 'Gemaf',
  },
  {
    id: '8202032002',
    districtId: '8202032',
    name: 'Sagea',
  },
  {
    id: '8202032003',
    districtId: '8202032',
    name: 'Fritu',
  },
  {
    id: '8202032004',
    districtId: '8202032',
    name: 'Waleh',
  },
  {
    id: '8202032008',
    districtId: '8202032',
    name: 'Desa Persiapan Trans Sp I',
  },
  {
    id: '8202032009',
    districtId: '8202032',
    name: 'Kiya',
  },
  {
    id: '8202033001',
    districtId: '8202033',
    name: 'Kobe',
  },
  {
    id: '8202033002',
    districtId: '8202033',
    name: 'Sawai Itepo',
  },
  {
    id: '8202033003',
    districtId: '8202033',
    name: 'Lelilef Waibulan',
  },
  {
    id: '8202033004',
    districtId: '8202033',
    name: 'Lelilef Sawai',
  },
  {
    id: '8202033005',
    districtId: '8202033',
    name: 'Woekop',
  },
  {
    id: '8202033006',
    districtId: '8202033',
    name: 'Woejerana',
  },
  {
    id: '8202033007',
    districtId: '8202033',
    name: 'Kulo Jaya',
  },
  {
    id: '8202034002',
    districtId: '8202034',
    name: 'Messa',
  },
  {
    id: '8202034003',
    districtId: '8202034',
    name: 'Dotte',
  },
  {
    id: '8202034004',
    districtId: '8202034',
    name: 'Kotalo',
  },
  {
    id: '8202034005',
    districtId: '8202034',
    name: 'Desa Persiapan Trans Sp II',
  },
  {
    id: '8202041001',
    districtId: '8202041',
    name: 'Umera',
  },
  {
    id: '8202041002',
    districtId: '8202041',
    name: 'Sanafi',
  },
  {
    id: '8202041003',
    districtId: '8202041',
    name: 'Kacepi',
  },
  {
    id: '8202041004',
    districtId: '8202041',
    name: 'Kapaleo',
  },
  {
    id: '8202041005',
    districtId: '8202041',
    name: 'Umiyal',
  },
  {
    id: '8202041006',
    districtId: '8202041',
    name: 'Sonof Kacepo',
  },
  {
    id: '8202041007',
    districtId: '8202041',
    name: 'Elfanun',
  },
  {
    id: '8202041008',
    districtId: '8202041',
    name: 'Yam',
  },
  {
    id: '8202042001',
    districtId: '8202042',
    name: 'Yeisowo',
  },
  {
    id: '8202042002',
    districtId: '8202042',
    name: 'Wailegi',
  },
  {
    id: '8202042005',
    districtId: '8202042',
    name: 'Kipai',
  },
  {
    id: '8202042010',
    districtId: '8202042',
    name: 'Yondeliu',
  },
  {
    id: '8202042011',
    districtId: '8202042',
    name: 'Baka Jaya',
  },
  {
    id: '8202043001',
    districtId: '8202043',
    name: 'Gemia',
  },
  {
    id: '8202043002',
    districtId: '8202043',
    name: 'Tepeleo',
  },
  {
    id: '8202043006',
    districtId: '8202043',
    name: 'Bilifitu',
  },
  {
    id: '8202043007',
    districtId: '8202043',
    name: 'Tepeleo Batu Dua',
  },
  {
    id: '8202043008',
    districtId: '8202043',
    name: 'Pantura Jaya',
  },
  {
    id: '8202043011',
    districtId: '8202043',
    name: 'Maliforo',
  },
  {
    id: '8202044001',
    districtId: '8202044',
    name: 'Bobane Indah',
  },
  {
    id: '8202044002',
    districtId: '8202044',
    name: 'Banemo',
  },
  {
    id: '8202044003',
    districtId: '8202044',
    name: 'Bobane Jaya',
  },
  {
    id: '8202044004',
    districtId: '8202044',
    name: 'Moreala',
  },
  {
    id: '8202044005',
    districtId: '8202044',
    name: 'Sibenpopo',
  },
  {
    id: '8202045001',
    districtId: '8202045',
    name: 'Peniti',
  },
  {
    id: '8202045002',
    districtId: '8202045',
    name: 'Masure',
  },
  {
    id: '8202045003',
    districtId: '8202045',
    name: 'Sakam',
  },
  {
    id: '8202045004',
    districtId: '8202045',
    name: 'Pallo',
  },
  {
    id: '8202045005',
    districtId: '8202045',
    name: 'Damuli',
  },
  {
    id: '8202045006',
    districtId: '8202045',
    name: 'Nursifa',
  },
  {
    id: '8203010004',
    districtId: '8203010',
    name: 'Wai Ina',
  },
  {
    id: '8203010005',
    districtId: '8203010',
    name: 'Kabau Darat',
  },
  {
    id: '8203010006',
    districtId: '8203010',
    name: 'Ona',
  },
  {
    id: '8203010008',
    districtId: '8203010',
    name: 'Kabau Pantai',
  },
  {
    id: '8203010009',
    districtId: '8203010',
    name: 'Nahi',
  },
  {
    id: '8203010010',
    districtId: '8203010',
    name: 'Paratina',
  },
  {
    id: '8203011001',
    districtId: '8203011',
    name: 'Wai Gai',
  },
  {
    id: '8203011002',
    districtId: '8203011',
    name: 'Fuata',
  },
  {
    id: '8203011003',
    districtId: '8203011',
    name: 'Sekom',
  },
  {
    id: '8203011004',
    districtId: '8203011',
    name: 'Wainib',
  },
  {
    id: '8203011005',
    districtId: '8203011',
    name: 'Wai Tamua',
  },
  {
    id: '8203020015',
    districtId: '8203020',
    name: 'Wailau',
  },
  {
    id: '8203020017',
    districtId: '8203020',
    name: 'Pastina',
  },
  {
    id: '8203020018',
    districtId: '8203020',
    name: 'Umaloya',
  },
  {
    id: '8203020019',
    districtId: '8203020',
    name: 'Wai Ipa',
  },
  {
    id: '8203020020',
    districtId: '8203020',
    name: 'Wai Hama',
  },
  {
    id: '8203020021',
    districtId: '8203020',
    name: 'Fogi',
  },
  {
    id: '8203020022',
    districtId: '8203020',
    name: 'Fatce',
  },
  {
    id: '8203020023',
    districtId: '8203020',
    name: 'Falahu',
  },
  {
    id: '8203020024',
    districtId: '8203020',
    name: 'Fagudu',
  },
  {
    id: '8203020025',
    districtId: '8203020',
    name: 'Mangon',
  },
  {
    id: '8203020026',
    districtId: '8203020',
    name: 'Waibau',
  },
  {
    id: '8203021001',
    districtId: '8203021',
    name: 'Bega',
  },
  {
    id: '8203021002',
    districtId: '8203021',
    name: 'Fat-Iba',
  },
  {
    id: '8203021003',
    districtId: '8203021',
    name: 'Waiman',
  },
  {
    id: '8203021004',
    districtId: '8203021',
    name: 'Soamole',
  },
  {
    id: '8203021005',
    districtId: '8203021',
    name: 'Wai Boga',
  },
  {
    id: '8203021006',
    districtId: '8203021',
    name: 'Manaf',
  },
  {
    id: '8203022001',
    districtId: '8203022',
    name: 'Wailia',
  },
  {
    id: '8203022002',
    districtId: '8203022',
    name: 'Fatkauyon',
  },
  {
    id: '8203022003',
    districtId: '8203022',
    name: 'Baleha',
  },
  {
    id: '8203022004',
    districtId: '8203022',
    name: 'Wai Goyofa',
  },
  {
    id: '8203022005',
    districtId: '8203022',
    name: 'Sama',
  },
  {
    id: '8203022006',
    districtId: '8203022',
    name: 'Waisepa',
  },
  {
    id: '8203023001',
    districtId: '8203023',
    name: 'Pohea',
  },
  {
    id: '8203023003',
    districtId: '8203023',
    name: 'Malbufa',
  },
  {
    id: '8203023004',
    districtId: '8203023',
    name: 'Bajo',
  },
  {
    id: '8203023005',
    districtId: '8203023',
    name: 'Man Gega',
  },
  {
    id: '8203023006',
    districtId: '8203023',
    name: 'Wainin',
  },
  {
    id: '8203023007',
    districtId: '8203023',
    name: 'Fokalik',
  },
  {
    id: '8203030006',
    districtId: '8203030',
    name: 'Waitina',
  },
  {
    id: '8203030007',
    districtId: '8203030',
    name: 'Kow',
  },
  {
    id: '8203030008',
    districtId: '8203030',
    name: 'Wai-Tamela',
  },
  {
    id: '8203030009',
    districtId: '8203030',
    name: 'Naflow',
  },
  {
    id: '8203030010',
    districtId: '8203030',
    name: 'Karamat Titdoy',
  },
  {
    id: '8203031001',
    districtId: '8203031',
    name: 'Baru Akol',
  },
  {
    id: '8203031002',
    districtId: '8203031',
    name: 'Capalulu',
  },
  {
    id: '8203031003',
    districtId: '8203031',
    name: 'Orifola',
  },
  {
    id: '8203031004',
    districtId: '8203031',
    name: 'Wailoba',
  },
  {
    id: '8203031005',
    districtId: '8203031',
    name: 'Mangoli',
  },
  {
    id: '8203031006',
    districtId: '8203031',
    name: 'Waitulia',
  },
  {
    id: '8203031007',
    districtId: '8203031',
    name: 'Wai U',
  },
  {
    id: '8203031008',
    districtId: '8203031',
    name: 'Paslal',
  },
  {
    id: '8203032001',
    districtId: '8203032',
    name: 'Kawata',
  },
  {
    id: '8203032002',
    districtId: '8203032',
    name: 'Pelita Jaya',
  },
  {
    id: '8203032003',
    districtId: '8203032',
    name: 'Waisakai',
  },
  {
    id: '8203032004',
    districtId: '8203032',
    name: 'Waisum',
  },
  {
    id: '8203040001',
    districtId: '8203040',
    name: 'Pas Ipa',
  },
  {
    id: '8203040002',
    districtId: '8203040',
    name: 'Dofa',
  },
  {
    id: '8203040003',
    districtId: '8203040',
    name: 'Leko Kadai',
  },
  {
    id: '8203040004',
    districtId: '8203040',
    name: 'Lekosula',
  },
  {
    id: '8203040015',
    districtId: '8203040',
    name: 'Pelita',
  },
  {
    id: '8203040016',
    districtId: '8203040',
    name: 'Johor',
  },
  {
    id: '8203040017',
    districtId: '8203040',
    name: 'Lelyaba',
  },
  {
    id: '8203041001',
    districtId: '8203041',
    name: 'Falabisahaya',
  },
  {
    id: '8203041002',
    districtId: '8203041',
    name: 'Madapuhi',
  },
  {
    id: '8203041003',
    districtId: '8203041',
    name: 'Pastabulu',
  },
  {
    id: '8203041004',
    districtId: '8203041',
    name: 'Modapia',
  },
  {
    id: '8203041005',
    districtId: '8203041',
    name: 'Minaluli',
  },
  {
    id: '8203041006',
    districtId: '8203041',
    name: 'Saniahaya',
  },
  {
    id: '8203041007',
    districtId: '8203041',
    name: 'Madapuhi Trans',
  },
  {
    id: '8203042001',
    districtId: '8203042',
    name: 'Auponhia',
  },
  {
    id: '8203042002',
    districtId: '8203042',
    name: 'Buya',
  },
  {
    id: '8203042004',
    districtId: '8203042',
    name: 'Wai Kafia',
  },
  {
    id: '8203042005',
    districtId: '8203042',
    name: 'Kaporo',
  },
  {
    id: '8203042006',
    districtId: '8203042',
    name: 'Wailab',
  },
  {
    id: '8204010001',
    districtId: '8204010',
    name: 'Loleo',
  },
  {
    id: '8204010002',
    districtId: '8204010',
    name: 'Mano',
  },
  {
    id: '8204010003',
    districtId: '8204010',
    name: 'Soligi',
  },
  {
    id: '8204010004',
    districtId: '8204010',
    name: 'Wayaloar',
  },
  {
    id: '8204010006',
    districtId: '8204010',
    name: 'Bobo',
  },
  {
    id: '8204010008',
    districtId: '8204010',
    name: 'Ocimaloleo',
  },
  {
    id: '8204010009',
    districtId: '8204010',
    name: 'Gambaru',
  },
  {
    id: '8204020008',
    districtId: '8204020',
    name: 'Anggai',
  },
  {
    id: '8204020009',
    districtId: '8204020',
    name: 'Sambiki',
  },
  {
    id: '8204020011',
    districtId: '8204020',
    name: 'Jikotamo',
  },
  {
    id: '8204020013',
    districtId: '8204020',
    name: 'Laiwui',
  },
  {
    id: '8204020014',
    districtId: '8204020',
    name: 'Buton',
  },
  {
    id: '8204020015',
    districtId: '8204020',
    name: 'Baru',
  },
  {
    id: '8204020016',
    districtId: '8204020',
    name: 'Akegula',
  },
  {
    id: '8204020021',
    districtId: '8204020',
    name: 'Kawasi',
  },
  {
    id: '8204020022',
    districtId: '8204020',
    name: 'Air Mangga',
  },
  {
    id: '8204021001',
    districtId: '8204021',
    name: 'Manatahan',
  },
  {
    id: '8204021002',
    districtId: '8204021',
    name: 'Jikohay',
  },
  {
    id: '8204021003',
    districtId: '8204021',
    name: 'Alam Kenanga',
  },
  {
    id: '8204021004',
    districtId: '8204021',
    name: 'Soa Sangaji',
  },
  {
    id: '8204021005',
    districtId: '8204021',
    name: 'Alam Pelita',
  },
  {
    id: '8204021006',
    districtId: '8204021',
    name: 'Tapa',
  },
  {
    id: '8204022002',
    districtId: '8204022',
    name: 'Kelo',
  },
  {
    id: '8204022004',
    districtId: '8204022',
    name: 'Wooi',
  },
  {
    id: '8204023001',
    districtId: '8204023',
    name: 'Pasir Putih',
  },
  {
    id: '8204023002',
    districtId: '8204023',
    name: 'Cap',
  },
  {
    id: '8204023003',
    districtId: '8204023',
    name: 'Galala',
  },
  {
    id: '8204023004',
    districtId: '8204023',
    name: 'Madapolo Barat',
  },
  {
    id: '8204023005',
    districtId: '8204023',
    name: 'Madapolo',
  },
  {
    id: '8204023006',
    districtId: '8204023',
    name: 'Madapolo Timur',
  },
  {
    id: '8204023007',
    districtId: '8204023',
    name: 'Waringi',
  },
  {
    id: '8204030034',
    districtId: '8204030',
    name: 'Tomori',
  },
  {
    id: '8204030035',
    districtId: '8204030',
    name: 'Labuha',
  },
  {
    id: '8204030036',
    districtId: '8204030',
    name: 'Amasing Kota',
  },
  {
    id: '8204030037',
    districtId: '8204030',
    name: 'Amasing Kali',
  },
  {
    id: '8204030038',
    districtId: '8204030',
    name: 'Indomut',
  },
  {
    id: '8204030039',
    districtId: '8204030',
    name: 'Belang Belang',
  },
  {
    id: '8204030040',
    districtId: '8204030',
    name: 'Sumae',
  },
  {
    id: '8204030041',
    districtId: '8204030',
    name: 'Kaputusan',
  },
  {
    id: '8204030042',
    districtId: '8204030',
    name: 'Hidayat',
  },
  {
    id: '8204030043',
    districtId: '8204030',
    name: 'Marabose',
  },
  {
    id: '8204030044',
    districtId: '8204030',
    name: 'Amasing Kota Barat',
  },
  {
    id: '8204030045',
    districtId: '8204030',
    name: 'Amasing Kota Utara',
  },
  {
    id: '8204030046',
    districtId: '8204030',
    name: 'Awanggoa',
  },
  {
    id: '8204030047',
    districtId: '8204030',
    name: 'Suma Tinggi',
  },
  {
    id: '8204031001',
    districtId: '8204031',
    name: 'Yoyok',
  },
  {
    id: '8204031002',
    districtId: '8204031',
    name: 'Tabalema',
  },
  {
    id: '8204031003',
    districtId: '8204031',
    name: 'Galala',
  },
  {
    id: '8204031004',
    districtId: '8204031',
    name: 'Jiko',
  },
  {
    id: '8204031005',
    districtId: '8204031',
    name: 'Bahu',
  },
  {
    id: '8204032001',
    districtId: '8204032',
    name: 'Waya',
  },
  {
    id: '8204032002',
    districtId: '8204032',
    name: 'Indong',
  },
  {
    id: '8204032003',
    districtId: '8204032',
    name: 'Bobo',
  },
  {
    id: '8204032004',
    districtId: '8204032',
    name: 'Pelita Jaya',
  },
  {
    id: '8204032005',
    districtId: '8204032',
    name: 'Akedabo',
  },
  {
    id: '8204032006',
    districtId: '8204032',
    name: 'Loleongusu',
  },
  {
    id: '8204033001',
    districtId: '8204033',
    name: 'Gandasuli',
  },
  {
    id: '8204033002',
    districtId: '8204033',
    name: 'Kupal',
  },
  {
    id: '8204033003',
    districtId: '8204033',
    name: 'Sawadai',
  },
  {
    id: '8204033005',
    districtId: '8204033',
    name: 'Tuakona',
  },
  {
    id: '8204033006',
    districtId: '8204033',
    name: 'Panambuang',
  },
  {
    id: '8204033007',
    districtId: '8204033',
    name: 'Mandaong',
  },
  {
    id: '8204033008',
    districtId: '8204033',
    name: 'Tembal',
  },
  {
    id: '8204033009',
    districtId: '8204033',
    name: 'Kampung Makian',
  },
  {
    id: '8204033010',
    districtId: '8204033',
    name: 'Papaloang',
  },
  {
    id: '8204034001',
    districtId: '8204034',
    name: 'Kampung Baru',
  },
  {
    id: '8204034002',
    districtId: '8204034',
    name: 'Batutaga',
  },
  {
    id: '8204034003',
    districtId: '8204034',
    name: 'Parapakanda',
  },
  {
    id: '8204034004',
    districtId: '8204034',
    name: 'Tanjung Obit',
  },
  {
    id: '8204034005',
    districtId: '8204034',
    name: 'Bajo',
  },
  {
    id: '8204034006',
    districtId: '8204034',
    name: 'Pasimbaos',
  },
  {
    id: '8204034007',
    districtId: '8204034',
    name: 'Sawanakar',
  },
  {
    id: '8204034008',
    districtId: '8204034',
    name: 'Toin',
  },
  {
    id: '8204040012',
    districtId: '8204040',
    name: 'Babang',
  },
  {
    id: '8204040013',
    districtId: '8204040',
    name: 'Bori',
  },
  {
    id: '8204040014',
    districtId: '8204040',
    name: 'Nyonyifi',
  },
  {
    id: '8204040015',
    districtId: '8204040',
    name: 'Sabatang',
  },
  {
    id: '8204040016',
    districtId: '8204040',
    name: 'Goro Goro',
  },
  {
    id: '8204040017',
    districtId: '8204040',
    name: 'Timlonga',
  },
  {
    id: '8204040018',
    districtId: '8204040',
    name: 'Sali Kecil',
  },
  {
    id: '8204040021',
    districtId: '8204040',
    name: 'Wayamiga',
  },
  {
    id: '8204040022',
    districtId: '8204040',
    name: 'Sayoang',
  },
  {
    id: '8204040023',
    districtId: '8204040',
    name: 'Kaireu',
  },
  {
    id: '8204041001',
    districtId: '8204041',
    name: 'Tabangame',
  },
  {
    id: '8204041002',
    districtId: '8204041',
    name: 'Wayaua',
  },
  {
    id: '8204041003',
    districtId: '8204041',
    name: 'Tabajaya',
  },
  {
    id: '8204041004',
    districtId: '8204041',
    name: 'Silang',
  },
  {
    id: '8204041005',
    districtId: '8204041',
    name: 'Liaro',
  },
  {
    id: '8204041006',
    districtId: '8204041',
    name: 'Waya Kuba',
  },
  {
    id: '8204041007',
    districtId: '8204041',
    name: 'Pigaraja',
  },
  {
    id: '8204042001',
    districtId: '8204042',
    name: 'Tawa Bacan Timur',
  },
  {
    id: '8204042002',
    districtId: '8204042',
    name: 'Songa',
  },
  {
    id: '8204042003',
    districtId: '8204042',
    name: 'Bibinoi',
  },
  {
    id: '8204042004',
    districtId: '8204042',
    name: 'Tabapoma',
  },
  {
    id: '8204042005',
    districtId: '8204042',
    name: 'Tutupa',
  },
  {
    id: '8204042006',
    districtId: '8204042',
    name: 'Tomara',
  },
  {
    id: '8204042007',
    districtId: '8204042',
    name: 'Wayatim',
  },
  {
    id: '8204050001',
    districtId: '8204050',
    name: 'Wiring Yoyok',
  },
  {
    id: '8204050002',
    districtId: '8204050',
    name: 'Tawabi',
  },
  {
    id: '8204050016',
    districtId: '8204050',
    name: 'Nondang',
  },
  {
    id: '8204050017',
    districtId: '8204050',
    name: 'Indari',
  },
  {
    id: '8204050018',
    districtId: '8204050',
    name: 'Kusubibi',
  },
  {
    id: '8204050019',
    districtId: '8204050',
    name: 'Kokotu',
  },
  {
    id: '8204050028',
    districtId: '8204050',
    name: 'Kotunang',
  },
  {
    id: '8204051001',
    districtId: '8204051',
    name: 'Kakupang',
  },
  {
    id: '8204051002',
    districtId: '8204051',
    name: 'Marikapal',
  },
  {
    id: '8204051003',
    districtId: '8204051',
    name: 'Bisori',
  },
  {
    id: '8204051004',
    districtId: '8204051',
    name: 'Doko',
  },
  {
    id: '8204051005',
    districtId: '8204051',
    name: 'Palamea',
  },
  {
    id: '8204051006',
    districtId: '8204051',
    name: 'Arumamang',
  },
  {
    id: '8204051007',
    districtId: '8204051',
    name: 'Lata Lata',
  },
  {
    id: '8204051008',
    districtId: '8204051',
    name: 'Sidanga',
  },
  {
    id: '8204051009',
    districtId: '8204051',
    name: 'Sengga Baru',
  },
  {
    id: '8204051010',
    districtId: '8204051',
    name: 'Imbu Imbu',
  },
  {
    id: '8204052001',
    districtId: '8204052',
    name: 'Tawa Bacan Barat',
  },
  {
    id: '8204052002',
    districtId: '8204052',
    name: 'Maritosu',
  },
  {
    id: '8204052003',
    districtId: '8204052',
    name: 'Loleo Jaya',
  },
  {
    id: '8204052004',
    districtId: '8204052',
    name: 'Koubalabala',
  },
  {
    id: '8204052005',
    districtId: '8204052',
    name: 'Loleo Mekar',
  },
  {
    id: '8204052006',
    districtId: '8204052',
    name: 'Kasiruta Dalam',
  },
  {
    id: '8204053001',
    districtId: '8204053',
    name: 'Sidopo',
  },
  {
    id: '8204053002',
    districtId: '8204053',
    name: 'Gorua Lolaro',
  },
  {
    id: '8204053003',
    districtId: '8204053',
    name: 'Nusa Babullah',
  },
  {
    id: '8204053004',
    districtId: '8204053',
    name: 'Jojame',
  },
  {
    id: '8204053005',
    districtId: '8204053',
    name: 'Yaba',
  },
  {
    id: '8204053006',
    districtId: '8204053',
    name: 'Geti Baru',
  },
  {
    id: '8204053007',
    districtId: '8204053',
    name: 'Geti Lama',
  },
  {
    id: '8204053008',
    districtId: '8204053',
    name: 'Gilalang',
  },
  {
    id: '8204060004',
    districtId: '8204060',
    name: 'Ligua',
  },
  {
    id: '8204060005',
    districtId: '8204060',
    name: 'Kida',
  },
  {
    id: '8204060006',
    districtId: '8204060',
    name: 'Buli',
  },
  {
    id: '8204060011',
    districtId: '8204060',
    name: 'Lelei',
  },
  {
    id: '8204060012',
    districtId: '8204060',
    name: 'Talimau',
  },
  {
    id: '8204060013',
    districtId: '8204060',
    name: 'Tawabi',
  },
  {
    id: '8204060015',
    districtId: '8204060',
    name: 'Guruapin',
  },
  {
    id: '8204060016',
    districtId: '8204060',
    name: 'Bajo',
  },
  {
    id: '8204060017',
    districtId: '8204060',
    name: 'Gunange',
  },
  {
    id: '8204060019',
    districtId: '8204060',
    name: 'Karamat',
  },
  {
    id: '8204060024',
    districtId: '8204060',
    name: 'Laigoma',
  },
  {
    id: '8204060025',
    districtId: '8204060',
    name: 'Gafi',
  },
  {
    id: '8204060026',
    districtId: '8204060',
    name: 'Siko',
  },
  {
    id: '8204060027',
    districtId: '8204060',
    name: 'Dorolamo',
  },
  {
    id: '8204061001',
    districtId: '8204061',
    name: 'Bokimiake',
  },
  {
    id: '8204061002',
    districtId: '8204061',
    name: 'Hatejawa',
  },
  {
    id: '8204061003',
    districtId: '8204061',
    name: 'Busua',
  },
  {
    id: '8204061004',
    districtId: '8204061',
    name: 'Fofao',
  },
  {
    id: '8204062001',
    districtId: '8204062',
    name: 'Sagawele',
  },
  {
    id: '8204062002',
    districtId: '8204062',
    name: 'Posi Posi',
  },
  {
    id: '8204062004',
    districtId: '8204062',
    name: 'Laluin',
  },
  {
    id: '8204062005',
    districtId: '8204062',
    name: 'Pasir Putih',
  },
  {
    id: '8204062006',
    districtId: '8204062',
    name: 'Orimakurunga',
  },
  {
    id: '8204063001',
    districtId: '8204063',
    name: 'Ake Jailolo',
  },
  {
    id: '8204063002',
    districtId: '8204063',
    name: 'Gayap',
  },
  {
    id: '8204063003',
    districtId: '8204063',
    name: 'Laromabati',
  },
  {
    id: '8204063004',
    districtId: '8204063',
    name: 'Modayama',
  },
  {
    id: '8204063005',
    districtId: '8204063',
    name: 'Ngokomalako',
  },
  {
    id: '8204063006',
    districtId: '8204063',
    name: 'Wayasipang',
  },
  {
    id: '8204070004',
    districtId: '8204070',
    name: 'Wailoa',
  },
  {
    id: '8204070005',
    districtId: '8204070',
    name: 'Gurua',
  },
  {
    id: '8204070006',
    districtId: '8204070',
    name: 'Dauri',
  },
  {
    id: '8204070007',
    districtId: '8204070',
    name: 'Ploili',
  },
  {
    id: '8204070008',
    districtId: '8204070',
    name: 'Samsuma',
  },
  {
    id: '8204070009',
    districtId: '8204070',
    name: 'Matangtengin',
  },
  {
    id: '8204070010',
    districtId: '8204070',
    name: 'Kyowor',
  },
  {
    id: '8204070011',
    districtId: '8204070',
    name: 'Rabutdaio',
  },
  {
    id: '8204070012',
    districtId: '8204070',
    name: 'Waigitang',
  },
  {
    id: '8204070017',
    districtId: '8204070',
    name: 'Sangapati',
  },
  {
    id: '8204070018',
    districtId: '8204070',
    name: 'Gitang',
  },
  {
    id: '8204070019',
    districtId: '8204070',
    name: 'Dalam',
  },
  {
    id: '8204070020',
    districtId: '8204070',
    name: 'Walo',
  },
  {
    id: '8204070021',
    districtId: '8204070',
    name: 'Gorup',
  },
  {
    id: '8204070022',
    districtId: '8204070',
    name: 'Kota',
  },
  {
    id: '8204071001',
    districtId: '8204071',
    name: 'Ombawa',
  },
  {
    id: '8204071002',
    districtId: '8204071',
    name: 'Bobawae',
  },
  {
    id: '8204071003',
    districtId: '8204071',
    name: 'Malapat',
  },
  {
    id: '8204071004',
    districtId: '8204071',
    name: 'Sebelei',
  },
  {
    id: '8204071005',
    districtId: '8204071',
    name: 'Talapao',
  },
  {
    id: '8204071006',
    districtId: '8204071',
    name: 'Mateketen',
  },
  {
    id: '8204071007',
    districtId: '8204071',
    name: 'Tegono',
  },
  {
    id: '8204080011',
    districtId: '8204080',
    name: 'Lemo Lemo',
  },
  {
    id: '8204080012',
    districtId: '8204080',
    name: 'Papaceda',
  },
  {
    id: '8204080013',
    districtId: '8204080',
    name: 'Oha',
  },
  {
    id: '8204080014',
    districtId: '8204080',
    name: 'Balitata',
  },
  {
    id: '8204080015',
    districtId: '8204080',
    name: 'Saketa',
  },
  {
    id: '8204080016',
    districtId: '8204080',
    name: 'Cango',
  },
  {
    id: '8204080017',
    districtId: '8204080',
    name: 'Koititi',
  },
  {
    id: '8204080018',
    districtId: '8204080',
    name: 'Doro',
  },
  {
    id: '8204080034',
    districtId: '8204080',
    name: 'Tabamasa',
  },
  {
    id: '8204080035',
    districtId: '8204080',
    name: 'Bumi Rahmat',
  },
  {
    id: '8204081001',
    districtId: '8204081',
    name: 'Dowora',
  },
  {
    id: '8204081003',
    districtId: '8204081',
    name: 'Yamly',
  },
  {
    id: '8204081004',
    districtId: '8204081',
    name: 'Gane Dalam',
  },
  {
    id: '8204081005',
    districtId: '8204081',
    name: 'Jibubu',
  },
  {
    id: '8204081006',
    districtId: '8204081',
    name: 'Awis',
  },
  {
    id: '8204081007',
    districtId: '8204081',
    name: 'Pasi Palele',
  },
  {
    id: '8204081008',
    districtId: '8204081',
    name: 'Tawa',
  },
  {
    id: '8204082001',
    districtId: '8204082',
    name: 'Boso',
  },
  {
    id: '8204082002',
    districtId: '8204082',
    name: 'Jikolamo',
  },
  {
    id: '8204082003',
    districtId: '8204082',
    name: 'Dolik',
  },
  {
    id: '8204082004',
    districtId: '8204082',
    name: 'Suka Damai',
  },
  {
    id: '8204082005',
    districtId: '8204082',
    name: 'Tokaka',
  },
  {
    id: '8204082006',
    districtId: '8204082',
    name: 'Nurjihat',
  },
  {
    id: '8204082007',
    districtId: '8204082',
    name: 'Moloku',
  },
  {
    id: '8204082008',
    districtId: '8204082',
    name: 'Samo',
  },
  {
    id: '8204082009',
    districtId: '8204082',
    name: 'Samat',
  },
  {
    id: '8204082010',
    districtId: '8204082',
    name: 'Posi Posi',
  },
  {
    id: '8204082011',
    districtId: '8204082',
    name: 'Gumira',
  },
  {
    id: '8204082012',
    districtId: '8204082',
    name: 'Batulak',
  },
  {
    id: '8204083001',
    districtId: '8204083',
    name: 'Gonone',
  },
  {
    id: '8204083002',
    districtId: '8204083',
    name: 'Pulau Gala',
  },
  {
    id: '8204083003',
    districtId: '8204083',
    name: 'Tawabi',
  },
  {
    id: '8204083004',
    districtId: '8204083',
    name: 'Kukupang',
  },
  {
    id: '8204083005',
    districtId: '8204083',
    name: 'Kurunga',
  },
  {
    id: '8204083006',
    districtId: '8204083',
    name: 'Yomen',
  },
  {
    id: '8204083007',
    districtId: '8204083',
    name: 'Liboba Hijrah',
  },
  {
    id: '8204090006',
    districtId: '8204090',
    name: 'Wosi',
  },
  {
    id: '8204090007',
    districtId: '8204090',
    name: 'Saketa',
  },
  {
    id: '8204090008',
    districtId: '8204090',
    name: 'Akelamo',
  },
  {
    id: '8204090009',
    districtId: '8204090',
    name: 'Bukit Indah',
  },
  {
    id: '8204090010',
    districtId: '8204090',
    name: 'Rawa Jaya',
  },
  {
    id: '8204090011',
    districtId: '8204090',
    name: 'Suka Maju',
  },
  {
    id: '8204090012',
    districtId: '8204090',
    name: 'Bukit Raya',
  },
  {
    id: '8204090013',
    districtId: '8204090',
    name: 'Sumber Makmur',
  },
  {
    id: '8204090014',
    districtId: '8204090',
    name: 'Lalubi',
  },
  {
    id: '8204090015',
    districtId: '8204090',
    name: 'Maffa',
  },
  {
    id: '8204090016',
    districtId: '8204090',
    name: 'Foya',
  },
  {
    id: '8204090017',
    districtId: '8204090',
    name: 'Tobaru',
  },
  {
    id: '8204090018',
    districtId: '8204090',
    name: 'Foya Tobaru',
  },
  {
    id: '8204090019',
    districtId: '8204090',
    name: 'Waimili',
  },
  {
    id: '8204090020',
    districtId: '8204090',
    name: 'Tanjung Jere',
  },
  {
    id: '8204090021',
    districtId: '8204090',
    name: 'Kebun Raja',
  },
  {
    id: '8204090022',
    districtId: '8204090',
    name: 'Kota Loow',
  },
  {
    id: '8204090024',
    districtId: '8204090',
    name: 'Cinta Damai',
  },
  {
    id: '8204091001',
    districtId: '8204091',
    name: 'Tabahidayah',
  },
  {
    id: '8204091002',
    districtId: '8204091',
    name: 'Luim',
  },
  {
    id: '8204091003',
    districtId: '8204091',
    name: 'Bisui',
  },
  {
    id: '8204091004',
    districtId: '8204091',
    name: 'Lelewi',
  },
  {
    id: '8204091005',
    districtId: '8204091',
    name: 'Tagea',
  },
  {
    id: '8204091006',
    districtId: '8204091',
    name: 'Matuting',
  },
  {
    id: '8204091007',
    districtId: '8204091',
    name: 'Matuting Tanjung',
  },
  {
    id: '8204091008',
    districtId: '8204091',
    name: 'Tabahijrah',
  },
  {
    id: '8204092001',
    districtId: '8204092',
    name: 'Gane Luar',
  },
  {
    id: '8204092002',
    districtId: '8204092',
    name: 'Ranga Ranga',
  },
  {
    id: '8204092003',
    districtId: '8204092',
    name: 'Kuwo',
  },
  {
    id: '8204092004',
    districtId: '8204092',
    name: 'Sawat',
  },
  {
    id: '8204092005',
    districtId: '8204092',
    name: 'Gaimu',
  },
  {
    id: '8205010009',
    districtId: '8205010',
    name: 'Tahane',
  },
  {
    id: '8205010011',
    districtId: '8205010',
    name: 'Matsa',
  },
  {
    id: '8205010013',
    districtId: '8205010',
    name: 'Ngofakiaha',
  },
  {
    id: '8205010014',
    districtId: '8205010',
    name: 'Samsuma',
  },
  {
    id: '8205010015',
    districtId: '8205010',
    name: 'Ngofagita',
  },
  {
    id: '8205010016',
    districtId: '8205010',
    name: 'Peleri',
  },
  {
    id: '8205010019',
    districtId: '8205010',
    name: 'Malapa',
  },
  {
    id: '8205010020',
    districtId: '8205010',
    name: 'Mailoa',
  },
  {
    id: '8205010021',
    districtId: '8205010',
    name: 'Ngofabobawa',
  },
  {
    id: '8205010022',
    districtId: '8205010',
    name: 'Soma',
  },
  {
    id: '8205010023',
    districtId: '8205010',
    name: 'Tagono',
  },
  {
    id: '8205010024',
    districtId: '8205010',
    name: 'Bobawa',
  },
  {
    id: '8205010025',
    districtId: '8205010',
    name: 'Tafasoho',
  },
  {
    id: '8205010026',
    districtId: '8205010',
    name: 'Talapao',
  },
  {
    id: '8205010027',
    districtId: '8205010',
    name: 'Sabale',
  },
  {
    id: '8205010028',
    districtId: '8205010',
    name: 'Tabobo',
  },
  {
    id: '8205010029',
    districtId: '8205010',
    name: 'Balisosang',
  },
  {
    id: '8205010030',
    districtId: '8205010',
    name: 'Sosol',
  },
  {
    id: '8205010031',
    districtId: '8205010',
    name: 'Gayok',
  },
  {
    id: '8205010032',
    districtId: '8205010',
    name: 'Wangeotak',
  },
  {
    id: '8205010033',
    districtId: '8205010',
    name: 'Bukit Tinggi',
  },
  {
    id: '8205010034',
    districtId: '8205010',
    name: 'Terpadu',
  },
  {
    id: '8205011001',
    districtId: '8205011',
    name: 'Pasir Putih',
  },
  {
    id: '8205011002',
    districtId: '8205011',
    name: 'Bobaneigo',
  },
  {
    id: '8205011003',
    districtId: '8205011',
    name: 'Tetewang',
  },
  {
    id: '8205011004',
    districtId: '8205011',
    name: 'Akelamo Kao',
  },
  {
    id: '8205011005',
    districtId: '8205011',
    name: 'Gamsungi',
  },
  {
    id: '8205011007',
    districtId: '8205011',
    name: 'Tiowor',
  },
  {
    id: '8205011008',
    districtId: '8205011',
    name: 'Tabanoma',
  },
  {
    id: '8205011009',
    districtId: '8205011',
    name: 'Kuntum Mekar',
  },
  {
    id: '8205011010',
    districtId: '8205011',
    name: 'Barumadehe',
  },
  {
    id: '8205011011',
    districtId: '8205011',
    name: 'Makaeling',
  },
  {
    id: '8205011012',
    districtId: '8205011',
    name: 'Toigo',
  },
  {
    id: '8205011013',
    districtId: '8205011',
    name: 'Akelamo Kao Cibok',
  },
  {
    id: '8205020004',
    districtId: '8205020',
    name: 'Kao',
  },
  {
    id: '8205020005',
    districtId: '8205020',
    name: 'Waringin Lelewi',
  },
  {
    id: '8205020006',
    districtId: '8205020',
    name: 'Jati',
  },
  {
    id: '8205020007',
    districtId: '8205020',
    name: 'Soasangaji Dim Dim',
  },
  {
    id: '8205020008',
    districtId: '8205020',
    name: 'Sasur',
  },
  {
    id: '8205020010',
    districtId: '8205020',
    name: 'Popon',
  },
  {
    id: '8205020021',
    districtId: '8205020',
    name: 'Patang',
  },
  {
    id: '8205020022',
    districtId: '8205020',
    name: 'Biang',
  },
  {
    id: '8205020025',
    districtId: '8205020',
    name: 'Waringin Lamo',
  },
  {
    id: '8205020026',
    districtId: '8205020',
    name: 'Goruang',
  },
  {
    id: '8205020027',
    districtId: '8205020',
    name: 'Kusu Lovra',
  },
  {
    id: '8205020028',
    districtId: '8205020',
    name: 'Sumber Agung',
  },
  {
    id: '8205021001',
    districtId: '8205021',
    name: 'Momoda',
  },
  {
    id: '8205021002',
    districtId: '8205021',
    name: 'Ngoali',
  },
  {
    id: '8205021003',
    districtId: '8205021',
    name: 'Gagaapok',
  },
  {
    id: '8205021004',
    districtId: '8205021',
    name: 'Makarti',
  },
  {
    id: '8205021005',
    districtId: '8205021',
    name: 'Toliwang',
  },
  {
    id: '8205021006',
    districtId: '8205021',
    name: 'Tolabit',
  },
  {
    id: '8205021007',
    districtId: '8205021',
    name: 'Tuguis',
  },
  {
    id: '8205021008',
    districtId: '8205021',
    name: 'Sangaji Jaya',
  },
  {
    id: '8205021009',
    districtId: '8205021',
    name: 'Soa Hukum',
  },
  {
    id: '8205021010',
    districtId: '8205021',
    name: 'Lelesang',
  },
  {
    id: '8205021011',
    districtId: '8205021',
    name: 'Kai',
  },
  {
    id: '8205021012',
    districtId: '8205021',
    name: 'Pitago',
  },
  {
    id: '8205021013',
    districtId: '8205021',
    name: 'Soamaetek',
  },
  {
    id: '8205021014',
    districtId: '8205021',
    name: 'Bailengit',
  },
  {
    id: '8205021015',
    districtId: '8205021',
    name: 'Parseba',
  },
  {
    id: '8205021016',
    districtId: '8205021',
    name: 'Toboulamo',
  },
  {
    id: '8205021017',
    districtId: '8205021',
    name: 'Torawat',
  },
  {
    id: '8205021018',
    districtId: '8205021',
    name: 'Takimo',
  },
  {
    id: '8205021019',
    districtId: '8205021',
    name: 'Wonosari',
  },
  {
    id: '8205021020',
    districtId: '8205021',
    name: 'Beringin Agung',
  },
  {
    id: '8205021021',
    districtId: '8205021',
    name: 'Margo Mulyo',
  },
  {
    id: '8205022001',
    districtId: '8205022',
    name: 'Gamlaha',
  },
  {
    id: '8205022002',
    districtId: '8205022',
    name: 'Doro',
  },
  {
    id: '8205022003',
    districtId: '8205022',
    name: 'Boulamo',
  },
  {
    id: '8205022004',
    districtId: '8205022',
    name: 'Daru',
  },
  {
    id: '8205022005',
    districtId: '8205022',
    name: 'Bobale',
  },
  {
    id: '8205022006',
    districtId: '8205022',
    name: 'Bori',
  },
  {
    id: '8205022007',
    districtId: '8205022',
    name: 'Pediwang',
  },
  {
    id: '8205022008',
    districtId: '8205022',
    name: 'Wateto',
  },
  {
    id: '8205022009',
    districtId: '8205022',
    name: 'Tunuo',
  },
  {
    id: '8205022010',
    districtId: '8205022',
    name: 'Gulo',
  },
  {
    id: '8205022011',
    districtId: '8205022',
    name: 'Warudu',
  },
  {
    id: '8205022012',
    districtId: '8205022',
    name: 'Dowongi Maiti',
  },
  {
    id: '8205030008',
    districtId: '8205030',
    name: 'Leleoto',
  },
  {
    id: '8205030009',
    districtId: '8205030',
    name: 'Paca',
  },
  {
    id: '8205030010',
    districtId: '8205030',
    name: 'Tobe',
  },
  {
    id: '8205030011',
    districtId: '8205030',
    name: 'Kupa Kupa',
  },
  {
    id: '8205030012',
    districtId: '8205030',
    name: 'Toma Halu',
  },
  {
    id: '8205030013',
    districtId: '8205030',
    name: 'Efi Efi',
  },
  {
    id: '8205030014',
    districtId: '8205030',
    name: 'Gamhoku',
  },
  {
    id: '8205030015',
    districtId: '8205030',
    name: 'Talaga Paca',
  },
  {
    id: '8205030016',
    districtId: '8205030',
    name: 'Lemah Ino',
  },
  {
    id: '8205030017',
    districtId: '8205030',
    name: 'Kupa Kupa Selatan',
  },
  {
    id: '8205030018',
    districtId: '8205030',
    name: 'Kakara B',
  },
  {
    id: '8205030019',
    districtId: '8205030',
    name: 'Tioua',
  },
  {
    id: '8205030020',
    districtId: '8205030',
    name: 'Pale',
  },
  {
    id: '8205031001',
    districtId: '8205031',
    name: 'Kusuri',
  },
  {
    id: '8205031002',
    districtId: '8205031',
    name: 'Sukamaju',
  },
  {
    id: '8205031003',
    districtId: '8205031',
    name: 'Togoliua',
  },
  {
    id: '8205031004',
    districtId: '8205031',
    name: 'Birinoa',
  },
  {
    id: '8205031005',
    districtId: '8205031',
    name: 'Wangongira',
  },
  {
    id: '8205031006',
    districtId: '8205031',
    name: 'UPT Togoliua',
  },
  {
    id: '8205032001',
    districtId: '8205032',
    name: 'Katana',
  },
  {
    id: '8205032002',
    districtId: '8205032',
    name: 'Gonga',
  },
  {
    id: '8205032003',
    districtId: '8205032',
    name: 'Meti',
  },
  {
    id: '8205032004',
    districtId: '8205032',
    name: 'Mawea',
  },
  {
    id: '8205032005',
    districtId: '8205032',
    name: 'Todokuiha',
  },
  {
    id: '8205032006',
    districtId: '8205032',
    name: 'Yaro',
  },
  {
    id: '8205040018',
    districtId: '8205040',
    name: 'Gamsungi',
  },
  {
    id: '8205040019',
    districtId: '8205040',
    name: 'Kumo',
  },
  {
    id: '8205040020',
    districtId: '8205040',
    name: 'Gura',
  },
  {
    id: '8205040021',
    districtId: '8205040',
    name: 'Kakara A',
  },
  {
    id: '8205040022',
    districtId: '8205040',
    name: 'Wari',
  },
  {
    id: '8205040024',
    districtId: '8205040',
    name: 'Rawajaya',
  },
  {
    id: '8205040025',
    districtId: '8205040',
    name: 'Gosoma',
  },
  {
    id: '8205040026',
    districtId: '8205040',
    name: 'Wari Ino',
  },
  {
    id: '8205040032',
    districtId: '8205040',
    name: 'Tagalaya',
  },
  {
    id: '8205041001',
    districtId: '8205041',
    name: 'Kaliupa',
  },
  {
    id: '8205041002',
    districtId: '8205041',
    name: 'Upa',
  },
  {
    id: '8205041003',
    districtId: '8205041',
    name: 'Pitu',
  },
  {
    id: '8205041004',
    districtId: '8205041',
    name: 'Lina Ino',
  },
  {
    id: '8205041005',
    districtId: '8205041',
    name: 'Kalipitu',
  },
  {
    id: '8205041006',
    districtId: '8205041',
    name: 'W K O',
  },
  {
    id: '8205041007',
    districtId: '8205041',
    name: 'Mahia',
  },
  {
    id: '8205041008',
    districtId: '8205041',
    name: 'Wosia',
  },
  {
    id: '8205041009',
    districtId: '8205041',
    name: 'Tanjung Niara',
  },
  {
    id: '8205042001',
    districtId: '8205042',
    name: 'Gorua Selatan',
  },
  {
    id: '8205042002',
    districtId: '8205042',
    name: 'Gorua',
  },
  {
    id: '8205042003',
    districtId: '8205042',
    name: 'Gorua Utara',
  },
  {
    id: '8205042004',
    districtId: '8205042',
    name: 'Popilo',
  },
  {
    id: '8205042005',
    districtId: '8205042',
    name: 'Popilo Utara',
  },
  {
    id: '8205042006',
    districtId: '8205042',
    name: 'Kokota Jaya',
  },
  {
    id: '8205042007',
    districtId: '8205042',
    name: 'Ruko',
  },
  {
    id: '8205042008',
    districtId: '8205042',
    name: 'Luari',
  },
  {
    id: '8205042009',
    districtId: '8205042',
    name: 'Tolonuo Selatan',
  },
  {
    id: '8205042010',
    districtId: '8205042',
    name: 'Tolonuo',
  },
  {
    id: '8205050005',
    districtId: '8205050',
    name: 'Mamuya',
  },
  {
    id: '8205050007',
    districtId: '8205050',
    name: 'Soa Sio',
  },
  {
    id: '8205050008',
    districtId: '8205050',
    name: 'Toweka',
  },
  {
    id: '8205050009',
    districtId: '8205050',
    name: 'Barataku',
  },
  {
    id: '8205050010',
    districtId: '8205050',
    name: 'Towara',
  },
  {
    id: '8205050011',
    districtId: '8205050',
    name: 'Simau',
  },
  {
    id: '8205051001',
    districtId: '8205051',
    name: 'Bale',
  },
  {
    id: '8205051002',
    districtId: '8205051',
    name: 'Ori',
  },
  {
    id: '8205051003',
    districtId: '8205051',
    name: 'Igobula',
  },
  {
    id: '8205051004',
    districtId: '8205051',
    name: 'Soakonora',
  },
  {
    id: '8205051005',
    districtId: '8205051',
    name: 'Togawa',
  },
  {
    id: '8205051006',
    districtId: '8205051',
    name: 'Togawa Besi',
  },
  {
    id: '8205051007',
    districtId: '8205051',
    name: 'Seki',
  },
  {
    id: '8205052001',
    districtId: '8205052',
    name: 'Samuda',
  },
  {
    id: '8205052002',
    districtId: '8205052',
    name: 'Soatobaru',
  },
  {
    id: '8205052003',
    districtId: '8205052',
    name: 'Roko',
  },
  {
    id: '8205052004',
    districtId: '8205052',
    name: 'Dokulamo',
  },
  {
    id: '8205052005',
    districtId: '8205052',
    name: 'Kira',
  },
  {
    id: '8205052006',
    districtId: '8205052',
    name: 'Duma',
  },
  {
    id: '8205052007',
    districtId: '8205052',
    name: 'Gotalamo',
  },
  {
    id: '8205052008',
    districtId: '8205052',
    name: 'Makete',
  },
  {
    id: '8205052009',
    districtId: '8205052',
    name: 'Ngidiho',
  },
  {
    id: '8205053001',
    districtId: '8205053',
    name: 'Limau',
  },
  {
    id: '8205053002',
    districtId: '8205053',
    name: 'Lalonga',
  },
  {
    id: '8205053003',
    districtId: '8205053',
    name: 'Bobi Singo',
  },
  {
    id: '8205053004',
    districtId: '8205053',
    name: 'Dodowo',
  },
  {
    id: '8205053005',
    districtId: '8205053',
    name: 'Salimuli',
  },
  {
    id: '8205053006',
    districtId: '8205053',
    name: 'Tutumaloleo',
  },
  {
    id: '8205053007',
    districtId: '8205053',
    name: 'Togasa',
  },
  {
    id: '8205053008',
    districtId: '8205053',
    name: 'Saluta',
  },
  {
    id: '8205053009',
    districtId: '8205053',
    name: 'Pelita',
  },
  {
    id: '8205053010',
    districtId: '8205053',
    name: 'Beringin Jaya',
  },
  {
    id: '8205053012',
    districtId: '8205053',
    name: 'Jere Tua',
  },
  {
    id: '8205060001',
    districtId: '8205060',
    name: 'Apulea',
  },
  {
    id: '8205060002',
    districtId: '8205060',
    name: 'Asimiro',
  },
  {
    id: '8205060003',
    districtId: '8205060',
    name: 'Dotia',
  },
  {
    id: '8205060004',
    districtId: '8205060',
    name: 'Ngajam',
  },
  {
    id: '8205060005',
    districtId: '8205060',
    name: 'Dorume',
  },
  {
    id: '8205060006',
    districtId: '8205060',
    name: 'Kailupa',
  },
  {
    id: '8205060007',
    districtId: '8205060',
    name: 'Gisik',
  },
  {
    id: '8205060008',
    districtId: '8205060',
    name: 'Kapa Kapa',
  },
  {
    id: '8205060009',
    districtId: '8205060',
    name: 'Pocao',
  },
  {
    id: '8205060010',
    districtId: '8205060',
    name: 'Tate',
  },
  {
    id: '8205060012',
    districtId: '8205060',
    name: 'Posi Posi',
  },
  {
    id: '8205060013',
    districtId: '8205060',
    name: 'Momojiu',
  },
  {
    id: '8205060014',
    districtId: '8205060',
    name: 'Worimoi',
  },
  {
    id: '8205060015',
    districtId: '8205060',
    name: 'Galao',
  },
  {
    id: '8205060017',
    districtId: '8205060',
    name: 'Podol',
  },
  {
    id: '8205060018',
    districtId: '8205060',
    name: 'Igo',
  },
  {
    id: '8205061001',
    districtId: '8205061',
    name: 'Tobo Tobo',
  },
  {
    id: '8205061002',
    districtId: '8205061',
    name: 'Fitako',
  },
  {
    id: '8205061003',
    districtId: '8205061',
    name: 'Dedeta',
  },
  {
    id: '8205061004',
    districtId: '8205061',
    name: 'Dagasuli',
  },
  {
    id: '8205061005',
    districtId: '8205061',
    name: 'Jikolamo',
  },
  {
    id: '8205061006',
    districtId: '8205061',
    name: 'Tua Kara',
  },
  {
    id: '8205061007',
    districtId: '8205061',
    name: 'Dama',
  },
  {
    id: '8205061008',
    districtId: '8205061',
    name: 'Dowonggila',
  },
  {
    id: '8205061009',
    districtId: '8205061',
    name: 'Cera',
  },
  {
    id: '8205061010',
    districtId: '8205061',
    name: 'Salube',
  },
  {
    id: '8206010001',
    districtId: '8206010',
    name: 'Bicoli',
  },
  {
    id: '8206010002',
    districtId: '8206010',
    name: 'Waci',
  },
  {
    id: '8206010004',
    districtId: '8206010',
    name: 'Loleolamo',
  },
  {
    id: '8206010005',
    districtId: '8206010',
    name: 'Gotowasi',
  },
  {
    id: '8206010006',
    districtId: '8206010',
    name: 'Kasuba',
  },
  {
    id: '8206010007',
    districtId: '8206010',
    name: 'Momole',
  },
  {
    id: '8206010008',
    districtId: '8206010',
    name: 'Sil',
  },
  {
    id: '8206010009',
    districtId: '8206010',
    name: 'Sowoli',
  },
  {
    id: '8206011001',
    districtId: '8206011',
    name: 'Maba Sangaji',
  },
  {
    id: '8206011002',
    districtId: '8206011',
    name: 'Soa Gimalaha',
  },
  {
    id: '8206011003',
    districtId: '8206011',
    name: 'Wailukum',
  },
  {
    id: '8206011004',
    districtId: '8206011',
    name: 'Soa Sangaji',
  },
  {
    id: '8206011005',
    districtId: '8206011',
    name: 'Soa Laipoh',
  },
  {
    id: '8206011006',
    districtId: '8206011',
    name: 'Tewil',
  },
  {
    id: '8206020001',
    districtId: '8206020',
    name: 'Nusa Ambu',
  },
  {
    id: '8206020002',
    districtId: '8206020',
    name: 'Pintatu',
  },
  {
    id: '8206020003',
    districtId: '8206020',
    name: 'Binagara',
  },
  {
    id: '8206020004',
    districtId: '8206020',
    name: 'Nusa Jaya',
  },
  {
    id: '8206020005',
    districtId: '8206020',
    name: 'Minamin',
  },
  {
    id: '8206020006',
    districtId: '8206020',
    name: 'Waijoi',
  },
  {
    id: '8206020007',
    districtId: '8206020',
    name: 'Saramaake',
  },
  {
    id: '8206020008',
    districtId: '8206020',
    name: 'Wasile',
  },
  {
    id: '8206020009',
    districtId: '8206020',
    name: 'Fayaul',
  },
  {
    id: '8206020010',
    districtId: '8206020',
    name: 'Tomares',
  },
  {
    id: '8206020011',
    districtId: '8206020',
    name: 'Tabanalou',
  },
  {
    id: '8206020012',
    districtId: '8206020',
    name: 'Saolat',
  },
  {
    id: '8206020013',
    districtId: '8206020',
    name: 'Loleba',
  },
  {
    id: '8206020014',
    districtId: '8206020',
    name: 'Nanas',
  },
  {
    id: '8206020015',
    districtId: '8206020',
    name: 'Sondo-Sondo',
  },
  {
    id: '8206020016',
    districtId: '8206020',
    name: 'Talaga Jaya',
  },
  {
    id: '8206020017',
    districtId: '8206020',
    name: 'Ake Jawi',
  },
  {
    id: '8206020018',
    districtId: '8206020',
    name: 'Ino Jaya',
  },
  {
    id: '8206020019',
    districtId: '8206020',
    name: 'Jikomoi',
  },
  {
    id: '8206020020',
    districtId: '8206020',
    name: 'Yawal',
  },
  {
    id: '8206020021',
    districtId: '8206020',
    name: 'Tanure',
  },
  {
    id: '8206020022',
    districtId: '8206020',
    name: 'Ekor',
  },
  {
    id: '8206020023',
    districtId: '8206020',
    name: 'Ekorino',
  },
  {
    id: '8206020024',
    districtId: '8206020',
    name: 'Bukutio',
  },
  {
    id: '8206030010',
    districtId: '8206030',
    name: 'Subaim',
  },
  {
    id: '8206030011',
    districtId: '8206030',
    name: 'Cemara Jaya',
  },
  {
    id: '8206030012',
    districtId: '8206030',
    name: 'Bumi Restu',
  },
  {
    id: '8206030013',
    districtId: '8206030',
    name: 'Batu Raja',
  },
  {
    id: '8206030014',
    districtId: '8206030',
    name: 'Mekar Sari',
  },
  {
    id: '8206030015',
    districtId: '8206030',
    name: 'Gulapapo',
  },
  {
    id: '8206030016',
    districtId: '8206030',
    name: 'Waisuba',
  },
  {
    id: '8206031001',
    districtId: '8206031',
    name: 'Daka Ino',
  },
  {
    id: '8206031002',
    districtId: '8206031',
    name: 'Ake Daga',
  },
  {
    id: '8206031003',
    districtId: '8206031',
    name: 'Toboino',
  },
  {
    id: '8206031004',
    districtId: '8206031',
    name: 'Dodaga',
  },
  {
    id: '8206031005',
    districtId: '8206031',
    name: 'Tutuling Jaya',
  },
  {
    id: '8206031006',
    districtId: '8206031',
    name: 'Woka Jaya',
  },
  {
    id: '8206031007',
    districtId: '8206031',
    name: 'Rawamangun',
  },
  {
    id: '8206031008',
    districtId: '8206031',
    name: 'Sidomulyo',
  },
  {
    id: '8206032001',
    districtId: '8206032',
    name: 'Lolobata',
  },
  {
    id: '8206032002',
    districtId: '8206032',
    name: 'Hatetabako',
  },
  {
    id: '8206032003',
    districtId: '8206032',
    name: 'Puao',
  },
  {
    id: '8206032004',
    districtId: '8206032',
    name: 'Kakaraino',
  },
  {
    id: '8206032005',
    districtId: '8206032',
    name: 'Foli',
  },
  {
    id: '8206032006',
    districtId: '8206032',
    name: 'Nyaolako',
  },
  {
    id: '8206032007',
    districtId: '8206032',
    name: 'Bokimaake',
  },
  {
    id: '8206032008',
    districtId: '8206032',
    name: 'Silalayang',
  },
  {
    id: '8206033001',
    districtId: '8206033',
    name: 'Iga',
  },
  {
    id: '8206033002',
    districtId: '8206033',
    name: 'Labi Labi',
  },
  {
    id: '8206033003',
    districtId: '8206033',
    name: 'Tatam',
  },
  {
    id: '8206033004',
    districtId: '8206033',
    name: 'Marimoi',
  },
  {
    id: '8206033005',
    districtId: '8206033',
    name: 'Bololo',
  },
  {
    id: '8206033006',
    districtId: '8206033',
    name: 'Hilaitetor',
  },
  {
    id: '8206033007',
    districtId: '8206033',
    name: 'Dowongi Jaya',
  },
  {
    id: '8206033008',
    districtId: '8206033',
    name: 'Majiko Tongone',
  },
  {
    id: '8206040010',
    districtId: '8206040',
    name: 'Buli Asal',
  },
  {
    id: '8206040011',
    districtId: '8206040',
    name: 'Buli Karya',
  },
  {
    id: '8206040012',
    districtId: '8206040',
    name: 'Buli',
  },
  {
    id: '8206040013',
    districtId: '8206040',
    name: 'Wayafli',
  },
  {
    id: '8206040014',
    districtId: '8206040',
    name: 'Sailal',
  },
  {
    id: '8206040015',
    districtId: '8206040',
    name: 'Geltoli',
  },
  {
    id: '8206040016',
    districtId: '8206040',
    name: 'Pekaulang',
  },
  {
    id: '8206040017',
    districtId: '8206040',
    name: 'Teluk Buli',
  },
  {
    id: '8206040018',
    districtId: '8206040',
    name: 'Gamesan',
  },
  {
    id: '8206040019',
    districtId: '8206040',
    name: 'Baburino',
  },
  {
    id: '8206041001',
    districtId: '8206041',
    name: 'Beringin Lamo',
  },
  {
    id: '8206041002',
    districtId: '8206041',
    name: 'Bebsili',
  },
  {
    id: '8206041004',
    districtId: '8206041',
    name: 'Wayamli',
  },
  {
    id: '8206041006',
    districtId: '8206041',
    name: 'Miaf',
  },
  {
    id: '8206041007',
    districtId: '8206041',
    name: 'Maratana Jaya',
  },
  {
    id: '8206041008',
    districtId: '8206041',
    name: 'Dorolamo Jaya',
  },
  {
    id: '8206041009',
    districtId: '8206041',
    name: 'Bangul',
  },
  {
    id: '8206041010',
    districtId: '8206041',
    name: 'Marasipno',
  },
  {
    id: '8206041011',
    districtId: '8206041',
    name: 'Babasaram',
  },
  {
    id: '8206041012',
    districtId: '8206041',
    name: 'Yawanli',
  },
  {
    id: '8206041013',
    districtId: '8206041',
    name: 'Tatangapu',
  },
  {
    id: '8206041014',
    districtId: '8206041',
    name: 'Gaifoli',
  },
  {
    id: '8206042001',
    districtId: '8206042',
    name: 'Sosolat',
  },
  {
    id: '8206042002',
    districtId: '8206042',
    name: 'Lolasita',
  },
  {
    id: '8206042003',
    districtId: '8206042',
    name: 'Dorosago',
  },
  {
    id: '8206042004',
    districtId: '8206042',
    name: 'Wasileo',
  },
  {
    id: '8206042005',
    districtId: '8206042',
    name: 'Patlian',
  },
  {
    id: '8206042006',
    districtId: '8206042',
    name: 'Pumlanga',
  },
  {
    id: '8206042007',
    districtId: '8206042',
    name: 'Jara Jara',
  },
  {
    id: '8206042008',
    districtId: '8206042',
    name: 'UPT Patlian Sp I',
  },
  {
    id: '8206042009',
    districtId: '8206042',
    name: 'UPT Patlian Sp II',
  },
  {
    id: '8206042010',
    districtId: '8206042',
    name: 'Lili',
  },
  {
    id: '8206042011',
    districtId: '8206042',
    name: 'Doromoi',
  },
  {
    id: '8206042012',
    districtId: '8206042',
    name: 'Patlean Jaya',
  },
  {
    id: '8207010001',
    districtId: '8207010',
    name: 'Juanga',
  },
  {
    id: '8207010002',
    districtId: '8207010',
    name: 'Pandanga',
  },
  {
    id: '8207010003',
    districtId: '8207010',
    name: 'Daruba',
  },
  {
    id: '8207010004',
    districtId: '8207010',
    name: 'Yayasan',
  },
  {
    id: '8207010005',
    districtId: '8207010',
    name: 'Kolorai',
  },
  {
    id: '8207010006',
    districtId: '8207010',
    name: 'Galo Galo',
  },
  {
    id: '8207010007',
    districtId: '8207010',
    name: 'Pilowo',
  },
  {
    id: '8207010008',
    districtId: '8207010',
    name: 'Darame',
  },
  {
    id: '8207010009',
    districtId: '8207010',
    name: 'Gotalamo',
  },
  {
    id: '8207010010',
    districtId: '8207010',
    name: 'Muhajirin',
  },
  {
    id: '8207010011',
    districtId: '8207010',
    name: 'Wawama',
  },
  {
    id: '8207010012',
    districtId: '8207010',
    name: 'Totodoku',
  },
  {
    id: '8207010013',
    districtId: '8207010',
    name: 'Joubela',
  },
  {
    id: '8207010014',
    districtId: '8207010',
    name: 'Mandiri',
  },
  {
    id: '8207010015',
    districtId: '8207010',
    name: 'Dehegila',
  },
  {
    id: '8207010016',
    districtId: '8207010',
    name: 'Aha',
  },
  {
    id: '8207010017',
    districtId: '8207010',
    name: 'Momojiu',
  },
  {
    id: '8207010018',
    districtId: '8207010',
    name: 'Sabatai Baru',
  },
  {
    id: '8207010019',
    districtId: '8207010',
    name: 'Sabatai Tua',
  },
  {
    id: '8207010020',
    districtId: '8207010',
    name: 'Daeo',
  },
  {
    id: '8207010021',
    districtId: '8207010',
    name: 'Falila',
  },
  {
    id: '8207010022',
    districtId: '8207010',
    name: 'Morodadi',
  },
  {
    id: '8207010023',
    districtId: '8207010',
    name: 'Nakamura',
  },
  {
    id: '8207010024',
    districtId: '8207010',
    name: 'Sabala',
  },
  {
    id: '8207010025',
    districtId: '8207010',
    name: 'Daeo Majiko',
  },
  {
    id: '8207020001',
    districtId: '8207020',
    name: 'Sambiki',
  },
  {
    id: '8207020002',
    districtId: '8207020',
    name: 'Sambiki Baru',
  },
  {
    id: '8207020003',
    districtId: '8207020',
    name: 'Sangowo',
  },
  {
    id: '8207020004',
    districtId: '8207020',
    name: 'Mira',
  },
  {
    id: '8207020005',
    districtId: '8207020',
    name: 'Rahmat',
  },
  {
    id: '8207020006',
    districtId: '8207020',
    name: 'Wewemo',
  },
  {
    id: '8207020007',
    districtId: '8207020',
    name: 'Buho Buho',
  },
  {
    id: '8207020008',
    districtId: '8207020',
    name: 'Lifao',
  },
  {
    id: '8207020009',
    districtId: '8207020',
    name: 'Gamlamo',
  },
  {
    id: '8207020010',
    districtId: '8207020',
    name: 'Sangowo Barat',
  },
  {
    id: '8207020011',
    districtId: '8207020',
    name: 'Sangowo Timur',
  },
  {
    id: '8207020012',
    districtId: '8207020',
    name: 'Doku Mira',
  },
  {
    id: '8207020013',
    districtId: '8207020',
    name: 'Gosoma Maluku',
  },
  {
    id: '8207020014',
    districtId: '8207020',
    name: 'Hino',
  },
  {
    id: '8207020015',
    districtId: '8207020',
    name: 'Seseli Jaya',
  },
  {
    id: '8207030001',
    districtId: '8207030',
    name: 'Waringin',
  },
  {
    id: '8207030002',
    districtId: '8207030',
    name: 'Aru Irian',
  },
  {
    id: '8207030003',
    districtId: '8207030',
    name: 'Cocomare',
  },
  {
    id: '8207030004',
    districtId: '8207030',
    name: 'Ngele Ngele Kecil',
  },
  {
    id: '8207030005',
    districtId: '8207030',
    name: 'Usbar Pantai',
  },
  {
    id: '8207030006',
    districtId: '8207030',
    name: 'Ngele Ngele Besar',
  },
  {
    id: '8207030007',
    districtId: '8207030',
    name: 'Raja',
  },
  {
    id: '8207030008',
    districtId: '8207030',
    name: 'Tiley',
  },
  {
    id: '8207030009',
    districtId: '8207030',
    name: 'Wayabula',
  },
  {
    id: '8207030011',
    districtId: '8207030',
    name: 'Cio Gerong',
  },
  {
    id: '8207030012',
    districtId: '8207030',
    name: 'Cio Dalam',
  },
  {
    id: '8207030013',
    districtId: '8207030',
    name: 'Saminyamau',
  },
  {
    id: '8207030014',
    districtId: '8207030',
    name: 'Posi Posi Rao',
  },
  {
    id: '8207030015',
    districtId: '8207030',
    name: 'Leo Leo',
  },
  {
    id: '8207030016',
    districtId: '8207030',
    name: 'Aru Burung',
  },
  {
    id: '8207030017',
    districtId: '8207030',
    name: 'Lou Madoro',
  },
  {
    id: '8207030018',
    districtId: '8207030',
    name: 'Tiley Pantai',
  },
  {
    id: '8207030019',
    districtId: '8207030',
    name: 'Bobula',
  },
  {
    id: '8207030020',
    districtId: '8207030',
    name: 'Cio Maloleo',
  },
  {
    id: '8207040001',
    districtId: '8207040',
    name: 'Libano',
  },
  {
    id: '8207040002',
    districtId: '8207040',
    name: 'Hapo',
  },
  {
    id: '8207040003',
    districtId: '8207040',
    name: 'Titigogoli',
  },
  {
    id: '8207040004',
    districtId: '8207040',
    name: 'Bere Bere Kecil',
  },
  {
    id: '8207040005',
    districtId: '8207040',
    name: 'Sopi',
  },
  {
    id: '8207040006',
    districtId: '8207040',
    name: 'Cendana',
  },
  {
    id: '8207040007',
    districtId: '8207040',
    name: 'Aru',
  },
  {
    id: '8207040008',
    districtId: '8207040',
    name: 'Pangeo',
  },
  {
    id: '8207040009',
    districtId: '8207040',
    name: 'Towara',
  },
  {
    id: '8207040010',
    districtId: '8207040',
    name: 'Cempaka',
  },
  {
    id: '8207040011',
    districtId: '8207040',
    name: 'Podimor Padange',
  },
  {
    id: '8207040012',
    districtId: '8207040',
    name: 'Sopi Majiko',
  },
  {
    id: '8207040013',
    districtId: '8207040',
    name: 'Loleo',
  },
  {
    id: '8207040014',
    districtId: '8207040',
    name: 'Gorugo',
  },
  {
    id: '8207050001',
    districtId: '8207050',
    name: 'Bido',
  },
  {
    id: '8207050002',
    districtId: '8207050',
    name: 'Yao',
  },
  {
    id: '8207050003',
    districtId: '8207050',
    name: 'Tawakali',
  },
  {
    id: '8207050004',
    districtId: '8207050',
    name: 'Sakita',
  },
  {
    id: '8207050005',
    districtId: '8207050',
    name: 'Leleo Jaya',
  },
  {
    id: '8207050006',
    districtId: '8207050',
    name: 'Kenari',
  },
  {
    id: '8207050008',
    districtId: '8207050',
    name: 'Losuo',
  },
  {
    id: '8207050009',
    districtId: '8207050',
    name: 'Korago',
  },
  {
    id: '8207050010',
    districtId: '8207050',
    name: 'Gorua',
  },
  {
    id: '8207050011',
    districtId: '8207050',
    name: 'Tanjung Saleh',
  },
  {
    id: '8207050012',
    districtId: '8207050',
    name: 'Goa Hira',
  },
  {
    id: '8207050013',
    districtId: '8207050',
    name: 'Maba',
  },
  {
    id: '8207050014',
    districtId: '8207050',
    name: 'Gorua Selatan',
  },
  {
    id: '8208010001',
    districtId: '8208010',
    name: 'Pancoran',
  },
  {
    id: '8208010002',
    districtId: '8208010',
    name: 'Tallo',
  },
  {
    id: '8208010003',
    districtId: '8208010',
    name: 'Ratahaya',
  },
  {
    id: '8208010004',
    districtId: '8208010',
    name: 'Wayo',
  },
  {
    id: '8208010006',
    districtId: '8208010',
    name: 'Bobong',
  },
  {
    id: '8208010007',
    districtId: '8208010',
    name: 'Maranti Jaya',
  },
  {
    id: '8208010008',
    districtId: '8208010',
    name: 'Kilong',
  },
  {
    id: '8208010009',
    districtId: '8208010',
    name: 'Karamat',
  },
  {
    id: '8208010010',
    districtId: '8208010',
    name: 'Holbota',
  },
  {
    id: '8208010011',
    districtId: '8208010',
    name: 'Kawalo',
  },
  {
    id: '8208010012',
    districtId: '8208010',
    name: 'Woyo',
  },
  {
    id: '8208010013',
    districtId: '8208010',
    name: 'Lohobuba',
  },
  {
    id: '8208010014',
    districtId: '8208010',
    name: 'Limbo',
  },
  {
    id: '8208020001',
    districtId: '8208020',
    name: 'Nggoli',
  },
  {
    id: '8208020002',
    districtId: '8208020',
    name: 'Bahu',
  },
  {
    id: '8208020003',
    districtId: '8208020',
    name: 'Bapenu',
  },
  {
    id: '8208020004',
    districtId: '8208020',
    name: 'Galebo',
  },
  {
    id: '8208020005',
    districtId: '8208020',
    name: 'Kilo',
  },
  {
    id: '8208020006',
    districtId: '8208020',
    name: 'Sumbong',
  },
  {
    id: '8208020007',
    districtId: '8208020',
    name: 'Nggaki',
  },
  {
    id: '8208020008',
    districtId: '8208020',
    name: 'Pencado',
  },
  {
    id: '8208020009',
    districtId: '8208020',
    name: 'Maluli',
  },
  {
    id: '8208030001',
    districtId: '8208030',
    name: 'Wolio',
  },
  {
    id: '8208030002',
    districtId: '8208030',
    name: 'Habunuha',
  },
  {
    id: '8208030003',
    districtId: '8208030',
    name: 'Fayaunana',
  },
  {
    id: '8208030005',
    districtId: '8208030',
    name: 'Tabona',
  },
  {
    id: '8208030006',
    districtId: '8208030',
    name: 'Kataga',
  },
  {
    id: '8208030007',
    districtId: '8208030',
    name: 'Kabunu',
  },
  {
    id: '8208040001',
    districtId: '8208040',
    name: 'Sofan',
  },
  {
    id: '8208040002',
    districtId: '8208040',
    name: 'Kawadang',
  },
  {
    id: '8208040003',
    districtId: '8208040',
    name: 'Losseng',
  },
  {
    id: '8208040004',
    districtId: '8208040',
    name: 'Mantarara',
  },
  {
    id: '8208040005',
    districtId: '8208040',
    name: 'Belo',
  },
  {
    id: '8208040006',
    districtId: '8208040',
    name: 'Wai Kadai',
  },
  {
    id: '8208040007',
    districtId: '8208040',
    name: 'Wai Kadai Sula',
  },
  {
    id: '8208040008',
    districtId: '8208040',
    name: 'Kamaya',
  },
  {
    id: '8208040009',
    districtId: '8208040',
    name: 'Waikoka',
  },
  {
    id: '8208050001',
    districtId: '8208050',
    name: 'Tubang',
  },
  {
    id: '8208050003',
    districtId: '8208050',
    name: 'Parigi',
  },
  {
    id: '8208050004',
    districtId: '8208050',
    name: 'Samuya',
  },
  {
    id: '8208060002',
    districtId: '8208060',
    name: 'Natang Kuning',
  },
  {
    id: '8208060004',
    districtId: '8208060',
    name: 'Padang',
  },
  {
    id: '8208060005',
    districtId: '8208060',
    name: 'Tikong',
  },
  {
    id: '8208060006',
    districtId: '8208060',
    name: 'Sahu',
  },
  {
    id: '8208060007',
    districtId: '8208060',
    name: 'Air Bulan',
  },
  {
    id: '8208060008',
    districtId: '8208060',
    name: 'Nunca',
  },
  {
    id: '8208060009',
    districtId: '8208060',
    name: 'Minton',
  },
  {
    id: '8208060010',
    districtId: '8208060',
    name: 'Gela',
  },
  {
    id: '8208060011',
    districtId: '8208060',
    name: 'London',
  },
  {
    id: '8208060013',
    districtId: '8208060',
    name: 'Hai',
  },
  {
    id: '8208060014',
    districtId: '8208060',
    name: 'Air Kalimat',
  },
  {
    id: '8208060015',
    districtId: '8208060',
    name: 'Jorjoga',
  },
  {
    id: '8208060016',
    districtId: '8208060',
    name: 'Tanjung Una',
  },
  {
    id: '8208060017',
    districtId: '8208060',
    name: 'Mananga',
  },
  {
    id: '8208060018',
    districtId: '8208060',
    name: 'Wahe',
  },
  {
    id: '8208060019',
    districtId: '8208060',
    name: 'Mbono',
  },
  {
    id: '8208070002',
    districtId: '8208070',
    name: 'Langganu',
  },
  {
    id: '8208070003',
    districtId: '8208070',
    name: 'Balohang',
  },
  {
    id: '8208070004',
    districtId: '8208070',
    name: 'Tolong',
  },
  {
    id: '8208070005',
    districtId: '8208070',
    name: 'Todoli',
  },
  {
    id: '8208080001',
    districtId: '8208080',
    name: 'Kasango',
  },
  {
    id: '8208080002',
    districtId: '8208080',
    name: 'Beringin Jaya',
  },
  {
    id: '8208080003',
    districtId: '8208080',
    name: 'Salati',
  },
  {
    id: '8208080004',
    districtId: '8208080',
    name: 'One May',
  },
  {
    id: '8271010005',
    districtId: '8271010',
    name: 'Jambula',
  },
  {
    id: '8271010006',
    districtId: '8271010',
    name: 'Kastela',
  },
  {
    id: '8271010007',
    districtId: '8271010',
    name: 'Foramadiahi',
  },
  {
    id: '8271010009',
    districtId: '8271010',
    name: 'Rua',
  },
  {
    id: '8271010011',
    districtId: '8271010',
    name: 'Afe-Taduma',
  },
  {
    id: '8271010026',
    districtId: '8271010',
    name: 'Dorpedu',
  },
  {
    id: '8271011001',
    districtId: '8271011',
    name: 'Figur',
  },
  {
    id: '8271011002',
    districtId: '8271011',
    name: 'Takofi',
  },
  {
    id: '8271011003',
    districtId: '8271011',
    name: 'Tafaga',
  },
  {
    id: '8271011004',
    districtId: '8271011',
    name: 'Tadenas',
  },
  {
    id: '8271011005',
    districtId: '8271011',
    name: 'Kota Moti',
  },
  {
    id: '8271011006',
    districtId: '8271011',
    name: 'Tafamutu',
  },
  {
    id: '8271012001',
    districtId: '8271012',
    name: 'Pantai Sagu',
  },
  {
    id: '8271012002',
    districtId: '8271012',
    name: 'Tifure',
  },
  {
    id: '8271012003',
    districtId: '8271012',
    name: 'Lelewi',
  },
  {
    id: '8271012004',
    districtId: '8271012',
    name: 'Mayau',
  },
  {
    id: '8271012005',
    districtId: '8271012',
    name: 'Bido',
  },
  {
    id: '8271012006',
    districtId: '8271012',
    name: 'Perum Bersatu',
  },
  {
    id: '8271013001',
    districtId: '8271013',
    name: 'Dorari Isa',
  },
  {
    id: '8271013002',
    districtId: '8271013',
    name: 'Tafraka',
  },
  {
    id: '8271013003',
    districtId: '8271013',
    name: 'Togolobe',
  },
  {
    id: '8271013004',
    districtId: '8271013',
    name: 'Mado',
  },
  {
    id: '8271013005',
    districtId: '8271013',
    name: 'Faudu',
  },
  {
    id: '8271013006',
    districtId: '8271013',
    name: 'Tomajiko',
  },
  {
    id: '8271014001',
    districtId: '8271014',
    name: 'Kulaba',
  },
  {
    id: '8271014002',
    districtId: '8271014',
    name: 'Bula',
  },
  {
    id: '8271014003',
    districtId: '8271014',
    name: 'Tobololo',
  },
  {
    id: '8271014004',
    districtId: '8271014',
    name: 'Togafo',
  },
  {
    id: '8271014005',
    districtId: '8271014',
    name: 'Sulamadaha',
  },
  {
    id: '8271014006',
    districtId: '8271014',
    name: 'Loto',
  },
  {
    id: '8271014007',
    districtId: '8271014',
    name: 'Takome',
  },
  {
    id: '8271020001',
    districtId: '8271020',
    name: 'Sasa',
  },
  {
    id: '8271020002',
    districtId: '8271020',
    name: 'Gambesi',
  },
  {
    id: '8271020003',
    districtId: '8271020',
    name: 'Fitu',
  },
  {
    id: '8271020004',
    districtId: '8271020',
    name: 'Kalumata',
  },
  {
    id: '8271020005',
    districtId: '8271020',
    name: 'Kayu Merah',
  },
  {
    id: '8271020006',
    districtId: '8271020',
    name: 'Bastiong Talangame',
  },
  {
    id: '8271020007',
    districtId: '8271020',
    name: 'Ubo-Ubo',
  },
  {
    id: '8271020008',
    districtId: '8271020',
    name: 'Mangga Dua',
  },
  {
    id: '8271020009',
    districtId: '8271020',
    name: 'Jati',
  },
  {
    id: '8271020010',
    districtId: '8271020',
    name: 'Toboko',
  },
  {
    id: '8271020011',
    districtId: '8271020',
    name: 'Tanah Tinggi',
  },
  {
    id: '8271020020',
    districtId: '8271020',
    name: 'Ngade',
  },
  {
    id: '8271020021',
    districtId: '8271020',
    name: 'Bastiong Karance',
  },
  {
    id: '8271020022',
    districtId: '8271020',
    name: 'Tabona',
  },
  {
    id: '8271020023',
    districtId: '8271020',
    name: 'Jati Perumnas',
  },
  {
    id: '8271020024',
    districtId: '8271020',
    name: 'Mangga Dua Utara',
  },
  {
    id: '8271020025',
    districtId: '8271020',
    name: 'Tanah Tinggi Barat',
  },
  {
    id: '8271021001',
    districtId: '8271021',
    name: 'Maliaro',
  },
  {
    id: '8271021002',
    districtId: '8271021',
    name: 'Kampung Pisang',
  },
  {
    id: '8271021003',
    districtId: '8271021',
    name: 'Takoma',
  },
  {
    id: '8271021004',
    districtId: '8271021',
    name: 'Kota Baru',
  },
  {
    id: '8271021005',
    districtId: '8271021',
    name: 'Muhajirin',
  },
  {
    id: '8271021006',
    districtId: '8271021',
    name: 'Tanah Raja',
  },
  {
    id: '8271021007',
    districtId: '8271021',
    name: 'Stadion',
  },
  {
    id: '8271021008',
    districtId: '8271021',
    name: 'Marikurubu',
  },
  {
    id: '8271021009',
    districtId: '8271021',
    name: 'Moya',
  },
  {
    id: '8271021010',
    districtId: '8271021',
    name: 'Salahuddin',
  },
  {
    id: '8271021011',
    districtId: '8271021',
    name: 'Santiong',
  },
  {
    id: '8271021012',
    districtId: '8271021',
    name: 'Kalumpang',
  },
  {
    id: '8271021013',
    districtId: '8271021',
    name: 'Gamalama',
  },
  {
    id: '8271021014',
    districtId: '8271021',
    name: 'Makassar Timur',
  },
  {
    id: '8271021015',
    districtId: '8271021',
    name: 'Makassar Barat',
  },
  {
    id: '8271030006',
    districtId: '8271030',
    name: 'Soa Sio',
  },
  {
    id: '8271030007',
    districtId: '8271030',
    name: 'Soa',
  },
  {
    id: '8271030008',
    districtId: '8271030',
    name: 'Salero',
  },
  {
    id: '8271030009',
    districtId: '8271030',
    name: 'Kasturian',
  },
  {
    id: '8271030011',
    districtId: '8271030',
    name: 'Toboleu',
  },
  {
    id: '8271030012',
    districtId: '8271030',
    name: 'Sangaji',
  },
  {
    id: '8271030013',
    districtId: '8271030',
    name: 'Dufa Dufa',
  },
  {
    id: '8271030014',
    districtId: '8271030',
    name: 'Tafure',
  },
  {
    id: '8271030015',
    districtId: '8271030',
    name: 'Tabam',
  },
  {
    id: '8271030016',
    districtId: '8271030',
    name: 'Sango',
  },
  {
    id: '8271030017',
    districtId: '8271030',
    name: 'Tarau',
  },
  {
    id: '8271030018',
    districtId: '8271030',
    name: 'Sangaji Utara',
  },
  {
    id: '8271030019',
    districtId: '8271030',
    name: 'Akehuda',
  },
  {
    id: '8271030020',
    districtId: '8271030',
    name: 'Tubo',
  },
  {
    id: '8272010001',
    districtId: '8272010',
    name: 'Marekofo',
  },
  {
    id: '8272010002',
    districtId: '8272010',
    name: 'Maregam',
  },
  {
    id: '8272010003',
    districtId: '8272010',
    name: 'Tongowai',
  },
  {
    id: '8272010004',
    districtId: '8272010',
    name: 'Gurabati',
  },
  {
    id: '8272010005',
    districtId: '8272010',
    name: 'Tomalou',
  },
  {
    id: '8272010006',
    districtId: '8272010',
    name: 'Tuguiha',
  },
  {
    id: '8272010007',
    districtId: '8272010',
    name: 'Dokiri',
  },
  {
    id: '8272010008',
    districtId: '8272010',
    name: 'Toloa',
  },
  {
    id: '8272020001',
    districtId: '8272020',
    name: 'Bobo',
  },
  {
    id: '8272020002',
    districtId: '8272020',
    name: 'Afa Afa',
  },
  {
    id: '8272020003',
    districtId: '8272020',
    name: 'Mareku',
  },
  {
    id: '8272020004',
    districtId: '8272020',
    name: 'Ome',
  },
  {
    id: '8272020005',
    districtId: '8272020',
    name: 'Jaya',
  },
  {
    id: '8272020006',
    districtId: '8272020',
    name: 'Fobaharu',
  },
  {
    id: '8272020008',
    districtId: '8272020',
    name: 'Maitara',
  },
  {
    id: '8272020009',
    districtId: '8272020',
    name: 'Gubu Kusuma',
  },
  {
    id: '8272020010',
    districtId: '8272020',
    name: 'Sirongo Folaraha',
  },
  {
    id: '8272020011',
    districtId: '8272020',
    name: 'Rum Balibunga',
  },
  {
    id: '8272020012',
    districtId: '8272020',
    name: 'Maitara Selatan',
  },
  {
    id: '8272020013',
    districtId: '8272020',
    name: 'Maitara Tengah',
  },
  {
    id: '8272020014',
    districtId: '8272020',
    name: 'Maitara Utara',
  },
  {
    id: '8272030007',
    districtId: '8272030',
    name: 'Seli',
  },
  {
    id: '8272030008',
    districtId: '8272030',
    name: 'Soadara',
  },
  {
    id: '8272030009',
    districtId: '8272030',
    name: 'Topo',
  },
  {
    id: '8272030010',
    districtId: '8272030',
    name: 'Soa Sio',
  },
  {
    id: '8272030011',
    districtId: '8272030',
    name: 'Gamtufkange',
  },
  {
    id: '8272030012',
    districtId: '8272030',
    name: 'Gura-Bunga',
  },
  {
    id: '8272030013',
    districtId: '8272030',
    name: 'Indonesiana',
  },
  {
    id: '8272030017',
    districtId: '8272030',
    name: 'Topo Tiga',
  },
  {
    id: '8272030018',
    districtId: '8272030',
    name: 'Tomagoba',
  },
  {
    id: '8272030019',
    districtId: '8272030',
    name: 'Folarora',
  },
  {
    id: '8272030020',
    districtId: '8272030',
    name: 'Goto',
  },
  {
    id: '8272030021',
    districtId: '8272030',
    name: 'Tambula',
  },
  {
    id: '8272030022',
    districtId: '8272030',
    name: 'Tuguwaji',
  },
  {
    id: '8272031001',
    districtId: '8272031',
    name: 'Dowora',
  },
  {
    id: '8272031002',
    districtId: '8272031',
    name: 'Kalaodi',
  },
  {
    id: '8272031003',
    districtId: '8272031',
    name: 'Mafututu',
  },
  {
    id: '8272031004',
    districtId: '8272031',
    name: 'Tosa',
  },
  {
    id: '8272031005',
    districtId: '8272031',
    name: 'Cobodoe',
  },
  {
    id: '8272031006',
    districtId: '8272031',
    name: 'Doyado',
  },
  {
    id: '8272031007',
    districtId: '8272031',
    name: 'Jikocobo',
  },
  {
    id: '8272040003',
    districtId: '8272040',
    name: 'Kusu Sinopa',
  },
  {
    id: '8272040004',
    districtId: '8272040',
    name: 'Payahe',
  },
  {
    id: '8272040005',
    districtId: '8272040',
    name: 'Toseho',
  },
  {
    id: '8272040006',
    districtId: '8272040',
    name: 'Gita Raja',
  },
  {
    id: '8272040008',
    districtId: '8272040',
    name: 'Woda',
  },
  {
    id: '8272040009',
    districtId: '8272040',
    name: 'Kosa',
  },
  {
    id: '8272040010',
    districtId: '8272040',
    name: 'Koli',
  },
  {
    id: '8272040011',
    districtId: '8272040',
    name: 'Bale',
  },
  {
    id: '8272040012',
    districtId: '8272040',
    name: 'Tului',
  },
  {
    id: '8272040013',
    districtId: '8272040',
    name: 'Sigela Yef',
  },
  {
    id: '8272040014',
    districtId: '8272040',
    name: 'Todapa',
  },
  {
    id: '8272040015',
    districtId: '8272040',
    name: 'Talasi',
  },
  {
    id: '8272040016',
    districtId: '8272040',
    name: 'Talagamori',
  },
  {
    id: '8272040017',
    districtId: '8272040',
    name: 'UPT Koli',
  },
  {
    id: '8272041001',
    districtId: '8272041',
    name: 'Sela Malofo',
  },
  {
    id: '8272041002',
    districtId: '8272041',
    name: 'Maidi',
  },
  {
    id: '8272041003',
    districtId: '8272041',
    name: 'Hager',
  },
  {
    id: '8272041004',
    districtId: '8272041',
    name: 'Wama',
  },
  {
    id: '8272041005',
    districtId: '8272041',
    name: 'Lifofa',
  },
  {
    id: '8272041007',
    districtId: '8272041',
    name: 'Tagalaya',
  },
  {
    id: '8272050003',
    districtId: '8272050',
    name: 'Somahode',
  },
  {
    id: '8272050004',
    districtId: '8272050',
    name: 'Akekolano',
  },
  {
    id: '8272050005',
    districtId: '8272050',
    name: 'Oba',
  },
  {
    id: '8272050006',
    districtId: '8272050',
    name: 'Sofifi',
  },
  {
    id: '8272050007',
    districtId: '8272050',
    name: 'Guraping',
  },
  {
    id: '8272050008',
    districtId: '8272050',
    name: 'Kaiyasa',
  },
  {
    id: '8272050009',
    districtId: '8272050',
    name: 'Garojou',
  },
  {
    id: '8272050011',
    districtId: '8272050',
    name: 'Ampera',
  },
  {
    id: '8272050012',
    districtId: '8272050',
    name: 'Bukit Durian',
  },
  {
    id: '8272050013',
    districtId: '8272050',
    name: 'Galala',
  },
  {
    id: '8272050014',
    districtId: '8272050',
    name: 'Balbar',
  },
  {
    id: '8272050015',
    districtId: '8272050',
    name: 'Gosale',
  },
  {
    id: '8272051001',
    districtId: '8272051',
    name: 'Togeme',
  },
  {
    id: '8272051002',
    districtId: '8272051',
    name: 'Lola',
  },
  {
    id: '8272051003',
    districtId: '8272051',
    name: 'Akelamo',
  },
  {
    id: '8272051004',
    districtId: '8272051',
    name: 'Akeguraci',
  },
  {
    id: '8272051005',
    districtId: '8272051',
    name: 'Akesai',
  },
  {
    id: '8272051006',
    districtId: '8272051',
    name: 'Aketobololo',
  },
  {
    id: '8272051007',
    districtId: '8272051',
    name: 'Akedotilou',
  },
  {
    id: '8272051008',
    districtId: '8272051',
    name: 'Aketubatu',
  },
  {
    id: '8272051009',
    districtId: '8272051',
    name: 'Tadupi',
  },
  {
    id: '8272051011',
    districtId: '8272051',
    name: 'Tauno',
  },
  {
    id: '8272051012',
    districtId: '8272051',
    name: 'Beringin Jaya',
  },
  {
    id: '8272051013',
    districtId: '8272051',
    name: 'Fanaha',
  },
  {
    id: '8272051014',
    districtId: '8272051',
    name: 'Siokona',
  },
  {
    id: '9101050006',
    districtId: '9101050',
    name: 'Tunas Gain',
  },
  {
    id: '9101050007',
    districtId: '9101050',
    name: 'Urat',
  },
  {
    id: '9101050008',
    districtId: '9101050',
    name: 'Sanggram',
  },
  {
    id: '9101050016',
    districtId: '9101050',
    name: 'Weri',
  },
  {
    id: '9101050017',
    districtId: '9101050',
    name: 'Kiria Bisa',
  },
  {
    id: '9101050018',
    districtId: '9101050',
    name: 'Saharei',
  },
  {
    id: '9101051001',
    districtId: '9101051',
    name: 'Antalisa',
  },
  {
    id: '9101051002',
    districtId: '9101051',
    name: 'Mas',
  },
  {
    id: '9101051003',
    districtId: '9101051',
    name: 'Tubirwasak',
  },
  {
    id: '9101051004',
    districtId: '9101051',
    name: 'Tarak',
  },
  {
    id: '9101051005',
    districtId: '9101051',
    name: 'Faur',
  },
  {
    id: '9101051006',
    districtId: '9101051',
    name: 'Malakuli',
  },
  {
    id: '9101051007',
    districtId: '9101051',
    name: 'Kiaba',
  },
  {
    id: '9101052001',
    districtId: '9101052',
    name: 'Waserat',
  },
  {
    id: '9101052002',
    districtId: '9101052',
    name: 'Kalamanuk',
  },
  {
    id: '9101052003',
    districtId: '9101052',
    name: 'Kotam',
  },
  {
    id: '9101052004',
    districtId: '9101052',
    name: 'Kwama',
  },
  {
    id: '9101052005',
    districtId: '9101052',
    name: 'Wayati',
  },
  {
    id: '9101052006',
    districtId: '9101052',
    name: 'Wayati Timur',
  },
  {
    id: '9101052007',
    districtId: '9101052',
    name: 'Wayati Barat',
  },
  {
    id: '9101052010',
    districtId: '9101052',
    name: 'Wambar',
  },
  {
    id: '9101052011',
    districtId: '9101052',
    name: 'Wambar Timur',
  },
  {
    id: '9101060008',
    districtId: '9101060',
    name: 'Fak Fak Selatan',
  },
  {
    id: '9101060009',
    districtId: '9101060',
    name: 'Fak Fak Utara',
  },
  {
    id: '9101060013',
    districtId: '9101060',
    name: 'Wrikapal',
  },
  {
    id: '9101060021',
    districtId: '9101060',
    name: 'Lusi Peri',
  },
  {
    id: '9101061001',
    districtId: '9101061',
    name: 'Dana Weria',
  },
  {
    id: '9101061002',
    districtId: '9101061',
    name: 'Kayu Merah',
  },
  {
    id: '9101061003',
    districtId: '9101061',
    name: 'Katemba',
  },
  {
    id: '9101061004',
    districtId: '9101061',
    name: 'Nemewikarya',
  },
  {
    id: '9101061005',
    districtId: '9101061',
    name: 'Raduria',
  },
  {
    id: '9101061006',
    districtId: '9101061',
    name: 'Brongkendik',
  },
  {
    id: '9101061007',
    districtId: '9101061',
    name: 'Air Besar',
  },
  {
    id: '9101061008',
    districtId: '9101061',
    name: 'Kanantare',
  },
  {
    id: '9101061009',
    districtId: '9101061',
    name: 'Mandopma',
  },
  {
    id: '9101061010',
    districtId: '9101061',
    name: 'Pasir Putih',
  },
  {
    id: '9101061011',
    districtId: '9101061',
    name: 'Pirma',
  },
  {
    id: '9101061012',
    districtId: '9101061',
    name: 'Sakartemin',
  },
  {
    id: '9101061013',
    districtId: '9101061',
    name: 'Uni Pokpok',
  },
  {
    id: '9101061014',
    districtId: '9101061',
    name: 'Hambrangkendik',
  },
  {
    id: '9101061015',
    districtId: '9101061',
    name: 'Krabelang',
  },
  {
    id: '9101062002',
    districtId: '9101062',
    name: 'Torea',
  },
  {
    id: '9101062003',
    districtId: '9101062',
    name: 'Sekban',
  },
  {
    id: '9101062004',
    districtId: '9101062',
    name: 'Dulan Pok Pok',
  },
  {
    id: '9101062005',
    districtId: '9101062',
    name: 'Kapaurtutin',
  },
  {
    id: '9101062006',
    districtId: '9101062',
    name: 'Tanama',
  },
  {
    id: '9101062007',
    districtId: '9101062',
    name: 'Wagom',
  },
  {
    id: '9101062008',
    districtId: '9101062',
    name: 'Wagom Utara',
  },
  {
    id: '9101062009',
    districtId: '9101062',
    name: 'Sukuru Tuare',
  },
  {
    id: '9101070005',
    districtId: '9101070',
    name: 'Purwasak',
  },
  {
    id: '9101070006',
    districtId: '9101070',
    name: 'Werba',
  },
  {
    id: '9101070007',
    districtId: '9101070',
    name: 'Kiat',
  },
  {
    id: '9101070008',
    districtId: '9101070',
    name: 'Wurkendik',
  },
  {
    id: '9101070010',
    districtId: '9101070',
    name: 'Kwuhkendik',
  },
  {
    id: '9101071001',
    districtId: '9101071',
    name: 'Sipatnanam',
  },
  {
    id: '9101071002',
    districtId: '9101071',
    name: 'Siboru',
  },
  {
    id: '9101071003',
    districtId: '9101071',
    name: 'Werabuan',
  },
  {
    id: '9101071004',
    districtId: '9101071',
    name: 'Werpigan',
  },
  {
    id: '9101071005',
    districtId: '9101071',
    name: 'Wartutin',
  },
  {
    id: '9101071006',
    districtId: '9101071',
    name: 'Kamandu Tetar',
  },
  {
    id: '9101080026',
    districtId: '9101080',
    name: 'Kriawaswas',
  },
  {
    id: '9101080027',
    districtId: '9101080',
    name: 'Mambuniibuni',
  },
  {
    id: '9101080028',
    districtId: '9101080',
    name: 'Mandoni',
  },
  {
    id: '9101080029',
    districtId: '9101080',
    name: 'Batufiafas',
  },
  {
    id: '9101080030',
    districtId: '9101080',
    name: 'Patimburak',
  },
  {
    id: '9101080031',
    districtId: '9101080',
    name: 'Sekar',
  },
  {
    id: '9101080032',
    districtId: '9101080',
    name: 'Kokas Kota',
  },
  {
    id: '9101080033',
    districtId: '9101080',
    name: 'Sisir',
  },
  {
    id: '9101080034',
    districtId: '9101080',
    name: 'Kampung Baru',
  },
  {
    id: '9101080035',
    districtId: '9101080',
    name: 'Ugar',
  },
  {
    id: '9101080036',
    districtId: '9101080',
    name: 'Kinam',
  },
  {
    id: '9101080055',
    districtId: '9101080',
    name: 'Wafus',
  },
  {
    id: '9101080057',
    districtId: '9101080',
    name: 'Kimina Kra',
  },
  {
    id: '9101080058',
    districtId: '9101080',
    name: 'Sosar',
  },
  {
    id: '9101080059',
    districtId: '9101080',
    name: 'Masina',
  },
  {
    id: '9101080060',
    districtId: '9101080',
    name: 'Pang Wada',
  },
  {
    id: '9101081004',
    districtId: '9101081',
    name: 'Patipi Pasir',
  },
  {
    id: '9101081007',
    districtId: '9101081',
    name: 'Puar',
  },
  {
    id: '9101081008',
    districtId: '9101081',
    name: 'Tibatibananam',
  },
  {
    id: '9101081009',
    districtId: '9101081',
    name: 'Offie',
  },
  {
    id: '9101081012',
    districtId: '9101081',
    name: 'Tetar',
  },
  {
    id: '9101081014',
    districtId: '9101081',
    name: 'Patipi Nusa',
  },
  {
    id: '9101081015',
    districtId: '9101081',
    name: 'Mawar',
  },
  {
    id: '9101081016',
    districtId: '9101081',
    name: 'Adora',
  },
  {
    id: '9101081018',
    districtId: '9101081',
    name: 'Bisa',
  },
  {
    id: '9101081019',
    districtId: '9101081',
    name: 'Muhriri',
  },
  {
    id: '9101082006',
    districtId: '9101082',
    name: 'Kramongmongga',
  },
  {
    id: '9101082008',
    districtId: '9101082',
    name: 'Kwamkwamur',
  },
  {
    id: '9101082010',
    districtId: '9101082',
    name: 'Mamur',
  },
  {
    id: '9101082011',
    districtId: '9101082',
    name: 'Pikpik',
  },
  {
    id: '9101082012',
    districtId: '9101082',
    name: 'Bahbadan',
  },
  {
    id: '9101082013',
    districtId: '9101082',
    name: 'Wargep',
  },
  {
    id: '9101082016',
    districtId: '9101082',
    name: 'Gewab',
  },
  {
    id: '9101083004',
    districtId: '9101083',
    name: 'Onim Sari',
  },
  {
    id: '9101083005',
    districtId: '9101083',
    name: 'Mekar Sari',
  },
  {
    id: '9101083006',
    districtId: '9101083',
    name: 'Bomberay V (UPT) / Pinang Agung',
  },
  {
    id: '9101083007',
    districtId: '9101083',
    name: 'Bomberay  VI (UPT) / Bumi Muroh Indah',
  },
  {
    id: '9101083011',
    districtId: '9101083',
    name: 'Tesha',
  },
  {
    id: '9101083012',
    districtId: '9101083',
    name: 'Onim Jaya',
  },
  {
    id: '9101083013',
    districtId: '9101083',
    name: 'Wono Rejo',
  },
  {
    id: '9101084001',
    districtId: '9101084',
    name: 'Andamata',
  },
  {
    id: '9101084002',
    districtId: '9101084',
    name: 'Arguni',
  },
  {
    id: '9101084003',
    districtId: '9101084',
    name: 'Fior',
  },
  {
    id: '9101084004',
    districtId: '9101084',
    name: 'Porir',
  },
  {
    id: '9101084005',
    districtId: '9101084',
    name: 'Arguni Barat',
  },
  {
    id: '9101085001',
    districtId: '9101085',
    name: 'Darembang',
  },
  {
    id: '9101085002',
    districtId: '9101085',
    name: 'Goras',
  },
  {
    id: '9101085003',
    districtId: '9101085',
    name: 'Waremu',
  },
  {
    id: '9101085004',
    districtId: '9101085',
    name: 'Metimber',
  },
  {
    id: '9101085005',
    districtId: '9101085',
    name: 'Wos',
  },
  {
    id: '9101085006',
    districtId: '9101085',
    name: 'Mbahamdandara',
  },
  {
    id: '9101085007',
    districtId: '9101085',
    name: 'Goras Selatan',
  },
  {
    id: '9101086001',
    districtId: '9101086',
    name: 'Tanehamur',
  },
  {
    id: '9101086002',
    districtId: '9101086',
    name: 'Rumbati',
  },
  {
    id: '9101086003',
    districtId: '9101086',
    name: 'Tawar',
  },
  {
    id: '9101086004',
    districtId: '9101086',
    name: 'Salakiti',
  },
  {
    id: '9101086005',
    districtId: '9101086',
    name: 'Werfa',
  },
  {
    id: '9101086006',
    districtId: '9101086',
    name: 'Gar',
  },
  {
    id: '9101086007',
    districtId: '9101086',
    name: 'Sengkiti',
  },
  {
    id: '9101086008',
    districtId: '9101086',
    name: 'Twootkendik',
  },
  {
    id: '9101087001',
    districtId: '9101087',
    name: 'Rangkendak',
  },
  {
    id: '9101087002',
    districtId: '9101087',
    name: 'Hamorkokma',
  },
  {
    id: '9101087003',
    districtId: '9101087',
    name: 'Kuagas',
  },
  {
    id: '9101087004',
    districtId: '9101087',
    name: 'Kayuni',
  },
  {
    id: '9101087005',
    districtId: '9101087',
    name: 'Ubadari',
  },
  {
    id: '9101087006',
    districtId: '9101087',
    name: 'Kaburbur',
  },
  {
    id: '9101087007',
    districtId: '9101087',
    name: 'Mananmur/Rangkendak II',
  },
  {
    id: '9101087008',
    districtId: '9101087',
    name: 'Pattukar',
  },
  {
    id: '9101087009',
    districtId: '9101087',
    name: 'Warpa',
  },
  {
    id: '9101088001',
    districtId: '9101088',
    name: 'Otoweri',
  },
  {
    id: '9101088002',
    districtId: '9101088',
    name: 'Mbima Jaya',
  },
  {
    id: '9101088003',
    districtId: '9101088',
    name: 'Warisa Mulia',
  },
  {
    id: '9101088004',
    districtId: '9101088',
    name: 'Bomberay VII (UPT) / Wonodadi Mulya',
  },
  {
    id: '9101088005',
    districtId: '9101088',
    name: 'Tomage',
  },
  {
    id: '9101088006',
    districtId: '9101088',
    name: 'Wamosan',
  },
  {
    id: '9101088007',
    districtId: '9101088',
    name: 'Wammar',
  },
  {
    id: '9101088008',
    districtId: '9101088',
    name: 'Wasa Mulya',
  },
  {
    id: '9101088009',
    districtId: '9101088',
    name: 'Syena Salawir',
  },
  {
    id: '9102010001',
    districtId: '9102010',
    name: 'Adijaya',
  },
  {
    id: '9102010002',
    districtId: '9102010',
    name: 'Nusa Ulan',
  },
  {
    id: '9102010003',
    districtId: '9102010',
    name: 'Kambala',
  },
  {
    id: '9102010004',
    districtId: '9102010',
    name: 'Y A R O N A',
  },
  {
    id: '9102010005',
    districtId: '9102010',
    name: 'H I A',
  },
  {
    id: '9102010006',
    districtId: '9102010',
    name: 'T A I R I',
  },
  {
    id: '9102010007',
    districtId: '9102010',
    name: 'Guriasa',
  },
  {
    id: '9102010008',
    districtId: '9102010',
    name: 'G A K A',
  },
  {
    id: '9102010009',
    districtId: '9102010',
    name: 'Esania',
  },
  {
    id: '9102010010',
    districtId: '9102010',
    name: 'E D O R',
  },
  {
    id: '9102020005',
    districtId: '9102020',
    name: 'Erigara',
  },
  {
    id: '9102020006',
    districtId: '9102020',
    name: 'Fudima',
  },
  {
    id: '9102020007',
    districtId: '9102020',
    name: 'Wainaga',
  },
  {
    id: '9102020008',
    districtId: '9102020',
    name: 'Kasira/Kensi',
  },
  {
    id: '9102020009',
    districtId: '9102020',
    name: 'Maskur',
  },
  {
    id: '9102020010',
    districtId: '9102020',
    name: 'Bayeda',
  },
  {
    id: '9102020011',
    districtId: '9102020',
    name: 'Moyana',
  },
  {
    id: '9102020012',
    districtId: '9102020',
    name: 'Tugarni',
  },
  {
    id: '9102020013',
    districtId: '9102020',
    name: 'Afuafu',
  },
  {
    id: '9102020014',
    districtId: '9102020',
    name: 'Kokoroba',
  },
  {
    id: '9102020015',
    districtId: '9102020',
    name: 'Tuguwara',
  },
  {
    id: '9102020024',
    districtId: '9102020',
    name: 'Sawatawera',
  },
  {
    id: '9102020026',
    districtId: '9102020',
    name: 'Wanggita',
  },
  {
    id: '9102020027',
    districtId: '9102020',
    name: 'Bofuwer',
  },
  {
    id: '9102020028',
    districtId: '9102020',
    name: 'Warwasi',
  },
  {
    id: '9102020029',
    districtId: '9102020',
    name: 'Sawia',
  },
  {
    id: '9102020030',
    districtId: '9102020',
    name: 'Weswasa',
  },
  {
    id: '9102020031',
    districtId: '9102020',
    name: 'Borogerba',
  },
  {
    id: '9102020032',
    districtId: '9102020',
    name: 'Pigo',
  },
  {
    id: '9102020033',
    districtId: '9102020',
    name: 'Tiwara',
  },
  {
    id: '9102020034',
    districtId: '9102020',
    name: 'Warua',
  },
  {
    id: '9102020035',
    districtId: '9102020',
    name: 'Gusi',
  },
  {
    id: '9102021001',
    districtId: '9102021',
    name: 'Wanoma',
  },
  {
    id: '9102021002',
    districtId: '9102021',
    name: 'I N A R I',
  },
  {
    id: '9102021003',
    districtId: '9102021',
    name: 'U R I S A',
  },
  {
    id: '9102021004',
    districtId: '9102021',
    name: 'Tanusan',
  },
  {
    id: '9102021005',
    districtId: '9102021',
    name: 'Ruara',
  },
  {
    id: '9102021006',
    districtId: '9102021',
    name: 'Kufuriai',
  },
  {
    id: '9102021007',
    districtId: '9102021',
    name: 'Manggera',
  },
  {
    id: '9102021008',
    districtId: '9102021',
    name: 'Warmenu',
  },
  {
    id: '9102021009',
    districtId: '9102021',
    name: 'Agerwara',
  },
  {
    id: '9102021010',
    districtId: '9102021',
    name: 'Jawera',
  },
  {
    id: '9102021011',
    districtId: '9102021',
    name: 'Waromi',
  },
  {
    id: '9102021012',
    districtId: '9102021',
    name: 'Ukiara',
  },
  {
    id: '9102021014',
    districtId: '9102021',
    name: 'Seraran',
  },
  {
    id: '9102021015',
    districtId: '9102021',
    name: 'Nagura',
  },
  {
    id: '9102030001',
    districtId: '9102030',
    name: 'Lumira',
  },
  {
    id: '9102030002',
    districtId: '9102030',
    name: 'Saria',
  },
  {
    id: '9102030003',
    districtId: '9102030',
    name: 'Lobo',
  },
  {
    id: '9102030004',
    districtId: '9102030',
    name: 'Namatota',
  },
  {
    id: '9102030005',
    districtId: '9102030',
    name: 'Mai Mai',
  },
  {
    id: '9102030006',
    districtId: '9102030',
    name: 'Foroma Jaya',
  },
  {
    id: '9102030007',
    districtId: '9102030',
    name: 'Murano',
  },
  {
    id: '9102030008',
    districtId: '9102030',
    name: 'Sisir',
  },
  {
    id: '9102030009',
    districtId: '9102030',
    name: 'Marsi',
  },
  {
    id: '9102030010',
    districtId: '9102030',
    name: 'Kaimana Kota',
  },
  {
    id: '9102030011',
    districtId: '9102030',
    name: 'K R O Y',
  },
  {
    id: '9102030012',
    districtId: '9102030',
    name: 'Trikora',
  },
  {
    id: '9102030013',
    districtId: '9102030',
    name: 'C O A',
  },
  {
    id: '9102030014',
    districtId: '9102030',
    name: 'Tanggaromi',
  },
  {
    id: '9102030021',
    districtId: '9102030',
    name: 'Kamaka',
  },
  {
    id: '9102030024',
    districtId: '9102030',
    name: 'Sara',
  },
  {
    id: '9102030025',
    districtId: '9102030',
    name: 'Werua',
  },
  {
    id: '9102030026',
    districtId: '9102030',
    name: 'Jarati',
  },
  {
    id: '9102030027',
    districtId: '9102030',
    name: 'Oray',
  },
  {
    id: '9102031001',
    districtId: '9102031',
    name: 'K O O Y',
  },
  {
    id: '9102031002',
    districtId: '9102031',
    name: 'W A M E S A',
  },
  {
    id: '9102031003',
    districtId: '9102031',
    name: 'Waho',
  },
  {
    id: '9102031004',
    districtId: '9102031',
    name: 'Bahumia',
  },
  {
    id: '9102031006',
    districtId: '9102031',
    name: 'Werafuta',
  },
  {
    id: '9102031007',
    districtId: '9102031',
    name: 'Rauna',
  },
  {
    id: '9102040001',
    districtId: '9102040',
    name: 'Siawatan',
  },
  {
    id: '9102040002',
    districtId: '9102040',
    name: 'Bamana',
  },
  {
    id: '9102040003',
    districtId: '9102040',
    name: 'Boiya',
  },
  {
    id: '9102040004',
    districtId: '9102040',
    name: 'Nariki',
  },
  {
    id: '9102040005',
    districtId: '9102040',
    name: 'Rurumo',
  },
  {
    id: '9102041001',
    districtId: '9102041',
    name: 'Hairapara',
  },
  {
    id: '9102041002',
    districtId: '9102041',
    name: 'Coremuri/Ombapamuku',
  },
  {
    id: '9102041003',
    districtId: '9102041',
    name: 'Wosokuno',
  },
  {
    id: '9102041004',
    districtId: '9102041',
    name: 'Wagioha',
  },
  {
    id: '9102041005',
    districtId: '9102041',
    name: 'Urubika',
  },
  {
    id: '9102041006',
    districtId: '9102041',
    name: 'Mury/Uray',
  },
  {
    id: '9103010001',
    districtId: '9103010',
    name: 'Sararti',
  },
  {
    id: '9103010002',
    districtId: '9103010',
    name: 'Wosimo',
  },
  {
    id: '9103010003',
    districtId: '9103010',
    name: 'Oya',
  },
  {
    id: '9103010004',
    districtId: '9103010',
    name: 'Yabore',
  },
  {
    id: '9103010005',
    districtId: '9103010',
    name: 'Inyora',
  },
  {
    id: '9103010006',
    districtId: '9103010',
    name: 'Undurara',
  },
  {
    id: '9103020008',
    districtId: '9103020',
    name: 'Wondiboi',
  },
  {
    id: '9103020012',
    districtId: '9103020',
    name: 'Isuy',
  },
  {
    id: '9103020013',
    districtId: '9103020',
    name: 'Kabuow',
  },
  {
    id: '9103020014',
    districtId: '9103020',
    name: 'Kaibi',
  },
  {
    id: '9103021001',
    districtId: '9103021',
    name: 'Senderawoi',
  },
  {
    id: '9103021002',
    districtId: '9103021',
    name: 'Tandia',
  },
  {
    id: '9103021003',
    districtId: '9103021',
    name: 'Sasirei',
  },
  {
    id: '9103021004',
    districtId: '9103021',
    name: 'Isei',
  },
  {
    id: '9103021005',
    districtId: '9103021',
    name: 'Rasiei',
  },
  {
    id: '9103021006',
    districtId: '9103021',
    name: 'Webi',
  },
  {
    id: '9103021007',
    districtId: '9103021',
    name: 'Uriemi',
  },
  {
    id: '9103021008',
    districtId: '9103021',
    name: 'Torey',
  },
  {
    id: '9103021009',
    districtId: '9103021',
    name: 'Nggatu',
  },
  {
    id: '9103022001',
    districtId: '9103022',
    name: 'Sobiar',
  },
  {
    id: '9103022002',
    districtId: '9103022',
    name: 'Ambumi',
  },
  {
    id: '9103022003',
    districtId: '9103022',
    name: 'Nanimori',
  },
  {
    id: '9103022005',
    districtId: '9103022',
    name: 'Yerenusi',
  },
  {
    id: '9103022006',
    districtId: '9103022',
    name: 'Muandarisi',
  },
  {
    id: '9103030012',
    districtId: '9103030',
    name: 'Wondamawi   II',
  },
  {
    id: '9103030013',
    districtId: '9103030',
    name: 'Manopi',
  },
  {
    id: '9103030014',
    districtId: '9103030',
    name: 'Maniwak',
  },
  {
    id: '9103030015',
    districtId: '9103030',
    name: 'Wasior I',
  },
  {
    id: '9103030016',
    districtId: '9103030',
    name: 'Wasior II',
  },
  {
    id: '9103030017',
    districtId: '9103030',
    name: 'Rado',
  },
  {
    id: '9103030018',
    districtId: '9103030',
    name: 'Dotir',
  },
  {
    id: '9103030019',
    districtId: '9103030',
    name: 'Iriati',
  },
  {
    id: '9103030020',
    districtId: '9103030',
    name: 'Moru',
  },
  {
    id: '9103030021',
    districtId: '9103030',
    name: 'Maimare',
  },
  {
    id: '9103040001',
    districtId: '9103040',
    name: 'Sobei',
  },
  {
    id: '9103040002',
    districtId: '9103040',
    name: 'Aisandami',
  },
  {
    id: '9103040003',
    districtId: '9103040',
    name: 'Yopenggar',
  },
  {
    id: '9103040007',
    districtId: '9103040',
    name: 'Sobey Indah',
  },
  {
    id: '9103041001',
    districtId: '9103041',
    name: 'Menarbu',
  },
  {
    id: '9103041002',
    districtId: '9103041',
    name: 'Sariay',
  },
  {
    id: '9103041003',
    districtId: '9103041',
    name: 'Niab',
  },
  {
    id: '9103041004',
    districtId: '9103041',
    name: 'Inday',
  },
  {
    id: '9103041005',
    districtId: '9103041',
    name: 'Syabes',
  },
  {
    id: '9103041006',
    districtId: '9103041',
    name: 'Mena',
  },
  {
    id: '9103050002',
    districtId: '9103050',
    name: 'Yopmeos',
  },
  {
    id: '9103050003',
    districtId: '9103050',
    name: 'Wamesa Tengah',
  },
  {
    id: '9103050006',
    districtId: '9103050',
    name: 'Sombokoro',
  },
  {
    id: '9103050007',
    districtId: '9103050',
    name: 'Sandey',
  },
  {
    id: '9103050008',
    districtId: '9103050',
    name: 'Windesi',
  },
  {
    id: '9103051001',
    districtId: '9103051',
    name: 'Werianggi',
  },
  {
    id: '9103051002',
    districtId: '9103051',
    name: 'Mamisi',
  },
  {
    id: '9103051003',
    districtId: '9103051',
    name: 'Werabur',
  },
  {
    id: '9103051004',
    districtId: '9103051',
    name: 'Kurei',
  },
  {
    id: '9103051005',
    districtId: '9103051',
    name: 'Tamoge',
  },
  {
    id: '9103060001',
    districtId: '9103060',
    name: 'Sabubar',
  },
  {
    id: '9103060004',
    districtId: '9103060',
    name: 'Karuan',
  },
  {
    id: '9103060005',
    districtId: '9103060',
    name: 'Ambuar',
  },
  {
    id: '9103060006',
    districtId: '9103060',
    name: 'Yarpate',
  },
  {
    id: '9103061001',
    districtId: '9103061',
    name: 'Waprak',
  },
  {
    id: '9103061002',
    districtId: '9103061',
    name: 'Yomber',
  },
  {
    id: '9103061003',
    districtId: '9103061',
    name: 'Syeiwar',
  },
  {
    id: '9103061004',
    districtId: '9103061',
    name: 'Nordiwar',
  },
  {
    id: '9103070001',
    districtId: '9103070',
    name: 'Yomakan',
  },
  {
    id: '9103070002',
    districtId: '9103070',
    name: 'Senebuay',
  },
  {
    id: '9103070003',
    districtId: '9103070',
    name: 'Yembekiri I',
  },
  {
    id: '9103070004',
    districtId: '9103070',
    name: 'Iseren',
  },
  {
    id: '9103070005',
    districtId: '9103070',
    name: 'Yariari',
  },
  {
    id: '9103070006',
    districtId: '9103070',
    name: 'Yembekiri II',
  },
  {
    id: '9103070007',
    districtId: '9103070',
    name: 'Wetitindau',
  },
  {
    id: '9103071001',
    districtId: '9103071',
    name: 'Kaprus',
  },
  {
    id: '9103071002',
    districtId: '9103071',
    name: 'Yermatum',
  },
  {
    id: '9103071003',
    districtId: '9103071',
    name: 'Reyob',
  },
  {
    id: '9103071004',
    districtId: '9103071',
    name: 'Siresi',
  },
  {
    id: '9103071005',
    districtId: '9103071',
    name: 'Nuspairo',
  },
  {
    id: '9104010001',
    districtId: '9104010',
    name: 'Fruata',
  },
  {
    id: '9104010002',
    districtId: '9104010',
    name: 'Maryedi',
  },
  {
    id: '9104010003',
    districtId: '9104010',
    name: 'Riendo',
  },
  {
    id: '9104010004',
    districtId: '9104010',
    name: 'Tarofa',
  },
  {
    id: '9104010005',
    districtId: '9104010',
    name: 'Mambriema',
  },
  {
    id: '9104010006',
    districtId: '9104010',
    name: 'Moniara',
  },
  {
    id: '9104010007',
    districtId: '9104010',
    name: 'Wararoma',
  },
  {
    id: '9104020002',
    districtId: '9104020',
    name: 'Amutu',
  },
  {
    id: '9104020003',
    districtId: '9104020',
    name: 'Nusei',
  },
  {
    id: '9104020004',
    districtId: '9104020',
    name: 'Kasira',
  },
  {
    id: '9104020009',
    districtId: '9104020',
    name: 'Irarutu III / Babo',
  },
  {
    id: '9104020010',
    districtId: '9104020',
    name: 'Modan Fisaura',
  },
  {
    id: '9104020011',
    districtId: '9104020',
    name: 'Kanaisi',
  },
  {
    id: '9104021001',
    districtId: '9104021',
    name: 'Tofoi',
  },
  {
    id: '9104021002',
    districtId: '9104021',
    name: 'Saengga',
  },
  {
    id: '9104021003',
    districtId: '9104021',
    name: 'Tanah Merah',
  },
  {
    id: '9104021004',
    districtId: '9104021',
    name: 'Materabu Jaya',
  },
  {
    id: '9104021005',
    districtId: '9104021',
    name: 'Forada',
  },
  {
    id: '9104021006',
    districtId: '9104021',
    name: 'Agoda',
  },
  {
    id: '9104021007',
    districtId: '9104021',
    name: 'Onar Lama',
  },
  {
    id: '9104021008',
    districtId: '9104021',
    name: 'Onar Baru',
  },
  {
    id: '9104022001',
    districtId: '9104022',
    name: 'Aroba',
  },
  {
    id: '9104022002',
    districtId: '9104022',
    name: 'Yaru',
  },
  {
    id: '9104022003',
    districtId: '9104022',
    name: 'Sido Makmur',
  },
  {
    id: '9104022004',
    districtId: '9104022',
    name: 'Wimbro',
  },
  {
    id: '9104022005',
    districtId: '9104022',
    name: 'Sangguar',
  },
  {
    id: '9104022006',
    districtId: '9104022',
    name: 'Disyaga Air Terjun',
  },
  {
    id: '9104022007',
    districtId: '9104022',
    name: 'Wamme',
  },
  {
    id: '9104023001',
    districtId: '9104023',
    name: 'Sara',
  },
  {
    id: '9104023002',
    districtId: '9104023',
    name: 'Warganusa',
  },
  {
    id: '9104023003',
    districtId: '9104023',
    name: 'Warga Nusa II',
  },
  {
    id: '9104023004',
    districtId: '9104023',
    name: 'Tugerama',
  },
  {
    id: '9104023005',
    districtId: '9104023',
    name: 'Irarutu I / Suga',
  },
  {
    id: '9104023007',
    districtId: '9104023',
    name: 'Kawaf',
  },
  {
    id: '9104030001',
    districtId: '9104030',
    name: 'Kuri  / Sarbei',
  },
  {
    id: '9104030002',
    districtId: '9104030',
    name: 'Kuri II / Naramasa',
  },
  {
    id: '9104030003',
    districtId: '9104030',
    name: 'Wagura',
  },
  {
    id: '9104030004',
    districtId: '9104030',
    name: 'Rafideso',
  },
  {
    id: '9104030005',
    districtId: '9104030',
    name: 'O B O',
  },
  {
    id: '9104030006',
    districtId: '9104030',
    name: 'Awegro',
  },
  {
    id: '9104030007',
    districtId: '9104030',
    name: 'Otemtra',
  },
  {
    id: '9104040001',
    districtId: '9104040',
    name: 'Wamesa II / Idor',
  },
  {
    id: '9104040002',
    districtId: '9104040',
    name: 'Yensei',
  },
  {
    id: '9104040003',
    districtId: '9104040',
    name: 'Wamesa I / Yakati',
  },
  {
    id: '9104040004',
    districtId: '9104040',
    name: 'Mamuranu',
  },
  {
    id: '9104040005',
    districtId: '9104040',
    name: 'Wasari',
  },
  {
    id: '9104040006',
    districtId: '9104040',
    name: 'Anakasi',
  },
  {
    id: '9104050001',
    districtId: '9104050',
    name: 'Bintuni Barat',
  },
  {
    id: '9104050002',
    districtId: '9104050',
    name: 'Wesiri',
  },
  {
    id: '9104050003',
    districtId: '9104050',
    name: 'Bintuni Timur',
  },
  {
    id: '9104050004',
    districtId: '9104050',
    name: 'Masina',
  },
  {
    id: '9104050005',
    districtId: '9104050',
    name: 'Sp V Manimery/ Argo Sigemeray',
  },
  {
    id: '9104050006',
    districtId: '9104050',
    name: 'Tuasai',
  },
  {
    id: '9104050007',
    districtId: '9104050',
    name: 'Iguriji',
  },
  {
    id: '9104050008',
    districtId: '9104050',
    name: 'Beimes',
  },
  {
    id: '9104050009',
    districtId: '9104050',
    name: 'Didguij',
  },
  {
    id: '9104050010',
    districtId: '9104050',
    name: 'Cutibo',
  },
  {
    id: '9104050011',
    districtId: '9104050',
    name: 'Trimoroi',
  },
  {
    id: '9104050012',
    districtId: '9104050',
    name: 'Asouw',
  },
  {
    id: '9104050013',
    districtId: '9104050',
    name: 'Kolak / Tolak',
  },
  {
    id: '9104050014',
    districtId: '9104050',
    name: 'Kohoin',
  },
  {
    id: '9104050015',
    districtId: '9104050',
    name: 'Tubi',
  },
  {
    id: '9104050016',
    districtId: '9104050',
    name: 'Kampung Lama',
  },
  {
    id: '9104050017',
    districtId: '9104050',
    name: 'Direb',
  },
  {
    id: '9104050018',
    districtId: '9104050',
    name: 'Missin',
  },
  {
    id: '9104050020',
    districtId: '9104050',
    name: 'Iguriji II',
  },
  {
    id: '9104050021',
    districtId: '9104050',
    name: 'Hokut',
  },
  {
    id: '9104050022',
    districtId: '9104050',
    name: 'Rosib',
  },
  {
    id: '9104050023',
    districtId: '9104050',
    name: 'Auaba',
  },
  {
    id: '9104050024',
    districtId: '9104050',
    name: 'Imbrij',
  },
  {
    id: '9104050025',
    districtId: '9104050',
    name: 'Dacna',
  },
  {
    id: '9104051001',
    districtId: '9104051',
    name: 'Bumi Saniari (Sp III)',
  },
  {
    id: '9104051002',
    districtId: '9104051',
    name: 'Banjar Ausoy (Sp IV)',
  },
  {
    id: '9104051003',
    districtId: '9104051',
    name: 'Waraitama (Spi)',
  },
  {
    id: '9104051004',
    districtId: '9104051',
    name: 'Atibo / Manimery',
  },
  {
    id: '9104051005',
    districtId: '9104051',
    name: 'Pasamai',
  },
  {
    id: '9104051006',
    districtId: '9104051',
    name: 'Korano Jaya (Sp II)',
  },
  {
    id: '9104051007',
    districtId: '9104051',
    name: 'Horna Baru',
  },
  {
    id: '9104051008',
    districtId: '9104051',
    name: 'Tinanteri / Manado',
  },
  {
    id: '9104051009',
    districtId: '9104051',
    name: 'Idut',
  },
  {
    id: '9104051010',
    districtId: '9104051',
    name: 'Muturi',
  },
  {
    id: '9104051011',
    districtId: '9104051',
    name: 'Tihibo',
  },
  {
    id: '9104051012',
    districtId: '9104051',
    name: 'Tirasai',
  },
  {
    id: '9104051013',
    districtId: '9104051',
    name: 'Botai',
  },
  {
    id: '9104051014',
    districtId: '9104051',
    name: 'Rubobo',
  },
  {
    id: '9104052001',
    districtId: '9104052',
    name: 'Tuhiba',
  },
  {
    id: '9104052002',
    districtId: '9104052',
    name: 'Tisaida',
  },
  {
    id: '9104052003',
    districtId: '9104052',
    name: 'Kucir',
  },
  {
    id: '9104052004',
    districtId: '9104052',
    name: 'Sibena Raya',
  },
  {
    id: '9104052005',
    districtId: '9104052',
    name: 'Sibena Permai',
  },
  {
    id: '9104052006',
    districtId: '9104052',
    name: 'Mincima',
  },
  {
    id: '9104052007',
    districtId: '9104052',
    name: 'Agomeda',
  },
  {
    id: '9104052008',
    districtId: '9104052',
    name: 'Inyesta',
  },
  {
    id: '9104052009',
    districtId: '9104052',
    name: 'Duhumenau',
  },
  {
    id: '9104052011',
    districtId: '9104052',
    name: 'Wassowi',
  },
  {
    id: '9104052012',
    districtId: '9104052',
    name: 'Usemebij / Kucir 2',
  },
  {
    id: '9104052013',
    districtId: '9104052',
    name: 'Kali Biru',
  },
  {
    id: '9104052014',
    districtId: '9104052',
    name: 'Titkai',
  },
  {
    id: '9104053001',
    districtId: '9104053',
    name: 'Horna',
  },
  {
    id: '9104053002',
    districtId: '9104053',
    name: 'Cumnaji',
  },
  {
    id: '9104053003',
    districtId: '9104053',
    name: 'Menci',
  },
  {
    id: '9104053004',
    districtId: '9104053',
    name: 'Sir',
  },
  {
    id: '9104053006',
    districtId: '9104053',
    name: 'Ugdohop',
  },
  {
    id: '9104053007',
    districtId: '9104053',
    name: 'Ahaura',
  },
  {
    id: '9104060001',
    districtId: '9104060',
    name: 'Tembuni',
  },
  {
    id: '9104060002',
    districtId: '9104060',
    name: 'Araisum',
  },
  {
    id: '9104060003',
    districtId: '9104060',
    name: 'Mogoy Baru',
  },
  {
    id: '9104060004',
    districtId: '9104060',
    name: 'Bangun Mulia (Stenkool I)',
  },
  {
    id: '9104060005',
    districtId: '9104060',
    name: 'Membera',
  },
  {
    id: '9104060006',
    districtId: '9104060',
    name: 'Ciner',
  },
  {
    id: '9104060007',
    districtId: '9104060',
    name: 'Muntop',
  },
  {
    id: '9104060009',
    districtId: '9104060',
    name: 'Pangkalan / Tussur',
  },
  {
    id: '9104060010',
    districtId: '9104060',
    name: 'Bangun Harjo',
  },
  {
    id: '9104070008',
    districtId: '9104070',
    name: 'Manunggal Jaya/Hti 2',
  },
  {
    id: '9104070009',
    districtId: '9104070',
    name: 'Kecap',
  },
  {
    id: '9104070010',
    districtId: '9104070',
    name: 'Aranday',
  },
  {
    id: '9104070011',
    districtId: '9104070',
    name: 'Kampung Baru',
  },
  {
    id: '9104070012',
    districtId: '9104070',
    name: 'Yakora',
  },
  {
    id: '9104070013',
    districtId: '9104070',
    name: 'Irira',
  },
  {
    id: '9104070014',
    districtId: '9104070',
    name: 'Botonik',
  },
  {
    id: '9104070015',
    districtId: '9104070',
    name: 'Kandarin',
  },
  {
    id: '9104071001',
    districtId: '9104071',
    name: 'Kalitami II',
  },
  {
    id: '9104071002',
    districtId: '9104071',
    name: 'Kalitami',
  },
  {
    id: '9104071003',
    districtId: '9104071',
    name: 'Kenara',
  },
  {
    id: '9104071004',
    districtId: '9104071',
    name: 'Bibiram',
  },
  {
    id: '9104071005',
    districtId: '9104071',
    name: 'Maroro',
  },
  {
    id: '9104072001',
    districtId: '9104072',
    name: 'Sebyar Rejosari',
  },
  {
    id: '9104072002',
    districtId: '9104072',
    name: 'Tomu',
  },
  {
    id: '9104072003',
    districtId: '9104072',
    name: 'Taroi',
  },
  {
    id: '9104072004',
    districtId: '9104072',
    name: 'Ekam',
  },
  {
    id: '9104072005',
    districtId: '9104072',
    name: 'Wanagir',
  },
  {
    id: '9104072006',
    districtId: '9104072',
    name: 'Ayut',
  },
  {
    id: '9104072007',
    districtId: '9104072',
    name: 'Adur',
  },
  {
    id: '9104072008',
    districtId: '9104072',
    name: 'Sorondaun',
  },
  {
    id: '9104072009',
    districtId: '9104072',
    name: 'Pera-Pera',
  },
  {
    id: '9104072010',
    districtId: '9104072',
    name: 'Tambanua',
  },
  {
    id: '9104072011',
    districtId: '9104072',
    name: 'Totitra',
  },
  {
    id: '9104073001',
    districtId: '9104073',
    name: 'Weriagar',
  },
  {
    id: '9104073002',
    districtId: '9104073',
    name: 'Mogotira',
  },
  {
    id: '9104073003',
    districtId: '9104073',
    name: 'Weriagar Baru',
  },
  {
    id: '9104073004',
    districtId: '9104073',
    name: 'Weriagar Utara',
  },
  {
    id: '9104073005',
    districtId: '9104073',
    name: 'Tuanakin',
  },
  {
    id: '9104073006',
    districtId: '9104073',
    name: 'Weriagar Selatan',
  },
  {
    id: '9104080001',
    districtId: '9104080',
    name: 'Jagiro',
  },
  {
    id: '9104080002',
    districtId: '9104080',
    name: 'Inggof',
  },
  {
    id: '9104080003',
    districtId: '9104080',
    name: 'Rawara',
  },
  {
    id: '9104080004',
    districtId: '9104080',
    name: 'Meyenda',
  },
  {
    id: '9104080008',
    districtId: '9104080',
    name: 'Barma Barat',
  },
  {
    id: '9104080009',
    districtId: '9104080',
    name: 'Mesih',
  },
  {
    id: '9104080010',
    districtId: '9104080',
    name: 'Mosusna',
  },
  {
    id: '9104080011',
    districtId: '9104080',
    name: 'Meridey',
  },
  {
    id: '9104080012',
    districtId: '9104080',
    name: 'Thimofro',
  },
  {
    id: '9104080013',
    districtId: '9104080',
    name: 'Yahtiwa',
  },
  {
    id: '9104080014',
    districtId: '9104080',
    name: 'Meyodo',
  },
  {
    id: '9104080015',
    districtId: '9104080',
    name: 'Irahima',
  },
  {
    id: '9104080016',
    districtId: '9104080',
    name: 'Orocomna',
  },
  {
    id: '9104080017',
    districtId: '9104080',
    name: 'Momiyefew',
  },
  {
    id: '9104080018',
    districtId: '9104080',
    name: 'Otwajd',
  },
  {
    id: '9104081001',
    districtId: '9104081',
    name: 'Meyado',
  },
  {
    id: '9104081002',
    districtId: '9104081',
    name: 'Barma',
  },
  {
    id: '9104081003',
    districtId: '9104081',
    name: 'Barma Baru / Stekool 2',
  },
  {
    id: '9104081004',
    districtId: '9104081',
    name: 'Vesco Damnem / Stenkool 3',
  },
  {
    id: '9104081005',
    districtId: '9104081',
    name: 'Meyado II',
  },
  {
    id: '9104081006',
    districtId: '9104081',
    name: 'Dagu',
  },
  {
    id: '9104081007',
    districtId: '9104081',
    name: 'Kaibur',
  },
  {
    id: '9104081008',
    districtId: '9104081',
    name: 'Manofi',
  },
  {
    id: '9104081009',
    districtId: '9104081',
    name: 'Kali Hitam',
  },
  {
    id: '9104082001',
    districtId: '9104082',
    name: 'Meyerga',
  },
  {
    id: '9104082002',
    districtId: '9104082',
    name: 'Macok',
  },
  {
    id: '9104082003',
    districtId: '9104082',
    name: 'Istikem',
  },
  {
    id: '9104082004',
    districtId: '9104082',
    name: 'Majnik',
  },
  {
    id: '9104082005',
    districtId: '9104082',
    name: 'Meyohda',
  },
  {
    id: '9104082006',
    districtId: '9104082',
    name: 'Inokra',
  },
  {
    id: '9104082007',
    districtId: '9104082',
    name: 'Igemi',
  },
  {
    id: '9104082008',
    districtId: '9104082',
    name: 'Merok',
  },
  {
    id: '9104082009',
    districtId: '9104082',
    name: 'Mahti',
  },
  {
    id: '9104082010',
    districtId: '9104082',
    name: 'Meserkir',
  },
  {
    id: '9104082011',
    districtId: '9104082',
    name: 'Mofickin',
  },
  {
    id: '9104082012',
    districtId: '9104082',
    name: 'Mereneitej',
  },
  {
    id: '9104082013',
    districtId: '9104082',
    name: 'Meyah',
  },
  {
    id: '9104082014',
    districtId: '9104082',
    name: 'Masefa',
  },
  {
    id: '9104090007',
    districtId: '9104090',
    name: 'Morombuy',
  },
  {
    id: '9104090012',
    districtId: '9104090',
    name: 'Meyom',
  },
  {
    id: '9104090017',
    districtId: '9104090',
    name: 'Anejero',
  },
  {
    id: '9104090018',
    districtId: '9104090',
    name: 'Mekiesefep',
  },
  {
    id: '9104090019',
    districtId: '9104090',
    name: 'Mogromus/Mogmen',
  },
  {
    id: '9104090020',
    districtId: '9104090',
    name: 'Meyejga',
  },
  {
    id: '9104090021',
    districtId: '9104090',
    name: 'Menggerba',
  },
  {
    id: '9104090022',
    districtId: '9104090',
    name: 'Meyokus',
  },
  {
    id: '9104090023',
    districtId: '9104090',
    name: 'Bomer',
  },
  {
    id: '9104090024',
    districtId: '9104090',
    name: 'Mojui',
  },
  {
    id: '9104090025',
    districtId: '9104090',
    name: 'Kewisini',
  },
  {
    id: '9104090026',
    districtId: '9104090',
    name: 'Meriraog',
  },
  {
    id: '9104090027',
    districtId: '9104090',
    name: 'Meyewah',
  },
  {
    id: '9104090028',
    districtId: '9104090',
    name: 'Taugo',
  },
  {
    id: '9104090029',
    districtId: '9104090',
    name: 'Mosoima',
  },
  {
    id: '9104090030',
    districtId: '9104090',
    name: 'Eneyinefa',
  },
  {
    id: '9104090031',
    districtId: '9104090',
    name: 'Mosodevew',
  },
  {
    id: '9104090033',
    districtId: '9104090',
    name: 'Makmi',
  },
  {
    id: '9104090034',
    districtId: '9104090',
    name: 'Merenusga',
  },
  {
    id: '9104090035',
    districtId: '9104090',
    name: 'Mear',
  },
  {
    id: '9104090036',
    districtId: '9104090',
    name: 'Massy',
  },
  {
    id: '9104090037',
    districtId: '9104090',
    name: 'Merifem',
  },
  {
    id: '9104090038',
    districtId: '9104090',
    name: 'Marmey',
  },
  {
    id: '9104091001',
    districtId: '9104091',
    name: 'Jahabra',
  },
  {
    id: '9104091002',
    districtId: '9104091',
    name: 'Ibori',
  },
  {
    id: '9104091004',
    districtId: '9104091',
    name: 'Meyorga',
  },
  {
    id: '9104091005',
    districtId: '9104091',
    name: 'Laudoho',
  },
  {
    id: '9104091006',
    districtId: '9104091',
    name: 'Eniba',
  },
  {
    id: '9104091007',
    districtId: '9104091',
    name: 'Mowtika',
  },
  {
    id: '9104091008',
    districtId: '9104091',
    name: 'Biscoop',
  },
  {
    id: '9104091009',
    districtId: '9104091',
    name: 'Dhija',
  },
  {
    id: '9104091010',
    districtId: '9104091',
    name: 'Tomou',
  },
  {
    id: '9104091011',
    districtId: '9104091',
    name: 'Mendesba',
  },
  {
    id: '9104091012',
    districtId: '9104091',
    name: 'Meyad / Meyoij',
  },
  {
    id: '9104091013',
    districtId: '9104091',
    name: 'Ijom',
  },
  {
    id: '9104091014',
    districtId: '9104091',
    name: 'Meminjem',
  },
  {
    id: '9104092001',
    districtId: '9104092',
    name: 'Masyeta',
  },
  {
    id: '9104092002',
    districtId: '9104092',
    name: 'Mestofu',
  },
  {
    id: '9104092003',
    districtId: '9104092',
    name: 'Kalibiru',
  },
  {
    id: '9104092004',
    districtId: '9104092',
    name: 'Mesomda',
  },
  {
    id: '9104092005',
    districtId: '9104092',
    name: 'Mesusuga',
  },
  {
    id: '9104092006',
    districtId: '9104092',
    name: 'Meygera',
  },
  {
    id: '9104092007',
    districtId: '9104092',
    name: 'Meyosa',
  },
  {
    id: '9104092009',
    districtId: '9104092',
    name: 'Meyar',
  },
  {
    id: '9104092010',
    districtId: '9104092',
    name: 'Onom',
  },
  {
    id: '9104092011',
    districtId: '9104092',
    name: 'Mayefeb',
  },
  {
    id: '9104092012',
    districtId: '9104092',
    name: 'Esnam',
  },
  {
    id: '9104092013',
    districtId: '9104092',
    name: 'Makwafeb',
  },
  {
    id: '9104092014',
    districtId: '9104092',
    name: 'Makira',
  },
  {
    id: '9104092015',
    districtId: '9104092',
    name: 'Imuj',
  },
  {
    id: '9104100001',
    districtId: '9104100',
    name: 'Moyeba',
  },
  {
    id: '9104100002',
    districtId: '9104100',
    name: 'Merestim',
  },
  {
    id: '9104100003',
    districtId: '9104100',
    name: 'Mosum',
  },
  {
    id: '9104100004',
    districtId: '9104100',
    name: 'Inofina',
  },
  {
    id: '9104100005',
    districtId: '9104100',
    name: 'Moyeba Utara',
  },
  {
    id: '9104100006',
    districtId: '9104100',
    name: 'Moyeba Timur',
  },
  {
    id: '9104100007',
    districtId: '9104100',
    name: 'Moyeba Barat',
  },
  {
    id: '9104100009',
    districtId: '9104100',
    name: 'Mesyem Timur',
  },
  {
    id: '9104100010',
    districtId: '9104100',
    name: 'Mosror',
  },
  {
    id: '9104101001',
    districtId: '9104101',
    name: 'Igomu',
  },
  {
    id: '9104101002',
    districtId: '9104101',
    name: 'Mesna',
  },
  {
    id: '9104101003',
    districtId: '9104101',
    name: 'Sumui',
  },
  {
    id: '9104101004',
    districtId: '9104101',
    name: 'Mesua / Meyera',
  },
  {
    id: '9104101005',
    districtId: '9104101',
    name: 'Injisni',
  },
  {
    id: '9104101006',
    districtId: '9104101',
    name: 'Mesimer / Mesoimen',
  },
  {
    id: '9104101007',
    districtId: '9104101',
    name: 'Injeif',
  },
  {
    id: '9104101008',
    districtId: '9104101',
    name: 'Isurkohmey',
  },
  {
    id: '9104101011',
    districtId: '9104101',
    name: 'Merenefa',
  },
  {
    id: '9104101012',
    districtId: '9104101',
    name: 'Kaibur',
  },
  {
    id: '9105110001',
    districtId: '9105110',
    name: 'Nimbay',
  },
  {
    id: '9105110002',
    districtId: '9105110',
    name: 'Prafi Kampung / Indise',
  },
  {
    id: '9105110003',
    districtId: '9105110',
    name: 'Subsay',
  },
  {
    id: '9105110004',
    districtId: '9105110',
    name: 'Meniy',
  },
  {
    id: '9105110005',
    districtId: '9105110',
    name: 'Madrat',
  },
  {
    id: '9105110006',
    districtId: '9105110',
    name: 'Dindey',
  },
  {
    id: '9105110008',
    districtId: '9105110',
    name: 'Warmare',
  },
  {
    id: '9105110009',
    districtId: '9105110',
    name: 'Tanah Merah',
  },
  {
    id: '9105110010',
    districtId: '9105110',
    name: 'Hingk',
  },
  {
    id: '9105110012',
    districtId: '9105110',
    name: 'Snaimboy',
  },
  {
    id: '9105110013',
    districtId: '9105110',
    name: 'Ibuwau',
  },
  {
    id: '9105110014',
    districtId: '9105110',
    name: 'Cening/Sotea',
  },
  {
    id: '9105110015',
    districtId: '9105110',
    name: 'Duwin Umsini',
  },
  {
    id: '9105110016',
    districtId: '9105110',
    name: 'Gueintuy',
  },
  {
    id: '9105110017',
    districtId: '9105110',
    name: 'Imboisrati',
  },
  {
    id: '9105110018',
    districtId: '9105110',
    name: 'Sraindabey',
  },
  {
    id: '9105110019',
    districtId: '9105110',
    name: 'Minogbey / Minbey',
  },
  {
    id: '9105110020',
    districtId: '9105110',
    name: 'Kwau',
  },
  {
    id: '9105110021',
    districtId: '9105110',
    name: 'Indobey',
  },
  {
    id: '9105110022',
    districtId: '9105110',
    name: 'Figoud',
  },
  {
    id: '9105110023',
    districtId: '9105110',
    name: 'Syou',
  },
  {
    id: '9105110024',
    districtId: '9105110',
    name: 'Minggre',
  },
  {
    id: '9105110025',
    districtId: '9105110',
    name: 'Dueibei',
  },
  {
    id: '9105110026',
    districtId: '9105110',
    name: 'Asarbey',
  },
  {
    id: '9105110027',
    districtId: '9105110',
    name: 'Kipouw',
  },
  {
    id: '9105110028',
    districtId: '9105110',
    name: 'Mokwam',
  },
  {
    id: '9105110029',
    districtId: '9105110',
    name: 'Amber',
  },
  {
    id: '9105110030',
    districtId: '9105110',
    name: 'Bahamyenti',
  },
  {
    id: '9105110031',
    districtId: '9105110',
    name: 'Aywou',
  },
  {
    id: '9105120002',
    districtId: '9105120',
    name: 'Waseki Indah',
  },
  {
    id: '9105120003',
    districtId: '9105120',
    name: 'Waseki',
  },
  {
    id: '9105120004',
    districtId: '9105120',
    name: 'Aimasi/Sp III Aimasi',
  },
  {
    id: '9105120005',
    districtId: '9105120',
    name: 'Udapi Hilir',
  },
  {
    id: '9105120006',
    districtId: '9105120',
    name: 'Desay',
  },
  {
    id: '9105120007',
    districtId: '9105120',
    name: 'Prafi Mulia',
  },
  {
    id: '9105120008',
    districtId: '9105120',
    name: 'Ingkwoisi',
  },
  {
    id: '9105120009',
    districtId: '9105120',
    name: 'Umbui',
  },
  {
    id: '9105120010',
    districtId: '9105120',
    name: 'Bogor',
  },
  {
    id: '9105120011',
    districtId: '9105120',
    name: 'Kali Amin',
  },
  {
    id: '9105120012',
    districtId: '9105120',
    name: 'Oyehek Brik',
  },
  {
    id: '9105120013',
    districtId: '9105120',
    name: 'Krenui',
  },
  {
    id: '9105120014',
    districtId: '9105120',
    name: 'Somi',
  },
  {
    id: '9105120015',
    districtId: '9105120',
    name: 'Matoa',
  },
  {
    id: '9105120016',
    districtId: '9105120',
    name: 'Lismaungu',
  },
  {
    id: '9105120017',
    districtId: '9105120',
    name: 'Jouben',
  },
  {
    id: '9105141001',
    districtId: '9105141',
    name: 'Tanah Merah Indah',
  },
  {
    id: '9105141002',
    districtId: '9105141',
    name: 'Soribo',
  },
  {
    id: '9105141003',
    districtId: '9105141',
    name: 'Wosi',
  },
  {
    id: '9105141004',
    districtId: '9105141',
    name: 'Sanggeng',
  },
  {
    id: '9105141005',
    districtId: '9105141',
    name: 'Manokwari Barat',
  },
  {
    id: '9105141006',
    districtId: '9105141',
    name: 'Padarni',
  },
  {
    id: '9105141007',
    districtId: '9105141',
    name: 'Manokwari Timur',
  },
  {
    id: '9105141008',
    districtId: '9105141',
    name: 'Amban',
  },
  {
    id: '9105141009',
    districtId: '9105141',
    name: 'Inggramui',
  },
  {
    id: '9105141010',
    districtId: '9105141',
    name: 'Udopi',
  },
  {
    id: '9105142001',
    districtId: '9105142',
    name: 'Mansinam',
  },
  {
    id: '9105142002',
    districtId: '9105142',
    name: 'Pasir Putih',
  },
  {
    id: '9105142003',
    districtId: '9105142',
    name: 'Arowi',
  },
  {
    id: '9105142004',
    districtId: '9105142',
    name: 'Bakaro',
  },
  {
    id: '9105142005',
    districtId: '9105142',
    name: 'Aipiri',
  },
  {
    id: '9105142006',
    districtId: '9105142',
    name: 'Sunsweni',
  },
  {
    id: '9105142007',
    districtId: '9105142',
    name: 'Ayambori',
  },
  {
    id: '9105143001',
    districtId: '9105143',
    name: 'Inoduas',
  },
  {
    id: '9105143002',
    districtId: '9105143',
    name: 'Cabang Dua',
  },
  {
    id: '9105143003',
    districtId: '9105143',
    name: 'Pami',
  },
  {
    id: '9105143004',
    districtId: '9105143',
    name: 'Sayro',
  },
  {
    id: '9105143005',
    districtId: '9105143',
    name: 'Bremi',
  },
  {
    id: '9105143006',
    districtId: '9105143',
    name: 'Yoom I',
  },
  {
    id: '9105143007',
    districtId: '9105143',
    name: 'Meinyumfoka',
  },
  {
    id: '9105143008',
    districtId: '9105143',
    name: 'Lebau',
  },
  {
    id: '9105143009',
    districtId: '9105143',
    name: 'Saubeba',
  },
  {
    id: '9105143010',
    districtId: '9105143',
    name: 'Yoom II',
  },
  {
    id: '9105143011',
    districtId: '9105143',
    name: 'Tanah Rubu',
  },
  {
    id: '9105143012',
    districtId: '9105143',
    name: 'Asay',
  },
  {
    id: '9105143013',
    districtId: '9105143',
    name: 'Menaito / Mubraidiba',
  },
  {
    id: '9105143014',
    districtId: '9105143',
    name: 'Mandopi',
  },
  {
    id: '9105143015',
    districtId: '9105143',
    name: 'Mubri',
  },
  {
    id: '9105143016',
    districtId: '9105143',
    name: 'Teluk Mubri',
  },
  {
    id: '9105143018',
    districtId: '9105143',
    name: 'Inya',
  },
  {
    id: '9105143019',
    districtId: '9105143',
    name: 'Warbepor',
  },
  {
    id: '9105143020',
    districtId: '9105143',
    name: 'Yonggam',
  },
  {
    id: '9105143021',
    districtId: '9105143',
    name: 'Singgimeba',
  },
  {
    id: '9105143024',
    districtId: '9105143',
    name: 'Inyei',
  },
  {
    id: '9105143025',
    districtId: '9105143',
    name: 'Indosufa . Indo Oufa',
  },
  {
    id: '9105144001',
    districtId: '9105144',
    name: 'Acemo',
  },
  {
    id: '9105144002',
    districtId: '9105144',
    name: 'Warsuami',
  },
  {
    id: '9105144004',
    districtId: '9105144',
    name: 'Mupi',
  },
  {
    id: '9105144007',
    districtId: '9105144',
    name: 'Angrisi',
  },
  {
    id: '9105144009',
    districtId: '9105144',
    name: 'Misapmeysi',
  },
  {
    id: '9105144012',
    districtId: '9105144',
    name: 'Maruni',
  },
  {
    id: '9105144013',
    districtId: '9105144',
    name: 'Wamesa',
  },
  {
    id: '9105144014',
    districtId: '9105144',
    name: 'Anday',
  },
  {
    id: '9105144015',
    districtId: '9105144',
    name: 'Waruri / Weluri',
  },
  {
    id: '9105144016',
    districtId: '9105144',
    name: 'Wasay',
  },
  {
    id: '9105144017',
    districtId: '9105144',
    name: 'Warmumi',
  },
  {
    id: '9105144018',
    districtId: '9105144',
    name: 'Dihara',
  },
  {
    id: '9105144019',
    districtId: '9105144',
    name: 'Katebu',
  },
  {
    id: '9105144020',
    districtId: '9105144',
    name: 'Masiepi',
  },
  {
    id: '9105144021',
    districtId: '9105144',
    name: 'Sowi',
  },
  {
    id: '9105144022',
    districtId: '9105144',
    name: 'Doput',
  },
  {
    id: '9105144023',
    districtId: '9105144',
    name: 'Warkomi',
  },
  {
    id: '9105144024',
    districtId: '9105144',
    name: 'Nginybou / Ngunibouw',
  },
  {
    id: '9105146002',
    districtId: '9105146',
    name: 'Misabugoid',
  },
  {
    id: '9105146003',
    districtId: '9105146',
    name: 'Mbata',
  },
  {
    id: '9105146004',
    districtId: '9105146',
    name: 'Hanghow',
  },
  {
    id: '9105146005',
    districtId: '9105146',
    name: 'Ningdip',
  },
  {
    id: '9105146006',
    districtId: '9105146',
    name: 'Ruambei / Urwambei',
  },
  {
    id: '9105146007',
    districtId: '9105146',
    name: 'Imboiti',
  },
  {
    id: '9105146008',
    districtId: '9105146',
    name: 'Wariari',
  },
  {
    id: '9105146014',
    districtId: '9105146',
    name: 'Warami',
  },
  {
    id: '9105146015',
    districtId: '9105146',
    name: 'Imhasuma',
  },
  {
    id: '9105146016',
    districtId: '9105146',
    name: 'Imbaisika I',
  },
  {
    id: '9105146017',
    districtId: '9105146',
    name: 'Imbaisika II/Imboysika',
  },
  {
    id: '9105146019',
    districtId: '9105146',
    name: 'Ungkopti',
  },
  {
    id: '9105146020',
    districtId: '9105146',
    name: 'Warkapi',
  },
  {
    id: '9105146021',
    districtId: '9105146',
    name: 'Mironi',
  },
  {
    id: '9105146022',
    districtId: '9105146',
    name: 'Ayawi',
  },
  {
    id: '9105146023',
    districtId: '9105146',
    name: 'Indibo',
  },
  {
    id: '9105146024',
    districtId: '9105146',
    name: 'Warmarway',
  },
  {
    id: '9105146030',
    districtId: '9105146',
    name: 'Wedoni',
  },
  {
    id: '9105146031',
    districtId: '9105146',
    name: 'Wamigti',
  },
  {
    id: '9105146032',
    districtId: '9105146',
    name: 'Ukembousi',
  },
  {
    id: '9105146033',
    districtId: '9105146',
    name: 'Meinyumfoku',
  },
  {
    id: '9105170004',
    districtId: '9105170',
    name: 'Igor',
  },
  {
    id: '9105170005',
    districtId: '9105170',
    name: 'Membowi',
  },
  {
    id: '9105170006',
    districtId: '9105170',
    name: 'Makwan',
  },
  {
    id: '9105170007',
    districtId: '9105170',
    name: 'Macuan/Sp V',
  },
  {
    id: '9105170008',
    districtId: '9105170',
    name: 'Prafi Barat',
  },
  {
    id: '9105170009',
    districtId: '9105170',
    name: 'Meiforga',
  },
  {
    id: '9105170010',
    districtId: '9105170',
    name: 'Kali Merah',
  },
  {
    id: '9105170011',
    districtId: '9105170',
    name: 'Muara Prafi/Prafi Timur',
  },
  {
    id: '9105170012',
    districtId: '9105170',
    name: 'Bowi Subur/Sp VI',
  },
  {
    id: '9105170013',
    districtId: '9105170',
    name: 'Sembab',
  },
  {
    id: '9105170014',
    districtId: '9105170',
    name: 'Sumber Boga/Sp VII',
  },
  {
    id: '9105170015',
    districtId: '9105170',
    name: 'Wariori',
  },
  {
    id: '9105170016',
    districtId: '9105170',
    name: 'Aurmios',
  },
  {
    id: '9105170023',
    districtId: '9105170',
    name: 'Mansaburi/Smaryam',
  },
  {
    id: '9105170024',
    districtId: '9105170',
    name: 'Masni',
  },
  {
    id: '9105170026',
    districtId: '9105170',
    name: 'Sibuni',
  },
  {
    id: '9105170033',
    districtId: '9105170',
    name: 'Wam Bola',
  },
  {
    id: '9105170034',
    districtId: '9105170',
    name: 'Wariori Indah',
  },
  {
    id: '9105170035',
    districtId: '9105170',
    name: 'Ririnfos',
  },
  {
    id: '9105170036',
    districtId: '9105170',
    name: 'Mobja',
  },
  {
    id: '9105170038',
    districtId: '9105170',
    name: 'Jowen',
  },
  {
    id: '9105170039',
    districtId: '9105170',
    name: 'Aska',
  },
  {
    id: '9105170040',
    districtId: '9105170',
    name: 'Mantedi',
  },
  {
    id: '9105170041',
    districtId: '9105170',
    name: 'Koyani',
  },
  {
    id: '9105170042',
    districtId: '9105170',
    name: 'Muara Wariori',
  },
  {
    id: '9105170043',
    districtId: '9105170',
    name: 'Undi',
  },
  {
    id: '9105170044',
    districtId: '9105170',
    name: 'Yen Soribo',
  },
  {
    id: '9105170047',
    districtId: '9105170',
    name: 'Meyof II',
  },
  {
    id: '9105171001',
    districtId: '9105171',
    name: 'Kaironi',
  },
  {
    id: '9105171002',
    districtId: '9105171',
    name: 'Waramui',
  },
  {
    id: '9105171003',
    districtId: '9105171',
    name: 'Sidey Jaya',
  },
  {
    id: '9105171004',
    districtId: '9105171',
    name: 'Saray',
  },
  {
    id: '9105171005',
    districtId: '9105171',
    name: 'Sidey Makmur',
  },
  {
    id: '9105171006',
    districtId: '9105171',
    name: 'Kasi',
  },
  {
    id: '9105171007',
    districtId: '9105171',
    name: 'Sidey',
  },
  {
    id: '9105171008',
    districtId: '9105171',
    name: 'Sidey Baru',
  },
  {
    id: '9105171009',
    districtId: '9105171',
    name: 'Wamnowi',
  },
  {
    id: '9105171010',
    districtId: '9105171',
    name: 'Wariki',
  },
  {
    id: '9105171011',
    districtId: '9105171',
    name: 'Meyof I',
  },
  {
    id: '9105171012',
    districtId: '9105171',
    name: 'Manggupi',
  },
  {
    id: '9106010001',
    districtId: '9106010',
    name: 'Mate',
  },
  {
    id: '9106010002',
    districtId: '9106010',
    name: 'Wadoi',
  },
  {
    id: '9106010003',
    districtId: '9106010',
    name: 'Sibae',
  },
  {
    id: '9106010004',
    districtId: '9106010',
    name: 'Isogo',
  },
  {
    id: '9106010017',
    districtId: '9106010',
    name: 'Serkos',
  },
  {
    id: '9106010019',
    districtId: '9106010',
    name: 'Solta Baru',
  },
  {
    id: '9106010021',
    districtId: '9106010',
    name: 'Nogibi',
  },
  {
    id: '9106010022',
    districtId: '9106010',
    name: 'Odeare',
  },
  {
    id: '9106010023',
    districtId: '9106010',
    name: 'Siri-Siri',
  },
  {
    id: '9106011001',
    districtId: '9106011',
    name: 'Mugim',
  },
  {
    id: '9106011002',
    districtId: '9106011',
    name: 'Nusa',
  },
  {
    id: '9106011003',
    districtId: '9106011',
    name: 'Saga',
  },
  {
    id: '9106011004',
    districtId: '9106011',
    name: 'Puragi',
  },
  {
    id: '9106011005',
    districtId: '9106011',
    name: 'Tawanggire',
  },
  {
    id: '9106011006',
    districtId: '9106011',
    name: 'Bedare',
  },
  {
    id: '9106020001',
    districtId: '9106020',
    name: 'Migori',
  },
  {
    id: '9106020002',
    districtId: '9106020',
    name: 'Siwatori',
  },
  {
    id: '9106020003',
    districtId: '9106020',
    name: 'Tarof',
  },
  {
    id: '9106020004',
    districtId: '9106020',
    name: 'Tambani',
  },
  {
    id: '9106020005',
    districtId: '9106020',
    name: 'Negeri Besar',
  },
  {
    id: '9106020006',
    districtId: '9106020',
    name: 'Kasuweri',
  },
  {
    id: '9106020010',
    districtId: '9106020',
    name: 'Korewatara',
  },
  {
    id: '9106020011',
    districtId: '9106020',
    name: 'Tapas',
  },
  {
    id: '9106020012',
    districtId: '9106020',
    name: 'Totona',
  },
  {
    id: '9106020013',
    districtId: '9106020',
    name: 'Daubak',
  },
  {
    id: '9106020014',
    districtId: '9106020',
    name: 'Topdan',
  },
  {
    id: '9106020015',
    districtId: '9106020',
    name: 'Nayakore',
  },
  {
    id: '9106020016',
    districtId: '9106020',
    name: 'Migirito',
  },
  {
    id: '9106020017',
    districtId: '9106020',
    name: 'Arbasina',
  },
  {
    id: '9106020018',
    districtId: '9106020',
    name: 'Birawaku',
  },
  {
    id: '9106020021',
    districtId: '9106020',
    name: 'Daimar',
  },
  {
    id: '9106021001',
    districtId: '9106021',
    name: 'Tapuri',
  },
  {
    id: '9106021002',
    districtId: '9106021',
    name: 'Benawa I',
  },
  {
    id: '9106021003',
    districtId: '9106021',
    name: 'Sumano',
  },
  {
    id: '9106021004',
    districtId: '9106021',
    name: 'Kais',
  },
  {
    id: '9106021005',
    districtId: '9106021',
    name: 'Yahadian',
  },
  {
    id: '9106021006',
    districtId: '9106021',
    name: 'Makaroro',
  },
  {
    id: '9106022001',
    districtId: '9106022',
    name: 'Kayubiro',
  },
  {
    id: '9106022002',
    districtId: '9106022',
    name: 'Udagaga',
  },
  {
    id: '9106022003',
    districtId: '9106022',
    name: 'Adona',
  },
  {
    id: '9106022004',
    districtId: '9106022',
    name: 'Benawa II',
  },
  {
    id: '9106022005',
    districtId: '9106022',
    name: 'Atori / Kambur',
  },
  {
    id: '9106022006',
    districtId: '9106022',
    name: 'Kamundan',
  },
  {
    id: '9106022007',
    districtId: '9106022',
    name: 'Bubuko',
  },
  {
    id: '9106022008',
    districtId: '9106022',
    name: 'Karirif',
  },
  {
    id: '9106022009',
    districtId: '9106022',
    name: 'Kamundan II',
  },
  {
    id: '9106023001',
    districtId: '9106023',
    name: 'Mogatemin',
  },
  {
    id: '9106023002',
    districtId: '9106023',
    name: 'Onimsefa',
  },
  {
    id: '9106023003',
    districtId: '9106023',
    name: 'Siranggo',
  },
  {
    id: '9106023004',
    districtId: '9106023',
    name: 'Ikana',
  },
  {
    id: '9106023005',
    districtId: '9106023',
    name: 'Mukamat',
  },
  {
    id: '9106023006',
    districtId: '9106023',
    name: 'Haimaran',
  },
  {
    id: '9106060001',
    districtId: '9106060',
    name: 'Bumi Ajo (Sp I)',
  },
  {
    id: '9106060002',
    districtId: '9106060',
    name: 'Hasik Jaya (Sp II)',
  },
  {
    id: '9106060003',
    districtId: '9106060',
    name: 'Moswaren',
  },
  {
    id: '9106060004',
    districtId: '9106060',
    name: 'Joshiro',
  },
  {
    id: '9106060005',
    districtId: '9106060',
    name: 'Kamisabe',
  },
  {
    id: '9106060006',
    districtId: '9106060',
    name: 'Hararo',
  },
  {
    id: '9106060007',
    districtId: '9106060',
    name: 'Tokass',
  },
  {
    id: '9106070008',
    districtId: '9106070',
    name: 'Wersar',
  },
  {
    id: '9106070014',
    districtId: '9106070',
    name: 'Seribauw',
  },
  {
    id: '9106070015',
    districtId: '9106070',
    name: 'Kohoin',
  },
  {
    id: '9106070016',
    districtId: '9106070',
    name: 'Aibobor',
  },
  {
    id: '9106070017',
    districtId: '9106070',
    name: 'Wehali',
  },
  {
    id: '9106070018',
    districtId: '9106070',
    name: 'Kaibus',
  },
  {
    id: '9106070019',
    districtId: '9106070',
    name: 'Wermit',
  },
  {
    id: '9106070021',
    districtId: '9106070',
    name: 'Tapiri',
  },
  {
    id: '9106070022',
    districtId: '9106070',
    name: 'Tegirolo',
  },
  {
    id: '9106070023',
    districtId: '9106070',
    name: 'Gorolo',
  },
  {
    id: '9106070024',
    districtId: '9106070',
    name: 'Magis',
  },
  {
    id: '9106070025',
    districtId: '9106070',
    name: 'Namro',
  },
  {
    id: '9106070026',
    districtId: '9106070',
    name: 'Sayolo',
  },
  {
    id: '9106070027',
    districtId: '9106070',
    name: 'Wernas',
  },
  {
    id: '9106070029',
    districtId: '9106070',
    name: 'Anny',
  },
  {
    id: '9106071006',
    districtId: '9106071',
    name: 'Woloin',
  },
  {
    id: '9106071007',
    districtId: '9106071',
    name: 'Haha',
  },
  {
    id: '9106071008',
    districtId: '9106071',
    name: 'Tofot',
  },
  {
    id: '9106071013',
    districtId: '9106071',
    name: 'Klaugin',
  },
  {
    id: '9106071014',
    districtId: '9106071',
    name: 'Srer Sembra',
  },
  {
    id: '9106071015',
    districtId: '9106071',
    name: 'Sbir',
  },
  {
    id: '9106071016',
    districtId: '9106071',
    name: 'Kamaro',
  },
  {
    id: '9106071017',
    districtId: '9106071',
    name: 'Kakas',
  },
  {
    id: '9106072003',
    districtId: '9106072',
    name: 'Waigo',
  },
  {
    id: '9106072004',
    districtId: '9106072',
    name: 'Wardik',
  },
  {
    id: '9106072005',
    districtId: '9106072',
    name: 'Boldon',
  },
  {
    id: '9106072006',
    districtId: '9106072',
    name: 'Sesor',
  },
  {
    id: '9106072007',
    districtId: '9106072',
    name: 'Wayer',
  },
  {
    id: '9106072008',
    districtId: '9106072',
    name: 'Unggi',
  },
  {
    id: '9106072009',
    districtId: '9106072',
    name: 'Bagraga',
  },
  {
    id: '9106073001',
    districtId: '9106073',
    name: 'Wamargege',
  },
  {
    id: '9106073002',
    districtId: '9106073',
    name: 'Konda',
  },
  {
    id: '9106073003',
    districtId: '9106073',
    name: 'Nakna',
  },
  {
    id: '9106073004',
    districtId: '9106073',
    name: 'Manelek',
  },
  {
    id: '9106073005',
    districtId: '9106073',
    name: 'Bariat',
  },
  {
    id: '9106074001',
    districtId: '9106074',
    name: 'Kayabo',
  },
  {
    id: '9106074002',
    districtId: '9106074',
    name: 'Sayal / Seremuk',
  },
  {
    id: '9106074003',
    districtId: '9106074',
    name: 'Komanggaret',
  },
  {
    id: '9106074004',
    districtId: '9106074',
    name: 'Manggroholo',
  },
  {
    id: '9106074005',
    districtId: '9106074',
    name: 'Sira',
  },
  {
    id: '9106074006',
    districtId: '9106074',
    name: 'Mlaswat',
  },
  {
    id: '9106074007',
    districtId: '9106074',
    name: 'Kwowok',
  },
  {
    id: '9106074008',
    districtId: '9106074',
    name: 'Sisir',
  },
  {
    id: '9106074009',
    districtId: '9106074',
    name: 'Kenaya',
  },
  {
    id: '9106074010',
    districtId: '9106074',
    name: 'Botain',
  },
  {
    id: '9106080004',
    districtId: '9106080',
    name: 'Sasnek',
  },
  {
    id: '9106080006',
    districtId: '9106080',
    name: 'Sawiat',
  },
  {
    id: '9106080010',
    districtId: '9106080',
    name: 'Wendi',
  },
  {
    id: '9106080011',
    districtId: '9106080',
    name: 'Sfagyo',
  },
  {
    id: '9106080012',
    districtId: '9106080',
    name: 'Sudrofoyo',
  },
  {
    id: '9106080013',
    districtId: '9106080',
    name: 'Wensoug',
  },
  {
    id: '9106081001',
    districtId: '9106081',
    name: 'Pasir Putih',
  },
  {
    id: '9106081004',
    districtId: '9106081',
    name: 'Wondum',
  },
  {
    id: '9106082001',
    districtId: '9106082',
    name: 'Kofalit',
  },
  {
    id: '9106082002',
    districtId: '9106082',
    name: 'Wenslolo',
  },
  {
    id: '9106082003',
    districtId: '9106082',
    name: 'Klamit',
  },
  {
    id: '9106082004',
    districtId: '9106082',
    name: 'Alma',
  },
  {
    id: '9106082005',
    districtId: '9106082',
    name: 'Mlabolo',
  },
  {
    id: '9107061001',
    districtId: '9107061',
    name: 'Klamugun',
  },
  {
    id: '9107061002',
    districtId: '9107061',
    name: 'Siwis',
  },
  {
    id: '9107061005',
    districtId: '9107061',
    name: 'Miskum',
  },
  {
    id: '9107061010',
    districtId: '9107061',
    name: 'Sbaga',
  },
  {
    id: '9107061011',
    districtId: '9107061',
    name: 'Klalik',
  },
  {
    id: '9107061012',
    districtId: '9107061',
    name: 'Malawhili',
  },
  {
    id: '9107062001',
    districtId: '9107062',
    name: 'Selekobo',
  },
  {
    id: '9107062004',
    districtId: '9107062',
    name: 'Klamede',
  },
  {
    id: '9107062005',
    districtId: '9107062',
    name: 'Sambatie',
  },
  {
    id: '9107062006',
    districtId: '9107062',
    name: 'Klagele',
  },
  {
    id: '9107100005',
    districtId: '9107100',
    name: 'Asbaken',
  },
  {
    id: '9107100006',
    districtId: '9107100',
    name: 'Malaumkarta',
  },
  {
    id: '9107100007',
    districtId: '9107100',
    name: 'Makbon',
  },
  {
    id: '9107100008',
    districtId: '9107100',
    name: 'Batu Lobang',
  },
  {
    id: '9107100009',
    districtId: '9107100',
    name: 'Batu Lobang Pantai',
  },
  {
    id: '9107100010',
    districtId: '9107100',
    name: 'Baingkete',
  },
  {
    id: '9107100011',
    districtId: '9107100',
    name: 'Kuadas',
  },
  {
    id: '9107100012',
    districtId: '9107100',
    name: 'Sawatuk',
  },
  {
    id: '9107100013',
    districtId: '9107100',
    name: 'Teluk Dore',
  },
  {
    id: '9107101001',
    districtId: '9107101',
    name: 'Klayili',
  },
  {
    id: '9107101002',
    districtId: '9107101',
    name: 'Malalilis',
  },
  {
    id: '9107101003',
    districtId: '9107101',
    name: 'Mahgufuk',
  },
  {
    id: '9107101004',
    districtId: '9107101',
    name: 'Mlasli/Kwakeik',
  },
  {
    id: '9107101005',
    districtId: '9107101',
    name: 'Malakobutuk',
  },
  {
    id: '9107110004',
    districtId: '9107110',
    name: 'Wanurian',
  },
  {
    id: '9107110015',
    districtId: '9107110',
    name: 'Klabra',
  },
  {
    id: '9107110016',
    districtId: '9107110',
    name: 'Kaas',
  },
  {
    id: '9107110017',
    districtId: '9107110',
    name: 'Klarion',
  },
  {
    id: '9107110019',
    districtId: '9107110',
    name: 'Mumpi',
  },
  {
    id: '9107110020',
    districtId: '9107110',
    name: 'Wensi',
  },
  {
    id: '9107110021',
    districtId: '9107110',
    name: 'Serselion',
  },
  {
    id: '9107110022',
    districtId: '9107110',
    name: 'Klawom',
  },
  {
    id: '9107110023',
    districtId: '9107110',
    name: 'Klamak',
  },
  {
    id: '9107110024',
    districtId: '9107110',
    name: 'Kmafo',
  },
  {
    id: '9107110025',
    districtId: '9107110',
    name: 'Midlal',
  },
  {
    id: '9107110026',
    districtId: '9107110',
    name: 'Sorain',
  },
  {
    id: '9107110027',
    districtId: '9107110',
    name: 'Armoin',
  },
  {
    id: '9107111003',
    districtId: '9107111',
    name: 'Wariau (Sp I)',
  },
  {
    id: '9107111004',
    districtId: '9107111',
    name: 'Klawana',
  },
  {
    id: '9107111005',
    districtId: '9107111',
    name: 'Klamono',
  },
  {
    id: '9107111008',
    districtId: '9107111',
    name: 'Gisim Darat',
  },
  {
    id: '9107111009',
    districtId: '9107111',
    name: 'Klalomon',
  },
  {
    id: '9107111011',
    districtId: '9107111',
    name: 'Wonosari',
  },
  {
    id: '9107111012',
    districtId: '9107111',
    name: 'Mlais',
  },
  {
    id: '9107111014',
    districtId: '9107111',
    name: 'Mlasmily',
  },
  {
    id: '9107111015',
    districtId: '9107111',
    name: 'Klasafet',
  },
  {
    id: '9107111016',
    districtId: '9107111',
    name: 'Posa',
  },
  {
    id: '9107112001',
    districtId: '9107112',
    name: 'Mlawes',
  },
  {
    id: '9107112002',
    districtId: '9107112',
    name: 'Malat',
  },
  {
    id: '9107112003',
    districtId: '9107112',
    name: 'Klabot',
  },
  {
    id: '9107112004',
    districtId: '9107112',
    name: 'Indiwi',
  },
  {
    id: '9107112009',
    districtId: '9107112',
    name: 'Warkti',
  },
  {
    id: '9107112010',
    districtId: '9107112',
    name: 'Somir',
  },
  {
    id: '9107112011',
    districtId: '9107112',
    name: 'Klanolo',
  },
  {
    id: '9107112012',
    districtId: '9107112',
    name: 'Mlasfa',
  },
  {
    id: '9107113003',
    districtId: '9107113',
    name: 'Tbotjin',
  },
  {
    id: '9107113004',
    districtId: '9107113',
    name: 'Mlawen',
  },
  {
    id: '9107113005',
    districtId: '9107113',
    name: 'Sas',
  },
  {
    id: '9107113006',
    districtId: '9107113',
    name: 'Wilty',
  },
  {
    id: '9107113007',
    districtId: '9107113',
    name: 'Byaklokfle',
  },
  {
    id: '9107113010',
    districtId: '9107113',
    name: 'Samoslo',
  },
  {
    id: '9107113011',
    districtId: '9107113',
    name: 'Kmasen',
  },
  {
    id: '9107113012',
    districtId: '9107113',
    name: 'Yurkaden',
  },
  {
    id: '9107113013',
    districtId: '9107113',
    name: 'Bertwaf',
  },
  {
    id: '9107113014',
    districtId: '9107113',
    name: 'Mlaron',
  },
  {
    id: '9107113015',
    districtId: '9107113',
    name: 'Klasawon',
  },
  {
    id: '9107113016',
    districtId: '9107113',
    name: 'Cokhif',
  },
  {
    id: '9107114001',
    districtId: '9107114',
    name: 'Disfra',
  },
  {
    id: '9107114002',
    districtId: '9107114',
    name: 'Bagun',
  },
  {
    id: '9107114003',
    districtId: '9107114',
    name: 'Klawom',
  },
  {
    id: '9107114004',
    districtId: '9107114',
    name: 'Klamomis',
  },
  {
    id: '9107114005',
    districtId: '9107114',
    name: 'Klakwonrit',
  },
  {
    id: '9107114006',
    districtId: '9107114',
    name: 'Mode',
  },
  {
    id: '9107114007',
    districtId: '9107114',
    name: 'Bratmawe',
  },
  {
    id: '9107114008',
    districtId: '9107114',
    name: 'Klawon',
  },
  {
    id: '9107114009',
    districtId: '9107114',
    name: 'Mlamli',
  },
  {
    id: '9107115001',
    districtId: '9107115',
    name: 'Maladuk',
  },
  {
    id: '9107115002',
    districtId: '9107115',
    name: 'Klamono Olie',
  },
  {
    id: '9107115003',
    districtId: '9107115',
    name: 'Barros',
  },
  {
    id: '9107115004',
    districtId: '9107115',
    name: 'Tiligum',
  },
  {
    id: '9107115005',
    districtId: '9107115',
    name: 'Kwawilibe',
  },
  {
    id: '9107116001',
    districtId: '9107116',
    name: 'Klamugun(Sp V)',
  },
  {
    id: '9107116002',
    districtId: '9107116',
    name: 'Klagulu (Sp.III)',
  },
  {
    id: '9107116003',
    districtId: '9107116',
    name: 'Malasigit (Sp II)',
  },
  {
    id: '9107116004',
    districtId: '9107116',
    name: 'Malajapa',
  },
  {
    id: '9107116005',
    districtId: '9107116',
    name: 'Klasman',
  },
  {
    id: '9107116006',
    districtId: '9107116',
    name: 'Malamoja',
  },
  {
    id: '9107116007',
    districtId: '9107116',
    name: 'Magatarum',
  },
  {
    id: '9107116008',
    districtId: '9107116',
    name: 'Tanah Tinggi',
  },
  {
    id: '9107116009',
    districtId: '9107116',
    name: 'Marik May',
  },
  {
    id: '9107118001',
    districtId: '9107118',
    name: 'Botain',
  },
  {
    id: '9107118002',
    districtId: '9107118',
    name: 'Klafluk',
  },
  {
    id: '9107118003',
    districtId: '9107118',
    name: 'Mamsit',
  },
  {
    id: '9107118004',
    districtId: '9107118',
    name: 'Sebake',
  },
  {
    id: '9107118005',
    districtId: '9107118',
    name: 'Klayastani',
  },
  {
    id: '9107119001',
    districtId: '9107119',
    name: 'Klamne',
  },
  {
    id: '9107119002',
    districtId: '9107119',
    name: 'Tarsa',
  },
  {
    id: '9107119003',
    districtId: '9107119',
    name: 'Wisbiak',
  },
  {
    id: '9107119004',
    districtId: '9107119',
    name: 'Klafyo',
  },
  {
    id: '9107119005',
    districtId: '9107119',
    name: 'Klafum',
  },
  {
    id: '9107119006',
    districtId: '9107119',
    name: 'Klarin',
  },
  {
    id: '9107119007',
    districtId: '9107119',
    name: 'Mlaswor',
  },
  {
    id: '9107119008',
    districtId: '9107119',
    name: 'Klafelem',
  },
  {
    id: '9107120005',
    districtId: '9107120',
    name: 'Matawolot',
  },
  {
    id: '9107120006',
    districtId: '9107120',
    name: 'Katinim',
  },
  {
    id: '9107120007',
    districtId: '9107120',
    name: 'Majener',
  },
  {
    id: '9107120008',
    districtId: '9107120',
    name: 'Malaus',
  },
  {
    id: '9107120009',
    districtId: '9107120',
    name: 'Walal',
  },
  {
    id: '9107120010',
    districtId: '9107120',
    name: 'Majaran',
  },
  {
    id: '9107120011',
    districtId: '9107120',
    name: 'Rawa Sugi',
  },
  {
    id: '9107121001',
    districtId: '9107121',
    name: 'Makotyamsa',
  },
  {
    id: '9107121002',
    districtId: '9107121',
    name: 'Makbalim',
  },
  {
    id: '9107121003',
    districtId: '9107121',
    name: 'Yeflio',
  },
  {
    id: '9107121004',
    districtId: '9107121',
    name: 'Makbusun',
  },
  {
    id: '9107121005',
    districtId: '9107121',
    name: 'Arar',
  },
  {
    id: '9107121006',
    districtId: '9107121',
    name: 'Klain',
  },
  {
    id: '9107121007',
    districtId: '9107121',
    name: 'Klasmelek',
  },
  {
    id: '9107122001',
    districtId: '9107122',
    name: 'Ninjimor',
  },
  {
    id: '9107122002',
    districtId: '9107122',
    name: 'Klasof',
  },
  {
    id: '9107122003',
    districtId: '9107122',
    name: 'Klawoton',
  },
  {
    id: '9107122004',
    districtId: '9107122',
    name: 'Klaforo',
  },
  {
    id: '9107122005',
    districtId: '9107122',
    name: 'Klafdalim',
  },
  {
    id: '9107122006',
    districtId: '9107122',
    name: 'Klasari',
  },
  {
    id: '9107122007',
    districtId: '9107122',
    name: 'Wonosobo',
  },
  {
    id: '9107123001',
    districtId: '9107123',
    name: 'Hobard',
  },
  {
    id: '9107123002',
    districtId: '9107123',
    name: 'Brianlo',
  },
  {
    id: '9107123003',
    districtId: '9107123',
    name: 'Floyi',
  },
  {
    id: '9107123004',
    districtId: '9107123',
    name: 'Klaselt',
  },
  {
    id: '9107123005',
    districtId: '9107123',
    name: 'Sfadon',
  },
  {
    id: '9107123006',
    districtId: '9107123',
    name: 'Selol',
  },
  {
    id: '9107123007',
    districtId: '9107123',
    name: 'Dais',
  },
  {
    id: '9107123008',
    districtId: '9107123',
    name: 'Klarin',
  },
  {
    id: '9107124001',
    districtId: '9107124',
    name: 'Mlakhan',
  },
  {
    id: '9107124002',
    districtId: '9107124',
    name: 'Mimpe',
  },
  {
    id: '9107124003',
    districtId: '9107124',
    name: 'Klais',
  },
  {
    id: '9107124005',
    districtId: '9107124',
    name: 'Tiklen',
  },
  {
    id: '9107124006',
    districtId: '9107124',
    name: 'Klahen',
  },
  {
    id: '9107124007',
    districtId: '9107124',
    name: 'Moos',
  },
  {
    id: '9107130005',
    districtId: '9107130',
    name: 'Kasim',
  },
  {
    id: '9107130006',
    districtId: '9107130',
    name: 'Malabam',
  },
  {
    id: '9107130008',
    districtId: '9107130',
    name: 'Kasimle',
  },
  {
    id: '9107130009',
    districtId: '9107130',
    name: 'Wawenagu',
  },
  {
    id: '9107130010',
    districtId: '9107130',
    name: 'Klayas',
  },
  {
    id: '9107130011',
    districtId: '9107130',
    name: 'Wasingsan',
  },
  {
    id: '9107130012',
    districtId: '9107130',
    name: 'Wayangkede',
  },
  {
    id: '9107131002',
    districtId: '9107131',
    name: 'Waimon',
  },
  {
    id: '9107131003',
    districtId: '9107131',
    name: 'Klasegun',
  },
  {
    id: '9107131004',
    districtId: '9107131',
    name: 'Majemau',
  },
  {
    id: '9107131005',
    districtId: '9107131',
    name: 'Wainlabat',
  },
  {
    id: '9107131006',
    districtId: '9107131',
    name: 'Gisim',
  },
  {
    id: '9107132001',
    districtId: '9107132',
    name: 'Sailolof',
  },
  {
    id: '9107132002',
    districtId: '9107132',
    name: 'Kotlol',
  },
  {
    id: '9107132006',
    districtId: '9107132',
    name: 'Dulbatan',
  },
  {
    id: '9107132008',
    districtId: '9107132',
    name: 'Manoket',
  },
  {
    id: '9107132009',
    districtId: '9107132',
    name: 'Payapop',
  },
  {
    id: '9107132010',
    districtId: '9107132',
    name: 'Masmaspop',
  },
  {
    id: '9107133001',
    districtId: '9107133',
    name: 'Duriankari',
  },
  {
    id: '9107133002',
    districtId: '9107133',
    name: 'Waliam',
  },
  {
    id: '9107133003',
    districtId: '9107133',
    name: 'Maralol',
  },
  {
    id: '9107133004',
    districtId: '9107133',
    name: 'Sakapul',
  },
  {
    id: '9107133005',
    districtId: '9107133',
    name: 'Wanfanim',
  },
  {
    id: '9107133006',
    districtId: '9107133',
    name: 'Waibin',
  },
  {
    id: '9107133007',
    districtId: '9107133',
    name: 'Waiman',
  },
  {
    id: '9107133008',
    districtId: '9107133',
    name: 'Batbiro',
  },
  {
    id: '9107133009',
    districtId: '9107133',
    name: 'Meyaup',
  },
  {
    id: '9107133010',
    districtId: '9107133',
    name: 'Sailen',
  },
  {
    id: '9107170001',
    districtId: '9107170',
    name: 'Malawele',
  },
  {
    id: '9107170004',
    districtId: '9107170',
    name: 'Malawili',
  },
  {
    id: '9107170005',
    districtId: '9107170',
    name: 'Aimas',
  },
  {
    id: '9107170006',
    districtId: '9107170',
    name: 'Mariat Pantai',
  },
  {
    id: '9107170011',
    districtId: '9107170',
    name: 'Mariat Gunung',
  },
  {
    id: '9107170012',
    districtId: '9107170',
    name: 'Warmon',
  },
  {
    id: '9107170014',
    districtId: '9107170',
    name: 'Klaigit',
  },
  {
    id: '9107170015',
    districtId: '9107170',
    name: 'Klabinain',
  },
  {
    id: '9107170016',
    districtId: '9107170',
    name: 'Malasaum',
  },
  {
    id: '9107171001',
    districtId: '9107171',
    name: 'Mariyai',
  },
  {
    id: '9107171002',
    districtId: '9107171',
    name: 'Klaben',
  },
  {
    id: '9107171003',
    districtId: '9107171',
    name: 'Klamasen',
  },
  {
    id: '9107171004',
    districtId: '9107171',
    name: 'Klamalu',
  },
  {
    id: '9107171005',
    districtId: '9107171',
    name: 'Klasuluk',
  },
  {
    id: '9107172001',
    districtId: '9107172',
    name: 'Klasugley',
  },
  {
    id: '9107172002',
    districtId: '9107172',
    name: 'Klauble',
  },
  {
    id: '9107172003',
    districtId: '9107172',
    name: 'Klablim',
  },
  {
    id: '9107172004',
    districtId: '9107172',
    name: 'Klawumuk',
  },
  {
    id: '9107172006',
    districtId: '9107172',
    name: 'Maibo',
  },
  {
    id: '9107180001',
    districtId: '9107180',
    name: 'Maladofok',
  },
  {
    id: '9107180003',
    districtId: '9107180',
    name: 'Sayosa',
  },
  {
    id: '9107180009',
    districtId: '9107180',
    name: 'Yorbes',
  },
  {
    id: '9107180011',
    districtId: '9107180',
    name: 'Klain',
  },
  {
    id: '9107180012',
    districtId: '9107180',
    name: 'Samusa',
  },
  {
    id: '9107180013',
    districtId: '9107180',
    name: 'Klamintu',
  },
  {
    id: '9107181001',
    districtId: '9107181',
    name: 'Klatim',
  },
  {
    id: '9107181002',
    districtId: '9107181',
    name: 'Bousui',
  },
  {
    id: '9107181003',
    districtId: '9107181',
    name: 'Klaos',
  },
  {
    id: '9107181004',
    districtId: '9107181',
    name: 'Luwelala',
  },
  {
    id: '9107181012',
    districtId: '9107181',
    name: 'Klagen',
  },
  {
    id: '9107181014',
    districtId: '9107181',
    name: 'Kamuyar',
  },
  {
    id: '9107181015',
    districtId: '9107181',
    name: 'Klaka',
  },
  {
    id: '9107181016',
    districtId: '9107181',
    name: 'Safdesa',
  },
  {
    id: '9107182001',
    districtId: '9107182',
    name: 'Saluk',
  },
  {
    id: '9107182002',
    districtId: '9107182',
    name: 'Klawaren',
  },
  {
    id: '9107182003',
    districtId: '9107182',
    name: 'Woluin',
  },
  {
    id: '9107182004',
    districtId: '9107182',
    name: 'Klalin Mos',
  },
  {
    id: '9107182005',
    districtId: '9107182',
    name: 'Kamlin',
  },
  {
    id: '9107182005',
    districtId: '9107182',
    name: 'Kwari',
  },
  {
    id: '9107183001',
    districtId: '9107183',
    name: 'Sailala',
  },
  {
    id: '9107183002',
    districtId: '9107183',
    name: 'Klawana',
  },
  {
    id: '9107183003',
    districtId: '9107183',
    name: 'Kladuk',
  },
  {
    id: '9107183004',
    districtId: '9107183',
    name: 'Klawon',
  },
  {
    id: '9107183005',
    districtId: '9107183',
    name: 'Klakak',
  },
  {
    id: '9107183006',
    districtId: '9107183',
    name: 'Klalwok',
  },
  {
    id: '9107184001',
    districtId: '9107184',
    name: 'Warbo',
  },
  {
    id: '9107184002',
    districtId: '9107184',
    name: 'Dasri',
  },
  {
    id: '9107184003',
    districtId: '9107184',
    name: 'Masos',
  },
  {
    id: '9107184004',
    districtId: '9107184',
    name: 'Ketawas',
  },
  {
    id: '9107184006',
    districtId: '9107184',
    name: 'Sulya',
  },
  {
    id: '9107184007',
    districtId: '9107184',
    name: 'Bouwoi',
  },
  {
    id: '9108011002',
    districtId: '9108011',
    name: 'Harapan Jaya',
  },
  {
    id: '9108011005',
    districtId: '9108011',
    name: 'Fafanlap',
  },
  {
    id: '9108011010',
    districtId: '9108011',
    name: 'Dabatan',
  },
  {
    id: '9108011011',
    districtId: '9108011',
    name: 'Kareyepop',
  },
  {
    id: '9108012001',
    districtId: '9108012',
    name: 'Lilinta',
  },
  {
    id: '9108012002',
    districtId: '9108012',
    name: 'Biga',
  },
  {
    id: '9108012003',
    districtId: '9108012',
    name: 'Gamta',
  },
  {
    id: '9108012004',
    districtId: '9108012',
    name: 'Magei',
  },
  {
    id: '9108012008',
    districtId: '9108012',
    name: 'Kapatcol',
  },
  {
    id: '9108020001',
    districtId: '9108020',
    name: 'Waigama',
  },
  {
    id: '9108020002',
    districtId: '9108020',
    name: 'Aduwei',
  },
  {
    id: '9108020013',
    districtId: '9108020',
    name: 'Atkari',
  },
  {
    id: '9108020014',
    districtId: '9108020',
    name: 'Solal',
  },
  {
    id: '9108020015',
    districtId: '9108020',
    name: 'Salafen',
  },
  {
    id: '9108021001',
    districtId: '9108021',
    name: 'Tolobi',
  },
  {
    id: '9108021002',
    districtId: '9108021',
    name: 'Balal',
  },
  {
    id: '9108021004',
    districtId: '9108021',
    name: 'Mikiran',
  },
  {
    id: '9108021005',
    districtId: '9108021',
    name: 'Awat',
  },
  {
    id: '9108022001',
    districtId: '9108022',
    name: 'Folley',
  },
  {
    id: '9108022002',
    districtId: '9108022',
    name: 'Tomolol',
  },
  {
    id: '9108022004',
    districtId: '9108022',
    name: 'Usaha Jaya',
  },
  {
    id: '9108022005',
    districtId: '9108022',
    name: 'Limalas Timur',
  },
  {
    id: '9108022006',
    districtId: '9108022',
    name: 'Limalas Barat',
  },
  {
    id: '9108022007',
    districtId: '9108022',
    name: 'Audam',
  },
  {
    id: '9108023001',
    districtId: '9108023',
    name: 'Pulau Tikus',
  },
  {
    id: '9108023002',
    districtId: '9108023',
    name: 'Wejim Barat',
  },
  {
    id: '9108023003',
    districtId: '9108023',
    name: 'Wejim Timur',
  },
  {
    id: '9108023004',
    districtId: '9108023',
    name: 'Satukurano',
  },
  {
    id: '9108031003',
    districtId: '9108031',
    name: 'Samate',
  },
  {
    id: '9108031005',
    districtId: '9108031',
    name: 'Kapatlap',
  },
  {
    id: '9108031009',
    districtId: '9108031',
    name: 'Wamega',
  },
  {
    id: '9108031010',
    districtId: '9108031',
    name: 'Waidim',
  },
  {
    id: '9108031011',
    districtId: '9108031',
    name: 'Jefman Barat',
  },
  {
    id: '9108031012',
    districtId: '9108031',
    name: 'Jefman Timur',
  },
  {
    id: '9108033001',
    districtId: '9108033',
    name: 'Kalobo',
  },
  {
    id: '9108033002',
    districtId: '9108033',
    name: 'Waijan',
  },
  {
    id: '9108033003',
    districtId: '9108033',
    name: 'Waimeci',
  },
  {
    id: '9108033004',
    districtId: '9108033',
    name: 'Wailabu',
  },
  {
    id: '9108033005',
    districtId: '9108033',
    name: 'Sakabu',
  },
  {
    id: '9108033006',
    districtId: '9108033',
    name: 'Wailen',
  },
  {
    id: '9108033007',
    districtId: '9108033',
    name: 'Waibu',
  },
  {
    id: '9108034001',
    districtId: '9108034',
    name: 'Solol',
  },
  {
    id: '9108034002',
    districtId: '9108034',
    name: 'Waibon',
  },
  {
    id: '9108034003',
    districtId: '9108034',
    name: 'Kaliam',
  },
  {
    id: '9108034004',
    districtId: '9108034',
    name: 'Kalwal',
  },
  {
    id: '9108035001',
    districtId: '9108035',
    name: 'Yenanas',
  },
  {
    id: '9108035002',
    districtId: '9108035',
    name: 'Waiman',
  },
  {
    id: '9108035003',
    districtId: '9108035',
    name: 'Wailebet',
  },
  {
    id: '9108035004',
    districtId: '9108035',
    name: 'Amdui',
  },
  {
    id: '9108036001',
    districtId: '9108036',
    name: 'Arefi Timur',
  },
  {
    id: '9108036002',
    districtId: '9108036',
    name: 'Arefi Selatan',
  },
  {
    id: '9108036003',
    districtId: '9108036',
    name: 'Yensawai Timur',
  },
  {
    id: '9108036004',
    districtId: '9108036',
    name: 'Yensawai Barat',
  },
  {
    id: '9108040015',
    districtId: '9108040',
    name: 'Saonek',
  },
  {
    id: '9108040016',
    districtId: '9108040',
    name: 'Friwen',
  },
  {
    id: '9108040018',
    districtId: '9108040',
    name: 'Saporkren',
  },
  {
    id: '9108040019',
    districtId: '9108040',
    name: 'Wawiyai',
  },
  {
    id: '9108041001',
    districtId: '9108041',
    name: 'Warsamdin',
  },
  {
    id: '9108041003',
    districtId: '9108041',
    name: 'Lopintol',
  },
  {
    id: '9108041004',
    districtId: '9108041',
    name: 'Kalitoko',
  },
  {
    id: '9108042001',
    districtId: '9108042',
    name: 'Yenbekwan',
  },
  {
    id: '9108042002',
    districtId: '9108042',
    name: 'Arborek',
  },
  {
    id: '9108042003',
    districtId: '9108042',
    name: 'Kapisawar',
  },
  {
    id: '9108042004',
    districtId: '9108042',
    name: 'Sawinggrai',
  },
  {
    id: '9108042005',
    districtId: '9108042',
    name: 'Yenwaoupnor',
  },
  {
    id: '9108042006',
    districtId: '9108042',
    name: 'Yenbuba',
  },
  {
    id: '9108042007',
    districtId: '9108042',
    name: 'Kabuy',
  },
  {
    id: '9108042008',
    districtId: '9108042',
    name: 'Kurkapa',
  },
  {
    id: '9108042009',
    districtId: '9108042',
    name: 'Sauandarek',
  },
  {
    id: '9108043001',
    districtId: '9108043',
    name: 'Waisai',
  },
  {
    id: '9108043002',
    districtId: '9108043',
    name: 'Sapordanco',
  },
  {
    id: '9108043003',
    districtId: '9108043',
    name: 'Bonkawir',
  },
  {
    id: '9108043004',
    districtId: '9108043',
    name: 'Warmasen',
  },
  {
    id: '9108044001',
    districtId: '9108044',
    name: 'Beo',
  },
  {
    id: '9108044002',
    districtId: '9108044',
    name: 'Arawai',
  },
  {
    id: '9108044003',
    districtId: '9108044',
    name: 'Kabilol',
  },
  {
    id: '9108044004',
    districtId: '9108044',
    name: 'Go',
  },
  {
    id: '9108044005',
    districtId: '9108044',
    name: 'Waifoi',
  },
  {
    id: '9108044006',
    districtId: '9108044',
    name: 'Warimak',
  },
  {
    id: '9108050007',
    districtId: '9108050',
    name: 'Bianci',
  },
  {
    id: '9108050008',
    districtId: '9108050',
    name: 'Salyo',
  },
  {
    id: '9108050010',
    districtId: '9108050',
    name: 'Waisilip',
  },
  {
    id: '9108051001',
    districtId: '9108051',
    name: 'Pam',
  },
  {
    id: '9108051002',
    districtId: '9108051',
    name: 'Gag',
  },
  {
    id: '9108051003',
    districtId: '9108051',
    name: 'Manyaifun',
  },
  {
    id: '9108051004',
    districtId: '9108051',
    name: 'Meosmanggara',
  },
  {
    id: '9108051005',
    districtId: '9108051',
    name: 'Saukabu',
  },
  {
    id: '9108051006',
    districtId: '9108051',
    name: 'Saupapir',
  },
  {
    id: '9108060006',
    districtId: '9108060',
    name: 'Asukweri',
  },
  {
    id: '9108060007',
    districtId: '9108060',
    name: 'Andey',
  },
  {
    id: '9108060008',
    districtId: '9108060',
    name: 'Kabare',
  },
  {
    id: '9108060011',
    districtId: '9108060',
    name: 'Bonsayor',
  },
  {
    id: '9108060012',
    districtId: '9108060',
    name: 'Darumbab',
  },
  {
    id: '9108060013',
    districtId: '9108060',
    name: 'Kalisade',
  },
  {
    id: '9108061001',
    districtId: '9108061',
    name: 'Boni',
  },
  {
    id: '9108061002',
    districtId: '9108061',
    name: 'Warwanai',
  },
  {
    id: '9108061003',
    districtId: '9108061',
    name: 'Mnier',
  },
  {
    id: '9108061004',
    districtId: '9108061',
    name: 'Warkori',
  },
  {
    id: '9108062001',
    districtId: '9108062',
    name: 'Rauki',
  },
  {
    id: '9108062002',
    districtId: '9108062',
    name: 'Urai',
  },
  {
    id: '9108062004',
    districtId: '9108062',
    name: 'Kapadiri',
  },
  {
    id: '9108070003',
    districtId: '9108070',
    name: 'Meosbekwan',
  },
  {
    id: '9108070005',
    districtId: '9108070',
    name: 'Reni',
  },
  {
    id: '9108070008',
    districtId: '9108070',
    name: 'Abidon',
  },
  {
    id: '9108071001',
    districtId: '9108071',
    name: 'Yenkawir',
  },
  {
    id: '9108071002',
    districtId: '9108071',
    name: 'Dorehkar',
  },
  {
    id: '9108071003',
    districtId: '9108071',
    name: 'Boiseran',
  },
  {
    id: '9108071004',
    districtId: '9108071',
    name: 'Runi',
  },
  {
    id: '9108071005',
    districtId: '9108071',
    name: 'Yenkanfan',
  },
  {
    id: '9108080002',
    districtId: '9108080',
    name: 'Urbinasopen',
  },
  {
    id: '9108080003',
    districtId: '9108080',
    name: 'Yenbekaki',
  },
  {
    id: '9109010005',
    districtId: '9109010',
    name: 'Wayo',
  },
  {
    id: '9109010007',
    districtId: '9109010',
    name: 'Sikor',
  },
  {
    id: '9109010009',
    districtId: '9109010',
    name: 'Ibe',
  },
  {
    id: '9109010010',
    districtId: '9109010',
    name: 'Syunam',
  },
  {
    id: '9109010011',
    districtId: '9109010',
    name: 'Banfot',
  },
  {
    id: '9109010012',
    districtId: '9109010',
    name: 'Iwin',
  },
  {
    id: '9109010014',
    districtId: '9109010',
    name: 'Imor',
  },
  {
    id: '9109011001',
    districtId: '9109011',
    name: 'Iof',
  },
  {
    id: '9109011002',
    districtId: '9109011',
    name: 'Banso',
  },
  {
    id: '9109011004',
    districtId: '9109011',
    name: 'Syujak',
  },
  {
    id: '9109011005',
    districtId: '9109011',
    name: 'Refane',
  },
  {
    id: '9109012001',
    districtId: '9109012',
    name: 'Ases',
  },
  {
    id: '9109012002',
    districtId: '9109012',
    name: 'Asuon',
  },
  {
    id: '9109012003',
    districtId: '9109012',
    name: 'Safoetiek',
  },
  {
    id: '9109012004',
    districtId: '9109012',
    name: 'Frasayuoh',
  },
  {
    id: '9109013001',
    districtId: '9109013',
    name: 'Soon',
  },
  {
    id: '9109013002',
    districtId: '9109013',
    name: 'Ruriay',
  },
  {
    id: '9109013003',
    districtId: '9109013',
    name: 'Tinggouw',
  },
  {
    id: '9109013004',
    districtId: '9109013',
    name: 'Hohair',
  },
  {
    id: '9109020002',
    districtId: '9109020',
    name: 'Yabouw',
  },
  {
    id: '9109020009',
    districtId: '9109020',
    name: 'Ayae',
  },
  {
    id: '9109020017',
    districtId: '9109020',
    name: 'Hobiah',
  },
  {
    id: '9109020018',
    districtId: '9109020',
    name: 'Ayawit',
  },
  {
    id: '9109020019',
    districtId: '9109020',
    name: 'Aifair',
  },
  {
    id: '9109021001',
    districtId: '9109021',
    name: 'Ayiamane',
  },
  {
    id: '9109021003',
    districtId: '9109021',
    name: 'Mawor',
  },
  {
    id: '9109021004',
    districtId: '9109021',
    name: 'Hewi',
  },
  {
    id: '9109021005',
    districtId: '9109021',
    name: 'Sahae',
  },
  {
    id: '9109021007',
    districtId: '9109021',
    name: 'Whismer',
  },
  {
    id: '9109022001',
    districtId: '9109022',
    name: 'Miri/Ibiah',
  },
  {
    id: '9109022002',
    districtId: '9109022',
    name: 'Meis',
  },
  {
    id: '9109022003',
    districtId: '9109022',
    name: 'Aifamas',
  },
  {
    id: '9109022004',
    districtId: '9109022',
    name: 'Meinad',
  },
  {
    id: '9109022005',
    districtId: '9109022',
    name: 'Ifiam',
  },
  {
    id: '9109022006',
    districtId: '9109022',
    name: 'Ataprumek',
  },
  {
    id: '9109023001',
    districtId: '9109023',
    name: 'Tabamsere',
  },
  {
    id: '9109023002',
    districtId: '9109023',
    name: 'Sayam',
  },
  {
    id: '9109023003',
    districtId: '9109023',
    name: 'Esyuom',
  },
  {
    id: '9109023004',
    districtId: '9109023',
    name: 'Ataf/Mafat',
  },
  {
    id: '9109023005',
    districtId: '9109023',
    name: 'Siakwa',
  },
  {
    id: '9109030001',
    districtId: '9109030',
    name: 'Saubeba',
  },
  {
    id: '9109030002',
    districtId: '9109030',
    name: 'Warmandi',
  },
  {
    id: '9109030003',
    districtId: '9109030',
    name: 'Wau',
  },
  {
    id: '9109030004',
    districtId: '9109030',
    name: 'Waibem',
  },
  {
    id: '9109030005',
    districtId: '9109030',
    name: 'Weyaf',
  },
  {
    id: '9109030006',
    districtId: '9109030',
    name: 'Wepriari',
  },
  {
    id: '9109030007',
    districtId: '9109030',
    name: 'Womom',
  },
  {
    id: '9109040001',
    districtId: '9109040',
    name: 'Kwoor',
  },
  {
    id: '9109040002',
    districtId: '9109040',
    name: 'Hopmare',
  },
  {
    id: '9109040010',
    districtId: '9109040',
    name: 'Sunggak',
  },
  {
    id: '9109040011',
    districtId: '9109040',
    name: 'Orwen',
  },
  {
    id: '9109040012',
    districtId: '9109040',
    name: 'Barar',
  },
  {
    id: '9109040013',
    districtId: '9109040',
    name: 'Esmambo',
  },
  {
    id: '9109041001',
    districtId: '9109041',
    name: 'Krisnos',
  },
  {
    id: '9109041002',
    districtId: '9109041',
    name: 'Syumbab',
  },
  {
    id: '9109041004',
    districtId: '9109041',
    name: 'Donan',
  },
  {
    id: '9109041005',
    districtId: '9109041',
    name: 'Dombron',
  },
  {
    id: '9109042001',
    districtId: '9109042',
    name: 'Syuau',
  },
  {
    id: '9109042002',
    districtId: '9109042',
    name: 'Batde',
  },
  {
    id: '9109042003',
    districtId: '9109042',
    name: 'Kwesefo',
  },
  {
    id: '9109042004',
    districtId: '9109042',
    name: 'Kranfotsu',
  },
  {
    id: '9109042005',
    districtId: '9109042',
    name: 'Bao',
  },
  {
    id: '9109042006',
    districtId: '9109042',
    name: 'Syumbi',
  },
  {
    id: '9109042007',
    districtId: '9109042',
    name: 'Jokbujoker',
  },
  {
    id: '9109050001',
    districtId: '9109050',
    name: 'Sausapor',
  },
  {
    id: '9109050006',
    districtId: '9109050',
    name: 'Jokte',
  },
  {
    id: '9109050007',
    districtId: '9109050',
    name: 'Emaos',
  },
  {
    id: '9109050008',
    districtId: '9109050',
    name: 'Uigwem',
  },
  {
    id: '9109050011',
    districtId: '9109050',
    name: 'Sungguwan',
  },
  {
    id: '9109050012',
    districtId: '9109050',
    name: 'Sau Uram',
  },
  {
    id: '9109050013',
    districtId: '9109050',
    name: 'Nanggou',
  },
  {
    id: '9109050014',
    districtId: '9109050',
    name: 'Bondek',
  },
  {
    id: '9109050015',
    districtId: '9109050',
    name: 'Bandonggwan',
  },
  {
    id: '9109050016',
    districtId: '9109050',
    name: 'Syurauw',
  },
  {
    id: '9109051001',
    districtId: '9109051',
    name: 'Bikar',
  },
  {
    id: '9109051003',
    districtId: '9109051',
    name: 'Werur Besar',
  },
  {
    id: '9109051004',
    districtId: '9109051',
    name: 'Werwaf',
  },
  {
    id: '9109051005',
    districtId: '9109051',
    name: 'Wertam',
  },
  {
    id: '9109051006',
    districtId: '9109051',
    name: 'Nombrak',
  },
  {
    id: '9109051007',
    districtId: '9109051',
    name: 'Syunai',
  },
  {
    id: '9109051008',
    districtId: '9109051',
    name: 'Bukit',
  },
  {
    id: '9109051009',
    districtId: '9109051',
    name: 'Suyam',
  },
  {
    id: '9109060001',
    districtId: '9109060',
    name: 'Baun',
  },
  {
    id: '9109060002',
    districtId: '9109060',
    name: 'Sumbekas',
  },
  {
    id: '9109060003',
    districtId: '9109060',
    name: 'Metnayam',
  },
  {
    id: '9109060006',
    districtId: '9109060',
    name: 'Ketawas',
  },
  {
    id: '9109060010',
    districtId: '9109060',
    name: 'Wormon',
  },
  {
    id: '9109060012',
    districtId: '9109060',
    name: 'Salem',
  },
  {
    id: '9109061001',
    districtId: '9109061',
    name: 'Bamusbama',
  },
  {
    id: '9109061002',
    districtId: '9109061',
    name: 'Bamusbayman',
  },
  {
    id: '9109061003',
    districtId: '9109061',
    name: 'Metbesa',
  },
  {
    id: '9109061005',
    districtId: '9109061',
    name: 'Syarwom',
  },
  {
    id: '9109061006',
    districtId: '9109061',
    name: 'Babak',
  },
  {
    id: '9109061007',
    districtId: '9109061',
    name: 'Bano',
  },
  {
    id: '9109070008',
    districtId: '9109070',
    name: 'Kebar Tengah / Anjai',
  },
  {
    id: '9109070010',
    districtId: '9109070',
    name: 'Meiwar',
  },
  {
    id: '9109070012',
    districtId: '9109070',
    name: 'Apoki',
  },
  {
    id: '9109070013',
    districtId: '9109070',
    name: 'Jafai',
  },
  {
    id: '9109070015',
    districtId: '9109070',
    name: 'Anarum',
  },
  {
    id: '9109070015',
    districtId: '9109070',
    name: 'Jambuani',
  },
  {
    id: '9109070016',
    districtId: '9109070',
    name: 'Manaria',
  },
  {
    id: '9109070017',
    districtId: '9109070',
    name: 'Narai',
  },
  {
    id: '9109070022',
    districtId: '9109070',
    name: 'Wasanggon',
  },
  {
    id: '9109070023',
    districtId: '9109070',
    name: 'Wabanek',
  },
  {
    id: '9109070039',
    districtId: '9109070',
    name: 'Pubuan',
  },
  {
    id: '9109071001',
    districtId: '9109071',
    name: 'Inambuari',
  },
  {
    id: '9109071002',
    districtId: '9109071',
    name: 'Kebar Timur / Jandurau',
  },
  {
    id: '9109071003',
    districtId: '9109071',
    name: 'Inam',
  },
  {
    id: '9109071004',
    districtId: '9109071',
    name: 'Arumi',
  },
  {
    id: '9109071005',
    districtId: '9109071',
    name: 'Kasi Inom',
  },
  {
    id: '9109071006',
    districtId: '9109071',
    name: 'Ireji',
  },
  {
    id: '9109071007',
    districtId: '9109071',
    name: 'Mey Cocforga',
  },
  {
    id: '9109071008',
    districtId: '9109071',
    name: 'Untorey',
  },
  {
    id: '9109071009',
    districtId: '9109071',
    name: 'Karawi',
  },
  {
    id: '9109071010',
    districtId: '9109071',
    name: 'Sitori',
  },
  {
    id: '9109071011',
    districtId: '9109071',
    name: 'Nabisai',
  },
  {
    id: '9109071012',
    districtId: '9109071',
    name: 'Arampak',
  },
  {
    id: '9109071013',
    districtId: '9109071',
    name: 'Wasabiti',
  },
  {
    id: '9109072001',
    districtId: '9109072',
    name: 'Nekori',
  },
  {
    id: '9109072002',
    districtId: '9109072',
    name: 'Ajami',
  },
  {
    id: '9109072003',
    districtId: '9109072',
    name: 'Arwani',
  },
  {
    id: '9109072004',
    districtId: '9109072',
    name: 'Atiki',
  },
  {
    id: '9109072005',
    districtId: '9109072',
    name: 'Aritowi',
  },
  {
    id: '9109072006',
    districtId: '9109072',
    name: 'Aniti',
  },
  {
    id: '9109072007',
    districtId: '9109072',
    name: 'Amnan',
  },
  {
    id: '9109072008',
    districtId: '9109072',
    name: 'Akari',
  },
  {
    id: '9109072009',
    districtId: '9109072',
    name: 'Umpay',
  },
  {
    id: '9109073001',
    districtId: '9109073',
    name: 'Akmuri',
  },
  {
    id: '9109073002',
    districtId: '9109073',
    name: 'Atay',
  },
  {
    id: '9109073003',
    districtId: '9109073',
    name: 'Maumi',
  },
  {
    id: '9109073004',
    districtId: '9109073',
    name: 'Aneti',
  },
  {
    id: '9109073005',
    districtId: '9109073',
    name: 'Ajami Waripi',
  },
  {
    id: '9109073006',
    districtId: '9109073',
    name: 'Itafifi',
  },
  {
    id: '9109073007',
    districtId: '9109073',
    name: 'Awori',
  },
  {
    id: '9109073008',
    districtId: '9109073',
    name: 'Atunari',
  },
  {
    id: '9109073009',
    districtId: '9109073',
    name: 'Aranari',
  },
  {
    id: '9109080001',
    districtId: '9109080',
    name: 'Kebar Barat / Senopi',
  },
  {
    id: '9109080004',
    districtId: '9109080',
    name: 'Arapi',
  },
  {
    id: '9109080006',
    districtId: '9109080',
    name: 'Sumo',
  },
  {
    id: '9109080007',
    districtId: '9109080',
    name: 'Ifat Mitu',
  },
  {
    id: '9109080008',
    districtId: '9109080',
    name: 'Povokek Ania',
  },
  {
    id: '9109080014',
    districtId: '9109080',
    name: 'Thomas',
  },
  {
    id: '9109081001',
    districtId: '9109081',
    name: 'Wausin',
  },
  {
    id: '9109081002',
    districtId: '9109081',
    name: 'Afrawi',
  },
  {
    id: '9109081003',
    districtId: '9109081',
    name: 'Wufmana',
  },
  {
    id: '9109081004',
    districtId: '9109081',
    name: 'Asiti',
  },
  {
    id: '9109081005',
    districtId: '9109081',
    name: 'Bisaud',
  },
  {
    id: '9109081006',
    districtId: '9109081',
    name: 'Nisandauw',
  },
  {
    id: '9109081007',
    districtId: '9109081',
    name: 'Atokwapi',
  },
  {
    id: '9109090005',
    districtId: '9109090',
    name: 'Serayo',
  },
  {
    id: '9109090011',
    districtId: '9109090',
    name: 'Wasarak',
  },
  {
    id: '9109090012',
    districtId: '9109090',
    name: 'Wekari',
  },
  {
    id: '9109090013',
    districtId: '9109090',
    name: 'Binasi',
  },
  {
    id: '9109090016',
    districtId: '9109090',
    name: 'Manggapnut',
  },
  {
    id: '9109090017',
    districtId: '9109090',
    name: 'Waramui',
  },
  {
    id: '9109091001',
    districtId: '9109091',
    name: 'Mangganek / Arupi',
  },
  {
    id: '9109091002',
    districtId: '9109091',
    name: 'Mangganek',
  },
  {
    id: '9109091003',
    districtId: '9109091',
    name: 'Wajarek',
  },
  {
    id: '9109091004',
    districtId: '9109091',
    name: 'Kalian',
  },
  {
    id: '9109091005',
    districtId: '9109091',
    name: 'Warpaperi',
  },
  {
    id: '9109092001',
    districtId: '9109092',
    name: 'Bondopi',
  },
  {
    id: '9109092002',
    districtId: '9109092',
    name: 'Sasui',
  },
  {
    id: '9109092003',
    districtId: '9109092',
    name: 'Manggaew',
  },
  {
    id: '9109092004',
    districtId: '9109092',
    name: 'Saurabon',
  },
  {
    id: '9109092005',
    districtId: '9109092',
    name: 'Wasawmonten',
  },
  {
    id: '9109100001',
    districtId: '9109100',
    name: 'Waru',
  },
  {
    id: '9109100002',
    districtId: '9109100',
    name: 'Bawey',
  },
  {
    id: '9109100003',
    districtId: '9109100',
    name: 'Arfu',
  },
  {
    id: '9109100004',
    districtId: '9109100',
    name: 'Warsnembri',
  },
  {
    id: '9109100005',
    districtId: '9109100',
    name: 'Bereambeker / Meriambeker',
  },
  {
    id: '9109100006',
    districtId: '9109100',
    name: 'Atori',
  },
  {
    id: '9109100007',
    districtId: '9109100',
    name: 'Bijamfou',
  },
  {
    id: '9109100008',
    districtId: '9109100',
    name: 'Warokon',
  },
  {
    id: '9109100009',
    districtId: '9109100',
    name: 'Arekon',
  },
  {
    id: '9109100010',
    districtId: '9109100',
    name: 'Bonpaya',
  },
  {
    id: '9109100011',
    districtId: '9109100',
    name: 'Marbuan',
  },
  {
    id: '9109110006',
    districtId: '9109110',
    name: 'Salewok',
  },
  {
    id: '9109110010',
    districtId: '9109110',
    name: 'Mega',
  },
  {
    id: '9109110012',
    districtId: '9109110',
    name: 'Malaworsai',
  },
  {
    id: '9109110015',
    districtId: '9109110',
    name: 'Kwade',
  },
  {
    id: '9109110016',
    districtId: '9109110',
    name: 'Namuas',
  },
  {
    id: '9109110017',
    districtId: '9109110',
    name: 'Bonem',
  },
  {
    id: '9109110018',
    districtId: '9109110',
    name: 'Warmasi',
  },
  {
    id: '9109110019',
    districtId: '9109110',
    name: 'Warmanen',
  },
  {
    id: '9109110020',
    districtId: '9109110',
    name: 'Warafor',
  },
  {
    id: '9109111001',
    districtId: '9109111',
    name: 'Dela',
  },
  {
    id: '9109111002',
    districtId: '9109111',
    name: 'Megame',
  },
  {
    id: '9109111003',
    districtId: '9109111',
    name: 'Kaladum',
  },
  {
    id: '9109111004',
    districtId: '9109111',
    name: 'Klasei',
  },
  {
    id: '9109111005',
    districtId: '9109111',
    name: 'Klabili',
  },
  {
    id: '9110010004',
    districtId: '9110010',
    name: 'Fatase',
  },
  {
    id: '9110010006',
    districtId: '9110010',
    name: 'Kambufatem',
  },
  {
    id: '9110010007',
    districtId: '9110010',
    name: 'Kambufatem Utara',
  },
  {
    id: '9110011001',
    districtId: '9110011',
    name: 'Isnum',
  },
  {
    id: '9110011002',
    districtId: '9110011',
    name: 'Arus',
  },
  {
    id: '9110011003',
    districtId: '9110011',
    name: 'Kofait',
  },
  {
    id: '9110011004',
    districtId: '9110011',
    name: 'Fait Nggre',
  },
  {
    id: '9110011005',
    districtId: '9110011',
    name: 'Faitsimar',
  },
  {
    id: '9110020001',
    districtId: '9110020',
    name: 'Kamro',
  },
  {
    id: '9110020002',
    districtId: '9110020',
    name: 'Sumanis',
  },
  {
    id: '9110020003',
    districtId: '9110020',
    name: 'Karsu',
  },
  {
    id: '9110020004',
    districtId: '9110020',
    name: 'Sris',
  },
  {
    id: '9110020005',
    districtId: '9110020',
    name: 'Eroh He',
  },
  {
    id: '9110020006',
    districtId: '9110020',
    name: 'Aitinyo',
  },
  {
    id: '9110020007',
    districtId: '9110020',
    name: 'Korom',
  },
  {
    id: '9110020008',
    districtId: '9110020',
    name: 'Tehak Kecil',
  },
  {
    id: '9110020009',
    districtId: '9110020',
    name: 'Sira Aya',
  },
  {
    id: '9110020014',
    districtId: '9110020',
    name: 'Sowai Sau',
  },
  {
    id: '9110020015',
    districtId: '9110020',
    name: 'Ibasuf',
  },
  {
    id: '9110021001',
    districtId: '9110021',
    name: 'Erok Wero',
  },
  {
    id: '9110021002',
    districtId: '9110021',
    name: 'Yaksoro',
  },
  {
    id: '9110021003',
    districtId: '9110021',
    name: 'Sira',
  },
  {
    id: '9110021004',
    districtId: '9110021',
    name: 'Awit',
  },
  {
    id: '9110021005',
    districtId: '9110021',
    name: 'Itigah',
  },
  {
    id: '9110021006',
    districtId: '9110021',
    name: 'Sira Tee',
  },
  {
    id: '9110021007',
    districtId: '9110021',
    name: 'Sabun',
  },
  {
    id: '9110021008',
    districtId: '9110021',
    name: 'Eway',
  },
  {
    id: '9110021009',
    districtId: '9110021',
    name: 'Wrait Tuu',
  },
  {
    id: '9110030001',
    districtId: '9110030',
    name: 'Sabah',
  },
  {
    id: '9110030003',
    districtId: '9110030',
    name: 'Fuog',
  },
  {
    id: '9110030004',
    districtId: '9110030',
    name: 'Imsun',
  },
  {
    id: '9110030005',
    districtId: '9110030',
    name: 'Kisor',
  },
  {
    id: '9110030006',
    districtId: '9110030',
    name: 'Sory',
  },
  {
    id: '9110030007',
    districtId: '9110030',
    name: 'Tasimara',
  },
  {
    id: '9110031001',
    districtId: '9110031',
    name: 'Womba',
  },
  {
    id: '9110031002',
    districtId: '9110031',
    name: 'Winuni',
  },
  {
    id: '9110031003',
    districtId: '9110031',
    name: 'Warba',
  },
  {
    id: '9110031004',
    districtId: '9110031',
    name: 'Warmu',
  },
  {
    id: '9110031005',
    districtId: '9110031',
    name: 'Makiri',
  },
  {
    id: '9110040001',
    districtId: '9110040',
    name: 'Tehahite',
  },
  {
    id: '9110040002',
    districtId: '9110040',
    name: 'Futon',
  },
  {
    id: '9110040004',
    districtId: '9110040',
    name: 'Kocuas',
  },
  {
    id: '9110040005',
    districtId: '9110040',
    name: 'Kokas',
  },
  {
    id: '9110040006',
    districtId: '9110040',
    name: 'Kocuwer',
  },
  {
    id: '9110040008',
    districtId: '9110040',
    name: 'Eisyo',
  },
  {
    id: '9110040009',
    districtId: '9110040',
    name: 'Fait Mayaf',
  },
  {
    id: '9110040010',
    districtId: '9110040',
    name: 'Bori',
  },
  {
    id: '9110050001',
    districtId: '9110050',
    name: 'Tehak Besar',
  },
  {
    id: '9110050002',
    districtId: '9110050',
    name: 'Mirafan',
  },
  {
    id: '9110050003',
    districtId: '9110050',
    name: 'Fategomi',
  },
  {
    id: '9110050004',
    districtId: '9110050',
    name: 'Gohsames',
  },
  {
    id: '9110050005',
    districtId: '9110050',
    name: "Asmuruf 'U'",
  },
  {
    id: '9110050006',
    districtId: '9110050',
    name: 'Faan',
  },
  {
    id: '9110051001',
    districtId: '9110051',
    name: 'Jitmau Timur',
  },
  {
    id: '9110051002',
    districtId: '9110051',
    name: 'Jitmau',
  },
  {
    id: '9110051003',
    districtId: '9110051',
    name: 'Isir',
  },
  {
    id: '9110051004',
    districtId: '9110051',
    name: 'Ikuf',
  },
  {
    id: '9110051005',
    districtId: '9110051',
    name: 'Sarimo',
  },
  {
    id: '9110051006',
    districtId: '9110051',
    name: 'Kambusabo',
  },
  {
    id: '9110051007',
    districtId: '9110051',
    name: 'Ikuf Utara',
  },
  {
    id: '9110060003',
    districtId: '9110060',
    name: 'Kambuaya',
  },
  {
    id: '9110060004',
    districtId: '9110060',
    name: 'Faitmajin',
  },
  {
    id: '9110060005',
    districtId: '9110060',
    name: 'Huberita',
  },
  {
    id: '9110060009',
    districtId: '9110060',
    name: 'Sefayit',
  },
  {
    id: '9110060010',
    districtId: '9110060',
    name: 'Ismayo',
  },
  {
    id: '9110061001',
    districtId: '9110061',
    name: 'Kambuwifa',
  },
  {
    id: '9110061002',
    districtId: '9110061',
    name: 'Kambuskato',
  },
  {
    id: '9110061003',
    districtId: '9110061',
    name: 'Mano',
  },
  {
    id: '9110061004',
    districtId: '9110061',
    name: 'Kambuskato Utara',
  },
  {
    id: '9110061005',
    districtId: '9110061',
    name: 'Isusu',
  },
  {
    id: '9110070006',
    districtId: '9110070',
    name: 'Mefkajim II',
  },
  {
    id: '9110070009',
    districtId: '9110070',
    name: 'Fraharoh',
  },
  {
    id: '9110070010',
    districtId: '9110070',
    name: 'Ayamaru',
  },
  {
    id: '9110070011',
    districtId: '9110070',
    name: 'Framu',
  },
  {
    id: '9110070024',
    districtId: '9110070',
    name: 'Smusuwioh',
  },
  {
    id: '9110071001',
    districtId: '9110071',
    name: 'Koma-Koma',
  },
  {
    id: '9110071002',
    districtId: '9110071',
    name: 'Sembaro',
  },
  {
    id: '9110071003',
    districtId: '9110071',
    name: 'Sauf',
  },
  {
    id: '9110071004',
    districtId: '9110071',
    name: 'Kanisabar',
  },
  {
    id: '9110071005',
    districtId: '9110071',
    name: 'Sfarare',
  },
  {
    id: '9110071007',
    districtId: '9110071',
    name: 'Lemauk Klit',
  },
  {
    id: '9110072001',
    districtId: '9110072',
    name: 'Adoh',
  },
  {
    id: '9110072003',
    districtId: '9110072',
    name: 'Sosian',
  },
  {
    id: '9110072004',
    districtId: '9110072',
    name: 'Orain',
  },
  {
    id: '9110072005',
    districtId: '9110072',
    name: 'Segior',
  },
  {
    id: '9110072006',
    districtId: '9110072',
    name: 'Orsu',
  },
  {
    id: '9110073001',
    districtId: '9110073',
    name: 'Fiane',
  },
  {
    id: '9110073002',
    districtId: '9110073',
    name: 'Kartapura',
  },
  {
    id: '9110073004',
    districtId: '9110073',
    name: 'Isme',
  },
  {
    id: '9110074001',
    districtId: '9110074',
    name: 'Chaliat',
  },
  {
    id: '9110074002',
    districtId: '9110074',
    name: 'Soroan',
  },
  {
    id: '9110074003',
    districtId: '9110074',
    name: 'Fanse',
  },
  {
    id: '9110074005',
    districtId: '9110074',
    name: 'Sfacko',
  },
  {
    id: '9110080002',
    districtId: '9110080',
    name: 'Hohoyar',
  },
  {
    id: '9110080003',
    districtId: '9110080',
    name: 'Setta',
  },
  {
    id: '9110080005',
    districtId: '9110080',
    name: 'Karetubun',
  },
  {
    id: '9110080006',
    districtId: '9110080',
    name: 'Yubiah',
  },
  {
    id: '9110080010',
    districtId: '9110080',
    name: 'Aus Tiwit',
  },
  {
    id: '9110080011',
    districtId: '9110080',
    name: 'Yukase',
  },
  {
    id: '9110080012',
    districtId: '9110080',
    name: 'Serma',
  },
  {
    id: '9110081001',
    districtId: '9110081',
    name: 'Suwiam',
  },
  {
    id: '9110081002',
    districtId: '9110081',
    name: 'Mapura',
  },
  {
    id: '9110081003',
    districtId: '9110081',
    name: 'Karfa',
  },
  {
    id: '9110081005',
    districtId: '9110081',
    name: 'Fraboh',
  },
  {
    id: '9110090004',
    districtId: '9110090',
    name: 'Kombif',
  },
  {
    id: '9110090005',
    districtId: '9110090',
    name: 'Seya',
  },
  {
    id: '9110090006',
    districtId: '9110090',
    name: 'Suswa',
  },
  {
    id: '9110090007',
    districtId: '9110090',
    name: 'Waban',
  },
  {
    id: '9110090011',
    districtId: '9110090',
    name: 'Rufases',
  },
  {
    id: '9110091001',
    districtId: '9110091',
    name: 'Renis',
  },
  {
    id: '9110091002',
    districtId: '9110091',
    name: 'Sire',
  },
  {
    id: '9110091003',
    districtId: '9110091',
    name: 'Seni',
  },
  {
    id: '9110091004',
    districtId: '9110091',
    name: 'Sabes',
  },
  {
    id: '9110091005',
    districtId: '9110091',
    name: 'Fase',
  },
  {
    id: '9110091006',
    districtId: '9110091',
    name: 'Kuraso',
  },
  {
    id: '9110091007',
    districtId: '9110091',
    name: 'Arne',
  },
  {
    id: '9110100001',
    districtId: '9110100',
    name: 'Fonatu',
  },
  {
    id: '9110100002',
    districtId: '9110100',
    name: 'Ayawasi Selatan',
  },
  {
    id: '9110100003',
    districtId: '9110100',
    name: 'Ayawasi',
  },
  {
    id: '9110100004',
    districtId: '9110100',
    name: 'Ayawasi Timur',
  },
  {
    id: '9110100005',
    districtId: '9110100',
    name: 'Maan',
  },
  {
    id: '9110100006',
    districtId: '9110100',
    name: 'Konja',
  },
  {
    id: '9110100007',
    districtId: '9110100',
    name: 'Jarat',
  },
  {
    id: '9110100008',
    districtId: '9110100',
    name: 'Susai',
  },
  {
    id: '9110100009',
    districtId: '9110100',
    name: 'Mosun',
  },
  {
    id: '9110100010',
    districtId: '9110100',
    name: 'Wayane',
  },
  {
    id: '9110110002',
    districtId: '9110110',
    name: 'Sawin',
  },
  {
    id: '9110110003',
    districtId: '9110110',
    name: 'Aitrem',
  },
  {
    id: '9110110004',
    districtId: '9110110',
    name: 'Aikrer',
  },
  {
    id: '9110110008',
    districtId: '9110110',
    name: 'Aisa',
  },
  {
    id: '9110110016',
    districtId: '9110110',
    name: 'Sahbuku',
  },
  {
    id: '9110110018',
    districtId: '9110110',
    name: 'Faan',
  },
  {
    id: '9110110019',
    districtId: '9110110',
    name: 'Aikus',
  },
  {
    id: '9110111001',
    districtId: '9110111',
    name: 'Kamat',
  },
  {
    id: '9110111002',
    districtId: '9110111',
    name: 'Ayata',
  },
  {
    id: '9110111003',
    districtId: '9110111',
    name: 'Aifam',
  },
  {
    id: '9110111004',
    districtId: '9110111',
    name: 'Mupas',
  },
  {
    id: '9110111005',
    districtId: '9110111',
    name: 'Ainesa',
  },
  {
    id: '9110112001',
    districtId: '9110112',
    name: 'Aimau',
  },
  {
    id: '9110112011',
    districtId: '9110112',
    name: 'Mesyam',
  },
  {
    id: '9110112012',
    districtId: '9110112',
    name: 'Aisasior',
  },
  {
    id: '9110112013',
    districtId: '9110112',
    name: 'Ainesra',
  },
  {
    id: '9110112014',
    districtId: '9110112',
    name: 'Framneway',
  },
  {
    id: '9111010001',
    districtId: '9111010',
    name: 'Kaprus',
  },
  {
    id: '9111010002',
    districtId: '9111010',
    name: 'Reyob',
  },
  {
    id: '9111010003',
    districtId: '9111010',
    name: 'Seimeba',
  },
  {
    id: '9111010004',
    districtId: '9111010',
    name: 'Yermatum',
  },
  {
    id: '9111020001',
    districtId: '9111020',
    name: 'Isim',
  },
  {
    id: '9111020003',
    districtId: '9111020',
    name: 'Duhugesa',
  },
  {
    id: '9111020004',
    districtId: '9111020',
    name: 'Umousi',
  },
  {
    id: '9111020005',
    districtId: '9111020',
    name: 'Dihisu',
  },
  {
    id: '9111020006',
    districtId: '9111020',
    name: 'Hugamod',
  },
  {
    id: '9111020007',
    districtId: '9111020',
    name: 'Dibera',
  },
  {
    id: '9111020008',
    districtId: '9111020',
    name: 'Tahosta',
  },
  {
    id: '9111020009',
    districtId: '9111020',
    name: 'Inyuara',
  },
  {
    id: '9111020010',
    districtId: '9111020',
    name: 'Sibjo',
  },
  {
    id: '9111020011',
    districtId: '9111020',
    name: 'Desra',
  },
  {
    id: '9111020012',
    districtId: '9111020',
    name: 'Mindermes',
  },
  {
    id: '9111030001',
    districtId: '9111030',
    name: 'Aryawen Moho',
  },
  {
    id: '9111030002',
    districtId: '9111030',
    name: 'Nenei',
  },
  {
    id: '9111030003',
    districtId: '9111030',
    name: 'Wama',
  },
  {
    id: '9111030004',
    districtId: '9111030',
    name: 'Disi',
  },
  {
    id: '9111030006',
    districtId: '9111030',
    name: 'Benyas',
  },
  {
    id: '9111030007',
    districtId: '9111030',
    name: 'Hoyou',
  },
  {
    id: '9111040001',
    districtId: '9111040',
    name: 'Yekwandi',
  },
  {
    id: '9111040002',
    districtId: '9111040',
    name: 'Gaya Baru',
  },
  {
    id: '9111040003',
    districtId: '9111040',
    name: 'Nenei Pantai / Nij',
  },
  {
    id: '9111040004',
    districtId: '9111040',
    name: 'Waren',
  },
  {
    id: '9111040005',
    districtId: '9111040',
    name: 'Siwi',
  },
  {
    id: '9111040006',
    districtId: '9111040',
    name: 'Demini',
  },
  {
    id: '9111050001',
    districtId: '9111050',
    name: 'Hamawi',
  },
  {
    id: '9111050002',
    districtId: '9111050',
    name: 'Bamaha',
  },
  {
    id: '9111050003',
    districtId: '9111050',
    name: 'Abresso',
  },
  {
    id: '9111050004',
    districtId: '9111050',
    name: 'Ransiki Kota',
  },
  {
    id: '9111050005',
    districtId: '9111050',
    name: 'Tobouw',
  },
  {
    id: '9111050006',
    districtId: '9111050',
    name: 'Sabri',
  },
  {
    id: '9111050007',
    districtId: '9111050',
    name: 'Kobrey',
  },
  {
    id: '9111050008',
    districtId: '9111050',
    name: 'Hamor',
  },
  {
    id: '9111050009',
    districtId: '9111050',
    name: 'Swer/Wamcei',
  },
  {
    id: '9111050010',
    districtId: '9111050',
    name: 'Mambrema',
  },
  {
    id: '9111050011',
    districtId: '9111050',
    name: 'Yamboy',
  },
  {
    id: '9111050012',
    districtId: '9111050',
    name: 'Nuhuei',
  },
  {
    id: '9111050013',
    districtId: '9111050',
    name: 'Susmorof',
  },
  {
    id: '9111060001',
    districtId: '9111060',
    name: 'Warkwandi',
  },
  {
    id: '9111060002',
    districtId: '9111060',
    name: 'Muari',
  },
  {
    id: '9111060003',
    districtId: '9111060',
    name: 'Oransbari',
  },
  {
    id: '9111060004',
    districtId: '9111060',
    name: 'Margomulyo',
  },
  {
    id: '9111060005',
    districtId: '9111060',
    name: 'Margorukun',
  },
  {
    id: '9111060006',
    districtId: '9111060',
    name: 'Akeju',
  },
  {
    id: '9111060007',
    districtId: '9111060',
    name: 'Sindang Jaya',
  },
  {
    id: '9111060008',
    districtId: '9111060',
    name: 'Waroser',
  },
  {
    id: '9111060009',
    districtId: '9111060',
    name: 'Warbiadi',
  },
  {
    id: '9111060010',
    districtId: '9111060',
    name: 'Watariri',
  },
  {
    id: '9111060011',
    districtId: '9111060',
    name: 'Sidomulyo',
  },
  {
    id: '9111060012',
    districtId: '9111060',
    name: 'Wandoki',
  },
  {
    id: '9111060013',
    districtId: '9111060',
    name: 'Masabui 2',
  },
  {
    id: '9111060014',
    districtId: '9111060',
    name: 'Masabui',
  },
  {
    id: '9112010001',
    districtId: '9112010',
    name: 'Kusmenau',
  },
  {
    id: '9112010002',
    districtId: '9112010',
    name: 'Sneraner',
  },
  {
    id: '9112010003',
    districtId: '9112010',
    name: 'Cirnohu',
  },
  {
    id: '9112010004',
    districtId: '9112010',
    name: 'Disra',
  },
  {
    id: '9112010005',
    districtId: '9112010',
    name: 'Dibetik',
  },
  {
    id: '9112010006',
    districtId: '9112010',
    name: 'Danmou',
  },
  {
    id: '9112010007',
    districtId: '9112010',
    name: 'Sirgemeih',
  },
  {
    id: '9112010008',
    districtId: '9112010',
    name: 'Demdanei',
  },
  {
    id: '9112010009',
    districtId: '9112010',
    name: 'Iranmeba',
  },
  {
    id: '9112010010',
    districtId: '9112010',
    name: 'Gedeira',
  },
  {
    id: '9112010011',
    districtId: '9112010',
    name: 'Dugrimog',
  },
  {
    id: '9112010012',
    districtId: '9112010',
    name: 'Cigera',
  },
  {
    id: '9112010013',
    districtId: '9112010',
    name: 'Tomsir',
  },
  {
    id: '9112010014',
    districtId: '9112010',
    name: 'Miseda',
  },
  {
    id: '9112020001',
    districtId: '9112020',
    name: 'Inyaub',
  },
  {
    id: '9112020002',
    districtId: '9112020',
    name: 'Duguhani',
  },
  {
    id: '9112020003',
    districtId: '9112020',
    name: 'Kopo',
  },
  {
    id: '9112020004',
    districtId: '9112020',
    name: 'Kobrey',
  },
  {
    id: '9112020005',
    districtId: '9112020',
    name: 'Kostera',
  },
  {
    id: '9112020007',
    districtId: '9112020',
    name: 'Saugemeba',
  },
  {
    id: '9112020008',
    districtId: '9112020',
    name: 'Menesrij',
  },
  {
    id: '9112020009',
    districtId: '9112020',
    name: 'Tuhubea',
  },
  {
    id: '9112020011',
    districtId: '9112020',
    name: 'Anuk',
  },
  {
    id: '9112020012',
    districtId: '9112020',
    name: 'Tomstera',
  },
  {
    id: '9112030001',
    districtId: '9112030',
    name: 'Itkau',
  },
  {
    id: '9112030002',
    districtId: '9112030',
    name: 'Tuabyam',
  },
  {
    id: '9112030003',
    districtId: '9112030',
    name: 'Sibiogud',
  },
  {
    id: '9112030004',
    districtId: '9112030',
    name: 'Tombrok',
  },
  {
    id: '9112030005',
    districtId: '9112030',
    name: 'Ingisrow',
  },
  {
    id: '9112030006',
    districtId: '9112030',
    name: 'Seseran / Sisrang',
  },
  {
    id: '9112030007',
    districtId: '9112030',
    name: 'Krobut / Kiwot',
  },
  {
    id: '9112030008',
    districtId: '9112030',
    name: 'Sakuni/Sakurai',
  },
  {
    id: '9112040001',
    districtId: '9112040',
    name: 'Memti',
  },
  {
    id: '9112040002',
    districtId: '9112040',
    name: 'Usti',
  },
  {
    id: '9112040003',
    districtId: '9112040',
    name: 'Inyebow',
  },
  {
    id: '9112040004',
    districtId: '9112040',
    name: 'Imbeisaba',
  },
  {
    id: '9112040006',
    districtId: '9112040',
    name: 'Koney',
  },
  {
    id: '9112050001',
    districtId: '9112050',
    name: 'Pamaha',
  },
  {
    id: '9112050002',
    districtId: '9112050',
    name: 'Testega Pamaha',
  },
  {
    id: '9112050003',
    districtId: '9112050',
    name: 'Iraiweri',
  },
  {
    id: '9112050004',
    districtId: '9112050',
    name: 'Imbai',
  },
  {
    id: '9112050006',
    districtId: '9112050',
    name: 'Susi',
  },
  {
    id: '9112050007',
    districtId: '9112050',
    name: 'Ingebai / Imbeisba',
  },
  {
    id: '9112050008',
    districtId: '9112050',
    name: 'Suteibey',
  },
  {
    id: '9112050010',
    districtId: '9112050',
    name: 'Ayaubey',
  },
  {
    id: '9112050013',
    districtId: '9112050',
    name: 'Ulong',
  },
  {
    id: '9112060001',
    districtId: '9112060',
    name: 'Tridaga',
  },
  {
    id: '9112060002',
    districtId: '9112060',
    name: 'Siskedouw',
  },
  {
    id: '9112060003',
    districtId: '9112060',
    name: 'Irbos',
  },
  {
    id: '9112060004',
    districtId: '9112060',
    name: 'Disura',
  },
  {
    id: '9112060005',
    districtId: '9112060',
    name: 'Deroubu',
  },
  {
    id: '9112060006',
    districtId: '9112060',
    name: 'Asum',
  },
  {
    id: '9112060007',
    districtId: '9112060',
    name: 'Taige',
  },
  {
    id: '9112060009',
    districtId: '9112060',
    name: 'Horeta',
  },
  {
    id: '9112060010',
    districtId: '9112060',
    name: 'Awaikum / Awaigau',
  },
  {
    id: '9112060011',
    districtId: '9112060',
    name: 'Ubeisa',
  },
  {
    id: '9112070001',
    districtId: '9112070',
    name: 'Minggot',
  },
  {
    id: '9112070002',
    districtId: '9112070',
    name: 'Penibut',
  },
  {
    id: '9112070003',
    districtId: '9112070',
    name: 'Monut',
  },
  {
    id: '9112070004',
    districtId: '9112070',
    name: 'Sopnyai',
  },
  {
    id: '9112070005',
    districtId: '9112070',
    name: 'Nungkimor',
  },
  {
    id: '9112070006',
    districtId: '9112070',
    name: 'Ngimoubre',
  },
  {
    id: '9112070007',
    districtId: '9112070',
    name: 'Kisap',
  },
  {
    id: '9112070008',
    districtId: '9112070',
    name: 'Leiheak',
  },
  {
    id: '9112070009',
    districtId: '9112070',
    name: 'Mbegau',
  },
  {
    id: '9112070010',
    districtId: '9112070',
    name: 'Minyeimemut',
  },
  {
    id: '9112070011',
    districtId: '9112070',
    name: 'Demunti',
  },
  {
    id: '9112070012',
    districtId: '9112070',
    name: 'Cangoisi',
  },
  {
    id: '9112070014',
    districtId: '9112070',
    name: 'Tumbeibehei',
  },
  {
    id: '9112070015',
    districtId: '9112070',
    name: 'Tingkwoikiu',
  },
  {
    id: '9112070016',
    districtId: '9112070',
    name: 'Mbrande / Mbramdega',
  },
  {
    id: '9112070017',
    districtId: '9112070',
    name: 'Gueiuti',
  },
  {
    id: '9112070018',
    districtId: '9112070',
    name: 'Humeysi',
  },
  {
    id: '9112070019',
    districtId: '9112070',
    name: 'Kwaiyehep',
  },
  {
    id: '9112070020',
    districtId: '9112070',
    name: 'Ikimabow',
  },
  {
    id: '9112070021',
    districtId: '9112070',
    name: 'Ntap',
  },
  {
    id: '9112070022',
    districtId: '9112070',
    name: 'Heatie Bouw',
  },
  {
    id: '9112070023',
    districtId: '9112070',
    name: 'Arion',
  },
  {
    id: '9112070025',
    districtId: '9112070',
    name: 'Kwok I',
  },
  {
    id: '9112070026',
    districtId: '9112070',
    name: 'Kwokwisngung/Kwok II',
  },
  {
    id: '9112070027',
    districtId: '9112070',
    name: 'Tigau Comti',
  },
  {
    id: '9112070028',
    districtId: '9112070',
    name: 'Gweipingbai',
  },
  {
    id: '9112070029',
    districtId: '9112070',
    name: 'Urwong',
  },
  {
    id: '9112080001',
    districtId: '9112080',
    name: 'Mbingma',
  },
  {
    id: '9112080002',
    districtId: '9112080',
    name: 'Inggrahim',
  },
  {
    id: '9112080003',
    districtId: '9112080',
    name: 'Imbrekti',
  },
  {
    id: '9112080004',
    districtId: '9112080',
    name: 'Memangker',
  },
  {
    id: '9112080005',
    districtId: '9112080',
    name: 'Imbonggun',
  },
  {
    id: '9112080006',
    districtId: '9112080',
    name: 'Bingwoyud',
  },
  {
    id: '9112080007',
    districtId: '9112080',
    name: 'Misadwer/Micadiwor',
  },
  {
    id: '9112080009',
    districtId: '9112080',
    name: 'Demaisi',
  },
  {
    id: '9112080011',
    districtId: '9112080',
    name: 'Coisi',
  },
  {
    id: '9112080012',
    districtId: '9112080',
    name: 'Micomti',
  },
  {
    id: '9112080013',
    districtId: '9112080',
    name: 'Ungga',
  },
  {
    id: '9112080014',
    districtId: '9112080',
    name: 'Nimbiau',
  },
  {
    id: '9112080015',
    districtId: '9112080',
    name: 'Sinaytoisi',
  },
  {
    id: '9112080016',
    districtId: '9112080',
    name: 'Sigim',
  },
  {
    id: '9112080017',
    districtId: '9112080',
    name: 'Smaingei',
  },
  {
    id: '9112080018',
    districtId: '9112080',
    name: 'Simerbei',
  },
  {
    id: '9112080019',
    districtId: '9112080',
    name: 'Apui',
  },
  {
    id: '9112080020',
    districtId: '9112080',
    name: 'Awibehey',
  },
  {
    id: '9112080021',
    districtId: '9112080',
    name: 'Aduer',
  },
  {
    id: '9112080022',
    districtId: '9112080',
    name: 'Anggra',
  },
  {
    id: '9112080023',
    districtId: '9112080',
    name: 'Ayau',
  },
  {
    id: '9112080024',
    districtId: '9112080',
    name: 'Imbenti',
  },
  {
    id: '9112080025',
    districtId: '9112080',
    name: 'Mitiede',
  },
  {
    id: '9112080026',
    districtId: '9112080',
    name: 'Menyambouw',
  },
  {
    id: '9112080027',
    districtId: '9112080',
    name: 'Ipingoisi',
  },
  {
    id: '9112080028',
    districtId: '9112080',
    name: 'Piyausi',
  },
  {
    id: '9112080029',
    districtId: '9112080',
    name: 'Mainda',
  },
  {
    id: '9112080030',
    districtId: '9112080',
    name: 'Handuk',
  },
  {
    id: '9112080031',
    districtId: '9112080',
    name: 'Indabri',
  },
  {
    id: '9112080032',
    districtId: '9112080',
    name: 'Ninsimoi',
  },
  {
    id: '9112080035',
    districtId: '9112080',
    name: 'Misapngoisi',
  },
  {
    id: '9112080036',
    districtId: '9112080',
    name: 'Andang',
  },
  {
    id: '9112080040',
    districtId: '9112080',
    name: 'Waminda',
  },
  {
    id: '9112080043',
    districtId: '9112080',
    name: 'Driye',
  },
  {
    id: '9112080049',
    districtId: '9112080',
    name: 'Njuar',
  },
  {
    id: '9112090001',
    districtId: '9112090',
    name: 'Soudin',
  },
  {
    id: '9112090002',
    districtId: '9112090',
    name: 'Unti',
  },
  {
    id: '9112090003',
    districtId: '9112090',
    name: 'Miey Comty',
  },
  {
    id: '9112090004',
    districtId: '9112090',
    name: 'Coijud',
  },
  {
    id: '9112090005',
    districtId: '9112090',
    name: 'Bingwaimod',
  },
  {
    id: '9112090006',
    districtId: '9112090',
    name: 'Minmo',
  },
  {
    id: '9112090007',
    districtId: '9112090',
    name: 'Ijigrek',
  },
  {
    id: '9112090008',
    districtId: '9112090',
    name: 'Timtou',
  },
  {
    id: '9112090009',
    districtId: '9112090',
    name: 'Minhou',
  },
  {
    id: '9112090010',
    districtId: '9112090',
    name: 'Catubou',
  },
  {
    id: '9112090011',
    districtId: '9112090',
    name: 'Aiga',
  },
  {
    id: '9112090012',
    districtId: '9112090',
    name: 'Kaungwam',
  },
  {
    id: '9112090013',
    districtId: '9112090',
    name: 'Bingrayud',
  },
  {
    id: '9112090014',
    districtId: '9112090',
    name: 'Idemai',
  },
  {
    id: '9112090015',
    districtId: '9112090',
    name: 'Mihiji',
  },
  {
    id: '9112090016',
    districtId: '9112090',
    name: 'Imandrigo',
  },
  {
    id: '9112090017',
    districtId: '9112090',
    name: 'Ndabou',
  },
  {
    id: '9112090018',
    districtId: '9112090',
    name: 'Slomiou',
  },
  {
    id: '9112090019',
    districtId: '9112090',
    name: 'Sugemah',
  },
  {
    id: '9112090020',
    districtId: '9112090',
    name: 'Jim',
  },
  {
    id: '9112090021',
    districtId: '9112090',
    name: 'Manggesuk',
  },
  {
    id: '9112100001',
    districtId: '9112100',
    name: 'Morumfeyi',
  },
  {
    id: '9112100002',
    districtId: '9112100',
    name: 'Iba',
  },
  {
    id: '9112100003',
    districtId: '9112100',
    name: 'Meksi',
  },
  {
    id: '9112100004',
    districtId: '9112100',
    name: 'Meigehenawu',
  },
  {
    id: '9112100005',
    districtId: '9112100',
    name: 'Mofoukeda',
  },
  {
    id: '9112100006',
    districtId: '9112100',
    name: 'Meidogda',
  },
  {
    id: '9112100007',
    districtId: '9112100',
    name: 'Asay II',
  },
  {
    id: '9112100009',
    districtId: '9112100',
    name: 'Menjugiji',
  },
  {
    id: '9112100010',
    districtId: '9112100',
    name: 'Meifekeni',
  },
  {
    id: '9112100011',
    districtId: '9112100',
    name: 'Samen Hon',
  },
  {
    id: '9112100012',
    districtId: '9112100',
    name: 'Testega',
  },
  {
    id: '9112100013',
    districtId: '9112100',
    name: 'Ishom',
  },
  {
    id: '9112100014',
    districtId: '9112100',
    name: 'Jijga',
  },
  {
    id: '9112100015',
    districtId: '9112100',
    name: 'Demoura',
  },
  {
    id: '9171010003',
    districtId: '9171010',
    name: 'Rufei',
  },
  {
    id: '9171010006',
    districtId: '9171010',
    name: 'Klawasi',
  },
  {
    id: '9171010008',
    districtId: '9171010',
    name: 'Pal Putih',
  },
  {
    id: '9171010010',
    districtId: '9171010',
    name: 'Puncak Cendrawasih',
  },
  {
    id: '9171011001',
    districtId: '9171011',
    name: 'Doom Timur',
  },
  {
    id: '9171011002',
    districtId: '9171011',
    name: 'Doom Barat',
  },
  {
    id: '9171011003',
    districtId: '9171011',
    name: 'Soop',
  },
  {
    id: '9171011004',
    districtId: '9171011',
    name: 'Raam',
  },
  {
    id: '9171012001',
    districtId: '9171012',
    name: 'Tanjung Kasuari',
  },
  {
    id: '9171012002',
    districtId: '9171012',
    name: 'Saoka',
  },
  {
    id: '9171012003',
    districtId: '9171012',
    name: 'Suprau',
  },
  {
    id: '9171012004',
    districtId: '9171012',
    name: 'Tampa Garam',
  },
  {
    id: '9171020011',
    districtId: '9171020',
    name: 'Klawuyuk',
  },
  {
    id: '9171020012',
    districtId: '9171020',
    name: 'Klawalu',
  },
  {
    id: '9171020013',
    districtId: '9171020',
    name: 'Klamana',
  },
  {
    id: '9171020016',
    districtId: '9171020',
    name: 'Kladufu',
  },
  {
    id: '9171021002',
    districtId: '9171021',
    name: 'Malanu',
  },
  {
    id: '9171021004',
    districtId: '9171021',
    name: 'Sawagumu',
  },
  {
    id: '9171021007',
    districtId: '9171021',
    name: 'Malasilen',
  },
  {
    id: '9171021009',
    districtId: '9171021',
    name: 'Matalamagi',
  },
  {
    id: '9171022002',
    districtId: '9171022',
    name: 'Klademak',
  },
  {
    id: '9171022003',
    districtId: '9171022',
    name: 'Remu Utara',
  },
  {
    id: '9171022006',
    districtId: '9171022',
    name: 'Kofkerbu',
  },
  {
    id: '9171023001',
    districtId: '9171023',
    name: 'Klaligi',
  },
  {
    id: '9171023002',
    districtId: '9171023',
    name: 'Malawei',
  },
  {
    id: '9171023003',
    districtId: '9171023',
    name: 'Remu Selatan',
  },
  {
    id: '9171023004',
    districtId: '9171023',
    name: 'Malabutor',
  },
  {
    id: '9171023005',
    districtId: '9171023',
    name: 'Klasabi',
  },
  {
    id: '9171024001',
    districtId: '9171024',
    name: 'Klasaman',
  },
  {
    id: '9171024002',
    districtId: '9171024',
    name: 'Klablim',
  },
  {
    id: '9171024003',
    districtId: '9171024',
    name: 'Giwu',
  },
  {
    id: '9171024004',
    districtId: '9171024',
    name: 'Kalasuat',
  },
  {
    id: '9171025001',
    districtId: '9171025',
    name: 'Klagete',
  },
  {
    id: '9171025003',
    districtId: '9171025',
    name: 'Malaingkedi',
  },
  {
    id: '9171025005',
    districtId: '9171025',
    name: 'Malamso',
  },
  {
    id: '9171025006',
    districtId: '9171025',
    name: 'Klabulu',
  },
  {
    id: '9171026001',
    districtId: '9171026',
    name: 'Kampung Baru',
  },
  {
    id: '9171026002',
    districtId: '9171026',
    name: 'Klakublik',
  },
  {
    id: '9171026003',
    districtId: '9171026',
    name: 'Klasuur',
  },
  {
    id: '9171026004',
    districtId: '9171026',
    name: 'Klabala',
  },
  {
    id: '9401010006',
    districtId: '9401010',
    name: 'Komolom',
  },
  {
    id: '9401010007',
    districtId: '9401010',
    name: 'Kumbis',
  },
  {
    id: '9401010008',
    districtId: '9401010',
    name: 'Kalilam',
  },
  {
    id: '9401010011',
    districtId: '9401010',
    name: 'Turiram',
  },
  {
    id: '9401010012',
    districtId: '9401010',
    name: 'Mambum',
  },
  {
    id: '9401010013',
    districtId: '9401010',
    name: 'Deka',
  },
  {
    id: '9401010014',
    districtId: '9401010',
    name: 'Woner',
  },
  {
    id: '9401010015',
    districtId: '9401010',
    name: 'Kiworo',
  },
  {
    id: '9401010016',
    districtId: '9401010',
    name: 'Kimaam',
  },
  {
    id: '9401010022',
    districtId: '9401010',
    name: 'Teri',
  },
  {
    id: '9401010023',
    districtId: '9401010',
    name: 'Sabudom',
  },
  {
    id: '9401011001',
    districtId: '9401011',
    name: 'Kladar',
  },
  {
    id: '9401011002',
    districtId: '9401011',
    name: 'Sabon',
  },
  {
    id: '9401011003',
    districtId: '9401011',
    name: 'Tor',
  },
  {
    id: '9401011004',
    districtId: '9401011',
    name: 'Waan',
  },
  {
    id: '9401011005',
    districtId: '9401011',
    name: 'Konorau',
  },
  {
    id: '9401011006',
    districtId: '9401011',
    name: 'Sibenda',
  },
  {
    id: '9401011007',
    districtId: '9401011',
    name: 'Wetau',
  },
  {
    id: '9401011008',
    districtId: '9401011',
    name: 'Kawe',
  },
  {
    id: '9401012001',
    districtId: '9401012',
    name: 'Konjombando',
  },
  {
    id: '9401012002',
    districtId: '9401012',
    name: 'Yeraha',
  },
  {
    id: '9401012003',
    districtId: '9401012',
    name: 'Wanggambi',
  },
  {
    id: '9401012004',
    districtId: '9401012',
    name: 'Bamol II',
  },
  {
    id: '9401012005',
    districtId: '9401012',
    name: 'Bamol I',
  },
  {
    id: '9401012006',
    districtId: '9401012',
    name: 'Iromoro',
  },
  {
    id: '9401012007',
    districtId: '9401012',
    name: 'Yamuka',
  },
  {
    id: '9401012008',
    districtId: '9401012',
    name: 'Suam',
  },
  {
    id: '9401012009',
    districtId: '9401012',
    name: 'Tabonji',
  },
  {
    id: '9401013001',
    districtId: '9401013',
    name: 'Bibikem',
  },
  {
    id: '9401013002',
    districtId: '9401013',
    name: 'Padua',
  },
  {
    id: '9401013003',
    districtId: '9401013',
    name: 'Wogekel',
  },
  {
    id: '9401013004',
    districtId: '9401013',
    name: 'Wanam',
  },
  {
    id: '9401020004',
    districtId: '9401020',
    name: 'Wambi',
  },
  {
    id: '9401020005',
    districtId: '9401020',
    name: 'Dufmira',
  },
  {
    id: '9401020006',
    districtId: '9401020',
    name: 'Iwol',
  },
  {
    id: '9401020007',
    districtId: '9401020',
    name: 'Makaling',
  },
  {
    id: '9401020008',
    districtId: '9401020',
    name: 'Okaba',
  },
  {
    id: '9401020009',
    districtId: '9401020',
    name: 'Alaku',
  },
  {
    id: '9401020010',
    districtId: '9401020',
    name: 'Alatep',
  },
  {
    id: '9401020011',
    districtId: '9401020',
    name: 'Sanggase',
  },
  {
    id: '9401020012',
    districtId: '9401020',
    name: 'Es Wambi',
  },
  {
    id: '9401021001',
    districtId: '9401021',
    name: 'Wamal',
  },
  {
    id: '9401021002',
    districtId: '9401021',
    name: 'Dokib',
  },
  {
    id: '9401021003',
    districtId: '9401021',
    name: 'Yowied',
  },
  {
    id: '9401021004',
    districtId: '9401021',
    name: 'Welbuti',
  },
  {
    id: '9401021005',
    districtId: '9401021',
    name: 'Dodalim',
  },
  {
    id: '9401021006',
    districtId: '9401021',
    name: 'Woboyo',
  },
  {
    id: '9401022001',
    districtId: '9401022',
    name: 'Po-Epe',
  },
  {
    id: '9401022002',
    districtId: '9401022',
    name: 'Taga Epe',
  },
  {
    id: '9401022003',
    districtId: '9401022',
    name: 'Nakias',
  },
  {
    id: '9401022004',
    districtId: '9401022',
    name: 'Salamepe',
  },
  {
    id: '9401022005',
    districtId: '9401022',
    name: 'Yawimu',
  },
  {
    id: '9401022006',
    districtId: '9401022',
    name: 'Yomop',
  },
  {
    id: '9401023001',
    districtId: '9401023',
    name: 'Kwemzied',
  },
  {
    id: '9401023002',
    districtId: '9401023',
    name: 'Kanis Kobat',
  },
  {
    id: '9401023003',
    districtId: '9401023',
    name: 'Kaptel',
  },
  {
    id: '9401023004',
    districtId: '9401023',
    name: 'Ihalik',
  },
  {
    id: '9401030004',
    districtId: '9401030',
    name: 'Kurik',
  },
  {
    id: '9401030005',
    districtId: '9401030',
    name: 'Harapan Makmur',
  },
  {
    id: '9401030006',
    districtId: '9401030',
    name: 'Ivi Mahad',
  },
  {
    id: '9401030007',
    districtId: '9401030',
    name: 'Telaga Sari',
  },
  {
    id: '9401030008',
    districtId: '9401030',
    name: 'Salor Indah',
  },
  {
    id: '9401030009',
    districtId: '9401030',
    name: 'Sumber Rejeki',
  },
  {
    id: '9401030010',
    districtId: '9401030',
    name: 'Jaya Makmur',
  },
  {
    id: '9401030013',
    districtId: '9401030',
    name: 'Sumber Mulya',
  },
  {
    id: '9401030017',
    districtId: '9401030',
    name: 'Kaliki',
  },
  {
    id: '9401030018',
    districtId: '9401030',
    name: 'Wapeko',
  },
  {
    id: '9401031002',
    districtId: '9401031',
    name: 'Rawasari',
  },
  {
    id: '9401031003',
    districtId: '9401031',
    name: 'Kaiburse',
  },
  {
    id: '9401031004',
    districtId: '9401031',
    name: 'Padang Raharja',
  },
  {
    id: '9401031005',
    districtId: '9401031',
    name: 'Onggari',
  },
  {
    id: '9401031006',
    districtId: '9401031',
    name: 'Suka Maju',
  },
  {
    id: '9401031007',
    districtId: '9401031',
    name: 'Domande',
  },
  {
    id: '9401032001',
    districtId: '9401032',
    name: 'Senegi',
  },
  {
    id: '9401032002',
    districtId: '9401032',
    name: 'Baad',
  },
  {
    id: '9401032003',
    districtId: '9401032',
    name: 'Wajau / Wayao',
  },
  {
    id: '9401032004',
    districtId: '9401032',
    name: 'Koa',
  },
  {
    id: '9401032005',
    districtId: '9401032',
    name: 'Kaisah',
  },
  {
    id: '9401040006',
    districtId: '9401040',
    name: 'Nasem',
  },
  {
    id: '9401040007',
    districtId: '9401040',
    name: 'Rimba Jaya',
  },
  {
    id: '9401040008',
    districtId: '9401040',
    name: 'Wasur',
  },
  {
    id: '9401040014',
    districtId: '9401040',
    name: 'Kelapa Lima',
  },
  {
    id: '9401040015',
    districtId: '9401040',
    name: 'Maro',
  },
  {
    id: '9401040016',
    districtId: '9401040',
    name: 'Mandala',
  },
  {
    id: '9401040017',
    districtId: '9401040',
    name: 'Samkai',
  },
  {
    id: '9401040018',
    districtId: '9401040',
    name: 'Karang Indah',
  },
  {
    id: '9401040056',
    districtId: '9401040',
    name: 'Bambu Pemali',
  },
  {
    id: '9401040057',
    districtId: '9401040',
    name: 'Seringgu Jaya',
  },
  {
    id: '9401040058',
    districtId: '9401040',
    name: 'Nggolar',
  },
  {
    id: '9401040059',
    districtId: '9401040',
    name: 'Bokem',
  },
  {
    id: '9401041002',
    districtId: '9401041',
    name: 'Waninggap Nanggo',
  },
  {
    id: '9401041003',
    districtId: '9401041',
    name: 'Matara',
  },
  {
    id: '9401041004',
    districtId: '9401041',
    name: 'Muram Sari',
  },
  {
    id: '9401041005',
    districtId: '9401041',
    name: 'Semangga Jaya',
  },
  {
    id: '9401041006',
    districtId: '9401041',
    name: 'Sidomulyo',
  },
  {
    id: '9401041007',
    districtId: '9401041',
    name: 'Kuprik',
  },
  {
    id: '9401041009',
    districtId: '9401041',
    name: 'Marga Mulya',
  },
  {
    id: '9401041010',
    districtId: '9401041',
    name: 'Waninggap Kai',
  },
  {
    id: '9401042001',
    districtId: '9401042',
    name: 'Soa',
  },
  {
    id: '9401042002',
    districtId: '9401042',
    name: 'Tambat',
  },
  {
    id: '9401042003',
    districtId: '9401042',
    name: 'Sumber Harapan',
  },
  {
    id: '9401042004',
    districtId: '9401042',
    name: 'Yasa Mulya',
  },
  {
    id: '9401042005',
    districtId: '9401042',
    name: 'Waninggap Say',
  },
  {
    id: '9401042006',
    districtId: '9401042',
    name: 'Waninggap Miraf',
  },
  {
    id: '9401042007',
    districtId: '9401042',
    name: 'Isanombias',
  },
  {
    id: '9401042008',
    districtId: '9401042',
    name: 'Yaba Maru',
  },
  {
    id: '9401042009',
    districtId: '9401042',
    name: 'Amunkai',
  },
  {
    id: '9401042010',
    districtId: '9401042',
    name: 'Hidup Baru',
  },
  {
    id: '9401042011',
    districtId: '9401042',
    name: 'Sermayam Indah',
  },
  {
    id: '9401042012',
    districtId: '9401042',
    name: 'Ngguti Bob',
  },
  {
    id: '9401042013',
    districtId: '9401042',
    name: 'Bersehati',
  },
  {
    id: '9401042014',
    districtId: '9401042',
    name: 'Kamangi',
  },
  {
    id: '9401043001',
    districtId: '9401043',
    name: 'Kamno Sari',
  },
  {
    id: '9401043002',
    districtId: '9401043',
    name: 'Gurinda Jaya',
  },
  {
    id: '9401043003',
    districtId: '9401043',
    name: 'Jagebob Raya',
  },
  {
    id: '9401043004',
    districtId: '9401043',
    name: 'Mimi Baru',
  },
  {
    id: '9401043005',
    districtId: '9401043',
    name: 'Wenda Asri',
  },
  {
    id: '9401043006',
    districtId: '9401043',
    name: 'Angger Parmegi',
  },
  {
    id: '9401043007',
    districtId: '9401043',
    name: 'Kartini',
  },
  {
    id: '9401043008',
    districtId: '9401043',
    name: 'Makarti Jaya',
  },
  {
    id: '9401043009',
    districtId: '9401043',
    name: 'Nalkin',
  },
  {
    id: '9401043010',
    districtId: '9401043',
    name: 'Poo',
  },
  {
    id: '9401043011',
    districtId: '9401043',
    name: 'Blandin Kakayo',
  },
  {
    id: '9401043012',
    districtId: '9401043',
    name: 'Jemunaen Jaya',
  },
  {
    id: '9401043013',
    districtId: '9401043',
    name: 'Melin Megikar',
  },
  {
    id: '9401043014',
    districtId: '9401043',
    name: 'Obathrow',
  },
  {
    id: '9401044001',
    districtId: '9401044',
    name: 'Rawa Biru',
  },
  {
    id: '9401044002',
    districtId: '9401044',
    name: 'Yanggandur',
  },
  {
    id: '9401044003',
    districtId: '9401044',
    name: 'Sota',
  },
  {
    id: '9401044004',
    districtId: '9401044',
    name: 'Erambu',
  },
  {
    id: '9401044005',
    districtId: '9401044',
    name: 'Toray',
  },
  {
    id: '9401045001',
    districtId: '9401045',
    name: 'Kondo',
  },
  {
    id: '9401045002',
    districtId: '9401045',
    name: 'Tomerau',
  },
  {
    id: '9401045003',
    districtId: '9401045',
    name: 'Tomer',
  },
  {
    id: '9401045004',
    districtId: '9401045',
    name: 'Onggaya',
  },
  {
    id: '9401050004',
    districtId: '9401050',
    name: 'Waan',
  },
  {
    id: '9401050005',
    districtId: '9401050',
    name: 'Selauw',
  },
  {
    id: '9401050006',
    districtId: '9401050',
    name: 'Kolam',
  },
  {
    id: '9401050007',
    districtId: '9401050',
    name: 'Boha',
  },
  {
    id: '9401050008',
    districtId: '9401050',
    name: 'Pachas',
  },
  {
    id: '9401050009',
    districtId: '9401050',
    name: 'Muting',
  },
  {
    id: '9401050010',
    districtId: '9401050',
    name: 'Wan Wai Bob',
  },
  {
    id: '9401050011',
    districtId: '9401050',
    name: 'Afkab Makmur',
  },
  {
    id: '9401050012',
    districtId: '9401050',
    name: 'Andaito',
  },
  {
    id: '9401050013',
    districtId: '9401050',
    name: 'Elanggol Jaya',
  },
  {
    id: '9401050014',
    districtId: '9401050',
    name: 'Sigabel',
  },
  {
    id: '9401050015',
    districtId: '9401050',
    name: 'Sed Agung',
  },
  {
    id: '9401051003',
    districtId: '9401051',
    name: 'Tanaas',
  },
  {
    id: '9401051004',
    districtId: '9401051',
    name: 'Sipias',
  },
  {
    id: '9401051005',
    districtId: '9401051',
    name: 'Enggal Jaya',
  },
  {
    id: '9401051006',
    districtId: '9401051',
    name: 'Geriser',
  },
  {
    id: '9401051007',
    districtId: '9401051',
    name: 'Metaat Makmur',
  },
  {
    id: '9401051008',
    districtId: '9401051',
    name: 'Bupul Indah',
  },
  {
    id: '9401051009',
    districtId: '9401051',
    name: 'Bouwer',
  },
  {
    id: '9401051010',
    districtId: '9401051',
    name: 'Bunggay',
  },
  {
    id: '9401051011',
    districtId: '9401051',
    name: 'Tof-Tof',
  },
  {
    id: '9401052001',
    districtId: '9401052',
    name: 'Kumaaf',
  },
  {
    id: '9401052002',
    districtId: '9401052',
    name: 'Nggayu',
  },
  {
    id: '9401052003',
    districtId: '9401052',
    name: 'Kafyamke',
  },
  {
    id: '9401052004',
    districtId: '9401052',
    name: 'Belbeland',
  },
  {
    id: '9401052005',
    districtId: '9401052',
    name: 'Mandekman',
  },
  {
    id: '9401052006',
    districtId: '9401052',
    name: 'Rawahayu',
  },
  {
    id: '9401052007',
    districtId: '9401052',
    name: 'Kindiki',
  },
  {
    id: '9401052008',
    districtId: '9401052',
    name: 'Selil',
  },
  {
    id: '9401052009',
    districtId: '9401052',
    name: 'Kireli',
  },
  {
    id: '9401052010',
    districtId: '9401052',
    name: 'Kandrakai',
  },
  {
    id: '9401052011',
    districtId: '9401052',
    name: 'Baidub',
  },
  {
    id: '9402110010',
    districtId: '9402110',
    name: 'Honelama',
  },
  {
    id: '9402110011',
    districtId: '9402110',
    name: 'Hurekama',
  },
  {
    id: '9402110012',
    districtId: '9402110',
    name: 'Wamena Kota',
  },
  {
    id: '9402110013',
    districtId: '9402110',
    name: 'Hituma',
  },
  {
    id: '9402110014',
    districtId: '9402110',
    name: 'Kama',
  },
  {
    id: '9402110015',
    districtId: '9402110',
    name: 'Wesaganya',
  },
  {
    id: '9402110029',
    districtId: '9402110',
    name: 'Mawampi',
  },
  {
    id: '9402110043',
    districtId: '9402110',
    name: 'Autakma',
  },
  {
    id: '9402110044',
    districtId: '9402110',
    name: 'Sinapuk',
  },
  {
    id: '9402110045',
    districtId: '9402110',
    name: 'Sinakma',
  },
  {
    id: '9402110046',
    districtId: '9402110',
    name: 'Silumarek',
  },
  {
    id: '9402110047',
    districtId: '9402110',
    name: 'Yaloaput',
  },
  {
    id: '9402110048',
    districtId: '9402110',
    name: 'Parema',
  },
  {
    id: '9402110054',
    districtId: '9402110',
    name: 'Agamoa',
  },
  {
    id: '9402110055',
    districtId: '9402110',
    name: 'Batu Merah',
  },
  {
    id: '9402110056',
    districtId: '9402110',
    name: 'Honelama II',
  },
  {
    id: '9402110057',
    districtId: '9402110',
    name: 'Onaima',
  },
  {
    id: '9402110058',
    districtId: '9402110',
    name: 'Lantipo',
  },
  {
    id: '9402110059',
    districtId: '9402110',
    name: 'Wamaroma',
  },
  {
    id: '9402111004',
    districtId: '9402111',
    name: 'Asolokobal',
  },
  {
    id: '9402111006',
    districtId: '9402111',
    name: 'Sinata',
  },
  {
    id: '9402111016',
    districtId: '9402111',
    name: 'Hesatom',
  },
  {
    id: '9402111017',
    districtId: '9402111',
    name: 'Asotapo',
  },
  {
    id: '9402111018',
    districtId: '9402111',
    name: 'Wiaima',
  },
  {
    id: '9402111025',
    districtId: '9402111',
    name: 'Ninabua',
  },
  {
    id: '9402111026',
    districtId: '9402111',
    name: 'Helaluwa',
  },
  {
    id: '9402111027',
    districtId: '9402111',
    name: 'Mulinekama',
  },
  {
    id: '9402111028',
    districtId: '9402111',
    name: 'Yapema',
  },
  {
    id: '9402112002',
    districtId: '9402112',
    name: 'Pugima',
  },
  {
    id: '9402112003',
    districtId: '9402112',
    name: 'Walelagama',
  },
  {
    id: '9402112010',
    districtId: '9402112',
    name: 'Kulaken',
  },
  {
    id: '9402112011',
    districtId: '9402112',
    name: 'Wamusage',
  },
  {
    id: '9402112021',
    districtId: '9402112',
    name: 'Itlay Halitopo',
  },
  {
    id: '9402112022',
    districtId: '9402112',
    name: 'Kubulakma',
  },
  {
    id: '9402113001',
    districtId: '9402113',
    name: 'Trikora',
  },
  {
    id: '9402113002',
    districtId: '9402113',
    name: 'Nanggo',
  },
  {
    id: '9402113030',
    districtId: '9402113',
    name: 'Dinggilmo',
  },
  {
    id: '9402113031',
    districtId: '9402113',
    name: 'Kora Jaya',
  },
  {
    id: '9402113032',
    districtId: '9402113',
    name: 'Korambirik',
  },
  {
    id: '9402113033',
    districtId: '9402113',
    name: 'Anggulpa',
  },
  {
    id: '9402114001',
    districtId: '9402114',
    name: 'Napua',
  },
  {
    id: '9402114002',
    districtId: '9402114',
    name: 'Lani Matuan',
  },
  {
    id: '9402114003',
    districtId: '9402114',
    name: 'Yelekama',
  },
  {
    id: '9402114004',
    districtId: '9402114',
    name: 'Sapalek',
  },
  {
    id: '9402114005',
    districtId: '9402114',
    name: 'Haelekma',
  },
  {
    id: '9402114006',
    districtId: '9402114',
    name: 'Okilik',
  },
  {
    id: '9402114007',
    districtId: '9402114',
    name: 'Holima',
  },
  {
    id: '9402114008',
    districtId: '9402114',
    name: 'Wilekama/Sawarek',
  },
  {
    id: '9402114009',
    districtId: '9402114',
    name: 'Yomaima',
  },
  {
    id: '9402115008',
    districtId: '9402115',
    name: 'Walaik',
  },
  {
    id: '9402115034',
    districtId: '9402115',
    name: 'Elarek',
  },
  {
    id: '9402115035',
    districtId: '9402115',
    name: 'Welekama',
  },
  {
    id: '9402115036',
    districtId: '9402115',
    name: 'Holima',
  },
  {
    id: '9402115037',
    districtId: '9402115',
    name: 'Yelai',
  },
  {
    id: '9402116016',
    districtId: '9402116',
    name: 'Ketimavit',
  },
  {
    id: '9402116017',
    districtId: '9402116',
    name: 'Wouma',
  },
  {
    id: '9402116049',
    districtId: '9402116',
    name: 'Pipitmo',
  },
  {
    id: '9402116050',
    districtId: '9402116',
    name: 'Sinarekowa',
  },
  {
    id: '9402116051',
    districtId: '9402116',
    name: 'Wesakma',
  },
  {
    id: '9402116052',
    districtId: '9402116',
    name: 'Logonoba',
  },
  {
    id: '9402116053',
    districtId: '9402116',
    name: 'Wesakin',
  },
  {
    id: '9402117005',
    districtId: '9402117',
    name: 'Walesi',
  },
  {
    id: '9402117019',
    districtId: '9402117',
    name: 'Yagara',
  },
  {
    id: '9402117020',
    districtId: '9402117',
    name: 'Asojelipele',
  },
  {
    id: '9402117021',
    districtId: '9402117',
    name: 'Lanitipo',
  },
  {
    id: '9402117022',
    districtId: '9402117',
    name: 'Pawekama',
  },
  {
    id: '9402117023',
    districtId: '9402117',
    name: 'Papenas',
  },
  {
    id: '9402117024',
    districtId: '9402117',
    name: 'Tulima',
  },
  {
    id: '9402118001',
    districtId: '9402118',
    name: 'Putagaima',
  },
  {
    id: '9402118002',
    districtId: '9402118',
    name: 'Sogokmo',
  },
  {
    id: '9402118003',
    districtId: '9402118',
    name: 'Asotipo',
  },
  {
    id: '9402118013',
    districtId: '9402118',
    name: 'Heberima',
  },
  {
    id: '9402118014',
    districtId: '9402118',
    name: 'Iwigima',
  },
  {
    id: '9402118015',
    districtId: '9402118',
    name: 'Pobiatma',
  },
  {
    id: '9402118016',
    districtId: '9402118',
    name: 'Hitigima',
  },
  {
    id: '9402118017',
    districtId: '9402118',
    name: 'Kuantapo',
  },
  {
    id: '9402118018',
    districtId: '9402118',
    name: 'Air Garam',
  },
  {
    id: '9402118019',
    districtId: '9402118',
    name: 'Hukulimo',
  },
  {
    id: '9402119007',
    districtId: '9402119',
    name: 'Minimo',
  },
  {
    id: '9402119008',
    districtId: '9402119',
    name: 'Maima',
  },
  {
    id: '9402119028',
    districtId: '9402119',
    name: 'Husewa',
  },
  {
    id: '9402119029',
    districtId: '9402119',
    name: 'Menagaima',
  },
  {
    id: '9402119036',
    districtId: '9402119',
    name: 'Esiak',
  },
  {
    id: '9402119037',
    districtId: '9402119',
    name: 'Heraewa',
  },
  {
    id: '9402119038',
    districtId: '9402119',
    name: 'Kepi',
  },
  {
    id: '9402120011',
    districtId: '9402120',
    name: 'Meagama',
  },
  {
    id: '9402120012',
    districtId: '9402120',
    name: 'Hubikosi',
  },
  {
    id: '9402120013',
    districtId: '9402120',
    name: 'Kosihilapok',
  },
  {
    id: '9402120018',
    districtId: '9402120',
    name: 'Kosimeaga',
  },
  {
    id: '9402120026',
    districtId: '9402120',
    name: 'Isakusa',
  },
  {
    id: '9402120027',
    districtId: '9402120',
    name: 'Pelima',
  },
  {
    id: '9402120028',
    districtId: '9402120',
    name: 'Pipukmo',
  },
  {
    id: '9402120029',
    districtId: '9402120',
    name: 'Musiaima II',
  },
  {
    id: '9402120030',
    districtId: '9402120',
    name: 'Jibilabaga',
  },
  {
    id: '9402120031',
    districtId: '9402120',
    name: 'Ikilumo',
  },
  {
    id: '9402120035',
    districtId: '9402120',
    name: 'Kikhumo',
  },
  {
    id: '9402121007',
    districtId: '9402121',
    name: 'Heatnem',
  },
  {
    id: '9402121008',
    districtId: '9402121',
    name: 'Wililimo',
  },
  {
    id: '9402121009',
    districtId: '9402121',
    name: 'Yabem',
  },
  {
    id: '9402121010',
    districtId: '9402121',
    name: 'Nukahilapok',
  },
  {
    id: '9402121011',
    districtId: '9402121',
    name: 'Wanggeri',
  },
  {
    id: '9402121019',
    districtId: '9402121',
    name: 'Yoman Weya',
  },
  {
    id: '9402121020',
    districtId: '9402121',
    name: 'Aleak',
  },
  {
    id: '9402121021',
    districtId: '9402121',
    name: 'Inanekelok',
  },
  {
    id: '9402121022',
    districtId: '9402121',
    name: 'Filia',
  },
  {
    id: '9402121023',
    districtId: '9402121',
    name: 'Isugunik',
  },
  {
    id: '9402121024',
    districtId: '9402121',
    name: 'Witalak',
  },
  {
    id: '9402121025',
    districtId: '9402121',
    name: 'Mulukmo',
  },
  {
    id: '9402121026',
    districtId: '9402121',
    name: 'Landia',
  },
  {
    id: '9402121027',
    districtId: '9402121',
    name: 'Duabalek',
  },
  {
    id: '9402122001',
    districtId: '9402122',
    name: 'Habema',
  },
  {
    id: '9402122003',
    districtId: '9402122',
    name: 'Tipalok',
  },
  {
    id: '9402122004',
    districtId: '9402122',
    name: 'Yagarobak',
  },
  {
    id: '9402122005',
    districtId: '9402122',
    name: 'Ibele',
  },
  {
    id: '9402122006',
    districtId: '9402122',
    name: 'Zapma',
  },
  {
    id: '9402122012',
    districtId: '9402122',
    name: 'Ayubaibur',
  },
  {
    id: '9402122017',
    districtId: '9402122',
    name: 'Holaliba',
  },
  {
    id: '9402122018',
    districtId: '9402122',
    name: 'Zinai',
  },
  {
    id: '9402122019',
    districtId: '9402122',
    name: 'Yokalpalek',
  },
  {
    id: '9402122020',
    districtId: '9402122',
    name: 'Yelebarek',
  },
  {
    id: '9402123001',
    districtId: '9402123',
    name: 'Tailarek',
  },
  {
    id: '9402123002',
    districtId: '9402123',
    name: 'Bokiem',
  },
  {
    id: '9402123003',
    districtId: '9402123',
    name: 'Iyora',
  },
  {
    id: '9402123004',
    districtId: '9402123',
    name: 'Budliem',
  },
  {
    id: '9402123005',
    districtId: '9402123',
    name: 'Huluaima',
  },
  {
    id: '9402124001',
    districtId: '9402124',
    name: 'Hubikiak',
  },
  {
    id: '9402124002',
    districtId: '9402124',
    name: 'Dokopku',
  },
  {
    id: '9402124003',
    districtId: '9402124',
    name: 'Musiaima',
  },
  {
    id: '9402124004',
    districtId: '9402124',
    name: 'Husoak',
  },
  {
    id: '9402124005',
    districtId: '9402124',
    name: 'Hom-Hom',
  },
  {
    id: '9402124006',
    districtId: '9402124',
    name: 'Hetuma',
  },
  {
    id: '9402124007',
    districtId: '9402124',
    name: 'Likino',
  },
  {
    id: '9402180009',
    districtId: '9402180',
    name: 'Araboda',
  },
  {
    id: '9402180012',
    districtId: '9402180',
    name: 'Kimbim',
  },
  {
    id: '9402180015',
    districtId: '9402180',
    name: 'Walak',
  },
  {
    id: '9402180016',
    districtId: '9402180',
    name: 'Logot',
  },
  {
    id: '9402180029',
    districtId: '9402180',
    name: 'Miligatnem',
  },
  {
    id: '9402180032',
    districtId: '9402180',
    name: 'Wawanca',
  },
  {
    id: '9402180036',
    districtId: '9402180',
    name: 'Loki',
  },
  {
    id: '9402180037',
    districtId: '9402180',
    name: 'Kombagwe',
  },
  {
    id: '9402180038',
    districtId: '9402180',
    name: 'Wanggonoma',
  },
  {
    id: '9402181001',
    districtId: '9402181',
    name: 'Siapma',
  },
  {
    id: '9402181002',
    districtId: '9402181',
    name: 'Elabukama',
  },
  {
    id: '9402181003',
    districtId: '9402181',
    name: 'Temia',
  },
  {
    id: '9402181004',
    districtId: '9402181',
    name: 'Anegera',
  },
  {
    id: '9402181005',
    districtId: '9402181',
    name: 'Mulupalek',
  },
  {
    id: '9402181006',
    districtId: '9402181',
    name: 'Pumasili',
  },
  {
    id: '9402181007',
    districtId: '9402181',
    name: 'Kosihave',
  },
  {
    id: '9402181008',
    districtId: '9402181',
    name: 'Hamuhi',
  },
  {
    id: '9402181009',
    districtId: '9402181',
    name: 'Yumugima',
  },
  {
    id: '9402181010',
    districtId: '9402181',
    name: 'Abulukmo',
  },
  {
    id: '9402182010',
    districtId: '9402182',
    name: 'Wogi',
  },
  {
    id: '9402182011',
    districtId: '9402182',
    name: 'Holasili',
  },
  {
    id: '9402182014',
    districtId: '9402182',
    name: 'Wame',
  },
  {
    id: '9402182024',
    districtId: '9402182',
    name: 'Elaboge',
  },
  {
    id: '9402182030',
    districtId: '9402182',
    name: 'Yerega',
  },
  {
    id: '9402182031',
    districtId: '9402182',
    name: 'Apnae',
  },
  {
    id: '9402182035',
    districtId: '9402182',
    name: 'Tikawo',
  },
  {
    id: '9402182041',
    districtId: '9402182',
    name: 'Olagi',
  },
  {
    id: '9402182042',
    districtId: '9402182',
    name: 'Gigilobo',
  },
  {
    id: '9402182043',
    districtId: '9402182',
    name: 'Wenenggulik',
  },
  {
    id: '9402183017',
    districtId: '9402183',
    name: 'Piramid',
  },
  {
    id: '9402183018',
    districtId: '9402183',
    name: 'Yonggime',
  },
  {
    id: '9402183019',
    districtId: '9402183',
    name: 'Algonik',
  },
  {
    id: '9402183020',
    districtId: '9402183',
    name: 'Perabaga',
  },
  {
    id: '9402183021',
    districtId: '9402183',
    name: 'Yalinggume',
  },
  {
    id: '9402183022',
    districtId: '9402183',
    name: 'Aboneri',
  },
  {
    id: '9402183037',
    districtId: '9402183',
    name: 'Gobalimo',
  },
  {
    id: '9402183038',
    districtId: '9402183',
    name: 'Balima',
  },
  {
    id: '9402183040',
    districtId: '9402183',
    name: 'Beam',
  },
  {
    id: '9402184001',
    districtId: '9402184',
    name: 'Kewin',
  },
  {
    id: '9402184002',
    districtId: '9402184',
    name: 'Holkima',
  },
  {
    id: '9402184007',
    districtId: '9402184',
    name: 'Asologaima',
  },
  {
    id: '9402184008',
    districtId: '9402184',
    name: 'Muliama',
  },
  {
    id: '9402184023',
    districtId: '9402184',
    name: 'Halefa',
  },
  {
    id: '9402184025',
    districtId: '9402184',
    name: 'Konam',
  },
  {
    id: '9402184026',
    districtId: '9402184',
    name: 'Delekama',
  },
  {
    id: '9402184027',
    districtId: '9402184',
    name: 'Silamik',
  },
  {
    id: '9402184028',
    districtId: '9402184',
    name: 'Molebaga',
  },
  {
    id: '9402184040',
    districtId: '9402184',
    name: 'Sekom',
  },
  {
    id: '9402184041',
    districtId: '9402184',
    name: 'Pilabaga',
  },
  {
    id: '9402184042',
    districtId: '9402184',
    name: 'Hukulagi',
  },
  {
    id: '9402185001',
    districtId: '9402185',
    name: 'Dogoname',
  },
  {
    id: '9402185002',
    districtId: '9402185',
    name: 'Yanenggame',
  },
  {
    id: '9402185003',
    districtId: '9402185',
    name: 'Dumapaga',
  },
  {
    id: '9402190007',
    districtId: '9402190',
    name: 'Kimima',
  },
  {
    id: '9402190008',
    districtId: '9402190',
    name: 'Jiwika',
  },
  {
    id: '9402190009',
    districtId: '9402190',
    name: 'Waga - Waga',
  },
  {
    id: '9402190010',
    districtId: '9402190',
    name: 'Eragama',
  },
  {
    id: '9402190011',
    districtId: '9402190',
    name: 'Abusa',
  },
  {
    id: '9402190012',
    districtId: '9402190',
    name: 'Milima',
  },
  {
    id: '9402190027',
    districtId: '9402190',
    name: 'Obya',
  },
  {
    id: '9402190028',
    districtId: '9402190',
    name: 'Mebagaima',
  },
  {
    id: '9402190029',
    districtId: '9402190',
    name: 'Iyantik',
  },
  {
    id: '9402190030',
    districtId: '9402190',
    name: 'Umpagalo',
  },
  {
    id: '9402190031',
    districtId: '9402190',
    name: 'Hopama',
  },
  {
    id: '9402190032',
    districtId: '9402190',
    name: 'Utkolo I',
  },
  {
    id: '9402191013',
    districtId: '9402191',
    name: 'Usilimo',
  },
  {
    id: '9402191014',
    districtId: '9402191',
    name: 'Siba',
  },
  {
    id: '9402191015',
    districtId: '9402191',
    name: 'Wosiala',
  },
  {
    id: '9402191032',
    districtId: '9402191',
    name: 'Gua Wisata',
  },
  {
    id: '9402191033',
    districtId: '9402191',
    name: 'Fikha',
  },
  {
    id: '9402191034',
    districtId: '9402191',
    name: 'Meagaima',
  },
  {
    id: '9402191035',
    districtId: '9402191',
    name: 'Alona',
  },
  {
    id: '9402191036',
    districtId: '9402191',
    name: 'Udulumo',
  },
  {
    id: '9402191037',
    districtId: '9402191',
    name: 'Abutpuk',
  },
  {
    id: '9402191038',
    districtId: '9402191',
    name: 'Isaiman',
  },
  {
    id: '9402192017',
    districtId: '9402192',
    name: 'Korma',
  },
  {
    id: '9402192018',
    districtId: '9402192',
    name: 'Alula',
  },
  {
    id: '9402192019',
    districtId: '9402192',
    name: 'Alolik',
  },
  {
    id: '9402192037',
    districtId: '9402192',
    name: 'Wiligima',
  },
  {
    id: '9402193005',
    districtId: '9402193',
    name: 'Mulima',
  },
  {
    id: '9402193006',
    districtId: '9402193',
    name: 'Wenabubaga',
  },
  {
    id: '9402193024',
    districtId: '9402193',
    name: 'Kilubaga',
  },
  {
    id: '9402193025',
    districtId: '9402193',
    name: 'Musalfak',
  },
  {
    id: '9402193026',
    districtId: '9402193',
    name: 'Punakul',
  },
  {
    id: '9402194001',
    districtId: '9402194',
    name: 'Wadangku',
  },
  {
    id: '9402194003',
    districtId: '9402194',
    name: 'Agulimo',
  },
  {
    id: '9402194004',
    districtId: '9402194',
    name: 'Musiem',
  },
  {
    id: '9402194005',
    districtId: '9402194',
    name: 'Yomosima',
  },
  {
    id: '9402195002',
    districtId: '9402195',
    name: 'Aikima',
  },
  {
    id: '9402195003',
    districtId: '9402195',
    name: 'Okoloma',
  },
  {
    id: '9402195004',
    districtId: '9402195',
    name: 'Pabuma',
  },
  {
    id: '9402195020',
    districtId: '9402195',
    name: 'Wara',
  },
  {
    id: '9402195021',
    districtId: '9402195',
    name: 'Pikhe',
  },
  {
    id: '9402195022',
    districtId: '9402195',
    name: 'Akiaput',
  },
  {
    id: '9402195023',
    districtId: '9402195',
    name: 'Suroba',
  },
  {
    id: '9402220006',
    districtId: '9402220',
    name: 'Bolakme',
  },
  {
    id: '9402220007',
    districtId: '9402220',
    name: 'Lanitimur',
  },
  {
    id: '9402220008',
    districtId: '9402220',
    name: 'Munak',
  },
  {
    id: '9402220026',
    districtId: '9402220',
    name: 'Bandua',
  },
  {
    id: '9402220028',
    districtId: '9402220',
    name: 'Tenonggame',
  },
  {
    id: '9402220032',
    districtId: '9402220',
    name: 'Molagalome',
  },
  {
    id: '9402220033',
    districtId: '9402220',
    name: 'Kwigiluk',
  },
  {
    id: '9402220035',
    districtId: '9402220',
    name: 'Nunggarugum',
  },
  {
    id: '9402220036',
    districtId: '9402220',
    name: 'Paitmos',
  },
  {
    id: '9402220037',
    districtId: '9402220',
    name: 'Wenamela',
  },
  {
    id: '9402220039',
    districtId: '9402220',
    name: 'Pagaluk',
  },
  {
    id: '9402220040',
    districtId: '9402220',
    name: 'Bimu',
  },
  {
    id: '9402220041',
    districtId: '9402220',
    name: 'Tekani',
  },
  {
    id: '9402220042',
    districtId: '9402220',
    name: 'Kugitero',
  },
  {
    id: '9402221003',
    districtId: '9402221',
    name: 'Kukurima',
  },
  {
    id: '9402221009',
    districtId: '9402221',
    name: 'Pirambot',
  },
  {
    id: '9402221010',
    districtId: '9402221',
    name: 'Wollo',
  },
  {
    id: '9402221015',
    districtId: '9402221',
    name: 'Wollo Timur',
  },
  {
    id: '9402221016',
    districtId: '9402221',
    name: 'Tegabaga',
  },
  {
    id: '9402221017',
    districtId: '9402221',
    name: 'Alugi',
  },
  {
    id: '9402221018',
    districtId: '9402221',
    name: 'Wodlama',
  },
  {
    id: '9402221019',
    districtId: '9402221',
    name: 'Wunan',
  },
  {
    id: '9402222002',
    districtId: '9402222',
    name: 'Taganik',
  },
  {
    id: '9402222003',
    districtId: '9402222',
    name: 'Yelengga',
  },
  {
    id: '9402222004',
    districtId: '9402222',
    name: 'Wananuk',
  },
  {
    id: '9402222007',
    districtId: '9402222',
    name: 'Pilimo',
  },
  {
    id: '9402222009',
    districtId: '9402222',
    name: 'Akorek',
  },
  {
    id: '9402222010',
    districtId: '9402222',
    name: 'Manili',
  },
  {
    id: '9402222011',
    districtId: '9402222',
    name: 'Aipakma',
  },
  {
    id: '9402222012',
    districtId: '9402222',
    name: 'Wugurima',
  },
  {
    id: '9402222013',
    districtId: '9402222',
    name: 'Bitti',
  },
  {
    id: '9402222014',
    districtId: '9402222',
    name: 'Wananuk Dua',
  },
  {
    id: '9402223027',
    districtId: '9402223',
    name: 'Lakwame',
  },
  {
    id: '9402223029',
    districtId: '9402223',
    name: 'Tagime',
  },
  {
    id: '9402223030',
    districtId: '9402223',
    name: 'Porome',
  },
  {
    id: '9402223034',
    districtId: '9402223',
    name: 'Onggobalo',
  },
  {
    id: '9402223038',
    districtId: '9402223',
    name: 'Lapeyo',
  },
  {
    id: '9402223039',
    districtId: '9402223',
    name: 'Yordania Tulak',
  },
  {
    id: '9402223040',
    districtId: '9402223',
    name: 'Wandinggunie',
  },
  {
    id: '9402223041',
    districtId: '9402223',
    name: 'Gume Kupari',
  },
  {
    id: '9402223042',
    districtId: '9402223',
    name: 'Mulugame',
  },
  {
    id: '9402223043',
    districtId: '9402223',
    name: 'Yogobur',
  },
  {
    id: '9402223044',
    districtId: '9402223',
    name: 'Yonggapura',
  },
  {
    id: '9402224004',
    districtId: '9402224',
    name: 'Tanah Merah',
  },
  {
    id: '9402224005',
    districtId: '9402224',
    name: 'Towagame',
  },
  {
    id: '9402224006',
    districtId: '9402224',
    name: 'Molagalome',
  },
  {
    id: '9402224007',
    districtId: '9402224',
    name: 'Kwigiluk',
  },
  {
    id: '9402224009',
    districtId: '9402224',
    name: 'Okwa',
  },
  {
    id: '9402225001',
    districtId: '9402225',
    name: 'Tagineri',
  },
  {
    id: '9402225002',
    districtId: '9402225',
    name: 'Binibaga',
  },
  {
    id: '9402225003',
    districtId: '9402225',
    name: 'Injuta',
  },
  {
    id: '9402225004',
    districtId: '9402225',
    name: 'Tamokilu',
  },
  {
    id: '9402225005',
    districtId: '9402225',
    name: 'Wilaloma',
  },
  {
    id: '9402225006',
    districtId: '9402225',
    name: 'Galelema',
  },
  {
    id: '9402225007',
    districtId: '9402225',
    name: 'Melemei',
  },
  {
    id: '9402225008',
    districtId: '9402225',
    name: 'Pagaluk',
  },
  {
    id: '9402225009',
    districtId: '9402225',
    name: 'Wuragukme',
  },
  {
    id: '9402226001',
    districtId: '9402226',
    name: 'Manda',
  },
  {
    id: '9402226002',
    districtId: '9402226',
    name: 'Bugi',
  },
  {
    id: '9402226003',
    districtId: '9402226',
    name: 'Kodlangga',
  },
  {
    id: '9402226004',
    districtId: '9402226',
    name: 'Walak Selatan',
  },
  {
    id: '9402226005',
    districtId: '9402226',
    name: 'Air Garam',
  },
  {
    id: '9402226006',
    districtId: '9402226',
    name: 'Totni',
  },
  {
    id: '9402226007',
    districtId: '9402226',
    name: 'Tagunik',
  },
  {
    id: '9402227011',
    districtId: '9402227',
    name: 'Irilingga',
  },
  {
    id: '9402227012',
    districtId: '9402227',
    name: 'Onggobaga',
  },
  {
    id: '9402227014',
    districtId: '9402227',
    name: 'Walakma',
  },
  {
    id: '9402227017',
    districtId: '9402227',
    name: 'Tirunggu',
  },
  {
    id: '9402227018',
    districtId: '9402227',
    name: 'Ayoma',
  },
  {
    id: '9402227019',
    districtId: '9402227',
    name: 'Dlonggoki',
  },
  {
    id: '9402227020',
    districtId: '9402227',
    name: 'Dlinggama',
  },
  {
    id: '9402228001',
    districtId: '9402228',
    name: 'Telegawi',
  },
  {
    id: '9402228002',
    districtId: '9402228',
    name: 'Tenondek',
  },
  {
    id: '9402228003',
    districtId: '9402228',
    name: 'Koragiga',
  },
  {
    id: '9402228005',
    districtId: '9402228',
    name: 'Tagibaga',
  },
  {
    id: '9402611001',
    districtId: '9402611',
    name: 'Lukaken',
  },
  {
    id: '9402611002',
    districtId: '9402611',
    name: 'Yogonima',
  },
  {
    id: '9402611003',
    districtId: '9402611',
    name: 'Tomisa',
  },
  {
    id: '9402611004',
    districtId: '9402611',
    name: 'Waoba',
  },
  {
    id: '9402611005',
    districtId: '9402611',
    name: 'Helepalegem',
  },
  {
    id: '9402611006',
    districtId: '9402611',
    name: 'Miami',
  },
  {
    id: '9402611007',
    districtId: '9402611',
    name: 'Siliwa',
  },
  {
    id: '9402611008',
    districtId: '9402611',
    name: 'Sumunikama',
  },
  {
    id: '9402611009',
    districtId: '9402611',
    name: 'Kemisake',
  },
  {
    id: '9402612001',
    districtId: '9402612',
    name: 'Siepkosi',
  },
  {
    id: '9402612002',
    districtId: '9402612',
    name: 'Noagalo',
  },
  {
    id: '9402612003',
    districtId: '9402612',
    name: 'Yumogima',
  },
  {
    id: '9402612004',
    districtId: '9402612',
    name: 'Isawa Himan',
  },
  {
    id: '9402612005',
    districtId: '9402612',
    name: 'Sekan',
  },
  {
    id: '9402612006',
    districtId: '9402612',
    name: 'Manika',
  },
  {
    id: '9402612007',
    districtId: '9402612',
    name: 'Sekan Dalam',
  },
  {
    id: '9402612008',
    districtId: '9402612',
    name: 'Lunaima',
  },
  {
    id: '9402612009',
    districtId: '9402612',
    name: 'Wekia',
  },
  {
    id: '9402614001',
    districtId: '9402614',
    name: 'Popugoba',
  },
  {
    id: '9402614002',
    districtId: '9402614',
    name: 'Yalelo',
  },
  {
    id: '9402614003',
    districtId: '9402614',
    name: 'Yomote',
  },
  {
    id: '9402614004',
    districtId: '9402614',
    name: 'Waima',
  },
  {
    id: '9403080004',
    districtId: '9403080',
    name: 'Soskotek',
  },
  {
    id: '9403080005',
    districtId: '9403080',
    name: 'Lapua',
  },
  {
    id: '9403080007',
    districtId: '9403080',
    name: 'Umbron',
  },
  {
    id: '9403080008',
    districtId: '9403080',
    name: 'Yadauw',
  },
  {
    id: '9403081001',
    districtId: '9403081',
    name: 'Pagai',
  },
  {
    id: '9403081002',
    districtId: '9403081',
    name: 'Hulu Atas',
  },
  {
    id: '9403081003',
    districtId: '9403081',
    name: 'Aurina',
  },
  {
    id: '9403081004',
    districtId: '9403081',
    name: 'Muara Nawa',
  },
  {
    id: '9403081005',
    districtId: '9403081',
    name: 'Kamikaru',
  },
  {
    id: '9403081006',
    districtId: '9403081',
    name: 'Naira',
  },
  {
    id: '9403082001',
    districtId: '9403082',
    name: 'Tabbeyan',
  },
  {
    id: '9403082002',
    districtId: '9403082',
    name: 'Ongan Jaya',
  },
  {
    id: '9403082003',
    districtId: '9403082',
    name: 'Kwarja',
  },
  {
    id: '9403082004',
    districtId: '9403082',
    name: 'Bumi Sahaja',
  },
  {
    id: '9403082005',
    districtId: '9403082',
    name: 'Nawa Mulya',
  },
  {
    id: '9403082006',
    districtId: '9403082',
    name: 'Nawa Mukti',
  },
  {
    id: '9403082007',
    districtId: '9403082',
    name: 'Takwa Bangun',
  },
  {
    id: '9403082008',
    districtId: '9403082',
    name: 'Purnawa Jati',
  },
  {
    id: '9403140001',
    districtId: '9403140',
    name: 'Kwansu',
  },
  {
    id: '9403140002',
    districtId: '9403140',
    name: 'Nambon',
  },
  {
    id: '9403140003',
    districtId: '9403140',
    name: 'Namei',
  },
  {
    id: '9403140004',
    districtId: '9403140',
    name: 'Mamda',
  },
  {
    id: '9403140005',
    districtId: '9403140',
    name: 'Mandayawan',
  },
  {
    id: '9403140006',
    districtId: '9403140',
    name: 'Sama',
  },
  {
    id: '9403140007',
    districtId: '9403140',
    name: 'Soaib',
  },
  {
    id: '9403140008',
    districtId: '9403140',
    name: 'Sabeab Kecil',
  },
  {
    id: '9403140009',
    districtId: '9403140',
    name: 'Sekori',
  },
  {
    id: '9403140010',
    districtId: '9403140',
    name: 'Skoaim',
  },
  {
    id: '9403140011',
    districtId: '9403140',
    name: 'Aib',
  },
  {
    id: '9403140012',
    districtId: '9403140',
    name: 'Bengguin Progo',
  },
  {
    id: '9403150002',
    districtId: '9403150',
    name: 'Nembugresi',
  },
  {
    id: '9403150003',
    districtId: '9403150',
    name: 'Ibub',
  },
  {
    id: '9403150004',
    districtId: '9403150',
    name: 'Hatib',
  },
  {
    id: '9403150005',
    districtId: '9403150',
    name: 'Bring',
  },
  {
    id: '9403150006',
    districtId: '9403150',
    name: 'Pupehabu',
  },
  {
    id: '9403150007',
    districtId: '9403150',
    name: 'Damoi Kati',
  },
  {
    id: '9403150008',
    districtId: '9403150',
    name: 'Demetim',
  },
  {
    id: '9403150009',
    districtId: '9403150',
    name: 'Yanbra',
  },
  {
    id: '9403150010',
    districtId: '9403150',
    name: 'Braso',
  },
  {
    id: '9403150012',
    districtId: '9403150',
    name: 'Hyansip',
  },
  {
    id: '9403150013',
    districtId: '9403150',
    name: 'Jagrang',
  },
  {
    id: '9403150015',
    districtId: '9403150',
    name: 'Swentab',
  },
  {
    id: '9403151001',
    districtId: '9403151',
    name: 'Klaisu',
  },
  {
    id: '9403151002',
    districtId: '9403151',
    name: 'Bangai',
  },
  {
    id: '9403151003',
    districtId: '9403151',
    name: 'Iwon',
  },
  {
    id: '9403151004',
    districtId: '9403151',
    name: 'Omon',
  },
  {
    id: '9403160002',
    districtId: '9403160',
    name: 'Oyengsi',
  },
  {
    id: '9403160003',
    districtId: '9403160',
    name: 'Singgriway',
  },
  {
    id: '9403160004',
    districtId: '9403160',
    name: 'Tabri',
  },
  {
    id: '9403160006',
    districtId: '9403160',
    name: 'Singgri',
  },
  {
    id: '9403160008',
    districtId: '9403160',
    name: 'Benyom',
  },
  {
    id: '9403160009',
    districtId: '9403160',
    name: 'Kuipons',
  },
  {
    id: '9403160011',
    districtId: '9403160',
    name: 'Imsar',
  },
  {
    id: '9403160018',
    districtId: '9403160',
    name: 'Kaitemung',
  },
  {
    id: '9403160019',
    districtId: '9403160',
    name: 'Kuwase',
  },
  {
    id: '9403160020',
    districtId: '9403160',
    name: 'Pobaim',
  },
  {
    id: '9403160021',
    districtId: '9403160',
    name: 'Yenggu Baru',
  },
  {
    id: '9403161001',
    districtId: '9403161',
    name: 'Sanggai',
  },
  {
    id: '9403161002',
    districtId: '9403161',
    name: 'Sarmai Atas',
  },
  {
    id: '9403161003',
    districtId: '9403161',
    name: 'Sarmai Bawah',
  },
  {
    id: '9403161004',
    districtId: '9403161',
    name: 'Yakasib',
  },
  {
    id: '9403161006',
    districtId: '9403161',
    name: 'Karya Bumi',
  },
  {
    id: '9403161007',
    districtId: '9403161',
    name: 'Imestum',
  },
  {
    id: '9403161009',
    districtId: '9403161',
    name: 'Hanggai Hamong',
  },
  {
    id: '9403170001',
    districtId: '9403170',
    name: 'Benyom Jaya I',
  },
  {
    id: '9403170002',
    districtId: '9403170',
    name: 'Benyom Jaya II',
  },
  {
    id: '9403170003',
    districtId: '9403170',
    name: 'Nembukrang',
  },
  {
    id: '9403170004',
    districtId: '9403170',
    name: 'Nimbokrang Sari',
  },
  {
    id: '9403170005',
    districtId: '9403170',
    name: 'Berab',
  },
  {
    id: '9403170006',
    districtId: '9403170',
    name: 'Wahab',
  },
  {
    id: '9403170007',
    districtId: '9403170',
    name: 'Hamongkrang',
  },
  {
    id: '9403170008',
    districtId: '9403170',
    name: 'Bunyom',
  },
  {
    id: '9403170009',
    districtId: '9403170',
    name: 'Rhepang Muaib',
  },
  {
    id: '9403180001',
    districtId: '9403180',
    name: 'Guriyad',
  },
  {
    id: '9403180002',
    districtId: '9403180',
    name: 'Sentosa',
  },
  {
    id: '9403180003',
    districtId: '9403180',
    name: 'Beneik',
  },
  {
    id: '9403180004',
    districtId: '9403180',
    name: 'Garusa',
  },
  {
    id: '9403180005',
    districtId: '9403180',
    name: 'Sawesuma',
  },
  {
    id: '9403180006',
    districtId: '9403180',
    name: 'Nandalzi',
  },
  {
    id: '9403200001',
    districtId: '9403200',
    name: 'Kamdera',
  },
  {
    id: '9403200002',
    districtId: '9403200',
    name: 'Muaif',
  },
  {
    id: '9403200003',
    districtId: '9403200',
    name: 'Ambora',
  },
  {
    id: '9403200004',
    districtId: '9403200',
    name: 'Yaugapsa',
  },
  {
    id: '9403200005',
    districtId: '9403200',
    name: 'Demta Kota',
  },
  {
    id: '9403200006',
    districtId: '9403200',
    name: 'Yakore',
  },
  {
    id: '9403200007',
    districtId: '9403200',
    name: 'Muris Kecil',
  },
  {
    id: '9403201001',
    districtId: '9403201',
    name: 'Maruway',
  },
  {
    id: '9403201002',
    districtId: '9403201',
    name: 'Meukisi',
  },
  {
    id: '9403201003',
    districtId: '9403201',
    name: 'Endokisi',
  },
  {
    id: '9403201004',
    districtId: '9403201',
    name: 'Snamai',
  },
  {
    id: '9403201005',
    districtId: '9403201',
    name: 'Buseryo',
  },
  {
    id: '9403210001',
    districtId: '9403210',
    name: 'Kendate',
  },
  {
    id: '9403210002',
    districtId: '9403210',
    name: 'Entiyebo',
  },
  {
    id: '9403210003',
    districtId: '9403210',
    name: 'Waiya',
  },
  {
    id: '9403210004',
    districtId: '9403210',
    name: 'Tablasupa',
  },
  {
    id: '9403210005',
    districtId: '9403210',
    name: 'Yepase',
  },
  {
    id: '9403210006',
    districtId: '9403210',
    name: 'Wambena',
  },
  {
    id: '9403210007',
    districtId: '9403210',
    name: 'Yewena',
  },
  {
    id: '9403210008',
    districtId: '9403210',
    name: 'Doromena',
  },
  {
    id: '9403211001',
    districtId: '9403211',
    name: 'Yongsu Sapari',
  },
  {
    id: '9403211002',
    districtId: '9403211',
    name: 'Yongsu Dosoyo',
  },
  {
    id: '9403211003',
    districtId: '9403211',
    name: 'Ormuwari',
  },
  {
    id: '9403211004',
    districtId: '9403211',
    name: 'Necheibe (Nehiba / Nacha Tawa)',
  },
  {
    id: '9403220007',
    districtId: '9403220',
    name: 'Sabron Sari',
  },
  {
    id: '9403220008',
    districtId: '9403220',
    name: 'Sabron Yoru',
  },
  {
    id: '9403220009',
    districtId: '9403220',
    name: 'Dosai',
  },
  {
    id: '9403220010',
    districtId: '9403220',
    name: 'Waibron',
  },
  {
    id: '9403220011',
    districtId: '9403220',
    name: 'Maribu',
  },
  {
    id: '9403221001',
    districtId: '9403221',
    name: 'Dondai',
  },
  {
    id: '9403221002',
    districtId: '9403221',
    name: 'Kwadeware',
  },
  {
    id: '9403221003',
    districtId: '9403221',
    name: 'Yakonde',
  },
  {
    id: '9403221004',
    districtId: '9403221',
    name: 'Sosiri',
  },
  {
    id: '9403221005',
    districtId: '9403221',
    name: 'Doyo Lama',
  },
  {
    id: '9403221006',
    districtId: '9403221',
    name: 'Doyo Baru',
  },
  {
    id: '9403221007',
    districtId: '9403221',
    name: 'Bambar',
  },
  {
    id: '9403230006',
    districtId: '9403230',
    name: 'Hobong',
  },
  {
    id: '9403230007',
    districtId: '9403230',
    name: 'Ifale / Ajau',
  },
  {
    id: '9403230008',
    districtId: '9403230',
    name: 'Yoboy / Kehusa / Kehiran',
  },
  {
    id: '9403230009',
    districtId: '9403230',
    name: 'Dobonsolo',
  },
  {
    id: '9403230010',
    districtId: '9403230',
    name: 'Yobeh',
  },
  {
    id: '9403230011',
    districtId: '9403230',
    name: 'Ifar Besar',
  },
  {
    id: '9403230012',
    districtId: '9403230',
    name: 'Sentani Kota',
  },
  {
    id: '9403230014',
    districtId: '9403230',
    name: 'Hinekombe',
  },
  {
    id: '9403230015',
    districtId: '9403230',
    name: 'Yahim',
  },
  {
    id: '9403231001',
    districtId: '9403231',
    name: 'Babrongko',
  },
  {
    id: '9403231002',
    districtId: '9403231',
    name: 'Simporo',
  },
  {
    id: '9403231003',
    districtId: '9403231',
    name: 'Khameyaka',
  },
  {
    id: '9403231004',
    districtId: '9403231',
    name: 'Atabar',
  },
  {
    id: '9403231005',
    districtId: '9403231',
    name: 'Ebungfa',
  },
  {
    id: '9403240001',
    districtId: '9403240',
    name: 'Puai',
  },
  {
    id: '9403240002',
    districtId: '9403240',
    name: 'Itakiwa',
  },
  {
    id: '9403240003',
    districtId: '9403240',
    name: 'Asei Besar',
  },
  {
    id: '9403240004',
    districtId: '9403240',
    name: 'Asei Kecil',
  },
  {
    id: '9403240005',
    districtId: '9403240',
    name: 'Nolokla',
  },
  {
    id: '9403240006',
    districtId: '9403240',
    name: 'Nendali',
  },
  {
    id: '9403240007',
    districtId: '9403240',
    name: 'Yokiwa',
  },
  {
    id: '9404050014',
    districtId: '9404050',
    name: 'Marga Jaya',
  },
  {
    id: '9404050015',
    districtId: '9404050',
    name: 'Argo Mulyo',
  },
  {
    id: '9404050016',
    districtId: '9404050',
    name: 'Topo Jaya',
  },
  {
    id: '9404050017',
    districtId: '9404050',
    name: 'Gamei Jaya',
  },
  {
    id: '9404050019',
    districtId: '9404050',
    name: 'Topo',
  },
  {
    id: '9404050020',
    districtId: '9404050',
    name: 'Gamei Biru',
  },
  {
    id: '9404051001',
    districtId: '9404051',
    name: 'Lokodimi',
  },
  {
    id: '9404051002',
    districtId: '9404051',
    name: 'Yegeugi',
  },
  {
    id: '9404051003',
    districtId: '9404051',
    name: 'Ogiyai / Waisai',
  },
  {
    id: '9404051004',
    districtId: '9404051',
    name: 'Kunupi / Obaipoto',
  },
  {
    id: '9404052001',
    districtId: '9404052',
    name: 'Jainoa',
  },
  {
    id: '9404052002',
    districtId: '9404052',
    name: 'Jigikebo',
  },
  {
    id: '9404052003',
    districtId: '9404052',
    name: 'Dikiya',
  },
  {
    id: '9404052004',
    districtId: '9404052',
    name: 'Tagauto',
  },
  {
    id: '9404052005',
    districtId: '9404052',
    name: 'Epouwa',
  },
  {
    id: '9404060001',
    districtId: '9404060',
    name: 'Wami Jaya',
  },
  {
    id: '9404060002',
    districtId: '9404060',
    name: 'Sima',
  },
  {
    id: '9404060003',
    districtId: '9404060',
    name: 'Akudiomi',
  },
  {
    id: '9404060004',
    districtId: '9404060',
    name: 'Yaur',
  },
  {
    id: '9404061001',
    districtId: '9404061',
    name: 'Napan Yaur',
  },
  {
    id: '9404061002',
    districtId: '9404061',
    name: 'Bawei',
  },
  {
    id: '9404061003',
    districtId: '9404061',
    name: 'Yeretuar',
  },
  {
    id: '9404061004',
    districtId: '9404061',
    name: 'Goni',
  },
  {
    id: '9404070002',
    districtId: '9404070',
    name: 'Wiraska',
  },
  {
    id: '9404070003',
    districtId: '9404070',
    name: 'Wanggar Makmur',
  },
  {
    id: '9404070004',
    districtId: '9404070',
    name: 'Bumi Mulia',
  },
  {
    id: '9404070010',
    districtId: '9404070',
    name: 'Karadiri',
  },
  {
    id: '9404070011',
    districtId: '9404070',
    name: 'Wanggar Sari',
  },
  {
    id: '9404071001',
    districtId: '9404071',
    name: 'Bumi Raya',
  },
  {
    id: '9404071002',
    districtId: '9404071',
    name: 'Wadio',
  },
  {
    id: '9404071003',
    districtId: '9404071',
    name: 'Gerbang Sadu',
  },
  {
    id: '9404071004',
    districtId: '9404071',
    name: 'Kali Semen',
  },
  {
    id: '9404071005',
    districtId: '9404071',
    name: 'Waroki',
  },
  {
    id: '9404080001',
    districtId: '9404080',
    name: 'Bumi Wonorejo',
  },
  {
    id: '9404080002',
    districtId: '9404080',
    name: 'Kalibobo',
  },
  {
    id: '9404080003',
    districtId: '9404080',
    name: 'Morgo',
  },
  {
    id: '9404080004',
    districtId: '9404080',
    name: 'Oyehe',
  },
  {
    id: '9404080005',
    districtId: '9404080',
    name: 'Karang Mulia',
  },
  {
    id: '9404080006',
    districtId: '9404080',
    name: 'Karang Tumaritis',
  },
  {
    id: '9404080007',
    districtId: '9404080',
    name: 'Girimulyo',
  },
  {
    id: '9404080008',
    districtId: '9404080',
    name: 'Kali Harapan',
  },
  {
    id: '9404080009',
    districtId: '9404080',
    name: 'Kali Susu',
  },
  {
    id: '9404080010',
    districtId: '9404080',
    name: 'Nabarua',
  },
  {
    id: '9404080011',
    districtId: '9404080',
    name: 'Siriwini',
  },
  {
    id: '9404080013',
    districtId: '9404080',
    name: 'Sanoba',
  },
  {
    id: '9404080014',
    districtId: '9404080',
    name: 'Sanoba Atas',
  },
  {
    id: '9404081001',
    districtId: '9404081',
    name: 'Waharia',
  },
  {
    id: '9404081002',
    districtId: '9404081',
    name: 'Kimi',
  },
  {
    id: '9404081003',
    districtId: '9404081',
    name: 'Samabusa',
  },
  {
    id: '9404081004',
    districtId: '9404081',
    name: 'Lani',
  },
  {
    id: '9404081005',
    districtId: '9404081',
    name: 'Air Mandidi',
  },
  {
    id: '9404090009',
    districtId: '9404090',
    name: 'Masipawa',
  },
  {
    id: '9404090010',
    districtId: '9404090',
    name: 'Napan',
  },
  {
    id: '9404090011',
    districtId: '9404090',
    name: 'Weinami',
  },
  {
    id: '9404090012',
    districtId: '9404090',
    name: 'Mosan',
  },
  {
    id: '9404091001',
    districtId: '9404091',
    name: 'Manunggal Jaya',
  },
  {
    id: '9404091002',
    districtId: '9404091',
    name: 'Maidei',
  },
  {
    id: '9404091003',
    districtId: '9404091',
    name: 'Legari Jaya',
  },
  {
    id: '9404091004',
    districtId: '9404091',
    name: 'Biha',
  },
  {
    id: '9404091005',
    districtId: '9404091',
    name: 'Nifasi',
  },
  {
    id: '9404091006',
    districtId: '9404091',
    name: 'Makimi',
  },
  {
    id: '9404092001',
    districtId: '9404092',
    name: 'Totoberi',
  },
  {
    id: '9404092002',
    districtId: '9404092',
    name: 'Samanui',
  },
  {
    id: '9404092004',
    districtId: '9404092',
    name: 'Taumi',
  },
  {
    id: '9404092005',
    districtId: '9404092',
    name: 'Kamarisanoi',
  },
  {
    id: '9404093001',
    districtId: '9404093',
    name: 'Arui',
  },
  {
    id: '9404093002',
    districtId: '9404093',
    name: 'Moor',
  },
  {
    id: '9404093003',
    districtId: '9404093',
    name: 'Kama',
  },
  {
    id: '9404093004',
    districtId: '9404093',
    name: 'Mambor',
  },
  {
    id: '9404093005',
    districtId: '9404093',
    name: 'Hariti',
  },
  {
    id: '9404100001',
    districtId: '9404100',
    name: 'Epomani',
  },
  {
    id: '9404100002',
    districtId: '9404100',
    name: 'Ugida',
  },
  {
    id: '9404100003',
    districtId: '9404100',
    name: 'Tibai',
  },
  {
    id: '9404100004',
    districtId: '9404100',
    name: 'Siriwo/ Unipo',
  },
  {
    id: '9404100005',
    districtId: '9404100',
    name: 'Aibore',
  },
  {
    id: '9404100006',
    districtId: '9404100',
    name: 'Mabou',
  },
  {
    id: '9404110001',
    districtId: '9404110',
    name: 'Parauto',
  },
  {
    id: '9404110002',
    districtId: '9404110',
    name: 'Bomopai',
  },
  {
    id: '9404110003',
    districtId: '9404110',
    name: 'Ororodo',
  },
  {
    id: '9404110004',
    districtId: '9404110',
    name: 'Yaro Makmur',
  },
  {
    id: '9404110005',
    districtId: '9404110',
    name: 'Jaya Mukti',
  },
  {
    id: '9404110006',
    districtId: '9404110',
    name: 'Wanggar Pantai',
  },
  {
    id: '9404110007',
    districtId: '9404110',
    name: 'Epougi',
  },
  {
    id: '9408040009',
    districtId: '9408040',
    name: 'W A B O',
  },
  {
    id: '9408040010',
    districtId: '9408040',
    name: 'Korombobi',
  },
  {
    id: '9408040011',
    districtId: '9408040',
    name: 'Wonsyupi',
  },
  {
    id: '9408040012',
    districtId: '9408040',
    name: 'Wabompi',
  },
  {
    id: '9408040013',
    districtId: '9408040',
    name: 'Nunsembai',
  },
  {
    id: '9408040014',
    districtId: '9408040',
    name: 'Mereruni',
  },
  {
    id: '9408040015',
    districtId: '9408040',
    name: 'Dawai',
  },
  {
    id: '9408040016',
    districtId: '9408040',
    name: 'Awunawai',
  },
  {
    id: '9408040017',
    districtId: '9408040',
    name: 'Nunsyiari',
  },
  {
    id: '9408040019',
    districtId: '9408040',
    name: 'Duai',
  },
  {
    id: '9408041003',
    districtId: '9408041',
    name: 'Yobi',
  },
  {
    id: '9408041004',
    districtId: '9408041',
    name: 'Soromasen',
  },
  {
    id: '9408041005',
    districtId: '9408041',
    name: 'Sambrawai',
  },
  {
    id: '9408041006',
    districtId: '9408041',
    name: 'Tindaret',
  },
  {
    id: '9408041007',
    districtId: '9408041',
    name: 'Kiriyou',
  },
  {
    id: '9408041008',
    districtId: '9408041',
    name: 'Roswari / Artaneng',
  },
  {
    id: '9408041009',
    districtId: '9408041',
    name: 'Doreimanona',
  },
  {
    id: '9408042001',
    districtId: '9408042',
    name: 'Wabuayar',
  },
  {
    id: '9408042002',
    districtId: '9408042',
    name: 'Ampimoi',
  },
  {
    id: '9408042003',
    districtId: '9408042',
    name: 'Karoaipi',
  },
  {
    id: '9408042004',
    districtId: '9408042',
    name: 'Randawaya',
  },
  {
    id: '9408042005',
    districtId: '9408042',
    name: 'Ayari',
  },
  {
    id: '9408042006',
    districtId: '9408042',
    name: 'Warironi',
  },
  {
    id: '9408042007',
    districtId: '9408042',
    name: 'Waita',
  },
  {
    id: '9408042008',
    districtId: '9408042',
    name: 'Tarei',
  },
  {
    id: '9408042009',
    districtId: '9408042',
    name: 'Bareraipi',
  },
  {
    id: '9408042010',
    districtId: '9408042',
    name: 'Siromi',
  },
  {
    id: '9408042011',
    districtId: '9408042',
    name: 'Arareni',
  },
  {
    id: '9408043001',
    districtId: '9408043',
    name: 'Barawai',
  },
  {
    id: '9408043007',
    districtId: '9408043',
    name: 'Waindu',
  },
  {
    id: '9408043008',
    districtId: '9408043',
    name: 'Sawenui',
  },
  {
    id: '9408043009',
    districtId: '9408043',
    name: 'Kororompui',
  },
  {
    id: '9408043010',
    districtId: '9408043',
    name: 'W O D A',
  },
  {
    id: '9408043011',
    districtId: '9408043',
    name: 'Aisau',
  },
  {
    id: '9408043012',
    districtId: '9408043',
    name: 'Sawendui',
  },
  {
    id: '9408044002',
    districtId: '9408044',
    name: 'Kaipuri',
  },
  {
    id: '9408044003',
    districtId: '9408044',
    name: 'Doreiamini',
  },
  {
    id: '9408044004',
    districtId: '9408044',
    name: 'Andesaria',
  },
  {
    id: '9408044006',
    districtId: '9408044',
    name: 'Kirimbri',
  },
  {
    id: '9408044007',
    districtId: '9408044',
    name: 'Mansiesi',
  },
  {
    id: '9408044008',
    districtId: '9408044',
    name: 'Manusundu',
  },
  {
    id: '9408044009',
    districtId: '9408044',
    name: 'Mnukwar',
  },
  {
    id: '9408050008',
    districtId: '9408050',
    name: 'Wadapi',
  },
  {
    id: '9408050009',
    districtId: '9408050',
    name: 'Wawuti',
  },
  {
    id: '9408050010',
    districtId: '9408050',
    name: 'Kainui I',
  },
  {
    id: '9408050011',
    districtId: '9408050',
    name: 'Kainui II',
  },
  {
    id: '9408050012',
    districtId: '9408050',
    name: 'Ransarnoni',
  },
  {
    id: '9408050013',
    districtId: '9408050',
    name: 'Aitiri',
  },
  {
    id: '9408050014',
    districtId: '9408050',
    name: 'Menawi',
  },
  {
    id: '9408050015',
    districtId: '9408050',
    name: 'Roipi',
  },
  {
    id: '9408050024',
    districtId: '9408050',
    name: 'Wanampompi',
  },
  {
    id: '9408050025',
    districtId: '9408050',
    name: 'Roipi II',
  },
  {
    id: '9408050026',
    districtId: '9408050',
    name: 'Mananayam',
  },
  {
    id: '9408051001',
    districtId: '9408051',
    name: 'Umani',
  },
  {
    id: '9408051002',
    districtId: '9408051',
    name: 'Saweru',
  },
  {
    id: '9408051003',
    districtId: '9408051',
    name: 'Rondepi',
  },
  {
    id: '9408051004',
    districtId: '9408051',
    name: 'Ambai',
  },
  {
    id: '9408051005',
    districtId: '9408051',
    name: 'Wamori',
  },
  {
    id: '9408051006',
    districtId: '9408051',
    name: 'Kawipi',
  },
  {
    id: '9408051007',
    districtId: '9408051',
    name: 'Adiwipi',
  },
  {
    id: '9408051008',
    districtId: '9408051',
    name: 'Baisore',
  },
  {
    id: '9408051009',
    districtId: '9408051',
    name: 'Ambai II',
  },
  {
    id: '9408051010',
    districtId: '9408051',
    name: 'Mambawi',
  },
  {
    id: '9408051015',
    districtId: '9408051',
    name: 'Imboriawa',
  },
  {
    id: '9408051016',
    districtId: '9408051',
    name: 'Bairei',
  },
  {
    id: '9408051017',
    districtId: '9408051',
    name: 'Nuniande',
  },
  {
    id: '9408051018',
    districtId: '9408051',
    name: 'Dorau',
  },
  {
    id: '9408051019',
    districtId: '9408051',
    name: 'Perea',
  },
  {
    id: '9408051020',
    districtId: '9408051',
    name: 'Toroa',
  },
  {
    id: '9408051021',
    districtId: '9408051',
    name: 'Marawi',
  },
  {
    id: '9408051022',
    districtId: '9408051',
    name: 'Aiwaranggani',
  },
  {
    id: '9408052001',
    districtId: '9408052',
    name: 'Borai',
  },
  {
    id: '9408052002',
    districtId: '9408052',
    name: 'Kabuaena',
  },
  {
    id: '9408052003',
    districtId: '9408052',
    name: 'Yapanani',
  },
  {
    id: '9408052004',
    districtId: '9408052',
    name: 'Kontiunai',
  },
  {
    id: '9408052005',
    districtId: '9408052',
    name: 'Waniwon',
  },
  {
    id: '9408052006',
    districtId: '9408052',
    name: 'Rambai',
  },
  {
    id: '9408052007',
    districtId: '9408052',
    name: 'Sanayoka',
  },
  {
    id: '9408060010',
    districtId: '9408060',
    name: 'Banawa',
  },
  {
    id: '9408060011',
    districtId: '9408060',
    name: 'Serui Laut',
  },
  {
    id: '9408060012',
    districtId: '9408060',
    name: 'Pasir Putih',
  },
  {
    id: '9408060013',
    districtId: '9408060',
    name: 'Pasir Hitam',
  },
  {
    id: '9408060014',
    districtId: '9408060',
    name: 'Tarau',
  },
  {
    id: '9408060015',
    districtId: '9408060',
    name: 'Serui Kota',
  },
  {
    id: '9408060016',
    districtId: '9408060',
    name: 'Serui Jaya',
  },
  {
    id: '9408060026',
    districtId: '9408060',
    name: 'Barawaikap',
  },
  {
    id: '9408060027',
    districtId: '9408060',
    name: 'Nundawipi',
  },
  {
    id: '9408060028',
    districtId: '9408060',
    name: 'Bawai',
  },
  {
    id: '9408060029',
    districtId: '9408060',
    name: 'Manaini',
  },
  {
    id: '9408060030',
    districtId: '9408060',
    name: 'Imandoa',
  },
  {
    id: '9408061001',
    districtId: '9408061',
    name: 'Kanawa',
  },
  {
    id: '9408061002',
    districtId: '9408061',
    name: 'Mariarotu',
  },
  {
    id: '9408061003',
    districtId: '9408061',
    name: 'Kamanap',
  },
  {
    id: '9408061004',
    districtId: '9408061',
    name: 'Panduami',
  },
  {
    id: '9408061005',
    districtId: '9408061',
    name: 'Ariepi',
  },
  {
    id: '9408061006',
    districtId: '9408061',
    name: 'Tatui',
  },
  {
    id: '9408061007',
    districtId: '9408061',
    name: 'Aromarea',
  },
  {
    id: '9408061008',
    districtId: '9408061',
    name: 'Serawandori',
  },
  {
    id: '9408061009',
    districtId: '9408061',
    name: 'Ambaidiru',
  },
  {
    id: '9408061010',
    districtId: '9408061',
    name: 'Mambo',
  },
  {
    id: '9408061011',
    districtId: '9408061',
    name: 'Ariepi II',
  },
  {
    id: '9408061013',
    districtId: '9408061',
    name: 'Manainin',
  },
  {
    id: '9408061014',
    districtId: '9408061',
    name: 'Serawandori II',
  },
  {
    id: '9408061015',
    districtId: '9408061',
    name: 'Numamam',
  },
  {
    id: '9408061016',
    districtId: '9408061',
    name: 'Ramangkurani',
  },
  {
    id: '9408062001',
    districtId: '9408062',
    name: 'Mariadei',
  },
  {
    id: '9408062002',
    districtId: '9408062',
    name: 'Warari',
  },
  {
    id: '9408062003',
    districtId: '9408062',
    name: 'Anataurei',
  },
  {
    id: '9408062004',
    districtId: '9408062',
    name: 'Mantembu',
  },
  {
    id: '9408062005',
    districtId: '9408062',
    name: 'Famboaman',
  },
  {
    id: '9408062006',
    districtId: '9408062',
    name: 'Yapan',
  },
  {
    id: '9408062007',
    districtId: '9408062',
    name: 'Ketuapi',
  },
  {
    id: '9408062008',
    districtId: '9408062',
    name: 'Kandowarira',
  },
  {
    id: '9408070007',
    districtId: '9408070',
    name: 'Webi',
  },
  {
    id: '9408070008',
    districtId: '9408070',
    name: 'Warabori',
  },
  {
    id: '9408070009',
    districtId: '9408070',
    name: 'Wimoni',
  },
  {
    id: '9408070010',
    districtId: '9408070',
    name: 'Ansus',
  },
  {
    id: '9408070011',
    districtId: '9408070',
    name: 'Natabui',
  },
  {
    id: '9408070012',
    districtId: '9408070',
    name: 'Papuma',
  },
  {
    id: '9408070013',
    districtId: '9408070',
    name: 'Kairawi',
  },
  {
    id: '9408070014',
    districtId: '9408070',
    name: 'Sasawa',
  },
  {
    id: '9408070015',
    districtId: '9408070',
    name: 'Yenusi Marau',
  },
  {
    id: '9408070016',
    districtId: '9408070',
    name: 'Marau',
  },
  {
    id: '9408070017',
    districtId: '9408070',
    name: 'Inowa',
  },
  {
    id: '9408070018',
    districtId: '9408070',
    name: 'Maniri',
  },
  {
    id: '9408070020',
    districtId: '9408070',
    name: 'Yarori',
  },
  {
    id: '9408070021',
    districtId: '9408070',
    name: 'Toweta',
  },
  {
    id: '9408070022',
    districtId: '9408070',
    name: 'Moiwani',
  },
  {
    id: '9408070023',
    districtId: '9408070',
    name: 'Nuwiora',
  },
  {
    id: '9408070024',
    districtId: '9408070',
    name: 'Narei',
  },
  {
    id: '9408071002',
    districtId: '9408071',
    name: 'Woinap',
  },
  {
    id: '9408071003',
    districtId: '9408071',
    name: 'Kanaki',
  },
  {
    id: '9408071004',
    districtId: '9408071',
    name: 'Dumani',
  },
  {
    id: '9408071005',
    districtId: '9408071',
    name: 'Wooi',
  },
  {
    id: '9408071006',
    districtId: '9408071',
    name: 'Aibondeni',
  },
  {
    id: '9408071007',
    districtId: '9408071',
    name: 'Karemoni',
  },
  {
    id: '9408071008',
    districtId: '9408071',
    name: 'Rembai',
  },
  {
    id: '9408071009',
    districtId: '9408071',
    name: 'Haihorei',
  },
  {
    id: '9408071010',
    districtId: '9408071',
    name: 'Jamaria',
  },
  {
    id: '9408071011',
    districtId: '9408071',
    name: 'Awado',
  },
  {
    id: '9408072001',
    districtId: '9408072',
    name: 'Miosnum',
  },
  {
    id: '9408072002',
    districtId: '9408072',
    name: 'Jeniari',
  },
  {
    id: '9408072003',
    districtId: '9408072',
    name: 'Yeituarau',
  },
  {
    id: '9408072004',
    districtId: '9408072',
    name: 'Ausem',
  },
  {
    id: '9408072005',
    districtId: '9408072',
    name: 'Kumpeki',
  },
  {
    id: '9408080001',
    districtId: '9408080',
    name: 'Poom I',
  },
  {
    id: '9408080002',
    districtId: '9408080',
    name: 'Poom II',
  },
  {
    id: '9408080004',
    districtId: '9408080',
    name: 'Rarisi',
  },
  {
    id: '9408080005',
    districtId: '9408080',
    name: 'Makiroan',
  },
  {
    id: '9408080006',
    districtId: '9408080',
    name: 'Worioi',
  },
  {
    id: '9408080007',
    districtId: '9408080',
    name: 'Humbe Awai',
  },
  {
    id: '9408080008',
    districtId: '9408080',
    name: 'Nurawi',
  },
  {
    id: '9408081001',
    districtId: '9408081',
    name: 'Waisani',
  },
  {
    id: '9408081002',
    districtId: '9408081',
    name: 'Munggui',
  },
  {
    id: '9408081003',
    districtId: '9408081',
    name: 'Asai',
  },
  {
    id: '9408081004',
    districtId: '9408081',
    name: 'Windesi',
  },
  {
    id: '9408081005',
    districtId: '9408081',
    name: 'Saruman',
  },
  {
    id: '9408081006',
    districtId: '9408081',
    name: 'Kaonda',
  },
  {
    id: '9408081007',
    districtId: '9408081',
    name: 'Karawi',
  },
  {
    id: '9408081008',
    districtId: '9408081',
    name: 'Rosbori',
  },
  {
    id: '9408081009',
    districtId: '9408081',
    name: 'Aryobu',
  },
  {
    id: '9409010005',
    districtId: '9409010',
    name: 'Namber',
  },
  {
    id: '9409010006',
    districtId: '9409010',
    name: 'Baruki',
  },
  {
    id: '9409010007',
    districtId: '9409010',
    name: 'Warido',
  },
  {
    id: '9409010008',
    districtId: '9409010',
    name: 'Kameri',
  },
  {
    id: '9409010014',
    districtId: '9409010',
    name: 'Subangungsi',
  },
  {
    id: '9409010015',
    districtId: '9409010',
    name: 'Serbin',
  },
  {
    id: '9409010016',
    districtId: '9409010',
    name: 'Kansai',
  },
  {
    id: '9409010017',
    districtId: '9409010',
    name: 'Pondori',
  },
  {
    id: '9409010019',
    districtId: '9409010',
    name: 'Rimba Raya',
  },
  {
    id: '9409010020',
    districtId: '9409010',
    name: 'Semayen',
  },
  {
    id: '9409010021',
    districtId: '9409010',
    name: 'Mambondo Sawai',
  },
  {
    id: '9409010022',
    districtId: '9409010',
    name: 'Pomdori Sup',
  },
  {
    id: '9409011001',
    districtId: '9409011',
    name: 'Wansra',
  },
  {
    id: '9409011002',
    districtId: '9409011',
    name: 'Masyara',
  },
  {
    id: '9409011003',
    districtId: '9409011',
    name: 'Pakreki',
  },
  {
    id: '9409011004',
    districtId: '9409011',
    name: 'Rawar',
  },
  {
    id: '9409011005',
    districtId: '9409011',
    name: 'Supmander',
  },
  {
    id: '9409011006',
    districtId: '9409011',
    name: 'Saribi',
  },
  {
    id: '9409011007',
    districtId: '9409011',
    name: 'Yenbepon',
  },
  {
    id: '9409011008',
    districtId: '9409011',
    name: 'Yenbeba',
  },
  {
    id: '9409011009',
    districtId: '9409011',
    name: 'Manwor Indah',
  },
  {
    id: '9409020010',
    districtId: '9409020',
    name: 'Yenburwo',
  },
  {
    id: '9409020011',
    districtId: '9409020',
    name: 'Kornasoren',
  },
  {
    id: '9409020014',
    districtId: '9409020',
    name: 'Rarsibo',
  },
  {
    id: '9409020015',
    districtId: '9409020',
    name: 'Asaryendi',
  },
  {
    id: '9409020016',
    districtId: '9409020',
    name: 'Yenmanu',
  },
  {
    id: '9409020017',
    districtId: '9409020',
    name: 'Fyepuri',
  },
  {
    id: '9409020018',
    districtId: '9409020',
    name: 'Indaibori',
  },
  {
    id: '9409020019',
    districtId: '9409020',
    name: 'Barkori',
  },
  {
    id: '9409020020',
    districtId: '9409020',
    name: 'Asaibori',
  },
  {
    id: '9409021001',
    districtId: '9409021',
    name: 'Mandori',
  },
  {
    id: '9409021002',
    districtId: '9409021',
    name: 'Bruyadori',
  },
  {
    id: '9409021003',
    districtId: '9409021',
    name: 'Dafi',
  },
  {
    id: '9409021004',
    districtId: '9409021',
    name: 'Sandau',
  },
  {
    id: '9409021005',
    districtId: '9409021',
    name: 'Amberparem/Amperem',
  },
  {
    id: '9409021006',
    districtId: '9409021',
    name: 'Duai',
  },
  {
    id: '9409021007',
    districtId: '9409021',
    name: 'Mandori Sup',
  },
  {
    id: '9409021008',
    districtId: '9409021',
    name: 'Warbukor',
  },
  {
    id: '9409021009',
    districtId: '9409021',
    name: 'Arimi Jaya',
  },
  {
    id: '9409021010',
    districtId: '9409021',
    name: 'Kamumi',
  },
  {
    id: '9409022001',
    districtId: '9409022',
    name: 'Bawei',
  },
  {
    id: '9409022002',
    districtId: '9409022',
    name: 'Manggari',
  },
  {
    id: '9409022003',
    districtId: '9409022',
    name: 'Sauribru',
  },
  {
    id: '9409022004',
    districtId: '9409022',
    name: 'Syoribo',
  },
  {
    id: '9409022005',
    districtId: '9409022',
    name: 'Andei',
  },
  {
    id: '9409022006',
    districtId: '9409022',
    name: 'Sauri',
  },
  {
    id: '9409022007',
    districtId: '9409022',
    name: 'Serdori',
  },
  {
    id: '9409022008',
    districtId: '9409022',
    name: 'Koryakam',
  },
  {
    id: '9409022009',
    districtId: '9409022',
    name: 'Andei Sup',
  },
  {
    id: '9409030001',
    districtId: '9409030',
    name: 'Auki',
  },
  {
    id: '9409030002',
    districtId: '9409030',
    name: 'Wundi',
  },
  {
    id: '9409030003',
    districtId: '9409030',
    name: 'Nusi Babaruk',
  },
  {
    id: '9409030004',
    districtId: '9409030',
    name: 'Nusi',
  },
  {
    id: '9409030005',
    districtId: '9409030',
    name: 'Pai',
  },
  {
    id: '9409030014',
    districtId: '9409030',
    name: 'Sandidori',
  },
  {
    id: '9409030015',
    districtId: '9409030',
    name: 'Sorina',
  },
  {
    id: '9409030016',
    districtId: '9409030',
    name: 'Inbeyomi',
  },
  {
    id: '9409030017',
    districtId: '9409030',
    name: 'Kanai',
  },
  {
    id: '9409030018',
    districtId: '9409030',
    name: 'Sokani',
  },
  {
    id: '9409030019',
    districtId: '9409030',
    name: 'Paidori',
  },
  {
    id: '9409031001',
    districtId: '9409031',
    name: 'Meos Mangguandi',
  },
  {
    id: '9409031002',
    districtId: '9409031',
    name: 'Supraima',
  },
  {
    id: '9409031003',
    districtId: '9409031',
    name: 'Samber Pasi',
  },
  {
    id: '9409031004',
    districtId: '9409031',
    name: 'Pasi',
  },
  {
    id: '9409031005',
    districtId: '9409031',
    name: 'Karabai',
  },
  {
    id: '9409031006',
    districtId: '9409031',
    name: 'Mbromsi',
  },
  {
    id: '9409031007',
    districtId: '9409031',
    name: 'Nyansoren',
  },
  {
    id: '9409031008',
    districtId: '9409031',
    name: 'Saribra',
  },
  {
    id: '9409031009',
    districtId: '9409031',
    name: 'Padaido',
  },
  {
    id: '9409031010',
    districtId: '9409031',
    name: 'Yeri',
  },
  {
    id: '9409031011',
    districtId: '9409031',
    name: 'Sasari',
  },
  {
    id: '9409031012',
    districtId: '9409031',
    name: 'Yen Manaina',
  },
  {
    id: '9409031013',
    districtId: '9409031',
    name: 'Anobo',
  },
  {
    id: '9409040001',
    districtId: '9409040',
    name: 'Sareidi',
  },
  {
    id: '9409040002',
    districtId: '9409040',
    name: 'Owi',
  },
  {
    id: '9409040003',
    districtId: '9409040',
    name: 'Rim',
  },
  {
    id: '9409040004',
    districtId: '9409040',
    name: 'Yenusi',
  },
  {
    id: '9409040005',
    districtId: '9409040',
    name: 'Orwer',
  },
  {
    id: '9409040006',
    districtId: '9409040',
    name: 'Woniki',
  },
  {
    id: '9409040007',
    districtId: '9409040',
    name: 'Bindusi',
  },
  {
    id: '9409040008',
    districtId: '9409040',
    name: 'Kajasi',
  },
  {
    id: '9409040009',
    districtId: '9409040',
    name: 'Kajasbo',
  },
  {
    id: '9409040017',
    districtId: '9409040',
    name: 'Rimba Jaya',
  },
  {
    id: '9409040018',
    districtId: '9409040',
    name: 'Soon',
  },
  {
    id: '9409040021',
    districtId: '9409040',
    name: 'Ruar',
  },
  {
    id: '9409040022',
    districtId: '9409040',
    name: 'Mandon',
  },
  {
    id: '9409040023',
    districtId: '9409040',
    name: 'Insumarires',
  },
  {
    id: '9409040024',
    districtId: '9409040',
    name: 'Soryar',
  },
  {
    id: '9409040025',
    districtId: '9409040',
    name: 'Yendakem',
  },
  {
    id: '9409040026',
    districtId: '9409040',
    name: 'Wasori',
  },
  {
    id: '9409040027',
    districtId: '9409040',
    name: 'Afefbo',
  },
  {
    id: '9409040028',
    districtId: '9409040',
    name: 'Yenberok',
  },
  {
    id: '9409040029',
    districtId: '9409040',
    name: 'Adorbari',
  },
  {
    id: '9409040030',
    districtId: '9409040',
    name: 'Bosnik Sup',
  },
  {
    id: '9409040031',
    districtId: '9409040',
    name: 'Inofi',
  },
  {
    id: '9409040032',
    districtId: '9409040',
    name: 'Waderbo',
  },
  {
    id: '9409040033',
    districtId: '9409040',
    name: 'Inmdi',
  },
  {
    id: '9409041001',
    districtId: '9409041',
    name: 'Opiaref',
  },
  {
    id: '9409041002',
    districtId: '9409041',
    name: 'Bakribo',
  },
  {
    id: '9409041003',
    districtId: '9409041',
    name: 'Marao',
  },
  {
    id: '9409041004',
    districtId: '9409041',
    name: 'Sawa',
  },
  {
    id: '9409041005',
    districtId: '9409041',
    name: 'Wadibu',
  },
  {
    id: '9409041006',
    districtId: '9409041',
    name: 'Anggopi',
  },
  {
    id: '9409041007',
    districtId: '9409041',
    name: 'Anggaduber',
  },
  {
    id: '9409041008',
    districtId: '9409041',
    name: 'Animi',
  },
  {
    id: '9409041009',
    districtId: '9409041',
    name: 'Kakur',
  },
  {
    id: '9409041010',
    districtId: '9409041',
    name: 'Tanjung Barari',
  },
  {
    id: '9409041011',
    districtId: '9409041',
    name: 'Sawadori',
  },
  {
    id: '9409041012',
    districtId: '9409041',
    name: 'Sauri',
  },
  {
    id: '9409041013',
    districtId: '9409041',
    name: 'Makmakerbo',
  },
  {
    id: '9409041014',
    districtId: '9409041',
    name: 'Yensama',
  },
  {
    id: '9409050001',
    districtId: '9409050',
    name: 'Inggiri',
  },
  {
    id: '9409050002',
    districtId: '9409050',
    name: 'Sorido',
  },
  {
    id: '9409050003',
    districtId: '9409050',
    name: 'Saramom',
  },
  {
    id: '9409050004',
    districtId: '9409050',
    name: 'Waupnor',
  },
  {
    id: '9409050005',
    districtId: '9409050',
    name: 'Burokub',
  },
  {
    id: '9409050006',
    districtId: '9409050',
    name: 'Fandoi',
  },
  {
    id: '9409050007',
    districtId: '9409050',
    name: 'Mandala',
  },
  {
    id: '9409050008',
    districtId: '9409050',
    name: 'Ambroben',
  },
  {
    id: '9409050009',
    districtId: '9409050',
    name: 'Swapodibo',
  },
  {
    id: '9409050010',
    districtId: '9409050',
    name: 'Mokmer',
  },
  {
    id: '9409050011',
    districtId: '9409050',
    name: 'Parai',
  },
  {
    id: '9409050012',
    districtId: '9409050',
    name: 'Insrom',
  },
  {
    id: '9409050013',
    districtId: '9409050',
    name: 'Samau',
  },
  {
    id: '9409050014',
    districtId: '9409050',
    name: 'Manswam',
  },
  {
    id: '9409050015',
    districtId: '9409050',
    name: 'Anggraidi',
  },
  {
    id: '9409050016',
    districtId: '9409050',
    name: 'Inggupi',
  },
  {
    id: '9409050017',
    districtId: '9409050',
    name: 'Babrinbo',
  },
  {
    id: '9409050018',
    districtId: '9409050',
    name: 'Karyendi',
  },
  {
    id: '9409050019',
    districtId: '9409050',
    name: 'Kababur',
  },
  {
    id: '9409050020',
    districtId: '9409050',
    name: 'Sanumi',
  },
  {
    id: '9409050021',
    districtId: '9409050',
    name: 'Manggandisapi',
  },
  {
    id: '9409060001',
    districtId: '9409060',
    name: 'Samofa',
  },
  {
    id: '9409060003',
    districtId: '9409060',
    name: 'Mandouw',
  },
  {
    id: '9409060004',
    districtId: '9409060',
    name: 'Brambaken',
  },
  {
    id: '9409060005',
    districtId: '9409060',
    name: 'Yafdas',
  },
  {
    id: '9409060006',
    districtId: '9409060',
    name: 'Maryendi',
  },
  {
    id: '9409060007',
    districtId: '9409060',
    name: 'Sambawofuar',
  },
  {
    id: '9409060008',
    districtId: '9409060',
    name: 'Karang Mulia',
  },
  {
    id: '9409060009',
    districtId: '9409060',
    name: 'Adainasnosen',
  },
  {
    id: '9409060010',
    districtId: '9409060',
    name: 'Dafuar',
  },
  {
    id: '9409060011',
    districtId: '9409060',
    name: 'Anjereuw',
  },
  {
    id: '9409060012',
    districtId: '9409060',
    name: 'Wisata Binsari',
  },
  {
    id: '9409060013',
    districtId: '9409060',
    name: 'Kamorfuar',
  },
  {
    id: '9409060014',
    districtId: '9409060',
    name: 'Kinmom',
  },
  {
    id: '9409070001',
    districtId: '9409070',
    name: 'Waroi',
  },
  {
    id: '9409070002',
    districtId: '9409070',
    name: 'Samber',
  },
  {
    id: '9409070003',
    districtId: '9409070',
    name: 'Sunyar',
  },
  {
    id: '9409070005',
    districtId: '9409070',
    name: 'Adoki',
  },
  {
    id: '9409070006',
    districtId: '9409070',
    name: 'Yendidori',
  },
  {
    id: '9409070007',
    districtId: '9409070',
    name: 'Moibaken',
  },
  {
    id: '9409070008',
    districtId: '9409070',
    name: 'Wirmaker',
  },
  {
    id: '9409070009',
    districtId: '9409070',
    name: 'Syabes',
  },
  {
    id: '9409070010',
    districtId: '9409070',
    name: 'Samber Sup',
  },
  {
    id: '9409070011',
    districtId: '9409070',
    name: 'Kabidon',
  },
  {
    id: '9409070012',
    districtId: '9409070',
    name: 'Rarmpimbo',
  },
  {
    id: '9409070013',
    districtId: '9409070',
    name: 'Padwa',
  },
  {
    id: '9409070014',
    districtId: '9409070',
    name: 'Suneri',
  },
  {
    id: '9409070015',
    districtId: '9409070',
    name: 'Binyeri',
  },
  {
    id: '9409070016',
    districtId: '9409070',
    name: 'Amyabenram',
  },
  {
    id: '9409070017',
    districtId: '9409070',
    name: 'Inpendi',
  },
  {
    id: '9409070018',
    districtId: '9409070',
    name: 'Birubi',
  },
  {
    id: '9409070019',
    districtId: '9409070',
    name: 'Padwa Pantai',
  },
  {
    id: '9409080001',
    districtId: '9409080',
    name: 'Kobeoser',
  },
  {
    id: '9409080002',
    districtId: '9409080',
    name: 'Sarwom',
  },
  {
    id: '9409080003',
    districtId: '9409080',
    name: 'Mambesak',
  },
  {
    id: '9409080004',
    districtId: '9409080',
    name: 'Andei',
  },
  {
    id: '9409080005',
    districtId: '9409080',
    name: 'Saukobye',
  },
  {
    id: '9409080006',
    districtId: '9409080',
    name: 'Yobdi',
  },
  {
    id: '9409080009',
    districtId: '9409080',
    name: 'Waromi',
  },
  {
    id: '9409080012',
    districtId: '9409080',
    name: 'Warsansan',
  },
  {
    id: '9409080013',
    districtId: '9409080',
    name: 'Dernafi',
  },
  {
    id: '9409080015',
    districtId: '9409080',
    name: 'Rosayendi',
  },
  {
    id: '9409080016',
    districtId: '9409080',
    name: 'Korem',
  },
  {
    id: '9409080017',
    districtId: '9409080',
    name: 'Mnuswor',
  },
  {
    id: '9409080018',
    districtId: '9409080',
    name: 'Warbon',
  },
  {
    id: '9409080019',
    districtId: '9409080',
    name: 'Wari',
  },
  {
    id: '9409080020',
    districtId: '9409080',
    name: 'Dofyo Wafor',
  },
  {
    id: '9409081001',
    districtId: '9409081',
    name: 'Makuker',
  },
  {
    id: '9409081002',
    districtId: '9409081',
    name: 'Wouna',
  },
  {
    id: '9409081003',
    districtId: '9409081',
    name: 'Rodifu',
  },
  {
    id: '9409081004',
    districtId: '9409081',
    name: 'Warbinsi',
  },
  {
    id: '9409081005',
    districtId: '9409081',
    name: 'Wonabraidi',
  },
  {
    id: '9409081006',
    districtId: '9409081',
    name: 'Rumbin',
  },
  {
    id: '9409081007',
    districtId: '9409081',
    name: 'Wodu',
  },
  {
    id: '9409081009',
    districtId: '9409081',
    name: 'Faknikdi',
  },
  {
    id: '9409081010',
    districtId: '9409081',
    name: 'Armnu',
  },
  {
    id: '9409081011',
    districtId: '9409081',
    name: 'Dasdo',
  },
  {
    id: '9409081012',
    districtId: '9409081',
    name: 'Mamorbo',
  },
  {
    id: '9409090004',
    districtId: '9409090',
    name: 'Marur',
  },
  {
    id: '9409090005',
    districtId: '9409090',
    name: 'Diano',
  },
  {
    id: '9409090006',
    districtId: '9409090',
    name: 'Saway',
  },
  {
    id: '9409090007',
    districtId: '9409090',
    name: 'Aman',
  },
  {
    id: '9409090008',
    districtId: '9409090',
    name: 'Yeruboy',
  },
  {
    id: '9409090009',
    districtId: '9409090',
    name: 'Ammoy',
  },
  {
    id: '9409090010',
    districtId: '9409090',
    name: 'Inswanbesi',
  },
  {
    id: '9409090011',
    districtId: '9409090',
    name: 'Koyomi',
  },
  {
    id: '9409090012',
    districtId: '9409090',
    name: 'Wasani',
  },
  {
    id: '9409090017',
    districtId: '9409090',
    name: 'Karuiberik',
  },
  {
    id: '9409090018',
    districtId: '9409090',
    name: 'Komboy',
  },
  {
    id: '9409090020',
    districtId: '9409090',
    name: 'Inswanbesi Sup',
  },
  {
    id: '9409090021',
    districtId: '9409090',
    name: 'Inyobi',
  },
  {
    id: '9409090022',
    districtId: '9409090',
    name: 'Warawaf',
  },
  {
    id: '9409090023',
    districtId: '9409090',
    name: 'Wir Insos',
  },
  {
    id: '9409090024',
    districtId: '9409090',
    name: 'Biawer',
  },
  {
    id: '9409090025',
    districtId: '9409090',
    name: 'Waniri',
  },
  {
    id: '9409090026',
    districtId: '9409090',
    name: 'Imbari',
  },
  {
    id: '9409090027',
    districtId: '9409090',
    name: 'Manbeori',
  },
  {
    id: '9409090028',
    districtId: '9409090',
    name: 'Mamfias',
  },
  {
    id: '9409091001',
    districtId: '9409091',
    name: 'Karmon',
  },
  {
    id: '9409091002',
    districtId: '9409091',
    name: 'Sor',
  },
  {
    id: '9409091003',
    districtId: '9409091',
    name: 'Yawosi/Fanindi',
  },
  {
    id: '9409091004',
    districtId: '9409091',
    name: 'Wasori',
  },
  {
    id: '9409091005',
    districtId: '9409091',
    name: 'Bosnabraidi',
  },
  {
    id: '9409091006',
    districtId: '9409091',
    name: 'Asur',
  },
  {
    id: '9409091007',
    districtId: '9409091',
    name: 'Indawi',
  },
  {
    id: '9409091008',
    districtId: '9409091',
    name: 'Madirai',
  },
  {
    id: '9409092001',
    districtId: '9409092',
    name: 'Sansundi',
  },
  {
    id: '9409092002',
    districtId: '9409092',
    name: 'Wopes',
  },
  {
    id: '9409100001',
    districtId: '9409100',
    name: 'Wasyai',
  },
  {
    id: '9409100002',
    districtId: '9409100',
    name: 'Andei',
  },
  {
    id: '9409100003',
    districtId: '9409100',
    name: 'Kababur',
  },
  {
    id: '9409100004',
    districtId: '9409100',
    name: 'Warberik',
  },
  {
    id: '9409100005',
    districtId: '9409100',
    name: 'Sosmay',
  },
  {
    id: '9409100006',
    districtId: '9409100',
    name: 'Yomdori',
  },
  {
    id: '9409100007',
    districtId: '9409100',
    name: 'Kanaan',
  },
  {
    id: '9409100008',
    districtId: '9409100',
    name: 'Asaryendi',
  },
  {
    id: '9409100009',
    districtId: '9409100',
    name: 'Opuri',
  },
  {
    id: '9409100010',
    districtId: '9409100',
    name: 'Sopendo',
  },
  {
    id: '9409100011',
    districtId: '9409100',
    name: 'Mamoribo',
  },
  {
    id: '9409100021',
    districtId: '9409100',
    name: 'Asarkir',
  },
  {
    id: '9409100022',
    districtId: '9409100',
    name: 'Dousi',
  },
  {
    id: '9409100023',
    districtId: '9409100',
    name: 'Marisen',
  },
  {
    id: '9409100024',
    districtId: '9409100',
    name: 'Sumbinya',
  },
  {
    id: '9409100025',
    districtId: '9409100',
    name: 'Insiri',
  },
  {
    id: '9409100026',
    districtId: '9409100',
    name: 'Karnindi',
  },
  {
    id: '9409100027',
    districtId: '9409100',
    name: 'Banasrares',
  },
  {
    id: '9409100028',
    districtId: '9409100',
    name: 'Dedifu',
  },
  {
    id: '9409100029',
    districtId: '9409100',
    name: 'Sopendo Sup Karkir',
  },
  {
    id: '9409100030',
    districtId: '9409100',
    name: 'Rarsbari',
  },
  {
    id: '9409101001',
    districtId: '9409101',
    name: 'Farusi',
  },
  {
    id: '9409101002',
    districtId: '9409101',
    name: 'Mandenderi',
  },
  {
    id: '9409101003',
    districtId: '9409101',
    name: 'Mardori',
  },
  {
    id: '9409101004',
    districtId: '9409101',
    name: 'Swaipak',
  },
  {
    id: '9409101005',
    districtId: '9409101',
    name: 'Kandi Bundi/Ampunbukor',
  },
  {
    id: '9409101006',
    districtId: '9409101',
    name: 'Sarwa',
  },
  {
    id: '9409101007',
    districtId: '9409101',
    name: 'Napdori',
  },
  {
    id: '9409101008',
    districtId: '9409101',
    name: 'Ramdori',
  },
  {
    id: '9409101009',
    districtId: '9409101',
    name: 'Wombrisauw',
  },
  {
    id: '9409101010',
    districtId: '9409101',
    name: 'Swainober',
  },
  {
    id: '9409101011',
    districtId: '9409101',
    name: 'Yenbepioper',
  },
  {
    id: '9409101012',
    districtId: '9409101',
    name: 'Busdori',
  },
  {
    id: '9409101013',
    districtId: '9409101',
    name: 'Insusbari',
  },
  {
    id: '9409101014',
    districtId: '9409101',
    name: 'Andoina',
  },
  {
    id: '9409101015',
    districtId: '9409101',
    name: 'Orkdori',
  },
  {
    id: '9409101016',
    districtId: '9409101',
    name: 'Saswarbo',
  },
  {
    id: '9410030001',
    districtId: '9410030',
    name: 'Umbutu / Uyubutu / Uwibutu',
  },
  {
    id: '9410030003',
    districtId: '9410030',
    name: 'Enarotali',
  },
  {
    id: '9410030009',
    districtId: '9410030',
    name: 'Kopo',
  },
  {
    id: '9410030012',
    districtId: '9410030',
    name: 'Papato',
  },
  {
    id: '9410030013',
    districtId: '9410030',
    name: 'Madi',
  },
  {
    id: '9410030015',
    districtId: '9410030',
    name: 'Ipakije',
  },
  {
    id: '9410030018',
    districtId: '9410030',
    name: 'Timida',
  },
  {
    id: '9410030019',
    districtId: '9410030',
    name: 'Aikai',
  },
  {
    id: '9410030025',
    districtId: '9410030',
    name: 'Awabutu',
  },
  {
    id: '9410030026',
    districtId: '9410030',
    name: 'Amougi Butu',
  },
  {
    id: '9410030027',
    districtId: '9410030',
    name: 'Wouyebutu',
  },
  {
    id: '9410030028',
    districtId: '9410030',
    name: 'Ekeitadi',
  },
  {
    id: '9410030029',
    districtId: '9410030',
    name: 'Pudotadi',
  },
  {
    id: '9410031002',
    districtId: '9410031',
    name: 'Wotai',
  },
  {
    id: '9410031003',
    districtId: '9410031',
    name: 'Keniapa / Udaugida',
  },
  {
    id: '9410031004',
    districtId: '9410031',
    name: 'Epouto',
  },
  {
    id: '9410032001',
    districtId: '9410032',
    name: 'Ayaigo / Kagupaida',
  },
  {
    id: '9410032002',
    districtId: '9410032',
    name: 'Kagupagu',
  },
  {
    id: '9410032003',
    districtId: '9410032',
    name: 'Ibomomaida / Ibumaida',
  },
  {
    id: '9410032004',
    districtId: '9410032',
    name: 'Kebo II',
  },
  {
    id: '9410032005',
    districtId: '9410032',
    name: 'Togowa',
  },
  {
    id: '9410032009',
    districtId: '9410032',
    name: 'Kebo I',
  },
  {
    id: '9410033001',
    districtId: '9410033',
    name: 'Kopaidagi',
  },
  {
    id: '9410033002',
    districtId: '9410033',
    name: 'Wejatadi',
  },
  {
    id: '9410033003',
    districtId: '9410033',
    name: 'Pugo Woge',
  },
  {
    id: '9410034001',
    districtId: '9410034',
    name: 'Uwamani',
  },
  {
    id: '9410034002',
    districtId: '9410034',
    name: 'Badauwo',
  },
  {
    id: '9410034003',
    districtId: '9410034',
    name: 'Toko',
  },
  {
    id: '9410035001',
    districtId: '9410035',
    name: 'Obaiyoweta',
  },
  {
    id: '9410035002',
    districtId: '9410035',
    name: 'Darouto',
  },
  {
    id: '9410036001',
    districtId: '9410036',
    name: 'Awebutu',
  },
  {
    id: '9410036002',
    districtId: '9410036',
    name: 'Panibagata',
  },
  {
    id: '9410036003',
    districtId: '9410036',
    name: 'Pugaida / Daupaida',
  },
  {
    id: '9410036004',
    districtId: '9410036',
    name: 'Ipuwa',
  },
  {
    id: '9410036005',
    districtId: '9410036',
    name: 'Mujaiyepa / Munayepa / Muniyep',
  },
  {
    id: '9410040003',
    districtId: '9410040',
    name: 'Ugidimi',
  },
  {
    id: '9410040004',
    districtId: '9410040',
    name: 'Bibida',
  },
  {
    id: '9410041001',
    districtId: '9410041',
    name: 'Duma',
  },
  {
    id: '9410041002',
    districtId: '9410041',
    name: 'Dogomo',
  },
  {
    id: '9410070004',
    districtId: '9410070',
    name: 'Toyaimoti',
  },
  {
    id: '9410070009',
    districtId: '9410070',
    name: 'Abatadi',
  },
  {
    id: '9410071003',
    districtId: '9410071',
    name: 'Pasir Putih',
  },
  {
    id: '9410071004',
    districtId: '9410071',
    name: 'Agapo / Widimeida',
  },
  {
    id: '9410071005',
    districtId: '9410071',
    name: 'Geida',
  },
  {
    id: '9410072001',
    districtId: '9410072',
    name: 'Deta',
  },
  {
    id: '9410072002',
    districtId: '9410072',
    name: 'Tuguwai',
  },
  {
    id: '9410073001',
    districtId: '9410073',
    name: 'Akoubaida',
  },
  {
    id: '9410073002',
    districtId: '9410073',
    name: 'Yabomaida',
  },
  {
    id: '9410073003',
    districtId: '9410073',
    name: 'Dauwagu',
  },
  {
    id: '9410074001',
    districtId: '9410074',
    name: 'Obaipugaida',
  },
  {
    id: '9410074002',
    districtId: '9410074',
    name: 'Eyagitaida',
  },
  {
    id: '9410080003',
    districtId: '9410080',
    name: 'Mogeya',
  },
  {
    id: '9410080004',
    districtId: '9410080',
    name: 'Obano',
  },
  {
    id: '9410080005',
    districtId: '9410080',
    name: 'Kegouda',
  },
  {
    id: '9410080006',
    districtId: '9410080',
    name: 'Tipakagouda',
  },
  {
    id: '9410080007',
    districtId: '9410080',
    name: 'Beko',
  },
  {
    id: '9410080009',
    districtId: '9410080',
    name: 'Wiyoga / Geiketago',
  },
  {
    id: '9410081001',
    districtId: '9410081',
    name: 'Ikotu / Bua',
  },
  {
    id: '9410081002',
    districtId: '9410081',
    name: 'Siriwo',
  },
  {
    id: '9410081003',
    districtId: '9410081',
    name: 'Kepi / Todia',
  },
  {
    id: '9410082001',
    districtId: '9410082',
    name: 'Epou / Epobutu',
  },
  {
    id: '9410082002',
    districtId: '9410082',
    name: 'Muyetadi',
  },
  {
    id: '9410083001',
    districtId: '9410083',
    name: 'Okaitadi',
  },
  {
    id: '9410083002',
    districtId: '9410083',
    name: 'Kito',
  },
  {
    id: '9410084001',
    districtId: '9410084',
    name: 'Ukawuwo',
  },
  {
    id: '9410084002',
    districtId: '9410084',
    name: 'Waipa',
  },
  {
    id: '9410090001',
    districtId: '9410090',
    name: 'Uwagi',
  },
  {
    id: '9410090002',
    districtId: '9410090',
    name: 'Nomouwodide',
  },
  {
    id: '9410090003',
    districtId: '9410090',
    name: 'Bogobaida / Bogodide',
  },
  {
    id: '9410090004',
    districtId: '9410090',
    name: 'Nawipawo',
  },
  {
    id: '9410090005',
    districtId: '9410090',
    name: 'Ipouwo',
  },
  {
    id: '9410090006',
    districtId: '9410090',
    name: 'Piyamo',
  },
  {
    id: '9411040002',
    districtId: '9411040',
    name: 'Turmo',
  },
  {
    id: '9411040003',
    districtId: '9411040',
    name: 'Fawi',
  },
  {
    id: '9411040006',
    districtId: '9411040',
    name: 'Bakusi',
  },
  {
    id: '9411040008',
    districtId: '9411040',
    name: 'Evo',
  },
  {
    id: '9411040009',
    districtId: '9411040',
    name: 'Yerei',
  },
  {
    id: '9411040010',
    districtId: '9411040',
    name: 'Kaho',
  },
  {
    id: '9411040011',
    districtId: '9411040',
    name: 'Biricare',
  },
  {
    id: '9411040012',
    districtId: '9411040',
    name: 'Dorey',
  },
  {
    id: '9411040013',
    districtId: '9411040',
    name: 'Fii',
  },
  {
    id: '9411041005',
    districtId: '9411041',
    name: 'Gueri',
  },
  {
    id: '9411041007',
    districtId: '9411041',
    name: 'Dagai',
  },
  {
    id: '9411041014',
    districtId: '9411041',
    name: 'Mbomban',
  },
  {
    id: '9411041015',
    districtId: '9411041',
    name: 'Yeihneri',
  },
  {
    id: '9411041016',
    districtId: '9411041',
    name: 'Mandaralani',
  },
  {
    id: '9411041017',
    districtId: '9411041',
    name: 'Debite',
  },
  {
    id: '9411041019',
    districtId: '9411041',
    name: 'Dagai 2',
  },
  {
    id: '9411041020',
    districtId: '9411041',
    name: 'Deide',
  },
  {
    id: '9411041021',
    districtId: '9411041',
    name: 'Faride',
  },
  {
    id: '9411041022',
    districtId: '9411041',
    name: 'Soi',
  },
  {
    id: '9411042003',
    districtId: '9411042',
    name: 'Tumbiwolu',
  },
  {
    id: '9411042004',
    districtId: '9411042',
    name: 'Kiyage',
  },
  {
    id: '9411042008',
    districtId: '9411042',
    name: 'Kelandu',
  },
  {
    id: '9411042018',
    districtId: '9411042',
    name: 'Atoli',
  },
  {
    id: '9411042023',
    districtId: '9411042',
    name: 'Amuringgik',
  },
  {
    id: '9411042024',
    districtId: '9411042',
    name: 'Wanggiba',
  },
  {
    id: '9411042025',
    districtId: '9411042',
    name: 'Tenggabangwi',
  },
  {
    id: '9411042026',
    districtId: '9411042',
    name: 'Ambo',
  },
  {
    id: '9411050009',
    districtId: '9411050',
    name: 'Wuyukwi',
  },
  {
    id: '9411050023',
    districtId: '9411050',
    name: 'Wuyuneri',
  },
  {
    id: '9411050025',
    districtId: '9411050',
    name: 'Usir',
  },
  {
    id: '9411050026',
    districtId: '9411050',
    name: 'Pepera',
  },
  {
    id: '9411050027',
    districtId: '9411050',
    name: 'Muliagambut',
  },
  {
    id: '9411050028',
    districtId: '9411050',
    name: 'Trikora',
  },
  {
    id: '9411050029',
    districtId: '9411050',
    name: 'Tuwogi',
  },
  {
    id: '9411050030',
    districtId: '9411050',
    name: 'Birakambut',
  },
  {
    id: '9411053001',
    districtId: '9411053',
    name: 'Yambi',
  },
  {
    id: '9411053002',
    districtId: '9411053',
    name: 'Moulo',
  },
  {
    id: '9411053003',
    districtId: '9411053',
    name: 'Tenolok',
  },
  {
    id: '9411053004',
    districtId: '9411053',
    name: 'Ginigom',
  },
  {
    id: '9411053005',
    districtId: '9411053',
    name: 'Mondu',
  },
  {
    id: '9411053006',
    districtId: '9411053',
    name: 'Danggenpaga',
  },
  {
    id: '9411053007',
    districtId: '9411053',
    name: 'Yoboluk',
  },
  {
    id: '9411053008',
    districtId: '9411053',
    name: 'Wonome',
  },
  {
    id: '9411053009',
    districtId: '9411053',
    name: 'Tirineri',
  },
  {
    id: '9411054001',
    districtId: '9411054',
    name: 'Jigunikime',
  },
  {
    id: '9411054003',
    districtId: '9411054',
    name: 'Ilamburawi',
  },
  {
    id: '9411054004',
    districtId: '9411054',
    name: 'Kalome',
  },
  {
    id: '9411055001',
    districtId: '9411055',
    name: 'Karubate',
  },
  {
    id: '9411055002',
    districtId: '9411055',
    name: 'Kulirik',
  },
  {
    id: '9411055003',
    districtId: '9411055',
    name: 'Dolinggobak',
  },
  {
    id: '9411055004',
    districtId: '9411055',
    name: 'Yalinggua',
  },
  {
    id: '9411055005',
    districtId: '9411055',
    name: 'Muara',
  },
  {
    id: '9411055006',
    districtId: '9411055',
    name: 'Talilome',
  },
  {
    id: '9411055007',
    districtId: '9411055',
    name: 'Doligobak',
  },
  {
    id: '9411055008',
    districtId: '9411055',
    name: 'Yambidugum',
  },
  {
    id: '9411056001',
    districtId: '9411056',
    name: 'Kulokenggame',
  },
  {
    id: '9411056002',
    districtId: '9411056',
    name: 'Igimbut',
  },
  {
    id: '9411056003',
    districtId: '9411056',
    name: 'Pagaleme',
  },
  {
    id: '9411056004',
    districtId: '9411056',
    name: 'Muliambut',
  },
  {
    id: '9411056005',
    districtId: '9411056',
    name: 'Lungguneri',
  },
  {
    id: '9411057002',
    districtId: '9411057',
    name: 'Yagonik',
  },
  {
    id: '9411057003',
    districtId: '9411057',
    name: 'Tiru',
  },
  {
    id: '9411057004',
    districtId: '9411057',
    name: 'Lulame',
  },
  {
    id: '9411057005',
    districtId: '9411057',
    name: 'Yarmukum',
  },
  {
    id: '9411057006',
    districtId: '9411057',
    name: 'Pilia',
  },
  {
    id: '9411057007',
    districtId: '9411057',
    name: 'Yaniruk',
  },
  {
    id: '9411057009',
    districtId: '9411057',
    name: 'Tukwi',
  },
  {
    id: '9411057010',
    districtId: '9411057',
    name: 'Yogorini',
  },
  {
    id: '9411057011',
    districtId: '9411057',
    name: 'Nalime',
  },
  {
    id: '9411058001',
    districtId: '9411058',
    name: 'Anggutari',
  },
  {
    id: '9411058002',
    districtId: '9411058',
    name: 'Wandenggobak',
  },
  {
    id: '9411058003',
    districtId: '9411058',
    name: 'Puncak Senyum',
  },
  {
    id: '9411058004',
    districtId: '9411058',
    name: 'Yiginikime',
  },
  {
    id: '9411058005',
    districtId: '9411058',
    name: 'Wunagelo',
  },
  {
    id: '9411058006',
    districtId: '9411058',
    name: 'Dondo',
  },
  {
    id: '9411058007',
    districtId: '9411058',
    name: 'Tanoba',
  },
  {
    id: '9411058008',
    districtId: '9411058',
    name: 'Niruwi',
  },
  {
    id: '9411058009',
    districtId: '9411058',
    name: 'Yalikambi',
  },
  {
    id: '9411060005',
    districtId: '9411060',
    name: 'Lambo',
  },
  {
    id: '9411060006',
    districtId: '9411060',
    name: 'Wurak',
  },
  {
    id: '9411060020',
    districtId: '9411060',
    name: 'Pindebaga',
  },
  {
    id: '9411060030',
    districtId: '9411060',
    name: 'Dolinggame',
  },
  {
    id: '9411060034',
    districtId: '9411060',
    name: 'Maka',
  },
  {
    id: '9411060035',
    districtId: '9411060',
    name: 'Mobigi',
  },
  {
    id: '9411060036',
    districtId: '9411060',
    name: 'Yauria I',
  },
  {
    id: '9411060037',
    districtId: '9411060',
    name: 'Belantara',
  },
  {
    id: '9411060038',
    districtId: '9411060',
    name: 'Kalengga',
  },
  {
    id: '9411060039',
    districtId: '9411060',
    name: 'Pulau Timur',
  },
  {
    id: '9411060040',
    districtId: '9411060',
    name: 'Girmor',
  },
  {
    id: '9411060041',
    districtId: '9411060',
    name: 'Pulogengga',
  },
  {
    id: '9411060042',
    districtId: '9411060',
    name: 'Kirigimaduk',
  },
  {
    id: '9411060043',
    districtId: '9411060',
    name: 'Puki Paki',
  },
  {
    id: '9411060044',
    districtId: '9411060',
    name: 'Kurikpulok',
  },
  {
    id: '9411060045',
    districtId: '9411060',
    name: 'Megewi Megewa',
  },
  {
    id: '9411060046',
    districtId: '9411060',
    name: 'Kaninonggo',
  },
  {
    id: '9411060047',
    districtId: '9411060',
    name: 'Gubulome',
  },
  {
    id: '9411060048',
    districtId: '9411060',
    name: 'Ginipago',
  },
  {
    id: '9411060049',
    districtId: '9411060',
    name: 'Aulame',
  },
  {
    id: '9411061001',
    districtId: '9411061',
    name: 'Gubugani',
  },
  {
    id: '9411061004',
    districtId: '9411061',
    name: 'Ambok',
  },
  {
    id: '9411061005',
    districtId: '9411061',
    name: 'Awiyam',
  },
  {
    id: '9411061006',
    districtId: '9411061',
    name: 'Tubugime',
  },
  {
    id: '9411061007',
    districtId: '9411061',
    name: 'Wariru',
  },
  {
    id: '9411061009',
    districtId: '9411061',
    name: 'Digi',
  },
  {
    id: '9411061010',
    districtId: '9411061',
    name: 'Kikup',
  },
  {
    id: '9411061011',
    districtId: '9411061',
    name: 'Gunung Tayok',
  },
  {
    id: '9411061012',
    districtId: '9411061',
    name: 'Nambu',
  },
  {
    id: '9411061013',
    districtId: '9411061',
    name: 'Asua',
  },
  {
    id: '9411061014',
    districtId: '9411061',
    name: 'Degei',
  },
  {
    id: '9411061015',
    districtId: '9411061',
    name: 'Sigou',
  },
  {
    id: '9411061016',
    districtId: '9411061',
    name: 'Nalu',
  },
  {
    id: '9411063001',
    districtId: '9411063',
    name: 'Yamoneri',
  },
  {
    id: '9411063002',
    districtId: '9411063',
    name: 'Gumawi',
  },
  {
    id: '9411063003',
    districtId: '9411063',
    name: 'Digolome',
  },
  {
    id: '9411063004',
    districtId: '9411063',
    name: 'Ngginigum',
  },
  {
    id: '9411063006',
    districtId: '9411063',
    name: 'Jimbeneri',
  },
  {
    id: '9411063007',
    districtId: '9411063',
    name: 'Aberiambut',
  },
  {
    id: '9411063008',
    districtId: '9411063',
    name: 'Kobarak',
  },
  {
    id: '9411063009',
    districtId: '9411063',
    name: 'Wugiwagi',
  },
  {
    id: '9411063010',
    districtId: '9411063',
    name: 'Yagaluk',
  },
  {
    id: '9411063011',
    districtId: '9411063',
    name: 'Moulo',
  },
  {
    id: '9411063012',
    districtId: '9411063',
    name: 'Jimbanime',
  },
  {
    id: '9411063013',
    districtId: '9411063',
    name: 'Jigolok',
  },
  {
    id: '9411063014',
    districtId: '9411063',
    name: 'Jigelo',
  },
  {
    id: '9411063015',
    districtId: '9411063',
    name: 'Piyapigi',
  },
  {
    id: '9411064001',
    districtId: '9411064',
    name: 'Ambit-Mbit',
  },
  {
    id: '9411064002',
    districtId: '9411064',
    name: 'Agobaga',
  },
  {
    id: '9411064003',
    districtId: '9411064',
    name: 'Alukme',
  },
  {
    id: '9411064004',
    districtId: '9411064',
    name: 'Anggitari',
  },
  {
    id: '9411064005',
    districtId: '9411064',
    name: 'Jibinggame',
  },
  {
    id: '9411064006',
    districtId: '9411064',
    name: 'Nakogwe',
  },
  {
    id: '9411064007',
    districtId: '9411064',
    name: 'Ginilome',
  },
  {
    id: '9411064008',
    districtId: '9411064',
    name: 'Yalibate',
  },
  {
    id: '9411064009',
    districtId: '9411064',
    name: 'Wurunikime',
  },
  {
    id: '9411064010',
    districtId: '9411064',
    name: 'Lerawera',
  },
  {
    id: '9411064011',
    districtId: '9411064',
    name: 'Andiron',
  },
  {
    id: '9411064012',
    districtId: '9411064',
    name: 'Tenomanggen',
  },
  {
    id: '9411064013',
    districtId: '9411064',
    name: 'Tirigoi',
  },
  {
    id: '9411064014',
    districtId: '9411064',
    name: 'Mondogoneri',
  },
  {
    id: '9411064015',
    districtId: '9411064',
    name: 'Towoluk',
  },
  {
    id: '9411064016',
    districtId: '9411064',
    name: 'Tenolok',
  },
  {
    id: '9411064017',
    districtId: '9411064',
    name: 'Oriluk',
  },
  {
    id: '9411064018',
    districtId: '9411064',
    name: 'Pagarugom',
  },
  {
    id: '9411064019',
    districtId: '9411064',
    name: 'Jiogobak',
  },
  {
    id: '9411065001',
    districtId: '9411065',
    name: 'Yawor',
  },
  {
    id: '9411065002',
    districtId: '9411065',
    name: 'Mepar',
  },
  {
    id: '9411065003',
    districtId: '9411065',
    name: 'Oum',
  },
  {
    id: '9411065005',
    districtId: '9411065',
    name: 'Woraluk',
  },
  {
    id: '9411065006',
    districtId: '9411065',
    name: 'Wurina',
  },
  {
    id: '9411065007',
    districtId: '9411065',
    name: 'Anebalui',
  },
  {
    id: '9411065008',
    districtId: '9411065',
    name: 'Pagolome',
  },
  {
    id: '9411065009',
    districtId: '9411065',
    name: 'Tombok',
  },
  {
    id: '9411065010',
    districtId: '9411065',
    name: 'Kering',
  },
  {
    id: '9411065011',
    districtId: '9411065',
    name: 'Meyongga',
  },
  {
    id: '9411065012',
    districtId: '9411065',
    name: 'Akwipaga',
  },
  {
    id: '9411065013',
    districtId: '9411065',
    name: 'Onendu',
  },
  {
    id: '9411066001',
    districtId: '9411066',
    name: 'Nioga',
  },
  {
    id: '9411066002',
    districtId: '9411066',
    name: 'Wonggi',
  },
  {
    id: '9411066003',
    districtId: '9411066',
    name: 'Yonggi',
  },
  {
    id: '9411066004',
    districtId: '9411066',
    name: 'Muruwi',
  },
  {
    id: '9411066005',
    districtId: '9411066',
    name: 'Wambagalo',
  },
  {
    id: '9411066006',
    districtId: '9411066',
    name: 'Gibaga',
  },
  {
    id: '9411066007',
    districtId: '9411066',
    name: 'Wutikme',
  },
  {
    id: '9411066008',
    districtId: '9411066',
    name: 'Wanduri',
  },
  {
    id: '9411066009',
    districtId: '9411066',
    name: 'Jigonikme',
  },
  {
    id: '9411066010',
    districtId: '9411066',
    name: 'Papak',
  },
  {
    id: '9411066011',
    districtId: '9411066',
    name: 'Walom',
  },
  {
    id: '9411067001',
    districtId: '9411067',
    name: 'Kumigi',
  },
  {
    id: '9411067003',
    districtId: '9411067',
    name: 'Apelome',
  },
  {
    id: '9411067004',
    districtId: '9411067',
    name: 'Mondu',
  },
  {
    id: '9411067005',
    districtId: '9411067',
    name: 'Gubuneri',
  },
  {
    id: '9411067006',
    districtId: '9411067',
    name: 'Kenendaga',
  },
  {
    id: '9411067007',
    districtId: '9411067',
    name: 'Timoramo',
  },
  {
    id: '9411067008',
    districtId: '9411067',
    name: 'Menggegenikime',
  },
  {
    id: '9411067009',
    districtId: '9411067',
    name: 'Tinggerage',
  },
  {
    id: '9411067010',
    districtId: '9411067',
    name: 'Wunggani',
  },
  {
    id: '9411067011',
    districtId: '9411067',
    name: 'Milineri',
  },
  {
    id: '9411067012',
    districtId: '9411067',
    name: 'Melela',
  },
  {
    id: '9411067013',
    districtId: '9411067',
    name: 'Noba-Noba',
  },
  {
    id: '9411067014',
    districtId: '9411067',
    name: 'Nogi',
  },
  {
    id: '9411067015',
    districtId: '9411067',
    name: 'Jinggi',
  },
  {
    id: '9411067016',
    districtId: '9411067',
    name: 'Ginilume',
  },
  {
    id: '9411067017',
    districtId: '9411067',
    name: 'Lingguni',
  },
  {
    id: '9411068001',
    districtId: '9411068',
    name: 'Andugir',
  },
  {
    id: '9411068002',
    districtId: '9411068',
    name: 'Muara Miguni',
  },
  {
    id: '9411068003',
    districtId: '9411068',
    name: 'Guna',
  },
  {
    id: '9411068004',
    districtId: '9411068',
    name: 'Mandura',
  },
  {
    id: '9411068005',
    districtId: '9411068',
    name: 'Lugubago',
  },
  {
    id: '9411068006',
    districtId: '9411068',
    name: 'Wumbiri',
  },
  {
    id: '9411068007',
    districtId: '9411068',
    name: 'Pereya',
  },
  {
    id: '9411068008',
    districtId: '9411068',
    name: 'Ginimanggen',
  },
  {
    id: '9411068009',
    districtId: '9411068',
    name: 'Laworage',
  },
  {
    id: '9411068010',
    districtId: '9411068',
    name: 'Abili',
  },
  {
    id: '9411068011',
    districtId: '9411068',
    name: 'Lugobago',
  },
  {
    id: '9411070002',
    districtId: '9411070',
    name: 'Tinggineri',
  },
  {
    id: '9411070003',
    districtId: '9411070',
    name: 'Monia',
  },
  {
    id: '9411070009',
    districtId: '9411070',
    name: 'Tingginambut',
  },
  {
    id: '9411070016',
    districtId: '9411070',
    name: 'Melekom',
  },
  {
    id: '9411070019',
    districtId: '9411070',
    name: 'Berime',
  },
  {
    id: '9411070020',
    districtId: '9411070',
    name: 'Womelagandan',
  },
  {
    id: '9411070021',
    districtId: '9411070',
    name: 'Tombo',
  },
  {
    id: '9411070022',
    districtId: '9411070',
    name: 'Gimanggen',
  },
  {
    id: '9411070023',
    districtId: '9411070',
    name: 'Uragi',
  },
  {
    id: '9411070024',
    districtId: '9411070',
    name: 'Yamengga',
  },
  {
    id: '9411070025',
    districtId: '9411070',
    name: 'Degi',
  },
  {
    id: '9411070026',
    districtId: '9411070',
    name: 'Paralo',
  },
  {
    id: '9411070027',
    districtId: '9411070',
    name: 'Yugumbelawi',
  },
  {
    id: '9411070028',
    districtId: '9411070',
    name: 'Bigirage',
  },
  {
    id: '9411070030',
    districtId: '9411070',
    name: 'Inikimaluk',
  },
  {
    id: '9411070031',
    districtId: '9411070',
    name: 'Gobak',
  },
  {
    id: '9411070032',
    districtId: '9411070',
    name: 'Papua',
  },
  {
    id: '9411070033',
    districtId: '9411070',
    name: 'Tingginime',
  },
  {
    id: '9411070034',
    districtId: '9411070',
    name: 'Gigume',
  },
  {
    id: '9411070035',
    districtId: '9411070',
    name: 'Yonggun',
  },
  {
    id: '9411071001',
    districtId: '9411071',
    name: 'Torage',
  },
  {
    id: '9411071002',
    districtId: '9411071',
    name: 'Palumagi',
  },
  {
    id: '9411071003',
    districtId: '9411071',
    name: 'Jiramok',
  },
  {
    id: '9411071004',
    districtId: '9411071',
    name: 'Yanenggawi',
  },
  {
    id: '9411071005',
    districtId: '9411071',
    name: 'Wurabume',
  },
  {
    id: '9411071006',
    districtId: '9411071',
    name: 'Binggelume',
  },
  {
    id: '9411071007',
    districtId: '9411071',
    name: 'Kayogebur',
  },
  {
    id: '9411071008',
    districtId: '9411071',
    name: 'Kalome',
  },
  {
    id: '9411071009',
    districtId: '9411071',
    name: 'Agape',
  },
  {
    id: '9411071010',
    districtId: '9411071',
    name: 'Cilome',
  },
  {
    id: '9411071011',
    districtId: '9411071',
    name: 'Longgawi',
  },
  {
    id: '9411071012',
    districtId: '9411071',
    name: 'Wundini',
  },
  {
    id: '9411071014',
    districtId: '9411071',
    name: 'Diraluk',
  },
  {
    id: '9411071015',
    districtId: '9411071',
    name: 'Pilibur',
  },
  {
    id: '9411071016',
    districtId: '9411071',
    name: 'Jinggwi',
  },
  {
    id: '9411072001',
    districtId: '9411072',
    name: 'Bunaluk',
  },
  {
    id: '9411072002',
    districtId: '9411072',
    name: 'Gereja Lama',
  },
  {
    id: '9411072003',
    districtId: '9411072',
    name: 'Anggalo',
  },
  {
    id: '9411072004',
    districtId: '9411072',
    name: 'Nanegeme',
  },
  {
    id: '9411072005',
    districtId: '9411072',
    name: 'Ponggoname',
  },
  {
    id: '9411072006',
    districtId: '9411072',
    name: 'Yunggwi',
  },
  {
    id: '9411072007',
    districtId: '9411072',
    name: 'Pernaluk',
  },
  {
    id: '9411072008',
    districtId: '9411072',
    name: 'Bime',
  },
  {
    id: '9411072009',
    districtId: '9411072',
    name: 'Wiyage',
  },
  {
    id: '9411072010',
    districtId: '9411072',
    name: 'Anggege',
  },
  {
    id: '9411072011',
    districtId: '9411072',
    name: 'Nuwi',
  },
  {
    id: '9411072012',
    districtId: '9411072',
    name: 'Piyabigimbut',
  },
  {
    id: '9411072013',
    districtId: '9411072',
    name: 'Kiburu',
  },
  {
    id: '9411072014',
    districtId: '9411072',
    name: 'Wanwi',
  },
  {
    id: '9411072015',
    districtId: '9411072',
    name: 'Gibume',
  },
  {
    id: '9411072016',
    districtId: '9411072',
    name: 'Naburage',
  },
  {
    id: '9411072017',
    districtId: '9411072',
    name: 'Anggagalo',
  },
  {
    id: '9411080002',
    districtId: '9411080',
    name: 'Mewoluk',
  },
  {
    id: '9411080007',
    districtId: '9411080',
    name: 'Anggulopaga',
  },
  {
    id: '9411080008',
    districtId: '9411080',
    name: 'Balinggup',
  },
  {
    id: '9411080009',
    districtId: '9411080',
    name: 'Waliba',
  },
  {
    id: '9411080010',
    districtId: '9411080',
    name: 'Wutikme',
  },
  {
    id: '9411080011',
    districtId: '9411080',
    name: 'Gininik',
  },
  {
    id: '9411080012',
    districtId: '9411080',
    name: 'Biak',
  },
  {
    id: '9411081001',
    districtId: '9411081',
    name: 'Wuramburu',
  },
  {
    id: '9411081002',
    districtId: '9411081',
    name: 'Gilibe',
  },
  {
    id: '9411081003',
    districtId: '9411081',
    name: 'Tigir',
  },
  {
    id: '9411081004',
    districtId: '9411081',
    name: 'Wuluma',
  },
  {
    id: '9411081005',
    districtId: '9411081',
    name: 'Ninggineri',
  },
  {
    id: '9411081006',
    districtId: '9411081',
    name: 'Wurabak',
  },
  {
    id: '9411081007',
    districtId: '9411081',
    name: 'Lumo',
  },
  {
    id: '9411081008',
    districtId: '9411081',
    name: 'Gilume',
  },
  {
    id: '9411081009',
    districtId: '9411081',
    name: 'Kililumo',
  },
  {
    id: '9411082002',
    districtId: '9411082',
    name: 'Belaba',
  },
  {
    id: '9411082003',
    districtId: '9411082',
    name: 'Maloinggen',
  },
  {
    id: '9411082004',
    districtId: '9411082',
    name: 'Tioleme',
  },
  {
    id: '9411082005',
    districtId: '9411082',
    name: 'Wanume',
  },
  {
    id: '9411090004',
    districtId: '9411090',
    name: 'Binime',
  },
  {
    id: '9411090007',
    districtId: '9411090',
    name: 'Yogolawi',
  },
  {
    id: '9411090008',
    districtId: '9411090',
    name: 'Yambuni',
  },
  {
    id: '9411090009',
    districtId: '9411090',
    name: 'Tiogeme',
  },
  {
    id: '9411090010',
    districtId: '9411090',
    name: 'Goyage',
  },
  {
    id: '9411090011',
    districtId: '9411090',
    name: 'Kabilimbut',
  },
  {
    id: '9411090012',
    districtId: '9411090',
    name: 'Wolame',
  },
  {
    id: '9411090013',
    districtId: '9411090',
    name: 'Muara',
  },
  {
    id: '9411090014',
    districtId: '9411090',
    name: 'Kwatineri',
  },
  {
    id: '9411090015',
    districtId: '9411090',
    name: 'Yileyale',
  },
  {
    id: '9411090016',
    districtId: '9411090',
    name: 'Gibaga',
  },
  {
    id: '9411090017',
    districtId: '9411090',
    name: 'Nami',
  },
  {
    id: '9411090018',
    districtId: '9411090',
    name: 'Linwakwi',
  },
  {
    id: '9411091001',
    districtId: '9411091',
    name: 'Dokome',
  },
  {
    id: '9411091002',
    districtId: '9411091',
    name: 'Urage',
  },
  {
    id: '9411091003',
    districtId: '9411091',
    name: 'Nungwawi',
  },
  {
    id: '9411091004',
    districtId: '9411091',
    name: 'Nowoneri',
  },
  {
    id: '9411091005',
    districtId: '9411091',
    name: 'Nowome',
  },
  {
    id: '9411091006',
    districtId: '9411091',
    name: 'Imulineri',
  },
  {
    id: '9411091007',
    districtId: '9411091',
    name: 'Molobak',
  },
  {
    id: '9411091008',
    districtId: '9411091',
    name: 'Purbalo',
  },
  {
    id: '9411091009',
    districtId: '9411091',
    name: 'Kumibut',
  },
  {
    id: '9412010020',
    districtId: '9412010',
    name: 'Kokonao',
  },
  {
    id: '9412010021',
    districtId: '9412010',
    name: 'Migiwia',
  },
  {
    id: '9412010022',
    districtId: '9412010',
    name: 'Mimika',
  },
  {
    id: '9412010023',
    districtId: '9412010',
    name: 'Kiyura',
  },
  {
    id: '9412010024',
    districtId: '9412010',
    name: 'Apuri',
  },
  {
    id: '9412010025',
    districtId: '9412010',
    name: 'Atapo',
  },
  {
    id: '9412010026',
    districtId: '9412010',
    name: 'Aparuka',
  },
  {
    id: '9412011001',
    districtId: '9412011',
    name: 'Potowayburu',
  },
  {
    id: '9412011002',
    districtId: '9412011',
    name: 'Yapakopa',
  },
  {
    id: '9412011003',
    districtId: '9412011',
    name: 'Aindua',
  },
  {
    id: '9412011004',
    districtId: '9412011',
    name: 'Tapormai',
  },
  {
    id: '9412011005',
    districtId: '9412011',
    name: 'Umar',
  },
  {
    id: '9412012001',
    districtId: '9412012',
    name: 'Pronggo',
  },
  {
    id: '9412012002',
    districtId: '9412012',
    name: 'Kipia',
  },
  {
    id: '9412012003',
    districtId: '9412012',
    name: 'Mapar',
  },
  {
    id: '9412012004',
    districtId: '9412012',
    name: 'Akar',
  },
  {
    id: '9412012005',
    districtId: '9412012',
    name: 'Kapiraya',
  },
  {
    id: '9412012006',
    districtId: '9412012',
    name: 'Uta',
  },
  {
    id: '9412012007',
    districtId: '9412012',
    name: 'Mupuruka',
  },
  {
    id: '9412012008',
    districtId: '9412012',
    name: 'Wumuka',
  },
  {
    id: '9412012009',
    districtId: '9412012',
    name: 'Wakia',
  },
  {
    id: '9412013001',
    districtId: '9412013',
    name: 'Ipiri',
  },
  {
    id: '9412013002',
    districtId: '9412013',
    name: 'Paripi',
  },
  {
    id: '9412013003',
    districtId: '9412013',
    name: 'Yaraya',
  },
  {
    id: '9412013004',
    districtId: '9412013',
    name: 'Amar',
  },
  {
    id: '9412013005',
    districtId: '9412013',
    name: 'Kawar',
  },
  {
    id: '9412013006',
    districtId: '9412013',
    name: 'Manuare',
  },
  {
    id: '9412020004',
    districtId: '9412020',
    name: 'Pomako',
  },
  {
    id: '9412020009',
    districtId: '9412020',
    name: 'Tipuka',
  },
  {
    id: '9412020010',
    districtId: '9412020',
    name: 'Hiripau',
  },
  {
    id: '9412020012',
    districtId: '9412020',
    name: 'Kaugapu',
  },
  {
    id: '9412020013',
    districtId: '9412020',
    name: 'Wania',
  },
  {
    id: '9412020015',
    districtId: '9412020',
    name: 'Mwapi',
  },
  {
    id: '9412021001',
    districtId: '9412021',
    name: 'Keakwa',
  },
  {
    id: '9412021002',
    districtId: '9412021',
    name: 'Tiwaka',
  },
  {
    id: '9412021003',
    districtId: '9412021',
    name: 'Atuka',
  },
  {
    id: '9412021004',
    districtId: '9412021',
    name: 'Aikawapuka',
  },
  {
    id: '9412021005',
    districtId: '9412021',
    name: 'Kamora',
  },
  {
    id: '9412022001',
    districtId: '9412022',
    name: 'Fanamo',
  },
  {
    id: '9412022002',
    districtId: '9412022',
    name: 'Ohotya',
  },
  {
    id: '9412022003',
    districtId: '9412022',
    name: 'Omawita',
  },
  {
    id: '9412022004',
    districtId: '9412022',
    name: 'Amamapare',
  },
  {
    id: '9412022005',
    districtId: '9412022',
    name: 'Ayuka',
  },
  {
    id: '9412030004',
    districtId: '9412030',
    name: 'Koperapoka',
  },
  {
    id: '9412030012',
    districtId: '9412030',
    name: 'Timika Jaya',
  },
  {
    id: '9412030013',
    districtId: '9412030',
    name: 'Kwamki Baru',
  },
  {
    id: '9412030015',
    districtId: '9412030',
    name: 'Nayaro',
  },
  {
    id: '9412030016',
    districtId: '9412030',
    name: 'Timika Indah',
  },
  {
    id: '9412030017',
    districtId: '9412030',
    name: 'Otomona',
  },
  {
    id: '9412030018',
    districtId: '9412030',
    name: 'Dingonarama',
  },
  {
    id: '9412030019',
    districtId: '9412030',
    name: 'Pasar Sentral',
  },
  {
    id: '9412030020',
    districtId: '9412030',
    name: 'Wanagon',
  },
  {
    id: '9412030021',
    districtId: '9412030',
    name: 'Sempan',
  },
  {
    id: '9412030022',
    districtId: '9412030',
    name: 'Hangaitji',
  },
  {
    id: '9412030023',
    districtId: '9412030',
    name: 'Ninabua',
  },
  {
    id: '9412030024',
    districtId: '9412030',
    name: 'Kebun Sirih',
  },
  {
    id: '9412030025',
    districtId: '9412030',
    name: 'Perintis',
  },
  {
    id: '9412031003',
    districtId: '9412031',
    name: 'Karang Senang',
  },
  {
    id: '9412031004',
    districtId: '9412031',
    name: 'Kuala Kencana',
  },
  {
    id: '9412031006',
    districtId: '9412031',
    name: 'Utikini Baru',
  },
  {
    id: '9412031007',
    districtId: '9412031',
    name: 'Bhintuka',
  },
  {
    id: '9412031008',
    districtId: '9412031',
    name: 'Pioka Kencana',
  },
  {
    id: '9412031009',
    districtId: '9412031',
    name: 'Mimika Gunung',
  },
  {
    id: '9412031010',
    districtId: '9412031',
    name: 'Karya Kencana',
  },
  {
    id: '9412031011',
    districtId: '9412031',
    name: 'Jimbi',
  },
  {
    id: '9412031012',
    districtId: '9412031',
    name: 'Utikini II',
  },
  {
    id: '9412031013',
    districtId: '9412031',
    name: 'Utikini III',
  },
  {
    id: '9412032001',
    districtId: '9412032',
    name: 'Tembagapura',
  },
  {
    id: '9412032002',
    districtId: '9412032',
    name: 'Waa',
  },
  {
    id: '9412032003',
    districtId: '9412032',
    name: 'Arwandop',
  },
  {
    id: '9412032004',
    districtId: '9412032',
    name: 'Tsinga',
  },
  {
    id: '9412032006',
    districtId: '9412032',
    name: 'Jagamin',
  },
  {
    id: '9412032007',
    districtId: '9412032',
    name: 'Opitawak',
  },
  {
    id: '9412032008',
    districtId: '9412032',
    name: 'Doliningokngin',
  },
  {
    id: '9412032009',
    districtId: '9412032',
    name: 'Banigogom',
  },
  {
    id: '9412032010',
    districtId: '9412032',
    name: 'Banti II',
  },
  {
    id: '9412033001',
    districtId: '9412033',
    name: 'Kamoro Jaya',
  },
  {
    id: '9412033002',
    districtId: '9412033',
    name: 'Monokau Jaya',
  },
  {
    id: '9412033003',
    districtId: '9412033',
    name: 'Wonosari Jaya',
  },
  {
    id: '9412033004',
    districtId: '9412033',
    name: 'Mandiri Jaya',
  },
  {
    id: '9412033005',
    districtId: '9412033',
    name: 'Inauga',
  },
  {
    id: '9412033006',
    districtId: '9412033',
    name: 'Nawaripi',
  },
  {
    id: '9412033007',
    districtId: '9412033',
    name: 'Kadun Jaya',
  },
  {
    id: '9412034001',
    districtId: '9412034',
    name: 'Limau Asri',
  },
  {
    id: '9412034002',
    districtId: '9412034',
    name: 'Limau Asri Barat',
  },
  {
    id: '9412034003',
    districtId: '9412034',
    name: 'Wangirja',
  },
  {
    id: '9412034004',
    districtId: '9412034',
    name: 'Iwaka',
  },
  {
    id: '9412034005',
    districtId: '9412034',
    name: 'Naena Muktipura',
  },
  {
    id: '9412034006',
    districtId: '9412034',
    name: 'Mulia Kencana',
  },
  {
    id: '9412034007',
    districtId: '9412034',
    name: 'Pigapu',
  },
  {
    id: '9412035001',
    districtId: '9412035',
    name: 'Harapan',
  },
  {
    id: '9412035002',
    districtId: '9412035',
    name: 'Mekurima',
  },
  {
    id: '9412035003',
    districtId: '9412035',
    name: 'Landum Mekar',
  },
  {
    id: '9412035004',
    districtId: '9412035',
    name: 'Olaroa',
  },
  {
    id: '9412035005',
    districtId: '9412035',
    name: 'Bintang Lima',
  },
  {
    id: '9412035006',
    districtId: '9412035',
    name: 'Damai',
  },
  {
    id: '9412035007',
    districtId: '9412035',
    name: 'Walani',
  },
  {
    id: '9412035008',
    districtId: '9412035',
    name: 'Amole',
  },
  {
    id: '9412035009',
    districtId: '9412035',
    name: 'Lamopi',
  },
  {
    id: '9412035010',
    districtId: '9412035',
    name: 'Tunas Matoa',
  },
  {
    id: '9412040005',
    districtId: '9412040',
    name: 'Faka Fuku',
  },
  {
    id: '9412040007',
    districtId: '9412040',
    name: 'Kiliarma',
  },
  {
    id: '9412040008',
    districtId: '9412040',
    name: 'Amungun',
  },
  {
    id: '9412040009',
    districtId: '9412040',
    name: 'Aramsolki',
  },
  {
    id: '9412040010',
    districtId: '9412040',
    name: 'Hinat Untung',
  },
  {
    id: '9412040011',
    districtId: '9412040',
    name: 'Masaimamo',
  },
  {
    id: '9412040012',
    districtId: '9412040',
    name: 'Emkoma Halama',
  },
  {
    id: '9412040013',
    districtId: '9412040',
    name: 'Emogora',
  },
  {
    id: '9412041001',
    districtId: '9412041',
    name: 'Jila',
  },
  {
    id: '9412041005',
    districtId: '9412041',
    name: 'Diloa',
  },
  {
    id: '9412041006',
    districtId: '9412041',
    name: 'Noemun',
  },
  {
    id: '9412041009',
    districtId: '9412041',
    name: 'Pasir Putih',
  },
  {
    id: '9412041010',
    districtId: '9412041',
    name: 'Pilikogom',
  },
  {
    id: '9412041011',
    districtId: '9412041',
    name: 'Bunaraugin',
  },
  {
    id: '9412041012',
    districtId: '9412041',
    name: 'Umpliga',
  },
  {
    id: '9412041013',
    districtId: '9412041',
    name: 'Diola II',
  },
  {
    id: '9412041014',
    districtId: '9412041',
    name: 'Amuaogom',
  },
  {
    id: '9412041015',
    districtId: '9412041',
    name: 'Jengkoan',
  },
  {
    id: '9412042001',
    districtId: '9412042',
    name: 'Sumapro',
  },
  {
    id: '9412042002',
    districtId: '9412042',
    name: 'Wapu',
  },
  {
    id: '9412042003',
    districtId: '9412042',
    name: 'Wenin',
  },
  {
    id: '9412042004',
    districtId: '9412042',
    name: 'Noema',
  },
  {
    id: '9412042005',
    districtId: '9412042',
    name: 'Sempan Timur',
  },
  {
    id: '9412042006',
    districtId: '9412042',
    name: 'Wacakam',
  },
  {
    id: '9412042007',
    districtId: '9412042',
    name: 'Waituku',
  },
  {
    id: '9412042008',
    districtId: '9412042',
    name: 'Yaitak',
  },
  {
    id: '9412042010',
    districtId: '9412042',
    name: 'Kanmapiri',
  },
  {
    id: '9412043001',
    districtId: '9412043',
    name: 'Enggin',
  },
  {
    id: '9412043002',
    districtId: '9412043',
    name: 'Senawak',
  },
  {
    id: '9412043003',
    districtId: '9412043',
    name: 'Geselama',
  },
  {
    id: '9412043004',
    districtId: '9412043',
    name: 'Bemoki',
  },
  {
    id: '9412043005',
    districtId: '9412043',
    name: 'Tagalarma',
  },
  {
    id: '9412043006',
    districtId: '9412043',
    name: 'Unomogom',
  },
  {
    id: '9412043007',
    districtId: '9412043',
    name: 'Wuarem',
  },
  {
    id: '9412043008',
    districtId: '9412043',
    name: 'Purua',
  },
  {
    id: '9412043009',
    districtId: '9412043',
    name: 'Kelmit',
  },
  {
    id: '9412043010',
    districtId: '9412043',
    name: 'Yenggelo',
  },
  {
    id: '9412043011',
    districtId: '9412043',
    name: 'Alama',
  },
  {
    id: '9412043012',
    districtId: '9412043',
    name: 'Wandud',
  },
  {
    id: '9412044001',
    districtId: '9412044',
    name: 'Hoya',
  },
  {
    id: '9412044002',
    districtId: '9412044',
    name: 'Jinoni',
  },
  {
    id: '9412044003',
    districtId: '9412044',
    name: 'Mamontoga',
  },
  {
    id: '9412044004',
    districtId: '9412044',
    name: 'Kulamogan',
  },
  {
    id: '9412044005',
    districtId: '9412044',
    name: 'Jawa',
  },
  {
    id: '9412044006',
    districtId: '9412044',
    name: 'Puti',
  },
  {
    id: '9413010007',
    districtId: '9413010',
    name: 'Getentiri',
  },
  {
    id: '9413010008',
    districtId: '9413010',
    name: 'Butiptiri',
  },
  {
    id: '9413010009',
    districtId: '9413010',
    name: 'Anggai',
  },
  {
    id: '9413010010',
    districtId: '9413010',
    name: 'Asiki',
  },
  {
    id: '9413010011',
    districtId: '9413010',
    name: 'Miri',
  },
  {
    id: '9413011001',
    districtId: '9413011',
    name: 'Kaisa',
  },
  {
    id: '9413011003',
    districtId: '9413011',
    name: 'Bhakti / Wagai',
  },
  {
    id: '9413011005',
    districtId: '9413011',
    name: 'Aiwat',
  },
  {
    id: '9413013004',
    districtId: '9413013',
    name: 'Metto',
  },
  {
    id: '9413013006',
    districtId: '9413013',
    name: 'Ujungkia',
  },
  {
    id: '9413013007',
    districtId: '9413013',
    name: 'Obinangge',
  },
  {
    id: '9413013008',
    districtId: '9413013',
    name: 'Watemu',
  },
  {
    id: '9413013009',
    districtId: '9413013',
    name: 'Kapohu',
  },
  {
    id: '9413020002',
    districtId: '9413020',
    name: 'Epsembit',
  },
  {
    id: '9413020004',
    districtId: '9413020',
    name: 'Umap',
  },
  {
    id: '9413020005',
    districtId: '9413020',
    name: 'Imko',
  },
  {
    id: '9413020006',
    districtId: '9413020',
    name: 'Anggumbit',
  },
  {
    id: '9413020007',
    districtId: '9413020',
    name: 'Niyimbang',
  },
  {
    id: '9413020008',
    districtId: '9413020',
    name: 'Andopbit',
  },
  {
    id: '9413020009',
    districtId: '9413020',
    name: 'Tinggam',
  },
  {
    id: '9413020013',
    districtId: '9413020',
    name: 'Osso',
  },
  {
    id: '9413020014',
    districtId: '9413020',
    name: 'Kamka',
  },
  {
    id: '9413020015',
    districtId: '9413020',
    name: 'Mindiptana',
  },
  {
    id: '9413020020',
    districtId: '9413020',
    name: 'Wanggatkibi',
  },
  {
    id: '9413020021',
    districtId: '9413020',
    name: 'Awayanka',
  },
  {
    id: '9413020022',
    districtId: '9413020',
    name: 'Kakuna',
  },
  {
    id: '9413021001',
    districtId: '9413021',
    name: 'Autriop',
  },
  {
    id: '9413021002',
    districtId: '9413021',
    name: 'Ogenatan',
  },
  {
    id: '9413021003',
    districtId: '9413021',
    name: 'Langgoan',
  },
  {
    id: '9413021004',
    districtId: '9413021',
    name: 'Warik Toop',
  },
  {
    id: '9413021005',
    districtId: '9413021',
    name: 'Tetop',
  },
  {
    id: '9413022002',
    districtId: '9413022',
    name: 'Amuan',
  },
  {
    id: '9413022003',
    districtId: '9413022',
    name: 'Mokbiran',
  },
  {
    id: '9413022004',
    districtId: '9413022',
    name: 'Kawangtet',
  },
  {
    id: '9413022005',
    districtId: '9413022',
    name: 'Kombut',
  },
  {
    id: '9413023001',
    districtId: '9413023',
    name: 'Anggamburan',
  },
  {
    id: '9413023004',
    districtId: '9413023',
    name: 'Amboran',
  },
  {
    id: '9413023005',
    districtId: '9413023',
    name: 'Kanggup',
  },
  {
    id: '9413023006',
    districtId: '9413023',
    name: 'Yomkondo',
  },
  {
    id: '9413030004',
    districtId: '9413030',
    name: 'Ampera',
  },
  {
    id: '9413030005',
    districtId: '9413030',
    name: 'Persatuan',
  },
  {
    id: '9413030006',
    districtId: '9413030',
    name: 'Mawan',
  },
  {
    id: '9413030007',
    districtId: '9413030',
    name: 'Sokanggo',
  },
  {
    id: '9413030008',
    districtId: '9413030',
    name: 'Mariam',
  },
  {
    id: '9413031001',
    districtId: '9413031',
    name: 'Bangun',
  },
  {
    id: '9413031002',
    districtId: '9413031',
    name: 'Sadar',
  },
  {
    id: '9413031003',
    districtId: '9413031',
    name: 'Makmur',
  },
  {
    id: '9413031004',
    districtId: '9413031',
    name: 'Hamkhu',
  },
  {
    id: '9413031005',
    districtId: '9413031',
    name: 'Hello',
  },
  {
    id: '9413031006',
    districtId: '9413031',
    name: 'Domo',
  },
  {
    id: '9413031007',
    districtId: '9413031',
    name: 'Sohokanggo',
  },
  {
    id: '9413031008',
    districtId: '9413031',
    name: 'Navini',
  },
  {
    id: '9413032001',
    districtId: '9413032',
    name: 'Patriot',
  },
  {
    id: '9413032002',
    districtId: '9413032',
    name: 'Ginggimob',
  },
  {
    id: '9413032003',
    districtId: '9413032',
    name: 'Maju',
  },
  {
    id: '9413032005',
    districtId: '9413032',
    name: 'Bukit',
  },
  {
    id: '9413032006',
    districtId: '9413032',
    name: 'Arimbit',
  },
  {
    id: '9413032007',
    districtId: '9413032',
    name: 'Aroa',
  },
  {
    id: '9413040003',
    districtId: '9413040',
    name: 'Jair',
  },
  {
    id: '9413040004',
    districtId: '9413040',
    name: 'Mandobo',
  },
  {
    id: '9413040005',
    districtId: '9413040',
    name: 'Kouh',
  },
  {
    id: '9413041001',
    districtId: '9413041',
    name: 'Somi',
  },
  {
    id: '9413041002',
    districtId: '9413041',
    name: 'Bomakia I',
  },
  {
    id: '9413041003',
    districtId: '9413041',
    name: 'Bomakia II',
  },
  {
    id: '9413041004',
    districtId: '9413041',
    name: 'Aifo',
  },
  {
    id: '9413041005',
    districtId: '9413041',
    name: 'Uni',
  },
  {
    id: '9413042001',
    districtId: '9413042',
    name: 'Firiwage',
  },
  {
    id: '9413042002',
    districtId: '9413042',
    name: 'Karuwage',
  },
  {
    id: '9413042005',
    districtId: '9413042',
    name: 'Waliburu',
  },
  {
    id: '9413042006',
    districtId: '9413042',
    name: 'Kabuwage',
  },
  {
    id: '9413043001',
    districtId: '9413043',
    name: 'Manggelum',
  },
  {
    id: '9413043002',
    districtId: '9413043',
    name: 'Mangga Tiga',
  },
  {
    id: '9413043003',
    districtId: '9413043',
    name: 'Kewam',
  },
  {
    id: '9413043004',
    districtId: '9413043',
    name: 'Bayanggop',
  },
  {
    id: '9413043005',
    districtId: '9413043',
    name: 'Gaguop',
  },
  {
    id: '9413043006',
    districtId: '9413043',
    name: 'Burunggop',
  },
  {
    id: '9413044001',
    districtId: '9413044',
    name: 'Fefero',
  },
  {
    id: '9413044003',
    districtId: '9413044',
    name: 'Yaniruma',
  },
  {
    id: '9413044004',
    districtId: '9413044',
    name: 'Manggemahe',
  },
  {
    id: '9413045003',
    districtId: '9413045',
    name: 'Biwage 2',
  },
  {
    id: '9413045004',
    districtId: '9413045',
    name: 'Biwage 1',
  },
  {
    id: '9413045009',
    districtId: '9413045',
    name: 'Kombai',
  },
  {
    id: '9413045010',
    districtId: '9413045',
    name: 'Niop',
  },
  {
    id: '9413045011',
    districtId: '9413045',
    name: 'Kawagit',
  },
  {
    id: '9413045012',
    districtId: '9413045',
    name: 'Wanggom',
  },
  {
    id: '9413046002',
    districtId: '9413046',
    name: 'Wanggemalo',
  },
  {
    id: '9413046003',
    districtId: '9413046',
    name: 'Dema',
  },
  {
    id: '9413046004',
    districtId: '9413046',
    name: 'Ugo',
  },
  {
    id: '9413046005',
    districtId: '9413046',
    name: 'Yafufla',
  },
  {
    id: '9413046006',
    districtId: '9413046',
    name: 'Sinimburu',
  },
  {
    id: '9413050001',
    districtId: '9413050',
    name: 'Winiktit',
  },
  {
    id: '9413050002',
    districtId: '9413050',
    name: 'Kanggewot',
  },
  {
    id: '9413050003',
    districtId: '9413050',
    name: 'Upyetetko',
  },
  {
    id: '9413050007',
    districtId: '9413050',
    name: 'Waropko',
  },
  {
    id: '9413050008',
    districtId: '9413050',
    name: 'Wombon',
  },
  {
    id: '9413050010',
    districtId: '9413050',
    name: 'Upkim',
  },
  {
    id: '9413050012',
    districtId: '9413050',
    name: 'Ikcan',
  },
  {
    id: '9413051001',
    districtId: '9413051',
    name: 'Anyumka',
  },
  {
    id: '9413051003',
    districtId: '9413051',
    name: 'Nyum / Awaken',
  },
  {
    id: '9413051004',
    districtId: '9413051',
    name: 'Kolopkam',
  },
  {
    id: '9413051005',
    districtId: '9413051',
    name: 'Arimbit',
  },
  {
    id: '9413052004',
    districtId: '9413052',
    name: 'Ninati',
  },
  {
    id: '9413052006',
    districtId: '9413052',
    name: 'Kawaktetbut',
  },
  {
    id: '9413052007',
    districtId: '9413052',
    name: 'Tembutka',
  },
  {
    id: '9413052008',
    districtId: '9413052',
    name: 'Timka',
  },
  {
    id: '9414010001',
    districtId: '9414010',
    name: 'Wagin',
  },
  {
    id: '9414010003',
    districtId: '9414010',
    name: 'Linggua',
  },
  {
    id: '9414010004',
    districtId: '9414010',
    name: 'Yatan',
  },
  {
    id: '9414010005',
    districtId: '9414010',
    name: 'Katan',
  },
  {
    id: '9414010006',
    districtId: '9414010',
    name: 'Monana',
  },
  {
    id: '9414010007',
    districtId: '9414010',
    name: 'Waman',
  },
  {
    id: '9414010008',
    districtId: '9414010',
    name: 'Koba',
  },
  {
    id: '9414010009',
    districtId: '9414010',
    name: 'Kogoyaman',
  },
  {
    id: '9414010010',
    districtId: '9414010',
    name: 'Ima',
  },
  {
    id: '9414010011',
    districtId: '9414010',
    name: 'Agham',
  },
  {
    id: '9414010013',
    districtId: '9414010',
    name: 'Magabak',
  },
  {
    id: '9414010014',
    districtId: '9414010',
    name: 'Ghanu',
  },
  {
    id: '9414010015',
    districtId: '9414010',
    name: 'Warume',
  },
  {
    id: '9414011001',
    districtId: '9414011',
    name: 'Kabe',
  },
  {
    id: '9414011002',
    districtId: '9414011',
    name: 'Sumur Aman',
  },
  {
    id: '9414011003',
    districtId: '9414011',
    name: 'Kofar',
  },
  {
    id: '9414011004',
    districtId: '9414011',
    name: 'Komru',
  },
  {
    id: '9414011006',
    districtId: '9414011',
    name: 'Taragae',
  },
  {
    id: '9414011007',
    districtId: '9414011',
    name: 'Upin',
  },
  {
    id: '9414011008',
    districtId: '9414011',
    name: 'Khaumi',
  },
  {
    id: '9414011009',
    districtId: '9414011',
    name: 'Atti',
  },
  {
    id: '9414011010',
    districtId: '9414011',
    name: 'Kayagae',
  },
  {
    id: '9414011011',
    districtId: '9414011',
    name: 'Pano',
  },
  {
    id: '9414011012',
    districtId: '9414011',
    name: 'Kogir',
  },
  {
    id: '9414020001',
    districtId: '9414020',
    name: 'Yodom',
  },
  {
    id: '9414020002',
    districtId: '9414020',
    name: 'Banamepe',
  },
  {
    id: '9414020003',
    districtId: '9414020',
    name: 'Bade',
  },
  {
    id: '9414020004',
    districtId: '9414020',
    name: 'Isyaman',
  },
  {
    id: '9414020007',
    districtId: '9414020',
    name: 'Gimikia',
  },
  {
    id: '9414020008',
    districtId: '9414020',
    name: 'Geturki',
  },
  {
    id: '9414021002',
    districtId: '9414021',
    name: 'Sahapikia',
  },
  {
    id: '9414021006',
    districtId: '9414021',
    name: 'Yibin',
  },
  {
    id: '9414021007',
    districtId: '9414021',
    name: 'Harapan',
  },
  {
    id: '9414021008',
    districtId: '9414021',
    name: 'Pies',
  },
  {
    id: '9414021010',
    districtId: '9414021',
    name: 'Mopio',
  },
  {
    id: '9414021011',
    districtId: '9414021',
    name: 'Sien',
  },
  {
    id: '9414021014',
    districtId: '9414021',
    name: 'Getiyo',
  },
  {
    id: '9414022001',
    districtId: '9414022',
    name: 'Homilikia',
  },
  {
    id: '9414022002',
    districtId: '9414022',
    name: 'Kobeta',
  },
  {
    id: '9414022003',
    districtId: '9414022',
    name: 'Asset',
  },
  {
    id: '9414022004',
    districtId: '9414022',
    name: 'Osso',
  },
  {
    id: '9414022005',
    districtId: '9414022',
    name: 'Bosma',
  },
  {
    id: '9414022006',
    districtId: '9414022',
    name: 'Ogoto',
  },
  {
    id: '9414023001',
    districtId: '9414023',
    name: 'Yeloba',
  },
  {
    id: '9414023002',
    districtId: '9414023',
    name: 'Konebi',
  },
  {
    id: '9414023003',
    districtId: '9414023',
    name: 'Sibi',
  },
  {
    id: '9414023004',
    districtId: '9414023',
    name: 'Tagaimon Siwo',
  },
  {
    id: '9414023005',
    districtId: '9414023',
    name: 'Tagaimon Korame',
  },
  {
    id: '9414024001',
    districtId: '9414024',
    name: 'Amk',
  },
  {
    id: '9414024002',
    districtId: '9414024',
    name: 'Yame',
  },
  {
    id: '9414024003',
    districtId: '9414024',
    name: 'Benggo',
  },
  {
    id: '9414024004',
    districtId: '9414024',
    name: 'Kokoya',
  },
  {
    id: '9414024005',
    districtId: '9414024',
    name: 'Mulya / Borobaha',
  },
  {
    id: '9414024012',
    districtId: '9414024',
    name: 'Ogorito',
  },
  {
    id: '9414030001',
    districtId: '9414030',
    name: 'Mappi Bawah',
  },
  {
    id: '9414030002',
    districtId: '9414030',
    name: 'Wanggate',
  },
  {
    id: '9414030003',
    districtId: '9414030',
    name: 'Kadam/Oyim',
  },
  {
    id: '9414030004',
    districtId: '9414030',
    name: 'P I A I',
  },
  {
    id: '9414030005',
    districtId: '9414030',
    name: 'Kogo',
  },
  {
    id: '9414030008',
    districtId: '9414030',
    name: 'S O B A',
  },
  {
    id: '9414030009',
    districtId: '9414030',
    name: 'Dagimon',
  },
  {
    id: '9414030010',
    districtId: '9414030',
    name: 'Kepi',
  },
  {
    id: '9414030011',
    districtId: '9414030',
    name: 'Obaa',
  },
  {
    id: '9414030013',
    districtId: '9414030',
    name: 'T O K O M',
  },
  {
    id: '9414030014',
    districtId: '9414030',
    name: 'M U I N',
  },
  {
    id: '9414030015',
    districtId: '9414030',
    name: 'Rayam',
  },
  {
    id: '9414030016',
    districtId: '9414030',
    name: 'Mairu',
  },
  {
    id: '9414030017',
    districtId: '9414030',
    name: 'Gauda',
  },
  {
    id: '9414030018',
    districtId: '9414030',
    name: 'Marbin',
  },
  {
    id: '9414030019',
    districtId: '9414030',
    name: 'Harome',
  },
  {
    id: '9414030020',
    districtId: '9414030',
    name: 'Yangpop',
  },
  {
    id: '9414030021',
    districtId: '9414030',
    name: 'Paedam',
  },
  {
    id: '9414030022',
    districtId: '9414030',
    name: 'Madu',
  },
  {
    id: '9414030023',
    districtId: '9414030',
    name: 'Metim',
  },
  {
    id: '9414030024',
    districtId: '9414030',
    name: 'Masin',
  },
  {
    id: '9414031001',
    districtId: '9414031',
    name: 'Rimba Jaya / Gayu',
  },
  {
    id: '9414031002',
    districtId: '9414031',
    name: 'Kaime',
  },
  {
    id: '9414031003',
    districtId: '9414031',
    name: 'T A I M/Pasue',
  },
  {
    id: '9414031004',
    districtId: '9414031',
    name: 'Kotiak',
  },
  {
    id: '9414031005',
    districtId: '9414031',
    name: 'N O H O N',
  },
  {
    id: '9414031006',
    districtId: '9414031',
    name: 'Kotup / Xotup',
  },
  {
    id: '9414031007',
    districtId: '9414031',
    name: 'Tokompatu',
  },
  {
    id: '9414031008',
    districtId: '9414031',
    name: 'Menya',
  },
  {
    id: '9414031009',
    districtId: '9414031',
    name: 'Bagaram',
  },
  {
    id: '9414031010',
    districtId: '9414031',
    name: 'Sepoh',
  },
  {
    id: '9414031011',
    districtId: '9414031',
    name: 'Baitate',
  },
  {
    id: '9414031012',
    districtId: '9414031',
    name: 'Afogoma',
  },
  {
    id: '9414040001',
    districtId: '9414040',
    name: 'Pagai',
  },
  {
    id: '9414040003',
    districtId: '9414040',
    name: 'Arare',
  },
  {
    id: '9414040004',
    districtId: '9414040',
    name: 'Katage',
  },
  {
    id: '9414040005',
    districtId: '9414040',
    name: 'Yagatsu',
  },
  {
    id: '9414040006',
    districtId: '9414040',
    name: 'Sogophe',
  },
  {
    id: '9414040007',
    districtId: '9414040',
    name: 'Wiyage',
  },
  {
    id: '9414040008',
    districtId: '9414040',
    name: 'Tsemtaipim',
  },
  {
    id: '9414040009',
    districtId: '9414040',
    name: 'Amagatsu',
  },
  {
    id: '9414040010',
    districtId: '9414040',
    name: 'Atsipim',
  },
  {
    id: '9414040011',
    districtId: '9414040',
    name: 'Okor',
  },
  {
    id: '9414040012',
    districtId: '9414040',
    name: 'Warogom',
  },
  {
    id: '9414040013',
    districtId: '9414040',
    name: 'Gairipim',
  },
  {
    id: '9414040014',
    districtId: '9414040',
    name: 'Kaibusene',
  },
  {
    id: '9414040015',
    districtId: '9414040',
    name: 'Kasima',
  },
  {
    id: '9414040016',
    districtId: '9414040',
    name: 'Kaibu',
  },
  {
    id: '9414040017',
    districtId: '9414040',
    name: 'Amenda',
  },
  {
    id: '9414040018',
    districtId: '9414040',
    name: 'A M U R O',
  },
  {
    id: '9414040019',
    districtId: '9414040',
    name: 'Mani',
  },
  {
    id: '9414050001',
    districtId: '9414050',
    name: 'Sigare',
  },
  {
    id: '9414050002',
    districtId: '9414050',
    name: 'Kaitok',
  },
  {
    id: '9414050003',
    districtId: '9414050',
    name: 'Homang',
  },
  {
    id: '9414050004',
    districtId: '9414050',
    name: 'Jufo Kecil',
  },
  {
    id: '9414050005',
    districtId: '9414050',
    name: 'Eci',
  },
  {
    id: '9414050006',
    districtId: '9414050',
    name: 'Yame',
  },
  {
    id: '9414050007',
    districtId: '9414050',
    name: 'Aboge',
  },
  {
    id: '9414050008',
    districtId: '9414050',
    name: 'Kopi',
  },
  {
    id: '9414050009',
    districtId: '9414050',
    name: 'Isage',
  },
  {
    id: '9414050010',
    districtId: '9414050',
    name: 'Kiki',
  },
  {
    id: '9414050011',
    districtId: '9414050',
    name: 'Khabu',
  },
  {
    id: '9414050012',
    districtId: '9414050',
    name: 'Jufo Besar',
  },
  {
    id: '9414050014',
    districtId: '9414050',
    name: 'Asaren',
  },
  {
    id: '9414050015',
    districtId: '9414050',
    name: 'Chanani',
  },
  {
    id: '9414050016',
    districtId: '9414050',
    name: 'Girimio',
  },
  {
    id: '9414050017',
    districtId: '9414050',
    name: 'Haffo',
  },
  {
    id: '9414050018',
    districtId: '9414050',
    name: 'Meda',
  },
  {
    id: '9414060006',
    districtId: '9414060',
    name: 'Tamanim',
  },
  {
    id: '9414060007',
    districtId: '9414060',
    name: 'Senggo',
  },
  {
    id: '9414060010',
    districtId: '9414060',
    name: 'Abau',
  },
  {
    id: '9414060011',
    districtId: '9414060',
    name: 'Kumasma',
  },
  {
    id: '9414060012',
    districtId: '9414060',
    name: 'Womin',
  },
  {
    id: '9414060013',
    districtId: '9414060',
    name: 'Bidneu',
  },
  {
    id: '9414061001',
    districtId: '9414061',
    name: 'Fomu',
  },
  {
    id: '9414061002',
    districtId: '9414061',
    name: 'Tiau',
  },
  {
    id: '9414061003',
    districtId: '9414061',
    name: 'Binerbis',
  },
  {
    id: '9414061005',
    districtId: '9414061',
    name: 'Amasu',
  },
  {
    id: '9414061006',
    districtId: '9414061',
    name: 'Imembi',
  },
  {
    id: '9414061008',
    districtId: '9414061',
    name: 'Tayau',
  },
  {
    id: '9414062001',
    districtId: '9414062',
    name: 'Wonggi',
  },
  {
    id: '9414062002',
    districtId: '9414062',
    name: 'Busiri',
  },
  {
    id: '9414062003',
    districtId: '9414062',
    name: 'Keta',
  },
  {
    id: '9414062004',
    districtId: '9414062',
    name: 'Veta',
  },
  {
    id: '9414062005',
    districtId: '9414062',
    name: 'Honya',
  },
  {
    id: '9414062006',
    districtId: '9414062',
    name: 'Haku',
  },
  {
    id: '9414062007',
    districtId: '9414062',
    name: 'Samarukie',
  },
  {
    id: '9414062008',
    districtId: '9414062',
    name: 'Bifo',
  },
  {
    id: '9414063001',
    districtId: '9414063',
    name: 'Sagis',
  },
  {
    id: '9414063002',
    districtId: '9414063',
    name: 'Kumaban',
  },
  {
    id: '9414063003',
    districtId: '9414063',
    name: 'Tugumau',
  },
  {
    id: '9414063004',
    districtId: '9414063',
    name: 'Basman',
  },
  {
    id: '9414063005',
    districtId: '9414063',
    name: 'Merokima',
  },
  {
    id: '9414063007',
    districtId: '9414063',
    name: 'Pier',
  },
  {
    id: '9414063008',
    districtId: '9414063',
    name: 'Tarwa',
  },
  {
    id: '9415010020',
    districtId: '9415010',
    name: 'Sanapai',
  },
  {
    id: '9415010021',
    districtId: '9415010',
    name: 'Eseib',
  },
  {
    id: '9415010022',
    districtId: '9415010',
    name: 'Bawor',
  },
  {
    id: '9415010023',
    districtId: '9415010',
    name: 'Seramit',
  },
  {
    id: '9415010024',
    districtId: '9415010',
    name: 'Yagamit',
  },
  {
    id: '9415010025',
    districtId: '9415010',
    name: 'Yahui',
  },
  {
    id: '9415010026',
    districtId: '9415010',
    name: 'Kamur',
  },
  {
    id: '9415010027',
    districtId: '9415010',
    name: 'Hainam',
  },
  {
    id: '9415010040',
    districtId: '9415010',
    name: 'Sarmafo',
  },
  {
    id: '9415011001',
    districtId: '9415011',
    name: 'Kawem',
  },
  {
    id: '9415011002',
    districtId: '9415011',
    name: 'Airo Sapem',
  },
  {
    id: '9415011003',
    districtId: '9415011',
    name: 'Kaipom',
  },
  {
    id: '9415011004',
    districtId: '9415011',
    name: 'Hahare',
  },
  {
    id: '9415011005',
    districtId: '9415011',
    name: 'Aikut',
  },
  {
    id: '9415011006',
    districtId: '9415011',
    name: 'Senepit',
  },
  {
    id: '9415011007',
    districtId: '9415011',
    name: 'Sanem',
  },
  {
    id: '9415011008',
    districtId: '9415011',
    name: 'Sasime',
  },
  {
    id: '9415011009',
    districtId: '9415011',
    name: 'Wagasu',
  },
  {
    id: '9415011010',
    districtId: '9415011',
    name: 'Heiyaram',
  },
  {
    id: '9415012001',
    districtId: '9415012',
    name: 'Amkai',
  },
  {
    id: '9415012002',
    districtId: '9415012',
    name: 'Yamkap',
  },
  {
    id: '9415012003',
    districtId: '9415012',
    name: 'Amaru',
  },
  {
    id: '9415012004',
    districtId: '9415012',
    name: 'Amkum',
  },
  {
    id: '9415012005',
    districtId: '9415012',
    name: 'Erosaman',
  },
  {
    id: '9415012006',
    districtId: '9415012',
    name: 'Amagais',
  },
  {
    id: '9415013002',
    districtId: '9415013',
    name: 'Tareo',
  },
  {
    id: '9415013003',
    districtId: '9415013',
    name: 'Semendoro',
  },
  {
    id: '9415013004',
    districtId: '9415013',
    name: 'Saman',
  },
  {
    id: '9415013005',
    districtId: '9415013',
    name: 'Aworket',
  },
  {
    id: '9415013006',
    districtId: '9415013',
    name: 'Primapun',
  },
  {
    id: '9415013007',
    districtId: '9415013',
    name: 'Kairin',
  },
  {
    id: '9415013008',
    districtId: '9415013',
    name: 'Bayun',
  },
  {
    id: '9415013009',
    districtId: '9415013',
    name: 'Santambor',
  },
  {
    id: '9415013010',
    districtId: '9415013',
    name: 'Yaptambor',
  },
  {
    id: '9415013011',
    districtId: '9415013',
    name: 'Simsagar',
  },
  {
    id: '9415013012',
    districtId: '9415013',
    name: 'Itersok',
  },
  {
    id: '9415014001',
    districtId: '9415014',
    name: 'Sohomane',
  },
  {
    id: '9415014002',
    districtId: '9415014',
    name: 'Suagai',
  },
  {
    id: '9415014004',
    districtId: '9415014',
    name: 'Sagare',
  },
  {
    id: '9415014005',
    districtId: '9415014',
    name: 'Yefuwagi',
  },
  {
    id: '9415014006',
    districtId: '9415014',
    name: 'Wagi',
  },
  {
    id: '9415020001',
    districtId: '9415020',
    name: 'Basim',
  },
  {
    id: '9415020002',
    districtId: '9415020',
    name: 'Waras',
  },
  {
    id: '9415020003',
    districtId: '9415020',
    name: 'Ocenep',
  },
  {
    id: '9415020004',
    districtId: '9415020',
    name: 'Pirien',
  },
  {
    id: '9415020005',
    districtId: '9415020',
    name: 'Biopis',
  },
  {
    id: '9415020006',
    districtId: '9415020',
    name: 'Nanai (Nanay)',
  },
  {
    id: '9415020013',
    districtId: '9415020',
    name: 'Ais',
  },
  {
    id: '9415020014',
    districtId: '9415020',
    name: 'Yawas',
  },
  {
    id: '9415020015',
    districtId: '9415020',
    name: 'Kayarpis',
  },
  {
    id: '9415020016',
    districtId: '9415020',
    name: 'Bakyor',
  },
  {
    id: '9415020017',
    districtId: '9415020',
    name: 'Isar',
  },
  {
    id: '9415020018',
    districtId: '9415020',
    name: 'Sayoa',
  },
  {
    id: '9415020019',
    districtId: '9415020',
    name: 'Bora',
  },
  {
    id: '9415021001',
    districtId: '9415021',
    name: 'Piramat',
  },
  {
    id: '9415021002',
    districtId: '9415021',
    name: 'Bawos',
  },
  {
    id: '9415021003',
    districtId: '9415021',
    name: 'Bagair',
  },
  {
    id: '9415021004',
    districtId: '9415021',
    name: 'Tauro',
  },
  {
    id: '9415021005',
    districtId: '9415021',
    name: 'Kagas',
  },
  {
    id: '9415021006',
    districtId: '9415021',
    name: 'Wiyar',
  },
  {
    id: '9415021007',
    districtId: '9415021',
    name: 'Amaita',
  },
  {
    id: '9415021008',
    districtId: '9415021',
    name: 'Akan Tapak',
  },
  {
    id: '9415021009',
    districtId: '9415021',
    name: 'Mapane',
  },
  {
    id: '9415021010',
    districtId: '9415021',
    name: 'Ainamsato',
  },
  {
    id: '9415030006',
    districtId: '9415030',
    name: 'Ambisu',
  },
  {
    id: '9415030010',
    districtId: '9415030',
    name: 'Yasiu/Yaisu',
  },
  {
    id: '9415030011',
    districtId: '9415030',
    name: 'Atsy',
  },
  {
    id: '9415030012',
    districtId: '9415030',
    name: 'Amanamkai',
  },
  {
    id: '9415030013',
    districtId: '9415030',
    name: 'Bipim',
  },
  {
    id: '9415030014',
    districtId: '9415030',
    name: 'Bine',
  },
  {
    id: '9415030015',
    districtId: '9415030',
    name: 'Sogoni',
  },
  {
    id: '9415030024',
    districtId: '9415030',
    name: 'Bakasei',
  },
  {
    id: '9415030028',
    districtId: '9415030',
    name: 'Cewewyamew',
  },
  {
    id: '9415031001',
    districtId: '9415031',
    name: 'Waganu',
  },
  {
    id: '9415031002',
    districtId: '9415031',
    name: 'Fos',
  },
  {
    id: '9415031003',
    districtId: '9415031',
    name: 'Awok',
  },
  {
    id: '9415031004',
    districtId: '9415031',
    name: 'Kaimo',
  },
  {
    id: '9415031005',
    districtId: '9415031',
    name: 'Yausakor',
  },
  {
    id: '9415031006',
    districtId: '9415031',
    name: 'Damen',
  },
  {
    id: '9415031007',
    districtId: '9415031',
    name: 'Biwar Darat',
  },
  {
    id: '9415031008',
    districtId: '9415031',
    name: 'Sakor',
  },
  {
    id: '9415032003',
    districtId: '9415032',
    name: 'Comoro',
  },
  {
    id: '9415032005',
    districtId: '9415032',
    name: 'Kawet',
  },
  {
    id: '9415032006',
    districtId: '9415032',
    name: 'Mausi',
  },
  {
    id: '9415033001',
    districtId: '9415033',
    name: 'Omanasep',
  },
  {
    id: '9415033002',
    districtId: '9415033',
    name: 'Warkai',
  },
  {
    id: '9415033003',
    districtId: '9415033',
    name: 'You',
  },
  {
    id: '9415033004',
    districtId: '9415033',
    name: 'Biwar Laut',
  },
  {
    id: '9415033005',
    districtId: '9415033',
    name: 'Atambuts',
  },
  {
    id: '9415033007',
    districtId: '9415033',
    name: 'Pirpis',
  },
  {
    id: '9415040001',
    districtId: '9415040',
    name: 'Jinak',
  },
  {
    id: '9415040002',
    districtId: '9415040',
    name: 'Wowi',
  },
  {
    id: '9415040007',
    districtId: '9415040',
    name: 'Karbis',
  },
  {
    id: '9415040008',
    districtId: '9415040',
    name: 'Bubis',
  },
  {
    id: '9415040009',
    districtId: '9415040',
    name: 'Binam',
  },
  {
    id: '9415040010',
    districtId: '9415040',
    name: 'Burbis',
  },
  {
    id: '9415040011',
    districtId: '9415040',
    name: 'Waganu Dua',
  },
  {
    id: '9415040014',
    districtId: '9415040',
    name: 'Sorai',
  },
  {
    id: '9415040015',
    districtId: '9415040',
    name: 'Wagabus',
  },
  {
    id: '9415040016',
    districtId: '9415040',
    name: 'Emnam',
  },
  {
    id: '9415041001',
    districtId: '9415041',
    name: 'Binamzain',
  },
  {
    id: '9415041002',
    districtId: '9415041',
    name: 'Pirabanak',
  },
  {
    id: '9415041003',
    districtId: '9415041',
    name: 'Woutu Braza',
  },
  {
    id: '9415041004',
    districtId: '9415041',
    name: 'Patippi',
  },
  {
    id: '9415041005',
    districtId: '9415041',
    name: 'Woutu Kolof',
  },
  {
    id: '9415041006',
    districtId: '9415041',
    name: 'Sipanap',
  },
  {
    id: '9415041007',
    districtId: '9415041',
    name: 'Pepera',
  },
  {
    id: '9415041008',
    districtId: '9415041',
    name: 'Ulakin',
  },
  {
    id: '9415041009',
    districtId: '9415041',
    name: 'Waijens',
  },
  {
    id: '9415041010',
    districtId: '9415041',
    name: 'Butukatnau',
  },
  {
    id: '9415041011',
    districtId: '9415041',
    name: 'Auban',
  },
  {
    id: '9415041019',
    districtId: '9415041',
    name: 'Kapayap I',
  },
  {
    id: '9415041020',
    districtId: '9415041',
    name: 'Kapayap II',
  },
  {
    id: '9415042001',
    districtId: '9415042',
    name: 'Daikot',
  },
  {
    id: '9415042002',
    districtId: '9415042',
    name: 'Somnak',
  },
  {
    id: '9415042003',
    districtId: '9415042',
    name: 'Dekamer',
  },
  {
    id: '9415042004',
    districtId: '9415042',
    name: 'Vakam',
  },
  {
    id: '9415042005',
    districtId: '9415042',
    name: 'Wabak',
  },
  {
    id: '9415042006',
    districtId: '9415042',
    name: 'Vakam Dua',
  },
  {
    id: '9415042007',
    districtId: '9415042',
    name: 'Bor',
  },
  {
    id: '9415043001',
    districtId: '9415043',
    name: 'Mabul',
  },
  {
    id: '9415043002',
    districtId: '9415043',
    name: 'Ayak',
  },
  {
    id: '9415043003',
    districtId: '9415043',
    name: 'Banum',
  },
  {
    id: '9415043004',
    districtId: '9415043',
    name: 'Ujung Batu',
  },
  {
    id: '9415043005',
    districtId: '9415043',
    name: 'Nagatun',
  },
  {
    id: '9415043006',
    districtId: '9415043',
    name: 'Amakot',
  },
  {
    id: '9415043007',
    districtId: '9415043',
    name: 'Kapayap III',
  },
  {
    id: '9415050005',
    districtId: '9415050',
    name: 'Ayam / Akat',
  },
  {
    id: '9415050006',
    districtId: '9415050',
    name: 'Manep',
  },
  {
    id: '9415050007',
    districtId: '9415050',
    name: 'Beco',
  },
  {
    id: '9415050008',
    districtId: '9415050',
    name: 'Yuni',
  },
  {
    id: '9415050009',
    districtId: '9415050',
    name: 'Betkuar',
  },
  {
    id: '9415050013',
    districtId: '9415050',
    name: 'Waw Cesaw',
  },
  {
    id: '9415050014',
    districtId: '9415050',
    name: 'Bayiw Pinam',
  },
  {
    id: '9415050016',
    districtId: '9415050',
    name: 'Jewes Doar',
  },
  {
    id: '9415050018',
    districtId: '9415050',
    name: 'Fakan',
  },
  {
    id: '9415050019',
    districtId: '9415050',
    name: 'Simini',
  },
  {
    id: '9415051001',
    districtId: '9415051',
    name: 'Sesakam',
  },
  {
    id: '9415051002',
    districtId: '9415051',
    name: 'Amborep',
  },
  {
    id: '9415051004',
    districtId: '9415051',
    name: 'Pau',
  },
  {
    id: '9415051005',
    districtId: '9415051',
    name: 'Akamar',
  },
  {
    id: '9415051006',
    districtId: '9415051',
    name: 'Birak',
  },
  {
    id: '9415051007',
    districtId: '9415051',
    name: 'Katew',
  },
  {
    id: '9415051008',
    districtId: '9415051',
    name: 'Dawer',
  },
  {
    id: '9415060001',
    districtId: '9415060',
    name: 'Beriten',
  },
  {
    id: '9415060004',
    districtId: '9415060',
    name: 'Yomoth',
  },
  {
    id: '9415060005',
    districtId: '9415060',
    name: 'Asuwetsy',
  },
  {
    id: '9415060006',
    districtId: '9415060',
    name: 'Bis Agats',
  },
  {
    id: '9415060007',
    districtId: '9415060',
    name: 'Bismam',
  },
  {
    id: '9415060010',
    districtId: '9415060',
    name: 'Mbait',
  },
  {
    id: '9415060011',
    districtId: '9415060',
    name: 'Bou',
  },
  {
    id: '9415060012',
    districtId: '9415060',
    name: 'Kaye',
  },
  {
    id: '9415060014',
    districtId: '9415060',
    name: 'Saw',
  },
  {
    id: '9415070003',
    districtId: '9415070',
    name: 'Erma',
  },
  {
    id: '9415070004',
    districtId: '9415070',
    name: 'Sona',
  },
  {
    id: '9415070015',
    districtId: '9415070',
    name: 'Sawa',
  },
  {
    id: '9415070025',
    districtId: '9415070',
    name: 'Pupis',
  },
  {
    id: '9415070026',
    districtId: '9415070',
    name: 'Agani',
  },
  {
    id: '9415070029',
    districtId: '9415070',
    name: 'Sauti',
  },
  {
    id: '9415070032',
    districtId: '9415070',
    name: 'Mumugu II',
  },
  {
    id: '9415071001',
    districtId: '9415071',
    name: 'Tomor',
  },
  {
    id: '9415071002',
    districtId: '9415071',
    name: 'Jifak',
  },
  {
    id: '9415071003',
    districtId: '9415071',
    name: 'Tii',
  },
  {
    id: '9415071004',
    districtId: '9415071',
    name: 'Sagapu',
  },
  {
    id: '9415071005',
    districtId: '9415071',
    name: 'Jesenko',
  },
  {
    id: '9415071006',
    districtId: '9415071',
    name: 'Koba',
  },
  {
    id: '9415071009',
    districtId: '9415071',
    name: 'Dumaten',
  },
  {
    id: '9415071010',
    districtId: '9415071',
    name: 'Hom-Hom',
  },
  {
    id: '9415071011',
    districtId: '9415071',
    name: 'Ajin',
  },
  {
    id: '9415071012',
    districtId: '9415071',
    name: 'Korobuk',
  },
  {
    id: '9415071013',
    districtId: '9415071',
    name: 'Katalina',
  },
  {
    id: '9415071014',
    districtId: '9415071',
    name: 'Obio',
  },
  {
    id: '9415071015',
    districtId: '9415071',
    name: 'Salbik',
  },
  {
    id: '9415071016',
    districtId: '9415071',
    name: 'Linduk',
  },
  {
    id: '9415071017',
    districtId: '9415071',
    name: 'Besika',
  },
  {
    id: '9415071018',
    districtId: '9415071',
    name: 'Laluk',
  },
  {
    id: '9415071019',
    districtId: '9415071',
    name: 'Kebikduk',
  },
  {
    id: '9415071020',
    districtId: '9415071',
    name: 'Hulam',
  },
  {
    id: '9415071021',
    districtId: '9415071',
    name: 'Walase',
  },
  {
    id: '9415071022',
    districtId: '9415071',
    name: 'Berimono',
  },
  {
    id: '9415071023',
    districtId: '9415071',
    name: 'Asgun',
  },
  {
    id: '9415072001',
    districtId: '9415072',
    name: 'Komor',
  },
  {
    id: '9415072002',
    districtId: '9415072',
    name: 'Warer',
  },
  {
    id: '9415072003',
    districtId: '9415072',
    name: 'Ayir',
  },
  {
    id: '9415072004',
    districtId: '9415072',
    name: 'Paar',
  },
  {
    id: '9415072005',
    districtId: '9415072',
    name: 'Amor',
  },
  {
    id: '9415072006',
    districtId: '9415072',
    name: 'Berip',
  },
  {
    id: '9415072007',
    districtId: '9415072',
    name: 'Jipawer',
  },
  {
    id: '9415072009',
    districtId: '9415072',
    name: 'Abamu',
  },
  {
    id: '9415073001',
    districtId: '9415073',
    name: 'Yeni',
  },
  {
    id: '9415073002',
    districtId: '9415073',
    name: 'Yamas',
  },
  {
    id: '9415073003',
    districtId: '9415073',
    name: 'Omor',
  },
  {
    id: '9415073004',
    districtId: '9415073',
    name: 'Onavai',
  },
  {
    id: '9415073005',
    districtId: '9415073',
    name: 'Yufri',
  },
  {
    id: '9415073006',
    districtId: '9415073',
    name: 'Yaun',
  },
  {
    id: '9415074001',
    districtId: '9415074',
    name: 'Weo',
  },
  {
    id: '9415074002',
    districtId: '9415074',
    name: 'As',
  },
  {
    id: '9415074003',
    districtId: '9415074',
    name: 'Atat',
  },
  {
    id: '9415074004',
    districtId: '9415074',
    name: 'Kapi',
  },
  {
    id: '9415074005',
    districtId: '9415074',
    name: 'Nakai',
  },
  {
    id: '9415074006',
    districtId: '9415074',
    name: 'Aou',
  },
  {
    id: '9415074007',
    districtId: '9415074',
    name: 'Esmapan',
  },
  {
    id: '9415074008',
    districtId: '9415074',
    name: 'Eroko',
  },
  {
    id: '9415074009',
    districtId: '9415074',
    name: 'Yakapis',
  },
  {
    id: '9415074010',
    districtId: '9415074',
    name: 'Fumeiripits',
  },
  {
    id: '9415074011',
    districtId: '9415074',
    name: 'Aoap',
  },
  {
    id: '9416010025',
    districtId: '9416010',
    name: 'Ibiroma',
  },
  {
    id: '9416010026',
    districtId: '9416010',
    name: 'Wanem',
  },
  {
    id: '9416010027',
    districtId: '9416010',
    name: 'Anjelma',
  },
  {
    id: '9416010028',
    districtId: '9416010',
    name: 'Obolma',
  },
  {
    id: '9416010029',
    districtId: '9416010',
    name: 'Hihundes',
  },
  {
    id: '9416010038',
    districtId: '9416010',
    name: 'Kilise',
  },
  {
    id: '9416010039',
    districtId: '9416010',
    name: 'Kima',
  },
  {
    id: '9416010040',
    districtId: '9416010',
    name: 'Luhulema',
  },
  {
    id: '9416010041',
    districtId: '9416010',
    name: 'Yagarelo',
  },
  {
    id: '9416010042',
    districtId: '9416010',
    name: 'Wulik Punua',
  },
  {
    id: '9416010043',
    districtId: '9416010',
    name: 'Esalien',
  },
  {
    id: '9416010044',
    districtId: '9416010',
    name: 'Tukuarek',
  },
  {
    id: '9416010045',
    districtId: '9416010',
    name: 'Lotia/Huglot',
  },
  {
    id: '9416010046',
    districtId: '9416010',
    name: 'Pusuaga',
  },
  {
    id: '9416010047',
    districtId: '9416010',
    name: 'Soroh',
  },
  {
    id: '9416010048',
    districtId: '9416010',
    name: 'Eroma',
  },
  {
    id: '9416010049',
    districtId: '9416010',
    name: 'Air Garam',
  },
  {
    id: '9416010050',
    districtId: '9416010',
    name: 'Wuluagaima',
  },
  {
    id: '9416010052',
    districtId: '9416010',
    name: 'Huguma',
  },
  {
    id: '9416010053',
    districtId: '9416010',
    name: 'Parela',
  },
  {
    id: '9416010054',
    districtId: '9416010',
    name: 'Hesmat',
  },
  {
    id: '9416011001',
    districtId: '9416011',
    name: 'Lidipmu',
  },
  {
    id: '9416011002',
    districtId: '9416011',
    name: 'Usaregeik',
  },
  {
    id: '9416011004',
    districtId: '9416011',
    name: 'Hendikma',
  },
  {
    id: '9416011006',
    districtId: '9416011',
    name: 'Dekbok',
  },
  {
    id: '9416011007',
    districtId: '9416011',
    name: 'Weleheikma',
  },
  {
    id: '9416011008',
    districtId: '9416011',
    name: 'Haletuk',
  },
  {
    id: '9416011009',
    districtId: '9416011',
    name: 'Yeriko',
  },
  {
    id: '9416011010',
    districtId: '9416011',
    name: 'Esaikma',
  },
  {
    id: '9416013001',
    districtId: '9416013',
    name: 'Dekai',
  },
  {
    id: '9416013002',
    districtId: '9416013',
    name: 'Kuaserama',
  },
  {
    id: '9416013003',
    districtId: '9416013',
    name: 'Moruku',
  },
  {
    id: '9416013004',
    districtId: '9416013',
    name: 'Massi',
  },
  {
    id: '9416013005',
    districtId: '9416013',
    name: 'Keikey',
  },
  {
    id: '9416013006',
    districtId: '9416013',
    name: 'Kuari',
  },
  {
    id: '9416013007',
    districtId: '9416013',
    name: 'Muara',
  },
  {
    id: '9416013008',
    districtId: '9416013',
    name: 'Kiribun',
  },
  {
    id: '9416013009',
    districtId: '9416013',
    name: 'Kokamu',
  },
  {
    id: '9416013010',
    districtId: '9416013',
    name: 'Tomon I',
  },
  {
    id: '9416013011',
    districtId: '9416013',
    name: 'Sokamu',
  },
  {
    id: '9416013012',
    districtId: '9416013',
    name: 'Tomon II',
  },
  {
    id: '9416014002',
    districtId: '9416014',
    name: 'Obio',
  },
  {
    id: '9416014004',
    districtId: '9416014',
    name: 'Ujin',
  },
  {
    id: '9416014005',
    districtId: '9416014',
    name: 'Yahufa',
  },
  {
    id: '9416014006',
    districtId: '9416014',
    name: 'Jibak',
  },
  {
    id: '9416014007',
    districtId: '9416014',
    name: 'Patin',
  },
  {
    id: '9416014008',
    districtId: '9416014',
    name: 'Hom Hom',
  },
  {
    id: '9416014009',
    districtId: '9416014',
    name: 'Wendame',
  },
  {
    id: '9416014010',
    districtId: '9416014',
    name: 'Kwakenoro',
  },
  {
    id: '9416014011',
    districtId: '9416014',
    name: 'Busupa',
  },
  {
    id: '9416014012',
    districtId: '9416014',
    name: 'Yagabo',
  },
  {
    id: '9416014013',
    districtId: '9416014',
    name: 'Penigik',
  },
  {
    id: '9416015001',
    districtId: '9416015',
    name: 'Pasema',
  },
  {
    id: '9416015002',
    districtId: '9416015',
    name: 'Leinoko',
  },
  {
    id: '9416015003',
    districtId: '9416015',
    name: 'Lowet',
  },
  {
    id: '9416015004',
    districtId: '9416015',
    name: 'Wea',
  },
  {
    id: '9416015005',
    districtId: '9416015',
    name: 'Sengangge',
  },
  {
    id: '9416015006',
    districtId: '9416015',
    name: 'Wulin',
  },
  {
    id: '9416015007',
    districtId: '9416015',
    name: 'Pupi',
  },
  {
    id: '9416016001',
    districtId: '9416016',
    name: 'Amuma',
  },
  {
    id: '9416016002',
    districtId: '9416016',
    name: 'Tolikapura',
  },
  {
    id: '9416016003',
    districtId: '9416016',
    name: 'Sarmuge',
  },
  {
    id: '9416016004',
    districtId: '9416016',
    name: 'Wisikma',
  },
  {
    id: '9416016005',
    districtId: '9416016',
    name: 'Balum Erang',
  },
  {
    id: '9416016006',
    districtId: '9416016',
    name: 'Golowen',
  },
  {
    id: '9416016007',
    districtId: '9416016',
    name: 'Orugai',
  },
  {
    id: '9416016008',
    districtId: '9416016',
    name: 'Sagasal',
  },
  {
    id: '9416016009',
    districtId: '9416016',
    name: 'Silorin',
  },
  {
    id: '9416016010',
    districtId: '9416016',
    name: 'Waeklek',
  },
  {
    id: '9416016011',
    districtId: '9416016',
    name: 'Plau',
  },
  {
    id: '9416016012',
    districtId: '9416016',
    name: 'Harapan',
  },
  {
    id: '9416016013',
    districtId: '9416016',
    name: 'Kinika',
  },
  {
    id: '9416017003',
    districtId: '9416017',
    name: 'Gopa',
  },
  {
    id: '9416017004',
    districtId: '9416017',
    name: 'Til',
  },
  {
    id: '9416017005',
    districtId: '9416017',
    name: 'Jifak',
  },
  {
    id: '9416017006',
    districtId: '9416017',
    name: 'Jinusugu',
  },
  {
    id: '9416017007',
    districtId: '9416017',
    name: 'Sagaput',
  },
  {
    id: '9416017008',
    districtId: '9416017',
    name: 'Tomor',
  },
  {
    id: '9416017009',
    districtId: '9416017',
    name: 'Woropi',
  },
  {
    id: '9416017010',
    districtId: '9416017',
    name: 'Senipan',
  },
  {
    id: '9416017011',
    districtId: '9416017',
    name: 'Yosua',
  },
  {
    id: '9416017012',
    districtId: '9416017',
    name: 'Rentis',
  },
  {
    id: '9416017013',
    districtId: '9416017',
    name: 'Solok',
  },
  {
    id: '9416018001',
    districtId: '9416018',
    name: 'Sabin',
  },
  {
    id: '9416018002',
    districtId: '9416018',
    name: 'Apdagma',
  },
  {
    id: '9416018003',
    districtId: '9416018',
    name: 'Mugi',
  },
  {
    id: '9416018004',
    districtId: '9416018',
    name: 'Harap',
  },
  {
    id: '9416018005',
    districtId: '9416018',
    name: 'Suok',
  },
  {
    id: '9416018007',
    districtId: '9416018',
    name: 'Kolodoma',
  },
  {
    id: '9416018008',
    districtId: '9416018',
    name: 'Sangatur',
  },
  {
    id: '9416018009',
    districtId: '9416018',
    name: 'Sowaling',
  },
  {
    id: '9416018010',
    districtId: '9416018',
    name: 'Yerekama',
  },
  {
    id: '9416018011',
    districtId: '9416018',
    name: 'Walkuna',
  },
  {
    id: '9416019001',
    districtId: '9416019',
    name: 'Momnowak',
  },
  {
    id: '9416019002',
    districtId: '9416019',
    name: 'Eksa',
  },
  {
    id: '9416019003',
    districtId: '9416019',
    name: 'Silimo',
  },
  {
    id: '9416019004',
    districtId: '9416019',
    name: 'Siloma',
  },
  {
    id: '9416019005',
    districtId: '9416019',
    name: 'Walkruk',
  },
  {
    id: '9416019006',
    districtId: '9416019',
    name: 'Sodule',
  },
  {
    id: '9416019007',
    districtId: '9416019',
    name: 'Sagaduk',
  },
  {
    id: '9416019008',
    districtId: '9416019',
    name: 'Asia',
  },
  {
    id: '9416019010',
    districtId: '9416019',
    name: 'Nekilei',
  },
  {
    id: '9416019011',
    districtId: '9416019',
    name: 'Suok',
  },
  {
    id: '9416019012',
    districtId: '9416019',
    name: 'Sianele',
  },
  {
    id: '9416019013',
    districtId: '9416019',
    name: 'Eremnahom',
  },
  {
    id: '9416019014',
    districtId: '9416019',
    name: 'Silon',
  },
  {
    id: '9416019015',
    districtId: '9416019',
    name: 'Fabe',
  },
  {
    id: '9416019016',
    districtId: '9416019',
    name: 'Weakma',
  },
  {
    id: '9416019017',
    districtId: '9416019',
    name: 'Pinda',
  },
  {
    id: '9416019018',
    districtId: '9416019',
    name: 'Hwesalome',
  },
  {
    id: '9416019019',
    districtId: '9416019',
    name: 'Sebin',
  },
  {
    id: '9416019020',
    districtId: '9416019',
    name: 'Wubialo',
  },
  {
    id: '9416020004',
    districtId: '9416020',
    name: 'Liligan',
  },
  {
    id: '9416020005',
    districtId: '9416020',
    name: 'Ninia',
  },
  {
    id: '9416020013',
    districtId: '9416020',
    name: 'Liligan 2',
  },
  {
    id: '9416020022',
    districtId: '9416020',
    name: 'Niniahan',
  },
  {
    id: '9416020023',
    districtId: '9416020',
    name: 'Sohwal',
  },
  {
    id: '9416020024',
    districtId: '9416020',
    name: 'Waerek',
  },
  {
    id: '9416020025',
    districtId: '9416020',
    name: 'Wahaik',
  },
  {
    id: '9416020026',
    districtId: '9416020',
    name: 'Hwealoma',
  },
  {
    id: '9416020027',
    districtId: '9416020',
    name: 'Babet',
  },
  {
    id: '9416020028',
    districtId: '9416020',
    name: 'Kahul',
  },
  {
    id: '9416021001',
    districtId: '9416021',
    name: 'Holuwon',
  },
  {
    id: '9416021003',
    districtId: '9416021',
    name: 'Weni',
  },
  {
    id: '9416021004',
    districtId: '9416021',
    name: 'Sosi',
  },
  {
    id: '9416021005',
    districtId: '9416021',
    name: 'Sia',
  },
  {
    id: '9416021006',
    districtId: '9416021',
    name: 'Bineleruk',
  },
  {
    id: '9416021007',
    districtId: '9416021',
    name: 'Sohonggik',
  },
  {
    id: '9416021008',
    districtId: '9416021',
    name: 'Danggema',
  },
  {
    id: '9416022001',
    districtId: '9416022',
    name: 'Wanim',
  },
  {
    id: '9416022002',
    districtId: '9416022',
    name: 'Lolat',
  },
  {
    id: '9416022004',
    districtId: '9416022',
    name: 'Serahak',
  },
  {
    id: '9416022005',
    districtId: '9416022',
    name: 'Webile',
  },
  {
    id: '9416022006',
    districtId: '9416022',
    name: 'Dinggila',
  },
  {
    id: '9416022007',
    districtId: '9416022',
    name: 'Esalek',
  },
  {
    id: '9416022008',
    districtId: '9416022',
    name: 'Denema',
  },
  {
    id: '9416023001',
    districtId: '9416023',
    name: 'Langda',
  },
  {
    id: '9416023002',
    districtId: '9416023',
    name: 'Alirji',
  },
  {
    id: '9416023003',
    districtId: '9416023',
    name: 'Laryi',
  },
  {
    id: '9416023004',
    districtId: '9416023',
    name: 'Kap-Kap/Kikmai',
  },
  {
    id: '9416023005',
    districtId: '9416023',
    name: 'Yalar',
  },
  {
    id: '9416023006',
    districtId: '9416023',
    name: 'Wasumurji',
  },
  {
    id: '9416023007',
    districtId: '9416023',
    name: 'Kirabuk',
  },
  {
    id: '9416024001',
    districtId: '9416024',
    name: 'Bomela',
  },
  {
    id: '9416024002',
    districtId: '9416024',
    name: 'Yalmabi',
  },
  {
    id: '9416024003',
    districtId: '9416024',
    name: 'Kitikni',
  },
  {
    id: '9416024004',
    districtId: '9416024',
    name: 'Palamdua',
  },
  {
    id: '9416024005',
    districtId: '9416024',
    name: 'Sombat',
  },
  {
    id: '9416024006',
    districtId: '9416024',
    name: 'Kubialat',
  },
  {
    id: '9416025001',
    districtId: '9416025',
    name: 'Tapasik',
  },
  {
    id: '9416025002',
    districtId: '9416025',
    name: 'Suntamon',
  },
  {
    id: '9416025003',
    districtId: '9416025',
    name: 'Dirik',
  },
  {
    id: '9416025004',
    districtId: '9416025',
    name: 'Masumkon',
  },
  {
    id: '9416025005',
    districtId: '9416025',
    name: 'Binalkon',
  },
  {
    id: '9416025008',
    districtId: '9416025',
    name: 'Bongkok',
  },
  {
    id: '9416026001',
    districtId: '9416026',
    name: 'Yalisomon',
  },
  {
    id: '9416026002',
    districtId: '9416026',
    name: 'Yabi',
  },
  {
    id: '9416026003',
    districtId: '9416026',
    name: 'Hamik',
  },
  {
    id: '9416026004',
    districtId: '9416026',
    name: 'Kulahaik',
  },
  {
    id: '9416026005',
    districtId: '9416026',
    name: 'Sobaham',
  },
  {
    id: '9416026006',
    districtId: '9416026',
    name: 'Balinggama',
  },
  {
    id: '9416026007',
    districtId: '9416026',
    name: 'Dohong',
  },
  {
    id: '9416026008',
    districtId: '9416026',
    name: 'Simbuk',
  },
  {
    id: '9416026009',
    districtId: '9416026',
    name: 'Puahun',
  },
  {
    id: '9416026010',
    districtId: '9416026',
    name: 'Silak Pahabol',
  },
  {
    id: '9416026012',
    districtId: '9416026',
    name: 'Benembia',
  },
  {
    id: '9416026013',
    districtId: '9416026',
    name: 'Hubik',
  },
  {
    id: '9416027001',
    districtId: '9416027',
    name: 'Korupun',
  },
  {
    id: '9416027002',
    districtId: '9416027',
    name: 'Dagi',
  },
  {
    id: '9416027004',
    districtId: '9416027',
    name: 'Wemin',
  },
  {
    id: '9416027005',
    districtId: '9416027',
    name: 'Morome',
  },
  {
    id: '9416027007',
    districtId: '9416027',
    name: 'Moo',
  },
  {
    id: '9416027008',
    districtId: '9416027',
    name: 'Batkuk',
  },
  {
    id: '9416027009',
    districtId: '9416027',
    name: 'Maldua',
  },
  {
    id: '9416027010',
    districtId: '9416027',
    name: 'Amdua',
  },
  {
    id: '9416027011',
    districtId: '9416027',
    name: 'Somsek',
  },
  {
    id: '9416027012',
    districtId: '9416027',
    name: 'Basal',
  },
  {
    id: '9416027013',
    districtId: '9416027',
    name: 'Yamdua',
  },
  {
    id: '9416027014',
    districtId: '9416027',
    name: 'Dildau',
  },
  {
    id: '9416028001',
    districtId: '9416028',
    name: 'Sela',
  },
  {
    id: '9416028002',
    districtId: '9416028',
    name: 'Megom',
  },
  {
    id: '9416028003',
    districtId: '9416028',
    name: 'Mondon',
  },
  {
    id: '9416028004',
    districtId: '9416028',
    name: 'Orisin',
  },
  {
    id: '9416028005',
    districtId: '9416028',
    name: 'Monamna',
  },
  {
    id: '9416028007',
    districtId: '9416028',
    name: 'Phoy',
  },
  {
    id: '9416028008',
    districtId: '9416028',
    name: 'Horoman',
  },
  {
    id: '9416028009',
    districtId: '9416028',
    name: 'Makero',
  },
  {
    id: '9416028010',
    districtId: '9416028',
    name: 'Dolbol',
  },
  {
    id: '9416028011',
    districtId: '9416028',
    name: 'Hemuka',
  },
  {
    id: '9416028012',
    districtId: '9416028',
    name: 'Sulda',
  },
  {
    id: '9416028013',
    districtId: '9416028',
    name: 'Mekdua',
  },
  {
    id: '9416028014',
    districtId: '9416028',
    name: 'Bera',
  },
  {
    id: '9416028015',
    districtId: '9416028',
    name: 'Holdomen',
  },
  {
    id: '9416028016',
    districtId: '9416028',
    name: 'Asok',
  },
  {
    id: '9416029001',
    districtId: '9416029',
    name: 'Debula',
  },
  {
    id: '9416029002',
    districtId: '9416029',
    name: 'Kubuk Dua',
  },
  {
    id: '9416029003',
    districtId: '9416029',
    name: 'Baluk',
  },
  {
    id: '9416029004',
    districtId: '9416029',
    name: 'Kemligin',
  },
  {
    id: '9416029005',
    districtId: '9416029',
    name: 'Kwelamdua',
  },
  {
    id: '9416029006',
    districtId: '9416029',
    name: 'Senayom',
  },
  {
    id: '9416029008',
    districtId: '9416029',
    name: 'Obis',
  },
  {
    id: '9416029009',
    districtId: '9416029',
    name: 'Yalidomon',
  },
  {
    id: '9416029010',
    districtId: '9416029',
    name: 'Kabulan',
  },
  {
    id: '9416030011',
    districtId: '9416030',
    name: 'Yaholikma',
  },
  {
    id: '9416030021',
    districtId: '9416030',
    name: 'Lelambo',
  },
  {
    id: '9416030034',
    districtId: '9416030',
    name: 'Tulpa',
  },
  {
    id: '9416030035',
    districtId: '9416030',
    name: 'Ilwap',
  },
  {
    id: '9416030036',
    districtId: '9416030',
    name: 'Kiltam',
  },
  {
    id: '9416030037',
    districtId: '9416030',
    name: 'Pilong',
  },
  {
    id: '9416030038',
    districtId: '9416030',
    name: 'Vuno',
  },
  {
    id: '9416030039',
    districtId: '9416030',
    name: 'Suahai',
  },
  {
    id: '9416030040',
    districtId: '9416030',
    name: 'Tohong',
  },
  {
    id: '9416030041',
    districtId: '9416030',
    name: 'Hohe',
  },
  {
    id: '9416030042',
    districtId: '9416030',
    name: 'Letin',
  },
  {
    id: '9416030043',
    districtId: '9416030',
    name: 'Paliptek',
  },
  {
    id: '9416031001',
    districtId: '9416031',
    name: 'Pontenikma',
  },
  {
    id: '9416031002',
    districtId: '9416031',
    name: 'Kuni',
  },
  {
    id: '9416031003',
    districtId: '9416031',
    name: 'Panggema',
  },
  {
    id: '9416031004',
    districtId: '9416031',
    name: 'Homtonggo',
  },
  {
    id: '9416031005',
    districtId: '9416031',
    name: 'Tukam',
  },
  {
    id: '9416031006',
    districtId: '9416031',
    name: 'Yangkali',
  },
  {
    id: '9416031007',
    districtId: '9416031',
    name: 'Weresili',
  },
  {
    id: '9416031009',
    districtId: '9416031',
    name: 'Kolu',
  },
  {
    id: '9416031010',
    districtId: '9416031',
    name: 'Binteluk',
  },
  {
    id: '9416031011',
    districtId: '9416031',
    name: 'Kemumanggen',
  },
  {
    id: '9416031012',
    districtId: '9416031',
    name: 'Tonggoi',
  },
  {
    id: '9416031013',
    districtId: '9416031',
    name: 'Masahan',
  },
  {
    id: '9416032001',
    districtId: '9416032',
    name: 'Walma',
  },
  {
    id: '9416032002',
    districtId: '9416032',
    name: 'Solinggul',
  },
  {
    id: '9416032003',
    districtId: '9416032',
    name: 'Hontulun',
  },
  {
    id: '9416032004',
    districtId: '9416032',
    name: 'Honggolek',
  },
  {
    id: '9416032005',
    districtId: '9416032',
    name: 'Weri',
  },
  {
    id: '9416032007',
    districtId: '9416032',
    name: 'Wewasi',
  },
  {
    id: '9416033001',
    districtId: '9416033',
    name: 'Nahomas',
  },
  {
    id: '9416033002',
    districtId: '9416033',
    name: 'Kosarek',
  },
  {
    id: '9416033003',
    districtId: '9416033',
    name: 'Silkom',
  },
  {
    id: '9416033004',
    districtId: '9416033',
    name: 'Mine',
  },
  {
    id: '9416033005',
    districtId: '9416033',
    name: 'Uldam',
  },
  {
    id: '9416033006',
    districtId: '9416033',
    name: 'Tiple',
  },
  {
    id: '9416033007',
    districtId: '9416033',
    name: 'Wahe',
  },
  {
    id: '9416033008',
    districtId: '9416033',
    name: 'Hombuka',
  },
  {
    id: '9416033009',
    districtId: '9416033',
    name: 'Wesaltek',
  },
  {
    id: '9416033010',
    districtId: '9416033',
    name: 'Konosa',
  },
  {
    id: '9416033011',
    districtId: '9416033',
    name: 'Illion',
  },
  {
    id: '9416034001',
    districtId: '9416034',
    name: 'Saruk',
  },
  {
    id: '9416034002',
    districtId: '9416034',
    name: 'Ubahak',
  },
  {
    id: '9416034003',
    districtId: '9416034',
    name: 'Sosomikma',
  },
  {
    id: '9416034004',
    districtId: '9416034',
    name: 'Pini',
  },
  {
    id: '9416034006',
    districtId: '9416034',
    name: 'Mabien',
  },
  {
    id: '9416034008',
    districtId: '9416034',
    name: 'Silong',
  },
  {
    id: '9416034009',
    districtId: '9416034',
    name: 'Nurap',
  },
  {
    id: '9416034010',
    districtId: '9416034',
    name: 'Wamuhuk',
  },
  {
    id: '9416034011',
    districtId: '9416034',
    name: 'Welile',
  },
  {
    id: '9416034012',
    districtId: '9416034',
    name: 'Kibianggen',
  },
  {
    id: '9416034014',
    districtId: '9416034',
    name: 'Tolomping',
  },
  {
    id: '9416034015',
    districtId: '9416034',
    name: 'Oblin',
  },
  {
    id: '9416034016',
    districtId: '9416034',
    name: 'Koluong',
  },
  {
    id: '9416034018',
    districtId: '9416034',
    name: 'Bisifak',
  },
  {
    id: '9416035001',
    districtId: '9416035',
    name: 'Nalca',
  },
  {
    id: '9416035003',
    districtId: '9416035',
    name: 'Cenderawasih',
  },
  {
    id: '9416035004',
    districtId: '9416035',
    name: 'Manggona',
  },
  {
    id: '9416035005',
    districtId: '9416035',
    name: 'Bolda',
  },
  {
    id: '9416035006',
    districtId: '9416035',
    name: 'Imsekla',
  },
  {
    id: '9416035010',
    districtId: '9416035',
    name: 'Hein',
  },
  {
    id: '9416035011',
    districtId: '9416035',
    name: 'Luwemna',
  },
  {
    id: '9416036001',
    districtId: '9416036',
    name: 'Puldama',
  },
  {
    id: '9416036004',
    districtId: '9416036',
    name: 'Kasen',
  },
  {
    id: '9416036005',
    districtId: '9416036',
    name: 'Bako',
  },
  {
    id: '9416036006',
    districtId: '9416036',
    name: 'Balsek',
  },
  {
    id: '9416036007',
    districtId: '9416036',
    name: 'Manbolak',
  },
  {
    id: '9416036008',
    districtId: '9416036',
    name: 'Famek',
  },
  {
    id: '9416036010',
    districtId: '9416036',
    name: 'Baru',
  },
  {
    id: '9416037001',
    districtId: '9416037',
    name: 'Tapla',
  },
  {
    id: '9416037002',
    districtId: '9416037',
    name: 'Nipsan',
  },
  {
    id: '9416037003',
    districtId: '9416037',
    name: 'Walmak',
  },
  {
    id: '9416037004',
    districtId: '9416037',
    name: 'Serengon',
  },
  {
    id: '9416037005',
    districtId: '9416037',
    name: 'Biu',
  },
  {
    id: '9416037006',
    districtId: '9416037',
    name: 'Ikmuk',
  },
  {
    id: '9416037007',
    districtId: '9416037',
    name: 'Ilukdamon',
  },
  {
    id: '9416037008',
    districtId: '9416037',
    name: 'Yalmun',
  },
  {
    id: '9416041001',
    districtId: '9416041',
    name: 'Samenage',
  },
  {
    id: '9416041002',
    districtId: '9416041',
    name: 'Haleroma',
  },
  {
    id: '9416041003',
    districtId: '9416041',
    name: 'Ison',
  },
  {
    id: '9416041004',
    districtId: '9416041',
    name: 'Asotapo',
  },
  {
    id: '9416041005',
    districtId: '9416041',
    name: 'Hirin',
  },
  {
    id: '9416041006',
    districtId: '9416041',
    name: 'Notnarek',
  },
  {
    id: '9416041008',
    districtId: '9416041',
    name: 'Pona',
  },
  {
    id: '9416041009',
    districtId: '9416041',
    name: 'Hugilokon',
  },
  {
    id: '9416042001',
    districtId: '9416042',
    name: 'Tangma',
  },
  {
    id: '9416042002',
    districtId: '9416042',
    name: 'Wamarek',
  },
  {
    id: '9416042003',
    districtId: '9416042',
    name: 'Hipela',
  },
  {
    id: '9416042004',
    districtId: '9416042',
    name: 'Huewi',
  },
  {
    id: '9416042005',
    districtId: '9416042',
    name: 'Punno',
  },
  {
    id: '9416042006',
    districtId: '9416042',
    name: 'Simeka',
  },
  {
    id: '9416042007',
    districtId: '9416042',
    name: 'Yeleas',
  },
  {
    id: '9416042008',
    districtId: '9416042',
    name: 'Aleleng',
  },
  {
    id: '9416042009',
    districtId: '9416042',
    name: 'Yalimo',
  },
  {
    id: '9416042010',
    districtId: '9416042',
    name: 'Helo',
  },
  {
    id: '9416043002',
    districtId: '9416043',
    name: 'Soba',
  },
  {
    id: '9416043003',
    districtId: '9416043',
    name: 'Hepinis',
  },
  {
    id: '9416043004',
    districtId: '9416043',
    name: 'Aguluntipmu',
  },
  {
    id: '9416043005',
    districtId: '9416043',
    name: 'Nilen',
  },
  {
    id: '9416043007',
    districtId: '9416043',
    name: 'Tanda',
  },
  {
    id: '9416044002',
    districtId: '9416044',
    name: 'Seima',
  },
  {
    id: '9416044003',
    districtId: '9416044',
    name: 'Yuarima',
  },
  {
    id: '9416044004',
    districtId: '9416044',
    name: 'Kosihun',
  },
  {
    id: '9416044005',
    districtId: '9416044',
    name: 'Hunenima',
  },
  {
    id: '9416044006',
    districtId: '9416044',
    name: 'Togoluk',
  },
  {
    id: '9416044007',
    districtId: '9416044',
    name: 'Hendang',
  },
  {
    id: '9416044008',
    districtId: '9416044',
    name: 'Herwae',
  },
  {
    id: '9416044010',
    districtId: '9416044',
    name: 'Wusagasem',
  },
  {
    id: '9416044011',
    districtId: '9416044',
    name: 'Itlay Wopi',
  },
  {
    id: '9416044012',
    districtId: '9416044',
    name: 'Ilokomo',
  },
  {
    id: '9416044013',
    districtId: '9416044',
    name: 'Hulesi',
  },
  {
    id: '9416044014',
    districtId: '9416044',
    name: 'Wanesi',
  },
  {
    id: '9416044015',
    districtId: '9416044',
    name: 'Panyoke',
  },
  {
    id: '9416044016',
    districtId: '9416044',
    name: 'Nyikinen',
  },
  {
    id: '9416044017',
    districtId: '9416044',
    name: 'Wesangma',
  },
  {
    id: '9416044018',
    districtId: '9416044',
    name: 'Olomisang',
  },
  {
    id: '9416044019',
    districtId: '9416044',
    name: 'Wemasili',
  },
  {
    id: '9416045001',
    districtId: '9416045',
    name: 'Yogosem',
  },
  {
    id: '9416045002',
    districtId: '9416045',
    name: 'Kiroma',
  },
  {
    id: '9416045003',
    districtId: '9416045',
    name: 'Sogasio',
  },
  {
    id: '9416045004',
    districtId: '9416045',
    name: 'Saikama',
  },
  {
    id: '9416045005',
    districtId: '9416045',
    name: 'Hokolekma',
  },
  {
    id: '9416045006',
    districtId: '9416045',
    name: 'Esahapuk',
  },
  {
    id: '9416045007',
    districtId: '9416045',
    name: 'Mesahaput',
  },
  {
    id: '9416046001',
    districtId: '9416046',
    name: 'Kayo',
  },
  {
    id: '9416046002',
    districtId: '9416046',
    name: 'Molama',
  },
  {
    id: '9416046004',
    districtId: '9416046',
    name: 'Walet',
  },
  {
    id: '9416046005',
    districtId: '9416046',
    name: 'Uase',
  },
  {
    id: '9416046006',
    districtId: '9416046',
    name: 'Hombesaloma',
  },
  {
    id: '9416046007',
    districtId: '9416046',
    name: 'Alhai',
  },
  {
    id: '9416047001',
    districtId: '9416047',
    name: 'Sumo',
  },
  {
    id: '9416047002',
    districtId: '9416047',
    name: 'Uam',
  },
  {
    id: '9416047003',
    districtId: '9416047',
    name: 'Maku',
  },
  {
    id: '9416047004',
    districtId: '9416047',
    name: 'Obokain',
  },
  {
    id: '9416047005',
    districtId: '9416047',
    name: 'Jibuk',
  },
  {
    id: '9416047006',
    districtId: '9416047',
    name: 'Wenapong',
  },
  {
    id: '9416047007',
    districtId: '9416047',
    name: 'Muara Balim',
  },
  {
    id: '9416047008',
    districtId: '9416047',
    name: 'Hunisi',
  },
  {
    id: '9416047009',
    districtId: '9416047',
    name: 'Boor',
  },
  {
    id: '9416047010',
    districtId: '9416047',
    name: 'Wirilu',
  },
  {
    id: '9416047011',
    districtId: '9416047',
    name: 'Kwiriside',
  },
  {
    id: '9416048001',
    districtId: '9416048',
    name: 'Paima',
  },
  {
    id: '9416048002',
    districtId: '9416048',
    name: 'Dugumhad',
  },
  {
    id: '9416048003',
    districtId: '9416048',
    name: 'Leleak',
  },
  {
    id: '9416048004',
    districtId: '9416048',
    name: 'Subsal',
  },
  {
    id: '9416048005',
    districtId: '9416048',
    name: 'Sengsenagaik',
  },
  {
    id: '9416048006',
    districtId: '9416048',
    name: 'Sipnidipmu',
  },
  {
    id: '9416048007',
    districtId: '9416048',
    name: 'Hogio 1',
  },
  {
    id: '9416048008',
    districtId: '9416048',
    name: 'Hogio 2',
  },
  {
    id: '9416049001',
    districtId: '9416049',
    name: 'Ukha',
  },
  {
    id: '9416049003',
    districtId: '9416049',
    name: 'Amisangi',
  },
  {
    id: '9416049004',
    districtId: '9416049',
    name: 'Wenapuk',
  },
  {
    id: '9416049005',
    districtId: '9416049',
    name: 'Eki',
  },
  {
    id: '9416049007',
    districtId: '9416049',
    name: 'Siolorema',
  },
  {
    id: '9416049008',
    districtId: '9416049',
    name: 'Musanarek',
  },
  {
    id: '9416049009',
    districtId: '9416049',
    name: 'Waliagelema',
  },
  {
    id: '9416049010',
    districtId: '9416049',
    name: 'Lua',
  },
  {
    id: '9416049011',
    districtId: '9416049',
    name: 'Wakunyama',
  },
  {
    id: '9416051004',
    districtId: '9416051',
    name: 'Wesagalep',
  },
  {
    id: '9416051005',
    districtId: '9416051',
    name: 'Wesama',
  },
  {
    id: '9416051006',
    districtId: '9416051',
    name: 'Weasi',
  },
  {
    id: '9416051007',
    districtId: '9416051',
    name: 'Honoasuok',
  },
  {
    id: '9416051008',
    districtId: '9416051',
    name: 'Weriaput',
  },
  {
    id: '9416051009',
    districtId: '9416051',
    name: 'Suesi',
  },
  {
    id: '9416051011',
    districtId: '9416051',
    name: 'Esema Husage',
  },
  {
    id: '9416051012',
    districtId: '9416051',
    name: 'Libuk',
  },
  {
    id: '9416051013',
    districtId: '9416051',
    name: 'Hepia',
  },
  {
    id: '9416051014',
    districtId: '9416051',
    name: 'Hagawen',
  },
  {
    id: '9416051015',
    districtId: '9416051',
    name: 'Werima',
  },
  {
    id: '9416051016',
    districtId: '9416051',
    name: 'Luarima',
  },
  {
    id: '9416051017',
    districtId: '9416051',
    name: 'Lokon',
  },
  {
    id: '9416052001',
    districtId: '9416052',
    name: 'Weawen',
  },
  {
    id: '9416052002',
    districtId: '9416052',
    name: 'Kwelena',
  },
  {
    id: '9416052003',
    districtId: '9416052',
    name: 'Banga',
  },
  {
    id: '9416052004',
    districtId: '9416052',
    name: 'Musan',
  },
  {
    id: '9416052005',
    districtId: '9416052',
    name: 'Salbi',
  },
  {
    id: '9416052006',
    districtId: '9416052',
    name: 'Erim',
  },
  {
    id: '9416052007',
    districtId: '9416052',
    name: 'Singokla',
  },
  {
    id: '9416052008',
    districtId: '9416052',
    name: 'Soline',
  },
  {
    id: '9416053001',
    districtId: '9416053',
    name: 'Seradala',
  },
  {
    id: '9416053002',
    districtId: '9416053',
    name: 'Moruf',
  },
  {
    id: '9416053003',
    districtId: '9416053',
    name: 'Koper',
  },
  {
    id: '9416053005',
    districtId: '9416053',
    name: 'Tokuni',
  },
  {
    id: '9416053006',
    districtId: '9416053',
    name: 'Burupmakot',
  },
  {
    id: '9416053007',
    districtId: '9416053',
    name: 'Yasip',
  },
  {
    id: '9416053008',
    districtId: '9416053',
    name: 'Masomduba',
  },
  {
    id: '9416053009',
    districtId: '9416053',
    name: 'Samboga',
  },
  {
    id: '9416054001',
    districtId: '9416054',
    name: 'Kabianggama',
  },
  {
    id: '9416054002',
    districtId: '9416054',
    name: 'Sohopma',
  },
  {
    id: '9416054003',
    districtId: '9416054',
    name: 'Sohal',
  },
  {
    id: '9416054004',
    districtId: '9416054',
    name: 'Bahabolma',
  },
  {
    id: '9416054005',
    districtId: '9416054',
    name: 'Subayo',
  },
  {
    id: '9416054006',
    districtId: '9416054',
    name: 'Buahun',
  },
  {
    id: '9416054007',
    districtId: '9416054',
    name: 'Domul',
  },
  {
    id: '9416055001',
    districtId: '9416055',
    name: 'Silakma',
  },
  {
    id: '9416055002',
    districtId: '9416055',
    name: 'Somarin',
  },
  {
    id: '9416055003',
    districtId: '9416055',
    name: 'Monin',
  },
  {
    id: '9416055004',
    districtId: '9416055',
    name: 'Enggelasue',
  },
  {
    id: '9416055005',
    districtId: '9416055',
    name: 'Oakbisik',
  },
  {
    id: '9416055006',
    districtId: '9416055',
    name: 'Husmo',
  },
  {
    id: '9416055007',
    districtId: '9416055',
    name: 'Karelma',
  },
  {
    id: '9416055008',
    districtId: '9416055',
    name: 'Kenkeni',
  },
  {
    id: '9416055009',
    districtId: '9416055',
    name: 'Momenggama',
  },
  {
    id: '9416055010',
    districtId: '9416055',
    name: 'Usabini',
  },
  {
    id: '9416056001',
    districtId: '9416056',
    name: 'Hilipuk',
  },
  {
    id: '9416056002',
    districtId: '9416056',
    name: 'Homodipmu',
  },
  {
    id: '9416056003',
    districtId: '9416056',
    name: 'Kini',
  },
  {
    id: '9416056004',
    districtId: '9416056',
    name: 'Yaruhuk',
  },
  {
    id: '9416056007',
    districtId: '9416056',
    name: 'Jamin',
  },
  {
    id: '9416056008',
    districtId: '9416056',
    name: 'Dindok',
  },
  {
    id: '9416056009',
    districtId: '9416056',
    name: 'Sohondipmu',
  },
  {
    id: '9416057001',
    districtId: '9416057',
    name: 'Sobundalek',
  },
  {
    id: '9416057002',
    districtId: '9416057',
    name: 'Tanggeam',
  },
  {
    id: '9416057003',
    districtId: '9416057',
    name: 'Amfulma',
  },
  {
    id: '9416057004',
    districtId: '9416057',
    name: 'Suksale',
  },
  {
    id: '9416057005',
    districtId: '9416057',
    name: 'Linggisen',
  },
  {
    id: '9416058001',
    districtId: '9416058',
    name: 'Palentum',
  },
  {
    id: '9416058002',
    districtId: '9416058',
    name: 'Hereapini',
  },
  {
    id: '9416058003',
    districtId: '9416058',
    name: 'Homboki',
  },
  {
    id: '9416058004',
    districtId: '9416058',
    name: 'Kinkun',
  },
  {
    id: '9416058005',
    districtId: '9416058',
    name: 'Menealgsing/Menetsing',
  },
  {
    id: '9416058007',
    districtId: '9416058',
    name: 'Kabukal',
  },
  {
    id: '9416058008',
    districtId: '9416058',
    name: 'Hoet',
  },
  {
    id: '9416058010',
    districtId: '9416058',
    name: 'Ohena',
  },
  {
    id: '9416058011',
    districtId: '9416058',
    name: 'Nelisa',
  },
  {
    id: '9416059001',
    districtId: '9416059',
    name: 'Membaham',
  },
  {
    id: '9416059002',
    districtId: '9416059',
    name: 'Heriky',
  },
  {
    id: '9416059003',
    districtId: '9416059',
    name: 'Talambela',
  },
  {
    id: '9416059004',
    districtId: '9416059',
    name: 'Wisomi',
  },
  {
    id: '9416059005',
    districtId: '9416059',
    name: 'Wanam',
  },
  {
    id: '9416059007',
    districtId: '9416059',
    name: 'Ubalihion',
  },
  {
    id: '9416059008',
    districtId: '9416059',
    name: 'Walahan',
  },
  {
    id: '9416059009',
    districtId: '9416059',
    name: 'Salakma',
  },
  {
    id: '9416059010',
    districtId: '9416059',
    name: 'Samiyul',
  },
  {
    id: '9416061001',
    districtId: '9416061',
    name: 'Tibul',
  },
  {
    id: '9416061002',
    districtId: '9416061',
    name: 'Lelambo',
  },
  {
    id: '9416061003',
    districtId: '9416061',
    name: 'Kikila',
  },
  {
    id: '9416061004',
    districtId: '9416061',
    name: 'Bari',
  },
  {
    id: '9416061006',
    districtId: '9416061',
    name: 'Palukae',
  },
  {
    id: '9416061007',
    districtId: '9416061',
    name: 'Wubri',
  },
  {
    id: '9416061008',
    districtId: '9416061',
    name: 'Paleromon',
  },
  {
    id: '9416061009',
    districtId: '9416061',
    name: 'Lelambo 2',
  },
  {
    id: '9416062001',
    districtId: '9416062',
    name: 'Siwiikma',
  },
  {
    id: '9416062002',
    districtId: '9416062',
    name: 'Piliam',
  },
  {
    id: '9416062003',
    districtId: '9416062',
    name: 'Pontenpilik',
  },
  {
    id: '9416062004',
    districtId: '9416062',
    name: 'Hiklahin',
  },
  {
    id: '9416062005',
    districtId: '9416062',
    name: 'Helapilik',
  },
  {
    id: '9416062006',
    districtId: '9416062',
    name: 'Pronggoli',
  },
  {
    id: '9416062007',
    districtId: '9416062',
    name: 'Lirutek',
  },
  {
    id: '9416063001',
    districtId: '9416063',
    name: 'Endomen',
  },
  {
    id: '9416063002',
    districtId: '9416063',
    name: 'Okloma',
  },
  {
    id: '9416063003',
    districtId: '9416063',
    name: 'Delon',
  },
  {
    id: '9416063004',
    districtId: '9416063',
    name: 'Suron',
  },
  {
    id: '9416063006',
    districtId: '9416063',
    name: 'Gidomen',
  },
  {
    id: '9416063007',
    districtId: '9416063',
    name: 'Galsin',
  },
  {
    id: '9416063008',
    districtId: '9416063',
    name: 'Kouwet',
  },
  {
    id: '9416065002',
    districtId: '9416065',
    name: 'Kona',
  },
  {
    id: '9416065004',
    districtId: '9416065',
    name: 'Kalpok',
  },
  {
    id: '9416065005',
    districtId: '9416065',
    name: 'Seklak',
  },
  {
    id: '9416066001',
    districtId: '9416066',
    name: 'Duram',
  },
  {
    id: '9416066002',
    districtId: '9416066',
    name: 'Yaminikma',
  },
  {
    id: '9416066003',
    districtId: '9416066',
    name: 'Goak',
  },
  {
    id: '9416066004',
    districtId: '9416066',
    name: 'Digitme',
  },
  {
    id: '9416066005',
    districtId: '9416066',
    name: 'Dengat',
  },
  {
    id: '9416066006',
    districtId: '9416066',
    name: 'Niniwi',
  },
  {
    id: '9416067001',
    districtId: '9416067',
    name: 'Dirwemna',
  },
  {
    id: '9416067002',
    districtId: '9416067',
    name: 'Aksal',
  },
  {
    id: '9416067003',
    districtId: '9416067',
    name: 'Dolsen',
  },
  {
    id: '9416067004',
    districtId: '9416067',
    name: 'Salengkomo',
  },
  {
    id: '9416067005',
    districtId: '9416067',
    name: 'Silion',
  },
  {
    id: '9417010003',
    districtId: '9417010',
    name: 'Ulkubi',
  },
  {
    id: '9417010004',
    districtId: '9417010',
    name: 'Walapkubun',
  },
  {
    id: '9417010005',
    districtId: '9417010',
    name: 'Iwur / Iwurmot',
  },
  {
    id: '9417010006',
    districtId: '9417010',
    name: 'Kurumkin',
  },
  {
    id: '9417010011',
    districtId: '9417010',
    name: 'Dinmot / Arim',
  },
  {
    id: '9417010013',
    districtId: '9417010',
    name: 'Ewenkatop',
  },
  {
    id: '9417010014',
    districtId: '9417010',
    name: 'Namger',
  },
  {
    id: '9417010015',
    districtId: '9417010',
    name: 'Kamyoim',
  },
  {
    id: '9417010016',
    districtId: '9417010',
    name: 'Dipol',
  },
  {
    id: '9417010017',
    districtId: '9417010',
    name: 'Nenginum',
  },
  {
    id: '9417011001',
    districtId: '9417011',
    name: 'Tarangop',
  },
  {
    id: '9417011002',
    districtId: '9417011',
    name: 'Arintap',
  },
  {
    id: '9417011004',
    districtId: '9417011',
    name: 'Sakup',
  },
  {
    id: '9417011005',
    districtId: '9417011',
    name: 'Nanum',
  },
  {
    id: '9417011006',
    districtId: '9417011',
    name: 'Kawor',
  },
  {
    id: '9417011007',
    districtId: '9417011',
    name: 'Ater',
  },
  {
    id: '9417011008',
    districtId: '9417011',
    name: 'Umding',
  },
  {
    id: '9417012001',
    districtId: '9417012',
    name: 'Tarup',
  },
  {
    id: '9417012002',
    districtId: '9417012',
    name: 'Marantikin',
  },
  {
    id: '9417012003',
    districtId: '9417012',
    name: 'Imsin',
  },
  {
    id: '9417012004',
    districtId: '9417012',
    name: 'Bitipding',
  },
  {
    id: '9417012005',
    districtId: '9417012',
    name: 'Onkor',
  },
  {
    id: '9417012007',
    districtId: '9417012',
    name: 'Omor',
  },
  {
    id: '9417013001',
    districtId: '9417013',
    name: 'Awinbon',
  },
  {
    id: '9417013002',
    districtId: '9417013',
    name: 'Kawe',
  },
  {
    id: '9417013003',
    districtId: '9417013',
    name: 'Yelobib',
  },
  {
    id: '9417013004',
    districtId: '9417013',
    name: 'Mikir',
  },
  {
    id: '9417013005',
    districtId: '9417013',
    name: 'Nanum',
  },
  {
    id: '9417020005',
    districtId: '9417020',
    name: 'Kabiding',
  },
  {
    id: '9417020025',
    districtId: '9417020',
    name: 'Mabilabol',
  },
  {
    id: '9417020026',
    districtId: '9417020',
    name: 'Okmakot',
  },
  {
    id: '9417020032',
    districtId: '9417020',
    name: 'Polsam',
  },
  {
    id: '9417020035',
    districtId: '9417020',
    name: 'Banumdol',
  },
  {
    id: '9417020036',
    districtId: '9417020',
    name: 'Molbib Silibib',
  },
  {
    id: '9417020037',
    districtId: '9417020',
    name: 'Aldom',
  },
  {
    id: '9417020038',
    districtId: '9417020',
    name: 'Kotdol',
  },
  {
    id: '9417021003',
    districtId: '9417021',
    name: 'Pepera',
  },
  {
    id: '9417021007',
    districtId: '9417021',
    name: 'Denom',
  },
  {
    id: '9417021008',
    districtId: '9417021',
    name: 'Ok Telabe',
  },
  {
    id: '9417021009',
    districtId: '9417021',
    name: 'Wok Bakon',
  },
  {
    id: '9417021010',
    districtId: '9417021',
    name: 'Okbontenam',
  },
  {
    id: '9417021011',
    districtId: '9417021',
    name: 'Bon Yakwol',
  },
  {
    id: '9417022003',
    districtId: '9417022',
    name: 'Alemsom',
  },
  {
    id: '9417022004',
    districtId: '9417022',
    name: 'Eraduman',
  },
  {
    id: '9417022005',
    districtId: '9417022',
    name: 'Tapasik',
  },
  {
    id: '9417022006',
    districtId: '9417022',
    name: 'Bakwalim Yub',
  },
  {
    id: '9417022007',
    districtId: '9417022',
    name: 'Imiriyi',
  },
  {
    id: '9417022008',
    districtId: '9417022',
    name: 'Suntamon',
  },
  {
    id: '9417022009',
    districtId: '9417022',
    name: 'Bondik',
  },
  {
    id: '9417022010',
    districtId: '9417022',
    name: 'Miruman',
  },
  {
    id: '9417022011',
    districtId: '9417022',
    name: 'Bunalkon',
  },
  {
    id: '9417022012',
    districtId: '9417022',
    name: 'Timbal',
  },
  {
    id: '9417022013',
    districtId: '9417022',
    name: 'Payol Masumkon',
  },
  {
    id: '9417022014',
    districtId: '9417022',
    name: 'Tapok',
  },
  {
    id: '9417023001',
    districtId: '9417023',
    name: 'Parim',
  },
  {
    id: '9417023002',
    districtId: '9417023',
    name: 'Yapimakot',
  },
  {
    id: '9417023003',
    districtId: '9417023',
    name: 'Seramkatop',
  },
  {
    id: '9417023004',
    districtId: '9417023',
    name: 'Modusit',
  },
  {
    id: '9417023005',
    districtId: '9417023',
    name: 'Okatem',
  },
  {
    id: '9417023006',
    districtId: '9417023',
    name: 'Yakmor',
  },
  {
    id: '9417023007',
    districtId: '9417023',
    name: 'Siminbuk',
  },
  {
    id: '9417023008',
    districtId: '9417023',
    name: 'Wanbakon',
  },
  {
    id: '9417024001',
    districtId: '9417024',
    name: 'Dabolding',
  },
  {
    id: '9417024002',
    districtId: '9417024',
    name: 'Kolomdol',
  },
  {
    id: '9417024003',
    districtId: '9417024',
    name: 'Tulo',
  },
  {
    id: '9417024004',
    districtId: '9417024',
    name: 'Arinkop',
  },
  {
    id: '9417024005',
    districtId: '9417024',
    name: 'Imik',
  },
  {
    id: '9417025001',
    districtId: '9417025',
    name: 'Mimin',
  },
  {
    id: '9417025002',
    districtId: '9417025',
    name: 'Oksop',
  },
  {
    id: '9417025004',
    districtId: '9417025',
    name: 'Atenar',
  },
  {
    id: '9417025005',
    districtId: '9417025',
    name: 'Alutbakon',
  },
  {
    id: '9417025006',
    districtId: '9417025',
    name: 'Oktumi',
  },
  {
    id: '9417026001',
    districtId: '9417026',
    name: 'Akmer',
  },
  {
    id: '9417026002',
    districtId: '9417026',
    name: 'Tapasik',
  },
  {
    id: '9417026003',
    districtId: '9417026',
    name: 'Kasawi',
  },
  {
    id: '9417026004',
    districtId: '9417026',
    name: 'Masim',
  },
  {
    id: '9417026005',
    districtId: '9417026',
    name: 'Bape',
  },
  {
    id: '9417026006',
    districtId: '9417026',
    name: 'Ibob',
  },
  {
    id: '9417027001',
    districtId: '9417027',
    name: 'Yumakot',
  },
  {
    id: '9417027002',
    districtId: '9417027',
    name: 'Limarum',
  },
  {
    id: '9417027003',
    districtId: '9417027',
    name: 'Kugulding',
  },
  {
    id: '9417027004',
    districtId: '9417027',
    name: 'Bulangkop',
  },
  {
    id: '9417027005',
    districtId: '9417027',
    name: 'Aplim',
  },
  {
    id: '9417027006',
    districtId: '9417027',
    name: 'Okdo',
  },
  {
    id: '9417030001',
    districtId: '9417030',
    name: 'Onya',
  },
  {
    id: '9417030006',
    districtId: '9417030',
    name: 'Omban',
  },
  {
    id: '9417030007',
    districtId: '9417030',
    name: 'Borme',
  },
  {
    id: '9417030008',
    districtId: '9417030',
    name: 'Arina',
  },
  {
    id: '9417030013',
    districtId: '9417030',
    name: 'Sikibur',
  },
  {
    id: '9417030014',
    districtId: '9417030',
    name: 'Bordamban',
  },
  {
    id: '9417030016',
    districtId: '9417030',
    name: 'Kwime',
  },
  {
    id: '9417030017',
    districtId: '9417030',
    name: 'Laydamban',
  },
  {
    id: '9417030018',
    districtId: '9417030',
    name: 'Kolgir',
  },
  {
    id: '9417030019',
    districtId: '9417030',
    name: 'Cangdamban',
  },
  {
    id: '9417030020',
    districtId: '9417030',
    name: 'Semban',
  },
  {
    id: '9417030021',
    districtId: '9417030',
    name: 'Bukap',
  },
  {
    id: '9417030030',
    districtId: '9417030',
    name: 'Aringgon',
  },
  {
    id: '9417031001',
    districtId: '9417031',
    name: 'Kameme',
  },
  {
    id: '9417031003',
    districtId: '9417031',
    name: 'Bime',
  },
  {
    id: '9417031004',
    districtId: '9417031',
    name: 'Lim Lim',
  },
  {
    id: '9417031005',
    districtId: '9417031',
    name: 'Bunggon',
  },
  {
    id: '9417031006',
    districtId: '9417031',
    name: 'Calab',
  },
  {
    id: '9417031007',
    districtId: '9417031',
    name: 'Limiri',
  },
  {
    id: '9417031008',
    districtId: '9417031',
    name: 'Teli',
  },
  {
    id: '9417031009',
    districtId: '9417031',
    name: 'Bob',
  },
  {
    id: '9417032004',
    districtId: '9417032',
    name: 'Wakidam',
  },
  {
    id: '9417032005',
    districtId: '9417032',
    name: 'Eipomek',
  },
  {
    id: '9417032006',
    districtId: '9417032',
    name: 'Talemo',
  },
  {
    id: '9417032008',
    districtId: '9417032',
    name: 'Londinin',
  },
  {
    id: '9417032010',
    districtId: '9417032',
    name: 'Lalakon',
  },
  {
    id: '9417032015',
    districtId: '9417032',
    name: 'Bunyirye',
  },
  {
    id: '9417032017',
    districtId: '9417032',
    name: 'Tanime',
  },
  {
    id: '9417032018',
    districtId: '9417032',
    name: 'Basiringe',
  },
  {
    id: '9417032019',
    districtId: '9417032',
    name: 'Barama',
  },
  {
    id: '9417032020',
    districtId: '9417032',
    name: 'Serabum',
  },
  {
    id: '9417032021',
    districtId: '9417032',
    name: 'Kweredala',
  },
  {
    id: '9417032022',
    districtId: '9417032',
    name: 'Mungkona',
  },
  {
    id: '9417032023',
    districtId: '9417032',
    name: 'Malingdam',
  },
  {
    id: '9417033001',
    districtId: '9417033',
    name: 'Weime',
  },
  {
    id: '9417033002',
    districtId: '9417033',
    name: 'Taramlu',
  },
  {
    id: '9417033003',
    districtId: '9417033',
    name: 'Merpasikme',
  },
  {
    id: '9417033004',
    districtId: '9417033',
    name: 'Dalumban',
  },
  {
    id: '9417033005',
    districtId: '9417033',
    name: 'Nomteren',
  },
  {
    id: '9417033006',
    districtId: '9417033',
    name: 'Mekramgon',
  },
  {
    id: '9417033007',
    districtId: '9417033',
    name: 'Youlban',
  },
  {
    id: '9417033008',
    districtId: '9417033',
    name: 'Meryang',
  },
  {
    id: '9417033009',
    districtId: '9417033',
    name: 'Limrepasikme',
  },
  {
    id: '9417034001',
    districtId: '9417034',
    name: 'Imde',
  },
  {
    id: '9417034002',
    districtId: '9417034',
    name: 'Lumdakna',
  },
  {
    id: '9417034003',
    districtId: '9417034',
    name: 'Marikla',
  },
  {
    id: '9417034004',
    districtId: '9417034',
    name: 'Yabosorom',
  },
  {
    id: '9417034005',
    districtId: '9417034',
    name: 'Pamek',
  },
  {
    id: '9417034006',
    districtId: '9417034',
    name: 'Baramirye',
  },
  {
    id: '9417034007',
    districtId: '9417034',
    name: 'Mandalak',
  },
  {
    id: '9417034009',
    districtId: '9417034',
    name: 'Kalek',
  },
  {
    id: '9417034010',
    districtId: '9417034',
    name: 'Barice',
  },
  {
    id: '9417034011',
    districtId: '9417034',
    name: 'Pinggon',
  },
  {
    id: '9417035001',
    districtId: '9417035',
    name: 'Nongme',
  },
  {
    id: '9417035002',
    districtId: '9417035',
    name: 'Rubol',
  },
  {
    id: '9417035003',
    districtId: '9417035',
    name: 'Yokom',
  },
  {
    id: '9417035004',
    districtId: '9417035',
    name: 'Yarigom',
  },
  {
    id: '9417035005',
    districtId: '9417035',
    name: 'Omtamur',
  },
  {
    id: '9417035006',
    districtId: '9417035',
    name: 'Canpally',
  },
  {
    id: '9417035007',
    districtId: '9417035',
    name: 'Kwarban',
  },
  {
    id: '9417036001',
    districtId: '9417036',
    name: 'Karye',
  },
  {
    id: '9417036002',
    districtId: '9417036',
    name: 'Batani',
  },
  {
    id: '9417036003',
    districtId: '9417036',
    name: 'Segame',
  },
  {
    id: '9417036004',
    districtId: '9417036',
    name: 'Palur 1',
  },
  {
    id: '9417036005',
    districtId: '9417036',
    name: 'Palur 2',
  },
  {
    id: '9417036006',
    districtId: '9417036',
    name: 'Sople',
  },
  {
    id: '9417036007',
    districtId: '9417036',
    name: 'Bakata',
  },
  {
    id: '9417040001',
    districtId: '9417040',
    name: 'Manunggal',
  },
  {
    id: '9417040002',
    districtId: '9417040',
    name: 'Apmisibil',
  },
  {
    id: '9417040003',
    districtId: '9417040',
    name: 'Iriding',
  },
  {
    id: '9417040004',
    districtId: '9417040',
    name: 'Okbifisil',
  },
  {
    id: '9417040016',
    districtId: '9417040',
    name: 'Atolbol',
  },
  {
    id: '9417040017',
    districtId: '9417040',
    name: 'Oktanglap',
  },
  {
    id: '9417040018',
    districtId: '9417040',
    name: 'Okaplo',
  },
  {
    id: '9417040023',
    districtId: '9417040',
    name: 'Oksemar',
  },
  {
    id: '9417041002',
    districtId: '9417041',
    name: 'Aboy',
  },
  {
    id: '9417041003',
    districtId: '9417041',
    name: 'Luban',
  },
  {
    id: '9417041005',
    districtId: '9417041',
    name: 'Lulis',
  },
  {
    id: '9417041006',
    districtId: '9417041',
    name: 'Pipal',
  },
  {
    id: '9417041007',
    districtId: '9417041',
    name: 'Woro',
  },
  {
    id: '9417041008',
    districtId: '9417041',
    name: 'Amase',
  },
  {
    id: '9417042001',
    districtId: '9417042',
    name: 'Tupoplyon',
  },
  {
    id: '9417042002',
    districtId: '9417042',
    name: 'Sabin',
  },
  {
    id: '9417042003',
    districtId: '9417042',
    name: 'Borban',
  },
  {
    id: '9417042004',
    districtId: '9417042',
    name: 'Maksum',
  },
  {
    id: '9417042005',
    districtId: '9417042',
    name: 'Yapil',
  },
  {
    id: '9417042006',
    districtId: '9417042',
    name: 'Kirimu',
  },
  {
    id: '9417042007',
    districtId: '9417042',
    name: 'Dumpasik',
  },
  {
    id: '9417042008',
    districtId: '9417042',
    name: 'Pedam',
  },
  {
    id: '9417042009',
    districtId: '9417042',
    name: 'Atembapol',
  },
  {
    id: '9417042010',
    districtId: '9417042',
    name: 'Markom',
  },
  {
    id: '9417042011',
    districtId: '9417042',
    name: 'Peneli',
  },
  {
    id: '9417042012',
    districtId: '9417042',
    name: 'Omliom',
  },
  {
    id: '9417043001',
    districtId: '9417043',
    name: 'Tairaplu',
  },
  {
    id: '9417043002',
    districtId: '9417043',
    name: 'Bautme',
  },
  {
    id: '9417043003',
    districtId: '9417043',
    name: 'Sinami',
  },
  {
    id: '9417043004',
    districtId: '9417043',
    name: 'Maigame',
  },
  {
    id: '9417043005',
    districtId: '9417043',
    name: 'Tarpadey',
  },
  {
    id: '9417043006',
    districtId: '9417043',
    name: 'Jitarger',
  },
  {
    id: '9417043008',
    districtId: '9417043',
    name: 'Juaban 1',
  },
  {
    id: '9417043009',
    districtId: '9417043',
    name: 'Juaban 2',
  },
  {
    id: '9417043010',
    districtId: '9417043',
    name: 'Teriame',
  },
  {
    id: '9417044001',
    districtId: '9417044',
    name: 'Yefta',
  },
  {
    id: '9417044002',
    districtId: '9417044',
    name: 'Lulis',
  },
  {
    id: '9417044003',
    districtId: '9417044',
    name: 'Tupalma 1',
  },
  {
    id: '9417044004',
    districtId: '9417044',
    name: 'Tupalma 2',
  },
  {
    id: '9417044005',
    districtId: '9417044',
    name: 'Kalimbu',
  },
  {
    id: '9417044006',
    districtId: '9417044',
    name: 'Bris',
  },
  {
    id: '9417050008',
    districtId: '9417050',
    name: 'Berusaha',
  },
  {
    id: '9417050009',
    districtId: '9417050',
    name: 'Oknanggul',
  },
  {
    id: '9417050015',
    districtId: '9417050',
    name: 'Pelebib',
  },
  {
    id: '9417050016',
    districtId: '9417050',
    name: 'Kiwi',
  },
  {
    id: '9417050017',
    districtId: '9417050',
    name: 'Kukihil',
  },
  {
    id: '9417050020',
    districtId: '9417050',
    name: 'Sopamikma',
  },
  {
    id: '9417050021',
    districtId: '9417050',
    name: 'Lolim',
  },
  {
    id: '9417050022',
    districtId: '9417050',
    name: 'Asua',
  },
  {
    id: '9417050023',
    districtId: '9417050',
    name: 'Mangoldoki',
  },
  {
    id: '9417050025',
    districtId: '9417050',
    name: 'Pomding',
  },
  {
    id: '9417050026',
    districtId: '9417050',
    name: 'Diip',
  },
  {
    id: '9417051001',
    districtId: '9417051',
    name: 'Wantem',
  },
  {
    id: '9417051002',
    districtId: '9417051',
    name: 'Oketur',
  },
  {
    id: '9417051003',
    districtId: '9417051',
    name: 'Okyop',
  },
  {
    id: '9417051004',
    districtId: '9417051',
    name: 'Ehiptem',
  },
  {
    id: '9417051007',
    districtId: '9417051',
    name: 'Dikdon',
  },
  {
    id: '9417051008',
    districtId: '9417051',
    name: 'Okyako',
  },
  {
    id: '9417051009',
    districtId: '9417051',
    name: 'Tatam',
  },
  {
    id: '9417051010',
    districtId: '9417051',
    name: 'Okhik',
  },
  {
    id: '9417051011',
    districtId: '9417051',
    name: 'Okyaop',
  },
  {
    id: '9417052001',
    districtId: '9417052',
    name: 'Kubibkop',
  },
  {
    id: '9417052002',
    districtId: '9417052',
    name: 'Okano',
  },
  {
    id: '9417052004',
    districtId: '9417052',
    name: 'Mangabit',
  },
  {
    id: '9417053001',
    districtId: '9417053',
    name: 'Okelwel',
  },
  {
    id: '9417053002',
    districtId: '9417053',
    name: 'Kotyobakon',
  },
  {
    id: '9417053003',
    districtId: '9417053',
    name: 'Okteneng',
  },
  {
    id: '9417053004',
    districtId: '9417053',
    name: 'Tengnong',
  },
  {
    id: '9417054001',
    districtId: '9417054',
    name: 'Oklip',
  },
  {
    id: '9417054002',
    districtId: '9417054',
    name: 'Okhim',
  },
  {
    id: '9417054003',
    districtId: '9417054',
    name: 'Oktem',
  },
  {
    id: '9417054004',
    districtId: '9417054',
    name: 'Oktumi',
  },
  {
    id: '9417054005',
    districtId: '9417054',
    name: 'Okamin',
  },
  {
    id: '9417054006',
    districtId: '9417054',
    name: 'Okbumul',
  },
  {
    id: '9417054007',
    districtId: '9417054',
    name: 'Komok',
  },
  {
    id: '9417055001',
    districtId: '9417055',
    name: 'Okma',
  },
  {
    id: '9417055002',
    districtId: '9417055',
    name: 'Paune',
  },
  {
    id: '9417055003',
    districtId: '9417055',
    name: 'Tinibil',
  },
  {
    id: '9417055004',
    districtId: '9417055',
    name: 'Oktae',
  },
  {
    id: '9417055005',
    districtId: '9417055',
    name: 'Okdilan',
  },
  {
    id: '9417055006',
    districtId: '9417055',
    name: 'Autpahit',
  },
  {
    id: '9417055007',
    districtId: '9417055',
    name: 'Tomka',
  },
  {
    id: '9417055008',
    districtId: '9417055',
    name: 'Okpa',
  },
  {
    id: '9417055009',
    districtId: '9417055',
    name: 'Okhaha',
  },
  {
    id: '9417055010',
    districtId: '9417055',
    name: 'Honkuding',
  },
  {
    id: '9417055011',
    districtId: '9417055',
    name: 'Bomding',
  },
  {
    id: '9417055012',
    districtId: '9417055',
    name: 'Okdunan',
  },
  {
    id: '9417056001',
    districtId: '9417056',
    name: 'Oktau',
  },
  {
    id: '9417056002',
    districtId: '9417056',
    name: 'Okngan',
  },
  {
    id: '9417056003',
    districtId: '9417056',
    name: 'Okbem',
  },
  {
    id: '9417056004',
    districtId: '9417056',
    name: 'Oktaru',
  },
  {
    id: '9417056006',
    districtId: '9417056',
    name: 'Kaep',
  },
  {
    id: '9417056007',
    districtId: '9417056',
    name: 'Bemhimiku',
  },
  {
    id: '9417056008',
    districtId: '9417056',
    name: 'Atang Doki',
  },
  {
    id: '9417056009',
    districtId: '9417056',
    name: 'Okalut Kumal',
  },
  {
    id: '9417056010',
    districtId: '9417056',
    name: 'Bilip Bayo',
  },
  {
    id: '9417060003',
    districtId: '9417060',
    name: 'Batom',
  },
  {
    id: '9417060008',
    districtId: '9417060',
    name: 'Oksip',
  },
  {
    id: '9417060009',
    districtId: '9417060',
    name: 'Sabi',
  },
  {
    id: '9417060010',
    districtId: '9417060',
    name: 'Batom 2',
  },
  {
    id: '9417060012',
    districtId: '9417060',
    name: 'Muara',
  },
  {
    id: '9417060015',
    districtId: '9417060',
    name: 'Okyako',
  },
  {
    id: '9417060016',
    districtId: '9417060',
    name: 'Mongham',
  },
  {
    id: '9417060017',
    districtId: '9417060',
    name: 'Belomo',
  },
  {
    id: '9417060018',
    districtId: '9417060',
    name: 'Pateng',
  },
  {
    id: '9417060019',
    districtId: '9417060',
    name: 'Abukerom',
  },
  {
    id: '9417061001',
    districtId: '9417061',
    name: 'Bias',
  },
  {
    id: '9417061002',
    districtId: '9417061',
    name: 'Bumi',
  },
  {
    id: '9417061003',
    districtId: '9417061',
    name: 'Tero',
  },
  {
    id: '9417061004',
    districtId: '9417061',
    name: 'Delemo',
  },
  {
    id: '9417062001',
    districtId: '9417062',
    name: 'Mot',
  },
  {
    id: '9417062002',
    districtId: '9417062',
    name: 'Muara Asbi',
  },
  {
    id: '9417062003',
    districtId: '9417062',
    name: 'Milki',
  },
  {
    id: '9417062005',
    districtId: '9417062',
    name: 'Tual',
  },
  {
    id: '9418010009',
    districtId: '9418010',
    name: 'Aulani',
  },
  {
    id: '9418010010',
    districtId: '9418010',
    name: 'Kanggime',
  },
  {
    id: '9418010022',
    districtId: '9418010',
    name: 'Logon',
  },
  {
    id: '9418010023',
    districtId: '9418010',
    name: 'Marlo',
  },
  {
    id: '9418010032',
    districtId: '9418010',
    name: 'Ligimbak',
  },
  {
    id: '9418010033',
    districtId: '9418010',
    name: 'Kugimaluk',
  },
  {
    id: '9418010034',
    districtId: '9418010',
    name: 'Purugi',
  },
  {
    id: '9418010035',
    districtId: '9418010',
    name: 'Kerena',
  },
  {
    id: '9418010041',
    districtId: '9418010',
    name: 'Lawor',
  },
  {
    id: '9418011005',
    districtId: '9418011',
    name: 'Yaliwak',
  },
  {
    id: '9418011006',
    districtId: '9418011',
    name: 'Lugwi',
  },
  {
    id: '9418011007',
    districtId: '9418011',
    name: 'Teropme',
  },
  {
    id: '9418011015',
    districtId: '9418011',
    name: 'Jigonime',
  },
  {
    id: '9418011018',
    districtId: '9418011',
    name: 'Pagona',
  },
  {
    id: '9418011019',
    districtId: '9418011',
    name: 'Mome',
  },
  {
    id: '9418011020',
    districtId: '9418011',
    name: 'Bogum',
  },
  {
    id: '9418011021',
    districtId: '9418011',
    name: 'Pindanggun',
  },
  {
    id: '9418011022',
    districtId: '9418011',
    name: 'Wonabu',
  },
  {
    id: '9418011025',
    districtId: '9418011',
    name: 'Wilileme',
  },
  {
    id: '9418011027',
    districtId: '9418011',
    name: 'Yangguni',
  },
  {
    id: '9418012001',
    districtId: '9418012',
    name: 'Nabunage',
  },
  {
    id: '9418012002',
    districtId: '9418012',
    name: 'Kutime',
  },
  {
    id: '9418012003',
    districtId: '9418012',
    name: 'Kupara',
  },
  {
    id: '9418012006',
    districtId: '9418012',
    name: 'Kumbo',
  },
  {
    id: '9418012008',
    districtId: '9418012',
    name: 'Timbindelo',
  },
  {
    id: '9418012011',
    districtId: '9418012',
    name: 'Yekito',
  },
  {
    id: '9418012012',
    districtId: '9418012',
    name: 'Missa',
  },
  {
    id: '9418012013',
    districtId: '9418012',
    name: 'Logi Lome',
  },
  {
    id: '9418012014',
    districtId: '9418012',
    name: 'Wewo',
  },
  {
    id: '9418012015',
    districtId: '9418012',
    name: 'Geningga',
  },
  {
    id: '9418012016',
    districtId: '9418012',
    name: 'Kimilo',
  },
  {
    id: '9418013001',
    districtId: '9418013',
    name: 'Martelo',
  },
  {
    id: '9418013002',
    districtId: '9418013',
    name: 'Egoni',
  },
  {
    id: '9418013004',
    districtId: '9418013',
    name: 'Tinggom',
  },
  {
    id: '9418013006',
    districtId: '9418013',
    name: 'Yakep',
  },
  {
    id: '9418013007',
    districtId: '9418013',
    name: 'Baguni',
  },
  {
    id: '9418013008',
    districtId: '9418013',
    name: 'Yamulo',
  },
  {
    id: '9418013011',
    districtId: '9418013',
    name: 'Welesi',
  },
  {
    id: '9418013012',
    districtId: '9418013',
    name: 'Orelukban',
  },
  {
    id: '9418013013',
    districtId: '9418013',
    name: 'Kulutin',
  },
  {
    id: '9418014001',
    districtId: '9418014',
    name: 'Wama',
  },
  {
    id: '9418014003',
    districtId: '9418014',
    name: 'Kwarini',
  },
  {
    id: '9418014004',
    districtId: '9418014',
    name: 'Weyage',
  },
  {
    id: '9418014006',
    districtId: '9418014',
    name: 'Wonitu',
  },
  {
    id: '9418014007',
    districtId: '9418014',
    name: 'Golena',
  },
  {
    id: '9418014008',
    districtId: '9418014',
    name: 'Korlo',
  },
  {
    id: '9418014009',
    districtId: '9418014',
    name: 'Gunalo',
  },
  {
    id: '9418014010',
    districtId: '9418014',
    name: 'Timer',
  },
  {
    id: '9418014011',
    districtId: '9418014',
    name: 'Nowo',
  },
  {
    id: '9418014012',
    districtId: '9418014',
    name: 'Gulak',
  },
  {
    id: '9418014013',
    districtId: '9418014',
    name: 'Towolome',
  },
  {
    id: '9418015003',
    districtId: '9418015',
    name: 'Posman',
  },
  {
    id: '9418015004',
    districtId: '9418015',
    name: 'Kogagi',
  },
  {
    id: '9418015005',
    districtId: '9418015',
    name: 'Tionggi',
  },
  {
    id: '9418015006',
    districtId: '9418015',
    name: 'Yeli',
  },
  {
    id: '9418015007',
    districtId: '9418015',
    name: 'Agin',
  },
  {
    id: '9418015008',
    districtId: '9418015',
    name: 'Wamigi',
  },
  {
    id: '9418015009',
    districtId: '9418015',
    name: 'Kolanggun',
  },
  {
    id: '9418015010',
    districtId: '9418015',
    name: 'Yebena',
  },
  {
    id: '9418016001',
    districtId: '9418016',
    name: 'Bogonuk',
  },
  {
    id: '9418016002',
    districtId: '9418016',
    name: 'Andomak',
  },
  {
    id: '9418016003',
    districtId: '9418016',
    name: 'Wisman',
  },
  {
    id: '9418016004',
    districtId: '9418016',
    name: 'Paba',
  },
  {
    id: '9418016005',
    districtId: '9418016',
    name: 'Ewan',
  },
  {
    id: '9418016006',
    districtId: '9418016',
    name: 'Wumelak',
  },
  {
    id: '9418016007',
    districtId: '9418016',
    name: 'Walelo',
  },
  {
    id: '9418016008',
    districtId: '9418016',
    name: 'Laura',
  },
  {
    id: '9418016009',
    districtId: '9418016',
    name: 'Talinamber',
  },
  {
    id: '9418016010',
    districtId: '9418016',
    name: 'Alinduda',
  },
  {
    id: '9418020019',
    districtId: '9418020',
    name: 'Karubaga',
  },
  {
    id: '9418020020',
    districtId: '9418020',
    name: 'Molera',
  },
  {
    id: '9418020030',
    districtId: '9418020',
    name: 'Kogimage',
  },
  {
    id: '9418020038',
    districtId: '9418020',
    name: 'Ampera',
  },
  {
    id: '9418020041',
    districtId: '9418020',
    name: 'Gininggadonak',
  },
  {
    id: '9418020042',
    districtId: '9418020',
    name: 'Danggulurik',
  },
  {
    id: '9418020043',
    districtId: '9418020',
    name: 'Gurikme',
  },
  {
    id: '9418020044',
    districtId: '9418020',
    name: 'Lirak',
  },
  {
    id: '9418020045',
    districtId: '9418020',
    name: 'Kimobur',
  },
  {
    id: '9418020046',
    districtId: '9418020',
    name: 'Muara',
  },
  {
    id: '9418020047',
    districtId: '9418020',
    name: 'Kurage Pura',
  },
  {
    id: '9418020048',
    districtId: '9418020',
    name: 'Kiranage',
  },
  {
    id: '9418020049',
    districtId: '9418020',
    name: 'Nalorini',
  },
  {
    id: '9418020050',
    districtId: '9418020',
    name: 'Bileme',
  },
  {
    id: '9418020051',
    districtId: '9418020',
    name: 'Gurikagewak',
  },
  {
    id: '9418020052',
    districtId: '9418020',
    name: 'Luwik',
  },
  {
    id: '9418020055',
    districtId: '9418020',
    name: 'Elsadai',
  },
  {
    id: '9418020056',
    districtId: '9418020',
    name: 'Ebenhaizer',
  },
  {
    id: '9418020057',
    districtId: '9418020',
    name: 'Kolilan',
  },
  {
    id: '9418020059',
    districtId: '9418020',
    name: 'Kuluname',
  },
  {
    id: '9418020060',
    districtId: '9418020',
    name: 'Pulanggun',
  },
  {
    id: '9418020062',
    districtId: '9418020',
    name: 'Longgoalome',
  },
  {
    id: '9418020063',
    districtId: '9418020',
    name: 'Wanimo',
  },
  {
    id: '9418021001',
    districtId: '9418021',
    name: 'Doge',
  },
  {
    id: '9418021002',
    districtId: '9418021',
    name: 'Tiri',
  },
  {
    id: '9418021003',
    districtId: '9418021',
    name: 'Yemarima',
  },
  {
    id: '9418021004',
    districtId: '9418021',
    name: 'Dugi',
  },
  {
    id: '9418021005',
    districtId: '9418021',
    name: 'Tigikun',
  },
  {
    id: '9418021009',
    districtId: '9418021',
    name: 'Goyage',
  },
  {
    id: '9418021010',
    districtId: '9418021',
    name: 'Benari',
  },
  {
    id: '9418021011',
    districtId: '9418021',
    name: 'Wijamurik',
  },
  {
    id: '9418021012',
    districtId: '9418021',
    name: 'Tigir',
  },
  {
    id: '9418021013',
    districtId: '9418021',
    name: 'Bopa',
  },
  {
    id: '9418021014',
    districtId: '9418021',
    name: 'Angkasa',
  },
  {
    id: '9418021015',
    districtId: '9418021',
    name: 'Gilok',
  },
  {
    id: '9418021016',
    districtId: '9418021',
    name: 'Woji',
  },
  {
    id: '9418021017',
    districtId: '9418021',
    name: 'Mampulaga',
  },
  {
    id: '9418021018',
    districtId: '9418021',
    name: 'Tidur Mabuk',
  },
  {
    id: '9418021019',
    districtId: '9418021',
    name: 'Bini',
  },
  {
    id: '9418021020',
    districtId: '9418021',
    name: 'Didelonik',
  },
  {
    id: '9418021022',
    districtId: '9418021',
    name: 'Peko',
  },
  {
    id: '9418022002',
    districtId: '9418022',
    name: 'Arombok',
  },
  {
    id: '9418022003',
    districtId: '9418022',
    name: 'Wurineri',
  },
  {
    id: '9418022007',
    districtId: '9418022',
    name: 'Pokegi',
  },
  {
    id: '9418022011',
    districtId: '9418022',
    name: 'Enanagi',
  },
  {
    id: '9418022012',
    districtId: '9418022',
    name: 'Keribaga',
  },
  {
    id: '9418022014',
    districtId: '9418022',
    name: 'Pindak',
  },
  {
    id: '9418022015',
    districtId: '9418022',
    name: 'Gilopaga',
  },
  {
    id: '9418022016',
    districtId: '9418022',
    name: 'Wona',
  },
  {
    id: '9418022017',
    districtId: '9418022',
    name: 'Numboboton',
  },
  {
    id: '9418023001',
    districtId: '9418023',
    name: 'Arulo',
  },
  {
    id: '9418023002',
    districtId: '9418023',
    name: 'Konda',
  },
  {
    id: '9418023005',
    districtId: '9418023',
    name: 'Mandura',
  },
  {
    id: '9418023006',
    districtId: '9418023',
    name: 'Mowilome',
  },
  {
    id: '9418023007',
    districtId: '9418023',
    name: 'Arumagi',
  },
  {
    id: '9418023010',
    districtId: '9418023',
    name: 'Gimo',
  },
  {
    id: '9418023011',
    districtId: '9418023',
    name: 'Silabula',
  },
  {
    id: '9418023012',
    districtId: '9418023',
    name: 'Arikoba',
  },
  {
    id: '9418023013',
    districtId: '9418023',
    name: 'Tingapura',
  },
  {
    id: '9418023014',
    districtId: '9418023',
    name: 'Ganage',
  },
  {
    id: '9418023015',
    districtId: '9418023',
    name: 'Yawineri',
  },
  {
    id: '9418024001',
    districtId: '9418024',
    name: 'Timojino',
  },
  {
    id: '9418024002',
    districtId: '9418024',
    name: 'Mondagul',
  },
  {
    id: '9418024005',
    districtId: '9418024',
    name: 'Tabowanimbo',
  },
  {
    id: '9418024006',
    districtId: '9418024',
    name: 'Nelawi',
  },
  {
    id: '9418024007',
    districtId: '9418024',
    name: 'Woromolome',
  },
  {
    id: '9418024008',
    districtId: '9418024',
    name: 'Kendemeya',
  },
  {
    id: '9418024009',
    districtId: '9418024',
    name: 'Palagi',
  },
  {
    id: '9418024010',
    districtId: '9418024',
    name: 'Megapura',
  },
  {
    id: '9418024015',
    districtId: '9418024',
    name: 'Wabuna',
  },
  {
    id: '9418024016',
    districtId: '9418024',
    name: 'Minagame',
  },
  {
    id: '9418024017',
    districtId: '9418024',
    name: 'Berename',
  },
  {
    id: '9418024018',
    districtId: '9418024',
    name: 'Yilogonime',
  },
  {
    id: '9418025001',
    districtId: '9418025',
    name: 'Menggeba',
  },
  {
    id: '9418025002',
    districtId: '9418025',
    name: 'Alopur',
  },
  {
    id: '9418025003',
    districtId: '9418025',
    name: 'Kuari',
  },
  {
    id: '9418025005',
    districtId: '9418025',
    name: 'Wanggugup',
  },
  {
    id: '9418025006',
    districtId: '9418025',
    name: 'Baliminggi',
  },
  {
    id: '9418025007',
    districtId: '9418025',
    name: 'Abepur',
  },
  {
    id: '9418025008',
    districtId: '9418025',
    name: 'Markar',
  },
  {
    id: '9418025009',
    districtId: '9418025',
    name: 'Umaga',
  },
  {
    id: '9418025010',
    districtId: '9418025',
    name: 'Kurik',
  },
  {
    id: '9418025012',
    districtId: '9418025',
    name: 'Menggenagame',
  },
  {
    id: '9418025013',
    districtId: '9418025',
    name: 'Luanggi',
  },
  {
    id: '9418025014',
    districtId: '9418025',
    name: 'Kondegun',
  },
  {
    id: '9418025015',
    districtId: '9418025',
    name: 'Jinulira',
  },
  {
    id: '9418025016',
    districtId: '9418025',
    name: 'Gubagi',
  },
  {
    id: '9418025017',
    districtId: '9418025',
    name: 'Tebenalo',
  },
  {
    id: '9418025018',
    districtId: '9418025',
    name: 'Kibur',
  },
  {
    id: '9418026001',
    districtId: '9418026',
    name: 'Aburage',
  },
  {
    id: '9418026002',
    districtId: '9418026',
    name: 'Wiyaluk',
  },
  {
    id: '9418026003',
    districtId: '9418026',
    name: 'Kogoyapura',
  },
  {
    id: '9418026004',
    districtId: '9418026',
    name: 'Tingwi',
  },
  {
    id: '9418026005',
    districtId: '9418026',
    name: 'Longgoboma',
  },
  {
    id: '9418026006',
    districtId: '9418026',
    name: 'Gubura',
  },
  {
    id: '9418026007',
    districtId: '9418026',
    name: 'Bogome',
  },
  {
    id: '9418026009',
    districtId: '9418026',
    name: 'Erimbur',
  },
  {
    id: '9418026010',
    districtId: '9418026',
    name: 'Megagirakuk',
  },
  {
    id: '9418027001',
    districtId: '9418027',
    name: 'Tomagipura',
  },
  {
    id: '9418027002',
    districtId: '9418027',
    name: 'Biuk',
  },
  {
    id: '9418027003',
    districtId: '9418027',
    name: 'Guburini',
  },
  {
    id: '9418027004',
    districtId: '9418027',
    name: 'Galuguk',
  },
  {
    id: '9418027005',
    districtId: '9418027',
    name: 'Wonabu',
  },
  {
    id: '9418027006',
    districtId: '9418027',
    name: 'Yugumabur',
  },
  {
    id: '9418027007',
    districtId: '9418027',
    name: 'Yiluk',
  },
  {
    id: '9418027008',
    districtId: '9418027',
    name: 'Binime',
  },
  {
    id: '9418027009',
    districtId: '9418027',
    name: 'Yiogobak',
  },
  {
    id: '9418027010',
    districtId: '9418027',
    name: 'Purugi',
  },
  {
    id: '9418027011',
    districtId: '9418027',
    name: 'Tomagi',
  },
  {
    id: '9418030003',
    districtId: '9418030',
    name: 'Mingganggo',
  },
  {
    id: '9418030004',
    districtId: '9418030',
    name: 'Apiam',
  },
  {
    id: '9418030005',
    districtId: '9418030',
    name: 'Umage',
  },
  {
    id: '9418030006',
    districtId: '9418030',
    name: 'Bokondini',
  },
  {
    id: '9418030007',
    districtId: '9418030',
    name: 'Galala',
  },
  {
    id: '9418030008',
    districtId: '9418030',
    name: 'Mairini',
  },
  {
    id: '9418030022',
    districtId: '9418030',
    name: 'Tenggama',
  },
  {
    id: '9418030023',
    districtId: '9418030',
    name: 'Kologume',
  },
  {
    id: '9418030024',
    districtId: '9418030',
    name: 'Lambogo',
  },
  {
    id: '9418030025',
    districtId: '9418030',
    name: 'Dunduma',
  },
  {
    id: '9418030026',
    districtId: '9418030',
    name: 'Jawalene',
  },
  {
    id: '9418031001',
    districtId: '9418031',
    name: 'Bokoneri',
  },
  {
    id: '9418031002',
    districtId: '9418031',
    name: 'Donggem',
  },
  {
    id: '9418031003',
    districtId: '9418031',
    name: 'Munagame',
  },
  {
    id: '9418031004',
    districtId: '9418031',
    name: 'Abimbak',
  },
  {
    id: '9418031006',
    districtId: '9418031',
    name: 'Kanewunuk',
  },
  {
    id: '9418031007',
    districtId: '9418031',
    name: 'Nanggurilime',
  },
  {
    id: '9418031008',
    districtId: '9418031',
    name: 'Omuk',
  },
  {
    id: '9418031009',
    districtId: '9418031',
    name: 'Durima',
  },
  {
    id: '9418031011',
    districtId: '9418031',
    name: 'Bolly',
  },
  {
    id: '9418031012',
    districtId: '9418031',
    name: 'Nunggalo',
  },
  {
    id: '9418031013',
    districtId: '9418031',
    name: 'Weri',
  },
  {
    id: '9418031014',
    districtId: '9418031',
    name: 'Tanabume',
  },
  {
    id: '9418031015',
    districtId: '9418031',
    name: 'Kanere',
  },
  {
    id: '9418031016',
    districtId: '9418031',
    name: 'Wonaga',
  },
  {
    id: '9418031017',
    districtId: '9418031',
    name: 'Waringga',
  },
  {
    id: '9418032001',
    districtId: '9418032',
    name: 'Wanggulam',
  },
  {
    id: '9418032002',
    districtId: '9418032',
    name: 'Nogobumbu',
  },
  {
    id: '9418032003',
    districtId: '9418032',
    name: 'Gabunggobak',
  },
  {
    id: '9418032004',
    districtId: '9418032',
    name: 'Bilubaga',
  },
  {
    id: '9418032005',
    districtId: '9418032',
    name: 'Bitilabur',
  },
  {
    id: '9418032006',
    districtId: '9418032',
    name: 'Abena',
  },
  {
    id: '9418032007',
    districtId: '9418032',
    name: 'Wulurik',
  },
  {
    id: '9418032008',
    districtId: '9418032',
    name: 'Arelam',
  },
  {
    id: '9418032009',
    districtId: '9418032',
    name: 'Gelalo',
  },
  {
    id: '9418032010',
    districtId: '9418032',
    name: 'Yibalo',
  },
  {
    id: '9418032011',
    districtId: '9418032',
    name: 'Windik',
  },
  {
    id: '9418032012',
    districtId: '9418032',
    name: 'Yinama',
  },
  {
    id: '9418032013',
    districtId: '9418032',
    name: 'Duma',
  },
  {
    id: '9418032014',
    districtId: '9418032',
    name: 'Wania',
  },
  {
    id: '9418040001',
    districtId: '9418040',
    name: 'Nugari',
  },
  {
    id: '9418040006',
    districtId: '9418040',
    name: 'Mamit',
  },
  {
    id: '9418040012',
    districtId: '9418040',
    name: 'Yowo',
  },
  {
    id: '9418040013',
    districtId: '9418040',
    name: 'Tioga',
  },
  {
    id: '9418040030',
    districtId: '9418040',
    name: 'Kobon',
  },
  {
    id: '9418040034',
    districtId: '9418040',
    name: 'Kabori',
  },
  {
    id: '9418040035',
    districtId: '9418040',
    name: 'Genani',
  },
  {
    id: '9418040036',
    districtId: '9418040',
    name: 'Wulinaga',
  },
  {
    id: '9418040038',
    districtId: '9418040',
    name: 'Aworera',
  },
  {
    id: '9418040040',
    districtId: '9418040',
    name: 'Agimdek',
  },
  {
    id: '9418041002',
    districtId: '9418041',
    name: 'Gualo',
  },
  {
    id: '9418041003',
    districtId: '9418041',
    name: 'Dimbugul',
  },
  {
    id: '9418041005',
    districtId: '9418041',
    name: 'Yogweme',
  },
  {
    id: '9418041007',
    districtId: '9418041',
    name: 'Wina',
  },
  {
    id: '9418041008',
    districtId: '9418041',
    name: 'Yugumengga',
  },
  {
    id: '9418041009',
    districtId: '9418041',
    name: 'Wariru',
  },
  {
    id: '9418041011',
    districtId: '9418041',
    name: 'Akima',
  },
  {
    id: '9418041012',
    districtId: '9418041',
    name: 'Malela',
  },
  {
    id: '9418041013',
    districtId: '9418041',
    name: 'Nakwil',
  },
  {
    id: '9418041014',
    districtId: '9418041',
    name: 'Finai',
  },
  {
    id: '9418041015',
    districtId: '9418041',
    name: 'Holandia',
  },
  {
    id: '9418041016',
    districtId: '9418041',
    name: 'Tawi',
  },
  {
    id: '9418042003',
    districtId: '9418042',
    name: 'Umagi',
  },
  {
    id: '9418042004',
    districtId: '9418042',
    name: 'Nolopur',
  },
  {
    id: '9418042005',
    districtId: '9418042',
    name: 'Nambu',
  },
  {
    id: '9418042006',
    districtId: '9418042',
    name: 'Yali',
  },
  {
    id: '9418042007',
    districtId: '9418042',
    name: 'Yalume',
  },
  {
    id: '9418042008',
    districtId: '9418042',
    name: 'Gatini',
  },
  {
    id: '9418042009',
    districtId: '9418042',
    name: 'Pagongga',
  },
  {
    id: '9418042010',
    districtId: '9418042',
    name: 'Mino',
  },
  {
    id: '9418042011',
    districtId: '9418042',
    name: 'Gurin',
  },
  {
    id: '9418042012',
    districtId: '9418042',
    name: 'Wama',
  },
  {
    id: '9418042014',
    districtId: '9418042',
    name: 'Popaga',
  },
  {
    id: '9418042015',
    districtId: '9418042',
    name: 'Piriluk',
  },
  {
    id: '9418043003',
    districtId: '9418043',
    name: 'Panaga',
  },
  {
    id: '9418043004',
    districtId: '9418043',
    name: 'Ibunuh',
  },
  {
    id: '9418043006',
    districtId: '9418043',
    name: 'Siak',
  },
  {
    id: '9418043007',
    districtId: '9418043',
    name: 'Eragani Satu',
  },
  {
    id: '9418043009',
    districtId: '9418043',
    name: 'Saksi Meler',
  },
  {
    id: '9418043010',
    districtId: '9418043',
    name: 'Kutiom',
  },
  {
    id: '9418043014',
    districtId: '9418043',
    name: 'Poido',
  },
  {
    id: '9418043016',
    districtId: '9418043',
    name: 'Yandono',
  },
  {
    id: '9418044001',
    districtId: '9418044',
    name: 'Gagulineri',
  },
  {
    id: '9418044002',
    districtId: '9418044',
    name: 'Telekonok',
  },
  {
    id: '9418044003',
    districtId: '9418044',
    name: 'Kuoklanggunik',
  },
  {
    id: '9418044004',
    districtId: '9418044',
    name: 'Bogokila',
  },
  {
    id: '9418044005',
    districtId: '9418044',
    name: 'Mabuk',
  },
  {
    id: '9418044006',
    districtId: '9418044',
    name: 'Nugari',
  },
  {
    id: '9418044007',
    districtId: '9418044',
    name: 'Genage',
  },
  {
    id: '9418044008',
    districtId: '9418044',
    name: 'Gindugunik',
  },
  {
    id: '9418044009',
    districtId: '9418044',
    name: 'Tigir',
  },
  {
    id: '9418044010',
    districtId: '9418044',
    name: 'Konengga',
  },
  {
    id: '9418045001',
    districtId: '9418045',
    name: 'Berembanak',
  },
  {
    id: '9418045002',
    districtId: '9418045',
    name: 'Habagi',
  },
  {
    id: '9418045004',
    districtId: '9418045',
    name: 'Kekoli',
  },
  {
    id: '9418045005',
    districtId: '9418045',
    name: 'Kamboniki',
  },
  {
    id: '9418045007',
    districtId: '9418045',
    name: 'Tari',
  },
  {
    id: '9418045008',
    districtId: '9418045',
    name: 'Kaloniki',
  },
  {
    id: '9418045009',
    districtId: '9418045',
    name: 'Marbuna',
  },
  {
    id: '9418045010',
    districtId: '9418045',
    name: 'Malta',
  },
  {
    id: '9418046001',
    districtId: '9418046',
    name: 'Tabowanimbo',
  },
  {
    id: '9418046002',
    districtId: '9418046',
    name: 'Onggokme',
  },
  {
    id: '9418046003',
    districtId: '9418046',
    name: 'Wenduri',
  },
  {
    id: '9418046007',
    districtId: '9418046',
    name: 'Liwese',
  },
  {
    id: '9418046009',
    districtId: '9418046',
    name: 'Tinger',
  },
  {
    id: '9418047001',
    districtId: '9418047',
    name: 'Bijere',
  },
  {
    id: '9418047002',
    districtId: '9418047',
    name: 'Takri',
  },
  {
    id: '9418047003',
    districtId: '9418047',
    name: 'Prawa',
  },
  {
    id: '9418047004',
    districtId: '9418047',
    name: 'Sigou',
  },
  {
    id: '9418047005',
    districtId: '9418047',
    name: 'Dagari',
  },
  {
    id: '9418047006',
    districtId: '9418047',
    name: 'Warka',
  },
  {
    id: '9418047007',
    districtId: '9418047',
    name: 'Pakare',
  },
  {
    id: '9418047008',
    districtId: '9418047',
    name: 'Tigou',
  },
  {
    id: '9418047009',
    districtId: '9418047',
    name: 'Bire',
  },
  {
    id: '9418047010',
    districtId: '9418047',
    name: 'Itoli',
  },
  {
    id: '9418047011',
    districtId: '9418047',
    name: 'Vakuyo',
  },
  {
    id: '9418048001',
    districtId: '9418048',
    name: 'Wari',
  },
  {
    id: '9418048002',
    districtId: '9418048',
    name: 'Papedari',
  },
  {
    id: '9418048003',
    districtId: '9418048',
    name: 'Dotori',
  },
  {
    id: '9418048004',
    districtId: '9418048',
    name: 'Timoga',
  },
  {
    id: '9418048005',
    districtId: '9418048',
    name: 'Kowari',
  },
  {
    id: '9418048006',
    districtId: '9418048',
    name: 'Wiki',
  },
  {
    id: '9418048008',
    districtId: '9418048',
    name: 'Friji',
  },
  {
    id: '9418048009',
    districtId: '9418048',
    name: 'Dorera',
  },
  {
    id: '9418048010',
    districtId: '9418048',
    name: 'Yanora',
  },
  {
    id: '9418048011',
    districtId: '9418048',
    name: 'Muna',
  },
  {
    id: '9418048012',
    districtId: '9418048',
    name: 'Beleise',
  },
  {
    id: '9418048013',
    districtId: '9418048',
    name: 'Kalibu',
  },
  {
    id: '9418048014',
    districtId: '9418048',
    name: 'Yamiriko',
  },
  {
    id: '9418048015',
    districtId: '9418048',
    name: 'Ninggame',
  },
  {
    id: '9418048016',
    districtId: '9418048',
    name: 'Laniloma',
  },
  {
    id: '9418048017',
    districtId: '9418048',
    name: 'Wakumeder',
  },
  {
    id: '9418049002',
    districtId: '9418049',
    name: 'Maburuk',
  },
  {
    id: '9418049003',
    districtId: '9418049',
    name: 'Dare',
  },
  {
    id: '9418049004',
    districtId: '9418049',
    name: 'Rogia',
  },
  {
    id: '9418049005',
    districtId: '9418049',
    name: 'Seriau',
  },
  {
    id: '9418049006',
    districtId: '9418049',
    name: 'Irege',
  },
  {
    id: '9418049008',
    districtId: '9418049',
    name: 'Kondala',
  },
  {
    id: '9418049009',
    districtId: '9418049',
    name: 'Yonira',
  },
  {
    id: '9418049010',
    districtId: '9418049',
    name: 'Tabonakme',
  },
  {
    id: '9418051002',
    districtId: '9418051',
    name: 'Nunggawi',
  },
  {
    id: '9418051003',
    districtId: '9418051',
    name: 'Kokondao',
  },
  {
    id: '9418051004',
    districtId: '9418051',
    name: 'Wondame',
  },
  {
    id: '9418051005',
    districtId: '9418051',
    name: 'Kuripa',
  },
  {
    id: '9418051006',
    districtId: '9418051',
    name: 'Kimobur',
  },
  {
    id: '9418051007',
    districtId: '9418051',
    name: 'Timobur',
  },
  {
    id: '9418051008',
    districtId: '9418051',
    name: 'Kilungga',
  },
  {
    id: '9418051009',
    districtId: '9418051',
    name: 'Nombori',
  },
  {
    id: '9418051010',
    districtId: '9418051',
    name: 'Delelah',
  },
  {
    id: '9418051011',
    districtId: '9418051',
    name: 'Gilo',
  },
  {
    id: '9418051012',
    districtId: '9418051',
    name: 'Undi',
  },
  {
    id: '9418051015',
    districtId: '9418051',
    name: 'Kanggineri',
  },
  {
    id: '9418051016',
    districtId: '9418051',
    name: 'Wonoluk',
  },
  {
    id: '9418051017',
    districtId: '9418051',
    name: 'Berenggo',
  },
  {
    id: '9418051018',
    districtId: '9418051',
    name: 'Tunibur',
  },
  {
    id: '9418051019',
    districtId: '9418051',
    name: 'Woyi',
  },
  {
    id: '9418051020',
    districtId: '9418051',
    name: 'Kubalo',
  },
  {
    id: '9418051021',
    districtId: '9418051',
    name: 'Tinowene',
  },
  {
    id: '9418051022',
    districtId: '9418051',
    name: 'Mololowa',
  },
  {
    id: '9418051023',
    districtId: '9418051',
    name: 'Konipaga',
  },
  {
    id: '9418051024',
    districtId: '9418051',
    name: 'Kabomangen',
  },
  {
    id: '9418051025',
    districtId: '9418051',
    name: 'Kondangwi',
  },
  {
    id: '9418051026',
    districtId: '9418051',
    name: 'Kipino',
  },
  {
    id: '9418060002',
    districtId: '9418060',
    name: 'Aruku',
  },
  {
    id: '9418060005',
    districtId: '9418060',
    name: 'Kubugiwa',
  },
  {
    id: '9418060010',
    districtId: '9418060',
    name: 'Minagi',
  },
  {
    id: '9418060011',
    districtId: '9418060',
    name: 'Menggenagi',
  },
  {
    id: '9418060012',
    districtId: '9418060',
    name: 'Kalewi',
  },
  {
    id: '9418060014',
    districtId: '9418060',
    name: 'Tiyangupur',
  },
  {
    id: '9418060015',
    districtId: '9418060',
    name: 'Numbugawi',
  },
  {
    id: '9418060026',
    districtId: '9418060',
    name: 'Genipur',
  },
  {
    id: '9418061001',
    districtId: '9418061',
    name: 'Yalipura',
  },
  {
    id: '9418061002',
    districtId: '9418061',
    name: 'Anawi',
  },
  {
    id: '9418061003',
    districtId: '9418061',
    name: 'Kotori',
  },
  {
    id: '9418061004',
    districtId: '9418061',
    name: 'Linggir',
  },
  {
    id: '9418061005',
    districtId: '9418061',
    name: 'Imurik',
  },
  {
    id: '9418061006',
    districtId: '9418061',
    name: 'Talikobak',
  },
  {
    id: '9418061007',
    districtId: '9418061',
    name: 'Gineri',
  },
  {
    id: '9418061008',
    districtId: '9418061',
    name: 'Loguk',
  },
  {
    id: '9418061009',
    districtId: '9418061',
    name: 'Bieleme',
  },
  {
    id: '9418061010',
    districtId: '9418061',
    name: 'Aridunda',
  },
  {
    id: '9418062001',
    districtId: '9418062',
    name: 'Pindelo',
  },
  {
    id: '9418062002',
    districtId: '9418062',
    name: 'Wugi',
  },
  {
    id: '9418062003',
    districtId: '9418062',
    name: 'Lena',
  },
  {
    id: '9418062004',
    districtId: '9418062',
    name: 'Kuagembur',
  },
  {
    id: '9418062005',
    districtId: '9418062',
    name: 'Loma',
  },
  {
    id: '9418062006',
    districtId: '9418062',
    name: 'Gitar',
  },
  {
    id: '9418062007',
    districtId: '9418062',
    name: 'Gilome',
  },
  {
    id: '9418062008',
    districtId: '9418062',
    name: 'Timoneri',
  },
  {
    id: '9418062009',
    districtId: '9418062',
    name: 'Wuronggi / Wuragi',
  },
  {
    id: '9418062010',
    districtId: '9418062',
    name: 'Buang Luda',
  },
  {
    id: '9418062011',
    districtId: '9418062',
    name: 'Koli',
  },
  {
    id: '9418070001',
    districtId: '9418070',
    name: 'Timori',
  },
  {
    id: '9418070003',
    districtId: '9418070',
    name: 'Geya',
  },
  {
    id: '9418070004',
    districtId: '9418070',
    name: 'Alobaga',
  },
  {
    id: '9418070005',
    districtId: '9418070',
    name: 'Nawu',
  },
  {
    id: '9418070006',
    districtId: '9418070',
    name: 'Tinagoga',
  },
  {
    id: '9418070007',
    districtId: '9418070',
    name: 'Witipur',
  },
  {
    id: '9418070009',
    districtId: '9418070',
    name: 'Winalo',
  },
  {
    id: '9418070011',
    districtId: '9418070',
    name: 'Kibu',
  },
  {
    id: '9418070012',
    districtId: '9418070',
    name: 'Wunggilipur',
  },
  {
    id: '9418070013',
    districtId: '9418070',
    name: 'Weyambi',
  },
  {
    id: '9418070018',
    districtId: '9418070',
    name: 'Dimbara',
  },
  {
    id: '9418071001',
    districtId: '9418071',
    name: 'Tina',
  },
  {
    id: '9418071002',
    districtId: '9418071',
    name: 'Mili',
  },
  {
    id: '9418071003',
    districtId: '9418071',
    name: 'Telalome',
  },
  {
    id: '9418071004',
    districtId: '9418071',
    name: 'Milineri',
  },
  {
    id: '9418071005',
    districtId: '9418071',
    name: 'Baganagapura',
  },
  {
    id: '9418071006',
    districtId: '9418071',
    name: 'Gayarai',
  },
  {
    id: '9418071007',
    districtId: '9418071',
    name: 'Kopenawi',
  },
  {
    id: '9418071008',
    districtId: '9418071',
    name: 'Banggeri',
  },
  {
    id: '9418071009',
    districtId: '9418071',
    name: 'Igari',
  },
  {
    id: '9418071010',
    districtId: '9418071',
    name: 'Wunggi',
  },
  {
    id: '9418080001',
    districtId: '9418080',
    name: 'Numba',
  },
  {
    id: '9418080005',
    districtId: '9418080',
    name: 'Baliminggi',
  },
  {
    id: '9418080006',
    districtId: '9418080',
    name: 'Kuma',
  },
  {
    id: '9418080007',
    districtId: '9418080',
    name: 'Yugumena',
  },
  {
    id: '9418080009',
    districtId: '9418080',
    name: 'Yalogo',
  },
  {
    id: '9418080011',
    districtId: '9418080',
    name: 'Yiragame',
  },
  {
    id: '9418080012',
    districtId: '9418080',
    name: 'Tingwineri',
  },
  {
    id: '9418080013',
    districtId: '9418080',
    name: 'Guniki',
  },
  {
    id: '9418080014',
    districtId: '9418080',
    name: 'Karagigelok',
  },
  {
    id: '9418080015',
    districtId: '9418080',
    name: 'Jinuwanu',
  },
  {
    id: '9418081001',
    districtId: '9418081',
    name: 'Kaiga',
  },
  {
    id: '9418081002',
    districtId: '9418081',
    name: 'Bawi',
  },
  {
    id: '9418081003',
    districtId: '9418081',
    name: 'Tina',
  },
  {
    id: '9418081004',
    districtId: '9418081',
    name: 'Kurbaya',
  },
  {
    id: '9418081005',
    districtId: '9418081',
    name: 'Wiyangger',
  },
  {
    id: '9418081006',
    districtId: '9418081',
    name: 'Piralome',
  },
  {
    id: '9418081007',
    districtId: '9418081',
    name: 'Wolu',
  },
  {
    id: '9418081008',
    districtId: '9418081',
    name: 'Kotorambur',
  },
  {
    id: '9418081009',
    districtId: '9418081',
    name: 'Tunggunale',
  },
  {
    id: '9418081010',
    districtId: '9418081',
    name: 'Agian',
  },
  {
    id: '9418090004',
    districtId: '9418090',
    name: 'Nugini',
  },
  {
    id: '9418090006',
    districtId: '9418090',
    name: 'Yiku',
  },
  {
    id: '9418090007',
    districtId: '9418090',
    name: 'Nilogabu',
  },
  {
    id: '9418090008',
    districtId: '9418090',
    name: 'Nakwi',
  },
  {
    id: '9418090009',
    districtId: '9418090',
    name: 'Nini',
  },
  {
    id: '9418090011',
    districtId: '9418090',
    name: 'Bimo',
  },
  {
    id: '9418090012',
    districtId: '9418090',
    name: 'Dugunagep',
  },
  {
    id: '9418100001',
    districtId: '9418100',
    name: 'Woraga',
  },
  {
    id: '9418100002',
    districtId: '9418100',
    name: 'Wamolo',
  },
  {
    id: '9418100003',
    districtId: '9418100',
    name: 'Kalarin',
  },
  {
    id: '9418100005',
    districtId: '9418100',
    name: 'Umar',
  },
  {
    id: '9418100006',
    districtId: '9418100',
    name: 'Winengga',
  },
  {
    id: '9418100007',
    districtId: '9418100',
    name: 'Wobe',
  },
  {
    id: '9418100008',
    districtId: '9418100',
    name: 'Gingga',
  },
  {
    id: '9418100009',
    districtId: '9418100',
    name: 'Punggelak',
  },
  {
    id: '9418100010',
    districtId: '9418100',
    name: 'Kurik',
  },
  {
    id: '9418100011',
    districtId: '9418100',
    name: 'Gumbini',
  },
  {
    id: '9418100012',
    districtId: '9418100',
    name: 'Muruneri',
  },
  {
    id: '9418100013',
    districtId: '9418100',
    name: 'Nangga',
  },
  {
    id: '9418100014',
    districtId: '9418100',
    name: 'Enggawogo',
  },
  {
    id: '9418100015',
    districtId: '9418100',
    name: 'Aworera',
  },
  {
    id: '9418100016',
    districtId: '9418100',
    name: 'Wamili',
  },
  {
    id: '9418100017',
    districtId: '9418100',
    name: 'Oker',
  },
  {
    id: '9418110002',
    districtId: '9418110',
    name: 'Tirib',
  },
  {
    id: '9418110003',
    districtId: '9418110',
    name: 'Beremo',
  },
  {
    id: '9418110004',
    districtId: '9418110',
    name: 'Bolobur',
  },
  {
    id: '9418110005',
    districtId: '9418110',
    name: 'Luki',
  },
  {
    id: '9418110007',
    districtId: '9418110',
    name: 'Tioner',
  },
  {
    id: '9418110009',
    districtId: '9418110',
    name: 'Liwina',
  },
  {
    id: '9418110010',
    districtId: '9418110',
    name: 'Eragani',
  },
  {
    id: '9418110011',
    districtId: '9418110',
    name: 'Pirage',
  },
  {
    id: '9418110012',
    districtId: '9418110',
    name: 'Logulo',
  },
  {
    id: '9418110013',
    districtId: '9418110',
    name: 'Bawi',
  },
  {
    id: '9418110014',
    districtId: '9418110',
    name: 'Koinggambu',
  },
  {
    id: '9418121001',
    districtId: '9418121',
    name: 'Gembilome',
  },
  {
    id: '9418121002',
    districtId: '9418121',
    name: 'Yido',
  },
  {
    id: '9418121003',
    districtId: '9418121',
    name: 'Omimbur',
  },
  {
    id: '9418121004',
    districtId: '9418121',
    name: 'Mopi / Yuniki',
  },
  {
    id: '9418121005',
    districtId: '9418121',
    name: 'Wenome',
  },
  {
    id: '9418121006',
    districtId: '9418121',
    name: 'Wonabunggame',
  },
  {
    id: '9418121007',
    districtId: '9418121',
    name: 'Tenabaga',
  },
  {
    id: '9418121009',
    districtId: '9418121',
    name: 'Kanggilo',
  },
  {
    id: '9418121010',
    districtId: '9418121',
    name: 'Yudimba',
  },
  {
    id: '9418121011',
    districtId: '9418121',
    name: 'Umar',
  },
  {
    id: '9418125002',
    districtId: '9418125',
    name: 'Kandimbaga',
  },
  {
    id: '9418125004',
    districtId: '9418125',
    name: 'Gabunam',
  },
  {
    id: '9418125005',
    districtId: '9418125',
    name: 'Gulak',
  },
  {
    id: '9418125006',
    districtId: '9418125',
    name: 'Kogotime',
  },
  {
    id: '9418125007',
    districtId: '9418125',
    name: 'Melaga',
  },
  {
    id: '9418125008',
    districtId: '9418125',
    name: 'Peyola',
  },
  {
    id: '9418125009',
    districtId: '9418125',
    name: 'Ekoni',
  },
  {
    id: '9418125010',
    districtId: '9418125',
    name: 'Belela',
  },
  {
    id: '9418126001',
    districtId: '9418126',
    name: 'Milipaa',
  },
  {
    id: '9418126002',
    districtId: '9418126',
    name: 'Wania',
  },
  {
    id: '9418126003',
    districtId: '9418126',
    name: 'Niagale',
  },
  {
    id: '9418126004',
    districtId: '9418126',
    name: 'Tarawi',
  },
  {
    id: '9418126006',
    districtId: '9418126',
    name: 'Ambena',
  },
  {
    id: '9418126007',
    districtId: '9418126',
    name: 'Gunombo',
  },
  {
    id: '9418126008',
    districtId: '9418126',
    name: 'Mawi',
  },
  {
    id: '9418126009',
    districtId: '9418126',
    name: 'Ripa',
  },
  {
    id: '9418126010',
    districtId: '9418126',
    name: 'Delegari',
  },
  {
    id: '9418127001',
    districtId: '9418127',
    name: 'Pekaleme',
  },
  {
    id: '9418127002',
    districtId: '9418127',
    name: 'Taleme',
  },
  {
    id: '9418127003',
    districtId: '9418127',
    name: 'Giko',
  },
  {
    id: '9418127005',
    districtId: '9418127',
    name: 'Kotorambur',
  },
  {
    id: '9418127006',
    districtId: '9418127',
    name: 'Minagame',
  },
  {
    id: '9418127007',
    districtId: '9418127',
    name: 'Karu',
  },
  {
    id: '9418127008',
    districtId: '9418127',
    name: 'Tabuh',
  },
  {
    id: '9418127009',
    districtId: '9418127',
    name: 'Gwak Dugunik',
  },
  {
    id: '9418127011',
    districtId: '9418127',
    name: 'Ambirik',
  },
  {
    id: '9418541002',
    districtId: '9418541',
    name: 'Linggira',
  },
  {
    id: '9418541003',
    districtId: '9418541',
    name: 'Wekaru',
  },
  {
    id: '9418541004',
    districtId: '9418541',
    name: 'Kagi',
  },
  {
    id: '9418541008',
    districtId: '9418541',
    name: 'Alukuni',
  },
  {
    id: '9418541010',
    districtId: '9418541',
    name: 'Yagagobak',
  },
  {
    id: '9418542001',
    districtId: '9418542',
    name: 'Gelok',
  },
  {
    id: '9418542002',
    districtId: '9418542',
    name: 'Yinuwanu',
  },
  {
    id: '9418542003',
    districtId: '9418542',
    name: 'Makido',
  },
  {
    id: '9418542004',
    districtId: '9418542',
    name: 'Kwa',
  },
  {
    id: '9418542005',
    districtId: '9418542',
    name: 'Geka',
  },
  {
    id: '9418542006',
    districtId: '9418542',
    name: 'Dimbara',
  },
  {
    id: '9418542007',
    districtId: '9418542',
    name: 'Wanuwi',
  },
  {
    id: '9418542009',
    districtId: '9418542',
    name: 'Tabunakme',
  },
  {
    id: '9418542010',
    districtId: '9418542',
    name: 'Mamberamongen',
  },
  {
    id: '9418543007',
    districtId: '9418543',
    name: 'Silo',
  },
  {
    id: '9418543008',
    districtId: '9418543',
    name: 'Logi',
  },
  {
    id: '9418543009',
    districtId: '9418543',
    name: 'Tagi',
  },
  {
    id: '9418543011',
    districtId: '9418543',
    name: 'Dunda',
  },
  {
    id: '9418543013',
    districtId: '9418543',
    name: 'Tamok  Lamaluk',
  },
  {
    id: '9418543014',
    districtId: '9418543',
    name: 'Wanuk',
  },
  {
    id: '9418543015',
    districtId: '9418543',
    name: 'Rumbepaga',
  },
  {
    id: '9418543016',
    districtId: '9418543',
    name: 'Yimbanime',
  },
  {
    id: '9419021004',
    districtId: '9419021',
    name: 'Dabe',
  },
  {
    id: '9419021006',
    districtId: '9419021',
    name: 'Vinyabor',
  },
  {
    id: '9419021007',
    districtId: '9419021',
    name: 'Dabe II',
  },
  {
    id: '9419021008',
    districtId: '9419021',
    name: 'Fito',
  },
  {
    id: '9419021009',
    districtId: '9419021',
    name: 'Nengke II / Nengke Baru',
  },
  {
    id: '9419021014',
    districtId: '9419021',
    name: 'Artibe',
  },
  {
    id: '9419021017',
    districtId: '9419021',
    name: 'Burtin / Assyaf',
  },
  {
    id: '9419021018',
    districtId: '9419021',
    name: 'Takar III / Kwentor',
  },
  {
    id: '9419022001',
    districtId: '9419022',
    name: 'Yamben / Beneraf',
  },
  {
    id: '9419022002',
    districtId: '9419022',
    name: 'Betaf',
  },
  {
    id: '9419022005',
    districtId: '9419022',
    name: 'Sunum / Yamna',
  },
  {
    id: '9419022006',
    districtId: '9419022',
    name: 'Betaf II / Tamnir',
  },
  {
    id: '9419022007',
    districtId: '9419022',
    name: 'Berenaf II / Simapde',
  },
  {
    id: '9419022009',
    districtId: '9419022',
    name: 'Betaf III',
  },
  {
    id: '9419024001',
    districtId: '9419024',
    name: 'Komra',
  },
  {
    id: '9419024002',
    districtId: '9419024',
    name: 'Ansudu',
  },
  {
    id: '9419024003',
    districtId: '9419024',
    name: 'Ansudu II / Srem',
  },
  {
    id: '9419024004',
    districtId: '9419024',
    name: 'Maweswares',
  },
  {
    id: '9419025001',
    districtId: '9419025',
    name: 'Mafen Tor',
  },
  {
    id: '9419025002',
    districtId: '9419025',
    name: 'Nika Tidi',
  },
  {
    id: '9419025003',
    districtId: '9419025',
    name: 'Arare',
  },
  {
    id: '9419025004',
    districtId: '9419025',
    name: 'Ampera',
  },
  {
    id: '9419025005',
    districtId: '9419025',
    name: 'Tabrawar',
  },
  {
    id: '9419025006',
    districtId: '9419025',
    name: 'Timron',
  },
  {
    id: '9419031004',
    districtId: '9419031',
    name: 'Taronta',
  },
  {
    id: '9419031005',
    districtId: '9419031',
    name: 'Armopa',
  },
  {
    id: '9419031007',
    districtId: '9419031',
    name: 'Bebon Jaya',
  },
  {
    id: '9419031011',
    districtId: '9419031',
    name: 'Tetom',
  },
  {
    id: '9419031013',
    districtId: '9419031',
    name: 'Narum',
  },
  {
    id: '9419032001',
    districtId: '9419032',
    name: 'Tarawasi',
  },
  {
    id: '9419032002',
    districtId: '9419032',
    name: 'Mawesday',
  },
  {
    id: '9419032003',
    districtId: '9419032',
    name: 'Kaptiau',
  },
  {
    id: '9419032006',
    districtId: '9419032',
    name: 'Tamarsari',
  },
  {
    id: '9419032007',
    districtId: '9419032',
    name: 'Mawesmukti',
  },
  {
    id: '9419032008',
    districtId: '9419032',
    name: 'Gwinjaya',
  },
  {
    id: '9419033001',
    districtId: '9419033',
    name: 'Krim / Podena',
  },
  {
    id: '9419033002',
    districtId: '9419033',
    name: 'Anus',
  },
  {
    id: '9419033003',
    districtId: '9419033',
    name: 'Rimsersari',
  },
  {
    id: '9419033006',
    districtId: '9419033',
    name: 'Korur',
  },
  {
    id: '9419033007',
    districtId: '9419033',
    name: 'Yarsun',
  },
  {
    id: '9419033008',
    districtId: '9419033',
    name: 'Rotea',
  },
  {
    id: '9419033009',
    districtId: '9419033',
    name: 'Anus II',
  },
  {
    id: '9419033010',
    districtId: '9419033',
    name: 'Podena II',
  },
  {
    id: '9419040003',
    districtId: '9419040',
    name: 'Samanente',
  },
  {
    id: '9419040004',
    districtId: '9419040',
    name: 'Konderjan',
  },
  {
    id: '9419040006',
    districtId: '9419040',
    name: 'Denander',
  },
  {
    id: '9419040008',
    districtId: '9419040',
    name: 'Sakron Tane',
  },
  {
    id: '9419041001',
    districtId: '9419041',
    name: 'Bora Bora',
  },
  {
    id: '9419041002',
    districtId: '9419041',
    name: 'Togonfo / Teminabor',
  },
  {
    id: '9419041003',
    districtId: '9419041',
    name: 'Waaf',
  },
  {
    id: '9419041004',
    districtId: '9419041',
    name: 'Segar Tor',
  },
  {
    id: '9419050004',
    districtId: '9419050',
    name: 'Sarmo',
  },
  {
    id: '9419050005',
    districtId: '9419050',
    name: 'Sarmi',
  },
  {
    id: '9419050006',
    districtId: '9419050',
    name: 'Mararena',
  },
  {
    id: '9419050007',
    districtId: '9419050',
    name: 'Sawar',
  },
  {
    id: '9419050012',
    districtId: '9419050',
    name: 'Armo',
  },
  {
    id: '9419050013',
    districtId: '9419050',
    name: 'Tafarewar',
  },
  {
    id: '9419050014',
    districtId: '9419050',
    name: 'Lembah Neidam',
  },
  {
    id: '9419051001',
    districtId: '9419051',
    name: 'Sewan',
  },
  {
    id: '9419051005',
    districtId: '9419051',
    name: 'Waskey',
  },
  {
    id: '9419051011',
    districtId: '9419051',
    name: 'Sewan II',
  },
  {
    id: '9419052001',
    districtId: '9419052',
    name: 'Munukania',
  },
  {
    id: '9419052004',
    districtId: '9419052',
    name: 'Kasukwe',
  },
  {
    id: '9419052005',
    districtId: '9419052',
    name: 'Wapoania',
  },
  {
    id: '9419053002',
    districtId: '9419053',
    name: 'Bagaiserwar',
  },
  {
    id: '9419053003',
    districtId: '9419053',
    name: 'Nanot',
  },
  {
    id: '9419053004',
    districtId: '9419053',
    name: 'Bagaiserwar II',
  },
  {
    id: '9419053005',
    districtId: '9419053',
    name: 'Sumsar',
  },
  {
    id: '9419053006',
    districtId: '9419053',
    name: 'Rorena',
  },
  {
    id: '9419054001',
    districtId: '9419054',
    name: 'Holmafem',
  },
  {
    id: '9419054002',
    districtId: '9419054',
    name: 'Ebram',
  },
  {
    id: '9419054003',
    districtId: '9419054',
    name: 'Tanjung Batu',
  },
  {
    id: '9419054005',
    districtId: '9419054',
    name: 'Omte/Kwepke',
  },
  {
    id: '9419055001',
    districtId: '9419055',
    name: 'Amsira',
  },
  {
    id: '9419055002',
    districtId: '9419055',
    name: 'Siaratesa',
  },
  {
    id: '9419055003',
    districtId: '9419055',
    name: 'Angkasa II',
  },
  {
    id: '9419055004',
    districtId: '9419055',
    name: 'Kamenawari',
  },
  {
    id: '9419055005',
    districtId: '9419055',
    name: 'Nisro',
  },
  {
    id: '9419055006',
    districtId: '9419055',
    name: 'Siantoa',
  },
  {
    id: '9419060013',
    districtId: '9419060',
    name: 'Waim',
  },
  {
    id: '9419060014',
    districtId: '9419060',
    name: 'Arbais',
  },
  {
    id: '9419060015',
    districtId: '9419060',
    name: 'Aruswar',
  },
  {
    id: '9419060017',
    districtId: '9419060',
    name: 'Martewar',
  },
  {
    id: '9419060018',
    districtId: '9419060',
    name: 'Wari',
  },
  {
    id: '9419060020',
    districtId: '9419060',
    name: 'Niwerawar',
  },
  {
    id: '9419060022',
    districtId: '9419060',
    name: 'Webro',
  },
  {
    id: '9419061001',
    districtId: '9419061',
    name: 'Sasawapece',
  },
  {
    id: '9419061002',
    districtId: '9419061',
    name: 'Wamariri',
  },
  {
    id: '9419061003',
    districtId: '9419061',
    name: 'Aurimi',
  },
  {
    id: '9419061004',
    districtId: '9419061',
    name: 'Tamaya',
  },
  {
    id: '9419061009',
    districtId: '9419061',
    name: 'Syurimania',
  },
  {
    id: '9419061011',
    districtId: '9419061',
    name: 'Kwapitania',
  },
  {
    id: '9419062001',
    districtId: '9419062',
    name: 'Karfasia',
  },
  {
    id: '9419062002',
    districtId: '9419062',
    name: 'Masep',
  },
  {
    id: '9419062004',
    districtId: '9419062',
    name: 'Burgena',
  },
  {
    id: '9419062005',
    districtId: '9419062',
    name: 'Samorkena',
  },
  {
    id: '9419063001',
    districtId: '9419063',
    name: 'Kapeso',
  },
  {
    id: '9419063002',
    districtId: '9419063',
    name: 'Pina',
  },
  {
    id: '9419063003',
    districtId: '9419063',
    name: 'Airoran',
  },
  {
    id: '9419063004',
    districtId: '9419063',
    name: 'Murara',
  },
  {
    id: '9419063005',
    districtId: '9419063',
    name: 'Maniwa',
  },
  {
    id: '9420010002',
    districtId: '9420010',
    name: 'Semografi',
  },
  {
    id: '9420010004',
    districtId: '9420010',
    name: 'Umuaf',
  },
  {
    id: '9420010007',
    districtId: '9420010',
    name: 'Yamraf II',
  },
  {
    id: '9420010008',
    districtId: '9420010',
    name: 'Tatakra',
  },
  {
    id: '9420011001',
    districtId: '9420011',
    name: 'Towe Lama / Towe Atas',
  },
  {
    id: '9420011002',
    districtId: '9420011',
    name: 'Towe Hitam',
  },
  {
    id: '9420011003',
    districtId: '9420011',
    name: 'Bias',
  },
  {
    id: '9420011006',
    districtId: '9420011',
    name: 'Terpones',
  },
  {
    id: '9420011007',
    districtId: '9420011',
    name: 'Tefalma',
  },
  {
    id: '9420012001',
    districtId: '9420012',
    name: 'Amgotro',
  },
  {
    id: '9420012003',
    districtId: '9420012',
    name: 'Fafenumbu',
  },
  {
    id: '9420012004',
    districtId: '9420012',
    name: 'Akarinda',
  },
  {
    id: '9420012005',
    districtId: '9420012',
    name: 'Jifanggry',
  },
  {
    id: '9420012006',
    districtId: '9420012',
    name: 'Jabanda',
  },
  {
    id: '9420012007',
    districtId: '9420012',
    name: 'Monggoafi',
  },
  {
    id: '9420020001',
    districtId: '9420020',
    name: 'Molof',
  },
  {
    id: '9420020003',
    districtId: '9420020',
    name: 'Warlef',
  },
  {
    id: '9420020005',
    districtId: '9420020',
    name: 'Woslay',
  },
  {
    id: '9420020007',
    districtId: '9420020',
    name: 'Waley',
  },
  {
    id: '9420020008',
    districtId: '9420020',
    name: 'Namla',
  },
  {
    id: '9420021002',
    districtId: '9420021',
    name: 'Wonam',
  },
  {
    id: '9420021003',
    districtId: '9420021',
    name: 'Kiambra',
  },
  {
    id: '9420021004',
    districtId: '9420021',
    name: 'Kaisenar',
  },
  {
    id: '9420021005',
    districtId: '9420021',
    name: 'Tefanma I',
  },
  {
    id: '9420030001',
    districtId: '9420030',
    name: 'Kalimo',
  },
  {
    id: '9420030002',
    districtId: '9420030',
    name: 'Yuwainda',
  },
  {
    id: '9420030003',
    districtId: '9420030',
    name: 'Banda',
  },
  {
    id: '9420030005',
    districtId: '9420030',
    name: 'Kalifam',
  },
  {
    id: '9420030006',
    districtId: '9420030',
    name: 'Ampas',
  },
  {
    id: '9420030007',
    districtId: '9420030',
    name: 'Bompai',
  },
  {
    id: '9420030008',
    districtId: '9420030',
    name: 'Sack',
  },
  {
    id: '9420040001',
    districtId: '9420040',
    name: 'Nawa / Sawanawa',
  },
  {
    id: '9420040006',
    districtId: '9420040',
    name: 'Workwana',
  },
  {
    id: '9420040007',
    districtId: '9420040',
    name: 'UPT Pir III / Bagia',
  },
  {
    id: '9420040008',
    districtId: '9420040',
    name: 'Ubiyau',
  },
  {
    id: '9420040010',
    districtId: '9420040',
    name: 'UPT Pir II / Yamta',
  },
  {
    id: '9420040011',
    districtId: '9420040',
    name: 'Arso Kota',
  },
  {
    id: '9420040012',
    districtId: '9420040',
    name: 'UPT Pir I / Yanamaa',
  },
  {
    id: '9420040013',
    districtId: '9420040',
    name: 'UPT Arso II / Yuwanain',
  },
  {
    id: '9420040015',
    districtId: '9420040',
    name: 'Asyaman',
  },
  {
    id: '9420040021',
    districtId: '9420040',
    name: 'Sawabum',
  },
  {
    id: '9420040022',
    districtId: '9420040',
    name: 'Bate / Bibiosi',
  },
  {
    id: '9420041003',
    districtId: '9420041',
    name: 'Kibay',
  },
  {
    id: '9420041004',
    districtId: '9420041',
    name: 'Sangke',
  },
  {
    id: '9420041005',
    districtId: '9420041',
    name: 'Skofro',
  },
  {
    id: '9420041014',
    districtId: '9420041',
    name: 'Amyu',
  },
  {
    id: '9420042001',
    districtId: '9420042',
    name: 'UPT Arso X / Yaturaharja',
  },
  {
    id: '9420042002',
    districtId: '9420042',
    name: 'UPT Arso XI / Ifia-Fia',
  },
  {
    id: '9420042003',
    districtId: '9420042',
    name: 'UPT Arso VI / Yammua',
  },
  {
    id: '9420042004',
    districtId: '9420042',
    name: 'UPT Arso VIII / Dukwia',
  },
  {
    id: '9420042005',
    districtId: '9420042',
    name: 'UPT Arso I / Sanggaria',
  },
  {
    id: '9420042006',
    districtId: '9420042',
    name: 'UPT Arso VII / Warbo',
  },
  {
    id: '9420042007',
    districtId: '9420042',
    name: 'Yowong',
  },
  {
    id: '9420042008',
    districtId: '9420042',
    name: 'Baburia',
  },
  {
    id: '9420043001',
    districtId: '9420043',
    name: 'Sawyatami',
  },
  {
    id: '9420043002',
    districtId: '9420043',
    name: 'Pyawi',
  },
  {
    id: '9420043004',
    districtId: '9420043',
    name: 'Wambes',
  },
  {
    id: '9420043005',
    districtId: '9420043',
    name: 'UPT Pir V / Yamara',
  },
  {
    id: '9420043006',
    districtId: '9420043',
    name: 'UPT Pir IV / Wonorejo',
  },
  {
    id: '9420043007',
    districtId: '9420043',
    name: 'Uskwar',
  },
  {
    id: '9420050001',
    districtId: '9420050',
    name: 'Skamto',
  },
  {
    id: '9420050002',
    districtId: '9420050',
    name: 'UPT Arso Xiii / Naramben',
  },
  {
    id: '9420050003',
    districtId: '9420050',
    name: 'UPT Arso Xiv / Wulukubun',
  },
  {
    id: '9420050004',
    districtId: '9420050',
    name: 'UPT Arso V / Wiyantri',
  },
  {
    id: '9420050005',
    districtId: '9420050',
    name: 'UPT Arso IV / Arsopura',
  },
  {
    id: '9420050006',
    districtId: '9420050',
    name: 'UPT Arso III / Jaifuri',
  },
  {
    id: '9420050007',
    districtId: '9420050',
    name: 'UPT Arso IX / Intaimilyan',
  },
  {
    id: '9420050008',
    districtId: '9420050',
    name: 'UPT Arso XII / Traimilyan',
  },
  {
    id: '9420050009',
    districtId: '9420050',
    name: 'Walma',
  },
  {
    id: '9420050010',
    districtId: '9420050',
    name: 'Gudang Garam',
  },
  {
    id: '9420050011',
    districtId: '9420050',
    name: 'Saefen 4.2',
  },
  {
    id: '9420050012',
    districtId: '9420050',
    name: 'Alang-Alang Raya',
  },
  {
    id: '9426010014',
    districtId: '9426010',
    name: 'Sawara Jaya Sp VI',
  },
  {
    id: '9426010015',
    districtId: '9426010',
    name: 'Waren Satu',
  },
  {
    id: '9426010016',
    districtId: '9426010',
    name: 'Waren Dua',
  },
  {
    id: '9426010017',
    districtId: '9426010',
    name: 'Sarafambai',
  },
  {
    id: '9426010018',
    districtId: '9426010',
    name: 'Nonomi',
  },
  {
    id: '9426010030',
    districtId: '9426010',
    name: 'Batu Zaman',
  },
  {
    id: '9426011005',
    districtId: '9426011',
    name: 'Toire Sp I',
  },
  {
    id: '9426011006',
    districtId: '9426011',
    name: 'Awaso',
  },
  {
    id: '9426011007',
    districtId: '9426011',
    name: 'Soimiangga',
  },
  {
    id: '9426011008',
    districtId: '9426011',
    name: 'Harapan Jaya Sp II',
  },
  {
    id: '9426011009',
    districtId: '9426011',
    name: 'Demisa Sp III',
  },
  {
    id: '9426011010',
    districtId: '9426011',
    name: 'Otodemo',
  },
  {
    id: '9426011011',
    districtId: '9426011',
    name: 'Firo',
  },
  {
    id: '9426012001',
    districtId: '9426012',
    name: 'Kemon Jaya Sp V',
  },
  {
    id: '9426012002',
    districtId: '9426012',
    name: 'Mambui',
  },
  {
    id: '9426012003',
    districtId: '9426012',
    name: 'Urei Faisei Tiga',
  },
  {
    id: '9426012004',
    districtId: '9426012',
    name: 'Urei Faisei Dua',
  },
  {
    id: '9426012005',
    districtId: '9426012',
    name: 'Nubuai',
  },
  {
    id: '9426012006',
    districtId: '9426012',
    name: 'Apainabo',
  },
  {
    id: '9426012007',
    districtId: '9426012',
    name: 'Urei Faisei Satu/Sanggei',
  },
  {
    id: '9426012008',
    districtId: '9426012',
    name: 'Usaiwa',
  },
  {
    id: '9426012009',
    districtId: '9426012',
    name: 'Ronggaiwa',
  },
  {
    id: '9426012010',
    districtId: '9426012',
    name: 'Paradoi',
  },
  {
    id: '9426012011',
    districtId: '9426012',
    name: 'Ghoyui',
  },
  {
    id: '9426012012',
    districtId: '9426012',
    name: 'Rorisi',
  },
  {
    id: '9426013001',
    districtId: '9426013',
    name: 'Sowiwa',
  },
  {
    id: '9426013002',
    districtId: '9426013',
    name: 'Ruambak Jaya Sp VII',
  },
  {
    id: '9426013003',
    districtId: '9426013',
    name: 'Baino Jaya Sp IV',
  },
  {
    id: '9426013004',
    districtId: '9426013',
    name: 'Botawa',
  },
  {
    id: '9426013005',
    districtId: '9426013',
    name: 'Aiboa/Epawa',
  },
  {
    id: '9426013006',
    districtId: '9426013',
    name: 'Rasawa',
  },
  {
    id: '9426013007',
    districtId: '9426013',
    name: 'Morowa',
  },
  {
    id: '9426013008',
    districtId: '9426013',
    name: 'Nau',
  },
  {
    id: '9426014001',
    districtId: '9426014',
    name: 'Wapoga',
  },
  {
    id: '9426014002',
    districtId: '9426014',
    name: 'Awera',
  },
  {
    id: '9426014003',
    districtId: '9426014',
    name: 'Pirare',
  },
  {
    id: '9426014004',
    districtId: '9426014',
    name: 'Syewa/Mirare',
  },
  {
    id: '9426014005',
    districtId: '9426014',
    name: 'Dokis',
  },
  {
    id: '9426014006',
    districtId: '9426014',
    name: 'Kamarisano',
  },
  {
    id: '9426014007',
    districtId: '9426014',
    name: 'Waweri',
  },
  {
    id: '9426020010',
    districtId: '9426020',
    name: 'Sinonde',
  },
  {
    id: '9426020012',
    districtId: '9426020',
    name: 'Sauri Sirami',
  },
  {
    id: '9426020013',
    districtId: '9426020',
    name: 'Koweda',
  },
  {
    id: '9426020014',
    districtId: '9426020',
    name: 'Kali Baru',
  },
  {
    id: '9426020015',
    districtId: '9426020',
    name: 'Sirami',
  },
  {
    id: '9426020017',
    districtId: '9426020',
    name: 'Obutai',
  },
  {
    id: '9426020018',
    districtId: '9426020',
    name: 'Wairo',
  },
  {
    id: '9426020019',
    districtId: '9426020',
    name: 'Kowogi',
  },
  {
    id: '9426020020',
    districtId: '9426020',
    name: 'Emauri',
  },
  {
    id: '9426021001',
    districtId: '9426021',
    name: 'Fafado',
  },
  {
    id: '9426021002',
    districtId: '9426021',
    name: 'Wobari',
  },
  {
    id: '9426021003',
    districtId: '9426021',
    name: 'Unareu',
  },
  {
    id: '9426021004',
    districtId: '9426021',
    name: 'Aimasi',
  },
  {
    id: '9426021006',
    districtId: '9426021',
    name: 'Ghaiwando',
  },
  {
    id: '9426021007',
    districtId: '9426021',
    name: 'Orambin',
  },
  {
    id: '9426021008',
    districtId: '9426021',
    name: 'Waghare',
  },
  {
    id: '9426021009',
    districtId: '9426021',
    name: 'Ghaiwaru',
  },
  {
    id: '9426021010',
    districtId: '9426021',
    name: 'Womorisi',
  },
  {
    id: '9426022001',
    districtId: '9426022',
    name: 'Aniboi',
  },
  {
    id: '9426022002',
    districtId: '9426022',
    name: 'Fafai',
  },
  {
    id: '9426022003',
    districtId: '9426022',
    name: 'Urato',
  },
  {
    id: '9426022004',
    districtId: '9426022',
    name: 'Mayaghaido',
  },
  {
    id: '9426022005',
    districtId: '9426022',
    name: 'Aiwa',
  },
  {
    id: '9426022006',
    districtId: '9426022',
    name: 'Demba',
  },
  {
    id: '9426022007',
    districtId: '9426022',
    name: 'Ronarai',
  },
  {
    id: '9426022009',
    districtId: '9426022',
    name: 'Wudokuri',
  },
  {
    id: '9426022010',
    districtId: '9426022',
    name: 'Biati',
  },
  {
    id: '9426023001',
    districtId: '9426023',
    name: 'Mambai',
  },
  {
    id: '9426023002',
    districtId: '9426023',
    name: 'Napani',
  },
  {
    id: '9426023003',
    districtId: '9426023',
    name: 'Soyoi',
  },
  {
    id: '9426023004',
    districtId: '9426023',
    name: 'Daimboa',
  },
  {
    id: '9426023005',
    districtId: '9426023',
    name: 'Wainarisi',
  },
  {
    id: '9426023006',
    districtId: '9426023',
    name: 'Fafarui',
  },
  {
    id: '9426023007',
    districtId: '9426023',
    name: 'Segha',
  },
  {
    id: '9426023008',
    districtId: '9426023',
    name: 'Sinabo',
  },
  {
    id: '9426023009',
    districtId: '9426023',
    name: 'Dawoa',
  },
  {
    id: '9426023010',
    districtId: '9426023',
    name: 'Woinui',
  },
  {
    id: '9426024001',
    districtId: '9426024',
    name: 'Wonti Bokhodaro',
  },
  {
    id: '9426024002',
    districtId: '9426024',
    name: 'Odase',
  },
  {
    id: '9426024003',
    districtId: '9426024',
    name: 'Wanda',
  },
  {
    id: '9426024004',
    districtId: '9426024',
    name: 'Sifuisera',
  },
  {
    id: '9426024005',
    districtId: '9426024',
    name: 'Borumei',
  },
  {
    id: '9426024006',
    districtId: '9426024',
    name: 'Wonti Kai',
  },
  {
    id: '9426024007',
    districtId: '9426024',
    name: 'Gheroi',
  },
  {
    id: '9426024008',
    districtId: '9426024',
    name: 'Ghoiwi Samberi',
  },
  {
    id: '9426024009',
    districtId: '9426024',
    name: 'Moyufuri',
  },
  {
    id: '9426024010',
    districtId: '9426024',
    name: 'Fimore',
  },
  {
    id: '9426030001',
    districtId: '9426030',
    name: 'Matadi',
  },
  {
    id: '9426030002',
    districtId: '9426030',
    name: 'Dimba',
  },
  {
    id: '9426030003',
    districtId: '9426030',
    name: 'Mpominatadi',
  },
  {
    id: '9426030004',
    districtId: '9426030',
    name: 'Maiyapo',
  },
  {
    id: '9426030005',
    districtId: '9426030',
    name: 'Oyetadi',
  },
  {
    id: '9426030006',
    districtId: '9426030',
    name: 'Maolagi',
  },
  {
    id: '9426030007',
    districtId: '9426030',
    name: 'Mbaindotadi',
  },
  {
    id: '9426030008',
    districtId: '9426030',
    name: 'Nabuya',
  },
  {
    id: '9426030009',
    districtId: '9426030',
    name: 'Dapiyaga',
  },
  {
    id: '9426030010',
    districtId: '9426030',
    name: 'Walampa Butu',
  },
  {
    id: '9426030011',
    districtId: '9426030',
    name: 'Didiwoi',
  },
  {
    id: '9426030013',
    districtId: '9426030',
    name: 'Malewoya',
  },
  {
    id: '9426030014',
    districtId: '9426030',
    name: 'Tunggamba',
  },
  {
    id: '9426030015',
    districtId: '9426030',
    name: 'Ebawaida',
  },
  {
    id: '9426030016',
    districtId: '9426030',
    name: 'Daboto',
  },
  {
    id: '9426040001',
    districtId: '9426040',
    name: 'Dairi',
  },
  {
    id: '9426040002',
    districtId: '9426040',
    name: 'Spoiri',
  },
  {
    id: '9426040003',
    districtId: '9426040',
    name: 'Sooh',
  },
  {
    id: '9426040004',
    districtId: '9426040',
    name: 'Diwa',
  },
  {
    id: '9426040005',
    districtId: '9426040',
    name: 'Kawari',
  },
  {
    id: '9426040006',
    districtId: '9426040',
    name: 'Kuaisa',
  },
  {
    id: '9426040007',
    districtId: '9426040',
    name: 'Foida',
  },
  {
    id: '9426040008',
    districtId: '9426040',
    name: 'Dirou',
  },
  {
    id: '9426040009',
    districtId: '9426040',
    name: 'Antu Aru',
  },
  {
    id: '9426040010',
    districtId: '9426040',
    name: 'Wauka',
  },
  {
    id: '9427010007',
    districtId: '9427010',
    name: 'Didiabolo',
  },
  {
    id: '9427010008',
    districtId: '9427010',
    name: 'Odori',
  },
  {
    id: '9427010009',
    districtId: '9427010',
    name: 'Fanindi',
  },
  {
    id: '9427010018',
    districtId: '9427010',
    name: 'Awaki',
  },
  {
    id: '9427010019',
    districtId: '9427010',
    name: 'Warbefondi',
  },
  {
    id: '9427010020',
    districtId: '9427010',
    name: 'Maryaidori',
  },
  {
    id: '9427011001',
    districtId: '9427011',
    name: 'Aruri',
  },
  {
    id: '9427011002',
    districtId: '9427011',
    name: 'Yamnaisu',
  },
  {
    id: '9427011004',
    districtId: '9427011',
    name: 'Rayori',
  },
  {
    id: '9427011005',
    districtId: '9427011',
    name: 'Wongkeina',
  },
  {
    id: '9427011006',
    districtId: '9427011',
    name: 'Imbirsbari',
  },
  {
    id: '9427011008',
    districtId: '9427011',
    name: 'Mbruwandi',
  },
  {
    id: '9427011009',
    districtId: '9427011',
    name: 'Manggonswan',
  },
  {
    id: '9427020005',
    districtId: '9427020',
    name: 'Warsa',
  },
  {
    id: '9427020006',
    districtId: '9427020',
    name: 'Warbor',
  },
  {
    id: '9427020007',
    districtId: '9427020',
    name: 'Kobari Jaya',
  },
  {
    id: '9427020008',
    districtId: '9427020',
    name: 'Fanjur',
  },
  {
    id: '9427021001',
    districtId: '9427021',
    name: 'Napisndi',
  },
  {
    id: '9427021002',
    districtId: '9427021',
    name: 'Amyas',
  },
  {
    id: '9427021003',
    districtId: '9427021',
    name: 'Koiryakam',
  },
  {
    id: '9427021004',
    districtId: '9427021',
    name: 'Waryei',
  },
  {
    id: '9427021005',
    districtId: '9427021',
    name: 'Masyai',
  },
  {
    id: '9427021006',
    districtId: '9427021',
    name: 'Wayori',
  },
  {
    id: '9427021008',
    districtId: '9427021',
    name: 'Mapia',
  },
  {
    id: '9427030001',
    districtId: '9427030',
    name: 'Wafor',
  },
  {
    id: '9427030002',
    districtId: '9427030',
    name: 'Sauyas',
  },
  {
    id: '9427030003',
    districtId: '9427030',
    name: 'Sorendidori',
  },
  {
    id: '9427030004',
    districtId: '9427030',
    name: 'Waryesi',
  },
  {
    id: '9427030005',
    districtId: '9427030',
    name: 'Wombonda',
  },
  {
    id: '9427030006',
    districtId: '9427030',
    name: 'Yawerma',
  },
  {
    id: '9427030007',
    districtId: '9427030',
    name: 'Marsram',
  },
  {
    id: '9427030009',
    districtId: '9427030',
    name: 'Douwbo',
  },
  {
    id: '9427030010',
    districtId: '9427030',
    name: 'Syurdori',
  },
  {
    id: '9428030002',
    districtId: '9428030',
    name: 'Nadofoai',
  },
  {
    id: '9428030003',
    districtId: '9428030',
    name: 'Rawiwa',
  },
  {
    id: '9428030004',
    districtId: '9428030',
    name: 'Barapasi',
  },
  {
    id: '9428030005',
    districtId: '9428030',
    name: 'Marikai',
  },
  {
    id: '9428030006',
    districtId: '9428030',
    name: 'Bariwaro',
  },
  {
    id: '9428031001',
    districtId: '9428031',
    name: 'Watiaro',
  },
  {
    id: '9428031002',
    districtId: '9428031',
    name: 'Baitanisa',
  },
  {
    id: '9428031003',
    districtId: '9428031',
    name: 'Dadat',
  },
  {
    id: '9428031004',
    districtId: '9428031',
    name: 'Kamai',
  },
  {
    id: '9428031005',
    districtId: '9428031',
    name: 'Gesa Baru',
  },
  {
    id: '9428031006',
    districtId: '9428031',
    name: 'Kerema',
  },
  {
    id: '9428032001',
    districtId: '9428032',
    name: 'Bensor',
  },
  {
    id: '9428032002',
    districtId: '9428032',
    name: 'Sorabi',
  },
  {
    id: '9428032003',
    districtId: '9428032',
    name: 'Poiwai',
  },
  {
    id: '9428032004',
    districtId: '9428032',
    name: 'Rapamarei',
  },
  {
    id: '9428032005',
    districtId: '9428032',
    name: 'Anasi',
  },
  {
    id: '9428032006',
    districtId: '9428032',
    name: 'Bonoi',
  },
  {
    id: '9428032007',
    districtId: '9428032',
    name: 'Tamakuri',
  },
  {
    id: '9428040001',
    districtId: '9428040',
    name: 'Baudi',
  },
  {
    id: '9428040003',
    districtId: '9428040',
    name: 'Swaseso',
  },
  {
    id: '9428040004',
    districtId: '9428040',
    name: 'Kapeso',
  },
  {
    id: '9428040005',
    districtId: '9428040',
    name: 'Bagusa',
  },
  {
    id: '9428040006',
    districtId: '9428040',
    name: 'Warembori',
  },
  {
    id: '9428040007',
    districtId: '9428040',
    name: 'Yoke',
  },
  {
    id: '9428050001',
    districtId: '9428050',
    name: 'Danau Bira',
  },
  {
    id: '9428050002',
    districtId: '9428050',
    name: 'Burmeso',
  },
  {
    id: '9428050004',
    districtId: '9428050',
    name: 'Kasonaweja',
  },
  {
    id: '9428050005',
    districtId: '9428050',
    name: 'Namunaweja',
  },
  {
    id: '9428050006',
    districtId: '9428050',
    name: 'Anggreso',
  },
  {
    id: '9428050011',
    districtId: '9428050',
    name: 'Marine Valen',
  },
  {
    id: '9428050017',
    districtId: '9428050',
    name: 'Kwerba',
  },
  {
    id: '9428050018',
    districtId: '9428050',
    name: 'Muaramarei',
  },
  {
    id: '9428051001',
    districtId: '9428051',
    name: 'Metaweja',
  },
  {
    id: '9428051002',
    districtId: '9428051',
    name: 'Babija',
  },
  {
    id: '9428051003',
    districtId: '9428051',
    name: 'Sasawakwesar',
  },
  {
    id: '9428060003',
    districtId: '9428060',
    name: 'Kustra',
  },
  {
    id: '9428060004',
    districtId: '9428060',
    name: 'Noyadi',
  },
  {
    id: '9428060005',
    districtId: '9428060',
    name: 'Obogoi',
  },
  {
    id: '9428060006',
    districtId: '9428060',
    name: 'Tuwao',
  },
  {
    id: '9428060007',
    districtId: '9428060',
    name: 'Wakeyadi',
  },
  {
    id: '9428070001',
    districtId: '9428070',
    name: 'Taiyai',
  },
  {
    id: '9428070002',
    districtId: '9428070',
    name: 'Bareri',
  },
  {
    id: '9428070003',
    districtId: '9428070',
    name: 'Kayi / Kay Seta',
  },
  {
    id: '9428070004',
    districtId: '9428070',
    name: 'Sikari',
  },
  {
    id: '9428070005',
    districtId: '9428070',
    name: 'Fona',
  },
  {
    id: '9428070006',
    districtId: '9428070',
    name: 'Haya',
  },
  {
    id: '9428080003',
    districtId: '9428080',
    name: 'Douw',
  },
  {
    id: '9428080006',
    districtId: '9428080',
    name: 'Papasena II',
  },
  {
    id: '9428080007',
    districtId: '9428080',
    name: 'Papasena I',
  },
  {
    id: '9428080008',
    districtId: '9428080',
    name: 'Taiyeve',
  },
  {
    id: '9428080009',
    districtId: '9428080',
    name: 'Dabra',
  },
  {
    id: '9428080010',
    districtId: '9428080',
    name: 'Foau',
  },
  {
    id: '9428080011',
    districtId: '9428080',
    name: 'Fokri / Baso',
  },
  {
    id: '9428080014',
    districtId: '9428080',
    name: 'Taria',
  },
  {
    id: '9428080015',
    districtId: '9428080',
    name: 'Kwa',
  },
  {
    id: '9429010002',
    districtId: '9429010',
    name: 'Ndugwa',
  },
  {
    id: '9429010021',
    districtId: '9429010',
    name: 'Biala',
  },
  {
    id: '9429010022',
    districtId: '9429010',
    name: 'Bambisik',
  },
  {
    id: '9429010023',
    districtId: '9429010',
    name: 'Sitpogol',
  },
  {
    id: '9429011001',
    districtId: '9429011',
    name: 'Gunia',
  },
  {
    id: '9429011002',
    districtId: '9429011',
    name: 'Kwegono',
  },
  {
    id: '9429011003',
    districtId: '9429011',
    name: 'Yeretma',
  },
  {
    id: '9429011004',
    districtId: '9429011',
    name: 'Anggulpa',
  },
  {
    id: '9429011005',
    districtId: '9429011',
    name: 'Moba Dua',
  },
  {
    id: '9429011006',
    districtId: '9429011',
    name: 'Langpang',
  },
  {
    id: '9429011007',
    districtId: '9429011',
    name: 'Pijama',
  },
  {
    id: '9429011008',
    districtId: '9429011',
    name: 'Moba',
  },
  {
    id: '9429012001',
    districtId: '9429012',
    name: 'Nganai',
  },
  {
    id: '9429012002',
    districtId: '9429012',
    name: 'Sitgama',
  },
  {
    id: '9429012003',
    districtId: '9429012',
    name: 'Pija',
  },
  {
    id: '9429012004',
    districtId: '9429012',
    name: 'Murupbaye',
  },
  {
    id: '9429012005',
    districtId: '9429012',
    name: 'Siat',
  },
  {
    id: '9429013001',
    districtId: '9429013',
    name: 'Nanggoal',
  },
  {
    id: '9429013002',
    districtId: '9429013',
    name: 'Kora',
  },
  {
    id: '9429013003',
    districtId: '9429013',
    name: 'Wenam',
  },
  {
    id: '9429013005',
    districtId: '9429013',
    name: 'Brutnai',
  },
  {
    id: '9429020002',
    districtId: '9429020',
    name: 'Kenyam',
  },
  {
    id: '9429020008',
    districtId: '9429020',
    name: 'Kemali',
  },
  {
    id: '9429020009',
    districtId: '9429020',
    name: 'Sralala',
  },
  {
    id: '9429020012',
    districtId: '9429020',
    name: 'Yunat',
  },
  {
    id: '9429020025',
    districtId: '9429020',
    name: 'Bomban',
  },
  {
    id: '9429021002',
    districtId: '9429021',
    name: 'Rapa',
  },
  {
    id: '9429021003',
    districtId: '9429021',
    name: 'Tobonggom',
  },
  {
    id: '9429021004',
    districtId: '9429021',
    name: 'Sokore',
  },
  {
    id: '9429021005',
    districtId: '9429021',
    name: 'Tombisik',
  },
  {
    id: '9429021006',
    districtId: '9429021',
    name: 'Paris',
  },
  {
    id: '9429021008',
    districtId: '9429021',
    name: 'Yepma',
  },
  {
    id: '9429022002',
    districtId: '9429022',
    name: 'Banggabaek',
  },
  {
    id: '9429022003',
    districtId: '9429022',
    name: 'Alguru',
  },
  {
    id: '9429022005',
    districtId: '9429022',
    name: 'Sagapusatu',
  },
  {
    id: '9429023001',
    districtId: '9429023',
    name: 'Wendama',
  },
  {
    id: '9429023003',
    districtId: '9429023',
    name: 'Yenai',
  },
  {
    id: '9429030001',
    districtId: '9429030',
    name: 'Geselema',
  },
  {
    id: '9429030005',
    districtId: '9429030',
    name: 'Talem',
  },
  {
    id: '9429030006',
    districtId: '9429030',
    name: 'Kosolpem',
  },
  {
    id: '9429031002',
    districtId: '9429031',
    name: 'Gemam',
  },
  {
    id: '9429031003',
    districtId: '9429031',
    name: 'Puruwa',
  },
  {
    id: '9429032001',
    districtId: '9429032',
    name: 'Maima',
  },
  {
    id: '9429032002',
    districtId: '9429032',
    name: 'Nolo',
  },
  {
    id: '9429032003',
    districtId: '9429032',
    name: 'Yenggelo',
  },
  {
    id: '9429032004',
    districtId: '9429032',
    name: 'Wuarem',
  },
  {
    id: '9429033002',
    districtId: '9429033',
    name: 'Alama',
  },
  {
    id: '9429033003',
    districtId: '9429033',
    name: 'Nolit',
  },
  {
    id: '9429033004',
    districtId: '9429033',
    name: 'Kulesa',
  },
  {
    id: '9429034002',
    districtId: '9429034',
    name: 'Meborok',
  },
  {
    id: '9429034004',
    districtId: '9429034',
    name: 'Ngenamba',
  },
  {
    id: '9429034005',
    districtId: '9429034',
    name: 'Narugum',
  },
  {
    id: '9429034006',
    districtId: '9429034',
    name: 'Eregenmangge',
  },
  {
    id: '9429034007',
    districtId: '9429034',
    name: 'Talpam',
  },
  {
    id: '9429034008',
    districtId: '9429034',
    name: 'Aptam',
  },
  {
    id: '9429034009',
    districtId: '9429034',
    name: 'Signimarem',
  },
  {
    id: '9429034010',
    districtId: '9429034',
    name: 'Bone',
  },
  {
    id: '9429034011',
    districtId: '9429034',
    name: 'Olonmu',
  },
  {
    id: '9429034012',
    districtId: '9429034',
    name: 'Sabiem',
  },
  {
    id: '9429034014',
    districtId: '9429034',
    name: 'Lumurak',
  },
  {
    id: '9429040002',
    districtId: '9429040',
    name: 'Mapenduma',
  },
  {
    id: '9429040010',
    districtId: '9429040',
    name: 'Duma',
  },
  {
    id: '9429040011',
    districtId: '9429040',
    name: 'Yoe',
  },
  {
    id: '9429040012',
    districtId: '9429040',
    name: 'Palsam',
  },
  {
    id: '9429040015',
    districtId: '9429040',
    name: 'Nowomlusu',
  },
  {
    id: '9429040016',
    districtId: '9429040',
    name: 'Kelapa Dua',
  },
  {
    id: '9429040018',
    districtId: '9429040',
    name: 'Lunggadumu',
  },
  {
    id: '9429041001',
    districtId: '9429041',
    name: 'Kroptak',
  },
  {
    id: '9429041002',
    districtId: '9429041',
    name: 'Gol',
  },
  {
    id: '9429041004',
    districtId: '9429041',
    name: 'Golparek',
  },
  {
    id: '9429041005',
    districtId: '9429041',
    name: 'Pesat',
  },
  {
    id: '9429041006',
    districtId: '9429041',
    name: 'Komoroam',
  },
  {
    id: '9429042001',
    districtId: '9429042',
    name: 'Paro',
  },
  {
    id: '9429042002',
    districtId: '9429042',
    name: 'Lombrik',
  },
  {
    id: '9429042003',
    districtId: '9429042',
    name: 'Animarem',
  },
  {
    id: '9429042004',
    districtId: '9429042',
    name: 'Tawelma',
  },
  {
    id: '9429042005',
    districtId: '9429042',
    name: 'Loaraba',
  },
  {
    id: '9429043002',
    districtId: '9429043',
    name: 'Bambi',
  },
  {
    id: '9429043003',
    districtId: '9429043',
    name: 'Kagayem',
  },
  {
    id: '9429043004',
    districtId: '9429043',
    name: 'Osama',
  },
  {
    id: '9429043006',
    districtId: '9429043',
    name: 'Ininkwaning',
  },
  {
    id: '9429043007',
    districtId: '9429043',
    name: 'Kumbuklema',
  },
  {
    id: '9429043009',
    districtId: '9429043',
    name: 'Sanwaruk',
  },
  {
    id: '9429043012',
    districtId: '9429043',
    name: 'Peya Peya',
  },
  {
    id: '9429043013',
    districtId: '9429043',
    name: 'Narugu',
  },
  {
    id: '9429050018',
    districtId: '9429050',
    name: 'Dondoklame',
  },
  {
    id: '9429050019',
    districtId: '9429050',
    name: 'Dobopem',
  },
  {
    id: '9429050020',
    districtId: '9429050',
    name: 'Paru',
  },
  {
    id: '9429050022',
    districtId: '9429050',
    name: 'Kemamburu',
  },
  {
    id: '9429050023',
    districtId: '9429050',
    name: 'Womsit',
  },
  {
    id: '9429050025',
    districtId: '9429050',
    name: 'Kerep Anggoma',
  },
  {
    id: '9429050026',
    districtId: '9429050',
    name: 'Manep',
  },
  {
    id: '9429050028',
    districtId: '9429050',
    name: 'Yalsengge',
  },
  {
    id: '9429050034',
    districtId: '9429050',
    name: 'Sarit',
  },
  {
    id: '9429050037',
    districtId: '9429050',
    name: 'Sambua',
  },
  {
    id: '9429050038',
    districtId: '9429050',
    name: 'Gisarok',
  },
  {
    id: '9429050039',
    districtId: '9429050',
    name: 'Isiklak',
  },
  {
    id: '9429051001',
    districtId: '9429051',
    name: 'Yal',
  },
  {
    id: '9429051002',
    districtId: '9429051',
    name: 'Palpam',
  },
  {
    id: '9429051003',
    districtId: '9429051',
    name: 'Sitbodo',
  },
  {
    id: '9429051004',
    districtId: '9429051',
    name: 'Diringgama',
  },
  {
    id: '9429051007',
    districtId: '9429051',
    name: 'Yaba',
  },
  {
    id: '9429051008',
    districtId: '9429051',
    name: 'Dengpa',
  },
  {
    id: '9429051009',
    districtId: '9429051',
    name: 'Girimnak',
  },
  {
    id: '9429051010',
    districtId: '9429051',
    name: 'Lambule',
  },
  {
    id: '9429051011',
    districtId: '9429051',
    name: 'Sujumbodo',
  },
  {
    id: '9429051012',
    districtId: '9429051',
    name: 'Suwelama',
  },
  {
    id: '9429051013',
    districtId: '9429051',
    name: 'Gularem',
  },
  {
    id: '9429051015',
    districtId: '9429051',
    name: 'Yimogi',
  },
  {
    id: '9429051016',
    districtId: '9429051',
    name: 'Samba',
  },
  {
    id: '9429051017',
    districtId: '9429051',
    name: 'Mugiarem',
  },
  {
    id: '9429051018',
    districtId: '9429051',
    name: 'Dangenpem',
  },
  {
    id: '9429051020',
    districtId: '9429051',
    name: 'Undo',
  },
  {
    id: '9429052001',
    districtId: '9429052',
    name: 'Mam',
  },
  {
    id: '9429052003',
    districtId: '9429052',
    name: 'Wolmbam',
  },
  {
    id: '9429052004',
    districtId: '9429052',
    name: 'Wanduama',
  },
  {
    id: '9429052006',
    districtId: '9429052',
    name: 'Lakda',
  },
  {
    id: '9429052007',
    districtId: '9429052',
    name: 'Yebandui',
  },
  {
    id: '9429052008',
    districtId: '9429052',
    name: 'Laruid',
  },
  {
    id: '9429052009',
    districtId: '9429052',
    name: 'Dendamba',
  },
  {
    id: '9429052010',
    districtId: '9429052',
    name: 'Kibiarem',
  },
  {
    id: '9429052011',
    districtId: '9429052',
    name: 'Papuarem',
  },
  {
    id: '9429052012',
    districtId: '9429052',
    name: 'Kibo',
  },
  {
    id: '9429052014',
    districtId: '9429052',
    name: 'Darakma',
  },
  {
    id: '9429060002',
    districtId: '9429060',
    name: 'Ekilapok',
  },
  {
    id: '9429060011',
    districtId: '9429060',
    name: 'Karunggame',
  },
  {
    id: '9429060013',
    districtId: '9429060',
    name: 'Disendobo',
  },
  {
    id: '9429060014',
    districtId: '9429060',
    name: 'Sumbo',
  },
  {
    id: '9429060015',
    districtId: '9429060',
    name: 'Yebadola',
  },
  {
    id: '9429060035',
    districtId: '9429060',
    name: 'Wiritlak',
  },
  {
    id: '9429060036',
    districtId: '9429060',
    name: 'Delsa',
  },
  {
    id: '9429060037',
    districtId: '9429060',
    name: 'Boroit',
  },
  {
    id: '9429061001',
    districtId: '9429061',
    name: 'Dal',
  },
  {
    id: '9429061002',
    districtId: '9429061',
    name: 'Silan',
  },
  {
    id: '9429061004',
    districtId: '9429061',
    name: 'Kaboneri',
  },
  {
    id: '9429061005',
    districtId: '9429061',
    name: 'Silankuru',
  },
  {
    id: '9429062003',
    districtId: '9429062',
    name: 'Uenoma',
  },
  {
    id: '9429062004',
    districtId: '9429062',
    name: 'Pasebem',
  },
  {
    id: '9429062005',
    districtId: '9429062',
    name: 'Sokmie',
  },
  {
    id: '9429062007',
    districtId: '9429062',
    name: 'Oldobo',
  },
  {
    id: '9429062009',
    districtId: '9429062',
    name: 'Kokujondumu',
  },
  {
    id: '9429063002',
    districtId: '9429063',
    name: 'Dakbiri',
  },
  {
    id: '9429063003',
    districtId: '9429063',
    name: 'Abualak',
  },
  {
    id: '9429063004',
    districtId: '9429063',
    name: 'Urugom',
  },
  {
    id: '9429063005',
    districtId: '9429063',
    name: 'Area',
  },
  {
    id: '9429063006',
    districtId: '9429063',
    name: 'Wumaga',
  },
  {
    id: '9429063007',
    districtId: '9429063',
    name: 'Gulama',
  },
  {
    id: '9429063008',
    districtId: '9429063',
    name: 'Kigam',
  },
  {
    id: '9429070002',
    districtId: '9429070',
    name: 'Mbua',
  },
  {
    id: '9429070008',
    districtId: '9429070',
    name: 'Otalama',
  },
  {
    id: '9429070009',
    districtId: '9429070',
    name: 'Arugia',
  },
  {
    id: '9429070010',
    districtId: '9429070',
    name: 'Opmu',
  },
  {
    id: '9429070012',
    districtId: '9429070',
    name: 'Kogomaru',
  },
  {
    id: '9429071002',
    districtId: '9429071',
    name: 'Baklema',
  },
  {
    id: '9429071005',
    districtId: '9429071',
    name: 'Kosobak',
  },
  {
    id: '9429072001',
    districtId: '9429072',
    name: 'Wutpaga',
  },
  {
    id: '9429072004',
    districtId: '9429072',
    name: 'Wuone',
  },
  {
    id: '9429072005',
    districtId: '9429072',
    name: 'Lauren',
  },
  {
    id: '9429072006',
    districtId: '9429072',
    name: 'Wangun',
  },
  {
    id: '9429073001',
    districtId: '9429073',
    name: 'Nenggeangin',
  },
  {
    id: '9429073002',
    districtId: '9429073',
    name: 'Nenggea',
  },
  {
    id: '9429073003',
    districtId: '9429073',
    name: 'Wulagume',
  },
  {
    id: '9429073004',
    districtId: '9429073',
    name: 'Kombama',
  },
  {
    id: '9429073005',
    districtId: '9429073',
    name: 'Wenggenambut',
  },
  {
    id: '9429074001',
    districtId: '9429074',
    name: 'Klabypma',
  },
  {
    id: '9429074004',
    districtId: '9429074',
    name: 'Kabolilangen',
  },
  {
    id: '9429074005',
    districtId: '9429074',
    name: 'Kolma',
  },
  {
    id: '9429074006',
    districtId: '9429074',
    name: 'Brambel',
  },
  {
    id: '9429074007',
    districtId: '9429074',
    name: 'Labrik',
  },
  {
    id: '9429080001',
    districtId: '9429080',
    name: 'Gearek',
  },
  {
    id: '9429080006',
    districtId: '9429080',
    name: 'Weneworarosa',
  },
  {
    id: '9429080009',
    districtId: '9429080',
    name: 'Bemogi',
  },
  {
    id: '9429080010',
    districtId: '9429080',
    name: 'Gilingga',
  },
  {
    id: '9429081001',
    districtId: '9429081',
    name: 'Mandala',
  },
  {
    id: '9429081002',
    districtId: '9429081',
    name: 'Pasir Putih',
  },
  {
    id: '9429082003',
    districtId: '9429082',
    name: 'Pijemae',
  },
  {
    id: '9430010017',
    districtId: '9430010',
    name: 'Mamiri',
  },
  {
    id: '9430010018',
    districtId: '9430010',
    name: 'Jiwikelanny',
  },
  {
    id: '9430010019',
    districtId: '9430010',
    name: 'Nisimok',
  },
  {
    id: '9430010021',
    districtId: '9430010',
    name: 'Piname',
  },
  {
    id: '9430010022',
    districtId: '9430010',
    name: 'Londu',
  },
  {
    id: '9430010023',
    districtId: '9430010',
    name: 'Kagaluwi',
  },
  {
    id: '9430010024',
    districtId: '9430010',
    name: 'Kotorambur',
  },
  {
    id: '9430010025',
    districtId: '9430010',
    name: 'Yorenime',
  },
  {
    id: '9430010026',
    districtId: '9430010',
    name: 'Waganenga',
  },
  {
    id: '9430010027',
    districtId: '9430010',
    name: 'Gembilani',
  },
  {
    id: '9430010028',
    districtId: '9430010',
    name: 'Nambume',
  },
  {
    id: '9430010029',
    districtId: '9430010',
    name: 'Tengenawi',
  },
  {
    id: '9430011002',
    districtId: '9430011',
    name: 'Lelam',
  },
  {
    id: '9430011003',
    districtId: '9430011',
    name: 'Yaneko',
  },
  {
    id: '9430011004',
    districtId: '9430011',
    name: 'Kimbo',
  },
  {
    id: '9430011007',
    districtId: '9430011',
    name: 'Teyiko',
  },
  {
    id: '9430011008',
    districtId: '9430011',
    name: 'Penggima',
  },
  {
    id: '9430011009',
    districtId: '9430011',
    name: 'Magelo',
  },
  {
    id: '9430011010',
    districtId: '9430011',
    name: 'Kibingga',
  },
  {
    id: '9430011011',
    districtId: '9430011',
    name: 'Ogobakni',
  },
  {
    id: '9430011012',
    districtId: '9430011',
    name: 'Wapur',
  },
  {
    id: '9430011013',
    districtId: '9430011',
    name: 'Andeyok',
  },
  {
    id: '9430011014',
    districtId: '9430011',
    name: 'Onesia',
  },
  {
    id: '9430011015',
    districtId: '9430011',
    name: 'Jilam',
  },
  {
    id: '9430012001',
    districtId: '9430012',
    name: 'Keloyak',
  },
  {
    id: '9430012002',
    districtId: '9430012',
    name: 'Wanuga',
  },
  {
    id: '9430012003',
    districtId: '9430012',
    name: 'Labora',
  },
  {
    id: '9430012004',
    districtId: '9430012',
    name: 'Kondena',
  },
  {
    id: '9430012005',
    districtId: '9430012',
    name: 'Kolunggu',
  },
  {
    id: '9430012006',
    districtId: '9430012',
    name: 'Yagarikme',
  },
  {
    id: '9430012007',
    districtId: '9430012',
    name: 'Ambena',
  },
  {
    id: '9430012008',
    districtId: '9430012',
    name: 'Timotius',
  },
  {
    id: '9430013001',
    districtId: '9430013',
    name: 'Juta',
  },
  {
    id: '9430013002',
    districtId: '9430013',
    name: 'Gondura',
  },
  {
    id: '9430013003',
    districtId: '9430013',
    name: 'Tigima',
  },
  {
    id: '9430013004',
    districtId: '9430013',
    name: 'Pirambor',
  },
  {
    id: '9430013005',
    districtId: '9430013',
    name: 'Wanggu',
  },
  {
    id: '9430013006',
    districtId: '9430013',
    name: 'Murtani',
  },
  {
    id: '9430013007',
    districtId: '9430013',
    name: 'Beam',
  },
  {
    id: '9430013009',
    districtId: '9430013',
    name: 'Gelok',
  },
  {
    id: '9430014002',
    districtId: '9430014',
    name: 'Wuragabur',
  },
  {
    id: '9430014003',
    districtId: '9430014',
    name: 'Yugumia',
  },
  {
    id: '9430014004',
    districtId: '9430014',
    name: 'Wumuak',
  },
  {
    id: '9430014005',
    districtId: '9430014',
    name: 'Indawa',
  },
  {
    id: '9430014006',
    districtId: '9430014',
    name: 'Andiaput',
  },
  {
    id: '9430014007',
    districtId: '9430014',
    name: 'Nambume',
  },
  {
    id: '9430014008',
    districtId: '9430014',
    name: 'Dolinggame',
  },
  {
    id: '9430014009',
    districtId: '9430014',
    name: 'Tinggira',
  },
  {
    id: '9430020008',
    districtId: '9430020',
    name: 'Wenam',
  },
  {
    id: '9430020009',
    districtId: '9430020',
    name: 'Ekanom',
  },
  {
    id: '9430020010',
    districtId: '9430020',
    name: 'Umbanume',
  },
  {
    id: '9430020011',
    districtId: '9430020',
    name: 'Yalipak',
  },
  {
    id: '9430020028',
    districtId: '9430020',
    name: 'Amberingime',
  },
  {
    id: '9430020029',
    districtId: '9430020',
    name: 'Aniwo',
  },
  {
    id: '9430020030',
    districtId: '9430020',
    name: 'Bugumbak',
  },
  {
    id: '9430021003',
    districtId: '9430021',
    name: 'Karunggame',
  },
  {
    id: '9430021006',
    districtId: '9430021',
    name: 'Kelonome',
  },
  {
    id: '9430021007',
    districtId: '9430021',
    name: 'Kulogonggame',
  },
  {
    id: '9430021008',
    districtId: '9430021',
    name: 'Dua Lanny',
  },
  {
    id: '9430021009',
    districtId: '9430021',
    name: 'Genena',
  },
  {
    id: '9430021010',
    districtId: '9430021',
    name: 'Timolome',
  },
  {
    id: '9430021011',
    districtId: '9430021',
    name: 'Kabiga',
  },
  {
    id: '9430021013',
    districtId: '9430021',
    name: 'Dangguni',
  },
  {
    id: '9430022001',
    districtId: '9430022',
    name: 'Milimbo',
  },
  {
    id: '9430022002',
    districtId: '9430022',
    name: 'Takobak',
  },
  {
    id: '9430022003',
    districtId: '9430022',
    name: 'Wamindik',
  },
  {
    id: '9430022005',
    districtId: '9430022',
    name: 'Kugame',
  },
  {
    id: '9430022006',
    districtId: '9430022',
    name: 'Kidoni',
  },
  {
    id: '9430022007',
    districtId: '9430022',
    name: 'Jinok',
  },
  {
    id: '9430022008',
    districtId: '9430022',
    name: 'Wewolome',
  },
  {
    id: '9430022009',
    districtId: '9430022',
    name: 'Umbename',
  },
  {
    id: '9430023002',
    districtId: '9430023',
    name: 'Yamiga',
  },
  {
    id: '9430023003',
    districtId: '9430023',
    name: 'Libome',
  },
  {
    id: '9430023006',
    districtId: '9430023',
    name: 'Kulia',
  },
  {
    id: '9430023007',
    districtId: '9430023',
    name: 'Wadinawi',
  },
  {
    id: '9430023009',
    districtId: '9430023',
    name: 'Kamenak',
  },
  {
    id: '9430023010',
    districtId: '9430023',
    name: 'Nengguga',
  },
  {
    id: '9430023011',
    districtId: '9430023',
    name: 'Golopura',
  },
  {
    id: '9430023012',
    districtId: '9430023',
    name: 'Gubugame',
  },
  {
    id: '9430024001',
    districtId: '9430024',
    name: 'Golo',
  },
  {
    id: '9430024004',
    districtId: '9430024',
    name: 'Yugumabur',
  },
  {
    id: '9430024005',
    districtId: '9430024',
    name: 'Uniwani',
  },
  {
    id: '9430024006',
    districtId: '9430024',
    name: 'Wiringgabut',
  },
  {
    id: '9430024009',
    districtId: '9430024',
    name: 'Kiludo',
  },
  {
    id: '9430024010',
    districtId: '9430024',
    name: 'Golomi',
  },
  {
    id: '9430030007',
    districtId: '9430030',
    name: 'Gurika',
  },
  {
    id: '9430030008',
    districtId: '9430030',
    name: 'Bokon',
  },
  {
    id: '9430030014',
    districtId: '9430030',
    name: 'Dura',
  },
  {
    id: '9430030015',
    districtId: '9430030',
    name: 'Oyi',
  },
  {
    id: '9430030016',
    districtId: '9430030',
    name: 'Olume',
  },
  {
    id: '9430030021',
    districtId: '9430030',
    name: 'Longgalo',
  },
  {
    id: '9430030022',
    districtId: '9430030',
    name: 'Palunggame',
  },
  {
    id: '9430030023',
    districtId: '9430030',
    name: 'Yilondum',
  },
  {
    id: '9430030024',
    districtId: '9430030',
    name: 'Kuapur',
  },
  {
    id: '9430030025',
    districtId: '9430030',
    name: 'Wadmalome',
  },
  {
    id: '9430031001',
    districtId: '9430031',
    name: 'Yakobak',
  },
  {
    id: '9430031004',
    districtId: '9430031',
    name: 'Wimolome',
  },
  {
    id: '9430031005',
    districtId: '9430031',
    name: 'Weneogun',
  },
  {
    id: '9430031006',
    districtId: '9430031',
    name: 'Libungga',
  },
  {
    id: '9430031007',
    districtId: '9430031',
    name: 'Umom',
  },
  {
    id: '9430031008',
    districtId: '9430031',
    name: 'Berangwi',
  },
  {
    id: '9430032001',
    districtId: '9430032',
    name: 'Mokoni',
  },
  {
    id: '9430032002',
    districtId: '9430032',
    name: 'Guninggame',
  },
  {
    id: '9430032003',
    districtId: '9430032',
    name: 'Name',
  },
  {
    id: '9430032004',
    districtId: '9430032',
    name: 'Bigipura',
  },
  {
    id: '9430032005',
    districtId: '9430032',
    name: 'Wakumalo',
  },
  {
    id: '9430032006',
    districtId: '9430032',
    name: 'Yanggelome',
  },
  {
    id: '9430032007',
    districtId: '9430032',
    name: 'Bumalome',
  },
  {
    id: '9430032008',
    districtId: '9430032',
    name: 'Popome',
  },
  {
    id: '9430033001',
    districtId: '9430033',
    name: 'Wulundia',
  },
  {
    id: '9430033003',
    districtId: '9430033',
    name: 'Molobok',
  },
  {
    id: '9430033004',
    districtId: '9430033',
    name: 'Tugunakwi',
  },
  {
    id: '9430033005',
    districtId: '9430033',
    name: 'Yanuru',
  },
  {
    id: '9430033006',
    districtId: '9430033',
    name: 'Dapogi',
  },
  {
    id: '9430034001',
    districtId: '9430034',
    name: 'Golime',
  },
  {
    id: '9430034002',
    districtId: '9430034',
    name: 'Ninabua',
  },
  {
    id: '9430034004',
    districtId: '9430034',
    name: 'Tepogi',
  },
  {
    id: '9430034005',
    districtId: '9430034',
    name: 'Ninengwa',
  },
  {
    id: '9430034006',
    districtId: '9430034',
    name: 'Gumagame',
  },
  {
    id: '9430034007',
    districtId: '9430034',
    name: 'Abua',
  },
  {
    id: '9430035002',
    districtId: '9430035',
    name: 'Pindoak',
  },
  {
    id: '9430035003',
    districtId: '9430035',
    name: 'Nobo',
  },
  {
    id: '9430035004',
    districtId: '9430035',
    name: 'Wayuleme',
  },
  {
    id: '9430035005',
    districtId: '9430035',
    name: 'Bogomamun',
  },
  {
    id: '9430035006',
    districtId: '9430035',
    name: 'Bonanip',
  },
  {
    id: '9430035007',
    districtId: '9430035',
    name: 'Lambui',
  },
  {
    id: '9430035008',
    districtId: '9430035',
    name: 'Kukepake',
  },
  {
    id: '9430035009',
    districtId: '9430035',
    name: 'Giari',
  },
  {
    id: '9430035010',
    districtId: '9430035',
    name: 'Kotorambur',
  },
  {
    id: '9430036001',
    districtId: '9430036',
    name: 'Konikme',
  },
  {
    id: '9430036002',
    districtId: '9430036',
    name: 'Bogun Kunik',
  },
  {
    id: '9430036003',
    districtId: '9430036',
    name: 'Logom',
  },
  {
    id: '9430036004',
    districtId: '9430036',
    name: 'Wandoak',
  },
  {
    id: '9430036005',
    districtId: '9430036',
    name: 'Giwan',
  },
  {
    id: '9430036006',
    districtId: '9430036',
    name: 'Gimili Alome',
  },
  {
    id: '9430036007',
    districtId: '9430036',
    name: 'Mabume',
  },
  {
    id: '9430036008',
    districtId: '9430036',
    name: 'Urgelo',
  },
  {
    id: '9430036009',
    districtId: '9430036',
    name: 'Omagapa',
  },
  {
    id: '9430037001',
    districtId: '9430037',
    name: 'Bonom',
  },
  {
    id: '9430037002',
    districtId: '9430037',
    name: 'Laurapaga',
  },
  {
    id: '9430037003',
    districtId: '9430037',
    name: 'Bawi',
  },
  {
    id: '9430037004',
    districtId: '9430037',
    name: 'Ogin',
  },
  {
    id: '9430037006',
    districtId: '9430037',
    name: 'Yugimbo',
  },
  {
    id: '9430037008',
    districtId: '9430037',
    name: 'Kuwanom',
  },
  {
    id: '9430037009',
    districtId: '9430037',
    name: 'Kuwoge',
  },
  {
    id: '9430037010',
    districtId: '9430037',
    name: 'Uwagambur',
  },
  {
    id: '9430037011',
    districtId: '9430037',
    name: 'Lagame',
  },
  {
    id: '9430040001',
    districtId: '9430040',
    name: 'Balingga',
  },
  {
    id: '9430040006',
    districtId: '9430040',
    name: 'Tima',
  },
  {
    id: '9430040007',
    districtId: '9430040',
    name: 'Balime',
  },
  {
    id: '9430040010',
    districtId: '9430040',
    name: 'Balimneri',
  },
  {
    id: '9430040013',
    districtId: '9430040',
    name: 'Timonikime',
  },
  {
    id: '9430040014',
    districtId: '9430040',
    name: 'Binolangen',
  },
  {
    id: '9430040015',
    districtId: '9430040',
    name: 'Dewaka',
  },
  {
    id: '9430040016',
    districtId: '9430040',
    name: 'Yiala',
  },
  {
    id: '9430040017',
    districtId: '9430040',
    name: 'Tuwewak',
  },
  {
    id: '9430040018',
    districtId: '9430040',
    name: 'Yumaneri',
  },
  {
    id: '9430041001',
    districtId: '9430041',
    name: 'Yeyugu/Gilubandu',
  },
  {
    id: '9430041002',
    districtId: '9430041',
    name: 'Tinggipura',
  },
  {
    id: '9430041004',
    districtId: '9430041',
    name: 'Magame',
  },
  {
    id: '9430041005',
    districtId: '9430041',
    name: 'Lorea',
  },
  {
    id: '9430041006',
    districtId: '9430041',
    name: 'Baliempura',
  },
  {
    id: '9430041007',
    districtId: '9430041',
    name: 'Denomagi',
  },
  {
    id: '9430041008',
    districtId: '9430041',
    name: 'Anggumabume',
  },
  {
    id: '9430042002',
    districtId: '9430042',
    name: 'Wame',
  },
  {
    id: '9430042003',
    districtId: '9430042',
    name: 'Ekaba',
  },
  {
    id: '9430042004',
    districtId: '9430042',
    name: 'Ogodome',
  },
  {
    id: '9430042005',
    districtId: '9430042',
    name: 'Longgapura',
  },
  {
    id: '9430042009',
    districtId: '9430042',
    name: 'Yalogu',
  },
  {
    id: '9430043001',
    districtId: '9430043',
    name: 'Tikome',
  },
  {
    id: '9430043002',
    districtId: '9430043',
    name: 'Anitila',
  },
  {
    id: '9430043003',
    districtId: '9430043',
    name: 'Tikoyowa',
  },
  {
    id: '9430043004',
    districtId: '9430043',
    name: 'Wanggunom',
  },
  {
    id: '9430043005',
    districtId: '9430043',
    name: 'Ningonak',
  },
  {
    id: '9430043007',
    districtId: '9430043',
    name: 'Nanim',
  },
  {
    id: '9430043008',
    districtId: '9430043',
    name: 'Luagame',
  },
  {
    id: '9430043009',
    districtId: '9430043',
    name: 'Bogogunik',
  },
  {
    id: '9430050003',
    districtId: '9430050',
    name: 'Wupaga',
  },
  {
    id: '9430050004',
    districtId: '9430050',
    name: 'Kuyawage',
  },
  {
    id: '9430050005',
    districtId: '9430050',
    name: 'Wamitu',
  },
  {
    id: '9430050006',
    districtId: '9430050',
    name: 'Luaren',
  },
  {
    id: '9430050007',
    districtId: '9430050',
    name: 'Timotani',
  },
  {
    id: '9430050008',
    districtId: '9430050',
    name: 'Kungganeri',
  },
  {
    id: '9430050009',
    districtId: '9430050',
    name: 'Gwilonik',
  },
  {
    id: '9430050011',
    districtId: '9430050',
    name: 'Peko',
  },
  {
    id: '9430050013',
    districtId: '9430050',
    name: 'Uwome',
  },
  {
    id: '9430050014',
    districtId: '9430050',
    name: 'Yugunomba',
  },
  {
    id: '9430051001',
    districtId: '9430051',
    name: 'Andugume',
  },
  {
    id: '9430051002',
    districtId: '9430051',
    name: 'Nenggeya',
  },
  {
    id: '9430051004',
    districtId: '9430051',
    name: 'Wamiru',
  },
  {
    id: '9430051007',
    districtId: '9430051',
    name: 'Nabel',
  },
  {
    id: '9430051008',
    districtId: '9430051',
    name: 'Tenawi',
  },
  {
    id: '9430051009',
    districtId: '9430051',
    name: 'Kobanu',
  },
  {
    id: '9430051010',
    districtId: '9430051',
    name: 'Piragi',
  },
  {
    id: '9430051011',
    districtId: '9430051',
    name: 'Mingga',
  },
  {
    id: '9430060003',
    districtId: '9430060',
    name: 'Bagi',
  },
  {
    id: '9430060004',
    districtId: '9430060',
    name: 'Malagai',
  },
  {
    id: '9430060005',
    districtId: '9430060',
    name: 'Oka',
  },
  {
    id: '9430060006',
    districtId: '9430060',
    name: 'Nambu',
  },
  {
    id: '9430060007',
    districtId: '9430060',
    name: 'Ganume',
  },
  {
    id: '9430060008',
    districtId: '9430060',
    name: 'Binilani',
  },
  {
    id: '9430060009',
    districtId: '9430060',
    name: 'Gumban',
  },
  {
    id: '9430060010',
    districtId: '9430060',
    name: 'Lowanom',
  },
  {
    id: '9430061002',
    districtId: '9430061',
    name: 'Wabiragi',
  },
  {
    id: '9430061003',
    districtId: '9430061',
    name: 'Nombome',
  },
  {
    id: '9430061005',
    districtId: '9430061',
    name: 'Wunabunggu',
  },
  {
    id: '9430061006',
    districtId: '9430061',
    name: 'Gilo',
  },
  {
    id: '9430061007',
    districtId: '9430061',
    name: 'Kewagi',
  },
  {
    id: '9430061008',
    districtId: '9430061',
    name: 'Numbokawi',
  },
  {
    id: '9430070006',
    districtId: '9430070',
    name: 'Argeneri',
  },
  {
    id: '9430070007',
    districtId: '9430070',
    name: 'Kuabaga',
  },
  {
    id: '9430070008',
    districtId: '9430070',
    name: 'Milinggame',
  },
  {
    id: '9430070009',
    districtId: '9430070',
    name: 'Gubo',
  },
  {
    id: '9430070010',
    districtId: '9430070',
    name: 'Ponuma',
  },
  {
    id: '9430070011',
    districtId: '9430070',
    name: 'Arungwi',
  },
  {
    id: '9430070013',
    districtId: '9430070',
    name: 'Gubulela',
  },
  {
    id: '9430071001',
    districtId: '9430071',
    name: 'Ponalo',
  },
  {
    id: '9430071003',
    districtId: '9430071',
    name: 'Tiwa',
  },
  {
    id: '9430071004',
    districtId: '9430071',
    name: 'Tabukeker',
  },
  {
    id: '9430071005',
    districtId: '9430071',
    name: 'Lura Marah',
  },
  {
    id: '9430071007',
    districtId: '9430071',
    name: 'Beyongwi',
  },
  {
    id: '9430071008',
    districtId: '9430071',
    name: 'Wuragi',
  },
  {
    id: '9430080003',
    districtId: '9430080',
    name: 'Dimba',
  },
  {
    id: '9430080004',
    districtId: '9430080',
    name: 'Megagobak',
  },
  {
    id: '9430080009',
    districtId: '9430080',
    name: 'Yugwa',
  },
  {
    id: '9430080010',
    districtId: '9430080',
    name: 'Nongopnage',
  },
  {
    id: '9430080011',
    districtId: '9430080',
    name: 'Wengenambur',
  },
  {
    id: '9430080012',
    districtId: '9430080',
    name: 'Talibarenak',
  },
  {
    id: '9430080013',
    districtId: '9430080',
    name: 'Wawiragi',
  },
  {
    id: '9430080014',
    districtId: '9430080',
    name: 'Mewilangun',
  },
  {
    id: '9430081001',
    districtId: '9430081',
    name: 'Tologi',
  },
  {
    id: '9430081002',
    districtId: '9430081',
    name: 'Kelulome',
  },
  {
    id: '9430081003',
    districtId: '9430081',
    name: 'Wiyagi',
  },
  {
    id: '9430081004',
    districtId: '9430081',
    name: 'Wegenpura',
  },
  {
    id: '9430081006',
    districtId: '9430081',
    name: 'Juyiga',
  },
  {
    id: '9430081007',
    districtId: '9430081',
    name: 'Wiringgame',
  },
  {
    id: '9430081008',
    districtId: '9430081',
    name: 'Lewinagi',
  },
  {
    id: '9430081009',
    districtId: '9430081',
    name: 'Peragime',
  },
  {
    id: '9430082001',
    districtId: '9430082',
    name: 'Wanggagome',
  },
  {
    id: '9430082002',
    districtId: '9430082',
    name: 'Wuluwa',
  },
  {
    id: '9430082003',
    districtId: '9430082',
    name: 'Langgime',
  },
  {
    id: '9430082004',
    districtId: '9430082',
    name: 'Kotorambur',
  },
  {
    id: '9430082005',
    districtId: '9430082',
    name: 'Wumbanakme',
  },
  {
    id: '9430082006',
    districtId: '9430082',
    name: 'Ambime',
  },
  {
    id: '9430082007',
    districtId: '9430082',
    name: 'Pindalo',
  },
  {
    id: '9430082008',
    districtId: '9430082',
    name: 'Yimiribaga',
  },
  {
    id: '9430082009',
    districtId: '9430082',
    name: 'Elubaga',
  },
  {
    id: '9430090004',
    districtId: '9430090',
    name: 'Pirawun',
  },
  {
    id: '9430090005',
    districtId: '9430090',
    name: 'Gamelia',
  },
  {
    id: '9430090007',
    districtId: '9430090',
    name: 'Gawiwarak',
  },
  {
    id: '9430090008',
    districtId: '9430090',
    name: 'Meyagale',
  },
  {
    id: '9430090009',
    districtId: '9430090',
    name: 'Wulaipas',
  },
  {
    id: '9430090010',
    districtId: '9430090',
    name: 'Gunagewak',
  },
  {
    id: '9430091001',
    districtId: '9430091',
    name: 'Ayafofa',
  },
  {
    id: '9430091002',
    districtId: '9430091',
    name: 'Salemo',
  },
  {
    id: '9430091003',
    districtId: '9430091',
    name: 'Yudani',
  },
  {
    id: '9430091004',
    districtId: '9430091',
    name: 'Delegari',
  },
  {
    id: '9430091005',
    districtId: '9430091',
    name: 'Igimbua',
  },
  {
    id: '9430091006',
    districtId: '9430091',
    name: 'Towoluk',
  },
  {
    id: '9430091008',
    districtId: '9430091',
    name: 'Yilokdu',
  },
  {
    id: '9430092001',
    districtId: '9430092',
    name: 'Ekapame',
  },
  {
    id: '9430092002',
    districtId: '9430092',
    name: 'Yugumabur',
  },
  {
    id: '9430092003',
    districtId: '9430092',
    name: 'Odika',
  },
  {
    id: '9430092004',
    districtId: '9430092',
    name: 'Wanome',
  },
  {
    id: '9430092006',
    districtId: '9430092',
    name: 'Kubagalo',
  },
  {
    id: '9430092008',
    districtId: '9430092',
    name: 'Papani',
  },
  {
    id: '9430093001',
    districtId: '9430093',
    name: 'Gukop',
  },
  {
    id: '9430093003',
    districtId: '9430093',
    name: 'Kori',
  },
  {
    id: '9430093004',
    districtId: '9430093',
    name: 'Keyagalo',
  },
  {
    id: '9430093005',
    districtId: '9430093',
    name: 'Guna',
  },
  {
    id: '9430093006',
    districtId: '9430093',
    name: 'Nondinime',
  },
  {
    id: '9430100005',
    districtId: '9430100',
    name: 'Megalunik',
  },
  {
    id: '9430100006',
    districtId: '9430100',
    name: 'Poga',
  },
  {
    id: '9430100007',
    districtId: '9430100',
    name: 'Kanumbume',
  },
  {
    id: '9430100009',
    districtId: '9430100',
    name: 'Lugobak',
  },
  {
    id: '9430100010',
    districtId: '9430100',
    name: 'Bigipaga',
  },
  {
    id: '9430100011',
    districtId: '9430100',
    name: 'Binompaga',
  },
  {
    id: '9430100012',
    districtId: '9430100',
    name: 'Lugwa',
  },
  {
    id: '9430100016',
    districtId: '9430100',
    name: 'Binipaga',
  },
  {
    id: '9430100018',
    districtId: '9430100',
    name: 'Guaneri',
  },
  {
    id: '9430101001',
    districtId: '9430101',
    name: 'Lualo',
  },
  {
    id: '9430101002',
    districtId: '9430101',
    name: 'Muara',
  },
  {
    id: '9430101003',
    districtId: '9430101',
    name: 'Gipura',
  },
  {
    id: '9430101005',
    districtId: '9430101',
    name: 'Abua',
  },
  {
    id: '9430101006',
    districtId: '9430101',
    name: 'Bogangi',
  },
  {
    id: '9430101008',
    districtId: '9430101',
    name: 'Wiyapur',
  },
  {
    id: '9430101010',
    districtId: '9430101',
    name: 'Golome',
  },
  {
    id: '9431010001',
    districtId: '9431010',
    name: 'Ninugagas',
  },
  {
    id: '9431010002',
    districtId: '9431010',
    name: 'Anduang',
  },
  {
    id: '9431010003',
    districtId: '9431010',
    name: 'Seralema',
  },
  {
    id: '9431010004',
    districtId: '9431010',
    name: 'Boroges',
  },
  {
    id: '9431010005',
    districtId: '9431010',
    name: 'Kobakma',
  },
  {
    id: '9431010007',
    districtId: '9431010',
    name: 'Guawage',
  },
  {
    id: '9431010008',
    districtId: '9431010',
    name: 'Luarima',
  },
  {
    id: '9431010009',
    districtId: '9431010',
    name: 'Keniwa',
  },
  {
    id: '9431010010',
    districtId: '9431010',
    name: 'Baliklabur',
  },
  {
    id: '9431010011',
    districtId: '9431010',
    name: 'Yagalim',
  },
  {
    id: '9431010012',
    districtId: '9431010',
    name: 'Samabegulik',
  },
  {
    id: '9431010013',
    districtId: '9431010',
    name: 'Wiyugobak',
  },
  {
    id: '9431010014',
    districtId: '9431010',
    name: 'Moga',
  },
  {
    id: '9431010015',
    districtId: '9431010',
    name: 'Dokle',
  },
  {
    id: '9431020001',
    districtId: '9431020',
    name: 'Melenggama',
  },
  {
    id: '9431020002',
    districtId: '9431020',
    name: 'Wirima',
  },
  {
    id: '9431020003',
    districtId: '9431020',
    name: 'Ilugwa',
  },
  {
    id: '9431020004',
    districtId: '9431020',
    name: 'Kalarin',
  },
  {
    id: '9431020005',
    districtId: '9431020',
    name: 'Danama',
  },
  {
    id: '9431020006',
    districtId: '9431020',
    name: 'Ilusilimo',
  },
  {
    id: '9431030001',
    districtId: '9431030',
    name: 'Tongrik/Yinaga',
  },
  {
    id: '9431030002',
    districtId: '9431030',
    name: 'Yagabur',
  },
  {
    id: '9431030003',
    districtId: '9431030',
    name: 'Tari',
  },
  {
    id: '9431030004',
    districtId: '9431030',
    name: 'Gelora',
  },
  {
    id: '9431030005',
    districtId: '9431030',
    name: 'Uganda',
  },
  {
    id: '9431030007',
    districtId: '9431030',
    name: 'Tikapura',
  },
  {
    id: '9431030008',
    districtId: '9431030',
    name: 'Timeria',
  },
  {
    id: '9431030009',
    districtId: '9431030',
    name: 'Onggobalo/Gwipu',
  },
  {
    id: '9431030010',
    districtId: '9431030',
    name: 'Mabuna',
  },
  {
    id: '9431030012',
    districtId: '9431030',
    name: 'Kelila',
  },
  {
    id: '9431030013',
    districtId: '9431030',
    name: 'Kambo',
  },
  {
    id: '9431030014',
    districtId: '9431030',
    name: 'Dogobak',
  },
  {
    id: '9431030015',
    districtId: '9431030',
    name: 'Pelanme',
  },
  {
    id: '9431030016',
    districtId: '9431030',
    name: 'Kindok',
  },
  {
    id: '9431030017',
    districtId: '9431030',
    name: 'Yalonggolo',
  },
  {
    id: '9431030019',
    districtId: '9431030',
    name: 'Apalo',
  },
  {
    id: '9431040001',
    districtId: '9431040',
    name: 'Mogonik',
  },
  {
    id: '9431040002',
    districtId: '9431040',
    name: 'Kino',
  },
  {
    id: '9431040003',
    districtId: '9431040',
    name: 'Ayeki',
  },
  {
    id: '9431040004',
    districtId: '9431040',
    name: 'Mologi',
  },
  {
    id: '9431040005',
    districtId: '9431040',
    name: 'Yabendili',
  },
  {
    id: '9431040006',
    districtId: '9431040',
    name: 'Winima',
  },
  {
    id: '9431040007',
    districtId: '9431040',
    name: 'Arsbol',
  },
  {
    id: '9431040008',
    districtId: '9431040',
    name: 'Wanilok/Yelam',
  },
  {
    id: '9431040009',
    districtId: '9431040',
    name: 'Pagale',
  },
  {
    id: '9431040010',
    districtId: '9431040',
    name: 'Enggaima',
  },
  {
    id: '9431040011',
    districtId: '9431040',
    name: 'Enggama',
  },
  {
    id: '9431040012',
    districtId: '9431040',
    name: 'Winam',
  },
  {
    id: '9431040013',
    districtId: '9431040',
    name: 'Kugap',
  },
  {
    id: '9431040014',
    districtId: '9431040',
    name: 'Erageam',
  },
  {
    id: '9431050001',
    districtId: '9431050',
    name: 'Taria',
  },
  {
    id: '9431050002',
    districtId: '9431050',
    name: 'Megabilis',
  },
  {
    id: '9431050003',
    districtId: '9431050',
    name: 'Homasam',
  },
  {
    id: '9431050004',
    districtId: '9431050',
    name: 'Higisyam',
  },
  {
    id: '9432010001',
    districtId: '9432010',
    name: 'Saly',
  },
  {
    id: '9432010002',
    districtId: '9432010',
    name: 'Mabualem',
  },
  {
    id: '9432010004',
    districtId: '9432010',
    name: 'Welarek',
  },
  {
    id: '9432010005',
    districtId: '9432010',
    name: 'Pisanggo',
  },
  {
    id: '9432010006',
    districtId: '9432010',
    name: 'Salema',
  },
  {
    id: '9432010008',
    districtId: '9432010',
    name: 'Langam',
  },
  {
    id: '9432010009',
    districtId: '9432010',
    name: 'Pami',
  },
  {
    id: '9432010010',
    districtId: '9432010',
    name: 'Pirang',
  },
  {
    id: '9432010011',
    districtId: '9432010',
    name: 'Poholanggen',
  },
  {
    id: '9432010012',
    districtId: '9432010',
    name: 'Wangkulamsafiang',
  },
  {
    id: '9432010013',
    districtId: '9432010',
    name: 'Irarek',
  },
  {
    id: '9432010014',
    districtId: '9432010',
    name: 'Apolongsili',
  },
  {
    id: '9432010015',
    districtId: '9432010',
    name: 'Suntam',
  },
  {
    id: '9432010017',
    districtId: '9432010',
    name: 'Kayo',
  },
  {
    id: '9432010018',
    districtId: '9432010',
    name: 'Panal',
  },
  {
    id: '9432010019',
    districtId: '9432010',
    name: 'Hilariki',
  },
  {
    id: '9432010021',
    districtId: '9432010',
    name: 'Helebol',
  },
  {
    id: '9432010022',
    districtId: '9432010',
    name: 'Silfal',
  },
  {
    id: '9432010023',
    districtId: '9432010',
    name: 'Sukalimi',
  },
  {
    id: '9432010024',
    districtId: '9432010',
    name: 'Nohonil',
  },
  {
    id: '9432010025',
    districtId: '9432010',
    name: 'Lasik',
  },
  {
    id: '9432010026',
    districtId: '9432010',
    name: 'Panalulun',
  },
  {
    id: '9432010027',
    districtId: '9432010',
    name: 'Wasupahik',
  },
  {
    id: '9432010028',
    districtId: '9432010',
    name: 'Folongsili',
  },
  {
    id: '9432010029',
    districtId: '9432010',
    name: 'Amuluk',
  },
  {
    id: '9432010030',
    districtId: '9432010',
    name: 'Yahamer',
  },
  {
    id: '9432020002',
    districtId: '9432020',
    name: 'Yarema',
  },
  {
    id: '9432020003',
    districtId: '9432020',
    name: 'Apalapsili',
  },
  {
    id: '9432020005',
    districtId: '9432020',
    name: 'Asilikma',
  },
  {
    id: '9432020006',
    districtId: '9432020',
    name: 'Tikano',
  },
  {
    id: '9432020007',
    districtId: '9432020',
    name: 'Nasinena',
  },
  {
    id: '9432020008',
    districtId: '9432020',
    name: 'Eal',
  },
  {
    id: '9432020009',
    districtId: '9432020',
    name: 'Hukalopunu',
  },
  {
    id: '9432020010',
    districtId: '9432020',
    name: 'Alimuluk',
  },
  {
    id: '9432020011',
    districtId: '9432020',
    name: 'Pong',
  },
  {
    id: '9432020012',
    districtId: '9432020',
    name: 'Moliyinggi',
  },
  {
    id: '9432020013',
    districtId: '9432020',
    name: 'Sobikambut',
  },
  {
    id: '9432020014',
    districtId: '9432020',
    name: 'Wiralesi',
  },
  {
    id: '9432020015',
    districtId: '9432020',
    name: 'Houaogalma',
  },
  {
    id: '9432020016',
    districtId: '9432020',
    name: 'Falukwalilo',
  },
  {
    id: '9432020017',
    districtId: '9432020',
    name: 'Benyam',
  },
  {
    id: '9432020019',
    districtId: '9432020',
    name: 'Sabualo',
  },
  {
    id: '9432020020',
    districtId: '9432020',
    name: 'Nanahoruk',
  },
  {
    id: '9432020024',
    districtId: '9432020',
    name: 'Humalen',
  },
  {
    id: '9432020026',
    districtId: '9432020',
    name: 'Makrig',
  },
  {
    id: '9432020027',
    districtId: '9432020',
    name: 'Yarema Satu',
  },
  {
    id: '9432020029',
    districtId: '9432020',
    name: 'Somohi',
  },
  {
    id: '9432030001',
    districtId: '9432030',
    name: 'Wambo',
  },
  {
    id: '9432030002',
    districtId: '9432030',
    name: 'Wambalfak',
  },
  {
    id: '9432030003',
    districtId: '9432030',
    name: 'Abenaho',
  },
  {
    id: '9432030004',
    districtId: '9432030',
    name: 'Dosumo',
  },
  {
    id: '9432030005',
    districtId: '9432030',
    name: 'Dombomi',
  },
  {
    id: '9432030007',
    districtId: '9432030',
    name: 'Landikma',
  },
  {
    id: '9432030008',
    districtId: '9432030',
    name: 'Hulikma',
  },
  {
    id: '9432030009',
    districtId: '9432030',
    name: 'Hublika/Sombule',
  },
  {
    id: '9432030011',
    districtId: '9432030',
    name: 'Yahatma',
  },
  {
    id: '9432030012',
    districtId: '9432030',
    name: 'Sohombunu',
  },
  {
    id: '9432030015',
    districtId: '9432030',
    name: 'Masanahikma',
  },
  {
    id: '9432030016',
    districtId: '9432030',
    name: 'Abagima',
  },
  {
    id: '9432030017',
    districtId: '9432030',
    name: 'Waghasilimo',
  },
  {
    id: '9432030018',
    districtId: '9432030',
    name: 'Wileroma',
  },
  {
    id: '9432030019',
    districtId: '9432030',
    name: 'Obabin',
  },
  {
    id: '9432030020',
    districtId: '9432030',
    name: 'Obabin Satu',
  },
  {
    id: '9432030021',
    districtId: '9432030',
    name: 'Dahonaikma',
  },
  {
    id: '9432030022',
    districtId: '9432030',
    name: 'Wanmal',
  },
  {
    id: '9432030023',
    districtId: '9432030',
    name: 'Arikbalek',
  },
  {
    id: '9432030024',
    districtId: '9432030',
    name: 'Yawan',
  },
  {
    id: '9432030025',
    districtId: '9432030',
    name: 'Wambal',
  },
  {
    id: '9432030028',
    districtId: '9432030',
    name: 'Mahial',
  },
  {
    id: '9432030029',
    districtId: '9432030',
    name: 'Alugi',
  },
  {
    id: '9432030030',
    districtId: '9432030',
    name: 'Sahikma',
  },
  {
    id: '9432030031',
    districtId: '9432030',
    name: 'Bonahik',
  },
  {
    id: '9432030032',
    districtId: '9432030',
    name: 'Eliekma',
  },
  {
    id: '9432030033',
    districtId: '9432030',
    name: 'Yabusup',
  },
  {
    id: '9432030035',
    districtId: '9432030',
    name: 'Suminaikma',
  },
  {
    id: '9432030037',
    districtId: '9432030',
    name: 'Fuahe',
  },
  {
    id: '9432030038',
    districtId: '9432030',
    name: 'Wutlarin',
  },
  {
    id: '9432030039',
    districtId: '9432030',
    name: 'Kolaima',
  },
  {
    id: '9432030040',
    districtId: '9432030',
    name: 'Wanggibo',
  },
  {
    id: '9432030041',
    districtId: '9432030',
    name: 'Walagima',
  },
  {
    id: '9432030042',
    districtId: '9432030',
    name: 'Tagabata',
  },
  {
    id: '9432030043',
    districtId: '9432030',
    name: 'Detpagado',
  },
  {
    id: '9432030044',
    districtId: '9432030',
    name: 'Bohum',
  },
  {
    id: '9432030045',
    districtId: '9432030',
    name: 'Sabilironggo',
  },
  {
    id: '9432030046',
    districtId: '9432030',
    name: 'Yanamik',
  },
  {
    id: '9432030047',
    districtId: '9432030',
    name: 'Langongkok',
  },
  {
    id: '9432030048',
    districtId: '9432030',
    name: 'Helaksili',
  },
  {
    id: '9432030051',
    districtId: '9432030',
    name: 'Yambaikma',
  },
  {
    id: '9432030052',
    districtId: '9432030',
    name: 'Nofualma',
  },
  {
    id: '9432030053',
    districtId: '9432030',
    name: 'Yutanggo',
  },
  {
    id: '9432030054',
    districtId: '9432030',
    name: 'Witlanggo',
  },
  {
    id: '9432030055',
    districtId: '9432030',
    name: 'Worol',
  },
  {
    id: '9432030056',
    districtId: '9432030',
    name: 'Bonggi',
  },
  {
    id: '9432030057',
    districtId: '9432030',
    name: 'Wilak',
  },
  {
    id: '9432030058',
    districtId: '9432030',
    name: 'Wangkun',
  },
  {
    id: '9432030059',
    districtId: '9432030',
    name: 'Hombanman',
  },
  {
    id: '9432030060',
    districtId: '9432030',
    name: 'Yama',
  },
  {
    id: '9432030061',
    districtId: '9432030',
    name: 'Wurupikma',
  },
  {
    id: '9432030062',
    districtId: '9432030',
    name: 'Halifur',
  },
  {
    id: '9432030064',
    districtId: '9432030',
    name: 'Kawokholik',
  },
  {
    id: '9432030065',
    districtId: '9432030',
    name: 'Horenikma',
  },
  {
    id: '9432030066',
    districtId: '9432030',
    name: 'Lasikma',
  },
  {
    id: '9432030068',
    districtId: '9432030',
    name: 'Heahobak',
  },
  {
    id: '9432030069',
    districtId: '9432030',
    name: 'Maleo',
  },
  {
    id: '9432030070',
    districtId: '9432030',
    name: 'Usabiye',
  },
  {
    id: '9432030071',
    districtId: '9432030',
    name: 'Kandibung',
  },
  {
    id: '9432030072',
    districtId: '9432030',
    name: 'Nilbo',
  },
  {
    id: '9432030073',
    districtId: '9432030',
    name: 'Sapiwarek',
  },
  {
    id: '9432030076',
    districtId: '9432030',
    name: 'Salo',
  },
  {
    id: '9432030077',
    districtId: '9432030',
    name: 'Moban',
  },
  {
    id: '9432030079',
    districtId: '9432030',
    name: 'Halisek',
  },
  {
    id: '9432030080',
    districtId: '9432030',
    name: 'Lohomabel',
  },
  {
    id: '9432030082',
    districtId: '9432030',
    name: 'Gefindo',
  },
  {
    id: '9432030084',
    districtId: '9432030',
    name: 'Amuki',
  },
  {
    id: '9432030085',
    districtId: '9432030',
    name: 'Wamhor',
  },
  {
    id: '9432030087',
    districtId: '9432030',
    name: 'Pamumu',
  },
  {
    id: '9432030088',
    districtId: '9432030',
    name: 'Wabuhuk',
  },
  {
    id: '9432030090',
    districtId: '9432030',
    name: 'Lilukikma',
  },
  {
    id: '9432030091',
    districtId: '9432030',
    name: 'Noholuok',
  },
  {
    id: '9432030092',
    districtId: '9432030',
    name: 'Wenemikma',
  },
  {
    id: '9432030093',
    districtId: '9432030',
    name: 'Nenomani',
  },
  {
    id: '9432030094',
    districtId: '9432030',
    name: 'Salohe',
  },
  {
    id: '9432030095',
    districtId: '9432030',
    name: 'Beyam',
  },
  {
    id: '9432030096',
    districtId: '9432030',
    name: 'Wilofing',
  },
  {
    id: '9432030097',
    districtId: '9432030',
    name: 'Fialem',
  },
  {
    id: '9432030098',
    districtId: '9432030',
    name: 'Horakia',
  },
  {
    id: '9432030099',
    districtId: '9432030',
    name: 'Suahe',
  },
  {
    id: '9432030101',
    districtId: '9432030',
    name: 'Waroham',
  },
  {
    id: '9432030102',
    districtId: '9432030',
    name: 'Sohi',
  },
  {
    id: '9432030103',
    districtId: '9432030',
    name: 'Sengikma',
  },
  {
    id: '9432030104',
    districtId: '9432030',
    name: 'Pirikalem',
  },
  {
    id: '9432030105',
    districtId: '9432030',
    name: 'Agris',
  },
  {
    id: '9432030107',
    districtId: '9432030',
    name: 'Wanam',
  },
  {
    id: '9432030108',
    districtId: '9432030',
    name: 'Dama',
  },
  {
    id: '9432040002',
    districtId: '9432040',
    name: 'Honita',
  },
  {
    id: '9432040003',
    districtId: '9432040',
    name: 'Alius',
  },
  {
    id: '9432040004',
    districtId: '9432040',
    name: 'Yabema',
  },
  {
    id: '9432040006',
    districtId: '9432040',
    name: 'Walkep',
  },
  {
    id: '9432040007',
    districtId: '9432040',
    name: 'Pangkik',
  },
  {
    id: '9432040008',
    districtId: '9432040',
    name: 'Maribu',
  },
  {
    id: '9432040009',
    districtId: '9432040',
    name: 'Yakikma',
  },
  {
    id: '9432040010',
    districtId: '9432040',
    name: 'Ulo',
  },
  {
    id: '9432040011',
    districtId: '9432040',
    name: 'Sira',
  },
  {
    id: '9432040012',
    districtId: '9432040',
    name: 'Ohobam',
  },
  {
    id: '9432040013',
    districtId: '9432040',
    name: 'Elelim Satu',
  },
  {
    id: '9432040016',
    districtId: '9432040',
    name: 'Tanabasi',
  },
  {
    id: '9432040017',
    districtId: '9432040',
    name: 'Holani',
  },
  {
    id: '9432040019',
    districtId: '9432040',
    name: 'Hesmat',
  },
  {
    id: '9432040020',
    districtId: '9432040',
    name: 'Molinggi',
  },
  {
    id: '9432040021',
    districtId: '9432040',
    name: 'Werekma',
  },
  {
    id: '9432040022',
    districtId: '9432040',
    name: 'Emon',
  },
  {
    id: '9432040023',
    districtId: '9432040',
    name: 'Kwikma',
  },
  {
    id: '9432040024',
    districtId: '9432040',
    name: 'Wagagu',
  },
  {
    id: '9432040025',
    districtId: '9432040',
    name: 'Sowi',
  },
  {
    id: '9432040026',
    districtId: '9432040',
    name: 'Sipson',
  },
  {
    id: '9432040027',
    districtId: '9432040',
    name: 'Sipsoi',
  },
  {
    id: '9432040029',
    districtId: '9432040',
    name: 'Ohoniam',
  },
  {
    id: '9432040030',
    districtId: '9432040',
    name: 'Subuiruinggama',
  },
  {
    id: '9432040031',
    districtId: '9432040',
    name: 'Duwong',
  },
  {
    id: '9432040035',
    districtId: '9432040',
    name: 'Momonhusi',
  },
  {
    id: '9432040036',
    districtId: '9432040',
    name: 'Helabu',
  },
  {
    id: '9432040037',
    districtId: '9432040',
    name: 'Pungkahiik',
  },
  {
    id: '9432040038',
    districtId: '9432040',
    name: 'Wara',
  },
  {
    id: '9432040039',
    districtId: '9432040',
    name: 'Hobakma',
  },
  {
    id: '9432040040',
    districtId: '9432040',
    name: 'Wasua',
  },
  {
    id: '9432040041',
    districtId: '9432040',
    name: 'Warikma',
  },
  {
    id: '9432040042',
    districtId: '9432040',
    name: 'Lapora',
  },
  {
    id: '9432040043',
    districtId: '9432040',
    name: 'Isila',
  },
  {
    id: '9432040044',
    districtId: '9432040',
    name: 'Habiyeambut',
  },
  {
    id: '9432040045',
    districtId: '9432040',
    name: 'Keron',
  },
  {
    id: '9432040046',
    districtId: '9432040',
    name: 'Pasimbolo',
  },
  {
    id: '9432040047',
    districtId: '9432040',
    name: 'Wekolani',
  },
  {
    id: '9432040048',
    districtId: '9432040',
    name: 'Fima',
  },
  {
    id: '9432040049',
    districtId: '9432040',
    name: 'Kalak',
  },
  {
    id: '9432040050',
    districtId: '9432040',
    name: 'Sohi',
  },
  {
    id: '9432050001',
    districtId: '9432050',
    name: 'Gilika',
  },
  {
    id: '9432050002',
    districtId: '9432050',
    name: 'Trikora',
  },
  {
    id: '9432050003',
    districtId: '9432050',
    name: 'Ampera',
  },
  {
    id: '9432050004',
    districtId: '9432050',
    name: 'Pepera',
  },
  {
    id: '9432050006',
    districtId: '9432050',
    name: 'Pensale',
  },
  {
    id: '9432050007',
    districtId: '9432050',
    name: 'Iyap',
  },
  {
    id: '9432050009',
    districtId: '9432050',
    name: 'Konobun',
  },
  {
    id: '9432050010',
    districtId: '9432050',
    name: 'Wirsa',
  },
  {
    id: '9432050011',
    districtId: '9432050',
    name: 'Karamina',
  },
  {
    id: '9432050012',
    districtId: '9432050',
    name: 'Dukunasi',
  },
  {
    id: '9432050013',
    districtId: '9432050',
    name: 'Thamaksin',
  },
  {
    id: '9432050014',
    districtId: '9432050',
    name: 'Ikon',
  },
  {
    id: '9432050016',
    districtId: '9432050',
    name: 'Lawe',
  },
  {
    id: '9432050017',
    districtId: '9432050',
    name: 'Kukdomol',
  },
  {
    id: '9432050018',
    districtId: '9432050',
    name: 'Mihol',
  },
  {
    id: '9432050019',
    districtId: '9432050',
    name: 'Mulia',
  },
  {
    id: '9432050020',
    districtId: '9432050',
    name: 'Naira',
  },
  {
    id: '9432050021',
    districtId: '9432050',
    name: 'Siwa',
  },
  {
    id: '9432050022',
    districtId: '9432050',
    name: 'Tiwayi',
  },
  {
    id: '9432050023',
    districtId: '9432050',
    name: 'Kutakuruk',
  },
  {
    id: '9432050024',
    districtId: '9432050',
    name: 'Narau',
  },
  {
    id: '9432050025',
    districtId: '9432050',
    name: 'Neigase',
  },
  {
    id: '9432050026',
    districtId: '9432050',
    name: 'Martaru',
  },
  {
    id: '9432050030',
    districtId: '9432050',
    name: 'Paluke',
  },
  {
    id: '9432050031',
    districtId: '9432050',
    name: 'Kamika',
  },
  {
    id: '9432050032',
    districtId: '9432050',
    name: 'Welap',
  },
  {
    id: '9432050033',
    districtId: '9432050',
    name: 'Kapawa',
  },
  {
    id: '9432050034',
    districtId: '9432050',
    name: 'Niyawi',
  },
  {
    id: '9432050035',
    districtId: '9432050',
    name: 'Yakwa',
  },
  {
    id: '9432050036',
    districtId: '9432050',
    name: 'Wernas',
  },
  {
    id: '9432050037',
    districtId: '9432050',
    name: 'Makrip',
  },
  {
    id: '9433010003',
    districtId: '9433010',
    name: 'Agadugume',
  },
  {
    id: '9433010004',
    districtId: '9433010',
    name: 'Gutyenggenak',
  },
  {
    id: '9433010005',
    districtId: '9433010',
    name: 'Dugunale',
  },
  {
    id: '9433010006',
    districtId: '9433010',
    name: 'Ogobakpelenak',
  },
  {
    id: '9433010007',
    districtId: '9433010',
    name: 'Dolinggu',
  },
  {
    id: '9433010008',
    districtId: '9433010',
    name: 'Ayume',
  },
  {
    id: '9433010021',
    districtId: '9433010',
    name: 'Terowi',
  },
  {
    id: '9433011002',
    districtId: '9433011',
    name: 'Wenggenambut',
  },
  {
    id: '9433011003',
    districtId: '9433011',
    name: 'Wanombut',
  },
  {
    id: '9433011004',
    districtId: '9433011',
    name: 'Tenawi',
  },
  {
    id: '9433011005',
    districtId: '9433011',
    name: 'Wamiru',
  },
  {
    id: '9433011006',
    districtId: '9433011',
    name: 'Pumbanak',
  },
  {
    id: '9433011007',
    districtId: '9433011',
    name: 'Piluwolu',
  },
  {
    id: '9433012001',
    districtId: '9433012',
    name: 'Jiwot',
  },
  {
    id: '9433012002',
    districtId: '9433012',
    name: 'Wuyunggame',
  },
  {
    id: '9433012003',
    districtId: '9433012',
    name: 'Gunaluk',
  },
  {
    id: '9433012004',
    districtId: '9433012',
    name: 'Deogi',
  },
  {
    id: '9433012006',
    districtId: '9433012',
    name: 'Kugiame',
  },
  {
    id: '9433020003',
    districtId: '9433020',
    name: 'Upaga',
  },
  {
    id: '9433020004',
    districtId: '9433020',
    name: 'Misimaga',
  },
  {
    id: '9433020005',
    districtId: '9433020',
    name: 'Gome',
  },
  {
    id: '9433020006',
    districtId: '9433020',
    name: 'Mundidok',
  },
  {
    id: '9433020007',
    districtId: '9433020',
    name: 'Tuwanggi',
  },
  {
    id: '9433020008',
    districtId: '9433020',
    name: 'Yaikimaki',
  },
  {
    id: '9433020009',
    districtId: '9433020',
    name: 'Agiyome',
  },
  {
    id: '9433020010',
    districtId: '9433020',
    name: 'Yanggerenok',
  },
  {
    id: '9433020012',
    districtId: '9433020',
    name: 'Wako',
  },
  {
    id: '9433020013',
    districtId: '9433020',
    name: 'Tegelobak',
  },
  {
    id: '9433020014',
    districtId: '9433020',
    name: 'Ninggabuma',
  },
  {
    id: '9433020015',
    districtId: '9433020',
    name: 'Kelanungin',
  },
  {
    id: '9433020016',
    districtId: '9433020',
    name: 'Yoggolawi',
  },
  {
    id: '9433021001',
    districtId: '9433021',
    name: 'Bela',
  },
  {
    id: '9433021002',
    districtId: '9433021',
    name: 'Amungkalipia',
  },
  {
    id: '9433021003',
    districtId: '9433021',
    name: 'Alama',
  },
  {
    id: '9433021004',
    districtId: '9433021',
    name: 'Tagalarama',
  },
  {
    id: '9433021005',
    districtId: '9433021',
    name: 'Bemoki',
  },
  {
    id: '9433021006',
    districtId: '9433021',
    name: 'Ompliga',
  },
  {
    id: '9433022001',
    districtId: '9433022',
    name: 'Welenggaru',
  },
  {
    id: '9433022002',
    districtId: '9433022',
    name: 'Towenggi II',
  },
  {
    id: '9433023001',
    districtId: '9433023',
    name: 'Erelmekawia',
  },
  {
    id: '9433023002',
    districtId: '9433023',
    name: 'Wamagun',
  },
  {
    id: '9433023003',
    districtId: '9433023',
    name: 'Kalpamonora',
  },
  {
    id: '9433023004',
    districtId: '9433023',
    name: 'Bomogin',
  },
  {
    id: '9433023005',
    districtId: '9433023',
    name: 'Mamoldema',
  },
  {
    id: '9433023006',
    districtId: '9433023',
    name: 'Ipmangkop',
  },
  {
    id: '9433023007',
    districtId: '9433023',
    name: 'Tamagun',
  },
  {
    id: '9433023008',
    districtId: '9433023',
    name: 'Amungkonin',
  },
  {
    id: '9433023009',
    districtId: '9433023',
    name: 'Ai Arama',
  },
  {
    id: '9433030003',
    districtId: '9433030',
    name: 'Kago',
  },
  {
    id: '9433030004',
    districtId: '9433030',
    name: 'Kimak',
  },
  {
    id: '9433030015',
    districtId: '9433030',
    name: 'Wuloni',
  },
  {
    id: '9433030016',
    districtId: '9433030',
    name: 'Nipuralome',
  },
  {
    id: '9433030017',
    districtId: '9433030',
    name: 'Kibogolome',
  },
  {
    id: '9433030018',
    districtId: '9433030',
    name: 'Tagaloa',
  },
  {
    id: '9433030019',
    districtId: '9433030',
    name: 'Jenggerpaga',
  },
  {
    id: '9433030020',
    districtId: '9433030',
    name: 'Ilmabet',
  },
  {
    id: '9433030021',
    districtId: '9433030',
    name: 'Kalebut',
  },
  {
    id: '9433031001',
    districtId: '9433031',
    name: 'Paluga',
  },
  {
    id: '9433031002',
    districtId: '9433031',
    name: 'Mayuberi',
  },
  {
    id: '9433031003',
    districtId: '9433031',
    name: 'Maki',
  },
  {
    id: '9433031004',
    districtId: '9433031',
    name: 'Miandiba / Mindipa',
  },
  {
    id: '9433031005',
    districtId: '9433031',
    name: 'Olenki',
  },
  {
    id: '9433031006',
    districtId: '9433031',
    name: 'Ayali',
  },
  {
    id: '9433031007',
    districtId: '9433031',
    name: 'Toegi',
  },
  {
    id: '9433031008',
    districtId: '9433031',
    name: 'Amungi',
  },
  {
    id: '9433031009',
    districtId: '9433031',
    name: 'Akonobak',
  },
  {
    id: '9433032001',
    districtId: '9433032',
    name: 'Ognanim',
  },
  {
    id: '9433032003',
    districtId: '9433032',
    name: 'Pologak',
  },
  {
    id: '9433032004',
    districtId: '9433032',
    name: 'Kabuki',
  },
  {
    id: '9433032005',
    districtId: '9433032',
    name: 'Ogongki',
  },
  {
    id: '9433032006',
    districtId: '9433032',
    name: 'Mabuga',
  },
  {
    id: '9433032007',
    districtId: '9433032',
    name: 'Kalemogom',
  },
  {
    id: '9433032008',
    districtId: '9433032',
    name: 'Koeao',
  },
  {
    id: '9433033001',
    districtId: '9433033',
    name: 'Pinapa',
  },
  {
    id: '9433033003',
    districtId: '9433033',
    name: 'Kunga',
  },
  {
    id: '9433033005',
    districtId: '9433033',
    name: 'Eromage',
  },
  {
    id: '9433033006',
    districtId: '9433033',
    name: 'Ninggibome',
  },
  {
    id: '9433033007',
    districtId: '9433033',
    name: 'Ondugura',
  },
  {
    id: '9433033008',
    districtId: '9433033',
    name: 'Manggume',
  },
  {
    id: '9433033010',
    districtId: '9433033',
    name: 'Aminggaru',
  },
  {
    id: '9433033011',
    districtId: '9433033',
    name: 'Domaoa',
  },
  {
    id: '9433033012',
    districtId: '9433033',
    name: 'Pungtrama',
  },
  {
    id: '9433033013',
    districtId: '9433033',
    name: 'Balamagalama',
  },
  {
    id: '9433033014',
    districtId: '9433033',
    name: 'Awilkinop',
  },
  {
    id: '9433040003',
    districtId: '9433040',
    name: 'Yauria / Wambru',
  },
  {
    id: '9433040007',
    districtId: '9433040',
    name: 'Gigobak / Gogobak',
  },
  {
    id: '9433040009',
    districtId: '9433040',
    name: 'Kumikomo',
  },
  {
    id: '9433040010',
    districtId: '9433040',
    name: 'Iskalebuk / Kawibut',
  },
  {
    id: '9433040012',
    districtId: '9433040',
    name: 'Kelemame',
  },
  {
    id: '9433040013',
    districtId: '9433040',
    name: 'Gigobak',
  },
  {
    id: '9433040014',
    districtId: '9433040',
    name: 'Gigobak II',
  },
  {
    id: '9433040015',
    districtId: '9433040',
    name: 'Gingga Baru',
  },
  {
    id: '9433040016',
    districtId: '9433040',
    name: 'Koloribanak',
  },
  {
    id: '9433040017',
    districtId: '9433040',
    name: 'Mogulu',
  },
  {
    id: '9433040018',
    districtId: '9433040',
    name: 'Pasir Putih',
  },
  {
    id: '9433040019',
    districtId: '9433040',
    name: 'Tenonggame',
  },
  {
    id: '9433041001',
    districtId: '9433041',
    name: 'Kilunggame',
  },
  {
    id: '9433041002',
    districtId: '9433041',
    name: 'Wonelupaga',
  },
  {
    id: '9433041003',
    districtId: '9433041',
    name: 'Tagalame I',
  },
  {
    id: '9433041004',
    districtId: '9433041',
    name: 'Bacini / Baksini',
  },
  {
    id: '9433041005',
    districtId: '9433041',
    name: 'Timobut',
  },
  {
    id: '9433041006',
    districtId: '9433041',
    name: 'Timobut Egewak',
  },
  {
    id: '9433041007',
    districtId: '9433041',
    name: 'Komapaga',
  },
  {
    id: '9433042002',
    districtId: '9433042',
    name: 'Nigolome / Nikoame',
  },
  {
    id: '9433042003',
    districtId: '9433042',
    name: 'Amulume',
  },
  {
    id: '9433042005',
    districtId: '9433042',
    name: 'Wombru',
  },
  {
    id: '9433042007',
    districtId: '9433042',
    name: 'Rumagi',
  },
  {
    id: '9433042008',
    districtId: '9433042',
    name: 'Tinibolu',
  },
  {
    id: '9433042009',
    districtId: '9433042',
    name: 'Winanggwi',
  },
  {
    id: '9433042010',
    districtId: '9433042',
    name: 'Kondokwe',
  },
  {
    id: '9433043001',
    districtId: '9433043',
    name: 'Pamebut',
  },
  {
    id: '9433043002',
    districtId: '9433043',
    name: 'Akenggen',
  },
  {
    id: '9433043003',
    districtId: '9433043',
    name: 'Mugalolo',
  },
  {
    id: '9433043004',
    districtId: '9433043',
    name: 'Jerusalem',
  },
  {
    id: '9433043005',
    districtId: '9433043',
    name: 'Wobulo',
  },
  {
    id: '9433043006',
    districtId: '9433043',
    name: 'Lambera',
  },
  {
    id: '9433043007',
    districtId: '9433043',
    name: 'Wiyabubu',
  },
  {
    id: '9433043008',
    districtId: '9433043',
    name: 'Yugumuak',
  },
  {
    id: '9433043009',
    districtId: '9433043',
    name: 'Wilewak',
  },
  {
    id: '9433043010',
    districtId: '9433043',
    name: 'Manggame',
  },
  {
    id: '9433050002',
    districtId: '9433050',
    name: 'Wakme',
  },
  {
    id: '9433050003',
    districtId: '9433050',
    name: 'Bokoma / Pogoma',
  },
  {
    id: '9433050005',
    districtId: '9433050',
    name: 'Golu',
  },
  {
    id: '9433050007',
    districtId: '9433050',
    name: 'Wiha',
  },
  {
    id: '9433050008',
    districtId: '9433050',
    name: 'Gagama',
  },
  {
    id: '9433050011',
    districtId: '9433050',
    name: 'Kolamagi',
  },
  {
    id: '9433050013',
    districtId: '9433050',
    name: 'Kumasingga',
  },
  {
    id: '9433050014',
    districtId: '9433050',
    name: 'Guwamu',
  },
  {
    id: '9433051001',
    districtId: '9433051',
    name: 'Molu',
  },
  {
    id: '9433051002',
    districtId: '9433051',
    name: 'Aguit',
  },
  {
    id: '9433051004',
    districtId: '9433051',
    name: 'Belaba',
  },
  {
    id: '9433051005',
    districtId: '9433051',
    name: 'Makuma',
  },
  {
    id: '9433052001',
    districtId: '9433052',
    name: 'Bina',
  },
  {
    id: '9433052002',
    districtId: '9433052',
    name: 'Lumakluk',
  },
  {
    id: '9433052003',
    districtId: '9433052',
    name: 'Wogot',
  },
  {
    id: '9433052004',
    districtId: '9433052',
    name: 'Kabogoluk',
  },
  {
    id: '9433052005',
    districtId: '9433052',
    name: 'Ogomegat',
  },
  {
    id: '9433052006',
    districtId: '9433052',
    name: 'Mamaput',
  },
  {
    id: '9433060001',
    districtId: '9433060',
    name: 'Wangbe',
  },
  {
    id: '9433060002',
    districtId: '9433060',
    name: 'Jindak / Alfalin',
  },
  {
    id: '9433060003',
    districtId: '9433060',
    name: 'Wonalbe',
  },
  {
    id: '9433060004',
    districtId: '9433060',
    name: 'Pelakoma',
  },
  {
    id: '9433060008',
    districtId: '9433060',
    name: 'Ulipia',
  },
  {
    id: '9433060009',
    districtId: '9433060',
    name: 'Marilaukin',
  },
  {
    id: '9433060010',
    districtId: '9433060',
    name: 'Aifalim',
  },
  {
    id: '9433060011',
    districtId: '9433060',
    name: 'Hikinat',
  },
  {
    id: '9433060013',
    districtId: '9433060',
    name: 'Nagaljagama',
  },
  {
    id: '9433060014',
    districtId: '9433060',
    name: 'Mongkoihol',
  },
  {
    id: '9433060015',
    districtId: '9433060',
    name: 'Nangi',
  },
  {
    id: '9433061001',
    districtId: '9433061',
    name: 'Erong Berang',
  },
  {
    id: '9433061002',
    districtId: '9433061',
    name: 'Daung / Kombet',
  },
  {
    id: '9433061003',
    districtId: '9433061',
    name: 'Kombet',
  },
  {
    id: '9433061004',
    districtId: '9433061',
    name: 'Onop',
  },
  {
    id: '9433061005',
    districtId: '9433061',
    name: 'Kulamagom',
  },
  {
    id: '9433061006',
    districtId: '9433061',
    name: 'Ogamanin',
  },
  {
    id: '9433070003',
    districtId: '9433070',
    name: 'Yulokoma',
  },
  {
    id: '9433070004',
    districtId: '9433070',
    name: 'Milawak',
  },
  {
    id: '9433070005',
    districtId: '9433070',
    name: 'Tinggilbet / Dangbet',
  },
  {
    id: '9433070007',
    districtId: '9433070',
    name: 'Pubet / Gimorit',
  },
  {
    id: '9433070008',
    districtId: '9433070',
    name: 'Dambet',
  },
  {
    id: '9433070010',
    districtId: '9433070',
    name: 'Jambul/Atti',
  },
  {
    id: '9433070011',
    districtId: '9433070',
    name: 'Wamki/Dengkibuma',
  },
  {
    id: '9433070012',
    districtId: '9433070',
    name: 'Ogamki',
  },
  {
    id: '9433070013',
    districtId: '9433070',
    name: 'Ondugi',
  },
  {
    id: '9433070014',
    districtId: '9433070',
    name: 'Ambobera',
  },
  {
    id: '9433071001',
    districtId: '9433071',
    name: 'Babe',
  },
  {
    id: '9433071002',
    districtId: '9433071',
    name: 'Nungai',
  },
  {
    id: '9433071004',
    districtId: '9433071',
    name: 'Kelmabet',
  },
  {
    id: '9433072001',
    districtId: '9433072',
    name: 'Kelandiruma',
  },
  {
    id: '9433072002',
    districtId: '9433072',
    name: 'Wandibet',
  },
  {
    id: '9433072005',
    districtId: '9433072',
    name: 'Bungok',
  },
  {
    id: '9433080001',
    districtId: '9433080',
    name: 'Iratoi',
  },
  {
    id: '9433080005',
    districtId: '9433080',
    name: 'Doufo',
  },
  {
    id: '9433080006',
    districtId: '9433080',
    name: 'Sibita',
  },
  {
    id: '9433080007',
    districtId: '9433080',
    name: 'Rawa',
  },
  {
    id: '9433080009',
    districtId: '9433080',
    name: 'Lani',
  },
  {
    id: '9433080010',
    districtId: '9433080',
    name: 'Wahuka',
  },
  {
    id: '9433081001',
    districtId: '9433081',
    name: 'Faisau',
  },
  {
    id: '9433081002',
    districtId: '9433081',
    name: 'Kordei',
  },
  {
    id: '9433081003',
    districtId: '9433081',
    name: 'Tayai',
  },
  {
    id: '9433081004',
    districtId: '9433081',
    name: 'Duatia',
  },
  {
    id: '9433081005',
    districtId: '9433081',
    name: 'Foisa',
  },
  {
    id: '9433081006',
    districtId: '9433081',
    name: 'Fokri',
  },
  {
    id: '9433081007',
    districtId: '9433081',
    name: 'Dervos',
  },
  {
    id: '9434010001',
    districtId: '9434010',
    name: 'Sukikai',
  },
  {
    id: '9434010002',
    districtId: '9434010',
    name: 'Wigoumakida',
  },
  {
    id: '9434010003',
    districtId: '9434010',
    name: 'Iyaro',
  },
  {
    id: '9434010004',
    districtId: '9434010',
    name: 'Unito',
  },
  {
    id: '9434020001',
    districtId: '9434020',
    name: 'Yegiyepa',
  },
  {
    id: '9434020002',
    districtId: '9434020',
    name: 'Apogomakida',
  },
  {
    id: '9434020003',
    districtId: '9434020',
    name: 'Deniyode',
  },
  {
    id: '9434020004',
    districtId: '9434020',
    name: 'Ukagu',
  },
  {
    id: '9434020005',
    districtId: '9434020',
    name: 'Kegata',
  },
  {
    id: '9434020006',
    districtId: '9434020',
    name: 'Egipa',
  },
  {
    id: '9434020007',
    districtId: '9434020',
    name: 'Ideduwa',
  },
  {
    id: '9434020008',
    districtId: '9434020',
    name: 'Tipaugi',
  },
  {
    id: '9434030001',
    districtId: '9434030',
    name: 'Toubaikebo',
  },
  {
    id: '9434030002',
    districtId: '9434030',
    name: 'Abouyaga',
  },
  {
    id: '9434030003',
    districtId: '9434030',
    name: 'Maikotu',
  },
  {
    id: '9434030004',
    districtId: '9434030',
    name: 'Yegoukotu',
  },
  {
    id: '9434040001',
    districtId: '9434040',
    name: 'Megaikebo',
  },
  {
    id: '9434040003',
    districtId: '9434040',
    name: 'Timepa',
  },
  {
    id: '9434040004',
    districtId: '9434040',
    name: 'Modio',
  },
  {
    id: '9434040005',
    districtId: '9434040',
    name: 'Putapa',
  },
  {
    id: '9434040006',
    districtId: '9434040',
    name: 'Tuamani / Atou',
  },
  {
    id: '9434040007',
    districtId: '9434040',
    name: 'Adauwo',
  },
  {
    id: '9434040008',
    districtId: '9434040',
    name: 'Gabaukunu',
  },
  {
    id: '9434040009',
    districtId: '9434040',
    name: 'Ukudawata / Upibega',
  },
  {
    id: '9434040010',
    districtId: '9434040',
    name: 'Bonakunu',
  },
  {
    id: '9434050001',
    districtId: '9434050',
    name: 'Abaimaida',
  },
  {
    id: '9434050002',
    districtId: '9434050',
    name: 'Bomomani',
  },
  {
    id: '9434050003',
    districtId: '9434050',
    name: 'Gapoya',
  },
  {
    id: '9434050004',
    districtId: '9434050',
    name: 'Diyoudimi',
  },
  {
    id: '9434050005',
    districtId: '9434050',
    name: 'Abaugi / Obaikagopa',
  },
  {
    id: '9434050006',
    districtId: '9434050',
    name: 'Magode',
  },
  {
    id: '9434050007',
    districtId: '9434050',
    name: 'Dawaikunu',
  },
  {
    id: '9434060001',
    districtId: '9434060',
    name: 'Abgoigi / Digimani',
  },
  {
    id: '9434060002',
    districtId: '9434060',
    name: 'Bobobutu',
  },
  {
    id: '9434060004',
    districtId: '9434060',
    name: 'Pona',
  },
  {
    id: '9434060005',
    districtId: '9434060',
    name: 'Makidimi',
  },
  {
    id: '9434060006',
    districtId: '9434060',
    name: 'Idadagi',
  },
  {
    id: '9434060007',
    districtId: '9434060',
    name: 'Motito',
  },
  {
    id: '9434060008',
    districtId: '9434060',
    name: 'Denemani',
  },
  {
    id: '9434060009',
    districtId: '9434060',
    name: 'Kigamani',
  },
  {
    id: '9434070001',
    districtId: '9434070',
    name: 'Bogoya Teugi',
  },
  {
    id: '9434070002',
    districtId: '9434070',
    name: 'Botumoma',
  },
  {
    id: '9434070003',
    districtId: '9434070',
    name: 'Puweta II',
  },
  {
    id: '9434070004',
    districtId: '9434070',
    name: 'Matadi',
  },
  {
    id: '9434070005',
    districtId: '9434070',
    name: 'Puweta I',
  },
  {
    id: '9434070006',
    districtId: '9434070',
    name: 'Digikebo',
  },
  {
    id: '9434070007',
    districtId: '9434070',
    name: 'Obaibega',
  },
  {
    id: '9434070008',
    districtId: '9434070',
    name: 'Pouwouda',
  },
  {
    id: '9434070009',
    districtId: '9434070',
    name: 'Ugikebo',
  },
  {
    id: '9434070010',
    districtId: '9434070',
    name: 'Tuwaida',
  },
  {
    id: '9434070011',
    districtId: '9434070',
    name: 'Ugikagouda',
  },
  {
    id: '9434070012',
    districtId: '9434070',
    name: 'Makidimi / Yepo',
  },
  {
    id: '9434080001',
    districtId: '9434080',
    name: 'Moanemani/ Ikebo',
  },
  {
    id: '9434080002',
    districtId: '9434080',
    name: 'Bukapa',
  },
  {
    id: '9434080003',
    districtId: '9434080',
    name: 'Mauwa',
  },
  {
    id: '9434080004',
    districtId: '9434080',
    name: 'Ekemanida',
  },
  {
    id: '9434080006',
    districtId: '9434080',
    name: 'Putapa',
  },
  {
    id: '9434080007',
    districtId: '9434080',
    name: 'Tokapo / Dikiyouwa',
  },
  {
    id: '9434080008',
    districtId: '9434080',
    name: 'Idakotu',
  },
  {
    id: '9434090001',
    districtId: '9434090',
    name: 'Bunauwo',
  },
  {
    id: '9434090002',
    districtId: '9434090',
    name: 'Yotapuga',
  },
  {
    id: '9434090003',
    districtId: '9434090',
    name: 'Ugapuga',
  },
  {
    id: '9434090004',
    districtId: '9434090',
    name: 'Boduda',
  },
  {
    id: '9434090005',
    districtId: '9434090',
    name: 'Nuwa',
  },
  {
    id: '9434090006',
    districtId: '9434090',
    name: 'Bokaibutu',
  },
  {
    id: '9434090007',
    districtId: '9434090',
    name: 'Deiyapa',
  },
  {
    id: '9434100001',
    districtId: '9434100',
    name: 'Idakebo',
  },
  {
    id: '9434100002',
    districtId: '9434100',
    name: 'Pugatadi II',
  },
  {
    id: '9434100003',
    districtId: '9434100',
    name: 'Pugatadi I',
  },
  {
    id: '9434100004',
    districtId: '9434100',
    name: 'Ikrar',
  },
  {
    id: '9434100005',
    districtId: '9434100',
    name: 'Obayo',
  },
  {
    id: '9434100006',
    districtId: '9434100',
    name: 'Kuyakago',
  },
  {
    id: '9434100007',
    districtId: '9434100',
    name: 'Yametadi',
  },
  {
    id: '9434100008',
    districtId: '9434100',
    name: 'Mogou',
  },
  {
    id: '9434100010',
    districtId: '9434100',
    name: 'Ekimani',
  },
  {
    id: '9435010001',
    districtId: '9435010',
    name: 'Mapa',
  },
  {
    id: '9435010002',
    districtId: '9435010',
    name: 'Bilai Dua',
  },
  {
    id: '9435010003',
    districtId: '9435010',
    name: 'Maya',
  },
  {
    id: '9435010004',
    districtId: '9435010',
    name: 'Degesiga',
  },
  {
    id: '9435010005',
    districtId: '9435010',
    name: 'Pogapa',
  },
  {
    id: '9435010006',
    districtId: '9435010',
    name: 'Bilai I',
  },
  {
    id: '9435010007',
    districtId: '9435010',
    name: 'Zomban Doga',
  },
  {
    id: '9435010008',
    districtId: '9435010',
    name: 'Kobae',
  },
  {
    id: '9435010009',
    districtId: '9435010',
    name: 'Selemama',
  },
  {
    id: '9435010010',
    districtId: '9435010',
    name: 'Kendetapa',
  },
  {
    id: '9435010011',
    districtId: '9435010',
    name: 'Hiyabu',
  },
  {
    id: '9435010012',
    districtId: '9435010',
    name: 'Bonogo',
  },
  {
    id: '9435010013',
    districtId: '9435010',
    name: 'Ogeapa',
  },
  {
    id: '9435010014',
    districtId: '9435010',
    name: 'Engganenga',
  },
  {
    id: '9435010015',
    districtId: '9435010',
    name: 'Agapa',
  },
  {
    id: '9435010016',
    districtId: '9435010',
    name: 'Waiagepa',
  },
  {
    id: '9435010017',
    districtId: '9435010',
    name: 'Bubisiga',
  },
  {
    id: '9435010018',
    districtId: '9435010',
    name: 'Hugitapa',
  },
  {
    id: '9435020001',
    districtId: '9435020',
    name: 'Emondi',
  },
  {
    id: '9435020002',
    districtId: '9435020',
    name: 'Mindau',
  },
  {
    id: '9435020003',
    districtId: '9435020',
    name: 'Ugimba',
  },
  {
    id: '9435020004',
    districtId: '9435020',
    name: 'Yoparu',
  },
  {
    id: '9435020005',
    districtId: '9435020',
    name: 'Mamba',
  },
  {
    id: '9435020006',
    districtId: '9435020',
    name: 'Yokatapa',
  },
  {
    id: '9435020007',
    districtId: '9435020',
    name: 'Bilogai',
  },
  {
    id: '9435020008',
    districtId: '9435020',
    name: 'Puyagiya',
  },
  {
    id: '9435020009',
    districtId: '9435020',
    name: 'Yalai',
  },
  {
    id: '9435020010',
    districtId: '9435020',
    name: 'Degeyabu/Buwisiga',
  },
  {
    id: '9435020011',
    districtId: '9435020',
    name: 'Mbilusiga',
  },
  {
    id: '9435020012',
    districtId: '9435020',
    name: 'Wandoga',
  },
  {
    id: '9435020013',
    districtId: '9435020',
    name: 'Kumlagupa',
  },
  {
    id: '9435020014',
    districtId: '9435020',
    name: 'Eknemba / Elenemba',
  },
  {
    id: '9435020016',
    districtId: '9435020',
    name: 'Ndugusiga',
  },
  {
    id: '9435030001',
    districtId: '9435030',
    name: 'Sanaba',
  },
  {
    id: '9435030004',
    districtId: '9435030',
    name: 'Kulapa',
  },
  {
    id: '9435030005',
    districtId: '9435030',
    name: 'Wabui',
  },
  {
    id: '9435030006',
    districtId: '9435030',
    name: 'Soagama',
  },
  {
    id: '9435030007',
    districtId: '9435030',
    name: 'Hitadipa',
  },
  {
    id: '9435030008',
    districtId: '9435030',
    name: 'Danggomba',
  },
  {
    id: '9435030009',
    districtId: '9435030',
    name: 'Balaimai',
  },
  {
    id: '9435030010',
    districtId: '9435030',
    name: 'Pugisiga',
  },
  {
    id: '9435040001',
    districtId: '9435040',
    name: 'Agisiga',
  },
  {
    id: '9435040002',
    districtId: '9435040',
    name: 'Tousiga',
  },
  {
    id: '9435040005',
    districtId: '9435040',
    name: 'Unabundaga',
  },
  {
    id: '9435040006',
    districtId: '9435040',
    name: 'Mbamogo',
  },
  {
    id: '9435040007',
    districtId: '9435040',
    name: 'Soali',
  },
  {
    id: '9435040008',
    districtId: '9435040',
    name: 'Danggoa',
  },
  {
    id: '9435040009',
    districtId: '9435040',
    name: 'Tomosiga',
  },
  {
    id: '9435040010',
    districtId: '9435040',
    name: 'Kombogisiga',
  },
  {
    id: '9435040011',
    districtId: '9435040',
    name: 'Tembage',
  },
  {
    id: '9435040012',
    districtId: '9435040',
    name: 'Dapiaga',
  },
  {
    id: '9435040013',
    districtId: '9435040',
    name: 'Bigasiga',
  },
  {
    id: '9435040014',
    districtId: '9435040',
    name: 'Janasiga',
  },
  {
    id: '9435050001',
    districtId: '9435050',
    name: 'Danggatadi',
  },
  {
    id: '9435050002',
    districtId: '9435050',
    name: 'Biandoga',
  },
  {
    id: '9435050003',
    districtId: '9435050',
    name: 'Bugalaga',
  },
  {
    id: '9435050004',
    districtId: '9435050',
    name: 'Yagaito',
  },
  {
    id: '9435050005',
    districtId: '9435050',
    name: 'Kalawa',
  },
  {
    id: '9435050006',
    districtId: '9435050',
    name: 'Yanei',
  },
  {
    id: '9435050007',
    districtId: '9435050',
    name: 'Pagamba',
  },
  {
    id: '9435050008',
    districtId: '9435050',
    name: 'Ular Merah',
  },
  {
    id: '9435050009',
    districtId: '9435050',
    name: 'Ndabatadi',
  },
  {
    id: '9435050010',
    districtId: '9435050',
    name: 'Aneya/Gitawa',
  },
  {
    id: '9435050011',
    districtId: '9435050',
    name: 'Edagitadi',
  },
  {
    id: '9435050012',
    districtId: '9435050',
    name: 'Kigitadi',
  },
  {
    id: '9435050013',
    districtId: '9435050',
    name: 'Maodagi',
  },
  {
    id: '9435050014',
    districtId: '9435050',
    name: 'Maniwo',
  },
  {
    id: '9435050015',
    districtId: '9435050',
    name: 'Mbiatapa',
  },
  {
    id: '9435060001',
    districtId: '9435060',
    name: 'Sabisa',
  },
  {
    id: '9435060002',
    districtId: '9435060',
    name: 'Jae',
  },
  {
    id: '9435060003',
    districtId: '9435060',
    name: 'Debasiga I',
  },
  {
    id: '9435060004',
    districtId: '9435060',
    name: 'Debasiga II',
  },
  {
    id: '9435060005',
    districtId: '9435060',
    name: 'Isandoga',
  },
  {
    id: '9435060006',
    districtId: '9435060',
    name: 'Mogalo',
  },
  {
    id: '9435060007',
    districtId: '9435060',
    name: 'Mbugulo',
  },
  {
    id: '9435060008',
    districtId: '9435060',
    name: 'Dubasiga',
  },
  {
    id: '9435060009',
    districtId: '9435060',
    name: 'Hulagupa',
  },
  {
    id: '9436010001',
    districtId: '9436010',
    name: 'Komauto',
  },
  {
    id: '9436010002',
    districtId: '9436010',
    name: 'Mogodagi',
  },
  {
    id: '9436010003',
    districtId: '9436010',
    name: 'Yamouwitina',
  },
  {
    id: '9436010004',
    districtId: '9436010',
    name: 'Ideego',
  },
  {
    id: '9436010005',
    districtId: '9436010',
    name: 'Uwe Onagei',
  },
  {
    id: '9436020001',
    districtId: '9436020',
    name: 'Widuwakiya',
  },
  {
    id: '9436020002',
    districtId: '9436020',
    name: 'Digibagata',
  },
  {
    id: '9436020003',
    districtId: '9436020',
    name: 'Ayatei',
  },
  {
    id: '9436020004',
    districtId: '9436020',
    name: 'Diyai',
  },
  {
    id: '9436020005',
    districtId: '9436020',
    name: 'Onago',
  },
  {
    id: '9436020006',
    districtId: '9436020',
    name: 'Tenedagi',
  },
  {
    id: '9436020007',
    districtId: '9436020',
    name: 'Gakokebo',
  },
  {
    id: '9436020009',
    districtId: '9436020',
    name: 'Yinudoba',
  },
  {
    id: '9436020010',
    districtId: '9436020',
    name: 'Piyakedimi',
  },
  {
    id: '9436020011',
    districtId: '9436020',
    name: 'Wagomani',
  },
  {
    id: '9436020012',
    districtId: '9436020',
    name: 'Demago',
  },
  {
    id: '9436020013',
    districtId: '9436020',
    name: 'Yipai',
  },
  {
    id: '9436020014',
    districtId: '9436020',
    name: 'Diyai II',
  },
  {
    id: '9436020015',
    districtId: '9436020',
    name: 'Onago II',
  },
  {
    id: '9436020016',
    districtId: '9436020',
    name: 'Meyepa',
  },
  {
    id: '9436020017',
    districtId: '9436020',
    name: 'Kogemani',
  },
  {
    id: '9436020018',
    districtId: '9436020',
    name: 'Yagu',
  },
  {
    id: '9436020019',
    districtId: '9436020',
    name: 'Obai',
  },
  {
    id: '9436020020',
    districtId: '9436020',
    name: 'Epanai',
  },
  {
    id: '9436020021',
    districtId: '9436020',
    name: 'Digikotu',
  },
  {
    id: '9436020022',
    districtId: '9436020',
    name: 'Maatadi',
  },
  {
    id: '9436030001',
    districtId: '9436030',
    name: 'Bomou',
  },
  {
    id: '9436030002',
    districtId: '9436030',
    name: 'Bomou II',
  },
  {
    id: '9436030003',
    districtId: '9436030',
    name: 'Yaba',
  },
  {
    id: '9436030004',
    districtId: '9436030',
    name: 'Waghete I',
  },
  {
    id: '9436030005',
    districtId: '9436030',
    name: 'Waghete II',
  },
  {
    id: '9436030006',
    districtId: '9436030',
    name: 'Okomokebo',
  },
  {
    id: '9436030007',
    districtId: '9436030',
    name: 'Ugiya',
  },
  {
    id: '9436030008',
    districtId: '9436030',
    name: 'Oneibo',
  },
  {
    id: '9436030009',
    districtId: '9436030',
    name: 'Motano',
  },
  {
    id: '9436030010',
    districtId: '9436030',
    name: 'Bomou III',
  },
  {
    id: '9436030011',
    districtId: '9436030',
    name: 'Amago',
  },
  {
    id: '9436030013',
    districtId: '9436030',
    name: 'Yaba II',
  },
  {
    id: '9436030014',
    districtId: '9436030',
    name: 'Mugouda',
  },
  {
    id: '9436030015',
    districtId: '9436030',
    name: 'Atouda',
  },
  {
    id: '9436030016',
    districtId: '9436030',
    name: 'Ikiyauwo',
  },
  {
    id: '9436030018',
    districtId: '9436030',
    name: 'Okomotadi',
  },
  {
    id: '9436030019',
    districtId: '9436030',
    name: 'Buwoudimi',
  },
  {
    id: '9436030020',
    districtId: '9436030',
    name: 'Ibodiyo',
  },
  {
    id: '9436040001',
    districtId: '9436040',
    name: 'Kokobaya',
  },
  {
    id: '9436040002',
    districtId: '9436040',
    name: 'Dakebo',
  },
  {
    id: '9436040003',
    districtId: '9436040',
    name: 'Watiyai',
  },
  {
    id: '9436040004',
    districtId: '9436040',
    name: 'Edagotadi',
  },
  {
    id: '9436040005',
    districtId: '9436040',
    name: 'Dagokebo',
  },
  {
    id: '9436040006',
    districtId: '9436040',
    name: 'Damabagata',
  },
  {
    id: '9436040007',
    districtId: '9436040',
    name: 'Bagou',
  },
  {
    id: '9436040008',
    districtId: '9436040',
    name: 'Waitakotu',
  },
  {
    id: '9436040009',
    districtId: '9436040',
    name: 'Pekepa',
  },
  {
    id: '9436040010',
    districtId: '9436040',
    name: 'Bagumoma',
  },
  {
    id: '9436040011',
    districtId: '9436040',
    name: 'Ipokeugida',
  },
  {
    id: '9436040012',
    districtId: '9436040',
    name: 'Idaiyodagi',
  },
  {
    id: '9436040013',
    districtId: '9436040',
    name: 'Udaugida',
  },
  {
    id: '9436040014',
    districtId: '9436040',
    name: 'Bagou II',
  },
  {
    id: '9436050001',
    districtId: '9436050',
    name: 'Kopai',
  },
  {
    id: '9436050002',
    districtId: '9436050',
    name: 'Kopai II',
  },
  {
    id: '9436050003',
    districtId: '9436050',
    name: 'Wooge',
  },
  {
    id: '9436050004',
    districtId: '9436050',
    name: 'Diita',
  },
  {
    id: '9436050005',
    districtId: '9436050',
    name: 'Yewadide',
  },
  {
    id: '9436050006',
    districtId: '9436050',
    name: 'Mudetadi',
  },
  {
    id: '9471010001',
    districtId: '9471010',
    name: 'Koya Barat',
  },
  {
    id: '9471010002',
    districtId: '9471010',
    name: 'Holtekam',
  },
  {
    id: '9471010003',
    districtId: '9471010',
    name: 'Skow Yambe',
  },
  {
    id: '9471010004',
    districtId: '9471010',
    name: 'Koya Timur',
  },
  {
    id: '9471010005',
    districtId: '9471010',
    name: 'Skow Mabo',
  },
  {
    id: '9471010006',
    districtId: '9471010',
    name: 'Skow Sae',
  },
  {
    id: '9471010007',
    districtId: '9471010',
    name: 'Koya Tengah',
  },
  {
    id: '9471010008',
    districtId: '9471010',
    name: 'Kampung Mosso',
  },
  {
    id: '9471020004',
    districtId: '9471020',
    name: 'Asano',
  },
  {
    id: '9471020005',
    districtId: '9471020',
    name: 'Nafri',
  },
  {
    id: '9471020006',
    districtId: '9471020',
    name: 'Engros',
  },
  {
    id: '9471020008',
    districtId: '9471020',
    name: 'Awiyo',
  },
  {
    id: '9471020009',
    districtId: '9471020',
    name: 'Koya Koso',
  },
  {
    id: '9471020010',
    districtId: '9471020',
    name: 'Yobe',
  },
  {
    id: '9471020011',
    districtId: '9471020',
    name: 'Abe Pantai',
  },
  {
    id: '9471020012',
    districtId: '9471020',
    name: 'Kota Baru',
  },
  {
    id: '9471020014',
    districtId: '9471020',
    name: 'Wai Mhorock',
  },
  {
    id: '9471020015',
    districtId: '9471020',
    name: 'Wahno',
  },
  {
    id: '9471021001',
    districtId: '9471021',
    name: 'Yoka',
  },
  {
    id: '9471021002',
    districtId: '9471021',
    name: 'Kampung Waena',
  },
  {
    id: '9471021003',
    districtId: '9471021',
    name: 'Hedam',
  },
  {
    id: '9471021005',
    districtId: '9471021',
    name: 'Waena',
  },
  {
    id: '9471021006',
    districtId: '9471021',
    name: 'Yabansai',
  },
  {
    id: '9471030002',
    districtId: '9471030',
    name: 'Entrop',
  },
  {
    id: '9471030003',
    districtId: '9471030',
    name: 'Tobati',
  },
  {
    id: '9471030004',
    districtId: '9471030',
    name: 'Hamadi',
  },
  {
    id: '9471030005',
    districtId: '9471030',
    name: 'Ardipura',
  },
  {
    id: '9471030006',
    districtId: '9471030',
    name: 'Numbai',
  },
  {
    id: '9471030007',
    districtId: '9471030',
    name: 'Argapura',
  },
  {
    id: '9471030008',
    districtId: '9471030',
    name: 'Tahima Soroma',
  },
  {
    id: '9471040001',
    districtId: '9471040',
    name: 'Gurabesi',
  },
  {
    id: '9471040002',
    districtId: '9471040',
    name: 'Bayangkara',
  },
  {
    id: '9471040003',
    districtId: '9471040',
    name: 'Mandala',
  },
  {
    id: '9471040004',
    districtId: '9471040',
    name: 'Trikora',
  },
  {
    id: '9471040005',
    districtId: '9471040',
    name: 'Angkasapura',
  },
  {
    id: '9471040007',
    districtId: '9471040',
    name: 'Tanjung Ria',
  },
  {
    id: '9471040008',
    districtId: '9471040',
    name: 'Kampung Kayobatu',
  },
]
